(function () {
    'use strict';

    angular.module('phoenixNewUi', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize',
        'ngMessages', 'ngAria', 'ui.router', 'ui.bootstrap', 'toastr', 'base64',
        'angular-ladda', 'minicolors', 'autoCompleteModule', 'formly', 'uiSwitch',
        'xeditable', 'ui.tab.scroll', 'mgo-angular-wizard', 'angular-markdown-editor',
        'angularResizable', 'ui.codemirror', 'ui.sortable', 'ngCsv',
        'ui.knob', 'ui.tree', 'ui.bootstrap.contextMenu', 'vcRecaptcha', 'dndLists', 'rzSlider',
        'schemaForm', 'infinite-scroll', 'jsonFormatter', 'angular-ssh', 'ngFileSaver', 'mc.resizer', 'gridstack-angular', 'zxcvbn'
    ]).config(['schemaFormDecoratorsProvider', function (decoratorsProvider) {
        decoratorsProvider.addMapping('bootstrapDecorator', 'loginInput', "app/login/passwordTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputText', "app/components/inputTemplate/inputTextTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputTextarea', "app/components/inputTemplate/inputTextareaTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputCheckbox', "app/components/inputTemplate/inputCheckboxTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputDropdown', "app/components/inputTemplate/inputDropdownTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputNumber', "app/components/inputTemplate/inputNumberTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputPassword', "app/components/inputTemplate/inputPasswordTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'inputLabel', "app/components/inputTemplate/inputLabelTemplate.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'authInput', "app/access/vault/createVault/createVaultFromAuthenticator/auth.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'xmlAuthInput', "app/access/vault/createVault/createVaultFromAuthenticator/xmlAuthInput.html");
        decoratorsProvider.addMapping('bootstrapDecorator', 'vaultInputDropdown', "app/components/inputTemplate/inputVaultDropdownTemplate.html");
    }]);

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('flattenDetailsModalCtrl',
            function ($uibModalInstance, $timeout, $window, $base64, DB, swal, microSpinner, amaran,
                      Iot3WorkbenchFactory, discoveryExtractorObj, isCreate, iot3JsonObj, mappingsArr) {
                var vm = this;

                vm.discoveryExtractorObj = isCreate ? discoveryExtractorObj : _.cloneDeepWith(discoveryExtractorObj);
                vm.isCreate = isCreate;
                vm.iot3JsonObj = iot3JsonObj;
                vm.mappingsArr = mappingsArr;

                vm.attrFilterOptionsForVerify = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }];
                vm.resetAttrFilterOptionsForVerify = _.cloneDeepWith(vm.attrFilterOptionsForVerify);

                vm.fnSelectExtractFilterForDiscovery = function (attrFilterObj, kvpPair, discoveryExtractorArr) {
                    if (attrFilterObj.filterValue === 'switch' && (!kvpPair.switchValuesArr ||
                        (kvpPair.switchValuesArr && !kvpPair.switchValuesArr.length))) {
                        kvpPair.switchValuesArr = [{
                            value: ''
                        }];
                    }
                    kvpPair.key = attrFilterObj.filterValue;
                    kvpPair.isArguments = attrFilterObj.isArguments;
                    if (discoveryExtractorArr[discoveryExtractorArr.length - 1 ].key !== '') {
                        discoveryExtractorArr.push({
                            key: '',
                            isArguments: true,
                            value: ''
                        })
                    }
                };

                vm.fnRemoveExtractFilterForDiscovery = function (kvpPair, $index, discoveryExtractorArr) {
                    discoveryExtractorArr.splice($index, 1);
                };

                vm.fnAddSwitchOption = function (kvpPair) {
                    kvpPair.switchValuesArr.push({
                        value: ''
                    })
                };

                vm.fnSelectMapper = function (mappingObj, extractorObj) {
                    extractorObj.mapper = mappingObj.id
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.discoveryExtractorObj);
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('loadModalViewCtrl',
            function ($uibModalInstance, $timeout, $uibModal, amaran, markdownOptionsObj, selectedStateObj, selectedStateName,
                      componentService, loadArr, injectArr, stashName, StateFactory, selectedStateInputsArr) {
                var vm = this;
                vm.selectedStateInputsArr = angular.copy(selectedStateInputsArr);
                vm.isStructureCreating = true;
                vm.markdownOptionsObj = markdownOptionsObj;
                vm.selectedStateObj = selectedStateObj;
                vm.isConfigurationsSaved = true;
                vm.isStateInfoLoaded = false;
                vm.modalLoadArr = loadArr;
                vm.savedStashArr = [];
                vm.allStatesFromChoice = [];
                vm.modalFlowJson = [];
                vm.modalInjectArr = injectArr;
                vm.stateConfigureObj = [];
                vm.inputsArr = [];
                vm.loadDetail = "Load results (complete or partial) from previously executed states that specified a `stash` value. The map key should be the destination path that the stashed data will be loaded to. e.g. `$.issue.title`. The corresponding map value is the stash name prefixed with a hash symbol `#` followed by the optional path to the field. e.g. `#stash-name.path.to.key`. The initial payload can be accessed using the reserved `#initial` stash name. If this value is not specified the output from the previous state is used.";
                vm.stashValue = stashName;
                vm.arrayIndex = null;
                vm.resetKvpPair = {};
                vm.selectedInputObj = '';
                vm.tabs = [{
                    title: 'Input',
                    tabIndex: 1,
                    visible: true,
                    templateUrl: ''
                }, {
                    title: 'Output',
                    tabIndex: 2,
                    visible: vm.selectedStateObj.type !== 'WAIT' && vm.selectedStateObj.type !== 'CHOICE',
                    templateUrl: ''
                }];

                vm.stateInputFieldArr = [];
                vm.selectedStateInputObj = {};

                vm.fnTabSelected = function (tab) {
                    vm.selectedTab = tab.tabIndex;
                };

                /* Start inject */
                vm.isShowJsonMapView = false;

                /*MapJson: Start*/
                vm.kvpPair = {};
                /*MapJson: End*/

                /*End inject */
                vm.fnGetSelectedState = function () {
                    vm.isStateInfoLoaded = false;
                    var inputObj = {
                        stateId: vm.selectedStateObj.id
                    };

                    StateFactory.getState(inputObj)
                        .then(function (response) {
                            response.name = selectedStateName;
                            vm.stateObj = response;
                            vm.isStateInfoLoaded = true;
                        }, function () {
                            vm.isStateInfoLoaded = true;
                        });
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCreateId = function (val) {
                    return val.replace(/[`~!@#$%^&*()_|+\-=?;:' ",.<>\{\}\[\]\\\/]/gi, '');
                };

                vm.fnIndexName = function (val) {
                    return val.replace('$.', '').replace('*$.', '').replace(/[.]+/ig, " > ");
                };

                /* start : inject functions */

                vm.fnKvpPairChangeInject = function (inputObj, index) {
                    if (inputObj.value === " ") {
                        inputObj.injectMap = '';
                        inputObj.isJsonIndex = true;
                        inputObj.injectMapWith$ = '';
                        inputObj.value = '';
                        inputObj.displayValue = '';
                    }
                    inputObj.displayPath = "Custom";
                    vm.selectedStateInputObj = inputObj;
                    vm.fnShowInjectJsonMapView(inputObj, index);
                };

                vm.fnShowInjectJsonMapView = function (kvpPair, index) {
                    vm.kvpPair = angular.copy(kvpPair);
                    vm.resetKvpPair = angular.copy(kvpPair);
                    vm.arrayIndex = index;
                    vm.isShowJsonMapView = true;
                };

                vm.fnCancelJsonMapView = function () {
                    var isFindInput = _.find(vm.stateInputFieldArr, {keyIndex: vm.resetKvpPair.keyIndex});
                    if (isFindInput) {
                        if (isFindInput.type === 'array') {
                            if (vm.resetKvpPair.isJsonIndex) {
                                isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.resetKvpPair.value);
                                isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.resetKvpPair.value);
                            } else {
                                isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.resetKvpPair.injectMap);
                                isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.resetKvpPair.injectMap);
                            }
                        } else {
                            if (vm.resetKvpPair.isJsonIndex) {
                                isFindInput.value = angular.copy(vm.resetKvpPair.value);
                                isFindInput.displayValue = angular.copy(vm.resetKvpPair.value);
                            } else {
                                isFindInput.value = angular.copy(vm.resetKvpPair.injectMap);
                                isFindInput.displayValue = angular.copy(vm.resetKvpPair.injectMap);
                            }
                        }
                    }
                    vm.kvpPair = {};
                    vm.arrayIndex = null;
                    vm.isShowJsonMapView = false;
                };

                vm.fnConvertObjectToFlatt = function (kvpPair) {
                    kvpPair.isJsonIndex = false;
                    if (kvpPair.value) {
                        if (isJson(kvpPair.value) &&
                            isNaN(parseFloat(kvpPair.value)) && !isFinite(kvpPair.value) &&
                            (kvpPair.value.trim() !== "true" && kvpPair.value.trim() !== "false" &&
                                kvpPair.value.trim() !== true && kvpPair.value.trim() !== false)) {
                            kvpPair.injectMapWith$ = {
                                $: {}
                            };
                            kvpPair.injectMapWith$.$ = angular.fromJson(kvpPair.value);
                            var tempObj = flatten(kvpPair.injectMapWith$);
                            var tempString = "";
                            kvpPair.injectMap = "";
                            Object.keys(tempObj).forEach(function (key) {
                                var tempArr = key.split(".");
                                var tempKeyString = "";
                                var tempIndex = "";
                                angular.forEach(tempArr, function (value) {
                                    if (!isNaN(value)) {
                                        tempIndex = "[" + value + "]";
                                        tempKeyString = tempKeyString + tempIndex;
                                    }
                                    else {
                                        tempKeyString === "" ? tempKeyString = value : tempKeyString = tempKeyString + "." + value //eslint-disable-line
                                        tempIndex = "";
                                    }
                                });
                                var newTempkey = tempKeyString;
                                tempString = "" ? tempString = newTempkey + "=" + tempObj[key] + ";\n" : tempString = tempString + newTempkey + "=" + tempObj[key] + ";\n"; //eslint-disable-line
                            });

                            kvpPair.injectMap = tempString;
                        } else {
                            kvpPair.injectMap = kvpPair.value;
                        }
                    } else {
                        kvpPair.injectMap = '';
                    }
                };

                vm.fnConvertFlattToObject = function (kvpPair, isCalledFromSave) {
                    if (!isCalledFromSave) {
                        kvpPair.isJsonIndex = true;
                    }
                    if (kvpPair.injectMap) {
                        if (kvpPair.injectMap.startsWith('$')) {
                            if (kvpPair.injectMap.includes(";")) {
                                var tempObj = {};
                                var tempArr = kvpPair.injectMap.split(';');
                                angular.forEach(tempArr, function (obj) {
                                    if (obj.includes("=")) {
                                        if (obj.split("=")[1].trim().replace(/["']/g, "") === "true" || obj.split("=")[1].trim().replace(/["']/g, "") === "false") {
                                            tempObj[obj.split("=")[0].trim()] = angular.fromJson(obj.split("=")[1].trim().replace(/["']/g, ""));
                                        }
                                        else {
                                            if (isNaN(obj.split("=")[1].trim().replace(/["']/g, ""))) {
                                                tempObj[obj.split("=")[0].trim()] = obj.split("=")[1].trim().replace(/["']/g, "");
                                            }
                                            else {
                                                tempObj[obj.split("=")[0].trim()] = parseInt(obj.split("=")[1].trim().replace(/["']/g, ""));
                                            }
                                        }
                                    }
                                });
                                kvpPair.value = angular.toJson(unflatten(tempObj).$, true);
                            } else {
                                kvpPair.value = kvpPair.injectMap;
                            }
                        } else {
                            kvpPair.value = kvpPair.injectMap;
                        }
                    } else {
                        kvpPair.value = '';
                    }
                };

                function unflatten(data) {
                    "use strict"; //eslint-disable-line
                    if (Object(data) !== data || angular.isArray(data)) {
                        return data;
                    }
                    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
                        resultholder = {};
                    /*eslint-disable*/
                    for (var p in data) {
                        var cur = resultholder,
                            prop = "",
                            m;
                        while (m = regex.exec(p)) {
                            cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
                            prop = m[2] || m[1];
                        }
                        cur[prop] = data[p];
                    }
                    /*eslint-enable*/
                    return resultholder[""] || resultholder;
                }

                function flatten(data) {
                    var result = {};

                    function recurse(cur, prop) {
                        if (Object(cur) !== cur) {
                            result[prop] = cur;
                        } else if (angular.isArray(cur)) {
                            for (var i = 0, l = cur.length; i < l; i++) {
                                recurse(cur[i], prop ? prop + "." + i : "" + i);
                            }
                            if (l === 0) {
                                result[prop] = [];
                            }
                        } else {
                            var isEmpty = true;
                            /*eslint-disable*/
                            for (var p in cur) {
                                isEmpty = false;
                                recurse(cur[p], prop ? prop + "." + p : p);
                            }
                            /*eslint-enable*/
                            if (isEmpty) {
                                result[prop] = {};
                            }
                        }
                    }

                    recurse(data, "");
                    return result;
                }

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.fnOpenInputInfo = function (inputObj) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/createWorkFlow/modals/inputInfoModal/inputInfoModal.html',
                        size: 'md',
                        controller: 'InputInfoModalCtrl as inputInfoModal',
                        resolve: {
                            inputObj: function () {
                                return inputObj;
                            }
                        }
                    })
                };

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                vm.ordinal_suffix_of = function (i) {
                    var j = i % 10,
                        k = i % 100;
                    if (j === 1 && k !== 11) {
                        return i + "st";
                    }
                    if (j === 2 && k !== 12) {
                        return i + "nd";
                    }
                    if (j === 3 && k !== 13) {
                        return i + "rd";
                    }
                    return i + "th";
                };

                vm.fnCreateArrayInputs = function (arrayModalType, modalObj) {
                    var startPoint = modalObj.key.lastIndexOf("[");
                    var lastPoint = modalObj.key.lastIndexOf("]");
                    var value = modalObj.key.substring(startPoint + 1, lastPoint);
                    var key = modalObj.key.substring(0, startPoint);
                    var isFindKey = _.find(vm.selectedStateInputsArr, {keyIndex: key});
                    if (isFindKey && isFindKey.type === "array") {
                        if (arrayModalType === 'Load') {
                            if (angular.isDefined(isFindKey.inputGroups)) {
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayValue: modalObj.value.includes('.') ? modalObj.value.split('.')[modalObj.value.split('.').length - 1] : modalObj.value,
                                    displayPath: modalObj.value.includes('.') ? modalObj.value.slice(0, modalObj.value.lastIndexOf(".")) : modalObj.value,
                                    value: modalObj.value
                                };
                            } else {
                                isFindKey.inputGroups = [];
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayValue: modalObj.value.includes('.') ? modalObj.value.split('.')[modalObj.value.split('.').length - 1] : modalObj.value,
                                    displayPath: modalObj.value.includes('.') ? modalObj.value.slice(0, modalObj.value.lastIndexOf(".")) : modalObj.value,
                                    value: modalObj.value
                                };
                            }
                        } else {
                            if (angular.isDefined(isFindKey.inputGroups)) {
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayPath: "Custom",
                                    displayValue: modalObj.value,
                                    value: modalObj.value,
                                    injectMap: '',
                                    isJsonIndex: true,
                                    injectMapWith$: ''
                                };
                            } else {
                                isFindKey.inputGroups = [];
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayPath: "Custom",
                                    displayValue: modalObj.value,
                                    value: modalObj.value,
                                    injectMap: '',
                                    isJsonIndex: true,
                                    injectMapWith$: ''
                                };
                            }
                        }
                        isFindKey.isDisplay = false;
                        var isRefFind = _.find(vm.stateInputFieldArr, {keyIndex: isFindKey.keyIndex});
                        if (!isRefFind) {
                            vm.stateInputFieldArr.push(isFindKey);
                        } else {
                            isRefFind.inputGroups[value] = isFindKey.inputGroups[value];
                        }
                    }
                };
                /* end : inject functions */
                vm.fnInitLoadViewModal = function () {
                    vm.fnGetSelectedState();
                    $timeout(function () {
                        vm.newSavedStashArr = [];
                        if (vm.modalLoadArr.length) {
                            _.forEach(vm.modalLoadArr, function (obj) {
                                if (obj.value !== '') {
                                    vm.newSavedStashArr.push({
                                        'index': obj.value,
                                        'keyIndex': obj.value
                                    });
                                }
                            });
                        }
                        var savedStashUniqArr = componentService.getUniqueIndexForTriggersModal(angular.copy(vm.newSavedStashArr));
                        vm.stateloadUiqIndexArr = angular.copy(savedStashUniqArr);

                        vm.inputsArr = angular.copy(vm.selectedStateObj.inputs);
                        vm.newInputsArr = [];
                        _.forEach(vm.inputsArr, function (obj) {
                            vm.newInputsArr.push({'index': obj, 'keyIndex': obj});
                        });
                        _.forEach(vm.modalLoadArr, function (loadObj) {
                            var tempIndex = _.findIndex(vm.newInputsArr, function (inputObj) {
                                return inputObj.index === loadObj.key || inputObj.index === "*" + loadObj.key
                            });
                            if (tempIndex === -1 && loadObj.key.length) {
                                var tokens = loadObj.key.split(".");
                                var result = "*" + tokens[0] + "." + tokens[1];
                                var hasObject = undefined;
                                _.forEach(vm.newInputsArr, function (objLoad) {
                                    if (objLoad.index.startsWith(result)) {
                                        hasObject = objLoad;
                                    }
                                });
                                if (!hasObject) {
                                    vm.newInputsArr.push({'index': loadObj.key, 'keyIndex': loadObj.key});
                                } else {
                                    vm.newInputsArr.push({'index': "*" + loadObj.key, 'keyIndex': "*" + loadObj.key});
                                }
                            }
                        });
                        _.forEach(vm.modalInjectArr, function (injectObj) {
                            var tempIndex = _.findIndex(vm.newInputsArr, function (inputObj) {
                                return inputObj.index === injectObj.key || inputObj.index === "*" + injectObj.key
                            });
                            if (tempIndex === -1 && injectObj.key.length) {
                                var tokens = injectObj.key.split(".");
                                var result = "*" + tokens[0] + "." + tokens[1];
                                var hasObject = undefined;
                                _.forEach(vm.newInputsArr, function (objInject) {
                                    if (objInject.index.startsWith(result)) {
                                        hasObject = objInject;
                                    }
                                });
                                if (!hasObject) {
                                    vm.newInputsArr.push({'index': injectObj.key, 'keyIndex': injectObj.key});
                                } else {
                                    vm.newInputsArr.push({
                                        'index': "*" + injectObj.key,
                                        'keyIndex': "*" + injectObj.key
                                    });
                                }
                            }
                        });
                        _.forEach(vm.newInputsArr, function (inputObj) {
                            inputObj.displayName = vm.fnIndexName(inputObj.index).replace('*', '')
                        });
                        _.forEach(vm.selectedStateInputsArr, function (selectedStateObj) {
                            selectedStateObj.index = selectedStateObj.keyIndex;
                            selectedStateObj.displayName = vm.fnIndexName(selectedStateObj.keyIndex).replace('*', '');
                            selectedStateObj.isDisplay = true;
                            if (selectedStateObj.required && selectedStateObj.required === "yes") {
                                selectedStateObj.isDisplay = false;
                                if (selectedStateObj.type === 'array') {
                                    selectedStateObj.inputGroups = [];
                                    selectedStateObj.inputGroups.push({
                                        description: selectedStateObj.description,
                                        displayName: selectedStateObj.index.includes('.') ? selectedStateObj.index.split('.')[selectedStateObj.index.split('.').length - 1] : selectedStateObj.index,
                                        displayPath: "",
                                        displayValue: "",
                                        index: selectedStateObj.index + "[" + 0 + "]",
                                        keyIndex: selectedStateObj.index,
                                        value: "",
                                        required: "no",
                                        type: "string"
                                    });
                                }
                                vm.stateInputFieldArr.unshift(angular.copy(selectedStateObj));
                            }
                        });
                        _.forEach(vm.modalLoadArr, function (modalLoadObj) {
                            if (modalLoadObj.key !== '' && modalLoadObj.value !== '') {
                                var isFind = _.find(vm.selectedStateInputsArr, {keyIndex: modalLoadObj.key});
                                if (isFind) {
                                    isFind.isDisplay = false;
                                    var tempObj = angular.copy(isFind);
                                    tempObj.value = modalLoadObj.value;
                                    if (tempObj.required && tempObj.required === "yes") {
                                        _.forEach(vm.stateInputFieldArr, function (obj) {
                                            if (obj.keyIndex === tempObj.keyIndex) {
                                                if (obj.type === 'array') {
                                                    vm.fnCreateArrayInputs('Load', modalLoadObj);
                                                } else {
                                                    obj.displayValue = tempObj.value.includes('.') ? tempObj.value.split('.')[tempObj.value.split('.').length - 1] : tempObj.value;
                                                    obj.displayPath = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                                    obj.value = tempObj.value;
                                                }
                                            }
                                        });
                                    } else {
                                        if (tempObj.type === 'array') {
                                            vm.fnCreateArrayInputs('Load', modalLoadObj);
                                        } else {
                                            tempObj.displayValue = tempObj.value.includes('.') ? tempObj.value.split('.')[tempObj.value.split('.').length - 1] : tempObj.value;
                                            tempObj.displayPath = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                        }
                                        vm.stateInputFieldArr.push(tempObj);
                                    }
                                } else {
                                    var regexp = /\[[0-9]+\]$/;
                                    if (regexp.test(modalLoadObj.key)) {
                                        vm.fnCreateArrayInputs('Load', modalLoadObj);
                                    } else {
                                        var newInputObj = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalLoadObj.key).replace('*', ''),
                                            index: modalLoadObj.key,
                                            isDisplay: false,
                                            keyIndex: modalLoadObj.key,
                                            required: "no",
                                            type: "string"
                                        };
                                        var newStateInputField = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalLoadObj.key).replace('*', ''),
                                            index: modalLoadObj.key,
                                            isDisplay: false,
                                            keyIndex: modalLoadObj.key,
                                            required: "no",
                                            type: "string",
                                            displayValue: modalLoadObj.value.includes('.') ? modalLoadObj.value.split('.')[modalLoadObj.value.split('.').length - 1] : modalLoadObj.value,
                                            displayPath: modalLoadObj.value.includes('.') ? modalLoadObj.value.slice(0, modalLoadObj.value.lastIndexOf(".")) : modalLoadObj.value,
                                            value: modalLoadObj.value
                                        };
                                        vm.selectedStateInputsArr.push(newInputObj);
                                        vm.stateInputFieldArr.push(newStateInputField);
                                    }
                                }
                            }
                        });
                        _.forEach(vm.modalInjectArr, function (modalInjectObj) {
                            if (modalInjectObj.key !== '' && modalInjectObj.value !== '') {
                                var isFind = _.find(vm.selectedStateInputsArr, {keyIndex: modalInjectObj.key});
                                if (isFind) {
                                    isFind.isDisplay = false;
                                    var tempObj = angular.copy(isFind);
                                    tempObj.displayPath = "Custom";
                                    tempObj.displayValue = modalInjectObj.value;
                                    tempObj.value = modalInjectObj.value;
                                    tempObj.injectMap = modalInjectObj.injectMap ? modalInjectObj.injectMap : '';
                                    tempObj.isJsonIndex = modalInjectObj.isJsonIndex ? modalInjectObj.isJsonIndex : true;
                                    tempObj.injectMapWith$ = modalInjectObj.injectMapWith$ ? modalInjectObj.injectMapWith$ : '';
                                    if (tempObj.required && tempObj.required === "yes") {
                                        _.forEach(vm.stateInputFieldArr, function (obj) {
                                            if (obj.keyIndex === tempObj.keyIndex) {
                                                if (obj.type === 'array') {
                                                    vm.fnCreateArrayInputs('Load', modalInjectObj);
                                                } else {
                                                    obj.displayPath = tempObj.displayPath;
                                                    obj.displayValue = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                                    obj.value = tempObj.value;
                                                    obj.injectMap = tempObj.injectMap;
                                                    obj.isJsonIndex = tempObj.isJsonIndex;
                                                    obj.injectMapWith$ = tempObj.injectMapWith$;
                                                }
                                            }
                                        });
                                    } else {
                                        vm.stateInputFieldArr.push(tempObj);
                                    }
                                } else {
                                    var regexp = /\[[0-9]+\]$/;
                                    if (regexp.test(modalInjectObj.key)) {
                                        vm.fnCreateArrayInputs('Inject', modalInjectObj);
                                    } else {
                                        var newInputObj = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalInjectObj.key).replace('*', ''),
                                            index: modalInjectObj.key,
                                            isDisplay: false,
                                            keyIndex: modalInjectObj.key,
                                            required: "no",
                                            type: "string"
                                        };
                                        var newStateInputField = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalInjectObj.key).replace('*', ''),
                                            index: modalInjectObj.key,
                                            isDisplay: false,
                                            keyIndex: modalInjectObj.key,
                                            required: "no",
                                            type: "string",
                                            displayPath: "Custom",
                                            displayValue: modalInjectObj.value,
                                            value: modalInjectObj.value,
                                            injectMap: '',
                                            isJsonIndex: true,
                                            injectMapWith$: ''
                                        };
                                        vm.selectedStateInputsArr.push(newInputObj);
                                        vm.stateInputFieldArr.push(newStateInputField);
                                    }
                                }
                            }
                        });

                        vm.selectedInputObj = '';
                        vm.inputIndexArray = componentService.getUniqueIndexForTriggersModal(vm.selectedStateInputsArr);
                        vm.savedStashNameArr = [];
                        if (Object.keys(vm.stateConfigureObj).length) {
                            Object.keys(vm.stateConfigureObj).forEach(function (key) {
                                if (vm.stateConfigureObj[key].sudoId !== vm.selectedStateObj.sudoId) {
                                    if (vm.stateConfigureObj[key].parameters && vm.stateConfigureObj[key].parameters.stash) {
                                        vm.savedStashNameArr.push(vm.stateConfigureObj[key].parameters.stash);
                                    }
                                }
                            });
                        }
                        /*output model tree-view*/
                        vm.newOutputsArr = [];
                        _.forEach(vm.selectedStateObj.outputs, function (obj) {
                            vm.newOutputsArr.push({'index': obj, 'keyIndex': obj});
                        });
                        var outputUniqArr = componentService.getUniqueIndexForTriggersModal(vm.newOutputsArr);
                        var outputNestedData = componentService.getHierarchyForTriggersModal(outputUniqArr, vm.newOutputsArr);
                        vm.nestedOutputArr = angular.copy(outputNestedData);
                        //fnCreateStructure(true);
                        $timeout(function () {
                            vm.isStructureCreating = false;
                        }, 100)
                    }, 500)
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('verifyDetailsModalCtrl',
            function ($scope, $uibModalInstance, $timeout, $window, $base64, $uibModal, DB, amaran,
                      swal, microSpinner, Iot3WorkbenchFactory, verifyObj, isCreate, iot3JsonObj, mappingsArr) {
                var vm = this;

                vm.verifyObj = isCreate ? verifyObj : _.cloneDeepWith(verifyObj);
                vm.isCreate = isCreate;
                vm.iot3JsonObj = iot3JsonObj;
                vm.mappingsArr = mappingsArr;

                vm.selectorPathOptions = {
                    'JSON': 'gjson',
                    'XML': 'xpath',
                    'HTML': 'xpath',
                    'CSV': 'xpath',
                    'OID': 'oid',
                    'Cookie': 'cookie',
                    'Header': 'header'
                };

                vm.attrSelectorPathOptions = [
                    "xpath",
                    "xslt",
                    "oid",
                    "gjson",
                    "cookie",
                    "header"
                ];

                vm.attrFilterOptionsForVerify = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "split",
                    "displayValue": "split",
                    "isArguments": true,
                    "isShow": true
                }];
                vm.resetAttrFilterOptionsForVerify = _.cloneDeepWith(vm.attrFilterOptionsForVerify);

                vm.fnResetSampleData = function (verifyObj) {
                    verifyObj.sampleDataForVerify = {};
                    verifyObj.selectedSampleDataForVerify = '';
                    verifyObj.manipulatedSampleDataForVerify = '';
                    verifyObj.isShowSampleDataForVerify = false;

                    if (!(verifyObj &&
                        verifyObj.selector &&
                        verifyObj.selector.type &&
                        verifyObj.selector.type.length)) {
                        verifyObj.selector.type = vm.selectorPathOptions.HTML;
                    }
                };

                vm.fnSelectMapper = function (mappingObj, verifyObj) {
                    verifyObj.extractor.mapper = mappingObj.id;
                    verifyObj.isMapperSelectedForVerify = true;
                };

                vm.fnSelectExtractFilterForVerify = function (attrFilterObj, kvpPair, verifyObj) {
                    if (attrFilterObj.filterValue === 'switch' && (!kvpPair.switchValuesArr ||
                        (kvpPair.switchValuesArr && !kvpPair.switchValuesArr.length))) {
                        kvpPair.switchValuesArr = [{
                            value: ''
                        }];
                    }
                    kvpPair.key = attrFilterObj.filterValue;
                    kvpPair.isArguments = attrFilterObj.isArguments;
                    // attrFilterObj.isShow = false;
                    if (verifyObj.extractFiltersArrForVerify[verifyObj.extractFiltersArrForVerify.length - 1 ].key !== '') {
                        verifyObj.extractFiltersArrForVerify.push({
                            key: '',
                            isArguments: true,
                            value: ''
                        })
                    }
                };

                vm.fnRemoveExtractFilterForVerify = function (kvpPair, $index, verifyObj) {
                    verifyObj.extractFiltersArrForVerify.splice($index, 1);
                };

                vm.fnAddSwitchOption = function (kvpPair) {
                    kvpPair.switchValuesArr.push({
                        value: ''
                    })
                };

                function convertCSVToXML(csvData) {
                    var splitter = ',';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    }
                    var csvArr = csvData.split('\n');
                    csvArr = _.map(csvArr, function (row) {
                        return row.trim();
                    });
                    var headings = csvArr[0].split(splitter);
                    var xml = '';

                    for (var i = 1; i < csvArr.length; i++) {
                        var details = csvArr[i].split(splitter);
                        xml += "<row>\n";

                        for (var j = 0; j < headings.length; j++) {
                            xml += '<item>'+ details[j] +'</item>';
                        }

                        xml += "</row>\n";
                    }
                    return xml;
                }

                function getElementByXpath(path) {
                    try {
                        return document.evaluate(path, document.getElementById('workBenchSampleTest'), null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    } catch (e) {
                        amaran.error(e);
                        return null;
                    }
                }

                function fnConvertOidToJson(oidData) {
                    var tempObj = {};
                    var oidArr = oidData.split('\n');
                    oidArr = _.map(oidArr, function (row) {
                        return row.trim();
                    });
                    _.forEach(oidArr, function (oidStr) {
                        var grp = oidStr.split(':');
                        tempObj[grp[0].trim()] = grp[1].trim();
                    });
                    return tempObj;
                }

                vm.fnOpenExpressionModal = function (expression, expressionType, sampleDataForVerify) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/expressionModal/expressionModal.html',
                        size: 'lg',
                        controller: 'expressionModalCtrl as expressionModal',
                        windowClass: 'modal-fullScreen',
                        resolve: {
                            expression: function () {
                                return expression;
                            },
                            expressionType: function () {
                                return expressionType;
                            },
                            sampleDataForSelectedAttr: function () {
                                return sampleDataForVerify;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        vm.verifyObj.selector.expression = obj.expression;
                        vm.verifyObj.selectedSampleDataForVerify = obj.selectedSampleData;
                    }, function () {
                    });
                };

                vm.fnGetSampleDataFromExpressionForVerify = function (verifyObj) {
                    if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse(verifyObj.sampleDataForVerify.sampleData.toString()); //eslint-disable-line
                            var selectedSampleDataForVerify = _.get(tempObj,
                                verifyObj.selector.expression, 'notFound');
                            if (selectedSampleDataForVerify === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                verifyObj.isShowSampleDataForVerify = false;
                            } else {
                                verifyObj.selectedSampleDataForVerify = selectedSampleDataForVerify;
                                verifyObj.isShowSampleDataForVerify = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            verifyObj.isShowSampleDataForVerify = false;
                        }
                    } else if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'html' ||
                        verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if (verifyObj.sampleDataForVerify.sampleData && verifyObj.sampleDataForVerify.sampleData.length) {
                            if (verifyObj.sampleDataForVerify.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(verifyObj.sampleDataForVerify.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(verifyObj.sampleDataForVerify.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": verifyObj.selector.expression,
                                "document": sampleData
                            }
                        };
                        Iot3WorkbenchFactory.evaluateXpath(inputObj)
                            .then(function (response) {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                if (response) {
                                    if (response.result) {
                                        verifyObj.selectedSampleDataForVerify = {
                                            sampleDataVal: response.result,
                                            isCollection: angular.isArray(response.result)
                                        };
                                        verifyObj.isShowSampleDataForVerify = true;
                                    } else if (response.error) {
                                        amaran.error(response.error);
                                        verifyObj.isShowSampleDataForVerify = false;
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        verifyObj.isShowSampleDataForVerify = false;
                                    }
                                } else {
                                    amaran.error('Something went wrong. Please try again.');
                                    verifyObj.isShowSampleDataForVerify = false;
                                }
                            }, function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                amaran.error('Something went wrong. Please try again.');
                                verifyObj.isShowSampleDataForVerify = false;
                            });
                    } else if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML(verifyObj.sampleDataForVerify.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainer');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if (verifyObj.selector.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath(verifyObj.selector.expression);
                        } else {
                            if (verifyObj.selector.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath(verifyObj.selector.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + verifyObj.selector.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + verifyObj.selector.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            verifyObj.isShowSampleDataForVerify = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                verifyObj.selectedSampleDataForVerify = htmlObjForCSV.innerHTML;
                            } else {
                                verifyObj.selectedSampleDataForVerify = htmlObjForCSV;
                            }
                            verifyObj.isShowSampleDataForVerify = true;
                        }
                        tempElemForCSV.remove();
                    } else if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson(verifyObj.sampleDataForVerify.sampleData);
                        if (oidJSon[verifyObj.selector.expression]) {
                            verifyObj.selectedSampleDataForVerify = oidJSon[verifyObj.selector.expression];
                            verifyObj.isShowSampleDataForVerify = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            verifyObj.isShowSampleDataForVerify = false;
                        }
                    } else if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = verifyObj.sampleDataForVerify.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes(verifyObj.selector.expression + "=")) {
                                    var cookieStr = splitStr.split(verifyObj.selector.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    verifyObj.selectedSampleDataForVerify = finalVal;
                                    verifyObj.isShowSampleDataForVerify = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    verifyObj.isShowSampleDataForVerify = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            verifyObj.isShowSampleDataForVerify = false;
                        }
                    } else if (verifyObj.sampleDataForVerify.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = verifyObj.sampleDataForVerify.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith(verifyObj.selector.expression + ':')) {
                                HeaderFlag = false;
                                verifyObj.selectedSampleDataForVerify = splitStr.split(verifyObj.selector.expression + ':')[1];
                                verifyObj.isShowSampleDataForVerify = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            verifyObj.isShowSampleDataForVerify = false;
                        }
                    } else {
                        verifyObj.isShowSampleDataForVerify = false;
                    }
                };

                vm.fnOpenSampleDataModal = function (verifySampleDataObj) {
                    var sampleData = '';
                    if (verifySampleDataObj.sampleDataType &&
                        (verifySampleDataObj.sampleDataType.toLowerCase() === 'html' ||
                            verifySampleDataObj.sampleDataType.toLowerCase() === 'xml')) {
                        if (verifySampleDataObj.sampleData && verifySampleDataObj.sampleData.length) {
                            if (verifySampleDataObj.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(verifySampleDataObj.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(verifySampleDataObj.sampleData)))
                            }
                        }
                    } else {
                        sampleData = _.cloneDeepWith(verifySampleDataObj.sampleData)
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/sampleDataModal/sampleDataModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'sampleDataModalCtrl as sampleDataModal',
                        resolve: {
                            sampleDataObj: function () {
                                return {
                                    type: verifySampleDataObj.sampleDataType,
                                    value: sampleData
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.$broadcast('topologyResizeCall');
                    }, function () {
                        $scope.$broadcast('topologyResizeCall');
                    });
                };

                vm.fnSelectSelectorPathOptions = function (selectorValue, verifyObj) {
                    verifyObj.selector.type = selectorValue;
                };

                vm.fnGlobalKeySelectedForDataSource = function (item, model, label, event, dataSourceKey, verifyObj) {
                    if (verifyObj.oldValueKeyForDataSource.includes('.')) {
                        verifyObj.dataSource = verifyObj.oldValueKeyForDataSource.substr(0, verifyObj.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                    } else {
                        verifyObj.dataSource = '%{' + dataSourceKey.name;
                    }
                };

                vm.fnCheckUniqueKeyForDataSource = function (dataSourceKey, verifyObj) {
                    verifyObj.globalKeyOptionsForDataSource = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        verifyObj.oldValueKeyForDataSource = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get(vm.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    verifyObj.globalKeyOptionsForDataSource.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys(vm.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                verifyObj.globalKeyOptionsForDataSource.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                vm.fnGetTypeSampleData = function (verifyObj) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if (verifyObj &&
                            verifyObj.dataSource &&
                            verifyObj.dataSource.length &&
                            verifyObj.dataSource.startsWith('%{') &&
                            verifyObj.dataSource.endsWith('}') &&
                            workbench.currentWorkspaceEngineSampleData &&
                            Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                            var engineTrail = verifyObj.dataSource.substr(2, verifyObj.dataSource.lastIndexOf('}') - 2);
                            var requestName = engineTrail.split('.');
                            var value = _.get(workbench.currentWorkspaceEngineSampleData, requestName[requestName.length - 1], 'notFound');

                            if (value !== 'notFound' && value.constructor.name === 'Object' &&
                                (value.sampleData && value.sampleData !== '')) {
                                verifyObj.sampleDataForVerify = value;
                                verifyObj.selector.type = vm.selectorPathOptions[value.sampleDataType];
                            } else {
                                vm.fnResetSampleData(verifyObj);
                            }
                        } else {
                            vm.fnResetSampleData(verifyObj);
                        }
                    } else {
                        vm.fnResetSampleData();
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.verifyObj);
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('sampleDataModalForEngineCtrl',
            function ($uibModalInstance, $timeout, $window, sampleDataObj) {
                var vm = this;
                vm.sampleDataObj = sampleDataObj;

                vm.sampleDataOptions = {
                    "HTML": "text/html",
                    "XML": "text/html",
                    "JSON": "javascript",
                    "CSV": "null",
                    "OID": "null",
                    "Cookie": "null",
                    "Header": "null"
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    mode: vm.sampleDataObj.type && vm.sampleDataOptions[vm.sampleDataObj.type] ?
                        vm.sampleDataOptions[vm.sampleDataObj.type] : 'null',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function (mode) {
                            _cm.setOption("mode", mode);
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            /*$timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);*/
                        });
                    }
                };

                vm.fnSelectSampleDataLanguage = function (typeMode, type) {
                    vm.sampleDataObj.type = type;
                    vm.modeChanged(typeMode);
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged(vm.sampleDataOptions[vm.sampleDataObj.type]);
                    }, 150)
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close({type: vm.sampleDataObj.type, value: vm.sampleDataObj.value});
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('discoveryDetailsModalCtrl',
            function ($scope, $uibModalInstance, $timeout, $window, $base64, $uibModal, DB, swal, microSpinner, amaran,
                      Iot3WorkbenchFactory, discoverySelectorObj, isCreate) {
                var vm = this;

                vm.discoverySelectorObj = isCreate ? discoverySelectorObj : _.cloneDeepWith(discoverySelectorObj);
                vm.isCreate = isCreate;

                vm.attrSelectorPathOptions = [
                    "xpath",
                    "xslt",
                    "oid",
                    "gjson",
                    "cookie",
                    "header"
                ];

                function convertCSVToXML(csvData) {
                    var splitter = ',';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    }
                    var csvArr = csvData.split('\n');
                    csvArr = _.map(csvArr, function (row) {
                        return row.trim();
                    });
                    var headings = csvArr[0].split(splitter);
                    var xml = '';

                    for (var i = 1; i < csvArr.length; i++) {
                        var details = csvArr[i].split(splitter);
                        xml += "<row>\n";

                        for (var j = 0; j < headings.length; j++) {
                            xml += '<item>'+ details[j] +'</item>';
                        }

                        xml += "</row>\n";
                    }
                    return xml;
                }

                function fnConvertOidToJson(oidData) {
                    var tempObj = {};
                    var oidArr = oidData.split('\n');
                    oidArr = _.map(oidArr, function (row) {
                        return row.trim();
                    });
                    _.forEach(oidArr, function (oidStr) {
                        var grp = oidStr.split(':');
                        tempObj[grp[0].trim()] = grp[1].trim();
                    });
                    return tempObj;
                }

                function getElementByXpath(path) {
                    try {
                        return document.evaluate(path, document.getElementById('workBenchSampleTest'), null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    } catch (e) {
                        amaran.error(e);
                        return null;
                    }
                }

                vm.fnOpenExpressionModal = function (expression, expressionType, sampleDataForDiscovery) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/expressionModal/expressionModal.html',
                        size: 'lg',
                        controller: 'expressionModalCtrl as expressionModal',
                        windowClass: 'modal-fullScreen',
                        resolve: {
                            expression: function () {
                                return expression;
                            },
                            expressionType: function () {
                                return expressionType;
                            },
                            sampleDataForSelectedAttr: function () {
                                return sampleDataForDiscovery;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        vm.discoverySelectorObj.value.selectorObj.expression = obj.expression;
                        vm.discoverySelectorObj.value.selectedSampleDataForDiscovery = obj.selectedSampleData;
                    }, function () {
                    });
                };

                vm.fnGetSampleDataFromExpressionForDiscovery = function (discoverySelectorObj) {
                    if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse(discoverySelectorObj.sampleDataForDiscovery.sampleData.toString()); //eslint-disable-line
                            var selectedSampleDataForDiscovery = _.get(tempObj,
                                discoverySelectorObj.selectorObj.expression, 'notFound');
                            if (selectedSampleDataForDiscovery === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                discoverySelectorObj.isShowSampleDataForDiscovery = false;
                            } else {
                                discoverySelectorObj.selectedSampleDataForDiscovery = selectedSampleDataForDiscovery;
                                discoverySelectorObj.isShowSampleDataForDiscovery = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            discoverySelectorObj.isShowSampleDataForDiscovery = false;
                        }
                    } else if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'html' ||
                        discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if (discoverySelectorObj.sampleDataForDiscovery.sampleData &&
                            discoverySelectorObj.sampleDataForDiscovery.sampleData.length) {
                            if (discoverySelectorObj.sampleDataForDiscovery.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(discoverySelectorObj.sampleDataForDiscovery.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(discoverySelectorObj.sampleDataForDiscovery.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": discoverySelectorObj.selectorObj.expression,
                                "document": sampleData
                            }
                        };
                        Iot3WorkbenchFactory.evaluateXpath(inputObj)
                            .then(function (response) {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                if (response) {
                                    if (response.result) {
                                        discoverySelectorObj.selectedSampleDataForDiscovery = {
                                            sampleDataVal: response.result,
                                            isCollection: angular.isArray(response.result)
                                        };
                                        discoverySelectorObj.isShowSampleDataForDiscovery = true;
                                    } else if (response.error) {
                                        amaran.error(response.error);
                                        discoverySelectorObj.isShowSampleDataForDiscovery = false;
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        discoverySelectorObj.isShowSampleDataForDiscovery = false;
                                    }
                                } else {
                                    amaran.error('Something went wrong. Please try again.');
                                    discoverySelectorObj.isShowSampleDataForDiscovery = false;
                                }
                            }, function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                amaran.error('Something went wrong. Please try again.');
                                discoverySelectorObj.isShowSampleDataForDiscovery = false;
                            });
                    } else if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML(discoverySelectorObj.sampleDataForDiscovery.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainerForDiscovery');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if (discoverySelectorObj.selectorObj.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath(discoverySelectorObj.selectorObj.expression);
                        } else {
                            if (discoverySelectorObj.selectorObj.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath(discoverySelectorObj.selectorObj.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + discoverySelectorObj.selectorObj.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + discoverySelectorObj.selectorObj.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            discoverySelectorObj.isShowSampleDataForDiscovery = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                discoverySelectorObj.selectedSampleDataForDiscovery = htmlObjForCSV.innerHTML;
                            } else {
                                discoverySelectorObj.selectedSampleDataForDiscovery = htmlObjForCSV;
                            }
                            discoverySelectorObj.isShowSampleDataForDiscovery = true;
                        }
                        tempElemForCSV.remove();
                    } else if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson(discoverySelectorObj.sampleDataForDiscovery.sampleData);
                        if (oidJSon[discoverySelectorObj.selectorObj.expression]) {
                            discoverySelectorObj.selectedSampleDataForDiscovery = oidJSon[discoverySelectorObj.selectorObj.expression];
                            discoverySelectorObj.isShowSampleDataForDiscovery = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            discoverySelectorObj.isShowSampleDataForDiscovery = false;
                        }
                    } else if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = discoverySelectorObj.sampleDataForDiscovery.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes(discoverySelectorObj.selectorObj.expression + "=")) {
                                    var cookieStr = splitStr.split(discoverySelectorObj.selectorObj.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    discoverySelectorObj.selectedSampleDataForDiscovery = finalVal;
                                    discoverySelectorObj.isShowSampleDataForDiscovery = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    discoverySelectorObj.isShowSampleDataForDiscovery = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            discoverySelectorObj.isShowSampleDataForDiscovery = false;
                        }
                    } else if (discoverySelectorObj.sampleDataForDiscovery.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = discoverySelectorObj.sampleDataForDiscovery.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith(discoverySelectorObj.selectorObj.expression + ':')) {
                                HeaderFlag = false;
                                discoverySelectorObj.selectedSampleDataForDiscovery = splitStr.split(discoverySelectorObj.selectorObj.expression + ':')[1];
                                discoverySelectorObj.isShowSampleDataForDiscovery = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            discoverySelectorObj.isShowSampleDataForDiscovery = false;
                        }
                    } else {
                        discoverySelectorObj.isShowSampleDataForDiscovery = false;
                    }
                };

                vm.fnOpenSampleDataModal = function (discoverySampleDataObj) {
                    var sampleData = '';
                    if (discoverySampleDataObj.sampleDataType &&
                        (discoverySampleDataObj.sampleDataType.toLowerCase() === 'html' ||
                            discoverySampleDataObj.sampleDataType.toLowerCase() === 'xml')) {
                        if (discoverySampleDataObj.sampleData && discoverySampleDataObj.sampleData.length) {
                            if (discoverySampleDataObj.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(discoverySampleDataObj.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(discoverySampleDataObj.sampleData)))
                            }
                        }
                    } else {
                        sampleData = _.cloneDeepWith(discoverySampleDataObj.sampleData)
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/sampleDataModal/sampleDataModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'sampleDataModalCtrl as sampleDataModal',
                        resolve: {
                            sampleDataObj: function () {
                                return {
                                    type: discoverySampleDataObj.sampleDataType,
                                    value: sampleData
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $scope.$broadcast('topologyResizeCall');
                    }, function () {
                        $scope.$broadcast('topologyResizeCall');
                    });
                };

                vm.fnSelectDiscoveryPathOptions = function (selectorValue, discoverySelectorObj) {
                    discoverySelectorObj.value.selectorObj.type = selectorValue;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.discoverySelectorObj);
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('engineRequestModalCtrl',
            function ($scope, $uibModalInstance, $timeout, $window, $base64, $uibModal, requestObj, isCreate) {
                var vm = this;
                vm.requestObj = isCreate ? requestObj : _.cloneDeepWith(requestObj);

                vm.methodOptionsArr = ["GET", "POST", "PUT", "PATCH", "DELETE"];

                vm.responseTypeEnumerationOptions = [{
                    name: 'header'
                }, {
                    name: 'cookie'
                }, {
                    name: 'body'
                }];

                vm.fnSelectMethodType = function (requestObj, methodType) {
                    requestObj.value.method = methodType;
                };

                vm.fnCheckUniqueKeyForOptions = function (kvpPairObj, index, queryArr) {
                    var count = 0;
                    angular.forEach(queryArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    kvpPairObj.isKeyDuplicated = count > 1;
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === queryArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && queryArr[queryArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (queryArr.length > 1) {
                                    angular.forEach(queryArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    queryArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnRemoveSupplementalForOption = function (index, OptionsArr) {
                    OptionsArr.splice(index, 1);
                };

                vm.fnAddResponse = function (event, responseArr) {
                    event.preventDefault();
                    responseArr.push({
                        type: 'header',
                        expression: '',
                        match: ''
                    })
                };

                vm.fnRemoveResponse = function (event, index, responseArr) {
                    event.preventDefault();
                    responseArr.splice(index, 1);
                };

                vm.fnSelectHttpResponseEnumeration = function (name, responseObj) {
                    responseObj.type = name
                };

                vm.fnOpenSampleDataModal = function (requestObj) {
                    var sampleData = '';
                    if (requestObj.sampleDataType &&
                        (requestObj.sampleDataType.toLowerCase() === 'html' ||
                            requestObj.sampleDataType.toLowerCase() === 'xml')) {
                        if (requestObj.sampleData && requestObj.sampleData.length) {
                            if (requestObj.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(requestObj.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(requestObj.sampleData)))
                            }
                        }
                    } else {
                        sampleData = _.cloneDeepWith(requestObj.sampleData)
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/steps/engine/modals/sampleDataModal/sampleDataModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'sampleDataModalForEngineCtrl as sampleDataModal',
                        resolve: {
                            sampleDataObj: function () {
                                return {
                                    type: _.cloneDeepWith(requestObj.sampleDataType),
                                    value: sampleData
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        requestObj.sampleDataType = _.cloneDeepWith(data.type);
                        if (data.type && (data.type === 'HTML' || data.type.toLowerCase() === 'xml')) {
                            requestObj.sampleData = $base64.encode(encodeURIComponent(_.cloneDeepWith(data.value)));
                        } else {
                            requestObj.sampleData = _.cloneDeepWith(data.value);
                        }
                        $scope.$broadcast('engineResizeCall');
                    }, function () {
                        $scope.$broadcast('engineResizeCall');
                    });
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.requestObj);
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, IssueFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.issueSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetIssueData = function (issueObj) {
                    var inputObj = {
                        issueId: issueObj.id
                    };

                    IssueFactory.describeIssue(inputObj)
                        .then(function (response) {
                            vm.issueSupplementalObj = response.tags ? angular.fromJson(response.tags) : {};
                            vm.issueSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.issueSupplementalObj, true) : vm.issueSupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.issueSupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.issueSupplementalObj)) {
                                angular.forEach(vm.issueSupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isIssueSupplementalDetailsLoaded = true;
                        })
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.issueSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.issueSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.issueSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.issueSupplementalObj = angular.toJson(vm.issueSupplementalObj, true);
                    } else {
                        vm.issueSupplementalObj = angular.fromJson(vm.issueSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.issueSupplementalObj)) {
                            angular.forEach(vm.issueSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveIssueData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.issueObj.tags = {};
                    var inputObj = {
                        issueId: vm.parent.issueObj.id,
                        body: {}
                    };
                    if (!vm.parent.issueObj.tags) {
                        vm.parent.issueObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.issueObj.tags = angular.fromJson(vm.issueSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.issueObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.issueObj.tags;
                    IssueFactory.replaceIssueTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Issue successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitIssueSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitIssueSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.issueSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.issueSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.issueSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitIssueSupplemental = function () {
                    vm.isIssueSupplementalDetailsLoaded = false;
                    if (vm.parent.issueObj.id) {
                        vm.fnGetIssueData(vm.parent.issueObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssuePrivateCtrl',
            function ($scope, $rootScope, $timeout, $http, $window, $sce, moment, PermissionsService, mermaid, microSpinner,
                      swal, amaran, copyService, CommentFactory, AvatarService, ColorService, DB, IssueFactory,
                      postActionModelMessage, postActionModelIcon, UserProfileService) {
                var vm = this;
                vm.parent = $scope.$parent;
                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                vm.isIssueDetailsLoaded = false;
                vm.selectedCommentView = _.cloneDeepWith(vm.parent.selectedCommentView);

                vm.issueObj = {};
                vm.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');
                vm.loginUserAvatar = AvatarService.getTextAvatar(vm.loginUser);
                vm.selectedComment = {};
                vm.isShowIssueSummary = false;
                vm.isShowMainComment = false;
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                vm.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;

                vm.newCommentObj = {
                    privateStream: true,
                    text: ""
                };
                vm.newSubComment = {
                    text: ""
                }
                vm.markedOptionObj = {
                    iconlibrary: "fa",
                    addExtraButtons: false,
                    resize: "vertical",
                    initialstate: "preview",
                    hiddenButtons: ['all']
                };

                vm.newCommentMarkedOptionObj = {
                    iconlibrary: 'fa',
                    addExtraButtons: false,
                    resize: 'vertical',
                    hiddenButtons: ['all']
                };
                vm.issuePrivateTabAPITimeout = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTabHeight();
                });

                vm.fnKeyDownComment = function () {
                    $timeout(function () {
                        var total = angular.element(".newCommentUI")[0].offsetHeight;
                        var commentTimeline = angular.element(".comment-timeline")[0] ? angular.element(".comment-timeline")[0].offsetHeight : 0;
                        var commentHeader = angular.element(".comment-header")[0] ? angular.element(".comment-header")[0].offsetHeight : 0;
                        var newHeight = (total - (commentTimeline + commentHeader + 105));
                        var minHeight = newHeight * 40 / 100;
                        var value = document.getElementsByClassName('newCommentTextBox')[0].value;
                        var numberOfLineBreaks = (value.match(/\n/g) || []).length;
                        var newHeight1 = 20 + numberOfLineBreaks * 20 + 12 + 2;
                        if (newHeight1 > minHeight) {
                            angular.element(".newCommentTextBox").css('height', newHeight1)
                        }
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    });
                };

                vm.fnClickNewComment = function (blur) {
                    if (angular.element(".newCommentUI")[0]) {
                        var total = angular.element(".newCommentUI")[0].offsetHeight;
                        var commentTimeline = angular.element(".comment-timeline")[0] ? angular.element(".comment-timeline")[0].offsetHeight : 0;
                        var commentHeader = angular.element(".comment-header")[0] ? angular.element(".comment-header")[0].offsetHeight : 0;
                        var commnetBodyHeight = angular.element(".newCommentTextBox")[0].offsetHeight;
                        var commnetBodyScrollHeight = angular.element(".newCommentTextBox")[0].scrollHeight;
                        var newHeight = (total - (commentTimeline + commentHeader + 105));
                        var minHeight = newHeight * 40 / 100;
                        angular.element(".newCommentTextBox").css('max-height', newHeight * 70 / 100);
                        if (blur) {
                            var value = document.getElementsByClassName('newCommentTextBox')[0].value;
                            var numberOfLineBreaks = (value.match(/\n/g) || []).length;
                            var newHeight1 = 20 + numberOfLineBreaks * 20 + 12 + 2;
                            if (newHeight1 > minHeight) {
                                angular.element(".newCommentTextBox").css('height', newHeight1)
                            }
                            if (!value.length) {
                                angular.element(".newCommentTextBox").css('height', 45)
                            }
                        } else {
                            if (commnetBodyHeight !== commnetBodyScrollHeight) {
                                angular.element(".newCommentTextBox").css('height', commnetBodyScrollHeight);
                            } else {
                                angular.element(".newCommentTextBox").css('height', minHeight);
                            }
                        }
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    }
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        $timeout(function () {
                            if (angular.element(".comment-timeline")[0]) {
                                var commentTimeline = angular.element(".comment-timeline")[0].offsetHeight;
                                var newCommentBlock = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                var commentHeader = angular.element(".comment-header")[0].offsetHeight;
                                var commentFooter = angular.isDefined(angular.element(".comment-footer")[0]) ? angular.element(".comment-footer")[0].offsetHeight : 0;
                                //var test = finalHeight + 200;
                                angular.element(".comment-body").css('height', (finalHeight - (commentTimeline + newCommentBlock + commentHeader + commentFooter + 60)) + 'px');
                            }
                            if (angular.element(".vertical-comment-view")[0]) {
                                var newCommentBlock1 = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                angular.element(".vertical-comment-view").css('height', (finalHeight - (newCommentBlock1 + 40)) + 'px');
                                //angular.element(".qa-message-content").css('height', ((finalHeight - (newCommentBlock1 + 40)) - 53) + 'px');
                                if (vm.issueSummary.isEditMode) {
                                    angular.element("#" + vm.issueSummary.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                } else {
                                    angular.element("#" + vm.issueSummary.id).css('height', '');
                                    if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                        _.forEach(vm.issueObj.privateComments, function (publicCommentObj) {
                                            if (publicCommentObj.isEditMode) {
                                                angular.element("#" + publicCommentObj.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                            } else {
                                                angular.element("#" + publicCommentObj.id).css('height', '');
                                            }
                                            if (publicCommentObj.subComments && publicCommentObj.subComments.length) {
                                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                                    if (subCommentObj.isEditMode) {
                                                        angular.element("#" + subCommentObj.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                                    } else {
                                                        angular.element("#" + subCommentObj.id).css('height', '');
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }
                                if (angular.element("#newSubComment")[0]) {
                                    angular.element("#newSubComment").css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                }
                            }
                        })
                    }
                };

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata, commentObj, newSubCommentObj) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        var elementName = '';
                        if (commentObj) {
                            elementName = 'editor' + commentObj.id;
                        } else if (newSubCommentObj) {
                            elementName = 'newSubCommentEditor';
                        } else {
                            elementName = 'newCommentEditor';
                        }
                        var domElement = document.getElementsByName(elementName)[0];
                        if (angular.isDefined(domElement)) {
                            var val = '';
                            if (type === 'image') {
                                if (commentObj) {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            } else {
                                if (commentObj) {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            }
                            if (document.selection) {
                                domElement.focus();
                                var sel = document.selection.createRange();
                                sel.text = val;
                                domElement.focus();
                            } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                                var startPos = domElement.selectionStart;
                                var endPos = domElement.selectionEnd;
                                var scrollTop = domElement.scrollTop;
                                domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                                domElement.focus();
                                domElement.selectionStart = startPos + val.length;
                                domElement.selectionEnd = startPos + val.length;
                                domElement.scrollTop = scrollTop;
                            } else {
                                domElement.value += val;
                                domElement.focus();
                            }
                            if (commentObj) {
                                commentObj.mdBody = document.getElementsByName(elementName)[0].value;
                                commentObj.fileUploading = false;
                            } else if (newSubCommentObj) {
                                vm.newSubComment.text = document.getElementsByName(elementName)[0].value;
                                vm.newSubComment.fileUploading = false;
                            } else {
                                vm.newCommentObj.text = document.getElementsByName(elementName)[0].value;
                                vm.newCommentObj.fileUploading = false;
                            }
                        } else {
                            if (type === 'image') {
                                if (commentObj) {
                                    commentObj.mdBody = commentObj.mdBody + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    vm.newSubComment.text = vm.newSubComment.text + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    vm.newCommentObj.text = vm.newCommentObj.text + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            } else {
                                if (commentObj) {
                                    commentObj.mdBody = commentObj.mdBody + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    vm.newSubComment.text = vm.newSubComment.text + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    vm.newCommentObj.text = vm.newCommentObj.text + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            }
                            if (commentObj) {
                                commentObj.fileUploading = false;
                            } else if (newSubCommentObj) {
                                vm.newSubComment.fileUploading = false;
                            } else {
                                vm.newCommentObj.fileUploading = false;
                            }
                        }
                    });
                };

                vm.uploadFiles = function (type, filedata, commentObj, newSubCommentObj) {
                    if (vm.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK) {
                        if (commentObj) {
                            commentObj.fileUploading = true;
                        } else if (newSubCommentObj) {
                            vm.newSubComment.fileUploading = true;
                        } else {
                            vm.newCommentObj.fileUploading = true;
                        }
                        $scope.$apply();
                        var inputObj = {
                            projectId: $scope.issueObj.projectId
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata, commentObj, newSubCommentObj);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file');
                    }
                };
                /*Upload: END*/

                vm.fnGetIssue = function (issueId, isDataRefresh) {
                    var tempObj = {
                        issueId: issueId
                    };
                    IssueFactory.describeIssue(tempObj)
                        .then(function (response) {
                            vm.isIssueDetailsLoaded = true;
                            response.isIssueEditMode = false;
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                if (response.resolved && response.resolutionDeadlineAt) {
                                    if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = true
                                    } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = false
                                    }
                                }
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            vm.issueObj = response;
                            vm.parent.tabs[0].title = angular.isDefined(vm.issueObj.publicComments) ? "Public [ " + vm.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            vm.parent.tabs[1].title = angular.isDefined(vm.issueObj.privateComments) ? "Private [ " + vm.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            vm.issueObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.createdAt);
                            vm.issueObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.updatedAt);
                            _.forEach(vm.issueObj.privateComments, function (privateCommentObj) {
                                privateCommentObj.userAvatar = angular.isDefined(privateCommentObj.createdBy) ? AvatarService.getTextAvatar({email: privateCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                privateCommentObj.humanDateCreated = moment.unix(privateCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                privateCommentObj.humanDateCreatedRelative = moment(privateCommentObj.humanDateCreated).fromNow();
                                privateCommentObj.humanDateCreatedAbsolute = moment.unix(privateCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                privateCommentObj.mdBody = _.cloneDeepWith(privateCommentObj.text);
                                _.forEach(privateCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                });
                            });
                            if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                                vm.selectedComment.isShowComment = true;
                                vm.isShowMainComment = true;
                            } else {
                                vm.fnShowIssueSummary();
                            }
                            vm.resetIssueObj = angular.copy(response);
                            vm.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined(vm.issueObj.createdBy) ? vm.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined(vm.issueObj.createdBy) ? AvatarService.getTextAvatar({email: vm.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined(vm.issueObj.createdAt) ? vm.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix(vm.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix(vm.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith(vm.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith(vm.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                vm.issueSummary = _.cloneDeepWith(tempSummary);
                            });
                            if (isDataRefresh) {
                                $scope.$emit('IssuePrivateDetailsChanged', _.cloneDeepWith(response));
                            }
                            $timeout(function () {
                                vm.fnSetTabHeight();
                                vm.fnRenderMermaid();
                                if (vm.selectedCommentView === 'Vertical') {
                                    $timeout(function () {
                                        var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                        objDiv.scrollTop = objDiv.scrollHeight;
                                    })
                                    vm.selectedComment = {};
                                }
                            });
                            vm.issuePrivateTabAPITimeout = $timeout(function () {
                                vm.fnChangeIssuePrivateData();
                            }, 60000);
                        }, function () {
                        })
                };

                vm.fnShowIssueSummary = function () {
                    var tempSummary = {};
                    vm.selectedComment = {};
                    tempSummary.createdBy = angular.isDefined(vm.issueObj.createdBy) ? vm.issueObj.createdBy : '';
                    tempSummary.userAvatar = angular.isDefined(vm.issueObj.createdBy) ? AvatarService.getTextAvatar({email: vm.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                    tempSummary.createdAt = angular.isDefined(vm.issueObj.createdAt) ? vm.issueObj.createdAt : '';
                    tempSummary.humanDateCreated = moment.unix(vm.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                    tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                    tempSummary.humanDateCreatedAbsolute = moment.unix(vm.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                    tempSummary.summary = _.cloneDeepWith(vm.issueObj.summary);
                    tempSummary.mdBody = _.cloneDeepWith(vm.issueObj.summary);
                    tempSummary.voteCount = _.cloneDeepWith(vm.issueObj.voteCount);
                    tempSummary.id = _.cloneDeepWith(vm.issueObj.id);
                    tempSummary.isShowComment = true;
                    $timeout(function () {
                        vm.selectedComment = _.cloneDeepWith(tempSummary);
                    });
                    vm.isShowIssueSummary = true;
                    vm.isShowMainComment = false;
                    vm.fnRenderMermaid();
                };

                vm.fnShowComment = function (comment, type, mainCommentObj) {
                    vm.selectedComment = {};
                    $timeout(function () {
                        comment.isShowComment = true;
                        vm.selectedComment = _.cloneDeepWith(comment);
                        if (type === 'subComment') {
                            vm.selectedComment.mainCommentId = mainCommentObj.id
                        }
                    }, 0);
                    vm.isShowMainComment = type === 'mainComment';
                    vm.isShowIssueSummary = false;
                    vm.fnRenderMermaid();
                };

                vm.fnAddCommentToIssue = function (issueObj, newCommentObj, type) {
                    newCommentObj.fileUploading = true;
                    var inputObj = {
                        issueId: issueObj.id,
                        body: {
                            privateStream: true,
                            text: newCommentObj.text,
                            syntax: newCommentObj.syntax
                        }
                    };
                    CommentFactory.addComment(inputObj)
                        .then(function () {
                            if (type === 'CommentResolve') {
                                vm.fnResolveIssue(issueObj, newCommentObj);
                            } else if (type === 'CommentResolveRequest') {
                                vm.fnResolveIssueRequest(issueObj, newCommentObj);
                            } else {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                                newCommentObj.syntax = "TEXT";
                                $timeout(function () {
                                    vm.isIssueDetailsLoaded = false;
                                    vm.fnGetIssue(vm.issueObj.id, true);
                                    vm.fnSetTabHeight();
                                });
                            }
                            //vm.fnShowComment();
                        })
                };

                vm.fnAddSubCommentToComment = function (commentObj, newCommentObj, type) {
                    newCommentObj.fileUploading = true;
                    var inputObj = {
                        commentId: commentObj.id,
                        body: {
                            privateStream: true,
                            text: newCommentObj.text
                        }
                    };
                    CommentFactory.addSubComment(inputObj)
                        .then(function () {
                            if (type === 'CommentResolve') {
                                vm.fnResolveIssue(vm.issueObj, newCommentObj);
                            } else if (type === 'CommentResolveRequest') {
                                vm.fnResolveIssueRequest(vm.issueObj, newCommentObj);
                            } else {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                                $timeout(function () {
                                    vm.isIssueDetailsLoaded = false;
                                    vm.fnGetIssue(vm.issueObj.id, true);
                                    vm.fnSetTabHeight();
                                });
                            }
                        })
                };

                vm.fnEditIssueComment = function (issueObj, commentObj, name) {
                    if (commentObj) {
                        commentObj.isDetailsOpened = true;
                        commentObj.isEditMode = true;
                        name = name + commentObj.id;
                    } else {
                        issueObj.isIssueEditMode = true;
                    }
                    $timeout(function () {
                        $rootScope.markdownEditorObjects[name].hidePreview();
                    }, 100);
                    if (vm.selectedCommentView === 'Vertical') {
                        if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                            _.forEach(vm.issueObj.privateComments, function (publicCommentObj) {
                                if (publicCommentObj.id !== commentObj.id) {
                                    publicCommentObj.mdBody = '';
                                    publicCommentObj.isShowComment = false;
                                    $timeout(function () {
                                        publicCommentObj.mdBody = publicCommentObj.text;
                                        publicCommentObj.isEditMode = false;
                                        publicCommentObj.isShowComment = true;
                                        $timeout(function () {
                                            var name = 'editor' + publicCommentObj.id;
                                            $rootScope.markdownEditorObjects[name].hidePreview();
                                            $rootScope.markdownEditorObjects[name].showPreview();
                                        });
                                    });
                                }
                                if (publicCommentObj.subComments && publicCommentObj.subComments.length) {
                                    _.forEach(publicCommentObj.subComments, function (publicSubCommentObj) {
                                        if (publicSubCommentObj.id !== commentObj.id) {
                                            publicSubCommentObj.mdBody = '';
                                            publicSubCommentObj.isShowComment = false;
                                            $timeout(function () {
                                                publicSubCommentObj.mdBody = publicSubCommentObj.text;
                                                publicSubCommentObj.isEditMode = false;
                                                publicSubCommentObj.isShowComment = true;
                                                $timeout(function () {
                                                    var name = 'editor' + publicSubCommentObj.id;
                                                    $rootScope.markdownEditorObjects[name].hidePreview();
                                                    $rootScope.markdownEditorObjects[name].showPreview();
                                                });
                                            });
                                        }
                                    })
                                }
                            })
                        }
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.fnRenderMermaid();
                    });
                };

                vm.fnUpdateIssueSummary = function (issueObj, commentObj) {
                    commentObj.fileUploading = true;
                    var inputObj = {
                        issueId: vm.issueObj.id,
                        body: {
                            summary: commentObj.mdBody
                        }
                    };
                    IssueFactory.modifySummary(inputObj)
                        .then(function (response) {
                            angular.forEach(response, function (val, key) {
                                commentObj[key] = val;
                            });
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            //commentObj.userAvatar = angular.isDefined(commentObj.createdBy) ? AvatarService.getTextAvatar({email: commentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            //commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            //commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                            //commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            commentObj.mdBody = _.cloneDeepWith(commentObj.summary);
                            commentObj.voteCount = _.cloneDeepWith(commentObj.voteCount);
                            vm.issueObj.summary = commentObj.summary;
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            $scope.$emit('IssueDetailsChanged', response);
                            $timeout(function () {
                                vm.fnSetTabHeight();
                                vm.fnRenderMermaid();
                            });
                        }, function () {
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                        })
                };


                vm.fnCancelCommentEditing = function (commentObj) {
                    commentObj.mdBody = '';
                    commentObj.isShowComment = false;
                    $timeout(function () {
                        if (vm.isShowIssueSummary === true) {
                            commentObj.mdBody = commentObj.summary;
                        } else {
                            commentObj.mdBody = commentObj.text;
                        }
                        commentObj.isEditMode = false;
                        commentObj.isShowComment = true;
                        $timeout(function () {
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            vm.fnSetTabHeight();
                            vm.fnRenderMermaid();
                        });
                    });
                };

                vm.fnCancelVerticalCommentEditing = function (commentObj, isSummary) {
                    commentObj.mdBody = '';
                    commentObj.isShowComment = false;
                    $timeout(function () {
                        if (isSummary === true) {
                            commentObj.mdBody = commentObj.summary;
                        } else {
                            commentObj.mdBody = commentObj.text;
                        }
                        commentObj.isEditMode = false;
                        commentObj.isShowComment = true;
                        $timeout(function () {
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].hidePreview();
                            $rootScope.markdownEditorObjects[name].showPreview();
                            vm.fnSetTabHeight();
                            vm.fnRenderMermaid();
                        });
                    });
                }

                vm.fnUpdateComment = function (issueObj, commentObj) {
                    commentObj.fileUploading = true;
                    var inputObj = {
                        commentId: commentObj.id,
                        body: {
                            text: commentObj.mdBody
                        }
                    };
                    CommentFactory.modifyCommentText(inputObj)
                        .then(function (response) {
                            angular.forEach(response, function (val, key) {
                                commentObj[key] = val;
                            });
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            //commentObj.userAvatar = angular.isDefined(commentObj.createdBy) ? AvatarService.getTextAvatar({email: commentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            //commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            //commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                            //commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            vm.fnSetTabHeight();
                            vm.fnRenderMermaid();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            if (vm.selectedCommentView === 'Horizontal') {
                                vm.fnCancelCommentEditing(commentObj);
                            } else {
                                vm.fnCancelVerticalCommentEditing(commentObj, false);
                            }
                        })
                };

                vm.fnDeleteIssueComment = function (issueObj, commentObj) {
                    swal({
                            title: "Delete the selected comment?",
                            text: "You are about to permanently delete the selected comment.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    commentId: commentObj.id
                                };
                                CommentFactory.deleteComment(inputObj)
                                    .then(function () {
                                        vm.isIssueDetailsLoaded = false;
                                        vm.issueObj.privateComments = _.remove(vm.issueObj.privateComments, function (obj) {
                                            if (obj && obj.subComments && obj.subComments.length) {
                                                obj.subComments = _.remove(obj.subComments, function (subCommentObj) {
                                                    return subCommentObj.id !== commentObj.id;
                                                });
                                            } else {
                                                return obj.id !== commentObj.id;
                                            }
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        vm.isIssueDetailsLoaded = true;
                                        vm.parent.tabs[1].title = angular.isDefined(vm.issueObj.privateComments) ? "Private [ " + vm.issueObj.privateComments.length + " ]" : +"Private [ 0 ]";
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            vm.selectedComment = {};
                                            if (vm.selectedCommentView === 'Horizontal') {
                                                $timeout(function () {
                                                    if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                                        vm.fnShowComment(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1], 'mainComment');
                                                    } else {
                                                        vm.fnShowIssueSummary()
                                                    }
                                                    // $scope.selectedComment =  _.cloneDeepWith($scope.issueObj.privateComments[$scope.issueObj.privateComments.length - 1]);
                                                }, 0);
                                            }
                                            /*$timeout(function () {
                                                vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                                            }, 0);*/
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnResolveIssue = function (issueObj, newCommentObj) {
                    var inputObj = {
                        issueId: issueObj.id
                    };
                    IssueFactory.resolveIssue(inputObj)
                        .then(function () {
                            newCommentObj.fileUploading = false;
                            newCommentObj.text = '';
                            vm.isIssueDetailsLoaded = false;
                            $timeout(function () {
                                vm.isIssueDetailsLoaded = false;
                                vm.fnGetIssue(vm.issueObj.id, true);
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnResolveIssueRequest = function (issueObj, newCommentObj) {
                    var inputObj = {
                        issueId: issueObj.id
                    };
                    IssueFactory.resolveIssueRequest(inputObj)
                        .then(function () {
                            newCommentObj.fileUploading = false;
                            newCommentObj.text = '';
                            vm.isIssueDetailsLoaded = false;
                            $timeout(function () {
                                vm.isIssueDetailsLoaded = false;
                                vm.fnGetIssue(vm.issueObj.id, true);
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetRelativeTime = function (createdDate) {
                    return moment.unix(createdDate).format("DD/MM/YYYY, HH:mm");
                };

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        vm.fnRenderMermaid();
                    }
                };

                vm.fnAddUpDownVoteToComment = function (isUpVote, commentObj) {
                    if (isUpVote && !vm.parent.userPermissionsObj.UP_VOTE_COMMENT) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote a comment.');
                        return;
                    } else if (!isUpVote && !vm.parent.userPermissionsObj.DOWN_VOTE_COMMENT) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote a comment.');
                        return;
                    }
                    commentObj.isVoteUpdateing = true;
                    commentObj.voteCount = commentObj.voteCount ? commentObj.voteCount : 0;
                    var input = {
                        commentId: commentObj.id,
                        body: {
                            voteCount: isUpVote ? commentObj.voteCount + 1 : commentObj.voteCount - 1
                        }
                    };
                    if (isUpVote) {
                        CommentFactory.upVoteComment(input)
                            .then(function (res) {
                                delete commentObj.isVoteUpdateing;
                                //commentObj = res;
                                vm.selectedComment.voteCount = res.voteCount;
                                commentObj.voteCount = res.voteCount;
                                commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                                commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            }, function (error) {
                                delete commentObj.isVoteUpdateing;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        CommentFactory.downVoteComment(input)
                            .then(function (res) {
                                delete commentObj.isVoteUpdateing;
                                //commentObj = res;
                                vm.selectedComment.voteCount = res.voteCount;
                                commentObj.voteCount = res.voteCount;
                                commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                                commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            }, function (error) {
                                delete commentObj.isVoteUpdateing;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                vm.fnAddUpDownVoteToIssue = function (isUpVote, issueObj) {
                    if (isUpVote && !vm.parent.userPermissionsObj.UP_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote an Issue.');
                        return;
                    } else if (!isUpVote && !vm.parent.userPermissionsObj.DOWN_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote an Issue.');
                        return;
                    }
                    issueObj.isVoteUpdateing = true;
                    issueObj.voteCount = issueObj.voteCount ? issueObj.voteCount : 0;
                    var input = {
                        issueId: issueObj.id
                    };
                    if (isUpVote) {
                        IssueFactory.upVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdateing;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(issueObj.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        IssueFactory.downVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdateing;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(issueObj.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce(); //eslint-disable-line
                        vega_runonce(); //eslint-disable-line
                    }, 100);
                };

                vm.fnAddNewSubComment = function (issueObj, commentObj) {
                    if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                        _.forEach(vm.issueObj.privateComments, function (publicCommentObj) {
                            if (publicCommentObj.isShowSubCommentEditor) {
                                publicCommentObj.isShowSubCommentEditor = false;
                            }
                        })
                    }
                    commentObj.isShowSubCommentEditor = true;
                    $timeout(function () {
                        document.getElementsByClassName("new-sub-comment-editor")[0].scrollIntoView();
                        vm.fnSetTabHeight();
                    });
                };

                vm.fnCancelVerticalNewSubComment = function (commentObj) {
                    commentObj.isShowSubCommentEditor = false;
                    vm.newSubComment = {
                        text: ""
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

                $scope.$on("IssueDetailsChanged", function (evt, response) {
                    response.isIssueEditMode = false;
                    var currntTime = moment().unix();
                    if (response.resolutionDeadlineAt) {
                        response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                        response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                        var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                        response.issueCreateDate = issueCreateDate;
                        response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                        var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                        response.issueDeadline = issueDeadline;
                        response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                        if (response.resolved && response.resolutionDeadlineAt) {
                            if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = true
                            } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = false
                            }
                        }
                    }
                    if (response.responseDeadlineAt) {
                        response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                        response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                        var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                        response.issueUpdatedDate = issueUpdatedDate;
                        response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                        var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                        response.issueResponseDeadline = issueResponseDeadline;
                        response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                    }
                    response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                    vm.issueObj = response;
                    vm.issueObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.createdAt);
                    vm.issueObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.updatedAt);
                    _.forEach(vm.issueObj.privateComments, function (publicCommentObj) {
                        publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                        publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                        publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                        publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                        _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                            subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                            subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                        });
                    });
                    if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                        vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                        vm.selectedComment.isShowComment = true;
                        vm.isShowMainComment = true;
                    } else {
                        vm.fnShowIssueSummary();
                    }
                    vm.resetIssueObj = angular.copy(response);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.fnRenderMermaid();
                    });
                });

                $rootScope.$on("IssueCommentViewChanged", function () { // eslint-disable-line
                    vm.selectedCommentView = _.cloneDeepWith(vm.parent.selectedCommentView);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.fnRenderMermaid();
                        if (vm.selectedCommentView === 'Vertical') {
                            $timeout(function () {
                                var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                objDiv.scrollTop = objDiv.scrollHeight;
                            })
                            vm.selectedComment = {};
                        } else {
                            //$scope.selectedComment = {};
                            if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                                vm.selectedComment.isShowComment = true;
                                vm.isShowMainComment = true;
                                vm.isShowIssueSummary = false;
                            } else {
                                vm.fnShowIssueSummary();
                            }
                        }
                    }, 100);
                });

                vm.fnChangeIssuePrivateData = function () {
                    var tempObj = {
                        issueId: vm.parent.issueObj.id
                    };
                    IssueFactory.describeIssue(tempObj)
                        .then(function (response) {
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                if (response.resolved && response.resolutionDeadlineAt) {
                                    if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = true
                                    } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = false
                                    }
                                }
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            response.isLastUpdated = moment().format('X');
                            vm.issueObj = response;
                            vm.parent.tabs[0].title = angular.isDefined(vm.issueObj.publicComments) ? "Public [ " + vm.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            vm.parent.tabs[1].title = angular.isDefined(vm.issueObj.privateComments) ? "Private [ " + vm.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            vm.issueObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.createdAt);
                            vm.issueObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.updatedAt);
                            _.forEach(vm.issueObj.privateComments, function (privateCommentObj) {
                                privateCommentObj.userAvatar = angular.isDefined(privateCommentObj.createdBy) ? AvatarService.getTextAvatar({email: privateCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                privateCommentObj.humanDateCreated = moment.unix(privateCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                privateCommentObj.humanDateCreatedRelative = moment(privateCommentObj.humanDateCreated).fromNow();
                                privateCommentObj.humanDateCreatedAbsolute = moment.unix(privateCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                privateCommentObj.mdBody = _.cloneDeepWith(privateCommentObj.text);
                                privateCommentObj.voteCount = _.cloneDeepWith(privateCommentObj.voteCount);
                                if (vm.selectedCommentView !== 'Vertical') {
                                    if (vm.selectedComment.id === privateCommentObj.id) {
                                        vm.selectedComment.text = _.cloneDeepWith(privateCommentObj.text);
                                        vm.selectedComment.humanDateCreated = moment.unix(privateCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                        vm.selectedComment.humanDateCreatedRelative = moment(privateCommentObj.humanDateCreated).fromNow();
                                        vm.selectedComment.humanDateCreatedAbsolute = moment.unix(privateCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                        vm.selectedComment.mdBody = _.cloneDeepWith(privateCommentObj.text);
                                        vm.selectedComment.voteCount = _.cloneDeepWith(privateCommentObj.voteCount);
                                        if (vm.selectedComment.isEditMode) {
                                            amaran.warning('The selected comment has been edited externally');
                                        }
                                        var selectedCommentName = 'editor' + privateCommentObj.id;
                                        $timeout(function () {
                                            if ($rootScope.markdownEditorObjects[selectedCommentName]) {
                                                $rootScope.markdownEditorObjects[selectedCommentName].showNewPreview();
                                            }
                                        })
                                    }
                                } else {
                                    var name = 'editor' + privateCommentObj.id;
                                    $timeout(function () {
                                        if ($rootScope.markdownEditorObjects[name]) {
                                            $rootScope.markdownEditorObjects[name].showNewPreview();
                                        }
                                    })
                                }
                                _.forEach(privateCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                    subCommentObj.voteCount = _.cloneDeepWith(subCommentObj.voteCount);
                                    if (vm.selectedCommentView !== 'Vertical') {
                                        if (vm.selectedComment.id === subCommentObj.id) {
                                            vm.selectedComment.text = _.cloneDeepWith(subCommentObj.text);
                                            vm.selectedComment.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                            vm.selectedComment.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                            vm.selectedComment.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                            vm.selectedComment.mdBody = _.cloneDeepWith(subCommentObj.text);
                                            vm.selectedComment.voteCount = _.cloneDeepWith(subCommentObj.voteCount);
                                            if (vm.selectedComment.isEditMode) {
                                                amaran.warning('The selected comment has been edited externally');
                                            }
                                            var selectedCommentName = 'editor' + subCommentObj.id;
                                            $timeout(function () {
                                                if ($rootScope.markdownEditorObjects[selectedCommentName]) {
                                                    $rootScope.markdownEditorObjects[selectedCommentName].showNewPreview();
                                                }
                                            })
                                        }
                                    } else {
                                        var name = 'editor' + subCommentObj.id;
                                        $timeout(function () {
                                            if ($rootScope.markdownEditorObjects[name]) {
                                                $rootScope.markdownEditorObjects[name].showNewPreview();
                                            }
                                        })
                                    }
                                });
                            });
                            vm.resetIssueObj = angular.copy(response);
                            vm.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined(vm.issueObj.createdBy) ? vm.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined(vm.issueObj.createdBy) ? AvatarService.getTextAvatar({email: vm.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined(vm.issueObj.createdAt) ? vm.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix(vm.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix(vm.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith(vm.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith(vm.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                vm.issueSummary = _.cloneDeepWith(tempSummary);
                                if (vm.selectedCommentView === 'Vertical') {
                                    var name = 'editor' + vm.issueSummary.id;
                                    $timeout(function () {
                                        if ($rootScope.markdownEditorObjects[name]) {
                                            $rootScope.markdownEditorObjects[name].showNewPreview();
                                        }
                                    })
                                }
                            });
                            if (vm.issueObj.privateComments && !vm.issueObj.privateComments.length) {
                                vm.fnShowIssueSummary();
                            }
                            $timeout(function () {
                                vm.fnSetTabHeight();
                                vm.fnRenderMermaid();
                            });
                            vm.issuePrivateTabAPITimeout = $timeout(function () {
                                vm.fnChangeIssuePrivateData();
                            }, 60000);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.issuePrivateTabAPITimeout = $timeout(function () {
                                vm.fnChangeIssuePrivateData();
                            }, 60000);
                        })
                }

                vm.fnInitIssuePrivate = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                    vm.isIssueDetailsLoaded = false;
                    vm.fnGetIssue(vm.parent.issueObj.id, false);
                }

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.issuePrivateTabAPITimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueHistoryCtrl',
            function ($scope, $timeout, $window, mermaid, moment, amaran, TabHeight, AvatarService, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.markedOptionObj = {
                    iconlibrary: "fa",
                    addExtraButtons: false,
                    resize: "vertical",
                    initialstate: "preview",
                    hiddenButtons: ['all']
                };
                vm.tableAlias = "tracker_histories";
                vm.issueHistoryAPITimeout = '';
                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Completed",
                        name: "eventEpoch",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Public comment",
                        name: "privateStream",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'privateStream\' = \'false\'',
                        localSearchValue: 'obj.privateStream === false'
                    }, {
                        displayName: "Private comment",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'dara->\'privateStream\' = \'true\'',
                        localSearchValue: 'obj.privateStream === true'
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: "eventEpoch", displayName: "Completed"}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.defaultSortString = 'eventEpoch desc';
                vm.isIssueHistoryDetailsLoaded = false;

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    $timeout.cancel(vm.issueHistoryAPITimeout);
                    vm.isIssueHistoryDetailsLoaded = false;
                    vm.filterQuery = filterQuery;
                    if (sortQuery) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    vm.isLabelsLoading = true;
                    vm.selectedLabelsArr = [];
                    if (vm.parent.issueObj.id) {
                        var sqlString = '';
                        if (sortQuery !== '') {
                            sqlString = "SELECT *, 'data->>\'" + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_histories';
                            sqlString += " WHERE data->>\'issueId = '" + vm.parent.issueObj.id + "'";
                            if (vm.sqlQuery && vm.sqlQuery.length) {
                                sqlString += " AND " + vm.sqlQuery.trim()
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ';';
                        } else {
                            sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_histories';
                            sqlString += " WHERE data->>\'issueId\' = '" + vm.parent.issueObj.id + "'";
                            if (vm.sqlQuery && vm.sqlQuery.length) {
                                sqlString += " AND " + vm.sqlQuery.trim()
                            }
                            sqlString += ' ORDER BY rt asc;';
                        }
                        vm.fnGetIssueHistory({sql: sqlString});
                    } else {
                        vm.isIssueHistoryDetailsLoaded = true;
                    }
                };

                vm.fnGetIssueHistory = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            _.forEach(response.data, function (obj) {
                                obj.timestamp = _.cloneDeepWith(obj.eventEpoch);
                                obj.myIndex = obj.timestamp + obj.description;
                                obj.eventEpoch = vm.fnGetAbsoluteOrRelativeTime(obj.eventEpoch);
                                obj.eventType = obj.eventType.replace(/_/g, " ");
                                obj.userAvatar = AvatarService.getTextAvatar({email: obj.tags.user});
                            });
                            vm.issueHistorysArr = _.cloneDeepWith(response.data);
                            vm.isIssueHistoryDetailsLoaded = true;
                            $timeout(function () {
                                mermaid.init(".lang-mermaid");
                                plantuml_runonce(); //eslint-disable-line
                                vega_runonce(); //eslint-disable-line
                            }, 1000);
                            vm.issueHistoryAPITimeout = $timeout(function () {
                                vm.fnUpdateData();
                            }, 60000);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.issueHistorysArr = [];
                            vm.isIssueHistoryDetailsLoaded = true;
                        })
                };

                vm.fnUpdateData = function () {
                    var sqlString = '';
                    if (vm.sort !== '') {
                        sqlString = 'SELECT *, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_histories';
                        sqlString += " WHERE data->>\'issueId'\ = '" + vm.parent.issueObj.id + "'";
                        if (vm.sqlQuery && vm.sqlQuery.length) {
                            sqlString += " AND " + vm.sqlQuery.trim()
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ';';
                    } else {
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_histories';
                        sqlString += " WHERE data->>\'issueId\' = '" + vm.parent.issueObj.id + "'";
                        if (vm.sqlQuery && vm.sqlQuery.length) {
                            sqlString += " AND " + vm.sqlQuery.trim()
                        }
                        sqlString += ' ORDER BY rt asc;';
                    }
                    QueryFactory.executeQuery({sql: sqlString})
                        .then(function (res) { // Success block
                            var lastUpdatedTime = vm.issueHistorysArr && vm.issueHistorysArr.length ? vm.issueHistorysArr[0] : '';
                            if (lastUpdatedTime !== '') {
                                _.forEach(res.data, function (obj) {
                                    obj.timestamp = _.cloneDeepWith(obj.eventEpoch);
                                    obj.myIndex = obj.timestamp + obj.description;
                                    obj.eventEpoch = vm.fnGetAbsoluteOrRelativeTime(obj.eventEpoch);
                                    obj.eventType = obj.eventType.replace(/_/g, " ");
                                    obj.userAvatar = AvatarService.getTextAvatar({email: obj.tags.user});
                                    if (obj.timestamp > lastUpdatedTime.timestamp) {
                                        vm.issueHistorysArr.unshift(obj);
                                    }
                                });
                            } else {
                                _.forEach(res.data, function (obj) {
                                    obj.timestamp = _.cloneDeepWith(obj.eventEpoch);
                                    obj.myIndex = obj.timestamp + obj.description;
                                    obj.eventEpoch = vm.fnGetAbsoluteOrRelativeTime(obj.eventEpoch);
                                    obj.eventType = obj.eventType.replace(/_/g, " ");
                                    obj.userAvatar = AvatarService.getTextAvatar({email: obj.tags.user});
                                });
                                vm.issueHistorysArr = _.cloneDeepWith(res.data);
                            }
                            _.forEach(vm.issueHistorysArr, function (obj) {
                                obj.eventEpoch = vm.fnGetAbsoluteOrRelativeTime(obj.timestamp);
                                obj.eventType = obj.eventType.replace(/_/g, " ");
                            });
                            vm.issueHistoryAPITimeout = $timeout(function () {
                                vm.fnUpdateData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.issueHistoryAPITimeout = $timeout(function () {
                                vm.fnUpdateData();
                            }, 60000);
                        })
                };

                vm.fnInitIssueHistory = function () {
                   /* vm.isIssueHistoryDetailsLoaded = false;
                    if (vm.parent.issueObj.id) {
                        var historySQL = "SELECT * FROM tracker_histories where issueId = '" + vm.parent.issueObj.id + "' order by eventEpoch desc;";
                        vm.fnGetIssueHistory({sql: historySQL});
                    } else {
                        vm.isIssueHistoryDetailsLoaded = true;
                    }
                    */
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.issueHistoryAPITimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueAttributesCtrl',
            function ($scope, $timeout, $window, amaran, $state, moment, ColorService, QueryFactory, TabHeight, ApiListService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAttributeDataLoading = true;
                vm.attributesArr = [];
                var getCurrentURL = ApiListService.getCurrentURL();

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var total = angular.element(".content-main")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeight = total - (header + 50);
                        angular.element("#issueAlarmTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAttributes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            res.data.map(function (obj) {
                                if (obj.receivedAt) {
                                    obj.receivedDate = vm.fnGetAbsoluteOrRelativeTime(obj.receivedAt);
                                }
                                if (obj.healthLastChangedAt) {
                                    obj.healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.healthLastChangedAt);
                                }
                            });
                            vm.attributesArr = res.data;
                            vm.isAttributeDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributeDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        })
                }

                vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.alarms', {selectedId: issueObj.id});
                }

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL+ "/#/node/alarm?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                }

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                vm.fnInitIssueAttributes = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                    vm.isAttributeDataLoading = true;
                    var tempIdString = "";
                    _.forEach(vm.parent.issueObj.attributeIds, function (id, index) {
                        if (index === vm.parent.issueObj.attributeIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    var sql = "WITH attributes AS ( " +
                        "SELECT node_attributes.data, node_attributes.data->>'_id' AS rt, node_ecus.data->>'name' AS ecuName, " +
                        "CASE WHEN (node_attributes.data->>'ecuId') = (node_attributes.data->>'nodeId') THEN node_ecus.data->>'name' ELSE node_nodes.data->>'name' end nodeName, " +
                        "CASE WHEN (node_attributes.data->>'ecuId') = (node_attributes.data->>'nodeId') THEN node_ecus.data->>'id' ELSE node_nodes.data->>'rootNodeId' END rootNodeId " +
                        "FROM node_attributes as node_attributes " +
                        "LEFT JOIN node_ecus ON (node_attributes.data->>'ecuId') = node_ecus.data->>'id' " +
                        "LEFT JOIN node_nodes ON (node_attributes.data->>'nodeId') = node_nodes.data->>'id' " +
                        "WHERE (node_attributes.data->>'id') IN (" + tempIdString + ") ORDER BY rt asc )," +
                        "rows AS ( SELECT COUNT(*) AS qty FROM node_attributes " +
                        "LEFT JOIN node_ecus ON (node_attributes.data->>'ecuId') = node_ecus.data->>'id' " +
                        "LEFT JOIN node_nodes ON (node_attributes.data->>'nodeId') = node_nodes.data->>'id' " +
                        "WHERE (node_attributes.data->>'id') IN (" + tempIdString + ") )" +
                        "SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows";
                    vm.fnGetAttributes({"sql": sql});
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueLinkedCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.fnInitIssueLinked = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueFormCtrl',
            function ($scope, $timeout, $window, amaran, IssueFactory, TabHeight, TypeFormService, TypesFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.issueObj = {};
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];

                vm.fnGetIssueData = function (issueId) {
                    var tempObj = {
                        issueId: issueId
                    };
                    IssueFactory.describeIssue(tempObj)
                        .then(function (response) {
                            vm.issueObj = response;
                            vm.resetIssueObj = _.cloneDeepWith(vm.issueObj);
                            vm.model = _.cloneDeepWith(vm.issueObj.customForm.values);
                            var inputObj = {
                                typeId: vm.issueObj.issueType.id
                            };
                            TypesFactory.describeIssueType(inputObj)
                                .then(function (response) {
                                    if (response.form && response.form.schema && response.form.schema.properties && Object.keys(response.form.schema.properties).length) {
                                        var tempData = TypeFormService.fnGenerateFormData(response.form.schema);
                                        vm.schema = tempData.schema;
                                        vm.form = tempData.form;
                                    } else {
                                        vm.schema = {
                                            $schema: "https://json-schema.org/draft/2019-09/schema",
                                            type: "object",
                                            properties: {}
                                        };
                                        vm.form = [];
                                    }
                                    vm.isIssueDetailsLoaded = true;
                                    $timeout(function () {
                                        TabHeight.fnSet();
                                    });
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isIssueDetailsLoaded = true;
                                    $timeout(function () {
                                        TabHeight.fnSet();
                                    });
                                });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueDetailsLoaded = true;
                            $timeout(function () {
                                TabHeight.fnSet();
                            });
                        })
                };

                vm.isDateUpdating = false;
                vm.fnSaveValue = function () {
                    vm.isDateUpdating = true;
                    var inputObj = {
                        issueId: vm.parent.issueObj.id,
                        body: vm.model
                    };
                    IssueFactory.replaceIssueFormValues(inputObj)
                        .then(function (response) {
                            vm.model = response.customForm.values;
                            vm.isDateUpdating = false;
                            amaran.success("Form Value Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDateUpdating = false;
                        })
                };

                vm.fnInitIssueForm = function () {
                    vm.isIssueDetailsLoaded = false;
                    if (vm.parent.issueObj.id) {
                        vm.fnGetIssueData(vm.parent.issueObj.id);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AccountSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, AccountFactory) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.isCreateFromView = false;
                vm.accountSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalDataAdded = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAccountData = function () {
                    vm.accountSupplementalObj = vm.parent.accountObj.tags ? angular.fromJson(vm.parent.accountObj.tags) : {};
                    vm.accountSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.accountSupplementalObj, true) : vm.accountSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.accountSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.accountSupplementalObj)) {
                        angular.forEach(vm.accountSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isAccountSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.accountSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.accountSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.accountSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.accountSupplementalObj = angular.toJson(vm.accountSupplementalObj, true);
                    } else {
                        vm.accountSupplementalObj = angular.fromJson(vm.accountSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.accountSupplementalObj)) {
                            angular.forEach(vm.accountSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveAccountData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.accountObj.tags = {};
                    var inputObj = {
                        accountId: vm.parent.accountObj.id,
                        body: {}
                    };
                    if (!vm.parent.accountObj.tags) {
                        vm.parent.accountObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.accountObj.tags = angular.fromJson(vm.accountSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.accountObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }

                    inputObj.body = vm.parent.accountObj.tags;
                    AccountFactory.replaceAccountData(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Account successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitAccountSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitAccountSupplemental();
                        })

                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.accountSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.accountSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        _.forEach(vm.accountSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitAccountSupplemental = function () {
                    vm.isAccountSupplementalDetailsLoaded = false;
                    if (vm.parent.accountObj.id) {
                        vm.fnGetAccountData(vm.parent.accountObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AccountUsersCtrl',
            function ($scope, $rootScope, $window, $cookies, $timeout, TabHeight, navigationMenuService, DB, UserFactory, AccountFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.authUserObj = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser') ? DB.fnGet("loginUser") : {};
                vm.isAllaccountUsersChecked = false;
                vm.accountUsersArr = [];

                vm.fnGetAccountUsers = function (accountObj) {
                    var inputObj = {
                        accountId: accountObj.id
                    };
                    AccountFactory.listAccountUsers(inputObj)
                        .then(function (resAccountUsers) {
                            vm.accountUsersArr = resAccountUsers;
                            vm.isAccountUsersLoading = false;
                        }, function () {
                            vm.isAccountUsersLoading = false;
                        })
                };

                vm.fnSudoAccess = function (userObj) {
                    $rootScope.$broadcast("startSudoProcess", userObj); //will be listened in main controller
                };

                vm.fnInitAccountUsers = function () {
                    $timeout( function () {
                        TabHeight.fnSet();
                    });
                    vm.isAccountUsersLoading = true;
                    if(vm.parent.accountObj.id){
                        vm.fnGetAccountUsers(vm.parent.accountObj);
                    }else{
                        vm.isAccountUsersLoading = false;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UserSecurityRolesCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, microSpinner, UserProfileService, PermissionsService, PaginationService, LastPageService, FedSudoUserService, UserFactory, RoleFactory, SecurityRoleFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllUserRolesChecked = false;
                vm.selectedUserRolesArr = [];
                //Search Variables
                var contextFieldArr = [
                    {name: 'GLOBAL', displayName: 'GLOBAL'},
                    {name: 'SECURITY_GROUP', displayName: 'SECURITY GROUP'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Context",
                        name: "context",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: contextFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 10;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddRole) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#userSecurityRolesTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddRoles = function () {
                    vm.isAllUserRolesChecked = false;
                    vm.fnCheckUncheckUserRolesAll();
                    vm.isShowAddRole = !vm.isShowAddRole;
                    if (vm.isShowAddGroup) {
                        vm.isInit = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddRole) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.isSecurityRolesLoading = true;
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isSecurityRolesLoading = true;
                    vm.selectedSecurityRolesArr = [];
                    vm.isAllChecked = false;
                    if (vm.filterQuery && vm.filterQuery.length && vm.isSinglePage) {
                        vm.fnGetFilterData();
                    } else {
                        var sortString = '';
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                        }
                        var currentPage = vm.currentPage - 1;
                        var input = {
                            limit: vm.perPage,
                            offset: vm.filterQuery && vm.filterQuery.length ? 0 : currentPage * vm.perPage,
                            orderBy: sortString && sortString.length ? sortString : '+id',
                            query: vm.sqlQuery && vm.sqlQuery.length ? vm.sqlQuery.trim() : ''
                        };
                        vm.fnGetSecurityRoles(input);
                    }
                };

                vm.fnGetFilterData = function () {
                    var securityRoleArr = [];
                    if (vm.isSinglePage) {
                        if (vm.securityRoleResponse.data.length) {
                            var filterSecurityRoleArr = [];
                            if (vm.filterQuery) {
                                filterSecurityRoleArr = _.filter(vm.securityRoleResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterSecurityRoleArr = _.cloneDeepWith(vm.securityRoleResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                securityRoleArr = _.orderBy(filterSecurityRoleArr, [sortValue], [sortType]);
                            } else {
                                securityRoleArr = _.cloneDeepWith(filterSecurityRoleArr);
                            }
                        }
                    } else {
                        securityRoleArr = vm.securityRoleResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? securityRoleArr.length : vm.securityRoleResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.securityRoleResponse.metadata.currentPage;
                    vm.securityRolesArr = securityRoleArr;
                    vm.isSecurityRolesLoading = false;
                    vm.isRefresh = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*END: Search*/

                vm.fnCheckUncheckUserRolesAll = function () {
                    angular.forEach(vm.userSecurityRolesArr, function (obj) {
                        obj.isCheck = vm.isAllUserRolesChecked;
                    });
                    if (vm.isAllUserRolesChecked) {
                        vm.selectedUserRolesArr = angular.copy(vm.userSecurityRolesArr);
                    } else {
                        vm.selectedUserRolesArr = [];
                    }
                };

                vm.fnCheckUncheckUserRolesHeader = function (roleObj) {
                    vm.isAllUserRolesChecked = true;
                    angular.forEach(vm.userSecurityRolesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllUserRolesChecked = false;
                        }
                    });

                    /* Toggle push in selected role array*/
                    var isValueFind = _.find(vm.selectedUserRolesArr, {'id': roleObj.id});
                    if (!isValueFind) {
                        vm.selectedUserRolesArr.push(roleObj)
                    } else {
                        _.remove(vm.selectedUserRolesArr, function (obj) {
                            return roleObj.id === obj.id;
                        });
                    }
                };

                vm.fnDeleteUserRoles = function (selectedUserRolesArr) {
                    swal({
                            title: "Remove all Selected Security Roles from User?",
                            text: "Security Roles will be permanently removed for the User.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedUserRolesArr, function (selectedRole) {
                                    var inputObj = {
                                        userId: vm.parent.userObj.id,
                                        securityRoleId: selectedRole.id
                                    };

                                    promises.push(UserFactory.removeSecurityRoleFromUser(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                        vm.selectedUserRolesArr = [];
                                        vm.fnGetUserSecurityRoles(vm.parent.userObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.securityRolesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedSecurityRolesArr = angular.copy(vm.securityRolesArr);
                    } else {
                        vm.selectedSecurityRolesArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;

                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    vm.isSecurityRolesLoading = true;
                    vm.selectedSecurityRolesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                    }
                    var currentPage = vm.currentPage - 1;
                    var input = {
                        limit: vm.perPage,
                        offset: isPerPageChanged ? 0 : vm.perPage * currentPage,
                        orderBy: sortString && sortString.length ? sortString : '+id',
                        query: vm.sqlQuery
                    };
                    vm.fnGetSecurityRoles(input);
                };

                vm.fnCheckUncheckHeader = function (roleObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.securityRolesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === roleObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected role array*/
                    var isValueFind = _.find(vm.selectedSecurityRolesArr, {'id': roleObj.id});
                    if (!isValueFind) {
                        vm.selectedSecurityRolesArr.push(roleObj)
                    } else {
                        _.remove(vm.selectedSecurityRolesArr, function (obj) {
                            return roleObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetSecurityRoles = function (input) {
                    SecurityRoleFactory.listSecurityRoles(input)
                        .then(function (res) { // Success block
                            vm.isSinglePage = !(res && res.metadata && res.metadata.totalPages && res.metadata.totalPages > 1);
                            vm.securityRoleResponse = _.cloneDeepWith(res);
                            vm.fnGetFilterData();
                            vm.isSecurityRolesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSecurityRolesLoading = false;
                        })
                };

                vm.fnAddRole = function () {
                    vm.isRoleAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedSecurityRolesArr, function (selectedRole) {
                        var inputObj = {
                            userId: vm.parent.userObj.id,
                            securityRoleId: selectedRole.id
                        };
                        promises.push(UserFactory.addSecurityRoleToUser(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected security roles successfully added in User");
                        vm.fnGetUserSecurityRoles(vm.parent.userObj);
                        vm.isRoleAdding = false;
                        vm.isShowAddRole = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isRoleAdding = false;
                    })
                };

                vm.fnGetUserSecurityRoles = function (userObj) {
                    var inputObj = {
                        userId: userObj.id
                    };
                    UserFactory.listUserSecurityRoles(inputObj)
                        .then(function (resUserRoles) {
                            vm.userSecurityRolesArr = resUserRoles;
                            vm.isUserSecurityRolesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUserSecurityRolesLoading = false;
                        })
                };

                vm.fnGoToUserRole = function (obj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "name": "id is equal to: " + obj.id,
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": obj.id
                    };
                    tagsArr.push(angular.copy(inputObj));
                    DB.fnSet('IsCalledFromUserRoles', true);
                    $state.go("main.securityRoles", {filter: angular.toJson(tagsArr)});
                };
                vm.fnInitUserSecurityRoles = function () {
                    if (!vm.parent.userObj.administrator) {
                        vm.isUserSecurityRolesLoading = true;
                        vm.fnGetUserSecurityRoles(vm.parent.userObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UserRelationshipsCtrl',
            function ($scope, $window, PermissionsService, GroupFactory, RoleFactory) {

                var vm = this;
                vm.groupPermObj = {};
                vm.rolePermObj = {};
                vm.parent = $scope.$parent;
                vm.isUserRelationshipLoaded = false;
                vm.relationshipObj = null;
                var userGroupsArr = [];
                var userRolesArr = [];
                var isGroupsCalled = false;
                var isRolesCalled = false;
                var count = 0;

                vm.fnCreateNestedRelationshipStructure = function () {
                    if (isGroupsCalled === true && isRolesCalled === true) {
                        vm.relationshipObj = angular.copy(vm.parent.userObj);
                        vm.relationshipObj.type = 'User';
                        vm.relationshipObj.children = [];
                        vm.relationshipObj.children.push.apply(vm.relationshipObj.children, userGroupsArr);
                        vm.relationshipObj.children.push.apply(vm.relationshipObj.children, userRolesArr);
                        vm.isUserRelationshipLoaded = true;
                    }
                };

                vm.fnGetUserRoles = function (userId) {
                    var inputObj = {
                        perPage: 0,
                        userId: userId
                    };
                    RoleFactory.getUserRoles(inputObj)
                        .then(function (resUserRoles) {
                            angular.forEach(resUserRoles, function (obj) {
                                obj.type = 'Role';
                            });
                            userRolesArr = resUserRoles;
                            isRolesCalled = true;
                            vm.fnCreateNestedRelationshipStructure();
                        }, function () {
                            userRolesArr = [];
                            isRolesCalled = true;
                            vm.fnCreateNestedRelationshipStructure();
                        })
                };

                vm.fnGetGroupRoles = function (groupObj, count) {
                    var inputObj = {
                        perPage: 0,
                        groupId: groupObj.id
                    };
                    RoleFactory.getGroupRoles(inputObj)
                        .then(function (resGroupRoles) {
                            angular.forEach(resGroupRoles, function (obj) {
                                obj.type = 'Role'
                            });
                            userGroupsArr[count].children = resGroupRoles;
                            count++;
                            vm.fnInitGetGroupRoles(count);
                        }, function () {
                            count++;
                            vm.fnInitGetGroupRoles(count);
                        })
                };

                vm.fnInitGetGroupRoles = function (count) {
                    if (count < userGroupsArr.length) {
                        vm.fnGetGroupRoles(userGroupsArr[count], count);
                    } else {
                        isGroupsCalled = true;
                        vm.fnCreateNestedRelationshipStructure();
                    }
                };

                vm.fnGetUserGroups = function (userId) {
                    var inputObj = {
                        perPage: 0,
                        userId: userId
                    };
                    GroupFactory.getUserGroups(inputObj)
                        .then(function (resUserGroups) {
                            angular.forEach(resUserGroups, function (obj) {
                                obj.type = 'Group';
                            });
                            userGroupsArr = resUserGroups;
                            if (userGroupsArr.length) {
                                count = 0;
                                vm.fnInitGetGroupRoles(count);
                            } else {
                                isGroupsCalled = true;
                                vm.fnCreateNestedRelationshipStructure();
                            }
                        }, function () {
                            userGroupsArr = [];
                            isGroupsCalled = true;
                            vm.fnCreateNestedRelationshipStructure();
                        })
                };

                vm.fnInitUserRelationships = function () {
                    vm.groupPermObj = PermissionsService.getPermissions('access:group');
                    vm.rolePermObj = PermissionsService.getPermissions('access:role');

                    if (vm.groupPermObj.List) {
                        vm.fnGetUserGroups(vm.parent.userObj.id);
                    }
                    if (vm.rolePermObj.List) {
                        vm.fnGetUserRoles(vm.parent.userObj.id);
                    }
                    if(!vm.rolePermObj.List || !vm.groupPermObj.List){
                        vm.isUserRelationshipLoaded = true;
                    }
                    angular.element($window).triggerHandler('resize')
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UserTeamsCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, $log, DB, amaran, swal, TabHeight, QueryFactory, PaginationQueryService, microSpinner, UserProfileService, PermissionsService, PaginationService, LastPageService, FedSudoUserService, UserFactory, TeamFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllTeamsChecked = false;
                vm.selectedUserTeamsArr = [];

                //Search Variables
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];

                vm.filterQuery = "";
                vm.sqlQuery = "";
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the nested data JSON string
                            var nestedData = angular.fromJson(item.data || '{}');
                            var primaryId = nestedData.id || nestedData._id || item.id || '';

                            var parsedItem = {
                                // Primary fields used in UI
                                id: primaryId,
                                name: nestedData.name || nestedData.Name || '',
                                description: nestedData.description || nestedData.Description || '',

                                // Team specific fields
                                teamIds: nestedData.teamIds || [],
                                totalUsers: nestedData.totalUsers || 0,

                                // Metadata fields
                                totalItems: item.totalitems || item.totalItems || 0,
                                createdAt: item.created_at || item.createdAt || '',
                                updatedAt: item.updated_at || item.updatedAt || '',
                                rt: item.rt || '',

                                // Additional team-specific fields
                                status: nestedData.status || '',
                                type: nestedData.type || '',
                                permissions: nestedData.permissions || [],
                                members: nestedData.members || [],

                                // UI state fields
                                isCheck: false,

                                // Original data preservation
                                _originalData: nestedData
                            };

                            // Ensure arrays using angular.isArray
                            parsedItem.teamIds = angular.isArray(parsedItem.teamIds) ? parsedItem.teamIds : [];
                            parsedItem.permissions = angular.isArray(parsedItem.permissions) ? parsedItem.permissions : [];
                            parsedItem.members = angular.isArray(parsedItem.members) ? parsedItem.members : [];

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing team item:', error, item);
                            return item;
                        }
                    });
                }



                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;

                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#userTeamsTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element(".tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddGroups = function () {
                    vm.isAllTeamsChecked = false;
                    vm.fnCheckUncheckTeamsAll();
                    vm.isShowAddGroup = !vm.isShowAddGroup;
                    if (vm.isShowAddGroup) {
                        vm.isInit = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.isTeamsLoading = true;
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page);
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage);
                    }
                    vm.isTeamsLoading = true;
                    vm.selectedTeamsArr = [];
                    vm.isAllChecked = false;

                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }

                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_teams';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : ' ';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_teams';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : ' ';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }

                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetTeams(input, true);
                };

                vm.fnGetFilterData = function () {
                    var userArr = [];
                    if (vm.isSinglePage) {
                        if (vm.teamResponse.data.length) {
                            var filterUserArr = [];
                            if (vm.filterQuery) {
                                filterUserArr = _.filter(vm.teamResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterUserArr = _.cloneDeepWith(vm.teamResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                userArr = _.orderBy(filterUserArr, [sortValue], [sortType]);
                            } else {
                                userArr = _.cloneDeepWith(filterUserArr);
                            }
                        }
                    } else {
                        userArr = vm.teamResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? userArr.length : vm.teamResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.teamResponse.metadata.currentPage;
                    vm.teamsArr = userArr;
                    vm.isTeamsLoading = false;
                    vm.isRefresh = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };
                /*END: Search*/

                vm.fnCheckUncheckTeamsAll = function () {
                    angular.forEach(vm.userTeamsArr, function (obj) {
                        obj.isCheck = vm.isAllTeamsChecked;
                    });
                    if (vm.isAllTeamsChecked) {
                        vm.selectedUserTeamsArr = angular.copy(vm.userTeamsArr);
                    } else {
                        vm.selectedUserTeamsArr = [];
                    }
                };

                vm.fnCheckUncheckTeamsHeader = function (groupObj) {
                    vm.isAllTeamsChecked = true;
                    angular.forEach(vm.userTeamsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllTeamsChecked = false;
                        }
                    });

                    /* Toggle push in selected group array*/
                    var isValueFind = _.find(vm.selectedUserTeamsArr, {'id': groupObj.id});
                    if (!isValueFind) {
                        vm.selectedUserTeamsArr.push(groupObj)
                    } else {
                        _.remove(vm.selectedUserTeamsArr, function (obj) {
                            return groupObj.id === obj.id;
                        });
                    }
                };


                vm.fnDeleteTeams = function (selectedUserTeamsArr) {
                    swal({
                            title: "Remove all Selected Teams from User?",
                            text: "Teams will be permanently removed for the User.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedUserTeamsArr, function (selectedGroup) {
                                    var inputObj = {
                                        userId: vm.parent.userObj.id,
                                        teamId: selectedGroup.id
                                    };

                                    promises.push(TeamFactory.removeUserFromTeam(inputObj));
                                });
                                $q.all(promises).then(function () {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    }, 1000);
                                    vm.selectedUserTeamsArr = [];
                                    var teamIds = "";
                                    var userTeamIds = [];
                                    if (vm.parent.userObj.teamIds && vm.parent.userObj.teamIds.length === selectedUserTeamsArr.length) {
                                        vm.userTeamsArr = [];
                                    } else {
                                        angular.forEach(vm.parent.userObj.teamIds, function (team) {
                                            if (!_.find(selectedUserTeamsArr, {id: team})) {
                                                userTeamIds.push(team);
                                            }
                                        });
                                        _.forEach(userTeamIds, function (teamId) {
                                            if (teamIds !== "") {
                                                teamIds += ", '" + teamId + "'";
                                            } else {
                                                teamIds = "'" + teamId + "'";
                                            }
                                        });
                                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where data->>\'id\' IN (" + teamIds + ") LIMIT " + 100 + ";";
                                        vm.fnGetUserTeams({sql: teamSQL}, [], false);
                                    }
                                    vm.parent.userObj.teamIds = userTeamIds.length ? userTeamIds : [];
                                    $scope.$emit('UserDetailsChanged', vm.parent.userObj);
                                }, function (error) {
                                    amaran.error(error.errorMessage);
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.teamsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTeamsArr = angular.copy(vm.teamsArr);
                    } else {
                        vm.selectedTeamsArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isTeamsLoading = true;
                    vm.selectedTeamsArr = [];
                    vm.isAllChecked = false;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_teams';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>' + vm.sort.split(' ')[0] + '\' AS rt FROM access_teams';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : ' ';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_teams';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : ' ';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetTeams(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.teamsArr);
                        vm.previousPage = page;
                        vm.fnGetTeams(input, false);
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    var loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnCheckUncheckHeader = function (groupObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.teamsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === groupObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected group array*/
                    var isValueFind = _.find(vm.selectedTeamsArr, {'id': groupObj.id});
                    if (!isValueFind) {
                        vm.selectedTeamsArr.push(groupObj)
                    } else {
                        _.remove(vm.selectedTeamsArr, function (obj) {
                            return groupObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetTeams = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            // Parse the response data
                            var parsedData = parsePostgresData(res.data);
                            vm.teamResponse = _.cloneDeepWith(res);
                            vm.teamResponse.data = parsedData;

                            if (isFirst && vm.teamResponse.data && vm.teamResponse.data.length) {
                                vm.totalItems = vm.teamResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.teamResponse.data.reverse();
                            }
                            vm.teamsArr = vm.teamResponse.data;
                            vm.isTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTeamsLoading = false;
                        });
                };


                vm.fnAddGroup = function () {
                    vm.isGroupAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedTeamsArr, function (selectedGroup) {
                        var inputObj = {
                            userId: vm.parent.userObj.id,
                            teamId: selectedGroup.id
                        };
                        promises.push(TeamFactory.addUserToTeam(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected teams successfully add in User");
                        var teamIds = "";
                        var userTeamIds = vm.parent.userObj.teamIds && vm.parent.userObj.teamIds.length ? _.cloneDeepWith(vm.parent.userObj.teamIds) : [];
                        angular.forEach(vm.selectedTeamsArr, function (selectedGroup) {
                            userTeamIds.push(selectedGroup.id);
                        });
                        _.forEach(userTeamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where data->>\'id\' IN (" + teamIds + ") LIMIT " + 100 + ";";
                        vm.fnGetUserTeams({sql: teamSQL}, [], false);
                        vm.isGroupAdding = false;
                        vm.isShowAddGroup = false;
                        vm.parent.userObj.teamIds = userTeamIds;
                        $scope.$emit('UserDetailsChanged', vm.parent.userObj);
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isGroupAdding = false;
                    })
                };

                vm.fnGetUserTeams = function (inputObj, preDefinedTeams, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (resTeams) {
                            // Parse the response data
                            var parsedTeams = parsePostgresData(resTeams.data);
                            var teams = isCalledForViz ? preDefinedTeams : [];

                            angular.forEach(parsedTeams, function (teamsObj) {
                                teams.push(teamsObj);
                            });

                            if ((parsedTeams && parsedTeams.length > 0) && (teams[0] && teams[0].totalItems > teams.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + teams[teams.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetUserTeams({sql: sqlString}, teams, true);
                            } else {
                                vm.userTeamsArr = _.cloneDeepWith(teams);
                                vm.isUserTeamsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                            }
                        }, function () {
                            vm.isUserTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };

                vm.fnGoToTeam = function (obj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "name": "id is equal to: " + obj.id,
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": obj.id
                    };
                    tagsArr.push(angular.copy(inputObj));
                    DB.fnSet('isCalledFromUser', true);
                    $state.go("main.teams", {filter: angular.toJson(tagsArr)});
                };

                vm.fnInitUserTeams = function () {
                    vm.isUserTeamsLoading = true;
                    if (vm.parent.userObj.teamIds && vm.parent.userObj.teamIds.length) {
                        var teamIds = "";
                        _.forEach(vm.parent.userObj.teamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where data->>\'id\' IN (" + teamIds + ") LIMIT " + 100 + ";";
                        vm.fnGetUserTeams({sql: teamSQL}, [], false);
                    } else {
                        vm.userTeamsArr = [];
                        vm.isUserTeamsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('colorPickerModalCtrl',
            function ($uibModalInstance, $http, $scope, $window, $timeout, DB, selectedColor) {
                var vm = this;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };

                vm.bgColor = '';

                vm.fnApply = function () {
                    $uibModalInstance.close(vm.bgColor);
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCheckInput = function () {
                    return /^#[0-9A-F]{6}$/i.test(vm.bgColor);
                };

                vm.fnInitColorPickerModal = function () {
                    vm.bgColor = selectedColor;
                };
            })
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TypeSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, TypesFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.typeSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetTypeData = function () {
                    vm.typeSupplementalObj = vm.parent.typeObj.tags ? angular.fromJson(vm.parent.typeObj.tags) : {};
                    vm.typeSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.typeSupplementalObj, true) : vm.typeSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.typeSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.typeSupplementalObj)) {
                        angular.forEach(vm.typeSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isTypeSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.typeSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.typeSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.typeSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.typeSupplementalObj = angular.toJson(vm.typeSupplementalObj, true);
                    } else {
                        vm.typeSupplementalObj = angular.fromJson(vm.typeSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.typeSupplementalObj)) {
                            angular.forEach(vm.typeSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveTypeData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.typeObj.tags = {};
                    var inputObj = {
                        typeId: vm.parent.typeObj.id,
                        body: {}
                    };
                    if (!vm.parent.typeObj.tags) {
                        vm.parent.typeObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.typeObj.tags = angular.fromJson(vm.typeSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.typeObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.typeObj.tags;
                    TypesFactory.replaceIssueTypeTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Type successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitTypeSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitTypeSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.typeSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.typeSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.typeSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitTypeSupplemental = function () {
                    vm.isTypeSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TypeFormCtrl',
            function ($scope, $timeout, $window, swal, $uibModal, amaran, TabHeight, TypesFactory, TypeFormService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isTypeDetailsLoaded = false;
                vm.typeObj = {};
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];
                vm.isUpdateCompleted = true;
                vm.isShowFormBuilderTabUI = false;

                vm.sortableOptions = {
                    disabled: !vm.parent.userPermissionsObj.UPDATE_TYPE_FORM,
                    stop: function () {
                        var tempArr = _.map(vm.formBuilderInput, function (formObj) {
                            return formObj.key;
                        });

                        var schema = {};

                        _.forEach(tempArr, function (tempKey) {
                            schema[tempKey] = vm.schema.properties[tempKey];
                        });

                        vm.schema.properties = _.cloneDeepWith(schema);
                        var tempData = TypeFormService.fnGenerateFormData(vm.schema);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        vm.formBuilderInput = tempData.formBuilderInput;
                    }
                };

                vm.subSortableOptions = {
                    disabled: !vm.parent.userPermissionsObj.UPDATE_TYPE_FORM,
                    stop: function () {
                        _.forEach(vm.formBuilderInput, function (formObj) {
                            if (formObj.type === 'panel-conditional' || formObj.type === 'panel-multiCheckbox') {
                                var tempKey = _.map(formObj.items, function (formObj) {
                                    return formObj.key;
                                });
                                var aaa = _.cloneDeepWith(vm.schema.properties[formObj.key].properties);
                                vm.schema.properties[formObj.key].properties = {};
                                _.forEach(tempKey, function (tempKey) {
                                    vm.schema.properties[formObj.key].properties[tempKey.split('.')[1]] = aaa[tempKey.split('.')[1]];
                                });
                            }
                        });
                        var tempData = TypeFormService.fnGenerateFormData(vm.schema);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        vm.formBuilderInput = tempData.formBuilderInput;
                    }
                };

                vm.subCHKSortableOptions = {
                    disabled: !vm.parent.userPermissionsObj.UPDATE_TYPE_FORM,
                    stop: function () {
                        _.forEach(vm.formBuilderInput, function (formObj) {
                            if (formObj.type === 'panel-conditional') {
                                _.forEach(formObj.items, function (itemObj) {
                                    if (itemObj.type === 'panel-multiCheckbox') {
                                        var tempKey = _.map(itemObj.items, function (formObj) {
                                            return formObj.key;
                                        });
                                        var aaa = _.cloneDeepWith(vm.schema.properties[formObj.key].properties[itemObj.key.split('.')[1]].properties);
                                        vm.schema.properties[formObj.key].properties[itemObj.key.split('.')[1]].properties = {};
                                        _.forEach(tempKey, function (tempKey) {
                                            vm.schema.properties[formObj.key].properties[itemObj.key.split('.')[1]].properties[tempKey.split('.')[2]] = aaa[tempKey.split('.')[2]];
                                        });
                                    }
                                })
                            }
                        });
                        var tempData = TypeFormService.fnGenerateFormData(vm.schema);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        vm.formBuilderInput = tempData.formBuilderInput;
                    }
                };

                vm.fnGetTypeData = function () {
                    vm.typeObj = vm.parent.typeObj;
                    if (vm.typeObj.form && vm.typeObj.form.schema && vm.typeObj.form.schema.properties && Object.keys(vm.typeObj.form.schema.properties).length) {
                        var tempData = TypeFormService.fnGenerateFormData(vm.typeObj.form.schema);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        vm.formBuilderInput = tempData.formBuilderInput;
                    } else {
                        vm.schema = {
                            $schema: "https://json-schema.org/draft/2019-09/schema",
                            type: "object",
                            properties: {}
                        };
                        vm.form = [];
                    }
                    if (vm.form.length) {
                        vm.isShowFormBuilderTabUI = true;
                    }
                    vm.resetTypeObj = _.cloneDeepWith(vm.typeObj);
                    vm.isTypeDetailsLoaded = true;
                };

                vm.fnUpdateFormConfig = function () {
                    var inputObj = {
                        body: {},
                        typeId: vm.parent.typeObj.id
                    };
                    vm.isUpdateCompleted = false;
                    inputObj.body = {
                        schema: vm.schema,
                        values: {}
                    };
                    TypesFactory.updateIssueTypeForm(inputObj)
                        .then(function () {
                            if (angular.isUndefined(vm.parent.typeObj.form)) {
                                vm.parent.typeObj.form = {};
                            }
                            if (angular.isUndefined(vm.parent.typeObj.form.schema)) {
                                vm.parent.typeObj.form.schema = {};
                            }
                            vm.parent.typeObj.form.schema = vm.schema;
                            vm.isUpdateCompleted = true;
                            amaran.success("Type Form Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                        })
                };

                /*New Changes: Start*/
                vm.fieldArr = [
                    {
                        name: 'Text Field',
                        icon: 'fa-terminal'
                    }, {
                        name: 'Text Area',
                        icon: 'fa-font'
                    }, {
                        name: 'Checkbox',
                        icon: 'fa-check-square'
                    }, {
                        name: 'Select',
                        icon: 'fa-th-list'
                    }, {
                        name: 'Number',
                        icon: 'fa-hashtag'
                    }, {
                        name: 'Password',
                        icon: 'fa-asterisk'
                    }, {
                        name: 'Multi Checkbox',
                        icon: 'fa-check-square-o'
                    }, {
                        name: 'Panel',
                        icon: 'fa-list-alt'
                    }
                ];

                vm.formBuilderInput = [];
                vm.schema = {
                    $schema: "https://json-schema.org/draft/2019-09/schema",
                    type: "object",
                    properties: {}
                };
                vm.form = [];
                vm.modal = [];

                vm.fnOnActionDrop = function (srcList, srcIndex) {
                    if (srcIndex !== 'main' && srcList.name === 'Panel') {
                        amaran.error('Multi-level Panels not allowed.');
                    } else {
                        vm.fnOpenInputConfigModal(srcList, srcIndex);
                    }
                    return true;
                };

                vm.fnOpenInputConfigModal = function (srcList, srcIndex) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return vm.form;
                            },
                            inputObj: function () {
                                return {};
                            },
                            isWorkbenchMode: function () {
                                return false;
                            },
                            iot3JsonObj: function () {
                                return {};
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema = _.cloneDeepWith(vm.schema);
                        $timeout(function () {
                            var subKey = '';
                            if (srcIndex === 'main') {
                                schema.properties[obj.key] = obj.value;
                            } else {
                                subKey = srcIndex + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                schema.properties[srcIndex].properties[obj.key] = tempObj.value;
                            }
                            vm.schema = schema;
                            if (obj.value.type === 'object' && obj.value.inputType === 'panel') {
                                if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                    var schemaObj = schema.properties[obj.key];
                                    schemaObj.multiformConfig = obj.multiformConfig;
                                    vm.schema = schema;
                                }
                            }
                            var tempData = TypeFormService.fnGenerateFormData(vm.schema);
                            vm.schema = tempData.schema;
                            vm.form = tempData.form;
                            vm.formBuilderInput = tempData.formBuilderInput;
                        });
                    }, function () {
                    });
                };

                vm.fnRemove = function (inputObj, multiForm, parentObj) {
                    var text = "";
                    if (inputObj.type === 'panel-conditional') {
                        text = 'Removing this component will also remove all of its children!'
                    }
                    swal({
                            title: "Delete the selected Component?",
                            text: text,
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                if (multiForm && multiForm === true) {
                                    var tempInputKey = inputObj.key.split('.')[1];
                                    delete vm.schema.properties[parentObj.key].properties[tempInputKey];
                                    //delete vm.model[parentObj.key][tempInputKey];
                                    var isFind = _.find(vm.form, function (formObj) {
                                        return formObj.key[0] === parentObj.key;
                                    });
                                    if (isFind) {
                                        var tempArr = _.cloneDeepWith(isFind.items);
                                        isFind.items = _.remove(isFind.items, function (itemObj) {
                                            return itemObj.key && itemObj.key[1] !== tempInputKey;
                                        });
                                        isFind.items.unshift(tempArr[0]);
                                    }
                                    var isFindFormBuilder = _.find(vm.formBuilderInput, function (formBuilderObj) {
                                        return formBuilderObj.key && formBuilderObj.key === parentObj.key;
                                    });
                                    if (isFindFormBuilder) {
                                        isFindFormBuilder.items = _.remove(isFindFormBuilder.items, function (itemObj) {
                                            return itemObj.key !== inputObj.key;
                                        });
                                    }
                                } else {
                                    var isFindReference = _.filter(vm.form, function (formObj) {
                                        if (formObj && formObj.multiformConfig && formObj.multiformConfig.referenceKey === inputObj.key) {
                                            return formObj;
                                        }
                                    });
                                    if (isFindReference.length) {
                                        _.forEach(isFindReference, function (referenceObj) {
                                            delete referenceObj.multiformConfig;
                                            delete referenceObj.condition;
                                            delete vm.schema.properties[referenceObj.key].multiformConfig;
                                            var isFind = _.find(vm.formBuilderInput, {key: inputObj.key});
                                            if (isFind) {
                                                delete isFind.multiformConfig;
                                            }
                                        });
                                        delete vm.schema.properties[inputObj.key];
                                        //delete vm.model[inputObj.key];
                                        vm.form = _.remove(vm.form, function (formObj) {
                                            return formObj.key[0] !== inputObj.key;
                                        });
                                        _.remove(vm.formBuilderInput, {key: inputObj.key});
                                    } else {
                                        delete vm.schema.properties[inputObj.key];
                                        //delete vm.model[inputObj.key];
                                        vm.form = _.remove(vm.form, function (formObj) {
                                            return formObj.key[0] !== inputObj.key;
                                        });
                                        _.remove(vm.formBuilderInput, {key: inputObj.key});
                                    }
                                }
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                $timeout(function () {
                                    $scope.$apply();
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetType = function (type) {
                    var newType = '';
                    switch (type) {
                        case 'inputText':
                            newType = _.find(vm.fieldArr, {name: 'Text Field'});
                            break;
                        case 'inputTextarea':
                            newType = _.find(vm.fieldArr, {name: 'Text Area'});
                            break;
                        case 'dropdown':
                            newType = _.find(vm.fieldArr, {name: 'Select'});
                            break;
                        case 'inputCheckbox':
                            newType = _.find(vm.fieldArr, {name: 'Checkbox'});
                            break;
                        case 'inputNumber':
                            newType = _.find(vm.fieldArr, {name: 'Number'});
                            break;
                        case 'inputPassword':
                            newType = _.find(vm.fieldArr, {name: 'Password'});
                            break;
                        case 'panel-multiCheckbox':
                            newType = _.find(vm.fieldArr, {name: 'Multi Checkbox'});
                            break;
                        default:
                            newType = _.find(vm.fieldArr, {name: 'Panel'});
                            break;
                    }
                    return newType;
                };

                vm.fnEditInput = function (inputObj, multiForm, parentObj) {
                    var resetInputObj = _.cloneDeepWith(inputObj);
                    if (multiForm === true) {
                        resetInputObj.key = resetInputObj.key.split('.')[1];
                        resetInputObj.schema = _.cloneDeepWith(vm.schema.properties[parentObj.key].properties[resetInputObj.key]);
                    } else {
                        resetInputObj.schema = _.cloneDeepWith(vm.schema.properties[inputObj.key]);
                    }
                    var srcList = vm.fnGetType(inputObj.type);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return vm.form;
                            },
                            inputObj: function () {
                                return resetInputObj;
                            },
                            isWorkbenchMode: function () {
                                return false;
                            },
                            iot3JsonObj: function () {
                                return {};
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema = _.cloneDeepWith(vm.schema);
                        vm.schema = {};
                        vm.form = [];
                        $timeout(function () {
                            var subKey = '';
                            if (multiForm === true) {
                                subKey = parentObj.key + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                if (resetInputObj.key !== obj.key) {
                                    delete schema.properties[parentObj.key].properties[resetInputObj.key];
                                }
                                schema.properties[parentObj.key].properties[obj.key] = tempObj.value;
                            } else {
                                if (inputObj.type !== "panel-conditional") {
                                    if (resetInputObj.key !== obj.key) {
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    schema.properties[obj.key] = obj.value;
                                }
                                if (inputObj.type === "panel-conditional") {
                                    var schemaObj = {};
                                    if (resetInputObj.key !== obj.key) {
                                        schema.properties[obj.key] = schema.properties[resetInputObj.key];
                                        schema.properties[obj.key].key = obj.key;
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.value.title;
                                    } else {
                                        obj.multiformConfig = {};
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.title;
                                    }
                                }
                            }
                            vm.schema = schema;
                            var tempData = TypeFormService.fnGenerateFormData(vm.schema);
                            vm.schema = tempData.schema;
                            vm.form = tempData.form;
                            vm.formBuilderInput = tempData.formBuilderInput;
                        });
                    }, function () {
                    });
                };

                /*New Changes: End*/

                vm.fnInitTypeForm = function () {
                    vm.isTypeDetailsLoaded = false;
                    if (vm.parent.typeObj.id) {
                        vm.fnGetTypeData(vm.parent.typeObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('StateSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, TrackerStateFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.stateSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetStateData = function () {
                    vm.stateSupplementalObj = vm.parent.stateObj.tags ? angular.fromJson(vm.parent.stateObj.tags) : {};
                    vm.stateSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.stateSupplementalObj, true) : vm.stateSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.stateSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.stateSupplementalObj)) {
                        angular.forEach(vm.stateSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isStateSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.stateSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.stateSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.stateSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.stateSupplementalObj = angular.toJson(vm.stateSupplementalObj, true);
                    } else {
                        vm.stateSupplementalObj = angular.fromJson(vm.stateSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.stateSupplementalObj)) {
                            angular.forEach(vm.stateSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveStateData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.stateObj.tags = {};
                    var inputObj = {
                        stateId: vm.parent.stateObj.id,
                        body: {}
                    };
                    if (!vm.parent.stateObj.tags) {
                        vm.parent.stateObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.stateObj.tags = angular.fromJson(vm.stateSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.stateObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.stateObj.tags;
                    TrackerStateFactory.replaceIssueStateTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to State successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitStateSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitStateSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.stateSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.stateSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.stateSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitStateSupplemental = function () {
                    vm.isStateSupplementalDetailsLoaded = false;
                    if (vm.parent.stateObj.id) {
                        vm.fnGetStateData(vm.parent.stateObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, ProjectFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.projectSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetProjectData = function () {
                    vm.projectSupplementalObj = vm.parent.projectObj.tags ? angular.fromJson(vm.parent.projectObj.tags) : {};
                    vm.projectSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.projectSupplementalObj, true) : vm.projectSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.projectSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isProjectSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.projectSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.projectSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.projectSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.projectSupplementalObj = angular.toJson(vm.projectSupplementalObj, true);
                    } else {
                        vm.projectSupplementalObj = angular.fromJson(vm.projectSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                            angular.forEach(vm.projectSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveProjectData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.projectObj.tags = {};
                    var inputObj = {
                        projectId: vm.parent.projectObj.id,
                        body: {}
                    };
                    if (!vm.parent.projectObj.tags) {
                        vm.parent.projectObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.projectObj.tags = angular.fromJson(vm.projectSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.projectObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.projectObj.tags;
                    ProjectFactory.replaceProjectTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Project successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.projectSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitProjectSupplemental = function () {
                    vm.isProjectSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectTeamsCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllTeamsChecked = false;
                vm.selectedProjectTeamsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 26 - actionDiv) + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnGetProjectTeams = function (inputObj, preDefinedTeams, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (resTeams) {
                            var teams = isCalledForViz ? preDefinedTeams : [];
                            _.forEach(resTeams.data, function (teamsObj) {
                                teams.push(teamsObj);
                            });
                            if ((resTeams.data && resTeams.data.length && resTeams.data.length > 0) && (teams[0] && teams[0].totalItems > teams.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + teams[teams.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectTeams({sql: sqlString}, teams, true);
                            } else {
                                vm.projectTeamsArr = _.cloneDeepWith(teams);
                                vm.isProjectTeamsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }
                        }, function () {
                            vm.isProjectTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnInitProjectTeams = function () {
                    vm.isProjectTeamsLoading = true;
                    if (vm.parent.projectObj.teamIds && vm.parent.projectObj.teamIds.length) {
                        var teamIds = "";
                        _.forEach(vm.parent.projectObj.teamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where id IN (" + teamIds + ") LIMIT " + 100 + ";";
                        vm.fnGetProjectTeams({sql: teamSQL}, [], false);
                    } else {
                        vm.projectTeamsArr = [];
                        vm.isProjectTeamsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectScriptCtrl',
            function ($scope, $timeout, $window, $state) {
                var vm = this;
                vm.parent = $scope.$parent;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGotoScripts = function () {
                    $state.go('main.project_scripts', {
                        name: vm.parent.projectObj.name,
                        selectedProject: vm.parent.projectObj.id
                    });
                };

                vm.fnInitProjectScript = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectEmailCtrl',
            function ($scope, $timeout, $window, $state) {
                var vm = this;
                vm.parent = $scope.$parent;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGotoEmailTemplate = function () {
                    $state.go('main.project_emailTemplate', {
                        name: vm.parent.projectObj.name,
                        selectedProject: vm.parent.projectObj.id
                    });
                };

                vm.fnInitProjectEmail = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PrioritySupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, PriorityFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.prioritySupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetPriorityData = function () {
                    vm.prioritySupplementalObj = vm.parent.priorityObj.tags ? angular.fromJson(vm.parent.priorityObj.tags) : {};
                    vm.prioritySupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.prioritySupplementalObj, true) : vm.prioritySupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.prioritySupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.prioritySupplementalObj)) {
                        angular.forEach(vm.prioritySupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isPrioritySupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.prioritySupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.prioritySupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.prioritySupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.prioritySupplementalObj = angular.toJson(vm.prioritySupplementalObj, true);
                    } else {
                        vm.prioritySupplementalObj = angular.fromJson(vm.prioritySupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.prioritySupplementalObj)) {
                            angular.forEach(vm.prioritySupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSavePriorityData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.priorityObj.tags = {};
                    var inputObj = {
                        priorityId: vm.parent.priorityObj.id,
                        body: {}
                    };
                    if (!vm.parent.priorityObj.tags) {
                        vm.parent.priorityObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.priorityObj.tags = angular.fromJson(vm.prioritySupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.priorityObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.priorityObj.tags;
                    PriorityFactory.replaceIssuePriorityTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Priority successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitPrioritySupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitPrioritySupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.prioritySupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.prioritySupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.prioritySupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitPrioritySupplemental = function () {
                    vm.isPrioritySupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LabelSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, LabelFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.labelSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetLabelData = function () {
                    vm.labelSupplementalObj = vm.parent.labelObj.tags ? angular.fromJson(vm.parent.labelObj.tags) : {};
                    vm.labelSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.labelSupplementalObj, true) : vm.labelSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.labelSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.labelSupplementalObj)) {
                        angular.forEach(vm.labelSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isLabelSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.labelSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.labelSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.labelSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.labelSupplementalObj = angular.toJson(vm.labelSupplementalObj, true);
                    } else {
                        vm.labelSupplementalObj = angular.fromJson(vm.labelSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.labelSupplementalObj)) {
                            angular.forEach(vm.labelSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveLabelData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.labelObj.tags = {};
                    var inputObj = {
                        labelId: vm.parent.labelObj.id,
                        body: {}
                    };
                    if (!vm.parent.labelObj.tags) {
                        vm.parent.labelObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.labelObj.tags = angular.fromJson(vm.labelSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.labelObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.labelObj.tags;
                    LabelFactory.replaceIssueLabelTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Label successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitLabelSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitLabelSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.labelSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.labelSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.labelSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitLabelSupplemental = function () {
                    vm.isLabelSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ArchivedPrivateCtrl',
            function ($scope, $rootScope, $timeout, $window, $sce, moment, UserProfileService, mermaid, microSpinner, swal, amaran, copyService, ArchivedIssueFactory, CommentFactory, AvatarService, ColorService, DB) {
                var vm = this;
                vm.parent = $scope.$parent;
                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                vm.isIssueDetailsLoaded = false;

                vm.issueObj = {};
                vm.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');
                vm.loginUserAvatar = AvatarService.getTextAvatar(vm.loginUser);
                vm.selectedComment = {};
                vm.isShowIssueSummary = false;
                vm.isShowMainComment = false;
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                vm.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;
                vm.selectedCommentView = _.cloneDeepWith(vm.parent.selectedCommentView);

                vm.markedOptionObj = {
                    iconlibrary: "fa",
                    addExtraButtons: false,
                    resize: "vertical",
                    initialstate: "preview",
                    hiddenButtons: ['all']
                };

                vm.newCommentMarkedOptionObj = {
                    iconlibrary: 'fa',
                    addExtraButtons: false,
                    resize: 'vertical',
                    hiddenButtons: ['all']
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTabHeight();
                });

                var text = '';
                var storeH = 0;
                var storeH2 = 0;

                vm.fnKeyDownComment = function () {
                    $timeout(function () {
                        if (storeH !== text.scrollHeight) {
                            text.style.height = text.scrollHeight + 2 + 'px';
                            storeH = text.scrollHeight;
                            if (storeH2 !== storeH) {
                                storeH2 = storeH;
                            }
                        }
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    });
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        $timeout(function () {
                            if (angular.element(".comment-timeline")[0]) {
                                var commentTimeline = angular.element(".comment-timeline")[0].offsetHeight;
                                var newCommentBlock = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                var commentHeader = angular.element(".comment-header")[0].offsetHeight;
                                var commentFooter = angular.isDefined(angular.element(".comment-footer")[0]) ? angular.element(".comment-footer")[0].offsetHeight : 0;
                                //var test = finalHeight + 200;
                                angular.element(".comment-body").css('height', (finalHeight - (commentTimeline + newCommentBlock + commentHeader + commentFooter + 60)) + 'px');
                            }
                            if (angular.element(".vertical-comment-view")[0]) {
                                var newCommentBlock1 = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                angular.element(".vertical-comment-view").css('height', (finalHeight - (newCommentBlock1 + 40)) + 'px');
                                //angular.element(".qa-message-content").css('height', ((finalHeight - (newCommentBlock1 + 40)) - 53) + 'px');
                            }
                        })
                    }
                };

                vm.fnGetIssue = function (issueId) {
                    var tempObj = {
                        issueId: issueId
                    };
                    ArchivedIssueFactory.describeArchivedIssue(tempObj)
                        .then(function (response) {
                            vm.isIssueDetailsLoaded = true;
                            response.isIssueEditMode = false;
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            vm.issueObj = response;
                            vm.parent.tabs[0].title = angular.isDefined(vm.issueObj.publicComments) ? "Public [ " + vm.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            vm.parent.tabs[1].title = angular.isDefined(vm.issueObj.privateComments) ? "Private [ " + vm.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            vm.issueObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.createdAt);
                            vm.issueObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issueObj.updatedAt);
                            _.forEach(vm.issueObj.privateComments, function (privateCommentObj) {
                                privateCommentObj.userAvatar = angular.isDefined(privateCommentObj.createdBy) ? AvatarService.getTextAvatar({email: privateCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                privateCommentObj.humanDateCreated = moment.unix(privateCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                privateCommentObj.humanDateCreatedRelative = moment(privateCommentObj.humanDateCreated).fromNow();
                                privateCommentObj.humanDateCreatedAbsolute = moment.unix(privateCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                privateCommentObj.mdBody = _.cloneDeepWith(privateCommentObj.text);
                                _.forEach(privateCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                });
                            });
                            if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                                vm.isShowMainComment = true;
                            } else {
                                vm.fnShowIssueSummary();
                            }
                            vm.resetIssueObj = angular.copy(response);
                            vm.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined(vm.issueObj.createdBy) ? vm.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined(vm.issueObj.createdBy) ? AvatarService.getTextAvatar({email: vm.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined(vm.issueObj.createdAt) ? vm.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix(vm.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix(vm.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith(vm.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith(vm.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith(vm.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                vm.issueSummary = _.cloneDeepWith(tempSummary);
                            });
                            $timeout(function () {
                                text = document.getElementById('newCommentBlock');
                                vm.fnSetTabHeight();
                            });
                        }, function () {
                        })
                };

                vm.fnShowIssueSummary = function () {
                    var tempSummary = {};
                    vm.selectedComment = {};
                    tempSummary.createdBy = angular.isDefined(vm.issueObj.createdBy) ? vm.issueObj.createdBy : '';
                    tempSummary.userAvatar = angular.isDefined(vm.issueObj.createdBy) ? AvatarService.getTextAvatar({email: vm.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                    tempSummary.createdAt = angular.isDefined(vm.issueObj.createdAt) ? vm.issueObj.createdAt : '';
                    tempSummary.humanDateCreated = moment.unix(vm.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                    tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                    tempSummary.humanDateCreatedAbsolute = moment.unix(vm.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                    tempSummary.summary = _.cloneDeepWith(vm.issueObj.summary);
                    tempSummary.mdBody = _.cloneDeepWith(vm.issueObj.summary);
                    tempSummary.voteCount = _.cloneDeepWith(vm.issueObj.voteCount);
                    tempSummary.id = _.cloneDeepWith(vm.issueObj.id);
                    $timeout(function () {
                        vm.selectedComment = _.cloneDeepWith(tempSummary);
                    });
                    vm.isShowIssueSummary = true;
                    vm.isShowMainComment = false;
                };

                vm.fnShowComment = function (comment, type) {
                    vm.selectedComment = {};
                    $timeout(function () {
                        vm.selectedComment = _.cloneDeepWith(comment);
                    }, 0);
                    vm.isShowMainComment = type === 'mainComment';
                    vm.isShowIssueSummary = false;
                };


                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetRelativeTime = function (createdDate) {
                    return moment.unix(createdDate).format("DD/MM/YYYY, HH:mm");
                };

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                    }
                };

                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce(); //eslint-disable-line
                        vega_runonce(); //eslint-disable-line
                    }, 100);
                };

                $rootScope.$on("IssueCommentViewChangedArchived", function () { // eslint-disable-line
                    vm.selectedCommentView = _.cloneDeepWith(vm.parent.selectedCommentView);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.fnRenderMermaid();
                        if (vm.selectedCommentView === 'Vertical') {
                            $timeout(function () {
                                var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                objDiv.scrollTop = objDiv.scrollHeight;
                            })
                            vm.selectedComment = {};
                        } else {
                            //$scope.selectedComment = {};
                            if (vm.issueObj.privateComments && vm.issueObj.privateComments.length) {
                                vm.selectedComment = _.cloneDeepWith(vm.issueObj.privateComments[vm.issueObj.privateComments.length - 1]);
                                vm.selectedComment.isShowComment = true;
                                vm.isShowMainComment = true;
                                vm.isShowIssueSummary = false;
                            } else {
                                vm.fnShowIssueSummary();
                            }
                        }
                    }, 100);
                });

                vm.fnInitIssuePrivate = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                    vm.isIssueDetailsLoaded = false;
                    vm.fnGetIssue(vm.parent.issueObj.id);
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ArchivedHistoryCtrl',
            function ($scope, $timeout, $window, moment, amaran, TabHeight, mermaid, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.markedOptionObj = {
                    iconlibrary: "fa",
                    addExtraButtons: false,
                    resize: "vertical",
                    initialstate: "preview",
                    hiddenButtons: ['all']
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetIssueHistory = function (inputObj, preDefinedHistory, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            var history = isCalledForViz ? preDefinedHistory : [];
                            _.forEach(response.data, function (historyObj) {
                                history.push(historyObj);
                            });
                            if ((response.data && response.data.length && response.data.length > 0) && (history[0] && history[0].totalItems > history.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_archived_histories';
                                sqlString += " WHERE data->>\'issueId\' = '"+ vm.parent.issueObj.id +"' and data->>\'_id\' > " + "'" + history[history.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetIssueHistory({sql: sqlString}, history, true);
                            } else {
                                vm.issueHistorysArr = _.cloneDeepWith(history);
                                vm.issueHistorysArr.map(function (obj) {
                                    obj.eventEpoch = vm.fnGetAbsoluteOrRelativeTime(obj.eventEpoch);
                                    obj.eventType = obj.eventType.replace(/_/g, " ");
                                });
                                vm.isIssueHistoryDetailsLoaded = true;
                                $timeout(function () {
                                    mermaid.init(".lang-mermaid");
                                    plantuml_runonce(); //eslint-disable-line
                                    vega_runonce(); //eslint-disable-line
                                },1000);
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.issueHistorysArr = [];
                            vm.isIssueHistoryDetailsLoaded = true;
                        })
                };

                vm.fnInitIssueHistory = function () {
                    vm.isIssueHistoryDetailsLoaded = false;
                    if (vm.parent.issueObj.id) {
                        var historySQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_archived_histories where data->>\'issueId\' = '"+ vm.parent.issueObj.id +"' LIMIT " + 100 + ";";
                        vm.fnGetIssueHistory({sql: historySQL}, [], false);
                    } else {
                        vm.isIssueHistoryDetailsLoaded = true;
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ArchivedFormCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, ArchivedIssueFactory, TypeFormService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.issueObj = {};
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];

                vm.fnGetIssueData = function (issueId) {
                    var tempObj = {
                        issueId: issueId
                    };
                    ArchivedIssueFactory.describeArchivedIssue(tempObj)
                        .then(function (response) {
                            vm.issueObj = response;
                            if (vm.issueObj.customForm && vm.issueObj.customForm.schema && vm.issueObj.customForm.schema.properties && Object.keys(vm.issueObj.customForm.schema.properties).length) {
                                var tempData = TypeFormService.fnGenerateFormData(vm.issueObj.customForm.schema);
                                vm.schema = tempData.schema;
                                vm.form = tempData.form;
                                vm.model = _.cloneDeepWith(vm.issueObj.customForm.values);
                            } else {
                                vm.schema = {
                                    $schema: "https://json-schema.org/draft/2019-09/schema",
                                    type: "object",
                                    properties: {}
                                };
                                vm.form = [];
                            }
                            vm.resetIssueObj = _.cloneDeepWith(vm.issueObj);
                            vm.isIssueDetailsLoaded = true;
                            $timeout(function () {
                                TabHeight.fnSet();
                            });
                        }, function () {
                            vm.isIssueDetailsLoaded = true;
                            $timeout(function () {
                                TabHeight.fnSet();
                            });
                        })
                };

                vm.fnInitIssueForm = function () {
                    vm.isIssueDetailsLoaded = false;
                    if (vm.parent.issueObj.id) {
                        vm.fnGetIssueData(vm.parent.issueObj.id);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('WorkflowFlowViewCtrl',
            function ($scope, $uibModal, $base64, $state, $stateParams, $timeout, microSpinner, swal, amaran, draw2d, DB, componentService,
                      FilterQueryService, breadcrumbObjService, PermissionsService, ListenerFactory, StateFactory,
                      WorkflowFactory) {
                var vm = this;
                var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
                var appCount = 0;
                vm.modelsObj = {};
                vm.workflowObj = null;
                vm.statesArr = [];
                vm.isWorkflowLoaded = false;
                vm.isListenerModelsLoading = true;
                vm.workflowId = $stateParams.id;
                vm.clonedCanvas = null;
                vm.isRefreshMdEditor = false;
                vm.isStateInfoLoaded = false;
                vm.stateInfoObj = null;
                vm.isCloneCompleted = true;
                vm.selectedStateInputsArr = [];
                /*MarkDown Editor Variable*/
                vm.markedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview"
                };

                /*Configure Variables: START*/
                vm.configureObj = {};
                vm.stashName = '';
                vm.loadArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                vm.injectArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                vm.injectDestination = '';
                vm.injectValue = '';
                vm.loadDetail = "Load results (complete or partial) from previously executed states that specified a `stash` value. The map key should be the destination path that the stashed data will be loaded to. e.g. `$.issue.title`. The corresponding map value is the stash name prefixed with a hash symbol `#` followed by the optional path to the field. e.g. `#stash-name.path.to.key`. The initial payload can be accessed using the reserved `#initial` stash name. If this value is not specified the output from the previous state is used.";
                vm.stashDetail = "The stash name to assign to the result of the task. This name allows the result to be loaded for any subsequent state in the workflow execution. The name must be between 1 an 10 characters and can contain [a-z][A-Z][0-9] and `-` (hyphen). Note: The name `initial` is reserved for the initial payload.";
                /*Configure Variables: END*/

                /*Connector Variables: START*/
                vm.queryBuilder = {"condition": "AND", "rules": []};
                vm.connectorExpressionObj = {};

                /*Connector Variables: END*/

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.fnSetConfigOptions = function (isCalledForModal, modalType) {
                    if (vm.selectedStateObj.parameters && vm.selectedStateObj.parameters.stash) {
                        vm.stashName = vm.selectedStateObj.parameters.stash;
                    } else {
                        vm.stashName = '';
                    }
                    if (vm.selectedStateObj.parameters && vm.selectedStateObj.parameters.load) {
                        vm.loadArr = [];
                        Object.keys(vm.selectedStateObj.parameters.load).forEach(function (key) {
                            var inputObj = {
                                key: key
                            };
                            if (vm.selectedStateObj.type === 'CHOICE') {
                                if (!vm.selectedStateObj.parameters.load[key].startsWith('#')) {
                                    var flag = false;
                                    var stateName = '';
                                    angular.forEach(vm.statesArr, function (state) {
                                        if (state.id === vm.selectedStateObj.parameters.load[key]) {
                                            flag = true;
                                            stateName = state.name;
                                        }
                                    });
                                    if (flag) {
                                        inputObj.value = stateName;
                                    } else {
                                        inputObj.value = vm.selectedStateObj.parameters.load[key];
                                    }
                                } else {
                                    inputObj.value = vm.selectedStateObj.parameters.load[key];
                                }
                            } else {
                                inputObj.value = vm.selectedStateObj.parameters.load[key];
                            }
                            vm.loadArr.push(inputObj);
                        });
                    } else {
                        vm.loadArr = [
                            {
                                key: '',
                                value: ''
                            }
                        ];
                    }
                    if (vm.selectedStateObj.parameters && vm.selectedStateObj.parameters.inject) {
                        vm.injectArr = [];
                        Object.keys(vm.selectedStateObj.parameters.inject).forEach(function (key) {
                            var inputObj = {
                                key: key,
                                value: ''
                            };
                            //vm.injectDestination = key;
                            var flag = isJson(vm.selectedStateObj.parameters.inject[key]);

                            if (flag) {
                                inputObj.value = angular.toJson(vm.selectedStateObj.parameters.inject[key], true);
                            } else {
                                inputObj.value = vm.selectedStateObj.parameters.inject[key];
                            }
                            vm.injectArr.push(inputObj);
                        });
                    } else {
                        vm.injectArr = [
                            {
                                key: '',
                                value: ''
                            }
                        ];
                        /*vm.injectDestination = '';
                         vm.injectValue = '';*/
                    }
                    vm.isStateMdInfoLoaded = true;
                    if (isCalledForModal) {
                        angular.element(".microSpinner").remove();
                        angular.element(".confirm").css("visibility", "visible");
                        swal.close();
                        $timeout(function () {
                            if (modalType === 'load') {
                                vm.fnOpenLoadModal();
                            }
                        }, 100)
                    }
                    $timeout(function () {
                        vm.isRefreshMdEditor = false;
                    })
                };

                vm.fnOpenLoadModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/workflowInfo/workflowTabs/worflowFlowView/modals/loadModal/loadModal.html',
                        size: 'lg',
                        controller: 'loadModalViewCtrl as loadModalView',
                        windowClass: 'modal-height100',
                        resolve: {
                            markdownOptionsObj: function () {
                                return vm.markedOptionObj
                            },
                            selectedStateObj: function () {
                                return vm.selectedStateObj
                            },
                            loadArr: function () {
                                return vm.loadArr
                            },
                            injectArr: function () {
                                return vm.injectArr
                            },
                            stashName: function () {
                                return vm.stashName
                            },
                            selectedStateName: function () {
                                return vm.selectedStateFigure.children.data[1].figure.children.data[0].figure.text;
                            },
                            selectedStateInputsArr: function () {
                                return vm.selectedStateInputsArr;
                            }

                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnActionIconSelected = function (type, userDataObj, stateFigure) {
                    vm.selectedStateFigure = stateFigure;
                    swal({
                        title: "Please wait while your data loads...",
                        type: "warning",
                        showConfirmButton: true,
                        showLoaderOnConfirm: true
                    });
                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                    angular.element(".confirm").css("visibility", "hidden");
                    if (!vm.selectedStateObj || (vm.selectedStateObj && vm.selectedStateObj.sudoId !== userDataObj.sudoId)) {
                        vm.fnGetSelectedStateInformation(userDataObj, true, true, type);
                    } else {
                        vm.fnGetSelectedStateInformation(userDataObj, false, true, type);
                    }
                };

                vm.fnGetSelectedStateInformation = function (userDataObj, isCalledForMdInfo, isCalledForModal, modalType) {
                    if (isCalledForMdInfo) {
                        vm.isStateMdInfoLoaded = false;
                    }
                    $timeout(function () {
                        vm.isRefreshMdEditor = true;
                        vm.isStateSelectedOnCanvas = true;
                        vm.stateInfoObj = null;
                        vm.selectedStateObj = userDataObj;
                        if (isCalledForMdInfo) {
                            StateFactory.getState({stateId: vm.selectedStateObj.id})
                                .then(function (response) {
                                    if (angular.isUndefined(response.info) || response.info === 'TODO') {
                                        vm.selectedStateObj.mdInfo = 'No Information';
                                    } else {
                                        // triggers Input Arr
                                        var triggersInputArr = FilterQueryService.fnGetWorkflowInputOutputInfo(response.inputs, vm.modelsObj, 'Input', true);
                                        vm.selectedStateInputsArr = angular.copy(triggersInputArr);
                                        var inputIndexArray = componentService.getUniqueIndexForTriggersModal(triggersInputArr);
                                        var inputTreeData = componentService.getHierarchyForTriggersModal(inputIndexArray, triggersInputArr);
                                        // triggers Output Arr
                                        var triggersOutputArr = FilterQueryService.fnGetWorkflowInputOutputInfo(response.outputs, vm.modelsObj, 'Output', true);
                                        var outputIndexArray = componentService.getUniqueIndexForTriggersModal(triggersOutputArr);
                                        var outputTreeData = componentService.getHierarchyForTriggersModal(outputIndexArray, triggersOutputArr);
                                        var tempMdInfo = $base64.decode(response.info);
                                        tempMdInfo = tempMdInfo.replace("<input-table>", fnCreateTreeView(inputTreeData));
                                        tempMdInfo = tempMdInfo.replace("<output-table>", fnCreateTreeView(outputTreeData));
                                        vm.selectedStateObj.mdInfo = tempMdInfo;
                                    }
                                    vm.fnSetConfigOptions(isCalledForModal, modalType);
                                }, function () {
                                    vm.selectedStateObj.mdInfo = 'No Information';
                                    vm.fnSetConfigOptions(isCalledForModal, modalType);
                                });
                        } else {
                            vm.fnSetConfigOptions(isCalledForModal, modalType);
                        }
                    })
                };

                vm.fnConnectorClick = function (connectorObj) {
                    if (angular.isDefined(vm.connectorExpressionObj[connectorObj.id])) {
                        vm.selectedConnectorObj = vm.connectorExpressionObj[connectorObj.id];
                    } else {
                        vm.selectedConnectorObj = connectorObj;
                    }
                    if (vm.selectedConnectorObj.userData && vm.selectedConnectorObj.userData.parameters && vm.selectedConnectorObj.userData.parameters.expression) {
                        vm.queryBuilder = vm.selectedConnectorObj.userData.parameters.expression;
                    } else {
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                    }
                    vm.isStateSelectedOnCanvas = false;
                    vm.selectedStateObj = {};
                    var modalInstanceForWorkflowTriggers = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/modals/connectorModal/connectorModal.html',
                        size: 'lg',
                        controller: 'connectorModalCtrl as connectorModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            connectorFieldExpArr: function () {
                                return [];
                            },
                            queryBuilder: function () {
                                return vm.queryBuilder;
                            },
                            selectedConnectorObj: function () {
                                return vm.selectedConnectorObj;
                            },
                            connectorExpressionObj: function () {
                                return vm.connectorExpressionObj;
                            },
                            isConnectorSaved: function () {
                                return true;
                            },
                            isReadOnly: function () {
                                return true;
                            }
                        }
                    });
                    modalInstanceForWorkflowTriggers.result.then(function () {
                    }, function () {
                    });
                };

                function fnCreateTreeView(workflowOutputsArr) {
                    var temp = '<ul class="tree">';
                    _.forEach(workflowOutputsArr, function (obj) {
                        temp = temp + '<li>' + (obj.index.includes('.') ? obj.index.split('.')[obj.index.split('.').length - 1] : obj.index) + ' ' + (obj.required === 'yes' ? '`(required)`' : '') + ' ' + (obj.type ? '`(' + obj.type + ')`' : '');
                        if (obj.children) {
                            temp = temp + '<ul>';
                            temp = temp + fnCreateChildrenTreeView(obj.children);
                        } else {
                            temp = temp + ' <br><div class="p-l-20">' + (obj.description ? obj.description : '') + '</div></li>';
                        }
                    });
                    return temp + '</ul></br>';
                }

                function fnCreateChildrenTreeView(objTree) {
                    var temp = '';
                    _.forEach(objTree, function (obj) {
                        temp = temp + '<li>' + (obj.index.includes('.') ? obj.index.split('.')[obj.index.split('.').length - 1] : obj.index) + ' ' + (obj.required === 'yes' ? '`(required)`' : '') + ' ' + (obj.type ? '`(' + obj.type + ')`' : '');
                        if (obj.children) {
                            temp = temp + '<ul>';
                            temp = temp + fnCreateChildrenTreeView(obj.children, temp);
                        } else {
                            temp = temp + ' <br><div class="p-l-20">' + (obj.description ? obj.description : '') + '</div></li>';
                        }
                    });
                    return temp + '</ul></li>';
                }

                vm.fnGetAppModels = function (count) {
                    var inputObj = {
                        appName: appArr[count]
                    };
                    ListenerFactory.getListenerModels(inputObj)
                        .then(function (response) {
                            vm.modelsObj[appArr[count]] = response;
                            count++;
                            if (count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        }, function () {
                            count++;
                            if (count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        })

                };

                vm.fnInitGetAppModels = function () {
                    vm.isListenerModelsLoading = true;
                    if (appCount < appArr.length) {
                        vm.fnGetAppModels(appCount);
                    } else {
                        vm.isListenerModelsLoading = false;
                    }
                };

                /* START:  Draw2d Canvas editor section*/
                var onInitCanvasListener = function (e) {
                    var userDataObj = e.detail;
                    if (userDataObj.category === "TRIGGER") {
                        vm.triggerCount = true;
                    }
                };

                var deleteSelectedStateListener = function (e) {
                    var userDataObj = e.detail;
                    if (vm.selectedStateObj && userDataObj.id === vm.selectedStateObj.id) {
                        vm.selectedStateObj = null;
                        vm.isStateSelectedOnCanvas = false;
                    }
                    if (userDataObj.category === "TRIGGER") {
                        vm.triggerCount = false;
                    }
                };

                var getSelectedActionViewListener = function (e) {
                    var type = e.detail.childFigure.cssClass.includes('inject-icon') ? 'inject' :
                        e.detail.childFigure.cssClass.includes('load-icon') ? 'load' :
                            e.detail.childFigure.cssClass.includes('stash-icon') ? 'stash' : '';
                    if (type.length) {
                        var userDataObj = e.detail.stateFigure.userData;
                        vm.fnActionIconSelected(type, userDataObj, e.detail.stateFigure);
                    }
                };

                var getSelectedStateListener = function (e) {
                    var userDataObj = e.detail.userData;
                    vm.fnGetSelectedStateInformation(userDataObj, true, false, '');
                };

                var getConnectionClickListener = function (e) {
                    var connector = e.detail;
                    vm.fnConnectorClick(connector)
                };

                document.addEventListener('onInitCanvas', onInitCanvasListener);
                document.addEventListener('deleteSelectedState', deleteSelectedStateListener);
                document.addEventListener('getSelectedActionView', getSelectedActionViewListener);
                document.addEventListener('getSelectedState', getSelectedStateListener);
                document.addEventListener('getConnectionClick', getConnectionClickListener);

                /*eslint-disable*/
                $scope.editor = {
                    /*eslint-enable*/
                    // Configuration of the editor
                    canvas: {
                        //Method to Get canvas in controller on Initialization
                        fnInit: function (canvas) {
                            vm.clonedCanvas = canvas;
                            $timeout(function () {
                                vm.fnInitWorkFlow();
                            })
                        },
                        jsonRead: function (canvas, jsonData) {
                            var reader = new draw2d.io.json.Reader();
                            reader.unmarshal(canvas, jsonData);
                        }
                    }
                };

                vm.fnCloneWorkFlow = function (workflowObj) {
                    vm.isCloneCompleted = false;
                    if (workflowObj.roles) {
                        delete workflowObj.roles;
                    }
                    var regexp = /^([A-Z|a-z|0-9`~!@#$%^&*()_|+\-=?;:' ",.<>\{\}\[\]\\\/]+)( - [1-9]+)$/;
                    var filterName = '';
                    if (regexp.test(workflowObj.name)) {
                        filterName = workflowObj.name.substring(0, workflowObj.name.lastIndexOf(" - "));
                    } else {
                        filterName = workflowObj.name;
                    }
                    var inputObj = {
                        perPage: 0,
                        filter: 'contains(#{name}, ${' + filterName + '})'
                    };
                    WorkflowFactory.getWorkflows(inputObj)
                        .then(function (res) { // Success block
                            vm.workFlowsArr = angular.copy(res);
                            var count = 0;
                            var filterName = '';
                            if (regexp.test(workflowObj.name)) {
                                filterName = workflowObj.name.substring(0, workflowObj.name.lastIndexOf(" - "));
                            } else {
                                filterName = workflowObj.name;
                            }
                            var index = 0;
                            _.forEach(vm.workFlowsArr, function (workFlowObj) {
                                if (regexp.test(workFlowObj.name)) {
                                    if (workFlowObj.name.substring(0, workFlowObj.name.lastIndexOf(" - ")) === filterName) {
                                        count++;
                                        var tempIndex = Number(workFlowObj.name.substring(workFlowObj.name.lastIndexOf(" - ") + 3, workFlowObj.name.length));
                                        if (tempIndex > index) {
                                            index = tempIndex
                                        }
                                    }
                                } else if (workFlowObj.name === filterName) {
                                    count++;
                                    index = index === 0 ? 1 : index;
                                }
                            });
                            index = count === 1 ? 1 : (index + 1);
                            workflowObj.name = count === 1 ? workflowObj.name + ' - 1' : filterName + ' - ' + index;
                            if (regexp.test(workflowObj.description)) {
                                workflowObj.description = workflowObj.description.substring(0, workflowObj.description.lastIndexOf(" - ")) + ' - ' + index;
                            } else {
                                workflowObj.description = count === 1 ? workflowObj.description + ' - 1' : workflowObj.description + ' - ' + index;
                            }
                            DB.fnSet("ClonedWorkFlowObj", angular.copy(workflowObj));
                            vm.isCloneCompleted = true;
                            $state.go("main.createWorkFlow");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                                vm.isCloneCompleted = true;
                            }
                        });
                };

                vm.fnInitWorkFlow = function () {
                    vm.fnInitGetAppModels();
                    vm.workflowPermissionObj = PermissionsService.getPermissions("pipeline:workflow");
                    WorkflowFactory.getWorkflow({workflowId: vm.workflowId})
                        .then(function (response) {
                            vm.workflowObj = response;
                            breadcrumbObjService.fnSetBreadcrumbObj({
                                "id": vm.workflowObj.name
                            });
                            StateFactory.getStates()
                                .then(function (response) {
                                    vm.statesArr = response;
                                    vm.isWorkflowLoaded = true;
                                }, function () {
                                    vm.isWorkflowLoaded = true;
                                });
                            if (vm.workflowObj) {
                                var newEvent = new CustomEvent(
                                    "callFromModelView", {
                                        detail: true
                                    }
                                );
                                document.dispatchEvent(newEvent);
                                $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.workflowObj.flow);
                            }
                        })
                };

                $scope.$on("$destroy", function () {
                    var newEvent = new CustomEvent(
                        "callFromModelView", {
                            detail: false
                        }
                    );
                    document.dispatchEvent(newEvent);
                    document.removeEventListener('onInitCanvas', onInitCanvasListener);
                    document.removeEventListener('deleteSelectedState', deleteSelectedStateListener);
                    document.removeEventListener('getSelectedActionView', getSelectedActionViewListener);
                    document.removeEventListener('getSelectedState', getSelectedStateListener);
                    document.removeEventListener('getConnectionClick', getConnectionClickListener);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('stateRenameModalCtrl',
            function ($uibModalInstance, stateName) {
                var vm = this;
                vm.stateName = stateName;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.stateName);
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('loadModalCtrl',
            function ($scope, swal, $timeout, $uibModal, $uibModalInstance, amaran, markdownOptionsObj, selectedStateObj, allStatesFromChoice,
                      loadArr, savedStashArr, componentService, flowJson, configureObj, injectArr, stashName, connectionsFromChoice, StateFactory, selectedStateName, selectedStateInputsArr) {
                var vm = this;
                vm.selectedStateInputsArr = angular.copy(selectedStateInputsArr);
                vm.isStructureCreating = true;
                vm.markdownOptionsObj = markdownOptionsObj;
                vm.selectedStateObj = selectedStateObj;
                vm.isConfigurationsSaved = true;
                vm.isStateInfoLoaded = false;
                vm.modalLoadArr = loadArr;
                vm.savedStashArr = savedStashArr;
                vm.allStatesFromChoice = allStatesFromChoice;
                vm.modalFlowJson = flowJson;
                vm.modalInjectArr = injectArr;
                vm.stateConfigureObj = configureObj;
                vm.inputsArr = [];
                vm.loadDetail = "Load results (complete or partial) from previously executed states that specified a `stash` value. The map key should be the destination path that the stashed data will be loaded to. e.g. `$.issue.title`. The corresponding map value is the stash name prefixed with a hash symbol `#` followed by the optional path to the field. e.g. `#stash-name.path.to.key`. The initial payload can be accessed using the reserved `#initial` stash name. If this value is not specified the output from the previous state is used.";
                vm.stashValue = stashName;
                vm.arrayIndex = null;
                vm.resetKvpPair = {};
                vm.selectedInputObj = '';
                vm.tabs = [{
                    title: 'Input',
                    tabIndex: 1,
                    visible: true,
                    templateUrl: ''
                }, {
                    title: 'Output',
                    tabIndex: 2,
                    visible: vm.selectedStateObj.type !== 'WAIT' && vm.selectedStateObj.type !== 'CHOICE',
                    templateUrl: ''
                }];

                vm.stateInputFieldArr = [];
                vm.selectedStateInputObj = {};
                vm.fnTabSelected = function (tab) {
                    vm.selectedTab = tab.tabIndex;
                };
                vm.isDisplayMappingInputs = true;
                /* Start inject */
                vm.isShowJsonMapView = false;

                /*MapJson: Start*/
                vm.kvpPair = {};
                /*MapJson: End*/

                /*End inject */
                vm.fnGetSelectedState = function () {
                    vm.isStateInfoLoaded = false;
                    var inputObj = {
                        stateId: vm.selectedStateObj.id
                    };

                    StateFactory.getState(inputObj)
                        .then(function (response) {
                            response.name = selectedStateName;
                            vm.stateObj = response;
                            vm.isStateInfoLoaded = true;
                        }, function () {
                            vm.isStateInfoLoaded = true;
                        });
                };

                vm.fnCancel = function () {
                    if (vm.isConfigurationsSaved === false) {
                        swal({
                                title: "Unsaved Changes!",
                                text: "You have unsaved changes. Would you like to save them?",
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "SAVE",
                                cancelButtonText: "DISCARD",
                                closeOnConfirm: true,
                                showLoaderOnConfirm: false
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    $timeout(function () {
                                        var tempArr = [vm.modalLoadArr, vm.modalInjectArr, vm.stashValue];
                                        $uibModalInstance.close(tempArr);
                                    })
                                } else {
                                    $uibModalInstance.dismiss('cancel');
                                }
                            });
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                };

                vm.fnSaveLoad = function () {
                    var flag = false;
                    var tempArr = [];
                    if (Object.keys(vm.stateConfigureObj).length) {
                        Object.keys(vm.stateConfigureObj).forEach(function (key) {
                            if (vm.stateConfigureObj[key].parameters && vm.stateConfigureObj[key].parameters.stash &&
                                key !== vm.selectedStateObj.sudoId) {
                                if (vm.stashValue === vm.stateConfigureObj[key].parameters.stash) {
                                    flag = true;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error("Stash name have already been saved in workflow. Please choose another one and try again.")
                        } else {
                            vm.modalLoadArr = [];
                            vm.modalInjectArr = [];
                            angular.forEach(vm.stateInputFieldArr, function (stateInputObj) {
                                if (stateInputObj.type === 'array') {
                                    angular.forEach(stateInputObj.inputGroups, function (inputGroupObj) {
                                        if (inputGroupObj.displayPath === "Custom") {
                                            vm.modalInjectArr.push({
                                                key: inputGroupObj.index,
                                                value: inputGroupObj.value,
                                                injectMap: inputGroupObj.injectMap,
                                                isJsonIndex: inputGroupObj.isJsonIndex,
                                                injectMapWith$: inputGroupObj.injectMapWith$
                                            })
                                        } else {
                                            vm.modalLoadArr.push({
                                                key: inputGroupObj.index,
                                                value: angular.copy(inputGroupObj.value)
                                            });
                                        }
                                    });
                                } else {
                                    if (stateInputObj.displayPath === "Custom") {
                                        vm.modalInjectArr.push({
                                            key: stateInputObj.keyIndex,
                                            value: stateInputObj.value,
                                            injectMap: stateInputObj.injectMap,
                                            isJsonIndex: stateInputObj.isJsonIndex,
                                            injectMapWith$: stateInputObj.injectMapWith$
                                        })
                                    } else {
                                        vm.modalLoadArr.push({
                                            key: stateInputObj.keyIndex,
                                            value: angular.copy(stateInputObj.value)
                                        });
                                    }
                                }
                            });
                            tempArr = [vm.modalLoadArr, vm.modalInjectArr, vm.stashValue];
                            $uibModalInstance.close(tempArr);
                        }
                    } else {
                        vm.modalLoadArr = [];
                        vm.modalInjectArr = [];
                        angular.forEach(vm.stateInputFieldArr, function (stateInputObj) {
                            if (stateInputObj.type === 'array') {
                                angular.forEach(stateInputObj.inputGroups, function (inputGroupObj) {
                                    if (inputGroupObj.displayPath === "Custom") {
                                        vm.modalInjectArr.push({
                                            key: inputGroupObj.keyIndex,
                                            value: inputGroupObj.value,
                                            injectMap: inputGroupObj.injectMap,
                                            isJsonIndex: inputGroupObj.isJsonIndex,
                                            injectMapWith$: inputGroupObj.injectMapWith$
                                        })
                                    } else {
                                        vm.modalLoadArr.push({
                                            key: inputGroupObj.keyIndex,
                                            value: angular.copy(inputGroupObj.value)
                                        });
                                    }
                                });
                            } else {
                                if (stateInputObj.displayPath === "Custom") {
                                    vm.modalInjectArr.push({
                                        key: stateInputObj.keyIndex,
                                        value: stateInputObj.value,
                                        injectMap: stateInputObj.injectMap,
                                        isJsonIndex: stateInputObj.isJsonIndex,
                                        injectMapWith$: stateInputObj.injectMapWith$
                                    })
                                } else {
                                    vm.modalLoadArr.push({
                                        key: stateInputObj.keyIndex,
                                        value: angular.copy(stateInputObj.value)
                                    });
                                }
                            }
                        });
                        tempArr = [vm.modalLoadArr, vm.modalInjectArr, vm.stashValue];
                        $uibModalInstance.close(tempArr);
                        //$uibModalInstance.close(vm.stashValue);
                    }
                };

                vm.oSource = null;
                vm.oTarget = null;
                vm.attArr = [];
                vm.kvpPathValue = '';

                vm.fnCreateId = function (val) {
                    return val.replace(/[`~!@#$%^&*()_|+\-=?;:' ",.<>\{\}\[\]\\\/]/gi, '');
                };

                vm.fnIndexName = function (val) {
                    return val.replace('$.', '').replace('*$.', '').replace(/[.]+/ig, " > ");
                };

                /* start : inject functions */

                vm.fnKvpPairChangeInject = function (inputObj, index) {
                    if (inputObj.value === " ") {
                        inputObj.injectMap = '';
                        inputObj.isJsonIndex = true;
                        inputObj.injectMapWith$ = '';
                        inputObj.value = '';
                        inputObj.displayValue = '';
                    }
                    vm.selectedStateInputObj = inputObj;
                    vm.fnShowInjectJsonMapView(inputObj, index);
                };

                vm.fnShowInjectJsonMapView = function (kvpPair, index) {
                    vm.kvpPair = angular.copy(kvpPair);
                    vm.resetKvpPair = angular.copy(kvpPair);
                    vm.arrayIndex = index;
                    vm.isShowJsonMapView = true;
                };

                vm.fnCancelJsonMapView = function () {
                    var isFindInput = _.find(vm.stateInputFieldArr, {keyIndex: vm.resetKvpPair.keyIndex});
                    if (isFindInput) {
                        if (isFindInput.type === 'array') {
                            if (vm.resetKvpPair.isJsonIndex) {
                                isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.resetKvpPair.value);
                                isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.resetKvpPair.value);
                            } else {
                                isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.resetKvpPair.injectMap);
                                isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.resetKvpPair.injectMap);
                            }
                        } else {
                            if (vm.resetKvpPair.isJsonIndex) {
                                isFindInput.value = angular.copy(vm.resetKvpPair.value);
                                isFindInput.displayValue = angular.copy(vm.resetKvpPair.value);
                            } else {
                                isFindInput.value = angular.copy(vm.resetKvpPair.injectMap);
                                isFindInput.displayValue = angular.copy(vm.resetKvpPair.injectMap);
                            }
                        }
                    }
                    vm.kvpPair = {};
                    vm.arrayIndex = null;
                    vm.isShowJsonMapView = false;
                };

                vm.fnInjectJsonMapView = function () {
                    if (vm.kvpPair) {
                        var isFindInput = _.find(vm.stateInputFieldArr, {keyIndex: vm.kvpPair.keyIndex});
                        if (isFindInput) {
                            if (isFindInput.type === 'array') {
                                if (vm.kvpPair.isJsonIndex) {
                                    isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.kvpPair.value);
                                    isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.kvpPair.value);
                                    isFindInput.inputGroups[vm.arrayIndex].displayPath = "Custom";
                                } else {
                                    isFindInput.inputGroups[vm.arrayIndex].value = angular.copy(vm.kvpPair.injectMap);
                                    isFindInput.inputGroups[vm.arrayIndex].displayValue = angular.copy(vm.kvpPair.injectMap);
                                    isFindInput.inputGroups[vm.arrayIndex].displayPath = "Custom";
                                }
                            } else {
                                if (vm.kvpPair.isJsonIndex) {
                                    isFindInput.value = angular.copy(vm.kvpPair.value);
                                    isFindInput.displayValue = angular.copy(vm.kvpPair.value);
                                    isFindInput.displayPath = "Custom";
                                } else {
                                    isFindInput.value = angular.copy(vm.kvpPair.injectMap);
                                    isFindInput.displayValue = angular.copy(vm.kvpPair.injectMap);
                                    isFindInput.displayPath = "Custom";
                                }
                            }
                            vm.fnCheckInputIsValid(isFindInput,false)
                        }
                    }
                    vm.kvpPair = {};
                    vm.resetKvpPair = {};
                    vm.arrayIndex = null;
                    vm.isShowJsonMapView = false;
                };

                vm.fnConvertObjectToFlatt = function (kvpPair) {
                    kvpPair.isJsonIndex = false;
                    if (kvpPair.value) {
                        if (isJson(kvpPair.value) &&
                            isNaN(parseFloat(kvpPair.value)) && !isFinite(kvpPair.value) &&
                            (kvpPair.value.trim() !== "true" && kvpPair.value.trim() !== "false" &&
                                kvpPair.value.trim() !== true && kvpPair.value.trim() !== false)) {
                            kvpPair.injectMapWith$ = {
                                $: {}
                            };
                            kvpPair.injectMapWith$.$ = angular.fromJson(kvpPair.value);
                            var tempObj = flatten(kvpPair.injectMapWith$);
                            var tempString = "";
                            kvpPair.injectMap = "";
                            Object.keys(tempObj).forEach(function (key) {
                                var tempArr = key.split(".");
                                var tempKeyString = "";
                                var tempIndex = "";
                                angular.forEach(tempArr, function (value) {
                                    if (!isNaN(value)) {
                                        tempIndex = "[" + value + "]";
                                        tempKeyString = tempKeyString + tempIndex;
                                    }
                                    else {
                                        tempKeyString === "" ? tempKeyString = value : tempKeyString = tempKeyString + "." + value //eslint-disable-line
                                        tempIndex = "";
                                    }
                                });
                                var newTempkey = tempKeyString;
                                tempString = "" ? tempString = newTempkey + "=" + tempObj[key] + ";\n" : tempString = tempString + newTempkey + "=" + tempObj[key] + ";\n"; //eslint-disable-line
                            });

                            kvpPair.injectMap = tempString;
                        } else {
                            kvpPair.injectMap = kvpPair.value;
                        }
                    } else {
                        kvpPair.injectMap = '';
                    }
                };

                vm.fnConvertFlattToObject = function (kvpPair, isCalledFromSave) {
                    if (!isCalledFromSave) {
                        kvpPair.isJsonIndex = true;
                    }
                    if (kvpPair.injectMap) {
                        if (kvpPair.injectMap.startsWith('$')) {
                            if (kvpPair.injectMap.includes(";")) {
                                var tempObj = {};
                                var tempArr = kvpPair.injectMap.split(';');
                                angular.forEach(tempArr, function (obj) {
                                    if (obj.includes("=")) {
                                        if (obj.split("=")[1].trim().replace(/["']/g, "") === "true" || obj.split("=")[1].trim().replace(/["']/g, "") === "false") {
                                            tempObj[obj.split("=")[0].trim()] = angular.fromJson(obj.split("=")[1].trim().replace(/["']/g, ""));
                                        }
                                        else {
                                            if (isNaN(obj.split("=")[1].trim().replace(/["']/g, ""))) {
                                                tempObj[obj.split("=")[0].trim()] = obj.split("=")[1].trim().replace(/["']/g, "");
                                            }
                                            else {
                                                tempObj[obj.split("=")[0].trim()] = parseInt(obj.split("=")[1].trim().replace(/["']/g, ""));
                                            }
                                        }
                                    }
                                });
                                kvpPair.value = angular.toJson(unflatten(tempObj).$, true);
                            } else {
                                kvpPair.value = kvpPair.injectMap;
                            }
                        } else {
                            kvpPair.value = kvpPair.injectMap;
                        }
                    } else {
                        kvpPair.value = '';
                    }
                };

                function unflatten(data) {
                    "use strict"; //eslint-disable-line
                    if (Object(data) !== data || angular.isArray(data)) {
                        return data;
                    }
                    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
                        resultholder = {};
                    /*eslint-disable*/
                    for (var p in data) {
                        var cur = resultholder,
                            prop = "",
                            m;
                        while (m = regex.exec(p)) {
                            cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
                            prop = m[2] || m[1];
                        }
                        cur[prop] = data[p];
                    }
                    /*eslint-enable*/
                    return resultholder[""] || resultholder;
                }

                function flatten(data) {
                    var result = {};

                    function recurse(cur, prop) {
                        if (Object(cur) !== cur) {
                            result[prop] = cur;
                        } else if (angular.isArray(cur)) {
                            for (var i = 0, l = cur.length; i < l; i++) {
                                recurse(cur[i], prop ? prop + "." + i : "" + i);
                            }
                            if (l === 0) {
                                result[prop] = [];
                            }
                        } else {
                            var isEmpty = true;
                            /*eslint-disable*/
                            for (var p in cur) {
                                isEmpty = false;
                                recurse(cur[p], prop ? prop + "." + p : p);
                            }
                            /*eslint-enable*/
                            if (isEmpty) {
                                result[prop] = {};
                            }
                        }
                    }

                    recurse(data, "");
                    return result;
                }

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.fnOpenArrayInputModal = function (inputFieldObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/createWorkFlow/modals/arrayInputModal/arrayInputModal.html',
                        size: 'md',
                        controller: 'ArrayInputModalCtrl as arrayInput',
                        resolve: {
                            selectedInput: function () {
                                return inputFieldObj;
                            },
                            savedLoadInputsArr: function () {
                                return vm.savedLoadInputsArr;
                            }
                        }
                    });
                    modalInstance.result.then(function (selectedInput) {
                        inputFieldObj.inputGroups = [];
                        _.forEach(selectedInput.inputGroups, function (obj) {
                            inputFieldObj.inputGroups.push(obj);
                        });
                    }, function () {

                    });
                };

                vm.fnAddNewInput = function (inputObj) {
                    var inputField = _.find(vm.stateInputFieldArr, {index: inputObj.index});
                    if (!inputField) {
                        var tempArr = inputObj.index.split("[");
                        if (inputObj.index && inputObj.index.includes("[") && !/^\d/.test(tempArr[1])) {
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/pipeline/workflows/modals/inputPrompt/inputPrompt.html',
                                size: 'md',
                                controller: 'inputPromptCtrl as inputPrompt',
                                resolve: {
                                    pathValue: function () {
                                        return inputObj.index;
                                    },
                                    forTarget: function () {
                                        return true;
                                    }
                                }
                            });
                            modalInstance.result.then(function (path) {
                                if (path && path.length) {
                                    var index = angular.copy(path);
                                    $timeout(function () {
                                        var tempObj = _.find(vm.stateInputFieldArr, {'index': index});
                                        if (!tempObj) {
                                            var newInputObj = {
                                                description: inputObj.description,
                                                displayName: vm.fnIndexName(index).replace('*', ''),
                                                index: index,
                                                isDisplay: false,
                                                keyIndex: index,
                                                required: "no",
                                                type: inputObj.type ? inputObj.type : "string"
                                            };
                                            vm.stateInputFieldArr.push(angular.copy(newInputObj));
                                            vm.selectedStateInputsArr.push(angular.copy(newInputObj));
                                        } else {
                                            amaran.error("Input already exists.")
                                        }
                                        vm.selectedInputObj = '';
                                    })
                                }
                            }, function () {
                                inputObj.displayValue = '';
                            });
                        } else {
                            if (inputObj.type && inputObj.type === 'array') {
                                inputObj.inputGroups = [];
                                inputObj.inputGroups.push({
                                    description: inputObj.description,
                                    displayName: inputObj.index.includes('.') ? inputObj.index.split('.')[inputObj.index.split('.').length - 1] : inputObj.index,
                                    displayPath: "",
                                    displayValue: "",
                                    index: inputObj.index + "[" + 0 + "]",
                                    keyIndex: inputObj.index,
                                    value: "",
                                    required: "no",
                                    type: "string"
                                });
                            }
                            if (inputObj.required && inputObj.required === "yes") {
                                inputObj.isDisplay = false;
                                vm.stateInputFieldArr.unshift(angular.copy(inputObj));
                            } else {
                                inputObj.isDisplay = false;
                                vm.stateInputFieldArr.push(angular.copy(inputObj));
                            }
                            vm.selectedInputObj = '';
                            vm.isDisplayMappingInputs = vm.isDisplayMappingInput();
                        }
                    }
                };

                vm.fnRemoveInputField = function (inputFieldObj, index) {
                    var isFindInput = _.find(vm.selectedStateInputsArr, {keyIndex: inputFieldObj.keyIndex});
                    if (isFindInput) {
                        isFindInput.isDisplay = true;
                    }
                    vm.stateInputFieldArr.splice(index, 1);
                    vm.isDisplayMappingInputs = vm.isDisplayMappingInput();
                };

                vm.fnLoadValueSelected = function (inputObj, index) {
                    if (inputObj.displayValue === "New Static Input") {
                        /*if (angular.isUndefined(inputObj.displayPath)) {
                            inputObj.displayPath = "Custom";
                        }*/
                        inputObj.displayValue = " ";
                        inputObj.value = angular.copy(inputObj.displayValue);
                        $timeout(function () {
                            vm.fnKvpPairChangeInject(inputObj, index);
                        });
                    } else {
                        var tempArr = inputObj.displayValue.split("[");
                        if (inputObj.displayValue && inputObj.displayValue.includes("[") && !/^\d/.test(tempArr[1])) {
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/pipeline/workflows/modals/inputPrompt/inputPrompt.html',
                                size: 'md',
                                controller: 'inputPromptCtrl as inputPrompt',
                                resolve: {
                                    pathValue: function () {
                                        return inputObj.displayValue;
                                    },
                                    forTarget: function () {
                                        return false;
                                    }
                                }
                            });
                            modalInstance.result.then(function (path) {
                                if (path && path.length) {
                                    var index = angular.copy(path);
                                    var tempObj = _.find(vm.savedLoadInputsArr, {'index': index});
                                    $timeout(function () {
                                        if (!tempObj) {
                                            vm.newSavedStashArr.push({
                                                'index': index,
                                                'keyIndex': index
                                            });
                                            var savedStashUniqArr = componentService.getUniqueIndexForTriggersModal(angular.copy(vm.newSavedStashArr));
                                            vm.stateloadUiqIndexArr = angular.copy(savedStashUniqArr);
                                            vm.savedLoadInputsArr = [];
                                            _.forEach(savedStashUniqArr, function (index) {
                                                vm.savedLoadInputsArr.push({
                                                    'index': index,
                                                    'keyIndex': index
                                                })
                                            });
                                            vm.savedLoadInputsArr.unshift({
                                                'index': "New Static Input",
                                                'keyIndex': "New Static Input",
                                                'isClickAble': true
                                            });
                                            inputObj.value = angular.copy(index);
                                            $timeout(function () {
                                                var id = ".";
                                                inputObj.displayValue = inputObj.value.includes(id) ? inputObj.value.split('.')[inputObj.value.split('.').length - 1] : inputObj.value;
                                                inputObj.displayPath = inputObj.value.includes(id) ? inputObj.value.slice(0, inputObj.value.lastIndexOf(".")) : inputObj.value;
                                            });
                                        }
                                    })
                                }
                            }, function () {
                                inputObj.displayValue = '';
                            });
                        } else {
                            inputObj.value = angular.copy(inputObj.displayValue);
                            $timeout(function () {
                                var id = ".";
                                inputObj.displayValue = inputObj.value.includes(id) ? inputObj.value.split('.')[inputObj.value.split('.').length - 1] : inputObj.value;
                                inputObj.displayPath = inputObj.value.includes(id) ? inputObj.value.slice(0, inputObj.value.lastIndexOf(".")) : inputObj.value;
                            });
                        }
                        vm.fnCheckInputIsValid(inputObj, true);
                    }
                };

                vm.fnLoadInputOnBlur = function (inputObj, index) {
                    if (angular.isDefined(inputObj.displayValue) && inputObj.displayValue !== '' && inputObj.displayPath === '') {
                        var isFindValue = _.find(vm.savedLoadInputsArr, {index: inputObj.displayValue});
                        if (isFindValue) {
                            vm.fnLoadValueSelected(inputObj, index);
                        } else {
                            if (angular.isUndefined(inputObj.displayPath)) {
                                inputObj.displayPath = "Custom";
                            } else {
                                inputObj.displayPath = "Custom";
                            }
                            inputObj.displayValue = angular.copy(inputObj.displayValue);
                            inputObj.value = angular.copy(inputObj.displayValue);
                            inputObj.injectMap = '';
                            inputObj.isJsonIndex = true;
                            inputObj.injectMapWith$ = '';
                            vm.fnCheckInputIsValid(inputObj, false);
                        }
                    }
                };

                vm.fnCheckInputIsValid = function (inputObj, isLoadMapping) {
                    if (isLoadMapping) {
                        var searchArr = _.filter(vm.savedLoadInputsArr, function (savedInputObj) {
                            if (savedInputObj.keyIndex.toLowerCase().includes(inputObj.value + '.'.toLowerCase())) {
                                return savedInputObj;
                            }
                        });
                        inputObj.isValidInput = searchArr.length === 0;
                    } else {
                        if (inputObj.type === 'boolean') {
                            inputObj.isValidInput = inputObj.value === 'true' || inputObj.value === true || inputObj.value === 'false' || inputObj.value === false;
                        } else if (inputObj.type === 'number' || inputObj.type === 'integer') {
                            inputObj.isValidInput = !isNaN(inputObj.value);
                        } else if (inputObj.type === 'string') {
                            inputObj.isValidInput = !isJson(inputObj.value);
                        }
                    }
                };
                vm.fnOpenInputInfo = function (inputObj) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/createWorkFlow/modals/inputInfoModal/inputInfoModal.html',
                        size: 'md',
                        controller: 'InputInfoModalCtrl as inputInfoModal',
                        resolve: {
                            inputObj: function () {
                                return inputObj;
                            }
                        }
                    })
                };

                vm.fnChangeInputStateType = function () {
                    if (vm.selectedStateInputObj.displayPath && vm.selectedStateInputObj.displayPath === "Custom") {
                        vm.selectedStateInputObj.displayPath = "";
                        vm.selectedStateInputObj.displayValue = "";
                        vm.selectedStateInputObj.value = "";
                        vm.selectedStateInputObj.isValidInput = false;
                        delete vm.selectedStateInputObj.injectMap;
                        delete vm.selectedStateInputObj.isJsonIndex;
                        delete vm.selectedStateInputObj.injectMapWith$;
                    }
                    vm.selectedStateInputObj = {};
                    vm.kvpPair = {};
                    vm.resetKvpPair = {};
                    vm.arrayIndex = null;
                    vm.isShowJsonMapView = false;
                };

                vm.fnCreateNewStateInput = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/createWorkFlow/modals/addNewInputModal/addNewInputModal.html',
                        size: 'md',
                        controller: 'AddNewInputModalCtrl as newInputModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedStateInputsArr: function () {
                                return vm.selectedStateInputsArr;
                            },
                            inputIndexArray: function () {
                                return vm.inputIndexArray;
                            },
                            savedLoadInputsArr: function () {
                                return vm.savedLoadInputsArr;
                            },
                            stateLoadUiqIndexArr: function () {
                                return vm.stateloadUiqIndexArr;
                            }
                        }
                    });
                    modalInstance.result.then(function (resObj) {
                        vm.selectedStateInputsArr = resObj[0];
                        vm.savedLoadInputsArr = resObj[1];
                        vm.isDisplayMappingInputs = vm.isDisplayMappingInput();
                    }, function () {
                        vm.isDisplayMappingInputs = vm.isDisplayMappingInput();
                    });
                };

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                vm.fnAddNewEntry = function (inputObj) {
                    inputObj.inputGroups.push({
                        description: inputObj.description,
                        displayName: inputObj.index.includes('.') ? inputObj.index.split('.')[inputObj.index.split('.').length - 1] : inputObj.index,
                        displayPath: "",
                        displayValue: "",
                        index: inputObj.index + "[" + inputObj.inputGroups.length + "]",
                        keyIndex: inputObj.index,
                        value: "",
                        required: "no",
                        type: "string"
                    });
                };

                vm.fnRemoveArrayEntry = function (inputFieldObj, inputGroups, index, parentIndex) {
                    if (inputGroups.length === 1) {
                        vm.fnRemoveInputField(inputFieldObj, parentIndex);
                    } else {
                        inputGroups.splice(index, 1);
                        _.forEach(inputGroups, function (value, key) {
                            inputGroups.index = inputFieldObj.index + "[" + key + "]";
                        })
                    }

                };

                vm.ordinal_suffix_of = function (i) {
                    var j = i % 10,
                        k = i % 100;
                    if (j === 1 && k !== 11) {
                        return i + "st";
                    }
                    if (j === 2 && k !== 12) {
                        return i + "nd";
                    }
                    if (j === 3 && k !== 13) {
                        return i + "rd";
                    }
                    return i + "th";
                };

                vm.fnCreateArrayInputs = function (arrayModalType, modalObj) {
                    var startPoint = modalObj.key.lastIndexOf("[");
                    var lastPoint = modalObj.key.lastIndexOf("]");
                    var value = modalObj.key.substring(startPoint + 1, lastPoint);
                    var key = modalObj.key.substring(0, startPoint);
                    var isFindKey = _.find(vm.selectedStateInputsArr, {keyIndex: key});
                    if (isFindKey && isFindKey.type === "array") {
                        if (arrayModalType === 'Load') {
                            if (angular.isDefined(isFindKey.inputGroups)) {
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayValue: modalObj.value.includes('.') ? modalObj.value.split('.')[modalObj.value.split('.').length - 1] : modalObj.value,
                                    displayPath: modalObj.value.includes('.') ? modalObj.value.slice(0, modalObj.value.lastIndexOf(".")) : modalObj.value,
                                    value: modalObj.value
                                };
                            } else {
                                isFindKey.inputGroups = [];
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayValue: modalObj.value.includes('.') ? modalObj.value.split('.')[modalObj.value.split('.').length - 1] : modalObj.value,
                                    displayPath: modalObj.value.includes('.') ? modalObj.value.slice(0, modalObj.value.lastIndexOf(".")) : modalObj.value,
                                    value: modalObj.value
                                };
                            }
                        } else {
                            if (angular.isDefined(isFindKey.inputGroups)) {
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayPath: "Custom",
                                    displayValue: modalObj.value,
                                    value: modalObj.value,
                                    injectMap: '',
                                    isJsonIndex: true,
                                    injectMapWith$: ''
                                };
                            } else {
                                isFindKey.inputGroups = [];
                                isFindKey.inputGroups[value] = {
                                    description: isFindKey.description,
                                    displayName: isFindKey.index.includes('.') ? isFindKey.index.split('.')[isFindKey.index.split('.').length - 1] : isFindKey.index,
                                    index: modalObj.key,
                                    keyIndex: isFindKey.index,
                                    required: "no",
                                    type: "string",
                                    displayPath: "Custom",
                                    displayValue: modalObj.value,
                                    value: modalObj.value,
                                    injectMap: '',
                                    isJsonIndex: true,
                                    injectMapWith$: ''
                                };
                            }
                        }
                        isFindKey.isDisplay = false;
                        var isRefFind = _.find(vm.stateInputFieldArr, {keyIndex: isFindKey.keyIndex});
                        if (!isRefFind) {
                            vm.stateInputFieldArr.push(isFindKey);
                        } else {
                            isRefFind.inputGroups[value] = isFindKey.inputGroups[value];
                        }
                    }
                };

                vm.isObjectEmpty = function (obj) {
                    if (angular.isUndefined(obj)) {
                        return true;
                    } else {
                        return Object.keys(obj).length === 0;
                    }
                };

                vm.isDisplayMappingInput = function () {
                    var count = 0;
                    _.forEach(vm.selectedStateInputsArr, function (selectedStateInputObj) {
                        if (selectedStateInputObj.isDisplay === true) {
                            count = count + 1;
                        }
                    });
                    return count !== 0;
                };

                vm.fnCreateNewStateInputObj = function (input, id) {
                    var inputField, newKeyIndex;
                    if (angular.isObject(input)) {
                        inputField = _.find(vm.stateInputFieldArr, {index: input.index});
                        if (!inputField) {
                            var isSelectedFindInput = _.find(vm.selectedStateInputsArr, {keyIndex: input.index});
                            if (isSelectedFindInput) {
                                vm.fnAddNewInput(isSelectedFindInput);
                            }
                        }
                    } else {
                        if (input.length && input !== '') {
                            var newTempString = input.split(' > ').join('.');
                            inputField = _.find(vm.stateInputFieldArr, {index: '$.' + newTempString});
                            if (!inputField) {
                                var isFindInput = _.find(vm.selectedStateInputsArr, {keyIndex: '$.' + newTempString});
                                if (isFindInput) {
                                    vm.fnAddNewInput(isFindInput);
                                } else {
                                    newKeyIndex = '$.' + newTempString.split(' ').join('');
                                    var newInputObj = {
                                        description: '',
                                        displayName: vm.fnIndexName(newKeyIndex).replace('*', ''),
                                        index: newKeyIndex,
                                        isDisplay: false,
                                        keyIndex: newKeyIndex,
                                        required: "no",
                                        type: "string"
                                    };
                                    vm.stateInputFieldArr.push(angular.copy(newInputObj));
                                    vm.selectedStateInputsArr.push(angular.copy(newInputObj));
                                }
                            }
                        }
                    }
                    vm.selectedInputObj = '';
                    angular.element("#" + id).blur();
                };

                /* end : inject functions */
                vm.fnInitLoadModal = function () {
                    vm.fnGetSelectedState();
                    $timeout(function () {
                        vm.newSavedStashArr = [];
                        if (vm.selectedStateObj.type === "CHOICE" && vm.modalFlowJson.length && connectionsFromChoice.data.length) {
                            if (!vm.allStatesFromChoice[vm.selectedStateObj.sudoId]) {
                                vm.allStatesFromChoice[vm.selectedStateObj.sudoId] = {};
                            }
                            angular.forEach(connectionsFromChoice.data, function (connectionObj) {
                                if (connectionObj.sourcePort.parent.userData.sudoId === vm.selectedStateObj.sudoId) {
                                    vm.allStatesFromChoice[vm.selectedStateObj.sudoId][connectionObj.targetPort.parent.userData.name] = connectionObj.targetPort.parent.userData.id;
                                    if (vm.savedStashArr.indexOf(connectionObj.targetPort.parent.userData.name) === -1) {
                                        vm.savedStashArr.push(connectionObj.targetPort.parent.userData.name);
                                    }
                                }
                            })
                        }
                        _.forEach(vm.savedStashArr, function (obj) {
                            vm.newSavedStashArr.push({'index': obj, 'keyIndex': obj});
                        });
                        if (vm.modalLoadArr.length) {
                            _.forEach(vm.modalLoadArr, function (obj) {
                                if (obj.value !== '') {
                                    vm.newSavedStashArr.push({
                                        'index': obj.value,
                                        'keyIndex': obj.value
                                    });
                                }
                            });
                        }
                        var savedStashUniqArr = componentService.getUniqueIndexForTriggersModal(angular.copy(vm.newSavedStashArr));
                        vm.stateloadUiqIndexArr = angular.copy(savedStashUniqArr);
                        vm.savedLoadInputsArr = [];
                        _.forEach(savedStashUniqArr, function (index) {
                            vm.savedLoadInputsArr.push({
                                'index': index,
                                'keyIndex': index
                            })
                        });
                        vm.savedLoadInputsArr.unshift({
                            'index': "New Static Input",
                            'keyIndex': "New Static Input"
                        });
                        vm.inputsArr = angular.copy(vm.selectedStateObj.inputs);
                        vm.newInputsArr = [];
                        _.forEach(vm.inputsArr, function (obj) {
                            vm.newInputsArr.push({'index': obj, 'keyIndex': obj});
                        });
                        _.forEach(vm.modalLoadArr, function (loadObj) {
                            var tempIndex = _.findIndex(vm.newInputsArr, function (inputObj) {
                                return inputObj.index === loadObj.key || inputObj.index === "*" + loadObj.key
                            });
                            if (tempIndex === -1 && loadObj.key.length) {
                                var tokens = loadObj.key.split(".");
                                var result = "*" + tokens[0] + "." + tokens[1];
                                var hasObject = undefined;
                                _.forEach(vm.newInputsArr, function (objLoad) {
                                    if (objLoad.index.startsWith(result)) {
                                        hasObject = objLoad;
                                    }
                                });
                                if (!hasObject) {
                                    vm.newInputsArr.push({'index': loadObj.key, 'keyIndex': loadObj.key});
                                } else {
                                    vm.newInputsArr.push({'index': "*" + loadObj.key, 'keyIndex': "*" + loadObj.key});
                                }
                            }
                        });
                        _.forEach(vm.modalInjectArr, function (injectObj) {
                            var tempIndex = _.findIndex(vm.newInputsArr, function (inputObj) {
                                return inputObj.index === injectObj.key || inputObj.index === "*" + injectObj.key
                            });
                            if (tempIndex === -1 && injectObj.key.length) {
                                var tokens = injectObj.key.split(".");
                                var result = "*" + tokens[0] + "." + tokens[1];
                                var hasObject = undefined;
                                _.forEach(vm.newInputsArr, function (objInject) {
                                    if (objInject.index.startsWith(result)) {
                                        hasObject = objInject;
                                    }
                                });
                                if (!hasObject) {
                                    vm.newInputsArr.push({'index': injectObj.key, 'keyIndex': injectObj.key});
                                } else {
                                    vm.newInputsArr.push({
                                        'index': "*" + injectObj.key,
                                        'keyIndex': "*" + injectObj.key
                                    });
                                }
                            }
                        });
                        _.forEach(vm.newInputsArr, function (inputObj) {
                            inputObj.displayName = vm.fnIndexName(inputObj.index).replace('*', '')
                        });
                        _.forEach(vm.selectedStateInputsArr, function (selectedStateObj) {
                            selectedStateObj.index = selectedStateObj.keyIndex;
                            selectedStateObj.displayName = vm.fnIndexName(selectedStateObj.keyIndex).replace('*', '');
                            selectedStateObj.isDisplay = true;
                            if (selectedStateObj.required && selectedStateObj.required === "yes") {
                                selectedStateObj.isDisplay = false;
                                if (selectedStateObj.type === 'array') {
                                    selectedStateObj.inputGroups = [];
                                    selectedStateObj.inputGroups.push({
                                        description: selectedStateObj.description,
                                        displayName: selectedStateObj.index.includes('.') ? selectedStateObj.index.split('.')[selectedStateObj.index.split('.').length - 1] : selectedStateObj.index,
                                        displayPath: "",
                                        displayValue: "",
                                        index: selectedStateObj.index + "[" + 0 + "]",
                                        keyIndex: selectedStateObj.index,
                                        value: "",
                                        required: "no",
                                        type: "string"
                                    });
                                }
                                vm.stateInputFieldArr.unshift(angular.copy(selectedStateObj));
                            }
                        });
                        _.forEach(vm.modalLoadArr, function (modalLoadObj) {
                            if (modalLoadObj.key !== '' && modalLoadObj.value !== '') {
                                var isFind = _.find(vm.selectedStateInputsArr, {keyIndex: modalLoadObj.key});
                                if (isFind) {
                                    isFind.isDisplay = false;
                                    var tempObj = angular.copy(isFind);
                                    tempObj.value = modalLoadObj.value;
                                    if (tempObj.required && tempObj.required === "yes") {
                                        _.forEach(vm.stateInputFieldArr, function (obj) {
                                            if (obj.keyIndex === tempObj.keyIndex) {
                                                if (obj.type === 'array') {
                                                    vm.fnCreateArrayInputs('Load', modalLoadObj);
                                                } else {
                                                    obj.displayValue = tempObj.value.includes('.') ? tempObj.value.split('.')[tempObj.value.split('.').length - 1] : tempObj.value;
                                                    obj.displayPath = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                                    obj.value = tempObj.value;
                                                }
                                            }
                                        });
                                    } else {
                                        if (tempObj.type === 'array') {
                                            vm.fnCreateArrayInputs('Load', modalLoadObj);
                                        } else {
                                            tempObj.displayValue = tempObj.value.includes('.') ? tempObj.value.split('.')[tempObj.value.split('.').length - 1] : tempObj.value;
                                            tempObj.displayPath = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                        }
                                        vm.stateInputFieldArr.push(tempObj);
                                    }
                                } else {
                                    var regexp = /\[[0-9]+\]$/;
                                    if (regexp.test(modalLoadObj.key)) {
                                        vm.fnCreateArrayInputs('Load', modalLoadObj);
                                    } else {
                                        var newInputObj = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalLoadObj.key).replace('*', ''),
                                            index: modalLoadObj.key,
                                            isDisplay: false,
                                            keyIndex: modalLoadObj.key,
                                            required: "no",
                                            type: "string"
                                        };
                                        var newStateInputField = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalLoadObj.key).replace('*', ''),
                                            index: modalLoadObj.key,
                                            isDisplay: false,
                                            keyIndex: modalLoadObj.key,
                                            required: "no",
                                            type: "string",
                                            displayValue: modalLoadObj.value.includes('.') ? modalLoadObj.value.split('.')[modalLoadObj.value.split('.').length - 1] : modalLoadObj.value,
                                            displayPath: modalLoadObj.value.includes('.') ? modalLoadObj.value.slice(0, modalLoadObj.value.lastIndexOf(".")) : modalLoadObj.value,
                                            value: modalLoadObj.value
                                        };
                                        vm.selectedStateInputsArr.push(newInputObj);
                                        vm.stateInputFieldArr.push(newStateInputField);
                                    }
                                }
                            }
                        });
                        _.forEach(vm.modalInjectArr, function (modalInjectObj) {
                            if (modalInjectObj.key !== '' && modalInjectObj.value !== '') {
                                var isFind = _.find(vm.selectedStateInputsArr, {keyIndex: modalInjectObj.key});
                                if (isFind) {
                                    isFind.isDisplay = false;
                                    var tempObj = angular.copy(isFind);
                                    tempObj.displayPath = "Custom";
                                    tempObj.displayValue = modalInjectObj.value;
                                    tempObj.value = modalInjectObj.value;
                                    tempObj.injectMap = modalInjectObj.injectMap ? modalInjectObj.injectMap : '';
                                    tempObj.isJsonIndex = modalInjectObj.isJsonIndex ? modalInjectObj.isJsonIndex : true;
                                    tempObj.injectMapWith$ = modalInjectObj.injectMapWith$ ? modalInjectObj.injectMapWith$ : '';
                                    if (tempObj.required && tempObj.required === "yes") {
                                        _.forEach(vm.stateInputFieldArr, function (obj) {
                                            if (obj.keyIndex === tempObj.keyIndex) {
                                                if (obj.type === 'array') {
                                                    vm.fnCreateArrayInputs('Load', modalInjectObj);
                                                } else {
                                                    obj.displayPath = tempObj.displayPath;
                                                    obj.displayValue = tempObj.value.includes('.') ? tempObj.value.slice(0, tempObj.value.lastIndexOf(".")) : tempObj.value;
                                                    obj.value = tempObj.value;
                                                    obj.injectMap = tempObj.injectMap;
                                                    obj.isJsonIndex = tempObj.isJsonIndex;
                                                    obj.injectMapWith$ = tempObj.injectMapWith$;
                                                }
                                            }
                                        });
                                    } else {
                                        vm.stateInputFieldArr.push(tempObj);
                                    }
                                } else {
                                    var regexp = /\[[0-9]+\]$/;
                                    if (regexp.test(modalInjectObj.key)) {
                                        vm.fnCreateArrayInputs('Inject', modalInjectObj);
                                    } else {
                                        var newInputObj = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalInjectObj.key).replace('*', ''),
                                            index: modalInjectObj.key,
                                            isDisplay: false,
                                            keyIndex: modalInjectObj.key,
                                            required: "no",
                                            type: "string"
                                        };
                                        var newStateInputField = {
                                            description: "",
                                            displayName: vm.fnIndexName(modalInjectObj.key).replace('*', ''),
                                            index: modalInjectObj.key,
                                            isDisplay: false,
                                            keyIndex: modalInjectObj.key,
                                            required: "no",
                                            type: "string",
                                            displayPath: "Custom",
                                            displayValue: modalInjectObj.value,
                                            value: modalInjectObj.value,
                                            injectMap: '',
                                            isJsonIndex: true,
                                            injectMapWith$: ''
                                        };
                                        vm.selectedStateInputsArr.push(newInputObj);
                                        vm.stateInputFieldArr.push(newStateInputField);
                                    }
                                }
                            }
                        });

                        vm.selectedInputObj = '';
                        vm.inputIndexArray = componentService.getUniqueIndexForTriggersModal(vm.selectedStateInputsArr);
                        vm.savedStashNameArr = [];
                        if (Object.keys(vm.stateConfigureObj).length) {
                            Object.keys(vm.stateConfigureObj).forEach(function (key) {
                                if (vm.stateConfigureObj[key].sudoId !== vm.selectedStateObj.sudoId) {
                                    if (vm.stateConfigureObj[key].parameters && vm.stateConfigureObj[key].parameters.stash) {
                                        vm.savedStashNameArr.push(vm.stateConfigureObj[key].parameters.stash);
                                    }
                                }
                            });
                        }
                        /*output model tree-view*/
                        vm.newOutputsArr = [];
                        _.forEach(vm.selectedStateObj.outputs, function (obj) {
                            vm.newOutputsArr.push({'index': obj, 'keyIndex': obj});
                        });
                        var outputUniqArr = componentService.getUniqueIndexForTriggersModal(vm.newOutputsArr);
                        var outputNestedData = componentService.getHierarchyForTriggersModal(outputUniqArr, vm.newOutputsArr);
                        vm.nestedOutputArr = angular.copy(outputNestedData);
                        //fnCreateStructure(true);
                        $timeout(function () {
                            vm.isStructureCreating = false;
                            vm.isDisplayMappingInputs = vm.isDisplayMappingInput();
                        }, 100)
                    }, 500)
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InputInfoModalCtrl',
            function ($uibModalInstance, inputObj) {
                var vm = this;

                vm.inputObj = inputObj;
                vm.fnIndexName = function (val) {
                    return val.replace('$.','').replace('*$.','').replace(/[.]+/ig, " > ");
                };

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InputTypeInfoCtrl',
            function ($uibModalInstance) {
                var vm = this;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('existingWorkflowFlowModalCtrl',
            function ($scope, $uibModalInstance, workflowHierarchy, currntStateId, isCalledFromAddBranch, ColorService) {
                var vm = this;
                vm.flowObj = workflowHierarchy;
                vm.cId = angular.copy(currntStateId);
                vm.isCalledFromAddBranch = angular.copy(isCalledFromAddBranch);
                vm.fnGetPanelHeadingCss = function (color) {
                    return ColorService.getDark(color, 15);
                };

                vm.fnGetInjectButtonCss = function (workflowHierarchyObj) {
                    return {
                        color: ColorService.getContrastTextColor(workflowHierarchyObj.color),
                        background: 'transparent',
                        border: '1px solid'
                    };
                };

                vm.fnInjectState = function (workflowHierarchyObj) {
                    $uibModalInstance.close(angular.copy(workflowHierarchyObj));
                };


                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitWorkflowFlowModal = function () {
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('errorFlowOptionsCtrl',
            function ($timeout, $uibModalInstance, tabsArr, stateName, errorFlowStyle) {
                var vm = this;
                vm.selectedDraft = null;
                vm.isClosedClicked = false;
                vm.isOpenClicked = false;
                vm.isAddExistingErrorFlow = false;
                vm.tabsArr = tabsArr;
                vm.stateName = stateName;
                vm.errorFlowStyle = errorFlowStyle;
                vm.fnAddNewErrorFlow = function () {
                    var data = {type: "Add New Error Flow"};
                    $uibModalInstance.close(data);
                };

                vm.fnAddExistingErrorFlow = function () {
                    vm.isAddExistingErrorFlow = true;
                };

                vm.fnInjectErrorFlow = function (obj) {
                    var data = {type: "Add Existing Error Flow", data: obj};
                    $uibModalInstance.close(data);
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };


                vm.fnInitModal = function () {
                    vm.draftsArr = [];
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ArrayInputModalCtrl',
            function ($uibModalInstance, $timeout, selectedInput, savedLoadInputsArr) {
                var vm = this;
                vm.selectedInput = angular.copy(selectedInput);
                vm.savedLoadInputsArr = angular.copy(savedLoadInputsArr);
                vm.isArrayCreating = false;
                vm.isInputBadlyFormatted = false;
                vm.txtSpec = '';
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/ld+json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    autofocus: false,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCheckInput = function () {
                    if (isJson(vm.txtSpec)) {
                        vm.isInputBadlyFormatted = angular.isArray(angular.fromJson(vm.txtSpec));
                    } else {
                        vm.isInputBadlyFormatted = false;
                    }
                };

                vm.fnSave = function () {
                    vm.isArrayCreating = true;
                    var tempArr = angular.copy(angular.fromJson(vm.txtSpec));
                    if (angular.isUndefined(vm.selectedInput.inputGroups)) {
                        vm.selectedInput.inputGroups = [];
                    } else {
                        vm.selectedInput.inputGroups = [];
                    }
                    _.forEach(tempArr, function (arrValue) {
                        if (isJson(arrValue)) {
                            vm.selectedInput.inputGroups.push({
                                description: vm.selectedInput.description,
                                displayName: vm.selectedInput.index.includes('.') ? vm.selectedInput.index.split('.')[vm.selectedInput.index.split('.').length - 1] : vm.selectedInput.index,
                                displayPath: "Custom",
                                displayValue: arrValue,
                                index: vm.selectedInput.index + "[" + vm.selectedInput.inputGroups.length + "]",
                                keyIndex: vm.selectedInput.index,
                                value: arrValue,
                                required: "no",
                                type: "string",
                                injectMap: '',
                                isJsonIndex: true,
                                injectMapWith$: ''
                            });
                        } else {
                            var isFindValue = _.find(vm.savedLoadInputsArr, {keyIndex: arrValue});
                            if (!isFindValue) {
                                vm.selectedInput.inputGroups.push({
                                    description: vm.selectedInput.description,
                                    displayName: vm.selectedInput.index.includes('.') ? vm.selectedInput.index.split('.')[vm.selectedInput.index.split('.').length - 1] : vm.selectedInput.index,
                                    displayPath: "Custom",
                                    displayValue: arrValue,
                                    index: vm.selectedInput.index + "[" + vm.selectedInput.inputGroups.length + "]",
                                    keyIndex: vm.selectedInput.index,
                                    value: arrValue,
                                    required: "no",
                                    type: "string",
                                    injectMap: '',
                                    isJsonIndex: true,
                                    injectMapWith$: ''
                                });
                            } else {
                                vm.selectedInput.inputGroups.push({
                                    description: vm.selectedInput.description,
                                    displayName: vm.selectedInput.index.includes('.') ? vm.selectedInput.index.split('.')[vm.selectedInput.index.split('.').length - 1] : vm.selectedInput.index,
                                    index: vm.selectedInput.index + "[" + vm.selectedInput.inputGroups.length + "]",
                                    keyIndex: vm.selectedInput.index,
                                    required: "no",
                                    type: "string",
                                    value: isFindValue.keyIndex,
                                    displayValue: isFindValue.keyIndex.includes('.') ? isFindValue.keyIndex.split('.')[isFindValue.keyIndex.split('.').length - 1] : isFindValue.keyIndex,
                                    displayPath: isFindValue.keyIndex.includes('.') ? isFindValue.keyIndex.slice(0, isFindValue.keyIndex.lastIndexOf(".")) : isFindValue.keyIndex
                                });
                            }
                        }
                    });
                    vm.isArrayCreating = false;
                    $uibModalInstance.close(vm.selectedInput);
                };

                vm.fnInitArrayInputModal = function () {
                    $timeout(function () {
                        vm.modeChanged();
                    }, 100)
                };

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AddNewInputModalCtrl',
            function ($uibModalInstance, selectedStateInputsArr,inputIndexArray,savedLoadInputsArr,stateLoadUiqIndexArr) {
                var vm = this;
                vm.selectedStateInputsArr = selectedStateInputsArr;
                vm.inputIndexArray = inputIndexArray;
                vm.savedLoadInputsArr = savedLoadInputsArr;
                vm.stateLoadUiqIndexArr = stateLoadUiqIndexArr;
                vm.customInputIndexArr = [];
                vm.name = '';
                vm.selectedInputObj = '';
                vm.selectedTab = 1;
                vm.tabs = [{
                    title: 'State Input',
                    tabIndex: 1,
                    visible: true,
                    templateUrl: ''
                }, {
                    title: 'Load Mapping',
                    tabIndex: 2,
                    visible: true,
                    templateUrl: ''
                }];

                vm.fnTabSelected = function (tab) {
                    vm.name = '';
                    vm.selectedInputObj = '';
                    vm.selectedTab = tab.tabIndex;
                    vm.customInputIndexArr = [];
                    if(vm.selectedTab === 1){
                        _.forEach(vm.inputIndexArray,function (obj) {
                            if(obj === '$'){
                                vm.customInputIndexArr.push({index:'NONE',keyIndex:obj})
                            }else{
                                vm.customInputIndexArr.push({index: vm.fnIndexName(obj),keyIndex:obj})
                            }
                        });
                    }else{
                        _.forEach(vm.stateLoadUiqIndexArr,function (obj) {
                            vm.customInputIndexArr.push({index: vm.fnIndexName(obj),keyIndex:obj})
                        });
                    }
                };

                vm.fnIndexName = function (val) {
                    return val.replace('$.','').replace('*$.','').replace(/[.]+/ig, " > ");
                };

                if(vm.selectedTab === 1){
                    _.forEach(vm.inputIndexArray,function (obj) {
                        if(obj === '$'){
                            vm.customInputIndexArr.push({index:'NONE',keyIndex:obj})
                        }else{
                            vm.customInputIndexArr.push({index: vm.fnIndexName(obj),keyIndex:obj})
                        }
                    });

                }else{
                    _.forEach(vm.stateLoadUiqIndexArr,function (obj) {
                        vm.customInputIndexArr.push({index: vm.fnIndexName(obj),keyIndex:obj})
                    });
                }

                vm.fnCheckObjectLength = function(obj){
                    return angular.isDefined(obj) && !Object.keys(obj).length;
                };

                vm.fnSaveStateInput = function(){
                    if(Object.keys(vm.selectedInputObj).length && vm.name.length){
                        var tempObj = {};
                        if(vm.selectedTab === 1){
                            tempObj = {
                                description: "",
                                displayName: vm.fnIndexName(vm.selectedInputObj.keyIndex+"."+vm.name),
                                index: vm.selectedInputObj.keyIndex+"."+vm.name,
                                isDisplay: true,
                                keyIndex: vm.selectedInputObj.keyIndex+"."+vm.name,
                                required: "no",
                                type: "string"
                            };
                            vm.selectedStateInputsArr.push(tempObj);
                        }else{
                            tempObj = {
                                keyIndex: vm.selectedInputObj.keyIndex+"."+vm.name
                            };
                            vm.savedLoadInputsArr.push(tempObj);
                        }
                        $uibModalInstance.close([vm.selectedStateInputsArr,vm.savedLoadInputsArr]);
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ListenerWorkflowCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, microSpinner, PermissionsService, PaginationService, LastPageService, FedSudoUserService, ListenerFactory, WorkflowFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllListenerWorkflowsChecked = false;
                vm.selectedListenerWorkflowsArr = [];

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    }
                ];
                vm.filterQuery = "";
                //var loginUser = DB.fnGet('loginUser');
                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.fnHideShowAddWorkflows = function () {
                    vm.isShowAddWorkflow = !vm.isShowAddWorkflow;
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isWorkflowsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    vm.isWorkflowsLoading = true;
                    vm.selectedWorkflowsArr = [];
                    vm.isAllChecked = false;
                    if(vm.WorkflowPermissionObj.List) {
                        vm.fnGetWorkflows(inputObj);
                    } else {
                        vm.workflowsArr = [];
                        vm.isWorkflowsLoading = false;
                    }
                };
                /*END: Search*/

                vm.fnCheckUncheckListenerWorkflowsAll = function () {
                    angular.forEach(vm.listenerWorkflowsArr, function (obj) {
                        obj.isCheck = vm.isAllListenerWorkflowsChecked;
                    });
                    if (vm.isAllListenerWorkflowsChecked) {
                        vm.selectedListenerWorkflowsArr = angular.copy(vm.listenerWorkflowsArr);
                    } else {
                        vm.selectedListenerWorkflowsArr = [];
                    }
                };

                vm.fnCheckUnchecklistenerWorkflowsHeader = function (workflowObj) {
                    vm.isAllListenerWorkflowsChecked = true;
                    angular.forEach(vm.listenerWorkflowsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllListenerWorkflowsChecked = false;
                        }
                    });

                    /* Toggle push in selected workflow array*/
                    var isValueFind = _.find(vm.selectedListenerWorkflowsArr, {'id': workflowObj.id});
                    if (!isValueFind) {
                        vm.selectedListenerWorkflowsArr.push(workflowObj)
                    } else {
                        _.remove(vm.selectedListenerWorkflowsArr, function (obj) {
                            return workflowObj.id === obj.id;
                        });
                    }
                };


                vm.fnDeleteListenerWorkflows = function (selectedListenerWorkflowsArr) {
                    swal({
                            title: "Remove all selected Workflows from Listener?",
                            text: "Worflows will be permanently removed for the  Listener.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedListenerWorkflowsArr, function (selectedWorkflow) {
                                    var inputObj = {
                                        listenerId: vm.parent.listenerObj.id,
                                        workflowId: selectedWorkflow.id
                                    };

                                    promises.push(ListenerFactory.removeWorkflowFromListener(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000)
                                        vm.selectedListenerWorkflowsArr = [];
                                        vm.fnGetListenerWorkflows(vm.parent.listenerObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.workflowsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedWorkflowsArr = angular.copy(vm.workflowsArr);
                    } else {
                        vm.selectedWorkflowsArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;

                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    vm.isWorkflowsLoading = true;
                    vm.selectedWorkflowsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetWorkflows(vm.inputObj);
                };

                vm.fnCheckUncheckHeader = function (workflowObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.workflowsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === workflowObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected workflow array*/
                    var isValueFind = _.find(vm.selectedWorkflowsArr, {'id': workflowObj.id});
                    if (!isValueFind) {
                        vm.selectedWorkflowsArr.push(workflowObj)
                    } else {
                        _.remove(vm.selectedWorkflowsArr, function (obj) {
                            return workflowObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetWorkflows = function (inputObj) {
                    WorkflowFactory.getWorkflows(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.workflows;
                            vm.workflowsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);

                            vm.isWorkflowsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                angular.element($window).resize();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWorkflowsLoading = false;
                            vm.isRefresh = false;
                        })
                };


                vm.fnAddWorkflow = function () {
                    vm.isWorkflowAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedWorkflowsArr, function (selectedWorkflow) {
                        var inputObj = {
                            listenerId: vm.parent.listenerObj.id,
                            workflowId: selectedWorkflow.id
                        };
                        promises.push(ListenerFactory.addWorkFlowToListener(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected Workflows successfully added to Listener");
                        vm.fnGetListenerWorkflows(vm.parent.listenerObj);
                        vm.isWorkflowAdding = false;
                        vm.isShowAddWorkflow = false;
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isWorkflowAdding = false;
                    })
                };

                vm.fnGetListenerWorkflows = function (listenerObj, isCalledFromInit) {
                    var inputObj = {
                        listenerId: listenerObj.id
                    };
                    ListenerFactory.getListenerWorkflow(inputObj)
                        .then(function (resListenerWorkflows) {
                            if(!isCalledFromInit) {
                                var tempArr = [];
                                angular.forEach(resListenerWorkflows, function (resObj) {
                                    tempArr.push(resObj.id);
                                });
                                vm.parent.listenerObj.workflowIds = tempArr;
                                $scope.$emit("ListenerDetailsChanged", vm.parent.listenerObj);
                            }
                            vm.listenerWorkflowsArr = resListenerWorkflows;
                            vm.isListenerWorkflowsLoading = false;
                        }, function () {
                            vm.isListenerWorkflowsLoading = false;
                        })
                };

                vm.fnInitListenerWorkflows = function () {
                    vm.WorkflowPermissionObj = PermissionsService.getPermissions("pipeline:workflow");
                    TabHeight.fnSet();
                    vm.isListenerWorkflowsLoading = true;
                    if (vm.parent.listenerObj.id && vm.WorkflowPermissionObj.List) {
                        vm.fnGetListenerWorkflows(vm.parent.listenerObj, true);
                    } else {
                        vm.listenerWorkflowsArr = [];
                        vm.isListenerWorkflowsLoading = false;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('addAttributesFromDeviceCtrl',
            function ($scope, $uibModalInstance, $window, $uibModal, $stateParams, amaran, moment, PaginationService, IconService, PermissionsService, FedSudoUserService, DB, DeviceFactory, TypeFactory, ColorService, $timeout, ComponentFactory, UserFactory) {
                var vm = this;
                vm.searchFieldArr = [];
                vm.filterQuery = "";

                //Devices Variables
                vm.isDevicesLoading = false;
                vm.devicesArr = [];
                vm.selectedDevicesArr = [];
                vm.selectedDeviceObj = {};
                vm.isObjectSelect = false;
                var loginUser = DB.fnGet('loginUser');
                vm.filter = "$";
                vm.search = {$: ''};
                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;

                //API params Variable
                vm.inputObj = {};

                //inventories Variable
                vm.inventoriesArr = [];
                vm.selectedInventoryObj = {};
                vm.selectedInventorysArr = [];
                vm.inventorieSearchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "TypeId",
                        fieldName: "typeId"
                    },
                    {
                        fieldDisplayName: "Health",
                        fieldName: "health"
                    },
                    {
                        fieldDisplayName: "Index",
                        fieldName: "index"
                    }
                ];
                vm.inventorieFilterQuery = "";


                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isDevicesLoading = true;
                    vm.filterQuery = filterQuery;

                    perPage = FedSudoUserService.fnGetUserData('perPage');
                    vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);

                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            perPage: vm.perPage
                        };
                    }

                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    if (vm.devicePermissionObj.List) {
                        vm.fnGetDevices(inputObj);
                    } else {
                        vm.devicesArr = [];
                        vm.isDevicesLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 90);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("#devicesAttributeTable tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnGetDevices = function (inputObj) {
                    DeviceFactory.getDevices(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.devices;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.devicesArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.isDevicesLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDevicesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckHeader = function (deviceObj) {
                    angular.forEach(vm.devicesArr, function (obj) {
                        obj.isCheck = false;
                    });
                    deviceObj.isCheck = true;
                    vm.selectedDeviceObj = deviceObj;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (perPage) {
                    //vm.currentPage = page;
                    vm.perPage = perPage;

                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: perPage
                        };
                    }
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.selectedDeviceObj = {};
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };

                vm.fnGetNextPrevCollection = function (collectionKey, collection, perPage) {
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: vm.perPage
                        };
                    }
                    if (collection.length) {
                        vm.inputObj[collectionKey] = collection;
                    }
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.selectedDeviceObj = {};
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };
                /*END: TABLE */

                /*START: Inventories*/
                vm.fnInventoriesFilterQueryChanged = function (filterQuery) {
                    vm.isDeviceInventoryDetailsLoaded = false;
                    vm.inventorieFilterQuery = filterQuery;

                    var inputObj = {};
                    if (vm.inventorieFilterQuery.length) {
                        inputObj = {
                            perPage: 0,
                            filter: vm.inventorieFilterQuery,
                            deviceId: vm.selectedDeviceObj.id
                        };
                    } else {
                        inputObj = {
                            perPage: 0,
                            deviceId: vm.selectedDeviceObj.id
                        };
                    }

                    vm.isDeviceInventoryDetailsLoaded = false;
                    vm.selectedInventoryObj = {};
                    vm.fnGetDeviceInventories(inputObj);
                };

                vm.fnGetDeviceInventories = function (inputObj) {
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            response.map(function (resObj) {
                                if (resObj.enabled === true) {
                                    var healthObj = ColorService.getHealthColor(resObj.health);
                                    resObj.healthName = healthObj.content;
                                    if (resObj.healthName === resObj.health) {
                                        resObj.toolTipName = resObj.health;
                                    } else {
                                        resObj.toolTipName = resObj.healthName + " " + resObj.health;
                                    }
                                    resObj.bgColor = healthObj['background-color'];
                                    resObj.textColor = healthObj.color;
                                }
                            });
                            vm.inventoriesArr = response;

                            vm.isDeviceInventoryDetailsLoaded = true;
                        }, function () {
                            vm.inventoriesArr = [];
                            vm.isDeviceInventoryDetailsLoaded = true;
                        })
                };

                vm.fnCheckUncheckInventoriesHeader = function (inventoryObj) {
                    angular.forEach(vm.inventoriesArr, function (obj) {
                        obj.isCheck = false;
                    });
                    inventoryObj.isCheck = true;
                    vm.selectedInventoryObj = inventoryObj;
                };

                vm.fnSelectInventory = function () {
                    vm.isInventoryObjectSelect = true;
                    vm.isComponentGhostDetailsLoaded = false;
                    vm.fnGetComponentGhost(vm.selectedInventoryObj);
                };

                vm.fnGetComponentGhost = function (componentObj) {
                    var inputObj = {
                        deviceId: componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };

                    ComponentFactory.getComponentGhost(inputObj)
                        .then(function (response) {
                            vm.componentGhostObj = response;
                            vm.componentReportedArr = [];
                            Object.keys(vm.componentGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.componentGhostObj[key].name;
                                tempObj.value = vm.componentGhostObj[key].reported ? vm.componentGhostObj[key].reported : null;
                                tempObj.health = vm.componentGhostObj[key].health ? vm.componentGhostObj[key].health : vm.selectedInventoryObj.health;
                                tempObj.humanTimestamp = moment(vm.componentGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.componentGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                var healthObj = ColorService.getHealthColor(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.bgColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                vm.componentReportedArr.push(tempObj);
                            });
                            vm.isAllChecked = true;
                            vm.fnCheckUncheckAllGhost();
                            vm.isComponentGhostDetailsLoaded = true;
                        })
                };

                vm.fnGetInventoriesHealthColor = function (health, componentGhostObj) {
                    var healthObj = ColorService.getHealthColor(health);
                    componentGhostObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGoBackToInventory = function () {
                    vm.isInventoryVisible = true;
                    vm.isGhostVisible = false;
                    vm.isInventoryObjectSelect = false;
                    vm.fnInventoriesFilterQueryChanged('');
                };

                vm.fnCheckUncheckAllGhost = function () {
                    angular.forEach(vm.componentReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostComponentsArr = angular.copy(vm.componentReportedArr);
                    } else {
                        vm.selectedGhostComponentsArr = [];
                    }
                };

                vm.fnCheckUncheckGhostHeader = function (componentGhostObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.componentReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                    var isValueFind = _.find(vm.selectedGhostComponentsArr, {'name': componentGhostObj.name});
                    if (!isValueFind) {
                        vm.selectedGhostComponentsArr.push(componentGhostObj)
                    } else {
                        _.remove(vm.selectedGhostComponentsArr, function (obj) {
                            return componentGhostObj.name === obj.name;
                        });
                    }
                };
                /*END: Inventories*/

                /*START: Ghost*/
                vm.fnGetDeviceGhost = function (deviceObj) {
                    var inputObj = {
                        deviceId: deviceObj.id
                    };

                    DeviceFactory.getDeviceGhost(inputObj)
                        .then(function (response) {
                            vm.deviceGhostObj = response;
                            vm.deviceReportedArr = [];
                            Object.keys(vm.deviceGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.deviceGhostObj[key].name;
                                tempObj.value = vm.deviceGhostObj[key].reported ? vm.deviceGhostObj[key].reported : null;
                                tempObj.health = vm.deviceGhostObj[key].health ? vm.deviceGhostObj[key].health : vm.selectedDeviceObj.defaultHealth;
                                tempObj.humanTimestamp = moment(vm.deviceGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.deviceGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                var healthObj = ColorService.getHealthColor(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.bgColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                vm.deviceReportedArr.push(tempObj);
                            });
                            vm.fnCheckUncheckAllDeviceGhost();
                            vm.isDeviceGhostDetailsLoaded = true;
                        })
                };

                vm.fnCheckUncheckAllDeviceGhost = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.deviceReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostDevicesArr = angular.copy(vm.deviceReportedArr);
                    } else {
                        vm.selectedGhostDevicesArr = [];
                    }
                };

                vm.fnCheckUncheckDeviceGhostHeader = function (deviceGhostObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.deviceReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });

                    var isValueFind = _.find(vm.selectedGhostDevicesArr, {'name': deviceGhostObj.name});
                    if (!isValueFind) {
                        vm.selectedGhostDevicesArr.push(deviceGhostObj)
                    } else {
                        _.remove(vm.selectedGhostDevicesArr, function (obj) {
                            return deviceGhostObj.name === obj.name;
                        });
                    }
                };

                /*END: Ghost*/
                vm.fnSelectDevice = function (obj) {
                    vm.isObjectSelect = true;
                    vm.fnGetType(obj.typeId);
                    vm.isGhostOrComponentDataLoade = true;
                };

                vm.fnGetType = function (typeId) {
                    var inputObj = {
                        typeId: typeId
                    };
                    TypeFactory.getType(inputObj)
                        .then(function (response) {
                            if (response.hasComponents === true) {
                                vm.isInventoryVisible = true;
                                vm.isGhostVisible = false;
                            } else {
                                vm.isInventoryVisible = false;
                                vm.isGhostVisible = true;
                                vm.isDeviceGhostDetailsLoaded = false;
                                vm.fnGetDeviceGhost(vm.selectedDeviceObj);
                            }
                            return true;
                        })
                };

                vm.fnGetHealthColor = function (health, deviceObj) {
                    var healthObj = ColorService.getHealthColor(health);
                    deviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function(phase){
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };
                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnCreateAttribute = function (array) {
                    var textObj, toggleObj;
                    vm.attributesArr = [];
                    _.forEach(array, function (obj) {
                        if (obj.value === "") {
                            obj.value = '---';
                        }
                        if (obj.value === "---") {
                            obj.value = 0;
                        }
                        if (obj.value === "overpower") {
                            obj.value = 100;
                        }
                        if (obj.value === "underpower") {
                            obj.value = -50;
                        }
                        var attributeObj = {
                            name: obj.name,
                            title: obj.name.charAt(0).toUpperCase() + obj.name.slice(1),
                            units: '',
                            value: obj.value,
                            display: '',
                            health: obj.health,
                            healthCode: obj.health,
                            options: {}
                        };
                        var healthObj = ColorService.getHealthColor(attributeObj.healthCode);
                        attributeObj.health = healthObj.content;
                        attributeObj.healthColor = healthObj['background-color'];
                        if (!isNaN(obj.value)) {
                            if (isInt(obj.value)) {
                                var gaugeObj = {
                                    min: 1,
                                    max: parseInt(obj.value * 10 / 100 + obj.value),
                                    defaultColor: '#6CCCCC',
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        color: ''
                                    }]
                                };
                                attributeObj.display = 'Gauge';
                                attributeObj.options = gaugeObj;
                            }
                            if (isFloat(obj.value)) {
                                var stackObj = {
                                    min: 1,
                                    max: parseFloat(obj.value * 10 / 100 + obj.value),
                                    defaultColor: '#6CCCCC',
                                    stackType: 'Horizontal',
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        color: ''
                                    }]
                                };
                                attributeObj.display = 'Stack';
                                attributeObj.options = stackObj;
                            }
                            if (typeof(obj.value) === "boolean") {
                                toggleObj = {
                                    default: {
                                        value: obj.value,
                                        trueText: true,
                                        falseText: false
                                    },
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        isTrue: ''
                                    }]
                                };
                                attributeObj.display = 'Toggle';
                                attributeObj.options = toggleObj;
                            }
                        } else if (isNaN(obj.value)) {
                            if (obj.value === 'true' || obj.value === 'false' || obj.value === 'on' || obj.value === 'off') {
                                toggleObj = {
                                    default: {
                                        value: obj.value,
                                        trueText: obj.value === 'on' || obj.value === 'off' ? 'on' : 'true',
                                        falseText: obj.value === 'on' || obj.value === 'off' ? 'off' : 'false'
                                    },
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        isTrue: ''
                                    }]
                                };
                                attributeObj.display = 'Toggle';
                                attributeObj.options = toggleObj;
                            } else {
                                textObj = {
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        text: ''
                                    }]
                                };
                                attributeObj.display = 'Text';
                                attributeObj.options = textObj;
                            }
                        } else {
                            textObj = {
                                mapType: 'range',
                                range: [{
                                    from: '',
                                    to: '',
                                    text: ''
                                }]
                            };
                            attributeObj.display = 'Text';
                            attributeObj.options = textObj;
                        }
                        vm.attributesArr.push(attributeObj);
                    });
                    $uibModalInstance.close(vm.attributesArr);
                };

                vm.fnGoBackToDevice = function () {
                    vm.isObjectSelect = false;
                    vm.fnFilterQueryChanged('');
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                function isInt(n) {
                    return Number(n) === n && n % 1 === 0;
                }

                function isFloat(n) {
                    return Number(n) === n && n % 1 !== 0;
                }

                vm.fnInitModel = function () {
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.searchFieldArr = [
                        {
                            fieldDisplayName: "ID",
                            fieldName: "id"
                        },
                        {
                            fieldDisplayName: "Name",
                            fieldName: "name"
                        },
                        {
                            fieldDisplayName: "Description",
                            fieldName: "description"
                        },
                        {
                            fieldDisplayName: "Phase",
                            fieldName: "phase"
                        },
                        {
                            fieldDisplayName: "TypeId",
                            fieldName: "typeId"
                        },
                        {
                            fieldDisplayName: "Health",
                            fieldName: "health"
                        },
                        {
                            fieldDisplayName: "DefaultHealth",
                            fieldName: "defaultHealth"
                        }
                    ];
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('addAttributesCtrl',
            function ($scope, $uibModalInstance, $window, $uibModal, $stateParams, amaran, moment, PaginationService, IconService, PermissionsService, FedSudoUserService, DB, GatewayFactory, ColorService, $timeout, UserFactory) {
                var vm = this;
                vm.searchFieldArr = [];
                vm.filterQuery = "";

                var loginUser = DB.fnGet('loginUser');

                //Gateway variables
                vm.isGatewaysLoading = false;
                vm.gatewaysArr = [];
                vm.selectedGatewaysArr = [];
                vm.selectedGatewayObj = {};

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;

                //API params Variable
                vm.inputObj = {};

                // gateway ghost
                vm.selectedGhostGatewaysArr = [];
                vm.filter = "$";
                vm.search = {$: ''};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isGatewaysLoading = true;
                    vm.filterQuery = filterQuery;
                    perPage = FedSudoUserService.fnGetUserData('perPage');
                    vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            perPage: vm.perPage
                        };
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetGateways(inputObj);
                    } else {
                        vm.gatewaysArr = [];
                        vm.isGatewaysLoading = false;
                    }
                };

                vm.fnGetGateways = function (inputObj) {
                    GatewayFactory.getGateways(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.gateways;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.gatewaysArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.isGatewaysLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewaysLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckHeader = function (gatewayObj) {
                    angular.forEach(vm.gatewaysArr, function (obj) {
                        obj.isCheck = false;
                    });
                    gatewayObj.isCheck = true;
                    vm.selectedGatewayObj = gatewayObj;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (perPage) {
                    //vm.currentPage = page;
                    vm.perPage = perPage;

                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: perPage
                        };
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetGateways(vm.inputObj);
                };

                vm.fnGetNextPrevCollection = function (collectionKey, collection, perPage) {
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: vm.perPage
                        };
                    }

                    if (collection.length) {
                        vm.inputObj[collectionKey] = collection;
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetGateways(vm.inputObj);
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 90);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("#gatewaysTable tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };


                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnSelectGateway = function (obj) {
                    vm.isObjectSelect = true;
                    vm.fnGetGatewayGhost(obj);
                };

                vm.fnGetGatewayGhost = function (gatewayObj) {
                    vm.isGatewayGhostDetailsLoaded = false;
                    var inputObj = {
                        gatewayId: gatewayObj.id
                    };
                    GatewayFactory.getGatewayGhost(inputObj)
                        .then(function (response) {
                            vm.gatewayGhostObj = response;
                            vm.gatewayReportedArr = [];
                            Object.keys(vm.gatewayGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.gatewayGhostObj[key].name;
                                tempObj.value = vm.gatewayGhostObj[key].reported ? vm.gatewayGhostObj[key].reported : null;
                                tempObj.health = vm.gatewayGhostObj[key].health ? vm.gatewayGhostObj[key].health : vm.selectedGatewayObj.defaultHealth;
                                tempObj.humanTimestamp = moment(vm.gatewayGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.gatewayGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                var healthObj = ColorService.getHealthColor(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.bgColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                vm.gatewayReportedArr.push(tempObj);
                            });
                            $timeout(function () {
                                vm.isAllChecked = true;
                                vm.fnCheckUncheckAllGatewayGhost();
                                vm.fnSetTableHeight();
                            });
                            vm.isGatewayGhostDetailsLoaded = true;
                        })
                };

                vm.fnCheckUncheckAllGatewayGhost = function () {
                    angular.forEach(vm.gatewayReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostGatewaysArr = angular.copy(vm.gatewayReportedArr);
                    } else {
                        vm.selectedGhostGatewaysArr = [];
                    }
                };

                vm.fnCheckUncheckHeaderGatewayGhost = function (gatewayObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.gatewayReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                    /* Toggle push in selected gateways array*/
                    var isValueFind = _.find(vm.selectedGhostGatewaysArr, {'name': gatewayObj.name});
                    if (!isValueFind) {
                        vm.selectedGhostGatewaysArr.push(gatewayObj)
                    } else {
                        _.remove(vm.selectedGhostGatewaysArr, function (obj) {
                            return gatewayObj.name === obj.name;
                        });
                    }
                };

                vm.fnCreateAttribute = function () {
                    var textObj, toggleObj;
                    vm.attributesArr = [];
                    _.forEach(vm.selectedGhostGatewaysArr, function (obj) {
                        if (obj.value === "") {
                            obj.value = '---';
                        }
                        if (obj.value === "---") {
                            obj.value = 0;
                        }
                        if (obj.value === "overpower") {
                            obj.value = 100;
                        }
                        if (obj.value === "underpower") {
                            obj.value = -50;
                        }
                        var attributeObj = {
                            name: obj.name,
                            title: obj.name.charAt(0).toUpperCase() + obj.name.slice(1),
                            units: '',
                            value: obj.value,
                            display: '',
                            health: obj.health,
                            healthCode: obj.health,
                            options: {}
                        };
                        var healthObj = ColorService.getHealthColor(attributeObj.healthCode);
                        attributeObj.health = healthObj.content;
                        attributeObj.healthColor = healthObj['background-color'];
                        if (!isNaN(obj.value)) {
                            if (isInt(obj.value)) {
                                var gaugeObj = {
                                    min: 1,
                                    max: parseInt(obj.value * 10 / 100 + obj.value),
                                    defaultColor: '#6CCCCC',
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        color: ''
                                    }]
                                };
                                attributeObj.display = 'Gauge';
                                attributeObj.options = gaugeObj;
                            }
                            if (isFloat(obj.value)) {
                                var stackObj = {
                                    min: 1,
                                    max: parseFloat(obj.value * 10 / 100 + obj.value),
                                    defaultColor: '#6CCCCC',
                                    stackType: 'Horizontal',
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        color: ''
                                    }]
                                };
                                attributeObj.display = 'Stack';
                                attributeObj.options = stackObj;
                            }
                            if (typeof(obj.value) === "boolean") {
                                toggleObj = {
                                    default: {
                                        value: obj.value,
                                        trueText: true,
                                        falseText: false
                                    },
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        isTrue: ''
                                    }]
                                };
                                attributeObj.display = 'Toggle';
                                attributeObj.options = toggleObj;
                            }
                        } else if (isNaN(obj.value)) {
                            if (obj.value === 'true' || obj.value === 'false' || obj.value === 'on' || obj.value === 'off') {
                                toggleObj = {
                                    default: {
                                        value: obj.value,
                                        trueText: obj.value === 'on' || obj.value === 'off' ? 'on' : 'true',
                                        falseText: obj.value === 'on' || obj.value === 'off' ? 'off' : 'false'
                                    },
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        isTrue: ''
                                    }]
                                };
                                attributeObj.display = 'Toggle';
                                attributeObj.options = toggleObj;
                            } else {
                                textObj = {
                                    mapType: 'range',
                                    range: [{
                                        from: '',
                                        to: '',
                                        text: ''
                                    }]
                                };
                                attributeObj.display = 'Text';
                                attributeObj.options = textObj;
                            }
                        } else {
                            textObj = {
                                mapType: 'range',
                                range: [{
                                    from: '',
                                    to: '',
                                    text: ''
                                }]
                            };
                            attributeObj.display = 'Text';
                            attributeObj.options = textObj;
                        }
                        vm.attributesArr.push(attributeObj);
                    });
                    $uibModalInstance.close(vm.attributesArr);
                };

                vm.fnGoBackToGateway = function () {
                    vm.isObjectSelect = false;
                    vm.fnFilterQueryChanged('');
                };

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColor(health);
                    gatewayObj.healthName = healthObj.content;
                    if (gatewayObj.healthName === health) {
                        gatewayObj.toolTipName = health;
                    } else {
                        gatewayObj.toolTipName = gatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconBorderColor = function(phase){
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                function isInt(n) {
                    return Number(n) === n && n % 1 === 0;
                }

                function isFloat(n) {
                    return Number(n) === n && n % 1 !== 0;
                }

                vm.fnInitModel = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.searchFieldArr = [
                        {
                            fieldDisplayName: "ID",
                            fieldName: "id"
                        },
                        {
                            fieldDisplayName: "Name",
                            fieldName: "name"
                        },
                        {
                            fieldDisplayName: "Description",
                            fieldName: "description"
                        },
                        {
                            fieldDisplayName: "Phase",
                            fieldName: "phase"
                        },
                        {
                            fieldDisplayName: "Connection",
                            fieldName: "connection"
                        },
                        {
                            fieldDisplayName: "TypeId",
                            fieldName: "typeId"
                        },
                        {
                            fieldDisplayName: "Health",
                            fieldName: "health"
                        },
                        {
                            fieldDisplayName: "DefaultHealth",
                            fieldName: "defaultHealth"
                        }
                    ];
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectTeamsCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllTeamsChecked = false;
                vm.selectedProjectTeamsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 26 - actionDiv) + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnGetProjectTeams = function (inputObj, preDefinedTeams, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (resTeams) {
                            var teams = isCalledForViz ? preDefinedTeams : [];
                            _.forEach(resTeams.data, function (teamsObj) {
                                teams.push(teamsObj);
                            });
                            if ((resTeams.data && resTeams.data.length && resTeams.data.length > 0) && (teams[0] && teams[0].totalItems > teams.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + teams[teams.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectTeams({sql: sqlString}, teams, true);
                            } else {
                                vm.projectTeamsArr = _.cloneDeepWith(teams);
                                vm.isProjectTeamsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }
                        }, function () {
                            vm.isProjectTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnInitProjectTeams = function () {
                    vm.isProjectTeamsLoading = true;
                    if (vm.parent.projectObj.teamIds && vm.parent.projectObj.teamIds.length) {
                        var teamIds = "";
                        _.forEach(vm.parent.projectObj.teamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems, data->>'_id' AS rt FROM access_teams WHERE data->>'id' = ANY(ARRAY[" + teamIds + "]) LIMIT " + 100 + ";";
                        vm.fnGetProjectTeams({sql: teamSQL}, [], false);
                    } else {
                        vm.projectTeamsArr = [];
                        vm.isProjectTeamsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, NodeProjectFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.projectSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetProjectData = function () {
                    vm.projectSupplementalObj = vm.parent.projectObj.tags ? angular.fromJson(vm.parent.projectObj.tags) : {};
                    vm.projectSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.projectSupplementalObj, true) : vm.projectSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.projectSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.projectSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.projectSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.projectSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.projectSupplementalObj = angular.toJson(vm.projectSupplementalObj, true);
                    } else {
                        vm.projectSupplementalObj = angular.fromJson(vm.projectSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                            angular.forEach(vm.projectSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveProjectData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.projectObj.tags = {};
                    var inputObj = {
                        projectId: vm.parent.projectObj.id,
                        body: {}
                    };
                    if (!vm.parent.projectObj.tags) {
                        vm.parent.projectObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.projectObj.tags = angular.fromJson(vm.projectSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.projectObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.projectObj.tags;
                    NodeProjectFactory.replaceProjectTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Project successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.projectSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitProjectSupplemental = function () {
                    vm.isProjectSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectScriptCtrl',
            function ($scope, $timeout, $window, $state) {
                var vm = this;
                vm.parent = $scope.$parent;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGotoScripts = function () {
                    $state.go('main.node_project_scripts', {
                        name: vm.parent.projectObj.name,
                        selectedProject: vm.parent.projectObj.id
                    });
                };

                vm.fnInitProjectScript = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectEmailCtrl',
            function ($scope, $timeout, $window, $state) {
                var vm = this;
                vm.parent = $scope.$parent;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGotoEmailTemplate = function () {
                    $state.go('main.node_project_emailTemplate', {
                        name: vm.parent.projectObj.name,
                        selectedProject: vm.parent.projectObj.id
                    });
                };

                vm.fnInitProjectEmail = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeAttributesCtrl',
            function ($scope, $timeout, $window, $state, DB, amaran, swal, TabHeight, NodeAttributesFactory, PermissionsService, $uibModal, moment, PaginationQueryService, copyService, NodeEcuFactory, WidgetsListService, BatchFactory, microSpinner, ColorService, NodeFactory, QueryFactory, Highcharts, postActionModelMessage, postActionModelIcon, $log) {
                var vm = this;
                var timezoneName = "";
                vm.parent = $scope.$parent;
                vm.isFullWidthDevice = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });
                vm.isNodeDetailsLoaded = false;
                vm.nodeObj = {};
                vm.resetNodeObj = {};
                vm.initNode = true;
                vm.chartData = [];
                vm.splineChartData = [];
                vm.selectedChartType = 'spline';
                vm.filter = "$";
                vm.attributeSearch = {$: ''};
                vm.selectedChartFor = 'Value';
                vm.selectedRange = "";
                vm.selectedChartData = [];
                vm.isShowNodeConnection = false;
                vm.isShowPlotNodeHealth = false;
                var connectionArr = [
                    {
                        name: "Connected",
                        value: 1,
                        color: '#218838'
                    },
                    {
                        name: "Disconnected",
                        value: -1,
                        color: '#C82333'
                    }
                ];
                vm.attributesList = [];
                vm.attributesStringValueArr = [];
                vm.tempAxesData = [
                    { // Primary yAxis
                        title: {
                            text: 'Values'
                        }
                    },
                    { // Primary yAxis
                        title: {
                            text: 'Health'
                        },
                        opposite: true,
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Connection'
                        },
                        opposite: true,
                        labels: {
                            formatter: function () {
                                return this.value === -1 ? 'Disconnected' : this.value // eslint-disable-line
                            }
                        },
                        categories: ['', 'Connected'],
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Attribute String Values'
                        },
                        opposite: true,
                        categories: vm.attributesStringValueArr,
                        visible: true
                    }
                ];
                vm.tempChartsData = [];
                vm.selectedHeatmapChartAttrObj = '';
                vm.axisArr = [
                    {
                        title: 'Minutes',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
                    },
                    {
                        title: 'Hours',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                    },
                    {
                        title: 'Days',
                        categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                    },
                    {
                        title: 'Weeks',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54"]
                    },
                    {
                        title: 'Months',
                        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    }
                ];
                vm.mathFunction = [
                    {
                        title: 'MIN'
                    },
                    {
                        title: 'MAX'
                    },
                    {
                        title: 'AVG'
                    }
                ];
                vm.selectedMathFunction = 'MAX';
                vm.selectedXAxis = vm.axisArr[2];
                vm.selectedYAxis = vm.axisArr[0];
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "This Node",
                        name: 'nodeId',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".data->>\'nodeId\' = '" + vm.parent.nodeObj.id + "'",
                        localSearchValue: "obj.nodeId === '" + vm.parent.nodeObj.id + "'"
                    }, {
                        displayName: "Node ID",
                        name: "nodeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Alarms",
                        name: 'alarms',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".reference like '%!'",
                        localSearchValue: "obj.reference.endsWith('!')"
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'},
                    {name: 'receivedAt', displayName: 'Value Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.defaultAttributeFilterArr = [
                    {
                        displaySearchText: "",
                        displaySelectedField: "This Node",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.nodeId === '" + vm.parent.nodeObj.id + "'",
                        searchText: "",
                        selectedField: "nodeId",
                        sqlValue: "node_attributes.data->>\'nodeId'\ = '" + vm.parent.nodeObj.id + "'"
                    },
                    {
                        displaySearchText: "",
                        displaySelectedField: "Alarms",
                        selectedConnector: "and",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.reference.endsWith('!')",
                        searchText: "",
                        selectedField: "alarms",
                        sqlValue: vm.tableAlias + ".data->>\'reference\' like '%!'"
                    }
                ];
                vm.defaultAttributeSortString = 'name asc';
                vm.perPage = 50;
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isShowPaginationContainer = true;
                vm.selectedPieChartData = {};
                vm.pieChartAttributeList = [];
                vm.heatmapChartAttributeList = [];
                vm.heatmapAttributeStringValueArr = [];
                var loaderModalInstance = "";
                vm.selectedAttribute = {};
                vm.plotableArr = [
                    {
                        name: 'Actual Value',
                        sortName: '[AV]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    },
                    {
                        name: 'Forecast Value',
                        sortName: '[FV]',
                        dataType: 'Forecast',
                        chartType: 'Value',
                        attrKey: 'isSelectedForecast'
                    },
                    {
                        name: 'Forecast Health',
                        sortName: '[FH]',
                        dataType: 'Forecast',
                        chartType: 'Health',
                        attrKey: 'isSelectedForecastHealthPlot'
                    },
                    {
                        name: 'Value Anomaly',
                        sortName: '[VA]',
                        dataType: 'Anomaly',
                        chartType: 'Value',
                        attrKey: 'isSelectedAnomaly'
                    },
                    {
                        name: 'Health Anomaly',
                        sortName: '[HA]',
                        dataType: 'Anomaly',
                        chartType: 'Health',
                        attrKey: 'isSelectedAnomalyHealthPlot'
                    }
                ];
                vm.nodePlotableArr = [
                    {
                        name: 'Actual Connection',
                        sortName: '[AC]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    }
                ];
                vm.selectedAttrKeyArr = [
                    {
                        name: 'Name',
                        key: 'name'
                    },
                    {
                        name: 'Value',
                        key: 'value'
                    },
                    {
                        name: 'Units',
                        key: 'read'
                    },
                    {
                        name: 'Health',
                        key: 'health'
                    },
                    {
                        name: 'Ref',
                        key: 'reference'
                    },
                    {
                        name: 'ID',
                        key: 'id'
                    },
                    {
                        name: 'Type',
                        key: 'type'
                    },
                    {
                        name: 'Node',
                        key: 'nodeName'
                    },
                    {
                        name: 'Alarm',
                        key: 'id'
                    }
                ];
                vm.granularityArr = [
                    {
                        name: '1 minute',
                        config: {
                            title: 'MINUTES',
                            value: 1,
                            time: 60000
                        }
                    },
                    {
                        name: '2 minute',
                        config: {
                            title: 'MINUTES',
                            value: 2,
                            time: 60000
                        }
                    },
                    {
                        name: '5 minute',
                        config: {
                            title: 'MINUTES',
                            value: 5,
                            time: 60000
                        }
                    },
                    {
                        name: '15 minute',
                        config: {
                            title: 'MINUTES',
                            value: 15,
                            time: 60000
                        }
                    },
                    {
                        name: '30 minute',
                        config: {
                            title: 'MINUTES',
                            value: 30,
                            time: 60000
                        }
                    },
                    {
                        name: '1 hour',
                        config: {
                            title: 'HOURS',
                            value: 1,
                            time: 3600000
                        }
                    },
                    {
                        name: '3 hour',
                        config: {
                            title: 'HOURS',
                            value: 3,
                            time: 3600000
                        }
                    },
                    {
                        name: '6 hour',
                        config: {
                            title: 'HOURS',
                            value: 6,
                            time: 3600000
                        }
                    },
                    {
                        name: '1 day',
                        config: {
                            title: 'DAYS',
                            value: 1,
                            time: 86400000
                        }
                    }
                ];
                vm.selectedGranularity = vm.granularityArr[1];
                vm.chartUpdateTimeout = '';
                vm.selectedAutoUpdateType = "Static";

                vm.attributeNameContextMenu = function (attributeObj) {
                    var tempContextMenu = [{
                        text: 'Edit Name',
                        click: function () {
                            vm.fnEditAttributeName(attributeObj);
                        }
                    }];
                    if (attributeObj.mode === 'RW' || attributeObj.mode === 'rw') {
                        tempContextMenu.push({
                            text: 'Edit Value',
                            click: function () {
                                vm.fnEditAttributeValue(attributeObj);
                            }
                        });
                    }
                    if (vm.permissionObj.ENABLE_ATTRIBUTE || vm.permissionObj.DISABLE_ATTRIBUTE) {
                        if (attributeObj.operation && attributeObj.operation === 'DISABLED') {
                            tempContextMenu.push({
                                text: 'Enable Attribute',
                                click: function () {
                                    vm.fnEnableAttribute(attributeObj);
                                }
                            });
                        } else {
                            tempContextMenu.push({
                                text: 'Disable Attribute',
                                click: function () {
                                    vm.fnDisableAttribute(attributeObj);
                                }
                            });
                        }
                    }
                    if (attributeObj.syncState === 'NOT_SYNCHRONIZED') {
                        tempContextMenu.push({
                            text: 'Synchronize',
                            click: function () {
                                vm.fnDeployAttribute(attributeObj);
                            }
                        });
                    }
                    return tempContextMenu;
                };

                vm.attributeValueContextMenu = function (attributeObj) {
                    return [{
                        text: 'Edit Value',
                        click: function () {
                            vm.fnEditAttributeValue(attributeObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = "";
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY node_attributes.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                        sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                            'att.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' AS rt ' +
                            'FROM attributes AS att ' +
                            'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                    } else {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                            'att.rt AS rt ' +
                            'FROM attributes AS att ' +
                            'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                    }
                    var input = {
                        sql: sqlString
                    };
                    if (vm.initNode === false) {
                        vm.isShowPaginationContainer = true;
                        vm.fnGetAttributes(input, true);
                    } else {
                        vm.isAttributesLoading = false;
                        vm.initNode = false;
                    }
                };

                vm.fnGetAttributes = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.attributesList = [];
                            if (vm.currentPage === 1) {
                                vm.attributesList.push({
                                    name: 'Node',
                                    displayName: 'Node',
                                    nodeName: vm.nodeObj.name,
                                    connected: vm.nodeObj.connected,
                                    id: vm.nodeObj.id,
                                    type: 'node',
                                    health: vm.nodeObj.health,
                                    projectId: vm.nodeObj.projectId,
                                    isSelected: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Actual Connection)',
                                        id: vm.nodeObj.id
                                    }) !== -1,
                                    isSelectedHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Actual Health)',
                                        id: vm.nodeObj.id
                                    }) !== -1,
                                    isSelectedForecast: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Forecast Connection)',
                                        id: vm.nodeObj.id
                                    }) !== -1,
                                    isSelectedForecastHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Forecast Health)',
                                        id: vm.nodeObj.id
                                    }) !== -1,
                                    isSelectedAnomaly: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Anomaly Connection)',
                                        id: vm.nodeObj.id
                                    }) !== -1,
                                    isSelectedAnomalyHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'Node (Anomaly Health)',
                                        id: vm.nodeObj.id
                                    }) !== -1
                                });
                            }
                            if (isFirst && res.data && res.data.length) {
                                vm.totalItems = res.data[0].totalItems + 1;
                                vm.currentPage = 1;
                            }
                            var parsedData = parsePostgresData(res.data);

                            if (inputObj.isNeedDataReverse) {
                                parsedData.reverse();
                            }
                            vm.resetAttributeLists = _.cloneDeepWith(parsedData);
                            vm.fnGenerateAttributesList();
                            vm.isAttributesLoading = false;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributesLoading = false;
                        })
                };

                vm.fnGenerateAttributesList = function () {
                    var tempAttributeObj = _.cloneDeepWith(vm.attributesList[0]);
                    vm.attributesList = [];
                    if (tempAttributeObj && tempAttributeObj.name === 'Node') {
                        tempAttributeObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: 'Node (Actual Connection)',
                            id: tempAttributeObj.id
                        }) !== -1;
                        tempAttributeObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: 'Node (Actual Health)',
                            id: tempAttributeObj.id
                        }) !== -1;
                        vm.attributesList.push(tempAttributeObj);
                        if (vm.selectedAttribute.id === tempAttributeObj.id) {
                            vm.selectedAttribute = tempAttributeObj;
                        }
                    }
                    _.forEach(vm.resetAttributeLists, function (attributeObj) {
                        attributeObj.displayName = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.name = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.type = 'attribute';
                        var tempActualObj = _.cloneDeepWith(attributeObj);
                        tempActualObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        vm.attributesList.push(tempActualObj);
                        if (vm.selectedAttribute.id === tempActualObj.id) {
                            vm.selectedAttribute = tempActualObj;
                        }
                    });
                    vm.fnSortAttributesByPlot();
                };

                vm.fnSortAttributesByPlot = function () {
                    /*var tempAttributeObj = _.cloneDeepWith(vm.attributesList[0]);
                    if (tempAttributeObj && tempAttributeObj.name === 'Node') {
                        vm.attributesList.splice(0, 1);
                        vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                        vm.attributesList.unshift(tempAttributeObj);
                    } else {
                        vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                    }*/
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_attributes as node_attributes';
                    } else { //for general sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY node_attributes.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                                'att.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' AS rt ' +
                                'FROM attributes AS att ' +
                                'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                                'att.rt AS rt ' +
                                'FROM attributes AS att ' +
                                'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAttributes(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.attributesList, true, 'node_attributes');
                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }
                        var newSQL = "WITH attributes AS (" + tempNewSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes";
                        newSQL += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        if (sortString !== '') { //for specific sort
                            newSQL += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.data->>\'qty\' AS totalItems, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                                'att.data->>' + "'" + vm.sort.split(' ')[0] + "'" + ' AS rt ' +
                                'FROM attributes AS att ' +
                                'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        } else { //for general sort
                            newSQL += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.data->>\'qty\' AS totalItems, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, ' +
                                'att.data->>\'_id\' AS rt ' +
                                'FROM attributes AS att ' +
                                'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        }
                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }
                        vm.previousPage = page;
                        vm.fnGetAttributes(newInput, false);
                    }
                };

                vm.fnOnActionDrop = function (srcList, dataType, chatsType) {
                    var isAllow = false;
                    if (vm.selectedChartType === 'pie') {
                        isAllow = !(dataType === 'Forecast' || dataType === 'Anomaly');
                    } else {
                        isAllow = true;
                    }
                    if (isAllow) {
                        var chartType = "";
                        var tempType = "";
                        if (chatsType === 'Value') {
                            chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                            tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        } else {
                            chartType = srcList.type === 'node' ? 'nodeHealth' : 'attributeHealth';
                            tempType = 'Health';
                        }
                        //var chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                        //var tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        var isFindIndex = _.findIndex(vm.selectedChartData, {
                            name: srcList.name + " (" + dataType + " " + tempType + ")",
                            chartType: chartType,
                            id: srcList.id
                        });
                        if (isFindIndex === -1) {
                            if (chatsType === 'Value') {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeConnection';
                                } else {
                                    srcList.chartType = 'attributeValue';
                                }
                            } else {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeHealth';
                                } else {
                                    srcList.chartType = 'attributeHealth';
                                }
                            }
                            srcList.dataType = _.cloneDeepWith(dataType);
                            if (chatsType === 'Value') {
                                if (dataType === 'Actual') {
                                    srcList.isSelected = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecast = true;
                                } else {
                                    srcList.isSelectedAnomaly = true;
                                }
                            } else {
                                if (dataType === 'Actual') {
                                    srcList.isSelectedHealthPlot = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecastHealthPlot = true;
                                } else {
                                    srcList.isSelectedAnomalyHealthPlot = true;
                                }
                            }
                            var tempSrcList = _.cloneDeepWith(srcList);
                            tempSrcList.name = tempSrcList.name + " (" + dataType + " " + tempType + ")";
                            vm.selectedChartData.push(tempSrcList);
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (vm.selectedChartType === 'heatmap') {
                                vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                            }
                            if (vm.selectedChartType === 'pie') {
                                vm.selectedPieChartData = vm.pieChartAttributeList[0];
                            }
                            $timeout(function () {
                                vm.fnGetAttributeAnalyticsData(srcList);
                            });
                        } else {
                            amaran.error('Attribute already added on chart.');
                        }
                    } else {
                        amaran.error('Attribute type is not allows for pie chart type.');
                    }
                };

                vm.fnGetAttributeAnalyticsData = function (srcList) {
                    var sql = vm.fnGetSQLQuery(srcList);
                    var chartContainerEle = angular.element(".chart-container-height");
                    loaderModalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                        size: 'md',
                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                        appendTo: chartContainerEle
                    });
                    QueryFactory.executeQuery({'sql': sql})
                        .then(function (res) { // Success block
                            vm.selectedChartData[vm.selectedChartData.length - 1].sql = sql;
                            vm.selectedChartData[vm.selectedChartData.length - 1].apiData = res.data;
                            vm.selectedChartData[vm.selectedChartData.length - 1].chartData = vm.fnGenerateChartData(srcList, res.data);
                            var tempType = srcList.chartType === 'nodeConnection' || srcList.chartType === 'attributeValue' ? 'Value' : 'Health';
                            var tempName = srcList.name + " (" + srcList.dataType + " " + tempType + ")";
                            var isFind = _.find(vm.pieChartAttributeList, {
                                name: tempName,
                                id: srcList.id
                            });
                            if (isFind) {
                                isFind.apiData = res.data;
                                isFind.chartData = vm.selectedChartData[vm.selectedChartData.length - 1].chartData;
                            }
                            if (vm.selectedChartType !== 'heatmap') {
                                loaderModalInstance.dismiss();
                                loaderModalInstance = "";
                            }
                            $timeout(function () {
                                vm.fnRenderChart();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            loaderModalInstance.dismiss();
                            loaderModalInstance = "";
                            vm.fnRemoveChartData(srcList)
                        })
                };

                vm.fnRenderChart = function () {
                    if (vm.selectedChartData.length) {
                        if (vm.selectedChartType === 'pie') {
                            vm.chartData = [];
                            var counts = {};
                            if (vm.selectedPieChartData && vm.selectedPieChartData.chartType) {
                                if (vm.selectedPieChartData.chartType === "nodeHealth" || vm.selectedPieChartData.chartType === "attributeHealth") {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.health] = (counts[x.health] || 0) + 1;
                                    });
                                } else {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.value] = (counts[x.value] || 0) + 1;
                                    });
                                }
                                _.forEach(counts, function (value, key) {
                                    vm.chartData.push({
                                        name: key,
                                        y: value
                                    });
                                });
                                $timeout(function () {
                                    Highcharts.chart('nodeAttributeChart', {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: 'pie'
                                        },
                                        title: {
                                            text: ''
                                        },
                                        tooltip: {
                                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        accessibility: {
                                            point: {
                                                valueSuffix: ''
                                            }
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: true,
                                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                                }
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: 'Value',
                                            colorByPoint: true,
                                            data: vm.chartData
                                        }]
                                    });
                                });
                            }
                        }
                        if (vm.selectedChartType === 'heatmap') {
                            if (angular.isDefined(vm.selectedHeatmapChartAttr) && vm.selectedHeatmapChartAttr.name.length) {
                                var sql = vm.fnGetHeatMapSQLQuery(vm.selectedHeatmapChartAttr);
                                if (loaderModalInstance === '') {
                                    var chartContainerEle = angular.element(".chart-container-height");
                                    loaderModalInstance = $uibModal.open({
                                        backdrop: 'static',
                                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                                        size: 'md',
                                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                                        appendTo: chartContainerEle
                                    });
                                }
                                QueryFactory.executeQuery({'sql': sql})
                                    .then(function (res) { // Success block
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.selectedHeatmapChartAttr.apiData = _.cloneDeepWith(res.data);
                                        var chartData = vm.fnGenerateHeatMapChartData(vm.selectedHeatmapChartAttr, _.cloneDeepWith(res.data));
                                        var chartName = '';
                                        if (angular.isDefined(vm.selectedHeatmapChartAttr.chartType) && vm.selectedHeatmapChartAttr.chartType === 'attributeValue') {
                                            chartName = 'Value';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'attributeHealth' || vm.selectedHeatmapChartAttr.chartType === 'nodeHealth') {
                                            chartName = vm.selectedHeatmapChartAttr.type === 'node' ? 'Node Health' : 'Health';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'nodeConnection') {
                                            chartName = 'Connection';
                                        }
                                        var isStringFound = false;
                                        _.forEach(res.data, function (dataObj) {
                                            if (dataObj.value && isNaN(dataObj.value)) {
                                                isStringFound = true;
                                            }
                                        });
                                        Highcharts.chart("nodeAttributeHeatmapChart", {
                                            chart: {
                                                type: 'heatmap'
                                            },
                                            exporting: {
                                                enabled: false
                                            },
                                            boost: {
                                                useGPUTranslations: true
                                            },
                                            legend: {
                                                enabled: false
                                            },
                                            title: {
                                                text: ''
                                            },
                                            subtitle: {
                                                text: ''
                                            },
                                            xAxis: {
                                                title: {
                                                    text: vm.selectedXAxis.title
                                                },
                                                categories: vm.selectedXAxis.categories,
                                                labels: {
                                                    format: vm.selectedXAxis.title === 'Hours' || vm.selectedXAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                }
                                            },
                                            yAxis: {
                                                categories: vm.selectedYAxis.categories,
                                                title: {
                                                    text: vm.selectedYAxis.title
                                                },
                                                reversed: false,
                                                labels: {
                                                    format: vm.selectedYAxis.title === 'Hours' || vm.selectedYAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                },
                                                //startOnTick: false,
                                                endOnTick: false
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                            colorAxis: {
                                                maxColor: Highcharts.getOptions().colors[0]
                                            },
                                            tooltip: {
                                                formatter: function () {
                                                    var tooltip = '';
                                                    if (this.series.name === 'Connection') { //eslint-disable-line
                                                        tooltip = '<b>Node Connection: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    } else if (this.series.name === 'Value') { //eslint-disable-line
                                                        var displayName = '';
                                                        if (isStringFound) {
                                                            displayName = this.point.name ? this.point.name : null; //eslint-disable-line
                                                        } else {
                                                            displayName = this.point.value; //eslint-disable-line
                                                        }
                                                        tooltip = '<b>Value: ' + displayName + '</b>'; //eslint-disable-line
                                                    } else {
                                                        tooltip = '<b>Health: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    }
                                                    return tooltip //eslint-disable-line
                                                }
                                            },
                                            series: [{
                                                boostThreshold: 100,
                                                borderWidth: 0,
                                                data: chartData,
                                                name: chartName,
                                                nullColor: '#FFFFFF',
                                                turboThreshold: chartData.length + 100 // #3404, remove after 4.0.5 release
                                            }]
                                        })
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.fnRemoveChartData(vm.selectedHeatmapChartAttr);
                                    });
                            }
                        }
                        if (vm.selectedChartType === 'spline' || vm.selectedChartType === 'bar') {
                            vm.splineChartData = [];
                            _.forEach(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.type === 'node') {
                                    if (chartDataObj.chartType === 'nodeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            yAxis: 1,
                                            data: chartDataObj.chartData,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempNodeHealthArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempNodeHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthAnomalyArr);
                                        }
                                    } else {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            yAxis: 2,
                                            data: chartDataObj.chartData,
                                            tooltip: {
                                                formatter: function () {
                                                    return '<b>' + moment(this.point.x).format('MM/DD/YYYY HH:mm') + '</b><br><b style="color:' + this.point.color + '">' + this.point.series.name + '</b><br><b>' + this.point.name + '</b><br/>'; //eslint-disable-line
                                                }
                                            },
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempConnectionForecastArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionForecast'),
                                                type: 'arearange',
                                                yAxis: 2,
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionForecastArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempConnectionAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                yAxis: 2,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionAnomalyArr);
                                        }
                                    }
                                } else {
                                    if (chartDataObj.chartType === 'attributeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            data: chartDataObj.chartData,
                                            yAxis: 1,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var healthForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast')
                                            var tempHealthArr = {
                                                name: chartDataObj.name,
                                                data: healthForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthForecast.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var healthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly');
                                            var tempHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: healthAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthAnomaly.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthAnomalyArr);
                                        }
                                    } else {
                                        if (chartDataObj.value && isNaN(chartDataObj.value)) {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                yAxis: 3,
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        } else {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        }

                                        if (chartDataObj.dataType === 'Forecast') {
                                            var isStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueForecast');
                                            var tempArr = {
                                                name: chartDataObj.name,
                                                data: valueForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueForecast.length + 100
                                            };
                                            if (isStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var isAnomalyStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueAnomaly');
                                            var tempValueAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: valueAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueAnomaly.length + 100
                                            };
                                            if (isAnomalyStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempValueAnomalyArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempValueAnomalyArr);
                                        }
                                    }
                                }
                            });

                            var isFindNodeConnection = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeConnection') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[2].visible = !!isFindNodeConnection;
                            var isFindHealthAxes = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeHealth' || chartDataObj.chartType === 'attributeHealth') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[1].visible = !!isFindHealthAxes;
                            $timeout(function () {
                                Highcharts.chart('nodeAttributeChart', {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        type: 'datetime',
                                        labels: {
                                            formatter: function () {
                                                return moment(this.value).format('MM/DD HH:mm'); // eslint-disable-line
                                            },
                                            rotation: -60
                                        },
                                        title: {
                                            text: ''
                                        }
                                    },
                                    yAxis: vm.tempAxesData,
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    series: vm.splineChartData
                                });
                            });
                        }
                        vm.fnSortAttributesByPlot();
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRemoveChartData = function (selectedObj) {
                    var isFindIndex = _.findIndex(vm.selectedChartData, {name: selectedObj.name, id: selectedObj.id});
                    if (isFindIndex !== -1) {
                        vm.selectedChartData.splice(isFindIndex, 1);
                        vm.fnGenerateAttributesList();
                    }
                    var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindPieDataIndex !== -1) {
                        vm.pieChartAttributeList.splice(isFindPieDataIndex, 1);
                        if (vm.pieChartAttributeList && vm.pieChartAttributeList.length) {
                            vm.selectedPieChartData = vm.pieChartAttributeList[0];
                        } else {
                            vm.selectedPieChartData = "";
                        }
                    }
                    var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindHeatmapDataIndex !== -1) {
                        vm.heatmapChartAttributeList.splice(isFindHeatmapDataIndex, 1);
                        if (vm.heatmapChartAttributeList && vm.heatmapChartAttributeList.length) {
                            vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                        } else {
                            vm.selectedHeatmapChartAttr = '';
                        }
                    }
                    $timeout(function () {
                        vm.fnRenderChart();
                    });
                };

                vm.fnGetHealthColor = function (attrCode, attrObj) {
                    var attrStyle = ColorService.getHealthColorForLoop(attrObj.projectId, attrCode);
                    attrObj.healthName = attrStyle.content;
                    return attrStyle;
                };

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };

                vm.fnGetNodeInfo = function () {
                    vm.nodeObj = _.cloneDeepWith(vm.parent.nodeObj);
                    _.forEach(vm.nodeObj.attributes, function (attrObj) {
                        attrObj.rt = attrObj.name;
                        attrObj.nodeName = vm.nodeObj.name;
                    })
                    vm.resetNodeObj = angular.copy(vm.nodeObj);
                    vm.isNodeDetailsLoaded = true;
                    vm.attributesList = [];
                    vm.attributesList.push({
                        name: 'Node',
                        displayName: 'Node',
                        nodeName: vm.nodeObj.name,
                        connected: vm.nodeObj.connected,
                        id: vm.nodeObj.id,
                        type: 'node',
                        health: vm.nodeObj.health,
                        projectId: vm.nodeObj.projectId,
                        isSelected: _.findIndex(vm.selectedChartData, {name: 'Node (Actual Connection)'}) !== -1
                    });
                    vm.nodeObj.attributes = _.orderBy(vm.nodeObj.attributes, ['name'], ['asc']);
                    vm.nodeObj.attributes = _.filter(vm.nodeObj.attributes, function (attrObj) {
                        return attrObj.reference.endsWith('!');
                    })
                    if (vm.nodeObj.attributes.length > vm.perPage) {
                        vm.resetAttributeLists = _.cloneDeepWith(vm.nodeObj.attributes.slice(0, vm.perPage));
                    } else {
                        vm.resetAttributeLists = _.cloneDeepWith(vm.nodeObj.attributes);
                    }
                    vm.totalItems = vm.nodeObj.attributes.length;
                    vm.fnGenerateAttributesList();
                    $timeout(function () {
                        TabHeight.fnSet();
                        vm.fnRenderChart();
                        var start = moment().subtract(3, 'hours');
                        var end = moment();
                        $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            opens: 'left',
                            startDate: start,
                            endDate: end,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            ranges: {
                                'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                                'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                                'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                                'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                                'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                                'Today': [moment().startOf('day'), moment()],
                                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                            },
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end, label) {
                            if (label === 'Custom Range') {
                                vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                            } else {
                                if (label === "Last 1 Hour") {
                                    vm.selectedRange = moment().subtract(1, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Hour") {
                                    vm.selectedRange = moment().subtract(3, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Days") {
                                    vm.selectedRange = moment().subtract(3, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 1 Week") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Week") {
                                    vm.selectedRange = moment().subtract(20, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Today") {
                                    vm.selectedRange = moment().startOf('day').format('X') + "," + moment().format('X');
                                } else if (label === "Yesterday") {
                                    vm.selectedRange = moment().subtract(1, 'days').startOf('day').format('X') + "," + moment().subtract(1, 'days').endOf('days').format('X');
                                } else if (label === "Last 7 Days") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 30 Days") {
                                    vm.selectedRange = moment().subtract(29, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "This Month") {
                                    vm.selectedRange = moment().startOf('month').format('X') + "," + moment().endOf('month').format('X');
                                } else {//"Last Month"
                                    vm.selectedRange = moment().subtract(1, 'month').startOf('month').format('X') + "," + moment().subtract(1, 'month').endOf('month').format('X');
                                }
                            }
                            if (angular.isDefined(angular.element("#selectedDate")[0])) {
                                document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                            }
                            var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                            var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                            var timeDifference = moment(endTime).diff(startTime, 'hours');
                            var rangeDiff = 1;
                            var rangeType = 'MINUTES';
                            if (timeDifference <= 1) {
                                rangeDiff = 1;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 1 && timeDifference <= 3) {
                                rangeDiff = 2;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 3 && timeDifference <= 6) {
                                rangeDiff = 5;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 6 && timeDifference <= 12) {
                                rangeDiff = 15;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 12 && timeDifference <= 24) {
                                rangeDiff = 30;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 24 && timeDifference <= 72) {
                                rangeDiff = 1;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 72 && timeDifference <= 168) {
                                rangeDiff = 3;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 168 && timeDifference <= 720) {
                                rangeDiff = 6;
                                rangeType = 'HOURS';
                            } else {
                                rangeDiff = 1;
                                rangeType = 'DAYS';
                            }
                            var isFind = _.find(vm.granularityArr, function (obj) {
                                return obj.config.title === rangeType && obj.config.value === rangeDiff;
                            })
                            if (isFind) {
                                vm.selectedGranularity = _.cloneDeepWith(isFind);
                            }
                            //vm.fnRenderChart();
                            vm.fnDataRangeChange();
                        });
                        vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                        }
                    })
                };

                vm.fnSelectPieChartAttr = function (chartObj) {
                    var isFind = _.find(vm.pieChartAttributeList, {name: chartObj.name});
                    if (isFind) {
                        vm.selectedPieChartData = isFind;
                        $timeout(function () {
                            vm.fnRenderChart();
                        })
                    }
                };

                /*vm.fnGetSQLQuery = function (srcList) {
                    var previousDateString = "";
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                    var sql = "";
                    var totalDuration = endTime.diff(startTime);
                    var rangeDiff = '';
                    var rangeType = 'MINUTES'; //MINUTES, HOURS, DAYS
                    var totalRange = '';
                    rangeDiff = vm.selectedGranularity.config.value;
                    rangeType = vm.selectedGranularity.config.title;
                    totalRange = parseInt(totalDuration / vm.selectedGranularity.config.time);
                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    if (rangeType !== 'DAYS') {
                        if (srcList.type === 'node') {
                            if (srcList.chartType === 'nodeHealth') {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        "FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        " FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.health) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health FROM slot_healths ORDER BY ts;";
                                }
                            } else {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_connection_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_connection_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value " +
                                        "FROM node_iot_node_connections WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value " +
                                        " FROM node_iot_node_connections WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.value) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value FROM slot_values ORDER BY ts;";
                                }
                            }

                        } else {
                            if (srcList.chartType === 'attributeHealth') {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        "FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        " FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.health) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health FROM slot_healths ORDER BY ts;";
                                }
                            } else {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_value_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_value_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_value_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_value_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value " +
                                        "FROM node_iot_attribute_values WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value " +
                                        " FROM node_iot_attribute_values WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.value) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value FROM slot_values ORDER BY ts;";
                                }
                            }
                        }
                    } else {
                        //previousDateString = moment.unix(parseInt(vm.selectedRange.split(',')[0])).subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                        if (srcList.type === 'node') {
                            if (srcList.chartType === 'nodeHealth') {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(data->>'health') AS last_val, slot_agg_val," +
                                        " MAX(data->>'confidence') AS last_confidence, slot_agg_confidence," +
                                        " MAX(data->>'type') AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.data->>'health') AS slot_agg_val, " +
                                        " MAX(in_interval_r.data->>'confidence') AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.data->>'type') AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(data->>'health') AS last_val, slot_agg_val," +
                                        " MAX(data->>'confidence') AS last_confidence, slot_agg_confidence," +
                                        " MAX(data->>'type') AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.data->>'health') AS slot_agg_val, " +
                                        " MAX(in_interval_r.data->>'confidence') AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.data->>'type') AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        "FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        " FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(data->>'health') AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.data->>'health') AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health FROM slot_healths ORDER BY ts;";
                                }
                            } else {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type " +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type " +
                                        " FROM slot_values ORDER BY ts;";
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_node_connection_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_node_connection_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type " +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type " +
                                        " FROM slot_values ORDER BY ts;";
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value " +
                                        "FROM node_iot_node_connections WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'nodeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->'connected' AS value " +
                                        " FROM node_iot_node_connections WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.data->'connected') AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value FROM slot_values ORDER BY ts;";
                                }
                            }

                        } else {
                            if (srcList.chartType === 'attributeHealth') {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts ;"
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.health) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_healths ORDER BY ts ;"
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        "FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'health' AS health " +
                                        " FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.health) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health FROM slot_healths ORDER BY ts ;"
                                }
                            } else {
                                if (srcList.dataType === 'Forecast') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_value_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_value_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts ;"
                                } else if (srcList.dataType === 'Anomaly') {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        "FROM node_iot_attribute_value_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value, data->>'confidence' AS confidence, data->>'type' AS type " +
                                        " FROM node_iot_attribute_value_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                        " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                        " MAX(type) AS last_type, slot_agg_type FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                        " MAX(in_interval_r.value) AS slot_agg_val, " +
                                        " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                        " MAX(in_interval_r.type) AS slot_agg_type" +
                                        " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts," +
                                        " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value," +
                                        " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                        " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                        " FROM slot_values ORDER BY ts ;"
                                } else {
                                    sql = "WITH readings AS ( (SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value " +
                                        "FROM node_iot_attribute_values WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                        " UNION ( SELECT timestamp AS timestamps, data->>'attributeId' AS id, DATE_TRUNC('second', to_timestamp(timestamp)) AS ts, data->>'value' AS value " +
                                        " FROM node_iot_attribute_values WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                        " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * u.i AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 day' * (u.i + " + rangeDiff + ") AS ts FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                        " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                        " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.value) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                        " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                        " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS text) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS value FROM slot_values ORDER BY ts ;"
                                }
                            }
                        }
                    }
                    return sql;
                };*/

                vm.fnGetSQLQuery = function (srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                    var sql = '';
                    var totalDuration = endTime.diff(startTime);
                    var rangeDiff = vm.selectedGranularity.config.value;
                    var rangeType = vm.selectedGranularity.config.title; // MINUTES, HOURS, DAYS
                    var totalRange = parseInt(totalDuration / vm.selectedGranularity.config.time);

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields) {
                        var fields = ['timestamp AS timestamps', 'data->>\'' + idField + '\' AS id',
                            'DATE_TRUNC(\'second\', to_timestamp(timestamp)) AS ts'];

                        valueFields.forEach(function(field) {
                            fields.push('data->\'' + field.name + '\' AS ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->\'' + field + '\' AS ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp(timestamp)) < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp(timestamp)) > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp(timestamp)) < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots() {
                        if (rangeType !== 'DAYS') {
                            return 'SELECT TIMESTAMP \'' + previousDateString + '\' + ' + rangeType + '(u.i - ' + rangeDiff + ') AS last_ts, ' +
                                'TIMESTAMP \'' + previousDateString + '\' + ' + rangeType + '(u.i) AS ts ' +
                                'FROM generate_series(0, ' + totalRange + ', ' + rangeDiff + ') AS u(i)';
                        } else {
                            return 'SELECT TIMESTAMP \'' + previousDateString + '\' + INTERVAL \'1 day\' * u.i AS last_ts, ' +
                                'TIMESTAMP \'' + previousDateString + '\' + INTERVAL \'1 day\' * (u.i + ' + rangeDiff + ') AS ts ' +
                                'FROM generate_series(0, ' + totalRange + ', ' + rangeDiff + ') AS u(i)';
                        }
                    }

                    function buildAggregationQuery(valueAlias, additionalFields) {
                        var baseFields = ['filled_slots.ts', 'MAX(' + valueAlias + ') AS last_val', 'slot_agg_val'];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = '(SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) last_previous_time, ' +
                            'MAX(in_interval_r.' + valueAlias + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS text) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        node: {
                            nodeHealth: {
                                base: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            nodeConnection: {
                                base: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'connected', alias: 'value' }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value' }
                            }
                        }
                    };

                    var config = srcList.type === 'node' ?
                        tableConfig.node[srcList.chartType === 'nodeHealth' ? 'nodeHealth' : 'nodeConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields) +
                        '), slots AS (' + buildTimeSlots() +
                        '), slot_values AS ' + buildAggregationQuery(config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_values ORDER BY ts;';

                    return sql;
                };


                vm.fnGetHeatMapSQLQuery = function (srcList) {
                    var startDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var selectedXAxisQString = "";
                    var selectedYAxisQString = "";
                    if (vm.selectedXAxis.title === 'Minutes') {
                        selectedXAxisQString = "EXTRACT(MINUTE FROM to_timestamp(timestamp)) as x";
                    } else if (vm.selectedXAxis.title === 'Hours') {
                        selectedXAxisQString = "EXTRACT(HOUR FROM to_timestamp(timestamp)) as x";
                    } else if (vm.selectedXAxis.title === 'Days') {
                        selectedXAxisQString = "EXTRACT(DOW FROM to_timestamp(timestamp)) as x";
                    } else if (vm.selectedXAxis.title === 'Weeks') {
                        selectedXAxisQString = "EXTRACT(WEEK FROM to_timestamp(timestamp)) as x";
                    } else {
                        selectedXAxisQString = "EXTRACT(MONTH FROM to_timestamp(timestamp)) as x";
                    }
                    if (vm.selectedYAxis.title === 'Minutes') {
                        selectedYAxisQString = "EXTRACT(MINUTE FROM to_timestamp(timestamp)) as y";
                    } else if (vm.selectedYAxis.title === 'Hours') {
                        selectedYAxisQString = "EXTRACT(HOUR FROM to_timestamp(timestamp)) as y";
                    } else if (vm.selectedYAxis.title === 'Days') {
                        selectedYAxisQString = "EXTRACT(DOW FROM to_timestamp(timestamp)) as y";
                    } else if (vm.selectedYAxis.title === 'Weeks') {
                        selectedYAxisQString = "EXTRACT(WEEK FROM to_timestamp(timestamp)) as y";
                    } else {
                        selectedYAxisQString = "EXTRACT(MONTH FROM to_timestamp(timestamp)) as y";
                    }

                    var sql = "";
                    if (srcList.type === "node") {
                        if (srcList.chartType === 'nodeHealth') {
                            sql = "SELECT to_timestamp(timestamp) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN valueType = 'FLOAT' THEN CAST(health AS FLOAT) ELSE health END as health, health as value, projectId " +
                                "FROM node_iot_node_healths " +
                                "WHERE to_timestamp(timestamp) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp(timestamp) < TIMESTAMP '" + endDateString + "' " +
                                "AND nodeId = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp(timestamp) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN connectedType = 'BOOLEAN' THEN CAST(connected AS BOOLEAN) ELSE connected END as connected, connected as value " +
                                "FROM node_iot_node_connections " +
                                "WHERE to_timestamp(timestamp) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp(timestamp) < TIMESTAMP '" + endDateString + "' " +
                                "AND nodeId = '" + srcList.id + "'";
                        }
                    } else {
                        if (srcList.chartType === 'attributeHealth') {
                            sql = "SELECT to_timestamp(timestamp) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN valueType = 'FLOAT' THEN CAST(value AS FLOAT) ELSE value END as value, health as value, projectId " +
                                "FROM node_iot_attribute_healths " +
                                "WHERE to_timestamp(timestamp) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp(timestamp) < TIMESTAMP '" + endDateString + "' " +
                                "AND attributeId = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp(timestamp) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN valueType = 'FLOAT' THEN CAST(value AS FLOAT) ELSE value END as value " +
                                "FROM node_iot_attribute_values " +
                                "WHERE to_timestamp(timestamp) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp(timestamp) < TIMESTAMP '" + endDateString + "' " +
                                "AND attributeId = '" + srcList.id + "'";
                        }
                    }

                    return sql;
                };

                vm.fnGenerateHeatMapChartData = function (srcList, apiRes) {
                    var chartData = [];
                    var isStringFound = false;
                    vm.heatmapAttributeStringValueArr = [];
                    _.forEach(apiRes, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                        if (dataObj.value && dataObj.value !== '' && vm.heatmapAttributeStringValueArr.indexOf(dataObj.value) === -1) {
                            vm.heatmapAttributeStringValueArr.push(dataObj.value);
                        }
                    });
                    if (!isStringFound) {
                        vm.heatmapAttributeStringValueArr = [];
                    }
                    _.forEach(vm.selectedXAxis.categories, function (xAxisCategoriesObj, xAxisIndex) {
                        _.forEach(vm.selectedYAxis.categories, function (yAxisCategoriesObj, yAxisIndex) {
                            var newXAxisIndex = _.cloneDeepWith(xAxisIndex);
                            var newYAxisIndex = _.cloneDeepWith(yAxisIndex);
                            if (vm.selectedXAxis.title === 'Days' || vm.selectedXAxis.title === 'Months') {
                                newXAxisIndex = newXAxisIndex + 1;
                            }
                            if (vm.selectedYAxis.title === 'Days' || vm.selectedYAxis.title === 'Months') {
                                newYAxisIndex = newYAxisIndex + 1;
                            }
                            var minValue = 0;
                            var maxValue = 0;
                            var avgValue = 0;
                            var isFindData = _.filter(apiRes, {x: newXAxisIndex, y: newYAxisIndex});
                            if (isFindData && isFindData.length) {
                                minValue = isFindData[0].value;
                                maxValue = isFindData[0].value;
                                var sum = 0;
                                avgValue = 0;
                                if (srcList.chartType === 'nodeConnection') {
                                    if (isFindData && isFindData.length > 1) {
                                        var connectedArr = _.filter(isFindData, {value: true});
                                        var disconnectedArr = _.filter(isFindData, {value: false});
                                        minValue = connectedArr.length < disconnectedArr.length;
                                        maxValue = connectedArr.length >= disconnectedArr.length;
                                        avgValue = isFindData.reduce(function (sum, next) {
                                            return sum && next.value;
                                        }, true);
                                    } else {
                                        minValue = isFindData[0].value;
                                        maxValue = isFindData[0].value;
                                        avgValue = isFindData[0].value;
                                    }
                                } else {
                                    if (isStringFound) {
                                        if (isFindData && isFindData.length > 1) {
                                            var groupData = _.groupBy(isFindData, function (n) {
                                                return n.value;
                                            });
                                            var minLength = Object.values(groupData)[0].length;
                                            var maxLength = Object.values(groupData)[0].length;
                                            minValue = Object.keys(groupData)[0];
                                            maxValue = Object.keys(groupData)[0];
                                            _.forEach(isFindData, function (findObj, key) {
                                                if (findObj.length < minLength) {
                                                    minValue = key;
                                                    minLength = findObj.length;
                                                }
                                                if (findObj.length > maxLength) {
                                                    maxValue = key;
                                                    maxLength = findObj.length;
                                                }
                                            });
                                            avgValue = isFindData.reduce(function (sum, next) {
                                                return sum && next.value;
                                            }, true);
                                        } else {
                                            minValue = isFindData[0].value;
                                            maxValue = isFindData[0].value;
                                            avgValue = isFindData[0].value;
                                        }
                                    } else {
                                        _.forEach(isFindData, function (findObj) {
                                            findObj.value = Number(findObj.value);
                                            if (findObj.value < minValue) {
                                                minValue = findObj.value;
                                            }
                                            if (findObj.value > maxValue) {
                                                maxValue = findObj.value;
                                            }
                                            sum = sum + findObj.value;
                                        });
                                        avgValue = sum / isFindData.length;
                                    }
                                }
                                var value = null;
                                if (vm.selectedMathFunction === 'MIN') {
                                    value = minValue;
                                } else if (vm.selectedMathFunction === 'MAX') {
                                    value = maxValue;
                                } else {
                                    value = avgValue;
                                }
                                if (srcList.chartType === 'nodeHealth') {
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value,
                                        color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                    })
                                } else if (srcList.chartType === 'nodeConnection') {
                                    var tempConnectionObj = _.find(connectionArr, {value: value === true ? 1 : -1});
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value !== '' ? tempConnectionObj.name : null,
                                        color: value !== '' ? tempConnectionObj.color : '#FFFFFF'
                                    })
                                } else {
                                    if (srcList.chartType === 'attributeValue') {
                                        if (isStringFound) {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: vm.heatmapAttributeStringValueArr.indexOf(value),
                                                name: value
                                            })
                                        } else {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: Number(value)
                                            })
                                        }
                                    } else {
                                        chartData.push({
                                            x: xAxisIndex,
                                            y: yAxisIndex,
                                            value: value,
                                            color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                        })
                                    }
                                }
                            } else {
                                chartData.push({
                                    x: xAxisIndex,
                                    y: yAxisIndex,
                                    value: null
                                });
                            }

                        })
                    });
                    return chartData;
                };

                vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    if (srcList.type === 'node') {
                        if (srcList.chartType === 'nodeHealth') {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health ? Number(dataObj.health) : null]);
                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    var tempConnectionObj = _.find(connectionArr, {value: dataObj.value === true ? 1 : -1});
                                    tempData.push({
                                        x: parseInt(dataObj.timestamp),
                                        y: dataObj.value ? tempConnectionObj.value : 0,
                                        name: dataObj.value ? tempConnectionObj.name : 'No Data Found',
                                        color: dataObj.value ? tempConnectionObj.color : '#808080'
                                    });
                                })
                            });
                        }
                    } else {
                        if (srcList.chartType === 'attributeValue') {
                            var isStringFound = false;
                            _.forEach(resData, function (dataObj) {
                                if (dataObj.value && isNaN(dataObj.value)) {
                                    isStringFound = true;
                                }
                            });
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    if (isStringFound) {
                                        if (dataObj.value && dataObj.value !== '' && vm.attributesStringValueArr.indexOf(dataObj.value) === -1) {
                                            vm.attributesStringValueArr.push(dataObj.value);
                                        }
                                        tempData.push([parseInt(dataObj.timestamp), vm.attributesStringValueArr.indexOf(dataObj.value) === -1 ? null : vm.attributesStringValueArr.indexOf(dataObj.value)]);
                                    } else {
                                        tempData.push([parseInt(dataObj.timestamp), dataObj.value ? Number(dataObj.value) : null]);
                                    }

                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health === 0 || dataObj.health > 0 ? Number(dataObj.health) : null]);
                                })
                            });
                        }
                    }
                    return tempData;
                };

                vm.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData.apiData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = vm.attributesStringValueArr.indexOf(tempDataObj.value) === -1 ? 0 : vm.attributesStringValueArr.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                vm.fnDataRangeChange = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        var chartContainerEle = angular.element(".chart-container-height");
                        loaderModalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                            size: 'md',
                            controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                            windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                            appendTo: chartContainerEle
                        });
                        count = 1;
                        vm.fnBatchOperation(batchCollectionObj, count);
                    }
                };

                vm.fnBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                _.forEach(response, function (responseObj, index) {
                                    var sql = angular.fromJson(responseObj.request.body);
                                    vm.selectedChartData[index].sql = sql.sql;
                                    var parsedData = parsePostgresData(responseObj.body.data);

                                    vm.selectedChartData[index].apiData = parsedData;
                                    vm.selectedChartData[index].chartData = vm.fnGenerateChartData(vm.selectedChartData[index], parsedData);
                                    var isFind = _.find(vm.pieChartAttributeList, {
                                        name: vm.selectedChartData[index].name,
                                        id: vm.selectedChartData[index].id
                                    });
                                    if (isFind) {
                                        isFind.apiData = responseObj.body.data;
                                        isFind.chartData = vm.selectedChartData[index].chartData;
                                    }
                                });
                                $timeout(function () {
                                    if (vm.selectedChartType !== 'heatmap') {
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                    }
                                    if (vm.selectedChartType === 'pie') {
                                        vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                    } else {
                                        vm.fnRenderChart();
                                    }
                                })
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                if (vm.selectedChartType !== 'heatmap') {
                                    loaderModalInstance.dismiss();
                                    loaderModalInstance = "";
                                }
                                if (vm.selectedChartType === 'pie') {
                                    vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                } else {
                                    vm.fnRenderChart();
                                }
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnEditAttributeName = function (selectedObj, dataType) {
                    var tempSelectedObj = _.cloneDeepWith(selectedObj);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditNameModal/attributeEditNameModal.html',
                        size: 'lg',
                        controller: 'attributeEditNameModalCtrl as attributeEditModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        var isFindInAttributeList = _.findIndex(vm.attributesList, {id: res.id});
                        if (isFindInAttributeList !== -1) {
                            vm.attributesList[isFindInAttributeList].name = res.name;
                            vm.attributesList[isFindInAttributeList].displayName = res.name;
                        }
                        var isFindInChartData = _.filter(vm.selectedChartData, {id: selectedObj.id});
                        if (isFindInChartData.length) {
                            _.forEach(isFindInChartData, function (chartObj) {
                                var tempChartType = "Value";
                                if (chartObj.chartType === 'attributeValue') {
                                    tempChartType = "Value"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Value)";
                                } else {
                                    tempChartType = "Health"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Health)";
                                }
                                chartObj.displayName = _.cloneDeepWith(res.name);
                                var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindPieDataIndex !== -1) {
                                    vm.pieChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.pieChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedPieChartData.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedPieChartData.name = vm.pieChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedPieChartData.displayName = res.name;
                                    }
                                }
                                var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindHeatmapDataIndex !== -1) {
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedHeatmapChartAttr.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedHeatmapChartAttr.name = vm.heatmapChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedHeatmapChartAttr.displayName = res.name;
                                    }
                                }
                            })
                        }
                        $timeout(function () {
                            vm.fnRenderChart();
                        });
                    }, function () {

                    });
                };

                vm.fnEditAttributeValue = function (selectedObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditValueModal/attributeEditValueModal.html',
                        size: 'lg',
                        controller: 'attributeEditValueModalCtrl as attributeEditValue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (jobRes) {
                        vm.fnGetEcu(selectedObj, jobRes);
                    }, function () {
                    });
                };

                vm.fnGetEcu = function (selectedObj, jobRes) {
                    var inputObj = {
                        ecuId: selectedObj.ecuId
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            vm.ecuObj = response;
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/node/modals/attributeValueUpdateTerminal/attributeValueUpdateTerminal.html',
                                size: 'lg',
                                controller: 'attributeValueUpdateTerminalCtrl as attributeValueUpdateTerminal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(jobRes);
                                    },
                                    ecuObj: function () {
                                        return _.cloneDeepWith(vm.ecuObj);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                            }, function () {
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnSelectAttribute = function (attributeObj) {
                    vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                    vm.selectedAttribute.name = _.cloneDeepWith(attributeObj.displayName);
                    if (vm.selectedAttribute.type === 'node') {
                        vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                            name: vm.selectedAttribute.name + " (Actual Connection)",
                            id: vm.selectedAttribute.id
                        }) !== -1;
                    } else {
                        vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                            name: vm.selectedAttribute.name + " (Actual Value)",
                            id: vm.selectedAttribute.id
                        }) !== -1;
                    }
                    vm.selectedAttribute.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                };

                vm.fnSelectedAttributeCopyToClipboard = function (key, attribute) {
                    attribute[key + 'IsCopyClicked'] = true;
                    copyService.fnCopyToClipboard(attribute[key]);
                    $timeout(function () {
                        delete attribute[key + 'IsCopyClicked'];
                    }, 2000)
                };

                vm.fnIsAttributeSelected = function () {
                    return !!vm.selectedAttribute && Object.keys(vm.selectedAttribute).length;
                };

                vm.fnOpenNodeInfo = function () {
                    if (vm.selectedAttribute.ecuId === vm.selectedAttribute.nodeId) {
                        $state.go('main.ecu', {selectedId: vm.selectedAttribute.ecuId});
                    } else {
                        $scope.$emit('openNodeDetail', vm.parent.nodeObj);
                    }
                };

                vm.fnEnableAttribute = function (attributeObj) {
                    swal({
                            title: "Enable the selected Attribute?",
                            text: "You are about to enable selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };
                                NodeAttributesFactory.enableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute enabling process cancelled", "error");
                            }
                        });
                };

                vm.fnDisableAttribute = function (attributeObj) {
                    swal({
                            title: "Disable the selected Attribute?",
                            text: "You are about to disable the selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };

                                NodeAttributesFactory.disableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute disable process cancelled", "error");
                            }
                        });
                };

                vm.fnSelectAutoUpdateChart = function () {
                    if (vm.selectedAutoUpdateType === 'Static') {
                        $timeout.cancel(vm.chartUpdateTimeout);
                    } else {
                        vm.chartUpdateTimeout = $timeout(function () {
                            vm.fnUpdateDateRangeInput();
                        }, 60000);
                    }
                };

                vm.fnUpdateDateRangeInput = function () {
                    var oldT = vm.selectedRange.split(',');
                    var newStart = moment.unix(parseInt(oldT[0])).add(1, 'minutes').format('X')
                    var newEnd = moment.unix(parseInt(oldT[1])).add(1, 'minutes').format('X')
                    vm.selectedRange = newStart + "," + newEnd;
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (moment.unix(parseInt(newStart)).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(parseInt(newEnd)).format('YYYY/MM/DD HH:mm'));
                    }
                    if (vm.selectedChartData && vm.selectedChartData.length) {
                        vm.fnGetChartUpdateData();
                    }
                    vm.chartUpdateTimeout = $timeout(function () {
                        vm.fnUpdateDateRangeInput();
                    }, 60000);
                };

                /*vm.fnGetUpdateChartSQLQuery = function (srcList) {
                    var previousDateString = "";
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var sql = "";
                    var rangeDiff = 1;
                    var rangeType = 'MINUTES'; //MINUTES, HOURS, DAYS
                    var totalRange = 1;
                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).subtract(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    if (srcList.type === 'node') {
                        if (srcList.chartType === 'nodeHealth') {
                            if (srcList.dataType === 'Forecast') {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_health_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * (u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * u.i AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.health) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS health," +
                                    " COALESCE( slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER( ORDER BY ts ), last_confidence ) AS confidence," +
                                    " COALESCE( slot_agg_type, LAG(slot_agg_type, 1) OVER( ORDER BY ts ), last_type ) AS type" +
                                    " FROM slot_healths ORDER BY ts ;"
                        } else if (srcList.dataType === 'Anomaly') {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_health_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * (u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * u.i AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.health) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS health," +
                                    " COALESCE( slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER( ORDER BY ts ), last_confidence ) AS confidence," +
                                    " COALESCE( slot_agg_type, LAG(slot_agg_type, 1) OVER( ORDER BY ts ), last_type ) AS type" +
                                    " FROM slot_healths ORDER BY ts ;"
                            } else {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health " +
                                    "FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->>'health' as health " +
                                    "FROM node_iot_node_healths WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * (u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * u.i AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.health) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts, COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS health FROM slot_healths ORDER BY ts ;"
                            }
                        } else {
                            if (srcList.dataType === 'Forecast') {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->'connected' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' " +
                                    "AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 ) " +
                                    " UNION ( SELECT timestamp as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, " +
                                    "data->'connected' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_connection_forecasts WHERE data->>'nodeId' = '" + srcList.id + "' " +
                                    "AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) ), " +
                                    "slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * (u.i - " + rangeDiff + ") AS last_ts, " +
                                    "TIMESTAMP '" + previousDateString + "' + INTERVAL '1 " + rangeType + "' * u.i AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) ), " +
                                    "slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val, " +
                                    "MAX(confidence) AS last_confidence, slot_agg_confidence, " +
                                    "MAX(type) AS last_type, slot_agg_type FROM " +
                                    "(SELECT slots.ts, MAX(previous_r.ts) last_previous_time, " +
                                    "MAX(in_interval_r.value) AS slot_agg_val, " +
                                    "MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    "MAX(in_interval_r.type) AS slot_agg_type " +
                                    "FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts " +
                                    "LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts " +
                                    "GROUP BY slots.ts) filled_slots " +
                                    "LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts " +
                                    "GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type) " +
                                    "SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts, " +
                                    "COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER(ORDER BY ts), last_val) AS value, " +
                                    "COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER(ORDER BY ts), last_confidence) AS confidence, " +
                                    "COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER(ORDER BY ts), last_type) AS type " +
                                    "FROM slot_values ORDER BY ts ;"
                        } else if (srcList.dataType === 'Anomaly') {
                                sql = "WITH readings AS ( (SELECT data->>'timestamp' as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->'connected' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_node_connection_anomalies where data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT data->>'timestamp' as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->'connected' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    " FROM node_iot_node_connection_anomalies WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM UNNEST(SEQUENCE(1, " + totalRange + ", " + rangeDiff + ") AS i) AS u )," +
                                    " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.value) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value," +
                                    " COALESCE( slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER( ORDER BY ts ), last_confidence ) AS confidence," +
                                    " COALESCE( slot_agg_type, LAG(slot_agg_type, 1) OVER( ORDER BY ts ), last_type ) AS type" +
                                    " FROM slot_values ORDER BY ts ;"
                            } else {
                                sql = "WITH readings AS ( (SELECT data->>'timestamp' as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->'connected' as value " +
                                    "FROM node_iot_node_connections where data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT data->>'timestamp' as timestamps, data->>'nodeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->'connected' as value " +
                                    " FROM node_iot_node_connections WHERE data->>'nodeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM UNNEST(SEQUENCE(1, " + totalRange + ", " + rangeDiff + ") AS i) AS u )," +
                                    " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.value) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts, COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value FROM slot_values ORDER BY ts ;"
                            }
                        }

                    } else {
                        if (srcList.chartType === 'attributeHealth') {
                            if (srcList.dataType === 'Forecast') {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    " FROM node_iot_attribute_health_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.health) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                    " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                    " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                    " FROM slot_healths ORDER BY ts ;"
                            } else if (srcList.dataType === 'Anomaly') {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health, data->>'confidence' as confidence, data->>'type' as type " +
                                    " FROM node_iot_attribute_health_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.health) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health," +
                                    " COALESCE(slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), last_confidence) AS confidence," +
                                    " COALESCE(slot_agg_type, LAG(slot_agg_type, 1) OVER (ORDER BY ts), last_type) AS type" +
                                    " FROM slot_healths ORDER BY ts ;"
                            } else {
                                sql = "WITH readings AS ( (SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health " +
                                    "FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT timestamp as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp(timestamp)) as ts, data->>'health' as health " +
                                    " FROM node_iot_attribute_healths WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp(timestamp)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_healths AS ( SELECT filled_slots.ts, MAX(health) AS last_val, slot_agg_val FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.health) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts, COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS health FROM slot_healths ORDER BY ts ;"
                            }
                        } else {
                            if (srcList.dataType === 'Forecast') {
                                sql = "WITH readings AS ( (SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_attribute_value_forecasts where data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    " FROM node_iot_attribute_value_forecasts WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.value) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value," +
                                    " COALESCE( slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER( ORDER BY ts ), last_confidence ) AS confidence," +
                                    " COALESCE( slot_agg_type, LAG(slot_agg_type, 1) OVER( ORDER BY ts ), last_type ) AS type" +
                                    " FROM slot_values ORDER BY ts ;"
                            } else if (srcList.dataType === 'Anomaly') {
                                sql = "WITH readings AS ( (SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    "FROM node_iot_attribute_value_anomalies where data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value, data->>'confidence' as confidence, data->>'type' as type " +
                                    " FROM node_iot_attribute_value_anomalies WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM generate_series(1, " + totalRange + ", " + rangeDiff + ") AS u(i) )," +
                                    " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val," +
                                    " MAX(confidence) AS last_confidence, slot_agg_confidence," +
                                    " MAX(type) AS last_type, slot_agg_type FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time," +
                                    " MAX(in_interval_r.value) AS slot_agg_val, " +
                                    " MAX(in_interval_r.confidence) AS slot_agg_confidence, " +
                                    " MAX(in_interval_r.type) AS slot_agg_type" +
                                    " FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val, slot_agg_confidence, slot_agg_type)" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts," +
                                    " COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value," +
                                    " COALESCE( slot_agg_confidence, LAG(slot_agg_confidence, 1) OVER( ORDER BY ts ), last_confidence ) AS confidence," +
                                    " COALESCE( slot_agg_type, LAG(slot_agg_type, 1) OVER( ORDER BY ts ), last_type ) AS type" +
                                    " FROM slot_values ORDER BY ts ;"
                            } else {
                                sql = "WITH readings AS ( (SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value " +
                                    "FROM node_iot_attribute_values where data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + previousDateString + "' ORDER BY ts DESC LIMIT 1 )" +
                                    " UNION ( SELECT data->>'timestamp' as timestamps, data->>'attributeId' as id, DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) as ts, data->>'value' as value " +
                                    " FROM node_iot_attribute_values WHERE data->>'attributeId' = '" + srcList.id + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) > TIMESTAMP '" + previousDateString + "' AND DATE_TRUNC('second', to_timestamp((data->>'timestamp')::bigint)) < TIMESTAMP '" + endDateString + "' ) )," +
                                    " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i - " + rangeDiff + ") AS last_ts, TIMESTAMP '" + previousDateString + "' + " + rangeType + "(u.i) AS ts FROM UNNEST(SEQUENCE(1, " + totalRange + ", " + rangeDiff + ") AS i) AS u )," +
                                    " slot_values AS ( SELECT filled_slots.ts, MAX(value) AS last_val, slot_agg_val FROM" +
                                    " (SELECT slots.ts, MAX(previous_r.ts) last_previous_time, MAX(in_interval_r.value) AS slot_agg_val FROM slots LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts GROUP BY slots.ts) filled_slots" +
                                    " LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts GROUP BY filled_slots.ts, slot_agg_val )" +
                                    " SELECT CAST(ts AT TIME ZONE '" + timezoneName + "' AS string) AS ts, COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value FROM slot_values ORDER BY ts ;"
                            }
                        }
                    }
                    return sql;
                };*/

                vm.fnGetUpdateChartSQLQuery = function (srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var sql = '';
                    var rangeDiff = 1;
                    var rangeType = 'MINUTES'; //MINUTES, HOURS, DAYS
                    var totalRange = 1;

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).subtract(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields, useTimestampCast) {
                        var fields = [
                            (useTimestampCast ? 'data->>\'timestamp\' as timestamps' : 'timestamp as timestamps'),
                            'data->\'' + idField + '\' as id',
                            (useTimestampCast ?
                                'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) as ts' :
                                'DATE_TRUNC(\'second\', to_timestamp(timestamp)) as ts')
                        ];

                        valueFields.forEach(function(field) {
                            fields.push('data->' + (field.useArrow ? '>>' : '') + '\'' + field.name + '\' as ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->\'' + field + '\' as ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            (useTimestampCast ?
                                'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' :
                                'DATE_TRUNC(\'second\', to_timestamp(timestamp))') +
                            ' < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            (useTimestampCast ?
                                'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' :
                                'DATE_TRUNC(\'second\', to_timestamp(timestamp))') +
                            ' > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            (useTimestampCast ?
                                'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' :
                                'DATE_TRUNC(\'second\', to_timestamp(timestamp))') +
                            ' < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots(useUnnest) {
                        var baseQuery = 'SELECT TIMESTAMP \'' + previousDateString + '\' + INTERVAL \'1 ' + rangeType + '\' * (u.i - ' + rangeDiff +
                            ') AS last_ts, TIMESTAMP \'' + previousDateString + '\' + INTERVAL \'1 ' + rangeType + '\' * u.i AS ts';

                        if (useUnnest) {
                            return baseQuery + ' FROM UNNEST(SEQUENCE(1, ' + totalRange + ', ' + rangeDiff + ') AS i) AS u';
                        } else {
                            return baseQuery + ' FROM generate_series(1, ' + totalRange + ', ' + rangeDiff + ') AS u(i)';
                        }
                    }

                    function buildAggregationQuery(slotType, valueField, additionalFields) {
                        var baseFields = [
                            'filled_slots.ts',
                            'MAX(' + valueField + ') AS last_val',
                            'slot_agg_val'
                        ];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = 'slot_' + slotType + ' AS ( SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) last_previous_time, ' +
                            'MAX(in_interval_r.' + valueField + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS string) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        node: {
                            nodeHealth: {
                                base: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'health', alias: 'health', useArrow: true }
                            },
                            nodeConnection: {
                                base: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'connected', alias: 'value', useArrow: false }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health', useArrow: true }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value', useArrow: true }
                            }
                        }
                    };

                    var config = srcList.type === 'node' ?
                        tableConfig.node[srcList.chartType === 'nodeHealth' ? 'nodeHealth' : 'nodeConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;
                    var useTimestampCast = srcList.type === 'attribute' || (srcList.type === 'node' && !srcList.chartType === 'nodeHealth');
                    var useUnnest = useTimestampCast && !srcList.dataType;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields, useTimestampCast) +
                        '), slots AS (' + buildTimeSlots(useUnnest) +
                        '), ' + buildAggregationQuery(config.valueField.alias === 'health' ? 'healths' : 'values',
                            config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_' + (config.valueField.alias === 'health' ? 'healths' : 'values') +
                        ' ORDER BY ts;';

                    return sql;
                };

                vm.fnGetChartUpdateData = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                };

                vm.fnChartUpdateBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            } else {
                                var chart = $('#nodeAttributeChart').highcharts(); //eslint-disable-line
                                _.forEach(response, function (responseObj, index) {
                                    var parsedData = parsePostgresData(responseObj.body.data);
                                    var tempChartData = vm.fnGenerateChartData(vm.selectedChartData[index], parsedData);
                                    $timeout(function () {
                                        vm.selectedChartData[index].apiData.shift();
                                        vm.selectedChartData[index].apiData.push(responseObj.body.data[0]);
                                        vm.selectedChartData[index].chartData.shift();
                                        vm.selectedChartData[index].chartData.push(_.cloneDeepWith(tempChartData[0]));
                                        var isFind = _.find(vm.pieChartAttributeList, {
                                            name: vm.selectedChartData[index].name,
                                            id: vm.selectedChartData[index].id
                                        });
                                        if (isFind) {
                                            isFind.apiData = _.cloneDeepWith(vm.selectedChartData[index].apiData);
                                            isFind.chartData = _.cloneDeepWith(vm.selectedChartData[index].chartData);
                                        }
                                        var isFindIndex = _.findIndex(chart.series, {name: vm.selectedChartData[index].name});
                                        if (isFindIndex !== -1) {
                                            chart.series[isFindIndex].addPoint(tempChartData[0], true, true);
                                            if (vm.selectedChartData[index].type === 'node') {
                                                if (vm.selectedChartData[index].chartType === 'nodeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthForecast[tempHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthAnomaly[tempHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempConnectionForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionForecast[tempConnectionForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempConnectionAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionAnomaly[tempConnectionAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            } else {
                                                if (vm.selectedChartData[index].chartType === 'attributeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthForecast[tempValueHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthAnomaly[tempValueHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {

                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueForecast[tempValueForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueAnomaly[tempValueAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    })
                                });
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnSetGranularity = function () {
                    vm.fnDataRangeChange();
                }

                vm.fnDeployAttribute = function (alarmObj) {
                    var input = {
                        attributeId: alarmObj.id
                    };
                    NodeAttributesFactory.deployAttribute(input)
                        .then(function (res) {
                            amaran.success("Attribute Synchronize in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html',
                                size: 'lg',
                                controller: 'attributeSyncModalCtrl as attributeSyncModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(res);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnExportToInsight = function () {
                    var tempChartArr = [];
                    var tempObj = {};
                    _.forEach(vm.selectedChartData, function (selectedChartObj) {
                        tempObj = {};
                        tempObj.query = selectedChartObj.sql;
                        tempObj.chart = {
                            chartConfiguration: {
                                chartType: "line",
                                dataMapping: {},
                                chartConfig: {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        labels: {
                                            rotation: -60,
                                            format: "{value:%d/%m %H:%M}"
                                        },
                                        title: {
                                            text: ''
                                        },
                                        type: "datetime"
                                    },
                                    yAxis: {
                                        title: {
                                            text: 'Values'
                                        }
                                    },
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    legend: {
                                        enabled: false
                                    }
                                }
                            }
                        };
                        if (selectedChartObj.type === 'node') {
                            if (selectedChartObj.chartType === 'nodeHealth') {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "health"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                            } else {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "value"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                            }
                        } else {
                            if (selectedChartObj.chartType === 'attributeHealth') {
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ForecastHealth';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'AnomalyHealth';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                                }
                            } else {
                                var isStringFound = false;
                                _.forEach(selectedChartObj.apiData, function (dataObj) {
                                    if (dataObj.value && isNaN(dataObj.value)) {
                                        isStringFound = true;
                                    }
                                });
                                if (isStringFound) {
                                    tempObj.chart.chartConfiguration.isSupportStringValue = true;
                                }
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueForecast';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueAnomaly';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                                }
                            }
                        }
                        tempChartArr.push(tempObj)
                    });
                    DB.fnSet('telemetryChart', tempChartArr);
                    $state.go('main.insight_query_editor');
                }

                vm.fnInitNodeAttributes = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var timezone = moment().zone();
                    timezoneName = moment.tz.guess();
                    Highcharts.setOptions({
                        global: {
                            timezoneOffset: timezone
                        }
                    });
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');

                    });
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.chartUpdateTimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, NodeFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.nodeSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetNodeData = function () {
                    vm.nodeSupplementalObj = vm.parent.nodeObj.tags ? angular.fromJson(_.cloneDeepWith(vm.parent.nodeObj.tags)) : {};
                    vm.nodeSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.nodeSupplementalObj, true) : vm.nodeSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.nodeSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.nodeSupplementalObj)) {
                        angular.forEach(vm.nodeSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isNodeSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.nodeSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.nodeSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.nodeSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.nodeSupplementalObj = angular.toJson(vm.nodeSupplementalObj, true);
                    } else {
                        vm.nodeSupplementalObj = angular.fromJson(vm.nodeSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.nodeSupplementalObj)) {
                            angular.forEach(vm.nodeSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveNodeData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.nodeObj.tags = {};
                    var inputObj = {
                        nodeId: vm.parent.nodeObj.id,
                        body: {}
                    };
                    if (!vm.parent.nodeObj.tags) {
                        vm.parent.nodeObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.nodeObj.tags = angular.fromJson(vm.nodeSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.nodeObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.nodeObj.tags;
                    NodeFactory.replaceNodeTags(inputObj)
                        .then(function (response) {
                            amaran.success("Tag added to node successfully");
                            $scope.$emit('NodeDetailsChanged', response);
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.nodeSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.nodeSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.nodeSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitNodeSupplemental = function () {
                    vm.isNodeSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeMetaCtrl',
            function ($scope, $timeout, TabHeight) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.fnInitNodeMeta = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeLocationCtrl',
            function ($scope, $timeout, amaran, $window, TabHeight, NodeFactory, L) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isSaveLoaderActive = false;
                var map = "";
                var marker = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element("#locationInputBlock")[0]) && angular.isDefined(angular.element("#map1")[0])) {
                        var contentMain = angular.element(".content-main")[0].offsetHeight;
                        var inputContainer = angular.element("#locationInputBlock")[0].offsetHeight;
                        var locationSaveActionBlock = 0;
                        if (angular.element("#locationSaveActionBlock")[0]) {
                            locationSaveActionBlock = angular.element("#locationSaveActionBlock")[0].offsetHeight;
                        }
                        var fianlMapHeight = contentMain - (inputContainer + locationSaveActionBlock + 40);
                        angular.element("#map1").css('height', fianlMapHeight + 'px');
                    }
                };

                vm.fnGetNodeLocation = function () {
                    vm.nodeObj = _.cloneDeepWith(vm.parent.nodeObj);
                    if (vm.nodeObj.location && vm.nodeObj.location.latitude && vm.nodeObj.location.longitude) {
                        vm.latitude = vm.nodeObj.location.latitude;
                        vm.longitude = vm.nodeObj.location.longitude;
                        vm.actualLatitude = vm.latitude;
                        vm.actualLongitude = vm.longitude;
                    } else {
                        vm.latitude = 39.721712;
                        vm.longitude = -104.941406;
                    }
                    $timeout(function () {

                        $timeout(function () {
                            document.getElementById('nodeLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                            var mapOptions = {};
                            mapOptions.center = [vm.latitude, vm.longitude];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                            map = new L.Map('map1', mapOptions);
                            marker = L.marker([vm.latitude, vm.longitude], {
                                draggable: true
                            }).addTo(map);
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                            marker.on('drag', function () {
                                $timeout(function () {
                                    vm.actualLatitude = marker.getLatLng().lat;
                                    vm.actualLongitude = marker.getLatLng().lng;
                                    //var test = getMapPostion(e.latlng.lat, e.latlng.lng, map.getZoom());
                                    //console.log('test', test);
                                })
                            });
                            $timeout(function () {
                                map.invalidateSize()
                            });
                        }, 1000)
                    }, 100)
                };

                vm.fnChangeLocation = function () {
                    if (vm.actualLatitude.length && vm.actualLongitude.length) {
                        var newLatLng = new L.LatLng(vm.actualLatitude, vm.actualLongitude);
                        marker.setLatLng(newLatLng);
                        map.setView(marker.getLatLng(), map.getZoom());
                    }
                };

                /*if (typeof(Number.prototype.toRad) === "undefined") {
                    Number.prototype.toRad = function () {
                        return this * Math.PI / 180;
                    }
                }

                function getMapPostion(lat, lon, zoom) {
                    var xtile = parseInt(Math.floor((lon + 180) / 360 * (1 << zoom)));
                    var ytile = parseInt(Math.floor((1 - Math.log(Math.tan(lat.toRad()) + 1 / Math.cos(lat.toRad())) / Math.PI) / 2 * (1 << zoom)));
                    return {x: xtile, y: ytile, z: zoom};
                    //return "" + zoom + "/" + xtile + "/" + ytile;
                }*/

                vm.fnSaveLocationInfo = function () {
                    vm.isSaveLoaderActive = true;
                    var inputObj = {
                        body: {},
                        nodeId: vm.nodeObj.id
                    };

                    inputObj.body = {
                        latitude: vm.actualLatitude,
                        longitude: vm.actualLongitude,
                        altitude: "",
                        x: "",
                        y: "",
                        z: "",
                        geoJson: {}
                    };
                    NodeFactory.replaceNodeLocation(inputObj)
                        .then(function (response) {
                            vm.nodeObj = response;
                            if (vm.nodeObj.location && vm.nodeObj.location.latitude && vm.nodeObj.location.longitude) {
                                vm.latitude = vm.nodeObj.location.latitude;
                                vm.longitude = vm.nodeObj.location.longitude;
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            $scope.$emit('NodeDetailsChanged', response);
                            vm.isSaveLoaderActive = false;
                            $timeout(function () {
                                $timeout(function () {
                                    document.getElementById('nodeLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                    var mapOptions = {};
                                    mapOptions.center = [vm.latitude, vm.longitude];
                                    mapOptions.zoom = 8;
                                    mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                    map = new L.Map('map1', mapOptions);
                                    marker = L.marker([vm.latitude, vm.longitude], {
                                        draggable: true
                                    }).addTo(map);
                                    $timeout(function () {
                                        vm.fnSetTabHeight();
                                    });
                                    marker.on('drag', function () {
                                        $timeout(function () {
                                            vm.actualLatitude = marker.getLatLng().lat;
                                            vm.actualLongitude = marker.getLatLng().lng;
                                            //var test = getMapPostion(e.latlng.lat, e.latlng.lng, map.getZoom());
                                            //console.log('test', test);
                                        })
                                    });
                                    $timeout(function () {
                                        map.invalidateSize()
                                    });
                                }, 100)
                            })
                            amaran.success("Location Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveLoaderActive = false;
                        });
                };

                vm.fnInitNodeLocation = function () {
                    if (vm.parent.nodeObj.id) {
                        vm.fnGetNodeLocation(vm.parent.nodeObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })

                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeIOT3Ctrl',
            function ($scope, $timeout, TabHeight) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.fnInitNodeIOT3 = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeGraphCtrl',
            function ($scope, $timeout, $state, $uibModal, NodeFactory, amaran, d3, TabHeight, panzoom, mermaid, ColorService, QueryFactory, $window, XLSX) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.nodeResponse = [];
                vm.nodesArr = [];
                vm.ecusArr = [];
                vm.isNodeLoading = false;
                vm.graphOptionsArr = [
                    {
                        displayName: 'AUTO COMPLETE',
                        name: 'AUTO_COMPLETE'
                    }, {
                        displayName: 'AUTO UPSTREAM',
                        name: 'AUTO_UPSTREAM'
                    }, {
                        displayName: 'AUTO DOWNSTREAM',
                        name: 'AUTO_DOWNSTREAM'
                    }, {
                        displayName: 'MERMAID',
                        name: 'MERMAID'
                    }
                ];
                vm.selectedGraphObj = vm.graphOptionsArr[0];
                vm.nodeHierarchicalData = [];
                vm.mermaidString = '';
                vm.finalMermaidString = '';
                vm.isShowMermaid = false;
                vm.selectedGraphView = 'fileView';//fileView, HierarchicalView
                vm.nodeFileData = [];
                vm.nodeFileDisplayData = [];

                /*start: file view code*/
                vm.collapseAll = function () {
                    $timeout(function () {
                        vm.nodeFileData.forEach(function iter(a) {
                            if (a.children && a.children.length) {
                                a.isExpanded = false;
                            }
                            return angular.isArray(a.children) && a.children.forEach(iter);
                        });
                        var tempObj = {
                            index: 'deviceRoot',
                            children: vm.nodeFileData,
                            health: 100,
                            isExpanded: true
                        };
                        vm.nodeFileDisplayData = _.cloneDeepWith([tempObj]);
                    });
                };

                vm.expandAll = function () {
                    $timeout(function () {
                        vm.nodeFileData.forEach(function iter(a) {
                            if (a.children && a.children.length) {
                                a.isExpanded = true;
                            }
                            return angular.isArray(a.children) && a.children.forEach(iter);
                        });
                        var tempObj = {
                            index: 'deviceRoot',
                            children: vm.nodeFileData,
                            health: 100,
                            isExpanded: true
                        };
                        vm.nodeFileDisplayData = angular.copy([tempObj]);
                    });
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle ECU connected field
                        if ('ecuconnected' in parsedItem || 'ecuConnected' in parsedItem) {
                            var value = parsedItem.ecuconnected || parsedItem.ecuConnected;
                            parsedItem.ecuConnected = angular.isString(value) ?
                                (value === "true") : Boolean(value);
                            delete parsedItem.ecuconnected;
                        }

                        // Handle node connected field
                        if ('connected' in parsedItem) {
                            parsedItem.connected = angular.isString(parsedItem.connected) ?
                                (parsedItem.connected === "true") : Boolean(parsedItem.connected);
                        }

                        // Handle rt field explicitly
                        parsedItem.rt = parsedItem.rt || '';

                        // Handle project name explicitly
                        parsedItem.projectName = parsedItem.projectname || parsedItem.projectName || '';
                        delete parsedItem.projectname;

                        // Handle all JSONB fields with potential lowercase names
                        var fieldMappings = {
                            'projectname': 'projectName',
                            'projectid': 'projectId',
                            'rootnodeid': 'rootNodeId',
                            'parentnodeid': 'parentNodeId',
                            'ecuid': 'ecuId',
                            'totalitems': 'totalItems'
                        };

                        // Convert each field from lowercase to camelCase
                        _.forEach(fieldMappings, function(camelCaseKey, lowercaseKey) {
                            if (lowercaseKey in parsedItem) {
                                parsedItem[camelCaseKey] = parsedItem[lowercaseKey];
                                delete parsedItem[lowercaseKey];
                            }
                        });

                        return {
                            id: parsedItem.id || parsedItem["?column?"] || '',
                            name: parsedItem.name || '',
                            projectId: parsedItem.projectId || parsedItem.projectid || '',
                            parentNodeId: parsedItem.parentNodeId || parsedItem.parentnodeid || '',
                            rootNodeId: parsedItem.rootNodeId || parsedItem.rootnodeid || '',
                            ecuId: parsedItem.ecuId || parsedItem.ecuid || '',
                            health: parseInt(parsedItem.health) || 0,
                            operation: parsedItem.operation || 'UNKNOWN',
                            connected: parsedItem.connected,
                            ecuConnected: parsedItem.ecuConnected,
                            rt: parsedItem.rt,
                            projectName: parsedItem.projectName,
                            totalItems: parseInt(parsedItem.totalitems || parsedItem.totalItems || 0)
                        };
                    });
                }
                /*end: file view code*/

                vm.fnGetNodes = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var nodeArr = isCalledForViz ? preDefinedProjects : [];
                            if (res.data && res.data.length) {
                                var parsedItems = parsePostgresData(res.data);
                                _.forEach(parsedItems, function (nodeObj) {
                                    var nodeStyle = ColorService.getHealthColorForLoop(nodeObj.projectId, nodeObj.health);
                                    nodeObj.healthName = nodeStyle.content;
                                    nodeObj.healthColor = nodeStyle['background-color'];
                                    nodeObj.textColor = nodeStyle.color;
                                    nodeArr.push(nodeObj);
                                });
                            }
                            if ((res.data && res.data.length && res.data.length > 0) && (nodeArr[0] && nodeArr[0].totalItems > nodeArr.length)) {
                                var sqlString = "SELECT " +
                                    "node_nodes.data->>\'id\' as id, " +
                                    "node_nodes.data->>\'name\' as name, " +
                                    "node_nodes.data->>\'projectId\' as projectId, " +
                                    "node_nodes.data->>\'parentNodeId\' as parentNodeId, " +
                                    "node_nodes.data->>\'rootNodeId\' as rootNodeId, " +
                                    "node_nodes.data->>\'ecuId\' as ecuId, " +
                                    "node_nodes.data->>\'health\' as health, " +
                                    "node_nodes.data->\'connected\' as connected, " +
                                    "node_nodes.data->>\'operation\' as operation, " +
                                    "node_nodes.data->>\'_id\' AS rt, " +
                                    "COUNT(*) OVER() as totalItems, " +
                                    "node_ecus.data->\'connected\' as ecuConnected, " +
                                    "node_projects.data->>\'name\' as projectName " +
                                    "FROM node_nodes " +
                                    "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                                    "INNER JOIN node_projects ON node_nodes.data->>\'projectId\' = node_projects.data->>\'id\' " +
                                    "Where node_nodes.data->>\'rootNodeId\' = '"+ vm.nodeObj.rootNodeId +"' "+
                                    "ORDER BY node_nodes.data->>\'_id\' asc LIMIT " + 500 +";";
                                vm.fnGetNodes({sql: sqlString}, nodeArr, true);
                            } else {
                                nodeArr.sort(function(a, b) {
                                    if ( a.name < b.name ){
                                        return -1;
                                    }
                                    if ( a.name > b.name ){
                                        return 1;
                                    }
                                    return 0;
                                });
                                vm.nodeResponse = {
                                    data: _.cloneDeepWith(nodeArr)
                                };
                                vm.totalNodes = nodeArr[0] ? nodeArr[0].totalItems : 0;

                                var treeData = buildHierarchy(vm.nodeResponse.data);
                                if (treeData && treeData.length > 1) {
                                    vm.nodeHierarchicalData = {
                                        name: 'Root',
                                        description: 'Main Node',
                                        isDummyNode: true,
                                        children: treeData
                                    }
                                } else {
                                    vm.nodeHierarchicalData = treeData[0]
                                }
                                if (vm.nodeObj.graph && vm.nodeObj.graph.type && vm.nodeObj.graph.type !== '') {
                                    var isFindGraphType = _.find(vm.graphOptionsArr, {name: vm.nodeObj.graph.type});
                                    if (isFindGraphType) {
                                        vm.selectedGraphObj = isFindGraphType;
                                    }
                                }
                                vm.fnRenderGraph();
                                vm.isNodeLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeLoading = false;
                        })
                };

                vm.fnOpenNodeInfoTab = function (nodeObj) {
                    if (nodeObj.id === vm.parent.nodeObj.id) {
                        $scope.$emit('openNodeDetailTab', nodeObj);
                    } else {
                        nodeObj.project = {
                            name: nodeObj.projectName,
                            id: nodeObj.projectId
                        }
                        $scope.$emit('openNodeDetail', nodeObj);
                    }
                }

                vm.fnOpenNodeTelemetryTab = function (nodeObj) {
                    if (nodeObj.id === vm.parent.nodeObj.id) {
                        $scope.$emit('openNodeTelemetryTab', nodeObj);
                    } else {
                        nodeObj.project = {
                            name: nodeObj.projectName,
                            id: nodeObj.projectId
                        }
                        $scope.$emit('openNodeTelemetry', nodeObj);
                    }
                }

                vm.fnOpenNodeEditModal = function (nodeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/nodeRenameModal/nodeRenameModal.html',
                        size: 'lg',
                        controller: 'nodeRenameModalCtrl as nodeRename',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith(nodeObj);
                            },
                            isForCascade: function () {
                                return false;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.isNodeLoading = true;
                        $timeout(function () {
                            vm.nodeFileData = [];
                            vm.nodeFileDisplayData = [];
                            _.forEach(response, function (resObj) {
                                var isFind = _.find(vm.nodeResponse.data, {id: resObj.body.id});
                                if (isFind) {
                                    isFind.name = resObj.body.name;
                                }
                                if (vm.nodeObj.id === resObj.body.id) {
                                    vm.nodeObj.name = resObj.body.name;
                                    $scope.$emit('NodeDetailsChanged', vm.nodeObj);
                                }
                            })
                            vm.nodeResponse.data = _.cloneDeepWith(vm.nodeResponse.data);
                            var treeData = buildHierarchy(vm.nodeResponse.data);
                            if (treeData && treeData.length > 1) {
                                vm.nodeHierarchicalData = {
                                    name: 'Root',
                                    description: 'Main Node',
                                    isDummyNode: true,
                                    children: treeData
                                }
                            } else {
                                vm.nodeHierarchicalData = treeData[0]
                            }
                            vm.fnRenderGraph();
                            vm.isNodeLoading = false;
                        }, 1000)
                    }, function () {
                    });
                }

                vm.fnOpenNodeEditAndCascadeModal = function (nodeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/nodeRenameModal/nodeRenameModal.html',
                        size: 'lg',
                        controller: 'nodeRenameModalCtrl as nodeRename',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith(nodeObj);
                            },
                            isForCascade: function () {
                                return true;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.isNodeLoading = true;
                        $timeout(function () {
                            vm.nodeFileData = [];
                            vm.nodeFileDisplayData = [];
                            _.forEach(response, function (resObj) {
                                var isFind = _.find(vm.nodeResponse.data, {id: resObj.body.id});
                                if (isFind) {
                                    isFind.name = resObj.body.name;
                                }
                                if (vm.nodeObj.id === resObj.body.id) {
                                    vm.nodeObj.name = resObj.body.name;
                                    $scope.$emit('NodeDetailsChanged', vm.nodeObj);
                                }
                            })
                            vm.nodeResponse.data = _.cloneDeepWith(vm.nodeResponse.data);
                            var treeData = buildHierarchy(vm.nodeResponse.data);
                            if (treeData && treeData.length > 1) {
                                vm.nodeHierarchicalData = {
                                    name: 'Root',
                                    description: 'Main Node',
                                    isDummyNode: true,
                                    children: treeData
                                }
                            } else {
                                vm.nodeHierarchicalData = treeData[0]
                            }
                            vm.fnRenderGraph();
                            vm.isNodeLoading = false;
                        }, 1000)
                    }, function () {
                    });
                }

                vm.fnRenderGraph = function () {
                    var tempFileObj = {};
                    if (vm.selectedGraphObj.name === 'AUTO_COMPLETE') {
                        var tempTreeData = [];
                        if (vm.nodeObj.rootNodeId && vm.nodeObj.rootNodeId !== '') {
                            tempTreeData = _.filter(vm.nodeResponse.data, function (dataObj) {
                                return dataObj.rootNodeId === vm.nodeObj.rootNodeId;
                            })
                        } else {
                            tempTreeData.push(vm.nodeObj);
                        }
                        vm.nodesArr = _.cloneDeepWith(tempTreeData);
                        var treeData = buildHierarchy(vm.nodesArr);
                        vm.nodeFileData = _.cloneDeepWith(treeData);
                        tempFileObj = {
                            index: 'deviceRoot',
                            children: vm.nodeFileData,
                            health: 100,
                            isExpanded: true
                        };
                        if (treeData && treeData.length) {
                            if (treeData && treeData.length > 1) {
                                vm.nodeTreeData = {
                                    name: 'Root',
                                    description: 'Main Node',
                                    isDummyNode: true,
                                    children: treeData
                                }
                            } else {
                                vm.nodeTreeData = treeData[0]
                            }
                        } else {
                            vm.nodeTreeData = {};
                        }
                    } else if (vm.selectedGraphObj.name === 'AUTO_UPSTREAM') {
                        var isFindData1 = {};
                        var testingData = [];
                        if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === vm.nodeObj.id) {
                            isFindData1 = _.cloneDeepWith(vm.nodeHierarchicalData);
                            delete isFindData1.children
                            if (isFindData1 && Object.keys(isFindData1).length) {
                                vm.nodeTreeData = isFindData1;
                                vm.nodeFileData = _.cloneDeepWith([isFindData1]);
                                tempFileObj = {
                                    index: 'deviceRoot',
                                    children: vm.nodeFileData,
                                    health: 100,
                                    isExpanded: true
                                };
                            } else {
                                vm.nodeTreeData = {};
                                vm.nodeFileData = _.cloneDeepWith([]);
                                tempFileObj = {
                                    index: 'deviceRoot',
                                    children: [],
                                    health: 100,
                                    isExpanded: true
                                };
                            }
                        } else {
                            var tempHierarchicalData = _.cloneDeepWith(vm.nodeHierarchicalData);
                            var tempData = [];
                            if (vm.nodeHierarchicalData.name === 'Root') {
                                tempHierarchicalData = {};
                                tempData = _.cloneDeepWith([_.find(vm.nodeHierarchicalData.children, {id : vm.nodeObj.rootNodeId})]);
                            } else {
                                tempData = _.cloneDeepWith(vm.nodeHierarchicalData.children);
                            }
                            var currentNode = searchRecursiveForUpstream(_.cloneDeepWith(tempHierarchicalData), _.cloneDeepWith(tempData), vm.nodeObj.id, testingData)
                            if (currentNode) {
                                delete currentNode.children
                                testingData.push(currentNode);
                                testingData = buildHierarchy(_.cloneDeepWith(testingData));
                                if (testingData[0].children && testingData[0].children.length > 1) {
                                    var isFindNode = _.findIndex(testingData[0].children, {id: vm.parent.nodeObj.id});
                                    vm.nodeTreeData = testingData[0].children[isFindNode];
                                    vm.nodeFileData = _.cloneDeepWith([testingData[0].children[isFindNode]]);
                                    tempFileObj = {
                                        index: 'deviceRoot',
                                        children: vm.nodeFileData,
                                        health: 100,
                                        isExpanded: true
                                    };
                                } else {
                                    vm.nodeTreeData = testingData[0];
                                    vm.nodeFileData = _.cloneDeepWith(testingData);
                                    tempFileObj = {
                                        index: 'deviceRoot',
                                        children: vm.nodeFileData,
                                        health: 100,
                                        isExpanded: true
                                    };
                                }
                            } else {
                                vm.nodeTreeData = {};
                            }
                        }
                    } else if (vm.selectedGraphObj.name === 'AUTO_DOWNSTREAM') {
                        var isFindData = {};
                        if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === vm.nodeObj.id) {
                            isFindData = vm.nodeHierarchicalData;
                        } else {
                            isFindData = searchRecursiveForDownstream(_.cloneDeepWith(vm.nodeHierarchicalData.children), vm.nodeObj.id)
                        }
                        if (isFindData && Object.keys(isFindData).length) {
                            vm.nodeTreeData = isFindData;
                            vm.nodeFileData = _.cloneDeepWith([isFindData]);
                            tempFileObj = {
                                index: 'deviceRoot',
                                children: [isFindData],
                                health: 100,
                                isExpanded: true
                            };
                        } else {
                            vm.nodeTreeData = {};
                            vm.nodeFileData = _.cloneDeepWith([]);
                            tempFileObj = {
                                index: 'deviceRoot',
                                children: [],
                                health: 100,
                                isExpanded: true
                            };
                        }
                    } else if (vm.selectedGraphObj.name === "MERMAID") {
                        if (vm.finalMermaidString !== '') {
                            $timeout(function () {
                                vm.isShowMermaid = true;
                                vm.fnRenderMermaid();
                            })
                        } else if (vm.nodeObj.graph && vm.nodeObj.graph.type && vm.nodeObj.graph.type !== '' && vm.nodeObj.graph.graph && vm.nodeObj.graph.graph !== '') {
                            var isFindGraphType = _.find(vm.graphOptionsArr, {name: vm.nodeObj.graph.type});
                            if (isFindGraphType) {
                                vm.mermaidString = _.cloneDeepWith(vm.nodeObj.graph.graph);
                                vm.fnGenerateMermaidString(vm.nodeObj.graph.graph);
                            }
                        }
                    }
                    if (vm.selectedGraphObj.name !== "MERMAID") {
                        vm.nodeFileDisplayData = _.cloneDeepWith([tempFileObj]);
                        vm.expandAll();
                        if (vm.selectedGraphView !== 'fileView') {
                            vm.fnCreatePanzoom();
                        }
                    }
                }

                function searchRecursiveForDownstream(data, id, testingData) {
                    var found = _.find(data, {id: id})
                    if (!found) {
                        var i = 0;
                        while (!found && i < data.length) {
                            if (data[i].children && data[i].children.length) {
                                found = searchRecursiveForDownstream(data[i].children, id, testingData);
                            }
                            i++;
                        }
                    }
                    return found;
                }

                function searchRecursiveForUpstream(tempData, data, id, testingData) {
                    var found = _.find(data, {id: id})
                    if (tempData && Object.keys(tempData).length) {
                        delete tempData.children
                        testingData.push(tempData);
                    }
                    if (!found) {
                        var i = 0;
                        while (!found && i < data.length) {
                            if (data[i].children && data[i].children.length) {
                                found = searchRecursiveForUpstream(data[i], data[i].children, id, testingData);
                            }
                            i++;
                        }
                    }
                    return found;
                }

                function buildHierarchy(arry) {

                    var roots = [], children = {};

                    // find the top level nodes and hash the children based on parent
                    for (var i = 0, len = arry.length; i < len; ++i) {
                        var item = arry[i],
                            p = item.parentNodeId,
                            target = !p ? roots : (children[p] || (children[p] = []));

                        target.push(item);
                    }

                    // function to recursively build the tree
                    var findChildren = function (parent) {
                        if (children[parent.id]) {
                            parent.children = children[parent.id];
                            for (var i = 0, len = parent.children.length; i < len; ++i) {
                                findChildren(parent.children[i]);
                            }
                        }
                    };

                    // enumerate through to handle the case where there are multiple roots
                    for (i = 0, len = roots.length; i < len; ++i) {
                        findChildren(roots[i]);
                    }

                    return roots;
                }

                vm.fnOpenMermaidEditor = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/mermaidEditor/mermaidEditor.html',
                        size: 'lg',
                        controller: 'mermaidEditorCtrl as mermaidEditorModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            value: function () {
                                return vm.mermaidString;
                            },
                            nodeHierarchicalData: function () {
                                return _.cloneDeepWith(vm.nodeHierarchicalData);
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.isShowMermaid = false;
                        vm.mermaidString = response;
                        vm.fnSaveGraphData(vm.selectedGraphObj, vm.mermaidString);
                        vm.fnGenerateMermaidString(response);
                    }, function () {
                    });
                }

                function fnCreateMermaidGraph(data, id) {
                    _.forEach(data, function (dataObj) {
                        vm.graphStr += '\n ' + id + "-->" + dataObj.id;
                        if (dataObj.children && dataObj.children.length) {
                            fnCreateMermaidGraph(dataObj.children, dataObj.id);
                        }
                    });
                }

                vm.fnGenerateMermaidString = function (response) {
                    vm.finalMermaidString = _.cloneDeepWith(response);
                    var tempMermaidString = _.cloneDeepWith(response);
                    var newReg = /(\w{8})-ne((\w{6}))-nn((\w{6}))\[\*\]+/g;
                    var newTempStr = '';
                    var tempResult = [];
                    vm.graphStr = '';
                    while ((newTempStr = newReg.exec(vm.mermaidString)) !== null) {
                        if (tempResult.indexOf(newTempStr[0]) === -1) {
                            tempResult.push(newTempStr[0]);
                            var tempId = newTempStr[0].replace(/\[\*\]/g, "");
                            var isFindData = {};
                            if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === tempId) {
                                isFindData = vm.nodeHierarchicalData;
                            } else {
                                isFindData = searchRecursiveForDownstream(_.cloneDeepWith(vm.nodeHierarchicalData.children), tempId)
                            }
                            if (isFindData && isFindData.id && isFindData.id !== "") {
                                fnCreateMermaidGraph(isFindData.children, isFindData.id);
                            }
                        }
                    }
                    vm.finalMermaidString = vm.finalMermaidString.replace(/\[\*\]/g, "");
                    vm.finalMermaidString += vm.graphStr;
                    $timeout(function () {
                        tempMermaidString = tempMermaidString.replace(/\[\*\]/g, "");
                        tempMermaidString += vm.graphStr;
                        var re = /(\w{8})-ne((\w{6}))-nn((\w{6}))+/g;
                        //var ecuRegx = /(\w{8})-ne((\w{6}))+/g;
                        var result = [];
                        var temp = '';
                        var health = [];
                        var classString = "";
                        var mappingString = "";
                        while ((temp = re.exec(vm.finalMermaidString)) !== null) {
                            if (result.indexOf(temp[0]) === -1) {
                                result.push(temp[0]);
                                var isFind = _.find(vm.nodeResponse.data, {id: temp[0]});
                                if (isFind) {
                                    if (health.indexOf(isFind.health) === -1) {
                                        health.push(isFind.health);
                                        var nodeStyle = ColorService.getHealthColorForLoop(isFind.projectId, isFind.health);
                                        if (classString === "") {
                                            classString = "classDef health_" + isFind.health + " fill:" + nodeStyle['background-color'] + ",color:" + nodeStyle.color
                                        } else {
                                            classString += "\n classDef health_" + isFind.health + " fill:" + nodeStyle['background-color'] + ",color:" + nodeStyle.color
                                        }
                                    }
                                    if (mappingString === "") {
                                        mappingString = isFind.id + "[" + isFind.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFind.health
                                    } else {
                                        mappingString += "\n " + isFind.id + "[" + isFind.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFind.health
                                    }
                                }
                            }
                        }
                        /*temp = '';
                        var ecuResult = [];
                        while ((temp = ecuRegx.exec(vm.finalMermaidString)) !== null) {
                            if (ecuResult.indexOf(temp[0]) === -1) {
                                ecuResult.push(temp[0]);
                                var isFindECU = _.find(vm.ecusArr, {id: temp[0]});
                                if (isFindECU) {
                                    if (health.indexOf(isFindECU.health) === -1) {
                                        health.push(isFindECU.health);
                                        var ecuStyle = ColorService.getHealthColorForLoop(isFindECU.projectId, isFindECU.health);
                                        if (classString === "") {
                                            classString = "classDef health_" + isFindECU.health + " fill:" + ecuStyle['background-color'] + ",color:" + ecuStyle.color
                                        } else {
                                            classString += "\n classDef health_" + isFindECU.health + " fill:" + ecuStyle['background-color'] + ",color:" + ecuStyle.color
                                        }
                                    }
                                    if (mappingString === "") {
                                        mappingString = isFindECU.id + "[" + isFindECU.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFindECU.health
                                    } else {
                                        mappingString += "\n " + isFindECU.id + "[" + isFindECU.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFindECU.health
                                    }
                                }
                            }
                        }*/
                        tempMermaidString += "\n" + mappingString;
                        tempMermaidString += "\n" + classString;
                        vm.finalMermaidString = tempMermaidString;
                        $timeout(function () {
                            vm.isShowMermaid = true;
                            vm.fnRenderMermaid();
                        })
                    })
                }

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".mermaid");
                        vm.fnCreateMermaidPanzoom();
                    }, 100);
                };
                /* eslint-enable */

                vm.fnSaveGraphData = function (type, data) {
                    vm.isSaveLoaderActive = true;
                    var inputObj = {
                        body: {},
                        nodeId: vm.nodeObj.id
                    };

                    inputObj.body = {
                        "name": type.name,
                        "description": type.displayName,
                        "type": type.name,
                        "graph": data,
                        "tags": {}
                    };
                    NodeFactory.replaceNodeGraph(inputObj)
                        .then(function (response) {
                            amaran.success("Graph Updated Successfully");
                            $scope.$emit('NodeDetailsChanged', response);
                            vm.isSaveLoaderActive = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveLoaderActive = false;
                        });
                };

                vm.fnSaveGraphInfo = function () {
                    if (vm.selectedGraphObj && vm.selectedGraphObj.name !== 'MERMAID') {
                        vm.fnSaveGraphData(vm.selectedGraphObj, '');
                    }
                }

                vm.fnGetNodeInfo = function () {
                    vm.nodeObj = _.cloneDeepWith(vm.parent.nodeObj);
                    var nodeInput = {
                        sql: "SELECT " +
                            "node_nodes.data->>\'id\' as id, " +
                            "node_nodes.data->>\'name\' as name, " +
                            "node_nodes.data->>\'projectId\' as projectId, " +
                            "node_nodes.data->>\'parentNodeId\' as parentNodeId, " +
                            "node_nodes.data->>\'rootNodeId\' as rootNodeId, " +
                            "node_nodes.data->>\'ecuId\' as ecuId, " +
                            "node_nodes.data->>\'health\' as health, " +
                            "node_nodes.data->\'connected\' as connected, " +
                            "node_nodes.data->>\'operation\' as operation, " +
                            "node_nodes.data->>\'_id\' AS rt, " +
                            "COUNT(*) OVER() as totalItems, " +
                            "node_ecus.data->\'connected\' as ecuConnected, " +
                            "node_projects.data->>\'name\' as projectName " +
                            "FROM node_nodes " +
                            "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                            "INNER JOIN node_projects ON node_nodes.data->>\'projectId\' = node_projects.data->>\'id\' " +
                            "Where node_nodes.data->>\'rootNodeId\' = '"+ vm.nodeObj.rootNodeId +"' "+
                            "ORDER BY node_nodes.data->>\'_id\' asc LIMIT " + 500 +";"
                    }
                    vm.fnGetNodes(nodeInput, [], false);
                };

                vm.fnCreatePanzoom = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#graphRelationshipsParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('graphRelationshipsParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                vm.fnCreateMermaidPanzoom = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#mermaidGraphParent');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('mermaidGraph'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                vm.fnGetECUs = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res.data && res.data.length) {
                                var parsedItems = parsePostgresData(res.data);
                                _.forEach(parsedItems, function (nodeObj) {
                                    var nodeStyle = ColorService.getHealthColorForLoop(nodeObj.projectId, nodeObj.health);
                                    nodeObj.healthName = nodeStyle.content;
                                    nodeObj.healthColor = nodeStyle['background-color'];
                                    nodeObj.textColor = nodeStyle.color;
                                });
                                vm.ecusArr = _.cloneDeepWith(parsedItems);
                            }
                            vm.ecusArr = _.cloneDeepWith(res.data);
                            var input = {
                                sql: "SELECT " +
                                    "node_nodes.data->>\'id\', " +
                                    "node_nodes.data->>\'name\', " +
                                    "node_nodes.data->>\'projectId\', " +
                                    "node_nodes.data->>\'parentNodeId\', " +
                                    "node_nodes.data->>\'rootNodeId\', " +
                                    "node_nodes.data->>\'ecuId\', " +
                                    "node_nodes.data->>\'health\', " +
                                    "node_nodes.data->\'connected\', " +
                                    "node_nodes.data->>\'operation\', " +
                                    "COUNT(*) OVER() as totalItems, " +
                                    "node_nodes.data->>\'_id\' AS rt, " +
                                    "node_ecus.data->\'connected\' as ecuConnected, " +
                                    "node_projects.data->>\'name\' as projectName " +
                                    "FROM node_nodes " +
                                    "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                                    "INNER JOIN node_projects ON node_nodes.data->>\'projectId\' = node_projects.data->>\'id\' " +
                                    "Where node_nodes.data->>\'rootNodeId\' = '"+ vm.nodeObj.rootNodeId +"' "+
                                    "ORDER BY node_nodes.data->>\'_id\' asc LIMIT " + 500 +";"
                            }
                            vm.fnGetNodes(input, [], false);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            var input = {
                                sql: "SELECT " +
                                    "node_nodes.data->>\'id\', " +
                                    "node_nodes.data->>\'name\', " +
                                    "node_nodes.data->>\'projectId\', " +
                                    "node_nodes.data->>\'parentNodeId\', " +
                                    "node_nodes.data->>\'rootNodeId\', " +
                                    "node_nodes.data->>\'ecuId\', " +
                                    "node_nodes.data->>\'health\', " +
                                    "node_nodes.data->\'connected\', " +
                                    "node_nodes.data->>\'operation\', " +
                                    "COUNT(*) OVER() as totalItems, " +
                                    "node_nodes.data->>\'_id\' AS rt, " +
                                    "node_ecus.data->\'connected\' as ecuConnected, " +
                                    "node_projects.data->>\'name\' as projectName " +
                                    "FROM node_nodes " +
                                    "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                                    "INNER JOIN node_projects ON node_nodes.data->>\'projectId\' = node_projects.data->>\'id\' " +
                                    "Where node_nodes.data->>\'rootNodeId\' = '"+ vm.nodeObj.rootNodeId +"' "+
                                    "ORDER BY node_nodes.data->>\'_id\' asc LIMIT " + 500 +";"
                            }
                            vm.fnGetNodes(input, [], false);
                        })
                };

                vm.fnOpenECUInfo = function () {
                    $state.go('main.ecu', {selectedId: vm.parent.ecuObj.id});
                }

                vm.fnInitNodeGraph = function () {
                    vm.isNodeLoading = true;
                    vm.nodeObj = _.cloneDeepWith(vm.parent.nodeObj);
                    vm.totalNodes = 0;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }

                vm.fnExportXLS = function() {
                    if (!vm.nodeResponse || !vm.nodeResponse.data) {
                        amaran.error("No data to export");
                        return;
                    }

                    try {
                        var data = _.map(vm.nodeResponse.data, function(node) {
                            var parsedNode = parsePostgresData([node])[0];
                            return {
                                'ID': parsedNode.id || '',
                                'Name': parsedNode.name || '',
                                'Project ID': parsedNode.projectId || '',
                                'Parent Node ID': parsedNode.parentNodeId || '',
                                'Root Node ID': parsedNode.rootNodeId || '',
                                'ECU ID': parsedNode.ecuId || '',
                                'Health': parsedNode.health || 0,
                                'ECU Connected': parsedNode.ecuConnected || false,
                                'Connected': parsedNode.connected || false,
                                'Operation': parsedNode.operation || 'UNKNOWN',
                                'RT': node.rt || '',
                                'Project Name': node.projectname || node.projectName || '',
                                'Total Items': parsedNode.totalItems || 0
                            };
                        });

                        var ws = XLSX.utils.json_to_sheet(data);
                        var wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Nodes");
                        XLSX.writeFile(wb, 'nodes_export_' + new Date().toISOString().slice(0,10) + '.xlsx');
                    } catch (error) {
                        amaran.error("Error exporting data: " + error.message);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeFormCtrl',
            function ($scope, $timeout, TabHeight) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.fnInitNodeForm = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

/**
 * Created by WebOsmotic on 2/10/2018.
 */
(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LifecycleStepCtrl',
            function ($scope, $timeout, $window, moment, TabHeight, ColorService, LifecycleFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllLifecycleStepsChecked = false;
                vm.selectedLifecycleStepsArr = [];
                vm.selectedLifecycleObj={};
                vm.isLifecycleStepDetailLoad=false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnGetLifecycleSteps = function (lifecycleObj) {
                    var inputObj = {
                        lifecycleId: lifecycleObj.id
                    };
                    inputObj.sort = '[dec]timestamp';
                    LifecycleFactory.getLifecycleSteps(inputObj)
                        .then(function (resLifecycleSteps) {
                            resLifecycleSteps.map(function (obj) {
                                var rids =  obj.id.split('-');
                                obj.stepId = "#" + rids[rids.length - 1];
                                obj.humanDateLastUpdated = moment(obj.timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                obj.humanDateLastUpdatedRelative = moment(obj.humanDateLastUpdated).fromNow();
                            });
                            vm.lifecycleStepsArr = resLifecycleSteps;
                            vm.isLifecycleStepsLoading = false;
                        }, function () {
                            vm.isLifecycleStepsLoading = false;
                        })
                };

                vm.fnGetLifecycleStep = function(lifecycleStepObj){
                    vm.isLifecycleStepDetailLoad=true;
                    vm.selectedLifecycleObj = lifecycleStepObj;

                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element("thead")[0])) {
                        var header = angular.element("thead")[0].offsetHeight;
                        var rightTableHieght = header + 193;
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnInitLifecycleSteps = function () {
                    TabHeight.fnSet();
                    vm.selectedLifecycleObj={};
                    vm.isLifecycleStepsLoading = true;
                    vm.isLifecycleStepDetailLoad=false;
                    if (vm.parent.lifecycleObj.id) {
                        vm.fnGetLifecycleSteps(vm.parent.lifecycleObj);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('workbenchDashboard', fnWorkbenchDashboard)

    /** @ngInject */
    function fnWorkbenchDashboard($rootScope, $timeout, $window, $sce, $uibModal, $base64, DB, swal) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/workbenchDashboard/workbenchDashboard.html',
            scope: {
                currentWorkspace: "=",
                iot3JsonObj: "=",
                sideActiveTabIndex: "=",
                isIot3FileLoaded: "=",
                fnCreateScratchIot: "&",
                fnCreateIotFromExisting: "&",
                fnCreateIotFromImport: "&",
                fnCreateWbFromImport: "&",
                fnExportWorkbench: "&",
                fnEditWorkspaceDetails: "&",
                fnInitiateResetWorkspace: '&',
                fnChangeTabDashboard: "&"
            },
            link: function ($scope) {

                $scope.workbenchDashboardTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.workbenchDashboardTabs[0];

                $scope.videoSource = $sce.trustAsResourceUrl("//www.youtube.com/watch?v=sN7qImZYvKY");

                $scope.statsArr = [];
                $scope.progressArr = [];
                $scope.infoSecArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#dashboardMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 67);
                        angular.element("#dashboardMainContainer").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitiateExportWorkbench = function () {
                    $scope.fnExportWorkbench();
                };

                $scope.fnInitiateTabChange = function (sideTab) {
                    $scope.fnChangeTabDashboard({item: sideTab});
                };

                $scope.fnInitIot3Dashboard = function () {
                    var yamlString = $base64.decode(DB.fnGet('iot3Workbench').currentWorkbench.yamlString);
                    var yamlArr = yamlString.split("\n");

                    $scope.infoSecArr = [{
                        key: 'Iot3 Version',
                        value: $scope.iot3JsonObj.iot3 && $scope.iot3JsonObj.iot3.length ? $scope.iot3JsonObj.iot3 : '-'
                    }, {
                        key: 'OEM',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.oem ? $scope.iot3JsonObj.info.oem : '-'
                    }, {
                        key: 'Author',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.author ? $scope.iot3JsonObj.info.author : '-'
                    }, {
                        key: 'Stage',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.stage ? $scope.iot3JsonObj.info.stage : '-'
                    }, {
                        key: 'Revision',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.revision ? $scope.iot3JsonObj.info.revision : '-'
                    }, {
                        key: 'Versions',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.versions && $scope.iot3JsonObj.info.versions.length ? $scope.iot3JsonObj.info.versions : []
                    }, {
                        key: 'Labels',
                        value: $scope.iot3JsonObj.info && $scope.iot3JsonObj.info.labels && $scope.iot3JsonObj.info.labels.length ? $scope.iot3JsonObj.info.labels : []
                    }];

                    $scope.statsArr = [{
                        key: 'Line Count',
                        value: yamlArr ? yamlArr.length : 0
                    }, {
                        key: 'Engine Type',
                        value: $scope.iot3JsonObj.engine ? $scope.iot3JsonObj.engine.http ? 'HTTP' : $scope.iot3JsonObj.engine.ssh ? 'SSH' : '-' : '-'
                    }, {
                        key: 'Global Declarations',
                        value: $scope.iot3JsonObj.global && Object.keys($scope.iot3JsonObj.global).length ? Object.keys($scope.iot3JsonObj.global).length : 0
                    }, {
                        key: 'Supported Types',
                        value: $scope.iot3JsonObj.template && $scope.iot3JsonObj.template.types ? Object.keys($scope.iot3JsonObj.template.types).length : 0
                    }, {
                        key: 'Supported Attributes',
                        value: $scope.iot3JsonObj.template && $scope.iot3JsonObj.template.attributes ? Object.keys($scope.iot3JsonObj.template.attributes).length : 0
                    }, {
                        key: 'Mappings',
                        value: $scope.iot3JsonObj.template && $scope.iot3JsonObj.template.filters && $scope.iot3JsonObj.template.filters.mappers ? Object.keys($scope.iot3JsonObj.template.filters.mappers).length : 0
                    }];

                    $scope.progressArr = [{
                        displayName: 'Info',
                        percentage: 0,
                        sideTab: {
                            title: 'Info',
                            tabIndex: 2
                        }
                    },{
                        displayName: 'Global',
                        percentage: 100,
                        issues: 0,
                        sideTab: {
                            title: 'Global',
                            tabIndex: 5
                        }
                    },{
                        displayName: 'Types',
                        percentage: 0,
                        sideTab: {
                            title: 'Types',
                            tabIndex: 8
                        }
                    },{
                        displayName: 'Registration',
                        percentage: 0,
                        sideTab: {
                            title: 'Registration',
                            tabIndex: 3
                        }
                    },{
                        displayName: 'Auth',
                        percentage: 0,
                        sideTab: {
                            title: 'Authentication',
                            tabIndex: 6
                        }
                    },{
                        displayName: 'Attributes',
                        percentage: 0,
                        sideTab: {
                            title: 'Attributes',
                            tabIndex: 9
                        }
                    },{
                        displayName: 'Engine',
                        percentage: 0,
                        sideTab: {
                            title: 'Engine',
                            tabIndex: 4
                        }
                    },{
                        displayName: 'Topology',
                        percentage: 0,
                        sideTab: {
                            title: 'Topology',
                            tabIndex: 7
                        }
                    },{
                        displayName: 'Mappers',
                        percentage: 0,
                        sideTab: {
                            title: 'Mappers',
                            tabIndex: 10
                        }
                    }];

                    /*Start: Info*/
                    var infoTotalTasks = 6;
                    var infoFinishedTasks = 0;
                    var infoIssuesArr = [];

                    if ($scope.iot3JsonObj && $scope.iot3JsonObj.info) {
                        if ($scope.iot3JsonObj.info.name && $scope.iot3JsonObj.info.name.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'Name is not defined in the info section'
                            })
                        }
                        if ($scope.iot3JsonObj.info.oem && $scope.iot3JsonObj.info.oem.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'OEM is not defined in the info section'
                            })
                        }
                        if ($scope.iot3JsonObj.info.model && $scope.iot3JsonObj.info.model.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'Model is not defined in the info section'
                            })
                        }
                        if ($scope.iot3JsonObj.info.versions && $scope.iot3JsonObj.info.versions.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'Versions are not added in the info section'
                            })
                        }
                        if ($scope.iot3JsonObj.info.author && $scope.iot3JsonObj.info.author.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'Author is not defined in the info section'
                            })
                        }
                        if ($scope.iot3JsonObj.info.created && $scope.iot3JsonObj.info.created.length) {
                            infoFinishedTasks++;
                        } else {
                            infoIssuesArr.push({
                                'issueText': 'Created is not defined in the info section'
                            })
                        }
                    }
                    $scope.progressArr[0].percentage = ((infoFinishedTasks / infoTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[0].issues = infoTotalTasks - infoFinishedTasks;
                    $scope.progressArr[0].issuesArr = infoIssuesArr;
                    /*End: Info*/

                    /*Start: Registration*/
                    var regTotalTasks = 2;
                    var regFinishedTasks = 0;
                    var regIssuesArr = [];

                    if ($scope.iot3JsonObj && $scope.iot3JsonObj.registration) {
                        if ($scope.iot3JsonObj.registration.vault &&
                            $scope.iot3JsonObj.registration.vault.properties &&
                            Object.keys($scope.iot3JsonObj.registration.vault.properties).length) {
                            regFinishedTasks++;
                        } else {
                            regIssuesArr.push({
                                'issueText': 'Vault information is not added to the registration section'
                            })
                        }
                        if ($scope.iot3JsonObj.registration.form &&
                            $scope.iot3JsonObj.registration.form.properties &&
                            Object.keys($scope.iot3JsonObj.registration.form.properties).length) {
                            regFinishedTasks++;
                        } else {
                            regIssuesArr.push({
                                'issueText': 'Form information is not added to the registration section'
                            })
                        }
                    }
                    $scope.progressArr[3].percentage = ((regFinishedTasks / regTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[3].issues = regTotalTasks - regFinishedTasks;
                    $scope.progressArr[3].issuesArr = regIssuesArr;
                    /*End: Registration*/

                    /*Start: Auth*/
                    var authTotalTasks = 1;
                    var authFinishedTasks = 0;
                    var authIssuesArr = [];

                    if ($scope.iot3JsonObj && $scope.iot3JsonObj.auth) {
                        if ($scope.iot3JsonObj.auth.http &&
                            $scope.iot3JsonObj.auth.http.actions &&
                            $scope.iot3JsonObj.auth.http.actions.login &&
                            $scope.iot3JsonObj.auth.http.actions.login.selector &&
                            $scope.iot3JsonObj.auth.http.actions.login.selector.type &&
                            $scope.iot3JsonObj.auth.http.actions.login.selector.type.length &&
                            $scope.iot3JsonObj.auth.http.actions.logout &&
                            $scope.iot3JsonObj.auth.http.actions.logout.selector &&
                            $scope.iot3JsonObj.auth.http.actions.logout.selector.type &&
                            $scope.iot3JsonObj.auth.http.actions.logout.selector.type.length) {
                            authFinishedTasks++;
                        } else if ($scope.iot3JsonObj.auth.snmp &&
                            $scope.iot3JsonObj.auth.snmp.version &&
                            $scope.iot3JsonObj.auth.snmp.version.length &&
                            $scope.iot3JsonObj.auth.snmp.credentials &&
                            Object.keys($scope.iot3JsonObj.auth.snmp.credentials).length) {
                            authFinishedTasks++;
                        } else {
                            authIssuesArr.push({
                                'issueText': 'Engine Type details are not complete in the authentication section'
                            })
                        }
                    }
                    $scope.progressArr[4].percentage = ((authFinishedTasks / authTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[4].issues = authTotalTasks - authFinishedTasks;
                    $scope.progressArr[4].issuesArr = authIssuesArr;
                    /*End: Auth*/


                    /*Start: Engine*/
                    var engineTotalTasks = 1;
                    var engineFinishedTasks = 0;
                    var engineIssuesArr = [];

                    if ($scope.iot3JsonObj && $scope.iot3JsonObj.engine) {
                        if ($scope.iot3JsonObj.engine.http) {
                            if ($scope.iot3JsonObj.engine.http.type &&
                                $scope.iot3JsonObj.engine.http.type.length){
                                engineFinishedTasks++;
                            } else {
                                engineIssuesArr.push({
                                    'issueText': 'HTTP Engine Type is not selected in the engine section'
                                })
                            }
                        } else {
                            engineFinishedTasks++;
                        }
                    }
                    $scope.progressArr[6].percentage = ((engineFinishedTasks / engineTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[6].issues = engineTotalTasks - engineFinishedTasks;
                    $scope.progressArr[6].issuesArr = engineIssuesArr;
                    /*End: Engine*/

                    /*Start: Mappers*/
                    var mapperTotalTasks = 1;
                    var mapperFinishedTasks = 0;
                    var mapperIssuesArr = [];

                    if ($scope.iot3JsonObj &&
                        $scope.iot3JsonObj.template &&
                        $scope.iot3JsonObj.template.filters &&
                        $scope.iot3JsonObj.template.filters.mappers &&
                        Object.keys($scope.iot3JsonObj.template.filters.mappers).length) {
                        mapperTotalTasks = Object.keys($scope.iot3JsonObj.template.filters.mappers).length;
                        Object.keys($scope.iot3JsonObj.template.filters.mappers).forEach(function (mapperKey) {
                            if ($scope.iot3JsonObj.template.filters.mappers[mapperKey].keyType &&
                                $scope.iot3JsonObj.template.filters.mappers[mapperKey].keyType.length &&
                                $scope.iot3JsonObj.template.filters.mappers[mapperKey].valueType &&
                                $scope.iot3JsonObj.template.filters.mappers[mapperKey].valueType.length) {
                                mapperFinishedTasks++
                            } else {
                                mapperIssuesArr.push({
                                    'issueText': 'Key Type or Value Type is not added to the ' + mapperKey +' mapper'
                                })
                            }
                        })
                    } else {
                        mapperFinishedTasks++;
                    }
                    $scope.progressArr[8].percentage = ((mapperFinishedTasks / mapperTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[8].issues = mapperTotalTasks - mapperFinishedTasks;
                    $scope.progressArr[8].issuesArr = mapperIssuesArr;
                    /*End: Mappers*/

                    /*Start: Topology*/
                    var topologyTotalTasks = 2;
                    var topologyFinishedTasks = 0;
                    var topologyIssuesArr = [];

                    if ($scope.iot3JsonObj &&
                        $scope.iot3JsonObj.topology &&
                        $scope.iot3JsonObj.topology.rootType &&
                        $scope.iot3JsonObj.topology.rootType.length) {
                        topologyFinishedTasks++
                    } else {
                        topologyIssuesArr.push({
                            'issueText': 'Root Type is not defined in the topology section'
                        })
                    }

                    if ($scope.iot3JsonObj &&
                        $scope.iot3JsonObj.topology &&
                        $scope.iot3JsonObj.topology.nodes &&
                        $scope.iot3JsonObj.topology.nodes.toString().length) {
                        topologyFinishedTasks++
                    } else {
                        topologyIssuesArr.push({
                            'issueText': 'Nodes is not defined in the topology section'
                        })
                    }
                    $scope.progressArr[7].percentage = ((topologyFinishedTasks / topologyTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[7].issues = topologyTotalTasks - topologyFinishedTasks;
                    $scope.progressArr[7].issuesArr = topologyIssuesArr;
                    /*End: Topology*/

                    /*Start: Types*/
                    var typesTotalTasks = 1;
                    var typesFinishedTasks = 0;
                    var typesIssuesArr = [];

                    if ($scope.iot3JsonObj &&
                        $scope.iot3JsonObj.template &&
                        $scope.iot3JsonObj.template.types &&
                        Object.keys($scope.iot3JsonObj.template.types).length) {
                        typesTotalTasks = Object.keys($scope.iot3JsonObj.template.types).length;
                        Object.keys($scope.iot3JsonObj.template.types).forEach(function (typeKey) {
                            if ($scope.iot3JsonObj.template.types[typeKey].price &&
                                ($scope.iot3JsonObj.template.types[typeKey].price.value ||
                                    $scope.iot3JsonObj.template.types[typeKey].price.value === 0) &&
                                $scope.iot3JsonObj.template.types[typeKey].price.unit &&
                                $scope.iot3JsonObj.template.types[typeKey].price.unit.length &&
                                $scope.iot3JsonObj.template.types[typeKey].energy &&
                                ($scope.iot3JsonObj.template.types[typeKey].energy.value ||
                                    $scope.iot3JsonObj.template.types[typeKey].energy.value === 0) &&
                                $scope.iot3JsonObj.template.types[typeKey].energy.unit &&
                                $scope.iot3JsonObj.template.types[typeKey].energy.unit.length) {
                                typesFinishedTasks++
                            } else {
                                typesIssuesArr.push({
                                    'issueText': 'Price or energy information is not completed for ' + typeKey + ' type'
                                })
                            }
                        })
                    } else {
                        if (!($scope.iot3JsonObj &&
                            $scope.iot3JsonObj.template &&
                            $scope.iot3JsonObj.template.types &&
                            Object.keys($scope.iot3JsonObj.template.types).length)) {
                            typesFinishedTasks++;
                        } else {
                            typesIssuesArr.push({
                                'issueText': 'Types are not added to the types section'
                            })
                        }
                    }
                    $scope.progressArr[2].percentage = ((typesFinishedTasks / typesTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[2].issues = typesTotalTasks - typesFinishedTasks;
                    $scope.progressArr[2].issuesArr = typesIssuesArr;
                    /*End: Types*/

                    /*Start: Attributes*/
                    var attrTotalTasks = 1;
                    var attrFinishedTasks = 0;
                    var attrIssuesArr = [];

                    if ($scope.iot3JsonObj &&
                        $scope.iot3JsonObj.template &&
                        $scope.iot3JsonObj.template.attributes &&
                        Object.keys($scope.iot3JsonObj.template.attributes).length) {
                        attrFinishedTasks++
                    } else {
                        attrFinishedTasks++;
                    }
                    $scope.progressArr[5].percentage = ((attrFinishedTasks / attrTotalTasks) * 100).toFixed(2);
                    $scope.progressArr[5].issues = attrTotalTasks - attrFinishedTasks;
                    $scope.progressArr[5].issuesArr = attrIssuesArr;
                    /*End: Attributes*/
                };

                $scope.fnShowIssues = function (displayName, issuesArr) {
                    if (issuesArr.length) {
                        var swalText = '';
                        _.forEach(issuesArr, function (issueObj, index) {
                            var updatedIndex = index + 1;
                            swalText += '<label>'+ updatedIndex + '. ' + issueObj.issueText +'</label>'
                        });
                        swal({
                                title: displayName,
                                text: swalText,
                                type: "warning",
                                html: true,
                                showCancelButton: false,
                                confirmButtonText: "Close",
                                closeOnConfirm: true,
                                showLoaderOnConfirm: false
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    swal.close();
                                }
                            });
                    }
                };

                $scope.fnCreateIot3Workspace = function (isScratch) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/createWorkspaceModal/createWorkspaceModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'createWorkspaceModalCtrl as createWorkspace',
                        resolve: {
                            isScratch: function () {
                                return isScratch;
                            },
                            isEdit: function () {
                                return false;
                            },
                            workSpaceObj: function () {
                                return {};
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (data.isScratch) {
                            $scope.fnCreateScratchIot({detailsObj: data.details});
                        }
                    }, function () {
                    });
                };

                $scope.fnOpenWorkspaceList = function (isGetBlueprints) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/workspaceListModal/workspaceListModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'workspaceListModalCtrl as workspaceList',
                        resolve: {
                            isGetBlueprints: function () {
                                return isGetBlueprints;
                            },
                            isHideDelete: function () {
                                return false;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (isGetBlueprints && data.selectedWorkspace && data.selectedWorkspace.iot3) {
                            data.selectedWorkspace.iot3 = _.cloneDeepWith(angular.fromJson(data.selectedWorkspace.iot3))
                        }
                        $scope.fnCreateIotFromExisting({isScratch: data.isScratch, detailsObj: data.selectedWorkspace});
                    }, function () {
                    });
                };

                $scope.uploadFiles = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var extension = filesSelected.name.substring(filesSelected.name.lastIndexOf('.'), filesSelected.name.length);
                        if (extension === '.iot3Wb') {
                            $scope.fnCreateWbFromImport({fileData: fileLoadedEvent.target.result});
                        } else {
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/iot3/iot3Workbench/modals/createWorkspaceModal/createWorkspaceModal.html',
                                size: 'lg',
                                windowClass: 'modal-height100',
                                controller: 'createWorkspaceModalCtrl as createWorkspace',
                                resolve: {
                                    isScratch: function () {
                                        return true;
                                    },
                                    isEdit: function () {
                                        return false;
                                    },
                                    workSpaceObj: function () {
                                        return {};
                                    }
                                }
                            });

                            modalInstance.result.then(function (data) {
                                $scope.fnCreateIotFromImport({detailsObj: data.details, fileData: fileLoadedEvent.target.result});
                            }, function () {
                            });
                        }
                    };
                    reader.readAsText(filesSelected);
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnEditWorkspace = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/createWorkspaceModal/createWorkspaceModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'createWorkspaceModalCtrl as createWorkspace',
                        resolve: {
                            isScratch: function () {
                                return false;
                            },
                            isEdit: function () {
                                return true
                            },
                            workSpaceObj: function () {
                                return $scope.currentWorkspace;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        $scope.fnEditWorkspaceDetails({workspaceObj: data.details});
                    }, function () {
                    });
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnInitWorkbenchDashboard = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitWorkbenchDashboard();

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Types', fnIot3Types)

    /** @ngInject */
    function fnIot3Types($rootScope, $timeout, $window, amaran, DB) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/types/types.html',
            scope: {
                currentWorkspace: "=",
                iot3JsonObj: "=",
                typesObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                /*START: Overview Tab*/
                $scope.typesTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.typesArr = [];
                $scope.activeTabIndex = $scope.typesTabs[0].tabIndex;
                $scope.filter = "$";
                $scope.typeSearch = {$: ''};
                /*END: Overview Tab*/

                /*START: Create Type*/
                $scope.createTypeObj = {
                    id: "",
                    name: "",
                    dataSource: "",
                    attributesKvpArr: [{
                        key: ""
                    }],
                    price: {
                        value: 0,
                        unit: "USD"
                    },
                    energy: {
                        "value": 0,
                        "unit": ""
                    },
                    alarmsArr: [{
                        key: '',
                        attributeName: '',
                        mapper: ''
                    }]
                };
                $scope.resetCreateTypeObj = _.cloneDeepWith($scope.createTypeObj);
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    mode: 'text/html',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            _cm.setOption("mode", $scope.selectedSampleDataObj.value);
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            /*$timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);*/
                        });
                    }
                };

                $scope.sampleData = {
                    value: ''
                };

                $scope.selectedCreateSubTabIndex = 1;
                $scope.isReferenceDuplicated = false;
                $scope.isReferencePatternMismatched = false;

                var referenceKeyCp = '';
                /*END: Create Type*/

                /*START: Type Detail*/
                $scope.detailEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    mode: 'text/html',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...

                        $scope.modeChangedForDetail = function () {
                            _cm.setOption("mode", $scope.selectedSampleDataObjForDetail.value);
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            /*$timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);*/
                        });
                    }
                };
                $scope.sampleDataForDetail = {
                    value: ''
                };
                $scope.selectedDetailSubTabIndex = 1;
                /*END: Type Detail*/

                /*START: Common Variable*/
                $scope.currencyArr = [{
                    symbol: "$",
                    name: "US Dollar",
                    symbol_native: "$",
                    decimal_digits: 2,
                    rounding: 0,
                    code: "USD",
                    name_plural: "US dollars"
                }, {
                    symbol: "CA$",
                    name: "Canadian Dollar",
                    symbol_native: "$",
                    decimal_digits: 2,
                    rounding: 0,
                    code: "CAD",
                    name_plural: "Canadian dollars"
                }, {
                    symbol: "€",
                    name: "Euro",
                    symbol_native: "€",
                    decimal_digits: 2,
                    rounding: 0,
                    code: "EUR",
                    name_plural: "euros"
                }, {
                    symbol: "AU$",
                    name: "Australian Dollar",
                    symbol_native: "$",
                    decimal_digits: 2,
                    rounding: 0,
                    code: "AUD",
                    name_plural: "Australian dollars"
                }];

                $scope.sampleDataOptions = [{
                    name: "HTML",
                    value: "text/html"
                }, {
                    name: "XML",
                    value: "text/html"
                }, {
                    name: "JSON",
                    value: "javascript"
                }, {
                    name: "CSV",
                    value: "null"
                }, {
                    name: "OID",
                    value: "null"
                }];
                $scope.selectedSampleDataObj = $scope.sampleDataOptions[0];
                $scope.selectedSampleDataObjForDetail = $scope.sampleDataOptions[0];
                /*END: Common Variable*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 35);
                        angular.element("#typesMainContainer").css('height', finalHeight + 'px');

                        var search = angular.isDefined(angular.element(".searchContainer")[0]) ? angular.element(".searchContainer")[0].offsetHeight : 0;
                        var tableHead = angular.isDefined(angular.element(".iotType-table thead")[0]) ? angular.element(".iotType-table thead")[0].offsetHeight : 0;
                        angular.element("#typeTable").css('height', (finalHeight - search - tableHead) + 'px');

                        angular.element("#typesMainContainerDetail").css('height', finalHeight + 30 + 'px');
                        angular.element("#typesCreateMainContainer").css('height', finalHeight + 30 + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 36; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                        angular.element("#typesMainContainerDetail .tabContent").css('height', (finalHeight + 35) - (tabHeader + 5) + 'px');
                        angular.element("#typesCreateMainContainer .tabContent").css('height', (finalHeight + 35) - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnCheckUniqueKeyForCreateAttributes = function (kvpPairObj, index) {
                    $scope.isReferencePatternMismatchedForCreateAttr = false;
                    $scope.isKeyDuplicatedForCreateAttr = false;
                    $scope.duplicatedIndexForCreateAttr = null;
                    var regExp = new RegExp("^[a-z0-9_]+$");
                    if (!regExp.test(kvpPairObj.key)) {
                        $scope.isReferencePatternMismatchedForCreateAttr = true;
                        $scope.duplicatedIndexForCreateAttr = index;
                    } else {
                        $scope.isReferencePatternMismatchedForCreateAttr = false;
                        var count = 0;
                        angular.forEach($scope.createTypeObj.attributesKvpArr, function (kvpPair) {
                            if (kvpPair.key === kvpPairObj.key) {
                                count++;
                            }
                        });
                        if (count > 1) {
                            $scope.isKeyDuplicatedForCreateAttr = true;
                            $scope.duplicatedIndexForCreateAttr = index;
                        } else {
                            $scope.isKeyDuplicatedForCreateAttr = false;
                            $scope.duplicatedIndexForCreateAttr = null;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDetailAttributes = function (kvpPairObj, index) {
                    $scope.isReferencePatternMismatchedForDetailAttr = false;
                    $scope.isKeyDuplicatedForDetailAttr = false;
                    $scope.duplicatedIndexForDetailAttr = null;
                    var regExp = new RegExp("^[a-z0-9_]+$");
                    if (!regExp.test(kvpPairObj.key)) {
                        $scope.isReferencePatternMismatchedForDetailAttr = true;
                        $scope.duplicatedIndexForDetailAttr = index;
                    } else {
                        $scope.isReferencePatternMismatchedForDetailAttr = false;
                        var count = 0;
                        angular.forEach($scope.selectedTypeObj.attributesKvpArr, function (kvpPair) {
                            if (kvpPair.key === kvpPairObj.key) {
                                count++;
                            }
                        });
                        if (count > 1) {
                            $scope.isKeyDuplicatedForDetailAttr = true;
                            $scope.duplicatedIndexForDetailAttr = index;
                        } else {
                            $scope.isKeyDuplicatedForDetailAttr = false;
                            $scope.duplicatedIndexForDetailAttr = null;
                        }
                    }
                };

                $scope.fnCheckUniqueAlarmName = function (alarmsObj, alarmIndex, type) {
                    if (type === 'create') {
                        var isFindIndex = _.findIndex($scope.createTypeObj.alarmsArr, function (alarmObj, index) {
                            return index !== alarmIndex && alarmObj.key === alarmsObj.key;
                        });
                        alarmsObj.isAlarmKeyDuplicated = isFindIndex !== -1;
                    } else {
                        var isFindIndexDetail = _.findIndex($scope.selectedTypeObj.alarmsArr, function (alarmObj, index) {
                            return index !== alarmIndex && alarmObj.key === alarmsObj.key;
                        });
                        alarmsObj.isAlarmKeyDuplicated = isFindIndexDetail !== -1;
                    }
                };

                $scope.fnAddAlarm = function (event, type) {
                    event.preventDefault();
                    if (type === 'create') {
                        $scope.createTypeObj.alarmsArr.push({
                            key: '',
                            attributeName: '',
                            mapper: ''
                        })
                    } else {
                        $scope.selectedTypeObj.alarmsArr.push({
                            key: '',
                            attributeName: '',
                            mapper: ''
                        })
                    }
                };

                $scope.fnDeleteAlarm = function (event, index, type) {
                    event.preventDefault();
                    if (type === 'create') {
                        $scope.createTypeObj.alarmsArr.splice(index, 1);
                    } else {
                        $scope.selectedTypeObj.alarmsArr.splice(index, 1);
                    }
                };

                $scope.fnSelectAttributeForAlarms = function (attributeName, alarmsObj) {
                    alarmsObj.attributeName = attributeName;
                };

                $scope.fnGlobalKeySelectedForMappings = function (item, model, label, event, alarmsObj, dataSourceKey) {
                    if (alarmsObj.oldValueKeyForMappings.includes('.')) {
                        alarmsObj.mapper = alarmsObj.oldValueKeyForMappings.substr(0, alarmsObj.oldValueKeyForMappings.lastIndexOf('.')) + '.' + dataSourceKey.name;
                    } else {
                        alarmsObj.mapper = '%{' + dataSourceKey.name;
                    }
                };

                $scope.fnCheckUniqueKeyForMappings = function (alarmsObj,dataSourceKey) {
                    alarmsObj.globalKeyOptions = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        alarmsObj.oldValueKeyForMappings = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    alarmsObj.globalKeyOptions.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                alarmsObj.globalKeyOptions.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnChangeTab($scope.typesTabs[0]);
                    $timeout(function () {
                        $scope.fnInitiateResetWorkspace();
                    })
                };

                $scope.fnChangeTab = function (tab) {
                    if ($scope.activeTabIndex !== 1 && $scope.activeTabIndex !== "Create Type") {
                        if ($scope.typesTabs[$scope.activeTabIndex - 1]) {
                            $scope.typesTabs[$scope.activeTabIndex - 1].id = $scope.selectedTypeObj.id;
                            $scope.typesTabs[$scope.activeTabIndex - 1].title = $scope.selectedTypeObj.name;
                        }
                        $scope.fnEditType();
                    }

                    $scope.activeTabIndex = tab.tabIndex;

                    $scope.isCreate = tab.id === "Create Type";

                    if (!$scope.isCreate && $scope.activeTabIndex !== 1) {
                        var isValueFind = _.find($scope.typesArr, {'id': tab.id});
                        if (isValueFind) {
                            $scope.fnGetTypeDetails(isValueFind);
                        }
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnRemoveTab = function (id, tabIndex) {
                    if (id !== 1 && id !== "Create Type") {
                        $scope.fnEditType();
                    }
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex($scope.typesTabs, {id: id});

                    if (id === "Create Type") {
                        $scope.isCreate = false;
                    }

                    if ($scope.activeTabIndex === tabIndex) {
                        if ($scope.typesTabs.length === (index + 1) || id === "Create Type") {
                            $scope.activeTabIndex = 1;
                        }
                    }
                    _.forEach($scope.typesTabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    $scope.typesTabs = _.cloneDeepWith(tabs);

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnTabChanged = function (tab) {
                    $scope.isCreate = tab.id === "Create Type";

                    $scope.fnSetTableHeight();
                };

                $scope.fnGlobalKeySelectedForDataSource = function (item, model, label, event, dataSourceKey, type) {
                    if (type === 'create') {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.createTypeObj.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.createTypeObj.dataSource = '%{' + dataSourceKey.name;
                        }
                    } else {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.selectedTypeObj.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.selectedTypeObj.dataSource = '%{' + dataSourceKey.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDataSource = function (dataSourceKey) {
                    $scope.globalKeyOptionsForDataSource = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        $scope.oldValueKeyForDataSource = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    $scope.globalKeyOptionsForDataSource.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                $scope.globalKeyOptionsForDataSource.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnOpenCreateTypeView = function () {
                    $scope.isCreate = true;
                    if ($scope.isCreate) {
                        var isTabExist = _.find($scope.typesTabs, {'id': 'Create Type'});
                        if (isTabExist) {
                            $timeout(function () {
                                $scope.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = $scope.typesTabs.length + 1;
                            $scope.typesTabs.push({
                                id: 'Create Type',
                                title: 'Create Type',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                $scope.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                $scope.fnGetTypeDetails = function (typeObj) {
                    $scope.selectedTypeObj = null;
                    referenceKeyCp = '';
                    /* Toggle push in selected types array*/
                    var isTabExist = _.find($scope.typesTabs, {'id': typeObj.id});
                    if (isTabExist) {
                        $timeout(function () {
                            $scope.activeTabIndex = isTabExist.tabIndex;
                            $scope.selectedTypeObj = typeObj;
                            referenceKeyCp = _.cloneDeepWith($scope.selectedTypeObj.id);
                            //$scope.fnUpdateSampleData();
                            $scope.$apply();
                        });
                    } else {
                        var newTabIndex = $scope.typesTabs.length + 1;
                        $scope.typesTabs.push({
                            id: typeObj.id,
                            title: typeObj.name,
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            $scope.activeTabIndex = newTabIndex;
                            $scope.selectedTypeObj = typeObj;
                            if ($scope.selectedTypeObj.alarms &&
                                Object.keys($scope.selectedTypeObj.alarms).length) {
                                var tempArr = [];
                                Object.keys($scope.selectedTypeObj.alarms).forEach(function (alarmKey) {
                                    tempArr.push({
                                        key: alarmKey,
                                        attributeName: $scope.selectedTypeObj.alarms[alarmKey].attribute,
                                        mapper: $scope.selectedTypeObj.alarms[alarmKey].mapper
                                    })
                                });
                                $scope.selectedTypeObj.alarmsArr = _.cloneDeepWith(tempArr);
                            } else {
                                $scope.selectedTypeObj.alarms = {};
                                $scope.selectedTypeObj.alarmsArr = [{
                                    key: '',
                                    attributeName: '',
                                    mapper: ''
                                }]
                            }
                            referenceKeyCp = _.cloneDeepWith($scope.selectedTypeObj.id);
                            //$scope.fnUpdateSampleData();
                            angular.element($window).triggerHandler('resize');
                        })
                    }
                };

                $scope.fnUpdateSampleData = function () {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if (workbench.currentWorkspaceSampleData && Object.keys(workbench.currentWorkspaceSampleData).length
                            && workbench.currentWorkspaceSampleData[$scope.selectedTypeObj.id]) {
                            $scope.sampleDataForDetail.value = workbench.currentWorkspaceSampleData[$scope.selectedTypeObj.id].sampleData;
                            var isFind = _.find($scope.sampleDataOptions, function (sampleDataObj) {
                                return sampleDataObj.name === workbench.currentWorkspaceSampleData[$scope.selectedTypeObj.id].sampleDataType;
                            });
                            if (isFind) {
                                $scope.selectedSampleDataObjForDetail = isFind;
                            } else {
                                $scope.selectedSampleDataObjForDetail = $scope.sampleDataOptions[0];
                            }
                        } else {
                            $scope.sampleDataForDetail = {
                                value: ''
                            };
                            $scope.selectedSampleDataObjForDetail = $scope.sampleDataOptions[0];
                        }
                        DB.fnSet('iot3Workbench', workbench);
                    } else {
                        $scope.sampleDataForDetail = {
                            value: ''
                        };
                        $scope.selectedSampleDataObjForDetail = $scope.sampleDataOptions[0];
                    }
                };

                $scope.fnSelectSampleDataLanguage = function (sampleDataObj, typeMode) {
                    if (typeMode === 'detail') {
                        $scope.selectedSampleDataObjForDetail = _.cloneDeepWith(sampleDataObj);
                        $scope.modeChangedForDetail();
                    } else {
                        $scope.selectedSampleDataObj = _.cloneDeepWith(sampleDataObj);
                        $scope.modeChanged();
                    }
                };

                $scope.fnAddAttribute = function (type) {
                    if (type === 'detail') {
                        $scope.selectedTypeObj.attributesKvpArr.push({
                            key: ""
                        });
                    } else {
                        $scope.createTypeObj.attributesKvpArr.push({
                            key: ""
                        });
                    }
                };

                $scope.fnRemoveAttribute = function (index, type) {
                    if (type === 'detail') {
                        $scope.selectedTypeObj.attributesKvpArr.splice(index, 1);
                    } else {
                        $scope.createTypeObj.attributesKvpArr.splice(index, 1);
                    }
                };

                $scope.fnAddTypeToList = function () {
                    var tempArr = _.filter($scope.createTypeObj.attributesKvpArr, function (attrObj) {
                        if (attrObj.key.length) {
                            if (!attrObj.key.startsWith($scope.createTypeObj.id + "_")) {
                                attrObj.key = $scope.createTypeObj.id + "_" + attrObj.key;
                            }
                            return attrObj;
                        }
                    });
                    $scope.createTypeObj.attributesKvpArr = _.cloneDeepWith(tempArr);

                    if ($scope.createTypeObj.alarmsArr && $scope.createTypeObj.alarmsArr.length) {
                        var tempObj = {};
                        _.forEach($scope.createTypeObj.alarmsArr, function (alarmObj) {
                            if (!alarmObj.isAlarmKeyDuplicated) {
                                tempObj[alarmObj.key] = {
                                    attribute: $scope.createTypeObj.id + "_" + alarmObj.attributeName,
                                    mapper: alarmObj.mapper
                                }
                            }
                        });
                        $scope.createTypeObj.alarms = _.cloneDeepWith(tempObj);
                        delete $scope.createTypeObj.alarmsArr;
                    } else {
                        $scope.createTypeObj.alarms = {};
                        delete $scope.createTypeObj.alarmsArr;
                    }
                    $scope.typesArr.push($scope.createTypeObj);
                    //$scope.fnSaveSample($scope.createTypeObj.id, {sampleDataType: $scope.selectedSampleDataObj.name, sampleData: $scope.sampleData.value});
                    $scope.createTypeObj = _.cloneDeepWith($scope.resetCreateTypeObj);
                    //$scope.sampleData.value = '';
                    $scope.fnRemoveTab("Create Type", $scope.activeTabIndex);
                };

                $scope.fnSaveSample = function (typeId, sampleDataObj) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if (workbench.currentWorkspaceSampleData && Object.keys(workbench.currentWorkspaceSampleData).length) {
                            if (referenceKeyCp && referenceKeyCp.length && workbench.currentWorkspaceSampleData[referenceKeyCp]) {
                                delete workbench.currentWorkspaceSampleData[referenceKeyCp];
                            }
                            workbench.currentWorkspaceSampleData[typeId] = sampleDataObj;
                        } else {
                            workbench.currentWorkspaceSampleData = {};
                            workbench.currentWorkspaceSampleData[typeId] = sampleDataObj;
                        }
                        DB.fnSet('iot3Workbench', workbench);
                    }
                };

                $scope.fnInitCalled = function () { //editorType
                    /*$timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        if (editorType === 'detail') {
                            $scope.modeChangedForDetail();
                        } else {
                            $scope.modeChanged();
                        }
                    }, 150)*/
                };

                $scope.fnSelectSubTab = function (tabIndex, typeMode) {
                    if (typeMode === 'detail') {
                        $scope.selectedDetailSubTabIndex = tabIndex;
                    } else {
                        $scope.selectedCreateSubTabIndex = tabIndex
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                    /*$timeout(function () {
                        if (typeMode === 'detail') {
                            $scope.modeChangedForDetail();
                        } else {
                            $scope.modeChanged();
                        }
                    })*/
                };

                $scope.fnCheckCreateTypeReference = function () {
                    $scope.isReferencePatternMismatched = false;
                    $scope.isReferenceDuplicated = false;
                    var regExp = new RegExp("^[a-z0-9_]+$");
                    if (!regExp.test($scope.createTypeObj.id)) {
                        $scope.isReferencePatternMismatched = true;
                    } else {
                        $scope.isReferencePatternMismatched = false;
                        var findIndex = _.findIndex($scope.typesArr, function (typeObj) {
                            return typeObj.id === $scope.createTypeObj.id;
                        });
                        if (findIndex !== -1) {
                            $scope.isReferenceDuplicated = true;
                        }
                    }
                };

                $scope.fnEditType = function () {
                    var tempArr = _.filter($scope.selectedTypeObj.attributesKvpArr, function (attrObj, index) {
                        var flag = true;
                        if ($scope.isKeyDuplicatedForDetailAttr || $scope.isReferencePatternMismatchedForDetailAttr) {
                            if (index === $scope.duplicatedIndexForDetailAttr) {
                                flag = false;
                            }
                        }
                        if (flag) {
                            if (attrObj.key.length && !attrObj.key.startsWith($scope.selectedTypeObj.id + "_")) {
                                if (referenceKeyCp && referenceKeyCp.length &&
                                    attrObj.key.startsWith(referenceKeyCp + "_")) {
                                    var splitArr = attrObj.key.split(referenceKeyCp + "_");
                                    attrObj.key = $scope.selectedTypeObj.id + "_" + splitArr[1];
                                } else {
                                    attrObj.key = $scope.selectedTypeObj.id + "_" + attrObj.key;
                                }
                            }
                            return attrObj;
                        }
                    });
                    $scope.selectedTypeObj.attributesKvpArr = _.cloneDeepWith(tempArr);
                    var findIndex = _.findIndex($scope.typesArr, function (typeObj) {
                        return typeObj.id === $scope.selectedTypeObj.id;
                    });

                    if ($scope.selectedTypeObj.alarmsArr && $scope.selectedTypeObj.alarmsArr.length) {
                        var tempObj = {};
                        _.forEach($scope.selectedTypeObj.alarmsArr, function (alarmObj) {
                            if (!alarmObj.isAlarmKeyDuplicated) {
                                if (referenceKeyCp && referenceKeyCp.length &&
                                    alarmObj.attributeName.startsWith(referenceKeyCp + "_")) {
                                    var splitArr = alarmObj.attributeName.split(referenceKeyCp + "_");
                                    alarmObj.attributeName = $scope.selectedTypeObj.id + "_" + splitArr[1];
                                } else {
                                    alarmObj.attributeName = $scope.selectedTypeObj.id + "_" + alarmObj.attributeName;
                                }
                                tempObj[alarmObj.key] = {
                                    attribute: alarmObj.attributeName,
                                    mapper: alarmObj.mapper
                                }
                            }
                        });
                        $scope.selectedTypeObj.alarms = _.cloneDeepWith(tempObj);
                        delete $scope.selectedTypeObj.alarmsArr;
                    } else {
                        $scope.selectedTypeObj.alarms = {};
                        delete $scope.selectedTypeObj.alarmsArr;
                    }

                    if (findIndex !== -1) {
                        $scope.typesArr[findIndex] = _.cloneDeepWith($scope.selectedTypeObj);
                        //$scope.fnSaveSample($scope.selectedTypeObj.id, {sampleDataType: $scope.selectedSampleDataObjForDetail.name, sampleData: $scope.sampleDataForDetail.value});
                    }

                    $scope.isReferencePatternMismatchedForDetailAttr = false;
                    $scope.isKeyDuplicatedForDetailAttr = false;
                    $scope.duplicatedIndexForDetailAttr = null;
                };

                $scope.fnDeleteType = function () {
                    var isTabExist = _.findIndex($scope.typesTabs, {'id': $scope.selectedTypeObj.id});

                    if (isTabExist) {
                        $scope.typesTabs.splice(isTabExist, 1);
                        $scope.selectedDetailSubTabIndex = 1;
                        $scope.activeTabIndex = 1;

                        var findIndex = _.findIndex($scope.typesArr, function (typeObj) {
                            return typeObj.id === $scope.selectedTypeObj.id;
                        });
                        if (findIndex !== -1) {
                            $scope.typesArr.splice(findIndex, 1);
                        }
                        $scope.selectedTypeObj = '';
                        referenceKeyCp = '';
                    }
                };

                $scope.fnSelectCurrencyCode = function (currencyCode, type) {
                    if (type === 'detail') {
                        $scope.selectedTypeObj.price.unit = currencyCode;
                    } else {
                        $scope.createTypeObj.price.unit = currencyCode;
                    }
                };

                function convertCSVToXML(csvData) {
                    var splitter = '';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    } else if (csvData.includes(',')) {
                        splitter = ','
                    }

                    if (splitter !== '') {
                        var csvArr = csvData.split('\n');
                        csvArr = _.map(csvArr, function (row) {
                            return row.trim();
                        });
                        var headings = csvArr[0].split(splitter);
                        var xml = '';

                        for (var i = 1; i < csvArr.length; i++) {
                            var details = csvArr[i].split(splitter);
                            xml += "<row>\n";

                            for (var j = 0; j < headings.length; j++) {
                                xml += '<item>'+ details[j] +'</item>';
                            }

                            xml += "</row>\n";
                        }
                        return xml;
                    } else {
                        return 'not valid';
                    }
                }

                $scope.fnConvertCsvToXml = function (type) {
                    var xmlData = '';
                    if (type === 'detail') {
                        xmlData = convertCSVToXML($scope.sampleDataForDetail.value);
                        if (xmlData === 'not valid') {
                            amaran.error('CSV is not valid!')
                        } else {
                            $scope.fnSelectSampleDataLanguage({
                                name: "XML",
                                value: "text/html"
                            }, 'detail');
                            $scope.sampleDataForDetail.value = xmlData;
                        }
                    } else {
                        xmlData = convertCSVToXML($scope.sampleData.value);
                        if (xmlData === 'not valid') {
                            amaran.error('CSV is not valid!')
                        } else {
                            $scope.fnSelectSampleDataLanguage({
                                name: "XML",
                                value: "text/html"});
                            $scope.sampleData.value = xmlData;
                        }
                    }
                };

                $scope.fnInitTypesTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;
                    if ($scope.typesObj && Object.keys($scope.typesObj).length) {
                        Object.keys($scope.typesObj).forEach(function (typeKey) {
                            var tempObj = $scope.typesObj[typeKey];
                            tempObj.attributesKvpArr = [];
                            if ($scope.typesObj[typeKey].attributes && $scope.typesObj[typeKey].attributes.length) {
                                _.forEach($scope.typesObj[typeKey].attributes, function (attrKey) {
                                    tempObj.attributesKvpArr.push({
                                        key: attrKey
                                    })
                                });
                            } else {
                                $scope.typesObj[typeKey].attributes = [];
                                tempObj.attributesKvpArr.push({
                                    key: ''
                                })
                            }
                            tempObj.id = typeKey;
                            $scope.typesArr.push(tempObj)
                        })
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitTypesTab();

                $scope.fnCallOnDestroyForTypes = function () {
                    var tempObj = {};
                    _.forEach($scope.typesArr, function (typeObj) {
                        tempObj[typeObj.id] = {
                            name: typeObj.name,
                            version: typeObj.version,
                            dataSource: typeObj.dataSource,
                            attributes: [],
                            alarms: typeObj.alarms,
                            price: {
                                value: typeObj.price.value,
                                unit: typeObj.price.unit
                            },
                            energy: {
                                value: typeObj.energy.value,
                                unit: typeObj.energy.unit
                            }
                        };
                        _.forEach(typeObj.attributesKvpArr, function (attrObj) {
                            if (attrObj.key.length) {
                                tempObj[typeObj.id].attributes.push(attrObj.key)
                            }
                        })
                    });
                    $scope.fnUpdateWorkbench({updateType: 'type', updateValue: tempObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnCallOnDestroyForTypes();
                });

                $window.onbeforeunload = function() {
                    $scope.fnCallOnDestroyForTypes();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Topology', fnIot3Topology)

    /** @ngInject */
    function fnIot3Topology($rootScope, $timeout, $window, $uibModal, amaran, DB) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/topology/topology.html',
            scope: {
                currentWorkspace: "=",
                iot3JsonObj: "=",
                iot3TopologyObj: "=",
                typesObj: "=",
                mappingsObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateGlobalFromAttr: "&",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.topologyTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.topologyTabs[0];

                $scope.selectedSubTabIndex = 1;

                $scope.attrSelectorPathOptions = [
                    "xpath",
                    "oid",
                    "gjson",
                    "cookie",
                    "header"
                ];

                $scope.discoveryTypeOptions = [
                    "static",
                    "list",
                    "map"
                ];

                $scope.resetVerifyObj = {
                    dataSource: '',
                    selector: {
                        type: '',
                        expression: '',
                        selectors: {}
                    },
                    extractor: {
                        keys: [],
                        transform: '',
                        filters: {},
                        mapper: '',
                        parameters: {}
                    },
                    match: ''
                };

                $scope.verifyArr = [{
                    dataSource: '',
                    selector: {
                        type: '',
                        expression: '',
                        selectors: {}
                    },
                    extractor: {
                        keys: [],
                        transform: '',
                        filters: {},
                        mapper: '',
                        parameters: {}
                    },
                    match: ''
                }];

                $scope.resetDiscoveryObj = {
                    type: $scope.discoveryTypeOptions[0],
                    dataSource: '',
                    expression: {},
                    selectors: {},
                    flatten: {}
                };

                $scope.mappingsArr = [];

                $scope.extractFiltersArrForVerify = [{
                    key: '',
                    value: ''
                }];
                $scope.resetExtractFiltersArrForVerify = _.cloneDeepWith($scope.extractFiltersArrForVerify);

                $scope.attrFilterOptionsForVerify = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "split",
                    "displayValue": "split",
                    "isArguments": true,
                    "isShow": true
                }];
                $scope.resetAttrFilterOptionsForVerify = _.cloneDeepWith($scope.attrFilterOptionsForVerify);
                $scope.isMapperSelectedForVerify = false;

                $scope.selectorPathOptions = {
                    'JSON': 'gjson',
                    'XML': 'xpath',
                    'HTML': 'xpath',
                    'CSV': 'xpath',
                    'OID': 'oid',
                    'Cookie': 'cookie',
                    'Header': 'header'
                };

                $scope.expressionsArr = [{
                    key: '',
                    value: ''
                }];

                $scope.resetSelectorObj = {
                    type: '',
                    expression: '',
                    selectors: {}
                };

                $scope.resetExtractorObj = {
                    keys: [],
                    transform: '',
                    filters: {},
                    mapper: '',
                    parameters: {}
                };

                $scope.selectorsArrForDiscovery = [];

                $scope.extractorsArrForDiscovery = [];

                $scope.rootTypesArr = [];

                /*Search Variables*/
                $scope.verifySearch = {$: ''};

                $scope.discoverySearch = {$: ''};

                $scope.filter = "$";
                $scope.flattenSearch = {$: ''};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#topologyMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 4);
                        angular.element("#topologyMainContainer").css('height', finalHeight + 'px');

                        var tabHeader = angular.isDefined(angular.element(".tab-container .nav-tabs")[0]) ? angular.element(".tab-container .nav-tabs")[0].offsetHeight : 42;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 40) + 'px');
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnChangeSubTab = function (tab) {
                    $scope.selectedSubTabIndex = tab;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnOpenVerifierModal = function (isCreate, verifyObj, index) {
                    var tempObj = {};
                    if (isCreate) {
                        tempObj = _.cloneDeepWith($scope.resetVerifyObj);
                        $scope.fnGetExtractorFiltersForVerify(tempObj);
                        $scope.fnGetTypeSampleData('verify', tempObj);
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/steps/topology/modals/verifyDetailsModal/verifyDetails.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'verifyDetailsModalCtrl as verifyDetails',
                        resolve: {
                            verifyObj: function () {
                                return isCreate ? tempObj : verifyObj;
                            },
                            isCreate: function () {
                                return isCreate;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            },
                            mappingsArr: function () {
                                return $scope.mappingsArr;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (isCreate) {
                            $scope.verifyArr.push(data);
                        } else {
                            $scope.verifyArr[index] = _.cloneDeepWith(data);
                        }
                    }, function () {
                    });

                };

                $scope.fnOpenDiscoveryModal = function (isCreate, discoverySelectorObj, index) {
                    var createDiscoverySelectorObj = {};
                    if (isCreate) {
                        createDiscoverySelectorObj = {
                            key: '',
                            value: {
                                selectorObj: _.cloneDeepWith($scope.resetSelectorObj)
                            }
                        };

                        if (DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            if ($scope.iot3TopologyObj &&
                                $scope.iot3TopologyObj.discovery &&
                                $scope.iot3TopologyObj.discovery.dataSource &&
                                $scope.iot3TopologyObj.discovery.dataSource.length &&
                                $scope.iot3TopologyObj.discovery.dataSource.startsWith('%{') &&
                                $scope.iot3TopologyObj.discovery.dataSource.endsWith('}') &&
                                workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                                var engineTrailForDiscovery = $scope.iot3TopologyObj.discovery.dataSource.substr(2, $scope.iot3TopologyObj.discovery.dataSource.lastIndexOf('}') - 2);
                                var requestNameForDiscovery = engineTrailForDiscovery.split('.');
                                var valueForDiscovery = _.get(workbench.currentWorkspaceEngineSampleData, requestNameForDiscovery[requestNameForDiscovery.length - 1], 'notFound');

                                if (valueForDiscovery !== 'notFound' && valueForDiscovery.constructor.name === 'Object') {
                                    createDiscoverySelectorObj.value.sampleDataForDiscovery = valueForDiscovery;
                                    createDiscoverySelectorObj.value.selectorObj.type = $scope.selectorPathOptions[valueForDiscovery.sampleDataType];
                                } else {
                                    $scope.fnResetSampleDataForDiscovery(createDiscoverySelectorObj.value);
                                }
                            } else {
                                $scope.fnResetSampleDataForDiscovery(createDiscoverySelectorObj.value);
                            }
                        } else {
                            $scope.fnResetSampleDataForDiscovery(createDiscoverySelectorObj.value);
                        }
                    }

                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/steps/topology/modals/discoveryDetailsModal/discoveryDetails.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'discoveryDetailsModalCtrl as discoveryDetails',
                        resolve: {
                            discoverySelectorObj: function () {
                                return isCreate ? createDiscoverySelectorObj : discoverySelectorObj;
                            },
                            isCreate: function () {
                                return isCreate;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (isCreate) {
                            $scope.selectorsArrForDiscovery.push(data);
                        } else {
                            $scope.selectorsArrForDiscovery[index] = _.cloneDeepWith(data);
                        }
                    }, function () {
                    });

                };

                $scope.fnOpenFlattenModal = function (isCreate, discoveryExtractorObj, index) {
                    var createExtractorObj = {};
                    if (isCreate) {
                        createExtractorObj = {
                            key: '',
                            value: {
                                extractFiltersArrForDiscovery: [{
                                    key: '',
                                    value: ''
                                }],
                                extractorObj: _.cloneDeepWith($scope.resetExtractorObj)
                            }
                        }
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/steps/topology/modals/flattenDetailsModal/flattenDetails.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'flattenDetailsModalCtrl as flattenDetails',
                        resolve: {
                            discoveryExtractorObj: function () {
                                return isCreate ? createExtractorObj : discoveryExtractorObj;
                            },
                            isCreate: function () {
                                return isCreate;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            },
                            mappingsArr: function () {
                                return $scope.mappingsArr;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (isCreate) {
                            $scope.extractorsArrForDiscovery.push(data);
                        } else {
                            $scope.extractorsArrForDiscovery[index] = _.cloneDeepWith(data);
                        }
                    }, function () {
                    });

                };

                $scope.fnDeleteVerifyObj = function (event, index) {
                    event.preventDefault();
                    $scope.verifyArr.splice(index, 1);
                };

                $scope.fnDeleteDiscoveryObj = function (event, index, type) {
                    event.preventDefault();
                    if (type === 'selector') {
                        $scope.selectorsArrForDiscovery.splice(index, 1);
                    } else {
                        $scope.extractorsArrForDiscovery.splice(index, 1);
                    }
                };

                $scope.fnSelectDiscoveryTypeOptions = function (discoveryType) {
                    $scope.iot3TopologyObj.discovery.type = discoveryType;
                };

                $scope.fnGlobalKeySelectedForRootType = function (item, model, label, event, rootTypeKey) {
                    if ($scope.oldValueKeyForRootType.includes('.')) {
                        $scope.iot3TopologyObj.rootType = $scope.oldValueKeyForRootType.substr(0, $scope.oldValueKeyForRootType.lastIndexOf('.')) + '.' + rootTypeKey.name;
                    } else {
                        $scope.iot3TopologyObj.rootType = '%{' + rootTypeKey.name;
                    }
                };

                $scope.fnCheckUniqueKeyForRootType = function (rootTypeKey) {
                    $scope.globalKeyOptionsForRootType = [];
                    if (rootTypeKey &&
                        rootTypeKey.startsWith('%{') && !rootTypeKey.endsWith('}')) {
                        $scope.oldValueKeyForRootType = rootTypeKey;
                        var keys = [];
                        if (rootTypeKey.includes('.')) {
                            var trail = rootTypeKey.substr(2, rootTypeKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    $scope.globalKeyOptionsForRootType.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                $scope.globalKeyOptionsForRootType.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnGlobalKeySelectedForDataSource = function (item, model, label, event, dataSourceKey, type) {
                    if (type === 'verify') {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.iot3TopologyObj.verify.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.iot3TopologyObj.verify.dataSource = '%{' + dataSourceKey.name;
                        }
                    } else {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.iot3TopologyObj.discovery.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.iot3TopologyObj.discovery.dataSource = '%{' + dataSourceKey.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDataSource = function (dataSourceKey) {
                    $scope.globalKeyOptionsForDataSource = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        $scope.oldValueKeyForDataSource = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    $scope.globalKeyOptionsForDataSource.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                $scope.globalKeyOptionsForDataSource.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnGetTypeSampleData = function (type, verifyObj) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if (type === 'verify') {
                            if (verifyObj &&
                                verifyObj.dataSource &&
                                verifyObj.dataSource.length &&
                                verifyObj.dataSource.startsWith('%{') &&
                                verifyObj.dataSource.endsWith('}') &&
                                workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                                var engineTrail = verifyObj.dataSource.substr(2, verifyObj.dataSource.lastIndexOf('}') - 2);
                                var requestName = engineTrail.split('.');
                                var value = _.get(workbench.currentWorkspaceEngineSampleData, requestName[requestName.length - 1], 'notFound');

                                if (value !== 'notFound' && value.constructor.name === 'Object' &&
                                    (value.sampleData && value.sampleData !== '')) {
                                    verifyObj.sampleDataForVerify = value;
                                    verifyObj.selector.type = $scope.selectorPathOptions[value.sampleDataType];
                                } else {
                                    $scope.fnResetSampleData(verifyObj);
                                }
                            } else {
                                $scope.fnResetSampleData(verifyObj);
                            }
                        } else {
                            if ($scope.iot3TopologyObj &&
                                $scope.iot3TopologyObj.discovery &&
                                $scope.iot3TopologyObj.discovery.dataSource &&
                                $scope.iot3TopologyObj.discovery.dataSource.length &&
                                $scope.iot3TopologyObj.discovery.dataSource.startsWith('%{') &&
                                $scope.iot3TopologyObj.discovery.dataSource.endsWith('}') &&
                                workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                                _.forEach($scope.selectorsArrForDiscovery, function (selectorObj) {
                                    var engineTrailForDiscovery = $scope.iot3TopologyObj.discovery.dataSource.substr(2, $scope.iot3TopologyObj.discovery.dataSource.lastIndexOf('}') - 2);
                                    var requestNameForDiscovery = engineTrailForDiscovery.split('.');
                                    var valueForDiscovery = _.get(workbench.currentWorkspaceEngineSampleData, requestNameForDiscovery[requestNameForDiscovery.length - 1], 'notFound');

                                    if (valueForDiscovery !== 'notFound' &&
                                        valueForDiscovery.constructor.name === 'Object' &&
                                        (valueForDiscovery.sampleData && valueForDiscovery.sampleData !== '')) {
                                        selectorObj.value.sampleDataForDiscovery = valueForDiscovery;
                                        selectorObj.value.selectorObj.type = $scope.selectorPathOptions[valueForDiscovery.sampleDataType];
                                    } else {
                                        $scope.fnResetSampleDataForDiscovery(selectorObj.value);
                                    }
                                });
                            } else {
                                _.forEach($scope.selectorsArrForDiscovery, function (selectorObj) {
                                    $scope.fnResetSampleDataForDiscovery(selectorObj.value);
                                });
                            }
                        }
                    } else {
                        if (type === 'verify') {
                            $scope.fnResetSampleData();
                        } else {
                            _.forEach($scope.selectorsArrForDiscovery, function (selectorObj) {
                                $scope.fnResetSampleDataForDiscovery(selectorObj.value);
                            });
                        }
                    }
                };

                $scope.fnResetSampleData = function (verifyObj) {
                    verifyObj.sampleDataForVerify = {};
                    verifyObj.selectedSampleDataForVerify = '';
                    verifyObj.manipulatedSampleDataForVerify = '';
                    verifyObj.isShowSampleDataForVerify = false;

                    if (!(verifyObj &&
                        verifyObj.selector &&
                        verifyObj.selector.type &&
                        verifyObj.selector.type.length)) {
                        verifyObj.selector.type = $scope.selectorPathOptions.HTML;
                    }
                };

                $scope.fnResetSampleDataForDiscovery = function (discoverySelectorObj) {
                    discoverySelectorObj.sampleDataForDiscovery = {};
                    discoverySelectorObj.selectedSampleDataForDiscovery = '';
                    discoverySelectorObj.manipulatedSampleDataForDiscovery = '';
                    discoverySelectorObj.isShowSampleDataForDiscovery = false;

                    if (!(discoverySelectorObj.selectorObj &&
                        discoverySelectorObj.selectorObj.type &&
                        discoverySelectorObj.selectorObj.type.length)) {
                        discoverySelectorObj.selectorObj.type = $scope.selectorPathOptions.HTML;
                    }
                };

                $scope.fnRemoveSupplementalExpression = function (index) {
                    $scope.expressionsArr.splice(index, 1)
                };

                $scope.fnGetExtractorFiltersForVerify = function (verifyObj) {
                    if (verifyObj &&
                        verifyObj.extractor &&
                        verifyObj.extractor.filters) {
                        var tempArr = [];
                        if (angular.isArray(verifyObj.extractor.filters)) {
                            if (verifyObj.extractor.filters.length) {
                                _.forEach(verifyObj.extractor.filters, function (filterValue) {
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(' '));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(' ')+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForVerify, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForVerify[isShowArguments].isShow = false;
                                    }

                                    var tempObj = {
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForVerify[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    };

                                    if (splitArr[0] === 'switch') {
                                        tempObj.value = '';
                                        var switchValuesArr = splitArr[1].split('\n');
                                        if (switchValuesArr && switchValuesArr.length) {
                                            tempObj.switchValuesArr = [];
                                            _.forEach(switchValuesArr, function (val) {
                                                if (val && val.length) {
                                                    tempObj.switchValuesArr.push({
                                                        value: val
                                                    })
                                                }
                                            });
                                            tempObj.switchValuesArr.push({
                                                value: ''
                                            })
                                        } else {
                                            tempObj.switchValuesArr = [{
                                                value: ''
                                            }]
                                        }
                                    }
                                    tempArr.push(tempObj);
                                });
                                tempArr.push({
                                    key: '',
                                    value: ''
                                });
                                verifyObj.extractFiltersArrForVerify = tempArr;
                            } else {
                                verifyObj.extractFiltersArrForVerify = _.cloneDeepWith($scope.resetExtractFiltersArrForVerify);
                            }
                        } else {
                            if (Object.keys(verifyObj.extractor.filters).length) {
                                Object.keys(verifyObj.extractor.filters).forEach(function (filterKey) {
                                    var filterValue = verifyObj.extractor.filters[filterKey];
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForVerify, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForVerify[isShowArguments].isShow = false;
                                    }

                                    var tempObj = {
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForVerify[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    };

                                    if (splitArr[0] === 'switch') {
                                        tempObj.value = '';
                                        var switchValuesArr = splitArr[1].split('\n');
                                        if (switchValuesArr && switchValuesArr.length) {
                                            tempObj.switchValuesArr = [];
                                            _.forEach(switchValuesArr, function (val) {
                                                if (val && val.length) {
                                                    tempObj.switchValuesArr.push({
                                                        value: val
                                                    })
                                                }
                                            });
                                            tempObj.switchValuesArr.push({
                                                value: ''
                                            })
                                        } else {
                                            tempObj.switchValuesArr = [{
                                                value: ''
                                            }]
                                        }
                                    }
                                    tempArr.push(tempObj);
                                });
                                tempArr.push({
                                    key: '',
                                    value: ''
                                });
                                verifyObj.extractFiltersArrForVerify = tempArr;
                            } else {
                                verifyObj.extractFiltersArrForVerify = _.cloneDeepWith($scope.resetExtractFiltersArrForVerify);
                            }
                        }
                    } else {
                        if (verifyObj.extractor.filters) {
                            verifyObj.extractor.filters = {};
                        } else {
                            verifyObj.extractor = {
                                filters: {}
                            };
                        }
                        verifyObj.extractFiltersArrForVerify = _.cloneDeepWith($scope.resetExtractFiltersArrForVerify);
                    }
                };

                $scope.fnSelectRootType = function (rootTypeObj) {
                    $scope.iot3TopologyObj.rootType = rootTypeObj.name;
                };

                $scope.fnAddWrapperToList = function () {
                    var isFindIndex = _.findIndex($scope.rootTypesArr, function (rootTypeObj) {
                        return rootTypeObj.isFromWrapper;
                    });

                    if (isFindIndex !== -1) {
                        if ($scope.iot3TopologyObj.rootType === $scope.rootTypesArr[isFindIndex].name) {
                            $scope.iot3TopologyObj.rootType = $scope.iot3TopologyObj.wrapperType;
                        }
                        $scope.rootTypesArr[isFindIndex].name = $scope.iot3TopologyObj.wrapperType;
                    } else {
                        $scope.rootTypesArr.push({
                            name: $scope.iot3TopologyObj.wrapperType,
                            isFromWrapper: true
                        })
                    }
                };

                $scope.fnInitTopologyTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.typesObj && Object.keys($scope.typesObj).length) {
                        Object.keys($scope.typesObj).forEach(function (typeKey) {
                            $scope.rootTypesArr.push({
                                name: typeKey
                            })
                        })
                    } else {
                        $scope.rootTypesArr = [];
                    }

                    if ($scope.iot3TopologyObj) {

                        if ($scope.iot3TopologyObj.wrapperType && $scope.iot3TopologyObj.wrapperType.length) {
                            $scope.rootTypesArr.push({
                                name: $scope.iot3TopologyObj.wrapperType,
                                isFromWrapper: true
                            })
                        } else {
                            $scope.iot3TopologyObj.wrapperType = '';
                        }

                        if (!$scope.iot3TopologyObj.discovery ||
                            ($scope.iot3TopologyObj.discovery && !Object.keys($scope.iot3TopologyObj.discovery).length)) {
                            $scope.iot3TopologyObj.discovery = _.cloneDeepWith($scope.resetDiscoveryObj);
                        }

                        if ($scope.iot3TopologyObj.discovery &&
                            $scope.iot3TopologyObj.discovery.type &&
                            !$scope.iot3TopologyObj.discovery.type.length) {
                            $scope.iot3TopologyObj.discovery.type = $scope.discoveryTypeOptions[0];
                        }

                        if (!$scope.iot3TopologyObj.rootType) {
                            $scope.iot3TopologyObj.rootType = '';
                        }

                        if (!$scope.iot3TopologyObj.nodes) {
                            $scope.iot3TopologyObj.nodes = false;
                        }

                        if ($scope.iot3TopologyObj.discovery &&
                            $scope.iot3TopologyObj.discovery.expression &&
                            Object.keys($scope.iot3TopologyObj.discovery.expression).length) {
                            var tempArr = [];
                            Object.keys($scope.iot3TopologyObj.discovery.expression).forEach(function (expressionKey) {
                                tempArr.push({
                                    key: expressionKey,
                                    value: $scope.iot3TopologyObj.discovery.expression[expressionKey]
                                })
                            });
                            tempArr.push({
                                key: '',
                                value: ''
                            });
                            $scope.expressionsArr = tempArr;
                        } else {
                            $scope.expressionsArr = [{
                                key: '',
                                value: ''
                            }]
                        }

                        if ($scope.iot3TopologyObj.discovery &&
                            $scope.iot3TopologyObj.discovery.selectors &&
                            Object.keys($scope.iot3TopologyObj.discovery.selectors).length) {
                            var tempArrForSelectors = [];
                            Object.keys($scope.iot3TopologyObj.discovery.selectors).forEach(function (selectorKey) {
                                tempArrForSelectors.push({
                                    key: selectorKey,
                                    value: {
                                        selectorObj: $scope.iot3TopologyObj.discovery.selectors[selectorKey].selector ?
                                            $scope.iot3TopologyObj.discovery.selectors[selectorKey].selector :
                                            $scope.iot3TopologyObj.discovery.selectors[selectorKey]
                                    }
                                })
                            });
                            $scope.selectorsArrForDiscovery = tempArrForSelectors;
                            $scope.fnGetTypeSampleData('discovery');
                        }

                        if ($scope.iot3TopologyObj.discovery &&
                            $scope.iot3TopologyObj.discovery.flatten &&
                            Object.keys($scope.iot3TopologyObj.discovery.flatten).length) {
                            var tempArrForExtractors = [];
                            Object.keys($scope.iot3TopologyObj.discovery.flatten).forEach(function (extractorKey) {

                                var extObj = {
                                    key: extractorKey,
                                    value: {
                                        extractFiltersArrForDiscovery: [],
                                        extractorObj: $scope.iot3TopologyObj.discovery.flatten[extractorKey]
                                    }
                                };

                                if ($scope.iot3TopologyObj.discovery.flatten[extractorKey] &&
                                    $scope.iot3TopologyObj.discovery.flatten[extractorKey].filters) {
                                    var tempArr = [];
                                    if (angular.isArray($scope.iot3TopologyObj.discovery.flatten[extractorKey].filters)) {
                                        if ($scope.iot3TopologyObj.discovery.flatten[extractorKey].filters.length) {
                                            _.forEach($scope.iot3TopologyObj.discovery.flatten[extractorKey].filters, function (filterValue) {
                                                var splitArr = [];
                                                if (filterValue.includes(":")) {
                                                    splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                                    splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                                } else {
                                                    splitArr[0] = filterValue.substr(0,filterValue.indexOf(' '));
                                                    splitArr[1] = filterValue.substr(filterValue.indexOf(' ')+1);
                                                }
                                                var isShowArguments = _.findIndex($scope.attrFilterOptionsForVerify, {'filterValue': splitArr[0]});
                                                if (isShowArguments !== -1) {
                                                    $scope.attrFilterOptionsForVerify[isShowArguments].isShow = false;
                                                }
                                                var tempObj = {
                                                    key: splitArr[0],
                                                    isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForVerify[isShowArguments].isArguments,
                                                    value: splitArr[1]
                                                };
                                                if (splitArr[0] === 'switch') {
                                                    tempObj.value = '';
                                                    var switchValuesArr = splitArr[1].split('\n');
                                                    if (switchValuesArr && switchValuesArr.length) {
                                                        tempObj.switchValuesArr = [];
                                                        _.forEach(switchValuesArr, function (val) {
                                                            if (val && val.length) {
                                                                tempObj.switchValuesArr.push({
                                                                    value: val
                                                                })
                                                            }
                                                        });
                                                        tempObj.switchValuesArr.push({
                                                            value: ''
                                                        })
                                                    } else {
                                                        tempObj.switchValuesArr = [{
                                                            value: ''
                                                        }]
                                                    }
                                                }
                                                tempArr.push(tempObj)
                                            });
                                            tempArr.push({
                                                key: '',
                                                value: ''
                                            });
                                            extObj.value.extractFiltersArrForDiscovery = _.cloneDeepWith(tempArr);
                                        } else {
                                            extObj.value.extractFiltersArrForDiscovery = [{
                                                key: '',
                                                value: ''
                                            }]
                                        }
                                    } else {
                                        if (Object.keys($scope.iot3TopologyObj.discovery.flatten[extractorKey].filters).length) {
                                            Object.keys($scope.iot3TopologyObj.discovery.flatten[extractorKey].filters).forEach(function (filterKey) {
                                                var filterValue = $scope.iot3TopologyObj.discovery.flatten[extractorKey].filters[filterKey];
                                                var splitArr = [];
                                                if (filterValue.includes(":")) {
                                                    splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                                    splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                                } else {
                                                    splitArr[0] = filterValue.substr(0,filterValue.indexOf(' '));
                                                    splitArr[1] = filterValue.substr(filterValue.indexOf(' ')+1);
                                                }
                                                var isShowArguments = _.findIndex($scope.attrFilterOptionsForVerify, {'filterValue': splitArr[0]});
                                                if (isShowArguments !== -1) {
                                                    $scope.attrFilterOptionsForVerify[isShowArguments].isShow = false;
                                                }
                                                var tempObj = {
                                                    key: splitArr[0],
                                                    isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForVerify[isShowArguments].isArguments,
                                                    value: splitArr[1]
                                                };
                                                if (splitArr[0] === 'switch') {
                                                    tempObj.value = '';
                                                    var switchValuesArr = splitArr[1].split('\n');
                                                    if (switchValuesArr && switchValuesArr.length) {
                                                        tempObj.switchValuesArr = [];
                                                        _.forEach(switchValuesArr, function (val) {
                                                            if (val && val.length) {
                                                                tempObj.switchValuesArr.push({
                                                                    value: val
                                                                })
                                                            }
                                                        });
                                                        tempObj.switchValuesArr.push({
                                                            value: ''
                                                        })
                                                    } else {
                                                        tempObj.switchValuesArr = [{
                                                            value: ''
                                                        }]
                                                    }
                                                }
                                                tempArr.push(tempObj)
                                            });
                                            tempArr.push({
                                                key: '',
                                                value: ''
                                            });
                                            extObj.value.extractFiltersArrForDiscovery = _.cloneDeepWith(tempArr);
                                        } else {
                                            extObj.value.extractFiltersArrForDiscovery = [{
                                                key: '',
                                                value: ''
                                            }]
                                        }
                                    }
                                } else {
                                    extObj.value.extractFiltersArrForDiscovery = [{
                                        key: '',
                                        value: ''
                                    }]
                                }

                                tempArrForExtractors.push(extObj)
                            });
                            $scope.extractorsArrForDiscovery = tempArrForExtractors;
                        }


                        if ($scope.iot3TopologyObj &&
                            $scope.iot3TopologyObj.verify &&
                            $scope.iot3TopologyObj.verify.length) {
                            if (angular.isArray($scope.iot3TopologyObj.verify)) {
                                var tempVerifyArr = [];
                                _.forEach($scope.iot3TopologyObj.verify, function (verifyObj) {
                                    if (!verifyObj.match) {
                                        verifyObj.match = '';
                                    }
                                    tempVerifyArr.push(verifyObj);
                                });
                                $scope.verifyArr = _.cloneDeepWith(tempVerifyArr);
                                _.forEach($scope.verifyArr, function (verifyObj) {
                                    $scope.fnGetExtractorFiltersForVerify(verifyObj);
                                    $scope.fnGetTypeSampleData('verify', verifyObj);
                                })
                            } else {
                                $scope.verifyArr = [];
                                if (!$scope.iot3TopologyObj.verify.match) {
                                    $scope.iot3TopologyObj.verify.match = '';
                                }
                                $scope.verifyArr.push($scope.iot3TopologyObj.verify);
                                $scope.fnGetExtractorFiltersForVerify($scope.verifyArr[0]);
                                $scope.fnGetTypeSampleData('verify', $scope.verifyArr[0]);
                            }
                        } else {
                            $scope.verifyArr = [];
                            /*$scope.verifyArr.push(_.cloneDeepWith($scope.resetVerifyObj));
                            $scope.fnGetExtractorFiltersForVerify($scope.verifyArr[0]);
                            $scope.fnGetTypeSampleData('verify', $scope.verifyArr[0]);*/
                        }
                    } else {
                        $scope.iot3TopologyObj = {
                            rootType: '',
                            wrapperType: '',
                            verify: [],
                            nodes: false,
                            discovery: _.cloneDeepWith($scope.resetDiscoveryObj)
                        };
                        $scope.verifyArr = [];
                        /*$scope.verifyArr.push(_.cloneDeepWith($scope.resetVerifyObj));
                        $scope.fnGetExtractorFiltersForVerify($scope.verifyArr[0]);
                        $scope.fnGetTypeSampleData('verify', $scope.verifyArr[0]);*/
                    }

                    if ($scope.mappingsObj && Object.keys($scope.mappingsObj).length) {
                        Object.keys($scope.mappingsObj).forEach(function (key) {
                            var tempObj = $scope.mappingsObj[key];
                            tempObj.id = key;
                            $scope.mappingsArr.push(tempObj);
                        })
                    } else {
                        $scope.mappingsArr = [];
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitTopologyTab();

                $scope.fnUpdateTopologyDetails = function () {

                    var tempVerifyArr = [];

                    _.forEach($scope.verifyArr, function (verifyObj) {
                        var tempExtractorObjForVerify = {};
                        _.forEach(verifyObj.extractFiltersArrForVerify, function (extractorObj, index) {
                            if (extractorObj.key && extractorObj.key.length) {
                                if (extractorObj.key === 'switch') {
                                    if (extractorObj.switchValuesArr && extractorObj.switchValuesArr.length) {
                                        var tempString = '';
                                        _.forEach(extractorObj.switchValuesArr, function (switchVal) {
                                            if (switchVal.value && switchVal.value.length) {
                                                tempString += switchVal.value + "\n";
                                            }
                                        });
                                        tempExtractorObjForVerify[index] = extractorObj.key + " " + tempString;
                                    } else {
                                        tempExtractorObjForVerify[index] = extractorObj.key + " " + "";
                                    }
                                } else {
                                    tempExtractorObjForVerify[index] = extractorObj.key + " " + extractorObj.value;
                                }
                            }
                        });

                        verifyObj.extractor.filters = tempExtractorObjForVerify;

                        delete verifyObj.extractFiltersArrForVerify;
                        delete verifyObj.sampleDataForVerify;
                        delete verifyObj.selectedSampleDataForVerify;
                        delete verifyObj.manipulatedSampleDataForVerify;
                        delete verifyObj.isShowSampleDataForVerify;
                        delete verifyObj.valueFocusForMapper;
                        delete verifyObj.globalKeyOptionsForDataSource;
                        delete verifyObj.oldValueKeyForDataSource;
                        delete verifyObj.isMapperSelectedForVerify;

                        tempVerifyArr.push(verifyObj);
                    });

                    $scope.iot3TopologyObj.verify = _.cloneDeepWith(tempVerifyArr);

                    if ($scope.iot3TopologyObj.nodes) {
                        var tempObj = {};
                        _.forEach($scope.expressionsArr, function (expressionObj) {
                            if (!expressionObj.isKeyDuplicated) {
                                tempObj[expressionObj.key] = expressionObj.value;
                            }
                        });
                        $scope.iot3TopologyObj.discovery.expression = tempObj;

                        var tempSelectorObj = {};
                        _.forEach($scope.selectorsArrForDiscovery, function (selectorObj) {
                            tempSelectorObj[selectorObj.key] = {
                                selector: selectorObj.value.selectorObj
                            };
                        });
                        $scope.iot3TopologyObj.discovery.selectors = tempSelectorObj;

                        var tempExtractorObj = {};
                        _.forEach($scope.extractorsArrForDiscovery, function (extractorObj) {

                            var tempExtractorObjForDiscovery = [];
                            _.forEach(extractorObj.value.extractFiltersArrForDiscovery, function (extractorObj, index) {
                                if (extractorObj.key && extractorObj.key.length) {
                                    if (extractorObj.key === 'switch') {
                                        if (extractorObj.switchValuesArr && extractorObj.switchValuesArr.length) {
                                            var tempString = '';
                                            _.forEach(extractorObj.switchValuesArr, function (switchVal) {
                                                if (switchVal.value && switchVal.value.length) {
                                                    tempString += switchVal.value + "\n";
                                                }
                                            });
                                            tempExtractorObjForDiscovery[index] = extractorObj.key + " " + tempString;
                                        } else {
                                            tempExtractorObjForDiscovery[index] = extractorObj.key + " " + "";
                                        }
                                    } else {
                                        tempExtractorObjForDiscovery[index] = extractorObj.key + " " + extractorObj.value;
                                    }
                                }
                            });

                            extractorObj.value.extractorObj.filters = tempExtractorObjForDiscovery;

                            tempExtractorObj[extractorObj.key] = extractorObj.value.extractorObj;
                        });
                        $scope.iot3TopologyObj.discovery.flatten = tempExtractorObj;
                    } else {
                        $scope.iot3TopologyObj.discovery = _.cloneDeepWith($scope.resetDiscoveryObj);
                    }

                    $scope.fnUpdateWorkbench({updateType: 'topology', updateValue: $scope.iot3TopologyObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnUpdateTopologyDetails();
                });

                $scope.$on('topologyResizeCall', function () {
                    $scope.fnSetTableHeight();
                });

                $window.onbeforeunload = function() {
                    $scope.fnUpdateTopologyDetails();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Registration', fnIot3Registration)

    /** @ngInject */
    function fnIot3Registration($rootScope, $timeout, $window, $uibModal, amaran, swal, TypeFormService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/registration/registration.html',
            scope: {
                currentWorkspace: "=",
                iot3RegistrationObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.registrationTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.registrationTabs[0];

                $scope.fingerPrintArr = [{
                    value: ''
                }];
                $scope.vaultId = {
                    name: ''
                };
                $scope.vaultOptionsArr = [];
                $scope.isShowVaultId = true;

                /*START: Form Tab Variables*/
                $scope.fieldArrForForm = [
                    {
                        name: 'Text Field',
                        icon: 'fa-terminal'
                    }, {
                        name: 'Text Area',
                        icon: 'fa-font'
                    }, {
                        name: 'Checkbox',
                        icon: 'fa-check-square'
                    }, {
                        name: 'Select',
                        icon: 'fa-th-list'
                    }, {
                        name: 'Number',
                        icon: 'fa-hashtag'
                    }, {
                        name: 'Password',
                        icon: 'fa-asterisk'
                    }, {
                        name: 'Panel',
                        icon: 'fa-list-alt'
                    }, {
                        name: 'Label',
                        icon: 'fa-tag'
                    }
                ];
                $scope.formModel = {};
                $scope.formArrForForm = [];
                $scope.formBuilderInput = [];
                $scope.formSchema = {
                    $schema: "http://json-schema.org/draft-07/schema#",
                    type: "object",
                    properties: {}
                };
                /*END: Form Tab Variables*/

                /*START: Vault Tab Variables*/
                $scope.fieldArrForVault = [
                    {
                        name: 'Text Field',
                        icon: 'fa-terminal'
                    }, {
                        name: 'Text Area',
                        icon: 'fa-font'
                    }, {
                        name: 'Checkbox',
                        icon: 'fa-check-square'
                    }, {
                        name: 'Select',
                        icon: 'fa-th-list'
                    }, {
                        name: 'Number',
                        icon: 'fa-hashtag'
                    }, {
                        name: 'Password',
                        icon: 'fa-asterisk'
                    }, {
                        name: 'Panel',
                        icon: 'fa-list-alt'
                    }, {
                        name: 'Label',
                        icon: 'fa-tag'
                    }
                ];
                $scope.vaultModel = {};
                $scope.formArrForVault = [];
                $scope.vaultBuilderInput = [];
                $scope.vaultSchema = {
                    $schema: "http://json-schema.org/draft-07/schema#",
                    type: "object",
                    properties: {}
                };
                /*END: Vault Tab Variables*/

                $scope.formOptionsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#registrationMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 20);
                        angular.element("#registrationMainContainer").css('height', finalHeight + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnRemoveFormOption = function (index) {
                    $scope.fingerPrintArr.splice(index, 1);
                    $scope.formOptionsArr = Object.keys($scope.formSchema.properties).filter(function(obj) {
                        var isFind = _.find($scope.fingerPrintArr, {value: obj});
                        if (!isFind) {
                            return obj;
                        }
                    });
                    if ($scope.fingerPrintArr[$scope.fingerPrintArr.length - 1].value !== '' &&
                        $scope.formOptionsArr.length) {
                        $scope.fingerPrintArr.push({
                            value: ''
                        });
                    }
                };

                $scope.fnSelectFormOption = function (formOption, selectedFingerPrint) {
                    selectedFingerPrint.value = formOption;

                    $scope.formOptionsArr = Object.keys($scope.formSchema.properties).filter(function(obj) {
                        var isFind = _.find($scope.fingerPrintArr, {value: obj});
                        if (!isFind) {
                            return obj;
                        }
                    });
                    if ($scope.fingerPrintArr[$scope.fingerPrintArr.length - 1].value !== '' &&
                        $scope.formOptionsArr.length) {
                        $scope.fingerPrintArr.push({
                            value: ''
                        });
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnOnActionDrop = function (srcList, srcIndex, schemaType) {
                    if (srcIndex !== 'main' && srcList.name === 'Panel') {
                        amaran.error('Multi-level Panels not allowed.');
                    } else {
                        $scope.fnOpenInputConfigModal(srcList, srcIndex, schemaType);
                    }
                    return true;
                };

                $scope.fnOpenInputConfigModal = function (srcList, srcIndex, schemaType) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return schemaType === 'form' ? $scope.formArrForForm : $scope.formArrForVault;
                            },
                            inputObj: function () {
                                return {};
                            },
                            isWorkbenchMode: function () {
                                return true;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema;
                        if (schemaType === 'form') {
                            schema = _.cloneDeepWith($scope.formSchema);
                            /*form = _.cloneDeepWith($scope.formArrForForm);
                            $scope.formSchema = {};
                            $scope.formArrForForm = [];*/
                        } else {
                            schema = _.cloneDeepWith($scope.vaultSchema);
                            /*form = _.cloneDeepWith($scope.formArrForVault);
                            $scope.vaultSchema = {};
                            $scope.formArrForVault = [];*/
                        }
                        $timeout(function () {
                            var subKey = '';
                            if (srcIndex === 'main') {
                                schema.properties[obj.key] = obj.value;
                            } else {
                                subKey = srcIndex + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                schema.properties[srcIndex].properties[obj.key] = tempObj.value;
                            }
                            if (schemaType === 'form') {
                                $scope.formSchema = schema;
                            } else {
                                $scope.vaultSchema = schema;
                            }
                            if (obj.value.type === 'object' && obj.value.inputType === 'panel') {
                                if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                    var schemaObj = schema.properties[obj.key];
                                    schemaObj.multiformConfig = obj.multiformConfig;
                                    if (schemaType === 'form') {
                                        $scope.formSchema = schema;
                                    } else {
                                        $scope.vaultSchema = schema;
                                    }
                                }
                            }
                            if (schemaType === 'form') {
                                var tempDataForm = TypeFormService.fnGenerateFormData($scope.formSchema);
                                $scope.formSchema = tempDataForm.schema;
                                $scope.formArrForForm = tempDataForm.form;
                                $scope.formBuilderInput = tempDataForm.formBuilderInput;
                            } else {
                                var tempData = TypeFormService.fnGenerateFormData($scope.vaultSchema);
                                $scope.vaultSchema = tempData.schema;
                                $scope.formArrForVault = tempData.form;
                                $scope.vaultBuilderInput = tempData.formBuilderInput;
                            }
                        });
                    }, function () {
                    });
                };

                $scope.fnGetType = function (type, schemaType) {
                    var newType = '';
                    switch (type) {
                        case 'inputText':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Text Field'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Text Field'});
                            }
                            break;
                        case 'inputTextarea':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Text Area'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Text Area'});
                            }
                            break;
                        case 'inputButton':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Button'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Button'});
                            }
                            break;
                        case 'dropdown':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Select'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Select'});
                            }
                            break;
                        case 'inputCheckbox':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Checkbox'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Checkbox'});
                            }
                            break;
                        case 'inputNumber':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Number'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Number'});
                            }
                            break;
                        case 'inputLabel':
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Label'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Label'});
                            }
                            break;
                        default:
                            if (schemaType === 'form') {
                                newType = _.find($scope.fieldArrForForm, {name: 'Panel'});
                            } else {
                                newType = _.find($scope.fieldArrForVault, {name: 'Panel'});
                            }
                            break;
                    }
                    return newType;
                };

                $scope.fnEditInput = function (inputObj, multiForm, parentObj, schemaType) {
                    var resetInputObj = _.cloneDeepWith(inputObj);
                    if (multiForm === true) {
                        resetInputObj.key = resetInputObj.key.split('.')[1];
                        if (schemaType === 'form') {
                            resetInputObj.schema = _.cloneDeepWith($scope.formSchema.properties[parentObj.key].properties[resetInputObj.key]);
                        } else {
                            resetInputObj.schema = _.cloneDeepWith($scope.vaultSchema.properties[parentObj.key].properties[resetInputObj.key]);
                        }
                    } else {
                        if (schemaType === 'form') {
                            resetInputObj.schema = _.cloneDeepWith($scope.formSchema.properties[inputObj.key]);
                        } else {
                            resetInputObj.schema = _.cloneDeepWith($scope.vaultSchema.properties[inputObj.key]);
                        }
                    }
                    var srcList = $scope.fnGetType(inputObj.type, schemaType);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return schemaType === 'form' ? $scope.formArrForForm : $scope.formArrForVault;
                            },
                            inputObj: function () {
                                return resetInputObj;
                            },
                            isWorkbenchMode: function () {
                                return true;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema;
                        if (schemaType === 'form') {
                            schema = _.cloneDeepWith($scope.formSchema);
                            /*form = _.cloneDeepWith($scope.formArrForForm);
                            $scope.formSchema = {};
                            $scope.formArrForForm = [];*/
                        } else {
                            schema = _.cloneDeepWith($scope.vaultSchema);
                            /*form = _.cloneDeepWith($scope.formArrForVault);
                            $scope.vaultSchema = {};
                            $scope.formArrForVault = [];*/
                        }
                        $timeout(function () {
                            var subKey = '';
                            if (multiForm === true) {
                                subKey = parentObj.key + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                if (resetInputObj.key !== obj.key) {
                                    delete schema.properties[parentObj.key].properties[resetInputObj.key];
                                }
                                schema.properties[parentObj.key].properties[obj.key] = tempObj.value;
                            } else {
                                if (inputObj.type !== "panel-conditional") {
                                    if (resetInputObj.key !== obj.key) {
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    schema.properties[obj.key] = obj.value;
                                }
                                if (inputObj.type === "panel-conditional") {
                                    var schemaObj = {};
                                    if (resetInputObj.key !== obj.key) {
                                        schema.properties[obj.key] = schema.properties[resetInputObj.key];
                                        schema.properties[obj.key].key = obj.key;
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.value.title;
                                    } else {
                                        obj.multiformConfig = {};
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.title;
                                    }
                                }
                            }
                            if (schemaType === 'form') {
                                $scope.formSchema = schema;
                                var tempDataForm = TypeFormService.fnGenerateFormData($scope.formSchema);
                                $scope.formSchema = tempDataForm.schema;
                                $scope.formArrForForm = tempDataForm.form;
                                $scope.formBuilderInput = tempDataForm.formBuilderInput;
                            } else {
                                $scope.vaultSchema = schema;
                                var tempData = TypeFormService.fnGenerateFormData($scope.vaultSchema);
                                $scope.vaultSchema = tempData.schema;
                                $scope.formArrForVault = tempData.form;
                                $scope.vaultBuilderInput = tempData.formBuilderInput;
                            }
                        });
                    }, function () {
                    });
                };

                $scope.fnRemove = function (inputObj, multiForm, parentObj, schemaType) {
                    var text = "";
                    if (inputObj.type === 'panel-conditional') {
                        text = 'Removing this component will also remove all of its children!'
                    }
                    swal({
                            title: "Delete the selected Component?",
                            text: text,
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                if (multiForm && multiForm === true) {
                                    var tempInputKey = inputObj.key.split('.')[1];
                                    var isFind;
                                    if (schemaType === 'form') {
                                        delete $scope.formSchema.properties[parentObj.key].properties[tempInputKey];
                                        delete $scope.formModel[parentObj.key][tempInputKey];
                                        isFind = _.find($scope.formArrForForm, function (formObj) {
                                            return formObj.key[0] === parentObj.key;
                                        });
                                    } else {
                                        delete $scope.vaultSchema.properties[parentObj.key].properties[tempInputKey];
                                        delete $scope.vaultModel[parentObj.key][tempInputKey];
                                        isFind = _.find($scope.formArrForVault, function (formObj) {
                                            return formObj.key[0] === parentObj.key;
                                        });
                                    }

                                    if (isFind) {
                                        var tempArr = _.cloneDeepWith(isFind.items);
                                        isFind.items = _.remove(isFind.items, function (itemObj) {
                                            return itemObj.key && itemObj.key[1] !== tempInputKey;
                                        });
                                        isFind.items.unshift(tempArr[0]);
                                    }

                                    var isFindFormBuilder;
                                    if (schemaType === 'form') {
                                        isFindFormBuilder = _.find($scope.formBuilderInput, function (formBuilderObj) {
                                            return formBuilderObj.key && formBuilderObj.key === parentObj.key;
                                        });
                                    } else {
                                        isFindFormBuilder = _.find($scope.vaultBuilderInput, function (formBuilderObj) {
                                            return formBuilderObj.key && formBuilderObj.key === parentObj.key;
                                        });
                                    }

                                    if (isFindFormBuilder) {
                                        isFindFormBuilder.items = _.remove(isFindFormBuilder.items, function (itemObj) {
                                            return itemObj.key !== inputObj.key;
                                        });
                                    }
                                } else {
                                    var isFindReference;
                                    if (schemaType === 'form') {
                                        isFindReference = _.filter($scope.formArrForForm, function (formObj) {
                                            if (formObj && formObj.multiformConfig && formObj.multiformConfig.referenceKey === inputObj.key) {
                                                return formObj;
                                            }
                                        });
                                    } else {
                                        isFindReference = _.filter($scope.formArrForVault, function (formObj) {
                                            if (formObj && formObj.multiformConfig && formObj.multiformConfig.referenceKey === inputObj.key) {
                                                return formObj;
                                            }
                                        });
                                    }

                                    if (isFindReference.length) {
                                        _.forEach(isFindReference, function (referenceObj) {
                                            delete referenceObj.multiformConfig;
                                            delete referenceObj.condition;
                                            var isFind;
                                            if (schemaType === 'form') {
                                                delete $scope.formSchema.properties[referenceObj.key].multiformConfig;
                                                isFind = _.find($scope.formBuilderInput, {key: inputObj.key});
                                            } else {
                                                delete $scope.vaultSchema.properties[referenceObj.key].multiformConfig;
                                                isFind = _.find($scope.vaultBuilderInput, {key: inputObj.key});
                                            }

                                            if (isFind) {
                                                delete isFind.multiformConfig;
                                            }
                                        });
                                        if (schemaType === 'form') {
                                            delete $scope.formSchema.properties[inputObj.key];
                                            delete $scope.formModel[inputObj.key];
                                            $scope.formArrForForm = _.remove($scope.formArrForForm, function (formObj) {
                                                return formObj.key[0] !== inputObj.key;
                                            });
                                            _.remove($scope.formBuilderInput, {key: inputObj.key});
                                        } else {
                                            delete $scope.vaultSchema.properties[inputObj.key];
                                            delete $scope.vaultModel[inputObj.key];
                                            $scope.formArrForVault = _.remove($scope.formArrForVault, function (formObj) {
                                                return formObj.key[0] !== inputObj.key;
                                            });
                                            _.remove($scope.vaultBuilderInput, {key: inputObj.key});
                                        }
                                    } else {
                                        if (schemaType === 'form') {
                                            delete $scope.formSchema.properties[inputObj.key];
                                            delete $scope.formModel[inputObj.key];
                                            $scope.formArrForForm = _.remove($scope.formArrForForm, function (formObj) {
                                                return formObj.key[0] !== inputObj.key;
                                            });
                                            _.remove($scope.formBuilderInput, {key: inputObj.key});
                                        } else {
                                            delete $scope.vaultSchema.properties[inputObj.key];
                                            delete $scope.vaultModel[inputObj.key];
                                            $scope.formArrForVault = _.remove($scope.formArrForVault, function (formObj) {
                                                return formObj.key[0] !== inputObj.key;
                                            });
                                            _.remove($scope.vaultBuilderInput, {key: inputObj.key});
                                        }
                                    }
                                }
                                if (schemaType === 'form') {
                                    $scope.formOptionsArr = Object.keys($scope.formSchema.properties).filter(function(obj) {
                                        var isFind = _.find($scope.fingerPrintArr, {value: obj});
                                        if (!isFind) {
                                            return obj;
                                        }
                                    });
                                    if ($scope.formOptionsArr.length && $scope.fingerPrintArr[$scope.fingerPrintArr.length - 1].value !== '') {
                                        $scope.fingerPrintArr.push({
                                            value: ''
                                        })
                                    }
                                    if (Object.keys($scope.formSchema.properties).length) {
                                        $scope.vaultOptionsArr = Object.keys($scope.formSchema.properties);
                                    } else {
                                        $scope.vaultOptionsArr = [];
                                    }
                                } else {
                                    $scope.isShowVaultId = !!Object.keys($scope.vaultSchema.properties).length;
                                }
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                $timeout(function () {
                                    $scope.$apply();
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnSelectVaultId = function (item) {
                    $scope.vaultId = {
                        name: item
                    };
                };

                $scope.fnInitRegistrationTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.iot3RegistrationObj.vaultId && $scope.iot3RegistrationObj.vaultId.length) {
                        $scope.vaultId = {
                            name: _.cloneDeepWith($scope.iot3RegistrationObj.vaultId)
                        }
                    }
                    if ($scope.iot3RegistrationObj && $scope.iot3RegistrationObj.fingerprint && $scope.iot3RegistrationObj.fingerprint.length) {
                        $scope.fingerPrintArr = [];
                        _.forEach($scope.iot3RegistrationObj.fingerprint, function (val) {
                            $scope.fingerPrintArr.push({
                                value: val
                            });
                        });
                        $scope.fingerPrintArr.push({
                            value: ''
                        })
                    } else {
                        $scope.iot3RegistrationObj.fingerprint = [];
                        $scope.fingerPrintArr = [{
                            value: ''
                        }]
                    }
                    if ($scope.iot3RegistrationObj && $scope.iot3RegistrationObj.form && $scope.iot3RegistrationObj.form.properties &&
                        Object.keys($scope.iot3RegistrationObj.form.properties).length) {

                        $scope.formOptionsArr = Object.keys($scope.iot3RegistrationObj.form.properties).filter(function(obj) {
                            return $scope.iot3RegistrationObj.fingerprint.indexOf(obj) === -1;
                        });
                        $scope.vaultOptionsArr = Object.keys($scope.iot3RegistrationObj.form.properties);
                        // $scope.fnCreateForm($scope.iot3RegistrationObj.form, 'form');
                        var tempData = TypeFormService.fnGenerateFormData($scope.iot3RegistrationObj.form);
                        $scope.formSchema = tempData.schema;
                        $scope.formArrForForm = tempData.form;
                        $scope.formBuilderInput = tempData.formBuilderInput;
                    } else {
                        if (angular.isUndefined($scope.iot3RegistrationObj.form)) {
                            $scope.iot3RegistrationObj.form = {
                                properties: {},
                                required: []
                            };
                        }
                        $scope.formSchema = {
                            $schema: "http://json-schema.org/draft-07/schema#",
                            type: "object",
                            properties: {}
                        };
                        $scope.vaultOptionsArr = [];
                        $scope.formArrForForm = [];
                    }
                    if ($scope.iot3RegistrationObj && $scope.iot3RegistrationObj.vault && $scope.iot3RegistrationObj.vault.properties &&
                        Object.keys($scope.iot3RegistrationObj.vault.properties).length) {
                        $scope.isShowVaultId = true;
                        // $scope.fnCreateForm($scope.iot3RegistrationObj.vault, 'vault');
                        var tempDataVault = TypeFormService.fnGenerateFormData($scope.iot3RegistrationObj.vault);
                        $scope.vaultSchema = tempDataVault.schema;
                        $scope.formArrForVault = tempDataVault.form;
                        $scope.vaultBuilderInput = tempDataVault.formBuilderInput;
                    } else {
                        if (angular.isUndefined($scope.iot3RegistrationObj.vault)) {
                            $scope.iot3RegistrationObj.vault = {
                                properties: {},
                                required: []
                            };
                        }
                        $scope.isShowVaultId = false;
                        $scope.vaultSchema = {
                            $schema: "http://json-schema.org/draft-07/schema#",
                            type: "object",
                            properties: {}
                        };
                        $scope.formArrForVault = [];
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitRegistrationTab();

                $scope.fnCallOnDestroyForRegistration = function () {
                    var tempObj = {};
                    if ($scope.isShowVaultId) {
                        tempObj.vaultId = $scope.vaultId.name
                    }
                    if ($scope.fingerPrintArr.length) {
                        var tempArr = [];
                        _.forEach($scope.fingerPrintArr, function (fingerPrintObj) {
                            if (fingerPrintObj.value && fingerPrintObj.value.length) {
                                tempArr.push(fingerPrintObj.value);
                            }
                        });
                        if (tempArr.length) {
                            tempObj.fingerprint = tempArr;
                        }
                    } else {
                        tempObj.fingerprint = [];
                    }
                    if ($scope.formSchema.properties && Object.keys($scope.formSchema.properties).length) {
                        tempObj.form = {};
                        tempObj.form.properties = $scope.formSchema.properties;
                        tempObj.form.required = [];
                        Object.keys($scope.formSchema.properties).forEach(function (keyName) {
                            if ($scope.formSchema.properties[keyName] && $scope.formSchema.properties[keyName].required) {
                                tempObj.form.required.push(keyName);
                            }
                        })
                    }
                    if ($scope.vaultSchema.properties && Object.keys($scope.vaultSchema.properties).length) {
                        tempObj.vault = {};
                        tempObj.vault.properties = $scope.vaultSchema.properties;
                        tempObj.vault.required = [];
                        Object.keys($scope.vaultSchema.properties).forEach(function (keyName) {
                            if ($scope.vaultSchema.properties[keyName] && $scope.vaultSchema.properties[keyName].required) {
                                tempObj.vault.required.push(keyName);
                            }
                        })
                    }
                    $scope.fnUpdateWorkbench({updateType: 'registration', updateValue: tempObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnCallOnDestroyForRegistration();
                });

                $window.onbeforeunload = function() {
                    $scope.fnCallOnDestroyForRegistration();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Mappings', fnIot3Mappings)

    /** @ngInject */
    function fnIot3Mappings($rootScope, $timeout, $window) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/mappings/mappings.html',
            scope: {
                currentWorkspace: "=",
                mappingsObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                /*START: Overview Tab*/
                $scope.mappingsTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.mappingsTabs[0].tabIndex;
                $scope.mappingsArr = [];
                $scope.filter = "$";
                $scope.mappingSearch = {$: ''};
                /*END: Overview Tab*/

                $scope.selectedCreateSubTabIndex = 1;
                $scope.selectedDetailSubTabIndex = 1;

                $scope.isReferencePatternMismatched = false;
                $scope.isReferenceDuplicated = false;

                $scope.createMappingObj = {
                    id: '',
                    keyType: 'String',
                    valueType: 'String',
                    isMap: true,
                    map: {},
                    mapArr: [{
                        key: '',
                        value: ''
                    }]
                };
                $scope.resetCreateMappingObj = _.cloneDeepWith($scope.createMappingObj);
                $scope.isCreate = false;

                $scope.isKeyDuplicated = false;
                $scope.duplicatedIndex = null;

                $scope.isKeyDuplicatedForDetail = false;
                $scope.duplicatedIndexForDetail = null;

                $scope.isKeyDuplicatedForArr = false;
                $scope.duplicatedIndexForArr = null;

                $scope.isKeyDuplicatedForArrDetail = false;
                $scope.duplicatedIndexForArrDetail = null;

                $scope.dataTypeOptions = {
                    String: 'text',
                    Int32: 'number',
                    Int64: 'number',
                    Float: 'number',
                    Binary: 'number',
                    Bool: 'text',
                    Date: 'date',
                    Time: 'time',
                    DateTime: 'datetime',
                    Button: 'button'
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 35);
                        angular.element("#mappingsMainContainer").css('height', finalHeight + 'px');

                        var search = angular.isDefined(angular.element(".searchContainer")[0]) ? angular.element(".searchContainer")[0].offsetHeight : 0;
                        var tableHead = angular.isDefined(angular.element(".mappings-table thead")[0]) ? angular.element(".mappings-table thead")[0].offsetHeight : 0;
                        angular.element("#mappingTable").css('height', (finalHeight - search - tableHead) + 'px');

                        angular.element("#mappingsMainContainerDetail").css('height', finalHeight + 30 + 'px');
                        angular.element("#mappingsCreateMainContainer").css('height', finalHeight + 30 + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 36; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                        angular.element("#mappingsMainContainerDetail .tabContent").css('height', (finalHeight + 35) - (tabHeader + 5) + 'px');
                        angular.element("#mappingsCreateMainContainer .tabContent").css('height', (finalHeight + 35) - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnChangeTab($scope.mappingsTabs[0]);
                    $timeout(function () {
                        $scope.fnInitiateResetWorkspace();
                    })
                };

                $scope.fnChangeTab = function (tab) {
                    if ($scope.activeTabIndex !== 1 && $scope.activeTabIndex !== "Create Mapping") {
                        $scope.fnEditMapping();
                    }
                    $scope.activeTabIndex = tab.tabIndex;

                    $scope.isCreate = tab.id === "Create Mapping";

                    if (!$scope.isCreate && $scope.activeTabIndex !== 1) {
                        var isValueFind = _.find($scope.mappingsArr, {'id': tab.id});
                        if (isValueFind) {
                            $scope.fnGetMappingDetails(isValueFind);
                        }
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnRemoveTab = function (id, tabIndex) {
                    if (id !== 1 && id !== "Create Mapping" && $scope.activeTabIndex === tabIndex) {
                        $scope.fnEditMapping();
                    }
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex($scope.mappingsTabs, {id: id});

                    if ($scope.activeTabIndex === tabIndex) {
                        if ($scope.mappingsTabs.length === (index + 1) || id === "Create Mapping") {
                            $scope.activeTabIndex = 1;
                        }
                    }
                    _.forEach($scope.mappingsTabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    $scope.mappingsTabs = _.cloneDeepWith(tabs);

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnTabChanged = function (tab) {
                    $scope.isCreate = tab.id === "Create Mapping";

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnOpenCreateMappingView = function () {
                    $scope.isCreate = true;
                    if ($scope.isCreate) {
                        var isTabExist = _.find($scope.mappingsTabs, {'id': 'Create Mapping'});
                        if (isTabExist) {
                            $timeout(function () {
                                $scope.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = $scope.mappingsTabs.length + 1;
                            $scope.mappingsTabs.push({
                                id: 'Create Mapping',
                                title: 'Create Mapping',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                $scope.activeTabIndex = newTabIndex;
                            });
                        }

                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        }, 100)
                    }
                };

                $scope.fnGetMappingDetails = function (mappingObj) {
                    $scope.selectedMappingObj = null;
                    /* Toggle push in selected mappings array*/
                    var isTabExist = _.find($scope.mappingsTabs, {'id': mappingObj.id});
                    if (isTabExist) {
                        $timeout(function () {
                            $scope.activeTabIndex = isTabExist.tabIndex;
                            $scope.selectedMappingObj = mappingObj;
                            if ($scope.selectedMappingObj.isMap) {
                                if (!$scope.selectedMappingObj.mapArr.length ||
                                    ($scope.selectedMappingObj.mapArr.length &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key !== '')) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            } else {
                                if (!$scope.selectedMappingObj.mapArr.length ||
                                    ($scope.selectedMappingObj.mapArr.length &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key !== '')) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: ''
                                    })
                                }
                            }
                        });
                    } else {
                        var newTabIndex = $scope.mappingsTabs.length + 1;
                        $scope.mappingsTabs.push({
                            id: mappingObj.id,
                            title: mappingObj.id,
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            $scope.activeTabIndex = newTabIndex;
                            $scope.selectedMappingObj = mappingObj;
                            if ($scope.selectedMappingObj.isMap) {
                                if (!$scope.selectedMappingObj.mapArr.length ||
                                    ($scope.selectedMappingObj.mapArr.length &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key !== '')) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            } else {
                                if (!$scope.selectedMappingObj.mapArr.length ||
                                    ($scope.selectedMappingObj.mapArr.length &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key &&
                                        $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key !== '')) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: ''
                                    })
                                }
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnSelectSubTab = function (tabIndex, mappingMode) {
                    if (mappingMode === 'detail') {
                        $scope.selectedDetailSubTabIndex = tabIndex
                    } else {
                        $scope.selectedCreateSubTabIndex = tabIndex
                    }
                };

                $scope.fnCheckCreateMappingReference = function () {
                    $scope.isReferencePatternMismatched = false;
                    $scope.isReferenceDuplicated = false;
                    var regExp = new RegExp("^[a-z0-9_]+$");
                    if (!regExp.test($scope.createMappingObj.id)) {
                        $scope.isReferencePatternMismatched = true;
                    } else {
                        $scope.isReferencePatternMismatched = false;
                        var findIndex = _.findIndex($scope.mappingsArr, function (mappingObj) {
                            return mappingObj.id === $scope.createMappingObj.id;
                        });
                        if (findIndex !== -1) {
                            $scope.isReferenceDuplicated = true;
                        }
                    }
                };

                $scope.fnAddMappingToList = function () {
                    if ($scope.createMappingObj.isMap) {
                        if (!$scope.createMappingObj.map) {
                            $scope.createMappingObj.map = {};
                        }
                        _.forEach($scope.createMappingObj.mapArr, function (mapObj) {
                            if (mapObj.key && mapObj.key.length && mapObj.value && mapObj.value.length) {
                                $scope.createMappingObj.map[mapObj.key] = mapObj.value;
                            }
                        });
                        $scope.createMappingObj.mapArr = _.filter($scope.createMappingObj.mapArr, function (mapObj) {
                            return mapObj.key && mapObj.key.length && mapObj.value && mapObj.value.length;
                        })
                    } else {
                        if (!$scope.createMappingObj.array) {
                            $scope.createMappingObj.array = [];
                        }
                        _.forEach($scope.createMappingObj.mapArr, function (mapObj) {
                            if (mapObj.key && mapObj.key.length) {
                                $scope.createMappingObj.array.push(mapObj.key);
                            }
                        });
                        $scope.createMappingObj.mapArr = _.filter($scope.createMappingObj.mapArr, function (mapObj) {
                            return mapObj.key && mapObj.key.length;
                        })
                    }

                    $scope.mappingsArr.push($scope.createMappingObj);
                    $scope.createMappingObj = _.cloneDeepWith($scope.resetCreateMappingObj);
                    $scope.fnRemoveTab("Create Mapping", $scope.activeTabIndex);
                };

                $scope.fnEditMapping = function () {

                    if ($scope.selectedMappingObj.isMap) {
                        var  tempObj = {};
                        _.forEach($scope.selectedMappingObj.mapArr, function (mapObj, index) {
                            if (mapObj.key && mapObj.key.length && mapObj.value && mapObj.value.length) {
                                if (!($scope.isKeyDuplicatedForDetail && index === $scope.duplicatedIndexForDetail)) {
                                    tempObj[mapObj.key] = mapObj.value
                                }
                            }
                        });
                        $scope.selectedMappingObj.mapArr = _.filter($scope.selectedMappingObj.mapArr, function (mapObj, index) {
                            if (!($scope.isKeyDuplicatedForDetail && index === $scope.duplicatedIndexForDetail)) {
                                return mapObj.key && mapObj.key.length && mapObj.value && mapObj.value.length;
                            }
                        });
                        $scope.selectedMappingObj.map = _.cloneDeepWith(tempObj);
                    } else {
                        var tempArr = [];
                        _.forEach($scope.selectedMappingObj.mapArr, function (mapObj, index) {
                            if (mapObj.key && mapObj.key.length) {
                                if (!($scope.isKeyDuplicatedForArrDetail && index === $scope.duplicatedIndexForArrDetail)) {
                                    tempArr.push(mapObj.key);
                                }
                            }
                        });
                        $scope.selectedMappingObj.mapArr = _.filter($scope.selectedMappingObj.mapArr, function (mapObj, index) {
                            if (!($scope.isKeyDuplicatedForArrDetail && index === $scope.duplicatedIndexForArrDetail)) {
                                return mapObj.key && mapObj.key.length;
                            }
                        });
                        $scope.selectedMappingObj.array = _.cloneDeepWith(tempArr);
                    }

                    var findIndex = _.findIndex($scope.mappingsArr, function (mappingObj) {
                        return mappingObj.id === $scope.selectedMappingObj.id;
                    });

                    if (findIndex !== -1) {
                        $scope.mappingsArr[findIndex] = _.cloneDeepWith($scope.selectedMappingObj);
                    }

                    $scope.isKeyDuplicatedForDetail = false;
                    $scope.duplicatedIndexForDetail = null;

                    $scope.isKeyDuplicatedForArrDetail = false;
                    $scope.duplicatedIndexForArrDetail = null;
                };

                $scope.fnDeleteMapping = function () {
                    var isTabExist = _.findIndex($scope.mappingsTabs, {'id': $scope.selectedMappingObj.id});

                    if (isTabExist) {
                        $scope.mappingsTabs.splice(isTabExist, 1);
                        $scope.selectedDetailSubTabIndex = 1;
                        $scope.activeTabIndex = 1;

                        var findIndex = _.findIndex($scope.mappingsArr, function (mappingObj) {
                            return mappingObj.id === $scope.selectedMappingObj.id;
                        });
                        if (findIndex !== -1) {
                            $scope.mappingsArr.splice(findIndex, 1);
                        }
                        $scope.selectedMappingObj = '';
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach($scope.createMappingObj.mapArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicated = true;
                        $scope.duplicatedIndex = index;
                    } else {
                        $scope.isKeyDuplicated = false;
                        $scope.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.createMappingObj.mapArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.createMappingObj.mapArr[$scope.createMappingObj.mapArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.createMappingObj.mapArr.length > 1) {
                                    angular.forEach($scope.createMappingObj.mapArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.createMappingObj.mapArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnRemoveSupplemental = function (index) {
                    $scope.createMappingObj.mapArr.splice(index, 1);
                };

                $scope.fnCheckUniqueKeyForDetail = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach($scope.selectedMappingObj.mapArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicatedForDetail = true;
                        $scope.duplicatedIndexForDetail = index;
                    } else {
                        $scope.isKeyDuplicatedForDetail = false;
                        $scope.duplicatedIndexForDetail = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.selectedMappingObj.mapArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.selectedMappingObj.mapArr.length > 1) {
                                    angular.forEach($scope.selectedMappingObj.mapArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnRemoveSupplementalForDetail = function (index) {
                    $scope.selectedMappingObj.mapArr.splice(index, 1);
                };

                $scope.fnCheckUniqueKeyArr = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach($scope.createMappingObj.mapArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicatedForArr = true;
                        $scope.duplicatedIndexForArr = index;
                    } else {
                        $scope.isKeyDuplicatedForArr = false;
                        $scope.duplicatedIndexForArr = null;
                    }
                    if (kvpPairObj.key) {
                        if (index + 1 === $scope.createMappingObj.mapArr.length) {
                            if (kvpPairObj.key.length && $scope.createMappingObj.mapArr[$scope.createMappingObj.mapArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.createMappingObj.mapArr.length > 1) {
                                    angular.forEach($scope.createMappingObj.mapArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.createMappingObj.mapArr.push({
                                        key: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnCheckUniqueKeyArrForDetail = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach($scope.selectedMappingObj.mapArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicatedForArrDetail = true;
                        $scope.duplicatedIndexForArrDetail = index;
                    } else {
                        $scope.isKeyDuplicatedForArrDetail = false;
                        $scope.duplicatedIndexForArrDetail = null;
                    }
                    if (kvpPairObj.key) {
                        if (index + 1 === $scope.selectedMappingObj.mapArr.length) {
                            if (kvpPairObj.key.length && $scope.selectedMappingObj.mapArr[$scope.selectedMappingObj.mapArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.selectedMappingObj.mapArr.length > 1) {
                                    angular.forEach($scope.selectedMappingObj.mapArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.selectedMappingObj.mapArr.push({
                                        key: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnChangeMappingTypeForCreate = function (mappingObj) {
                    if (mappingObj.isMap) {
                        delete mappingObj.array;
                        mappingObj.keyType = 'String';
                        mappingObj.valueType = 'String';
                        mappingObj.mapArr = [{
                            key: '',
                            value: ''
                        }]
                    } else {
                        delete  mappingObj.map;
                        mappingObj.keyType = 'String';
                        mappingObj.valueType = 'String';
                        mappingObj.mapArr = [{
                            key: ''
                        }]
                    }
                };

                $scope.fnSelectKeyTypeValue = function (key, type) {
                    if (type === 'detail') {
                        $scope.selectedMappingObj.keyType = key;
                    } else {
                        $scope.createMappingObj.keyType = key;
                    }
                };

                $scope.fnSelectValueTypeValue = function (key, type) {
                    if (type === 'detail') {
                        $scope.selectedMappingObj.valueType = key;
                    } else {
                        $scope.createMappingObj.valueType = key;
                    }
                };

                $scope.fnCheckAddMapping = function () {
                    if ($scope.createMappingObj.id.length === 0 || $scope.createMappingObj.keyType.length === 0 ||
                    $scope.createMappingObj.valueType.length === 0 || $scope.isReferenceDuplicated ||
                    $scope.isReferencePatternMismatched) {
                        return true;
                    } else {
                        return $scope.createMappingObj.isMap ? $scope.isKeyDuplicated : $scope.isKeyDuplicatedForArr;
                    }
                };

                $scope.fnInitMappingsTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.mappingsObj && Object.keys($scope.mappingsObj).length) {
                        Object.keys($scope.mappingsObj).forEach(function (mappingKey) {
                            var tempObj = {
                                id: mappingKey,
                                keyType: $scope.mappingsObj[mappingKey].keyType,
                                valueType: $scope.mappingsObj[mappingKey].valueType
                            };
                            tempObj.isMap = !!$scope.mappingsObj[mappingKey].map;
                            if (tempObj.isMap) {
                                tempObj.map = $scope.mappingsObj[mappingKey].map;
                                tempObj.mapArr = [];
                                Object.keys($scope.mappingsObj[mappingKey].map).forEach(function (mapKey) {
                                    tempObj.mapArr.push({
                                        key: mapKey,
                                        value: $scope.mappingsObj[mappingKey].map[mapKey]
                                    })
                                });
                            } else {
                                tempObj.array = $scope.mappingsObj[mappingKey].array;
                                tempObj.mapArr = [];
                                _.forEach($scope.mappingsObj[mappingKey].array, function (mapKey) {
                                    tempObj.mapArr.push({
                                        key: mapKey
                                    })
                                });
                            }
                            $scope.mappingsArr.push(tempObj)
                        })
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitMappingsTab();

                $scope.fnCallOnDestroyForMappings = function () {
                    var tempObj = {};
                    _.forEach($scope.mappingsArr, function (mappingObj) {
                        tempObj[mappingObj.id] = {
                            keyType: mappingObj.keyType,
                            valueType: mappingObj.valueType
                        };
                        if (mappingObj.isMap) {
                            tempObj[mappingObj.id].map = {};
                            _.forEach(mappingObj.mapArr, function (mapObj) {
                                tempObj[mappingObj.id].map[mapObj.key] = mapObj.value;
                            })
                        } else {
                            tempObj[mappingObj.id].array = [];
                            _.forEach(mappingObj.mapArr, function (mapObj) {
                                tempObj[mappingObj.id].array.push(mapObj.key);
                            })
                        }
                    });
                    $scope.fnUpdateWorkbench({updateType: 'mapping', updateValue: tempObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnCallOnDestroyForMappings();
                });

                $window.onbeforeunload = function() {
                    $scope.fnCallOnDestroyForMappings();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Detail', fnIot3Detail)

    /** @ngInject */
    function fnIot3Detail($rootScope, $timeout, $window, $base64, amaran, DB, jsyaml) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/iot3/iot3.html',
            scope: {
                currentWorkspace: "=",
                sideActiveTabIndex: "=",
                fnReverseUpdate: "&",
                fnDownloadIot3: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.iot3Tabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.iot3Tabs[0];
                $scope.iot3Detail = {
                    yamlString: ''
                };

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            $timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);
                        });

                        $scope.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#iot3TabMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 4);
                        angular.element("#iot3TabMainContainer").css('height', finalHeight + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        $scope.modeChanged();
                    }, 100)
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnDownloadIot3File = function () {
                    $scope.fnDownloadIot3();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    }
                    catch (error) {
                        $scope.setLine(_.cloneDeepWith(error));
                        return false;
                    }
                };

                $scope.fnChangeDone = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100);
                    var isValidJson = $scope.fnConvertYamlToJson($scope.iot3Detail.yamlString);
                    if (isValidJson !== false) {
                        // vm.iot3JSON = isValidJson;
                        $scope.isChangesSync = true;
                        $timeout(function () {
                            $scope.setLine();
                        });
                    } else {
                        $scope.isChangesSync = false;
                    }
                    /*$timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)*/
                };

                $scope.fnSaveIot3File = function () {
                    $scope.fnReverseUpdate({yamlStr: $scope.iot3Detail.yamlString})
                    $timeout(function () {
                        amaran.success('Iot3 file updated successfully');
                    })
                };

                $scope.fnInitIot3Tab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    $scope.iot3Detail.yamlString = $base64.decode(DB.fnGet('iot3Workbench').currentWorkbench.yamlString);
                    $scope.fnChangeDone();
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitIot3Tab();

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Info', fnIot3Info)

    /** @ngInject */
    function fnIot3Info($rootScope, $timeout, $window, DB, moment) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/info/info.html',
            scope: {
                currentWorkspace: "=",
                iot3InfoObj: '=',
                iot3Version: '=',
                sideActiveTabIndex: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.infoTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.infoTabs[0];

                $scope.stagesArr = [{
                    name: "alpha"
                }, {
                    name: "beta"
                }, {
                    name: "preview"
                }, {
                    name: "release"
                }];
                $scope.infoObj = {};
                $scope.selectedVersion = '';
                $scope.selectedLabel = '';

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#infoMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 35);
                        angular.element("#infoMainContainer").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnSelectStage = function (stateObj) {
                    $scope.infoObj.stage = stateObj.name;
                };

                $scope.fnRemoveResource = function (resourceType, index) {
                    if (resourceType === 'versions') {
                        $scope.infoObj.versions.splice(index, 1);
                    } else if (resourceType === 'labels') {
                        $scope.infoObj.labels.splice(index, 1);
                    }
                };

                $scope.fnAddResources = function (resourceType, resourceValue) {
                    if (resourceType === 'versions') {
                        if (resourceValue && resourceValue.length) {
                            if (!$scope.infoObj.versions || $scope.infoObj.versions === null) {
                                $scope.infoObj.versions = [];
                            }
                            $scope.infoObj.versions.push(resourceValue);
                            $scope.selectedVersion = '';
                        }
                    } else if (resourceType === 'labels') {
                        if (resourceValue && resourceValue.length) {
                            if (!$scope.infoObj.labels || $scope.infoObj.labels === null) {
                                $scope.infoObj.labels = [];
                            }
                            $scope.infoObj.labels.push(resourceValue);
                            $scope.selectedLabel = '';
                        }
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnInitInfoTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.iot3InfoObj) {
                        $scope.infoObj = _.cloneDeepWith($scope.iot3InfoObj);
                        if (!$scope.infoObj.stage || $scope.infoObj.stage.length === 0) {
                            $scope.infoObj.stage = $scope.stagesArr[0].name;
                        }
                    } else {
                        $scope.infoObj = {
                            name: '',
                            oem: '',
                            model: '',
                            versions: [],
                            description: '',
                            stage: '',
                            author: DB.fnGet('loginUser').email,
                            revision: 1,
                            created: moment().format('YYYY-MM-DD'),
                            updated: moment().format('YYYY-MM-DD'),
                            labels: []
                        };
                        $scope.infoObj.stage = $scope.stagesArr[0].name;
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitInfoTab();

                $scope.$on('$destroy', function () {
                    $scope.fnUpdateWorkbench({updateType: 'info', updateValue: $scope.infoObj});
                });

                $window.onbeforeunload = function() {
                    $scope.fnUpdateWorkbench({updateType: 'info', updateValue: $scope.infoObj});
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Global', fnIot3Global)

    /** @ngInject */
    function fnIot3Global($rootScope, $timeout, $window) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/global/global.html',
            scope: {
                currentWorkspace: "=",
                iot3GlobalObj: "=",
                iot3AuthenticationObj: "=",
                iot3JsonObj: "=",
                sideActiveTabIndex: "=",
                attributesObj: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.globalTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.globalTabs[0];

                $scope.globalKVPArr = [{
                        key: '',
                        value: ''
                    }
                ];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#globalMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 20);
                        angular.element("#globalMainContainer").css('height', finalHeight + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnGlobalKeySelected = function (item, model, label, event, kvpPair, type) {
                    if (type === 'key') {
                        if (kvpPair.oldValueKey.includes('.')) {
                            kvpPair.key = kvpPair.oldValueKey.substr(0, kvpPair.oldValueKey.lastIndexOf('.')) + '.' + kvpPair.key.name;
                        } else {
                            kvpPair.key = '${' + kvpPair.key.name;
                        }
                    } else if (type === 'value') {
                        if (kvpPair.oldValue.includes('.')) {
                            kvpPair.value = kvpPair.oldValue.substr(0, kvpPair.oldValue.lastIndexOf('.')) + '.' + kvpPair.value.name;
                        } else {
                            kvpPair.value = '${' + kvpPair.value.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKey = function (kvpPairObj, index, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach($scope.globalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicated = true;
                        $scope.duplicatedIndex = index;
                    } else {
                        $scope.isKeyDuplicated = false;
                        $scope.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.globalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.globalKVPArr[$scope.globalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.globalKVPArr.length > 1) {
                                    angular.forEach($scope.globalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.globalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnRemoveSupplemental = function (index) {
                    $scope.globalKVPArr.splice(index, 1);
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                function traverseAndFlatten(currentNode, target, flattenedKey) {
                    for (var key in currentNode) {
                        if (currentNode.hasOwnProperty(key)) {
                            var newKey;

                            if (flattenedKey === undefined) { //eslint-disable-line
                                newKey = key;
                            } else {
                                newKey = flattenedKey + '.' + key;
                            }

                            var value = currentNode[key];
                            if (typeof value === "object") { //eslint-disable-line
                                traverseAndFlatten(value, target, newKey);
                            } else {
                                target[newKey] = value;
                            }
                        }
                    }
                }

                function flatten(obj) {
                    var flattenedObject = {};
                    traverseAndFlatten(obj, flattenedObject);
                    return flattenedObject;
                }

                $scope.fnInitGlobalTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.iot3GlobalObj && Object.keys($scope.iot3GlobalObj).length) {
                        $scope.globalKVPArr = [];
                        var flattenObj = flatten($scope.iot3GlobalObj);
                        Object.keys(flattenObj).forEach(function (keyName) {
                            $scope.globalKVPArr.push({
                                key: keyName,
                                value: flattenObj[keyName],
                                isFromAttr: false,
                                isFromAuthLogin: false,
                                isFromAuthLogout: false
                            });
                        });


                        Object.keys($scope.attributesObj).forEach(function (attrKey) {
                            if ($scope.attributesObj[attrKey].attributes &&
                                $scope.attributesObj[attrKey].attributes.dataSink &&
                                $scope.attributesObj[attrKey].attributes.dataSink.length) {
                                $scope.globalKVPArr.push({
                                    key: $scope.attributesObj[attrKey].attributes.dataSink,
                                    value: '',
                                    isFromAttr: true,
                                    isFromAuthLogin: false,
                                    isFromAuthLogout: false
                                });
                            }
                        });

                        if ($scope.iot3AuthenticationObj &&
                            $scope.iot3AuthenticationObj.http &&
                            $scope.iot3AuthenticationObj.http.actions) {
                            if ($scope.iot3AuthenticationObj.http.actions.login &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSink &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSink.length) {
                                $scope.globalKVPArr.push({
                                    key: $scope.iot3AuthenticationObj.http.actions.login.dataSink,
                                    value: '',
                                    isFromAttr: false,
                                    isFromAuthLogin: true,
                                    isFromAuthLogout: false
                                });
                            }
                            if ($scope.iot3AuthenticationObj.http.actions.logout &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSink &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSink.length) {
                                $scope.globalKVPArr.push({
                                    key: $scope.iot3AuthenticationObj.http.actions.logout.dataSink,
                                    value: '',
                                    isFromAttr: false,
                                    isFromAuthLogin: false,
                                    isFromAuthLogout: true
                                });
                            }
                        }
                        $scope.globalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitGlobalTab();

                $scope.fnCallOnDestroyForGlobal = function () {
                    var tempObj = {};
                    _.forEach($scope.globalKVPArr, function (kvpObj) {
                        if (kvpObj.key.length && !kvpObj.isFromAttr && !kvpObj.isFromAuthLogin && !kvpObj.isFromAuthLogout) {
                            _.set(tempObj, kvpObj.key, kvpObj.value);
                        }
                    });
                    $scope.fnUpdateWorkbench({updateType: 'global', updateValue: tempObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnCallOnDestroyForGlobal();
                });

                $window.onbeforeunload = function() {
                    $scope.fnCallOnDestroyForGlobal();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Engine', fnIot3Engine)

    /** @ngInject */
    function fnIot3Engine($rootScope, $timeout, $window, $uibModal, DB) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/engine/engine.html',
            scope: {
                currentWorkspace: "=",
                sideActiveTabIndex: "=",
                iot3EngineObj: "=",
                iot3JsonObj: "=",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.engineTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.engineTabs[0];

                $scope.selectedSubTabIndex = 1;

                $scope.engineTypesArr = {
                    http: 'HTTP',
                    snmp: 'SNMP'
                };

                $scope.booleanOptions = [{
                    key: 'True',
                    value: true
                }, {
                    key: 'False',
                    value: false
                }];

                $scope.resetSshObj = {
                    supportsBulk: false,
                    bulkRange: 0,
                    maxOids: 50,
                    timeout: 60
                };

                $scope.resetHttpObj = {
                    type: 'api',
                    requests: {},
                    requestsArr: []
                };

                $scope.resetHttpRequestObj = {
                    method: '',
                    uri: '',
                    encoding: '',
                    contentType: '',
                    query: {},
                    queryArr: [{
                        key: '',
                        value: ''
                    }],
                    header: {},
                    headerArr: [{
                        key: '',
                        value: ''
                    }],
                    body: {},
                    bodyArr: [{
                        key: '',
                        value: ''
                    }],
                    responses: {
                        success: [{
                            type: 'header',
                            expression: '',
                            match: ''
                        }],
                        failure: [{
                            type: 'header',
                            expression: '',
                            match: ''
                        }]
                    }
                };

                // $scope.resetHttpObj.requestsArr[0].value = _.cloneDeepWith($scope.resetHttpRequestObj);

                $scope.typeEnumerationOptions = [{
                    name: 'api'
                }, {
                    name: 'scrape'
                }];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#engineMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 20);
                        angular.element("#engineMainContainer").css('height', finalHeight + 16 + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight + 16 - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $timeout(function () {
                        $scope.fnInitiateResetWorkspace();
                    });
                };

                $scope.fnSelectBooleanOption = function (booleanOption, type) {
                    if (type === 'sshSupport') {
                        $scope.iot3EngineObj.tunnel.ssh.supported = booleanOption.value;
                    } else if (type === 'httpSupport') {
                        $scope.iot3EngineObj.tunnel.http.supported = booleanOption.value;
                    }
                };

                $scope.fnSelectEngineType = function (type) {
                    $scope.iot3EngineObj.engineType = type;
                };

                $scope.fnSelectHttpTypeEnumeration = function (name) {
                    $scope.iot3EngineObj.http.type = name
                };

                /*$scope.fnAddEngineRequest = function (event) {
                    event.preventDefault();
                    $scope.iot3EngineObj.http.requestsArr.push({
                        name: '',
                        value: _.cloneDeepWith($scope.resetHttpRequestObj),
                        sampleData: '',
                        sampleDataType: 'HTML'
                    })
                };*/

                $scope.fnDeleteEngineRequest = function (index) {
                    $scope.iot3EngineObj.http.requestsArr.splice(index, 1);
                };

                $scope.fnOpenEngineDetails = function (isCreate, requestObj, index) {
                    var createRequestObj = {
                        name: '',
                        value: _.cloneDeepWith($scope.resetHttpRequestObj),
                        sampleData: '',
                        sampleDataType: 'HTML'
                    };

                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/steps/engine/modals/engineRequestModal/engineRequestModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'engineRequestModalCtrl as engineRequestModal',
                        resolve: {
                            requestObj: function () {
                                return isCreate ? createRequestObj : requestObj;
                            },
                            isCreate: function () {
                                return isCreate;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        if (isCreate) {
                            $scope.iot3EngineObj.http.requestsArr.push(data);
                        } else {
                            $scope.iot3EngineObj.http.requestsArr[index] = _.cloneDeepWith(data);
                        }
                    }, function () {
                    });
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnChangeSubTab = function (tab) {
                    $scope.selectedSubTabIndex = tab;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnRemoveSupplementalForSsh = function (index) {
                    $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.splice(index, 1);
                };

                $scope.fnRemoveSupplementalForHttp = function (index) {
                    $scope.iot3EngineObj.tunnel.http.httpInstructionsArr.splice(index, 1);
                };

                $scope.fnGlobalKeySelected = function (item, model, label, event, kvpPair, type) {
                    if (type === 'key') {
                        if (kvpPair.oldValueKey.includes('.')) {
                            kvpPair.key = kvpPair.oldValueKey.substr(0, kvpPair.oldValueKey.lastIndexOf('.')) + '.' + kvpPair.key.name;
                        } else {
                            kvpPair.key = '${' + kvpPair.key.name;
                        }
                    } else if (type === 'value') {
                        if (kvpPair.oldValue.includes('.')) {
                            kvpPair.value = kvpPair.oldValue.substr(0, kvpPair.oldValue.lastIndexOf('.')) + '.' + kvpPair.value.name;
                        } else {
                            kvpPair.value = '${' + kvpPair.value.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForSsh = function (kvpPairObj, index, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach($scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    kvpPairObj.isSshKeyDuplicated = count > 1;
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr[$scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.length > 1) {
                                    angular.forEach($scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForHttp = function (kvpPairObj, index, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach($scope.iot3EngineObj.tunnel.http.httpInstructionsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    kvpPairObj.isHttpKeyDuplicated = count > 1;
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.iot3EngineObj.tunnel.http.httpInstructionsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.iot3EngineObj.tunnel.http.httpInstructionsArr[$scope.iot3EngineObj.tunnel.http.httpInstructionsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.iot3EngineObj.tunnel.http.httpInstructionsArr.length > 1) {
                                    angular.forEach($scope.iot3EngineObj.tunnel.http.httpInstructionsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.iot3EngineObj.tunnel.http.httpInstructionsArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnSaveSampleForEngine = function (sampleDataObj) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        workbench.currentWorkspaceEngineSampleData = sampleDataObj;
                        DB.fnSet('iot3Workbench', workbench);
                    }
                };

                $scope.fnClearSampleDataForEngine = function () {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        workbench.currentWorkspaceEngineSampleData = {};
                        DB.fnSet('iot3Workbench', workbench);
                    }
                };

                $scope.fnUpdateEngineDetails = function () {
                    var tempObj = {};
                    $scope.iot3EngineObj.tunnel.ssh.displayInstructions = {};
                    _.forEach($scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr, function (sshInstructionObj) {
                        if (sshInstructionObj.key && sshInstructionObj.key.length && !sshInstructionObj.isSshKeyDuplicated) {
                            $scope.iot3EngineObj.tunnel.ssh.displayInstructions[sshInstructionObj.key] = sshInstructionObj.value;
                        }
                    });
                    delete $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr;

                    $scope.iot3EngineObj.tunnel.http.displayInstructions = {};
                    _.forEach($scope.iot3EngineObj.tunnel.http.httpInstructionsArr, function (httpInstructionObj) {
                        if (httpInstructionObj.key && httpInstructionObj.key.length && !httpInstructionObj.isHttpKeyDuplicated) {
                            $scope.iot3EngineObj.tunnel.http.displayInstructions[httpInstructionObj.key] = httpInstructionObj.value;
                        }
                    });
                    delete $scope.iot3EngineObj.tunnel.http.httpInstructionsArr;

                    if ($scope.iot3EngineObj.engineType === 'http') {
                        delete $scope.iot3EngineObj.snmp;
                        $scope.iot3EngineObj.http.requests = {};
                        _.forEach($scope.iot3EngineObj.http.requestsArr, function (requestObj) {
                            if (requestObj.name && requestObj.name.length) {
                                tempObj[requestObj.name] = {
                                    sampleDataType: requestObj.sampleDataType,
                                    sampleData: requestObj.sampleData
                                };

                                requestObj.value.query = {};
                                _.forEach(requestObj.value.queryArr, function (queryObj) {
                                    if (queryObj.key && queryObj.key.length && !queryObj.isKeyDuplicated) {
                                        requestObj.value.query[queryObj.key] = queryObj.value;
                                    }
                                });
                                delete requestObj.value.queryArr;

                                requestObj.value.header = {};
                                _.forEach(requestObj.value.headerArr, function (headerObj) {
                                    if (headerObj.key && headerObj.key.length && !headerObj.isKeyDuplicated) {
                                        requestObj.value.header[headerObj.key] = headerObj.value;
                                    }
                                });
                                delete requestObj.value.headerArr;

                                requestObj.value.body = {};
                                _.forEach(requestObj.value.bodyArr, function (bodyObj) {
                                    if (bodyObj.key && bodyObj.key.length && !bodyObj.isKeyDuplicated) {
                                        requestObj.value.body[bodyObj.key] = bodyObj.value;
                                    }
                                });
                                delete requestObj.value.bodyArr;

                                if (requestObj.value && requestObj.value.responses) {
                                    if (requestObj.value.responses.success && requestObj.value.responses.success.length) {
                                        requestObj.value.responses.success = _.filter(requestObj.value.responses.success, function (successObj) {
                                            delete successObj.open;
                                            return successObj;
                                        })
                                    }

                                    if (requestObj.value.responses.failure && requestObj.value.responses.failure.length) {
                                        requestObj.value.responses.failure = _.filter(requestObj.value.responses.failure, function (failureObj) {
                                            delete failureObj.open;
                                            return failureObj;
                                        })
                                    }
                                }
                                $scope.iot3EngineObj.http.requests[requestObj.name] = requestObj.value;
                            }
                        });
                        delete $scope.iot3EngineObj.http.requestsArr;
                        $scope.fnSaveSampleForEngine(tempObj);
                    } else if ($scope.iot3EngineObj.engineType === 'snmp') {
                        delete $scope.iot3EngineObj.http;
                        $scope.fnClearSampleDataForEngine();
                    }
                    delete $scope.iot3EngineObj.engineType;

                    $scope.fnUpdateWorkbench({updateType: 'engine', updateValue: $scope.iot3EngineObj});
                };

                $scope.fnInitEngineTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.iot3EngineObj && Object.keys($scope.iot3EngineObj).length) {
                        if ($scope.iot3EngineObj.tunnel && $scope.iot3EngineObj.tunnel.ssh &&
                            $scope.iot3EngineObj.tunnel.ssh.displayInstructions &&
                            Object.keys($scope.iot3EngineObj.tunnel.ssh.displayInstructions).length) {
                            var tempArr =[];

                            Object.keys($scope.iot3EngineObj.tunnel.ssh.displayInstructions).forEach(function (sshKey) {
                                tempArr.push({
                                    key: sshKey,
                                    value: $scope.iot3EngineObj.tunnel.ssh.displayInstructions[sshKey]
                                })
                            });
                            $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr = _.cloneDeepWith(tempArr);
                            $scope.iot3EngineObj.tunnel.ssh.sshInstructionsArr.push({
                                key: '',
                                value: ''
                            })
                        } else {
                            if (angular.isUndefined($scope.iot3EngineObj.tunnel)) {
                                $scope.iot3EngineObj.tunnel = {
                                    ssh: {
                                        supported: false,
                                        displayInstructions: {},
                                        sshInstructionsArr: [{
                                            key: '',
                                            value: ''
                                        }]
                                    }
                                }
                            } else {
                                $scope.iot3EngineObj.tunnel.ssh = {
                                    supported: $scope.iot3EngineObj &&
                                    $scope.iot3EngineObj.tunnel &&
                                    $scope.iot3EngineObj.tunnel.ssh &&
                                    $scope.iot3EngineObj.tunnel.ssh.supported ?
                                        $scope.iot3EngineObj.tunnel.ssh.supported : false,
                                    displayInstructions: {},
                                    sshInstructionsArr: [{
                                        key: '',
                                        value: ''
                                    }]
                                }
                            }
                        }

                        if ($scope.iot3EngineObj.tunnel && $scope.iot3EngineObj.tunnel.http &&
                            $scope.iot3EngineObj.tunnel.http.displayInstructions &&
                            Object.keys($scope.iot3EngineObj.tunnel.http.displayInstructions).length) {
                            var tempArrForHttp =[];
                            Object.keys($scope.iot3EngineObj.tunnel.http.displayInstructions).forEach(function (httpKey) {
                                tempArrForHttp.push({
                                    key: httpKey,
                                    value: $scope.iot3EngineObj.tunnel.http.displayInstructions[httpKey]
                                })
                            });
                            $scope.iot3EngineObj.tunnel.http.httpInstructionsArr = _.cloneDeepWith(tempArrForHttp);
                            $scope.iot3EngineObj.tunnel.http.httpInstructionsArr.push({
                                key: '',
                                value: ''
                            })
                        } else {
                            if (angular.isUndefined($scope.iot3EngineObj.tunnel)) {
                                $scope.iot3EngineObj.tunnel = {
                                    http: {
                                        supported: false,
                                        displayInstructions: {},
                                        httpInstructionsArr: [{
                                            key: '',
                                            value: ''
                                        }]
                                    }
                                }
                            } else {
                                $scope.iot3EngineObj.tunnel.http = {
                                    supported: $scope.iot3EngineObj && $scope.iot3EngineObj.tunnel &&
                                    $scope.iot3EngineObj.tunnel.http && $scope.iot3EngineObj.tunnel.http.supported ?
                                        $scope.iot3EngineObj.tunnel.http.supported : false,
                                    displayInstructions: {},
                                    httpInstructionsArr: [{
                                        key: '',
                                        value: ''
                                    }]
                                }
                            }
                        }

                        if ($scope.iot3EngineObj.http && Object.keys($scope.iot3EngineObj.http).length) {
                            $scope.iot3EngineObj.engineType = 'http';
                            var savedSampleDataObj = {};
                            if (DB.fnGet('iot3Workbench')) {
                                var workbench = DB.fnGet('iot3Workbench');
                                if (workbench.currentWorkspaceEngineSampleData) {
                                    savedSampleDataObj = workbench.currentWorkspaceEngineSampleData;
                                }
                            }

                            $scope.iot3EngineObj.http.requestsArr = [];
                            if ($scope.iot3EngineObj.http.requests && Object.keys($scope.iot3EngineObj.http.requests).length) {
                                Object.keys($scope.iot3EngineObj.http.requests).forEach(function (key) {
                                    var queryArr = [];
                                    var headerArr = [];
                                    var bodyArr = [];
                                    if ($scope.iot3EngineObj.http.requests[key] &&
                                        $scope.iot3EngineObj.http.requests[key].query &&
                                        Object.keys($scope.iot3EngineObj.http.requests[key].query).length) {
                                        Object.keys($scope.iot3EngineObj.http.requests[key].query).forEach(function (queryKey) {
                                            queryArr.push({
                                                key: queryKey,
                                                value: $scope.iot3EngineObj.http.requests[key].query[queryKey]
                                            })
                                        });
                                        queryArr.push({
                                            key: '',
                                            value: ''
                                        });
                                        $scope.iot3EngineObj.http.requests[key].queryArr = queryArr;
                                    } else {
                                        if (!$scope.iot3EngineObj.http.requests[key]) {
                                            $scope.iot3EngineObj.http.requests[key] = {};
                                        }
                                        $scope.iot3EngineObj.http.requests[key].query = {};
                                        $scope.iot3EngineObj.http.requests[key].queryArr = [{
                                            key: '',
                                            value: ''
                                        }];
                                    }

                                    if ($scope.iot3EngineObj &&
                                        $scope.iot3EngineObj.http &&
                                        $scope.iot3EngineObj.http.requests &&
                                        $scope.iot3EngineObj.http.requests[key] &&
                                        $scope.iot3EngineObj.http.requests[key].header &&
                                        Object.keys($scope.iot3EngineObj.http.requests[key].header).length) {
                                        Object.keys($scope.iot3EngineObj.http.requests[key].header).forEach(function (headerKey) {
                                            headerArr.push({
                                                key: headerKey,
                                                value: $scope.iot3EngineObj.http.requests[key].header[headerKey]
                                            })
                                        });
                                        headerArr.push({
                                            key: '',
                                            value: ''
                                        });
                                        $scope.iot3EngineObj.http.requests[key].headerArr = headerArr;
                                    } else {
                                        $scope.iot3EngineObj.http.requests[key].header = {};
                                        $scope.iot3EngineObj.http.requests[key].headerArr = [{
                                            key: '',
                                            value: ''
                                        }];
                                    }

                                    if ($scope.iot3EngineObj &&
                                        $scope.iot3EngineObj.http &&
                                        $scope.iot3EngineObj.http.requests &&
                                        $scope.iot3EngineObj.http.requests[key] &&
                                        $scope.iot3EngineObj.http.requests[key].body &&
                                        Object.keys($scope.iot3EngineObj.http.requests[key].body).length) {
                                        Object.keys($scope.iot3EngineObj.http.requests[key].body).forEach(function (bodyKey) {
                                            bodyArr.push({
                                                key: bodyKey,
                                                value: $scope.iot3EngineObj.http.requests[key].body[bodyKey]
                                            })
                                        });
                                        bodyArr.push({
                                            key: '',
                                            value: ''
                                        });
                                        $scope.iot3EngineObj.http.requests[key].bodyArr = bodyArr;
                                    } else {
                                        $scope.iot3EngineObj.http.requests[key].body = {};
                                        $scope.iot3EngineObj.http.requests[key].bodyArr = [{
                                            key: '',
                                            value: ''
                                        }];
                                    }

                                    var tempObj = {
                                        name: key,
                                        value: $scope.iot3EngineObj.http.requests[key],
                                        sampleData: '',
                                        sampleDataType: 'HTML'
                                    };

                                    if (savedSampleDataObj[key]) {
                                        tempObj.sampleData = savedSampleDataObj[key].sampleData;
                                        tempObj.sampleDataType = savedSampleDataObj[key].sampleDataType;
                                    }

                                    $scope.iot3EngineObj.http.requestsArr.push(tempObj)
                                })
                            } else {
                                /*$scope.iot3EngineObj.http.requestsArr = [{
                                    name: '',
                                    value: _.cloneDeepWith($scope.resetHttpRequestObj),
                                    sampleData: '',
                                    sampleDataType: 'HTML'
                                }];*/
                            }
                        } else if ($scope.iot3EngineObj.snmp && Object.keys($scope.iot3EngineObj.snmp).length) {
                            $scope.iot3EngineObj.engineType = 'snmp';
                        } else {
                            $scope.iot3EngineObj.engineType = 'http';
                            $scope.iot3EngineObj.http = _.cloneDeepWith($scope.resetHttpObj);
                        }
                    } else {
                        $scope.iot3EngineObj = {
                            tunnel: {
                                ssh: {
                                    supported: false,
                                    displayInstructions: {},
                                    sshInstructionsArr: [{
                                        key: '',
                                        value: ''
                                    }]
                                },
                                http: {
                                    supported: false,
                                    displayInstructions: {},
                                    httpInstructionsArr: [{
                                        key: '',
                                        value: ''
                                    }]
                                }
                            },
                            engineType: 'http',
                            http: _.cloneDeepWith($scope.resetHttpObj)
                        }
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitEngineTab();

                $scope.$on('$destroy', function () {
                    $scope.fnUpdateEngineDetails();
                });

                $scope.$on('engineResizeCall', function () {
                    $scope.fnSetTableHeight();
                });

                $window.onbeforeunload = function() {
                    $scope.fnUpdateEngineDetails();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Authentication', fnIot3Authentication)

    /** @ngInject */
    function fnIot3Authentication($rootScope, $timeout, $window, $uibModal, DB, amaran, swal, microSpinner, $base64, Iot3WorkbenchFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/authentication/authentication.html',
            scope: {
                currentWorkspace: "=",
                iot3AuthenticationObj: "=",
                iot3JsonObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateGlobalFromAttr: "&",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                $scope.authenticationTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.authenticationTabs[0];

                $scope.resetXDataObj = {
                    dataSource: '',
                    selector: {
                        type: '',
                        expression: '',
                        selectors: {}
                    },
                    lookup: {},
                    extractor: {
                        keys: [],
                        transform: '',
                        filters: {},
                        mapper: '',
                        parameters: {}
                    },
                    dataSink: ''
                };

                $scope.resetHttpAuthenticationObj = {
                    actions: {
                        login: _.cloneDeepWith($scope.resetXDataObj),
                        logout: _.cloneDeepWith($scope.resetXDataObj)
                    }
                };

                $scope.resetSnmpAuthenticationObj = {
                    version: '',
                    credentials: {}
                };

                $scope.authenticationTypes = {
                    'http': 'HTTP',
                    'snmp': 'SNMP'
                };

                $scope.attrSelectorPathOptions = [
                    "xpath",
                    "xslt",
                    "oid",
                    "gjson",
                    "cookie",
                    "header"
                ];
                $scope.loginSelectorType = '';
                $scope.sampleDataForLogin = {};
                $scope.selectedSampleDataForLogin = '';
                $scope.manipulatedSampleDataForLogin = '';
                $scope.isShowSampleDataForLogin = false;
                $scope.mappingsArr = [];

                $scope.extractFiltersArrForLogin = [{
                    key: '',
                    value: ''
                }];
                $scope.resetExtractFiltersArrForLogin = _.cloneDeepWith($scope.extractFiltersArrForLogin);

                $scope.extractFiltersArrForLogout = [{
                    key: '',
                    value: ''
                }];
                $scope.resetExtractFiltersArrForLogout = _.cloneDeepWith($scope.extractFiltersArrForLogout);

                $scope.attrFilterOptionsForLogin = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "split",
                    "displayValue": "split",
                    "isArguments": true,
                    "isShow": true
                }];
                $scope.resetAttrFilterOptionsForLogin = _.cloneDeepWith($scope.attrFilterOptionsForLogin);

                $scope.attrFilterOptionsForLogout = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "split",
                    "displayValue": "split",
                    "isArguments": true,
                    "isShow": true
                }];
                $scope.resetAttrFilterOptionsForLogout = _.cloneDeepWith($scope.attrFilterOptionsForLogout);

                $scope.isMapperSelectedForLogin = false;
                $scope.isMapperSelectedForLogout = false;

                $scope.selectorPathOptions = {
                    'JSON': 'GJson',
                    'XML': 'xPath',
                    'HTML': 'xPath',
                    'CSV': 'xPath',
                    'OID': 'OID',
                    'Cookie': 'cookie',
                    'Header': 'header'
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element('#authenticationMainContainer'))) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 20);
                        angular.element("#authenticationMainContainer").css('height', finalHeight + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function () {

                };

                $scope.fnRemoveTab = function () {

                };

                $scope.fnOpenExpressionModal = function (expression, expressionType, sampleDataForMode, mode) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/expressionModal/expressionModal.html',
                        size: 'lg',
                        controller: 'expressionModalCtrl as expressionModal',
                        windowClass: 'modal-fullScreen',
                        resolve: {
                            expression: function () {
                                return expression;
                            },
                            expressionType: function () {
                                return expressionType;
                            },
                            sampleDataForSelectedAttr: function () {
                                return sampleDataForMode;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        if (mode === 'login') {
                            $scope.iot3AuthenticationObj.http.actions.login.selector.expression = obj.expression;
                            $scope.selectedSampleDataForLogin = obj.selectedSampleData;
                        } else {
                            $scope.iot3AuthenticationObj.http.actions.logout.selector.expression = obj.expression;
                            $scope.selectedSampleDataForLogout = obj.selectedSampleData;
                        }
                    }, function () {
                    });
                };

                $scope.fnSelectExtractFilterForLogin = function (attrFilterObj, kvpPair) {
                    kvpPair.key = attrFilterObj.filterValue;
                    kvpPair.isArguments = attrFilterObj.isArguments;
                    attrFilterObj.isShow = false;
                    if ($scope.extractFiltersArrForLogin[$scope.extractFiltersArrForLogin.length - 1 ].key !== '') {
                        $scope.extractFiltersArrForLogin.push({
                            key: '',
                            isArguments: true,
                            value: ''
                        })
                    }
                };

                $scope.fnSelectExtractFilterForLogout = function (attrFilterObj, kvpPair) {
                    kvpPair.key = attrFilterObj.filterValue;
                    kvpPair.isArguments = attrFilterObj.isArguments;
                    attrFilterObj.isShow = false;
                    if ($scope.extractFiltersArrForLogout[$scope.extractFiltersArrForLogout.length - 1 ].key !== '') {
                        $scope.extractFiltersArrForLogout.push({
                            key: '',
                            isArguments: true,
                            value: ''
                        })
                    }
                };

                $scope.fnRemoveExtractFilterForLogin = function (kvpPair, $index) {
                    var isFindIndex = _.findIndex($scope.attrFilterOptionsForLogin, {filterValue: kvpPair.key});
                    if (isFindIndex !== -1) {
                        $scope.attrFilterOptionsForLogin[isFindIndex].isShow = true;
                    }
                    $scope.extractFiltersArrForLogin.splice($index, 1);
                };

                $scope.fnRemoveExtractFilterForLogout = function (kvpPair, $index) {
                    var isFindIndex = _.findIndex($scope.attrFilterOptionsForLogout, {filterValue: kvpPair.key});
                    if (isFindIndex !== -1) {
                        $scope.attrFilterOptionsForLogout[isFindIndex].isShow = true;
                    }
                    $scope.extractFiltersArrForLogout.splice($index, 1);
                };

                $scope.fnSelectMapper = function (mappingObj, type) {
                    if (type === 'login') {
                        $scope.iot3AuthenticationObj.http.actions.login.extractor.mapper = mappingObj.id;
                        $scope.isMapperSelectedForLogin = true;
                    } else {
                        $scope.iot3AuthenticationObj.http.actions.logout.extractor.mapper = mappingObj.id;
                        $scope.isMapperSelectedForLogout = true;
                    }
                };

                function getElementByXpath(path) {
                    try {
                        return document.evaluate(path, document.getElementById('workBenchSampleTest'), null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    } catch (e) {
                        amaran.error(e);
                        return null;
                    }
                }

                function convertCSVToXML(csvData) {
                    var splitter = ',';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    }
                    var csvArr = csvData.split('\n');
                    csvArr = _.map(csvArr, function (row) {
                        return row.trim();
                    });
                    var headings = csvArr[0].split(splitter);
                    var xml = '';

                    for (var i = 1; i < csvArr.length; i++) {
                        var details = csvArr[i].split(splitter);
                        xml += "<row>\n";

                        for (var j = 0; j < headings.length; j++) {
                            xml += '<item>'+ details[j] +'</item>';
                        }

                        xml += "</row>\n";
                    }
                    return xml;
                }

                function fnConvertOidToJson(oidData) {
                    var tempObj = {};
                    var oidArr = oidData.split('\n');
                    oidArr = _.map(oidArr, function (row) {
                        return row.trim();
                    });
                    _.forEach(oidArr, function (oidStr) {
                        var grp = oidStr.split(':');
                        tempObj[grp[0].trim()] = grp[1].trim();
                    });
                    return tempObj;
                }

                $scope.fnGetSampleDataFromExpressionForLogin = function () {
                    if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse($scope.sampleDataForLogin.sampleData.toString()); //eslint-disable-line
                            var selectedSampleDataForLogin = _.get(tempObj,
                                $scope.iot3AuthenticationObj.http.actions.login.selector.expression, 'notFound');
                            if (selectedSampleDataForLogin === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                $scope.isShowSampleDataForLogin = false;
                            } else {
                                $scope.selectedSampleDataForLogin = selectedSampleDataForLogin;
                                $scope.isShowSampleDataForLogin = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            $scope.isShowSampleDataForLogin = false;
                        }
                    } else if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'html' ||
                        $scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if ($scope.sampleDataForLogin.sampleData &&
                            $scope.sampleDataForLogin.sampleData.length) {
                            if ($scope.sampleDataForLogin.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith($scope.sampleDataForLogin.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForLogin.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": $scope.iot3AuthenticationObj.http.actions.login.selector.expression,
                                "document": sampleData
                            }
                        };
                        Iot3WorkbenchFactory.evaluateXpath(inputObj)
                            .then(function (response) {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                if (response) {
                                    if (response.result) {
                                        $scope.selectedSampleDataForLogin = {
                                            sampleDataVal: response.result,
                                            isCollection: angular.isArray(response.result)
                                        };
                                        $scope.isShowSampleDataForLogin = true;
                                    } else if (response.error) {
                                        amaran.error(response.error);
                                        $scope.isShowSampleDataForLogin = false;
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        $scope.isShowSampleDataForLogin = false;
                                    }
                                } else {
                                    amaran.error('Something went wrong. Please try again.');
                                    $scope.isShowSampleDataForLogin = false;
                                }
                            }, function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                amaran.error('Something went wrong. Please try again.');
                                $scope.isShowSampleDataForLogin = false;
                            });
                    } else if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML($scope.sampleDataForLogin.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainer');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if ($scope.iot3AuthenticationObj.http.actions.login.selector.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath($scope.iot3AuthenticationObj.http.actions.login.selector.expression);
                        } else {
                            if ($scope.iot3AuthenticationObj.http.actions.login.selector.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath($scope.iot3AuthenticationObj.http.actions.login.selector.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.iot3AuthenticationObj.http.actions.login.selector.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.iot3AuthenticationObj.http.actions.login.selector.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogin = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                $scope.selectedSampleDataForLogin = htmlObjForCSV.innerHTML;
                            } else {
                                $scope.selectedSampleDataForLogin = htmlObjForCSV;
                            }
                            $scope.isShowSampleDataForLogin = true;
                        }
                        tempElemForCSV.remove();
                    } else if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson($scope.sampleDataForLogin.sampleData);
                        if (oidJSon[$scope.iot3AuthenticationObj.http.actions.login.selector.expression]) {
                            $scope.selectedSampleDataForLogin = oidJSon[$scope.iot3AuthenticationObj.http.actions.login.selector.expression];
                            $scope.isShowSampleDataForLogin = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogin = false;
                        }
                    } else if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = $scope.sampleDataForLogin.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes($scope.iot3AuthenticationObj.http.actions.login.selector.expression + "=")) {
                                    var cookieStr = splitStr.split($scope.iot3AuthenticationObj.http.actions.login.selector.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    $scope.selectedSampleDataForLogin = finalVal;
                                    $scope.isShowSampleDataForLogin = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    $scope.isShowSampleDataForLogin = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogin = false;
                        }
                    } else if ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = $scope.sampleDataForLogin.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith($scope.iot3AuthenticationObj.http.actions.login.selector.expression + ':')) {
                                HeaderFlag = false;
                                $scope.selectedSampleDataForLogin = splitStr.split($scope.iot3AuthenticationObj.http.actions.login.selector.expression + ':')[1];
                                $scope.isShowSampleDataForLogin = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogin = false;
                        }
                    } else {
                        $scope.isShowSampleDataForLogin = false;
                    }
                };

                $scope.fnGetSampleDataFromExpressionForLogout = function () {
                    if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse($scope.sampleDataForLogout.sampleData.toString()); //eslint-disable-line
                            var selectedSampleDataForLogout = _.get(tempObj,
                                $scope.iot3AuthenticationObj.http.actions.logout.selector.expression, 'notFound');
                            if (selectedSampleDataForLogout === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                $scope.isShowSampleDataForLogout = false;
                            } else {
                                $scope.selectedSampleDataForLogout = selectedSampleDataForLogout;
                                $scope.isShowSampleDataForLogout = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            $scope.isShowSampleDataForLogout = false;
                        }
                    } else if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'html' ||
                        $scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if ($scope.sampleDataForLogout.sampleData &&
                            $scope.sampleDataForLogout.sampleData.length) {
                            if ($scope.sampleDataForLogout.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith($scope.sampleDataForLogout.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForLogout.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": $scope.iot3AuthenticationObj.http.actions.logout.selector.expression,
                                "document": sampleData
                            }
                        };
                        Iot3WorkbenchFactory.evaluateXpath(inputObj)
                            .then(function (response) {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                if (response) {
                                    if (response.result) {
                                        $scope.selectedSampleDataForLogout = {
                                            sampleDataVal: response.result,
                                            isCollection: angular.isArray(response.result)
                                        };
                                        $scope.isShowSampleDataForLogout = true;
                                    } else if (response.error) {
                                        amaran.error(response.error);
                                        $scope.isShowSampleDataForLogout = false;
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        $scope.isShowSampleDataForLogout = false;
                                    }
                                } else {
                                    amaran.error('Something went wrong. Please try again.');
                                    $scope.isShowSampleDataForLogout = false;
                                }
                            }, function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                amaran.error('Something went wrong. Please try again.');
                                $scope.isShowSampleDataForLogout = false;
                            });
                    } else if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML($scope.sampleDataForLogout.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainer');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if ($scope.iot3AuthenticationObj.http.actions.logout.selector.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath($scope.iot3AuthenticationObj.http.actions.logout.selector.expression);
                        } else {
                            if ($scope.iot3AuthenticationObj.http.actions.logout.selector.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath($scope.iot3AuthenticationObj.http.actions.logout.selector.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.iot3AuthenticationObj.http.actions.logout.selector.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.iot3AuthenticationObj.http.actions.logout.selector.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogout = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                $scope.selectedSampleDataForLogout = htmlObjForCSV.innerHTML;
                            } else {
                                $scope.selectedSampleDataForLogout = htmlObjForCSV;
                            }
                            $scope.isShowSampleDataForLogout = true;
                        }
                        tempElemForCSV.remove();
                    } else if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson($scope.sampleDataForLogout.sampleData);
                        if (oidJSon[$scope.iot3AuthenticationObj.http.actions.logout.selector.expression]) {
                            $scope.selectedSampleDataForLogout = oidJSon[$scope.iot3AuthenticationObj.http.actions.logout.selector.expression];
                            $scope.isShowSampleDataForLogout = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogout = false;
                        }
                    } else if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = $scope.sampleDataForLogout.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes($scope.iot3AuthenticationObj.http.actions.logout.selector.expression + "=")) {
                                    var cookieStr = splitStr.split($scope.iot3AuthenticationObj.http.actions.logout.selector.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    $scope.selectedSampleDataForLogout = finalVal;
                                    $scope.isShowSampleDataForLogout = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    $scope.isShowSampleDataForLogout = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogout = false;
                        }
                    } else if ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = $scope.sampleDataForLogout.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith($scope.iot3AuthenticationObj.http.actions.logout.selector.expression + ':')) {
                                HeaderFlag = false;
                                $scope.selectedSampleDataForLogout = splitStr.split($scope.iot3AuthenticationObj.http.actions.logout.selector.expression + ':')[1];
                                $scope.isShowSampleDataForLogout = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleDataForLogout = false;
                        }
                    } else {
                        $scope.isShowSampleDataForLogout = false;
                    }
                };

                $scope.fnOpenSampleDataModal = function (type) {
                    var sampleData = '';
                    if (type === 'login') {
                        if ($scope.sampleDataForLogin.sampleDataType &&
                            ($scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'html' ||
                                $scope.sampleDataForLogin.sampleDataType.toLowerCase() === 'xml')) {
                            if ($scope.sampleDataForLogin.sampleData && $scope.sampleDataForLogin.sampleData.length) {
                                if ($scope.sampleDataForLogin.sampleData.includes("</")) {
                                    sampleData = _.cloneDeepWith($scope.sampleDataForLogin.sampleData);
                                } else {
                                    sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForLogin.sampleData)))
                                }
                            }
                        } else {
                            sampleData = _.cloneDeepWith($scope.sampleDataForLogin.sampleData)
                        }
                    } else {
                        if ($scope.sampleDataForLogout.sampleDataType &&
                            ($scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'html' ||
                                $scope.sampleDataForLogout.sampleDataType.toLowerCase() === 'xml')) {
                            if ($scope.sampleDataForLogout.sampleData && $scope.sampleDataForLogout.sampleData.length) {
                                if ($scope.sampleDataForLogout.sampleData.includes("</")) {
                                    sampleData = _.cloneDeepWith($scope.sampleDataForLogout.sampleData);
                                } else {
                                    sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForLogout.sampleData)))
                                }
                            }
                        } else {
                            sampleData = _.cloneDeepWith($scope.sampleDataForLogout.sampleData)
                        }
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/sampleDataModal/sampleDataModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'sampleDataModalCtrl as sampleDataModal',
                        resolve: {
                            sampleDataObj: function () {
                                return {
                                    type: type === 'login' ? $scope.sampleDataForLogin.sampleDataType : $scope.sampleDataForLogout.sampleDataType,
                                    value: type === sampleData
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        })
                    }, function () {
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        })
                    });
                };

                $scope.fnSelectSelectorPathOptions = function (selectorValue, type) {
                    if (type === 'login') {
                        $scope.loginSelectorType = selectorValue;
                    } else {
                        $scope.logoutSelectorType = selectorValue;
                    }
                };

                $scope.fnGlobalKeySelectedForDataSource = function (item, model, label, event, dataSourceKey, type) {
                    if (type === 'login') {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.iot3AuthenticationObj.http.actions.login.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.iot3AuthenticationObj.http.actions.login.dataSource = '%{' + dataSourceKey.name;
                        }
                    } else {
                        if ($scope.oldValueKeyForDataSource.includes('.')) {
                            $scope.iot3AuthenticationObj.http.actions.logout.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                        } else {
                            $scope.iot3AuthenticationObj.http.actions.logout.dataSource = '%{' + dataSourceKey.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDataSource = function (dataSourceKey) {
                    $scope.globalKeyOptionsForDataSource = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        $scope.oldValueKeyForDataSource = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    $scope.globalKeyOptionsForDataSource.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                $scope.globalKeyOptionsForDataSource.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnGetTypeSampleData = function (type) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if (type === 'login') {
                            if ($scope.iot3AuthenticationObj &&
                                $scope.iot3AuthenticationObj.http &&
                                $scope.iot3AuthenticationObj.http.actions.login &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSource &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSource.length &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSource.startsWith('%{') &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSource.endsWith('}') &&
                                workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                                var engineTrail = $scope.iot3AuthenticationObj.http.actions.login.dataSource.substr(2, $scope.iot3AuthenticationObj.http.actions.login.dataSource.lastIndexOf('}') - 2);
                                var requestName = engineTrail.split('.');
                                var value = _.get(workbench.currentWorkspaceEngineSampleData, requestName[requestName.length - 1], 'notFound');

                                if (value !== 'notFound' && value.constructor.name === 'Object' &&
                                    (value.sampleData && value.sampleData !== '')) {
                                    $scope.sampleDataForLogin = value;
                                    $scope.loginSelectorType = $scope.selectorPathOptions[value.sampleDataType];
                                } else {
                                    $scope.fnResetSampleData();
                                }
                            } else {
                                $scope.fnResetSampleData();
                            }
                        } else {
                            if ($scope.iot3AuthenticationObj &&
                                $scope.iot3AuthenticationObj.http &&
                                $scope.iot3AuthenticationObj.http.actions.logout &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSource &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSource.length &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSource.startsWith('%{') &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSource.endsWith('}') &&
                                workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                                var engineTrailForLogout = $scope.iot3AuthenticationObj.http.actions.logout.dataSource.substr(2, $scope.iot3AuthenticationObj.http.actions.logout.dataSource.lastIndexOf('}') - 2);
                                var requestNameForLogout = engineTrailForLogout.split('.');
                                var valueForLogout = _.get(workbench.currentWorkspaceEngineSampleData, requestNameForLogout[requestNameForLogout.length - 1], 'notFound');

                                if (valueForLogout !== 'notFound' && valueForLogout.constructor.name === 'Object' &&
                                    (valueForLogout.sampleData && valueForLogout.sampleData !== '')) {
                                    $scope.sampleDataForLogout = valueForLogout;
                                    $scope.logoutSelectorType = $scope.selectorPathOptions[valueForLogout.sampleDataType];
                                } else {
                                    $scope.fnResetSampleDataForLogout();
                                }
                            } else {
                                $scope.fnResetSampleDataForLogout();
                            }
                        }
                    } else {
                        if (type === 'login') {
                            $scope.fnResetSampleData();
                        } else {
                            $scope.fnResetSampleDataForLogout();
                        }
                    }
                };

                $scope.fnResetSampleData = function () {
                    $scope.sampleDataForLogin = {};
                    $scope.selectedSampleDataForLogin = '';
                    $scope.manipulatedSampleDataForLogin = '';
                    $scope.isShowSampleDataForLogin = false;

                    if ($scope.iot3AuthenticationObj &&
                        $scope.iot3AuthenticationObj.http &&
                        $scope.iot3AuthenticationObj.http.actions &&
                        $scope.iot3AuthenticationObj.http.actions.login &&
                        $scope.iot3AuthenticationObj.http.actions.login.selector &&
                        $scope.iot3AuthenticationObj.http.actions.login.selector.type &&
                        $scope.iot3AuthenticationObj.http.actions.login.selector.type.length) {
                        $scope.loginSelectorType = $scope.iot3AuthenticationObj.http.actions.login.selector.type;
                    } else {
                        $scope.loginSelectorType = $scope.selectorPathOptions.HTML;
                    }
                };

                $scope.fnResetSampleDataForLogout = function () {
                    $scope.sampleDataForLogout = {};
                    $scope.selectedSampleDataForLogout = '';
                    $scope.manipulatedSampleDataForLogout = '';
                    $scope.isShowSampleDataForLogin = false;

                    if ($scope.iot3AuthenticationObj &&
                        $scope.iot3AuthenticationObj.http &&
                        $scope.iot3AuthenticationObj.http.actions &&
                        $scope.iot3AuthenticationObj.http.actions.logout &&
                        $scope.iot3AuthenticationObj.http.actions.logout.selector &&
                        $scope.iot3AuthenticationObj.http.actions.logout.selector.type &&
                        $scope.iot3AuthenticationObj.http.actions.logout.selector.type.length) {
                        $scope.logoutSelectorType = $scope.iot3AuthenticationObj.http.actions.logout.selector.type;
                    } else {
                        $scope.logoutSelectorType = $scope.selectorPathOptions.HTML;
                    }
                };

                $scope.fnSelectAuthenticationType = function (type) {
                    $scope.iot3AuthenticationObj.authenticationType = type;
                    if (type === 'snmp') {
                        delete $scope.iot3AuthenticationObj.http;
                        if ($scope.iot3AuthenticationObj.snmp && $scope.iot3AuthenticationObj.snmp.credentials &&
                            Object.keys($scope.iot3AuthenticationObj.snmp.credentials).length) {
                            if (angular.isUndefined($scope.iot3AuthenticationObj.snmp.version)) {
                                $scope.iot3AuthenticationObj.snmp.version = ''
                            }
                            $scope.iot3AuthenticationObj.snmp.credentialsArr = [];
                            Object.keys($scope.iot3AuthenticationObj.snmp.credentials).forEach(function (key) {
                                $scope.iot3AuthenticationObj.snmp.credentialsArr.push({
                                    key: key,
                                    value: $scope.iot3AuthenticationObj.snmp.credentials[key]
                                })
                            });
                            $scope.iot3AuthenticationObj.snmp.credentialsArr.push({
                                key: '',
                                value:''
                            })
                        } else {
                            $scope.iot3AuthenticationObj.snmp = {};
                            $scope.iot3AuthenticationObj.snmp.version = '';
                            $scope.iot3AuthenticationObj.snmp.credentials = {};
                            $scope.iot3AuthenticationObj.snmp.credentialsArr = [{
                                key: '',
                                value: ''
                            }]
                        }
                    } else if (type === 'http') {
                        delete $scope.iot3AuthenticationObj.snmp;
                        $scope.iot3AuthenticationObj.http = _.cloneDeepWith($scope.resetHttpAuthenticationObj);
                    }
                };

                $scope.fnRemoveSupplementalForCredential = function (index, credentialsArr) {
                    credentialsArr.splice(index, 1);
                };

                $scope.fnKeySelectedForAutoFill = function (item, model, label, event, kvpPair, type) {
                    if (type === 'key') {
                        if (kvpPair.oldValueKey.includes('.')) {
                            kvpPair.key = kvpPair.oldValueKey.substr(0, kvpPair.oldValueKey.lastIndexOf('.')) + '.' + kvpPair.key.name;
                        } else {
                            kvpPair.key = '${' + kvpPair.key.name;
                        }
                    } else if (type === 'value') {
                        if (kvpPair.oldValue.includes('.')) {
                            kvpPair.value = kvpPair.oldValue.substr(0, kvpPair.oldValue.lastIndexOf('.')) + '.' + kvpPair.value.name;
                        } else {
                            kvpPair.value = '${' + kvpPair.value.name;
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForCredentials = function (kvpPairObj, index, credentialsArr, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach(credentialsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    kvpPairObj.isKeyDuplicated = count > 1;
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === credentialsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && credentialsArr[credentialsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (credentialsArr.length > 1) {
                                    angular.forEach(credentialsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    credentialsArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnGetExtractorFiltersForLogin = function () {
                    if ($scope.iot3AuthenticationObj && $scope.iot3AuthenticationObj.http &&
                        $scope.iot3AuthenticationObj.http.actions &&
                        $scope.iot3AuthenticationObj.http.actions.login &&
                        $scope.iot3AuthenticationObj.http.actions.login.extractor &&
                        $scope.iot3AuthenticationObj.http.actions.login.extractor.filters) {
                        var tempArr = [];
                        if (angular.isArray($scope.iot3AuthenticationObj.http.actions.login.extractor.filters)) {
                            if ($scope.iot3AuthenticationObj.http.actions.login.extractor.filters.length) {
                                _.forEach($scope.iot3AuthenticationObj.http.actions.login.extractor.filters, function (filterValue) {
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForLogin, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForLogin[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForLogin[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    })
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArrForLogin = tempArr;
                            } else {
                                $scope.extractFiltersArrForLogin = _.cloneDeepWith($scope.resetExtractFiltersArrForLogin);
                            }
                        } else {
                            if (Object.keys($scope.iot3AuthenticationObj.http.actions.login.extractor.filters).length) {
                                Object.keys($scope.iot3AuthenticationObj.http.actions.login.extractor.filters).forEach(function (filterKey) {
                                    var filterValue = $scope.iot3AuthenticationObj.http.actions.login.extractor.filters[filterKey];
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForLogin, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForLogin[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForLogin[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    })
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArrForLogin = tempArr;
                            } else {
                                $scope.extractFiltersArrForLogin = _.cloneDeepWith($scope.resetExtractFiltersArrForLogin);
                            }
                        }
                    } else {
                        if ($scope.iot3AuthenticationObj.http.actions.login.extractor) {
                            $scope.iot3AuthenticationObj.http.actions.login.extractor.filters = {};
                        } else {
                            $scope.iot3AuthenticationObj.http.actions.login.extractor = {
                                filters: {}
                            };
                        }
                        $scope.extractFiltersArrForLogin = _.cloneDeepWith($scope.resetExtractFiltersArrForLogin);
                    }
                };

                $scope.fnGetExtractorFiltersForLogout = function () {
                    if ($scope.iot3AuthenticationObj && $scope.iot3AuthenticationObj.http &&
                        $scope.iot3AuthenticationObj.http.actions &&
                        $scope.iot3AuthenticationObj.http.actions.logout &&
                        $scope.iot3AuthenticationObj.http.actions.logout.extractor &&
                        $scope.iot3AuthenticationObj.http.actions.logout.extractor.filters) {
                        var tempArr = [];
                        if (angular.isArray($scope.iot3AuthenticationObj.http.actions.logout.extractor.filters)) {
                            if ($scope.iot3AuthenticationObj.http.actions.logout.extractor.filters.length) {
                                _.forEach($scope.iot3AuthenticationObj.http.actions.logout.extractor.filters, function (filterValue) {
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForLogout, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForLogout[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForLogout[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    })
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArrForLogout = tempArr;
                            } else {
                                $scope.extractFiltersArrForLogout = _.cloneDeepWith($scope.resetExtractFiltersArrForLogout);
                            }
                        } else {
                            if (Object.keys($scope.iot3AuthenticationObj.http.actions.logout.extractor.filters).length) {
                                Object.keys($scope.iot3AuthenticationObj.http.actions.logout.extractor.filters).forEach(function (filterKey) {
                                    var filterValue = $scope.iot3AuthenticationObj.http.actions.logout.extractor.filters[filterKey];
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptionsForLogout, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptionsForLogout[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptionsForLogout[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    });
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArrForLogout = tempArr;
                            } else {
                                $scope.extractFiltersArrForLogout = _.cloneDeepWith($scope.resetExtractFiltersArrForLogout);
                            }
                        }
                    } else {
                        if ($scope.iot3AuthenticationObj.http.actions.logout.extractor) {
                            $scope.iot3AuthenticationObj.http.actions.logout.extractor.filters = {};
                        } else {
                            $scope.iot3AuthenticationObj.http.actions.logout.extractor = {
                                filters: {}
                            };
                        }
                        $scope.extractFiltersArrForLogout = _.cloneDeepWith($scope.resetExtractFiltersArrForLogout);
                    }
                };

                $scope.fnInitAuthenticationTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    if ($scope.iot3AuthenticationObj && Object.keys($scope.iot3AuthenticationObj).length) {
                        if ($scope.iot3AuthenticationObj.http) {
                            delete $scope.iot3AuthenticationObj.snmp;
                            $scope.fnGetExtractorFiltersForLogin();
                            $scope.fnGetExtractorFiltersForLogout();
                            $scope.fnGetTypeSampleData('login');
                            $scope.fnGetTypeSampleData('logout');
                            $scope.iot3AuthenticationObj.authenticationType = 'http';
                        } else if ($scope.iot3AuthenticationObj.snmp) {
                            delete $scope.iot3AuthenticationObj.http;
                            $scope.iot3AuthenticationObj.authenticationType = 'snmp';
                            if ($scope.iot3AuthenticationObj.snmp &&
                                $scope.iot3AuthenticationObj.snmp.credentials &&
                                Object.keys($scope.iot3AuthenticationObj.snmp.credentials).length) {
                                if (angular.isUndefined($scope.iot3AuthenticationObj.snmp.version)) {
                                    $scope.iot3AuthenticationObj.snmp.version = '';
                                }
                                $scope.iot3AuthenticationObj.snmp.credentialsArr = [];
                                Object.keys($scope.iot3AuthenticationObj.snmp.credentials).forEach(function (key) {
                                    $scope.iot3AuthenticationObj.snmp.credentialsArr.push({
                                        key: key,
                                        value: $scope.iot3AuthenticationObj.snmp.credentials[key]
                                    })
                                });
                                $scope.iot3AuthenticationObj.snmp.credentialsArr.push({
                                    key: '',
                                    value:''
                                })
                            } else {
                                $scope.iot3AuthenticationObj.snmp = {};
                                if (angular.isUndefined($scope.iot3AuthenticationObj.snmp.version)) {
                                    $scope.iot3AuthenticationObj.snmp.version = '';
                                }
                                $scope.iot3AuthenticationObj.snmp.credentials = {};
                                $scope.iot3AuthenticationObj.snmp.credentialsArr = [{
                                    key: '',
                                    value: ''
                                }]
                            }
                        } else {
                            $scope.iot3AuthenticationObj.authenticationType = 'http';
                            $scope.iot3AuthenticationObj.http = _.cloneDeepWith($scope.resetHttpAuthenticationObj);
                        }
                    } else {
                        $scope.iot3AuthenticationObj = {
                            authenticationType: 'http',
                            http: _.cloneDeepWith($scope.resetHttpAuthenticationObj)
                        }
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitAuthenticationTab();

                $scope.fnUpdateAuthenticationDetails = function () {
                    if ($scope.iot3AuthenticationObj.authenticationType === 'http') {
                        delete $scope.iot3AuthenticationObj.snmp;
                        if ($scope.iot3AuthenticationObj.http && $scope.iot3AuthenticationObj.http.actions) {
                            /*if ($scope.iot3AuthenticationObj.http.actions.login &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSink &&
                                $scope.iot3AuthenticationObj.http.actions.login.dataSink.length) {
                                $scope.fnUpdateGlobalFromAttr({valueObj: {key: $scope.iot3AuthenticationObj.http.actions.login.dataSink, value: ''}})
                            }*/

                            /*if ($scope.iot3AuthenticationObj.http.actions.logout &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSink &&
                                $scope.iot3AuthenticationObj.http.actions.logout.dataSink.length) {
                                $scope.fnUpdateGlobalFromAttr({valueObj: {key: $scope.iot3AuthenticationObj.http.actions.logout.dataSink, value: ''}})
                            }*/
                        }

                        $scope.iot3AuthenticationObj.http.actions.login.selector.type = $scope.loginSelectorType;
                        $scope.iot3AuthenticationObj.http.actions.logout.selector.type = $scope.logoutSelectorType;

                        var tempExtractorObjForLogin = {};
                        _.forEach($scope.extractFiltersArrForLogin, function (extractorObj, index) {
                            if (extractorObj.key && extractorObj.key.length) {
                                tempExtractorObjForLogin[index] = extractorObj.key + " " + extractorObj.value;
                            }
                        });

                        $scope.iot3AuthenticationObj.http.actions.login.extractor.filters = tempExtractorObjForLogin;

                        var tempExtractorObjForLogout = {};
                        _.forEach($scope.extractFiltersArrForLogout, function (extractorObj, index) {
                            if (extractorObj.key && extractorObj.key.length) {
                                tempExtractorObjForLogout[index] = extractorObj.key + " " + extractorObj.value;
                            }
                        });

                        $scope.iot3AuthenticationObj.http.actions.logout.extractor.filters = tempExtractorObjForLogout;

                    } else if ($scope.iot3AuthenticationObj.authenticationType === 'snmp') {
                        delete $scope.iot3AuthenticationObj.http;
                        $scope.iot3AuthenticationObj.snmp.credentials = {};
                        _.forEach($scope.iot3AuthenticationObj.snmp.credentialsArr, function (credentialObj) {
                            if (!credentialObj.isKeyDuplicated && credentialObj.key && credentialObj.key.length) {
                                $scope.iot3AuthenticationObj.snmp.credentials[credentialObj.key] = credentialObj.value;
                            }
                        });
                        delete $scope.iot3AuthenticationObj.snmp.credentialsArr;
                    }
                    delete $scope.iot3AuthenticationObj.authenticationType;
                    $scope.fnUpdateWorkbench({updateType: 'authentication', updateValue: $scope.iot3AuthenticationObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnUpdateAuthenticationDetails();
                });

                $window.onbeforeunload = function() {
                    $scope.fnUpdateAuthenticationDetails();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3Attributes', fnIot3Attributes)

    /** @ngInject */
    function fnIot3Attributes($rootScope, $timeout, $window, $uibModal, amaran, swal, $cookies, $http, $base64, DB,
                              TypeFormService, microSpinner, Iot3WorkbenchFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Workbench/steps/attributes/attributes.html',
            scope: {
                currentWorkspace: "=",
                typesObj: "=",
                iot3JsonObj: "=",
                attributesObj: "=",
                mappingsObj: "=",
                sideActiveTabIndex: "=",
                fnUpdateGlobalFromAttr: "&",
                fnUpdateWorkbench: "&",
                fnInitiateResetWorkspace: '&'
            },
            link: function ($scope) {

                /*START: Overview Tab*/
                $scope.attributesTabs = [{
                    title: 'Overview',
                    tabIndex: 1
                }];
                $scope.activeTabIndex = $scope.attributesTabs[0].tabIndex;
                $scope.attributesArr = [];
                $scope.filter = "$";
                $scope.attrSearch = {$: ''};
                $scope.selectorValueOption = {
                    String: 'text',
                    Int32: 'number',
                    Int64: 'number',
                    Float: 'number',
                    Binary: 'number',
                    Bool: 'text',
                    Date: 'date',
                    Time: 'time',
                    DateTime: 'datetime',
                    Button: 'button'
                };
                /*END: Overview Tab*/

                $scope.selectedDetailSubTabIndex = 1;

                /*START: Form Tab Variables*/
                $scope.fieldArrForForm = [
                    {
                        name: 'Text Field',
                        icon: 'fa-terminal'
                    }, {
                        name: 'Text Area',
                        icon: 'fa-font'
                    }, {
                        name: 'Checkbox',
                        icon: 'fa-check-square'
                    }, {
                        name: 'Select',
                        icon: 'fa-th-list'
                    }, {
                        name: 'Number',
                        icon: 'fa-hashtag'
                    }, {
                        name: 'Password',
                        icon: 'fa-asterisk'
                    }, {
                        name: 'Panel',
                        icon: 'fa-list-alt'
                    }, {
                        name: 'Label',
                        icon: 'fa-tag'
                    }
                ];
                $scope.formModel = {};
                $scope.formArrForForm = [];
                $scope.formBuilderInput = [];
                $scope.formSchema = {
                    $schema: "http://json-schema.org/draft-07/schema#",
                    type: "object",
                    properties: {}
                };
                /*END: Form Tab Variables*/

                $scope.conditionTypes = [{
                    key: '=='
                }, {
                    key: '!=='
                }, {
                    key: '>'
                }, {
                    key: '>='
                }, {
                    key: '<'
                }, {
                    key: '<='
                }, {
                    key: '~='
                }];

                $scope.selectedRequire = {
                    value: ''
                };

                $scope.selectorPathOptions = {
                    'JSON': 'gjson',
                    'XML': 'xpath',
                    'HTML': 'xpath',
                    'CSV': 'xpath',
                    'OID': 'oid',
                    'Cookie': 'cookie',
                    'Header': 'header'
                };

                $scope.attrSelectorPathOptions = [
                    "xpath",
                    "xslt",
                    "oid",
                    "gjson",
                    "cookie",
                    "header"
                ];

                $scope.selectedSampleData = '';
                $scope.manipulatedSampleData = '';
                $scope.mappingsArr = [];
                $scope.extractFiltersArr = [{
                    key: '',
                    value: ''
                }];
                $scope.resetExtractFiltersArr = _.cloneDeepWith($scope.extractFiltersArr);
                $scope.isMapperSelected = false;
                $scope.attrFilterOptions = [{
                    "filterValue": "concat",
                    "displayValue": "Concat",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mapper",
                    "displayValue": "Mapper",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatDate",
                    "displayValue": "Format Date",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatInt",
                    "displayValue": "Format Int",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "formatFloat",
                    "displayValue": "Format Float",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "prefix",
                    "displayValue": "Prefix",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "regexpReplace",
                    "displayValue": "Regex Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replace",
                    "displayValue": "Replace",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "replacer",
                    "displayValue": "Replacer",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "switch",
                    "displayValue": "Switch",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trim",
                    "displayValue": "Trim",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "trimSpace",
                    "displayValue": "Trim Space",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toLower",
                    "displayValue": "To Lower",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toUpper",
                    "displayValue": "To Upper",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toTitle",
                    "displayValue": "To Title",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "toHex",
                    "displayValue": "To Hex",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "tokenizeUrl",
                    "displayValue": "Tokenize Url",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "unescape",
                    "displayValue": "Unescape",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "Use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "version",
                    "displayValue": "Version",
                    "isArguments": false,
                    "isShow": true
                }, {
                    "filterValue": "wrap",
                    "displayValue": "Wrap",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "add",
                    "displayValue": "Add",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "sub",
                    "displayValue": "Sub",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "mul",
                    "displayValue": "Mul",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "div",
                    "displayValue": "Div",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "use",
                    "displayValue": "use",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "RegExract",
                    "displayValue": "RegExract",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "xpath",
                    "displayValue": "xpath",
                    "isArguments": true,
                    "isShow": true
                }, {
                    "filterValue": "split",
                    "displayValue": "split",
                    "isArguments": true,
                    "isShow": true
                }];
                $scope.resetAttrFilterOptions = _.cloneDeepWith($scope.attrFilterOptions);

                $scope.sampleDataForSelectedAttr = {};
                $scope.selectedSampleData = '';
                $scope.manipulatedSampleData = '';
                $scope.selectedAttrSelectorType = '';
                $scope.isShowSampleData = false;

                $scope.attrOptions = [];

                $scope.writeButtonLabelObj = {
                    labelVal: ''
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;

                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + dashboardHeader + 35);
                        angular.element("#attributesMainContainer").css('height', finalHeight + 'px');

                        var search = angular.isDefined(angular.element(".searchContainer")[0]) ? angular.element(".searchContainer")[0].offsetHeight : 0;
                        var tableHead = angular.isDefined(angular.element(".attrsTemplate-table thead")[0]) ? angular.element(".attrsTemplate-table thead")[0].offsetHeight : 0;

                        angular.element("#attrMainContainerDetail").css('height', finalHeight + 30 + 'px');
                        angular.element("#attributeTable").css('height', (finalHeight - search - tableHead) + 'px');

                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        // var footer = 36; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        angular.element(".tabContent").css('height', finalHeight - (tabHeader + 5) + 'px');
                        angular.element("#attrMainContainerDetail .tabContent").css('height', (finalHeight + 35) - (tabHeader + 5) + 'px');
                    }
                };

                $scope.fnSelectSelectorPathOptions = function (selectorValue) {
                    //$scope.selectedAttributeObj.attributes.selector.type = selectorValue;
                    $scope.selectedAttrSelectorType = selectorValue;
                };

                $scope.fnSelectExtractFilter = function (attrFilterObj, kvpPair) {
                    kvpPair.key = attrFilterObj.filterValue;
                    kvpPair.isArguments = attrFilterObj.isArguments;
                    //attrFilterObj.isShow = false;
                    if ($scope.extractFiltersArr[$scope.extractFiltersArr.length - 1 ].key !== '') {
                        $scope.extractFiltersArr.push({
                            key: '',
                            isArguments: true,
                            value: ''
                        })
                    }
                };

                $scope.fnRemoveExtractFilter = function (kvpPair, $index) {
                    var isFindIndex = _.findIndex($scope.attrFilterOptions, {filterValue: kvpPair.key});
                    if (isFindIndex !== -1) {
                        $scope.attrFilterOptions[isFindIndex].isShow = true;
                    }
                    $scope.extractFiltersArr.splice($index, 1);
                };

                $scope.fnSelectMapper = function (mappingObj) {
                    $scope.selectedAttributeObj.attributes.extractor.mapper = mappingObj.id;
                    $scope.isMapperSelected = true;
                };

                $scope.fnRemoveRequire = function (index) {
                    $scope.selectedAttributeObj.attributes.requires.splice(index, 1);
                };

                $scope.fnAddRequires = function (requireValue) {
                    if (!$scope.selectedAttributeObj.attributes.requires) {
                        $scope.selectedAttributeObj.attributes.requires = [];
                    }
                    $scope.selectedAttributeObj.attributes.requires.push(requireValue);
                    $scope.selectedRequire.value = '';
                };

                $scope.fnSelectConditionOperator = function (kvpPair, conditionTypeObj) {
                    kvpPair.operator = conditionTypeObj.key;
                };

                $scope.fnGlobalKeySelected = function (item, model, label, event, kvpPair, type) {
                    if (type === 'key') {
                        if (kvpPair.oldValueKey.includes('.')) {
                            kvpPair.key = kvpPair.oldValueKey.substr(0, kvpPair.oldValueKey.lastIndexOf('.')) + '.' + kvpPair.key.name;
                        } else {
                            kvpPair.key = '${' + kvpPair.key.name;
                        }
                    } else if (type === 'value') {
                        if (kvpPair.oldValue.includes('.')) {
                            kvpPair.value = kvpPair.oldValue.substr(0, kvpPair.oldValue.lastIndexOf('.')) + '.' + kvpPair.value.name;
                        } else {
                            kvpPair.value = '${' + kvpPair.value.name;
                        }
                    }
                };

                $scope.fnGlobalKeySelectedForDataSource = function (item, model, label, event, dataSourceKey) {
                    if ($scope.oldValueKeyForDataSource.includes('.')) {
                        $scope.selectedAttributeObj.attributes.dataSource = $scope.oldValueKeyForDataSource.substr(0, $scope.oldValueKeyForDataSource.lastIndexOf('.')) + '.' + dataSourceKey.name;
                    } else {
                        $scope.selectedAttributeObj.attributes.dataSource = '%{' + dataSourceKey.name;
                    }
                };

                $scope.fnCheckUniqueKey = function (kvpPairObj, index, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach($scope.selectedAttributeObj.readConditionsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicated = true;
                        $scope.duplicatedIndex = index;
                    } else {
                        $scope.isKeyDuplicated = false;
                        $scope.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.selectedAttributeObj.readConditionsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.selectedAttributeObj.readConditionsArr[$scope.selectedAttributeObj.readConditionsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.selectedAttributeObj.readConditionsArr.length > 1) {
                                    angular.forEach($scope.selectedAttributeObj.readConditionsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.selectedAttributeObj.readConditionsArr.push({
                                        key: '',
                                        value: '',
                                        operator: '=='
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDataSource = function (dataSourceKey) {
                    $scope.globalKeyOptionsForDataSource = [];
                    if (dataSourceKey &&
                        dataSourceKey.startsWith('%{') && !dataSourceKey.endsWith('}')) {
                        $scope.oldValueKeyForDataSource = dataSourceKey;
                        var keys = [];
                        if (dataSourceKey.includes('.')) {
                            var trail = dataSourceKey.substr(2, dataSourceKey.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    $scope.globalKeyOptionsForDataSource.push({
                                        key: '%{' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                $scope.globalKeyOptionsForDataSource.push({
                                    key: '%{' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForDelete = function (kvpPairObj, index, type) {
                    kvpPairObj.globalKeyOptions = [];
                    if (type === 'key' && kvpPairObj.key &&
                        kvpPairObj.key.startsWith('${') && !kvpPairObj.key.endsWith('}')) {
                        kvpPairObj.oldValueKey = kvpPairObj.key;
                        var keys = [];
                        if (kvpPairObj.key.includes('.')) {
                            var trail = kvpPairObj.key.substr(2, kvpPairObj.key.lastIndexOf('.') - 2);
                            var value = _.get($scope.iot3JsonObj, trail, 'notFound');
                            if (value.constructor.name === 'Object') {
                                keys = Object.keys(value);
                                _.forEach(keys, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trail + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keys = Object.keys($scope.iot3JsonObj);
                            _.forEach(keys, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    } else if (type === 'value' && kvpPairObj.value &&
                        kvpPairObj.value.startsWith('${') && !kvpPairObj.value.endsWith('}')) {
                        kvpPairObj.oldValue = kvpPairObj.value;
                        var keysVal = [];
                        if (kvpPairObj.value.includes('.')) {
                            var trailVal = kvpPairObj.value.substr(2, kvpPairObj.value.lastIndexOf('.') - 2);
                            var value1 = _.get($scope.iot3JsonObj, trailVal, 'notFound');
                            if (value1.constructor.name === 'Object') {
                                keysVal = Object.keys(value1);
                                _.forEach(keysVal, function (keyName) {
                                    kvpPairObj.globalKeyOptions.push({
                                        key: '${' + trailVal + '.' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        } else {
                            keysVal = Object.keys($scope.iot3JsonObj);
                            _.forEach(keysVal, function (keyName) {
                                kvpPairObj.globalKeyOptions.push({
                                    key: '${' + keyName,
                                    name: keyName
                                })
                            });
                        }
                    }
                    var count = 0;
                    angular.forEach($scope.selectedAttributeObj.deleteConditionsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isDeleteKeyDuplicated = true;
                        $scope.deleteDuplicatedIndex = index;
                    } else {
                        $scope.isDeleteKeyDuplicated = false;
                        $scope.deleteDuplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.selectedAttributeObj.deleteConditionsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.selectedAttributeObj.deleteConditionsArr[$scope.selectedAttributeObj.deleteConditionsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.selectedAttributeObj.deleteConditionsArr.length > 1) {
                                    angular.forEach($scope.selectedAttributeObj.deleteConditionsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.selectedAttributeObj.deleteConditionsArr.push({
                                        key: '',
                                        value: '',
                                        operator: '=='
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnCheckUniqueKeyForReadInstruction = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach($scope.selectedAttributeObj.properties.read.instructionsArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        $scope.isKeyDuplicatedForReadInstruction = true;
                        $scope.duplicatedIndexForReadInstruction = index;
                    } else {
                        $scope.isKeyDuplicatedForReadInstruction = false;
                        $scope.duplicatedIndexForReadInstruction = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === $scope.selectedAttributeObj.properties.read.instructionsArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && $scope.selectedAttributeObj.properties.read.instructionsArr[$scope.selectedAttributeObj.properties.read.instructionsArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if ($scope.selectedAttributeObj.properties.read.instructionsArr.length > 1) {
                                    angular.forEach($scope.selectedAttributeObj.properties.read.instructionsArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    $scope.selectedAttributeObj.properties.read.instructionsArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                $scope.fnRemoveSupplemental = function (index) {
                    $scope.selectedAttributeObj.readConditionsArr.splice(index, 1);
                };

                $scope.fnRemoveSupplementalForDelete = function (index) {
                    $scope.selectedAttributeObj.deleteConditionsArr.splice(index, 1);
                };

                $scope.fnRemoveSupplementalForReadInstruction = function (index) {
                    $scope.selectedAttributeObj.properties.read.instructionsArr.splice(index, 1);
                };

                $scope.fnOnActionDrop = function (srcList, srcIndex, schemaType) {
                    if (srcIndex !== 'main' && srcList.name === 'Panel') {
                        amaran.error('Multi-level Panels not allowed.');
                    } else {
                        $scope.fnOpenInputConfigModal(srcList, srcIndex, schemaType);
                    }
                    return true;
                };

                $scope.fnOpenInputConfigModal = function (srcList, srcIndex) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return $scope.formArrForForm;
                            },
                            inputObj: function () {
                                return {};
                            },
                            isWorkbenchMode: function () {
                                return true;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema = _.cloneDeepWith($scope.formSchema);
                        $timeout(function () {
                            var subKey = '';
                            if (srcIndex === 'main') {
                                schema.properties[obj.key] = obj.value;
                            } else {
                                subKey = srcIndex + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                schema.properties[srcIndex].properties[obj.key] = tempObj.value;
                            }
                            $scope.formSchema = schema;
                            if (obj.value.type === 'object' && obj.value.inputType === 'panel') {
                                if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                    var schemaObj = schema.properties[obj.key];
                                    schemaObj.multiformConfig = obj.multiformConfig;
                                    $scope.formSchema = schema;
                                }
                            }
                            var tempData = TypeFormService.fnGenerateFormData($scope.formSchema);
                            $scope.formSchema = tempData.schema;
                            $scope.formArrForForm = tempData.form;
                            $scope.formBuilderInput = tempData.formBuilderInput;
                        });
                    }, function () {
                    });
                };

                $scope.fnGetType = function (type) {
                    var newType = '';
                    switch (type) {
                        case 'inputText':
                            newType = _.find($scope.fieldArrForForm, {name: 'Text Field'});
                            break;
                        case 'inputTextarea':
                            newType = _.find($scope.fieldArrForForm, {name: 'Text Area'});
                            break;
                        case 'inputButton':
                            newType = _.find($scope.fieldArrForForm, {name: 'Button'});
                            break;
                        case 'dropdown':
                            newType = _.find($scope.fieldArrForForm, {name: 'Select'});
                            break;
                        case 'inputCheckbox':
                            newType = _.find($scope.fieldArrForForm, {name: 'Checkbox'});
                            break;
                        case 'inputNumber':
                            newType = _.find($scope.fieldArrForForm, {name: 'Number'});
                            break;
                        case 'inputLabel':
                            newType = _.find($scope.fieldArrForForm, {name: 'Label'});
                            break;
                        default:
                            newType = _.find($scope.fieldArrForForm, {name: 'Panel'});
                            break;
                    }
                    return newType;
                };

                $scope.fnEditInput = function (inputObj, multiForm, parentObj) {
                    var resetInputObj = _.cloneDeepWith(inputObj);
                    if (multiForm === true) {
                        resetInputObj.key = resetInputObj.key.split('.')[1];
                        resetInputObj.schema = _.cloneDeepWith($scope.formSchema.properties[parentObj.key].properties[resetInputObj.key]);
                    } else {
                        resetInputObj.schema = _.cloneDeepWith($scope.formSchema.properties[inputObj.key]);
                    }
                    var srcList = $scope.fnGetType(inputObj.type);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/types/modal/inputConfigModal/inputConfigModal.html',
                        size: 'lg',
                        controller: 'inputConfigModalCtrl as inputConfigModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            formComponent: function () {
                                return srcList;
                            },
                            formArr: function () {
                                return $scope.formArrForForm;
                            },
                            inputObj: function () {
                                return resetInputObj;
                            },
                            isWorkbenchMode: function () {
                                return true;
                            },
                            iot3JsonObj: function () {
                                return $scope.iot3JsonObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        var schema = _.cloneDeepWith($scope.formSchema);
                        $scope.formSchema = {};
                        $scope.formArrForForm = [];
                        $timeout(function () {
                            var subKey = '';
                            if (multiForm === true) {
                                subKey = parentObj.key + '.' + obj.key + "";
                                var tempObj = _.cloneDeepWith(obj);
                                tempObj.key = subKey;
                                if (resetInputObj.key !== obj.key) {
                                    delete schema.properties[parentObj.key].properties[resetInputObj.key];
                                }
                                schema.properties[parentObj.key].properties[obj.key] = tempObj.value;
                            } else {
                                if (inputObj.type !== "panel-conditional") {
                                    if (resetInputObj.key !== obj.key) {
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    schema.properties[obj.key] = obj.value;
                                }
                                if (inputObj.type === "panel-conditional") {
                                    var schemaObj = {};
                                    if (resetInputObj.key !== obj.key) {
                                        schema.properties[obj.key] = schema.properties[resetInputObj.key];
                                        schema.properties[obj.key].key = obj.key;
                                        delete schema.properties[resetInputObj.key];
                                    }
                                    if (obj.multiformConfig && obj.multiformConfig.conditionObj && (obj.multiformConfig.conditionObj.show === true || obj.multiformConfig.conditionObj.show === false) && obj.multiformConfig.conditionObj.when.length && obj.multiformConfig.conditionObj.value.length) {
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.value.title;
                                    } else {
                                        obj.multiformConfig = {};
                                        schemaObj = schema.properties[obj.key];
                                        schemaObj.multiformConfig = obj.multiformConfig;
                                        schemaObj.title = obj.title;
                                    }
                                }
                            }
                            $scope.formSchema = schema;
                            var tempData = TypeFormService.fnGenerateFormData($scope.formSchema);
                            $scope.formSchema = tempData.schema;
                            $scope.formArrForForm = tempData.form;
                            $scope.formBuilderInput = tempData.formBuilderInput;
                        });
                    }, function () {
                    });
                };

                $scope.fnRemove = function (inputObj, multiForm, parentObj) {
                    var text = "";
                    if (inputObj.type === 'panel-conditional') {
                        text = 'Removing this component will also remove all of its children!'
                    }
                    swal({
                            title: "Delete the selected Component?",
                            text: text,
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                if (multiForm && multiForm === true) {
                                    var tempInputKey = inputObj.key.split('.')[1];
                                    var isFind;
                                    delete $scope.formSchema.properties[parentObj.key].properties[tempInputKey];
                                    delete $scope.formModel[parentObj.key][tempInputKey];
                                    isFind = _.find($scope.formArrForForm, function (formObj) {
                                        return formObj.key[0] === parentObj.key;
                                    });

                                    if (isFind) {
                                        var tempArr = _.cloneDeepWith(isFind.items);
                                        isFind.items = _.remove(isFind.items, function (itemObj) {
                                            return itemObj.key && itemObj.key[1] !== tempInputKey;
                                        });
                                        isFind.items.unshift(tempArr[0]);
                                    }

                                    var isFindFormBuilder;
                                    isFindFormBuilder = _.find($scope.formBuilderInput, function (formBuilderObj) {
                                        return formBuilderObj.key && formBuilderObj.key === parentObj.key;
                                    });

                                    if (isFindFormBuilder) {
                                        isFindFormBuilder.items = _.remove(isFindFormBuilder.items, function (itemObj) {
                                            return itemObj.key !== inputObj.key;
                                        });
                                    }
                                } else {
                                    var isFindReference;
                                    isFindReference = _.filter($scope.formArrForForm, function (formObj) {
                                        if (formObj && formObj.multiformConfig && formObj.multiformConfig.referenceKey === inputObj.key) {
                                            return formObj;
                                        }
                                    });

                                    if (isFindReference.length) {
                                        _.forEach(isFindReference, function (referenceObj) {
                                            delete referenceObj.multiformConfig;
                                            delete referenceObj.condition;
                                            var isFind;
                                            delete $scope.formSchema.properties[referenceObj.key].multiformConfig;
                                            isFind = _.find($scope.formBuilderInput, {key: inputObj.key});

                                            if (isFind) {
                                                delete isFind.multiformConfig;
                                            }
                                        });
                                        delete $scope.formSchema.properties[inputObj.key];
                                        delete $scope.formModel[inputObj.key];
                                        $scope.formArrForForm = _.remove($scope.formArrForForm, function (formObj) {
                                            return formObj.key[0] !== inputObj.key;
                                        });
                                        _.remove($scope.formBuilderInput, {key: inputObj.key});
                                    } else {
                                        delete $scope.formSchema.properties[inputObj.key];
                                        delete $scope.formModel[inputObj.key];
                                        $scope.formArrForForm = _.remove($scope.formArrForForm, function (formObj) {
                                            return formObj.key[0] !== inputObj.key;
                                        });
                                        _.remove($scope.formBuilderInput, {key: inputObj.key});
                                    }
                                }
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                $timeout(function () {
                                    $scope.$apply();
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCallResetWorkspace = function() {
                    $scope.fnInitiateResetWorkspace();
                };

                $scope.fnChangeTab = function (tab) {
                    if ($scope.activeTabIndex !== 1) {
                        $scope.fnEditAttribute();
                    }
                    $timeout(function () {
                        $scope.activeTabIndex = tab.tabIndex;
                        $scope.extractFiltersArr = _.cloneDeepWith($scope.resetExtractFiltersArr);
                        $scope.attrFilterOptions = _.cloneDeepWith($scope.resetAttrFilterOptions);
                        $scope.sampleDataForSelectedAttr = {};
                        $scope.selectedSampleData = '';
                        $scope.manipulatedSampleData = '';
                        $scope.selectedAttrSelectorType = '';
                        $scope.isShowSampleData = false;
                        $scope.formModel = {};
                        $scope.formArrForForm = [];
                        $scope.formBuilderInput = [];
                        $scope.formSchema = {
                            $schema: "http://json-schema.org/draft-07/schema#",
                            type: "object",
                            properties: {}
                        };
                    });

                    if ($scope.activeTabIndex !== 1) {
                        var isValueFind = _.find($scope.attributesArr, {'id': tab.id});
                        if (isValueFind) {
                            $scope.fnGetAttributeDetails(isValueFind);
                        }
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnRemoveTab = function (id, tabIndex) {
                    if ($scope.activeTabIndex === tabIndex) {
                        $scope.fnEditAttribute();

                        $timeout(function () {
                            $scope.extractFiltersArr = _.cloneDeepWith($scope.resetExtractFiltersArr);
                            $scope.attrFilterOptions = _.cloneDeepWith($scope.resetAttrFilterOptions);
                            $scope.sampleDataForSelectedAttr = {};
                            $scope.selectedSampleData = '';
                            $scope.manipulatedSampleData = '';
                            $scope.selectedAttrSelectorType = '';
                            $scope.isShowSampleData = false;
                            $scope.formModel = {};
                            $scope.formArrForForm = [];
                            $scope.formBuilderInput = [];
                            $scope.formSchema = {
                                $schema: "http://json-schema.org/draft-07/schema#",
                                type: "object",
                                properties: {}
                            };
                        });
                    }

                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex($scope.attributesTabs, {id: id});

                    if ($scope.activeTabIndex === tabIndex) {
                        if ($scope.attributesTabs.length === (index + 1)) {
                            $scope.activeTabIndex = 1;
                        }
                    }
                    _.forEach($scope.attributesTabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    $scope.attributesTabs = _.cloneDeepWith(tabs);

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnTabChanged = function () {

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnSelectSubTab = function (tabIndex) {
                    $scope.selectedDetailSubTabIndex = tabIndex;
                };

                $scope.fnEditAttribute = function () {
                    /*if ($scope.selectedAttributeObj.attributes &&
                        $scope.selectedAttributeObj.attributes.dataSink &&
                        $scope.selectedAttributeObj.attributes.dataSink.length) {
                        $scope.fnUpdateGlobalFromAttr({valueObj: {key: $scope.selectedAttributeObj.attributes.dataSink, value: ''}})
                    }*/
                    $scope.selectedAttributeObj.conditions = {
                        read: [],
                        delete: []
                    };
                    _.forEach($scope.selectedAttributeObj.readConditionsArr, function (readConditionObj) {
                        if (readConditionObj.key.length) {
                            $scope.selectedAttributeObj.conditions.read.push("\"" + readConditionObj.key + "\" " + readConditionObj.operator + " \"" + readConditionObj.value + "\"")
                        }
                    });

                    _.forEach($scope.selectedAttributeObj.deleteConditionsArr, function (deleteConditionObj) {
                        if (deleteConditionObj.key.length) {
                            $scope.selectedAttributeObj.conditions.delete.push("\"" + deleteConditionObj.key + "\" " + deleteConditionObj.operator + " \"" + deleteConditionObj.value + "\"")
                        }
                    });

                    $scope.selectedAttributeObj.attributes.selector.type = $scope.selectedAttrSelectorType;

                    var tempInstructionObj = {};
                    _.forEach($scope.selectedAttributeObj.properties.read.instructionsArr, function (instructionObj) {
                        tempInstructionObj[instructionObj.key] = instructionObj.value;
                    });
                    $scope.selectedAttributeObj.properties.read.instructions = tempInstructionObj;

                    if ($scope.formSchema.properties && Object.keys($scope.formSchema.properties).length) {
                        $scope.selectedAttributeObj.properties.readWrite = "RW";
                        if (!$scope.selectedAttributeObj.properties.write) {
                            $scope.selectedAttributeObj.properties.write = {};
                        }
                        $scope.selectedAttributeObj.properties.write.type = 'object';
                        $scope.selectedAttributeObj.properties.write.properties = {};
                        $scope.selectedAttributeObj.properties.write.properties = $scope.formSchema.properties;
                        if ($scope.writeButtonLabelObj &&
                            $scope.writeButtonLabelObj.labelVal &&
                            $scope.writeButtonLabelObj.labelVal.length) {
                            $scope.selectedAttributeObj.properties.write.buttonLabel = $scope.writeButtonLabelObj.labelVal;
                        } else {
                            $scope.selectedAttributeObj.properties.write.buttonLabel = '';
                        }
                    } else {
                        $scope.selectedAttributeObj.properties.readWrite = "R";
                        if ($scope.selectedAttributeObj.properties.write) {
                            $scope.selectedAttributeObj.properties.write.properties = {};
                        } else {
                            $scope.selectedAttributeObj.properties.write = {
                                properties: {}
                            }
                        }
                        if ($scope.writeButtonLabelObj &&
                            $scope.writeButtonLabelObj.labelVal &&
                            $scope.writeButtonLabelObj.labelVal.length) {
                            $scope.selectedAttributeObj.properties.write.buttonLabel = $scope.writeButtonLabelObj.labelVal;
                        } else {
                            $scope.selectedAttributeObj.properties.write.buttonLabel = '';
                        }
                    }

                    var tempExtractorObj = {};
                    _.forEach($scope.extractFiltersArr, function (extractorObj, index) {
                        if (extractorObj.key && extractorObj.key.length) {
                            tempExtractorObj[index] = extractorObj.key + " " + extractorObj.value;
                        }
                    });

                    $scope.selectedAttributeObj.attributes.extractor.filters = tempExtractorObj;

                    var findIndex = _.findIndex($scope.attributesArr, function (attrObj) {
                        return attrObj.id === $scope.selectedAttributeObj.id;
                    });

                    if (findIndex !== -1) {
                        $scope.attributesArr[findIndex] = _.cloneDeepWith($scope.selectedAttributeObj);
                    }
                };

                $scope.fnGetAttributeDetails = function (attrObj) {
                    $scope.selectedAttributeObj = null;
                    /* Toggle push in selected attributes array*/
                    var isTabExist = _.find($scope.attributesTabs, {'id': attrObj.id});
                    if (isTabExist) {
                        $timeout(function () {
                            $scope.activeTabIndex = isTabExist.tabIndex;
                            $scope.selectedAttributeObj = attrObj;
                            $scope.fnGetTypeSampleData();
                            $scope.fnGetExtractorFilters();
                            $scope.fnResetWriteForm();
                        });
                    } else {
                        var newTabIndex = $scope.attributesTabs.length + 1;
                        $scope.attributesTabs.push({
                            id: attrObj.id,
                            title: attrObj.id,
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            $scope.activeTabIndex = newTabIndex;
                            $scope.selectedAttributeObj = attrObj;
                            $scope.fnGetTypeSampleData();
                            $scope.fnGetExtractorFilters();
                            $scope.fnResetWriteForm();
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 100)
                };

                $scope.fnOpenSampleDataModal = function () {
                    var sampleData = '';
                    if ($scope.sampleDataForSelectedAttr.sampleDataType &&
                        ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'html' ||
                            $scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'xml')) {
                        if ($scope.sampleDataForSelectedAttr.sampleData && $scope.sampleDataForSelectedAttr.sampleData.length) {
                            if ($scope.sampleDataForSelectedAttr.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith($scope.sampleDataForSelectedAttr.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForSelectedAttr.sampleData)))
                            }
                        }
                    } else {
                        sampleData = _.cloneDeepWith($scope.sampleDataForSelectedAttr.sampleData)
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/sampleDataModal/sampleDataModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'sampleDataModalCtrl as sampleDataModal',
                        resolve: {
                            sampleDataObj: function () {
                                return {
                                    type: $scope.sampleDataForSelectedAttr.sampleDataType,
                                    value: sampleData
                                };
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        })
                    }, function () {
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        })
                    });
                };

                function getElementByXpath(path) {
                    try {
                        return document.evaluate(path, document.getElementById('workBenchSampleTest'), null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    } catch (e) {
                        amaran.error(e);
                        return null;
                    }
                }

                function convertCSVToXML(csvData) {
                    var splitter = ',';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    }
                    var csvArr = csvData.split('\n');
                    csvArr = _.map(csvArr, function (row) {
                        return row.trim();
                    });
                    var headings = csvArr[0].split(splitter);
                    var xml = '';

                    for (var i = 1; i < csvArr.length; i++) {
                        var details = csvArr[i].split(splitter);
                        xml += "<row>\n";

                        for (var j = 0; j < headings.length; j++) {
                            xml += '<item>'+ details[j] +'</item>';
                        }

                        xml += "</row>\n";
                    }
                    return xml;
                }

                function fnConvertOidToJson(oidData) {
                    var tempObj = {};
                    var oidArr = oidData.split('\n');
                    oidArr = _.map(oidArr, function (row) {
                        return row.trim();
                    });
                    _.forEach(oidArr, function (oidStr) {
                        var grp = oidStr.split(':');
                        tempObj[grp[0].trim()] = grp[1].trim();
                    });
                    return tempObj;
                }

                $scope.fnOpenExpressionModal = function (expression, expressionType) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/expressionModal/expressionModal.html',
                        size: 'lg',
                        controller: 'expressionModalCtrl as expressionModal',
                        windowClass: 'modal-fullScreen',
                        resolve: {
                            expression: function () {
                                return expression;
                            },
                            expressionType: function () {
                                return expressionType;
                            },
                            sampleDataForSelectedAttr: function () {
                                return $scope.sampleDataForSelectedAttr;
                            }
                        }
                    });

                    modalInstance.result.then(function (obj) {
                        $scope.selectedAttributeObj.attributes.selector.expression = obj.expression;
                        $scope.selectedSampleData = obj.selectedSampleData;
                    }, function () {
                    });
                };

                $scope.fnGetSampleDataFromExpression = function () {
                    if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse($scope.sampleDataForSelectedAttr.sampleData.toString()); //eslint-disable-line
                            var selectedSampleData = _.get(tempObj,
                                $scope.selectedAttributeObj.attributes.selector.expression, 'notFound');
                            if (selectedSampleData === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                $scope.isShowSampleData = false;
                            } else {
                                $scope.selectedSampleData = selectedSampleData;
                                $scope.isShowSampleData = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            $scope.isShowSampleData = false;
                        }
                    } else if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'html' ||
                        $scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if ($scope.sampleDataForSelectedAttr.sampleData &&
                            $scope.sampleDataForSelectedAttr.sampleData.length) {
                            if ($scope.sampleDataForSelectedAttr.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith($scope.sampleDataForSelectedAttr.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith($scope.sampleDataForSelectedAttr.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": $scope.selectedAttributeObj.attributes.selector.expression,
                                "document": sampleData
                            }
                        };
                        Iot3WorkbenchFactory.evaluateXpath(inputObj)
                            .then(function (response) {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                if (response) {
                                    if (response.result) {
                                        $scope.selectedSampleData = {
                                            sampleDataVal: response.result,
                                            isCollection: angular.isArray(response.result)
                                        };
                                        $scope.isShowSampleData = true;
                                    } else if (response.error) {
                                        amaran.error(response.error);
                                        $scope.isShowSampleData = false;
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        $scope.isShowSampleData = false;
                                    }
                                } else {
                                    amaran.error('Something went wrong. Please try again.');
                                    $scope.isShowSampleData = false;
                                }
                            }, function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                amaran.error('Something went wrong. Please try again.');
                                $scope.isShowSampleData = false;
                            });
                    } else if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML($scope.sampleDataForSelectedAttr.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainer');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if ($scope.selectedAttributeObj.attributes.selector.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath($scope.selectedAttributeObj.attributes.selector.expression);
                        } else {
                            if ($scope.selectedAttributeObj.attributes.selector.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath($scope.selectedAttributeObj.attributes.selector.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.selectedAttributeObj.attributes.selector.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + $scope.selectedAttributeObj.attributes.selector.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleData = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                $scope.selectedSampleData = htmlObjForCSV.innerHTML;
                            } else {
                                $scope.selectedSampleData = htmlObjForCSV;
                            }
                            $scope.isShowSampleData = true;
                        }
                        tempElemForCSV.remove();
                    } else if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson($scope.sampleDataForSelectedAttr.sampleData);
                        if (oidJSon[$scope.selectedAttributeObj.attributes.selector.expression]) {
                            $scope.selectedSampleData = oidJSon[$scope.selectedAttributeObj.attributes.selector.expression];
                            $scope.isShowSampleData = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleData = false;
                        }
                    } else if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = $scope.sampleDataForSelectedAttr.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes($scope.selectedAttributeObj.attributes.selector.expression + "=")) {
                                    var cookieStr = splitStr.split($scope.selectedAttributeObj.attributes.selector.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    $scope.selectedSampleData = finalVal;
                                    $scope.isShowSampleData = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    $scope.isShowSampleData = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleData = false;
                        }
                    } else if ($scope.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = $scope.sampleDataForSelectedAttr.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith($scope.selectedAttributeObj.attributes.selector.expression + ':')) {
                                HeaderFlag = false;
                                $scope.selectedSampleData = splitStr.split($scope.selectedAttributeObj.attributes.selector.expression + ':')[1];
                                $scope.isShowSampleData = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            $scope.isShowSampleData = false;
                        }
                    } else {
                        $scope.isShowSampleData = false;
                    }
                };

                $scope.fnSetTypeSampleData = function () {
                    var workbench = DB.fnGet('iot3Workbench');
                    if ($scope.typesObj &&
                        $scope.typesObj[$scope.selectedAttributeObj.parentName] &&
                        $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource &&
                        $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource.length &&
                        $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource.startsWith('%{') &&
                        $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource.endsWith('}') &&
                        workbench.currentWorkspaceEngineSampleData &&
                        Object.keys(workbench.currentWorkspaceEngineSampleData).length) {
                        var engineTrail = $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource.substr(2, $scope.typesObj[$scope.selectedAttributeObj.parentName].dataSource.lastIndexOf('}') - 2);
                        var requestName = engineTrail.split('.');
                        var value = _.get(workbench.currentWorkspaceEngineSampleData, requestName[requestName.length - 1], 'notFound');

                        if (value !== 'notFound' && value.constructor.name === 'Object' &&
                            (value.sampleData && value.sampleData !== '')) {
                            $scope.sampleDataForSelectedAttr = value;
                            $scope.selectedAttrSelectorType = $scope.selectorPathOptions[value.sampleDataType];
                        } else {
                            $scope.sampleDataForSelectedAttr = {};
                            $scope.selectedSampleData = '';
                            $scope.manipulatedSampleData = '';
                            $scope.isShowSampleData = false;
                            if ($scope.selectedAttributeObj &&
                                $scope.selectedAttributeObj.attributes &&
                                $scope.selectedAttributeObj.attributes.selector &&
                                $scope.selectedAttributeObj.attributes.selector.type &&
                                $scope.selectedAttributeObj.attributes.selector.type.length) {
                                $scope.selectedAttrSelectorType = $scope.selectedAttributeObj.attributes.selector.type;
                            } else {
                                $scope.selectedAttrSelectorType = $scope.selectorPathOptions.HTML;
                            }
                        }
                    } else {
                        $scope.sampleDataForSelectedAttr = {};
                        $scope.selectedSampleData = '';
                        $scope.manipulatedSampleData = '';
                        $scope.isShowSampleData = false;
                        if ($scope.selectedAttributeObj &&
                            $scope.selectedAttributeObj.attributes &&
                            $scope.selectedAttributeObj.attributes.selector &&
                            $scope.selectedAttributeObj.attributes.selector.type &&
                            $scope.selectedAttributeObj.attributes.selector.type.length) {
                            $scope.selectedAttrSelectorType = $scope.selectedAttributeObj.attributes.selector.type;
                        } else {
                            $scope.selectedAttrSelectorType = $scope.selectorPathOptions.HTML;
                        }
                    }
                };

                $scope.fnGetTypeSampleData = function () {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        if ($scope.selectedAttributeObj &&
                            $scope.selectedAttributeObj.attributes &&
                            $scope.selectedAttributeObj.attributes.dataSource &&
                            $scope.selectedAttributeObj.attributes.dataSource.length &&
                            $scope.selectedAttributeObj.attributes.dataSource.startsWith('%{') &&
                            $scope.selectedAttributeObj.attributes.dataSource.endsWith('}') &&
                            workbench.currentWorkspaceEngineSampleData &&
                            Object.keys(workbench.currentWorkspaceEngineSampleData).length) {

                            var engineTrail = $scope.selectedAttributeObj.attributes.dataSource.substr(2, $scope.selectedAttributeObj.attributes.dataSource.lastIndexOf('}') - 2);
                            var requestName = engineTrail.split('.');
                            var value = _.get(workbench.currentWorkspaceEngineSampleData, requestName[requestName.length - 1], 'notFound');

                            if (value !== 'notFound' && value.constructor.name === 'Object' &&
                                (value.sampleData && value.sampleData !== '')) {
                                $scope.sampleDataForSelectedAttr = value;
                                $scope.selectedAttrSelectorType = $scope.selectorPathOptions[value.sampleDataType];
                            } else {
                                $scope.fnSetTypeSampleData();
                            }

                        } else {
                            $scope.fnSetTypeSampleData();
                        }
                    } else {
                        $scope.sampleDataForSelectedAttr = {};
                        $scope.selectedSampleData = '';
                        $scope.manipulatedSampleData = '';
                        $scope.isShowSampleData = false;
                        if ($scope.selectedAttributeObj.attributes.selector.type === '') {
                            $scope.selectedAttrSelectorType = $scope.selectorPathOptions.HTML;
                        } else {
                            $scope.selectedAttrSelectorType = $scope.selectedAttributeObj.attributes.selector.type;
                        }
                    }
                };

                $scope.fnGetExtractorFilters = function () {
                    $scope.attrFilterOptions = _.cloneDeepWith($scope.resetAttrFilterOptions);
                    if ($scope.selectedAttributeObj && $scope.selectedAttributeObj.attributes &&
                        $scope.selectedAttributeObj.attributes.extractor &&
                        $scope.selectedAttributeObj.attributes.extractor.filters) {
                        var tempArr = [];
                        if (angular.isArray($scope.selectedAttributeObj.attributes.extractor.filters)) {
                            if ($scope.selectedAttributeObj.attributes.extractor.filters.length) {
                                _.forEach($scope.selectedAttributeObj.attributes.extractor.filters, function (filterValue) {
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptions, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptions[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptions[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    })
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArr = _.cloneDeepWith(tempArr);
                            } else {
                                $scope.extractFiltersArr = _.cloneDeepWith($scope.resetExtractFiltersArr);
                            }
                        } else {
                            if (Object.keys($scope.selectedAttributeObj.attributes.extractor.filters).length) {
                                Object.keys($scope.selectedAttributeObj.attributes.extractor.filters).forEach(function (filterKey) {
                                    var filterValue = $scope.selectedAttributeObj.attributes.extractor.filters[filterKey];
                                    var splitArr = [];
                                    if (filterValue.includes(":")) {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(':'));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(':')+1);
                                    } else {
                                        splitArr[0] = filterValue.substr(0,filterValue.indexOf(" "));
                                        splitArr[1] = filterValue.substr(filterValue.indexOf(" ")+1);
                                    }
                                    var isShowArguments = _.findIndex($scope.attrFilterOptions, {'filterValue': splitArr[0]});
                                    if (isShowArguments !== -1) {
                                        $scope.attrFilterOptions[isShowArguments].isShow = false;
                                    }
                                    tempArr.push({
                                        key: splitArr[0],
                                        isArguments: isShowArguments === -1 ? true : $scope.attrFilterOptions[isShowArguments].isArguments,
                                        value: splitArr[1]
                                    })
                                });
                                if (tempArr[tempArr.length - 1].key.length) {
                                    tempArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                                $scope.extractFiltersArr = _.cloneDeepWith(tempArr);
                            } else {
                                $scope.extractFiltersArr = _.cloneDeepWith($scope.resetExtractFiltersArr);
                            }
                        }
                    } else {
                        if ($scope.selectedAttributeObj.attributes.extractor) {
                            $scope.selectedAttributeObj.attributes.extractor.filters = {};
                        } else {
                            $scope.selectedAttributeObj.attributes.extractor = {
                                filters: {}
                            };
                        }
                        $scope.extractFiltersArr = _.cloneDeepWith($scope.resetExtractFiltersArr);
                    }
                };

                $scope.fnResetWriteForm = function () {
                    if ($scope.selectedAttributeObj.properties.write &&
                        $scope.selectedAttributeObj.properties.write.properties &&
                        Object.keys($scope.selectedAttributeObj.properties.write.properties).length) {
                        // $scope.fnCreateForm({properties: $scope.selectedAttributeObj.properties.write.properties});
                        var tempData = TypeFormService.fnGenerateFormData($scope.selectedAttributeObj.properties.write);
                        $scope.formSchema = tempData.schema;
                        $scope.formArrForForm = tempData.form;
                        $scope.formBuilderInput = tempData.formBuilderInput;
                    } else {
                        $scope.formModel = {};
                        $scope.formArrForForm = [];
                        $scope.formBuilderInput = [];
                        $scope.formSchema = {
                            $schema: "http://json-schema.org/draft-07/schema#",
                            type: "object",
                            properties: {}
                        };
                    }

                    if ($scope.selectedAttributeObj.properties.write &&
                        $scope.selectedAttributeObj.properties.write.buttonLabel &&
                        $scope.selectedAttributeObj.properties.write.buttonLabel.length) {
                        $scope.writeButtonLabelObj.labelVal = $scope.selectedAttributeObj.properties.write.buttonLabel;
                    } else {
                        $scope.writeButtonLabelObj.labelVal = '';
                    }
                };

                $scope.fnSelectValueTypeForSelectors = function (key) {
                    $scope.selectedAttributeObj.properties.read.type = key;
                };

                $scope.fnInitAttributesTab = function () {
                    $scope.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;

                    var tempAttrArr = [];
                    if ($scope.attributesObj && Object.keys($scope.attributesObj).length) {
                        Object.keys($scope.attributesObj).forEach(function (attrKey) {
                            var isFindType = '';
                            Object.keys($scope.typesObj).forEach(function (typeKey) {
                                if ($scope.typesObj[typeKey].attributes.includes(attrKey)) {
                                    isFindType = typeKey;
                                }
                            });
                            if (isFindType !== '') {
                                $scope.attrOptions.push(attrKey);
                                tempAttrArr.push(attrKey);
                                var tempObj = {};
                                tempObj.id = attrKey;
                                tempObj.parentName = isFindType;
                                tempObj.name = $scope.attributesObj[attrKey].name;
                                tempObj.description = $scope.attributesObj[attrKey].description ? $scope.attributesObj[attrKey].description : '';
                                tempObj.conditions = $scope.attributesObj[attrKey].conditions ? $scope.attributesObj[attrKey].conditions : {
                                    read: [],
                                    delete: []
                                };
                                tempObj.readConditionsArr = [];
                                tempObj.deleteConditionsArr = [];
                                if (tempObj.conditions.read &&
                                    tempObj.conditions.read.length) {
                                    _.forEach(tempObj.conditions.read, function (readValue) {
                                        var split1 = readValue.split("\" ");
                                        tempObj.readConditionsArr.push({
                                            key: split1[0].replace(/"/g, ''),
                                            value: split1[1].split(" \"")[1].replace(/"/g, ''),
                                            operator: split1[1].split(" \"")[0].replace(/"/g, '')
                                        })
                                    })
                                } else {
                                    if (!tempObj.conditions.read) {
                                        tempObj.conditions.read = [];
                                    }
                                    tempObj.readConditionsArr.push({
                                        key: '',
                                        value: '',
                                        operator: ''
                                    })
                                }
                                if (tempObj.conditions.delete &&
                                    tempObj.conditions.delete.length) {
                                    _.forEach(tempObj.conditions.delete, function (readValue) {
                                        var split1 = readValue.split("\" ");
                                        tempObj.deleteConditionsArr.push({
                                            key: split1[0].replace(/"/g, ''),
                                            value: split1[1].split(" \"")[1].replace(/"/g, ''),
                                            operator: split1[1].split(" \"")[0].replace(/"/g, '')
                                        })
                                    })
                                } else {
                                    if (!tempObj.conditions.delete) {
                                        tempObj.conditions.delete = [];
                                    }
                                    tempObj.deleteConditionsArr.push({
                                        key: '',
                                        value: '',
                                        operator: ''
                                    })
                                }
                                tempObj.attributes = $scope.attributesObj[attrKey].attributes ? $scope.attributesObj[attrKey].attributes : {
                                    dataSource: "",
                                    requires: [],
                                    selector: {
                                        type: '',
                                        expression: '',
                                        selectors: {}
                                    },
                                    lookup: {},
                                    extractor: {
                                        keys: [],
                                        transform: "",
                                        filters: {},
                                        mapper: "",
                                        parameters: {}
                                    }
                                };

                                if (tempObj.attributes && tempObj.attributes.selector) {
                                    tempObj.attributes.selector.selectors = {};
                                }

                                if ($scope.attributesObj[attrKey].attributes &&
                                    angular.isUndefined($scope.attributesObj[attrKey].attributes.extractor)) {
                                    $scope.attributesObj[attrKey].attributes.extractor = {
                                        keys: [],
                                        transform: "",
                                        filters: {},
                                        mapper: "",
                                        parameters: {}
                                    }
                                } else if ($scope.attributesObj[attrKey].attributes.extractor === null) {
                                    $scope.attributesObj[attrKey].attributes.extractor = {
                                        keys: [],
                                        transform: "",
                                        filters: {},
                                        mapper: "",
                                        parameters: {}
                                    }
                                }

                                if ($scope.attributesObj[attrKey].attributes.extractor &&
                                    !$scope.attributesObj[attrKey].attributes.extractor.mapper) {
                                    $scope.attributesObj[attrKey].attributes.extractor.mapper = '';
                                }

                                if ($scope.attributesObj[attrKey].attributes.extractor &&
                                    !$scope.attributesObj[attrKey].attributes.extractor.filters) {
                                    $scope.attributesObj[attrKey].attributes.extractor.filters = {};
                                }

                                tempObj.properties = $scope.attributesObj[attrKey].properties ? $scope.attributesObj[attrKey].properties : {
                                    readWrite: "R",
                                    read: {
                                        type: 'String',
                                        enum: "",
                                        unit: "",
                                        instructions: {}
                                    },
                                    write: {
                                        type: "object",
                                        required: [],
                                        properties: {}
                                    }
                                };
                                if ($scope.attributesObj[attrKey] && $scope.attributesObj[attrKey].properties) {
                                    if (angular.isUndefined($scope.attributesObj[attrKey].properties.read)) {
                                        $scope.attributesObj[attrKey].properties.read = {
                                            type: 'String',
                                            enum: "",
                                            unit: "",
                                            instructions: {}
                                        }
                                    } else if (angular.isUndefined($scope.attributesObj[attrKey].properties.read.unit) ||
                                        $scope.attributesObj[attrKey].properties.read.unit === null) {
                                        $scope.attributesObj[attrKey].properties.read.unit = '';
                                    }
                                } else {
                                    $scope.attributesObj[attrKey].properties = {
                                        readWrite: 'R',
                                        read: {
                                            type: 'String',
                                            enum: "",
                                            unit: "",
                                            instructions: {}
                                        }
                                    }
                                }

                                if (tempObj.properties.read && tempObj.properties.read.instructions && Object.keys(tempObj.properties.read.instructions).length) {
                                    tempObj.properties.read.instructionsArr = [];
                                    Object.keys(tempObj.properties.read.instructions).forEach(function (instructionKey) {
                                        tempObj.properties.read.instructionsArr.push({
                                            key: instructionKey,
                                            value: tempObj.properties.read.instructions[instructionKey]
                                        })
                                    });
                                    tempObj.properties.read.instructionsArr.push({
                                        key: '',
                                        value: ''
                                    })
                                } else {
                                    tempObj.properties.read.instructions = {};
                                    tempObj.properties.read.instructionsArr = [];
                                }
                                $scope.attributesArr.push(tempObj);
                            }
                        });
                    }

                    if ($scope.typesObj && Object.keys($scope.typesObj).length) {
                        Object.keys($scope.typesObj).forEach(function (typeKey) {
                            _.forEach($scope.typesObj[typeKey].attributes, function (attrName) {
                                if (!tempAttrArr.includes(attrName)) {
                                    $scope.attrOptions.push(attrName);
                                    var tempObj = {
                                        parentName: typeKey,
                                        id: attrName,
                                        name: "",
                                        description: "",
                                        readConditionsArr: [{
                                            key: '',
                                            value: '',
                                            operator: ''
                                        }],
                                        deleteConditionsArr: [{
                                            key: '',
                                            value: '',
                                            operator: ''
                                        }],
                                        conditions: {
                                            read: [],
                                            delete: []
                                        },
                                        attributes: {
                                            dataSource: "",
                                            requires: [],
                                            selector: {
                                                type: "",
                                                expression: "",
                                                selectors: {}
                                            },
                                            lookup: {},
                                            extractor: {
                                                keys: [],
                                                transform: "",
                                                filters: {},
                                                mapper: "",
                                                parameters: {}
                                            },
                                            dataSink: ''
                                        },
                                        properties: {
                                            readWrite: "R",
                                            read: {
                                                type: "String",
                                                enum: "",
                                                unit: "",
                                                instructionsArr: [{
                                                    key: '',
                                                    value: ''
                                                }],
                                                instructions: {}
                                            },
                                            write: {
                                                type: "object",
                                                required: [],
                                                properties: {}
                                            }
                                        }
                                    };
                                    $scope.attributesArr.push(tempObj);
                                }
                            })
                        });
                    }

                    if ($scope.mappingsObj && Object.keys($scope.mappingsObj).length) {
                        Object.keys($scope.mappingsObj).forEach(function (key) {
                            var tempObj = $scope.mappingsObj[key];
                            tempObj.id = key;
                            $scope.mappingsArr.push(tempObj);
                        })
                    } else {
                        $scope.mappingsArr = [];
                    }

                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    });
                };

                $scope.fnInitAttributesTab();

                $scope.fnCallOnDestroyForAttributes = function () {
                    var tempObj = {};
                    _.forEach($scope.attributesArr, function (attrObj) {
                        tempObj[attrObj.id] = {};
                        tempObj[attrObj.id].name = attrObj.name;
                        tempObj[attrObj.id].description = attrObj.description;
                        tempObj[attrObj.id].conditions = {
                            read: [],
                            delete: []
                        };
                        _.forEach(attrObj.readConditionsArr, function (readConditionObj) {
                            if (readConditionObj.key.length) {
                                tempObj[attrObj.id].conditions.read.push("\"" + readConditionObj.key + "\" " + readConditionObj.operator + " \"" + readConditionObj.value + "\"")
                            }
                        });

                        _.forEach(attrObj.deleteConditionsArr, function (deleteConditionObj) {
                            if (deleteConditionObj.key.length) {
                                tempObj[attrObj.id].conditions.delete.push("\"" + deleteConditionObj.key + "\" " + deleteConditionObj.operator + " \"" + deleteConditionObj.value + "\"")
                            }
                        });
                        tempObj[attrObj.id].attributes = attrObj.attributes;
                        var tempInstructionObj = {};
                        _.forEach(attrObj.properties.read.instructionsArr, function (instructionObj) {
                            tempInstructionObj[instructionObj.key] = instructionObj.value;
                        });
                        tempObj[attrObj.id].properties = attrObj.properties;
                        tempObj[attrObj.id].properties.read.instructions = tempInstructionObj;
                        delete  tempObj[attrObj.id].properties.read.instructionsArr;

                        /*if ($scope.formSchema.properties && Object.keys($scope.formSchema.properties).length) {
                            tempObj[attrObj.id].properties.readWrite = "RW";
                            if (!tempObj[attrObj.id].properties.write) {
                                tempObj[attrObj.id].properties.write = {};
                            }
                            tempObj[attrObj.id].properties.write.properties = {};
                            tempObj[attrObj.id].properties.write.properties = $scope.formSchema.properties;
                        } else {
                            tempObj[attrObj.id].properties.readWrite = "R";
                            if (!tempObj[attrObj.id].properties.write) {
                                tempObj[attrObj.id].properties.write = {};
                            }
                            tempObj[attrObj.id].properties.write.properties = {};
                        }*/
                    });

                    $scope.fnUpdateWorkbench({updateType: 'templateAttribute', updateValue: tempObj});
                };

                $scope.$on('$destroy', function () {
                    $scope.fnCallOnDestroyForAttributes();
                });

                $window.onbeforeunload = function() {
                    $scope.fnCallOnDestroyForAttributes();
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('workspaceListModalCtrl',
            function ($uibModalInstance, $timeout, $window, amaran, swal, UserProfileService, QueryFactory,
                      PaginationQueryService, Iot3WorkbenchFactory, NodeIoT3Factory, isGetBlueprints, isHideDelete) {
                var vm = this;

                vm.isDataLoading = true;
                vm.isRefreshed = true;
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;
                vm.isHideDelete = isHideDelete;
                vm.isGetBlueprints = isGetBlueprints;
                vm.tableName = isGetBlueprints ? 'node_iot3_references' : 'node_iot3_workspaces';

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];

                vm.isShowLoader = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 90);
                        angular.element(".workspaceList-table tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (obj) {
                    _.forEach(vm.dataArr, function (dataObj) {
                        dataObj.isCheck = false;
                    });
                    obj.isCheck = !obj.isCheck;
                    if (obj.isCheck) {
                        vm.selectedWorkspace = obj
                    } else {
                        vm.selectedWorkspace = ""
                    }
                };

                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isDataLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ' + vm.tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetWorkspaceList(input, true);
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isDataLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM ' + vm.tableName;
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM ' + vm.tableName;
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ' + vm.tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetWorkspaceList(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.dataArr);
                        vm.previousPage = page;
                        vm.fnGetWorkspaceList(input, false);
                    }
                };

                vm.fnGetWorkspaceList = function (input, isFirst) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            vm.dataResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.dataResponse.data && vm.dataResponse.data.length) {
                                vm.totalItems = vm.dataResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (input.isNeedDataReverse) {
                                vm.dataResponse.data.reverse();
                            }
                            vm.dataArr = vm.dataResponse.data;
                            vm.isDataLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDataLoading = false;
                            vm.isRefresh = false;
                        });
                };

                vm.fnDeleteWorkspace = function (selectedWorkspace) {
                    swal({
                            title: "Are you sure?",
                            text: "You are about to permanently delete the Iot3 workspace.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: true,
                            showLoaderOnConfirm: false
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                vm.isShowLoader = true;
                                if (vm.isGetBlueprints) {
                                    NodeIoT3Factory.deleteIoT3Reference({iot3Id: selectedWorkspace.id})
                                        .then(function () {
                                            vm.isRefreshed = false;
                                            $timeout(function () {
                                                vm.isRefreshed = true;
                                                vm.isShowLoader = false;
                                                vm.selectedWorkspace = ""
                                            })
                                        }, function () {
                                            vm.isRefreshed = false;
                                            $timeout(function () {
                                                vm.isRefreshed = true;
                                                vm.isShowLoader = false;
                                                vm.selectedWorkspace = ""
                                            })
                                        })
                                } else {
                                    Iot3WorkbenchFactory.deleteIot3Workbench({workspaceId: selectedWorkspace.id})
                                        .then(function () {
                                            vm.isRefreshed = false;
                                            $timeout(function () {
                                                vm.isRefreshed = true;
                                                vm.isShowLoader = false;
                                                vm.selectedWorkspace = ""
                                            })
                                        }, function () {
                                            vm.isRefreshed = false;
                                            $timeout(function () {
                                                vm.isRefreshed = true;
                                                vm.isShowLoader = false;
                                                vm.selectedWorkspace = ""
                                            })
                                        })
                                }
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetWorkspaceDetails = function (workspaceId) {
                    if (vm.isGetBlueprints) {
                        NodeIoT3Factory.describeIoT3Reference({iot3Id: workspaceId})
                            .then(function (res) { // Success block
                                $uibModalInstance.close({selectedWorkspace: res, isScratch: false});
                            }, function () {
                                vm.isShowLoader = false;
                            });
                    } else {
                        Iot3WorkbenchFactory.describeIot3Worbench({workspaceId: workspaceId})
                            .then(function (res) {
                                vm.isShowLoader = false;
                                $uibModalInstance.close({selectedWorkspace: res, isScratch: false});
                            }, function () {
                                vm.isShowLoader = false;
                            })
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    if (vm.selectedWorkspace.id) {
                        vm.isShowLoader = true;
                        vm.fnGetWorkspaceDetails(vm.selectedWorkspace.id);
                    }
                };

                vm.fnInit = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0)
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('sampleDataModalCtrl',
            function ($uibModalInstance, $timeout, $window, sampleDataObj) {
                var vm = this;
                vm.sampleDataObj = sampleDataObj;

                vm.sampleDataOptions = {
                    "HTML": "text/html",
                    "XML": "text/html",
                    "JSON": "javascript",
                    "CSV": "null",
                    "OID": "null",
                    "Cookie": "null",
                    "Header": "null"
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    readOnly: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    mode: vm.sampleDataObj.type && vm.sampleDataOptions[vm.sampleDataObj.type] ?
                        vm.sampleDataOptions[vm.sampleDataObj.type] : 'null',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            /*$timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);*/
                        });
                    }
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 150)
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInit = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('expressionModalCtrl',
            function ($scope, $uibModalInstance, $timeout, $window, $base64, $uibModal, DB, swal, microSpinner,
                      Iot3WorkbenchFactory, amaran, expression, expressionType, sampleDataForSelectedAttr) {
                var vm = this;

                vm.expressionObj = {
                    expression: _.cloneDeepWith(expression),
                    expressionType: _.cloneDeepWith(expressionType)
                };

                vm.sampleDataForSelectedAttr = _.cloneDeepWith(sampleDataForSelectedAttr);

                vm.sampleDataOptions = {
                    "HTML": "text/html",
                    "XML": "text/html",
                    "XSLT": "text/html",
                    "JSON": "javascript",
                    "CSV": "null",
                    "OID": "null",
                    "Cookie": "null",
                    "Header": "null"
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    readOnly: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    mode: vm.sampleDataForSelectedAttr.sampleDataType && vm.sampleDataOptions[vm.sampleDataForSelectedAttr.sampleDataType] ?
                        vm.sampleDataOptions[vm.sampleDataForSelectedAttr.sampleDataType] : 'null',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            /*$timeout(function () {
                                $scope.fnChangeDone();
                            }, 100);*/
                        });
                    }
                };

                vm.sampleData = '';

                function getElementByXpath(path) {
                    try {
                        return document.evaluate(path, document.getElementById('workBenchSampleTest'), null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                    } catch (e) {
                        amaran.error(e);
                        return null;
                    }
                }

                function convertCSVToXML(csvData) {
                    var splitter = ',';
                    if (csvData.includes(';')) {
                        splitter = ';'
                    }
                    var csvArr = csvData.split('\n');
                    csvArr = _.map(csvArr, function (row) {
                        return row.trim();
                    });
                    var headings = csvArr[0].split(splitter);
                    var xml = '';

                    for (var i = 1; i < csvArr.length; i++) {
                        var details = csvArr[i].split(splitter);
                        xml += "<row>\n";

                        for (var j = 0; j < headings.length; j++) {
                            xml += '<item>'+ details[j] +'</item>';
                        }

                        xml += "</row>\n";
                    }
                    return xml;
                }

                function fnConvertOidToJson(oidData) {
                    var tempObj = {};
                    var oidArr = oidData.split('\n');
                    oidArr = _.map(oidArr, function (row) {
                        return row.trim();
                    });
                    _.forEach(oidArr, function (oidStr) {
                        var grp = oidStr.split(':');
                        tempObj[grp[0].trim()] = grp[1].trim();
                    });
                    return tempObj;
                }

                vm.fnTestExpression = function () {
                    if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'json') {
                        try {
                            var tempObj = JSON.parse(vm.sampleDataForSelectedAttr.sampleData.toString()); //eslint-disable-line
                            var selectedSampleData = _.get(tempObj,
                                vm.expressionObj.expression, 'notFound');
                            if (selectedSampleData === 'notFound') {
                                amaran.error('Selected expression was not found in the sample data. Please try again.');
                                vm.isShowSampleData = false;
                            } else {
                                vm.selectedSampleData = selectedSampleData;
                                vm.isShowSampleData = true;
                            }
                        } catch (err) {
                            amaran.error('The Sample data is not a valid JSON. Please correct the sample data and try again.');
                            vm.isShowSampleData = false;
                        }
                    } else if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'html' ||
                        vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'xml') {
                        var sampleData = '';
                        if (vm.sampleDataForSelectedAttr.sampleData &&
                            vm.sampleDataForSelectedAttr.sampleData.length) {
                            if (vm.sampleDataForSelectedAttr.sampleData.includes("</")) {
                                sampleData = _.cloneDeepWith(vm.sampleDataForSelectedAttr.sampleData);
                            } else {
                                sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(vm.sampleDataForSelectedAttr.sampleData)))
                            }
                        }
                        swal({
                            title: "Please wait while we fetch the sample data from expression.",
                            type: "warning",
                            html: true,
                            showCancelButton: false,
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var inputObj = {
                            body: {
                                "expression": vm.expressionObj.expression,
                                "document": sampleData
                            }
                        };

                        if (expressionType.toLowerCase() === 'xslt') {
                            Iot3WorkbenchFactory.evaluateXslt(inputObj)
                                .then(function (response) {
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                    if (response) {
                                        if (response.result) {
                                            vm.selectedSampleData = {
                                                sampleDataVal: response.result,
                                                isCollection: angular.isArray(response.result)
                                            };
                                            if (vm.selectedSampleData.isCollection) {
                                                var arrText = '';
                                                _.forEach(vm.selectedSampleData.sampleDataVal, function (sampleText, index) {
                                                    arrText += index + '. ' + sampleText +'\n'
                                                });
                                                vm.selectedSampleData.arrText = arrText;
                                            }
                                            vm.isShowSampleData = true;
                                        } else if (response.error) {
                                            amaran.error(response.error);
                                            vm.isShowSampleData = false;
                                        } else {
                                            amaran.error('Something went wrong. Please try again.');
                                            vm.isShowSampleData = false;
                                        }
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        vm.isShowSampleData = false;
                                    }
                                }, function () {
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                    amaran.error('Something went wrong. Please try again.');
                                    vm.isShowSampleData = false;
                                });
                        } else {
                            Iot3WorkbenchFactory.evaluateXpath(inputObj)
                                .then(function (response) {
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                    if (response) {
                                        if (response.result) {
                                            vm.selectedSampleData = {
                                                sampleDataVal: response.result,
                                                isCollection: angular.isArray(response.result)
                                            };
                                            if (vm.selectedSampleData.isCollection) {
                                                var arrText = '';
                                                _.forEach(vm.selectedSampleData.sampleDataVal, function (sampleText, index) {
                                                    arrText += index + '. ' + sampleText +'\n'
                                                });
                                                vm.selectedSampleData.arrText = arrText;
                                            }
                                            vm.isShowSampleData = true;
                                        } else if (response.error) {
                                            amaran.error(response.error);
                                            vm.isShowSampleData = false;
                                        } else {
                                            amaran.error('Something went wrong. Please try again.');
                                            vm.isShowSampleData = false;
                                        }
                                    } else {
                                        amaran.error('Something went wrong. Please try again.');
                                        vm.isShowSampleData = false;
                                    }
                                }, function () {
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                    amaran.error('Something went wrong. Please try again.');
                                    vm.isShowSampleData = false;
                                });
                        }
                    } else if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'csv') {
                        var xmlData = convertCSVToXML(vm.sampleDataForSelectedAttr.sampleData);
                        var mainContainerForCSV = document.getElementById('lookupMainContainer');
                        var tempElemForCSV = document.createElement('div');
                        tempElemForCSV.id = 'workBenchSampleTest';
                        tempElemForCSV.style.visibility = 'hidden';
                        tempElemForCSV.innerHTML = xmlData;
                        mainContainerForCSV.appendChild(tempElemForCSV);
                        var htmlObjForCSV = {};
                        if (vm.expressionObj.expression.startsWith('//html')) {
                            htmlObjForCSV = getElementByXpath(vm.expressionObj.expression);
                        } else {
                            if (vm.expressionObj.expression.startsWith("//")) {
                                htmlObjForCSV = getElementByXpath(vm.expressionObj.expression.replace('//', '//div[@id = "workBenchSampleTest"]//'));
                            } else {
                                htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + vm.expressionObj.expression);
                            }
                            //htmlObjForCSV = getElementByXpath('//div[@id = "workBenchSampleTest"]/' + vm.expressionObj.expression);
                        }
                        if (htmlObjForCSV === null) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            vm.isShowSampleData = false;
                        } else {
                            if (htmlObjForCSV.innerHTML) {
                                vm.selectedSampleData = htmlObjForCSV.innerHTML;
                            } else {
                                vm.selectedSampleData = htmlObjForCSV;
                            }
                            vm.isShowSampleData = true;
                        }
                        tempElemForCSV.remove();
                    } else if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'oid') {
                        var oidJSon = fnConvertOidToJson(vm.sampleDataForSelectedAttr.sampleData);
                        if (oidJSon[vm.expressionObj.expression]) {
                            vm.selectedSampleData = oidJSon[vm.expressionObj.expression];
                            vm.isShowSampleData = true;
                        } else {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            vm.isShowSampleData = false;
                        }
                    } else if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'cookie') {
                        var tempCookieStr = vm.sampleDataForSelectedAttr.sampleData.toString();
                        var splitArr = tempCookieStr.split("\n");
                        var flag = true;
                        _.forEach(splitArr, function (splitStr) {
                            if (splitStr.startsWith('Cookie:')) {
                                flag = false;
                                if (splitStr.includes(vm.expressionObj.expression + "=")) {
                                    var cookieStr = splitStr.split(vm.expressionObj.expression + "=")[1];
                                    var finalVal = '';
                                    if (cookieStr.includes(';')) {
                                        finalVal = cookieStr.substr(0, cookieStr.indexOf(';'))
                                    } else {
                                        finalVal = cookieStr;
                                    }
                                    vm.selectedSampleData = finalVal;
                                    vm.isShowSampleData = true;
                                } else {
                                    amaran.error('Selected expression was not found in the sample data. Please try again.');
                                    vm.isShowSampleData = false;
                                }
                            }
                        });
                        if (flag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            vm.isShowSampleData = false;
                        }
                    } else if (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'header') {
                        var tempHeaderStr = vm.sampleDataForSelectedAttr.sampleData.toString();
                        var splitHeaderArr = tempHeaderStr.split("\n");
                        var HeaderFlag = true;
                        _.forEach(splitHeaderArr, function (splitStr) {
                            if (splitStr.startsWith(vm.expressionObj.expression + ':')) {
                                HeaderFlag = false;
                                vm.selectedSampleData = splitStr.split(vm.expressionObj.expression + ':')[1];
                                vm.isShowSampleData = true;
                            }
                        });
                        if (HeaderFlag) {
                            amaran.error('Selected expression was not found in the sample data. Please try again.');
                            vm.isShowSampleData = false;
                        }
                    } else {
                        vm.isShowSampleData = false;
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close({
                        expression: vm.expressionObj.expression,
                        selectedSampleData: vm.selectedSampleData
                    });
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 150)
                };

                vm.fnInitModel = function () {
                    if (vm.sampleDataForSelectedAttr.sampleDataType &&
                        (vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'html' ||
                            vm.sampleDataForSelectedAttr.sampleDataType.toLowerCase() === 'xml')) {
                        if (vm.sampleDataForSelectedAttr.sampleData && vm.sampleDataForSelectedAttr.sampleData.length) {
                            if (vm.sampleDataForSelectedAttr.sampleData.includes("</")) {
                                vm.sampleData = _.cloneDeepWith(vm.sampleDataForSelectedAttr.sampleData);
                            } else {
                                vm.sampleData = decodeURIComponent($base64.decode(_.cloneDeepWith(vm.sampleDataForSelectedAttr.sampleData)))
                            }
                        } else {
                            vm.sampleData = ''
                        }
                    } else {
                        if (vm.sampleDataForSelectedAttr.sampleData) {
                            vm.sampleData = _.cloneDeepWith(vm.sampleDataForSelectedAttr.sampleData)
                        } else {
                            vm.sampleData = ''
                        }
                    }

                    $timeout(function () {
                        vm.fnTestExpression();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createWorkspaceModalCtrl',
            function ($uibModalInstance, isScratch, isEdit, workSpaceObj) {
                var vm = this;
                vm.isScratch = isScratch;
                vm.isEdit = isEdit;
                vm.workspaceObj = {
                    name: vm.isEdit ? workSpaceObj.name : "",
                    description: vm.isEdit ? workSpaceObj.description : ""
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    if (vm.isEdit) {
                        $uibModalInstance.close({details: vm.workspaceObj});
                    } else {
                        $uibModalInstance.close({isScratch: vm.isScratch, details: vm.workspaceObj});
                    }
                };

                vm.fnInit = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('HealthSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, HealthFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.healthSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetHealthData = function () {
                    vm.healthSupplementalObj = vm.parent.healthObj.tags ? angular.fromJson(vm.parent.healthObj.tags) : {};
                    vm.healthSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.healthSupplementalObj, true) : vm.healthSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.healthSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.healthSupplementalObj)) {
                        angular.forEach(vm.healthSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.healthSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.healthSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.healthSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.healthSupplementalObj = angular.toJson(vm.healthSupplementalObj, true);
                    } else {
                        vm.healthSupplementalObj = angular.fromJson(vm.healthSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.healthSupplementalObj)) {
                            angular.forEach(vm.healthSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveHealthData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.healthObj.tags = {};
                    var inputObj = {
                        healthId: vm.parent.healthObj.id,
                        body: {}
                    };
                    if (!vm.parent.healthObj.tags) {
                        vm.parent.healthObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.healthObj.tags = angular.fromJson(vm.healthSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.healthObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.healthObj.tags;
                    HealthFactory.replaceNodeHealthTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Health successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitHealthSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitHealthSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.healthSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.healthSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.healthSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitHealthSupplemental = function () {
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewaySupplementalCtrl',
            function ($scope, $timeout, $window, amaran, DB, TabHeight, PermissionsService, GatewayFactory, $uibModal) {
                var vm = this;

                //var loginUser = DB.fnGet('loginUser');

                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.gatewaySupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnInjectFunction = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html',
                        size: 'lg',
                        controller: 'supplementFunctionModalCtrl as supplementModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (supplementalArr) {
                        _.forEach(supplementalArr, function (supplementalObj) {
                            if (supplementalObj.key && supplementalObj.value && supplementalObj.key.length && supplementalObj.value.length) {
                                var isFind = _.find(vm.supplementalKVPArr, {key: supplementalObj.key});
                                if(!isFind){
                                    vm.supplementalKVPArr.push(supplementalObj);
                                }else{
                                    isFind.value = supplementalObj.value;
                                }
                            }
                        });
                        _.remove(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            return supplementalKVPObj.key === '' && supplementalKVPObj.value === '';
                        });
                        if (!vm.supplementalKVPArr.length) {
                            vm.supplementalKVPArr = [{key: '', value: ''}];
                        }
                    }, function () {
                    });

                };


                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetGatewayData = function (gatewayObj) {
                    var inputObj = {
                        gatewayId: gatewayObj.id
                    };

                    GatewayFactory.getGateway(inputObj)
                        .then(function (response) {
                            vm.gatewaySupplementalObj = response.data ? angular.fromJson(response.data) : {};
                            /*{
                                lat: ["456"],
                                    long: ["789"]
                            };*/
                            vm.gatewaySupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.gatewaySupplementalObj,true):vm.gatewaySupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.gatewaySupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.gatewaySupplementalObj)) {
                                angular.forEach(vm.gatewaySupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value[0]
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isGatewaySupplementalDetailsLoaded = true;
                        })
                };
                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isSupplementalEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isSupplementalEditable = false;
                        vm.gatewaySupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };
                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.gatewaySupplementalObj = angular.toJson(vm.gatewaySupplementalObj, true);
                    } else {
                        vm.gatewaySupplementalObj = angular.fromJson(vm.gatewaySupplementalObj);
                        //vm.resetSupplementalObj = angular.copy(vm.gatewaySupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.gatewaySupplementalObj)) {
                            angular.forEach(vm.gatewaySupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value[0]
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                        vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnSaveGatewayData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.gatewayObj.data = {};
                    var inputObj = {
                        gatewayId: vm.parent.gatewayObj.id,
                        body: {}
                    };
                    if (!vm.parent.gatewayObj.data) {
                        vm.parent.gatewayObj.data = {};
                    }
                    angular.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                        if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                            vm.parent.gatewayObj.data[kpPairObj.key] = ["" + kpPairObj.value + ""];
                        }
                    });

                    inputObj.body = vm.parent.gatewayObj.data;
                    GatewayFactory.updateGatewayData(inputObj)
                        .then(function () {
                            amaran.success("Data added to Gateway successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitGatewaySupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.isCreateFromView = false;
                            vm.fnInitGatewaySupplemental();
                        })

                };

                vm.fnEditGatewayData = function (obj) {
                    vm.isSupplementalEditableUpdate = true;
                    var inputObj = {
                        gatewayId: vm.parent.gatewayObj.id,
                        body: {
                            data:  angular.fromJson(obj)
                        }
                    };
                    GatewayFactory.modifyGateway(inputObj)
                        .then(function () {
                            amaran.success("Data edited successfully");
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitGatewaySupplemental();
                        }, function () {
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitGatewaySupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if(isCalledEditMode){
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.gatewaySupplementalObj = angular.copy(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.gatewaySupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.gatewaySupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value[0]
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                };
                vm.fnInitGatewaySupplemental = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:gateway");
                    TabHeight.fnSet();
                    vm.isGatewaySupplementalDetailsLoaded = false;
                    if (vm.parent.gatewayObj.id) {
                        vm.fnGetGatewayData(vm.parent.gatewayObj);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayTopologyCtrl',
            function ($scope, $window, PermissionsService, ComponentFactory, DeviceFactory) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isGatewayTopologyDataLoaded = false;
                vm.relationshipObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetGatewayDevices = function (gatewayId) {
                    vm.isGatewayTopologyDataLoaded = false;
                    var devicesArr = [];
                    var inputObj = {
                        q: "(term field=gatewayid '" + gatewayId + "')",
                        size: 100,
                        start: 0
                    };
                    vm.fnGetDevices(inputObj, devicesArr);
                };

                vm.fnGetDevices = function (inputObj, devicesArr) {
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) {
                            var tempDeviceObj = {};
                            _.forEach(res.hit, function (hitObj) {
                                tempDeviceObj = {};
                                _.forEach(hitObj.fields, function (value, key) {
                                    var tempNewKey = '';
                                    switch (key) {
                                        case "typeid":
                                            tempNewKey = 'typeId';
                                            break;
                                        case "gatewayid":
                                            tempNewKey = 'gatewayId';
                                            break;
                                        case "clusterids":
                                            tempNewKey = 'clusterIds';
                                            break;
                                        default:
                                            tempNewKey = key;
                                            break
                                    }
                                    if (key !== 'clusterids') {
                                        tempDeviceObj[tempNewKey] = value[0];
                                    } else {
                                        tempDeviceObj[tempNewKey] = value;
                                    }
                                });
                                var typeObj = _.find(vm.parent.deviceTypesArr, {'id': tempDeviceObj.typeId});
                                tempDeviceObj.hasComponents = !!(typeObj && typeObj.hasComponents);
                                tempDeviceObj.type = 'device';
                                devicesArr.push(tempDeviceObj);
                            });
                            if (devicesArr.length < res.found) {
                                var inputObjTemp = {
                                    start: inputObj.start + inputObj.size,
                                    size: inputObj.size,
                                    q: inputObj.q,
                                    sort: inputObj.sort
                                };
                                vm.fnGetDevices(inputObjTemp, devicesArr, true);
                            } else {
                                vm.devicesArr = angular.copy(devicesArr);
                                vm.isGatewayTopologyDataLoaded = true;
                                vm.fnCreateRelationship();
                            }
                        })
                };

                vm.fnCreateRelationship = function () {
                    vm.relationshipObj = vm.parent.gatewayObj;
                    vm.relationshipObj.type = 'gateway';
                    vm.relationshipObj.children = vm.devicesArr;
                };

                vm.fnInitGatewayTopology = function () {
                    vm.fnSetTabHeight();
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.componentPermissionObj = PermissionsService.getPermissions("node:component");
                    if (vm.devicePermissionObj.List) {
                        vm.fnGetGatewayDevices(vm.parent.gatewayObj.id);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayOverviewCtrl',
            function ($http, $window, $scope, $state, $timeout, $uibModal, $cookies, amaran, moment, TabHeight, PermissionsService,
                      analyticsService, IconService, ColorService, AnalyticsFactory, DeviceFactory) {
                var vm = this;
                var startTime = "";
                var endTime = "";
                vm.parent = $scope.$parent;
                vm.infoSectionClass = vm.parent.infoSectionClass;

                /*START: CHART ARRAYS*/
                vm.healthData = [];
                vm.barData = [];
                vm.gatewayPieData = [];
                vm.gatewayHealthPieData = [];
                vm.GatewayConnectionPieData = [];
                vm.categoriesArr = ["Gateway"];
                vm.isShowDeviceConnection = false;
                /*END: CHART ARRAYS*/

                /*START: CHART LOADERS*/
                vm.isGatewayAggregateDataLoading = true;
                vm.isBarCharLoading = true;
                vm.isPieChartLoading = true;
                /*END: CHART LOADERS*/

                /*START: FILTER OPTIONS*/
                vm.filterOptions = [{
                    value: '1h',
                    tabIndex: 0,
                    name: '1',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3h',
                    tabIndex: 1,
                    name: '3',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '12h',
                    tabIndex: 2,
                    name: '12',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3d',
                    tabIndex: 3,
                    name: '3',
                    units: 'days',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '1w',
                    tabIndex: 4,
                    name: '1',
                    units: 'weeks',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: 'Custom',
                    tabIndex: 5
                }];
                vm.chartOptions = [{
                    name: 'Area Chart',
                    icon: 'fa-area-chart',
                    tabIndex: 0
                }, {
                    name: 'Pie Chart',
                    icon: 'fa-pie-chart',
                    tabIndex: 1
                }];
                vm.selectedFilterOption = vm.filterOptions[1];
                vm.selectedFilterObj = vm.filterOptions[1];
                vm.selectedChartType = vm.chartOptions[0];
                vm.selectedAggregateFn = 'MEAN';
                /*END: FILTER OPTIONS*/
                vm.isShowLabel = false;

                vm.fnGetAnalyticsQueryData = function () {
                    vm.isGatewayAggregateDataLoading = true;
                    vm.isBarCharLoading = true;
                    var inputObj = {
                        "dataSets": ["AGGREGATE", "CONNECTION"],
                        "nodeId": vm.parent.gatewayObj.id,
                        "timeRange": {}
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };

                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        vm.aggregateCategoriesArr = [];
                        startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsData = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if(response && response.data && response.data.data){
                                vm.analyticsData = response.data.data;
                            }else{
                                vm.analyticsData = {};
                            }
                            if(response && response.data && response.data.meta){
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            }else{
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnGetAnalyticsQuery(timeStampsArr);
                        vm.fnGetConnectionData(timeStampsArr);
                    }, function error() {
                        vm.analyticsData = {};
                        vm.aggregateCategoriesArr = [];
                        startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnGetAnalyticsQuery(timeStampsArr);
                        vm.fnGetConnectionData(timeStampsArr);
                    });
                };

                vm.fnGetAnalyticsQuery = function (timeStampsArr) {
                    vm.aggregateHealthArr = [];
                    if (vm.analyticsData && vm.analyticsData.AGGREGATE && vm.analyticsData.AGGREGATE.points) {
                        var gatewayAnalyticsb64String = vm.analyticsData.AGGREGATE.points;
                        var gatewayAnalyticsCSVString = analyticsService.getCSVString(gatewayAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAggregateHealthData(gatewayAnalyticsCSVString);
                        var gatewayPieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.length) {
                            vm.aggregateHealthArr = tempAggregateHealthArr;
                            var gatewayPieChartString = vm.analyticsData.AGGREGATE.summary;
                            var gatewayPieChartAnalyticsCSVString = analyticsService.getCSVString(gatewayPieChartString);
                            gatewayPieChartAnalyticsData = analyticsService.getAggregateHealthPieChartData(gatewayPieChartAnalyticsCSVString);
                        } else {
                            gatewayPieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        }
                        vm.fnGeneratePieData(gatewayPieChartAnalyticsData);
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        vm.fnGeneratePieData(pieChartAnalyticsData);
                    }
                    vm.isGatewayAggregateDataLoading = false;
                };

                vm.fnCreateAggregateStaticHealth = function (timeStampsArr) {
                    var analyticsHealthArr = [];
                    var tempIndex = 0;
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var healthObj = ColorService.getHealthColorForLoop(parseInt(vm.parent.gatewayObj.health));
                        vm.aggregateHealthArr.push({
                            x: 0,
                            y: tempIndex,
                            value: parseInt(vm.parent.gatewayObj.health),
                            color: healthObj['background-color'],
                            healthObj: healthObj,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsHealthArr.push({
                            duration: 100,
                            health: parseInt(vm.parent.gatewayObj.health),
                            healthObj: healthObj,
                            id: vm.parent.gatewayObj.id,
                            percentage: 100,
                            marker: {fillColor: healthObj['background-color']}
                        });
                        tempIndex++
                    });
                    return analyticsHealthArr;
                };

                vm.fnGetConnectionData = function (timeStampsArr) {
                    vm.gatewayConnectionArr = [];
                    if (vm.analyticsData && vm.analyticsData.CONNECTION && vm.analyticsData.CONNECTION.points) {
                        var gatewayAnalyticsb64String = vm.analyticsData.CONNECTION.points;
                        var gatewayAnalyticsCSVString = analyticsService.getCSVString(gatewayAnalyticsb64String);
                        var tempConnectionArr = analyticsService.getConnectionData(gatewayAnalyticsCSVString);
                        var gatewayConnectionPieChartAnalyticsData = [];
                        if (tempConnectionArr.length) {
                            vm.gatewayConnectionArr = tempConnectionArr;
                            var gatewayPieChartString = vm.analyticsData.CONNECTION.summary;
                            var gatewayPieChartAnalyticsCSVString = analyticsService.getCSVString(gatewayPieChartString);
                            gatewayConnectionPieChartAnalyticsData = analyticsService.getConnectionPieData(gatewayPieChartAnalyticsCSVString);
                        } else {
                            gatewayConnectionPieChartAnalyticsData = vm.fnCreateConnectionStaticData(timeStampsArr);
                        }
                        vm.fnGenerateConnectionPieData(gatewayConnectionPieChartAnalyticsData);
                    } else {
                        var gatewayConnectionPieChart = vm.fnCreateConnectionStaticData(timeStampsArr);
                        vm.fnGenerateConnectionPieData(gatewayConnectionPieChart);
                    }
                    vm.isBarCharLoading = false;
                };

                vm.fnCreateConnectionStaticData = function (timeStampsArr) {
                    var analyticsConnectionPieArr = [];
                    var tempIndex = 0;
                    var connectionStatus = vm.parent.gatewayObj.connection === "CONNECTED" ? "connected":"disconnected";
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var connectionColor = ColorService.getConnectionColor(vm.parent.gatewayObj.connection).color;
                        vm.gatewayConnectionArr.push({
                            x: 0,
                            y: tempIndex,
                            value: "-",
                            connection: connectionStatus,
                            color: connectionColor,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsConnectionPieArr.push({
                            duration: 100,
                            percentage: 100,
                            connection: connectionStatus
                        });
                        tempIndex++
                    });
                    return analyticsConnectionPieArr;
                };

                vm.fnGenerateConnectionPieData = function (barData) {
                    var pieData = [];
                    var groupedConnectionObj = _.groupBy(barData, function (x) {
                        return x.connection
                    });
                    _.forEach(groupedConnectionObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        pieData.push({
                            name: key,
                            y: totalP,
                            color: ColorService.getConnectionColor(key).color,
                            healthTextColor: ColorService.getConnectionColor(key).color
                        })
                    });
                    vm.gatewayConnectionPieData = pieData;
                };

                vm.fnGeneratePieData = function (healthArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(healthArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: totalP,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.gatewayHealthPieData = pieData;
                };

                vm.fnGetGatewayDevices = function (gatewayId, preDefinedDevices, isCalledForViz) {
                    vm.isPieChartLoading = true;
                    var inputObj = {
                        q: "(term field=gatewayid '" + gatewayId + "')",
                        size: 100,
                        start: 0
                    };
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) {
                            var devicesArr = isCalledForViz ? preDefinedDevices : [];
                            var tempDeviceObj = {};
                            _.forEach(res.hit, function (hitObj) {
                                tempDeviceObj = {};
                                _.forEach(hitObj.fields, function (value, key) {
                                    var tempNewKey = '';
                                    switch (key) {
                                        case "typeid":
                                            tempNewKey = 'typeId';
                                            break;
                                        case "gatewayid":
                                            tempNewKey = 'gatewayId';
                                            break;
                                        case "clusterids":
                                            tempNewKey = 'clusterIds';
                                            break;
                                        default:
                                            tempNewKey = key;
                                            break
                                    }
                                    if (key !== 'clusterids') {
                                        tempDeviceObj[tempNewKey] = value[0];
                                    } else {
                                        tempDeviceObj[tempNewKey] = value;
                                    }
                                });
                                devicesArr.push(tempDeviceObj);
                            });
                            if (devicesArr.length < res.found) {
                                var inputObjTemp = {
                                    start: inputObj.start + inputObj.size,
                                    size: inputObj.size,
                                    q: inputObj.q,
                                    sort: inputObj.sort
                                };
                                vm.fnGetDevices(inputObjTemp, devicesArr, true);
                            } else {
                                vm.devicesArr = angular.copy(devicesArr);
                                vm.totalItems = parseInt(res.found);
                                vm.fnGenerateComponentsPieData(vm.devicesArr);
                            }
                        })
                };

                vm.fnGenerateComponentsPieData = function (inventoriesArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(inventoriesArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: val.length,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.gatewayPieData = pieData;
                    vm.isPieChartLoading = false;
                };

                vm.fnGoToDevices = function () {
                    var filterArr = [{
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        name: "gatewayid term: " + vm.parent.gatewayObj.id.toLowerCase(),
                        selectedField: "gatewayid",
                        selectedFilter: {
                            operatorName: "term",
                            operator: "term"
                        },
                        searchText: vm.parent.gatewayObj.id.toLowerCase()
                    }];
                    $state.go('main.device', {q: angular.toJson(filterArr)});
                };

                vm.fnChangeChartType = function (charType) {
                    if (vm.selectedChartType.tabIndex !== charType.tabIndex) {
                        vm.selectedChartType = charType;
                    }
                };

                vm.fnChangeFilterOption = function (filterOption) {
                    if ((vm.filterOptions.length - 1) === filterOption.tabIndex) {
                        vm.fnOpenDateTimeHelpModal();
                    }
                    if (vm.selectedFilterOption.tabIndex !== filterOption.tabIndex) {
                        vm.selectedFilterOption = filterOption;

                        if ((vm.filterOptions.length - 1) !== filterOption.tabIndex) {
                            vm.selectedFilterObj = filterOption;
                            startTime = _.cloneDeepWith(parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x')));
                            endTime = Date.now();
                            vm.healthData = [];
                            vm.barData = [];
                            vm.fnGetAnalyticsQueryData();
                        }
                    }
                };

                vm.fnOpenDateTimeHelpModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html',
                        size: 'lg',
                        controller: 'analyticsDateTimeHelpModalCtrl as analyticsDateTimeModal',
                        resolve: {
                            selectedTime: function () {
                                return vm.selectedFilterObj;
                            },
                            selectedAggregateFn: function () {
                                return vm.selectedAggregateFn;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.selectedFilterObj = response.selectedTime;
                        vm.selectedAggregateFn = response.selectedAggregateFn;
                        vm.healthData = [];
                        if (vm.selectedFilterObj.type === "absolute") {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        } else {
                            startTime = _.cloneDeepWith(parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x')));
                            endTime = Date.now();
                        }
                        vm.fnGetAnalyticsQuery(vm.parent.gatewayObj.id);
                        vm.barData = [];
                        vm.fnGetAnalyticsQueryData();
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 1000)
                    }, function () {
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 1000)
                    });
                };

                $scope.$on('redrawChart', function (evt, data) {
                    vm.infoSectionClass = data;
                });

                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };

                vm.fnInitGatewayOverview = function () {
                    startTime = _.cloneDeepWith(parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x')));
                    endTime = Date.now();
                    vm.fnGetAnalyticsQueryData();
                    vm.fnGetGatewayDevices(vm.parent.gatewayObj.id);
                    TabHeight.fnSet();
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayLocationCtrl',
            function ($scope, $window, $timeout,  $q, Paho, PermissionsService, amaran, TabHeight, GatewayFactory, L) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isGatewayLocationDetailsLoaded = false;
                vm.isSaveLoaderActive = false;
                vm.latitude = '';
                vm.longitude = '';
                vm.actualLatitude = '';
                vm.actualLongitude = '';
                var map = "";
                var marker = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element("#locationInputBlock")[0]) && angular.isDefined(angular.element("#map1")[0])) {
                        var contentMain = angular.element(".content-main")[0].offsetHeight;
                        var inputContainer = angular.element("#locationInputBlock")[0].offsetHeight;
                        var locationSaveActionBlock = 0;
                        if (angular.element("#locationSaveActionBlock")[0]) {
                            locationSaveActionBlock = angular.element("#locationSaveActionBlock")[0].offsetHeight;
                        }
                        var fianlMapHeight = contentMain - (inputContainer + locationSaveActionBlock + 40);
                        angular.element("#map1").css('height', fianlMapHeight + 'px');
                    }
                };

                vm.fnGetGatewayLocation = function (gatewayObj) {
                    var inputObj = {
                        gatewayId: gatewayObj.id
                    };
                    GatewayFactory.getGateway(inputObj)
                        .then(function (response) {
                            vm.gatewayObj = response;
                            if (vm.gatewayObj.location && vm.gatewayObj.location.length) {
                                vm.latitude = parseFloat(vm.gatewayObj.location.split(',')[0]);
                                vm.longitude = parseFloat(vm.gatewayObj.location.split(',')[1]);
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            $timeout(function () {
                                vm.isGatewayLocationDetailsLoaded = true;
                                $timeout(function () {
                                    document.getElementById('gatewayLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                    var mapOptions = {};
                                    mapOptions.center = [vm.latitude, vm.longitude];
                                    mapOptions.zoom = 8;
                                    mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                    map = new L.Map('map1', mapOptions);
                                    marker = L.marker([vm.latitude, vm.longitude], {
                                        draggable: true
                                    }).addTo(map);
                                    $timeout(function () {
                                        vm.fnSetTabHeight();
                                    });
                                    marker.on('drag', function () {
                                        $timeout(function () {
                                            vm.actualLatitude = marker.getLatLng().lat;
                                            vm.actualLongitude = marker.getLatLng().lng;
                                        })
                                    });
                                    $timeout(function () {
                                        map.invalidateSize()
                                    });
                                }, 100)
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $timeout(function () {
                                vm.isGatewayLocationDetailsLoaded = true;
                            })
                        })
                };

                vm.fnSaveLocationInfo = function(){
                    vm.isSaveLoaderActive = true;
                    var inputObj = {
                        body: {},
                        gatewayId: vm.gatewayObj.id
                    };

                    inputObj.body = {
                        location: vm.actualLatitude+","+vm.actualLongitude
                    };

                    GatewayFactory.modifyGateway(inputObj)
                        .then(function (response) {
                            vm.gatewayObj = response;
                            if (vm.gatewayObj.location && vm.gatewayObj.location.length) {
                                vm.latitude = parseFloat(vm.gatewayObj.location.split(',')[0]);
                                vm.longitude = parseFloat(vm.gatewayObj.location.split(',')[1]);
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            vm.isSaveLoaderActive = false;
                            $timeout(function () {
                                document.getElementById('gatewayLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                var mapOptions = {};
                                mapOptions.center = [vm.latitude, vm.longitude];
                                mapOptions.zoom = 8;
                                mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                map = new L.Map('map1', mapOptions);
                                marker = L.marker([vm.latitude, vm.longitude], {
                                    draggable: true
                                }).addTo(map);
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                });
                                marker.on('drag', function () {
                                    $timeout(function () {
                                        vm.actualLatitude = marker.getLatLng().lat;
                                        vm.actualLongitude = marker.getLatLng().lng;
                                    })
                                });
                                $timeout(function () {
                                    map.invalidateSize()
                                });
                            }, 100);
                            amaran.success("Location Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveLoaderActive = false;
                        });
                };

                vm.fnChangeLocation = function () {
                    if (vm.actualLatitude.length && vm.actualLongitude.length) {
                        var newLatLng = new L.LatLng(vm.actualLatitude, vm.actualLongitude);
                        marker.setLatLng(newLatLng);
                        map.setView(marker.getLatLng(), map.getZoom());
                    }
                };

                vm.fnInitGatewayLocation = function () {
                    vm.gatewayPermissionsObj = PermissionsService.getPermissions("node:gateway");
                    TabHeight.fnSet();
                    vm.isGatewayLocationDetailsLoaded = false;
                    if (vm.parent.gatewayObj.id) {
                        vm.fnGetGatewayLocation(vm.parent.gatewayObj);
                    }
                };


            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayGhostCtrl',
            function ($scope, $http, $window, $timeout, $state, $stateParams, $q, $uibModal, $cookies, Paho, ColorService, PermissionsService, DB,
                      moment, amaran, swal, TabHeight, SchemaService, GhostService, GatewayFactory, TypeFactory,
                      WebSocketFactory, UserFactory, FedSudoUserService, AppInitService, AnalyticsFactory,
                      jsonToCsvConvertService, XLSX, analyticsService) {
                var vm = this;
                var overLayWebSocketTimeout;
                var client;
                var count = 0;
                vm.parent = $scope.$parent;
                vm.isTableViewVisible = true;
                vm.isGhostDetailsEditable = false;
                vm.isGhostUpdateCompleted = true;
                vm.gatewayGhostObj = {};
                vm.selectedGhostObj = {};
                vm.ghostUpdateObj = {};
                vm.isEditInputValidated = false;
                vm.filter = "$";
                vm.search = {$: ''};

                vm.tabs = [
                    {
                        icon: "fa-table",
                        tabIndex: 0
                    }
                ];
                vm.selectedTab = {};
                vm.tableOptionsObj = {
                    health: true,
                    name: true,
                    value: true,
                    display: true
                };
                var currentTime = Date.now();
                var hours = 3;
                vm.isShowAllGhostAttributes = false;
                vm.recentlyUpdatedComponentReportedArr = [];
                vm.unhealthyComponentReportedArr = [];
                vm.currentTime = '';
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTreeHeight();
                });

                vm.fnSetTreeHeight = function () {
                    if (angular.isDefined(angular.element(".ghostLayoutContainer")[0]) &&
                        angular.isDefined(angular.element(".viewGhostSearchBar")[0])) {
                        var total, search, finalHeight;
                        total = angular.element(".ghostLayoutContainer")[0].offsetHeight;
                        search = angular.element(".viewGhostSearchBar")[0].offsetHeight;
                        finalHeight = total - (search + 51);
                        angular.element(".ghostAttributesLayout-table-normal #gatewayReportedArr").css('height', finalHeight + 'px');
                        var unhealthyComponentFinalHeight = angular.copy(finalHeight / 2) - (20 + 34 + 10);
                        var recentlyUpdatedComponentFinalHeight = angular.copy(finalHeight / 2) - (34 + 20 + 10);
                        angular.element(".ghostAttributesLayout-table-normal #noComponentReportedData").css('height', finalHeight + 'px');
                        angular.element(".ghostAttributesLayout-table-normal #unhealthyComponentReported").css('height', (unhealthyComponentFinalHeight + 35) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal #recentlyUpdatedComponentReported").css('height', (recentlyUpdatedComponentFinalHeight + 35) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal tbody#unhealthyComponentReportedArr").css('height', (unhealthyComponentFinalHeight) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal tbody#recentlyUpdatedComponentReportedArr").css('height', (recentlyUpdatedComponentFinalHeight) + 'px');
                    }
                };

                //Context Menu: Start
                vm.attributesContextMenu = function (deviceGhostObj) {
                    return [{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnRenameAttribute(deviceGhostObj);
                        }
                    }]
                };
                //Context Menu: End

                vm.fnRefreshRelativeGatewayGhostTime = function () {
                    angular.forEach(vm.gatewayReportedArr, function (gatewayGhostObj) {
                        gatewayGhostObj.humanDateLastUpdatedRelative = moment(gatewayGhostObj.humanTimestamp).fromNow();
                    });
                    vm.repeatativeGatewayGhostTimer = $timeout(function () {
                        vm.fnRefreshRelativeGatewayGhostTime();
                    }, 60000)
                };

                vm.fnGetGatewayGhost = function (gatewayObj) {
                    var inputObj = {
                        gatewayId: gatewayObj.id
                    };

                    GatewayFactory.getGatewayGhost(inputObj)
                        .then(function (response) {
                            vm.gatewayGhostObj = response;
                            vm.gatewayReportedArr = [];
                            Object.keys(vm.gatewayGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.gatewayGhostObj[key].name;
                                tempObj.value = vm.gatewayGhostObj[key].reported ? vm.gatewayGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.gatewayGhostObj[key].enabled) ? vm.gatewayGhostObj[key].enabled : true;
                                tempObj.health = vm.gatewayGhostObj[key].health ? vm.gatewayGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.gatewayGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.gatewayGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.displayName = vm.gatewayGhostObj[key].displayName;
                                tempObj.unit = angular.isDefined(vm.gatewayGhostObj[key].unit) ? vm.gatewayGhostObj[key].unit : "";
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                tempObj.displayValue = tempObj.enabled === false? 'disabled':tempObj.value === "__empty" ? "": tempObj.value;
                                vm.gatewayReportedArr.push(tempObj);
                            });
                            $timeout(function () {
                                $timeout.cancel(vm.repeatativeGatewayGhostTimer);
                                vm.fnRefreshRelativeGatewayGhostTime();
                            }, 60000);
                            vm.fnGetTypeDefinition(vm.gatewayReportedArr);
                            count = 0;
                            vm.currentTime = moment();
                            vm.isAttributeAnalyticsDataFetch = true;
                            vm.fnInitAttributeAnalytics(count);
                        })
                };

                vm.fnDownloadXls = function () {
                    var gatewayGhostArrCp = angular.copy(vm.gatewayGhostObj);
                    var tempData = _.map(gatewayGhostArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "GatewayGhost");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "gatewayGhost_" + $stateParams.selectedId + ".xlsx");
                };
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchorGhost')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchorGhost').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = angular.copy(vm.gatewayGhostObj);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    Object.keys(tempData).map(function(key) {
                        vm.csvHeaderArr = Object.keys(tempData[key]);
                        return vm.csvHeaderArr;
                    });
                    return _.map(data[1], function (deviceGhostObj) {
                        var tempObj = {};
                        _.forEach(vm.csvHeaderArr, function (headerText) {
                            tempObj[headerText] = deviceGhostObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnGetTypeDefinition = function (gatewayReportedArr) {
                    TypeFactory.getType({typeId: vm.parent.gatewayObj.typeId})
                        .then(function (response) {
                            if (Object.keys(response.definitions).length) {
                                angular.forEach(gatewayReportedArr, function (gatewayReportedObj) {
                                    Object.keys(response.definitions).forEach(function (key) {
                                        if (gatewayReportedObj.name === key) {
                                            gatewayReportedObj.editable = true;
                                            var inputObj = {};
                                            inputObj[key] = response.definitions[key];
                                            gatewayReportedObj.schema = SchemaService.convertJsonToSchema(inputObj);
                                            angular.forEach(gatewayReportedObj.schema, function (tempObj) {
                                                if (tempObj.default) {
                                                    tempObj.typeValue = tempObj.default;
                                                } else {
                                                    tempObj.typeValue = "";
                                                }
                                                tempObj.isValueMissing = false;
                                                tempObj.isPatternMismatch = false;
                                                tempObj.isMinError = false;
                                                tempObj.isMaxError = false;
                                            });
                                        }
                                    })
                                });
                                vm.selectedTab = vm.tabs[0];
                                vm.isGatewayGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                });
                            } else {
                                vm.selectedTab = vm.tabs[0];
                                vm.isGatewayGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                });
                            }
                            vm.fnGetUnhealthyAndHealthyAttribute(gatewayReportedArr);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.selectedTab = vm.tabs[0];
                            vm.isGatewayGhostDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            });
                            vm.fnGetUnhealthyAndHealthyAttribute(gatewayReportedArr);
                        })
                };

                vm.fnGetUnhealthyAndHealthyAttribute = function (gatewayReportedArr) {
                    vm.recentlyUpdatedComponentReportedArr = [];
                    vm.unhealthyComponentReportedArr = [];
                    currentTime = Date.now();
                    _.forEach(gatewayReportedArr, function (gatewayReporedObj) {
                        var recentlyUpdateTimeStampData = hours * 60 * 60 * 1000;
                        var deviceTimeStampDiff = currentTime - gatewayReporedObj.timestamp;
                        if (deviceTimeStampDiff <= recentlyUpdateTimeStampData) {
                            vm.recentlyUpdatedComponentReportedArr.push(gatewayReporedObj);
                        }
                        if (gatewayReporedObj.health > 299) {
                            vm.unhealthyComponentReportedArr.push(gatewayReporedObj);
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnUpdateAttributeOnWSS = function (obj) {
                    var recentlyUpdatedIndex = _.findIndex(vm.recentlyUpdatedComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (recentlyUpdatedIndex !== -1) {
                        vm.recentlyUpdatedComponentReportedArr.splice(recentlyUpdatedIndex, 1);
                    }
                    var unhealthyComponentIndex = _.findIndex(vm.unhealthyComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (unhealthyComponentIndex !== -1) {
                        vm.unhealthyComponentReportedArr.splice(unhealthyComponentIndex, 1);
                    }
                    vm.recentlyUpdatedComponentReportedArr.push(obj);
                    if (obj.health > 299) {
                        vm.unhealthyComponentReportedArr.push(obj);
                    }
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnEditGhostValue = function (gatewayGhostObj) {
                    vm.selectedGhostObj = gatewayGhostObj.schema;
                    vm.fnOpenModifyGhostAttributeModal();
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isEditInputValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.ghostUpdateObj = propertiesObj;
                    } else {
                        vm.ghostUpdateObj = {};
                    }
                };

                vm.fnGoBackToTableView = function () {
                    vm.selectedGhostObj = {};
                    vm.isGhostDetailsEditable = false;
                };

                vm.fnUpdateGhostValue = function () {
                    vm.isGhostUpdateCompleted = false;
                    var inputObj = {
                        gatewayId: vm.parent.gatewayObj.id,
                        body: {
                            state: {
                                metadata: vm.ghostUpdateObj
                            }
                        }
                    };
                    GatewayFactory.modifyGatewayGhost(inputObj)
                        .then(function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isGatewayGhostDetailsLoaded = false;
                            vm.fnGetGatewayGhost(vm.parent.gatewayObj);
                            amaran.success("Ghost Value Updated");
                        }, function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isGatewayGhostDetailsLoaded = false;
                            vm.fnGetGatewayGhost(vm.parent.gatewayObj);
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.gatewayReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostGatewaysArr = angular.copy(vm.gatewayReportedArr);
                    } else {
                        vm.selectedGhostGatewaysArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.gatewayReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                };

                vm.isEmptyObject = function (obj) {
                    return Object.keys(obj).length;
                };

                vm.fnGetHealthColor = function (health, gatewayGhostObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayGhostObj.healthName = healthObj.content;
                    if (gatewayGhostObj.healthName === health) {
                        gatewayGhostObj.toolTipName = health;
                    } else {
                        gatewayGhostObj.toolTipName = gatewayGhostObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    $timeout.cancel(overLayWebSocketTimeout);
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.gatewayReportedArr, function (ghostObj) {
                        return ghostObj.name === messageJson.name;
                    });
                    if (index !== -1 && vm.gatewayReportedArr[index]) {
                        if (messageJson.health) {
                            vm.gatewayReportedArr[index].health = messageJson.health;
                            var healthObj = ColorService.getHealthColorForLoop(vm.gatewayReportedArr[index].health);
                            vm.gatewayReportedArr[index].healthName = healthObj.content;
                            vm.gatewayReportedArr[index].healthColor = healthObj['background-color'];
                            vm.gatewayReportedArr[index].textColor = healthObj.color;
                            if (vm.gatewayReportedArr[index].healthName === vm.gatewayReportedArr[index].health) {
                                vm.gatewayReportedArr[index].toolTipName = vm.gatewayReportedArr[index].health;
                            } else {
                                vm.gatewayReportedArr[index].toolTipName = vm.gatewayReportedArr[index].healthName + " "
                                    + vm.gatewayReportedArr[index].health;
                            }
                        }
                        if (messageJson.value) {
                            vm.gatewayReportedArr[index].value = messageJson.value;
                            vm.gatewayReportedArr[index].displayValue = vm.gatewayReportedArr[index].enabled === false? 'disabled':vm.gatewayReportedArr[index].value === "__empty" ? "": vm.gatewayReportedArr[index].value;
                        }
                        vm.gatewayReportedArr[index].timestamp = Math.floor(Date.now() / 1000);
                        vm.gatewayReportedArr[index].humanTimestamp = moment.unix(vm.gatewayReportedArr[index].timestamp).format("MM/DD/YYYY HH:mm:ss");
                        vm.gatewayReportedArr[index].humanDateLastUpdatedAbsolute = moment.unix(vm.gatewayReportedArr[index].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                        vm.gatewayReportedArr[index].humanDateLastUpdatedRelative = moment(vm.gatewayReportedArr[index].humanTimestamp).fromNow();
                        $timeout(function () {
                            vm.gatewayReportedArr[index].isProcessing = false;
                        });
                        angular.element($window).triggerHandler('resize');
                        $timeout(function () {
                            vm.fnUpdateAttributeOnWSS(vm.gatewayReportedArr[index]);
                        });
                    }
                }


                vm.fnInitializeWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/attributes/" + vm.parent.gatewayObj.id})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("gateway ghost websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("gateway ghost websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnShowAllGhostAttributes = function () {
                    vm.isShowAllGhostAttributes = true;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenModifyGhostAttributeModal = function () {
                    var inputObj = {
                        gatewayId: vm.parent.gatewayObj.id,
                        body: {}
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/modifyGhostAttribute/modifyGhostAttribute.html',
                        size: 'md',
                        controller: 'modifyGhostAttributeCtrl as modifyGhostAttribute',
                        resolve: {
                            selectedGhostObj: function () {
                                return angular.copy(vm.selectedGhostObj);
                            },
                            ghostType: function () {
                                return 'Gateway'
                            },
                            requiredInputObj: function () {
                                return inputObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        vm.selectedGhostObj = {};
                    }, function () {
                        vm.selectedGhostObj = {};
                    });
                };

                vm.fnInitAttributeAnalytics = function (count) {
                    vm.isAttributeAnalyticsDataFetch = false;
                    if (count < vm.gatewayReportedArr.length) {
                        vm.fnGetAttributeAnalyticsValue(count);
                    } else {
                        $timeout(function () {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        });
                    }
                };

                vm.fnGetAttributeAnalyticsValue = function (count) {
                    if (vm.gatewayReportedArr[count].health > 299 ) {
                        var duration = moment.duration(vm.currentTime.diff(vm.gatewayReportedArr[count].timestamp));
                        var minutes = duration.asMinutes();
                        if (minutes < 10) {
                            var inputObj = {
                                dataSets: ["ATOMIC"],
                                nodeId: vm.parent.gatewayObj.id,
                                timeRange: {
                                    relative: {
                                        start: "10m"
                                    }
                                },
                                attributeQuery: {
                                    attributeName: vm.gatewayReportedArr[count].name,
                                    queryType: "VALUE"
                                }
                            };
                            var headers = {
                                'Content-Type': 'application/json',
                                'x-pre-api-version': '4',
                                'authorization': 'Bearer ' + $cookies.get('phoenix')
                            };
                            var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                            $http({
                                method: "POST",
                                url: apiURL,
                                responseType: 'application/json',
                                headers: headers,
                                data: inputObj
                            }).then(function (response) {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                if (response && response.status && response.data &&
                                    !response.status.toString().startsWith('20')) {
                                    vm.analyticsValueData = {};
                                    amaran.error(response.data.message);
                                } else {
                                    if(response && response.data && response.data.data){
                                        vm.analyticsValueData = response.data.data;
                                    }else{
                                        vm.analyticsValueData = {};
                                    }
                                    if (response && response.data && response.data.meta) {
                                        startTime = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                        endTime = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                    }
                                }
                                if (vm.analyticsValueData && vm.analyticsValueData.ATOMIC && vm.analyticsValueData.ATOMIC.points) {
                                    var attributeAnalyticsb64String = vm.analyticsValueData.ATOMIC.points;
                                    var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                                    var tempAggregateHealthArr = analyticsService.getAttributeValueData(attributeAnalyticsCSVString);
                                    if (tempAggregateHealthArr.attributeValueData.length) {
                                        var analyticsAttrValueArr = [];
                                        var valuesArr = tempAggregateHealthArr.attributeValuesArr.sort(function (a, b) {
                                            return a - b;
                                        });
                                        _.forEach(tempAggregateHealthArr.attributeValueData, function (obj) {
                                            analyticsAttrValueArr.push({
                                                x: obj.x,
                                                y: valuesArr.indexOf(obj.y),
                                                name: obj.y
                                            })
                                        });
                                        vm.gatewayReportedArr[count].inlineChartData = analyticsAttrValueArr;
                                    } else {
                                        vm.gatewayReportedArr[count].inlineChartData = [{
                                            x: startTime,
                                            y: 0,
                                            name: vm.gatewayReportedArr[count].value
                                        }, {
                                            x: endTime,
                                            y: 0,
                                            name: vm.gatewayReportedArr[count].value
                                        }];
                                    }
                                    count++;
                                    if (count < vm.gatewayReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                } else {
                                    vm.gatewayReportedArr[count].inlineChartData = [{
                                        x: startTime,
                                        y: 0,
                                        name: vm.gatewayReportedArr[count].value
                                    }, {
                                        x: endTime,
                                        y: 0,
                                        name: vm.gatewayReportedArr[count].value
                                    }];
                                    count++;
                                    if (count < vm.gatewayReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                }
                            }, function error() {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                vm.gatewayReportedArr[count].inlineChartData = [{
                                    x: startTime,
                                    y: 0,
                                    name: vm.gatewayReportedArr[count].value
                                }, {
                                    x: endTime,
                                    y: 0,
                                    name: vm.gatewayReportedArr[count].value
                                }];
                                count++;
                                if (count < vm.gatewayReportedArr.length) {
                                    vm.fnGetAttributeAnalyticsValue(count);
                                } else {
                                    //done
                                    vm.isAttributeAnalyticsDataFetch = true;
                                    $timeout(function () {
                                        vm.fnSetTreeHeight();
                                    })
                                }
                            });
                        } else {
                            vm.gatewayReportedArr[count].inlineChartData = [
                                {
                                    x: moment().subtract(10, 'minutes').valueOf(),
                                    y: 0,
                                    name: vm.gatewayReportedArr[count].value
                                }, {
                                    x: moment().valueOf(),
                                    y: 0,
                                    name: vm.gatewayReportedArr[count].value
                                }];
                            count++;
                            if (count < vm.gatewayReportedArr.length) {
                                vm.fnGetAttributeAnalyticsValue(count);
                            } else {
                                vm.isAttributeAnalyticsDataFetch = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                })
                            }
                        }
                    } else {
                        vm.gatewayReportedArr[count].inlineChartData = [];
                        count++;
                        if (count < vm.gatewayReportedArr.length) {
                            vm.fnGetAttributeAnalyticsValue(count);
                        } else {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        }
                    }
                };

                vm.fnOpenAttributeStatistics = function (selectedAttribute) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html',
                        size: 'lg',
                        controller: 'attributeStatisticsModalCtrl as attributeStatistics',
                        resolve: {
                            selectedAttribute: function () {
                                return selectedAttribute;
                            },
                            selectedComponent: function () {
                                return vm.parent.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnRenameAttribute = function(gatewayGhostObj){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeRenameModal/attributeRenameModal.html',
                        size: 'md',
                        controller: 'attributeRenameModalCtrl as attributeRenameModal',
                        resolve: {
                            selectedGhostObj: function () {
                                return _.cloneDeepWith(gatewayGhostObj);
                            },
                            ghostType: function () {
                                return 'Gateway'
                            },
                            id: function () {
                                return vm.parent.gatewayObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (newName) {
                        gatewayGhostObj.displayName = newName;
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        },1000)
                    }, function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        },1000)
                    });
                };

                vm.fnManageIssue = function (gatewayGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeManageIssueTemplateModal/attributeManageIssueTemplateModal.html',
                        size: 'lg',
                        controller: 'attributeManageIssueTemplateModalCtrl as attributeManageIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueType: function () {
                                return "gateway"
                            },
                            GhostObj: function () {
                                return gatewayGhostObj;
                            },
                            componentObj: function () {
                                return {};
                            },
                            deviceObj: function () {
                                return {};
                            },
                            gatewayObj: function () {
                                return vm.parent.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                        })
                    }, function () {

                    });
                };

                vm.fnInitGatewayGhost = function () {
                    vm.fnInitializeWebSockets();
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    TabHeight.fnSet();
                    vm.isGatewayGhostDetailsLoaded = false;
                    if (vm.parent.gatewayObj.id) {
                        vm.fnGetGatewayGhost(vm.parent.gatewayObj);
                    }
                };

                $scope.$on('$destroy', function () {
                    if (client) {
                        client.disconnect();
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayClustersCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, Paho, ColorService,microSpinner,postActionModelIcon, postActionModelMessage,
                      PermissionsService,FedSudoUserService, PaginationService,LastPageService, DB, TabHeight, ClusterFactory, amaran, swal) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isgatewayClustersDetailsLoaded = false;
                vm.isAllgatewayClustersChecked = false;
                vm.gatewayClustersArr = [];
                vm.selectedgatewayClustersArr = [];
                vm.selectedClustersArr = [];
                vm.isShowAddCluster = false;
                vm.filter = "$";
                vm.search = {$: ''};
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    }
                ];
                vm.filterQuery = "";

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if(vm.isShowAddCluster){
                        if (angular.isDefined(angular.element(".content-main")[0]) &&
                            angular.isDefined(angular.element(".headerTitle")[0]) &&
                            angular.isDefined(angular.element(".table-content-box")[1]) &&
                            angular.isDefined(angular.element(".search-panel")[0]) &&
                            angular.isDefined(angular.element(".search-tag-container")[1]) &&
                            angular.isDefined(angular.element("thead")[1]) &&
                            angular.isDefined(angular.element(".pagination-container")[1])) {
                            var totalList1 = angular.element(".content-main")[0].offsetHeight;
                            var headerTitle = angular.element(".headerTitle")[0].offsetHeight;
                            var search = angular.element(".search-panel")[0].offsetHeight;
                            var searchTag = angular.element(".search-tag-container")[1].offsetHeight;
                            var header = angular.element("thead")[1].offsetHeight;
                            var pagination = angular.element(".pagination-container")[1].offsetHeight;
                            var finalHeight = totalList1 - (headerTitle + search + pagination + searchTag + header + 34);
                            angular.element("#clusters-table tbody").css('height', finalHeight + 'px');
                        }
                    }else{
                        if (angular.isDefined(angular.element(".content-main")[0]) &&
                            angular.isDefined(angular.element(".viewClusterSearchBar")[0]) && angular.isDefined(angular.element("thead")[0])) {
                            var totalList = angular.element(".content-main")[0].offsetHeight;
                            var searchList = angular.element(".viewClusterSearchBar")[0].offsetHeight;
                            var header1 = angular.element("thead")[0].offsetHeight;
                            var finalHeightList = totalList - (searchList + header1 +10);
                            angular.element("#gatewayAllClusters").css('height', finalHeightList + 'px');
                        }
                    }

                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnHideShowAddClusters = function () {
                    vm.isAllgatewayClustersChecked = false;
                    vm.fnCheckUncheckGatewayClusterAll();
                    vm.isShowAddCluster = !vm.isShowAddCluster;
                };

                vm.fnCheckUncheckGatewayClusterAll = function () {
                    angular.forEach(vm.gatewayClustersArr, function (obj) {
                        obj.isCheck = vm.isAllgatewayClustersChecked;
                    });
                    if (vm.isAllgatewayClustersChecked) {
                        vm.selectedClustersArr = angular.copy(vm.gatewayClustersArr);
                    } else {
                        vm.selectedClustersArr = [];
                    }

                };

                vm.fnCheckUncheckGatewayClusterHeader = function (clusterObj, fromList) {
                    vm.isAllgatewayClustersChecked  = true;
                    angular.forEach(vm.gatewayClustersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllgatewayClustersChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === clusterObj.id) {
                                obj.isCheck = false;
                                vm.isAllgatewayClustersChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected cluster array*/
                    var isValueFind = _.find(vm.selectedClustersArr, {'id': clusterObj.id});
                    if (!isValueFind) {
                        vm.selectedClustersArr.push(clusterObj)
                    } else {
                        _.remove(vm.selectedClustersArr, function (obj) {
                            return clusterObj.id === obj.id;
                        });
                    }
                };

                vm.fnCheckUncheckHeader = function (clusterObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.clustersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === clusterObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected cluster array*/
                    var isValueFind = _.find(vm.selectedgatewayClustersArr, {'id': clusterObj.id});
                    if (!isValueFind) {
                        vm.selectedgatewayClustersArr.push(clusterObj)
                    } else {
                        _.remove(vm.selectedgatewayClustersArr, function (obj) {
                            return clusterObj.id === obj.id;
                        });
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.clustersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedgatewayClustersArr = angular.copy(vm.clustersArr);
                    } else {
                        vm.selectedgatewayClustersArr = [];
                    }
                };


                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isClustersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    vm.isClustersLoading = true;
                    vm.selectedgatewayClustersArr = [];
                    vm.isAllgatewayClustersChecked = false;
                    if(vm.permissionObj.List) {
                        vm.fnGetClusters(inputObj);
                    } else {
                        vm.clustersArr = [];
                        vm.isClustersLoading = false;
                    }
                };

                vm.fnGetClusters = function (inputObj) {
                    ClusterFactory.getClusters(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.clusters;
                            vm.clustersArr = _.cloneDeepWith(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            vm.isClustersLoading = false;
                            $timeout(function () {
                                angular.element($window).resize();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isClustersLoading = false;
                        })
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    vm.isClustersLoading = true;
                    vm.selectedgatewayClustersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetClusters(vm.inputObj);
                };


                vm.fnAddClusterToGateway = function () {
                    vm.isClusterAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedgatewayClustersArr, function (selectedCluster) {
                        var inputObj = {
                            gatewayId: vm.parent.gatewayObj.id,
                            clusterId: selectedCluster.id
                        };
                        promises.push(ClusterFactory.addGatewayToCluster(inputObj));
                    });
                    $q.all(promises).then(function () {
                        amaran.success("Selected clusters successfully add in Gateway");
                        vm.isClusterAdding = false;
                        vm.isShowAddCluster = false;
                        vm.isgatewayClustersDetailsLoaded = false;
                        $timeout(function () {
                            vm.fnGetgatewayClusters(vm.parent.gatewayObj);
                        });
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isClusterAdding = false;
                    })
                };

                vm.fnDeleteGatewayCluster = function (selectedGatewayClusterArr) {
                    swal({
                            title: "Remove all selected clusters from Gateway?",
                            text: "Clusters will be permanently removed for the Gateway.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedGatewayClusterArr, function (selectedCluster) {
                                    var inputObj = {
                                        gatewayId: vm.parent.gatewayObj.id,
                                        clusterId: selectedCluster.id
                                    };
                                    promises.push(ClusterFactory.removeGatewayFromCluster(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedgatewayClustersArr = [];
                                        vm.isgatewayClustersDetailsLoaded = false;
                                        $timeout(function () {
                                            vm.fnGetgatewayClusters(vm.parent.gatewayObj);
                                        });
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetgatewayClusters = function (gatewayObj) {
                    var inputObj = {
                        gatewayId: gatewayObj.id
                    };
                    ClusterFactory.getGatewayClusters(inputObj)
                        .then(function (response) {
                            TabHeight.fnSet();
                            vm.gatewayClustersArr = response;
                            vm.isgatewayClustersDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnInitGatewayClusters = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:cluster");
                    vm.isgatewayClustersDetailsLoaded = false;
                    if(vm.permissionObj.List){
                        if (vm.parent.gatewayObj.id) {
                            vm.fnGetgatewayClusters(vm.parent.gatewayObj);
                        }
                    }else{
                        vm.isgatewayClustersDetailsLoaded = true;
                    }
                    TabHeight.fnSet();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('Es4SupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, NodeES4Factory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.es4SupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetEs4Data = function () {
                    vm.es4SupplementalObj = vm.parent.es4Obj.tags ? angular.fromJson(vm.parent.es4Obj.tags) : {};
                    vm.es4SupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.es4SupplementalObj, true) : vm.es4SupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.es4SupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.es4SupplementalObj)) {
                        angular.forEach(vm.es4SupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.es4SupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.es4SupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.es4SupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.es4SupplementalObj = angular.toJson(vm.es4SupplementalObj, true);
                    } else {
                        vm.es4SupplementalObj = angular.fromJson(vm.es4SupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.es4SupplementalObj)) {
                            angular.forEach(vm.es4SupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveEs4Data = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.es4Obj.tags = {};
                    var inputObj = {
                        es4Id: vm.parent.es4Obj.id,
                        body: {}
                    };
                    if (!vm.parent.es4Obj.tags) {
                        vm.parent.es4Obj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.es4Obj.tags = angular.fromJson(vm.es4SupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.es4Obj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.es4Obj.tags;
                    NodeES4Factory.replaceES4Tags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to ES4 successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitEs4Supplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitEs4Supplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.es4SupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.es4SupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.es4SupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitEs4Supplemental = function () {
                    vm.isEs4SupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('Es4ScriptCtrl',
            function ($scope, $timeout, $window, $uibModal, amaran, TabHeight, NodeES4Factory, NodeEcuFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isEs4ScriptDetailsLoaded = false;
                vm.value = {};
                vm.availableDataLibs = ['common_S4'];
                vm.isScriptEditable = false;
                vm.isECUDetailsLoaded = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    //vm.fnSetTabHeight();
                });

                vm.fnGetEs4Data = function () {
                    vm.scriptObj = _.cloneDeepWith(vm.parent.es4Obj);
                    vm.scriptConfigObj = {
                        scriptBody: vm.parent.es4Obj.script ? vm.parent.es4Obj.script : ''
                    };
                    vm.isScriptEditable = false;
                    vm.isEs4ScriptDetailsLoaded = true;
                };

                vm.fnChangeToEditable = function () {
                    vm.resetScriptBody = _.cloneDeepWith(vm.scriptConfigObj.scriptBody);
                    vm.isScriptEditable = true;
                };

                vm.fnCancelEditable = function () {
                    $timeout(function () {
                        vm.scriptConfigObj.scriptBody = _.cloneDeepWith(vm.resetScriptBody);
                        vm.isScriptEditable = false;
                    })
                };

                vm.fnSaveScript = function () {
                    if (vm.value.getData().length) {
                        vm.isSaveChanges = true;
                        var input = {
                            es4Id: vm.scriptObj.id,
                            body: {
                                script: vm.value.getData()
                            }
                        };
                        NodeES4Factory.updateES4Script(input).then(function (response) {
                            vm.isSaveChanges = false;
                            vm.isScriptEditable = false;
                            amaran.success("ES4 Script update successfully");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/es4/modal/es4JobTerminal/es4JobTerminal.html',
                                size: 'lg',
                                controller: 'es4JobTerminalCtrl as es4JobTerminal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(response);
                                    },
                                    ecuObj: function () {
                                        return _.cloneDeepWith(vm.ecuObj);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveChanges = false;
                            vm.scriptConfigObj = {
                                scriptBody: vm.scriptObj.script ? vm.scriptObj.script : ''
                            };
                            vm.isScriptEditable = false;
                        });
                    } else {
                        amaran.error("Script cannot be null.");
                    }

                };

                vm.fnGetECUInfo = function (id) {
                    var inputObj = {
                        ecuId: id
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            vm.ecuObj = _.cloneDeepWith(response);
                            vm.fnGetEs4Data(vm.parent.es4Obj);
                            vm.isECUDetailsLoaded = true;
                        })
                };

                vm.fnInitScriptTab = function () {
                    vm.isECUDetailsLoaded = false;
                    if (vm.parent.es4Obj.id) {
                        if (vm.parent.es4Obj.ecuId) {
                            vm.fnGetECUInfo(vm.parent.es4Obj.ecuId);
                        }
                    }
                };

                vm.fnInitEs4Script = function () {
                    vm.isEs4ScriptDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('EcuAttributesCtrl',
            function ($scope, $timeout, $window, $state, DB, amaran, swal, $uibModal, TabHeight, moment, NodeAttributesFactory, PermissionsService, PaginationQueryService, copyService, WidgetsListService, BatchFactory, microSpinner, ColorService, NodeEcuFactory, QueryFactory, Highcharts, postActionModelMessage, postActionModelIcon, $log) {
                var vm = this;
                var timezoneName = "";
                vm.parent = $scope.$parent;
                vm.isFullWidthDevice = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });
                vm.isECUDetailsLoaded = false;
                vm.ecuObj = {};
                vm.resetECUObj = {};
                vm.initECU = true;
                vm.chartData = [];
                vm.splineChartData = [];
                vm.selectedChartType = 'spline';
                vm.filter = "$";
                vm.attributeSearch = {$: ''};
                vm.selectedChartFor = 'Value';
                vm.selectedRange = "";
                vm.selectedChartData = [];
                vm.isShowECUConnection = false;
                vm.isShowPlotECUHealth = false;
                var connectionArr = [
                    {
                        name: "Connected",
                        value: 1,
                        color: '#218838'
                    },
                    {
                        name: "Disconnected",
                        value: -1,
                        color: '#C82333'
                    }
                ];
                vm.attributesList = [];
                vm.attributesStringValueArr = [];
                vm.tempAxesData = [
                    { // Primary yAxis
                        title: {
                            text: 'Values'
                        }
                    },
                    { // Primary yAxis
                        title: {
                            text: 'Health'
                        },
                        opposite: true,
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Connection'
                        },
                        opposite: true,
                        labels: {
                            formatter: function () {
                                return this.value === -1 ? 'Disconnected' : this.value // eslint-disable-line
                            }
                        },
                        categories: ['', 'Connected'],
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Attribute String Values'
                        },
                        opposite: true,
                        categories: vm.attributesStringValueArr,
                        visible: true
                    }
                ];
                vm.tempChartsData = [];
                vm.selectedHeatmapChartAttrObj = '';
                vm.axisArr = [
                    {
                        title: 'Minutes',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
                    },
                    {
                        title: 'Hours',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                    },
                    {
                        title: 'Days',
                        categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                    },
                    {
                        title: 'Weeks',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54"]
                    },
                    {
                        title: 'Months',
                        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    }
                ];
                vm.mathFunction = [
                    {
                        title: 'MIN'
                    },
                    {
                        title: 'MAX'
                    },
                    {
                        title: 'AVG'
                    }
                ];
                vm.selectedMathFunction = 'MAX';
                vm.selectedXAxis = vm.axisArr[2];
                vm.selectedYAxis = vm.axisArr[0];
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "This ECU",
                        name: 'ecuId',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".data->>\'ecuId\' = " + vm.tableAlias + ".data->>\'nodeId\' and " + vm.tableAlias + ".data->>\'ecuId\' = '" + vm.parent.ecuObj.id + "'",
                        localSearchValue: "obj.ecuId === '" + vm.parent.ecuObj.id + "' && obj.ecuId === obj.nodeId"
                    }, {
                        displayName: "ECU ID",
                        name: "ecuId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Alarms",
                        name: 'alarms',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".reference like '%!'",
                        localSearchValue: "obj.reference.endsWith('!')"
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'},
                    {name: 'receivedAt', displayName: 'Value Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.defaultAttributeFilterArr = [
                    {
                        displaySearchText: "",
                        displaySelectedField: "This ECU",
                        id: 40355493,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.ecuId === '" + vm.parent.ecuObj.id + "' && obj.ecuId === obj.nodeId",
                        searchText: "",
                        selectedField: "ecuId",
                        sqlValue: "node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' and node_attributes.data->>\'ecuId\' = '" + vm.parent.ecuObj.id + "'"
                    },
                    {
                        displaySearchText: "",
                        displaySelectedField: "Alarms",
                        selectedConnector: "and",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.reference.endsWith('!')",
                        searchText: "",
                        selectedField: "alarms",
                        sqlValue: vm.tableAlias + ".data->>\'reference\' like '%!'"
                    }
                ];
                vm.defaultAttributeSortString = 'name asc';
                vm.perPage = 50;
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isShowPaginationContainer = true;
                vm.selectedPieChartData = {};
                vm.pieChartAttributeList = [];
                vm.heatmapChartAttributeList = [];
                vm.heatmapAttributeStringValueArr = [];
                var loaderModalInstance = "";
                vm.selectedAttribute = {};
                vm.plotableArr = [
                    {
                        name: 'Actual Value',
                        sortName: '[AV]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    },
                    {
                        name: 'Forecast Value',
                        sortName: '[FV]',
                        dataType: 'Forecast',
                        chartType: 'Value',
                        attrKey: 'isSelectedForecast'
                    },
                    {
                        name: 'Forecast Health',
                        sortName: '[FH]',
                        dataType: 'Forecast',
                        chartType: 'Health',
                        attrKey: 'isSelectedForecastHealthPlot'
                    },
                    {
                        name: 'Value Anomaly',
                        sortName: '[VA]',
                        dataType: 'Anomaly',
                        chartType: 'Value',
                        attrKey: 'isSelectedAnomaly'
                    },
                    {
                        name: 'Health Anomaly',
                        sortName: '[HA]',
                        dataType: 'Anomaly',
                        chartType: 'Health',
                        attrKey: 'isSelectedAnomalyHealthPlot'
                    }
                ];
                vm.selectedAttrKeyArr = [
                    {
                        name: 'Name',
                        key: 'name'
                    },
                    {
                        name: 'Value',
                        key: 'value'
                    },
                    {
                        name: 'Units',
                        key: 'read'
                    },
                    {
                        name: 'Health',
                        key: 'health'
                    },
                    {
                        name: 'Ref',
                        key: 'reference'
                    },
                    {
                        name: 'ID',
                        key: 'id'
                    },
                    {
                        name: 'Type',
                        key: 'type'
                    },
                    {
                        name: 'ECU',
                        key: 'nodeName'
                    },
                    {
                        name: 'Alarm',
                        key: 'id'
                    }
                ];
                vm.ecuPlotableArr = [
                    {
                        name: 'Actual Connection',
                        sortName: '[AC]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    }
                ];
                vm.granularityArr = [
                    {
                        name: '1 minute',
                        config: {
                            title: 'MINUTES',
                            value: 1,
                            time: 60000
                        }
                    },
                    {
                        name: '2 minute',
                        config: {
                            title: 'MINUTES',
                            value: 2,
                            time: 60000
                        }
                    },
                    {
                        name: '5 minute',
                        config: {
                            title: 'MINUTES',
                            value: 5,
                            time: 60000
                        }
                    },
                    {
                        name: '15 minute',
                        config: {
                            title: 'MINUTES',
                            value: 15,
                            time: 60000
                        }
                    },
                    {
                        name: '30 minute',
                        config: {
                            title: 'MINUTES',
                            value: 30,
                            time: 60000
                        }
                    },
                    {
                        name: '1 hour',
                        config: {
                            title: 'HOURS',
                            value: 1,
                            time: 3600000
                        }
                    },
                    {
                        name: '3 hour',
                        config: {
                            title: 'HOURS',
                            value: 3,
                            time: 3600000
                        }
                    },
                    {
                        name: '6 hour',
                        config: {
                            title: 'HOURS',
                            value: 6,
                            time: 3600000
                        }
                    },
                    {
                        name: '1 day',
                        config: {
                            title: 'DAYS',
                            value: 1,
                            time: 86400000
                        }
                    }
                ];
                vm.selectedGranularity = vm.granularityArr[1];
                vm.chartUpdateTimeout = '';
                vm.selectedAutoUpdateType = "Static";

                vm.attributeNameContextMenu = function (attributeObj) {
                    var tempContextMenu = [{
                        text: 'Edit Name',
                        click: function () {
                            vm.fnEditAttributeName(attributeObj);
                        }
                    }];
                    if (attributeObj.mode === 'RW' || attributeObj.mode === 'rw') {
                        tempContextMenu.push({
                            text: 'Edit Value',
                            click: function () {
                                vm.fnEditAttributeValue(attributeObj);
                            }
                        });
                    }
                    if (vm.permissionObj.ENABLE_ATTRIBUTE || vm.permissionObj.DISABLE_ATTRIBUTE) {
                        if (attributeObj.operation && attributeObj.operation === 'DISABLED') {
                            tempContextMenu.push({
                                text: 'Enable Attribute',
                                click: function () {
                                    vm.fnEnableAttribute(attributeObj);
                                }
                            });
                        } else {
                            tempContextMenu.push({
                                text: 'Disable Attribute',
                                click: function () {
                                    vm.fnDisableAttribute(attributeObj);
                                }
                            });
                        }
                    }
                    if (attributeObj.syncState === 'NOT_SYNCHRONIZED') {
                        tempContextMenu.push({
                            text: 'Synchronize',
                            click: function () {
                                vm.fnDeployAttribute(attributeObj);
                            }
                        });
                    }
                    return tempContextMenu;
                };

                vm.attributeValueContextMenu = function (attributeObj) {
                    return [{
                        text: 'Edit Value',
                        click: function () {
                            vm.fnEditAttributeValue(attributeObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Parse JSONB data
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle boolean fields
                                if (angular.isDefined(parsedData.value)) {
                                    if (parsedData.valueType === 'BOOLEAN') {
                                        parsedData.value = parsedData.value === "true" || parsedData.value === true;
                                    } else if (parsedData.valueType === 'FLOAT') {
                                        parsedData.value = parseFloat(parsedData.value);
                                    }
                                }

                                // Handle mode field
                                if (angular.isDefined(parsedData.mode)) {
                                    parsedData.mode = parsedData.mode.toUpperCase();
                                }

                                // Handle timestamps
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Handle read/write permissions
                                if (parsedData.read) {
                                    parsedData.read = angular.fromJson(parsedData.read);
                                }
                                if (parsedData.write) {
                                    parsedData.write = angular.fromJson(parsedData.write);
                                }

                                // Handle attribute reference
                                if (parsedData.reference) {
                                    parsedData.reference = parsedData.reference.toString();
                                }

                                // Handle health data
                                if (parsedData.health) {
                                    parsedData.health = parseInt(parsedData.health);
                                }
                                if (parsedData.healthLastChangedAt) {
                                    parsedData.healthLastChangedAt = parseInt(parsedData.healthLastChangedAt);
                                }

                                // Handle alarm status
                                if (parsedData.reference && parsedData.reference.endsWith('!')) {
                                    parsedData.hasAlarm = true;
                                }

                                // Merge parsed data with item
                                return angular.extend({}, parsedItem, parsedData);

                            } catch (e) {
                                $log.error('Error parsing ECU attribute data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = "";
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                        sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                    } else {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.rt AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                    }
                    var input = {
                        sql: sqlString
                    };
                    if (vm.initECU === false) {
                        vm.isShowPaginationContainer = true;
                        vm.fnGetAttributes(input, true);
                    } else {
                        vm.isAttributesLoading = false;
                        vm.initECU = false;
                    }
                };

                vm.fnGetAttributes = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var parsedData = parsePostgresData(res.data);
                            vm.attributesList = [];
                            if (vm.currentPage === 1) {
                                vm.attributesList.push({
                                    name: 'ECU',
                                    displayName: 'ECU',
                                    ecuName: vm.ecuObj.name,
                                    connected: vm.ecuObj.connected,
                                    id: vm.ecuObj.id,
                                    type: 'ecu',
                                    health: vm.ecuObj.health,
                                    projectId: vm.ecuObj.projectId,
                                    isSelected: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Actual Connection)',
                                        id: vm.ecuObj.id
                                    }) !== -1,
                                    isSelectedHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Actual Health)',
                                        id: vm.ecuObj.id
                                    }) !== -1,
                                    isSelectedForecast: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Forecast Connection)',
                                        id: vm.ecuObj.id
                                    }) !== -1,
                                    isSelectedForecastHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Forecast Health)',
                                        id: vm.ecuObj.id
                                    }) !== -1,
                                    isSelectedAnomaly: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Anomaly Connection)',
                                        id: vm.ecuObj.id
                                    }) !== -1,
                                    isSelectedAnomalyHealthPlot: _.findIndex(vm.selectedChartData, {
                                        name: 'ECU (Anomaly Health)',
                                        id: vm.ecuObj.id
                                    }) !== -1
                                });
                            }
                            if (isFirst && parsedData && parsedData.length) {
                                vm.totalItems = parsedData[0].totalitems + 1;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                parsedData.reverse();
                            }
                            vm.resetAttributeLists = _.cloneDeepWith(parsedData);
                            vm.fnGenerateAttributesList();
                            vm.isAttributesLoading = false;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributesLoading = false;
                        })
                };

                vm.fnGenerateAttributesList = function () {
                    var tempAttributeObj = _.cloneDeepWith(vm.attributesList[0]);
                    vm.attributesList = [];
                    if (tempAttributeObj && tempAttributeObj.name === 'ECU') {
                        tempAttributeObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: 'ECU (Actual Connection)',
                            id: tempAttributeObj.id
                        }) !== -1;
                        tempAttributeObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: 'ECU (Actual Health)',
                            id: tempAttributeObj.id
                        }) !== -1;
                        vm.attributesList.push(tempAttributeObj);
                    }
                    _.forEach(vm.resetAttributeLists, function (attributeObj) {
                        attributeObj.displayName = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.name = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.type = 'attribute';
                        var tempActualObj = _.cloneDeepWith(attributeObj);
                        tempActualObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        vm.attributesList.push(tempActualObj);
                        if (vm.selectedAttribute.id === tempActualObj.id) {
                            vm.selectedAttribute = tempActualObj;
                        }
                    });
                    vm.fnSortAttributesByPlot();
                };

                vm.fnSortAttributesByPlot = function () {
                    /*var tempAttributeObj = _.cloneDeepWith(vm.attributesList[0]);
                    if (tempAttributeObj && tempAttributeObj.name === 'ECU') {
                        vm.attributesList.splice(0, 1);
                        vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                        vm.attributesList.unshift(tempAttributeObj);
                    } else {
                        vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                    }*/
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_attributes as node_attributes';
                    } else { //for general sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'rt\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAttributes(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.attributesList, true, 'node_attributes');
                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }
                        var newSQL = "WITH data->>\'attributes\' AS (" + tempNewSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes";
                        newSQL += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        if (sortString !== '') { //for specific sort
                            newSQL += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        } else { //for general sort
                            newSQL += 'SELECT att.*, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.rt AS rt FROM attributes AS att LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.data->>\'id\', rows';
                        }
                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }
                        vm.previousPage = page;
                        vm.fnGetAttributes(newInput, false);
                    }
                };

                vm.fnOnActionDrop = function (srcList, dataType, chatsType) {
                    var isAllow = false;
                    if (vm.selectedChartType === 'pie') {
                        isAllow = !(dataType === 'Forecast' || dataType === 'Anomaly');
                    } else {
                        isAllow = true;
                    }
                    if (isAllow) {
                        var chartType = "";
                        var tempType = "";
                        if (chatsType === 'Value') {
                            chartType = srcList.type === 'ecu' ? 'ecuConnection' : 'attributeValue';
                            tempType = srcList.type === 'ecu' ? 'Connection' : 'Value';
                        } else {
                            chartType = srcList.type === 'ecu' ? 'ecuHealth' : 'attributeHealth';
                            tempType = 'Health';
                        }
                        //var chartType = srcList.type === 'ecu' ? 'nodeConnection' : 'attributeValue';
                        //var tempType = srcList.type === 'ecu' ? 'Connection' : 'Value';
                        var isFindIndex = _.findIndex(vm.selectedChartData, {
                            name: srcList.name + " (" + dataType + " " + tempType + ")",
                            chartType: chartType,
                            id: srcList.id
                        });
                        if (isFindIndex === -1) {
                            if (chatsType === 'Value') {
                                if (srcList.type === 'ecu') {
                                    srcList.chartType = 'ecuConnection';
                                } else {
                                    srcList.chartType = 'attributeValue';
                                }
                            } else {
                                if (srcList.type === 'ecu') {
                                    srcList.chartType = 'ecuHealth';
                                } else {
                                    srcList.chartType = 'attributeHealth';
                                }
                            }
                            srcList.dataType = _.cloneDeepWith(dataType);
                            if (chatsType === 'Value') {
                                if (dataType === 'Actual') {
                                    srcList.isSelected = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecast = true;
                                } else {
                                    srcList.isSelectedAnomaly = true;
                                }
                            } else {
                                if (dataType === 'Actual') {
                                    srcList.isSelectedHealthPlot = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecastHealthPlot = true;
                                } else {
                                    srcList.isSelectedAnomalyHealthPlot = true;
                                }
                            }
                            var tempSrcList = _.cloneDeepWith(srcList);
                            tempSrcList.name = tempSrcList.name + " (" + dataType + " " + tempType + ")";
                            vm.selectedChartData.push(tempSrcList);
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (vm.selectedChartType === 'heatmap') {
                                vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                            }
                            if (vm.selectedChartType === 'pie') {
                                vm.selectedPieChartData = vm.pieChartAttributeList[0];
                            }
                            $timeout(function () {
                                vm.fnGetAttributeAnalyticsData(srcList);
                            });
                        } else {
                            amaran.error('Attribute already added on chart.');
                        }
                    } else {
                        amaran.error('Attribute type is not allows for pie chart type.');
                    }
                };

                vm.fnGetAttributeAnalyticsData = function (srcList) {
                    var sql = vm.fnGetSQLQuery(srcList);
                    var chartContainerEle = angular.element(".chart-container-height");
                    loaderModalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                        size: 'md',
                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                        appendTo: chartContainerEle
                    });
                    QueryFactory.executeQuery({'sql': sql})
                        .then(function (res) { // Success block
                            vm.selectedChartData[vm.selectedChartData.length - 1].sql = sql;
                            vm.selectedChartData[vm.selectedChartData.length - 1].apiData = res.data;
                            vm.selectedChartData[vm.selectedChartData.length - 1].chartData = vm.fnGenerateChartData(srcList, res.data);
                            var tempType = srcList.chartType === 'ecuConnection' || srcList.chartType === 'attributeValue' ? 'Value' : 'Health';
                            var tempName = srcList.name + " (" + srcList.dataType + " " + tempType + ")";
                            var isFind = _.find(vm.pieChartAttributeList, {
                                name: tempName,
                                id: srcList.id
                            });
                            if (isFind) {
                                isFind.apiData = res.data;
                                isFind.chartData = vm.selectedChartData[vm.selectedChartData.length - 1].chartData;
                            }
                            if (vm.selectedChartType !== 'heatmap') {
                                loaderModalInstance.dismiss();
                                loaderModalInstance = "";
                            }
                            $timeout(function () {
                                vm.fnRenderChart();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            loaderModalInstance.dismiss();
                            loaderModalInstance = "";
                            vm.fnRemoveChartData(srcList)
                        })
                };

                vm.fnRenderChart = function () {
                    if (vm.selectedChartData.length) {
                        if (vm.selectedChartType === 'pie') {
                            vm.chartData = [];
                            var counts = {};
                            if (vm.selectedPieChartData && vm.selectedPieChartData.chartType) {
                                if (vm.selectedPieChartData.chartType === "ecuHealth" || vm.selectedPieChartData.chartType === "attributeHealth") {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.health] = (counts[x.health] || 0) + 1;
                                    });
                                } else {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.value] = (counts[x.value] || 0) + 1;
                                    });
                                }
                                _.forEach(counts, function (value, key) {
                                    vm.chartData.push({
                                        name: key,
                                        y: value
                                    });
                                });
                                $timeout(function () {
                                    Highcharts.chart('ecuAttributeChart', {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: 'pie'
                                        },
                                        title: {
                                            text: ''
                                        },
                                        tooltip: {
                                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        accessibility: {
                                            point: {
                                                valueSuffix: ''
                                            }
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: true,
                                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                                }
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: 'Value',
                                            colorByPoint: true,
                                            data: vm.chartData
                                        }]
                                    });
                                });
                            }
                        }
                        if (vm.selectedChartType === 'heatmap') {
                            if (angular.isDefined(vm.selectedHeatmapChartAttr) && vm.selectedHeatmapChartAttr.name.length) {
                                var sql = vm.fnGetHeatMapSQLQuery(vm.selectedHeatmapChartAttr);
                                if (loaderModalInstance === '') {
                                    var chartContainerEle = angular.element(".chart-container-height");
                                    loaderModalInstance = $uibModal.open({
                                        backdrop: 'static',
                                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                                        size: 'md',
                                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                                        appendTo: chartContainerEle
                                    });
                                }
                                QueryFactory.executeQuery({'sql': sql})
                                    .then(function (res) { // Success block
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.selectedHeatmapChartAttr.apiData = _.cloneDeepWith(res.data);
                                        var chartData = vm.fnGenerateHeatMapChartData(vm.selectedHeatmapChartAttr, _.cloneDeepWith(res.data));
                                        var chartName = '';
                                        if (angular.isDefined(vm.selectedHeatmapChartAttr.chartType) && vm.selectedHeatmapChartAttr.chartType === 'attributeValue') {
                                            chartName = 'Value';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'attributeHealth' || vm.selectedHeatmapChartAttr.chartType === 'ecuHealth') {
                                            chartName = vm.selectedHeatmapChartAttr.type === 'ecu' ? 'ECU Health' : 'Health';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'ecuConnection') {
                                            chartName = 'Connection';
                                        }
                                        var isStringFound = false;
                                        _.forEach(res.data, function (dataObj) {
                                            if (dataObj.value && isNaN(dataObj.value)) {
                                                isStringFound = true;
                                            }
                                        });
                                        Highcharts.chart("ecuAttributeHeatmapChart", {
                                            chart: {
                                                type: 'heatmap'
                                            },
                                            exporting: {
                                                enabled: false
                                            },
                                            boost: {
                                                useGPUTranslations: true
                                            },
                                            legend: {
                                                enabled: false
                                            },
                                            title: {
                                                text: ''
                                            },
                                            subtitle: {
                                                text: ''
                                            },
                                            xAxis: {
                                                title: {
                                                    text: vm.selectedXAxis.title
                                                },
                                                categories: vm.selectedXAxis.categories,
                                                labels: {
                                                    format: vm.selectedXAxis.title === 'Hours' || vm.selectedXAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                }
                                            },
                                            yAxis: {
                                                categories: vm.selectedYAxis.categories,
                                                title: {
                                                    text: vm.selectedYAxis.title
                                                },
                                                reversed: false,
                                                labels: {
                                                    format: vm.selectedYAxis.title === 'Hours' || vm.selectedYAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                },
                                                //startOnTick: false,
                                                endOnTick: false
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                            colorAxis: {
                                                maxColor: Highcharts.getOptions().colors[0]
                                            },
                                            tooltip: {
                                                formatter: function () {
                                                    var tooltip = '';
                                                    if (this.series.name === 'Connection') { //eslint-disable-line
                                                        tooltip = '<b>ECU Connection: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    } else if (this.series.name === 'Value') { //eslint-disable-line
                                                        var displayName = '';
                                                        if (isStringFound) {
                                                            displayName = this.point.name ? this.point.name : null; //eslint-disable-line
                                                        } else {
                                                            displayName = this.point.value; //eslint-disable-line
                                                        }
                                                        tooltip = '<b>Value: ' + displayName + '</b>'; //eslint-disable-line
                                                    } else {
                                                        tooltip = '<b>Health: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    }
                                                    return tooltip //eslint-disable-line
                                                }
                                            },
                                            series: [{
                                                boostThreshold: 100,
                                                borderWidth: 0,
                                                data: chartData,
                                                name: chartName,
                                                nullColor: '#FFFFFF',
                                                turboThreshold: chartData.length + 100 // #3404, remove after 4.0.5 release
                                            }]
                                        })
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.fnRemoveChartData(vm.selectedHeatmapChartAttr);
                                    });
                            }
                        }
                        if (vm.selectedChartType === 'spline' || vm.selectedChartType === 'bar') {
                            vm.splineChartData = [];
                            _.forEach(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.type === 'ecu') {
                                    if (chartDataObj.chartType === 'ecuHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            yAxis: 1,
                                            data: chartDataObj.chartData,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempEcuHealthArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast').length + 100
                                            };
                                            vm.splineChartData.push(tempEcuHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempEcuHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly').length + 100
                                            };
                                            vm.splineChartData.push(tempEcuHealthAnomalyArr);
                                        }
                                    } else {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            yAxis: 2,
                                            data: chartDataObj.chartData,
                                            tooltip: {
                                                formatter: function () {
                                                    return '<b>' + moment(this.point.x).format('MM/DD/YYYY HH:mm') + '</b><br><b style="color:' + this.point.color + '">' + this.point.series.name + '</b><br><b>' + this.point.name + '</b><br/>'; //eslint-disable-line
                                                }
                                            },
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempConnectionForecastArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionForecast'),
                                                type: 'arearange',
                                                yAxis: 2,
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionForecast').length + 100
                                            };
                                            vm.splineChartData.push(tempConnectionForecastArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempConnectionAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                yAxis: 2,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionAnomaly').length + 100
                                            };
                                            vm.splineChartData.push(tempConnectionAnomalyArr);
                                        }
                                    }
                                } else {
                                    if (chartDataObj.chartType === 'attributeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            data: chartDataObj.chartData,
                                            yAxis: 1,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var healthForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast');
                                            var tempHealthArr = {
                                                name: chartDataObj.name,
                                                data: healthForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthForecast.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var healthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly')
                                            var tempHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: healthAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthAnomaly.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthAnomalyArr);
                                        }
                                    } else {
                                        if (chartDataObj.value && isNaN(chartDataObj.value)) {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                yAxis: 3,
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        } else {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        }
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var isStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var forecastData = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueForecast');
                                            var tempArr = {
                                                name: chartDataObj.name,
                                                data: forecastData,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: forecastData.length + 100
                                            };
                                            if (isStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var isAnomalyStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueAnomaly');
                                            var tempValueAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: valueAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueAnomaly.length + 100
                                            };
                                            if (isAnomalyStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempValueAnomalyArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempValueAnomalyArr);
                                        }
                                    }
                                }
                            });

                            var isFindECUConnection = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'ecuConnection') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[2].visible = !!isFindECUConnection;
                            var isFindHealthAxes = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'ecuHealth' || chartDataObj.chartType === 'attributeHealth') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[1].visible = !!isFindHealthAxes;
                            $timeout(function () {
                                Highcharts.chart('ecuAttributeChart', {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        type: 'datetime',
                                        labels: {
                                            formatter: function () {
                                                return moment(this.value).format('MM/DD HH:mm'); // eslint-disable-line
                                            },
                                            rotation: -60
                                        },
                                        title: {
                                            text: ''
                                        }
                                    },
                                    yAxis: vm.tempAxesData,
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    series: vm.splineChartData
                                });
                            });
                        }
                        vm.fnSortAttributesByPlot();
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRemoveChartData = function (selectedObj) {
                    var isFindIndex = _.findIndex(vm.selectedChartData, {name: selectedObj.name, id: selectedObj.id});
                    if (isFindIndex !== -1) {
                        vm.selectedChartData.splice(isFindIndex, 1);
                        vm.fnGenerateAttributesList();
                    }
                    var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindPieDataIndex !== -1) {
                        vm.pieChartAttributeList.splice(isFindPieDataIndex, 1);
                        if (vm.pieChartAttributeList && vm.pieChartAttributeList.length) {
                            vm.selectedPieChartData = vm.pieChartAttributeList[0];
                        } else {
                            vm.selectedPieChartData = "";
                        }
                    }
                    var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindHeatmapDataIndex !== -1) {
                        vm.heatmapChartAttributeList.splice(isFindHeatmapDataIndex, 1);
                        if (vm.heatmapChartAttributeList && vm.heatmapChartAttributeList.length) {
                            vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                        } else {
                            vm.selectedHeatmapChartAttr = '';
                        }
                    }
                    $timeout(function () {
                        vm.fnRenderChart();
                    });
                };

                vm.fnGetHealthColor = function (attrCode, attrObj) {
                    var attrStyle = ColorService.getHealthColorForLoop(attrObj.projectId, attrCode);
                    attrObj.healthName = attrStyle.content;
                    return attrStyle;
                };

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };

                vm.fnGetECUInfo = function () {
                    vm.ecuObj = _.cloneDeepWith(vm.parent.ecuObj);
                    _.forEach(vm.ecuObj.attributes, function (attrObj) {
                        attrObj.rt = attrObj.name;
                        attrObj.nodeName = vm.ecuObj.name
                    })
                    vm.resetECUObj = angular.copy(vm.ecuObj);
                    vm.isECUDetailsLoaded = true;
                    vm.attributesList = [];
                    vm.attributesList.push({
                        name: 'ECU',
                        displayName: 'ECU',
                        ecuName: vm.ecuObj.name,
                        connected: vm.ecuObj.connected,
                        id: vm.ecuObj.id,
                        type: 'ecu',
                        health: vm.ecuObj.health,
                        projectId: vm.ecuObj.projectId,
                        isSelected: _.findIndex(vm.selectedChartData, {name: 'ECU (Actual Connection)'}) !== -1
                    });
                    vm.ecuObj.attributes = _.orderBy(vm.ecuObj.attributes, ['name'], ['asc']);
                    vm.ecuObj.attributes = _.filter(vm.ecuObj.attributes, function (attrObj) {
                        return attrObj.reference.endsWith('!');
                    })
                    if (vm.ecuObj.attributes.length > vm.perPage) {
                        vm.resetAttributeLists = _.cloneDeepWith(vm.ecuObj.attributes.slice(0, vm.perPage));
                    } else {
                        vm.resetAttributeLists = _.cloneDeepWith(vm.ecuObj.attributes);
                    }
                    vm.totalItems = vm.ecuObj.attributes.length;
                    vm.fnGenerateAttributesList();
                    $timeout(function () {
                        TabHeight.fnSet();
                        vm.fnRenderChart();
                        var start = moment().subtract(3, 'hours');
                        var end = moment();
                        $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            opens: 'left',
                            startDate: start,
                            endDate: end,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            ranges: {
                                'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                                'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                                'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                                'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                                'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                                'Today': [moment().startOf('day'), moment()],
                                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                            },
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end, label) {
                            if (label === 'Custom Range') {
                                vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                            } else {
                                if (label === "Last 1 Hour") {
                                    vm.selectedRange = moment().subtract(1, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Hour") {
                                    vm.selectedRange = moment().subtract(3, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Days") {
                                    vm.selectedRange = moment().subtract(3, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 1 Week") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Week") {
                                    vm.selectedRange = moment().subtract(20, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Today") {
                                    vm.selectedRange = moment().startOf('day').format('X') + "," + moment().format('X');
                                } else if (label === "Yesterday") {
                                    vm.selectedRange = moment().subtract(1, 'days').startOf('day').format('X') + "," + moment().subtract(1, 'days').endOf('days').format('X');
                                } else if (label === "Last 7 Days") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 30 Days") {
                                    vm.selectedRange = moment().subtract(29, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "This Month") {
                                    vm.selectedRange = moment().startOf('month').format('X') + "," + moment().endOf('month').format('X');
                                } else {//"Last Month"
                                    vm.selectedRange = moment().subtract(1, 'month').startOf('month').format('X') + "," + moment().subtract(1, 'month').endOf('month').format('X');
                                }
                            }
                            if (angular.isDefined(angular.element("#selectedDate")[0])) {
                                document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                            }
                            var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                            var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                            var timeDifference = moment(endTime).diff(startTime, 'hours');
                            var rangeDiff = 1;
                            var rangeType = 'MINUTES';
                            if (timeDifference <= 1) {
                                rangeDiff = 1;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 1 && timeDifference <= 3) {
                                rangeDiff = 2;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 3 && timeDifference <= 6) {
                                rangeDiff = 5;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 6 && timeDifference <= 12) {
                                rangeDiff = 15;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 12 && timeDifference <= 24) {
                                rangeDiff = 30;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 24 && timeDifference <= 72) {
                                rangeDiff = 1;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 72 && timeDifference <= 168) {
                                rangeDiff = 3;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 168 && timeDifference <= 720) {
                                rangeDiff = 6;
                                rangeType = 'HOURS';
                            } else {
                                rangeDiff = 1;
                                rangeType = 'DAYS';
                            }
                            var isFind = _.find(vm.granularityArr, function (obj) {
                                return obj.config.title === rangeType && obj.config.value === rangeDiff;
                            })
                            if (isFind) {
                                vm.selectedGranularity = _.cloneDeepWith(isFind);
                            }
                            //vm.fnRenderChart();
                            vm.fnDataRangeChange();
                        });
                        vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                        }
                    })
                };

                vm.fnSelectPieChartAttr = function (chartObj) {
                    var isFind = _.find(vm.selectedChartData, {name: chartObj.name});
                    if (isFind) {
                        vm.selectedPieChartData = isFind;
                        $timeout(function () {
                            vm.fnRenderChart();
                        })
                    }
                };

                // 1. Main SQL query function for chart data
                vm.fnGetSQLQuery = function (srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                    var sql = '';
                    var totalDuration = endTime.diff(startTime);
                    var rangeDiff = vm.selectedGranularity.config.value;
                    var rangeType = vm.selectedGranularity.config.title; // MINUTES, HOURS, DAYS
                    var totalRange = parseInt(totalDuration / vm.selectedGranularity.config.time);

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields) {
                        var fields = ['data->>\'timestamp\' AS timestamps', 'data->>\'' + idField + '\' AS id',
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) AS ts'];

                        valueFields.forEach(function(field) {
                            fields.push('data->>\'' + field.name + '\' AS ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->>\'' + field + '\' AS ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots() {
                        var intervalType = rangeType.substring(0, rangeType.length - 1).toLowerCase(); // Convert 'MINUTES' to 'minute'

                        if (rangeType !== 'DAYS') {
                            return "SELECT " +
                                "TIMESTAMP '" + previousDateString + "' + (u.i - 1) * INTERVAL '" + rangeDiff + " " + intervalType + "' AS last_ts, " +
                                "TIMESTAMP '" + previousDateString + "' + u.i * INTERVAL '" + rangeDiff + " " + intervalType + "' AS ts " +
                                "FROM generate_series(1, " + totalRange + ", 1) AS u(i)";
                        } else {
                            return "SELECT " +
                                "TIMESTAMP '" + previousDateString + "' + (u.i * INTERVAL '1 day') AS last_ts, " +
                                "TIMESTAMP '" + previousDateString + "' + ((u.i + " + rangeDiff + ") * INTERVAL '1 day') AS ts " +
                                "FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i)";
                        }
                    }

                    function buildAggregationQuery(valueAlias, additionalFields) {
                        var baseFields = ['filled_slots.ts', 'MAX(' + valueAlias + ') AS last_val', 'slot_agg_val'];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = '(SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) AS last_previous_time, ' +
                            'MAX(in_interval_r.' + valueAlias + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) AS filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS text) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        ecu: {
                            ecuHealth: {
                                base: 'node_iot_ecu_healths',
                                forecast: 'node_iot_ecu_health_forecasts',
                                anomaly: 'node_iot_ecu_health_anomalies',
                                idField: 'ecuId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            ecuConnection: {
                                base: 'node_iot_ecu_connections',
                                forecast: 'node_iot_ecu_connection_forecasts',
                                anomaly: 'node_iot_ecu_connection_anomalies',
                                idField: 'ecuId',
                                valueField: { name: 'connected', alias: 'value' }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value' }
                            }
                        }
                    };

                    var config = srcList.type === 'ecu' ?
                        tableConfig.ecu[srcList.chartType === 'ecuHealth' ? 'ecuHealth' : 'ecuConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields) +
                        '), slots AS (' + buildTimeSlots() +
                        '), slot_values AS ' + buildAggregationQuery(config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_values ORDER BY ts;';

                    return sql;
                };

                // 2. SQL query function for chart updates
                vm.fnGetUpdateChartSQLQuery = function (srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var sql = '';
                    var rangeDiff = 1;
                    var totalRange = 1;

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).subtract(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields) {
                        var fields = [
                            'data->>\'timestamp\' as timestamps',
                            'data->>\'' + idField + '\' as id',
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) as ts'
                        ];

                        valueFields.forEach(function(field) {
                            fields.push('data->>\'' + field.name + '\' as ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->>\'' + field + '\' as ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots() {
                        var intervalType = 'minute'; // For MINUTES

                        return 'SELECT TIMESTAMP \'' + previousDateString + '\' - INTERVAL \'' + rangeDiff + ' ' + intervalType + '\' AS last_ts, ' +
                            'TIMESTAMP \'' + previousDateString + '\' + (n * INTERVAL \'' + rangeDiff + ' ' + intervalType + '\') AS ts ' +
                            'FROM generate_series(1, ' + totalRange + ', 1) AS n';
                    }

                    function buildAggregationQuery(slotType, valueField, additionalFields) {
                        var baseFields = [
                            'filled_slots.ts',
                            'MAX(' + valueField + ') AS last_val',
                            'slot_agg_val'
                        ];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = 'slot_' + slotType + ' AS ( SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) AS last_previous_time, ' +
                            'MAX(in_interval_r.' + valueField + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) AS filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS text) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        ecu: {
                            ecuHealth: {
                                base: 'node_iot_ecu_healths',
                                forecast: 'node_iot_ecu_health_forecasts',
                                anomaly: 'node_iot_ecu_health_anomalies',
                                idField: 'ecuId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            ecuConnection: {
                                base: 'node_iot_ecu_connections',
                                forecast: 'node_iot_ecu_connection_forecasts',
                                anomaly: 'node_iot_ecu_connection_anomalies',
                                idField: 'ecuId',
                                valueField: { name: 'connected', alias: 'value' }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value' }
                            }
                        }
                    };

                    var config = srcList.type === 'ecu' ?
                        tableConfig.ecu[srcList.chartType === 'ecuHealth' ? 'ecuHealth' : 'ecuConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields) +
                        '), slots AS (' + buildTimeSlots() +
                        '), ' + buildAggregationQuery(config.valueField.alias === 'health' ? 'healths' : 'values',
                            config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_' + (config.valueField.alias === 'health' ? 'healths' : 'values') +
                        ' ORDER BY ts;';

                    return sql;
                };

// 3. SQL query function for heatmap
                vm.fnGetHeatMapSQLQuery = function (srcList) {
                    var startDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var selectedXAxisQString = "";
                    var selectedYAxisQString = "";

                    if (vm.selectedXAxis.title === 'Minutes') {
                        selectedXAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Hours') {
                        selectedXAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Days') {
                        selectedXAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Weeks') {
                        selectedXAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else {
                        selectedXAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    }

                    if (vm.selectedYAxis.title === 'Minutes') {
                        selectedYAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Hours') {
                        selectedYAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Days') {
                        selectedYAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Weeks') {
                        selectedYAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else {
                        selectedYAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    }

                    var sql = "";
                    if (srcList.type === "ecu") {
                        if (srcList.chartType === 'ecuHealth') {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'health\' AS FLOAT) ELSE data->>\'health\' END as health, data->>\'health\' as value, data->>\'projectId\' as projectId " +
                                "FROM node_iot_ecu_healths " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'ecuId\' = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'connectedType\' = 'BOOLEAN' THEN CAST(data->>\'connected\' AS BOOLEAN) ELSE data->>\'connected\' END as connected, data->>\'connected\' as value " +
                                "FROM node_iot_ecu_connections " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'ecuId\' = '" + srcList.id + "'";
                        }
                    } else {
                        if (srcList.chartType === 'attributeHealth') {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'value\' AS FLOAT) ELSE data->>\'value\' END as value, data->>\'health\' as value, data->>\'projectId\' as projectId " +
                                "FROM node_iot_attribute_healths " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'attributeId\' = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'value\' AS FLOAT) ELSE data->>\'value\' END as value " +
                                "FROM node_iot_attribute_values " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'attributeId\' = '" + srcList.id + "'";
                        }
                    }

                    return sql;
                };

                vm.fnGenerateHeatMapChartData = function (srcList, apiRes) {
                    var chartData = [];
                    var isStringFound = false;
                    vm.heatmapAttributeStringValueArr = [];
                    _.forEach(apiRes, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                        if (dataObj.value && dataObj.value !== '' && vm.heatmapAttributeStringValueArr.indexOf(dataObj.value) === -1) {
                            vm.heatmapAttributeStringValueArr.push(dataObj.value);
                        }
                    });
                    if (!isStringFound) {
                        vm.heatmapAttributeStringValueArr = [];
                    }
                    _.forEach(vm.selectedXAxis.categories, function (xAxisCategoriesObj, xAxisIndex) {
                        _.forEach(vm.selectedYAxis.categories, function (yAxisCategoriesObj, yAxisIndex) {
                            var newXAxisIndex = _.cloneDeepWith(xAxisIndex);
                            var newYAxisIndex = _.cloneDeepWith(yAxisIndex);
                            if (vm.selectedXAxis.title === 'Days' || vm.selectedXAxis.title === 'Months') {
                                newXAxisIndex = newXAxisIndex + 1;
                            }
                            if (vm.selectedYAxis.title === 'Days' || vm.selectedYAxis.title === 'Months') {
                                newYAxisIndex = newYAxisIndex + 1;
                            }
                            var minValue = 0;
                            var maxValue = 0;
                            var avgValue = 0;
                            var isFindData = _.filter(apiRes, {x: newXAxisIndex, y: newYAxisIndex});
                            if (isFindData && isFindData.length) {
                                minValue = isFindData[0].value;
                                maxValue = isFindData[0].value;
                                var sum = 0;
                                avgValue = 0;
                                if (srcList.chartType === 'ecuConnection') {
                                    if (isFindData && isFindData.length > 1) {
                                        var connectedArr = _.filter(isFindData, {value: true});
                                        var disconnectedArr = _.filter(isFindData, {value: false});
                                        minValue = connectedArr.length < disconnectedArr.length;
                                        maxValue = connectedArr.length >= disconnectedArr.length;
                                        avgValue = isFindData.reduce(function (sum, next) {
                                            return sum && next.value;
                                        }, true);
                                    } else {
                                        minValue = isFindData[0].value;
                                        maxValue = isFindData[0].value;
                                        avgValue = isFindData[0].value;
                                    }
                                } else {
                                    if (isStringFound) {
                                        if (isFindData && isFindData.length > 1) {
                                            var groupData = _.groupBy(isFindData, function (n) {
                                                return n.value;
                                            });
                                            var minLength = Object.values(groupData)[0].length;
                                            var maxLength = Object.values(groupData)[0].length;
                                            minValue = Object.keys(groupData)[0];
                                            maxValue = Object.keys(groupData)[0];
                                            _.forEach(isFindData, function (findObj, key) {
                                                if (findObj.length < minLength) {
                                                    minValue = key;
                                                    minLength = findObj.length;
                                                }
                                                if (findObj.length > maxLength) {
                                                    maxValue = key;
                                                    maxLength = findObj.length;
                                                }
                                            });
                                            avgValue = isFindData.reduce(function (sum, next) {
                                                return sum && next.value;
                                            }, true);
                                        } else {
                                            minValue = isFindData[0].value;
                                            maxValue = isFindData[0].value;
                                            avgValue = isFindData[0].value;
                                        }
                                    } else {
                                        _.forEach(isFindData, function (findObj) {
                                            findObj.value = Number(findObj.value);
                                            if (findObj.value < minValue) {
                                                minValue = findObj.value;
                                            }
                                            if (findObj.value > maxValue) {
                                                maxValue = findObj.value;
                                            }
                                            sum = sum + findObj.value;
                                        });
                                        avgValue = sum / isFindData.length;
                                    }
                                }
                                var value = null;
                                if (vm.selectedMathFunction === 'MIN') {
                                    value = minValue;
                                } else if (vm.selectedMathFunction === 'MAX') {
                                    value = maxValue;
                                } else {
                                    value = avgValue;
                                }
                                if (srcList.chartType === 'ecuHealth') {
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value,
                                        color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                    })
                                } else if (srcList.chartType === 'ecuConnection') {
                                    var tempConnectionObj = _.find(connectionArr, {value: value === true ? 1 : -1});
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value !== '' ? tempConnectionObj.name : null,
                                        color: value !== '' ? tempConnectionObj.color : '#FFFFFF'
                                    })
                                } else {
                                    if (srcList.chartType === 'attributeValue') {
                                        if (isStringFound) {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: vm.heatmapAttributeStringValueArr.indexOf(value),
                                                name: value
                                            })
                                        } else {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: Number(value)
                                            })
                                        }
                                    } else {
                                        chartData.push({
                                            x: xAxisIndex,
                                            y: yAxisIndex,
                                            value: value,
                                            color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                        })
                                    }
                                }
                            } else {
                                chartData.push({
                                    x: xAxisIndex,
                                    y: yAxisIndex,
                                    value: null
                                });
                            }

                        })
                    });
                    return chartData;
                };

                vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    if (srcList.type === 'ecu') {
                        if (srcList.chartType === 'ecuHealth') {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health ? Number(dataObj.health) : 0]);
                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    var tempConnectionObj = _.find(connectionArr, {value: dataObj.value === true ? 1 : -1});
                                    tempData.push({
                                        x: parseInt(dataObj.timestamp),
                                        y: dataObj.value ? tempConnectionObj.value : 0,
                                        name: dataObj.value ? tempConnectionObj.name : 'No Data Found',
                                        color: dataObj.value ? tempConnectionObj.color : '#808080'
                                    });
                                })
                            });
                        }
                    } else {
                        if (srcList.chartType === 'attributeValue') {
                            var isStringFound = false;
                            _.forEach(resData, function (dataObj) {
                                if (dataObj.value && isNaN(dataObj.value)) {
                                    isStringFound = true;
                                }
                            });
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    if (isStringFound) {
                                        if (dataObj.value && dataObj.value !== '' && vm.attributesStringValueArr.indexOf(dataObj.value) === -1) {
                                            vm.attributesStringValueArr.push(dataObj.value);
                                        }
                                        tempData.push([parseInt(dataObj.timestamp), vm.attributesStringValueArr.indexOf(dataObj.value) === -1 ? null : vm.attributesStringValueArr.indexOf(dataObj.value)]);
                                    } else {
                                        tempData.push([parseInt(dataObj.timestamp), dataObj.value ? Number(dataObj.value) : null]);
                                    }

                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health === 0 || dataObj.health > 0 ? Number(dataObj.health) : null]);
                                })
                            });
                        }
                    }
                    return tempData;
                };

                vm.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData.apiData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = vm.attributesStringValueArr.indexOf(tempDataObj.value) === -1 ? 0 : vm.attributesStringValueArr.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                vm.fnDataRangeChange = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        var chartContainerEle = angular.element(".chart-container-height");
                        loaderModalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                            size: 'md',
                            controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                            windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                            appendTo: chartContainerEle
                        });
                        count = 1;
                        vm.fnBatchOperation(batchCollectionObj, count);
                    }
                };

                vm.fnBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                _.forEach(response, function (responseObj, index) {
                                    var sql = angular.fromJson(responseObj.request.body);
                                    vm.selectedChartData[index].sql = sql.sql;
                                    vm.selectedChartData[index].apiData = responseObj.body.data;
                                    vm.selectedChartData[index].chartData = vm.fnGenerateChartData(vm.selectedChartData[index], responseObj.body.data);
                                    var isFind = _.find(vm.pieChartAttributeList, {
                                        name: vm.selectedChartData[index].name,
                                        id: vm.selectedChartData[index].id
                                    });
                                    if (isFind) {
                                        isFind.apiData = responseObj.body.data;
                                        isFind.chartData = vm.selectedChartData[index].chartData
                                    }
                                });
                                $timeout(function () {
                                    if (vm.selectedChartType !== 'heatmap') {
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                    }
                                    if (vm.selectedChartType === 'pie') {
                                        vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                    } else {
                                        vm.fnRenderChart();
                                    }
                                })
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                if (vm.selectedChartType !== 'heatmap') {
                                    loaderModalInstance.dismiss();
                                    loaderModalInstance = "";
                                }
                                if (vm.selectedChartType === 'pie') {
                                    vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                } else {
                                    vm.fnRenderChart();
                                }
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnEditAttributeName = function (selectedObj, dataType) {
                    var tempSelectedObj = _.cloneDeepWith(selectedObj);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditNameModal/attributeEditNameModal.html',
                        size: 'lg',
                        controller: 'attributeEditNameModalCtrl as attributeEditModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        var isFindInAttributeList = _.findIndex(vm.attributesList, {id: res.id});
                        if (isFindInAttributeList !== -1) {
                            vm.attributesList[isFindInAttributeList].name = res.name;
                            vm.attributesList[isFindInAttributeList].displayName = res.name;
                        }
                        var isFindInChartData = _.filter(vm.selectedChartData, {id: selectedObj.id});
                        if (isFindInChartData.length) {
                            _.forEach(isFindInChartData, function (chartObj) {
                                var tempChartType = "Value";
                                if (chartObj.chartType === 'attributeValue') {
                                    tempChartType = "Value"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Value)";
                                } else {
                                    tempChartType = "Health"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Health)";
                                }
                                chartObj.displayName = _.cloneDeepWith(res.name);
                                var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindPieDataIndex !== -1) {
                                    vm.pieChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.pieChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedPieChartData.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedPieChartData.name = vm.pieChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedPieChartData.displayName = res.name;
                                    }
                                }
                                var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindHeatmapDataIndex !== -1) {
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedHeatmapChartAttr.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedHeatmapChartAttr.name = vm.heatmapChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedHeatmapChartAttr.displayName = res.name;
                                    }
                                }
                            })
                        }
                        $timeout(function () {
                            vm.fnRenderChart();
                        });
                    }, function () {

                    });
                };

                vm.fnSelectAttribute = function (attributeObj) {
                    vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                    vm.selectedAttribute.name = _.cloneDeepWith(attributeObj.displayName);
                    if (vm.selectedAttribute.type === 'ecu') {
                        vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                            name: vm.selectedAttribute.name + " (Actual Connection)",
                            id: vm.selectedAttribute.id
                        }) !== -1;
                    } else {
                        vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                            name: vm.selectedAttribute.name + " (Actual Value)",
                            id: vm.selectedAttribute.id
                        }) !== -1;
                    }
                    vm.selectedAttribute.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                };

                vm.fnSelectedAttributeCopyToClipboard = function (key, attribute) {
                    attribute[key + 'IsCopyClicked'] = true;
                    copyService.fnCopyToClipboard(attribute[key]);
                    $timeout(function () {
                        delete attribute[key + 'IsCopyClicked'];
                    }, 2000)
                };

                vm.fnIsAttributeSelected = function () {
                    return !!vm.selectedAttribute && Object.keys(vm.selectedAttribute).length;
                };

                vm.fnOpenNodeInfo = function () {
                    if (vm.selectedAttribute.ecuId === vm.selectedAttribute.nodeId) {
                        $scope.$emit('openECUDetail', vm.parent.ecuObj);
                    } else {
                        $state.go('main.node', {selectedId: vm.selectedAttribute.nodeId});
                    }
                };

                vm.fnEnableAttribute = function (attributeObj) {
                    swal({
                            title: "Enable the selected Attribute?",
                            text: "You are about to enable selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };
                                NodeAttributesFactory.enableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute enabling process cancelled", "error");
                            }
                        });
                };

                vm.fnDisableAttribute = function (attributeObj) {
                    swal({
                            title: "Disable the selected Attribute?",
                            text: "You are about to disable the selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };

                                NodeAttributesFactory.disableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute disable process cancelled", "error");
                            }
                        });
                };

                vm.fnSelectAutoUpdateChart = function () {
                    if (vm.selectedAutoUpdateType === 'Static') {
                        $timeout.cancel(vm.chartUpdateTimeout);
                    } else {
                        vm.chartUpdateTimeout = $timeout(function () {
                            vm.fnUpdateDateRangeInput();
                        }, 60000);
                    }
                };

                vm.fnUpdateDateRangeInput = function () {
                    var oldT = vm.selectedRange.split(',');
                    var newStart = moment.unix(parseInt(oldT[0])).add(1, 'minutes').format('X')
                    var newEnd = moment.unix(parseInt(oldT[1])).add(1, 'minutes').format('X')
                    vm.selectedRange = newStart + "," + newEnd;
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (moment.unix(parseInt(newStart)).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(parseInt(newEnd)).format('YYYY/MM/DD HH:mm'));
                    }
                    if (vm.selectedChartData && vm.selectedChartData.length) {
                        vm.fnGetChartUpdateData();
                    }
                    vm.chartUpdateTimeout = $timeout(function () {
                        vm.fnUpdateDateRangeInput();
                    }, 60000);
                };

                vm.fnGetChartUpdateData = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                };

                vm.fnChartUpdateBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            } else {
                                var chart = $('#ecuAttributeChart').highcharts(); //eslint-disable-line
                                _.forEach(response, function (responseObj, index) {
                                    var parsedData = parsePostgresData(responseObj.body.data);
                                    var tempChartData = vm.fnGenerateChartData(vm.selectedChartData[index], parsedData);
                                    $timeout(function () {
                                        vm.selectedChartData[index].apiData.shift();
                                        vm.selectedChartData[index].apiData.push(responseObj.body.data[0]);
                                        vm.selectedChartData[index].chartData.shift();
                                        vm.selectedChartData[index].chartData.push(_.cloneDeepWith(tempChartData[0]));
                                        var isFind = _.find(vm.pieChartAttributeList, {
                                            name: vm.selectedChartData[index].name,
                                            id: vm.selectedChartData[index].id
                                        });
                                        if (isFind) {
                                            isFind.apiData = _.cloneDeepWith(vm.selectedChartData[index].apiData);
                                            isFind.chartData = _.cloneDeepWith(vm.selectedChartData[index].chartData);
                                        }
                                        var isFindIndex = _.findIndex(chart.series, {name: vm.selectedChartData[index].name});
                                        if (isFindIndex !== -1) {
                                            chart.series[isFindIndex].addPoint(tempChartData[0], true, true);
                                            if (vm.selectedChartData[index].type === 'node') {
                                                if (vm.selectedChartData[index].chartType === 'nodeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthForecast[tempHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthAnomaly[tempHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempConnectionForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionForecast[tempConnectionForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempConnectionAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionAnomaly[tempConnectionAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            } else {
                                                if (vm.selectedChartData[index].chartType === 'attributeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthForecast[tempValueHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthAnomaly[tempValueHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {

                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueForecast[tempValueForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueAnomaly[tempValueAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    })
                                });
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnSetGranularity = function () {
                    vm.fnDataRangeChange();
                }

                vm.fnDeployAttribute = function (alarmObj) {
                    var input = {
                        attributeId: alarmObj.id
                    };
                    NodeAttributesFactory.deployAttribute(input)
                        .then(function (res) {
                            amaran.success("Attribute Synchronize in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html',
                                size: 'lg',
                                controller: 'attributeSyncModalCtrl as attributeSyncModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(res);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnExportToInsight = function () {
                    var tempChartArr = [];
                    var tempObj = {};
                    _.forEach(vm.selectedChartData, function (selectedChartObj) {
                        tempObj = {};
                        tempObj.query = selectedChartObj.sql;
                        tempObj.chart = {
                            chartConfiguration: {
                                chartType: "line",
                                dataMapping: {},
                                chartConfig: {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        labels: {
                                            rotation: -60,
                                            format: "{value:%d/%m %H:%M}"
                                        },
                                        title: {
                                            text: ''
                                        },
                                        type: "datetime"
                                    },
                                    yAxis: {
                                        title: {
                                            text: 'Values'
                                        }
                                    },
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    legend: {
                                        enabled: false
                                    }
                                }
                            }
                        };
                        if (selectedChartObj.type === 'ecu') {
                            if (selectedChartObj.chartType === 'ecuHealth') {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "health"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                            } else {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "value"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                            }
                        } else {
                            if (selectedChartObj.chartType === 'attributeHealth') {
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ForecastHealth';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'AnomalyHealth';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                                }
                            } else {
                                var isStringFound = false;
                                _.forEach(selectedChartObj.apiData, function (dataObj) {
                                    if (dataObj.value && isNaN(dataObj.value)) {
                                        isStringFound = true;
                                    }
                                });
                                if (isStringFound) {
                                    tempObj.chart.chartConfiguration.isSupportStringValue = true;
                                }
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueForecast';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueAnomaly';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                                }
                            }
                        }
                        tempChartArr.push(tempObj)
                    });
                    DB.fnSet('telemetryChart', tempChartArr);
                    $state.go('main.insight_query_editor');
                };

                vm.fnInitEcuAttributes = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var timezone = moment().zone();
                    timezoneName = moment.tz.guess();
                    Highcharts.setOptions({
                        global: {
                            timezoneOffset: timezone
                        }
                    });
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');

                    });
                    var ecuId = vm.parent.ecuObj.id;
                    if (ecuId !== '') {
                        vm.fnGetECUInfo(ecuId);
                    }
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.chartUpdateTimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('EcuSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, NodeEcuFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.ecuSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetECUData = function () {
                    vm.ecuSupplementalObj = vm.parent.ecuObj.tags ? angular.fromJson(_.cloneDeepWith(vm.parent.ecuObj.tags)) : {};
                    vm.ecuSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.ecuSupplementalObj, true) : vm.ecuSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.ecuSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.ecuSupplementalObj)) {
                        angular.forEach(vm.ecuSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isNodeSupplementalDetailsLoaded = true;
                };

                vm.fnGetEcuData = function () {
                    vm.ecuSupplementalObj = vm.parent.ecuObj.tags ? angular.fromJson(vm.parent.ecuObj.tags) : {};
                    vm.ecuSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.ecuSupplementalObj, true) : vm.ecuSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.ecuSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.ecuSupplementalObj)) {
                        angular.forEach(vm.ecuSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.ecuSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.ecuSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.ecuSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.ecuSupplementalObj = angular.toJson(vm.ecuSupplementalObj, true);
                    } else {
                        vm.ecuSupplementalObj = angular.fromJson(vm.ecuSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.ecuSupplementalObj)) {
                            angular.forEach(vm.ecuSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveEcuData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.ecuObj.tags = {};
                    var inputObj = {
                        ecuId: vm.parent.ecuObj.id,
                        body: {}
                    };
                    if (!vm.parent.ecuObj.tags) {
                        vm.parent.ecuObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.ecuObj.tags = angular.fromJson(vm.ecuSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.ecuObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.ecuObj.tags;
                    NodeEcuFactory.updateEcuTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to ECU successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitEcuSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitEcuSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.ecuSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.ecuSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.ecuSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitEcuSupplemental = function () {
                    vm.isEcuSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('RegisterECUCtrl', function ($scope, $timeout, $window, $log, amaran, TabHeight, NodeEcuFactory) {
            var vm = this;
            vm.parent = $scope.$parent;
            vm.ecuRegisterObj = {
                ecuId: '',
                serialId: ''
            };
            vm.isUpdateCompleted = true;

            vm.fnRegisterECU = function (ecuRegisterObj) {
                if (!ecuRegisterObj.ecuId) {
                    amaran.error('ECU ID is required');
                    return;
                }
                if (!ecuRegisterObj.serialId) {
                    amaran.error('Serial Number is required');
                    return;
                }
                // Convert serialId to serial for API compatibility
                var apiPayload = {
                    ecuId: ecuRegisterObj.ecuId,
                    serialId: ecuRegisterObj.serialId.trim()
                };

                vm.isUpdateCompleted = false;
                NodeEcuFactory.bindEcuToUnit(apiPayload)
                    .then(function (response) {
                        // Parse response if it's in data field
                        if (response.data && angular.isString(response.data)) {
                            try {
                                var parsedData = angular.fromJson(response.data);
                                angular.extend(response, parsedData);
                                delete response.data;
                            } catch (e) {
                                $log.error('Error parsing response:', e);
                            }
                        }

                        vm.isUpdateCompleted = true;
                        $scope.$emit('ECUDetailsChanged', response);
                        amaran.success('ECU Registering in progress.');
                    }, function (error) {
                        vm.isUpdateCompleted = true;
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        } else {
                            amaran.error('Failed to register ECU');
                        }
                    });
            };

            /*vm.fnInitRegisterECU = function () {
                if (vm.parent.ecuObj && vm.parent.ecuObj.id) {
                    vm.ecuRegisterObj.ecuId = vm.parent.ecuObj.id;
                }
                $timeout(function () {
                    TabHeight.fnSet();
                });
            };*/

            /*vm.fnInitRegisterECU = function () {
                // Initialize with ECU data if available
                if (vm.parent.ecuObj && vm.parent.ecuObj.id) {
                    vm.ecuRegisterObj = {
                        ecuId: vm.parent.ecuObj.id,
                        serialId: vm.parent.ecuObj.serial || ''
                    };
                }

                // Set up watchers for parent ECU object changes
                $scope.$watch('parent.ecuObj', function(newVal) {
                    if (newVal && newVal.id) {
                        vm.ecuRegisterObj.ecuId = newVal.id;
                    }
                });

                $timeout(function () {
                    TabHeight.fnSet();
                });
            };*/

            vm.fnInitRegisterECU = function () {
                // Get ECU data from parent scope
                if (vm.parent.ecuObj && vm.parent.ecuObj.id) {
                    vm.ecuRegisterObj = {
                        ecuId: vm.parent.ecuObj.id,
                        serialId: vm.parent.ecuObj.serial || ''
                    };
                }

                $timeout(function () {
                    TabHeight.fnSet();
                });
            };

        });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ECULocationCtrl',
            function ($scope, $timeout, amaran, $window, TabHeight, NodeEcuFactory, L) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isECULocationDetailsLoaded = false;
                vm.isSaveLoaderActive = false;
                var map = "";
                var marker = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element("#locationInputBlock")[0]) && angular.isDefined(angular.element("#map1")[0])) {
                        var contentMain = angular.element(".content-main")[0].offsetHeight;
                        var inputContainer = angular.element("#locationInputBlock")[0].offsetHeight;
                        var locationSaveActionBlock = 0;
                        if (angular.element("#locationSaveActionBlock")[0]) {
                            locationSaveActionBlock = angular.element("#locationSaveActionBlock")[0].offsetHeight;
                        }
                        var fianlMapHeight = contentMain - (inputContainer + locationSaveActionBlock + 40);
                        angular.element("#map1").css('height', fianlMapHeight + 'px');
                    }
                };

                vm.fnGetECULocation = function () {
                    vm.ecuObj = _.cloneDeepWith(vm.parent.ecuObj);
                    if (vm.ecuObj.location && vm.ecuObj.location.latitude && vm.ecuObj.location.longitude) {
                        vm.latitude = vm.ecuObj.location.latitude;
                        vm.longitude = vm.ecuObj.location.longitude;
                        vm.actualLatitude = vm.latitude;
                        vm.actualLongitude = vm.longitude;
                    } else {
                        vm.latitude = 39.721712;
                        vm.longitude = -104.941406;
                    }
                    $timeout(function () {
                        vm.isECULocationDetailsLoaded = true;
                        $timeout(function () {
                            document.getElementById('ecuLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                            var mapOptions = {};
                            mapOptions.center = [vm.latitude, vm.longitude];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                            map = new L.Map('map1', mapOptions);
                            marker = L.marker([vm.latitude, vm.longitude], {
                                draggable: true
                            }).addTo(map);
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                            marker.on('drag', function () {
                                $timeout(function () {
                                    vm.actualLatitude = marker.getLatLng().lat;
                                    vm.actualLongitude = marker.getLatLng().lng;
                                    //var test = getMapPostion(e.latlng.lat, e.latlng.lng, map.getZoom());
                                    //console.log('test', test);
                                })
                            });
                            $timeout(function () {
                                map.invalidateSize()
                            });
                        }, 1000)
                    },100)
                };

                vm.fnChangeLocation = function () {
                    if (vm.actualLatitude.length && vm.actualLongitude.length) {
                        var newLatLng = new L.LatLng(vm.actualLatitude, vm.actualLongitude);
                        marker.setLatLng(newLatLng);
                        map.setView(marker.getLatLng(), map.getZoom());
                    }
                };

                /*if (typeof(Number.prototype.toRad) === "undefined") {
                    Number.prototype.toRad = function () {
                        return this * Math.PI / 180;
                    }
                }

                function getMapPostion(lat, lon, zoom) {
                    var xtile = parseInt(Math.floor((lon + 180) / 360 * (1 << zoom)));
                    var ytile = parseInt(Math.floor((1 - Math.log(Math.tan(lat.toRad()) + 1 / Math.cos(lat.toRad())) / Math.PI) / 2 * (1 << zoom)));
                    return {x: xtile, y: ytile, z: zoom};
                    //return "" + zoom + "/" + xtile + "/" + ytile;
                }*/

                vm.fnSaveLocationInfo = function () {
                    vm.isSaveLoaderActive = true;
                    var inputObj = {
                        body: {},
                        ecuId: vm.ecuObj.id
                    };

                    inputObj.body = {
                        latitude: vm.actualLatitude,
                        longitude: vm.actualLongitude,
                        altitude: "",
                        x: "",
                        y: "",
                        z: "",
                        geoJson: {}
                    };
                    NodeEcuFactory.updateEcuLocation(inputObj)
                        .then(function (response) {
                            vm.ecuObj = response;
                            if (vm.ecuObj.location && vm.ecuObj.location.latitude && vm.ecuObj.location.longitude) {
                                vm.latitude = vm.ecuObj.location.latitude;
                                vm.longitude = vm.ecuObj.location.longitude;
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            vm.isSaveLoaderActive = false;
                            $timeout(function () {
                                vm.isECULocationDetailsLoaded = true;
                                $timeout(function () {
                                    document.getElementById('ecuLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                    var mapOptions = {};
                                    mapOptions.center = [vm.latitude, vm.longitude];
                                    mapOptions.zoom = 8;
                                    mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                    map = new L.Map('map1', mapOptions);
                                    marker = L.marker([vm.latitude, vm.longitude], {
                                        draggable: true
                                    }).addTo(map);
                                    $timeout(function () {
                                        vm.fnSetTabHeight();
                                    });
                                    marker.on('drag', function () {
                                        $timeout(function () {
                                            vm.actualLatitude = marker.getLatLng().lat;
                                            vm.actualLongitude = marker.getLatLng().lng;
                                            //var test = getMapPostion(e.latlng.lat, e.latlng.lng, map.getZoom());
                                            //console.log('test', test);
                                        })
                                    });
                                    $timeout(function () {
                                        map.invalidateSize()
                                    });
                                }, 100)
                            })
                            amaran.success("Location Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveLoaderActive = false;
                        });
                };

                vm.fnInitECULocation = function () {
                    vm.isECULocationDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })

                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceGhostCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, $cookies, Paho, ColorService, PermissionsService,
                      GhostService, DB, moment, amaran, swal, TabHeight, SchemaService, TypeFactory,
                      WebSocketFactory, DeviceFactory, UserFactory, FedSudoUserService, AppInitService, IconService, GatewayFactory, AnalyticsFactory,
                      jsonToCsvConvertService, XLSX, analyticsService) {
                var vm = this;
                var overLayWebSocketTimeout;
                var client;
                var count = 0;
                vm.parent = $scope.$parent;
                vm.isGhostDetailsEditable = false;
                vm.isGhostUpdateCompleted = true;
                vm.isFooterLoaderActive = false;
                vm.deviceGhostObj = {};
                vm.selectedGhostObj = {};
                vm.ghostUpdateObj = {};
                vm.isEditInputValidated = false;
                vm.filter = "$";
                vm.search = {$: ''};
                vm.isDropUp = false;
                vm.currentTime = '';

                vm.tabs = [
                    {
                        icon: "fa-table",
                        tabIndex: 0
                    }
                ];
                vm.selectedTab = {};
                vm.tableOptionsObj = {
                    health: true,
                    name: true,
                    value: true,
                    display: true
                };
                var currentTime = Date.now();
                var hours = 3;
                vm.isShowAllGhostAttributes = false;
                vm.recentlyUpdatedComponentReportedArr = [];
                vm.unhealthyComponentReportedArr = [];
                vm.isAttributeAnalyticsDataFetch = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element(".viewGhostSearchBar")[0]) && angular.isDefined(angular.element("thead")[0])) {
                        var totalList = angular.element(".content-main")[0].offsetHeight;
                        var searchList = angular.element(".viewGhostSearchBar")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightList = totalList - (searchList + header + 35 + 20);
                        angular.element("#deviceAllGhostAttributes").css('height', finalHeightList + 'px');
                        var unhealthyComponentFinalHeight = angular.copy(finalHeightList / 2) - (20 + 34 + 10);
                        var recentlyUpdatedComponentFinalHeight = angular.copy(finalHeightList / 2) - (34 + 20 + 10);
                        angular.element(".devicesGhost-table #noComponentReportedData").css('height', finalHeightList + 'px');
                        angular.element(".devicesGhost-table #unhealthyComponentReported").css('height', (unhealthyComponentFinalHeight + 35) + 'px');
                        angular.element(".devicesGhost-table #recentlyUpdatedComponentReported").css('height', (recentlyUpdatedComponentFinalHeight + 35) + 'px');
                        angular.element(".devicesGhost-table tbody#unhealthyComponentReportedArr").css('height', (unhealthyComponentFinalHeight) + 'px');
                        angular.element(".devicesGhost-table tbody#recentlyUpdatedComponentReportedArr").css('height', (recentlyUpdatedComponentFinalHeight) + 'px');
                    }
                };

                vm.fnDownloadXls = function () {
                    var devicesGhostArrCp = angular.copy(vm.deviceGhostObj);
                    var tempData = _.map(devicesGhostArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "DevicesGhost");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "deviceGhost_" + $stateParams.selectedId + ".xlsx");
                };
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchorGhost')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchorGhost').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = angular.copy(vm.deviceGhostObj);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    Object.keys(tempData).map(function(key) {
                        vm.csvHeaderArr = Object.keys(tempData[key]);
                        return vm.csvHeaderArr;
                    });
                    return _.map(data[1], function (deviceGhostObj) {
                        var tempObj = {};
                        _.forEach(vm.csvHeaderArr, function (headerText) {
                            tempObj[headerText] = deviceGhostObj[headerText];
                        });
                        return tempObj;
                    });
                };

                //Context Menu: Start
                vm.attributesContextMenu = function (deviceGhostObj) {
                    return [{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnRenameAttribute(deviceGhostObj);
                        }
                    }]
                };
                //Context Menu: End

                vm.fnRefreshRelativeDeviceGhostTime = function () {
                    angular.forEach(vm.deviceReportedArr, function (deviceGhostObj) {
                        deviceGhostObj.humanDateLastUpdatedRelative = moment(deviceGhostObj.humanTimestamp).fromNow();
                    });
                    vm.repeatativeDeviceGhostTimer = $timeout(function () {
                        vm.fnRefreshRelativeDeviceGhostTime();
                    }, 60000)
                };

                vm.fnGetDeviceGhost = function (deviceObj) {
                    var inputObj = {
                        deviceId: deviceObj.id
                    };

                    DeviceFactory.getDeviceGhost(inputObj)
                        .then(function (response) {
                            vm.deviceGhostObj = response;
                            vm.deviceReportedArr = [];
                            Object.keys(vm.deviceGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.deviceGhostObj[key].name;
                                tempObj.value = vm.deviceGhostObj[key].reported ? vm.deviceGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.deviceGhostObj[key].enabled) ? vm.deviceGhostObj[key].enabled : true;
                                tempObj.health = vm.deviceGhostObj[key].health ? vm.deviceGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.deviceGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.deviceGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.displayName = vm.deviceGhostObj[key].displayName;
                                tempObj.unit = angular.isDefined(vm.deviceGhostObj[key].unit) ? vm.deviceGhostObj[key].unit : "";
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                tempObj.displayValue = tempObj.enabled === false? 'disabled': tempObj.value === "__empty" ? "": tempObj.value;
                                vm.deviceReportedArr.push(tempObj);
                            });
                            $timeout(function () {
                                TabHeight.fnSet();
                                $timeout.cancel(vm.repeatativeDeviceGhostTimer);
                                vm.fnRefreshRelativeDeviceGhostTime();
                            }, 60000);
                            vm.fnGetTypeDefinition(vm.deviceReportedArr);
                            count = 0;
                            vm.currentTime = moment();
                            vm.isAttributeAnalyticsDataFetch = true;
                            vm.fnInitAttributeAnalytics(count);
                        })
                };

                vm.fnGetTypeDefinition = function (deviceReportedArr) {
                    TypeFactory.getType({typeId: vm.parent.deviceObj.typeId})
                        .then(function (response) {
                            if (Object.keys(response.definitions).length) {
                                angular.forEach(deviceReportedArr, function (deviceReportedObj) {
                                    Object.keys(response.definitions).forEach(function (key) {
                                        if (deviceReportedObj.name === key) {
                                            deviceReportedObj.editable = true;
                                            var inputObj = {};
                                            inputObj[key] = response.definitions[key];
                                            deviceReportedObj.schema = SchemaService.convertJsonToSchema(inputObj);
                                            angular.forEach(deviceReportedObj.schema, function (tempObj) {
                                                if (tempObj.default) {
                                                    tempObj.typeValue = tempObj.default;
                                                } else {
                                                    tempObj.typeValue = "";
                                                }
                                                tempObj.isValueMissing = false;
                                                tempObj.isPatternMismatch = false;
                                                tempObj.isMinError = false;
                                                tempObj.isMaxError = false;
                                            });
                                        }
                                    })
                                });
                                vm.selectedTab = vm.tabs[0];
                                vm.isDeviceGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                })
                            } else {
                                vm.selectedTab = vm.tabs[0];
                                vm.isDeviceGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                })
                            }
                            vm.fnGetUnhealthyAndHealthyAttribute(deviceReportedArr);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.selectedTab = vm.tabs[0];
                            vm.isDeviceGhostDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                            vm.fnGetUnhealthyAndHealthyAttribute(deviceReportedArr);
                        })
                };

                vm.fnGetUnhealthyAndHealthyAttribute = function (deviceReportedArr) {
                    vm.recentlyUpdatedComponentReportedArr = [];
                    vm.unhealthyComponentReportedArr = [];
                    currentTime = Date.now();
                    _.forEach(deviceReportedArr, function (deviceReporedObj) {
                        var recentlyUpdateTimeStampData = hours * 60 * 60 * 1000;
                        var deviceTimeStampDiff = currentTime - deviceReporedObj.timestamp;
                        if (deviceTimeStampDiff <= recentlyUpdateTimeStampData) {
                            vm.recentlyUpdatedComponentReportedArr.push(deviceReporedObj);
                        }
                        if (deviceReporedObj.health > 299) {
                            vm.unhealthyComponentReportedArr.push(deviceReporedObj);
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

                vm.fnUpdateAttributeOnWSS = function (obj) {
                    var recentlyUpdatedIndex = _.findIndex(vm.recentlyUpdatedComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (recentlyUpdatedIndex !== -1) {
                        vm.recentlyUpdatedComponentReportedArr.splice(recentlyUpdatedIndex, 1);
                    }
                    var unhealthyComponentIndex = _.findIndex(vm.unhealthyComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (unhealthyComponentIndex !== -1) {
                        vm.unhealthyComponentReportedArr.splice(unhealthyComponentIndex, 1);
                    }
                    vm.recentlyUpdatedComponentReportedArr.push(obj);
                    if (obj.health > 299) {
                        vm.unhealthyComponentReportedArr.push(obj);
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

                vm.fnEditGhostValue = function (deviceGhostObj) {
                    vm.selectedGhostObj = deviceGhostObj.schema;
                    vm.fnOpenModifyGhostAttributeModal();
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isEditInputValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.ghostUpdateObj = propertiesObj;
                    } else {
                        vm.ghostUpdateObj = {};
                    }
                };

                vm.fnGoBackToTableView = function () {
                    vm.selectedGhostObj = {};
                    vm.isGhostDetailsEditable = false;
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

                vm.fnUpdateGhostValue = function () {
                    vm.isGhostUpdateCompleted = false;
                    var inputObj = {
                        deviceId: vm.parent.deviceObj.id,
                        body: {
                            state: {
                                metadata: vm.ghostUpdateObj
                            }
                        }
                    };
                    DeviceFactory.modifyDeviceGhost(inputObj)
                        .then(function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isDeviceGhostDetailsLoaded = false;
                            vm.fnGetDeviceGhost(vm.parent.deviceObj);
                            amaran.success("Ghost Value Updated");
                        }, function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isDeviceGhostDetailsLoaded = false;
                            vm.fnGetDeviceGhost(vm.parent.deviceObj);
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.deviceReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostDevicesArr = angular.copy(vm.deviceReportedArr);
                    } else {
                        vm.selectedGhostDevicesArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.deviceReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                };

                vm.isEmptyObject = function (obj) {
                    return Object.keys(obj).length;
                };

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    $timeout.cancel(overLayWebSocketTimeout);
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.deviceReportedArr, function (ghostObj) {
                        return ghostObj.name === messageJson.name;
                    });
                    if (index !== -1 && vm.deviceReportedArr[index]) {
                        if (messageJson.health) {
                            vm.deviceReportedArr[index].health = messageJson.health;
                            var healthObj = ColorService.getHealthColorForLoop(vm.deviceReportedArr[index].health);
                            vm.deviceReportedArr[index].healthName = healthObj.content;
                            vm.deviceReportedArr[index].healthColor = healthObj['background-color'];
                            vm.deviceReportedArr[index].textColor = healthObj.color;
                            if (vm.deviceReportedArr[index].healthName === vm.deviceReportedArr[index].health) {
                                vm.deviceReportedArr[index].toolTipName = vm.deviceReportedArr[index].health;
                            } else {
                                vm.deviceReportedArr[index].toolTipName = vm.deviceReportedArr[index].healthName + " "
                                    + vm.deviceReportedArr[index].health;
                            }
                        }
                        if (messageJson.value) {
                            vm.deviceReportedArr[index].value = messageJson.value;
                            vm.deviceReportedArr[index].displayValue = vm.deviceReportedArr[index].enabled === false? 'disabled': vm.deviceReportedArr[index].value === "__empty" ? "": vm.deviceReportedArr[index].value;
                        }
                        vm.deviceReportedArr[index].timestamp = Math.floor(Date.now() / 1000);
                        vm.deviceReportedArr[index].humanTimestamp = moment.unix(vm.deviceReportedArr[index].timestamp).format("MM/DD/YYYY HH:mm:ss");
                        vm.deviceReportedArr[index].humanDateLastUpdatedAbsolute = moment.unix(vm.deviceReportedArr[index].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                        vm.deviceReportedArr[index].humanDateLastUpdatedRelative = moment(vm.deviceReportedArr[index].humanTimestamp).fromNow();
                        $timeout(function () {
                            vm.deviceReportedArr[index].isProcessing = false;
                        });
                        angular.element($window).triggerHandler('resize');
                        $timeout(function () {
                            vm.fnUpdateAttributeOnWSS(vm.deviceReportedArr[index]);
                        });
                    }
                }

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnEnableDisableAttribute = function (deviceGhostObj) {
                    vm.isFooterLoaderActive = true;
                    var inputObj = {};
                    if (angular.isUndefined(deviceGhostObj.enabled) || deviceGhostObj.enabled === true) {
                        inputObj = {
                            deviceId: vm.parent.deviceObj.id,
                            attributeName: deviceGhostObj.name
                        };
                        DeviceFactory.disableDeviceAttribute(inputObj)
                            .then(function (response) {
                                vm.isFooterLoaderActive = false;
                                if (!response.code) {
                                    deviceGhostObj.enabled = false;
                                    amaran.success("The Attribute disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    deviceGhostObj.enabled = true;
                                    amaran.error(response.message)
                                }
                            })
                    } else {
                        inputObj = {
                            deviceId: vm.parent.deviceObj.id,
                            body: deviceGhostObj
                        };
                        DeviceFactory.enableDeviceAttribute(inputObj)
                            .then(function (response) {
                                vm.isFooterLoaderActive = false;
                                if (!response.code) {
                                    deviceGhostObj.enabled = true;
                                    amaran.success("The Attribute enable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    deviceGhostObj.enabled = false;
                                    amaran.error(response.message);
                                }
                            })
                    }
                };

                vm.fnInitializeWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/attributes/" + vm.parent.deviceObj.id})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("device ghost websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("device ghost websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnOpenNativeInterface = function () {
                    $scope.$emit('OpenNativeInterface', true);
                };

                $scope.$on('DeviceAttributeLoader', function () {
                    if (vm.isFooterLoaderActive) {
                        vm.isFooterLoaderActive = false;
                    }
                });

                vm.fnGetGatewayDetails = function (gatewayId) {
                    GatewayFactory.getGateway({gatewayId: gatewayId})
                        .then(function (res) {
                            vm.gatewayObj = res;
                        }, function () {
                            vm.gatewayObj = null;
                        })
                };

                vm.fnManageIssue = function (deviceGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeManageIssueTemplateModal/attributeManageIssueTemplateModal.html',
                        size: 'lg',
                        controller: 'attributeManageIssueTemplateModalCtrl as attributeManageIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueType: function () {
                                return "device"
                            },
                            GhostObj: function () {
                                return deviceGhostObj;
                            },
                            componentObj: function () {
                                return {};
                            },
                            deviceObj: function () {
                                return vm.parent.deviceObj;
                            },
                            gatewayObj: function () {
                                return vm.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                        })
                    }, function () {

                    });
                };

                vm.fnInitDeviceGhost = function () {
                    if ($stateParams.isConnectNativeInterface && ($stateParams.isConnectNativeInterface === 'true' ||
                        $stateParams.isConnectNativeInterface === true)) {
                        $timeout(function () {
                            $state.go('main.device', {isConnectNativeInterface: ''}, {notify: false});
                            delete $stateParams.isConnectNativeInterface;
                            vm.fnOpenNativeInterface();
                        })
                    }
                    vm.fnInitializeWebSockets();
                    vm.devicePermissionsObj = PermissionsService.getPermissions("node:device");
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    TabHeight.fnSet();
                    vm.isDeviceGhostDetailsLoaded = false;
                    var gatewayId = vm.parent.deviceObj.id.substring(0, vm.parent.deviceObj.id.lastIndexOf("-"));
                    vm.fnGetGatewayDetails(gatewayId);
                    if (vm.parent.deviceObj.id) {
                        vm.fnGetDeviceGhost(vm.parent.deviceObj);
                    }
                };

                vm.fnShowAllGhostAttributes = function () {
                    vm.isShowAllGhostAttributes = true;
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };

                vm.fnOpenModifyGhostAttributeModal = function () {
                    var inputObj = {
                        deviceId: vm.parent.deviceObj.id,
                        body: {}
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/modifyGhostAttribute/modifyGhostAttribute.html',
                        size: 'md',
                        controller: 'modifyGhostAttributeCtrl as modifyGhostAttribute',
                        resolve: {
                            selectedGhostObj: function () {
                                return angular.copy(vm.selectedGhostObj);
                            },
                            ghostType: function () {
                                return 'Device'
                            },
                            requiredInputObj: function () {
                                return inputObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        vm.selectedGhostObj = {};
                    }, function () {
                        vm.selectedGhostObj = {};
                    });
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnInitAttributeAnalytics = function (count) {
                    vm.isAttributeAnalyticsDataFetch = false;
                    if (count < vm.deviceReportedArr.length) {
                        vm.fnGetAttributeAnalyticsValue(count);
                    } else {
                        $timeout(function () {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            })
                        });
                    }
                };

                vm.fnGetAttributeAnalyticsValue = function (count) {
                    if (vm.deviceReportedArr[count].health > 299) {
                        var duration = moment.duration(vm.currentTime.diff(vm.deviceReportedArr[count].timestamp));
                        var minutes = duration.asMinutes();
                        if (minutes < 10) {
                            var inputObj = {
                                dataSets: ["ATOMIC"],
                                nodeId: vm.parent.deviceObj.id,
                                timeRange: {
                                    relative: {
                                        start: "10m"
                                    }
                                },
                                attributeQuery: {
                                    attributeName: vm.deviceReportedArr[count].name,
                                    queryType: "VALUE"
                                }
                            };
                            var headers = {
                                'Content-Type': 'application/json',
                                'x-pre-api-version': '4',
                                'authorization': 'Bearer ' + $cookies.get('phoenix')
                            };
                            var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                            $http({
                                method: "POST",
                                url: apiURL,
                                responseType: 'application/json',
                                headers: headers,
                                data: inputObj
                            }).then(function (response) {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                if (response && response.status && response.data &&
                                    !response.status.toString().startsWith('20')) {
                                    vm.analyticsValueData = {};
                                    amaran.error(response.data.message);
                                } else {
                                    if(response && response.data && response.data.data){
                                        vm.analyticsValueData = response.data.data;
                                    }else{
                                        vm.analyticsValueData = {};
                                    }
                                    if (response && response.data && response.data.meta) {
                                        startTime = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                        endTime = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                    }
                                }
                                if (vm.analyticsValueData && vm.analyticsValueData.ATOMIC && vm.analyticsValueData.ATOMIC.points) {
                                    var attributeAnalyticsb64String = vm.analyticsValueData.ATOMIC.points;
                                    var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                                    var tempAggregateHealthArr = analyticsService.getAttributeValueData(attributeAnalyticsCSVString);
                                    if (tempAggregateHealthArr.attributeValueData.length) {
                                        var analyticsAttrValueArr = [];
                                        var valuesArr = tempAggregateHealthArr.attributeValuesArr.sort(function (a, b) {
                                            return a - b;
                                        });
                                        _.forEach(tempAggregateHealthArr.attributeValueData, function (obj) {
                                            analyticsAttrValueArr.push({
                                                x: obj.x,
                                                y: valuesArr.indexOf(obj.y),
                                                name: obj.y
                                            })
                                        });
                                        vm.deviceReportedArr[count].inlineChartData = analyticsAttrValueArr;
                                    } else {
                                        vm.deviceReportedArr[count].inlineChartData = [{
                                            x: startTime,
                                            y: 0,
                                            name: vm.deviceReportedArr[count].value
                                        }, {
                                            x: endTime,
                                            y: 0,
                                            name: vm.deviceReportedArr[count].value
                                        }];
                                    }
                                    count++;
                                    if (count < vm.deviceReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTabHeight();
                                        })
                                    }
                                } else {
                                    vm.deviceReportedArr[count].inlineChartData = [{
                                        x: startTime,
                                        y: 0,
                                        name: vm.deviceReportedArr[count].value
                                    }, {
                                        x: endTime,
                                        y: 0,
                                        name: vm.deviceReportedArr[count].value
                                    }];
                                    count++;
                                    if (count < vm.deviceReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTabHeight();
                                        })
                                    }
                                }
                            }, function error() {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                vm.deviceReportedArr[count].inlineChartData = [{
                                    x: startTime,
                                    y: 0,
                                    name: vm.deviceReportedArr[count].value
                                }, {
                                    x: endTime,
                                    y: 0,
                                    name: vm.deviceReportedArr[count].value
                                }];
                                count++;
                                if (count < vm.deviceReportedArr.length) {
                                    vm.fnGetAttributeAnalyticsValue(count);
                                } else {
                                    //done
                                    vm.isAttributeAnalyticsDataFetch = true;
                                    $timeout(function () {
                                        vm.fnSetTabHeight();
                                    })
                                }
                            });
                        } else {
                            var newChartData = [{
                                x: moment().subtract(10, 'minutes').valueOf(),
                                y: 0,
                                name: vm.deviceReportedArr[count].value
                            }, {
                                x: moment().valueOf(),
                                y: 0,
                                name: vm.deviceReportedArr[count].value
                            }];
                            vm.deviceReportedArr[count].inlineChartData = newChartData;
                            count++;
                            if (count < vm.deviceReportedArr.length) {
                                vm.fnGetAttributeAnalyticsValue(count);
                            } else {
                                vm.isAttributeAnalyticsDataFetch = true;
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                })
                            }
                        }
                    } else {
                        vm.deviceReportedArr[count].inlineChartData = [];
                        count++;
                        if (count < vm.deviceReportedArr.length) {
                            vm.fnGetAttributeAnalyticsValue(count);
                        } else {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            })
                        }
                    }
                };

                vm.fnRenameAttribute = function (deviceGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeRenameModal/attributeRenameModal.html',
                        size: 'md',
                        controller: 'attributeRenameModalCtrl as attributeRenameModal',
                        resolve: {
                            selectedGhostObj: function () {
                                return _.cloneDeepWith(deviceGhostObj);
                            },
                            ghostType: function () {
                                return 'Device'
                            },
                            id: function () {
                                return vm.parent.deviceObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (newName) {
                        deviceGhostObj.displayName = newName;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 1000)
                    }, function () {
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 1000)
                    });
                };

                vm.fnOpenAttributeStatistics = function (selectedAttribute) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html',
                        size: 'lg',
                        controller: 'attributeStatisticsModalCtrl as attributeStatistics',
                        resolve: {
                            selectedAttribute: function () {
                                return selectedAttribute;
                            },
                            selectedComponent: function () {
                                return vm.parent.deviceObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.$on('$destroy', function () {
                    if (client) {
                        client.disconnect();
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, DB, PermissionsService, TabHeight, DeviceFactory, $uibModal) {
                var vm = this;

                //var loginUser = DB.fnGet('loginUser');

                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.deviceSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnInjectFunction = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html',
                        size: 'lg',
                        controller: 'supplementFunctionModalCtrl as supplementModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (supplementalArr) {
                        _.forEach(supplementalArr, function (supplementalObj) {
                            if (supplementalObj.key && supplementalObj.value && supplementalObj.key.length && supplementalObj.value.length) {
                                var isFind = _.find(vm.supplementalKVPArr, {key: supplementalObj.key});
                                if(!isFind){
                                    vm.supplementalKVPArr.push(supplementalObj);
                                }else{
                                    isFind.value = supplementalObj.value;
                                }
                            }
                        });
                        _.remove(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            return supplementalKVPObj.key === '' && supplementalKVPObj.value === '';
                        });
                        if (!vm.supplementalKVPArr.length) {
                            vm.supplementalKVPArr = [{key: '', value: ''}];
                        }
                    }, function () {
                    });

                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetDeviceData = function (deviceObj) {
                    var inputObj = {
                        deviceId: deviceObj.id
                    };

                    DeviceFactory.getDevice(inputObj)
                        .then(function (response) {
                            vm.deviceSupplementalObj = response.data ? angular.fromJson(response.data) : {};
                            /*{
                                lat: ["456"],
                                    long: ["789"]
                            };*/
                            vm.deviceSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.deviceSupplementalObj,true):vm.deviceSupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.deviceSupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.deviceSupplementalObj)) {
                                angular.forEach(vm.deviceSupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value[0]
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isDeviceSupplementalDetailsLoaded = true;
                        })
                };
                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isSupplementalEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isSupplementalEditable = false;
                        vm.deviceSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };
                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.deviceSupplementalObj = angular.toJson(vm.deviceSupplementalObj, true);
                    } else {
                        vm.deviceSupplementalObj = angular.fromJson(vm.deviceSupplementalObj);
                        //vm.resetSupplementalObj = angular.copy(vm.deviceSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.deviceSupplementalObj)) {
                            angular.forEach(vm.deviceSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value[0]
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                        vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnSaveDeviceData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.deviceObj.data = {};
                    var inputObj = {
                        deviceId: vm.parent.deviceObj.id,
                        body: {}
                    };
                    if (!vm.parent.deviceObj.data) {
                        vm.parent.deviceObj.data = {};
                    }
                    angular.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                        if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                            vm.parent.deviceObj.data[kpPairObj.key] = ["" + kpPairObj.value + ""];
                        }
                    });
                    inputObj.body = vm.parent.deviceObj.data;
                    DeviceFactory.updateDeviceData(inputObj)
                        .then(function () {
                            amaran.success("Data added to device successfully");
                                vm.isSupplementalDetailChanging = false;
                                vm.isSupplementalDetailsEditable = false;
                                vm.fnInitDeviceSupplemental();
                        }, function () {
                                vm.isSupplementalDetailChanging = false;
                                vm.isSupplementalDetailsEditable = false;
                                vm.fnInitDeviceSupplemental();
                        })

                };

                vm.fnEditDeviceData = function (obj) {
                    vm.isSupplementalEditableUpdate = true;
                    var inputObj = {
                        deviceId: vm.parent.deviceObj.id,
                        body: {
                            data: angular.fromJson(obj)
                        }
                    };
                    DeviceFactory.modifyDevice(inputObj)
                        .then(function () {
                            amaran.success("Data edited successfully");
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitDeviceSupplemental();
                        }, function () {
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitDeviceSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if(isCalledEditMode){
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    });
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.deviceSupplementalObj = angular.copy(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.deviceSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.deviceSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value[0]
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                };
                vm.fnInitDeviceSupplemental = function () {
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    TabHeight.fnSet();
                    vm.isDeviceSupplementalDetailsLoaded = false;
                    if (vm.parent.deviceObj.id) {
                        vm.fnGetDeviceData(vm.parent.deviceObj);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceOverviewCtrl',
            function ($window, $scope, $state, $timeout, $uibModal, $stateParams, $http, $cookies, pako, amaran, moment, TabHeight, PermissionsService, AnalyticsFactory,
                      IconService, ColorService, GatewayFactory, ComponentFactory, analyticsService) {
                var vm = this;
                var startTime = "";
                var endTime = "";

                vm.parent = $scope.$parent;
                vm.infoSectionClass = vm.parent.infoSectionClass;
                vm.hasComponents = vm.parent.deviceObj.hasComponents;

                /*START: CHART ARRAYS*/
                vm.healthData = [];
                vm.barData = [];
                vm.componentsCount = [];
                vm.componentPieData = [];
                vm.deviceHealthPieData = [];
                vm.deviceConnectionPieData = [];
                vm.gatewayConnectionPieData = [];
                vm.componentsPieDataObj = {};
                vm.selectedComponentPie = '';
                vm.atomicComponentPieData = [];
                vm.isShowGatewayConnection = true;
                vm.categoriesArr = ["Device", "Gateway"];
                vm.allComponentsPieDateArr = [];
                /*END: CHART ARRAYS*/

                vm.deviceGateway = {};
                vm.isGatewayEmpty = true;

                /*START: CHART LOADERS*/
                vm.isGatewayDetailsLoading = true;
                vm.isAggregateChartLoading = true;
                vm.isBarCharLoading = true;
                vm.isComponentsLoading = true;
                vm.isPieChartLoading = true;
                vm.isGetAtomicHealth = false;
                vm.isComponentLongResponse = false;
                /*END: CHART LOADERS*/
                vm.analyticsV4Data = {};

                /*START: FILTER OPTIONS*/
                vm.filterOptions = [{
                    value: '1h',
                    tabIndex: 0,
                    name: '1',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3h',
                    tabIndex: 1,
                    name: '3',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '12h',
                    tabIndex: 2,
                    name: '12',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3d',
                    tabIndex: 3,
                    name: '3',
                    units: 'days',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '1w',
                    tabIndex: 4,
                    name: '1',
                    units: 'weeks',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: 'Custom',
                    tabIndex: 5
                }];
                vm.chartOptions = [{
                    name: 'Area Chart',
                    icon: 'fa-area-chart',
                    tabIndex: 0
                }, {
                    name: 'Pie Chart',
                    icon: 'fa-pie-chart',
                    tabIndex: 1
                }];
                vm.selectedFilterOption = vm.filterOptions[1];
                vm.selectedFilterObj = vm.filterOptions[1];
                vm.selectedChartType = vm.chartOptions[0];
                vm.selectedAggregateFn = 'MAX';
                /*END: FILTER OPTIONS*/

                vm.isShowLabel = false;
                vm.isShowComponentPieLabel = false;

                /* Analytics V4 endpoint: Start */
                vm.fnGetAnalyticsQueryData = function () {
                    vm.isGetAnalyticsData = true;
                    vm.isGetAtomicHealth = false;
                    vm.isAggregateChartLoading = true;
                    vm.isBarCharLoading = true;
                    vm.deviceConnectionArr = [];
                    var inputObj = {
                        "dataSets": [],
                        "nodeId": vm.parent.deviceObj.id,
                        "timeRange": {}
                    };
                    if (vm.componentsArr && vm.componentsArr.length) {
                        inputObj.dataSets = ["ATOMIC", "AGGREGATE", "CONNECTION"]
                    } else {
                        inputObj.dataSets = ["AGGREGATE", "CONNECTION"]
                    }
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };
                    vm.isComponentLongResponse = false;
                    vm.longResponseTimer = $timeout(function () {
                        vm.isComponentLongResponse = true;
                    }, 5000);
                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        $timeout.cancel(vm.longResponseTimer);
                        vm.heatmapCategoriesArr = [];
                        startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsV4Data = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if (response && response.data && response.data.data) {
                                vm.analyticsV4Data = response.data.data;
                            } else {
                                vm.analyticsV4Data = {};
                            }
                            vm.analyticsV4Data = response.data.data;
                            if (response && response.data && response.data.meta) {
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            } else {
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.heatmapCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnGetAggregateHealth(timeStampsArr);
                        vm.fnCreateDeviceConnectionData(timeStampsArr);
                        vm.isGetAnalyticsData = false;
                        if (vm.componentsArr && vm.componentsArr.length) {
                            vm.fnGetAtomicHealth(timeStampsArr);
                        } else {
                            vm.isGetAtomicHealth = true;
                        }
                    }, function error() {
                        vm.heatmapCategoriesArr = [];
                        startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.heatmapCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnGetAggregateHealth(timeStampsArr);
                        if (vm.componentsArr && vm.componentsArr.length) {
                            vm.fnGetAtomicHealth(timeStampsArr);
                        }
                        vm.fnCreateDeviceConnectionData(timeStampsArr);
                        vm.isGetAnalyticsData = false;
                    });
                };

                /* Analytics V4 endpoint: End */

                /* TimeLine Interval: Start */
                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };
                /* TimeLine Interval: end */

                vm.fnGetString = function (key) {
                    return key.replace(/#/g, ' → ').replace(/:/g, ' ');
                };

                /* Aggregate & Atomic Health: Start */
                vm.fnGetAggregateHealth = function (timeStampsArr) {
                    vm.isAggregateChartLoading = true;
                    if (vm.analyticsV4Data && vm.analyticsV4Data.AGGREGATE && vm.analyticsV4Data.AGGREGATE.points) {
                        var deviceAnalyticsb64String = vm.analyticsV4Data.AGGREGATE.points;
                        var deviceAnalyticsCSVString = analyticsService.getCSVString(deviceAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAggregateHealthData(deviceAnalyticsCSVString);
                        var devicePieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.length) {
                            vm.aggregateHealthArr = tempAggregateHealthArr;
                            var devicePieChartString = vm.analyticsV4Data.AGGREGATE.summary;
                            var devicePieChartAnalyticsCSVString = analyticsService.getCSVString(devicePieChartString);
                            devicePieChartAnalyticsData = analyticsService.getAggregateHealthPieChartData(devicePieChartAnalyticsCSVString);
                        } else {
                            devicePieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        }
                        vm.fnGeneratePieData(devicePieChartAnalyticsData, 'device');
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        vm.fnGeneratePieData(pieChartAnalyticsData, 'device');
                    }
                    vm.isAggregateChartLoading = false;
                };

                vm.fnGetAtomicHealth = function (timeStampsArr) {
                    vm.isGetAtomicHealth = false;
                    vm.componentsPieDataObj = {};
                    vm.atomicHealthArr = [];
                    vm.atomicHealthComponentArr = [];
                    if (vm.analyticsV4Data && vm.analyticsV4Data.ATOMIC && vm.analyticsV4Data.ATOMIC.points) {
                        var b64Data = vm.analyticsV4Data.ATOMIC.points;
                        var componentAnalyticsCSVString = analyticsService.getCSVString(b64Data);
                        var tempAtomicDataObj = analyticsService.getAtomicHealthData(componentAnalyticsCSVString, vm.componentsArr);
                        if (tempAtomicDataObj && tempAtomicDataObj.atomicHealthArr.length) {
                            vm.atomicHealthArr = tempAtomicDataObj.atomicHealthArr;
                            vm.atomicHealthComponentArr = tempAtomicDataObj.atomicHealthCategoriesArr;
                            vm.componentsPieDataObj.All = "All";
                            vm.selectedComponentPie = "All";
                            var devicePieChartString = vm.analyticsV4Data.ATOMIC.summary;
                            var devicePieChartAnalyticsCSVString = analyticsService.getCSVString(devicePieChartString);
                            vm.allComponentsPieDateArr = analyticsService.getAtomicHealthPieChartData(devicePieChartAnalyticsCSVString, vm.componentsArr);
                            _.forEach(_.groupBy(vm.allComponentsPieDateArr, "id"), function (obj, key) {
                                var isFindComponent = _.find(vm.componentsArr, {id: key});
                                if (isFindComponent) {
                                    if (!vm.componentsPieDataObj[isFindComponent.index]) {
                                        vm.componentsPieDataObj[isFindComponent.index] = [];
                                    }
                                    vm.componentsPieDataObj[isFindComponent.index] = obj;
                                }
                            });
                        } else {
                            var tempAtomicHealth = vm.fnCreateAtomicStaticHealth(timeStampsArr);
                            vm.atomicHealthArr = tempAtomicHealth.atomicHealthArr;
                            vm.atomicHealthComponentArr = tempAtomicHealth.atomicHealthCategoriesArr;
                            vm.allComponentsPieDateArr = tempAtomicHealth.allComponentsPieDateArr;
                            vm.componentsPieDataObj.All = "All";
                            vm.selectedComponentPie = "All";
                            _.forEach(_.groupBy(vm.allComponentsPieDateArr, "id"), function (obj, key) {
                                var isFindComponent = _.find(vm.componentsArr, {id: key});
                                if (isFindComponent) {
                                    if (!vm.componentsPieDataObj[isFindComponent.index]) {
                                        vm.componentsPieDataObj[isFindComponent.index] = [];
                                    }
                                    vm.componentsPieDataObj[isFindComponent.index] = obj;
                                }
                            });
                        }
                        vm.fnGeneratePieData(vm.allComponentsPieDateArr, 'component');
                    } else {
                        var tempAtomicHealth1 = vm.fnCreateAtomicStaticHealth(timeStampsArr);
                        vm.atomicHealthArr = tempAtomicHealth1.atomicHealthArr;
                        vm.atomicHealthComponentArr = tempAtomicHealth1.atomicHealthCategoriesArr;
                        vm.allComponentsPieDateArr = tempAtomicHealth1.allComponentsPieDateArr;
                        vm.componentsPieDataObj.All = "All";
                        vm.selectedComponentPie = "All";
                        _.forEach(_.groupBy(vm.allComponentsPieDateArr, "id"), function (obj, key) {
                            var isFindComponent = _.find(vm.componentsArr, {id: key});
                            if (isFindComponent) {
                                if (!vm.componentsPieDataObj[isFindComponent.index]) {
                                    vm.componentsPieDataObj[isFindComponent.index] = [];
                                }
                                vm.componentsPieDataObj[isFindComponent.index] = obj;
                            }
                        });
                        vm.fnGeneratePieData(vm.allComponentsPieDateArr, 'component');
                    }
                    vm.isGetAtomicHealth = true;
                };

                vm.fnCreateAggregateStaticHealth = function (timeStampsArr) {
                    vm.aggregateHealthArr = [];
                    var analyticsHealthArr = [];
                    var tempIndex = 0;
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var healthObj = ColorService.getHealthColorForLoop(parseInt(vm.parent.deviceObj.health));
                        vm.aggregateHealthArr.push({
                            x: 0,
                            y: tempIndex,
                            value: parseInt(vm.parent.deviceObj.health),
                            color: healthObj['background-color'],
                            healthObj: healthObj,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsHealthArr.push({
                            duration: 100,
                            health: parseInt(vm.parent.deviceObj.health),
                            healthObj: healthObj,
                            id: vm.parent.deviceObj.id,
                            percentage: 100,
                            marker: {fillColor: healthObj['background-color']}
                        });
                        tempIndex++
                    });
                    return analyticsHealthArr;
                };

                vm.fnCreateAtomicStaticHealth = function (timeStampsArr) {
                    var tempArr = _.filter(vm.componentsArr, {enabled: true});
                    var i1 = 1;
                    var k1 = 1;
                    var finalArr1 = [];
                    var tempCharData1 = [];
                    var allComponentsPieDateArr = [];
                    _.forEach(tempArr, function (obj) {
                        k1 = 1;
                        tempCharData1.push(obj.name && obj.name !== ' ' ? obj.name : obj.index ? obj.index.includes('#') ? obj.index.split('#')[obj.index.split('#').length - 1].replace(':', ' ') : obj.index.replace(':', ' ') : 'default');
                        _.forEach(timeStampsArr, function (timeStamp) {
                            var health = obj.health;
                            var healthObj = ColorService.getHealthColorForLoop(health);
                            finalArr1.push({
                                x: i1 - 1,
                                y: k1 - 1,
                                value: health,
                                color: healthObj['background-color'],
                                healthObj: healthObj,
                                date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                            });
                            allComponentsPieDateArr.push({
                                duration: 100,
                                health: health,
                                healthObj: healthObj,
                                id: obj.id,
                                marker: {fillColor: healthObj['background-color']},
                                percentage: 100
                            });
                            k1++;
                        });
                        i1++;
                    });
                    return {
                        atomicHealthArr: finalArr1,
                        atomicHealthCategoriesArr: tempCharData1,
                        allComponentsPieDateArr: allComponentsPieDateArr
                    };
                };
                /* Aggregate & Atomic Health: End */

                /* Connection chart Data: Start */
                vm.fnCreateDeviceConnectionData = function (timeStampsArr) {
                    vm.deviceConnectionArr = [];
                    if (vm.analyticsV4Data && vm.analyticsV4Data.CONNECTION && vm.analyticsV4Data.CONNECTION.points) {
                        var deviceAnalyticsb64String = vm.analyticsV4Data.CONNECTION.points;
                        var deviceAnalyticsCSVString = analyticsService.getCSVString(deviceAnalyticsb64String);
                        var tempConnectionArr = analyticsService.getConnectionData(deviceAnalyticsCSVString);
                        var deviceConnectionPieChartAnalyticsData = [];
                        if (tempConnectionArr.length) {
                            vm.deviceConnectionArr = tempConnectionArr;
                            var devicePieChartString = vm.analyticsV4Data.CONNECTION.summary;
                            var devicePieChartAnalyticsCSVString = analyticsService.getCSVString(devicePieChartString);
                            deviceConnectionPieChartAnalyticsData = analyticsService.getConnectionPieData(devicePieChartAnalyticsCSVString);
                        } else {
                            deviceConnectionPieChartAnalyticsData = vm.fnCreateConnectionStaticData(timeStampsArr);
                        }
                        vm.fnGenerateConnectionPieData(deviceConnectionPieChartAnalyticsData, 'device');
                    } else {
                        var deviceConnectionPieChart = vm.fnCreateConnectionStaticData(timeStampsArr);
                        vm.fnGenerateConnectionPieData(deviceConnectionPieChart, 'device');
                    }
                    vm.isBarCharLoading = false;
                };

                vm.fnCreateConnectionStaticData = function (timeStampsArr) {
                    var analyticsConnectionPieArr = [];
                    var tempIndex = 0;
                    var connectionStatus = vm.parent.deviceObj.connection === "CONNECTED" ? "connected" : "disconnected";
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var connectionColor = ColorService.getConnectionColor(vm.parent.deviceObj.connection).color;
                        vm.deviceConnectionArr.push({
                            x: 0,
                            y: tempIndex,
                            value: "-",
                            connection: connectionStatus,
                            color: connectionColor,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsConnectionPieArr.push({
                            duration: 100,
                            percentage: 100,
                            connection: connectionStatus
                        });
                        tempIndex++
                    });
                    return analyticsConnectionPieArr;
                };

                /* Connection chart Data: End */

                /* Generate Pie Chart Data: Start */
                vm.fnGenerateConnectionPieData = function (barData, type) {
                    var pieData = [];
                    var groupedConnectionObj = _.groupBy(barData, function (x) {
                        return x.connection
                    });
                    _.forEach(groupedConnectionObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        pieData.push({
                            name: key,
                            y: totalP,
                            color: ColorService.getConnectionColor(key).color,
                            healthTextColor: ColorService.getConnectionColor(key).color
                        })
                    });
                    if (type.toLowerCase() === 'device') {
                        vm.deviceConnectionPieData = pieData;
                    } else {
                        vm.gatewayConnectionPieData = pieData;
                    }
                };

                vm.fnGeneratePieData = function (healthArr, type) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(healthArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: totalP,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    if (type === 'device') {
                        vm.deviceHealthPieData = pieData;
                    } else if (type === 'component') {
                        vm.atomicComponentPieData = pieData;
                    }
                };

                vm.fnGenerateComponentsPieData = function (inventoriesArr) {
                    var pieData = [];
                    var tempData = _.filter(inventoriesArr, {enabled: true});
                    var groupedHealthObj = _.mapValues(_.groupBy(tempData, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: val.length,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.componentPieData = pieData;
                    vm.isPieChartLoading = false;
                };
                /* Generate Pie Chart Data: End */

                /* Component Detail : Start */
                vm.fnGetDeviceComponent = function (inputObj) {
                    vm.isComponentsLoading = true;
                    vm.isPieChartLoading = true;
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            var topicObj = {};
                            _.forEach(vm.parent.typesArr, function (d) {
                                topicObj[d.id] = d
                            });
                            _.forEach(response, function (resObj) {
                                if (resObj.enabled === true) {
                                    var healthObj = ColorService.getHealthColorForLoop(resObj.health);
                                    resObj.healthName = healthObj.content;
                                    if (resObj.healthName === resObj.health) {
                                        resObj.toolTipName = resObj.health;
                                    } else {
                                        resObj.toolTipName = resObj.healthName + " " + resObj.health;
                                    }
                                    resObj.healthColor = healthObj['background-color'];
                                    resObj.textColor = healthObj.color;
                                }
                                resObj.typeObj = topicObj[resObj.typeId];
                            });
                            vm.componentsArr = _.cloneDeepWith(response);
                            vm.fnGetComponentsActiveInactiveCount(response);
                            vm.fnGenerateComponentsPieData(response);
                            vm.fnGetAnalyticsQueryData();
                        }, function () {
                            vm.componentsArr = [];
                            vm.componentsCount = [];
                            vm.componentPieData = [];
                            vm.fnGetAnalyticsQueryData();
                            vm.isComponentsLoading = false;
                        });
                };

                vm.fnGetComponentsActiveInactiveCount = function (inventoriesArr) {
                    var componentActive = 0;
                    var componentDeActive = 0;
                    angular.forEach(inventoriesArr, function (inventoryObj) {
                        if (inventoryObj.enabled === true) {
                            componentActive++;
                        } else {
                            componentDeActive++;
                        }
                    });
                    vm.componentsCount = [{
                        name: 'Disabled',
                        y: componentDeActive,
                        color: '#434348',
                        total: inventoriesArr.length
                    }, {
                        name: 'Enabled',
                        y: componentActive,
                        color: '#7cb5ec',
                        total: inventoriesArr.length
                    }];
                    vm.isComponentsLoading = false;
                };

                vm.fnChangeComponentPieOption = function () {
                    vm.atomicComponentPieData = [];
                    $timeout(function () {
                        if (vm.selectedComponentPie === "All") {
                            vm.fnGeneratePieData(vm.allComponentsPieDateArr, 'component');
                        } else {
                            vm.fnGeneratePieData(vm.componentsPieDataObj[vm.selectedComponentPie], 'component');
                        }

                    });
                };
                /* Component Detail : End */

                /* Time interval setting: Start */
                vm.fnChangeChartType = function (charType) {
                    if (vm.selectedChartType.tabIndex !== charType.tabIndex) {
                        vm.selectedChartType = charType;
                    }
                };

                vm.fnChangeFilterOption = function (filterOption) {
                    if ((vm.filterOptions.length - 1) === filterOption.tabIndex) {
                        vm.fnOpenDateTimeHelpModal();
                    }
                    if (vm.selectedFilterOption.tabIndex !== filterOption.tabIndex) {
                        vm.selectedFilterOption = filterOption;

                        if ((vm.filterOptions.length - 1) !== filterOption.tabIndex) {
                            vm.selectedFilterObj = filterOption;
                            startTime = _.cloneDeepWith(parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x')));
                            endTime = Date.now();
                            vm.healthData = [];
                            vm.fnGetAnalyticsQueryData();
                        }
                    }
                };

                vm.fnOpenDateTimeHelpModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html',
                        size: 'lg',
                        controller: 'analyticsDateTimeHelpModalCtrl as analyticsDateTimeModal',
                        resolve: {
                            selectedTime: function () {
                                return vm.selectedFilterObj;
                            },
                            selectedAggregateFn: function () {
                                return vm.selectedAggregateFn;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.selectedFilterObj = response.selectedTime;
                        vm.selectedAggregateFn = response.selectedAggregateFn;
                        vm.healthData = [];
                        if (vm.selectedFilterObj.type === "absolute") {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        } else {
                            startTime = _.cloneDeepWith(parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x')));
                            endTime = Date.now();
                        }
                        vm.fnGetAnalyticsQueryData();
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 1000)
                    }, function () {
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 1000)
                    });
                };
                /* Time interval setting: End */

                /* Gateway Details: Start */
                vm.fnGetGatewayDetails = function () {
                    GatewayFactory.getGateway({gatewayId: vm.parent.deviceObj.gatewayId})
                        .then(function (res) {
                            vm.deviceGateway = res;
                            vm.isGatewayEmpty = false;
                            vm.isGatewayDetailsLoading = false;
                        }, function () {
                            vm.deviceGateway = {};
                            vm.isGatewayEmpty = true;
                            vm.isGatewayDetailsLoading = false;
                        });
                };

                vm.fnGoToGateway = function () {
                    $state.go('main.gateway', {selectedId: vm.deviceGateway.id, selectedDetailsTab: 1})
                };
                /* Gateway Details: Start */

                /* Health & Connection Icon service: Start */
                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetHealthColor = function (health, obj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    obj.healthName = healthObj.content;
                    return healthObj;
                };
                /* Health & Connection Icon service: End */

                /* Open Native Interface: Start*/
                vm.fnOpenNativeInterface = function () {
                    $scope.$emit('OpenNativeInterface', true);
                };
                /* Open Native Interface: End*/

                /* Chart Resize event: Start*/
                $scope.$on('redrawChart', function (evt, data) {
                    vm.infoSectionClass = data;
                });
                /* Chart Resize event: End*/

                vm.fnOpenGatewayConnectionModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/gatewayConnectionModal/gatewayConnectionModal.html',
                        size: 'lg',
                        controller: 'gatewayConnectionModalCtrl as gatewayConnectionModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            deviceGatewayObj: function () {
                                return vm.deviceGateway;
                            },
                            selectedFilterObj: function () {
                                return _.cloneDeepWith(vm.selectedFilterObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                        })
                    }, function () {

                    });
                };

                vm.fnInitDeviceOverview = function () {
                    startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                    endTime = Date.now();
                    if ($stateParams.isConnectNativeInterface && ($stateParams.isConnectNativeInterface === 'true' ||
                        $stateParams.isConnectNativeInterface === true)) {
                        $timeout(function () {
                            $state.go('main.device', {isConnectNativeInterface: ''}, {notify: false});
                            delete $stateParams.isConnectNativeInterface;
                            vm.fnOpenNativeInterface();
                        })
                    }
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if (vm.gatewayPermissionObj.List) {
                        vm.isGatewayDetailsLoading = true;
                        vm.fnGetGatewayDetails();
                    } else {
                        vm.isGatewayDetailsLoading = false;
                        vm.isGatewayEmpty = true;
                    }
                    if (vm.parent.deviceObj.hasComponents) {
                        var inputObj = {
                            perPage: 0,
                            deviceId: vm.parent.deviceObj.id
                        };
                        vm.fnGetDeviceComponent(inputObj);
                    } else {
                        vm.componentsArr = [];
                        vm.fnGetAnalyticsQueryData();
                    }
                    TabHeight.fnSet();
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceObserverCtrl',
            function ($scope, $window, $timeout, $uibModal, $state, TabHeight, swal, ColorService, AppInitService, IconService,
                      ObserverFactory, TypeFactory, ComponentFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.observersArr = [];
                vm.deviceComponentsArr = [];
                vm.resetDeviceComponentsArr = [];
                vm.typesArr = [];
                vm.componentTypesArr = [];
                vm.isDeviceInventoryDetailsLoaded = false;
                vm.isDeviceComponentSearching = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element(".observerSearchBar")[0])) {
                        var total = angular.element(".content-main")[0].offsetHeight;
                        var search = angular.element(".observerSearchBar")[0].offsetHeight;
                        var finalHeightList = total - (search + 43);
                        angular.element(".componentAccordion").css('height', finalHeightList + 'px');
                    }
                };

                vm.fnGetObserveStateIcon = function (state) {
                    return state === 'INACTIVE' ? IconService.fnGetStateIcon(state) + ' InactiveStateIcon' : IconService.fnGetStateIcon(state);
                };

                vm.getObserverStateColor = function (state) {
                    return ColorService.getStateColor(state);
                };

                vm.fnGoToObserver = function (observer) {
                    $state.go('main.observer', {selectedId: observer.id})
                };

                vm.fnCreateObserverForComponent = function (e, component) {
                    e.stopPropagation();
                    e.preventDefault();
                    swal({
                            title: "Create Observer",
                            text: "Do you want to create a new one observer/add condition to an existing OR create from blueprint?",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Create new or add to an existing observer",
                            cancelButtonText: "Create from blueprint",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            swal.close();
                            if (isConfirm) {
                                var modalInstance = $uibModal.open({
                                    backdrop: 'static',
                                    templateUrl: 'app/node/device/modal/observerConditionModal/observerConditionModal.html',
                                    size: 'lg',
                                    controller: 'observerConditionModalCtrl as observerConditionModal',
                                    windowClass: 'modal-height100',
                                    resolve: {
                                        selectedComponent: function () {
                                            return component;
                                        },
                                        componentGhostObj: function () {
                                            return {};
                                        },
                                        typeObj: function () {
                                            return component.typeObj;
                                        }
                                    }
                                });
                                modalInstance.result.then(function () {
                                }, function () {
                                });
                            } else {
                                swal.close();
                                $state.go('main.observer', {openBlueprintView: true})
                            }
                        });
                };

                vm.fnDeviceComponentFilter = function () {
                    $timeout.cancel(vm.repeatativeTimer);
                    vm.repeatativeTimer = $timeout(function () {
                        vm.isDeviceComponentSearching = true;
                        vm.deviceComponentsArr = [];
                        if (angular.isDefined(vm.search)) {
                            vm.deviceComponentsArr = _.filter(vm.resetDeviceComponentsArr, function (inventoriesObj) {
                                var tempIndex = '';
                                if (angular.isDefined(inventoriesObj.name) && inventoriesObj.name !== ' ') {
                                    if (inventoriesObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                        return inventoriesObj;
                                    }
                                } else {
                                    tempIndex = inventoriesObj.index;
                                    if (tempIndex.toLowerCase().includes(vm.search.toLowerCase())) {
                                        return inventoriesObj;
                                    }
                                }
                            });

                            if (!vm.deviceComponentsArr.length) {
                                vm.deviceComponentsArr = _.filter(vm.resetDeviceComponentsArr, function (inventoriesObj) {
                                    return inventoriesObj.id.includes(vm.search);
                                })
                            }
                        } else {
                            vm.deviceComponentsArr = angular.copy(vm.resetDeviceComponentsArr);
                        }
                        vm.isDeviceComponentSearching = false;
                    }, 500);
                };

                vm.fnGetDeviceInventories = function (inputObj) {
                    vm.isDeviceInventoryDetailsLoaded = false;
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            var deviceComponentsObj = {};
                            var topicObj = {};
                            _.forEach(vm.parent.typesArr, function (d) {
                                topicObj[d.id] = d
                            });
                            _.forEach(response, function (resObj) {
                                resObj.isExpanded = true;
                                var tempObj = deviceComponentsObj[resObj.index];
                                if (tempObj && tempObj.data) {
                                    resObj.supplementalData = tempObj.data;
                                }
                                if (resObj.enabled === true) {
                                    var healthObj = ColorService.getHealthColorForLoop(resObj.health);
                                    resObj.healthName = healthObj.content;
                                    if (resObj.healthName === resObj.health) {
                                        resObj.toolTipName = resObj.health;
                                    } else {
                                        resObj.toolTipName = resObj.healthName + " " + resObj.health;
                                    }
                                    resObj.healthColor = healthObj['background-color'];
                                    resObj.textColor = healthObj.color;
                                }
                                resObj.typeObj = topicObj[resObj.typeId];
                                var componentObserverArr = [];
                                _.forEach(vm.observersArr, function (observerObj) {
                                    if ((observerObj.topicOem === '*' || observerObj.topicOem === resObj.typeObj.oem) &&
                                        (observerObj.topicModel === '*' || observerObj.topicModel === resObj.typeObj.model) &&
                                        (observerObj.topicVersion === '*' || observerObj.topicVersion === resObj.typeObj.version) &&
                                        (observerObj.topicName === '*' || observerObj.topicName === resObj.typeObj.name) &&
                                        (observerObj.topicId === '*' || observerObj.topicId === resObj.id)) {
                                        componentObserverArr.push(observerObj);
                                    }
                                });
                                resObj.componentObserverArr = componentObserverArr;
                            });
                            vm.deviceComponentsArr = response;
                            vm.resetDeviceComponentsArr = _.cloneDeep(response);
                            vm.isDeviceInventoryDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            })
                        }, function () {
                            vm.deviceComponentsArr = [];
                            vm.resetDeviceComponentsArr = [];
                            vm.isDeviceInventoryDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            })
                        });
                };

                vm.fnGetObservers = function () {
                    var inputObj = {
                        perPage: 0,
                        deviceId: vm.parent.deviceObj.id
                    };
                    ObserverFactory.getObservers({perPage: 0})
                        .then(function (res) { // Success block
                            vm.observersArr = res;
                            vm.isObserversLoading = false;
                            vm.fnGetDeviceInventories(inputObj);
                        }, function () { // Error block
                            vm.observersArr = [];
                            vm.isObserversLoading = false;
                            vm.fnGetDeviceInventories(inputObj);
                        })
                };

                vm.fnInitDeviceObserver = function () {
                    vm.fnGetObservers();
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                    TabHeight.fnSet();
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceLocationCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, Paho, ColorService, PermissionsService,
                      GhostService, DB, moment, amaran, swal, TabHeight, SchemaService, TypeFactory, VisualizerFactory,
                      WebSocketFactory, DeviceFactory, L) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isDeviceLocationDetailsLoaded = false;
                vm.isSaveLoaderActive = false;
                vm.latitude = '';
                vm.longitude = '';
                vm.actualLatitude = '';
                vm.actualLongitude = '';
                var map = "";
                var marker = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element("#locationInputBlock")[0]) && angular.isDefined(angular.element("#map1")[0])) {
                        var contentMain = angular.element(".content-main")[0].offsetHeight;
                        var inputContainer = angular.element("#locationInputBlock")[0].offsetHeight;
                        var locationSaveActionBlock = 0;
                        if (angular.element("#locationSaveActionBlock")[0]) {
                            locationSaveActionBlock = angular.element("#locationSaveActionBlock")[0].offsetHeight;
                        }
                        var fianlMapHeight = contentMain - (inputContainer + locationSaveActionBlock + 40);
                        angular.element("#map1").css('height', fianlMapHeight + 'px');
                    }
                };

                vm.fnGetDeviceLocation = function (deviceObj) {
                    var inputObj = {
                        deviceId: deviceObj.id
                    };
                    DeviceFactory.getDevice(inputObj)
                        .then(function (response) {
                            vm.deviceObj = response;
                            if (vm.deviceObj.location && vm.deviceObj.location.length) {
                                vm.latitude = parseFloat(vm.deviceObj.location.split(',')[0]);
                                vm.longitude = parseFloat(vm.deviceObj.location.split(',')[1]);
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            $timeout(function () {
                                vm.isDeviceLocationDetailsLoaded = true;
                                $timeout(function () {
                                    document.getElementById('deviceLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                    var mapOptions = {};
                                    mapOptions.center = [vm.latitude, vm.longitude];
                                    mapOptions.zoom = 8;
                                    mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                    map = new L.Map('map1', mapOptions);
                                    marker = L.marker([vm.latitude, vm.longitude], {
                                        draggable: true
                                    }).addTo(map);
                                    $timeout(function () {
                                        vm.fnSetTabHeight();
                                    });
                                    marker.on('drag', function () {
                                        $timeout(function () {
                                            vm.actualLatitude = marker.getLatLng().lat;
                                            vm.actualLongitude = marker.getLatLng().lng;
                                        })
                                    });
                                    $timeout(function () {
                                        map.invalidateSize()
                                    });
                                }, 100)
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $timeout(function () {
                                vm.isDeviceLocationDetailsLoaded = true;
                            })
                        })
                };

                vm.fnSaveLocationInfo = function () {
                    vm.isSaveLoaderActive = true;
                    var inputObj = {
                        body: {},
                        deviceId: vm.deviceObj.id
                    };

                    inputObj.body = {
                        location: vm.actualLatitude + "," + vm.actualLongitude
                    };
                    DeviceFactory.modifyDevice(inputObj)
                        .then(function (response) {
                            vm.deviceObj = response;
                            if (vm.deviceObj.location && vm.deviceObj.location.length) {
                                vm.latitude = parseFloat(vm.deviceObj.location.split(',')[0]);
                                vm.longitude = parseFloat(vm.deviceObj.location.split(',')[1]);
                                vm.actualLatitude = vm.latitude;
                                vm.actualLongitude = vm.longitude;
                            } else {
                                vm.latitude = 39.721712;
                                vm.longitude = -104.941406;
                            }
                            vm.isSaveLoaderActive = false;
                            $timeout(function () {
                                document.getElementById('deviceLocationMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                                var mapOptions = {};
                                mapOptions.center = [vm.latitude, vm.longitude];
                                mapOptions.zoom = 8;
                                mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                                map = new L.Map('map1', mapOptions);
                                marker = L.marker([vm.latitude, vm.longitude], {
                                    draggable: true
                                }).addTo(map);
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                });
                                marker.on('drag', function () {
                                    $timeout(function () {
                                        vm.actualLatitude = marker.getLatLng().lat;
                                        vm.actualLongitude = marker.getLatLng().lng;
                                    })
                                });
                                $timeout(function () {
                                    map.invalidateSize()
                                });
                            }, 100);
                            amaran.success("Location Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSaveLoaderActive = false;
                        });
                };

                vm.fnChangeLocation = function () {
                    if (vm.actualLatitude.length && vm.actualLongitude.length) {
                        var newLatLng = new L.LatLng(vm.actualLatitude, vm.actualLongitude);
                        marker.setLatLng(newLatLng);
                        map.setView(marker.getLatLng(), map.getZoom());
                    }
                };

                vm.fnInitDeviceLocation = function () {
                    vm.devicePermissionsObj = PermissionsService.getPermissions("node:device");
                    TabHeight.fnSet();
                    vm.isDeviceLocationDetailsLoaded = false;
                    if (vm.parent.deviceObj.id) {
                        vm.fnGetDeviceLocation(vm.parent.deviceObj);
                    }
                };


            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceInventoryCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, $uibModal, IconService, ColorService,
                      PermissionsService, DB, moment, amaran, swal, microSpinner, Paho, TabHeight, componentService,
                      WebSocketFactory, GatewayFactory, UserFactory, TypeFactory, ComponentFactory, FedSudoUserService,
                      postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, XLSX) {

                var loginUser = DB.fnGet('loginUser');
                var inventoryTimer, client, gatewayClient;
                var vm = this;
                vm.parent = $scope.$parent;
                vm.inventoriesArr = [];
                vm.bubbleChartArr = [];
                vm.selectedInventoryObj = null;
                vm.selectedInventorysArr = [];
                //vm.deviceComponentsArr = [];
                vm.search = '';
                vm.expandedNodes = [];
                vm.gatewayObj = null;
                vm.componentActive = 0;
                vm.isDisableComponentSuccess = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTreeHeight();
                });
                var collator = new Intl.Collator(undefined, {
                    numeric: true,
                    sensitivity: 'base'
                });
                vm.deviceHealthObj = ColorService.getHealthColorForLoop(vm.parent.deviceObj.health);
                vm.fnSetTreeHeight = function () {
                    if (vm.isFileViewSelected && angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("#SearchCol")[0])) {
                        var total, search, finalHeight;
                        if (angular.isUndefined(angular.element("treecontrol ul li treeitem")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            search = angular.element("#SearchCol")[0].offsetHeight;
                            finalHeight = total - (search + 37);
                            angular.element("treecontrol ul").css('min-height', finalHeight + 'px');
                            angular.element("#deviceInventoryFileViewContent").css('height', (finalHeight - 34) + 'px');
                        } else {
                            total = angular.element(".content-main")[0].offsetHeight;
                            search = angular.element("#SearchCol")[0].offsetHeight;
                            finalHeight = total - (search + 37);
                            angular.element("treecontrol ul li treeitem ul:last").css('min-height', finalHeight + 'px');
                        }
                    } else if (vm.isTableViewSelected && angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("#SearchCol")[0]) && angular.isDefined(angular.element("thead")[0])) {
                        var totalList = angular.element(".content-main")[0].offsetHeight;
                        var searchList = angular.element("#SearchCol")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightList = totalList - (searchList + header + 57);
                        angular.element("#deviceInventoryTableView tbody").css('height', finalHeightList + 'px');
                    } else if (vm.isSunburstViewSelected && angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("#SearchCol")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        search = angular.element("#SearchCol")[0].offsetHeight;
                        finalHeight = total - (search + 37);
                        angular.element("#deviceInventorySunburstViewContent").css('height', (finalHeight - 16) + 'px');
                    } else if (vm.isTreeViewSelected && angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("#SearchCol")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        search = angular.element("#SearchCol")[0].offsetHeight;
                        finalHeight = total - (search + 37);
                        angular.element("#deviceInventoryTreeViewContent").css('height', (finalHeight - 20) + 'px');
                    } else if (vm.isBubbleChartSelected && angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("#SearchCol")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        search = angular.element("#SearchCol")[0].offsetHeight;
                        finalHeight = total - (search + 37);
                        angular.element("#deviceInventoryBubbleViewContent").css('height', (finalHeight - 20) + 'px');
                    }
                };

                vm.fnGetComponentContextMenuOption = function (inventoryObj, option) {
                    switch (option) {
                        case'Open':
                            vm.fnGetComponentDetails(inventoryObj);
                            break;

                        case'Edit Supplemental':
                            vm.fnGetComponentDetails(inventoryObj, true);
                            break;

                        case'Rename':
                            vm.fnOpenComponentRenameModal(inventoryObj);
                            break;
                    }
                }

                /*START: Context Menu*/
                vm.fnGetComponentContextMenu = function (inventoryObj) {
                    return [{
                        text: 'Open',
                        click: function () {
                            vm.fnGetComponentDetails(inventoryObj)
                        },
                        displayed: inventoryObj.enabled === true
                    }, {
                        text: 'Edit Supplemental Data',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnGetComponentDetails(inventoryObj, true);
                        },
                        displayed: inventoryObj.enabled === true
                    }, {
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnOpenComponentRenameModal(inventoryObj);
                        },
                        displayed: inventoryObj.enabled === true
                    }]
                };

                vm.fnOpenComponentRenameModal = function (componentObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/componentRenameModal/componentRenameModal.html',
                        size: 'md',
                        controller: 'componentRenameModalCtrl as compRename',
                        resolve: {
                            componentObj: function () {
                                return componentObj;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        angular.forEach(vm.inventoriesArr, function (inventory) {
                            if (inventory.id === response.id) {
                                if (vm.selectedInventoryObj) {
                                    vm.selectedInventoryObj.name = response.name;
                                }
                                if (vm.selectedNodeObj) {
                                    vm.selectedNodeObj.name = response.name;
                                }
                                inventory.name = response.name;
                            }
                        });
                        vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                        var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                        vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                        vm.nestedInventoriesArr.sort(function (a, b) {
                            return  collator.compare(a.index, b.index)
                        });
                        vm.nestedInventoriesArr.forEach(function iter(a) {
                            if (a.children && a.children.length) {
                                a.children.sort(function (a, b) {
                                    return collator.compare(a.index, b.index)
                                });
                            }
                            return angular.isArray(a.children) && a.children.forEach(iter);
                        });
                        var tempObj = {
                            index: 'deviceRoot',
                            children: vm.nestedInventoriesArr,
                            health: 100,
                            isExpanded: true
                        };
                        vm.sunburstInventoriesObj = angular.copy(tempObj);
                        if (vm.inventoriesArr.length) {
                            vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                        } else {
                            vm.nestedFileInventoriesObj = {};
                        }

                        if (vm.isTreeViewSelected) {
                            $timeout(function () {
                                $scope.conCallBack(); //eslint-disable-line
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        });
                    }, function () {

                    });
                };

                vm.fnOpenSupplementalDataModal = function (componentObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/componentSupplementalDataModal/componentSupplementalData.html',
                        size: 'lg',
                        controller: 'supplementalDataModalCtrl as supplementalDataModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            componentObj: function () {
                                return componentObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                        })
                    }, function () {

                    });
                };
                /*END: Context Menu*/

                /*Table View: START*/
                vm.isTableViewSelected = false;
                vm.fnShowTableView = function () {
                    vm.fnSetSelectedTab('isTableViewSelected');
                    vm.isTableViewSelected = true;
                    vm.isBubbleChartSelected = false;
                    vm.isFileViewSelected = false;
                    vm.isSunburstViewSelected = false;
                    vm.isTreeViewSelected = false;
                    vm.selectedNodeObj = null;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.fnGetInventory = function (inventoryObj) {
                    vm.selectedInventorysArr = [];
                    angular.forEach(vm.inventoriesArr, function (obj) {
                        obj.isCheck = false;
                    });
                    inventoryObj.isCheck = true;
                    vm.selectedInventoryObj = inventoryObj;
                    vm.selectedInventorysArr.push(inventoryObj);
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.inventoriesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    vm.selectedInventoryObj = null;
                    if (vm.isAllChecked) {
                        vm.selectedInventorysArr = angular.copy(vm.inventoriesArr);
                    } else {
                        vm.selectedInventorysArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function (inventoryObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.inventoriesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                    var isValueFind = _.find(vm.selectedInventorysArr, {'id': inventoryObj.id});
                    if (!isValueFind) {
                        vm.selectedInventorysArr.push(inventoryObj)
                    } else {
                        _.remove(vm.selectedInventorysArr, function (obj) {
                            return inventoryObj.id === obj.id;
                        });
                    }
                    if (vm.selectedInventorysArr.length === 1) {
                        vm.selectedInventoryObj = vm.selectedInventorysArr[0];
                    } else {
                        vm.selectedInventoryObj = null;
                    }
                };
                /*Table View: END*/

                /*File View: START*/
                vm.isFileViewSelected = false;
                vm.fnShowFileView = function () {
                    vm.fnSetSelectedTab('isFileViewSelected');
                    vm.isFileViewSelected = true;
                    vm.isBubbleChartSelected = false;
                    vm.isTableViewSelected = false;
                    vm.isTreeViewSelected = false;
                    vm.isSunburstViewSelected = false;
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.treeOptions = {
                    nodeChildren: "children"
                };
                vm.fnNodeSelected = function (node) {
                    var obj = {};
                    angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                        if (inventoryObj.index === node.index) {
                            obj = inventoryObj
                        }
                    });
                    if (Object.keys(obj).length) {
                        vm.selectedNodeObj = angular.copy(obj);
                    } else {
                        vm.selectedNodeObj = angular.copy(node);
                    }
                };
                /*File View: END*/

                /*Sunburst View: START*/
                vm.isSunburstViewSelected = false;
                vm.fnShowSunburstView = function () {
                    vm.fnSetSelectedTab('isSunburstViewSelected');
                    vm.isSunburstViewSelected = true;
                    vm.isBubbleChartSelected = false;
                    vm.isTableViewSelected = false;
                    vm.isFileViewSelected = false;
                    vm.isTreeViewSelected = false;
                    vm.selectedNodeObj = null;
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };
                /*Sunburst View: END*/

                /*Tree View: START*/
                vm.isTreeViewSelected = false;
                vm.fnShowTreeView = function () {
                    vm.fnSetSelectedTab('isTreeViewSelected');
                    vm.isTreeViewSelected = true;
                    vm.isBubbleChartSelected = false;
                    vm.isSunburstViewSelected = false;
                    vm.isTableViewSelected = false;
                    vm.isFileViewSelected = false;
                    vm.selectedNodeObj = null;
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };
                /*Tree View: END*/

                /*Bubble View: END*/
                vm.isBubbleChartSelected = false;
                vm.fnShowBubbleView = function () {
                    vm.fnSetSelectedTab('isBubbleChartSelected');
                    vm.isBubbleChartSelected = true;
                    vm.isTreeViewSelected = false;
                    vm.isSunburstViewSelected = false;
                    vm.isTableViewSelected = false;
                    vm.isFileViewSelected = false;
                    vm.selectedNodeObj = null;
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };
                /*Bubble View: END*/

                vm.fnGetComponentDetails = function (inventoryObj, isCalledForModal) {
                    vm.isFileViewUpdating = true;
                    var inputObj = {
                        deviceId: vm.parent.deviceObj.id,
                        componentId: inventoryObj.id
                    };
                    ComponentFactory.getComponent(inputObj)
                        .then(function (response) {
                            vm.isFileViewUpdating = false;
                            if (isCalledForModal) {
                                $scope.$emit("SetSelectedComponent", response);
                                vm.fnOpenSupplementalDataModal(response);
                            } else {
                                $timeout(function () {
                                    $state.go('main.device', {selectedComponentId: response.id}, {notify: false});
                                    $stateParams.selectedComponentId = response.id;
                                });
                                $scope.$emit("setGatewayObjForComponent", vm.gatewayObj);
                                $scope.$emit("ComponentSelected", response);
                                $scope.$emit("getInventorySelected", vm.resetInventoriesArr);
                            }
                        })
                };

                vm.fnDownloadXls = function () {
                    var gatewayGhostArrCp = _.cloneDeepWith(vm.inventoriesArr);
                    gatewayGhostArrCp.sort(function (a, b) {
                        return  collator.compare(a.index, b.index)
                    });
                    var tempData = _.map(gatewayGhostArrCp, function (tempObj) {
                        delete tempObj.isExpanded;
                        delete tempObj.healthName;
                        delete tempObj.toolTipName;
                        delete tempObj.healthColor;
                        delete tempObj.textColor;
                        delete tempObj.typeObj;
                        delete tempObj.children;
                        delete tempObj.parentIndex;
                        delete tempObj.defaultHealth;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "deviceInventory");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "deviceInventory_" + $stateParams.selectedId + ".xlsx");
                };
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchorGhost')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchorGhost').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.inventoriesArr);
                    tempData.sort(function (a, b) {
                        return  collator.compare(a.index, b.index)
                    });
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    Object.keys(data[1]).map(function (key) {
                        vm.csvHeaderArr = Object.keys(tempData[key]);
                        if (vm.csvHeaderArr.indexOf('isExpanded') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('isExpanded'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('healthName') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('healthName'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('toolTipName') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('toolTipName'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('healthColor') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('healthColor'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('textColor') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('textColor'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('typeObj') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('typeObj'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('children') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('children'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('parentIndex') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('parentIndex'), 1);
                        }
                        if (vm.csvHeaderArr.indexOf('defaultHealth') !== -1) {
                            vm.csvHeaderArr.splice(vm.csvHeaderArr.indexOf('defaultHealth'), 1);
                        }
                        return vm.csvHeaderArr;
                    });
                    return _.map(data[1], function (deviceObj) {
                        var tempObj = {};
                        _.forEach(vm.csvHeaderArr, function (headerText) {
                            tempObj[headerText] = deviceObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnGetComponentGhostDetails = function (inventoryObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/viewGhostAttributes.html',
                        size: 'lg',
                        controller: 'viewGhostAttributesCtrl as viewGhostAttributes',
                        windowClass: 'modal-height100',
                        resolve: {
                            inventoryObj: function () {
                                return inventoryObj;
                            },
                            parentInventories: function () {
                                return vm.inventoriesArr;
                            },
                            deviceObj: function () {
                                return vm.parent.deviceObj;
                            },
                            gatewayObj: function () {
                                return vm.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnEnableDisableComponent = function (selectedInventoryObj, isCalledFromTree) {
                    if (selectedInventoryObj.enabled && selectedInventoryObj.enabled === true) {
                        selectedInventoryObj.enabled = false;
                    } else {
                        selectedInventoryObj.enabled = true;
                    }
                    vm.isFileViewUpdating = true;
                    var inputObj = {};
                    if (selectedInventoryObj.enabled === true) {
                        inputObj = {
                            deviceId: vm.parent.deviceObj.id,
                            body: [selectedInventoryObj.id]
                        };
                        ComponentFactory.enableComponent(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                                        if (inventoryObj.id === selectedInventoryObj.id) {
                                            selectedInventoryObj.enabled = true;
                                            inventoryObj.enabled = true;
                                            var healthObj = ColorService.getHealthColorForLoop(selectedInventoryObj.health);
                                            selectedInventoryObj.healthName = healthObj.content;
                                            inventoryObj.healthName = healthObj.content;
                                            if (selectedInventoryObj.healthName === selectedInventoryObj.health) {
                                                selectedInventoryObj.toolTipName = selectedInventoryObj.health;
                                                inventoryObj.toolTipName = inventoryObj.health;
                                            } else {
                                                selectedInventoryObj.toolTipName = selectedInventoryObj.healthName + " " + selectedInventoryObj.health;
                                                inventoryObj.toolTipName = inventoryObj.healthName + " " + inventoryObj.health;
                                            }
                                            selectedInventoryObj.healthColor = healthObj['background-color'];
                                            inventoryObj.healthColor = healthObj['background-color'];
                                            selectedInventoryObj.textColor = healthObj.color;
                                            inventoryObj.textColor = healthObj.color;
                                        }
                                    });
                                    vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                                    var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                    vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                    vm.nestedInventoriesArr.sort(function (a, b) {
                                        return  collator.compare(a.index, b.index)
                                    });
                                    vm.nestedInventoriesArr.forEach(function iter(a) {
                                        if (a.children && a.children.length) {
                                            a.children.sort(function (a, b) {
                                                return collator.compare(a.index, b.index)
                                            });
                                        }
                                        return angular.isArray(a.children) && a.children.forEach(iter);
                                    });
                                    var tempObj = {
                                        index: 'deviceRoot',
                                        children: vm.nestedInventoriesArr,
                                        health: 100,
                                        isExpanded: true
                                    };
                                    vm.sunburstInventoriesObj = angular.copy(tempObj);
                                    if (isCalledFromTree) {
                                        if (vm.inventoriesArr.length) {
                                            vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                        } else {
                                            vm.nestedFileInventoriesObj = {};
                                        }
                                    }
                                    vm.fnGetComponentsActiveInactiveCount();
                                    vm.isFileViewUpdating = false;
                                    amaran.success("The Component enable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    selectedInventoryObj.enabled = !selectedInventoryObj.enabled;
                                    vm.isFileViewUpdating = false;
                                    amaran.error("Component Enabled was unsuccessful")
                                }
                            })
                    } else {
                        swal({
                                title: "Disable this Component?",
                                text: "Disabling this component will prevent it from being monitored.",
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "disable",
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    inputObj = {
                                        deviceId: vm.parent.deviceObj.id,
                                        componentId: selectedInventoryObj.id
                                    };
                                    selectedInventoryObj.isCountdownIconShow = true;
                                    ComponentFactory.disableComponent(inputObj)
                                        .then(function (response) {
                                            if (!response.errors) {
                                                angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                                                    if (inventoryObj.id === selectedInventoryObj.id) {
                                                        selectedInventoryObj.enabled = false;
                                                        inventoryObj.enabled = false;
                                                    }
                                                });
                                                vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                                                var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                                vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                                vm.nestedInventoriesArr.sort(function (a, b) {
                                                    return  collator.compare(a.index, b.index)
                                                });
                                                vm.nestedInventoriesArr.forEach(function iter(a) {
                                                    if (a.children && a.children.length) {
                                                        a.children.sort(function (a, b) {
                                                            return collator.compare(a.index, b.index)
                                                        });
                                                    }
                                                    return angular.isArray(a.children) && a.children.forEach(iter);
                                                });
                                                var tempObj = {
                                                    index: 'deviceRoot',
                                                    children: vm.nestedInventoriesArr,
                                                    health: 100,
                                                    isExpanded: true
                                                };
                                                vm.sunburstInventoriesObj = angular.copy(tempObj);
                                                if (isCalledFromTree) {
                                                    if (vm.inventoriesArr.length) {
                                                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                                    } else {
                                                        vm.nestedFileInventoriesObj = {};
                                                    }
                                                }
                                                swal({
                                                    title: postActionModelMessage,
                                                    html: true,
                                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'customSwalActionModel'
                                                });
                                                angular.element(".microSpinner").remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                vm.isFileViewUpdating = false;
                                                vm.isDisableComponentSuccess = true;
                                                $timeout(function (selectedInventoryObj) {
                                                    return selectedInventoryObj;
                                                }, 30000, true, selectedInventoryObj)
                                                    .then(function (refObj) {
                                                        refObj.isCountdownIconShow = false;
                                                        vm.isDisableComponentSuccess = false;
                                                    });
                                                vm.fnGetComponentsActiveInactiveCount();
                                                amaran.success("The Component disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                                $timeout(function () {
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    swal.close();
                                                }, 1000)
                                            } else {
                                                angular.element('.microSpinner').remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                swal.close();
                                                selectedInventoryObj.enabled = !selectedInventoryObj.enabled;
                                                vm.isFileViewUpdating = false;
                                                amaran.error("Component Disabled was unsuccessful")
                                            }
                                        })
                                } else {
                                    selectedInventoryObj.enabled = !selectedInventoryObj.enabled;
                                    vm.isFileViewUpdating = false;
                                    $scope.$apply();
                                    swal("Cancelled", "Disable Process Cancelled", "error");
                                }
                            });
                    }
                };

                vm.fnEnableAllComponent = function (selectedInventoryArr) {
                    vm.enableInventoryArr = _.filter(selectedInventoryArr, {'enabled': false});
                    var count = 1;
                    vm.isFileViewUpdating = true;
                    var inputObj = {};
                    angular.forEach(vm.enableInventoryArr, function (selectedInventoryObj) {
                        inputObj = {
                            deviceId: vm.parent.deviceObj.id,
                            body: [selectedInventoryObj.id]
                        };
                        ComponentFactory.enableComponent(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                                        if (inventoryObj.id === selectedInventoryObj.id) {
                                            selectedInventoryObj.enabled = true;
                                            inventoryObj.enabled = true;
                                            var healthObj = ColorService.getHealthColorForLoop(selectedInventoryObj.health);
                                            selectedInventoryObj.healthName = healthObj.content;
                                            inventoryObj.healthName = healthObj.content;
                                            if (selectedInventoryObj.healthName === selectedInventoryObj.health) {
                                                selectedInventoryObj.toolTipName = selectedInventoryObj.health;
                                                inventoryObj.toolTipName = inventoryObj.health;
                                            } else {
                                                selectedInventoryObj.toolTipName = selectedInventoryObj.healthName + " " + selectedInventoryObj.health;
                                                inventoryObj.toolTipName = inventoryObj.healthName + " " + inventoryObj.health;
                                            }
                                            selectedInventoryObj.healthColor = healthObj['background-color'];
                                            inventoryObj.healthColor = healthObj['background-color'];
                                            selectedInventoryObj.textColor = healthObj.color;
                                            inventoryObj.textColor = healthObj.color;
                                        }
                                    });
                                    if (count === vm.enableInventoryArr.length) {
                                        vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                                        var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                        vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                        vm.nestedInventoriesArr.sort(function (a, b) {
                                            return  collator.compare(a.index, b.index)
                                        });
                                        vm.nestedInventoriesArr.forEach(function iter(a) {
                                            if (a.children && a.children.length) {
                                                a.children.sort(function (a, b) {
                                                    return collator.compare(a.index, b.index)
                                                });
                                            }
                                            return angular.isArray(a.children) && a.children.forEach(iter);
                                        });
                                        var tempObj = {
                                            index: 'deviceRoot',
                                            children: vm.nestedInventoriesArr,
                                            health: 100,
                                            isExpanded: true
                                        };
                                        vm.sunburstInventoriesObj = angular.copy(tempObj);
                                        if (vm.inventoriesArr.length) {
                                            vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                        } else {
                                            vm.nestedFileInventoriesObj = {};
                                        }
                                        vm.fnGetComponentsActiveInactiveCount();
                                        vm.isFileViewUpdating = false;
                                        amaran.success("The Component enable request is being processed. The current progress can be viewed in the Lifecycles.");
                                    } else {
                                        count++;
                                    }
                                } else {
                                    vm.isFileViewUpdating = false;
                                    amaran.error("Component Enabled was unsuccessful")
                                }
                            });
                    });

                };

                vm.fnDisableAllComponent = function (selectedInventoryArr) {
                    vm.disableComponentArr = _.filter(selectedInventoryArr, {'enabled': true});
                    var count = 1;
                    vm.isFileViewUpdating = true;
                    vm.isDisableComponentSuccess = true;
                    vm.componentCount = 1;
                    var inputObj = {};
                    swal({
                            title: "Disable all Components?",
                            text: "Disabling all components will prevent them from being monitored.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(vm.disableComponentArr, function (selectedInventoryObj) {
                                    inputObj = {
                                        deviceId: vm.parent.deviceObj.id,
                                        componentId: selectedInventoryObj.id
                                    };
                                    ComponentFactory.disableComponent(inputObj)
                                        .then(function (response) {
                                            if (!response.errors) {
                                                angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                                                    if (inventoryObj.id === selectedInventoryObj.id) {
                                                        selectedInventoryObj.enabled = false;
                                                        inventoryObj.enabled = false;
                                                        selectedInventoryObj.isCountdownIconShow = true;
                                                        inventoryObj.isCountdownIconShow = true;
                                                        $timeout(function (selectedInventoryObj) {
                                                            return selectedInventoryObj;
                                                        }, 30000, true, selectedInventoryObj)
                                                            .then(function (refObj) {
                                                                var inventoriesData = _.find(vm.inventoriesArr, {id: refObj.id});
                                                                if (inventoriesData) {
                                                                    inventoriesData.isCountdownIconShow = false;
                                                                }
                                                                refObj.isCountdownIconShow = false;
                                                                if (vm.componentCount === vm.disableComponentArr.length) {
                                                                    var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                                                    vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                                                    vm.nestedInventoriesArr.sort(function (a, b) {
                                                                        return  collator.compare(a.index, b.index)
                                                                    });
                                                                    vm.nestedInventoriesArr.forEach(function iter(a) {
                                                                        if (a.children && a.children.length) {
                                                                            a.children.sort(function (a, b) {
                                                                                return collator.compare(a.index, b.index)
                                                                            });
                                                                        }
                                                                        return angular.isArray(a.children) && a.children.forEach(iter);
                                                                    });
                                                                    var tempObj = {
                                                                        index: 'deviceRoot',
                                                                        children: vm.nestedInventoriesArr,
                                                                        health: 100,
                                                                        isExpanded: true
                                                                    };
                                                                    vm.sunburstInventoriesObj = angular.copy(tempObj);
                                                                    if (vm.inventoriesArr.length) {
                                                                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                                                    } else {
                                                                        vm.nestedFileInventoriesObj = {};
                                                                    }
                                                                    $timeout(function () {
                                                                        vm.componentCount = 0;
                                                                        vm.isDisableComponentSuccess = false;
                                                                    });
                                                                } else {
                                                                    vm.componentCount++;
                                                                }
                                                            });
                                                    }
                                                });
                                                if (count === vm.disableComponentArr.length) {
                                                    vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                                                    var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                                    vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                                    vm.nestedInventoriesArr.sort(function (a, b) {
                                                        return  collator.compare(a.index, b.index)
                                                    });
                                                    vm.nestedInventoriesArr.forEach(function iter(a) {
                                                        if (a.children && a.children.length) {
                                                            a.children.sort(function (a, b) {
                                                                return collator.compare(a.index, b.index)
                                                            });
                                                        }
                                                        return angular.isArray(a.children) && a.children.forEach(iter);
                                                    });
                                                    var tempObj = {
                                                        index: 'deviceRoot',
                                                        children: vm.nestedInventoriesArr,
                                                        health: 100,
                                                        isExpanded: true
                                                    };
                                                    vm.sunburstInventoriesObj = angular.copy(tempObj);
                                                    if (vm.inventoriesArr.length) {
                                                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                                    } else {
                                                        vm.nestedFileInventoriesObj = {};
                                                    }
                                                    swal({
                                                        title: postActionModelMessage,
                                                        html: true,
                                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                        showCancelButton: false,
                                                        showConfirmButton: false,
                                                        customClass: 'customSwalActionModel'
                                                    });
                                                    angular.element(".microSpinner").remove();
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    vm.isFileViewUpdating = false;
                                                    vm.fnGetComponentsActiveInactiveCount();
                                                    $timeout(function () {
                                                        angular.element(".confirm").css("visibility", "visible");
                                                        swal.close();
                                                    }, 1000);
                                                    amaran.success("The Component disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                                } else {
                                                    count++;
                                                }
                                            } else {
                                                if (count === vm.disableComponentArr.length) {
                                                    swal({
                                                        title: postActionModelMessage,
                                                        html: true,
                                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                        showCancelButton: false,
                                                        showConfirmButton: false,
                                                        customClass: 'customSwalActionModel'
                                                    });
                                                    angular.element(".microSpinner").remove();
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    vm.isFileViewUpdating = false;
                                                    vm.fnGetComponentsActiveInactiveCount();
                                                    $timeout(function () {
                                                        angular.element(".confirm").css("visibility", "visible");
                                                        swal.close();
                                                    }, 1000);
                                                } else {
                                                    count++;
                                                }
                                            }
                                        })
                                });
                            } else {
                                vm.isFileViewUpdating = false;
                                swal("Cancelled", "Disable Process Cancelled", "error");
                                if (!$scope.$$phase) { //eslint-disable-line
                                    $scope.$apply();
                                }
                            }
                        });
                };

                vm.fnGetDeviceInventories = function (inputObj) {
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            var deviceComponentsObj = {};
                            _.forEach(vm.deviceComponentsArr, function (d) {
                                deviceComponentsObj[d.index] = d
                            });
                            var topicObj = {};
                            _.forEach(vm.parent.typesArr, function (d) {
                                topicObj[d.id] = d
                            });
                            _.forEach(response, function (resObj) {
                                resObj.isExpanded = false;
                                var tempObj = deviceComponentsObj[resObj.index];
                                if (tempObj && tempObj.data) {
                                    resObj.supplementalData = tempObj.data;
                                }
                                if (resObj.enabled === true) {
                                    var healthObj = ColorService.getHealthColorForLoop(resObj.health);
                                    resObj.healthName = healthObj.content;
                                    if (resObj.healthName === resObj.health) {
                                        resObj.toolTipName = resObj.health;
                                    } else {
                                        resObj.toolTipName = resObj.healthName + " " + resObj.health;
                                    }
                                    resObj.healthColor = healthObj['background-color'];
                                    resObj.textColor = healthObj.color;
                                }
                                resObj.typeObj = topicObj[resObj.typeId];
                            });
                            vm.inventoriesArr = response;
                            vm.resetInventoriesArr = _.cloneDeep(response);

                            var chartData = [];
                            var tempDataObj = _.groupBy(vm.inventoriesArr, function (deviceObj) {
                                return deviceObj.health;
                            });
                            _.forEach(tempDataObj, function (val, key) {
                                var tempValArr = [];
                                _.forEach(val, function (valObj) {
                                    tempValArr.push({
                                        name: valObj.name,
                                        value: Math.floor(Math.random() * 100) + 1,
                                        pointId: valObj.id
                                    })
                                });
                                chartData.push({
                                    name: key,
                                    data: tempValArr,
                                    color: ColorService.getHealthColorForLoop(key)['background-color']
                                })
                            });
                            vm.bubbleChartArr = chartData;
                            var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                            vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                            vm.nestedInventoriesArr.sort(function (a, b) {
                                return  collator.compare(a.index, b.index)
                            });
                            vm.nestedInventoriesArr.forEach(function iter(a) {
                                if (a.children && a.children.length) {
                                    a.children.sort(function (a, b) {
                                        return collator.compare(a.index, b.index)
                                    });
                                }
                                return angular.isArray(a.children) && a.children.forEach(iter);
                            });
                            var tempObj = {
                                index: 'deviceRoot',
                                children: vm.nestedInventoriesArr,
                                health: 100,
                                isExpanded: true
                            };
                            vm.sunburstInventoriesObj = _.cloneDeep(tempObj);
                            if (vm.inventoriesArr.length) {
                                vm.nestedFileInventoriesObj = _.cloneDeep([tempObj]);
                            } else {
                                vm.nestedFileInventoriesObj = {};
                            }
                            vm.isDeviceInventoryDetailsLoaded = true;
                            vm.fnGetComponentsActiveInactiveCount();
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            });
                            if ($stateParams.selectedComponentId && $stateParams.selectedComponentId.substring(0, $stateParams.selectedComponentId.lastIndexOf("-")) === vm.parent.deviceObj.id) {
                                vm.fnGetComponentDetails({id: $stateParams.selectedComponentId})
                            } else {
                                $state.go('main.device', {selectedComponentId: ''}, {notify: false});
                                delete $stateParams.selectedComponentId;
                            }
                            $timeout(function () {
                                $window.dispatchEvent(new Event("resize"));
                            });
                        }, function () {
                            vm.inventoriesArr = [];
                            vm.isDeviceInventoryDetailsLoaded = true;
                        });
                };

                $scope.$on("ComponentDetailsUpdated", function (event, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.inventoriesArr, function (inventoryObj) {
                        if (inventoryObj.id === vm.parent.selectedComponent.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                if (vm.selectedInventoryObj && Object.keys(vm.selectedInventoryObj).length &&
                                    vm.selectedInventoryObj.id === vm.parent.selectedComponent.id && vm.selectedInventoryObj[key]) {
                                    vm.selectedInventoryObj[key] = val;
                                }
                                if (vm.selectedNodeObj && Object.keys(vm.selectedNodeObj).length &&
                                    vm.selectedNodeObj.id === vm.parent.selectedComponent.id && vm.selectedNodeObj[key]) {
                                    vm.selectedNodeObj[key] = val;
                                }
                                vm.parent.selectedComponent[key] = val;
                                inventoryObj[key] = val;
                            });
                            if (!resetCopy.data && inventoryObj.data) {
                                delete inventoryObj.data;
                                delete vm.parent.selectedComponent.data;
                                if (vm.selectedInventoryObj) {
                                    delete vm.selectedInventoryObj.data;
                                }
                                if (vm.selectedNodeObj) {
                                    delete vm.selectedNodeObj.data;
                                }
                            }
                        }
                    });
                    vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);

                    var chartData = [];
                    var tempDataObj = _.groupBy(vm.inventoriesArr, function (deviceObj) {
                        return deviceObj.health;
                    });
                    _.forEach(tempDataObj, function (val, key) {
                        var tempValArr = [];
                        _.forEach(val, function (valObj) {
                            tempValArr.push({
                                name: valObj.name,
                                value: Math.floor(Math.random() * 100) + 1,
                                pointId: valObj.id
                            })
                        });
                        chartData.push({
                            name: key,
                            data: tempValArr,
                            color: ColorService.getHealthColorForLoop(key)['background-color']
                        })
                    });
                    vm.bubbleChartArr = chartData;

                    var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                    vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                    vm.nestedInventoriesArr.sort(function (a, b) {
                        return  collator.compare(a.index, b.index)
                    });
                    vm.nestedInventoriesArr.forEach(function iter(a) {
                        if (a.children && a.children.length) {
                            a.children.sort(function (a, b) {
                                return collator.compare(a.index, b.index)
                            });
                        }
                        return angular.isArray(a.children) && a.children.forEach(iter);
                    });
                    var tempObj = {
                        index: 'deviceRoot',
                        children: vm.nestedInventoriesArr,
                        health: 100,
                        isExpanded: true
                    };
                    vm.sunburstInventoriesObj = angular.copy(tempObj);
                    if (vm.inventoriesArr.length) {
                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                    } else {
                        vm.nestedFileInventoriesObj = {};
                    }
                });

                $scope.registerCallBack = function (callback) { //eslint-disable-line
                    $scope.conCallBack = callback; //eslint-disable-line
                };

                vm.fnSetSelectedTab = function (tab) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        loginUser = DB.fnGet('loginUser');
                        var inputObj = {
                            userId: loginUser.id,
                            body: {}
                        };

                        if (angular.isDefined(tab)) {
                            if (loginUser.data) {
                                loginUser.data['selectedTabInventory' + vm.parent.deviceObj.id] = ["" + tab + ""];
                                inputObj.body = loginUser.data;
                            }
                        } else {
                            if (loginUser.data) {
                                delete loginUser.data['selectedTabInventory' + vm.parent.deviceObj.id];
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body = {}
                            }
                        }
                        UserFactory.updateUserData(inputObj)
                            .then(function (data) {
                                loginUser.data = data;
                                DB.fnSet('loginUser', loginUser);
                            }, function () {
                            });
                    } else {
                        if (angular.isDefined(tab)) {
                            FedSudoUserService.fnSetUserData('selectedTabInventory' + vm.parent.deviceObj.id, ["" + tab + ""]);
                        } else {
                            if (loginUser.data) {
                                FedSudoUserService.fnRemoveUserData('selectedTabInventory' + vm.parent.deviceObj.id);
                            }
                        }
                    }
                };

                vm.fnGetNodeSummaryHealthColor = function (deviceObj) {
                    if (deviceObj.children) {
                        var summaryHealthCode = deviceObj.health ? deviceObj.health : 0;
                        angular.forEach(deviceObj.children, function (device) {
                            if (device.summaryHealthCode && device.summaryHealthCode > summaryHealthCode) {
                                summaryHealthCode = device.summaryHealthCode
                            } else if (device.health > summaryHealthCode) {
                                summaryHealthCode = device.health
                            }
                        });
                        deviceObj.summaryHealthCode = summaryHealthCode;
                        var healthObj = ColorService.getHealthColorForLoop(summaryHealthCode);
                        deviceObj.summaryHealthName = healthObj.content;
                        if (deviceObj.summaryHealthName === summaryHealthCode) {
                            deviceObj.toolTipName = summaryHealthCode;
                        } else {
                            deviceObj.toolTipName = deviceObj.summaryHealthName + " " + summaryHealthCode;
                        }
                        return healthObj;
                    }
                };

                vm.fnGetTopicInfo = function (typeId) {
                    var tempObj = _.find(vm.parent.typesArr, {'id': typeId});
                    if (tempObj) {
                        return tempObj;
                    }
                };

                /*start: file view code*/
                vm.collapseAll = function () {
                    $timeout(function () {
                        vm.expandedNodes = [];
                        vm.nestedInventoriesArr.forEach(function iter(a) {
                            if (a.children && a.children.length) {
                                a.isExpanded = false;
                            }
                            return angular.isArray(a.children) && a.children.forEach(iter);
                        });
                        var tempObj = {
                            index: 'deviceRoot',
                            children: vm.nestedInventoriesArr,
                            health: 100,
                            isExpanded: true
                        };
                        vm.nestedFileInventoriesObj = _.cloneDeepWith([tempObj]);
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            loginUser = DB.fnGet('loginUser');
                            var inputObj = {
                                userId: loginUser.id,
                                body: {}
                            };
                            if (loginUser.data) {
                                delete loginUser.data['inventoryPreferences' + vm.parent.deviceObj.id];
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body = {}
                            }
                            UserFactory.updateUserData(inputObj)
                                .then(function (data) {
                                    loginUser.data = data;
                                    DB.fnSet('loginUser', loginUser);
                                }, function () {
                                });
                        } else {
                            FedSudoUserService.fnRemoveUserData('inventoryPreferences' + vm.parent.deviceObj.id);
                        }
                    });
                };

                vm.expandAll = function () {
                    $timeout(function () {
                        vm.expandedNodes = [];
                        vm.nestedInventoriesArr.forEach(function iter(a) {
                            if (a.children && a.children.length) {
                                a.isExpanded = true;
                                vm.expandedNodes.push(a.index);
                            }
                            return angular.isArray(a.children) && a.children.forEach(iter);
                        });
                        var tempObj = {
                            index: 'deviceRoot',
                            children: vm.nestedInventoriesArr,
                            health: 100,
                            isExpanded: true
                        };
                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            loginUser = DB.fnGet('loginUser');
                            var inputObj = {
                                userId: loginUser.id,
                                body: {}
                            };

                            if (vm.expandedNodes && vm.expandedNodes.length !== 0) {
                                if (loginUser.data) {
                                    loginUser.data['inventoryPreferences' + vm.parent.deviceObj.id] = vm.expandedNodes;
                                    inputObj.body = loginUser.data;
                                }
                            } else {
                                if (loginUser.data) {
                                    delete loginUser.data['inventoryPreferences' + vm.parent.deviceObj.id];
                                    inputObj.body = loginUser.data;
                                } else {
                                    inputObj.body = {}
                                }
                            }
                            UserFactory.updateUserData(inputObj)
                                .then(function (data) {
                                    loginUser.data = data;
                                    DB.fnSet('loginUser', loginUser);
                                }, function () {
                                });
                        } else {
                            if (vm.expandedNodes && vm.expandedNodes.length !== 0) {
                                FedSudoUserService.fnSetUserData('inventoryPreferences' + vm.parent.deviceObj.id, vm.expandedNodes);
                            } else {
                                FedSudoUserService.fnRemoveUserData('inventoryPreferences' + vm.parent.deviceObj.id);
                            }
                        }
                    });
                };

                /*end: file view code*/

                vm.fnInventoryFilter = function () {
                    vm.isSearchDeviceInventoryDetailsLoaded = false;
                    vm.inventoriesArr = [];
                    if (angular.isDefined(vm.search)) {
                        vm.inventoriesArr = _.filter(vm.resetInventoriesArr, function (inventoriesObj) {
                            var tempIndex = '';
                            if (angular.isDefined(inventoriesObj.name) && inventoriesObj.name !== ' ') {
                                if (inventoriesObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                    return inventoriesObj;
                                }
                            } else {
                                if (vm.isTableViewSelected) {
                                    tempIndex = inventoriesObj.index;
                                } else {
                                    tempIndex = inventoriesObj.index.includes('#') ? inventoriesObj.index.split('#')[inventoriesObj.index.split('#').length - 1].replace(':', ' ') : inventoriesObj.index.replace(':', ' ');
                                }
                                if (tempIndex.toLowerCase().includes(vm.search.toLowerCase())) {
                                    return inventoriesObj;
                                }
                            }
                        });

                        if (!vm.inventoriesArr.length) {
                            vm.inventoriesArr = _.filter(vm.resetInventoriesArr, function (inventoriesObj) {
                                return inventoriesObj.id.includes(vm.search);
                            })
                        }
                    } else {
                        vm.inventoriesArr = angular.copy(vm.resetInventoriesArr);
                    }

                    var chartData = [];
                    var tempDataObj = _.groupBy(vm.inventoriesArr, function (deviceObj) {
                        return deviceObj.health;
                    });
                    _.forEach(tempDataObj, function (val, key) {
                        var tempValArr = [];
                        _.forEach(val, function (valObj) {
                            tempValArr.push({
                                name: valObj.name,
                                value: Math.floor(Math.random() * 100) + 1,
                                pointId: valObj.id
                            })
                        });
                        chartData.push({
                            name: key,
                            data: tempValArr,
                            color: ColorService.getHealthColorForLoop(key)['background-color']
                        })
                    });
                    vm.bubbleChartArr = chartData;

                    var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                    vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr, vm.resetInventoriesArr);
                    vm.nestedInventoriesArr.sort(function (a, b) {
                        return  collator.compare(a.index, b.index)
                    });
                    vm.nestedInventoriesArr.forEach(function iter(a) {
                        if (a.children && a.children.length) {
                            a.children.sort(function (a, b) {
                                return collator.compare(a.index, b.index)
                            });
                        }
                        return angular.isArray(a.children) && a.children.forEach(iter);
                    });
                    var tempObj = {
                        index: 'deviceRoot',
                        children: vm.nestedInventoriesArr,
                        health: 100,
                        isExpanded: true
                    };
                    vm.sunburstInventoriesObj = {};
                    vm.sunburstInventoriesObj = angular.copy(tempObj);
                    if (vm.inventoriesArr.length) {
                        vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                    } else {
                        vm.nestedFileInventoriesObj = {};
                    }
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        });
                        //$window.dispatchEvent(new Event("resize"));
                        vm.isSearchDeviceInventoryDetailsLoaded = true;
                    });
                };

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    $timeout.cancel(inventoryTimer);
                    inventoryTimer = $timeout(function () {
                        var index = _.findIndex(vm.inventoriesArr, function (inventoryObj) {
                            return inventoryObj.id === messageJson.id;
                        });
                        if (index !== -1 && vm.inventoriesArr[index]) {
                            if (messageJson.health) {
                                vm.inventoriesArr[index].health = messageJson.health;
                                var healthObj = ColorService.getHealthColorForLoop(vm.inventoriesArr[index].health);
                                vm.inventoriesArr[index].healthName = healthObj.content;
                                vm.inventoriesArr[index].healthColor = healthObj['background-color'];
                                vm.inventoriesArr[index].textColor = healthObj.color;
                                if (vm.inventoriesArr[index].healthName === vm.inventoriesArr[index].health) {
                                    vm.inventoriesArr[index].toolTipName = vm.inventoriesArr[index].health;
                                } else {
                                    vm.inventoriesArr[index].toolTipName = vm.inventoriesArr[index].healthName + " "
                                        + vm.inventoriesArr[index].health;
                                }
                                vm.resetInventoriesArr = angular.copy(vm.inventoriesArr);
                                var indexArray = componentService.getUniqueIndex(vm.inventoriesArr);
                                vm.nestedInventoriesArr = componentService.getHierarchy(indexArray, vm.inventoriesArr);
                                vm.nestedInventoriesArr.sort(function (a, b) {
                                    return  collator.compare(a.index, b.index)
                                });
                                vm.nestedInventoriesArr.forEach(function iter(a) {
                                    if (a.children && a.children.length) {
                                        a.children.sort(function (a, b) {
                                            return collator.compare(a.index, b.index)
                                        });
                                    }
                                    return angular.isArray(a.children) && a.children.forEach(iter);
                                });
                                var tempObj = {
                                    index: 'deviceRoot',
                                    children: vm.nestedInventoriesArr,
                                    health: 100,
                                    isExpanded: true
                                };
                                if (vm.isTreeViewSelected) {
                                    $timeout(function () {
                                        $scope.conCallBack(); //eslint-disable-line
                                    });
                                }
                                vm.sunburstInventoriesObj = angular.copy(tempObj);
                                if (vm.inventoriesArr.length) {
                                    vm.nestedFileInventoriesObj = angular.copy([tempObj]);
                                } else {
                                    vm.nestedFileInventoriesObj = {};
                                }
                            }
                        }
                    }, 2000);
                }

                function onGatewayConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeGatewayWebSocket();
                    }
                }

                function onGatewayMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    if (vm.gatewayObj && vm.gatewayObj.id === messageJson.id) {
                        if (messageJson.health) {
                            vm.gatewayObj.health = messageJson.health;
                        }
                        if (messageJson.phase) {
                            vm.gatewayObj.phase = messageJson.phase;
                        }
                        if (messageJson.connection) {
                            vm.gatewayObj.connection = messageJson.connection;
                        }
                        $scope.$emit("setGatewayObjForComponent", vm.gatewayObj);
                    }
                }

                vm.fnInitializeWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/components/" + vm.parent.deviceObj.id})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("inventory websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("inventory websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnInitializeGatewayWebSocket = function () {
                    var sudoUserObj = DB.fnGet('sudo');
                    var federationObj = DB.fnGet('federation');
                    var webSocketId = '';
                    if (sudoUserObj) {
                        webSocketId = sudoUserObj.id.split("-")[0];
                    } else if (federationObj) {
                        webSocketId = federationObj.id.split("-")[1];
                    } else {
                        webSocketId = loginUser.id.split("-")[0];
                    }
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/gateways/" + webSocketId})
                        .then(function (res) {
                            var requestUrl = res.url;
                            gatewayClient = new Paho.MQTT.Client(requestUrl, res.clientId);

                            gatewayClient.onConnectionLost = onGatewayConnectionLost;
                            gatewayClient.onMessageArrived = onGatewayMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("gateway websocket onConnect"); //eslint-disable-line*/
                                    gatewayClient.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("gateway websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            gatewayClient.connect(connectOptions);
                        })
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnGetGatewayDetails = function (gatewayId) {
                    GatewayFactory.getGateway({gatewayId: gatewayId})
                        .then(function (res) {
                            vm.gatewayObj = res;
                        }, function () {
                            vm.gatewayObj = null;
                        })
                };

                vm.fnGetComponentsActiveInactiveCount = function () {
                    vm.componentActive = 0;
                    angular.forEach(vm.resetInventoriesArr, function (inventoryObj) {
                        if (inventoryObj.enabled === true) {
                            vm.componentActive++;
                        }
                    });
                };

                vm.fnInitDeviceInventory = function () {
                    if ($stateParams.isConnectNativeInterface && ($stateParams.isConnectNativeInterface === 'true' ||
                        $stateParams.isConnectNativeInterface === true)) {
                        $timeout(function () {
                            $state.go('main.device', {isConnectNativeInterface: ''}, {notify: false});
                            delete $stateParams.isConnectNativeInterface;
                            vm.fnOpenNativeInterface();
                        })
                    }
                    vm.fnInitializeWebSockets();
                    var gatewayId = vm.parent.deviceObj.id.substring(0, vm.parent.deviceObj.id.lastIndexOf("-"));
                    vm.fnGetGatewayDetails(gatewayId);
                    vm.fnInitializeGatewayWebSocket();
                    vm.componentPermissionObj = PermissionsService.getPermissions("node:component");
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    TabHeight.fnSet();
                    var selectedTabInventory = FedSudoUserService.fnGetUserData('selectedTabInventory' + vm.parent.deviceObj.id);
                    var userChoice = selectedTabInventory === '' ? undefined : selectedTabInventory[0];
                    if (angular.isDefined(userChoice)) {
                        vm[userChoice] = true;
                    }
                    else {
                        vm.isFileViewSelected = true;
                    }
                    var inputObj = {
                        perPage: 0,
                        deviceId: vm.parent.deviceObj.id
                    };
                    vm.isDeviceInventoryDetailsLoaded = false;
                    vm.isSearchDeviceInventoryDetailsLoaded = true;
                    vm.selectedInventoryObj = null;
                    vm.fnGetDeviceInventories(inputObj);
                    //vm.fnGetAllDeviceComponents(inputObj);
                };

                vm.fnOpenNativeInterface = function () {
                    $scope.$emit('OpenNativeInterface', true);
                };

                vm.fnGetNodeInfo = function (treeDate) {
                    var inventoryPreferences = FedSudoUserService.fnGetUserData("inventoryPreferences" + vm.parent.deviceObj.id);
                    inventoryPreferences = inventoryPreferences === '' ? [] : inventoryPreferences;
                    if (inventoryPreferences.length !== 0) {
                        var index = inventoryPreferences.indexOf(treeDate.index);
                        if (index > -1) {
                            inventoryPreferences.splice(index, 1);
                        } else {
                            inventoryPreferences.push(treeDate.index);
                        }
                    } else {
                        inventoryPreferences.push(treeDate.index);
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        loginUser = DB.fnGet('loginUser');
                        var inputObj = {
                            userId: loginUser.id,
                            body: {}
                        };
                        if (inventoryPreferences && inventoryPreferences.length !== 0) {
                            if (loginUser.data) {
                                loginUser.data['inventoryPreferences' + vm.parent.deviceObj.id] = inventoryPreferences;
                                inputObj.body = loginUser.data;
                            }
                        } else {
                            if (loginUser.data) {
                                delete loginUser.data['inventoryPreferences' + vm.parent.deviceObj.id];
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body = {}
                            }
                        }
                        UserFactory.updateUserData(inputObj)
                            .then(function (data) {
                                loginUser.data = data;
                                DB.fnSet('loginUser', loginUser);
                            }, function () {
                            });
                    } else {
                        if (inventoryPreferences && inventoryPreferences.length !== 0) {
                            FedSudoUserService.fnSetUserData('inventoryPreferences' + vm.parent.deviceObj.id, inventoryPreferences);
                        } else {
                            FedSudoUserService.fnRemoveUserData('inventoryPreferences' + vm.parent.deviceObj.id);
                        }
                    }
                };

                $scope.$on("CallInventoryResize", function () {
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                });

                $scope.$on("DeviceHealthStatusChanged", function (evt, data) {
                    vm.deviceHealthObj = ColorService.getHealthColorForLoop(data.health);
                });

                $scope.$on("$destroy", function () {
                    if (client) {
                        client.disconnect();
                    }
                    if (gatewayClient) {
                        gatewayClient.disconnect();
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceClustersCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, Paho, ColorService,microSpinner,postActionModelIcon, postActionModelMessage,
                      PermissionsService,FedSudoUserService, PaginationService,LastPageService, DB, TabHeight, ClusterFactory, amaran, swal) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isDeviceClustersDetailsLoaded = false;
                vm.isAllDeviceClustersChecked = false;
                vm.deviceClustersArr = [];
                vm.selectedDeviceClustersArr = [];
                vm.selectedClustersArr = [];
                vm.isShowAddCluster = false;
                vm.filter = "$";
                vm.search = {$: ''};
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    }
                ];
                vm.filterQuery = "";

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if(vm.isShowAddCluster){
                        if (angular.isDefined(angular.element(".content-main")[0]) &&
                            angular.isDefined(angular.element(".headerTitle")[0]) &&
                            angular.isDefined(angular.element(".table-content-box")[1]) &&
                            angular.isDefined(angular.element(".search-panel")[0]) &&
                            angular.isDefined(angular.element(".search-tag-container")[0]) &&
                            angular.isDefined(angular.element("thead")[1]) &&
                            angular.isDefined(angular.element(".pagination-container")[1])) {
                            var totalList1 = angular.element(".content-main")[0].offsetHeight;
                            var headerTitle = angular.element(".headerTitle")[0].offsetHeight;
                            var search = angular.element(".search-panel")[0].offsetHeight;
                            var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                            var header = angular.element("thead")[1].offsetHeight;
                            var pagination = angular.element(".pagination-container")[1].offsetHeight;
                            var finalHeight = totalList1 - (headerTitle + search + pagination + searchTag + header + 34);
                            angular.element("#clusters-table tbody").css('height', finalHeight + 'px');
                        }
                    }else{
                        if (angular.isDefined(angular.element(".content-main")[0]) &&
                            angular.isDefined(angular.element(".viewClusterSearchBar")[0]) && angular.isDefined(angular.element("thead")[0])) {
                            var totalList = angular.element(".content-main")[0].offsetHeight;
                            var searchList = angular.element(".viewClusterSearchBar")[0].offsetHeight;
                            var header1 = angular.element("thead")[0].offsetHeight;
                            var finalHeightList = totalList - (searchList + header1 +10);
                            angular.element("#deviceAllClusters").css('height', finalHeightList + 'px');
                        }
                    }

                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 80);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnHideShowAddClusters = function () {
                    vm.isAllDeviceClustersChecked = false;
                    vm.fnCheckUncheckDeviceClusterAll();
                    vm.isShowAddCluster = !vm.isShowAddCluster;
                };

                vm.fnCheckUncheckDeviceClusterAll = function () {
                    angular.forEach(vm.deviceClustersArr, function (obj) {
                        obj.isCheck = vm.isAllDeviceClustersChecked;
                    });
                    if (vm.isAllDeviceClustersChecked) {
                        vm.selectedClustersArr = angular.copy(vm.deviceClustersArr);
                    } else {
                        vm.selectedClustersArr = [];
                    }

                };

                vm.fnCheckUncheckDeviceClusterHeader = function (clusterObj, fromList) {
                    vm.isAllDeviceClustersChecked  = true;
                    angular.forEach(vm.deviceClustersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllDeviceClustersChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === clusterObj.id) {
                                obj.isCheck = false;
                                vm.isAllDeviceClustersChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected cluster array*/
                    var isValueFind = _.find(vm.selectedClustersArr, {'id': clusterObj.id});
                    if (!isValueFind) {
                        vm.selectedClustersArr.push(clusterObj)
                    } else {
                        _.remove(vm.selectedClustersArr, function (obj) {
                            return clusterObj.id === obj.id;
                        });
                    }
                };

                vm.fnCheckUncheckHeader = function (clusterObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.clustersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === clusterObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected cluster array*/
                    var isValueFind = _.find(vm.selectedDeviceClustersArr, {'id': clusterObj.id});
                    if (!isValueFind) {
                        vm.selectedDeviceClustersArr.push(clusterObj)
                    } else {
                        _.remove(vm.selectedDeviceClustersArr, function (obj) {
                            return clusterObj.id === obj.id;
                        });
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.clustersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDeviceClustersArr = angular.copy(vm.clustersArr);
                    } else {
                        vm.selectedDeviceClustersArr = [];
                    }
                };


                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isClustersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    vm.isClustersLoading = true;
                    vm.selectedDeviceClustersArr = [];
                    vm.isAllDeviceClustersChecked = false;
                    if(vm.permissionObj.List) {
                        vm.fnGetClusters(inputObj);
                    } else {
                        vm.clustersArr = [];
                        vm.isClustersLoading = false;
                    }
                };

                vm.fnGetClusters = function (inputObj) {
                    ClusterFactory.getClusters(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.clusters;
                            vm.clustersArr = _.cloneDeepWith(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            vm.isClustersLoading = false;
                            $timeout(function () {
                                //angular.element($window).resize();
                                vm.fnSetTabHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isClustersLoading = false;
                        })
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    vm.isClustersLoading = true;
                    vm.selectedDeviceClustersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetClusters(vm.inputObj);
                };


                vm.fnAddClusterToDevice = function () {
                    vm.isClusterAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedDeviceClustersArr, function (selectedCluster) {
                        var inputObj = {
                            deviceId: vm.parent.deviceObj.id,
                            clusterId: selectedCluster.id
                        };
                        promises.push(ClusterFactory.addDeviceToCluster(inputObj));
                    });
                    $q.all(promises).then(function () {
                        amaran.success("Selected clusters successfully add in Device");
                        vm.isClusterAdding = false;
                        vm.isShowAddCluster = false;
                        vm.isDeviceClustersDetailsLoaded = false;
                        $timeout(function () {
                            vm.fnGetDeviceClusters(vm.parent.deviceObj);
                        });
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isClusterAdding = false;
                    })
                };

                vm.fnDeleteDeviceCluster = function (selectedDeviceClusterArr) {
                    swal({
                            title: "Remove all selected clusters from Device?",
                            text: "Clusters will be permanently removed for the Device.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedDeviceClusterArr, function (selectedCluster) {
                                    var inputObj = {
                                        deviceId: vm.parent.deviceObj.id,
                                        clusterId: selectedCluster.id
                                    };
                                    promises.push(ClusterFactory.removeDeviceFromCluster(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedDeviceClustersArr = [];
                                        vm.isDeviceClustersDetailsLoaded = false;
                                        $timeout(function () {
                                            vm.fnGetDeviceClusters(vm.parent.deviceObj);
                                        });
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetDeviceClusters = function (deviceObj) {
                    var inputObj = {
                        deviceId: deviceObj.id
                    };
                    ClusterFactory.getDeviceClusters(inputObj)
                        .then(function (response) {
                            TabHeight.fnSet();
                            vm.deviceClustersArr = response;
                            vm.isDeviceClustersDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnInitDeviceClusters = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:cluster");
                    vm.isDeviceClustersDetailsLoaded = false;
                    if(vm.permissionObj.List){
                        if (vm.parent.deviceObj.id) {
                            vm.fnGetDeviceClusters(vm.parent.deviceObj);
                        }
                    }else{
                        vm.isDeviceClustersDetailsLoaded = true;
                    }
                    TabHeight.fnSet();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceAlarmsCtrl',
            function ($scope, $timeout, $state, $uibModal, TabHeight, moment, amaran, swal, PermissionsService,
                      postActionModelMessage, postActionModelIcon, microSpinner, ComponentFactory, GatewayFactory,
                      ColorService, IconService, componentService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.deviceComponentsArr = [];
                vm.componentPieData = [];
                vm.isDeviceHealthy = true;
                vm.unhealthyComponentAttributeObj = {};
                var count = 0;
                vm.deviceObj = vm.parent.deviceObj;
                vm.gatewayObj = {};
                vm.isGatewayLoaded = true;
                vm.totalAlarmsCount = 0;

                vm.fnRefreshRelativeComponentGhostTime = function () {
                    _.forEach(vm.unhealthyComponentAttributeObj, function (value) {
                        _.forEach(value.attributes, function (componentGhostObj) {
                            componentGhostObj.humanDateLastUpdatedRelative = moment(componentGhostObj.humanTimestamp).fromNow();
                        })
                    });
                    vm.repeatativeComponentGhostTimer = $timeout(function () {
                        vm.fnRefreshRelativeComponentGhostTime();
                    }, 60000)
                };

                vm.fnGetDeviceComponent = function (inputObj) {
                    vm.isComponentsLoading = true;
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            var topicObj = {};
                            _.forEach(vm.parent.typesArr, function (d) {
                                topicObj[d.id] = d
                            });
                            _.forEach(response, function (resObj) {
                                if (resObj.enabled === true) {
                                    var healthObj = ColorService.getHealthColorForLoop(resObj.health);
                                    resObj.healthName = healthObj.content;
                                    if (resObj.healthName === resObj.health) {
                                        resObj.toolTipName = resObj.health;
                                    } else {
                                        resObj.toolTipName = resObj.healthName + " " + resObj.health;
                                    }
                                    resObj.healthColor = healthObj['background-color'];
                                    resObj.textColor = healthObj.color;
                                }
                                resObj.typeObj = topicObj[resObj.typeId];
                            });
                            vm.deviceComponentsArr = _.cloneDeepWith(response);
                            vm.indexArray = componentService.getUniqueIndex(response);
                            vm.unhealthyComponentsArr = _.filter(response, function (componentObj) {
                                if (componentObj.enabled === true && componentObj.health > 299) {
                                    return componentObj;
                                }
                            });
                            vm.isComponentsLoading = false;
                            vm.isPieChartLoading = true;
                            //vm.fnGenerateComponentsPieData(vm.unhealthyComponentsArr);
                            if (vm.unhealthyComponentsArr.length) {
                                count = 0;
                                vm.fnInitGetUnhealthyAttribute(count);
                            } else {
                                vm.isPieChartLoading = false;
                                vm.isDeviceHealthy = true;
                            }
                        }, function () {
                            vm.deviceComponentsArr = [];
                            vm.unhealthyComponentsArr = [];
                            vm.isComponentsLoading = false;
                        });
                };

                vm.fnGenerateComponentsPieData = function () {
                    var pieData = [];
                    var tempArr = [];
                    var tempObj = {};
                    _.forEach(vm.unhealthyComponentAttributeObj, function (componentObj, key) {
                        if (componentObj && componentObj.attributes && componentObj.attributes.length !== 0) {
                            _.forEach(componentObj.attributes, function (attributeObj) {
                                tempArr.push(attributeObj);
                            });
                            if (componentObj.breadcrumbArr && componentObj.breadcrumbArr.length !== 0) {
                                tempObj[key] = componentObj.breadcrumbArr[componentObj.breadcrumbArr.length - 1].index;
                            }
                        }
                    });
                    var componentSortData = mapOrder(tempObj, vm.indexArray);
                    var tempUnhealthyComponentAttributeObj = {};
                    _.forEach(componentSortData, function (obj) {
                        tempUnhealthyComponentAttributeObj[obj.key] = vm.unhealthyComponentAttributeObj[obj.key];
                    });
                    vm.unhealthyComponentAttributeObj = tempUnhealthyComponentAttributeObj;
                    vm.totalAlarmsCount = _.cloneDeepWith(tempArr.length);
                    var groupedHealthObj = _.mapValues(_.groupBy(tempArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: val.length,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.componentPieData = pieData;
                    vm.isPieChartLoading = false;
                };

                function mapOrder(array, order) {
                    var arr = [];
                    var prop;
                    for (prop in array) {
                        if (array.hasOwnProperty(prop)) {
                            arr.push({
                                'key': prop,
                                'value': array[prop]
                            });
                        }
                    }
                    arr.sort(function (a, b) {
                        if (order.indexOf(a.value) > order.indexOf(b.value)) {
                            return 1;
                        } else {
                            return -1;
                        }
                    });
                    return arr;
                }

                vm.fnInitGetUnhealthyAttribute = function (count) {
                    vm.isAttributeDataFetch = true;
                    if (count < vm.unhealthyComponentsArr.length) {
                        vm.fnGetUnhealthyAttribute(count);
                    } else {
                        $timeout(function () {
                            $timeout(function () {
                                $timeout.cancel(vm.repeatativeComponentGhostTimer);
                                vm.fnRefreshRelativeComponentGhostTime();
                            }, 60000);
                            vm.fnRemoveEmptyAttributeComponent();
                            vm.isAttributeDataFetch = false;
                        });
                    }
                };

                vm.fnGetUnhealthyAttribute = function (count) {
                    var inputObj = {
                        deviceId: vm.unhealthyComponentsArr[count].id.substring(0, vm.unhealthyComponentsArr[count].id.lastIndexOf("-")),
                        componentId: vm.unhealthyComponentsArr[count].id
                    };
                    ComponentFactory.getComponentGhost(inputObj)
                        .then(function (response) {
                            vm.componentGhostObj = response;
                            vm.componentReportedArr = [];
                            Object.keys(vm.componentGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.id = vm.componentGhostObj[key].id;
                                tempObj.name = vm.componentGhostObj[key].name;
                                tempObj.value = vm.componentGhostObj[key].reported ? vm.componentGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.componentGhostObj[key].enabled) ? vm.componentGhostObj[key].enabled : true;
                                tempObj.health = vm.componentGhostObj[key].health ? vm.componentGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.componentGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.componentGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.humanDateLastUpdatedAbsolute = moment(vm.componentGhostObj[key].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                                tempObj.displayName = vm.componentGhostObj[key].displayName;
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                tempObj.displayValue = tempObj.enabled === false? 'disabled':tempObj.value;
                                vm.componentReportedArr.push(tempObj);
                            });
                            var tempObj = {
                                attributes: [],
                                breadcrumbArr: []
                            };
                            tempObj.attributes = _.filter(vm.componentReportedArr, function (componentReportedObj) {
                                if (componentReportedObj.health > 299) {
                                    return componentReportedObj;
                                }
                            });
                            var tempBreadcrumbStr = vm.unhealthyComponentsArr[count].index;
                            vm.tempBreadcrumbArr = tempBreadcrumbStr.split("#");
                            var tempArr = [];
                            var tempString = '';
                            _.forEach(vm.tempBreadcrumbArr, function (value) {
                                var tempObj = {};
                                tempString = tempString === '' ? value : tempString + "#" + value;
                                var isValueFind = _.find(vm.deviceComponentsArr, {'index': tempString});
                                if (isValueFind && isValueFind.enabled === true) {
                                    tempObj.isClickable = true;
                                    tempObj.displayName = isValueFind.name && isValueFind.name !== ' ' ? isValueFind.name : value.replace(':', ' ');
                                    tempObj.inventorieObj = isValueFind;
                                    var healthObj = ColorService.getHealthColorForLoop(isValueFind.health);
                                    tempObj.healthName = healthObj.content;
                                    tempObj.healthColor = healthObj['background-color'];
                                    tempObj.textColor = healthObj.color;
                                } else {
                                    tempObj.isClickable = false;
                                    tempObj.displayName = value.replace(':', ' ');
                                    tempObj.inventorieObj = {};
                                }
                                tempObj.index = tempBreadcrumbStr;
                                tempArr.push(tempObj);
                            });
                            tempObj.breadcrumbArr = tempArr;
                            vm.unhealthyComponentAttributeObj[vm.unhealthyComponentsArr[count].id] = tempObj;
                            count++;
                            if (count < vm.unhealthyComponentsArr.length) {
                                vm.fnGetUnhealthyAttribute(count);
                            } else {
                                $timeout(function () {
                                    $timeout.cancel(vm.repeatativeComponentGhostTimer);
                                    vm.fnRefreshRelativeComponentGhostTime();
                                }, 60000);
                                vm.fnRemoveEmptyAttributeComponent();
                                vm.isAttributeDataFetch = false;
                            }
                        }, function () {
                            count++;
                            if (count < vm.unhealthyComponentsArr.length) {
                                vm.fnGetUnhealthyAttribute(count);
                            } else {
                                $timeout(function () {
                                    $timeout.cancel(vm.repeatativeComponentGhostTimer);
                                    vm.fnRefreshRelativeComponentGhostTime();
                                }, 60000);
                                vm.fnRemoveEmptyAttributeComponent();
                                vm.isAttributeDataFetch = false;
                            }
                        })
                };

                vm.fnRemoveEmptyAttributeComponent = function () {
                    _.forEach(vm.unhealthyComponentAttributeObj, function (componentObj, key) {
                        if (componentObj && componentObj.attributes && componentObj.attributes.length === 0) {
                            delete vm.unhealthyComponentAttributeObj[key];
                            _.remove(vm.unhealthyComponentsArr, {id: key});
                        }
                    });
                    vm.fnGenerateComponentsPieData(vm.unhealthyComponentsArr);
                    if (vm.unhealthyComponentsArr.length === 0) {
                        vm.isDeviceHealthy = true;
                    }
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnGetGatewayDetails = function (gatewayId) {
                    GatewayFactory.getGateway({gatewayId: gatewayId})
                        .then(function (res) {
                            vm.gatewayObj = res;
                            vm.isGatewayLoaded = false;
                        }, function () {
                            vm.gatewayObj = null;
                            vm.isGatewayLoaded = false;
                        })
                };

                vm.fnDisableAttribute = function (id, componentGhostObj) {
                    if (angular.isUndefined(componentGhostObj.enabled) || componentGhostObj.enabled === true) {
                        swal({
                                title: "Disable Attribute?",
                                text: "Disabling attribute will prevent them from being monitored.",
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "disable",
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    var inputObj = {
                                        deviceId: id.substring(0, id.lastIndexOf("-")),
                                        componentId: id,
                                        attributeName: componentGhostObj.name
                                    };
                                    ComponentFactory.disableComponentAttribute(inputObj)
                                        .then(function (response) {
                                            if (!response.errors) {
                                                componentGhostObj.enabled = false;
                                                vm.isFooterLoaderActive = false;
                                                _.remove(vm.unhealthyComponentAttributeObj[id].attributes, {name: componentGhostObj.name});
                                                vm.fnRemoveEmptyAttributeComponent();
                                                swal({
                                                    title: postActionModelMessage,
                                                    html: true,
                                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'customSwalActionModel'
                                                });
                                                angular.element(".microSpinner").remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                $timeout(function () {
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    swal.close();
                                                }, 1000);
                                                amaran.success("The Attribute disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                            } else {
                                                componentGhostObj.enabled = true;
                                                vm.isFooterLoaderActive = false;
                                                amaran.error("Attribute Disable was unsuccessful")
                                            }
                                        });
                                } else {
                                    vm.isFileViewUpdating = false;
                                    amaran.error("Disable Process Cancelled");
                                }
                            });
                    }
                };

                vm.fnCreateIssue = function (id, componentGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeManageIssueModal/attributeManageIssueModal.html',
                        size: 'lg',
                        controller: 'attributeManageIssueModalCtrl as attributeManageIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueType: function () {
                                return "component"
                            },
                            GhostObj: function () {
                                return componentGhostObj;
                            },
                            componentObj: function () {
                                return _.find(vm.deviceComponentsArr, {id: id});
                            },
                            deviceObj: function () {
                                return vm.parent.deviceObj;
                            },
                            gatewayObj: function () {
                                return vm.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                        })
                    }, function () {

                    });
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.repeatativeComponentGhostTimer);
                });

                vm.fnOpenAttributeStatistics = function (selectedAttribute, id) {
                    var selectedComponent = {
                        id: id
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html',
                        size: 'lg',
                        controller: 'attributeStatisticsModalCtrl as attributeStatistics',
                        resolve: {
                            selectedAttribute: function () {
                                return selectedAttribute;
                            },
                            selectedComponent: function () {
                                return selectedComponent;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnDownloadCSV = function (className) {
                    var chart = $('.' + className).highcharts();//eslint-disable-line
                    chart.downloadCSV();
                };

                vm.fnDownloadXLS = function (className) {
                    var chart = $('.' + className).highcharts();//eslint-disable-line
                    chart.downloadXLS();
                };

                vm.fnGoToTab = function (type) {
                    switch (type) {
                        case 'deviceTelemetry':
                            if (vm.parent.deviceObj.hasComponents === true) {
                                vm.parent.fnTabSelected({tabIndex: 6});
                            } else {
                                vm.parent.fnTabSelected({tabIndex: 2});
                            }
                            break;
                        case 'gatewayTelemetry':
                            $state.go('main.gateway', {selectedId: vm.gatewayObj.id, selectedDetailsTab: 2});
                            break;
                    }
                };

                vm.fnRightClick = function (breadCrumb, idToFind) {
                    if (idToFind) {
                        var targetObj = _.find(breadCrumb, function (bread) {
                            return bread.inventorieObj && bread.inventorieObj.id === idToFind;
                        });
                        vm.fnGetComponentGhostDetails(targetObj.inventorieObj);
                    } else {
                        vm.fnGetComponentGhostDetails(breadCrumb.inventorieObj);
                    }
                };

                vm.fnGetComponentGhostDetails = function (inventoryObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/viewGhostAttributes.html',
                        size: 'lg',
                        controller: 'viewGhostAttributesCtrl as viewGhostAttributes',
                        windowClass: 'modal-height100',
                        resolve: {
                            inventoryObj: function () {
                                return inventoryObj;
                            },
                            parentInventories: function () {
                                return vm.deviceComponentsArr;
                            },
                            deviceObj: function () {
                                return $scope.deviceObj;
                            },
                            gatewayObj: function () {
                                return $scope.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnRenameAttribute = function(id, componentGhostObj){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeRenameModal/attributeRenameModal.html',
                        size: 'md',
                        controller: 'attributeRenameModalCtrl as attributeRenameModal',
                        resolve: {
                            selectedGhostObj: function () {
                                return _.cloneDeepWith(componentGhostObj);
                            },
                            ghostType: function () {
                                return 'Component'
                            },
                            id: function () {
                                return id;
                            }
                        }
                    });
                    modalInstance.result.then(function (newName) {
                        componentGhostObj.displayName = newName;
                    }, function () {
                    });
                };

                vm.fnInitDeviceAlarms = function () {
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    TabHeight.fnSet();
                    var gatewayId = vm.parent.deviceObj.id.substring(0, vm.parent.deviceObj.id.lastIndexOf("-"));
                    vm.isGatewayLoaded = true;
                    vm.fnGetGatewayDetails(gatewayId);
                    if (vm.parent.deviceObj && vm.parent.deviceObj.health > 299) {
                        vm.isDeviceHealthy = false;
                        var inputObj = {
                            perPage: 0,
                            deviceId: vm.parent.deviceObj.id
                        };
                        vm.fnGetDeviceComponent(inputObj);
                    } else {
                        vm.isDeviceHealthy = true;
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ComponentOverviewCtrl',
            function ($window, $scope, $state, $timeout, $cookies, $http, $uibModal, moment, amaran, TabHeight, PermissionsService, AnalyticsFactory,
                      IconService, ComponentFactory, ColorService, analyticsService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.infoSectionClass = vm.parent.infoSectionClass;
                vm.gatewayObj = vm.parent.cmpGatewayObj;
                vm.deviceObj = vm.parent.deviceObj;
                vm.selectedComponent = _.cloneDeepWith(vm.parent.selectedComponent);
                vm.telemetryPieData = [];
                vm.selectedFilterObj = {
                    type: 'relative',
                    name: '3',
                    value: '3h',
                    units: 'hours',
                    window: '5m'
                };
                vm.aggregateHealthArr = [];
                vm.isAggregateHealthLoading = true;
                vm.componentHealthPieData = [];

                /*START: FILTER OPTIONS*/
                vm.filterOptions = [{
                    value: '1h',
                    tabIndex: 0,
                    name: '1',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '3h',
                    tabIndex: 1,
                    name: '3',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '12h',
                    tabIndex: 2,
                    name: '12',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '3d',
                    tabIndex: 3,
                    name: '3',
                    units: 'days',
                    window: "1h",
                    type: 'relative'
                }, {
                    value: '1w',
                    tabIndex: 4,
                    name: '1',
                    units: 'weeks',
                    window: "1h",
                    type: 'relative'
                }, {
                    value: 'Custom',
                    tabIndex: 5
                }];
                vm.chartOptions = [{
                    name: 'Area Chart',
                    icon: 'fa-area-chart',
                    tabIndex: 0
                }, {
                    name: 'Pie Chart',
                    icon: 'fa-pie-chart',
                    tabIndex: 1
                }];
                vm.selectedFilterOption = vm.filterOptions[1];
                vm.selectedFilterObj = vm.filterOptions[1];
                vm.selectedChartType = vm.chartOptions[0];
                vm.selectedAggregateFn = 'MEAN';
                /*END: FILTER OPTIONS*/
                vm.isShowLabel = false;

                vm.fnChangeChartType = function (charType) {
                    if (vm.selectedChartType.tabIndex !== charType.tabIndex) {
                        vm.selectedChartType = charType;
                    }
                };

                vm.fnChangeFilterOption = function (filterOption) {
                    if ((vm.filterOptions.length - 1) === filterOption.tabIndex) {
                        vm.fnOpenDateTimeHelpModal();
                    }
                    if (vm.selectedFilterOption.tabIndex !== filterOption.tabIndex) {
                        vm.selectedFilterOption = filterOption;
                        if ((vm.filterOptions.length - 1) !== filterOption.tabIndex) {
                            vm.aggregateHealthArr = [];
                            vm.selectedFilterObj = filterOption;
                            vm.fnGetAnalyticsQuery(vm.parent.selectedComponent.id);
                        }
                    }
                };

                vm.fnGetComponentGhost = function (componentObj) {
                    var inputObj = {
                        deviceId: componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };
                    ComponentFactory.getComponentGhost(inputObj)
                        .then(function (response) {
                            vm.componentGhostObj = response;
                            vm.componentReportedArr = [];
                            Object.keys(vm.componentGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.componentGhostObj[key].name;
                                tempObj.value = vm.componentGhostObj[key].reported ? vm.componentGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.componentGhostObj[key].enabled) ? vm.componentGhostObj[key].enabled : true;
                                tempObj.health = vm.componentGhostObj[key].health ? vm.componentGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.componentGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.componentGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.humanDateLastUpdatedAbsolute = moment(vm.componentGhostObj[key].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                vm.componentReportedArr.push(tempObj);
                            });
                            vm.fnGenerateTelemetryPieData(vm.componentReportedArr);
                            vm.isComponentGhostDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isComponentGhostDetailsLoaded = true;
                        })
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnGetAnalyticsQuery = function (id) {
                    vm.isAggregateHealthLoading = true;
                    var inputObj = {
                        "dataSets": ["AGGREGATE"],
                        "nodeId": id,
                        "timeRange": {}
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };

                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsData = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if(response && response.data && response.data.data){
                                vm.analyticsData = response.data.data;
                            }else{
                                vm.analyticsData = {};
                            }
                            if(response && response.data && response.data.meta){
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            }else{
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateComponentAggregateData(timeStampsArr);
                    }, function error() {
                        vm.analyticsData = {};
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateComponentAggregateData(timeStampsArr);
                    });
                    /*vm.fnGeneratePieDataForComponent("");
                    vm.isAggregateHealthLoading = false;*/
                };

                vm.fnCreateComponentAggregateData = function(timeStampsArr){
                    vm.aggregateHealthArr = [];
                    if (vm.analyticsData && vm.analyticsData.AGGREGATE && vm.analyticsData.AGGREGATE.points) {
                        var componentAnalyticsb64String = vm.analyticsData.AGGREGATE.points;
                        var componentAnalyticsCSVString = analyticsService.getCSVString(componentAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAggregateHealthData(componentAnalyticsCSVString);
                        var componentPieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.length) {
                            vm.aggregateHealthArr = tempAggregateHealthArr;
                            var componentPieChartString = vm.analyticsData.AGGREGATE.summary;
                            var componentPieChartAnalyticsCSVString = analyticsService.getCSVString(componentPieChartString);
                            componentPieChartAnalyticsData = analyticsService.getAggregateHealthPieChartData(componentPieChartAnalyticsCSVString);
                        } else {
                            componentPieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        }
                        vm.fnGeneratePieDataForComponent(componentPieChartAnalyticsData);
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        vm.fnGeneratePieDataForComponent(pieChartAnalyticsData);
                    }
                    vm.isAggregateHealthLoading = false;
                };

                vm.fnCreateAggregateStaticHealth = function (timeStampsArr) {
                    var analyticsHealthArr = [];
                    var tempIndex = 0;
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var healthObj = ColorService.getHealthColorForLoop(parseInt(vm.parent.selectedComponent.health));
                        vm.aggregateHealthArr.push({
                            x: 0,
                            y: tempIndex,
                            value: parseInt(vm.parent.selectedComponent.health),
                            color: healthObj['background-color'],
                            healthObj: healthObj,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsHealthArr.push({
                            duration: 100,
                            health: parseInt(vm.parent.selectedComponent.health),
                            healthObj: healthObj,
                            id: vm.parent.selectedComponent.health.id,
                            percentage: 100,
                            marker: {fillColor: healthObj['background-color']}
                        });
                        tempIndex++
                    });
                    return analyticsHealthArr;
                };

                vm.fnOpenDateTimeHelpModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html',
                        size: 'lg',
                        controller: 'analyticsDateTimeHelpModalCtrl as analyticsDateTimeModal',
                        resolve: {
                            selectedTime: function () {
                                return vm.selectedFilterObj;
                            },
                            selectedAggregateFn: function () {
                                return vm.selectedAggregateFn;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.selectedFilterObj = response.selectedTime;
                        vm.selectedAggregateFn = response.selectedAggregateFn;
                        vm.aggregateHealthArr = [];
                        vm.fnGetAnalyticsQuery(vm.parent.selectedComponent.id);
                    }, function () {
                        vm.aggregateHealthArr = [];
                        vm.fnGetAnalyticsQuery(vm.parent.selectedComponent.id);
                    });
                };

                vm.fnGeneratePieDataForComponent = function (healthArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(healthArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: totalP,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.componentHealthPieData = pieData;
                };

                vm.fnGenerateTelemetryPieData = function (inventoriesArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(inventoriesArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: val.length,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.telemetryPieData = pieData;
                    vm.isPieChartLoading = false;
                };

                vm.fnGoBackToInventory = function () {
                    $scope.$emit("GoBackToInventory");
                };

                $scope.$on('redrawChart', function (evt, data) {
                    vm.infoSectionClass = data;
                });

                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };

                vm.fnInitComponentOverview = function () {
                    TabHeight.fnSet();
                    vm.isComponentGhostDetailsLoaded = false;
                    if (vm.parent.selectedComponent.id) {
                        var tempBreadcrumbStr = vm.parent.selectedComponent.index;
                        vm.tempBreadcrumbArr = tempBreadcrumbStr.split("#");
                        var tempArr = [];
                        var tempString = '';
                        _.forEach(vm.tempBreadcrumbArr, function (value) {
                            var tempObj = {};
                            tempString = tempString === '' ? value : tempString + "#" + value;
                            var isValueFind = _.find(vm.parent.inventoriesArr, {'index': tempString});
                            if (isValueFind && isValueFind.enabled === true) {
                                tempObj.isClickable = true;
                                tempObj.displayName = isValueFind.name && isValueFind.name !== ' ' ? isValueFind.name : value.replace(':', ' ');
                                tempObj.inventorieObj = isValueFind;
                                var healthObj = ColorService.getHealthColorForLoop(isValueFind.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                            } else {
                                tempObj.isClickable = false;
                                tempObj.displayName = value.replace(':', ' ');
                                tempObj.inventorieObj = {};
                            }
                            tempArr.push(tempObj);
                        });
                        vm.breadcrumbArray = tempArr;
                        vm.fnGetComponentGhost(vm.parent.selectedComponent);
                        vm.fnGetAnalyticsQuery(vm.parent.selectedComponent.id);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ComponentSupplementalCtrl',
            function ($rootScope, $scope, $timeout, $window, amaran, DB, PermissionsService, TabHeight, ComponentFactory, $uibModal) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.componentSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnInjectFunction = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html',
                        size: 'lg',
                        controller: 'supplementFunctionModalCtrl as supplementModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (supplementalArr) {
                        _.forEach(supplementalArr, function (supplementalObj) {
                            if (supplementalObj.key && supplementalObj.value && supplementalObj.key.length && supplementalObj.value.length) {
                                var isFind = _.find(vm.supplementalKVPArr, {key: supplementalObj.key});
                                if(!isFind){
                                    vm.supplementalKVPArr.push(supplementalObj);
                                }else{
                                    isFind.value = supplementalObj.value;
                                }
                            }
                        });
                        _.remove(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            return supplementalKVPObj.key === '' && supplementalKVPObj.value === '';
                        });
                        if (!vm.supplementalKVPArr.length) {
                            vm.supplementalKVPArr = [{key: '', value: ''}];
                        }
                    }, function () {
                    });

                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetComponentData = function (componentObj) {
                    var inputObj = {
                        deviceId: componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };

                    ComponentFactory.getComponent(inputObj)
                        .then(function (response) {
                            vm.componentSupplementalObj = response.data ? angular.fromJson(response.data) : {};
                            /*{
                                lat: ["456"],
                                    long: ["789"]
                            };*/
                            vm.componentSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.componentSupplementalObj, true) : vm.componentSupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.componentSupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                                angular.forEach(vm.componentSupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value[0]
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isComponentSupplementalDetailsLoaded = true;
                        })
                };
                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isSupplementalEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isSupplementalEditable = false;
                        vm.componentSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };
                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.componentSupplementalObj = angular.toJson(vm.componentSupplementalObj, true);
                    } else {
                        vm.componentSupplementalObj = angular.fromJson(vm.componentSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                            angular.forEach(vm.componentSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value[0]
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                        vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnSaveComponentData = function (isSupplementalEdit) {
                    if (isSupplementalEdit) {
                        vm.isSupplementalDetailChanging = true;
                        vm.parent.selectedComponent.data = {};
                    } else {
                        vm.isSupplementalDataAdded = true;
                    }
                    var inputObj = {
                        deviceId : vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.parent.selectedComponent.id,
                        body: {
                            data: {}
                        }
                    };
                    if (!vm.parent.selectedComponent.data) {
                        vm.parent.selectedComponent.data = {};
                    }
                    angular.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                        if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                            vm.parent.selectedComponent.data[kpPairObj.key] = ["" + kpPairObj.value + ""];
                        }
                    });

                    inputObj.body.data = vm.parent.selectedComponent.data;
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function () { //response
                            // $rootScope.$broadcast('ComponentSupplementalDataUpdated', response);
                            amaran.success("Data added to component successfully");
                            if (isSupplementalEdit) {
                                vm.isSupplementalDetailChanging = false;
                                vm.isSupplementalDetailsEditable = false;

                            } else {
                                vm.isSupplementalDataAdded = false;
                            }
                            vm.isCreateFromView = false;
                            vm.fnInitComponentSupplemental();
                        }, function () {
                            if (isSupplementalEdit) {
                                vm.isSupplementalDetailChanging = false;
                                vm.isSupplementalDetailsEditable = false;
                            } else {
                                vm.isSupplementalDataAdded = false;
                            }
                            vm.isCreateFromView = false;
                            vm.fnInitComponentSupplemental();
                        })

                };

                vm.fnEditComponentData = function (obj) {
                    vm.isSupplementalEditableUpdate = true;
                    var inputObj = {
                        deviceId : vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.parent.selectedComponent.id,
                        body: {
                            data:  obj ? angular.fromJson(obj) : {}
                        }
                    };
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function () { //response
                            // $rootScope.$broadcast('ComponentSupplementalDataUpdated', response);
                            amaran.success("Data edited successfully");
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitComponentSupplemental();
                        }, function () {
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitComponentSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if(isCalledEditMode){
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.componentSupplementalObj = angular.copy(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.componentSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value[0]
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                };

                vm.fnGoBackToInventory = function () {
                    $scope.$emit("GoBackToInventory");
                };

                vm.fnInitComponentSupplemental = function () {
                    vm.componentPermissionObj = PermissionsService.getPermissions("node:component");
                    TabHeight.fnSet();
                    vm.isComponentSupplementalDetailsLoaded = false;
                    if (vm.parent.selectedComponent.id) {
                        vm.fnGetComponentData(vm.parent.selectedComponent);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ComponentGhostCtrl',
            function ($scope, $window, $timeout, $http, $state, $stateParams, $q, $uibModal, $cookies, Paho, IconService, ColorService,
                      GhostService, PermissionsService, DB, moment, amaran, swal, TabHeight, SchemaService, TypeFactory,
                      WebSocketFactory, ComponentFactory, UserFactory, FedSudoUserService, AppInitService, AnalyticsFactory, jsonToCsvConvertService, XLSX, analyticsService) {
                var vm = this;
                var inventoryTimer, overLayWebSocketTimeout;
                var client;
                var count = 0;
                vm.parent = $scope.$parent;
                vm.componentObj = vm.parent.selectedComponent;
                vm.gatewayObj = vm.parent.cmpGatewayObj;
                vm.deviceObj = vm.parent.deviceObj;
                vm.isGhostDetailsEditable = false;
                vm.isGhostUpdateCompleted = true;
                vm.isFooterLoaderActive = false;
                vm.componentGhostObj = {};
                vm.selectedGhostObj = {};
                vm.ghostUpdateObj = {};
                vm.isEditInputValidated = false;
                vm.filter = "$";
                vm.search = {$: ''};
                vm.isDropUp = false;
                vm.tabs = [
                    {
                        icon: "fa-table",
                        tabIndex: 0
                    }
                ];
                vm.selectedTab = {};
                vm.tableOptionsObj = {
                    health: true,
                    name: true,
                    value: true,
                    display: true
                };
                var currentTime = Date.now();
                var hours = 3;
                vm.isShowAllGhostAttributes = false;
                vm.recentlyUpdatedComponentReportedArr = [];
                vm.unhealthyComponentReportedArr = [];
                vm.isAttributeAnalyticsDataFetch = false;
                vm.currentTime = '';
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTreeHeight();
                });

                vm.fnSetTreeHeight = function () {
                    if (angular.isDefined(angular.element(".layoutContainer")[0]) &&
                        angular.isDefined(angular.element(".viewGhostSearchBar")[0])) {
                        var total, search, finalHeight;
                        total = angular.element(".layoutContainer")[0].offsetHeight;
                        search = angular.element(".viewGhostSearchBar")[0].offsetHeight;
                        finalHeight = total - (search + 51);
                        angular.element(".ghostAttributesLayout-table-normal #componentGhostData").css('height', finalHeight + 'px');
                        var unhealthyComponentFinalHeight = angular.copy(finalHeight / 2) - (20 + 34 + 10);
                        var recentlyUpdatedComponentFinalHeight = angular.copy(finalHeight / 2) - (34 + 20 + 10);
                        angular.element(".ghostAttributesLayout-table-normal #noComponentReportedData").css('height', finalHeight + 'px');
                        angular.element(".ghostAttributesLayout-table-normal #unhealthyComponentReported").css('height', (unhealthyComponentFinalHeight + 35) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal #recentlyUpdatedComponentReported").css('height', (recentlyUpdatedComponentFinalHeight + 35) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal tbody#unhealthyComponentReportedArr").css('height', (unhealthyComponentFinalHeight) + 'px');
                        angular.element(".ghostAttributesLayout-table-normal tbody#recentlyUpdatedComponentReportedArr").css('height', (recentlyUpdatedComponentFinalHeight) + 'px');
                    }
                };

                //Context Menu: Start
                vm.attributesContextMenu = function (deviceGhostObj) {
                    return [{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnRenameAttribute(deviceGhostObj);
                        }
                    }]
                };
                //Context Menu: End

                vm.fnRefreshRelativeComponentGhostTime = function () {
                    angular.forEach(vm.componentReportedArr, function (componentGhostObj) {
                        componentGhostObj.humanDateLastUpdatedRelative = moment(componentGhostObj.humanTimestamp).fromNow();
                    });
                    vm.repeatativeComponentGhostTimer = $timeout(function () {
                        vm.fnRefreshRelativeComponentGhostTime();
                    }, 60000)
                };

                vm.fnDownloadXls = function () {
                    var gatewayGhostArrCp = angular.copy(vm.componentGhostObj);
                    var tempData = _.map(gatewayGhostArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "ComponentGhost");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "componentGhost_" + $stateParams.selectedId + ".xlsx");
                };
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchorGhostForComponent')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchorGhostForComponent').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = angular.copy(vm.componentGhostObj);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    Object.keys(tempData).map(function(key) {
                        vm.csvHeaderArr = Object.keys(tempData[key]);
                        return vm.csvHeaderArr;
                    });
                    return _.map(data[1], function (deviceGhostObj) {
                        var tempObj = {};
                        _.forEach(vm.csvHeaderArr, function (headerText) {
                            tempObj[headerText] = deviceGhostObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnGetComponentGhost = function (componentObj) {
                    var inputObj = {
                        deviceId: componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };

                    ComponentFactory.getComponentGhost(inputObj)
                        .then(function (response) {
                            vm.componentGhostObj = response;
                            vm.componentReportedArr = [];
                            Object.keys(vm.componentGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.componentGhostObj[key].name;
                                tempObj.value = vm.componentGhostObj[key].reported ? vm.componentGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.componentGhostObj[key].enabled) ? vm.componentGhostObj[key].enabled : true;
                                tempObj.health = vm.componentGhostObj[key].health ? vm.componentGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.componentGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.componentGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.humanDateLastUpdatedAbsolute = moment(vm.componentGhostObj[key].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                                tempObj.displayName = vm.componentGhostObj[key].displayName;
                                tempObj.unit = angular.isDefined(vm.componentGhostObj[key].unit) ? vm.componentGhostObj[key].unit : "";
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                tempObj.displayValue = tempObj.enabled === false? 'disabled':tempObj.value === "__empty" ? "": tempObj.value;
                                vm.componentReportedArr.push(tempObj);
                            });
                            $timeout(function () {
                                $timeout.cancel(vm.repeatativeComponentGhostTimer);
                                vm.fnRefreshRelativeComponentGhostTime();
                            }, 60000);
                            vm.fnGetTypeDefinition(vm.componentReportedArr);
                            count = 0;
                            vm.currentTime = moment();
                            vm.isAttributeAnalyticsDataFetch = true;
                            vm.fnInitAttributeAnalytics(count);
                        })
                };

                vm.fnGetTypeDefinition = function (componentReportedArr) {
                    TypeFactory.getType({typeId: vm.parent.selectedComponent.typeId})
                        .then(function (response) {
                            vm.typeObj = angular.copy(response);
                            if (Object.keys(response.definitions).length) {
                                angular.forEach(componentReportedArr, function (componentReportedObj) {
                                    Object.keys(response.definitions).forEach(function (key) {
                                        if (componentReportedObj.name === key) {
                                            componentReportedObj.editable = true;
                                            var inputObj = {};
                                            inputObj[key] = response.definitions[key];
                                            componentReportedObj.schema = SchemaService.convertJsonToSchema(inputObj);
                                            angular.forEach(componentReportedObj.schema, function (tempObj) {
                                                if (tempObj.default) {
                                                    tempObj.typeValue = tempObj.default;
                                                } else {
                                                    tempObj.typeValue = "";
                                                }
                                                tempObj.isValueMissing = false;
                                                tempObj.isPatternMismatch = false;
                                                tempObj.isMinError = false;
                                                tempObj.isMaxError = false;
                                            });
                                        }
                                    })
                                });
                                vm.selectedTab = vm.tabs[0];
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                });
                                vm.isComponentGhostDetailsLoaded = true;
                            } else {
                                vm.selectedTab = vm.tabs[0];
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                });
                                vm.isComponentGhostDetailsLoaded = true;
                            }
                            vm.fnGetUnhealthyAndHealthyAttribute(componentReportedArr);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.selectedTab = vm.tabs[0];
                            vm.isComponentGhostDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            });
                            vm.fnGetUnhealthyAndHealthyAttribute(componentReportedArr);
                        })
                };

                vm.fnGetUnhealthyAndHealthyAttribute = function (componentReportedArr) {
                    vm.recentlyUpdatedComponentReportedArr = [];
                    vm.unhealthyComponentReportedArr = [];
                    currentTime = Date.now();
                    _.forEach(componentReportedArr, function (comtponentReporedObj) {
                        var recentlyUpdateTimeStampData = hours * 60 * 60 * 1000;
                        var deviceTimeStampDiff = currentTime - comtponentReporedObj.timestamp;
                        if (deviceTimeStampDiff <= recentlyUpdateTimeStampData) {
                            vm.recentlyUpdatedComponentReportedArr.push(comtponentReporedObj);
                        }
                        if (comtponentReporedObj.health > 299) {
                            vm.unhealthyComponentReportedArr.push(comtponentReporedObj);
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnEditGhostValue = function (componentGhostObj) {
                    vm.selectedGhostObj = componentGhostObj.schema;
                    vm.fnOpenModifyGhostAttributeModal();
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isEditInputValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.ghostUpdateObj = propertiesObj;
                    } else {
                        vm.ghostUpdateObj = {};
                    }
                };

                vm.fnGoBackToTableView = function () {
                    vm.selectedGhostObj = {};
                    vm.isGhostDetailsEditable = false;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnUpdateGhostValue = function () {
                    vm.isGhostUpdateCompleted = false;
                    var inputObj = {
                        deviceId: vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.parent.selectedComponent.id,
                        body: {
                            state: {
                                metadata: vm.ghostUpdateObj
                            }
                        }
                    };
                    ComponentFactory.modifyComponentGhost(inputObj)
                        .then(function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isComponentGhostDetailsLoaded = false;
                            vm.fnGetComponentGhost(vm.parent.selectedComponent);
                            amaran.success("Ghost Value Updated");
                        }, function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isComponentGhostDetailsLoaded = false;
                            vm.fnGetComponentGhost(vm.parent.selectedComponent);
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.componentReportedArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGhostComponentsArr = angular.copy(vm.componentReportedArr);
                    } else {
                        vm.selectedGhostComponentsArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.componentReportedArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                };

                vm.isEmptyObject = function (obj) {
                    return Object.keys(obj).length;
                };

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    $timeout.cancel(overLayWebSocketTimeout);
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.componentReportedArr, function (ghostObj) {
                        return ghostObj.name === messageJson.name;
                    });
                    if (index !== -1 && vm.componentReportedArr[index]) {
                        if (messageJson.health) {
                            vm.componentReportedArr[index].health = messageJson.health;
                            var healthObj = ColorService.getHealthColorForLoop(vm.componentReportedArr[index].health);
                            vm.componentReportedArr[index].healthName = healthObj.content;
                            vm.componentReportedArr[index].healthColor = healthObj['background-color'];
                            vm.componentReportedArr[index].textColor = healthObj.color;
                            if (vm.componentReportedArr[index].healthName === vm.componentReportedArr[index].health) {
                                vm.componentReportedArr[index].toolTipName = vm.componentReportedArr[index].health;
                            } else {
                                vm.componentReportedArr[index].toolTipName = vm.componentReportedArr[index].healthName + " "
                                    + vm.componentReportedArr[index].health;
                            }
                        }
                        if (messageJson.value) {
                            vm.componentReportedArr[index].value = messageJson.value;
                            vm.componentReportedArr[index].displayValue = vm.componentReportedArr[index].enabled === false? 'disabled':vm.componentReportedArr[index].value === "__empty" ? "": vm.componentReportedArr[index].value;
                        }
                        vm.componentReportedArr[index].timestamp = Math.floor(Date.now() / 1000);
                        vm.componentReportedArr[index].humanTimestamp = moment.unix(vm.componentReportedArr[index].timestamp).format("MM/DD/YYYY HH:mm:ss");
                        vm.componentReportedArr[index].humanDateLastUpdatedAbsolute = moment.unix(vm.componentReportedArr[index].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                        vm.componentReportedArr[index].humanDateLastUpdatedRelative = moment(vm.componentReportedArr[index].humanTimestamp).fromNow();
                        $timeout(function () {
                            vm.componentReportedArr[index].isProcessing = false;
                        });
                        angular.element($window).triggerHandler('resize');
                        $timeout(function () {
                            vm.fnUpdateAttributeOnWSS(vm.componentReportedArr[index]);
                        });
                    }
                }

                vm.fnUpdateAttributeOnWSS = function (obj) {
                    var recentlyUpdatedIndex = _.findIndex(vm.recentlyUpdatedComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (recentlyUpdatedIndex !== -1) {
                        vm.recentlyUpdatedComponentReportedArr.splice(recentlyUpdatedIndex, 1);
                    }
                    var unhealthyComponentIndex = _.findIndex(vm.unhealthyComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (unhealthyComponentIndex !== -1) {
                        vm.unhealthyComponentReportedArr.splice(unhealthyComponentIndex, 1);
                    }
                    vm.recentlyUpdatedComponentReportedArr.push(obj);
                    if (obj.health > 299) {
                        vm.unhealthyComponentReportedArr.push(obj);
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    });
                };


                vm.fnInitializeWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/attributes/" + vm.parent.selectedComponent.id})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("component ghost websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("component ghost websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnInitializeComponentsWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/components/" + vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-"))})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onComponentsConnectionLost;
                            client.onMessageArrived = onComponentsMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("inventory websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("inventory websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                function onComponentsConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeComponentsWebSockets();
                    }
                }

                function onComponentsMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    $timeout.cancel(inventoryTimer);
                    inventoryTimer = $timeout(function () {
                        var index = _.findIndex(vm.breadcrumbArray, function (breadcrumbObj) {
                            return breadcrumbObj.isClickable && breadcrumbObj.inventorieObj.id === messageJson.id;
                        });
                        if (index !== -1 && vm.breadcrumbArray[index]) {
                            if (messageJson.health) {
                                var healthObj = ColorService.getHealthColorForLoop(messageJson.health);
                                vm.breadcrumbArray[index].healthName = healthObj.content;
                                vm.breadcrumbArray[index].healthColor = healthObj['background-color'];
                                vm.breadcrumbArray[index].textColor = healthObj.color;
                                if (vm.breadcrumbArray[index].healthName === messageJson.health) {
                                    vm.breadcrumbArray[index].inventorieObj.toolTipName = messageJson.health;
                                } else {
                                    vm.breadcrumbArray[index].inventorieObj.toolTipName = vm.breadcrumbArray[index].healthName + " "
                                        + messageJson.health;
                                }
                            }
                        }
                    }, 2000);
                }

                vm.fnEnableDisableAttribute = function (componentGhostObj) {
                    vm.isFooterLoaderActive = true;
                    var inputObj = {};
                    if (angular.isUndefined(componentGhostObj.enabled) || componentGhostObj.enabled === true) {
                        inputObj = {
                            deviceId: vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                            componentId: vm.parent.selectedComponent.id,
                            attributeName: componentGhostObj.name
                        };
                        ComponentFactory.disableComponentAttribute(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    componentGhostObj.enabled = false;
                                    vm.isFooterLoaderActive = false;
                                    amaran.success("The Attribute disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    componentGhostObj.enabled = true;
                                    vm.isFooterLoaderActive = false;
                                    amaran.error("Attribute Disable was unsuccessful")
                                }
                            })
                    } else {
                        inputObj = {
                            deviceId: vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                            componentId: vm.parent.selectedComponent.id,
                            body: componentGhostObj
                        };
                        ComponentFactory.enableComponentAttribute(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    componentGhostObj.enabled = true;
                                    vm.isFooterLoaderActive = false;
                                    amaran.success("The Attribute enable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    componentGhostObj.enabled = false;
                                    vm.isFooterLoaderActive = false;
                                    amaran.error("Attribute enable was unsuccessful")
                                }
                            })
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnManageIssue = function (componentGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeManageIssueTemplateModal/attributeManageIssueTemplateModal.html',
                        size: 'lg',
                        controller: 'attributeManageIssueTemplateModalCtrl as attributeManageIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueType: function () {
                                return "component"
                            },
                            GhostObj: function () {
                                return componentGhostObj;
                            },
                            componentObj: function () {
                                return vm.componentObj;
                            },
                            deviceObj: function () {
                                return vm.deviceObj;
                            },
                            gatewayObj: function () {
                                return vm.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                    }, function () {
                    });
                };

                vm.fnInitComponentGhost = function () {
                    vm.fnInitializeWebSockets();
                    vm.fnInitializeComponentsWebSockets();
                    vm.isShowAllGhostAttributes = false;
                    vm.recentlyUpdatedComponentReportedArr = [];
                    vm.unhealthyComponentReportedArr = [];
                    vm.componentPermissionsObj = PermissionsService.getPermissions("node:component");
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    TabHeight.fnSet();
                    vm.isComponentGhostDetailsLoaded = false;
                    if (vm.parent.selectedComponent.id) {
                        var tempBreadcrumbStr = vm.parent.selectedComponent.index;
                        vm.tempBreadcrumbArr = tempBreadcrumbStr.split("#");
                        var tempArr = [];
                        var tempString = '';
                        _.forEach(vm.tempBreadcrumbArr, function (value) {
                            var tempObj = {};
                            tempString = tempString === '' ? value : tempString + "#" + value;
                            var isValueFind = _.find(vm.parent.inventoriesArr, {'index': tempString});
                            if (isValueFind && isValueFind.enabled === true) {
                                tempObj.isClickable = true;
                                tempObj.displayName = isValueFind.name && isValueFind.name !== ' ' ? isValueFind.name : value.replace(':', ' ');
                                tempObj.inventorieObj = isValueFind;
                                var healthObj = ColorService.getHealthColorForLoop(isValueFind.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                            } else {
                                tempObj.isClickable = false;
                                tempObj.displayName = value.replace(':', ' ');
                                tempObj.inventorieObj = {};
                            }
                            tempArr.push(tempObj);
                        });
                        vm.breadcrumbArray = tempArr;
                        vm.fnGetComponentGhost(vm.parent.selectedComponent);
                    }
                };

                $window.dispatchEvent(new Event("resize"));

                vm.fnGoBackToInventory = function () {
                    $scope.$emit("GoBackToInventory");
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.repeatativeComponentGhostTimer);
                    if (client) {
                        client.disconnect();
                    }
                });

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnShowAllGhostAttributes = function () {
                    vm.isShowAllGhostAttributes = true;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.fnOpenModifyGhostAttributeModal = function () {
                    var inputObj = {
                        deviceId: vm.parent.selectedComponent.id.substring(0, vm.parent.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.parent.selectedComponent.id,
                        body: {}
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/modifyGhostAttribute/modifyGhostAttribute.html',
                        size: 'md',
                        controller: 'modifyGhostAttributeCtrl as modifyGhostAttribute',
                        resolve: {
                            selectedGhostObj: function () {
                                return angular.copy(vm.selectedGhostObj);
                            },
                            ghostType: function () {
                                return 'Component'
                            },
                            requiredInputObj: function () {
                                return inputObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        vm.selectedGhostObj = {};
                    }, function () {
                        vm.selectedGhostObj = {};
                    });
                };

                vm.fnInitAttributeAnalytics = function (count) {
                    vm.isAttributeAnalyticsDataFetch = false;
                    if (count < vm.componentReportedArr.length) {
                        vm.fnGetAttributeAnalyticsValue(count);
                    } else {
                        $timeout(function () {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        });
                    }
                };

                vm.fnGetAttributeAnalyticsValue = function (count) {
                    if (vm.componentReportedArr[count].health > 299) {
                        var duration = moment.duration(vm.currentTime.diff(vm.componentReportedArr[count].timestamp));
                        var minutes = duration.asMinutes();
                        if (minutes < 10) {
                            var inputObj = {
                                dataSets: ["ATOMIC"],
                                nodeId: vm.componentObj.id,
                                timeRange: {
                                    relative: {
                                        start: "10m"
                                    }
                                },
                                attributeQuery: {
                                    attributeName: vm.componentReportedArr[count].name,
                                    queryType: "VALUE"
                                }
                            };
                            var headers = {
                                'Content-Type': 'application/json',
                                'x-pre-api-version': '4',
                                'authorization': 'Bearer ' + $cookies.get('phoenix')
                            };
                            var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                            $http({
                                method: "POST",
                                url: apiURL,
                                responseType: 'application/json',
                                headers: headers,
                                data: inputObj
                            }).then(function (response) {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                if (response && response.status && response.data &&
                                    !response.status.toString().startsWith('20')) {
                                    vm.analyticsValueData = {};
                                    amaran.error(response.data.message);
                                } else {
                                    if(response && response.data && response.data.data){
                                        vm.analyticsValueData = response.data.data;
                                    }else{
                                        vm.analyticsValueData = {};
                                    }
                                    if (response && response.data && response.data.meta) {
                                        startTime = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                        endTime = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                    }
                                }
                                if (vm.analyticsValueData && vm.analyticsValueData.ATOMIC && vm.analyticsValueData.ATOMIC.points) {
                                    var attributeAnalyticsb64String = vm.analyticsValueData.ATOMIC.points;
                                    var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                                    var tempAggregateHealthArr = analyticsService.getAttributeValueData(attributeAnalyticsCSVString);
                                    if (tempAggregateHealthArr.attributeValueData.length) {
                                        var analyticsAttrValueArr = [];
                                        var valuesArr = tempAggregateHealthArr.attributeValuesArr.sort(function (a, b) {
                                            return a - b;
                                        });
                                        _.forEach(tempAggregateHealthArr.attributeValueData, function (obj) {
                                            analyticsAttrValueArr.push({
                                                x: obj.x,
                                                y: valuesArr.indexOf(obj.y),
                                                name: obj.y
                                            })
                                        });
                                        vm.componentReportedArr[count].inlineChartData = analyticsAttrValueArr;
                                    } else {
                                        vm.componentReportedArr[count].inlineChartData = [{
                                            x: startTime,
                                            y: 0,
                                            name: vm.componentReportedArr[count].value
                                        }, {
                                            x: endTime,
                                            y: 0,
                                            name: vm.componentReportedArr[count].value
                                        }];
                                    }
                                    count++;
                                    if (count < vm.componentReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                } else {
                                    vm.componentReportedArr[count].inlineChartData = [{
                                        x: startTime,
                                        y: 0,
                                        name: vm.componentReportedArr[count].value
                                    }, {
                                        x: endTime,
                                        y: 0,
                                        name: vm.componentReportedArr[count].value
                                    }];
                                    count++;
                                    if (count < vm.componentReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                }
                            }, function error() {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                vm.componentReportedArr[count].inlineChartData = [{
                                    x: startTime,
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }, {
                                    x: endTime,
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }];
                                count++;
                                if (count < vm.componentReportedArr.length) {
                                    vm.fnGetAttributeAnalyticsValue(count);
                                } else {
                                    //done
                                    vm.isAttributeAnalyticsDataFetch = true;
                                    $timeout(function () {
                                        vm.fnSetTreeHeight();
                                    })
                                }
                            });
                        } else {
                            vm.componentReportedArr[count].inlineChartData = [
                                {
                                    x: moment().subtract(10, 'minutes').valueOf(),
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }, {
                                    x: moment().valueOf(),
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }];
                            count++;
                            if (count < vm.componentReportedArr.length) {
                                vm.fnGetAttributeAnalyticsValue(count);
                            } else {
                                //done
                                vm.isAttributeAnalyticsDataFetch = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                })
                            }
                        }
                    } else {
                        vm.componentReportedArr[count].inlineChartData = [];
                        count++;
                        if (count < vm.componentReportedArr.length) {
                            vm.fnGetAttributeAnalyticsValue(count);
                        } else {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        }
                    }
                };

                vm.fnOpenAttributeStatistics = function (selectedAttribute) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html',
                        size: 'lg',
                        controller: 'attributeStatisticsModalCtrl as attributeStatistics',
                        resolve: {
                            selectedAttribute: function () {
                                return selectedAttribute;
                            },
                            selectedComponent: function () {
                                return vm.componentObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnRenameAttribute = function(componentGhostObj){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeRenameModal/attributeRenameModal.html',
                        size: 'md',
                        controller: 'attributeRenameModalCtrl as attributeRenameModal',
                        resolve: {
                            selectedGhostObj: function () {
                                return _.cloneDeepWith(componentGhostObj);
                            },
                            ghostType: function () {
                                return 'Component'
                            },
                            id: function () {
                                return vm.componentObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (newName) {
                        componentGhostObj.displayName = newName;
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        },1000)
                    }, function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        },1000)
                    });
                };

                vm.fnGetComponent = function (inventoryObj) {
                    vm.isComponentGhostDetailsLoaded = false;
                    var inputObj = {
                        deviceId: inventoryObj.id.substring(0, inventoryObj.id.lastIndexOf("-")),
                        componentId: inventoryObj.id
                    };
                    ComponentFactory.getComponent(inputObj)
                        .then(function (response) {
                            $timeout(function () {
                                $scope.$emit("ComponentSelected", response);
                                $scope.$emit("getInventorySelected", vm.parent.inventoriesArr);
                                vm.fnInitComponentGhost();
                            });
                        })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ComponentDetailsCtrl',
            function ($rootScope, $scope, $timeout, $window, amaran, IconService, ColorService, ComponentFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                vm.isComponentDetailsEditable = false;
                vm.isComponentUpdateCompleted = true;

                vm.componentObj = angular.copy(vm.parent.selectedComponent);

                $window.dispatchEvent(new Event("resize"));

                vm.fnGetHealthColor = function (health, componentObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    componentObj.healthName = healthObj.content;
                    if(componentObj.healthName === health) {
                        componentObj.toolTipName = health;
                    } else {
                        componentObj.toolTipName = componentObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function(phase){
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnResetDetails = function () {
                    vm.componentObj = angular.copy(vm.parent.selectedComponent);
                    vm.isComponentDetailsEditable = false
                };

                vm.fnMakeComponentDetailsEditable = function () {
                    vm.isComponentDetailsEditable = true;
                };

                vm.fnUpdateComponentDetails = function () {
                    vm.isComponentUpdateCompleted = false;
                    var inputObj = {
                        deviceId : vm.componentObj.id.substring(0, vm.componentObj.id.lastIndexOf("-")),
                        componentId : vm.componentObj.id,
                        body: {
                            name: vm.componentObj.name
                        }
                    };
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function (response) {
                            $rootScope.$broadcast("ComponentDetailsUpdated", response);
                            amaran.success("Component Details Updated Successfully");
                            vm.componentObj = angular.copy(response);
                            vm.isComponentUpdateCompleted = true;
                            vm.isComponentDetailsEditable = false;
                        },function () {
                            amaran.error("Component Details update was unsuccessful");
                            vm.componentObj = angular.copy(vm.parent.selectedComponent);
                            vm.isComponentUpdateCompleted = true;
                            vm.isComponentDetailsEditable = false;
                        })
                };

                vm.fnGoBackToInventory = function () {
                    $scope.$emit("GoBackToInventory");
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ClusterTopologyCtrl',
            function ($scope, $window, $timeout, PermissionsService, ClusterFactory) {
                var vm = this;

                vm.parent = $scope.$parent;
                vm.isClusterTopologyDataLoaded = false;
                vm.clusterDevicesArr = [];
                vm.clusterGatewaysArr = [];
                vm.relationshipObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetClusterDevices = function (clusterId) {
                    var inputObj = {
                        clusterId: clusterId,
                        perPage: 0
                    };
                    ClusterFactory.getClusterDevices(inputObj)
                        .then(function (response) {
                            _.forEach(response, function (responseObj) {
                                var typeObj = _.find(vm.parent.typesArr, {'id': responseObj.typeId});
                                responseObj.hasComponents = !!(typeObj && typeObj.hasComponents);
                                responseObj.type = 'device';
                            });
                            vm.clusterDevicesArr = response;
                            vm.fnCreateRelationship();
                        }, function () {
                            vm.clusterDevicesArr = [];
                            vm.fnCreateRelationship();
                        })
                };

                vm.fnGetClusterGateways = function (clusterId) {
                    var inputObj = {
                        clusterId: clusterId,
                        perPage: 0
                    };
                    ClusterFactory.getClusterGateways(inputObj)
                        .then(function (response) {
                            _.forEach(response, function (responseObj) {
                                responseObj.type = 'gateway';
                            });
                            vm.clusterGatewaysArr = response;
                            if (vm.devicePermissionObj.List) {
                                vm.fnGetClusterDevices(vm.parent.clusterObj.id);
                            } else {
                                vm.fnCreateRelationship();
                            }
                        }, function () {
                            vm.clusterGatewaysArr = [];
                            if (vm.devicePermissionObj.List) {
                                vm.fnGetClusterDevices(vm.parent.clusterObj.id);
                            } else {
                                vm.fnCreateRelationship();
                            }
                        })
                };

                vm.fnCreateRelationship = function () {
                    vm.relationshipObj = vm.parent.clusterObj;
                    vm.relationshipObj.type = 'cluster';
                    vm.relationshipObj.children = [];
                    if (vm.clusterGatewaysArr.length) {
                        var uniqueDeviceArr = [];
                        _.forEach(vm.clusterDevicesArr, function (clusterDeviceObj) {
                            var index = _.findIndex(vm.clusterGatewaysArr, {id: clusterDeviceObj.gatewayId});
                            if (index !== -1) {
                                if (!vm.clusterGatewaysArr[index].children) {
                                    vm.clusterGatewaysArr[index].children = [];
                                }
                                vm.clusterGatewaysArr[index].children.push(clusterDeviceObj);
                            } else {
                                uniqueDeviceArr.push(clusterDeviceObj);
                            }
                        });
                        vm.relationshipObj.children.push.apply(vm.relationshipObj.children, vm.clusterGatewaysArr);
                        vm.relationshipObj.children.push.apply(vm.relationshipObj.children, uniqueDeviceArr);
                    } else {
                        vm.relationshipObj.children = vm.clusterDevicesArr;
                    }
                    vm.isClusterTopologyDataLoaded = true;
                };

                vm.fnInitClusterTopology = function () {
                    vm.fnSetTabHeight();
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if (vm.gatewayPermissionObj.List) {
                        vm.fnGetClusterGateways(vm.parent.clusterObj.id);
                    } else if (vm.devicePermissionObj.List) {
                        vm.fnGetClusterDevices(vm.parent.clusterObj.id);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('clusterSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, DB, PermissionsService, TabHeight, ClusterFactory, $uibModal) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.clusterSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnInjectFunction = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html',
                        size: 'lg',
                        controller: 'supplementFunctionModalCtrl as supplementModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (supplementalArr) {
                        _.forEach(supplementalArr, function (supplementalObj) {
                            if (supplementalObj.key && supplementalObj.value && supplementalObj.key.length && supplementalObj.value.length) {
                                var isFind = _.find(vm.supplementalKVPArr, {key: supplementalObj.key});
                                if (!isFind) {
                                    vm.supplementalKVPArr.push(supplementalObj);
                                } else {
                                    isFind.value = supplementalObj.value;
                                }
                            }
                        });
                        _.remove(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            return supplementalKVPObj.key === '' && supplementalKVPObj.value === '';
                        });
                        if (!vm.supplementalKVPArr.length) {
                            vm.supplementalKVPArr = [{key: '', value: ''}];
                        }
                    }, function () {
                    });

                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.getClusterData = function (clusterObj) {
                    var inputObj = {
                        clusterId: clusterObj.id
                    };
                    ClusterFactory.getCluster(inputObj)
                        .then(function (response) {
                            vm.clusterSupplementalObj = response.data ? angular.fromJson(response.data) : {};
                            vm.clusterSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.clusterSupplementalObj, true) : vm.clusterSupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.clusterSupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.clusterSupplementalObj)) {
                                angular.forEach(vm.clusterSupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value[0]
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isClusterSupplementalDetailsLoaded = true;
                        })
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isSupplementalEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isSupplementalEditable = false;
                        vm.clusterSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.clusterSupplementalObj = angular.toJson(vm.clusterSupplementalObj, true);
                    } else {
                        vm.clusterSupplementalObj = angular.fromJson(vm.clusterSupplementalObj);
                        //vm.resetSupplementalObj = angular.copy(vm.clusterSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.clusterSupplementalObj)) {
                            angular.forEach(vm.clusterSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value[0]
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                        vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnSaveClusterData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.clusterObj.data = {};
                    var inputObj = {
                        clusterId: vm.parent.clusterObj.id,
                        body: {}
                    };
                    if (!vm.parent.clusterObj.data) {
                        vm.parent.clusterObj.data = {};
                    }
                    angular.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                        if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                            vm.parent.clusterObj.data[kpPairObj.key] = ["" + kpPairObj.value + ""];
                        }
                    });

                    inputObj.body = vm.parent.clusterObj.data;
                    ClusterFactory.updateClusterData(inputObj)
                        .then(function () {
                            amaran.success("Data added to cluster successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitClusterSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitClusterSupplemental();
                        })

                };

                vm.fnEditClusterData = function (obj) {
                    vm.isSupplementalEditableUpdate = true;
                    var inputObj = {
                        clusterId: vm.parent.clusterObj.id,
                        body: angular.fromJson(obj)
                    };
                    ClusterFactory.updateClusterData(inputObj)
                        .then(function () {
                            amaran.success("Data edited successfully");
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitClusterSupplemental();
                        }, function () {
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitClusterSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if(isCalledEditMode){
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.clusterSupplementalObj = angular.copy(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.clusterSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.clusterSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value[0]
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                };
                vm.fnInitClusterSupplemental = function () {
                    vm.clusterPermissionObj = PermissionsService.getPermissions("node:cluster");
                    TabHeight.fnSet();
                    vm.isClusterSupplementalDetailsLoaded = false;
                    if (vm.parent.clusterObj.id) {
                        vm.getClusterData(vm.parent.clusterObj);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ClusterGatewayCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, Paho, ColorService, PermissionsService,
                      GhostService, DB, swal, microSpinner, TabHeight, postActionModelMessage, postActionModelIcon, amaran, ClusterFactory,IconService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isClusterGatewayDetailsLoaded = false;
                vm.gatewayClustersArr = [];
                vm.filter = "$";
                vm.search = {$: ''};

                vm.isAllClusterGatewaysChecked = false;
                vm.selectedClusterGatewaysArr = [];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element(".viewClusterSearchBar")[0]) && angular.isDefined(angular.element("thead")[0])) {
                        var totalList = angular.element(".content-main")[0].offsetHeight;
                        var searchList = angular.element(".viewClusterSearchBar")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightList = totalList - (searchList + header + 10);
                        angular.element("#ClusterGateways").css('height', finalHeightList + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetClusterGateways = function (clusterObj) {
                    var inputObj = {
                        clusterId: clusterObj.id
                    };
                    ClusterFactory.getClusterGateways(inputObj)
                        .then(function (response) {
                            TabHeight.fnSet();
                            vm.clusterGatewaysArr = response;
                            vm.isClusterGatewayDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetHealthColor = function (health, clusterGatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    clusterGatewayObj.healthName = healthObj.content;
                    if (clusterGatewayObj.healthName === health) {
                        clusterGatewayObj.toolTipName = health;
                    } else {
                        clusterGatewayObj.toolTipName = clusterGatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnCheckUncheckClusterGatewaysAll = function () {
                    angular.forEach(vm.clusterGatewaysArr, function (obj) {
                        obj.isCheck = vm.isAllClusterGatewaysChecked;
                    });
                    if (vm.isAllClusterGatewaysChecked) {
                        vm.selectedClusterGatewaysArr = angular.copy(vm.clusterGatewaysArr);
                    } else {
                        vm.selectedClusterGatewaysArr = [];
                    }
                };

                vm.fnCheckUncheckClusterGatewaysHeader = function (gatewayObj) {
                    vm.isAllClusterGatewaysChecked = true;
                    angular.forEach(vm.clusterGatewaysArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllClusterGatewaysChecked = false;
                        }
                    });

                    /* Toggle push in selected gateway array*/
                    var isValueFind = _.find(vm.selectedClusterGatewaysArr, {'id': gatewayObj.id});
                    if (!isValueFind) {
                        vm.selectedClusterGatewaysArr.push(gatewayObj)
                    } else {
                        _.remove(vm.selectedClusterGatewaysArr, function (obj) {
                            return gatewayObj.id === obj.id;
                        });
                    }
                };

                vm.fnDeleteGroupGateways = function (selectedClusterGatewaysArr) {
                    swal({
                            title: "Remove all selected Gateways from Cluster?",
                            text: "Gateways will be permanently removed for the Cluster.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedClusterGatewaysArr, function (selectedGateway) {
                                    var inputObj = {
                                        clusterId: vm.parent.clusterObj.id,
                                        gatewayId: selectedGateway.id
                                    };

                                    promises.push(ClusterFactory.removeGatewayFromCluster(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedClusterGatewaysArr = [];
                                        vm.fnGetClusterGateways(vm.parent.clusterObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnAddNewGateway = function(){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/cluster/modals/gatewayElementList/gatewayElementListModel.html',
                        size: 'lg',
                        windowClass: "modal-height100",
                        controller: 'gatewayElementListModalCtrl as gatewayElemList',
                        resolve: {
                            isCallFromGatewaysTab: function () {
                                return true;
                            },
                            clusterId: function () {
                                return vm.parent.clusterObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (message) {
                        if(message === 'Gateway Added'){
                            vm.isClusterGatewayDetailsLoaded = false;
                            if (vm.parent.clusterObj.id) {
                                vm.fnGetClusterGateways(vm.parent.clusterObj);
                            }
                        }
                    }, function () {
                    });
                };

                vm.fnInitClusterGateways = function () {
                    vm.clusterPermissionObj = PermissionsService.getPermissions("node:cluster");
                    vm.isClusterGatewayDetailsLoaded = false;
                    if (vm.parent.clusterObj.id) {
                        vm.fnGetClusterGateways(vm.parent.clusterObj);
                    }
                    TabHeight.fnSet();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ClusterDeviceCtrl',
            function ($scope, $window, $http, $timeout, $state, $stateParams, $q, $uibModal, Paho, ColorService, PermissionsService,
                      GhostService, DB, swal, microSpinner, TabHeight, postActionModelMessage, postActionModelIcon, amaran, ClusterFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isClusterDeviceDetailsLoaded = false;
                vm.deviceClustersArr = [];
                vm.filter = "$";
                vm.search = {$: ''};

                vm.isAllClusterDevicesChecked = false;
                vm.selectedClusterDevicesArr = [];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element(".viewClusterSearchBar")[0]) && angular.isDefined(angular.element("thead")[0])) {
                        var totalList = angular.element(".content-main")[0].offsetHeight;
                        var searchList = angular.element(".viewClusterSearchBar")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightList = totalList - (searchList + header + 10);
                        angular.element("#ClusterDevices").css('height', finalHeightList + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetClusterDevices = function (clusterObj) {
                    var inputObj = {
                        clusterId: clusterObj.id
                    };
                    ClusterFactory.getClusterDevices(inputObj)
                        .then(function (response) {
                            TabHeight.fnSet();
                            vm.clusterDevicesArr = response;
                            vm.isClusterDeviceDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            });
                        })
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetHealthColor = function (health, clusterDeviceObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    clusterDeviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnCheckUncheckClusterDevicesAll = function () {
                    angular.forEach(vm.clusterDevicesArr, function (obj) {
                        obj.isCheck = vm.isAllClusterDevicesChecked;
                    });
                    if (vm.isAllClusterDevicesChecked) {
                        vm.selectedClusterDevicesArr = angular.copy(vm.clusterDevicesArr);
                    } else {
                        vm.selectedClusterDevicesArr = [];
                    }
                };

                vm.fnCheckUncheckClusterDevicesHeader = function (deviceObj) {
                    vm.isAllClusterDevicesChecked = true;
                    angular.forEach(vm.clusterDevicesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllClusterDevicesChecked = false;
                        }
                    });

                    /* Toggle push in selected device array*/
                    var isValueFind = _.find(vm.selectedClusterDevicesArr, {'id': deviceObj.id});
                    if (!isValueFind) {
                        vm.selectedClusterDevicesArr.push(deviceObj)
                    } else {
                        _.remove(vm.selectedClusterDevicesArr, function (obj) {
                            return deviceObj.id === obj.id;
                        });
                    }
                };

                vm.fnDeleteGroupDevices = function (selectedClusterDevicesArr) {
                    swal({
                            title: "Remove all selected Devices from Cluster?",
                            text: "Devices will be permanently removed for the Cluster.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedClusterDevicesArr, function (selectedDevice) {
                                    var inputObj = {
                                        clusterId: vm.parent.clusterObj.id,
                                        deviceId: selectedDevice.id
                                    };

                                    promises.push(ClusterFactory.removeDeviceFromCluster(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedClusterDevicesArr = [];
                                        vm.fnGetClusterDevices(vm.parent.clusterObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnAddNewDevice = function(){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/cluster/modals/elementList/elementListModal.html',
                        size: 'lg',
                        windowClass: "modal-height100",
                        controller: 'elementListModalCtrl as elemList',
                        resolve: {
                            isCallFromDevicesTab: function () {
                                return true;
                            },
                            clusterId: function () {
                                return vm.parent.clusterObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (message) {
                        if(message === 'Device Added'){
                            vm.isClusterDeviceDetailsLoaded = false;
                            if (vm.parent.clusterObj.id) {
                                vm.fnGetClusterDevices(vm.parent.clusterObj);
                            }
                        }
                    }, function () {
                    });
                };

                vm.fnInitClusterDevices = function () {
                    vm.clusterPermissionObj = PermissionsService.getPermissions("node:cluster");
                    vm.isClusterDeviceDetailsLoaded = false;
                    if (vm.parent.clusterObj.id) {
                        vm.fnGetClusterDevices(vm.parent.clusterObj);
                    }
                    TabHeight.fnSet();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmIssuesCtrl',
            function ($scope, $timeout, $window, amaran, $state, QueryFactory, ApiListService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isIssueDataLoading = true;
                vm.issuesArr = [];
                var getCurrentURL = ApiListService.getCurrentURL();
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var total = angular.element(".content-main")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeight = total - (header + 20);
                        angular.element("#alarmIssueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAttributes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            vm.issuesArr = res.data;
                            vm.isIssueDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        })
                }

                vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.issue', {selectedId: issueObj.id});
                }

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL+ "/#/tracker/issue?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                }

                vm.fnInitAlarmIssues = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    });
                    vm.isIssueDataLoading = true;
                    var tempIdString = "";
                    _.forEach(vm.parent.alarmObj.issueIds, function (id, index) {
                        if (index === vm.parent.alarmObj.issueIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    var sql = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_issues where data->>\'id\' IN (" + tempIdString + ");"
                    vm.fnGetAttributes({"sql": sql});
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmAttributesCtrl',
            function ($scope, $timeout, $window, $state, $log, DB, amaran, swal, TabHeight, $uibModal, moment, copyService, PermissionsService, PaginationQueryService, NodeAttributesFactory, WidgetsListService, BatchFactory, microSpinner, ColorService, NodeFactory, QueryFactory, Highcharts, postActionModelMessage, postActionModelIcon) {
                var vm = this;
                var timezoneName = "";
                vm.parent = $scope.$parent;
                vm.isFullWidthDevice = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });
                vm.isNodeDetailsLoaded = false;
                vm.alarmObj = {};
                vm.resetalarmObj = {};
                vm.initNode = true;
                vm.chartData = [];
                vm.splineChartData = [];
                vm.selectedChartType = 'spline';
                vm.filter = "$";
                vm.attributeSearch = {$: ''};
                vm.selectedChartFor = 'Value';
                vm.selectedRange = "";
                vm.selectedChartData = [];
                vm.isShowNodeConnection = false;
                vm.isShowPlotNodeHealth = false;
                var connectionArr = [
                    {
                        name: "Connected",
                        value: 1,
                        color: '#218838'
                    },
                    {
                        name: "Disconnected",
                        value: -1,
                        color: '#C82333'
                    }
                ];
                vm.attributesList = [];
                vm.attributesStringValueArr = [];
                vm.tempAxesData = [
                    { // Primary yAxis
                        title: {
                            text: 'Values'
                        }
                    },
                    { // Primary yAxis
                        title: {
                            text: 'Health'
                        },
                        opposite: true,
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Connection'
                        },
                        opposite: true,
                        labels: {
                            formatter: function () {
                                return this.value === -1 ? 'Disconnected' : this.value // eslint-disable-line
                            }
                        },
                        categories: ['', 'Connected'],
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Attribute String Values'
                        },
                        opposite: true,
                        categories: vm.attributesStringValueArr,
                        visible: true
                    }
                ];
                vm.tempChartsData = [];
                vm.selectedHeatmapChartAttrObj = '';
                vm.axisArr = [
                    {
                        title: 'Minutes',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
                    },
                    {
                        title: 'Hours',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                    },
                    {
                        title: 'Days',
                        categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                    },
                    {
                        title: 'Weeks',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54"]
                    },
                    {
                        title: 'Months',
                        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    }
                ];
                vm.mathFunction = [
                    {
                        title: 'MIN'
                    },
                    {
                        title: 'MAX'
                    },
                    {
                        title: 'AVG'
                    }
                ];
                vm.selectedMathFunction = 'MAX';
                vm.selectedXAxis = vm.axisArr[2];
                vm.selectedYAxis = vm.axisArr[0];
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "This Node",
                        name: 'nodeId',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".data->>\'nodeId\' = '" + vm.parent.alarmObj.nodeId + "'",
                        localSearchValue: "obj.nodeId === '" + vm.parent.alarmObj.nodeId + "'"
                    }, {
                        displayName: "Node ID",
                        name: "nodeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "ECU ID",
                        name: "ecuId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Attribute ID",
                        name: "id",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'},
                    {name: 'receivedAt', displayName: 'Value Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.defaultAttributeFilterArr = [
                    {
                        displaySearchText: "",
                        displaySelectedField: "This Node",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.nodeId === '" + vm.parent.alarmObj.nodeId + "'",
                        searchText: "",
                        selectedField: "nodeId",
                        sqlValue: "node_attributes.data->>\'nodeId\' = '" + vm.parent.alarmObj.nodeId + "'"
                    }, {
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        selectedField: "id",
                        selectedConnector: "and",
                        displaySelectedField: "Attribute ID",
                        selectedFilter: {
                            operatorName: "=",
                            operator: "="
                        },
                        searchText: vm.parent.alarmObj.id,
                        displaySearchText: vm.parent.alarmObj.id,
                        sqlValue: "node_attributes.data->>\'id\' = '" + vm.parent.alarmObj.id + "'"
                    }
                ];
                vm.defaultAttributeSortString = 'name asc';
                vm.perPage = 50;
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isShowPaginationContainer = true;
                vm.selectedPieChartData = {};
                vm.pieChartAttributeList = [];
                vm.heatmapChartAttributeList = [];
                vm.heatmapAttributeStringValueArr = [];
                vm.resetAttributeLists = [];
                var loaderModalInstance = "";
                vm.selectedAttribute = {};
                vm.plotableArr = [
                    {
                        name: 'Actual Value',
                        sortName: '[AV]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    },
                    {
                        name: 'Forecast Value',
                        sortName: '[FV]',
                        dataType: 'Forecast',
                        chartType: 'Value',
                        attrKey: 'isSelectedForecast'
                    },
                    {
                        name: 'Forecast Health',
                        sortName: '[FH]',
                        dataType: 'Forecast',
                        chartType: 'Health',
                        attrKey: 'isSelectedForecastHealthPlot'
                    },
                    {
                        name: 'Value Anomaly',
                        sortName: '[VA]',
                        dataType: 'Anomaly',
                        chartType: 'Value',
                        attrKey: 'isSelectedAnomaly'
                    },
                    {
                        name: 'Health Anomaly',
                        sortName: '[HA]',
                        dataType: 'Anomaly',
                        chartType: 'Health',
                        attrKey: 'isSelectedAnomalyHealthPlot'
                    }
                ];
                vm.selectedAttrKeyArr = [
                    {
                        name: 'Name',
                        key: 'name'
                    },
                    {
                        name: 'Value',
                        key: 'value'
                    },
                    {
                        name: 'Units',
                        key: 'read'
                    },
                    {
                        name: 'Health',
                        key: 'health'
                    },
                    {
                        name: 'Ref',
                        key: 'reference'
                    },
                    {
                        name: 'ID',
                        key: 'id'
                    },
                    {
                        name: 'Type',
                        key: 'type'
                    },
                    {
                        name: 'Node',
                        key: 'nodeName'
                    },
                    {
                        name: 'Alarm',
                        key: 'id'
                    }
                ];
                vm.granularityArr = [
                    {
                        name: '1 minute',
                        config: {
                            title: 'MINUTES',
                            value: 1,
                            time: 60000
                        }
                    },
                    {
                        name: '2 minute',
                        config: {
                            title: 'MINUTES',
                            value: 2,
                            time: 60000
                        }
                    },
                    {
                        name: '5 minute',
                        config: {
                            title: 'MINUTES',
                            value: 5,
                            time: 60000
                        }
                    },
                    {
                        name: '15 minute',
                        config: {
                            title: 'MINUTES',
                            value: 15,
                            time: 60000
                        }
                    },
                    {
                        name: '30 minute',
                        config: {
                            title: 'MINUTES',
                            value: 30,
                            time: 60000
                        }
                    },
                    {
                        name: '1 hour',
                        config: {
                            title: 'HOURS',
                            value: 1,
                            time: 3600000
                        }
                    },
                    {
                        name: '3 hour',
                        config: {
                            title: 'HOURS',
                            value: 3,
                            time: 3600000
                        }
                    },
                    {
                        name: '6 hour',
                        config: {
                            title: 'HOURS',
                            value: 6,
                            time: 3600000
                        }
                    },
                    {
                        name: '1 day',
                        config: {
                            title: 'DAYS',
                            value: 1,
                            time: 86400000
                        }
                    }
                ];
                vm.selectedGranularity = vm.granularityArr[1];
                vm.chartUpdateTimeout = '';
                vm.selectedAutoUpdateType = "Static";

                vm.attributeNameContextMenu = function (attributeObj) {
                    var tempContextMenu = [{
                        text: 'Edit Name',
                        click: function () {
                            vm.fnEditAttributeName(attributeObj);
                        }
                    }];
                    if (attributeObj.mode === 'RW' || attributeObj.mode === 'rw') {
                        tempContextMenu.push({
                            text: 'Edit Value',
                            click: function () {
                                vm.fnEditAttributeValue(attributeObj);
                            }
                        });
                    }
                    if (vm.permissionObj.ENABLE_ATTRIBUTE || vm.permissionObj.DISABLE_ATTRIBUTE) {
                        if (attributeObj.operation && attributeObj.operation === 'DISABLED') {
                            tempContextMenu.push({
                                text: 'Enable Attribute',
                                click: function () {
                                    vm.fnEnableAttribute(attributeObj);
                                }
                            });
                        } else {
                            tempContextMenu.push({
                                text: 'Disable Attribute',
                                click: function () {
                                    vm.fnDisableAttribute(attributeObj);
                                }
                            });
                        }
                    }
                    if (attributeObj.syncState === 'NOT_SYNCHRONIZED') {
                        tempContextMenu.push({
                            text: 'Synchronize',
                            click: function () {
                                vm.fnDeployAttribute(attributeObj);
                            }
                        });
                    }
                    return tempContextMenu;
                };

                vm.attributeValueContextMenu = function (attributeObj) {
                    return [{
                        text: 'Edit Value',
                        click: function () {
                            vm.fnEditAttributeValue(attributeObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Parse JSONB data if it's a string
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle boolean fields
                                if (angular.isDefined(parsedData.value)) {
                                    if (parsedData.valueType === 'BOOLEAN') {
                                        parsedData.value = parsedData.value === "true" || parsedData.value === true;
                                    } else if (parsedData.valueType === 'FLOAT') {
                                        parsedData.value = parseFloat(parsedData.value);
                                    }
                                }

                                // Handle mode field
                                if (angular.isDefined(parsedData.mode)) {
                                    parsedData.mode = parsedData.mode.toUpperCase();
                                }

                                // Handle timestamps
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Handle read/write permissions
                                if (parsedData.read) {
                                    parsedData.read = angular.fromJson(parsedData.read);
                                }
                                if (parsedData.write) {
                                    parsedData.write = angular.fromJson(parsedData.write);
                                }

                                // Handle attribute reference
                                if (parsedData.reference) {
                                    parsedData.reference = parsedData.reference.toString();
                                }

                                // Handle health data
                                if (parsedData.health) {
                                    parsedData.health = parseInt(parsedData.health);
                                }
                                if (parsedData.healthLastChangedAt) {
                                    parsedData.healthLastChangedAt = parseInt(parsedData.healthLastChangedAt);
                                }

                                // Handle alarm status
                                if (parsedData.reference && parsedData.reference.endsWith('!')) {
                                    parsedData.hasAlarm = true;
                                }

                                // Merge parsed data with item
                                return angular.extend({}, parsedItem, parsedData);

                            } catch (e) {
                                $log.error('Error parsing alarm attribute data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }


                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    // Initialize sorting
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }

                    // Handle filters and tags
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }

                    // Set query params
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    vm.isAttributesLoading = true;

                    // Build sort string
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }

                    // Generate SQL query
                    var sqlString = '';
                    if (sortString !== '') {
                        // Query with specific sort
                        sqlString = 'WITH attributes AS ( ' +
                            'SELECT node_attributes.*, ' +
                            'CAST(node_attributes.data->>\'' + sortValue + '\' AS text) AS rt ' +
                            'FROM node_attributes AS node_attributes';

                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY rt ' + sortType + ' LIMIT ' + vm.perPage + ' ),';

                        // Get total count
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";

                        // Final select with joins
                        sqlString += 'SELECT ' +
                            'att.*, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'rows.qty AS totalItems, ' +
                            'CASE ' +
                            '   WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ' +
                            '   ELSE node_nodes.data->>\'name\' ' +
                            'END AS nodeName, ' +
                            'CASE ' +
                            '   WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.id ' +
                            '   ELSE node_nodes.data->>\'rootNodeId\' ' +
                            'END AS rootNodeId, ' +
                            'rt ' +
                            'FROM attributes AS att ' +
                            'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.id ' +
                            'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.id, ' +
                            'rows';
                    } else {
                        // Query without specific sort
                        sqlString = 'WITH attributes AS ( ' +
                            'SELECT node_attributes.*, ' +
                            'node_attributes.data->>\'_id\' AS rt ' +
                            'FROM node_attributes AS node_attributes';

                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';

                        // Get total count
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";

                        // Final select with joins
                        sqlString += 'SELECT ' +
                            'att.*, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'rows.qty AS totalItems, ' +
                            'CASE ' +
                            '   WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ' +
                            '   ELSE node_nodes.data->>\'name\' ' +
                            'END AS nodeName, ' +
                            'CASE ' +
                            '   WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' THEN node_ecus.id ' +
                            '   ELSE node_nodes.data->>\'rootNodeId\' ' +
                            'END AS rootNodeId, ' +
                            'rt ' +
                            'FROM attributes AS att ' +
                            'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.id ' +
                            'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.id, ' +
                            'rows';
                    }

                    var input = {
                        sql: sqlString
                    };
                    vm.isShowPaginationContainer = true;
                    vm.fnGetAttributes(input, true);
                };

                vm.fnGetAttributes = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var parsedData = parsePostgresData(res.data);
                            if (isFirst && parsedData && parsedData.length) {
                                vm.totalItems = parsedData[0].totalItems + 1;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                parsedData.reverse();
                            }
                            vm.resetAttributeLists = _.cloneDeepWith(parsedData);
                            vm.fnGenerateAttributesList();
                            vm.isAttributesLoading = false;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributesLoading = false;
                        })
                };

                vm.fnGenerateAttributesList = function () {
                    vm.attributesList = [];
                    _.forEach(vm.resetAttributeLists, function (attributeObj) {
                        attributeObj.displayName = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.name = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.type = 'attribute';
                        var tempActualObj = _.cloneDeepWith(attributeObj);
                        tempActualObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        vm.attributesList.push(tempActualObj);
                        if (vm.selectedAttribute.id === tempActualObj.id) {
                            vm.selectedAttribute = tempActualObj;
                        }
                    });
                    vm.fnSortAttributesByPlot();
                };

                vm.fnSortAttributesByPlot = function () {
                    //vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                };

                vm.fnPageChanged = function(page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isAttributesLoading = true;

                    // Handle sorting
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }

                    function buildBaseSelect(useRt) {
                        return 'SELECT node_attributes.*, ' +
                            'CAST(node_attributes.data->>\'' + (useRt ? sortValue : '_id') + '\' AS text) AS rt ' +
                            'FROM node_attributes AS node_attributes';
                    }

                    function buildFullSelect(useSort) {
                        var sql = 'WITH attributes AS ( ' + buildBaseSelect(useSort);
                        sql += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sql += useSort ?
                            ' ORDER BY rt ' + sortType + ' LIMIT ' + vm.perPage :
                            ' ORDER BY rt ASC LIMIT ' + vm.perPage;
                        sql += ' ),';
                        sql += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sql += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";

                        sql += 'SELECT att.*, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'rows.qty AS totalItems, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' ' +
                            '     THEN node_ecus.data->>\'name\' ' +
                            '     ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                            'CASE WHEN att.data->>\'ecuId\' = att.data->>\'nodeId\' ' +
                            '     THEN node_ecus.id ' +
                            '     ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId, ' +
                            (useSort ? 'att.data->>\'' + sortValue + '\'' : 'att.rt') + ' AS rt ' +
                            'FROM attributes AS att ' +
                            'LEFT JOIN node_ecus ON att.data->>\'ecuId\' = node_ecus.id ' +
                            'LEFT JOIN node_nodes ON att.data->>\'nodeId\' = node_nodes.id, ' +
                            'rows';
                        return sql;
                    }

                    if (isPerPageChanged) {
                        vm.fnGetAttributes({
                            sql: buildFullSelect(sortString !== '')
                        }, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(
                            buildBaseSelect(sortString !== ''),
                            vm.sqlQuery,
                            sortString,
                            page,
                            vm.previousPage,
                            perPage,
                            vm.totalItems,
                            vm.attributesList,
                            true,
                            'node_attributes'
                        );

                        var baseSQL = input.sql.endsWith(';') ?
                            input.sql.slice(0, -1) :
                            input.sql;

                        var newSQL = "WITH attributes AS (" + baseSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes";
                        newSQL += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        newSQL += buildFullSelect(sortString !== '').split('WITH attributes AS')[1];

                        vm.previousPage = page;
                        vm.fnGetAttributes({
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }, false);
                    }
                };

                vm.fnOnActionDrop = function (srcList, dataType, chatsType) {
                    var isAllow = false;
                    if (vm.selectedChartType === 'pie') {
                        isAllow = !(dataType === 'Forecast' || dataType === 'Anomaly');
                    } else {
                        isAllow = true;
                    }
                    if (isAllow) {
                        var chartType = "";
                        var tempType = "";
                        if (chatsType === 'Value') {
                            chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                            tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        } else {
                            chartType = srcList.type === 'node' ? 'nodeHealth' : 'attributeHealth';
                            tempType = 'Health';
                        }
                        //var chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                        //var tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        var isFindIndex = _.findIndex(vm.selectedChartData, {
                            name: srcList.name + " (" + dataType + " " + tempType + ")",
                            chartType: chartType,
                            id: srcList.id
                        });
                        if (isFindIndex === -1) {
                            if (chatsType === 'Value') {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeConnection';
                                } else {
                                    srcList.chartType = 'attributeValue';
                                }
                            } else {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeHealth';
                                } else {
                                    srcList.chartType = 'attributeHealth';
                                }
                            }
                            srcList.dataType = _.cloneDeepWith(dataType);
                            if (chatsType === 'Value') {
                                if (dataType === 'Actual') {
                                    srcList.isSelected = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecast = true;
                                } else {
                                    srcList.isSelectedAnomaly = true;
                                }
                            } else {
                                if (dataType === 'Actual') {
                                    srcList.isSelectedHealthPlot = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecastHealthPlot = true;
                                } else {
                                    srcList.isSelectedAnomalyHealthPlot = true;
                                }
                            }
                            var tempSrcList = _.cloneDeepWith(srcList);
                            tempSrcList.name = tempSrcList.name + " (" + dataType + " " + tempType + ")";
                            vm.selectedChartData.push(tempSrcList);
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (vm.selectedChartType === 'heatmap') {
                                vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                            }
                            if (vm.selectedChartType === 'pie') {
                                vm.selectedPieChartData = vm.pieChartAttributeList[0];
                            }
                            $timeout(function () {
                                vm.fnGetAttributeAnalyticsData(srcList);
                            });
                        } else {
                            amaran.error('Attribute already added on chart.');
                        }
                    } else {
                        amaran.error('Attribute type is not allows for pie chart type.');
                    }
                };

                vm.fnGetAttributeAnalyticsData = function (srcList) {
                    var sql = vm.fnGetSQLQuery(srcList);
                    var chartContainerEle = angular.element(".chart-container-height");
                    loaderModalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                        size: 'md',
                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                        appendTo: chartContainerEle
                    });
                    QueryFactory.executeQuery({'sql': sql})
                        .then(function (res) { // Success block
                            vm.selectedChartData[vm.selectedChartData.length - 1].sql = sql;
                            vm.selectedChartData[vm.selectedChartData.length - 1].apiData = res.data;
                            vm.selectedChartData[vm.selectedChartData.length - 1].chartData = vm.fnGenerateChartData(srcList, res.data);
                            var tempType = srcList.chartType === 'nodeConnection' || srcList.chartType === 'attributeValue' ? 'Value' : 'Health';
                            var tempName = srcList.name + " (" + srcList.dataType + " " + tempType + ")";
                            var isFind = _.find(vm.pieChartAttributeList, {
                                name: tempName,
                                id: srcList.id
                            });
                            if (isFind) {
                                isFind.apiData = res.data;
                                isFind.chartData = vm.selectedChartData[vm.selectedChartData.length - 1].chartData;
                            }
                            if (vm.selectedChartType !== 'heatmap') {
                                loaderModalInstance.dismiss();
                                loaderModalInstance = "";
                            }
                            $timeout(function () {
                                vm.fnRenderChart();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            loaderModalInstance.dismiss();
                            loaderModalInstance = "";
                            vm.fnRemoveChartData(srcList)
                        })
                };

                vm.fnRenderChart = function () {
                    if (vm.selectedChartData.length) {
                        if (vm.selectedChartType === 'pie') {
                            vm.chartData = [];
                            var counts = {};
                            if (vm.selectedPieChartData && vm.selectedPieChartData.chartType) {
                                if (vm.selectedPieChartData.chartType === "nodeHealth" || vm.selectedPieChartData.chartType === "attributeHealth") {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.health] = (counts[x.health] || 0) + 1;
                                    });
                                } else {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.value] = (counts[x.value] || 0) + 1;
                                    });
                                }
                                _.forEach(counts, function (value, key) {
                                    vm.chartData.push({
                                        name: key,
                                        y: value
                                    });
                                });
                                $timeout(function () {
                                    Highcharts.chart('nodeAttributeChart', {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: 'pie'
                                        },
                                        title: {
                                            text: ''
                                        },
                                        tooltip: {
                                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        accessibility: {
                                            point: {
                                                valueSuffix: ''
                                            }
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: true,
                                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                                }
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: 'Value',
                                            colorByPoint: true,
                                            data: vm.chartData
                                        }]
                                    });
                                });
                            }
                        }
                        if (vm.selectedChartType === 'heatmap') {
                            if (angular.isDefined(vm.selectedHeatmapChartAttr) && vm.selectedHeatmapChartAttr.name.length) {
                                var sql = vm.fnGetHeatMapSQLQuery(vm.selectedHeatmapChartAttr);
                                if (loaderModalInstance === '') {
                                    var chartContainerEle = angular.element(".chart-container-height");
                                    loaderModalInstance = $uibModal.open({
                                        backdrop: 'static',
                                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                                        size: 'md',
                                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                                        appendTo: chartContainerEle
                                    });
                                }
                                QueryFactory.executeQuery({'sql': sql})
                                    .then(function (res) { // Success block
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.selectedHeatmapChartAttr.apiData = _.cloneDeepWith(res.data);
                                        var chartData = vm.fnGenerateHeatMapChartData(vm.selectedHeatmapChartAttr, _.cloneDeepWith(res.data));
                                        var chartName = '';
                                        if (angular.isDefined(vm.selectedHeatmapChartAttr.chartType) && vm.selectedHeatmapChartAttr.chartType === 'attributeValue') {
                                            chartName = 'Value';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'attributeHealth' || vm.selectedHeatmapChartAttr.chartType === 'nodeHealth') {
                                            chartName = vm.selectedHeatmapChartAttr.type === 'node' ? 'Node Health' : 'Health';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'nodeConnection') {
                                            chartName = 'Connection';
                                        }
                                        var isStringFound = false;
                                        _.forEach(res.data, function (dataObj) {
                                            if (dataObj.value && isNaN(dataObj.value)) {
                                                isStringFound = true;
                                            }
                                        });
                                        Highcharts.chart("nodeAttributeHeatmapChart", {
                                            chart: {
                                                type: 'heatmap'
                                            },
                                            exporting: {
                                                enabled: false
                                            },
                                            boost: {
                                                useGPUTranslations: true
                                            },
                                            legend: {
                                                enabled: false
                                            },
                                            title: {
                                                text: ''
                                            },
                                            subtitle: {
                                                text: ''
                                            },
                                            xAxis: {
                                                title: {
                                                    text: vm.selectedXAxis.title
                                                },
                                                categories: vm.selectedXAxis.categories,
                                                labels: {
                                                    format: vm.selectedXAxis.title === 'Hours' || vm.selectedXAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                }
                                            },
                                            yAxis: {
                                                categories: vm.selectedYAxis.categories,
                                                title: {
                                                    text: vm.selectedYAxis.title
                                                },
                                                reversed: false,
                                                labels: {
                                                    format: vm.selectedYAxis.title === 'Hours' || vm.selectedYAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                },
                                                //startOnTick: false,
                                                endOnTick: false
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                            colorAxis: {
                                                maxColor: Highcharts.getOptions().colors[0]
                                            },
                                            tooltip: {
                                                formatter: function () {
                                                    var tooltip = '';
                                                    if (this.series.name === 'Connection') { //eslint-disable-line
                                                        tooltip = '<b>Node Connection: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    } else if (this.series.name === 'Value') { //eslint-disable-line
                                                        var displayName = '';
                                                        if (isStringFound) {
                                                            displayName = this.point.name ? this.point.name : null; //eslint-disable-line
                                                        } else {
                                                            displayName = this.point.value; //eslint-disable-line
                                                        }
                                                        tooltip = '<b>Value: ' + displayName + '</b>'; //eslint-disable-line
                                                    } else {
                                                        tooltip = '<b>Health: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    }
                                                    return tooltip //eslint-disable-line
                                                }
                                            },
                                            series: [{
                                                boostThreshold: 100,
                                                borderWidth: 0,
                                                data: chartData,
                                                name: chartName,
                                                nullColor: '#FFFFFF',
                                                turboThreshold: chartData.length + 100 // #3404, remove after 4.0.5 release
                                            }]
                                        })
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.fnRemoveChartData(vm.selectedHeatmapChartAttr);
                                    });
                            }
                        }
                        if (vm.selectedChartType === 'spline' || vm.selectedChartType === 'bar') {
                            vm.splineChartData = [];
                            _.forEach(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.type === 'node') {
                                    if (chartDataObj.chartType === 'nodeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            yAxis: 1,
                                            data: chartDataObj.chartData,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempNodeHealthArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempNodeHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthAnomalyArr);
                                        }
                                    } else {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            yAxis: 2,
                                            data: chartDataObj.chartData,
                                            tooltip: {
                                                formatter: function () {
                                                    return '<b>' + moment(this.point.x).format('MM/DD/YYYY HH:mm') + '</b><br><b style="color:' + this.point.color + '">' + this.point.series.name + '</b><br><b>' + this.point.name + '</b><br/>'; //eslint-disable-line
                                                }
                                            },
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempConnectionForecastArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionForecast'),
                                                type: 'arearange',
                                                yAxis: 2,
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionForecastArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempConnectionAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                yAxis: 2,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionAnomalyArr);
                                        }
                                    }
                                } else {
                                    if (chartDataObj.chartType === 'attributeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            data: chartDataObj.chartData,
                                            yAxis: 1,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var healthForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast');
                                            var tempHealthArr = {
                                                name: chartDataObj.name,
                                                data: healthForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthForecast.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var healthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly');
                                            var tempHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: healthAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthAnomaly.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthAnomalyArr);
                                        }
                                    } else {
                                        if (chartDataObj.value && isNaN(chartDataObj.value)) {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                yAxis: 3,
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        } else {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        }

                                        if (chartDataObj.dataType === 'Forecast') {
                                            var isStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueForecast');
                                            var tempArr = {
                                                name: chartDataObj.name,
                                                data: valueForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueForecast.length + 100
                                            };
                                            if (isStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var isAnomalyStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueAnomaly');
                                            var tempValueAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: valueAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueAnomaly.length + 100
                                            };
                                            if (isAnomalyStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempValueAnomalyArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempValueAnomalyArr);
                                        }
                                    }
                                }
                            });

                            var isFindNodeConnection = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeConnection') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[2].visible = !!isFindNodeConnection;
                            var isFindHealthAxes = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeHealth' || chartDataObj.chartType === 'attributeHealth') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[1].visible = !!isFindHealthAxes;
                            $timeout(function () {
                                Highcharts.chart('nodeAttributeChart', {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        type: 'datetime',
                                        labels: {
                                            formatter: function () {
                                                return moment(this.value).format('MM/DD HH:mm'); // eslint-disable-line
                                            },
                                            rotation: -60
                                        },
                                        title: {
                                            text: ''
                                        }
                                    },
                                    yAxis: vm.tempAxesData,
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    series: vm.splineChartData
                                });
                            });
                        }
                        vm.fnSortAttributesByPlot();
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRemoveChartData = function (selectedObj) {
                    var isFindIndex = _.findIndex(vm.selectedChartData, {name: selectedObj.name, id: selectedObj.id});
                    if (isFindIndex !== -1) {
                        vm.selectedChartData.splice(isFindIndex, 1);
                        vm.fnGenerateAttributesList();
                    }
                    var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindPieDataIndex !== -1) {
                        vm.pieChartAttributeList.splice(isFindPieDataIndex, 1);
                        if (vm.pieChartAttributeList && vm.pieChartAttributeList.length) {
                            vm.selectedPieChartData = vm.pieChartAttributeList[0];
                        } else {
                            vm.selectedPieChartData = "";
                        }
                    }
                    var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindHeatmapDataIndex !== -1) {
                        vm.heatmapChartAttributeList.splice(isFindHeatmapDataIndex, 1);
                        if (vm.heatmapChartAttributeList && vm.heatmapChartAttributeList.length) {
                            vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                        } else {
                            vm.selectedHeatmapChartAttr = '';
                        }
                    }
                    $timeout(function () {
                        vm.fnRenderChart();
                    });
                };

                vm.fnGetHealthColor = function (attrCode, attrObj) {
                    var attrStyle = ColorService.getHealthColorForLoop(attrObj.projectId, attrCode);
                    attrObj.healthName = attrStyle.content;
                    return attrStyle;
                };

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };

                vm.fnGetAttributeInfo = function () {
                    vm.alarmObj = vm.parent.alarmObj;
                    vm.alarmObj.nodeName = _.cloneDeepWith(vm.parent.alarmObj.nodeName ? vm.parent.alarmObj.nodeName : "");
                    vm.resetalarmObj = angular.copy(vm.alarmObj);
                    vm.isAttributeDetailsLoaded = true;
                    vm.attributesList = [];
                    //vm.nodeObj.attributes = angular.copy(vm.alarmObj);
                    vm.resetAttributeLists = _.cloneDeepWith([vm.alarmObj]);
                    vm.totalItems = 1;
                    vm.fnGenerateAttributesList();
                    $timeout(function () {
                        TabHeight.fnSet();
                        vm.fnRenderChart();
                        var start = moment().subtract(3, 'hours');
                        var end = moment();
                        $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            opens: 'left',
                            startDate: start,
                            endDate: end,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            ranges: {
                                'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                                'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                                'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                                'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                                'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                                'Today': [moment().startOf('day'), moment()],
                                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                            },
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end, label) {
                            if (label === 'Custom Range') {
                                vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                            } else {
                                if (label === "Last 1 Hour") {
                                    vm.selectedRange = moment().subtract(1, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Hour") {
                                    vm.selectedRange = moment().subtract(3, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Days") {
                                    vm.selectedRange = moment().subtract(3, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 1 Week") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Week") {
                                    vm.selectedRange = moment().subtract(20, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Today") {
                                    vm.selectedRange = moment().startOf('day').format('X') + "," + moment().format('X');
                                } else if (label === "Yesterday") {
                                    vm.selectedRange = moment().subtract(1, 'days').startOf('day').format('X') + "," + moment().subtract(1, 'days').endOf('days').format('X');
                                } else if (label === "Last 7 Days") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 30 Days") {
                                    vm.selectedRange = moment().subtract(29, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "This Month") {
                                    vm.selectedRange = moment().startOf('month').format('X') + "," + moment().endOf('month').format('X');
                                } else {//"Last Month"
                                    vm.selectedRange = moment().subtract(1, 'month').startOf('month').format('X') + "," + moment().subtract(1, 'month').endOf('month').format('X');
                                }
                            }
                            if (angular.isDefined(angular.element("#selectedDate")[0])) {
                                document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                            }
                            var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                            var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                            var timeDifference = moment(endTime).diff(startTime, 'hours');
                            var rangeDiff = 1;
                            var rangeType = 'MINUTES';
                            if (timeDifference <= 1) {
                                rangeDiff = 1;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 1 && timeDifference <= 3) {
                                rangeDiff = 2;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 3 && timeDifference <= 6) {
                                rangeDiff = 5;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 6 && timeDifference <= 12) {
                                rangeDiff = 15;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 12 && timeDifference <= 24) {
                                rangeDiff = 30;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 24 && timeDifference <= 72) {
                                rangeDiff = 1;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 72 && timeDifference <= 168) {
                                rangeDiff = 3;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 168 && timeDifference <= 720) {
                                rangeDiff = 6;
                                rangeType = 'HOURS';
                            } else {
                                rangeDiff = 1;
                                rangeType = 'DAYS';
                            }
                            var isFind = _.find(vm.granularityArr, function (obj) {
                                return obj.config.title === rangeType && obj.config.value === rangeDiff;
                            })
                            if (isFind) {
                                vm.selectedGranularity = _.cloneDeepWith(isFind);
                            }
                            //vm.fnRenderChart();
                            vm.fnDataRangeChange();
                        });
                        vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                        }
                        //vm.fnOnActionDrop(vm.attributesList[0], 'Actual');
                        vm.attributesList[0].chartType = 'attributeValue';
                        vm.attributesList[0].dataType = _.cloneDeepWith('Actual');
                        vm.attributesList[0].isSelected = true;
                        var tempSrcList = _.cloneDeepWith(vm.attributesList[0]);
                        tempSrcList.name = tempSrcList.name + " (Actual Value)";
                        vm.selectedChartData.push(tempSrcList);
                        vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                        vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));

                        vm.attributesList[0].chartType = 'attributeHealth';
                        vm.attributesList[0].dataType = _.cloneDeepWith('Actual');
                        vm.attributesList[0].isSelectedHealthPlot = true;
                        var tempHealthSrcList = _.cloneDeepWith(vm.attributesList[0]);
                        tempHealthSrcList.name = tempHealthSrcList.name + " (Actual Health)";
                        vm.selectedChartData.push(tempHealthSrcList);
                        vm.selectedAttribute = _.cloneDeepWith(vm.attributesList[0]);
                        vm.pieChartAttributeList.push(_.cloneDeepWith(tempHealthSrcList));
                        vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempHealthSrcList));
                        vm.fnDataRangeChange();
                    })
                };

                vm.fnSelectPieChartAttr = function (chartObj) {
                    var isFind = _.find(vm.pieChartAttributeList, {name: chartObj.name});
                    if (isFind) {
                        vm.selectedPieChartData = isFind;
                        $timeout(function () {
                            vm.fnRenderChart();
                        })
                    }
                };

                // Replace vm.fnGetSQLQuery, vm.fnGetUpdateChartSQLQuery, and vm.fnGetHeatMapSQLQuery with these versions

                vm.fnGetSQLQuery = function(srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                    var sql = '';
                    var totalDuration = endTime.diff(startTime);
                    var rangeDiff = vm.selectedGranularity.config.value;
                    var rangeType = vm.selectedGranularity.config.title; // MINUTES, HOURS, DAYS
                    var totalRange = parseInt(totalDuration / vm.selectedGranularity.config.time);

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields) {
                        var fields = ['data->>\'timestamp\' AS timestamps', 'data->>\'' + idField + '\' AS id',
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) AS ts'];

                        valueFields.forEach(function(field) {
                            fields.push('data->>\'' + field.name + '\' AS ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->>\'' + field + '\' AS ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots() {
                        var intervalType = rangeType.substring(0, rangeType.length - 1).toLowerCase(); // Convert 'MINUTES' to 'minute'

                        if (rangeType !== 'DAYS') {
                            return "SELECT " +
                                "TIMESTAMP '" + previousDateString + "' + (u.i - 1) * INTERVAL '" + rangeDiff + " " + intervalType + "' AS last_ts, " +
                                "TIMESTAMP '" + previousDateString + "' + u.i * INTERVAL '" + rangeDiff + " " + intervalType + "' AS ts " +
                                "FROM generate_series(1, " + totalRange + ", 1) AS u(i)";
                        } else {
                            return "SELECT " +
                                "TIMESTAMP '" + previousDateString + "' + (u.i * INTERVAL '1 day') AS last_ts, " +
                                "TIMESTAMP '" + previousDateString + "' + ((u.i + " + rangeDiff + ") * INTERVAL '1 day') AS ts " +
                                "FROM generate_series(0, " + totalRange + ", " + rangeDiff + ") AS u(i)";
                        }
                    }

                    function buildAggregationQuery(valueAlias, additionalFields) {
                        var baseFields = ['filled_slots.ts', 'MAX(' + valueAlias + ') AS last_val', 'slot_agg_val'];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = '(SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) AS last_previous_time, ' +
                            'MAX(in_interval_r.' + valueAlias + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) AS filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS text) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        node: {
                            nodeHealth: {
                                base: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            nodeConnection: {
                                base: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'connected', alias: 'value' }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value' }
                            }
                        }
                    };

                    var config = srcList.type === 'node' ?
                        tableConfig.node[srcList.chartType === 'nodeHealth' ? 'nodeHealth' : 'nodeConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields) +
                        '), slots AS (' + buildTimeSlots() +
                        '), slot_values AS ' + buildAggregationQuery(config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_values ORDER BY ts;';

                    return sql;
                };

                vm.fnGetUpdateChartSQLQuery = function(srcList) {
                    var previousDateString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var sql = '';
                    var rangeDiff = 1;
                    var totalRange = 1;

                    previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).subtract(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    function buildBasicQuery(tableName, idField, valueFields, additionalFields) {
                        var fields = [
                            'data->>\'timestamp\' as timestamps',
                            'data->>\'' + idField + '\' as id',
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint)) as ts'
                        ];

                        valueFields.forEach(function(field) {
                            fields.push('data->>\'' + field.name + '\' as ' + field.alias);
                        });

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('data->>\'' + field + '\' as ' + field);
                            });
                        }

                        var query = '(SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' < TIMESTAMP \'' + previousDateString + '\' ' +
                            'ORDER BY ts DESC LIMIT 1)';

                        query += ' UNION (SELECT ' + fields.join(', ') +
                            ' FROM ' + tableName +
                            ' WHERE data->>\'' + idField + '\' = \'' + srcList.id + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' > TIMESTAMP \'' + previousDateString + '\' AND ' +
                            'DATE_TRUNC(\'second\', to_timestamp((data->>\'timestamp\')::bigint))' +
                            ' < TIMESTAMP \'' + endDateString + '\')';

                        return query;
                    }

                    function buildTimeSlots() {
                        var intervalType = 'minute'; // For MINUTES

                        return 'SELECT TIMESTAMP \'' + previousDateString + '\' - INTERVAL \'' + rangeDiff + ' ' + intervalType + '\' AS last_ts, ' +
                            'TIMESTAMP \'' + previousDateString + '\' + (n * INTERVAL \'' + rangeDiff + ' ' + intervalType + '\') AS ts ' +
                            'FROM generate_series(1, ' + totalRange + ', 1) AS n';
                    }

                    function buildAggregationQuery(slotType, valueField, additionalFields) {
                        var baseFields = [
                            'filled_slots.ts',
                            'MAX(' + valueField + ') AS last_val',
                            'slot_agg_val'
                        ];
                        var additionalAggs = [];

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                baseFields.push('MAX(' + field + ') AS last_' + field);
                                baseFields.push('slot_agg_' + field);
                                additionalAggs.push('MAX(in_interval_r.' + field + ') AS slot_agg_' + field);
                            });
                        }

                        var query = 'slot_' + slotType + ' AS ( SELECT ' + baseFields.join(', ') + ' FROM ' +
                            '(SELECT slots.ts, MAX(previous_r.ts) AS last_previous_time, ' +
                            'MAX(in_interval_r.' + valueField + ') AS slot_agg_val';

                        if (additionalAggs.length > 0) {
                            query += ', ' + additionalAggs.join(', ');
                        }

                        query += ' FROM slots ' +
                            'LEFT JOIN readings previous_r ON previous_r.ts <= slots.ts ' +
                            'LEFT JOIN readings in_interval_r ON in_interval_r.ts < slots.ts AND in_interval_r.ts > slots.last_ts ' +
                            'GROUP BY slots.ts) AS filled_slots ' +
                            'LEFT JOIN readings ON filled_slots.last_previous_time = readings.ts ' +
                            'GROUP BY filled_slots.ts, slot_agg_val';

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                query += ', slot_agg_' + field;
                            });
                        }

                        query += ')';
                        return query;
                    }

                    function buildSelectionQuery(valueAlias, additionalFields) {
                        var fields = ['CAST(ts AT TIME ZONE \'' + timezoneName + '\' AS text) AS ts'];
                        fields.push('COALESCE(slot_agg_val, LAG(slot_agg_val, 1) OVER (ORDER BY ts), last_val) AS ' + valueAlias);

                        if (additionalFields) {
                            additionalFields.forEach(function(field) {
                                fields.push('COALESCE(slot_agg_' + field + ', LAG(slot_agg_' + field + ', 1) OVER (ORDER BY ts), last_' + field + ') AS ' + field);
                            });
                        }

                        return fields.join(', ');
                    }

                    var tableConfig = {
                        node: {
                            nodeHealth: {
                                base: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            nodeConnection: {
                                base: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies',
                                idField: 'nodeId',
                                valueField: { name: 'connected', alias: 'value' }
                            }
                        },
                        attribute: {
                            attributeHealth: {
                                base: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'health', alias: 'health' }
                            },
                            attributeValue: {
                                base: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies',
                                idField: 'attributeId',
                                valueField: { name: 'value', alias: 'value' }
                            }
                        }
                    };

                    var config = srcList.type === 'node' ?
                        tableConfig.node[srcList.chartType === 'nodeHealth' ? 'nodeHealth' : 'nodeConnection'] :
                        tableConfig.attribute[srcList.chartType === 'attributeHealth' ? 'attributeHealth' : 'attributeValue'];

                    var tableName = config.base;
                    var additionalFields = null;

                    if (srcList.dataType === 'Forecast' || srcList.dataType === 'Anomaly') {
                        tableName = srcList.dataType === 'Forecast' ? config.forecast : config.anomaly;
                        additionalFields = ['confidence', 'type'];
                    }

                    sql = 'WITH readings AS (' +
                        buildBasicQuery(tableName, config.idField, [config.valueField], additionalFields) +
                        '), slots AS (' + buildTimeSlots() +
                        '), ' + buildAggregationQuery(config.valueField.alias === 'health' ? 'healths' : 'values',
                            config.valueField.alias, additionalFields) +
                        ' SELECT ' + buildSelectionQuery(config.valueField.alias, additionalFields) +
                        ' FROM slot_' + (config.valueField.alias === 'health' ? 'healths' : 'values') +
                        ' ORDER BY ts;';

                    return sql;
                };

                vm.fnGetHeatMapSQLQuery = function(srcList) {
                    var startDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var selectedXAxisQString = "";
                    var selectedYAxisQString = "";

                    if (vm.selectedXAxis.title === 'Minutes') {
                        selectedXAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Hours') {
                        selectedXAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Days') {
                        selectedXAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Weeks') {
                        selectedXAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else {
                        selectedXAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    }

                    if (vm.selectedYAxis.title === 'Minutes') {
                        selectedYAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Hours') {
                        selectedYAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Days') {
                        selectedYAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Weeks') {
                        selectedYAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else {
                        selectedYAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    }

                    var sql = "";
                    if (srcList.type === "node") {
                        if (srcList.chartType === 'nodeHealth') {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'health\' AS FLOAT) ELSE data->>\'health\' END as health, data->>\'health\' as value, data->>\'projectId\' as projectId " +
                                "FROM node_iot_node_healths " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'nodeId\' = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'connectedType\' = 'BOOLEAN' THEN CAST(data->>\'connected\' AS BOOLEAN) ELSE data->>\'connected\' END as connected, data->>\'connected\' as value " +
                                "FROM node_iot_node_connections " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'nodeId\' = '" + srcList.id + "'";
                        }
                    } else {
                        if (srcList.chartType === 'attributeHealth') {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'health\' AS FLOAT) ELSE data->>\'health\' END as health, data->>\'health\' as value, data->>\'projectId\' as projectId " +
                                "FROM node_iot_attribute_healths " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'attributeId\' = '" + srcList.id + "'";
                        } else {
                            sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                                " " + selectedYAxisQString + " , " +
                                " " + selectedXAxisQString + " , " +
                                "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'value\' AS FLOAT) ELSE data->>\'value\' END as value " +
                                "FROM node_iot_attribute_values " +
                                "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                                "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                                "AND data->>\'attributeId\' = '" + srcList.id + "'";
                        }
                    }

                    return sql;
                };

                vm.fnGenerateHeatMapChartData = function (srcList, apiRes) {
                    var chartData = [];
                    var isStringFound = false;
                    vm.heatmapAttributeStringValueArr = [];
                    _.forEach(apiRes, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                        if (dataObj.value && dataObj.value !== '' && vm.heatmapAttributeStringValueArr.indexOf(dataObj.value) === -1) {
                            vm.heatmapAttributeStringValueArr.push(dataObj.value);
                        }
                    });
                    if (!isStringFound) {
                        vm.heatmapAttributeStringValueArr = [];
                    }
                    _.forEach(vm.selectedXAxis.categories, function (xAxisCategoriesObj, xAxisIndex) {
                        _.forEach(vm.selectedYAxis.categories, function (yAxisCategoriesObj, yAxisIndex) {
                            var newXAxisIndex = _.cloneDeepWith(xAxisIndex);
                            var newYAxisIndex = _.cloneDeepWith(yAxisIndex);
                            if (vm.selectedXAxis.title === 'Days' || vm.selectedXAxis.title === 'Months') {
                                newXAxisIndex = newXAxisIndex + 1;
                            }
                            if (vm.selectedYAxis.title === 'Days' || vm.selectedYAxis.title === 'Months') {
                                newYAxisIndex = newYAxisIndex + 1;
                            }
                            var minValue = 0;
                            var maxValue = 0;
                            var avgValue = 0;
                            var isFindData = _.filter(apiRes, {x: newXAxisIndex, y: newYAxisIndex});
                            if (isFindData && isFindData.length) {
                                minValue = isFindData[0].value;
                                maxValue = isFindData[0].value;
                                var sum = 0;
                                avgValue = 0;
                                if (srcList.chartType === 'nodeConnection') {
                                    if (isFindData && isFindData.length > 1) {
                                        var connectedArr = _.filter(isFindData, function(d) {
                                            return d.value === true || d.value === 'true';
                                        });
                                        var disconnectedArr = _.filter(isFindData, function(d) {
                                            return d.value === false || d.value === 'false';
                                        });
                                        minValue = connectedArr.length < disconnectedArr.length;
                                        maxValue = connectedArr.length >= disconnectedArr.length;
                                        avgValue = isFindData.reduce(function(sum, next) {
                                            return sum && (next.value === true || next.value === 'true');
                                        }, true);
                                    } else {
                                        minValue = isFindData[0].value === true || isFindData[0].value === 'true';
                                        maxValue = isFindData[0].value === true || isFindData[0].value === 'true';
                                        avgValue = isFindData[0].value === true || isFindData[0].value === 'true';
                                    }
                                } else {
                                    if (isStringFound) {
                                        if (isFindData && isFindData.length > 1) {
                                            var groupData = _.groupBy(isFindData, function (n) {
                                                return n.value;
                                            });
                                            var minLength = Object.values(groupData)[0].length;
                                            var maxLength = Object.values(groupData)[0].length;
                                            minValue = Object.keys(groupData)[0];
                                            maxValue = Object.keys(groupData)[0];
                                            _.forEach(isFindData, function (findObj, key) {
                                                if (findObj.length < minLength) {
                                                    minValue = key;
                                                    minLength = findObj.length;
                                                }
                                                if (findObj.length > maxLength) {
                                                    maxValue = key;
                                                    maxLength = findObj.length;
                                                }
                                            });
                                            avgValue = isFindData.reduce(function (sum, next) {
                                                return sum && next.value;
                                            }, true);
                                        } else {
                                            minValue = isFindData[0].value;
                                            maxValue = isFindData[0].value;
                                            avgValue = isFindData[0].value;
                                        }
                                    } else {
                                        _.forEach(isFindData, function (findObj) {
                                            findObj.value = Number(findObj.value);
                                            if (findObj.value < minValue) {
                                                minValue = findObj.value;
                                            }
                                            if (findObj.value > maxValue) {
                                                maxValue = findObj.value;
                                            }
                                            sum = sum + findObj.value;
                                        });
                                        avgValue = sum / isFindData.length;
                                    }
                                }
                                var value = null;
                                if (vm.selectedMathFunction === 'MIN') {
                                    value = minValue;
                                } else if (vm.selectedMathFunction === 'MAX') {
                                    value = maxValue;
                                } else {
                                    value = avgValue;
                                }
                                if (srcList.chartType === 'nodeHealth') {
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value,
                                        color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                    })
                                } else if (srcList.chartType === 'nodeConnection') {
                                    var tempConnectionObj = _.find(connectionArr, {
                                        value: (value === true || value === 'true') ? 1 : -1
                                    });
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value !== '' ? tempConnectionObj.name : null,
                                        color: value !== '' ? tempConnectionObj.color : '#FFFFFF'
                                    });
                                } else {
                                    if (srcList.chartType === 'attributeValue') {
                                        if (isStringFound) {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: vm.heatmapAttributeStringValueArr.indexOf(value),
                                                name: value
                                            })
                                        } else {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: Number(value)
                                            })
                                        }
                                    } else {
                                        chartData.push({
                                            x: xAxisIndex,
                                            y: yAxisIndex,
                                            value: value,
                                            color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                        })
                                    }
                                }
                            } else {
                                chartData.push({
                                    x: xAxisIndex,
                                    y: yAxisIndex,
                                    value: null
                                });
                            }

                        })
                    });
                    return chartData;
                };

                vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    if (srcList.type === 'node') {
                        if (srcList.chartType === 'nodeHealth') {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health ? Number(dataObj.health) : null]);
                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    var tempConnectionObj = _.find(connectionArr, {
                                        value: (dataObj.value === true || dataObj.value === 'true') ? 1 : -1});
                                    tempData.push({
                                        x: parseInt(dataObj.timestamp),
                                        y: dataObj.value ? tempConnectionObj.value : 0,
                                        name: dataObj.value ? tempConnectionObj.name : 'No Data Found',
                                        color: dataObj.value ? tempConnectionObj.color : '#808080'
                                    });
                                })
                            });
                        }
                    } else {
                        if (srcList.chartType === 'attributeValue') {
                            var isStringFound = false;
                            _.forEach(resData, function (dataObj) {
                                if (dataObj.value && isNaN(dataObj.value)) {
                                    isStringFound = true;
                                }
                            });
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    if (isStringFound) {
                                        if (dataObj.value && dataObj.value !== '' && vm.attributesStringValueArr.indexOf(dataObj.value) === -1) {
                                            vm.attributesStringValueArr.push(dataObj.value);
                                        }
                                        tempData.push([parseInt(dataObj.timestamp), vm.attributesStringValueArr.indexOf(dataObj.value) === -1 ? null : vm.attributesStringValueArr.indexOf(dataObj.value)]);
                                    } else {
                                        tempData.push([parseInt(dataObj.timestamp), dataObj.value ? Number(dataObj.value) : null]);
                                    }

                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health === 0 || dataObj.health > 0 ? Number(dataObj.health) : null]);
                                })
                            });
                        }
                    }
                    return tempData;
                };

                vm.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData.apiData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = vm.attributesStringValueArr.indexOf(tempDataObj.value) === -1 ? 0 : vm.attributesStringValueArr.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                vm.fnDataRangeChange = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        var chartContainerEle = angular.element(".chart-container-height");
                        loaderModalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                            size: 'md',
                            controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                            windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                            appendTo: chartContainerEle
                        });
                        count = 1;
                        vm.fnBatchOperation(batchCollectionObj, count);
                    }
                };

                vm.fnBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                _.forEach(response, function (responseObj, index) {
                                    var sql = angular.fromJson(responseObj.request.body);
                                    vm.selectedChartData[index].sql = sql.sql;
                                    vm.selectedChartData[index].apiData = responseObj.body.data;
                                    vm.selectedChartData[index].chartData = vm.fnGenerateChartData(vm.selectedChartData[index], responseObj.body.data);
                                    var isFind = _.find(vm.pieChartAttributeList, {
                                        name: vm.selectedChartData[index].name,
                                        id: vm.selectedChartData[index].id
                                    });
                                    if (isFind) {
                                        isFind.apiData = responseObj.body.data;
                                        isFind.chartData = vm.selectedChartData[index].chartData;
                                    }
                                });
                                $timeout(function () {
                                    if (vm.selectedChartType !== 'heatmap') {
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                    }
                                    if (vm.selectedChartType === 'pie') {
                                        vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                    } else {
                                        vm.fnRenderChart();
                                    }
                                })
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                if (vm.selectedChartType !== 'heatmap') {
                                    loaderModalInstance.dismiss();
                                    loaderModalInstance = "";
                                }
                                if (vm.selectedChartType === 'pie') {
                                    vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                } else {
                                    vm.fnRenderChart();
                                }
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnEditAttributeName = function (selectedObj, dataType) {
                    var tempSelectedObj = _.cloneDeepWith(selectedObj);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditNameModal/attributeEditNameModal.html',
                        size: 'lg',
                        controller: 'attributeEditNameModalCtrl as attributeEditModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        var isFindInAttributeList = _.findIndex(vm.attributesList, {id: res.id});
                        if (isFindInAttributeList !== -1) {
                            vm.attributesList[isFindInAttributeList].name = res.name;
                            vm.attributesList[isFindInAttributeList].displayName = res.name;
                        }
                        var isFindInChartData = _.filter(vm.selectedChartData, {id: selectedObj.id});
                        if (isFindInChartData.length) {
                            _.forEach(isFindInChartData, function (chartObj) {
                                var tempChartType = "Value";
                                if (chartObj.chartType === 'attributeValue') {
                                    tempChartType = "Value"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Value)";
                                } else {
                                    tempChartType = "Health"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Health)";
                                }
                                chartObj.displayName = _.cloneDeepWith(res.name);
                                var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindPieDataIndex !== -1) {
                                    vm.pieChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.pieChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedPieChartData.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedPieChartData.name = vm.pieChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedPieChartData.displayName = res.name;
                                    }
                                }
                                var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindHeatmapDataIndex !== -1) {
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedHeatmapChartAttr.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedHeatmapChartAttr.name = vm.heatmapChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedHeatmapChartAttr.displayName = res.name;
                                    }
                                }
                            })
                        }
                        $timeout(function () {
                            vm.fnRenderChart();
                        });
                    }, function () {

                    });
                };

                vm.fnEditAttributeValue = function (selectedObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditValueModal/attributeEditValueModal.html',
                        size: 'lg',
                        controller: 'attributeEditValueModalCtrl as attributeEditValue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (jobRes) {
                        vm.fnGetEcu(selectedObj, jobRes);
                    }, function () {
                    });
                };

                vm.fnSelectAttribute = function (attributeObj) {
                    vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                    vm.selectedAttribute.name = _.cloneDeepWith(attributeObj.displayName);
                    vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                };

                vm.fnSelectedAttributeCopyToClipboard = function (key, attribute) {
                    attribute[key + 'IsCopyClicked'] = true;
                    copyService.fnCopyToClipboard(attribute[key]);
                    $timeout(function () {
                        delete attribute[key + 'IsCopyClicked'];
                    }, 2000)
                };

                vm.fnIsAttributeSelected = function () {
                    return !!vm.selectedAttribute && Object.keys(vm.selectedAttribute).length;
                };

                vm.fnOpenNodeInfo = function () {
                    if (vm.selectedAttribute.ecuId === vm.selectedAttribute.nodeId) {
                        var ecuInputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: vm.selectedAttribute.ecuId,
                            displaySearchText: vm.selectedAttribute.ecuId
                        }];
                        $state.go('main.ecu', {
                            filter: angular.toJson(ecuInputObj),
                            selectedId: vm.selectedAttribute.ecuId
                        });
                    } else {
                        var inputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: vm.selectedAttribute.nodeId,
                            displaySearchText: vm.selectedAttribute.nodeId,
                            isNeedTableAlias: true
                        }];
                        $state.go('main.node', {
                            filter: angular.toJson(inputObj),
                            selectedId: vm.selectedAttribute.nodeId
                        });
                    }
                };

                vm.fnEnableAttribute = function (attributeObj) {
                    swal({
                            title: "Enable the selected Attribute?",
                            text: "You are about to enable selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };
                                NodeAttributesFactory.enableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute enabling process cancelled", "error");
                            }
                        });
                };

                vm.fnDisableAttribute = function (attributeObj) {
                    swal({
                            title: "Disable the selected Attribute?",
                            text: "You are about to disable the selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };

                                NodeAttributesFactory.disableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute disable process cancelled", "error");
                            }
                        });
                };

                vm.fnSelectAutoUpdateChart = function () {
                    if (vm.selectedAutoUpdateType === 'Static') {
                        $timeout.cancel(vm.chartUpdateTimeout);
                    } else {
                        vm.chartUpdateTimeout = $timeout(function () {
                            vm.fnUpdateDateRangeInput();
                        }, 60000);
                    }
                };

                vm.fnUpdateDateRangeInput = function () {
                    var oldT = vm.selectedRange.split(',');
                    var newStart = moment.unix(parseInt(oldT[0])).add(1, 'minutes').format('X')
                    var newEnd = moment.unix(parseInt(oldT[1])).add(1, 'minutes').format('X')
                    vm.selectedRange = newStart + "," + newEnd;
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (moment.unix(parseInt(newStart)).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(parseInt(newEnd)).format('YYYY/MM/DD HH:mm'));
                    }
                    if (vm.selectedChartData && vm.selectedChartData.length) {
                        vm.fnGetChartUpdateData();
                    }
                    vm.chartUpdateTimeout = $timeout(function () {
                        vm.fnUpdateDateRangeInput();
                    }, 60000);
                };

                vm.fnGetChartUpdateData = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                };

                vm.fnChartUpdateBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            } else {
                                var chart = $('#nodeAttributeChart').highcharts(); //eslint-disable-line
                                _.forEach(response, function (responseObj, index) {
                                    var tempChartData = vm.fnGenerateChartData(vm.selectedChartData[index], responseObj.body.data);
                                    $timeout(function () {
                                        vm.selectedChartData[index].apiData.shift();
                                        vm.selectedChartData[index].apiData.push(responseObj.body.data[0]);
                                        vm.selectedChartData[index].chartData.shift();
                                        vm.selectedChartData[index].chartData.push(_.cloneDeepWith(tempChartData[0]));
                                        var isFind = _.find(vm.pieChartAttributeList, {
                                            name: vm.selectedChartData[index].name,
                                            id: vm.selectedChartData[index].id
                                        });
                                        if (isFind) {
                                            isFind.apiData = _.cloneDeepWith(vm.selectedChartData[index].apiData);
                                            isFind.chartData = _.cloneDeepWith(vm.selectedChartData[index].chartData);
                                        }
                                        var isFindIndex = _.findIndex(chart.series, {name: vm.selectedChartData[index].name});
                                        if (isFindIndex !== -1) {
                                            chart.series[isFindIndex].addPoint(tempChartData[0], true, true);
                                            if (vm.selectedChartData[index].type === 'node') {
                                                if (vm.selectedChartData[index].chartType === 'nodeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthForecast[tempHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempHealthAnomaly[tempHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempConnectionForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionForecast[tempConnectionForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempConnectionAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempConnectionAnomaly[tempConnectionAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            } else {
                                                if (vm.selectedChartData[index].chartType === 'attributeHealth') {
                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthForecast[tempValueHealthForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueHealthAnomaly[tempValueHealthAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                } else {

                                                    if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                        var tempValueForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueForecast');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueForecast[tempValueForecast.length - 1], true, true);
                                                        })
                                                    }
                                                    if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                        var tempValueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueAnomaly');
                                                        $timeout(function () {
                                                            chart.series[isFindIndex + 1].addPoint(tempValueAnomaly[tempValueAnomaly.length - 1], true, true);
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    })
                                });
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnSetGranularity = function () {
                    vm.fnDataRangeChange();
                }

                vm.fnDeployAttribute = function (alarmObj) {
                    var input = {
                        attributeId: alarmObj.id
                    };
                    NodeAttributesFactory.deployAttribute(input)
                        .then(function (res) {
                            amaran.success("Attribute Synchronize in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html',
                                size: 'lg',
                                controller: 'attributeSyncModalCtrl as attributeSyncModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(res);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnExportToInsight = function () {
                    var tempChartArr = [];
                    var tempObj = {};
                    _.forEach(vm.selectedChartData, function (selectedChartObj) {
                        tempObj = {};
                        tempObj.query = selectedChartObj.sql;
                        tempObj.chart = {
                            chartConfiguration: {
                                chartType: "line",
                                dataMapping: {},
                                chartConfig: {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        labels: {
                                            rotation: -60,
                                            format: "{value:%d/%m %H:%M}"
                                        },
                                        title: {
                                            text: ''
                                        },
                                        type: "datetime"
                                    },
                                    yAxis: {
                                        title: {
                                            text: 'Values'
                                        }
                                    },
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    legend: {
                                        enabled: false
                                    }
                                }
                            }
                        };
                        if (selectedChartObj.type === 'node') {
                            if (selectedChartObj.chartType === 'nodeHealth') {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "health"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                            } else {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "value"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                            }
                        } else {
                            if (selectedChartObj.chartType === 'attributeHealth') {
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ForecastHealth';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'AnomalyHealth';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                                }
                            } else {
                                var isStringFound = false;
                                _.forEach(selectedChartObj.apiData, function (dataObj) {
                                    if (dataObj.value && isNaN(dataObj.value)) {
                                        isStringFound = true;
                                    }
                                });
                                if (isStringFound) {
                                    tempObj.chart.chartConfiguration.isSupportStringValue = true;
                                }
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueForecast';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueAnomaly';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                                }
                            }
                        }
                        tempChartArr.push(tempObj)
                    });
                    DB.fnSet('telemetryChart', tempChartArr);
                    $state.go('main.insight_query_editor');
                }

                vm.fnInitAlarmAttributes = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    if (DB.fnGet('isOpenRelatedAlarm')) {
                        DB.fnRemove('isOpenRelatedAlarm');
                        var tempName = "";
                        if (vm.parent.alarmObj.name.includes('_')) {
                            tempName = _.cloneDeepWith(vm.parent.alarmObj.name.split('_')[0]) + '_';
                        } else if (vm.parent.alarmObj.name.includes(' ')) {
                            tempName = _.cloneDeepWith(vm.parent.alarmObj.name.split(' ')[0]) + ' ';
                        } else {
                            tempName = _.cloneDeepWith(vm.parent.alarmObj.name);
                        }
                        vm.searchFiltersArr.push({
                            displayName: "Related Telemetry",
                            name: "name",
                            regexp: "",
                            errorMessage: "",
                            isDirectFilterApply: true,
                            sqlValue: "LOWER(node_attributes.data->>\'name\') LIKE '" + tempName.toLowerCase() + "%'"
                        });
                        vm.defaultAttributeFilterArr = [
                            {
                                displaySearchText: "",
                                displaySelectedField: "This Node",
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                isDirectFilterApply: true,
                                localSearchValue: "obj.nodeId === '" + vm.parent.alarmObj.nodeId + "'",
                                searchText: "",
                                selectedField: "nodeId",
                                sqlValue: vm.tableAlias + ".data->>\'nodeId\' = '" + vm.parent.alarmObj.nodeId + "'"
                            }, {
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                selectedField: "name",
                                displaySelectedField: "Related Telemetry",
                                selectedConnector: "and",
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: "LOWER(node_attributes.data->>\'name\') LIKE '" + tempName.toLowerCase() + "%'"
                            }
                        ];
                        vm.defaultAttributeSortString = 'data->>\'healthLastChangedAt\' desc';
                    }
                    var timezone = moment().zone();
                    timezoneName = moment.tz.guess();
                    Highcharts.setOptions({
                        global: {
                            timezoneOffset: timezone
                        }
                    });
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    });
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.chartUpdateTimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmHistoryIssuesCtrl',
            function ($scope, $timeout, $window, amaran, $state, QueryFactory, ApiListService, $log) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isIssueDataLoading = true;
                vm.issuesArr = [];
                var getCurrentURL = ApiListService.getCurrentURL();
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.perPage = 20;
                vm.currentPage = 1;
                vm.totalItems = 0;

                var resizeTimeout;
                appWindow = angular.element($window);
                appWindow.bind('resize', function() {
                    if (resizeTimeout) {
                        $timeout.cancel(resizeTimeout);
                    }
                    resizeTimeout = $timeout(function() {
                        vm.fnSetTableHeight();
                    }, 100);
                });

                function parseIssuesData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse data field if exists
                        if (angular.isString(item.data)) {
                            try {
                                var parsedData = angular.fromJson(item.data);

                                // Set core fields with defaults
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name || '';
                                parsedItem.summary = parsedData.summary || '';
                                parsedItem.status = parsedData.status;

                            } catch (e) {
                                $log.error('Error parsing issue data:', e);
                            }
                        }

                        return parsedItem;
                    });
                }


                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-main")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var total = angular.element(".content-main")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeight = total - (header + 20);
                        angular.element("#alarmIssueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAttributes = function (inputObj) {
                    vm.isIssueDataLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            // Parse and store the data
                            vm.issuesArr = parseIssuesData(res.data);

                            // Set total items if available
                            if (vm.issuesArr.length > 0 && vm.issuesArr[0].totalItems) {
                                vm.totalItems = vm.issuesArr[0].totalItems;
                            }

                            vm.isIssueDataLoading = false;

                            // Use nextTick to let data bind first
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueDataLoading = false;
                            vm.issuesArr = [];

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };

                /*vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.issue', {selectedId: issueObj.id});
                }

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL+ "/#/tracker/issue?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                }*/

                /*vm.fnInitAlarmIssues = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    });
                    vm.isIssueDataLoading = true;
                    var tempIdString = "";
                    _.forEach(vm.parent.alarmObj.issueIds, function (id, index) {
                        if (index === vm.parent.alarmObj.issueIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    var sql = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_issues where data->>\'id\' IN (" + tempIdString + ");"
                    vm.fnGetAttributes({"sql": sql});
                }*/

                vm.fnPageChanged = function(page) {
                    vm.currentPage = page;
                    vm.fnLoadIssues();
                };

                vm.fnLoadIssues = function() {
                    if (!vm.parent.alarmObj.issueIds || !vm.parent.alarmObj.issueIds.length) {
                        vm.issuesArr = [];
                        vm.isIssueDataLoading = false;
                        return;
                    }

                    var tempIdString = vm.parent.alarmObj.issueIds
                        .map(function(id) { return "'" + id + "'"; })
                        .join(',');

                    var offset = (vm.currentPage - 1) * vm.perPage;

                    var sql = "SELECT *, COUNT(*) OVER() as totalItems, data->>'_id' AS rt " +
                        "FROM tracker_issues " +
                        "WHERE data->>'id' IN (" + tempIdString + ") " +
                        "ORDER BY rt ASC " +
                        "LIMIT " + vm.perPage + " " +
                        "OFFSET " + offset;

                    vm.fnGetAttributes({"sql": sql});
                };

                vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.issue', {selectedId: issueObj.id});
                };

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL + "/#/tracker/issue?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                };

                vm.fnInitAlarmIssues = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    });
                    vm.fnLoadIssues();
                };

                // Cleanup on destroy
                $scope.$on('$destroy', function() {
                    if (resizeTimeout) {
                        $timeout.cancel(resizeTimeout);
                    }
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmHistoryAttributesCtrl',
            function ($scope, $timeout, $window, $state, DB, amaran, swal, TabHeight, $uibModal, moment, copyService, PermissionsService, PaginationQueryService, NodeAttributesFactory, WidgetsListService, BatchFactory, microSpinner, ColorService, NodeFactory, QueryFactory, Highcharts, postActionModelMessage, postActionModelIcon, $log) {
                var vm = this;
                var timezoneName = "";
                vm.parent = $scope.$parent;
                vm.isFullWidthDevice = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });
                vm.isNodeDetailsLoaded = false;
                vm.alarmObj = {};
                vm.resetalarmObj = {};
                vm.initNode = true;
                vm.chartData = [];
                vm.splineChartData = [];
                vm.selectedChartType = 'spline';
                vm.filter = "$";
                vm.attributeSearch = {$: ''};
                vm.selectedChartFor = 'Value';
                vm.selectedRange = "";
                vm.selectedChartData = [];
                vm.isShowNodeConnection = false;
                vm.isShowPlotNodeHealth = false;
                var connectionArr = [
                    {
                        name: "Connected",
                        value: 1,
                        color: '#218838'
                    },
                    {
                        name: "Disconnected",
                        value: -1,
                        color: '#C82333'
                    }
                ];
                vm.attributesList = [];
                vm.attributesStringValueArr = [];
                vm.tempAxesData = [
                    { // Primary yAxis
                        title: {
                            text: 'Values'
                        }
                    },
                    { // Primary yAxis
                        title: {
                            text: 'Health'
                        },
                        opposite: true,
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Connection'
                        },
                        opposite: true,
                        labels: {
                            formatter: function () {
                                return this.value === -1 ? 'Disconnected' : this.value // eslint-disable-line
                            }
                        },
                        categories: ['', 'Connected'],
                        visible: false
                    },
                    {
                        gridLineWidth: 0,
                        title: {
                            text: 'Attribute String Values'
                        },
                        opposite: true,
                        categories: vm.attributesStringValueArr,
                        visible: true
                    }
                ];
                vm.tempChartsData = [];
                vm.selectedHeatmapChartAttrObj = '';
                vm.axisArr = [
                    {
                        title: 'Minutes',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
                    },
                    {
                        title: 'Hours',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                    },
                    {
                        title: 'Days',
                        categories: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
                    },
                    {
                        title: 'Weeks',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54"]
                    },
                    {
                        title: 'Months',
                        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    }
                ];
                vm.mathFunction = [
                    {
                        title: 'MIN'
                    },
                    {
                        title: 'MAX'
                    },
                    {
                        title: 'AVG'
                    }
                ];
                vm.selectedMathFunction = 'MAX';
                vm.selectedXAxis = vm.axisArr[2];
                vm.selectedYAxis = vm.axisArr[0];
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "This Node",
                        name: 'nodeId',
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + ".data->>\'nodeId\' = '" + vm.parent.alarmObj.nodeId + "'",
                        localSearchValue: "obj.nodeId === '" + vm.parent.alarmObj.nodeId + "'"
                    }, {
                        displayName: "Node ID",
                        name: "nodeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "ECU ID",
                        name: "ecuId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Attribute ID",
                        name: "id",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'},
                    {name: 'receivedAt', displayName: 'Value Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.defaultAttributeFilterArr = [
                    {
                        displaySearchText: "",
                        displaySelectedField: "This Node",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isDirectFilterApply: true,
                        localSearchValue: "obj.nodeId === '" + vm.parent.alarmObj.nodeId + "'",
                        searchText: "",
                        selectedField: "nodeId",
                        sqlValue: "node_attributes.data->>\'nodeId\' = '" + vm.parent.alarmObj.nodeId + "'"
                    }, {
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        selectedField: "id",
                        selectedConnector: "and",
                        displaySelectedField: "Attribute ID",
                        selectedFilter: {
                            operatorName: "=",
                            operator: "="
                        },
                        searchText: vm.parent.alarmObj.id,
                        displaySearchText: vm.parent.alarmObj.id,
                        sqlValue: "node_attributes.data->>\'id\' = '" + vm.parent.alarmObj.id + "'"
                    }
                ];
                vm.perPage = 50;
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isShowPaginationContainer = true;
                vm.selectedPieChartData = {};
                vm.pieChartAttributeList = [];
                vm.heatmapChartAttributeList = [];
                vm.heatmapAttributeStringValueArr = [];
                vm.resetAttributeLists = [];
                var loaderModalInstance = "";
                vm.selectedAttribute = {};
                vm.plotableArr = [
                    {
                        name: 'Actual Value',
                        sortName: '[AV]',
                        dataType: 'Actual',
                        chartType: 'Value',
                        attrKey: 'isSelected'
                    },
                    {
                        name: 'Actual Health',
                        sortName: '[AH]',
                        dataType: 'Actual',
                        chartType: 'Health',
                        attrKey: 'isSelectedHealthPlot'
                    },
                    {
                        name: 'Forecast Value',
                        sortName: '[FV]',
                        dataType: 'Forecast',
                        chartType: 'Value',
                        attrKey: 'isSelectedForecast'
                    },
                    {
                        name: 'Forecast Health',
                        sortName: '[FH]',
                        dataType: 'Forecast',
                        chartType: 'Health',
                        attrKey: 'isSelectedForecastHealthPlot'
                    },
                    {
                        name: 'Value Anomaly',
                        sortName: '[VA]',
                        dataType: 'Anomaly',
                        chartType: 'Value',
                        attrKey: 'isSelectedAnomaly'
                    },
                    {
                        name: 'Health Anomaly',
                        sortName: '[HA]',
                        dataType: 'Anomaly',
                        chartType: 'Health',
                        attrKey: 'isSelectedAnomalyHealthPlot'
                    }
                ];
                vm.selectedAttrKeyArr = [
                    {
                        name: 'Name',
                        key: 'name'
                    },
                    {
                        name: 'Value',
                        key: 'value'
                    },
                    {
                        name: 'Units',
                        key: 'read'
                    },
                    {
                        name: 'Health',
                        key: 'health'
                    },
                    {
                        name: 'Ref',
                        key: 'reference'
                    },
                    {
                        name: 'ID',
                        key: 'id'
                    },
                    {
                        name: 'Type',
                        key: 'type'
                    },
                    {
                        name: 'Node',
                        key: 'nodeName'
                    },
                    {
                        name: 'Alarm',
                        key: 'id'
                    }
                ];
                vm.granularityArr = [
                    {
                        name: '1 minute',
                        config: {
                            title: 'MINUTES',
                            value: 1,
                            time: 60000
                        }
                    },
                    {
                        name: '2 minute',
                        config: {
                            title: 'MINUTES',
                            value: 2,
                            time: 60000
                        }
                    },
                    {
                        name: '5 minute',
                        config: {
                            title: 'MINUTES',
                            value: 5,
                            time: 60000
                        }
                    },
                    {
                        name: '15 minute',
                        config: {
                            title: 'MINUTES',
                            value: 15,
                            time: 60000
                        }
                    },
                    {
                        name: '30 minute',
                        config: {
                            title: 'MINUTES',
                            value: 30,
                            time: 60000
                        }
                    },
                    {
                        name: '1 hour',
                        config: {
                            title: 'HOURS',
                            value: 1,
                            time: 3600000
                        }
                    },
                    {
                        name: '3 hour',
                        config: {
                            title: 'HOURS',
                            value: 3,
                            time: 3600000
                        }
                    },
                    {
                        name: '6 hour',
                        config: {
                            title: 'HOURS',
                            value: 6,
                            time: 3600000
                        }
                    },
                    {
                        name: '1 day',
                        config: {
                            title: 'DAYS',
                            value: 1,
                            time: 86400000
                        }
                    }
                ];
                vm.selectedGranularity = vm.granularityArr[1];
                vm.chartUpdateTimeout = '';
                vm.selectedAutoUpdateType = "Static";

                vm.attributeNameContextMenu = function (attributeObj) {
                    var tempContextMenu = [{
                        text: 'Edit Name',
                        click: function () {
                            vm.fnEditAttributeName(attributeObj);
                        }
                    }];
                    if (attributeObj.mode === 'RW' || attributeObj.mode === 'rw') {
                        tempContextMenu.push({
                            text: 'Edit Value',
                            click: function () {
                                vm.fnEditAttributeValue(attributeObj);
                            }
                        });
                    }
                    if (vm.permissionObj.ENABLE_ATTRIBUTE || vm.permissionObj.DISABLE_ATTRIBUTE) {
                        if (attributeObj.operation && attributeObj.operation === 'DISABLED') {
                            tempContextMenu.push({
                                text: 'Enable Attribute',
                                click: function () {
                                    vm.fnEnableAttribute(attributeObj);
                                }
                            });
                        } else {
                            tempContextMenu.push({
                                text: 'Disable Attribute',
                                click: function () {
                                    vm.fnDisableAttribute(attributeObj);
                                }
                            });
                        }
                    }
                    if (attributeObj.syncState === 'NOT_SYNCHRONIZED') {
                        tempContextMenu.push({
                            text: 'Synchronize',
                            click: function () {
                                vm.fnDeployAttribute(attributeObj);
                            }
                        });
                    }
                    return tempContextMenu;
                };

                vm.attributeValueContextMenu = function (attributeObj) {
                    return [{
                        text: 'Edit Value',
                        click: function () {
                            vm.fnEditAttributeValue(attributeObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    // Cache current time calculation
                    var currentTime = moment().unix();

                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle standard timestamps
                        if (item.updated_at) {
                            parsedItem.updatedAt = moment(item.updated_at).valueOf() / 1000;
                            parsedItem.healthLastChangedAt = parsedItem.updatedAt;
                        }
                        if (item.created_at) {
                            parsedItem.createdAt = moment(item.created_at).valueOf() / 1000;
                        }

                        // Parse the data field if it exists and is a string
                        if (angular.isString(item.data)) {
                            try {
                                var parsedData = angular.fromJson(item.data);

                                // Set core fields from parsed data
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.health = parsedData.health;
                                parsedItem.attributeId = parsedData.attributeId;
                                parsedItem.ecuId = parsedData.ecuId;
                                parsedItem.nodeId = parsedData.nodeId;
                                parsedItem.projectId = parsedData.projectId;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.ecuName = parsedItem.ecuname;
                                parsedItem.nodeName = parsedItem.nodename;

                                // Set additional attribute-specific fields
                                parsedItem.reference = parsedData.reference;
                                parsedItem.mode = parsedData.mode;
                                parsedItem.read = {
                                    type: parsedData.type || 'STRING',
                                    unit: parsedData.unit || ''
                                };
                                parsedItem.value = parsedData.value;

                                // Handle timestamp and relative time in one go
                                if (parsedData.timestamp) {
                                    parsedItem.timestamp = parseInt(parsedData.timestamp);
                                    var timestamp = parseInt(parsedData.timestamp);
                                    var differenceHours = (currentTime - timestamp) / 3600;
                                    parsedItem.healthUpdatedDate = differenceHours > 24 ?
                                        moment.unix(timestamp).format("DD/MM/YYYY") :
                                        moment.unix(timestamp).fromNow();
                                }

                                // Set isAlarm flag
                                parsedItem.isAlarm = parsedItem.reference && parsedItem.reference.endsWith('!');

                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }

                        return parsedItem;
                    });
                }


                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.data, node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY (node_attributes.data->>\''+vm.sort.split(' ')[0]+'\')::text ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                        sqlString += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                    } else {
                        sqlString = 'WITH attributes AS ( SELECT node_attributes.data, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                        sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        sqlString += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'_id\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                    }
                    var input = {
                        sql: sqlString
                    };
                    if (vm.initNode === false) {
                        vm.isShowPaginationContainer = true;
                        vm.fnGetAttributes(input, true);
                    } else {
                        vm.isAttributesLoading = false;
                        vm.initNode = false;
                    }
                };

                vm.fnGetAttributes = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            try {
                                vm.attributesList = [];

                                // Store total items count if this is first page
                                if (isFirst && res.data && res.data.length) {
                                    vm.totalItems = res.data[0].totalItems + 1;
                                    vm.currentPage = 1;
                                }

                                // Reverse data if needed
                                if (inputObj.isNeedDataReverse) {
                                    res.data.reverse();
                                }

                                // Parse the PostgreSQL data using our parsing function
                                var parsedData = parsePostgresData(res.data);

                                // Store the parsed data
                                vm.resetAttributeLists = _.cloneDeepWith(parsedData);

                                // Generate attribute list using parsed data
                                vm.fnGenerateAttributesList();
                                vm.isAttributesLoading = false;
                            } catch (err) {
                                $log.error('Error parsing attribute data:', err);
                                amaran.error('Error processing attribute data');
                                vm.isAttributesLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributesLoading = false;
                        })
                };

                vm.fnGenerateAttributesList = function () {
                    vm.attributesList = [];
                    _.forEach(vm.resetAttributeLists, function (attributeObj) {
                        attributeObj.displayName = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.name = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        attributeObj.type = 'attribute';
                        var tempActualObj = _.cloneDeepWith(attributeObj);
                        tempActualObj.isSelected = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Actual Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Forecast Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Value)",
                            id: tempActualObj.id
                        }) !== -1;
                        tempActualObj.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                            name: tempActualObj.name + " (Anomaly Health)",
                            id: tempActualObj.id
                        }) !== -1;
                        vm.attributesList.push(tempActualObj);
                        if (vm.selectedAttribute.id === tempActualObj.id) {
                            vm.selectedAttribute = tempActualObj;
                        }
                    });
                    vm.fnSortAttributesByPlot();
                };

                vm.fnSortAttributesByPlot = function () {
                    //vm.attributesList = _.orderBy(vm.attributesList, ['isSelected', 'isSelectedHealthPlot', 'isSelectedForecast', 'isSelectedForecastHealthPlot', 'isSelectedAnomaly', 'isSelectedAnomalyHealthPlot'], ['desc', 'desc', 'desc', 'desc', 'desc', 'desc']);
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isAttributesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_attributes.data, node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_attributes as node_attributes';
                    } else { //for general sort
                        sqlString = 'SELECT node_attributes.data, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.data, node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY (node_attributes.data->>\''+vm.sort.split(' ')[0]+'\')::text ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.data, node_attributes.data->>\'_id\' AS rt FROM node_attributes as node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'_id\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAttributes(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.attributesList, true, 'node_attributes');
                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }
                        var newSQL = "WITH attributes AS (" + tempNewSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes";
                        newSQL += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                        if (sortString !== '') { //for specific sort
                            newSQL += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                        } else { //for general sort
                            newSQL += 'SELECT att.data, node_ecus.data->>\'name\' as ecuName, rows.qty AS totalItems, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, CASE WHEN (att.data->>\'ecuId\') = (att.data->>\'nodeId\') THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId, att.data->>\'_id\' AS rt FROM attributes AS att LEFT JOIN node_ecus ON (att.data->>\'ecuId\') = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON (att.data->>\'nodeId\') = node_nodes.data->>\'id\', rows';
                        }
                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }
                        vm.previousPage = page;
                        vm.fnGetAttributes(newInput, false);
                    }
                };

                vm.fnOnActionDrop = function (srcList, dataType, chatsType) {
                    var isAllow = false;
                    if (vm.selectedChartType === 'pie') {
                        isAllow = !(dataType === 'Forecast' || dataType === 'Anomaly');
                    } else {
                        isAllow = true;
                    }
                    if (isAllow) {
                        var chartType = "";
                        var tempType = "";
                        if (chatsType === 'Value') {
                            chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                            tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        } else {
                            chartType = srcList.type === 'node' ? 'nodeHealth' : 'attributeHealth';
                            tempType = 'Health';
                        }
                        //var chartType = srcList.type === 'node' ? 'nodeConnection' : 'attributeValue';
                        //var tempType = srcList.type === 'node' ? 'Connection' : 'Value';
                        var isFindIndex = _.findIndex(vm.selectedChartData, {
                            name: srcList.name + " (" + dataType + " " + tempType + ")",
                            chartType: chartType,
                            id: srcList.id
                        });
                        if (isFindIndex === -1) {
                            if (chatsType === 'Value') {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeConnection';
                                } else {
                                    srcList.chartType = 'attributeValue';
                                }
                            } else {
                                if (srcList.type === 'node') {
                                    srcList.chartType = 'nodeHealth';
                                } else {
                                    srcList.chartType = 'attributeHealth';
                                }
                            }
                            srcList.dataType = _.cloneDeepWith(dataType);
                            if (chatsType === 'Value') {
                                if (dataType === 'Actual') {
                                    srcList.isSelected = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecast = true;
                                } else {
                                    srcList.isSelectedAnomaly = true;
                                }
                            } else {
                                if (dataType === 'Actual') {
                                    srcList.isSelectedHealthPlot = true;
                                } else if (dataType === 'Forecast') {
                                    srcList.isSelectedForecastHealthPlot = true;
                                } else {
                                    srcList.isSelectedAnomalyHealthPlot = true;
                                }
                            }
                            var tempSrcList = _.cloneDeepWith(srcList);
                            tempSrcList.name = tempSrcList.name + " (" + dataType + " " + tempType + ")";
                            vm.selectedChartData.push(tempSrcList);
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (!(dataType === 'Forecast' || dataType === 'Anomaly')) {
                                vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                            }
                            if (vm.selectedChartType === 'heatmap') {
                                vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                            }
                            if (vm.selectedChartType === 'pie') {
                                vm.selectedPieChartData = vm.pieChartAttributeList[0];
                            }
                            $timeout(function () {
                                vm.fnGetAttributeAnalyticsData(srcList);
                            });
                        } else {
                            amaran.error('Attribute already added on chart.');
                        }
                    } else {
                        amaran.error('Attribute type is not allows for pie chart type.');
                    }
                };

                vm.fnGetAttributeAnalyticsData = function (srcList) {
                    var sql = vm.fnGetSQLQuery(srcList);
                    var chartContainerEle = angular.element(".chart-container-height");
                    loaderModalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                        size: 'md',
                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                        appendTo: chartContainerEle
                    });
                    QueryFactory.executeQuery({'sql': sql})
                        .then(function (res) { // Success block
                            vm.selectedChartData[vm.selectedChartData.length - 1].sql = sql;
                            vm.selectedChartData[vm.selectedChartData.length - 1].apiData = res.data;
                            vm.selectedChartData[vm.selectedChartData.length - 1].chartData = vm.fnGenerateChartData(srcList, res.data);
                            var tempType = srcList.chartType === 'nodeConnection' || srcList.chartType === 'attributeValue' ? 'Value' : 'Health';
                            var tempName = srcList.name + " (" + srcList.dataType + " " + tempType + ")";
                            var isFind = _.find(vm.pieChartAttributeList, {
                                name: tempName,
                                id: srcList.id
                            });
                            if (isFind) {
                                isFind.apiData = res.data;
                                isFind.chartData = vm.selectedChartData[vm.selectedChartData.length - 1].chartData;
                            }
                            if (vm.selectedChartType !== 'heatmap') {
                                loaderModalInstance.dismiss();
                                loaderModalInstance = "";
                            }
                            $timeout(function () {
                                vm.fnRenderChart();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            loaderModalInstance.dismiss();
                            loaderModalInstance = "";
                            vm.fnRemoveChartData(srcList)
                        })
                };

                vm.fnRenderChart = function () {
                    if (vm.selectedChartData.length) {
                        if (vm.selectedChartType === 'pie') {
                            vm.chartData = [];
                            var counts = {};
                            if (vm.selectedPieChartData && vm.selectedPieChartData.chartType) {
                                if (vm.selectedPieChartData.chartType === "nodeHealth" || vm.selectedPieChartData.chartType === "attributeHealth") {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.health] = (counts[x.health] || 0) + 1;
                                    });
                                } else {
                                    vm.selectedPieChartData.apiData.forEach(function (x) {
                                        counts[x.value] = (counts[x.value] || 0) + 1;
                                    });
                                }
                                _.forEach(counts, function (value, key) {
                                    vm.chartData.push({
                                        name: key,
                                        y: value
                                    });
                                });
                                $timeout(function () {
                                    Highcharts.chart('nodeAttributeChart', {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: 'pie'
                                        },
                                        title: {
                                            text: ''
                                        },
                                        tooltip: {
                                            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        accessibility: {
                                            point: {
                                                valueSuffix: ''
                                            }
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: true,
                                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                                }
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: 'Value',
                                            colorByPoint: true,
                                            data: vm.chartData
                                        }]
                                    });
                                });
                            }
                        }
                        if (vm.selectedChartType === 'heatmap') {
                            if (angular.isDefined(vm.selectedHeatmapChartAttr) && vm.selectedHeatmapChartAttr.name.length) {
                                var sql = vm.fnGetHeatMapSQLQuery(vm.selectedHeatmapChartAttr);
                                if (loaderModalInstance === '') {
                                    var chartContainerEle = angular.element(".chart-container-height");
                                    loaderModalInstance = $uibModal.open({
                                        backdrop: 'static',
                                        templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                                        size: 'md',
                                        controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                                        windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                                        appendTo: chartContainerEle
                                    });
                                }
                                QueryFactory.executeQuery({'sql': sql})
                                    .then(function (res) { // Success block
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.selectedHeatmapChartAttr.apiData = _.cloneDeepWith(res.data);
                                        var chartData = vm.fnGenerateHeatMapChartData(vm.selectedHeatmapChartAttr, _.cloneDeepWith(res.data));
                                        var chartName = '';
                                        if (angular.isDefined(vm.selectedHeatmapChartAttr.chartType) && vm.selectedHeatmapChartAttr.chartType === 'attributeValue') {
                                            chartName = 'Value';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'attributeHealth' || vm.selectedHeatmapChartAttr.chartType === 'nodeHealth') {
                                            chartName = vm.selectedHeatmapChartAttr.type === 'node' ? 'Node Health' : 'Health';
                                        }
                                        if (vm.selectedHeatmapChartAttr.chartType === 'nodeConnection') {
                                            chartName = 'Connection';
                                        }
                                        var isStringFound = false;
                                        _.forEach(res.data, function (dataObj) {
                                            if (dataObj.value && isNaN(dataObj.value)) {
                                                isStringFound = true;
                                            }
                                        });
                                        Highcharts.chart("nodeAttributeHeatmapChart", {
                                            chart: {
                                                type: 'heatmap'
                                            },
                                            exporting: {
                                                enabled: false
                                            },
                                            boost: {
                                                useGPUTranslations: true
                                            },
                                            legend: {
                                                enabled: false
                                            },
                                            title: {
                                                text: ''
                                            },
                                            subtitle: {
                                                text: ''
                                            },
                                            xAxis: {
                                                title: {
                                                    text: vm.selectedXAxis.title
                                                },
                                                categories: vm.selectedXAxis.categories,
                                                labels: {
                                                    format: vm.selectedXAxis.title === 'Hours' || vm.selectedXAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                }
                                            },
                                            yAxis: {
                                                categories: vm.selectedYAxis.categories,
                                                title: {
                                                    text: vm.selectedYAxis.title
                                                },
                                                reversed: false,
                                                labels: {
                                                    format: vm.selectedYAxis.title === 'Hours' || vm.selectedYAxis.title === 'Minutes' ? '{value}:00' : '{value}' // long month
                                                },
                                                //startOnTick: false,
                                                endOnTick: false
                                            },
                                            credits: {
                                                enabled: false
                                            },
                                            colorAxis: {
                                                maxColor: Highcharts.getOptions().colors[0]
                                            },
                                            tooltip: {
                                                formatter: function () {
                                                    var tooltip = '';
                                                    if (this.series.name === 'Connection') { //eslint-disable-line
                                                        tooltip = '<b>Node Connection: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    } else if (this.series.name === 'Value') { //eslint-disable-line
                                                        var displayName = '';
                                                        if (isStringFound) {
                                                            displayName = this.point.name ? this.point.name : null; //eslint-disable-line
                                                        } else {
                                                            displayName = this.point.value; //eslint-disable-line
                                                        }
                                                        tooltip = '<b>Value: ' + displayName + '</b>'; //eslint-disable-line
                                                    } else {
                                                        tooltip = '<b>Health: ' + this.point.value + '</b>'; //eslint-disable-line
                                                    }
                                                    return tooltip //eslint-disable-line
                                                }
                                            },
                                            series: [{
                                                boostThreshold: 100,
                                                borderWidth: 0,
                                                data: chartData,
                                                name: chartName,
                                                nullColor: '#FFFFFF',
                                                turboThreshold: chartData.length + 100 // #3404, remove after 4.0.5 release
                                            }]
                                        })
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                        vm.fnRemoveChartData(vm.selectedHeatmapChartAttr);
                                    });
                            }
                        }
                        if (vm.selectedChartType === 'spline' || vm.selectedChartType === 'bar') {
                            vm.splineChartData = [];
                            _.forEach(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.type === 'node') {
                                    if (chartDataObj.chartType === 'nodeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            yAxis: 1,
                                            data: chartDataObj.chartData,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempNodeHealthArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempNodeHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempNodeHealthAnomalyArr);
                                        }
                                    } else {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            yAxis: 2,
                                            data: chartDataObj.chartData,
                                            tooltip: {
                                                formatter: function () {
                                                    return '<b>' + moment(this.point.x).format('MM/DD/YYYY HH:mm') + '</b><br><b style="color:' + this.point.color + '">' + this.point.series.name + '</b><br><b>' + this.point.name + '</b><br/>'; //eslint-disable-line
                                                }
                                            },
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var tempConnectionForecastArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionForecast'),
                                                type: 'arearange',
                                                yAxis: 2,
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionForecastArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var tempConnectionAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ConnectionAnomaly'),
                                                type: 'arearange',
                                                lineWidth: 0,
                                                yAxis: 2,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                }
                                            };
                                            vm.splineChartData.push(tempConnectionAnomalyArr);
                                        }
                                    }
                                } else {
                                    if (chartDataObj.chartType === 'attributeHealth') {
                                        vm.splineChartData.push({
                                            name: chartDataObj.name,
                                            data: chartDataObj.chartData,
                                            yAxis: 1,
                                            type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                            boostThreshold: 100,
                                            turboThreshold: chartDataObj.chartData.length + 100
                                        });
                                        if (chartDataObj.dataType === 'Forecast') {
                                            var healthForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthForecast');
                                            var tempHealthArr = {
                                                name: chartDataObj.name,
                                                data: healthForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthForecast.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var healthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'HealthAnomaly');
                                            var tempHealthAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: healthAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                yAxis: 1,
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: healthAnomaly.length + 100
                                            };
                                            vm.splineChartData.push(tempHealthAnomalyArr);
                                        }
                                    } else {
                                        if (chartDataObj.value && isNaN(chartDataObj.value)) {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                yAxis: 3,
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        } else {
                                            vm.splineChartData.push({
                                                name: chartDataObj.name,
                                                data: chartDataObj.chartData,
                                                type: vm.selectedChartType === 'spline' ? 'line' : 'column',
                                                boostThreshold: 100,
                                                turboThreshold: chartDataObj.chartData.length + 100
                                            });
                                        }

                                        if (chartDataObj.dataType === 'Forecast') {
                                            var isStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueForecast = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueForecast');
                                            var tempArr = {
                                                name: chartDataObj.name,
                                                data: valueForecast,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueForecast.length + 100
                                            };
                                            if (isStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempArr);
                                        }
                                        if (chartDataObj.dataType === 'Anomaly') {
                                            var isAnomalyStringFound = false;
                                            _.forEach(chartDataObj.apiData, function (dataObj) {
                                                if (dataObj.value && isNaN(dataObj.value)) {
                                                    isStringFound = true;
                                                }
                                            });
                                            var valueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(chartDataObj, 'ValueAnomaly')
                                            var tempValueAnomalyArr = {
                                                name: chartDataObj.name,
                                                data: valueAnomaly,
                                                type: 'arearange',
                                                lineWidth: 0,
                                                linkedTo: ':previous',
                                                color: Highcharts.getOptions().colors[vm.splineChartData.length - 1],
                                                fillOpacity: 0.3,
                                                zIndex: 0,
                                                marker: {
                                                    enabled: false
                                                },
                                                boostThreshold: 100,
                                                turboThreshold: valueAnomaly.length + 100
                                            };
                                            if (isAnomalyStringFound || (chartDataObj.value && isNaN(chartDataObj.value))) {
                                                tempValueAnomalyArr.yAxis = 3
                                            }
                                            vm.splineChartData.push(tempValueAnomalyArr);
                                        }
                                    }
                                }
                            });

                            var isFindNodeConnection = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeConnection') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[2].visible = !!isFindNodeConnection;
                            var isFindHealthAxes = _.find(vm.selectedChartData, function (chartDataObj) {
                                if (chartDataObj.chartType === 'nodeHealth' || chartDataObj.chartType === 'attributeHealth') {
                                    return chartDataObj;
                                }
                            });
                            vm.tempAxesData[1].visible = !!isFindHealthAxes;
                            $timeout(function () {
                                Highcharts.chart('nodeAttributeChart', {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        type: 'datetime',
                                        labels: {
                                            formatter: function () {
                                                return moment(this.value).format('MM/DD HH:mm'); // eslint-disable-line
                                            },
                                            rotation: -60
                                        },
                                        title: {
                                            text: ''
                                        }
                                    },
                                    yAxis: vm.tempAxesData,
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    series: vm.splineChartData
                                });
                            });
                        }
                        vm.fnSortAttributesByPlot();
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRemoveChartData = function (selectedObj) {
                    var isFindIndex = _.findIndex(vm.selectedChartData, {name: selectedObj.name, id: selectedObj.id});
                    if (isFindIndex !== -1) {
                        vm.selectedChartData.splice(isFindIndex, 1);
                        vm.fnGenerateAttributesList();
                    }
                    var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindPieDataIndex !== -1) {
                        vm.pieChartAttributeList.splice(isFindPieDataIndex, 1);
                        if (vm.pieChartAttributeList && vm.pieChartAttributeList.length) {
                            vm.selectedPieChartData = vm.pieChartAttributeList[0];
                        } else {
                            vm.selectedPieChartData = "";
                        }
                    }
                    var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                        name: selectedObj.name,
                        id: selectedObj.id
                    });
                    if (isFindHeatmapDataIndex !== -1) {
                        vm.heatmapChartAttributeList.splice(isFindHeatmapDataIndex, 1);
                        if (vm.heatmapChartAttributeList && vm.heatmapChartAttributeList.length) {
                            vm.selectedHeatmapChartAttr = vm.heatmapChartAttributeList[0];
                        } else {
                            vm.selectedHeatmapChartAttr = '';
                        }
                    }
                    $timeout(function () {
                        vm.fnRenderChart();
                    });
                };

                vm.fnGetHealthColor = function (attrCode, attrObj) {
                    var attrStyle = ColorService.getHealthColorForLoop(attrObj.projectId, attrCode);
                    attrObj.healthName = attrStyle.content;
                    return attrStyle;
                };

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };

                vm.fnGetAttributeInfo = function () {
                    vm.alarmObj = vm.parent.alarmObj;
                    vm.alarmObj.nodeName = _.cloneDeepWith(vm.parent.alarmObj.nodeName ? vm.parent.alarmObj.nodeName : "");
                    vm.resetalarmObj = angular.copy(vm.alarmObj);
                    vm.isAttributeDetailsLoaded = true;
                    vm.attributesList = [];
                    //vm.nodeObj.attributes = angular.copy(vm.alarmObj);
                    vm.resetAttributeLists = _.cloneDeepWith([vm.alarmObj]);
                    vm.totalItems = 1;
                    vm.fnGenerateAttributesList();
                    $timeout(function () {
                        TabHeight.fnSet();
                        vm.fnRenderChart();
                        var start = moment().subtract(3, 'hours');
                        var end = moment();
                        $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            opens: 'left',
                            startDate: start,
                            endDate: end,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            ranges: {
                                'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                                'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                                'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                                'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                                'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                                'Today': [moment().startOf('day'), moment()],
                                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                            },
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end, label) {
                            if (label === 'Custom Range') {
                                vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                            } else {
                                if (label === "Last 1 Hour") {
                                    vm.selectedRange = moment().subtract(1, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Hour") {
                                    vm.selectedRange = moment().subtract(3, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Days") {
                                    vm.selectedRange = moment().subtract(3, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 1 Week") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Week") {
                                    vm.selectedRange = moment().subtract(20, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Today") {
                                    vm.selectedRange = moment().startOf('day').format('X') + "," + moment().format('X');
                                } else if (label === "Yesterday") {
                                    vm.selectedRange = moment().subtract(1, 'days').startOf('day').format('X') + "," + moment().subtract(1, 'days').endOf('days').format('X');
                                } else if (label === "Last 7 Days") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 30 Days") {
                                    vm.selectedRange = moment().subtract(29, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "This Month") {
                                    vm.selectedRange = moment().startOf('month').format('X') + "," + moment().endOf('month').format('X');
                                } else {//"Last Month"
                                    vm.selectedRange = moment().subtract(1, 'month').startOf('month').format('X') + "," + moment().subtract(1, 'month').endOf('month').format('X');
                                }
                            }
                            if (angular.isDefined(angular.element("#selectedDate")[0])) {
                                document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                            }
                            var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                            var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                            var timeDifference = moment(endTime).diff(startTime, 'hours');
                            var rangeDiff = 1;
                            var rangeType = 'MINUTES';
                            if (timeDifference <= 1) {
                                rangeDiff = 1;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 1 && timeDifference <= 3) {
                                rangeDiff = 2;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 3 && timeDifference <= 6) {
                                rangeDiff = 5;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 6 && timeDifference <= 12) {
                                rangeDiff = 15;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 12 && timeDifference <= 24) {
                                rangeDiff = 30;
                                rangeType = 'MINUTES';
                            } else if (timeDifference >= 24 && timeDifference <= 72) {
                                rangeDiff = 1;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 72 && timeDifference <= 168) {
                                rangeDiff = 3;
                                rangeType = 'HOURS';
                            } else if (timeDifference >= 168 && timeDifference <= 720) {
                                rangeDiff = 6;
                                rangeType = 'HOURS';
                            } else {
                                rangeDiff = 1;
                                rangeType = 'DAYS';
                            }
                            var isFind = _.find(vm.granularityArr, function (obj) {
                                return obj.config.title === rangeType && obj.config.value === rangeDiff;
                            })
                            if (isFind) {
                                vm.selectedGranularity = _.cloneDeepWith(isFind);
                            }
                            //vm.fnRenderChart();
                            vm.fnDataRangeChange();
                        });
                        vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                        }
                        //vm.fnOnActionDrop(vm.attributesList[0], 'Actual');
                        vm.attributesList[0].chartType = 'attributeValue';
                        vm.attributesList[0].dataType = _.cloneDeepWith('Actual');
                        vm.attributesList[0].isSelected = true;
                        var tempSrcList = _.cloneDeepWith(vm.attributesList[0]);
                        tempSrcList.name = tempSrcList.name + " (Actual Value)";
                        vm.selectedChartData.push(tempSrcList);
                        vm.pieChartAttributeList.push(_.cloneDeepWith(tempSrcList));
                        vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempSrcList));

                        vm.attributesList[0].chartType = 'attributeHealth';
                        vm.attributesList[0].dataType = _.cloneDeepWith('Actual');
                        vm.attributesList[0].isSelectedHealthPlot = true;
                        var tempHealthSrcList = _.cloneDeepWith(vm.attributesList[0]);
                        tempHealthSrcList.name = tempHealthSrcList.name + " (Actual Health)";
                        vm.selectedChartData.push(tempHealthSrcList);
                        vm.selectedAttribute = _.cloneDeepWith(vm.attributesList[0]);
                        vm.pieChartAttributeList.push(_.cloneDeepWith(tempHealthSrcList));
                        vm.heatmapChartAttributeList.push(_.cloneDeepWith(tempHealthSrcList));
                        vm.fnDataRangeChange();
                    },1000);
                };

                vm.fnSelectPieChartAttr = function (chartObj) {
                    var isFind = _.find(vm.pieChartAttributeList, {name: chartObj.name});
                    if (isFind) {
                        vm.selectedPieChartData = isFind;
                        $timeout(function () {
                            vm.fnRenderChart();
                        })
                    }
                };


                vm.fnGetSQLQuery = function (srcList) {
                    // Configuration maps
                    var TABLE_MAP = {
                        node: {
                            health: {
                                actual: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies'
                            },
                            connection: {
                                actual: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies'
                            }
                        },
                        attribute: {
                            health: {
                                actual: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies'
                            },
                            value: {
                                actual: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies'
                            }
                        }
                    };

                    // Determine key parameters
                    var previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');

                    var totalDuration = endTime.diff(startTime);
                    var rangeDiff = vm.selectedGranularity.config.value;
                    var rangeType = vm.selectedGranularity.config.title;
                    var totalRange = parseInt(totalDuration / vm.selectedGranularity.config.time);

                    // Determine data source type and details
                    var dataType = srcList.dataType.toLowerCase();
                    var sourceType = srcList.type === 'node' ? 'node' : 'attribute';
                    var chartType = srcList.chartType.replace('node', '').toLowerCase();

                    // Select appropriate table
                    var table = TABLE_MAP[sourceType][chartType][dataType];
                    var idColumn = sourceType === 'node' ? 'nodeId' : 'attributeId';

                    // Dynamic column and value selections based on chart type
                    var valueColumnName = chartType === 'health' ? 'health' :
                        chartType === 'connection' ? 'connected' : 'value';

                    // varruct SQL query with dynamic components
                    var sql = "" +
                        "WITH readings AS (" +
                        "    (SELECT " +
                        "        data->>'timestamp' as timestamps, " +
                        "        data->>'"+idColumn+"' as id, " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) as ts, " +
                        "        data->>'"+valueColumnName+"' as value, " +
                        (dataType !== 'actual' ? "data->>'confidence' as confidence, data->>'type' as type" : "") +
                        "    FROM "+table+" " +
                        "    WHERE " +
                        "        data->>'"+idColumn+"' = '"+srcList.id+"' AND " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) < TIMESTAMP '"+previousDateString+"' " +
                        "    ORDER BY ts DESC LIMIT 1)" +
                        "    UNION" +
                        "    (SELECT " +
                        "        data->>'timestamp' as timestamps, " +
                        "        data->>'"+idColumn+"' as id, " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) as ts, " +
                        "        data->>'"+valueColumnName+"' as value, " +
                        (dataType !== 'actual' ? "data->>'confidence' as confidence, data->>'type' as type" : "") +
                        "    FROM "+table+" " +
                        "    WHERE " +
                        "        data->>'"+idColumn+"' = '"+srcList.id+"' AND " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) > TIMESTAMP '"+previousDateString+"' AND" +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) < TIMESTAMP '"+endDateString+"')" +
                        ")," +
                        "slots AS (" +
                        "    SELECT " +
                        "        TIMESTAMP '"+previousDateString+"' + "+rangeType+"(u.i - "+rangeDiff+") AS last_ts, " +
                        "        TIMESTAMP '"+previousDateString+"' + "+rangeType+"(u.i) AS ts " +
                        "    FROM UNNEST(SEQUENCE(0, "+totalRange+", "+rangeDiff+")) AS u" +
                        ")," +
                        "slot_values AS (" +
                        "    SELECT " +
                        "        filled_slots.ts, " +
                        "        MAX(value) AS last_val, " +
                        (dataType !== 'actual' ? "MAX(confidence) AS last_confidence, MAX(type) AS last_type," : "") +
                        "        MAX(in_interval_r.value) AS slot_agg_val " +
                        (dataType !== 'actual' ? ", MAX(in_interval_r.confidence) AS slot_agg_confidence, MAX(in_interval_r.type) AS slot_agg_type" : "") +
                        "    FROM slots filled_slots" +
                        "    LEFT JOIN readings previous_r ON previous_r.ts <= filled_slots.ts" +
                        "    LEFT JOIN readings in_interval_r ON " +
                        "        in_interval_r.ts < filled_slots.ts AND " +
                        "        in_interval_r.ts > filled_slots.last_ts" +
                        "    GROUP BY filled_slots.ts" +
                        ")," +
                        "final_values AS (" +
                        "    SELECT " +
                        "        CAST(ts AT TIME ZONE '"+timezoneName+"' AS string) AS ts," +
                        "        COALESCE(" +
                        "            slot_agg_val, " +
                        "            LAG(slot_agg_val, 1) OVER (ORDER BY ts), " +
                        "            last_val" +
                        "        ) AS value " +
                        (dataType !== 'actual' ?
                            ", COALESCE(" +
                            "            slot_agg_confidence, " +
                            "            LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), " +
                            "            last_confidence" +
                            "        ) AS confidence" +
                            ", COALESCE(" +
                            "            slot_agg_type, " +
                            "            LAG(slot_agg_type, 1) OVER (ORDER BY ts), " +
                            "            last_type" +
                            "        ) AS type"
                            : "") +
                        "    FROM slot_values" +
                        ")," +
                        "SELECT * FROM final_values ORDER BY ts;";

                    return sql;
                };

                vm.fnGetHeatMapSQLQuery = function (srcList) {
                    // Configuration maps for axis extraction
                    var AXIS_EXTRACT_MAP = {
                        'Minutes': 'MINUTE',
                        'Hours': 'HOUR',
                        'Days': 'DAYOFWEEK',
                        'Weeks': 'ISOWEEK',
                        'Months': 'MONTH'
                    };

                    // Table mapping
                    var TABLE_MAP = {
                        node: {
                            health: 'node_iot_node_healths',
                            connection: 'node_iot_node_connections'
                        },
                        attribute: {
                            health: 'node_iot_attribute_healths',
                            value: 'node_iot_attribute_values'
                        }
                    };

                    // Timestamp calculations
                    var startDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    // Dynamic axis extraction
                    var selectedXAxisQString = "EXTRACT(" +
                        (AXIS_EXTRACT_MAP[vm.selectedXAxis.title] || 'MONTH') +
                        " FROM TIMESTAMP_SECONDS(data->>'timestamp')) as x";

                    var selectedYAxisQString = "EXTRACT(" +
                        (AXIS_EXTRACT_MAP[vm.selectedYAxis.title] || 'MONTH') +
                        " FROM TIMESTAMP_SECONDS(data->>'timestamp')) as y";

                    // Determine source type and chart type
                    var sourceType = srcList.type === 'node' ? 'node' : 'attribute';
                    var chartType = srcList.chartType.replace('node', '').toLowerCase();

                    // Select table and column details
                    var table = TABLE_MAP[sourceType][chartType];
                    var idColumn = sourceType === 'node' ? 'nodeId' : 'attributeId';
                    var valueColumn = chartType === 'health' ? 'health' : 'value';

                    // varruct dynamic SQL
                    var sql = "" +
                        "SELECT " +
                        "    TIMESTAMP_SECONDS(data->>'timestamp') AS date, " +
                        "    " + selectedYAxisQString + ", " +
                        "    " + selectedXAxisQString + ", " +
                        "    CASE WHEN data->>'valueType' = 'FLOAT' THEN CAST(data->>'"+valueColumn+"' AS FLOAT) ELSE data->>'"+valueColumn+"' END, " +
                        "    data->>'"+valueColumn+"' as value " +
                        (chartType === 'health' ? ", data->>'projectId' " : "") +
                        "FROM " + table + " " +
                        "WHERE " +
                        "    TIMESTAMP_SECONDS(data->>'timestamp') > TIMESTAMP '" + startDateString + "' " +
                        "    AND TIMESTAMP_SECONDS(data->>'timestamp') < TIMESTAMP '" + endDateString + "' " +
                        "    AND data->>'"+idColumn+"' = '" + srcList.id + "'";

                    return sql;
                };

                vm.fnGenerateHeatMapChartData = function (srcList, apiRes) {
                    var chartData = [];
                    var isStringFound = false;
                    vm.heatmapAttributeStringValueArr = [];
                    _.forEach(apiRes, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                        if (dataObj.value && dataObj.value !== '' && vm.heatmapAttributeStringValueArr.indexOf(dataObj.value) === -1) {
                            vm.heatmapAttributeStringValueArr.push(dataObj.value);
                        }
                    });
                    if (!isStringFound) {
                        vm.heatmapAttributeStringValueArr = [];
                    }
                    _.forEach(vm.selectedXAxis.categories, function (xAxisCategoriesObj, xAxisIndex) {
                        _.forEach(vm.selectedYAxis.categories, function (yAxisCategoriesObj, yAxisIndex) {
                            var newXAxisIndex = _.cloneDeepWith(xAxisIndex);
                            var newYAxisIndex = _.cloneDeepWith(yAxisIndex);
                            if (vm.selectedXAxis.title === 'Days' || vm.selectedXAxis.title === 'Months') {
                                newXAxisIndex = newXAxisIndex + 1;
                            }
                            if (vm.selectedYAxis.title === 'Days' || vm.selectedYAxis.title === 'Months') {
                                newYAxisIndex = newYAxisIndex + 1;
                            }
                            var minValue = 0;
                            var maxValue = 0;
                            var avgValue = 0;
                            var isFindData = _.filter(apiRes, {x: newXAxisIndex, y: newYAxisIndex});
                            if (isFindData && isFindData.length) {
                                minValue = isFindData[0].value;
                                maxValue = isFindData[0].value;
                                var sum = 0;
                                avgValue = 0;
                                if (srcList.chartType === 'nodeConnection') {
                                    if (isFindData && isFindData.length > 1) {
                                        var connectedArr = _.filter(isFindData, {value: true});
                                        var disconnectedArr = _.filter(isFindData, {value: false});
                                        minValue = connectedArr.length < disconnectedArr.length;
                                        maxValue = connectedArr.length >= disconnectedArr.length;
                                        avgValue = isFindData.reduce(function (sum, next) {
                                            return sum && next.value;
                                        }, true);
                                    } else {
                                        minValue = isFindData[0].value;
                                        maxValue = isFindData[0].value;
                                        avgValue = isFindData[0].value;
                                    }
                                } else {
                                    if (isStringFound) {
                                        if (isFindData && isFindData.length > 1) {
                                            var groupData = _.groupBy(isFindData, function (n) {
                                                return n.value;
                                            });
                                            var minLength = Object.values(groupData)[0].length;
                                            var maxLength = Object.values(groupData)[0].length;
                                            minValue = Object.keys(groupData)[0];
                                            maxValue = Object.keys(groupData)[0];
                                            _.forEach(isFindData, function (findObj, key) {
                                                if (findObj.length < minLength) {
                                                    minValue = key;
                                                    minLength = findObj.length;
                                                }
                                                if (findObj.length > maxLength) {
                                                    maxValue = key;
                                                    maxLength = findObj.length;
                                                }
                                            });
                                            avgValue = isFindData.reduce(function (sum, next) {
                                                return sum && next.value;
                                            }, true);
                                        } else {
                                            minValue = isFindData[0].value;
                                            maxValue = isFindData[0].value;
                                            avgValue = isFindData[0].value;
                                        }
                                    } else {
                                        _.forEach(isFindData, function (findObj) {
                                            findObj.value = Number(findObj.value);
                                            if (findObj.value < minValue) {
                                                minValue = findObj.value;
                                            }
                                            if (findObj.value > maxValue) {
                                                maxValue = findObj.value;
                                            }
                                            sum = sum + findObj.value;
                                        });
                                        avgValue = sum / isFindData.length;
                                    }
                                }
                                var value = null;
                                if (vm.selectedMathFunction === 'MIN') {
                                    value = minValue;
                                } else if (vm.selectedMathFunction === 'MAX') {
                                    value = maxValue;
                                } else {
                                    value = avgValue;
                                }
                                if (srcList.chartType === 'nodeHealth') {
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value,
                                        color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                    })
                                } else if (srcList.chartType === 'nodeConnection') {
                                    var tempConnectionObj = _.find(connectionArr, {value: value === true ? 1 : -1});
                                    chartData.push({
                                        x: xAxisIndex,
                                        y: yAxisIndex,
                                        value: value !== '' ? tempConnectionObj.name : null,
                                        color: value !== '' ? tempConnectionObj.color : '#FFFFFF'
                                    })
                                } else {
                                    if (srcList.chartType === 'attributeValue') {
                                        if (isStringFound) {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: vm.heatmapAttributeStringValueArr.indexOf(value),
                                                name: value
                                            })
                                        } else {
                                            chartData.push({
                                                x: xAxisIndex,
                                                y: yAxisIndex,
                                                value: Number(value)
                                            })
                                        }
                                    } else {
                                        chartData.push({
                                            x: xAxisIndex,
                                            y: yAxisIndex,
                                            value: value,
                                            color: value === "" ? '#FFFFFF' : vm.fnGetHealthColor(value, {projectId: isFindData[0].projectId})['background-color']
                                        })
                                    }
                                }
                            } else {
                                chartData.push({
                                    x: xAxisIndex,
                                    y: yAxisIndex,
                                    value: null
                                });
                            }

                        })
                    });
                    return chartData;
                };

                vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    if (srcList.type === 'node') {
                        if (srcList.chartType === 'nodeHealth') {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health ? Number(dataObj.health) : null]);
                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    var tempConnectionObj = _.find(connectionArr, {value: dataObj.value === true ? 1 : -1});
                                    tempData.push({
                                        x: parseInt(dataObj.timestamp),
                                        y: dataObj.value ? tempConnectionObj.value : 0,
                                        name: dataObj.value ? tempConnectionObj.name : 'No Data Found',
                                        color: dataObj.value ? tempConnectionObj.color : '#808080'
                                    });
                                })
                            });
                        }
                    } else {
                        if (srcList.chartType === 'attributeValue') {
                            var isStringFound = false;
                            _.forEach(resData, function (dataObj) {
                                if (dataObj.value && isNaN(dataObj.value)) {
                                    isStringFound = true;
                                }
                            });
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    if (isStringFound) {
                                        if (dataObj.value && dataObj.value !== '' && vm.attributesStringValueArr.indexOf(dataObj.value) === -1) {
                                            vm.attributesStringValueArr.push(dataObj.value);
                                        }
                                        tempData.push([parseInt(dataObj.timestamp), vm.attributesStringValueArr.indexOf(dataObj.value) === -1 ? null : vm.attributesStringValueArr.indexOf(dataObj.value)]);
                                    } else {
                                        tempData.push([parseInt(dataObj.timestamp), dataObj.value ? Number(dataObj.value) : null]);
                                    }

                                })
                            });
                        } else {
                            _.forEach(resData, function (dataObj) {
                                var tempA = dataObj.ts.replace('T', ' ').split('.')[0];
                                $timeout(function () {
                                    dataObj.timestamp = moment(tempA).format('x');
                                    tempData.push([parseInt(dataObj.timestamp), dataObj.health === 0 || dataObj.health > 0 ? Number(dataObj.health) : null]);
                                })
                            });
                        }
                    }
                    return tempData;
                };

                vm.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData.apiData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = vm.attributesStringValueArr.indexOf(tempDataObj.value) === -1 ? 0 : vm.attributesStringValueArr.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData.apiData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                vm.fnDataRangeChange = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        var chartContainerEle = angular.element(".chart-container-height");
                        loaderModalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html',
                            size: 'md',
                            controller: 'telemetryDataLoadModalCtrl as telemetryDataLoadModal',
                            windowClass: 'd-flex align-items-center justify-content-center chart-loader-class',
                            appendTo: chartContainerEle
                        });
                        count = 1;
                        vm.fnBatchOperation(batchCollectionObj, count);
                    }
                };

                vm.fnBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                try {
                                    _.forEach(response, function (responseObj, index) {
                                        var sql = angular.fromJson(responseObj.request.body);
                                        vm.selectedChartData[index].sql = sql.sql;

                                        // Parse the PostgreSQL data
                                        var parsedData = parsePostgresData(responseObj.body.data);

                                        vm.selectedChartData[index].apiData = parsedData;
                                        vm.selectedChartData[index].chartData = vm.fnGenerateChartData(vm.selectedChartData[index], parsedData);

                                        var isFind = _.find(vm.pieChartAttributeList, {
                                            name: vm.selectedChartData[index].name,
                                            id: vm.selectedChartData[index].id
                                        });

                                        if (isFind) {
                                            isFind.apiData = parsedData;
                                            isFind.chartData = vm.selectedChartData[index].chartData;
                                        }
                                    });

                                    $timeout(function () {
                                        if (vm.selectedChartType !== 'heatmap') {
                                            loaderModalInstance.dismiss();
                                            loaderModalInstance = "";
                                        }
                                        if (vm.selectedChartType === 'pie') {
                                            vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                        } else {
                                            vm.fnRenderChart();
                                        }
                                    });
                                } catch (err) {
                                    $log.error('Error parsing batch operation data:', err);
                                    if (vm.selectedChartType !== 'heatmap') {
                                        loaderModalInstance.dismiss();
                                        loaderModalInstance = "";
                                    }
                                    amaran.error('Error processing chart data');
                                }
                            }
                        }, function (error) { // Error block
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                if (vm.selectedChartType !== 'heatmap') {
                                    loaderModalInstance.dismiss();
                                    loaderModalInstance = "";
                                }
                                if (vm.selectedChartType === 'pie') {
                                    vm.fnSelectPieChartAttr(vm.pieChartAttributeList[0]);
                                } else {
                                    vm.fnRenderChart();
                                }
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnEditAttributeName = function (selectedObj, dataType) {
                    var tempSelectedObj = _.cloneDeepWith(selectedObj);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditNameModal/attributeEditNameModal.html',
                        size: 'lg',
                        controller: 'attributeEditNameModalCtrl as attributeEditModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        var isFindInAttributeList = _.findIndex(vm.attributesList, {id: res.id});
                        if (isFindInAttributeList !== -1) {
                            vm.attributesList[isFindInAttributeList].name = res.name;
                            vm.attributesList[isFindInAttributeList].displayName = res.name;
                        }
                        var isFindInChartData = _.filter(vm.selectedChartData, {id: selectedObj.id});
                        if (isFindInChartData.length) {
                            _.forEach(isFindInChartData, function (chartObj) {
                                var tempChartType = "Value";
                                if (chartObj.chartType === 'attributeValue') {
                                    tempChartType = "Value"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Value)";
                                } else {
                                    tempChartType = "Health"
                                    chartObj.name = _.cloneDeepWith(res.name) + " (" + chartObj.dataType + " Health)";
                                }
                                chartObj.displayName = _.cloneDeepWith(res.name);
                                var isFindPieDataIndex = _.findIndex(vm.pieChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindPieDataIndex !== -1) {
                                    vm.pieChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.pieChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedPieChartData.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedPieChartData.name = vm.pieChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedPieChartData.displayName = res.name;
                                    }
                                }
                                var isFindHeatmapDataIndex = _.findIndex(vm.heatmapChartAttributeList, {
                                    name: _.cloneDeepWith(tempSelectedObj.name) + " (" + chartObj.dataType + " " + tempChartType + ")",
                                    id: selectedObj.id
                                });
                                if (isFindHeatmapDataIndex !== -1) {
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].name = _.cloneDeepWith(chartObj.name);
                                    vm.heatmapChartAttributeList[isFindPieDataIndex].displayName = res.name;
                                    if (vm.selectedHeatmapChartAttr.name === _.cloneDeepWith(tempSelectedObj.name) + " (" + dataType + " " + tempChartType + ")") {
                                        vm.selectedHeatmapChartAttr.name = vm.heatmapChartAttributeList[isFindPieDataIndex].name
                                        vm.selectedHeatmapChartAttr.displayName = res.name;
                                    }
                                }
                            })
                        }
                        $timeout(function () {
                            vm.fnRenderChart();
                        });
                    }, function () {

                    });
                };

                vm.fnEditAttributeValue = function (selectedObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/attributeEditValueModal/attributeEditValueModal.html',
                        size: 'lg',
                        controller: 'attributeEditValueModalCtrl as attributeEditValue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(selectedObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (jobRes) {
                        vm.fnGetEcu(selectedObj, jobRes);
                    }, function () {
                    });
                };

                vm.fnSelectAttribute = function (attributeObj) {
                    vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                    vm.selectedAttribute.name = _.cloneDeepWith(attributeObj.displayName);
                    vm.selectedAttribute.isSelected = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Actual Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecast = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedForecastHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Forecast Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomaly = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Value)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                    vm.selectedAttribute.isSelectedAnomalyHealthPlot = _.findIndex(vm.selectedChartData, {
                        name: vm.selectedAttribute.name + " (Anomaly Health)",
                        id: vm.selectedAttribute.id
                    }) !== -1;
                };

                vm.fnSelectedAttributeCopyToClipboard = function (key, attribute) {
                    attribute[key + 'IsCopyClicked'] = true;
                    copyService.fnCopyToClipboard(attribute[key]);
                    $timeout(function () {
                        delete attribute[key + 'IsCopyClicked'];
                    }, 2000)
                };

                vm.fnIsAttributeSelected = function () {
                    return !!vm.selectedAttribute && Object.keys(vm.selectedAttribute).length;
                };

                vm.fnOpenNodeInfo = function () {
                    if (vm.selectedAttribute.ecuId === vm.selectedAttribute.nodeId) {
                        var ecuInputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: vm.selectedAttribute.ecuId,
                            displaySearchText: vm.selectedAttribute.ecuId
                        }];
                        $state.go('main.ecu', {
                            filter: angular.toJson(ecuInputObj),
                            selectedId: vm.selectedAttribute.ecuId
                        });
                    } else {
                        var inputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: vm.selectedAttribute.nodeId,
                            displaySearchText: vm.selectedAttribute.nodeId,
                            isNeedTableAlias: true
                        }];
                        $state.go('main.node', {
                            filter: angular.toJson(inputObj),
                            selectedId: vm.selectedAttribute.nodeId
                        });
                    }
                };

                vm.fnEnableAttribute = function (attributeObj) {
                    swal({
                            title: "Enable the selected Attribute?",
                            text: "You are about to enable selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };
                                NodeAttributesFactory.enableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute enabling process cancelled", "error");
                            }
                        });
                };

                vm.fnDisableAttribute = function (attributeObj) {
                    swal({
                            title: "Disable the selected Attribute?",
                            text: "You are about to disable the selected attribute.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    attributeId: attributeObj.id
                                };

                                NodeAttributesFactory.disableAttribute(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Attribute disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Attribute disable process cancelled", "error");
                            }
                        });
                };

                vm.fnSelectAutoUpdateChart = function () {
                    if (vm.selectedAutoUpdateType === 'Static') {
                        $timeout.cancel(vm.chartUpdateTimeout);
                    } else {
                        vm.chartUpdateTimeout = $timeout(function () {
                            vm.fnUpdateDateRangeInput();
                        }, 60000);
                    }
                };

                vm.fnUpdateDateRangeInput = function () {
                    var oldT = vm.selectedRange.split(',');
                    var newStart = moment.unix(parseInt(oldT[0])).add(1, 'minutes').format('X')
                    var newEnd = moment.unix(parseInt(oldT[1])).add(1, 'minutes').format('X')
                    vm.selectedRange = newStart + "," + newEnd;
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (moment.unix(parseInt(newStart)).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(parseInt(newEnd)).format('YYYY/MM/DD HH:mm'));
                    }
                    if (vm.selectedChartData && vm.selectedChartData.length) {
                        vm.fnGetChartUpdateData();
                    }
                    vm.chartUpdateTimeout = $timeout(function () {
                        vm.fnUpdateDateRangeInput();
                    }, 60000);
                };

                vm.fnGetUpdateChartSQLQuery = function (srcList) {
                    // Configuration maps
                    var TABLE_MAP = {
                        node: {
                            health: {
                                actual: 'node_iot_node_healths',
                                forecast: 'node_iot_node_health_forecasts',
                                anomaly: 'node_iot_node_health_anomalies'
                            },
                            connection: {
                                actual: 'node_iot_node_connections',
                                forecast: 'node_iot_node_connection_forecasts',
                                anomaly: 'node_iot_node_connection_anomalies'
                            }
                        },
                        attribute: {
                            health: {
                                actual: 'node_iot_attribute_healths',
                                forecast: 'node_iot_attribute_health_forecasts',
                                anomaly: 'node_iot_attribute_health_anomalies'
                            },
                            value: {
                                actual: 'node_iot_attribute_values',
                                forecast: 'node_iot_attribute_value_forecasts',
                                anomaly: 'node_iot_attribute_value_anomalies'
                            }
                        }
                    };

                    // Timestamp calculations
                    var previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).subtract(1, 'minutes').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';

                    // Determine data source type and details
                    var dataType = 'actual';
                    if (srcList.dataType) {
                        dataType = srcList.dataType.toLowerCase();
                    }
                    var sourceType = srcList.type === 'node' ? 'node' : 'attribute';
                    var chartType = srcList.chartType.replace('node', '').toLowerCase();

                    // Select appropriate table
                    var table = TABLE_MAP[sourceType][chartType][dataType];
                    var idColumn = sourceType === 'node' ? 'nodeId' : 'attributeId';

                    // Dynamic column and value selections based on chart type
                    var valueColumnName = chartType === 'health' ? 'health' :
                        chartType === 'connection' ? 'connected' : 'value';

                    // Construct SQL query with dynamic components
                    var sql = "" +
                        "WITH readings AS (" +
                        "    (SELECT " +
                        "        data->>'timestamp' as timestamps, " +
                        "        data->>'"+idColumn+"' as id, " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) as ts, " +
                        "        data->>'"+valueColumnName+"' as value, " +
                        (dataType !== 'actual' ? "data->>'confidence' as confidence, data->>'type' as type" : "") +
                        "    FROM "+table+" " +
                        "    WHERE " +
                        "        data->>'"+idColumn+"' = '"+srcList.id+"' AND " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) < TIMESTAMP '" + previousDateString + "' " +
                        "    ORDER BY ts DESC LIMIT 1)" +
                        "    UNION" +
                        "    (SELECT " +
                        "        data->>'timestamp' as timestamps, " +
                        "        data->>'"+idColumn+"' as id, " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) as ts, " +
                        "        data->>'"+valueColumnName+"' as value, " +
                        (dataType !== 'actual' ? "data->>'confidence' as confidence, data->>'type' as type" : "") +
                        "    FROM "+table+" " +
                        "    WHERE " +
                        "        data->>'"+idColumn+"' = '"+srcList.id+"' AND " +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) > TIMESTAMP '"+previousDateString+"' AND" +
                        "        DATE_TRUNC('second', TIMESTAMP_SECONDS(data->>'timestamp')) < TIMESTAMP '"+endDateString+"')" +
                        ")," +
                        "slots AS (" +
                        "    SELECT " +
                        "        TIMESTAMP '"+previousDateString+"' + 'minute'(u.i - 1) AS last_ts, " +
                        "        TIMESTAMP '"+previousDateString+"' + 'minute'(u.i) AS ts " +
                        "    FROM UNNEST(SEQUENCE(1, 2)) AS u" +
                        ")," +
                        "slot_values AS (" +
                        "    SELECT " +
                        "        filled_slots.ts, " +
                        "        MAX(value) AS last_val, " +
                        (dataType !== 'actual' ? "MAX(confidence) AS last_confidence, MAX(type) AS last_type," : "") +
                        "        MAX(in_interval_r.value) AS slot_agg_val " +
                        (dataType !== 'actual' ? ", MAX(in_interval_r.confidence) AS slot_agg_confidence, MAX(in_interval_r.type) AS slot_agg_type" : "") +
                        "    FROM slots filled_slots" +
                        "    LEFT JOIN readings previous_r ON previous_r.ts <= filled_slots.ts" +
                        "    LEFT JOIN readings in_interval_r ON " +
                        "        in_interval_r.ts < filled_slots.ts AND " +
                        "        in_interval_r.ts > filled_slots.last_ts" +
                        "    GROUP BY filled_slots.ts" +
                        ")," +
                        "final_values AS (" +
                        "    SELECT " +
                        "        CAST(ts AT TIME ZONE '"+timezoneName+"' AS string) AS ts," +
                        "        COALESCE(" +
                        "            slot_agg_val, " +
                        "            LAG(slot_agg_val, 1) OVER (ORDER BY ts), " +
                        "            last_val" +
                        "        ) AS value " +
                        (dataType !== 'actual' ?
                            ", COALESCE(" +
                            "            slot_agg_confidence, " +
                            "            LAG(slot_agg_confidence, 1) OVER (ORDER BY ts), " +
                            "            last_confidence" +
                            "        ) AS confidence" +
                            ", COALESCE(" +
                            "            slot_agg_type, " +
                            "            LAG(slot_agg_type, 1) OVER (ORDER BY ts), " +
                            "            last_type" +
                            "        ) AS type"
                            : "") +
                        "    FROM slot_values" +
                        ")," +
                        "SELECT * FROM final_values ORDER BY ts;";

                    return sql;
                };

                vm.fnGetChartUpdateData = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedChartData, function (selectedChartData, index) {
                        if (index <= step) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/insight/queries";
                            inputObj.body = {
                                sql: vm.fnGetUpdateChartSQLQuery(selectedChartData)
                            };
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                };

                vm.fnChartUpdateBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            } else {
                                try {
                                    var chart = angular.element('#nodeAttributeChart').highcharts();
                                    angular.forEach(response, function (responseObj, index) {
                                        // Parse the PostgreSQL data
                                        var parsedData = parsePostgresData(responseObj.body.data);
                                        var tempChartData = vm.fnGenerateChartData(vm.selectedChartData[index], parsedData);

                                        $timeout(function () {
                                            vm.selectedChartData[index].apiData.shift();
                                            vm.selectedChartData[index].apiData.push(parsedData[0]);
                                            vm.selectedChartData[index].chartData.shift();
                                            vm.selectedChartData[index].chartData.push(_.cloneDeepWith(tempChartData[0]));

                                            var isFind = _.find(vm.pieChartAttributeList, {
                                                name: vm.selectedChartData[index].name,
                                                id: vm.selectedChartData[index].id
                                            });

                                            if (isFind) {
                                                isFind.apiData = _.cloneDeepWith(vm.selectedChartData[index].apiData);
                                                isFind.chartData = _.cloneDeepWith(vm.selectedChartData[index].chartData);
                                            }

                                            var isFindIndex = _.findIndex(chart.series, {name: vm.selectedChartData[index].name});
                                            if (isFindIndex !== -1) {
                                                chart.series[isFindIndex].addPoint(tempChartData[0], true, true);

                                                if (vm.selectedChartData[index].type === 'node') {
                                                    if (vm.selectedChartData[index].chartType === 'nodeHealth') {
                                                        if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                            var tempHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempHealthForecast[tempHealthForecast.length - 1], true, true);
                                                            });
                                                        }
                                                        if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                            var tempHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempHealthAnomaly[tempHealthAnomaly.length - 1], true, true);
                                                            });
                                                        }
                                                    } else {
                                                        if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                            var tempConnectionForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionForecast');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempConnectionForecast[tempConnectionForecast.length - 1], true, true);
                                                            });
                                                        }
                                                        if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                            var tempConnectionAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ConnectionAnomaly');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempConnectionAnomaly[tempConnectionAnomaly.length - 1], true, true);
                                                            });
                                                        }
                                                    }
                                                } else {
                                                    if (vm.selectedChartData[index].chartType === 'attributeHealth') {
                                                        if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                            var tempValueHealthForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthForecast');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempValueHealthForecast[tempValueHealthForecast.length - 1], true, true);
                                                            });
                                                        }
                                                        if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                            var tempValueHealthAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'HealthAnomaly');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempValueHealthAnomaly[tempValueHealthAnomaly.length - 1], true, true);
                                                            });
                                                        }
                                                    } else {
                                                        if (vm.selectedChartData[index].dataType === 'Forecast') {
                                                            var tempValueForecast = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueForecast');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempValueForecast[tempValueForecast.length - 1], true, true);
                                                            });
                                                        }
                                                        if (vm.selectedChartData[index].dataType === 'Anomaly') {
                                                            var tempValueAnomaly = vm.fnGenerateChartForecastAndAnomalyData(vm.selectedChartData[index], 'ValueAnomaly');
                                                            $timeout(function () {
                                                                chart.series[isFindIndex + 1].addPoint(tempValueAnomaly[tempValueAnomaly.length - 1], true, true);
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                        });
                                    });
                                } catch (err) {
                                    $log.error('Error updating chart data:', err);
                                    amaran.error('Error updating chart');
                                }
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnChartUpdateBatchOperation(batchCollectionObj, count);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnSetGranularity = function () {
                    vm.fnDataRangeChange();
                }

                vm.fnDeployAttribute = function (alarmObj) {
                    var input = {
                        attributeId: alarmObj.id
                    };
                    NodeAttributesFactory.deployAttribute(input)
                        .then(function (res) {
                            amaran.success("Attribute Synchronize in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html',
                                size: 'lg',
                                controller: 'attributeSyncModalCtrl as attributeSyncModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(res);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnExportToInsight = function () {
                    var tempChartArr = [];
                    var tempObj = {};
                    _.forEach(vm.selectedChartData, function (selectedChartObj) {
                        tempObj = {};
                        tempObj.query = selectedChartObj.sql;
                        tempObj.chart = {
                            chartConfiguration: {
                                chartType: "line",
                                dataMapping: {},
                                chartConfig: {
                                    chart: {
                                        zoomType: 'xy'
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    tooltip: {
                                        shared: true,
                                        crosshairs: true
                                    },
                                    xAxis: {
                                        labels: {
                                            rotation: -60,
                                            format: "{value:%d/%m %H:%M}"
                                        },
                                        title: {
                                            text: ''
                                        },
                                        type: "datetime"
                                    },
                                    yAxis: {
                                        title: {
                                            text: 'Values'
                                        }
                                    },
                                    title: {
                                        text: ''
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    plotOptions: {},
                                    exporting: {
                                        enabled: false
                                    },
                                    legend: {
                                        enabled: false
                                    }
                                }
                            }
                        };
                        if (selectedChartObj.type === 'node') {
                            if (selectedChartObj.chartType === 'nodeHealth') {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "health"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                            } else {
                                tempObj.chart.chartConfiguration.dataMapping = {
                                    name: "ts",
                                    y: "value"
                                }
                                tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                            }
                        } else {
                            if (selectedChartObj.chartType === 'attributeHealth') {
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ForecastHealth';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'AnomalyHealth';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "health"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Health";
                                }
                            } else {
                                var isStringFound = false;
                                _.forEach(selectedChartObj.apiData, function (dataObj) {
                                    if (dataObj.value && isNaN(dataObj.value)) {
                                        isStringFound = true;
                                    }
                                });
                                if (isStringFound) {
                                    tempObj.chart.chartConfiguration.isSupportStringValue = true;
                                }
                                if (selectedChartObj.dataType === 'Forecast') {
                                    //Forecast
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueForecast';
                                } else if (selectedChartObj.dataType === 'Anomaly') {
                                    //Anomaly
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartFor = 'ValueAnomaly';
                                } else {
                                    tempObj.chart.chartConfiguration.dataMapping = {
                                        name: "ts",
                                        y: "value"
                                    }
                                    tempObj.chart.chartConfiguration.chartConfig.yAxis.title.text = "Value";
                                }
                            }
                        }
                        tempChartArr.push(tempObj)
                    });
                    DB.fnSet('telemetryChart', tempChartArr);
                    $state.go('main.insight_query_editor');
                };

                vm.fnInitAlarmAttributes = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var timezone = moment().zone();
                    timezoneName = moment.tz.guess();
                    Highcharts.setOptions({
                        global: {
                            timezoneOffset: timezone
                        }
                    });
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');

                    });
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.chartUpdateTimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightWidgetWidgetCtrl',
            function ($scope, $timeout, $sce, TabHeight, InsightWidgetFactory, amaran, jsonToCsvConvertService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.svgArr = [
                    {
                        title: "Dashboard",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Account",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "User",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Team",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Vault",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Authenticator",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Federation",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email Template",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Audits",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/log.svg#log\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "S4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Issues",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Archives",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/archive.svg#archive\"></use> \n" +
                            "</svg>"
                    }, {
                        title: "Projects",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Labels",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/label.svg#label\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Priorities",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "States",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/state.svg#state\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Types",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/types.svg#types\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Payment Methods",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/card.svg#card\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Invoices",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/invoice.svg#invoice\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Discounts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/discount.svg#discount\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Credit Tokens",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/creditTokens.svg#creditToken\"></use> \n" +
                            "</svg>"

                    },
                    {
                        title: "Business",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/business.svg#business\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Plans",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/plan.svg#plan\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Products",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/product.svg#product\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Carts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"22px\" height=\"22px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/cart.svg#cart\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ECU",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Nodes",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/device.svg#device\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Alarms",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Jobs",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/jobs.svg#jobs\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Fleet",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Software",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/software.svg#software\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Healths",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/health.svg#health\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ES4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/es4.svg#es4\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Observers",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/observers.svg#observers\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Emails",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    }
                ];
                vm.isWidgetDetailsLoaded = false;
                vm.isPasteSVGCode = false;
                vm.previewWidgetChartData = {};
                vm.isDetailsEditable = false;
                vm.isUpdateCompleted = true;

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.fnEditSVGCode = function () {
                    vm.isPasteSVGCode = true;
                };

                vm.fnSelectIcon = function (obj) {
                    vm.selectWidgetObj.layout.icon = obj.iconURL;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isDetailsEditable = true;
                };

                vm.fnResetDetails = function () {
                    vm.selectWidgetObj = angular.copy(vm.resetSelectWidgetObj);
                    vm.isDetailsEditable = false
                };

                vm.fnGetWidgetInfo = function (widgetId) {
                    var inputObj = {
                        widgetId: widgetId
                    };
                    InsightWidgetFactory.executeWidget(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.layout.isExport)) {
                                response.layout.isExport = true;
                                response.layout.exportOptions = [
                                    {
                                        name: "Download PNG image",
                                        action: "downloadPNG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download JPEG image",
                                        action: "downloadJPEG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download PDF image",
                                        action: "downloadPDF",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download SVG vector image",
                                        action: "downloadSVG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download CSV File",
                                        action: "downloadCSV",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download XLS File",
                                        action: "downloadXLS",
                                        isAllow: true
                                    }
                                ];
                                response.layout.isTrackerExport = false
                            }
                            vm.selectWidgetObj = _.cloneDeepWith(response);
                            vm.resetSelectWidgetObj = _.cloneDeepWith(response);
                            vm.dataConfig = [];
                            var headers = {};
                            _.forEach(vm.selectWidgetObj.chart.definition.dataMapping, function (value, key) {
                                vm.dataConfig.push({
                                    key: key,
                                    value: value
                                });
                                headers[value] = value
                            });
                            var items = [];
                            _.forEach(vm.selectWidgetObj.chart.query.results.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            vm.selectWidgetObj.chart.definition.chartConfig.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            vm.isWidgetDetailsLoaded = true;
                            vm.previewWidgetChartData = _.cloneDeepWith(vm.selectWidgetObj.chart.definition.chartConfig)
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetDetailsLoaded = true;
                        })
                };

                vm.fnUpdateWidgetInfo = function () {
                    var inputObj = {
                        body: {
                            layout: {}
                        },
                        widgetId: vm.selectWidgetObj.id
                    };
                    vm.isUpdateCompleted = false;
                    vm.isDetailsEditable = false;
                    inputObj.body.layout = vm.selectWidgetObj.layout;
                    InsightWidgetFactory.updateWidgetLayout(inputObj)
                        .then(function () {
                            vm.isUpdateCompleted = true;
                            amaran.success("Widget Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                        })
                }

                vm.fnInitWidgetWidget = function () {
                    vm.fnGetWidgetInfo(vm.parent.widgetObj.id);
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightWidgetTagsCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, InsightWidgetFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.widgetSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetWidgetData = function () {
                    vm.widgetSupplementalObj = vm.parent.widgetObj.tags ? angular.fromJson(vm.parent.widgetObj.tags) : {};
                    vm.widgetSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.widgetSupplementalObj, true) : vm.widgetSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.widgetSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.widgetSupplementalObj)) {
                        angular.forEach(vm.widgetSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isWidgetSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.widgetSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.widgetSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.widgetSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.widgetSupplementalObj = angular.toJson(vm.widgetSupplementalObj, true);
                    } else {
                        vm.widgetSupplementalObj = angular.fromJson(vm.widgetSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.widgetSupplementalObj)) {
                            angular.forEach(vm.widgetSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveWidgetData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.widgetObj.tags = {};
                    var inputObj = {
                        widgetId: vm.parent.widgetObj.id,
                        body: {}
                    };
                    if (!vm.parent.widgetObj.tags) {
                        vm.parent.widgetObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.widgetObj.tags = angular.fromJson(vm.widgetSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.widgetObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.widgetObj.tags;
                    InsightWidgetFactory.replaceWidgetTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Widget successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitWidgetSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitWidgetSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.widgetSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.widgetSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.widgetSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitWidgetSupplemental = function () {
                    vm.isWidgetSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightWidgetChartCtrl',
            function ($scope, $window, $timeout, DB, AppInitService, moment, TabHeight, UserProfileService, QueryFactory, InsightWidgetFactory, sqlFormatter, InsightProjectFactory, InsightChartFactory, PaginationQueryService, amaran) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isShowChangeChart = false;
                vm.selectedChartArr = [];
                vm.isChartChanging = false;

                var tableName = 'insight_charts';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.chartsProjectFilter = "$";
                vm.chartsProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isChartsLoading = false;
                vm.chartsResponse = [];
                vm.chartsArr = [];
                vm.selectedChartsArr = [];
                vm.selectedChartsObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.fnHideShowChangeChart = function () {
                    vm.isShowChangeChart = !vm.isShowChangeChart;
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowChangeChart) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;

                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#chartsTable").css('height', finalHeight + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowChangeChart) {
                        if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element(".pagination-container")[0]) && angular.isDefined(angular.element(".search-panel-v4")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    }
                };

                vm.fnGetChart = function (chartId) {
                    vm.selectedChartArr = [];
                    var inputObj = {
                        chartId: chartId
                    };
                    InsightChartFactory.describeChart(inputObj)
                        .then(function (response) {
                            vm.chartObj = response;
                            if (vm.chartObj.createdAt) {
                                vm.chartObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.chartObj.createdAt);
                            }
                            if (vm.chartObj.updatedAt) {
                                vm.chartObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.chartObj.updatedAt);
                            }
                            if (vm.chartObj.projectId) {
                                vm.chartObj.project = _.cloneDeepWith(vm.selectedChartProject);
                            }
                            vm.selectedChartArr.push(_.cloneDeepWith(vm.chartObj));
                            if (angular.isUndefined(vm.chartObj.description)) {
                                vm.chartObj.description = '';
                            }
                            vm.isChartDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartDetailsLoaded = true;
                        })
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'charts', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectCharts = function (projectObj) {
                    vm.isChartsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetCharts(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.chartsArr);
                        vm.previousPage = page;
                        vm.fnGetCharts(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetCharts = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.chartsResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.chartsResponse.data && vm.chartsResponse.data.length) {
                                vm.totalItems = vm.chartsResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.chartsResponse.data.reverse();
                            }
                            vm.chartsArr = _.cloneDeepWith(vm.chartsResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isChartsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (chartsObj) {
                    angular.forEach(vm.chartsArr, function (obj) {
                        if (chartsObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindCharts = _.find(vm.chartsArr, function (chartsObj) {
                        return chartsObj.isCheck === true;
                    });
                    if (isFindCharts) {
                        vm.selectedChartsObj = _.cloneDeepWith(isFindCharts);
                    } else {
                        vm.selectedChartsObj = {};
                    }
                };

                vm.isChartsObjSelected = function () {
                    return !!vm.selectedChartsObj && Object.keys(vm.selectedChartsObj).length;
                };

                vm.fnSaveChart = function () {
                    vm.isChartChanging = true;
                    var inputObj = {
                        widgetId: vm.parent.widgetObj.id,
                        chartId: vm.selectedChartsObj.id
                    };
                    inputObj.body = vm.parent.widgetObj.tags;
                    InsightWidgetFactory.updateWidgetChart(inputObj)
                        .then(function (response) {
                            amaran.success("Widget Chart Change successfully");
                            $scope.$emit('ChartDetailsChanged', response);
                            vm.parent.widgetObj.chartId = response.chartId;
                            vm.isChartChanging = false;
                            vm.fnHideShowChangeChart();
                            vm.fnInitChartChart();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartChanging = false;
                            vm.fnHideShowChangeChart();
                            vm.fnInitChartChart();
                        })
                };

                vm.fnInitChartChart = function () {
                    vm.chartId = vm.parent.widgetObj.chartId;
                    if (vm.chartId) {
                        vm.isChartDetailsLoaded = false;
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            var projectsArr = AppInitService.getInitData('insightProjectsArr');
                            var isFind = _.find(projectsArr, {id: vm.parent.widgetObj.projectId});
                            if (isFind) {
                                vm.selectedChartProject = _.cloneDeepWith(isFind);
                            }
                            vm.fnGetChart(vm.chartId);
                        } else {
                            InsightProjectFactory.describeProject({projectId: vm.parent.widgetObj.projectId}).then(function (res) { // Success block
                                vm.selectedChartProject = _.cloneDeepWith(res);
                                vm.fnGetChart(vm.chartId);
                            });
                        }
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightProjectTagsCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, InsightProjectFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.projectSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetProjectData = function () {
                    vm.projectSupplementalObj = vm.parent.projectObj.tags ? angular.fromJson(vm.parent.projectObj.tags) : {};
                    vm.projectSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.projectSupplementalObj, true) : vm.projectSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.projectSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isProjectSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.projectSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.projectSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.projectSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.projectSupplementalObj = angular.toJson(vm.projectSupplementalObj, true);
                    } else {
                        vm.projectSupplementalObj = angular.fromJson(vm.projectSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                            angular.forEach(vm.projectSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveProjectData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.projectObj.tags = {};
                    var inputObj = {
                        projectId: vm.parent.projectObj.id,
                        body: {}
                    };
                    if (!vm.parent.projectObj.tags) {
                        vm.parent.projectObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.projectObj.tags = angular.fromJson(vm.projectSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.projectObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.projectObj.tags;
                    InsightProjectFactory.replaceProjectTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Project successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitProjectSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.projectSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.projectSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.projectSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitProjectSupplemental = function () {
                    vm.isProjectSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightQueryTagsCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.querySupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetQueryData = function () {
                    vm.querySupplementalObj = vm.parent.queryObj.tags ? angular.fromJson(vm.parent.queryObj.tags) : {};
                    vm.querySupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.querySupplementalObj, true) : vm.querySupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.querySupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.querySupplementalObj)) {
                        angular.forEach(vm.querySupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isQuerySupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.querySupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.querySupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.querySupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.querySupplementalObj = angular.toJson(vm.querySupplementalObj, true);
                    } else {
                        vm.querySupplementalObj = angular.fromJson(vm.querySupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.querySupplementalObj)) {
                            angular.forEach(vm.querySupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveQueryData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.queryObj.tags = {};
                    var inputObj = {
                        queryId: vm.parent.queryObj.id,
                        body: {}
                    };
                    if (!vm.parent.queryObj.tags) {
                        vm.parent.queryObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.queryObj.tags = angular.fromJson(vm.querySupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.queryObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.queryObj.tags;
                    QueryFactory.replaceQueryTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Query successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitQuerySupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitQuerySupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.querySupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.querySupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.querySupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitQuerySupplemental = function () {
                    vm.isQuerySupplementalDetailsLoaded = false;
                    /*if (vm.parent.queryObj.id) {
                        vm.fnGetQueryData(vm.parent.queryObj);
                    }*/
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightQueryCtrl',
            function ($scope, $timeout, TabHeight, QueryFactory, sqlFormatter, amaran) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.queryObj = {};
                vm.isQueryDetailsLoaded = false;
                vm.availableDataLibs = ['ql_S4'];
                vm.queryConfig = {
                    value: {},
                    editorValue: ''
                };
                vm.isQuerySearchDataLoading = false;
                vm.isQueryChanging = false;

                vm.fnGetQuery = function () {
                    vm.queryObj = vm.parent.queryObj;
                    vm.resetQueryObj = angular.copy(vm.queryObj);
                    if (angular.isUndefined(vm.queryObj.description)) {
                        vm.queryObj.description = '';
                    }
                    vm.isQueryDetailsLoaded = true;
                    vm.queryConfig.editorValue = vm.queryObj.sql;
                };

                vm.fnRunQuery = function () {
                    if (vm.queryConfig.value.getData().length) {
                        vm.isQuerySearchDataLoading = true;
                        vm.softwareSearchData = [];
                        var input = {
                            "sql": vm.queryConfig.value.getData()
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            vm.querySearchData = res;
                            vm.querySearchDataHeader = [];
                            _.forEach(vm.querySearchData.data, function (dataObj) {
                                _.forEach(Object.keys(dataObj), function (value) {
                                    vm.querySearchDataHeader.push(value);
                                });
                            });
                            vm.querySearchDataHeader = _.uniq(_.map(vm.querySearchDataHeader)).sort();
                            vm.isQuerySearchDataLoading = false;
                        }, function () { // Error block
                            vm.isQuerySearchDataLoading = false;
                        });
                    }
                };

                vm.fnFormatSQL = function () {
                    var sql = vm.queryConfig.value.getData();
                    vm.queryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnSaveQuery = function () {
                    if (vm.queryConfig.value.getData().length) {
                        vm.isQueryChanging = true;
                        var inputObj = {
                            queryId: vm.parent.queryObj.id,
                            body: {}
                        };
                        inputObj.body = {
                            sql: vm.queryConfig.value.getData()
                        };
                        QueryFactory.updateQuerySQL(inputObj)
                            .then(function () {
                                amaran.success("Query Updated successfully");
                                vm.isQueryChanging = false;
                            }, function (error) {
                                vm.isQueryChanging = false;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            })
                    } else {
                        amaran.error("The parameter 'sql' is a required parameter and cannot be null.");
                    }
                }

                vm.fnInitQuery = function () {
                    vm.queryId = vm.parent.queryObj.id;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };
                vm.fnInitQuery();
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightDashboardTagsCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, InsightDashboardFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.dashboardSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetDashboardData = function () {
                    vm.dashboardSupplementalObj = vm.parent.dashboardObj.tags ? angular.fromJson(vm.parent.dashboardObj.tags) : {};
                    vm.dashboardSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.dashboardSupplementalObj, true) : vm.dashboardSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.dashboardSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.dashboardSupplementalObj)) {
                        angular.forEach(vm.dashboardSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isDashboardSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.dashboardSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.dashboardSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.dashboardSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.dashboardSupplementalObj = angular.toJson(vm.dashboardSupplementalObj, true);
                    } else {
                        vm.dashboardSupplementalObj = angular.fromJson(vm.dashboardSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.dashboardSupplementalObj)) {
                            angular.forEach(vm.dashboardSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveDashboardData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.dashboardObj.tags = {};
                    var inputObj = {
                        dashboardId: vm.parent.dashboardObj.id,
                        body: {}
                    };
                    if (!vm.parent.dashboardObj.tags) {
                        vm.parent.dashboardObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.dashboardObj.tags = angular.fromJson(vm.dashboardSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.dashboardObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.dashboardObj.tags;
                    InsightDashboardFactory.replaceDashboardTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Dashboard successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitDashboardSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitDashboardSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.dashboardSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.dashboardSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.dashboardSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitDashboardSupplemental = function () {
                    vm.isDashboardSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightDashboardDashboardCtrl',
            function ($scope, $timeout, $sce, TabHeight, InsightDashboardFactory, jsonToCsvConvertService, amaran) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.selectDashboardObj = {};
                vm.isDashboardDetailsLoaded = false;
                vm.widgets = [];

                vm.options = {
                    cellHeight: 200,
                    verticalMargin: 20,
                    disableDrag: true,
                    disableResize: true
                };

                vm.fnGotoDashboardEdit = function () {
                    $scope.$emit('EditDashboardDetails', vm.parent.dashboardObj);
                };

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.fnGetDashboardInfo = function (dashboardId) {
                    var inputObj = {
                        dashboardId: dashboardId
                    };
                    InsightDashboardFactory.executeDashboard(inputObj)
                        .then(function (response) {
                            vm.selectDashboardObj = _.cloneDeepWith(response);
                            vm.selectDashboardObj.cells.sort(function(a, b) {
                                return a.y === b.y ? a.x - b.x : a.y - b.y;
                            });
                            var items = _.cloneDeepWith(vm.selectDashboardObj.cells);
                            var arranged = [];
                            for (var i = 0; i < items.length; i++) {
                                if (angular.isUndefined(items[i].wasAdded)) {
                                    arranged.push(items[i]);
                                    items[i].wasAdded = "true";
                                    for (var j = i + 1; j < items.length; j++) {
                                        if (items[i].y > items[j].y && angular.isUndefined(items[j].wasAdded)) {
                                            arranged.push(items[j]);
                                            items[j].wasAdded = "true";
                                        }
                                    }
                                }
                            }
                            vm.selectDashboardObj.cells = _.cloneDeepWith(arranged);
                            _.forEach(vm.selectDashboardObj.cells, function (cellObj) {
                                if (angular.isUndefined(cellObj.widget.layout.isExport)) {
                                    cellObj.widget.layout.isExport = true;
                                    cellObj.widget.layout.exportOptions = [
                                        {
                                            name: "Download PNG image",
                                            action: "downloadPNG",
                                            isAllow: true
                                        },
                                        {
                                            name: "Download JPEG image",
                                            action: "downloadJPEG",
                                            isAllow: true
                                        },
                                        {
                                            name: "Download PDF image",
                                            action: "downloadPDF",
                                            isAllow: true
                                        },
                                        {
                                            name: "Download SVG vector image",
                                            action: "downloadSVG",
                                            isAllow: true
                                        },
                                        {
                                            name: "Download CSV File",
                                            action: "downloadCSV",
                                            isAllow: true
                                        },
                                        {
                                            name: "Download XLS File",
                                            action: "downloadXLS",
                                            isAllow: true
                                        }
                                    ];
                                    cellObj.widget.layout.isTrackerExport = false
                                }
                                cellObj.width = _.cloneDeepWith(cellObj.w);
                                cellObj.height = _.cloneDeepWith(cellObj.h);
                                delete cellObj.w;
                                delete cellObj.h;
                                if (cellObj.widget.chart && cellObj.widget.chart.syntax === 'HIGHCHARTS') {
                                    vm.dataConfig = [];
                                    var headers = {};
                                    _.forEach(cellObj.widget.chart.definition.dataMapping, function (value, key) {
                                        vm.dataConfig.push({
                                            key: key,
                                            value: value
                                        });
                                        headers[value] = value
                                    });
                                    var items = [];
                                    _.forEach(cellObj.widget.chart.query.results.data, function (obj) {
                                        var tempObj = {};
                                        _.forEach(vm.dataConfig, function (dataConfigObj) {
                                            tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                        });
                                        items.push(tempObj);
                                    });
                                    items.unshift(headers);
                                    var jsonObject = angular.toJson(items);
                                    cellObj.widget.chart.definition.chartConfig.data = {
                                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                        "googleSpreadsheetKey": false,
                                        "googleSpreadsheetWorksheet": false,
                                        "decimalPoint": ","
                                    };
                                }
                                vm.widgets.push(cellObj);
                            })
                            vm.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardDetailsLoaded = true;
                        })
                };


                vm.fnInitDashboardDashboard = function () {
                    vm.isDashboardDetailsLoaded = false;
                    if (vm.parent.dashboardObj.id) {
                        vm.fnGetDashboardInfo(vm.parent.dashboardObj.id);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightChartTagsCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, InsightChartFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.chartSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetChartData = function () {
                    vm.chartSupplementalObj = vm.parent.chartObj.tags ? angular.fromJson(vm.parent.chartObj.tags) : {};
                    vm.chartSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.chartSupplementalObj, true) : vm.chartSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.chartSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.chartSupplementalObj)) {
                        angular.forEach(vm.chartSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isChartSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.chartSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.chartSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.chartSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.chartSupplementalObj = angular.toJson(vm.chartSupplementalObj, true);
                    } else {
                        vm.chartSupplementalObj = angular.fromJson(vm.chartSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.chartSupplementalObj)) {
                            angular.forEach(vm.chartSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveChartData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.chartObj.tags = {};
                    var inputObj = {
                        chartId: vm.parent.chartObj.id,
                        body: {}
                    };
                    if (!vm.parent.chartObj.tags) {
                        vm.parent.chartObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.chartObj.tags = angular.fromJson(vm.chartSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.chartObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.chartObj.tags;
                    InsightChartFactory.replaceChartTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Chart successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitChartSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitChartSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.chartSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.chartSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.chartSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitChartSupplemental = function () {
                    vm.isChartSupplementalDetailsLoaded = false;
                    if (vm.parent.chartObj.id) {
                        vm.fnGetChartData(vm.parent.chartObj);
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightChartQueryCtrl',
            function ($scope, $window, $timeout, DB, AppInitService, moment, TabHeight, UserProfileService, QueryFactory, sqlFormatter, InsightProjectFactory, InsightChartFactory, PaginationQueryService, amaran) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isShowChangeQuery = false;
                vm.selectedQueryArr = [];
                vm.isQueryChanging = false;

                var tableName = 'insight_queries';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.queriesProjectFilter = "$";
                vm.queriesProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isQueriesLoading = false;
                vm.queriesResponse = [];
                vm.queriesArr = [];
                vm.selectedQueriesArr = [];
                vm.selectedQueriesObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.fnHideShowChangeQuery = function () {
                    vm.isShowChangeQuery = !vm.isShowChangeQuery;
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowChangeQuery) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;

                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#queriesTable").css('height', finalHeight + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowChangeQuery) {
                        if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element(".pagination-container")[0]) && angular.isDefined(angular.element(".search-panel-v4")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    }
                };

                vm.fnGetQuery = function (queryId) {
                    vm.selectedQueryArr = [];
                    var inputObj = {
                        queryId: queryId
                    };
                    QueryFactory.describeQuery(inputObj)
                        .then(function (response) {
                            vm.queryObj = response;
                            if (vm.queryObj.createdAt) {
                                vm.queryObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.queryObj.createdAt);
                            }
                            if (vm.queryObj.updatedAt) {
                                vm.queryObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.queryObj.updatedAt);
                            }
                            if (vm.queryObj.projectId) {
                                vm.queryObj.project = _.cloneDeepWith(vm.selectedChartProject);
                            }
                            vm.selectedQueryArr.push(_.cloneDeepWith(vm.queryObj));
                            if (angular.isUndefined(vm.queryObj.description)) {
                                vm.queryObj.description = '';
                            }
                            vm.isQueryDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueryDetailsLoaded = true;
                        })
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'queries', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectQueries = function (projectObj) {
                    vm.isQueriesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, fata->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetQueries(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.queriesArr);
                        vm.previousPage = page;
                        vm.fnGetQueries(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetQueries = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.queriesResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.queriesResponse.data && vm.queriesResponse.data.length) {
                                vm.totalItems = vm.queriesResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.queriesResponse.data.reverse();
                            }
                            vm.queriesArr = _.cloneDeepWith(vm.queriesResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isQueriesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueriesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (queriesObj) {
                    angular.forEach(vm.queriesArr, function (obj) {
                        if (queriesObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindQueries = _.find(vm.queriesArr, function (queriesObj) {
                        return queriesObj.isCheck === true;
                    });
                    if (isFindQueries) {
                        vm.selectedQueriesObj = _.cloneDeepWith(isFindQueries);
                    } else {
                        vm.selectedQueriesObj = {};
                    }
                };

                vm.isQueriesObjSelected = function () {
                    return !!vm.selectedQueriesObj && Object.keys(vm.selectedQueriesObj).length;
                };

                vm.fnSaveQuery = function () {
                    vm.isQueryChanging = true;
                    var inputObj = {
                        chartId: vm.parent.chartObj.id,
                        queryId: vm.selectedQueriesObj.id
                    };
                    inputObj.body = vm.parent.chartObj.tags;
                    InsightChartFactory.updateChartQuery(inputObj)
                        .then(function (response) {
                            amaran.success("Chart Query Change successfully");
                            $scope.$emit('ChartDetailsChanged', response);
                            vm.parent.chartObj.queryId = response.queryId;
                            vm.isQueryChanging = false;
                            vm.fnHideShowChangeQuery();
                            vm.fnInitChartQuery();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueryChanging = false;
                            vm.fnHideShowChangeQuery();
                            vm.fnInitChartQuery();
                        })
                };

                vm.fnInitChartQuery = function () {
                    vm.queryId = vm.parent.chartObj.queryId;
                    if (vm.queryId) {
                        vm.isQueryDetailsLoaded = false;
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            var projectsArr = AppInitService.getInitData('insightProjectsArr');
                            var isFind = _.find(projectsArr, {id: vm.parent.chartObj.projectId});
                            if (isFind) {
                                vm.selectedChartProject = _.cloneDeepWith(isFind);
                            }
                            vm.fnGetQuery(vm.queryId);
                        } else {
                            InsightProjectFactory.describeProject({projectId: vm.parent.chartObj.projectId}).then(function (res) { // Success block
                                vm.selectedChartProject = _.cloneDeepWith(res);
                                vm.fnGetQuery(vm.queryId);
                            });
                        }
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightChartChartCtrl',
            function ($scope, $timeout, TabHeight, InsightChartFactory, amaran, jsonToCsvConvertService, Highcharts) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isChartDetailsLoaded = false;
                vm.selectChartObj = {};

                vm.fnGotoChartEdit = function () {
                    $scope.$emit('EditChartDetails', vm.parent.chartObj);
                };

                vm.fnGetChartInfo = function (chartId) {
                    var inputObj = {
                        chartId: chartId
                    };
                    InsightChartFactory.executeChart(inputObj)
                        .then(function (response) {
                            vm.selectChartObj = _.cloneDeepWith(response);
                            vm.dataConfig = [];
                            var headers = {};
                            _.forEach(vm.selectChartObj.definition.dataMapping, function (value, key) {
                                vm.dataConfig.push({
                                    key: key,
                                    value: value
                                });
                                headers[value] = value
                            });
                            var items = [];
                            _.forEach(vm.selectChartObj.query.results.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            vm.selectChartObj.definition.chartConfig.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            vm.isChartDetailsLoaded = true;
                            $timeout(function () {
                                Highcharts.chart('chartPreviewChart', vm.selectChartObj.definition.chartConfig);
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartDetailsLoaded = true;
                        })
                };

                vm.fnInitChartChart = function () {
                    vm.isChartDetailsLoaded = false;
                    vm.fnGetChartInfo(vm.parent.chartObj.id);
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InferenceCtrl',
            function ($scope, $window, $timeout, InferenceFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.parent = $scope.$parent;
                vm.typesArr = [
                    {
                        displayName: 'Text',
                        contentType: 'text/plain'
                    },
                    {
                        displayName: 'libsvm',
                        contentType: 'text/x-libsvm'
                    },
                    {
                        displayName: 'CSV',
                        contentType: 'text/csv'
                    },
                    {
                        displayName: 'Json',
                        contentType: 'application/json'
                    }
                ];
                vm.typeObj = '';
                vm.jsonInferenceBody = '';
                vm.inferenceBody = '';
                vm.inferenceResultBody = '';
                vm.isInferenceCreating = false;
                vm.isInferenceCreated = false;

                vm.jsonEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                vm.fnResetInference = function () {
                    vm.inferenceResultBody = '';
                    vm.typeObj = '';
                    vm.jsonInferenceBody = '';
                    vm.inferenceBody = '';
                    vm.isInferenceCreating = false;
                    vm.isInferenceCreated = false;
                };

                vm.fnSaveInference = function () {
                    vm.isInferenceCreating = true;
                    var inputObj = {
                        body: '',
                        ContentType: '',
                        deploymentId: vm.parent.deploymentObj.id
                    };
                    if(vm.typeObj.displayName === 'Json') {
                        inputObj.body = angular.fromJson(vm.jsonInferenceBody);
                        inputObj.ContentType = vm.typeObj.contentType;
                    } else {
                        inputObj.body = vm.inferenceBody;
                        inputObj.ContentType = vm.typeObj.contentType;
                    }

                    InferenceFactory.createInference(inputObj)
                        .then(function (response) {
                            vm.inferenceResultBody = angular.toJson(response, true);
                            vm.isInferenceCreating = false;
                            vm.isInferenceCreated = true;
                        }, function () {
                            vm.fnResetInference();
                            vm.isInferenceCreating = false;
                        })
                };

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return true;
                    }
                    return false;
                }

                vm.fnCheckValidationInference = function () {
                    if(!vm.typeObj) {
                        return true;
                    } else {
                        if(vm.typeObj.displayName === 'Json') {
                           var flag = isJson(vm.jsonInferenceBody);
                           return flag;
                        } else {
                            if(!vm.inferenceBody) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitInferences = function () {
                    vm.fnSetTabHeight();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('VaultTeamsCtrl',
            function ($scope, $timeout, $state, $window, DB, TabHeight, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                    }
                };

                vm.fnGetVaultTeams = function (inputObj, preDefinedTeams, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (resTeams) {
                            var teams = isCalledForViz ? preDefinedTeams : [];
                            _.forEach(resTeams.data, function (teamsObj) {
                                teams.push(teamsObj);
                            });
                            if ((resTeams.data && resTeams.data.length && resTeams.data.length > 0) && (teams[0] && teams[0].totalItems > teams.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + teams[teams.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetVaultTeams({sql: sqlString}, teams, true);
                            } else {
                                vm.vaultTeamsArr = _.cloneDeepWith(teams);
                                vm.isVaultTeamsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }
                        }, function () {
                            vm.isVaultTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };
                vm.fnGoToTeam = function (obj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "name": "id is equal to: " + obj.id,
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": obj.id
                    };
                    tagsArr.push(angular.copy(inputObj));
                    DB.fnSet('isCalledFromUser', true);
                    $state.go("main.teams", {filter: angular.toJson(tagsArr)});
                };

                vm.fnInitVaultTeams = function () {
                    vm.isVaultTeamsLoading = true;
                    if (vm.parent.vaultObj.teamIds && vm.parent.vaultObj.teamIds.length) {
                        var teamIds = "";
                        _.forEach(vm.parent.vaultObj.teamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where data->>\'id\' IN (" + teamIds + ") LIMIT " + 100 + ";";
                        vm.fnGetVaultTeams({sql: teamSQL}, [], false);
                    } else {
                        vm.vaultTeamsArr = [];
                        vm.isVaultTeamsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('VaultSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, TeamFactory, VaultsFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.vaultSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 26 - actionDiv) + 'px');
                    }
                };

                vm.fnGetVaultData = function () {
                    vm.vaultSupplementalObj = vm.parent.vaultObj.tags ? angular.fromJson(vm.parent.vaultObj.tags) : {};
                    vm.vaultSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.vaultSupplementalObj, true) : vm.vaultSupplementalObj;
                    vm.vaultSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.vaultSupplementalObj, true) : vm.vaultSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.vaultSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.vaultSupplementalObj)) {
                        angular.forEach(vm.vaultSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isVaultSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.vaultSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };
                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.vaultSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.vaultSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.vaultSupplementalObj = angular.toJson(vm.vaultSupplementalObj, true);
                    } else {
                        vm.vaultSupplementalObj = angular.fromJson(vm.vaultSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.vaultSupplementalObj)) {
                            angular.forEach(vm.vaultSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveVaultData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.vaultObj.tags = {};
                    var inputObj = {
                        vaultId: vm.parent.vaultObj.id,
                        body: {}
                    };
                    if (!vm.parent.vaultObj.tags) {
                        vm.parent.vaultObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.vaultObj.tags = angular.fromJson(vm.vaultSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.vaultObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.vaultObj.tags;
                    VaultsFactory.replaceVaultData(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Vault successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitVaultSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitVaultSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.vaultSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.vaultSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        _.forEach(vm.vaultSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitVaultSupplemental = function () {
                    vm.isVaultSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ContentCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, TeamFactory, VaultsFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.vaultContentObj = {};
                vm.isContentDetailsEditable = false;
                vm.isContentDecrypt = false;
                vm.contentKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                vm.resetContentKVPArr = angular.copy(vm.contentKVPArr);
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 26 - actionDiv) + 'px');
                    }
                };

                vm.fnGetVaultData = function (vaultObj) {
                    vm.contentKVPArr = angular.copy(vm.resetContentKVPArr);
                    vm.isContentDecrypt = true;
                    vm.isVaultContentDetailsLoaded = false;
                    var inputObj = {
                        vaultId: vaultObj.id
                    };
                    VaultsFactory.describeVaultContent(inputObj)
                        .then(function (response) {
                            if(!response) {
                                // vm.fnAddContentKey(true);
                                vm.isContentDetailsEditable = true;
                            } else {
                                vm.vaultContentObj = response ? angular.fromJson(response) : {};
                                vm.vaultContentObj = vm.isAdvancedOption ? angular.toJson(vm.vaultContentObj, true) : vm.vaultContentObj;
                                vm.resetContentObj = angular.copy(vm.vaultContentObj);
                                vm.contentKVPArr = [];
                                if (!vm.isObjectEmpty(vm.vaultContentObj)) {
                                    angular.forEach(vm.vaultContentObj, function (value, key) {
                                        var tempObj = {
                                            key: key,
                                            value: value,
                                            inputType: 'password'
                                        };
                                        vm.contentKVPArr.push(tempObj);
                                    });
                                }
                                vm.resetContentArr = angular.copy(vm.contentKVPArr);
                            }
                            vm.isVaultContentDetailsLoaded = true;
                        })
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.vaultContentObj = angular.toJson(angular.copy(angular.fromJson(vm.resetContentObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.vaultContentObj = {};
                        _.forEach(vm.contentKVPArr, function (contentKVPObj) {
                            vm.vaultContentObj[contentKVPObj.key] = contentKVPObj.value;
                        });
                        vm.vaultContentObj = angular.toJson(vm.vaultContentObj, true);
                    } else {
                        vm.vaultContentObj = angular.fromJson(vm.vaultContentObj);
                        vm.contentKVPArr = [];
                        if (!vm.isObjectEmpty(vm.vaultContentObj)) {
                            angular.forEach(vm.vaultContentObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value,
                                    inputType: 'password'
                                };
                                vm.contentKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isContentDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveVaultData = function () {
                    vm.isContentDetailChanging = true;
                    vm.parent.vaultObj.tags = {};
                    var inputObj = {
                        vaultId: vm.parent.vaultObj.id,
                        body: {}
                    };
                    if (!vm.parent.vaultObj.tags) {
                        vm.parent.vaultObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.vaultObj.tags = angular.fromJson(vm.vaultContentObj)
                    } else {
                        _.forEach(vm.contentKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.vaultObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.vaultObj.tags;
                    VaultsFactory.replaceVaultContent(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Vault successfully");
                            vm.isContentDetailChanging = false;
                            vm.isContentDetailsEditable = false;
                            vm.isContentDecrypt = false;
                            vm.isAdvancedOption = false;
                        }, function () {
                            vm.isContentDetailChanging = false;
                            vm.isContentDetailsEditable = false;
                            vm.isContentDecrypt = false;
                            vm.isAdvancedOption = false;
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.contentKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.contentKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.contentKVPArr[vm.contentKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.contentKVPArr.length > 1) {
                                    angular.forEach(vm.contentKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.contentKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddContentKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isContentDetailsEditable = true;
                    }
                    vm.contentKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveContent = function (index) {
                    vm.contentKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.vaultContentObj = _.cloneDeepWith(vm.resetContentObj);
                    if (!vm.isObjectEmpty(vm.vaultContentObj)) {
                        vm.contentKVPArr = [];
                        _.forEach(vm.vaultContentObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.contentKVPArr.push(tempObj);
                        });
                    } else {
                        vm.contentKVPArr = [];
                    }
                    vm.isContentDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isContentDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isContentDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.contentKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.hideShowPassword = function (kvpPair) {
                    if (kvpPair.inputType === 'password') {
                        kvpPair.inputType = 'text';
                    } else {
                        kvpPair.inputType = 'password';
                    }
                };

                vm.fnKvpPairChange = function (kvpPair, index) {
                    if (kvpPair.value && kvpPair.key) {
                        if (index + 1 === vm.contentKVPArr.length) {
                            if (kvpPair.key.length && kvpPair.value.length && vm.contentKVPArr[vm.contentKVPArr.length - 1].key === kvpPair.key) {
                                var count = 0;
                                if (vm.contentKVPArr.length > 1) {
                                    angular.forEach(vm.contentKVPArr, function (kvpPairObj) {
                                        if (kvpPairObj.key === kvpPair.key) {
                                            count++;
                                        }
                                    });
                                }
                                if (count <= 1) {
                                    var inputObj = {
                                        key: '',
                                        value: '',
                                        inputType: 'password'
                                    };
                                    vm.contentKVPArr.push(inputObj)
                                }
                            }
                        }
                    }
                };

                vm.fnInitVaultContent = function () {
                    vm.isVaultContentDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TeamUsersCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, $log, DB, amaran, swal, TabHeight, microSpinner, QueryFactory, PaginationQueryService, UserProfileService, PermissionsService, PaginationService, LastPageService, FedSudoUserService, UserFactory, TeamFactory, postActionModelIcon, postActionModelMessage, IconService, ColorService, AvatarService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllTeamUsersChecked = false;
                vm.selectedTeamUsersArr = [];

                //Search Variables
                vm.isRefreshData = true;

                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'UNCONFIRMED', displayName: 'UNCONFIRMED'},
                    {name: 'SUSPENDED', displayName: 'SUSPENDED'},
                    {name: 'UNPAID', displayName: 'UNPAID'},
                    {name: 'CLOSED', displayName: 'CLOSED'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Email",
                        name: "email",
                        regexp: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
                        errorMessage: "Invalid Email address."
                    },
                    {
                        displayName: "Username",
                        name: "username",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "First Name",
                        name: "firstName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Last Name",
                        name: "lastName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "State",
                        name: "state",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.stateFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'email', displayName: 'Email'},
                    {name: 'username', displayName: 'Username'},
                    {name: 'state', displayName: 'State'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //var loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;
                vm.isUsersLoading = false;
                vm.isShowAddUser = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                id: item.id || parsedData.id || '',
                                firstName: parsedData.firstName || '',
                                lastName: parsedData.lastName || '',
                                email: parsedData.email || '',
                                username: parsedData.username || '',
                                state: parsedData.state || '',
                                administrator: parsedData.administrator || false,
                                accountOwner: parsedData.accountOwner || false,
                                type: parsedData.type || '',
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Add timestamps if they exist
                            if (item.created_at || parsedData.createdAt) {
                                parsedItem.createdAt = parsedData.createdAt || new Date(item.created_at).getTime() / 1000;
                            }

                            if (item.updated_at || parsedData.updatedAt) {
                                parsedItem.updatedAt = parsedData.updatedAt || new Date(item.updated_at).getTime() / 1000;
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddUser) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;

                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#teamsUserTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element(".tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddUser) {
                        if (angular.isDefined(angular.element(".content-main")[0]) && angular.isDefined(angular.element(".pagination-container")[0]) && angular.isDefined(angular.element(".search-panel-v4")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddUsers = function () {
                    vm.isAllTeamUsersChecked = false;
                    vm.fnCheckUncheckTeamUsersAll();
                    vm.isShowAddUser = !vm.isShowAddUser;
                    if (vm.isShowAddUser) {
                        vm.isInit = true;
                    }
                };

                vm.fnGetUserStateIcon = function (state) {
                    var icon = IconService.fnGetUserStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "SUSPENDED":
                            return icon + ' InactiveStateIcon';
                        default:
                            return icon + ' unconfirmedStateIcon';
                    }
                };

                vm.fnReturnUserImg = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                };

                vm.getUserStateColor = function (state) {
                    return ColorService.getUserStateColor(state);
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (sortQuery) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isUsersLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_users';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetUsers(input, true);
                };

                /*END: Search*/

                vm.fnCheckUncheckTeamUsersAll = function () {
                    angular.forEach(vm.teamUsersArr, function (obj) {
                        obj.isCheck = vm.isAllTeamUsersChecked;
                    });
                    if (vm.isAllTeamUsersChecked) {
                        vm.selectedTeamUsersArr = angular.copy(vm.teamUsersArr);
                    } else {
                        vm.selectedTeamUsersArr = [];
                    }
                };

                vm.fnCheckUncheckTeamUsersHeader = function (userObj) {
                    vm.isAllTeamUsersChecked = true;
                    angular.forEach(vm.teamUsersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllTeamUsersChecked = false;
                        }
                    });

                    /* Toggle push in selected user array*/
                    var isValueFind = _.find(vm.selectedTeamUsersArr, {'id': userObj.id});
                    if (!isValueFind) {
                        vm.selectedTeamUsersArr.push(userObj)
                    } else {
                        _.remove(vm.selectedTeamUsersArr, function (obj) {
                            return userObj.id === obj.id;
                        });
                    }
                };


                vm.fnDeleteTeamUsers = function (selectedTeamUsersArr) {
                    swal({
                            title: "Remove all selected Users from Team?",
                            text: "Users will be permanently removed for the Team.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedTeamUsersArr, function (selectedUser) {
                                    var inputObj = {
                                        teamId: vm.parent.teamObj.id,
                                        userId: selectedUser.id
                                    };
                                    promises.push(TeamFactory.removeUserFromTeam(inputObj));
                                });
                                $q.all(promises).then(function () {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    }, 1000);
                                    vm.selectedTeamUsersArr = [];
                                    //vm.fnGetTeamUsers(vm.parent.teamObj);
                                    var userIds = "";
                                    var teamUserIds = [];
                                    if (vm.parent.teamObj.userIds && vm.parent.teamObj.userIds.length === selectedTeamUsersArr.length) {
                                        vm.teamUsersArr = [];
                                    } else {
                                        angular.forEach(vm.parent.teamObj.userIds, function (team) {
                                            if (!_.find(selectedTeamUsersArr, {id: team})) {
                                                teamUserIds.push(team);
                                            }
                                        });
                                        _.forEach(teamUserIds, function (teamId) {
                                            if (userIds !== "") {
                                                userIds += ", '" + teamId + "'";
                                            } else {
                                                userIds = "'" + teamId + "'";
                                            }
                                        });
                                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users where data->>\'id\' IN (" + userIds + ") LIMIT " + 100 + ";";
                                        vm.fnGetTeamUsers({sql: teamSQL}, [], false);
                                    }
                                    vm.parent.teamObj.userIds = teamUserIds.length ? teamUserIds : [];
                                    $scope.$emit('TeamDetailsChanged', vm.parent.teamObj);
                                }, function (error) {
                                    amaran.error(error.errorMessage);
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.usersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedUsersArr = angular.copy(vm.usersArr);
                    } else {
                        vm.selectedUsersArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isUsersLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_users';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_users';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetUsers(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.teamsArr);
                        vm.previousPage = page;
                        vm.fnGetUsers(input, false);
                    }
                };

                vm.fnCheckUncheckHeader = function (userObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.usersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === userObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected user array*/
                    var isValueFind = _.find(vm.selectedUsersArr, {'id': userObj.id});
                    if (!isValueFind) {
                        vm.selectedUsersArr.push(userObj)
                    } else {
                        _.remove(vm.selectedUsersArr, function (obj) {
                            return userObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetUsers = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data = vm.parsePostgresData(res.data);
                            vm.userResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.userResponse.data && vm.userResponse.data.length) {
                                vm.totalItems = vm.userResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.userResponse.data.reverse();
                            }
                            vm.usersArr = vm.userResponse.data;
                            vm.isUsersLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                angular.element($window).resize();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUsersLoading = false;
                            vm.isRefresh = false;
                        })
                };


                vm.fnAddUser = function () {
                    vm.isUserAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedUsersArr, function (selectedUser) {
                        var inputObj = {
                            teamId: vm.parent.teamObj.id,
                            userId: selectedUser.id
                        };
                        promises.push(TeamFactory.addUserToTeam(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected users successfully add in Team");
                        var userIds = "";
                        var teamUserIds = vm.parent.teamObj.userIds && vm.parent.teamObj.userIds.length ? _.cloneDeepWith(vm.parent.teamObj.userIds) : [];
                        angular.forEach(vm.selectedUsersArr, function (selectedGroup) {
                            teamUserIds.push(selectedGroup.id);
                        });
                        _.forEach(teamUserIds, function (teamId) {
                            if (userIds !== "") {
                                userIds += ", '" + teamId + "'";
                            } else {
                                userIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users where data->>\'id\' IN (" + userIds + ") LIMIT " + 100 + ";";
                        vm.fnGetTeamUsers({sql: teamSQL}, [], false);
                        vm.isUserAdding = false;
                        vm.isShowAddUser = false;
                        vm.parent.teamObj.userIds = teamUserIds;
                        $scope.$emit('TeamDetailsChanged', vm.parent.teamObj);
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isUserAdding = false;
                    })
                };

                vm.fnGetTeamUsers = function (inputObj, preDefinedUsers, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            res.data = vm.parsePostgresData(res.data);
                            var users = isCalledForViz ? preDefinedUsers : [];
                            _.forEach(res.data, function (userObj) {
                                users.push(userObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (users[0] && users[0].totalItems > users.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetUserTeams({sql: sqlString}, users, true);
                            } else {
                                vm.teamUsersArr = users;
                                vm.isTeamUsersLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }
                        }, function () {
                            vm.isTeamUsersLoading = false;
                        })
                };

                vm.fnGoToUsers = function (obj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "name": "id is equal to: " + obj.id,
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": obj.id
                    };
                    tagsArr.push(angular.copy(inputObj));
                    /*DB.fnSet('isCalledFromUser', true);*/
                    $state.go("main.users", {filter: angular.toJson(tagsArr)});
                };

                vm.fnInitTeamUsers = function () {
                    vm.usersPermissionObj = PermissionsService.getPermissions("access:user");
                    vm.isTeamUsersLoading = true;
                    if (vm.parent.teamObj.userIds && vm.parent.teamObj.userIds.length) {
                        var userIds = "";
                        _.forEach(vm.parent.teamObj.userIds, function (teamId) {
                            if (userIds !== "") {
                                userIds += ", '" + teamId + "'";
                            } else {
                                userIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users where data->>\'id\' IN (" + userIds + ") LIMIT " + 100 + ";";
                        vm.fnGetTeamUsers({sql: teamSQL}, [], false);
                    } else {
                        vm.teamUsersArr = [];
                        vm.isTeamUsersLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TeamSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, TeamFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.teamSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetTeamData = function () {
                    vm.teamSupplementalObj = vm.parent.teamObj.tags ? angular.fromJson(vm.parent.teamObj.tags) : {};
                    vm.teamSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.teamSupplementalObj, true) : vm.teamSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.teamSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.teamSupplementalObj)) {
                        angular.forEach(vm.teamSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isTeamSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.teamSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.teamSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.teamSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.teamSupplementalObj = angular.toJson(vm.teamSupplementalObj, true);
                    } else {
                        vm.teamSupplementalObj = angular.fromJson(vm.teamSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.teamSupplementalObj)) {
                            angular.forEach(vm.teamSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveTeamData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.teamObj.tags = {};
                    var inputObj = {
                        teamId: vm.parent.teamObj.id,
                        body: {}
                    };
                    if (!vm.parent.teamObj.tags) {
                        vm.parent.teamObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.teamObj.tags = angular.fromJson(vm.teamSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.teamObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.teamObj.tags;
                    TeamFactory.replaceTeamTags(inputObj)
                        .then(function () {
                            amaran.success("Tag added to User Group successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitTeamSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitTeamSupplemental();
                        })

                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.teamSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.teamSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        _.forEach(vm.teamSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitTeamSupplemental = function () {
                    vm.isTeamSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TeamResourcesCtrl',
            function ($scope, $base64, $uibModal, $timeout, amaran, TabHeight, PermissionsService,
                      TeamFactory, BatchFactory, NodeProjectFactory, VaultsFactory, ProjectFactory, FederationsFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.resetResourceArr = [];
                vm.teamArr = [
                    {
                        title: "Access",
                        subapp: [{name: 'Federation', type: 'ACCESS_FEDERATION', isChecked: false},
                            {name: 'Vault', type: 'ACCESS_VAULT', isChecked: false}]
                    },
                    {
                        title: "Tracker",
                        subapp: [{name: 'Project', type: 'TRACKER_PROJECT', isChecked: false}]
                    },
                    {
                        title: "Node",
                        subapp: [{name: 'Project', type: 'NODE_PROJECT', isChecked: false}]
                    }
                ];
                vm.resetTeamArr = _.cloneDeepWith(vm.teamArr);
                var count = 0;
                vm.isUpdateCompleted = true;
                vm.resourceArr = [];

                vm.fnHideShowAddResources = function () {
                    /*vm.isAllTeamResourcesChecked = false;
                    _.forEach(vm.teamArr, function (resourceObj) {
                        _.forEach(resourceObj.subapp, function (subServiceObj) {
                            var isFindService = _.find(vm.teamResourcesArr, {service: subServiceObj.type});
                            if (isFindService) {
                                subServiceObj.isChecked = true;
                            }
                        })
                    });*/
                    vm.isShowAddResources = !vm.isShowAddResources;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };

                vm.fnCheckUncheckApps = function (teamObj, active) {
                    if (!active) {
                        vm.teamResourcesArr.splice(vm.teamResourcesArr.indexOf(teamObj.type), 1);
                    }
                };

                vm.openModal = function (resource) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/access/team/modal/resourceModal.html',
                        size: 'lg',
                        controller: 'resourceModalCtrl as resourceModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            resourceName: function () {
                                return resource;
                            }
                        }
                    });
                    modalInstance.result.then(function (resourceId) {
                        vm.teamResourcesArr.push({
                            service: resource.type,
                            id: resourceId
                        });
                    }, function () {
                        resource.isChecked = false;
                    });
                };

                vm.fnUpdateTeam = function () {
                    if (vm.addedResourcesArr.length && count < vm.addedResourcesArr.length) {
                        vm.fnCreateNewResources(vm.addedResourcesArr[count])
                    } else {
                        if (vm.deletedResourcesArr.length) {
                            vm.fnDeleteTeamResources(vm.deletedResourcesArr);
                        } else {
                            vm.fnUpdateTeamResources();
                        }
                    }
                };

                vm.fnCreateNewResources = function (statementObj) {
                    var inputObj = {
                        teamId: vm.parent.teamObj.id,
                        resourceId: statementObj.id
                    };
                    TeamFactory.addResourceToTeam(inputObj)
                        .then(function () {
                            count++;
                            vm.fnUpdateTeam();
                        })
                };

                vm.fnDeleteTeamResources = function (statementsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var editCount = 1;
                    var batchArr = [];
                    var inputObj = {};
                    angular.forEach(statementsArr, function (selectedStatementId, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + vm.parent.teamObj.id + "/resources/" + selectedStatementId.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            editCount++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + vm.parent.teamObj.id + "/resources/" + selectedStatementId.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        }
                    });
                    editCount = 1;
                    vm.fnDeleteBatchOperation(batchCollectionObj, editCount);
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, editCount) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[editCount],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount);
                            } else {
                                count = 0;
                                vm.fnUpdateTeamResources();
                            }
                        }, function (error) {
                            if (editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount);
                            } else {
                                count = 0;
                                vm.fnUpdateTeamResources();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnUpdateTeamResources = function () {
                    vm.isUpdateCompleted = true;
                    amaran.success("Team Updated Successfully");
                    vm.fnCancel();
                    vm.fnInitTeamResources();
                };

                vm.fnSave = function () {
                    vm.deletedResourcesArr = [];
                    vm.addedResourcesArr = [];
                    _.forEach(vm.resetResourceArr, function (resourceObj) {
                        var isFindObj = _.find(vm.teamResourcesArr, function (resObj) {
                            if (resObj.service === resourceObj.service && resObj.id === resourceObj.id) {
                                return resObj;
                            }
                        });
                        if (!isFindObj) {
                            vm.deletedResourcesArr.push(resourceObj);
                        }
                    });
                    _.forEach(vm.teamResourcesArr, function (resourceObj) {
                        var isFindObj = _.find(vm.resetResourceArr, {
                            service: resourceObj.service,
                            id: resourceObj.id
                        });
                        if (vm.teamResourcesArr && vm.teamResourcesArr.length && !isFindObj) {
                            vm.addedResourcesArr.push(resourceObj);
                        }
                        if (vm.teamResourcesArr && !vm.teamResourcesArr.length) {
                            vm.addedResourcesArr.push(resourceObj);
                        }
                    });
                    count = 0;
                    vm.isUpdateCompleted = false;
                    vm.fnUpdateTeam();
                };

                vm.fnCancel = function () {
                    vm.isShowAddResources = false;
                    vm.teamArr = _.cloneDeepWith(vm.resetTeamArr);
                    vm.teamResourcesArr = _.cloneDeepWith(vm.resetResourceArr);
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                };

                vm.fnRemoveTeamResource = function (resource) {
                    resource.isResourceRemoveProcessActive = true;
                    var inputObj = {
                        "teamId": vm.parent.teamObj.id,
                        "resourceId": resource.id
                    };
                    TeamFactory.removeResourceFromTeam(inputObj)
                        .then(function (res) {
                            vm.resourceArr = [];
                            _.forEach(res.resourceIds, function (resourceId) {
                                var id = resourceId.split("-")[1];
                                if (id.startsWith('cu')) {
                                    vm.resourceArr.push({
                                        service: 'ACCESS_FEDERATION',
                                        displayName: 'ACCESS FEDERATION',
                                        id: resourceId
                                    });
                                }
                                if (id.startsWith('tp')) {
                                    vm.resourceArr.push({
                                        service: 'TRACKER_PROJECT',
                                        displayName: 'TRACKER PROJECT',
                                        id: resourceId
                                    });
                                }
                                if (id.startsWith('av')) {
                                    vm.resourceArr.push({
                                        service: 'ACCESS_VAULT',
                                        displayName: 'ACCESS VAULT',
                                        id: resourceId
                                    });
                                }
                                if (id.startsWith('np')) {
                                    vm.resourceArr.push({
                                        service: 'NODE_PROJECT',
                                        displayName: 'NODE PROJECT',
                                        id: resourceId
                                    });
                                }
                            });
                            vm.teamResourcesArr = _.cloneDeepWith(vm.resourceArr);
                            vm.resetResourceArr = _.cloneDeepWith(vm.resourceArr);
                        })
                };

                vm.fnGetFederationResource = function (id) {
                    var inputObj = {
                        federationId: id
                    };
                    FederationsFactory.describeFederation(inputObj)
                        .then(function (res) {
                            var index = _.findIndex(vm.teamResourcesArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                vm.teamResourcesArr[index].resourceName = res.alias;
                            }
                            vm.resetResourceArr = _.cloneDeepWith(vm.teamResourcesArr);
                        })
                };

                vm.fnGetTrackerProjectResource = function (id) {
                    var inputObj = {
                        projectId: id
                    };
                    ProjectFactory.describeProject(inputObj)
                        .then(function (res) {
                            var index = _.findIndex(vm.teamResourcesArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                vm.teamResourcesArr[index].resourceName = res.name;
                            }
                            vm.resetResourceArr = _.cloneDeepWith(vm.teamResourcesArr);
                        })
                };

                vm.fnGetVaultResource = function (id) {
                    var inputObj = {
                        vaultId: id
                    };
                    VaultsFactory.describeVault(inputObj)
                        .then(function (res) {
                            var index = _.findIndex(vm.teamResourcesArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                vm.teamResourcesArr[index].resourceName = res.name;
                            }
                            vm.resetResourceArr = _.cloneDeepWith(vm.teamResourcesArr);
                        })
                };

                vm.fnGetNodeProjectResource = function (id) {
                    var inputObj = {
                        projectId: id
                    };
                    NodeProjectFactory.describeProject(inputObj)
                        .then(function (res) {
                            var index = _.findIndex(vm.teamResourcesArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                vm.teamResourcesArr[index].resourceName = res.name;
                            }
                            vm.resetResourceArr = _.cloneDeepWith(vm.teamResourcesArr);
                        })
                };

                vm.fnGetTeamResources = function () {
                    var accessPerm = PermissionsService.getPermissionsV4('access');
                    var trackerPerm = PermissionsService.getPermissionsV4('tracker');
                    var nodePerm = PermissionsService.getPermissionsV4('node');
                    vm.resourceArr = [];
                    _.forEach(vm.parent.teamObj.resourceIds, function (resourceId) {
                        var id = resourceId.split("-")[1];
                        if (id.startsWith('cu')) {
                            vm.resourceArr.push({
                                service: 'ACCESS_FEDERATION',
                                displayName: 'ACCESS FEDERATION',
                                id: resourceId
                            });
                            if (accessPerm.DESCRIBE_FEDERATION) {
                                vm.fnGetFederationResource(resourceId);
                            }
                        }
                        if (id.startsWith('tp')) {
                            vm.resourceArr.push({
                                service: 'TRACKER_PROJECT',
                                displayName: 'TRACKER PROJECT',
                                id: resourceId
                            });
                            if (trackerPerm.DESCRIBE_PROJECT) {
                                vm.fnGetTrackerProjectResource(resourceId);
                            }
                        }
                        if (id.startsWith('av')) {
                            vm.resourceArr.push({
                                service: 'ACCESS_VAULT',
                                displayName: 'ACCESS VAULT',
                                id: resourceId
                            });
                            if (accessPerm.DESCRIBE_VAULT) {
                                vm.fnGetVaultResource(resourceId);
                            }
                        }
                        if (id.startsWith('np')) {
                            vm.resourceArr.push({
                                service: 'NODE_PROJECT',
                                displayName: 'NODE PROJECT',
                                id: resourceId
                            });
                            if (nodePerm.DESCRIBE_PROJECT) {
                                vm.fnGetNodeProjectResource(resourceId);
                            }
                        }
                    });
                    vm.teamResourcesArr = _.cloneDeepWith(vm.resourceArr);
                    vm.resetResourceArr = _.cloneDeepWith(vm.resourceArr);
                    vm.isTeamResourcesLoading = false;
                };

                vm.fnInitTeamResources = function () {
                    vm.isTeamResourcesLoading = true;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, FederationsFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.federationSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.fnGetFederationData = function () {
                    vm.federationSupplementalObj = vm.parent.federationObj.tags ? angular.fromJson(vm.parent.federationObj.tags) : {};
                    vm.federationSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.federationSupplementalObj, true) : vm.federationSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.federationSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.federationSupplementalObj)) {
                        angular.forEach(vm.federationSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isFederationSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.federationSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.federationSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.federationSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.federationSupplementalObj = angular.toJson(vm.federationSupplementalObj, true);
                    } else {
                        vm.federationSupplementalObj = angular.fromJson(vm.federationSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.federationSupplementalObj)) {
                            angular.forEach(vm.federationSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveFederationData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.federationObj.tags = {};
                    var inputObj = {
                        federationId: vm.parent.federationObj.id,
                        body: {}
                    };
                    if (!vm.parent.federationObj.tags) {
                        vm.parent.federationObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.federationObj.tags = angular.fromJson(vm.federationSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.federationObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }
                    inputObj.body = vm.parent.federationObj.tags;
                    FederationsFactory.replaceFederationData(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Federation successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitFederationSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitFederationSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.federationSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.federationSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.federationSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitFederationSupplemental = function () {
                    vm.isFederationSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationsTeamsCtrl',
            function ($scope, $timeout, $state, $window, DB, TabHeight, QueryFactory) {
                var vm = this;
                vm.parent = $scope.$parent;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                    }
                };

                vm.fnGetFederationTeams = function (inputObj, preDefinedTeams, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (resTeams) {
                            var teams = isCalledForViz ? preDefinedTeams : [];
                            _.forEach(resTeams.data, function (teamsObj) {
                                teams.push(teamsObj);
                            });
                            if ((resTeams.data && resTeams.data.length && resTeams.data.length > 0) && (teams[0] && teams[0].totalItems > teams.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + teams[teams.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetFederationTeams({sql: sqlString}, teams, true);
                            } else {
                                vm.federationTeamsArr = _.cloneDeepWith(teams);
                                vm.isFederationTeamsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }
                        }, function () {
                            vm.isFederationTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnGoToTeam = function (obj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "name": "id is equal to: " + obj.id,
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": obj.id
                    };
                    tagsArr.push(angular.copy(inputObj));
                    DB.fnSet('isCalledFromUser', true);
                    $state.go("main.teams", {filter: angular.toJson(tagsArr)});
                };

                vm.fnInitFederationTeams = function () {
                    vm.isFederationTeamsLoading = true;
                    if (vm.parent.federationObj.teamIds && vm.parent.federationObj.teamIds.length) {
                        var teamIds = "";
                        _.forEach(vm.parent.federationObj.teamIds, function (teamId) {
                            if (teamIds !== "") {
                                teamIds += ", '" + teamId + "'";
                            } else {
                                teamIds = "'" + teamId + "'";
                            }
                        });
                        var teamSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_teams where data->>\'id\' IN (" + teamIds + ") LIMIT " + 100 + ";";
                        vm.fnGetFederationTeams({sql: teamSQL}, [], false);
                    } else {
                        vm.federationTeamsArr = [];
                        vm.isFederationTeamsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationScriptCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, FederationsFactory, swal, microSpinner, postActionModelMessage, postActionModelIcon) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.scriptBody = "";
                vm.scripts = {};
                vm.isScriptEditable = false;
                vm.isSaveChanges = false;

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        vm.readOnlyFalse = function () {
                            vm.editorOptions.readOnly = false;
                        };
                        vm.readOnlyTrue = function () {
                            vm.editorOptions.readOnly = true;
                        };
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.getFederationScripts = function (federationObj) {
                    var inputObj = {
                        federationId: federationObj.id
                    };
                    FederationsFactory.describeFederationScript(inputObj)
                        .then(function (response) {
                            vm.scripts = _.cloneDeepWith(response);
                            vm.scriptBody = response.script;
                            vm.isScriptEditable = false;
                            vm.isFederationScriptLoaded = false;
                            $timeout(function () {
                                $timeout(function () {
                                    vm.modeChanged();
                                    vm.fnSetTabHeight();
                                }, 100);
                            });
                        }, function () {
                            vm.isFederationScriptLoaded = false;
                        });
                };

                vm.fnInitFederationScript = function () {
                    vm.isFederationScriptLoaded = true;
                    if (vm.parent.federationObj.id) {
                        vm.getFederationScripts(vm.parent.federationObj);
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };

                vm.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    federationId: vm.parent.federationObj.id
                                };
                                FederationsFactory.resetFederationScript(inputObj)
                                    .then(function (response) {
                                        vm.scripts = _.cloneDeepWith(response);
                                        vm.scriptBody = response.script;
                                        vm.isScriptEditable = false;
                                        $timeout(function () {
                                            vm.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnSaveScript = function () {
                    vm.isSaveChanges = true;
                    var input = {
                        federationId: vm.parent.federationObj.id,
                        body: {
                            "scriptType": vm.scripts.scriptType,
                            "context": vm.scripts.context,
                            "script": vm.scriptBody
                        }
                    };
                    FederationsFactory.updateFederationScript(input).then(function (response) {
                        vm.isSaveChanges = false;
                        vm.scripts = _.cloneDeepWith(response);
                        vm.scriptBody = response.script;
                        vm.isScriptEditable = false;
                        vm.selectedNewTab = 1;
                        $timeout(function () {
                            vm.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        vm.isSaveChanges = false;
                        vm.scriptBody = vm.scripts.body;
                        vm.isScriptEditable = false;
                        $timeout(function () {
                            vm.readOnlyTrue();
                        });
                    });
                };

                vm.fnChangeToEditable = function () {
                    vm.resetScriptBody = _.cloneDeepWith(vm.scriptBody);
                    vm.isScriptEditable = true;
                    vm.readOnlyFalse();
                };

                vm.fnCancelEditable = function () {
                    $timeout(function () {
                        vm.scriptBody = _.cloneDeepWith(vm.resetScriptBody);
                        vm.isScriptEditable = false;
                        vm.readOnlyTrue();
                    })
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationRolesCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, microSpinner, UserProfileService, PaginationService, LastPageService, FedSudoUserService, FederationsFactory, RoleFactory, postActionModelIcon, SecurityRoleFactory, postActionModelMessage
            ) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllFederationRolesChecked = false;
                vm.selectedFederationRolesArr = [];

                //Search Variables

                var contextFieldArr = [
                    {name: 'GLOBAL', displayName: 'GLOBAL'},
                    {name: 'SECURITY_GROUP', displayName: 'SECURITY GROUP'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Context",
                        name: "context",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: contextFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //var loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 10;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddRole) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#federationSecurityRolesTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddRole) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddSecurityRoles = function () {
                    vm.isAllFederationRolesChecked = false;
                    vm.fnCheckUncheckFederationRolesAll();
                    vm.isShowAddRole = !vm.isShowAddRole;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isRolesLoading = true;
                    vm.selectedRolesArr = [];
                    vm.isAllChecked = false;
                    if (vm.filterQuery && vm.filterQuery.length && vm.isSinglePage) {
                        vm.fnGetFilterData();
                    } else {
                        var sortString = '';
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                        }
                        var currentPage = vm.currentPage - 1;
                        var input = {
                            limit: vm.perPage,
                            offset: vm.filterQuery && vm.filterQuery.length ? 0 : currentPage * vm.perPage,
                            orderBy: sortString && sortString.length ? sortString : '+id',
                            query: vm.sqlQuery && vm.sqlQuery.length ? vm.sqlQuery.trim() : ''
                        };
                        vm.fnGetSecurityRoles(input);
                    }
                };

                vm.fnGetFilterData = function () {
                    var securityRoleArr = [];
                    if (vm.isSinglePage) {
                        if (vm.securityRoleResponse.data.length) {
                            var filterSecurityRoleArr = [];
                            if (vm.filterQuery) {
                                filterSecurityRoleArr = _.filter(vm.securityRoleResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterSecurityRoleArr = _.cloneDeepWith(vm.securityRoleResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                securityRoleArr = _.orderBy(filterSecurityRoleArr, [sortValue], [sortType]);
                            } else {
                                securityRoleArr = _.cloneDeepWith(filterSecurityRoleArr);
                            }
                        }
                    }
                    else {
                        securityRoleArr = vm.securityRoleResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? securityRoleArr.length : vm.securityRoleResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.securityRoleResponse.metadata.currentPage;
                    vm.rolesArr = securityRoleArr;
                    if ($state.current.name === 'main.securityRoles') {
                        $timeout(function () {
                            $state.go('main.securityRoles', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isRefresh = false;
                    vm.isRolesLoading = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*END: Search*/

                vm.fnCheckUncheckFederationRolesAll = function () {
                    angular.forEach(vm.federationRolesArr, function (obj) {
                        obj.isCheck = vm.isAllFederationRolesChecked;
                    });
                    if (vm.isAllFederationRolesChecked) {
                        vm.selectedFederationRolesArr = angular.copy(vm.federationRolesArr);
                    } else {
                        vm.selectedFederationRolesArr = [];
                    }
                };

                vm.fnCheckUncheckFederationRolesHeader = function (roleObj) {
                    vm.isAllFederationRolesChecked = true;
                    angular.forEach(vm.federationRolesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllFederationRolesChecked = false;
                        }
                    });

                    /* Toggle push in selected role array*/
                    var isValueFind = _.find(vm.selectedFederationRolesArr, {'id': roleObj.id});
                    if (!isValueFind) {
                        vm.selectedFederationRolesArr.push(roleObj)
                    } else {
                        _.remove(vm.selectedFederationRolesArr, function (obj) {
                            return roleObj.id === obj.id;
                        });
                    }
                };

                vm.fnDeleteFederationSecurityRoles = function (selectedFederationRolesArr) {
                    swal({
                            title: "Remove all selected Security Roles from Federation?",
                            text: "Security Roles will be permanently removed for the Federation.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedFederationRolesArr, function (selectedRole) {
                                    var inputObj = {
                                        federationId: vm.parent.federationObj.id,
                                        securityRoleId: selectedRole.id
                                    };

                                    promises.push(FederationsFactory.removeSecurityRoleFromFederation(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedFederationRolesArr = [];
                                        vm.fnGetFederationSecurityRoles(vm.parent.federationObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.rolesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedRolesArr = angular.copy(vm.rolesArr);
                    } else {
                        vm.selectedRolesArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isRolesLoading = true;
                    vm.selectedRolesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                    }
                    var currentPage = vm.currentPage - 1;
                    var input = {
                        limit: vm.perPage,
                        offset: isPerPageChanged ? 0 : vm.perPage * currentPage,
                        orderBy: sortString && sortString.length ? sortString : '+id',
                        query: vm.sqlQuery
                    };
                    vm.fnGetSecurityRoles(input);
                };

                vm.fnCheckUncheckHeader = function (roleObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.rolesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === roleObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected role array*/
                    var isValueFind = _.find(vm.selectedRolesArr, {'id': roleObj.id});
                    if (!isValueFind) {
                        vm.selectedRolesArr.push(roleObj)
                    } else {
                        _.remove(vm.selectedRolesArr, function (obj) {
                            return roleObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetSecurityRoles = function (input) {
                    SecurityRoleFactory.listSecurityRoles(input)
                        .then(function (res) { // Success block
                            vm.isSinglePage = !(res && res.metadata && res.metadata.totalPages && res.metadata.totalPages > 1);
                            vm.securityRoleResponse = _.cloneDeepWith(res);
                            vm.fnGetFilterData();
                            vm.isRolesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isRolesLoading = false;
                        })
                };

                vm.fnAddSecurityRole = function () {
                    vm.isRoleAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedRolesArr, function (selectedRole) {
                        var inputObj = {
                            federationId: vm.parent.federationObj.id,
                            securityRoleId: selectedRole.id
                        };
                        promises.push(FederationsFactory.addSecurityRoleToFederation(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected Security role successfully added in Federation");
                        vm.fnGetFederationSecurityRoles(vm.parent.federationObj);
                        vm.isRoleAdding = false;
                        vm.isShowAddRole = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isRoleAdding = false;
                    })
                };

                vm.fnGetFederationSecurityRoles = function (federationObj) {
                    var inputObj = {
                        federationId: federationObj.id
                    };
                    FederationsFactory.listFederationSecurityRoles(inputObj)
                        .then(function (resFederationRoles) {
                            vm.federationRolesArr = resFederationRoles;
                            vm.isFederationRolesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFederationRolesLoading = false;
                        })
                };

                vm.fnInitFederationSecurityRoles = function () {
                    vm.isFederationRolesLoading = true;
                    vm.fnGetFederationSecurityRoles(vm.parent.federationObj);
                    $timeout(function () {
                        TabHeight.fnSet();
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationGroupsCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, microSpinner, UserProfileService, PermissionsService, PaginationService, LastPageService, FedSudoUserService, FederationsFactory, GroupFactory, postActionModelIcon, postActionModelMessage, SecurityGroupFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllFederationGroupsChecked = false;
                vm.selectedFederationGroupsArr = [];

                //Search Variables
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },{
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },{
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //var loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 10;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;

                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#federationSecurityGroupsTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddGroup) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddSecurityGroups = function () {
                    vm.isAllFederationGroupsChecked = false;
                    vm.fnCheckUncheckFederationGroupsAll();
                    vm.isShowAddGroup = !vm.isShowAddGroup;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isGroupsLoading = true;
                    vm.selectedGroupsArr = [];
                    vm.isAllChecked = false;
                    if (vm.filterQuery && vm.filterQuery.length && vm.isSinglePage) {
                        vm.fnGetFilterData();
                    } else {
                        var sortString = '';
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                        }
                        var currentPage = vm.currentPage - 1;
                        var input = {
                            limit: vm.perPage,
                            offset: vm.filterQuery && vm.filterQuery.length ? 0 : currentPage * vm.perPage,
                            orderBy: sortString && sortString.length ? sortString : '+id',
                            query: vm.sqlQuery && vm.sqlQuery.length ? vm.sqlQuery.trim() : ''
                        };
                        vm.fnGetSecurityGroups(input);
                    }
                };

                vm.fnGetFilterData = function () {
                    var securityGroupArr = [];
                    if (vm.isSinglePage) {
                        if (vm.securityGroupResponse.data.length) {
                            var filterSecurityGroupArr = [];
                            if (vm.filterQuery) {
                                filterSecurityGroupArr = _.filter(vm.securityGroupResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterSecurityGroupArr = _.cloneDeepWith(vm.securityGroupResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                securityGroupArr = _.orderBy(filterSecurityGroupArr, [sortValue], [sortType]);
                            } else {
                                securityGroupArr = _.cloneDeepWith(filterSecurityGroupArr);
                            }
                        }
                    }
                    else {
                        securityGroupArr = vm.securityGroupResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? securityGroupArr.length : vm.securityGroupResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.securityGroupResponse.metadata.currentPage;
                    vm.groupsArr = securityGroupArr;
                    vm.isRefresh = false;
                    vm.isGroupsLoading = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*END: Search*/

                vm.fnCheckUncheckFederationGroupsAll = function () {
                    angular.forEach(vm.federationGroupsArr, function (obj) {
                        obj.isCheck = vm.isAllFederationGroupsChecked;
                    });
                    if (vm.isAllFederationGroupsChecked) {
                        vm.selectedFederationGroupsArr = angular.copy(vm.federationGroupsArr);
                    } else {
                        vm.selectedFederationGroupsArr = [];
                    }
                };

                vm.fnCheckUncheckFederationGroupsHeader = function (groupObj) {
                    vm.isAllFederationGroupsChecked = true;
                    angular.forEach(vm.federationGroupsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllFederationGroupsChecked = false;
                        }
                    });

                    /* Toggle push in selected group array*/
                    var isValueFind = _.find(vm.selectedFederationGroupsArr, {'id': groupObj.id});
                    if (!isValueFind) {
                        vm.selectedFederationGroupsArr.push(groupObj)
                    } else {
                        _.remove(vm.selectedFederationGroupsArr, function (obj) {
                            return groupObj.id === obj.id;
                        });
                    }
                };


                vm.fnDeleteFederationGroups = function (selectedFederationGroupsArr) {
                    swal({
                            title: "Remove all selected Security Groups from Federation?",
                            text: "Security Groups will be permanently removed for the Federation.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedFederationGroupsArr, function (selectedGroup) {
                                    var inputObj = {
                                        federationId: vm.parent.federationObj.id,
                                        securityGroupId: selectedGroup.id
                                    };

                                    promises.push(FederationsFactory.removeSecurityGroupFromFederation(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        vm.selectedFederationGroupsArr = [];
                                        vm.fnGetFederationGroups(vm.parent.federationObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.groupsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGroupsArr = angular.copy(vm.groupsArr);
                    } else {
                        vm.selectedGroupsArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isGroupsLoading = true;
                    vm.selectedGroupsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                    }
                    var currentPage = vm.currentPage - 1;
                    var input = {
                        limit: vm.perPage,
                        offset: isPerPageChanged ? 0 : vm.perPage * currentPage,
                        orderBy: sortString && sortString.length ? sortString : '+id',
                        query: vm.sqlQuery
                    };
                    vm.fnGetSecurityGroups(input);
                };

                vm.fnCheckUncheckHeader = function (groupObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.groupsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === groupObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected group array*/
                    var isValueFind = _.find(vm.selectedGroupsArr, {'id': groupObj.id});
                    if (!isValueFind) {
                        vm.selectedGroupsArr.push(groupObj)
                    } else {
                        _.remove(vm.selectedGroupsArr, function (obj) {
                            return groupObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetSecurityGroups = function (input) {
                    SecurityGroupFactory.listSecurityGroups(input)
                        .then(function (res) { // Success block
                            vm.isSinglePage = !(res && res.metadata && res.metadata.totalPages && res.metadata.totalPages > 1);
                            vm.securityGroupResponse = _.cloneDeepWith(res);
                            vm.fnGetFilterData();
                            vm.isGroupsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGroupsLoading = false;
                        })
                };

                vm.fnAddSecurityGroup = function () {
                    vm.isGroupAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedGroupsArr, function (selectedGroup) {
                        var inputObj = {
                            federationId: vm.parent.federationObj.id,
                            securityGroupId: selectedGroup.id
                        };
                        promises.push(FederationsFactory.addSecurityGroupToFederation(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected Security groups successfully added in Federation");
                        vm.fnGetFederationGroups(vm.parent.federationObj);
                        vm.isGroupAdding = false;
                        vm.isShowAddGroup = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isGroupAdding = false;
                    })
                };

                vm.fnGetFederationGroups = function (federationObj) {
                    var inputObj = {
                        federationId: federationObj.id
                    };
                    FederationsFactory.listFederationSecurityGroups(inputObj)
                        .then(function (resFederationGroups) {
                            vm.federationGroupsArr = resFederationGroups;
                            vm.isFederationGroupsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function () {
                            vm.isFederationGroupsLoading = false;
                        })
                };

                vm.fnInitFederationGroups = function () {
                    vm.isFederationGroupsLoading = true;
                    vm.fnGetFederationGroups(vm.parent.federationObj);
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AuthenticatorUsersCtrl',
            function ($scope, $window, $timeout, $state, $stateParams, $q, DB, amaran, swal, TabHeight, microSpinner, UserProfileService, PaginationService, LastPageService, FedSudoUserService, UserFactory,
                      AuthenticatorFactory, postActionModelIcon, postActionModelMessage, IconService, ColorService, AvatarService) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAllAuthenticatorUsersChecked = false;
                vm.selectedAuthenticatorUsersArr = [];

                //Search Variables
                vm.isInit = true;

                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'UNCONFIRMED', displayName: 'UNCONFIRMED'},
                    {name: 'SUSPENDED', displayName: 'SUSPENDED'},
                    {name: 'UNPAID', displayName: 'UNPAID'},
                    {name: 'CLOSED', displayName: 'CLOSED'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Email",
                        name: "email",
                        regexp: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
                        errorMessage: "Invalid Email address."
                    },
                    {
                        displayName: "Username",
                        name: "username",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "First Name",
                        name: "firstName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Last Name",
                        name: "lastName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "State",
                        name: "state",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.stateFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'firstName', displayName: 'Firstname'},
                    {name: 'lastName', displayName: 'Lastname'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'email', displayName: 'Email'},
                    {name: 'username', displayName: 'Username'},
                    {name: 'state', displayName: 'State'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //var loginUser = DB.fnGet('loginUser');
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 10;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddUser) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + pagination + header + 85);
                            angular.element("#UserTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element(".tableContainer tbody").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnHideShowAddUsers = function () {
                    vm.isAllAuthenticatorUsersChecked = false;
                    vm.fnCheckUncheckAuthenticatorUsersAll();
                    vm.isShowAddUser = !vm.isShowAddUser;
                    if (vm.isShowAddUser) {
                        vm.isInit = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnSetLoaderTableHeight = function () {
                    var total = 0;
                    if (vm.isShowAddUser) {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var header = 36;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + header + 80);
                            angular.element("#loading-row").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.isDefined(angular.element(".content-main")[0])) {
                            total = angular.element(".content-main")[0].offsetHeight;
                            var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                            var tableHeader = 36;
                            angular.element("#loading-row").css('height', (total - tableHeader - 16 - actionDiv) + 'px');
                        }
                    }
                };

                vm.fnGetUserStateIcon = function (state) {
                    var icon = IconService.fnGetUserStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "SUSPENDED":
                            return icon + ' InactiveStateIcon';
                        default:
                            return icon + ' unconfirmedStateIcon';
                    }
                };

                vm.fnReturnUserImg = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                };

                vm.getUserStateColor = function (state) {
                    return ColorService.getUserStateColor(state);
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.isUsersLoading = true;
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isUsersLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    if (vm.filterQuery && vm.filterQuery.length && vm.isSinglePage) {
                        vm.fnGetFilterData();
                    } else {
                        var sortString = '';
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                        }
                        var currentPage = vm.currentPage - 1;
                        var input = {
                            limit: vm.perPage,
                            offset: vm.filterQuery && vm.filterQuery.length ? 0 : currentPage * vm.perPage,
                            orderBy: sortString && sortString.length ? sortString : '+id',
                            query: vm.sqlQuery && vm.sqlQuery.length ? vm.sqlQuery.trim() : ''
                        };
                        vm.fnGetUsers(input);
                    }
                };

                vm.fnGetFilterData = function () {
                    var userArr = [];
                    if (vm.isSinglePage) {
                        if (vm.userResponse.data.length) {
                            var filterUserArr = [];
                            if (vm.filterQuery) {
                                filterUserArr = _.filter(vm.userResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterUserArr = _.cloneDeepWith(vm.userResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                userArr = _.orderBy(filterUserArr, [sortValue], [sortType]);
                            } else {
                                userArr = _.cloneDeepWith(filterUserArr);
                            }
                        }
                    } else {
                        userArr = vm.userResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? userArr.length : vm.userResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.userResponse.metadata.currentPage;
                    vm.usersArr = userArr;
                    if ($state.current.name === 'main.users') {
                        $timeout(function () {
                            $state.go('main.users', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isRefresh = false;
                    vm.isUsersLoading = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*END: Search*/

                vm.fnCheckUncheckAuthenticatorUsersAll = function () {
                    angular.forEach(vm.authenticatorUsersArr, function (obj) {
                        obj.isCheck = vm.isAllAuthenticatorUsersChecked;
                    });
                    if (vm.isAllAuthenticatorUsersChecked) {
                        vm.selectedAuthenticatorUsersArr = angular.copy(vm.authenticatorUsersArr);
                    } else {
                        vm.selectedAuthenticatorUsersArr = [];
                    }
                };

                vm.fnCheckUncheckAuthenticatorUsersHeader = function (userObj) {
                    vm.isAllAuthenticatorUsersChecked = true;
                    angular.forEach(vm.authenticatorUsersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllAuthenticatorUsersChecked = false;
                        }
                    });

                    /* Toggle push in selected user array*/
                    var isValueFind = _.find(vm.selectedAuthenticatorUsersArr, {'id': userObj.id});
                    if (!isValueFind) {
                        vm.selectedAuthenticatorUsersArr.push(userObj)
                    } else {
                        _.remove(vm.selectedAuthenticatorUsersArr, function (obj) {
                            return userObj.id === obj.id;
                        });
                    }
                };

                vm.fnDeleteAuthenticatorUsers = function (selectedAuthenticatorUsersArr) {
                    swal({
                            title: "Remove all selected Users from Authenticator?",
                            text: "Users will be permanently removed for the Authenticator.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var promises = [];
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedAuthenticatorUsersArr, function (selectedUser) {
                                    var inputObj = {
                                        authenticatorId: vm.parent.authenticatorObj.id,
                                        userId: selectedUser.id
                                    };

                                    promises.push(AuthenticatorFactory.removeUserFromAuthenticator(inputObj));

                                    $q.all(promises).then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        vm.selectedAuthenticatorUsersArr = [];
                                        vm.fnGetAuthenticatorUsers(vm.parent.authenticatorObj);
                                    }, function (error) {
                                        amaran.error(error.errorMessage);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                                });
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.usersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedUsersArr = angular.copy(vm.usersArr);
                    } else {
                        vm.selectedUsersArr = [];
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isUsersLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                    }
                    var currentPage = vm.currentPage - 1;
                    var input = {
                        limit: vm.perPage,
                        offset: isPerPageChanged ? 0 : vm.perPage * currentPage,
                        orderBy: sortString && sortString.length ? sortString : '+id',
                        query: vm.sqlQuery
                    };
                    vm.fnGetUsers(input);
                };

                vm.fnCheckUncheckHeader = function (userObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.usersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === userObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected user array*/
                    var isValueFind = _.find(vm.selectedUsersArr, {'id': userObj.id});
                    if (!isValueFind) {
                        vm.selectedUsersArr.push(userObj)
                    } else {
                        _.remove(vm.selectedUsersArr, function (obj) {
                            return userObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetUsers = function (input) {
                    UserFactory.listUsers(input)
                        .then(function (res) { // Success block
                            vm.isSinglePage = !(res && res.metadata && res.metadata.totalPages && res.metadata.totalPages > 1);
                            vm.userResponse = _.cloneDeepWith(res);
                            vm.fnGetFilterData();
                            vm.isUsersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUsersLoading = false;
                            vm.isRefresh = false;
                        })
                };


                vm.fnAddUser = function () {
                    vm.isUserAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedUsersArr, function (selectedUser) {
                        var inputObj = {
                            authenticatorId: vm.parent.authenticatorObj.id,
                            userId: selectedUser.id
                        };
                        promises.push(AuthenticatorFactory.addUserToAuthenticator(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected users successfully add in Authenticator");
                        vm.fnGetAuthenticatorUsers(vm.parent.authenticatorObj);
                        vm.isUserAdding = false;
                        vm.isShowAddUser = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        vm.isUserAdding = false;
                    })
                };

                vm.fnGetAuthenticatorUsers = function (authenticatorObj) {
                    var inputObj = {
                        authenticatorId: authenticatorObj.id
                    };
                    AuthenticatorFactory.listAuthenticatorUsers(inputObj)
                        .then(function (resAuthenticatorUsers) {
                            vm.authenticatorUsersArr = resAuthenticatorUsers;
                            vm.isAuthenticatorUsersLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAuthenticatorUsersLoading = false;
                        })
                };

                vm.fnInitAuthenticatorUsers = function () {
                    TabHeight.fnSet();
                    vm.isAuthenticatorUsersLoading = true;
                    if (vm.parent.authenticatorObj.id) {
                        vm.fnGetAuthenticatorUsers(vm.parent.authenticatorObj);
                    } else {
                        vm.isAuthenticatorUsersLoading = false;
                    }
                    $timeout(function () {
                        TabHeight.fnSet();
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AuthenticatorSupplementalCtrl',
            function ($scope, $timeout, $window, amaran, TabHeight, AuthenticatorFactory) {
                var vm = this;
                vm.parent = $scope.$parent;
                vm.isAdvancedOption = false;
                vm.authenticatorSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    var total = 0;
                    if (angular.isDefined(angular.element(".content-main")[0])) {
                        total = angular.element(".content-main")[0].offsetHeight;
                        var actionDiv = angular.isDefined(angular.element(".action-div")[0]) ? angular.element(".action-div")[0].offsetHeight : 0;
                        var tableHeader = 36;
                        angular.element(".tableContainer tbody").css('height', (total - tableHeader - 26 - actionDiv) + 'px');
                    }
                };

                vm.fnGetAuthenticatorData = function () {
                    vm.authenticatorSupplementalObj = vm.parent.authenticatorObj.tags ? angular.fromJson(vm.parent.authenticatorObj.tags) : {};
                    vm.authenticatorSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.authenticatorSupplementalObj, true) : vm.authenticatorSupplementalObj;
                    vm.resetSupplementalObj = angular.copy(vm.authenticatorSupplementalObj);
                    vm.supplementalKVPArr = [];
                    if (!vm.isObjectEmpty(vm.authenticatorSupplementalObj)) {
                        angular.forEach(vm.authenticatorSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    }
                    vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    vm.isAuthenticatorSupplementalDetailsLoaded = true;
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.readOnlyFalse();
                    } else {
                        vm.authenticatorSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.authenticatorSupplementalObj = {};
                        _.forEach(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            vm.authenticatorSupplementalObj[supplementalKVPObj.key] = supplementalKVPObj.value;
                        });
                        vm.authenticatorSupplementalObj = angular.toJson(vm.authenticatorSupplementalObj, true);
                    } else {
                        vm.authenticatorSupplementalObj = angular.fromJson(vm.authenticatorSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.authenticatorSupplementalObj)) {
                            angular.forEach(vm.authenticatorSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        $timeout(function () {
                            vm.fnToggle();
                        });
                    }
                };

                vm.fnSaveAuthenticatorData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.parent.authenticatorObj.tags = {};
                    var inputObj = {
                        authenticatorId: vm.parent.authenticatorObj.id,
                        body: {}
                    };
                    if (!vm.parent.authenticatorObj.tags) {
                        vm.parent.authenticatorObj.tags = {};
                    }
                    if (vm.isAdvancedOption) {
                        vm.parent.authenticatorObj.tags = angular.fromJson(vm.authenticatorSupplementalObj)
                    } else {
                        _.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                            if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                                vm.parent.authenticatorObj.tags[kpPairObj.key] = kpPairObj.value;
                            }
                        });
                    }

                    inputObj.body = vm.parent.authenticatorObj.tags;
                    AuthenticatorFactory.replaceAuthenticatorData(inputObj)
                        .then(function () {
                            amaran.success("Tag added to Authenticator successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitAuthenticatorSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitAuthenticatorSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                    if (kvpPairObj.value && kvpPairObj.key) {
                        if (index + 1 === vm.supplementalKVPArr.length) {
                            if (kvpPairObj.key.length && kvpPairObj.value.length && vm.supplementalKVPArr[vm.supplementalKVPArr.length - 1].key === kvpPairObj.key) {
                                var tempCount = 0;
                                if (vm.supplementalKVPArr.length > 1) {
                                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                                        if (kvpPair.key === kvpPairObj.key) {
                                            tempCount++;
                                        }
                                    });
                                }
                                if (tempCount <= 1) {
                                    vm.supplementalKVPArr.push({
                                        key: '',
                                        value: ''
                                    })
                                }
                            }
                        }
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if (isCalledEditMode) {
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.authenticatorSupplementalObj = _.cloneDeepWith(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.authenticatorSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        _.forEach(vm.authenticatorSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                    if (vm.isAdvancedOption) {
                        vm.fnToggle();
                    }
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                    if (vm.isAdvancedOption && vm.isSupplementalDetailsEditable) {
                        $timeout(function () {
                            vm.fnToggle(true);
                        });
                    } else {
                        vm.supplementalKVPArr.push({
                            key: '',
                            value: ''
                        });
                    }
                };

                vm.fnInitAuthenticatorSupplemental = function () {
                    vm.isAuthenticatorSupplementalDetailsLoaded = false;
                    $timeout(function () {
                        TabHeight.fnSet();
                    })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('setupModalCtrl',
            function ($scope, swal, $timeout, $uibModalInstance, amaran, WizardHandler, GroupFactory, PermissionsService, DB, recipesService, recipeObj) {
                var vm = this;
                vm.recipeObj = recipeObj;
                vm.isDetailsLoaded = false;
                vm.isAllAccess = true;
                vm.isWizardLastStep = false;
                vm.isSetupStart = false;
                vm.isErrorOccurred = false;
                vm.apiSuccessArr=[];
                /*End inject */

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCheckUserPermission = function (recipeObj) {
                    _.forEach(recipeObj.permissionArr, function (obj) {
                        if(obj.permission !==''){
                            obj.isAccess = vm.userPermissions[obj.permission] === "TRUE";
                        }
                        if(obj.isAccess === false){
                            vm.isAllAccess = false;
                        }
                    });
                    $timeout(function () {
                        vm.isDetailsLoaded = false;
                    });
                };

                vm.fnNextStep = function () {
                    var wizardTotalStep = WizardHandler.wizard().totalStepCount();
                    var wizardCurrentStep = WizardHandler.wizard().currentStepNumber();
                    if(wizardTotalStep > wizardCurrentStep){
                        WizardHandler.wizard().next();
                        if(wizardTotalStep === wizardCurrentStep+1){
                            vm.isWizardLastStep = true;
                        }
                    }
                };

                $scope.$on('wizard:stepChanged',function(event, args) {
                    if(args.index ===0){
                        vm.isWizardLastStep = false;
                    }
                });

                vm.fnCallRecipeService = function (count, apiCallArr, idObj) {
                    vm.recipeObj.permissionArr[count].isVisible = true;
                    $timeout(function () {
                        var createFederation = recipesService.fnInitRecipes(count, apiCallArr, idObj);
                        createFederation.then(function (response) {
                            vm.recipeObj.permissionArr[count].isStepFinished = true;
                            count++;
                            if (apiCallArr.length && count < apiCallArr.length) {
                                vm.fnCallRecipeService(count, apiCallArr, response.idObj);
                            } else {
                                vm.isSetupStart = false;
                                $timeout(function () {
                                    amaran.success("Support Federation created successfully");
                                    $uibModalInstance.dismiss('cancel');
                                }, 100);
                            }
                        }, function () {
                            vm.isErrorOccurred = true;
                            vm.recipeObj.permissionArr[count].isErrorOccurred = true;
                            var createFederation = recipesService.deleteSaveData(idObj);
                            createFederation.then(function () {
                                vm.isSetupStart = false;
                                $timeout(function () {
                                    amaran.error("Support Federation Not created successfully");
                                    $uibModalInstance.dismiss('cancel');
                                }, 100);
                            });
                        });
                    }, 1000)
                };

                vm.fnFinishedWizard = function () {
                    vm.isSetupStart = true;
                    var apiCallArr = [];
                    var subApp = '';
                    var serviceName = '';
                    _.forEach(vm.recipeObj.permissionArr, function (obj) {
                        if(obj.permission !==''){
                            serviceName = obj.permission.split(':')[obj.permission.split(':').length - 1];
                            subApp = obj.permission.split(':')[obj.permission.split(':').length - 2];
                            apiCallArr.push({"name":obj.name,"service":subApp+":"+serviceName})
                        }
                    });
                    var count = 0;
                    if (apiCallArr.length && count < apiCallArr.length) {
                        vm.fnCallRecipeService(count, apiCallArr);
                    }

                };

                vm.fnInitSetupModal = function () {
                    vm.isDetailsLoaded = true;
                    vm.userPermissions = DB.fnGet("userPermissions");
                    if(vm.recipeObj && Object.keys(vm.recipeObj).length !==0){
                        vm.fnCheckUserPermission(vm.recipeObj);
                    }else{
                        vm.isDetailsLoaded = false;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeConfigurationModalCtrl',
            function ($scope, $timeout, $uibModalInstance, amaran, WizardHandler, PermissionsService, AppInitService,
                      DB, recipesService, ColorService, UserFactory, TypeFactory, ObserverFactory, BatchFactory,
                      HealthFactory, NotificationFactory, DeviceFactory, recipeObj) {
                var vm = this;

                vm.recipeObj = recipeObj;

                /*START: Privileges tab*/
                vm.isDetailsLoaded = false;
                vm.isAllAccess = true;
                /*END: Privileges End*/

                /*START: Extra Data*/
                vm.accountUsers = [];
                vm.typesArr = [];
                vm.observerBlueprints = [];
                vm.observersArr = [];
                vm.devicesArr = [];
                vm.isSpinnerShow = false;
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                vm.isDeviceDetailsLoaded = false;
                vm.isTypesDetailsLoaded = false;
                vm.isObserverBlueprintsDetailsLoaded = false;
                vm.isObserversDetailsLoaded = false;
                vm.isTypesFilter = false;
                vm.search = '';
                vm.isBluePrintSelected = false;
                vm.isObserversConfigurationDone = false;
                vm.isFindDeviceObservers = false;
                vm.isObserverDataCreate = false;
                /*END: Extra Data*/

                /*START: WIZARD STEPS*/
                vm.currentStepIndex = 0;
                /*END: WIZARD STEPS*/

                /*START: Default Values*/
                var defaultHealths = [{
                    code: 200,
                    name: 'OK',
                    color: '#00ff00'
                }, {
                    code: 299,
                    name: 'Gateway Disconnect',
                    color: '#cc338c'
                }, {
                    code: 300,
                    name: 'Warning',
                    color: '#ffff00'
                }, {
                    code: 400,
                    name: 'Severe',
                    color: '#ffa500'
                }, {
                    code: 500,
                    name: 'Critical',
                    color: '#ff0000'
                }];
                var notificationConfigObj = {
                    name: '',
                    description: "",
                    state: "ACTIVE",
                    logging: true,
                    window: {
                        includeDaysOfYear: [],
                        excludeDaysOfYear: [],
                        daysOfTheWeek: [],
                        timezone: "UTC",
                        startHour: "08",
                        startMinute: "00",
                        endHour: "17",
                        endMinute: "00",
                        always: true
                    },
                    function: {
                        type: "NONE",
                        settings: {
                            seconds: 0,
                            acceptableHealths: []
                        }
                    },
                    target: {
                        scope: "ATTRIBUTE",
                        beforeHealth: 0,
                        afterHealth: 0
                    },
                    dispatch: {
                        type: "EMAIL",
                        settings: {
                            emails: []
                        }
                    }
                };

                vm.defaultNotifications = [{
                    name: 'Any > Severe',
                    beforeHealth: -1,
                    afterHealth: 400,
                    emails: [],
                    emailValue: "",
                    isOpen: false,
                    isDone: false,
                    isInputError: false
                }, {
                    name: 'Any > Critical',
                    beforeHealth: -1,
                    afterHealth: 500,
                    emails: [],
                    emailValue: "",
                    isOpen: false,
                    isDone: false,
                    isInputError: false
                }, {
                    name: 'Severe > OK',
                    beforeHealth: 400,
                    afterHealth: 200,
                    emails: [],
                    emailValue: "",
                    isOpen: false,
                    isDone: false,
                    isInputError: false
                }, {
                    name: 'Critical > OK',
                    beforeHealth: 500,
                    afterHealth: 200,
                    emails: [],
                    emailValue: "",
                    isOpen: false,
                    isDone: false,
                    isInputError: false
                }];
                /*END: Default Values*/

                /*START: Modal*/
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSetDeviceTypeHeight = function () {
                    if (angular.element(".modal-body")[0] && angular.element(".searchDiv")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var searchDiv = angular.element(".searchDiv")[0].offsetHeight;
                        var stepsIndicator = angular.element(".steps-indicator")[0].offsetHeight;
                        var finalHeight = total - (searchDiv + stepsIndicator);
                        angular.element(".deviceModelDiv").css('height', (finalHeight - 105) + 'px');
                    }
                };
                /*END: Modal*/

                /*START: Observers*/
                vm.fnInitCreateObservers = function () {
                    var inputObj = {};
                    inputObj.size = 100;
                    inputObj.start = 0;
                    inputObj.q = "";
                    vm.fnGetDevices(inputObj);
                };

                vm.fnCreateObserverData = function () {
                    var tempObserversArr = [];
                    if (vm.devicesArr && vm.devicesArr.length) {
                        var typesArr = [];
                        _.forEach(vm.devicesArr, function (deviceObj) {
                            var isFindType = _.find(typesArr, {typeId: deviceObj.typeId});
                            if (!isFindType) {
                                typesArr.push(deviceObj);
                            }
                        });
                        if (vm.observersArr && vm.observersArr.length) {
                            _.forEach(typesArr, function (deviceObj) {
                                var existingOb = _.filter(vm.observersArr, function (observerObj) {
                                    if ((observerObj.topicOem === '*' || observerObj.topicOem === deviceObj.oem) &&
                                        (observerObj.topicModel === '*' || observerObj.topicModel === deviceObj.model) &&
                                        (observerObj.topicVersion === '*' || observerObj.topicVersion === deviceObj.version) &&
                                        (observerObj.topicId === '*' || observerObj.topicId === deviceObj.typeId)) {
                                        return observerObj;
                                    }
                                });
                                var isObserverFound = !!(existingOb && existingOb.length);
                                if (!isObserverFound) {
                                    var existingBluePrintOb = _.filter(vm.observerBlueprints, function (observerObj) {
                                        if ((observerObj.topicOem === '*' || observerObj.topicOem === deviceObj.oem) &&
                                            (observerObj.topicModel === '*' || observerObj.topicModel === deviceObj.model) &&
                                            (observerObj.topicVersion === '*' || observerObj.topicVersion === deviceObj.version) &&
                                            (observerObj.topicId === '*' || observerObj.topicId === deviceObj.typeId)) {
                                            return observerObj;
                                        }
                                    });
                                    if (existingBluePrintOb && existingBluePrintOb.length) {
                                        tempObserversArr.push(existingBluePrintOb[0]);
                                    }
                                }
                            });
                        } else {
                            _.forEach(typesArr, function (deviceObj) {
                                var existingBluePrintOb = _.filter(vm.observerBlueprints, function (observerObj) {
                                    if ((observerObj.topicOem === '*' || observerObj.topicOem === deviceObj.oem) &&
                                        (observerObj.topicModel === '*' || observerObj.topicModel === deviceObj.model) &&
                                        (observerObj.topicVersion === '*' || observerObj.topicVersion === deviceObj.version) &&
                                        (observerObj.topicId === '*' || observerObj.topicId === deviceObj.typeId)) {
                                        return observerObj;
                                    }
                                });
                                if (existingBluePrintOb && existingBluePrintOb.length) {
                                    tempObserversArr.push(existingBluePrintOb[0]);
                                }
                            });
                        }
                        if (tempObserversArr && tempObserversArr.length) {
                            vm.isFindDeviceObservers = true;
                            vm.isObserverDataCreate = false;
                            var batchArr = [];
                            var inputObj = {};
                            angular.forEach(tempObserversArr, function (observerObj, index) {
                                inputObj.method = "POST";
                                inputObj.id = index;
                                inputObj.path = "/observers";
                                inputObj.body = observerObj;
                                batchArr.push(inputObj);
                                inputObj = {};
                            });
                            BatchFactory.executeBatchRequests({body: batchArr, tag: 'observer', appName: 'node'})
                                .then(function () {
                                    amaran.success('Observer created successfully');
                                    vm.isObserversConfigurationDone = true;
                                    vm.isObserverDataCreate = true;
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isObserversConfigurationDone = true;
                                    vm.isObserverDataCreate = true;
                                })
                        } else {
                            vm.isFindDeviceObservers = false;
                            vm.isObserversConfigurationDone = true;
                        }
                    }
                };

                vm.fnBluePrintSelected = function (selectedBluePrintObj) {
                    vm.uniqueSelectedBluePrintObj = selectedBluePrintObj;
                    vm.isBluePrintSelected = true;

                    var existingOb = _.filter(vm.observersArr, function (observerObj) {
                        if ((observerObj.topicOem === '*' || observerObj.topicOem === vm.uniqueSelectedBluePrintObj.oem) &&
                            (observerObj.topicModel === '*' || observerObj.topicModel === vm.uniqueSelectedBluePrintObj.model) &&
                            (observerObj.topicVersion === '*' || observerObj.topicVersion === vm.uniqueSelectedBluePrintObj.version) &&
                            (observerObj.topicName === '*' || observerObj.topicName === vm.uniqueSelectedBluePrintObj.name) &&
                            (observerObj.topicId === '*' || observerObj.topicId === vm.uniqueSelectedBluePrintObj.id)) {
                            return observerObj;
                        }
                    });
                    vm.isObserverFound = !!(existingOb && existingOb.length);
                    if (!vm.isObserverFound) {
                        var existingBluePrintOb = _.filter(vm.observerBlueprints, function (observerObj) {
                            if ((observerObj.topicOem === '*' || observerObj.topicOem === vm.uniqueSelectedBluePrintObj.oem) &&
                                (observerObj.topicModel === '*' || observerObj.topicModel === vm.uniqueSelectedBluePrintObj.model) &&
                                (observerObj.topicVersion === '*' || observerObj.topicVersion === vm.uniqueSelectedBluePrintObj.version) &&
                                (observerObj.topicName === '*' || observerObj.topicName === vm.uniqueSelectedBluePrintObj.name) &&
                                (observerObj.topicId === '*' || observerObj.topicId === vm.uniqueSelectedBluePrintObj.id)) {
                                return observerObj;
                            }
                        });
                        vm.selectedObserverBluePrint = existingBluePrintOb.length ? existingBluePrintOb[0] : {};
                        vm.isObserverFoundFromBluePrint = !!(existingBluePrintOb && existingBluePrintOb.length);
                    } else {
                        vm.selectedObserverBluePrint = {};
                        vm.isObserverFoundFromBluePrint = false;
                        vm.isObserversConfigurationDone = true;
                    }
                    if (vm.isObserverFoundFromBluePrint) {
                        var createObj = {
                            "name": vm.selectedObserverBluePrint.name,
                            "description": vm.selectedObserverBluePrint.description,
                            "state": vm.selectedObserverBluePrint.state,
                            "topicOem": vm.selectedObserverBluePrint.topicOem,
                            "topicModel": vm.selectedObserverBluePrint.topicModel,
                            "topicName": vm.selectedObserverBluePrint.topicName,
                            "topicVersion": vm.selectedObserverBluePrint.topicVersion,
                            "topicId": vm.selectedObserverBluePrint.topicId,
                            "policy": vm.selectedObserverBluePrint.policy,
                            "conditions": vm.selectedObserverBluePrint.conditions
                        };

                        var inputObj = {
                            body: createObj
                        };
                        ObserverFactory.createObserver(inputObj)
                            .then(function () {
                                amaran.success('Observer created successfully');
                                vm.isObserversConfigurationDone = true;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isObserversConfigurationDone = true;
                            });
                    }
                };

                vm.fnTypesFilter = function () {
                    vm.isTypesFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.typesArr, function (typeObj) {
                            if (typeObj.id.includes(vm.search) || typeObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.typesArr);
                    }
                    vm.fnSearchTypeFilter(searchArr);
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnSetDeviceTypeHeight();
                        });
                        vm.isTypesFilter = false;
                    }, 1000)
                };

                vm.fnSearchTypeFilter = function (searchArr) {
                    vm.uniqueBluePrintObj = {};
                    _.map(searchArr, function (item) {
                        if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model]) {
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model] = {
                                typeName: '',
                                typeValue: [],
                                isGatewayDataLoad: false
                            };
                        }
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeName = item.name;
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.push(item);
                        if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj) {
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj = item;
                        }
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.sort(dynamicSort("version"));
                    });
                    _.forEach(vm.uniqueBluePrintObj, function (obj) {
                        obj.selectedTypeVersionObj = obj.typeValue[0]
                    })
                };

                function dynamicSort(property) {
                    var sortOrder = 1;
                    if (property[0] === "-") {
                        sortOrder = -1;
                        property = property.substr(1);
                    }
                    return function (b, a) {
                        /* next line works with strings and numbers,
                         * and you may want to customize it to your needs
                         */
                        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                        return result * sortOrder;
                    }
                }
                /*END: Observers*/

                /*START: Notifications*/
                vm.fnInitCreateNotifications = function () {
                    vm.defaultNotifications[0].isOpen = true;
                };

                vm.fnCreateArrayTag = function (arrValue, id, kvpPair) {
                    if (arrValue) {
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (!re.test(arrValue)) {
                            kvpPair.isInputError = true;
                        } else {
                            var flag = false;
                            angular.forEach(kvpPair.emails, function (obj) {
                                if (obj === arrValue) {
                                    flag = true;
                                }
                            });
                            if (!flag) {
                                kvpPair.emails.push(angular.copy(arrValue));
                                kvpPair.emailValue = "";
                                angular.element('#' + id).blur();
                            } else {
                                amaran.error('Email already present. Please enter a different email.');
                            }
                        }
                    }
                };

                vm.fnRemoveEmailTag = function (notificationObj, index) {
                    notificationObj.emails.splice(index, 1);
                };

                vm.fnGotoNextNotification = function (notificationObj, index) {
                    vm.isNotificationCreating = true;
                    var inputObj = _.cloneDeepWith(notificationConfigObj);
                    inputObj.name = _.cloneDeepWith(notificationObj.name);
                    inputObj.target.beforeHealth = _.cloneDeepWith(notificationObj.beforeHealth);
                    inputObj.target.afterHealth = _.cloneDeepWith(notificationObj.afterHealth);
                    inputObj.dispatch.settings.emails = _.cloneDeepWith(notificationObj.emails);
                    NotificationFactory.createNotification({body: inputObj})
                        .then(function () {
                            vm.isNotificationCreating = false;
                            vm.defaultNotifications[index].isOpen = false;
                            vm.defaultNotifications[index].isDone = true;
                            if (vm.defaultNotifications.length - 1 !== index) {
                                vm.defaultNotifications[index + 1].isOpen = true;
                            } else {
                                vm.fnNextStep();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNotificationCreating = false;
                        });
                };

                vm.fnGetHealthColor = function (health) {
                    return ColorService.getHealthColorForLoop(health);
                };
                /*END: Notifications*/

                /*START: Health*/
                vm.fnInitCreateHealths = function () {
                    vm.isSpinnerShow = true;
                    var batchArr = [];
                    var inputObj = {};
                    var oldHealtsArr = DB.fnGet('healthArray');
                    angular.forEach(defaultHealths, function (healthObj, index) {
                        inputObj.method = "POST";
                        inputObj.id = index;
                        inputObj.path = "/healths";
                        inputObj.body = healthObj;
                        batchArr.push(inputObj);
                        inputObj = {};
                    });
                    BatchFactory.executeBatchRequests({body: batchArr, tag: 'health', appName: 'node'})
                        .then(function (res) {
                            _.forEach(res, function (resObj) {
                                if (resObj.statusCode.toString().startsWith('2')) {
                                    oldHealtsArr.push(defaultHealths[parseInt(resObj.request.id)])
                                }
                            });
                            ColorService.fnSetHealthData(oldHealtsArr);
                            amaran.success('Health created successfully');
                            vm.isSpinnerShow = false;
                            vm.fnNextStep();
                        });
                };
                /*END: Health*/

                /*START: Privileges*/
                vm.fnCheckUserPermission = function (recipeObj) {
                    _.forEach(recipeObj.permissionArr, function (obj) {
                        if (obj.permission !== '') {
                            obj.isAccess = vm.userPermissions[obj.permission] === "TRUE";
                        }
                        if (obj.isAccess === false) {
                            vm.isAllAccess = false;
                        }
                    });
                    if (vm.isAllAccess) {
                        vm.fnGetAllUsers();
                        vm.fnGetTypes();
                    }
                    $timeout(function () {
                        vm.isDetailsLoaded = false;
                    });
                };
                /*END: Privileges*/

                /*START: Extra Data*/
                vm.fnGetDevices = function (inputObj, preDefinedDevices, isCalledForViz) {
                    vm.isDeviceDetailsLoaded = false;
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) { // Success block
                            var devicesArr = isCalledForViz ? preDefinedDevices : [];
                            var tempDeviceObj = {};
                            _.forEach(res.hit, function (hitObj) {
                                tempDeviceObj = {};
                                _.forEach(hitObj.fields, function (value, key) {
                                    var tempNewKey = '';
                                    switch (key) {
                                        case "typeid":
                                            tempNewKey = 'typeId';
                                            break;
                                        case "gatewayid":
                                            tempNewKey = 'gatewayId';
                                            break;
                                        case "clusterids":
                                            tempNewKey = 'clusterIds';
                                            break;
                                        default:
                                            tempNewKey = key;
                                            break
                                    }
                                    if (key !== 'clusterids') {
                                        tempDeviceObj[tempNewKey] = value[0];
                                    } else {
                                        tempDeviceObj[tempNewKey] = value;
                                    }
                                });
                                devicesArr.push(tempDeviceObj);
                            });
                            if (devicesArr.length < res.found) {
                                var inputObjTemp = {
                                    start: inputObj.start + inputObj.size,
                                    size: inputObj.size,
                                    q: ""
                                };
                                vm.fnGetDevices(inputObjTemp, devicesArr, true);
                            } else {
                                vm.devicesArr = _.cloneDeepWith(devicesArr);
                                vm.isDeviceDetailsLoaded = true;
                                vm.fnGetObserverData();
                            }
                        }, function (error) { // Error block
                            vm.devicesArr = [];
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDeviceDetailsLoaded = true;
                        })
                };

                vm.fnGetObserverData = function () {
                    vm.isObserversDetailsLoaded = false;
                    var batchArr = [];
                    var inputObj = {};
                    var observerAPI = [{path: "/blueprints/observers"}, {path: "/observers"}];
                    angular.forEach(observerAPI, function (observerObj, index) {
                        inputObj.method = "GET";
                        inputObj.id = index;
                        inputObj.path = observerObj.path;
                        inputObj.body = {perPage: 0};
                        batchArr.push(inputObj);
                        inputObj = {};
                    });
                    BatchFactory.executeBatchRequests({body: batchArr, tag: 'observer', appName: 'node'})
                        .then(function (res) {
                            _.forEach(res, function (resObj) {
                                if (resObj && resObj.request && resObj.request.path && resObj.request.path === "/observers") {
                                    vm.observersArr = resObj && resObj.body ? resObj.body : [];
                                } else {
                                    vm.observerBlueprints = resObj && resObj.body ? resObj.body : [];
                                }
                            });
                            vm.isObserversDetailsLoaded = true;
                            vm.fnCreateObserverData();
                            $timeout(function () {
                                vm.fnSetDeviceTypeHeight();
                            });
                        }, function (error) {
                            vm.observersArr = [];
                            vm.observerBlueprints = [];
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isObserversDetailsLoaded = true;
                            vm.fnCreateObserverData();
                            $timeout(function () {
                                vm.fnSetDeviceTypeHeight();
                            });
                        })
                };

                vm.fnGetTypes = function () {
                    vm.isTypesDetailsLoaded = false;
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        var typesArr = AppInitService.getInitData('typesArr');
                        var tempArr = _.filter(typesArr, {category: 'DEVICE'});
                        _.forEach(tempArr, function (tempObj) {
                            var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                            tempObj.properties = angular.copy(propertiesObj);
                        });
                        vm.typesArr = tempArr;
                        vm.fnSearchTypeFilter(vm.typesArr);
                        vm.isTypesDetailsLoaded = true;
                    } else {
                        TypeFactory.getTypes({perPage: 0})
                            .then(function (response) {
                                var tempArr = _.filter(response, {category: 'DEVICE'});
                                _.forEach(tempArr, function (tempObj) {
                                    var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                                    tempObj.properties = angular.copy(propertiesObj);
                                });
                                vm.typesArr = tempArr;
                                vm.fnSearchTypeFilter(vm.typesArr);
                                vm.isTypesDetailsLoaded = true;
                            }, function (error) {
                                vm.typesArr = [];
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isTypesDetailsLoaded = true;
                            })
                    }
                };

                vm.fnGetAllUsers = function () {
                    UserFactory.getUsers({perPage: 0})
                        .then(function (res) {
                            vm.accountUsers = _.filter(res, function (resObj) {
                                return resObj.email;
                            });
                        })
                };
                /*END: Extra Data*/

                /*START: Wizard Functions*/
                vm.fnNextStep = function () {
                    WizardHandler.wizard().next();
                    switch (vm.currentStepIndex + 1) {
                        case 1:
                            vm.fnInitCreateHealths();
                            break;
                        case 2:
                            vm.fnInitCreateNotifications();
                            break;
                        case 3:
                            vm.fnInitCreateObservers();
                            break;
                    }
                };

                vm.fnFinishedWizard = function () {
                    $uibModalInstance.close();
                };

                $scope.$on('wizard:stepChanged', function (event, args) {
                    vm.currentStepIndex = args.index;
                });

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                /*END: Wizard Functions*/

                //Initialization
                vm.fnInitSetupModal = function () {
                    vm.isDetailsLoaded = true;
                    vm.userPermissions = DB.fnGet("userPermissions");
                    if (vm.recipeObj && Object.keys(vm.recipeObj).length !== 0) {
                        vm.fnCheckUserPermission(vm.recipeObj);
                    } else {
                        vm.isDetailsLoaded = false;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('accessConfigurationModalCtrl',
            function ($scope, $timeout, $uibModalInstance, amaran, WizardHandler, PermissionsService, AppInitService,
                      DB, recipesService, UserFactory, TypeFactory, ObserverFactory, RoleFactory, GroupFactory,
                      BatchFactory, recipeObj) {
                var vm = this;
                vm.recipeObj = recipeObj;
                vm.isDetailsLoaded = false;
                vm.isAllAccess = true;
                vm.isSetupStart = false;
                vm.isErrorOccurred = false;
                vm.isDefaultRoleLoaded = false;
                vm.isEntityCreating = false;
                vm.currentStepIndex = 0;
                vm.accountUsers = [];
                var defaultRole = {
                    "name": "Default Allow",
                    "description": "Default allow all role",
                    "statements": [
                        {
                            "effect": "ALLOW",
                            "actions": [
                                "*"
                            ]
                        }
                    ]
                };

                vm.defaultRoles = [
                    {
                        "defaultId": 1,
                        "name": "Deny Access",
                        "description": "Deny privilege to access app.",
                        "statements": [
                            {
                                "actions": [
                                    "access:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 2,
                        "name": "Deny Access Users",
                        "description": "Deny access to Access user service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:user:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 3,
                        "name": "Deny Access Users [Create, Modify, Delete]",
                        "description": "Allow Read only access to Access user service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:user:AddGroup",
                                    "access:user:AddRole",
                                    "access:user:Delete",
                                    "access:user:Modify",
                                    "access:user:RemoveRole",
                                    "access:user:RemoveGroup",
                                    "access:user:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 4,
                        "name": "Deny Access Roles",
                        "description": "Deny access to Access roles service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:role:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 5,
                        "name": "Deny Access Roles [Create, Modify, Delete]",
                        "description": "Allow read only access to Access roles service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:role:Modify",
                                    "access:role:Delete",
                                    "access:role:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 6,
                        "name": "Deny Access Groups",
                        "description": "Deny access to Access groups service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:group:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 7,
                        "name": "Deny Access Groups [Create, Modify, Delete]",
                        "description": "Allow read only access to Access groups service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:group:AddRole",
                                    "access:group:Delete",
                                    "access:group:RemoveRole",
                                    "access:group:Modify",
                                    "access:group:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 8,
                        "name": "Deny Access Vaults",
                        "description": "Deny access to Access Vaults service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:vault:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 9,
                        "name": "Deny Access Vaults [Create, Delete]",
                        "description": "Allow read only access to Access Vaults service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:vault:Create",
                                    "access:vault:Delete",
                                    "access:vault:Invoke"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 10,
                        "name": "Deny Access Authenticators",
                        "description": "Deny access to Access Authenticators service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:authenticator:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 11,
                        "name": "Deny Access Authenticators [Create, Modify, Delete]",
                        "description": "Allow read only access to Access Authenticators service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:authenticator:Create",
                                    "access:authenticator:Modify",
                                    "access:authenticator:Delete",
                                    "access:authenticator:AddUser",
                                    "access:authenticator:RemoveUser"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 12,
                        "name": "Deny Access Contacts",
                        "description": "Deny access to Access Contacts service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:contact:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 13,
                        "name": "Deny Access Contacts [Create, Modify, Delete]",
                        "description": "Allow read only access to Access Contacts service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:contact:Create",
                                    "access:contact:Modify",
                                    "access:contact:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 14,
                        "name": "Deny Access Federations",
                        "description": "Deny access to Access Federations service.",
                        "statements": [
                            {
                                "actions": [
                                    "access:federation:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 15,
                        "name": "Deny Pipeline",
                        "description": "Deny privilege to Pipeline app.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 16,
                        "name": "Deny Pipeline Workflows",
                        "description": "Deny access to Pipeline Workflows service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:workflow:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 17,
                        "name": "Deny Pipeline Workflows [Create, Modify, Delete]",
                        "description": "Allow read only access to Pipeline Workflows service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:workflow:Create",
                                    "pipeline:workflow:Modify",
                                    "pipeline:workflow:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 18,
                        "name": "Deny Pipeline Listeners",
                        "description": "Deny access to Pipeline Listeners service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:listener:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 19,
                        "name": "Deny Pipeline Listeners [Create, Modify, Delete]",
                        "description": "Allow read only access to Pipeline Listeners service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:listener:Create",
                                    "pipeline:listener:Modify",
                                    "pipeline:listener:Delete",
                                    "pipeline:listener:RemoveWorkflow",
                                    "pipeline:listener:AddWorkflow"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 20,
                        "name": "Deny Pipeline Templates",
                        "description": "Deny access to Pipeline Templates service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:template:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 21,
                        "name": "Deny Pipeline Templates [Create, Modify, Delete]",
                        "description": "Allow read only access to Pipeline Templates service.",
                        "statements": [
                            {
                                "actions": [
                                    "pipeline:template:Create",
                                    "pipeline:template:Modify",
                                    "pipeline:template:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 22,
                        "name": "Deny Node",
                        "description": "Deny privilege to Node app.",
                        "statements": [
                            {
                                "actions": [
                                    "node:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 23,
                        "name": "Deny Node Devices",
                        "description": "Deny access to Node Devices service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:device:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 24,
                        "name": "Deny Node Devices [Create, Modify, Delete, Enable/Disable Components, Enable/Disable Attributes, Open Tunnels]",
                        "description": "Allow read only access to Node Devices service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:device:Modify",
                                    "node:device:Delete",
                                    "node:device:CreateTunnel",
                                    "node:device:EnableAttribute",
                                    "node:device:DisableAttribute",
                                    "node:device:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 25,
                        "name": "Deny Node Clusters",
                        "description": "Deny access to Node Clusters service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:cluster:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 26,
                        "name": "Deny Node Clusters [Create, Modify, Delete]",
                        "description": "Allow read only access to Node Clusters service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:cluster:Create",
                                    "node:cluster:Delete",
                                    "node:cluster:AddDevice",
                                    "node:cluster:AddGateway",
                                    "node:cluster:RemoveDevice",
                                    "node:cluster:RemoveGateway",
                                    "node:cluster:Modify"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 27,
                        "name": "Deny Node Gateways",
                        "description": "Deny access to Node Gateways service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:gateway:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 28,
                        "name": "Deny Node Gateways [Create, Modify, Delete]",
                        "description": "Allow read only access to Node Gateways service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:gateway:Create",
                                    "node:gateway:Delete",
                                    "node:gateway:Modify"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 29,
                        "name": "Deny Node Observers",
                        "description": "Deny access to Node Observers service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:observer:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 30,
                        "name": "Deny Node Observers [Create, Modify, Delete]",
                        "description": "Allow read only access to Node Observers service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:observer:Delete",
                                    "node:observer:Modify",
                                    "node:observer:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 31,
                        "name": "Deny Node Healths",
                        "description": "Deny access to Node Healths service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:health:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 32,
                        "name": "Deny Node Healths [Create, Modify, Delete]",
                        "description": "Allow read only access to Node Healths service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:health:Create",
                                    "node:health:Modify",
                                    "node:health:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 33,
                        "name": "Deny Node Notifications",
                        "description": "Deny access to Node Notifications service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:notification:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 34,
                        "name": "Deny Node Notifications [Create, Modify, Delete]",
                        "description": "Allow read only access to Node Notifications service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:notification:Create",
                                    "node:notification:Delete",
                                    "node:notification:Modify"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 35,
                        "name": "Deny Node Lifecycles",
                        "description": "Deny access to Node Lifecycles service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:lifecycle:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 36,
                        "name": "Deny Node Lifecycles [Create, Delete]",
                        "description": "Allow read only access to Node Lifecycles service.",
                        "statements": [
                            {
                                "actions": [
                                    "node:lifecycle:Delete",
                                    "node:lifecycle:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 37,
                        "name": "Deny Tracker",
                        "description": "Deny privilege to tracker app.",
                        "statements": [
                            {
                                "actions": [
                                    "tracker:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 38,
                        "name": "Deny Tracker Issues",
                        "description": "Deny access to Tracker Issues service.",
                        "statements": [
                            {
                                "actions": [
                                    "tracker:issue:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 39,
                        "name": "Deny Tracker Issues [Create, Modify, Delete, Add/Modify/Delete Comments, Upload Files, Modify Labels]",
                        "description": "Allow read only access to Tracker Issues service.",
                        "statements": [
                            {
                                "actions": [
                                    "tracker:issue:Create",
                                    "tracker:issue:Modify",
                                    "tracker:issue:ListComment",
                                    "tracker:issue:Delete",
                                    "tracker:issue:ModifyLabel",
                                    "tracker:issue:RemoveComment",
                                    "tracker:issue:ModifyComment",
                                    "tracker:issue:AddComment"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 40,
                        "name": "Deny Tracker Labels",
                        "description": "Deny access to Tracker Labels service.",
                        "statements": [
                            {
                                "actions": [
                                    "tracker:label:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 41,
                        "name": "Deny Tracker Labels [Create, Modify, Delete]",
                        "description": "Allow read only access to Tracker Labels service.",
                        "statements": [
                            {
                                "actions": [
                                    "tracker:label:Modify",
                                    "tracker:label:Create",
                                    "tracker:label:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 42,
                        "name": "Deny Storage",
                        "description": "Deny privilege to Storage app.",
                        "statements": [
                            {
                                "actions": [
                                    "storage:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 43,
                        "name": "Deny Storage Files [Create, Modify, Delete]",
                        "description": "Allow read only access to Storage Files service.",
                        "statements": [
                            {
                                "actions": [
                                    "storage:file:Modify",
                                    "storage:file:Delete",
                                    "storage:file:Download",
                                    "storage:file:Upload"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 44,
                        "name": "Deny Storage Applications Folder",
                        "description": "Deny access to Storage Applications Folder.",
                        "statements": [
                            {
                                "actions": [
                                    "storage:folder:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 45,
                        "name": "Deny AI",
                        "description": "Deny access to AI app.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 46,
                        "name": "Deny AI Trainer",
                        "description": "Deny access to Trainer service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:trainer:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 47,
                        "name": "Deny AI Trainer [Create, Modify, Delete]",
                        "description": "Allow read only access to Trainer service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:trainer:Delete",
                                    "ai:trainer:Create",
                                    "ai:trainer:Stop"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 48,
                        "name": "Deny AI Model",
                        "description": "Deny access to AI Model service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:model:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 49,
                        "name": "Deny AI Model [Create, Modify, Delete]",
                        "description": "Allow read only access to AI Model service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:model:Modify",
                                    "ai:model:Delete",
                                    "ai:model:Create"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 50,
                        "name": "Deny AI Distribution",
                        "description": "Deny access to AI Distribution service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:distribution:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 51,
                        "name": "Deny AI Distribution [Create, Modify, Delete]",
                        "description": "Allow read only access to AI Distribution service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:distribution:Create",
                                    "ai:distribution:Delete",
                                    "ai:distribution:Modify"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 52,
                        "name": "Deny AI Deployment",
                        "description": "Deny access to AI Deployment service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:deployment:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 53,
                        "name": "Deny AI Deployment [Create, Modify, Delete]",
                        "description": "Allow read only access to AI Deployment service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:deployment:Create",
                                    "ai:deployment:Modify",
                                    "ai:deployment:Delete"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 54,
                        "name": "Deny AI Inference",
                        "description": "Deny access to AI Inference service.",
                        "statements": [
                            {
                                "actions": [
                                    "ai:inference:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    },
                    {
                        "defaultId": 55,
                        "name": "Deny Billing",
                        "description": "Deny privilege to Billing app.",
                        "statements": [
                            {
                                "actions": [
                                    "billing:*"
                                ],
                                "effect": "DENY"
                            }
                        ]
                    }
                ];

                vm.defaultGroups = [
                    {
                        name: 'Super Admins',
                        description: 'Group having access to all apps throughout the system.',
                        roles: [0],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Account Managers',
                        description: 'Group having access to all apps except Billing.',
                        roles: [0, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Security Managers',
                        description: 'Group having full privileges to access app.',
                        roles: [0, 15, 22, 37, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Node Manager',
                        description: 'Group having full privileges to node app.',
                        roles: [0, 1, 15, 37, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Node Technicians',
                        description: 'Group having full privileges to devices, clusters, gateways, healths & notifications.',
                        roles: [0, 1, 15, 29, 35, 37, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Node Visitors',
                        description: 'Group that have view only privilege for devices and healths.',
                        roles: [0, 1, 15, 24, 25, 27, 29, 32, 33, 35, 37, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Tracker Technicians',
                        description: 'Group having full privileges to tracker app.',
                        roles: [0, 1, 15, 22, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Tracker Visitors',
                        description: 'Group that have view only privilege for issues and labels.',
                        roles: [0, 1, 15, 22, 39, 41, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Pipeline Manager',
                        description: 'Group having full privileges to pipeline app.',
                        roles: [0, 1, 22, 37, 42, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Storage Manager',
                        description: 'Group having full privileges to storage app.',
                        roles: [0, 1, 15, 22, 37, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Storage Technicians',
                        description: 'Group having full privileges to storage files.',
                        roles: [0, 1, 15, 22, 37, 44, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'Storage Visitors',
                        description: 'Group that have view only privilege for storage files',
                        roles: [0, 1, 15, 22, 37, 43, 44, 45, 55],
                        userValue: "",
                        usersArr: []
                    }, {
                        name: 'AI Data Scientists',
                        description: 'Group having full privileges to AI app.',
                        roles: [0, 1, 15, 22, 37, 42, 55],
                        userValue: "",
                        usersArr: []
                    }];

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClose = function () {
                    $uibModalInstance.close();
                };

                vm.fnCheckUserPermission = function (recipeObj) {
                    _.forEach(recipeObj.permissionArr, function (obj) {
                        if (obj.permission !== '') {
                            obj.isAccess = vm.userPermissions[obj.permission] === "TRUE";
                        }
                        if (obj.isAccess === false) {
                            vm.isAllAccess = false;
                        }
                    });
                    if (vm.isAllAccess) {
                        vm.fnGetAllUsers();
                        vm.fnGetRoles();
                    }
                    $timeout(function () {
                        vm.isDetailsLoaded = false;
                    });
                };

                vm.fnGetAllUsers = function () {
                    UserFactory.getUsers({perPage: 0})
                        .then(function (res) {
                            vm.accountUsers = res;
                        })
                };

                vm.fnCreateDefaultRole = function () {
                    RoleFactory.createRole({body: defaultRole})
                        .then(function (res) {
                            res.defaultId = 0;
                            vm.defaultRoles.unshift(res);
                            vm.isDefaultRoleLoaded = true;
                        }, function () {
                            vm.isDefaultRoleLoaded = true;
                        })
                };

                vm.fnGetRoles = function () {
                    vm.isDefaultRoleLoaded = false;
                    RoleFactory.getRoles({perPage: 0})
                        .then(function (res) { // Success block
                            var index = _.findIndex(res, function (resObj) {
                                return resObj.statements && resObj.statements.length === 1 &&
                                    resObj.statements[0].effect === defaultRole.statements[0].effect && resObj.statements[0].actions &&
                                    resObj.statements[0].actions.length === 1 &&
                                    resObj.statements[0].actions[0] === defaultRole.statements[0].actions[0]
                            });
                            if (index === -1) {
                                vm.fnCreateDefaultRole();
                            } else {
                                res[index].defaultId = 0;
                                vm.defaultRoles.unshift(res[index]);
                                vm.isDefaultRoleLoaded = true;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDefaultRoleLoaded = true;
                        });
                    $timeout(function () {
                        vm.isDefaultRoleLoaded = true;
                    })
                };

                vm.fnCreateRole = function (batchCollectionObj, count, leftGroupsArr) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'role', appName: 'access'})
                        .then(function (res) {
                            _.forEach(res, function (resObj) {
                                if (!resObj.statusCode.toString().startsWith('2')) {
                                    leftGroupsArr.push({
                                        method: resObj.request.method,
                                        id: resObj.request.id,
                                        path: resObj.request.path,
                                        body: resObj.request.body
                                    });
                                } else {
                                    vm.defaultRoles[resObj.request.id].id = resObj.body.id;
                                }
                            });
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnCreateRole(batchCollectionObj, count, leftGroupsArr);
                            } else {
                                if (leftGroupsArr.length) {
                                    vm.fnInitCreateRoles(leftGroupsArr, true);
                                } else {
                                    vm.isEntityCreating = false;
                                    vm.fnNextStep();
                                }
                            }
                        });
                };

                vm.fnInitCreateRoles = function (rolesArr, isCalledForLeftOver) {
                    vm.isEntityCreating = true;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var leftGroupsArr = [];
                    var inputObj = {};

                    angular.forEach(rolesArr, function (roleObj, index) {
                        if (index <= step) {
                            if (isCalledForLeftOver) {
                                batchArr.push(roleObj);
                                batchCollectionObj[count] = batchArr;
                            } else {
                                inputObj.method = "POST";
                                inputObj.id = roleObj.defaultId;
                                inputObj.path = "/roles";
                                inputObj.body = {
                                    name: roleObj.name,
                                    description: roleObj.description,
                                    statements: roleObj.statements
                                };
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            }
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            if (isCalledForLeftOver) {
                                batchArr.push(roleObj);
                                batchCollectionObj[count] = batchArr;
                            } else {
                                inputObj.method = "POST";
                                inputObj.id = roleObj.defaultId;
                                inputObj.path = "/roles";
                                inputObj.body = {
                                    name: roleObj.name,
                                    description: roleObj.description,
                                    statements: roleObj.statements
                                };
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            }
                        }
                    });
                    count = 1;
                    vm.fnCreateRole(batchCollectionObj, count, leftGroupsArr);
                };

                vm.fnInitCreateGroups = function (groupsArr, isCalledForLeftOver) {
                    vm.isEntityCreating = true;
                    var batchArr = [];
                    var leftGroupsArr = [];
                    var inputObj = {};

                    if (isCalledForLeftOver) {
                        batchArr = groupsArr;
                    } else {
                        angular.forEach(groupsArr, function (healthObj, index) {
                            inputObj.method = "POST";
                            inputObj.id = index;
                            inputObj.path = "/groups";
                            inputObj.body = {
                                name: healthObj.name,
                                description: healthObj.description
                            };
                            batchArr.push(inputObj);
                            inputObj = {};
                        });
                    }
                    BatchFactory.executeBatchRequests({body: batchArr, tag: 'group', appName: 'access'})
                        .then(function (res) {
                            _.forEach(res, function (resObj) {
                                if (!resObj.statusCode.toString().startsWith('2')) {
                                    leftGroupsArr.push({
                                        method: resObj.request.method,
                                        id: resObj.request.id,
                                        path: resObj.request.path,
                                        body: resObj.request.body
                                    });
                                } else {
                                    vm.defaultGroups[resObj.request.id].id = resObj.body.id
                                }
                            });
                            if (leftGroupsArr.length) {
                                vm.fnInitCreateGroups(leftGroupsArr, true);
                            } else {

                                amaran.success('Groups created successfully');
                                vm.isEntityCreating = false;
                                vm.fnNextStep();
                            }
                        });
                };

                vm.fnInitBindGroupsToRoles = function (count) {
                    vm.isEntityCreating = true;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.defaultGroups[count].roles, function (roleIndex, index) {
                        inputObj.method = "DELETE";
                        inputObj.id = index;
                        inputObj.path = "/groups/" + vm.defaultGroups[count].id + "/roles/" + vm.defaultRoles[roleIndex].id;
                        batchArr.push(inputObj);
                        inputObj = {};
                    });
                    BatchFactory.executeBatchRequests({body: batchArr, tag: 'group', appName: 'access'})
                        .then(function () {
                            amaran.success('User Added successfully');
                            vm.isEntityCreating = false;
                            vm.fnNextStep();
                        });
                };

                vm.fnCreateArrayTag = function (arrValue, id, kvpPair) {
                    var flag = false;
                    angular.forEach(kvpPair.usersArr, function (obj) {
                        if (obj.id === arrValue.id) {
                            flag = true;
                        }
                    });
                    if (!flag) {
                        kvpPair.usersArr.push(angular.copy(arrValue));
                        kvpPair.userValue = "";
                        angular.element('#' + id).blur();
                    } else {
                        amaran.error('User already present. Please enter a different user.');
                    }
                };

                vm.fnRemoveUserTag = function (groupObj, index) {
                    groupObj.usersArr.splice(index, 1);
                };

                vm.fnAddUser = function (groupsObj) {
                    vm.isEntityCreating = true;
                    var batchArr = [];
                    var inputObj = {};
                    angular.forEach(groupsObj.usersArr, function (userObj, index) {
                        inputObj.method = "PUT";
                        inputObj.id = index;
                        inputObj.path = "/users/" + userObj.id + "/groups/" + groupsObj.id;
                        batchArr.push(inputObj);
                        inputObj = {};
                    });
                    BatchFactory.executeBatchRequests({body: batchArr, tag: 'group', appName: 'access'})
                        .then(function () {
                            vm.isEntityCreating = false;
                        }, function () {
                            vm.isEntityCreating = false;
                        });
                };

                vm.fnNextStep = function () {
                    WizardHandler.wizard().next();
                    switch (vm.currentStepIndex + 1) {
                        case 1:
                            var tempRolesArr = angular.copy(vm.defaultRoles);
                            tempRolesArr.splice(0, 1);
                            vm.fnInitCreateRoles(tempRolesArr);
                            break;
                        case 2:
                            vm.fnInitCreateGroups(vm.defaultGroups);
                            break;
                        case 3:
                            var count = 0;
                            vm.fnInitBindGroupsToRoles(count);
                            break;
                        case 4:
                            // group add user
                            break;
                    }
                };

                $scope.$on('wizard:stepChanged', function (event, args) {
                    vm.currentStepIndex = args.index;
                });

                vm.fnInitSetupModal = function () {
                    vm.isDetailsLoaded = true;
                    vm.userPermissions = DB.fnGet("userPermissions");
                    if (vm.recipeObj && Object.keys(vm.recipeObj).length !== 0) {
                        vm.fnCheckUserPermission(vm.recipeObj);
                    } else {
                        vm.isDetailsLoaded = false;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PrivilegesCtrl',
            function ($scope, $window, $timeout, DB, $sce) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                var loginUser = DB.fnGet("loginUser");
                vm.isAccessAllowed = !!(loginUser.administrator && loginUser.administrator === true);
                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.accessMenu = [
                    {
                        "name": "Dashboard",
                        "state": "main.access_dashboard",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        "name": "User",
                        "state": "main.users",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        "name": "Team",
                        "state": "main.userGroups",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        "name": "Security Role",
                        "state": "main.securityRoles",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/security-role.svg#security_role_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        "name": "Security Group",
                        "state": "main.securityGroups",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/securityGroup.svg#securtiy_group\"></use> \n" +
                            "</svg>"
                    },
                    {
                        "name": "Vault",
                        "state": "main.vaults",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                            "</svg>"
                    },
                    {
                        "name": "Authenticator",
                        "state": "main.authenticators",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                            "</svg>"
                    },
                    {
                        "name": "Email",
                        "state": "main.emails",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                            "</svg>"
                    },
                    {
                        "name": "Federation",
                        "state": "main.federations",
                        "isAcess": true,
                        "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                            "</svg>"
                    }];

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element("#aboutMyAccountContent .content-footer")[0]) ? angular.element("#aboutMyAccountContent .content-footer")[0].offsetHeight : 0; // .offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitPrivileges = function () {
                    var data = DB.fnGet('menu');
                    vm.privilegesArr = _.cloneDeepWith(data);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PasswordCtrl',
            function ($scope, $window, $timeout, amaran, DB, SessionFactory, UserFactory, WizardHandler) {
                var vm = this;

                var loginUser = DB.fnGet("loginUser");

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.oldPassword = '';
                vm.newPassword = '';
                vm.oldPassword = '';
                vm.confirmPassword = '';
                vm.inputType = 'password';
                vm.inputTypeConfirm = 'password';
                vm.inputTypeOld = 'password';

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element("#passwordContent .content-footer")[0]) ? angular.element("#passwordContent .content-footer")[0].offsetHeight : 0; // .offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAuthFields = function () {
                    vm.isAuthFieldsLoading = true;
                    vm.isAuthFieldsLoading = false;
                };

                vm.fnChangePassword = function () {
                    vm.isPasswordChanging = true;
                    var userInputObj = {
                        userId: loginUser.id,
                        body: {
                            password: vm.newPassword
                        }
                    };
                    UserFactory.updateUserPassword(userInputObj)
                        .then(function () {
                            amaran.success("Password updated successfully");
                            vm.newPassword = '';
                            vm.confirmPassword = '';
                            vm.oldPassword = '';
                            vm.isPasswordChanging = false;
                            WizardHandler.wizard().goTo(0);
                        }, function (error) {
                            amaran.error(error.errorMessage);
                            vm.newPassword = '';
                            vm.confirmPassword = '';
                            vm.oldPassword = '';
                            vm.isPasswordChanging = false;
                            WizardHandler.wizard().goTo(0);
                        })
                };

                vm.hideShowPassword = function () {
                    if (vm.inputType === 'password') {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                };

                vm.hideShowPasswordConfirm = function () {
                    if (vm.inputTypeConfirm === 'password') {
                        vm.inputTypeConfirm = 'text';
                    } else {
                        vm.inputTypeConfirm = 'password';
                    }
                };

                vm.hideShowOldPassword = function () {
                    if (vm.inputTypeOld === 'password') {
                        vm.inputTypeOld = 'text';
                    } else {
                        vm.inputTypeOld = 'password';
                    }
                };

                vm.fnInitPassword = function () {
                    vm.user = angular.copy(loginUser);
                    vm.user.accountId = vm.user.id.split("-")[0].trim();
                    if (Object.keys(HOST_URL).length) { //eslint-disable-line
                        var url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                        vm.stage = '';
                        if (url.startsWith('dev')) {
                            vm.stage = '.notification-predictivetech.io';
                        } else {
                            vm.stage = '.predictivetech.io'
                        }
                    } else {
                        vm.stage = '.predictivetech.io';
                    }
                    vm.user.inboundEmail = "<?>@" + vm.user.accountId + vm.stage;
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('MultiFactorAuthenticationCtrl',
            function ($scope, $window, $timeout, DB, amaran, jsSHA, UserFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element("#multiFactorAuthenticationContent .content-footer")[0]) ? angular.element("#multiFactorAuthenticationContent .content-footer")[0].offsetHeight : 0; // .offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                function dec2hex(s) {
                    return (s < 15.5 ? '0' : '') + Math.round(s).toString(16);
                }

                function base32tohex(base32) {
                    var base32chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
                    var bits = "";
                    var hex = "";
                    var i = 0;
                    for (i = 0; i < base32.length; i++) {
                        var val = base32chars.indexOf(base32.charAt(i).toUpperCase());
                        bits += leftpad(val.toString(2), 5, '0');
                    }

                    for (i = 0; i + 4 <= bits.length; i += 4) {
                        var chunk = bits.substr(i, 4);
                        hex = hex + parseInt(chunk, 2).toString(16);
                    }
                    return hex;
                }

                function leftpad(str, len, pad) {
                    if (len + 1 >= str.length) {
                        str = Array(len + 1 - str.length).join(pad) + str;
                    }
                    return str;
                }

                function updateOtp(secretKey) {
                    var key = base32tohex(secretKey);
                    var epoch = Math.round(new Date().getTime() / 1000.0);
                    var time = leftpad(dec2hex(Math.floor(epoch / 30)), 16, '0');
                    // updated for jsSHA v2.0.0 - http://caligatio.github.io/jsSHA/
                    var shaObj = new jsSHA("SHA-1", "HEX");
                    shaObj.setHMACKey(key, "HEX");
                    shaObj.update(time);
                    vm.img = 'https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=200x200&chld=M|0&cht=qr&chl=otpauth://totp/' + vm.userEmail + '%3Fsecret%3D' + secretKey;
                }

                function stringGen(len) {
                    var text = "";
                    var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
                    for (var i = 0; i < len; i++) {
                        text += charset.charAt(Math.floor(Math.random() * charset.length));
                    }
                    return text;
                }

                vm.fnGenerateMFAKey = function () {
                    vm.secretKey = stringGen(16);
                    updateOtp(vm.secretKey);
                };

                vm.fnAuthenticationSwitchToggle = function (tempSwitchValue) {
                    vm.isAuthenticationChanging = true;
                    if (tempSwitchValue === true) {
                        var input = {
                            secret: vm.secretKey
                        };
                        UserFactory.enableMFA(input).then(function () {
                            vm.isAuthenticationChanging = false;
                            var loginUser = DB.fnGet('loginUser');
                            loginUser.mfa = true;
                            DB.fnSet('loginUser', loginUser);
                            amaran.success("Multi Factor Authentication enable successfully");
                            vm.tempSwitchValue = true;
                            vm.secretKey = "";
                        }, function () {
                            vm.isAuthenticationChanging = false;
                        });
                    } else {
                        UserFactory.disableMFA().then(function () {
                            vm.isAuthenticationChanging = false;
                            vm.secretKey = "";
                            var loginUser = DB.fnGet('loginUser');
                            loginUser.mfa = false;
                            DB.fnSet('loginUser', loginUser);
                            amaran.success("Multi Factor Authentication disable successfully");
                            vm.tempSwitchValue = false;
                        }, function () {
                            vm.isAuthenticationChanging = false;
                        });
                    }
                };

                vm.fnInitMultiFactorAuthentication = function () {
                    var loginUser = DB.fnGet('loginUser');
                    vm.userEmail = loginUser.email ? loginUser.email : '';
                    vm.tempSwitchValue = angular.isDefined(loginUser.mfa) && loginUser.mfa === true;
                    vm.secretKey = "";
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi')
        .controller('APIKeysCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, XLSX, amaran, swal,
                      microSpinner, DB, LastPageService, PaginationService, BatchFactory, UserFactory,
                      ApiKeyFactory, postActionModelIcon, postActionModelMessage, FedSudoUserService,
                      jsonToCsvConvertService, PermissionsService) {
                var vm = this;

                //Search Variables
                vm.isRefreshData = true;
                vm.isInit = true;
                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'INACTIVE', displayName: 'INACTIVE'}
                ];
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "State",
                        name: "state",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.stateFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'state', displayName: 'State'}
                ];
                vm.filterQuery = "";

                //Access Token Variables
                vm.isAccessTokenLoading = false;
                vm.accessTokenArr = [];
                vm.selectedAccessTokenArr = [];
                vm.selectedAccessTokenObj = {};
                vm.isReload = false;
                vm.isTokenCreating = false;
                vm.isTokenDetailsChanging = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                vm.perPage = loginUser.data ? (loginUser.data.perPage ? parseInt(loginUser.data.perPage[0]) : 20) : 20;
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAccessTokenLoading = true;
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetAccessTokens();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterAccessTokenArr = [];
                    var accessTokenArr = [];
                    if (vm.accessTokenResponse.length) {
                        if (vm.filterQuery) {
                            filterAccessTokenArr = _.filter(vm.accessTokenResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterAccessTokenArr = _.cloneDeepWith(vm.accessTokenResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            accessTokenArr = _.orderBy(filterAccessTokenArr, [sortValue], [sortType]);
                        } else {
                            accessTokenArr = _.cloneDeepWith(filterAccessTokenArr);
                        }
                    }
                    vm.totalItems = accessTokenArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.accessTokenArr = accessTokenArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.access_token') {
                        $timeout(function () {
                            $state.go('main.access_token', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isAccessTokenLoading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var totalContentContainer = angular.element(".content-container")[0].offsetHeight;
                        var tabContentHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element("#apiKeysContent .content-footer")[0]) ? angular.element("#apiKeysContent .content-footer")[0].offsetHeight : 0; // .offsetHeight;
                        var contentContainerFinalHeight = totalContentContainer - (tabContentHeader + footer);
                        angular.element(".tabContent").css('height', contentContainerFinalHeight + 'px');
                    }
                    if (angular.isDefined(angular.element(".content-container")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var tabFooter = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + tabHeader + tabFooter + 60);
                        angular.element("#apiKeys").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-container")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var tabFooter = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + tabHeader + searchTag + tabFooter + 40);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (tokenObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.accessTokenArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === tokenObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected vault array*/
                    var isValueFind = _.find(vm.selectedAccessTokenArr, {'id': tokenObj.id});
                    if (!isValueFind) {
                        vm.selectedAccessTokenArr.push(tokenObj)
                    } else {
                        _.remove(vm.selectedAccessTokenArr, function (obj) {
                            return tokenObj.id === obj.id;
                        });
                    }

                    if (vm.selectedAccessTokenArr.length === 1) {
                        vm.selectedAccessTokenObj = vm.selectedAccessTokenArr[0];
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.accessTokenArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAccessTokenArr = angular.copy(vm.accessTokenArr);
                    } else {
                        vm.selectedAccessTokenArr = [];
                    }
                    if (vm.accessTokenArr.length === 1) {
                        vm.selectedAccessTokenObj = vm.accessTokenArr[0];
                    }

                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAccessTokenCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.accessTokenArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var vaultsArrCp = _.cloneDeepWith(vm.accessTokenArr);
                    var tempData = _.map(vaultsArrCp, function (tempObj) {
                        // delete tempObj.content;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "AccessToken");
                    XLSX.writeFile(wb, "access_token.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            vm.fnUpdateUserData(perPage);
                        } else {
                            FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAccessTokenLoading = true;
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetAccessTokens();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetAccessToken = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedAccessTokenArr = [tokenObj]; // Assign array with single token object
                    vm.selectedAccessTokenObj = tokenObj;
                };

                vm.fnGetAccessTokens = function (inputObj) {
                    if (vm.permissionObj.LIST_API_KEYS) {
                        ApiKeyFactory.listApiKeys(inputObj)
                            .then(function (res) { // Success block
                                vm.accessTokenResponse = _.cloneDeepWith(res);
                                vm.fnGetFilterData();
                                if ($state.current.name === 'main.access_token') {
                                    $state.go('main.access_token', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isAccessTokenLoading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isAccessTokenLoading = false;
                                vm.isRefresh = false;
                            })
                    } else {
                        vm.accessTokenResponse = [];
                        vm.fnGetFilterData();
                        vm.isAccessTokenLoading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnDeleteMultipleTokens = function (selectedAccessTokenArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedAccessTokenArr, function (selectedToken, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/api-keys/" + selectedToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/api-keys/" + selectedToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected access tokens?",
                            text: "You are about to permanently delete the selected access tokens.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccessTokenArr, function (selectedToken) {
                                    angular.forEach(vm.accessTokenArr, function (tokenObj, index) {
                                        if (selectedToken.id === tokenObj.id) {
                                            vm.accessTokenArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccessTokenArr.length;
                                vm.selectedAccessTokenObj = null;
                                vm.selectedAccessTokenArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccessTokenArr, function (selectedToken) {
                                    angular.forEach(vm.accessTokenArr, function (tokenObj, index) {
                                        if (selectedToken.id === tokenObj.id) {
                                            vm.accessTokenArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccessTokenArr.length;
                                vm.selectedAccessTokenObj = null;
                                vm.selectedAccessTokenArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnChangeStateOfToken = function (tokenObj) {
                    vm.isTokenDetailsChanging = true;
                    var inputObj = {
                        apikeyId: tokenObj.id,
                        body: {
                            "state": tokenObj.state === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
                        }
                    };
                    ApiKeyFactory.updateApiKeyState(inputObj)
                        .then(function (response) {
                            angular.forEach(vm.accessTokenArr, function (token) {
                                if (token.id === vm.selectedAccessTokenObj.id) {
                                    vm.selectedAccessTokenObj.state = response.state;
                                    token.state = response.state;
                                    vm.isTokenDetailsChanging = false;
                                    if (inputObj.body.state === 'ACTIVE') {
                                        amaran.success("State activated successfully")
                                    } else {
                                        amaran.success("State deactivated successfully")
                                    }
                                }
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTokenDetailsChanging = false;
                        })
                };

                vm.fnDownloadToken = function (tokenObj) {
                    vm.isTokenDetailsChanging = true;
                    var inputObj = {
                        apikeyId: tokenObj.id
                    };
                    ApiKeyFactory.describeApiKey(inputObj)
                        .then(function (response) {
                            var textFile = null,
                                makeTextFile = function (text) {
                                    var data = new Blob([text], {type: 'text/plain'});

                                    // If we are replacing a previously generated file we need to
                                    // manually revoke the object URL to avoid memory leaks.
                                    if (textFile !== null) {
                                        $window.URL.revokeObjectURL(textFile);
                                    }

                                    textFile = $window.URL.createObjectURL(data);

                                    return textFile;
                                };

                            var str = '';
                            str += 'Id : ' + response.id + ' \n';
                            str += 'Private Key : ' + response.privateKey + " \n";
                            str += 'State : ' + response.state + " \n";

                            var link = document.createElement('a');
                            link.href = makeTextFile(str);
                            link.download = "API_keys.txt";
                            link.click();
                            vm.isTokenDetailsChanging = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTokenDetailsChanging = false;
                        })
                }

                vm.fnCreateNewToken = function () {
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isTokenCreating = true;
                    ApiKeyFactory.createNewApiKey()
                        .then(function (resObj) {
                            vm.totalItems = vm.totalItems + 1;
                            vm.accessTokenArr.push(resObj);
                            vm.isTokenCreating = false;
                            vm.fnDownloadPrivateKey(resObj);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTokenCreating = false;
                        });
                };

                vm.fnDownloadPrivateKey = function (key) {
                    swal({
                            title: "Do you want to download the access-token?",
                            text: "You can download the access-token only once.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "download",
                            closeOnConfirm: true,
                            showLoaderOnConfirm: false
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var textFile = null,
                                    makeTextFile = function (text) {
                                        var data = new Blob([text], {type: 'text/plain'});

                                        // If we are replacing a previously generated file we need to
                                        // manually revoke the object URL to avoid memory leaks.
                                        if (textFile !== null) {
                                            $window.URL.revokeObjectURL(textFile);
                                        }

                                        textFile = $window.URL.createObjectURL(data);

                                        return textFile;
                                    };

                                var str = '';
                                str += 'Id : ' + key.id + ' \n';
                                str += 'Private Key : ' + key.privateKey + " \n";
                                str += 'State : ' + key.state + " \n";

                                var link = document.createElement('a');
                                link.href = makeTextFile(str);
                                link.download = "API_keys.txt";
                                link.click();
                            } else {
                                swal.close();
                            }
                        });
                };

                vm.fnInitAccessToken = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('access');
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AboutMyAccountCtrl',
            function ($scope, $window, $timeout, amaran, DB, copyService) {
                var vm = this;

                var loginUser = DB.fnGet("loginUser");

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element("#aboutMyAccountContent .content-footer")[0]) ?  angular.element("#aboutMyAccountContent .content-footer")[0].offsetHeight: 0; // .offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCopyInputText = function (data, type) {
                    if(type === 'Email') {
                        data = '@' + data.split("<?>@")[1];
                    }
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnInitAboutMyAccount = function () {
                    vm.user = angular.copy(loginUser);
                    vm.user.accountId = vm.user.id.split("-")[0].trim();
                    if(Object.keys(HOST_URL).length) { //eslint-disable-line
                        var url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                        vm.stage = '';
                        if (url.startsWith('dev')) {
                            vm.stage = '.dev-email.ecsmon.ecsiteapp.com';
                        } else {
                            vm.stage = '.www.ecsmon.ecsiteapp.com'
                        }
                    } else {
                        vm.stage = '.www.ecsmon.ecsiteapp.com';
                    }
                    vm.user.inboundEmail = "<?>@" + vm.user.accountId + vm.stage;
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AboutMeCtrl',
            function ($scope, $window, $timeout, amaran, DB, PermissionsService, UserProfileService, UserFactory) {
                var vm = this;

                var loginUser = DB.fnGet("loginUser");

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.isUserDetailsChanging = false;
                vm.isDetailsEditable = false;

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnResetValues = function () {
                    vm.isDetailsEditable = false;
                    vm.user = angular.copy(vm.resetUserObj)
                };

                vm.fnUpdateUserDetails = function (userObj) {
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    vm.isUserDetailsChanging = true;

                    if (angular.isUndefined(userObj.bio)) {
                        userObj.bio = '';
                    }

                    inputObj.body = {
                        firstName: userObj.firstName,
                        lastName: userObj.lastName,
                        bio: userObj.bio
                    };
                    UserFactory.updateUser(inputObj)
                        .then(function (response) {
                            loginUser.firstName = response.firstName;
                            loginUser.lastName = response.lastName;
                            if (response.bio) {
                                loginUser.bio = response.bio;
                            }
                            DB.fnSet("loginUser", loginUser);
                            vm.isUserDetailsChanging = false;
                            vm.isDetailsEditable = false;
                            amaran.success("User details updated successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUserDetailsChanging = false;
                            vm.isDetailsEditable = false;
                        })
                };

                vm.fnInitAboutMe = function () {
                    vm.user = angular.copy(loginUser);
                    vm.user.accountId = vm.user.id.split("-")[0].trim();
                    vm.resetUserObj = _.cloneDeepWith(vm.user);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ColorThemeCtrl',
            function ($scope, $window, $timeout, $base64, DB, UserProfileService, UserFactory, $uibModal) {
                var vm = this;

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };
                vm.isFullWidthDevice = false;
                vm.isThemePreviewChanged = false;
                vm.isBgSelected = true;
                vm.isThemeSelected = false;
                vm.isPrimarySelected = false;
                vm.isTextColorSelected = false;
                vm.isSecondaryTextColorSelected = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.isUserDataSet = true;
                vm.themeColors = [
                    {
                        bgColor: "#ffffff",
                        bgLightColor: '#f2f2f2',
                        bgDarkColor: '#e6e6e6',
                        primaryColor: '#6CCCCC',
                        primaryDarkColor: "#46bfbf",
                        primaryLightColor: '#b8e6e6',
                        textColor: '#191919',
                        textSecondaryColor: '#4d4d4d',
                        name: 'Default Light'
                    },
                    {
                        bgColor: "#2b2c30",
                        bgLightColor: '#43454b',
                        bgDarkColor: '#131315',
                        primaryColor: '#6CCCCC',
                        primaryDarkColor: "#46bfbf",
                        primaryLightColor: '#b8e6e6',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Default Dark'
                    },
                    {
                        bgColor: "#2D4473",
                        bgDarkColor: '#082f82',
                        bgLightColor: '#3665c7',
                        primaryColor: '#F2C438',
                        primaryDarkColor: "#f7be11",
                        primaryLightColor: '#e3cc86',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 1'
                    },
                    {
                        bgColor: "#152625",
                        bgDarkColor: '#155956',
                        bgLightColor: '#487573',
                        primaryColor: '#BF495E',
                        primaryDarkColor: "#fa2f54",
                        primaryLightColor: '#eb788d',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 2'
                    },
                    {
                        bgColor: "#161a1c",
                        bgDarkColor: '#2a2b2b',
                        bgLightColor: '#363b3d',
                        primaryColor: '#2976A6',
                        primaryDarkColor: "#0d4f78",
                        primaryLightColor: '#50a4d9',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 3'
                    },
                    {
                        bgColor: "#2b2b2b",
                        bgDarkColor: '#131315',
                        bgLightColor: '#43454b',
                        primaryColor: '#bf5b04',
                        primaryDarkColor: "#eb6e02",
                        primaryLightColor: '#e39049',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 4'
                    },
                    {
                        bgColor: "#142126",
                        bgDarkColor: '#122e38',
                        bgLightColor: '#255769',
                        primaryColor: '#21afbf',
                        primaryDarkColor: "#066570",
                        primaryLightColor: '#45b7c4',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 5'
                    },
                    {
                        bgColor: "#2b2b2b",
                        bgDarkColor: '#131315',
                        bgLightColor: '#43454b',
                        primaryColor: '#c97855',
                        primaryDarkColor: "#a65735",
                        primaryLightColor: '#db9070',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 6'
                    },
                    {
                        bgColor: "#161a1c",
                        bgDarkColor: '#2a2b2b',
                        bgLightColor: '#363b3d',
                        primaryColor: '#7F7EFF',
                        primaryDarkColor: "#403fb5",
                        primaryLightColor: '#8988e3',
                        textColor: '#ffffff',
                        textSecondaryColor: '#dedfe2',
                        name: 'Theme 7'
                    }];
                vm.isAutoThemeAdjustment = UserProfileService.fnGetSystemProfileObj('autoThemeAdjustment');

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                vm.fnApplyTheme = function (bgColor, primaryColor, textColor, secondaryTextColor) {
                    vm.isUserDataSet = false;
                    var responseTheme = {
                        "bgPrimaryColor": bgColor,
                        "brandPrimary": primaryColor,
                        "textPrimaryColor": textColor,
                        "textSecondaryColor": secondaryTextColor,
                        "previewBgColor": bgColor,
                        "previewPrimaryColor": primaryColor,
                        "previewTextPrimaryColor": textColor,
                        "previewTextSecondaryColor": secondaryTextColor
                    };

                    var userProfileData = DB.fnGet('userProfile');
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.appliedTheme = responseTheme;
                    } else {
                        userProfileData.pre.home.all = {
                            appliedTheme: responseTheme
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };
                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            DB.fnSet('appliedTheme', responseTheme);
                            less.modifyVars(responseTheme); // eslint-disable-line
                            vm.isUserDataSet = true;
                            vm.resetBgColor = angular.copy(bgColor);
                            vm.resetPrimaryColor = angular.copy(primaryColor);
                            vm.resetTextColor = angular.copy(vm.textColor);
                            vm.resetSecondaryTextColor = angular.copy(vm.secondaryTextColor);
                            $scope.$emit('ThemeSettingsChanged');
                        }, function () {
                            vm.isUserDataSet = true;
                        });
                };

                vm.fnResetTheme = function () {
                    vm.isUserDataSet = false;
                    var responseTheme = {
                        "bgPrimaryColor": "#ffffff",
                        "brandPrimary": "#6CCCCC",
                        "previewBgColor": "#ffffff",
                        "previewPrimaryColor": "#6CCCCC"
                    };

                    var userProfileData = DB.fnGet('userProfile');
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.appliedTheme = {};
                    } else {
                        userProfileData.pre.home.all = {
                            appliedTheme: {}
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };
                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            DB.fnRemove('appliedTheme');
                            vm.bgColor = "#fff";
                            vm.primaryColor = "#6CCCCC";
                            vm.textColor = "#191919";
                            vm.secondaryTextColor = "#4d4d4d";
                            less.modifyVars(responseTheme); // eslint-disable-line
                            vm.resetBgColor = angular.copy(vm.bgColor);
                            vm.resetPrimaryColor = angular.copy(vm.primaryColor);
                            vm.resetTextColor = angular.copy(vm.textColor);
                            vm.resetSecondaryTextColor = angular.copy(vm.secondaryTextColor);
                            vm.isUserDataSet = true;
                            $scope.$emit('ThemeSettingsChanged');
                        }, function () {
                            vm.isUserDataSet = true;
                        });
                };

                vm.fnChangeThemeColor = function (theme) {
                    vm.isThemeSelected = true;
                    vm.updatedTheme = _.cloneDeepWith(theme);

                    var previewResponse = {};
                    if (DB.fnGet('appliedTheme')) {
                        var responseTheme = DB.fnGet('appliedTheme');
                        previewResponse = {
                            "bgPrimaryColor": responseTheme.bgPrimaryColor,
                            "brandPrimary": responseTheme.brandPrimary,
                            "textPrimaryColor": responseTheme.textPrimaryColor,
                            "textSecondaryColor": responseTheme.textSecondaryColor,
                            "previewBgColor": vm.updatedTheme.bgColor,
                            "previewPrimaryColor": vm.updatedTheme.primaryColor,
                            "previewTextPrimaryColor": vm.updatedTheme.textColor,
                            "previewTextSecondaryColor": vm.updatedTheme.textSecondaryColor
                        };
                    } else {
                        previewResponse = {
                            "bgPrimaryColor": "#fff",
                            "brandPrimary": "#6CCCCC",
                            "previewBgColor": vm.updatedTheme.bgColor,
                            "previewPrimaryColor": vm.updatedTheme.primaryColor,
                            "previewTextPrimaryColor": vm.updatedTheme.textColor,
                            "previewTextSecondaryColor": vm.updatedTheme.textSecondaryColor
                        };
                    }

                    less.modifyVars(previewResponse); // eslint-disable-line
                    vm.bgColor = vm.updatedTheme.bgColor;
                    vm.primaryColor = vm.updatedTheme.primaryColor;
                    vm.textColor = vm.updatedTheme.textColor;
                    vm.secondaryTextColor = vm.updatedTheme.textSecondaryColor;
                };

                vm.fnPreviewBackground = function (bgColor) {
                    if (vm.isThemeSelected) {
                        vm.updatedTheme.bgColor = bgColor;
                    }
                    if (/^#[0-9A-F]{6}$/i.test(bgColor)) {
                        var previewResponse = {
                            "bgPrimaryColor": vm.resetBgColor,
                            "brandPrimary": vm.resetPrimaryColor,
                            "textPrimaryColor": vm.resetTextColor,
                            "textSecondaryColor": vm.resetSecondaryTextColor,
                            "previewBgColor": bgColor,
                            "previewPrimaryColor": vm.isThemeSelected ? vm.updatedTheme.primaryColor : vm.primaryColor
                        };
                        less.modifyVars(previewResponse); // eslint-disable-line
                        vm.textColor = rgb2hex(angular.element('.previewTextCol').css('background-color'));
                        vm.secondaryTextColor = rgb2hex(angular.element('.previewSecondaryTextCol').css('background-color'));
                    }
                };

                vm.fnPreviewPrimary = function (primaryColor) {
                    if (vm.isThemeSelected) {
                        vm.updatedTheme.primaryColor = primaryColor;
                    }
                    if (/^#[0-9A-F]{6}$/i.test(primaryColor)) {
                        var previewResponse = {
                            "bgPrimaryColor": vm.resetBgColor,
                            "brandPrimary": vm.resetPrimaryColor,
                            "textPrimaryColor": vm.resetTextColor,
                            "textSecondaryColor": vm.resetSecondaryTextColor,
                            "previewBgColor": vm.isThemeSelected ? vm.updatedTheme.bgColor : vm.bgColor,
                            "previewPrimaryColor": primaryColor
                        };
                        less.modifyVars(previewResponse); // eslint-disable-line
                        vm.textColor = rgb2hex(angular.element('.previewTextCol').css('background-color'));
                        vm.secondaryTextColor = rgb2hex(angular.element('.previewSecondaryTextCol').css('background-color'));
                    }
                };

                vm.fnPreviewTextColor = function (textColor) {
                    if (vm.isThemeSelected) {
                        vm.updatedTheme.textColor = textColor;
                    }
                    if (/^#[0-9A-F]{6}$/i.test(textColor)) {
                        var previewResponse = {
                            "bgPrimaryColor": vm.resetBgColor,
                            "brandPrimary": vm.resetPrimaryColor,
                            "textPrimaryColor": vm.resetTextColor,
                            "textSecondaryColor": vm.resetSecondaryTextColor,
                            "previewBgColor": vm.isThemeSelected ? vm.updatedTheme.bgColor : vm.bgColor,
                            "previewPrimaryColor": vm.isThemeSelected ? vm.updatedTheme.primaryColor : vm.primaryColor,
                            "previewTextPrimaryColor": textColor,
                            "previewTextSecondaryColor": vm.secondaryTextColor
                        };
                        less.modifyVars(previewResponse); // eslint-disable-line
                    }
                };

                vm.fnPreviewSecondaryTextColor = function (secondaryTextColor) {
                    if (vm.isThemeSelected) {
                        vm.updatedTheme.textSecondaryColor = secondaryTextColor;
                    }
                    if (/^#[0-9A-F]{6}$/i.test(secondaryTextColor)) {
                        var previewResponse = {
                            "bgPrimaryColor": vm.resetBgColor,
                            "brandPrimary": vm.resetPrimaryColor,
                            "textPrimaryColor": vm.resetTextColor,
                            "textSecondaryColor": vm.resetSecondaryTextColor,
                            "previewBgColor": vm.isThemeSelected ? vm.updatedTheme.bgColor : vm.bgColor,
                            "previewPrimaryColor": vm.isThemeSelected ? vm.updatedTheme.primaryColor : vm.primaryColor,
                            "previewTextPrimaryColor": vm.textColor,
                            "previewTextSecondaryColor": secondaryTextColor
                        };
                        less.modifyVars(previewResponse); // eslint-disable-line
                    }
                };

                vm.fnOpenColorModal = function (type) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/user-settings/preferences/preferencesTab/colorTheme/modal/colorpicker.html',
                        size: 'md',
                        controller: 'colorPickerModalCtrl as colorPickerModal',
                        resolve: {
                            selectedColor: function () {
                                if (type === 'bgColorModal') {
                                    return _.cloneDeepWith(vm.bgColor);
                                } else if (type === 'primaryColorModal') {
                                    return _.cloneDeepWith(vm.primaryColor);
                                } else if (type === 'textPrimaryColor') {
                                    return _.cloneDeepWith(vm.textColor);
                                } else {
                                    return _.cloneDeepWith(vm.secondaryTextColor);
                                }
                            }
                        }
                    });
                    modalInstance.result.then(function (color) {
                        if (type === 'bgColorModal') {
                            vm.bgColor = color;
                            vm.fnPreviewBackground(color);
                        } else if (type === 'primaryColorModal') {
                            vm.primaryColor = color;
                            vm.fnPreviewPrimary(color);
                        } else if (type === 'textPrimaryColor') {
                            vm.textColor = color;
                            vm.fnPreviewTextColor(color);
                        } else {
                            vm.secondaryTextColor = color;
                            vm.fnPreviewSecondaryTextColor(color);
                        }
                    }, function () {
                    });
                };

                function rgb2hex(color) {
                    if (color.substr(0, 1) === '#') {
                        return color;
                    }
                    var digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);
                    var red = parseInt(digits[2]);
                    var green = parseInt(digits[3]);
                    var blue = parseInt(digits[4]);

                    var rgb = blue | (green << 8) | (red << 16);
                    return digits[1] + '#' + rgb.toString(16);
                }

                vm.fnSetAutoThemeAdjustment = function () {
                    vm.isUserDataSet = false;
                    var userProfileData = DB.fnGet('userProfile');
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.autoThemeAdjustment = vm.isAutoThemeAdjustment;
                    } else {
                        userProfileData.pre.home.all = {
                            autoThemeAdjustment: vm.isAutoThemeAdjustment
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };
                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            vm.isUserDataSet = true;
                            $scope.$emit('ThemeSettingsChanged');
                        }, function () {
                            vm.isUserDataSet = true;
                            $scope.$emit('ThemeSettingsChanged');
                        });
                };

                vm.fnInitColorTheme = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    if (DB.fnGet('appliedTheme')) {
                        var responseTheme = DB.fnGet('appliedTheme');
                        vm.bgColor = responseTheme.bgPrimaryColor;
                        vm.primaryColor = responseTheme.brandPrimary;
                        vm.textColor = responseTheme.textPrimaryColor;
                        vm.secondaryTextColor = responseTheme.textSecondaryColor;
                    } else {
                        vm.bgColor = "#ffffff";
                        vm.primaryColor = "#6CCCCC";
                        vm.textColor = "#191919";
                        vm.secondaryTextColor = "#4d4d4d";
                    }
                    vm.resetBgColor = _.cloneDeepWith(vm.bgColor);
                    vm.resetPrimaryColor = _.cloneDeepWith(vm.primaryColor);
                    vm.resetTextColor = _.cloneDeepWith(vm.textColor);
                    vm.resetSecondaryTextColor = _.cloneDeepWith(vm.secondaryTextColor);
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LandingPageCtrl',
            function ($scope, $window, $timeout, DB, UserFactory, amaran) {
                var vm = this;
                var userProfile = DB.fnGet('userProfile');
                vm.stage = '';
                vm.landingUrl = '';
                vm.isLandingUrlEligible = true;

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckLandingInput = function (landingUrl) {
                    vm.isLandingUrlEligible = !(landingUrl && landingUrl.length && (landingUrl.startsWith('https:') || landingUrl.startsWith('http:')));
                }

                vm.fnSaveUserLandingPageSettings = function (landingUrl) {
                    vm.isLandingUrlChanging = true;
                    var userProfileData = _.cloneDeepWith(userProfile);
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.isLandingUrlSet = landingUrl;
                    } else {
                        userProfileData.pre.home.all = {
                            isLandingUrlSet: landingUrl
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };

                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            userProfile = response;
                            amaran.success("Landing URL updated successfully");
                            vm.isLandingUrlChanging = false;
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnInitLandingPage = function () {
                    if (Object.keys(HOST_URL).length) { //eslint-disable-line
                        var url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                        vm.stage = '';
                        if (url.startsWith('dev')) {
                            vm.stage = 'https://www.ecsmon.ecsiteapp.com/#/';
                        } else {
                            vm.stage = 'https://www.ecsmon.ecsiteapp.com/#/'
                        }
                    } else {
                        vm.stage = 'https://www.ecsmon.ecsiteapp.com/#/';
                    }
                    if (userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet) {
                        vm.landingUrl = userProfile.pre.home.all.isLandingUrlSet !== "" ? userProfile.pre.home.all.isLandingUrlSet : '';
                    } else {
                        vm.landingUrl = '';
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AdvancedCtrl',
            function ($scope, $window, $timeout, DB, UserFactory, swal, amaran, microSpinner, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                var userProfileData = DB.fnGet('userProfile');

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.isUserDataEditable = false;
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isUserDataEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isUserDataEditable = false;
                        vm.userProfile = angular.copy(vm.resetUserProfile);
                        vm.ReadOnlyTrue();
                    }
                };

                vm.fnSaveUserProfileData = function (userProfileData) {
                    vm.isUserProfileDetailsChanging = true;
                    var inputObj = {
                        body: userProfileData
                    };
                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            userProfileData = response;
                            vm.userProfile = angular.toJson(userProfileData, true);
                            vm.resetUserProfile = _.cloneDeepWith(vm.userProfile);
                            vm.isUserProfileDetailsChanging = false;
                            vm.isUserDataEditable = false;
                            amaran.success("User Profile data updated successfully");
                        }, function () {
                            vm.isUserDataEditable = false;
                            vm.isUserProfileDetailsChanging = false;
                        });
                };

                vm.fnResetUserProfileData = function () {
                    swal({
                            title: "Reset the Profile Data?",
                            text: "You are about to reset the data.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.<br/><br/>" +
                                "Please type in the word \"Reset\" to reset data.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "reset",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (inputValue) {
                            if (inputValue === null) {
                                return false;
                            }

                            if (inputValue === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (inputValue !== 'Reset') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (inputValue === 'Reset') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    body: {}
                                };
                                UserFactory.updateUserProfile(inputObj)
                                    .then(function (response) {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        DB.fnSet('userProfile', response);
                                        userProfileData = response;
                                        vm.userProfile = angular.toJson(userProfileData, true);
                                        vm.resetUserProfile = _.cloneDeepWith(vm.userProfile);
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            vm.isUserProfileDetailsChanging = false;
                                            vm.isUserDataEditable = false;
                                            amaran.success("User profile data reset successfully");
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        vm.isUserDataEditable = false;
                                        vm.isUserProfileDetailsChanging = false;
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    });
                            } else if (inputValue === false) {
                                swal("Cancelled", "Reset Process Cancelled", "error");
                            }
                        });
                }

                vm.fnInitAdvanced = function () {
                    vm.userProfile = angular.toJson(userProfileData, true);
                    vm.resetUserProfile = _.cloneDeepWith(vm.userProfile);
                    $timeout(function () {
                        vm.modeChanged();
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('inputConfigModalCtrl',
            function ($uibModalInstance, formComponent, formArr, inputObj, isWorkbenchMode, iot3JsonObj) {
                var vm = this;
                vm.formComponent = _.cloneDeepWith(formComponent);
                vm.formArr = _.cloneDeepWith(formArr);
                vm.inputObj = _.cloneDeepWith(inputObj);
                vm.isEditMode = false;
                vm.isWorkbenchMode = isWorkbenchMode;
                vm.iot3JsonObj = iot3JsonObj;
                vm.inputConfig = {
                    display: [
                        {
                            inputType: 'text',
                            inputTitle: 'Title',
                            inputValue: '',
                            inputPlaceholder: 'Field Title',
                            inputRequired: true,
                            schemaKey: 'title'
                        }
                    ],
                    data: [
                        {
                            inputType: 'text',
                            inputTitle: 'S4 reference name',
                            inputPlaceholder: 'S4 reference name',
                            inputValue: '',
                            inputRequired: true,
                            schemaKey: 'key'
                        }
                    ],
                    validation: [],
                    condition: []
                };
                vm.selectEnumArr = [
                    {
                        value: ''
                    }
                ];
                vm.conditional = {
                    show: '',
                    when: '',
                    value: ''
                };
                vm.isReferenceNameValid = false;
                vm.selectChkEnumArr = [
                    {
                        title: '',
                        key: ''
                    }
                ];

                vm.fnGlobalKeySelected = function (item, model, label, event, enumObj) {
                    if (vm.isWorkbenchMode) {
                        if (vm.oldValueKey.includes('.')) {
                            enumObj.value = vm.oldValueKey.substr(0, vm.oldValueKey.lastIndexOf('.')) + '.' + enumObj.value.name;
                        } else {
                            enumObj.value = '${' + enumObj.value.name;
                        }
                    }
                };

                vm.fnCheckUniqueKey = function (enumObj) {
                    if (vm.isWorkbenchMode) {
                        vm.globalKeyOptions = [];
                        if (enumObj.value &&
                            enumObj.value.startsWith('${') && !enumObj.value.endsWith('}')) {
                            vm.oldValueKey = enumObj.value;
                            var keys = [];
                            if (enumObj.value.includes('.')) {
                                var trail = enumObj.value.substr(2, enumObj.value.lastIndexOf('.') - 2);
                                var value = _.get(vm.iot3JsonObj, trail, 'notFound');
                                if (value.constructor.name === 'Object') {
                                    keys = Object.keys(value);
                                    _.forEach(keys, function (keyName) {
                                        vm.globalKeyOptions.push({
                                            key: '${' + trail + '.' + keyName,
                                            name: keyName
                                        })
                                    });
                                }
                            } else {
                                keys = Object.keys(vm.iot3JsonObj);
                                _.forEach(keys, function (keyName) {
                                    vm.globalKeyOptions.push({
                                        key: '${' + keyName,
                                        name: keyName
                                    })
                                });
                            }
                        }
                    }
                };

                vm.fnCheckInputValid = function (input) {
                    if (input.schemaKey === 'key') {
                        var pattern = /^[a-zA-Z0-9_]*$/;
                        var patt = new RegExp(pattern);
                        vm.isReferenceNameValid = patt.test(input.inputValue);
                    }
                };

                vm.onInputChange = function (input) {
                    if ((input.inputTitle === "Title" || input.inputTitle === "Label Value") && vm.isEditMode === false) {
                        if (angular.isDefined(input.inputValue)) {
                            vm.inputConfig.data[0].inputValue = input.inputValue.toString().replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, "_").toLocaleLowerCase();
                        } else {
                            vm.inputConfig.data[0].inputValue = '';
                        }
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCreateArrayTag = function () {
                    vm.selectEnumArr.push({
                        value: ''
                    })
                };

                vm.onChkArrayInputChange = function (input) {
                    if (angular.isDefined(input.title)) {
                        input.key = input.title.toString().replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s+/g, "_").toLocaleLowerCase();
                    } else {
                        input.key = '';
                    }
                };

                vm.fnCreateChkArrayTag = function () {
                    vm.selectChkEnumArr.push(
                        {
                            title: '',
                            key: ''
                        }
                    );
                }

                vm.fnRemoveArrayTag = function (index) {
                    vm.selectEnumArr.splice(index, 1);
                };

                vm.fnRemoveChkArrayTag = function (index) {
                    vm.selectChkEnumArr.splice(index, 1);
                }

                vm.checkInputValue = function () {
                    var flag = false;
                    _.forEach(vm.inputConfig.display, function (displayObj) {
                        if (displayObj.inputRequired === true && (angular.isUndefined(displayObj.inputValue) || displayObj.inputValue === '')) {
                            if (flag === false) {
                                flag = true
                            } else {
                                flag = false
                            }

                        }
                    });
                    _.forEach(vm.inputConfig.data, function (dataObj) {
                        if (dataObj.inputRequired === true && (angular.isUndefined(dataObj.inputValue) || dataObj.inputValue === '')) {
                            if (flag === false) {
                                flag = true
                            } else {
                                flag = false
                            }
                        }
                    });
                    _.forEach(vm.inputConfig.validation, function (validationObj) {
                        if (validationObj.inputRequired === true && (angular.isUndefined(validationObj.inputValue) || validationObj.inputValue === '')) {
                            if (flag === false) {
                                flag = true
                            } else {
                                flag = false
                            }
                        }
                    });
                    return flag;
                };

                vm.fnSave = function () {
                    var tempObj = {};
                    if (vm.formComponent.name === 'Text Field' || vm.formComponent.name === 'Text Area') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'string';
                        if (vm.formComponent.name === 'Text Area') {
                            tempObj.value.inputType = 'textarea';
                        }
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null && validationObj.inputValue.toString().length) {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.formComponent.name === 'Select') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'string';
                        tempObj.value.inputType = 'dropdown';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null || validationObj.inputValue !== '') {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        var tempArr = [];
                        _.forEach(vm.selectEnumArr, function (obj) {
                            tempArr.push(obj.value);
                        });
                        tempObj.value.enum = tempArr;
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.formComponent.name === 'Checkbox') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'boolean';
                        //tempObj.value.inputType = 'checkbox';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null || validationObj.inputValue !== '') {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj)
                    }
                    if (vm.formComponent.name === 'Number') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'number';
                        //tempObj.value.inputType = 'number';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null && validationObj.inputValue.toString().length) {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj)
                    }
                    if (vm.formComponent.name === 'Password') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'string';
                        tempObj.value.inputType = 'password';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null && validationObj.inputValue.toString().length) {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj)
                    }
                    if (vm.formComponent.name === 'Panel') {
                        tempObj = {key: '', value: {}, multiformConfig: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'object';
                        tempObj.value.inputType = 'panel';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        tempObj.value.properties = {};
                        if (vm.conditional.show && vm.conditional.show.length && vm.conditional.when && vm.conditional.when.length && vm.conditional.value && vm.conditional.value.length) {
                            var inputType = _.find(vm.keyArr, {key: vm.conditional.when});
                            tempObj.multiformConfig = {
                                referenceKey: vm.conditional.when,
                                type: "conditional",
                                conditionObj: {
                                    show: vm.conditional.show === 'true',
                                    when: vm.conditional.when,
                                    value: vm.conditional.value,
                                    inputType: inputType.type
                                }
                            };
                        }
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.formComponent.name === 'Button') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'button';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null && validationObj.inputValue.toString().length) {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj);
                    }

                    if (vm.formComponent.name === 'Label') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'label';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (validationObj.inputValue !== null && validationObj.inputValue.toString().length) {
                                tempObj.value[validationObj.schemaKey] = validationObj.inputValue;
                            }
                        });
                        $uibModalInstance.close(tempObj);
                    }

                    if (vm.formComponent.name === 'Multi Checkbox') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.inputConfig.data[0].inputValue;
                        tempObj.value.type = 'object';
                        tempObj.value.inputType = 'multiCheckbox';
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            tempObj.value[displayObj.schemaKey] = displayObj.inputValue;
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            tempObj.value[dataObj.schemaKey] = dataObj.inputValue;
                        });
                        tempObj.value.type = "object";
                        tempObj.value.properties = {};
                        _.forEach(vm.selectChkEnumArr, function (chkObj) {
                            tempObj.value.properties[chkObj.key] = {
                                type: 'boolean',
                                title: chkObj.title
                            };
                        });
                        $uibModalInstance.close(tempObj);
                    }
                };

                vm.fnGetType = function (type) {
                    var newType = '';
                    switch (type) {
                        case 'inputText':
                            newType = 'Text Field';
                            break;
                        case 'inputTextarea':
                            newType = 'Text Area';
                            break;
                        case 'inputDropdown':
                            newType = 'Select';
                            break;
                        case 'inputCheckbox':
                            newType = 'Checkbox';
                            break;
                        case 'inputNumber':
                            newType = 'Number';
                            break;
                        case 'inputPassword':
                            newType = 'Password';
                            break;
                        case 'inputButton':
                            newType = 'Button';
                            break;
                        case 'inputLabel':
                            newType = 'Label';
                            break;
                        case 'inputMultiCheckbox':
                            newType = 'Multi Checkbox';
                            break;
                        default:
                            newType = 'Panel';
                            break;
                    }
                    return newType;
                };

                vm.fnInitModel = function () {
                    vm.keyArr = [];
                    _.forEach(vm.formArr, function (formObj) {
                        if (formObj.key && formObj.key.length === 1) {
                            vm.keyArr.push({
                                key: formObj.key[0],
                                value: formObj.key[0],
                                type: vm.fnGetType(formObj.type),
                                title: formObj.title
                            });
                        } else if (formObj.key && formObj.key.length === 2) {
                            vm.keyArr.push({
                                key: formObj.key[0] + '.' + formObj.key[1],
                                value: formObj.key[0] + '.' + formObj.key[1],
                                type: vm.fnGetType(formObj.type),
                                title: formObj.title
                            });
                        }
                    });
                    if (vm.formComponent.name === 'Checkbox' || vm.formComponent.name === 'Select' || vm.formComponent.name === 'Text Field' || vm.formComponent.name === 'Text Area' || vm.formComponent.name === 'Number' || vm.formComponent.name === 'Password') {
                        vm.inputConfig.validation.push(
                            {
                                inputType: 'checkbox',
                                inputTitle: 'Required',
                                inputValue: false,
                                inputRequired: false,
                                labelId: 'checkboxRequired',
                                schemaKey: 'required'
                            }
                        );
                    }
                    if (vm.formComponent.name === 'Text Field' || vm.formComponent.name === 'Text Area' || vm.formComponent.name === 'Password') {
                        vm.inputConfig.display.push(
                            {
                                inputType: 'text',
                                inputTitle: 'Placeholder',
                                inputValue: '',
                                inputPlaceholder: 'Placeholder',
                                inputRequired: false,
                                schemaKey: 'placeholder'
                            }
                        );
                        vm.inputConfig.validation.push(
                            {
                                inputType: 'number',
                                inputTitle: 'Minimum Length',
                                inputValue: '',
                                inputPlaceholder: 'Minimum Length',
                                inputRequired: false,
                                schemaKey: 'minLength'
                            },
                            {
                                inputType: 'number',
                                inputTitle: 'Maximum Length',
                                inputValue: '',
                                inputPlaceholder: 'Maximum Length',
                                inputRequired: false,
                                schemaKey: 'maxLength'
                            }
                        );
                    }
                    if (vm.formComponent.name === 'Number') {
                        vm.inputConfig.display.push(
                            {
                                inputType: 'text',
                                inputTitle: 'Placeholder',
                                inputValue: '',
                                inputPlaceholder: 'Placeholder',
                                inputRequired: false,
                                schemaKey: 'placeholder'
                            }
                        );
                        vm.inputConfig.validation.push(
                            {
                                inputType: 'number',
                                inputTitle: 'Minimum Value',
                                inputValue: '',
                                inputPlaceholder: 'Minimum Value',
                                inputRequired: false,
                                schemaKey: 'minimum'
                            },
                            {
                                inputType: 'number',
                                inputTitle: 'Maximum Value',
                                inputValue: '',
                                inputPlaceholder: 'Maximum Value',
                                inputRequired: false,
                                schemaKey: 'maximum'
                            }
                        );
                    }
                    if (vm.formComponent.name === 'Button') {
                        vm.inputConfig.data[0].inputType = 'button';
                        vm.inputConfig.display = [{
                            inputType: 'text',
                            inputTitle: 'Button Name',
                            inputValue: '',
                            inputPlaceholder: 'Button Name',
                            inputRequired: true,
                            schemaKey: 'name'
                        }, {
                            inputType: 'text',
                            inputTitle: 'Field Value',
                            inputValue: '',
                            inputPlaceholder: 'Field Value',
                            inputRequired: true,
                            schemaKey: 'value'
                        }];
                    }

                    if (vm.formComponent.name === 'Label') {
                        vm.inputConfig.display = [{
                            inputType: 'text',
                            inputTitle: 'Label Value',
                            inputValue: '',
                            inputPlaceholder: 'Label Value',
                            inputRequired: true,
                            schemaKey: 'title'
                        }];
                    }

                    vm.inputConfig.display.push({
                        inputType: 'checkbox',
                        inputTitle: 'Hide Input',
                        inputValue: false,
                        inputRequired: false,
                        labelId: 'checkboxHideInput',
                        schemaKey: 'hide'
                    });
                    if (Object.keys(vm.inputObj).length) {
                        vm.isEditMode = true;
                        _.forEach(vm.inputConfig.display, function (displayObj) {
                            if (angular.isDefined(vm.inputObj[displayObj.schemaKey])) {
                                displayObj.inputValue = _.cloneDeepWith(vm.inputObj[displayObj.schemaKey]);
                            } else if (angular.isDefined(vm.inputObj.schema) && angular.isDefined(vm.inputObj.schema[displayObj.schemaKey])) {
                                displayObj.inputValue = _.cloneDeepWith(vm.inputObj.schema[displayObj.schemaKey]);
                            }
                        });
                        _.forEach(vm.inputConfig.data, function (dataObj) {
                            if (angular.isDefined(vm.inputObj[dataObj.schemaKey])) {
                                dataObj.inputValue = _.cloneDeepWith(vm.inputObj[dataObj.schemaKey]);
                            } else if (angular.isDefined(vm.inputObj.schema) && angular.isDefined(vm.inputObj.schema[dataObj.schemaKey])) {
                                dataObj.inputValue = _.cloneDeepWith(vm.inputObj.schema[dataObj.schemaKey]);
                            }
                        });
                        _.forEach(vm.inputConfig.validation, function (validationObj) {
                            if (angular.isDefined(vm.inputObj[validationObj.schemaKey])) {
                                validationObj.inputValue = _.cloneDeepWith(vm.inputObj[validationObj.schemaKey]);
                            } else if (angular.isDefined(vm.inputObj.schema) && angular.isDefined(vm.inputObj.schema[validationObj.schemaKey])) {
                                validationObj.inputValue = _.cloneDeepWith(vm.inputObj.schema[validationObj.schemaKey]);
                            }
                        });
                        if (vm.formComponent.name === 'Select') {
                            vm.selectEnumArr = [];
                            _.forEach(vm.inputObj.enum, function (enumObj) {
                                vm.selectEnumArr.push({
                                    value: enumObj
                                });
                            });
                        }
                        if (vm.formComponent.name === 'Multi Checkbox') {
                            vm.selectChkEnumArr = [];
                            _.forEach(vm.inputObj.schema.properties, function (value, key) {
                                vm.selectChkEnumArr.push({
                                    title: value.title,
                                    key: key
                                });
                            });
                        }
                        if (vm.formComponent.name === 'Panel') {
                            if (vm.inputObj.multiformConfig && vm.inputObj.multiformConfig.referenceKey !== '') {
                                vm.conditional.show = true + '';
                                vm.conditional.when = _.cloneDeepWith(vm.inputObj.multiformConfig.referenceKey);
                            }
                            if (vm.inputObj.multiformConfig && vm.inputObj.multiformConfig.conditionObj) {
                                vm.conditional.show = _.cloneDeepWith(vm.inputObj.multiformConfig.conditionObj.show + '');
                                vm.conditional.when = _.cloneDeepWith(vm.inputObj.multiformConfig.conditionObj.when);
                                vm.conditional.value = _.cloneDeepWith(vm.inputObj.multiformConfig.conditionObj.value);
                            }
                        }
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('addNewPropertiesCtrl',
            function ($uibModalInstance, amaran) {
                var vm = this;
                vm.selectedInput = '';
                vm.inputTypeArr = [
                    {
                        name: 'string',
                        displayName: 'Text'
                    },
                    {
                        name: 'string',
                        displayName: 'Textarea'
                    },
                    {
                        name: 'boolean',
                        displayName: 'Check Box'
                    },
                    {
                        name: 'string',
                        displayName: 'Dropdown'
                    }
                ];
                vm.test = '';
                var tempObj = {};
                vm.tempInput = '';
                vm.newForm = {
                    key: '',
                    title: '',
                    type: 'object',
                    properties: {}
                };
                vm.formInput = [
                    {
                        key: '',
                        title: '',
                        type: ''
                    }
                ];

                vm.fnAddNewInput = function () {
                    vm.formInput.push({
                        key: '',
                        title: '',
                        type: ''
                    });
                };

                vm.fnSelectedMultiFormInputType = function (name, index) {
                    if (name.displayName === 'Text') {
                        vm.formInput[index].type = 'string';
                        vm.formInput[index].required = false;
                        if (name === 'Textarea') {
                            vm.formInput[index].inputType = 'textarea'
                        }
                    } else if (name.displayName === 'Textarea') {
                        vm.formInput[index].type = 'string';
                        vm.formInput[index].required = false;
                        vm.formInput[index].inputType = 'textarea'
                    } else if (name.displayName === 'Dropdown') {
                        vm.formInput[index].type = 'string';
                        vm.formInput[index].required = false;
                        vm.formInput[index].inputType = 'dropdown';
                        vm.formInput[index].enum = [];
                    }
                };

                vm.textOrTextareaInputObj = {
                    key: '',
                    title: '',
                    type: 'string',
                    minLength: null,
                    maxLength: null,
                    description: '',
                    required: false
                };

                vm.checkboxInputObj = {
                    key: '',
                    title: '',
                    type: 'boolean',
                    multiform: false
                };

                vm.dropDownInputObj = {
                    key: '',
                    title: '',
                    type: 'string',
                    enum: [],
                    required: false
                };
                vm.arrValue = '';
                vm.arrValueMF = '';
                /*description: '',*/

                vm.fnCreateArrayTag = function (value, id) {
                    if (value && value.toString().length) {
                        var flag = false;
                        _.forEach(vm.dropDownInputObj.enum, function (obj) {
                            if (obj === value) {
                                flag = true;
                            }
                        });

                        if (!flag) {
                            vm.dropDownInputObj.enum.push(_.cloneDeepWith(value));
                            vm.arrValue = "";
                            angular.element('#' + id).blur();
                        } else {
                            amaran.error('Value already present. Please enter a different Value.');
                        }
                    }
                };

                vm.fnRemoveArrayTag = function (index) {
                    vm.dropDownInputObj.enum.splice(index, 1);
                };

                vm.fnCreateArrayTagForMF = function (value, id, obj) {
                    if (value && value.toString().length) {
                        var flag = false;
                        _.forEach(obj.enum, function (obj) {
                            if (obj === value) {
                                flag = true;
                            }
                        });

                        if (!flag) {
                            obj.enum.push(_.cloneDeepWith(value));
                            obj.arrValue = "";
                            angular.element('#' + id).blur();
                        } else {
                            amaran.error('Value already present. Please enter a different Value.');
                        }
                    }
                };

                vm.fnRemoveArrayTagMF = function (index, obj) {
                    obj.enum.splice(index, 1);
                };

                vm.fnSave = function () {
                    if (vm.selectedInput.displayName === 'Text') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.textOrTextareaInputObj.key;
                        tempObj.value = {title: vm.textOrTextareaInputObj.title};
                        tempObj.value.type = 'string';
                        tempObj.value.description = vm.textOrTextareaInputObj.description;
                        tempObj.value.required = vm.textOrTextareaInputObj.required;
                        if (vm.textOrTextareaInputObj.minLength !== null) {
                            tempObj.value.minLength = vm.textOrTextareaInputObj.minLength;
                        }
                        if (vm.textOrTextareaInputObj.maxLength !== null) {
                            tempObj.value.maxLength = vm.textOrTextareaInputObj.maxLength;
                        }
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.selectedInput.displayName === 'Textarea') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.textOrTextareaInputObj.key;
                        tempObj.value = {title: vm.textOrTextareaInputObj.title};
                        tempObj.value.type = 'string';
                        tempObj.value.description = vm.textOrTextareaInputObj.description;
                        tempObj.value.required = vm.textOrTextareaInputObj.required;
                        tempObj.value.inputType = 'textarea';
                        if (vm.textOrTextareaInputObj.minLength !== null) {
                            tempObj.value.minLength = vm.textOrTextareaInputObj.minLength;
                        }
                        if (vm.textOrTextareaInputObj.maxLength !== null) {
                            tempObj.value.maxLength = vm.textOrTextareaInputObj.maxLength;
                        }
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.selectedInput.displayName === 'Dropdown') {
                        tempObj = {key: '', value: {}};
                        tempObj.key = vm.dropDownInputObj.key;
                        tempObj.value = {title: vm.dropDownInputObj.title};
                        tempObj.value.type = 'string';
                        tempObj.value.required = vm.dropDownInputObj.required;
                        tempObj.value.enum = vm.dropDownInputObj.enum;
                        tempObj.value.inputType = 'dropdown';
                        $uibModalInstance.close(tempObj);
                    }
                    if (vm.selectedInput.displayName === 'Check Box') {
                        tempObj = {key: '', value: {}, multiform: {}};
                        tempObj.key = vm.checkboxInputObj.key;
                        tempObj.value = {title: vm.checkboxInputObj.title};
                        tempObj.value.type = 'boolean';
                        /*tempObj.value.description = vm.checkboxInputObj.description;*/
                        tempObj.value.inputType = 'checkbox';
                        tempObj.value.multiform = vm.checkboxInputObj.multiform;
                        if (vm.checkboxInputObj.multiform) {
                            var test = {};
                            var tempArr = [];
                            _.forEach(vm.formInput, function (inputObj) {
                                test = {};
                                if (inputObj.tempInputType.displayName === 'Text') {
                                    test = {key: '', value: {}};
                                    test.key = inputObj.key;
                                    test.value = {title: inputObj.title};
                                    test.value.type = 'string';
                                    test.value.description = inputObj.description;
                                    test.value.required = inputObj.required;
                                    if (inputObj.minLength !== null) {
                                        test.value.minLength = inputObj.minLength;
                                    }
                                    if (vm.textOrTextareaInputObj.maxLength !== null) {
                                        test.value.maxLength = inputObj.maxLength;
                                    }
                                }
                                if (inputObj.tempInputType.displayName === 'Textarea') {
                                    test = {key: '', value: {}};
                                    test.key = inputObj.key;
                                    test.value = {title: inputObj.title};
                                    test.value.type = 'string';
                                    test.value.description = inputObj.description;
                                    test.value.required = inputObj.required;
                                    test.value.inputType = 'textarea';
                                    if (inputObj.minLength !== null) {
                                        test.value.minLength = inputObj.minLength;
                                    }
                                    if (inputObj.maxLength !== null) {
                                        test.value.maxLength = inputObj.maxLength;
                                    }
                                }
                                if (inputObj.tempInputType.displayName === 'Check Box') {
                                    test = {key: '', value: {}};
                                    test.key = inputObj.key;
                                    test.value = {title: inputObj.title};
                                    test.value.type = 'boolean';
                                    test.value.inputType = 'checkbox';
                                }
                                if (inputObj.tempInputType.displayName === 'Dropdown') {
                                    test = {key: '', value: {}};
                                    test.key = inputObj.key;
                                    test.value = {title: inputObj.title};
                                    test.value.type = 'string';
                                    test.value.required = inputObj.required;
                                    test.value.enum = inputObj.enum;
                                    test.value.inputType = 'dropdown';
                                }
                                tempArr.push(test);
                            });
                            vm.newForm.properties = _.cloneDeepWith(tempArr);
                            tempObj.multiform = vm.newForm;
                            $uibModalInstance.close(tempObj)
                        } else {
                            $uibModalInstance.close(tempObj)
                        }
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCheckInput = function () {
                    var flag = true;
                    _.forEach(vm.formInput, function (inputObj, index) {
                        if(inputObj.tempInputType && inputObj.tempInputType.displayName){
                            if ((inputObj.tempInputType && inputObj.tempInputType.displayName === 'Text') || (inputObj.tempInputType && inputObj.tempInputType.displayName === 'Textarea')) {
                                if ((inputObj.key && inputObj.key.length) && (inputObj.title && inputObj.title.length)) {
                                    if (index !== 0) {
                                        if (flag === false) {
                                            flag = false;
                                        }
                                    } else {
                                        flag = false;
                                    }
                                }
                            }
                            if (inputObj.tempInputType && inputObj.tempInputType.displayName === 'Check Box') {
                                if ((inputObj.key && inputObj.key.length) && (inputObj.title && inputObj.title.length)) {
                                    if (index !== 0) {
                                        if (flag === false) {
                                            flag = false;
                                        }
                                    } else {
                                        flag = false;
                                    }
                                }
                            }
                            if (inputObj.tempInputType && inputObj.tempInputType.displayName === 'Dropdown') {
                                if ((inputObj.key && inputObj.key.length) && (inputObj.title && inputObj.title.length) && (inputObj.enum && inputObj.enum.length)) {
                                    if (index !== 0) {
                                        if (flag === false) {
                                            flag = false;
                                        }
                                    } else {
                                        flag = false;
                                    }
                                }
                            }
                        } else {
                            if ((inputObj.key && inputObj.key.length) && (inputObj.title && inputObj.title.length)) {
                                if (index !== 0) {
                                    if (flag === false) {
                                        flag = false;
                                    }
                                } else {
                                    flag = false;
                                }
                            }
                        }
                    });
                    return !flag;
                };

                vm.validateNewInput = function () {
                    var flag = true;
                    if (vm.selectedInput && vm.selectedInput.displayName && (vm.selectedInput.displayName === 'Text' || vm.selectedInput.displayName === 'Textarea')) {
                        if ((vm.textOrTextareaInputObj.key && vm.textOrTextareaInputObj.key.length) && (vm.textOrTextareaInputObj.title && vm.textOrTextareaInputObj.title.length)) {
                            flag = false;
                        }
                    }
                    if (vm.selectedInput && vm.selectedInput.displayName && vm.selectedInput.displayName === 'Dropdown') {
                        if ((vm.dropDownInputObj.key && vm.dropDownInputObj.key.length) && (vm.dropDownInputObj.title && vm.dropDownInputObj.title.length) && (vm.dropDownInputObj.enum && vm.dropDownInputObj.enum.length)) {
                            flag = false;
                        }
                    }
                    if (vm.selectedInput && vm.selectedInput.displayName && vm.selectedInput.displayName === 'Check Box') {
                        if (vm.checkboxInputObj.multiform) {
                            if ((vm.checkboxInputObj.key && vm.checkboxInputObj.key.length) && (vm.checkboxInputObj.title && vm.checkboxInputObj.title.length) && (vm.newForm.key && vm.newForm.key.length) && (vm.newForm.title && vm.newForm.title.length) && vm.fnCheckInput()) {
                                flag = false;
                            }
                        } else {
                            if ((vm.checkboxInputObj.key && vm.checkboxInputObj.key.length) && (vm.checkboxInputObj.title && vm.checkboxInputObj.title.length)) {
                                flag = false;
                            }
                        }
                    }
                    return flag;
                };

                vm.fnInitModel = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('issueAttributesModalCtrl',
            function ($rootScope, $window, ColorService, $state, moment, amaran, $timeout, $uibModalInstance, ApiListService, issueObj, QueryFactory) {
                var vm = this;
                vm.selectedIssue = _.cloneDeepWith(issueObj);
                vm.isAttributeDataLoading = true;
                vm.attributesArr = [];
                var getCurrentURL = ApiListService.getCurrentURL();

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeight = total - (header + 30);
                        angular.element("#alarmIssueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                vm.fnGetAttributes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            res.data.map(function (obj) {
                                if (obj.receivedAt) {
                                    obj.receivedDate = vm.fnGetAbsoluteOrRelativeTime(obj.receivedAt);
                                }
                                if (obj.healthLastChangedAt) {
                                    obj.healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.healthLastChangedAt);
                                }
                            });
                            vm.attributesArr = res.data;
                            vm.isAttributeDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAttributeDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.alarms', {selectedId: issueObj.id});
                    $uibModalInstance.dismiss('cancel');
                }

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL+ "/#/node/alarm?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                }

                vm.fnInitIssueAttributesModal = function () {
                    vm.isAttributeDataLoading = true;
                    var tempIdString = "";
                    _.forEach(vm.selectedIssue.attributeIds, function (id, index) {
                        if (index === vm.selectedIssue.attributeIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    var sql = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_attributes where data->>\'id\' IN (" + tempIdString + ");"
                    vm.fnGetAttributes({"sql": sql});
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('addNewAttributeModalCtrl',
            function ($rootScope, $window, $state, DB, AppInitService, moment, BatchFactory, PaginationQueryService, amaran, $timeout, IssueFactory, $uibModalInstance, UserProfileService, ApiListService, issueObj, ColorService, QueryFactory, $log) {
                var vm = this;
                vm.selectedIssue = _.cloneDeepWith(issueObj);
                vm.alarmProjectFilter = "$";
                vm.alarmProjectSearch = {$: ''};
                vm.projectsArr = [];
                vm.isProjectLoaded = false;

                //Search Variables
                vm.isRefreshData = true;
                vm.isProjectLoaded = false;
                vm.isInitAlarm = true;
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "data->>'id'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Name",
                        name: "data->>'name'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "data->>'description'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Mode",
                        name: "data->>'mode'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Reference",
                        name: "data->>'reference'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "data->>'health'",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Node ID",
                        name: "data->>'nodeId'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "ECU ID",
                        name: "data->>'ecuId'",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Node Name",
                        name: "node_nodes.data->>'name'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }, {
                        displayName: "ECU Name",
                        name: "node_ecus.data->>'name'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }, {
                        displayName: "Tracked",
                        name: "issueIds",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "jsonb_array_length(node_attributes.data->'issueIds') > 0",
                        localSearchValue: "obj.issueIds.length > 0"
                    }, {
                        displayName: "Untracked",
                        name: "issueIds",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "node_attributes.data->'issueIds' IS NULL OR jsonb_array_length(node_attributes.data->'issueIds') = 0",
                        localSearchValue: "!obj.issueIds.length"
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Alarms Variables
                vm.isAlarmsLoading = false;
                vm.alarmsArr = [];
                vm.selectedAlarmsArr = [];
                vm.selectedAlarmObj = {};
                vm.isTabsLoading = null;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.alarmResponse = [];
                vm.isAttributeAdding = false;
                vm.isAllChecked = false;
                vm.tempCompletedAttributeList = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.parsePostgresData = function(data) {
                    return data.map(function(item) {
                        var parsed = item.data || {};
                        parsed._id = item._id;
                        parsed.id = parsed.id || item._id;
                        parsed.receivedAt = parsed.receivedAt ? parseInt(parsed.receivedAt) : null;
                        parsed.healthLastChangedAt = parsed.healthLastChangedAt ? parseInt(parsed.healthLastChangedAt) : null;
                        parsed.ecuName = item.ecuName;
                        parsed.nodeName = item.nodeName;
                        parsed.rootNodeId = item.rootNodeId;
                        parsed.totalItems = parseInt(item.totalItems);
                        return parsed;
                    });
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.page) {
                        vm.currentPage = Math.ceil(vm.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.perPage = Math.ceil(vm.perPage)
                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;

                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'alarm', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = "data->>'" + sortValue + "' " + sortType;
                    }

                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = "WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>'_id' AS rt, " +
                                "node_ecus.data->>'name' AS ecuName, " +
                                "CASE WHEN node_attributes.data->>'ecuId' = node_attributes.data->>'nodeId' " +
                                "THEN node_ecus.data->>'name' ELSE node_nodes.data->>'name' END nodeName, " +
                                "CASE WHEN node_attributes.data->>'ecuId' = node_attributes.data->>'nodeId' " +
                                "THEN node_ecus.data->>'id' ELSE node_nodes.data->>'rootNodeId' END rootNodeId " +
                                "FROM node_attributes as node_attributes";
                            sqlString += " LEFT JOIN node_ecus ON node_attributes.data->>'ecuId' = node_ecus.data->>'id' " +
                                "LEFT JOIN node_nodes ON node_attributes.data->>'nodeId' = node_nodes.data->>'id'";
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>'projectId' = '" + vm.project.id + "'" :
                                " WHERE node_attributes.data->>'projectId' = '" + vm.project.id + "'";
                            sqlString += " ORDER BY " + sortString + " LIMIT " + vm.perPage + " ),";
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, ' +
                                    'node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' ' +
                                vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                    }
                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];

                            // Transform JSONB data to match expected format
                            _.forEach(res.data, function (projectObj) {
                                var transformed = projectObj.data || {};
                                transformed._id = projectObj._id;
                                transformed.id = transformed.id || projectObj._id;
                                transformed.totalItems = parseInt(projectObj.totalItems || 0);
                                transformed.rt = projectObj.rt;
                                projects.push(transformed);
                            });

                            if ((res.data && res.data.length && res.data.length > 0) &&
                                (projects[0] && projects[0].totalItems > projects.length)) {

                                var sqlString = 'SELECT*, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';

                                $log.debug('Loading more projects with query:', sqlString);
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function (error) { // Error block
                            $log.error('Error loading projects:', error);
                            vm.fnGetProjects(inputObj, [], false);
                        });
                };

                vm.fnGetProjectAlarm = function(projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = "data->>'"+sortValue+"' "+sortType;
                    }

                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = "SELECT*, data->>'" + sortValue + "' AS rt FROM node_attributes";
                    } else { //for general sort
                        sqlString = "SELECT*, data->>\'_id\' AS rt FROM node_attributes";
                    }

                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, ' +
                                'node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] +
                                ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" :
                                " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, ' +
                                'node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' ' +
                                vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                'FROM node_attributes as node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    }

                    $log.debug('Generated SQL query:', sqlString);

                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'selectedProject',
                            _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'selectedProject', '');
                    }

                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#alarmTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.alarmsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAlarmsArr = angular.copy(vm.alarmsArr);
                    } else {
                        vm.selectedAlarmsArr = [];
                    }
                };

                vm.fnCheckUncheckCheckbox = function (alarmObj) {
                    var isFindIndex = _.findIndex(vm.selectedAlarmsArr, {id: alarmObj});
                    if (alarmObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.push(alarmObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnPageChanged = function(page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }

                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;

                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = "data->>'"+sortValue+"' "+sortType;
                    }

                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                            'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                            'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                            'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                            'FROM node_attributes as node_attributes';
                        sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                    } else { //for general sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                            'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                            'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                            'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                            'FROM node_attributes as node_attributes';
                        sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                    }

                    if (isPerPageChanged) {
                        if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, ' +
                                    'node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                    'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                    " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" :
                                    " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] +
                                    ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                    " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" :
                                    " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, data->>\'_id\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                    'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                    " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" :
                                    " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ?
                                    " WHERE " + vm.sqlQuery.trim() + " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" :
                                    " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        } else {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, ' +
                                    'node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                    'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY node_attributes.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] +
                                    ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, data->>\'_id\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END nodeName, ' +
                                    'CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' ' +
                                    'THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END rootNodeId ' +
                                    'FROM node_attributes as node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes ' +
                                    'LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAlarms(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }

                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page,
                            vm.previousPage, perPage, vm.totalItems, vm.alarmsArr, true, 'node_attributes');

                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }

                        var newSQL = "WITH attributes AS (" + tempNewSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes " +
                            "LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                            "LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'";
                        newSQL += tempSQL && tempSQL.length ? " WHERE " + tempSQL.trim() + ")" : " )";
                        newSQL += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';

                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }

                        $log.debug('Generated pagination SQL:', newSQL);

                        vm.previousPage = page;
                        vm.fnGetAlarms(newInput, false);
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetAlarms = function (inputObj, isFirst) {
                    vm.isAlarmsLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.receivedAt) {
                                    obj.receivedDate = vm.fnGetAbsoluteOrRelativeTime(obj.receivedAt);
                                }
                                if (obj.healthLastChangedAt) {
                                    obj.healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.healthLastChangedAt);
                                }
                            });
                            vm.alarmResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.alarmResponse.data && vm.alarmResponse.data.length) {
                                vm.totalItems = vm.alarmResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.alarmResponse.data.reverse();
                            }
                            vm.alarmsArr = vm.alarmResponse.data;
                            vm.isRefresh = false;
                            vm.isAlarmsLoading = false;
                            vm.isInitAlarm = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAlarmsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };
                /*END: TABLE*/

                vm.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                vm.isAlarmObjSelected = function () {
                    return angular.isDefined(vm.selectedAlarmsArr) && vm.selectedAlarmsArr.length;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnAddAttribute = function () {
                    vm.isAttributeAdding = true;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedAlarmsArr, function (selectedAttribute, index) {
                        if (index <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + vm.selectedIssue.id + "/attributes/" + selectedAttribute.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + vm.selectedIssue.id + "/attributes/" + selectedAttribute.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnAttributeBatchOperation(batchCollectionObj, count);
                }

                vm.fnAttributeBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker',
                        parallel: false
                    }).then(function (batchRes) {
                        _.forEach(batchRes, function (obj) {
                            if (obj.statusCode.toString().startsWith('20')) {
                                var tempId = obj.request.path.split('/');
                                var isFind = _.find(vm.selectedAlarmsArr, {id: tempId[tempId.length - 1]})
                                if (isFind) {
                                    vm.tempCompletedAttributeList.push(isFind);
                                }
                            }
                        });
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnAttributeBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success('Attribute added successfully');
                            vm.isAttributeAdding = false;
                            $uibModalInstance.close(vm.tempCompletedAttributeList);
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnAttributeBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success('Attribute added successfully');
                            vm.isAttributeAdding = false;
                            $uibModalInstance.close(vm.tempCompletedAttributeList);
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    });
                };

                vm.fnInitAttributesModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('addParticipantCtrl',
            function ($uibModalInstance, $timeout) {
                var vm = this;
                vm.newEmail = '';
                vm.isCreateDisabled = true;
                vm.isCreateDisabled = true;
                vm.isEmailCreating = true;
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                vm.fnValidateEmail = function (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(email)) {
                        vm.isCreateDisabled = true;
                        return false;
                    } else {
                        vm.isCreateDisabled = false;
                        return true;
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isEmailCreating = false;

                    $timeout(function () {
                        vm.isEmailCreating = true;
                        vm.isCreateDisabled = true;
                        $uibModalInstance.close({email: vm.newEmail});
                    });
                };

            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('issueInfo', fnIssueInfo)

    /** @ngInject */
    function fnIssueInfo($rootScope, $state, $stateParams, $window, $http, $base64, $timeout, $uibModal, $sce, $location,
                         moment, microSpinner, swal, amaran, copyService, CommentFactory, mermaid, AvatarService,
                         ColorService, DB, IssueFactory, postActionModelMessage, postActionModelIcon, UserProfileService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/issue/directives/issueInfo/issueInfo.html',
            scope: {
                issueObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isIssueInfoUpdating = false;
                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    65: false, //a
                    76: false, //l
                    67: false, //c
                    79: false, //o
                    85: false //u
                };
                $scope.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');
                $scope.isIssueStateChange = false;
                $scope.loginUserAvatar = AvatarService.getTextAvatar($scope.loginUser);
                $scope.selectedComment = {};
                $scope.isShowIssueSummary = false;
                $scope.isShowMainComment = false;
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                $scope.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;
                $scope.selectedCommentView = 'Horizontal'; //Vertical
                $scope.issuePublicTabAPITimeout = "";
                $scope.tabs = [
                    {
                        title: 'Public',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Private',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/issuePrivate/issuePrivate.html',
                        visible: true
                    },
                    {
                        title: 'Form',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/IssueForm/issueForm.html',
                        visible: !!(angular.isDefined($scope.issueObj.customForm) && $scope.issueObj.customForm.schema && $scope.issueObj.customForm.schema.properties && Object.keys($scope.issueObj.customForm.schema.properties).length)
                    },
                    {
                        title: 'History',
                        tabIndex: 4,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/issueHistory/issueHistory.html',
                        visible: true
                    },
                    {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/issueSupplemental/issueSupplemental.html',
                        visible: true
                    },
                    {
                        title: 'Attributes',
                        tabIndex: 6,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/issueAttributes/issueAttributes.html',
                        visible: !!($scope.issueObj.attributeIds && $scope.issueObj.attributeIds.length)
                    }
                ];

                $scope.newCommentObj = {
                    privateStream: false,
                    text: ""
                };

                $scope.newSubComment = {
                    text: ""
                }
                $scope.markedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview",
                    hiddenButtons: ['all']
                };

                $scope.newCommentMarkedOptionObj = {
                    iconlibrary: 'fa',
                    addExtraButtons: false,
                    resize: 'vertical',
                    hiddenButtons: ['all']
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnCopyIssueLink = function () {
                    var url = $location.absUrl().split('?')[0];
                    copyService.fnCopyToClipboard(url + '?selectedId=' + $scope.issueObj.id);
                    $timeout(function () {
                        amaran.success("Link copied successfully");
                    })
                };

                $scope.issueDetailContextMenu = function (issueDetailObj) {
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            issueDetailObj.isTitleEditable = true;
                            $scope.resetEditIssueDetailObj = angular.copy(issueDetailObj);
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            })
                        }
                    }]
                };

                $scope.fnCancelIssueTitleEditMode = function (issueDetailObj, isSuccessCall) {
                    if (isSuccessCall) {
                        issueDetailObj.name = angular.copy(issueDetailObj.name);
                        issueDetailObj.isTitleEditable = false;
                        $scope.resetEditIssueDetailObj = {};
                    } else {
                        issueDetailObj.name = angular.copy($scope.resetEditIssueDetailObj.name);
                        issueDetailObj.isTitleEditable = false;
                        $scope.resetEditIssueDetailObj = {};
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    })
                };

                $scope.fnSaveIssueTitle = function (issueDetailObj) {
                    issueDetailObj.isTitleEditable = false;
                    var inputObj = {
                        body: {},
                        issueId: issueDetailObj.id
                    };
                    inputObj.body = {
                        "name": issueDetailObj.name
                    };
                    IssueFactory.modifyName(inputObj)
                        .then(function (response) {
                            issueDetailObj.name = response.name;
                            $scope.fnCancelIssueTitleEditMode(issueDetailObj, true);
                            amaran.success("Issue Updated Successfully");
                            $scope.$emit('IssueDetailsChanged', response);
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            $scope.fnCancelIssueTitleEditMode(issueDetailObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        $timeout(function () {
                            if (angular.element(".comment-timeline")[0]) {
                                var commentTimeline = angular.element(".comment-timeline")[0].offsetHeight;
                                var newCommentBlock = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                var commentHeader = angular.element(".comment-header")[0].offsetHeight;
                                var commentFooter = angular.isDefined(angular.element(".comment-footer")[0]) ? angular.element(".comment-footer")[0].offsetHeight : 0;
                                //var test = finalHeight + 200;
                                angular.element(".comment-body").css('height', (finalHeight - (commentTimeline + newCommentBlock + commentHeader + commentFooter + 60)) + 'px');
                            }
                            if (angular.element(".vertical-comment-view")[0]) {
                                var newCommentBlock1 = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                angular.element(".vertical-comment-view").css('height', (finalHeight - (newCommentBlock1 + 40)) + 'px');
                                //angular.element(".qa-message-content").css('height', ((finalHeight - (newCommentBlock1 + 40)) - 53) + 'px');
                                if ($scope.issueSummary.isEditMode) {
                                    angular.element("#" + $scope.issueSummary.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                } else {
                                    angular.element("#" + $scope.issueSummary.id).css('height', '');
                                    if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                        _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                            if (publicCommentObj.isEditMode) {
                                                angular.element("#" + publicCommentObj.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                            } else {
                                                angular.element("#" + publicCommentObj.id).css('height', '');
                                            }
                                            if (publicCommentObj.subComments && publicCommentObj.subComments.length) {
                                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                                    if (subCommentObj.isEditMode) {
                                                        angular.element("#" + subCommentObj.id).css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                                    } else {
                                                        angular.element("#" + subCommentObj.id).css('height', '');
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }
                                if (angular.element("#newSubComment")[0]) {
                                    angular.element("#newSubComment").css('height', (((finalHeight - (newCommentBlock1 + 90)) - 53) / 2) + 'px');
                                }
                            }
                        })
                    }
                };

                $scope.fnKeyDownComment = function () {
                    $timeout(function () {
                        var total = angular.element(".newCommentUI")[0].offsetHeight;
                        var commentTimeline = angular.element(".comment-timeline")[0] ? angular.element(".comment-timeline")[0].offsetHeight : 0;
                        var commentHeader = angular.element(".comment-header")[0] ? angular.element(".comment-header")[0].offsetHeight : 0;
                        var newHeight = (total - (commentTimeline + commentHeader + 105));
                        var minHeight = newHeight * 40 / 100;
                        var value = document.getElementsByClassName('newCommentTextBox')[0].value;
                        var numberOfLineBreaks = (value.match(/\n/g) || []).length;
                        var newHeight1 = 20 + numberOfLineBreaks * 20 + 12 + 2;
                        if (newHeight1 > minHeight) {
                            angular.element(".newCommentTextBox").css('height', newHeight1)
                        }
                        $timeout(function () {
                            $scope.fnSetTabHeight();
                        });
                    });
                };

                $scope.fnClickNewComment = function (blur) {
                    if (angular.element(".newCommentUI")[0]) {
                        var total = angular.element(".newCommentUI")[0].offsetHeight;
                        var commentTimeline = angular.element(".comment-timeline")[0] ? angular.element(".comment-timeline")[0].offsetHeight : 0;
                        var commentHeader = angular.element(".comment-header")[0] ? angular.element(".comment-header")[0].offsetHeight : 0;
                        var commnetBodyHeight = angular.element(".newCommentTextBox")[0].offsetHeight;
                        var commnetBodyScrollHeight = angular.element(".newCommentTextBox")[0].scrollHeight;
                        var newHeight = (total - (commentTimeline + commentHeader + 105));
                        var minHeight = newHeight * 40 / 100;
                        angular.element(".newCommentTextBox").css('max-height', newHeight * 70 / 100);
                        if (blur) {
                            var value = document.getElementsByClassName('newCommentTextBox')[0].value;
                            var numberOfLineBreaks = (value.match(/\n/g) || []).length;
                            var newHeight1 = 20 + numberOfLineBreaks * 20 + 12 + 2;
                            if (newHeight1 > minHeight) {
                                angular.element(".newCommentTextBox").css('height', newHeight1)
                            }
                            if (!value.length) {
                                angular.element(".newCommentTextBox").css('height', 45)
                            }
                        } else {
                            if (commnetBodyHeight !== commnetBodyScrollHeight) {
                                angular.element(".newCommentTextBox").css('height', commnetBodyScrollHeight);
                            } else {
                                angular.element(".newCommentTextBox").css('height', minHeight);
                            }
                        }
                        $timeout(function () {
                            $scope.fnSetTabHeight();
                        });
                    }
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                /*Upload: START*/
                $scope.uploadIssueFile = function (res, type, filedata, commentObj, newSubCommentObj) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        var elementName = '';
                        if (commentObj) {
                            elementName = 'editor' + commentObj.id;
                        } else if (newSubCommentObj) {
                            elementName = 'newSubCommentEditor';
                        } else {
                            elementName = 'newCommentEditor';
                        }
                        var domElement = document.getElementsByName(elementName)[0];
                        if (angular.isDefined(domElement)) {
                            var val = '';
                            if (type === 'image') {
                                if (commentObj) {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            } else {
                                if (commentObj) {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            }
                            if (document.selection) {
                                domElement.focus();
                                var sel = document.selection.createRange();
                                sel.text = val;
                                domElement.focus();
                            } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                                var startPos = domElement.selectionStart;
                                var endPos = domElement.selectionEnd;
                                var scrollTop = domElement.scrollTop;
                                domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                                domElement.focus();
                                domElement.selectionStart = startPos + val.length;
                                domElement.selectionEnd = startPos + val.length;
                                domElement.scrollTop = scrollTop;
                            } else {
                                domElement.value += val;
                                domElement.focus();
                            }
                            if (commentObj) {
                                commentObj.mdBody = document.getElementsByName(elementName)[0].value;
                                commentObj.fileUploading = false;
                            } else if (newSubCommentObj) {
                                $scope.newSubComment.text = document.getElementsByName(elementName)[0].value;
                                $scope.newSubComment.fileUploading = false;
                            } else {
                                $scope.newCommentObj.text = document.getElementsByName(elementName)[0].value;
                                $scope.newCommentObj.fileUploading = false;
                            }
                        } else {
                            if (type === 'image') {
                                if (commentObj) {
                                    commentObj.mdBody = commentObj.mdBody + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    $scope.newSubComment.text = $scope.newSubComment.text + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    $scope.newCommentObj.text = $scope.newCommentObj.text + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            } else {
                                if (commentObj) {
                                    commentObj.mdBody = commentObj.mdBody + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else if (newSubCommentObj) {
                                    $scope.newSubComment.text = $scope.newSubComment.text + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                } else {
                                    $scope.newCommentObj.text = $scope.newCommentObj.text + " [" + filedata.name + "](" + res.downloadUrl + ")";
                                }
                            }
                            if (commentObj) {
                                commentObj.fileUploading = false;
                            } else if (newSubCommentObj) {
                                $scope.newSubComment.fileUploading = false;
                            } else {
                                $scope.newCommentObj.fileUploading = false;
                            }
                        }
                    });
                };

                $scope.uploadFiles = function (type, filedata, commentObj, newSubCommentObj) {
                    if ($scope.userPermissionsObj.GET_FILE_UPLOAD_LINK) {
                        if (commentObj) {
                            commentObj.fileUploading = true;
                        } else if (newSubCommentObj) {
                            $scope.newSubComment.fileUploading = true;
                        } else {
                            $scope.newCommentObj.fileUploading = true;
                        }
                        $scope.$apply();
                        var inputObj = {
                            projectId: $scope.issueObj.projectId
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                $scope.uploadIssueFile(res, type, filedata, commentObj, newSubCommentObj);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file');
                    }
                };
                /*Upload: END*/

                $scope.fnGetIssue = function (issueId) {
                    var tempObj = {
                        issueId: issueId
                    };
                    IssueFactory.describeIssue(tempObj)
                        .then(function (response) {
                            $scope.isIssueDetailsLoaded = true;
                            response.isIssueEditMode = false;
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                if (response.resolved && response.resolutionDeadlineAt) {
                                    if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = true
                                    } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = false
                                    }
                                }
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            $scope.issueObj = response;
                            $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                            $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                            _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                                publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                });
                            });
                            if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                $scope.selectedComment.isShowComment = true;
                                $scope.isShowMainComment = true;
                                $scope.isShowIssueSummary = false;
                            } else {
                                $scope.fnShowIssueSummary();
                            }
                            $scope.resetIssueObj = angular.copy(response);
                            $scope.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                $scope.issueSummary = _.cloneDeepWith(tempSummary);
                            });
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.fnRenderMermaid();
                                if ($scope.selectedCommentView === 'Vertical') {
                                    $timeout(function () {
                                        var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                        objDiv.scrollTop = objDiv.scrollHeight;
                                    })
                                    $scope.selectedComment = {};
                                }
                            });
                            if ($scope.issuePublicTabAPITimeout === "") {
                                $scope.issuePublicTabAPITimeout = $timeout(function () {
                                    $scope.fnChangeIssuePublicData();
                                }, 60000);
                            }
                        }, function () {
                        })
                };

                $scope.fnShowIssueSummary = function () {
                    var tempSummary = {};
                    $scope.selectedComment = {};
                    tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                    tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                    tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                    tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                    tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                    tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                    tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                    tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                    tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                    tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                    tempSummary.isShowComment = true;
                    $timeout(function () {
                        $scope.selectedComment = _.cloneDeepWith(tempSummary);
                    });
                    $scope.isShowIssueSummary = true;
                    $scope.isShowMainComment = false;
                    $scope.fnRenderMermaid();
                };

                $scope.fnShowComment = function (comment, type, mainCommentObj) {
                    $scope.selectedComment = {};
                    $timeout(function () {
                        comment.isShowComment = true;
                        $scope.selectedComment = _.cloneDeepWith(comment);
                        if (type === 'subComment') {
                            $scope.selectedComment.mainCommentId = mainCommentObj.id
                        }
                    }, 0);
                    $scope.isShowMainComment = type === 'mainComment';
                    $scope.isShowIssueSummary = false;
                    $scope.fnRenderMermaid();
                };

                $scope.fnAddCommentToIssue = function (issueObj, newCommentObj, type) {
                    newCommentObj.fileUploading = true;
                    var inputObj = {
                        issueId: issueObj.id,
                        body: {
                            privateStream: false,
                            text: newCommentObj.text,
                            syntax: newCommentObj.syntax
                        }
                    };
                    CommentFactory.addComment(inputObj)
                        .then(function (response) {
                            response.fileUploading = false;
                            if (type === 'CommentResolve') {
                                $scope.fnResolveIssue(issueObj, newCommentObj);
                            } else if (type === 'CommentResolveRequest') {
                                $scope.fnResolveIssueRequest(issueObj, newCommentObj);
                            } else {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                                newCommentObj.syntax = "TEXT";
                                $timeout(function () {
                                    $scope.isIssueDetailsLoaded = false;
                                    $scope.fnGetIssue($scope.issueObj.id);
                                    $scope.fnSetTabHeight();
                                });
                            }
                            //$scope.fnShowComment();
                        })
                };

                $scope.fnAddSubCommentToComment = function (commentObj, newCommentObj, type) {
                    newCommentObj.fileUploading = true;
                    var inputObj = {
                        commentId: commentObj.id,
                        body: {
                            privateStream: false,
                            text: newCommentObj.text
                        }
                    };
                    CommentFactory.addSubComment(inputObj)
                        .then(function (response) {
                            response.fileUploading = false;
                            if (type === 'CommentResolve') {
                                $scope.fnResolveIssue($scope.issueObj, newCommentObj);
                            } else if (type === 'CommentResolveRequest') {
                                $scope.fnResolveIssueRequest($scope.issueObj, newCommentObj);
                            } else {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                                $timeout(function () {
                                    $scope.isIssueDetailsLoaded = false;
                                    $scope.fnGetIssue($scope.issueObj.id);
                                    $scope.fnSetTabHeight();
                                });
                            }
                        })
                };

                $scope.fnEditIssueComment = function (issueObj, commentObj, name) {
                    if (commentObj) {
                        commentObj.isDetailsOpened = true;
                        commentObj.isEditMode = true;
                        name = name + commentObj.id;
                    } else {
                        issueObj.isIssueEditMode = true;
                    }
                    $timeout(function () {
                        $rootScope.markdownEditorObjects[name].hidePreview();
                    }, 100);
                    if ($scope.selectedCommentView === 'Vertical') {
                        if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                            _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                if (publicCommentObj.id !== commentObj.id) {
                                    publicCommentObj.mdBody = '';
                                    publicCommentObj.isShowComment = false;
                                    $timeout(function () {
                                        publicCommentObj.mdBody = publicCommentObj.text;
                                        publicCommentObj.isEditMode = false;
                                        publicCommentObj.isShowComment = true;
                                        $timeout(function () {
                                            var name = 'editor' + publicCommentObj.id;
                                            $rootScope.markdownEditorObjects[name].hidePreview();
                                            $rootScope.markdownEditorObjects[name].showPreview();
                                        });
                                    });
                                }
                                if (publicCommentObj.subComments && publicCommentObj.subComments.length) {
                                    _.forEach(publicCommentObj.subComments, function (publicSubCommentObj) {
                                        if (publicSubCommentObj.id !== commentObj.id) {
                                            publicSubCommentObj.mdBody = '';
                                            publicSubCommentObj.isShowComment = false;
                                            $timeout(function () {
                                                publicSubCommentObj.mdBody = publicSubCommentObj.text;
                                                publicSubCommentObj.isEditMode = false;
                                                publicSubCommentObj.isShowComment = true;
                                                $timeout(function () {
                                                    var name = 'editor' + publicSubCommentObj.id;
                                                    $rootScope.markdownEditorObjects[name].hidePreview();
                                                    $rootScope.markdownEditorObjects[name].showPreview();
                                                });
                                            });
                                        }
                                    })
                                }
                            })
                        }
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    $scope.fnRenderMermaid();
                };

                $scope.fnUpdateIssueSummary = function (issueObj, commentObj) {
                    commentObj.fileUploading = true;
                    var inputObj = {
                        issueId: $scope.issueObj.id,
                        body: {
                            summary: commentObj.mdBody
                        }
                    };
                    IssueFactory.modifySummary(inputObj)
                        .then(function (response) {
                            angular.forEach(response, function (val, key) {
                                commentObj[key] = val;
                            });
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            //commentObj.userAvatar = angular.isDefined(commentObj.createdBy) ? AvatarService.getTextAvatar({email: commentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            //commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            //commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                            //commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            commentObj.mdBody = _.cloneDeepWith(commentObj.summary);
                            commentObj.voteCount = _.cloneDeepWith(commentObj.voteCount);
                            $scope.issueObj.summary = commentObj.summary;
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            $scope.$emit('IssueDetailsChanged', response);
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        }, function () {
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        })
                };


                $scope.fnCancelCommentEditing = function (commentObj) {
                    commentObj.mdBody = '';
                    commentObj.isShowComment = false;
                    $timeout(function () {
                        if ($scope.isShowIssueSummary === true) {
                            commentObj.mdBody = commentObj.summary;
                        } else {
                            commentObj.mdBody = commentObj.text;
                        }
                        commentObj.isEditMode = false;
                        commentObj.isShowComment = true;
                        $timeout(function () {
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                        });
                    });
                };

                $scope.fnCancelVerticalCommentEditing = function (commentObj, isSummary) {
                    commentObj.mdBody = '';
                    commentObj.isShowComment = false;
                    $timeout(function () {
                        if (isSummary === true) {
                            commentObj.mdBody = commentObj.summary;
                        } else {
                            commentObj.mdBody = commentObj.text;
                        }
                        commentObj.isEditMode = false;
                        commentObj.isShowComment = true;
                        $timeout(function () {
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].hidePreview();
                            $rootScope.markdownEditorObjects[name].showPreview();
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                        });
                    });
                }

                $scope.fnUpdateComment = function (issueObj, commentObj) {
                    commentObj.fileUploading = true;
                    var inputObj = {
                        commentId: commentObj.id,
                        body: {
                            text: commentObj.mdBody
                        }
                    };
                    CommentFactory.modifyCommentText(inputObj)
                        .then(function (response) {
                            angular.forEach(response, function (val, key) {
                                commentObj[key] = val;
                            });
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            //commentObj.userAvatar = angular.isDefined(commentObj.createdBy) ? AvatarService.getTextAvatar({email: commentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            //commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            //commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                            //commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            var name = 'editor' + commentObj.id;
                            $rootScope.markdownEditorObjects[name].showPreview();
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            commentObj.fileUploading = false;
                            commentObj.isEditMode = false;
                            if ($scope.selectedCommentView === 'Horizontal') {
                                $scope.fnCancelCommentEditing(commentObj);
                            } else {
                                $scope.fnCancelVerticalCommentEditing(commentObj, false);
                            }
                        })
                };

                $scope.fnDeleteIssueComment = function (issueObj, commentObj) {
                    angular.element(".microSpinner").remove();
                    angular.element(".confirm").css("visibility", "visible");
                    swal({
                            title: "Delete the selected comment?",
                            text: "You are about to permanently delete the selected comment.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    commentId: commentObj.id
                                };
                                CommentFactory.deleteComment(inputObj)
                                    .then(function () {
                                        $scope.isIssueDetailsLoaded = false;
                                        $scope.issueObj.publicComments = _.remove($scope.issueObj.publicComments, function (obj) {
                                            return obj.id !== commentObj.id;
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $scope.isIssueDetailsLoaded = true;
                                        $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : +"Public [ 0 ]";
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            $scope.selectedComment = {};
                                            if ($scope.selectedCommentView === 'Horizontal') {
                                                $timeout(function () {
                                                    if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                                        $scope.fnShowComment($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1], 'mainComment');
                                                    } else {
                                                        $scope.fnShowIssueSummary()
                                                    }
                                                    // $scope.selectedComment =  _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                                }, 0);
                                            }
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout.cancel($scope.issuePublicTabAPITimeout);
                    if ($scope.selectedTab === 1) {
                        $scope.issuePublicTabAPITimeout = $timeout(function () {
                            $scope.fnChangeIssuePublicData();
                        }, 60000);
                    }
                    $timeout(function () {
                        $state.go('main.issue', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnInitIssue = function () {
                    $scope.isIssueDetailsLoaded = false;
                    $scope.fnGetIssue($scope.issueObj.id);
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnReOpenIssue = function (issueObj) {
                    $scope.isIssueInfoUpdating = true;
                    var inputObj = {
                        issueId: issueObj.id
                    };
                    IssueFactory.reopenIssue(inputObj)
                        .then(function (response) {
                            $scope.issueObj.resolved = response.resolved;
                            response.fileUploading = false;
                            $scope.isIssueDetailsLoaded = false;
                            $scope.isIssueInfoUpdating = false;
                            $timeout(function () {
                                $scope.isIssueDetailsLoaded = false;
                                $scope.fnGetIssue($scope.issueObj.id);
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIssueInfoUpdating = false;
                        })
                };

                $scope.fnResolveIssue = function (issueObj, newCommentObj) {
                    $scope.isIssueInfoUpdating = true;
                    var inputObj = {
                        issueId: issueObj.id
                    };
                    IssueFactory.resolveIssue(inputObj)
                        .then(function (response) {
                            $scope.issueObj.resolved = response.resolved;
                            $scope.$emit('issueResolved', issueObj.id);
                            if (angular.isDefined(newCommentObj)) {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                            }
                            $scope.isIssueDetailsLoaded = false;
                            $scope.isIssueInfoUpdating = false;
                            $timeout(function () {
                                $scope.isIssueDetailsLoaded = false;
                                $scope.fnGetIssue($scope.issueObj.id);
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIssueInfoUpdating = false;
                        })
                };

                $scope.fnResolveIssueRequest = function (issueObj, newCommentObj) {
                    $scope.isIssueInfoUpdating = true;
                    var inputObj = {
                        issueId: issueObj.id
                    };
                    IssueFactory.resolveIssueRequest(inputObj)
                        .then(function (response) {
                            $scope.issueObj.resolved = response.resolved;
                            if (angular.isDefined(newCommentObj)) {
                                newCommentObj.fileUploading = false;
                                newCommentObj.text = '';
                            }
                            $scope.isIssueDetailsLoaded = false;
                            $scope.isIssueInfoUpdating = false;
                            $timeout(function () {
                                $scope.isIssueDetailsLoaded = false;
                                $scope.fnGetIssue($scope.issueObj.id);
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIssueInfoUpdating = false;
                        })
                };

                $scope.fnAddUpDownVoteToComment = function (isUpVote, commentObj) {
                    if (isUpVote && !$scope.userPermissionsObj.UP_VOTE_COMMENT) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote a comment.');
                        return;
                    } else if (!isUpVote && !$scope.userPermissionsObj.DOWN_VOTE_COMMENT) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote a comment.');
                        return;
                    }
                    commentObj.isVoteUpdateing = true;
                    commentObj.voteCount = commentObj.voteCount ? commentObj.voteCount : 0;
                    var input = {
                        commentId: commentObj.id,
                        body: {
                            voteCount: isUpVote ? commentObj.voteCount + 1 : commentObj.voteCount - 1
                        }
                    };
                    if (isUpVote) {
                        CommentFactory.upVoteComment(input)
                            .then(function (res) {
                                delete commentObj.isVoteUpdateing;
                                //commentObj = res;
                                $scope.selectedComment.voteCount = res.voteCount;
                                commentObj.voteCount = res.voteCount;
                                commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                                commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            }, function (error) {
                                delete commentObj.isVoteUpdateing;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        CommentFactory.downVoteComment(input)
                            .then(function (res) {
                                delete commentObj.isVoteUpdateing;
                                //commentObj = res;
                                $scope.selectedComment.voteCount = res.voteCount;
                                commentObj.voteCount = res.voteCount;
                                commentObj.humanDateCreated = moment.unix(commentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                commentObj.humanDateCreatedRelative = moment(commentObj.humanDateCreated).fromNow();
                                commentObj.humanDateCreatedAbsolute = moment.unix(commentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                commentObj.mdBody = _.cloneDeepWith(commentObj.text);
                            }, function (error) {
                                delete commentObj.isVoteUpdateing;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                $scope.fnAddUpDownVoteToIssue = function (isUpVote, issueObj) {
                    if (isUpVote && !$scope.userPermissionsObj.UP_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote an Issue.');
                        return;
                    } else if (!isUpVote && !$scope.userPermissionsObj.DOWN_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote an Issue.');
                        return;
                    }
                    issueObj.isVoteUpdateing = true;
                    issueObj.voteCount = issueObj.voteCount ? issueObj.voteCount : 0;
                    var input = {
                        issueId: issueObj.id
                    };
                    if (isUpVote) {
                        IssueFactory.upVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdateing;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(issueObj.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        IssueFactory.downVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdateing;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(issueObj.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                $scope.fnArchivedIssue = function (issueObj) {
                    $scope.isIssueInfoUpdating = true;
                    var input = {
                        issueId: issueObj.id
                    };
                    IssueFactory.archiveIssue(input)
                        .then(function () {
                            $scope.$emit('issueArchive', issueObj.id);
                            $scope.isIssueInfoUpdating = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIssueInfoUpdating = false;
                        });
                };

                $scope.fnGetRelativeTime = function (createdDate) {
                    return moment.unix(createdDate).format("DD/MM/YYYY, HH:mm");
                };

                $scope.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        $scope.fnRenderMermaid();
                    }
                };

                $scope.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce(); //eslint-disable-line
                        vega_runonce(); //eslint-disable-line
                    }, 100);
                };

                $scope.fnChangeCommentView = function (type) {
                    $scope.selectedCommentView = type;
                    if ($scope.selectedTab === 1) {
                        $timeout(function () {
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                            if (type === 'Vertical') {
                                $timeout(function () {
                                    var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                    objDiv.scrollTop = objDiv.scrollHeight;
                                })
                                $scope.selectedComment = {};
                            } else {
                                //$scope.selectedComment = {};
                                if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                    $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                    $scope.selectedComment.isShowComment = true;
                                    $scope.isShowMainComment = true;
                                    $scope.isShowIssueSummary = false;
                                } else {
                                    $scope.fnShowIssueSummary();
                                }
                            }
                        });
                    } else {
                        $rootScope.$emit('IssueCommentViewChanged');
                    }
                };

                $scope.fnAddNewSubComment = function (issueObj, commentObj) {
                    if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                        _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                            if (publicCommentObj.isShowSubCommentEditor) {
                                publicCommentObj.isShowSubCommentEditor = false;
                            }
                        })
                    }
                    commentObj.isShowSubCommentEditor = true;
                    $timeout(function () {
                        document.getElementsByClassName("new-sub-comment-editor")[0].scrollIntoView();
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnCancelVerticalNewSubComment = function (commentObj) {
                    commentObj.isShowSubCommentEditor = false;
                    $scope.newSubComment = {
                        text: ""
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnChangeIssuePublicData = function () {
                    var tempObj = {
                        issueId: $scope.issueObj.id
                    };
                    IssueFactory.describeIssue(tempObj)
                        .then(function (response) {
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                if (response.resolved && response.resolutionDeadlineAt) {
                                    if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = true
                                    } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                        response.isResolvedAtTime = false
                                    }
                                }
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            $scope.issueObj = response;
                            $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                            $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                            _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                                publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                                publicCommentObj.voteCount = _.cloneDeepWith(publicCommentObj.voteCount);
                                if ($scope.selectedCommentView !== 'Vertical') {
                                    if ($scope.selectedComment.id === publicCommentObj.id) {
                                        $scope.selectedComment.text = _.cloneDeepWith(publicCommentObj.text);
                                        $scope.selectedComment.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                        $scope.selectedComment.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                                        $scope.selectedComment.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                        $scope.selectedComment.mdBody = _.cloneDeepWith(publicCommentObj.text);
                                        $scope.selectedComment.voteCount = _.cloneDeepWith(publicCommentObj.voteCount);
                                        if ($scope.selectedComment.isEditMode) {
                                            amaran.warning('The selected comment has been edited externally');
                                        }
                                        var selectedCommentName = 'editor' + publicCommentObj.id;
                                        $timeout(function () {
                                            if ($rootScope.markdownEditorObjects[selectedCommentName]) {
                                                $rootScope.markdownEditorObjects[selectedCommentName].showNewPreview();
                                            }
                                        })
                                    }
                                } else {
                                    var name = 'editor' + publicCommentObj.id;
                                    $timeout(function () {
                                        if ($rootScope.markdownEditorObjects[name]) {
                                            $rootScope.markdownEditorObjects[name].showNewPreview();
                                        }
                                    })
                                }
                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                    subCommentObj.voteCount = _.cloneDeepWith(subCommentObj.voteCount);
                                    if ($scope.selectedCommentView !== 'Vertical') {
                                        if ($scope.selectedComment.id === subCommentObj.id) {
                                            $scope.selectedComment.text = _.cloneDeepWith(subCommentObj.text);
                                            $scope.selectedComment.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                            $scope.selectedComment.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                            $scope.selectedComment.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                            $scope.selectedComment.mdBody = _.cloneDeepWith(subCommentObj.text);
                                            $scope.selectedComment.voteCount = _.cloneDeepWith(subCommentObj.voteCount);
                                            if ($scope.selectedComment.isEditMode) {
                                                amaran.warning('The selected comment has been edited externally');
                                            }
                                            var selectedCommentName = 'editor' + subCommentObj.id;
                                            $timeout(function () {
                                                if ($rootScope.markdownEditorObjects[selectedCommentName]) {
                                                    $rootScope.markdownEditorObjects[selectedCommentName].showNewPreview();
                                                }
                                            })
                                        }
                                    } else {
                                        var name = 'editor' + subCommentObj.id;
                                        $timeout(function () {
                                            if ($rootScope.markdownEditorObjects[name]) {
                                                $rootScope.markdownEditorObjects[name].showNewPreview();
                                            }
                                        })
                                    }
                                });
                            });
                            $scope.resetIssueObj = angular.copy(response);
                            $scope.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                $scope.issueSummary = _.cloneDeepWith(tempSummary);
                                if ($scope.selectedCommentView === 'Vertical') {
                                    var name = 'editor' + $scope.issueSummary.id;
                                    $timeout(function () {
                                        if ($rootScope.markdownEditorObjects[name]) {
                                            $rootScope.markdownEditorObjects[name].showNewPreview();
                                        }
                                    })
                                }
                            });
                            if ($scope.issueObj.publicComments && !$scope.issueObj.publicComments.length) {
                                $scope.fnShowIssueSummary();
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.fnRenderMermaid();
                            });
                            $scope.issuePublicTabAPITimeout = $timeout(function () {
                                $scope.fnChangeIssuePublicData();
                            }, 60000);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.issuePublicTabAPITimeout = $timeout(function () {
                                $scope.fnChangeIssuePublicData();
                            }, 60000);
                        })
                };

                var issueInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.issue') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[69] && $scope.issuePermissionsObj.Modify && !$scope.isIssueEditMode &&
                                $scope.issueObj.state === 'OPEN' && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Edit
                                $scope.fnEditIssueComment($scope.issueObj, null, 'issueEditor');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[65] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Assignee tab
                                $scope.fnSwitchTab('Assignee');
                                codeset[38] = false;
                                codeset[65] = false;
                            } else if (codeset[38] && codeset[76] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Label tab
                                $scope.fnSwitchTab('Labels');
                                codeset[38] = false;
                                codeset[76] = false;
                            } else if (codeset[38] && codeset[67] && $scope.issuePermissionsObj.Modify &&
                                $scope.issueObj.state === 'OPEN' && !$scope.isIssueStateChange && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Close Issue
                                $scope.fnChangeIssueState($scope.issueObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[67] = false;
                            } else if (codeset[38] && codeset[79] && $scope.issuePermissionsObj.Modify &&
                                $scope.issueObj.state === 'CLOSED' && !$scope.isIssueStateChange && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Open Issue
                                $scope.fnChangeIssueState($scope.issueObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[79] = false;
                            } else if (codeset[38] && codeset[85] &&
                                $scope.issuePermissionsObj.Modify && $scope.filePermissionsObj.Upload && $scope.issueObj.state === 'OPEN' && $scope.selectedTab === 1) {
                                event.preventDefault();
                                var element = document.activeElement;
                                if (element.type === 'textarea' && element.name === 'issueEditor') {
                                    codeset[38] = false;
                                    codeset[85] = false;
                                    document.getElementById($scope.issueObj.commentIds[0] + '').click()
                                } else if (element.type === 'textarea' && element.name.includes('editor')) {
                                    codeset[38] = false;
                                    codeset[85] = false;
                                    var id = element.name.replace('editor', '');
                                    document.getElementById(id + '').click()
                                } else if (element.type === 'textarea' && element.name === 'newCommentEditor') {
                                    codeset[38] = false;
                                    codeset[85] = false;
                                    document.getElementById('newComment').click()
                                }
                            }
                        }
                    }
                };

                $scope.$on("IssueDetailsChanged", function (evt, response) {
                    response.isIssueEditMode = false;
                    var currntTime = moment().unix();
                    if (response.resolutionDeadlineAt) {
                        response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                        response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                        var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                        response.issueCreateDate = issueCreateDate;
                        response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                        var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                        response.issueDeadline = issueDeadline;
                        response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                        if (response.resolved && response.resolutionDeadlineAt) {
                            if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = true
                            } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = false
                            }
                        }
                    }
                    if (response.responseDeadlineAt) {
                        response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                        response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                        var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                        response.issueUpdatedDate = issueUpdatedDate;
                        response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                        var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                        response.issueResponseDeadline = issueResponseDeadline;
                        response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                    }
                    response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                    $scope.issueObj = response;
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        _.forEach($scope.issueObj.assignees, function (userObj) {
                            userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                        })
                    }
                    $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                    $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                    $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                    $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                    _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                        publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                        publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                        publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                        publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                        _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                            subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                            subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                        });
                    });
                    /*if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                        $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                        $scope.selectedComment.isShowComment = true;
                        $scope.isShowMainComment = true;
                    } else {
                        $scope.fnShowIssueSummary();
                    }*/
                    if ($scope.selectedCommentView === 'Horizontal') {
                        if ($scope.isShowIssueSummary === true) {
                            $scope.fnShowIssueSummary();
                        } else {
                            $scope.fnShowComment($scope.selectedComment, $scope.isShowMainComment ? 'mainComment' : 'subComment')
                        }
                    }
                    $scope.resetIssueObj = angular.copy(response);
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                        $scope.fnRenderMermaid();
                    });
                    $scope.tabs[2].visible = !!(angular.isDefined($scope.issueObj.customForm) && $scope.issueObj.customForm.schema && $scope.issueObj.customForm.schema.properties && Object.keys($scope.issueObj.customForm.schema.properties).length)
                });

                $scope.$on("IssuePrivateDetailsChanged", function (evt, response) {
                    var currntTime = moment().unix();
                    if (response.resolutionDeadlineAt) {
                        response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                        response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                        var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                        response.issueCreateDate = issueCreateDate;
                        response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                        var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                        response.issueDeadline = issueDeadline;
                        response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                        if (response.resolved && response.resolutionDeadlineAt) {
                            if (response.resolvedAt <= response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = true
                            } else if (response.resolvedAt > response.resolutionDeadlineAt) {
                                response.isResolvedAtTime = false
                            }
                        }
                    }
                    if (response.responseDeadlineAt) {
                        response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                        response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                        var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                        response.issueUpdatedDate = issueUpdatedDate;
                        response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                        var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                        response.issueResponseDeadline = issueResponseDeadline;
                        response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                    }
                    response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                    $scope.issueObj = response;
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        _.forEach($scope.issueObj.assignees, function (userObj) {
                            userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                        })
                    }
                    $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                    $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                    $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                    $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                    $scope.resetIssueObj = angular.copy(response);
                    $scope.$emit('IssueDetailsChanged', _.cloneDeepWith(response));
                });

                var issueInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.issue') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', issueInfoKeyDownEventHandler);
                document.addEventListener('keyup', issueInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel($scope.relativeTimeTimer);
                    $timeout.cancel($scope.issuePublicTabAPITimeout);
                    document.removeEventListener('keydown', issueInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', issueInfoKeyUpEventHandler);
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('issueBoards', fnIssueBoards)

    /** @ngInject */
    function fnIssueBoards($base64, $rootScope, $timeout, $sce, $state, $stateParams, DB, amaran, moment, issuePriorityArr,
                           issueStateArr, issueTypeArr, AppInitService, QueryFactory, UserProfileService, AvatarService, ProjectFactory,
                           IssueFactory, $log) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/issue/directives/issueBoards/issueBoards.html',
            scope: {
                fnSetTableHeight: "&",
                fnHideShowCreateForm: "&",
                getSettings: "&",
                getIssueDetails: "&",
                totalItems: "=",
                issueBoardForState: "=",
                issueBoardForPriority: "=",
                issueBoardForType: "=",
                userPermissionsObj: '=',
                fnSetTabName: "&"
            },
            link: function ($scope) {

                $scope.areIssuesLoading = true;
                $scope.issueResponse = [];
                $scope.allIssueStatesOrPriority = [];
                var loginUser = DB.fnGet('loginUser');

                //Search Variables
                $scope.isRefreshData = true;
                $scope.isRefresh = false;

                var tableName = 'tracker_issues';
                var FiltersArrOrder = ['Assigned to me', 'Resolution Overdue', 'Response Overdue', 'Open', 'Resolved', 'Assignee', 'Created', 'Updated', 'Type', 'Priority', 'Status', 'Label', 'Participant', 'ID', 'Name', 'Summary', 'Unread'];
                $scope.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Summary",
                        name: "summary",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Created",
                        name: "createdAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Updated",
                        name: "updatedAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Open",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'false\'',
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Resolved",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'true\'',
                        localSearchValue: 'obj.resolved === true'
                    }, {
                        displayName: "Resolution Overdue",
                        name: "resolutionDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() > obj.resolutionDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() < obj.resolutionDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Response Overdue",
                        name: "responseDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        localSearch: {
                            type: 'timestamp',
                            name: 'assignees',
                            key: 'email'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                filter: '>',
                                localSearch: 'moment().unix() > obj.responseDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                filter: '<',
                                localSearch: 'moment().unix() < obj.responseDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Assigned to me",
                        name: tableName + ".data->>'assignees'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "EXISTS (SELECT 1 FROM jsonb_array_elements(" + tableName + ".data->'assignees') as u WHERE u->>'email' = '" + loginUser.email + "')",
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Unread",
                        name: tableName + ".data->>'lastPublicCommentReadBy'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "NOT (" + tableName + ".data->'lastPublicCommentReadBy' ? '" + loginUser.email + "')",
                        localSearchValue: "!obj.lastPublicCommentReadBy.includes('" + loginUser.email + "')"
                    }];

                $scope.sortFieldArr = [
                    {name: 'data->>\'name\'', displayName: 'Name'},
                    {name: 'data->>\'description\'', displayName: 'Description'},
                    {name: "tracker_issues.data->>'issuePriority->>name'", displayName: "Priority"}
                ];
                $scope.filterQuery = "";
                $scope.perPage = 100;
                $scope.currentPage = 1;

                //board variables
                $scope.boardData = {};

                //projectRelationshipsObj
                $scope.projectRelationshipsObj = {};
                $scope.isInitIssue = true;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                /*START: Issue State or Priority Change*/
                $scope.dropCallback = function (index, item, external, type, target, targetId) {
                    if ($scope.issueBoardForState) {
                        if (!item.issueState || (item.issueState && item.issueState.id !== targetId)) {
                            var boardId = item.issueState && item.issueState.id ? item.issueState.id : 'unassigned';
                            var filteredList = _.filter($scope.boardData[boardId].children, function (itemObj) {
                                return itemObj.id !== item.id;
                            });
                            $scope.boardData[boardId].children = angular.copy(filteredList);
                            if (targetId !== 'unassigned') {
                                item.issueState = {
                                    id: targetId,
                                    name: target.name,
                                    color: target.color
                                }
                                $scope.fnChangeIssueState(item.id, targetId);
                            } else {
                                item.issueState = null;
                                $scope.fnRemoveIssueState(item.id, targetId)
                            }
                            $scope.boardData[targetId].children.splice(index, 0, item);
                        }
                    } else if ($scope.issueBoardForPriority) {
                        if (!item.issuePriority || (item.issuePriority && item.issuePriority.id !== targetId)) {
                            var boardIdPriority = item.issuePriority && item.issuePriority.id ? item.issuePriority.id : 'unassigned';
                            var filteredListPriority = _.filter($scope.boardData[boardIdPriority].children, function (itemObj) {
                                return itemObj.id !== item.id;
                            });
                            $scope.boardData[boardIdPriority].children = angular.copy(filteredListPriority);
                            if (targetId !== 'unassigned') {
                                item.issuePriority = {
                                    id: targetId,
                                    name: target.name,
                                    color: target.color
                                }
                                $scope.fnChangeIssuePriority(item.id, targetId);
                            } else {
                                item.issuePriority = null;
                                $scope.fnRemoveIssuePriority(item.id, targetId)
                            }
                            $scope.boardData[targetId].children.splice(index, 0, item);
                        }
                    } else {
                        if (!item.issueType || (item.issueType && item.issueType.id !== targetId)) {
                            var boardIdType = item.issueType && item.issueType.id ? item.issueType.id : 'unassigned';
                            var filteredListType = _.filter($scope.boardData[boardIdType].children, function (itemObj) {
                                return itemObj.id !== item.id;
                            });
                            $scope.boardData[boardIdType].children = angular.copy(filteredListType);
                            if (targetId !== 'unassigned') {
                                item.issueType = {
                                    id: targetId,
                                    name: target.name,
                                    color: target.color
                                }
                                $scope.fnChangeIssueType(item.id, targetId);
                            } else {
                                item.issueType = null;
                                $scope.fnRemoveIssueType(item.id, targetId)
                            }
                            $scope.boardData[targetId].children.splice(index, 0, item);
                        }
                    }
                }

                $scope.fnChangeIssueState = function (issueId, stateId) {
                    var inputObj = {
                        "issueId": issueId,
                        "stateId": stateId
                    };
                    IssueFactory.modifyState(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[stateId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issueState = response.issueState;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        }, function () {
                        })
                };

                $scope.fnChangeIssuePriority = function (issueId, priorityId) {
                    var inputObj = {
                        "issueId": issueId,
                        "priorityId": priorityId
                    };
                    IssueFactory.modifyPriority(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[priorityId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issuePriority = response.issuePriority;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        }, function () {
                        })
                };

                $scope.fnChangeIssueType = function (issueId, typeId) {
                    $scope.isTypeChanged = false;
                    var inputObj = {
                        "issueId": issueId,
                        "typeId": typeId
                    };
                    IssueFactory.modifyType(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[typeId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issueType = response.issueType;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        }, function () {
                        })
                };

                $scope.fnRemoveIssueState = function (issueId, typeId) {
                    var inputObj = {
                        issueId: issueId
                    }
                    IssueFactory.removeIssueState(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[typeId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issueState = response.issueState;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        })
                }

                $scope.fnRemoveIssuePriority = function (issueId, typeId) {
                    var inputObj = {
                        issueId: issueId
                    }
                    IssueFactory.removeIssuePriority(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[typeId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issuePriority = response.issuePriority;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        })
                }

                $scope.fnRemoveIssueType = function (issueId, typeId) {
                    var inputObj = {
                        issueId: issueId
                    }
                    IssueFactory.removeIssueType(inputObj)
                        .then(function (response) {
                            _.forEach($scope.boardData[typeId].children, function (issueObj) {
                                if (issueObj.id === issueId) {
                                    issueObj.issueType = response.issueType;
                                    $rootScope.$broadcast("IssueDetailsChanged", response);
                                }
                            })
                        })
                }
                /*END: Issue State or Priority Change*/

                /*START: UI functions*/
                $scope.fnGetAssigneeAvatar = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                }

                $scope.fnGetIssuesLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj) && angular.isDefined(labelObj.color)) {
                        var labelTextColor = $scope.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + labelTextColor
                        }
                    }
                };

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                $scope.fnOpenSettings = function () {
                    $scope.getSettings({
                        isCalledForState: $scope.issueBoardForState,
                        isCalledForPriority: $scope.issueBoardForPriority,
                        isCalledForType: $scope.issueBoardForType
                    })
                }
                /*END: UI functions*/

                /*START: Search*/
                $scope.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, isCalledFromInit) {
                    $scope.filterQuery = filterQuery;
                    $scope.sqlQuery = sqlQuery;
                    if (sortQuery) {
                        $scope.sort = $stateParams.sort
                    } else {
                        $scope.sort = '';
                    }
                    if (isCalledFromInit) {
                        $scope.areIssuesLoading = true;
                    }
                    if ($scope.isInitIssue === false) {
                        $scope.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            $scope.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            $scope.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            $scope.fnGetProject({sql: projectSQL}, [], false).then(function(response) {
                                return parsePostgresData(response);
                            });
                        }
                    }
                };
                /*END: Search*/

                /*START: GET Data*/
                $scope.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    var sortString = '';
                    if ($scope.sort) {
                        var sortType = $scope.sort.split(' ')[1];
                        var sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find($scope.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            $scope.project = isFindProject;
                            $scope.fnSetTabName({data: $scope.project.name})
                        } else {
                            $scope.project = {};
                            $scope.fnSetTabName({data: ''})
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find($scope.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            $scope.project = isFindStateParamsProject;
                            $scope.fnSetTabName({data: $scope.project.name})
                        } else {
                            $scope.project = {};
                            $scope.fnSetTabName({data: ''})
                        }
                    } else {
                        $scope.project = $scope.projectsArr[1];
                        $scope.fnSetTabName({data: $scope.project.name})
                    }
                    var tempSQL = _.cloneDeepWith($scope.sqlQuery);
                    if (tempSQL && tempSQL.length) {
                        if (!$scope.sqlQuery.includes('resolved')) {
                            tempSQL += " and data->>'resolved'::boolean = false";
                        }
                    } else {
                        tempSQL += "data->>'resolved'::boolean = false";
                    }
                    if ($scope.project && $scope.project.id === "All") {
                        var tempIndex = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>'projectId'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            $scope.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            $scope.searchFiltersArr.splice(tempIndexForAll, 1);
                            $scope.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if ($scope.project && Object.keys($scope.project).length && $scope.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? " WHERE " + tempSQL.trim() + " and data->>'projectId' = '" + $scope.project.id + "'" : " WHERE data->>'projectId' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY data->>\'' + $scope.sort.split(' ')[0] + '\' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() + " and data->>'projectId' = '" + $scope.project.id + "'" : " WHERE data->>'projectId' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + $scope.sort.split(' ')[0] + '\' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    }
                    $scope.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    $scope.isProjectLoaded = true;
                };

                $scope.fnGetIssues = function (inputObj) {
                    $scope.areIssuesLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var currentTime = moment().unix();
                            res.data.map(function (obj) {
                                obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                                if (obj.createdAt) {
                                    obj.createdDate = $scope.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find($scope.projectsArr, {id: obj.projectId});
                                }
                                if (obj.resolutionDeadlineAt) {
                                    obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                                    obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                                    var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    obj.issueCreateDate = issueCreateDate;
                                    obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    obj.issueDeadline = issueDeadline;
                                    obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (obj.responseDeadlineAt) {
                                    obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                                    obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                                    var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    obj.issueUpdatedDate = issueUpdatedDate;
                                    obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    obj.issueResponseDeadline = issueResponseDeadline;
                                    obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(obj.lastPublicCommentReadBy) && obj.lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(obj.lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    obj.isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    obj.isRead = false;
                                }
                            });
                            $scope.issueResponse = _.cloneDeepWith(res);
                            $scope.totalItems = $scope.issueResponse.data[0] ? $scope.issueResponse.data[0].totalItems : 0;
                            $scope.issuesArr = _.cloneDeepWith($scope.issueResponse.data);
                            $scope.isRefresh = false;
                            $scope.isInitIssue = false;
                            $scope.fnRunAdvanceSearchQuery();
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.areIssuesLoading = false;
                            $scope.isRefresh = false;
                        })
                };

                $scope.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    $scope.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var projects = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (projectObj) {
                                    projects.push(projectObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetProject({sql: sqlString}, projects, true);
                                } else {
                                    $scope.projectsArr = _.cloneDeepWith(projects);
                                    $scope.fnSetSelectedProject();
                                }
                            }, function () {
                                $scope.fnGetProject(inputObj, [], false).then(function(response) {
                                    return parsePostgresData(response);
                                });
                            });
                        });
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnGetProjectIssue = function (projectObj) {
                    $scope.allIssueStatesOrPriority = [];
                    $scope.isProjectLoaded = false;
                    $scope.project = projectObj.id === "All" ? {} : projectObj;
                    $scope.fnSetTabName({data: $scope.project.name ? $scope.project.name : ''});
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', '');
                    }
                    $scope.areIssuesLoading = true;
                    var sortString = '';
                    if ($scope.sort) {
                        var sortType = $scope.sort.split(' ')[1];
                        var sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var tempSQL = _.cloneDeepWith($scope.sqlQuery);
                    if (tempSQL && tempSQL.length) {
                        if (!$scope.sqlQuery.includes('resolved')) {
                            tempSQL += " and data->>'resolved' = 'false'";
                        }
                    } else {
                        tempSQL += 'data->\'resolved\' = \'false\'';
                    }
                    if ($scope.project && $scope.project.id === "All") {
                        var tempIndex = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->'project'->>'id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            $scope.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            $scope.searchFiltersArr.splice(tempIndexForAll, 1);
                            $scope.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if ($scope.project && Object.keys($scope.project).length && $scope.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? " WHERE " + tempSQL.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'id\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() : '';
                            sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'id\' AS rt FROM tracker_issues';
                            sqlString += tempSQL && tempSQL.length ? ' WHERE ' + tempSQL.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    }
                    $scope.projectRelationshipsObj = {};
                    $scope.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    $scope.isProjectLoaded = true;
                };

                $scope.fnRunAdvanceSearchQuery = function () {
                    var whereClause = "";
                    if ($scope.sqlQuery && $scope.sqlQuery.length) {
                        if ($scope.sqlQuery.includes('projectId')) {
                            whereClause = $scope.sqlQuery.trim();
                        } else {
                            whereClause = $scope.sqlQuery.trim() + " AND data->>\'projectId\' = '" + $scope.project.id + "'";
                        }
                    } else {
                        whereClause = "data->>\'projectId\' = '" + $scope.project.id + "'";
                    }
                    var sortString = '';
                    if ($scope.sort) {
                        var sortType = $scope.sort.split(' ')[1];
                        var sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    $scope.advanceSearchData = [];
                    var input = {
                        select: $scope.issueBoardForState ?
                            'tracker_issues.data->\'issueState\'->\'id\' as state_id, COUNT(*) as count' :
                            $scope.issueBoardForPriority ?
                                'tracker_issues.data->\'issuePriority\'->\'id\' as priority_id, COUNT(*) as count' :
                                'tracker_issues.data->\'issueType\'->\'id\' as type_id, COUNT(*) as count',
                        where: whereClause,
                        orderBy: sortString && sortString.length ? sortString : '',
                        limit: '',
                        offset: '',
                        groupBy: $scope.issueBoardForState ?
                            'tracker_issues.data->\'issueState\'->\'id\'' :
                            $scope.issueBoardForPriority ?
                                'tracker_issues.data->\'issuePriority\'->\'id\'' :
                                'tracker_issues.data->\'issueType\'->\'id\''
                    };
                    if (!input.where.includes('resolved')) {
                        if (input.where.length) {
                            input.where = input.where + ' data->\'resolved\' = \'false\'"';
                        } else {
                            input.where = 'data->\'resolved\' = \'false\'"';
                        }
                    }
                    var tempSQL = 'select ' + input.select + ' from tracker_issues where ' + input.where + ' group by ' + input.groupBy;
                    /*if (input.orderBy !== '') {
                        tempSQL += ' order by ' + input.orderBy;
                    }*/
                    QueryFactory.executeQuery({sql: tempSQL}).then(function (res) {
                        return parsePostgresData(res.data).then(function(parsedData) {
                            $scope.advanceSearchData = parsedData;
                            $scope.fnGetStatesOrPriority();
                        });
                    }, function () { // Error block
                    });
                };

                $scope.fnGetStatesOrPriority = function () {
                    if ($scope.projectRelationshipsObj && Object.keys($scope.projectRelationshipsObj).length) {
                        var upstreamProject = "";
                        _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                            if (upstreamProject !== "") {
                                upstreamProject += ", '" + projectId + "'";
                            } else {
                                upstreamProject = "'" + projectId + "'";
                            }
                        });
                        if ($scope.issueBoardForState) {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnCreateBoardData();
                            } else {
                                var issueStatesSQL = "SELECT data FROM tracker_states as states where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])"
                                fnGetAllIssueStates({sql: issueStatesSQL}).then(function(response) {
                                    return parsePostgresData(response);
                                });
                            }
                        } else if ($scope.issueBoardForPriority) {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnCreateBoardData();
                            } else {
                                var issuePrioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])";
                                fnGetAllIssuePriorities({sql: issuePrioritiesSQL}).then(function(response) {
                                    return parsePostgresData(response);
                                });
                            }
                        } else {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnCreateBoardData();
                            } else {
                                var issueTypesSQL = "SELECT * FROM tracker_types as types where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])";
                                fnGetAllIssueTypes({sql: issueTypesSQL}).then(function(response) {
                                    return parsePostgresData(response);
                                });
                            }
                        }
                    } else {
                        var inputObj = {
                            projectId: $scope.project.id
                        };
                        ProjectFactory.describeProjectRelationships(inputObj)
                            .then(function (response) {
                                $scope.projectRelationshipsObj = _.cloneDeepWith(response);
                                var upstreamProject = "";
                                _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                    if (upstreamProject !== "") {
                                        upstreamProject += ", '" + projectId + "'";
                                    } else {
                                        upstreamProject = "'" + projectId + "'";
                                    }
                                });
                                if ($scope.issueBoardForState) {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnCreateBoardData();
                                    } else {
                                        var issueStatesSQL = "SELECT * FROM tracker_states as states where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])";
                                        fnGetAllIssueStates({sql: issueStatesSQL}).then(function(response) {
                                            return parsePostgresData(response);
                                        });
                                    }
                                } else if ($scope.issueBoardForPriority) {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnCreateBoardData();
                                    } else {
                                        var issuePrioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])";
                                        fnGetAllIssuePriorities({sql: issuePrioritiesSQL}).then(function(response) {
                                            return parsePostgresData(response);
                                        });
                                    }
                                } else {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnCreateBoardData();
                                    } else {
                                        var issueTypesSQL = "SELECT * FROM tracker_types as types where data->>'projectId' = ANY(ARRAY[" + upstreamProject + "])";
                                        fnGetAllIssueTypes({sql: issueTypesSQL}).then(function(response) {
                                            return parsePostgresData(response);
                                        });
                                    }
                                }
                            }, function () {
                            });
                    }
                };

                function fnGetAllIssueStates(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = _.cloneDeepWith(res.data);
                            $scope.fnCreateBoardData();
                        }, function () { // Error block
                        })
                }

                function fnGetAllIssuePriorities(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = _.cloneDeepWith(res.data);
                            $scope.fnCreateBoardData();
                        }, function () { // Error block
                        })
                }

                function fnGetAllIssueTypes(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = _.cloneDeepWith(res.data);
                            $scope.fnCreateBoardData();
                        }, function () { // Error block
                        })
                }

                $scope.fnLoadNext = function (key, value) {
                    if (key !== 'unassigned' && !value.isScrollDisabled && value.children.length < value.totalItems) {
                        value.isScrollDisabled = true;
                        if (value.children && value.children.length) {
                            var input = {
                                where: $scope.issueBoardForState ?
                                    "tracker_issues.data->'issueState'->>'id' = '" + key + "'" :
                                    $scope.issueBoardForPriority ?
                                        "tracker_issues.data->'issuePriority'->>'id' = '" + key + "'" :
                                        "tracker_issues.data->'issueType'->>'id' = '" + key + "'"
                            };
                            var resultToken = _.cloneDeepWith(value.children[value.children.length - 1].rt);
                            var sortString = '';
                            var sortType = '';
                            var sortValue = '';
                            if ($scope.sort) {
                                sortType = $scope.sort.split(' ')[1];
                                sortValue = $scope.sort.split(' ')[0];
                                sortString = sortValue + ' ' + sortType;
                            }
                            var tempNextPageWhere = '';
                            if (sortString !== '') {
                                var nextPageComparator = sortType === 'desc' ? '<' : '>';
                                if (/^-?\d+$/.test(resultToken)) {
                                    tempNextPageWhere = ' AND data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + resultToken;
                                } else {
                                    tempNextPageWhere = ' AND data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + "'" + resultToken + "'";
                                }
                            } else {
                                tempNextPageWhere += ' AND data->>\'_id\' > ' + "'" + resultToken + "'";
                            }
                            var sqlString = '';
                            if (sortString !== '') {
                                sqlString = 'SELECT data, data->>\'' + sortValue + '\' AS rt FROM tracker_issues';
                            } else {
                                sqlString = 'SELECT data, data->>\'_id\' AS rt FROM tracker_issues';
                            }
                            var loadNextSQL = sqlString + ' where ' + input.where + tempNextPageWhere + ' limit 100;';
                            QueryFactory.executeQuery({sql: loadNextSQL}).then(function (res) {
                                return parsePostgresData(res.data).then(function(parsedData) {
                                    _.forEach(parsedData, function (resObj) {
                                        var isIssueFound = _.findIndex(value.children, {id: resObj.id});
                                        if (isIssueFound === -1) {
                                            value.children.push(resObj);
                                        }
                                    });
                                    value.isScrollDisabled = false;
                                });
                            }, function () { // Error block
                                value.isScrollDisabled = false;
                            });
                        } else {
                            value.isScrollDisabled = false;
                        }
                    }
                };

                $scope.fnChangeBoardSettings = function (key, value) {
                    value.isCollapsed = !value.isCollapsed;
                    var boardSelection = $scope.issueBoardForState ?
                        UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueStateBoard') :
                        $scope.issueBoardForPriority ?
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issuePriorityBoard') :
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueTypeBoard');
                    if (boardSelection) {
                        if (boardSelection[$scope.project.id] && boardSelection[$scope.project.id].length) {
                            _.forEach(boardSelection[$scope.project.id], function (boardObj) {
                                if (boardObj.id === key) {
                                    boardObj.isCollapsed = value.isCollapsed;
                                }
                            });
                            if ($scope.issueBoardForState) {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                            } else if ($scope.issueBoardForPriority) {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                            } else {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                            }
                        }
                    }
                };

                $scope.fnCreateBoardData = function () {
                    $scope.boardData = {
                        'unassigned': {
                            name: 'Back Log',
                            color: '#63656b',
                            isCollapsed: true,
                            isShow: true,
                            children: []
                        }
                    };
                    var boardSelection = $scope.issueBoardForState ?
                        UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueStateBoard') :
                        $scope.issueBoardForPriority ?
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issuePriorityBoard') :
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueTypeBoard');

                    $scope.allIssueStatesOrPriority = _.orderBy($scope.allIssueStatesOrPriority, ['name'], ['asc']);
                    if (boardSelection && boardSelection[$scope.project.id] && boardSelection[$scope.project.id].length) {
                        var tempDataArr = [];
                        _.forEach(boardSelection[$scope.project.id], function (boardObj) {
                            if (boardObj.id !== 'unassigned' && boardObj.isShow) {
                                _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                                    if (selectedProjectState.id === boardObj.id) {
                                        $scope.boardData[boardObj.id] = {
                                            name: selectedProjectState.name,
                                            color: selectedProjectState.color,
                                            isCollapsed: boardObj.isCollapsed,
                                            isShow: boardObj.isShow,
                                            children: []
                                        };
                                        if ($scope.issueBoardForState) {
                                            $scope.boardData[boardObj.id].resolved = selectedProjectState.resolved;
                                            $scope.boardData[boardObj.id].archived = selectedProjectState.archived;
                                        }
                                        tempDataArr.push({
                                            id: boardObj.id,
                                            isCollapsed: boardObj.isCollapsed,
                                            isShow: boardObj.isShow
                                        });
                                    }
                                })
                            } else {
                                tempDataArr.push({
                                    id: boardObj.id,
                                    isCollapsed: boardObj.isCollapsed,
                                    isShow: boardObj.isShow
                                });
                            }
                        });
                        _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                            var isFind = _.find(boardSelection[$scope.project.id], {id: selectedProjectState.id});
                            if (!isFind) {
                                $scope.boardData[selectedProjectState.id] = {
                                    name: selectedProjectState.name,
                                    color: selectedProjectState.color,
                                    isCollapsed: true,
                                    isShow: true,
                                    children: []
                                };
                                if ($scope.issueBoardForState) {
                                    $scope.boardData[selectedProjectState.id].resolved = selectedProjectState.resolved;
                                    $scope.boardData[selectedProjectState.id].archived = selectedProjectState.archived;
                                }
                                tempDataArr.push({
                                    id: selectedProjectState.id,
                                    isCollapsed: true,
                                    isShow: true
                                });
                            }
                        });
                        boardSelection[$scope.project.id] = tempDataArr;
                        if ($scope.issueBoardForState) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                        } else if ($scope.issueBoardForPriority) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                        } else {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                        }
                    } else {
                        if (boardSelection === '') {
                            boardSelection = {};
                        } else if (!boardSelection[$scope.project.id]) {
                            boardSelection[$scope.project.id] = [];
                        }
                        var tempStateArr = [];
                        $scope.boardData = {
                            'unassigned': {
                                name: 'Back Log',
                                color: '#63656b',
                                isCollapsed: true,
                                isShow: true,
                                children: []
                            }
                        };
                        _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                            tempStateArr.push({
                                id: selectedProjectState.id,
                                isCollapsed: true,
                                isShow: true
                            });
                            $scope.boardData[selectedProjectState.id] = {
                                name: selectedProjectState.name,
                                color: selectedProjectState.color,
                                isCollapsed: true,
                                isShow: true,
                                children: []
                            };
                            if ($scope.issueBoardForState) {
                                $scope.boardData[selectedProjectState.id].resolved = selectedProjectState.resolved;
                                $scope.boardData[selectedProjectState.id].archived = selectedProjectState.archived;
                            }
                        });
                        boardSelection[$scope.project.id] = tempStateArr;
                        if ($scope.issueBoardForState) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                        } else if ($scope.issueBoardForPriority) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                        } else {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                        }
                    }
                    _.forEach($scope.issuesArr, function (issueObj) {
                        if ($scope.issueBoardForState) {
                            if (issueObj.issueState && issueObj.issueState.id) {
                                if (!$scope.boardData[issueObj.issueState.id]) {
                                    $scope.boardData[issueObj.issueState.id] = {
                                        name: issueObj.issueState.name,
                                        color: issueObj.issueState.color,
                                        isCollapsed: true,
                                        isShow: true,
                                        archived: issueObj.issueState.archived,
                                        resolved: issueObj.issueState.resolved,
                                        children: []
                                    }
                                }
                                $scope.boardData[issueObj.issueState.id].children.push(issueObj);
                            } else {
                                $scope.boardData.unassigned.children.push(issueObj);
                            }
                        } else if ($scope.issueBoardForPriority) {
                            if (issueObj.issuePriority && issueObj.issuePriority.id) {
                                if (!$scope.boardData[issueObj.issuePriority.id]) {
                                    $scope.boardData[issueObj.issuePriority.id] = {
                                        name: issueObj.issuePriority.name,
                                        color: issueObj.issuePriority.color,
                                        isCollapsed: true,
                                        isShow: true,
                                        children: []
                                    }
                                }
                                $scope.boardData[issueObj.issuePriority.id].children.push(issueObj);
                            } else {
                                $scope.boardData.unassigned.children.push(issueObj);
                            }
                        } else {
                            if (issueObj.issueType && issueObj.issueType.id) {
                                if (!$scope.boardData[issueObj.issueType.id]) {
                                    $scope.boardData[issueObj.issueType.id] = {
                                        name: issueObj.issueType.name,
                                        color: issueObj.issueType.color,
                                        isCollapsed: true,
                                        isShow: true,
                                        children: []
                                    }
                                }
                                $scope.boardData[issueObj.issueType.id].children.push(issueObj);
                            } else {
                                $scope.boardData.unassigned.children.push(issueObj);
                            }
                        }
                    });

                    _.forEach($scope.advanceSearchData, function (advanceObj) {
                        if ($scope.issueBoardForState) {
                            if (advanceObj && advanceObj.issueState && $scope.boardData[advanceObj.issueState.id]
                                && advanceObj.issueState.name === $scope.boardData[advanceObj.issueState.id].name) {
                                $scope.boardData[advanceObj.issueState.id].totalItems = advanceObj.count;
                            }
                        } else if ($scope.issueBoardForPriority) {
                            if (advanceObj && advanceObj.issuePriority && $scope.boardData[advanceObj.issuePriority.id]
                                && advanceObj.issuePriority.name === $scope.boardData[advanceObj.issuePriority.id].name) {
                                $scope.boardData[advanceObj.issuePriority.id].totalItems = advanceObj.count;
                            }
                        } else {
                            if (advanceObj && advanceObj.issueType && $scope.boardData[advanceObj.issueType.id]
                                && advanceObj.issueType.name === $scope.boardData[advanceObj.issueType.id].name) {
                                $scope.boardData[advanceObj.issueType.id].totalItems = advanceObj.count;
                            }
                        }
                    });
                    $scope.areIssuesLoading = false;
                    $scope.isRefresh = false;
                };
                /*END: GET Data*/

                $scope.fnAddUpDownVoteToIssue = function (isUpVote, issueObj) {
                    if (isUpVote && !$scope.userPermissionsObj.UP_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote an Issue.');
                        return;
                    } else if (!isUpVote && !$scope.userPermissionsObj.DOWN_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote an Issue.');
                        return;
                    }
                    issueObj.isVoteUpdating = true;
                    issueObj.voteCount = issueObj.voteCount ? issueObj.voteCount : 0;
                    var input = {
                        issueId: issueObj.id
                    };
                    if (isUpVote) {
                        IssueFactory.upVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdating;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(res.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        IssueFactory.downVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdating;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(res.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                $scope.fnReload = function () {
                    $scope.isRefresh = true;
                    $scope.isRefreshData = false;
                    $scope.isInitIssue = true;
                    // vm.fnGenerateChartData();
                    $timeout(function () {
                        $scope.isRefreshData = true;
                    }, 10)
                };

                $scope.fnOrderFiltersArr = function () {
                    var tempArr = FiltersArrOrder.map(function (i) {
                        return $scope.searchFiltersArr.find(function (o) {
                            return o.displayName === i;
                        });
                    });
                    $scope.searchFiltersArr = _.filter(tempArr, function (tempObj) {
                        return angular.isObject(tempObj);
                    });
                };

                $scope.fnGetAssignee = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var users = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (userObj) {
                                    users.push({
                                        id: userObj.id,
                                        firstName: userObj.firstName,
                                        lastName: userObj.lastName,
                                        fullName: userObj.firstName + ' ' + userObj.lastName,
                                        email: userObj.email,
                                        userAvatar: angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                    });
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (users[0] && users[0].totalItems > users.length)) {
                                    var sqlString = 'SELECT data, data->>\'_id\' AS rt FROM access_users';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetAssignee({sql: sqlString}, users, true);
                                } else {
                                    $scope.assigneeArr = _.cloneDeepWith(users);
                                    $timeout(function () {
                                        $scope.searchFiltersArr.push(
                                            {
                                                displayName: "Assignee",
                                                name: tableName + ".data->>'assignees'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'assignees',
                                                    key: 'email'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: $scope.assigneeArr,
                                                displayKeyName: 'fullName',
                                                isShowId: true,
                                                isShowUserAvatar: true,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'email'
                                            }
                                        );
                                        $scope.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                $scope.fnGetTypes = function (inputObj, preDefinedIssueTypes, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var types = isCalledForViz ? preDefinedIssueTypes : [];
                                _.forEach(parsedData, function (typeObj) {
                                    types.push(typeObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (types[0] && types[0].totalItems > types.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + types[types.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetTypes({sql: sqlString}, types, true);
                                } else {
                                    $scope.issueTypesArr = _.cloneDeepWith(types);
                                    $timeout(function () {
                                        $scope.searchFiltersArr.push(
                                            {
                                                displayName: "Type",
                                                name: tableName + ".data->\'issueType\'->>\'id\'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueType',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: $scope.issueTypesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        $scope.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                $scope.fnGetPriorities = function (inputObj, preDefinedIssuePriorities, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var priorities = isCalledForViz ? preDefinedIssuePriorities : [];
                                _.forEach(parsedData, function (priorityObj) {
                                    priorities.push(priorityObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (priorities[0] && priorities[0].totalItems > priorities.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + priorities[priorities.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetPriorities({sql: sqlString}, priorities, true);
                                } else {
                                    $scope.issuePrioritiesArr = _.cloneDeepWith(priorities);
                                    $timeout(function () {
                                        $scope.searchFiltersArr.push(
                                            {
                                                displayName: "Priority",
                                                name: tableName + ".data->\'issuePriority\'->>\'id\'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issuePriority',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: $scope.issuePrioritiesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        $scope.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                $scope.fnGetStates = function (inputObj, preDefinedIssueStates, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var states = isCalledForViz ? preDefinedIssueStates : [];
                                _.forEach(parsedData, function (stateObj) {
                                    states.push(stateObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (states[0] && states[0].totalItems > states.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + states[states.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetStates({sql: sqlString}, states, true);
                                } else {
                                    $scope.issueStatesArr = _.cloneDeepWith(states);
                                    $timeout(function () {
                                        $scope.searchFiltersArr.push(
                                            {
                                                displayName: "Status",
                                                name: tableName + ".data->\'issueState\'->>\'id\'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueState',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: $scope.issueStatesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        $scope.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                $scope.fnGetIssueLabels = function (inputObj, preDefinedIssueLabels, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var labels = isCalledForViz ? preDefinedIssueLabels : [];
                                _.forEach(parsedData, function (labelObj) {
                                    labels.push(labelObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (labels[0] && labels[0].totalItems > labels.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + labels[labels.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    $scope.fnGetIssueLabels({sql: sqlString}, labels, true);
                                } else {
                                    $scope.issueLabelsArr = _.cloneDeepWith(labels);
                                    $timeout(function () {
                                        $scope.searchFiltersArr.push(
                                            {
                                                displayName: "Label",
                                                name: tableName + ".data->'issueLabels'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'issueLabels',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: $scope.issueLabelsArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        $scope.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                $scope.fnInitBoards = function () {
                    var assigneeSQL = 'SELECT data, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users ORDER BY rt asc LIMIT ' + 100 + ';';
                    $scope.fnGetAssignee({sql: assigneeSQL}, [], false).then(function(response) {
                        return parsePostgresData(response);
                    });
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issueTypesArr').length !== 0) {
                        $scope.issueTypesArr = _.cloneDeepWith(AppInitService.getInitData('issueTypesArr'));
                        $timeout(function () {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Type",
                                    name: tableName + ".data->\'issueType\'->>\'id\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueType',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.issueTypesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            $scope.fnOrderFiltersArr();
                        });
                    } else {
                        var typeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_types ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetTypes({sql: typeSQL}, [], false);
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issuePrioritiesArr').length !== 0) {
                        $scope.issuePrioritiesArr = _.cloneDeepWith(AppInitService.getInitData('issuePrioritiesArr'));
                        $timeout(function () {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Priority",
                                    name: tableName + ".data->'issuePriority'->>'id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issuePriority',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.issuePrioritiesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            $scope.fnOrderFiltersArr();
                        });
                    } else {
                        var prioritiesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_priorities ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetPriorities({sql: prioritiesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issueStatesArr').length !== 0) {
                        $scope.issueStatesArr = _.cloneDeepWith(AppInitService.getInitData('issueStatesArr'));
                        $timeout(function () {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Status",
                                    name: tableName + ".data->'issueState'->>'id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueState',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.issueStatesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            $scope.fnOrderFiltersArr();
                        });
                    } else {
                        var statesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_states ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetStates({sql: statesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    var labelsSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_labels ORDER BY rt asc LIMIT ' + 100 + ';';
                    $scope.fnGetIssueLabels({sql: labelsSQL}, [], false).then(function(response) {
                        return parsePostgresData(response);
                    });
                }
                $scope.fnInitBoards();
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('issueAssigneeLabelSideBar', fnIssueAssigneeLabelSideBar)

    /** @ngInject */
    function fnIssueAssigneeLabelSideBar($rootScope, $timeout, $state, $uibModal, swal, amaran, microSpinner, PermissionsService, DB, AvatarService,
                                         ColorService, IssueFactory, LabelFactory, CommentFactory, UserFactory, TypesFactory, PriorityFactory, TrackerStateFactory,
                                         ProjectFactory, AppInitService, EmailFactory, BatchFactory, QueryFactory, UserProfileService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/issue/directives/issueAssigneeLabelSideBar/issueAssigneeLabelSideBar.html',
            scope: {
                issueObj: '=',
                userPermissionsObj: '=',
                isExpanded: "="
            },
            link: function ($scope) {
                $scope.filter = "$";
                $scope.labelSearch = {$: ''};

                /*Assignee: START*/
                $scope.usersArr = [{
                    username: 'assign to me'
                }];
                $scope.isIssueAssigneeLoaded = false;
                $scope.changeAssigneeView = false;
                $scope.isAssigneeChanged = true;
                $scope.selectedUser = {};
                /*Assignee: END*/

                /*Type: START*/
                $scope.typesArr = [];
                $scope.isIssueTypeLoaded = false;
                $scope.changeTypeView = false;
                $scope.isTypeChanged = true;
                $scope.selectedType = {};
                /*Type: END*/

                /*Labels: START*/
                $scope.labelsArr = [];
                $scope.isIssueLablesLoaded = false;
                $scope.addLabelView = false;
                $scope.isLabelsAdded = true;
                $scope.selectedLabelsArr = [];
                $scope.selectedLabel = {};
                /*Labels: END*/


                /*Priority: START*/
                $scope.prioritiesArr = [];
                $scope.isIssuePriorityLoaded = false;
                $scope.changePriorityView = false;
                $scope.isPriorityChanged = true;
                $scope.selectedPriority = {};
                /*Priority: END*/

                /*State: START*/
                $scope.statesArr = [];
                $scope.isIssueStateLoaded = false;
                $scope.changeStateView = false;
                $scope.isStateChanged = true;
                $scope.selectedState = {};
                /*State: END*/

                /*Participant: START*/
                $scope.participantsArr = [];
                $scope.isIssueParticipantLoaded = false;
                $scope.changeParticipantView = false;
                $scope.isParticipantChanged = true;
                $scope.selectedParticipant = {};
                /*Participant: END*/

                /*Project: START*/
                $scope.projectsArr = [];
                $scope.isIssueProjectLoaded = false;
                $scope.changeProjectView = false;
                $scope.isProjectChanged = true;
                $scope.selectedProject = {};
                /*Project: END*/


                /*Confidential: START*/
                $scope.confidentialsArr = [{'name': "Confidential", 'value': true}, {
                    'name': "Not Confidential",
                    'value': false
                }];
                $scope.isIssueConfidentialLoaded = false;
                $scope.changeConfidentialView = false;
                $scope.isConfidentialChanged = true;
                $scope.selectedConfidential = {};
                /*Confidential: END*/

                $scope.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                /*Assignee: START*/
                $scope.addAssigneeArr = [];
                $scope.deleteAssigneeArr = [];
                $scope.usersArr = [];
                $scope.teamsArr = [];
                $scope.fnGetUsers = function (inputObj) {
                    ProjectFactory.listPossibleProjectAssignees(inputObj)
                        .then(function (response) {
                            var teamsSQL = "SELECT * from access_teams where "
                            _.forEach(response, function (userObj, index) {
                                userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                                if (index === (response.length - 1)) {
                                    teamsSQL += " data->'userIds' @> '[" + userObj.id + "]'"
                                } else {
                                    teamsSQL += " data->'userIds' @> '[" + userObj.id + "]' or "
                                }
                            });
                            $scope.usersArr = _.unionBy($scope.issueObj.assignees, response, 'id');
                            $scope.usersArr.sort(function (a, b) {
                                if (a.firstName < b.firstName) {
                                    return -1;
                                }
                                if (a.firstName > b.firstName) {
                                    return 1;
                                }
                                return 0;
                            });
                            if (response && response.length && $scope.usersArr && $scope.usersArr.length && ($scope.loginUser.administrator === true || $scope.loginUser.accountOwner === true)) {
                                $scope.fnGetUsersTeams({'sql': teamsSQL});
                            }
                            $scope.isIssueAssigneeLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIssueAssigneeLoaded = true;
                        })
                };

                $scope.fnGetUsersTeams = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (response) {
                            var userArr = [];
                            $scope.teamsArr = _.cloneDeepWith(response.data);
                            var sql = "SELECT * from access_users where data->>\'id\' IN ("
                            _.forEach(response.data, function (teamObj) {
                                userArr = userArr.concat(teamObj.userIds)
                            });
                            var newUserArr = _.uniq(userArr);
                            _.forEach(newUserArr, function (userObj, index) {
                                if (index === (newUserArr.length - 1)) {
                                    sql += "'" + userObj + "')";
                                } else {
                                    sql += "'" + userObj + "', ";
                                }
                            });
                            $scope.fnGetTeamUsers({sql: sql});
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.fnGetTeamUsers = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (response) {
                            $scope.teamUserData = response.data;
                            _.forEach($scope.teamsArr, function (teamObj) {
                                teamObj.userArr = [];
                                _.forEach(teamObj.userIds, function (userId) {
                                    var isFind = _.find($scope.teamUserData, {'id': userId});
                                    if (isFind) {
                                        isFind.userAvatar = angular.isDefined(isFind) ? AvatarService.getTextAvatar(isFind) : 'assets/images/svg/logo_color.svg';
                                        teamObj.userArr.push(_.cloneDeepWith(isFind));
                                        var isFindUser = _.find($scope.usersArr, {'id': userId});
                                        if (!isFindUser) {
                                            $scope.usersArr.push(_.cloneDeepWith(isFind));
                                        }
                                    }
                                })
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.fnGetTeamInfo = function (teamObj) {
                    _.forEach(teamObj.userArr, function (userObj) {
                        var isFind = _.find($scope.issueObj.assignees, {'id': userObj.id});
                        if (!isFind) {
                            var isFindInUserArr = _.find($scope.usersArr, {'id': userObj.id});
                            if (isFindInUserArr) {
                                $scope.fnGetAssigneeInfo(isFindInUserArr);
                            }
                        }
                    });
                    $scope.fnCancelChangeAssignee();
                }

                $scope.fnGetAssigneeInfo = function (assigneeObj) {
                    if (assigneeObj.isCheck) {
                        if ($scope.userPermissionsObj.REMOVE_ASSIGNEE_FROM_ISSUE) {
                            assigneeObj.isCheck = false;
                            var isFindAssignee = _.find($scope.assigneesAssignees, {id: assigneeObj.id});
                            if (isFindAssignee) {
                                $scope.deleteAssigneeArr.push(isFindAssignee);
                            } else {
                                var isFindAssigneeInAddAssigneeArr = _.findIndex($scope.addAssigneeArr, {id: assigneeObj.id});
                                if (isFindAssigneeInAddAssigneeArr !== 1) {
                                    $scope.addAssigneeArr.splice(isFindAssigneeInAddAssigneeArr, 1);
                                }
                            }
                        } else {
                            amaran.error('Sorry, Looks like you do not have permission to remove an assignee')
                        }
                    } else {
                        if ($scope.userPermissionsObj.ADD_ASSIGNEE_TO_ISSUE) {
                            assigneeObj.isCheck = true;
                            var isFindAssigneesAssignee = _.find($scope.assigneesAssignees, {id: assigneeObj.id});
                            if (!isFindAssigneesAssignee) {
                                $scope.addAssigneeArr.push(assigneeObj);
                            } else {
                                var isFindDeleteAssignee = _.findIndex($scope.deleteAssigneeArr, {id: assigneeObj.id});
                                if (isFindDeleteAssignee !== -1) {
                                    $scope.deleteAssigneeArr.splice(isFindDeleteAssignee, 1);
                                }
                            }
                        } else {
                            amaran.error('Sorry, Looks like you do not have permission to add an assignee')
                        }
                    }
                };

                $scope.fnCancelChangeAssignee = function () {
                    $scope.selectedAssignee = {};
                    $scope.changeAssigneeView = false;
                    if ($scope.deleteAssigneeArr.length || $scope.addAssigneeArr.length) {
                        $scope.fnUpdateIssueAssignee();
                    }
                };

                $scope.fnOnToggleAssignee = function (isOpen) {
                    if (isOpen === false && ($scope.deleteAssigneeArr.length || $scope.addAssigneeArr.length)) {
                        $scope.fnUpdateIssueAssignee();
                    } else {
                        $scope.changeAssigneeView = false;
                        $scope.selectedAssignee = {};
                    }
                };

                $scope.fnUpdateIssueAssignee = function () {
                    $scope.isIssueAssigneeLoaded = false;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    var assigneeIndex = 0;

                    angular.forEach($scope.addAssigneeArr, function (assigneeObj) {
                        if (assigneeIndex <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = assigneeIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/assignees/" + assigneeObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = assigneeIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/assignees/" + assigneeObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        assigneeIndex++;
                    });

                    angular.forEach($scope.deleteAssigneeArr, function (assigneeObj) {
                        if (assigneeIndex <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = assigneeIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/assignees/" + assigneeObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = assigneeIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/assignees/" + assigneeObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        assigneeIndex++;
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        count = 1;
                        $scope.fnBatchOperationAssignee(batchCollectionObj, count);
                    }
                    $scope.selectedAssignee = {};
                    $scope.changeAssigneeView = false;
                };

                $scope.fnBatchOperationAssignee = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker',
                        parallel: false
                    }).then(function (response) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            $scope.fnBatchOperationAssignee(batchCollectionObj, count);
                        } else {
                            if (response[response.length - 1].body && response[response.length - 1].body.assignees) {
                                $scope.issueObj.assignees = response[response.length - 1].body.assignees;
                                _.forEach($scope.issueObj.assignees, function (userObj) {
                                    userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                });
                                $scope.assigneesAssignees = _.cloneDeepWith($scope.issueObj.assignees);
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            } else {
                                $scope.issueObj.assignees = [];
                                _.forEach($scope.issueObj.assignees, function (userObj) {
                                    userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                });
                                $scope.assigneesAssignees = _.cloneDeepWith($scope.issueObj.assignees);
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            }
                            $scope.deleteAssigneeArr = [];
                            $scope.addAssigneeArr = [];
                            $scope.isIssueAssigneeLoaded = true;
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            $scope.fnBatchOperationAssignee(batchCollectionObj, count);
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                            $scope.isIssueAssigneeLoaded = true;
                        }
                    });
                };

                $scope.fnOpenChangeAssigneeView = function () {
                    $scope.changeAssigneeView = true;
                    _.forEach($scope.assigneesAssignees, function (issueAssigneeObj) {
                        var isFindAssignee = _.find($scope.usersArr, {id: issueAssigneeObj.id});
                        isFindAssignee.isCheck = !!isFindAssignee;
                    });
                };

                $scope.fnManageAssignees = function () {
                    $state.go("main.users");
                };
                /*Assignee: END*/

                /*Type: START*/
                $scope.addTypeArr = [];
                $scope.deleteTypeArr = [];
                $scope.fnGetTypes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.typesArr = _.cloneDeepWith(response.data);
                            _.forEach($scope.typesArr, function (typeObj) {
                                typeObj.isCheck = !!($scope.assigneesType && $scope.assigneesType.id && typeObj.id === $scope.assigneesType.id);
                            });
                            $scope.isIssueTypeLoaded = true;
                        }, function () {
                            $scope.isIssueTypeLoaded = true;
                        })
                };

                $scope.fnGetTypeInfo = function (typeObj) {
                    if (typeObj.isCheck && !$scope.userPermissionsObj.REMOVE_ISSUE_TYPE) {
                        amaran.error('Sorry, Looks Like you do not have permission to remove a type.');
                        return;
                    } else if (!typeObj.isCheck && !$scope.userPermissionsObj.UPDATE_ISSUE_TYPE) {
                        amaran.error('Sorry, Looks Like you do not have permission to update a type.');
                        return;
                    }
                    _.forEach($scope.typesArr, function (type) {
                        if (typeObj.id !== type.id) {
                            type.isCheck = false;
                        }
                    });
                    typeObj.isCheck = !typeObj.isCheck;
                    $scope.deleteTypeArr = [];
                    $scope.addTypeArr = [];
                    var isFindCheck = _.find($scope.typesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined($scope.assigneesType.id)) {
                            if ($scope.assigneesType.id !== isFindCheck.id) {
                                $scope.addTypeArr = [typeObj];
                            }
                        } else {
                            $scope.addTypeArr = [typeObj];
                        }
                    } else {
                        if (angular.isDefined($scope.assigneesType.id)) {
                            if ($scope.assigneesType.id === typeObj.id) {
                                $scope.deleteTypeArr = [$scope.assigneesType];
                            }
                        }

                    }
                };

                $scope.fnCancelChangeType = function () {
                    $scope.selectedType = {};
                    $scope.changeTypeView = false;
                    if ($scope.deleteTypeArr.length || $scope.addTypeArr.length) {
                        $scope.fnUpdateIssueType();
                    }
                };

                $scope.fnOnToggleType = function (isOpen) {
                    if (isOpen === false && ($scope.deleteTypeArr.length || $scope.addTypeArr.length)) {
                        $scope.fnUpdateIssueType();
                    } else {
                        $scope.changeTypeView = false;
                        $scope.selectedType = {};
                    }
                };

                $scope.fnUpdateIssueType = function () {
                    $scope.isIssueTypeLoaded = false;
                    if ($scope.deleteTypeArr.length) {
                        IssueFactory.removeIssueType({"issueId": $scope.issueObj.id})
                            .then(function (response) {
                                $scope.issueObj.issueType = response.issueType;
                                $scope.assigneesType = angular.isDefined($scope.issueObj.issueType) ? _.cloneDeepWith($scope.issueObj.issueType) : {};
                                _.forEach($scope.typesArr, function (typeObj) {
                                    typeObj.isCheck = !!($scope.assigneesType && $scope.assigneesType.id && typeObj.id === $scope.assigneesType.id);
                                });
                                $scope.changeTypeView = false;
                                $scope.isIssueTypeLoaded = true;
                                $scope.deleteTypeArr = [];
                                $scope.addTypeArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changeTypeView = false;
                                $scope.isIssueTypeLoaded = true;
                                $scope.deleteTypeArr = [];
                                $scope.addTypeArr = [];
                            })
                    } else {
                        var inputObj = {
                            "issueId": $scope.issueObj.id,
                            "typeId": $scope.addTypeArr[0].id
                        };
                        IssueFactory.modifyType(inputObj)
                            .then(function (response) {
                                $scope.issueObj.issueType = response.issueType;
                                $scope.assigneesType = _.cloneDeepWith(response.issueType);
                                _.forEach($scope.typesArr, function (typeObj) {
                                    typeObj.isCheck = !!($scope.assigneesType && $scope.assigneesType.id && typeObj.id === $scope.assigneesType.id);
                                });
                                $scope.changeTypeView = false;
                                $scope.isIssueTypeLoaded = true;
                                $scope.deleteTypeArr = [];
                                $scope.addTypeArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changeTypeView = false;
                                $scope.isIssueTypeLoaded = true;
                                $scope.deleteTypeArr = [];
                                $scope.addTypeArr = [];
                            })
                    }
                    $scope.selectedType = {};
                    $scope.changeTypeView = false;
                };

                $scope.fnOpenChangeTypeView = function () {
                    $scope.changeTypeView = true;
                    _.forEach($scope.typesArr, function (typeObj) {
                        typeObj.isCheck = !!($scope.assigneesType && $scope.assigneesType.id && typeObj.id === $scope.assigneesType.id);
                    });
                };

                $scope.fnManageProjectTypes = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.issueObj.project.id,
                        "displaySearchText": $scope.issueObj.project.name
                    }];
                    $state.go("main.types", {filter: angular.toJson(inputObj)});
                };

                /*Type: END*/

                /*Priority: START*/
                $scope.addPrioritiesArr = [];
                $scope.deletePrioritiesArr = [];
                $scope.fnGetPriorities = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.prioritiesArr = _.cloneDeepWith(response.data);
                            _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                                prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                            });
                            $scope.isIssuePriorityLoaded = true;
                        }, function () {
                            $scope.isIssuePriorityLoaded = true;
                        })
                };

                $scope.fnGetPrioritiesInfo = function (prioritiesObj) {
                    if (prioritiesObj.isCheck && !$scope.userPermissionsObj.REMOVE_ISSUE_PRIORITY) {
                        amaran.error('Sorry, Looks Like you do not have permission to remove a priority.');
                        return;
                    } else if (!prioritiesObj.isCheck && !$scope.userPermissionsObj.UPDATE_ISSUE_PRIORITY) {
                        amaran.error('Sorry, Looks Like you do not have permission to update a priority.');
                        return;
                    }
                    _.forEach($scope.prioritiesArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    $scope.deletePrioritiesArr = [];
                    $scope.addPrioritiesArr = [];
                    var isFindCheck = _.find($scope.prioritiesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined($scope.assigneesPriorities.id)) {
                            if ($scope.assigneesPriorities.id !== isFindCheck.id) {
                                $scope.addPrioritiesArr = [prioritiesObj];
                            }
                        } else {
                            $scope.addPrioritiesArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined($scope.assigneesPriorities.id)) {
                            if ($scope.assigneesPriorities.id === prioritiesObj.id) {
                                $scope.deletePrioritiesArr = [$scope.assigneesPriorities];
                            }
                        }

                    }
                };

                $scope.fnCancelChangePriority = function () {
                    $scope.selectedType = {};
                    $scope.changePriorityView = false;
                    if ($scope.deletePrioritiesArr.length || $scope.addPrioritiesArr.length) {
                        $scope.fnUpdateIssuePriority();
                    }
                };

                $scope.fnOnTogglePriority = function (isOpen) {
                    if (isOpen === false && ($scope.deletePrioritiesArr.length || $scope.addPrioritiesArr.length)) {
                        $scope.fnUpdateIssuePriority();
                    } else {
                        $scope.changePriorityView = false;
                        $scope.selectedPriority = {};
                    }
                };

                $scope.fnUpdateIssuePriority = function () {
                    $scope.isIssuePriorityLoaded = false;
                    if ($scope.deletePrioritiesArr.length) {
                        IssueFactory.removeIssuePriority({"issueId": $scope.issueObj.id})
                            .then(function (response) {
                                $scope.issueObj.issuePriority = response.issuePriority;
                                $scope.assigneesPriorities = angular.isDefined($scope.issueObj.issuePriority) ? _.cloneDeepWith($scope.issueObj.issuePriority) : {};
                                _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                                    prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                                });
                                $scope.changePriorityView = false;
                                $scope.isIssuePriorityLoaded = true;
                                $scope.deletePrioritiesArr = [];
                                $scope.addPrioritiesArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changePriorityView = false;
                                $scope.isIssuePriorityLoaded = true;
                                $scope.deletePrioritiesArr = [];
                                $scope.addPrioritiesArr = [];
                            })
                    } else {
                        var inputObj = {
                            "issueId": $scope.issueObj.id,
                            "priorityId": $scope.addPrioritiesArr[0].id
                        };
                        IssueFactory.modifyPriority(inputObj)
                            .then(function (response) {
                                $scope.issueObj.issuePriority = response.issuePriority;
                                $scope.assigneesPriorities = angular.isDefined($scope.issueObj.issuePriority) ? _.cloneDeepWith($scope.issueObj.issuePriority) : {};
                                _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                                    prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                                });
                                $scope.changePriorityView = false;
                                $scope.isIssuePriorityLoaded = true;
                                $scope.deletePrioritiesArr = [];
                                $scope.addPrioritiesArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changePriorityView = false;
                                $scope.isIssuePriorityLoaded = true;
                                $scope.deletePrioritiesArr = [];
                                $scope.addPrioritiesArr = [];
                            })
                    }
                    $scope.selectedPriority = {};
                    $scope.changePriorityView = false;
                };

                $scope.fnOpenChangePriorityView = function () {
                    $scope.changePriorityView = true;
                    _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                        prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                    });
                };

                $scope.fnManageProjectPriority = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.issueObj.project.id,
                        "displaySearchText": $scope.issueObj.project.name
                    }];
                    $state.go("main.priorities", {filter: angular.toJson(inputObj)});
                };

                /*Priority: END*/

                /*State: START*/
                $scope.addStatesArr = [];
                $scope.deleteStatesArr = [];
                $scope.fnGetStates = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.statesArr = _.cloneDeepWith(response.data);
                            _.forEach($scope.statesArr, function (statesObj) {
                                statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                            });
                            $scope.isIssueStateLoaded = true;
                        }, function () {
                            $scope.isIssueStateLoaded = true;
                        })
                };

                $scope.fnGetStatesInfo = function (statesObj) {
                    if (statesObj.isCheck && !$scope.userPermissionsObj.REMOVE_ISSUE_STATE) {
                        amaran.error('Sorry, Looks Like you do not have permission to remove a state.');
                        return;
                    } else if (!statesObj.isCheck && !$scope.userPermissionsObj.UPDATE_ISSUE_TYPE) {
                        amaran.error('Sorry, Looks Like you do not have permission to update a state.');
                        return;
                    }
                    _.forEach($scope.statesArr, function (states) {
                        if (statesObj.id !== states.id) {
                            states.isCheck = false;
                        }
                    });
                    statesObj.isCheck = !statesObj.isCheck;
                    $scope.deleteStatesArr = [];
                    $scope.addStatesArr = [];
                    var isFindCheck = _.find($scope.statesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined($scope.assigneesState.id)) {
                            if ($scope.assigneesState.id !== isFindCheck.id) {
                                $scope.addStatesArr = [statesObj];
                            }
                        } else {
                            $scope.addStatesArr = [statesObj];
                        }
                    } else {
                        if (angular.isDefined($scope.assigneesState.id)) {
                            if ($scope.assigneesState.id === statesObj.id) {
                                $scope.deleteStatesArr = [$scope.assigneesState];
                            }
                        }
                    }
                };

                $scope.fnCancelChangeState = function () {
                    $scope.selectedState = {};
                    $scope.changeStateView = false;
                    if ($scope.deleteStatesArr.length || $scope.addStatesArr.length) {
                        $scope.fnUpdateIssueState();
                    }
                };

                $scope.fnOnToggleState = function (isOpen) {
                    if (isOpen === false && ($scope.deleteStatesArr.length || $scope.addStatesArr.length)) {
                        $scope.fnUpdateIssueState();
                    } else {
                        $scope.changeStateView = false;
                        $scope.selectedState = {};
                    }
                };

                $scope.fnUpdateIssueState = function () {
                    $scope.isIssueStateLoaded = false;
                    if ($scope.deleteStatesArr.length) {
                        IssueFactory.removeIssueState({"issueId": $scope.issueObj.id})
                            .then(function (response) {
                                $scope.issueObj.issueState = response.issueState;
                                $scope.assigneesState = angular.isDefined($scope.issueObj.issueState) ? _.cloneDeepWith($scope.issueObj.issueState) : {};
                                _.forEach($scope.statesArr, function (statesObj) {
                                    statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                                });
                                $scope.changeStateView = false;
                                $scope.isIssueStateLoaded = true;
                                $scope.deleteStatesArr = [];
                                $scope.addStatesArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changeStateView = false;
                                $scope.isIssueStateLoaded = true;
                                $scope.deleteStatesArr = [];
                                $scope.addStatesArr = [];
                            })
                    } else {
                        var inputObj = {
                            "issueId": $scope.issueObj.id,
                            "stateId": $scope.addStatesArr[0].id
                        };
                        IssueFactory.modifyState(inputObj)
                            .then(function (response) {
                                $scope.issueObj.issueState = response.issueState;
                                $scope.assigneesState = angular.isDefined($scope.issueObj.issueState) ? _.cloneDeepWith($scope.issueObj.issueState) : {};
                                _.forEach($scope.statesArr, function (statesObj) {
                                    statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                                });
                                $scope.changeStateView = false;
                                $scope.isIssueStateLoaded = true;
                                $scope.deleteStatesArr = [];
                                $scope.addStatesArr = [];
                                $scope.$emit('IssueDetailsChanged', response);
                            }, function () {
                                $scope.changeStateView = false;
                                $scope.isIssueStateLoaded = true;
                                $scope.deleteStatesArr = [];
                                $scope.addStatesArr = [];
                            })
                    }
                    $scope.selectedState = {};
                    $scope.changeStateView = false;
                };

                $scope.fnOpenChangeStateView = function () {
                    $scope.changeStateView = true;
                    _.forEach($scope.statesArr, function (statesObj) {
                        statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                    });
                };

                $scope.fnManageProjectState = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.issueObj.project.id,
                        "displaySearchText": $scope.issueObj.project.name
                    }];
                    $state.go("main.state", {filter: angular.toJson(inputObj)});
                };
                /*State: END*/

                /*Labels: START*/
                $scope.addLabelArr = [];
                $scope.deleteLabelArr = [];
                $scope.fnGetLabels = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.labelsArr = _.cloneDeepWith(response.data);
                            _.forEach($scope.assigneesLabels, function (issueLabelObj) {
                                var isFindLabel = _.find($scope.labelsArr, {id: issueLabelObj.id});
                                isFindLabel.isCheck = !!isFindLabel;
                            });
                            $scope.isIssueLablesLoaded = true;
                        }, function () {
                            $scope.isIssueLablesLoaded = true;
                        })
                };

                $scope.fnGetLabelInfo = function (labelObj) {
                    if (labelObj.isCheck) {
                        if ($scope.userPermissionsObj.REMOVE_ASSIGNEE_FROM_ISSUE) {
                            labelObj.isCheck = false;
                            var isFindLabel = _.find($scope.assigneesLabels, {id: labelObj.id});
                            if (isFindLabel) {
                                $scope.deleteLabelArr.push(isFindLabel);
                            } else {
                                var isFindLabelInAddLabelArr = _.findIndex($scope.addLabelArr, {id: labelObj.id});
                                if (isFindLabelInAddLabelArr !== 1) {
                                    $scope.addLabelArr.splice(isFindLabelInAddLabelArr, 1);
                                }
                            }
                        } else {
                            amaran.error('Sorry, Looks like you do not have permission to remove a label')
                        }
                    } else {
                        if ($scope.userPermissionsObj.ADD_ASSIGNEE_TO_ISSUE) {
                            labelObj.isCheck = true;
                            var isFindAssigneesLabel = _.find($scope.assigneesLabels, {id: labelObj.id});
                            if (!isFindAssigneesLabel) {
                                $scope.addLabelArr.push(labelObj);
                            } else {
                                var isFindDeleteLabel = _.findIndex($scope.deleteLabelArr, {id: labelObj.id});
                                if (isFindDeleteLabel !== -1) {
                                    $scope.deleteLabelArr.splice(isFindDeleteLabel, 1);
                                }
                            }
                        } else {
                            amaran.error('Sorry, Looks like you do not have permission to add a label')
                        }
                    }
                };

                $scope.fnAddLabelsToIssue = function (selectedLabel) {
                    $scope.isLabelsAdded = false;
                    var inputObj = {
                        issueId: $scope.issueObj.id,
                        labelId: selectedLabel.id
                    };
                    IssueFactory.addLabel(inputObj)
                        .then(function (res) {
                            $scope.issueObj.issueLabels = res.issueLabels;
                            $scope.isLabelsAdded = true;
                            $scope.addLabelView = false;
                            $scope.selectedLabel = {};
                        }, function () {
                            $scope.addLabelView = true;
                            $scope.isLabelsAdded = true;
                            $scope.selectedLabel = {};
                        });
                };

                $scope.fnCancelAddLabelView = function () {
                    $scope.selectedLabel = {};
                    $scope.addLabelView = false;
                    if ($scope.deleteLabelArr.length || $scope.addLabelArr.length) {
                        $scope.fnUpdateIssueLabel();
                    }
                };

                $scope.fnOnToggle = function (isOpen) {
                    if (isOpen === false && ($scope.deleteLabelArr.length || $scope.addLabelArr.length)) {
                        $scope.fnUpdateIssueLabel();
                    } else {
                        $scope.addLabelView = false;
                        $scope.selectedLabel = {};
                    }
                };

                $scope.fnUpdateIssueLabel = function () {
                    $scope.isIssueLablesLoaded = false;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    var labelIndex = 0;

                    angular.forEach($scope.addLabelArr, function (labelObj) {
                        if (labelIndex <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = labelIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/labels/" + labelObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = labelIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/labels/" + labelObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        labelIndex++;
                    });

                    angular.forEach($scope.deleteLabelArr, function (labelObj) {
                        if (labelIndex <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = labelIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/labels/" + labelObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = labelIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/labels/" + labelObj.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        labelIndex++;
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        count = 1;
                        $scope.fnBatchOperation(batchCollectionObj, count);
                    }
                    $scope.selectedLabel = {};
                    $scope.addLabelView = false;
                };

                $scope.fnBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker',
                        parallel: false
                    })
                        .then(function (response) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                $scope.fnBatchOperation(batchCollectionObj, count);
                            } else {
                                if (response[response.length - 1].body && response[response.length - 1].body.issueLabels) {
                                    $scope.issueObj.issueLabels = response[response.length - 1].body.issueLabels;
                                    $scope.assigneesLabels = _.cloneDeepWith($scope.issueObj.issueLabels);
                                    $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                                } else {
                                    $scope.issueObj.issueLabels = [];
                                    $scope.assigneesLabels = _.cloneDeepWith($scope.issueObj.issueLabels);
                                    $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                                }
                                $scope.deleteLabelArr = [];
                                $scope.addLabelArr = [];
                                $scope.isIssueLablesLoaded = true;
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                $scope.fnBatchOperation(batchCollectionObj, count);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                                $scope.isIssueLablesLoaded = true;
                            }
                        });
                };

                $scope.fnOpenAddLabelView = function () {
                    $scope.addLabelView = true;
                    _.forEach($scope.assigneesLabels, function (issueLabelObj) {
                        var isFindLabel = _.find($scope.labelsArr, {id: issueLabelObj.id});
                        isFindLabel.isCheck = !!isFindLabel;
                    });
                };

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                $scope.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": $scope.fnInvertColor(color.toString())
                        }
                    }
                };

                $scope.fnManageProjectLabels = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.issueObj.project.id,
                        "displaySearchText": $scope.issueObj.project.name
                    }];
                    $state.go("main.label", {filter: angular.toJson(inputObj)});
                };
                /*Labels: END*/

                /*Participant: START*/
                $scope.addParticipantArr = [];
                $scope.deleteParticipantArr = [];
                $scope.fnGetParticipants = function (inputObj, preDefinedIssueParticipants, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            var participants = isCalledForViz ? preDefinedIssueParticipants : [];
                            _.forEach(res.data, function (participantObj) {
                                participants.push({
                                    name: participantObj.email,
                                    id: participantObj.email
                                });
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (participants[0] && participants[0].totalItems > participants.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_whitelist_emails';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + participants[participants.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                $scope.fnGetParticipants({sql: sqlString}, participants, true);
                            } else {
                                $scope.participantUsersArr = [];
                                $scope.participantUsersArr = _.cloneDeepWith(participants);
                                _.forEach($scope.assigneesParticipants, function (issueParticipantObj) {
                                    var isFindParticipant = _.find($scope.participantUsersArr, {email: issueParticipantObj.email});
                                    issueParticipantObj.isCheck = !!isFindParticipant;
                                });
                                $scope.isIssueParticipantLoaded = true;
                            }
                        }, function () {
                            $scope.isIssueParticipantLoaded = true;
                        })
                };

                $scope.fnGetParticipantInfo = function (participantObj) {
                    if (participantObj.isCheck) {
                        participantObj.isCheck = false;
                        var isFindParticipant = _.find($scope.assigneesParticipants, {email: participantObj.email});
                        if (isFindParticipant) {
                            $scope.deleteParticipantArr.push(isFindParticipant);
                        } else {
                            var isFindParticipantInAddParticipantArr = _.findIndex($scope.addParticipantArr, {email: participantObj.email});
                            if (isFindParticipantInAddParticipantArr !== 1) {
                                $scope.addParticipantArr.splice(isFindParticipantInAddParticipantArr, 1);
                            }
                        }
                    } else {
                        participantObj.isCheck = true;
                        var isFindAssigneesParticipant = _.find($scope.assigneesParticipants, {email: participantObj.email});
                        if (!isFindAssigneesParticipant) {
                            $scope.addParticipantArr.push(participantObj);
                        } else {
                            var isFindDeleteParticipant = _.findIndex($scope.deleteParticipantArr, {email: participantObj.email});
                            if (isFindDeleteParticipant !== -1) {
                                $scope.deleteParticipantArr.splice(isFindDeleteParticipant, 1);
                            }
                        }
                    }
                };

                $scope.fnCancelChangeParticipant = function () {
                    $scope.selectedParticipant = {};
                    $scope.changeParticipantView = false;
                    $scope.isParticipantChanged = true;
                    if ($scope.deleteParticipantArr.length || $scope.addParticipantArr.length) {
                        $scope.fnUpdateIssueParticipant();
                    }
                };

                $scope.fnOnToggleParticipant = function (isOpen) {
                    if (isOpen === false && ($scope.deleteParticipantArr.length || $scope.addParticipantArr.length)) {
                        $scope.fnUpdateIssueParticipant();
                    } else {
                        $scope.changeParticipantView = false;
                        $scope.selectedParticipant = {};
                    }
                };

                $scope.fnUpdateIssueParticipant = function () {
                    $scope.isIssueParticipantsLoaded = false;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    var participantIndex = 0;
                    angular.forEach($scope.addParticipantArr, function (participantObj) {
                        if (participantIndex <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = participantIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/participants/" + participantObj.email;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = participantIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/participants/" + participantObj.email;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        participantIndex++;
                    });

                    angular.forEach($scope.deleteParticipantArr, function (participantObj) {
                        if (participantIndex <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = participantIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/participants/" + participantObj.email;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = participantIndex;
                            inputObj.path = "/tracker/issues/" + $scope.issueObj.id + "/participants/" + participantObj.email;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                        participantIndex++;
                    });
                    if (Object.keys(batchCollectionObj).length) {
                        count = 1;
                        $scope.fnBatchOperationParticipant(batchCollectionObj, count);
                    }
                    $scope.selectedParticipant = {};
                    $scope.changeParticipantView = false;
                };

                $scope.fnBatchOperationParticipant = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker',
                        parallel: false
                    }).then(function (response) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            $scope.fnBatchOperationParticipant(batchCollectionObj, count);
                        } else {
                            if (response[response.length - 1].body && response[response.length - 1].body.participants) {
                                $scope.issueObj.participants = response[response.length - 1].body.participants;
                                $scope.assigneesParticipants = [];
                                _.forEach($scope.issueObj.participants, function (participantsObj) {
                                    $scope.assigneesParticipants.push({
                                        email: participantsObj
                                    });
                                });
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            } else {
                                $scope.issueObj.participants = [];
                                $scope.assigneesParticipants = [];
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            }
                            $scope.deleteParticipantArr = [];
                            $scope.addParticipantArr = [];
                            $scope.isIssueParticipantLoaded = true;
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            $scope.fnBatchOperationParticipant(batchCollectionObj, count);
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                            $scope.isIssueParticipantLoaded = true;
                        }
                    });
                };

                $scope.fnOpenChangeParticipantView = function () {
                    $scope.changeParticipantView = true;
                    /*_.forEach($scope.assigneesParticipants, function (issueParticipantObj) {
                        var isFindParticipant = _.find($scope.participantUsersArr, {email: issueParticipantObj.email});
                        isFindParticipant.isCheck = !!isFindParticipant;
                    });*/
                };

                $scope.fnAddNewParticipant = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html',
                        size: 'lg',
                        controller: 'addParticipantCtrl as addParticipant',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function () {
                    }, function () {

                    });
                };

                $scope.fnManageProjectParticipants = function () {
                    $state.go("main.emails");
                };

                $scope.fnAddParticipants = function (participants) {
                    $scope.changeParticipantView = false;
                    $scope.isIssueParticipantLoaded = false;
                    var inputObj = {
                        "issueId": $scope.issueObj.id,
                        "participant": participants
                    };
                    IssueFactory.addParticipant(inputObj)
                        .then(function (response) {
                            $scope.issueObj.participants = response.participants;
                            $scope.assigneesParticipants = [];
                            _.forEach($scope.issueObj.participants, function (participantsObj) {
                                $scope.assigneesParticipants.push({
                                    email: participantsObj
                                });
                            });
                            $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            $scope.isIssueParticipantLoaded = true;
                        }, function () {
                            $scope.isIssueParticipantLoaded = true;
                        })
                };

                $scope.fnDeleteParticipants = function (participants) {
                    $scope.changeParticipantView = false;
                    $scope.isIssueParticipantLoaded = false;
                    var inputObj = {
                        "issueId": $scope.issueObj.id,
                        "participant": participants
                    };
                    IssueFactory.removeParticipant(inputObj)
                        .then(function (response) {
                            $scope.issueObj.participants = response.participants;
                            $scope.assigneesParticipants = [];
                            _.forEach($scope.issueObj.participants, function (participantsObj) {
                                $scope.assigneesParticipants.push({
                                    email: participantsObj
                                });
                            });
                            $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            $scope.isIssueParticipantLoaded = true;
                        }, function () {
                            $scope.isIssueParticipantLoaded = true;
                        })
                };
                /*Participant: END*/

                /*Project: START*/
                $scope.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                $scope.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                $scope.projectsArr = _.cloneDeepWith(projects);
                                $scope.projectsArr.sort(function (a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                _.forEach($scope.projectsArr, function (projectObj) {
                                    if (projectObj.id === $scope.issueObj.projectId) {
                                        $scope.issueObj.project = projectObj;
                                    }
                                });
                                $scope.isIssueProjectLoaded = true;
                            }
                        }, function () { // Error block
                            $scope.isIssueProjectLoaded = true;
                        })
                };

                $scope.fnOpenChangeProjectView = function () {
                    $scope.selectedProject = {};
                    $scope.changeProjectView = true;
                };

                $scope.fnChangeIssueProject = function (selectedProject) {
                    $scope.isProjectChanged = false;
                    var inputObj = {
                        "issueId": $scope.issueObj.id,
                        "projectId": selectedProject.id
                    };
                    IssueFactory.moveIssueProject(inputObj)
                        .then(function (response) {
                            $scope.issueObj.projectId = response.projectId;
                            $scope.changeProjectView = false;
                            $scope.isProjectChanged = true;
                            $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            $scope.fnInitAssigneeLabelSideBar();
                        }, function () {
                            $scope.changeProjectView = false;
                            $scope.isProjectChanged = true;
                        })
                };

                $scope.fnCancelChangeProject = function () {
                    $scope.selectedProject = {};
                    $scope.changeProjectView = false;
                    $scope.isProjectChanged = true;
                };
                /*Project: END*/

                /*Confidential: START*/
                $scope.fnOpenChangeConfidentialView = function () {
                    $scope.selectedConfidential = {};
                    $scope.changeConfidentialView = true;
                };

                $scope.fnChangeIssueConfidential = function (selectedConfidential) {
                    $scope.isConfidentialChanged = false;
                    var inputObj = {
                        "issueId": $scope.issueObj.id
                    };
                    if (selectedConfidential.value) {
                        IssueFactory.makeIssuePrivate(inputObj)
                            .then(function () {
                                $scope.issueObj.confidential = true;
                                $scope.changeConfidentialView = false;
                                $scope.isConfidentialChanged = true;
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            }, function () {
                                $scope.changeConfidentialView = false;
                                $scope.isConfidentialChanged = true;
                            })
                    } else {
                        IssueFactory.makeIssuePublic(inputObj)
                            .then(function () {
                                $scope.issueObj.confidential = false;
                                $scope.changeConfidentialView = false;
                                $scope.isConfidentialChanged = true;
                                $scope.$emit('IssueDetailsChanged', $scope.issueObj);
                            }, function () {
                                $scope.changeConfidentialView = false;
                                $scope.isConfidentialChanged = true;
                            });
                    }
                };

                $scope.fnCancelChangeConfidential = function () {
                    $scope.selectedConfidential = {};
                    $scope.changeConfidentialView = false;
                    $scope.isConfidentialChanged = true;
                };
                /*Confidential: END*/

                $scope.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                $scope.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                $scope.fnOpenAttributeModal = function (issueObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/addNewAttribute/addNewAttribute.html',
                        size: 'lg',
                        controller: 'addNewAttributeModalCtrl as attributeModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueObj: function () {
                                return _.cloneDeepWith(issueObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        _.forEach(res, function (obj) {
                            $scope.selectedAttributesArr.push(obj);
                            if (angular.isUndefined($scope.issueObj.attributeIds)) {
                                $scope.issueObj.attributeIds = [];
                            }
                            $scope.issueObj.attributeIds.push(_.cloneDeepWith(obj.id));
                        })
                    }, function () {
                    });
                };

                $scope.fnGetAttributes = function () {
                    var tempIdString = "";
                    _.forEach($scope.issueObj.attributeIds, function (id, index) {
                        if (index === $scope.issueObj.attributeIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    //var sql = "SELECT *, COUNT(*) OVER() as totalItems , _id AS rt FROM node_attributes where id IN (" + tempIdString + ");"
                    var sql = "WITH attributes AS ( " +
                        "SELECT node_attributes.*, node_attributes.data->>'_id' AS rt, node_ecus.data->>'name' AS ecuName, " +
                        "CASE WHEN node_attributes.data->>'ecuId' = node_attributes.data->>'nodeId' THEN node_ecus.data->>'name' ELSE node_nodes.data->>'name' END nodeName, " +
                        "CASE WHEN node_attributes.data->>'ecuId' = node_attributes.data->>'nodeId' THEN node_ecus.data->>'id' ELSE node_nodes.data->>'rootNodeId' END rootNodeId " +
                        "FROM node_attributes as node_attributes " +
                        "LEFT JOIN node_ecus ON node_attributes.data->>'ecuId' = node_ecus.data->>'id' " +
                        "LEFT JOIN node_nodes ON node_attributes.data->>'nodeId' = node_nodes.data->>'id' " +
                        "WHERE node_attributes.id IN (" + tempIdString + ") ORDER BY rt asc )," +
                        "rows AS ( SELECT COUNT(*) AS qty FROM node_attributes " +
                        "LEFT JOIN node_ecus ON node_attributes.data->>'ecuId' = node_ecus.data->>'id' " +
                        "LEFT JOIN node_nodes ON node_attributes.data->>'nodeId' = node_ecus.data->>'id' " +
                        "WHERE node_attributes.id IN (" + tempIdString + ") )" +
                        "SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows";
                    QueryFactory.executeQuery({"sql": sql})
                        .then(function (res) {
                            $scope.selectedAttributesArr = res.data;
                            $scope.isAttributeDataLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAttributeDataLoading = false;
                        })
                }

                $scope.fnDeleteAttribute = function (attributeObj) {
                    IssueFactory.removeAttributeFromIssue({
                        issueId: $scope.issueObj.id,
                        attributeId: attributeObj.id
                    }).then(function () {
                        amaran.success('Attribute removed successfully');
                        _.remove($scope.selectedAttributesArr, function (obj) {
                            return obj.id === attributeObj.id;
                        });
                        _.remove($scope.issueObj.attributeIds, function (obj) {
                            return obj === attributeObj.id;
                        });
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    })
                }

                $scope.fnOpenAttributeInfo = function (attributeObj) {
                    $state.go('main.alarms', {selectedId: attributeObj.id});
                }

                $scope.fnOpenAllAttributeInfo = function () {
                    var inputObj = [{
                        displaySearchText: $scope.issueObj.id,
                        displaySelectedField: "Issue ID",
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        isNeedTableAlias: true,
                        searchText: $scope.issueObj.id,
                        selectedField: "issueIds",
                        selectedFilter: {operatorName: '=', operator: '='},
                        sqlSearchType: "array"
                    }];
                    $state.go('main.alarms', {filter: angular.toJson(inputObj)});
                }

                $scope.fnExpandCollapseSideBar = function () {
                    $scope.isExpanded = !$scope.isExpanded;
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'sideBarExpanded', _.cloneDeepWith($scope.isExpanded));
                }

                $scope.fnGetAssigneesTooltipInfo = function () {
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        return $scope.issueObj.assignees.map(function (el) {
                            return el.firstName + " " + el.lastName
                        }).join(", ");
                    } else {
                        return "No assignee";
                    }
                };

                $scope.fnGetLabelsTooltipInfo = function () {
                    if ($scope.issueObj.issueLabels && $scope.issueObj.issueLabels.length) {
                        return $scope.issueObj.issueLabels.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No labels";
                    }
                };

                $scope.fnGetParticipantsTooltipInfo = function () {
                    if ($scope.issueObj.participants && $scope.issueObj.participants.length) {
                        return $scope.issueObj.participants.map(function (el) {
                            return el
                        }).join(", ");
                    } else {
                        return "No participant";
                    }
                };

                $scope.fnGetAlarmsTooltipInfo = function () {
                    if ($scope.selectedAttributesArr && $scope.selectedAttributesArr.length) {
                        return $scope.selectedAttributesArr.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No attributes";
                    }
                };

                $scope.$watch('issueObj', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        _.forEach($scope.issueObj.assignees, function (userObj) {
                            userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                        });
                        $scope.assigneesAssignees = _.cloneDeepWith($scope.issueObj.assignees);
                        $scope.assigneesType = angular.isDefined($scope.issueObj.issueType) ? _.cloneDeepWith($scope.issueObj.issueType) : {};
                        $scope.assigneesLabels = _.cloneDeepWith($scope.issueObj.issueLabels);
                        $scope.assigneesPriorities = angular.isDefined($scope.issueObj.issuePriority) ? _.cloneDeepWith($scope.issueObj.issuePriority) : {};
                        $scope.assigneesState = angular.isDefined($scope.issueObj.issueState) ? _.cloneDeepWith($scope.issueObj.issueState) : {};
                        $scope.assigneesParticipants = [];
                        _.forEach($scope.issueObj.participants, function (participantsObj) {
                            $scope.assigneesParticipants.push({
                                email: participantsObj
                            });
                        });
                        $scope.isAttributeDataLoading = true;
                        if ($scope.issueObj.attributeIds && $scope.issueObj.attributeIds.length) {
                            $scope.fnGetAttributes();
                        } else {
                            $scope.isAttributeDataLoading = false;
                        }
                    }
                });

                $scope.fnInitAssigneeLabelSideBar = function () {
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        _.forEach($scope.issueObj.assignees, function (userObj) {
                            userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                        })
                    }
                    $scope.usersArr = [{
                        username: 'assign to me'
                    }];
                    $scope.isIssueAssigneeLoaded = false;
                    $scope.assigneesAssignees = _.cloneDeepWith($scope.issueObj.assignees);

                    $scope.isIssueTypeLoaded = false;
                    var input = {
                        projectId: $scope.issueObj.projectId
                    };

                    $scope.fnGetUsers(input);
                    $scope.isAttributeDataLoading = true;
                    if ($scope.issueObj.attributeIds && $scope.issueObj.attributeIds.length) {
                        $scope.fnGetAttributes();
                    } else {
                        $scope.isAttributeDataLoading = false;
                    }

                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            $scope.projectRelationshipsObj = _.cloneDeepWith(response);
                            var upstreamProject = "";
                            _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                            $scope.assigneesType = angular.isDefined($scope.issueObj.issueType) ? _.cloneDeepWith($scope.issueObj.issueType) : {};
                            $scope.fnGetTypes({sql: typeSQL});

                            var labelSQL = "SELECT * FROM tracker_labels as labels where WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                            $scope.isIssueLablesLoaded = false;
                            $scope.assigneesLabels = _.cloneDeepWith($scope.issueObj.issueLabels);
                            $scope.fnGetLabels({sql: labelSQL});

                            $scope.isIssuePriorityLoaded = false;
                            $scope.assigneesPriorities = angular.isDefined($scope.issueObj.issuePriority) ? _.cloneDeepWith($scope.issueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                            $scope.fnGetPriorities({sql: prioritiesSQL});
                            $scope.changePriorityView = false;

                            var stateSQL = "SELECT * FROM tracker_states as states where WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                            $scope.isIssueStateLoaded = false;
                            $scope.assigneesState = angular.isDefined($scope.issueObj.issueState) ? _.cloneDeepWith($scope.issueObj.issueState) : {};
                            $scope.fnGetStates({sql: stateSQL});
                            $scope.changeStateView = false;

                            $scope.isIssueParticipantLoaded = false;
                            $scope.assigneesParticipants = [];
                            _.forEach($scope.issueObj.participants, function (participantsObj) {
                                $scope.assigneesParticipants.push({
                                    email: participantsObj
                                });
                            });
                            //var participantsSQL = 'SELECT *, COUNT(*) OVER() as totalItems , _id AS rt FROM access_whitelist_emails ORDER BY rt asc LIMIT ' + 100 + ';';
                            //$scope.fnGetParticipants({sql: participantsSQL}, [], false);
                            $scope.changeParticipantView = false;
                            $scope.participants = '';
                            $scope.isIssueParticipantLoaded = true;
                        }, function () {
                        });

                    $scope.isIssueProjectLoaded = true;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        $scope.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        $scope.projectsArr.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        });
                        _.forEach($scope.projectsArr, function (projectObj) {
                            if (projectObj.id === $scope.issueObj.projectId) {
                                $scope.issueObj.project = projectObj;
                            }
                        });
                        $scope.isIssueProjectLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    $scope.changeProjectView = false;
                };
                $scope.fnInitAssigneeLabelSideBar();
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('boardSettings', fnBoardSettings)

    /** @ngInject */
    function fnBoardSettings($timeout, $stateParams, $base64, DB, UserProfileService, AppInitService, ProjectFactory, QueryFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/issue/directives/boardSettings/boardSettings.html',
            scope: {
                isCalledForState: "=",
                isCalledForPriority: "=",
                isCalledForType: "="
            },
            link: function ($scope) {
                $scope.projectsArr = [];
                $scope.allIssueStatesOrPriority = [];
                $scope.panelsArr = [];
                $scope.resetPanelsArr = [];
                $scope.isPanelsLoading = true;
                $scope.isSettingsSaved = true;
                $scope.projectRelationshipsObj = {};

                $scope.fnGetStatesOrPriority = function () {
                    if ($scope.projectRelationshipsObj && Object.keys($scope.projectRelationshipsObj).length) {
                        var upstreamProject = "";
                        _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                            if (upstreamProject !== "") {
                                upstreamProject += ", '" + projectId + "'";
                            } else {
                                upstreamProject = "'" + projectId + "'";
                            }
                        });

                        if ($scope.isCalledForState) {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnGetPanels();
                            } else {
                                var issueStatesSQL = "SELECT * FROM tracker_states as states WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                fnGetAllIssueStates({sql: issueStatesSQL});
                            }
                        } else if ($scope.isCalledForPriority) {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnGetPanels();
                            } else {
                                var issuePrioritiesSQL = "SELECT * FROM tracker_priorities as priorities WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                fnGetAllIssuePriorities({sql: issuePrioritiesSQL});
                            }
                        } else {
                            if ($scope.allIssueStatesOrPriority.length) {
                                $scope.fnGetPanels();
                            } else {
                                var issueTypesSQL = "SELECT * FROM tracker_types as types WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                fnGetAllIssueTypes({sql: issueTypesSQL});
                            }
                        }
                    } else {
                        var inputObj = {
                            projectId: $scope.project.id
                        };
                        ProjectFactory.describeProjectRelationships(inputObj)
                            .then(function (response) {
                                $scope.projectRelationshipsObj = _.cloneDeepWith(response);
                                var upstreamProject = "";
                                _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                    if (upstreamProject !== "") {
                                        upstreamProject += ", '" + projectId + "'";
                                    } else {
                                        upstreamProject = "'" + projectId + "'";
                                    }
                                });
                                if ($scope.isCalledForState) {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnGetPanels();
                                    } else {
                                        var issueStatesSQL = "SELECT * FROM tracker_states as states WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                        fnGetAllIssueStates({sql: issueStatesSQL});
                                    }
                                } else if ($scope.isCalledForPriority) {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnGetPanels();
                                    } else {
                                        var issuePrioritiesSQL = "SELECT * FROM tracker_priorities as priorities WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                        fnGetAllIssuePriorities({sql: issuePrioritiesSQL});
                                    }
                                } else {
                                    if ($scope.allIssueStatesOrPriority.length) {
                                        $scope.fnGetPanels();
                                    } else {
                                        var issueTypesSQL = "SELECT * FROM tracker_types as types WHERE ARRAY[" + upstreamProject + "] @> ARRAY[data->>'projectId']";
                                        fnGetAllIssueTypes({sql: issueTypesSQL});
                                    }
                                }
                            }, function () {
                            });
                    }
                };

                function fnGetAllIssueStates(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = res.data;
                            $scope.fnGetPanels();
                        }, function () { // Error block
                        })
                }

                function fnGetAllIssuePriorities(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = res.data;
                            $scope.fnGetPanels();
                        }, function () { // Error block
                        })
                }

                function fnGetAllIssueTypes(inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            $scope.allIssueStatesOrPriority = res.data;
                            $scope.fnGetPanels();
                        }, function () { // Error block
                        })
                }

                $scope.fnGetPanels = function () {
                    $scope.panelsArr = [];
                    var boardSelection = $scope.isCalledForState ?
                        UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueStateBoard') :
                        $scope.isCalledForPriority ?
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issuePriorityBoard') :
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueTypeBoard');

                    $scope.allIssueStatesOrPriority = _.orderBy($scope.allIssueStatesOrPriority, ['name'], ['asc']);
                    if (boardSelection && boardSelection[$scope.project.id] && boardSelection[$scope.project.id].length) {
                        var tempDataArr = [];
                        _.forEach(boardSelection[$scope.project.id], function (boardObj) {
                            _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                                if (selectedProjectState.id === boardObj.id) {
                                    $scope.panelsArr.push({
                                        id: selectedProjectState.id,
                                        name: selectedProjectState.name,
                                        color: selectedProjectState.color,
                                        isCollapsed: boardObj.isCollapsed,
                                        isShow: boardObj.isShow
                                    });
                                    tempDataArr.push({
                                        id: selectedProjectState.id,
                                        isCollapsed: boardObj.isCollapsed,
                                        isShow: boardObj.isShow
                                    });
                                }
                            })
                        });
                        _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                            var isFind = _.find(boardSelection[$scope.project.id], {id: selectedProjectState.id});
                            if (!isFind) {
                                $scope.panelsArr.push({
                                    id: selectedProjectState.id,
                                    name: selectedProjectState.name,
                                    color: selectedProjectState.color,
                                    isCollapsed: true,
                                    isShow: true,
                                    children: []
                                });
                                tempDataArr.push({
                                    id: selectedProjectState.id,
                                    isCollapsed: true,
                                    isShow: true
                                });
                            }
                        });
                        boardSelection[$scope.project.id] = tempDataArr;
                        if ($scope.isCalledForState) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                        } else if ($scope.isCalledForPriority) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                        } else {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                        }
                    } else {
                        var localArr = [];
                        _.forEach($scope.allIssueStatesOrPriority, function (selectedProjectState) {
                            localArr.push({id: selectedProjectState.id, isCollapsed: true, isShow: true});
                            $scope.panelsArr.push({
                                id: selectedProjectState.id,
                                name: selectedProjectState.name,
                                color: selectedProjectState.color,
                                isCollapsed: true,
                                isShow: true,
                                children: []
                            })
                        });
                        boardSelection[$scope.project.id] = localArr;
                        if ($scope.isCalledForState) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                        } else if ($scope.isCalledForPriority) {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                        } else {
                            UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                        }
                    }
                    $scope.resetPanelsArr = angular.copy($scope.panelsArr);
                    $scope.isPanelsLoading = false;
                };

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                $scope.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find($scope.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            $scope.project = isFindProject;
                        } else {
                            $scope.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find($scope.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            $scope.project = isFindStateParamsProject;
                        } else {
                            $scope.project = {};
                        }
                    } else {
                        $scope.project = $scope.projectsArr[1];
                    }
                    $scope.isProjectLoaded = true;
                    $scope.fnGetStatesOrPriority();
                };

                $scope.fnGetAllProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    $scope.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\'  AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\'  > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\'  asc LIMIT ' + 100 + ';';
                                $scope.fnGetAllProjects({sql: sqlString}, projects, true);
                            } else {
                                $scope.projectsArr = _.cloneDeepWith(res.data);
                                $scope.fnSetSelectedProject();
                            }
                        }, function () {
                            $scope.fnGetProjects();
                        });
                };

                $scope.fnGetProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        $scope.projectsArr = AppInitService.getInitData('projectsArr');
                        $scope.fnSetSelectedProject();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\'  AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetAllProjects({sql: projectSQL}, [], false);
                    }
                };

                $scope.fnChangeProject = function (projectObj) {
                    $scope.allIssueStatesOrPriority = [];
                    $scope.project = angular.copy(projectObj);
                    $scope.projectRelationshipsObj = {};
                    $scope.fnGetStatesOrPriority();
                };

                $scope.fnSaveSettings = function () {
                    var boardSelection = $scope.isCalledForState ?
                        UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueStateBoard') :
                        $scope.isCalledForPriority ?
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issuePriorityBoard') :
                            UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'issueTypeBoard');

                    $scope.isSettingsSaved = false;
                    var localArr = [];
                    _.forEach($scope.panelsArr, function (panelObj) {
                        localArr.push({
                            id: panelObj.id,
                            isCollapsed: panelObj.isCollapsed,
                            isShow: panelObj.isShow
                        })
                    });
                    boardSelection[$scope.project.id] = localArr;
                    if ($scope.isCalledForState) {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueStateBoard', boardSelection);
                    } else if ($scope.isCalledForPriority) {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issuePriorityBoard', boardSelection);
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'issueTypeBoard', boardSelection);
                    }
                    $timeout(function () {
                        $scope.isSettingsSaved = true;
                    }, 1000)
                };

                $scope.fnResetPanels = function () {
                    $scope.panelsArr = angular.copy($scope.resetPanelsArr);
                };

                $scope.fnMoveItem = function (from, to) {
                    var elem = $scope.panelsArr.splice(from, 1)[0];
                    $scope.panelsArr.splice(to, 0, elem);
                };

                $scope.fnInitBoardSettings = function () {
                    $scope.isPanelsLoading = true;
                    $scope.isProjectLoaded = false;
                    $scope.fnGetProjects();
                };

                $scope.fnInitBoardSettings();
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('archivedSideBar', fnArchivedSideBar)

    /** @ngInject */
    function fnArchivedSideBar($rootScope, $timeout, $state, $uibModal, swal, amaran, microSpinner, PermissionsService, DB, AvatarService,
                                         ColorService, IssueFactory, LabelFactory, CommentFactory, UserFactory, TypesFactory, PriorityFactory, TrackerStateFactory,
                                         ProjectFactory, AppInitService, UserProfileService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/archived/directives/archivedSideBar/archivedSideBar.html',
            scope: {
                issueObj: '=',
                isExpanded: "="
            },
            link: function ($scope) {

                /*Project: START*/
                $scope.projectsArr = [];
                $scope.isIssueProjectLoaded = false;
                /*Project: END*/

                $scope.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                /*Labels: START*/

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                $scope.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": $scope.fnInvertColor(color.toString())
                        }
                    }
                };
                /*Labels: END*/

                /*Project: START*/
                $scope.fnGetProjects = function (inputObj) {
                    ProjectFactory.listProjects(inputObj)
                        .then(function (response) {
                            $scope.projectsArr = _.cloneDeepWith(response.data);
                            var isFindProject = _.find($scope.projectsArr, {id: $scope.issueObj.projectId});
                            if(isFindProject){
                                $scope.issueObj.project = isFindProject;
                            }
                            $scope.isIssueProjectLoaded = true;
                        }, function () {
                            $scope.isIssueProjectLoaded = true;
                        })
                };
                /*Project: END*/

                $scope.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                $scope.fnExpandCollapseSideBar = function () {
                    $scope.isExpanded = !$scope.isExpanded;
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'sideBarExpanded', _.cloneDeepWith($scope.isExpanded));
                }

                $scope.fnGetAssigneesTooltipInfo = function () {
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        return $scope.issueObj.assignees.map(function (el) {
                            return el.firstName + " " + el.lastName
                        }).join(", ");
                    } else {
                        return "No assignee";
                    }
                };

                $scope.fnGetLabelsTooltipInfo = function () {
                    if ($scope.issueObj.issueLabels && $scope.issueObj.issueLabels.length) {
                        return $scope.issueObj.issueLabels.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No labels";
                    }
                };

                $scope.fnGetParticipantsTooltipInfo = function () {
                    if ($scope.issueObj.participants && $scope.issueObj.participants.length) {
                        return $scope.issueObj.participants.map(function (el) {
                            return el
                        }).join(", ");
                    } else {
                        return "No participant";
                    }
                };


                $scope.fnInitAssigneeLabelSideBar = function () {
                    if ($scope.issueObj.assignees && $scope.issueObj.assignees.length) {
                        _.forEach($scope.issueObj.assignees, function (userObj) {
                            userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                        })
                    }
                    $scope.assigneesLabels = _.cloneDeepWith($scope.issueObj.issueLabels);

                    $scope.isIssueProjectLoaded = false;
                    if (AppInitService.getInitData('projectsArr').length !== 0) {
                        $scope.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var isFindProject = _.find($scope.projectsArr, {id: $scope.issueObj.projectId});
                        if(isFindProject){
                            $scope.issueObj.project = isFindProject;
                        }
                        $scope.isIssueProjectLoaded = true;
                    } else {
                        $scope.fnGetProjects();
                    }
                };
                $scope.fnInitAssigneeLabelSideBar();
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('restoreIssueCtrl',
            function ($uibModalInstance, amaran, AppInitService, DB, ProjectFactory, issueId, ArchivedIssueFactory) {
                var vm = this;
                vm.projectsArr = [];
                vm.isIssueProjectLoaded = false;
                vm.selectedProject = "";
                vm.isRestore = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnUnarchivesIssue = function () {
                    vm.isRestore = false;
                    var inputObj = {
                        issueId: issueId
                    };
                    if (vm.selectedProject && Object.keys(vm.selectedProject).length) {
                        inputObj.projectId = vm.selectedProject.id;
                    }
                    ArchivedIssueFactory.restoreIssue(inputObj)
                        .then(function () {
                            amaran.success("Issue restore successfully.");
                            $uibModalInstance.close('success');
                            vm.isRestore = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $uibModalInstance.dismiss('cancel');
                            vm.isRestore = true;
                        });
                };

                vm.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                vm.fnInitModal = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        vm.isIssueProjectLoaded = true;
                    } else {
                        ProjectFactory.listProjects()
                            .then(function (response) {
                                vm.projectsArr = _.cloneDeepWith(response.data);
                                vm.isIssueProjectLoaded = true;
                            }, function () {
                                vm.isIssueProjectLoaded = true;
                            })
                    }
                }

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('renameModalCtrl',
            function ($uibModalInstance, folderObj, FolderFactory, FileFactory) {
                var vm = this;
                vm.itemName = angular.copy(folderObj.name);
                vm.isRenameProcessOn = false;
                vm.folderObj = angular.copy(folderObj);

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isRenameProcessOn = true;
                    var inputObj = {};
                    if(vm.folderObj.type === 'file') {
                        inputObj = {
                            body: {
                                function: 'RENAME',
                                source: {
                                    path: angular.copy(vm.folderObj.path)
                                },
                                destination: {
                                    path: ''
                                }
                            }
                        };
                        var tempArr = vm.folderObj.name.split(".");
                        tempArr[0] = vm.itemName;
                        var subPath = vm.folderObj.path.substring(0, vm.folderObj.path.lastIndexOf("/") + 1);
                        var newFileArr = vm.itemName.split(".");
                        var newExtension = null;
                        if(vm.itemName.includes('.') && newFileArr[newFileArr.length - 2]!==''){
                            if(newFileArr[newFileArr.length - 1] === ''){
                                newExtension = null;
                            }else{
                                newExtension = newFileArr[newFileArr.length - 1];
                            }
                        }else{
                            newExtension = null;
                        }
                        var newFileName = newExtension === null?vm.itemName+"."+tempArr[1]:vm.itemName;
                        inputObj.body.destination.path = subPath + newFileName;
                        FileFactory.modifyFile(inputObj)
                            .then(function () {
                                vm.isRenameProcessOn = false;
                                $uibModalInstance.close('success');
                            }, function () {
                                vm.isRenameProcessOn = false;
                                $uibModalInstance.close('fail');
                            })
                    } else if (vm.folderObj.type === 'folder') {
                        inputObj = {
                            body: {
                                function: 'RENAME',
                                source: {
                                    path: vm.folderObj.path
                                },
                                destination: {
                                    path: ''
                                }
                            }
                        };
                        var index = vm.folderObj.path.lastIndexOf('/', vm.folderObj.path.lastIndexOf('/') - 1);
                        var subPathFolder = vm.folderObj.path.substring(0, index + 1);
                        inputObj.body.destination.path = subPathFolder + vm.itemName + "/";

                        FolderFactory.modifyFolder(inputObj)
                            .then(function () {
                                vm.isRenameProcessOn = false;
                                $uibModalInstance.close('success');
                            }, function () {
                                vm.isRenameProcessOn = false;
                                $uibModalInstance.close('fail');
                            })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LockECUSerialCtrl',
            function ($uibModalInstance, amaran, IconService, ColorService, NodeEcuFactory, accountObj) {
                var vm = this;
                vm.accountObj = accountObj;
                vm.inputObj = {
                    accountId: '',
                    serialId: ''
                };
                vm.isUpdateCompleted = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnLockSerialToAccount = function (inputObj) {
                    vm.isUpdateCompleted = false;
                    NodeEcuFactory.lockAccountToEcu(inputObj)
                        .then(function () {
                            vm.isUpdateCompleted = true;
                            amaran.success("Serial number lock successfully");
                            $uibModalInstance.dismiss('cancel');
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                        })
                };

                vm.fnInitLockECUSerialModal = function () {
                    vm.inputObj.accountId = vm.accountObj.id;
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('accountInfo', fnAccountInfo)

    /** @ngInject */
    function fnAccountInfo($rootScope, $window, $state, $stateParams, $timeout, microSpinner, swal, amaran, AccountFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/predictive/account/directives/accountInfo/accountInfo.html',
            scope: {
                accountObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/predictive/account/directives/accountInfo/accountSteps/details.html'
                    }, /*{
                        title: 'Users',
                        tabIndex: 2,
                        templateUrl: 'app/predictive/account/directives/accountInfo/accountSteps/accountUsers/accountUsers.html'
                    },*/ {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/predictive/account/directives/accountInfo/accountSteps/accountSupplemental/accountSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetAccount = function (accountId) {
                    var inputObj = {
                        accountId: accountId
                    };
                    AccountFactory.describeAccount(inputObj)
                        .then(function (response) {
                            $scope.accountObj = response;
                            $scope.resetAccountObj = angular.copy($scope.accountObj);
                            if (angular.isUndefined($scope.accountObj.description)) {
                                $scope.accountObj.description = '';
                            }
                            $scope.isAccountDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAccountDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.accounts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateAccountDetails = function (accountObj) {
                    var inputObj = {
                        body: {},
                        accountId: accountObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(accountObj.description)) {
                        accountObj.description = '';
                    }
                    inputObj.body = {
                        name: accountObj.name,
                        description: accountObj.description
                    };
                    AccountFactory.updateAccount(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('AccountDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Account Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteAccount = function (accountObj) {
                    swal({
                            title: "Delete the selected account?",
                            text: "You are about to permanently delete the selected account.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    accountId: accountObj.id
                                };
                                AccountFactory.deleteAccount(inputObj)
                                    .then(function () {
                                        $scope.$emit('AccountDeleted', accountObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.accountObj = angular.copy($scope.resetAccountObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnCreateSupportSession = function (accountObj) {
                    $rootScope.$broadcast("startSudoProcess", accountObj); //will be listened in main controller
                };

                $scope.fnInitAccount = function () {
                    $scope.isAccountDetailsLoaded = false;
                    $scope.accountId = $scope.accountObj.id;
                    if ($scope.accountId) {
                        $scope.fnGetAccount($scope.accountId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitAccount();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                var accountInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.accounts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteAccount($scope.accountObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] &&
                                !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var accountInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.accounts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', accountInfoKeyDownEventHandler);
                document.addEventListener('keyup', accountInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', accountInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', accountInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('workflowTriggersModalCtrl',
            function ($timeout, $window, $uibModalInstance, FilterQueryService, componentService, triggersArr, modelsObj) {
                var vm = this;

                /*filters: START*/
                vm.isTriggersModalSelected = false;
                vm.selectedFunction = "";
                vm.search = "";

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClose = function (selectedFunction) {
                    $uibModalInstance.close(selectedFunction);
                };

                vm.fnGetModelInfo = function (obj) {
                    vm.workflowOutputsArr = [];
                    vm.isTriggersModalSelected = true;
                    var triggersOutputArr = FilterQueryService.fnGetWorkflowInputOutputInfo(obj.outputs, vm.modelsObj, 'Output', true);
                    var indexArray = componentService.getUniqueIndexForTriggersModal(triggersOutputArr);
                    vm.workflowOutputsArr = componentService.getHierarchyForTriggersModal(indexArray, triggersOutputArr);
                    vm.selectedFunction = obj;
                };

                vm.fnInject = function (obj) {
                    $uibModalInstance.close(obj);
                };

                vm.fnStatesFilter = function () {
                    var statesData = '';
                    if (angular.isDefined(vm.search)) {
                        statesData = _.filter(triggersArr, function (statesObj) {
                            if (statesObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return statesObj;
                            }
                        });
                    } else {
                        statesData = angular.copy(triggersArr);
                    }
                    vm.triggersArr = statesData;
                };

                vm.fnBackToFunctions = function () {
                    vm.selectedFunction = '';
                    vm.isTriggersModalSelected = false;
                };

                vm.fnInitWorkflowTriggersModal = function () {
                    vm.triggersArr = triggersArr;
                    vm.modelsObj = modelsObj;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('draftNameCtrl',
            function ($uibModalInstance, draftsOptions) {
                var vm = this;
                vm.draftName = '';

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.draftName);
                };

                vm.fnCheckNameAvailability= function (draftName) {
                    if(draftsOptions[draftName]) {
                        vm.isDraftNameUnique = false;
                    } else {
                        vm.isDraftNameUnique = true;
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('previewWorkFlowCtrl',
            function ($scope, $uibModalInstance, $uibModal, PermissionsService, $timeout, draw2d, WorkflowFactory, workflowId) {
                var vm = this;
                vm.draftName = '';
                vm.workflowId = workflowId;
                vm.workflowObj = null;
                vm.clonedCanvas = null;

                /* START:  Draw2d Canvas editor section*/
                document.addEventListener('onInitCanvas', function (e) {
                    var userDataObj = e.detail;
                    if (userDataObj.category === "TRIGGER") {
                        vm.triggerCount = true;
                    }
                });

                /*eslint-disable*/
                $scope.editor = {
                    /*eslint-enable*/
                    // Configuration of the editor
                    canvas: {
                        //Method to Get canvas in controller on Initialization
                        fnInit: function (canvas) {
                            vm.clonedCanvas = canvas;
                            $timeout(function () {
                                vm.fnInitModel();
                            })
                        },
                        jsonRead: function (canvas, jsonData) {
                            var reader = new draw2d.io.json.Reader();
                            reader.unmarshal(canvas, jsonData);
                        }
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClone = function () {
                    $uibModalInstance.close(true);
                };

                vm.fnInitModel = function () {
                    vm.workflowPermissionObj = PermissionsService.getPermissions("pipeline:workflow");
                    WorkflowFactory.getWorkflow({workflowId: vm.workflowId})
                        .then(function (response) {
                            vm.workflowObj = response;
                            if (vm.workflowObj) {
                                var newEvent = new CustomEvent(
                                    "callFromModelView", {
                                        detail: true
                                    }
                                );
                                document.dispatchEvent(newEvent);
                                $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.workflowObj.flow);
                            }
                        })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('inputPromptCtrl',
            function ($uibModalInstance, pathValue, forTarget) {
                var vm = this;
                var promptPathValue = pathValue;
                var isForTarget = forTarget;
                vm.promptoptionsArr = [];

                vm.fnSave = function () {
                    angular.forEach(vm.promptoptionsArr, function (prompObj) {
                        var key = "[" + prompObj.key + "]";
                        var value = "[" + (prompObj.value-1) + "]";
                        promptPathValue = angular.copy(promptPathValue.replace(key, value));
                    });
                    $uibModalInstance.close(promptPathValue);
                };

                vm.fnClose = function(){
                    $uibModalInstance.dismiss('cancel');
                };

                vm.ordinal_suffix_of = function (i) {
                    var j = i % 10,
                        k = i % 100;
                    if (j === 1 && k !== 11) {
                        return i + "ST";
                    }
                    if (j === 2 && k !== 12) {
                        return i + "ND";
                    }
                    if (j === 3 && k !== 13) {
                        return i + "RD";
                    }
                    return i + "TH";
                };

                vm.fnInitPrompt = function () {
                    var tempArr;
                    if(!isForTarget && pathValue.startsWith('#')) {
                        var temp = pathValue.replace("#", "");
                        tempArr = temp.split(".");
                        angular.forEach(tempArr, function (value) {
                            if(value.endsWith("]")){
                                var option = value.substring(value.lastIndexOf("[") + 1, value.length).replace("]", "");
                                var title = value.substring(0, value.lastIndexOf("[") - 1);
                                vm.promptoptionsArr.push({
                                    key: option,
                                    value: 1,
                                    fieldLabel:title
                                })
                            }
                        })
                    } else if (isForTarget) {
                        tempArr = pathValue.split(".");
                        angular.forEach(tempArr, function (value) {
                            if(value.endsWith("]")){
                                var option = value.substring(value.lastIndexOf("[") + 1, value.length).replace("]", "");
                                var title = value.substring(0, value.lastIndexOf("[")- 1);
                                vm.promptoptionsArr.push({
                                    key: option,
                                    value: 1,
                                    fieldLabel:title
                                })
                            }
                        })
                    }
                };

                vm.fnInitPrompt();
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('draftOptionsCtrl',
            function ($timeout, $uibModalInstance, DB, draftObj) {
                var vm = this;
                vm.selectedDraft = null;
                vm.isClosedClicked = false;
                vm.isOpenClicked = false;

                vm.fnCancel = function () {
                    vm.isClosedClicked = true;
                    DB.fnSet("WorkflowsSavedDrafts", draftObj);
                    $timeout(function () {
                        $uibModalInstance.dismiss('cancel');
                    }, 1000)
                };

                vm.fnOpen = function () {
                    vm.isOpenClicked = true;
                    DB.fnSet("WorkflowsSavedDrafts", draftObj);
                    $timeout(function () {
                        $uibModalInstance.close(vm.selectedDraft);
                    }, 1000)
                };

                vm.fnselectDraft = function (selectedDraftObj) {
                    angular.forEach(vm.draftsArr, function (draft) {
                        if (draft.name === selectedDraftObj.name) {
                            draft.isCheck = true;
                            vm.selectedDraft = draft.name;
                        } else {
                            draft.isCheck = false;
                        }
                    })
                };

                vm.fnDeleteDraft = function (selectedDraft, index) {
                    if(selectedDraft.name === selectedDraft.name) {
                        vm.selectedDraft = null;
                    }
                    vm.draftsArr.splice(index, 1);
                    delete draftObj[selectedDraft.name];
                    DB.fnSet("WorkflowsSavedDrafts", draftObj);
                };

                vm.fnInitModal = function () {
                    vm.draftsArr = [];
                    Object.keys(draftObj).forEach(function (key) {
                        vm.draftsArr.push({
                            name: key,
                            isCheck: false
                        });
                    });
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('connectorModalCtrl',
            function ($timeout, amaran, swal, $uibModalInstance, connectorFieldExpArr, queryBuilder, selectedConnectorObj,
                      connectorExpressionObj, isConnectorSaved, isReadOnly) {
                var vm = this;
                vm.connectorFieldExpArr = connectorFieldExpArr;
                vm.queryBuilder = queryBuilder;
                vm.selectedConnectorObj = selectedConnectorObj;
                vm.connectorExpressionObj = connectorExpressionObj;
                vm.isConnectorSaved = isConnectorSaved;
                vm.isReadOnly = isReadOnly;

                vm.fnClose = function () {
                    $uibModalInstance.close();
                };

                /*Expression Connector: START*/
                vm.fnSaveExpression = function (isSaveSilently) {
                    var parameterObj = {
                        parameters: {}
                    };
                    parameterObj.parameters.expression = vm.queryBuilder;
                    vm.selectedConnectorObj.userData = parameterObj;
                    vm.connectorExpressionObj[vm.selectedConnectorObj.id] = vm.selectedConnectorObj;
                    vm.selectedConnectorObj.attr({
                        color: "#129ce4"
                    });
                    if (!isSaveSilently) {
                        amaran.success("Expression saved successfully");
                    }
                    vm.isConnectorSaved = true;
                    $uibModalInstance.close({
                        connectorFieldExpArr: vm.connectorFieldExpArr,
                        queryBuilder: vm.queryBuilder,
                        selectedConnectorObj: vm.selectedConnectorObj,
                        connectorExpressionObj: vm.connectorExpressionObj,
                        isConnectorSaved: isConnectorSaved
                    });
                };

                vm.fnExitExpression = function () {
                    if (vm.isConnectorSaved === true) {
                        vm.fnSaveExpression(true);
                    } else {
                        swal({
                                title: "Unsaved Changes!",
                                text: "You have unsaved changes. Would you like to save them?",
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "SAVE",
                                cancelButtonText: "DISCARD",
                                closeOnConfirm: true,
                                showLoaderOnConfirm: false
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    $timeout(function () {
                                        vm.fnSaveExpression();
                                    })
                                } else {
                                    if (vm.selectedConnectorObj.userData && vm.selectedConnectorObj.userData.parameters && vm.selectedConnectorObj.userData.parameters.expression) {
                                        vm.queryBuilder = angular.copy(vm.selectedConnectorObj.userData.parameters.expression);
                                    } else {
                                        vm.queryBuilder = {"condition": "AND", "rules": []};
                                    }
                                    $uibModalInstance.dismiss({
                                        connectorFieldExpArr: vm.connectorFieldExpArr,
                                        queryBuilder: vm.queryBuilder,
                                        selectedConnectorObj: vm.selectedConnectorObj,
                                        connectorExpressionObj: vm.connectorExpressionObj,
                                        isConnectorSaved: isConnectorSaved
                                    });
                                }
                            });
                    }
                };
                /*Expression Connector: END*/

                vm.fnInitModal = function () {

                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('workflowStateModalCtrl',
            function ($timeout, $window, $uibModalInstance, FilterQueryService, componentService, ColorService, statesArr, modelsObj) {
                var vm = this;

                /*filters: START*/
                vm.selectedFunction = "";
                vm.functionSearch = '';
                vm.serviceSearch = '';
                vm.outputSearch = '';

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".state-search-panel")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".state-search-panel")[0].offsetHeight;
                        var nav = angular.element(".nav")[0].offsetHeight;
                        search = search === 0 ? 72 : search;
                        var finalHeight = total - (search + nav + 50);
                        angular.element(".functionTab").css('height', (finalHeight) + 'px');
                        angular.element(".serviceTab").css('height', (finalHeight) + 'px');
                        angular.element(".outputTab").css('height', (finalHeight) + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInject = function (obj) {
                    $uibModalInstance.close(obj);
                };

                vm.fnGetPanelHeadingCss = function (color) {
                    return ColorService.getDark(color, 15);
                };
                vm.fnGetStateLabelCss = function (workflowHierarchyObj) {
                    var stateLabel = {};
                    stateLabel.width = "100%";
                    stateLabel.padding = "5px 5px";
                    stateLabel.background = workflowHierarchyObj.color;
                    stateLabel.borderRadius = "5px";
                    stateLabel.border = "solid rgba(0,0,0,0.3)";
                    stateLabel.margin = "0";
                    stateLabel.fontWeight = "normal";
                    stateLabel.position = "relative";
                    return stateLabel;
                };

                vm.fnGetStateIconCss = function (workflowHierarchyObj) {
                    var stateIcon = {};
                    stateIcon.position = "absolute";
                    stateIcon.background = ColorService.getDark(workflowHierarchyObj.color, 15);
                    stateIcon.padding = "6px";
                    stateIcon.top = "0";
                    stateIcon.left = "0";
                    return stateIcon;
                };

                vm.fnGetStateTextCss = function (workflowHierarchyObj) {
                    var stateText = {};
                    stateText.marginLeft = "32px";
                    stateText.position = "relative";
                    stateText.top = "4px";
                    stateText.fontSize = "15px";
                    stateText.fontWeight = "bold";
                    stateText.color = ColorService.getContrastTextColor(workflowHierarchyObj.color);
                    return stateText;
                };
                vm.getContrastTextColor = function (color) {
                    var bodyTextColor = {};
                    bodyTextColor.color = ColorService.getContrastTextColor(color);
                    bodyTextColor.fontSize = "12px";
                    bodyTextColor['background-color'] = color;
                    return bodyTextColor;
                };

                vm.fnGetInjectButtonCss = function (workflowHierarchyObj) {
                    return {
                        color: ColorService.getContrastTextColor(workflowHierarchyObj.color),
                        background: 'transparent',
                        border: '1px solid'
                    };
                };

                vm.fnStatesFilter = function (type) {
                    if (type === "FUNCTION") {
                        var functionStateArr = '';
                        if (angular.isDefined(vm.functionSearch)) {
                            functionStateArr = _.filter(vm.resetStatesArr.FUNCTION, function (statesObj) {
                                if (statesObj.name.toLowerCase().includes(vm.functionSearch.toLowerCase())) {
                                    return statesObj;
                                }
                            });
                        } else {
                            functionStateArr = _.cloneDeep(vm.resetStatesArr.FUNCTION);
                        }
                        vm.statesArr.FUNCTION = functionStateArr;
                    } else if (type === "SERVICE") {
                        var serviceStateArr = '';
                        if (angular.isDefined(vm.serviceSearch)) {
                            serviceStateArr = _.filter(vm.resetStatesArr.SERVICE, function (statesObj) {
                                if (statesObj.name.toLowerCase().includes(vm.serviceSearch.toLowerCase())) {
                                    return statesObj;
                                }
                            });
                        } else {
                            serviceStateArr = _.cloneDeep(vm.resetStatesArr.SERVICE);
                        }
                        vm.statesArr.SERVICE = serviceStateArr;
                    } else {
                        var outputStateArr = '';
                        if (angular.isDefined(vm.outputSearch)) {
                            outputStateArr = _.filter(vm.resetStatesArr.OUTPUT, function (statesObj) {
                                if (statesObj.name.toLowerCase().includes(vm.outputSearch.toLowerCase())) {
                                    return statesObj;
                                }
                            });
                        } else {
                            outputStateArr = _.cloneDeep(vm.resetStatesArr.OUTPUT);
                        }
                        vm.statesArr.OUTPUT = outputStateArr;
                    }
                };

                vm.fnInitWorkflowStatesModal = function () {
                    vm.statesArr = statesArr;
                    vm.resetStatesArr = _.cloneDeep(statesArr);
                    vm.modelsObj = modelsObj;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('htmlPreviewModalCtrl',
            function ($uibModalInstance, decodedBody) {
                var vm = this;
                vm.decodedBody = decodedBody;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitHTMLPreviewModal = function () {
                    var string = angular.copy(vm.decodedBody);
                    var element = document.getElementById('htmlParse');
                    //var htmlObject = $(string); //eslint-disable-line
                    element.innerHTML = string; //eslint-disable-line
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('editListenerPanelCtrl',
            function ($scope, $timeout, $window, $rootScope, amaran, FilterQueryService, ActionOptionArrService, ListenerFactory, WizardHandler, BatchFactory) {
                var vm = this;
                var count =0;
                vm.actionOptionArr = [];
                vm.tabSelected = function () {
                    vm.modeChanged();
                    if (vm.queryBuilder.rules.length) {
                        vm.statementsObj.advance = angular.copy(angular.toJson(vm.queryBuilder, true))
                    }
                };

                vm.queryBuilderSelected = function () {
                    if (angular.isDefined(vm.statementsObj.advance) && isJson(vm.statementsObj.advance)) {
                        vm.queryBuilder = angular.copy(angular.fromJson(vm.statementsObj.advance));
                    }
                };

                vm.isAllChecked = false;
                vm.selectedStatementssArr = [];
                vm.deleteListenerStatementsArr = [];
                vm.selectedTab = 1;
                var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
                var appCount = 0;
                vm.modelsObj = {};
                vm.tabs = [
                    {
                        title: 'Information',
                        tabIndex: 1
                    },
                    {
                        title: 'Statements',
                        tabIndex: 2
                    }
                ];
                vm.isAddExpression = false;
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };
                vm.actionArr = [];
                vm.queryBuilder = {"condition": "AND", "rules": []};
                vm.isEditMode = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    //vm.fnSetTableHeight();
                });

                vm.newListenerObj = {
                    name: '',
                    description: '',
                    statements: []
                };

                vm.statementsObj = {
                    effect: "ALLOW",
                    actions: []
                };

                vm.effectOptionArr = [
                    "ALLOW",
                    "DENY"
                ];

                vm.statesArr = [
                    "INACTIVE",
                    "ACTIVE"
                ];

                vm.fnAddNewStatements = function () {
                    WizardHandler.wizard().goTo(0);
                    var rulesObj = {
                        "condition": "AND",
                        "rules": []
                    };
                    vm.qbFilters = null;
                    $rootScope.$broadcast("queryBuilderReset", rulesObj);
                    vm.queryBuilder = {"condition": "AND", "rules": []};
                    vm.statementsObj = {
                        effect: "ALLOW",
                        actions: []
                    };
                };

                vm.fnEditStatements = function (statementsObj) {
                    WizardHandler.wizard().goTo(0);
                    var rulesObj;
                    if (!statementsObj.expression || statementsObj.expression === null) {
                        rulesObj = {"condition": "AND", "rules": []};
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                    } else {
                        rulesObj = statementsObj.expression;
                        vm.queryBuilder = statementsObj.expression;
                    }
                    vm.statementsObj = statementsObj;
                    vm.qbFilters = null;
                    vm.isEditMode = true;
                    $rootScope.$broadcast("queryBuilderSet", rulesObj);
                };

                vm.fnCreateFilterObj = function (actionsArr) {
                    vm.qbFilters = null;
                    var arr = FilterQueryService.fnGetFilterArr(actionsArr, vm.modelsObj);
                    $timeout(function () {
                        arr = arr.map(function (val) {
                            return {
                                id: val,
                                type: 'string',
                                operators: ['equal',
                                    'not_equal',
                                    'in',
                                    'not_in',
                                    'start',
                                    'not_start',
                                    'end',
                                    'not_end',
                                    'less',
                                    'less_or_equal',
                                    'greater',
                                    'greater_or_equal']
                            }
                        });
                        vm.qbFilters = arr;
                    },10);
                };

                vm.fnCreateActionTag = function (action) {
                    if (action) {
                        var flag = false;
                        angular.forEach(vm.statementsObj.actions, function (actionObj) {
                            if (actionObj === action) {
                                flag = true;
                            }
                        });

                        if (!flag) {
                            vm.statementsObj.actions.push(angular.copy(action));
                            vm.action = "";
                        }
                    }
                };

                vm.fnRemoveTags = function (index) {
                    vm.statementsObj.actions.splice(index, 1);
                };

                vm.fnRemoveFromArr = function (index, arr) {
                    $rootScope.$broadcast('updateDeleteListenerStatementsArr', arr[index].id);
                    arr.splice(index, 1);
                };

                vm.fnExpression = function (isBuilder, isEditMode) {
                    if (isBuilder) {
                        $rootScope.$broadcast('changeText', {});
                    }

                    $timeout(function () {
                        if (vm.activeTab === 1 && vm.statementsObj.advance) {
                            vm.statementsObj.expression = vm.statementsObj.advance;
                        } else {
                            if (vm.queryBuilder.rules.length) {
                                vm.statementsObj.expression = vm.queryBuilder
                            } else {
                                vm.statementsObj.expression = null;
                            }
                        }
                        if (vm.statementsObj.expression) {
                            delete vm.statementsObj.expression.valid;
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            // noinspection JSAnnotator
                            delete vm.statementsObj.advance;
                        }
                        var rulesObj = '';
                        if (!isEditMode) {
                            vm.newListenerObj.statements.push(vm.statementsObj);
                            vm.statementsObj = {
                                effect: "ALLOW",
                                actions: []
                            };
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            rulesObj = {"condition": "AND", "rules": []};
                            $rootScope.$broadcast("queryBuilderSet", rulesObj);
                        }else {
                            vm.statementsObj = angular.copy({
                                effect: "ALLOW",
                                actions: []
                            });
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            rulesObj = {"condition": "AND", "rules": []};
                            $rootScope.$broadcast("queryBuilderSet", rulesObj);
                        }
                        vm.isEditMode = false;
                    }, 10);
                    vm.isAddExpression = false;
                };

                vm.fnGoBacktoReview = function () {
                    vm.isAddExpression = false;
                    vm.statementsObj = angular.copy({
                        effect: "ALLOW",
                        actions: []
                    });
                    vm.queryBuilder = {"condition": "AND", "rules": []};
                    var rulesObj = {"condition": "AND", "rules": []};
                    $rootScope.$broadcast("queryBuilderSet", rulesObj);
                };

                /*/!*start: blue print*!/
                vm.isCalledFromBluePrint = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';

                vm.fnBluePrintSelected = function (selectedBluePrint) {
                    vm.isBluePrintSelected = false;
                    if (selectedBluePrint) {
                        angular.forEach(vm.bluePrintArr, function (bluePrintObj) {
                            if (bluePrintObj.name === selectedBluePrint) {
                                vm.newListenerObj = bluePrintObj;
                            }
                        });
                        $timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });
                        $timeout(function () {
                            vm.isBluePrintSelected = true;
                        })
                    }
                };
                vm.fnInitCreateListenerFromBluePrint = function () {
                    vm.isCalledFromBluePrint = true;
                    ListenerFactory.getListenerBluePrints()
                        .then(function (response) {
                            vm.bluePrintArr = response;
                            var tempObj = {
                                name: ''
                            };
                            vm.bluePrintArr.unshift(tempObj);
                            vm.isBluePrintFetched = true;

                        }, function () {
                            vm.isBluePrintFetched = true;
                        })
                };
                /!*end: blue print*!/*/

                /*START: Edit Blue Print*/
                vm.fnInitEditBluePrint = function (listenerObj) {
                    vm.fnInitEditAppModels();
                    if (listenerObj) {
                        vm.newListenerObj = listenerObj;
                        vm.resetNewListenerObj = angular.copy(vm.newListenerObj);
                    }
                };

                vm.fnExitEditMode = function () {
                    /*$rootScope.$broadcast("exitListenerEditMode");*/
                    vm.deleteListenerStatementsArr = [];
                };

                vm.fnEditExpression = function (obj) {
                    vm.isAddExpression = true;
                    $timeout(function () {
                        vm.fnEditStatements(obj);
                    });
                };

                vm.count = 0;
                vm.fnDeleteExpression = function () {
                    angular.forEach(vm.newListenerObj.statements, function (obj, index) {
                        if (obj.isCheck) {
                            if (obj.id) {
                                vm.deleteListenerStatementsArr.push(obj.id);
                            }
                            vm.newListenerObj.statements.splice(index, 1);
                        }
                    });
                };

                vm.fnUpdateListenerStatement = function (listenerObj, statementObj) {
                    var inputObj = {
                        listenerId: listenerObj.id,
                        statementId: statementObj.id,
                        body: statementObj
                    };

                    ListenerFactory.modifyListenerStatement(inputObj)
                        .then(function () {
                            count++;
                            vm.fnUpdateListener(listenerObj);
                        })
                };

                vm.fnCreateNewStatement = function (listenerObj, statementObj) {
                    var inputObj = {
                        listenerId: listenerObj.id,
                        body: statementObj
                    };

                    ListenerFactory.createListenerStatement(inputObj)
                        .then(function () {
                            count++;
                            vm.fnUpdateListener(listenerObj);
                        })
                };

                vm.fnUpdateListener = function (listenerObj) {
                    if (listenerObj.statements.length && count < listenerObj.statements.length) {
                        if (listenerObj.statements[count].id) {
                            vm.fnUpdateListenerStatement(listenerObj, listenerObj.statements[count])
                        } else {
                            vm.fnCreateNewStatement(listenerObj, listenerObj.statements[count])
                        }
                    } else {
                        if(vm.deleteListenerStatementsArr.length) {
                            vm.fnDeleteListenerStatements(listenerObj, vm.deleteListenerStatementsArr);
                        } else {
                            count = 0;
                            vm.fnUpdateListenerDetails(listenerObj);
                        }
                    }
                };

                vm.fnDeleteListenerStatements = function (listenerObj, statementsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var editCount = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(statementsArr, function (selectedStatementId, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + listenerObj.id + "/statements/" + selectedStatementId;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            editCount++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + listenerObj.id + "/statements/" + selectedStatementId;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        }
                    });
                    editCount = 1;
                    vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, editCount, listenerObj) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[editCount], tag: 'listener', appName: 'pipeline'})
                        .then(function () {
                            if(editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                            } else {
                                count = 0;
                                vm.fnUpdateListenerDetails(listenerObj);
                            }
                        }, function (error) {
                            if(editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                            } else {
                                count = 0;
                                vm.fnUpdateListenerDetails(listenerObj);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnUpdateListenerDetails = function (listenerObj) {
                    var inputObj = {
                        body: {},
                        listenerId: listenerObj.id
                    };
                    vm.isUpdateCompleted = false;

                    if (angular.isUndefined(listenerObj.description)) {
                        listenerObj.description = '';
                    }
                    inputObj.body = {
                        name: listenerObj.name,
                        description: listenerObj.description,
                        state: listenerObj.state
                    };
                    ListenerFactory.modifyListener(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('ListenerDetailsChanged', response);
                            $scope.$broadcast("updateProcessCompleted");
                            vm.isUpdateCompleted = true;
                            vm.isDetailsEditable = false;
                            vm.isListenerCreating = false;
                            $scope.$emit("exitListenerEditMode",response);
                            vm.deleteListenerStatementsArr = [];
                            amaran.success("Listener Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                            vm.isDetailsEditable = false;
                            vm.isListenerCreating = false;
                        })
                };

                vm.finishedWizardEdit = function (newListenerObj) {
                    vm.isListenerCreating = true;
                    count = 0;
                    /*$rootScope.$broadcast("updateListener", newListenerObj);*/
                    vm.fnUpdateListener(newListenerObj);
                };

                vm.fnAddExpression = function () {
                    vm.btnText = "Add Expression";
                    vm.isAddExpression = true;
                };

                vm.fnCheckUncheckHeader = function (statementsObj) {
                    vm.isAllChecked = false;
                    vm.selectedStatementssArr = [];
                    angular.forEach(vm.newListenerObj.statements, function (obj) {
                        obj.isCheck = false;
                    });
                    statementsObj.isCheck = !statementsObj.isCheck;
                    if (statementsObj.isCheck) {
                        vm.selectedStatementssArr.push(statementsObj)
                    } else {
                        vm.selectedStatementssArr = []
                    }
                };
                function isJson(jsonObj) {
                    try {
                        angular.fromJson(jsonObj);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                $scope.$on("updateProcessCompleted", function () {
                    vm.isListenerCreating = false;
                });

                vm.fnCancel = function () {
                    vm.deleteListenerStatementsArr = [];
                    $scope.$emit("exitListenerEditMode",vm.resetNewListenerObj);
                };

                vm.fnGetAppModels = function (count) {
                    var inputObj = {
                        appName: appArr[count]
                    };
                    ListenerFactory.getListenerModels(inputObj)
                        .then(function (response) {
                            vm.modelsObj[appArr[count]] = response;
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        }, function () {
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        })

                };
                vm.fnInitEditAppModels = function () {
                    vm.isListenerModelsLoading = true;
                    vm.actionOptionArr = ActionOptionArrService.getActionOptionArr();
                    if(appCount < appArr.length) {
                        vm.fnGetAppModels(appCount);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('softwareJobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobsArr) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobsArr = _.cloneDeepWith(jobsArr);
                vm.completedJob = [];
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    mode: 'text/plain',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to ECU software version.\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Queued job to " + vm.jobsArr.length + " ECUs.\n";
                        vm.fnGetCompletedJob();
                    }, 100)
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'requestType\' = 'NEW_ECU_SOFTWARE_VERSION_REQUEST'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                _.forEach(res.data, function (jobObj) {
                                    var isFindJob = _.find(vm.jobsArr, {id: jobObj.id});
                                    if (isFindJob) {
                                        var isFindInCompletedJob = _.find(vm.completedJob, {id: isFindJob.id});
                                        if (!isFindInCompletedJob) {
                                            vm.completedJob.push(isFindJob);
                                        }
                                    }
                                });
                                if (vm.completedJob.length !== vm.jobsArr.length) {
                                    if (vm.jobsArr.length !== 0) {
                                        vm.jobAPITimeout = $timeout(function () {
                                            vm.fnGetCompletedJob();
                                        }, 10000);
                                    }
                                } else {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(vm.completedJob[vm.completedJob.length - 1].completedAt) + "     " + vm.jobsArr.length + " ECUs job successfully completed.\n";
                                }
                            } else {
                                if (vm.jobsArr.length !== 0) {
                                    vm.jobAPITimeout = $timeout(function () {
                                        vm.fnGetCompletedJob();
                                    }, 10000);
                                }
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('softwareBroadcastCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, swal, sqlFormatter, microSpinner, softwareObj, SoftwareFactory) {
                var vm = this;
                vm.selectedSoftware = _.cloneDeepWith(softwareObj);
                vm.availableDataLibs = ['ql_S4'];
                vm.softwareQueryConfig = {
                    value: {},
                    editorValue: ''
                };
                vm.isSoftwareSearchDataLoading = false;
                /*var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });*/

                vm.fnRunSoftwareSearchQuery = function () {
                    if (vm.softwareQueryConfig.value.getData().length) {
                        vm.isSoftwareSearchDataLoading = true;
                        vm.softwareSearchData = [];
                        var input = {
                            "sql": vm.softwareQueryConfig.value.getData()
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            vm.softwareSearchData = res.data;
                            vm.softwareSearchDataHeader = [];
                            _.forEach(vm.softwareSearchData, function (dataObj) {
                                _.forEach(Object.keys(dataObj), function (value) {
                                    vm.softwareSearchDataHeader.push(value);
                                });
                            });
                            vm.softwareSearchDataHeader = _.uniq(_.map(vm.softwareSearchDataHeader)).sort();
                            vm.isSoftwareSearchDataLoading = false;
                        }, function () { // Error block
                            vm.isSoftwareSearchDataLoading = false;
                        });
                    }
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnBroadcastECUSoftware = function (softwareObj) {
                    vm.isBroadcastNewECUSoftware = true;
                    swal({
                            title: "Broadcast the selected Software?",
                            text: "This will update the software for all the ECU returned. Would you like to proceed ?",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Yes",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var input = {
                                    softwareId: softwareObj.id,
                                    body: {
                                        sql: vm.softwareQueryConfig.value.getData()
                                    }
                                };
                                SoftwareFactory.broadcastNewECUSoftware(input)
                                    .then(function (response) {
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                        vm.isBroadcastNewECUSoftware = false;
                                        $uibModalInstance.close(response);
                                        amaran.success("Software broadcast in progress.");
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                        vm.isBroadcastNewECUSoftware = false;
                                        $uibModalInstance.dismiss('cancel');
                                    });
                            } else {
                                vm.isBroadcastNewECUSoftware = false;
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                });
                            }
                        });
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnFormatSQL = function () {
                    var sql = vm.softwareQueryConfig.value.getData();
                    vm.softwareQueryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                vm.fnInitSoftwareBroadcastModal = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateObserverJobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Update Observer\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('viewAttributesCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, attributesArr, selectedNode) {
                var vm = this;
                vm.attributes = _.cloneDeepWith(attributesArr);
                vm.resetAttributes = _.cloneDeepWith(attributesArr);
                vm.selectedNode = _.cloneDeepWith(selectedNode);

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".modal-body")[0] && angular.element(".local-search-bar")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var searchBar = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = 36;
                        var finalHeight = total - (searchBar + header + 35);
                        angular.element("#nodeViewAttributesTableBody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitViewAttributesModal = function () {
                    _.forEach(vm.attributes, function (attributeObj) {
                        attributeObj.displayName = attributeObj.name && attributeObj.name !== '' ? attributeObj.name : attributeObj.reference;
                        if (Object.keys(attributeObj.properties).includes('readWrite')) {
                            attributeObj.mode = 'RW';
                        } else if (Object.keys(attributeObj.properties).includes('write')) {
                            attributeObj.mode = 'W';
                        } else if (Object.keys(attributeObj.properties).includes('read')) {
                            attributeObj.mode = 'R';
                        } else {
                            attributeObj.mode = '';
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateNodeIoT3ModalCtrl',
            function ($scope, $rootScope, $window, moment, $timeout, $uibModalInstance, jsyaml, amaran, NodeFactory, TypeFormService, nodeObj) {
                var vm = this;
                vm.selectedNode = _.cloneDeepWith(nodeObj);
                vm.fileArray = '';
                vm.selectedIoT3FileObj = {
                    iot3File: '',
                    iot3: {}
                };
                vm.isIoT3FileSelected = false;
                vm.oldForm = [];
                vm.oldModel = {};
                vm.oldSchema = {};
                vm.newForm = [];
                vm.newModel = {};
                vm.newSchema = {};
                vm.isIoT3FormValid = false;
                vm.isNodeRegistering = false;

                vm.fnUpdateIoT3File = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var fileData = fileLoadedEvent.target.result;
                        var testYaml = vm.fnConvertYamlToJson(fileData);
                        if (testYaml === null || angular.isUndefined(testYaml)) {
                            amaran.error('Yaml format is incorrect. Please check it and try again.')
                        } else {
                            vm.selectedIoT3FileObj.iot3File = _.cloneDeepWith(fileData);
                            vm.selectedIoT3FileObj.iot3 = _.cloneDeepWith(testYaml);
                            var tempData = TypeFormService.fnGenerateFormData(vm.selectedIoT3FileObj.iot3.registration.form);
                            vm.newSchema = tempData.schema;
                            vm.newForm = tempData.form;
                            vm.isIoT3FileSelected = true;
                            var tempModelData = _.cloneDeepWith(vm.oldModel);
                            if (Object.keys(tempModelData).length) {
                                _.forEach(vm.newSchema.properties, function (value, key) {
                                    if (value.type === 'object') {
                                        _.forEach(value.properties, function (objValue, objKey) {
                                            if (tempModelData[key] && tempModelData[key][objKey]) {
                                                if (vm.newModel[key]) {
                                                    vm.newModel[key][objKey] = tempModelData[key][objKey];
                                                } else {
                                                    vm.newModel[key] = {};
                                                    vm.newModel[key][objKey] = tempModelData[key][objKey];
                                                }
                                            }
                                        })
                                    } else {
                                        if (tempModelData[key]) {
                                            vm.newModel[key] = tempModelData[key];
                                        }
                                    }
                                });
                            }
                            $scope.$apply();
                        }
                    };
                    reader.readAsText(filesSelected);
                }

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        if (error && Object.keys(error).length) {
                            amaran.error('Yaml format is incorrect. Please check it and try again.')
                        }
                        return false;
                    }
                };

                vm.fnCheckIot3Validation = function (value) {
                    vm.isIoT3FormValid = value;
                    return value;
                };

                vm.fnUpdateNode = function () {
                    vm.isNodeRegistering = true;
                    var input = {
                        nodeId: vm.selectedNode.id,
                        body: {
                            iot3: {
                                iot3: ""
                            },
                            form: {
                                schema: "",
                                values: ""
                            }
                        }
                    };
                    var tempIoT3File = _.cloneDeepWith(angular.toJson(vm.selectedIoT3FileObj.iot3File));
                    input.body.iot3.iot3 = tempIoT3File.substring(1, tempIoT3File.length - 1);
                    input.body.form.schema = _.cloneDeepWith(vm.newSchema);
                    input.body.form.values = _.cloneDeepWith(vm.newModel);
                    NodeFactory.replaceRegistration(input)
                        .then(function () {
                            vm.isNodeRegistering = false;
                            amaran.success("Node update registration in progress.");
                            vm.fnCancel();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeRegistering = false;
                            vm.fnCancel();
                        })
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitUpdateNodeIoT3Modal = function () {
                    vm.oldModel = _.cloneDeepWith(vm.selectedNode.registration.form.values);
                    var tempData = TypeFormService.fnGenerateFormData(vm.selectedNode.registration.form.schema);
                    vm.oldSchema = tempData.schema;
                    vm.oldForm = tempData.form;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeSyncModalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new job has been created to synchronize a node\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeRenameModalCtrl',
            function ($rootScope, $uibModalInstance, amaran, nodeObj, isForCascade, $timeout, BatchFactory, NodeFactory) {
                var vm = this;
                vm.isForCascadeRename = _.cloneDeepWith(isForCascade);
                vm.selectedNodeName = _.cloneDeepWith(nodeObj.name);
                vm.selectedNode = _.cloneDeepWith(nodeObj);
                vm.isNameUpdating = false;
                vm.childNodesArr = [];
                vm.apiResponse = [];
                vm.isNodeInfoLoading = true;
                vm.attributesArr = [];

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnUpdateNodeName = function () {
                    vm.isNameUpdating = true;
                    if (vm.selectedNodeName.includes("{{") && vm.selectedNodeName.includes("}}")) {
                        var newReg = /{{(([^}][^}]?|[^}]}?)*)}}+/g;
                        var newTempStr = '';
                        var tempResult = [];
                        while ((newTempStr = newReg.exec(vm.selectedNodeName)) !== null) {
                            if (tempResult.indexOf(newTempStr[0]) === -1) {
                                tempResult.push(newTempStr[0]);
                            }
                        }
                        var tempNameStr = _.cloneDeepWith(vm.selectedNodeName);
                        _.forEach(tempResult, function (obj) {
                            var str = obj.substring(obj.indexOf("{") + 2, obj.indexOf("}"));
                            var isFind = _.find(vm.attributesArr, {reference: str})
                            if (isFind) {
                                tempNameStr = tempNameStr.replaceAll(obj, isFind.value);
                            }
                        });
                        vm.selectedNodeName = tempNameStr;
                    }
                    vm.childNodesArr = [];
                    if (vm.isForCascadeRename) {
                        var tempNodeObj = _.cloneDeepWith(vm.selectedNode);
                        if (tempNodeObj.children && tempNodeObj.children.length) {
                            fnCreateNodeArr(tempNodeObj.children);
                        }
                        vm.selectedNode.newName = vm.selectedNodeName;
                        vm.childNodesArr.unshift(vm.selectedNode);
                        vm.fnRenameMultipleNodes(vm.childNodesArr)
                    } else {
                        var inputObj = {
                            nodeId: vm.selectedNode.id,
                            body: {
                                name: vm.selectedNodeName
                            }
                        };
                        NodeFactory.updateNodeName(inputObj)
                            .then(function (res) { // Success block
                                vm.isNameUpdating = false;
                                amaran.success("Node Updated Successfully");
                                $uibModalInstance.close([{body: res}]);
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                $uibModalInstance.close([]);
                                vm.isNameUpdating = false;
                            })
                    }
                };

                function fnCreateNodeArr(data) {
                    _.forEach(data, function (dataObj) {
                        if (dataObj.name.startsWith(vm.selectedNode.name) && dataObj.isCheck) {
                            dataObj.newName = dataObj.name.replace(vm.selectedNode.name, vm.selectedNodeName);
                            vm.childNodesArr.push(dataObj);
                        }
                        if (dataObj.children && dataObj.children.length) {
                            fnCreateNodeArr(dataObj.children);
                        }
                    });
                }

                vm.fnRenameMultipleNodes = function (selectedNodesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    vm.apiResponse = [];

                    angular.forEach(selectedNodesArr, function (selectedNode, index) {
                        if (index <= step) {
                            inputObj.method = "PATCH";
                            inputObj.id = index;
                            inputObj.path = "/node/nodes/" + selectedNode.id + "/names";
                            inputObj.body = {name: selectedNode.newName};
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PATCH";
                            inputObj.id = index;
                            inputObj.path = "/node/nodes/" + selectedNode.id + "/names";
                            inputObj.body = {name: selectedNode.newName};
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    count = 1;
                    vm.fnRenameBatchOperation(batchCollectionObj, count);
                };

                vm.fnRenameBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (res) {
                        _.forEach(res, function (resObj) {
                            vm.apiResponse.push(resObj);
                        })
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnRenameBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success("Node Updated Successfully");
                            $uibModalInstance.close(vm.apiResponse);
                            vm.isNameUpdating = false;
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnRenameBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success("Node Updated Successfully");
                            $uibModalInstance.close(vm.apiResponse);
                            vm.isNameUpdating = false;
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    });
                };

                vm.fnInitNodeRenameModal = function () {
                    NodeFactory.describeNode({nodeId: vm.selectedNode.id})
                        .then(function (res) {
                            vm.attributesArr = res.attributes ? res.attributes : [];
                            vm.isNodeInfoLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeInfoLoading = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeNotesModalCtrl',
            function ($rootScope, $timeout, $uibModalInstance, amaran, IconService, ColorService, NodeFactory, nodeObj, permissionObj) {
                var vm = this;
                vm.nodeObj = nodeObj;
                vm.permissionObj = permissionObj;
                vm.isNodeLoading = true;
                vm.isDetailsEditable = false;
                vm.isNotesUpdating = false;
                vm.newCommentMarkedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview",
                    hiddenButtons: ['all']
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetNodeInfo = function () {
                    NodeFactory.describeNode({nodeId: vm.nodeObj.id})
                        .then(function (res) {
                            vm.nodeObj = res;
                            vm.mdBody = vm.nodeObj.notes;
                            vm.isNodeLoading = false;
                        }, function () {
                            //vm.nodeObj = {};
                            vm.isNodeLoading = false;
                        })
                };

                vm.fnEditNodeNotes = function (name) {
                    vm.isDetailsEditable = true;
                    $timeout(function () {
                        $rootScope.markdownEditorObjects[name].hidePreview();
                    }, 100);
                };

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                    }
                };

                vm.fnSaveNotes = function (name) {
                    vm.isNotesUpdating = true;
                    var inputObj = {
                        nodeId: vm.nodeObj.id,
                        body: {
                            notes: vm.mdBody
                        }
                    };
                    NodeFactory.updateNodeNote(inputObj)
                        .then(function (response) {
                            $rootScope.markdownEditorObjects[name].showPreview();
                            amaran.success('Notes save successfully');
                            $uibModalInstance.close(response);
                            vm.isNotesUpdating = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $uibModalInstance.dismiss('cancel');
                            vm.isNotesUpdating = false;
                        })
                };

                vm.fnInitNodeNotesModal = function () {
                    vm.fnGetNodeInfo();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeDeleteJobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    mode: 'text/plain',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to delete node\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeDiscoverJobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: 'text/plain',
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to re-discover node\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('mermaidEditorCtrl',
            function ($rootScope, $timeout, $uibModalInstance, value, nodeHierarchicalData) {
                var vm = this;
                vm.newMarkedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    hiddenButtons: ['all']
                };
                vm.mdBody = value;
                vm.nodeHierarchicalData = _.cloneDeepWith(nodeHierarchicalData)
                vm.isShowNodeExpandOption = false;

                vm.fnChangeEditorValue = function () {
                    var newReg = /(\w{8})-ne((\w{6}))-nn((\w{6}))\[\*\]+/g;
                    vm.isShowNodeExpandOption = newReg.exec(vm.mdBody) !== null;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSaveNotes = function () {
                    $uibModalInstance.close(vm.mdBody);
                };

                vm.fnExpandNodes = function() {
                    var newReg = /(\w{8})-ne((\w{6}))-nn((\w{6}))\[\*\]+/g;
                    var finalMermaidString = _.cloneDeepWith(vm.mdBody);
                    var newTempStr = '';
                    var tempResult = [];
                    vm.graphStr = '';
                    while ((newTempStr = newReg.exec(vm.mdBody)) !== null) {
                        if (tempResult.indexOf(newTempStr[0]) === -1) {
                            tempResult.push(newTempStr[0]);
                            var tempId = newTempStr[0].replace(/\[\*\]/g, "");
                            var isFindData = {};
                            if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === tempId) {
                                isFindData = vm.nodeHierarchicalData;
                            } else {
                                isFindData = searchRecursiveForDownstream(_.cloneDeepWith(vm.nodeHierarchicalData.children), tempId)
                            }
                            if (isFindData && isFindData.id && isFindData.id !== "") {
                                fnCreateMermaidGraph(isFindData.children, isFindData.id);
                            }
                        }
                    }
                    finalMermaidString = finalMermaidString.replace(/\[\*\]/g, "");
                    finalMermaidString += vm.graphStr;
                    vm.mdBody = _.cloneDeepWith(finalMermaidString);
                    vm.fnChangeEditorValue();
                }

                function fnCreateMermaidGraph(data, id) {
                    _.forEach(data, function (dataObj) {
                        vm.graphStr += '\n ' + id + "-->" + dataObj.id;
                        if (dataObj.children && dataObj.children.length) {
                            fnCreateMermaidGraph(dataObj.children, dataObj.id);
                        }
                    });
                }

                function searchRecursiveForDownstream(data, id, testingData) {
                    var found = _.find(data, {id: id})
                    if (!found) {
                        var i = 0;
                        while (!found && i < data.length) {
                            if (data[i].children && data[i].children.length) {
                                found = searchRecursiveForDownstream(data[i].children, id, testingData);
                            }
                            i++;
                        }
                    }
                    return found;
                }

                vm.fnInitMermaidEditor = function () {
                    vm.mdBody = value;
                    vm.fnChangeEditorValue();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeJobTerminalCtrl',
            function ($rootScope, $window, swal, moment, $timeout, $uibModalInstance, $cookies, QueryFactory, UserProfileService,
                      amaran, nodeObj, isEcuTunnel, jsyaml, TunnelFactory, NodeEcuFactory, NodeFactory, $http, DB, $log) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';
                vm.tunnelTypes = [];
                vm.selectedTunnelType = '';
                vm.isShowTerminal = false;
                vm.nodeDetailsLoading = true;
                vm.isTunnelRequestActive = false;

                vm.jobObj = {};
                vm.nodeObj = _.cloneDeepWith(nodeObj);
                vm.isEcuTunnel = _.cloneDeepWith(isEcuTunnel);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.timeOutOptions = [{
                    displayName: '10 Minutes',
                    value: 600
                }, {
                    displayName: '20 Minutes',
                    value: 1200
                }, {
                    displayName: '30 Minutes',
                    value: 1800
                }, {
                    displayName: '45 Minutes',
                    value: 2700
                }, {
                    displayName: '1 Hour',
                    value: 3600
                }];

                //nodeTunnelDuration
                var tunnelDuration = UserProfileService.fnGetSystemProfileObj('nodeTunnelDuration');
                if (tunnelDuration === '') {
                    vm.selectedTimeout = _.cloneDeepWith(vm.timeOutOptions[0]);
                } else {
                    vm.selectedTimeout = _.cloneDeepWith(tunnelDuration);
                }

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        try {
                            var parsedItem = _.cloneDeep(item);

                            // Parse the nested data JSON string
                            var parsedData = angular.isString(parsedItem.data) ?
                                angular.fromJson(parsedItem.data) : parsedItem.data;

                            // Convert timestamps
                            var finalItem = {
                                id: parsedItem.id || parsedData.id,
                                jobResult: parsedData.jobResult || '',
                                startedAt: parsedData.startedAt ? parseInt(parsedData.startedAt) : null,
                                completedAt: parsedData.completedAt ? parseInt(parsedData.completedAt) : null,
                                requestType: parsedData.requestType || '',
                                ecuId: parsedData.ecuId || '',
                                projectId: parsedData.projectId || '',
                                expiresAt: parsedData.expiresAt ? parseInt(parsedData.expiresAt) : null,
                                requestedBy: parsedData.requestedBy || '',
                                audits: parsedData.audits || '',
                                // Keep original timestamps too
                                created_at: parsedItem.created_at,
                                updated_at: parsedItem.updated_at
                            };

                            // Return merged data
                            return angular.extend({}, parsedData, finalItem);

                        } catch (e) {
                            $log.error('Error parsing job data:', e, item);
                            return item;
                        }
                    });
                }

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Open a Tunnel\n";
                        if (vm.isEcuTunnel) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.nodeObj.name + "' ECU (" + vm.nodeObj.id + ") to acknowledge the job\n";
                        } else {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.nodeObj.name + "' Node (" + vm.nodeObj.id + ") to acknowledge the job\n";
                        }
                        if (vm.nodeObj.connected !== true) {
                            if (vm.isEcuTunnel) {
                                vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the Node comes back online\n";
                            } else {
                                vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The Node is currently offline the job will continue when the Node comes back online\n";
                            }
                        } else {
                            //vm.fnGetPendingJob();
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.nodeObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.nodeObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
                }

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedResults = parsePostgresData(res.data);
                            $log.debug('Parsed completed job results:', parsedResults);

                            if (parsedResults && parsedResults.length) {
                                var jobData = parsedResults[0];

                                if (jobData.audits && jobData.audits.length) {
                                    var tempAuditsArr = jobData.audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(jobData.startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }

                                if (jobData.jobResult === "SUCCESS") {
                                    var guidStr = guid();
                                    vm.jobSummary += " >              The Job was executed successfully.\n";
                                    vm.jobSummary += " >              One moment while we create a secure tunnel.\n";
                                    vm.jobSummary += " >              This can take up to 60 seconds.\n";
                                    var basePath = '';
                                    var url = '';
                                    var environment = 'prod';
                                    if(Object.keys(HOST_URL).length) { //eslint-disable-line
                                        url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                                        if (url.startsWith('dev')) {
                                            environment = 'dev';
                                            basePath = 'https://dev-tunnel.ecsmon.ecsiteapp.com'
                                        } else {
                                            basePath = 'https://tunnel.ecsmon.ecsiteapp.com'
                                        }
                                    } else {
                                        basePath = 'https://tunnel.ecsmon.ecsiteapp.com'
                                    }
                                    var apiURL = basePath + "/tunnel/"; //eslint-disable-line
                                    var authToken = '';
                                    if (DB.fnGet('federation')) {
                                        authToken = 'Basic ' + DB.fnGet('federation').sessionObj.federationToken;
                                    } else if (DB.fnGet('support')) {
                                        authToken = 'Basic ' + DB.fnGet('support').sessionObj.supportToken;
                                    } else {
                                        authToken = 'Basic ' + $cookies.get('phoenix')
                                    }
                                    var headers = {
                                        'Content-Type': 'application/json',
                                        'Authorization': authToken,
                                        'deviceId': vm.nodeObj.id,
                                        'jobId': vm.jobObj.id,
                                        'jobUuid': guidStr,
                                        'timeout': vm.selectedTimeout.value,
                                        'tunnelType': vm.selectedTunnelType,
                                        'predictiveEnvironment': environment
                                    };
                                    $http({
                                        method: "GET",
                                        url: apiURL,
                                        responseType: 'application/json',
                                        headers: headers
                                    }).then(function (response) {
                                        if (response && response.data && response.data.tunnel_port) {
                                            $cookies.put('predictivetunnel_' + vm.jobObj.id, guidStr, {domain: '.ecsmon.ecsiteapp.com', samesite: 'None', secure: true});
                                            vm.jobSummary += " >              Tunnel established successfully. Opening the tunnel in a new tab.\n";
                                            var popup_window = '';
                                            if (response.data.path && response.data.path !== '') {
                                                vm.jobSummary += " >              Tunnel URL : " + basePath + ":" + response.data.tunnel_port + response.data.path + ".\n";
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port + response.data.path, '_blank');
                                            } else {
                                                vm.jobSummary += " >              Tunnel URL : " + basePath + ":" + response.data.tunnel_port + ".\n";
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port, '_blank');
                                            }
                                            try {
                                                popup_window.focus();
                                            }
                                            catch (e) {
                                                swal({
                                                    title: "Pop-up Blocker is enabled!",
                                                    text: "This site uses pop-up for the tunnel. Please enable them for this website in your browser or add this site to your exception list.",
                                                    type: "warning",
                                                    html: true,
                                                    showCancelButton: true,
                                                    showCancelButtonText: 'OK',
                                                    showConfirmButton: false,
                                                    showLoaderOnConfirm: false
                                                });
                                            }
                                        } else {
                                            vm.jobSummary += " >              We encountered an error while trying to establish a secure connection. Please try again.\n";
                                        }
                                    }, function error() {

                                    });
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) {
                            $log.error('Error fetching completed job:', error);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    }
                    catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        return false;
                    }
                };

                vm.fnRequestNodeTunnel = function (nodeObj) {
                    vm.isTunnelRequestActive = true;
                    var inputObj = {
                        timeout: vm.selectedTimeout.value,
                        type: vm.selectedTunnelType === 'HTTPS' ? 'HTTP' : vm.selectedTunnelType
                    };
                    if (vm.isEcuTunnel) {
                        inputObj.ecuId = nodeObj.id;
                        NodeEcuFactory.ecuTunnelRequest(inputObj)
                            .then(function (response) {
                                vm.jobObj = _.cloneDeepWith(response);
                                amaran.success("ECU tunnel request is in progress.");
                                vm.isTunnelRequestActive = false;
                                vm.isShowTerminal = true;
                            }, function (error) {
                                vm.isTunnelRequestActive = false;
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            })
                    } else {
                        inputObj.nodeId = nodeObj.id;
                        NodeFactory.requestNodeTunnel(inputObj)
                            .then(function (response) {
                                vm.jobObj = _.cloneDeepWith(response);
                                amaran.success("Node tunnel request is in progress.");
                                vm.isTunnelRequestActive = false;
                                vm.isShowTerminal = true;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            })
                    }
                };

                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.setUpEcuTunnel = function () {
                    vm.tunnelTypes.push({
                        name: 'SSH'
                    });
                    vm.fnSelectTunnelType(vm.tunnelTypes[0]);
                    vm.nodeDetailsLoading = false;
                };

                vm.fnGetNodeDetails = function (nodeObj) {
                    var inputObj = {
                        nodeId: nodeObj.id
                    };
                    NodeFactory.describeNode(inputObj)
                        .then(function (response) {
                            vm.nodeObj = _.cloneDeepWith(response);
                            vm.iot3Obj = vm.fnConvertYamlToJson(response.registration.iot3.iot3);
                            if (vm.iot3Obj.engine) {
                                if (vm.iot3Obj.engine.tunneling) {
                                    if (vm.iot3Obj.engine.tunneling.http && vm.iot3Obj.engine.tunneling.http.supported) {
                                        if (vm.iot3Obj.engine.tunneling.http.displayInstructions &&
                                            vm.iot3Obj.engine.tunneling.http.displayInstructions.protocol &&
                                            vm.iot3Obj.engine.tunneling.http.displayInstructions.protocol.length &&
                                            vm.iot3Obj.engine.tunneling.http.displayInstructions.protocol.toLowerCase() === 'https') {
                                            vm.tunnelTypes.push({
                                                name: 'HTTPS'
                                            })
                                        } else {
                                            vm.tunnelTypes.push({
                                                name: 'HTTP'
                                            })
                                        }
                                    }

                                    if (vm.iot3Obj.engine.tunneling.ssh && vm.iot3Obj.engine.tunneling.ssh.supported) {
                                        vm.tunnelTypes.push({
                                            name: 'SSH'
                                        })
                                    }

                                } else if (vm.iot3Obj.engine.tunnel) {
                                    if (vm.iot3Obj.engine.tunnel.http && vm.iot3Obj.engine.tunnel.http.supported) {
                                        if (vm.iot3Obj.engine.tunnel.http.displayInstructions &&
                                            vm.iot3Obj.engine.tunnel.http.displayInstructions.protocol &&
                                            vm.iot3Obj.engine.tunnel.http.displayInstructions.protocol.length &&
                                            vm.iot3Obj.engine.tunnel.http.displayInstructions.protocol.toLowerCase() === 'https') {
                                            vm.tunnelTypes.push({
                                                name: 'HTTPS'
                                            })
                                        } else {
                                            vm.tunnelTypes.push({
                                                name: 'HTTP'
                                            })
                                        }
                                    }

                                    if (vm.iot3Obj.engine.tunnel.ssh && vm.iot3Obj.engine.tunnel.ssh.supported) {
                                        vm.tunnelTypes.push({
                                            name: 'SSH'
                                        })
                                    }
                                }

                                if (vm.tunnelTypes.length) {
                                    vm.fnSelectTunnelType(vm.tunnelTypes[0]);
                                }
                            }
                            vm.nodeDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeDetailsLoading = false;
                        })
                };

                vm.fnInitJobTerminalModal = function () {
                    if (vm.isEcuTunnel) {
                        vm.setUpEcuTunnel(vm.nodeObj);
                    } else {
                        vm.fnGetNodeDetails(vm.nodeObj);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('iot3SupportCtrl',
            function ($uibModalInstance) {
                var vm = this;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuListCtrl',
            function ($rootScope, $window, $timeout, $uibModal, $uibModalInstance, ColorService, amaran, moment, PaginationQueryService, QueryFactory, DB, AppInitService, UserProfileService) {
                var vm = this;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitEcu = true;
                vm.defaultECUFilterArr = [{
                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                    selectedField: "registered",
                    displaySelectedField: "Registered",
                    searchText: '',
                    displaySearchText: '',
                    isDirectFilterApply: true,
                    sqlValue: 'data->\'registered\' = \'true\'',
                    localSearchValue: 'obj.registered === true'
                }];

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Registered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'true\'',
                        localSearchValue: 'obj.registered === true'
                    }, {
                        displayName: "Unregistered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'registered = false',
                        localSearchValue: 'obj.registered === false'
                    }, {
                        displayName: "Phase",
                        name: "phase",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->\'connected\' = \'false\' or data->\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "NTP",
                        name: "ntp",
                        localSearch: {
                            type: 'objects',
                            name: 'ntp',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Enabled',
                                id: 'ENABLED'
                            }, {
                                name: 'Disabled',
                                id: 'DISABLED'
                            }, {
                                name: 'Enabling',
                                id: 'ENABLING'
                            }, {
                                name: 'Disabling',
                                id: 'DISABLING'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }, {
                        displayName: "VPN",
                        name: "vpn",
                        localSearch: {
                            type: 'objects',
                            name: 'vpn',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Enabled',
                                id: 'ENABLED'
                            }, {
                                name: 'Disabled',
                                id: 'DISABLED'
                            }, {
                                name: 'Enabling',
                                id: 'ENABLING'
                            }, {
                                name: 'Disabling',
                                id: 'DISABLING'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                vm.ecuProjectFilter = "$";
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};

                //Ecus Variables
                vm.isEcusLoading = false;
                vm.ecusArr = [];

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.ecuResponse = [];

                /*function parsePostgresData(items) {
    return items.map(function(item) {
        var parsedItem = _.cloneDeep(item);

        // Handle timestamps standardization
        if (angular.isDefined(parsedItem.updatedAt)) {
            parsedItem.updatedAt = parsedItem.updatedAt;
        } else if (angular.isDefined(parsedItem.updated_at)) {
            parsedItem.updatedAt = parsedItem.updated_at;
        }

        if (angular.isDefined(parsedItem.createdAt)) {
            parsedItem.createdAt = parsedItem.createdAt;
        } else if (angular.isDefined(parsedItem.created_at)) {
            parsedItem.createdAt = parsedItem.created_at;
        }

        // Handle ECU connection status
        if (angular.isDefined(parsedItem.ecuConnected)) {
            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
        } else if (angular.isDefined(parsedItem.ecuconnected)) {
            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
        }

        if (angular.isString(parsedItem.data)) {
            try {
                var parsedData = angular.fromJson(parsedItem.data);

                // Handle node connection status from data
                if (angular.isDefined(parsedData.connected)) {
                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                }

                // Set receivedAt from _event_time if available
                if (parsedData._event_time && parsedData._event_time.value) {
                    var microseconds = parseInt(parsedData._event_time.value);
                    if (!isNaN(microseconds)) {
                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                    }
                }

                // Set healthLastChangedAt from updated_at
                if (parsedItem.updated_at) {
                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                }

                // Merge the parsed data with our item
                return angular.extend({}, parsedItem, parsedData);
            } catch (e) {
                $log.error('Error parsing data:', e);
                return parsedItem;
            }
        }
        return parsedItem;
   });
                }*/

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.page) {
                        vm.currentPage = Math.ceil(vm.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.perPage = Math.ceil(vm.perPage)
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/


                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and projectId = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " projectId = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                            });
                            vm.ecuResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                vm.totalItems = vm.ecuResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }
                            vm.ecusArr = vm.ecuResponse.data;
                            vm.isRefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnGetProjectEcu = function (projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnReload = function () {
                    vm.isInitEcu = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnStartNetworkScan = function (ecuObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/ecu/modals/networkScan/networkScan.html',
                        size: 'lg',
                        controller: 'networkScanCtrl as networkScan',
                        windowClass: 'modal-height100',
                        resolve: {
                            ecuObj: function () {
                                return _.cloneDeepWith(ecuObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitECUListModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuInfoModalCtrl',
            function ($uibModalInstance, IconService, ColorService, NodeEcuFactory, nodeObj) {
                var vm = this;
                var nodeInfoObj = nodeObj;
                vm.isECULoading = true;
                vm.ecuObj = {};

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnGetECUInfo = function (ecuId) {
                    NodeEcuFactory.describeECU({ecuId: ecuId})
                        .then(function (res) {
                            vm.ecuObj = res;
                            vm.isECULoading = false;
                        }, function () {
                            vm.ecuObj = {};
                            vm.isECULoading = false;
                        })
                };

                vm.fnInitECUNodeModal = function () {
                    vm.isECULoading = true;
                    vm.fnGetECUInfo(nodeInfoObj.ecuId);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeValueUpdateTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    mode: 'text/plain',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to update attribute\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeEditValueModalCtrl',
            function ($rootScope, $uibModalInstance, amaran, attributeObj, $timeout, NodeAttributesFactory, TypeFormService) {
                var vm = this;
                vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                vm.isValueUpdating = false;
                vm.jsonSchema = "";
                vm.form = [];
                vm.modal = {};

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnUpdateAttributeValue = function () {
                    vm.isValueUpdating = true;
                    var attributeValue = Object.values(vm.model)[0];
                    var inputObj = {
                        attributeId: vm.selectedAttribute.id,
                        body: {
                            value: attributeValue
                        }
                    };
                    NodeAttributesFactory.updateAttributeValue(inputObj)
                        .then(function () { // Success block
                            NodeAttributesFactory.writeAttributeValues({attributeId: vm.selectedAttribute.id})
                                .then(function (jobRes) {
                                    amaran.success('Attribute value are being updated.');
                                    vm.isValueUpdating = false;
                                    $uibModalInstance.close(jobRes);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isValueUpdating = false;
                                })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isValueUpdating = false;
                        })
                };

                vm.fnInitAttributeEditValueModal = function () {
                    vm.jsonSchema = _.cloneDeepWith(angular.fromJson(attributeObj.write));
                    if (vm.jsonSchema && vm.jsonSchema.properties && Object.keys(vm.jsonSchema.properties).length) {
                        var tempData = TypeFormService.fnGenerateFormData(vm.jsonSchema);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        vm.model = {};
                    } else {
                        vm.schema = {
                            $schema: "https://json-schema.org/draft/2019-09/schema",
                            type: "object",
                            properties: {}
                        };
                        vm.form = [];
                        vm.model = {};
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeEditNameModalCtrl',
            function ($rootScope, $uibModalInstance, amaran, attributeObj, $timeout, NodeAttributesFactory) {
                var vm = this;
                vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                vm.isNameUpdating = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnUpdateAttributeName = function () {
                    vm.isNameUpdating = true;
                    var inputObj = {
                        attributeId: vm.selectedAttribute.id,
                        body: {
                            name: vm.selectedAttribute.name
                        }
                    };
                    NodeAttributesFactory.updateAttributeName(inputObj)
                        .then(function (res) { // Success block
                            vm.isNameUpdating = false;
                            $uibModalInstance.close(res);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNameUpdating = false;
                        })
                };

                vm.fnInitAttributeRenameModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('jobInfo', fnJobInfo)

    /** @ngInject */
    function fnJobInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, moment, ColorService, NodeEcuFactory,
                       copyService, NodeProjectFactory, AppInitService, QueryFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/job/jobInfo/jobInfo.html',
            scope: {
                jobObj: '=',
                selectedJobTable: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                var authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                var accountId = authUserObj && authUserObj.id ? authUserObj.id.split("-")[0] : '';
                if ($scope.selectedJobTable.name === 'ecu_completed_jobs') {
                    $scope.tabs = [
                        {
                            title: 'Details',
                            tabIndex: 1,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/details.html'
                        },
                        {
                            title: 'Results',
                            tabIndex: 2,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/jobResults/jobResults.html'
                        },
                        {
                            title: 'Payload',
                            tabIndex: 3,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/jobPayload/jobPayload.html'
                        }
                    ];
                    if (accountId === 'cu000000' && $scope.jobObj.requestType === "EXECUTE_ECU_BASH_REQUEST") {
                        $scope.tabs.push({
                            title: 'Bash Script',
                            tabIndex: 4,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/jobBashScript/jobBashScript.html'
                        });
                        $scope.tabs.push({
                            title: 'Output',
                            tabIndex: 5,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/jobOutput/jobOutput.html'
                        })
                    }
                } else {
                    $scope.tabs = [
                        {
                            title: 'Details',
                            tabIndex: 1,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/details.html'
                        },
                        {
                            title: 'Payload',
                            tabIndex: 2,
                            templateUrl: 'app/node/job/jobInfo/jobTabs/jobPayload/jobPayload.html'
                        }
                    ];
                }
                $scope.jobSummary = '';
                $scope.jobBashCommandDetailsLoaded = false;
                $scope.jobOutput = '';

                $scope.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    mode: 'text/plain',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                $scope.jobBashScriptOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/x-sh",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };
                $scope.scriptObj = {
                    'script': ''
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.job', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnGetStartedTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var tempDate = moment.unix(timestamp).format("MM/DD/YYYY");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var tempCurrentDate = moment.unix(moment().unix()).format("MM/DD/YYYY");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (moment(tempDate).isSame(tempCurrentDate)) {
                        if (differenceHours > 24) {
                            relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' on ' + moment.unix(timestamp).format("DD/MM/YYYY");
                        } else if (differenceHours > 1) {
                            relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' today';
                        } else {
                            relativeTime = moment(datetime).fromNow();
                        }
                    } else {
                        relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' on ' + moment.unix(timestamp).format("DD/MM/YYYY");
                    }
                    return relativeTime;
                };

                $scope.fnGetJob = function (jobId) {
                    var inputObj = {
                        "sql": "SELECT * from " + $scope.selectedJobTable.name + " where id = '" + jobId + "'"
                    };
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            if (response.data && response.data.length) {
                                if (response.data[0].startsAt) {
                                    response.data[0].startsAtTime = $scope.fnGetStartedTime(response.data[0].startsAt);
                                }
                                if (response.data[0].startedAt) {
                                    response.data[0].startedAtTime = $scope.fnGetStartedTime(response.data[0].startedAt);
                                }
                                if (response.data[0].expiresAt) {
                                    response.data[0].expiresAtTime = $scope.fnGetAbsoluteOrRelativeTime(response.data[0].expiresAt);
                                }
                                if (response.data[0].requestType) {
                                    response.data[0].requestTypeString = response.data[0].requestType.replace(/_/g, " ");
                                }
                                if (response.data[0].completedAt) {
                                    response.data[0].completedAtTime = $scope.fnGetStartedTime(response.data[0].completedAt);
                                }
                                $scope.jobObj = response.data[0];
                            } else {
                                $scope.jobObj = {};
                            }
                            if ($scope.jobObj && $scope.jobObj.audits && $scope.jobObj.audits.length) {
                                var tempAuditsArr = $scope.jobObj.audits.split('\n');
                                $scope.jobSummary = '';
                                _.forEach(tempAuditsArr, function (tempAuditsObj) {
                                    if (tempAuditsObj !== '') {
                                        $scope.jobSummary += " > " + moment.unix($scope.jobObj.startedAt).format("HH:mm:ss") + '     ' + tempAuditsObj + "\n";
                                    }
                                });
                            }
                            if ($scope.jobObj.jobResult === 'FAILURE') {
                                $scope.jobSummary += " > " + moment.unix($scope.jobObj.completedAt).format("HH:mm:ss") + "     The job failed and was aborted\n";
                            }
                            if ($scope.jobObj.jobResult === 'SUCCESS') {
                                $scope.jobSummary += " > " + moment.unix($scope.jobObj.completedAt).format("HH:mm:ss") + "     The job successfully completed\n";
                            }
                            if ($scope.jobObj.jobResult === 'MIXED') {
                                $scope.jobSummary += " > " + moment.unix($scope.jobObj.completedAt).format("HH:mm:ss") + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                            }
                            $scope.isJobDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isJobDetailsLoaded = true;
                        })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitJob = function () {
                    $scope.isJobDetailsLoaded = false;
                    if ($scope.jobObj.id) {
                        $scope.fnGetJob($scope.jobObj.id);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitJob();

                $scope.fnInitJobDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitPayload = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitResults = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitJobAudits = function () {
                    $timeout(function () {
                        $scope.jobModeChanged();
                    }, 100);

                };

                $scope.fnInitOutput = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    $scope.jobBashCommandDetailsLoaded = false;
                    NodeEcuFactory.describeBashCommand({jobId: $scope.jobObj.id})
                        .then(function (response) {
                            $scope.jobOutput = '';
                            if (response.output && response.output.length) {
                                var tempOutputsArr = response.output.split('\n');
                                _.forEach(tempOutputsArr, function (tempOutputObj) {
                                    if (tempOutputObj !== '') {
                                        $scope.jobOutput += " >              " + tempOutputObj + "\n";
                                    }
                                });
                            }
                            $scope.jobBashCommandDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.jobBashCommandDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        })
                };

                $scope.fnInitBashScript = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    $scope.jobBashCommandDetailsLoaded = false;
                    NodeEcuFactory.describeBashCommand({jobId: $scope.jobObj.id})
                        .then(function (response) {
                            $scope.scriptObj.script = response.script;
                            $scope.jobBashCommandDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.jobBashCommandDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        })
                };
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createIoT3Ctrl',
            function ($scope, $window, $uibModal, $timeout, amaran, jsyaml, moment, microSpinner, swal,
                      postActionModelIcon, postActionModelMessage, NodeIoT3Factory) {
                var vm = this;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                vm.tabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1,
                        templateUrl: 'app/node/iot3/iot3Service/createIot3/iot3CreateSteps/details.html'
                    },
                    {
                        title: 'Nodes',
                        tabIndex: 2,
                        templateUrl: 'app/node/iot3/iot3Service/createIot3/iot3CreateSteps/iot3Nodes/iot3Nodes.html'
                    },
                    {
                        title: 'Iot3',
                        tabIndex: 3,
                        templateUrl: 'app/node/iot3/iot3Service/createIot3/iot3CreateSteps/iot3Edtior/iot3Editor.html'
                    }
                ];

                vm.iot3Obj = {
                    iot3JSON: {},
                    iot3: ''
                };

                vm.selectedTab = 3;
                vm.isDetailsEditable = false;
                vm.isIot3ReferenceLoaded = true;
                vm.isIot3ReferenceSaving = false;
                vm.searchText = '';

                vm.cloneReferenceId = '';

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            vm.isChangesSync = false;
                            $timeout(function () {
                                vm.fnChangeDone();
                            }, 100);
                        });

                        vm.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };
                    }
                };

                vm.fnChangeDone = function (isCalledFromInit) {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100);
                    var isValidJson = vm.fnConvertYamlToJson(vm.iot3Obj.iot3);
                    if (isValidJson !== false) {
                        vm.iot3Obj.iot3JSON = isValidJson;

                        if ((angular.isDefined(vm.iot3Obj.iot3JSON) &&
                            vm.iot3Obj.iot3JSON !== 'undefined') &&
                            Object.keys(vm.iot3Obj.iot3JSON).length) {

                            if (!vm.iot3Obj.iot3JSON.info) {
                                vm.iot3Obj.iot3JSON.info = {};
                                vm.iot3Obj.iot3JSON.info.created = '';
                                vm.iot3Obj.iot3JSON.info.updated = '';
                                vm.iot3Obj.iot3JSON.info.labelsArr = [];
                                if (isCalledFromInit) {
                                    vm.iot3Obj.iot3JSON.info.revision = 1;
                                }
                            } else {
                                if (vm.iot3Obj.iot3JSON.info.created) {
                                    vm.iot3Obj.iot3JSON.info.created = vm.iot3Obj.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3Obj.iot3JSON.info.created = '';
                                }
                                if (vm.iot3Obj.iot3JSON.info.updated) {
                                    vm.iot3Obj.iot3JSON.info.updated = vm.iot3Obj.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3Obj.iot3JSON.info.updated = '';
                                }

                                vm.iot3Obj.iot3JSON.info.labelsArr = [];
                                if (vm.iot3Obj.iot3JSON.info.labels && vm.iot3Obj.iot3JSON.info.labels.length) {
                                    _.forEach(vm.iot3Obj.iot3JSON.info.labels, function (labelName) {
                                        var colorObj = vm.fnGetLabelColor();
                                        vm.iot3Obj.iot3JSON.info.labelsArr.push({
                                            name: labelName,
                                            bgColor: colorObj['background-color'],
                                            textColor: colorObj.color
                                        })
                                    })
                                }

                                if (isCalledFromInit) {
                                    if (vm.iot3Obj.iot3JSON.info.revision && angular.isNumber(vm.iot3Obj.iot3JSON.info.revision)) {
                                        vm.iot3Obj.iot3JSON.info.revision = vm.iot3Obj.iot3JSON.info.revision + 1;
                                    }
                                }
                            }

                            if (!vm.iot3Obj.iot3JSON.template) {
                                vm.iot3Obj.iot3JSON.template = {};
                                vm.iot3Obj.iot3JSON.template.typesArr = [];
                            } else {
                                vm.iot3Obj.iot3JSON.template.typesArr = [];
                                if (vm.iot3Obj.iot3JSON.template.types &&
                                    Object.keys(vm.iot3Obj.iot3JSON.template.types).length) {
                                    _.forEach(vm.iot3Obj.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3Obj.iot3JSON.template.typesArr.push(tempObj)
                                    });
                                }
                            }

                            if (!vm.iot3Obj.iot3JSON.engine) {
                                vm.iot3Obj.iot3JSON.engine = {};
                                vm.iot3Obj.iot3JSON.engine.engineType = '';
                            } else {
                                vm.iot3Obj.iot3JSON.engine.engineType = '';
                                if (vm.iot3Obj.iot3JSON.engine.http) {
                                    vm.iot3Obj.iot3JSON.engine.engineType = 'HTTP';
                                } else if (vm.iot3Obj.iot3JSON.engine.ssh) {
                                    vm.iot3Obj.iot3JSON.engine.engineType = 'SSH';
                                }
                            }

                            if (isCalledFromInit) {
                                vm.iot3Obj.iot3 = jsyaml.dump(vm.iot3Obj.iot3JSON, {lineWidth: -1})
                            }
                        }
                        vm.isChangesSync = true;
                        $timeout(function () {
                            vm.setLine();
                        });
                    } else {
                        vm.isChangesSync = false;
                        //amaran.error('YAML format is not valid.');
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        return false;
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                vm.fnGetLabelColor = function () {
                    var labelColor = '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
                    var labelTextColor = vm.fnInvertColor(labelColor);
                    return {
                        "background-color": labelColor,
                        "color": "" + labelTextColor
                    }
                };

                vm.fnViewAttributes = function (iot3TypeObj) {
                    var attributes = _.filter(vm.iot3Obj.iot3JSON.template.attributes, function (value, key) {
                        value.reference = key;
                        return iot3TypeObj.attributes.includes(key);
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/viewAttributes/viewAttributes.html',
                        size: 'lg',
                        controller: 'viewAttributesCtrl as viewAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedNode: function () {
                                return _.cloneDeepWith(iot3TypeObj);
                            },
                            attributesArr: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnDeleteIot3Reference = function (id) {
                    var inputObj = {
                        iot3Id: id
                    };
                    NodeIoT3Factory.deleteIoT3Reference(inputObj)
                        .then(function () {
                            swal({
                                title: postActionModelMessage,
                                html: true,
                                imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'customSwalActionModel'
                            });
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            $timeout(function () {
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                $scope.$emit('iot3Added', id);
                            },1000);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element('.microSpinner').remove();
                            angular.element(".confirm").css("visibility", "visible");
                            $scope.$emit('iot3Added');
                        })
                };

                vm.fnSaveIot3Reference = function () {
                    vm.isIot3ReferenceSaving = true;
                    var inputObj = {
                        body: {
                            iot3: vm.iot3Obj.iot3
                        }
                    };
                    NodeIoT3Factory.createIoT3Reference(inputObj)
                        .then(function () {
                            amaran.success('IoT3 Reference added successfully');
                            vm.isIot3ReferenceSaving = false;
                            if (vm.cloneReferenceId && vm.cloneReferenceId.length) {
                                swal({
                                        title: "Delete the original IoT3 reference?",
                                        text: "Do you want to delete the original IoT3 reference. Please note that this operation cannot be undone.",
                                        type: "warning",
                                        html: true,
                                        showCancelButton: true,
                                        confirmButtonText: "delete",
                                        closeOnConfirm: false,
                                        showLoaderOnConfirm: true
                                    },
                                    function (isConfirm) {
                                        if (isConfirm) {
                                            angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                            angular.element(".confirm").css("visibility", "hidden");
                                            vm.fnDeleteIot3Reference(vm.cloneReferenceId);
                                        } else {
                                            $scope.$emit('iot3Added');
                                        }
                                    });
                            } else {
                                $scope.$emit('iot3Added');
                            }
                        }, function (err) {
                            amaran.error(err);
                            vm.isIot3ReferenceSaving = false;
                        })
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 100)
                };

                vm.fnTabSelected = function (tab) {
                    vm.selectedTab = tab.tabIndex;
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }

                    if (angular.isDefined(angular.element(".iot3NodeMainContent")[0]) &&
                        angular.isDefined(angular.element(".local-search-bar")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var totalNodes = angular.element(".iot3NodeMainContent")[0].offsetHeight;
                        var search = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightNode = totalNodes - (search + header + 10);
                        angular.element("#iot3NodeTableBody").css('height', finalHeightNode + 'px');
                    }
                };

                vm.fnInitIot3 = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                    var iot3CloneObj = angular.fromJson(localStorage.getItem('iot3CloneObj'));
                    if (iot3CloneObj && iot3CloneObj.iot3YamlStr) {
                        vm.cloneReferenceId = _.cloneDeepWith(iot3CloneObj.referenceId);
                        vm.iot3Obj.iot3 = _.cloneDeepWith(iot3CloneObj.iot3YamlStr);
                        localStorage.removeItem('iot3CloneObj');
                        $timeout(function () {
                            vm.fnChangeDone(true);
                        })
                    }
                };
                /*-------End: Controller Code------*/
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('iot3ServiceInfo', fnIot3ServiceInfo)

    /** @ngInject */
    function fnIot3ServiceInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran,
                               jsyaml, moment, AppInitService, NodeIoT3Factory, copyService, postActionModelIcon,
                               $uibModal, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/iot3/iot3Service/iot3Info/iot3Info.html',
            scope: {
                iot3Obj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                $scope.tabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1,
                        templateUrl: 'app/node/iot3/iot3Service/iot3Info/iot3Steps/details.html'
                    },
                    {
                        title: 'Nodes',
                        tabIndex: 2,
                        templateUrl: 'app/node/iot3/iot3Service/iot3Info/iot3Steps/iot3Nodes/iot3Nodes.html'
                    },
                    {
                        title: 'Iot3',
                        tabIndex: 3,
                        templateUrl: 'app/node/iot3/iot3Service/iot3Info/iot3Steps/iot3Edtior/iot3Editor.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 3;
                    }
                } else {
                    $scope.selectedTab = 3;
                }
                $scope.isDetailsEditable = false;
                $scope.isIot3ReferenceLoaded = false;
                $scope.searchText = '';

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            $scope.isChangesSync = false;
                        });

                        $scope.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };
                    }
                };

                $scope.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        $scope.setLine(_.cloneDeepWith(error));
                        return false;
                    }
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                $scope.fnGetLabelColor = function () {
                    var labelColor = '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
                    var labelTextColor = $scope.fnInvertColor(labelColor);
                    return {
                        "background-color": labelColor,
                        "color": "" + labelTextColor
                    }
                };

                $scope.fnViewAttributes = function (iot3TypeObj) {
                    var attributes = _.filter($scope.iot3Obj.iot3JSON.template.attributes, function (value, key) {
                        value.reference = key;
                        return iot3TypeObj.attributes.includes(key);
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/viewAttributes/viewAttributes.html',
                        size: 'lg',
                        controller: 'viewAttributesCtrl as viewAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedNode: function () {
                                return _.cloneDeepWith(iot3TypeObj);
                            },
                            attributesArr: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        $scope.modeChanged();
                    }, 100)
                };

                $scope.fnGetIot3Reference = function (iot3Id) {
                    var inputObj = {
                        iot3Id: iot3Id
                    };
                    NodeIoT3Factory.describeIoT3Reference(inputObj)
                        .then(function (response) {
                            $scope.iot3Obj = response;

                            $scope.iot3Obj.labelsArr = [];
                            if ($scope.iot3Obj.labels && $scope.iot3Obj.labels.length) {
                                _.forEach($scope.iot3Obj.labels, function (labelName) {
                                    var colorObj = $scope.fnGetLabelColor();
                                    $scope.iot3Obj.labelsArr.push({
                                        name: labelName,
                                        bgColor: colorObj['background-color'],
                                        textColor: colorObj.color
                                    })
                                })
                            }

                            if ($scope.iot3Obj.createdAt) {
                                $scope.iot3Obj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.iot3Obj.createdAt);
                            }

                            if ($scope.iot3Obj.updatedAt) {
                                $scope.iot3Obj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.iot3Obj.updatedAt);
                            }

                            if ($scope.iot3Obj.iot3) {
                                var testYaml = jsyaml.load($scope.iot3Obj.iot3);
                                if (!(testYaml === null ||  angular.isUndefined(testYaml))) {
                                    $scope.iot3Obj.iot3JSON = $scope.fnConvertYamlToJson($scope.iot3Obj.iot3);

                                    if ($scope.iot3Obj.iot3JSON) {
                                        if ($scope.iot3Obj.iot3JSON.engine) {
                                            if ($scope.iot3Obj.iot3JSON.engine.http) {
                                                $scope.engineType = 'HTTP';
                                            } else if ($scope.iot3Obj.iot3JSON.engine.ssh) {
                                                $scope.engineType = 'SSH';
                                            }
                                        }

                                        if ($scope.iot3Obj.iot3JSON.template &&
                                            $scope.iot3Obj.iot3JSON.template.types) {
                                            if (Object.keys($scope.iot3Obj.iot3JSON.template.types).length) {
                                                var tempTypesArr = [];
                                                Object.keys($scope.iot3Obj.iot3JSON.template.types).forEach(function (typeKey) {
                                                    $scope.iot3Obj.iot3JSON.template.types[typeKey].id = typeKey;
                                                    tempTypesArr.push($scope.iot3Obj.iot3JSON.template.types[typeKey]);
                                                });
                                                $scope.iot3Obj.iot3JSON.template.typesArr = tempTypesArr;
                                            } else {
                                                $scope.iot3Obj.iot3JSON.template.typesArr = [];
                                            }
                                        } else {
                                            if (!$scope.iot3Obj.iot3JSON.template) {
                                                $scope.iot3Obj.iot3JSON.template = {};
                                            }
                                            $scope.iot3Obj.iot3JSON.template.typesArr = [];
                                        }
                                    }
                                    $scope.iot3Obj.yamlString = jsyaml.dump($scope.iot3Obj.iot3JSON, {lineWidth: -1});
                                } else {
                                    $scope.iot3Obj.iot3JSON = {};
                                    $scope.iot3Obj.yamlString = '';
                                }
                            } else {
                                $scope.iot3Obj.iot3JSON = {};
                                $scope.iot3Obj.yamlString = '';
                            }

                            if (angular.isUndefined($scope.iot3Obj.description)) {
                                $scope.iot3Obj.description = '';
                            }

                            $scope.resetIot3Obj = angular.copy($scope.iot3Obj);
                            $scope.isIot3ReferenceLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isIot3ReferenceLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.iot3', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                        $scope.fnSetTabHeight();
                    })
                };

                $scope.fnDeleteIot3Reference = function (iot3Obj) {
                    swal({
                            title: "Delete the selected Iot3 Reference?",
                            text: "You are about to permanently delete the selected iot3.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    iot3Id: iot3Obj.id
                                };
                                NodeIoT3Factory.deleteIoT3Reference(inputObj)
                                    .then(function () {
                                        $scope.$emit('Iot3Deleted', iot3Obj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCloneIot3Reference = function (iot3Obj) {
                    $scope.$emit('InitiateClone', {iot3YamlStr: iot3Obj.iot3, referenceId: iot3Obj.id})
                };

                $scope.fnResetDetails = function () {
                    $scope.iot3Obj = angular.copy($scope.resetIot3Obj);
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }

                    if (angular.isDefined(angular.element(".iot3NodeMainContent")[0]) &&
                        angular.isDefined(angular.element(".local-search-bar")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var totalNodes = angular.element(".iot3NodeMainContent")[0].offsetHeight;
                        var search = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeightNode = totalNodes - (search + header + 10);
                        angular.element("#iot3NodeTableBody").css('height', finalHeightNode + 'px');
                    }
                };

                $scope.fnInitializeResizeEvent = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitIot3 = function () {
                    $scope.isIot3ReferenceLoaded = false;
                    $scope.iot3Id = $scope.iot3Obj.id;
                    if ($scope.iot3Id) {
                        $scope.fnGetIot3Reference($scope.iot3Id);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnInitIot3();
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('jobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj, NodeEcuFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Execute Command '\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                NodeEcuFactory.describeBashCommand({jobId: vm.jobObj.id})
                                    .then(function (response) {
                                        if (response.output && response.output.length) {
                                            var tempOutputsArr = response.output.split('\n');
                                            _.forEach(tempOutputsArr, function (tempOutputObj) {
                                                if (tempOutputObj !== '') {
                                                    vm.jobSummary += " >              " + tempOutputObj + "\n";
                                                }
                                            });
                                        }
                                        if (res.data[0].jobResult === 'FAILURE') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                        }
                                        if (res.data[0].jobResult === 'SUCCESS') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                        }
                                        if (res.data[0].jobResult === 'MIXED') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                        }
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        if (res.data[0].jobResult === 'FAILURE') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                        }
                                        if (res.data[0].jobResult === 'SUCCESS') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                        }
                                        if (res.data[0].jobResult === 'MIXED') {
                                            vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                        }
                                    });
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('es4JobTerminalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Update ES4\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('networkScanCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, QueryFactory, NodeEcuFactory, moment, ecuObj, amaran, $log) {
                var vm = this;
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.inputObj = {
                    auto: true,
                    range: ""
                }
                vm.isJobIdFound = false;
                vm.isNetworkScanStart = false;

                vm.jobAPITimeout = '';
                vm.jobObj = {};
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    readOnly: true,
                    mode: 'text/plain',
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    if (vm.isJobIdFound) {
                        vm.fnSetTabHeight();
                    }
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Timestamp parsing
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle data parsing from JSONB column
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Merge the parsed data with our item
                                parsedItem = angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Network Scan\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            var parsedResults = parsePostgresData(res.data);

                            if (parsedResults && parsedResults.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            var parsedResults = parsePostgresData(res.data);

                            if (parsedResults && parsedResults.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            // Parse the results
                            var parsedResults = parsePostgresData(res.data);

                            if (parsedResults && parsedResults.length) {
                                if (parsedResults[0].audits && parsedResults[0].audits.length) {
                                    var tempAuditsArr = parsedResults[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (parsedResults[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (parsedResults[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (parsedResults[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnNetworkScan = function () {
                    vm.isNetworkScanStart = true;
                    var inputObj = {
                        ecuId: ecuObj.id,
                        body: vm.inputObj
                    };
                    NodeEcuFactory.ecuNetworkScan(inputObj)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            vm.isNetworkScanStart = false;
                            vm.isJobIdFound = true;
                            amaran.success("ECU network scan request in progress.");
                            vm.fnIntiJob();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNetworkScanStart = false;
                            vm.isJobIdFound = false;
                        })
                }

                vm.fnCancel = function () {
                    if (vm.isJobIdFound) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitNetworkScanModal = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuSyncModalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, ecuObj, $log) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Timestamp parsing
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Job-specific timestamp parsing
                        if (angular.isDefined(parsedItem.startedAt)) {
                            parsedItem.startedAt = parsedItem.startedAt;
                        }

                        if (angular.isDefined(parsedItem.completedAt)) {
                            parsedItem.completedAt = parsedItem.completedAt;
                        }

                        // Handle data parsing from JSONB column
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Merge the parsed data with our item
                                parsedItem = angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Synchronizing ECU\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            // Parse the results
                            var parsedResults = parsePostgresData(res.data);

                            if (parsedResults && parsedResults.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            var parsedResults = parsePostgresData(res.data);
                            if (parsedResults && parsedResults.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            // Success block
                            var parsedResults = parsePostgresData(res.data);
                            if (parsedResults && parsedResults.length) {
                                if (parsedResults[0].audits && parsedResults[0].audits.length) {
                                    var tempAuditsArr = parsedResults[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (parsedResults[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (parsedResults[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (parsedResults[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(parsedResults[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitJobTerminalModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuProjectCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, QueryFactory, NodeEcuFactory, moment, ecuObj, selectedProject, DB, AppInitService, amaran, $log) {
                var vm = this;
                vm.ecuObj = _.cloneDeepWith(ecuObj);
                vm.projectsArr = [];
                vm.isProjectsLoaded = false;
                vm.isECUProjectUpdating = false;
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.selectedProject = _.cloneDeepWith(selectedProject);
                vm.selectedProjectId = _.cloneDeepWith(selectedProject.id);

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Timestamp standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle data parsing from JSONB column
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Merge the parsed data with our item
                                parsedItem = angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                // Log error if JSON parsing fails
                                $log.error('Error parsing data:', e);
                            }
                        }

                        // Project-specific parsing
                        parsedItem.name = parsedItem.name || parsedItem.projectName;

                        return parsedItem;
                    });
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            var parsedData = parsePostgresData(res.data);

                            _.forEach(parsedData, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((parsedData && parsedData.length && parsedData.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectsLoaded = true;
                            }
                        }, function () { // Error block
                            vm.isProjectsLoaded = true;
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                    vm.fnUpdateIssueProject(true);
                };

                vm.fnUpdateIssueProject = function (notClose) {
                    if (vm.deleteProjectsArr.length) {
                        vm.selectedProjectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        vm.selectedProjectId = vm.selectedProject.id;
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    if (angular.isUndefined(notClose)) {
                        vm.changeProjectView = false;
                    }
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                            vm.selectedProjectId = "";
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnUpdateECUProject = function () {
                    vm.isECUProjectUpdating = true;
                    var inputObj = {
                        ecuId: vm.ecuObj.id,
                        projectId: vm.selectedProjectId
                    };
                    NodeEcuFactory.updateEcuProject(inputObj)
                        .then(function (res) { // Success block
                            vm.isECUProjectUpdating = false;
                            amaran.success("ECU Project Updated Successfully");
                            $uibModalInstance.close({selectedProject: vm.selectedProject, ecuData: res});
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isECUProjectUpdating = false;
                        })
                };

                vm.fnInitECUProjectModal = function () {
                    vm.isProjectsLoaded = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        vm.projectsArr = parsePostgresData(AppInitService.getInitData('nodeProjectsArr'));
                        vm.isProjectsLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('observerConditionModalCtrl',
            function ($scope, $timeout, $uibModalInstance, $state, $stateParams, DB, PermissionsService,
                      ObserverFactory, PaginationService, LastPageService, amaran, UserFactory, FedSudoUserService,
                      SortIconService, IconService, ColorService, selectedComponent, componentGhostObj, typeObj) {
                var vm = this;
                vm.selectedComponentGhostObj = {};
                vm.selectedComponentObj = {};
                vm.typeObj = {};
                vm.isExistionObserverOptionSelected = false;
                vm.isObserverObjSelected = false;
                vm.isExistionObserverConditionOptionSelected = false;
                var loginUser = DB.fnGet('loginUser');

                /*Observer table start*/
                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }
                    ,
                    {
                        fieldDisplayName: "State",
                        fieldName: "state"
                    }
                ];
                vm.filterQuery = "";

                vm.selectedObserverObj = {};
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isObserversLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    } else if ($stateParams.size) {
                        vm.perPage = Math.ceil($stateParams.size)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isObserversLoading = true;
                    vm.selectedObserversArr = [];
                    vm.isAllChecked = false;
                    if(vm.observerPermissionsObj.List) {
                        vm.fnGetObservers(inputObj);
                    } else {
                        vm.observersArr = [];
                        vm.isObserversLoading = false;
                    }
                };

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 90);
                        angular.element("#observerConditionModal tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (observerObj) {
                    angular.forEach(vm.observersArr, function (obj) {
                        obj.isCheck = false;
                    });
                    observerObj.isCheck = true;
                    vm.selectedObserverObj = observerObj;
                };

                vm.fnGetObservers = function (inputObj) {
                    ObserverFactory.getObservers(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.observers;
                            vm.observersArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            vm.isObserversLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isObserversLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isObserversLoading = true;
                    vm.selectedObserversArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetObservers(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnGetObserveStateIcon = function (state) {
                    return state === 'INACTIVE' ? IconService.fnGetStateIcon(state) + ' InactiveStateIcon' : IconService.fnGetStateIcon(state);
                };

                vm.getObserverStateColor = function (state) {
                    return ColorService.getStateColor(state);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.observerSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "observerSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.observerSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnObserverSort = function (type) {
                    if(!DB.fnGet('federation') && !DB.fnGet('sudo')){
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('observerSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('observerSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('observerSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.observerPermissionsObj.List = false;
                    $timeout(function () {
                        vm.observerPermissionsObj.List = true;
                    }, 10)
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.fnSelectObserver = function(selectedObserverObj){
                    vm.selectedObserverObj = selectedObserverObj;
                    vm.isObserverObjSelected = true;
                };

                /*Observer table end*/

                vm.fnCreateNewObserver = function () {
                    vm.newObserverObj = {
                        name: vm.selectedComponentObj.name + " " + vm.selectedComponentObj.oem,
                        description: vm.selectedComponentObj.name + " " + vm.selectedComponentObj.oem,
                        state: 'ACTIVE',
                        policy: 'MATCH_ALL',
                        topicOem: vm.typeObj.oem,
                        topicModel: vm.typeObj.model,
                        topicName: vm.typeObj.name,
                        topicVersion: vm.typeObj.version,
                        topicId: '*',
                        conditions: []
                    };
                    var conditionObj = {
                        "condition": "AND", "rules": [{
                            field: vm.selectedComponentGhostObj.name ? vm.selectedComponentGhostObj.name : '',
                            input: "text",
                            operator: "is equal to",
                            type: "string",
                            value: vm.selectedComponentGhostObj.value ? vm.selectedComponentGhostObj.value : ''
                        }]
                    };
                    DB.fnSet("CreateObserverComponentCondition", vm.newObserverObj);
                    DB.fnSet("CreateObserverConditionObj", conditionObj);
                    $state.go('main.observer', {openCreateView: true});
                    $uibModalInstance.dismiss('dismiss');
                };

                vm.fnAddToExistingObserver = function(){
                    vm.isExistionObserverOptionSelected = true;
                };

                vm.fnBackToExistingObserverOption = function(){
                    vm.isExistionObserverOptionSelected = false;
                };

                vm.fnCreateNewConditionForExistingObserver = function(){
                    var conditionObj = {
                        "condition": "AND", "rules": [{
                            field: vm.selectedComponentGhostObj.name ? vm.selectedComponentGhostObj.name : '',
                            input: "text",
                            operator: "is equal to",
                            type: "string",
                            value: vm.selectedComponentGhostObj.value ? vm.selectedComponentGhostObj.value : ''
                        }]
                    };
                    DB.fnSet("CreateObserverConditionObj", conditionObj);
                    $state.go('main.observer', {selectedId: vm.selectedObserverObj.id, openEditView: true});
                    $uibModalInstance.dismiss('dismiss');
                };

                vm.fnAddToExistingCondition = function(){
                    vm.isExistionObserverConditionOptionSelected = true;
                };

                vm.fnBackToExistingObserver = function(){
                    vm.isExistionObserverConditionOptionSelected = false;
                };

                vm.fnBackToObserver = function(){
                    vm.selectedObserverObj = {};
                    vm.isObserverObjSelected = false;
                };

                vm.fnGetHealthColor = function (healthCode) {
                    return ColorService.getHealthColorForLoop(healthCode);
                };

                vm.fnGetHealthName = function (healthCode) {
                    var healthStyle = ColorService.getHealthColorForLoop(healthCode);
                    return healthStyle.content ? healthStyle.content : healthCode;
                };

                vm.fnSelectObserverCondition = function(conditions){
                    conditions.expression.rules.push({
                        field: vm.selectedComponentGhostObj.name ? vm.selectedComponentGhostObj.name : '',
                        input: "text",
                        operator: "is equal to",
                        type: "string",
                        value: vm.selectedComponentGhostObj.value ? vm.selectedComponentGhostObj.value : ''
                    });
                    DB.fnSet("CreateObserverConditionObj", conditions);
                    $state.go('main.observer', {selectedId: vm.selectedObserverObj.id, openEditView: true});
                    $uibModalInstance.dismiss('dismiss');
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitModel = function () {
                    vm.observerPermissionsObj = PermissionsService.getPermissions("node:observer");
                    vm.healthPermissionObj = PermissionsService.getPermissions("node:health");
                    vm.selectedComponentGhostObj = componentGhostObj;
                    vm.selectedComponentObj = selectedComponent;
                    vm.typeObj = typeObj;
                };

                $scope.$on('$destroy', function () {
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('gatewayInfoDeviceCtrl',
            function ($uibModalInstance, IconService, ColorService, GatewayFactory, deviceObj) {
                var vm = this;
                var deviceInfoObj = deviceObj;
                vm.isGatewayLoading = true;
                vm.gatewayObj = {};

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    if (gatewayObj.healthName === health) {
                        gatewayObj.toolTipName = health;
                    } else {
                        gatewayObj.toolTipName = gatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetGatewayInfo = function (gatewayId) {
                    GatewayFactory.getGateway({gatewayId: gatewayId})
                        .then(function (res) {
                            vm.gatewayObj = res;
                            vm.isGatewayLoading = false;
                        }, function () {
                            vm.gatewayObj = {};
                            vm.isGatewayLoading = false;
                        })
                };

                vm.fnInitGatewayDeviceModal = function () {
                    vm.isGatewayLoading = true;
                    var gatewayId = deviceInfoObj.id.substring(0, deviceInfoObj.id.lastIndexOf("-"));
                    vm.fnGetGatewayInfo(gatewayId);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('gatewayConnectionModalCtrl',
            function ($rootScope, $scope, $timeout, $window, $http, amaran, $cookies,
                      $uibModalInstance, TabHeight, analyticsService, ColorService, moment, deviceGatewayObj, selectedFilterObj) {
                var vm = this;
                vm.deviceGatewayObj = deviceGatewayObj;
                vm.selectedTab = 0;
                vm.selectedFilterObj = selectedFilterObj;
                vm.analyticsV4Data = {};

                vm.fnChangeSelectedTab = function(index){
                    vm.selectedTab = index;
                };

                vm.fnCloseModal = function () {
                    $uibModalInstance.close();
                };

                vm.fnGetGatewayConnectionAnalyticsQueryData = function () {
                    vm.isGetGatewayConnectionAnalyticsData = true;
                    vm.isBarCharLoading = true;
                    var inputObj = {
                        "dataSets": ["CONNECTION"],
                        "nodeId": vm.deviceGatewayObj.id,
                        "timeRange": {}
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };
                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        vm.heatmapCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsV4Data = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if(response && response.data && response.data.data){
                                vm.analyticsV4Data = response.data.data;
                            }else{
                                vm.analyticsV4Data = {};
                            }
                            if(response && response.data && response.data.meta){
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            }else{
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.heatmapCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateDeviceConnectionData(timeStampsArr);
                        vm.isGetGatewayConnectionAnalyticsData = false;
                    }, function error() {
                        vm.analyticsV4Data = {};
                        vm.heatmapCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.heatmapCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateDeviceConnectionData(timeStampsArr);
                        vm.isGetGatewayConnectionAnalyticsData = false;
                    });
                };

                vm.fnCreateDeviceConnectionData = function (timeStampsArr) {
                    vm.gatewayConnectionArr = [];
                    if (vm.analyticsV4Data && vm.analyticsV4Data.CONNECTION && vm.analyticsV4Data.CONNECTION.points) {
                        var gatewayAnalyticsb64String = vm.analyticsV4Data.CONNECTION.points;
                        var gatewayAnalyticsCSVString = analyticsService.getCSVString(gatewayAnalyticsb64String);
                        var tempConnectionArr = analyticsService.getConnectionData(gatewayAnalyticsCSVString);
                        var gatewayConnectionPieChartAnalyticsData = [];
                        if (tempConnectionArr.length) {
                            vm.gatewayConnectionArr = tempConnectionArr;
                            var gatewayPieChartString = vm.analyticsV4Data.CONNECTION.summary;
                            var gatewayPieChartAnalyticsCSVString = analyticsService.getCSVString(gatewayPieChartString);
                            gatewayConnectionPieChartAnalyticsData = analyticsService.getConnectionPieData(gatewayPieChartAnalyticsCSVString);
                        } else {
                            gatewayConnectionPieChartAnalyticsData = vm.fnCreateConnectionStaticData(timeStampsArr);
                        }
                        vm.fnGenerateConnectionPieData(gatewayConnectionPieChartAnalyticsData);
                    } else {
                        var gatewayConnectionPieChart = vm.fnCreateConnectionStaticData(timeStampsArr);
                        vm.fnGenerateConnectionPieData(gatewayConnectionPieChart);
                    }
                    vm.isBarCharLoading = false;
                };

                vm.fnCreateConnectionStaticData = function (timeStampsArr) {
                    var analyticsConnectionPieArr = [];
                    var tempIndex = 0;
                    var connectionStatus = vm.deviceGatewayObj.connection === "CONNECTED" ? "connected":"disconnected";
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var connectionColor = ColorService.getConnectionColor(vm.deviceGatewayObj.connection).color;
                        vm.gatewayConnectionArr.push({
                            x: 0,
                            y: tempIndex,
                            value: "-",
                            connection: connectionStatus,
                            color: connectionColor,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsConnectionPieArr.push({
                            duration: 100,
                            percentage: 100,
                            connection: connectionStatus
                        });
                        tempIndex++
                    });
                    return analyticsConnectionPieArr;
                };

                vm.fnGenerateConnectionPieData = function (barData) {
                    var pieData = [];
                    var groupedConnectionObj = _.groupBy(barData, function (x) {
                        return x.connection
                    });
                    _.forEach(groupedConnectionObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        pieData.push({
                            name: key,
                            y: totalP,
                            color: ColorService.getConnectionColor(key).color,
                            healthTextColor: ColorService.getConnectionColor(key).color
                        })
                    });
                    vm.gatewayConnectionPieData = pieData;
                };

                /* TimeLine Interval: Start */
                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };
                /* TimeLine Interval: end */

                vm.fnInitGatewayConnectionModal = function () {
                    vm.selectedTab = 0;
                    TabHeight.fnSet();
                    vm.fnGetGatewayConnectionAnalyticsQueryData();
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeviceVersionSupportCtrl',
            function ($uibModalInstance) {
                var vm = this;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('componentRenameModalCtrl',
            function ($uibModalInstance, ComponentFactory, componentObj) {
                var vm = this;
                vm.compObj = componentObj;
                vm.compName = vm.compObj.name ? vm.compObj.name : '';
                vm.isComponentUpdating = false;

                vm.fnUpdateComponentName = function (compName) {
                    vm.isComponentUpdating = true;
                    var inputObj = {
                        deviceId : vm.compObj.id.substring(0, vm.compObj.id.lastIndexOf("-")),
                        componentId: vm.compObj.id,
                        body: {
                            name: compName
                        }
                    };
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function (response) {
                            vm.isComponentUpdating = false;
                            $uibModalInstance.close(response);
                        });
                };

                vm.fnRemoveCompName = function () {
                    vm.compName = ' ';
                    vm.fnUpdateComponentName(vm.compName);
                };

                vm.fnCancel = function() {
                    $uibModalInstance.dismiss('cancel');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('supplementalDataModalCtrl',
            function ($rootScope, $scope, $timeout, $window, amaran, DB,
                      $uibModalInstance, PermissionsService, TabHeight, ComponentFactory, componentObj, $uibModal) {
                var vm = this;

                vm.selectedComponent = componentObj;
                vm.isAdvancedOption = false;
                vm.componentSupplementalObj = {};
                vm.isSupplementalDetailsEditable = false;
                vm.isSupplementalEditable = false;
                vm.supplementalKVPArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnInjectFunction = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html',
                        size: 'lg',
                        controller: 'supplementFunctionModalCtrl as supplementModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (supplementalArr) {
                        _.forEach(supplementalArr, function (supplementalObj) {
                            if (supplementalObj.key && supplementalObj.value && supplementalObj.key.length && supplementalObj.value.length) {
                                var isFind = _.find(vm.supplementalKVPArr, {key: supplementalObj.key});
                                if (!isFind) {
                                    vm.supplementalKVPArr.push(supplementalObj);
                                } else {
                                    isFind.value = supplementalObj.value;
                                }
                            }
                        });
                        _.remove(vm.supplementalKVPArr, function (supplementalKVPObj) {
                            return supplementalKVPObj.key === '' && supplementalKVPObj.value === '';
                        });
                        if (!vm.supplementalKVPArr.length) {
                            vm.supplementalKVPArr = [{key: '', value: ''}];
                        }
                    }, function () {
                    });

                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetComponentData = function (componentObj) {
                    var inputObj = {
                        deviceId : componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };

                    ComponentFactory.getComponent(inputObj)
                        .then(function (response) {
                            vm.componentSupplementalObj = response.data ? angular.fromJson(response.data) : {};
                            /*{
                                lat: ["456"],
                                    long: ["789"]
                            };*/
                            vm.componentSupplementalObj = vm.isAdvancedOption ? angular.toJson(vm.componentSupplementalObj,true):vm.componentSupplementalObj;
                            vm.resetSupplementalObj = angular.copy(vm.componentSupplementalObj);
                            vm.supplementalKVPArr = [];
                            if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                                angular.forEach(vm.componentSupplementalObj, function (value, key) {
                                    var tempObj = {
                                        key: key,
                                        value: value[0]
                                    };
                                    vm.supplementalKVPArr.push(tempObj);
                                });
                            }
                            vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                            vm.isComponentSupplementalDetailsLoaded = true;
                        })
                };
                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };

                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isSupplementalEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isSupplementalEditable = false;
                        vm.componentSupplementalObj = angular.toJson(angular.copy(angular.fromJson(vm.resetSupplementalObj)), true);
                        vm.ReadOnlyTrue();
                    }
                };
                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.componentSupplementalObj = angular.toJson(vm.componentSupplementalObj, true);
                    } else {
                        vm.componentSupplementalObj = angular.fromJson(vm.componentSupplementalObj);
                        vm.supplementalKVPArr = [];
                        if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                            angular.forEach(vm.componentSupplementalObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value[0]
                                };
                                vm.supplementalKVPArr.push(tempObj);
                            });
                        }
                        vm.resetSupplementalArr = angular.copy(vm.supplementalKVPArr);
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnSaveComponentData = function () {
                    vm.isSupplementalDetailChanging = true;
                    vm.selectedComponent.data = {};
                    var inputObj = {
                        deviceId : vm.selectedComponent.id.substring(0, vm.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.selectedComponent.id,
                        body: {
                            data: {}
                        }
                    };
                    if (!vm.selectedComponent.data) {
                        vm.selectedComponent.data = {};
                    }
                    angular.forEach(vm.supplementalKVPArr, function (kpPairObj) {
                        if (kpPairObj.key && kpPairObj.value && kpPairObj.key.length && kpPairObj.value.length) {
                            vm.selectedComponent.data[kpPairObj.key] = ["" + kpPairObj.value + ""];
                        }
                    });

                    inputObj.body.data = vm.selectedComponent.data;
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function (response) {
                            vm.selectedComponent = response;
                            amaran.success("Data added to component successfully");
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitComponentSupplemental();
                        }, function () {
                            vm.isSupplementalDetailChanging = false;
                            vm.isSupplementalDetailsEditable = false;
                            vm.fnInitComponentSupplemental();
                        })

                };

                vm.fnEditComponentData = function (obj) {
                    vm.isSupplementalEditableUpdate = true;
                    var inputObj = {
                        deviceId : vm.selectedComponent.id.substring(0, vm.selectedComponent.id.lastIndexOf("-")),
                        componentId: vm.selectedComponent.id,
                        body: {
                            data:  obj ? angular.fromJson(obj) : {}
                        }
                    };
                    ComponentFactory.modifyComponent(inputObj)
                        .then(function (response) {
                            vm.selectedComponent = response;
                            amaran.success("Data edited successfully");
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitComponentSupplemental();
                        }, function () {
                            vm.isSupplementalEditable = false;
                            vm.isSupplementalEditableUpdate = false;
                            vm.fnInitComponentSupplemental();
                        })
                };

                vm.fnCheckUniqueKey = function (kvpPairObj, index) {
                    var count = 0;
                    angular.forEach(vm.supplementalKVPArr, function (kvpPair) {
                        if (kvpPair.key === kvpPairObj.key) {
                            count++;
                        }
                    });
                    if (count > 1) {
                        vm.isKeyDuplicated = true;
                        vm.duplicatedIndex = index;
                    } else {
                        vm.isKeyDuplicated = false;
                        vm.duplicatedIndex = null;
                    }
                };

                vm.fnAddSupplementalKey = function (isCalledEditMode) {
                    if(isCalledEditMode){
                        vm.isSupplementalDetailsEditable = true;
                    }
                    vm.supplementalKVPArr.push({
                        key: '',
                        value: ''
                    })
                };

                vm.fnRemoveSupplemental = function (index) {
                    vm.supplementalKVPArr.splice(index, 1);
                };

                vm.fnResetDetails = function () {
                    vm.componentSupplementalObj = angular.copy(vm.resetSupplementalObj);
                    if (!vm.isObjectEmpty(vm.componentSupplementalObj)) {
                        vm.supplementalKVPArr = [];
                        angular.forEach(vm.componentSupplementalObj, function (value, key) {
                            var tempObj = {
                                key: key,
                                value: value[0]
                            };
                            vm.supplementalKVPArr.push(tempObj);
                        });
                    } else {
                        vm.supplementalKVPArr = [];
                    }
                    vm.isSupplementalDetailsEditable = false;
                };

                vm.fnChangeFieldsToEditable = function () {
                    vm.isSupplementalDetailsEditable = true;
                };

                vm.fnCloseModal = function () {
                    $uibModalInstance.close(); //vm.selectedComponent
                };

                vm.fnInitComponentSupplemental = function () {
                    vm.componentPermissionObj = PermissionsService.getPermissions("node:component");
                    TabHeight.fnSet();
                    vm.isComponentSupplementalDetailsLoaded = false;
                    if (vm.selectedComponent.id) {
                        vm.fnGetComponentData(vm.selectedComponent);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('gatewayElementListModalCtrl',
            function ($scope, $uibModalInstance, $window, $timeout, $q, amaran, PaginationService,
                      IconService, PermissionsService, DB, GatewayFactory, ColorService, ClusterFactory, isCallFromGatewaysTab,clusterId) {
                var vm = this;

                vm.searchFieldArr = [];
                vm.filterQuery = "";
                vm.isCallFromGatewaysTab = isCallFromGatewaysTab;
                vm.clusterId = clusterId;

                //Gateways Variables
                vm.isGatewaysLoading = false;
                vm.gatewaysArr = [];
                vm.selectedgatewaysArr = [];
                vm.isObjectSelect = false;
                vm.filter = "$";
                vm.search = {$: ''};

                //pagination variables
                vm.perPage = 0;
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;

                //API params Variable
                vm.inputObj = {};


                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isGatewaysLoading = true;
                    vm.filterQuery = filterQuery;

                    vm.perPage = 0;

                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            perPage: vm.perPage
                        };
                    }

                    vm.isGatewaysLoading = true;
                    vm.selectedgatewaysArr = [];
                    vm.isAllChecked = false;
                    if (vm.gatewayPermissionObj.List) {
                        vm.fnGetGateways(inputObj);
                    } else {
                        vm.gatewaysArr = [];
                        vm.isGatewaysLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    if (gatewayObj.healthName === health) {
                        gatewayObj.toolTipName = health;
                    } else {
                        gatewayObj.toolTipName = gatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 100);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 90);

                        angular.element("#gatewaysElementTable tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetGateways = function (inputObj) {
                    GatewayFactory.getGateways(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.gateways;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.gatewaysArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.isGatewaysLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewaysLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.gatewaysArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedgatewaysArr = angular.copy(vm.gatewaysArr);
                    } else {
                        vm.selectedgatewaysArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function (gatewayObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.gatewaysArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                    /* Toggle push in selected devices array*/
                    var isValueFind = _.find(vm.selectedgatewaysArr, {'id': gatewayObj.id});
                    if (!isValueFind) {
                        vm.selectedgatewaysArr.push(gatewayObj)
                    } else {
                        _.remove(vm.selectedgatewaysArr, function (obj) {
                            return gatewayObj.id === obj.id;
                        });
                    }
                };

                vm.fnGetNextPrevCollection = function (collectionKey, collection, perPage) {
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: vm.perPage
                        };
                    }
                    if (collection.length) {
                        vm.inputObj[collectionKey] = collection;
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedgatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetGateways(vm.inputObj);
                };
                /*END: TABLE */

                vm.fnSelectGateways = function () {
                    $uibModalInstance.close(vm.selectedgatewaysArr);
                };

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function(phase){
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };
                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.fnAddGatewaysToCluster = function(){
                    vm.isGatewayAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedgatewaysArr, function (selectedGateway) {
                        var inputObj = {
                            clusterId: vm.clusterId,
                            gatewayId: selectedGateway.id
                        };
                        promises.push(ClusterFactory.addGatewayToCluster(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected Gateways successfully add in Cluster");
                        vm.isGatewayAdding = false;
                        $uibModalInstance.close('Gateway Added');
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isGatewayAdding = false;
                        vm.fnCancel();
                    })
                };

                vm.fnInitModel = function () {
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.searchFieldArr = [
                        {
                            fieldDisplayName: "ID",
                            fieldName: "id"
                        },
                        {
                            fieldDisplayName: "Name",
                            fieldName: "name"
                        },
                        {
                            fieldDisplayName: "Description",
                            fieldName: "description"
                        },
                        {
                            fieldDisplayName: "Phase",
                            fieldName: "phase"
                        },
                        {
                            fieldDisplayName: "Connection",
                            fieldName: "connection"
                        },
                        {
                            fieldDisplayName: "TypeId",
                            fieldName: "typeId"
                        },
                        {
                            fieldDisplayName: "Health",
                            fieldName: "health"
                        },
                        {
                            fieldDisplayName: "DefaultHealth",
                            fieldName: "defaultHealth"
                        }
                    ];
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('elementListModalCtrl',
            function ($scope, $uibModalInstance, $window, $timeout, $q, amaran, PaginationService,
                      IconService, PermissionsService, DB, DeviceFactory, ColorService, ClusterFactory, AppInitService, TypeFactory, FedSudoUserService, GatewayFactory, isCallFromDevicesTab, LastPageService, clusterId) {
                var vm = this;
                vm.filterQuery = "";
                vm.isCallFromDevicesTab = isCallFromDevicesTab;
                vm.clusterId = clusterId;

                //Devices Variables
                vm.isDevicesLoading = false;
                vm.devicesArr = [];
                vm.selectedDevicesArr = [];
                vm.isObjectSelect = false;
                vm.filter = "$";
                vm.search = {$: ''};

                //pagination variables
                vm.perPage = 0;
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;

                //API params Variable
                vm.inputObj = {};
                var typeCount = 0;
                vm.deviceFilter = [
                    {
                        title: 'Health',
                        subMenu: [{
                            title: '200-500',
                            healthrange: {
                                minValue: "200",
                                maxValue: "500"
                            }
                        }, {
                            title: '300-500',
                            healthrange: {
                                minValue: "300",
                                maxValue: "500"
                            }
                        }, {
                            title: '400-500',
                            healthrange: {
                                minValue: "400",
                                maxValue: "500"
                            }
                        }]
                    }, {
                        title: 'Connection',
                        subMenu: [{
                            title: 'Connected'
                        }, {
                            title: 'Disconnected'
                        }]
                    }, {
                        title: 'Gateway'
                    }, {
                        title: 'OEM'
                    }, {
                        title: 'Model'
                    }, {
                        title: 'Phase'
                    }];
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "Phase",
                        fieldName: "phase"
                    },
                    {
                        fieldDisplayName: "TypeId",
                        fieldName: "typeId"
                    },
                    {
                        fieldDisplayName: "Health",
                        fieldName: "health"
                    },
                    {
                        fieldDisplayName: "DefaultHealth",
                        fieldName: "defaultHealth"
                    }
                ];
                var perPage = FedSudoUserService.fnGetUserData('perPage');

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.start = 0;
                vm.sort = "";

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, isCalledDirective, isCalledFromInit) {
                    //vm.isDevicesLoading = true;
                    vm.filterQuery = filterQuery;
                    vm.perPage = parseInt(perPage === '' ? 20 : parseInt(perPage[0] > 100 ? '100' : perPage[0]));
                    var inputObj = {};
                    if (sortQuery && sortQuery.length && sortQuery !== '') {
                        inputObj.sort = sortQuery;
                    } else {
                        inputObj.sort = "";
                    }
                    if (vm.filterQuery.length) {
                        inputObj.size = vm.perPage;
                        inputObj.q = vm.filterQuery;
                        inputObj.start = isCalledDirective ? 0 : vm.start ? parseInt(vm.start) : 0;
                    } else {
                        inputObj.size = vm.perPage;
                        inputObj.q = "";
                        inputObj.start = isCalledDirective ? 0 : vm.start ? parseInt(vm.start) : 0;
                    }
                    if (isCalledFromInit) {
                        vm.isDevicesLoading = true;
                    } else {
                        vm.isDeviceSearchDataLoaded = true;
                    }
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    if (vm.devicePermissionObj.List) {
                        if (typeCount === 0) {
                            vm.fnGetTypes(inputObj);
                        } else {
                            vm.fnGetDevices(inputObj);
                        }
                    } else {
                        vm.devicesArr = [];
                        vm.isDevicesLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return connection === 'CONNECTED' ? 'device-connected' : 'device-disconnected';
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        angular.element("#devicesElementTable tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 100);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetDevices = function (inputObj, preDefinedDevices, isCalledForViz) {
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) { // Success block
                            vm.isNextVisisble = (res.hit.length + res.start) < res.found;
                            vm.isPrevVisible = res.start !== 0;
                            var devicesArr = isCalledForViz ? preDefinedDevices : [];
                            var tempDeviceObj = {};
                            _.forEach(res.hit, function (hitObj) {
                                tempDeviceObj = {};
                                _.forEach(hitObj.fields, function (value, key) {
                                    var tempNewKey = '';
                                    switch (key) {
                                        case "typeid":
                                            tempNewKey = 'typeId';
                                            break;
                                        case "gatewayid":
                                            tempNewKey = 'gatewayId';
                                            break;
                                        case "clusterids":
                                            tempNewKey = 'clusterIds';
                                            break;
                                        default:
                                            tempNewKey = key;
                                            break
                                    }
                                    if (key !== 'clusterids') {
                                        tempDeviceObj[tempNewKey] = value[0];
                                    } else {
                                        tempDeviceObj[tempNewKey] = value;
                                    }
                                });
                                devicesArr.push(tempDeviceObj);
                            });
                            _.forEach(devicesArr, function (resObj) {
                                var typeObj = _.find(vm.typesArr, {'id': resObj.typeId});
                                if (typeObj) {
                                    resObj.hasComponents = typeObj.hasComponents;
                                }
                                resObj.isEditable = false;
                            });
                            vm.devicesArr = _.cloneDeepWith(devicesArr);
                            vm.totalItems = parseInt(res.found);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, res.start === 0 ? 1 : (res.start / vm.perPage + 1));
                            vm.start = inputObj.start;
                            vm.sort = inputObj.sort;
                            if (vm.isDeviceSearchDataLoaded === true) {
                                vm.isDeviceSearchDataLoaded = false;
                            }
                            vm.isDevicesLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDevicesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetTypes = function (inputObj) {
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        vm.typesArr = AppInitService.getInitData('typesArr');
                        vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                        typeCount++;
                        vm.fnGetDevices(inputObj);
                    } else {
                        TypeFactory.getTypes()
                            .then(function (response) {
                                vm.typesArr = response;
                                vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                                typeCount++;
                                vm.fnGetDevices(inputObj);
                            })
                    }
                };

                vm.fnGetGatewaysInfo = function () {
                    GatewayFactory.getGateways({perPage: 0})
                        .then(function (res) {
                            vm.gatewaysArr = res;
                        }, function () {
                            vm.gatewaysArr = [];
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.devicesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDevicesArr = _.cloneDeepWith(vm.devicesArr);
                    } else {
                        vm.selectedDevicesArr = [];
                    }
                };

                vm.fnCheckUncheckHeader = function (deviceObj) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.devicesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                    });
                    /* Toggle push in selected devices array*/
                    var isValueFind = _.find(vm.selectedDevicesArr, {'id': deviceObj.id});
                    if (!isValueFind) {
                        vm.selectedDevicesArr.push(deviceObj)
                    } else {
                        _.remove(vm.selectedDevicesArr, function (obj) {
                            return deviceObj.id === obj.id;
                        });
                    }
                };

                vm.fnPageChanged = function (perPage) {
                    //vm.currentPage = page;
                    vm.perPage = perPage;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            size: perPage,
                            q: vm.filterQuery,
                            sort: vm.sort && vm.sort !== ""? vm.sort : '',
                            start: 0
                        };
                    } else {
                        vm.inputObj = {
                            size: perPage,
                            q: '',
                            sort: vm.sort && vm.sort !== ""? vm.sort : '',
                            start: 0
                        };
                    }
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };

                vm.fnGetNextPrePagination = function (page, perPage) {
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            size: perPage,
                            q: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            size: perPage,
                            q: ""
                        };
                    }
                    vm.inputObj.sort = vm.sort && vm.sort !== ""? vm.sort : '';
                    vm.inputObj.start = parseInt(perPage * (page - 1));
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };
                /*END: TABLE */

                vm.fnSelectDevices = function () {
                    $uibModalInstance.close(vm.selectedDevicesArr);
                };

                vm.fnGetHealthColor = function (health, deviceObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    deviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };
                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                vm.fnAddDevicesToCluster = function () {
                    vm.isDeviceAdding = true;
                    var promises = [];
                    angular.forEach(vm.selectedDevicesArr, function (selectedUser) {
                        var inputObj = {
                            clusterId: vm.clusterId,
                            deviceId: selectedUser.id
                        };
                        promises.push(ClusterFactory.addDeviceToCluster(inputObj));
                    });

                    $q.all(promises).then(function () {
                        amaran.success("Selected Devices successfully add in Cluster");
                        vm.isDeviceAdding = false;
                        $uibModalInstance.close('Device Added');
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        vm.isDeviceAdding = false;
                        vm.fnCancel();
                    })
                };

                vm.fnInitModel = function () {
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if (vm.gatewayPermissionObj.List) {
                        vm.fnGetGatewaysInfo();
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('metaInfoModalCtrl',
            function ($scope, $rootScope, $window, L, leafletImage, $http, moment, amaran, $timeout, $uibModalInstance, attributeObj, selectedRootNodeObj, selectedProject, NodeFactory, NodeEcuFactory, NodeAttributesFactory, IssueFactory) {
                var vm = this;
                vm.selectedProject = _.cloneDeepWith(selectedProject);
                vm.selectedAttributeObj = _.cloneDeepWith(attributeObj);
                var nodeId = _.cloneDeepWith(vm.selectedAttributeObj.nodeId);
                var ecuId = _.cloneDeepWith(vm.selectedAttributeObj.ecuId);
                var rootNode = _.cloneDeepWith(selectedRootNodeObj);
                vm.metaDataOptionArr = [
                    {
                        title: 'ECU',
                        isShow: true
                    },
                    {
                        title: 'Node',
                        isShow: nodeId !== ecuId
                    },
                    {
                        title: 'Root Node',
                        isShow: nodeId !== ecuId
                    },
                    {
                        title: 'Attribute',
                        isShow: true
                    }
                ];
                vm.selectedMetaOptions = vm.metaDataOptionArr[0];
                vm.isTableDataLoading = true;
                vm.ecuMetaDataConfig = [
                    {
                        name: 'name',
                        displayName: 'Name'
                    }, {
                        name: 'description',
                        displayName: 'Description'
                    }, {
                        name: 'health',
                        displayName: 'Health'
                    }, {
                        name: 'connected',
                        displayName: 'Connection'
                    }, {
                        name: 'serial',
                        displayName: 'Serial'
                    }, {
                        name: 'lastSeenAt',
                        displayName: 'Last Seen'
                    }, {
                        name: 'tags',
                        displayName: 'Tags'
                    }
                ];
                vm.nodeMetaDataConfig = [
                    {
                        name: 'name',
                        displayName: 'Name'
                    }, {
                        name: 'description',
                        displayName: 'Description'
                    }, {
                        name: 'health',
                        displayName: 'Health'
                    }, {
                        name: 'connected',
                        displayName: 'Connection'
                    }, {
                        name: 'lastSeenAt',
                        displayName: 'Last Seen'
                    }, {
                        name: 'model',
                        displayName: 'Model'
                    }, {
                        name: 'oem',
                        displayName: 'OEM'
                    }, {
                        name: 'version',
                        displayName: 'Version'
                    }, {
                        name: 'tags',
                        displayName: 'Tags'
                    }
                ];
                vm.rootNodeMetaDataConfig = [
                    {
                        name: 'name',
                        displayName: 'Name'
                    }, {
                        name: 'description',
                        displayName: 'Description'
                    }, {
                        name: 'health',
                        displayName: 'Health'
                    }, {
                        name: 'connected',
                        displayName: 'Connection'
                    }, {
                        name: 'lastSeenAt',
                        displayName: 'Last Seen'
                    }, {
                        name: 'model',
                        displayName: 'Model'
                    }, {
                        name: 'oem',
                        displayName: 'OEM'
                    }, {
                        name: 'version',
                        displayName: 'Version'
                    }, {
                        name: 'tags',
                        displayName: 'Tags'
                    }
                ];
                vm.attributeMetaDataConfig = [
                    {
                        name: 'name',
                        displayName: 'Name'
                    }, {
                        name: 'health',
                        displayName: 'Health'
                    }, {
                        name: 'value',
                        displayName: 'Value'
                    }, {
                        name: 'mode',
                        displayName: 'Mode'
                    }, {
                        name: 'reference',
                        displayName: 'Reference'
                    }
                ]
                vm.tableData = {
                    title: "",
                    headerArr: [{name: "", title: ""}],
                    bodyObj: {}
                }
                vm.tableMDString = "";
                vm.isLocationData = false;
                vm.isShowMap = false;
                var map = "";
                var marker = ""; //eslint-disable-line
                vm.imageBlob = '';
                vm.isImageUploading = false;
                vm.latitude = "";
                vm.longitude = "";

                vm.fnGetMetaInformation = function () {
                    vm.isLocationData = false;
                    vm.isShowMap = false;
                    map = "";
                    marker = "";
                    vm.imageBlob = '';
                    vm.tableData = {
                        title: "",
                        headerArr: [],
                        bodyObj: {}
                    };
                    vm.tableMDString = "<table>\n";
                    if (vm.selectedMetaOptions.title === 'ECU') {
                        NodeEcuFactory.describeECU({ecuId: ecuId})
                            .then(function (res) { // Success block
                                _.forEach(vm.ecuMetaDataConfig, function (obj) {
                                    if (angular.isDefined(res[obj.name])) {
                                        if (obj.name === 'connected') {
                                            vm.tableData.bodyObj[obj.name] = res[obj.name] === true ? 'Connected' : 'Disconnected';
                                        } else if (obj.name === 'lastSeenAt') {
                                            vm.tableData.bodyObj[obj.name] = moment.unix(res[obj.name]).format("MM/DD/YYYY HH:mm:ss");
                                        } else {
                                            vm.tableData.bodyObj[obj.name] = res[obj.name];
                                        }
                                        vm.tableMDString += "<tr>\n";
                                        if (obj.name === 'tags') {
                                            vm.tableMDString += "<td style='vertical-align: middle;'><b>" + obj.displayName + "</b></td>\n";
                                            vm.tableMDString += "<td>\n<table style='width: 100%'>\n";
                                            _.forEach(res[obj.name], function (value, key) {
                                                vm.tableMDString += "<tr>\n";
                                                vm.tableMDString += "<td><b>" + key + "</b></td>\n"
                                                vm.tableMDString += "<td>" + value + "</td>\n"
                                                vm.tableMDString += "</tr>\n"
                                            })
                                            vm.tableMDString += "</table>\n</td>";
                                        } else {
                                            vm.tableMDString += "<td><b>" + obj.displayName + "</b></td>\n";
                                            if (angular.isDefined(vm.tableData.bodyObj[obj.name])) {
                                                vm.tableMDString += "<td> " + vm.tableData.bodyObj[obj.name] + "</td>\n";
                                            } else {
                                                vm.tableMDString += "<td> " + "" + "</td>\n";
                                            }
                                        }
                                        vm.tableMDString += "</tr>\n";
                                    }
                                })
                                vm.tableMDString += "\n</table>";
                                vm.tableData.title = "ECU Information";
                                vm.tableMDString = "\n## " + vm.tableData.title + "\n" + vm.tableMDString;
                                vm.tableData.headerArr = _.cloneDeepWith(vm.ecuMetaDataConfig);
                                vm.isTableDataLoading = false;
                                if (res.location && res.location.latitude && res.location.longitude) {
                                    vm.latitude = res.location.latitude;
                                    vm.longitude = res.location.longitude;
                                    vm.fnGenerateLocationData();
                                }
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isTableDataLoading = false;
                            })
                    } else if (vm.selectedMetaOptions.title === 'Node') {
                        NodeFactory.describeNode({nodeId: nodeId})
                            .then(function (res) { // Success block
                                _.forEach(vm.nodeMetaDataConfig, function (obj) {
                                    if (obj.name === 'model' || obj.name === "oem" || obj.name === "version") {
                                        vm.tableData.bodyObj[obj.name] = res.meta[obj.name];
                                    } else {
                                        if (angular.isDefined(res[obj.name])) {
                                            if (obj.name === 'connected') {
                                                vm.tableData.bodyObj[obj.name] = res[obj.name] === true ? 'Connected' : 'Disconnected';
                                            } else if (obj.name === 'lastSeenAt') {
                                                vm.tableData.bodyObj[obj.name] = moment.unix(res[obj.name]).format("MM/DD/YYYY HH:mm:ss");
                                            } else {
                                                vm.tableData.bodyObj[obj.name] = res[obj.name];
                                            }
                                        }
                                    }
                                    vm.tableMDString += "<tr>\n";
                                    if (obj.name === 'tags') {
                                        vm.tableMDString += "<td style='vertical-align: middle;'><b>" + obj.displayName + "</b></td>\n";
                                        vm.tableMDString += "<td>\n<table style='width: 100%'>\n";
                                        _.forEach(res[obj.name], function (value, key) {
                                            vm.tableMDString += "<tr>\n";
                                            vm.tableMDString += "<td><b>" + key + "</b></td>\n"
                                            vm.tableMDString += "<td>" + value + "</td>\n"
                                            vm.tableMDString += "</tr>\n"
                                        })
                                        vm.tableMDString += "</table>\n</td>";
                                    } else {
                                        vm.tableMDString += "<td><b>" + obj.displayName + "</b></td>\n";
                                        if (angular.isDefined(vm.tableData.bodyObj[obj.name])) {
                                            vm.tableMDString += "<td> " + vm.tableData.bodyObj[obj.name] + "</td>\n";
                                        } else {
                                            vm.tableMDString += "<td> " + "" + "</td>\n";
                                        }
                                    }
                                    vm.tableMDString += "</tr>\n";
                                })
                                vm.tableMDString += "</table>\n";
                                vm.tableData.title = "Node Information";
                                vm.tableMDString = "\n## " + vm.tableData.title + "\n" + vm.tableMDString;
                                vm.tableData.headerArr = _.cloneDeepWith(vm.nodeMetaDataConfig);
                                vm.isTableDataLoading = false;
                                if (res.location && res.location.latitude && res.location.longitude) {
                                    vm.latitude = res.location.latitude;
                                    vm.longitude = res.location.longitude;
                                    vm.fnGenerateLocationData();
                                }
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isTableDataLoading = false;
                            })
                    } else if (vm.selectedMetaOptions.title === 'Root Node') {
                        _.forEach(vm.rootNodeMetaDataConfig, function (obj) {
                            if (obj.name === 'model' || obj.name === "oem" || obj.name === "version") {
                                vm.tableData.bodyObj[obj.name] = rootNode.meta[obj.name];
                            } else {
                                if (angular.isDefined(rootNode[obj.name])) {
                                    if (obj.name === 'connected') {
                                        vm.tableData.bodyObj[obj.name] = rootNode[obj.name] === true ? 'Connected' : 'Disconnected';
                                    } else if (obj.name === 'lastSeenAt') {
                                        vm.tableData.bodyObj[obj.name] = moment.unix(rootNode[obj.name]).format("MM/DD/YYYY HH:mm:ss");
                                    } else {
                                        vm.tableData.bodyObj[obj.name] = rootNode[obj.name];
                                    }
                                }
                            }
                            vm.tableMDString += "<tr>\n";
                            if (obj.name === 'tags') {
                                vm.tableMDString += "<td style='vertical-align: middle;'><b>" + obj.displayName + "</b></td>\n";
                                vm.tableMDString += "<td>\n<table style='width: 100%'>\n";
                                _.forEach(rootNode[obj.name], function (value, key) {
                                    vm.tableMDString += "<tr>\n";
                                    vm.tableMDString += "<td><b>" + key + "</b></td>\n"
                                    vm.tableMDString += "<td>" + value + "</td>\n"
                                    vm.tableMDString += "</tr>\n"
                                })
                                vm.tableMDString += "</table>\n</td>";
                            } else {
                                vm.tableMDString += "<td><b>" + obj.displayName + "</b></td>\n";
                                if (angular.isDefined(vm.tableData.bodyObj[obj.name])) {
                                    vm.tableMDString += "<td> " + vm.tableData.bodyObj[obj.name] + "</td>\n";
                                } else {
                                    vm.tableMDString += "<td> " + "" + "</td>\n";
                                }
                            }
                            vm.tableMDString += "</tr>\n";
                        })
                        vm.tableMDString += "</table>\n";
                        vm.tableData.title = "Root Node Information";
                        vm.tableMDString = "\n## " + vm.tableData.title + "\n" + vm.tableMDString;
                        vm.tableData.headerArr = _.cloneDeepWith(vm.nodeMetaDataConfig);
                        vm.isTableDataLoading = false;
                        if (vm.rootNodeMetaDataConfig.location && vm.rootNodeMetaDataConfig.location.latitude && vm.rootNodeMetaDataConfig.location.longitude) {
                            vm.latitude = vm.rootNodeMetaDataConfig.location.latitude;
                            vm.longitude = vm.rootNodeMetaDataConfig.location.longitude;
                            vm.fnGenerateLocationData();
                        }
                    } else {
                        NodeAttributesFactory.describeAttribute({attributeId: vm.selectedAttributeObj.id})
                            .then(function (res) { // Success block
                                _.forEach(vm.attributeMetaDataConfig, function (obj) {
                                    if (angular.isDefined(res[obj.name])) {
                                        vm.tableData.bodyObj[obj.name] = res[obj.name];
                                    }
                                    vm.tableMDString += "<tr>\n";
                                    vm.tableMDString += "<td><b>" + obj.displayName + "</b></td>\n";
                                    if (angular.isDefined(vm.tableData.bodyObj[obj.name])) {
                                        vm.tableMDString += "<td> " + vm.tableData.bodyObj[obj.name] + "</td>\n";
                                    } else {
                                        vm.tableMDString += "<td> " + "" + "</td>\n";
                                    }
                                    vm.tableMDString += "</tr>\n";
                                })
                                vm.tableMDString += "</table>\n";
                                vm.tableData.title = "Attribute Information";
                                vm.tableMDString = "\n## " + vm.tableData.title + "\n" + vm.tableMDString;
                                vm.tableData.headerArr = _.cloneDeepWith(vm.attributeMetaDataConfig);
                                vm.isTableDataLoading = false;
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isTableDataLoading = false;
                            })
                    }
                }

                vm.fnGenerateLocationData = function () {
                    map = "";
                    marker = "";
                    vm.imageBlob = '';
                    vm.isImageUploading = false;
                    $timeout(function () {
                        document.getElementById('nodeLocationMap').innerHTML = "<div id='map1' style='width: 550px;height: 350px;'></div>";
                        var mapOptions = {};
                        mapOptions.center = [vm.latitude, vm.longitude];
                        mapOptions.zoom = 15;
                        mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        map = new L.Map('map1', mapOptions);
                        marker = L.marker([vm.latitude, vm.longitude]).addTo(map);

                        $timeout(function () {
                            leafletImage(map, function (err, canvas) {
                                var img = document.createElement('img');
                                var dimensions = map.getSize();
                                img.width = dimensions.x;
                                img.height = dimensions.y;
                                img.src = canvas.toDataURL();
                                document.getElementById('map-image').innerHTML = '';
                                document.getElementById('map-image').appendChild(img);
                                angular.element("#map1").css('display', 'none');
                                vm.imageBlob = dataURLtoFile(canvas.toDataURL(), 'map.png');
                                vm.isShowMap = true;
                                $scope.$apply();
                            });
                        });
                        $timeout(function () {
                            map.invalidateSize()
                        });
                    })
                };

                function dataURLtoFile(dataurl, filename) {

                    var arr = dataurl.split(','),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);

                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new File([u8arr], filename, {type: mime});
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInject = function () {
                    if (vm.isLocationData) {
                        vm.isImageUploading = true;
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                $http({
                                    method: 'PUT',
                                    url: res.uploadUrl,
                                    config: {
                                        headers: {
                                            'Content-Type': vm.imageBlob.type
                                        }
                                    },
                                    data: vm.imageBlob
                                }).success(function () {
                                    var imageURL = " ![map.png](" + res.downloadUrl + ")";
                                    vm.tableMDString += "\n\n ## Location Information\n" + imageURL;
                                    vm.isImageUploading = false;
                                    $uibModalInstance.close(vm.tableMDString)
                                });
                            })
                    } else {
                        $uibModalInstance.close(vm.tableMDString)
                    }
                }

                vm.fnInitMetaInfoModal = function () {
                    vm.isTableDataLoading = true;
                    vm.fnGetMetaInformation();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('issueListModalCtrl',
            function ($rootScope, $window, DB, $sce, UserProfileService, PaginationQueryService, BatchFactory, AppInitService, $state, moment, amaran, $timeout, $uibModalInstance, ApiListService, attributes, QueryFactory) {
                var vm = this;
                vm.selectedAttributes = _.cloneDeepWith(attributes);
                var loginUser = DB.fnGet('loginUser');
                var tableName = 'tracker_issues';
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitIssue = true;
                //Search Variables
                vm.isRefreshData = true;
                vm.assigneeArr = [];
                vm.issueTypesArr = [];
                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};
                var FiltersArrOrder = ['Assigned to me', 'Created by me', 'Resolution Overdue', 'Response Overdue', 'Open', 'Resolved', 'Assignee', 'Created', 'Updated', 'Type', 'Priority', 'Status', 'Label', 'Participant', 'ID', 'Name', 'Summary', 'Unread', 'Project'];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Summary",
                        name: "summary",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Created",
                        name: "createdAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Updated",
                        name: "updatedAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Open",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->>\'resolved\' = \'false\'',
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Resolved",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->>\'resolved\' = \'true\'',
                        localSearchValue: 'obj.resolved === true'
                    }, {
                        displayName: "Resolution Overdue",
                        name: "resolutionDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() > obj.resolutionDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() < obj.resolutionDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Response Overdue",
                        name: "responseDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        localSearch: {
                            type: 'timestamp',
                            name: 'assignees',
                            key: 'email'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                filter: '>',
                                localSearch: 'moment().unix() > obj.responseDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                filter: '<',
                                localSearch: 'moment().unix() < obj.responseDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Assigned to me",
                        name: tableName + ".data->>\'assignees\'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "data->>'assignees' IS NOT NULL AND (data->>'assignees') @> '[{\"email\": \"" + loginUser.email + "\"}]'",
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Created by me",
                        name: tableName + ".data->>\'createdBy\'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "data->>\'createdBy\' = '" + loginUser.email + "'",
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Unread",
                        name: tableName + ".data->>\'lastPublicCommentReadBy\'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "(data->>'lastPublicCommentReadBy' IS NULL OR NOT (data->>'lastPublicCommentReadBy') ? '" + loginUser.email + "')",
                        localSearchValue: "!obj.lastPublicCommentReadBy.includes('" + loginUser.email + "')"
                    }];

                vm.defaultFilterArr = [
                    {
                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        selectedField: "resolved",
                        displaySelectedField: "Open",
                        searchText: '',
                        displaySearchText: '',
                        isDirectFilterApply: true,
                        sqlValue: 'data->>\'resolved\' = \'false\'',
                        localSearchValue: 'obj.resolved === false'
                    }
                ];
                vm.isIssueAdding = false;
                vm.tempCompletedAttributeList = [];

                vm.fnOrderFiltersArr = function () {
                    var tempArr = FiltersArrOrder.map(function (i) {
                        return vm.searchFiltersArr.find(function (o) {
                            return o.displayName === i;
                        });
                    });
                    vm.searchFiltersArr = _.filter(tempArr, function (tempObj) {
                        return angular.isObject(tempObj);
                    });
                };

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: "createdAt", displayName: "Created"},
                    {name: "updatedAt", displayName: "Updated"},
                    {name: "tracker_issues.issuePriority.name", displayName: "Priority"}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Issues Variables
                vm.isIssuesLoading = false;
                vm.issuesArr = [];
                vm.selectedIssueObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.issueResponse = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#issueTable").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.page) {
                        vm.currentPage = Math.ceil(vm.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.perPage = Math.ceil(vm.perPage)
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetIssues({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetIssues = function (inputObj, isFirst) {
                    vm.isIssuesLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var currentTime = moment().unix();
                            res.data.map(function (obj) {
                                obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.resolvedAt) {
                                    obj.resolvedDate = vm.fnGetAbsoluteOrRelativeTime(obj.resolvedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.resolutionDeadlineAt) {
                                    obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                                    obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                                    var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    obj.issueCreateDate = issueCreateDate;
                                    obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    obj.issueDeadline = issueDeadline;
                                    obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (obj.responseDeadlineAt) {
                                    obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                                    obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                                    var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    obj.issueUpdatedDate = issueUpdatedDate;
                                    obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    obj.issueResponseDeadline = issueResponseDeadline;
                                    obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (obj.resolved && obj.resolutionDeadlineAt) {
                                    if (obj.resolvedAt <= obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = true
                                    } else if (obj.resolvedAt > obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = false
                                    }
                                }
                                obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(obj.lastPublicCommentReadBy) && obj.lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(obj.lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    obj.isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    obj.isRead = false;
                                }
                            });
                            vm.issueResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.issueResponse.data && vm.issueResponse.data.length) {
                                vm.totalItems = vm.issueResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.issueResponse.data.reverse();
                            }
                            vm.issuesArr = vm.issueResponse.data;
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };
                /*END: Search*/

                vm.fnGetProjectIssue = function (projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_issues';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', '');
                    }
                    vm.fnGetIssues({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_issues';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIssues(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.issuesArr);
                        vm.previousPage = page;
                        vm.fnGetIssues(input, false);
                    }
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj.color)) {
                        vm.labelTextColor = vm.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + vm.labelTextColor
                        }
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckCheckbox = function (issuesObj) {
                    angular.forEach(vm.issuesArr, function (obj) {
                        if (issuesObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindIssue = _.find(vm.issuesArr, function (issuesObj) {
                        return issuesObj.isCheck === true;
                    });
                    if (isFindIssue) {
                        vm.selectedIssueObj = _.cloneDeepWith(isFindIssue);
                    } else {
                        vm.selectedIssueObj = {};
                    }
                };

                vm.isIssueObjSelected = function () {
                    return !!vm.selectedIssueObj && Object.keys(vm.selectedIssueObj).length;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnAddIssue = function () {
                    vm.isIssueAdding = true;
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedAttributes, function (selectedAttribute, index) {
                        if (index <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + vm.selectedIssueObj.id + "/attributes/" + selectedAttribute.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + vm.selectedIssueObj.id + "/attributes/" + selectedAttribute.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    count = 1;
                    vm.fnAttributeBatchOperation(batchCollectionObj, count);
                }

                vm.fnAttributeBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker',
                        parallel: false
                    }).then(function (batchRes) {
                        _.forEach(batchRes, function (obj) {
                            if (obj.statusCode.toString().startsWith('20')) {
                                var tempId = obj.request.path.split('/');
                                var isFind = _.find(vm.selectedAttributes, {id: tempId[tempId.length - 1]})
                                if (isFind) {
                                    vm.tempCompletedAttributeList.push(isFind);
                                }
                            }
                        });
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnAttributeBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success('Attribute added successfully');
                            vm.isIssueAdding = false;
                            $uibModalInstance.close({
                                attributes: vm.tempCompletedAttributeList,
                                issueId: vm.selectedIssueObj.id
                            });
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnAttributeBatchOperation(batchCollectionObj, count);
                        } else {
                            amaran.success('Attribute added successfully');
                            vm.isIssueAdding = false;
                            $uibModalInstance.close({
                                attributes: vm.tempCompletedAttributeList,
                                issueId: vm.selectedIssueObj.id
                            });
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    });
                };


                vm.fnInitIssueListModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('linkIssueModalCtrl',
            function ($rootScope, $window, $state, DB, $sce, moment, AppInitService, amaran, $timeout, copyService, $uibModalInstance, ApiListService, attributeObj, QueryFactory) {
                var vm = this;
                vm.selectedAttribute = _.cloneDeepWith(attributeObj);
                vm.isIssueDataLoading = true;
                vm.issuesArr = [];
                var getCurrentURL = ApiListService.getCurrentURL();

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element("thead")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var finalHeight = total - (header + 30);
                        angular.element("#alarmIssueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetAttributes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            var currentTime = moment().unix();
                            res.data.map(function (obj) {
                                obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.resolvedAt) {
                                    obj.resolvedDate = vm.fnGetAbsoluteOrRelativeTime(obj.resolvedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.resolutionDeadlineAt) {
                                    obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                                    obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                                    var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    obj.issueCreateDate = issueCreateDate;
                                    obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    obj.issueDeadline = issueDeadline;
                                    obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (obj.responseDeadlineAt) {
                                    obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                                    obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                                    var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    obj.issueUpdatedDate = issueUpdatedDate;
                                    obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    obj.issueResponseDeadline = issueResponseDeadline;
                                    obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (obj.resolved && obj.resolutionDeadlineAt) {
                                    if (obj.resolvedAt <= obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = true
                                    } else if (obj.resolvedAt > obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = false
                                    }
                                }
                                obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            });
                            vm.issuesArr = res.data;
                            vm.isIssueDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueDataLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        })
                }

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };


                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                vm.fnGetIssuesLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj.color)) {
                        vm.labelTextColor = vm.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + vm.labelTextColor
                        }
                    }
                };

                vm.fnCopyInfoToClipboard = function (data, type) {
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnOpenIssueInfo = function (issueObj) {
                    $state.go('main.issue', {selectedId: issueObj.id});
                    $uibModalInstance.dismiss('cancel');
                }

                vm.fnOpenIssueInNewTab = function (issueObj) {
                    var url = getCurrentURL+ "/#/tracker/issue?selectedId=" + issueObj.id;
                    $window.open(url, "_blank");
                }

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                var tempIdString = "";
                                _.forEach(vm.selectedAttribute.issueIds, function (id, index) {
                                    if (index === vm.selectedAttribute.issueIds.length - 1) {
                                        tempIdString += "'" + id + "'";
                                    } else {
                                        tempIdString += "'" + id + "',";
                                    }
                                })
                                var sql = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_issues where data->>\'id\' IN (" + tempIdString + ");"
                                vm.fnGetAttributes({"sql": sql});
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnInitLinkIssueModal = function () {
                    vm.isIssueDataLoading = true;
                    var tempIdString = "";
                    _.forEach(vm.selectedAttribute.issueIds, function (id, index) {
                        if (index === vm.selectedAttribute.issueIds.length - 1) {
                            tempIdString += "'" + id + "'";
                        } else {
                            tempIdString += "'" + id + "',";
                        }
                    })
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var sql = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_issues where id IN (" + tempIdString + ");"
                        vm.fnGetAttributes({"sql": sql});
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProject({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeTelemetryModalCtrl',
            function ($rootScope, $window, moment, amaran, d3, $timeout, $log, $uibModalInstance, mermaid, NodeFactory, QueryFactory, ColorService, panzoom, attributeId) {
                var vm = this;
                vm.selectedAttributeId = _.cloneDeepWith(attributeId);
                vm.selectedChartType = 'spline';
                vm.isChartDataLoading = true;
                vm.isHeatmapChartDataLoading = false;
                vm.selectedChartData = {};
                vm.selectedHeatmapChart = {};
                vm.vegaChartData = {};
                vm.axisArr = [
                    {
                        title: 'Minutes',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59"]
                    },
                    {
                        title: 'Hours',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]
                    },
                    {
                        title: 'Days',
                        categories: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
                    },
                    {
                        title: 'Weeks',
                        categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54"]
                    },
                    {
                        title: 'Months',
                        categories: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
                    }
                ];
                vm.mathFunction = [
                    {
                        title: 'MIN'
                    },
                    {
                        title: 'MAX'
                    },
                    {
                        title: 'AVG'
                    }
                ];
                vm.selectedMathFunction = 'MAX';
                vm.selectedXAxis = vm.axisArr[2];
                vm.selectedYAxis = vm.axisArr[0];

                // Add this function to the attributeTelemetryModal.controller.js file
                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Parse data field if it's a string (JSONB from Postgres is returned as string)
                        if (angular.isString(parsedItem.data)) {
                            try {
                                parsedItem.data = angular.fromJson(parsedItem.data);
                            } catch (e) {
                                $log.error('Error parsing data JSON:', e);
                                // Keep data as is if parsing fails
                            }
                        }

                        // Process data fields - directly copy properties from data to the item
                        if (parsedItem.data && angular.isObject(parsedItem.data)) {
                            // Extract key properties from the data object
                            var dataProps = ['name', 'value', 'reference', 'health', 'mode', 'ecuId', 'nodeId',
                                'healthLastChangedAt', 'projectId', 'read', 'write', 'operation',
                                'syncState', 'valueType', '_event_time', 'type', 'attributeId'];

                            dataProps.forEach(function(prop) {
                                if (angular.isDefined(parsedItem.data[prop])) {
                                    parsedItem[prop] = parsedItem.data[prop];
                                }
                            });

                            // Handle boolean fields
                            if (angular.isDefined(parsedItem.value)) {
                                if (parsedItem.valueType === 'BOOLEAN') {
                                    parsedItem.value = parsedItem.value === "true" || parsedItem.value === true;
                                } else if (parsedItem.valueType === 'FLOAT') {
                                    parsedItem.value = parseFloat(parsedItem.value);
                                }
                            }

                            // Handle timestamps
                            if (parsedItem._event_time) {
                                var microseconds;
                                if (angular.isObject(parsedItem._event_time) && parsedItem._event_time.value) {
                                    microseconds = parseInt(parsedItem._event_time.value);
                                } else {
                                    microseconds = parseInt(parsedItem._event_time);
                                }

                                if (!isNaN(microseconds)) {
                                    parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    parsedItem.timestamp = Math.floor(microseconds / 1000000);
                                }
                            }
                        }

                        // Handle direct timestamp field in query results
                        if (parsedItem.ts && angular.isString(parsedItem.ts)) {
                            try {
                                var tempDate = parsedItem.ts.replace('T', ' ').split('.')[0];
                                parsedItem.timestamp = moment(tempDate).valueOf();
                            } catch (e) {
                                $log.error('Error parsing timestamp:', e);
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };

                // Updated fnGetSQLQuery function
                vm.fnGetSQLQuery = function (srcList) {
                    var previousDateString = "";
                    var endDateString = moment.unix(parseInt(vm.selectedRange.split(',')[1])).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var startTime = moment.unix(parseInt(vm.selectedRange.split(',')[0]), 'YYYY-MM-DD HH:mm:ss');
                    var endTime = moment.unix(parseInt(vm.selectedRange.split(',')[1]), 'YYYY-MM-DD HH:mm:ss');
                    var diffrent = endTime.diff(startTime, 'days');
                    var differenceInHours = endTime.diff(startTime, 'hours');
                    var sql = "";

                    if (differenceInHours <= 23) {
                        previousDateString = moment.unix(parseInt(vm.selectedRange.split(',')[0])).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                        sql = "WITH raw_readings AS ( SELECT data->>\'timestamp\' as timestamps, data->>\'attributeId\' as id, " +
                            "DATE_TRUNC('second', to_timestamp((data->>\'timestamp\')::bigint)) as ts, data->>\'value\' as value " +
                            "FROM node_iot_attribute_values where data->>\'attributeId\' = '" + srcList.id + "' order by data->>\'timestamp\' ), " +
                            "readings AS ( ( SELECT * FROM raw_readings WHERE ts < TIMESTAMP '" + previousDateString + "' order by ts desc LIMIT 1 ) " +
                            "UNION ( SELECT * FROM raw_readings WHERE ts > TIMESTAMP '" + previousDateString + "' AND ts < TIMESTAMP '" + endDateString + "' ) )," +
                            " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' - INTERVAL '1 hour' AS last_ts, " +
                            "TIMESTAMP '" + previousDateString + "' + (n * INTERVAL '1 hour') AS ts " +
                            "FROM generate_series(0, " + differenceInHours + ", 1) AS n(i)," +
                            " slot_values AS ( SELECT slots.ts, " +
                            "( SELECT r.value FROM readings r WHERE r.ts <= slots.ts ORDER BY r.ts DESC LIMIT 1 ) AS last_val, " +
                            "( SELECT MAX(r.value) FROM readings r WHERE r.ts <= slots.ts AND r.ts >= slots.last_ts ) AS slot_agg_val " +
                            "FROM slots ) " +
                            "SELECT ts, COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value FROM slot_values ORDER BY ts;";
                    } else {
                        previousDateString = moment.unix(parseInt(vm.selectedRange.split(',')[0])).subtract(1, 'days').format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                        sql = "WITH raw_readings AS ( SELECT data->>\'timestamp\' as timestamps, data->>\'attributeId\' as id, " +
                            "DATE_TRUNC('second', to_timestamp((data->>\'timestamp\')::bigint)) as ts, data->>\'value\' as value " +
                            "FROM node_iot_attribute_values where data->>\'attributeId\' = '" + srcList.id + "' order by data->>\'timestamp\' ), " +
                            "readings AS ( ( SELECT * FROM raw_readings WHERE ts < TIMESTAMP '" + previousDateString + "' order by ts desc LIMIT 1 ) " +
                            "UNION ( SELECT * FROM raw_readings WHERE ts > TIMESTAMP '" + previousDateString + "' AND ts < TIMESTAMP '" + endDateString + "' ) )," +
                            " slots AS ( SELECT TIMESTAMP '" + previousDateString + "' + (n * INTERVAL '1 day') AS last_ts, " +
                            "TIMESTAMP '" + previousDateString + "' + ((n + 1) * INTERVAL '1 day') AS ts " +
                            "FROM generate_series(0, " + diffrent + ", 1) AS n(i)," +
                            " slot_values AS ( SELECT slots.ts, " +
                            "( SELECT r.value FROM readings r WHERE r.ts <= slots.ts ORDER BY r.ts DESC LIMIT 1 ) AS last_val, " +
                            "( SELECT MAX(r.value) FROM readings r WHERE r.ts <= slots.ts AND r.ts >= slots.last_ts ) AS slot_agg_val " +
                            "FROM slots ) " +
                            "SELECT ts, COALESCE( slot_agg_val, LAG(slot_agg_val, 1) OVER( ORDER BY ts ), last_val ) AS value FROM slot_values ORDER BY ts;";
                    }
                    return sql;
                };

// Updated fnGetHeatMapSQLQuery function
                vm.fnGetHeatMapSQLQuery = function (srcList) {
                    var startDateString = moment.unix(parseInt(vm.selectedRange.split(',')[0])).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var endDateString = moment.unix(parseInt(vm.selectedRange.split(',')[1])).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var selectedXAxisQString = "";
                    var selectedYAxisQString = "";

                    if (vm.selectedXAxis.title === 'Minutes') {
                        selectedXAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Hours') {
                        selectedXAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Days') {
                        selectedXAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else if (vm.selectedXAxis.title === 'Weeks') {
                        selectedXAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    } else {
                        selectedXAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as x";
                    }

                    if (vm.selectedYAxis.title === 'Minutes') {
                        selectedYAxisQString = "EXTRACT(MINUTE FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Hours') {
                        selectedYAxisQString = "EXTRACT(HOUR FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Days') {
                        selectedYAxisQString = "EXTRACT(DOW FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else if (vm.selectedYAxis.title === 'Weeks') {
                        selectedYAxisQString = "EXTRACT(WEEK FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    } else {
                        selectedYAxisQString = "EXTRACT(MONTH FROM to_timestamp((data->>\'timestamp\')::bigint)) as y";
                    }

                    var sql = "SELECT to_timestamp((data->>\'timestamp\')::bigint) AS date, " +
                        " " + selectedYAxisQString + " , " +
                        " " + selectedXAxisQString + " , " +
                        "CASE WHEN data->>\'valueType\' = 'FLOAT' THEN CAST(data->>\'value\' AS FLOAT) ELSE data->>\'value\' END as value " +
                        "FROM node_iot_attribute_values " +
                        "WHERE to_timestamp((data->>\'timestamp\')::bigint) > TIMESTAMP '" + startDateString + "' " +
                        "AND to_timestamp((data->>\'timestamp\')::bigint) < TIMESTAMP '" + endDateString + "' " +
                        "AND data->>\'attributeId\' = '" + srcList.id + "'";

                    return sql;
                };

                /*vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    /!*var isStringFound = false;
                    _.forEach(resData, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                    });*!/
                    _.forEach(resData, function (dataObj) {
                        var tempA = dataObj.ts.slice(0, -1).replace('T', ' ').split('.')[0];
                        $timeout(function () {
                            dataObj.timestamp = moment(tempA).format('x');
                            var tempDate = moment(tempA).format('MM/DD HH:mm');
                            /!*if (isStringFound) {
                                if (dataObj.value && dataObj.value !== '' && vm.attributesStringValueArr.indexOf(dataObj.value) === -1) {
                                    vm.attributesStringValueArr.push(dataObj.value);
                                }
                                tempData.push([parseInt(dataObj.timestamp), vm.attributesStringValueArr.indexOf(dataObj.value) === -1 ? null : vm.attributesStringValueArr.indexOf(dataObj.value)]);
                            } else {
                                tempData.push([parseInt(dataObj.timestamp), dataObj.value ? Number(dataObj.value) : null]);
                            }*!/
                            //tempData.push([parseInt(dataObj.timestamp), dataObj.value]);
                            tempData.push({
                                ts: tempDate,
                                value: dataObj.value ? dataObj.value : "null"
                            })
                        })
                    });
                    return tempData;
                };*/

                vm.fnGenerateChartData = function (srcList, resData) {
                    var tempData = [];
                    _.forEach(resData, function (dataObj) {
                        $timeout(function () {
                            var tempDate = moment(dataObj.timestamp).format('MM/DD HH:mm');
                            tempData.push({
                                ts: tempDate,
                                value: dataObj.value ? dataObj.value : "null"
                            });
                        });
                    });
                    return tempData;
                };

                vm.fnGenerateHeatMapChartData = function (srcList, apiRes) {
                    var chartData = [];
                    var isStringFound = false;
                    vm.heatmapAttributeStringValueArr = [];
                    _.forEach(apiRes, function (dataObj) {
                        if (dataObj.value && isNaN(dataObj.value)) {
                            isStringFound = true;
                        }
                        if (dataObj.value && dataObj.value !== '' && vm.heatmapAttributeStringValueArr.indexOf(dataObj.value) === -1) {
                            vm.heatmapAttributeStringValueArr.push(dataObj.value);
                        }
                    });
                    if (!isStringFound) {
                        vm.heatmapAttributeStringValueArr = [];
                    }
                    _.forEach(vm.selectedXAxis.categories, function (xAxisCategoriesObj, xAxisIndex) {
                        _.forEach(vm.selectedYAxis.categories, function (yAxisCategoriesObj, yAxisIndex) {
                            var minValue = 0;
                            var maxValue = 0;
                            var avgValue = 0;
                            var isFindData = _.filter(apiRes, {x: xAxisIndex, y: yAxisIndex});
                            if (isFindData && isFindData.length) {
                                minValue = isFindData[0].value;
                                maxValue = isFindData[0].value;
                                var sum = 0;
                                avgValue = 0;
                                if (isStringFound) {
                                    if (isFindData && isFindData.length > 1) {
                                        var groupData = _.groupBy(isFindData, function (n) {
                                            return n.value;
                                        });
                                        var minLength = Object.values(groupData)[0].length;
                                        var maxLength = Object.values(groupData)[0].length;
                                        minValue = Object.keys(groupData)[0];
                                        maxValue = Object.keys(groupData)[0];
                                        _.forEach(isFindData, function (findObj, key) {
                                            if (findObj.length < minLength) {
                                                minValue = key;
                                                minLength = findObj.length;
                                            }
                                            if (findObj.length > maxLength) {
                                                maxValue = key;
                                                maxLength = findObj.length;
                                            }
                                        });
                                        avgValue = isFindData.reduce(function (sum, next) {
                                            return sum && next.value;
                                        }, true);
                                    } else {
                                        minValue = isFindData[0].value;
                                        maxValue = isFindData[0].value;
                                        avgValue = isFindData[0].value;
                                    }
                                } else {
                                    _.forEach(isFindData, function (findObj) {
                                        if (findObj.value < minValue) {
                                            minValue = findObj.value;
                                        }
                                        if (findObj.value > maxValue) {
                                            maxValue = findObj.value;
                                        }
                                        sum = sum + findObj.value;
                                    });
                                    avgValue = sum / isFindData.length;
                                }
                                var value = null;
                                if (vm.selectedMathFunction === 'MIN') {
                                    value = minValue;
                                } else if (vm.selectedMathFunction === 'MAX') {
                                    value = maxValue;
                                } else {
                                    value = avgValue;
                                }
                                if (isStringFound) {
                                    chartData.push({
                                        x: xAxisIndex,
                                        XName: xAxisCategoriesObj,
                                        y: yAxisIndex,
                                        YName: yAxisCategoriesObj,
                                        value: vm.heatmapAttributeStringValueArr.indexOf(value),
                                        name: value
                                    })
                                } else {
                                    chartData.push({
                                        x: xAxisIndex,
                                        XName: xAxisCategoriesObj,
                                        y: yAxisIndex,
                                        YName: yAxisCategoriesObj,
                                        value: value
                                    })
                                }
                            } else {
                                chartData.push({
                                    x: xAxisIndex,
                                    XName: xAxisCategoriesObj,
                                    y: yAxisIndex,
                                    YName: yAxisCategoriesObj,
                                    value: null
                                });
                            }

                        })
                    });
                    return chartData;
                };

                vm.fnGetAttributeAnalyticsData = function (srcList) {
                    var sql = vm.fnGetSQLQuery(srcList);
                    QueryFactory.executeQuery({'sql': sql})
                        .then(function (res) { // Success block
                            var parsedData = parsePostgresData(res.data);
                            vm.selectedChartData.apiData = parsedData;
                            vm.selectedChartData.chartData = vm.fnGenerateChartData(srcList, parsedData);
                            vm.isChartDataLoading = false;
                            $timeout(function () {
                                vm.fnRenderChart();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartDataLoading = false;
                        });
                };

                vm.fnRenderChart = function () {
                    var dataAA = vm.selectedChartData.chartData;
                    var teData = _.cloneDeepWith(dataAA);
                    if (vm.selectedChartType === 'pie') {
                        vm.chartData = [];
                        var counts = {};
                        vm.selectedChartData.chartData.forEach(function (x) {
                            counts[x.value] = (counts[x.value] || 0) + 1;
                        });
                        _.forEach(counts, function (value, key) {
                            vm.chartData.push({
                                name: key,
                                y: value
                            });
                        });
                        vm.vegaChartData = {
                            "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
                            "width": "container",
                            "height": "container",
                            "description": "",
                            "data": {
                                "values": vm.chartData
                            },
                            "mark": "arc",
                            "encoding": {
                                "theta": {"field": "y", "type": "quantitative"},
                                "color": {"field": "name", "type": "nominal"}
                            },
                            "view": {"stroke": null}
                        }
                        $timeout(function () {
                            /*eslint-disable*/
                            vegaEmbed("#test-vega", vm.vegaChartData, {actions: false}).then(function (result) {
                            }).catch(console.error);
                            /*eslint-disable*/
                        });
                    }
                    if (vm.selectedChartType === 'spline') {
                        var tempChartData = [];
                        _.forEach(dataAA, function (aa) {
                            tempChartData.push(aa)
                        })
                        vm.vegaChartData = {
                            "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
                            "description": "Bump chart",
                            "width": "container",
                            "height": "container",
                            "data": {
                                "values": teData
                            },
                            "mark": {"type": "line", "point": true},
                            "encoding": {
                                "x": {
                                    "field": "ts", "type": "ordinal", "axis": {
                                        "labelAngle": -45
                                    },
                                    "title": 'Date'
                                },
                                "y": {"field": "value", "type": "nominal", "title": 'Attribute Value'},
                                "order": {
                                    "field": "value",
                                    "type": "nominal"
                                }
                            }
                        };
                        vm.vegaChartData.data.values = tempChartData
                        $timeout(function () {
                            /*eslint-disable*/
                            vegaEmbed("#test-vega", vm.vegaChartData, {actions: false}).then(function (result) {
                            }).catch(console.error);
                            /*eslint-disable*/
                        });
                    }
                    if (vm.selectedChartType === 'heatmap') {
                        vm.isHeatmapChartDataLoading = true;
                        var sql = vm.fnGetHeatMapSQLQuery({id: vm.selectedAttributeId});
                        QueryFactory.executeQuery({'sql': sql})
                            .then(function (res) { // Success block
                                vm.isHeatmapChartDataLoading = false;
                                var parsedData = parsePostgresData(res.data);
                                vm.selectedHeatmapChart.apiData = _.cloneDeepWith(parsedData);
                                var chartData = vm.fnGenerateHeatMapChartData(vm.selectedHeatmapChart, _.cloneDeepWith(parsedData));
                                var chartName = '';
                                var isStringFound = false;
                                _.forEach(res.data, function (dataObj) {
                                    if (dataObj.value && isNaN(dataObj.value)) {
                                        isStringFound = true;
                                    }
                                });
                                vm.vegaChartData = {
                                    "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
                                    "width": "container",
                                    "height": "container",
                                    "data": {"values": chartData},
                                    "mark": "rect",
                                    "encoding": {
                                        "y": {
                                            "field": "YName",
                                            "type": "nominal",
                                            "title": vm.selectedYAxis.title,
                                            "sort": {"field": "y", "order": "descending"}
                                        },
                                        "x": {
                                            "field": "XName",
                                            "type": "nominal",
                                            "title": vm.selectedXAxis.title,
                                            "axis": {
                                                "labelAngle": 0
                                            },
                                            "sort": {"field": "x", "order": "ascending"}
                                        },
                                        "color": {"field": "name"}
                                    },
                                    "config": {"axis": {"grid": true, "tickBand": "extent"}}
                                }
                                vm.vegaChartData.data.values = chartData;
                                $timeout(function () {
                                    /*eslint-disable*/
                                    vegaEmbed("#nodeAttributeHeatmapChart", vm.vegaChartData, {actions: false}).then(function (result) {
                                    }).catch(console.error);
                                    /*eslint-disable*/
                                });
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                    if (vm.selectedChartType === 'bar') {
                        var tempChartData = [];
                        _.forEach(dataAA, function (aa) {
                            tempChartData.push(aa)
                        })
                        vm.vegaChartData = {
                            "$schema": "https://vega.github.io/schema/vega-lite/v5.json",
                            "description": "Bump chart",
                            "width": "container",
                            "height": "container",
                            "data": {
                                "values": teData
                            },
                            "mark": "bar",
                            "encoding": {
                                "x": {
                                    "field": "ts", "type": "nominal", "axis": {
                                        "labelAngle": -45
                                    },
                                    "title": 'Date'
                                },
                                "y": {"field": "value", "type": "nominal", "title": 'Attribute Value'}
                            }
                        };
                        vm.vegaChartData.data.values = tempChartData
                        $timeout(function () {
                            /*eslint-disable*/
                            vegaEmbed("#test-vega", vm.vegaChartData, {actions: false}).then(function (result) {
                            }).catch(console.error);
                            /*eslint-disable*/
                        });
                    }
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInject = function () {
                    delete vm.vegaChartData.width;
                    delete vm.vegaChartData.height;
                    $uibModalInstance.close(vm.vegaChartData);
                }

                vm.fnInitAttributeTelemetryModal = function () {
                    var start = moment().subtract(3, 'hours');
                    var end = moment();
                    $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                        timePicker: true,
                        timePicker24Hour: true,
                        autoApply: true,
                        opens: 'left',
                        startDate: start,
                        endDate: end,
                        maxDate: moment(),
                        StartMinDate: moment().subtract(1, 'days'),
                        ranges: {
                            'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                            'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                            'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                            'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                            'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                            'Today': [moment().startOf('day'), moment()],
                            'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                            'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                            'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                            'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                        },
                        locale: {
                            format: 'YYYY/MM/DD HH:mm'
                        }
                    }, function (start, end) {
                        vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                        }
                        //vm.fnRenderChart();
                        vm.fnGetAttributeAnalyticsData({id: vm.selectedAttributeId});
                    });
                    vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                    }
                    vm.isChartDataLoading = true;
                    vm.fnGetAttributeAnalyticsData({id: vm.selectedAttributeId});
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeSyncModalCtrl',
            function ($rootScope, $window, moment, $timeout, $uibModalInstance, QueryFactory, amaran, jobObj, NodeEcuFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });
                vm.jobAPITimeout = '';

                vm.jobObj = _.cloneDeepWith(jobObj);
                vm.ecuDetailsLoading = true;
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to Synchronizing Attribute\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job\n";
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where id = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $timeout.cancel(vm.jobAPITimeout);
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetECUDetails = function (ecuId) {
                    var inputObj = {
                        ecuId: ecuId
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            vm.ecuObj = _.cloneDeepWith(response);
                            vm.ecuDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.ecuDetailsLoading = false;
                        })
                }

                vm.fnInitJobTerminalModal = function () {
                    vm.fnGetECUDetails(vm.jobObj.ecuId);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeGraphModalCtrl',
            function ($rootScope, $window, moment, amaran, d3, $timeout, $uibModalInstance, mermaid, NodeFactory, QueryFactory, ColorService, panzoom, attributeId, $log) {
                var vm = this;
                vm.graphOptionsArr = [{
                    displayName: 'AUTO COMPLETE',
                    name: 'AUTO_COMPLETE'
                }, {
                    displayName: 'AUTO UPSTREAM',
                    name: 'AUTO_UPSTREAM'
                }, {
                    displayName: 'AUTO DOWNSTREAM',
                    name: 'AUTO_DOWNSTREAM'
                }];
                /*, {
                    displayName: 'CURRENT',
                    name: 'CURRENT'
                }*/
                vm.selectedGraphObj = vm.graphOptionsArr[0];
                vm.selectedAttributeId = _.cloneDeepWith(attributeId);
                vm.isNodeLoading = true;
                vm.finalMermaidString = "";
                vm.isShowMermaid = false;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnGetNodes = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            // Parse the response data using the parsePostgresData method
                            var parsedData = parsePostgresData(res.data);

                            _.forEach(parsedData, function (nodeObj) {
                                var nodeStyle = ColorService.getHealthColorForLoop(nodeObj.projectId, nodeObj.health);
                                nodeObj.healthName = nodeStyle.content;
                                nodeObj.healthColor = nodeStyle['background-color'];
                                nodeObj.textColor = nodeStyle.color;
                            })
                            vm.nodeObj = _.cloneDeepWith(_.find(parsedData, {id: vm.selectedNodeId}));
                            vm.nodeResponse = _.cloneDeepWith({data: parsedData});
                            var treeData = buildHierarchy(vm.nodeResponse.data);
                            if (treeData && treeData.length > 1) {
                                vm.nodeHierarchicalData = {
                                    name: 'Root',
                                    description: 'Main Node',
                                    isDummyNode: true,
                                    children: treeData
                                }
                            } else {
                                vm.nodeHierarchicalData = treeData[0]
                            }
                            vm.fnRenderGraph();
                            vm.isNodeLoading = false;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeLoading = false;
                        })
                };

                vm.fnRenderGraph = function () {
                    vm.isShowMermaid = false;
                    if (vm.selectedGraphObj.name === 'AUTO_COMPLETE') {
                        var tempTreeData = [];
                        if (vm.nodeObj.rootNodeId && vm.nodeObj.rootNodeId !== '') {
                            tempTreeData = _.filter(vm.nodeResponse.data, function (dataObj) {
                                return dataObj.rootNodeId === vm.nodeObj.rootNodeId;
                            })
                        } else {
                            tempTreeData.push(vm.nodeObj);
                        }
                        vm.nodesArr = _.cloneDeepWith(tempTreeData);
                        var treeData = buildHierarchy(vm.nodesArr);
                        if (treeData && treeData.length) {
                            if (treeData && treeData.length > 1) {
                                vm.nodeTreeData = {
                                    name: 'Root',
                                    description: 'Main Node',
                                    isDummyNode: true,
                                    children: treeData
                                }
                            } else {
                                vm.nodeTreeData = treeData[0]
                            }
                        } else {
                            vm.nodeTreeData = {};
                        }
                    } else if (vm.selectedGraphObj.name === 'AUTO_UPSTREAM') {
                        var isFindData1 = {};
                        var testingData = [];
                        if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === vm.nodeObj.id) {
                            isFindData1 = _.cloneDeepWith(vm.nodeHierarchicalData);
                            delete isFindData1.children
                            if (isFindData1 && Object.keys(isFindData1).length) {
                                vm.nodeTreeData = isFindData1;
                            } else {
                                vm.nodeTreeData = {};
                            }
                        } else {
                            var tempHierarchicalData = _.cloneDeepWith(vm.nodeHierarchicalData);
                            if (vm.nodeHierarchicalData.name === 'Root') {
                                tempHierarchicalData = {}
                            }
                            var currentNode = searchRecursiveForUpstream(_.cloneDeepWith(tempHierarchicalData), _.cloneDeepWith(vm.nodeHierarchicalData.children), vm.nodeObj.id, testingData)
                            if (currentNode) {
                                delete currentNode.children
                                testingData.push(currentNode);
                                testingData = buildHierarchy(_.cloneDeepWith(testingData));
                                if (testingData[0].children && testingData[0].children.length > 1) {
                                    var isFindNode = _.findIndex(testingData[0].children, {id: vm.parent.nodeObj.id});
                                    vm.nodeTreeData = testingData[0].children[isFindNode];
                                } else {
                                    vm.nodeTreeData = testingData[0];
                                }
                            } else {
                                vm.nodeTreeData = {};
                            }
                        }
                    } else if (vm.selectedGraphObj.name === 'AUTO_DOWNSTREAM') {
                        var isFindData = {};
                        if (vm.nodeHierarchicalData.id && vm.nodeHierarchicalData.id === vm.nodeObj.id) {
                            isFindData = vm.nodeHierarchicalData;
                        } else {
                            isFindData = searchRecursiveForDownstream(_.cloneDeepWith(vm.nodeHierarchicalData.children), vm.nodeObj.id)
                        }
                        if (isFindData && Object.keys(isFindData).length) {
                            vm.nodeTreeData = isFindData;
                        } else {
                            vm.nodeTreeData = {};
                            vm.nodeFileData = _.cloneDeepWith([]);
                        }
                    }
                    vm.mermaidString = "graph LR \n";
                    vm.finalMermaidString = "";
                    if (Object.keys(vm.nodeTreeData).length === 1) {
                        //array
                        _.forEach(vm.nodeTreeData, function (nodeObj) {
                            vm.mermaidString += "root --> " + nodeObj.id + "\n";
                            if (nodeObj.children && nodeObj.children.length) {
                                vm.fnGetMermaidString(nodeObj);
                            }
                        })
                    } else {
                        if (vm.nodeTreeData.children && vm.nodeTreeData.children.length) {
                            vm.fnGetMermaidString(vm.nodeTreeData);
                        } else {
                            vm.mermaidString +=  vm.nodeTreeData.id + "\n";
                        }
                    }
                    vm.finalMermaidString = _.cloneDeepWith(vm.mermaidString);
                    var re = /(\w{8})-ne((\w{6}))-nn((\w{6}))+/g;
                    var result = [];
                    var temp = '';
                    var health = [];
                    var classString = "";
                    var mappingString = "";
                    while ((temp = re.exec(vm.finalMermaidString)) !== null) {
                        if (result.indexOf(temp[0]) === -1) {
                            result.push(temp[0]);
                            var isFind = _.find(vm.nodeResponse.data, {id: temp[0]});
                            if (isFind) {
                                if (health.indexOf(isFind.health) === -1) {
                                    health.push(isFind.health);
                                    var nodeStyle = ColorService.getHealthColorForLoop(isFind.projectId, isFind.health);
                                    if (classString === "") {
                                        classString = "classDef health_" + isFind.health + " fill:" + nodeStyle['background-color'] + ",color:" + nodeStyle.color
                                    } else {
                                        classString += "\n classDef health_" + isFind.health + " fill:" + nodeStyle['background-color'] + ",color:" + nodeStyle.color
                                    }
                                }
                                if (mappingString === "") {
                                    mappingString = isFind.id + "[" + isFind.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFind.health
                                } else {
                                    mappingString += "\n " + isFind.id + "[" + isFind.name.replace(/[\[\]]/g, "").replace(/['"]+/g, "'") + "]:::health_" + isFind.health
                                }
                            }
                        }
                    }
                    vm.finalMermaidString  += "\n" + mappingString;
                    vm.finalMermaidString  += "\n" + classString;
                    $timeout(function () {
                        vm.isShowMermaid = true
                        vm.fnRenderMermaid();
                    })
                }

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".mermaid");
                        vm.fnCreateMermaidPanzoom();
                    }, 100);
                };
                /* eslint-enable */

                vm.fnCreateMermaidPanzoom = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#mermaidGraphParent');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('mermaidGraph'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                vm.fnGetMermaidString = function (nodeObj) {
                    _.forEach(nodeObj.children, function (childrenObj) {
                        vm.mermaidString += nodeObj.id + " --> " + childrenObj.id + "\n";
                        if (childrenObj.children && childrenObj.children.length) {
                            vm.fnGetMermaidString(childrenObj);
                        }
                    })
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInject = function () {
                    $uibModalInstance.close(vm.finalMermaidString);
                }

                function searchRecursiveForDownstream(data, id, testingData) {
                    var found = _.find(data, {id: id})
                    if (!found) {
                        var i = 0;
                        while (!found && i < data.length) {
                            if (data[i].children && data[i].children.length) {
                                found = searchRecursiveForDownstream(data[i].children, id, testingData);
                            }
                            i++;
                        }
                    }
                    return found;
                }

                function searchRecursiveForUpstream(tempData, data, id, testingData) {
                    var found = _.find(data, {id: id})
                    if (tempData && Object.keys(tempData).length) {
                        delete tempData.children
                        testingData.push(tempData);
                    }
                    if (!found) {
                        var i = 0;
                        while (!found && i < data.length) {
                            if (data[i].children && data[i].children.length) {
                                found = searchRecursiveForUpstream(data[i], data[i].children, id, testingData);
                            }
                            i++;
                        }
                    }
                    return found;
                }

                function buildHierarchy(arry) {

                    var roots = [], children = {};

                    // find the top level nodes and hash the children based on parent
                    for (var i = 0, len = arry.length; i < len; ++i) {
                        var item = arry[i],
                            p = item.parentNodeId,
                            target = !p ? roots : (children[p] || (children[p] = []));

                        target.push(item);
                    }

                    // function to recursively build the tree
                    var findChildren = function (parent) {
                        if (children[parent.id]) {
                            parent.children = children[parent.id];
                            for (var i = 0, len = parent.children.length; i < len; ++i) {
                                findChildren(parent.children[i]);
                            }
                        }
                    };

                    // enumerate through to handle the case where there are multiple roots
                    for (i = 0, len = roots.length; i < len; ++i) {
                        findChildren(roots[i]);
                    }

                    return roots;
                }

                vm.fnInitAttributeGraphModal = function () {
                    vm.isNodeLoading = true;
                    vm.selectedNodeId = vm.selectedAttributeId.substring(0, vm.selectedAttributeId.lastIndexOf("-"));
                    $timeout(function () {
                        var input = {
                            sql: "SELECT node_nodes.*, node_ecus.data->\'connected\' as ecuConnected, node_projects.data->>\'name\' as projectName FROM node_nodes INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' INNER JOIN node_projects ON node_nodes.data->>\'projectId\' = node_projects.data->>\'id\'"
                        }
                        vm.fnGetNodes(input);
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('queryListModalCtrl',
            function ($rootScope, $window, $timeout, $sce, $uibModalInstance, amaran, moment, PaginationQueryService, QueryFactory, DB, AppInitService, UserProfileService) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#querysTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.isQueryAdding = false;

                var tableName = 'insight_queries';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.querysProjectFilter = "$";
                vm.querysProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isQuerysLoading = false;
                vm.querysResponse = [];
                vm.querysArr = [];
                vm.selectedQuerysArr = [];
                vm.selectedQuerysObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isQuerysLoading = true;
                    vm.selectedQuerysArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'querys', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetQuerys({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectQuerys = function (projectObj) {
                    vm.isQuerysLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetQuerys({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isQuerysLoading = true;
                    vm.selectedQuerysArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetQuerys(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.querysArr);
                        vm.previousPage = page;
                        vm.fnGetQuerys(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetQuerys = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.querysResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.querysResponse.data && vm.querysResponse.data.length) {
                                vm.totalItems = vm.querysResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.querysResponse.data.reverse();
                            }
                            vm.querysArr = _.cloneDeepWith(vm.querysResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isQuerysLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQuerysLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id? asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (querysObj) {
                    angular.forEach(vm.querysArr, function (obj) {
                        if (querysObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindQuerys = _.find(vm.querysArr, function (querysObj) {
                        return querysObj.isCheck === true;
                    });
                    if (isFindQuerys) {
                        vm.selectedQuerysObj = _.cloneDeepWith(isFindQuerys);
                    } else {
                        vm.selectedQuerysObj = {};
                    }
                };

                vm.isQueryObjSelected = function () {
                    return !!vm.selectedQuerysObj && Object.keys(vm.selectedQuerysObj).length;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInjectQuery = function () {
                    //$uibModalInstance.close();
                    $uibModalInstance.close({
                        id: vm.selectedQuerysObj.id,
                        name: vm.selectedQuerysObj.name,
                        sql: vm.selectedQuerysObj.sql,
                        projectId: vm.selectedQuerysObj.projectId
                    })
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitQueryListModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('highchartModalCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, highed) {
                var vm = this;
                var instance;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInjectChart = function () {
                    $uibModalInstance.close(instance.getEmbeddableJSON());
                };

                vm.fnInitHighchartModal = function () {
                    $("#chartEditor").empty(); //eslint-disable-line
                    var myOptions = {
                        chart: {
                            type: 'pie'
                        },
                        title: {
                            text: " "
                        },
                        subtitle: {
                            text: " "
                        },
                        xAxis: {
                            type: "category"
                        },
                        exporting: {
                            enabled: false
                        },
                        credits: {
                            enabled: false
                        },
                        plotOptions: {
                            series: {
                                dataLabels: {
                                    enabled: true
                                }
                            }
                        },
                        series: [
                            {
                                animationLimit: -1
                            }
                        ],
                        legend: {
                            enabled: false
                        }
                    };
                    instance = highed.DrawerEditor('chartEditor', {
                        defaultChartOptions: myOptions
                    });
                    $timeout(function () {
                        $('.fa-bar-chart').click(); //eslint-disable-line
                        $timeout(function () {
                            if ($(".highed-list a:last-child")[0]) { //eslint-disable-line
                                $(".highed-list a:last-child")[0].remove(); //eslint-disable-line
                            }
                            $timeout(function () {
                                var data = document.getElementsByClassName("item");
                                for (var i = 0; i < data.length; i++) {
                                    data[i].addEventListener("click", function () {  //eslint-disable-line
                                        $('#chartEditor .highed-chart-template-cat-desc div').remove(); //eslint-disable-line
                                        $('#chartEditor .highed-chart-template-samples').remove(); //eslint-disable-line
                                    });
                                }
                            })
                        });
                    }, 250);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createWidgetModalCtrl',
            function ($rootScope, $window, $timeout, $sce, $uibModalInstance, chartObj, queryObj, DB, AppInitService, QueryFactory, InsightChartFactory, amaran, rawData, InsightWidgetFactory, predefinedQuery) {
                var vm = this;
                vm.selectedChartObj = _.cloneDeepWith(chartObj);
                vm.selectedQueryObj = _.cloneDeepWith(queryObj);
                vm.selectedRawData = _.cloneDeepWith(rawData);
                vm.selectedPredefinedQuery = _.cloneDeepWith(predefinedQuery);
                vm.isPredefinedQueryMatch = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + dashboardHeader);
                        angular.element(".tabContent1").css('height', finalHeight + 'px');
                        if (angular.element(".wizard")[0] && angular.element(".tab-content")[0] && angular.element(".title-border-bottom")[0]) {
                            var wizardInner = angular.element(".wizard")[0].offsetHeight;
                            var titleBorderBottom = angular.element(".title-border-bottom")[0].offsetHeight !== 0 ? angular.element(".title-border-bottom")[0].offsetHeight : 29;
                            angular.element(".wizard-tab-height").css('height', finalHeight - (wizardInner + titleBorderBottom) + 'px');
                        }
                    }
                };
                vm.svgArr = [
                    {
                        title: "Dashboard",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Account",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "User",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Team",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Vault",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Authenticator",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Federation",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email Template",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Audits",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/log.svg#log\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "S4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Issues",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Archives",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/archive.svg#archive\"></use> \n" +
                            "</svg>"
                    }, {
                        title: "Projects",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Labels",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/label.svg#label\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Priorities",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "States",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/state.svg#state\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Types",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/types.svg#types\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Payment Methods",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/card.svg#card\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Invoices",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/invoice.svg#invoice\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Discounts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/discount.svg#discount\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Credit Tokens",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/creditTokens.svg#creditToken\"></use> \n" +
                            "</svg>"

                    },
                    {
                        title: "Business",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/business.svg#business\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Plans",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/plan.svg#plan\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Products",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/product.svg#product\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Carts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"22px\" height=\"22px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/cart.svg#cart\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ECU",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Nodes",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/device.svg#device\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Alarms",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Jobs",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/jobs.svg#jobs\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Fleet",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Software",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/software.svg#software\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Healths",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/health.svg#health\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ES4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/es4.svg#es4\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Observers",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/observers.svg#observers\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Emails",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    }
                ];
                vm.activeStep = 1;
                vm.newWidgetObj = {
                    name: '',
                    description: '',
                    chartId: '',
                    projectId: '',
                    layout: {}
                };
                vm.widgetConfig = {
                    title: "",
                    icon: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">   <use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use> </svg>",
                    buttonText: "",
                    buttonLink: "",
                    target: "Same Window",
                    isExport: true,
                    exportOptions: [
                        {
                            name:"Download PNG image",
                            action: "downloadPNG",
                            isAllow: true
                        },
                        {
                            name:"Download JPEG image",
                            action: "downloadJPEG",
                            isAllow: true
                        },
                        {
                            name:"Download PDF image",
                            action: "downloadPDF",
                            isAllow: true
                        },
                        {
                            name:"Download SVG vector image",
                            action: "downloadSVG",
                            isAllow: true
                        },
                        {
                            name:"Download CSV File",
                            action: "downloadCSV",
                            isAllow: true
                        },
                        {
                            name:"Download XLS File",
                            action: "downloadXLS",
                            isAllow: true
                        }
                    ],
                    isTrackerExport: false
                }
                vm.isPasteSVGCode = false;
                vm.isWidgetCreating = false;
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.fnEditSVGCode = function () {
                    vm.isPasteSVGCode = true;
                };

                vm.fnSelectIcon = function (obj) {
                    vm.widgetConfig.icon = obj.iconURL;
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnGotoPreviousNextStep = function (isGotoPreviousStep) {
                    if (isGotoPreviousStep) {
                        vm.activeStep = vm.activeStep - 1;
                    } else {
                        vm.activeStep = vm.activeStep + 1;
                    }
                    /*if (vm.activeStep === 3) {

                    }*/
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    }, 0);
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                }, 0);
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newWidgetObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newWidgetObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnCheckQueryValidation = function () {
                    if (vm.selectedPredefinedQuery && vm.selectedPredefinedQuery.sql && vm.selectedPredefinedQuery.sql.length) {
                        if (vm.selectedQueryObj.sql === vm.selectedPredefinedQuery.sql) {
                            vm.isPredefinedQueryMatch = true;
                            vm.newWidgetObj.projectId = vm.selectedPredefinedQuery.projectId;
                        }
                    }
                }

                vm.fnCreateQuery = function () {
                    vm.isWidgetCreating = true;
                    if (vm.isPredefinedQueryMatch) {
                        vm.fnCreateChart(vm.selectedPredefinedQuery);
                    } else {
                        var queryInputObj = {
                            body: {
                                name: vm.newWidgetObj.name + " - Query",
                                description: vm.newWidgetObj.description,
                                sql: vm.selectedQueryObj.sql,
                                projectId: vm.newWidgetObj.projectId
                            }
                        };
                        QueryFactory.createQuery(queryInputObj)
                            .then(function (resObj) {
                                amaran.success("Query created successfully");
                                vm.fnCreateChart(resObj);
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isQueryCreating = false;
                            });
                    }
                }

                vm.fnCreateChart = function (res) {
                    var inputObj = {
                        body: {
                            name: vm.newWidgetObj.name + " - Chart",
                            description: vm.newWidgetObj.description
                        }
                    };
                    inputObj.body.queryId = res.id;
                    inputObj.body.projectId = vm.newWidgetObj.projectId;
                    inputObj.body.syntax = vm.selectedChartObj.syntax;
                    inputObj.body.definition = vm.selectedChartObj.definition;
                    InsightChartFactory.createChart(inputObj)
                        .then(function (resObj) {
                            amaran.success("Chart created successfully");
                            vm.fnCreateWidget(resObj);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                }

                vm.fnCreateWidget = function (res) {
                    var inputObj = {
                        body: vm.newWidgetObj
                    };
                    inputObj.body.chartId = res.id;
                    inputObj.body.projectId = vm.newWidgetObj.projectId;
                    inputObj.body.layout = _.cloneDeepWith(vm.widgetConfig);
                    InsightWidgetFactory.createWidget(inputObj)
                        .then(function () {
                            vm.isWidgetCreating = false;
                            amaran.success("Widget created successfully");
                            $uibModalInstance.close();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetCreating = false;
                        });
                }

                vm.fnInitCreateWidgetModal = function () {
                    vm.fnCheckQueryValidation();
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('insightProjectsArr');
                        vm.isProjectCreateLoaded = true;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 0);
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createChartModalCtrl',
            function ($rootScope, $window, $timeout, $sce, $uibModalInstance, chartObj, queryObj, DB, AppInitService, QueryFactory, InsightChartFactory, amaran, rawData, predefinedQuery) {
                var vm = this;
                vm.selectedChartObj = _.cloneDeepWith(chartObj);
                vm.selectedQueryObj = _.cloneDeepWith(queryObj);
                vm.selectedRawData = _.cloneDeepWith(rawData);
                vm.selectedPredefinedQuery = _.cloneDeepWith(predefinedQuery);
                vm.newChartObj = {
                    name: '',
                    description: '',
                    projectId: ''
                };
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.selectedProject = {};
                vm.isChartCreating = false;
                vm.isPredefinedQueryMatch = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newChartObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newChartObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnCreateQuery = function () {
                    vm.isChartCreating = true;
                    if (vm.isPredefinedQueryMatch) {
                        vm.fnCreateChart(vm.selectedPredefinedQuery);
                    } else {
                        var queryInputObj = {
                            body: {
                                name: vm.newChartObj.name + " - Query",
                                description: vm.newChartObj.description,
                                sql: vm.selectedQueryObj.sql,
                                projectId: vm.newChartObj.projectId
                            }
                        };
                        QueryFactory.createQuery(queryInputObj)
                            .then(function (resObj) {
                                amaran.success("Query created successfully");
                                vm.fnCreateChart(resObj);
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isQueryCreating = false;
                            });
                    }
                }

                vm.fnCheckQueryValidation = function () {
                    if (vm.selectedPredefinedQuery && vm.selectedPredefinedQuery.sql && vm.selectedPredefinedQuery.sql.length) {
                        if (vm.selectedQueryObj.sql === vm.selectedPredefinedQuery.sql) {
                            vm.isPredefinedQueryMatch = true;
                            vm.newChartObj.projectId = vm.selectedPredefinedQuery.projectId;
                        }
                    }
                }

                vm.fnCreateChart = function (res) {
                    var inputObj = {
                        body: {
                            name: vm.newChartObj.name,
                            description: vm.newChartObj.description
                        }
                    };
                    inputObj.body.queryId = res.id;
                    inputObj.body.projectId = vm.newChartObj.projectId;
                    inputObj.body.syntax = vm.selectedChartObj.syntax;
                    inputObj.body.definition = vm.selectedChartObj.definition;
                    InsightChartFactory.createChart(inputObj)
                        .then(function () {
                            amaran.success("Chart created successfully");
                            $uibModalInstance.close();
                            vm.isChartCreating = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartCreating = false;
                        });
                }

                vm.fnInitCreateChartModal = function () {
                    vm.fnCheckQueryValidation();
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('insightProjectsArr');
                        vm.isProjectCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('queryEditor', fnQueryEditorDirective);

    /** @ngInject */
    function fnQueryEditorDirective($timeout, $window, $uibModal, $http, moment, amaran, DB, QueryFactory, sqlFormatter, highed, Highcharts, IssueFactory, jsonToCsvConvertService) {
        return {
            restrict: 'EA',
            scope: {
                tabObj: '='
            },
            templateUrl: "app/insight/insight_query_editor/directives/queryEditor/queryEditor.html",
            link: function ($scope) {
                var chartMapping = [
                    {
                        "chartType": "arearange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "area",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "columnrange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "column",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "line",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "spline",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "pie",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "funnel",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "pyramid",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "solidgauge",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "bubble",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "value",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "boxplot",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "low",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q1",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "median",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q3",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "high",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "scatter",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    }
                ];
                $scope.availableDataLibs = ['ql_S4'];
                $scope.queryConfig = {
                    value: {},
                    editorValue: ''
                };
                $scope.isQuerySearchDataLoading = false;
                $scope.csvHeaderArr = [];
                $scope.selectedChartType = $scope.tabObj.chartType ? $scope.tabObj.chartType : "RAWDATA"; // HIGHCHARTS, RAWDATA
                $scope.selectedChart = {
                    chartConfiguration: {
                        chartType: 'pie',
                        dataMapping: {},
                        chartConfig: {
                            chart: {
                                type: 'pie'
                            },
                            title: {
                                text: " "
                            },
                            subtitle: {
                                text: " "
                            },
                            xAxis: {
                                type: "category"
                            },
                            exporting: {
                                enabled: false
                            },
                            credits: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            },
                            series: [
                                {
                                    animationLimit: -1
                                }
                            ],
                            legend: {
                                enabled: false
                            }
                        }
                    }
                };
                $scope.dataConfig = _.cloneDeepWith([
                    {
                        "key": "name",
                        "value": "",
                        "isRequired": true
                    },
                    {
                        "key": "y",
                        "value": "",
                        "isRequired": true
                    }
                ]);
                $scope.isAllowMultiField = false;
                $scope.isLoadDataFromTab = false;
                $scope.selectedPredefinedQuery = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".CodeMirror")[0])) {
                        var totalSQL = angular.element(".custom-sql-editor")[0].offsetHeight;
                        angular.element(".query-editor-main-content .CodeMirror").css('height', (totalSQL - 15) + 'px');
                    }
                };

                /*SQL: Start*/
                $scope.fnRunQuery = function () {
                    if ($scope.queryConfig.value.getData().length) {
                        $scope.isQuerySearchDataLoading = true;
                        $scope.softwareSearchData = [];
                        $scope.csvHeaderArr = [];
                        var input = {
                            "sql": $scope.queryConfig.value.getData()
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            $scope.querySearchData = res;
                            $scope.querySearchDataHeader = [];
                            $scope.apiDataHeader = [];
                            _.forEach($scope.querySearchData.data, function (dataObj) {
                                _.forEach(dataObj, function (value, key) {
                                    if (!_.find($scope.querySearchDataHeader, {name: key})) {
                                        $scope.querySearchDataHeader.push({
                                            name: key,
                                            type: typeof value,
                                            isPlotted: false
                                        });
                                        $scope.csvHeaderArr.push(key);
                                    }
                                    $scope.apiDataHeader.push(key);
                                });
                            });
                            $scope.querySearchDataHeader = _.uniq(_.map($scope.querySearchDataHeader)).sort();
                            $scope.apiDataHeader = _.uniq(_.map($scope.apiDataHeader)).sort();
                            $scope.isQuerySearchDataLoading = false;
                            $scope.fnUpdateTabData();
                            if ($scope.isLoadDataFromTab) {
                                $scope.isLoadDataFromTab = false;
                                $scope.fnDataConfigSelected(false);
                                $scope.fnRefreshChart();
                            } else {
                                if ($scope.fnCheckRequiredInput()) {
                                    $scope.fnRefreshChart();
                                }
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isQuerySearchDataLoading = false;
                        });
                    }
                };

                $scope.fnCheckRequiredInput = function () {
                    var flag = true;
                    $scope.dataConfig.map(function (kvpPairObj) {
                        if (angular.isUndefined(kvpPairObj.key) || kvpPairObj.key === "" || angular.isUndefined(kvpPairObj.value) || kvpPairObj.value === "") {
                            flag = false;
                        }
                    });
                    return flag;
                };

                $scope.fnFormatSQL = function () {
                    var sql = $scope.queryConfig.value.getData();
                    $scope.queryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                $scope.test = function () {
                    if (angular.element('#csvAnchor')[0]) {
                        $timeout(function () {
                            document.getElementById('csvAnchor').click();
                        })
                    }
                }

                $scope.fnDownloadCSV = function () {
                    var tempData = _.cloneDeepWith($scope.querySearchData.data);
                    var tempCSVData = [];
                    var obj = {};
                    _.forEach(tempData, function (tempObj) {
                        obj = {};
                        _.forEach($scope.csvHeaderArr, function (headerObj) {
                            if (angular.isArray(tempObj[headerObj])) {
                                var tempArr = _.cloneDeepWith(tempObj[headerObj]);
                                if (tempArr.length) {
                                    if (angular.isObject(tempArr[0])) {
                                        /*eslint-disable*/
                                        obj[headerObj] = JSON.stringify(tempArr); //eslint-disable-line*/
                                        /*eslint-enable*/
                                    } else {
                                        obj[headerObj] = tempArr.toString();
                                    }
                                } else {
                                    obj[headerObj] = ''
                                }
                            } else if (angular.isObject(tempObj[headerObj])) {
                                if (!_.isEmpty(tempObj[headerObj])) {
                                    /*eslint-disable*/
                                    obj[headerObj] = JSON.stringify(tempObj[headerObj]); //eslint-disable-line*/
                                    /*eslint-enable*/
                                } else {
                                    obj[headerObj] = '';
                                }
                            } else {
                                obj[headerObj] = tempObj[headerObj]
                            }
                        })
                        tempCSVData.push(obj);
                    })
                    return tempCSVData;
                }

                $scope.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                $scope.fnGetType = function (data) {
                    return typeof data;
                };

                /*eslint-disable*/
                $scope.stripClone = function (obj) {
                    if (obj === null || !angular.isObject(obj)) {
                        return obj;
                    }
                    var copy = obj.constructor();
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr) && attr !== '$$hashKey') {
                            var obj_attr = obj[attr];
                            if (angular.isObject(obj_attr)) {
                                copy[attr] = $scope.stripClone(obj_attr);
                            } else if (typeof obj_attr === "array") { //eslint-disable-line*/
                                copy[attr] = [];
                                for (var i = 0; i < obj_attr.length; i++) {
                                    copy[attr].push($scope.stripClone(obj_attr));
                                }
                            } else {
                                copy[attr] = obj_attr;
                            }
                        }
                    }
                    return copy;
                };
                /*eslint-enable*/

                $scope.myEncodeJson = function (obj) {
                    return angular.toJson($scope.stripClone(obj));
                };

                $scope.fnDownloadJSON = function () {
                    var link = document.createElement("a");
                    link.download = "rowdata.json";
                    var data = "data:text/json;charset=utf-8," + $scope.myEncodeJson($scope.querySearchData.data);
                    link.href = "data:" + data;
                    link.click();
                }

                $scope.downloadChartData = function (id, type) {
                    var chart = $('#' + id).highcharts(); //eslint-disable-line
                    if (chart) {
                        if (type === 'downloadPNG') {
                            chart.exportChart();
                        } else if (type === 'downloadJPEG') {
                            chart.exportChart({
                                type: 'image/jpeg'
                            });
                        } else {
                            chart.exportChart({
                                type: 'image/svg+xml'
                            });
                        }
                    }
                }
                /*SQL: End*/

                $scope.fnOpenHighchartModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/insight/insight_query_editor/modals/highchartModal/highchartModal.html',
                        size: 'lg',
                        controller: 'highchartModalCtrl as highchartModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        $scope.selectedChart.chartConfiguration.chartConfig = _.cloneDeepWith(res);
                        $scope.selectedChart.chartConfiguration.chartType = $scope.selectedChart.chartConfiguration.chartConfig.chart.type;
                        var chartMappingData = _.find(chartMapping, {chartType: $scope.selectedChart.chartConfiguration.chartType});
                        $scope.isAllowMultiField = chartMappingData.isAllowMultiField;
                        $scope.dataConfig = [];
                        if ($scope.selectedChart && $scope.selectedChart.chartConfiguration && $scope.selectedChart.chartConfiguration.dataMapping && !_.isEmpty($scope.selectedChart.chartConfiguration.dataMapping)) {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                if ($scope.selectedChart.chartConfiguration.dataMapping[requiredDataObj.key]) {
                                    $scope.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: $scope.selectedChart.chartConfiguration.dataMapping[requiredDataObj.key],
                                        isRequired: true
                                    });
                                } else {
                                    $scope.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: '',
                                        isRequired: true
                                    });
                                }
                            });
                            if ($scope.dataConfig.length !== Object.keys($scope.selectedChart.chartConfiguration.dataMapping).length) {
                                var arr = Object.keys($scope.selectedChart.chartConfiguration.dataMapping);
                                _.forEach(arr, function (arrKey) {
                                    var isFind = _.find($scope.dataConfig, {key: arrKey});
                                    if (!isFind) {
                                        $scope.dataConfig.push(
                                            {
                                                key: arrKey,
                                                value: $scope.selectedChart.chartConfiguration.dataMapping[arrKey]
                                            }
                                        )
                                    }
                                });
                            }
                        } else {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                $scope.dataConfig.push({
                                    key: requiredDataObj.key,
                                    value: '',
                                    isRequired: true
                                });
                            });
                        }
                        $scope.selectedChart.chartConfiguration.dataMapping = {};
                        _.forEach($scope.dataConfig, function (dataConfigObj) {
                            $scope.selectedChart.chartConfiguration.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                        });
                        var testingJSON = $scope.selectedChart.chartConfiguration.chartConfig;
                        var headers = {};
                        _.forEach($scope.dataConfig, function (dataConfigObj) {
                            headers[dataConfigObj.value] = dataConfigObj.value
                        });
                        var items = [];
                        if ($scope.querySearchData && $scope.querySearchData.data && $scope.querySearchData.data.length) {
                            _.forEach($scope.querySearchData.data, function (obj) {
                                var tempObj = {};
                                _.forEach($scope.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                        }
                        items.unshift(headers);
                        var jsonObject = angular.toJson(items);
                        if (Object.keys(jsonObject).length) {
                            testingJSON.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                        }
                        $scope.selectedChart.chartConfiguration.chartConfig = testingJSON;
                        $scope.fnUpdateTabData();
                        $("#previewChart").empty(); //eslint-disable-line
                        $timeout(function () {
                            if (angular.isDefined(angular.element("#previewChart")[0])) {
                                Highcharts.chart('previewChart', testingJSON);
                            }
                        })
                    }, function () {

                    });
                };

                $scope.fnEditChartProperties = function () {
                    var testingJSON = $scope.selectedChart.chartConfiguration.chartConfig;
                    var headers = {};
                    _.forEach($scope.dataConfig, function (dataConfigObj) {
                        headers[dataConfigObj.value] = dataConfigObj.value
                    });
                    var items = [];
                    if ($scope.querySearchData && $scope.querySearchData.data && $scope.querySearchData.data.length) {
                        _.forEach($scope.querySearchData.data, function (obj) {
                            var tempObj = {};
                            _.forEach($scope.dataConfig, function (dataConfigObj) {
                                tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                            });
                            items.push(tempObj);
                        });
                    }
                    items.unshift(headers);
                    var jsonObject = angular.toJson(items);
                    if (Object.keys(jsonObject).length) {
                        testingJSON.data = {
                            "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                            "googleSpreadsheetKey": false,
                            "googleSpreadsheetWorksheet": false,
                            "decimalPoint": ","
                        };
                    }
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/chartEditor/chartEditorModal.html',
                        size: 'lg',
                        controller: 'chartEditorModalCtrl as chartEditor',
                        windowClass: 'modal-height100',
                        resolve: {
                            chartObj: function () {
                                return testingJSON;
                            },
                            csvData: function () {
                                return jsonToCsvConvertService.convertToCSV(jsonObject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) { //response
                        $scope.selectedChart.chartConfiguration.chartConfig = res;
                        $scope.fnUpdateTabData();
                        $("#previewChart").empty(); //eslint-disable-line
                        $timeout(function () {
                            if (angular.isDefined(angular.element("#previewChart")[0])) {
                                Highcharts.chart('previewChart', res);
                            }
                        })
                    }, function () {
                    });
                };

                $scope.fnRefreshChart = function () {
                    var testingJSON = $scope.selectedChart.chartConfiguration.chartConfig;
                    var headers = {};
                    _.forEach($scope.dataConfig, function (dataConfigObj) {
                        headers[dataConfigObj.value] = dataConfigObj.value
                    });
                    var items = [];
                    if ($scope.querySearchData && $scope.querySearchData.data && $scope.querySearchData.data.length) {
                        if ($scope.selectedChart.chartConfiguration.isSupportStringValue) {
                            testingJSON.yAxis.categories = [];
                        }
                        _.forEach($scope.querySearchData.data, function (obj) {
                            var tempObj = {};
                            _.forEach($scope.dataConfig, function (dataConfigObj) {
                                if ($scope.selectedChart.chartConfiguration.isSupportStringValue && dataConfigObj.key !== 'name') {
                                    if (obj[dataConfigObj.value] && obj[dataConfigObj.value] !== '' && testingJSON.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1) {
                                        testingJSON.yAxis.categories.push(obj[dataConfigObj.value]);
                                    }
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? testingJSON.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1 ? null : testingJSON.yAxis.categories.indexOf(obj[dataConfigObj.value]) : null;
                                } else {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                }
                            });
                            items.push(tempObj);
                        });
                    }
                    items.unshift(headers);
                    var jsonObject = angular.toJson(items);
                    if (Object.keys(jsonObject).length) {
                        testingJSON.data = {
                            "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                            "googleSpreadsheetKey": false,
                            "googleSpreadsheetWorksheet": false,
                            "decimalPoint": ","
                        };
                        testingJSON.series = [];
                    }
                    if (angular.isDefined($scope.selectedChart.chartConfiguration.chartFor)) {
                        testingJSON.data = [];
                        var chartData = [];
                        _.forEach(items, function (obj) {
                            if (obj.ts !== 'ts') {
                                var tempObj = Object.values(obj);
                                var tempA = tempObj[0].replace('T', ' ').split('.')[0];
                                var timestamp = moment(tempA).format('x');
                                tempObj[0] = parseInt(timestamp);
                                chartData.push(tempObj);
                            }
                        })
                        testingJSON.series = [];
                        testingJSON.series.push({
                            data: chartData,
                            name: 'charts'
                        });
                        var tempValueAnomalyArr = {
                            name: 'arearange',
                            data: $scope.fnGenerateChartForecastAndAnomalyData($scope.querySearchData.data, $scope.selectedChart.chartConfiguration.chartFor, testingJSON),
                            type: 'arearange',
                            lineWidth: 0,
                            linkedTo: ':previous',
                            fillOpacity: 0.3,
                            zIndex: 0,
                            marker: {
                                enabled: false
                            }
                        };
                        testingJSON.series.push(tempValueAnomalyArr);
                    }
                    $scope.selectedChart.chartConfiguration.dataMapping = {};
                    _.forEach($scope.dataConfig, function (dataConfigObj) {
                        $scope.selectedChart.chartConfiguration.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                    });
                    $timeout(function () {
                        $("#previewChart").empty(); //eslint-disable-line
                        if (angular.isDefined(angular.element("#previewChart")[0])) {
                            Highcharts.chart('previewChart', testingJSON);
                        }
                    })
                };

                $scope.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor, testingJSON) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = testingJSON.yAxis.categories.indexOf(tempDataObj.value) === -1 ? 0 : testingJSON.yAxis.categories.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                $scope.fnIsValidWidget = function () {
                    if ($scope.selectedChartType !== 'RAWDATA') {
                        return !Object.keys($scope.selectedChart.chartConfiguration).length;
                    }
                }

                $scope.fnDataConfigSelected = function (refresh) {
                    _.forEach($scope.querySearchDataHeader, function (headerObj) {
                        var isFind = _.find($scope.dataConfig, {value: headerObj.name});
                        headerObj.isPlotted = !!isFind;
                    })
                    if (!refresh) {
                        $scope.fnRefreshChart();
                    }
                    $scope.fnUpdateTabData();
                }

                $scope.fnAddNewMapping = function () {
                    var tempKey = "mapping_";
                    var keyNumber = 0;
                    _.forEach($scope.dataConfig, function (value) {
                        if (value.key.startsWith('mapping_')) {
                            var number = parseInt(value.key.toString().split('_')[1]);
                            if (number > keyNumber) {
                                keyNumber = number;
                            }
                        }
                    });
                    tempKey = tempKey + (keyNumber + 1);
                    $scope.dataConfig.push({
                        key: tempKey,
                        value: ''
                    });
                    $scope.fnUpdateTabData();
                };

                $scope.fnRemoveMapping = function (index) {
                    $scope.dataConfig.splice(index, 1);
                    $scope.selectedChart.chartConfiguration.dataMapping = {};
                    _.forEach($scope.dataConfig, function (dataConfigObj) {
                        $scope.selectedChart.chartConfiguration.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                    });
                    $scope.fnDataConfigSelected();
                    $scope.fnUpdateTabData();
                    $timeout(function () {
                        $scope.fnRefreshChart();
                    }, 1000)
                };

                $scope.fnOpenCreateWidgetModal = function () {
                    if ($scope.queryConfig.value.getData().length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/insight/insight_query_editor/modals/createWidgetModal/createWidgetModal.html',
                            size: 'lg',
                            controller: 'createWidgetModalCtrl as createWidgetModal',
                            windowClass: 'modal-height100',
                            resolve: {
                                chartObj: function () {
                                    return {
                                        syntax: $scope.selectedChartType,
                                        definition: $scope.selectedChartType !== 'RAWDATA' ? $scope.selectedChart.chartConfiguration : {}
                                    };
                                },
                                queryObj: function () {
                                    return {
                                        sql: $scope.queryConfig.value.getData()
                                    };
                                },
                                rawData: function () {
                                    return {
                                        headerData: $scope.querySearchDataHeader,
                                        bodyData: $scope.querySearchData.data
                                    }
                                },
                                predefinedQuery: function () {
                                    return $scope.selectedPredefinedQuery;
                                }
                            }
                        });
                        modalInstance.result.then(function () { //response
                            $scope.selectedChartType = "RAWDATA";
                            $scope.selectedChart = {
                                chartConfiguration: {
                                    chartType: 'pie',
                                    dataMapping: {},
                                    chartConfig: {
                                        chart: {
                                            type: 'pie'
                                        },
                                        title: {
                                            text: " "
                                        },
                                        subtitle: {
                                            text: " "
                                        },
                                        xAxis: {
                                            type: "category"
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        plotOptions: {
                                            series: {
                                                dataLabels: {
                                                    enabled: true
                                                }
                                            }
                                        },
                                        series: [
                                            {
                                                animationLimit: -1
                                            }
                                        ],
                                        legend: {
                                            enabled: false
                                        }
                                    }
                                }
                            };
                            $scope.dataConfig = _.cloneDeepWith([
                                {
                                    "key": "name",
                                    "value": "",
                                    "isRequired": true
                                },
                                {
                                    "key": "y",
                                    "value": "",
                                    "isRequired": true
                                }
                            ]);
                            $scope.isAllowMultiField = false;
                            $scope.csvHeaderArr = [];
                            $scope.querySearchData = [];
                            $scope.querySearchDataHeader = [];
                            $scope.apiDataHeader = [];
                            //$scope.queryConfig.editorValue = sqlFormatter.format("").toString();
                            $scope.fnUpdateTabData();
                        }, function () {
                        });
                    } else {
                        amaran.error("The 'sql' is a required parameter and cannot be null.");
                    }
                }

                $scope.fnOpenCreateChartModal = function () {
                    if ($scope.queryConfig.value.getData().length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/insight/insight_query_editor/modals/createChartModal/createChartModal.html',
                            size: 'lg',
                            controller: 'createChartModalCtrl as createChartModal',
                            windowClass: 'modal-height100',
                            resolve: {
                                chartObj: function () {
                                    return {
                                        syntax: $scope.selectedChartType,
                                        definition: $scope.selectedChartType !== 'RAWDATA' ? $scope.selectedChart.chartConfiguration : {}
                                    };
                                },
                                queryObj: function () {
                                    return {
                                        sql: $scope.queryConfig.value.getData()
                                    };
                                },
                                rawData: function () {
                                    return {
                                        headerData: $scope.querySearchDataHeader,
                                        bodyData: $scope.querySearchData.data
                                    }
                                },
                                predefinedQuery: function () {
                                    return $scope.selectedPredefinedQuery;
                                }
                            }
                        });
                        modalInstance.result.then(function () { //response
                            $scope.selectedChartType = "RAWDATA";
                            $scope.selectedChart = {
                                chartConfiguration: {
                                    chartType: 'pie',
                                    dataMapping: {},
                                    chartConfig: {
                                        chart: {
                                            type: 'pie'
                                        },
                                        title: {
                                            text: " "
                                        },
                                        subtitle: {
                                            text: " "
                                        },
                                        xAxis: {
                                            type: "category"
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        plotOptions: {
                                            series: {
                                                dataLabels: {
                                                    enabled: true
                                                }
                                            }
                                        },
                                        series: [
                                            {
                                                animationLimit: -1
                                            }
                                        ],
                                        legend: {
                                            enabled: false
                                        }
                                    }
                                }
                            };
                            $scope.dataConfig = _.cloneDeepWith([
                                {
                                    "key": "name",
                                    "value": "",
                                    "isRequired": true
                                },
                                {
                                    "key": "y",
                                    "value": "",
                                    "isRequired": true
                                }
                            ]);
                            $scope.isAllowMultiField = false;
                            $scope.csvHeaderArr = [];
                            $scope.querySearchData = [];
                            $scope.querySearchDataHeader = [];
                            $scope.apiDataHeader = [];
                            //$scope.queryConfig.editorValue = sqlFormatter.format("").toString();
                            $scope.fnUpdateTabData();
                        }, function () {
                        });
                    } else {
                        amaran.error("The 'sql' is a required parameter and cannot be null.");
                    }
                }

                $scope.fnChangeChartType = function (type) {
                    $scope.selectedChartType = type;
                    if (type === 'HIGHCHARTS') {
                        $scope.fnRefreshChart();
                    }
                    $scope.fnUpdateTabData();
                }

                $scope.fnUpdateTabData = function () {
                    $scope.tabObj.chartType = _.cloneDeepWith($scope.selectedChartType);
                    $scope.tabObj.chart = _.cloneDeepWith($scope.selectedChart);
                    $scope.tabObj.query = $scope.queryConfig.value.getData().length ? _.cloneDeepWith($scope.queryConfig.value.getData()) : "";
                    $scope.$emit('tabDetailsChanged');
                }

                $scope.fnSetTabData = function () {
                    if ($scope.tabObj && $scope.tabObj.tabIndex === 1 && DB.fnGet('insightQueryFromTable')) {
                        var sqlQuery = DB.fnGet('insightQueryFromTable');
                        DB.fnRemove('insightQueryFromTable');
                        $scope.selectedPredefinedQuery = {};
                        $scope.queryConfig.editorValue = _.cloneDeepWith(sqlQuery);
                        $timeout(function () {
                            $scope.fnFormatSQL();
                            $scope.fnRunQuery();
                        }, 1500)
                    } else {
                        $scope.selectedPredefinedQuery = $scope.tabObj.predefinedQuery && Object.keys($scope.tabObj.predefinedQuery).length ? _.cloneDeepWith($scope.tabObj.predefinedQuery) : {};
                        $scope.queryConfig.editorValue = $scope.tabObj.query && Object.keys($scope.tabObj.query).length ? _.cloneDeepWith($scope.tabObj.query) : '';
                        $scope.selectedChart = $scope.tabObj.chart && Object.keys($scope.tabObj.chart).length ? _.cloneDeepWith($scope.tabObj.chart) : $scope.selectedChart;
                        var chartMappingData = _.find(chartMapping, {chartType: $scope.selectedChart.chartConfiguration.chartType});
                        $scope.isAllowMultiField = chartMappingData.isAllowMultiField;
                        $scope.dataConfig = [];
                        if ($scope.selectedChart && $scope.selectedChart.chartConfiguration && $scope.selectedChart.chartConfiguration.dataMapping && !_.isEmpty($scope.selectedChart.chartConfiguration.dataMapping)) {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                if ($scope.selectedChart.chartConfiguration.dataMapping[requiredDataObj.key]) {
                                    $scope.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: $scope.selectedChart.chartConfiguration.dataMapping[requiredDataObj.key],
                                        isRequired: true
                                    });
                                }
                            });
                            if ($scope.dataConfig.length !== Object.keys($scope.selectedChart.chartConfiguration.dataMapping).length) {
                                var arr = Object.keys($scope.selectedChart.chartConfiguration.dataMapping);
                                _.forEach(arr, function (arrKey) {
                                    var isFind = _.find($scope.dataConfig, {key: arrKey});
                                    if (!isFind) {
                                        $scope.dataConfig.push(
                                            {
                                                key: arrKey,
                                                value: $scope.selectedChart.chartConfiguration.dataMapping[arrKey]
                                            }
                                        )
                                    }
                                });
                            }
                        } else {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                $scope.dataConfig.push({
                                    key: requiredDataObj.key,
                                    value: '',
                                    isRequired: true
                                });
                            });
                        }
                        if ($scope.dataConfig.length) {
                            $scope.isLoadDataFromTab = true;
                        }
                        if ($scope.tabObj.query && Object.keys($scope.tabObj.query).length) {
                            $timeout(function () {
                                $scope.fnFormatSQL();
                                $scope.fnRunQuery();
                            }, 1500)
                        }
                    }
                }

                $scope.fnOpenQueryModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/insight/insight_query_editor/modals/queryListModal/queryListModal.html',
                        size: 'lg',
                        controller: 'queryListModalCtrl as queryListModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        $scope.selectedPredefinedQuery = _.cloneDeepWith(res);
                        $scope.tabObj.query = _.cloneDeepWith(res.sql);
                        $scope.tabObj.predefinedQuery = _.cloneDeepWith(res);
                        $scope.queryConfig.editorValue = _.cloneDeepWith(res.sql);
                    }, function () {

                    });
                }

                $scope.fnOpenCreateIssueTab = function () {
                    var tempIssueData = {
                        result: {
                            data: $scope.querySearchData.data,
                            header: $scope.querySearchDataHeader
                        },
                        chart: $scope.selectedChart.chartConfiguration.chartConfig
                    };
                    $scope.$emit('openCreateIssueTab', tempIssueData);
                }

                $scope.fnInitQueryEditor = function () {
                    var timezone = moment().zone();
                    Highcharts.setOptions({
                        global: {
                            timezoneOffset: timezone
                        }
                    });
                    $scope.isEditorDataLoading = true;
                    $timeout(function () {
                        $scope.isEditorDataLoading = false;
                        $scope.fnSetTabData();
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                            $timeout(function () {
                                document.getElementsByClassName('CodeMirror-vscrollbar')[0].scrollTop += 5;
                                $timeout(function () {
                                    document.getElementsByClassName('CodeMirror-vscrollbar')[0].scrollTop -= 5;
                                }, 1000);
                            }, 1000);
                        }, 1000)
                    }, 1000)
                };

                $scope.fnInitQueryEditor();
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('vaultsModalCtrl',
            function ($uibModalInstance, $timeout, vaultsArr, $window) {
                var vm = this;
                vm.vaultsArr = vaultsArr;
                vm.resetVaultsArr = angular.copy(vaultsArr);
                vm.isComponentUpdating = false;
                vm.isVaultsFilter = false;
                vm.search = '';

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".modal-content")[0]) {
                        var total = angular.element(".modal-content")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        var searchDiv = 0;
                        if(angular.element(".vaultSearchDiv")[0]){
                            searchDiv = angular.element(".vaultSearchDiv")[0].offsetHeight;
                        }
                        if(angular.element("#vaultFooter")[0]){
                            footer = angular.element("#vaultFooter")[0].offsetHeight;
                        }
                        if(angular.element("#vaultHeader")[0]){
                            header = angular.element("#vaultHeader")[0].offsetHeight;
                        }
                        var finalHeight = total - (searchDiv + header + footer);
                        angular.element(".vaultModelDiv").css('height', (finalHeight-25) + 'px');
                    }
                };




                vm.fnVaultsFilter = function () {
                    vm.isVaultsFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.resetVaultsArr, function (typeObj) {
                            if (typeObj.name.toLowerCase().includes(vm.search.toLowerCase()) || typeObj.id.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetVaultsArr);
                    }
                    vm.vaultsArr = searchArr;
                    $timeout(function () {
                        vm.isVaultsFilter = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, 1000)
                };

                vm.fnSelectVault = function (vaultObj) {
                    $uibModalInstance.close(vaultObj);
                };

                vm.fnCancel = function() {
                    $uibModalInstance.dismiss('cancel');
                }
                vm.fnInitModel = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });

                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('queryBuilderModalCtrl',
            function ($timeout, $window, $uibModalInstance, $uibModal, GatewayFactory, DeviceFactory, ComponentFactory, TimezoneOptionArrService, resetFilterArr, filtersArr, isCallFromNode, operators, conditionIndex, condition) {
                var vm = this;

                /*filters: START*/
                //vm.functionsArr = ["ghost()", "ghost(...)"];
                vm.categoryArr = ["GATEWAY", "DEVICE", "COMPONENT"];
                vm.optionsArr = [];
                vm.devicesArr = [];
                vm.isFunctionSelected = false;
                vm.isSearchActivated = false;
                vm.isOptionsLoaded = false;
                vm.isComponentsLoaded = false;
                vm.isDeviceSelected = false;
                vm.selectedCategory = "";
                vm.selectedFunction = "";
                vm.selectedOption = "";
                vm.selectedDevice = "";
                vm.isFunctionSelected = false;
                vm.selectedTimeZone = 'UTC';
                vm.filtersArr = filtersArr ? filtersArr : [];
                vm.resetFilterArr = resetFilterArr;
                vm.timeZoneArr = TimezoneOptionArrService.getTimezoneOptionArr();
                vm.regularExpression = '';
                vm.regularExpressionTestArr = [{
                    inputValue: '',
                    isValid: false
                }];

                //$timeout(function(){ angular.element($window).triggerHandler('resize') });

                if (isCallFromNode === true) {
                    vm.functionsArr = [
                        {
                            "name": "ghost()",
                            "description": "Retrieve the ghost image for the Gateway. Device or Component that the event originated from. This allows cross attribute referencing within a node. If your observer does not reference a specific ID this function can be accessed by prefixing any attribute name with 'ghost().<attribute>'. e.g. 'ghost().temp' would fetch the 'temp' attribute from the nodes ghost image.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        /*{
                            "name": "ghost(...)",
                            "description": "Retrieves the ghost image for a specific pre-defined Gateway. Device or Component. This allows cross node attribute referencing. This function can natively be accessed in the same way as the 'ghost()' function but adding the target ghost ID between the brackets. e.g. 'ghost(12345678).temp' would fetch the 'temp' attribute from the node with ID '12345678'. ",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },*/
                        {
                            "name": "TimeOfDay()",
                            "description": "A function for comparative time based evaluations. An optional timezone can be set and the function will return the current time of day using standard single integer 24 hour format. e.g. 4:20am would be returned as 420, 5:16pm would be returned as 1716.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        {
                            "name": "DayOfWeek()",
                            "description": "A function for comparative weekly based evaluations. An optional timezone can be set and the function will return the current day of the week as a number from 1 to 7. e.g. Monday will return 1 and Sunday will return 7.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        {
                            "name": "DayOfMonth()",
                            "description": "A function for comparative monthly based evaluations. An optional timezone can be set and the function will return the current day of the month as a number between 1 and 31 inclusive.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        {
                            "name": "DayOfYear()",
                            "description": "A function for comparative yearly based evaluations. An optional timezone can be set and the function will return the current day of the year as a number between 1 and 365 inclusive.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        {
                            "name": "Matches()",
                            "description": "A function to matches multiple values. This takes a regular expression inside the brackets to match multiple field names.",
                            "isDisable": conditionIndex === 0 && condition === 'AND'
                        },
                        {
                            "name": "Import attributes from Node",
                            "description": "Retrieve the ghost image from the Node.",
                            "isDisable": conditionIndex === 1 && condition === 'AND'
                        }
                    ];
                } else {
                    vm.functionsArr = [
                        {
                            "name": "TimeOfDay()",
                            "description": "A function for comparative time based evaluations. An optional timezone can be set and the function will return the current time of day using standard single integer 24 hour format. e.g. 4:20am would be returned as 420, 5:16pm would be returned as 1716."
                        },
                        {
                            "name": "DayOfWeek()",
                            "description": "A function for comparative weekly based evaluations. An optional timezone can be set and the function will return the current day of the week as a number from 1 to 7. e.g. Monday will return 1 and Sunday will return 7."
                        },
                        {
                            "name": "DayOfMonth()",
                            "description": "A function for comparative monthly based evaluations. An optional timezone can be set and the function will return the current day of the month as a number between 1 and 31 inclusive."
                        },
                        {
                            "name": "DayOfYear()",
                            "description": "A function for comparative yearly based evaluations. An optional timezone can be set and the function will return the current day of the year as a number between 1 and 365 inclusive."
                        }];
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClose = function () {
                    if (isCallFromNode === true) {
                        if (vm.functionType === "TimeOfDay()") {
                            if (!vm.filtersArr.includes('TimeOfDay(' + vm.selectedTimeZone + ')')) {
                                vm.filtersArr.push('TimeOfDay(' + vm.selectedTimeZone + ')');
                            }
                        }
                        if (vm.functionType === "DayOfWeek()") {
                            if (!vm.filtersArr.includes('DayOfWeek(' + vm.selectedTimeZone + ')')) {
                                vm.filtersArr.push('DayOfWeek(' + vm.selectedTimeZone + ')');
                            }
                        }
                        if (vm.functionType === "DayOfMonth()") {
                            if (!vm.filtersArr.includes('DayOfMonth(' + vm.selectedTimeZone + ')')) {
                                vm.filtersArr.push('DayOfMonth(' + vm.selectedTimeZone + ')');
                            }
                        }
                        if (vm.functionType === "DayOfYear()") {
                            if (!vm.filtersArr.includes('DayOfYear(' + vm.selectedTimeZone + ')')) {
                                vm.filtersArr.push('DayOfYear(' + vm.selectedTimeZone + ')');
                            }
                        }
                        if (vm.functionType === "Matches()") {
                            if (!vm.filtersArr.includes('Matches(' + vm.regularExpression + ')')) {
                                vm.filtersArr.push('Matches(' + vm.regularExpression + ')');
                            }
                        }
                    } else {
                        var tempObj = {
                            id: '',
                            type: "string",
                            operators: operators ? operators : ''
                        };
                        if (vm.functionType === "TimeOfDay()") {
                            if (!_.find(vm.filtersArr, {'id': 'TimeOfDay(' + vm.selectedTimeZone + ')'})) {
                                tempObj.id = 'TimeOfDay(' + vm.selectedTimeZone + ')';
                                vm.filtersArr.push(tempObj);
                            }
                        }
                        if (vm.functionType === "DayOfWeek()") {
                            if (!_.find(vm.filtersArr, {'id': 'DayOfWeek(' + vm.selectedTimeZone + ')'})) {
                                tempObj.id = 'DayOfWeek(' + vm.selectedTimeZone + ')';
                                vm.filtersArr.push(tempObj);
                            }
                        }
                        if (vm.functionType === "DayOfMonth()") {
                            if (!_.find(vm.filtersArr, {'id': 'DayOfMonth(' + vm.selectedTimeZone + ')'})) {
                                tempObj.id = 'DayOfMonth(' + vm.selectedTimeZone + ')';
                                vm.filtersArr.push(tempObj);
                            }
                        }
                        if (vm.functionType === "DayOfYear()") {
                            if (!_.find(vm.filtersArr, {'id': 'DayOfYear(' + vm.selectedTimeZone + ')'})) {
                                tempObj.id = 'DayOfYear(' + vm.selectedTimeZone + ')';
                                vm.filtersArr.push(tempObj);
                            }
                        }
                    }
                    $uibModalInstance.close(vm.filtersArr);
                };

                vm.fnAddNewAttributes = function (visualizerType) {
                    var modalInstance;
                    if (visualizerType === 'Gateway') {
                        modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/visualization/createVisualization/modal/addAttributes/addAttributes.html',
                            size: 'lg',
                            controller: 'addAttributesCtrl as addAttributes',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (array) {
                            if (array !== 'cancel') {
                                vm.attributesArr = array;
                                _.forEach(vm.attributesArr, function (value) {
                                    if (!vm.filtersArr.includes(value.name)) {
                                        vm.filtersArr.push(value.name);
                                    }
                                });
                            }
                        }, function () {
                        });
                    } else if (visualizerType === 'Device' || visualizerType === 'Component') {
                        modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/visualization/createVisualization/modal/addAttributesFromDevice/addAttributesFromDevice.html',
                            size: 'lg',
                            controller: 'addAttributesFromDeviceCtrl as addAttributesFromDevice',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (array) {
                            if (array !== 'cancel') {
                                vm.attributesArr = array;
                                _.forEach(vm.attributesArr, function (value) {
                                    if (!vm.filtersArr.includes(value.name)) {
                                        vm.filtersArr.push(value.name);
                                    }
                                });
                            }
                        }, function () {
                        });
                    }
                };

                vm.fnFunctionSelected = function (selectedFunction) {
                    vm.selectedCategory = "";
                    vm.selectedOption = "";
                    vm.selectedDevice = "";
                    switch (selectedFunction) {
                        case "ghost()":
                            vm.isGettingGhostValues = true;
                            vm.isSearchActivated = false;
                            vm.filtersArr = angular.copy(vm.resetFilterArr);
                            vm.filtersArr.map(function (filterName) {
                                if (vm.filtersArr.indexOf("ghost()." + filterName) === -1) {
                                    vm.filtersArr.push("ghost()." + filterName);
                                }
                            });
                            vm.isGettingGhostValues = false;
                            break;
                        case "ghost(...)":
                            vm.filtersArr = angular.copy(vm.resetFilterArr);
                            vm.isSearchActivated = true;
                            break;
                        case "no function":
                            vm.isSearchActivated = false;
                            vm.filtersArr = angular.copy(vm.resetFilterArr);
                            break;
                    }
                };

                vm.fnCategorySelected = function (selectedCategory) {
                    vm.isDeviceSelected = false;
                    vm.isOptionsLoaded = false;
                    vm.selectedOption = "";
                    vm.selectedDevice = "";
                    vm.optionsArr = [];
                    switch (selectedCategory) {
                        case "GATEWAY":
                            GatewayFactory.getGateways()
                                .then(function (response) {
                                    response.map(function (resObj) {
                                        vm.optionsArr.push({name: resObj.name, id: resObj.id});
                                    });
                                    vm.isOptionsLoaded = true;
                                });
                            break;
                        case "DEVICE":
                            DeviceFactory.getDevices()
                                .then(function (response) {
                                    response.map(function (resObj) {
                                        vm.optionsArr.push({name: resObj.name, id: resObj.id});
                                    });
                                    vm.isOptionsLoaded = true;
                                });
                            break;
                        case "COMPONENT":
                            vm.devicesArr = [];
                            DeviceFactory.getDevices()
                                .then(function (response) {
                                    response.map(function (resObj) {
                                        vm.devicesArr.push({name: resObj.name, id: resObj.id});
                                    });
                                    vm.isOptionsLoaded = true;
                                });
                            break;
                    }
                };

                vm.fnDeviceSelected = function (selectedDevice) {
                    vm.isDeviceSelected = true;
                    vm.isComponentsLoaded = false;
                    vm.selectedOption = "";
                    var inputObj = {
                        deviceId: selectedDevice,
                        perPage: 0
                    };
                    ComponentFactory.getComponents(inputObj)
                        .then(function (response) {
                            if (response.length) {
                                response.map(function (resObj) {
                                    vm.optionsArr.push({name: resObj.name, id: resObj.id});
                                });
                            } else {
                                vm.optionsArr = [];
                            }
                            vm.isComponentsLoaded = true;
                        })
                };

                vm.fnOptionSelected = function (selectedCategory, selectedOption) {
                    vm.isGettingGhostValues = true;
                    switch (selectedCategory) {
                        case 'GATEWAY':
                            GatewayFactory.getGatewayGhost({gatewayId: selectedOption})
                                .then(function (response) {
                                    Object.keys(response).forEach(function (key) {
                                        if (vm.filtersArr.indexOf("ghost(" + selectedOption + ")." + response[key].name) === -1) {
                                            vm.filtersArr.push("ghost(" + selectedOption + ")." + response[key].name);
                                        }
                                    });
                                    vm.isGettingGhostValues = false;
                                });
                            break;
                        case 'DEVICE':
                            DeviceFactory.getDeviceGhost({deviceId: selectedOption})
                                .then(function (response) {
                                    Object.keys(response).forEach(function (key) {
                                        if (vm.filtersArr.indexOf("ghost(" + selectedOption + ")." + response[key].name) === -1) {
                                            vm.filtersArr.push("ghost(" + selectedOption + ")." + response[key].name);
                                        }
                                    });
                                    vm.isGettingGhostValues = false;
                                });
                            break;
                        case 'COMPONENT':
                            var tempArr = selectedOption.split("-");
                            ComponentFactory.getComponentGhost({
                                deviceId: tempArr[0] + "-" + tempArr[1] + "-" + tempArr[2],
                                componentId: selectedOption
                            })
                                .then(function (response) {
                                    Object.keys(response).forEach(function (key) {
                                        if (vm.filtersArr.indexOf("ghost(" + selectedOption + ")." + response[key].name) === -1) {
                                            vm.filtersArr.push("ghost(" + selectedOption + ")." + response[key].name);
                                        }
                                    });
                                    vm.isGettingGhostValues = false;
                                });
                            break;
                    }
                };

                vm.fnTimeZoneSelected = function (selectedTimeZone) {
                    vm.selectedTimeZone = selectedTimeZone;
                };

                vm.fnInject = function (obj) {
                    vm.functionType = obj.name;
                    if (vm.functionType === 'ghost()') {
                        vm.filtersArr = angular.copy(vm.resetFilterArr);
                        vm.filtersArr.map(function (filterName) {
                            if (vm.filtersArr.indexOf("ghost()." + filterName) === -1) {
                                vm.filtersArr.push("ghost()." + filterName);
                            }
                        });
                        $uibModalInstance.close(vm.filtersArr);
                    }
                    if (vm.functionType === 'Import attributes from Node') {
                        $uibModalInstance.dismiss('cancel');
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/observer/nodeAttributesModal/nodeAttribute.html',
                            size: 'lg',
                            controller: 'nodeAttributeCtrl as nodeAttribute',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (type) {
                            if (type !== 'cancel') {
                                vm.nodeType = type;
                                vm.fnAddNewAttributes(vm.nodeType);
                            }
                        }, function () {
                        });
                    }
                    vm.isFunctionSelected = true;
                };

                vm.fnBackToFunctions = function () {
                    vm.functionType = '';
                    vm.isFunctionSelected = false;
                };

                vm.fnTestRegularExpression = function (data) {
                    if (angular.isDefined(data.inputValue)) {
                        data.isValid = vm.regularExpression === '' ? false : RegExp(vm.regularExpression).test(data.inputValue);
                    } else {
                        data.isValid = false;
                    }
                };

                vm.fnAddRegularExpressionInput = function () {
                    vm.regularExpressionTestArr.push({
                        inputValue: '',
                        isValid: false
                    });
                };

                vm.fnRemoveRegularExpressionInput = function (index) {
                    vm.regularExpressionTestArr.splice(index, 1);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('paymentMethodCtrl',
            function ($uibModalInstance, $state, amaran, PaymentMethodsFactory, InvoiceFactory, invoiceId) {
                var vm = this;
                vm.token = '';

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnPayInvoice = function () {
                    vm.isCartUpdating = true;
                    var input = {
                        invoiceId: invoiceId
                    };
                    if (vm.selectedPaymentMethod.defaultPaymentMethod !== true) {
                        input.paymentMethodId = vm.selectedPaymentMethod.id
                    }
                    InvoiceFactory.payInvoice(input)
                        .then(function () {
                            vm.isCartUpdating = false;
                            amaran.success("Payment Successfully");
                            $uibModalInstance.close();
                        }, function () {
                            vm.isCartUpdating = false;
                            $uibModalInstance.close();
                        })
                };

                vm.fnGetPaymentMethod = function () {
                    vm.isPaymentMethodLoading = true;
                    vm.selectedPaymentMethod = {};
                    PaymentMethodsFactory.listPaymentMethods()
                        .then(function (res) {
                            vm.paymentMethodArr = _.filter(res, function (paymentMethodObj) {
                                if (paymentMethodObj.defaultPaymentMethod === true) {
                                    vm.selectedPaymentMethod = _.cloneDeepWith(paymentMethodObj);
                                }
                                return paymentMethodObj.active === true;
                            });
                            if (!Object.keys(vm.selectedPaymentMethod).length) {
                                vm.selectedPaymentMethod = vm.paymentMethodArr.length ? vm.paymentMethodArr[0] : {};
                            }
                            vm.isPaymentMethodLoading = false;
                        }, function () {
                            vm.isPaymentMethodLoading = false;
                        })
                };

                vm.fnGetCreditCardClass = function (cardType) {
                    if (cardType === 'discover') {
                        return 'fa-cc-discover';
                    } else if (cardType === 'jcb') {
                        return 'fa-cc-jcb';
                    } else if (cardType === 'americanexpress') {
                        return 'fa-cc-amex';
                    } else if (cardType === 'dinersclub') {
                        return 'fa-cc-diners-club';
                    } else if (cardType === 'visa') {
                        return 'fa-cc-visa';
                    } else if (cardType === 'mastercard') {
                        return 'fa-cc-mastercard';
                    } else {
                        return 'fa-credit-card';
                    }
                };

                vm.fnManagePaymentMethod = function () {
                    $uibModalInstance.dismiss('cancel');
                    $state.go('main.payment_method');
                };

                vm.fnCheckPaymentMethod = function () {
                    return Object.keys(vm.selectedPaymentMethod).length === 0;
                };

                vm.fnInit = function () {
                    vm.fnGetPaymentMethod();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('claimCreditCtrl',
            function ($uibModalInstance, CreditTokenFactory, amaran, token) {
                var vm = this;
                vm.token = token;
                vm.isCreditToken = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isCreditToken = true;
                    var input = {
                        tokenId: vm.token
                    };
                    CreditTokenFactory.claimUnclaimedCreditToken(input)
                        .then(function () {
                            amaran.success("Credit Token Claim Successfully");
                            $uibModalInstance.dismiss('cancel');
                            vm.isCreditToken = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $uibModalInstance.dismiss('cancel');
                            vm.isCreditToken = false;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('sendCreditTokenCtrl',
            function ($uibModalInstance, CreditTokenFactory, QueryFactory, amaran, creditTokenId, $log) {
                var vm = this;
                vm.isCreditTokenSending = false;
                vm.userId = "";
                vm.isUserListLoading = true;
                vm.isFormValid = false;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields needed for the typeahead
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.firstName = parsedData.firstName || parsedItem.first_name || '';
                                parsedItem.lastName = parsedData.lastName || parsedItem.last_name || '';

                                // Merge remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing user data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isCreditTokenSending = true;
                    var input = {
                        tokenId: creditTokenId,
                        userId: vm.userId
                    };
                    CreditTokenFactory.sendUnclaimedCreditTokenToUser(input)
                        .then(function () {
                            vm.isCreditTokenSending = false;
                            amaran.success("Credit Token Sent successfully");
                            $uibModalInstance.dismiss('cancel');
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isCreditTokenSending = false;
                            $uibModalInstance.dismiss('cancel');
                        });
                };

                vm.fnGetUsers = function (inputObj, preDefinedUsers, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var users = isCalledForViz ? preDefinedUsers : [];

                            // Parse the PostgreSQL response
                            var parsedData = parsePostgresData(res.data);

                            _.forEach(parsedData, function (accountObj) {
                                users.push(accountObj);
                            });

                            if ((parsedData && parsedData.length && parsedData.length > 0) &&
                                (users[0] && users[0].totalItems > users.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetUsers({sql: sqlString}, users, true);
                            } else {
                                vm.usersArr = users;
                                vm.isUserListLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUserListLoading = false;
                        });
                };

                vm.fnCheckValidation = function (valid) {
                    vm.isFormValid = valid;
                };

                vm.fnInitSendCreditTokens = function () {
                    vm.isUserListLoading = true;
                    var sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetUsers({sql: sqlString}, [], false);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('BusinessDetailsCtrl',
            function ($scope, $window, $timeout, amaran, PermissionsService, BusinessDetailFactory) {
                var vm = this;

                vm.isEditable = false;
                vm.isBusinessDetailLoading = true;
                vm.isBusinessDetailLoading = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var header = angular.element(".dashboard-header")[0] ? angular.element(".dashboard-header")[0].offsetHeight : 0; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer + header);
                        angular.element(".businessDetails").css('height', finalHeight + 'px');
                    }
                };

                vm.fnChangeToEditable = function () {
                    vm.isEditable = true;
                };

                vm.fnCancelEditable = function () {
                    vm.isEditable = false;
                    vm.businessInfo = _.cloneDeepWith(vm.resetBusinessInfo);
                };

                vm.fnSaveBusinessDetail = function () {
                    vm.isBusinessDetailSaveChanges = true;
                    var input = {
                        body: {
                            "businessName": vm.businessInfo.businessName,
                            "businessAddress": {
                                "city": vm.businessInfo.businessAddress.city,
                                "country": vm.businessInfo.businessAddress.country,
                                "line1": vm.businessInfo.businessAddress.line1,
                                "line2": vm.businessInfo.businessAddress.line2,
                                "postalCode": vm.businessInfo.businessAddress.postalCode,
                                "state": vm.businessInfo.businessAddress.state
                            },
                            "businessEmail": vm.businessInfo.businessEmail,
                            "businessPhone": vm.businessInfo.businessPhone
                        }
                    };
                    BusinessDetailFactory.updateBusinessDetails(input).then(function (response) {
                        vm.isEditable = false;
                        vm.isBusinessDetailSaveChanges = false;
                        vm.businessInfo = _.cloneDeepWith(response);
                        vm.resetBusinessInfo = _.cloneDeepWith(vm.businessInfo);
                        amaran.success('Business Details Updated Successfully');
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    }, function () {
                        vm.isEditable = false;
                        vm.isBusinessDetailSaveChanges = false;
                        vm.businessInfo = _.cloneDeepWith(vm.resetBusinessInfo);
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    });
                };

                vm.fnInitBusinessDetail = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.isBusinessDetailLoading = true;
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                    BusinessDetailFactory.describeBusinessDetails().then(function (response) {
                        vm.businessInfo = _.cloneDeepWith(response);
                        vm.resetBusinessInfo = _.cloneDeepWith(response);
                        vm.isBusinessDetailLoading = false;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    }, function () {
                        vm.isBusinessDetailLoading = false;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    })
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createModelFromTrainerModalCtrl',
            function ($scope, $window, $uibModalInstance, amaran, PermissionsService, AlgorithmFactory, ModelFactory, trainerObj) {
                var vm = this;
                vm.title = "Create Model from Trainer";
                vm.newModelObj = {
                    name: '',
                    description: '',
                    algorithmId: '',
                    artifactPath: ''
                };
                var resetModelObj = angular.copy(vm.newModelObj);
                vm.isModelCreating = false;
                vm.isDetailsLoaded = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCreateNewModel = function (newModelObj) {
                    vm.isModelCreating = true;
                    var inputObj = {
                        body: newModelObj
                    };
                    ModelFactory.createModel(inputObj)
                        .then(function () {
                            vm.isModelCreating = false;
                            vm.newModelObj = angular.copy(resetModelObj);
                            $uibModalInstance.close();
                        }, function () {
                            vm.isModelCreating = false;
                            $uibModalInstance.dismiss('cancel');
                        })
                };

                vm.fnSelectTrainer = function (selectedTrainerObj) {
                    vm.newModelObj.algorithmId = selectedTrainerObj.algorithmId;
                    var url = HOST_URL.ai.split("https://")[1]; //eslint-disable-line
                    var stage;
                    if (url.startsWith('dev')) {
                        stage = 'dev';
                    } else {
                        stage = 'pro'
                    }
                    vm.newModelObj.artifactPath = selectedTrainerObj.outputPath + stage + "-" + selectedTrainerObj.id + "/output/model.tar.gz";
                };

                vm.fnInitCreateModelFromTrainer = function () {
                    vm.isDetailsLoaded = false;
                    var inputObj = {
                        algorithmId: trainerObj.algorithmId
                    };
                    AlgorithmFactory.getAlgorithm(inputObj)
                        .then(function (response) {
                            vm.algorithmObj = response;
                            vm.fnSelectTrainer(trainerObj);
                            vm.isDetailsLoaded = true;
                        }, function () {
                            vm.isDetailsLoaded = true;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('trainerParams', fnTrainerParams);

    /** @ngInject */
    function fnTrainerParams($http) {
        return {
            restrict: 'EA',
            scope: {
                fnCheckParameterValidation: '&',
                algorithmId: "=",
                clonedParametersObj: "="
            },
            templateUrl: "app/ai/trainer/directives/trainerParams/trainerParams.html",
            link: function ($scope) {
                $scope.paramOptionsObj = {};
                $scope.parametersObj = {};
                $scope.isAdvancedVisible = false;

                $scope.fnCheckValidation = function () {
                    var flag = true;
                    Object.keys($scope.parametersObj).forEach(function (key) {
                        if($scope.parametersObj[key].isValueMissing ||
                            $scope.parametersObj[key].isMinMaxError || $scope.parametersObj[key].isPatternMismatch ||
                            $scope.parametersObj[key].commaPatternMessage || $scope.parametersObj[key].isCommaNumberPatternMismatch ||
                            $scope.parametersObj[key].isInputCommaWithTextPatternMismatch || $scope.parametersObj[key].isNotArray) {
                            flag = false;
                        }
                    });
                    if(flag) {
                        var parametersObjCopy = angular.copy($scope.parametersObj);
                        var tempObj = {};
                        Object.keys(parametersObjCopy).forEach(function (key) {
                           if(parametersObjCopy[key].isRequired === false) {
                               if(parametersObjCopy[key].userInput && parametersObjCopy[key].userInput !== parametersObjCopy[key].default) {
                                   tempObj[key] = parametersObjCopy[key].userInput;
                               }
                           } else {
                               tempObj[key] = parametersObjCopy[key].userInput;
                           }
                        });
                        $scope.fnCheckParameterValidation({isValidate: true, parametersObj: tempObj});
                    } else {
                        $scope.fnCheckParameterValidation({isValidate: false, parametersObj: {}});
                    }
                };

                $scope.fnCheckRequired = function (key) {
                    if($scope.parametersObj[key].requiredCondition) {
                        var condition = '';
                        angular.forEach($scope.parametersObj[key].requiredCondition, function (conditionObj, index) {
                            if(index !== 0) {
                                condition += conditionObj.joinOperator;
                            }
                            var keyvalue = $scope.parametersObj[conditionObj.key].userInput;
                            if($scope.parametersObj[conditionObj.key] && $scope.parametersObj[conditionObj.key].userInput === '') {
                                keyvalue = undefined;
                            }
                            condition += "'" + keyvalue + "'" + conditionObj.operator + "'" + conditionObj.value + "'";
                        });
                        if(eval(condition)) {
                            $scope.parametersObj[key].isRequired = true;
                            if(!$scope.parametersObj[key].userInput || $scope.parametersObj[key].userInput === '') {
                                $scope.parametersObj[key].isValueMissing = true;
                            } else {
                                $scope.parametersObj[key].isValueMissing = false;
                            }
                        } else {
                            $scope.parametersObj[key].isRequired = false;
                            $scope.parametersObj[key].isValueMissing = false;
                        }
                    }
                    if ($scope.parametersObj[key].required === true) {
                        $scope.parametersObj[key].isRequired = true;
                        if(!$scope.parametersObj[key].userInput || $scope.parametersObj[key].userInput === '') {
                            $scope.parametersObj[key].isValueMissing = true;
                        } else {
                            $scope.parametersObj[key].isValueMissing = false;
                        }
                    } else {
                        $scope.parametersObj[key].isRequired = false;
                        $scope.parametersObj[key].isValueMissing = false;
                    }
                };

                $scope.fnCheckMinMax = function (key) {
                    if ($scope.parametersObj[key].hasOwnProperty("min") || $scope.parametersObj[key].hasOwnProperty('max')) {
                        if ($scope.parametersObj[key].userInput && ($scope.parametersObj[key].userInput < $scope.parametersObj[key].min ||
                                $scope.parametersObj[key].userInput > $scope.parametersObj[key].max)) {
                            $scope.parametersObj[key].isMinMaxError = true;
                        } else {
                            $scope.parametersObj[key].isMinMaxError = false;
                        }
                    } else {
                        $scope.parametersObj[key].isMinMaxError = false;
                    }
                };

                $scope.fnCheckInputComma = function (key) {
                    if($scope.parametersObj[key].inputType === 'inputComma' && $scope.parametersObj[key].type === 'text') {
                        if($scope.parametersObj[key].userInput && !/^\w(\s*,?\s*\w)*$/.test($scope.parametersObj[key].userInput)) {
                            $scope.parametersObj[key].isCommaPatternMismatch = true;
                            $scope.parametersObj[key].commaPatternMessage = 'The input does not match the required pattern. The value should not start or end with a ",".';
                        } else {
                            $scope.parametersObj[key].isCommaPatternMismatch = false;
                            $scope.parametersObj[key].commaPatternMessage = '';
                        }
                    } else {
                        $scope.parametersObj[key].isCommaPatternMismatch = false;
                        $scope.parametersObj[key].commaPatternMessage = '';
                    }

                    if($scope.parametersObj[key].inputType === 'inputComma' && $scope.parametersObj[key].type === 'number') {
                        if($scope.parametersObj[key].userInput && !/^(?!,)(,?[0-9]+)+$/.test($scope.parametersObj[key].userInput)) {
                            $scope.parametersObj[key].isCommaNumberPatternMismatch = true;
                            $scope.parametersObj[key].commaNumberPatternMessage = 'The input does not match the required pattern. The value should not start or end with a ",". The input does not accept space.';
                        } else {
                            if($scope.parametersObj[key] && $scope.parametersObj[key].hasOwnProperty('max')) {
                                var tempArr = $scope.parametersObj[key].userInput.split(",");
                                if(tempArr.length > $scope.parametersObj[key].max) {
                                    $scope.parametersObj[key].isCommaNumberPatternMismatch = true;
                                    $scope.parametersObj[key].commaNumberPatternMessage = 'Input can only accept ' + $scope.parametersObj[key].max + ' values';
                                } else {
                                    $scope.parametersObj[key].isCommaNumberPatternMismatch = false;
                                    $scope.parametersObj[key].commaNumberPatternMessage = '';
                                }
                            } else {
                                $scope.parametersObj[key].isCommaNumberPatternMismatch = false;
                                $scope.parametersObj[key].commaNumberPatternMessage = '';
                            }
                        }
                    } else {
                        $scope.parametersObj[key].isCommaNumberPatternMismatch = false;
                        $scope.parametersObj[key].commaNumberPatternMessage = '';
                    }
                };

                $scope.fnCheckValueValidation = function (key) {
                    if($scope.parametersObj[key].userInput && $scope.parametersObj[key].hasOwnProperty('valueValidation')) {
                        var condition = '';
                        var patternMessage = 'Input value should be ';
                        angular.forEach($scope.parametersObj[key].valueValidation, function (conditionObj, index) {
                            if(index !== 0) {
                                condition += conditionObj.joinOperator;
                                if(conditionObj.joinOperator === '||') {
                                    patternMessage += ' OR ';
                                }
                            }
                            if(conditionObj.operator === '===') {
                                patternMessage += 'equal to'
                            }else {
                                patternMessage += conditionObj.operator
                            }
                            patternMessage += " " + conditionObj.value;
                            var keyvalue = $scope.parametersObj[key].userInput;
                            if($scope.parametersObj[conditionObj.key] && $scope.parametersObj[conditionObj.key].userInput === '') {
                                keyvalue = undefined;
                            }
                            if(isNaN(keyvalue)) {
                                keyvalue = "'" + keyvalue + "'"
                            }
                            var value = '';
                            if(isNaN(conditionObj.value)) {
                                if(!conditionObj.value.startsWith("'")) {
                                    value = "'" + conditionObj.value + "'"
                                }
                            } else {
                                value = conditionObj.value;
                            }
                            condition += keyvalue + conditionObj.operator + value;
                        });
                        if(eval(condition)) {
                            $scope.parametersObj[key].isPatternMismatch = false;
                            $scope.parametersObj[key].patternMessage = '';
                        } else {
                            $scope.parametersObj[key].isPatternMismatch = true;
                            $scope.parametersObj[key].patternMessage = patternMessage;
                        }
                    } else {
                        $scope.parametersObj[key].isPatternMismatch = false;
                        $scope.parametersObj[key].patternMessage = '';
                    }
                };

                $scope.fnCheckInputCommaWithText = function (key) {
                    if($scope.parametersObj[key].inputType === 'inputCommaWithText') {
                        if(angular.isDefined($scope.parametersObj[key].validValues)) {
                            if($scope.parametersObj[key].userInput &&
                                (/^(?!,)(,?[0-9]+)+$/.test($scope.parametersObj[key].userInput))) {
                                var tempArr = $scope.parametersObj[key].userInput.split(",");
                                var flag = false;
                                angular.forEach(tempArr, function (val) {
                                    if(!val.trim().includes($scope.parametersObj[key].validValues)) {
                                        flag = true;
                                    }
                                });
                                if(flag) {
                                    $scope.parametersObj[key].isInputCommaWithTextPatternMismatch = true;
                                    var text = '';
                                    angular.forEach(tempArr, function (tempVal, index) {
                                        text += tempVal.trim();
                                        if(index !== tempArr.length - 1) {
                                            text += ", "
                                        }
                                    });
                                    $scope.parametersObj[key].isInputCommaWithTextPatternMessage = 'The input only accepts Comma Separated list from values ' + text;
                                } else {
                                    $scope.parametersObj[key].isInputCommaWithTextPatternMismatch = false;
                                    $scope.parametersObj[key].isInputCommaWithTextPatternMessage = '';

                                }
                            } else {
                                $scope.parametersObj[key].isInputCommaWithTextPatternMismatch = true;
                                $scope.parametersObj[key].isInputCommaWithTextPatternMessage = 'The input only accepts Comma Separated list';
                            }
                        } else if ($scope.parametersObj[key].userInput &&
                            (/^(?!,)(,?[0-9]+)+$/.test($scope.parametersObj[key].userInput) || $scope.parametersObj[key].userInput === $scope.parametersObj[key].validText)) {
                            $scope.parametersObj[key].isInputCommaWithTextPatternMismatch = false;
                            $scope.parametersObj[key].isInputCommaWithTextPatternMessage = '';
                        } else {
                            $scope.parametersObj[key].isInputCommaWithTextPatternMismatch = true;
                            $scope.parametersObj[key].isInputCommaWithTextPatternMessage = 'The input only accepts Comma Separated list';
                        }
                    }
                };

                $scope.fnCheckArray = function (key) {
                    if($scope.parametersObj[key].inputType === 'array') {
                        if ($scope.parametersObj[key].userInput && !/^(\s*-?\d+(\.\d+)?)(\s*,\s*-?\d+(\.\d+)?)*$/.test($scope.parametersObj[key].userInput)) {
                            $scope.parametersObj[key].isNotArray = true;
                            $scope.parametersObj[key].isNotArrayPatternMessage = 'Value should a comma separated list of floats';
                        } else {
                            $scope.parametersObj[key].isNotArray = false;
                            $scope.parametersObj[key].isNotArrayPatternMessage = '';
                        }
                    }
                };

                $scope.fnCreateParametersStructure = function (paramObj) {
                    if(Object.keys($scope.clonedParametersObj).length &&
                        ($scope.clonedParametersObj.parameters && Object.keys($scope.clonedParametersObj.parameters).length)) {
                        Object.keys($scope.clonedParametersObj.parameters).forEach(function (key) {
                            if(paramObj[key]) {
                                paramObj[key].userInput = $scope.clonedParametersObj.parameters[key]
                            }
                        })
                    }
                    Object.keys(paramObj).forEach(function (key) {
                        $scope.fnCheckRequired(key);
                        $scope.fnCheckMinMax(key);
                        $scope.fnCheckInputComma(key);
                        $scope.fnCheckValueValidation(key);
                        $scope.fnCheckInputCommaWithText(key);
                        $scope.fnCheckArray(key);
                    });
                    $scope.fnCheckValidation();
                };
                $scope.fnValidate = function (key) {
                    $scope.fnCheckParamOptions();
                    $scope.fnCheckRequired(key);
                    $scope.fnCheckMinMax(key);
                    $scope.fnCheckInputComma(key);
                    $scope.fnCheckValueValidation(key);
                    $scope.fnCheckInputCommaWithText(key);
                    $scope.fnCheckArray(key);
                    $scope.fnCheckValidation();
                };

                $scope.fnCheckParamOptions = function () {
                    Object.keys($scope.parametersObj).forEach(function (key) {
                        if($scope.parametersObj[key].if) {
                            var condition = '';
                            angular.forEach($scope.parametersObj[key].if, function (conditionObj, index) {
                                if(index !== 0) {
                                    condition += conditionObj.joinOperator;
                                }
                                var keyvalue = $scope.parametersObj[conditionObj.key].userInput;
                                if($scope.parametersObj[conditionObj.key] && $scope.parametersObj[conditionObj.key].userInput === '') {
                                    keyvalue = undefined;
                                }
                                condition += "'" + keyvalue + "'" + conditionObj.operator + "'" + conditionObj.value + "'";
                            });
                            if(eval(condition)) {
                                $scope.parametersObj[key].isDisabled = false;
                            } else {
                                $scope.parametersObj[key].isDisabled = true;
                            }
                        } else {
                            $scope.parametersObj[key].isDisabled = false;
                        }
                    });
                };

                $scope.fnAddDefaults = function (paramObj) {
                    Object.keys(paramObj).forEach(function (selectedParamOption) {
                        if(paramObj[selectedParamOption].hasOwnProperty('defaultCondition')) {
                            if(paramObj.hasOwnProperty(paramObj[selectedParamOption].defaultCondition.key)) {
                                paramObj[selectedParamOption].userInput = paramObj[paramObj[selectedParamOption].defaultCondition.key].userInput
                            } else {
                                paramObj[selectedParamOption].userInput = paramObj[paramObj[selectedParamOption].defaultCondition.key].default;
                            }
                        } else if (paramObj[selectedParamOption].hasOwnProperty('default')) {
                            if(paramObj[selectedParamOption].default === "-" && paramObj[selectedParamOption].type === 'number') {
                                paramObj[selectedParamOption].userInput = ''
                            } else {
                                paramObj[selectedParamOption].userInput = paramObj[selectedParamOption].default
                            }
                        } else {
                            paramObj[selectedParamOption].userInput = ''
                        }
                    });
                    $scope.fnCheckParamOptions();
                    $scope.fnCreateParametersStructure(paramObj);
                };

                $scope.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };
                $scope.fnInit = function(){
                    var path = 'assets/json/algo-' + $scope.algorithmId + '.json';
                    $http.get(path)
                        .then(function (response) {
                            $scope.paramOptionsObj = response.data;
                            $scope.parametersObj = angular.copy($scope.paramOptionsObj);
                            $scope.fnAddDefaults($scope.parametersObj);
                        },function () {});
                };
                $scope.fnInit();
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createVaultFromTypeCtrl',
            function ($scope, $timeout, DB, SchemaService, amaran, AppInitService, VaultsFactory, TypeFactory) {

                var vm = this;
                vm.title = "Create Vault";
                vm.vaultKVPArr = [
                    {
                        key: '',
                        value: '',
                        inputType: 'password',
                        tabIndex: 0
                    }
                ];
                vm.newVaultObj = {
                    name: '',
                    description: '',
                    content: {}
                };

                vm.advancedVaultKVPArr = [
                    {
                        key: '',
                        value: '',
                        inputType: 'password'
                    }
                ];

                vm.booleanOptionArr = ["true", "false"];

                vm.typesArr = [];
                vm.isTypesLoading = true;
                vm.selectedType = '';
                vm.isTypeSelected = false;
                vm.isFormValidated = false;
                vm.isAdvancedVisible = false;
                vm.hideShowPassword = function (vaultObj) {
                    if (vaultObj.inputType === 'password') {
                        vaultObj.inputType = 'text';
                    } else {
                        vaultObj.inputType = 'password';
                    }
                };

                vm.fnRemoveKvpPair = function (index) {
                    vm.vaultKVPArr.splice(index, 1);
                };

                vm.fnKvpPairChange = function (kvpPair) {
                    if (kvpPair.type) {
                        vm.fnValidate(kvpPair);
                    }
                    /*if (kvpPair.value && kvpPair.key) {
                        if (index + 1 === vm.vaultKVPArr.length) {
                            if (kvpPair.key.length && kvpPair.value.length && vm.vaultKVPArr[vm.vaultKVPArr.length - 1].key === kvpPair.key) {
                                var count = 0;
                                if (vm.vaultKVPArr.length > 1) {
                                    angular.forEach(vm.vaultKVPArr, function (kvpPairObj) {
                                        if (kvpPairObj.key === kvpPair.key) {
                                            count++;
                                        }
                                    });
                                }
                                if (count <= 1) {
                                    var inputObj = {
                                        key: '',
                                        value: '',
                                        inputType: 'password',
                                        tabIndex: 0
                                    };
                                    vm.vaultKVPArr.push(inputObj)
                                }
                            }
                        }
                    }*/
                };

                vm.fnValidate = function (kvpPair) {
                    if (kvpPair.required && (kvpPair.required === true || kvpPair.required === "true")) {
                        if (kvpPair.value) {
                            kvpPair.isValueMissing = false;
                        } else {
                            kvpPair.isValueMissing = true;
                        }
                    }
                    if (kvpPair.type === "Number") {
                        if (!isNaN(kvpPair.value)) {
                            kvpPair.isValueNotNumber = false;
                            if (kvpPair.min) {
                                if (kvpPair.value < kvpPair.min) {
                                    kvpPair.isMinError = true;
                                } else {
                                    kvpPair.isMinError = false;
                                }
                            }
                            if (kvpPair.max) {
                                if (kvpPair.value > kvpPair.max) {
                                    kvpPair.isMaxError = true;
                                } else {
                                    kvpPair.isMaxError = false;
                                }
                            }
                        } else {
                            kvpPair.isValueNotNumber = true;
                        }
                    }
                    if (kvpPair.regex) {
                        var regExp = new RegExp(kvpPair.regex);
                        if (regExp.test(kvpPair.value)) {
                            kvpPair.isPatternMismatch = false;
                        } else {
                            kvpPair.isPatternMismatch = true;
                        }
                    }
                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnCheckAllFieldsValidation = function () {
                    var flag = true;
                    vm.vaultKVPArr.map(function (kvpPairObj) {
                        if (kvpPairObj.type) {
                            if (kvpPairObj.required && (kvpPairObj.required === true || kvpPairObj.required === "true")) {
                                if (!kvpPairObj.value) {
                                    flag = false;
                                }
                            }
                            if (kvpPairObj.type !== "Array") {
                                if (kvpPairObj.type && kvpPairObj.type === "Number") {
                                    if (!isNaN(kvpPairObj.value)) {
                                        if (kvpPairObj.min) {
                                            if (kvpPairObj.value < kvpPairObj.min) {
                                                flag = false;
                                            }
                                        }
                                        if (kvpPairObj.max) {
                                            if (kvpPairObj.value > kvpPairObj.max) {
                                                flag = false;
                                            }
                                        }
                                    } else {
                                        flag = false;
                                    }
                                }
                                if (kvpPairObj.regex) {
                                    var regExp = new RegExp(kvpPairObj.regex);
                                    if (!regExp.test(kvpPairObj.value)) {
                                        flag = false;
                                    }
                                }
                            } else {
                                if (kvpPairObj.min) {
                                    if (kvpPairObj.value.length < kvpPairObj.min) {
                                        flag = false;
                                    }
                                }
                                if (kvpPairObj.max) {
                                    if (kvpPairObj.value.length > kvpPairObj.max) {
                                        flag = false;
                                    }
                                }
                            }
                        }
                    });
                    if (flag) {
                        vm.isFormValidated = true;
                    } else {
                        vm.isFormValidated = false;
                    }
                };

                vm.fnCreateNewVault = function (newVaultObj, vaultKvpArr) {
                    angular.forEach(vaultKvpArr, function (kvpPairObj) {
                        if (angular.isDefined(kvpPairObj.key) && kvpPairObj.key.length && angular.isDefined(kvpPairObj.value) && kvpPairObj.value.length) {
                            if (/^\d+$/.test(kvpPairObj.value)) {
                                newVaultObj.content[kvpPairObj.key] = parseInt(kvpPairObj.value);
                            } else {
                                newVaultObj.content[kvpPairObj.key] = kvpPairObj.value;
                            }
                        }
                    });
                    angular.forEach(vm.advancedVaultKVPArr, function (kvpPairObj) {
                        if (angular.isDefined(kvpPairObj.key) && kvpPairObj.key.length && angular.isDefined(kvpPairObj.value) && kvpPairObj.value.length) {
                            if (/^\d+$/.test(kvpPairObj.value)) {
                                newVaultObj.content[kvpPairObj.key] = parseInt(kvpPairObj.value);
                            } else {
                                newVaultObj.content[kvpPairObj.key] = kvpPairObj.value;
                            }
                        }
                    });
                    vm.isVaultCreating = true;
                    var inputObj = {
                        body: newVaultObj
                    };
                    VaultsFactory.createVault(inputObj)
                        .then(function (resObj) {
                            vm.isVaultCreating = false;
                            $scope.vaults.fnHideShowCreateForm(); //parent function

                            vm.newVaultObj = {
                                name: '',
                                description: '',
                                content: {}
                            };
                            vm.vaultKVPArr = [
                                {
                                    key: '',
                                    value: '',
                                    inputType: 'password',
                                    tabIndex: 0
                                }
                            ];
                            vm.advancedVaultKVPArr = [
                                {
                                    key: '',
                                    value: '',
                                    inputType: 'password'
                                }
                            ];
                            $timeout(function () { // set table height
                                $scope.vaults.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('VaultAdded', 'Create Vault');
                            $scope.vaults.totalItems = $scope.vaults.totalItems + 1;
                            $scope.vaults.vaultsArr.push(resObj);
                            $scope.vaults.fnReload();
                            amaran.success("Vault created successfully");
                        }, function () {
                            vm.isVaultCreating = false;
                        });
                };

                vm.fnTypeSelected = function (selectedType) {
                    vm.isTypeSelected = false;
                    var typePropertiesArr = [];
                    if (Object.keys(selectedType.securities).length) {
                        typePropertiesArr = angular.copy(SchemaService.convertJsonToSchema(selectedType.securities));
                        angular.forEach(typePropertiesArr, function (tempObj) {
                            tempObj.key = tempObj.name;
                            if (tempObj.default) {
                                tempObj.value = tempObj.default;
                            } else {
                                if (tempObj.type === "Array") {
                                    tempObj.value = [];
                                } else {
                                    tempObj.value = "";
                                }
                            }
                            tempObj.inputType = 'password';
                            tempObj.isValueMissing = false;
                            tempObj.isPatternMismatch = false;
                            tempObj.isMinError = false;
                            tempObj.isMaxError = false;
                            tempObj.isValueNotNumber = false;
                            tempObj.tabIndex = -1;
                        });
                        vm.vaultKVPArr = typePropertiesArr;
                    }
                    $timeout(function () {
                        vm.isTypeSelected = true;
                    })
                };

                vm.fnCreateArrayTag = function (arrValue, id, kvpPair) {
                    if (arrValue) {
                        var flag = false;
                        if (kvpPair.item !== "Boolean") {
                            angular.forEach(kvpPair.value, function (obj) {
                                if (obj === arrValue) {
                                    flag = true;
                                }
                            });
                        }

                        if (!flag && kvpPair.isMaxError !== true) {
                            if (kvpPair.regex) {
                                if (kvpPair.isPatternMismatch === false) {
                                    kvpPair.value.push(angular.copy(arrValue));
                                    kvpPair.arrValue = "";
                                    angular.element('#' + id).blur();
                                }
                            } else {
                                kvpPair.value.push(angular.copy(arrValue));
                                kvpPair.arrValue = "";
                                angular.element('#' + id).blur();
                            }
                        }
                    }
                    vm.fnArrayValidation(kvpPair, kvpPair.arrValue);
                };

                vm.fnRemoveSelectedArrayTag = function (kvpPair, index) {
                    kvpPair.value.splice(index, 1);
                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnArrayValidation = function (kvpPair, value) {
                    if (kvpPair.required && (kvpPair.required === true || kvpPair.required === "true")) {
                        if (kvpPair.value) {
                            kvpPair.isValueMissing = false;
                        } else {
                            kvpPair.isValueMissing = true;
                        }
                    }
                    if (kvpPair.min) {
                        if (kvpPair.value.length < kvpPair.min) {
                            kvpPair.isMinError = true;
                        } else {
                            kvpPair.isMinError = false;
                        }
                    }
                    if (kvpPair.max) {
                        if (kvpPair.value.length >= kvpPair.max) {
                            kvpPair.isMaxError = true;
                        } else {
                            kvpPair.isMaxError = false;
                        }
                    }
                    if (kvpPair.regex) {
                        var regExp = new RegExp(kvpPair.regex);
                        if (regExp.test(value)) {
                            kvpPair.isPatternMismatch = false;
                        } else {
                            kvpPair.isPatternMismatch = true;
                        }
                    }
                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);
                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                /*START: AdvancedVaultKVPArr*/
                vm.fnAddNewKvp = function () {
                    vm.advancedVaultKVPArr.push({
                        key: '',
                        value: '',
                        inputType: 'password'
                    });
                };

                vm.fnRemoveAdvancedKvpPair = function (index) {
                    if (vm.advancedVaultKVPArr.length === 1) {
                        vm.advancedVaultKVPArr = [
                            {
                                key: '',
                                value: '',
                                inputType: 'password'
                            }
                        ];
                        vm.isAdvancedVisible = false;
                    } else {
                        vm.advancedVaultKVPArr.splice(index, 1);
                    }

                };
                /*END: AdvancedVaultKVPArr*/

                vm.fnInitCreateVaultFromType = function () {
                    vm.isTypesLoading = true;
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        var typesArr = AppInitService.getInitData('typesArr');
                        vm.typesArr = _.filter(typesArr, {category: "DEVICE"});
                        vm.isTypesLoading = false;
                    } else {
                        var inputObj = {
                            filter: "#{category} = ${DEVICE}"
                        };
                        TypeFactory.getTypes(inputObj)
                            .then(function (response) {
                                vm.typesArr = response;
                                vm.isTypesLoading = false;
                            })
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createVaultFromNodeCtrl',
            function ($scope, $timeout, $uibModal, SchemaService, amaran, VaultsFactory, jsyaml, TypeFormService) {

                var vm = this;
                vm.title = "Create Vault";
                vm.newVaultObj = {
                    name: '',
                    description: '',
                    content: {}
                };
                vm.iot3BlueprintsArr = [];
                vm.selectedIot3File = '';
                vm.isIot3FileSelected = false;
                vm.model = {};
                vm.form = {};
                vm.schema = {};

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: false,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                vm.hideShowPassword = function (vaultObj) {
                    if (vaultObj.inputType === 'password') {
                        vaultObj.inputType = 'text';
                    } else {
                        vaultObj.inputType = 'password';
                    }
                };

                vm.fnCreateNewVault = function (newVaultObj) {
                    newVaultObj.content = _.cloneDeepWith(vm.model);
                    vm.isVaultCreating = true;
                    var inputObj = {
                        body: newVaultObj
                    };
                    VaultsFactory.createVault(inputObj)
                        .then(function (resObj) {
                            $scope.vaults.fnHideShowCreateForm(true, 'node'); //parent function
                            vm.newVaultObj = {
                                name: '',
                                description: '',
                                content: {}
                            };
                            $timeout(function () { // set table height
                                $scope.vaults.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('VaultAdded', 'Create Vault from Node');
                            $scope.vaults.totalItems = $scope.vaults.totalItems + 1;
                            $scope.vaults.vaultsArr.push(resObj);
                            $scope.vaults.fnReload();
                            amaran.success("Vault created successfully");
                            vm.isVaultCreating = false;
                        }, function () {
                            vm.isVaultCreating = false;
                        });
                };

                vm.fnIot3FileSelected = function (schemaObj) {
                    vm.isIot3FileSelected = false;
                    vm.schema = {};
                    vm.form = [];
                    vm.model = {};
                    if (schemaObj.properties && Object.keys(schemaObj.properties).length) {
                        var tempData = TypeFormService.fnGenerateFormData(schemaObj);
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                    }
                    $timeout(function () {
                        vm.isIot3FileSelected = true;
                    })
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    }
                    catch (error) {
                        amaran.error('Yaml format is incorrect. Please check it and try again.')
                        return false;
                    }
                };

                vm.fnConvertIot3Yaml = function (selectedWorkspace) {
                    if (selectedWorkspace && selectedWorkspace.iot3) {
                        var iot3Json = {};
                        var tempIOT3String = '';
                        try {
                            tempIOT3String = _.cloneDeepWith(angular.fromJson(selectedWorkspace.iot3));
                        } catch (error) {
                            tempIOT3String = _.cloneDeepWith(selectedWorkspace.iot3);
                        }
                        selectedWorkspace.iot3File = _.cloneDeepWith(tempIOT3String);
                        iot3Json = vm.fnConvertYamlToJson(selectedWorkspace.iot3File);
                        if (iot3Json && iot3Json.registration && iot3Json.registration.vault) {
                            vm.selectedIot3File = selectedWorkspace;
                            vm.fnIot3FileSelected(iot3Json.registration.vault);
                        } else {
                            vm.selectedIot3File = '';
                            vm.isIot3FileSelected = false;
                            vm.schema = {};
                            vm.form = [];
                            vm.model = {};
                        }
                    }
                };

                vm.fnResetIot3File = function () {
                    vm.selectedIot3File = '';
                    vm.isIot3FileSelected = false;
                    vm.schema = {};
                    vm.form = [];
                    vm.model = {};
                };

                vm.uploadFiles = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        vm.fnConvertIot3Yaml({iot3: fileLoadedEvent.target.result});
                    };
                    reader.readAsText(filesSelected);
                };

                vm.fnOpenIot3BlueprintsModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/iot3/iot3Workbench/modals/workspaceListModal/workspaceListModal.html',
                        size: 'lg',
                        windowClass: 'modal-height100',
                        controller: 'workspaceListModalCtrl as workspaceList',
                        resolve: {
                            isGetBlueprints: function () {
                                return true;
                            },
                            isHideDelete: function () {
                                return true;
                            }
                        }
                    });

                    modalInstance.result.then(function (data) {
                        vm.fnConvertIot3Yaml(data.selectedWorkspace);
                    }, function () {
                    });
                };

                vm.fnInitCreateVaultFromNode = function () {

                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createVaultFromAuthenticatorCtrl',
            function ($scope, $timeout, $uibModal, SchemaService, amaran, VaultsFactory, AuthenticatorFactory, QueryFactory) {

                var vm = this;
                vm.title = "Create Vault";
                vm.newVaultObj = {
                    name: '',
                    description: '',
                    content: {}
                };
                vm.typesArr = [];
                vm.isTypesLoading = true;
                vm.selectedType = '';
                vm.isTypeSelected = false;
                vm.model = {};
                vm.form = {};
                vm.schema = {};
                var totalItems = 0;
                var dataLimit = 100;

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: false,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                vm.hideShowPassword = function (vaultObj) {
                    if (vaultObj.inputType === 'password') {
                        vaultObj.inputType = 'text';
                    } else {
                        vaultObj.inputType = 'password';
                    }
                };

                vm.fnCreateNewVault = function (newVaultObj) {
                    newVaultObj.content = _.cloneDeepWith(vm.model);
                    vm.isVaultCreating = true;
                    var inputObj = {
                        body: newVaultObj
                    };
                    VaultsFactory.createVault(inputObj)
                        .then(function (resObj) {
                            $scope.vaults.fnHideShowCreateForm(); //parent function
                            vm.newVaultObj = {
                                name: '',
                                description: '',
                                content: {}
                            };
                            $timeout(function () { // set table height
                                $scope.vaults.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('VaultAdded', 'Create Vault  from Authenticator');
                            $scope.vaults.totalItems = $scope.vaults.totalItems + 1;
                            $scope.vaults.vaultsArr.push(resObj);
                            $scope.vaults.fnReload();
                            amaran.success("Vault created successfully");
                            vm.isVaultCreating = false;
                        }, function () {
                            vm.isVaultCreating = false;
                        });
                };

                vm.fnTypeSelected = function (selectedType) {
                    vm.isTypeSelected = false;
                    var tempArr = [];
                    vm.schema = {};
                    vm.form = [];
                    vm.model = {};
                    if (selectedType.vaultForm.schema && selectedType.vaultForm.schema.properties && Object.keys(selectedType.vaultForm.schema.properties).length) {
                        _.forEach(selectedType.vaultForm.schema.properties, function (value, key) {
                            if (value.format === "xml") {
                                tempArr.push({
                                    key: key,
                                    type: "xmlAuthInput",
                                    feedback: false,
                                    title: value.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: value.description && value.description !== '' ? value.description : value.title,
                                    isHide: true,
                                    inputAction: {
                                        fnInjectFunction: function (name) {
                                            vm.fnInjectFunction(name);
                                        }
                                    },
                                    editorOpt: vm.editorOptions
                                });
                            } else {
                                tempArr.push({
                                    key: key,
                                    type: "authInput",
                                    feedback: false,
                                    title: value.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: value.description && value.description !== '' ? value.description : value.title,
                                    isHide: true,
                                    inputAction: {
                                        fnInjectFunction: function (name) {
                                            vm.fnInjectFunction(name);
                                        }
                                    }
                                });
                            }
                            vm.model[key] = "";
                        });
                        vm.schema = _.cloneDeepWith(selectedType.vaultForm.schema);
                        vm.form = tempArr;
                    } else {
                        vm.schema = {
                            $schema: "http://json-schema.org/draft-03/schema#",
                            type: "object",
                            properties: {}
                        };
                        vm.form = [];
                    }
                    $timeout(function () {
                        vm.isTypeSelected = true;
                    })
                };

                vm.fnInjectFunction = function (kvpPair) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/access/vault/modal/vaultAuthenticatorModal.html',
                        size: 'lg',
                        controller: 'vaultAuthenticatorModalCtrl as vAModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (arr) {
                        vm.model[kvpPair[0]] = arr;
                    }, function () {
                    });
                };

                vm.fnGetAuthenticatorTypes = function (inputObj, previousData, isNextData) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) { // Success block
                            if (isNextData === false) {
                                totalItems = _.cloneDeepWith(response.data[0].totalItems);
                            }
                            var authenticators = isNextData ? previousData : [];
                            _.forEach(response.data, function (vaultObj) {
                                authenticators.push(vaultObj);
                            });
                            if ((response.data && response.data.length && response.data.length > 0) && (totalItems > authenticators.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_authenticator_types';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + authenticators[authenticators.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                                vm.fnGetAuthenticatorTypes({sql: sqlString}, authenticators, true);
                            } else {
                                vm.typesArr = _.cloneDeepWith(authenticators);
                                vm.isTypesLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTypesLoading = false;
                        })

                };

                vm.fnInitCreateVaultFromAuthenticator = function () {
                    vm.isTypesLoading = true;
                    var inputObj = {
                        sql: 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_authenticator_types ORDER BY rt asc LIMIT ' + dataLimit + ';'
                    };
                    vm.fnGetAuthenticatorTypes(inputObj, [], false);
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('userInfo', fnUserInfo)

    /** @ngInject */
    function fnUserInfo($window, $state, $stateParams, $timeout, $uibModal, IconService, ColorService, amaran, swal, microSpinner, UserFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/users/directives/userInfo/userInfo.html',
            scope: {
                userObj: '=',
                authUserObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                $scope.adminPermissionStructureObj = {
                    isChanged: false,
                    isActive: false
                };

                $scope.resetAdminPermissionStructureObj = _.cloneDeepWith($scope.adminPermissionStructureObj);
                $scope.permissionsStructureObj = {
                    "billing": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "node": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "tracker": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "pipeline": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "storage": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "ai": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    },
                    "insight": {
                        "isChanged": false,
                        "manager": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Full access to all projects including features that can change your bill'
                        },
                        "supervisor": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Full access to all projects excluding features that can change your bill'
                        },
                        "engineer": {
                            isActive: false,
                            isApplicable: false,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "team_member": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects via teams without access to settings'
                        },
                        "customer": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'Restricted access to projects'
                        },
                        "none": {
                            isActive: false,
                            isApplicable: true,
                            permDetail: 'No access'
                        }
                    }
                };
                $scope.resetPermissionsStructureObj = _.cloneDeepWith($scope.permissionsStructureObj);

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    71: false, //g
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/access/users/directives/userInfo/userSteps/details.html'
                    },
                    {
                        title: 'Teams',
                        tabIndex: 2,
                        templateUrl: 'app/access/users/directives/userInfo/userSteps/teams/teams.html'
                    },
                    {
                        title: 'Permissions',
                        tabIndex: 3,
                        templateUrl: 'app/access/users/directives/userInfo/userSteps/userPermissions/userPermissions.html'
                    }/*,
                    {
                        title: 'Relationship',
                        tabIndex: 4,
                        templateUrl: 'app/access/users/directives/userInfo/userSteps/userRelationships/userRelationships.html'
                    }*/
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isPermissionsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.isPermissionUpdateCompleted = true;
                $scope.isUserUpdating = false;

                $scope.fnUpdatePermissions = function (value, key, appName) {
                    value[key].isActive = true;
                    var flag = false;
                    if (appName === 'billing' && $scope.userObj.billingRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'node' && $scope.userObj.nodeRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'tracker' && $scope.userObj.trackerRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'pipeline' && $scope.userObj.pipelineRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'storage' && $scope.userObj.storageRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'ai' && $scope.userObj.aiRole.toLowerCase() !== key) {
                        flag = true;
                    } else if (appName === 'insight' && $scope.userObj.insightRole.toLowerCase() !== key) {
                        flag = true;
                    }
                    $scope.permissionsStructureObj[appName].isChanged = flag;
                    Object.keys(value).forEach(function (permName) {
                        if (permName !== key && permName !== 'isChanged') {
                            value[permName].isActive = false;
                        }
                    })
                };

                $scope.fnChangeAdminStatus = function (isAdmin) {
                    $scope.adminPermissionStructureObj.isChanged = $scope.userObj.administrator !== isAdmin;
                    if (isAdmin) {
                        Object.keys($scope.permissionsStructureObj).forEach(function (keys) {
                            if (keys !== 'billing') {
                                Object.keys($scope.permissionsStructureObj[keys]).forEach(function (permName) {
                                    if (permName !== 'isChanged') {
                                        $scope.permissionsStructureObj[keys][permName].isActive = permName === 'manager';
                                    } else {
                                        var flag = false;
                                        if (keys === 'node' && $scope.userObj.nodeRole !== 'MANAGER') {
                                            flag = true;
                                        } else if (keys === 'tracker' && $scope.userObj.trackerRole !== 'MANAGER') {
                                            flag = true;
                                        } else if (keys === 'storage' && $scope.userObj.storageRole !== 'MANAGER') {
                                            flag = true;
                                        } else if (keys === 'ai' && $scope.userObj.aiRole !== 'MANAGER') {
                                            flag = true;
                                        } else if (keys === 'pipeline' && $scope.userObj.pipelineRole !== 'MANAGER') {
                                            flag = true;
                                        } else if (keys === 'insight' && $scope.userObj.insightRole !== 'MANAGER') {
                                            flag = true;
                                        }
                                        if (flag) {
                                            $scope.permissionsStructureObj[keys][permName] = true;
                                        }
                                    }
                                })
                            }
                        })
                    } else {
                        $scope.permissionsStructureObj = _.cloneDeepWith($scope.resetPermissionsStructureObj);
                    }
                };

                $scope.fnGetUser = function (userId) {
                    $scope.userAPIObj = {
                        userId: userId
                    };
                    UserFactory.describeUser($scope.userAPIObj)
                        .then(function (response) {
                            $scope.userObj = response;
                            $scope.resetUserObj = angular.copy($scope.userObj);
                            $scope.fnSetupUserPermissions(response);
                            if (angular.isUndefined($scope.userObj.bio)) {
                                $scope.userObj.bio = '';
                            }
                            $scope.isUserDetailsLoaded = true;
                            if ($stateParams.openEditView && ($stateParams.openEditView === 'true' || $stateParams.openEditView === true)) {
                                $scope.fnOpenEditMode();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUserDetailsLoaded = true;
                        });
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.users', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateUserPermissions = function (tempArr, appName, userObj, count, field) {
                    var permKey = '';
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    if (appName === 'administrator') {
                        permKey = $scope.adminPermissionStructureObj.isActive
                    } else {
                        Object.keys($scope.permissionsStructureObj[appName]).forEach(function (perName) {
                            if (perName !== 'isChanged' && $scope.permissionsStructureObj[appName][perName].isActive) {
                                permKey = perName;
                            }
                        });
                    }
                    switch (appName) {
                        case 'administrator':
                            inputObj.body = {
                                administrator: permKey
                            };
                            UserFactory.updateUserAdministrator(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'billing':
                            inputObj.body = {
                                billingRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserBillingRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'tracker':
                            inputObj.body = {
                                trackerRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserTrackerRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'node':
                            inputObj.body = {
                                nodeRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserNodeRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'pipeline':
                            inputObj.body = {
                                pipelineRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserPipelineRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'storage':
                            inputObj.body = {
                                storageRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserStorageRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'ai':
                            inputObj.body = {
                                aiRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserAiRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                        case 'insight':
                            inputObj.body = {
                                insightRole: permKey.toUpperCase()
                            };
                            UserFactory.updateUserInsightRole(inputObj)
                                .then(function (response) {
                                    count ++;
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, response, field, count);
                                }, function (error) {
                                    count ++;
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                                });
                            break;
                    }
                };

                $scope.fnStartUserUpdate = function (tempArr, userObj, field, count) {
                    if (tempArr[count] === 'userDetails') {
                        $scope.fnUpdateUserBio(userObj, field);
                    } else {
                        $scope.fnUpdateUserPermissions(tempArr, tempArr[count], userObj, count, field)
                    }
                };

                $scope.fnUpdateUserBio = function(userObj, field) {
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };

                    if (angular.isUndefined(userObj.bio)) {
                        userObj.bio = '';
                    }

                    if (field) {
                        inputObj.body[field] = $scope.userObj[field]
                    } else {
                        inputObj.body = {
                            firstName: userObj.firstName,
                            lastName: userObj.lastName,
                            username: userObj.username,
                            email: userObj.email,
                            bio: userObj.bio
                        }
                    }
                    UserFactory.updateUser(inputObj)
                        .then(function (response) {
                            $scope.$emit('UserDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            /*$scope.isUpdateCompleted = true;
                            $scope.fnInitUser();*/
                            amaran.success("User Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnUpdateUserDetails = function (userObj, field) {
                    $scope.isPermissionUpdateCompleted = false;
                    $scope.isPermissionsEditable = false;
                    var tempArr = [];
                    var count = 0;
                    if ($scope.adminPermissionStructureObj.isChanged) {
                        tempArr.push("administrator");
                    }
                    Object.keys($scope.permissionsStructureObj).forEach(function (appName) {
                        if ($scope.permissionsStructureObj[appName].isChanged) {
                            tempArr.push(appName);
                        }
                    });
                    // tempArr.push('userDetails');
                    $scope.fnCheckIfPermissionUpdateState(tempArr, userObj, field, count);
                };

                $scope.fnCheckIfPermissionUpdateState = function (tempArr, userObj, field, count) {
                    if (count < tempArr.length) {
                        $scope.fnStartUserUpdate(tempArr, userObj, field, count);
                    } else {
                        $scope.isPermissionUpdateCompleted = true;
                        $scope.userObj = _.cloneDeepWith(userObj);
                        $scope.$emit('UserDetailsChanged', userObj);
                        $scope.fnInitUserPermissions();
                        amaran.success("User Updated Successfully");
                    }
                };

                $scope.fnUpdateUserState = function (userObj) {
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    $scope.isPermissionUpdateCompleted = false;
                    $scope.isPermissionsEditable = false;
                    inputObj.body = {
                        state: userObj.state
                    };
                    UserFactory.updateUserState(inputObj)
                        .then(function (response) {
                            $scope.$emit('UserDetailsChanged', response);
                            $scope.isPermissionUpdateCompleted = true;
                            amaran.success("User Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isPermissionUpdateCompleted = true;
                        })
                };

                $scope.fnResetPassword = function (userObj) {
                    var inputObj = {
                        identifier: userObj.email
                    };
                    UserFactory.requestPasswordResetLink(inputObj)
                        .then(function () {
                            amaran.success("Your request for reset password is send Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.resendUserActivationLink = function (user) {
                    $scope.isUserUpdating = true;
                    var inputObj = {
                        userId: user.id,
                        identifier: user.email
                    };
                    UserFactory.requestUnconfirmedUserActivationLink(inputObj)
                        .then(function () {
                            amaran.success("Email send Successfully");
                            $scope.isUserUpdating = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUserUpdating = false;
                        });
                };

                $scope.fnMakeAdministrator = function (userObj) {
                    $scope.isUserUpdating = true;
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    $scope.isPermissionsEditable = false;
                    inputObj.body = {
                        administrator: true
                    };
                    UserFactory.updateUserAdministrator(inputObj)
                        .then(function (response) {
                            $scope.userObj = _.cloneDeepWith(response);
                            $scope.$emit('UserDetailsChanged', response);
                            $scope.isUserUpdating = false;
                            amaran.success("User Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUserUpdating = false;
                        })
                };

                $scope.fnDeleteUser = function (userObj) {
                    swal({
                            title: "Delete the selected user?",
                            text: "You are about to permanently delete the selected user.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    userId: userObj.id
                                };
                                UserFactory.deleteUser(inputObj)
                                    .then(function () {
                                        $scope.$emit('UserDeleted', userObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenEditMode = function () {
                    $state.go('main.users', {openEditView: ''}, {notify: false});
                    delete $stateParams.openEditView;
                    $scope.fnChangeFieldsToEditable();

                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnChangePermissionsToEditable = function () {
                    $scope.isPermissionsEditable = true;
                };

                $scope.fnResetPermissionDetails = function () {
                    $scope.adminPermissionStructureObj = _.cloneDeepWith($scope.resetAdminPermissionStructureObj);
                    $scope.permissionsStructureObj = _.cloneDeepWith($scope.resetPermissionsStructureObj);
                    $scope.isPermissionsEditable = false;
                };

                $scope.fnResetDetails = function () {
                    $scope.userObj = angular.copy($scope.resetUserObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnIsPermissionAllowed = function (key) {
                    if ($scope.adminPermissionStructureObj.isActive) {
                        if (key === 'billing') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_BILLING_ROLE;
                        } else {
                            return false;
                        }
                    } else {
                        if (key === 'billing') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_BILLING_ROLE;
                        } else if (key === 'node') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_NODE_ROLE;
                        } else if (key === 'tracker') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_TRACKER_ROLE;
                        } else if (key === 'pipeline') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_PIPELINE_ROLE;
                        } else if (key === 'storage') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_STORAGE_ROLE;
                        } else if (key === 'ai') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_AI_ROLE;
                        } else if (key === 'insight') {
                            return $scope.userObj.id !== $scope.authUserObj.id && $scope.userPermissionsObj.UPDATE_USER_INSIGHT_ROLE;
                        }
                    }
                };

                $scope.fnSetupUserPermissions = function (userObj) {
                    if (userObj.administrator) {
                        userObj.nodeRole = 'MANAGER';
                        userObj.trackerRole = 'MANAGER';
                        userObj.pipelineRole = 'MANAGER';
                        userObj.storageRole = 'MANAGER';
                        userObj.aiRole = 'MANAGER';
                        userObj.insightRole = 'MANAGER';
                    }
                    $scope.adminPermissionStructureObj.isActive = !!userObj.administrator;
                    $scope.adminPermissionStructureObj.isChanged = false;
                    Object.keys($scope.permissionsStructureObj).forEach(function (appName) {
                        Object.keys($scope.permissionsStructureObj[appName]).forEach(function (permName) {
                            if (permName !== 'isChanged') {
                                if (appName === 'billing') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.billingRole.toLowerCase();
                                } else if (appName === 'node') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.nodeRole.toLowerCase();
                                } else if (appName === 'tracker') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.trackerRole.toLowerCase();
                                } else if (appName === 'pipeline') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.pipelineRole.toLowerCase();
                                } else if (appName === 'storage') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.storageRole.toLowerCase();
                                } else if (appName === 'ai') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.aiRole.toLowerCase();
                                } else if (appName === 'insight') {
                                    $scope.permissionsStructureObj[appName][permName].isActive = permName === userObj.insightRole.toLowerCase();
                                }
                            } else {
                                $scope.permissionsStructureObj[appName][permName] = false;
                            }
                        })
                    });
                    $scope.resetAdminPermissionStructureObj = _.cloneDeepWith($scope.adminPermissionStructureObj);
                    $scope.resetPermissionsStructureObj = _.cloneDeepWith($scope.permissionsStructureObj);
                };

                $scope.fnInitUserPermissions = function () {
                    $scope.isPermissionsEditable = false;
                    $scope.isPermissionUpdateCompleted = true;
                    $scope.isUserPermissionDetailsLoaded = false;
                    $scope.fnSetupUserPermissions($scope.userObj);
                    $timeout(function () {
                        $scope.isUserPermissionDetailsLoaded = true;
                    });
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitUser = function () {
                    $scope.isUserDetailsLoaded = false;
                    $scope.userId = $scope.userObj.id;
                    if ($scope.userId) {
                        $scope.fnGetUser($scope.userId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitUser();

                $scope.fnInitDetailTab = function(){
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnGetUserStateIcon = function (state) {
                    var icon = IconService.fnGetUserStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "SUSPENDED":
                            return icon + ' InactiveStateIcon';
                        default:
                            return icon + ' unconfirmedStateIcon';
                    }
                };

                $scope.getUserStateColor = function (state) {
                    return ColorService.getUserStateColor(state);
                };

                $scope.fnUpdateUserRole = function (type, userObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/access/users/modal/updateUserRoleModal.html',
                        size: 'lg',
                        controller: 'updateUserRoleModalCtrl as updateUserRoleModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            userRoleType: function () {
                                return type;
                            },
                            userObj: function () {
                                return userObj;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        $scope.userObj = _.cloneDeepWith(response);
                        $scope.$emit('UserDetailsChanged', response);
                    }, function () {

                    });
                };

                var userInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.users') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.userPermissionsObj.DELETE_USER &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteUser($scope.userObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.userPermissionsObj.UPDATE_USER
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[71] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Groups');
                                codeset[38] = false;
                                codeset[71] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var userInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.users') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', userInfoKeyDownEventHandler);
                document.addEventListener('keyup', userInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', userInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', userInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('SupportTabCtrl',
            function ($timeout, $window, amaran, AccountFactory) {
                var vm = this;
                vm.isSupportChanging = false;
                vm.supportSwitchValue = false;
                vm.isPlansLoading = true;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 0;
                        var header = angular.element(".dashboard-header")[0] ? angular.element(".dashboard-header")[0].offsetHeight : 0; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer + 42 + header);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnToggleSupportSwitch = function(SupportEnable) {
                    vm.isSupportChanging = true;
                    if(SupportEnable){
                        AccountFactory.enableAccountSupportAccess().then(function (response) {
                            vm.supportSwitchValue = angular.isDefined(response.supportAccess) && response.supportAccess === true;
                            vm.isSupportChanging = false;
                            amaran.success("ECSite Support enable successfully");
                        }, function () {
                            vm.isSupportChanging = false;
                        });
                    } else {
                        AccountFactory.disableAccountSupportAccess().then(function (response) {
                            vm.supportSwitchValue = angular.isDefined(response.supportAccess) && response.supportAccess === true;
                            vm.isSupportChanging = false;
                            amaran.success("ECSite Support disable successfully");
                        }, function () {
                            vm.isSupportChanging = false;
                        });
                    }
                };

                vm.fnInitSupportTab = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                    vm.isPlansLoading = true;
                    AccountFactory.describeAccountState().then(function (response) {
                        vm.supportSwitchValue = angular.isDefined(response.supportAccess) && response.supportAccess === true;
                        vm.isPlansLoading = false;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    }, function () {
                        vm.isPlansLoading = false;
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        });
                    });
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('typeInfo', fnTypeInfo)

    /** @ngInject */
    function fnTypeInfo($window, $state, $stateParams, DB, $timeout, microSpinner, swal, amaran, ProjectFactory,
                        TypesFactory, copyService, postActionModelIcon, postActionModelMessage, AppInitService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/types/typesInfo/typeInfo.html',
            scope: {
                typeObj: '=',
                userPermissionsObj: '=',
                fnCallCloneObj: '&'
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.selectedProject = {};
                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/types/typesInfo/typesSteps/details.html'
                    },
                    {
                        title: 'Form',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/types/typesInfo/typesSteps/typeForm/typeForm.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/types/typesInfo/typesSteps/typeSupplemental/typeSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                $scope.isDisplayMiniColors = false;

                $scope.suggestedTypesArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912",
                    "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444",
                    "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                $scope.fnAssignSuggestedColor = function (suggestedColor) {
                    $scope.typeObj.color = suggestedColor;
                };

                $scope.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                $scope.fnDisplayMiniColors = function () {
                    $scope.isDisplayMiniColors = true;
                };

                $scope.fnGetType = function (typeId) {
                    var inputObj = {
                        typeId: typeId
                    };
                    TypesFactory.describeIssueType(inputObj)
                        .then(function (response) {
                            $scope.typeObj = response;
                            $scope.resetTypeObj = angular.copy($scope.typeObj);
                            if (angular.isUndefined($scope.typeObj.description)) {
                                $scope.typeObj.description = '';
                            }
                            $scope.isTypeDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isTypeDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.types', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateTypeDetails = function (typeObj) {
                    var inputObj = {
                        body: {},
                        typeId: typeObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(typeObj.description)) {
                        typeObj.description = '';
                    }
                    inputObj.body = {
                        name: typeObj.name,
                        description: typeObj.description,
                        color: typeObj.color,
                        projectId: typeObj.projectId
                    };
                    TypesFactory.updateIssueType(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var typesArr = AppInitService.getInitData('issueTypesArr');
                                var index = _.findIndex(typesArr, {id: response.id});
                                if (index !== -1) {
                                    typesArr[index].name = response.name;
                                    typesArr[index].description = response.description;
                                    typesArr[index].color = response.color;
                                    typesArr[index].projectId = response.projectId;
                                    AppInitService.fnUpdateIssueTypesData(typesArr);
                                }
                            }
                            $scope.$emit('TypeDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Type Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteType = function (typeObj) {
                    swal({
                            title: "Delete the selected Type?",
                            text: "You are about to permanently delete the selected Type.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    typeId: typeObj.id
                                };
                                TypesFactory.deleteIssueType(inputObj)
                                    .then(function () {
                                        $scope.$emit('TypeDeleted', typeObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                            var typesArr = AppInitService.getInitData('issueTypesArr');
                                            _.remove(typesArr, function (n) {
                                                return n.id === typeObj.id;
                                            });
                                            AppInitService.fnUpdateIssueTypesData(typesArr);
                                        }
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.typeObj = angular.copy($scope.resetTypeObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitType = function () {
                    $scope.isTypeDetailsLoaded = false;
                    $scope.typeId = $scope.typeObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('projectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.typeObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetType($scope.typeId);
                    } else {
                        ProjectFactory.describeProject({projectId: $scope.typeObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.typeId) {
                                $scope.fnGetType($scope.typeId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitType();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnCloneTypeInfo = function (typeObj) {
                    $scope.fnCallCloneObj({data: typeObj});
                };

                var typeInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.types') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteType($scope.typeObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var typeInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.types') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', typeInfoKeyDownEventHandler);
                document.addEventListener('keyup', typeInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', typeInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', typeInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createTypeCtrl',
            function ($scope, $timeout, $state, DB, TypesFactory, ProjectFactory, AppInitService, QueryFactory, amaran) {

                var vm = this;
                vm.title = "Create Type";
                vm.isTypeCreating = false;
                vm.isTypeCreateLoaded = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.newTypeObj = {
                    name: '',
                    description: '',
                    color: '',
                    projectId: ''
                };
                vm.isDisplayMiniColors = false;
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.suggestedTypesArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                vm.fnAssignSuggestedColor = function (suggestedColor) {
                    vm.newTypeObj.color = suggestedColor;
                };

                vm.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                vm.fnDisplayMiniColors = function () {
                    vm.isDisplayMiniColors = true;
                };

                vm.fnCreateNewPriority = function (newTypeObj) {
                    vm.isTypeCreating = true;
                    var inputObj = {
                        body: newTypeObj
                    };
                    TypesFactory.createIssueType(inputObj)
                        .then(function (resObj) {
                            vm.isTypeCreating = false;
                            $scope.types.fnHideShowCreateForm(); //parent function

                            vm.newTypeObj = {
                                name: '',
                                description: '',
                                color: '',
                                projectId: ''
                            };
                            if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var typesArr = AppInitService.getInitData('issueTypesArr');
                                typesArr.push(resObj);
                                AppInitService.fnUpdateIssueTypesData(typesArr);
                            }
                            vm.isTypeCreating = false;
                            $timeout(function () { // set table height
                                $scope.types.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('typeAdded', resObj.id);
                            $scope.types.totalItems = $scope.types.totalItems + 1;
                            $scope.types.typeArr.push(resObj);
                            $scope.types.fnReload();
                            amaran.success("Type created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTypeCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.fnCheckCloneType();
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newTypeObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newTypeObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                vm.fnManageProject = function () {
                    $state.go("main.project");
                };
                /*Project: END*/

                vm.fnCheckCloneType = function () {
                    if (DB.fnGet('ClonedTypeObj')) {
                        var cloneTypeObj = _.cloneDeepWith(DB.fnGet('ClonedTypeObj'));
                        var inputObj = {
                            typeId: cloneTypeObj.id
                        };
                        TypesFactory.describeIssueType(inputObj)
                            .then(function (response) {
                                cloneTypeObj = _.cloneDeepWith(DB.fnGet('ClonedTypeObj'));
                                var formData = {};
                                if (response.form) {
                                    formData = response.form;
                                    formData.values = {};
                                }
                                var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                                    return projectObj.id === cloneTypeObj.projectId;
                                });
                                if (findIndex !== -1) {
                                    vm.selectedProject = _.cloneDeepWith(vm.projectsArr[findIndex]);
                                    vm.fnGetProjectInfo(vm.projectsArr[findIndex]);
                                    $timeout(function () {
                                        vm.fnOnToggleProject(false);
                                    })
                                }
                                vm.newTypeObj = {
                                    name: cloneTypeObj.name,
                                    description: cloneTypeObj.description,
                                    color: cloneTypeObj.color,
                                    projectId: cloneTypeObj.projectId,
                                    form: formData
                                };
                                DB.fnRemove('ClonedTypeObj');
                                vm.isTypeCreateLoaded = true;
                            }, function () {
                                vm.isTypeCreateLoaded = true;
                            });
                    } else {
                        vm.isTypeCreateLoaded = true;
                    }
                };

                vm.fnInitCreateType = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.fnCheckCloneType();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('stateInfo', fnStateInfo)

    /** @ngInject */
    function fnStateInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, AppInitService, TrackerStateFactory, ProjectFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/state/stateInfo/stateInfo.html',
            scope: {
                stateObj: '=',
                userPermissionsObj: '=',
                fnCallCloneObj: '&'
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.selectedProject = {};
                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/state/stateInfo/stateSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/state/stateInfo/stateSteps/stateSupplemental/stateSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                $scope.isDisplayMiniColors = false;

                $scope.suggestedStatesArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                $scope.fnAssignSuggestedColor = function (suggesstedColor) {
                    $scope.stateObj.color = suggesstedColor;
                };

                $scope.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                $scope.fnDisplayMiniColors = function () {
                    $scope.isDisplayMiniColors = true;
                };

                $scope.fnGetState = function (stateId) {
                    var inputObj = {
                        stateId: stateId
                    };
                    TrackerStateFactory.describeIssueState(inputObj)
                        .then(function (response) {
                            $scope.stateObj = response;
                            $scope.resetStateObj = angular.copy($scope.stateObj);
                            if (angular.isUndefined($scope.stateObj.description)) {
                                $scope.stateObj.description = '';
                            }
                            $scope.isStateDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isStateDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.state', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateStateDetails = function (stateObj) {
                    var inputObj = {
                        body: {},
                        stateId: stateObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(stateObj.description)) {
                        stateObj.description = '';
                    }
                    inputObj.body = {
                        name: stateObj.name,
                        description: stateObj.description,
                        color: stateObj.color
                    };
                    TrackerStateFactory.updateIssueState(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var stateArr = AppInitService.getInitData('issueStatesArr');
                            var index = _.findIndex(stateArr, {id: response.id});
                            if (index !== -1) {
                                stateArr[index].name = response.name;
                                stateArr[index].description = response.description;
                                stateArr[index].color = response.color;
                                AppInitService.fnUpdateIssueStatesData(stateArr);
                            }
                            $scope.$emit('StateDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("State Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteState = function (stateObj) {
                    swal({
                            title: "Delete the selected State?",
                            text: "You are about to permanently delete the selected State.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    stateId: stateObj.id
                                };
                                TrackerStateFactory.deleteIssueState(inputObj)
                                    .then(function () {
                                        $scope.$emit('StateDeleted', stateObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        var stateArr = AppInitService.getInitData('issueStatesArr');
                                        _.remove(stateArr, function (n) {
                                            return n.id === stateObj.id;
                                        });
                                        AppInitService.fnUpdateIssueStatesData(stateArr);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.stateObj = angular.copy($scope.resetStateObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitState = function () {
                    $scope.isStateDetailsLoaded = false;
                    $scope.stateId = $scope.stateObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('projectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.stateObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetState($scope.stateId);
                    } else {
                        ProjectFactory.describeProject({projectId: $scope.stateObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.stateId) {
                                $scope.fnGetState($scope.stateId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitState();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnCloneStateInfo = function (stateObj) {
                    $scope.fnCallCloneObj({data: stateObj});
                };

                var stateInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.state') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteState($scope.stateObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var stateInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.state') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', stateInfoKeyDownEventHandler);
                document.addEventListener('keyup', stateInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', stateInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', stateInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createStateCtrl',
            function ($scope, $timeout, $state, DB, TrackerStateFactory,
                      ProjectFactory, AppInitService, QueryFactory, amaran) {

                var vm = this;
                vm.title = "Create State";
                vm.isStateCreating = false;
                vm.isStateCreateLoaded = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.newStateObj = {
                    name: '',
                    description: '',
                    color: '',
                    projectId: '',
                    resolved: false,
                    archived: false
                };
                vm.isDisplayMiniColors = false;
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.suggestedStatesArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                vm.fnAssignSuggestedColor = function (suggesstedColor) {
                    vm.newStateObj.color = suggesstedColor;
                };

                vm.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                vm.fnDisplayMiniColors = function () {
                    vm.isDisplayMiniColors = true;
                };

                vm.fnCreateNewState = function (newStateObj) {
                    vm.isStateCreating = true;
                    var inputObj = {
                        body: newStateObj
                    };
                    TrackerStateFactory.createIssueState(inputObj)
                        .then(function (response) {
                            // $scope.State.fnHideShowCreateForm(); //parent function
                            vm.newStateObj = {
                                name: '',
                                description: '',
                                color: '',
                                projectId: '',
                                resolved: false,
                                archived: false
                            };
                            if(!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var stateArr = AppInitService.getInitData('issueStatesArr');
                                stateArr.push(response);
                                AppInitService.fnUpdateIssueStatesData(stateArr);
                            }
                            vm.isStateCreating = false;
                            $timeout(function () { // set table height
                                $scope.state.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('stateAdded', response.id);
                            $scope.state.totalItems = $scope.state.totalItems + 1;
                            $scope.state.statesArr.push(response);
                            $scope.state.fnReload();
                            amaran.success("State created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isStateCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.fnCheckCloneState();
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newStateObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newStateObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                vm.fnManageProject = function () {
                    $state.go("main.project");
                };
                /*Project: END*/

                vm.fnCheckCloneState = function () {
                    if (DB.fnGet('ClonedStateObj')) {
                        var cloneStateObj = DB.fnGet('ClonedStateObj');
                        var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                            return projectObj.id === cloneStateObj.projectId;
                        });
                        if (findIndex !== -1) {
                            vm.selectedProject = _.cloneDeepWith(vm.projectsArr[findIndex]);
                            vm.fnGetProjectInfo(vm.projectsArr[findIndex]);
                            $timeout(function () {
                                vm.fnOnToggleProject(false);
                            })
                        }
                        vm.newStateObj = {
                            name: cloneStateObj.name,
                            description: cloneStateObj.description,
                            color: cloneStateObj.color,
                            projectId: cloneStateObj.projectId,
                            resolved: false,
                            archived: false
                        };
                        DB.fnRemove('ClonedStateObj');
                    }
                    vm.isStateCreateLoaded = true;
                };

                vm.fnInitCreateState = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.fnCheckCloneState();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }

                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('trackerScriptInfo', fnTrackerScriptInfo)

    /** @ngInject */
    function fnTrackerScriptInfo($http, $window, $state, $timeout, $base64, TrackerScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/script/scriptInfo/scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4', 'tracker_S4', 'email_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/script/scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType
                    };
                    TrackerScriptFactory.describeScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            $scope.scriptObj.name = toUpper(scriptType.replace(/_/g, " "));
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.tracker_scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    $scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        $scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function () {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        }
                    };
                    TrackerScriptFactory.updateScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType
                                };
                                TrackerScriptFactory.resetScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            $scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('projectScriptInfo', fnProjectScriptInfo)

    /** @ngInject */
    function fnProjectScriptInfo($http, $window, $state, $timeout, $base64, TrackerScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/project_script/project_scriptInfo/project_scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4', 'tracker_S4', 'email_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/project_script/project_scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType,
                        projectId: $stateParams.selectedProject
                    };
                    TrackerScriptFactory.describeProjectScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            $scope.scriptObj.name = toUpper(scriptType.replace(/_/g, " "));
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.project_scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    $scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        $scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function (isCascade, unselectedProjectsList) {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        },
                        projectId: $stateParams.selectedProject,
                        cascade: isCascade,
                        exclude: unselectedProjectsList
                    };
                    TrackerScriptFactory.updateProjectScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType,
                                    projectId: $stateParams.selectedProject
                                };
                                TrackerScriptFactory.resetProjectScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            $scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenScriptModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/project_script/modal/trackerProjectScriptModal.html',
                        size: 'lg',
                        controller: 'trackerProjectScriptModalCtrl as trackerProjectScript',
                        windowClass: 'modal-height100',
                        resolve: {
                            scriptObj: function () {
                                return _.cloneDeepWith($scope.scriptObj);
                            },
                            projectObj: function () {
                                return {
                                    id: $stateParams.selectedProject,
                                    name: $scope.selectedProjectName
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        $scope.fnSaveScript(true, response);
                    }, function () {
                    });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($stateParams.name) {
                        $scope.selectedProjectName = $stateParams.name
                    }
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('trackerProjectScriptModalCtrl',
            function ($window, $timeout, $uibModalInstance, amaran, scriptObj, projectObj, ProjectFactory) {
                var vm = this;
                vm.selectedScriptObj = scriptObj;
                vm.selectedProjectObj = projectObj;
                vm.selectedProjectObj.isCheck = true;
                vm.selectedProjectRelationships = {};
                vm.isProjectRelationshipsDataLoading = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnConfirm = function () {
                    var unselectedProjects = '';
                    _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                        if (!downstreamProjectObj.isCheck) {
                            if (unselectedProjects !== '') {
                                unselectedProjects += ", " + downstreamProjectObj.id;
                            } else {
                                unselectedProjects = downstreamProjectObj.id;
                            }
                        }
                    })
                    $uibModalInstance.close(unselectedProjects);
                }

                vm.fnInitTrackerProjectScriptModal = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    var inputObj = {
                        projectId: vm.selectedProjectObj.id
                    };
                    ProjectFactory.describeProjectRelationships(inputObj)
                        .then(function (response) {
                            vm.selectedProjectRelationships = _.cloneDeepWith(response);
                            _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                                downstreamProjectObj.isCheck = true;
                            })
                            vm.isProjectRelationshipsDataLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectRelationshipsDataLoading = false;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('projectEmailTemplateInfo', fnProjectEmailTemplateInfo)

    /** @ngInject */
    function fnProjectEmailTemplateInfo($http, $window, $state, $timeout, $base64, TrackerEmailTemplateFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/project_emailTemplate/project_emailTemplateInfo/project_emailTemplateInfo.html',
            scope: {
                emailTemplateObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isShowPrviewRenderedHTML = true;
                $scope.isEmailTemplateLoading = true;
                $scope.emailTemplates = {};
                $scope.activeTabIndex = 1;
                $scope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                $scope.isEmailValid = true;
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    htmlMode: true,
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        };
                        $scope.setLine = function (errors) {
                            $timeout(function () {
                                _cm.clearGutter('gutter-error');
                                if (errors && errors.length) {
                                    for (var i = 0; i < errors.length; i++) {
                                        var error = errors[i];
                                        var errorLine = error.line - 1;
                                        var marker = document.createElement("div");
                                        marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                        marker.setAttribute('data-toggle', 'tooltip');
                                        marker.setAttribute('data-placement', 'auto');
                                        marker.setAttribute('title', error.message);
                                        _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                                    }
                                }
                            }, 0)

                        };
                        _cm.on("changes", function () {
                            $scope.isValidTemplate = false;
                        });
                        $scope.getString = function () {
                            return _cm.getSelection();
                        };

                        $scope.replaceString = function (str) {
                            return _cm.replaceSelection(str);
                        };

                    }
                };
                $scope.isValidTemplate = true;
                $scope.emailTemplateType = "";
                $scope.isShowVariables = false;

                $scope.tabs = [
                    {
                        title: 'Template',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/project_emailTemplate/project_emailTemplateInfo/project_emailTemplateSteps/details.html'
                    }
                ];

                $scope.bold = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<b>' + string + '</b>');
                };

                $scope.italic = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<i>' + string + '</i>');
                };

                $scope.underline = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<u>' + string + '</u>');
                };

                $scope.strike = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<span style="text-decoration: line-through;">' + string + '</span>');
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetEmailTemplateData = function (emailTemplateType) {
                    $scope.isEmailTemplateDataLoading = true;
                    var inputObj = {
                        type: emailTemplateType,
                        projectId: $stateParams.selectedProject
                    };
                    TrackerEmailTemplateFactory.describeEmailTemplate(inputObj)
                        .then(function (response) {
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper(emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.isEmailTemplateDataLoading = false;
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEmailTemplateDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.project_emailTemplate', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        var emailTemplateToolbar = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".email-template-toolbar")[0]) ? angular.element(".email-template-toolbar")[0].offsetHeight : 0;
                        angular.element(".email-body").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".email-template").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".tabContent1").css('height', (finalHeight - (42 + aboutText)) + 'px');
                        angular.element(".emailConfigurationInfo").css('height', (finalHeight - (42 + aboutText)) + 'px');
                    }
                };

                $scope.fnViewRenderedHTML = function (isRender) {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    if (isRender) {
                        $scope.isShowPrviewRenderedHTML = true;
                    } else {
                        $scope.isShowPrviewRenderedHTML = !$scope.isShowPrviewRenderedHTML;
                    }
                    $timeout(function () {
                        if ($scope.isShowPrviewRenderedHTML) {
                            var string = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isTemplateLoading = true;
                            $http({
                                method: 'POST',
                                url: 'https://api.mjml.io/v1/render',
                                config: {},
                                data: {
                                    "mjml": string
                                }
                            }).success(function (res) {
                                $scope.isTemplateLoading = false;
                                if (res.errors && res.errors.length) {
                                    $scope.isValidTemplate = false;
                                    $scope.setLine(_.cloneDeepWith(res.errors));
                                } else {
                                    $scope.isValidTemplate = true;
                                    //$scope.setLine([]);
                                }
                                $timeout(function () {
                                    var element = document.getElementById('htmlParse');
                                    element.innerHTML = res.html; //eslint-disable-line
                                });
                                $timeout(function () {
                                    $scope.fnSetTabHeight();
                                });
                            });
                        } else {
                            if ($scope.isTemplateEditable) {
                                $timeout(function () {
                                    $scope.readOnlyFalse();
                                    $scope.fnValidateTemplate();
                                });
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.modeChanged();
                            });
                        }
                    });
                };

                $scope.fnCheckEmail = function () {
                    var patt = new RegExp($scope.emailPattern);
                    $scope.isEmailValid = patt.test($scope.templateConfigObj.emailFrom);
                };

                $scope.fnChangeToEditable = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        $timeout(function () {
                            $scope.resetHtmlbody = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isShowPrviewRenderedHTML = false;
                            $scope.isTemplateEditable = true;
                            $timeout(function () {
                                $scope.readOnlyFalse();
                                $scope.fnValidateTemplate();
                            });
                        })
                    } else {
                        $timeout(function () {
                            $scope.fnViewRenderedHTML(true);
                            $scope.templateConfigObj.mjmlBody = _.cloneDeepWith($scope.resetHtmlbody);
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.ReadOnlyTrue();
                            });
                        });
                    }
                };

                $scope.fnValidateTemplate = function () {
                    $scope.isValidatingTemplate = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        $scope.isValidatingTemplate = false;
                        if (res.errors && res.errors.length) {
                            $scope.isValidTemplate = false;
                            $scope.setLine(_.cloneDeepWith(res.errors));
                        } else {
                            $scope.isValidTemplate = true;
                            $scope.setLine([]);
                        }
                    });

                };

                $scope.fnSaveEmailTemplate = function (isCascade, unselectedProjectsList) {
                    $scope.isSaveChanges = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        var input = {
                            type: $scope.emailTemplateObj.type,
                            body: {},
                            projectId: $stateParams.selectedProject,
                            cascade: isCascade,
                            exclude: unselectedProjectsList
                        };
                        input.body = {
                            "templateType": $scope.emailTemplateObj.templateType,
                            "context": $scope.emailTemplateObj.context,
                            "body": res.mjml,
                            "from": $scope.templateConfigObj.emailFrom,
                            "subject": $scope.templateConfigObj.emailSubject,
                            "variables": $scope.emailTemplateObj.variables
                        };
                        TrackerEmailTemplateFactory.updateEmailTemplate(input).then(function (response) {
                            $scope.isSaveChanges = false;
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = $scope.emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.fnViewRenderedHTML(true);
                                });
                            });
                            amaran.success("Template update successfully");
                        }, function () {
                            $scope.isSaveChanges = false;
                            $scope.templateConfigObj = {
                                emailFrom: $scope.emailTemplateObj.from,
                                mjmlBody: $scope.emailTemplateObj.body,
                                emailSubject: $scope.emailTemplateObj.subject,
                                emailVariables: $scope.emailTemplateObj.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                        });
                    });
                };

                $scope.fnResetEmailTemplate = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this email template back to its original template. All the current email template settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.emailTemplateObj.type,
                                    projectId: $stateParams.selectedProject
                                };
                                TrackerEmailTemplateFactory.resetEmailTemplate(inputObj)
                                    .then(function (response) {
                                        $scope.emailTemplateObj = _.cloneDeepWith(response);
                                        $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                                        $scope.emailTemplateObj.type = $scope.emailTemplateType;
                                        $scope.templateConfigObj = {
                                            emailFrom: response.from,
                                            mjmlBody: response.body,
                                            emailSubject: response.subject,
                                            emailVariables: response.variables
                                        };
                                        $scope.isValidTemplate = true;
                                        $scope.isTemplateEditable = false;
                                        $scope.isShowVariables = false;
                                        $timeout(function () {
                                            $timeout(function () {
                                                $scope.fnViewRenderedHTML(true);
                                            });
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenTemplateModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/project_emailTemplate/modal/trackerProjectTemplateModal.html',
                        size: 'lg',
                        controller: 'trackerProjectTemplateModalCtrl as trackerProjectTemplate',
                        windowClass: 'modal-height100',
                        resolve: {
                            templateObj: function () {
                                return _.cloneDeepWith($scope.emailTemplateObj);
                            },
                            projectObj: function () {
                                return {
                                    id: $stateParams.selectedProject,
                                    name: $scope.selectedProjectName
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        $scope.fnSaveEmailTemplate(true, response);
                    }, function () {
                    });
                };

                $scope.fnInitEmailTemplate = function () {
                    $scope.emailTemplateType = _.cloneDeepWith($scope.emailTemplateObj.type);
                    if ($stateParams.name) {
                        $scope.selectedProjectName = $stateParams.name
                    }
                    if ($scope.emailTemplateObj.type) {
                        $scope.fnGetEmailTemplateData($scope.emailTemplateObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('trackerProjectTemplateModalCtrl',
            function ($window, $timeout, $uibModalInstance, amaran, templateObj, projectObj, ProjectFactory) {
                var vm = this;
                vm.selectedTemplateObj = templateObj;
                vm.selectedProjectObj = projectObj;
                vm.selectedProjectObj.isCheck = true;
                vm.selectedProjectRelationships = {};
                vm.isProjectRelationshipsDataLoading = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnConfirm = function () {
                    var unselectedProjects = '';
                    _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                        if (!downstreamProjectObj.isCheck) {
                            if (unselectedProjects !== '') {
                                unselectedProjects += ", " + downstreamProjectObj.id;
                            } else {
                                unselectedProjects = downstreamProjectObj.id;
                            }
                        }
                    })
                    $uibModalInstance.close(unselectedProjects);
                }

                vm.fnInitTrackerProjectTemplateModal = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    var inputObj = {
                        projectId: vm.selectedProjectObj.id
                    };
                    ProjectFactory.describeProjectRelationships(inputObj)
                        .then(function (response) {
                            vm.selectedProjectRelationships = _.cloneDeepWith(response);
                            _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                                downstreamProjectObj.isCheck = true;
                            })
                            vm.isProjectRelationshipsDataLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectRelationshipsDataLoading = false;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('projectInfo', fnProjectInfo)

    /** @ngInject */
    function fnProjectInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, AppInitService, ProjectFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/project/projectInfo/projectInfo.html',
            scope: {
                projectObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/details.html'
                    },
                    {
                        title: 'Teams',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectTeam/projectTeam.html'
                    },
                    {
                        title: 'S4',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectScripts/projectScripts.html'
                    },
                    {
                        title: 'Email Template',
                        tabIndex: 4,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectEmail/projectEmail.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectSupplemental/projectSupplemental.html'
                    }
                ];
                /*
                {
                        title: 'S4',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectScripts/projectScripts.html'
                    },
                    {
                        title: 'Email Template',
                        tabIndex: 4,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectEmail/projectEmail.html'
                    }
                */
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetProject = function (projectId) {
                    var inputObj = {
                        projectId: projectId
                    };
                    ProjectFactory.describeProject(inputObj)
                        .then(function (response) {
                            $scope.projectObj = response;
                            $scope.resetProjectObj = angular.copy($scope.projectObj);
                            if (angular.isUndefined($scope.projectObj.description)) {
                                $scope.projectObj.description = '';
                            }
                            $scope.isProjectDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isProjectDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.project', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateProjectDetails = function (projectObj) {
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(projectObj.description)) {
                        projectObj.description = '';
                    }
                    inputObj.body = {
                        name: projectObj.name,
                        description: projectObj.description
                    };
                    ProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var projectArr = AppInitService.getInitData('projectsArr');
                                var index = _.findIndex(projectArr, {id: response.id});
                                if (index !== -1) {
                                    projectArr[index].name = response.name;
                                    projectArr[index].description = response.description;
                                    AppInitService.fnUpdateProjectData(projectArr);
                                }
                            }
                            $scope.$emit('ProjectDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteProject = function (projectObj) {
                    swal({
                            title: "Delete the selected Project?",
                            text: "You are about to permanently delete the selected Project.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    projectId: projectObj.id
                                };
                                ProjectFactory.deleteProject(inputObj)
                                    .then(function () {
                                        $scope.$emit('ProjectDeleted', projectObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        var projectArr = AppInitService.getInitData('projectsArr');
                                        _.remove(projectArr, function (n) {
                                            return n.id === projectObj.id;
                                        });
                                        AppInitService.fnUpdateProjectData(projectArr);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.projectObj = angular.copy($scope.resetProjectObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitProject = function () {
                    $scope.isProjectDetailsLoaded = false;
                    $scope.projectId = $scope.projectObj.id;
                    if ($scope.projectObj.parentProjectId && $scope.projectObj.parentProjectId !== "") {
                        ProjectFactory.describeProject({projectId: $scope.projectObj.parentProjectId})
                            .then(function (response) {
                                $scope.selectedProject = response;
                                if ($scope.projectId) {
                                    $scope.fnGetProject($scope.projectId);
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        if ($scope.projectId) {
                            $scope.fnGetProject($scope.projectId);
                        }
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitProject();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var projectInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteProject($scope.projectObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var projectInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectInfoKeyDownEventHandler);
                document.addEventListener('keyup', projectInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', projectInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('priorityInfo', fnPriorityInfo)

    /** @ngInject */
    function fnPriorityInfo($window, $state, $stateParams, $timeout, AppInitService, microSpinner, swal, amaran, DB,
                            ProjectFactory, PriorityFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/priorities/prioritiesInfo/priorityInfo.html',
            scope: {
                priorityObj: '=',
                userPermissionsObj: '=',
                fnCallCloneObj: "&"
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.selectedProject = {};

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/priorities/prioritiesInfo/prioritySteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/priorities/prioritiesInfo/prioritySteps/prioritySupplemental/prioritySupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                $scope.isDisplayMiniColors = false;

                $scope.suggestedPrioritiesArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                $scope.fnAssignSuggestedColor = function (suggestedColor) {
                    $scope.priorityObj.color = suggestedColor;
                };

                $scope.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                $scope.fnDisplayMiniColors = function () {
                    $scope.isDisplayMiniColors = true;
                };

                $scope.fnGetPriority = function (priorityId) {
                    var inputObj = {
                        priorityId: priorityId
                    };
                    PriorityFactory.describeIssuePriority(inputObj)
                        .then(function (response) {
                            $scope.priorityObj = response;
                            $scope.resetPriorityObj = angular.copy($scope.priorityObj);
                            if (angular.isUndefined($scope.priorityObj.description)) {
                                $scope.priorityObj.description = '';
                            }
                            $scope.isPriorityDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isPriorityDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.priorities', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdatePriorityDetails = function (priorityObj) {
                    var inputObj = {
                        body: {},
                        priorityId: priorityObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(priorityObj.description)) {
                        priorityObj.description = '';
                    }
                    inputObj.body = {
                        name: priorityObj.name,
                        description: priorityObj.description,
                        color: priorityObj.color,
                        projectId: priorityObj.projectId,
                        order: priorityObj.order
                    };
                    PriorityFactory.updateIssuePriority(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var priorityArr = AppInitService.getInitData('issuePrioritiesArr');
                            var index = _.findIndex(priorityArr, {id: response.id});
                            if (index !== -1) {
                                priorityArr[index].name = response.name;
                                priorityArr[index].description = response.description;
                                priorityArr[index].color = response.color;
                                priorityArr[index].projectId = response.projectId;
                                AppInitService.fnUpdateIssuePrioritiesData(priorityArr);
                            }
                            $scope.$emit('PriorityDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Priority Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeletePriority = function (priorityObj) {
                    swal({
                            title: "Delete the selected Priority?",
                            text: "You are about to permanently delete the selected Priority.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    priorityId: priorityObj.id
                                };
                                PriorityFactory.deleteIssuePriority(inputObj)
                                    .then(function () {
                                        $scope.$emit('PriorityDeleted', priorityObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        var priorityArr = AppInitService.getInitData('issuePrioritiesArr');
                                        _.remove(priorityArr, function (n) {
                                            return n.id === priorityObj.id;
                                        });
                                        AppInitService.fnUpdateIssuePrioritiesData(priorityArr);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.priorityObj = angular.copy($scope.resetPriorityObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnClonePriorityInfo = function (priorityObj) {
                    $scope.fnCallCloneObj({data: priorityObj});
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitPriority = function () {
                    $scope.isPriorityDetailsLoaded = false;
                    $scope.priorityId = $scope.priorityObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('projectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.priorityObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetPriority($scope.priorityId);
                    } else {
                        ProjectFactory.describeProject({projectId: $scope.priorityObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.priorityId) {
                                $scope.fnGetPriority($scope.priorityId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitPriority();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var priorityInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.priorities') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeletePriority($scope.priorityObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var priorityInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.priorities') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', priorityInfoKeyDownEventHandler);
                document.addEventListener('keyup', priorityInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', priorityInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', priorityInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createProjectCtrl',
            function ($scope, $window, $uibModal, DB, amaran, ProjectFactory, $timeout, AppInitService, QueryFactory) {
                var vm = this;
                vm.title = "Create Project";
                vm.isProjectCreateLoaded = false;
                vm.newProjectObj = {
                    name: '',
                    description: '',
                    parentProjectId: ''
                };
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.fnCreateNewProject = function (newProjectObj) {
                    vm.isProjectCreating = true;
                    var inputObj = {
                        body: newProjectObj
                    };
                    ProjectFactory.createProject(inputObj)
                        .then(function (resObj) {
                            vm.isProjectCreating = false;
                            vm.newProjectObj = {
                                name: '',
                                description: '',
                                parentProjectId: ''
                            };
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var projectArr = AppInitService.getInitData('projectsArr');
                                projectArr.push(resObj);
                                AppInitService.fnUpdateProjectData(projectArr);
                            }
                            $timeout(function () {
                                $scope.project.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('projectAdded', resObj.id);
                            $scope.project.totalItems = $scope.projects.totalItems + 1;
                            $scope.project.projectArr.push(resObj);
                            $scope.project.fnReload();
                            amaran.success("Project created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newProjectObj.parentProjectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newProjectObj.parentProjectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnInitCreateProject = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.isProjectCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createPriorityCtrl',
            function ($scope, $timeout, $state, PriorityFactory, DB,
                      ProjectFactory, AppInitService, QueryFactory, amaran) {

                var vm = this;
                vm.title = "Create Priority";
                vm.isPriorityCreating = false;
                vm.isPriorityCreateLoaded = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.newPriorityObj = {
                    name: '',
                    description: '',
                    color: '',
                    projectId: '',
                    order: ''
                };
                vm.selectedProject = {};
                vm.isDisplayMiniColors = false;

                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.suggestedLabelsArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                vm.fnAssignSuggestedColor = function (suggestedColor) {
                    vm.newPriorityObj.color = suggestedColor;
                };

                vm.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                vm.fnDisplayMiniColors = function () {
                    vm.isDisplayMiniColors = true;
                };

                vm.fnCreateNewPriority = function (newPriorityObj) {
                    vm.isPriorityCreating = true;
                    var inputObj = {
                        body: newPriorityObj
                    };
                    PriorityFactory.createIssuePriority(inputObj)
                        .then(function (resObj) {
                            vm.isPriorityCreating = false;
                            $scope.priorities.fnHideShowCreateForm(); //parent function

                            vm.newPriorityObj = {
                                name: '',
                                description: '',
                                color: '',
                                projectId: ''
                            };
                            if(!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var priorityArr = AppInitService.getInitData('issuePrioritiesArr');
                                priorityArr.push(resObj);
                                AppInitService.fnUpdateIssuePrioritiesData(priorityArr);
                            }
                            vm.isPriorityCreating = false;
                            $timeout(function () { // set table height
                                $scope.priorities.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('priorityAdded', resObj.id);
                            $scope.priorities.totalItems = $scope.priorities.totalItems + 1;
                            $scope.priorities.priorityArr.push(resObj);
                            $scope.priorities.fnReload();
                            amaran.success("Priority created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isPriorityCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.fnCheckClonePriority();
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newPriorityObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newPriorityObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                vm.fnManageProject = function () {
                    $state.go("main.project");
                };
                /*Project: END*/

                vm.fnCheckClonePriority = function () {
                    if (DB.fnGet('ClonedPriorityObj')) {
                        var clonePriorityObj = DB.fnGet('ClonedPriorityObj');
                        var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                            return projectObj.id === clonePriorityObj.projectId;
                        });
                        if (findIndex !== -1) {
                            vm.selectedProject = _.cloneDeepWith(vm.projectsArr[findIndex]);
                            vm.fnGetProjectInfo(vm.projectsArr[findIndex]);
                            $timeout(function () {
                                vm.fnOnToggleProject(false);
                            })
                        }
                        vm.newPriorityObj = {
                            name: clonePriorityObj.name,
                            description: clonePriorityObj.description,
                            color: clonePriorityObj.color,
                            projectId: clonePriorityObj.projectId
                        };
                        DB.fnRemove('ClonedPriorityObj');
                    }
                    vm.isPriorityCreateLoaded = true;
                };

                vm.fnInitCreatePriority = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.fnCheckClonePriority();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('labelInfo', fnLabelInfo)

    /** @ngInject */
    function fnLabelInfo($window, $state, $stateParams, $timeout, DB, microSpinner, swal, amaran, LabelFactory, AppInitService, ProjectFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/label/labelInfo/labelInfo.html',
            scope: {
                labelObj: '=',
                userPermissionsObj: '=',
                fnCallCloneObj: "&"
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/label/labelInfo/labelSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/label/labelInfo/labelSteps/labelSupplemental/labelSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                $scope.selectedProject = {};
                $scope.isDisplayMiniColors = false;

                $scope.suggestedLabelsArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                $scope.fnAssignSuggestedColor = function (suggesstedColor) {
                    $scope.labelObj.color = suggesstedColor;
                };

                $scope.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                $scope.fnDisplayMiniColors = function () {
                    $scope.isDisplayMiniColors = true;
                };

                $scope.fnGetLabel = function (labelId) {
                    var inputObj = {
                        labelId: labelId
                    };
                    LabelFactory.describeIssueLabel(inputObj)
                        .then(function (response) {
                            $scope.labelObj = response;
                            $scope.resetLabelObj = angular.copy($scope.labelObj);
                            if (angular.isUndefined($scope.labelObj.description)) {
                                $scope.labelObj.description = '';
                            }
                            $scope.isLabelDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isLabelDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.label', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateLabelDetails = function (labelObj) {
                    var inputObj = {
                        body: {},
                        labelId: labelObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(labelObj.description)) {
                        labelObj.description = '';
                    }
                    inputObj.body = {
                        name: labelObj.name,
                        description: labelObj.description,
                        color: labelObj.color
                    };
                    LabelFactory.updateIssueLabel(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('LabelDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Label Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteLabel = function (labelObj) {
                    swal({
                            title: "Delete the selected Label?",
                            text: "You are about to permanently delete the selected Label.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    labelId: labelObj.id
                                };
                                LabelFactory.deleteIssueLabel(inputObj)
                                    .then(function () {
                                        $scope.$emit('LabelDeleted', labelObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.labelObj = angular.copy($scope.resetLabelObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitLabel = function () {
                    $scope.isLabelDetailsLoaded = false;
                    $scope.labelId = $scope.labelObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('projectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.labelObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetLabel($scope.labelId);
                    } else {
                        ProjectFactory.describeProject({projectId: $scope.labelObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.labelId) {
                                $scope.fnGetLabel($scope.labelId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitLabel();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnCloneLabelInfo = function (labelObj) {
                    $scope.fnCallCloneObj({data: labelObj});
                };

                var labelInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.label') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteLabel($scope.labelObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var labelInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.label') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', labelInfoKeyDownEventHandler);
                document.addEventListener('keyup', labelInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', labelInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', labelInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createLabelCtrl',
            function ($scope, $timeout, $state, DB, LabelFactory, AppInitService, QueryFactory) {

                var vm = this;
                vm.title = "Create Label";
                vm.isLabelCreating = false;
                vm.isLabelCreateLoaded = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.newLabelObj = {
                    name: '',
                    description: '',
                    color: '',
                    projectId: ''
                };
                vm.selectedProject = {};
                vm.isDisplayMiniColors = false;
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.filterProject = [];
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.suggestedLabelsArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                vm.fnAssignSuggestedColor = function (suggesstedColor) {
                    vm.newLabelObj.color = suggesstedColor;
                };

                vm.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                vm.fnDisplayMiniColors = function () {
                    vm.isDisplayMiniColors = true;
                };

                vm.fnCreateNewLabel = function (newLabelObj) {
                    vm.isLabelCreating = true;
                    var inputObj = {
                        body: newLabelObj
                    };
                    LabelFactory.createIssueLabel(inputObj)
                        .then(function (response) {
                            $scope.label.fnHideShowCreateForm(); //parent function
                            vm.newLabelObj = {
                                name: '',
                                description: '',
                                color: '',
                                projectId: ''
                            };
                            vm.isLabelCreating = false;
                            $timeout(function () { // set table height
                                $scope.label.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('labelAdded');
                            $scope.label.totalItems = $scope.label.totalItems + 1;
                            $scope.label.labelsArr.push(response);
                            $scope.label.fnReload();
                        }, function () {
                            vm.isLabelCreating = false;
                        })
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                                    return projectObj.isCheck;
                                });
                                if (findIndex !== -1) {
                                    vm.newLabelObj.projectId = vm.projectsArr[findIndex].id;
                                    vm.selectedProject = angular.isDefined(vm.projectsArr[findIndex]) ? _.cloneDeepWith(vm.projectsArr[findIndex]) : {};
                                }
                                vm.fnCheckCloneLabel();
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newLabelObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newLabelObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                vm.fnManageProject = function () {
                    $state.go("main.project");
                };
                /*Project: END*/

                vm.fnCheckCloneLabel = function () {
                    if (DB.fnGet('ClonedLabelObj')) {
                        var cloneLabelObj = DB.fnGet('ClonedLabelObj');
                        var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                            return projectObj.id === cloneLabelObj.projectId;
                        });
                        if (findIndex !== -1) {
                            vm.selectedProject = _.cloneDeepWith(vm.projectsArr[findIndex]);
                            vm.fnGetProjectInfo(vm.projectsArr[findIndex]);
                            $timeout(function () {
                                vm.fnOnToggleProject(false);
                            })
                        }
                        vm.newLabelObj = {
                            name: cloneLabelObj.name,
                            description: cloneLabelObj.description,
                            color: cloneLabelObj.color,
                            projectId: cloneLabelObj.projectId
                        };
                        DB.fnRemove('ClonedLabelObj');
                    }
                    vm.isLabelCreateLoaded = true;
                };

                vm.fnInitCreateLabel = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        var findIndex = _.findIndex(vm.projectsArr, function (projectObj) {
                            return projectObj.isCheck;
                        });
                        if (findIndex !== -1) {
                            vm.newLabelObj.projectId = vm.projectsArr[findIndex].id;
                            vm.selectedProject = angular.isDefined(vm.projectsArr[findIndex]) ? _.cloneDeepWith(vm.projectsArr[findIndex]) : {};
                        }
                        vm.fnCheckCloneLabel();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('storageUploadCtrl',
            function ($uibModalInstance, $http, $scope, $window, $timeout, $stateParams, $state, moment, amaran, DB, LastPageService, PermissionsService, PaginationService, UserFactory, FileFactory, FolderFactory, fileData) {
                var vm = this;
                vm.draftName = '';
                vm.fileData = fileData;
                vm.isCreateViewSelected = false;
                vm.isFolderCreating = false;
                vm.archiveFileExtensionArr = ['zip', 'z', 'gz', 'tar', 'rpm', 'rar', 'pkg', 'deb', 'arj', '7z'];
                vm.programmingFileExtensionArr = ['sql', 'xml', 'db', 'apk', 'bat', 'bin', 'com', 'exe', 'jar', 'wsf', 'py', 'asp', 'aspx', 'css', 'htm', 'html', 'js', 'jsp', 'part', 'php', 'rss', 'xhtml', 'c', 'class', 'cpp', 'cs', 'h', 'java', 'sh', 'swift', 'vb', 'less', 'json'];
                vm.audioFileExtensionArr = ['aif', 'cda', 'mid', 'midi', 'mp3', 'mpa', 'ogg', 'wav', 'wma', 'wpl'];
                vm.videoFileExtensionArr = ['3g2', '3gp', 'h264', 'm4v', 'mkv', 'avi', 'flv', 'wmv', 'mov', 'mp4', 'mpg', 'mpeg', 'rm', 'swf', 'vob'];
                vm.imageFileExtensionArr = ['ai', 'bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'ps', 'psd', 'svg', 'tif', 'tiff'];
                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "Path",
                        fieldName: "path"
                    }
                ];
                vm.filterQuery = [];

                //Listener Variables
                vm.isFoldersLoading = false;
                vm.isFileUploading = false;
                vm.isShowFileDetails = false;
                vm.folderArr = [];
                vm.selectedFoldersArr = [];
                vm.selectedFolderObj = null;
                vm.selectedFunction = '';
                vm.breadcrumbArray = [];
                var loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');

                //pagination variables
                vm.perPage = loginUser.data ? (loginUser.data.perPage ? parseInt(loginUser.data.perPage[0]) : 20) : 20;
                vm.maxSize = 10;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.currentPath = '/';
                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isFoldersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "SEARCH",
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "LIST",
                            path: vm.currentPath
                        };
                    }
                    vm.selectedFunction = inputObj.function;
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.selectedFolderObj = null;
                    vm.isAllChecked = false;
                    if (vm.contentPermissionObj.List) {
                        vm.fnGetFolders(inputObj);
                    } else {
                        vm.folderArr = [];
                        vm.isFoldersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 100);
                        angular.element("#storageUploadModal tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 80);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetFolders = function (inputObj) {
                    FolderFactory.getContents(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.contents;
                            res.map(function (obj) {
                                if (obj.path.slice(-1) === "/") {
                                    var folderName = obj.path.split('/');
                                    obj.name = folderName[folderName.length - 2];
                                    obj.icon = "fa-folder-open";
                                    obj.lastUpdate = "-";
                                    obj.fileSize = "-";
                                    obj.type = "folder";
                                } else {
                                    var fileName = obj.path.split('/');
                                    obj.name = fileName[fileName.length - 1];
                                    obj.icon = vm.fnDetermineFileIcon(obj);
                                    obj.lastUpdate = moment(obj.lastModified).utc()._d;
                                    obj.fileSize = bytesToSize(obj.size);
                                    obj.type = "file";
                                }
                            });
                            vm.folderArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckHeader = function (folderObj) {
                    angular.forEach(vm.folderArr, function (obj) {
                        obj.isCheck = false;
                    });
                    folderObj.isCheck = true;
                    vm.selectedFolderObj = folderObj;
                };

                vm.fnGetFolder = function (folderObj) {
                    if (folderObj.type === "file") {
                        vm.fnCheckUncheckHeader(folderObj);
                    } else {
                        vm.breadcrumbArray.push(folderObj.name);
                        vm.currentPath = vm.currentPath + folderObj.name + "/";
                        $timeout(function () {
                            vm.fnReload();
                        }, 100)
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            if(DB.fnGet('sudo')){
                                DB.fnSet('sudo', loginUser);
                            }else{
                                DB.fnSet('loginUser', loginUser);
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;

                    vm.fnUpdateUserData(perPage);
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery,
                            function: vm.selectedFunction
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            function: vm.selectedFunction
                        };
                    }

                    if (vm.selectedFunction === 'LIST') {
                        vm.inputObj.path = vm.currentPath;
                    }
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetFolders(vm.inputObj);
                };

                vm.fnGetPath = function (pathName, $index) {
                    vm.currentPath = '';
                    //var index =  vm.breadcrumbArray.indexOf(pathName);
                    vm.breadcrumbArray.splice($index + 1, vm.breadcrumbArray.length - 1);
                    angular.forEach(vm.breadcrumbArray, function (breadCrumbName) {
                        vm.currentPath = vm.currentPath + breadCrumbName;
                        if (breadCrumbName !== "/") {
                            vm.currentPath = vm.currentPath + "/";
                        }
                    });
                    $timeout(function () {
                        vm.fnReload();
                    }, 100)
                };
                /*END: TABLE*/
                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.contentPermissionObj.List = false;
                    $timeout(function () {
                        vm.contentPermissionObj.List = true;
                    }, 10)
                };

                function bytesToSize(bytes) {
                    var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
                    if (bytes === 0) {
                        return 'n/a';
                    }
                    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                    if (i === 0) {
                        return bytes + ' ' + sizes[i];
                    }
                    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.uploadFiles = function (fileData) {
                    if(fileData.size < 5000000000000) {
                        vm.progressBar = 0;
                        vm.progressCounter = 0;
                        vm.isFileUploading = true;
                        var path = vm.currentPath;
                        var inputObj = {
                            body: {
                                path: path + fileData.name,
                                size: fileData.size
                            }
                        };
                        FileFactory.createFile(inputObj)
                            .then(function(response){
                                vm.uploadStorageFile(response.url, fileData, path);
                            })
                    } else {
                        amaran.error("File size should be less than 5 TB.");
                        $uibModalInstance.dismiss('cancel');
                    }
                };
                vm.uploadStorageFile = function (url, fileData, path) {
                    $http({
                        method: 'PUT',
                        url: url,
                        config: {
                            headers: {
                                'Content-Type': fileData.type
                            }
                        },
                        uploadEventHandlers: {
                            progress: function (e) {
                                if (e.lengthComputable) {
                                    vm.progressBar = (e.loaded / e.total) * 100;
                                    vm.progressCounter = vm.progressBar;
                                }
                            }
                        },
                        data: fileData
                    }).success(function () {
                        var basePath = '';
                        var url = HOST_URL.tracker.split("https://")[1]; //eslint-disable-line
                        if (url.startsWith('dev')) {
                            basePath = 'https://dev-console.ecsmon.ecsiteapp.com/#/'
                        } else {
                            basePath = 'https://console.ecsmon.ecsiteapp.com/#/'
                        }
                        var fileUrl = basePath + 'storage/folder?path=' + encodeURIComponent(path) + '&selectedFile=' + encodeURIComponent(fileData.name);
                        vm.isFileUploading = false;
                        var extension = vm.fnDetermineFileBase64(fileData);
                        $uibModalInstance.close({url: fileUrl, extension: extension});
                    });
                };

                vm.fnDetermineFileBase64 = function (obj) {
                    var extension = obj.name.split('.')[obj.name.split('.').length - 1];
                    if (extension === "pdf") {
                        return "data:image/png;base64,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";
                    } else if (_.includes(vm.programmingFileExtensionArr, extension)) {
                        return "data:image/png;base64,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";
                    } else if (_.includes(vm.audioFileExtensionArr, extension)) {
                        return "data:image/png;base64,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";
                    }else if (_.includes(vm.videoFileExtensionArr, extension)) {
                        return "data:image/png;base64,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";
                    }else if (_.includes(vm.imageFileExtensionArr, extension)) {
                        return "data:image/png;base64,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";
                    }else if (extension === "xlsx" || extension === "xls" || extension === 'csv') {
                        return "data:image/png;base64,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";
                    } else if (extension === "pptx" || extension === "ppt") {
                        return "data:image/png;base64,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";
                    } else if (extension === "txt") {
                        return "data:image/png;base64,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";
                    } else if (extension === "docx" || extension === "doc") {
                        return "data:image/png;base64,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";
                    } else if (_.includes(vm.archiveFileExtensionArr, extension)) {
                        return "data:image/png;base64,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";
                    } else {
                        return "data:image/png;base64,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";
                    }
                };

                vm.fnDetermineFileIcon = function (obj) {
                    var extension = obj.name.split('.')[obj.name.split('.').length - 1];
                    if (extension === "pdf") {
                        return "fa-file-pdf-o";
                    } else if (_.includes(vm.programmingFileExtensionArr, extension)) {
                        return "fa-file-code-o";
                    } else if (_.includes(vm.audioFileExtensionArr, extension)) {
                        return "fa-file-audio-o";
                    }else if (_.includes(vm.videoFileExtensionArr, extension)) {
                        return "fa-file-video-o";
                    }else if (_.includes(vm.imageFileExtensionArr, extension)) {
                        return "fa-file-image-o";
                    }else if (extension === "xlsx" || extension === "xls" || extension === 'csv') {
                        return "fa-file-excel-o";
                    } else if (extension === "pptx" || extension === "ppt") {
                        return "fa-file-powerpoint-o";
                    } else if (extension === "txt") {
                        return "fa-file-text-o";
                    } else if (extension === "docx" || extension === "doc") {
                        return "fa-file-word-o";
                    } else if (_.includes(vm.archiveFileExtensionArr, extension)) {
                        return "fa-file-archive-o";
                    } else {
                        return "fa-file-o";
                    }
                };

                vm.fnCreateNewFolder = function (name) {
                    vm.isFolderCreating = true;
                    var inputObj = {
                        body: {
                            path: vm.currentPath + name + "/"
                        }
                    };
                    FolderFactory.createFolder(inputObj)
                        .then(function () {
                            vm.isFolderCreating = false;
                            vm.folderName = '';
                            vm.isCreateViewSelected = false;
                            //vm.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFolderCreating = false;
                            vm.isCreateViewSelected = false;
                            //vm.fnReload();
                        });
                };


                vm.fnInitModel = function () {
                    vm.contentPermissionObj = PermissionsService.getPermissions("storage:content");// list permission List:"TRUE"
                    vm.folderPermissionObj = PermissionsService.getPermissions("storage:folder");
                    if (vm.currentPath === '/') {
                        vm.breadcrumbArray = ["/"];
                    } else {
                        vm.breadcrumbArray = ["/"];
                        var tempArr = vm.currentPath.split("/");
                        angular.forEach(tempArr, function (path) {
                            if (path.length) {
                                vm.breadcrumbArray.push(path);
                            }
                        })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createIssueCtrl',
            function ($rootScope, $window, $stateParams, $http, $scope, $timeout, $state, $uibModal, mermaid, AppInitService,
                      ProjectFactory, swal, amaran, moment, DB, PermissionsService, AvatarService, IssueFactory,
                      EmailFactory, UserFactory, QueryFactory, UserProfileService, TypeFormService, TypesFactory) {
                var vm = this;
                vm.issueDraftObj = {};
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    });
                });

                vm.isIssueCreating = false;
                vm.fileUploading = false;
                vm.newIssueObj = {
                    confidential: false,
                    assignees: [],
                    issueLabels: [],
                    participants: [],
                    name: "",
                    summary: "",
                    resolved: false
                };
                vm.resetNewIssueObj = angular.copy(vm.newIssueObj);
                vm.projectsArr = [];
                vm.selectedProject = {};

                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};

                vm.filter = "$";
                vm.labelSearch = {$: ''};
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                vm.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;

                /*Types: START*/
                vm.typesArr = [];
                vm.selectedType = {};
                vm.isIssueTypeLoaded = false;
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];
                vm.isTypeDetailsLoaded = true;
                /*Types: END*/

                /*Assignee: START*/
                vm.filterAssignees = "$";
                vm.assigneeSearch = {$: ''};
                vm.usersArr = [{
                    username: 'assign to me'
                }];
                vm.isIssueAssigneeLoaded = false;
                vm.changeAssigneeView = false;
                vm.isAssigneeChanged = true;
                vm.selectedUser = "";
                /*Assignee: END*/

                /*Labels: START*/
                vm.labelsArr = [];
                vm.isIssueLablesLoaded = false;
                vm.addLabelView = false;
                vm.isLabelsAdded = true;
                vm.selectedLabelsArr = [];
                vm.selectedLabel = {};
                /*Labels: END*/

                /*Priority: START*/
                vm.priorityFilter = "$";
                vm.prioritySearch = {$: ''};
                vm.prioritiesArr = [];
                vm.isIssuePriorityLoaded = false;
                vm.changePriorityView = false;
                vm.isPriorityChanged = true;
                vm.selectedPriority = "";
                /*Priority: END*/

                /*State: START*/
                vm.stateFilter = "$";
                vm.stateSearch = {$: ''};
                vm.statesArr = [];
                vm.isIssueStateLoaded = false;
                vm.changeStateView = false;
                vm.isStateChanged = true;
                vm.selectedState = {};
                /*State: END*/

                /*Participant: START*/
                vm.participantFilter = "$";
                vm.participantSearch = {$: ''};
                vm.participantsArr = [];
                vm.isIssueParticipantLoaded = false;
                vm.changeParticipantView = false;
                vm.isParticipantChanged = true;
                vm.selectedParticipant = {};
                vm.assigneesParticipants = [];
                /*Participant: END*/

                /*Confidential: START*/
                vm.confidentialsArr = [{'name': "Confidential", 'value': true}, {
                    'name': "Not Confidential",
                    'value': false
                }];
                vm.isIssueConfidentialLoaded = false;
                vm.changeConfidentialView = false;
                vm.isConfidentialChanged = true;
                vm.selectedConfidential = {};
                /*Confidential: END*/

                vm.projectRelationshipsObj = {};

                vm.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        vm.fnRenderMermaid();
                    }
                };

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        if (type === 'image') {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                        } else {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " [" + filedata.name + "](" + res.downloadUrl + ")";
                        }
                        vm.fileUploading = false;
                    });
                };

                vm.uploadFiles = function (type, filedata) {
                    if (vm.permissionObj.GET_FILE_UPLOAD_LINK) {
                        vm.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                vm.fnCreateNewIssue = function (newIssueObj) {
                    if (newIssueObj.issueType && newIssueObj.issueType.form) {
                        newIssueObj.issueType.form.values = vm.model;
                    }
                    vm.isIssueCreating = true;
                    var inputObj = {
                        'body': newIssueObj,
                        'projectId': vm.selectedProject.id
                    };
                    IssueFactory.createIssue(inputObj)
                        .then(function (response) {
                            vm.isIssueCreating = false;
                            vm.newIssueObj = angular.copy(vm.resetNewIssueObj);
                            localStorage.removeItem('issueDraft');
                            localStorage.removeItem('fedSupportIssueDraft');
                            if (newIssueObj.participants && newIssueObj.participants.length) {
                                var tempArr = [];
                                _.forEach(newIssueObj.participants, function (participant) {
                                    tempArr.push({
                                        email: participant
                                    })
                                });
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', tempArr);
                            } else {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', []);
                            }
                            vm.model = {};
                            vm.fnInitCreateIssue();
                            $timeout(function () { // set table height
                                $scope.issue.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('issueAdded', response);
                        }, function () {
                            vm.isIssueCreating = false;
                        })
                };

                vm.fnChangeProject = function (projectObj) {
                    vm.selectedProject = projectObj;
                    vm.newIssueObj.projectId = projectObj.id;
                    vm.newIssueObj.issueLabels = [];
                    delete vm.newIssueObj.issueState;
                    delete vm.newIssueObj.issuePriority;

                    /*Types: START*/
                    vm.typesArr = [];
                    vm.selectedType = {};
                    vm.isIssueTypeLoaded = false;
                    vm.model = {};
                    vm.schema = {};
                    vm.form = ['*'];
                    /*Types: END*/

                    /*Labels: START*/
                    vm.labelsArr = [];
                    vm.isIssueLablesLoaded = false;
                    vm.addLabelView = false;
                    vm.isLabelsAdded = true;
                    vm.selectedLabelsArr = [];
                    vm.selectedLabel = {};
                    /*Labels: END*/

                    /*Priority: START*/
                    vm.prioritiesArr = [];
                    vm.isIssuePriorityLoaded = false;
                    vm.changePriorityView = false;
                    vm.isPriorityChanged = true;
                    vm.selectedPriority = "";
                    /*Priority: END*/

                    /*State: START*/
                    vm.statesArr = [];
                    vm.isIssueStateLoaded = false;
                    vm.changeStateView = false;
                    vm.isStateChanged = true;
                    vm.selectedState = {};
                    /*State: END*/

                    vm.isIssueTypeLoaded = false;
                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;
                        }, function () {
                        });
                };

                /*Assignee: START*/
                vm.addAssigneeArr = [];
                vm.deleteAssigneeArr = [];
                vm.teamsArr = [];

                vm.fnGetUsers = function (inputObj) {
                    ProjectFactory.listPossibleProjectAssignees(inputObj)
                        .then(function (response) {
                            var teamsSQL = "SELECT * FROM access_teams WHERE ";
                            _.forEach(response, function (userObj, index) {
                                userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                                if (vm.issueDraftObj && vm.issueDraftObj.assignees && vm.issueDraftObj.assignees.length) {
                                    var isFindAssignee = _.find(vm.issueDraftObj.assignees, {id: userObj.id});
                                    if (isFindAssignee) {
                                        userObj.isCheck = true;

                                        if (!vm.assigneesAssignees) {
                                            vm.assigneesAssignees = [];
                                        }
                                        vm.assigneesAssignees.push({
                                            bio: userObj.bio,
                                            firstName: userObj.firstName,
                                            id: userObj.id,
                                            lastName: userObj.lastName,
                                            tags: userObj.tags,
                                            username: userObj.username,
                                            userAvatar: userObj.userAvatar,
                                            email: userObj.email
                                        })
                                    }
                                }
                                if (index === (response.length - 1)) {
                                    teamsSQL += " access_teams.data->'userIds' @> '[\"" + userObj.id + "\"]'::jsonb ";
                                } else {
                                    teamsSQL += " access_teams.data->'userIds' @> '[\"" + userObj.id + "\"]'::jsonb OR ";
                                }
                            });
                            response.sort(function (a, b) {
                                if (a.firstName < b.firstName) {
                                    return -1;
                                }
                                if (a.firstName > b.firstName) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.usersArr = _.cloneDeepWith(response);
                            if (vm.usersArr && vm.usersArr.length && (vm.loginUser.administrator === true || vm.loginUser.accountOwner === true)) {
                                vm.fnGetUsersTeams({'sql': teamsSQL});
                            }
                            vm.isIssueAssigneeLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueAssigneeLoaded = true;
                        })
                };

                vm.fnGetUsersTeams = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (response) {
                            var userArr = [];
                            vm.teamsArr = _.cloneDeepWith(response.data);
                            var sql = "SELECT * from access_users where data->>\'id\' IN ("
                            _.forEach(response.data, function (teamObj) {
                                userArr = userArr.concat(teamObj.userIds)
                            });
                            var newUserArr = _.uniq(userArr);
                            _.forEach(newUserArr, function (userObj, index) {
                                if (index === (newUserArr.length - 1)) {
                                    sql += "'" + userObj + "')";
                                } else {
                                    sql += "'" + userObj + "', ";
                                }
                            });
                            vm.fnGetTeamUsers({sql: sql});
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetTeamUsers = function (input) {
                    QueryFactory.executeQuery(input)
                        .then(function (response) {
                            vm.teamUserData = response.data;
                            _.forEach(vm.teamsArr, function (teamObj) {
                                teamObj.userArr = [];
                                _.forEach(teamObj.userIds, function (userId) {
                                    var isFind = _.find(vm.teamUserData, {'id': userId});
                                    if (isFind) {
                                        isFind.userAvatar = angular.isDefined(isFind) ? AvatarService.getTextAvatar(isFind) : 'assets/images/svg/logo_color.svg';
                                        teamObj.userArr.push(_.cloneDeepWith(isFind));
                                        var isFindUser = _.find(vm.usersArr, {'id': userId});
                                        if (!isFindUser) {
                                            vm.usersArr.push(_.cloneDeepWith(isFind));
                                        }
                                    }
                                })
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetTeamInfo = function (teamObj) {
                    _.forEach(teamObj.userArr, function (userObj) {
                        var isFindInUserArr = _.find(vm.usersArr, {'id': userObj.id});
                        if (isFindInUserArr) {
                            vm.fnGetAssigneeInfo(isFindInUserArr);
                        }
                    });
                    vm.fnCancelChangeAssignee();
                }

                vm.fnGetAssigneeInfo = function (assigneeObj) {
                    if (assigneeObj.isCheck) {
                        assigneeObj.isCheck = false;
                        var isFindAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (isFindAssignee) {
                            vm.deleteAssigneeArr.push(isFindAssignee);
                        } else {
                            var isFindAssigneeInAddAssigneeArr = _.findIndex(vm.addAssigneeArr, {id: assigneeObj.id});
                            if (isFindAssigneeInAddAssigneeArr !== 1) {
                                vm.addAssigneeArr.splice(isFindAssigneeInAddAssigneeArr, 1);
                            }
                        }
                    } else {
                        assigneeObj.isCheck = true;
                        var isFindAssigneesAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (!isFindAssigneesAssignee) {
                            vm.addAssigneeArr.push(assigneeObj);
                        } else {
                            var isFindDeleteAssignee = _.findIndex(vm.deleteAssigneeArr, {id: assigneeObj.id});
                            if (isFindDeleteAssignee !== -1) {
                                vm.deleteAssigneeArr.splice(isFindDeleteAssignee, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeAssignee = function () {
                    vm.selectedAssignee = {};
                    vm.changeAssigneeView = false;
                    if (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length) {
                        vm.fnUpdateIssueAssignee();
                    }
                };

                vm.fnOnToggleAssignee = function (isOpen) {
                    if (isOpen === false && (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length)) {
                        vm.fnUpdateIssueAssignee();
                    } else {
                        vm.changeAssigneeView = false;
                        vm.selectedAssignee = {};
                    }
                };

                vm.fnUpdateIssueAssignee = function () {
                    vm.isIssueAssigneeLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesAssignees, function (assigneeObj) {
                        var findIndex = _.findIndex(vm.deleteAssigneeArr, function (deleteObj) {
                            return deleteObj.id === assigneeObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: assigneeObj.bio,
                                firstName: assigneeObj.firstName,
                                id: assigneeObj.id,
                                lastName: assigneeObj.lastName,
                                tags: assigneeObj.tags,
                                username: assigneeObj.username,
                                userAvatar: assigneeObj.userAvatar,
                                email: assigneeObj.email
                            });
                        }
                    });
                    _.forEach(vm.addAssigneeArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesAssignees, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: addObj.bio,
                                firstName: addObj.firstName,
                                id: addObj.id,
                                lastName: addObj.lastName,
                                tags: addObj.tags,
                                username: addObj.username,
                                userAvatar: addObj.userAvatar,
                                email: addObj.email
                            })
                        }
                    });
                    vm.newIssueObj.assignees = _.cloneDeepWith(tempArr);
                    vm.assigneesAssignees = _.cloneDeepWith(tempArr);
                    vm.isIssueAssigneeLoaded = true;
                    vm.selectedAssignee = "";
                    vm.deleteAssigneeArr = [];
                    vm.addAssigneeArr = [];
                    vm.changeAssigneeView = false;
                };

                vm.fnOpenChangeAssigneeView = function () {
                    vm.changeAssigneeView = true;
                    _.forEach(vm.assigneesAssignees, function (issueAssigneeObj) {
                        var isFindAssignee = _.find(vm.usersArr, {id: issueAssigneeObj.id});
                        isFindAssignee.isCheck = !!isFindAssignee;
                    });
                };

                vm.fnManageAssignees = function () {
                    $state.go("main.users");
                };
                /*Assignee: END*/

                /*Type: START*/
                vm.fnGetTypes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            vm.typesArr = _.cloneDeepWith(response.data);
                            vm.typesArr.unshift({
                                id: "noType",
                                name: "Select Type"
                            });
                            if (vm.issueDraftObj && vm.issueDraftObj.issueType) {
                                var isFindType = _.find(vm.typesArr, {id: vm.issueDraftObj.issueType.id});
                                if (isFindType) {
                                    vm.selectedType = vm.issueDraftObj.issueType;
                                    vm.fnCreateTypeForm();
                                } else {
                                    vm.selectedType = vm.typesArr[0];
                                }
                            } else {
                                vm.selectedType = vm.typesArr[0];
                            }
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        })
                };

                vm.fnSelectType = function (typeObj) {
                    vm.selectedType = typeObj;
                    if (vm.selectedType.id === 'noType') {
                        delete vm.newIssueObj.issueType;
                        vm.model = {};
                        vm.schema = {};
                        vm.form = ['*'];
                    } else {
                        vm.newIssueObj.issueType = typeObj;
                        vm.fnCreateTypeForm();
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                vm.fnCheckIssueTypeValidation = function () {
                    if (vm.newIssueObj.issueType && vm.form.length) {
                        var flag = false;
                        _.forEach(vm.form, function (formObj) {
                            if (formObj.required) {
                                _.forEach(formObj.key, function (keyValue) {
                                    if (angular.isUndefined(vm.model[keyValue]) || (angular.isDefined(vm.model[keyValue]) && !vm.model[keyValue].toString().length)) {
                                        flag = true;
                                    }
                                })
                            }
                        });
                        return flag;
                    } else {
                        return false;
                    }
                };

                vm.fnCreateTypeForm = function () {
                    vm.isTypeDetailsLoaded = false;
                    var inputObj = {
                        typeId: vm.selectedType.id
                    };
                    TypesFactory.describeIssueType(inputObj)
                        .then(function (response) {
                            if (response.form && response.form.schema && response.form.schema.properties && Object.keys(response.form.schema.properties).length) {
                                var tempData = TypeFormService.fnGenerateFormData(response.form.schema);
                                vm.schema = tempData.schema;
                                vm.form = tempData.form;
                                if (angular.isDefined(vm.issueDraftObj)) {
                                    if (angular.isDefined(vm.newIssueObj.issueType) && angular.isDefined(vm.newIssueObj.issueType.form)) {
                                        vm.model = vm.issueDraftObj.issueType.form.values;
                                    }
                                }
                            } else {
                                vm.schema = {
                                    $schema: "https://json-schema.org/draft/2019-09/schema",
                                    type: "object",
                                    properties: {}
                                };
                                vm.form = [];
                            }
                            vm.isTypeDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isTypeDetailsLoaded = true;
                            //vm.fnCreateTypeForm();
                        });
                };
                /*Type: END*/

                /*Priority: START*/
                vm.addPrioritiesArr = [];
                vm.deletePrioritiesArr = [];
                vm.fnGetPriorities = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.prioritiesArr = _.cloneDeepWith(response.data);
                            vm.isIssuePriorityLoaded = true;
                        }, function () {
                            vm.isIssuePriorityLoaded = true;
                        })
                };

                vm.fnGetPrioritiesInfo = function (prioritiesObj) {
                    _.forEach(vm.prioritiesArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deletePrioritiesArr = [];
                    vm.addPrioritiesArr = [];
                    var isFindCheck = _.find(vm.prioritiesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id !== isFindCheck.id) {
                                vm.addPrioritiesArr = [prioritiesObj];
                            }
                        } else {
                            vm.addPrioritiesArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id === prioritiesObj.id) {
                                vm.deletePrioritiesArr = [vm.assigneesPriorities];
                            }
                        }

                    }
                };

                vm.fnCancelChangePriority = function () {
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                    if (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length) {
                        vm.fnUpdateIssuePriority();
                    }
                };

                vm.fnOnTogglePriority = function (isOpen) {
                    if (isOpen === false && (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length)) {
                        vm.fnUpdateIssuePriority();
                    } else {
                        vm.changePriorityView = false;
                        vm.selectedPriority = {};
                    }
                };

                vm.fnUpdateIssuePriority = function () {
                    vm.isIssuePriorityLoaded = false;
                    if (vm.deletePrioritiesArr.length) {
                        delete vm.newIssueObj.issuePriority;
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    } else {
                        vm.newIssueObj.issuePriority = vm.addPrioritiesArr[0];
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    }
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                };

                vm.fnOpenChangePriorityView = function () {
                    vm.changePriorityView = true;
                    _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                        prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                    });
                };

                vm.fnManageProjectPriority = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.priorities", {filter: angular.toJson(inputObj)});
                };
                /*Priority: END*/

                /*State: START*/
                vm.addStatesArr = [];
                vm.deleteStatesArr = [];
                vm.fnGetStates = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.statesArr = _.cloneDeepWith(response.data);
                            vm.isIssueStateLoaded = true;
                        }, function () {
                            vm.isIssueStateLoaded = true;
                        })
                };

                vm.fnGetStatesInfo = function (statesObj) {
                    _.forEach(vm.statesArr, function (states) {
                        if (statesObj.id !== states.id) {
                            states.isCheck = false;
                        }
                    });
                    statesObj.isCheck = !statesObj.isCheck;
                    vm.deleteStatesArr = [];
                    vm.addStatesArr = [];
                    var isFindCheck = _.find(vm.statesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id !== isFindCheck.id) {
                                vm.addStatesArr = [statesObj];
                            }
                        } else {
                            vm.addStatesArr = [statesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id === statesObj.id) {
                                vm.deleteStatesArr = [vm.assigneesState];
                            }
                        }
                    }
                };

                vm.fnCancelChangeState = function () {
                    vm.selectedState = {};
                    vm.changeStateView = false;
                    if (vm.deleteStatesArr.length || vm.addStatesArr.length) {
                        vm.fnUpdateIssueState();
                    }
                };

                vm.fnOnToggleState = function (isOpen) {
                    if (isOpen === false && (vm.deleteStatesArr.length || vm.addStatesArr.length)) {
                        vm.fnUpdateIssueState();
                    } else {
                        vm.changeStateView = false;
                        vm.selectedState = {};
                    }
                };

                vm.fnUpdateIssueState = function () {
                    vm.isIssueStateLoaded = false;
                    if (vm.deleteStatesArr.length) {
                        delete vm.newIssueObj.issueState;
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    } else {
                        vm.newIssueObj.issueState = vm.addStatesArr[0];
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    }
                    vm.selectedState = {};
                    vm.changeStateView = false;
                };

                vm.fnOpenChangeStateView = function () {
                    vm.changeStateView = true;
                    _.forEach(vm.statesArr, function (statesObj) {
                        statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                    });
                };

                vm.fnManageProjectState = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.state", {filter: angular.toJson(inputObj)});
                };
                /*State: END*/

                /*Labels: START*/
                vm.addLabelArr = [];
                vm.deleteLabelArr = [];
                vm.fnGetLabels = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.labelsArr = _.cloneDeepWith(response.data);
                            vm.isIssueLablesLoaded = true;
                        }, function () {
                            vm.isIssueLablesLoaded = true;
                        })
                };

                vm.fnGetLabelInfo = function (labelObj) {
                    if (labelObj.isCheck) {
                        labelObj.isCheck = false;
                        var isFindLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (isFindLabel) {
                            vm.deleteLabelArr.push(isFindLabel);
                        } else {
                            var isFindLabelInAddLabelArr = _.findIndex(vm.addLabelArr, {id: labelObj.id});
                            if (isFindLabelInAddLabelArr !== 1) {
                                vm.addLabelArr.splice(isFindLabelInAddLabelArr, 1);
                            }
                        }
                    } else {
                        labelObj.isCheck = true;
                        var isFindAssigneesLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (!isFindAssigneesLabel) {
                            vm.addLabelArr.push(labelObj);
                        } else {
                            var isFindDeleteLabel = _.findIndex(vm.deleteLabelArr, {id: labelObj.id});
                            if (isFindDeleteLabel !== -1) {
                                vm.deleteLabelArr.splice(isFindDeleteLabel, 1);
                            }
                        }
                    }
                };

                vm.fnAddLabelsToIssue = function (selectedLabel) {
                    vm.isLabelsAdded = false;
                    vm.newIssueObj.issueLabels.push(selectedLabel);
                    vm.isLabelsAdded = true;
                    vm.addLabelView = false;
                    vm.selectedLabel = {};
                };

                vm.fnCancelAddLabelView = function () {
                    vm.selectedLabel = {};
                    vm.addLabelView = false;
                    if (vm.deleteLabelArr.length || vm.addLabelArr.length) {
                        vm.fnUpdateIssueLabel();
                    }
                };

                vm.fnOnToggle = function (isOpen) {
                    if (isOpen === false && (vm.deleteLabelArr.length || vm.addLabelArr.length)) {
                        vm.fnUpdateIssueLabel();
                    } else {
                        vm.addLabelView = false;
                        vm.selectedLabel = {};
                    }
                };

                vm.fnUpdateIssueLabel = function () {
                    vm.isIssueLablesLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesLabels, function (labelObj) {
                        var findIndex = _.findIndex(vm.deleteLabelArr, function (deleteObj) {
                            return deleteObj.id === labelObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: labelObj.id,
                                name: labelObj.name,
                                color: labelObj.color,
                                tags: labelObj.tags ? labelObj.tags : {}
                            });
                        }
                    });
                    _.forEach(vm.addLabelArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesLabels, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: addObj.id,
                                name: addObj.name,
                                color: addObj.color,
                                tags: addObj.tags ? addObj.tags : {}
                            })
                        }
                    });
                    vm.newIssueObj.issueLabels = _.cloneDeepWith(tempArr);
                    vm.assigneesLabels = _.cloneDeepWith(tempArr);
                    vm.isIssueLablesLoaded = true;
                    vm.selectedLabel = {};
                    vm.deleteLabelArr = [];
                    vm.addLabelArr = [];
                    vm.addLabelView = false;
                };

                vm.fnOpenAddLabelView = function () {
                    vm.addLabelView = true;
                    _.forEach(vm.assigneesLabels, function (issueLabelObj) {
                        var isFindLabel = _.find(vm.labelsArr, {id: issueLabelObj.id});
                        isFindLabel.isCheck = !!isFindLabel;
                    });
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": vm.fnInvertColor(color.toString())
                        }
                    }
                };

                vm.fnManageProjectLabels = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.projectId
                    }];
                    $state.go("main.label", {filter: angular.toJson(inputObj)});
                };
                /*Labels: END*/

                /*Participant: START*/
                vm.addParticipantArr = [];
                vm.deleteParticipantArr = [];
                vm.fnGetParticipants = function () {
                    var participants = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'participantsList');
                    if (participants && participants.length) {
                        vm.participantUsersArr = _.cloneDeepWith(participants);
                    } else {
                        vm.participantUsersArr = [];
                    }
                    if (vm.newIssueObj &&
                        vm.newIssueObj.participants &&
                        vm.newIssueObj.participants.length) {
                        _.forEach(vm.newIssueObj.participants, function (participant) {
                            var isFindIndex = _.findIndex(vm.participantUsersArr, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndex === -1) {
                                vm.participantUsersArr.push({
                                    email: participant,
                                    isCheck: true
                                })
                            }

                            var isFindIndexAssignee = _.findIndex(vm.assigneesParticipants, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndexAssignee === -1) {
                                vm.assigneesParticipants.push({
                                    email: participant
                                })
                            }
                        })
                    }
                    vm.resetParticipantUsersArr = _.cloneDeepWith(vm.participantUsersArr);
                    vm.isIssueParticipantLoaded = true;
                };

                vm.fnGetParticipantInfo = function (participantObj) {
                    if (participantObj.isCheck) {
                        participantObj.isCheck = false;
                        var isFindParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (isFindParticipant) {
                            vm.deleteParticipantArr.push(isFindParticipant);
                        } else {
                            var isFindParticipantInAddParticipantArr = _.findIndex(vm.addParticipantArr, {email: participantObj.email});
                            if (isFindParticipantInAddParticipantArr !== 1) {
                                vm.addParticipantArr.splice(isFindParticipantInAddParticipantArr, 1);
                            }
                        }
                    } else {
                        participantObj.isCheck = true;
                        var isFindAssigneesParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (!isFindAssigneesParticipant) {
                            vm.addParticipantArr.push(participantObj);
                        } else {
                            var isFindDeleteParticipant = _.findIndex(vm.deleteParticipantArr, {email: participantObj.email});
                            if (isFindDeleteParticipant !== -1) {
                                vm.deleteParticipantArr.splice(isFindDeleteParticipant, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeParticipant = function () {
                    vm.selectedParticipant = {};
                    vm.changeParticipantView = false;
                    vm.isParticipantChanged = true;
                    if (vm.deleteParticipantArr.length || vm.addParticipantArr.length) {
                        vm.fnUpdateIssueParticipant();
                    }
                };

                vm.fnOnToggleParticipant = function (isOpen) {
                    if (isOpen === false && (vm.deleteParticipantArr.length || vm.addParticipantArr.length)) {
                        vm.fnUpdateIssueParticipant();
                    } else {
                        vm.changeParticipantView = false;
                        vm.selectedParticipant = {};
                    }
                };

                vm.fnUpdateIssueParticipant = function () {
                    vm.isIssueParticipantsLoaded = false;
                    var tempArr = [];
                    var participantsArr = [];
                    _.forEach(vm.assigneesParticipants, function (participantObj) {
                        var findIndex = _.findIndex(vm.deleteParticipantArr, function (deleteObj) {
                            return deleteObj.email === participantObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(participantObj.email);
                            tempArr.push(participantObj);
                        }
                    });
                    _.forEach(vm.addParticipantArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesParticipants, function (tempObj) {
                            return tempObj.email === addObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(addObj.email);
                            tempArr.push(addObj);
                        }
                    });
                    vm.newIssueObj.participants = _.cloneDeepWith(participantsArr);
                    vm.assigneesParticipants = _.cloneDeepWith(tempArr);
                    vm.isIssueParticipantsLoaded = true;
                    vm.selectedParticipant = {};
                    vm.deleteParticipantArr = [];
                    vm.addParticipantArr = [];
                    vm.changeParticipantView = false;
                };

                vm.fnOpenChangeParticipantView = function () {
                    vm.changeParticipantView = true;
                    _.forEach(vm.assigneesParticipants, function (issueParticipantObj) {
                        var isFindParticipant = _.find(vm.participantUsersArr, {email: issueParticipantObj.email});
                        isFindParticipant.isCheck = !!isFindParticipant;
                    });
                };

                vm.fnAddNewParticipant = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html',
                        size: 'lg',
                        controller: 'addParticipantCtrl as addParticipant',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (data) {
                        if (!vm.newIssueObj.participants) {
                            vm.newIssueObj.participants = [];
                        }
                        if (!vm.assigneesParticipants) {
                            vm.assigneesParticipants = [];
                        }
                        if (!vm.participantUsersArr) {
                            vm.participantUsersArr = [];
                        }
                        vm.newIssueObj.participants.push(_.cloneDeepWith(data.email));
                        vm.assigneesParticipants.push(_.cloneDeepWith(data));
                        vm.participantUsersArr.push(_.cloneDeepWith(data));
                    }, function () {

                    });
                };
                /*Participant: END*/

                /*Confidential: START*/
                vm.fnOpenChangeConfidentialView = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = true;
                };

                vm.fnChangeIssueConfidential = function (selectedConfidential) {
                    vm.isConfidentialChanged = false;
                    if (selectedConfidential.value) {
                        vm.newIssueObj.confidential = true;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    } else {
                        vm.newIssueObj.confidential = false;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    }
                };

                vm.fnCancelChangeConfidential = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = false;
                    vm.isConfidentialChanged = true;
                };
                /*Confidential: END*/

                vm.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                vm.fnInitSideBar = function () {
                    vm.usersArr = [{
                        username: 'assign to me'
                    }];
                    vm.isIssueAssigneeLoaded = false;
                    vm.usersArr = [];
                    vm.changeAssigneeView = false;

                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states WHERE data->>'projectId' IN (<upstreamProject>)";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;

                            vm.isIssueParticipantLoaded = false;
                            vm.fnGetParticipants();
                            vm.changeParticipantView = false;
                        }, function () {
                        });
                };

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce();
                        vega_runonce();
                    }, 100);
                };
                /* eslint-enable */

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.sort(function (a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                                    var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                                    if (isFindDraftProject) {
                                        vm.selectedProject = isFindDraftProject;
                                        vm.newIssueObj.projectId = isFindDraftProject.id;
                                    } else {
                                        vm.fnGetSelectedProject();
                                    }
                                } else {
                                    vm.fnGetSelectedProject();
                                }
                                vm.fnInitSideBar();
                                vm.isProjectLoaded = true;
                            }
                        }, function () { // Error block
                            vm.isProjectLoaded = true;
                            vm.projectsArr = [];
                        })
                };

                vm.fnGetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.selectedProject = isFindProject;
                            vm.newIssueObj.projectId = isFindProject.id;
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.selectedProject = isFindStateParamsProject;
                            vm.newIssueObj.projectId = isFindStateParamsProject.id;
                        }
                    } else {
                        _.forEach(vm.projectsArr, function (dataObj) {
                            if (!dataObj.parentProjectId) {
                                vm.selectedProject = dataObj;
                                vm.newIssueObj.projectId = dataObj.id;
                            }
                        });
                    }
                };

                vm.fnInitCreateIssue = function () {
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        vm.issueDraftObj = localStorage.getItem('fedSupportIssueDraft') ?
                            angular.fromJson(localStorage.getItem('fedSupportIssueDraft')) : {};
                    } else {
                        vm.issueDraftObj = localStorage.getItem('issueDraft') ?
                            angular.fromJson(localStorage.getItem('issueDraft')) : {};
                    }
                    if (angular.isDefined(vm.issueDraftObj) && vm.issueDraftObj !== {}) {
                        vm.newIssueObj = vm.issueDraftObj;
                    }
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.isProjectLoaded = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.projectsArr.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        });
                        if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                            var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                            if (isFindDraftProject) {
                                vm.selectedProject = isFindDraftProject;
                                vm.newIssueObj.projectId = isFindDraftProject.id;
                            } else {
                                vm.fnGetSelectedProject();
                            }
                        } else {
                            vm.fnGetSelectedProject();
                        }
                        $timeout(function () {
                            vm.fnInitSideBar();
                            vm.isProjectLoaded = true;
                        })
                    } else {
                        vm.isProjectLoaded = false;
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                $scope.$on('resetCreateIssue', function () {
                    /*vm.newIssueObj = angular.copy(vm.resetNewIssueObj);
                    vm.fnInitCreateIssue();
                    $timeout(function () { // set table height
                        $scope.issue.fnSetTableHeight();//parent function
                    }, 800);*/
                });

                vm.fnSetIssueMarkdownHeight = function () {
                    var height = 282;
                    if (angular.isDefined(angular.element("#modal-body")[0]) &&
                        angular.isDefined(angular.element("#newIssueTitle")[0]) &&
                        angular.isDefined(angular.element("#typeListDropdown")[0])) {
                        var total = angular.element("#modal-body")[0].offsetHeight;
                        var newIssue = angular.element("#newIssueTitle")[0].offsetHeight;
                        var typeListDropdown = angular.element("#typeListDropdown")[0].offsetHeight;
                        var finalHeight = total - (newIssue + typeListDropdown + 60);
                        if (height < finalHeight) {
                            angular.element("#issueMarkdownContainer").css('height', finalHeight + 'px');
                        } else {
                            angular.element("#issueMarkdownContainer").css('height', 282 + 'px');
                        }
                    }

                };

                vm.fnSaveIssueDraft = function () {
                    if (vm.newIssueObj.issueType && vm.newIssueObj.issueType.form) {
                        vm.newIssueObj.issueType.form.values = vm.model;
                    }

                    if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                        localStorage.setItem('issueDraft', angular.toJson(vm.newIssueObj));
                    } else {
                        localStorage.setItem('fedSupportIssueDraft', angular.toJson(vm.newIssueObj));
                    }
                };

                vm.fnExpandCollapseSideBar = function () {
                    vm.isExpanded = !vm.isExpanded;
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'sideBarExpanded', _.cloneDeepWith(vm.isExpanded));
                };

                vm.fnGetAssigneesTooltipInfo = function () {
                    if (vm.newIssueObj.assignees && vm.newIssueObj.assignees.length) {
                        return vm.newIssueObj.assignees.map(function (el) {
                            return el.firstName + " " + el.lastName
                        }).join(", ");
                    } else {
                        return "No assignee";
                    }
                };

                vm.fnGetLabelsTooltipInfo = function () {
                    if (vm.newIssueObj.issueLabels && vm.newIssueObj.issueLabels.length) {
                        return vm.newIssueObj.issueLabels.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No labels";
                    }
                };

                vm.fnGetParticipantsTooltipInfo = function () {
                    if (vm.newIssueObj.participants && vm.newIssueObj.participants.length) {
                        return vm.newIssueObj.participants.map(function (el) {
                            return el
                        }).join(", ");
                    } else {
                        return "No participant";
                    }
                };

                $window.onbeforeunload = function () {
                    return vm.fnSaveIssueDraft();
                };

                $scope.$on("$destroy", function () {
                    vm.fnSaveIssueDraft();
                });
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('archivedInfo', fnArchivedInfo)

    /** @ngInject */
    function fnArchivedInfo($rootScope, $state, $stateParams, $window, $base64, $timeout, $uibModal, mermaid, $sce, moment, microSpinner,
                            swal, amaran, copyService, CommentFactory, AvatarService, ColorService, DB, IssueFactory, postActionModelMessage, postActionModelIcon, ArchivedIssueFactory, UserProfileService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/tracker/archived/archivedInfo/archivedInfo.html',
            scope: {
                issueObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    65: false, //a
                    76: false, //l
                    67: false, //c
                    79: false, //o
                    85: false //u
                };
                $scope.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');
                $scope.isIssueStateChange = false;
                $scope.loginUserAvatar = AvatarService.getTextAvatar($scope.loginUser);
                $scope.selectedComment = {};
                $scope.isShowIssueSummary = false;
                $scope.isShowMainComment = false;
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                $scope.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;
                $scope.selectedCommentView = 'Horizontal'; //Vertical

                $scope.tabs = [
                    {
                        title: 'Public',
                        tabIndex: 1,
                        templateUrl: 'app/tracker/archived/archivedInfo/archivedSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Private',
                        tabIndex: 2,
                        templateUrl: 'app/tracker/archived/archivedInfo/archivedSteps/archivedPrivate/archivedPrivate.html',
                        visible: true
                    },
                    {
                        title: 'Form',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/archived/archivedInfo/archivedSteps/archivedForm/archivedForm.html',
                        visible: !!(angular.isDefined($scope.issueObj.customForm) && $scope.issueObj.customForm.schema && $scope.issueObj.customForm.schema.properties && Object.keys($scope.issueObj.customForm.schema.properties).length)
                    },
                    {
                        title: 'History',
                        tabIndex: 4,
                        templateUrl: 'app/tracker/archived/archivedInfo/archivedSteps/archivedHistory/archivedHistory.html',
                        visible: true
                    }
                    /*{
                        title: 'Linked',
                        tabIndex: 5,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/Linked/issueLinked.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/tracker/issue/directives/issueInfo/issueSteps/issueSupplemental/issueSupplemental.html'
                    }*/
                ];

                $scope.markedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview",
                    hiddenButtons: ['all']
                };

                $scope.newCommentMarkedOptionObj = {
                    iconlibrary: 'fa',
                    addExtraButtons: false,
                    resize: 'vertical',
                    hiddenButtons: ['all']
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.issuePublicTabAPITimeout = "";

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        $timeout(function () {
                            if (angular.element(".comment-timeline")[0]) {
                                var commentTimeline = angular.element(".comment-timeline")[0].offsetHeight;
                                var newCommentBlock = 0;
                                var commentHeader = angular.element(".comment-header")[0].offsetHeight;
                                var commentFooter = angular.isDefined(angular.element(".comment-footer")[0]) ? angular.element(".comment-footer")[0].offsetHeight : 0;
                                //var test = finalHeight + 200;
                                angular.element(".comment-body").css('height', (finalHeight - (commentTimeline + newCommentBlock + commentHeader + commentFooter + 60)) + 'px');
                            }
                            if (angular.element(".vertical-comment-view")[0]) {
                                var newCommentBlock1 = angular.element(".new-comment-block")[0] ? angular.element(".new-comment-block")[0].offsetHeight : 0;
                                angular.element(".vertical-comment-view").css('height', (finalHeight - (newCommentBlock1 + 40)) + 'px');
                                //angular.element(".qa-message-content").css('height', ((finalHeight - (newCommentBlock1 + 40)) - 53) + 'px');
                            }
                        })
                    }
                };

                var text = '';
                var storeH = 0;
                var storeH2 = 0;

                $scope.fnKeyDownComment = function () {
                    $timeout(function () {
                        if (storeH !== text.scrollHeight) {
                            text.style.height = text.scrollHeight + 2 + 'px';
                            storeH = text.scrollHeight;
                            if (storeH2 !== storeH) {
                                storeH2 = storeH;
                            }
                        }
                        $timeout(function () {
                            $scope.fnSetTabHeight();
                        });
                    });
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnGetIssue = function (issueId) {
                    var tempObj = {
                        issueId: issueId
                    };
                    ArchivedIssueFactory.describeArchivedIssue(tempObj)
                        .then(function (response) {
                            $scope.isIssueDetailsLoaded = true;
                            response.isIssueEditMode = false;
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            $scope.issueObj = response;
                            $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                            $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                            _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                                publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                });
                            });
                            if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                $scope.isShowMainComment = true;
                            } else {
                                $scope.fnShowIssueSummary();
                            }
                            $scope.resetIssueObj = angular.copy(response);
                            $scope.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                $scope.issueSummary = _.cloneDeepWith(tempSummary);
                            });
                            $timeout(function () {
                                text = document.getElementById('newCommentBlock');
                                $scope.fnSetTabHeight();
                            });
                        }, function () {
                        })
                };

                $scope.fnShowIssueSummary = function () {
                    var tempSummary = {};
                    $scope.selectedComment = {};
                    tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                    tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                    tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                    tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                    tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                    tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                    tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                    tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                    tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                    tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                    $timeout(function () {
                        $scope.selectedComment = _.cloneDeepWith(tempSummary);
                    });
                    $scope.isShowIssueSummary = true;
                    $scope.isShowMainComment = false;
                };

                $scope.fnShowComment = function (comment, type) {
                    $scope.selectedComment = {};
                    $timeout(function () {
                        $scope.selectedComment = _.cloneDeepWith(comment);
                    }, 0);
                    $scope.isShowMainComment = type === 'mainComment';
                    $scope.isShowIssueSummary = false;
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.archives', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnInitIssue = function () {
                    $scope.isIssueDetailsLoaded = false;
                    $scope.fnGetIssue($scope.issueObj.id);
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnGetRelativeTime = function (createdDate) {
                    return moment.unix(createdDate).format("DD/MM/YYYY, HH:mm");
                };

                $scope.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                    }
                };

                $scope.fnRestoreIssue = function (issueObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/archived/modal/RestoreIssue/RestoreIssue.html',
                        size: 'lg',
                        controller: 'restoreIssueCtrl as restoreIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueId: function () {
                                return issueObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $scope.$emit('issueRestore', issueObj.id);
                    }, function () {
                    });
                };

                $scope.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce(); //eslint-disable-line
                        vega_runonce(); //eslint-disable-line
                    }, 100);
                };

                $scope.fnChangeCommentView = function (type) {
                    $scope.selectedCommentView = type;
                    if ($scope.selectedTab === 1) {
                        $timeout(function () {
                            $scope.fnSetTabHeight();
                            $scope.fnRenderMermaid();
                            if (type === 'Vertical') {
                                $timeout(function () {
                                    var objDiv = document.getElementsByClassName("vertical-comment-view")[0];
                                    objDiv.scrollTop = objDiv.scrollHeight;
                                })
                                $scope.selectedComment = {};
                            } else {
                                //$scope.selectedComment = {};
                                if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                    $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                    $scope.selectedComment.isShowComment = true;
                                    $scope.isShowMainComment = true;
                                    $scope.isShowIssueSummary = false;
                                } else {
                                    $scope.fnShowIssueSummary();
                                }
                            }
                        });
                    } else {
                        $rootScope.$emit('IssueCommentViewChangedArchived');
                    }
                };

                $scope.fnChangeIssuePublicData = function () {
                    var tempObj = {
                        issueId: $scope.issueObj.id
                    };
                    ArchivedIssueFactory.describeArchivedIssue(tempObj)
                        .then(function (response) {
                            var currntTime = moment().unix();
                            if (response.resolutionDeadlineAt) {
                                response.isResolutionDeadlinePastDate = currntTime >= response.resolutionDeadlineAt;
                                response.remainingTime = 100 * (1 - (currntTime - response.createdAt) / (response.resolutionDeadlineAt - response.createdAt));
                                var issueCreateDate = moment.unix(response.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                response.issueCreateDate = issueCreateDate;
                                response.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                var issueDeadline = moment.unix(response.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                response.issueDeadline = issueDeadline;
                                response.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                            }
                            if (response.responseDeadlineAt) {
                                response.isResponseDeadlinePastDate = currntTime >= response.responseDeadlineAt;
                                response.responseTime = 100 * (1 - (currntTime - response.updatedAt) / (response.responseDeadlineAt - response.updatedAt));
                                var issueUpdatedDate = moment.unix(response.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                response.issueUpdatedDate = issueUpdatedDate;
                                response.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                var issueResponseDeadline = moment.unix(response.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                response.issueResponseDeadline = issueResponseDeadline;
                                response.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                            }
                            response.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + response.issueDeadlineRelativeDateTime + '</b> </br>(At ' + response.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + response.issueCreateRelativeDateTime + ' </b></br> (At ' + response.issueCreateDate + ')</div>'); //eslint-disable-line*/
                            $scope.issueObj = response;
                            $scope.tabs[0].title = angular.isDefined($scope.issueObj.publicComments) ? "Public [ " + $scope.issueObj.publicComments.length + " ]" : "Public [ 0 ]";
                            $scope.tabs[1].title = angular.isDefined($scope.issueObj.privateComments) ? "Private [ " + $scope.issueObj.privateComments.length + " ]" : "Private [ 0 ]";
                            $scope.issueObj.createdDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.createdAt);
                            $scope.issueObj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime($scope.issueObj.updatedAt);
                            _.forEach($scope.issueObj.publicComments, function (publicCommentObj) {
                                publicCommentObj.userAvatar = angular.isDefined(publicCommentObj.createdBy) ? AvatarService.getTextAvatar({email: publicCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                publicCommentObj.humanDateCreated = moment.unix(publicCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                publicCommentObj.humanDateCreatedRelative = moment(publicCommentObj.humanDateCreated).fromNow();
                                publicCommentObj.humanDateCreatedAbsolute = moment.unix(publicCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                publicCommentObj.mdBody = _.cloneDeepWith(publicCommentObj.text);
                                _.forEach(publicCommentObj.subComments, function (subCommentObj) {
                                    subCommentObj.userAvatar = angular.isDefined(subCommentObj.createdBy) ? AvatarService.getTextAvatar({email: subCommentObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                                    subCommentObj.humanDateCreated = moment.unix(subCommentObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    subCommentObj.humanDateCreatedRelative = moment(subCommentObj.humanDateCreated).fromNow();
                                    subCommentObj.humanDateCreatedAbsolute = moment.unix(subCommentObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                    subCommentObj.mdBody = _.cloneDeepWith(subCommentObj.text);
                                });
                            });
                            if ($scope.issueObj.publicComments && $scope.issueObj.publicComments.length) {
                                $scope.selectedComment = _.cloneDeepWith($scope.issueObj.publicComments[$scope.issueObj.publicComments.length - 1]);
                                $scope.isShowMainComment = true;
                            } else {
                                $scope.fnShowIssueSummary();
                            }
                            $scope.resetIssueObj = angular.copy(response);
                            $scope.issueSummary = {};
                            var tempSummary = {};
                            tempSummary.createdBy = angular.isDefined($scope.issueObj.createdBy) ? $scope.issueObj.createdBy : '';
                            tempSummary.userAvatar = angular.isDefined($scope.issueObj.createdBy) ? AvatarService.getTextAvatar({email: $scope.issueObj.createdBy}) : 'assets/images/svg/logo_color.svg';
                            tempSummary.createdAt = angular.isDefined($scope.issueObj.createdAt) ? $scope.issueObj.createdAt : '';
                            tempSummary.humanDateCreated = moment.unix($scope.issueObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            tempSummary.humanDateCreatedRelative = moment(tempSummary.humanDateCreated).fromNow();
                            tempSummary.humanDateCreatedAbsolute = moment.unix($scope.issueObj.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                            tempSummary.summary = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.mdBody = _.cloneDeepWith($scope.issueObj.summary);
                            tempSummary.id = _.cloneDeepWith($scope.issueObj.id);
                            tempSummary.voteCount = _.cloneDeepWith($scope.issueObj.voteCount);
                            tempSummary.isShowComment = true;
                            $timeout(function () {
                                $scope.issueSummary = _.cloneDeepWith(tempSummary);
                            });
                            $timeout(function () {
                                text = document.getElementById('newCommentBlock');
                                $scope.fnSetTabHeight();
                            });
                            $scope.issuePublicTabAPITimeout = $timeout(function () {
                                $scope.fnChangeIssuePublicData();
                            }, 60000);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.$emit('issueRestore', $scope.issueObj.id);
                        })
                };

                $scope.issuePublicTabAPITimeout = $timeout(function () {
                    $scope.fnChangeIssuePublicData();
                }, 60000);

                var issueInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.archives') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[65] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Assignee tab
                                $scope.fnSwitchTab('Assignee');
                                codeset[38] = false;
                                codeset[65] = false;
                            } else if (codeset[38] && codeset[76] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Label tab
                                $scope.fnSwitchTab('Labels');
                                codeset[38] = false;
                                codeset[76] = false;
                            }
                        }
                    }
                };

                var issueInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.archives') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', issueInfoKeyDownEventHandler);
                document.addEventListener('keyup', issueInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel($scope.relativeTimeTimer);
                    $timeout.cancel($scope.issuePublicTabAPITimeout);
                    document.removeEventListener('keydown', issueInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', issueInfoKeyUpEventHandler);
                });
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('shippingDetailsCtrl',
            function ($http, $uibModalInstance, amaran, CartFactory, selectedPaymentMethod, isShippable) {
                var vm = this;
                vm.isPossibleAddressesLoading = false;
                vm.isCartCheckoutProcessing = false;
                vm.selectedPaymentMethod = selectedPaymentMethod;
                vm.isShippable = isShippable;
                vm.addressArr = {
                    companyName: '',
                    recipientName: '',
                    geocodedAddress: {},
                    address: '',
                    deliveryInstructions: ''
                };
                vm.selectedAddress = '';
                vm.possibleAddresses = [];
                vm.isAddressSelected = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSelectAddress = function (index) {
                    angular.forEach(vm.possibleAddresses, function (obj, indexLoop) {
                        if (indexLoop !== index) {
                            obj.isChecked = false;
                        }
                    });
                    if (vm.possibleAddresses[index].isChecked) {
                        vm.selectedAddress = vm.possibleAddresses[index];
                        vm.isAddressSelected = true;
                    } else {
                        vm.selectedAddress = '';
                        vm.isAddressSelected = false;
                    }
                };

                vm.fnGetGooglePlusCodes = function () {
                    vm.isPossibleAddressesLoading = true;
                    var input = {
                        address: vm.addressArr.address.split(' ').join('+')
                    };
                    CartFactory.describeGeocodeForAddress(input)
                        .then(function (res) {
                            vm.isPossibleAddressesLoading = false;
                            vm.possibleAddresses = res;
                        }, function () {
                            vm.isPossibleAddressesLoading = false;
                            vm.possibleAddresses = [];
                        })
                };

                vm.fnCheckout = function () {
                    vm.isCartCheckoutProcessing = true;
                    var input = {
                        body: {
                            "companyName": vm.isShippable ? vm.addressArr.companyName : '',
                            "recipientName": vm.isShippable ? vm.addressArr.recipientName : '',
                            "geocodedAddress": vm.isShippable ? vm.selectedAddress : {},
                            "deliveryInstructions": vm.isShippable ? vm.addressArr.deliveryInstructions : ''
                        }
                    };
                    if (vm.selectedPaymentMethod.defaultPaymentMethod !== true) {
                        input.paymentMethodId = vm.selectedPaymentMethod.id
                    }
                    CartFactory.checkoutCart(input)
                        .then(function (res) {
                            vm.isCartCheckoutProcessing = false;
                            $uibModalInstance.close(res);
                        }, function () {
                            vm.isCartCheckoutProcessing = false;
                        })
                };

                vm.fnInitShippingDetails = function () {
                   if (!vm.isShippable) {
                       vm.fnCheckout();
                   }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('folderInfo', fnFolderInfo)

    /** @ngInject */
    function fnFolderInfo($http, $window, $state, $stateParams, $timeout, $uibModal, microSpinner, swal, amaran, copyService, FileFactory,  postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/storage/folder/folderInfo/folderInfo.html',
            scope: {
                folderCurrentPath:'=',
                folderBreadcrumbArray:'=',
                folderObj: '=',
                filterQuery: '=',
                folderPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });
                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/storage/folder/folderInfo/folderTabs/details.html',
                        visible : true
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        if($scope.tabs[parseInt($stateParams.selectedDetailsTab)-1].visible === true){
                            $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                        }else{
                            $scope.selectedTab = 1;
                        }
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.folder', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.isFileDownloading = false;
                $scope.isFilePathCopied = true;
                $scope.directiveBreadcrumbArray = [];

                $scope.fnGetFile = function (path) {
                    var inputObj = {
                        path: path
                    };
                    FileFactory.getFile(inputObj)
                        .then(function (response) {
                            response.metadata.type =  response.metadata.type === null? "-": response.metadata.type;
                            response.metadata.encoding = response.metadata.encoding === null? "-":response.metadata.encoding;
                            response.metadata.language = response.metadata.language === null? "-":response.metadata.language;
                            response.metadata.md5 = response.metadata.md5 === null? "-":response.metadata.md5;
                            $scope.fileObj =  angular.copy(response);
                            $scope.isFolderDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isFolderDetailsLoaded = true;
                        })
                };

                $scope.fnDownloadFile = function (url,filename,fileType) {
                    $scope.isFileDownloading = true;
                    $http({
                        method : "GET",
                        url : url,
                        responseType:'blob'
                    }).then(function mySuccess(response) {
                        var file = new Blob([response.data], { type: fileType });
                        var fileURL = URL.createObjectURL(file);
                        var link=document.createElement('a');
                        link.href=fileURL;
                        link.download=filename;
                        $scope.isFileDownloading = false;
                        link.click();
                    }, function error () {

                    });
                };

                $scope.fnDeleteFile = function (folderObj) {
                    swal({
                            title: "Delete the selected file?",
                            text: "You are about to permanently delete the selected file.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    path: folderObj.path
                                };
                                FileFactory.deleteFile(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                        $scope.$emit('callReload');
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenRenameModal = function (folderObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/storage/folder/modals/renameModal/renameModal.html',
                        size: 'md',
                        controller: 'renameModalCtrl as renameModal',
                        resolve: {
                            folderObj: function () {
                                return folderObj;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        if(response === 'success') {
                            amaran.success('Renamed successfully');
                            $scope.$emit('callReload');
                        } else {
                            amaran.success('Rename was unsuccessful');
                            $scope.$emit('callReload');
                        }
                    }, function () {

                    });
                };

                $scope.fnSetCutCopyPath = function (functionType, folderObj) {
                    var copyArr = [];
                    var inputObj = {
                        function: functionType,
                        path: folderObj.path,
                        type: folderObj.type,
                        name: folderObj.name
                    };
                    copyArr.push(inputObj);
                    $scope.$emit('cutCopyEventTriggered', copyArr);
                };

                $scope.fnCheckFileType = function (folderObj, fileObj) {
                    var extensionArr = ["pdf", "jpg", "jpeg", "png", "txt", "json", "mp3"];
                    var extension = folderObj.name.split('.')[folderObj.name.split('.').length - 1];
                    var index = extensionArr.indexOf(extension);
                    if(index > -1) {
                        return true;
                    } else {
                        if(fileObj && fileObj.type && fileObj.type === "text/plain") {
                            return true;
                        } else {
                            return false;
                        }
                    }
                };

                $scope.fnOpenFileInNewTab = function (folderObj) {
                    var inputObj = {
                        path: folderObj.path
                    };
                    FileFactory.getFile(inputObj)
                        .then(function (response) {
                            var win = window.open(response.url, '_blank'); //eslint-disable-line
                            win.focus();
                            //vm.fnGetFileFromUrl(response.url, folderObj.name, response.metadata.type); //do not remove
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.fnGetFileFromUrl = function (url,filename,fileType) { //do not delete
                    $http({
                        method : "GET",
                        url : url,
                        responseType:'blob'
                    }).then(function (response) {
                        var file = new Blob([response.data], { type: fileType });
                        var fileURL = URL.createObjectURL(file);
                        var link=document.createElement('a');
                        link.target = "_blank";
                        link.href=fileURL;
                        link.click();
                    }, function error () {

                    });
                };

                $scope.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnCopyToClipboard = function (value) {
                    $scope.isFilePathCopied = false;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function() {
                        $scope.isFilePathCopied = true;
                    }, 1000)
                };

                $scope.fnInitFolder = function () {
                    $scope.isFolderDetailsLoaded = false;
                    $scope.path = $scope.folderObj.path;
                    if($scope.filterQuery.length) {
                        $scope.directiveBreadcrumbArray.push("/");
                        var tempArr = $scope.path.split("/");
                        tempArr.map(function (path) {
                            if(path.length) {
                                $scope.directiveBreadcrumbArray.push(path);
                            }
                        });
                    } else {
                        $scope.directiveBreadcrumbArray = $scope.folderBreadcrumbArray
                    }
                    if ($scope.path) {
                        $scope.fnGetFile($scope.path);
                    }
                    $scope.fnSetTabHeight();
                };
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createFolderCtrl',
            function ($scope, $timeout, amaran, FolderFactory) {

                var vm = this;
                vm.folderName = '';
                vm.title = "Create Folder";

                vm.fnCreateNewFolder = function (name) {
                    vm.isFolderCreating = true;
                    var inputObj = {
                        body: {
                            path: $scope.folder.currentPath + name + "/"
                        }
                    };
                    FolderFactory.createFolder(inputObj)
                        .then(function (resObj) {
                            vm.isFolderCreating = false;
                            $scope.folder.fnHideShowCreateForm(); //parent function
                            vm.folderName = '';
                            $timeout(function(){ // set table height
                                $scope.folder.fnSetTableHeight();//parent function
                            }, 800);
                            if($scope.folder.contentPermissionObj.List) {
                                $scope.folder.totalItems = $scope.folder.totalItems + 1;
                                $scope.folder.folderArr.push(resObj);
                                $scope.folder.fnReload();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFolderCreating = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createAccountCtrl',
            function ($scope, amaran, AccountFactory) {
                var vm = this;

                vm.title = "Create Account";
                vm.newAccountObj = {
                    user: {},
                    account: {}
                };

                vm.userObj = {};
                vm.accountObj = {name: ''};
                vm.isEmailInvalid = true;
                vm.showUserNameSuggestions = false;
                vm.isEmailInvalid = true;
                vm.isEmailAvailable = true;
                vm.isUsernameAvailable = true;
                vm.fnValidateEmail = function (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    vm.isEmailInvalid = !re.test(email);
                };
                vm.userObj = {};
                vm.accountObj = {name: ''};
                vm.isCreatingNewAccount = false;

                vm.fnCreateNewAccount = function () {
                    vm.isCreatingNewAccount = true;
                    vm.newAccountObj.user = angular.copy({
                        firstName: vm.userObj.firstName,
                        lastName: vm.userObj.lastName,
                        username: vm.userObj.username,
                        email: vm.userObj.email
                    });
                    vm.accountObj.name = vm.accountObj.name === '' ? vm.userObj.firstName + "_" + vm.userObj.lastName : vm.accountObj.name;
                    vm.newAccountObj.account = angular.copy({
                        name: vm.accountObj.name
                    });
                    AccountFactory.createNewSelfServiceAccount({body: vm.newAccountObj})
                        .then(function () {
                            amaran.success("Account created Successfully");
                            vm.isCreatingNewAccount = false;
                            $scope.$emit('accountAdded');
                        }, function (error) {
                            if (error && error.errorCode) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isCreatingNewAccount = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngCodeMirror', fnNgCodeMirror);

    /** @ngInject */
    function fnNgCodeMirror($timeout) {
        return {
            restrict: 'EA',
            scope: {
                injectModel: "=",
                indexNum: "=",
                isConfigSaved: '=',
                fnChangeModel: '&'
            },
            template: '<textarea ui-codemirror="editorOptions" ng-model="injectModel.value"></textarea>',
            transclude: true,
            link: {
                pre: function ($scope) {
                    $scope.editorOptions = {
                        lineNumbers: true,
                        lineWrapping: true,
                        mode: "application/ld+json",
                        gutters: ["CodeMirror-lint-markers"],
                        /* lint: true,*/
                        /* autofocus: true,*/
                        onLoad: function (_cm) {
                            $scope.cmObj = _cm;
                            $scope.modeChanged = function () {
                                $timeout(function () {
                                    $scope.cmObj.refresh();
                                }, 0)

                            };
                        }
                    };

                    $scope.$watch('injectModel', function (newValue, oldValue) {
                        if (newValue.value !== oldValue.value) {
                            $scope.fnChangeModel({kvpPair: newValue, index: $scope.indexNum});
                            $scope.isConfigSaved = false;
                        }
                    }, true);
                },
                post: function ($scope) {
                    $scope.modeChanged();
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('workflowInfo', fnWorkflowInfo)

    /** @ngInject */
    function fnWorkflowInfo($window, $state, $timeout, $stateParams, $uibModal, microSpinner,
                            draw2d, swal, amaran, DB, WorkflowFactory, copyService,postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/pipeline/workflows/workflowInfo/workflowInfo.html',
            scope: {
                workflowObj: '=',
                workflowPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                    $scope.fnGetPreviewDivHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [{
                    title: 'Details',
                    tabIndex: 1,
                    templateUrl: 'app/pipeline/workflows/workflowInfo/workflowTabs/details.html'
                    },
                    {
                        title: 'Logging',
                        tabIndex: 2,
                        templateUrl: 'app/pipeline/workflows/workflowInfo/workflowTabs/logging.html'
                    },
                    {
                        title: 'Roles',
                        tabIndex: 3,
                        templateUrl: 'app/pipeline/workflows/workflowInfo/workflowTabs/roles.html'
                    }];
                $scope.clonedCanvas = null;
                $scope.isCloneCompleted = true;
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.isLoggingUpdateCompleted = true;
                $scope.isLogginDetailsEditable = false;
                var resetLoggingData;

                /* START:  Draw2d Canvas editor section*/
                document.addEventListener('onInitCanvas', function (e) {
                    var userDataObj = e.detail;
                    if (userDataObj.category === "TRIGGER") {
                        $scope.triggerCount = true;
                    }
                });

                /*eslint-disable*/
                $scope.editor = {
                    /*eslint-enable*/
                    // Configuration of the editor
                    canvas: {
                        //Method to Get canvas in controller on Initialization
                        fnInit: function (canvas) {
                            $scope.clonedCanvas = canvas;
                            /*$timeout(function () {
                                $scope.fnInitModel();
                            })*/
                        },
                        jsonRead: function (canvas, jsonData) {
                            var reader = new draw2d.io.json.Reader();
                            reader.unmarshal(canvas, jsonData);
                        }
                    }
                };

                $scope.fnGetWorkflow = function (workflowId) {
                    var inputObj = {
                        workflowId: workflowId
                    };
                    WorkflowFactory.getWorkflow(inputObj)
                        .then(function (response) {
                            $scope.workflowObj = response;
                            resetLoggingData = angular.copy($scope.workflowObj.logging.enabled);
                            if (angular.isUndefined($scope.workflowObj.description)) {
                                $scope.workflowObj.description = '';
                            }
                            $scope.isWorkflowDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnGetPreviewDivHeight();
                                $timeout(function () {
                                    if ($scope.workflowObj) {
                                        var newEvent = new CustomEvent(
                                            "callFromModelView", {
                                                detail: true
                                            }
                                        );
                                        document.dispatchEvent(newEvent);
                                        $scope.editor.canvas.jsonRead($scope.clonedCanvas, $scope.workflowObj.flow);
                                    }
                                })
                            });
                        }, function () {
                            $scope.isWorkflowDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.workflows', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateWorkflowDetails = function (workflowObj) {
                    var inputObj = {
                        body: {},
                        workflowId: workflowObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(workflowObj.description)) {
                        workflowObj.description = '';
                    }
                    inputObj.body = {
                        name: workflowObj.name,
                        description: workflowObj.description
                    };
                    WorkflowFactory.modifyWorkflow(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('WorkflowDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Workflow Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnUpdateWorkflowLoggingDetails = function (workflowObj) {
                    var inputObj = {
                        body: {},
                        workflowId: workflowObj.id
                    };
                    $scope.isLoggingUpdateCompleted = false;
                    $scope.isLogginDetailsEditable = false;
                    inputObj.body = {
                        logging: {
                            enabled: workflowObj.logging.enabled
                        }
                    };
                    WorkflowFactory.modifyWorkflow(inputObj)
                        .then(function (res) {
                            resetLoggingData = angular.copy(res.logging.enabled);
                            $scope.isLoggingUpdateCompleted = true;
                            amaran.success("Workflow Logging Details Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isLoggingUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteWorkflow = function (workflowObj) {
                    swal({
                            title: "Delete the selected workflow?",
                            text: "You are about to permanently delete the selected workflow.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    workflowId: workflowObj.id
                                };
                                WorkflowFactory.deleteWorkflow(inputObj)
                                    .then(function () {
                                        $scope.$emit('WorkflowDeleted', workflowObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function () {
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnEnableLoggingEditable = function () {
                    $scope.isLogginDetailsEditable = true;
                };

                $scope.fnCancelEditing = function () {
                    $scope.workflowObj.logging.enabled = angular.copy(resetLoggingData);
                    $scope.isDetailsEditable = false;
                    $scope.isLogginDetailsEditable = false;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetPreviewDivHeight = function () {
                    if (angular.element(".tabContent")[0] && angular.element("#wfFormDiv")[0] &&
                        angular.element('#wfActionsDiv')[0] && angular.element('#wfEditActionsDiv')[0]) {
                        var finalHeight = angular.element(".tabContent")[0].offsetHeight -
                            (angular.element("#wfFormDiv")[0].offsetHeight + angular.element("#wfActionsDiv")[0].offsetHeight +
                                angular.element('#wfEditActionsDiv')[0].offsetHeight) - 20;
                        angular.element("#wfPreviewDiv").css('max-height', finalHeight + 'px');
                    }
                };

                $scope.fnCloneWorkFlow = function (workflowObj) {
                    $scope.isCloneCompleted = false;
                    var newEvent = new CustomEvent(
                        "callFromModelView", {
                            detail: false
                        }
                    );
                    document.dispatchEvent(newEvent);
                    $timeout(function () {
                        if (workflowObj.roles) {
                            delete workflowObj.roles;
                        }
                        var regexp = /^([A-Z|a-z|0-9`~!@#$%^&*()_|+\-=?;:' ",.<>\{\}\[\]\\\/]+)( - [1-9]+)$/;
                        var filterName = '';
                        if (regexp.test(workflowObj.name)) {
                            filterName = workflowObj.name.substring(0, workflowObj.name.lastIndexOf(" - "));
                        } else {
                            filterName = workflowObj.name;
                        }
                        var inputObj = {
                            perPage: 0,
                            filter: 'contains(#{name}, ${' + filterName + '})'
                        };
                        WorkflowFactory.getWorkflows(inputObj)
                            .then(function (res) { // Success block
                                $scope.workFlowsArr = angular.copy(res);
                                var count = 0;
                                var filterName = '';
                                if (regexp.test(workflowObj.name)) {
                                    filterName = workflowObj.name.substring(0, workflowObj.name.lastIndexOf(" - "));
                                } else {
                                    filterName = workflowObj.name;
                                }
                                var index = 0;
                                _.forEach($scope.workFlowsArr, function (workFlowObj) {
                                    if (regexp.test(workFlowObj.name)) {
                                        if (workFlowObj.name.substring(0, workFlowObj.name.lastIndexOf(" - ")) === filterName) {
                                            count++;
                                            var tempIndex = Number(workFlowObj.name.substring(workFlowObj.name.lastIndexOf(" - ") + 3, workFlowObj.name.length));
                                            if (tempIndex > index) {
                                                index = tempIndex
                                            }
                                        }
                                    } else if (workFlowObj.name === filterName) {
                                        count++;
                                        index = index === 0 ? 1 : index;
                                    }
                                });
                                index = count === 1 ? 1 : (index + 1);
                                workflowObj.name = count === 1 ? workflowObj.name + ' - 1' : filterName + ' - ' + index;
                                if (regexp.test(workflowObj.description)) {
                                    workflowObj.description = workflowObj.description.substring(0, workflowObj.description.lastIndexOf(" - ")) + ' - ' + index;
                                } else {
                                    workflowObj.description = count === 1 ? workflowObj.description + ' - 1' : workflowObj.description + ' - ' + index;
                                }
                                DB.fnSet("ClonedWorkFlowObj", angular.copy(workflowObj));
                                $scope.isCloneCompleted = true;
                                $state.go("main.createWorkFlow");
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                $scope.isCloneCompleted = true;
                            });
                    })
                };

                $scope.fnPreviewWorkFlow = function (workflowObj, id) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/modals/previewWorkFlow/previewWorkFlow.html',
                        size: 'overlay',
                        controller: 'previewWorkFlowCtrl as previewWorkFlow',
                        resolve: {
                            workflowId: function () {
                                return id;
                            }
                        }
                    });
                    modalInstance.result.then(function (isCalledForClone) {
                        if (isCalledForClone) {
                            $timeout(function () {
                                $scope.fnCloneWorkFlow($scope.workflowObj);
                            }, 1000)
                        }
                    }, function () {
                    });

                };

                $scope.fnInitWorkflow = function () {
                    $scope.isWorkflowDetailsLoaded = false;
                    $scope.workflowId = $scope.workflowObj.id;
                    if ($scope.workflowId) {
                        $scope.fnGetWorkflow($scope.workflowId);
                    }
                    $scope.fnSetTabHeight();
                };

                var workflowInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.workflows') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.workflowPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteWorkflow($scope.workflowObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.workflowPermissionsObj.Modify &&
                                !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var workflowInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.workflows') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', workflowInfoKeyDownEventHandler);
                document.addEventListener('keyup', workflowInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    var newEvent = new CustomEvent(
                        "callFromModelView", {
                            detail: false
                        }
                    );
                    document.dispatchEvent(newEvent);
                    document.removeEventListener('keydown', workflowInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', workflowInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createWorkFlowCtrl',
            function ($window, $scope, $timeout, $base64, $stateParams, $state, $http, $uibModal, microSpinner, swal, amaran, draw2d, DB, FilterQueryService, componentService, ColorService, StateFactory, ListenerFactory, WorkflowFactory) {
                var vm = this;
                var isImportFunctionalityWorking = false;
                vm.isCalledFromTidy = false;
                vm.isStateSelectedOnCanvas = false;
                vm.stateOrderArr = ["TRIGGER", "FUNCTION", "SERVICE", "OUTPUT"];
                vm.isStatesLoading = false;
                vm.stateParamDraftName = null;
                vm.allStatesFromChoice = {};
                vm.statesArr = [];
                vm.selectedStateFigure = null;
                var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
                var appCount = 0;
                vm.modelsObj = {};
                vm.isListenerModelsLoading = true;
                vm.isWorkfolwSave = false;
                vm.selectedStateInputsArr = [];
                // search states client side
                vm.search = '';
                vm.triggerCount = false;
                /*Configure Variables: START*/
                vm.configureObj = {};
                vm.savedStashArr = ["#initial"];
                vm.savedStashObj = {};
                vm.stashName = '';
                vm.loadArr = [
                    {
                        key: '',
                        value: ''
                    }
                ];

                vm.injectArr = [
                    {
                        key: '',
                        value: '',
                        injectMap: '',
                        isJsonIndex: true,
                        injectMapWith$: ''
                    }
                ];
                vm.isConfigSaved = false;
                /*Configure Variables: END*/

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Type",
                        fieldName: "type"
                    },
                    {
                        fieldDisplayName: "Category",
                        fieldName: "category"
                    },
                    {
                        fieldDisplayName: "Information",
                        fieldName: "info"
                    }
                ];
                vm.filterQuery = "";

                /*Workflow Variables: START*/
                vm.newWorkFlowObj = {
                    name: '',
                    description: '',
                    flow: [],
                    logging: {
                        enabled: false
                    }
                };
                var resetWorkFlowObj = angular.copy(vm.newWorkFlowObj);
                vm.isWorkflowsCreating = false;
                vm.isWorkflowValidating = false;
                vm.isValidateSuccessful = null;
                vm.isRefreshMdEditor = false;
                vm.isStateInfoLoaded = false;
                vm.stateInfoObj = null;
                /*Workflow Variables: END*/

                /*Connector Variables: START*/
                vm.queryBuilder = {"condition": "AND", "rules": []};
                vm.connectorExpressionObj = {};
                vm.isConnectorSaved = false;
                vm.connectorFieldExpArr = [];
                /*Connector Variables: END*/

                /*MarkDown Editor Variable*/
                vm.markedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview"
                };
                vm.draftsOptions = DB.fnGet('WorkflowsSavedDrafts') ? DB.fnGet('WorkflowsSavedDrafts') : {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSaveWorkflowDetails = function () {
                    if (vm.stateParamDraftName) {
                        vm.fnGetJson(vm.flowJson);
                        vm.draftsOptions[vm.stateParamDraftName] = vm.newWorkFlowObj;
                        DB.fnSet("WorkflowsSavedDrafts", vm.draftsOptions);
                        vm.draftsOptions = DB.fnGet("WorkflowsSavedDrafts");
                        vm.repeatativeTimer = $timeout(function () {
                            vm.fnSaveWorkflowDetails();
                        }, 10000)
                    }
                };

                //Function to test if the given value is Json or not
                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.fnFilterQueryChanged = function (filterQuery) {
                    $scope.editor.palette.figuresObj = null;
                    vm.filterQuery = filterQuery;

                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {};
                    }
                    vm.fnGetStates(inputObj);
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel1")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel1")[0].offsetHeight;
                        var finalHeight = total - (search + 30);
                        angular.element(".accordionWithScroll").css('height', finalHeight + 'px');
                    }
                };

                vm.createPort = function (type, locator, stateFigure, singleOut) {
                    var newPort = null;
                    var count = 0;

                    switch (type) {
                        case "input":
                            newPort = draw2d.Configuration.factory.createInputPort(this); //eslint-disable-line
                            count = stateFigure.inputPorts.getSize();
                            break;
                        case "output":
                            newPort = draw2d.Configuration.factory.createOutputPort(this); //eslint-disable-line
                            count = stateFigure.outputPorts.getSize();
                            if (singleOut) {
                                newPort.setMaxFanOut(1);
                            }
                            break;
                        case "hybrid":
                            newPort = draw2d.Configuration.factory.createHybridPort(this); //eslint-disable-line
                            count = stateFigure.hybridPorts.getSize();
                            break;
                        default:
                            throw "Unknown type [" + type + "] of port requested";
                    }

                    newPort.setName(type + "_" + stateFigure.userData.type + "_" + count);

                    stateFigure.addPort(newPort, locator);
                };

                vm.fnAddDefaultStashName = function (val) {
                    var tempVal = val.replace(/[`~!@#$%^&*()_|+\-=?;:' ",.<>\{\}\[\]\\\/]/gi, '-');
                    var str = tempVal.replace("--", "-").toLowerCase();
                    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";
                    var text = "";
                    for (var i = 0; i < 3; i++) {
                        text += possible.charAt(Math.floor(Math.random() * possible.length));
                    }
                    if(str.endsWith("-")) {
                        return str + text;
                    } else {
                        return str + "-" + text
                    }
                };

                // vm.getShape = function (shape, type, name, color, icon) {
                vm.getShape = function (stateObj) {
                    var shape = stateObj.shape;
                    var type = stateObj.class;
                    var name = stateObj.name;
                    var color = stateObj.color ? stateObj.color : "#00ff00";
                    var icon = stateObj.icon;

                    var stateFigure = eval("new " + shape + "();");
                    stateFigure.addCssClass("draw2d-container");

                    switch (type) {
                        case "HorizontalLayout":
                            //Icon
                            var iconImage = new draw2d.shape.basic.Image({
                                minWidth: 20,
                                minHeight: 20
                            });
                            iconImage.setPath('data:image/svg+xml;base64,' + icon);

                            //Label
                            var nameLabel = new draw2d.shape.basic.Label({text: name});
                            nameLabel.attr({
                                stroke: 0,
                                fontColor: ColorService.getContrastTextColor(color)
                            });
                            nameLabel.installEditor(new draw2d.ui.LabelInplaceEditor());
                            nameLabel.addCssClass("draw2d-text");

                            //Icon Container
                            var iconContainer = new draw2d.shape.layout.VerticalLayout({
                                padding: 6,
                                bgColor: ColorService.getDark(color, 15),
                                stroke: 1
                            });
                            iconContainer.add(iconImage, new draw2d.layout.locator.CenterLocator());
                            iconContainer.addCssClass("draw2d-icon");

                            //Label Container
                            var labelContainer = new draw2d.shape.layout.VerticalLayout({
                                padding: 6,
                                bgColor: color
                            });
                            labelContainer.add(nameLabel, new draw2d.layout.locator.CenterLocator());
                            labelContainer.addCssClass("draw2d-label");

                            stateFigure.add(iconContainer); //add Icon Container
                            stateFigure.add(labelContainer); //add Label Container

                            if (stateObj.category !== 'TRIGGER') {
                                /*Load: Start*/
                                var loadContainer = new draw2d.shape.layout.VerticalLayout({
                                    padding: 4,
                                    bgColor: color
                                });
                                var loadImage  = new draw2d.shape.basic.Image({
                                    minWidth: 10,
                                    minHeight: 10
                                });
                                loadImage.setPath('assets/images/svg/gear.svg');
                                loadImage.addCssClass("draw2d-modal-icon load-icon");
                                loadImage.on("click", function () {
                                    var connections = stateFigure.getConnections();
                                    vm.fnActionIconSelected('load', stateFigure, userDataObj, connections);
                                });
                                loadContainer.add(loadImage, new draw2d.layout.locator.CenterLocator());
                                loadContainer.addCssClass("draw2d-action-icon");
                                stateFigure.add(loadContainer);
                                /*Load: End*/

                                if(stateObj.type !== 'FAIL' && stateObj.type !== 'SUCCEED') {
                                    /*State Condition: Start*/
                                    var stateConditionContainer = new draw2d.shape.layout.VerticalLayout({
                                        padding: 4,
                                        bgColor: color
                                    });
                                    var stateConditionImage  = new draw2d.shape.basic.Image({
                                        minWidth: 10,
                                        minHeight: 10
                                    });
                                    stateConditionImage.setPath('assets/images/svg/exclamation.svg');
                                    stateConditionImage.addCssClass('stateCondition-icon');
                                    stateConditionContainer.add(stateConditionImage, new draw2d.layout.locator.CenterLocator());
                                    stateConditionContainer.addCssClass("draw2d-action-icon");
                                    /*State Condition: End*/
                                }
                            }
                            stateFigure.attr({
                                stroke: 2,
                                bgColor: color,
                                radius: 4,
                                padding: 0
                            });
                            var userDataObj = {
                                "id": stateObj.id,
                                "sudoId": stateObj.id + Date.now(),
                                "type": stateObj.type,
                                "category": stateObj.category,
                                "name": stateObj.name,
                                "inputs": stateObj.inputs ? FilterQueryService.fnGetWorkflowStateArr(stateObj.inputs, _.cloneDeep(vm.modelsObj), true) : [],
                                "outputs": stateObj.outputs ? FilterQueryService.fnGetWorkflowStateArr(stateObj.outputs, _.cloneDeep(vm.modelsObj)) : [],
                                "parameters": {}
                            };

                            if(stateObj.type !== 'WAIT' && stateObj.type !== 'CHOICE' && stateObj.category !== 'TRIGGER') {
                                userDataObj.parameters.stash = vm.fnAddDefaultStashName(stateObj.name);
                                var stash = userDataObj.parameters.stash;
                                var tempStashArr = [];
                                if (!stash.startsWith("#")) {
                                    stash = "#" + stash
                                }
                                if (userDataObj.outputs) {
                                    tempStashArr.push(stash);
                                    angular.forEach(userDataObj.outputs, function (output) {
                                        if (tempStashArr.indexOf(output.replace("$", stash)) === -1) {
                                            tempStashArr.push(output.replace("$", stash));
                                        }
                                    })
                                } else {
                                    tempStashArr.push(stash);
                                }
                                vm.savedStashObj[userDataObj.sudoId] = tempStashArr;
                                vm.configureObj[userDataObj.sudoId] = userDataObj;
                            }

                            if (userDataObj.category === "TRIGGER" && userDataObj.outputs.length) {
                                var tempArr = [];
                                var triggerStash = "#initial";
                                angular.forEach(userDataObj.outputs, function (output) {
                                    if (tempArr.indexOf(output.replace("$", triggerStash)) === -1) {
                                        tempArr.push(output.replace("$", triggerStash));
                                    }
                                });
                                vm.savedStashObj[userDataObj.sudoId] = tempArr;
                                tempArr = [];
                            }

                            stateFigure.setUserData(userDataObj);
                            if (stateObj.category !== 'TRIGGER' && stateObj.type !== 'FAIL' &&
                                stateObj.type !== 'SUCCEED') {
                                stateConditionImage.setId(userDataObj.sudoId);
                                stateFigure.add(stateConditionContainer);
                            }
                            if (stateObj.inPort) {
                                vm.createPort('input', draw2d.layout.locator.InputPortLocator, stateFigure);
                            }
                            if (stateObj.outPort) {
                                vm.createPort('output', draw2d.layout.locator.OutputPortLocator, stateFigure, stateObj.singleOut);
                            }
                            stateFigure.on("removed", function () {
                                if (vm.selectedStateObj && stateFigure.userData.sudoId === vm.selectedStateObj.sudoId) {
                                    vm.selectedStateObj = null;
                                    vm.isStateSelectedOnCanvas = false;
                                }
                                if (stateFigure.userData.category === "TRIGGER" && !vm.isCalledFromTidy) {
                                    vm.triggerCount = false;
                                    if(isImportFunctionalityWorking === false){
                                        vm.fnOpenWorkflowTriggersModal();
                                    }
                                } else {
                                    $timeout(function () {
                                        vm.isCalledFromTidy = false;
                                    }, 1000)
                                }
                                if (vm.savedStashObj[stateFigure.userData.sudoId]) {
                                    delete vm.savedStashObj[stateFigure.userData.sudoId];
                                }
                                if (vm.configureObj[stateFigure.userData.sudoId]) {
                                    delete vm.configureObj[stateFigure.userData.sudoId];
                                }
                            });

                            stateFigure.on("click", function () {
                                var connections = stateFigure.getConnections();
                                vm.selectedStateFigure = stateFigure;
                                vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                            });

                            iconContainer.on("click", function () {
                                var connections = stateFigure.getConnections();
                                vm.selectedStateFigure = stateFigure;
                                vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                            });

                            labelContainer.on("click", function () {
                                var connections = stateFigure.getConnections();
                                vm.selectedStateFigure = stateFigure;
                                vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                            });

                            iconImage.on("click", function () {
                                var connections = stateFigure.getConnections();
                                vm.selectedStateFigure = stateFigure;
                                vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                            });

                            nameLabel.on("click", function () {
                                var connections = stateFigure.getConnections();
                                vm.selectedStateFigure = stateFigure;
                                vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                            });

                    }
                    return stateFigure;
                };

                vm.fnGetConnectionsHierarchy = function (arr, sudoId, isInitialCall, isCalledForModal, modalType) {
                    var subConnections = [];
                    if (isInitialCall) {
                        vm.connectionsArr = [];
                    }
                    angular.forEach(arr, function (connectionObj) {
                        if (connectionObj.sourcePort.parent.userData.sudoId !== sudoId) {
                            vm.connectionsArr.push(connectionObj.sourcePort.parent);
                            var sub = connectionObj.sourcePort.parent.getConnections();
                            if (sub.data && sub.data.length) {
                                angular.forEach(sub.data, function (subObj) {
                                    if (subObj.sourcePort.parent.userData.sudoId !== connectionObj.sourcePort.parent.userData.sudoId &&
                                        subObj.sourcePort.parent.userData.sudoId !== sudoId) {
                                        subConnections.push(subObj);
                                    }
                                })
                            }
                        }
                    });
                    if (subConnections.length) {
                        vm.fnGetConnectionsHierarchy(subConnections, sudoId, false, isCalledForModal, modalType);
                    } else {
                        var tempArr = [];
                        angular.forEach(vm.connectionsArr, function (connectionObj) {
                            if (tempArr.indexOf(connectionObj.userData.sudoId) === -1) {
                                tempArr.push(connectionObj.userData.sudoId);
                                if (vm.savedStashObj[connectionObj.userData.sudoId]) {
                                    vm.savedStashArr.push.apply(vm.savedStashArr, vm.savedStashObj[connectionObj.userData.sudoId])
                                }
                            }
                        });
                        if(isCalledForModal) {
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                            $timeout(function () {
                                if (modalType === 'load') {
                                    vm.fnOpenLoadModal();
                                }
                            },100)
                        }
                    }
                };

                vm.fnSetConfigOptions = function (selectedStateObj, connections, isCalledForModal, modalType) {
                    if (selectedStateObj.parameters && selectedStateObj.parameters.stash) {
                        vm.stashName = selectedStateObj.parameters.stash;
                    } else {
                        vm.stashName = '';
                    }

                    if (selectedStateObj.parameters && selectedStateObj.parameters.load) {
                        vm.loadArr = [];
                        Object.keys(selectedStateObj.parameters.load).forEach(function (key) {
                            var inputObj = {
                                key: key
                            };
                            if (selectedStateObj.type === 'CHOICE') {
                                if (!selectedStateObj.parameters.load[key].startsWith('#')) {
                                    var flag = false;
                                    var stateName = '';
                                    angular.forEach(vm.statesArr, function (state) {
                                        if (state.id === selectedStateObj.parameters.load[key]) {
                                            flag = true;
                                            stateName = state.name;
                                        }
                                    });
                                    if (flag) {
                                        inputObj.value = stateName;
                                    } else {
                                        inputObj.value = selectedStateObj.parameters.load[key];
                                    }
                                } else {
                                    inputObj.value = selectedStateObj.parameters.load[key];
                                }
                            } else {
                                inputObj.value = selectedStateObj.parameters.load[key];
                            }
                            vm.loadArr.push(inputObj);
                        });
                        vm.loadArr.push({
                            key: '',
                            value: ''
                        })
                    } else {
                        vm.loadArr = [
                            {
                                key: '',
                                value: ''
                            }
                        ];
                    }

                    if (selectedStateObj.parameters && selectedStateObj.parameters.inject) {
                        vm.injectArr = [];
                        Object.keys(selectedStateObj.parameters.inject).forEach(function (key) {
                            var inputObj = {
                                key: key,
                                value: '',
                                injectMap: '',
                                isJsonIndex: true,
                                injectMapWith$: ''
                            };
                            var flag = isJson(selectedStateObj.parameters.inject[key]);

                            if (flag) {
                                inputObj.value = angular.toJson(selectedStateObj.parameters.inject[key], true);
                            } else {
                                inputObj.value = selectedStateObj.parameters.inject[key];
                            }
                            vm.injectArr.push(inputObj);
                        });
                        vm.injectArr.push({
                            key: '',
                            value: '',
                            injectMap: '',
                            isJsonIndex: true,
                            injectMapWith$: ''
                        })
                    } else {
                        vm.injectArr = [
                            {
                                key: '',
                                value: '',
                                injectMap: '',
                                isJsonIndex: true,
                                injectMapWith$: ''
                            }
                        ];
                    }
                    vm.savedStashArr = ["#initial"];
                    if (connections && connections.data.length) {
                        vm.fnGetConnectionsHierarchy(connections.data, selectedStateObj.sudoId, true, isCalledForModal, modalType);
                    } else {
                        if (Object.keys(vm.savedStashObj).length) {
                            Object.keys(vm.savedStashObj).forEach(function (key) {
                                if (key !== selectedStateObj.sudoId) {
                                    vm.savedStashArr.push.apply(vm.savedStashArr, vm.savedStashObj[key])
                                }
                            });
                        }
                        if(isCalledForModal) {
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                            $timeout(function () {
                                if (modalType === 'load') {
                                    vm.fnOpenLoadModal();
                                }
                            },100)
                        }
                    }
                    vm.isStateMdInfoLoaded = true;
                    $timeout(function () {
                        vm.isRefreshMdEditor = false;
                    })
                };

                vm.fnOpenLoadModal = function () {
                    vm.fnGetJson(vm.flowJson);
                    if (vm.selectedStateObj.type === "CHOICE") {
                        var connectionsFromChoice = vm.selectedStateFigure.getConnections();
                    }
                    //.children[0].text
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/createWorkFlow/modals/loadModal/loadModal.html',
                        size: 'lg',
                        controller: 'loadModalCtrl as loadModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            markdownOptionsObj: function () {
                                return vm.markedOptionObj
                            },
                            selectedStateObj: function () {
                                return vm.selectedStateObj
                            },
                            allStatesFromChoice: function () {
                                return vm.allStatesFromChoice
                            },
                            loadArr: function () {
                                return vm.loadArr
                            },
                            savedStashArr: function () {
                                return vm.savedStashArr
                            },
                            flowJson: function () {
                                return vm.newWorkFlowObj.flow
                            },
                            configureObj: function () {
                                return vm.configureObj;
                            },
                            connectionsFromChoice: function () {
                                return connectionsFromChoice
                            },
                            injectArr: function () {
                                return vm.injectArr
                            },
                            stashName: function () {
                                return vm.stashName
                            },
                            selectedStateName: function () {
                                return vm.selectedStateFigure.children.data[1].figure.children.data[0].figure.text
                            },
                            selectedStateInputsArr: function () {
                                return vm.selectedStateInputsArr;
                            }
                        }
                    });
                    modalInstance.result.then(function (data) {
                        vm.loadArr = data[0];
                        vm.injectArr = data[1];
                        vm.stashName = data[2];
                        vm.fnSaveConfiguration();
                    }, function () {});
                };

                vm.fnActionIconSelected = function(type, selectedStateFigure, userDataObj, connections) {
                    swal({
                        title: "Please wait while your data loads...",
                        type: "warning",
                        showConfirmButton: true,
                        showLoaderOnConfirm: true
                    });
                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                    angular.element(".confirm").css("visibility", "hidden");
                    if(!vm.selectedStateObj || (vm.selectedStateObj && vm.selectedStateObj.sudoId !== userDataObj.sudoId)) {
                        vm.selectedStateFigure = selectedStateFigure;
                        vm.fnGetSelectedStateInformation(userDataObj, connections, true, true, type);
                    } else {
                        vm.fnGetSelectedStateInformation(userDataObj, connections, false, true, type);
                    }
                };

                vm.fnGetSelectedStateInformation = function (userDataObj, connections, isCalledForMdInfo, isCalledForModal, modalType) {
                    if(isCalledForMdInfo) {
                        vm.isStateMdInfoLoaded = false;
                    }
                    vm.isStateMdInfoLoaded = false;
                    if (angular.isDefined(userDataObj)) {
                        vm.isConfigSaved = false;
                        vm.isRefreshMdEditor = true;
                        vm.isStateSelectedOnCanvas = true;
                        vm.stateInfoObj = null;
                        if (angular.isDefined(vm.configureObj[userDataObj.sudoId])) {
                            vm.selectedStateObj = vm.configureObj[userDataObj.sudoId];
                        } else {
                            vm.selectedStateObj = userDataObj;
                        }
                        if(isCalledForMdInfo) {
                            StateFactory.getState({stateId: vm.selectedStateObj.id})
                                .then(function (response) {
                                    if (angular.isUndefined(response.info) || response.info === 'TODO') {
                                        vm.selectedStateObj.mdInfo = 'No Information';
                                    } else {
                                        // triggers Input Arr
                                        var triggersInputArr = FilterQueryService.fnGetWorkflowInputOutputInfo(response.inputs, _.cloneDeep(vm.modelsObj), 'Input', true);
                                        vm.selectedStateInputsArr = angular.copy(triggersInputArr);
                                        var inputIndexArray = componentService.getUniqueIndexForTriggersModal(triggersInputArr);
                                        var inputTreeData = componentService.getHierarchyForTriggersModal(inputIndexArray, triggersInputArr);
                                        var tempArr = [];
                                        angular.forEach(inputTreeData, function (nestedObj) {
                                            if (nestedObj.index === '$') {
                                                tempArr.push.apply(tempArr, nestedObj.children)
                                            } else if (nestedObj.index === '*$') {
                                                tempArr.push.apply(tempArr, nestedObj.children)
                                            } else {
                                                tempArr.push(nestedObj);
                                            }
                                        });
                                        // triggers Output Arr
                                        var triggersOutputArr = FilterQueryService.fnGetWorkflowInputOutputInfo(response.outputs, _.cloneDeep(vm.modelsObj), 'Output', true);
                                        var outputIndexArray = componentService.getUniqueIndexForTriggersModal(triggersOutputArr);
                                        var outputTreeData = componentService.getHierarchyForTriggersModal(outputIndexArray, triggersOutputArr);
                                        var tempOutputTreeData = [];
                                        angular.forEach(outputTreeData, function (nestedObj) {
                                            if (nestedObj.index === '$') {
                                                tempOutputTreeData.push.apply(tempOutputTreeData, nestedObj.children)
                                            } else if (nestedObj.index === '*$') {
                                                tempOutputTreeData.push.apply(tempOutputTreeData, nestedObj.children)
                                            } else {
                                                tempOutputTreeData.push(nestedObj);
                                            }
                                        });
                                        var tempMdInfo = $base64.decode(response.info);
                                        tempMdInfo = tempMdInfo.replace("<input-table>", fnCreateTreeView(angular.copy(tempArr)));
                                        tempMdInfo = tempMdInfo.replace("<output-table>", fnCreateTreeView(angular.copy(tempOutputTreeData)));
                                        vm.selectedStateObj.mdInfo = tempMdInfo;
                                    }
                                    vm.fnSetConfigOptions(vm.selectedStateObj, connections, isCalledForModal, modalType);
                                }, function () {
                                    vm.selectedStateObj.mdInfo = 'No Information';
                                    vm.fnSetConfigOptions(vm.selectedStateObj, connections, isCalledForModal, modalType);
                                });
                        } else {
                            vm.fnSetConfigOptions(vm.selectedStateObj, connections, isCalledForModal, modalType);
                        }
                    }
                };

                function fnCreateTreeView(workflowOutputsArr) {
                    var temp = '<ul class="tree">';
                    _.forEach(workflowOutputsArr, function (obj) {
                        temp = temp + '<li>' + (obj.index.includes('.') ? obj.index.split('.')[obj.index.split('.').length - 1] : obj.index) + ' ' + (obj.required === 'yes' ? '`(required)`' : '') + ' ' + (obj.type ? '`(' + obj.type + ')`' : '');
                        if (obj.children) {
                            temp = temp + '<ul>';
                            temp = temp + fnCreateChildrenTreeView(obj.children);
                        } else {
                            temp = temp + ' <br><div class="p-l-20">' + (obj.description ? obj.description : '') + '</div></li>';
                        }
                    });
                    return temp + '</ul></br>';
                }

                function fnCreateChildrenTreeView(objTree) {
                    var temp = '';
                    _.forEach(objTree, function (obj) {
                        temp = temp + '<li>' + (obj.index.includes('.') ? obj.index.split('.')[obj.index.split('.').length - 1] : obj.index) + ' ' + (obj.required === 'yes' ? '`(required)`' : '') + ' ' + (obj.type ? '`(' + obj.type + ')`' : '');
                        if (obj.children) {
                            temp = temp + '<ul>';
                            temp = temp + fnCreateChildrenTreeView(obj.children, temp);
                        } else {
                            temp = temp + ' <br><div class="p-l-20">' + (obj.description ? obj.description : '') + '</div></li>';
                        }
                    });
                    return temp + '</ul></li>';
                }

                vm.fnConnectorClick = function (connectorObj) {
                    vm.connectorFieldExpArr = [];
                    var operators = ['equal',
                        'not_equal',
                        'in',
                        'not_in',
                        'start',
                        'not_start',
                        'end',
                        'not_end',
                        'less',
                        'less_or_equal',
                        'greater',
                        'greater_or_equal'];
                    if (connectorObj && connectorObj.sourcePort.parent.userData &&
                        connectorObj.sourcePort.parent.userData.parameters && connectorObj.sourcePort.parent.userData.parameters.load && connectorObj.sourcePort.parent.userData.parameters.load['$.payload']) {
                        var tempLoadValue = connectorObj.sourcePort.parent.userData.parameters.load['$.payload'];
                        if (tempLoadValue.startsWith("#")) {
                            tempLoadValue = tempLoadValue.split("#")[1];
                        }
                        var savedStashArr = ["#initial"];
                        if (Object.keys(vm.savedStashObj).length) {
                            Object.keys(vm.savedStashObj).forEach(function (key) {
                                savedStashArr.push.apply(savedStashArr, vm.savedStashObj[key]);
                            });
                        }
                        angular.forEach(savedStashArr, function (stashValue) {
                            if (stashValue.includes(tempLoadValue)) {
                                if (stashValue.startsWith("#" + tempLoadValue + ".")) {
                                    var dropDownValue = '';
                                    if (vm.connectorFieldExpArr.indexOf(dropDownValue) === -1) {
                                        vm.connectorFieldExpArr.push({
                                            id: "$." + stashValue.split('#' + tempLoadValue + ".")[1],
                                            type: 'string',
                                            operators: operators
                                        });
                                    }
                                }
                            }
                        });
                    }
                    if (angular.isDefined(vm.connectorExpressionObj[connectorObj.id])) {
                        vm.selectedConnectorObj = vm.connectorExpressionObj[connectorObj.id];
                    } else {
                        vm.selectedConnectorObj = connectorObj;
                    }
                    if (vm.selectedConnectorObj.userData && vm.selectedConnectorObj.userData.parameters && vm.selectedConnectorObj.userData.parameters.expression) {
                        vm.queryBuilder = angular.copy(vm.selectedConnectorObj.userData.parameters.expression);
                    } else {
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                    }
                    vm.isConnectorSaved = false;
                    vm.isStateSelectedOnCanvas = false;
                    vm.selectedStateObj = {};
                    var modalInstanceForWorkflowTriggers = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/modals/connectorModal/connectorModal.html',
                        size: 'lg',
                        controller: 'connectorModalCtrl as connectorModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            connectorFieldExpArr: function () {
                                return vm.connectorFieldExpArr;
                            },
                            queryBuilder: function () {
                                return vm.queryBuilder;
                            },
                            selectedConnectorObj: function () {
                                return vm.selectedConnectorObj;
                            },
                            connectorExpressionObj: function () {
                                return vm.connectorExpressionObj;
                            },
                            isConnectorSaved: function () {
                                return vm.isConnectorSaved;
                            },
                            isReadOnly: function () {
                                return false;
                            }
                        }
                    });
                    modalInstanceForWorkflowTriggers.result.then(function (dataObj) {
                        dataObj.connectorFieldExpArr = vm.connectorFieldExpArr;
                        dataObj.queryBuilder = vm.queryBuilder;
                        dataObj.selectedConnectorObj = vm.selectedConnectorObj;
                        dataObj.connectorExpressionObj = vm.connectorExpressionObj;
                        dataObj.isConnectorSaved = vm.isConnectorSaved;
                    }, function (dataObj) {
                        dataObj.connectorFieldExpArr = vm.connectorFieldExpArr;
                        dataObj.queryBuilder = vm.queryBuilder;
                        dataObj.selectedConnectorObj = vm.selectedConnectorObj;
                        dataObj.connectorExpressionObj = vm.connectorExpressionObj;
                        dataObj.isConnectorSaved = vm.isConnectorSaved;
                    });
                };

                /* START:  Draw2d Canvas editor section*/
                var onInitCanvasListener = function (e) {
                    var userDataObj = e.detail;
                    if (userDataObj.category === "TRIGGER") {
                        vm.triggerCount = true;
                    }
                };

                var deleteSelectedStateListener = function (e) {
                    var userDataObj = e.detail;
                    if (vm.selectedStateObj && userDataObj.sudoId === vm.selectedStateObj.sudoId) {
                        vm.selectedStateObj = null;
                        vm.isStateSelectedOnCanvas = false;
                    }
                    if (userDataObj.category === "TRIGGER" && !vm.isCalledFromTidy) {
                        vm.triggerCount = false;
                        vm.fnOpenWorkflowTriggersModal();
                    } else {
                        $timeout(function () {
                            vm.isCalledFromTidy = false;
                        }, 1000)
                    }
                    if (vm.savedStashObj[userDataObj.sudoId]) {
                        delete vm.savedStashObj[userDataObj.sudoId];
                    }
                    if (vm.configureObj[userDataObj.sudoId]) {
                        delete vm.configureObj[userDataObj.sudoId];
                    }
                };

                var  getSelectedActionListener = function (e) {
                    var type = e.detail.childFigure.cssClass.includes('inject-icon') ? 'inject' :
                        e.detail.childFigure.cssClass.includes('load-icon') ? 'load' :
                            e.detail.childFigure.cssClass.includes('stash-icon') ? 'stash' : '';
                    if(type.length) {
                        var connections = e.detail.stateFigure.getConnections();
                        var userDataObj = e.detail.stateFigure.userData;
                        vm.fnActionIconSelected(type, e.detail.stateFigure, userDataObj, connections);
                    }
                };

                var getSelectedStateListener = function (e) {
                    var connections = e.detail.getConnections();
                    var userDataObj = e.detail.userData;
                    vm.selectedStateFigure = e.detail;
                    vm.fnGetSelectedStateInformation(userDataObj, connections, true, false, '');
                };

                var getConnectionClickListener = function (e) {
                    var connector = e.detail;
                    vm.fnConnectorClick(connector)
                };

                document.addEventListener('onInitCanvas', onInitCanvasListener);
                document.addEventListener('deleteSelectedState', deleteSelectedStateListener);
                document.addEventListener('getSelectedAction', getSelectedActionListener);
                document.addEventListener('getSelectedState', getSelectedStateListener);
                document.addEventListener('getConnectionClick', getConnectionClickListener);

                vm.fnStateDragStart = function () {
                    angular.element("#stateSearchInput").blur();
                };

                vm.clonedCanvas = null;
                $scope.editor = { //eslint-disable-line
                    // Configuration of the editor
                    canvas: {
                        //Method to Get canvas in controller on Initialization
                        fnInit: function (canvas) {
                            vm.clonedCanvas = canvas;
                        },
                        // callback if a DOM node from the palette is dropped inside the canvas
                        onDrop: function (dropTarget, x, y) { //shiftKey, ctrlKey 4th and 5th param
                            var stateObj = angular.element(dropTarget).data("state");
                            var figure = vm.getShape(stateObj);

                            //To count the no. of Trigger shape on canvas as Only one Trigger is allowed on canvas.
                            if (figure.userData.category === "TRIGGER") {
                                vm.triggerCount = true;
                            }

                            // create a command for the undo/redo support
                            var command = new draw2d.command.CommandAdd(this, figure, x - 50, y - 19); //eslint-disable-line
                            this.getCommandStack().execute(command); //eslint-disable-line
                        },

                        // callback id connection create between two figures
                        createConnection: function () {
                            // return my special kind of connection
                            var connection = new draw2d.Connection();
                            connection.setRouter(new draw2d.layout.connection.SplineConnectionRouter());

                            // get connection target and sourcePort and targetPort
                            $timeout(function () {
                                if (connection.sourcePort.name === "output_CHOICE_0") {
                                    connection.attr({
                                        color: "#FF0000"
                                    });

                                    var icon = new draw2d.shape.icon.Gear();
                                    icon.setHeight(20);
                                    icon.setWidth(20);
                                    connection.add(icon, new draw2d.layout.locator.PolylineMidpointLocator());
                                    var self;

                                    icon.onMouseEnter = function () {
                                        self = this; //eslint-disable-line
                                        this.tooltip = $('<div class="tooltip">Setting</div>') //eslint-disable-line
                                            .appendTo('#canvas')
                                            .hide()
                                            .fadeIn(100);
                                        this.tooltip.css({ //eslint-disable-line
                                            'top': icon.getAbsoluteY() + 22,
                                            'left': icon.getAbsoluteX() - 10
                                        });
                                        $timeout(function () {
                                            if(self.tooltip !== null) {
                                                self.tooltip.fadeOut(100, function () { //eslint-disable-line
                                                    $(this).remove(); //eslint-disable-line
                                                });
                                                self.tooltip = null; //eslint-disable-line
                                            }
                                        }, 1000)
                                    };

                                    icon.onMouseLeave = function () {
                                        if(this.tooltip !== null) { //eslint-disable-line
                                            this.tooltip.fadeOut(100, function () { //eslint-disable-line
                                                $(this).remove(); //eslint-disable-line
                                            });
                                            this.tooltip = null; //eslint-disable-line
                                        }
                                    };

                                    icon.on("click", function () {
                                        if(self.tooltip !== null) {
                                            self.tooltip.fadeOut(100, function () { //eslint-disable-line
                                                $(this).remove(); //eslint-disable-line
                                            });
                                            self.tooltip = null; //eslint-disable-line
                                        }
                                        vm.fnConnectorClick(connection);
                                    });

                                    connection.on("click", function () {
                                        vm.fnConnectorClick(connection);
                                    });
                                }

                            });

                            return connection;
                        },
                        jsonRead: function (canvas, jsonData) {
                            var reader = new draw2d.io.json.Reader();
                            reader.unmarshal(canvas, jsonData);
                        },
                        clear: function () {
                            var flag = false;
                            angular.forEach(angular.fromJson(vm.flowJson), function (flowObj) {
                                if (flowObj.userData && flowObj.userData.category === 'TRIGGER') {
                                    flag = true;
                                }
                            });
                            if (flag) {
                                vm.isCalledFromTidy = true;
                            }
                            vm.clonedCanvas.clear();
                        }
                    },

                    // provide all figures to show in the left hand palette.
                    // Used by the directrives/canvas.js
                    palette: {
                        figures: [
                            /*  {class: "draw2d.shape.node.Between", name: "Between", "color" : "#ff0000"},
                             {class: "draw2d.shape.node.End", name: "End"},*/
                            {
                                class: "draw2d.shape.layout.HorizontalLayout",
                                name: "tcp",
                                type: "HorizontalLayout",
                                color: "#dbe8ff",
                                icon: "Alarm"
                            },
                            {
                                class: "draw2d.shape.layout.HorizontalLayout",
                                name: "ucp",
                                type: "HorizontalLayout",
                                color: "#e7ffdb",
                                icon: "Aumade"
                            },
                            {
                                class: "draw2d.shape.layout.HorizontalLayout",
                                name: "function",
                                type: "HorizontalLayout",
                                color: "#ffe3db",
                                icon: "Cloud2"
                            },
                            {
                                class: "draw2d.shape.layout.HorizontalLayout",
                                name: "delay",
                                type: "HorizontalLayout",
                                color: "#fcffdb",
                                icon: "IMac"
                            }
                        ]
                    }
                };

                /* END:  Draw2d Canvas editor section*/
                vm.fnGetJson = function (flowJson) {
                    if (angular.isDefined(flowJson)) {
                        vm.newWorkFlowObj.flow = angular.fromJson(flowJson);
                    }
                };

                vm.fnGetStates = function (inputObj) {
                    vm.isStatesLoading = true;
                    var tempObj = {};
                    $scope.editor.palette.figuresObj = {};
                    StateFactory.getStates(inputObj)
                        .then(function (response) {
                            vm.statesArr = angular.copy(response);
                            tempObj = _.groupBy(response, function (stateObj) {
                                stateObj.shape = "state.BoxLayout";
                                stateObj.class = "HorizontalLayout";
                                // stateObj.color = ColorService.getLighten(getRandomColor(), 20);
                                switch (stateObj.type) {
                                    case "SUCCEED":
                                    case "FAIL":
                                        stateObj.outPort = 0;
                                        stateObj.inPort = 1;
                                        break;
                                    case "INPUT":
                                        stateObj.outPort = 1;
                                        stateObj.inPort = 0;
                                        stateObj.singleOut = true;
                                        break;
                                    case "TASK":
                                    case "WAIT":
                                        stateObj.outPort = 1;
                                        stateObj.inPort = 1;
                                        stateObj.singleOut = true;
                                        break;
                                    default:
                                        stateObj.outPort = 1;
                                        stateObj.inPort = 1;
                                }

                                return stateObj.category
                            });
                            vm.stateOrderArr.map(function (stateName) {
                                if (tempObj[stateName]) {
                                    $scope.editor.palette.figuresObj[stateName] = tempObj[stateName]
                                }
                            });
                            vm.functionTriggerStateArr = _.filter(tempObj.TRIGGER, {category: 'TRIGGER'});
                            vm.isStatesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                                vm.fnOpenWorkflowTriggersModal();
                            }, 20);
                        }, function () {
                            vm.isStatesLoading = false;
                        })
                };

                vm.fnGetSelectedState = function () {
                    vm.isStateInfoLoaded = false;
                    var inputObj = {
                        stateId: vm.selectedStateObj.id
                    };

                    StateFactory.getState(inputObj)
                        .then(function (response) {
                            vm.stateInfoObj = response;
                            vm.isStateInfoLoaded = true;
                        }, function () {
                            vm.isStateInfoLoaded = true;
                        });
                };

                vm.fnValidateWorkflow = function () {
                    if (!vm.newWorkFlowObj.name.length) {
                        swal("Missing Workflow name", "Please add a name to the Workflow to validate it.");
                    } else {
                        vm.isWorkflowValidating = true;
                        vm.fnGetJson(vm.flowJson);
                        if (angular.isDefined(vm.newWorkFlowObj.flow)) {
                            angular.forEach(vm.newWorkFlowObj.flow, function (flowObj) {
                                if (vm.configureObj[flowObj.userData.sudoId]) {
                                    flowObj.userData = vm.configureObj[flowObj.userData.sudoId];
                                } else if (vm.connectorExpressionObj[flowObj.id]) {
                                    flowObj.userData = vm.connectorExpressionObj[flowObj.id].userData;
                                } else if (flowObj.userData.parameters && !Object.keys(flowObj.userData.parameters).length) {
                                    delete flowObj.userData.parameters;
                                }
                            });

                            var inputObj = {
                                body: {
                                    name: vm.newWorkFlowObj.name,
                                    description: vm.newWorkFlowObj.description,
                                    flow: vm.newWorkFlowObj.flow,
                                    logging: {
                                        "enabled": false
                                    }
                                }
                            };
                            if (vm.newWorkFlowObj.logging) {
                                inputObj.body.logging.enabled = vm.newWorkFlowObj.logging.enabled;
                            }
                            WorkflowFactory.validateWorkflow(inputObj)
                                .then(function () {
                                    amaran.success("WorkFlow Validated Successfully");
                                    vm.isWorkflowValidating = false;
                                    vm.isValidateSuccessful = true;
                                }, function (error) {
                                    vm.isValidateSuccessful = false;
                                    vm.isWorkflowValidating = false;
                                    swal("Invalid Workflow", error.errorMessage);
                                })
                        }
                    }
                };

                vm.fnCreateWorkFlow = function () {
                    vm.isWorkflowsCreating = true;
                    vm.fnGetJson(vm.flowJson);
                    var tempCanvasFigure = vm.clonedCanvas.getFigures();
                    _.forEach(tempCanvasFigure.data, function (tempObj) {
                        var figIndex = _.findIndex(vm.newWorkFlowObj.flow, function (flowObj) {
                            return flowObj.type === 'state.BoxLayout' && flowObj.userData.sudoId === tempObj.userData.sudoId;
                        });
                        if(figIndex !== -1 && vm.newWorkFlowObj.flow[figIndex] &&
                            vm.newWorkFlowObj.flow[figIndex].subChild.length > 2) {
                            vm.newWorkFlowObj.flow[figIndex].subChild[vm.newWorkFlowObj.flow[figIndex].subChild.length - 1].subChild[0].path =
                                tempObj.children.data[tempObj.children.data.length - 1].figure.children.data[0].figure.getPath();
                        }
                    });
                    if (angular.isDefined(vm.newWorkFlowObj.flow)) {
                        angular.forEach(vm.newWorkFlowObj.flow, function (flowObj) {
                            if (vm.configureObj[flowObj.userData.sudoId]) {
                                flowObj.userData = vm.configureObj[flowObj.userData.sudoId];
                                if (flowObj.userData.info) {
                                    delete flowObj.userData.info;
                                }
                                if (flowObj.userData.mdInfo) {
                                    delete flowObj.userData.mdInfo;
                                }
                            } else if (vm.connectorExpressionObj[flowObj.id]) {
                                flowObj.userData = vm.connectorExpressionObj[flowObj.id].userData;
                            } else if (flowObj.userData.parameters && !Object.keys(flowObj.userData.parameters).length) {
                                delete flowObj.userData.parameters;
                            }
                        });

                        var inputObj = {
                            body: {
                                name: vm.newWorkFlowObj.name,
                                description: vm.newWorkFlowObj.description,
                                flow: vm.newWorkFlowObj.flow,
                                logging: {
                                    "enabled": false
                                }
                            }
                        };
                        if (vm.newWorkFlowObj.logging) {
                            inputObj.body.logging.enabled = vm.newWorkFlowObj.logging.enabled;
                        }
                        WorkflowFactory.validateWorkflow(inputObj)
                            .then(function () {
                                vm.isWorkfolwSave = true;
                                amaran.success("WorkFlow Validated Successfully");
                                WorkflowFactory.createWorkflow(inputObj)
                                    .then(function (response) {
                                        vm.isWorkflowsCreating = false;
                                        if (vm.stateParamDraftName) {
                                            delete  vm.draftsOptions[vm.stateParamDraftName];
                                            DB.fnSet("WorkflowsSavedDrafts", vm.draftsOptions)
                                        }
                                        vm.clonedCanvas.clear();
                                        vm.newWorkFlowObj = angular.copy(resetWorkFlowObj);
                                        vm.isStateSelectedOnCanvas = false;
                                        vm.selectedStateObj = null;
                                        vm.selectedConnectorObj = null;
                                        vm.savedStashArr = ["#initial"];
                                        vm.savedStashObj = {};
                                        amaran.success("WorkFlow Created");
                                        vm.isWorkfolwSave = true;
                                        $state.go("main.workflows", {isCalledAfterCreate: angular.toJson(response)});
                                    }, function () {
                                        vm.isWorkflowsCreating = false;
                                        vm.isStateSelectedOnCanvas = false;
                                        amaran.error("WorkFlow was not Created");
                                    })
                            }, function () {
                                vm.isWorkflowsCreating = false;
                                amaran.error("WorkFlow Validation Unsuccessful")
                            })
                    }
                };

                vm.getBluePrint = function (bluePrintId) {
                    vm.isWorkFlowLoading = true;
                    var inputObj = {
                        workflowId: bluePrintId
                    };
                    WorkflowFactory.getWorkflowBluePrint(inputObj)
                        .then(function (res) {
                            vm.newWorkFlowObj = res;
                            vm.fnSetStashObj(vm.newWorkFlowObj.flow);
                            $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.newWorkFlowObj.flow);
                            vm.isWorkFlowLoading = false;
                        }, function () {
                            vm.isWorkFlowLoading = false;
                        })
                };

                vm.fnSetStashObj = function (flow) {
                    var tempArr = [];
                    angular.forEach(flow, function (flowObj) {
                        if (flowObj.userData) {
                            if (flowObj.userData.category === "TRIGGER" && flowObj.userData.outputs && flowObj.userData.outputs.length) {
                                var triggerStash = "#initial";
                                angular.forEach(flowObj.userData.outputs, function (output) {
                                    if (tempArr.indexOf(output.replace("$", triggerStash)) === -1) {
                                        tempArr.push(output.replace("$", triggerStash));
                                    }
                                });
                                vm.savedStashObj[flowObj.userData.sudoId] = tempArr;
                                tempArr = [];
                            } else if (flowObj.userData.parameters && flowObj.userData.parameters.stash && flowObj.userData.outputs) {
                                var stash = flowObj.userData.parameters.stash;
                                if (!stash.startsWith('#')) {
                                    stash = "#" + stash
                                }
                                tempArr.push(stash);
                                angular.forEach(flowObj.userData.outputs, function (output) {
                                    if (tempArr.indexOf(output.replace("$", stash)) === -1) {
                                        tempArr.push(output.replace("$", stash));
                                    }
                                });
                                vm.savedStashObj[flowObj.userData.sudoId] = tempArr;
                                tempArr = [];
                            }
                        }
                    });
                };

                vm.fnGetAppModels = function (count) {
                    var inputObj = {
                        appName: appArr[count]
                    };
                    ListenerFactory.getListenerModels(inputObj)
                        .then(function (response) {
                            vm.modelsObj[appArr[count]] = response;
                            count++;
                            if (count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                    vm.fnFilterQueryChanged(vm.filterQuery);
                                });
                            }
                        }, function () {
                            count++;
                            if (count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                    vm.fnFilterQueryChanged(vm.filterQuery);
                                });
                            }
                        })

                };

                vm.fnInitGetAppModels = function () {
                    vm.isListenerModelsLoading = true;
                    if (appCount < appArr.length) {
                        vm.fnGetAppModels(appCount);
                    } else {
                        vm.isListenerModelsLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                            vm.fnFilterQueryChanged(vm.filterQuery);
                        });
                    }
                };

                vm.fnOpenWorkflowTriggersModal = function () {
                    if (vm.isWorkfolwSave === false && vm.isListenerModelsLoading === false && vm.isStatesLoading === false && !vm.triggerCount && $state.current.name === "main.createWorkFlow") {
                        var modalInstanceForWorkflowTriggers = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/pipeline/workflows/modals/workflowTriggersModal/workflowTriggersModal.html',
                            size: 'lg',
                            controller: 'workflowTriggersModalCtrl as workflowTriggersModal',
                            windowClass: 'modal-height100',
                            resolve: {
                                triggersArr: function () {
                                    return vm.functionTriggerStateArr;
                                },
                                modelsObj: function () {
                                    return _.cloneDeep(vm.modelsObj);
                                }

                            }
                        });
                        modalInstanceForWorkflowTriggers.result.then(function (obj) {
                            var stateObj = obj;
                            var figure = vm.getShape(stateObj);
                            if (figure.userData.category === "TRIGGER") {
                                vm.triggerCount = true;
                            }
                            // create a command for the undo/redo support
                            var command = new draw2d.command.CommandAdd(vm.clonedCanvas, figure, 100 - 50, 100 - 19); //eslint-disable-line
                            vm.clonedCanvas.getCommandStack().execute(command); //eslint-disable-line
                        }, function () {

                        });
                    }

                };
                vm.fnInitCreateWorkFlow = function () {
                    vm.fnInitGetAppModels();
                    if ($stateParams.bluePrintId) {
                        vm.getBluePrint($stateParams.bluePrintId);
                    } else if (DB.fnGet("ClonedWorkFlowObj")) {
                        var clonedWorkFlowObj = DB.fnGet("ClonedWorkFlowObj");
                        vm.newWorkFlowObj = angular.copy(clonedWorkFlowObj);
                        vm.triggerCount = true;
                        $timeout(function () {
                            /*creating graphical representation of flow on canvas*/
                            vm.fnSetStashObj(vm.newWorkFlowObj.flow);
                            $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.newWorkFlowObj.flow);
                            DB.fnRemove("ClonedWorkFlowObj"); //important do not comment line
                        });
                    } else if ($stateParams.draftName) {
                        vm.stateParamDraftName = $stateParams.draftName;
                        if (vm.draftsOptions[vm.stateParamDraftName]) {
                            vm.newWorkFlowObj = vm.draftsOptions[vm.stateParamDraftName];
                            $timeout(function () {
                                /*creating graphical representation of flow on canvas*/
                                vm.fnSetStashObj(vm.newWorkFlowObj.flow);
                                $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.newWorkFlowObj.flow);
                            });
                        }
                        $timeout.cancel(vm.repeatativeTimer);
                        $timeout(function () {
                            vm.fnSaveWorkflowDetails();
                        }, 10000)
                    }
                    if (vm.draftsOptions && Object.keys(vm.draftsOptions).length) {
                        vm.isDraftsAvailable = true;
                    } else {
                        vm.isDraftsAvailable = false;
                    }
                    //vm.fnFilterQueryChanged(vm.filterQuery);
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                /*Configure State: START*/
                vm.fnIsTabVisible = function (tab) {
                    var flag = true;
                    if (tab.title === 'Stash') {
                        if (vm.selectedStateObj.type === 'WAIT' || vm.selectedStateObj.type === "CHOICE") {
                            flag = false;
                        }
                    }
                    return flag;
                };

                function unflatten(data) {
                    "use strict"; //eslint-disable-line
                    if (Object(data) !== data || angular.isArray(data)) {
                        return data;
                    }
                    var regex = /\.?([^.\[\]]+)|\[(\d+)\]/g,
                        resultholder = {};
                    /*eslint-disable*/
                    for (var p in data) {
                        var cur = resultholder,
                            prop = "",
                            m;
                        while (m = regex.exec(p)) {
                            cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
                            prop = m[2] || m[1];
                        }
                        cur[prop] = data[p];
                    }
                    /*eslint-enable*/
                    return resultholder[""] || resultholder;
                }

                function flatten(data) {
                    var result = {};

                    function recurse(cur, prop) {
                        if (Object(cur) !== cur) {
                            result[prop] = cur;
                        } else if (angular.isArray(cur)) {
                            for (var i = 0, l = cur.length; i < l; i++) {
                                recurse(cur[i], prop ? prop + "." + i : "" + i);
                            }
                            if (l === 0) {
                                result[prop] = [];
                            }
                        } else {
                            var isEmpty = true;
                            /*eslint-disable*/
                            for (var p in cur) {
                                isEmpty = false;
                                recurse(cur[p], prop ? prop + "." + p : p);
                            }
                            /*eslint-enable*/
                            if (isEmpty) {
                                result[prop] = {};
                            }
                        }
                    }

                    recurse(data, "");
                    return result;
                }

                vm.fnConvertObjectToFlatt = function (kvpPair) {
                    kvpPair.isJsonIndex = false;
                    if (kvpPair.value) {
                        if (isJson(kvpPair.value) &&
                            isNaN(parseFloat(kvpPair.value)) && !isFinite(kvpPair.value) &&
                            (kvpPair.value.trim() !== "true" && kvpPair.value.trim() !== "false" &&
                            kvpPair.value.trim() !== true && kvpPair.value.trim() !== false)) {
                            kvpPair.injectMapWith$ = {
                                $: {}
                            };
                            kvpPair.injectMapWith$.$ = angular.fromJson(kvpPair.value);
                            var tempObj = flatten(kvpPair.injectMapWith$);
                            var tempString = "";
                            kvpPair.injectMap = "";
                            Object.keys(tempObj).forEach(function (key) {
                                var tempArr = key.split(".");
                                var tempKeyString = "";
                                var tempIndex = "";
                                angular.forEach(tempArr, function (value) {
                                    if (!isNaN(value)) {
                                        tempIndex = "[" + value + "]";
                                        tempKeyString = tempKeyString + tempIndex;
                                    }
                                    else {
                                        tempKeyString === "" ? tempKeyString = value : tempKeyString = tempKeyString + "." + value //eslint-disable-line
                                        tempIndex = "";
                                    }
                                });
                                var newTempkey = tempKeyString;
                                tempString = "" ? tempString = newTempkey + "=" + tempObj[key] + ";\n" : tempString = tempString + newTempkey + "=" + tempObj[key] + ";\n"; //eslint-disable-line
                            });

                            kvpPair.injectMap = tempString;
                        } else {
                            kvpPair.injectMap = kvpPair.value;
                        }
                    } else {
                        kvpPair.injectMap = '';
                    }
                };

                vm.fnConvertFlattToObject = function (kvpPair, isCalledFromSave) {
                    if (!isCalledFromSave) {
                        kvpPair.isJsonIndex = true;
                    }
                    if (kvpPair.injectMap) {
                        if (kvpPair.injectMap.startsWith('$')) {
                            if (kvpPair.injectMap.includes(";")) {
                                var tempObj = {};
                                var tempArr = kvpPair.injectMap.split(';');
                                angular.forEach(tempArr, function (obj) {
                                    if (obj.includes("=")) {
                                        if (obj.split("=")[1].trim().replace(/["']/g, "") === "true" || obj.split("=")[1].trim().replace(/["']/g, "") === "false") {
                                            tempObj[obj.split("=")[0].trim()] = angular.fromJson(obj.split("=")[1].trim().replace(/["']/g, ""));
                                        }
                                        else {
                                            if (isNaN(obj.split("=")[1].trim().replace(/["']/g, ""))) {
                                                tempObj[obj.split("=")[0].trim()] = obj.split("=")[1].trim().replace(/["']/g, "");
                                            }
                                            else {
                                                tempObj[obj.split("=")[0].trim()] = parseInt(obj.split("=")[1].trim().replace(/["']/g, ""));
                                            }
                                        }
                                    }
                                });
                                kvpPair.value = angular.toJson(unflatten(tempObj).$, true);
                            } else {
                                kvpPair.value = kvpPair.injectMap;
                            }
                        } else {
                            kvpPair.value = kvpPair.injectMap;
                        }
                    } else {
                        kvpPair.value = '';
                    }
                };

                vm.fnGetInjectJson = function (kvpPair) {
                    var tempObj = {};
                    if (kvpPair.isJsonIndex) {
                        if (isJson(kvpPair.value) &&
                            isNaN(parseFloat(kvpPair.value)) && !isFinite(kvpPair.value) &&
                            (kvpPair.value.trim() !== "true" && kvpPair.value.trim() !== "false" &&
                            kvpPair.value.trim() !== true && kvpPair.value.trim() !== false)) {
                            tempObj = angular.fromJson(kvpPair.value);
                            kvpPair.value = angular.toJson(tempObj, true);
                        }
                    } else {
                        vm.fnConvertFlattToObject(kvpPair, true);
                    }
                };

                vm.fnSaveConfiguration = function () {
                    var parameterObj = {};
                    var loadObj = {};
                    var injectObj = {};

                    if (vm.stashName && vm.stashName.length && /^[a-zA-Z\d-]+$/.test(vm.stashName)) {
                        parameterObj.stash = vm.stashName;
                    } else {
                        delete parameterObj.stash;
                    }

                    angular.forEach(vm.loadArr, function (obj) {
                        if (obj.key && obj.value && obj.key.length && obj.value.length) {
                            if (!obj.value.startsWith('#')) {
                                if (vm.allStatesFromChoice[vm.selectedStateObj.sudoId] && vm.allStatesFromChoice[vm.selectedStateObj.sudoId][obj.value]) {
                                    loadObj[obj.key] = vm.allStatesFromChoice[vm.selectedStateObj.sudoId][obj.value];
                                } else {
                                    loadObj[obj.key] = obj.value;
                                }
                            } else {
                                loadObj[obj.key] = obj.value;
                            }
                        }
                    });

                    if (Object.keys(loadObj).length) {
                        parameterObj.load = loadObj;
                    } else {
                        delete parameterObj.load;
                    }

                    angular.forEach(vm.injectArr, function (obj) {
                        if (obj.key && obj.key.length && ((obj.value && obj.value.length) || (obj.injectMap && obj.injectMap.length))) {
                            vm.fnGetInjectJson(obj);
                            var flag = isJson(obj.value);
                            if (flag) {
                                injectObj[obj.key] = angular.fromJson(obj.value);
                            } else {
                                if (obj.value.trim() === "true") {
                                    injectObj[obj.key] = true;
                                } else if (obj.value.trim() === "false") {
                                    injectObj[obj.key] = false;
                                } else if (angular.isNumber(obj.value)) {
                                    injectObj[obj.key] = obj.value.parseInt();
                                } else {
                                    injectObj[obj.key] = obj.value
                                }
                            }
                        }
                    });

                    if (Object.keys(injectObj).length) {
                        parameterObj.inject = injectObj;
                    } else {
                        delete parameterObj.inject;
                    }
                    if (Object.keys(parameterObj).length !== 0) {
                        if (parameterObj.stash && parameterObj.stash.length) {
                            var stash = parameterObj.stash;
                            var tempArr = [];
                            if (!stash.startsWith("#")) {
                                stash = "#" + stash
                            }
                            if (vm.selectedStateObj.outputs) {
                                tempArr.push(stash);
                                angular.forEach(vm.selectedStateObj.outputs, function (output) {
                                    if (tempArr.indexOf(output.replace("$", stash)) === -1) {
                                        tempArr.push(output.replace("$", stash));
                                    }
                                })
                            } else {
                                tempArr.push(stash);
                            }
                            vm.savedStashObj[vm.selectedStateObj.sudoId] = tempArr;
                        }
                        vm.configureObj[vm.selectedStateObj.sudoId] = vm.selectedStateObj;
                    }
                    vm.selectedStateObj.parameters = parameterObj;
                    vm.isConfigSaved = true;
                    amaran.success("State configuration changes saved successfully");
                    vm.fnCheckConfigurationValidation(vm.selectedStateObj);
                };

                vm.fnCheckConfigurationValidation = function (selectedStateObj) {
                    var tempArr = [];
                    angular.forEach(selectedStateObj.inputs, function (inputVal) {
                        if(inputVal.startsWith("*")) {
                            tempArr.push(inputVal);
                        }
                    });
                    var validationArr = [];
                    var tempKey = '';
                    angular.forEach(tempArr, function (tempVal) {
                        if(selectedStateObj.parameters) {
                            if(selectedStateObj.parameters.inject) {
                                if(selectedStateObj.parameters.inject[tempVal.replace("*", "")]) {
                                    if(_.indexOf(validationArr, tempVal) === -1) {
                                        validationArr.push(tempVal);
                                    }
                                } else {
                                    tempKey = tempVal+"[0]";
                                    if(selectedStateObj.parameters.inject[tempKey.replace("*", "")]){
                                        if(_.indexOf(validationArr, tempKey) === -1) {
                                            validationArr.push(tempKey);
                                        }
                                    }
                                }
                            }if (selectedStateObj.parameters.load) {
                                if(selectedStateObj.parameters.load[tempVal.replace("*", "")]) {
                                    if(_.indexOf(validationArr, tempVal) === -1) {
                                        validationArr.push(tempVal);
                                    }
                                } else {
                                    tempKey = tempVal+"[0]";
                                    if(selectedStateObj.parameters.load[tempKey.replace("*", "")]){
                                        if(_.indexOf(validationArr, tempKey) === -1) {
                                            validationArr.push(tempKey);
                                        }
                                    }
                                }
                            }
                        }
                    });
                    var tempFigure = vm.clonedCanvas.getFigures();
                    angular.forEach(tempFigure.data, function (tempObj) {
                        if(tempObj.userData.sudoId === selectedStateObj.sudoId) {
                            var iconFigure = tempObj.children.data[tempObj.children.data.length - 1];
                            if(validationArr.length === tempArr.length) {
                                iconFigure.figure.children.data[0].figure.setPath("assets/images/svg/check.svg")
                            } else {
                                iconFigure.figure.children.data[0].figure.setPath("assets/images/svg/exclamation.svg")
                            }
                        }
                    })
                };
                /*Configure State: END*/

                /*Import/Export: START*/
                vm.fnImportWorkflow = function () {
                    if (vm.stateParamDraftName) {
                        $state.go("main.createWorkFlow", {draftName: ""}, {notify: false});
                        delete $stateParams.draftName;
                        vm.stateParamDraftName = null;
                    }
                    isImportFunctionalityWorking = true;
                    vm.fnResetWorkflow(true);
                    var filesSelected = document.getElementById("upload-file-selector").files;
                    var a = filesSelected[0].name.split('.');
                    if (filesSelected.length > 0 && a[a.length - 1] === 'json') {

                        var fileToLoad = filesSelected[0];
                        var fileReader = new FileReader();
                        fileReader.onload = function (fileLoadedEvent) {
                            var url = fileLoadedEvent.target.result;
                            var request = {
                                method: 'get',
                                url: url,
                                dataType: 'json',
                                contentType: "application/json"
                            };
                            $http(request)
                                .then(function (jsonData) {
                                    vm.newWorkFlowObj = jsonData.data;
                                    vm.flowJson = angular.toJson(vm.newWorkFlowObj.flow, true);
                                    $timeout(function () {
                                        $scope.editor.canvas.jsonRead(vm.clonedCanvas, vm.newWorkFlowObj.flow);
                                    })
                                }, function () {
                                    isImportFunctionalityWorking = false;
                                })
                        };
                        fileReader.readAsDataURL(fileToLoad);
                        isImportFunctionalityWorking = false;
                    } else {
                        swal("Invalid format", "File of type json is required for workflow import");
                    }
                };

                vm.fnExportWorkflow = function () {
                    vm.fnGetJson(vm.flowJson);
                    var filename;
                    if (vm.newWorkFlowObj.name.length) {
                        filename = vm.newWorkFlowObj.name + Date.now() + ".json";
                    } else {
                        filename = 'workflow' + Date.now() + ".json";
                    }
                    var blob = new Blob([angular.toJson(vm.newWorkFlowObj)], {type: 'text/json'});
                    var e = document.createEvent('MouseEvents'),
                        a = document.createElement('a');
                    a.download = filename;
                    a.href = window.URL.createObjectURL(blob); //eslint-disable-line
                    a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
                    e.initEvent('click', true, false, window,
                        0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    a.dispatchEvent(e);
                };

                vm.fnResetWorkflow = function (isResetSilently) {
                    if (!isResetSilently) {
                        swal({
                                title: "Are you sure?",
                                text: "Reset will clear all the workflow details",
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "reset",
                                closeOnConfirm: false,
                                showLoaderOnConfirm: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    vm.clonedCanvas.clear();
                                    vm.newWorkFlowObj = angular.copy(resetWorkFlowObj);
                                    vm.isValidateSuccessful = null;
                                    vm.isStateInfoLoaded = false;
                                    vm.stateInfoObj = null;
                                    vm.queryBuilder = {"condition": "AND", "rules": []};
                                    vm.connectorExpressionObj = {};
                                    vm.isConnectorSaved = false;
                                    vm.isStateSelectedOnCanvas = false;
                                    vm.stashName = '';
                                    vm.loadArr = [
                                        {
                                            key: '',
                                            value: ''
                                        }
                                    ];
                                    vm.injectArr = [
                                        {
                                            key: '',
                                            value: '',
                                            injectMap: '',
                                            isJsonIndex: true,
                                            injectMapWith$: ''
                                        }
                                    ];
                                    vm.savedStashArr = ["#initial"];
                                    vm.savedStashObj = {};
                                    $timeout(function () {
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    }, 1000)
                                } else {
                                    swal("Cancelled", "Delete Process Cancelled", "error");
                                }
                            });
                    } else {
                        vm.clonedCanvas.clear();
                        vm.newWorkFlowObj = angular.copy(resetWorkFlowObj);
                        vm.isValidateSuccessful = null;
                        vm.isStateInfoLoaded = false;
                        vm.stateInfoObj = null;
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                        vm.connectorExpressionObj = {};
                        vm.isConnectorSaved = false;
                        vm.isStateSelectedOnCanvas = false;
                        vm.stashName = '';
                        vm.loadArr = [
                            {
                                key: '',
                                value: ''
                            }
                        ];
                        vm.injectArr = [
                            {
                                key: '',
                                value: '',
                                injectMap: '',
                                isJsonIndex: true,
                                injectMapWith$: ''
                            }
                        ];
                        vm.savedStashArr = ["#initial"];
                        vm.savedStashObj = {};
                    }
                };
                /*Import/Export: END*/

                /*Draft: START*/
                vm.fnLoadDrafts = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/modals/draftOptions/draftOptions.html',
                        size: 'md',
                        controller: 'draftOptionsCtrl as draftOptions',
                        resolve: {
                            draftObj: function () {
                                return vm.draftsOptions;
                            }
                        }
                    });
                    modalInstance.result.then(function (selectedDraftName) {
                        $timeout.cancel(vm.repeatativeTimer);
                        vm.draftsOptions = DB.fnGet('WorkflowsSavedDrafts');
                        if (vm.draftsOptions[selectedDraftName]) {
                            vm.fnResetWorkflow(true);
                            $state.go("main.createWorkFlow", {'draftName': selectedDraftName});
                            vm.stateParamDraftName = selectedDraftName;
                        } else {
                            amaran.error("Draft not found");
                        }
                    }, function () {
                        vm.draftsOptions = DB.fnGet('WorkflowsSavedDrafts');
                        if (vm.draftsOptions && Object.keys(vm.draftsOptions).length) {
                            vm.isDraftsAvailable = true;
                        } else {
                            vm.isDraftsAvailable = false;
                        }
                    });
                };

                vm.fnSaveDraft = function () {
                    if (vm.stateParamDraftName) {
                        vm.fnGetJson(vm.flowJson);
                        vm.draftsOptions[vm.stateParamDraftName] = vm.newWorkFlowObj;
                        DB.fnSet("WorkflowsSavedDrafts", vm.draftsOptions);
                        vm.draftsOptions = DB.fnGet("WorkflowsSavedDrafts");
                        if (vm.draftsOptions && Object.keys(vm.draftsOptions).length) {
                            vm.isDraftsAvailable = true;
                        } else {
                            vm.isDraftsAvailable = false;
                        }
                        amaran.success("Draft updated");
                    } else {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/pipeline/workflows/modals/saveDraftName/saveDraftName.html',
                            size: 'md',
                            controller: 'draftNameCtrl as createDraft',
                            resolve: {
                                draftsOptions: function () {
                                    return vm.draftsOptions;
                                }
                            }
                        });
                        modalInstance.result.then(function (draftName) {
                            vm.fnGetJson(vm.flowJson);
                            vm.draftsOptions[draftName] = vm.newWorkFlowObj;
                            DB.fnSet("WorkflowsSavedDrafts", vm.draftsOptions);
                            $timeout(function () {
                                vm.draftsOptions = DB.fnGet("WorkflowsSavedDrafts");
                                if (vm.draftsOptions && Object.keys(vm.draftsOptions).length) {
                                    vm.isDraftsAvailable = true;
                                } else {
                                    vm.isDraftsAvailable = false;
                                }
                                amaran.success("Draft saved");
                                $state.go("main.createWorkFlow", {'draftName': draftName}, {notify: false});
                                $stateParams.draftName = draftName;
                                vm.stateParamDraftName = draftName;
                                $timeout.cancel(vm.repeatativeTimer);
                                $timeout(function () {
                                    vm.fnSaveWorkflowDetails();
                                }, 10000)
                            });
                        }, function () {

                        });
                    }
                };
                /*Draft: END*/

                vm.fnTidyWorkflow = function () {
                    var flowJson = angular.fromJson(vm.flowJson);
                    var count = 0;
                    _.forEach(flowJson, function (flowObj, index) {
                        if (flowObj.type === 'state.BoxLayout') {
                            if (index === 0) {
                                flowObj.x = 50;
                                flowObj.y = 18;
                            } else if (index && (index % 2 === 0)) {
                                count++;
                                flowObj.x = 50;
                                flowObj.y = 18 + (count * 60);
                            } else {
                                flowObj.x = 150 + flowJson[index - 1].width;
                                if (index === 1) {
                                    flowObj.y = 18;
                                } else {
                                    flowObj.y = 18 + (count * 60);
                                }
                            }
                            /*flowObj.x = 200;
                            if (index === 0) {
                                flowObj.y = 18
                            } else {
                                flowObj.y = 18 + (index * 60);
                            }*/
                        }
                    });
                    $scope.editor.canvas.clear();
                    $scope.editor.canvas.jsonRead(vm.clonedCanvas, angular.toJson(flowJson, true));
                };

                vm.fnStatesFilter = function () {
                    vm.isStatesLoading = true;
                    var tempObj = {};
                    $scope.editor.palette.figuresObj = {};
                    var statesData = [];
                    if (angular.isDefined(vm.search)) {
                        statesData = _.filter(vm.statesArr, function (statesObj) {
                            if (statesObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return statesObj;
                            }
                        });
                    } else {
                        statesData = angular.copy(vm.statesArr);
                    }
                    tempObj = _.groupBy(statesData, function (stateObj) {
                        stateObj.shape = "state.BoxLayout";
                        stateObj.class = "HorizontalLayout";
                        // stateObj.color = ColorService.getLighten(getRandomColor(), 20);
                        switch (stateObj.type) {
                            case "SUCCEED":
                            case "FAIL":
                                stateObj.outPort = 0;
                                stateObj.inPort = 1;
                                break;
                            case "INPUT":
                                stateObj.outPort = 1;
                                stateObj.inPort = 0;
                                stateObj.singleOut = true;
                                break;
                            case "TASK":
                            case "WAIT":
                                stateObj.outPort = 1;
                                stateObj.inPort = 1;
                                stateObj.singleOut = true;
                                break;
                            default:
                                stateObj.outPort = 1;
                                stateObj.inPort = 1;
                        }

                        return stateObj.category
                    });
                    vm.stateOrderArr.map(function (stateName) {
                        if (tempObj[stateName]) {
                            $scope.editor.palette.figuresObj[stateName] = tempObj[stateName]
                        }
                    });
                    $timeout(function () {
                        vm.isStatesLoading = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, 500);
                };

                $scope.$on("$destroy", function () {
                    $timeout.cancel(vm.repeatativeTimer);
                    document.removeEventListener('onInitCanvas', onInitCanvasListener);
                    document.removeEventListener('deleteSelectedState', deleteSelectedStateListener);
                    document.removeEventListener('getSelectedAction', getSelectedActionListener);
                    document.removeEventListener('getSelectedState', getSelectedStateListener);
                    document.removeEventListener('getConnectionClick', getConnectionClickListener);
                })
            });

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive("transformerInfo", fnTransformerInfo)

    /** @ngInject */
    function fnTransformerInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, TransformerFactory,copyService,  postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/pipeline/transformers/transformerInfo/transformerInfo.html',
            scope: {
                transformerObj: '=',
                transformerPermissionsObj: '='
            },
            link : function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/pipeline/transformers/transformerInfo/transformerTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetTransformer = function (transformerId) {
                    var inputObj = {
                        transformerId: transformerId
                    };
                    TransformerFactory.getTransformer(inputObj)
                        .then(function (response) {
                            $scope.transformerObj = response;
                            if (angular.isUndefined($scope.transformerObj.description)) {
                                $scope.transformerObj.description = '';
                            }
                            $scope.isTransformerDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isTransformerDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.transformers', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateTransformerDetails = function (transformerObj) {
                    var inputObj = {
                        body: {},
                        transformerId: transformerObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(transformerObj.description)) {
                        transformerObj.description = '';
                    }
                    inputObj.body = {
                        name: transformerObj.name,
                        description: transformerObj.description,
                        spec: transformerObj.spec
                    };
                    TransformerFactory.modifyTransformer(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('TransformerDetailsChanged', response);
                            $scope.$broadcast("updateProcessCompleted");
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            DB.fnRemove("TransformerEditMode");
                            amaran.success("Transformer Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteTransformer = function (transformerObj) {
                    swal({
                            title: "Delete the selected transformer?",
                            text: "You are about to permanently delete the selected transformer.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    transformerId: transformerObj.id
                                };
                                TransformerFactory.deleteTransformer(inputObj)
                                    .then(function () {
                                        $scope.$emit('TransformerDeleted', transformerObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function (transformerObj) {
                    $scope.isDetailsEditable = true;
                    DB.fnSet("TransformerEditMode", transformerObj);
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                function isJson(jsonObj) {
                    try {
                        angular.fromJson(jsonObj);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                $scope.getPrettyJson = function (jsonObj) {
                    var flag = isJson(jsonObj);
                    if (flag) {
                        return angular.toJson(angular.fromJson(jsonObj), true);
                    } else {
                        return jsonObj;
                    }
                };

                $scope.fnInitTransformer = function () {
                    $scope.isTransformerDetailsLoaded = false;
                    $scope.transformerId = $scope.transformerObj.id;
                    if ($scope.transformerId) {
                        $scope.fnGetTransformer($scope.transformerId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.$on("exitTransformerEditMode", function () {
                    $scope.isDetailsEditable = false;
                    DB.fnRemove("exitTransformerEditMode");
                });

                $scope.$on("updateTransformer", function (event, data) {
                    $scope.fnUpdateTransformerDetails(data);
                });

                var transformerInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.transformers') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.transformerPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //delete
                                $scope.fnDeleteTransformer($scope.transformerObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.transformerPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //edit
                                $scope.fnChangeFieldsToEditable($scope.transformerObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var transformerInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.transformers') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', transformerInfoKeyDownEventHandler);
                document.addEventListener('keyup', transformerInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', transformerInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', transformerInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createTransformerCtrl',
            function ($scope, $base64, $window, $rootScope, TransformerFactory, $timeout, WizardHandler, DB) {
                var vm = this;

                $scope.$on('wizard:stepChanged', function (event, args) {
                    if (args.index === 1 || args.index === 2) {
                        vm.modeChanged(args.index);
                    }
                });

                vm.cmObj = {};
                var count = 1; //to separate the codemirror editor object which is used to identify when it needs to be initialized.

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/ld+json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    autofocus: true,
                    onLoad: function (_cm) {
                        vm.cmObj[count] = _cm;
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function (countIndex) {
                            $timeout(function () {
                                vm.cmObj[countIndex].refresh();
                            }, 0)
                        };
                        count++;
                    }
                };

                vm.title = "Create Transformer";
                vm.reviewBtnTxt = 'Create Transformer';

                // search type client side
                vm.search = '';
                vm.isBluePrintFilter = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newTransformerObj = {
                    name: '',
                    description: '',
                    spec: ''
                };

                var resetObj = angular.copy(vm.newTransformerObj);

                vm.validateInput = '';
                vm.validateResult = '';
                vm.isTransformerValidating = false;
                vm.isTransformerCreating = false;
                vm.isValidateFailed = false;
                vm.isValidated = false;
                vm.isInputBadlyFormatted = false;

                vm.fnGoToValidation = function (spec) {
                    var flag = isJson(spec);

                    if (flag) {
                        vm.isValidated = false;
                        vm.isValidateFailed = false;
                        vm.isInputBadlyFormatted = false;
                        WizardHandler.wizard().goTo(2);
                    } else {
                        vm.isInputBadlyFormatted = true;
                    }
                };

                vm.fnGoToTransformer = function () {
                    WizardHandler.wizard().goTo(1);
                };

                vm.fnGoToReview = function () {
                    WizardHandler.wizard().goTo(3);
                };

                vm.fnGoToInfo = function () {
                    WizardHandler.wizard().goTo(0);
                };

                vm.fnValidateAgain = function () {
                    vm.isValidated = false;
                };

                vm.fnValidateTransformer = function (validateInput, transformerObj) {
                    vm.isTransformerValidating = true;

                    var flag = isJson(validateInput);

                    if (flag) {
                        var inputObj = {
                            body: {
                                input: angular.fromJson(validateInput),
                                spec: angular.fromJson(transformerObj.txtSpec)
                            }
                        };

                        TransformerFactory.validateTransformer(inputObj)
                            .then(function (response) {
                                vm.isValidated = true;
                                vm.isTransformerValidating = false;
                                vm.validateResult = angular.toJson(response);
                            }, function () {
                                vm.isValidateFailed = true;
                                vm.isTransformerValidating = false;
                            })
                    } else {
                        vm.isTransformerValidating = false;
                        vm.isInputBadlyFormatted = true;
                    }
                };

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.getPrettyJson = function (jsonObj) {
                    var flag = isJson(jsonObj);
                    if (flag) {
                        return angular.toJson(angular.fromJson(jsonObj), true);
                    } else {
                        return jsonObj;
                    }
                };

                vm.fnSetTableHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight();

                vm.finishedWizard = function () {
                    vm.isTransformerCreating = true;
                    var createObj = {
                        "name": vm.newTransformerObj.name,
                        "description": vm.newTransformerObj.description,
                        "spec": angular.fromJson(vm.newTransformerObj.txtSpec)
                    };

                    var inputObj = {
                        body: createObj
                    };

                    TransformerFactory.createTransformer(inputObj)
                        .then(function (resObj) {
                            $scope.transformers.totalItems = $scope.transformers.totalItems + 1;
                            $scope.transformers.transformersArr.push(resObj);
                            if (vm.isCalledFromBluePrint) {
                                $scope.transformers.fnHideShowCreateForm(true); //parent function
                            } else {
                                $scope.transformers.fnHideShowCreateForm();
                            }
                            vm.isCalledFromBluePrint = false;
                            vm.newTransformerObj = angular.copy(resetObj);
                            vm.validateInput = '';
                            vm.isTransformerCreating = false;
                            $timeout(function(){ // set table height
                                $scope.transformers.fnSetTableHeight();//parent function
                            }, 800)
                            $scope.transformers.fnReload();
                        }, function () {
                            vm.isCalledFromBluePrint = false;
                            vm.isTransformerCreating = false;
                        })
                };

                /*start: blue print*/
                vm.isCalledFromBluePrint = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';

                vm.fnBluePrintSelected = function (selectedBluePrint) {
                    vm.isBluePrintSelected = false;
                    if (selectedBluePrint) {
                        angular.forEach(vm.bluePrintArr, function (bluePrintObj) {
                            if (bluePrintObj.name === selectedBluePrint) {
                                vm.newTransformerObj = bluePrintObj;
                                vm.newTransformerObj.txtSpec = angular.toJson(vm.newTransformerObj.spec);
                            }
                        });
                        $timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });
                        $timeout(function () {
                            vm.isBluePrintSelected = true;
                        })
                    }
                };
                vm.fnInitCreateTransformerFromBluePrint = function () {
                    vm.isCalledFromBluePrint = true;
                    TransformerFactory.getTransformerBluePrints()
                        .then(function (response) {
                            vm.bluePrintArr = response;
                            vm.resetBluePrintArr = angular.copy(vm.bluePrintArr);
                            vm.isBluePrintFetched = true;
                        }, function () {
                            vm.isBluePrintFetched = true;
                        })
                };
                /*end: blue print*/

                /*START: Edit Blue Print*/
                vm.fnInitEditBluePrint = function () {
                    if (DB.fnGet("TransformerEditMode")) {
                        vm.reviewBtnTxt = 'Save Transformer'; //if changed then the value has to also change on review.html ng-if condition
                        vm.newTransformerObj = DB.fnGet("TransformerEditMode");
                        vm.newTransformerObj.txtSpec = angular.toJson(vm.newTransformerObj.spec, true);
                        /*$timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });*/
                    }
                };

                vm.fnExitEditMode = function () {
                    $rootScope.$broadcast("exitTransformerEditMode");
                };

                vm.finishedWizardEdit = function (newTransformerObj) {
                    vm.isTransformerCreating = true;
                    vm.newTransformerObj.spec = angular.fromJson(vm.newTransformerObj.txtSpec);
                    $rootScope.$broadcast("updateTransformer", newTransformerObj);
                };

                $scope.$on("updateProcessCompleted", function () {
                    vm.isTransformerCreating = false;
                })

                vm.fnBluePrintFilter = function () {
                    vm.isBluePrintFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.resetBluePrintArr, function (typeObj) {
                            if (typeObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetBluePrintArr);
                    }
                    vm.bluePrintArr = searchArr;
                    $timeout(function () {
                        vm.isBluePrintFilter = false;
                    },1000)
                };
                /*END: Edit Blue Print*/
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive("templateInfo", fnTemplateInfo)

    /** @ngInject */
    function fnTemplateInfo($window, $state, $stateParams, $base64, $timeout, $uibModal, microSpinner, swal, amaran, DB, TemplateFactory,copyService,  postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/pipeline/templates/templateInfo/templateInfo.html',
            scope: {
                templateObj: '=',
                templatePermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/pipeline/templates/templateInfo/templateTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetTemplate = function (templateId) {
                    var inputObj = {
                        templateId: templateId
                    };
                    TemplateFactory.getTemplate(inputObj)
                        .then(function (response) {
                            $scope.templateObj = response;
                            if (angular.isUndefined($scope.templateObj.description)) {
                                $scope.templateObj.description = '';
                            }
                            $scope.isTemplateDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isTemplateDetailsLoaded = true;
                        })
                };

                $scope.fnUpdateTemplateDetails = function (templateObj) {
                    var inputObj = {
                        body: {},
                        templateId: templateObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(templateObj.description)) {
                        templateObj.description = '';
                    }
                    inputObj.body = {
                        name: templateObj.name,
                        description: templateObj.description,
                        body: templateObj.body
                    };
                    TemplateFactory.modifyTemplate(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('TemplateDetailsChanged', response);
                            $scope.$broadcast("updateProcessCompleted");
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            DB.fnRemove("TemplateEditMode");
                            amaran.success("Template Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.pipeline_templates', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnDeleteTemplate = function (templateObj) {
                    swal({
                            title: "Delete the selected template?",
                            text: "You are about to permanently delete the selected template.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    templateId: templateObj.id
                                };
                                TemplateFactory.deleteTemplate(inputObj)
                                    .then(function () {
                                        $scope.$emit('TemplateDeleted', templateObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function (templateObj) {
                    $scope.isDetailsEditable = true;
                    DB.fnSet("TemplateEditMode", templateObj);
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                function isJson(jsonObj) {
                    try {
                        angular.fromJson(jsonObj);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                $scope.getPrettyJson = function (jsonObj) {
                    var flag = isJson($base64.decode(jsonObj));
                    if (flag) {
                        return angular.toJson(angular.fromJson($base64.decode(jsonObj)), true);
                    } else {
                        return decodeURIComponent(escape($base64.decode(jsonObj)));
                    }
                };

                $scope.fnInitTemplate = function () {
                    $scope.isTemplateDetailsLoaded = false;
                    $scope.templateId = $scope.templateObj.id;
                    if ($scope.templateId) {
                        $scope.fnGetTemplate($scope.templateId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.fnCheckIsHTML = function () {
                    if(isHtml($scope.getPrettyJson($scope.templateObj.body))){
                        $scope.isHTMLCode = true;
                    }else{
                        $scope.isHTMLCode = false;
                    }
                };

                $scope.fnViewRenderedHTML = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/templates/modal/htmlPreviewModal/htmlPreviewModal.html',
                        size: 'lg',
                        controller: 'htmlPreviewModalCtrl as htmlPreview',
                        windowClass: 'modal-height100',
                        resolve: {
                            decodedBody: function () {
                                return $scope.getPrettyJson($scope.templateObj.body);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {});
                };

                function isHtml (testString) {
                    var htmlRegex = new RegExp("<([A-Za-z][A-Za-z0-9]*)\\b[^>]*>(.*?)</\\1>");
                    return htmlRegex.test(angular.toJson(testString));
                }

                $scope.$on("exitTemplateEditMode", function () {
                    $scope.isDetailsEditable = false;
                    DB.fnRemove("exitTemplateEditMode");
                });

                $scope.$on("updateTemplate", function (event, data) {
                    $scope.fnUpdateTemplateDetails(data);
                });

                var templateInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.pipeline_templates') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.templatePermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteTemplate($scope.templateObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.templatePermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Edit
                                $scope.fnChangeFieldsToEditable($scope.templateObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var templateInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.pipeline_templates') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', templateInfoKeyDownEventHandler);
                document.addEventListener('keyup', templateInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', templateInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', templateInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createTemplateCtrl',
            function ($scope, $base64, $window, $rootScope, $uibModal, TemplateFactory, $timeout, WizardHandler, DB) {
                var vm = this;

                $scope.$on('wizard:stepChanged', function (event, args) {
                    if (args.index === 2) {
                        vm.modeChanged();
                    }
                });

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                vm.title = "Create Template";
                vm.reviewBtnTxt = 'Create Template';

                // search type client side
                vm.search = '';
                vm.isBluePrintFilter = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newTemplateObj = {
                    name: '',
                    description: '',
                    body: '',
                    decodedBody: ''
                };

                var resetObj = angular.copy(vm.newTemplateObj);

                vm.validateInput = '';
                vm.validateResult = '';
                vm.isTemplateValidating = false;
                vm.isTemplateCreating = false;
                vm.isValidateFailed = false;
                vm.isValidated = false;
                vm.isInputBadlyFormatted = false;

                vm.fnGoToValidation = function () {
                    vm.isValidated = false;
                    vm.isValidateFailed = false;
                    vm.isInputBadlyFormatted = false;
                };

                vm.fnGoToTemplate = function () {
                    WizardHandler.wizard().goTo(1);
                };

                vm.fnGoToInfo = function () {
                    WizardHandler.wizard().goTo(0);
                };

                vm.fnGoToReview = function () {
                    WizardHandler.wizard().goTo(3);
                };

                vm.fnValidateAgain = function () {
                    vm.isValidated = false;
                };

                vm.fnValidateTemplate = function (validateInput, templateObj) {
                    vm.isTemplateValidating = true;

                    var flag = isJson(validateInput);

                    if (flag) {
                        var inputObj = {
                            body: {
                                input: angular.fromJson(validateInput),
                                body: $base64.encode(unescape(encodeURIComponent(templateObj.decodedBody)))
                            }
                        };

                        TemplateFactory.validateTemplate(inputObj)
                            .then(function (response) {
                                vm.isValidated = true;
                                vm.isTemplateValidating = false;
                                vm.validateResult = decodeURIComponent(escape($base64.decode(response.template)));
                            }, function () {
                                vm.isValidateFailed = true;
                                vm.isTemplateValidating = false;
                            })
                    } else {
                        vm.isTemplateValidating = false;
                        vm.isInputBadlyFormatted = true;
                    }
                };

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                vm.fnSetTableHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight();

                vm.finishedWizard = function () {
                    vm.isTemplateCreating = true;
                    var createObj = {
                        "name": vm.newTemplateObj.name,
                        "description": vm.newTemplateObj.description,
                        "body": $base64.encode(unescape(encodeURIComponent(vm.newTemplateObj.decodedBody)))
                    };

                    var inputObj = {
                        body: createObj
                    };

                    TemplateFactory.createTemplate(inputObj)
                        .then(function (resObj) {
                            if (vm.isCalledFromBluePrint) {
                                $scope.templates.fnHideShowCreateForm(true); //parent function
                            } else {
                                $scope.templates.fnHideShowCreateForm();
                            }
                            vm.isCalledFromBluePrint = false;
                            vm.newTemplateObj = angular.copy(resetObj);
                            vm.validateInput = '';
                            vm.isTemplateCreating = false;
                            $timeout(function(){ // set table height
                                $scope.templates.fnSetTableHeight();//parent function
                            }, 800);
                            if($scope.templates.permissionObj.List) {
                                $scope.templates.totalItems = $scope.templates.totalItems + 1;
                                $scope.templates.templatesArr.push(resObj);
                                $scope.templates.fnReload();
                            }
                        }, function () {
                            vm.isCalledFromBluePrint = false;
                            vm.isTemplateCreating = false;
                        })
                };

                /*start: blue print*/
                vm.isCalledFromBluePrint = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';

                vm.fnBluePrintSelected = function (selectedBluePrint) {
                    vm.isBluePrintSelected = false;
                    if (selectedBluePrint) {
                        angular.forEach(vm.bluePrintArr, function (bluePrintObj) {
                            if (bluePrintObj.name === selectedBluePrint) {
                                vm.newTemplateObj = bluePrintObj;
                                vm.newTemplateObj.decodedBody = decodeURIComponent(escape($base64.decode(vm.newTemplateObj.body)));
                            }
                        });
                        $timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });
                        $timeout(function () {
                            vm.isBluePrintSelected = true;
                        })
                    }
                };
                vm.fnInitCreateTemplateFromBluePrint = function () {
                    vm.isCalledFromBluePrint = true;
                    TemplateFactory.getTemplateBluePrints()
                        .then(function (response) {
                            vm.bluePrintArr = response;
                            vm.resetBluePrintArr = angular.copy(vm.bluePrintArr);
                            vm.isBluePrintFetched = true;

                        }, function () {
                            vm.isBluePrintFetched = true;
                        })
                };
                /*end: blue print*/

                /*START: Edit Blue Print*/
                vm.fnInitEditBluePrint = function () {
                    if (DB.fnGet("TemplateEditMode")) {
                        vm.reviewBtnTxt = 'Save Template'; //if changed then the value has to also change on review.html ng-if condition
                        vm.newTemplateObj = DB.fnGet("TemplateEditMode");
                        vm.newTemplateObj.decodedBody = decodeURIComponent(escape($base64.decode(vm.newTemplateObj.body)));
                        vm.fnCheckIsHTML()
                        /*$timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });*/
                    }
                };

                vm.fnExitEditMode = function () {
                    $rootScope.$broadcast("exitTemplateEditMode");
                };

                vm.finishedWizardEdit = function (newTemplateObj) {
                    vm.isTemplateCreating = true;
                    newTemplateObj.body = $base64.encode(unescape(encodeURIComponent((newTemplateObj.decodedBody))));
                    $rootScope.$broadcast("updateTemplate", newTemplateObj);
                };

                vm.fnCheckIsHTML = function () {
                    if(isHtml(vm.newTemplateObj.decodedBody)){
                        vm.isHTMLCode = true;
                    }else{
                        vm.isHTMLCode = false;
                    }
                };

                vm.fnViewRenderedHTML = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/templates/modal/htmlPreviewModal/htmlPreviewModal.html',
                        size: 'lg',
                        controller: 'htmlPreviewModalCtrl as htmlPreview',
                        windowClass: 'modal-height100',
                        resolve: {
                            decodedBody: function () {
                                return vm.newTemplateObj.decodedBody;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {});
                };

                function isHtml (testString) {
                    var htmlRegex = new RegExp("<([A-Za-z][A-Za-z0-9]*)\\b[^>]*>(.*?)</\\1>");
                    return htmlRegex.test(angular.toJson(testString));
                }


                $scope.$on("updateProcessCompleted", function () {
                    vm.isTemplateCreating = false;
                })

                vm.fnBluePrintFilter = function () {
                    vm.isBluePrintFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.resetBluePrintArr, function (typeObj) {
                            if (typeObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetBluePrintArr);
                    }
                    vm.bluePrintArr = searchArr;
                    $timeout(function () {
                        vm.isBluePrintFilter = false;
                    },1000)
                };
                /*END: Edit Blue Print*/
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('listenerInfo', fnlistenerInfo)

    /** @ngInject */
    function fnlistenerInfo($window, $state, $stateParams, $timeout,$uibModal, microSpinner, swal, amaran, DB, copyService, PermissionsService, ListenerFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/pipeline/listeners/listenerInfo/listenerInfo.html',
            scope: {
                listenerObj: '=',
                listenerPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/pipeline/listeners/listenerInfo/listenerTabs/details.html',
                        visible: true
                    },
                    {
                        title: 'Workflows',
                        tabIndex: 2,
                        templateUrl: 'app/pipeline/listeners/listenerInfo/listenerTabs/listenerWorkflow/listenerWorkflow.html',
                        visible: true
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.isUpdateListenerState = true;
                $scope.deleteListenerStatementsArr = [];

                $scope.fnGetListener = function (listenerId) {
                    var inputObj = {
                        listenerId: listenerId
                    };
                    ListenerFactory.getListener(inputObj)
                        .then(function (response) {
                            $scope.listenerObj = response;
                            if (angular.isUndefined($scope.listenerObj.description)) {
                                $scope.listenerObj.description = '';
                            }
                            $scope.isListenerDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isListenerDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.listeners', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnDeleteListener = function (listenerObj) {
                    swal({
                            title: "Delete the selected listener?",
                            text: "You are about to permanently delete the selected listener.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    listenerId: listenerObj.id
                                };
                                ListenerFactory.deleteListener(inputObj)
                                    .then(function () {
                                        $scope.$emit('ListenerDeleted', listenerObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function (listenerObj) {
                    /*$scope.isDetailsEditable = true;*/
                    var windowSize = angular.element($window);
                    if(windowSize[0].innerWidth > 1600){
                        $scope.isDetailsEditable = true;
                        $scope.listenerObj = listenerObj;
                    } else {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/pipeline/listeners/editListener/editListener.html',
                            size: 'lg',
                            controller: 'editListenerCtrl as editListener',
                            resolve: {
                                listenerObj: function () {
                                    return listenerObj;
                                }
                            }
                        });
                        modalInstance.result.then(function () {

                        }, function (obj) {
                            $scope.listenerObj = angular.copy(obj);
                        });
                    }
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitListener = function () {
                    $scope.isListenerDetailsLoaded = false;
                    $scope.listenerId = $scope.listenerObj.id;
                    if ($scope.listenerId) {
                        $scope.fnGetListener($scope.listenerId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.fnChangeListenerState = function(listenerObj){
                    var inputObj = {
                        body: {},
                        listenerId: listenerObj.id
                    };
                    $scope.isUpdateListenerState = false;

                    if (angular.isUndefined(listenerObj.description)) {
                        listenerObj.description = '';
                    }
                    inputObj.body = {
                        state: listenerObj.state === 'ACTIVE'?'INACTIVE':'ACTIVE'
                    };
                    ListenerFactory.modifyListener(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.listenerObj = response;
                            $scope.$emit('ListenerDetailsChanged', response);
                            $scope.$broadcast("updateProcessCompleted");
                            $scope.isUpdateListenerState = true;
                            amaran.success("Listener Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.$on("exitListenerEditMode", function (event,data) {
                    $scope.listenerObj = data;
                    $scope.isDetailsEditable = false;
                });


                $scope.$on("updateDeleteListenerStatementsArr", function (event, data) {
                    $scope.deleteListenerStatementsArr.push(data);
                });

                var listenerInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.listeners') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.listenerPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteListener($scope.listenerObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.listenerPermissionsObj.Modify
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable($scope.listenerObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var listenerInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.listeners') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', listenerInfoKeyDownEventHandler);
                document.addEventListener('keyup', listenerInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', listenerInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', listenerInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('editListenerCtrl',
            function ($scope, $timeout, $uibModalInstance, $window, $rootScope, amaran, FilterQueryService, ActionOptionArrService, ListenerFactory, WizardHandler, BatchFactory, listenerObj) {
                var vm = this;
                var count =0;
                vm.actionOptionArr = [];
                vm.tabSelected = function () {
                    vm.modeChanged();
                    if (vm.queryBuilder.rules.length) {
                        vm.statementsObj.advance = angular.copy(angular.toJson(vm.queryBuilder, true))
                    }
                };

                vm.queryBuilderSelected = function () {
                    if (angular.isDefined(vm.statementsObj.advance) && isJson(vm.statementsObj.advance)) {
                        vm.queryBuilder = angular.copy(angular.fromJson(vm.statementsObj.advance));
                    }
                };

                vm.isAllChecked = false;
                vm.selectedStatementssArr = [];
                vm.deleteListenerStatementsArr = [];
                vm.selectedTab = 1;
                var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
                var appCount = 0;
                vm.modelsObj = {};
                vm.tabs = [
                    {
                        title: 'Information',
                        tabIndex: 1
                    },
                    {
                        title: 'Statements',
                        tabIndex: 2
                    }
                ];
                vm.isAddExpression = false;
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };
                vm.actionArr = [];
                vm.queryBuilder = {"condition": "OR", "rules": []};
                vm.isEditMode = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newListenerObj = {
                    name: '',
                    description: '',
                    statements: []
                };

                vm.statementsObj = {
                    effect: "ALLOW",
                    actions: []
                };

                vm.effectOptionArr = [
                    "ALLOW",
                    "DENY"
                ];

                vm.statesArr = [
                    "INACTIVE",
                    "ACTIVE"
                ];

                vm.fnAddNewStatements = function () {
                    WizardHandler.wizard().goTo(0);
                    var rulesObj = {
                        "condition": "AND",
                        "rules": []
                    };
                    vm.qbFilters = null;
                    $rootScope.$broadcast("queryBuilderReset", rulesObj);
                    vm.queryBuilder = {"condition": "AND", "rules": []};
                    vm.statementsObj = {
                        effect: "ALLOW",
                        actions: []
                    };
                };

                vm.fnEditStatements = function (statementsObj) {
                    WizardHandler.wizard().goTo(0);
                    var rulesObj;
                    if (!statementsObj.expression || statementsObj.expression === null) {
                        rulesObj = {"condition": "AND", "rules": []};
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                    } else {
                        rulesObj = statementsObj.expression;
                        vm.queryBuilder = statementsObj.expression;
                    }
                    vm.statementsObj = statementsObj;
                    vm.qbFilters = null;
                    vm.isEditMode = true;
                    $rootScope.$broadcast("queryBuilderSet", rulesObj);
                };

                vm.fnCreateFilterObj = function (actionsArr) {
                    vm.qbFilters = null;
                    var arr = FilterQueryService.fnGetFilterArr(actionsArr, vm.modelsObj);
                    $timeout(function () {
                        arr = arr.map(function (val) {
                            return {
                                id: val,
                                type: 'string',
                                operators: ['equal',
                                    'not_equal',
                                    'in',
                                    'not_in',
                                    'start',
                                    'not_start',
                                    'end',
                                    'not_end',
                                    'less',
                                    'less_or_equal',
                                    'greater',
                                    'greater_or_equal']
                            }
                        });
                        vm.qbFilters = arr;
                    },10);
                };

                vm.fnCreateActionTag = function (action) {
                    if (action) {
                        var flag = false;
                        angular.forEach(vm.statementsObj.actions, function (actionObj) {
                            if (actionObj === action) {
                                flag = true;
                            }
                        });

                        if (!flag) {
                            vm.statementsObj.actions.push(angular.copy(action));
                            vm.action = "";
                        }
                    }
                };

                vm.fnRemoveTags = function (index) {
                    vm.statementsObj.actions.splice(index, 1);
                };

                vm.fnRemoveFromArr = function (index, arr) {
                    $rootScope.$broadcast('updateDeleteListenerStatementsArr', arr[index].id);
                    arr.splice(index, 1);
                };

                vm.fnExpression = function (isBuilder, isEditMode) {
                    if (isBuilder) {
                        $rootScope.$broadcast('changeText', {});
                    }

                    $timeout(function () {
                        if (vm.activeTab === 1 && vm.statementsObj.advance) {
                            vm.statementsObj.expression = vm.statementsObj.advance;
                        } else {
                            if (vm.queryBuilder.rules.length) {
                                vm.statementsObj.expression = vm.queryBuilder
                            } else {
                                vm.statementsObj.expression = null;
                            }
                        }
                        if (vm.statementsObj.expression) {
                            delete vm.statementsObj.expression.valid;
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            // noinspection JSAnnotator
                            delete vm.statementsObj.advance;
                        }
                        var rulesObj = '';
                        if (!isEditMode) {
                            vm.newListenerObj.statements.push(vm.statementsObj);
                            vm.statementsObj = {
                                effect: "ALLOW",
                                actions: []
                            };
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            rulesObj = {"condition": "AND", "rules": []};
                            $rootScope.$broadcast("queryBuilderSet", rulesObj);
                        }else {
                            vm.statementsObj = angular.copy({
                                effect: "ALLOW",
                                actions: []
                            });
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            rulesObj = {"condition": "AND", "rules": []};
                            $rootScope.$broadcast("queryBuilderSet", rulesObj);
                        }
                        vm.isEditMode = false;
                    }, 10);
                    vm.isAddExpression = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element("#expressionDiv")[0]) &&
                        angular.isDefined(angular.element("#addExpressionDiv")[0]) &&
                        angular.isDefined(angular.element(".table-container")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {

                        var modalBody = angular.element("#expressionDiv")[0].offsetHeight;
                        var express = angular.element("#addExpressionDiv")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var rightTableHieght = modalBody - (pagination + header + express +  50);
                        angular.element(".edit-listener-table tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetTableHeight();

                vm.fnGoBacktoReview = function () {
                    vm.isAddExpression = false;
                    vm.statementsObj = angular.copy({
                        effect: "ALLOW",
                        actions: []
                    });
                    vm.queryBuilder = {"condition": "AND", "rules": []};
                    var rulesObj = {"condition": "AND", "rules": []};
                    $rootScope.$broadcast("queryBuilderSet", rulesObj);
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };


                vm.fnSet = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                /*START: Edit Blue Print*/
                vm.fnInitEditBluePrint = function () {
                    vm.fnInitEditAppModels();
                    if (listenerObj) {
                        vm.newListenerObj = listenerObj;
                        vm.resetNewListenerObj = angular.copy(vm.newListenerObj);
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }
                };

                vm.fnExitEditMode = function () {
                    /*$rootScope.$broadcast("exitListenerEditMode");*/
                    vm.deleteListenerStatementsArr = [];
                };

                vm.fnEditExpression = function (obj) {
                    vm.isAddExpression = true;
                    $timeout(function () {
                        vm.fnEditStatements(obj);
                    });
                };

                vm.count = 0;
                vm.fnDeleteExpression = function () {
                    angular.forEach(vm.newListenerObj.statements, function (obj, index) {
                        if (obj.isCheck) {
                            if (obj.id) {
                                vm.deleteListenerStatementsArr.push(obj.id);
                            }
                            vm.newListenerObj.statements.splice(index, 1);
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnUpdateListenerStatement = function (listenerObj, statementObj) {
                    var inputObj = {
                        listenerId: listenerObj.id,
                        statementId: statementObj.id,
                        body: statementObj
                    };

                    ListenerFactory.modifyListenerStatement(inputObj)
                        .then(function () {
                            count++;
                            vm.fnUpdateListener(listenerObj);
                        })
                };

                vm.fnCreateNewStatement = function (listenerObj, statementObj) {
                    var inputObj = {
                        listenerId: listenerObj.id,
                        body: statementObj
                    };

                    ListenerFactory.createListenerStatement(inputObj)
                        .then(function () {
                            count++;
                            vm.fnUpdateListener(listenerObj);
                        })
                };

                vm.fnUpdateListener = function (listenerObj) {
                    if (listenerObj.statements.length && count < listenerObj.statements.length) {
                        if (listenerObj.statements[count].id) {
                            vm.fnUpdateListenerStatement(listenerObj, listenerObj.statements[count])
                        } else {
                            vm.fnCreateNewStatement(listenerObj, listenerObj.statements[count])
                        }
                    } else {
                        if(vm.deleteListenerStatementsArr.length) {
                            vm.fnDeleteListenerStatements(listenerObj, vm.deleteListenerStatementsArr);
                        } else {
                            count = 0;
                            vm.fnUpdateListenerDetails(listenerObj);
                        }
                    }
                };

                vm.fnDeleteListenerStatements = function (listenerObj, statementsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var editCount = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(statementsArr, function (selectedStatementId, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + listenerObj.id + "/statements/" + selectedStatementId;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            editCount++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + listenerObj.id + "/statements/" + selectedStatementId;
                            batchArr.push(inputObj);
                            batchCollectionObj[editCount] = batchArr;
                            inputObj = {};
                        }
                    });
                    editCount = 1;
                    vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, editCount, listenerObj) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[editCount], tag: 'listener', appName: 'pipeline'})
                        .then(function () {
                            if(editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                            } else {
                                count = 0;
                                vm.fnUpdateListenerDetails(listenerObj);
                            }
                        }, function (error) {
                            if(editCount < Object.keys(batchCollectionObj).length) {
                                editCount++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, editCount, listenerObj);
                            } else {
                                count = 0;
                                vm.fnUpdateListenerDetails(listenerObj);
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnUpdateListenerDetails = function (listenerObj) {
                    var inputObj = {
                        body: {},
                        listenerId: listenerObj.id
                    };
                    vm.isUpdateCompleted = false;

                    if (angular.isUndefined(listenerObj.description)) {
                        listenerObj.description = '';
                    }
                    inputObj.body = {
                        name: listenerObj.name,
                        description: listenerObj.description,
                        state: listenerObj.state
                    };
                    ListenerFactory.modifyListener(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('ListenerDetailsChanged', response);
                            $scope.$broadcast("updateProcessCompleted");
                            vm.isUpdateCompleted = true;
                            vm.isDetailsEditable = false;
                            vm.isListenerCreating = false;
                            amaran.success("Listener Updated Successfully");
                            $uibModalInstance.dismiss(response);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                            vm.isDetailsEditable = false;
                            vm.isListenerCreating = false;
                        })
                };

                vm.finishedWizardEdit = function (newListenerObj) {
                    vm.isListenerCreating = true;
                    count = 0;
                    /*$rootScope.$broadcast("updateListener", newListenerObj);*/
                    vm.fnUpdateListener(newListenerObj);
                };

                vm.fnAddExpression = function () {
                    vm.btnText = "Add Expression";
                    vm.isAddExpression = true;
                };

                vm.fnCheckUncheckHeader = function (statementsObj) {
                    vm.isAllChecked = false;
                    vm.selectedStatementssArr = [];
                    angular.forEach(vm.newListenerObj.statements, function (obj) {
                        obj.isCheck = false;
                    });
                    statementsObj.isCheck = !statementsObj.isCheck;
                    if (statementsObj.isCheck) {
                        vm.selectedStatementssArr.push(statementsObj)
                    } else {
                        vm.selectedStatementssArr = []
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                function isJson(jsonObj) {
                    try {
                        angular.fromJson(jsonObj);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                $scope.$on("updateProcessCompleted", function () {
                    vm.isListenerCreating = false;
                });
                /*END: Edit Blue Print*/
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss(vm.resetNewListenerObj);
                };

                vm.fnGetAppModels = function (count) {
                    var inputObj = {
                        appName: appArr[count]
                    };
                    ListenerFactory.getListenerModels(inputObj)
                        .then(function (response) {
                            vm.modelsObj[appArr[count]] = response;
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        }, function () {
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        })

                };
                vm.fnInitEditAppModels = function () {
                    vm.isListenerModelsLoading = true;
                    vm.actionOptionArr = ActionOptionArrService.getActionOptionArr();
                    if(appCount < appArr.length) {
                        vm.fnGetAppModels(appCount);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createListenerCtrl',
            function ($scope, $window, $rootScope, $timeout, ListenerFactory, FilterQueryService, ActionOptionArrService, WizardHandler) {
                var vm = this;
                vm.actionOptionArr = [];
                vm.tabSelected = function () {
                    vm.modeChanged();
                    if (vm.queryBuilder.rules.length) {
                        vm.statementsObj.advance = angular.copy(angular.toJson(vm.queryBuilder, true))
                    }
                };

                vm.queryBuilderSelected = function () {
                    if (angular.isDefined(vm.statementsObj.advance) && isJson(vm.statementsObj.advance)) {
                        vm.queryBuilder = angular.copy(angular.fromJson(vm.statementsObj.advance));
                    }
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                vm.title = "Create Listener";
                vm.actionArr = [];
                vm.queryBuilder = {"condition": "OR", "rules": []};
                vm.isEditMode = false;
                vm.reviewBtnTxt = 'Create Listener';
                vm.isListenerModelsLoading = true;
                var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
                var appCount = 0;
                vm.modelsObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newListenerObj = {
                    name: '',
                    description: '',
                    statements: [],
                    state:'ACTIVE'
                };

                vm.statementsObj = {
                    effect: "ALLOW",
                    actions: []
                };

                var resetObj = angular.copy(vm.newListenerObj);

                vm.effectOptionArr = [
                    "ALLOW",
                    "DENY"
                ];

                vm.statesArr = [
                    "INACTIVE",
                    "ACTIVE"
                ];

                vm.fnAddNewStatements = function () {
                    WizardHandler.wizard().goTo(1);
                    var rulesObj = {
                        "condition": "AND",
                        "rules": []
                    };
                    vm.qbFilters = null;
                    $rootScope.$broadcast("queryBuilderReset", rulesObj);
                    vm.queryBuilder = {"condition": "AND", "rules": []};
                    vm.statementsObj = {
                        effect: "ALLOW",
                        actions: []
                    };
                };

                vm.fnEditStatements = function (statementsObj) {
                    WizardHandler.wizard().goTo(1);
                    var rulesObj;
                    if (!statementsObj.expression || statementsObj.expression === null) {
                        rulesObj = {"condition": "AND", "rules": []};
                        vm.queryBuilder = {"condition": "AND", "rules": []};
                    } else {
                        rulesObj = statementsObj.expression;
                        vm.queryBuilder = statementsObj.expression;
                    }
                    vm.statementsObj = statementsObj;
                    vm.qbFilters = null;
                    vm.isEditMode = true;
                    $rootScope.$broadcast("queryBuilderSet", rulesObj);
                };

                vm.fnCreateFilterObj = function (actionsArr) {
                    vm.qbFilters = null;
                    var arr = FilterQueryService.fnGetFilterArr(actionsArr, vm.modelsObj);
                    $timeout(function () {
                        arr = arr.map(function (val) {
                            return {
                                id: val,
                                type: 'string',
                                operators: ['equal',
                                    'not_equal',
                                    'in',
                                    'not_in',
                                    'start',
                                    'not_start',
                                    'end',
                                    'not_end',
                                    'less',
                                    'less_or_equal',
                                    'greater',
                                    'greater_or_equal']
                            }
                        });
                        vm.qbFilters = arr;
                    },10);
                };

                vm.fnCreateActionTag = function (action) {
                    if (action) {
                        var flag = false;
                        angular.forEach(vm.statementsObj.actions, function (actionObj) {
                            if (actionObj === action) {
                                flag = true;
                            }
                        });

                        if (!flag) {
                            vm.statementsObj.actions.push(angular.copy(action));
                            vm.action = "";
                        }
                    }
                };

                vm.fnRemoveTags = function (index) {
                    vm.statementsObj.actions.splice(index, 1);
                };

                vm.fnRemoveFromArr = function (index, arr) {
                    $rootScope.$broadcast('updateDeleteListenerStatementsArr', arr[index].id);
                    arr.splice(index, 1);
                };

                vm.fnExpression = function (isBuilder, isEditMode) {
                    if (isBuilder) {
                        $rootScope.$broadcast('changeText', {});
                    }

                    $timeout(function () {
                        if (vm.activeTab === 1 && vm.statementsObj.advance) {
                            vm.statementsObj.expression = vm.statementsObj.advance;
                        } else {
                            if (vm.queryBuilder.rules.length) {
                                vm.statementsObj.expression = vm.queryBuilder
                            } else {
                                vm.statementsObj.expression = null;
                            }
                        }
                        if (vm.statementsObj.expression) {
                            delete vm.statementsObj.expression.valid;
                            vm.queryBuilder = {"condition": "AND", "rules": []};
                            // noinspection JSAnnotator
                            delete vm.statementsObj.advance;
                        }
                        if (!isEditMode) {
                            vm.newListenerObj.statements.push(vm.statementsObj);
                        }
                        vm.isEditMode = false;
                    }, 10)
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight();

                vm.fnGoBacktoReview = function () {
                    if (vm.isEditMode === true) {
                        vm.isEditMode = false;
                    }
                    WizardHandler.wizard().goTo(3);
                };

                vm.finishedWizard = function () {
                    vm.isListenerCreating = true;
                    var createObj = {
                        "name": vm.newListenerObj.name,
                        "description": vm.newListenerObj.description,
                        "state": vm.newListenerObj.state,
                        "statements": vm.newListenerObj.statements
                    };

                    var inputObj = {
                        body: createObj
                    };

                    ListenerFactory.createListener(inputObj)
                        .then(function (resObj) {
                            if (vm.isCalledFromBluePrint) {
                                $scope.listeners.fnHideShowCreateForm(true); //parent function
                            } else {
                                $scope.listeners.fnHideShowCreateForm();
                            }
                            vm.isCalledFromBluePrint = false;
                            vm.newListenerObj = angular.copy(resetObj);
                            vm.isListenerCreating = false;


                            $timeout(function () { // set table height
                                $scope.listeners.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('listenerAdded', resObj.id);
                            if($scope.listeners.permissionObj.List) {
                                $scope.listeners.totalItems = $scope.listeners.totalItems + 1;
                                $scope.listeners.listenersArr.push(resObj);
                                $scope.listeners.fnReload();
                            }
                        }, function () {
                            vm.isListenerCreating = false;
                        })
                };

                /*start: blue print*/
                vm.isCalledFromBluePrint = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';

                vm.fnBluePrintSelected = function (selectedBluePrint) {
                    vm.isBluePrintSelected = false;
                    if (selectedBluePrint) {
                        angular.forEach(vm.bluePrintArr, function (bluePrintObj) {
                            if (bluePrintObj.name === selectedBluePrint) {
                                vm.newListenerObj = bluePrintObj;
                            }
                        });
                        $timeout(function () {
                            WizardHandler.wizard().goTo(3);
                        });
                        $timeout(function () {
                            vm.isBluePrintSelected = true;
                        })
                    }
                };
                vm.fnInitCreateListenerFromBluePrint = function () {
                    vm.isCalledFromBluePrint = true;
                    ListenerFactory.getListenerBluePrints()
                        .then(function (response) {
                            vm.bluePrintArr = response;
                            var tempObj = {
                                name: ''
                            };
                            vm.bluePrintArr.unshift(tempObj);
                            vm.isBluePrintFetched = true;
                            vm.fnInitCreateListeners();
                        }, function () {
                            vm.isBluePrintFetched = true;
                            vm.fnInitCreateListeners();
                        })
                };
                /*end: blue print*/

                /*START: Edit Blue Print*/

                function isJson(jsonObj) {
                    try {
                        angular.fromJson(jsonObj);
                    } catch (err) {
                        return false;
                    }
                    return true;
                }

                $scope.$on("updateProcessCompleted", function () {
                    vm.isListenerCreating = false;
                });
                /*END: Edit Blue Print*/

                vm.fnGetAppModels = function (count) {
                    var inputObj = {
                        appName: appArr[count]
                    };
                    ListenerFactory.getListenerModels(inputObj)
                        .then(function (response) {
                            vm.modelsObj[appArr[count]] = response;
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        }, function () {
                            count ++;
                            if(count < appArr.length) {
                                vm.fnGetAppModels(count);
                            } else {
                                vm.isListenerModelsLoading = false;
                            }
                        })

                };
                vm.fnInitCreateListeners = function () {
                    vm.isListenerModelsLoading = true;
                    vm.actionOptionArr = ActionOptionArrService.getActionOptionArr();
                    if(appCount < appArr.length) {
                        vm.fnGetAppModels(appCount);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('visualizationInfo', fnVisualizationInfo)

    /** @ngInject */
    function fnVisualizationInfo($window, $timeout, $state, $stateParams, DB, microSpinner, swal, amaran, copyService, PermissionsService, VisualizerFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/visualization/visualizationInfo/visualizationInfo.html',
            scope: {
                visualizerObj: '=',
                visualizerPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/visualization/visualizationInfo/visualizationTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.visualizer', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetVisualizer = function (visualizerId) {
                    var inputObj = {
                        visualizerId: visualizerId
                    };
                    VisualizerFactory.getVisualizer(inputObj)
                        .then(function (response) {
                            $scope.visualizerObj = response;
                            $scope.resetVisualizerObj = angular.copy($scope.visualizerObj);
                            if (angular.isUndefined($scope.visualizerObj.description)) {
                                $scope.visualizerObj.description = '';
                            }
                            $scope.isVisualizerDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isVisualizerDetailsLoaded = true;
                        })
                };

                $scope.fnDeleteVisualizer = function (visualizerObj) {
                    swal({
                            title: "Delete the selected visualizer?",
                            text: "You are about to permanently delete the selected visualizer.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    visualizerId: visualizerObj.id
                                };
                                VisualizerFactory.deleteVisualizer(inputObj)
                                    .then(function () {
                                        $scope.$emit('VisualizerDeleted', visualizerObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGoToVisualization = function (visualizerObj, type) {
                    var stateName = '';
                    if (visualizerObj.typeId === "Device" || visualizerObj.typeId === "Gateway") {
                        stateName = type === 'view' ? "main.viewDeviceGatewayVisualizer" : "main.editDeviceGatewayVisualizer";
                        $state.go(stateName, {
                            id: visualizerObj.id,
                            type: visualizerObj.typeId,
                            filter: visualizerObj.metadata.filterQuery ? visualizerObj.metadata.filterQuery : ''
                        });
                    } else {
                        stateName = type === 'view' ? "main.viewVisualizer" : "main.editVisualizer";
                        $state.go(stateName, {id: visualizerObj.id});
                    }
                };

                $scope.fnInitVisualization = function () {
                    $scope.isVisualizerDetailsLoaded = false;
                    $scope.visualizerId = $scope.visualizerObj.id;
                    $scope.permissionObj = PermissionsService.getPermissions("node:visualizer");
                    $scope.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    $scope.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if ($scope.visualizerId) {
                        $scope.fnGetVisualizer($scope.visualizerId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.fnCheckUserPermission = function (visualizerObj) {
                    if (visualizerObj.typeId === "Device") {
                        return $scope.permissionObj.Create && $scope.devicePermissionObj.List;
                    }
                    if (visualizerObj.typeId === "Gateway") {
                        return $scope.permissionObj.Create && $scope.gatewayPermissionObj.List;
                    }
                    if(visualizerObj.typeId !== "Device" && visualizerObj.typeId !== "Gateway"){
                        return $scope.permissionObj.Create;
                    }
                };

                $scope.fnCloneVisualizer = function (visualizerObj) {
                    DB.fnSet("CloneVisualizer", visualizerObj);
                    if (visualizerObj.typeId === 'Device') {
                        $state.go('main.createDeviceGatewayVisualizer', {
                            type: 'Device'
                        });
                    }
                    if (visualizerObj.typeId === 'Gateway') {
                        $state.go('main.createDeviceGatewayVisualizer', {
                            type: 'Gateway'
                        });
                    }
                    if (visualizerObj.typeId !== "Device" && visualizerObj.typeId !== "Gateway") {
                        $state.go("main.createVisualizer");
                    }
                };

                var visualizerInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.visualizer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.visualizerPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteVisualizer($scope.visualizerObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.visualizerPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnGoToVisualization($scope.visualizerObj, 'edit');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var visualizerInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.visualizer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', visualizerInfoKeyDownEventHandler);
                document.addEventListener('keyup', visualizerInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', visualizerInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', visualizerInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('CreateVisualizerCtrl',
            function ($scope, $http, $timeout, $state, $uibModal, $stateParams, DB, swal, amaran, microSpinner, PermissionsService,
                      GhostService, ColorService, AppInitService, GatewayFactory, DeviceFactory, ComponentFactory, VisualizerFactory,
                      TypeFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                vm.isView = $state.current.name === "main.viewVisualizer";
                vm.visualizerId = $stateParams.id;

                localStorage.removeItem('ghostData');
                localStorage.removeItem('ghostDataZoom');

                //minicolors customSettings
                vm.customSettings = {
                    position: 'bottom right',
                    inline: true
                };

                /*Visuazer: START*/
                vm.selectedTab = 1;
                vm.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1
                    },
                    {
                        title: 'Attributes',
                        tabIndex: 2
                    },
                    {
                        title: 'Layout',
                        tabIndex: 3
                    }
                ];
                vm.newVisualizersObj = {
                    name: '',
                    description: '',
                    typeId: '',
                    icon: '',
                    metadata: null,
                    layout: {
                        type: ''
                    }
                };
                vm.isAllChecked = true;

                vm.tableOptionsObj = {
                    health: true,
                    name: true,
                    title: true,
                    value: true,
                    units: true,
                    display: true
                };

                // var resetObj = angular.copy(vm.newVisualizersObj);
                /*Visuazer: END*/

                /*Details Tab: START*/
                vm.isTypeFetched = false;
                vm.isTypeSelected = false;
                vm.isNavigation = true;
                vm.selectedIcon = '';
                vm.typesArr = [];
                vm.selectedType = '';
                vm.sideMenuArray = ['Details', 'Attributes', 'Layout'];
                vm.layoutArray = ['Overlay', 'Table', 'Grid'];
                /*Details Tab: END*/

                /*Attributes Tab: START*/
                vm.chartArr = ['Gauge', 'Stack', 'Icon', 'Toggle', 'Text'];
                vm.mappingArr = ['Range', 'Direct'];
                vm.orientationArr = ['Horizontal', 'Vertical'];
                vm.mapType = 'Range';
                vm.orientationType = 'Horizontal';
                vm.attributesArr = [];
                vm.selectedAttributesArr = [];
                vm.attributeObj = {
                    name: '',
                    title: '',
                    units: '',
                    value: '',
                    display: '',
                    health: 500,
                    healthCode: 500,
                    options: {}
                };
                var resetAttributeObj = angular.copy(vm.attributeObj);
                vm.gaugeObj = {
                    min: '',
                    max: '',
                    defaultColor: '',
                    mapType: 'range',
                    range: [{
                        from: '',
                        to: '',
                        color: ''
                    }]
                };
                vm.stackObj = {
                    min: '',
                    max: '',
                    defaultColor: '',
                    stackType: '',
                    mapType: 'range',
                    range: [{
                        from: '',
                        to: '',
                        color: ''
                    }]
                };
                vm.iconObj = {
                    defaultIcon: '',
                    mapType: 'range',
                    range: [{
                        from: '',
                        to: '',
                        icon: ''
                    }]
                };
                vm.toggleObj = {
                    default: {
                        value: '',
                        trueText: '',
                        falseText: ''
                    },
                    mapType: 'range',
                    range: [{
                        from: '',
                        to: '',
                        isTrue: ''
                    }]
                };
                vm.textObj = {
                    mapType: 'range',
                    range: [{
                        from: '',
                        to: '',
                        text: ''
                    }]
                };
                vm.directMap = false;
                vm.stackType = false;
                vm.filter = "$";
                vm.search = {$: ''};
                vm.isAllAttributesChecked = false;
                vm.isAttributeEditMode = false;
                vm.isUniqueError = false;
                vm.booleanValArr = [true, false];
                vm.isAttributeFormVisible = false;
                /*Attributes Tab: END*/

                /*Layout Tab: START*/
                vm.layoutFilter = "$";
                vm.layoutSearch = {$: ''};
                vm.base64data = null;
                vm.fileUploading = false;
                vm.gridValue = '3';
                vm.gridClass = '4';
                vm.gridColumsOptionsArr = [{'value': '1', 'class': '12'}, {'value': '2', 'class': '6'}, {
                    'value': '3',
                    'class': '4'
                }];
                vm.isVisualizerCreating = false;
                vm.isVisualizerImageUpdate = false;
                /*Layout Tab: END*/

                /*Details Tab: START*/
                vm.fnTypeSelected = function (selectedTypeObj) {
                    vm.isTypeSelected = false;
                    // vm.newVisualizersObj = angular.copy(resetObj);
                    vm.newVisualizersObj.typeId = selectedTypeObj.id;
                    vm.faIcons = [];
                    $http.get('assets/json/fa-icons.json')
                        .then(function (response) {
                            angular.forEach(response.data, function (icon) {
                                vm.faIcons.push(icon.replace("fa-", ""));
                            });
                            //vm.faIcons = response.data;
                        }, function () {
                        });
                    $timeout(function () {
                        vm.isTypeSelected = true;
                    })
                };

                vm.fnSelectIcon = function (selectedIcon) {
                    vm.newVisualizersObj.icon = 'fa-' + selectedIcon;
                };
                /*Details Tab: END*/

                /*Attributes Tab: START*/
                vm.fnGetIcons = function () {
                    vm.faIconsForAttribute = '';
                    $http.get('assets/json/fa-icons.json')
                        .then(function (response) {
                            vm.faIconsForAttribute = response.data;
                        }, function () {
                        });
                };

                vm.fnResetDisplayOptions = function () {
                    vm.gaugeObj = {
                        min: '',
                        max: '',
                        defaultColor: '',
                        mapType: 'range',
                        range: [{
                            from: '',
                            to: '',
                            color: ''
                        }]
                    };
                    vm.stackObj = {
                        min: '',
                        max: '',
                        defaultColor: '',
                        mapType: 'range',
                        range: [{
                            from: '',
                            to: '',
                            color: ''
                        }]
                    };
                    vm.iconObj = {
                        defaultIcon: '',
                        mapType: 'range',
                        range: [{
                            from: '',
                            to: '',
                            icon: ''
                        }]
                    };
                    vm.toggleObj = {
                        default: {
                            value: '',
                            trueText: '',
                            falseText: ''
                        },
                        mapType: 'range',
                        range: [{
                            from: '',
                            to: '',
                            isTrue: ''
                        }]
                    };
                    vm.textObj = {
                        mapType: 'range',
                        range: [{
                            from: '',
                            to: '',
                            text: ''
                        }]
                    };
                    vm.directMap = false;
                    vm.mapType = 'Range';
                };

                vm.fnAddAttribute = function (optionsObj) {
                    /* vm.attributeObj.health = "HELP";
                     vm.attributeObj.healthColor = "red";*/
                    var healthObj = ColorService.getHealthColor(vm.attributeObj.healthCode);
                    vm.attributeObj.health = healthObj.content;
                    vm.attributeObj.healthColor = healthObj['background-color'];
                    optionsObj.stackType = angular.copy(vm.orientationType === "Vertical" ? 'vertical' : 'horizontal');
                    vm.attributeObj.options = optionsObj;
                    vm.attributesArr.push(vm.attributeObj);
                    vm.fnResetDisplayOptions();
                    vm.attributeObj = angular.copy(resetAttributeObj);
                    vm.isAttributeFormVisible = false;
                    vm.orientationType = 'Horizontal';
                };

                vm.fnEditAttribute = function (attributeObj) {
                    vm.attributeObj = angular.copy(attributeObj);
                    if (vm.attributeObj.options.mapType === 'direct') {
                        vm.directMap = true;
                        vm.mapType = 'Direct';
                    } else {
                        vm.directMap = false;
                        vm.mapType = 'Range';
                    }
                    if (vm.attributeObj.display === "Gauge") {
                        vm.gaugeObj = vm.attributeObj.options;
                    } else if (vm.attributeObj.display === "Stack") {
                        vm.orientationType = vm.attributeObj.options.stackType === 'vertical' ? 'Vertical' : 'Horizontal';
                        vm.attributeObj.options.stackType = vm.orientationType === 'Vertical' ? 'vertical' : 'horizontal';
                        vm.stackObj = vm.attributeObj.options;
                    } else if (vm.attributeObj.display === "Icon") {
                        vm.iconObj = vm.attributeObj.options;
                    } else if (vm.attributeObj.display === "Text") {
                        vm.textObj = vm.attributeObj.options;
                    } else if (vm.attributeObj.display === "Toggle") {
                        vm.toggleObj = vm.attributeObj.options;
                    }
                    vm.isAttributeEditMode = true;
                    vm.isAttributeFormVisible = true;
                };

                vm.fnEditAttributeValues = function (optionsObj) {
                    angular.forEach(vm.attributesArr, function (attrObj) {
                        if (attrObj.name === vm.attributeObj.name) {
                            var healthObj = ColorService.getHealthColor(vm.attributeObj.healthCode);
                            vm.attributeObj.health = healthObj.content;
                            vm.attributeObj.healthColor = healthObj['background-color'];
                            vm.attributeObj.options = optionsObj;
                            Object.keys(vm.attributeObj).forEach(function (key) {
                                attrObj[key] = vm.attributeObj[key]
                            });
                            vm.fnResetDisplayOptions();
                            vm.attributeObj = angular.copy(resetAttributeObj);
                            vm.isAttributeEditMode = false;
                            vm.isAttributeFormVisible = false;
                            vm.orientationType = 'Horizontal';
                        }
                    });
                };

                vm.fnCheckUniqueName = function (attrName) {
                    if (vm.attributesArr.length) {
                        var flag = false;
                        angular.forEach(vm.attributesArr, function (attrObj) {
                            if (attrObj.name === attrName) {
                                flag = true;
                            }
                        });
                        vm.isUniqueError = flag;
                    } else {
                        vm.isUniqueError = false;
                    }
                };

                vm.fnCheckUncheckAttributesAll = function () {
                    angular.forEach(vm.attributesArr, function (obj) {
                        obj.isCheck = vm.isAllAttributesChecked;
                    });
                    if (vm.isAllAttributesChecked) {
                        vm.selectedAttributesArr = angular.copy(vm.attributesArr);
                    } else {
                        vm.selectedAttributesArr = [];
                    }
                };

                vm.fnCheckUncheckAttributesHeader = function (attributeObj) {
                    vm.isAllAttributesChecked = true;
                    angular.forEach(vm.attributesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllAttributesChecked = false;
                        }
                    });

                    /* Toggle push in selected attribute array*/
                    var isValueFind = _.find(vm.selectedAttributesArr, {'name': attributeObj.name});
                    if (!isValueFind) {
                        vm.selectedAttributesArr.push(attributeObj)
                    } else {
                        _.remove(vm.selectedAttributesArr, function (obj) {
                            return attributeObj.name === obj.name;
                        });
                    }
                };

                vm.fnRemoveAttributes = function (selectedAttributesArr) {
                    swal({
                            title: "Remove all Selected Attributes?",
                            text: "Attributes will be permanently removed.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "remove",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedAttributesArr, function (selectedAttributeObj) {
                                    angular.forEach(vm.attributesArr, function (attObj, index) {
                                        if (selectedAttributeObj.name === attObj.name) {
                                            vm.attributesArr.splice(index, 1);
                                        }
                                    })
                                });

                                $timeout(function () {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    }, 1000);
                                    vm.selectedAttributesArr = [];
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnResetAttributeForm = function () {
                    vm.fnResetDisplayOptions();
                    vm.isAttributeEditMode = false;
                    vm.directMap = false;
                    vm.attributeObj = angular.copy(resetAttributeObj);
                    vm.isAttributeFormVisible = true;
                };

                vm.fnMapToggle = function (isDirectMap, optionsObj) {
                    isDirectMap = isDirectMap === 'Direct' ? true : false;
                    vm.directMap = isDirectMap;
                    if (vm.attributeObj.display === 'Gauge' || vm.attributeObj.display === 'Stack') {
                        if (isDirectMap) {
                            optionsObj.mapType = "direct";
                            if (optionsObj.range) {
                                delete optionsObj.range;
                            }
                            optionsObj.direct = [
                                {
                                    value: '',
                                    color: ''
                                }
                            ];
                        } else {
                            optionsObj.mapType = "range";
                            if (optionsObj.direct) {
                                delete optionsObj.direct;
                            }
                            optionsObj.range = [
                                {
                                    from: '',
                                    to: '',
                                    color: ''
                                }
                            ];
                        }
                    } else if (vm.attributeObj.display === 'Icon') {
                        if (isDirectMap) {
                            optionsObj.mapType = "direct";
                            if (optionsObj.range) {
                                delete optionsObj.range;
                            }
                            optionsObj.direct = [
                                {
                                    value: '',
                                    icon: ''
                                }
                            ];
                        } else {
                            optionsObj.mapType = "range";
                            if (optionsObj.direct) {
                                delete optionsObj.direct;
                            }
                            optionsObj.range = [
                                {
                                    from: '',
                                    to: '',
                                    icon: ''
                                }
                            ];
                        }
                    } else if (vm.attributeObj.display === 'Toggle') {
                        if (isDirectMap) {
                            optionsObj.mapType = "direct";
                            if (optionsObj.range) {
                                delete optionsObj.range;
                            }
                            optionsObj.direct = [
                                {
                                    value: '',
                                    isTrue: ''
                                }
                            ];
                        } else {
                            optionsObj.mapType = "range";
                            if (optionsObj.direct) {
                                delete optionsObj.direct;
                            }
                            optionsObj.range = [
                                {
                                    from: '',
                                    to: '',
                                    isTrue: ''
                                }
                            ];
                        }
                    } else if (vm.attributeObj.display === 'Text') {
                        if (isDirectMap) {
                            optionsObj.mapType = "direct";
                            if (optionsObj.range) {
                                delete optionsObj.range;
                            }
                            optionsObj.direct = [
                                {
                                    value: '',
                                    text: ''
                                }
                            ];
                        } else {
                            optionsObj.mapType = "range";
                            if (optionsObj.direct) {
                                delete optionsObj.direct;
                            }
                            optionsObj.range = [
                                {
                                    from: '',
                                    to: '',
                                    text: ''
                                }
                            ];
                        }
                    }
                };

                vm.fnAddMapCondition = function (directMap, arr) {
                    if (vm.attributeObj.display === 'Gauge' || vm.attributeObj.display === 'Stack') {
                        if (directMap) {
                            arr.push({
                                value: '',
                                color: ''
                            })
                        } else {
                            arr.push({
                                from: '',
                                to: '',
                                color: ''
                            })
                        }
                    } else if (vm.attributeObj.display === 'Icon') {
                        if (directMap) {
                            arr.push({
                                value: '',
                                icon: ''
                            })
                        } else {
                            arr.push({
                                from: '',
                                to: '',
                                icon: ''
                            })
                        }
                    } else if (vm.attributeObj.display === 'Toggle') {
                        if (directMap) {
                            arr.push({
                                value: '',
                                isTrue: ''
                            })
                        } else {
                            arr.push({
                                from: '',
                                to: '',
                                isTrue: ''
                            })
                        }
                    } else if (vm.attributeObj.display === 'Text') {
                        if (directMap) {
                            arr.push({
                                value: '',
                                text: ''
                            })
                        } else {
                            arr.push({
                                from: '',
                                to: '',
                                text: ''
                            })
                        }
                    }
                };
                /*Attributes Tab: END*/

                /*Layout Tab: START*/
                vm.fnGetFile = function (url) {
                    $http({
                        method: 'GET',
                        url: url,
                        responseType: 'blob'
                    }).success(function (blob) {
                        var reader = new FileReader();
                        reader.readAsDataURL(blob);
                        reader.onloadend = function () {
                            vm.base64data = reader.result;
                            vm.fileUploading = false;
                            vm.isVisualizerImageUpdate = false;
                            $timeout(function () {
                                if (!$scope.$$phase) { //eslint-disable-line
                                    $scope.$apply();
                                }
                            })
                        }
                    });
                };

                vm.uploadFiles = function (fileArrayBuffer, filesObj, isUpdate) {
                    vm.fileUploading = !isUpdate;
                    vm.isVisualizerImageUpdate = !!isUpdate;
                    var input = {
                        file: fileArrayBuffer,
                        fileName: filesObj.name
                    };
                    VisualizerFactory.uploadFile(input, filesObj.type)
                        .then(function (resData) {
                            if (resData.message) {
                                amaran.error(resData.message);
                            } else {
                                var url = resData.basepath + resData.path;
                                vm.newVisualizersObj.layout.background = url;
                                vm.fnGetFile(url);
                            }
                            vm.fileUploading = false;
                            vm.isVisualizerImageUpdate = false;
                        }, function (error) {
                            vm.fileUploading = false;
                            vm.isVisualizerImageUpdate = false;
                            amaran.error(error.errorMessage);
                        });
                    $scope.$apply();
                };


                vm.fnSelectedGridValue = function (value) {
                    vm.gridClass = value.class;
                    vm.fnInitGridLayout();
                };

                vm.fnInitTableLayout = function () {
                    if (vm.attributesArr.length) {
                        vm.tableAttributeArr = [];
                        angular.forEach(vm.attributesArr, function (attrObj) {
                            var tempObj = angular.copy(attrObj);
                            if (tempObj.display === "Gauge") {
                                if (tempObj.value !== null && !isNaN(tempObj.value) && tempObj.value !== true) {
                                    if (tempObj.value >= tempObj.options.min && tempObj.value <= tempObj.options.max) {
                                        tempObj.knobOptions = {
                                            "startAngle": -90,
                                            "size": 75,
                                            "endAngle": 90,
                                            "readOnly": true,
                                            "unit": tempObj.units ? tempObj.units : '',
                                            "trackColor": '#D3D3D3',
                                            "barColor": GhostService.fnGetColor(tempObj.options, tempObj.value),
                                            "trackWidth": 15,
                                            "barWidth": 15,
                                            "subText": {
                                                "enabled": true,
                                                "text": ""
                                            },
                                            "min": tempObj.options.min,
                                            "max": tempObj.options.max
                                        };
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                } else {
                                    if (tempObj.value === null) {
                                        tempObj.isValueMissing = true;
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                }
                            } else if (attrObj.display === "Stack") {
                                if (tempObj.value !== null && !isNaN(tempObj.value) && tempObj.value !== true) {
                                    if (tempObj.value >= tempObj.options.min && tempObj.value <= tempObj.options.max) {
                                        tempObj.stackColor = GhostService.fnGetColor(tempObj.options, tempObj.value);
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                } else {
                                    if (tempObj.value === null) {
                                        tempObj.isValueMissing = true;
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                }
                            } else if (attrObj.display === "Toggle") {
                                if (tempObj.value !== null) {
                                    var toggleObj = GhostService.fnGetToggleValue(tempObj.options, tempObj.value);
                                    tempObj.displayText = toggleObj.displayText;
                                    tempObj.switchValue = toggleObj.switchValue;
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            } else if (attrObj.display === "Icon") {
                                if (tempObj.value !== null) {
                                    tempObj.displayIcon = GhostService.fnGetIconValue(tempObj.options, tempObj.value);
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            } else if (attrObj.display === "Text") {
                                if (tempObj.value !== null) {
                                    tempObj.displayText = GhostService.fnGetTextValue(tempObj.options, tempObj.value);
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            }
                            vm.tableAttributeArr.push(tempObj);
                        });
                    } else {
                        vm.tableAttributeArr = [];
                    }
                };

                vm.fnInitGridLayout = function () {
                    if (vm.attributesArr.length) {
                        vm.gridAttributeArr = [];
                        angular.forEach(vm.attributesArr, function (attrObj) {
                            var tempObj = angular.copy(attrObj);
                            if (tempObj.display === "Gauge") {
                                if (tempObj.value !== null && !isNaN(tempObj.value) && tempObj.value !== true) {
                                    if (tempObj.value >= tempObj.options.min && tempObj.value <= tempObj.options.max) {
                                        tempObj.knobOptions = {
                                            "startAngle": -90,
                                            "size": vm.gridClass === '4' ? 100 : 200,
                                            "endAngle": 90,
                                            "readOnly": true,
                                            "unit": tempObj.units ? tempObj.units : '',
                                            "trackColor": '#D3D3D3',
                                            "barColor": GhostService.fnGetColor(tempObj.options, tempObj.value),
                                            "trackWidth": 15,
                                            "barWidth": 15,
                                            "subText": {
                                                "enabled": true,
                                                "text": ""
                                            },
                                            "min": tempObj.options.min,
                                            "max": tempObj.options.max
                                        };
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                } else {
                                    if (tempObj.value === null) {
                                        tempObj.isValueMissing = true;
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                }
                            } else if (attrObj.display === "Stack") {
                                if (tempObj.value !== null && !isNaN(tempObj.value) && tempObj.value !== true) {
                                    if (tempObj.value >= tempObj.options.min && tempObj.value <= tempObj.options.max) {
                                        tempObj.stackColor = GhostService.fnGetColor(tempObj.options, tempObj.value);
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                } else {
                                    if (tempObj.value === null) {
                                        tempObj.isValueMissing = true;
                                    } else {
                                        tempObj.isErroPresent = true;
                                    }
                                }
                            } else if (attrObj.display === "Toggle") {
                                if (tempObj.value !== null) {
                                    var toggleObj = GhostService.fnGetToggleValue(tempObj.options, tempObj.value);
                                    tempObj.displayText = toggleObj.displayText;
                                    tempObj.switchValue = toggleObj.switchValue;
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            } else if (attrObj.display === "Icon") {
                                if (tempObj.value !== null) {
                                    tempObj.displayIcon = GhostService.fnGetIconValue(tempObj.options, tempObj.value);
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            } else if (attrObj.display === "Text") {
                                if (tempObj.value !== null) {
                                    tempObj.displayText = GhostService.fnGetTextValue(tempObj.options, tempObj.value);
                                } else {
                                    tempObj.isValueMissing = true;
                                }
                            }
                            vm.gridAttributeArr.push(tempObj);
                        });
                    } else {
                        vm.gridAttributeArr = [];
                    }
                };

                vm.fnCreateVisualizer = function (layout) {
                    vm.isVisualizerCreating = true;
                    switch (layout) {
                        case 'table':
                            vm.newVisualizersObj.layout.tableOptions = vm.tableOptionsObj;
                            vm.newVisualizersObj.metadata = vm.attributesArr;
                            break;
                        case 'grid':
                            vm.newVisualizersObj.metadata = vm.attributesArr;
                            vm.newVisualizersObj.layout.gridClass = vm.gridClass;
                            vm.newVisualizersObj.layout.gridValue = vm.gridValue;
                            break;
                        case 'overlay':
                            vm.newVisualizersObj.layout.overlayAtributesArr = vm.attributesArr;
                            vm.newVisualizersObj.metadata = angular.fromJson(localStorage.getItem('ghostData'));
                            break;
                    }
                    var inputObj = {};

                    if (vm.visualizerId) {
                        vm.fnEditVisualizer(vm.newVisualizersObj);
                    } else {
                        inputObj = {
                            body: vm.newVisualizersObj
                        };
                        VisualizerFactory.createVisualizer(inputObj)
                            .then(function () {
                                vm.isVisualizerCreating = false;
                                vm.isNavigation = false;
                                $state.go("main.visualizer");
                            }, function () {
                                vm.isVisualizerCreating = false;
                                vm.isNavigation = false;
                                $state.go("main.visualizer");
                            });
                    }
                };

                vm.fnEditVisualizer = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": {
                            name: visualizerObj.name,
                            description: visualizerObj.description ? visualizerObj.description : '',
                            icon: visualizerObj.icon,
                            typeId: visualizerObj.typeId
                        }
                    };
                    VisualizerFactory.modifyVisualizer(inputObj)
                        .then(function () {
                            vm.fnEditVisualizerMetadata(visualizerObj);
                        }, function () {
                            vm.fnEditVisualizerMetadata(visualizerObj);
                        })
                };

                vm.fnEditVisualizerMetadata = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": visualizerObj.metadata
                    };

                    VisualizerFactory.modifyVisualizerMetadata(inputObj)
                        .then(function () {
                            vm.fnEditVisualizerLayout(visualizerObj);
                        }, function () {
                            vm.fnEditVisualizerLayout(visualizerObj);
                        })
                };

                vm.fnEditVisualizerLayout = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": visualizerObj.layout
                    };
                    VisualizerFactory.modifyVisualizerLayout(inputObj)
                        .then(function () {
                            vm.isVisualizerCreating = false;
                            vm.isNavigation = false;
                            $state.go("main.visualizer");
                        }, function () {
                            vm.isNavigation = false;
                            vm.isVisualizerCreating = false;
                            $state.go("main.visualizer");
                        })
                };
                /*Layout Tab: END*/

                vm.fnCreateMetaData = function () {
                    vm.attributesArr = [
                        {
                            "name": "prop1",
                            "units": "%",
                            "display": "Gauge",
                            "health": "HELP",
                            "healthColor": "red",
                            "options": {
                                "min": 1,
                                "max": 100,
                                "mapType": "range",
                                "range": [
                                    {
                                        "from": 12,
                                        "to": 122,
                                        "color": "#2e1608"
                                    }
                                ],
                                "defaultColor": "#3e6323"
                            },
                            "value": 25
                        },
                        {
                            "name": "prop2",
                            "units": "%",
                            "display": "Stack",
                            "health": "HELP",
                            "healthColor": "red",
                            "options": {
                                "min": 1,
                                "max": 100,
                                "mapType": "range",
                                "range": [
                                    {
                                        "from": 1,
                                        "to": 100,
                                        "color": "#2f1e70"
                                    }
                                ],
                                "defaultColor": "#2c5929"
                            },
                            "value": 50
                        },
                        {
                            "name": "prop3",
                            "units": "%",
                            "display": "Icon",
                            "health": "HELP",
                            "healthColor": "red",
                            "options": {
                                "mapType": "range",
                                "range": [
                                    {
                                        "from": 1,
                                        "to": 10,
                                        "icon": "fa-500px"
                                    },
                                    {
                                        "from": 20,
                                        "to": 30,
                                        "icon": "fa-align-center"
                                    }
                                ]
                            },
                            "value": "fa-adjust"
                        },
                        {
                            "name": "prop4",
                            "units": "%",
                            "display": "Toggle",
                            "health": "HELP",
                            "healthColor": "red",
                            "options": {
                                "default": {
                                    "value": true,
                                    "trueText": "happy",
                                    "falseText": "sad"
                                },
                                "mapType": "range",
                                "range": [
                                    {
                                        "from": 1,
                                        "to": 10,
                                        "isTrue": true
                                    }
                                ]
                            },
                            "value": true
                        },
                        {
                            "name": "prop5",
                            "units": "%",
                            "display": "Text",
                            "health": "HELP",
                            "healthColor": "red",
                            "options": {
                                "mapType": "direct",
                                "direct": [
                                    {
                                        "value": 45,
                                        "text": "text"
                                    }
                                ]
                            },
                            "value": "hello"
                        }
                    ];
                };

                vm.fnGetTypes = function () {
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        vm.typesArr = AppInitService.getInitData('typesArr');
                        vm.isTypeFetched = true;
                        if (vm.visualizerId || vm.newVisualizersObj.typeId) {
                            var typeObj = _.find(vm.typesArr, {'id': vm.newVisualizersObj.typeId});
                            vm.selectedType = typeObj;
                            vm.fnTypeSelected(typeObj);
                        }
                    } else {
                        TypeFactory.getTypes()
                            .then(function (response) {
                                vm.typesArr = response;
                                vm.isTypeFetched = true;
                                if (vm.visualizerId || vm.newVisualizersObj.typeId) {
                                    var typeObj = _.find(vm.typesArr, {'id': vm.newVisualizersObj.typeId});
                                    vm.selectedType = typeObj;
                                    vm.fnTypeSelected(typeObj);
                                }
                            }, function () {
                                vm.isTypeFetched = true;
                            })
                    }
                };

                vm.fnGetHealthObj = function (data, isOverlay) {
                    return data
                        .map(function (obj) {
                            var tempObj = isOverlay ? obj.object : obj;
                            if (angular.isDefined(tempObj.healthCode)) {
                                var healthObj = ColorService.getHealthColor(tempObj.healthCode);
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.health = healthObj.content;
                            }
                            if (isOverlay) {
                                obj.object = tempObj;
                            } else {
                                obj = tempObj;
                            }
                            return tempObj;
                        });
                };

                vm.fnGetVisualizer = function (id) {
                    VisualizerFactory.getVisualizer({visualizerId: id})
                        .then(function (data) {
                            vm.newVisualizersObj = data;
                            vm.selectedIcon = data.icon.replace("fa-", "");
                            vm.fnGetTypes();
                            if (data.layout.type === 'Overlay') {
                                var temp = vm.fnGetHealthObj(data.metadata.nodes.source, true);
                                vm.attributesArr = data.layout.overlayAtributesArr ? data.layout.overlayAtributesArr : temp;
                                localStorage.setItem('ghostData', angular.toJson(data.metadata));
                                vm.fnGetFile(data.layout.background);
                            } else {
                                vm.attributesArr = vm.fnGetHealthObj(data.metadata, false);
                                if (data.layout.type === 'Grid') {
                                    vm.gridClass = data.layout.gridClass;
                                    vm.gridValue = data.layout.gridValue;
                                }
                                if (data.layout.type === 'Table') {
                                    for (var key in vm.tableOptionsObj) {
                                        if (key) {
                                            vm.tableOptionsObj[key] = data.layout.tableOptions[key] ? data.layout.tableOptions[key] : false;
                                        }
                                    }
                                }
                            }
                            vm.selectedTab = 3;
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.tableOptionsObj, function (value, key) {
                        vm.tableOptionsObj[key] = vm.isAllChecked;
                    });
                };

                vm.fnCheckUncheckHeader = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.tableOptionsObj, function (value, key) {
                        if (!vm.tableOptionsObj[key]) {
                            vm.isAllChecked = false;
                        }
                    });

                };

                vm.fnGoBackToVisualization = function () {
                    $state.go('main.visualizer');
                };

                vm.fnStackTypeToggle = function (orientationType) {
                    vm.stackObj.stackType = orientationType === 'Vertical' ? 'vertical' : 'horizontal';
                };

                vm.fnAddNewAttributes = function (visualizerType) {
                    var modalInstance;
                    if (visualizerType === 'Gateway') {
                        modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/visualization/createVisualization/modal/addAttributes/addAttributes.html',
                            size: 'lg',
                            controller: 'addAttributesCtrl as addAttributes',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (array) {
                            if (array !== 'cancel') {
                                vm.attributesArr = array;
                            }
                        }, function () {
                        });
                    } else if (visualizerType === 'Device') {
                        modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/visualization/createVisualization/modal/addAttributesFromDevice/addAttributesFromDevice.html',
                            size: 'lg',
                            controller: 'addAttributesFromDeviceCtrl as addAttributesFromDevice',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (array) {
                            if (array !== 'cancel') {
                                vm.attributesArr = array;
                            }
                        }, function () {
                        });
                    }
                };

                $scope.$on('onBeforeUnload', function (e, confirmation) {
                    if (vm.isView !== true) {
                        confirmation.message = "All data willl be lost.";
                        e.preventDefault();
                    }
                });
                $scope.$on('onUnload', function () {
                    //console.log('leaving page'); // Use 'Preserve Log' option in Console
                });

                $scope.$on('$stateChangeStart', function (event) {
                    if (vm.isNavigation === true && vm.isView !== true) {
                        var answer = confirm("Are you sure you want to leave this page?"); //eslint-disable-line
                        if (!answer) {
                            event.preventDefault();
                        }
                    }
                });


                //Init Function
                vm.fnInitVisualizer = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:visualizer");
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if (DB.fnGet("CloneVisualizer")) {
                        vm.newVisualizersObj = angular.copy(DB.fnGet("CloneVisualizer"));
                        DB.fnRemove("CloneVisualizer");
                        vm.fnGetTypes();
                        vm.selectedIcon = vm.newVisualizersObj.icon.replace("fa-", "");
                        if (vm.newVisualizersObj.layout.type === 'Overlay') {
                            var temp = vm.fnGetHealthObj(vm.newVisualizersObj.metadata.nodes.source, true);
                            vm.attributesArr = vm.newVisualizersObj.layout.overlayAtributesArr ? vm.newVisualizersObj.layout.overlayAtributesArr : temp;
                            localStorage.setItem('ghostData', angular.toJson(vm.newVisualizersObj.metadata));
                            vm.fnGetFile(vm.newVisualizersObj.layout.background);
                        } else {
                            vm.attributesArr = vm.fnGetHealthObj(vm.newVisualizersObj.metadata, false);
                            if (vm.newVisualizersObj.layout.type === 'Grid') {
                                vm.gridClass = vm.newVisualizersObj.layout.gridClass;
                                vm.gridValue = vm.newVisualizersObj.layout.gridValue;
                            }
                            if (vm.newVisualizersObj.layout.type === 'Table') {
                                for (var key in vm.tableOptionsObj) {
                                    if (key) {
                                        vm.tableOptionsObj[key] = vm.newVisualizersObj.layout.tableOptions[key] ? vm.newVisualizersObj.layout.tableOptions[key] : false;
                                    }
                                }
                            }
                        }
                        vm.selectedTab = 3;
                    } else {
                        if (vm.visualizerId) {
                            vm.fnGetVisualizer(vm.visualizerId);
                        } else {
                            vm.fnGetTypes();
                        }
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('CreateDeviceGatewayVisualizationCtrl',
            function ($scope, $http, $timeout, $state, $window, $stateParams, DB, L, swal, amaran, microSpinner, PermissionsService, PaginationService, IconService, FedSudoUserService, ColorService, DeviceFactory, GatewayFactory, UserFactory, VisualizerFactory) {
                var vm = this;

                vm.isView = $state.current.name === "main.viewDeviceGatewayVisualizer";
                vm.visualizerId = $stateParams.id;

                var loginUser = DB.fnGet('loginUser');

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*Visuazer: START*/
                vm.selectedTab = 1;
                vm.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1
                    },
                    {
                        title: 'Query',
                        tabIndex: 2
                    },
                    {
                        title: 'Configuration',
                        tabIndex: 3
                    },
                    {
                        title: 'Layout',
                        tabIndex: 4
                    }
                ];

                vm.newDeviceGatewayVisualizersObj = {
                    name: '',
                    description: '',
                    typeId: '',
                    icon: '',
                    metadata: {},
                    layout: {
                        type: ''
                    }
                };
                vm.metaDataObj = {};
                vm.selectedIcon = '';
                vm.LayoutFilterQuery = '';
                vm.gridValue = '3';
                vm.gridClass = '4';
                vm.gridColumsOptionsArr = [{'value': '1', 'class': '12'}, {'value': '2', 'class': '6'}, {
                    'value': '3',
                    'class': '4'
                }];
                vm.selectedGridLayoutObj = {};
                vm.gridBorderColor = '';
                vm.gridBgColor = '';
                vm.gridOptionsObj = {};
                vm.isAllChecked = true;
                vm.layoutArray = ['Table', 'Grid', 'Treemap', 'Geomap'];
                vm.isLayoutDataLoaded = false;
                vm.isGeomapLoading = false;
                vm.isNavigation = true;
                /*Visuazer: END*/

                /*Details Tab: START*/
                vm.fnGetIcons = function () {
                    vm.faIcons = [];
                    $http.get('assets/json/fa-icons.json')
                        .then(function (response) {
                            angular.forEach(response.data, function (icon) {
                                vm.faIcons.push(icon.replace("fa-", ""));
                            });
                            /*vm.faIcons = response.data;*/
                        }, function () {
                        });
                };

                vm.fnSelectIcon = function (selectedIcon) {
                    vm.newDeviceGatewayVisualizersObj.icon = 'fa-' + selectedIcon;
                };
                /*Details Tab: END*/

                /* Query Tab: START */
                vm.fnGetDeviceDetails = function () {
                    vm.deviceSearchFieldArr = [
                        {
                            fieldDisplayName: "ID",
                            fieldName: "id"
                        },
                        {
                            fieldDisplayName: "Name",
                            fieldName: "name"
                        },
                        {
                            fieldDisplayName: "Description",
                            fieldName: "description"
                        },
                        {
                            fieldDisplayName: "Phase",
                            fieldName: "phase"
                        },
                        {
                            fieldDisplayName: "TypeId",
                            fieldName: "typeId"
                        },
                        {
                            fieldDisplayName: "Health",
                            fieldName: "health"
                        },
                        {
                            fieldDisplayName: "DefaultHealth",
                            fieldName: "defaultHealth"
                        }
                    ];
                    vm.tableOptionsObj = {
                        name: true,
                        description: true,
                        phase: true,
                        connection:true,
                        gateway:true,
                        health: true
                    };
                    vm.filterQuery = "";
                    vm.isDevicesLoading = false;
                    vm.devicesArr = [];
                    var perPage = FedSudoUserService.fnGetUserData('perPage');
                    vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                    vm.totalItems = 0;
                    vm.prevCollection = null;
                    vm.nextCollection = null;
                    vm.isPrevVisible = false;
                    vm.inputObj = {};
                };

                vm.fnGetGatewayDetails = function () {
                    vm.gatewaySearchFieldArr = [
                        {
                            fieldDisplayName: "ID",
                            fieldName: "id"
                        },
                        {
                            fieldDisplayName: "Name",
                            fieldName: "name"
                        },
                        {
                            fieldDisplayName: "Description",
                            fieldName: "description"
                        },
                        {
                            fieldDisplayName: "Phase",
                            fieldName: "phase"
                        },
                        {
                            fieldDisplayName: "Connection",
                            fieldName: "connection"
                        },
                        {
                            fieldDisplayName: "TypeId",
                            fieldName: "typeId"
                        },
                        {
                            fieldDisplayName: "Health",
                            fieldName: "health"
                        },
                        {
                            fieldDisplayName: "DefaultHealth",
                            fieldName: "defaultHealth"
                        }
                    ];
                    vm.tableOptionsObj = {
                        name: true,
                        description: true,
                        phase: true,
                        connection: true,
                        health: true
                    };
                    vm.filterQuery = "";
                    vm.isGatewaysLoading = false;
                    vm.gatewaysArr = [];
                    var perPage = FedSudoUserService.fnGetUserData('perPage');
                    vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                    vm.totalItems = 0;
                    vm.prevCollection = null;
                    vm.nextCollection = null;
                    vm.isPrevVisible = false;
                    vm.inputObj = {};
                };

                vm.fnFilterQueryChanged = function (filterQuery, tagsArr, isCalledFromGeoMap, isCalledForLayout) {
                    if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                        vm.isDevicesLoading = true;
                    } else if (vm.newDeviceGatewayVisualizersObj.typeId === "Gateway") {
                        vm.isGatewaysLoading = true;
                    }
                    vm.filterQuery = filterQuery;

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        vm.metaDataObj.filterQuery = tagsArr;
                        vm.metaDataObj.layoutFilterQuery = vm.filterQuery;
                        inputObj = {
                            perPage: isCalledForLayout === true ? 0 : vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        delete vm.metaDataObj.filterQuery;
                        delete vm.metaDataObj.layoutFilterQuery;
                        inputObj = {
                            perPage: isCalledForLayout === true ? 0 : vm.perPage
                        };
                    }
                    if ($stateParams.next) {
                        inputObj.next = $stateParams.next
                    } else if ($stateParams.previous) {
                        inputObj.previous = $stateParams.previous
                    }
                    if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                        vm.isDevicesLoading = true;
                        if (vm.devicePermissionObj.List) {
                            vm.fnGetDevices(inputObj, isCalledFromGeoMap);
                        } else {
                            vm.devicesArr = [];
                            vm.isDevicesLoading = false;
                        }
                    } else if (vm.newDeviceGatewayVisualizersObj.typeId === "Gateway") {
                        vm.isGatewaysLoading = true;
                        if (vm.gatewayPermissionObj.List) {
                            vm.fnGetGateways(inputObj, isCalledFromGeoMap);
                        } else {
                            vm.gatewaysArr = [];
                            vm.isGatewaysLoading = false;
                        }
                    }
                };

                vm.fnGetDevices = function (inputObj, isCalledFromGeoMap) {
                    DeviceFactory.getDevices(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.devices;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.devicesArr = angular.copy(res);
                            vm.layoutArr = angular.copy(vm.devicesArr);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            if (vm.isView) {
                                if ($state.current.name === 'main.viewDeviceGatewayVisualizer') {
                                    $state.go('main.viewDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            } else if (vm.visualizerId) {
                                if ($state.current.name === 'main.editDeviceGatewayVisualizer') {
                                    $state.go('main.editDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            } else {
                                if ($state.current.name === 'main.createDeviceGatewayVisualizer') {
                                    $state.go('main.createDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            }

                            if (isCalledFromGeoMap) {
                                vm.fnInitGeomapLayout();
                            }
                            vm.isDevicesLoading = false;
                            vm.isLayoutDataLoaded = true;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDevicesLoading = false;
                            vm.isLayoutDataLoaded = true;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetGateways = function (inputObj, isCalledFromGeoMap) {
                    GatewayFactory.getGateways(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.gateways;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.gatewaysArr = angular.copy(res);
                            vm.layoutArr = angular.copy(vm.gatewaysArr);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            if (vm.isView) {
                                if ($state.current.name === 'main.viewDeviceGatewayVisualizer') {
                                    $state.go('main.viewDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            } else if (vm.visualizerId) {
                                if ($state.current.name === 'main.editDeviceGatewayVisualizer') {
                                    $state.go('main.editDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            } else {
                                if ($state.current.name === 'main.createDeviceGatewayVisualizer') {
                                    $state.go('main.createDeviceGatewayVisualizer', {
                                        perPage: inputObj.perPage,
                                        next: inputObj.next ? inputObj.next : "",
                                        previous: inputObj.previous ? inputObj.previous : ""
                                    }, {notify: false});
                                    $stateParams.perPage = inputObj.perPage;
                                    $stateParams.next = inputObj.next;
                                    $stateParams.previous = inputObj.previous;
                                }
                            }

                            if (isCalledFromGeoMap) {
                                vm.fnInitGeomapLayout();
                            }

                            vm.isGatewaysLoading = false;
                            vm.isLayoutDataLoaded = true;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewaysLoading = false;
                            vm.isLayoutDataLoaded = true;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (perPage) {
                    vm.perPage = perPage;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: perPage
                        };
                    }
                    if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                        vm.isDevicesLoading = true;
                        vm.fnGetDevices(vm.inputObj);
                    } else if (vm.newDeviceGatewayVisualizersObj.typeId === "Gateway") {
                        vm.isGatewaysLoading = true;
                        vm.fnGetGateways(vm.inputObj);
                    }
                };

                vm.fnGetNextPrevCollection = function (collectionKey, collection, perPage) {
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: vm.perPage
                        };
                    }
                    if (collection.length) {
                        vm.inputObj[collectionKey] = collection;
                    }

                    if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                        vm.isDevicesLoading = true;
                        vm.fnGetDevices(vm.inputObj);
                    } else if (vm.newDeviceGatewayVisualizersObj.typeId === "Gateway") {
                        vm.isGatewaysLoading = true;
                        vm.fnGetGateways(vm.inputObj);
                    }
                };
                /* Query Tab: END */

                /* Configuration Tab: START */
                vm.fnSelectedGridValue = function (value) {
                    vm.gridClass = value.class;
                };
                /* Configuration Tab: END */

                /* Layout Tab: START*/
                vm.fnInitLayout = function () {
                    vm.isLayoutDataLoaded = false;
                    var isCalledFromGeoMap = vm.newDeviceGatewayVisualizersObj.layout.type === 'Geomap';
                    if (isCalledFromGeoMap) {
                        vm.isGeomapLoading = true;
                    }
                    if (vm.metaDataObj.layoutFilterQuery) {
                        vm.fnFilterQueryChanged(vm.metaDataObj.layoutFilterQuery, vm.metaDataObj.filterQuery, isCalledFromGeoMap, true)
                    } else {
                        vm.fnFilterQueryChanged('', '', isCalledFromGeoMap, true);
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.tableOptionsObj, function (value, key) {
                        vm.tableOptionsObj[key] = vm.isAllChecked;
                    });
                };

                vm.fnCheckUncheckHeader = function () {
                    vm.isAllChecked = true;
                    angular.forEach(vm.tableOptionsObj, function (value, key) {
                        if (!vm.tableOptionsObj[key]) {
                            vm.isAllChecked = false;
                        }
                    });

                };
                /* Layout Tab: END*/

                vm.fnGetHealthColor = function (health, deviceObj) {
                    var healthObj = ColorService.getHealthColor(health);
                    deviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconBorderColor = function(phase){
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetDeviceConnectionIcon = function(connection){
                    return connection === 'CONNECTED' ?'device-connected':'device-disconnected';
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnCreateVisualizer = function (layout) {
                    vm.isVisualizerCreating = true;
                    switch (layout) {
                        case 'table':
                            vm.newDeviceGatewayVisualizersObj.layout.tableOptions = vm.tableOptionsObj;
                            vm.newDeviceGatewayVisualizersObj.metadata = vm.metaDataObj;
                            break;
                        case 'grid':
                            vm.newDeviceGatewayVisualizersObj.metadata = vm.metaDataObj;
                            vm.newDeviceGatewayVisualizersObj.layout.gridOptionsObj = vm.gridOptionsObj;
                            vm.newDeviceGatewayVisualizersObj.layout.gridClass = vm.gridClass;
                            vm.newDeviceGatewayVisualizersObj.layout.gridValue = vm.gridValue;
                            break;
                        case 'geomap':
                            vm.newDeviceGatewayVisualizersObj.metadata = vm.metaDataObj;
                            break;
                        case 'treemap':
                            vm.newDeviceGatewayVisualizersObj.metadata = vm.metaDataObj;
                            break;
                    }
                    var inputObj = {};

                    if (vm.visualizerId) {
                        vm.fnEditVisualizer(vm.newDeviceGatewayVisualizersObj);
                    } else {
                        inputObj = {
                            body: vm.newDeviceGatewayVisualizersObj
                        };
                        VisualizerFactory.createVisualizer(inputObj)
                            .then(function () {
                                vm.isVisualizerCreating = false;
                                vm.isNavigation = false;
                                $state.go("main.visualizer");
                            }, function () {
                                vm.isVisualizerCreating = false;
                                vm.isNavigation = false;
                                $state.go("main.visualizer");
                            });
                    }
                };

                vm.fnEditVisualizer = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": {
                            name: visualizerObj.name,
                            description: visualizerObj.description ? visualizerObj.description : '',
                            icon: visualizerObj.icon,
                            typeId: visualizerObj.typeId
                        }
                    };
                    VisualizerFactory.modifyVisualizer(inputObj)
                        .then(function () {
                            vm.fnEditVisualizerMetadata(visualizerObj);
                        }, function () {
                            vm.fnEditVisualizerMetadata(visualizerObj);
                        })
                };

                vm.fnEditVisualizerMetadata = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": visualizerObj.metadata
                    };

                    VisualizerFactory.modifyVisualizerMetadata(inputObj)
                        .then(function () {
                            vm.fnEditVisualizerLayout(visualizerObj);
                        }, function () {
                            vm.fnEditVisualizerLayout(visualizerObj);
                        })
                };

                vm.fnEditVisualizerLayout = function (visualizerObj) {
                    var inputObj = {
                        "visualizerId": vm.visualizerId,
                        "body": visualizerObj.layout
                    };
                    VisualizerFactory.modifyVisualizerLayout(inputObj)
                        .then(function () {
                            vm.isVisualizerCreating = false;
                            vm.isNavigation = false;
                            $state.go("main.visualizer");
                        }, function () {
                            vm.isVisualizerCreating = false;
                            vm.isNavigation = false;
                            $state.go("main.visualizer");
                        })
                };

                vm.fnGoBackToVisualization = function () {
                    $state.go('main.visualizer');
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnGetVisualizer = function (id) {
                    VisualizerFactory.getVisualizer({visualizerId: id})
                        .then(function (data) {
                            vm.newDeviceGatewayVisualizersObj = data;
                            vm.selectedIcon = data.icon.replace("fa-", "");
                            if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                                vm.fnGetDeviceDetails();
                            } else {
                                vm.fnGetGatewayDetails();
                            }
                            if (data.layout.type === 'Geomap') {
                                vm.metaDataObj = data.metadata;
                            } else if (data.layout.type === 'Grid') {
                                vm.metaDataObj = data.metadata;
                                vm.gridOptionsObj = data.layout.gridOptionsObj;
                                vm.gridClass = data.layout.gridClass;
                                vm.gridValue = data.layout.gridValue;
                            } else if (data.layout.type === 'Table') {
                                vm.metaDataObj = data.metadata;
                                for (var key in vm.tableOptionsObj) {
                                    if (key) {
                                        vm.tableOptionsObj[key] = data.layout.tableOptions[key] ? data.layout.tableOptions[key] : false;
                                    }
                                }
                            } else if (data.layout.type === 'Treemap') {
                                vm.metaDataObj = data.metadata;
                            }
                            vm.selectedTab = 4;
                        })
                };

                vm.fnGetStateName = function () {
                    if (vm.isView) {
                        return "main.viewDeviceGatewayVisualizer";
                    } else if (vm.visualizerId) {
                        return "main.editDeviceGatewayVisualizer";
                    } else {
                        return "main.createDeviceGatewayVisualizer";
                    }
                };

                vm.fnInitGeomapLayout = function () {
                    //vm.layoutArr[0].data = {"lat": 21.1702, "long": 72.8311};
                    //vm.layoutArr[1].data = {"late": 21.1702, "longe": 72.8311};
                    /*var dataArray = "";
                    vm.newDeviceGatewayVisualizersObj.typeId === "Device" ? dataArray = vm.devicesArr : dataArray = vm.gatewaysArr;*/
                    var loc = {};
                    var locations = [];
                    angular.forEach(vm.layoutArr, function (dataObj) {
                        loc = {};
                        if (angular.isDefined(dataObj.data)) {
                            angular.forEach(dataObj.data, function (value, key) {
                                if (key === vm.metaDataObj.lat) {
                                    loc = {dataObj: dataObj};
                                    loc.lat = value[0];
                                } else if (key === vm.metaDataObj.long) {
                                    loc.lng = value[0];
                                }
                            });
                            if (Object.keys(loc).length && loc.lat && loc.lng) {
                                locations.push(loc);
                            }
                        }
                    });
                    vm.fnRenderMap(locations);
                };

                vm.fnRenderMap = function (locations) {
                    $timeout(function () {
                        var mapOptions = {};
                        if (locations.length > 0) {
                            if(angular.isDefined(vm.metaDataObj.defaultLat) && angular.isDefined(vm.metaDataObj.defaultLong))
                            {
                                mapOptions.center = [vm.metaDataObj.defaultLat, vm.metaDataObj.defaultLong];
                            }else {
                                mapOptions.center = [locations[0].lat, locations[0].lng];
                            }
                            mapOptions.zoom = vm.metaDataObj.defaultZoom ? vm.metaDataObj.defaultZoom : 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        } else {
                           if(angular.isDefined(vm.metaDataObj.defaultLat) && angular.isDefined(vm.metaDataObj.defaultLong))
                            {
                                mapOptions.center = [vm.metaDataObj.defaultLat, vm.metaDataObj.defaultLong];
                            }else {
                               /*---- Default Location : Denver -----*/
                                mapOptions.center = [39.721712, -104.941406];
                            }
                            mapOptions.zoom = vm.metaDataObj.defaultZoom ? vm.metaDataObj.defaultZoom : 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        }
                        var map = new L.Map('map', mapOptions);
                        setMarkers(map, locations);
                    });
                };

                function setMarkers(map, locations) {
                    if (locations.length > 0) {
                        var markerClusterGroup = L.markerClusterGroup();
                        angular.forEach(locations, function (value) {
                            if (angular.isDefined(value.lat) && angular.isDefined(value.lng)) {
                                var healthObj = ColorService.getHealthColor(value.dataObj.health);
                                var svg = '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.068 125" enable-background="new 0 0 56.068 100" xml:space="preserve">' +
                                    '<path stroke="black" stroke-width="2" fill="' + healthObj['background-color'] + '" d="M28.034,0C12.552,0,0,12.552,0,28.034S28.034,100,28.034,100s28.034-56.483,28.034-71.966S43.517,0,28.034,0z' +
                                    'M28.034,40.477c-6.871,0-12.442-5.572-12.442-12.442c0-6.872,5.571-12.442,12.442-12.442c6.872,0,12.442,5.57,12.442,12.442' +
                                    'C40.477,34.905,34.906,40.477,28.034,40.477z"/>' +
                                    ' </svg>';
                                var icon = L.icon({
                                    iconUrl: 'data:image/svg+xml;base64,' + btoa(svg),
                                    iconSize: [25, 41], // size of the icon
                                    shadowSize: [50, 64], // size of the shadow
                                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                                    shadowAnchor: [4, 62],  // the same for the shadow
                                    popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
                                })
                                var marker = L.marker([value.lat, value.lng], {icon: icon});
                                var contentString = "";
                                if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                                    contentString = '<div>' +
                                        '<h3>' + value.dataObj.name + '</h3>' +
                                        '<div class="m-t-4">' +
                                        '<button class="btn btn-xs btn-default ellipsis-label"' +
                                        'uib-tooltip="health"' +
                                        'tooltip-placement="right"' +
                                        'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                        '<span>' + healthObj.content + '</span>' +
                                        ' </button>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-l-10 m-r-5 m-t-3 fa ' + vm.fnGetDeviceConnectionIcon(value.dataObj.connection) + '"' +
                                        'uib-tooltip="' + value.dataObj.connection + '"' +
                                        'tooltip-placement="left"' +
                                        '</span>' +
                                        '</div>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-r-10 deviceInfoPageIcon phaseIconBorder"'+
                                        'uib-tooltip="'+value.dataObj.phase+'"'+
                                        'tooltip-placement="left"'+
                                        'style="border-color:'+vm.fnGetPhaseIconBorderColor(value.dataObj.phase)['border-color']+'">'+
                                        '<span class="'+vm.fnGetPhaseIcon(value.dataObj.phase)+'"></span>'+
                                        '</span>'+
                                        '</div>' +
                                        '</div>' +
                                        '<p class="m-4">Type Id: ' + value.dataObj.typeId + '</p>' +
                                        '<p class="m-4">Id: ' + value.dataObj.id + '</h4>' +
                                        '</div>';
                                } else {
                                    contentString = '<div>' +
                                        '<h3>' + value.dataObj.name + '</h3>' +
                                        '<div class="m-t-4">' +
                                        '<button class="btn btn-xs btn-default ellipsis-label"' +
                                        'uib-tooltip="health"' +
                                        'tooltip-placement="right"' +
                                        'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                        '<span>' + healthObj.content + '</span>' +
                                        ' </button>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-l-10 m-r-5 m-t-5 fa ' + vm.fnGetConnectionIcon(value.dataObj.connection) + '"' +
                                        'uib-tooltip="' + value.dataObj.connection + '"' +
                                        'tooltip-placement="left"' +
                                        'style="color:' + vm.fnGetConnectionIconColor(value.dataObj.connection).color + '"' +
                                        '</span>' +
                                        '</div>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-r-5 deviceInfoPageIcon phaseIconBorder"'+
                                        'uib-tooltip="'+value.dataObj.phase+'"'+
                                        'tooltip-placement="left"'+
                                        'style="border-color:'+vm.fnGetPhaseIconBorderColor(value.dataObj.phase)['border-color']+'">'+
                                        '<span class="'+vm.fnGetPhaseIcon(value.dataObj.phase)+'"></span>'+
                                        '</span>'+
                                        '</div>' +
                                        '</div>' +
                                        '<p class="m-4">Type Id: ' + value.dataObj.typeId + '</p>' +
                                        '<p class="m-4">Id: ' + value.dataObj.id + '</p>' +
                                        '</div>';
                                }
                                marker.bindPopup(contentString);
                                marker.on('mouseover', function () {
                                    this.openPopup(); //eslint-disable-line
                                });
                                markerClusterGroup.addLayer(marker);
                            }
                        });
                        map.addLayer(markerClusterGroup);
                    }
                    $timeout(function () {
                        map.invalidateSize()
                    }, 200);
                    vm.isGeomapLoading = !vm.isGeomapLoading;
                }

                vm.fnSetGridStyle = function (attrObj) {
                    if (vm.gridOptionsObj &&
                        vm.gridOptionsObj[attrObj.id]) {
                        return {
                            'background-color': ColorService.hexToRgbA(vm.gridOptionsObj[attrObj.id].bgColor, vm.gridOptionsObj[attrObj.id].bgOpacity),
                            'border-color': ColorService.hexToRgbA(vm.gridOptionsObj[attrObj.id].boderColor, vm.gridOptionsObj[attrObj.id].borderOpacity)
                        };
                    } else {
                        return '';
                    }
                };

                vm.fnSetGridLayoutOptions = function () {
                    if (angular.isUndefined(vm.gridOptionsObj)) {
                        vm.gridOptionsObj = {};
                    }
                    if (angular.isUndefined(vm.gridOptionsObj[vm.selectedGridLayoutObj.id])) {
                        vm.gridOptionsObj[vm.selectedGridLayoutObj.id] = {};
                    }
                    vm.gridOptionsObj[vm.selectedGridLayoutObj.id].bgColor = vm.gridBgColor;
                    vm.gridOptionsObj[vm.selectedGridLayoutObj.id].boderColor = vm.gridBorderColor;
                    vm.gridOptionsObj[vm.selectedGridLayoutObj.id].borderOpacity = vm.gridBorderOpacity;
                    vm.gridOptionsObj[vm.selectedGridLayoutObj.id].bgOpacity = vm.gridBgOpacity;
                };

                vm.fnShowGridStyleOptions = function (attrObj) {
                    vm.selectedGridLayoutObj = attrObj;
                    if (vm.gridOptionsObj &&
                        vm.gridOptionsObj[attrObj.id]) {
                        vm.gridBgColor = vm.gridOptionsObj[attrObj.id].bgColor;
                        vm.gridBorderColor = vm.gridOptionsObj[attrObj.id].boderColor;
                        vm.gridBorderOpacity = vm.gridOptionsObj[attrObj.id].borderOpacity;
                        vm.gridBgOpacity = vm.gridOptionsObj[attrObj.id].bgOpacity;
                    } else {
                        if (DB.fnGet('appliedTheme')) {
                            var responseTheme = DB.fnGet('appliedTheme');
                            vm.gridBgColor = responseTheme.bgPrimaryColor;
                            vm.gridBorderColor = responseTheme.textPrimaryColor;
                            vm.gridBorderOpacity = 1;
                            vm.gridBgOpacity = 1;
                        } else {
                            vm.gridBgColor = "#ffffff";
                            vm.gridBorderColor = "#191919";
                            vm.gridBorderOpacity = 1;
                            vm.gridBgOpacity = 1;
                        }
                    }
                    angular.element(".node-menu-container")[0].style.display = "block";
                };

                vm.fnDeselectGrid = function () {
                    $timeout(function () {
                        vm.selectedGridLayoutObj = {};
                        angular.element(".node-menu-container")[0].style.display = "none";
                    })
                };

                $scope.$on('onBeforeUnload', function (e, confirmation) {
                    if(vm.isView !== true){
                        confirmation.message = "All data willl be lost.";
                        e.preventDefault();
                    }
                });
                $scope.$on('onUnload', function () {
                    //console.log('leaving page'); // Use 'Preserve Log' option in Console
                });

                $scope.$on('$stateChangeStart', function( event ) {
                    if(vm.isNavigation === true && vm.isView !== true){
                        var answer = confirm("Are you sure you want to leave this page?"); //eslint-disable-line
                        if (!answer) {
                            event.preventDefault();
                        }
                    }
                });

                //Init Function
                vm.fnInitDeviceGatewayVisualizer = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:visualizer");
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    if(DB.fnGet("CloneVisualizer")){
                        vm.newDeviceGatewayVisualizersObj = angular.copy(DB.fnGet("CloneVisualizer"));
                        DB.fnRemove("CloneVisualizer");
                        vm.selectedIcon = vm.newDeviceGatewayVisualizersObj.icon.replace("fa-", "");
                        if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                            vm.fnGetDeviceDetails();
                        } else {
                            vm.fnGetGatewayDetails();
                        }
                        if (vm.newDeviceGatewayVisualizersObj.layout.type === 'Geomap') {
                            vm.metaDataObj = vm.newDeviceGatewayVisualizersObj.metadata;
                        } else if (vm.newDeviceGatewayVisualizersObj.layout.type === 'Grid') {
                            vm.metaDataObj = vm.newDeviceGatewayVisualizersObj.metadata;
                            vm.gridOptionsObj = vm.newDeviceGatewayVisualizersObj.layout.gridOptionsObj;
                            vm.gridClass = vm.newDeviceGatewayVisualizersObj.layout.gridClass;
                            vm.gridValue = vm.newDeviceGatewayVisualizersObj.layout.gridValue;
                        } else if (vm.newDeviceGatewayVisualizersObj.layout.type === 'Table') {
                            vm.metaDataObj = vm.newDeviceGatewayVisualizersObj.metadata;
                            for (var key in vm.tableOptionsObj) {
                                if (key) {
                                    vm.tableOptionsObj[key] = vm.newDeviceGatewayVisualizersObj.layout.tableOptions[key] ? vm.newDeviceGatewayVisualizersObj.layout.tableOptions[key] : false;
                                }
                            }
                        } else if (vm.newDeviceGatewayVisualizersObj.layout.type === 'Treemap') {
                            vm.metaDataObj = vm.newDeviceGatewayVisualizersObj.metadata;
                        }
                        vm.selectedTab = 4;
                    }else {
                        vm.newDeviceGatewayVisualizersObj.typeId = $stateParams.type;
                        if (vm.visualizerId) {
                            vm.fnGetVisualizer(vm.visualizerId);
                        } else {
                            if (vm.newDeviceGatewayVisualizersObj.typeId === "Device") {
                                vm.fnGetDeviceDetails();
                            } else {
                                vm.fnGetGatewayDetails();
                            }
                        }
                    }
                    vm.fnGetIcons();
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('softwareInfo', fnSoftwareInfo)

    /** @ngInject */
    function fnSoftwareInfo($window, $state, $stateParams, $timeout, $uibModal, microSpinner, swal, amaran, DB, postActionModelMessage, copyService, postActionModelIcon, SoftwareFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/software/softwareInfo/softwareInfo.html',
            scope: {
                softwareObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'About',
                        tabIndex: 1,
                        templateUrl: 'app/node/software/softwareInfo/softwareSteps/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.software', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetSoftware = function (softwareId) {
                    var inputObj = {
                        softwareId: softwareId
                    };
                    SoftwareFactory.describeECUSoftware(inputObj)
                        .then(function (response) {
                            response.latest = !!response.latest;
                            $scope.softwareObj = response;
                            $scope.isSoftwareDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isSoftwareDetailsLoaded = true;
                        })
                };

                $scope.fnDeleteSoftware = function (softwareObj) {
                    swal({
                            title: "Delete the selected Software?",
                            text: "You are about to permanently delete the selected Software.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    softwareId: softwareObj.id
                                };
                                SoftwareFactory.deleteECUSoftware(inputObj)
                                    .then(function () {
                                        $scope.$emit('SoftwareDeleted', softwareObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnMakeLatest = function (softwareObj) {
                    var input = {
                        softwareId: softwareObj.id
                    };
                    SoftwareFactory.makeECUSoftwareLatest(input)
                        .then(function (res) { // Success block
                            softwareObj.latest = res.latest;
                            amaran.success("Software updated successfully");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.fnActivatesSoftware = function (softwareObj) {
                    var input = {
                        softwareId: softwareObj.id
                    };
                    SoftwareFactory.activateNewECUSoftwareUploaded(input)
                        .then(function (res) { // Success block
                            softwareObj.latest = res.latest;
                            amaran.success("Software activated successfully");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.fnOpenBroadcastSoftware = function (softwareObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/software/modals/softwareBroadcast/softwareBroadcast.html',
                        size: 'lg',
                        controller: 'softwareBroadcastCtrl as softwareBroadcast',
                        windowClass: 'modal-height100',
                        resolve: {
                            softwareObj: function () {
                                return _.cloneDeepWith(softwareObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (data) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/software/modals/softwareJobTerminal/softwareJobTerminal.html',
                            size: 'lg',
                            controller: 'softwareJobTerminalCtrl as softwareJob',
                            windowClass: 'modal-height100',
                            resolve: {
                                jobsArr: function () {
                                    return _.cloneDeepWith(data);
                                }
                            }
                        });
                        modalInstance.result.then(function () {

                        }, function () {
                        });
                    }, function () {
                    });
                };

                $scope.fnInitSoftware = function () {
                    $scope.isSoftwareDetailsLoaded = false;
                    $scope.softwareId = $scope.softwareObj.id;
                    if ($scope.softwareId) {
                        $scope.fnGetSoftware($scope.softwareId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };


                var softwareInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.software') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.softwarePermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteSoftware($scope.softwareObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.softwarePermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var softwareInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.software') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', softwareInfoKeyDownEventHandler);
                document.addEventListener('keyup', softwareInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', softwareInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', softwareInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createSoftwareCtrl',
            function ($scope, $window, amaran, $timeout, $http, SoftwareFactory) {
                var vm = this;
                vm.title = "Create Project";
                vm.newSoftwareObj = {
                    architecture: 'ARM',
                    version: '',
                    description: ''
                };
                vm.fileData = "";
                vm.selectedFileName = "";
                vm.isSoftwareCreating = false;

                vm.fnCreateNewSoftware = function (newSoftwareObj) {
                    vm.isSoftwareCreating = true;
                    var inputObj = {
                        body: newSoftwareObj
                    };
                    SoftwareFactory.createNewECUSoftwareVersion(inputObj)
                        .then(function (response) {
                            vm.uploadSoftwareBinaryFile(response, vm.fileData);
                        }, function () {
                            vm.isSoftwareCreating = false;
                        })
                };

                vm.uploadSoftwareBinaryFile = function (res, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.link,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        $scope.$emit('softwareAdded');
                        $scope.software.fnReload();
                        amaran.success("Software created successfully");
                        vm.isSoftwareCreating = false;
                    });
                };

                vm.uploadFiles = function (filedata) {
                    vm.fileData = filedata;
                    vm.selectedFileName = filedata.name;
                    angular.element($window).triggerHandler('resize');
                };


                vm.fnInitCreateSoftware = function () {

                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeScriptInfo', fnNodeScriptInfo)

    /** @ngInject */
    function fnNodeScriptInfo($http, $window, $state, $timeout, $base64, NodeScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/script/scriptInfo/scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4', 'tracker_S4', 'notifications_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/node/script/scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType
                    };
                    NodeScriptFactory.describeScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            var name = '';
                            if(scriptType.includes('ecu') || scriptType.includes('vpn') || scriptType.includes('ntp')) {
                                var o = scriptType.split('_');
                                name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                            } else {
                                name = toUpper(scriptType.replace(/_/g, " "));
                            }
                            $scope.scriptObj.name = name;
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    $scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        $scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function () {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        }
                    };
                    NodeScriptFactory.updateScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType
                                };
                                NodeScriptFactory.resetScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            $scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeProjectScriptInfo', fnNodeProjectScriptInfo)

    /** @ngInject */
    function fnNodeProjectScriptInfo($http, $window, $state, $timeout, $base64, NodeScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/project_script/node_project_scriptInfo/node_project_scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";
                $scope.selectedProjectRelationships = {};

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4', 'tracker_S4', 'notifications_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/node/project_script/node_project_scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType,
                        projectId: $stateParams.selectedProject
                    };
                    NodeScriptFactory.describeProjectScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            var name = '';
                            if(scriptType.includes('ecu') || scriptType.includes('vpn') || scriptType.includes('ntp')) {
                                var o = scriptType.split('_');
                                name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                            } else {
                                name = toUpper(scriptType.replace(/_/g, " "));
                            }
                            $scope.scriptObj.name = name;
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_project_scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    $scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        $scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function (isCascade, unselectedProjectsList) {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        },
                        projectId: $stateParams.selectedProject,
                        cascade: isCascade,
                        exclude: unselectedProjectsList
                    };
                    NodeScriptFactory.updateProjectScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType,
                                    projectId: $stateParams.selectedProject
                                };
                                NodeScriptFactory.resetProjectScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            $scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenScriptModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/project_script/modal/nodeProjectScriptModal.html',
                        size: 'lg',
                        controller: 'nodeProjectScriptModalCtrl as nodeProjectScript',
                        windowClass: 'modal-height100',
                        resolve: {
                            scriptObj: function () {
                                return _.cloneDeepWith($scope.scriptObj);
                            },
                            projectObj: function () {
                                return {
                                    id: $stateParams.selectedProject,
                                    name: $scope.selectedProjectName
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        $scope.fnSaveScript(true, response);
                    }, function () {
                    });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($stateParams.name) {
                        $scope.selectedProjectName = $stateParams.name
                    }
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeProjectScriptModalCtrl',
            function ($window, $timeout, $uibModalInstance, amaran, scriptObj, projectObj, NodeProjectFactory) {
                var vm = this;
                vm.selectedScriptObj = scriptObj;
                vm.selectedProjectObj = projectObj;
                vm.selectedProjectObj.isCheck = true;
                vm.selectedProjectRelationships = {};
                vm.isProjectRelationshipsDataLoading = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnConfirm = function () {
                    var unselectedProjects = '';
                    _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                        if (!downstreamProjectObj.isCheck) {
                            if (unselectedProjects !== '') {
                                unselectedProjects += ", " + downstreamProjectObj.id;
                            } else {
                                unselectedProjects = downstreamProjectObj.id;
                            }
                        }
                    })
                    $uibModalInstance.close(unselectedProjects);
                }

                vm.fnInitNodeProjectScriptModal = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    var inputObj = {
                        projectId: vm.selectedProjectObj.id
                    };
                    NodeProjectFactory.describeProjectRelationships(inputObj)
                        .then(function (response) {
                            vm.selectedProjectRelationships = _.cloneDeepWith(response);
                            _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                                downstreamProjectObj.isCheck = true;
                            })
                            vm.isProjectRelationshipsDataLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectRelationshipsDataLoading = false;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeProjectEmailTemplateInfo', fnNodeProjectEmailTemplateInfo)

    /** @ngInject */
    function fnNodeProjectEmailTemplateInfo($http, $window, $state, $timeout, $base64, NodeEmailTemplateFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/project_emailTemplate/node_project_emailTemplate/node_project_emailTemplateInfo.html',
            scope: {
                emailTemplateObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isShowPrviewRenderedHTML = true;
                $scope.isEmailTemplateLoading = true;
                $scope.emailTemplates = {};
                $scope.activeTabIndex = 1;
                $scope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                $scope.isEmailValid = true;
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    htmlMode: true,
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        };
                        $scope.setLine = function (errors) {
                            $timeout(function () {
                                _cm.clearGutter('gutter-error');
                                if (errors && errors.length) {
                                    for (var i = 0; i < errors.length; i++) {
                                        var error = errors[i];
                                        var errorLine = error.line - 1;
                                        var marker = document.createElement("div");
                                        marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                        marker.setAttribute('data-toggle', 'tooltip');
                                        marker.setAttribute('data-placement', 'auto');
                                        marker.setAttribute('title', error.message);
                                        _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                                    }
                                }
                            }, 0)

                        };
                        _cm.on("changes", function () {
                            $scope.isValidTemplate = false;
                        });
                        $scope.getString = function () {
                            return _cm.getSelection();
                        };

                        $scope.replaceString = function (str) {
                            return _cm.replaceSelection(str);
                        };

                    }
                };
                $scope.isValidTemplate = true;
                $scope.emailTemplateType = "";
                $scope.isShowVariables = false;

                $scope.tabs = [
                    {
                        title: 'Template',
                        tabIndex: 1,
                        templateUrl: 'app/node/project_emailTemplate/node_project_emailTemplate/node_project_emailTemplateSteps/details.html'
                    }
                ];

                $scope.bold = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<b>' + string + '</b>');
                };

                $scope.italic = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<i>' + string + '</i>');
                };

                $scope.underline = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<u>' + string + '</u>');
                };

                $scope.strike = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<span style="text-decoration: line-through;">' + string + '</span>');
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetEmailTemplateData = function (emailTemplateType) {
                    $scope.isEmailTemplateDataLoading = true;
                    var inputObj = {
                        type: emailTemplateType,
                        projectId: $stateParams.selectedProject
                    };
                    NodeEmailTemplateFactory.describeProjectEmailTemplate(inputObj)
                        .then(function (response) {
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            var name = '';
                            if (emailTemplateType.includes('ecu') || emailTemplateType.includes('vpn') || emailTemplateType.includes('ntp')) {
                                var o = emailTemplateType.split('_');
                                name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                            } else {
                                name = toUpper(emailTemplateType.replace(/_/g, " "));
                            }
                            $scope.emailTemplateObj.name = name;
                            $scope.emailTemplateObj.type = emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.isEmailTemplateDataLoading = false;
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEmailTemplateDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_project_emailTemplate', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        var emailTemplateToolbar = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".email-template-toolbar")[0]) ? angular.element(".email-template-toolbar")[0].offsetHeight : 0;
                        angular.element(".email-body").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".email-template").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".tabContent1").css('height', (finalHeight - (42 + aboutText)) + 'px');
                        angular.element(".emailConfigurationInfo").css('height', (finalHeight - (42 + aboutText)) + 'px');
                    }
                };

                $scope.fnViewRenderedHTML = function (isRender) {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    if (isRender) {
                        $scope.isShowPrviewRenderedHTML = true;
                    } else {
                        $scope.isShowPrviewRenderedHTML = !$scope.isShowPrviewRenderedHTML;
                    }
                    $timeout(function () {
                        if ($scope.isShowPrviewRenderedHTML) {
                            var string = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isTemplateLoading = true;
                            $http({
                                method: 'POST',
                                url: 'https://api.mjml.io/v1/render',
                                config: {},
                                data: {
                                    "mjml": string
                                }
                            }).success(function (res) {
                                $scope.isTemplateLoading = false;
                                if (res.errors && res.errors.length) {
                                    $scope.isValidTemplate = false;
                                    $scope.setLine(_.cloneDeepWith(res.errors));
                                } else {
                                    $scope.isValidTemplate = true;
                                    //$scope.setLine([]);
                                }
                                $timeout(function () {
                                    var element = document.getElementById('htmlParse');
                                    element.innerHTML = res.html; //eslint-disable-line
                                });
                                $timeout(function () {
                                    $scope.fnSetTabHeight();
                                });
                            });
                        } else {
                            if ($scope.isTemplateEditable) {
                                $timeout(function () {
                                    $scope.readOnlyFalse();
                                    $scope.fnValidateTemplate();
                                });
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.modeChanged();
                            });
                        }
                    });
                };

                $scope.fnCheckEmail = function () {
                    var patt = new RegExp($scope.emailPattern);
                    $scope.isEmailValid = patt.test($scope.templateConfigObj.emailFrom);
                };

                $scope.fnChangeToEditable = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        $timeout(function () {
                            $scope.resetHtmlbody = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isShowPrviewRenderedHTML = false;
                            $scope.isTemplateEditable = true;
                            $timeout(function () {
                                $scope.readOnlyFalse();
                                $scope.fnValidateTemplate();
                            });
                        })
                    } else {
                        $timeout(function () {
                            $scope.fnViewRenderedHTML(true);
                            $scope.templateConfigObj.mjmlBody = _.cloneDeepWith($scope.resetHtmlbody);
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.ReadOnlyTrue();
                            });
                        });
                    }
                };

                $scope.fnValidateTemplate = function () {
                    $scope.isValidatingTemplate = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        $scope.isValidatingTemplate = false;
                        if (res.errors && res.errors.length) {
                            $scope.isValidTemplate = false;
                            $scope.setLine(_.cloneDeepWith(res.errors));
                        } else {
                            $scope.isValidTemplate = true;
                            $scope.setLine([]);
                        }
                    });

                };

                $scope.fnSaveEmailTemplate = function (isCascade, unselectedProjectsList) {
                    $scope.isSaveChanges = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        var input = {
                            type: $scope.emailTemplateObj.type,
                            body: {},
                            projectId: $stateParams.selectedProject,
                            cascade: isCascade,
                            exclude: unselectedProjectsList
                        };
                        input.body = {
                            "templateType": $scope.emailTemplateObj.templateType,
                            "context": $scope.emailTemplateObj.context,
                            "body": res.mjml,
                            "from": $scope.templateConfigObj.emailFrom,
                            "subject": $scope.templateConfigObj.emailSubject,
                            "variables": $scope.emailTemplateObj.variables
                        };
                        NodeEmailTemplateFactory.updateProjectEmailTemplate(input).then(function (response) {
                            $scope.isSaveChanges = false;
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = $scope.emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.fnViewRenderedHTML(true);
                                });
                            });
                            amaran.success("Template update successfully");
                        }, function () {
                            $scope.isSaveChanges = false;
                            $scope.templateConfigObj = {
                                emailFrom: $scope.emailTemplateObj.from,
                                mjmlBody: $scope.emailTemplateObj.body,
                                emailSubject: $scope.emailTemplateObj.subject,
                                emailVariables: $scope.emailTemplateObj.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                        });
                    });
                };

                $scope.fnResetEmailTemplate = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this email template back to its original template. All the current email template settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.emailTemplateObj.type,
                                    projectId: $stateParams.selectedProject
                                };
                                NodeEmailTemplateFactory.resetProjectEmailTemplate(inputObj)
                                    .then(function (response) {
                                        $scope.emailTemplateObj = _.cloneDeepWith(response);
                                        $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                                        $scope.emailTemplateObj.type = $scope.emailTemplateType;
                                        $scope.templateConfigObj = {
                                            emailFrom: response.from,
                                            mjmlBody: response.body,
                                            emailSubject: response.subject,
                                            emailVariables: response.variables
                                        };
                                        $scope.isValidTemplate = true;
                                        $scope.isTemplateEditable = false;
                                        $scope.isShowVariables = false;
                                        $timeout(function () {
                                            $timeout(function () {
                                                $scope.fnViewRenderedHTML(true);
                                            });
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenTemplateModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/project_emailTemplate/modal/nodeProjectTemplateModal.html',
                        size: 'lg',
                        controller: 'nodeProjectTemplateModalCtrl as nodeProjectTemplate',
                        windowClass: 'modal-height100',
                        resolve: {
                            templateObj: function () {
                                return _.cloneDeepWith($scope.emailTemplateObj);
                            },
                            projectObj: function () {
                                return {
                                    id: $stateParams.selectedProject,
                                    name: $scope.selectedProjectName
                                };
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        $scope.fnSaveEmailTemplate(true, response);
                    }, function () {
                    });
                };

                $scope.fnInitEmailTemplate = function () {
                    $scope.emailTemplateType = _.cloneDeepWith($scope.emailTemplateObj.type);
                    if ($stateParams.name) {
                        $scope.selectedProjectName = $stateParams.name
                    }
                    if ($scope.emailTemplateObj.type) {
                        $scope.fnGetEmailTemplateData($scope.emailTemplateObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeProjectTemplateModalCtrl',
            function ($window, $timeout, $uibModalInstance, amaran, templateObj, projectObj, NodeProjectFactory) {
                var vm = this;
                vm.selectedTemplateObj = templateObj;
                vm.selectedProjectObj = projectObj;
                vm.selectedProjectObj.isCheck = true;
                vm.selectedProjectRelationships = {};
                vm.isProjectRelationshipsDataLoading = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnConfirm = function () {
                    var unselectedProjects = '';
                    _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                        if (!downstreamProjectObj.isCheck) {
                            if (unselectedProjects !== '') {
                                unselectedProjects += ", " + downstreamProjectObj.id;
                            } else {
                                unselectedProjects = downstreamProjectObj.id;
                            }
                        }
                    })
                    $uibModalInstance.close(unselectedProjects);
                }

                vm.fnInitNodeProjectTemplateModal = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    var inputObj = {
                        projectId: vm.selectedProjectObj.id
                    };
                    NodeProjectFactory.describeProjectRelationships(inputObj)
                        .then(function (response) {
                            vm.selectedProjectRelationships = _.cloneDeepWith(response);
                            _.forEach(vm.selectedProjectRelationships.downstreamProjects, function (downstreamProjectObj) {
                                downstreamProjectObj.isCheck = true;
                            })
                            vm.isProjectRelationshipsDataLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectRelationshipsDataLoading = false;
                        })
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeProjectInfo', fnNodeProjectInfo)

    /** @ngInject */
    function fnNodeProjectInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, AppInitService, NodeProjectFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/project/projectInfo/projectInfo.html',
            scope: {
                projectObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/project/projectInfo/projectSteps/details.html'
                    },
                    {
                        title: 'Teams',
                        tabIndex: 2,
                        templateUrl: 'app/node/project/projectInfo/projectSteps/projectTeam/projectTeam.html'
                    },
                    {
                        title: 'S4',
                        tabIndex: 3,
                        templateUrl: 'app/node/project/projectInfo/projectSteps/projectS4/nodeProjectScripts.html'
                    },
                    {
                        title: 'Email Template',
                        tabIndex: 4,
                        templateUrl: 'app/node/project/projectInfo/projectSteps/projectEmailTemplate/nodeProjectEmail.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/node/project/projectInfo/projectSteps/projectSupplemental/nodeProjectSupplemental.html'
                    }
                ];
                /*
                {
                        title: 'S4',
                        tabIndex: 3,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectScripts/projectScripts.html'
                    },
                    {
                        title: 'Email Template',
                        tabIndex: 4,
                        templateUrl: 'app/tracker/project/projectInfo/projectSteps/projectEmail/projectEmail.html'
                    }
                */
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetProject = function (projectId) {
                    var inputObj = {
                        projectId: projectId
                    };
                    NodeProjectFactory.describeProject(inputObj)
                        .then(function (response) {
                            $scope.projectObj = response;
                            $scope.resetProjectObj = angular.copy($scope.projectObj);
                            if (angular.isUndefined($scope.projectObj.description)) {
                                $scope.projectObj.description = '';
                            }
                            $scope.isProjectDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isProjectDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_project', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateProjectDetails = function (projectObj) {
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(projectObj.description)) {
                        projectObj.description = '';
                    }
                    inputObj.body = {
                        name: projectObj.name,
                        description: projectObj.description
                    };
                    NodeProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var projectArr = AppInitService.getInitData('nodeProjectsArr');
                                var index = _.findIndex(projectArr, {id: response.id});
                                if (index !== -1) {
                                    projectArr[index].name = response.name;
                                    projectArr[index].description = response.description;
                                    AppInitService.fnUpdateNodeProjectData(projectArr);
                                }
                            }
                            $scope.$emit('ProjectDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteProject = function (projectObj) {
                    swal({
                            title: "Delete the selected Project?",
                            text: "You are about to permanently delete the selected Project.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    projectId: projectObj.id
                                };
                                NodeProjectFactory.deleteProject(inputObj)
                                    .then(function () {
                                        $scope.$emit('ProjectDeleted', projectObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        var projectArr = AppInitService.getInitData('nodeProjectsArr');
                                        _.remove(projectArr, function (n) {
                                            return n.id === projectObj.id;
                                        });
                                        AppInitService.fnUpdateNodeProjectData(projectArr);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.projectObj = angular.copy($scope.resetProjectObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitProject = function () {
                    $scope.isProjectDetailsLoaded = false;
                    $scope.projectId = $scope.projectObj.id;
                    if ($scope.projectObj.parentProjectId && $scope.projectObj.parentProjectId !== "") {
                        NodeProjectFactory.describeProject({projectId: $scope.projectObj.parentProjectId})
                            .then(function (response) {
                                $scope.selectedProject = response;
                                if ($scope.projectId) {
                                    $scope.fnGetProject($scope.projectId);
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        if ($scope.projectId) {
                            $scope.fnGetProject($scope.projectId);
                        }
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitProject();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var projectInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteProject($scope.projectObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var projectInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectInfoKeyDownEventHandler);
                document.addEventListener('keyup', projectInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', projectInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createNodeProjectCtrl',
            function ($scope, $window, $uibModal, amaran, DB, NodeProjectFactory, $timeout, AppInitService, QueryFactory) {
                var vm = this;
                vm.title = "Create Project";
                vm.isProjectCreateLoaded = false;
                vm.newProjectObj = {
                    name: '',
                    description: '',
                    parentProjectId: ''
                };
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.fnCreateNewProject = function (newProjectObj) {
                    vm.isProjectCreating = true;
                    var inputObj = {
                        body: newProjectObj
                    };
                    NodeProjectFactory.createProject(inputObj)
                        .then(function (resObj) {
                            vm.isProjectCreating = false;
                            vm.newProjectObj = {
                                name: '',
                                description: '',
                                parentProjectId: ''
                            };
                            if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var projectArr = AppInitService.getInitData('nodeProjectsArr');
                                projectArr.push(resObj);
                                AppInitService.fnUpdateNodeProjectData(projectArr);
                            }
                            $timeout(function () {
                                $scope.project.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('projectAdded', resObj.id);
                            $scope.project.totalItems = $scope.project.totalItems + 1;
                            $scope.project.projectsArr.push(resObj);
                            $scope.project.fnReload();
                            amaran.success("Project created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newProjectObj.parentProjectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newProjectObj.parentProjectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnInitCreateProject = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        vm.isProjectCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('observerInfo', fnObserverInfo)

    /** @ngInject */
    function fnObserverInfo($window, $state, $stateParams, $timeout, $uibModal, microSpinner, d3, swal, amaran, panzoom,
                            DB, ObserverFactory, BatchFactory, copyService, PermissionsService, ColorService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/observer/observerInfo/observerInfo.html',
            scope: {
                ecuObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isObserversLoading = true;
                $scope.observerObj = {};

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/node/observer/observerInfo/observerTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_observer', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.selectedNewTab = 1;

                $scope.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.fnGetObserverData = function(ecuId){
                    $scope.isObserverDataLoading = true;
                    var inputObj = {
                        ecuId: ecuId
                    };
                    ObserverFactory.describeECUObserver(inputObj)
                        .then(function (response) {
                            $scope.observerObj = _.cloneDeepWith(response);
                            $scope.observerConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isObserverDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    //$scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isObserverDataLoading = false;
                        });
                };

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.observerConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.observerConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                    })
                };

                $scope.fnSaveScript = function () {
                    $scope.isSaveChanges = true;
                    var input = {
                        ecuId: $scope.ecuId,
                        body: {
                            "script": $scope.value.getData()
                        }
                    };
                    ObserverFactory.updateECUObserver(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        amaran.success("Observer script updating in progress");
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/observer/modal/updateObserverJobTerminal/updateObserverJobTerminal.html',
                            size: 'lg',
                            controller: 'updateObserverJobTerminalCtrl as updateObserverJobTerminal',
                            windowClass: 'modal-height100',
                            resolve: {
                                jobObj: function () {
                                    return _.cloneDeepWith(response);
                                },
                                ecuObj: function () {
                                    return _.cloneDeepWith($scope.ecuObj);
                                }
                            }
                        });
                        modalInstance.result.then(function () {
                            $timeout(function () {
                                angular.element($window).triggerHandler('resize');
                            },1000);
                        }, function () {
                            $timeout(function () {
                                angular.element($window).triggerHandler('resize');
                            },1000);
                        });
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.observerConfigObj = {
                            scriptBody: $scope.observerObj.script
                        };
                        $scope.isScriptEditable = false;
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: $scope.ecuId
                                };
                                ObserverFactory.resetECUObserver(inputObj)
                                    .then(function (response) {
                                        $scope.observerObj = _.cloneDeepWith(response);
                                        $scope.observerConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Reset Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitObserver = function () {
                    $scope.ecuId = _.cloneDeepWith($scope.ecuObj.id);
                    if ($scope.ecuId) {
                        $scope.fnGetObserverData($scope.ecuId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('notificationInfo', fnNotificationInfo)

    /** @ngInject */
    function fnNotificationInfo($window, $state, $stateParams, $timeout, $uibModal, microSpinner, d3, swal, amaran, panzoom,
                                DB, NotificationFactory, copyService, PermissionsService, ColorService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/notification/notificationInfo/notificationInfo.html',
            scope: {
                notificationObj: '=',
                notificationPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };
                $scope.dayName = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/notification/notificationInfo/notificationTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.notification', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.isNotificationStateUpdateCompleted = true;

                $scope.fnGetNotification = function (notificationId) {
                    var inputObj = {
                        notificationId: notificationId
                    };
                    NotificationFactory.getNotification(inputObj)
                        .then(function (response) {
                            response.window.startHour = response.window.startHour.toString().length === 1 ? '0'+response.window.startHour:response.window.startHour;
                            response.window.startMinute = response.window.startMinute.toString().length === 1 ? '0'+response.window.startMinute:response.window.startMinute;
                            response.window.endHour = response.window.endHour.toString().length === 1 ? '0'+response.window.endHour:response.window.endHour;
                            response.window.endMinute = response.window.endMinute.toString().length === 1 ? '0'+response.window.endMinute:response.window.endMinute;
                            $scope.notificationObj = response;
                            if (angular.isUndefined($scope.notificationObj.description)) {
                                $scope.notificationObj.description = '';
                            }
                            $scope.isNotificationDetailsLoaded = true;
                            if($stateParams.openEditView && ($stateParams.openEditView === 'true' || $stateParams.openEditView === true)) {
                                $scope.fnOpenEditMode();
                            }
                            $scope.fnResizeNotification();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isNotificationDetailsLoaded = true;
                        })
                };

                $scope.fnUpdateNotificationDetails = function (notificationObj) {
                    var inputObj = {
                        body: {},
                        notificationId: notificationObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(notificationObj.description)) {
                        notificationObj.description = '';
                    }
                    inputObj.body = {
                        name: notificationObj.name,
                        description: notificationObj.description,
                        state: notificationObj.state,
                        logging: notificationObj.logging,
                        window: notificationObj.window,
                        function: notificationObj.function,
                        target: notificationObj.target,
                        dispatch: notificationObj.dispatch
                    };
                    NotificationFactory.modifyNotification(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            response.window.startHour = response.window.startHour.toString().length === 1 ? '0'+response.window.startHour:response.window.startHour;
                            response.window.startMinute = response.window.startMinute.toString().length === 1 ? '0'+response.window.startMinute:response.window.startMinute;
                            response.window.endHour = response.window.endHour.toString().length === 1 ? '0'+response.window.endHour:response.window.endHour;
                            response.window.endMinute = response.window.endMinute.toString().length === 1 ? '0'+response.window.endMinute:response.window.endMinute;
                            $scope.$emit('NotificationDetailsChanged', response);
                            DB.fnRemove("NotificationEditMode");
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            $scope.fnResizeNotification();
                            amaran.success("Notification Updated Successfully");
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteNotification = function (notificationObj) {
                    swal({
                            title: "Delete the selected notification?",
                            text: "You are about to permanently delete the selected notification.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    notificationId: notificationObj.id
                                };
                                NotificationFactory.deleteNotification(inputObj)
                                    .then(function () {
                                        $scope.$emit('NotificationDeleted', notificationObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnOpenEditMode = function(){
                    $state.go('main.notification', {openEditView: ''}, {notify: false});
                    delete $stateParams.openEditView;
                    $scope.fnChangeFieldsToEditable($scope.notificationObj);

                };

                $scope.fnChangeFieldsToEditable = function (notificationObj) {
                    $scope.isDetailsEditable = true;
                    $scope.fnSetTabHeight();
                    DB.fnSet("NotificationEditMode", notificationObj);
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        var editDetailHeight = $scope.isDetailsEditable ? 36 : 0;
                        angular.element(".tabContent").css('height', finalHeight  + editDetailHeight + 'px');
                        if (angular.element(".inputDivForNotification")[0]) {
                            var inputDiv = angular.element(".inputDivForNotification")[0].offsetHeight;
                            var h = finalHeight - (footer + inputDiv + 2);
                            angular.element("#notificationParentDiv").css('height', h + 'px');
                        }
                    }
                };

                $scope.secondsToHms = function (d) {
                    d = Number(d);
                    var h = Math.floor(d / 3600);
                    var m = Math.floor(d % 3600 / 60);
                    var s = Math.floor(d % 3600 % 60);

                    var hDisplay = h > 0 ? h + (h === 1 ? " hour " : " hours ") : "";
                    var mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes ") : "";
                    var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
                    return hDisplay + mDisplay + sDisplay;
                };

                $scope.fnCloneNotification = function (notificationObj) {
                    DB.fnSet("ClonedNotificationObj", notificationObj);
                    $scope.$emit('NotificationClone');
                };

                $scope.fnInitNotification = function () {
                    $scope.healthPermissionObj = PermissionsService.getPermissions("node:health");
                    $scope.isNotificationDetailsLoaded = false;
                    $scope.notificationId = $scope.notificationObj.id;
                    if ($scope.notificationId) {
                        $scope.fnGetNotification($scope.notificationId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.$on("exitNotificationEditMode", function () {
                    $scope.isDetailsEditable = false;
                    DB.fnRemove("NotificationEditMode");
                    $scope.fnResizeNotification();
                    $scope.isDetailsEditable = false;
                });

                $scope.$on("updateNotification", function (event, data) {
                    $scope.fnUpdateNotificationDetails(data);
                });

                $scope.fnGetHealthColor = function (healthCode) {
                    return ColorService.getHealthColorForLoop(healthCode);
                };

                $scope.fnGetHealthName = function (healthCode) {
                    var healthStyle = ColorService.getHealthColorForLoop(healthCode);
                    return healthStyle.content ? healthStyle.content : healthCode;
                };

                $scope.fnResizeNotification = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                        $timeout(function () {
                            var translate = {scale: 1, translate: [0, 0]};
                            $timeout(function () {
                                var ele = d3.select('#notificationDesign');
                                var n = ele.node();
                                n.height = n.scrollHeight;
                                n.width = n.scrollWidth + 20;
                                n.x = 0;
                                n.y = 0;
                                var height = n.parentNode.clientHeight,
                                    width = n.parentNode.clientWidth;
                                translate.scale = Math.min(height / n.height, width / n.width);
                                translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                                var instance = panzoom(document.getElementById('notificationDesign'), {
                                    zoomSpeed: 0.065, maxZoom: 1.5,
                                    minZoom: translate.scale / 3
                                });
                                instance.zoomTo(0, 0, translate.scale);
                                instance.moveTo(translate.translate[0], translate.translate[1]);
                            });
                        });
                    });
                };

                $scope.fnChangeNotificationState = function (notificationObj) {
                    var inputObj = {
                        body: {},
                        notificationId: notificationObj.id
                    };
                    $scope.isNotificationStateUpdateCompleted = false;

                    inputObj.body = {
                        state: notificationObj.state === 'ACTIVE'?'INACTIVE':'ACTIVE'
                    };
                    NotificationFactory.modifyNotification(inputObj)
                        .then(function (response) {
                            response.window.startHour = response.window.startHour.toString().length === 1 ? '0'+response.window.startHour:response.window.startHour;
                            response.window.startMinute = response.window.startMinute.toString().length === 1 ? '0'+response.window.startMinute:response.window.startMinute;
                            response.window.endHour = response.window.endHour.toString().length === 1 ? '0'+response.window.endHour:response.window.endHour;
                            response.window.endMinute = response.window.endMinute.toString().length === 1 ? '0'+response.window.endMinute:response.window.endMinute;
                            $scope.$emit('NotificationDetailsChanged', response);
                            $scope.isNotificationStateUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            $scope.fnResizeNotification();
                            amaran.success("Notification Updated Successfully");
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isNotificationStateUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                var notificationInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.notification') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.notificationPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteNotification($scope.notificationObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.notificationPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable($scope.notificationObj);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var notificationInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.notification') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', notificationInfoKeyDownEventHandler);
                document.addEventListener('keyup', notificationInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', notificationInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', notificationInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('notificationModalCtrl',
            function ($scope, $timeout, $uibModalInstance, $state, $stateParams, amaran, PermissionsService, ColorService, TimezoneOptionArrService, HealthFactory, conditionType, typeObj) {
                var vm = this;
                vm.conditionType = conditionType;
                vm.selectedTypeObj = typeObj;
                vm.targetScopeArr = ["ATTRIBUTE", "DEVICE", "COMPONENT", "GATEWAY"];
                vm.dispatchSettingsArr = [{
                    key: "emails",
                    value: [],
                    type: "array",
                    inputType: 'text',
                    inputTypeNeeded: 'email',
                    arrValue: '',
                    isInputError: false
                }];
                //vm.functionTypeArr = ["NONE", "REVERSE LOOKUP"];
                vm.functionTypeArr = [{option:'NONE',displayName:'NONE'},{option:'REVERSE_LOOKUP',displayName:"REVERSE LOOKUP"}];
                vm.functionSettingsArr = [{key: "seconds", value: 0, type: "number", inputType: "number"},
                    {
                        key: "acceptableHealths",
                        value: [],
                        type: "array",
                        inputType: "number",
                        inputTypeNeeded: 'number',
                        arrValue: '',
                        isInputError: false
                    }];
                vm.timezoneOptionArr = TimezoneOptionArrService.getTimezoneOptionArr();
                vm.includeDaysOfYear = '';
                vm.excludeDaysOfYear = '';
                vm.daysOfTheWeek = '';
                vm.startTime = "08:00";
                vm.endTime = "17:00";
                vm.todayYear = new Date().getFullYear();
                vm.months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                vm.days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                vm.dayName = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                vm.isHealthDetailsLoaded = false;
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                vm.isShowAdvancedOption = false;

                vm.fnAddValue = function (id) {
                    if (id === 'startTime') {
                        document.getElementById(id).click();
                    }
                    if (id === 'endTime') {
                        document.getElementById(id).click();
                    }
                    if (id === 'includeDaysOfYear') {
                        document.getElementById(id).focus();
                    }
                    if (id === 'excludeDaysOfYear') {
                        document.getElementById(id).focus();
                    }
                };

                vm.fnCreateArrayTag = function (arrValue, id, kvpPair) {
                    if (arrValue) {
                        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if (kvpPair.inputTypeNeeded && kvpPair.inputTypeNeeded === 'email' && !re.test(arrValue)) {
                            kvpPair.isInputError = true;
                        } else if (kvpPair.inputTypeNeeded && kvpPair.inputTypeNeeded === 'number' && !(arrValue >= 100) && (arrValue <= 599)) {
                            kvpPair.isInputError = true;
                        } else {
                            var flag = false;
                            angular.forEach(kvpPair.value, function (obj) {
                                if (obj === arrValue) {
                                    flag = true;
                                }
                            });

                            if (!flag) {
                                kvpPair.value.push(angular.copy(arrValue));
                                kvpPair.arrValue = "";
                                angular.element('#' + id).blur();
                                if (kvpPair.inputTypeNeeded && kvpPair.inputTypeNeeded === 'number') {
                                    kvpPair.isInputError = false;
                                }
                            } else {
                                amaran.error('Value already present. Please enter a different Value.');
                            }
                        }
                    }
                };

                vm.fnRemoveDispatchEmailTag = function (kvpPair, index) {
                    kvpPair.value.splice(index, 1);
                };

                vm.fnRemoveSelectedArrayTag = function (id, index) {
                    if (id === 'includeDaysOfYear') {
                        vm.selectedTypeObj.includeDaysOfYear.splice(index, 1);
                    }
                    if (id === 'excludeDaysOfYear') {
                        vm.selectedTypeObj.excludeDaysOfYear.splice(index, 1);
                    }
                    if (id === 'daysOfTheWeek') {
                        vm.selectedTypeObj.daysOfTheWeek.splice(index, 1);
                    }
                };

                vm.fnCheckValidation = function () {
                    var flag;
                    if (vm.conditionType === 'window') {
                        if (vm.selectedTypeObj.always === true) {
                            return false;
                        } else {
                            return (!vm.selectedTypeObj.timezone || (vm.selectedTypeObj.timezone && !vm.selectedTypeObj.timezone.length));
                        }
                    }
                    if (vm.conditionType === 'target') {
                        if (vm.selectedTypeObj.beforeHealth === -1 && vm.selectedTypeObj.afterHealth === -1) {
                            return false;
                        } else if (vm.selectedTypeObj.beforeHealth === -1 || vm.selectedTypeObj.afterHealth === -1) {
                            if (vm.selectedTypeObj.beforeHealth === -1) {
                                return vm.selectedTypeObj.beforeHealth !== -1 || !((vm.selectedTypeObj.afterHealth >= 100) && (vm.selectedTypeObj.afterHealth <= 599));
                            } else {
                                return !((vm.selectedTypeObj.beforeHealth >= 100) && (vm.selectedTypeObj.beforeHealth <= 599)) || vm.selectedTypeObj.afterHealth !== -1;
                            }
                        }
                        else {
                            return !((vm.selectedTypeObj.beforeHealth >= 100) && (vm.selectedTypeObj.beforeHealth <= 599)) || !((vm.selectedTypeObj.afterHealth >= 100) && (vm.selectedTypeObj.afterHealth <= 599));
                        }
                    }
                    if (vm.conditionType === 'function') {
                        if (vm.selectedTypeObj.type === 'REVERSE_LOOKUP') {
                            flag = true;
                            _.forEach(vm.functionSettingsArr, function (obj) {
                                if (obj.key === "acceptableHealths") {
                                    if (obj.value.length === 0) {
                                        flag = false;
                                    }
                                } else {
                                    if ((!obj.value && obj.value !== 0) || obj.value === "") {
                                        flag = false;
                                    }
                                }

                            });
                            return !flag;
                        } else {
                            return false;
                        }
                    }
                    if (vm.conditionType === 'dispatch') {
                        flag = true;
                        _.forEach(vm.dispatchSettingsArr, function (obj) {
                            if (obj.key === 'emails' && obj.value.length === 0) {
                                flag = false;
                            }
                            if (!obj.value || obj.value === "") {
                                flag = false;
                            }
                        });
                        return !flag;
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    if (vm.conditionType === 'window') {
                        vm.selectedTypeObj.daysOfTheWeek.sort();
                    }
                    if (vm.conditionType === 'function') {
                        vm.selectedTypeObj.settings = {};
                        _.forEach(vm.functionSettingsArr, function (obj) {
                            vm.selectedTypeObj.settings[obj.key] = obj.value;
                        });
                    }
                    if (vm.conditionType === 'dispatch') {
                        _.forEach(vm.dispatchSettingsArr, function (obj) {
                            vm.selectedTypeObj.settings[obj.key] = obj.value;
                        });
                    }
                    $uibModalInstance.close(vm.selectedTypeObj);
                };

                vm.dateFromDay = function (day) {
                    var date = new Date(vm.todayYear, 0);
                    var currentDate = new Date(date.setDate(day));
                    return vm.days[currentDate.getDay()] + ' ' + vm.months[currentDate.getMonth()] + ' ' + currentDate.getDate() + ' ' + currentDate.getFullYear();
                };

                vm.fnGetHealths = function () {
                    HealthFactory.getHealths()
                        .then(function (response) {
                            _.forEach(response, function (healthObj) {
                                healthObj.healthStyle = ColorService.getHealthColorForLoop(healthObj.code);
                                healthObj.healthName = healthObj.healthStyle.content;
                            });
                            vm.healthsArr = response;
                            vm.isHealthDetailsLoaded = true;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isHealthDetailsLoaded = true;
                        })
                };

                vm.fnGetHealthColor = function (health) {
                    return ColorService.getHealthColorForLoop(health);
                };

                vm.fnSetWorkingWeek = function () {
                    vm.startTime = "08:00";
                    vm.endTime = "17:00";
                    var startTime = vm.startTime.split(':');
                    vm.selectedTypeObj.startHour = startTime[0];
                    vm.selectedTypeObj.startMinute = startTime[1];
                    var endTime = vm.endTime.split(':');
                    vm.selectedTypeObj.endHour = endTime[0];
                    vm.selectedTypeObj.endMinute = endTime[1];
                    vm.selectedTypeObj.daysOfTheWeek = [];
                    var dayOfWeek = [1, 2, 3, 4, 5];
                    vm.selectedTypeObj.daysOfTheWeek = angular.copy(dayOfWeek);
                };

                vm.fnCreateDaysOfTheWeek = function (actionIndex) {
                    var flag = false;
                    angular.forEach(vm.selectedTypeObj.daysOfTheWeek, function (obj) {
                        if (obj === actionIndex + 1) {
                            flag = true;
                        }
                    });
                    if (!flag) {
                        vm.selectedTypeObj.daysOfTheWeek.push(angular.copy(actionIndex + 1));
                    }
                };

                vm.fnSetBeforeAnyHealth = function () {
                    vm.selectedTypeObj.beforeHealth = -1;
                };

                vm.fnUnSetBeforeAnyHealth = function () {
                    vm.selectedTypeObj.beforeHealth = '';
                };

                vm.fnSetAfterAnyHealth = function () {
                    vm.selectedTypeObj.afterHealth = -1;
                };

                vm.fnUnSetAfterAnyHealth = function () {
                    vm.selectedTypeObj.afterHealth = '';
                };

                vm.fnShowAdvancedOption = function () {
                    vm.isShowAdvancedOption = !vm.isShowAdvancedOption;
                    if (!vm.isShowAdvancedOption) {
                        vm.selectedTypeObj.includeDaysOfYear = [];
                        vm.selectedTypeObj.excludeDaysOfYear = [];
                    }
                };

                vm.fnInitModel = function () {
                    vm.healthPermissionObj = PermissionsService.getPermissions("node:health");
                    if (vm.conditionType === "window") {
                        vm.startTime = vm.selectedTypeObj.startHour + ":" + vm.selectedTypeObj.startMinute;
                        vm.endTime = vm.selectedTypeObj.endHour + ":" + vm.selectedTypeObj.endMinute;
                        $timeout(function () {
                            angular.element('#startTime').mdtimepicker({
                                timeFormat: 'hh:mm',
                                format: 'hh:mm'
                            }).on('timechanged', function (e) {
                                var startTime = e.value.split(':');
                                vm.selectedTypeObj.startHour = startTime[0];
                                vm.selectedTypeObj.startMinute = startTime[1];
                                vm.startTime = vm.selectedTypeObj.startHour + ":" + vm.selectedTypeObj.startMinute;
                                $scope.$apply();
                            });
                            angular.element('#endTime').mdtimepicker({
                                timeFormat: 'hh:mm',
                                format: 'hh:mm'
                            }).on('timechanged', function (e) {
                                var endTime = e.value.split(':');
                                vm.selectedTypeObj.endHour = endTime[0];
                                vm.selectedTypeObj.endMinute = endTime[1];
                                vm.endTime = vm.selectedTypeObj.endHour + ":" + vm.selectedTypeObj.endMinute;
                                $scope.$apply();
                            });
                            angular.element('#includeDaysOfYear').bootstrapMaterialDatePicker({
                                weekStart: 0,
                                time: false
                            }).on('change', function (e, date) {
                                var start = new Date(date._d.getFullYear(), 0, 0);
                                var diff = date._d - start;
                                var oneDay = 1000 * 60 * 60 * 24;
                                var day = Math.floor(diff / oneDay);
                                if (day) {
                                    var flag = false;
                                    angular.forEach(vm.selectedTypeObj.includeDaysOfYear, function (obj) {
                                        if (obj === day) {
                                            flag = true;
                                        }
                                    });
                                    if (!flag) {
                                        vm.selectedTypeObj.includeDaysOfYear.push(angular.copy(day));
                                        angular.element('#includeDaysOfYear').blur();
                                    }
                                }
                                $scope.$apply();
                            });
                            angular.element('#excludeDaysOfYear').bootstrapMaterialDatePicker({
                                weekStart: 0,
                                time: false
                            }).on('change', function (e, date) {
                                var start = new Date(date._d.getFullYear(), 0, 0);
                                var diff = date._d - start;
                                var oneDay = 1000 * 60 * 60 * 24;
                                var day = Math.floor(diff / oneDay);
                                if (day) {
                                    var flag = false;
                                    angular.forEach(vm.selectedTypeObj.excludeDaysOfYear, function (obj) {
                                        if (obj === day) {
                                            flag = true;
                                        }
                                    });
                                    if (!flag) {
                                        vm.selectedTypeObj.excludeDaysOfYear.push(angular.copy(day));
                                        angular.element('#excludeDaysOfYear').blur();
                                    }
                                }
                                $scope.$apply();
                            });
                        });
                        vm.selectedTypeObj.includeDaysOfYear = !vm.selectedTypeObj.includeDaysOfYear ? [] : vm.selectedTypeObj.includeDaysOfYear;
                        vm.selectedTypeObj.excludeDaysOfYear = !vm.selectedTypeObj.excludeDaysOfYear ? [] : vm.selectedTypeObj.excludeDaysOfYear;
                        vm.selectedTypeObj.daysOfTheWeek = !vm.selectedTypeObj.daysOfTheWeek ? [] : vm.selectedTypeObj.daysOfTheWeek;
                        if(vm.selectedTypeObj.includeDaysOfYear.length ||  vm.selectedTypeObj.excludeDaysOfYear.length){
                            vm.isShowAdvancedOption = true;
                        }
                    }
                    if (vm.conditionType === "target") {
                        if (vm.healthPermissionObj.List === true) {
                            vm.fnGetHealths();
                        } else {
                            vm.isHealthDetailsLoaded = true;
                        }
                    }
                    if (vm.conditionType === "function") {
                        if(angular.isUndefined(vm.selectedTypeObj.type)){
                            vm.selectedTypeObj.type = "NONE";
                        }
                        vm.functionSettingsArr[0].value = vm.selectedTypeObj.settings ? vm.selectedTypeObj.settings.seconds : 0;
                        vm.functionSettingsArr[1].value = vm.selectedTypeObj.settings && angular.isDefined(vm.selectedTypeObj.settings.acceptableHealths) ? vm.selectedTypeObj.settings.acceptableHealths : [];
                        if (vm.healthPermissionObj.List === true) {
                            vm.fnGetHealths();
                        } else {
                            vm.isHealthDetailsLoaded = true;
                        }
                    }
                    if (vm.conditionType === 'dispatch') {
                        _.forEach(vm.dispatchSettingsArr, function (obj) {
                            if (obj.key === 'emails') {
                                obj.value = angular.isDefined(vm.selectedTypeObj.settings.emails) ? vm.selectedTypeObj.settings.emails : [];
                            }
                        });
                    }
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createNotificationCtrl',
            function ($rootScope, $scope, $timeout, $window, $uibModal, $stateParams, amaran, DB, d3, panzoom, PermissionsService, ColorService, NotificationFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.title = "Create Notification";
                vm.statesArr = ["ACTIVE", "INACTIVE"];
                vm.dayName = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
                vm.isBasicInformationDone = false;
                vm.newNotificationObj = {
                    "name": "",
                    "description": "",
                    "state": "ACTIVE",
                    "logging": true,
                    "window": {
                        "includeDaysOfYear": [],
                        "excludeDaysOfYear": [],
                        "daysOfTheWeek": [],
                        "timezone": "UTC",
                        "startHour": '08',
                        "startMinute": '00',
                        "endHour": '17',
                        "endMinute": '00',
                        "always": true
                    },
                    "function": {
                        "type": "NONE",
                        "settings": {
                            "seconds": 0,
                            "acceptableHealths": []
                        }
                    },
                    "target": {
                        "scope": "ATTRIBUTE",
                        "beforeHealth": '',
                        "afterHealth": ''
                    },
                    "dispatch": {
                        "type": "EMAIL",
                        "settings": {
                            "emails": []
                        }
                    }
                };
                vm.resetNotificationObj = angular.copy(vm.newNotificationObj);

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                        if (angular.element("#notificationContent")[0]) {
                            angular.element("#notificationContent").css('height', finalHeight - 30 + 'px');
                        }
                        if($stateParams.selectedId){
                            angular.element("#notificationParentDiv").css('height', finalHeight - 60 + 'px');
                        }else{
                            angular.element("#notificationParentDiv").css('height', finalHeight - 30 + 'px');
                        }

                    }
                };

                vm.fnCreateNewNotification = function (newNotificationObj) {
                    vm.isNotificationCreating = true;
                    var inputObj = {
                        body: newNotificationObj
                    };
                    NotificationFactory.createNotification(inputObj)
                        .then(function (resObj) {
                            vm.isNotificationCreating = false;
                            $scope.notification.fnHideShowCreateForm(); //parent function
                            vm.newNotificationObj = angular.copy(vm.resetNotificationObj);
                            $timeout(function () { // set table height
                                $scope.notification.fnSetTableHeight();//parent function
                            }, 800);
                            if ($scope.notification.permissionObj.List) {
                                $scope.notification.totalItems = $scope.notification.totalItems + 1;
                                $scope.notification.notificationsArr.push(resObj);
                                $scope.notification.fnReload();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNotificationCreating = false;
                        });
                };

                vm.fnResizeNotificationView = function (className) {
                    var height = className ? 64 : 31;
                    className = className ? className : '.modal-body';
                    angular.element("#notificationParentDiv").css('height', (angular.element(className)[0].offsetHeight - height) + 'px');
                    var translate = {scale: 1, translate: [0, 0]};
                    $timeout(function () {
                        var ele = d3.select('#notificationDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight;
                        n.width = n.scrollWidth + 20;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('notificationDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    });
                };

                vm.fnNextStep = function (className) {
                    vm.isBasicInformationDone = true;
                    vm.fnResizeNotificationView(className);
                };

                vm.fnOpenSettingModal = function (type, typeObj) {
                    vm.resetTypeObj = angular.copy(typeObj);
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/notification/modal/notificationModal.html',
                        size: 'lg',
                        controller: 'notificationModalCtrl as notificationModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            conditionType: function () {
                                return type;
                            },
                            typeObj: function () {
                                return typeObj;
                            }
                        }
                    });
                    modalInstance.result.then(function (resObj) {
                        vm.newNotificationObj[type] = resObj;
                    }, function () {
                        vm.newNotificationObj[type] = angular.copy(vm.resetTypeObj);
                    });
                };

                vm.secondsToHms = function (d) {
                    d = Number(d);
                    var h = Math.floor(d / 3600);
                    var m = Math.floor(d % 3600 / 60);
                    var s = Math.floor(d % 3600 % 60);

                    var hDisplay = h > 0 ? h + (h === 1 ? " hour " : " hours ") : "";
                    var mDisplay = m > 0 ? m + (m === 1 ? " minute " : " minutes ") : "";
                    var sDisplay = s > 0 ? s + (s === 1 ? " second" : " seconds") : "";
                    return hDisplay + mDisplay + sDisplay;
                };

                vm.fnGetHealthColor = function (health) {
                    return ColorService.getHealthColorForLoop(health);
                };

                vm.fnCheckValidation = function () {
                    if (vm.newNotificationObj.window.always === true) {
                        if (vm.newNotificationObj.target.beforeHealth === -1 && vm.newNotificationObj.target.afterHealth === -1) {
                            return vm.newNotificationObj.target.beforeHealth !== -1 || vm.newNotificationObj.target.afterHealth !== -1 || !vm.newNotificationObj.dispatch.settings.emails.length;
                        } else if (vm.newNotificationObj.target.beforeHealth === -1 || vm.newNotificationObj.target.afterHealth === -1) {
                            if (vm.newNotificationObj.target.beforeHealth === -1) {
                                return !(vm.newNotificationObj.target.afterHealth >= 100 && vm.newNotificationObj.target.afterHealth <= 599) || !vm.newNotificationObj.dispatch.settings.emails.length;
                            } else {
                                return !(vm.newNotificationObj.target.beforeHealth >= 100 && vm.newNotificationObj.target.beforeHealth <= 599) ||
                                    !vm.newNotificationObj.dispatch.settings.emails.length;
                            }
                        } else {
                            return (!(vm.newNotificationObj.target.beforeHealth >= 100 && vm.newNotificationObj.target.beforeHealth <= 599) ||
                                (!(vm.newNotificationObj.target.afterHealth >= 100 && vm.newNotificationObj.target.afterHealth <= 599))) ||
                                !vm.newNotificationObj.dispatch.settings.emails.length;
                        }
                    } else {
                        if (vm.newNotificationObj.target.beforeHealth === -1 && vm.newNotificationObj.target.afterHealth === -1) {
                            return !(vm.newNotificationObj.window.timezone && vm.newNotificationObj.window.timezone.length) || vm.newNotificationObj.target.beforeHealth !== -1 || vm.newNotificationObj.target.afterHealth !== -1 || !vm.newNotificationObj.dispatch.settings.emails.length;
                        } else if (vm.newNotificationObj.target.beforeHealth === -1 || vm.newNotificationObj.target.afterHealth === -1) {
                            if (vm.newNotificationObj.target.beforeHealth === -1) {
                                return !(vm.newNotificationObj.window.timezone && vm.newNotificationObj.window.timezone.length) ||
                                    (!(vm.newNotificationObj.target.afterHealth >= 100 && vm.newNotificationObj.target.afterHealth <= 599)) ||
                                    !vm.newNotificationObj.dispatch.settings.emails.length;
                            } else {
                                return !(vm.newNotificationObj.window.timezone && vm.newNotificationObj.window.timezone.length) ||
                                    (!(vm.newNotificationObj.target.beforeHealth >= 100 && vm.newNotificationObj.target.beforeHealth <= 599)) ||
                                    !vm.newNotificationObj.dispatch.settings.emails.length;
                            }
                        } else {
                            return !(vm.newNotificationObj.window.timezone && vm.newNotificationObj.window.timezone.length) ||
                                (!(vm.newNotificationObj.target.beforeHealth >= 100 && vm.newNotificationObj.target.beforeHealth <= 599) ||
                                    (!(vm.newNotificationObj.target.afterHealth >= 100 && vm.newNotificationObj.target.afterHealth <= 599))) ||
                                !vm.newNotificationObj.dispatch.settings.emails.length;
                        }
                    }
                };

                /*Edit Notification*/

                vm.fnInitEditNotification = function () {
                    if (DB.fnGet("NotificationEditMode")) {
                        vm.fnInitCreateNotification();
                        vm.reviewBtnTxt = 'Save Notification'; //if changed then the value has to also change on review.html ng-if condition
                        vm.newNotificationObj = angular.copy(DB.fnGet("NotificationEditMode"));
                        DB.fnRemove("NotificationEditMode");
                        $timeout(function () {
                            vm.isBasicInformationDone = true;
                            vm.fnResizeNotificationView('.content-main');
                        })
                    }
                };

                vm.fnExitEditMode = function () {
                    $rootScope.$broadcast("exitNotificationEditMode");
                };

                vm.fnSaveNotification = function (newNotificationObj) {
                    vm.isNotificationCreating = true;
                    $rootScope.$broadcast("updateNotification", newNotificationObj);
                };

                /**/

                vm.fnInitCreateNotification = function () {
                    vm.healthPermissionObj = PermissionsService.getPermissions("node:health");
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                    if (DB.fnGet("ClonedNotificationObj")) {
                        vm.newNotificationObj = angular.copy(DB.fnGet("ClonedNotificationObj"));
                        DB.fnRemove("ClonedNotificationObj");
                        $timeout(function () {
                            vm.isBasicInformationDone = true;
                            vm.fnResizeNotificationView();
                        })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateIoT3Ctrl',
            function ($rootScope, $scope, $timeout, $window, $uibModal, $state, $stateParams, TypeFormService, NodeEcuFactory, NodeFactory, ColorService, PaginationQueryService, AppInitService, UserProfileService, jsyaml, NodeIoT3Factory, Iot3WorkbenchFactory, amaran, DB, moment, QueryFactory) {
                var vm = this;

                /* Step 1: Register Home Page
                * Step 2: List IoT3 files
                * Step 3: IoT3 file summary.
                * Step 4: IoT3 file config summary and option to open the ECU list.
                * Step 5: Node Registration summary.
                * Step 6: Node Registration process terminal.
                */

                vm.totalSteps = 6;
                vm.activeStep = 1;
                vm.newNodeObj = {
                    name: "",
                    description: "",
                    registration: {
                        iot3: {
                            iot3: ""
                        },
                        form: {
                            schema: {},
                            values: {}
                        },
                        graph: {
                            type: "AUTO_COMPLETE",
                            graph: "string"
                        }
                    }
                };
                vm.isNodeRegistering = false;
                vm.nodeRegisteringObj = {};
                vm.jobAPITimeout = '';
                vm.cloneNodeInformation = {};
                vm.isIoT3References = true;
                vm.vaultsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                    vm.fnSetDataHeight();
                    if (vm.activeStep === 3 || vm.activeStep === 6) {
                        vm.fnSetTabHeight();
                    }
                    if (vm.activeStep === 5) {
                        vm.fnSetECUTableHeight();
                    }
                    if (vm.activeStep === 3 && vm.selectedTabIndex === 2) {
                        vm.fnSetIot3NodeTableHeight();
                    }
                });

                vm.fnGotoPreviousStep = function () {
                    vm.activeStep = vm.activeStep - 1;
                    if (vm.activeStep === 2) {
                        vm.selectedIoT3FileObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnGotoNextStep = function (step) {
                    vm.activeStep = step;
                    if (vm.activeStep === 3) {
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 100);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createNode-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 4) {
                            var headerHeight = angular.element(".user-header")[0].offsetHeight;
                            angular.element("#step4").css('height', (total - headerHeight - footer) + 'px');
                        }
                    }
                };

                vm.fnSetDataHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 188 + dashboardHeader + mainFooter);
                        angular.element("#healthTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECUTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 198 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetIot3NodeTableHeight = function () {
                    if (angular.element(".tabContent")[0] && angular.element(".iot3-node-desc")[0] && angular.element(".local-search-bar")[0]) {
                        var total = angular.element(".tabContent")[0].offsetHeight;
                        var nodeDesc = angular.element(".iot3-node-desc")[0].offsetHeight;
                        var searchBar = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = 36;
                        var finalHeight = total - (searchBar + nodeDesc + header + 35);
                        angular.element("#iot3RegisterNodeTableBody").css('height', finalHeight + 'px');
                    }
                };

                $timeout(function () {
                    vm.fnSetTableHeight();
                });

                vm.fnGotoIoTEditor = function () {
                    vm.fnGotoNextStep(3);
                    vm.selectedTabIndex = 3
                };

                vm.fnGotoImportWorkbench = function () {
                    vm.isIoT3References = false;
                    vm.fnGotoNextStep(2);
                    vm.selectedTabIndex = 2
                }

                vm.uploadFiles = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var fileData = fileLoadedEvent.target.result;
                        var testYaml = vm.fnConvertYamlToJson(fileData);
                        if (testYaml === null || angular.isUndefined(testYaml)) {
                            amaran.error('Yaml format is incorrect. Please check it and try again.')
                        } else {
                            vm.selectedIoT3FileObj.iot3File = fileData;

                            $timeout(function () {
                                vm.fnInitCalled();
                            })
                        }
                    };
                    reader.readAsText(filesSelected);
                };

                vm.fnAddDefaultIoT3Filters = function (oemType) {
                    vm.isIoT3References = true;
                    if (oemType !== '') {
                        vm.defaultIoT3FilterArr = [
                            {
                                "id": 391527638,
                                "selectedField": "oem",
                                "displaySelectedField": "OEM",
                                "selectedFilter": {
                                    "operatorName": "=",
                                    "operator": "="
                                },
                                "searchText": oemType,
                                "displaySearchText": oemType
                            }
                        ];
                    } else {
                        vm.defaultIoT3FilterArr = [];
                    }

                    $timeout(function () {
                        vm.fnGotoNextStep(2);
                    });

                };

                /*Node IoT3: Start*/
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.defaultIoT3FilterArr = [];
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.iot3SearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "OEM",
                        name: "oem",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3SortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.iot3FilterQuery = "";
                vm.defaultIot3SortString = 'name asc';
                vm.iot3SqlQuery = "";
                vm.isIoT3RefreshData = true;
                vm.isIoT3Refresh = false;
                vm.iot3JSON = {};
                vm.notDisplayInfo = [
                    'name',
                    'oem',
                    'model',
                    'author',
                    'created',
                    'updated',
                    'versions',
                    'documentation'
                ];
                vm.iot3Summary = [];
                vm.isIoT3DetailLoading = false;
                vm.iot3NodeArr = [];

                vm.fnIOT3FilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3FilterQuery = filterQuery;
                    vm.iot3SqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3s(input, true);
                };

                vm.fnGetIOT3s = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            if (isFirst && res.data && res.data.length) {
                                vm.totalItems = res.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                res.data.reverse();
                            }
                            vm.iot3sArr = _.cloneDeepWith(res.data);
                            vm.isIoT3Refresh = false;
                            vm.isIOT3sLoading = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3sLoading = false;
                            vm.isIoT3RefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        })
                };

                vm.fnIoT3PageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_references';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_references';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3s(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3SqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3sArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3s(input, false);
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnSelectIoT3File = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    NodeIoT3Factory.describeIoT3Reference({iot3Id: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        if (error && Object.keys(error).length) {
                            var errorLine = error.mark.line - 1;
                            vm.goToLine(errorLine);
                        }
                        return false;
                    }
                };

                vm.fnReloadIoT3s = function () {
                    vm.isIoT3RefreshData = false;
                    vm.isIoT3Refresh = true;
                    $timeout(function () {
                        vm.isIoT3RefreshData = true;
                    }, 10)
                };

                /*Node IoT3: End*/

                /*Node IoT3 Workspaces: Start*/
                vm.iot3WorkspacesSearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3WorkspacesSortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.iot3WorkspacesFilterQuery = "";
                vm.iot3WorkspacesSqlQuery = "";
                vm.isIoT3WorkspacesRefreshData = true;
                vm.isIoT3WorkspacesRefresh = false;

                vm.fnIOT3WorkspacesFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3WorkspacesFilterQuery = filterQuery;
                    vm.iot3WorkspacesSqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3Workspaces(input, true);
                };

                vm.fnGetIOT3Workspaces = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                            });
                            if (isFirst && res.data && res.data.length) {
                                vm.totalItems = res.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                res.data.reverse();
                            }
                            vm.iot3WorkspacesArr = _.cloneDeepWith(res.data);
                            vm.isIoT3WorkspacesRefresh = false;
                            vm.isIOT3WorkspacesLoading = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3WorkspacesLoading = false;
                            vm.isIoT3WorkspacesRefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        })
                };

                vm.fnIoT3WorkspacesPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_iot3_workspaces';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3Workspaces(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3WorkspacesSqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3WorkspacesArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3Workspaces(input, false);
                    }
                };

                vm.fnSelectIoT3WorkspacesFile = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    Iot3WorkbenchFactory.describeIot3Worbench({workspaceId: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnReloadIoT3Workspaces = function () {
                    vm.isIoT3WorkspacesRefreshData = false;
                    vm.isIoT3WorkspacesRefresh = true;
                    $timeout(function () {
                        vm.isIoT3WorkspacesRefreshData = true;
                    }, 10)
                };
                /*Node IoT3 Workspaces: End*/

                /*IoT3 File Summary: Start*/
                vm.selectedIoT3FileObj = {};
                vm.selectedTabIndex = 1;
                vm.iot3Tabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    },
                    {
                        title: 'Nodes',
                        tabIndex: 2
                    },
                    {
                        title: 'IoT3',
                        tabIndex: 3
                    }
                ];
                vm.isChangesSync = true;

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            vm.isChangesSync = false;
                            $timeout(function () {
                                vm.fnChangeDone();
                            }, 100);
                        });

                        vm.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };

                        vm.goToLine = function (lineNumber) {
                            _cm.setCursor(lineNumber);
                        };
                    }
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = 55;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 100)
                };

                vm.fnInitSecurityRegistration = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 500)
                }

                vm.fnChangeDone = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                    var isValidJson = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File);
                    if (isValidJson !== false) {
                        vm.iot3JSON = isValidJson;
                        vm.iot3Summary = [];
                        vm.iot3NodeArr = [];
                        if ((angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined') && Object.keys(vm.iot3JSON).length) {
                            if (vm.iot3JSON.info.created) {
                                vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                            } else {
                                vm.iot3JSON.info.created = '';
                            }
                            if (vm.iot3JSON.info.updated) {
                                vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                            } else {
                                vm.iot3JSON.info.updated = '';
                            }
                            if (vm.iot3JSON && vm.iot3JSON.iot3) {
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.info) {
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                    var tempObj = typeValue;
                                    tempObj.type = typeKey;
                                    vm.iot3NodeArr.push(tempObj)
                                });
                            }
                        }
                        vm.isChangesSync = true;
                        $timeout(function () {
                            vm.setLine();
                        });
                    } else {
                        vm.isChangesSync = false;
                        //amaran.error('YAML format is not valid.');
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                };

                vm.fnTabSelected = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        if (vm.selectedTabIndex === 3) {
                            vm.isChangesSync = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File) !== false;
                        }
                        if (vm.selectedTabIndex === 2) {
                            vm.fnSetIot3NodeTableHeight();
                        }
                    }, 100)
                };

                vm.fnViewAttributes = function (iot3NodeObj) {
                    var attributes = _.filter(vm.iot3JSON.template.attributes, function (value, key) {
                        value.reference = key;
                        return iot3NodeObj.attributes.includes(key);
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/viewAttributes/viewAttributes.html',
                        size: 'lg',
                        controller: 'viewAttributesCtrl as viewAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedNode: function () {
                                return _.cloneDeepWith(iot3NodeObj);
                            },
                            attributesArr: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.isValidateIoT3File = function () {
                    return !!(vm.isChangesSync && vm.iot3JSON && angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined' && Object.keys(vm.iot3JSON).length);
                    //return !!vm.selectedEcuObj && Object.keys(vm.selectedEcuObj).length;
                };

                /*IoT3 File Summary: End*/

                /*IoT3 Security Registration: Start*/
                vm.isLoading = true;
                vm.model = {};
                vm.schema = {};
                vm.form = [];
                vm.isIoT3FormValid = false;
                vm.fnSecurityRegistrationInit = function () {
                    vm.isLoading = true;
                    if (vm.iot3JSON && vm.iot3JSON.registration && vm.iot3JSON.registration.form && vm.iot3JSON.registration.form.properties) {
                        var tempData = TypeFormService.fnGenerateFormData(vm.iot3JSON.registration.form);
                        var isFindVault = _.find(tempData.form, function (formObj) {
                            return formObj.key === 'vault_id';
                        })
                        if (isFindVault) {
                            isFindVault.titleMap = _.map(vm.vaultsArr, function (vaultObj) {
                                return {name: vaultObj.name, id: vaultObj.id};
                            })
                            isFindVault.type = "vaultInputDropdown";
                        }
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        var tempModelData = _.cloneDeepWith(vm.model);
                        vm.model = {};
                        if (Object.keys(tempModelData).length) {
                            _.forEach(vm.schema.properties, function (value, key) {
                                if (value.type === 'object') {
                                    _.forEach(value.properties, function (objValue, objKey) {
                                        if (tempModelData[key] && tempModelData[key][objKey]) {
                                            if (vm.model[key]) {
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            } else {
                                                vm.model[key] = {};
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            }
                                        }
                                    })
                                } else {
                                    if (tempModelData[key]) {
                                        vm.model[key] = tempModelData[key];
                                    }
                                }
                            });
                        }
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    } else {
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    }
                };

                vm.fnCheckIot3Validation = function (value) {
                    vm.isIoT3FormValid = value;
                    return value;
                };
                /*IoT3 Security Registration: End*/

                /*Job: Start*/
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.jobModeChanged();
                        vm.jobSummary = " > " + moment().format("HH:mm:ss") + "     A new Job has been created to update node IoT3 '" + vm.newNodeObj.name + "'\n";
                        vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.selectedEcuObj.name + "' ECU (" + vm.selectedEcuObj.id + ") to acknowledge the job\n";
                        if (vm.selectedEcuObj.connected !== true) {
                            vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The ECU is currently offline the job will continue when the ECU comes back online\n";
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                $timeout(function () {
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     The '" + vm.selectedEcuObj.name + "' ECU has accepted the job and it is now active\n";
                                    vm.jobSummary += " > " + moment().format("HH:mm:ss") + "     Waiting for '" + vm.selectedEcuObj.name + "' ECU to update the status of the job [this may take a while]\n";
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].startedAt) + "     " + tempAuditsObj + "\n";
                                            } else {
                                                vm.jobSummary += " >              " + tempAuditsObj + "\n";
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job failed and was aborted\n";
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job successfully completed\n";
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummary += " > " + vm.fnGetJobTime(res.data[0].completedAt) + "     The job was only partially successful. Please see above for operations that failed to compete.\n";
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                /*Job: End*/

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 172);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECULoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 185);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnRegisterNewNode = function () {
                    vm.isNodeRegistering = true;
                    var input = {
                        nodeId: vm.selectedNodeId.nodeId,
                        body: {
                            iot3: {
                                iot3: ""
                            },
                            form: {
                                schema: "",
                                values: ""
                            }
                        }
                    };
                    var tempIoT3File = _.cloneDeepWith(angular.toJson(vm.selectedIoT3FileObj.iot3File));
                    input.body.iot3.iot3 = tempIoT3File.substring(1, tempIoT3File.length - 1);
                    input.body.form.schema = _.cloneDeepWith(vm.schema);
                    input.body.form.values = _.cloneDeepWith(vm.model);
                    NodeFactory.replaceRegistration(input)
                        .then(function (res) {
                            vm.nodeRegisteringObj = _.cloneDeepWith(res);
                            amaran.success("Node IoT3 update in progress.");
                            vm.isNodeRegistering = false;
                            vm.fnGotoNextStep(6);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeRegistering = false;
                        })
                };

                vm.fnInit = function () {
                    vm.selectedNodeId = _.find($scope.node.tabs, {id: 'Update IoT3'});
                    vm.fnGetECUInfo();
                    vm.fnGetNodeInfo();
                    var vaultSQL = 'SELECT data->>\'id\', data->>\'name\', COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_vaults ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetVaults({sql: vaultSQL}, [], false);
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnGetECUInfo = function () {
                    var ecuId = vm.selectedNodeId.nodeId.substring(0, vm.selectedNodeId.nodeId.lastIndexOf("-"));
                    NodeEcuFactory.describeECU({ecuId: ecuId})
                        .then(function (ecuInfo) {
                            vm.selectedEcuObj = _.cloneDeepWith(ecuInfo);
                            if (vm.selectedEcuObj.projectId) {
                                vm.selectedEcuObj.project = _.find($scope.node.projectsArr, {id: vm.selectedEcuObj.projectId});
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                }

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnGetNodeInfo = function () {
                    NodeFactory.describeNode({nodeId: vm.selectedNodeId.nodeId})
                        .then(function (nodeRes) {
                            vm.oldModel = _.cloneDeepWith(nodeRes.registration.form.values);
                            var tempData = TypeFormService.fnGenerateFormData(nodeRes.registration.form.schema);
                            vm.oldSchema = tempData.schema;
                            vm.oldForm = tempData.form;
                            vm.newNodeObj.name = _.cloneDeepWith(nodeRes.name);
                            vm.newNodeObj.description = _.cloneDeepWith(nodeRes.description);
                            vm.model = _.cloneDeepWith(nodeRes.registration.form.values);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                }

                vm.fnOpenIoT3Documentation = function () {
                    $state.go('main.documentations', {selectedId: 'ud3729d5'})
                };

                vm.fnOpenIot3SupportModel = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/iot3Support/iot3Support.html',
                        size: 'md',
                        controller: 'iot3SupportCtrl as iot3Support'
                    });
                };

                vm.fnOpenECUListModel = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/ecuListModal/ecuList.html',
                        size: 'lg',
                        controller: 'ecuListCtrl as ecuList',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }

                vm.fnGetVaults = function (inputObj, preDefinedVaults, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var vaults = isCalledForViz ? preDefinedVaults : [];
                            _.forEach(res.data, function (projectObj) {
                                vaults.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (vaults[0] && vaults[0].totalItems > vaults.length)) {
                                var sqlString = 'SELECT data->>\'id\', data->>\'name\', data->>\'_id\' AS rt FROM access_vaults';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + vaults[vaults.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetVaults({sql: sqlString}, vaults, true);
                            } else {
                                vm.vaultsArr = _.cloneDeepWith(vaults);
                                vm.vaultsArr = _.sortBy(vm.vaultsArr, ['name']);
                            }
                        }, function () { // Error block
                        })
                }

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 6) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeTunnelCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeFactory, $log) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */

                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.tunnelTypes = [];
                vm.selectedTunnelType = '';
                vm.nodeDetailsLoading = true;
                vm.isTunnelRequestActive = false;
                vm.timeOutOptions = [
                    {
                        displayName: '10 Minutes',
                        value: 600
                    }, {
                        displayName: '20 Minutes',
                        value: 1200
                    }, {
                        displayName: '30 Minutes',
                        value: 1800
                    }, {
                        displayName: '45 Minutes',
                        value: 2700
                    }, {
                        displayName: '1 Hour',
                        value: 3600
                    }
                ];
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobSummaryArr = [];

                //nodeTunnelDuration
                var tunnelDuration = UserProfileService.fnGetSystemProfileObj('nodeTunnelDuration');
                if (tunnelDuration === '') {
                    vm.selectedTimeout = _.cloneDeepWith(vm.timeOutOptions[0]);
                } else {
                    vm.selectedTimeout = _.cloneDeepWith(tunnelDuration);
                }

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse timestamps
                        if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = moment(parsedItem.updated_at).unix();
                        }
                        if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = moment(parsedItem.created_at).unix();
                        }

                        // Parse the data JSON field
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Convert string timestamps to numbers if they aren't already
                                if (parsedData.startedAt && angular.isString(parsedData.startedAt)) {
                                    parsedData.startedAt = parseInt(parsedData.startedAt);
                                }
                                if (parsedData.completedAt && angular.isString(parsedData.completedAt)) {
                                    parsedData.completedAt = parseInt(parsedData.completedAt);
                                }
                                if (parsedData.expiresAt && angular.isString(parsedData.expiresAt)) {
                                    parsedData.expiresAt = parseInt(parsedData.expiresAt);
                                }

                                // Ensure jobResult is uppercase
                                if (parsedData.jobResult) {
                                    parsedData.jobResult = parsedData.jobResult.toString().toUpperCase();
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);

                            } catch (e) {
                                $log.error('Error parsing job data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#node-tunnel-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        return false;
                    }
                };

                /*vm.fnGetNodeDetails = function (nodeObj) {
                    var inputObj = {
                        nodeId: nodeObj.id
                    };
                    NodeFactory.describeNode(inputObj)
                        .then(function (response) {
                            vm.nodeObj = _.cloneDeepWith(response);
                            vm.iot3Obj = vm.fnConvertYamlToJson(response.registration.iot3.iot3);
                            if (vm.iot3Obj.engines) {  // Check for plural form
                                if (vm.iot3Obj.engines.tunneling) {
                                    if (vm.iot3Obj.engines.tunneling.http && vm.iot3Obj.engines.tunneling.http.supported) {
                                        if (vm.iot3Obj.engines.tunneling.http.displayInstructions &&
                                            vm.iot3Obj.engines.tunneling.http.displayInstructions.protocol &&
                                            vm.iot3Obj.engines.tunneling.http.displayInstructions.protocol.length &&
                                            vm.iot3Obj.engines.tunneling.http.displayInstructions.protocol.toLowerCase() === 'https') {
                                            vm.tunnelTypes.push({
                                                name: 'HTTPS'
                                            });
                                        } else {
                                            vm.tunnelTypes.push({
                                                name: 'HTTP'
                                            });
                                        }
                                    }

                                    if (vm.iot3Obj.engines.tunneling.ssh && vm.iot3Obj.engines.tunneling.ssh.supported) {
                                        vm.tunnelTypes.push({
                                            name: 'SSH'
                                        });
                                    }
                                } else if (vm.iot3Obj.engines.tunnel) {
                                    if (vm.iot3Obj.engines.tunnel.http && vm.iot3Obj.engines.tunnel.http.supported) {
                                        if (vm.iot3Obj.engines.tunnel.http.displayInstructions &&
                                            vm.iot3Obj.engines.tunnel.http.displayInstructions.protocol &&
                                            vm.iot3Obj.engines.tunnel.http.displayInstructions.protocol.length &&
                                            vm.iot3Obj.engines.tunnel.http.displayInstructions.protocol.toLowerCase() === 'https') {
                                            vm.tunnelTypes.push({
                                                name: 'HTTPS'
                                            });
                                        } else {
                                            vm.tunnelTypes.push({
                                                name: 'HTTP'
                                            });
                                        }
                                    }

                                    if (vm.iot3Obj.engines.tunnel.ssh && vm.iot3Obj.engines.tunnel.ssh.supported) {
                                        vm.tunnelTypes.push({
                                            name: 'SSH'
                                        });
                                    }
                                }

                                if (vm.tunnelTypes.length) {
                                    vm.fnSelectTunnelType(vm.tunnelTypes[0]);
                                }
                            }
                            vm.nodeDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeDetailsLoading = false;
                        })
                };*/

                vm.fnGetNodeDetails = function (nodeObj) {
                    var inputObj = {
                        nodeId: nodeObj.id
                    };
                    NodeFactory.describeNode(inputObj)
                        .then(function (response) {
                            vm.nodeObj = _.cloneDeepWith(response);
                            vm.iot3Obj = vm.fnConvertYamlToJson(response.registration.iot3.iot3);

                            // Reset tunnel types array
                            vm.tunnelTypes = [];

                            // Check all possible tunnel configuration paths
                            function checkTunnelSupport(config) {
                                if (!config) {
                                    return;
                                }

                                // Check HTTP/HTTPS support
                                if (config.http && config.http.supported) {
                                    if (config.http.displayInstructions &&
                                        config.http.displayInstructions.protocol &&
                                        config.http.displayInstructions.protocol.toLowerCase() === 'https') {
                                        vm.tunnelTypes.push({ name: 'HTTPS' });
                                    } else {
                                        vm.tunnelTypes.push({ name: 'HTTP' });
                                    }
                                }

                                // Check SSH support
                                if (config.ssh && config.ssh.supported) {
                                    vm.tunnelTypes.push({ name: 'SSH' });
                                }
                            }

                            // First check if engines exists (this is required according to Java code)
                            if (vm.iot3Obj.engines) {
                                // Check tunneling under engines
                                if (vm.iot3Obj.engines.tunneling) {
                                    checkTunnelSupport(vm.iot3Obj.engines.tunneling);
                                }
                                // Check tunnel under engines
                                if (vm.iot3Obj.engines.tunnel) {
                                    checkTunnelSupport(vm.iot3Obj.engines.tunnel);
                                }
                            }

                            // Also check engine (singular) path
                            if (vm.iot3Obj.engine && vm.iot3Obj.engine.tunnel) {
                                checkTunnelSupport(vm.iot3Obj.engine.tunnel);
                            }

                            if (vm.tunnelTypes.length) {
                                vm.fnSelectTunnelType(vm.tunnelTypes[0]);
                            }

                            vm.nodeDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeDetailsLoading = false;
                        });
                };

                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnRequestNodeTunnel = function () {
                    vm.isTunnelRequestActive = true;
                    var inputObj = {
                        timeout: vm.selectedTimeout.value,
                        type: vm.selectedTunnelType === 'HTTPS' ? 'HTTP' : vm.selectedTunnelType
                    };
                    inputObj.nodeId = vm.selectedTabInfo.rootNodeId;
                    NodeFactory.requestNodeTunnel(inputObj)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            amaran.success("Node tunnel request is in progress.");
                            vm.isTunnelRequestActive = false;
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTunnelRequestActive = false;
                        })

                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to Open a Tunnel"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.nodeObj.name + "' Node (" + vm.nodeObj.id + ") to acknowledge the job"
                        })
                        if (vm.nodeObj.connected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The Node is currently offline the job will continue when the Node comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.nodeObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.nodeObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
                }

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                var jobData = parsedData[0];

                                if (jobData.audits && jobData.audits.length) {
                                    var tempAuditsArr = jobData.audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(jobData.startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }

                                if (jobData.jobResult === "SUCCESS") {
                                    var guidStr = guid();
                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "The Job was executed successfully."
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "One moment while we create a secure tunnel."
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "This can take up to 60 seconds."
                                    })
                                    var basePath = '';
                                    var url = '';
                                    var environment = 'prod';
                                    if (Object.keys(HOST_URL).length) { //eslint-disable-line
                                        url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                                        if (url.startsWith('dev')) {
                                            environment = 'dev';
                                            basePath = 'https://dev-tunnel.ecsmon.ecsiteapp.com'
                                        } else {
                                            basePath = 'https://tunnel.ecsmon.ecsiteapp.com'
                                        }
                                    } else {
                                        basePath = 'https://tunnel.ecsmon.ecsiteapp.com'
                                    }
                                    var apiURL = basePath + "/tunnel/"; //eslint-disable-line
                                    var authToken = '';
                                    if (DB.fnGet('federation')) {
                                        authToken = 'Basic ' + DB.fnGet('federation').sessionObj.federationToken;
                                    } else if (DB.fnGet('support')) {
                                        authToken = 'Basic ' + DB.fnGet('support').sessionObj.supportToken;
                                    } else {
                                        authToken = 'Basic ' + $cookies.get('phoenix')
                                    }
                                    var headers = {
                                        'Content-Type': 'application/json',
                                        'Authorization': authToken,
                                        'deviceId': vm.nodeObj.id,
                                        'jobId': vm.jobObj.id,
                                        'jobUuid': guidStr,
                                        'timeout': vm.selectedTimeout.value,
                                        'tunnelType': vm.selectedTunnelType,
                                        'predictiveEnvironment': environment
                                    };
                                    $http({
                                        method: "GET",
                                        url: apiURL,
                                        responseType: 'application/json',
                                        headers: headers
                                    }).then(function (response) {
                                        if (response && response.data && response.data.tunnel_port) {
                                            $cookies.put('predictivetunnel_' + vm.jobObj.id, guidStr, {
                                                domain: '.ecsmon.ecsiteapp.com',
                                                samesite: 'None',
                                                secure: true
                                            });
                                            vm.jobSummaryArr.push({
                                                dateTime: "",
                                                summary: "Tunnel established successfully. Opening the tunnel in a new tab."
                                            })
                                            var popup_window = '';
                                            if (response.data.path && response.data.path !== '') {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: "Tunnel URL : " + basePath + ":" + response.data.tunnel_port + response.data.path + "."
                                                })
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port + response.data.path, '_blank');
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: "Tunnel URL : " + basePath + ":" + response.data.tunnel_port + "."
                                                })
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port, '_blank');
                                            }
                                            try {
                                                popup_window.focus();
                                            } catch (e) {
                                                swal({
                                                    title: "Pop-up Blocker is enabled!",
                                                    text: "This site uses pop-up for the tunnel. Please enable them for this website in your browser or add this site to your exception list.",
                                                    type: "warning",
                                                    html: true,
                                                    showCancelButton: true,
                                                    showCancelButtonText: 'OK',
                                                    showConfirmButton: false,
                                                    showLoaderOnConfirm: false
                                                });
                                            }
                                        } else {
                                            vm.jobSummaryArr.push({
                                                dateTime: "",
                                                summary: "We encountered an error while trying to establish a secure connection. Please try again."
                                            })
                                        }
                                    }, function error() {

                                    });
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.node.tabs, {id: 'Tunnel'});
                    vm.fnGetNodeDetails({id: vm.selectedTabInfo.rootNodeId});
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeSynchronizingCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeFactory, $log) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */

                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.nodeDetailsLoading = true;
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobSummaryArr = [];
                vm.deploysUnsynchronizedNode = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#node-synchronizing-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnGetNodeDetails = function (nodeObj) {
                    var SQL = "SELECT " +
                        "node_nodes.*, " +
                        "node_ecus.data->\'connected\' as ecuConnected, " +
                        "node_ecus.data->>\'name\' as ecuName " +
                        "FROM " +
                        "node_nodes " +
                        "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                        "WHERE " +
                        "node_nodes.data->>\'id\' = '" + nodeObj.id + "' " +
                        "LIMIT 10;";
                    QueryFactory.executeQuery({sql: SQL})
                        .then(function (response) {
                            if (response && response.data && response.data.length) {
                                var parsedItems = parsePostgresData(response.data);
                                vm.nodeObj = _.cloneDeepWith(parsedItems[0]);
                            } else {
                                vm.nodeObj = "";
                            }
                            vm.nodeDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeDetailsLoading = false;
                        })
                };

                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnRequestNodeSynchronizing = function () {
                    vm.deploysUnsynchronizedNode = true;
                    var input = {
                        nodeId: vm.nodeObj.id
                    };
                    NodeFactory.deployNode(input)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            vm.deploysUnsynchronizedNode = false;
                            amaran.success("Node synchronize in progress.");
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.deploysUnsynchronizedNode = false;
                        });
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new job has been created to synchronize a node"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.nodeObj.ecuName + "' ECU (" + vm.nodeObj.ecuId + ") to acknowledge the job"
                        })
                        if (vm.nodeObj.ecuConnected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.nodeObj.ecuName + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.nodeObj.ecuName + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                var parsedItems = parsePostgresData(res.data);
                                if (parsedItems[0].audits && parsedItems[0].audits.length) {
                                    var tempAuditsArr = parsedItems[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(parsedItems[0].startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }
                                if (parsedItems[0].jobResult === "SUCCESS") {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(parsedItems[0].completedAt),
                                        summary: "The job successfully completed."
                                    })
                                }
                                if (parsedItems[0].jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(parsedItems[0].completedAt),
                                        summary: "The job failed and was aborted."
                                    })
                                }
                                if (parsedItems[0].jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(parsedItems[0].completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.node.tabs, {id: 'SynchronizingNode'});
                    vm.fnGetNodeDetails({id: vm.selectedTabInfo.nodeId});
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeInfo', fnNodeInfo)

    /** @ngInject */
    function fnNodeInfo($window, $state, moment, $stateParams, $timeout, $uibModal, microSpinner, swal, amaran, DB, ColorService, NodeEcuFactory, jsyaml, copyService, NodeProjectFactory, BatchFactory, AppInitService, NodeFactory, postActionModelMessage, postActionModelIcon, TypeFormService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/node/nodeInfo/nodeInfo.html',
            scope: {
                nodeObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isRediscoveryPermission = false;
                var activeUser = '';
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    var federationUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                    activeUser = federationUser.sessionObj.user;
                } else {
                    activeUser = DB.fnGet("loginUser");
                }
                if (activeUser.accountOwner === true || activeUser.administrator === true || activeUser.nodeRole === 'MANAGER') {
                    $scope.isRediscoveryPermission = true;
                }
                $scope.isEcuDetailsLoaded = false;

                $scope.fnGetEcu = function () {
                    $scope.isEcuDetailsLoaded = false;
                    var inputObj = {
                        ecuId: $scope.nodeObj.ecuId
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            if (response.lastSeenAt && response.lastSeenAt !== 0) {
                                response.lastSeenDate = $scope.fnGetAbsoluteOrRelativeTime(response.lastSeenAt);
                            }
                            $scope.ecuObj = response;
                            $scope.isEcuDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEcuDetailsLoaded = true;
                        })
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                if ($scope.nodeObj.id) {
                    $scope.nodeObj.ecuId = $scope.nodeObj.id.substring(0, $scope.nodeObj.id.lastIndexOf("-"));
                    $scope.fnGetEcu();
                }

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Graph',
                        tabIndex: 1,
                        templateUrl: 'app/node/node/nodeInfo/nodeSteps/nodeGraph/nodeGraph.html'
                    },
                    {
                        title: 'Telemetry',
                        tabIndex: 2,
                        templateUrl: 'app/node/node/nodeInfo/nodeSteps/nodeAttributes/nodeAttributes.html'
                    },
                    {
                        title: 'Location',
                        tabIndex: 3,
                        templateUrl: 'app/node/node/nodeInfo/nodeSteps/nodeLocation/nodeLocation.html'
                    },
                    {
                        title: 'About',
                        tabIndex: 4,
                        templateUrl: 'app/node/node/nodeInfo/nodeSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/node/node/nodeInfo/nodeSteps/nodeSupplemental/nodeSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.nodeEnergyObj = {};
                $scope.nodePriceObj = {};
                $scope.model = {};
                $scope.schema = {};
                $scope.form = [];

                $scope.fnGetNode = function (nodeId) {
                    var inputObj = {
                        nodeId: nodeId
                    };
                    NodeFactory.describeNode(inputObj)
                        .then(function (response) {
                            $scope.nodeObj = response;
                            var iot3Obj = $scope.fnConvertYamlToJson($scope.nodeObj.registration.iot3.iot3)
                            var tempData = TypeFormService.fnGenerateFormData(iot3Obj.registration.form);
                            $scope.schema = tempData.schema;
                            $scope.form = tempData.form;
                            $scope.model = $scope.nodeObj.registration.form.values;
                            if (iot3Obj.template) {
                                _.forEach(iot3Obj.template.types, function (value) {
                                    if ($scope.nodeObj && $scope.nodeObj.meta && $scope.nodeObj.meta.model && $scope.nodeObj.meta.model === value.name && $scope.nodeObj.meta.version && Number($scope.nodeObj.meta.version) === value.version && (value.energy || value.price)) {
                                        $scope.nodeEnergyObj = value.energy ? value.energy : {};
                                        $scope.nodePriceObj = value.price ? value.price : {};
                                        return false;
                                    }
                                })
                            }
                            $scope.resetNodeObj = angular.copy($scope.nodeObj);
                            if (DB.fnGet('isNodeEditable')) {
                                $scope.fnChangeFieldsToEditable();
                                DB.fnRemove('isNodeEditable');
                            }
                            $scope.isNodeDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isNodeDetailsLoaded = true;
                        })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };


                $scope.fnInitNode = function () {
                    $scope.isNodeDetailsLoaded = false;
                    $scope.isDisplayMiniColors = false;
                    $scope.nodeId = $scope.nodeObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.nodeObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        if ($scope.nodeId) {
                            $scope.fnGetNode($scope.nodeId);
                        }
                    } else {
                        NodeProjectFactory.describeProject({projectId: $scope.nodeObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.nodeId) {
                                $scope.fnGetNode($scope.nodeId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitNode();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                }

                $scope.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                $scope.fnUpdateNodeDetails = function (nodeObj) {
                    $scope.isUpdateCompleted = false;
                    var inputObj = {
                        body: {},
                        nodeId: nodeObj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/nodes/" + nodeObj.id + "/names",
                        body: {name: nodeObj.name}
                    });

                    if (angular.isDefined(nodeObj.description)) {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/nodes/" + nodeObj.id + "/descriptions",
                            body: {description: nodeObj.description}
                        });
                    } else {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/nodes/" + nodeObj.id + "/descriptions",
                            body: {description: ''}
                        });
                    }

                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        var tempEcuObj = response[response.length - 1].body;
                        if (tempEcuObj.code === 400) {
                            $scope.isUpdateCompleted = true;
                            amaran.error(tempEcuObj.message);
                            $scope.fnResetDetails();
                        } else {
                            if (angular.isUndefined(tempEcuObj.description)) {
                                tempEcuObj.description = '';
                            }
                            $scope.$emit('NodeDetailsChanged', tempEcuObj);
                            $scope.nodeObj.name = tempEcuObj.name;
                            $scope.nodeObj.description = tempEcuObj.description;
                            amaran.success("Node Updated Successfully");
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    })
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.nodeObj = angular.copy($scope.resetNodeObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnDeleteNode = function (nodeObj) {
                    swal({
                            title: "Delete the selected Node?",
                            text: "You are about to permanently delete the selected Node.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.<br/><br/>" +
                                "Please type in the word \"Delete\" to delete Node.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (inputValue) {
                            if (inputValue === null) {
                                return false;
                            }

                            if (inputValue === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (inputValue !== 'Delete') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (inputValue === 'Delete') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    nodeId: nodeObj.id
                                };
                                NodeFactory.deleteNode(inputObj)
                                    .then(function (response) {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node deleting in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            var modalInstance = $uibModal.open({
                                                backdrop: 'static',
                                                templateUrl: 'app/node/node/modals/nodeDeleteJobTerminal/nodeDeleteJobTerminal.html',
                                                size: 'lg',
                                                controller: 'nodeDeleteJobTerminalCtrl as nodeDeleteJobTerminal',
                                                windowClass: 'modal-height100',
                                                resolve: {
                                                    jobObj: function () {
                                                        return _.cloneDeepWith(response);
                                                    },
                                                    ecuObj: function () {
                                                        return _.cloneDeepWith($scope.ecuObj);
                                                    }
                                                }
                                            });
                                            modalInstance.result.then(function () {
                                                $timeout(function () {
                                                    angular.element($window).triggerHandler('resize');
                                                }, 1000);
                                            }, function () {
                                                $timeout(function () {
                                                    angular.element($window).triggerHandler('resize');
                                                }, 1000);
                                            });
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else if (inputValue === false) {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnEnableNode = function (nodeObj) {
                    swal({
                            title: "Enable the selected Node?",
                            text: "You are about to enable selected Node.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    nodeId: nodeObj.id
                                };
                                NodeFactory.enableNode(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Node enabling Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnDisabledNode = function (ecuObj) {
                    swal({
                            title: "Disable the selected Node?",
                            text: "You are about to disable elected Node.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    nodeId: ecuObj.id
                                };
                                NodeFactory.disableNode(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Node disabling process cancelled", "error");
                            }
                        });
                };

                $scope.fnDeployNode = function (nodeObj) {
                    $scope.$emit('RequestNodeSynchronizing', nodeObj);
                };

                $scope.fnRequestReplaceRegistration = function (nodeObj) {
                    $scope.$emit('RequestReplaceRegistration', nodeObj);
                };

                $scope.fnRequestNodeTunnel = function (nodeObj) {
                    $scope.$emit('RequestNodeTunnel', nodeObj);
                };

                $scope.fnRequestReplaceRediscovery = function (nodeObj) {
                    $scope.$emit('RequestNodeDiscover', nodeObj);
                }

                $scope.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        return false;
                    }
                };

                $scope.fnCloneNodeSettings = function (nodeObj) {
                    $scope.$emit('CloneNodeSettings', nodeObj);
                }

                $scope.fnGotoTelemetryTab = function () {
                    $scope.fnTabSelected({tabIndex: 1});
                }

                $scope.$on('openNodeDetailTab', function () {
                    $scope.fnTabSelected({tabIndex: 4});
                });

                $scope.$on('openNodeTelemetryTab', function () {
                    $scope.fnTabSelected({tabIndex: 1});
                });

                var nodeInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.nodePermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteNode($scope.nodeObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.nodePermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var nodeInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', nodeInfoKeyDownEventHandler);
                document.addEventListener('keyup', nodeInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', nodeInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', nodeInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

/**
 * Created by WebOsmotic on 2/10/2018.
 */
(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('lifecycleInfo', fnLifecycleInfo)

    /** @ngInject */
    function fnLifecycleInfo($window, $state, $stateParams, $timeout, swal, amaran, microSpinner, copyService, LifecycleFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/lifecycle/lifecycleInfo/lifecycleInfo.html',
            scope: {
                lifecycleObj: '=',
                lifecyclePermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });
                $scope.tabs = [
                    {
                        title: 'Steps',
                        tabIndex: 1,
                        templateUrl: 'app/node/lifecycle/lifecycleInfo/lifecycleTabs/lifecycleStep/lifecycleStep.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 2,
                        templateUrl: 'app/node/lifecycle/lifecycleInfo/lifecycleTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.lifecycle', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };
                $scope.fnGetLifecycle = function (lifecycleId) {
                    var inputObj = {
                        lifecycleId: lifecycleId
                    };
                    LifecycleFactory.getLifecycle(inputObj)
                        .then(function (response) {
                            $scope.lifecycleObj = response;
                            $scope.resetLifecycleObj = angular.copy($scope.lifecycleObj);
                            if (angular.isUndefined($scope.lifecycleObj.description)) {
                                $scope.lifecycleObj.description = '';
                            }
                            $scope.isLifecycleDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isLifecycleDetailsLoaded = true;
                        })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnDeleteLifecycle = function (lifecycleObj) {
                    swal({
                            title: "Delete the selected lifecycle?",
                            text: "You are about to permanently delete the selected lifecycle.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    lifecycleId: lifecycleObj.id
                                };
                                LifecycleFactory.deleteLifecycle(inputObj)
                                    .then(function () {
                                        $scope.$emit('LifecycleDeleted', lifecycleObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitLifecycle = function () {
                    $scope.isLifecycleDetailsLoaded = false;
                    $scope.lifecycleId = $scope.lifecycleObj.id;
                    if ($scope.lifecycleId) {
                        $scope.fnGetLifecycle($scope.lifecycleId);
                    }
                    $scope.fnSetTabHeight();
                };
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('nodeDiscoverCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeFactory, $log) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */

                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.nodeDetailsLoading = true;
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobSummaryArr = [];
                vm.discoverNode = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#node-discover-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnGetNodeDetails = function (nodeObj) {
                    var SQL = "SELECT " +
                        "node_nodes.*, " +
                        "node_ecus.data->\'connected\' as ecuConnected, " +
                        "node_ecus.data->>\'name\' as ecuName " +
                        "FROM " +
                        "node_nodes " +
                        "INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' " +
                        "WHERE " +
                        "node_nodes.data->>\'id\' = '" + nodeObj.id + "' " +
                        "LIMIT 10;";
                    QueryFactory.executeQuery({sql: SQL})
                        .then(function (response) {
                            if (response && response.data && response.data.length) {
                                var parsedItems = parsePostgresData(response.data);
                                vm.nodeObj = _.cloneDeepWith(parsedItems[0]);
                            } else {
                                vm.nodeObj = "";
                            }
                            vm.nodeDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeDetailsLoading = false;
                        })
                };

                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnRequestNodeDiscover = function () {
                    vm.discoverNode = true;
                    var input = {
                        nodeId: vm.nodeObj.id
                    };
                    NodeFactory.discoverNode(input)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            vm.discoverNode = false;
                            amaran.success("Node discover request in progress.");
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.discoverNode = false;
                        });
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to re-discover node"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.nodeObj.ecuName + "' ECU (" + vm.nodeObj.ecuId + ") to acknowledge the job"
                        })
                        if (vm.nodeObj.ecuConnected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.nodeObj.ecuName + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.nodeObj.ecuName + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                var parsedItems = parsePostgresData(res.data);
                                if (parsedItems[0].audits && parsedItems[0].audits.length) {
                                    var tempAuditsArr = parsedItems[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(parsedItems[0].startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === "SUCCESS") {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job successfully completed."
                                    })
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job failed and was aborted."
                                    })
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.node.tabs, {id: 'RediscoveryNode'});
                    vm.fnGetNodeDetails({id: vm.selectedTabInfo.nodeId});
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createNodeCtrl',
            function ($rootScope, $scope, $timeout, $window, $uibModal, $state, $stateParams, $log, swal, TypeFormService, NodeEcuFactory, NodeFactory, ColorService, PaginationQueryService, AppInitService, UserProfileService, jsyaml, NodeIoT3Factory, Iot3WorkbenchFactory, amaran, DB, moment, QueryFactory, microSpinner) {
                var vm = this;

                /* Step 1: Register Home Page
                * Step 2: List IoT3 files
                * Step 3: IoT3 file summary.
                * Step 4: IoT3 file config summary and option to open the ECU list.
                * Step 5: ECU list page.
                * Seep 6: ECU project change page. (If ECU currently has zero nodes registered)
                * Step 7: Node Registration summary.
                * Step 8: Node Registration process terminal.
                */

                vm.totalSteps = 8;
                vm.activeStep = 1;
                vm.newNodeObj = {
                    name: "",
                    description: "",
                    registration: {
                        iot3: {
                            iot3: ""
                        },
                        form: {
                            schema: {},
                            values: {}
                        },
                        graph: {
                            type: "AUTO_COMPLETE",
                            graph: "string"
                        }
                    }
                };
                vm.isNodeRegistering = false;
                vm.nodeRegisteringObj = {};
                vm.jobAPITimeout = '';
                vm.cloneNodeInformation = {};
                vm.isIoT3References = true;
                vm.jobSummaryArr = [];
                vm.vaultsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                    vm.fnSetDataHeight();
                    if (vm.activeStep === 3 || vm.activeStep === 7) {
                        vm.fnSetTabHeight();
                    }
                    if (vm.activeStep === 5) {
                        vm.fnSetECUTableHeight();
                    }
                    if (vm.activeStep === 3 && vm.selectedTabIndex === 2) {
                        vm.fnSetIot3NodeTableHeight();
                    }
                });

                /*function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map common fields
                                parsedItem.id = parsedItem.id || parsedData._id || parsedData.id;
                                if (parsedData.vault_id && angular.isObject(parsedData.vault_id)) {
                                    parsedItem.vault_id = parsedData.vault_id.id || parsedData.vault_id; // Ensure correct vault_id
                                }

                                parsedItem.subject = parsedData.subject ? {
                                    name: parsedData.subject.name,
                                    description: parsedData.subject.description,
                                    type: parsedData.subject.type || 'string'
                                } : null;

                                parsedItem.projectId = parsedData.projectId || parsedData.projectid || parsedItem.projectid;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedItem.description || parsedData.description;

                                // IoT3 specific fields
                                parsedItem.oem = parsedData.oem;
                                parsedItem.model = parsedData.model;
                                parsedItem.versions = parsedData.versions;
                                parsedItem.labels = parsedData.labels;
                                parsedItem.revision = parsedData.revision;
                                parsedItem.author = parsedData.author;

                                // ECU specific fields
                                parsedItem.connected = parsedData.connected;
                                parsedItem.health = parsedData.health;
                                parsedItem.phase = parsedData.phase;
                                parsedItem.vpn = parsedData.vpn;
                                parsedItem.ntp = parsedData.ntp;
                                parsedItem.version = parsedData.version;
                                parsedItem.lifecycleState = parsedData.lifecycleState || parsedData.lifecyclestate;
                                parsedItem.syncState = parsedData.syncState || parsedData.syncstate;
                                parsedItem.lastSeenAt = parsedData.lastSeenAt || parsedData.lastseenat;

                                // Handle timestamps
                                if (parsedItem.updatedAt || parsedData.updatedAt) {
                                    parsedItem.updatedAt = parsedItem.updatedAt || parsedData.updatedAt;
                                } else if (parsedItem.updated_at || parsedData.updated_at) {
                                    parsedItem.updatedAt = parsedItem.updated_at || parsedData.updated_at;
                                }

                                if (parsedItem.createdAt || parsedData.createdAt) {
                                    parsedItem.createdAt = parsedItem.createdAt || parsedData.createdAt;
                                } else if (parsedItem.created_at || parsedData.created_at) {
                                    parsedItem.createdAt = parsedItem.created_at || parsedData.created_at;
                                }

                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }*/
                function parsePostgresData(items) {
                    $log.debug('Raw items:', items);

                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle registration data if present
                                if (parsedData.registration && angular.isString(parsedData.registration)) {
                                    try {
                                        parsedData.registration = angular.fromJson(parsedData.registration);
                                    } catch (e) {
                                        $log.error('Error parsing registration data:', e);
                                    }
                                }

                                // Map core fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name;
                                parsedItem.description = parsedData.description;
                                parsedItem.health = parsedData.health;
                                parsedItem.connected = parsedData.connected === true || parsedData.connected === 'true';
                                parsedItem.phase = parsedData.phase;
                                parsedItem.lifecycleState = parsedData.lifecycleState;
                                parsedItem.syncState = parsedData.syncState;
                                parsedItem.projectId = parsedData.projectId;
                                parsedItem.ntp = parsedData.ntp;
                                parsedItem.vpn = parsedData.vpn;
                                parsedItem.version = parsedData.version;

                                // Handle all timestamp variations
                                // Created timestamps
                                parsedItem.createdAt = parsedItem.createdAt ||
                                    parsedData.createdAt ||
                                    parsedItem.created_at ||
                                    parsedData.created_at;

                                // Updated timestamps
                                parsedItem.updatedAt = parsedItem.updatedAt ||
                                    parsedData.updatedAt ||
                                    parsedItem.updated_at ||
                                    parsedData.updated_at;

                                // Last seen timestamps
                                parsedItem.lastSeenAt = parsedItem.lastSeenAt ||
                                    parsedData.lastSeenAt ||
                                    parsedItem.last_seen_at ||
                                    parsedData.last_seen_at;

                                // Ensure both snake_case and camelCase versions exist for compatibility
                                parsedItem.created_at = parsedItem.createdAt;
                                parsedItem.updated_at = parsedItem.updatedAt;
                                parsedItem.last_seen_at = parsedItem.lastSeenAt;

                                // Handle registration data
                                if (parsedData.registration) {
                                    parsedItem.registration = parsedData.registration;
                                }

                                // Handle totalItems/totalitems variations
                                parsedItem.totalItems = parseInt(item.totalitems || item.totalItems || 0);

                                $log.debug('Parsed item:', parsedItem);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }
                vm.parsePostgresData = parsePostgresData;

                vm.fnGotoPreviousStep = function () {
                    if (vm.activeStep === 3) {
                        vm.selectedIoT3FileObj = {};
                        vm.activeStep = vm.activeStep - 1;
                    }
                    if (vm.activeStep === 7 && vm.isECUHasNode === true) {
                        vm.activeStep = vm.activeStep - 2;
                    } else {
                        vm.activeStep = vm.activeStep - 1;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnGotoNextStep = function (step) {
                    vm.activeStep = step;
                    if (vm.activeStep === 3) {
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 100);
                    }
                    if (vm.activeStep === 6) {
                        vm.selectedProject = _.find(vm.projectsArr, {id: vm.selectedEcuObj.projectId});
                        vm.selectedProjectId = vm.selectedEcuObj.projectId;
                        vm.fnCheckECUHasNode(7);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createNode-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 4) {
                            var headerHeight = angular.element(".user-header")[0].offsetHeight;
                            angular.element("#step4").css('height', (total - headerHeight - footer) + 'px');
                        }
                        if (vm.activeStep === 8) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tab-node-registration-summary").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnSetDataHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 188 + dashboardHeader + mainFooter);
                        angular.element("#healthTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECUTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 198 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetIot3NodeTableHeight = function () {
                    if (angular.element(".tabContent")[0] && angular.element(".iot3-node-desc")[0] && angular.element(".local-search-bar")[0]) {
                        var total = angular.element(".tabContent")[0].offsetHeight;
                        var nodeDesc = angular.element(".iot3-node-desc")[0].offsetHeight;
                        var searchBar = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = 36;
                        var finalHeight = total - (searchBar + nodeDesc + header + 35);
                        angular.element("#iot3RegisterNodeTableBody").css('height', finalHeight + 'px');
                    }
                };

                $timeout(function () {
                    vm.fnSetTableHeight();
                });

                vm.fnGotoIoTEditor = function () {
                    vm.fnGotoNextStep(3);
                    vm.selectedTabIndex = 3
                };

                vm.fnGotoImportWorkbench = function () {
                    vm.isIoT3References = false;
                    vm.fnGotoNextStep(2);
                    vm.selectedTabIndex = 2
                }

                vm.uploadFiles = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var fileData = fileLoadedEvent.target.result;
                        var testYaml = vm.fnConvertYamlToJson(fileData);
                        if (testYaml === null || angular.isUndefined(testYaml)) {
                            amaran.error('Yaml format is incorrect. Please check it and try again.')
                        } else {
                            vm.selectedIoT3FileObj.iot3File = fileData;

                            $timeout(function () {
                                vm.fnInitCalled();
                            })
                        }
                    };
                    reader.readAsText(filesSelected);
                };

                vm.fnAddDefaultIoT3Filters = function (oemType) {
                    vm.isIoT3References = true;
                    if (oemType !== '') {
                        vm.defaultIoT3FilterArr = [
                            {
                                "id": 391527638,
                                "selectedField": "oem",
                                "displaySelectedField": "OEM",
                                "selectedFilter": {
                                    "operatorName": "=",
                                    "operator": "="
                                },
                                "searchText": oemType,
                                "displaySearchText": oemType
                            }
                        ];
                    } else {
                        vm.defaultIoT3FilterArr = [];
                    }

                    $timeout(function () {
                        vm.fnGotoNextStep(2);
                    });

                };

                /*Node IoT3: Start*/
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.defaultIoT3FilterArr = [];
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.iot3SearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "OEM",
                        name: "oem",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3SortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.defaultIot3SortString = 'name asc';
                vm.iot3FilterQuery = "";
                vm.iot3SqlQuery = "";
                vm.isIoT3RefreshData = true;
                vm.isIoT3Refresh = false;
                vm.iot3JSON = {};
                vm.notDisplayInfo = [
                    'name',
                    'oem',
                    'model',
                    'author',
                    'created',
                    'updated',
                    'versions',
                    'documentation'
                ];
                vm.iot3Summary = [];
                vm.isIoT3DetailLoading = false;
                vm.iot3NodeArr = [];

                vm.fnIOT3FilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3FilterQuery = filterQuery;
                    vm.iot3SqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE data->>\'' + vm.iot3SqlQuery.trim() : '\' ';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE data->>\'' + vm.iot3SqlQuery.trim() : '\'';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3s(input, true);
                };

                vm.fnGetIOT3s = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data = vm.parsePostgresData(res.data);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetIoT3AbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetIoT3AbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            if (isFirst && res.data && res.data.length) {
                                vm.totalItems = res.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                res.data.reverse();
                            }
                            vm.iot3sArr = _.cloneDeepWith(res.data);
                            vm.isIoT3Refresh = false;
                            vm.isIOT3sLoading = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3sLoading = false;
                            vm.isIoT3RefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        })
                };

                vm.fnIoT3PageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_references';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_references';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE data->>\'' + vm.iot3SqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE data->>\'' + vm.iot3SqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3s(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3SqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3sArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3s(input, false);
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetIoT3AbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours < 24) {
                        relativeTime = "Today";
                    } else if (differenceHours > 24 && differenceHours < 48) {
                        relativeTime = "Yesterday";
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return {relativeTime: relativeTime, date: moment.unix(timestamp).format("DD/MM/YYYY HH:mm:ss")};
                };

                vm.fnSelectIoT3File = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    vm.iot3Summary = [];
                    NodeIoT3Factory.describeIoT3Reference({iot3Id: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        if (error && Object.keys(error).length) {
                            var errorLine = error.mark.line - 1;
                            vm.goToLine(errorLine);
                        }
                        return false;
                    }
                };

                vm.fnReloadIoT3s = function () {
                    vm.isIoT3RefreshData = false;
                    vm.isIoT3Refresh = true;
                    $timeout(function () {
                        vm.isIoT3RefreshData = true;
                    }, 10)
                };

                /*Node IoT3: End*/

                /*Node IoT3 Workspaces: Start*/
                vm.iot3WorkspacesSearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3WorkspacesSortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.iot3WorkspacesFilterQuery = "";
                vm.iot3WorkspacesSqlQuery = "";
                vm.isIoT3WorkspacesRefreshData = true;
                vm.isIoT3WorkspacesRefresh = false;

                vm.fnIOT3WorkspacesFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3WorkspacesFilterQuery = filterQuery;
                    vm.iot3WorkspacesSqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE data->>\'' + vm.iot3WorkspacesSqlQuery.trim() : '\'';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE data->>\'' + vm.iot3WorkspacesSqlQuery.trim() : '\'';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3Workspaces(input, true);
                };

                vm.fnGetIOT3Workspaces = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data = vm.parsePostgresData(res.data);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                            });
                            if (isFirst && res.data && res.data.length) {
                                vm.totalItems = res.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                res.data.reverse();
                            }
                            vm.iot3WorkspacesArr = _.cloneDeepWith(res.data);
                            vm.isIoT3WorkspacesRefresh = false;
                            vm.isIOT3WorkspacesLoading = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3WorkspacesLoading = false;
                            vm.isIoT3WorkspacesRefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            })
                        })
                };

                vm.fnIoT3WorkspacesPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_workspaces';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE data->>\'' + vm.iot3WorkspacesSqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE data->>\'' + vm.iot3WorkspacesSqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3Workspaces(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3WorkspacesSqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3WorkspacesArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3Workspaces(input, false);
                    }
                };

                vm.fnSelectIoT3WorkspacesFile = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    vm.iot3Summary = [];
                    Iot3WorkbenchFactory.describeIot3Worbench({workspaceId: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnReloadIoT3Workspaces = function () {
                    vm.isIoT3WorkspacesRefreshData = false;
                    vm.isIoT3WorkspacesRefresh = true;
                    $timeout(function () {
                        vm.isIoT3WorkspacesRefreshData = true;
                    }, 10)
                };
                /*Node IoT3 Workspaces: End*/

                /*IoT3 File Summary: Start*/
                vm.selectedIoT3FileObj = {};
                vm.selectedTabIndex = 1;
                vm.iot3Tabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    },
                    {
                        title: 'Nodes',
                        tabIndex: 2
                    },
                    {
                        title: 'IoT3',
                        tabIndex: 3
                    }
                ];
                vm.isChangesSync = true;

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            vm.isChangesSync = false;
                            $timeout(function () {
                                vm.fnChangeDone();
                            }, 100);
                        });

                        vm.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };

                        vm.goToLine = function (lineNumber) {
                            _cm.setCursor(lineNumber);
                        };
                    }
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = 55;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 100)
                };

                vm.fnInitSecurityRegistration = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 500)
                }

                vm.fnChangeDone = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                    var isValidJson = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File);
                    if (isValidJson !== false) {
                        vm.iot3JSON = isValidJson;
                        vm.iot3Summary = [];
                        vm.iot3NodeArr = [];
                        if ((angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined') && Object.keys(vm.iot3JSON).length) {
                            if (vm.iot3JSON.info.created) {
                                vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                            } else {
                                vm.iot3JSON.info.created = '';
                            }
                            if (vm.iot3JSON.info.updated) {
                                vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                            } else {
                                vm.iot3JSON.info.updated = '';
                            }
                            if (vm.iot3JSON && vm.iot3JSON.iot3) {
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.info) {
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                    var tempObj = typeValue;
                                    tempObj.type = typeKey;
                                    vm.iot3NodeArr.push(tempObj)
                                });
                            }
                        }
                        vm.isChangesSync = true;
                        $timeout(function () {
                            vm.setLine();
                        });
                    } else {
                        vm.isChangesSync = false;
                        //amaran.error('YAML format is not valid.');
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                };

                vm.fnTabSelected = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        if (vm.selectedTabIndex === 3) {
                            vm.isChangesSync = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File) !== false;
                        }
                        if (vm.selectedTabIndex === 2) {
                            vm.fnSetIot3NodeTableHeight();
                        }
                    }, 100)
                };

                vm.fnViewAttributes = function (iot3NodeObj) {
                    var attributes = _.filter(vm.iot3JSON.template.attributes, function (value, key) {
                        value.reference = key;
                        return iot3NodeObj.attributes.includes(key);
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/viewAttributes/viewAttributes.html',
                        size: 'lg',
                        controller: 'viewAttributesCtrl as viewAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedNode: function () {
                                return _.cloneDeepWith(iot3NodeObj);
                            },
                            attributesArr: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.isValidateIoT3File = function () {
                    return !!(vm.isChangesSync && vm.iot3JSON && angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined' && Object.keys(vm.iot3JSON).length);
                    //return !!vm.selectedEcuObj && Object.keys(vm.selectedEcuObj).length;
                };

                /*IoT3 File Summary: End*/

                /*IoT3 Security Registration: Start*/
                vm.isLoading = true;
                vm.model = {};
                vm.schema = {};
                vm.form = [];
                vm.isIoT3FormValid = false;
                vm.fnSecurityRegistrationInit = function () {
                    vm.isLoading = true;
                    if (vm.iot3JSON && vm.iot3JSON.registration && vm.iot3JSON.registration.form && vm.iot3JSON.registration.form.properties) {
                        var tempData = TypeFormService.fnGenerateFormData(vm.iot3JSON.registration.form);
                        var isFindVault = _.find(tempData.form, function (formObj) {
                            return formObj.key === 'vault_id';
                        })
                        if (isFindVault) {
                            isFindVault.titleMap = _.map(vm.vaultsArr, function (vaultObj) {
                                return {name: vaultObj.name, id: vaultObj.id};
                            })
                            isFindVault.type = "vaultInputDropdown";
                        }
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        var tempModelData = _.cloneDeepWith(vm.model);
                        vm.model = {};
                        if (Object.keys(tempModelData).length) {
                            _.forEach(vm.schema.properties, function (value, key) {
                                if (value.type === 'object') {
                                    _.forEach(value.properties, function (objValue, objKey) {
                                        if (tempModelData[key] && tempModelData[key][objKey]) {
                                            if (vm.model[key]) {
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            } else {
                                                vm.model[key] = {};
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            }
                                        }
                                    })
                                } else {
                                    if (tempModelData[key]) {
                                        vm.model[key] = tempModelData[key];
                                    }
                                }
                            });
                        }
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    } else {
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    }
                };

                vm.fnCheckIot3Validation = function (value) {
                    vm.isIoT3FormValid = value;
                    return value;
                };
                /*IoT3 Security Registration: End*/

                /*ECU: Start*/
                vm.isProjectLoaded = false;
                vm.projectsArr = [];
                vm.isInitEcu = true;
                vm.isECURefresh = false;
                vm.isECURefreshData = true;
                vm.selectedEcuObj = {};
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};
                vm.searchECUFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Phase",
                        name: "phase",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->>\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->>\'connected\' = \'false\' or data->>\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortECUFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.ecuFilterQuery = "";
                vm.ecuSqlQuery = "";
                vm.isColumnView = true;
                vm.isECUHasNode = true;
                vm.isECUProjectUpdating = false;

                vm.fnECUFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.ecuFilterQuery = filterQuery;
                    vm.ecuSqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEcusLoading = true;
                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE data->>\'" + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->>\'registered\' = \'true\'";
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->>\'registered\' = \'true\'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + '\' and data->>\'registered\' = \'true\' ' : ' WHERE data->>\'registered\' = \'true\'';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + '\' and data->>\'registered\' = \'true\' ' : ' WHERE data->>\'registered\' = \'true\'';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectEcu = function (projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE data->>\'" + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->>\'registered\' = \'true\'";
                        } else {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\' ' + vm.ecuSqlQuery.trim() + '\'and data->>\'registered\' = \'true\'' : 'WHERE data->>\'registered\' = \'true\'';
                        }
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE data->>\'" + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->>\'registered\' = \'true\' ";
                        } else {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + '\' and data->>\'registered\' = \'true\'' : 'WHERE data->>\'registered\' = \'true\'';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        //UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        //UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', '');
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data = vm.parsePostgresData(res.data);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                                if (vm.selectedEcuObj && vm.selectedEcuObj.id) {
                                    if (obj.id === vm.selectedEcuObj.id) {
                                        obj.isCheck = true;
                                    }
                                }
                            });
                            vm.ecuResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                vm.totalItems = vm.ecuResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }
                            vm.ecusArr = vm.ecuResponse.data;
                            vm.isECURefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;
                            $timeout(function () {
                                vm.fnSetECUTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isECURefresh = false;
                            $timeout(function () {
                                vm.fnSetECUTableHeight();
                            })
                        })
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnECUCheckUncheckHeader = function (ecuObj) {
                    angular.forEach(vm.ecusArr, function (obj) {
                        if (ecuObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindEcu = _.find(vm.ecusArr, function (ecusObj) {
                        return ecusObj.isCheck === true;
                    });
                    if (isFindEcu) {
                        vm.selectedEcuObj = _.cloneDeepWith(isFindEcu);
                    } else {
                        vm.selectedEcuObj = {};
                    }
                };

                vm.isEcuObjSelected = function () {
                    return !!vm.selectedEcuObj && Object.keys(vm.selectedEcuObj).length;
                };

                vm.fnECUPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isEcusLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE data->>\'" + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\'" : " WHERE data->>\'registered\' = \'true\'";
                            }
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE data->>\'" + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE data->>\'' + vm.ecuSqlQuery.trim() + "\' and data->>\'registered\' = \'true\'" : " WHERE data->>\'registered\' = \'true\'";
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.ecuSqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>\'registered\' = \'true\' and data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnECUReload = function () {
                    vm.isInitEcu = true;
                    vm.isECURefresh = true;
                    vm.isECURefreshData = false;
                    $timeout(function () {
                        vm.isECURefreshData = true;
                    }, 10)
                };

                vm.fnCheckECUHasNode = function (step) {
                    vm.isEcuNodeGetting = true;
                    var ecuNodeSQL = "select * from node_nodes where data->>\'ecuId\' = '" + vm.selectedEcuObj.id + "';"
                    QueryFactory.executeQuery({sql: ecuNodeSQL})
                        .then(function (res) {
                            vm.isECUHasNode = !!(res && res.data && res.data.length);
                            vm.isEcuNodeGetting = false;
                            if (vm.isECUHasNode) {
                                vm.fnGotoNextStep(step);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isECUHasNode = true;
                            vm.isEcuNodeGetting = false;
                        });
                };

                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                vm.selectedProject = {};
                vm.selectedProjectId = '';

                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }
                    }
                    vm.fnUpdateIssueProject(true);
                };

                vm.fnUpdateIssueProject = function (notClose) {
                    if (vm.deleteProjectsArr.length) {
                        vm.selectedProjectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        vm.selectedProjectId = vm.selectedProject.id;
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    if (angular.isUndefined(notClose)) {
                        vm.changeProjectView = false;
                    }
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                            vm.selectedProjectId = "";
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                vm.fnUpdateECUProject = function () {
                    if (vm.selectedProjectId !== vm.selectedEcuObj.projectId) {
                        vm.isECUProjectUpdating = true;
                        var inputObj = {
                            ecuId: vm.selectedEcuObj.id,
                            projectId: vm.selectedProjectId
                        };
                        NodeEcuFactory.updateEcuProject(inputObj)
                            .then(function () { // Success block
                                vm.selectedEcuObj.projectId = _.cloneDeepWith(vm.selectedProjectId);
                                vm.selectedEcuObj.project = _.find(vm.projectsArr, {id: vm.selectedProjectId});
                                amaran.success("ECU Project Updated Successfully");
                                vm.fnGotoNextStep(7);
                                vm.isECUProjectUpdating = false;
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isECUProjectUpdating = false;
                            })
                    } else {
                        vm.fnGotoNextStep(7);
                    }
                };

                /*ECU: End*/

                /*Job: Start*/
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to register node '" + vm.newNodeObj.name + "'"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.selectedEcuObj.name + "' ECU (" + vm.selectedEcuObj.id + ") to acknowledge the job"
                        })
                        if (vm.selectedEcuObj.connected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.selectedEcuObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.selectedEcuObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(res.data[0].startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job failed and was aborted"
                                    })
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job successfully completed"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "Open"
                                    })
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                /*Job: End*/

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 172);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECULoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 185);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnRegisterNewNode = function () {
                    vm.isNodeRegistering = true;
                    var formValues = _.cloneDeep(vm.model);

                    /*if (formValues.vault_id) {
                        formValues.vault_id = {
                            id: formValues.vault_id,
                            type: "string"
                        };
                    }*/

                    if (formValues.vault_id && formValues.vault_id.id) {
                        formValues.vault_id = formValues.vault_id.id; // Send as a simple string
                    }


                    var input = {
                        ecuId: vm.selectedEcuObj.id,
                        body: {
                            name: vm.newNodeObj.name,
                            description: vm.newNodeObj.description,
                            registration: {
                                iot3: {
                                    iot3: angular.toJson(vm.selectedIoT3FileObj.iot3File).substring(1, -1)
                                },
                                form: {
                                    schema: "",
                                    values: formValues
                                },
                                graph: {
                                    type: "AUTO_COMPLETE",
                                    graph: "string"
                                }
                            }
                        }
                    };

                    NodeFactory.registerNode(input)
                        .then(function (res) {
                            vm.nodeRegisteringObj = _.cloneDeepWith(res);
                            amaran.success("Node registration in progress.");
                            vm.isNodeRegistering = false;
                            vm.fnGotoNextStep(8);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeRegistering = false;
                        });
                };

                vm.fnInit = function () {
                    if (DB.fnGet('cloneNodeSettings')) {
                        swal({
                            title: "Please wait while your data loads...",
                            type: "warning",
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var selectedNodeObj = _.cloneDeepWith(DB.fnGet('cloneNodeSettings'));
                        DB.fnRemove('cloneNodeSettings');
                        vm.fnGetECUInfo(selectedNodeObj)
                    }
                    var vaultSQL = 'SELECT data->>\'id\', data->>\'name\', COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_vaults ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetVaults({sql: vaultSQL}, [], false);
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnGetECUInfo = function (selectedNodeObj) {
                    NodeEcuFactory.describeECU({ecuId: selectedNodeObj.ecuId})
                        .then(function (ecuInfo) {
                            vm.selectedEcuObj = _.cloneDeepWith(ecuInfo);
                            vm.fnGetNodeInfo(selectedNodeObj);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                }

                vm.fnGetNodeInfo = function (selectedNodeObj) {
                    NodeFactory.describeNode({nodeId: selectedNodeObj.id})
                        .then(function (nodeRes) {
                            vm.cloneNodeInformation = _.cloneDeepWith(nodeRes);
                            var res = _.cloneDeepWith(nodeRes.registration.iot3);
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.newNodeObj.name = _.cloneDeepWith(nodeRes.name);
                            vm.newNodeObj.description = _.cloneDeepWith(nodeRes.description);
                            vm.model = _.cloneDeepWith(nodeRes.registration.form.values);
                            $timeout(function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnGotoNextStep(4);
                            }, 1000)

                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                }

                vm.fnOpenIoT3Documentation = function () {
                    $state.go('main.documentations', {selectedId: 'ud3729d5'})
                };

                vm.fnOpenIot3SupportModel = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/iot3Support/iot3Support.html',
                        size: 'md',
                        controller: 'iot3SupportCtrl as iot3Support'
                    });
                };

                vm.fnOpenECUListModel = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/ecuListModal/ecuList.html',
                        size: 'lg',
                        controller: 'ecuListCtrl as ecuList',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }

                vm.fnOpenCreatedNode = function (nodeInfo) {
                    $scope.$emit('openNodeDetail', nodeInfo);
                }

                vm.fnGetVaults = function (inputObj, preDefinedVaults, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var vaults = isCalledForViz ? preDefinedVaults : [];
                            _.forEach(res.data, function (projectObj) {
                                vaults.push(projectObj);
                            });
                            if (vaults[0] && vaults[0].totalItems > vaults.length) {
                                var sqlString = 'SELECT data->>\'id\', data->>\'name\', data->>\'_id\' AS rt FROM access_vaults';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + vaults[vaults.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetVaults({sql: sqlString}, vaults, true);
                            } else {
                                vm.vaultsArr = _.cloneDeepWith(vaults);
                                vm.vaultsArr = _.sortBy(vm.vaultsArr, ['name']);
                            }
                        }, function () { // Error block
                        })
                }

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 8) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createNodeCtrl',
            function ($rootScope, $scope, $timeout, $window, $uibModal, $state, $stateParams, swal, TypeFormService, NodeEcuFactory, NodeFactory, ColorService, PaginationQueryService, AppInitService, UserProfileService, jsyaml, NodeIoT3Factory, Iot3WorkbenchFactory, amaran, DB, moment, QueryFactory, microSpinner, $log) {
                var vm = this;

                /* Step 1: Register Home Page
                * Step 2: List IoT3 files
                * Step 3: IoT3 file summary.
                * Step 4: IoT3 file config summary and option to open the ECU list.
                * Step 5: ECU list page.
                * Seep 6: ECU project change page. (If ECU currently has zero nodes registered)
                * Step 7: Node Registration summary.
                * Step 8: Node Registration process terminal.
                */

                vm.totalSteps = 8;
                vm.activeStep = 1;
                vm.newNodeObj = {
                    name: "",
                    description: "",
                    registration: {
                        iot3: {
                            iot3: ""
                        },
                        form: {
                            schema: {},
                            values: {}
                        },
                        graph: {
                            type: "AUTO_COMPLETE",
                            graph: "string"
                        }
                    }
                };
                vm.isNodeRegistering = false;
                vm.nodeRegisteringObj = {};
                vm.jobAPITimeout = '';
                vm.cloneNodeInformation = {};
                vm.isIoT3References = true;
                vm.jobSummaryArr = [];
                vm.vaultsArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                    vm.fnSetDataHeight();
                    if (vm.activeStep === 3 || vm.activeStep === 7) {
                        vm.fnSetTabHeight();
                    }
                    if (vm.activeStep === 5) {
                        vm.fnSetECUTableHeight();
                    }
                    if (vm.activeStep === 3 && vm.selectedTabIndex === 2) {
                        vm.fnSetIot3NodeTableHeight();
                    }
                });

                vm.fnGotoPreviousStep = function () {
                    if (vm.activeStep === 3) {
                        vm.selectedIoT3FileObj = {};
                        vm.activeStep = vm.activeStep - 1;
                    }
                    if (vm.activeStep === 7 && vm.isECUHasNode === true) {
                        vm.activeStep = vm.activeStep - 2;
                    } else {
                        vm.activeStep = vm.activeStep - 1;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnGotoNextStep = function (step) {
                    vm.activeStep = step;
                    if (vm.activeStep === 3) {
                        $timeout(function () {
                            vm.fnSetTabHeight();
                        }, 100);
                    }
                    if (vm.activeStep === 6) {
                        vm.selectedProject = _.find(vm.projectsArr, {id: vm.selectedEcuObj.projectId});
                        vm.selectedProjectId = vm.selectedEcuObj.projectId;
                        vm.fnCheckECUHasNode(7);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createNode-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 4) {
                            var headerHeight = angular.element(".user-header")[0].offsetHeight;
                            angular.element("#step4").css('height', (total - headerHeight - footer) + 'px');
                        }
                        if (vm.activeStep === 8) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tab-node-registration-summary").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnSetDataHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 188 + dashboardHeader + mainFooter);
                        angular.element("#healthTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECUTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.isDefined(angular.element("thead")[0]) ? angular.element("thead")[0].offsetHeight : 36;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 198 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetIot3NodeTableHeight = function () {
                    if (angular.element(".tabContent")[0] && angular.element(".iot3-node-desc")[0] && angular.element(".local-search-bar")[0]) {
                        var total = angular.element(".tabContent")[0].offsetHeight;
                        var nodeDesc = angular.element(".iot3-node-desc")[0].offsetHeight;
                        var searchBar = angular.element(".local-search-bar")[0].offsetHeight;
                        var header = 36;
                        var finalHeight = total - (searchBar + nodeDesc + header + 35);
                        angular.element("#iot3RegisterNodeTableBody").css('height', finalHeight + 'px');
                    }
                };

                $timeout(function () {
                    vm.fnSetTableHeight();
                });

                vm.fnGotoIoTEditor = function () {
                    vm.fnGotoNextStep(3);
                    vm.selectedTabIndex = 3
                };

                vm.fnGotoImportWorkbench = function () {
                    vm.isIoT3References = false;
                    vm.fnGotoNextStep(2);
                    vm.selectedTabIndex = 2
                }

                vm.uploadFiles = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var fileData = fileLoadedEvent.target.result;
                        var testYaml = vm.fnConvertYamlToJson(fileData);
                        if (testYaml === null || angular.isUndefined(testYaml)) {
                            amaran.error('Yaml format is incorrect. Please check it and try again.')
                        } else {
                            vm.selectedIoT3FileObj.iot3File = fileData;

                            $timeout(function () {
                                vm.fnInitCalled();
                            })
                        }
                    };
                    reader.readAsText(filesSelected);
                };

                vm.fnAddDefaultIoT3Filters = function (oemType) {
                    vm.isIoT3References = true;
                    if (oemType !== '') {
                        vm.defaultIoT3FilterArr = [
                            {
                                "id": 391527638,
                                "selectedField": "oem",
                                "displaySelectedField": "OEM",
                                "selectedFilter": {
                                    "operatorName": "=",
                                    "operator": "="
                                },
                                "searchText": oemType,
                                "displaySearchText": oemType
                            }
                        ];
                    } else {
                        vm.defaultIoT3FilterArr = [];
                    }

                    $timeout(function () {
                        vm.fnGotoNextStep(2);
                    });

                };

                /*Node IoT3: Start*/
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.defaultIoT3FilterArr = [];
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.iot3SearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "OEM",
                        name: "oem",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3SortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.defaultIot3SortString = 'name asc';
                vm.iot3FilterQuery = "";
                vm.iot3SqlQuery = "";
                vm.isIoT3RefreshData = true;
                vm.isIoT3Refresh = false;
                vm.iot3JSON = {};
                vm.notDisplayInfo = [
                    'name',
                    'oem',
                    'model',
                    'author',
                    'created',
                    'updated',
                    'versions',
                    'documentation'
                ];
                vm.iot3Summary = [];
                vm.isIoT3DetailLoading = false;
                vm.iot3NodeArr = [];

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);
                                angular.extend(parsedItem, parsedData);

                                // Ensure id and name are available at top level
                                if (!parsedItem.id && parsedData.id) {
                                    parsedItem.id = parsedData.id;
                                }
                                if (!parsedItem.name && parsedData.name) {
                                    parsedItem.name = parsedData.name;
                                }

                                // Handle timestamps
                                ['createdAt', 'updatedAt', 'lastSeenAt'].forEach(function(field) {
                                    if (parsedData[field]) {
                                        parsedItem[field] = parseInt(parsedData[field]);
                                    }
                                });

                                // Handle booleans
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedItem.connected = parsedData.connected === true || parsedData.connected === 'true';
                                }
                                if (angular.isDefined(parsedData.registered)) {
                                    parsedItem.registered = parsedData.registered === true || parsedData.registered === 'true';
                                }

                                // Handle numbers
                                ['health', 'version'].forEach(function(field) {
                                    if (parsedData[field]) {
                                        parsedItem[field] = parseInt(parsedData[field]);
                                    }
                                });

                                // Handle vault content and ensure vault_id is string
                                if (parsedData.content) {
                                    parsedItem.content = angular.isString(parsedData.content) ?
                                        angular.fromJson(parsedData.content) : parsedData.content;
                                    if (parsedItem.content.vault_id) {
                                        parsedItem.content.vault_id = String(parsedItem.content.vault_id);
                                    }
                                }

                                delete parsedItem.data;

                                // Handle button arrays
                                ['versions', 'labels'].forEach(function(field) {
                                    if (angular.isArray(parsedItem[field])) {
                                        parsedItem[field + 'Buttons'] = parsedItem[field].map(function(val) {
                                            return {
                                                text: val,
                                                type: field.slice(0, -1)
                                            };
                                        });
                                    }
                                });

                            } catch (e) {
                                $log.error('Error parsing data field:', e);
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnIOT3FilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3FilterQuery = filterQuery;
                    vm.iot3SqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                        sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3s(input, true);
                };

                vm.fnGetIOT3s = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            // First parse the raw data
                            var parsedData = parsePostgresData(res.data);

                            // Then apply additional transformations
                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetIoT3AbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetIoT3AbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });

                            if (isFirst && parsedData && parsedData.length) {
                                vm.totalItems = parsedData[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                parsedData.reverse();
                            }

                            vm.iot3sArr = _.cloneDeepWith(parsedData);
                            vm.isIoT3Refresh = false;
                            vm.isIOT3sLoading = false;

                            $timeout(function () {
                                vm.fnSetDataHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3sLoading = false;
                            vm.isIoT3RefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            });
                        });
                };

                vm.fnIoT3PageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3sLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_references';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_references';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                            sqlString += vm.iot3SqlQuery && vm.iot3SqlQuery.length ? ' WHERE ' + vm.iot3SqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3s(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3SqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3sArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3s(input, false);
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetIoT3AbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours < 24) {
                        relativeTime = "Today";
                    } else if (differenceHours > 24 && differenceHours < 48) {
                        relativeTime = "Yesterday";
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return {relativeTime: relativeTime, date: moment.unix(timestamp).format("DD/MM/YYYY HH:mm:ss")};
                };

                vm.fnSelectIoT3File = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    vm.iot3Summary = [];
                    NodeIoT3Factory.describeIoT3Reference({iot3Id: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        if (error && Object.keys(error).length) {
                            var errorLine = error.mark.line - 1;
                            vm.goToLine(errorLine);
                        }
                        return false;
                    }
                };

                vm.fnReloadIoT3s = function () {
                    vm.isIoT3RefreshData = false;
                    vm.isIoT3Refresh = true;
                    $timeout(function () {
                        vm.isIoT3RefreshData = true;
                    }, 10)
                };

                /*Node IoT3: End*/

                /*Node IoT3 Workspaces: Start*/
                vm.iot3WorkspacesSearchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.iot3WorkspacesSortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.iot3WorkspacesFilterQuery = "";
                vm.iot3WorkspacesSqlQuery = "";
                vm.isIoT3WorkspacesRefreshData = true;
                vm.isIoT3WorkspacesRefresh = false;

                vm.fnIOT3WorkspacesFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.iot3WorkspacesFilterQuery = filterQuery;
                    vm.iot3WorkspacesSqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery && sortQuery.length) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                        sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIOT3Workspaces(input, true);
                };

                vm.fnGetIOT3Workspaces = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            // First parse the raw data
                            var parsedData = parsePostgresData(res.data);

                            // Then apply additional transformations
                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                            });

                            if (isFirst && parsedData && parsedData.length) {
                                vm.totalItems = parsedData[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                parsedData.reverse();
                            }

                            vm.iot3WorkspacesArr = _.cloneDeepWith(parsedData);
                            vm.isIoT3WorkspacesRefresh = false;
                            vm.isIOT3WorkspacesLoading = false;

                            $timeout(function () {
                                vm.fnSetDataHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIOT3WorkspacesLoading = false;
                            vm.isIoT3WorkspacesRefreshData = false;
                            $timeout(function () {
                                vm.fnSetDataHeight();
                            });
                        });
                };

                vm.fnIoT3WorkspacesPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isIOT3WorkspacesLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_workspaces';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_workspaces';
                            sqlString += vm.iot3WorkspacesSqlQuery && vm.iot3WorkspacesSqlQuery.length ? ' WHERE ' + vm.iot3WorkspacesSqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIOT3Workspaces(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.iot3WorkspacesSqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3WorkspacesArr);
                        vm.previousPage = page;
                        vm.fnGetIOT3Workspaces(input, false);
                    }
                };

                vm.fnSelectIoT3WorkspacesFile = function (iot3Obj, nextStep) {
                    vm.isIoT3DetailLoading = true;
                    //vm.selectedIoT3FileObj = {};
                    vm.fnGotoNextStep(3);
                    vm.selectedIoT3FileObj = _.cloneDeepWith(iot3Obj);
                    vm.iot3Summary = [];
                    Iot3WorkbenchFactory.describeIot3Worbench({workspaceId: iot3Obj.id})
                        .then(function (res) { // Success block
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.isIoT3DetailLoading = false;
                            if (nextStep === 4) {
                                vm.fnGotoNextStep(4);
                            }
                        });
                };

                vm.fnReloadIoT3Workspaces = function () {
                    vm.isIoT3WorkspacesRefreshData = false;
                    vm.isIoT3WorkspacesRefresh = true;
                    $timeout(function () {
                        vm.isIoT3WorkspacesRefreshData = true;
                    }, 10)
                };
                /*Node IoT3 Workspaces: End*/

                /*IoT3 File Summary: Start*/
                vm.selectedIoT3FileObj = {};
                vm.selectedTabIndex = 1;
                vm.iot3Tabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    },
                    {
                        title: 'Nodes',
                        tabIndex: 2
                    },
                    {
                        title: 'IoT3',
                        tabIndex: 3
                    }
                ];
                vm.isChangesSync = true;

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        _cm.on("change", function () {
                            vm.isChangesSync = false;
                            $timeout(function () {
                                vm.fnChangeDone();
                            }, 100);
                        });

                        vm.setLine = function (errors) {
                            _cm.clearGutter('gutter-error');
                            if (errors && Object.keys(errors).length) {
                                var errorLine = errors.mark.line - 1;
                                var marker = document.createElement("div");
                                marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                marker.setAttribute('data-toggle', 'tooltip');
                                marker.setAttribute('data-placement', 'auto');
                                marker.setAttribute('title', errors.reason);
                                _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                            }
                        };

                        vm.goToLine = function (lineNumber) {
                            _cm.setCursor(lineNumber);
                        };
                    }
                };

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = 55;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitCalled = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.modeChanged();
                    }, 100)
                };

                vm.fnInitSecurityRegistration = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 500)
                }

                vm.fnChangeDone = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                    var isValidJson = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File);
                    if (isValidJson !== false) {
                        vm.iot3JSON = isValidJson;
                        vm.iot3Summary = [];
                        vm.iot3NodeArr = [];
                        if ((angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined') && Object.keys(vm.iot3JSON).length) {
                            if (vm.iot3JSON.info.created) {
                                vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                            } else {
                                vm.iot3JSON.info.created = '';
                            }
                            if (vm.iot3JSON.info.updated) {
                                vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                            } else {
                                vm.iot3JSON.info.updated = '';
                            }
                            if (vm.iot3JSON && vm.iot3JSON.iot3) {
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.info) {
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                            }
                            if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                    var tempObj = typeValue;
                                    tempObj.type = typeKey;
                                    vm.iot3NodeArr.push(tempObj)
                                });
                            }
                        }
                        vm.isChangesSync = true;
                        $timeout(function () {
                            vm.setLine();
                        });
                    } else {
                        vm.isChangesSync = false;
                        //amaran.error('YAML format is not valid.');
                    }
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                    }, 100)
                };

                vm.fnTabSelected = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                        if (vm.selectedTabIndex === 3) {
                            vm.isChangesSync = vm.fnConvertYamlToJson(vm.selectedIoT3FileObj.iot3File) !== false;
                        }
                        if (vm.selectedTabIndex === 2) {
                            vm.fnSetIot3NodeTableHeight();
                        }
                    }, 100)
                };

                vm.fnViewAttributes = function (iot3NodeObj) {
                    var attributes = _.filter(vm.iot3JSON.template.attributes, function (value, key) {
                        value.reference = key;
                        return iot3NodeObj.attributes.includes(key);
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/viewAttributes/viewAttributes.html',
                        size: 'lg',
                        controller: 'viewAttributesCtrl as viewAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedNode: function () {
                                return _.cloneDeepWith(iot3NodeObj);
                            },
                            attributesArr: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.isValidateIoT3File = function () {
                    return !!(vm.isChangesSync && vm.iot3JSON && angular.isDefined(vm.iot3JSON) && vm.iot3JSON !== 'undefined' && Object.keys(vm.iot3JSON).length);
                    //return !!vm.selectedEcuObj && Object.keys(vm.selectedEcuObj).length;
                };

                /*IoT3 File Summary: End*/

                /*IoT3 Security Registration: Start*/
                vm.isLoading = true;
                vm.model = {};
                vm.schema = {};
                vm.form = [];
                vm.isIoT3FormValid = false;
                vm.fnSecurityRegistrationInit = function () {
                    vm.isLoading = true;
                    if (vm.iot3JSON && vm.iot3JSON.registration && vm.iot3JSON.registration.form && vm.iot3JSON.registration.form.properties) {
                        var tempData = TypeFormService.fnGenerateFormData(vm.iot3JSON.registration.form);
                        var isFindVault = _.find(tempData.form, function (formObj) {
                            return formObj.key === 'vault_id';
                        })
                        if (isFindVault) {
                            isFindVault.titleMap = _.map(vm.vaultsArr, function (vaultObj) {
                                return {name: vaultObj.name, id: vaultObj.id};
                            })
                            isFindVault.type = "vaultInputDropdown";
                        }
                        vm.schema = tempData.schema;
                        vm.form = tempData.form;
                        var tempModelData = _.cloneDeepWith(vm.model);
                        vm.model = {};
                        if (Object.keys(tempModelData).length) {
                            _.forEach(vm.schema.properties, function (value, key) {
                                if (value.type === 'object') {
                                    _.forEach(value.properties, function (objValue, objKey) {
                                        if (tempModelData[key] && tempModelData[key][objKey]) {
                                            if (vm.model[key]) {
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            } else {
                                                vm.model[key] = {};
                                                vm.model[key][objKey] = tempModelData[key][objKey];
                                            }
                                        }
                                    })
                                } else {
                                    if (tempModelData[key]) {
                                        vm.model[key] = tempModelData[key];
                                    }
                                }
                            });
                        }
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    } else {
                        $timeout(function () {
                            vm.isLoading = false;
                        }, 200)
                    }
                };

                vm.fnCheckIot3Validation = function (value) {
                    vm.isIoT3FormValid = value;
                    return value;
                };
                /*IoT3 Security Registration: End*/

                /*ECU: Start*/
                vm.isProjectLoaded = false;
                vm.projectsArr = [];
                vm.isInitEcu = true;
                vm.isECURefresh = false;
                vm.isECURefreshData = true;
                vm.selectedEcuObj = {};
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};
                vm.searchECUFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Phase",
                        name: "phase",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->\'connected\' = \'false\' or data->\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortECUFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.ecuFilterQuery = "";
                vm.ecuSqlQuery = "";
                vm.isColumnView = true;
                vm.isECUHasNode = true;
                vm.isECUProjectUpdating = false;

                vm.fnECUFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.ecuFilterQuery = filterQuery;
                    vm.ecuSqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    vm.currentPage = 1;
                    if (sortQuery) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEcusLoading = true;
                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>'_id' AS rt FROM node_projects ORDER BY rt asc LIMIT 100;";
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE " + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "' and data->'registered' = 'true'";
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? '  WHERE ' + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->'registered' = 'true'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + ' and data->\'registered\' = \'true\' ' : ' WHERE data->\'registered\' = \'true\'';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + ' and data->\'registered\' = \'true\' ' : ' WHERE data->\'registered\' = \'true\'';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectEcu = function (projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE " + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->\'registered\' = 'true'";
                        } else {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + 'and data->\'registered\' = \'true\'' : 'WHERE data->\'registered\' = \'true\'';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE " + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "' and data->\'registered\' = 'true' ";
                        } else {
                            sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + 'and data->\'registered\' = \'true\'' : 'WHERE data->\'registered\' = \'true\'';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        //UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        //UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', '');
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                                if (vm.selectedEcuObj && vm.selectedEcuObj.id) {
                                    if (obj.id === vm.selectedEcuObj.id) {
                                        obj.isCheck = true;
                                    }
                                }
                            });
                            vm.ecuResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                vm.totalItems = vm.ecuResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }
                            vm.ecusArr = vm.ecuResponse.data;
                            vm.isECURefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;
                            $timeout(function () {
                                vm.fnSetECUTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isECURefresh = false;
                            $timeout(function () {
                                vm.fnSetECUTableHeight();
                            })
                        })
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnECUCheckUncheckHeader = function (ecuObj) {
                    angular.forEach(vm.ecusArr, function (obj) {
                        if (ecuObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindEcu = _.find(vm.ecusArr, function (ecusObj) {
                        return ecusObj.isCheck === true;
                    });
                    if (isFindEcu) {
                        vm.selectedEcuObj = _.cloneDeepWith(isFindEcu);
                    } else {
                        vm.selectedEcuObj = {};
                    }
                };

                vm.isEcuObjSelected = function () {
                    return !!vm.selectedEcuObj && Object.keys(vm.selectedEcuObj).length;
                };

                vm.fnECUPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isEcusLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE " + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true'" : " WHERE data->\'registered\' = 'true'";
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? " WHERE " + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.ecuSqlQuery && vm.ecuSqlQuery.length ? ' WHERE ' + vm.ecuSqlQuery.trim() + " and data->\'registered\' = 'true'" : " WHERE data->\'registered\' = 'true'";
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.ecuSqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->\'registered\' = 'true' and data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnECUReload = function () {
                    vm.isInitEcu = true;
                    vm.isECURefresh = true;
                    vm.isECURefreshData = false;
                    $timeout(function () {
                        vm.isECURefreshData = true;
                    }, 10)
                };

                vm.fnCheckECUHasNode = function (step) {
                    vm.isEcuNodeGetting = true;
                    var ecuNodeSQL = "select * from node_nodes where data->>\'ecuId\' = '" + vm.selectedEcuObj.id + "';"
                    QueryFactory.executeQuery({sql: ecuNodeSQL})
                        .then(function (res) {
                            vm.isECUHasNode = !!(res && res.data && res.data.length);
                            vm.isEcuNodeGetting = false;
                            if (vm.isECUHasNode) {
                                vm.fnGotoNextStep(step);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isECUHasNode = true;
                            vm.isEcuNodeGetting = false;
                        });
                };

                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                vm.selectedProject = {};
                vm.selectedProjectId = '';

                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }
                    }
                    vm.fnUpdateIssueProject(true);
                };

                vm.fnUpdateIssueProject = function (notClose) {
                    if (vm.deleteProjectsArr.length) {
                        vm.selectedProjectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        vm.selectedProjectId = vm.selectedProject.id;
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        //vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    if (angular.isUndefined(notClose)) {
                        vm.changeProjectView = false;
                    }
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                            vm.selectedProjectId = "";
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                vm.fnUpdateECUProject = function () {
                    if (vm.selectedProjectId !== vm.selectedEcuObj.projectId) {
                        vm.isECUProjectUpdating = true;
                        var inputObj = {
                            ecuId: vm.selectedEcuObj.id,
                            projectId: vm.selectedProjectId
                        };
                        NodeEcuFactory.updateEcuProject(inputObj)
                            .then(function () { // Success block
                                vm.selectedEcuObj.projectId = _.cloneDeepWith(vm.selectedProjectId);
                                vm.selectedEcuObj.project = _.find(vm.projectsArr, {id: vm.selectedProjectId});
                                amaran.success("ECU Project Updated Successfully");
                                vm.fnGotoNextStep(7);
                                vm.isECUProjectUpdating = false;
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isECUProjectUpdating = false;
                            })
                    } else {
                        vm.fnGotoNextStep(7);
                    }
                };

                /*ECU: End*/

                /*Job: Start*/
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobEditorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    mode: 'text/plain',
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.jobModeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                    }
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to register node '" + vm.newNodeObj.name + "'"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.selectedEcuObj.name + "' ECU (" + vm.selectedEcuObj.id + ") to acknowledge the job"
                        })
                        if (vm.selectedEcuObj.connected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        } else {
                            vm.fnGetPendingJob();
                        }
                    }, 100)
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.selectedEcuObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.selectedEcuObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.nodeRegisteringObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(res.data[0].startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job failed and was aborted"
                                    })
                                }
                                if (res.data[0].jobResult === 'SUCCESS') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job successfully completed"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "Open"
                                    })
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                /*Job: End*/

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 172);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetECULoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 185);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnRegisterNewNode = function () {
                    vm.isNodeRegistering = true;

                    if (vm.newNodeObj && vm.newNodeObj.registration && vm.newNodeObj.registration.form) {
                        vm.newNodeObj.registration.form.values = parsePostgresData([vm.newNodeObj.registration.form.values])[0];
                    }

                    var input = {
                        ecuId: vm.selectedEcuObj.id,
                        body: {}
                    };
                    input.body = _.cloneDeepWith(vm.newNodeObj);
                    var tempIoT3File = _.cloneDeepWith(angular.toJson(vm.selectedIoT3FileObj.iot3File));
                    input.body.registration.iot3.iot3 = tempIoT3File.substring(1, tempIoT3File.length - 1);
                    input.body.registration.form.schema = "";
                    input.body.registration.form.values = angular.fromJson(angular.toJson(vm.model));
                    if (input.body.registration.form.values.vault_id) {
                        input.body.registration.form.values.vault_id = String(input.body.registration.form.values.vault_id);
                    }
                    NodeFactory.registerNode(input)
                        .then(function (res) {
                            vm.nodeRegisteringObj = _.cloneDeepWith(res);
                            amaran.success("Node registration in progress.");
                            vm.isNodeRegistering = false;
                            vm.fnGotoNextStep(8);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodeRegistering = false;
                        })
                };

                vm.fnInit = function () {
                    if (DB.fnGet('cloneNodeSettings')) {
                        swal({
                            title: "Please wait while your data loads...",
                            type: "warning",
                            showConfirmButton: true,
                            showLoaderOnConfirm: true
                        });
                        angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                        angular.element(".confirm").css("visibility", "hidden");
                        var selectedNodeObj = _.cloneDeepWith(DB.fnGet('cloneNodeSettings'));
                        DB.fnRemove('cloneNodeSettings');
                        vm.fnGetECUInfo(selectedNodeObj)
                    }
                    //var vaultSQL = 'SELECT data->>\'id\' as id, data->>\'name\' as name, COUNT(*) OVER() as totalItems , data->>\'id\' AS rt FROM access_vaults ORDER BY rt asc LIMIT ' + 100 + ';';
                    var vaultSQL = 'SELECT data->>\'id\' as id, data->>\'name\' as name FROM access_vaults ORDER BY id;';
                    vm.fnGetVaults({sql: vaultSQL}, [], false);
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnGetECUInfo = function (selectedNodeObj) {
                    NodeEcuFactory.describeECU({ecuId: selectedNodeObj.ecuId})
                        .then(function (ecuInfo) {
                            vm.selectedEcuObj = _.cloneDeepWith(ecuInfo);
                            vm.fnGetNodeInfo(selectedNodeObj);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                }

                vm.fnGetNodeInfo = function (selectedNodeObj) {
                    NodeFactory.describeNode({nodeId: selectedNodeObj.id})
                        .then(function (nodeRes) {
                            vm.cloneNodeInformation = _.cloneDeepWith(nodeRes);
                            var res = _.cloneDeepWith(nodeRes.registration.iot3);
                            if (res.createdAt) {
                                res.createdDate = vm.fnGetAbsoluteOrRelativeTime(res.createdAt);
                            }
                            if (res.updatedAt) {
                                res.updatedDate = vm.fnGetAbsoluteOrRelativeTime(res.updatedAt);
                            }
                            var tempIOT3String = '';
                            try {
                                tempIOT3String = _.cloneDeepWith(angular.fromJson(res.iot3));
                            } catch (error) {
                                tempIOT3String = _.cloneDeepWith(res.iot3);
                            }
                            res.iot3File = _.cloneDeepWith(tempIOT3String);
                            vm.resetIoT3File = _.cloneDeepWith(tempIOT3String);
                            vm.isChangesSync = true;
                            vm.iot3JSON = vm.fnConvertYamlToJson(res.iot3File);
                            if (Object.keys(vm.iot3JSON).length) {
                                if (vm.iot3JSON.info.created) {
                                    vm.iot3JSON.info.created = vm.iot3JSON.info.created.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.created = '';
                                }
                                if (vm.iot3JSON.info.updated) {
                                    vm.iot3JSON.info.updated = vm.iot3JSON.info.updated.split('T')[0];
                                } else {
                                    vm.iot3JSON.info.updated = '';
                                }
                                vm.iot3Summary.push({
                                    key: 'IOT3 SPEC',
                                    value: vm.iot3JSON.iot3,
                                    valueType: typeof vm.iot3JSON.iot3
                                });
                                _.forEach(vm.iot3JSON.info, function (iot3InfoValue, iot3InfoKey) {
                                    if (!vm.notDisplayInfo.includes(iot3InfoKey)) {
                                        vm.iot3Summary.push(
                                            {
                                                key: iot3InfoKey,
                                                value: iot3InfoValue,
                                                valueType: typeof iot3InfoValue
                                            }
                                        )
                                    }
                                });
                                vm.iot3NodeArr = [];
                                if (vm.iot3JSON && vm.iot3JSON.template && vm.iot3JSON.template.types) {
                                    _.forEach(vm.iot3JSON.template.types, function (typeValue, typeKey) {
                                        var tempObj = typeValue;
                                        tempObj.type = typeKey;
                                        vm.iot3NodeArr.push(tempObj)
                                    });
                                }
                                vm.selectedIoT3FileObj = _.cloneDeepWith(res);
                            } else {
                                vm.selectedIoT3FileObj = {};
                            }
                            vm.newNodeObj.name = _.cloneDeepWith(nodeRes.name);
                            vm.newNodeObj.description = _.cloneDeepWith(nodeRes.description);
                            vm.model = _.cloneDeepWith(nodeRes.registration.form.values);
                            $timeout(function () {
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnGotoNextStep(4);
                            }, 1000)

                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                }

                vm.fnOpenIoT3Documentation = function () {
                    $state.go('main.documentations', {selectedId: 'ud3729d5'})
                };

                vm.fnOpenIot3SupportModel = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/iot3Support/iot3Support.html',
                        size: 'md',
                        controller: 'iot3SupportCtrl as iot3Support'
                    });
                };

                vm.fnOpenECUListModel = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/ecuListModal/ecuList.html',
                        size: 'lg',
                        controller: 'ecuListCtrl as ecuList',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }

                vm.fnOpenCreatedNode = function (nodeInfo) {
                    $scope.$emit('openNodeDetail', nodeInfo);
                }

                vm.fnGetVaults = function (inputObj, preDefinedVaults, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var vaults = isCalledForViz ? preDefinedVaults : [];
                            _.forEach(res.data, function (projectObj) {
                                vaults.push(projectObj);
                            });
                            if (vaults[0] && vaults[0].totalItems > vaults.length) {
                                var sqlString = 'SELECT data->>\'id\', data->>\'name\', data->>\'_id\' AS rt FROM access_vaults';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + vaults[vaults.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetVaults({sql: sqlString}, vaults, true);
                            } else {
                                vm.vaultsArr = _.cloneDeepWith(vaults);
                                vm.vaultsArr = _.sortBy(vm.vaultsArr, ['name']);
                            }
                        }, function () { // Error block
                        })
                }

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 8) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('iot3WorkbenchCtrl',
            function ($scope, $window, $timeout, $base64, DB, jsyaml, moment, amaran, swal, FileSaver,
                      Blob, Iot3WorkbenchFactory) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.workspaceUpdating = false;
                vm.currentIot3Worspace = {
                    name : "",
                    description: "",
                    yamlString: "",
                    isScratch: true
                };
                vm.resetCurrentIot3Workspace = _.cloneDeepWith(vm.currentIot3Worspace);
                vm.sideTabs = [
                    {
                        title: 'Dashboard',
                        tabIndex: 1
                    },
                    {
                        title: 'Info',
                        tabIndex: 2
                    },
                    {
                        title: 'Registration',
                        tabIndex: 3
                    },
                    {
                        title: 'Engine',
                        tabIndex: 4
                    },
                    {
                        title: 'Global',
                        tabIndex: 5
                    },
                    {
                        title: 'Authentication',
                        tabIndex: 6
                    },
                    {
                        title: 'Topology',
                        tabIndex: 7
                    },
                    {
                        title: 'Types',
                        tabIndex: 8
                    },
                    {
                        title: 'Attributes',
                        tabIndex: 9
                    },
                    {
                        title: 'Mappers',
                        tabIndex: 10
                    },
                    {
                        title: 'IoT3',
                        tabIndex: 11
                    }
                ];
                vm.sideActiveTabIndex = vm.sideTabs[0];

                vm.iot3JSON = {
                    iot3: "0.10.1",
                    info: {
                        name: '',
                        oem: '',
                        model: '',
                        versions: [],
                        description: '',
                        stage: '',
                        author: DB.fnGet('loginUser').email,
                        revision: 1,
                        created: moment().format('YYYY-MM-DD'),
                        updated: moment().format('YYYY-MM-DD'),
                        labels: []
                    },
                    global: {},
                    registration: {
                        vaultId: '',
                        fingerprint: [],
                        vault: {},
                        form: {}
                    },
                    engine: {
                        tunnel: {
                            ssh: {
                                supported: false,
                                displayInstructions: {}
                            },
                            http: {
                                supported: false,
                                displayInstructions: {}
                            }
                        }
                    },
                    auth: {},
                    template: {
                        types: {},
                        attributes: {},
                        filters: {
                            mappers: {}
                        }
                    }
                };
                vm.resetIot3Json = _.cloneDeepWith(vm.iot3JSON);
                vm.isIot3FileLoaded = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        //vm.fnSetTableHeight();
                    });
                });

                vm.fnChangeSideTab = function (tab) {
                    vm.sideActiveTabIndex = _.cloneDeepWith(tab);
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    }
                    catch (error) {
                        vm.setLine(_.cloneDeepWith(error));
                        return false;
                    }
                };

                vm.fnReverseUpdateIot3 = function (yamlStr) {
                    vm.iot3JSON = vm.fnConvertYamlToJson(yamlStr);
                    vm.fnSaveCurrentYamlString(yamlStr);
                };

                vm.fnUpdateCurrentWorkbench = function (updateType, updateValue) {
                    if (updateType === 'info') {
                        vm.iot3JSON.info = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'global') {
                        vm.iot3JSON.global = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'registration') {
                        vm.iot3JSON.registration = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'engine') {
                        vm.iot3JSON.engine = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'authentication') {
                        vm.iot3JSON.auth = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'type') {
                        vm.iot3JSON.template.types = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'topology') {
                        vm.iot3JSON.topology = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'mapping') {
                        vm.iot3JSON.template.filters.mappers = _.cloneDeepWith(updateValue);
                    } else if (updateType === 'templateAttribute') {
                        vm.iot3JSON.template.attributes = _.cloneDeepWith(updateValue);
                    }
                    vm.fnSaveCurrentYamlString(jsyaml.dump(vm.iot3JSON, {lineWidth: -1}));
                };

                vm.fnSaveCurrentYamlString = function (yamlString) {
                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        workbench.currentWorkbench = {
                            id: vm.currentIot3Worspace.id ? vm.currentIot3Worspace.id : '',
                            name: vm.currentIot3Worspace.name,
                            description: vm.currentIot3Worspace.description,
                            isScratch: vm.currentIot3Worspace.isScratch,
                            yamlString: $base64.encode(yamlString)
                        };
                        DB.fnSet('iot3Workbench', workbench);
                    } else {
                        DB.fnSet('iot3Workbench', {currentWorkbench :{
                                id: vm.currentIot3Worspace.id ? vm.currentIot3Worspace.id : '',
                                name: vm.currentIot3Worspace.name,
                                description: vm.currentIot3Worspace.description,
                                isScratch: vm.currentIot3Worspace.isScratch,
                                yamlString: $base64.encode(yamlString)
                            }})
                    }
                };

                vm.fnUpdateGlobalVarFromAttr = function (valueObj) {
                    _.set(vm.iot3JSON.global, valueObj.key, valueObj.value);
                    vm.fnUpdateCurrentWorkbench('global', vm.iot3JSON.global);
                };

                vm.fnDownloadIot3File = function () {
                    var data = new Blob([jsyaml.dump(vm.iot3JSON, {lineWidth: -1})], { type: 'application/json' });
                    FileSaver.saveAs(data, vm.currentIot3Worspace.name + '_iot3_' + moment().unix() + '.iot3');
                };

                vm.fnDownloadWorkbench = function () {
                    var workbench = {};
                    if (DB.fnGet('iot3Workbench')) {
                        workbench = DB.fnGet('iot3Workbench');
                        var data = new Blob([angular.toJson(workbench, true)], { type: 'application/json' });
                        FileSaver.saveAs(data, vm.currentIot3Worspace.name + '_' + moment().unix() + '.iot3Wb');
                    }
                };

                vm.fnCreateScratchIot = function (detailsObj) {
                    vm.iot3JSON = _.cloneDeepWith(vm.resetIot3Json);
                    var yamlString = jsyaml.dump(vm.iot3JSON, {lineWidth: -1});
                    vm.currentIot3Worspace.name = detailsObj.name;
                    vm.currentIot3Worspace.description = detailsObj.description;
                    vm.currentIot3Worspace.isScratch = true;
                    vm.fnSaveCurrentYamlString(yamlString);
                    $timeout(function () {
                        if (detailsObj.metadata && DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            workbench.currentWorkspaceSampleData = {};
                            workbench.currentWorkspaceEngineSampleData = {};
                            DB.fnSet('iot3Workbench', workbench)
                        }
                    });
                    vm.isIot3FileLoaded = true;
                };

                vm.fnImportWorkbenchDetails = function (fileData) {
                    var wbJson = angular.fromJson(fileData);

                    vm.iot3JSON = vm.fnConvertYamlToJson($base64.decode(wbJson.currentWorkbench.yamlString));
                    vm.currentIot3Worspace.name = wbJson.currentWorkbench.name;
                    vm.currentIot3Worspace.description = wbJson.currentWorkbench.description;
                    vm.currentIot3Worspace.isScratch = wbJson.currentWorkbench.name.isScratch;
                    vm.fnSaveCurrentYamlString($base64.decode(wbJson.currentWorkbench.yamlString));
                    $timeout(function () {
                        if (DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            if (wbJson.currentWorkspaceSampleData) {
                                workbench.currentWorkspaceSampleData = wbJson.currentWorkspaceSampleData;
                            } else {
                                workbench.currentWorkspaceSampleData = {};
                            }

                            if (wbJson.currentWorkspaceEngineSampleData) {
                                workbench.currentWorkspaceEngineSampleData = wbJson.currentWorkspaceEngineSampleData;
                            } else {
                                workbench.currentWorkspaceEngineSampleData = {};
                            }
                            DB.fnSet('iot3Workbench', workbench)
                        }
                    });
                    vm.isIot3FileLoaded = true;
                };

                vm.fnCreateFromImport = function (detailsObj, fileData) {
                    vm.currentIot3Worspace.name = detailsObj.name;
                    vm.currentIot3Worspace.description = detailsObj.description;
                    vm.currentIot3Worspace.isScratch = true;
                    var testYaml = jsyaml.load(fileData);
                    if (testYaml === null ||  angular.isUndefined(testYaml)) {
                        vm.iot3JSON = _.cloneDeepWith(vm.resetIot3Json);
                        var yamlString = jsyaml.dump(vm.iot3JSON, {lineWidth: -1});
                        vm.fnSaveCurrentYamlString(yamlString);
                    } else {
                        vm.iot3JSON = vm.fnConvertYamlToJson(fileData);
                        vm.fnSaveCurrentYamlString(fileData);
                    }
                    $timeout(function () {
                        if (detailsObj.metadata && DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            workbench.currentWorkspaceSampleData = {};
                            DB.fnSet('iot3Workbench', workbench)
                        }
                    });
                    vm.isIot3FileLoaded = true;
                };

                vm.fnCreateIot3WorkspaceFromExisting = function (isScratch, detailsObj) { //isScratch, detailsObj
                    vm.currentIot3Worspace.id = detailsObj.id;
                    vm.currentIot3Worspace.name = detailsObj.name;
                    vm.currentIot3Worspace.description = detailsObj.description;
                    vm.currentIot3Worspace.isScratch = isScratch;
                    var testYaml = jsyaml.load(detailsObj.iot3);
                    if (testYaml === null ||  angular.isUndefined(testYaml)) {
                        vm.iot3JSON = _.cloneDeepWith(vm.resetIot3Json);
                        var yamlString = jsyaml.dump(vm.iot3JSON, {lineWidth: -1});
                        vm.fnSaveCurrentYamlString(yamlString);
                    } else {
                        vm.iot3JSON = vm.fnConvertYamlToJson(detailsObj.iot3);
                        vm.fnSaveCurrentYamlString(detailsObj.iot3);
                    }
                    $timeout(function () {
                        if (detailsObj.metadata && DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            workbench.currentWorkspaceSampleData = detailsObj.metadata.currentWorkspaceSampleData ?
                                detailsObj.metadata.currentWorkspaceSampleData : detailsObj.metadata;
                            workbench.currentWorkspaceEngineSampleData = detailsObj.metadata.currentWorkspaceEngineSampleData ?
                                detailsObj.metadata.currentWorkspaceEngineSampleData : {};
                            DB.fnSet('iot3Workbench', workbench)
                        }
                    });
                    vm.isIot3FileLoaded = true;
                };

                vm.fnEditWorkspaceDetails = function (workspaceObj) {
                    vm.currentIot3Worspace.name = workspaceObj.name;
                    vm.currentIot3Worspace.description = workspaceObj.description;

                    if (DB.fnGet('iot3Workbench')) {
                        var workbench = DB.fnGet('iot3Workbench');
                        workbench.currentWorkbench.name =  vm.currentIot3Worspace.name;
                        workbench.currentWorkbench.description = vm.currentIot3Worspace.description;
                        DB.fnSet('iot3Workbench', workbench);
                    }
                };

                vm.fnResetWorkspace = function () {
                    swal({
                            title: "Close Workbench?",
                            text: "Please make sure all the unsaved changes are saved before closing the workspace.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Close",
                            closeOnConfirm: true,
                            showLoaderOnConfirm: false
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                DB.fnRemove('iot3Workbench');
                                vm.isIot3FileLoaded = false;
                                vm.sideActiveTabIndex = vm.sideTabs[0];
                                vm.iot3JSON = _.cloneDeepWith(vm.resetIot3Json);
                                vm.currentIot3Worspace = _.cloneDeepWith(vm.resetCurrentIot3Workspace);
                                swal.close();
                                angular.element($window).triggerHandler('resize');
                            }
                        });
                };

                vm.fnCreateIot3WorkspaceToCloud = function () {
                    vm.fnChangeSideTab(vm.sideTabs[vm.sideTabs.length - 1]);
                    $timeout(function () {
                        vm.workspaceUpdating = true;
                        var metadata = {};
                        if (DB.fnGet('iot3Workbench')) {
                            var workbench = DB.fnGet('iot3Workbench');
                            if (workbench.currentWorkspaceSampleData &&
                                Object.keys(workbench.currentWorkspaceSampleData).length) {
                                metadata.currentWorkspaceSampleData = workbench.currentWorkspaceSampleData;
                            } else {
                                metadata.currentWorkspaceSampleData = {};
                            }

                            if (workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {
                                metadata.currentWorkspaceEngineSampleData = workbench.currentWorkspaceEngineSampleData
                            } else {
                                metadata.currentWorkspaceEngineSampleData = {};
                            }
                        }
                        var inputObj = {
                            body: {
                                name: vm.currentIot3Worspace.name,
                                description: vm.currentIot3Worspace.description,
                                iot3: jsyaml.dump(vm.iot3JSON, {lineWidth: -1}),
                                metadata: metadata
                            }
                        };

                        Iot3WorkbenchFactory.createIot3Workbench(inputObj)
                            .then(function (res) {
                                vm.workspaceUpdating = false;
                                amaran.success('Iot3 Workspace created successfully');
                                vm.currentIot3Worspace.id = res.id;
                                vm.currentIot3Worspace.isScratch = false;
                            }, function () {
                                vm.workspaceUpdating = false;
                            })
                    })
                };

                vm.fnUpdateIot3WorkspaceToCloud = function () {
                    vm.fnChangeSideTab(vm.sideTabs[vm.sideTabs.length - 1]);
                    $timeout(function () {
                        vm.workspaceUpdating = true;
                        var metadata = {};
                        var workbench = DB.fnGet('iot3Workbench');
                        if (workbench) {
                            if (workbench.currentWorkspaceSampleData &&
                                Object.keys(workbench.currentWorkspaceSampleData).length) {
                                metadata.currentWorkspaceSampleData = workbench.currentWorkspaceSampleData;
                            } else {
                                metadata.currentWorkspaceSampleData = {};
                            }

                            if (workbench.currentWorkspaceEngineSampleData &&
                                Object.keys(workbench.currentWorkspaceEngineSampleData).length) {
                                metadata.currentWorkspaceEngineSampleData = workbench.currentWorkspaceEngineSampleData
                            } else {
                                metadata.currentWorkspaceEngineSampleData = {};
                            }
                        }
                        var inputObj = {
                            workspaceId: '',
                            body: {
                                name: vm.currentIot3Worspace.name,
                                description: vm.currentIot3Worspace.description,
                                iot3: jsyaml.dump(vm.iot3JSON, {lineWidth: -1}),
                                metadata: metadata
                            }
                        };

                        if (vm.currentIot3Worspace && vm.currentIot3Worspace.id && vm.currentIot3Worspace.id.length) {
                            inputObj.workspaceId = vm.currentIot3Worspace.id;
                        } else if (workbench && workbench.currentWorkbench && workbench.currentWorkbench.id) {
                            inputObj.workspaceId = workbench.currentWorkbench.id;
                        }

                        if (inputObj.workspaceId && inputObj.workspaceId.length) {
                            Iot3WorkbenchFactory.updateIot3Worbench(inputObj)
                            .then(function () {
                                vm.workspaceUpdating = false;
                                amaran.success('Iot3 Workspace updated successfully');
                                //vm.currentIot3Worspace.id = res.id;
                                vm.currentIot3Worspace.isScratch = false;
                            }, function () {
                                vm.workspaceUpdating = false;
                            })
                        } else {
                            amaran.error('Iot3 Workspace ID was not found');
                            vm.workspaceUpdating = false;
                        }
                    });
                };

                vm.fnInitIot3Workbench = function () {
                    // DB.fnRemove('iot3Workbench');
                    vm.isFullWidthDevice = angular.element($window)[0].innerWidth > 1600;
                    var workbench = DB.fnGet('iot3Workbench');
                    if (workbench && workbench.currentWorkbench && workbench.currentWorkbench.name &&
                        workbench.currentWorkbench.name.length && workbench.currentWorkbench.yamlString &&
                        workbench.currentWorkbench.yamlString.length) {
                        vm.currentIot3Worspace = _.cloneDeepWith(workbench.currentWorkbench);
                        vm.iot3JSON = vm.fnConvertYamlToJson($base64.decode(workbench.currentWorkbench.yamlString));
                        vm.isIot3FileLoaded = true;
                    } else {
                        DB.fnRemove('iot3Workbench');
                        vm.isIot3FileLoaded = false;
                        vm.sideActiveTabIndex = vm.sideTabs[0];
                        vm.iot3JSON = _.cloneDeepWith(vm.resetIot3Json);
                        vm.currentIot3Worspace = _.cloneDeepWith(vm.resetCurrentIot3Workspace);
                    }
                };
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('iot3Ctrl',
            function ($scope, $window, $timeout, $stateParams, ApiListService, $sce, $state, $uibModal,
                      amaran, swal, moment, microSpinner, PaginationQueryService, WidgetsListService,
                      UserProfileService, DB, XLSX, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, postActionModelIcon,
                      postActionModelMessage, QueryFactory) {
                var vm = this;

                vm.isFullWidthDevice = false;
                vm.isShowWidgets = true;
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Model",
                        name: "model",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Iot3 Variables
                vm.isIot3FilesLoading = false;
                vm.iot3FilesArr = [];
                vm.selectedIot3FilesArr = [];
                vm.selectedIot3Obj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.iot3Response = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.isShowDashboard = false;
                vm.isShowIot3Stats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.dashboardWidgets = [
                    {
                        "id": 0,
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Projects",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n</svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select project.data->>\'id\', project.data->>\'name\', count(nodes.data->>\'id\') as node from node_projects as project LEFT JOIN node_nodes as nodes ON nodes.projectId = project.id GROUP BY project.id, project.name"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "name",
                                "y": "node"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": false
                                        }
                                    }
                                },
                                "series": [],
                                "chart": {
                                    "type": "pie"
                                },
                                "data": {
                                    "csv": "name,node\r\nDefault,1\r\nInternal,0\r\nExternal,0\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                }
                            }
                        }
                    },
                    {
                        "id": 1,
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Nodes",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/device.svg#device\"></use> \n</svg>"
                        },
                        "APIConfiguration": {
                            "sql": "WITH results AS ( SELECT 'Connected' AS type, COUNT(*) AS nodes FROM node_nodes where data->\'connected\' = 'true' UNION ALL SELECT 'Disconnected' AS type, COUNT(*) AS nodes FROM node_nodes where data->\'connected\' = 'false') SELECT * FROM results"
                        },
                        "chartConfiguration": {
                            "chartType": "column",
                            "dataMapping": {
                                "name": "type",
                                "y": "nodes"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": false
                                        },
                                        "animation": false
                                    }
                                },
                                "series": [
                                    {
                                        "name": "nodes",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "column",
                                    "polar": false
                                },
                                "data": {
                                    "csv": "type,nodes\r\nConnected,0\r\nDisconnected,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false
                                },
                                "yAxis": {
                                    "title": {
                                        "text": "Nodes"
                                    }
                                },
                                "legend": {
                                    "enabled": false
                                }
                            }
                        }
                    },
                    {
                        "id": 2,
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Sync State",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/node/syncState.svg#syncState\"></use> \n</svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select count(*) as node, data->>\'syncState\' from node_nodes group by data->>\'syncState\'"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "syncState",
                                "y": "node"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "datahealths": {
                                            "enabled": false
                                        }
                                    }
                                },
                                "series": [
                                    {
                                        "data": [
                                            [
                                                "Test12User5",
                                                1
                                            ],
                                            [
                                                "TestUser2",
                                                1
                                            ],
                                            [
                                                "TestUser6",
                                                3
                                            ],
                                            [
                                                "TestUser1",
                                                0
                                            ],
                                            [
                                                "TestUser4",
                                                1
                                            ],
                                            [
                                                "TestUser3",
                                                0
                                            ],
                                            [
                                                "TestUser7",
                                                0
                                            ],
                                            [
                                                "KunalBariya",
                                                1
                                            ]
                                        ],
                                        "name": "userCount",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "data": {
                                    "csv": "userName,userCount\r\nTest12User5,1\r\nTestUser2,1\r\nTestUser6,3\r\nTestUser1,0\r\nTestUser4,1\r\nTestUser3,0\r\nTestUser7,0\r\nKunalBariya,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                }
                            }
                        }
                    },
                    {
                        "id": 3,
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Lifecycle State",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use> \n</svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select count(*) as node, data->>\'lifecycleState\' from node_nodes group by data->>\'lifecycleState\'"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "lifecycleState",
                                "y": "node"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "datahealths": {
                                            "enabled": false
                                        }
                                    }
                                },
                                "series": [
                                    {
                                        "data": [
                                            [
                                                "Test12User5",
                                                1
                                            ],
                                            [
                                                "TestUser2",
                                                1
                                            ],
                                            [
                                                "TestUser6",
                                                3
                                            ],
                                            [
                                                "TestUser1",
                                                0
                                            ],
                                            [
                                                "TestUser4",
                                                1
                                            ],
                                            [
                                                "TestUser3",
                                                0
                                            ],
                                            [
                                                "TestUser7",
                                                0
                                            ],
                                            [
                                                "KunalBariya",
                                                1
                                            ]
                                        ],
                                        "name": "userCount",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "data": {
                                    "csv": "userName,userCount\r\nTest12User5,1\r\nTestUser2,1\r\nTestUser6,3\r\nTestUser1,0\r\nTestUser4,1\r\nTestUser3,0\r\nTestUser7,0\r\nKunalBariya,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                }
                            }
                        }
                    }
                ];
                vm.resetDashboardWidgets = _.cloneDeepWith(vm.dashboardWidgets);
                vm.selectedColumn = 0;

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: false,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIot3FilesLoading = true;
                    vm.selectedIot3FilesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetIot3References(input, true);
                };

                /*END: Search*/

                /*START: Chart*/
                vm.fnGenerateChartData = function () {
                    vm.chartData = {};
                    _.forEach(vm.dashboardWidgets, function (WidgetObj, key) {
                        if (WidgetObj.widgetType === 'dynamic') {
                            var input = {
                                sql: WidgetObj.APIConfiguration.sql
                            };
                            QueryFactory.executeQuery(input).then(function (res) {
                                if (WidgetObj.chartConfiguration && WidgetObj.chartConfiguration.dataMapping && !_.isEmpty(WidgetObj.chartConfiguration.dataMapping)) {
                                    if (WidgetObj.chartConfiguration.chartConfig && !_.isEmpty(WidgetObj.chartConfiguration.chartConfig)) {
                                        var headers = {};
                                        _.forEach(WidgetObj.chartConfiguration.dataMapping, function (val) {
                                            headers[val] = val;
                                        });
                                        var items = [];
                                        if (res.data && res.data.length) {
                                            _.forEach(res.data, function (obj) {
                                                var tempObj = {};
                                                _.forEach(WidgetObj.chartConfiguration.dataMapping, function (val) {
                                                    tempObj[val] = obj[val] !== null ? obj[val] : 0;
                                                });
                                                items.push(tempObj);
                                            });
                                        } else {
                                            WidgetObj.isDataNull = true;
                                        }
                                        items.unshift(headers);
                                        WidgetObj.chartConfiguration.chartConfig.data.csv = jsonToCsvConvertService.convertToCSV(angular.toJson(items));
                                        vm.chartData[key] = WidgetObj.chartConfiguration.chartConfig;
                                        $timeout(function () {
                                            vm.fnSetTableHeight();
                                        });
                                    }
                                }
                            }, function () { // Error block
                            });
                        }
                    });
                };
                /*END: Chart*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.iot3FilesArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedIot3FilesArr = [];
                                vm.selectedIot3Obj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.iot3', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Iot3";
                        vm.isShowIot3Stats = tab.id === "iot3Stats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowAdvanceSearch = tab.id === "Advanced Search";
                        if (vm.isShowWidgetEditor) {
                            vm.selectedColumn = 0;
                        }
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnGenerateChartData();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Iot3";
                    vm.isShowIot3Stats = tab.id === "iot3Stats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowAdvanceSearch = tab.id === "Advanced Search";
                    if (tab.id === "Dashboard" || tab.id === "Create Iot3" || tab.id === "iot3Stats" || tab.id === "WidgetEditor" || tab.id === "Advanced Search") {
                        $state.go('main.iot3', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Iot3") {
                        vm.activeTabIndex = 1;
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.iot3', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#iot3Table").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (iot3Obj, fromList) {
                    if (vm.permissionObj.DESCRIBE_IOT3) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.iot3FilesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === iot3Obj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected iot3 array*/
                        var isValueFind = _.find(vm.selectedIot3FilesArr, {'id': iot3Obj.id});
                        if (!isValueFind) {
                            vm.selectedIot3FilesArr.push(iot3Obj);
                            var isTabExist = _.find(vm.tabs, {'id': iot3Obj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: iot3Obj.id,
                                    title: iot3Obj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedIot3FilesArr, function (obj) {
                                return iot3Obj.id === obj.id;
                            });
                        }
                        if (vm.selectedIot3FilesArr.length === 1) {
                            vm.fnGetIot3ReferenceDetail(vm.selectedIot3FilesArr[0])
                        } else {
                            $state.go('main.iot3', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.iot3FilesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedIot3FilesArr = angular.copy(vm.iot3FilesArr);
                    } else {
                        vm.selectedIot3FilesArr = [];
                    }
                    $state.go('main.iot3', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedIot3FilesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Iot3'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Iot3',
                                title: 'Create Iot3',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.iot3', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isIot3FilesLoading = true;
                    vm.selectedIot3FilesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_iot3_references';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_iot3_references';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_iot3_references';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_iot3_references';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIot3References(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.iot3FilesArr);
                        vm.previousPage = page;
                        vm.fnGetIot3References(input, false);
                    }
                };

                vm.fnOpenIot3InfoTab = function (iot3Obj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(iot3Obj);
                };

                vm.fnGetIot3Reference = function (iot3Obj, iot3FilesArr) {
                    angular.forEach(iot3FilesArr, function (iot3) {
                        iot3.isCheck = false;
                    });
                    iot3Obj.isCheck = true;
                    vm.selectedIot3FilesArr = [iot3Obj]; // Assign array with single Iot3 object
                    vm.fnGetIot3ReferenceDetail(iot3Obj);
                };

                vm.fnGetIot3ReferenceDetail = function (iot3Obj) {
                    vm.isIot3DetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when iot3 is selected
                        vm.selectedIot3Obj = iot3Obj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.iot3', {
                                selectedId: vm.selectedIot3Obj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedIot3Obj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isIot3DetailsLoaded = true;
                        } else {
                            $state.go('main.iot3', {selectedId: vm.selectedIot3Obj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedIot3Obj.id;
                            vm.isIot3DetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                vm.fnGetLabelColor = function () {
                    var labelColor = '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
                    var labelTextColor = vm.fnInvertColor(labelColor);
                    return {
                        "background-color": labelColor,
                        "color": "" + labelTextColor
                    }
                };

                vm.fnGetIot3References = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                obj.labelsArr = [];
                                if (obj.labels && obj.labels.length) {
                                    _.forEach(obj.labels, function (labelName) {
                                        var colorObj = vm.fnGetLabelColor();
                                        obj.labelsArr.push({
                                            name: labelName,
                                            bgColor: colorObj['background-color'],
                                            textColor: colorObj.color
                                        })
                                    })
                                }
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                            });
                            vm.iot3Response = _.cloneDeepWith(res);
                            if (isFirst && vm.iot3Response.data && vm.iot3Response.data.length) {
                                vm.totalItems = vm.iot3Response.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.iot3Response.data.reverse();
                            }
                            vm.iot3FilesArr = vm.iot3Response.data;

                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetIot3Reference(res[0], vm.iot3FilesArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var iot3Data = _.find(vm.iot3FilesArr, {"id": $stateParams.selectedId});
                                if (iot3Data) {
                                    vm.fnCheckUncheckHeader(iot3Data)
                                }
                            }
                            if ($state.current.name === 'main.iot3') {
                                $state.go('main.iot3', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isIot3FilesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIot3FilesLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    vm.fnGenerateChartData();
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("InitiateClone", function (evt, data) {
                    localStorage.setItem('iot3CloneObj', angular.toJson(data));
                    vm.fnHideShowCreateForm();
                });

                $scope.$on("Iot3Deleted", function (evt, data) {
                    vm.selectedIot3Obj = null;
                    vm.selectedIot3FilesArr = [];
                    vm.iot3FilesArr = vm.iot3FilesArr.filter(function (iot3Obj) {
                        return (iot3Obj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.iot3', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("iot3Added", function (evt, data) {
                    if (data && data.length) {
                        var i = 1;
                        var tabs = [];
                        _.forEach(vm.tabs, function (tabObj) {
                            if (data !== tabObj.id) {
                                tabObj.tabIndex = _.cloneDeep(i);
                                tabs.push(tabObj);
                                i++;
                            }
                        });
                        vm.tabs = _.cloneDeepWith(tabs);
                    }
                    vm.fnRemoveTab('Create Iot3');
                });

                vm.fnDeleteMultipleIot3References = function (selectedIot3FilesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedIot3FilesArr, function (selectedIot3, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/iot3/" + selectedIot3.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/iot3/" + selectedIot3.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Iot3 References?",
                            text: "You are about to permanently delete the selected iot3 references.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedIot3FilesArr, function (selectedIot3Obj) {
                                    angular.forEach(vm.iot3FilesArr, function (iot3Obj, index) {
                                        if (selectedIot3Obj.id === iot3Obj.id) {
                                            vm.iot3FilesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedIot3FilesArr.length;
                                vm.selectedIot3Obj = null;
                                vm.selectedIot3FilesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedIot3FilesArr, function (selectedIot3Obj) {
                                    angular.forEach(vm.iot3FilesArr, function (iot3Obj, index) {
                                        if (selectedIot3Obj.id === iot3Obj.id) {
                                            vm.iot3FilesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedIot3FilesArr.length;
                                vm.selectedIot3Obj = null;
                                vm.selectedIot3FilesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetIot3Dashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIot3Stats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'iot3Stats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIot3Stats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'iot3Stats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIot3Stats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getIot3CSVData = function () {
                    var tempData = _.cloneDeepWith(vm.iot3FilesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.iot3FilesArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Iot3References");
                    XLSX.writeFile(wb, "Iot3References.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'iot3', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function (index) {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                    vm.selectedColumn = index;
                };

                vm.fnShowAdvanceSearchForm = function () {
                    vm.isShowAdvanceSearch = true;
                    var isTabExist = _.find(vm.tabs, {id: 'Advanced Search'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Advanced Search',
                            title: 'Advanced Search',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                vm.fnInitIot3Service = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    var tempDashboardWidgets = UserProfileService.fnGetUserProfileObj('iot3Service', 'iot3', 'dashboardWidgets');
                    if (tempDashboardWidgets === '' || !tempDashboardWidgets.length) {
                        UserProfileService.fnUpdateUserProfileObj('iot3Service', 'iot3', 'dashboardWidgets', _.cloneDeepWith(angular.fromJson(angular.toJson(vm.dashboardWidgets))));
                    } else {
                        vm.dashboardWidgets = _.cloneDeepWith(tempDashboardWidgets);
                    }
                    vm.fnGenerateChartData();
                    var tempValue = UserProfileService.fnGetUserProfileObj('iot3Service', 'iot3', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('healthInfo', fnHealthInfo)

    /** @ngInject */
    function fnHealthInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, ColorService, copyService, NodeProjectFactory, AppInitService, HealthFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/health/healthInfo/healthInfo.html',
            scope: {
                healthObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/health/healthInfo/healthTabs/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/node/health/healthInfo/healthTabs/healthSupplemental/healthSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.health', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };
                $scope.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                $scope.suggestedHealthsArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetHealth = function (healthId) {
                    var inputObj = {
                        healthId: healthId
                    };
                    HealthFactory.describeNodeHealth(inputObj)
                        .then(function (response) {
                            $scope.healthObj = response;
                            $scope.resetHealthObj = angular.copy($scope.healthObj);
                            $scope.isHealthDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isHealthDetailsLoaded = true;
                        })
                };

                $scope.fnUpdateHealthDetails = function (healthObj) {
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;
                    if (angular.isUndefined(healthObj.description)) {
                        healthObj.description = '';
                    }
                    var inputObj = {
                        body: {
                            name: healthObj.name,
                            description: healthObj.description,
                            color: healthObj.color
                        },
                        healthId: healthObj.id
                    };
                    HealthFactory.updateNodeHealth(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var healthArr = DB.fnGet('healthArray');
                            var index = _.findIndex(healthArr, {id: response.id});
                            if (index !== -1) {
                                healthArr[index].name = response.name;
                                healthArr[index].description = response.description;
                                healthArr[index].color = response.color;
                                ColorService.fnSetHealthData(healthArr);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.resetHealthObj = angular.copy(response);
                            $scope.$emit('HealthDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            $scope.isDisplayMiniColors = false;
                            amaran.success("Health Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteHealth = function (healthObj) {
                    swal({
                            title: "Delete the selected health?",
                            text: "You are about to permanently delete the selected health.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    healthId: healthObj.id
                                };
                                HealthFactory.deleteNodeHealth(inputObj)
                                    .then(function () {
                                        $scope.$emit('HealthDeleted', healthObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnAssignSuggestedColor = function (suggesstedColor) {
                    $scope.healthObj.color = suggesstedColor;
                };

                $scope.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                $scope.fnDisplayMiniColors = function () {
                    $scope.isDisplayMiniColors = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.healthObj = angular.copy($scope.resetHealthObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitHealth = function () {
                    $scope.isHealthDetailsLoaded = false;
                    $scope.isDisplayMiniColors = false;
                    $scope.healthId = $scope.healthObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.healthObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        if ($scope.healthId) {
                            $scope.fnGetHealth($scope.healthId);
                        }
                    } else {
                        NodeProjectFactory.describeProject({projectId: $scope.healthObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.healthId) {
                                $scope.fnGetHealth($scope.healthId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitHealth();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                var healthInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.health') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.healthPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteHealth($scope.healthObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.healthPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var healthInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.health') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', healthInfoKeyDownEventHandler);
                document.addEventListener('keyup', healthInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', healthInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', healthInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createHealthCtrl',
            function ($scope, $timeout, $state, DB, HealthFactory, AppInitService, QueryFactory) {
                var vm = this;
                vm.title = "Create Label";
                vm.isHealthCreating = false;
                vm.isHealthCreateLoaded = false;
                vm.customSettings = {
                    position: 'bottom left',
                    inline: true
                };
                vm.newHealthObj = {
                    name: '',
                    description: '',
                    color: '',
                    value: '',
                    projectId: ''
                };
                vm.selectedProject = {};
                vm.isDisplayMiniColors = false;
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/
                vm.suggestedLabelsArr = ["#0c4bc1", "#578ec2", "#65a78e", "#b3d09c", "#77b067", "#88c643", "#224912", "#394a5b", "#818b8c", "#9f9bcf", "#5252a5", "#8257a6", "#fcecde", "#9f5066", "#bd3b6d", "#b83444", "#e7413d", "#c7615c", "#d2cb50", "#e5ad69", "#a78b54"];

                vm.fnAssignSuggestedColor = function (suggesstedColor) {
                    vm.newHealthObj.color = suggesstedColor;
                };

                vm.fnAssignSpanBackground = function (suggestedColor) {
                    return {
                        "background-color": suggestedColor
                    }
                };

                vm.fnDisplayMiniColors = function () {
                    vm.isDisplayMiniColors = !vm.isDisplayMiniColors;
                };

                vm.fnCreateNewHealth = function (newHealthObj) {
                    vm.isHealthCreating = true;
                    var inputObj = {
                        body: newHealthObj
                    };
                    HealthFactory.createNodeHealth(inputObj)
                        .then(function (response) {
                            $scope.health.fnHideShowCreateForm(); //parent function
                            vm.newHealthObj = {
                                name: '',
                                description: '',
                                color: '',
                                projectId: ''
                            };
                            vm.isHealthCreating = false;
                            $timeout(function () { // set table height
                                $scope.health.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('healthAdded', response);
                            $scope.health.totalItems = $scope.health.totalItems + 1;
                            $scope.health.healthsArr.push(response);
                            $scope.health.fnReload();
                        }, function () {
                            vm.isHealthCreating = false;
                        })
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isHealthCreateLoaded = true;
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newHealthObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newHealthObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                vm.fnManageProject = function () {
                    $state.go("main.project");
                };
                /*Project: END*/

                vm.fnInitCreateHealth = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        vm.isHealthCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('gatewayInfo', fnGatewayInfo)

    /** @ngInject */
    function fnGatewayInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, copyService, IconService, ColorService, GatewayFactory, postActionModelIcon, postActionModelMessage, TypeFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/gateway/gatewayInfo/gatewayInfo.html',
            scope: {
                gatewayObj: '=',
                gatewayPermissionsObj: '=',
                infoSectionClass: "=",
                deviceTypesArr:"="
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                $scope.$watch('infoSectionClass', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.infoSectionClass = newValue;
                        $scope.$broadcast('redrawChart', $scope.infoSectionClass);
                    }
                }, true);

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewayOverview/gatewayOverview.html',
                        visible: true
                    },
                    {
                        title: 'Telemetry',
                        tabIndex: 2,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewayGhost/gatewayGhost.html'
                    },
                    {
                        title: 'Topology',
                        tabIndex: 3,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewayTopology/gatewayTopology.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 4,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/details.html'
                    },
                    {
                        title: 'Location',
                        tabIndex: 5,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewayLocation/gatewayLocation.html'
                    },
                    {
                        title: 'Clusters',
                        tabIndex: 6,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewayClusters/gatewayClusters.html'
                    },
                    {
                        title: 'Supplemental',
                        tabIndex: 7,
                        templateUrl: 'app/node/gateway/gatewayInfo/gatewayTabs/gatewaySupplemental/gatewaySupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetGateway = function (gatewayId) {
                    var inputObj = {
                        gatewayId: gatewayId
                    };
                    GatewayFactory.getGateway(inputObj)
                        .then(function (response) {
                            $scope.gatewayObj = response;
                            $scope.resetGatewayObj = angular.copy($scope.gatewayObj);
                            if (angular.isUndefined($scope.gatewayObj.description)) {
                                $scope.gatewayObj.description = '';
                            }
                            $scope.isGatewayDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isGatewayDetailsLoaded = true;
                        })
                };

                $scope.fnGetTypeInfo = function(){
                    TypeFactory.getType({typeId: $scope.gatewayObj.typeId})
                        .then(function (response) {
                            $scope.gatewayTypObj = response;
                            $scope.fnGetGateway($scope.gatewayObj.id);
                        }, function () {
                            $scope.gatewayTypObj = {};
                            $scope.fnGetGateway($scope.gatewayObj.id);
                        })
                };

                $scope.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };

                $scope.fnUpdateGatewayDetails = function (gatewayObj) {
                    var inputObj = {
                        body: {},
                        gatewayId: gatewayObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(gatewayObj.description)) {
                        gatewayObj.description = '';
                    }
                    inputObj.body = {
                        name: gatewayObj.name,
                        description: gatewayObj.description
                    };
                    GatewayFactory.modifyGateway(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetGatewayObj = angular.copy(response);
                            $scope.$emit('GatewayDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Gateway Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteGateway = function (gatewayObj) {
                    swal({
                            title: "Delete the selected gateway?",
                            text: "You are about to permanently delete the selected gateway.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    gatewayId: gatewayObj.id
                                };
                                GatewayFactory.deleteGateway(inputObj)
                                    .then(function () {
                                        $scope.$emit('GatewayDeleted', gatewayObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.gateway', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnResetDetails = function () {
                    $scope.gatewayObj = angular.copy($scope.resetGatewayObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnExitEditMode = function () {
                    $scope.gatewayObj = angular.copy($scope.resetGatewayObj);
                    $scope.isDetailsEditable = false;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    return healthObj;
                };

                $scope.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                $scope.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                $scope.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                $scope.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                $scope.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                $scope.fnInitGateway = function () {
                    $scope.isGatewayDetailsLoaded = false;
                    $scope.gatewayId = $scope.gatewayObj.id;
                    if ($scope.gatewayId) {
                        $scope.fnGetTypeInfo();
                        //$scope.fnGetGateway($scope.gatewayId);
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.fnGatewayInfoSectionFullScreen = function () {
                    $scope.$emit('GatewayInfoSectionClick');
                };

                var gatewayInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.gateway') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.gatewayPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteGateway($scope.gatewayObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.gatewayPermissionsObj.Modify
                                && !$scope.isDetailsEditable && $scope.selectedTab === 2 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var gatewayInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.gateway') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', gatewayInfoKeyDownEventHandler);
                document.addEventListener('keyup', gatewayInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', gatewayInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', gatewayInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createGatewayCtrl',
            function ($scope, $timeout, $window, $rootScope, amaran, DB, SchemaService, AppInitService, GatewayFactory, TypeFactory) {
                var vm = this;

                vm.title = "Order Gateway";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newGatewayObj = {
                    name: '',
                    description: '',
                    typeId: '',
                    properties: {}
                };
                //var resetObj = angular.copy(vm.newGatewayObj);

                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.isBluePrintFilter = false;
                vm.search = '';
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';

                vm.typePropertiesArr = [];
                vm.isTypeformValidated = false;

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight();

                vm.fnCreateGateway = function (newGatewayObj) {
                    vm.isGatewayCreating = true;
                    var inputObj = {
                        body: newGatewayObj
                    };
                    GatewayFactory.createGateway(inputObj)
                        .then(function (response) {
                            vm.isGatewayCreating = false;
                            $scope.gateway.fnHideShowCreateForm(); //parent function
                            vm.newGatewayObj = {
                                name: '',
                                description: '',
                                typeId: '',
                                properties: {}
                            };
                            amaran.success("Gateway created successfully");
                            $scope.$emit('gatewayAdded', response.id);
                            if ($scope.gateway.permissionObj.List) {
                                $scope.gateway.totalItems = $scope.gateway.totalItems + 1;
                                $scope.gateway.gatewaysArr.push(response);
                                $scope.gateway.fnReload();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewayCreating = false;
                        });
                };

                vm.fnBluePrintSelected = function (selectedBluePrintObj) {
                    vm.isBluePrintSelected = false;
                    vm.newGatewayObj.typeId = selectedBluePrintObj.id;
                    if (Object.keys(selectedBluePrintObj.properties).length) {
                        vm.typePropertiesArr = angular.copy(SchemaService.convertJsonToSchema(selectedBluePrintObj.properties));
                        angular.forEach(vm.typePropertiesArr, function (tempObj) {
                            if (tempObj.default) {
                                tempObj.typeValue = tempObj.default;
                            } else {
                                tempObj.typeValue = "";
                            }
                            tempObj.isValueMissing = false;
                            tempObj.isPatternMismatch = false;
                            tempObj.isMinError = false;
                            tempObj.isMaxError = false;
                        });
                    } else {
                        vm.typePropertiesArr = [];
                    }
                    $timeout(function () {
                        vm.isBluePrintSelected = true;
                    })
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isTypeformValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.newGatewayObj.properties = propertiesObj;
                    } else {
                        vm.newGatewayObj.properties = {};
                    }
                };

                vm.fnTypesFilter = function () {
                    vm.isBluePrintFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.resetUniqueBluePrintObj, function (typeObj) {
                            if (typeObj.typeName.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetUniqueBluePrintObj);
                    }
                    vm.uniqueBluePrintObj = searchArr;
                    $timeout(function () {
                        vm.isBluePrintFilter = false;
                    }, 1000)
                };

                vm.fnCheckObjLength = function (obj) {
                    return !!Object.keys(obj).length;
                };

                vm.fnInitCreateGateway = function () {
                    vm.isBluePrintFetched = false;
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        var typesArr = AppInitService.getInitData('typesArr');
                        var tempArr = _.filter(typesArr,{category:'GATEWAY'});
                        _.forEach(tempArr, function (tempObj) {
                            var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                            tempObj.properties = angular.copy(propertiesObj);
                        });
                        vm.bluePrintArr = tempArr;
                        vm.uniqueBluePrintObj = {};
                        _.map(vm.bluePrintArr, function (item) {
                            if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model]) {
                                vm.uniqueBluePrintObj[item.oem + '-' + item.model] = {
                                    typeName: '',
                                    typeValue: [],
                                    isGatewayDataLoad: false
                                };
                            }
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeName = item.name;
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.push(item);
                            if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj) {
                                vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj = item;
                            }
                        });
                        vm.resetUniqueBluePrintObj = angular.copy(vm.uniqueBluePrintObj);
                        vm.isBluePrintFetched = true;
                    } else {
                        var inputObj = {
                            filter: "#{category} = ${GATEWAY}"
                        };
                        TypeFactory.getTypes(inputObj)
                            .then(function (response) {
                                var tempArr = response;
                                _.forEach(tempArr, function (tempObj) {
                                    var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                                    tempObj.properties = angular.copy(propertiesObj);
                                });
                                vm.bluePrintArr = tempArr;
                                vm.uniqueBluePrintObj = {};
                                _.map(vm.bluePrintArr, function (item) {
                                    if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model]) {
                                        vm.uniqueBluePrintObj[item.oem + '-' + item.model] = {
                                            typeName: '',
                                            typeValue: [],
                                            isGatewayDataLoad: false
                                        };
                                    }
                                    vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeName = item.name;
                                    vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.push(item);
                                    if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj) {
                                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj = item;
                                    }
                                });
                                vm.resetUniqueBluePrintObj = angular.copy(vm.uniqueBluePrintObj);
                                vm.isBluePrintFetched = true;
                            }, function () {
                                vm.isBluePrintFetched = true;
                            })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('fleetEcuInfo', fnFleetEcuInfo)

    /** @ngInject */
    function fnFleetEcuInfo($window, $state, $stateParams, $timeout, $log, microSpinner, $uibModal, swal, amaran, DB,
                            BatchFactory, ColorService, copyService, NodeProjectFactory, AppInitService,
                            NodeEcuFactory, QueryFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/fleet/fleetInfo/fleetInfo.html',
            scope: {
                ecuObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isDetailsEditable = false;
                $scope.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                $scope.accountId = $scope.authUserObj && $scope.authUserObj.id ? $scope.authUserObj.id.split("-")[0] : '';
                $scope.scriptObj = {
                    'script': ''
                };
                $scope.isCommandExecuteing = false;
                $scope.isShowScript = false;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'About',
                        tabIndex: 1,
                        templateUrl: 'app/node/fleet/fleetInfo/fleetSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Script',
                        tabIndex: 2,
                        templateUrl: 'app/node/fleet/fleetInfo/fleetSteps/script/script.html',
                        visible: true
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/x-sh",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: false,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };
                $scope.scriptData = '';

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.fleet', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map core fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name;
                                parsedItem.description = parsedData.description;
                                parsedItem.health = parsedData.health;
                                parsedItem.connected = parsedData.connected === true || parsedData.connected === 'true';
                                parsedItem.phase = parsedData.phase;
                                parsedItem.lifecycleState = parsedData.lifecycleState;
                                parsedItem.syncState = parsedData.syncState;
                                parsedItem.projectId = parsedData.projectId;
                                parsedItem.ntp = parsedData.ntp;
                                parsedItem.vpn = parsedData.vpn;
                                parsedItem.version = parsedData.version;

                                // Handle timestamps
                                parsedItem.createdAt = parsedItem.createdAt ||
                                    parsedData.createdAt ||
                                    parsedItem.created_at;
                                parsedItem.updatedAt = parsedItem.updatedAt ||
                                    parsedData.updatedAt ||
                                    parsedItem.updated_at;

                                // Ensure both formats exist
                                parsedItem.created_at = parsedItem.createdAt;
                                parsedItem.updated_at = parsedItem.updatedAt;

                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }
                        return parsedItem;
                    });
                }

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                $scope.fnRequestECUTunnel = function (ecuObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                        size: 'lg',
                        controller: 'jobTerminalCtrl as jobTerminal',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith(ecuObj);
                            },
                            isEcuTunnel: function () {
                                return true;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    }, function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    });
                };

                $scope.fnCheckHealth = function () {
                    return angular.isDefined($scope.ecuObj.health);
                }

                $scope.fnGetFleetECUInfo = function () {
                    var sql = "SELECT * FROM node_fleet_ecus where id = '" + $scope.ecuObj.id + "'";
                    QueryFactory.executeQuery({sql: sql})
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                $scope.ecuObj = _.cloneDeepWith(parsePostgresData(res.data)[0]);
                            } else {
                                amaran.error('ECU detail not found');
                                $scope.$emit('EcuFleetNotFound', $scope.ecuObj);
                            }
                            $scope.isEcuDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEcuDetailsLoaded = true;
                            $scope.$emit('EcuFleetNotFound', $scope.ecuObj);
                        })
                }

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitScriptTab = function () {
                    $scope.isShowScript = false;
                    $timeout(function () {
                        $scope.isShowScript = true;
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitEcu = function () {
                    $scope.isEcuDetailsLoaded = false;
                    $scope.ecuId = $scope.ecuObj.id;
                    $scope.fnGetFleetECUInfo();
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitEcu();

                $scope.fnExecuteCommand = function () {
                    $scope.isCommandExecuteing = true;
                    var inputObj = {
                        ecuId: $scope.ecuObj.id,
                        body: {
                            script: $scope.scriptObj.script
                        }
                    };
                    NodeEcuFactory.requestECUBashCommand(inputObj)
                        .then(function (response) {
                            amaran.success("ECU Bash Command in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/fleet/modal/jobTerminal/jobTerminal.html',
                                size: 'lg',
                                controller: 'jobTerminalCtrl as jobTerminal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(response);
                                    },
                                    ecuObj: function () {
                                        return _.cloneDeepWith($scope.ecuObj);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                            $scope.isCommandExecuteing = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isCommandExecuteing = false;
                        });
                };

                var ecuInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.fleet') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.ecuPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteEcu($scope.ecuObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.ecuPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var ecuInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.fleet') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', ecuInfoKeyDownEventHandler);
                document.addEventListener('keyup', ecuInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', ecuInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', ecuInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('es4Info', fnEs4Info)

    /** @ngInject */
    function fnEs4Info($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, BatchFactory, ColorService, copyService, NodeProjectFactory, AppInitService, NodeES4Factory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/es4/es4Info/es4Info.html',
            scope: {
                es4Obj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isDetailsEditable = false;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'About',
                        tabIndex: 1,
                        templateUrl: 'app/node/es4/es4Info/es4Steps/details.html',
                        visible: true
                    },
                    {
                        title: 'Code',
                        tabIndex: 2,
                        templateUrl: 'app/node/es4/es4Info/es4Steps/es4Script/es4Script.html',
                        visible: true
                    },
                    {
                        title: 'Tags',
                        tabIndex: 3,
                        templateUrl: 'app/node/es4/es4Info/es4Steps/es4Supplemental/es4Supplemental.html',
                        visible: true
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_es4', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetEs4 = function (es4Id) {
                    var inputObj = {
                        es4Id: es4Id
                    };
                    NodeES4Factory.describeES4(inputObj)
                        .then(function (response) {
                            $scope.es4Obj = response;
                            $scope.resetEs4Obj = angular.copy($scope.es4Obj);
                            $scope.isEs4DetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEs4DetailsLoaded = true;
                        })
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnUpdateEs4Details = function (es4Obj) {
                    $scope.isUpdateCompleted = false;
                    var inputObj = {
                        body: {},
                        es4Id: es4Obj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/edge-scripts/" + es4Obj.id + "/names",
                        body: {name: es4Obj.name}
                    });

                    if (angular.isDefined(es4Obj.description)) {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/edge-scripts/" + es4Obj.id + "/descriptions",
                            body: {description: es4Obj.description}
                        });
                    } else {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/edge-scripts/" + es4Obj.id + "/descriptions",
                            body: {description: ''}
                        });
                    }

                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        var tempEs4Obj = response[response.length - 1].body;
                        if (tempEs4Obj.code === 400) {
                            $scope.isUpdateCompleted = true;
                            amaran.error(tempEs4Obj.message);
                            $scope.fnResetDetails();
                        } else {
                            if (angular.isUndefined(tempEs4Obj.description)) {
                                tempEs4Obj.description = '';
                            }
                            $scope.$emit('Es4DetailsChanged', tempEs4Obj);
                            $scope.es4Obj.name = tempEs4Obj.name;
                            $scope.es4Obj.description = tempEs4Obj.description;
                            amaran.success("ES4 Updated Successfully");
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    })
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.es4Obj = angular.copy($scope.resetEs4Obj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnDeployES4 = function (es4Obj) {
                    swal({
                            title: "Deploy the selected ES4?",
                            text: "You are about to deploy the selected ES4.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "deploy",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    es4Id: es4Obj.id
                                };
                                NodeES4Factory.deployES4(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ES4 deploy in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Deploy Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnDeleteEs4 = function(es4Obj){
                    swal({
                            title: "Delete the selected ES4?",
                            text: "You are about to delete the selected ES4.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    es4Id: es4Obj.id
                                };
                                NodeES4Factory.deleteES4(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ES4 delete in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitEs4 = function () {
                    $scope.isEs4DetailsLoaded = false;
                    $scope.es4Id = $scope.es4Obj.id;
                    if ($scope.es4Id) {
                        $scope.fnGetEs4($scope.es4Id);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitEs4();

                var es4InfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_es4') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.userPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteEs4($scope.es4Obj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.userPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var es4InfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_es4') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', es4InfoKeyDownEventHandler);
                document.addEventListener('keyup', es4InfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', es4InfoKeyDownEventHandler);
                    document.removeEventListener('keyup', es4InfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createEs4Ctrl',
            function ($scope, $window, $timeout, amaran, NodeES4Factory, UserProfileService, QueryFactory) {
                var vm = this;
                vm.isEs4CreateLoaded = false;
                vm.ecusArr = [];
                vm.selectedEcu = {};
                vm.es4EcuFilter = "$";
                vm.es4EcuSearch = {$: ''};
                vm.newEs4Obj = {
                    name: "",
                    description: "",
                    script: ""
                };
                vm.isEs4Creating = false;
                vm.isScriptEditable = true;
                vm.value = {};
                vm.availableDataLibs = ['common_S4'];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetHeight();
                });

                vm.fnSetHeight = function () {
                    if (angular.element(".modal-body")[0]) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var ecuNameContainer = angular.element(".ecuNameContainer")[0].offsetHeight;
                        var descriptionContainer = angular.element(".descriptionContainer")[0].offsetHeight;
                        var createBtnContainer = angular.element(".createBtnContainer")[0].offsetHeight;
                        var finalHeight = total - (ecuNameContainer + descriptionContainer + createBtnContainer + 90);
                        angular.element(".scriptContainer").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetEcus = function (inputObj, preDefinedEcus, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var ecus = isCalledForViz ? preDefinedEcus : [];
                            _.forEach(res.data, function (projectObj) {
                                ecus.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (ecus[0] && ecus[0].totalItems > ecus.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + ecus[ecus.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetEcus({sql: sqlString}, ecus, true);
                            } else {
                                vm.ecusArr = _.cloneDeepWith(ecus);
                                var tempSelectedEcu = UserProfileService.fnGetUserProfileObj('node', 'es4', 'selectedEcu');
                                if (tempSelectedEcu !== '') {
                                    var isFindEcu = _.find(vm.ecusArr, {id: tempSelectedEcu.id});
                                    if (isFindEcu) {
                                        vm.selectedEcu = isFindEcu;
                                    } else {
                                        vm.selectedEcu = vm.ecusArr[0];
                                    }
                                } else {
                                    vm.selectedEcu = vm.ecusArr[0];
                                }
                                vm.isEs4CreateLoaded = true;
                                $timeout(function () {
                                    vm.fnSetHeight();
                                });
                            }
                        }, function () { // Error block
                            vm.fnGetEcus(inputObj, [], false);
                        })
                };

                vm.fnGetEs4Ecu = function (ecuObj) {
                    vm.selectedEcu = ecuObj;
                    //vm.newEs4Obj.ecuId = ecuObj.id;
                    //vm.newEs4Obj.projectId = ecuObj.projectId;
                };

                vm.fnCreateNewEs4 = function (es4Obj) {
                    vm.isEs4Creating = true;
                    es4Obj.script = vm.value.getData();
                    var inputObj = {
                        ecuId: vm.selectedEcu.id,
                        body: es4Obj
                    };
                    NodeES4Factory.createES4(inputObj)
                        .then(function () { // Success block
                            vm.isEs4Creating = false;
                            amaran.success("ES4 creation in progress.");
                            $scope.$emit('es4Added');
                            $timeout(function () {
                                vm.fnSetHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEs4Creating = false;
                        })

                };

                vm.fnInitCreateEs4 = function () {
                    var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_ecus ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetEcus({sql: projectSQL}, [], false);
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeEmailTemplateInfo', fnNodeEmailTemplateInfo)

    /** @ngInject */
    function fnNodeEmailTemplateInfo($http, $window, $state, $timeout, $base64, NodeEmailTemplateFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/emailTemplate/emailTemplateInfo/emailTemplateInfo.html',
            scope: {
                emailTemplateObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isShowPrviewRenderedHTML = true;
                $scope.isEmailTemplateLoading = true;
                $scope.emailTemplates = {};
                $scope.activeTabIndex = 1;
                $scope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                $scope.isEmailValid = true;
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    htmlMode: true,
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        };
                        $scope.setLine = function (errors) {
                            $timeout(function () {
                                _cm.clearGutter('gutter-error');
                                if (errors && errors.length) {
                                    for (var i = 0; i < errors.length; i++) {
                                        var error = errors[i];
                                        var errorLine = error.line - 1;
                                        var marker = document.createElement("div");
                                        marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                        marker.setAttribute('data-toggle', 'tooltip');
                                        marker.setAttribute('data-placement', 'auto');
                                        marker.setAttribute('title', error.message);
                                        _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                                    }
                                }
                            }, 0)

                        };
                        _cm.on("changes", function () {
                            $scope.isValidTemplate = false;
                        });
                        $scope.getString = function () {
                            return _cm.getSelection();
                        };

                        $scope.replaceString = function (str) {
                            return _cm.replaceSelection(str);
                        };

                    }
                };
                $scope.isValidTemplate = true;
                $scope.emailTemplateType = "";
                $scope.isShowVariables = false;

                $scope.tabs = [
                    {
                        title: 'Template',
                        tabIndex: 1,
                        templateUrl: 'app/node/emailTemplate/emailTemplateInfo/emailTemplateSteps/details.html'
                    }
                ];

                $scope.bold = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<b>' + string + '</b>');
                };

                $scope.italic = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<i>' + string + '</i>');
                };

                $scope.underline = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<u>' + string + '</u>');
                };

                $scope.strike = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<span style="text-decoration: line-through;">' + string + '</span>');
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetEmailTemplateData = function (emailTemplateType) {
                    $scope.isEmailTemplateDataLoading = true;
                    var inputObj = {
                        type: emailTemplateType
                    };
                    NodeEmailTemplateFactory.describeEmailTemplate(inputObj)
                        .then(function (response) {
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            var name = '';
                            if(emailTemplateType.includes('ecu') || emailTemplateType.includes('vpn') || emailTemplateType.includes('ntp')) {
                                var o = emailTemplateType.split('_');
                                name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                            } else {
                                name = toUpper(emailTemplateType.replace(/_/g, " "));
                            }
                            $scope.emailTemplateObj.name = name;
                            $scope.emailTemplateObj.type = emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.isEmailTemplateDataLoading = false;
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEmailTemplateDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.node_emailTemplate', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        var emailTemplateToolbar = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".email-template-toolbar")[0]) ? angular.element(".email-template-toolbar")[0].offsetHeight : 0;
                        angular.element(".email-body").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".email-template").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".tabContent1").css('height', (finalHeight - (42 + aboutText)) + 'px');
                        angular.element(".emailConfigurationInfo").css('height', (finalHeight - (42 + aboutText)) + 'px');
                    }
                };

                $scope.fnViewRenderedHTML = function (isRender) {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    if (isRender) {
                        $scope.isShowPrviewRenderedHTML = true;
                    } else {
                        $scope.isShowPrviewRenderedHTML = !$scope.isShowPrviewRenderedHTML;
                    }
                    $timeout(function () {
                        if ($scope.isShowPrviewRenderedHTML) {
                            var string = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isTemplateLoading = true;
                            $http({
                                method: 'POST',
                                url: 'https://api.mjml.io/v1/render',
                                config: {},
                                data: {
                                    "mjml": string
                                }
                            }).success(function (res) {
                                $scope.isTemplateLoading = false;
                                if (res.errors && res.errors.length) {
                                    $scope.isValidTemplate = false;
                                    $scope.setLine(_.cloneDeepWith(res.errors));
                                } else {
                                    $scope.isValidTemplate = true;
                                    //$scope.setLine([]);
                                }
                                $timeout(function () {
                                    var element = document.getElementById('htmlParse');
                                    element.innerHTML = res.html; //eslint-disable-line
                                });
                                $timeout(function () {
                                    $scope.fnSetTabHeight();
                                });
                            });
                        } else {
                            if ($scope.isTemplateEditable) {
                                $timeout(function () {
                                    $scope.readOnlyFalse();
                                    $scope.fnValidateTemplate();
                                });
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.modeChanged();
                            });
                        }
                    });
                };

                $scope.fnCheckEmail = function () {
                    var patt = new RegExp($scope.emailPattern);
                    $scope.isEmailValid = patt.test($scope.templateConfigObj.emailFrom);
                };

                $scope.fnChangeToEditable = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        $timeout(function () {
                            $scope.resetHtmlbody = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isShowPrviewRenderedHTML = false;
                            $scope.isTemplateEditable = true;
                            $timeout(function () {
                                $scope.readOnlyFalse();
                                $scope.fnValidateTemplate();
                            });
                        })
                    } else {
                        $timeout(function () {
                            $scope.fnViewRenderedHTML(true);
                            $scope.templateConfigObj.mjmlBody = _.cloneDeepWith($scope.resetHtmlbody);
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.ReadOnlyTrue();
                            });
                        });
                    }
                };

                $scope.fnValidateTemplate = function () {
                    $scope.isValidatingTemplate = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        $scope.isValidatingTemplate = false;
                        if (res.errors && res.errors.length) {
                            $scope.isValidTemplate = false;
                            $scope.setLine(_.cloneDeepWith(res.errors));
                        } else {
                            $scope.isValidTemplate = true;
                            $scope.setLine([]);
                        }
                    });

                };

                $scope.fnSaveEmailTemplate = function () {
                    $scope.isSaveChanges = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        var input = {
                            type: $scope.emailTemplateObj.type,
                            body: {}
                        };
                        input.body = {
                            "templateType": $scope.emailTemplateObj.templateType,
                            "context": $scope.emailTemplateObj.context,
                            "body": res.mjml,
                            "from": $scope.templateConfigObj.emailFrom,
                            "subject": $scope.templateConfigObj.emailSubject,
                            "variables": $scope.emailTemplateObj.variables
                        };
                        NodeEmailTemplateFactory.updateEmailTemplate(input).then(function (response) {
                            $scope.isSaveChanges = false;
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = $scope.emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.fnViewRenderedHTML(true);
                                });
                            });
                            amaran.success("Template update successfully");
                        }, function () {
                            $scope.isSaveChanges = false;
                            $scope.templateConfigObj = {
                                emailFrom: $scope.emailTemplateObj.from,
                                mjmlBody: $scope.emailTemplateObj.body,
                                emailSubject: $scope.emailTemplateObj.subject,
                                emailVariables: $scope.emailTemplateObj.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                        });
                    });
                };

                $scope.fnResetEmailTemplate = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this email back to its original template. All the current email settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.emailTemplateObj.type
                                };
                                NodeEmailTemplateFactory.resetEmailTemplate(inputObj)
                                    .then(function (response) {
                                        $scope.emailTemplateObj = _.cloneDeepWith(response);
                                        $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                                        $scope.emailTemplateObj.type = $scope.emailTemplateType;
                                        $scope.templateConfigObj = {
                                            emailFrom: response.from,
                                            mjmlBody: response.body,
                                            emailSubject: response.subject,
                                            emailVariables: response.variables
                                        };
                                        $scope.isValidTemplate = true;
                                        $scope.isTemplateEditable = false;
                                        $scope.isShowVariables = false;
                                        $timeout(function () {
                                            $timeout(function () {
                                                $scope.fnViewRenderedHTML(true);
                                            });
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitEmailTemplate = function () {
                    $scope.emailTemplateType = _.cloneDeepWith($scope.emailTemplateObj.type);
                    if ($scope.emailTemplateObj.type) {
                        $scope.fnGetEmailTemplateData($scope.emailTemplateObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuSynchronizingCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeEcuFactory) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */

                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.ecuDetailsLoading = true;
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobSummaryArr = [];
                vm.deploysUnsynchronizedEcu = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#ecu-synchronizing-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnGetECUDetails = function (ecuObj) {
                    NodeEcuFactory.describeECU({ecuId: ecuObj.id})
                        .then(function (response) {
                            if (response) {
                                vm.ecuObj = _.cloneDeepWith(response);
                            } else {
                                vm.ecuObj = "";
                            }
                            vm.ecuDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.ecuDetailsLoading = false;
                        })
                };

                vm.fnRequestECUSynchronizing = function () {
                    vm.deploysUnsynchronizedEcu = true;
                    var input = {
                        ecuId: vm.ecuObj.id
                    };
                    NodeEcuFactory.deployEcu(input)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            vm.deploysUnsynchronizedEcu = false;
                            amaran.success("ECU synchronize in progress.");
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.deploysUnsynchronizedEcu = false;
                        });
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to Synchronizing ECU"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job"
                        })
                        if (vm.ecuObj.ecuConnected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            if (res && res.data && res.data.length) {
                                if (res.data[0].audits && res.data[0].audits.length) {
                                    var tempAuditsArr = res.data[0].audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(res.data[0].startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }
                                if (res.data[0].jobResult === "SUCCESS") {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job successfully completed."
                                    })
                                }
                                if (res.data[0].jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job failed and was aborted."
                                    })
                                }
                                if (res.data[0].jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(res.data[0].completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.ecu.tabs, {id: 'SynchronizingECU'});
                    vm.fnGetECUDetails({id: vm.selectedTabInfo.ecuId});
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .factory('ECUTunnelHelperService', function($log, jsyaml) {
            var service = {
                parseECUResponse: parseECUResponse,
                validateTunnelConfig: validateTunnelConfig
            };

            return service;

            function parseECUResponse(response) {
                var result = {
                    debugInfo: {
                        rawIot3: '',
                        parsedConfig: null,
                        tunnelTypes: [],
                        parseError: null,
                        parsingSteps: []
                    },
                    tunnelTypes: []
                };

                try {
                    // Store raw IoT3
                    if (!response || !response.registration || !response.registration.iot3) {
                        result.debugInfo.parseError = 'No IoT3 configuration found';
                        return result;
                    }

                    result.debugInfo.rawIot3 = response.registration.iot3;
                    result.debugInfo.parsingSteps.push('Found IoT3 configuration');

                    // Parse YAML
                    var iot3Config = jsyaml.load(response.registration.iot3);
                    result.debugInfo.parsedConfig = iot3Config;
                    result.debugInfo.parsingSteps.push('Parsed YAML configuration');

                    if (!iot3Config || !iot3Config.engines || !iot3Config.engines.tunnel) {
                        result.debugInfo.parseError = 'No tunnel configuration found';
                        return result;
                    }

                    var tunnelConfig = iot3Config.engines.tunnel;

                    // Check for SSH
                    if (tunnelConfig.ssh && tunnelConfig.ssh.supported) {
                        result.tunnelTypes.push({ name: 'SSH' });
                        result.debugInfo.tunnelTypes.push('SSH');
                        result.debugInfo.parsingSteps.push('Found SSH support');
                    }

                    // Check for HTTP/HTTPS
                    if (tunnelConfig.http && tunnelConfig.http.supported) {
                        result.tunnelTypes.push({ name: 'HTTP' });
                        result.debugInfo.tunnelTypes.push('HTTP');
                        result.debugInfo.parsingSteps.push('Found HTTP support');

                        if (tunnelConfig.http.displayInstructions &&
                            tunnelConfig.http.displayInstructions.protocol === 'HTTPS') {
                            result.tunnelTypes.push({ name: 'HTTPS' });
                            result.debugInfo.tunnelTypes.push('HTTPS');
                            result.debugInfo.parsingSteps.push('Found HTTPS support');
                        }
                    }

                    return result;

                } catch (error) {
                    $log.error('Error parsing ECU response:', error);
                    result.debugInfo.parseError = error.message || 'Unknown error parsing configuration';
                    return result;
                }
            }

            function validateTunnelConfig(tunnelConfig) {
                var result = {
                    isValid: true,
                    errors: [],
                    warnings: []
                };

                if (!tunnelConfig) {
                    result.isValid = false;
                    result.errors.push('No tunnel configuration available');
                    return result;
                }

                // Validate SSH configuration
                if (tunnelConfig.ssh) {
                    if (typeof tunnelConfig.ssh.supported !== 'boolean') {
                        result.warnings.push('SSH support flag should be boolean');
                    }
                }

                // Validate HTTP configuration
                if (tunnelConfig.http) {
                    if (typeof tunnelConfig.http.supported !== 'boolean') {
                        result.warnings.push('HTTP support flag should be boolean');
                    }

                    if (tunnelConfig.http.supported) {
                        if (!tunnelConfig.http.port) {
                            result.warnings.push('HTTP port not specified');
                        }
                    }
                }

                return result;
            }
        })
        .controller('ecuTunnelCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeEcuFactory, $log) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */

                $log.debug('EcuTunnel controller initialized');

                // Test log to verify logging is working
                $log.debug('Test log message');
                $log.error('Test error message');

                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.tunnelTypes = [];
                vm.selectedTunnelType = '';
                vm.ecuDetailsLoading = true;
                vm.isTunnelRequestActive = false;
                vm.timeOutOptions = [
                    {
                        displayName: '10 Minutes',
                        value: 600
                    }, {
                        displayName: '20 Minutes',
                        value: 1200
                    }, {
                        displayName: '30 Minutes',
                        value: 1800
                    }, {
                        displayName: '45 Minutes',
                        value: 2700
                    }, {
                        displayName: '1 Hour',
                        value: 3600
                    }
                ];
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.jobSummaryArr = [];

                //ecuTunnelDuration
                var tunnelDuration = UserProfileService.fnGetSystemProfileObj('nodeTunnelDuration');
                if (tunnelDuration === '') {
                    vm.selectedTimeout = _.cloneDeepWith(vm.timeOutOptions[0]);
                } else {
                    vm.selectedTimeout = _.cloneDeepWith(tunnelDuration);
                }

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse timestamps
                        if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = moment(parsedItem.updated_at).unix();
                        }
                        if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = moment(parsedItem.created_at).unix();
                        }

                        // Parse the data JSON field
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Convert string timestamps to numbers if they aren't already
                                if (parsedData.startedAt && angular.isString(parsedData.startedAt)) {
                                    parsedData.startedAt = parseInt(parsedData.startedAt);
                                }
                                if (parsedData.completedAt && angular.isString(parsedData.completedAt)) {
                                    parsedData.completedAt = parseInt(parsedData.completedAt);
                                }
                                if (parsedData.expiresAt && angular.isString(parsedData.expiresAt)) {
                                    parsedData.expiresAt = parseInt(parsedData.expiresAt);
                                }

                                // Ensure jobResult is uppercase
                                if (parsedData.jobResult) {
                                    parsedData.jobResult = parsedData.jobResult.toString().toUpperCase();
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);

                            } catch (e) {
                                $log.error('Error parsing job data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#ecu-tunnel-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnGetECUDetails = function (ecuObj) {
                    var inputObj = {
                        ecuId: ecuObj.id
                    };

                    // Initialize debugInfo right away
                    vm.debugInfo = {
                        rawIot3: '',
                        parsedConfig: null,
                        tunnelTypes: [],
                        parseError: null
                    };

                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            vm.ecuObj = _.cloneDeepWith(response);

                            // Store raw IoT3 config for debugging
                            vm.debugInfo.rawIot3 = response.registration.iot3;

                            // Reset tunnel types array
                            vm.tunnelTypes = [];

                            // Check if response has engines and tunnel configuration
                            if (response.registration && response.registration.iot3) {
                                try {
                                    // Parse the iot3 YAML configuration
                                    var iot3Config = jsyaml.load(response.registration.iot3);

                                    // Store parsed config for debugging
                                    vm.debugInfo.parsedConfig = iot3Config;

                                    if (iot3Config && iot3Config.engines && iot3Config.engines.tunnel) {
                                        // Check for SSH tunnel support
                                        if (iot3Config.engines.tunnel.ssh && iot3Config.engines.tunnel.ssh.supported) {
                                            vm.tunnelTypes.push({ name: 'SSH' });
                                            vm.debugInfo.tunnelTypes.push('SSH');
                                        }

                                        // Check for HTTP tunnel support
                                        if (iot3Config.engines.tunnel.http && iot3Config.engines.tunnel.http.supported) {
                                            vm.tunnelTypes.push({ name: 'HTTP' });
                                            vm.debugInfo.tunnelTypes.push('HTTP');
                                        }

                                        // Check for HTTPS tunnel support
                                        if (iot3Config.engines.tunnel.http &&
                                            iot3Config.engines.tunnel.http.supported &&
                                            iot3Config.engines.tunnel.http.displayInstructions &&
                                            iot3Config.engines.tunnel.http.displayInstructions.protocol === 'HTTPS') {
                                            vm.tunnelTypes.push({ name: 'HTTPS' });
                                            vm.debugInfo.tunnelTypes.push('HTTPS');
                                        }
                                    }
                                } catch (e) {
                                    $log.error('Error parsing tunnel configuration:', e);
                                    vm.debugInfo.parseError = e.toString();
                                }
                            }

                            // Select first available tunnel type if any exist
                            if (vm.tunnelTypes.length > 0) {
                                vm.fnSelectTunnelType(vm.tunnelTypes[0]);
                            }

                            vm.ecuDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.ecuDetailsLoading = false;
                        });
                };


                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnRequestECUTunnel = function () {
                    vm.isTunnelRequestActive = true;
                    var inputObj = {
                        timeout: vm.selectedTimeout.value,
                        type: vm.selectedTunnelType === 'HTTPS' ? 'HTTP' : vm.selectedTunnelType
                    };
                    inputObj.ecuId = vm.selectedTabInfo.ecuId;
                    NodeEcuFactory.ecuTunnelRequest(inputObj)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            amaran.success("ECU tunnel request is in progress.");
                            vm.isTunnelRequestActive = false;
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTunnelRequestActive = false;
                        })

                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to Open a Tunnel"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job"
                        })
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the Node comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>'id' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>'id' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
                }

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    $log.debug('Getting completed job details for:', vm.jobObj.id);
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>\'id\' = '" + vm.jobObj.id + "'"
                    };
                    $log.debug('Querying completed job:', input);
                    vm.latestResponse = null;
                    vm.parsedResponse = null;

                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            vm.latestResponse = angular.copy(res.data);
                            var parsedData = parsePostgresData(res.data);
                            vm.parsedResponse = parsedData;
                            if (parsedData && parsedData.length) {
                                $log.debug('Got data:', parsedData);

                                var jobData = parsedData[0];// Success block

                                $log.debug('Processing job data:', jobData);
                                if (jobData.audits && jobData.audits.length) {
                                    var tempAuditsArr = jobData.audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(jobData.startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }

                                if (jobData.jobResult === "SUCCESS") {
                                    // Log the success state
                                    $log.debug('Tunnel job completed successfully:', jobData);

                                    var guidStr = guid();
                                    $log.debug('Generated GUID:', guidStr);

                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "The Job was executed successfully."
                                    });
                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "One moment while we create a secure tunnel."
                                    });
                                    vm.jobSummaryArr.push({
                                        dateTime: "",
                                        summary: "This can take up to 60 seconds."
                                    });

                                    // Set up base path for tunnel service
                                    var basePath = '';
                                    var url = '';
                                    var environment = 'prod';
                                    try {
                                        // Get HOST_URL from $window
                                        var HOST_URL = $window.HOST_URL || {};

                                        if (Object.keys(HOST_URL).length) {
                                            url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1];
                                            $log.debug('URL after split:', url);

                                            if (url.startsWith('dev')) {
                                                environment = 'dev';
                                                basePath = 'https://dev-tunnel.ecsmon.ecsiteapp.com'
                                            } else {
                                                basePath = 'https://tunnel.ecsmon.ecsiteapp.com'
                                            }
                                        } else {
                                            basePath = 'https://tunnel.ecsmon.ecsiteapp.com';
                                        }
                                    } catch (e) {
                                        $log.error('Error determining base path:', angular.toJson(e));
                                        basePath = 'https://tunnel.ecsmon.ecsiteapp.com';
                                    }
                                    $log.debug('Using base path:', basePath);
                                    var apiURL = basePath + "/tunnel/";
                                    $log.debug('Final API URL:', apiURL);

                                    // Prepare headers
                                    var authToken = '';
                                    if (DB.fnGet('federation')) {
                                        authToken = 'Basic ' + DB.fnGet('federation').sessionObj.federationToken;
                                        $log.debug('Using federation token');
                                    } else if (DB.fnGet('support')) {
                                        authToken = 'Basic ' + DB.fnGet('support').sessionObj.supportToken;
                                        $log.debug('Using support token');
                                    } else {
                                        authToken = 'Basic ' + $cookies.get('phoenix')
                                        $log.debug('Using phoenix cookie token');
                                    }

                                    var headers = {
                                        'Content-Type': 'application/json',
                                        'Authorization': authToken,
                                        'deviceId': vm.ecuObj.id,
                                        'jobId': vm.jobObj.id,
                                        'jobUuid': guidStr,
                                        'timeout': vm.selectedTimeout.value,
                                        'tunnelType': vm.selectedTunnelType,
                                        'predictiveEnvironment': environment
                                    };

                                    $log.debug('Request headers prepared:', angular.toJson(headers));

                                    // Make request to tunnel service
                                    $log.debug('Making tunnel service request...');

                                    $http({
                                        method: "GET",
                                        url: apiURL,
                                        responseType: 'application/json',
                                        headers: headers
                                    }).then(function (response) {
                                        $log.debug('Tunnel service response:', response);

                                        if (response && response.data && response.data.tunnel_port) {
                                            $log.debug('Tunnel port received:', response.data.tunnel_port);

                                            // Set cookie
                                            $cookies.put('predictivetunnel_' + vm.jobObj.id, guidStr, {
                                                domain: '.ecsmon.ecsiteapp.com',
                                                samesite: 'None',
                                                secure: true
                                            });
                                            $log.debug('Cookie set successfully');

                                            vm.jobSummaryArr.push({
                                                dateTime: "",
                                                summary: "Tunnel established successfully. Opening the tunnel in a new tab."
                                            });

                                            var popup_window = '';
                                            if (response.data.path && response.data.path !== '') {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: "Tunnel URL : " + basePath + ":" + response.data.tunnel_port + response.data.path + "."
                                                });
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port + response.data.path, '_blank');
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: "Tunnel URL : " + basePath + ":" + response.data.tunnel_port + "."
                                                });
                                                popup_window = $window.open(basePath + ':' + response.data.tunnel_port, '_blank');
                                            }

                                            try {
                                                popup_window.focus();
                                            } catch (e) {
                                                $log.error('Popup window error:', e);
                                                swal({
                                                    title: "Pop-up Blocker is enabled!",
                                                    text: "This site uses pop-up for the tunnel. Please enable them for this website in your browser or add this site to your exception list.",
                                                    type: "warning",
                                                    html: true,
                                                    showCancelButton: true,
                                                    showCancelButtonText: 'OK',
                                                    showConfirmButton: false,
                                                    showLoaderOnConfirm: false
                                                });
                                            }
                                        } else {
                                            $log.error('Invalid tunnel response:', response);
                                            vm.jobSummaryArr.push({
                                                dateTime: "",
                                                summary: "We encountered an error while trying to establish a secure connection. Please try again."
                                            });
                                        }
                                    }, function error(err) {
                                        $log.error('Tunnel service request failed:', angular.toJson(err));
                                        vm.jobSummaryArr.push({
                                            dateTime: "",
                                            summary: "Error creating tunnel: " + (err.message || angular.toJson(err))
                                        });
                                    });
                                } else {
                                    $log.debug('Job did not complete successfully:', jobData);
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.ecu.tabs, {id: 'Tunnel'});
                    if (vm.selectedTabInfo && vm.selectedTabInfo.ecuId.length) {
                        vm.fnGetECUDetails({id: vm.selectedTabInfo.ecuId});
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ecuNetworkscanCtrl',
            function ($rootScope, $scope, $timeout, $window, $cookies, $http, DB, jsyaml, amaran, moment, swal, UserProfileService, QueryFactory, NodeEcuFactory, $log) {
                var vm = this;

                /*
                * Step 1: Tunnel Config
                * Step 2: Tunnel process terminal.
                */
                vm.inputObj = {
                    auto: true,
                    range: ""
                }
                vm.totalSteps = 2;
                vm.activeStep = 1;
                vm.ecuDetailsLoading = true;
                vm.selectedJobTabIndex = 1;
                vm.jobTabs = [
                    {
                        title: 'Summary',
                        tabIndex: 1
                    }
                ];
                vm.isNetworkScanStart = false;

                vm.jobSummaryArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        if (angular.isDefined(parsedItem.startedAt)) {
                            parsedItem.startedAt = parseInt(parsedItem.startedAt);
                        }

                        if (angular.isDefined(parsedItem.completedAt)) {
                            parsedItem.completedAt = parseInt(parsedItem.completedAt);
                        }

                        // Parse JSONB data
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle job specific fields
                                if (parsedData.jobResult) {
                                    parsedData.jobResult = parsedData.jobResult.toString().toUpperCase();
                                }

                                if (parsedData.audits) {
                                    // Ensure audits are properly formatted as string
                                    parsedData.audits = parsedData.audits.toString();
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);

                            } catch (e) {
                                $log.error('Error parsing ECU network scan data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#ecu-networkscan-modal-body").css('height', finalHeight + 'px');
                        if (vm.activeStep === 2) {
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var tabHeader = 42;
                            var finalHeightNew = finalHeight - (tabHeader + dashboardHeader);
                            angular.element(".tabContent1").css('height', finalHeightNew + 'px');
                        }
                    }
                };

                vm.fnConvertYamlToJson = function (yamlString) {
                    try {
                        return _.cloneDeepWith(angular.fromJson(angular.toJson(jsyaml.load(yamlString))));
                    } catch (error) {
                        return false;
                    }
                };

                vm.fnGetECUDetails = function (ecuObj) {
                    var inputObj = {
                        ecuId: ecuObj.id
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            vm.ecuObj = _.cloneDeepWith(response);
                            vm.ecuDetailsLoading = false;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.ecuDetailsLoading = false;
                        })
                };

                vm.fnSelectTunnelType = function (tunnelTypeObj) {
                    vm.selectedTunnelType = tunnelTypeObj.name;
                };

                vm.fnChangeTimeout = function (timeoutObj) {
                    vm.selectedTimeout = _.cloneDeepWith(timeoutObj)
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        UserProfileService.fnUpdateSystemProfileObj('nodeTunnelDuration', _.cloneDeepWith(timeoutObj));
                    }
                };

                vm.fnRequestECUNetworkScan = function () {
                    vm.isNetworkScanStart = true;
                    var inputObj = {
                        ecuId: vm.ecuObj.id,
                        body: vm.inputObj
                    };
                    NodeEcuFactory.ecuNetworkScan(inputObj)
                        .then(function (response) {
                            vm.jobObj = _.cloneDeepWith(response);
                            vm.isNetworkScanStart = false;
                            vm.isJobIdFound = true;
                            amaran.success("ECU network scan request in progress.");
                            vm.activeStep = 2;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            }, 0);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNetworkScanStart = false;
                            vm.isJobIdFound = false;
                        })
                };

                vm.fnIntiJob = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "A new Job has been created to Network Scan"
                        })
                        vm.jobSummaryArr.push({
                            dateTime: moment().format("HH:mm:ss"),
                            summary: "Waiting for '" + vm.ecuObj.name + "' ECU (" + vm.ecuObj.id + ") to acknowledge the job"
                        })
                        if (vm.ecuObj.connected !== true) {
                            vm.jobSummaryArr.push({
                                dateTime: moment().format("HH:mm:ss"),
                                summary: "The ECU is currently offline the job will continue when the ECU comes back online"
                            })
                        }
                        vm.fnGetPendingJob();
                    }, 100)
                };

                vm.fnGetPendingJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_pending_jobs where data->>'id' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetPendingJob();
                                }, 10000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "The '" + vm.ecuObj.name + "' ECU has accepted the job and it is now active"
                                    })
                                    vm.jobSummaryArr.push({
                                        dateTime: moment().format("HH:mm:ss"),
                                        summary: "Waiting for '" + vm.ecuObj.name + "' ECU to update the status of the job [this may take a while]"
                                    })
                                    vm.fnGetActiveJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetActiveJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_active_jobs where data->>'id' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetActiveJob();
                                }, 5000);
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetJobTime = function (timestamp) {
                    return moment.unix(timestamp).format("HH:mm:ss");
                };

                vm.fnGetCompletedJob = function () {
                    var input = {
                        sql: "SELECT * FROM ecu_completed_jobs where data->>'id' = '" + vm.jobObj.id + "'"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            var parsedData = parsePostgresData(res.data);
                            if (parsedData && parsedData.length) {
                                var jobData = parsedData[0];

                                if (jobData.audits && jobData.audits.length) {
                                    var tempAuditsArr = jobData.audits.split('\n');
                                    _.forEach(tempAuditsArr, function (tempAuditsObj, index) {
                                        if (tempAuditsObj !== '') {
                                            if (index === 0) {
                                                vm.jobSummaryArr.push({
                                                    dateTime: vm.fnGetJobTime(jobData.startedAt),
                                                    summary: tempAuditsObj
                                                })
                                            } else {
                                                vm.jobSummaryArr.push({
                                                    dateTime: "",
                                                    summary: tempAuditsObj
                                                })
                                            }
                                        }
                                    });
                                }

                                if (jobData.jobResult === "SUCCESS") {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(jobData.completedAt),
                                        summary: "The job successfully completed."
                                    })
                                }
                                if (jobData.jobResult === 'FAILURE') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(jobData.completedAt),
                                        summary: "The job failed and was aborted."
                                    })
                                }
                                if (jobData.jobResult === 'MIXED') {
                                    vm.jobSummaryArr.push({
                                        dateTime: vm.fnGetJobTime(jobData.completedAt),
                                        summary: "The job was only partially successful. Please see above for operations that failed to compete."
                                    })
                                }
                            } else {
                                vm.jobAPITimeout = $timeout(function () {
                                    vm.fnGetCompletedJob();
                                }, 10000);
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnInit = function () {
                    vm.selectedTabInfo = _.find($scope.ecu.tabs, {id: 'NetworkScanECU'});
                    vm.fnGetECUDetails({id: vm.selectedTabInfo.ecuId});
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                $scope.$on('$destroy', function () {
                    if (vm.activeStep === 2) {
                        $timeout.cancel(vm.jobAPITimeout);
                    }
                })
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ecuInfo', fnEcuInfo)

    /** @ngInject */
    function fnEcuInfo($window, $state, $stateParams, $timeout, $log, moment, microSpinner, QueryFactory, swal, amaran, $uibModal, DB, BatchFactory, ColorService, copyService, NodeProjectFactory, AppInitService, NodeEcuFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/ecu/ecuInfo/ecuInfo.html',
            scope: {
                ecuObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isDetailsEditable = false;
                $scope.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                $scope.accountId = $scope.authUserObj && $scope.authUserObj.id ? $scope.authUserObj.id.split("-")[0] : '';
                $scope.isECUHasNode = true;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Telemetry',
                        tabIndex: 1,
                        templateUrl: 'app/node/ecu/ecuInfo/ecuSteps/ecuAttributes/ecuAttributes.html',
                        visible: true
                    },
                    {
                        title: 'About',
                        tabIndex: 2,
                        templateUrl: 'app/node/ecu/ecuInfo/ecuSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Register ECU',
                        tabIndex: 3,
                        templateUrl: 'app/node/ecu/ecuInfo/ecuSteps/registerECU/registerECU.html',
                        visible: $scope.ecuObj.phase === 'UNREGISTERED'
                    },
                    {
                        title: 'Location',
                        tabIndex: 4,
                        templateUrl: 'app/node/ecu/ecuInfo/ecuSteps/ecuLocation/ecuLocation.html',
                        visible: true
                    }, {
                        title: 'Tags',
                        tabIndex: 5,
                        templateUrl: 'app/node/ecu/ecuInfo/ecuSteps/ecuSupplemental/ecuSupplemental.html',
                        visible: true
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map core fields with proper type handling
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name;
                                parsedItem.description = parsedData.description;
                                parsedItem.health = parseInt(parsedData.health);
                                parsedItem.connected = parsedData.connected === true || parsedData.connected === 'true';
                                parsedItem.phase = parsedData.phase;
                                parsedItem.lifecycleState = parsedData.lifecycleState;
                                parsedItem.syncState = parsedData.syncState;
                                parsedItem.projectId = parsedData.projectId;
                                parsedItem.ntp = parsedData.ntp;
                                parsedItem.vpn = parsedData.vpn;
                                parsedItem.version = parsedData.version;
                                parsedItem.serial = parsedData.serial;
                                parsedItem.registered = parsedData.registered === true || parsedData.registered === 'true';

                                // Handle timestamps
                                // Handle all timestamp variations
                                // Created timestamps
                                parsedItem.createdAt = parsedItem.createdAt ||
                                    parsedData.createdAt ||
                                    parsedItem.created_at ||
                                    parsedData.created_at;

                                // Updated timestamps
                                parsedItem.updatedAt = parsedItem.updatedAt ||
                                    parsedData.updatedAt ||
                                    parsedItem.updated_at ||
                                    parsedData.updated_at;

                                // Last seen timestamps
                                parsedItem.lastSeenAt = parsedItem.lastSeenAt ||
                                    parsedData.lastSeenAt ||
                                    parsedItem.last_seen_at ||
                                    parsedData.last_seen_at;

                                // Ensure both snake_case and camelCase versions exist for compatibility
                                parsedItem.created_at = parsedItem.createdAt;
                                parsedItem.updated_at = parsedItem.updatedAt;
                                parsedItem.last_seen_at = parsedItem.lastSeenAt;
                                // Handle tags if present
                                if (parsedData.tags) {
                                    parsedItem.tags = parsedData.tags;
                                }

                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }
                        return parsedItem;
                    });
                }

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.ecu', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetEcu = function (ecuId) {
                    var inputObj = {
                        ecuId: ecuId
                    };
                    NodeEcuFactory.describeECU(inputObj)
                        .then(function (response) {
                            $scope.ecuObj = parsePostgresData([response])[0];
                            if (response.lastSeenAt && response.lastSeenAt !== 0) {
                                response.lastSeenDate = $scope.fnGetAbsoluteOrRelativeTime(response.lastSeenAt);
                            }
                            if (response.registeredAt && response.registeredAt !== 0) {
                                response.registeredDate = $scope.fnGetAbsoluteOrRelativeTime(response.registeredAt);
                            }
                            if (response.updatedAt && response.updatedAt !== 0) {
                                response.updatedDate = $scope.fnGetAbsoluteOrRelativeTime(response.updatedAt);
                            }
                            if (response.createdAt && response.createdAt !== 0) {
                                response.createdDate = $scope.fnGetAbsoluteOrRelativeTime(response.createdAt);
                            }
                            $scope.resetEcuObj = angular.copy($scope.ecuObj);
                            $scope.fnCheckECUHasNode($scope.ecuObj);
                            $scope.isEcuDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEcuDetailsLoaded = true;
                        })
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnCheckECUHasNode = function (ecuObj) {
                    var input = {
                        sql: "select * from node_nodes where data->>\'ecuId\' = '" + ecuObj.id + "' limit 1;"
                    };
                    QueryFactory.executeQuery(input)
                        .then(function (res) {
                            $scope.isECUHasNode = !!(res && res.data && res.data.length);
                        }, function () { // Error block
                            $scope.isECUHasNode = true;
                        });
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                $scope.fnUpdateEcuDetails = function (ecuObj) {
                    $scope.isUpdateCompleted = false;
                    var inputObj = {
                        body: {},
                        ecuId: ecuObj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/ecus/" + ecuObj.id + "/names",
                        body: {name: ecuObj.name}
                    });

                    if (angular.isDefined(ecuObj.description)) {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/ecus/" + ecuObj.id + "/descriptions",
                            body: {description: ecuObj.description}
                        });
                    } else {
                        batchArr.push({
                            method: "PATCH",
                            id: 2,
                            path: "/node/ecus/" + ecuObj.id + "/descriptions",
                            body: {description: ''}
                        });
                    }

                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        var tempEcuObj = response[response.length - 1].body;
                        if (tempEcuObj.code === 400) {
                            $scope.isUpdateCompleted = true;
                            amaran.error(tempEcuObj.message);
                            $scope.fnResetDetails();
                        } else {
                            if (angular.isUndefined(tempEcuObj.description)) {
                                tempEcuObj.description = '';
                            }
                            $scope.$emit('EcuDetailsChanged', tempEcuObj);
                            $scope.ecuObj.name = tempEcuObj.name;
                            $scope.ecuObj.description = tempEcuObj.description;
                            amaran.success("ECU Updated Successfully");
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isUpdateCompleted = true;
                        $scope.isDetailsEditable = false;
                    })
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.ecuObj = angular.copy($scope.resetEcuObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnRebootECU = function (ecuObj) {
                    swal({
                            title: "Reboot the selected ECU?",
                            text: "You are about to reboot the selected ECU.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "reboot",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.rebootEcu(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU reboot in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Reboot Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnDeregisterECU = function (ecuObj) {
                    swal({
                            title: "Deregister the selected ECU?",
                            text: "You are about to deregister the selected ECU.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.<br/><br/>" +
                                "Please type in the word \"Deregister\" to deregister ECU.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "deregister",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (inputValue) {
                            if (inputValue === null) {
                                return false;
                            }

                            if (inputValue === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (inputValue !== 'Deregister') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (inputValue === 'Deregister') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.deregisterEcu(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU deregistration in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else if (inputValue === false) {
                                swal("Cancelled", "Deregister Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnDeployECU = function (ecuObj) {
                    $scope.$emit('RequestECUSynchronizing', ecuObj);
                };

                $scope.fnEnableECUNTP = function (ecuObj) {
                    swal({
                            title: "Enable the selected ECU NTP?",
                            text: "You are about to enable NTP the selected ECU.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.enableEcuNtp(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU NTP enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "ECU NTP enabling Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnDisabledECUNTP = function (ecuObj) {
                    swal({
                            title: "Disable the selected ECU NTP?",
                            text: "You are about to disable NTP the selected ECU.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.disableEcuNtp(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU NTP disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "ECU NTP disabling process cancelled", "error");
                            }
                        });
                };

                $scope.fnEnableECUVPN = function (ecuObj) {
                    swal({
                            title: "Enable the selected ECU VPN?",
                            text: "You are about to enable VPN the selected ECU.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.enableEcuVpn(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU VPN enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "ECU VPN enabling process cancelled", "error");
                            }
                        });
                };

                $scope.fnDisabledECUVPN = function (ecuObj) {
                    swal({
                            title: "Disable the selected ECU VPN?",
                            text: "You are about to disable VPN the selected ECU.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    ecuId: ecuObj.id
                                };
                                NodeEcuFactory.disableEcuVpn(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("ECU VPN disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "ECU VPN disabling process cancelled", "error");
                            }
                        });
                };

                $scope.fnRequestECUTunnel = function (ecuObj) {
                    $scope.$emit('RequestECUTunnel', ecuObj);
                };

                $scope.fnRequestStartNetworkScan = function () {
                    $scope.$emit('RequestECUNetworkScan', $scope.ecuObj);
                };

                $scope.fnChangeECUProject = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/ecu/modals/ecuProject/ecuProject.html',
                        size: 'lg',
                        controller: 'ecuProjectCtrl as ecuProject',
                        windowClass: 'modal-height100',
                        resolve: {
                            ecuObj: function () {
                                return _.cloneDeepWith($scope.ecuObj);
                            },
                            selectedProject: function () {
                                return _.cloneDeepWith($scope.selectedProject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        $scope.ecuObj.projectId = res.ecuData.projectId;
                        $scope.selectedProject = res.selectedProject;
                        $scope.$emit('EcuDetailsChanged', $scope.ecuObj);
                    }, function () {

                    });
                };

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitEcu = function () {
                    $scope.isEcuDetailsLoaded = false;
                    $scope.ecuId = $scope.ecuObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.ecuObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        if ($scope.ecuId) {
                            $scope.fnGetEcu($scope.ecuId);
                        }
                    } else {
                        NodeProjectFactory.describeProject({projectId: $scope.ecuObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.ecuId) {
                                $scope.fnGetEcu($scope.ecuId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitEcu();

                $scope.$on("ECUDetailsChanged", function (evt, response) {
                    $scope.selectedTab = 1;
                    $scope.fnTabSelected({tabIndex: 1});
                    $scope.fnSetTabHeight();
                    $scope.tabs[2].visible = response.phase === 'UNREGISTERED';
                    $scope.isEcuDetailsLoaded = false;
                    $scope.fnGetEcu(response.id);
                });

                var ecuInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.ecu') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.ecuPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteEcu($scope.ecuObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.ecuPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var ecuInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.ecu') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', ecuInfoKeyDownEventHandler);
                document.addEventListener('keyup', ecuInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', ecuInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', ecuInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('viewGhostAttributesCtrl',
            function ($window, $scope, $timeout, amaran, $http, $uibModal, $uibModalInstance, $cookies, moment, Paho, inventoryObj, parentInventories, DB, ColorService,
                      PermissionsService, GhostService, SchemaService, FedSudoUserService, copyService, IconService, AppInitService, UserFactory, TypeFactory, ComponentFactory, WebSocketFactory, deviceObj, gatewayObj, AnalyticsFactory, jsonToCsvConvertService, XLSX, analyticsService) {
                var vm = this;
                var inventoryTimer, client, overLayWebSocketTimeout;
                vm.selectedInventoryObj = {};
                vm.filter = "$";
                vm.search = {$: ''};
                vm.isComponentGhostDetailsLoaded = true;
                vm.componentGhostObj = '';
                vm.componentReportedArr = [];
                vm.tabs = [
                    {
                        icon: "fa-table",
                        tabIndex: 0
                    }
                ];
                vm.selectedTab = {};
                vm.tableOptionsObj = {
                    health: true,
                    name: true,
                    value: true,
                    display: true
                };
                vm.isFooterSpinnerActive = false;
                vm.isShowAllGhostAttributes = false;
                vm.recentlyUpdatedComponentReportedArr = [];
                vm.unhealthyComponentReportedArr = [];
                vm.isGhostDetailsEditable = false;
                vm.isGhostUpdateCompleted = true;
                vm.selectedGhostObj = {};
                vm.ghostUpdateObj = {};
                vm.isEditInputValidated = false;
                var currentTime = Date.now();
                var hours = 3;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTreeHeight();
                });
                vm.isDropUp = false;

                vm.analyticsTabs = [{
                    title: 'Overview',
                    tabIndex: 1,
                    templateUrl: ''
                }, {
                    title: 'Telemetry',
                    tabIndex: 2,
                    templateUrl: ''
                }];
                vm.selectedAnalyticsTabs = 1;
                vm.isPieChartLoading = true;
                vm.TelemetryPieData = [];
                vm.selectedFilterObj = {
                    type: 'relative',
                    name: '3',
                    value: '3h',
                    units: 'hours',
                    window: '5m'
                };
                vm.healthData = [];
                vm.isAggregateHealthLoading = true;

                vm.fnChangeAnalyticsTabs = function (obj) {
                    vm.selectedAnalyticsTabs = obj.tabIndex;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };
                vm.isAttributeAnalyticsDataFetch = false;

                //Context Menu: Start
                vm.attributesContextMenu = function (deviceGhostObj) {
                    return [{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnRenameAttribute(deviceGhostObj);
                        }
                    }]
                };
                //Context Menu: End

                /*START: FILTER OPTIONS*/
                vm.filterOptions = [{
                    value: '1h',
                    tabIndex: 0,
                    name: '1',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '3h',
                    tabIndex: 1,
                    name: '3',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '12h',
                    tabIndex: 2,
                    name: '12',
                    units: 'hours',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '3d',
                    tabIndex: 3,
                    name: '3',
                    units: 'days',
                    window: "1h",
                    type: 'relative'
                }, {
                    value: '1w',
                    tabIndex: 4,
                    name: '1',
                    units: 'weeks',
                    window: "1h",
                    type: 'relative'
                }, {
                    value: 'Custom',
                    tabIndex: 5
                }];
                vm.chartOptions = [{
                    name: 'Area Chart',
                    icon: 'fa-area-chart',
                    tabIndex: 0
                }, {
                    name: 'Pie Chart',
                    icon: 'fa-pie-chart',
                    tabIndex: 1
                }];
                vm.selectedFilterOption = vm.filterOptions[1];
                vm.selectedFilterObj = vm.filterOptions[1];
                vm.selectedChartType = vm.chartOptions[0];
                vm.selectedAggregateFn = 'MEAN';
                /*END: FILTER OPTIONS*/
                vm.currentTime = '';
                vm.isShowLabel = false;
                vm.fnChangeChartType = function (charType) {
                    if (vm.selectedChartType.tabIndex !== charType.tabIndex) {
                        vm.selectedChartType = charType;
                    }
                };

                vm.fnChangeFilterOption = function (filterOption) {
                    if ((vm.filterOptions.length - 1) === filterOption.tabIndex) {
                        vm.fnOpenDateTimeHelpModal();
                    }
                    if (vm.selectedFilterOption.tabIndex !== filterOption.tabIndex) {
                        vm.selectedFilterOption = filterOption;
                        if ((vm.filterOptions.length - 1) !== filterOption.tabIndex) {
                            vm.healthData = [];
                            vm.selectedFilterObj = filterOption;
                            vm.fnGetAnalyticsQuery(vm.selectedInventoryObj.id);
                        }
                    }
                };

                vm.fnSetTreeHeight = function () {
                    if (vm.selectedAnalyticsTabs === 2 && angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".viewGhostSearchBar")[0])) {
                        var total, search, finalHeight;
                        total = angular.element(".modal-body")[0].offsetHeight;
                        search = angular.element(".viewGhostSearchBar")[0].offsetHeight;
                        finalHeight = total - (search + 108);
                        angular.element(".viewGhostAttributesLayout-table tbody").css('height', finalHeight + 'px');
                        var unhealthyComponentFinalHeight = angular.copy(finalHeight / 2) - (20 + 34 + 10);
                        var recentlyUpdatedComponentFinalHeight = angular.copy(finalHeight / 2) - (34 + 20 + 10);
                        angular.element(".viewGhostAttributesLayout-table #noGhostAttributeData").css('height', finalHeight + 'px');
                        angular.element(".viewGhostAttributesLayout-table #unhealthyComponentReported").css('height', (unhealthyComponentFinalHeight + 35) + 'px');
                        angular.element(".viewGhostAttributesLayout-table #recentlyUpdatedComponentReported").css('height', (recentlyUpdatedComponentFinalHeight + 35) + 'px');
                        angular.element(".viewGhostAttributesLayout-table tbody#unhealthyComponentReportedArr").css('height', (unhealthyComponentFinalHeight) + 'px');
                        angular.element(".viewGhostAttributesLayout-table tbody#recentlyUpdatedComponentReportedArr").css('height', (recentlyUpdatedComponentFinalHeight) + 'px');
                    }
                };

                vm.fnCloseAlert = function () {
                    document.getElementsByClassName("cycleAlert-bottom")[0].style.display = "none";
                };

                vm.fnGetComponentData = function (inventoryObj) {
                    vm.isFileViewUpdating = true;
                    var inputObj = {
                        deviceId: inventoryObj.id.substring(0, inventoryObj.id.lastIndexOf("-")),
                        componentId: inventoryObj.id
                    };
                    ComponentFactory.getComponent(inputObj)
                        .then(function (response) {
                            vm.selectedComponent = response;
                            vm.fnGetComponentGhost(response);
                        })
                };


                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnGetComponentGhost = function (componentObj) {
                    var inputObj = {
                        deviceId: componentObj.id.substring(0, componentObj.id.lastIndexOf("-")),
                        componentId: componentObj.id
                    };
                    ComponentFactory.getComponentGhost(inputObj)
                        .then(function (response) {
                            vm.componentGhostObj = response;
                            vm.componentReportedArr = [];
                            Object.keys(vm.componentGhostObj).forEach(function (key) {
                                var tempObj = {};
                                tempObj.name = vm.componentGhostObj[key].name;
                                tempObj.value = vm.componentGhostObj[key].reported ? vm.componentGhostObj[key].reported : null;
                                tempObj.enabled = angular.isDefined(vm.componentGhostObj[key].enabled) ? vm.componentGhostObj[key].enabled : true;
                                tempObj.health = vm.componentGhostObj[key].health ? vm.componentGhostObj[key].health : 200;
                                tempObj.humanTimestamp = moment(vm.componentGhostObj[key].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                tempObj.timestamp = vm.componentGhostObj[key].timestamp;
                                tempObj.humanDateLastUpdatedRelative = moment(tempObj.humanTimestamp).fromNow();
                                tempObj.displayName = vm.componentGhostObj[key].displayName;
                                tempObj.unit = angular.isDefined(vm.componentGhostObj[key].unit) ? vm.componentGhostObj[key].unit : "";
                                var healthObj = ColorService.getHealthColorForLoop(tempObj.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                                if (tempObj.healthName === tempObj.health) {
                                    tempObj.toolTipName = tempObj.health;
                                } else {
                                    tempObj.toolTipName = tempObj.healthName + " " + tempObj.health;
                                }
                                tempObj.displayValue = tempObj.enabled === false ? 'disabled' : tempObj.value === "__empty" ? "" : tempObj.value;
                                vm.componentReportedArr.push(tempObj);
                            });
                            $timeout(function () {
                                $timeout.cancel(vm.repeatativeComponentGhostTimer);
                                vm.fnRefreshRelativeComponentGhostTime();
                            }, 60000);
                            vm.fnGetTypeDefinition(vm.componentReportedArr);
                            vm.fnGenerateTelemetryPieData(vm.componentReportedArr);
                            count = 0;
                            vm.isAttributeAnalyticsDataFetch = true;
                            vm.currentTime = moment();
                            vm.fnInitAttributeAnalytics(count);
                        })
                };

                vm.fnDownloadXls = function () {
                    var gatewayGhostArrCp = angular.copy(vm.componentGhostObj);
                    var tempData = _.map(gatewayGhostArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "ComponentGhost");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "componentGhost_" + vm.selectedInventoryObj.id + ".xlsx");
                };
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchorGhost')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchorGhost').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = angular.copy(vm.componentGhostObj);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    Object.keys(tempData).map(function (key) {
                        vm.csvHeaderArr = Object.keys(tempData[key]);
                        return vm.csvHeaderArr;
                    });
                    return _.map(data[1], function (deviceGhostObj) {
                        var tempObj = {};
                        _.forEach(vm.csvHeaderArr, function (headerText) {
                            tempObj[headerText] = deviceGhostObj[headerText];
                        });
                        return tempObj;
                    });
                };
                vm.fnGenerateTelemetryPieData = function (inventoriesArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(inventoriesArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: val.length,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.TelemetryPieData = pieData;
                    vm.isPieChartLoading = false;
                };

                vm.fnRefreshRelativeComponentGhostTime = function () {
                    angular.forEach(vm.componentReportedArr, function (componentGhostObj) {
                        componentGhostObj.humanDateLastUpdatedRelative = moment(componentGhostObj.humanTimestamp).fromNow();
                    });
                    vm.repeatativeComponentGhostTimer = $timeout(function () {
                        vm.fnRefreshRelativeComponentGhostTime();
                    }, 60000)
                };

                vm.fnGetTypeDefinition = function (componentReportedArr) {
                    TypeFactory.getType({typeId: vm.selectedComponent.typeId})
                        .then(function (response) {
                            vm.typeObj = angular.copy(response);
                            if (Object.keys(response.definitions).length) {
                                angular.forEach(componentReportedArr, function (componentReportedObj) {
                                    Object.keys(response.definitions).forEach(function (key) {
                                        if (componentReportedObj.name === key) {
                                            componentReportedObj.editable = true;
                                            var inputObj = {};
                                            inputObj[key] = response.definitions[key];
                                            componentReportedObj.schema = SchemaService.convertJsonToSchema(inputObj);
                                            angular.forEach(componentReportedObj.schema, function (tempObj) {
                                                if (tempObj.default) {
                                                    tempObj.typeValue = tempObj.default;
                                                } else {
                                                    tempObj.typeValue = "";
                                                }
                                                tempObj.isValueMissing = false;
                                                tempObj.isPatternMismatch = false;
                                                tempObj.isMinError = false;
                                                tempObj.isMaxError = false;
                                            });
                                        }
                                    })
                                });
                                vm.selectedTab = vm.tabs[0];
                                vm.isComponentGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                })
                            } else {
                                vm.selectedTab = vm.tabs[0];
                                vm.isComponentGhostDetailsLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                })
                            }
                            vm.fnGetUnhealthyAndHealthyAttribute(componentReportedArr);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.selectedTab = vm.tabs[0];
                            vm.isComponentGhostDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            });
                            vm.fnGetUnhealthyAndHealthyAttribute(componentReportedArr);
                        })
                };

                vm.fnGetUnhealthyAndHealthyAttribute = function (componentReportedArr) {
                    vm.recentlyUpdatedComponentReportedArr = [];
                    vm.unhealthyComponentReportedArr = [];
                    currentTime = Date.now();
                    _.forEach(componentReportedArr, function (comtponentReporedObj) {
                        var recentlyUpdateTimeStampData = hours * 60 * 60 * 1000;
                        var deviceTimeStampDiff = currentTime - comtponentReporedObj.timestamp;
                        if (deviceTimeStampDiff <= recentlyUpdateTimeStampData) {
                            vm.recentlyUpdatedComponentReportedArr.push(comtponentReporedObj);
                        }
                        if (comtponentReporedObj.health > 299) {
                            vm.unhealthyComponentReportedArr.push(comtponentReporedObj);
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCopyToClipboard = function (value, duration) {
                    vm.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        vm.isCopyClicked = false;
                    }, duration)
                };

                vm.fnEnableDisableAttribute = function (componentGhostObj) {
                    vm.isFileViewUpdating = false;
                    var inputObj = {};
                    if (angular.isUndefined(componentGhostObj.enabled) || componentGhostObj.enabled === true) {
                        inputObj = {
                            deviceId: inventoryObj.id.substring(0, inventoryObj.id.lastIndexOf("-")),
                            componentId: inventoryObj.id,
                            attributeName: componentGhostObj.name
                        };
                        ComponentFactory.disableComponentAttribute(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    componentGhostObj.enabled = false;
                                    vm.isFileViewUpdating = false;
                                    amaran.success("The Attribute disable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    componentGhostObj.enabled = true;
                                    vm.isFileViewUpdating = false;
                                    amaran.error("Attribute Disable was unsuccessful")
                                }
                            })
                    } else {
                        inputObj = {
                            deviceId: inventoryObj.id.substring(0, inventoryObj.id.lastIndexOf("-")),
                            componentId: inventoryObj.id,
                            body: componentGhostObj
                        };
                        ComponentFactory.enableComponentAttribute(inputObj)
                            .then(function (response) {
                                if (!response.errors) {
                                    componentGhostObj.enabled = true;
                                    vm.isFileViewUpdating = false;
                                    amaran.success("The Attribute enable request is being processed. The current progress can be viewed in the Lifecycles.");
                                } else {
                                    componentGhostObj.enabled = false;
                                    vm.isFileViewUpdating = false;
                                    amaran.error("Attribute enable was unsuccessful")
                                }
                            })
                    }
                };

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    $timeout.cancel(overLayWebSocketTimeout);
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.componentReportedArr, function (ghostObj) {
                        return ghostObj.name === messageJson.name;
                    });
                    var healthObj = {};
                    if (index !== -1 && vm.componentReportedArr[index]) {
                        if (messageJson.health && vm.componentReportedArr[index].health !== messageJson.health) {
                            vm.componentReportedArr[index].health = messageJson.health;
                            healthObj = ColorService.getHealthColorForLoop(vm.componentReportedArr[index].health);
                            vm.componentReportedArr[index].healthName = healthObj.content;
                            vm.componentReportedArr[index].healthColor = healthObj['background-color'];
                            vm.componentReportedArr[index].textColor = healthObj.color;
                            if (vm.componentReportedArr[index].healthName === vm.componentReportedArr[index].health) {
                                vm.componentReportedArr[index].toolTipName = vm.componentReportedArr[index].health;
                            } else {
                                vm.componentReportedArr[index].toolTipName = vm.componentReportedArr[index].healthName + " "
                                    + vm.componentReportedArr[index].health;
                            }
                        }
                        if (messageJson.value) {
                            vm.componentReportedArr[index].value = messageJson.value;
                            vm.componentReportedArr[index].displayValue = vm.componentReportedArr[index].enabled === false ? 'disabled' : vm.componentReportedArr[index].value === "__empty" ? "" : vm.componentReportedArr[index].value;
                        }
                        vm.componentReportedArr[index].timestamp = Math.floor(Date.now());
                        vm.componentReportedArr[index].humanTimestamp = moment(vm.componentReportedArr[index].timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                        vm.componentReportedArr[index].humanDateLastUpdatedAbsolute = moment(vm.componentReportedArr[index].timestamp).format('MMMM Do YYYY, h:mm:ss a');
                        vm.componentReportedArr[index].humanDateLastUpdatedRelative = moment(vm.componentReportedArr[index].humanTimestamp).fromNow();
                        $timeout(function () {
                            vm.componentReportedArr[index].isProcessing = false;
                        });
                        $timeout(function () {
                            vm.fnUpdateAttributeOnWSS(vm.componentReportedArr[index]);
                        });
                    }
                }

                vm.fnUpdateAttributeOnWSS = function (obj) {
                    var recentlyUpdatedIndex = _.findIndex(vm.recentlyUpdatedComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (recentlyUpdatedIndex !== -1) {
                        vm.recentlyUpdatedComponentReportedArr.splice(recentlyUpdatedIndex, 1);
                    }
                    var unhealthyComponentIndex = _.findIndex(vm.unhealthyComponentReportedArr, function (ghostObj) {
                        return ghostObj.name === obj.name;
                    });
                    if (unhealthyComponentIndex !== -1) {
                        vm.unhealthyComponentReportedArr.splice(unhealthyComponentIndex, 1);
                    }
                    vm.recentlyUpdatedComponentReportedArr.push(obj);
                    if (obj.health > 299) {
                        vm.unhealthyComponentReportedArr.push(obj);
                    }
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    });
                };

                vm.fnInitializeWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/attributes/" + vm.selectedInventoryObj.id})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("component ghost websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("component ghost websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnInitializeComponentsWebSockets = function () {
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/components/" + vm.selectedInventoryObj.id.substring(0, vm.selectedInventoryObj.id.lastIndexOf("-"))})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onComponentsConnectionLost;
                            client.onMessageArrived = onComponentsMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("inventory websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("inventory websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                function onComponentsConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeComponentsWebSockets();
                    }
                }

                function onComponentsMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    $timeout.cancel(inventoryTimer);
                    inventoryTimer = $timeout(function () {
                        var index = _.findIndex(vm.breadcrumbArray, function (breadcrumbObj) {
                            return breadcrumbObj.isClickable && breadcrumbObj.inventorieObj.id === messageJson.id;
                        });
                        if (index !== -1 && vm.breadcrumbArray[index]) {
                            if (messageJson.health) {
                                var healthObj = ColorService.getHealthColorForLoop(messageJson.health);
                                vm.breadcrumbArray[index].healthName = healthObj.content;
                                vm.breadcrumbArray[index].healthColor = healthObj['background-color'];
                                vm.breadcrumbArray[index].textColor = healthObj.color;
                                if (vm.breadcrumbArray[index].healthName === messageJson.health) {
                                    vm.breadcrumbArray[index].inventorieObj.toolTipName = messageJson.health;
                                } else {
                                    vm.breadcrumbArray[index].inventorieObj.toolTipName = vm.breadcrumbArray[index].healthName + " "
                                        + messageJson.health;
                                }
                            }
                        }
                    }, 2000);
                }

                vm.fnCreateObserverCondition = function (componentGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/observerConditionModal/observerConditionModal.html',
                        size: 'lg',
                        controller: 'observerConditionModalCtrl as observerConditionModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            selectedComponent: function () {
                                return vm.selectedComponent;
                            },
                            componentGhostObj: function () {
                                return componentGhostObj;
                            },
                            typeObj: function () {
                                return vm.typeObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function (res) {
                        if (res === 'dismiss') {
                            $uibModalInstance.dismiss('cancel');
                        }
                    });
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                vm.fnShowAllGhostAttributes = function () {
                    vm.isShowAllGhostAttributes = true;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.fnEditGhostValue = function (componentGhostObj) {
                    vm.selectedGhostObj = componentGhostObj.schema;
                    vm.fnOpenModifyGhostAttributeModal();
                };

                vm.fnGoBackToTableView = function () {
                    vm.selectedGhostObj = {};
                    vm.isGhostDetailsEditable = false;
                    $timeout(function () {
                        vm.fnSetTreeHeight();
                    })
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isEditInputValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.ghostUpdateObj = propertiesObj;
                    } else {
                        vm.ghostUpdateObj = {};
                    }
                };

                vm.fnUpdateGhostValue = function () {
                    vm.isGhostUpdateCompleted = false;
                    var inputObj = {
                        deviceId: vm.selectedInventoryObj.id.substring(0, vm.selectedInventoryObj.id.lastIndexOf("-")),
                        componentId: vm.selectedInventoryObj.id,
                        body: {
                            state: {
                                metadata: vm.ghostUpdateObj
                            }
                        }
                    };
                    ComponentFactory.modifyComponentGhost(inputObj)
                        .then(function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isComponentGhostDetailsLoaded = false;
                            vm.fnGetComponentData(vm.selectedInventoryObj);
                            amaran.success("Ghost Value Updated");
                        }, function () {
                            vm.isGhostUpdateCompleted = true;
                            vm.fnGoBackToTableView();
                            vm.isComponentGhostDetailsLoaded = false;
                            vm.fnGetComponentData(vm.selectedInventoryObj);
                        })
                };

                vm.fnOpenModifyGhostAttributeModal = function () {
                    var inputObj = {
                        deviceId: vm.selectedInventoryObj.id.substring(0, vm.selectedInventoryObj.id.lastIndexOf("-")),
                        componentId: vm.selectedInventoryObj.id,
                        body: {}
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/modifyGhostAttribute/modifyGhostAttribute.html',
                        size: 'md',
                        controller: 'modifyGhostAttributeCtrl as modifyGhostAttribute',
                        resolve: {
                            selectedGhostObj: function () {
                                return angular.copy(vm.selectedGhostObj);
                            },
                            ghostType: function () {
                                return 'Component'
                            },
                            requiredInputObj: function () {
                                return inputObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        vm.selectedGhostObj = {};
                    }, function () {
                        vm.selectedGhostObj = {};
                    });
                };

                vm.fnGetAnalyticsQuery = function (id) {
                    vm.isAggregateHealthLoading = true;
                    var inputObj = {
                        "dataSets": ["AGGREGATE"],
                        "nodeId": id,
                        "timeRange": {}
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };

                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsData = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if (response && response.data && response.data.data) {
                                vm.analyticsData = response.data.data;
                            } else {
                                vm.analyticsData = {};
                            }
                            if (response && response.data && response.data.meta) {
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            } else {
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateCompoentAnalyticsData(timeStampsArr);
                    }, function error() {
                        vm.analyticsData = {};
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateCompoentAnalyticsData(timeStampsArr);
                    });
                };

                vm.fnCreateCompoentAnalyticsData = function (timeStampsArr) {
                    vm.aggregateHealthArr = [];
                    if (vm.analyticsData && vm.analyticsData.AGGREGATE && vm.analyticsData.AGGREGATE.points) {
                        var gatewayAnalyticsb64String = vm.analyticsData.AGGREGATE.points;
                        var gatewayAnalyticsCSVString = analyticsService.getCSVString(gatewayAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAggregateHealthData(gatewayAnalyticsCSVString);
                        var gatewayPieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.length) {
                            vm.aggregateHealthArr = tempAggregateHealthArr;
                            var gatewayPieChartString = vm.analyticsData.AGGREGATE.summary;
                            var gatewayPieChartAnalyticsCSVString = analyticsService.getCSVString(gatewayPieChartString);
                            gatewayPieChartAnalyticsData = analyticsService.getAggregateHealthPieChartData(gatewayPieChartAnalyticsCSVString);
                        } else {
                            gatewayPieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        }
                        vm.fnGeneratePieDataForComponent(gatewayPieChartAnalyticsData);
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        vm.fnGeneratePieDataForComponent(pieChartAnalyticsData);
                    }
                    vm.isAggregateHealthLoading = false;
                };

                vm.fnCreateAggregateStaticHealth = function (timeStampsArr) {
                    var analyticsHealthArr = [];
                    var tempIndex = 0;
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var healthObj = ColorService.getHealthColorForLoop(parseInt(vm.selectedInventoryObj.health));
                        vm.aggregateHealthArr.push({
                            x: 0,
                            y: tempIndex,
                            value: parseInt(vm.selectedInventoryObj.health),
                            color: healthObj['background-color'],
                            healthObj: healthObj,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsHealthArr.push({
                            duration: 100,
                            health: parseInt(vm.selectedInventoryObj.health),
                            healthObj: healthObj,
                            id: vm.selectedInventoryObj.id,
                            percentage: 100,
                            marker: {fillColor: healthObj['background-color']}
                        });
                        tempIndex++
                    });
                    return analyticsHealthArr;
                };

                vm.fnGeneratePieDataForComponent = function (healthArr) {
                    var pieData = [];
                    var groupedHealthObj = _.mapValues(_.groupBy(healthArr, "health"), function (v) {
                        return _.sortBy(v, "health");
                    });
                    _.forEach(groupedHealthObj, function (val, key) {
                        var totalP = 0;
                        _.forEach(val, function (valObj) {
                            totalP = totalP + valObj.percentage
                        });
                        var healthObj = ColorService.getHealthColorForLoop(key);
                        pieData.push({
                            name: healthObj.content,
                            y: totalP,
                            color: healthObj['background-color'],
                            healthTextColor: healthObj.color
                        })
                    });
                    vm.componentHealthPieData = pieData;
                };

                vm.fnOpenDateTimeHelpModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html',
                        size: 'lg',
                        controller: 'analyticsDateTimeHelpModalCtrl as analyticsDateTimeModal',
                        resolve: {
                            selectedTime: function () {
                                return vm.selectedFilterObj;
                            },
                            selectedAggregateFn: function () {
                                return vm.selectedAggregateFn;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.selectedFilterObj = response.selectedTime;
                        vm.selectedAggregateFn = response.selectedAggregateFn;
                        vm.healthData = [];
                        vm.fnGetAnalyticsQuery(vm.selectedInventoryObj.id);
                    }, function () {
                        vm.healthData = [];
                        vm.fnGetAnalyticsQuery(vm.selectedInventoryObj.id);
                    });
                };

                var count = 0;
                vm.fnInitAttributeAnalytics = function (count) {
                    vm.isAttributeAnalyticsDataFetch = false;
                    if (count < vm.componentReportedArr.length) {
                        vm.fnGetAttributeAnalyticsValue(count);
                    } else {
                        $timeout(function () {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        });
                    }
                };

                vm.fnGetAttributeAnalyticsValue = function (count) {
                    if (vm.componentReportedArr[count].health > 299) {
                        var duration = moment.duration(vm.currentTime.diff(vm.componentReportedArr[count].timestamp));
                        var minutes = duration.asMinutes();
                        if (minutes < 10) {
                            var body = {
                                dataSets: ["ATOMIC"],
                                nodeId: vm.selectedInventoryObj.id,
                                timeRange: {
                                    relative: {
                                        start: "10m"
                                    }
                                },
                                attributeQuery: {
                                    attributeName: vm.componentReportedArr[count].name,
                                    queryType: "VALUE"
                                }
                            };
                            var headers = {
                                'Content-Type': 'application/json',
                                'x-pre-api-version': '4',
                                'authorization': 'Bearer ' + $cookies.get('phoenix')
                            };
                            var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                            $http({
                                method: "POST",
                                url: apiURL,
                                responseType: 'application/json',
                                headers: headers,
                                data: body
                            }).then(function (response) {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                if (response && response.status && response.data &&
                                    !response.status.toString().startsWith('20')) {
                                    vm.analyticsValueData = {};
                                    amaran.error(response.data.message);
                                } else {
                                    if(response && response.data && response.data.data){
                                        vm.analyticsValueData = response.data.data;
                                    }else{
                                        vm.analyticsValueData = {};
                                    }
                                    if (response && response.data && response.data.meta) {
                                        startTime = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                        endTime = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                    }
                                }
                                if (vm.analyticsValueData && vm.analyticsValueData.ATOMIC && vm.analyticsValueData.ATOMIC.points) {
                                    var attributeAnalyticsb64String = vm.analyticsValueData.ATOMIC.points;
                                    var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                                    var tempAggregateHealthArr = analyticsService.getAttributeValueData(attributeAnalyticsCSVString);
                                    if (tempAggregateHealthArr.attributeValueData.length) {
                                        var analyticsAttrValueArr = [];
                                        var valuesArr = tempAggregateHealthArr.attributeValuesArr.sort(function (a, b) {
                                            return a - b;
                                        });
                                        _.forEach(tempAggregateHealthArr.attributeValueData, function (obj) {
                                            analyticsAttrValueArr.push({
                                                x: obj.x,
                                                y: valuesArr.indexOf(obj.y),
                                                name: obj.y
                                            })
                                        });
                                        vm.componentReportedArr[count].inlineChartData = analyticsAttrValueArr;
                                    } else {
                                        vm.componentReportedArr[count].inlineChartData = [{
                                            x: startTime,
                                            y: 0,
                                            name: vm.componentReportedArr[count].value
                                        }, {
                                            x: endTime,
                                            y: 0,
                                            name: vm.componentReportedArr[count].value
                                        }];
                                    }
                                    count++;
                                    if (count < vm.componentReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                } else {
                                    vm.componentReportedArr[count].inlineChartData = [{
                                        x: startTime,
                                        y: 0,
                                        name: vm.componentReportedArr[count].value
                                    }, {
                                        x: endTime,
                                        y: 0,
                                        name: vm.componentReportedArr[count].value
                                    }];
                                    count++;
                                    if (count < vm.componentReportedArr.length) {
                                        vm.fnGetAttributeAnalyticsValue(count);
                                    } else {
                                        //done
                                        vm.isAttributeAnalyticsDataFetch = true;
                                        $timeout(function () {
                                            vm.fnSetTreeHeight();
                                        })
                                    }
                                }
                            }, function error() {
                                var startTime = moment().subtract(10, 'minutes').valueOf();
                                var endTime = moment().valueOf();
                                vm.componentReportedArr[count].inlineChartData = [{
                                    x: startTime,
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }, {
                                    x: endTime,
                                    y: 0,
                                    name: vm.componentReportedArr[count].value
                                }];
                                count++;
                                if (count < vm.componentReportedArr.length) {
                                    vm.fnGetAttributeAnalyticsValue(count);
                                } else {
                                    //done
                                    vm.isAttributeAnalyticsDataFetch = true;
                                    $timeout(function () {
                                        vm.fnSetTreeHeight();
                                    })
                                }
                            });
                        } else {
                            var newChartData1 = [{
                                x: moment().subtract(10, 'minutes').valueOf(),
                                y: 0,
                                name: vm.componentReportedArr[count].value
                            }, {
                                x: moment().valueOf(),
                                y: 0,
                                name: vm.componentReportedArr[count].value
                            }];
                            vm.componentReportedArr[count].inlineChartData = newChartData1;
                            count++;
                            if (count < vm.componentReportedArr.length) {
                                vm.fnGetAttributeAnalyticsValue(count);
                            } else {
                                vm.isAttributeAnalyticsDataFetch = true;
                                $timeout(function () {
                                    vm.fnSetTreeHeight();
                                })
                            }
                        }
                    } else {
                        vm.componentReportedArr[count].inlineChartData = [];
                        count++;
                        if (count < vm.componentReportedArr.length) {
                            vm.fnGetAttributeAnalyticsValue(count);
                        } else {
                            //done
                            vm.isAttributeAnalyticsDataFetch = true;
                            $timeout(function () {
                                vm.fnSetTreeHeight();
                            })
                        }
                    }
                };

                vm.fnOpenAttributeStatistics = function (selectedAttribute) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html',
                        size: 'lg',
                        controller: 'attributeStatisticsModalCtrl as attributeStatistics',
                        resolve: {
                            selectedAttribute: function () {
                                return selectedAttribute;
                            },
                            selectedComponent: function () {
                                return vm.selectedComponent;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        }, 1000)
                    }, function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        }, 1000)
                    });
                };

                vm.fnRenameAttribute = function (componentGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeRenameModal/attributeRenameModal.html',
                        size: 'md',
                        controller: 'attributeRenameModalCtrl as attributeRenameModal',
                        resolve: {
                            selectedGhostObj: function () {
                                return _.cloneDeepWith(componentGhostObj);
                            },
                            ghostType: function () {
                                return 'Component'
                            },
                            id: function () {
                                return vm.selectedInventoryObj.id;
                            }
                        }
                    });
                    modalInstance.result.then(function (newName) {
                        componentGhostObj.displayName = newName;
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        }, 1000)
                    }, function () {
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        }, 1000)
                    });
                };

                vm.fnManageIssue = function (componentGhostObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/attributeManageIssueTemplateModal/attributeManageIssueTemplateModal.html',
                        size: 'lg',
                        controller: 'attributeManageIssueTemplateModalCtrl as attributeManageIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueType: function () {
                                return "component"
                            },
                            GhostObj: function () {
                                return componentGhostObj;
                            },
                            componentObj: function () {
                                return vm.selectedInventoryObj;
                            },
                            deviceObj: function () {
                                return vm.deviceObj;
                            },
                            gatewayObj: function () {
                                return vm.gatewayObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                            $uibModalInstance.dismiss('cancel');
                        })
                    }, function () {
                        $timeout(function () {
                            // vm.fnUpdateComponentSupplementalData(response, true);
                            $uibModalInstance.dismiss('cancel');
                        })
                    });
                };

                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };

                vm.fnInitModel = function () {
                    vm.observerPermissionsObj = PermissionsService.getPermissions("node:observer");
                    vm.componentPermissionsObj = PermissionsService.getPermissions("node:component");
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    vm.selectedInventoryObj = inventoryObj;
                    vm.parentInventories = parentInventories;
                    vm.deviceObj = deviceObj;
                    vm.gatewayObj = gatewayObj;
                    vm.isComponentGhostDetailsLoaded = false;
                    vm.fnInitializeWebSockets();
                    vm.fnInitializeComponentsWebSockets();
                    if (vm.selectedInventoryObj.id) {
                        var tempBreadcrumbStr = vm.selectedInventoryObj.index;
                        vm.tempBreadcrumbArr = tempBreadcrumbStr.split("#");
                        var tempArr = [];
                        var tempString = '';
                        _.forEach(vm.tempBreadcrumbArr, function (value) {
                            var tempObj = {};
                            tempString = tempString === '' ? value : tempString + "#" + value;
                            var isValueFind = _.find(vm.parentInventories, {'index': tempString});
                            if (isValueFind && isValueFind.enabled === true) {
                                tempObj.isClickable = true;
                                tempObj.displayName = isValueFind.name && isValueFind.name !== ' ' ? isValueFind.name : value.replace(':', ' ');
                                tempObj.inventorieObj = isValueFind;
                                var healthObj = ColorService.getHealthColorForLoop(isValueFind.health);
                                tempObj.healthName = healthObj.content;
                                tempObj.healthColor = healthObj['background-color'];
                                tempObj.textColor = healthObj.color;
                            } else {
                                tempObj.isClickable = false;
                                tempObj.displayName = value.replace(':', ' ');
                                tempObj.inventorieObj = {};
                            }
                            tempArr.push(tempObj);
                        });
                        vm.breadcrumbArray = tempArr;
                    }
                    vm.fnGetComponentData(vm.selectedInventoryObj);
                    vm.fnGetAnalyticsQuery(vm.selectedInventoryObj.id);
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.repeatativeComponentGhostTimer);
                    if (client) {
                        client.disconnect();
                    }
                });
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('deviceInfo', fnDeviceInfo)

    /** @ngInject */
    function fnDeviceInfo($window, $state, $http, $stateParams, $timeout, $cookies, microSpinner, swal, amaran, DB, copyService, IconService, ColorService, DeviceFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/device/devicesInfo/devicesInfo.html',
            scope: {
                deviceObj: '=',
                typesArr: '=',
                infoSectionClass: "=",
                devicePermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                $scope.$watch('infoSectionClass', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.infoSectionClass = newValue;
                        $scope.$broadcast('redrawChart', $scope.infoSectionClass);
                    }
                }, true);

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                if ($scope.deviceObj.hasComponents === true) {
                    $scope.tabs = [
                        {
                            title: 'Overview',
                            tabIndex: 1,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceOverview/deviceOverview.html',
                            visible: true
                        },
                        {
                            title: 'Inventory',
                            tabIndex: 2,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceInventory/deviceInventory.html',
                            visible: true
                        },
                        {
                            title: 'Alarms',
                            tabIndex: 3,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceAlarms/deviceAlarms.html',
                            visible: true
                        },
                        {
                            title: 'Location',
                            tabIndex: 4,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceLocation/devicesLocation.html',
                            visible: true
                        },
                        {
                            title: 'Clusters',
                            tabIndex: 5,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceClusters/devicesClusters.html',
                            visible: true
                        },
                        {
                            title: 'Telemetry',
                            tabIndex: 6,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/devicesGhost/devicesGhost.html',
                            visible: true
                        },
                        {
                            title: 'Observer',
                            tabIndex: 7,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceObserver/deviceObserver.html',
                            visible: true
                        },
                        {
                            title: 'Details',
                            tabIndex: 8,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/details.html',
                            visible: true
                        },
                        {
                            title: 'Supplemental',
                            tabIndex: 9,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceSupplemental/deviceSupplemental.html',
                            visible: true
                        }
                    ];
                } else {
                    $scope.tabs = [
                        {
                            title: 'Overview',
                            tabIndex: 1,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceOverview/deviceOverview.html',
                            visible: true
                        },
                        {
                            title: 'Telemetry',
                            tabIndex: 2,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/devicesGhost/devicesGhost.html',
                            visible: true
                        },
                        {
                            title: 'Details',
                            tabIndex: 3,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/details.html',
                            visible: true
                        },
                        {
                            title: 'Location',
                            tabIndex: 4,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceLocation/devicesLocation.html',
                            visible: true
                        },
                        {
                            title: 'Clusters',
                            tabIndex: 5,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceClusters/devicesClusters.html',
                            visible: true
                        },
                        {
                            title: 'Supplemental',
                            tabIndex: 6,
                            templateUrl: 'app/node/device/devicesInfo/devicesTabs/deviceSupplemental/deviceSupplemental.html',
                            visible: true
                        }
                    ];
                }
                $scope.isOpenNativeInterface = false;
                $scope.componentTabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1,
                        templateUrl: 'app/node/device/devicesInfo/componentTabs/componentOverview/componentOverview.html',
                        visible: true
                    },
                    {
                        title: 'Telemetry',
                        tabIndex: 2,
                        templateUrl: 'app/node/device/devicesInfo/componentTabs/componentGhost/componentGhost.html',
                        visible: true
                    },
                    {
                        title: 'Details',
                        tabIndex: 3,
                        templateUrl: 'app/node/device/devicesInfo/componentTabs/componentDetails/componentDetails.html',
                        visible: true
                    },
                    {
                        title: 'Supplemental',
                        tabIndex: 4,
                        templateUrl: 'app/node/device/devicesInfo/componentTabs/componentSupplemental/componentSupplemental.html',
                        visible: true
                    }
                ];

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.devicePropertiesArr = [];
                $scope.resetDevicePropertiesArr = [];

                $scope.isComponentViewSelected = false;
                $scope.isSessionEnd = false;
                $scope.isSessionStart = false;
                $scope.isFindError = false;
                $scope.isNativeLaunchNewTab = false;
                $scope.errorMessage = '';
                $scope.nmsLoadMessage = '';
                $scope.nmsInformationMessage = '';
                $scope.nmsSavedURL = '';
                $scope.isIframeLoaded = true;
                $scope.fnGetDevice = function (deviceId) {
                    var inputObj = {
                        deviceId: deviceId
                    };
                    DeviceFactory.getDevice(inputObj)
                        .then(function (response) {
                            $scope.devicePropertiesArr = [];
                            $scope.resetDevicePropertiesArr = [];
                            response.hasComponents = $scope.deviceObj.hasComponents;
                            $scope.deviceObj = response;
                            $scope.deviceTypeInfo = _.find($scope.typesArr, {id: $scope.deviceObj.typeId});
                            if ($scope.deviceObj.properties) {
                                Object.keys($scope.deviceObj.properties).forEach(function (key) {
                                    $scope.devicePropertiesArr.push({
                                        key: key,
                                        value: $scope.deviceObj.properties[key],
                                        isPreDefine: true
                                    })
                                });
                                $scope.resetDevicePropertiesArr = angular.copy($scope.devicePropertiesArr);
                            }
                            $scope.resetDeviceObj = angular.copy($scope.deviceObj);
                            $scope.isDeviceDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDeviceDetailsLoaded = true;
                        })
                };

                $scope.fnDetermineType = function (deviceObj) {
                    if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                        if (deviceObj.hasComponents !== true) {
                            $scope.selectedTab = parseInt($stateParams.selectedDetailsTab) === 7 ? 6 : parseInt($stateParams.selectedDetailsTab);
                        } else {
                            $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                        }
                    } else {
                        $scope.selectedTab = 1
                    }
                };

                $scope.fnUpdateDeviceDetails = function (deviceObj) {
                    var inputObj = {
                        body: {},
                        deviceId: deviceObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(deviceObj.description)) {
                        deviceObj.description = '';
                    }
                    var propertiesObj = {};
                    _.forEach($scope.devicePropertiesArr, function (propertyObj) {
                        if (propertyObj.key && propertyObj.key.length && propertyObj.value && propertyObj.value.length) {
                            propertiesObj[propertyObj.key] = propertyObj.value;
                        }
                    });
                    inputObj.body = {
                        name: deviceObj.name,
                        description: deviceObj.description,
                        properties: deviceObj.propertiesObj
                    };
                    DeviceFactory.modifyDevice(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetDeviceObj = angular.copy(response);
                            $scope.$emit('DeviceDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Device Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteDevice = function (deviceObj) {
                    swal({
                            title: "Delete the selected device?",
                            text: "You are about to permanently delete the selected device.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    deviceId: deviceObj.id
                                };
                                DeviceFactory.deleteDevice(inputObj)
                                    .then(function () {
                                        $scope.$emit('DeviceDeleted', deviceObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnAddNewKvp = function () {
                    $scope.devicePropertiesArr.push({
                        key: '',
                        value: ''
                    })
                };

                $scope.fnRemoveKvpPair = function (index) {
                    $scope.devicePropertiesArr.splice(index, 1);
                    if (!$scope.devicePropertiesArr.length) {
                        $scope.devicePropertiesArr = [{
                            key: '',
                            value: ''
                        }]
                    }
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.deviceObj = angular.copy($scope.resetDeviceObj);
                    $scope.devicePropertiesArr = angular.copy($scope.resetDevicePropertiesArr);
                    $scope.isDetailsEditable = false
                };

                $scope.fnExitEditMode = function () {
                    $scope.deviceObj = angular.copy($scope.resetDeviceObj);
                    $scope.isDetailsEditable = false;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element("#nativeIFrame")) {
                            angular.element("#nativeIFrame").css('height', '100%');
                            angular.element("#nativeIFrame").css('width', '100%');
                        }
                    }
                };

                $scope.fnGetHealthColor = function (health, deviceObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    deviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                $scope.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                $scope.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                $scope.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.device', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnComponentTabSelected = function (tab) {
                    $scope.componentSelectedTab = tab.tabIndex;
                };

                $scope.fnDeviceInfoSectionFullScreen = function () {
                    $scope.$emit('DeviceInfoSectionClick');
                };

                $scope.$on("setGatewayObjForComponent", function (evt, data) {
                    $scope.cmpGatewayObj = data;
                });

                $scope.$on("ComponentSelected", function (evt, data) {
                    $scope.selectedComponent = data;
                    $scope.componentSelectedTab = 1;
                    $scope.isComponentViewSelected = true;
                });
                $scope.$on("getInventorySelected", function (evt, data) {
                    $scope.inventoriesArr = data;
                    $scope.componentSelectedTab = 1;
                    $scope.isComponentViewSelected = true;
                });

                $scope.$on("GoBackToInventory", function () {
                    $state.go('main.device', {selectedComponentId: ''}, {notify: false});
                    delete $stateParams.selectedComponentId;
                    $scope.cmpGatewayObj = null;
                    $scope.selectedComponent = {};
                    $scope.isComponentViewSelected = false;
                    $scope.$broadcast("CallInventoryResize");
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    }, 1000);
                });

                $scope.$on('SetSelectedComponent', function (evt, data) {
                    $scope.selectedComponent = data;
                });

                $scope.$on('UnsetSelectedComponent', function () {
                    $scope.selectedComponent = {};
                });

                $scope.$on('OpenNativeInterface', function (evt, data) {
                    $scope.isOpenNativeInterface = data;
                    $timeout(function () {
                        $scope.$emit('DeviceInfoSectionClick');
                    });
                });

                $scope.fnCloseNativeConsole = function () {
                    $scope.isOpenNativeInterface = false;
                    $scope.isSessionEnd = false;
                    $scope.isSessionStart = false;
                    $scope.minutes = "00";
                    $scope.seconds = "00";
                    $timeout(function () {
                        $scope.$emit('DeviceInfoSectionClick');
                    });
                };

                $scope.fnConfirmAndOpenNewTab = function () {
                    $window.open($scope.nmsSavedURL, '_blank');
                };

                $scope.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                $scope.fnInitDevice = function (isCalledFromInitial) {
                    if (isCalledFromInitial) {
                        $scope.fnDetermineType($scope.deviceObj);
                    } else {
                        $scope.isDeviceDetailsLoaded = false;
                        $scope.deviceId = $scope.deviceObj.id;
                        if ($scope.deviceId) {
                            $scope.fnGetDevice($scope.deviceId, isCalledFromInitial);
                        }
                    }
                    $scope.fnSetTabHeight();
                };

                $scope.fnInitDeviceTunnel = function () {
                    var timeout = 600;
                    var uniqueSessionId = guid();
                    $scope.isFindError = false;
                    $scope.minutes = "10";
                    $scope.seconds = "00";
                    $scope.isDeviceDeviceTunnelLoaded = false;
                    $scope.nmsLoadMessage = 'One moment while we create a secure tunnel';
                    $scope.nmsInformationMessage = 'This can take up to 60 seconds';
                    var basePath = '';
                    var url = HOST_URL.tracker.split("https://")[1]; //eslint-disable-line
                    var environment = 'prod';
                    if (url.startsWith('dev')) {
                        environment = 'dev';
                        basePath = 'https://dev-tunnel.predictivetech.io'
                    } else {
                        basePath = 'https://tunnel.predictivetech.io'
                    }
                    var apiURL = basePath + "/tunnel/"; //eslint-disable-line
                    var headers = {
                        'Content-Type': 'application/json',
                        'deviceId': $scope.deviceObj.id,
                        'timeout': timeout,
                        'predictivetunnel': uniqueSessionId,
                        'predictiveEnvironment': environment
                    };
                    $http({
                        method: "GET",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers
                    }).then(function (response) {
                        if (response && (response.data === null || (response.status && !response.status.toString().startsWith('20')))) {
                            amaran.error(response.data === null ? 'We encountered an error while trying to establish a secure connection. To protect your privacy we do not establish connections to public IPs from the Gateway. Please make sure the device is registered on an IP local to the Gateway.' : !response.data.message ? response.statusText : response.data.message);
                            $scope.isFindError = true;
                            $scope.errorMessage = response.data === null ? 'We encountered an error while trying to establish a secure connection. To protect your privacy we do not establish connections to public IPs from the Gateway. Please make sure the device is registered on an IP local to the Gateway.' : !response.data.message ? response.statusText : response.data.message;
                            $scope.isDeviceDeviceTunnelLoaded = true;
                        } else {
                            var deviceTypeInfo = _.find($scope.typesArr, {id: $scope.deviceObj.typeId});
                            if (($scope.deviceObj.nativeUiType && $scope.deviceObj.nativeUiType === "Window") || deviceTypeInfo.oem === 'CommScope') { //CommScope
                                $scope.isNativeLaunchNewTab = true;
                                $scope.isDeviceDeviceTunnelLoaded = true;
                                $scope.nmsLoadMessage = 'WARNING The remote NMS uses an insecure frame design. To protect you the interface will be opened in a new tab. ';
                                $scope.nmsInformationMessage = 'Note that the session timer will not be visible in the new tab.';
                                $scope.nmsSavedURL = basePath + ":" + response.data.tunnel_port + "/?predictivetunnel=" + uniqueSessionId;
                            } else {
                                $scope.isNativeLaunchNewTab = false;
                                $scope.nmsLoadMessage = 'Tunnel successfully created.\n One moment while we connect you';
                                $scope.nmsInformationMessage = 'This can take up to 10 seconds';
                                $scope.isDeviceDeviceTunnelLoaded = true;
                                $scope.isSessionStart = true;
                                $scope.isSessionEnd = false;
                                $scope.isIframeLoaded = false;
                                $timeout(function () {
                                    $scope.fnSetTabHeight();
                                    $("#nativeIFrame").attr('src', basePath + ":" + response.data.tunnel_port + "/?predictivetunnel=" + uniqueSessionId); //eslint-disable-line
                                    $timeout(function () {
                                        $scope.isIframeLoaded = true;
                                        startTimer();
                                    }, 10000);
                                }, 1000)
                            }
                        }
                    }, function error() {
                        $scope.isDeviceDeviceTunnelLoaded = true;
                    });
                    $scope.fnSetTabHeight();
                };

                function startTimer() {
                    var m = parseInt($scope.minutes);
                    var s = parseInt(checkSecond((parseInt($scope.seconds) - 1)));
                    if (s === 59) {
                        m = m - 1
                    }
                    if (m === 0 && s === 30) {
                        amaran.warning("Your session will expire in 30 Seconds.");
                    }
                    if (m < 0) {
                        amaran.error("Your session has expired.");
                        $scope.isSessionStart = false;
                        $scope.isSessionEnd = true;
                    } else {
                        $scope.minutes = m.toString().length === 1 ? '0' + m : m;
                        $scope.seconds = s.toString().length === 1 ? '0' + s : s;
                        $timeout(function () {
                            if (parseInt($scope.minutes) >= 0) {
                                startTimer();
                            }
                        }, 1000)
                    }
                }

                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
                }

                function checkSecond(sec) {
                    if (sec < 10 && sec >= 0) {
                        sec = "0" + sec
                    }
                    if (sec < 0) {
                        sec = "59"
                    }
                    return sec;
                }

                var deviceInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.device') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.devicePermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteDevice($scope.deviceObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.devicePermissionsObj.Modify
                                && !$scope.isDetailsEditable && $scope.selectedTab === 3 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var deviceInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.device') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', deviceInfoKeyDownEventHandler);
                document.addEventListener('keyup', deviceInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', deviceInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', deviceInfoKeyUpEventHandler);
                });

                $scope.fnInitDevice(true);
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createDeviceCtrl',
            function ($scope, $timeout, $window, $rootScope, amaran, DB, SchemaService, PermissionsService, jsonToCsvConvertService, ColorService, IconService, AppInitService, GatewayFactory, TypeFactory, DeviceFactory, ObserverFactory, $uibModal) {
                var vm = this;

                vm.title = "Create Device";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.newDeviceObj = {
                    name: '',
                    description: '',
                    typeId: '',
                    gatewayId: '',
                    properties: {}
                };
                vm.totalDeviceForGateway = 0;
                vm.isGatewayDeviceLoading = true;
                vm.devicePieCount = [{
                    name: 'Device',
                    y: vm.totalDeviceForGateway,
                    color: '#434348',
                    total: 0
                }];
                vm.showGatewayCapacityPie = false;
                vm.gatewayCapacityPieCount = [{
                    name: 'Capacity',
                    y: 0,
                    color: '#434348',
                    total: 100
                }];
                vm.defaultHealthState = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.isGatewaySelected = false;
                vm.bluePrintArr = [];
                vm.uniqueBluePrintObj = {};
                vm.uniqueSelectedBluePrintObj = {};
                vm.uniqueSelectedGatewayObj = {};
                vm.selectedBluePrint = '';
                vm.selectedGateway = '';
                vm.typePropertiesArr = [];
                vm.isTypeformValidated = false;
                vm.isButtonVisible = false;
                // search type client side
                vm.search = '';
                vm.gatewaySearch = '';
                vm.isTypesFilter = false;
                vm.isGatewaysFilter = false;
                vm.isGatewayLoaded = false;
                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var footer = 0;
                        var searchDiv = 60;
                        var deviceFunctionalModel = 0;
                        if (angular.element(".createDeviceFooter")[0]) {
                            footer = angular.element(".createDeviceFooter")[0].offsetHeight;
                        }
                        if (angular.element("#deviceFunctionalModel")[0]) {
                            deviceFunctionalModel = angular.element("#deviceFunctionalModel")[0].offsetHeight;
                        }
                        var finalHeight = total - (searchDiv + header + footer + deviceFunctionalModel);
                        var modelHeight = total - (header + footer);
                        angular.element(".deviceModelDiv").css('height', (finalHeight - 162) + 'px');
                        angular.element(".create-device-modal-body").css('height', modelHeight + 'px');
                    }
                };
                vm.activeStep = 1;

                vm.fnSetTableHeight();

                vm.fnCreateDevice = function (newDeviceObj) {
                    vm.isDeviceCreating = true;
                    var inputObj = {
                        body: newDeviceObj
                    };
                    DeviceFactory.createDevice(inputObj)
                        .then(function () {
                            vm.isdeviceCreating = false;
                            $scope.devices.fnHideShowCreateForm(); //parent function
                            vm.newDeviceObj = {
                                name: '',
                                description: '',
                                typeId: '',
                                gatewayId: '',
                                properties: {}
                            };
                            $scope.$emit('deviceAdded', 'testId');
                            amaran.success("Device registration in progress.");
                            if (vm.devicePermissionObj.List) {
                                //$scope.devices.totalItems = $scope.devices.totalItems + 1;
                                //$scope.devices.devicesArr.push(response);
                                $scope.devices.fnReload();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDeviceCreating = false;
                        })
                };

                vm.fnBluePrintSelected = function (selectedBluePrintObj, valueObj) {
                    vm.uniqueSelectedBluePrintObj = selectedBluePrintObj;
                    vm.isBluePrintSelected = false;
                    vm.newDeviceObj.typeId = selectedBluePrintObj.id;
                    if (Object.keys(selectedBluePrintObj.properties).length) {
                        vm.typePropertiesArr = angular.copy(SchemaService.convertJsonToSchema(selectedBluePrintObj.properties));
                        angular.forEach(vm.typePropertiesArr, function (tempObj) {
                            if (tempObj.default) {
                                tempObj.typeValue = tempObj.default;
                            } else {
                                if (tempObj.type === "Array") {
                                    tempObj.typeValue = [];
                                } else if (tempObj.type === 'Boolean') {
                                    tempObj.typeValue = false;
                                } else {
                                    tempObj.typeValue = "";
                                }
                            }
                            tempObj.isValueMissing = false;
                            tempObj.isPatternMismatch = false;
                            tempObj.isMinError = false;
                            tempObj.isMaxError = false;
                        });
                    } else {
                        vm.typePropertiesArr = [];
                    }
                    valueObj.isGatewayDataLoad = true;
                    $timeout(function () {
                        vm.isBluePrintSelected = true;
                        valueObj.isGatewayDataLoad = false;
                        $timeout(function () {
                            vm.activeStep = 2;
                            vm.fnSetTableHeight();
                        })
                    });
                    /*if (vm.gatwayPermissionObj.List) {
                        GatewayFactory.getGateways()
                            .then(function (res) { // Success block
                                vm.gatewaysArr = angular.copy(res);
                                vm.resetGatewaysArr = angular.copy(vm.gatewaysArr);
                                $timeout(function () {
                                    vm.isBluePrintSelected = true;
                                    valueObj.isGatewayDataLoad = false;
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    })
                                });
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                $timeout(function () {
                                    vm.isBluePrintSelected = true;
                                    valueObj.isGatewayDataLoad = false;
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    })
                                });
                            });
                    } else {
                        vm.gatewaysArr = [];
                        vm.isBluePrintSelected = true;
                        valueObj.isGatewayDataLoad = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }*/
                };

                vm.fnOpenVersionSupportModel = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/deviceVersionSupportModel/deviceVersionSupport.html',
                        size: 'md',
                        controller: 'DeviceVersionSupportCtrl as versionSupport'
                    });
                };

                vm.fnEmptySelectedGateway = function () {
                    vm.isGatewaySelected = false;
                    vm.newDeviceObj.gatewayId = ''
                };

                vm.fnGatewaySelected = function (selectedGatewayObj) {
                    vm.uniqueSelectedGatewayObj = selectedGatewayObj;
                    vm.newDeviceObj.gatewayId = selectedGatewayObj.id;
                    vm.isGatewaySelected = true;
                    vm.totalDeviceForGateway = 0;
                    vm.isGatewayDeviceLoading = true;
                    vm.devicePieCount = [{
                        name: 'Device',
                        y: vm.totalDeviceForGateway,
                        color: '#434348',
                        total: 0
                    }];
                    vm.showGatewayCapacityPie = false;
                    vm.gatewayCapacityPieCount = [{
                        name: 'Capacity',
                        y: 0,
                        color: '#434348',
                        total: 100
                    }];
                    vm.fnGetDevices({start: 0, size: 100, q: "(term field=gatewayid '" + selectedGatewayObj.id + "')"});
                    vm.fnGetGatewayTelemetry(selectedGatewayObj.id);
                    $timeout(function () {
                        vm.activeStep = 3;
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnGetGatewayTelemetry = function (gatewayId) {
                    var inputObj = {
                        gatewayId: gatewayId
                    };
                    GatewayFactory.getGatewayGhost(inputObj)
                        .then(function (res) {
                            if (res.gtw_capacity_used) {
                                vm.showGatewayCapacityPie = true;
                                var gtwCapacityUsed = 0;
                                if(res.gtw_capacity_used.reported){
                                    if(isNaN(res.gtw_capacity_used.reported)){
                                        var matches = res.gtw_capacity_used.reported.match(/(\d+)/g);
                                        var str = matches.toString();
                                        gtwCapacityUsed = parseInt(str.replace(/[,]/g, ""));
                                    }else{
                                        gtwCapacityUsed = res.gtw_capacity_used.reported;
                                    }
                                }
                                var gtwCapacityAvailable = gtwCapacityUsed > 0 ?  100 - gtwCapacityUsed : 100;
                                vm.gatewayCapacityPieCount = [{
                                    name: 'Gateway capacity used',
                                    y: gtwCapacityUsed,
                                    color: 'red',
                                    total: 100
                                }, {
                                    name: 'Gateway capacity available',
                                    y: gtwCapacityAvailable,
                                    color: 'green',
                                    total: 100
                                }];
                            } else {
                                vm.showGatewayCapacityPie = false;
                            }
                        })
                };

                vm.fnGetDevices = function (inputObj) {
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) { // Success block
                            vm.totalDeviceForGateway = vm.totalDeviceForGateway + res.hit.length;
                            if (res.hit.length < res.found) {
                                var inputObjTemp = {
                                    start: inputObj.start + inputObj.size,
                                    size: inputObj.size,
                                    q: inputObj.q
                                };
                                vm.fnGetDevices(inputObjTemp);
                            } else {
                                vm.devicePieCount = [{
                                    name: 'Device',
                                    y: vm.totalDeviceForGateway,
                                    color: '#434348',
                                    total: res.found
                                }];
                                vm.isGatewayDeviceLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewayDeviceLoading = false;
                        })
                };

                vm.fnCheckTypeFormValidation = function (isValidate, propertiesObj) {
                    vm.isTypeformValidated = isValidate;
                    if (Object.keys(propertiesObj).length) {
                        vm.newDeviceObj.properties = propertiesObj;
                    } else {
                        vm.newDeviceObj.properties = {};
                    }
                };

                vm.fnBluePrintSelectedForCSV = function (selectedBluePrintObj) {
                    vm.isBluePrintSelected = false;
                    vm.selectedBluePrintObj = selectedBluePrintObj;
                    vm.isButtonVisible = true;
                };

                vm.getCSVData = function () {
                    vm.data = [{
                        "name": "",
                        "description": "",
                        "typeId": "",
                        "gatewayId": "",
                        "mode": "",
                        "defaultHealth": ""
                    }];
                    vm.data[0].properties = vm.selectedBluePrintObj.properties;
                    vm.data[0].typeId = vm.selectedBluePrintObj.id;
                    var data = jsonToCsvConvertService.getCsvArray(vm.data);
                    vm.headerArray = data[0];
                    vm.getArray = "";
                    return vm.getArray;
                };

                vm.fnCreateDeviceFromCSV = function () {
                    var filesSelected = document.getElementById("upload-file-selector").files[0];
                    var reader = new FileReader();
                    reader.onload = function (fileLoadedEvent) {
                        var inputObj = {
                            body: fileLoadedEvent.target.result
                        };
                        DeviceFactory.createDeviceFromCSV(inputObj)
                            .then(function () {
                                $scope.$emit('deviceAdded', 'testId');
                                amaran.success("Device registration in progress.");
                            })
                    };
                    reader.readAsText(filesSelected);
                };

                vm.fnTypesFilter = function () {
                    vm.isTypesFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.bluePrintArr, function (typeObj) {
                            if (typeObj.id.includes(vm.search) || typeObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.bluePrintArr);
                    }
                    vm.fnSearchTypeFilter(searchArr);
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                        vm.isTypesFilter = false;
                    }, 1000)
                };

                vm.fnGatewaysFilter = function () {
                    vm.isGatewaysFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.gatewaySearch)) {
                        searchArr = _.filter(vm.resetGatewaysArr, function (gatewayObj) {
                            if (gatewayObj.id.includes(vm.gatewaySearch) || gatewayObj.name && gatewayObj.name.toLowerCase().includes(vm.gatewaySearch.toLowerCase())) {
                                return gatewayObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetGatewaysArr);
                    }
                    vm.gatewaysArr = searchArr;
                    $timeout(function () {
                        vm.isGatewaysFilter = false;
                    }, 1000)
                };

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    if (gatewayObj.healthName === health) {
                        gatewayObj.toolTipName = health;
                    } else {
                        gatewayObj.toolTipName = gatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                vm.fnSearchTypeFilter = function (searchArr) {
                    vm.uniqueBluePrintObj = {};
                    _.map(searchArr, function (item) {
                        if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model]) {
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model] = {
                                typeName: '',
                                typeValue: [],
                                isGatewayDataLoad: false
                            };
                        }
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeName = item.name;
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.push(item);
                        if (!vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj) {
                            vm.uniqueBluePrintObj[item.oem + '-' + item.model].selectedTypeVersionObj = item;
                        }
                        vm.uniqueBluePrintObj[item.oem + '-' + item.model].typeValue.sort(dynamicSort("version"));
                    });
                    _.forEach(vm.uniqueBluePrintObj, function (obj) {
                        obj.selectedTypeVersionObj = obj.typeValue[0]
                    })
                };

                function dynamicSort(property) {
                    var sortOrder = 1;
                    if (property[0] === "-") {
                        sortOrder = -1;
                        property = property.substr(1);
                    }
                    return function (b, a) {
                        /* next line works with strings and numbers,
                         * and you may want to customize it to your needs
                         */
                        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                        return result * sortOrder;
                    }
                }

                /* **********wizard:Start********** */
                vm.isObserverStepDone = false;
                vm.fnGoToDeviceType = function () {
                    vm.activeStep = 1;
                    vm.isBluePrintSelected = false;
                    vm.newDeviceObj.typeId = '';
                    vm.isGatewaySelected = false;
                    vm.newDeviceObj.gatewayId = '';
                    vm.isObserverStepDone = false;
                    vm.fnInitCreateDevice();
                };

                vm.fnGoToGatewayStep = function () {
                    vm.activeStep = 2;
                    vm.isGatewaySelected = false;
                    vm.newDeviceObj.gatewayId = '';
                    vm.isObserverStepDone = false;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnGoToObserverStep = function () {
                    vm.activeStep = 3;
                    vm.isObserverStepDone = false;
                };

                vm.fnObserverConfigurationDone = function () {
                    vm.isObserverStepDone = true;
                    vm.activeStep = 4;
                };

                vm.fnInitObserverTab = function () {
                    if (vm.observerPermissionObj.List) {
                        vm.fnGetObservers();
                    }
                };

                vm.fnGotoReviewTab = function(){
                    vm.activeStep = 5;
                };
                /* **********wizard:End********** */

                /* **********BluePrint:Start********** */
                vm.observerBluePrintArr = [];
                vm.observersArr = [];
                vm.isObserverFound = false;
                vm.isObserverFoundFromBluePrint = false;
                vm.selectedObserverBluePrint = {};
                vm.isObserverCreating = true;

                vm.fnGetObservers = function () {
                    vm.isObserversFetched = false;
                    ObserverFactory.getObservers({perPage: 0})
                        .then(function (res) { // Success block
                            vm.observersArr = _.cloneDeepWith(res);
                            var existingOb = _.filter(vm.observersArr, function (observerObj) {
                                if ((observerObj.topicOem === '*' || observerObj.topicOem === vm.uniqueSelectedBluePrintObj.oem) &&
                                    (observerObj.topicModel === '*' || observerObj.topicModel === vm.uniqueSelectedBluePrintObj.model) &&
                                    (observerObj.topicVersion === '*' || observerObj.topicVersion === vm.uniqueSelectedBluePrintObj.version) &&
                                    (observerObj.topicName === '*' || observerObj.topicName === vm.uniqueSelectedBluePrintObj.name) &&
                                    (observerObj.topicId === '*' || observerObj.topicId === vm.uniqueSelectedBluePrintObj.id)) {
                                    return observerObj;
                                }
                            });
                            vm.isObserverFound = !!(existingOb && existingOb.length);
                            if (!vm.isObserverFound) {
                                var existingBluePrintOb = _.filter(vm.observerBluePrintArr, function (observerObj) {
                                    if ((observerObj.topicOem === '*' || observerObj.topicOem === vm.uniqueSelectedBluePrintObj.oem) &&
                                        (observerObj.topicModel === '*' || observerObj.topicModel === vm.uniqueSelectedBluePrintObj.model) &&
                                        (observerObj.topicVersion === '*' || observerObj.topicVersion === vm.uniqueSelectedBluePrintObj.version) &&
                                        (observerObj.topicName === '*' || observerObj.topicName === vm.uniqueSelectedBluePrintObj.name) &&
                                        (observerObj.topicId === '*' || observerObj.topicId === vm.uniqueSelectedBluePrintObj.id)) {
                                        return observerObj;
                                    }
                                });
                                vm.selectedObserverBluePrint = existingBluePrintOb.length ? existingBluePrintOb[0] : {};
                                vm.isObserverFoundFromBluePrint = !!(existingBluePrintOb && existingBluePrintOb.length);
                            } else {
                                vm.selectedObserverBluePrint = {};
                                vm.isObserverFoundFromBluePrint = false;
                            }
                            vm.isObserversFetched = true;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.observersArr = [];
                            vm.isObserversFetched = true;
                        })
                };

                vm.fnGetObserverBluePrints = function () {
                    vm.isObserverBluePrintFetched = false;
                    ObserverFactory.getObserverBlueprints()
                        .then(function (response) {
                            vm.observerBluePrintArr = response;
                            vm.isObserverBluePrintFetched = true;
                        }, function () {
                            vm.observerBluePrintArr = [];
                            vm.isObserverBluePrintFetched = true;
                        })
                };

                vm.fnCreateObserver = function(isCreate){
                    if(isCreate){
                        vm.isObserverCreating = false;
                        var createObj = {
                            "name": vm.selectedObserverBluePrint.name,
                            "description": vm.selectedObserverBluePrint.description,
                            "state": vm.selectedObserverBluePrint.state,
                            "topicOem": vm.selectedObserverBluePrint.topicOem,
                            "topicModel": vm.selectedObserverBluePrint.topicModel,
                            "topicName": vm.selectedObserverBluePrint.topicName,
                            "topicVersion": vm.selectedObserverBluePrint.topicVersion,
                            "topicId": vm.selectedObserverBluePrint.topicId,
                            "policy": vm.selectedObserverBluePrint.policy,
                            "conditions": vm.selectedObserverBluePrint.conditions
                        };

                        var inputObj = {
                            body: createObj
                        };

                        ObserverFactory.createObserver(inputObj)
                            .then(function () {
                                vm.isObserverCreating = true;
                                vm.fnObserverConfigurationDone();
                                amaran.success('Observer created successfully')
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isObserverCreating = true;
                                vm.fnObserverConfigurationDone();
                            })
                    }else{
                        vm.fnObserverConfigurationDone();
                    }
                };
                /* **********BluePrint:End********** */

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                vm.fnInitCreateDevice = function () {
                    vm.activeStep = 1;
                    vm.isBluePrintFetched = false;
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatwayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.observerPermissionObj = PermissionsService.getPermissions("node:observer");
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        var typesArr = AppInitService.getInitData('typesArr');
                        var tempArr = _.filter(typesArr, {category: 'DEVICE'});
                        _.forEach(tempArr, function (tempObj) {
                            var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                            tempObj.properties = angular.copy(propertiesObj);
                        });
                        vm.bluePrintArr = tempArr;
                        vm.fnSearchTypeFilter(vm.bluePrintArr);
                        vm.isBluePrintFetched = true;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    } else {
                        var inputObj = {
                            filter: "#{category} = ${DEVICE}"
                        };
                        TypeFactory.getTypes(inputObj)
                            .then(function (response) {
                                var tempArr = response;
                                _.forEach(tempArr, function (tempObj) {
                                    var propertiesObj = _(tempObj.properties).toPairs().sortBy(0).fromPairs().value();
                                    tempObj.properties = angular.copy(propertiesObj);
                                });
                                vm.bluePrintArr = tempArr;
                                vm.fnSearchTypeFilter(vm.bluePrintArr);
                                vm.isBluePrintFetched = true;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                            }, function () {
                                vm.isBluePrintFetched = true;
                                vm.fnSetTableHeight();
                            })
                    }
                    vm.isGatewayLoaded = false;
                    if (vm.gatwayPermissionObj.List) {
                        GatewayFactory.getGateways()
                            .then(function (res) { // Success block
                                vm.gatewaysArr = angular.copy(res);
                                vm.resetGatewaysArr = angular.copy(vm.gatewaysArr);
                                vm.isGatewayLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isGatewayLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                })
                            });
                    } else {
                        vm.gatewaysArr = [];
                        vm.isGatewayLoaded = true;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                    if (vm.observerPermissionObj.List) {
                        vm.fnGetObserverBluePrints();
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createClusterCtrl',
            function ($scope, $timeout, $uibModal, $q, amaran, ClusterFactory) {
                var vm = this;

                vm.title = "Create Cluster";
                vm.devicesArr = [];
                vm.gatewaysArr = [];
                vm.newClusterObj = {
                    name: '',
                    description: '',
                    deviceIds: [],
                    gatewayIds: []
                };

                vm.fnOpenDeviceModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/cluster/modals/elementList/elementListModal.html',
                        size: 'lg',
                        windowClass: "modal-height100",
                        controller: 'elementListModalCtrl as elemList',
                        resolve: {
                            isCallFromDevicesTab: function () {
                                return false;
                            },
                            clusterId: function () {
                                return '';
                            }
                        }
                    });
                    modalInstance.result.then(function (devicesArr) {
                        vm.devicesArr = devicesArr
                    }, function () {
                    });
                };

                vm.fnOpenGatewayModel = function (){
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/cluster/modals/gatewayElementList/gatewayElementListModel.html',
                        size: 'lg',
                        windowClass: "modal-height100",
                        controller: 'gatewayElementListModalCtrl as gatewayElemList',
                        resolve: {
                            isCallFromGatewaysTab: function () {
                                return false;
                            },
                            clusterId: function () {
                                return '';
                            }
                        }
                    });
                    modalInstance.result.then(function (gatewaysArr) {
                      vm.gatewaysArr = gatewaysArr
                    }, function () {
                    });
                };

                vm.fnRemoveDeviceFromSelected = function (deviceObj) {
                    _.remove(vm.devicesArr, function (obj) {
                        return deviceObj.id === obj.id;
                    });
                };

                vm.fnRemoveGatewayFromSelected = function (gatewayObj) {
                    _.remove(vm.gatewaysArr, function (obj) {
                        return gatewayObj.id === obj.id;
                    });
                };

                vm.fnCreateNewCluster = function (newClusterObj) {
                    vm.isClusterCreating = true;
                    /*newClusterObj.deviceIds = _.map(vm.devicesArr, function (device) {
                        return device.id;
                    });*/
                    var inputObj = {
                        body: newClusterObj
                    };
                    ClusterFactory.createCluster(inputObj)
                        .then(function (resObj) {
                            var promises = [];
                            angular.forEach(vm.devicesArr, function (selectedUser) {
                                var inputObj = {
                                    clusterId: resObj.id,
                                    deviceId: selectedUser.id
                                };
                                promises.push(ClusterFactory.addDeviceToCluster(inputObj));
                            });
                            angular.forEach(vm.gatewaysArr, function (selectedUser) {
                                var inputObj = {
                                    clusterId: resObj.id,
                                    gatewayId: selectedUser.id
                                };
                                promises.push(ClusterFactory.addGatewayToCluster(inputObj));
                            });

                            $q.all(promises).then(function () {
                                vm.isClusterCreating = false;
                                $scope.clusters.fnHideShowCreateForm(); //parent function
                                vm.newClusterObj = {
                                    name: '',
                                    description: '',
                                    deviceIds: [],
                                    gatewayIds:[]
                                };
                                $timeout(function(){ // set table height
                                    $scope.clusters.fnSetTableHeight();//parent function
                                }, 800);
                                if($scope.clusters.permissionObj.List){
                                    $scope.clusters.totalItems = $scope.clusters.totalItems + 1;
                                    $scope.clusters.clustersArr.push(resObj);
                                    $scope.clusters.fnReload();
                                }
                                amaran.success("Cluster created successfully");
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.newClusterObj = {
                                    name: '',
                                    description: '',
                                    deviceIds: [],
                                    gatewayIds: []
                                };
                                $timeout(function(){ // set table height
                                    $scope.clusters.fnSetTableHeight();//parent function
                                }, 800);
                                if($scope.clusters.permissionObj.List){
                                    $scope.clusters.totalItems = $scope.clusters.totalItems + 1;
                                    $scope.clusters.clustersArr.push(resObj);
                                    $scope.clusters.fnReload();
                                }
                                vm.isClusterCreating = false;
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isClusterCreating = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('clusterInfo', fnClusterInfo)

    /** @ngInject */
    function fnClusterInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, ClusterFactory, copyService,
                           postActionModelIcon, postActionModelMessage, PermissionsService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/cluster/clusterInfo/clusterInfo.html',
            scope: {
                clusterObj: '=',
                typesArr: '=',
                clusterPermissionsObj: '='
            },
            link: function ($scope) {
                $scope.devicePermissionObj = PermissionsService.getPermissions("node:device");
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    68: false //d
                };

                if ($scope.devicePermissionObj.List) {
                    $scope.tabs = [{
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/details.html'
                    }, {
                        title: 'Devices',
                        tabIndex: 2,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/clusterDevice/clusterDevice.html'
                    }, {
                        title: 'Gateways',
                        tabIndex: 3,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/clusterGateway/clusterGateway.html'
                    }, {
                        title: 'Topology',
                        tabIndex: 4,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/clusterTopology/clusterTopology.html'
                    }, {
                        title: 'Supplemental',
                        tabIndex: 5,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/clusterSupplement/clusterSupplement.html'
                    }];
                } else {
                    $scope.tabs = [{
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/details.html'
                    }, {
                        title: 'Supplemental',
                        tabIndex: 2,
                        templateUrl: 'app/node/cluster/clusterInfo/clusterSteps/clusterSupplement/clusterSupplement.html'
                    }];
                }
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 2;
                    }
                } else {
                    $scope.selectedTab = 2;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.resetClusterObj = {};

                $scope.fnGetCluster = function (clusterId) {
                    var inputObj = {
                        clusterId: clusterId
                    };
                    ClusterFactory.getCluster(inputObj)
                        .then(function (response) {
                            $scope.clusterObj = response;
                            if (angular.isUndefined($scope.clusterObj.description)) {
                                $scope.clusterObj.description = '';
                            }

                            $scope.resetClusterObj = angular.copy($scope.clusterObj);
                            $scope.isClusterDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.cluster', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.clusterObj = angular.copy($scope.resetClusterObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnUpdateClusterDetails = function (clusterObj) {
                    var inputObj = {
                        body: {},
                        clusterId: clusterObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    if (angular.isUndefined(clusterObj.description)) {
                        clusterObj.description = '';
                    }
                    inputObj.body = {
                        name: clusterObj.name,
                        description: clusterObj.description
                    };
                    ClusterFactory.modifyCluster(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetClusterObj = angular.copy(response);
                            $scope.$emit('ClusterDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Cluster Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnDeleteCluster = function (clusterObj) {
                    swal({
                            title: "Delete the selected cluster?",
                            text: "You are about to permanently delete the selected cluster.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    clusterId: clusterObj.id
                                };
                                ClusterFactory.deleteCluster(inputObj)
                                    .then(function () {
                                        $scope.$emit('ClusterDeleted', clusterObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function () {
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitCluster = function () {
                    $scope.isClusterDetailsLoaded = false;
                    $scope.clusterId = $scope.clusterObj.id;
                    if ($scope.clusterId) {
                        $scope.fnGetCluster($scope.clusterId);
                    }
                    $scope.fnSetTabHeight();
                };

                var clusterInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.cluster') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.clusterPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteCluster($scope.clusterObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var clusterInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.cluster') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', clusterInfoKeyDownEventHandler);
                document.addEventListener('keyup', clusterInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', clusterInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', clusterInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createAttributeIssueCtrl',
            function ($rootScope, $window, $stateParams, $http, $scope, $timeout, $state, $uibModal, mermaid, AppInitService,
                      ProjectFactory, swal, amaran, moment, DB, PermissionsService, AvatarService, IssueFactory,
                      EmailFactory, UserFactory, QueryFactory, UserProfileService, TypeFormService, TypesFactory, NodeFactory) {
                var vm = this;
                vm.issueDraftObj = {};
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    });
                });

                vm.isIssueCreating = false;
                vm.fileUploading = false;
                vm.newIssueObj = {
                    confidential: false,
                    assignees: [],
                    issueLabels: [],
                    participants: [],
                    name: "",
                    summary: "",
                    resolved: false
                };
                vm.resetNewIssueObj = angular.copy(vm.newIssueObj);
                vm.projectsArr = [];
                vm.selectedProject = {};
                vm.selectedAttributeId = "";
                vm.selectedAttributeObj = {};

                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};

                vm.filter = "$";
                vm.labelSearch = {$: ''};
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                vm.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;

                /*Types: START*/
                vm.typesArr = [];
                vm.selectedType = {};
                vm.isIssueTypeLoaded = false;
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];
                vm.isTypeDetailsLoaded = true;
                /*Types: END*/

                /*Assignee: START*/
                vm.filterAssignees = "$";
                vm.assigneeSearch = {$: ''};
                vm.usersArr = [{
                    username: 'assign to me'
                }];
                vm.isIssueAssigneeLoaded = false;
                vm.changeAssigneeView = false;
                vm.isAssigneeChanged = true;
                vm.selectedUser = "";
                /*Assignee: END*/

                /*Labels: START*/
                vm.labelsArr = [];
                vm.isIssueLablesLoaded = false;
                vm.addLabelView = false;
                vm.isLabelsAdded = true;
                vm.selectedLabelsArr = [];
                vm.selectedLabel = {};
                /*Labels: END*/

                /*Priority: START*/
                vm.priorityFilter = "$";
                vm.prioritySearch = {$: ''};
                vm.prioritiesArr = [];
                vm.isIssuePriorityLoaded = false;
                vm.changePriorityView = false;
                vm.isPriorityChanged = true;
                vm.selectedPriority = "";
                /*Priority: END*/

                /*State: START*/
                vm.stateFilter = "$";
                vm.stateSearch = {$: ''};
                vm.statesArr = [];
                vm.isIssueStateLoaded = false;
                vm.changeStateView = false;
                vm.isStateChanged = true;
                vm.selectedState = {};
                /*State: END*/

                /*Participant: START*/
                vm.participantFilter = "$";
                vm.participantSearch = {$: ''};
                vm.participantsArr = [];
                vm.isIssueParticipantLoaded = false;
                vm.changeParticipantView = false;
                vm.isParticipantChanged = true;
                vm.selectedParticipant = {};
                vm.assigneesParticipants = [];
                /*Participant: END*/

                /*Confidential: START*/
                vm.confidentialsArr = [{'name': "Confidential", 'value': true}, {
                    'name': "Not Confidential",
                    'value': false
                }];
                vm.isIssueConfidentialLoaded = false;
                vm.changeConfidentialView = false;
                vm.isConfidentialChanged = true;
                vm.selectedConfidential = {};
                /*Confidential: END*/

                vm.projectRelationshipsObj = {};

                vm.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        vm.fnRenderMermaid();
                    }
                };

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        if (type === 'image') {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                        } else {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " [" + filedata.name + "](" + res.downloadUrl + ")";
                        }
                        vm.fileUploading = false;
                    });
                };

                vm.uploadFiles = function (type, filedata) {
                    if (vm.permissionObj.GET_FILE_UPLOAD_LINK) {
                        vm.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                vm.fnCreateNewIssue = function (newIssueObj) {
                    if (newIssueObj.issueType && newIssueObj.issueType.form) {
                        newIssueObj.issueType.form.values = vm.model;
                    }
                    vm.isIssueCreating = true;
                    var inputObj = {
                        'body': newIssueObj,
                        'projectId': vm.selectedProject.id,
                        'attributeId': vm.selectedAttributeId
                    };
                    IssueFactory.createIssueFromNode(inputObj)
                        .then(function (response) {
                            vm.isIssueCreating = false;
                            vm.newIssueObj = angular.copy(vm.resetNewIssueObj);
                            localStorage.removeItem('attributeIssueDraft');
                            localStorage.removeItem('fedSupportAttributeIssueDraft');
                            if (newIssueObj.participants && newIssueObj.participants.length) {
                                var tempArr = [];
                                _.forEach(newIssueObj.participants, function (participant) {
                                    tempArr.push({
                                        email: participant
                                    })
                                });
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', tempArr);
                            } else {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', []);
                            }
                            vm.model = {};
                            amaran.success("Issue created successfully");
                            $scope.$emit('attributeIssueAdded', response);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssueCreating = false;
                        })
                };

                vm.fnChangeProject = function (projectObj) {
                    vm.selectedProject = projectObj;
                    vm.newIssueObj.projectId = projectObj.id;
                    vm.newIssueObj.issueLabels = [];
                    delete vm.newIssueObj.issueState;
                    delete vm.newIssueObj.issuePriority;

                    /*Types: START*/
                    vm.typesArr = [];
                    vm.selectedType = {};
                    vm.isIssueTypeLoaded = false;
                    vm.model = {};
                    vm.schema = {};
                    vm.form = ['*'];
                    /*Types: END*/

                    /*Labels: START*/
                    vm.labelsArr = [];
                    vm.isIssueLablesLoaded = false;
                    vm.addLabelView = false;
                    vm.isLabelsAdded = true;
                    vm.selectedLabelsArr = [];
                    vm.selectedLabel = {};
                    /*Labels: END*/

                    /*Priority: START*/
                    vm.prioritiesArr = [];
                    vm.isIssuePriorityLoaded = false;
                    vm.changePriorityView = false;
                    vm.isPriorityChanged = true;
                    vm.selectedPriority = "";
                    /*Priority: END*/

                    /*State: START*/
                    vm.statesArr = [];
                    vm.isIssueStateLoaded = false;
                    vm.changeStateView = false;
                    vm.isStateChanged = true;
                    vm.selectedState = {};
                    /*State: END*/

                    vm.isIssueTypeLoaded = false;
                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;
                        }, function () {
                        });
                };

                /*Assignee: START*/
                vm.addAssigneeArr = [];
                vm.deleteAssigneeArr = [];

                vm.fnGetUsers = function (inputObj) {
                    ProjectFactory.listPossibleProjectAssignees(inputObj)
                        .then(function (response) {
                            _.forEach(response, function (userObj) {
                                userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                                if (vm.issueDraftObj && vm.issueDraftObj.assignees && vm.issueDraftObj.assignees.length) {
                                    var isFindAssignee = _.find(vm.issueDraftObj.assignees, {id: userObj.id});
                                    if (isFindAssignee) {
                                        userObj.isCheck = true;

                                        if (!vm.assigneesAssignees) {
                                            vm.assigneesAssignees = [];
                                        }
                                        vm.assigneesAssignees.push({
                                            bio: userObj.bio,
                                            firstName: userObj.firstName,
                                            id: userObj.id,
                                            lastName: userObj.lastName,
                                            tags: userObj.tags,
                                            username: userObj.username,
                                            userAvatar: userObj.userAvatar,
                                            email: userObj.email
                                        })
                                    }
                                }
                            });
                            response.sort(function (a, b) {
                                if (a.firstName < b.firstName) {
                                    return -1;
                                }
                                if (a.firstName > b.firstName) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.usersArr = _.cloneDeepWith(response);
                            vm.isIssueAssigneeLoaded = true;
                        }, function () {
                            vm.isIssueAssigneeLoaded = true;
                        })
                };

                vm.fnGetAssigneeInfo = function (assigneeObj) {
                    if (assigneeObj.isCheck) {
                        assigneeObj.isCheck = false;
                        var isFindAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (isFindAssignee) {
                            vm.deleteAssigneeArr.push(isFindAssignee);
                        } else {
                            var isFindAssigneeInAddAssigneeArr = _.findIndex(vm.addAssigneeArr, {id: assigneeObj.id});
                            if (isFindAssigneeInAddAssigneeArr !== 1) {
                                vm.addAssigneeArr.splice(isFindAssigneeInAddAssigneeArr, 1);
                            }
                        }
                    } else {
                        assigneeObj.isCheck = true;
                        var isFindAssigneesAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (!isFindAssigneesAssignee) {
                            vm.addAssigneeArr.push(assigneeObj);
                        } else {
                            var isFindDeleteAssignee = _.findIndex(vm.deleteAssigneeArr, {id: assigneeObj.id});
                            if (isFindDeleteAssignee !== -1) {
                                vm.deleteAssigneeArr.splice(isFindDeleteAssignee, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeAssignee = function () {
                    vm.selectedAssignee = {};
                    vm.changeAssigneeView = false;
                    if (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length) {
                        vm.fnUpdateIssueAssignee();
                    }
                };

                vm.fnOnToggleAssignee = function (isOpen) {
                    if (isOpen === false && (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length)) {
                        vm.fnUpdateIssueAssignee();
                    } else {
                        vm.changeAssigneeView = false;
                        vm.selectedAssignee = {};
                    }
                };

                vm.fnUpdateIssueAssignee = function () {
                    vm.isIssueAssigneeLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesAssignees, function (assigneeObj) {
                        var findIndex = _.findIndex(vm.deleteAssigneeArr, function (deleteObj) {
                            return deleteObj.id === assigneeObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: assigneeObj.bio,
                                firstName: assigneeObj.firstName,
                                id: assigneeObj.id,
                                lastName: assigneeObj.lastName,
                                tags: assigneeObj.tags,
                                username: assigneeObj.username,
                                userAvatar: assigneeObj.userAvatar,
                                email: assigneeObj.email
                            });
                        }
                    });
                    _.forEach(vm.addAssigneeArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesAssignees, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: addObj.bio,
                                firstName: addObj.firstName,
                                id: addObj.id,
                                lastName: addObj.lastName,
                                tags: addObj.tags,
                                username: addObj.username,
                                userAvatar: addObj.userAvatar,
                                email: addObj.email
                            })
                        }
                    });
                    vm.newIssueObj.assignees = _.cloneDeepWith(tempArr);
                    vm.assigneesAssignees = _.cloneDeepWith(tempArr);
                    vm.isIssueAssigneeLoaded = true;
                    vm.selectedAssignee = "";
                    vm.deleteAssigneeArr = [];
                    vm.addAssigneeArr = [];
                    vm.changeAssigneeView = false;
                };

                vm.fnOpenChangeAssigneeView = function () {
                    vm.changeAssigneeView = true;
                    _.forEach(vm.assigneesAssignees, function (issueAssigneeObj) {
                        var isFindAssignee = _.find(vm.usersArr, {id: issueAssigneeObj.id});
                        isFindAssignee.isCheck = !!isFindAssignee;
                    });
                };

                vm.fnManageAssignees = function () {
                    $state.go("main.users");
                };
                /*Assignee: END*/

                /*Type: START*/
                vm.fnGetTypes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            vm.typesArr = _.cloneDeepWith(response.data);
                            vm.typesArr.unshift({
                                id: "noType",
                                name: "Select Type"
                            });
                            if (vm.issueDraftObj && vm.issueDraftObj.issueType) {
                                var isFindType = _.find(vm.typesArr, {id: vm.issueDraftObj.issueType.id});
                                if (isFindType) {
                                    vm.selectedType = vm.issueDraftObj.issueType;
                                    vm.fnCreateTypeForm();
                                } else {
                                    vm.selectedType = vm.typesArr[0];
                                }
                            } else {
                                vm.selectedType = vm.typesArr[0];
                            }
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        })
                };

                vm.fnSelectType = function (typeObj) {
                    vm.selectedType = typeObj;
                    if (vm.selectedType.id === 'noType') {
                        delete vm.newIssueObj.issueType;
                        vm.model = {};
                        vm.schema = {};
                        vm.form = ['*'];
                    } else {
                        vm.newIssueObj.issueType = typeObj;
                        vm.fnCreateTypeForm();
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                vm.fnCheckIssueTypeValidation = function () {
                    if (vm.newIssueObj.issueType && vm.form.length) {
                        var flag = false;
                        _.forEach(vm.form, function (formObj) {
                            if (formObj.required) {
                                _.forEach(formObj.key, function (keyValue) {
                                    if (angular.isUndefined(vm.model[keyValue]) || (angular.isDefined(vm.model[keyValue]) && !vm.model[keyValue].toString().length)) {
                                        flag = true;
                                    }
                                })
                            }
                        });
                        return flag;
                    } else {
                        return false;
                    }
                };

                vm.fnCreateTypeForm = function () {
                    vm.isTypeDetailsLoaded = false;
                    var inputObj = {
                        typeId: vm.selectedType.id
                    };
                    TypesFactory.describeIssueType(inputObj)
                        .then(function (response) {
                            if (response.form && response.form.schema && response.form.schema.properties && Object.keys(response.form.schema.properties).length) {
                                var tempData = TypeFormService.fnGenerateFormData(response.form.schema);
                                vm.schema = tempData.schema;
                                vm.form = tempData.form;
                                if (angular.isDefined(vm.issueDraftObj)) {
                                    if (angular.isDefined(vm.newIssueObj.issueType) && angular.isDefined(vm.newIssueObj.issueType.form)) {
                                        vm.model = vm.issueDraftObj.issueType.form.values;
                                    }
                                }
                            } else {
                                vm.schema = {
                                    $schema: "https://json-schema.org/draft/2019-09/schema",
                                    type: "object",
                                    properties: {}
                                };
                                vm.form = [];
                            }
                            vm.isTypeDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isTypeDetailsLoaded = true;
                            //vm.fnCreateTypeForm();
                        });
                };
                /*Type: END*/

                /*Priority: START*/
                vm.addPrioritiesArr = [];
                vm.deletePrioritiesArr = [];
                vm.fnGetPriorities = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.prioritiesArr = _.cloneDeepWith(response.data);
                            vm.isIssuePriorityLoaded = true;
                        }, function () {
                            vm.isIssuePriorityLoaded = true;
                        })
                };

                vm.fnGetPrioritiesInfo = function (prioritiesObj) {
                    _.forEach(vm.prioritiesArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deletePrioritiesArr = [];
                    vm.addPrioritiesArr = [];
                    var isFindCheck = _.find(vm.prioritiesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id !== isFindCheck.id) {
                                vm.addPrioritiesArr = [prioritiesObj];
                            }
                        } else {
                            vm.addPrioritiesArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id === prioritiesObj.id) {
                                vm.deletePrioritiesArr = [vm.assigneesPriorities];
                            }
                        }

                    }
                };

                vm.fnCancelChangePriority = function () {
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                    if (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length) {
                        vm.fnUpdateIssuePriority();
                    }
                };

                vm.fnOnTogglePriority = function (isOpen) {
                    if (isOpen === false && (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length)) {
                        vm.fnUpdateIssuePriority();
                    } else {
                        vm.changePriorityView = false;
                        vm.selectedPriority = {};
                    }
                };

                vm.fnUpdateIssuePriority = function () {
                    vm.isIssuePriorityLoaded = false;
                    if (vm.deletePrioritiesArr.length) {
                        delete vm.newIssueObj.issuePriority;
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    } else {
                        vm.newIssueObj.issuePriority = vm.addPrioritiesArr[0];
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    }
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                };

                vm.fnOpenChangePriorityView = function () {
                    vm.changePriorityView = true;
                    _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                        prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                    });
                };

                vm.fnManageProjectPriority = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.priorities", {filter: angular.toJson(inputObj)});
                };
                /*Priority: END*/

                /*State: START*/
                vm.addStatesArr = [];
                vm.deleteStatesArr = [];
                vm.fnGetStates = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.statesArr = _.cloneDeepWith(response.data);
                            vm.isIssueStateLoaded = true;
                        }, function () {
                            vm.isIssueStateLoaded = true;
                        })
                };

                vm.fnGetStatesInfo = function (statesObj) {
                    _.forEach(vm.statesArr, function (states) {
                        if (statesObj.id !== states.id) {
                            states.isCheck = false;
                        }
                    });
                    statesObj.isCheck = !statesObj.isCheck;
                    vm.deleteStatesArr = [];
                    vm.addStatesArr = [];
                    var isFindCheck = _.find(vm.statesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id !== isFindCheck.id) {
                                vm.addStatesArr = [statesObj];
                            }
                        } else {
                            vm.addStatesArr = [statesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id === statesObj.id) {
                                vm.deleteStatesArr = [vm.assigneesState];
                            }
                        }
                    }
                };

                vm.fnCancelChangeState = function () {
                    vm.selectedState = {};
                    vm.changeStateView = false;
                    if (vm.deleteStatesArr.length || vm.addStatesArr.length) {
                        vm.fnUpdateIssueState();
                    }
                };

                vm.fnOnToggleState = function (isOpen) {
                    if (isOpen === false && (vm.deleteStatesArr.length || vm.addStatesArr.length)) {
                        vm.fnUpdateIssueState();
                    } else {
                        vm.changeStateView = false;
                        vm.selectedState = {};
                    }
                };

                vm.fnUpdateIssueState = function () {
                    vm.isIssueStateLoaded = false;
                    if (vm.deleteStatesArr.length) {
                        delete vm.newIssueObj.issueState;
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    } else {
                        vm.newIssueObj.issueState = vm.addStatesArr[0];
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    }
                    vm.selectedState = {};
                    vm.changeStateView = false;
                };

                vm.fnOpenChangeStateView = function () {
                    vm.changeStateView = true;
                    _.forEach(vm.statesArr, function (statesObj) {
                        statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                    });
                };

                vm.fnManageProjectState = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.state", {filter: angular.toJson(inputObj)});
                };
                /*State: END*/

                /*Labels: START*/
                vm.addLabelArr = [];
                vm.deleteLabelArr = [];
                vm.fnGetLabels = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.labelsArr = _.cloneDeepWith(response.data);
                            vm.isIssueLablesLoaded = true;
                        }, function () {
                            vm.isIssueLablesLoaded = true;
                        })
                };

                vm.fnGetLabelInfo = function (labelObj) {
                    if (labelObj.isCheck) {
                        labelObj.isCheck = false;
                        var isFindLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (isFindLabel) {
                            vm.deleteLabelArr.push(isFindLabel);
                        } else {
                            var isFindLabelInAddLabelArr = _.findIndex(vm.addLabelArr, {id: labelObj.id});
                            if (isFindLabelInAddLabelArr !== 1) {
                                vm.addLabelArr.splice(isFindLabelInAddLabelArr, 1);
                            }
                        }
                    } else {
                        labelObj.isCheck = true;
                        var isFindAssigneesLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (!isFindAssigneesLabel) {
                            vm.addLabelArr.push(labelObj);
                        } else {
                            var isFindDeleteLabel = _.findIndex(vm.deleteLabelArr, {id: labelObj.id});
                            if (isFindDeleteLabel !== -1) {
                                vm.deleteLabelArr.splice(isFindDeleteLabel, 1);
                            }
                        }
                    }
                };

                vm.fnAddLabelsToIssue = function (selectedLabel) {
                    vm.isLabelsAdded = false;
                    vm.newIssueObj.issueLabels.push(selectedLabel);
                    vm.isLabelsAdded = true;
                    vm.addLabelView = false;
                    vm.selectedLabel = {};
                };

                vm.fnCancelAddLabelView = function () {
                    vm.selectedLabel = {};
                    vm.addLabelView = false;
                    if (vm.deleteLabelArr.length || vm.addLabelArr.length) {
                        vm.fnUpdateIssueLabel();
                    }
                };

                vm.fnOnToggle = function (isOpen) {
                    if (isOpen === false && (vm.deleteLabelArr.length || vm.addLabelArr.length)) {
                        vm.fnUpdateIssueLabel();
                    } else {
                        vm.addLabelView = false;
                        vm.selectedLabel = {};
                    }
                };

                vm.fnUpdateIssueLabel = function () {
                    vm.isIssueLablesLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesLabels, function (labelObj) {
                        var findIndex = _.findIndex(vm.deleteLabelArr, function (deleteObj) {
                            return deleteObj.id === labelObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: labelObj.id,
                                name: labelObj.name,
                                color: labelObj.color,
                                tags: labelObj.tags ? labelObj.tags : {}
                            });
                        }
                    });
                    _.forEach(vm.addLabelArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesLabels, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: addObj.id,
                                name: addObj.name,
                                color: addObj.color,
                                tags: addObj.tags ? addObj.tags : {}
                            })
                        }
                    });
                    vm.newIssueObj.issueLabels = _.cloneDeepWith(tempArr);
                    vm.assigneesLabels = _.cloneDeepWith(tempArr);
                    vm.isIssueLablesLoaded = true;
                    vm.selectedLabel = {};
                    vm.deleteLabelArr = [];
                    vm.addLabelArr = [];
                    vm.addLabelView = false;
                };

                vm.fnOpenAddLabelView = function () {
                    vm.addLabelView = true;
                    _.forEach(vm.assigneesLabels, function (issueLabelObj) {
                        var isFindLabel = _.find(vm.labelsArr, {id: issueLabelObj.id});
                        isFindLabel.isCheck = !!isFindLabel;
                    });
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": vm.fnInvertColor(color.toString())
                        }
                    }
                };

                vm.fnManageProjectLabels = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.projectId
                    }];
                    $state.go("main.label", {filter: angular.toJson(inputObj)});
                };
                /*Labels: END*/

                /*Participant: START*/
                vm.addParticipantArr = [];
                vm.deleteParticipantArr = [];
                vm.fnGetParticipants = function () {
                    var participants = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'participantsList');
                    if (participants && participants.length) {
                        vm.participantUsersArr = _.cloneDeepWith(participants);
                    } else {
                        vm.participantUsersArr = [];
                    }
                    if (vm.newIssueObj &&
                        vm.newIssueObj.participants &&
                        vm.newIssueObj.participants.length) {
                        _.forEach(vm.newIssueObj.participants, function (participant) {
                            var isFindIndex = _.findIndex(vm.participantUsersArr, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndex === -1) {
                                vm.participantUsersArr.push({
                                    email: participant,
                                    isCheck: true
                                })
                            }

                            var isFindIndexAssignee = _.findIndex(vm.assigneesParticipants, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndexAssignee === -1) {
                                vm.assigneesParticipants.push({
                                    email: participant
                                })
                            }
                        })
                    }
                    vm.resetParticipantUsersArr = _.cloneDeepWith(vm.participantUsersArr);
                    vm.isIssueParticipantLoaded = true;
                };

                vm.fnGetParticipantInfo = function (participantObj) {
                    if (participantObj.isCheck) {
                        participantObj.isCheck = false;
                        var isFindParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (isFindParticipant) {
                            vm.deleteParticipantArr.push(isFindParticipant);
                        } else {
                            var isFindParticipantInAddParticipantArr = _.findIndex(vm.addParticipantArr, {email: participantObj.email});
                            if (isFindParticipantInAddParticipantArr !== 1) {
                                vm.addParticipantArr.splice(isFindParticipantInAddParticipantArr, 1);
                            }
                        }
                    } else {
                        participantObj.isCheck = true;
                        var isFindAssigneesParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (!isFindAssigneesParticipant) {
                            vm.addParticipantArr.push(participantObj);
                        } else {
                            var isFindDeleteParticipant = _.findIndex(vm.deleteParticipantArr, {email: participantObj.email});
                            if (isFindDeleteParticipant !== -1) {
                                vm.deleteParticipantArr.splice(isFindDeleteParticipant, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeParticipant = function () {
                    vm.selectedParticipant = {};
                    vm.changeParticipantView = false;
                    vm.isParticipantChanged = true;
                    if (vm.deleteParticipantArr.length || vm.addParticipantArr.length) {
                        vm.fnUpdateIssueParticipant();
                    }
                };

                vm.fnOnToggleParticipant = function (isOpen) {
                    if (isOpen === false && (vm.deleteParticipantArr.length || vm.addParticipantArr.length)) {
                        vm.fnUpdateIssueParticipant();
                    } else {
                        vm.changeParticipantView = false;
                        vm.selectedParticipant = {};
                    }
                };

                vm.fnUpdateIssueParticipant = function () {
                    vm.isIssueParticipantsLoaded = false;
                    var tempArr = [];
                    var participantsArr = [];
                    _.forEach(vm.assigneesParticipants, function (participantObj) {
                        var findIndex = _.findIndex(vm.deleteParticipantArr, function (deleteObj) {
                            return deleteObj.email === participantObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(participantObj.email);
                            tempArr.push(participantObj);
                        }
                    });
                    _.forEach(vm.addParticipantArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesParticipants, function (tempObj) {
                            return tempObj.email === addObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(addObj.email);
                            tempArr.push(addObj);
                        }
                    });
                    vm.newIssueObj.participants = _.cloneDeepWith(participantsArr);
                    vm.assigneesParticipants = _.cloneDeepWith(tempArr);
                    vm.isIssueParticipantsLoaded = true;
                    vm.selectedParticipant = {};
                    vm.deleteParticipantArr = [];
                    vm.addParticipantArr = [];
                    vm.changeParticipantView = false;
                };

                vm.fnOpenChangeParticipantView = function () {
                    vm.changeParticipantView = true;
                    _.forEach(vm.assigneesParticipants, function (issueParticipantObj) {
                        var isFindParticipant = _.find(vm.participantUsersArr, {email: issueParticipantObj.email});
                        isFindParticipant.isCheck = !!isFindParticipant;
                    });
                };

                vm.fnAddNewParticipant = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html',
                        size: 'lg',
                        controller: 'addParticipantCtrl as addParticipant',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (data) {
                        if (!vm.newIssueObj.participants) {
                            vm.newIssueObj.participants = [];
                        }
                        if (!vm.assigneesParticipants) {
                            vm.assigneesParticipants = [];
                        }
                        if (!vm.participantUsersArr) {
                            vm.participantUsersArr = [];
                        }
                        vm.newIssueObj.participants.push(_.cloneDeepWith(data.email));
                        vm.assigneesParticipants.push(_.cloneDeepWith(data));
                        vm.participantUsersArr.push(_.cloneDeepWith(data));
                    }, function () {

                    });
                };
                /*Participant: END*/

                /*Confidential: START*/
                vm.fnOpenChangeConfidentialView = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = true;
                };

                vm.fnChangeIssueConfidential = function (selectedConfidential) {
                    vm.isConfidentialChanged = false;
                    if (selectedConfidential.value) {
                        vm.newIssueObj.confidential = true;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    } else {
                        vm.newIssueObj.confidential = false;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    }
                };

                vm.fnCancelChangeConfidential = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = false;
                    vm.isConfidentialChanged = true;
                };
                /*Confidential: END*/

                vm.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                vm.fnInitSideBar = function () {
                    vm.usersArr = [{
                        username: 'assign to me'
                    }];
                    vm.isIssueAssigneeLoaded = false;
                    vm.usersArr = [];
                    vm.changeAssigneeView = false;

                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;

                            vm.isIssueParticipantLoaded = false;
                            vm.fnGetParticipants();
                            vm.changeParticipantView = false;
                        }, function () {
                        });
                };

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce();
                        vega_runonce();
                    }, 100);
                };
                /* eslint-enable */

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.sort(function (a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                                    var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                                    if (isFindDraftProject) {
                                        vm.selectedProject = isFindDraftProject;
                                        vm.newIssueObj.projectId = isFindDraftProject.id;
                                    } else {
                                        vm.fnGetSelectedProject();
                                    }
                                } else {
                                    vm.fnGetSelectedProject();
                                }
                                vm.fnInitSideBar();
                                //vm.isProjectLoaded = true;
                                vm.fnGetSelectedNodeInfo();
                            }
                        }, function () { // Error block
                            vm.isProjectLoaded = true;
                            vm.projectsArr = [];
                        })
                };

                vm.fnGetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.selectedProject = isFindProject;
                            vm.newIssueObj.projectId = isFindProject.id;
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.selectedProject = isFindStateParamsProject;
                            vm.newIssueObj.projectId = isFindStateParamsProject.id;
                        }
                    } else {
                        _.forEach(vm.projectsArr, function (dataObj) {
                            if (!dataObj.parentProjectId) {
                                vm.selectedProject = dataObj;
                                vm.newIssueObj.projectId = dataObj.id;
                            }
                        });
                    }
                };

                vm.fnInitCreateIssue = function () {
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        vm.issueDraftObj = {};
                        if (localStorage.getItem('fedSupportAttributeIssueDraft')) {
                            vm.issueDraftObj = angular.fromJson(localStorage.getItem('fedSupportAttributeIssueDraft'));
                            vm.selectedAttributeObj = _.cloneDeepWith(vm.issueDraftObj.selectedAttributeObj);
                            delete vm.issueDraftObj.selectedAttributeObj;
                        }
                    } else {
                        vm.issueDraftObj = {};
                        if (localStorage.getItem('attributeIssueDraft')) {
                            vm.issueDraftObj = angular.fromJson(localStorage.getItem('attributeIssueDraft'));
                            vm.selectedAttributeObj = _.cloneDeepWith(vm.issueDraftObj.selectedAttributeObj);
                            delete vm.issueDraftObj.selectedAttributeObj;
                        }
                    }
                    if (angular.isDefined(vm.issueDraftObj) && vm.issueDraftObj !== {}) {
                        vm.newIssueObj = vm.issueDraftObj;
                    }
                    if (DB.fnGet('createIssueAlarmObj')) {
                        vm.selectedAttributeObj = _.cloneDeepWith(DB.fnGet('createIssueAlarmObj'));
                        DB.fnRemove("createIssueAlarmObj");
                        var nodeName = vm.selectedAttributeObj.nodeName && vm.selectedAttributeObj.nodeName.length ? vm.selectedAttributeObj.nodeName : "";
                        vm.newIssueObj.name = vm.selectedAttributeObj.name + " " + nodeName;
                        vm.newIssueObj.attributeId = vm.selectedAttributeObj.id;
                    }
                    vm.selectedAttributeId = vm.newIssueObj.attributeId;
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.isProjectLoaded = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.projectsArr.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        });
                        if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                            var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                            if (isFindDraftProject) {
                                vm.selectedProject = isFindDraftProject;
                                vm.newIssueObj.projectId = isFindDraftProject.id;
                            } else {
                                vm.fnGetSelectedProject();
                            }
                        } else {
                            vm.fnGetSelectedProject();
                        }
                        $timeout(function () {
                            vm.fnInitSideBar();
                            vm.fnGetSelectedNodeInfo();
                        })
                    } else {
                        vm.isProjectLoaded = false;
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                vm.fnGetSelectedNodeInfo = function () {
                    if (vm.selectedAttributeObj.nodeId === vm.selectedAttributeObj.ecuId) {
                        var url = HOST_URL.node.split("https://")[1]; //eslint-disable-line
                        var environment = url.startsWith('dev') ? 'dev' : 'prod';
                        var attrURL = "";
                        if (environment === 'dev') {
                            attrURL = "https://dev.ecsmon.ecsiteapp.com/#/node/alarm?selectedId=" + vm.selectedAttributeId
                        } else {
                            attrURL = "https://www.ecsmon.ecsiteapp.com/#/node/alarm?selectedId=" + vm.selectedAttributeId
                        }
                        var attrValue = vm.selectedAttributeObj.value ? vm.selectedAttributeObj.value : '';
                        vm.newIssueObj.summary = "The __*" + vm.selectedAttributeObj.name + "*__ at __*" + vm.selectedAttributeObj.ecuName + "*__ has a value of __*" + attrValue + "*__. [View Attribute](" + attrURL + ")";
                        vm.isProjectLoaded = true;
                        $timeout(function () {
                            vm.fnSetIssueMarkdownHeight();
                        })
                    } else {
                        var inputObj = {
                            nodeId: vm.selectedAttributeId.substring(0, vm.selectedAttributeId.lastIndexOf("-"))
                        };
                        NodeFactory.describeNode(inputObj)
                            .then(function (response) {
                                vm.selectedNodeObj = response;
                                var sqlQuery = "select node_nodes.*,node_ecus.data->>\'name\' as ecuName from node_nodes INNER JOIN node_ecus ON node_nodes.data->>\'ecuId\' = node_ecus.data->>\'id\' where node_nodes.data->>\'id\' = '" + response.rootNodeId + "'";
                                QueryFactory.executeQuery({sql: sqlQuery})
                                    .then(function (rootResponse) {
                                        vm.selectedRootNodeObj = rootResponse.data[0];
                                        //var attributeObj = _.cloneDeepWith(DB.fnGet('createIssueAlarmObj'));
                                        var url = HOST_URL.node.split("https://")[1]; //eslint-disable-line
                                        var environment = url.startsWith('dev') ? 'dev' : 'prod';
                                        var attrURL = "";
                                        if (environment === 'dev') {
                                            attrURL = "https://dev.ecsmon.ecsiteapp.com/#/node/alarm?selectedId=" + vm.selectedAttributeId
                                        } else {
                                            attrURL = "https://www.ecsmon.ecsiteapp.com/#/node/alarm?selectedId=" + vm.selectedAttributeId
                                        }
                                        var attrValue = vm.selectedAttributeObj.value ? vm.selectedAttributeObj.value : '';
                                        var nodeIndex = vm.selectedNodeObj.index && vm.selectedNodeObj.index.length ? vm.selectedNodeObj.index: "";
                                        var rootNodeName = rootResponse && rootResponse.data.length && rootResponse.data[0].name && rootResponse.data[0].name.length ? rootResponse.data[0].name : '';
                                        var rootNodeECUName = rootResponse && rootResponse.data.length && rootResponse.data[0].ecuName && rootResponse.data[0].ecuName.length ? rootResponse.data[0].ecuName : '';
                                        vm.newIssueObj.summary = "The __*" + vm.selectedAttributeObj.name + "*__ for __*" + nodeIndex + "*__ on __*" + rootNodeName + "*__ at __*" + rootNodeECUName + "*__ has a value of __*" + attrValue + "*__. [View Attribute](" + attrURL + ")";
                                        vm.isProjectLoaded = true;
                                        $timeout(function () {
                                            vm.fnSetIssueMarkdownHeight();
                                        })
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        vm.isProjectLoaded = true;
                                        $timeout(function () {
                                            vm.fnSetIssueMarkdownHeight();
                                        })
                                    })
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isProjectLoaded = true;
                                $timeout(function () {
                                    vm.fnSetIssueMarkdownHeight();
                                })
                            })
                    }
                }

                vm.fnSetIssueMarkdownHeight = function () {
                    var height = 282;
                    if (angular.isDefined(angular.element("#modal-body")[0]) &&
                        angular.isDefined(angular.element("#newIssueTitle")[0]) &&
                        angular.isDefined(angular.element("#typeListDropdown")[0])) {
                        var total = angular.element("#modal-body")[0].offsetHeight;
                        var newIssue = angular.element("#newIssueTitle")[0].offsetHeight;
                        var typeListDropdown = angular.element("#typeListDropdown")[0].offsetHeight;
                        var finalHeight = total - (newIssue + typeListDropdown + 60);
                        if (height < finalHeight) {
                            angular.element("#issueMarkdownContainer").css('height', finalHeight + 'px');
                        } else {
                            angular.element("#issueMarkdownContainer").css('height', 282 + 'px');
                        }
                    }
                };

                vm.fnSaveIssueDraft = function () {
                    if (vm.newIssueObj.issueType && vm.newIssueObj.issueType.form) {
                        vm.newIssueObj.issueType.form.values = vm.model;
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                        vm.newIssueObj.selectedAttributeObj = vm.selectedAttributeObj;
                        localStorage.setItem('attributeIssueDraft', angular.toJson(vm.newIssueObj));
                    } else {
                        vm.newIssueObj.selectedAttributeObj = vm.selectedAttributeObj;
                        localStorage.setItem('fedSupportAttributeIssueDraft', angular.toJson(vm.newIssueObj));
                    }
                };

                vm.fnOpenAttributeGraphModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/attributeGraphModal/attributeGraphModal.html',
                        size: 'lg',
                        controller: 'attributeGraphModalCtrl as attributeGraph',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeId: function () {
                                return _.cloneDeepWith(vm.selectedAttributeId);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        if (vm.newIssueObj.summary && vm.newIssueObj.summary.length) {
                            vm.newIssueObj.summary += "\n```mermaid \n" + res + "\n```";
                        } else {
                            vm.newIssueObj.summary = "```mermaid \n" + res + "\n```";
                        }
                    }, function () {
                    });
                }

                vm.fnOpenAttributeTelemetryModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/attributeTelemetryModal/attributeTelemetryModal.html',
                        size: 'lg',
                        controller: 'attributeTelemetryModalCtrl as attributeTelemetry',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeId: function () {
                                return _.cloneDeepWith(vm.selectedAttributeId);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        if (vm.newIssueObj.summary && vm.newIssueObj.summary.length) {
                            vm.newIssueObj.summary += "\n```vega \n" + angular.toJson(res) + "\n```";
                        } else {
                            vm.newIssueObj.summary = "```vega \n" + angular.toJson(res) + "\n```";
                        }
                    }, function () {
                    });
                }

                vm.fnOpenMetaInfoModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/metaInfoModal/metaInfoModal.html',
                        size: 'lg',
                        controller: 'metaInfoModalCtrl as metaInfoModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(vm.selectedAttributeObj);
                            },
                            selectedRootNodeObj: function () {
                                return _.cloneDeepWith(vm.selectedRootNodeObj);
                            },
                            selectedProject: function () {
                                return _.cloneDeepWith(vm.selectedProject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        if (vm.newIssueObj.summary && vm.newIssueObj.summary.length) {
                            vm.newIssueObj.summary += "\n" + res + "\n";
                        } else {
                            vm.newIssueObj.summary = "\n" + res + "\n";
                        }
                    }, function () {
                    });
                }

                vm.fnExpandCollapseSideBar = function () {
                    vm.isExpanded = !vm.isExpanded;
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'sideBarExpanded', _.cloneDeepWith(vm.isExpanded));
                };

                vm.fnGetAssigneesTooltipInfo = function () {
                    if (vm.newIssueObj.assignees && vm.newIssueObj.assignees.length) {
                        return vm.newIssueObj.assignees.map(function (el) {
                            return el.firstName + " " + el.lastName
                        }).join(", ");
                    } else {
                        return "No assignee";
                    }
                };

                vm.fnGetLabelsTooltipInfo = function () {
                    if (vm.newIssueObj.issueLabels && vm.newIssueObj.issueLabels.length) {
                        return vm.newIssueObj.issueLabels.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No labels";
                    }
                };

                vm.fnGetParticipantsTooltipInfo = function () {
                    if (vm.newIssueObj.participants && vm.newIssueObj.participants.length) {
                        return vm.newIssueObj.participants.map(function (el) {
                            return el
                        }).join(", ");
                    } else {
                        return "No participant";
                    }
                };

                $window.onbeforeunload = function () {
                    return vm.fnSaveIssueDraft();
                };

                $scope.$on("$destroy", function () {
                    vm.fnSaveIssueDraft();
                });
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('alarmInfo', fnAlarmInfo)

    /** @ngInject */
    function fnAlarmInfo($window, $state, $stateParams, $timeout, $uibModal, microSpinner, swal, amaran, DB, ColorService,
                         copyService, NodeProjectFactory, BatchFactory, AppInitService, NodeFactory, NodeAttributesFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/alarms/alarmInfo/alarmInfo.html',
            scope: {
                alarmObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.nodeRootId = _.cloneDeepWith($scope.alarmObj.rootNodeId);
                var loginUser = DB.fnGet('loginUser');
                $scope.isShowECUTunnelOption = loginUser.id.startsWith('cu000000') && !DB.fnGet('support') && !DB.fnGet('federation');
                $scope.ecuName = _.cloneDeepWith($scope.alarmObj.ecuName);
                $scope.nodeName = _.cloneDeepWith($scope.alarmObj.nodeName);

                $scope.tabs = [
                    {
                        title: 'Telemetry',
                        tabIndex: 1,
                        templateUrl: 'app/node/alarms/alarmInfo/alarmSteps/alarmAttributes/alarmAttributes.html',
                        visible: true
                    },
                    {
                        title: 'About',
                        tabIndex: 2,
                        templateUrl: 'app/node/alarms/alarmInfo/alarmSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Issues',
                        tabIndex: 3,
                        templateUrl: 'app/node/alarms/alarmInfo/alarmSteps/alarmIssues/alarmIssues.html',
                        visible: false
                    }
                ];
                if ($scope.alarmObj.issueIds && $scope.alarmObj.issueIds.length) {
                    $scope.tabs[2].visible = true;
                }
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.alarms', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnGetAlarm = function (attributeId) {
                    var inputObj = {
                        attributeId: attributeId
                    };
                    NodeAttributesFactory.describeAttribute(inputObj)
                        .then(function (response) {
                            $scope.alarmObj = response;
                            $scope.resetAlarmObj = angular.copy($scope.alarmObj);
                            $scope.isAlarmDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAlarmDetailsLoaded = true;
                        })
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                $scope.fnCreateIssue = function (alarmObj) {
                    $scope.$emit('createIssueAttributeIssue', alarmObj);
                }

                $scope.fnOpenNodeTunnel = function (alarmObj) {
                    if (alarmObj.ecuId === alarmObj.nodeId) {
                        $scope.$emit('openNodeTunnel', alarmObj);
                    } else {
                        if (alarmObj.rootNodeId) {
                            $scope.$emit('openNodeTunnel', alarmObj);
                        } else {
                            if ($scope.nodeRootId) {
                                alarmObj.rootNodeId = _.cloneDeepWith($scope.nodeRootId);
                                $scope.$emit('openNodeTunnel', alarmObj);
                            } else {
                                swal({
                                    title: "Please wait while your data loads...",
                                    type: "warning",
                                    showConfirmButton: true,
                                    showLoaderOnConfirm: true
                                });
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                NodeFactory.describeNode({'nodeId': alarmObj.nodeId})
                                    .then(function (res) { // Success block
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                        alarmObj.rootNodeId = res.rootNodeId;
                                        $scope.$emit('openNodeTunnel', alarmObj);
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            }
                        }
                    }
                }

                $scope.fnOpenIssueListModal = function (attributes) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/issueListModal/issueListModal.html',
                        size: 'lg',
                        controller: 'issueListModalCtrl as issueList',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributes: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        _.forEach(attributes, function (attributeObj) {
                            var isFind = _.find(res.attributes, {id: attributeObj.id});
                            if (isFind) {
                                if (angular.isUndefined(attributeObj.issueIds)) {
                                    attributeObj.issueIds = [];
                                }
                                attributeObj.issueIds.push(_.cloneDeepWith(res.issueId));
                            }
                        })
                    }, function () {
                    });
                }

                $scope.fnOpenLinkIssueModal = function (attributeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/linkIssueModal/linkIssueModal.html',
                        size: 'lg',
                        controller: 'linkIssueModalCtrl as linkIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(attributeObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.fnOpenNodeInfo = function () {
                    if ($scope.alarmObj.ecuId === $scope.alarmObj.nodeId) {
                        var ecuInputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: $scope.alarmObj.ecuId,
                            displaySearchText: $scope.alarmObj.ecuId
                        }];
                        $state.go('main.ecu', {
                            filter: angular.toJson(ecuInputObj),
                            selectedId: $scope.alarmObj.ecuId
                        });
                    } else {
                        var inputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: $scope.alarmObj.nodeId,
                            displaySearchText: $scope.alarmObj.nodeId,
                            isNeedTableAlias: true
                        }];
                        $state.go('main.node', {
                            filter: angular.toJson(inputObj),
                            selectedId: $scope.alarmObj.nodeId
                        });
                    }
                };

                $scope.fnInitAlarmDetail = function () {
                    $scope.isAlarmDetailsLoaded = false;
                    $scope.alarmId = $scope.alarmObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.alarmObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        if ($scope.alarmId) {
                            $scope.fnGetAlarm($scope.alarmId);
                        }
                    } else {
                        NodeProjectFactory.describeProject({projectId: $scope.alarmObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.alarmId) {
                                $scope.fnGetAlarm($scope.alarmId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitDetails = function(){
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitAlarmDetail();
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('alarmHistoryInfo', fnAlarmHistoryInfo)

    /** @ngInject */
    function fnAlarmHistoryInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, ColorService,
                                copyService, NodeProjectFactory, BatchFactory, AppInitService, NodeFactory, NodeAttributesFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/node/alarmHistory/alarmHistoryInfo/alarmHistoryInfo.html',
            scope: {
                alarmObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.nodeRootId = _.cloneDeepWith($scope.alarmObj.rootNodeId);
                var loginUser = DB.fnGet('loginUser');
                $scope.isShowECUTunnelOption = loginUser.id.startsWith('cu000000') && !DB.fnGet('support') && !DB.fnGet('federation');
                $scope.ecuName = _.cloneDeepWith($scope.alarmObj.ecuName);
                $scope.nodeName = _.cloneDeepWith($scope.alarmObj.nodeName);

                $scope.tabs = [
                    {
                        title: 'Telemetry',
                        tabIndex: 1,
                        templateUrl: 'app/node/alarmHistory/alarmHistoryInfo/alarmHistorySteps/alarmHistoryAttributes/alarmHistoryAttributes.html',
                        visible: true
                    },
                    {
                        title: 'About',
                        tabIndex: 2,
                        templateUrl: 'app/node/alarms/alarmInfo/alarmSteps/details.html',
                        visible: true
                    },
                    {
                        title: 'Issues',
                        tabIndex: 3,
                        templateUrl: 'app/node/alarmHistory/alarmHistoryInfo/alarmHistorySteps/alarmHistoryIssues/alarmHistoryIssues.html',
                        visible: false
                    }
                ];
                if ($scope.alarmObj.issueIds && $scope.alarmObj.issueIds.length) {
                    $scope.tabs[2].visible = true;
                }
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.alarmHistory', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnGetAlarm = function (attributeId) {
                    var inputObj = {
                        attributeId: attributeId
                    };
                    NodeAttributesFactory.describeAttribute(inputObj)
                        .then(function (response) {
                            $scope.alarmObj = response;
                            $scope.resetAlarmObj = angular.copy($scope.alarmObj);
                            $scope.isAlarmDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAlarmDetailsLoaded = true;
                        })
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                $scope.fnCreateIssue = function (alarmObj) {
                    $scope.$emit('createIssueAttributeIssue', alarmObj);
                }

                $scope.fnOpenNodeTunnel = function (alarmObj) {
                    if (alarmObj.ecuId === alarmObj.nodeId) {
                        $scope.$emit('openNodeTunnel', alarmObj);
                    } else {
                        if (alarmObj.rootNodeId) {
                            $scope.$emit('openNodeTunnel', alarmObj);
                        } else {
                            if ($scope.nodeRootId) {
                                alarmObj.rootNodeId = _.cloneDeepWith($scope.nodeRootId);
                                $scope.$emit('openNodeTunnel', alarmObj);
                            } else {
                                swal({
                                    title: "Please wait while your data loads...",
                                    type: "warning",
                                    showConfirmButton: true,
                                    showLoaderOnConfirm: true
                                });
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                NodeFactory.describeNode({'nodeId': alarmObj.nodeId})
                                    .then(function (res) { // Success block
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                        alarmObj.rootNodeId = res.rootNodeId;
                                        $scope.$emit('openNodeTunnel', alarmObj);
                                    }, function (error) { // Error block
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            }
                        }
                    }
                };

                $scope.fnOpenNodeInfo = function () {
                    if ($scope.alarmObj.ecuId === $scope.alarmObj.nodeId) {
                        var ecuInputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: $scope.alarmObj.ecuId,
                            displaySearchText: $scope.alarmObj.ecuId
                        }];
                        $state.go('main.ecu', {
                            filter: angular.toJson(ecuInputObj),
                            selectedId: $scope.alarmObj.ecuId
                        });
                    } else {
                        var inputObj = [{
                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                            selectedField: "id",
                            displaySelectedField: "ID",
                            selectedFilter: {
                                operatorName: "=",
                                operator: "="
                            },
                            searchText: $scope.alarmObj.nodeId,
                            displaySearchText: $scope.alarmObj.nodeId,
                            isNeedTableAlias: true
                        }];
                        $state.go('main.node', {
                            filter: angular.toJson(inputObj),
                            selectedId: $scope.alarmObj.nodeId
                        });
                    }
                };

                $scope.fnInitAlarmDetail = function () {
                    $scope.isAlarmDetailsLoaded = false;
                    $scope.alarmId = $scope.alarmObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.alarmObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        if ($scope.alarmId) {
                            $scope.fnGetAlarm($scope.alarmId);
                        }
                    } else {
                        NodeProjectFactory.describeProject({projectId: $scope.alarmObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.alarmId) {
                                $scope.fnGetAlarm($scope.alarmId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitDetails = function(){
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitAlarmDetail();
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('federationOptionsCtrl',
            function ($window, $uibModalInstance, $timeout, amaran, $stateParams, UserProfileService, PaginationQueryService, QueryFactory) {
                var vm = this;

                vm.federationsArr = [];
                vm.isRefreshData = true;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                var typeFieldArr = [
                    {name: 'INBOUND', displayName: 'INBOUND'},
                    {name: 'OUTBOUND', displayName: 'OUTBOUND'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Alias",
                        name: "alias",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Type",
                        name: "type",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: typeFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'alias', displayName: 'Alias'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";

                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if (sortQuery) {
                        vm.sort = sortQuery
                    } else {
                        vm.sort = '';
                    }
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    vm.isFederationsLoading = true;
                    vm.previousPage = 1;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_federations';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE data->>\'type\' = 'OUTBOUND' and " + vm.sqlQuery.trim() : " WHERE data->>\'type\' = 'OUTBOUND'";
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_federations';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE data->>\'type\' = 'OUTBOUND' and " + vm.sqlQuery.trim() : " WHERE data->>\'type\' = 'OUTBOUND'";
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetFederations(input, true);
                };

                /*START: End*/

                vm.fnSetTableHeight = function () {
                    if (angular.element(".modal-content")[0]) {
                        var total = angular.element(".modal-content")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        var searchDiv = 0;
                        var pagination = 0;
                        if (angular.element(".federation-searchDiv")[0]) {
                            searchDiv = angular.element(".federation-searchDiv")[0].offsetHeight;
                        }
                        if (angular.element(".federation-footerDiv")[0]) {
                            footer = angular.element(".federation-footerDiv")[0].offsetHeight;
                        }
                        if (angular.element(".federation-headerDiv")[0]) {
                            header = angular.element(".federation-headerDiv")[0].offsetHeight;
                        }
                        if (angular.element(".federation-pagination")[0]) {
                            pagination = angular.element(".federation-pagination")[0].offsetHeight;
                        }
                        var finalHeight = total - (searchDiv + header + pagination + footer);
                        angular.element(".federation-ModelDiv").css('height', (finalHeight - 25) + 'px');
                    }
                };

                vm.fnSelectFederation = function (fedObj) {
                    $uibModalInstance.close(fedObj)
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetFederations = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.federationsResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.federationsResponse.data && vm.federationsResponse.data.length) {
                                vm.totalItems = vm.federationsResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.federationsResponse.data.reverse();
                            }
                            vm.federationsArr = vm.federationsResponse.data;
                            vm.isRefresh = false;
                            vm.isFederationsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFederationsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isFederationsLoading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_federations';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_federations';
                    }
                    if (isPerPageChanged) {
                        //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_federations';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE data->>\'type'\ = 'OUTBOUND' and " + vm.sqlQuery.trim() : "WHERE data->>\'type\' = 'OUTBOUND'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_federations';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE data->>\'type\' = 'OUTBOUND' and " + vm.sqlQuery.trim() : "WHERE data->>\'type\' = 'OUTBOUND'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetFederations(perPageInput, true);
                    } else {//for page change
                        if(vm.sqlQuery && vm.sqlQuery.length){
                            vm.sqlQuery += " and data->>\'type\' = 'OUTBOUND'";
                        } else {
                            vm.sqlQuery += " data->>\'type\' = 'OUTBOUND'";
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.federationsArr);
                        vm.previousPage = page;
                        vm.fnGetFederations(input, false);
                    }
                };

                $timeout(function () {
                    vm.fnSetTableHeight();
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('federatedAccessCtrl',
            function ($scope, $uibModalInstance, $timeout, DB, amaran, AvatarService, copyService, FedSudoUserService) {
                var vm = this;
                vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                vm.fnGetUserAvatar = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                };

                vm.fnCopyInfoToClipboard = function (data, type) {
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnReturnToMyAccount = function(){
                    $uibModalInstance.close('ReturnToMyAccount');
                };

                vm.fnUpdateUserWindowChoice = function(){
                    FedSudoUserService.fnSetAuthUserData('isFederationInitMessageEnabled', ["" + false + ""]);
                    $timeout(function () {
                        $uibModalInstance.dismiss('cancel');
                    })
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitModal = function () {
                    vm.federationObj = DB.fnGet('federation');
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightWidgetInfo', fnInsightWidgetInfo)

    /** @ngInject */
    function fnInsightWidgetInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, InsightWidgetFactory, AppInitService, InsightProjectFactory, QueryFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/insight/insight_widgets/insightWidgetInfo/insightWidgetInfo.html',
            scope: {
                widgetObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Widget',
                        tabIndex: 1,
                        templateUrl: 'app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetWidget/insightWidgetWidget.html'
                    },
                    {
                        title: 'Chart',
                        tabIndex: 2,
                        templateUrl: 'app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetChart/insightWidgetChart.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 3,
                        templateUrl: 'app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 4,
                        templateUrl: 'app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetTags/insightWidgetTags.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.selectedProject = {};

                $scope.fnGetWidget = function (widgetId) {
                    var inputObj = {
                        widgetId: widgetId
                    };
                    InsightWidgetFactory.describeWidget(inputObj)
                        .then(function (response) {
                            $scope.widgetObj = response;
                            $scope.resetWidgetObj = angular.copy($scope.widgetObj);
                            if (angular.isUndefined($scope.widgetObj.description)) {
                                $scope.widgetObj.description = '';
                            }
                            $scope.isWidgetDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isWidgetDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.insight_widgets', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateWidgetDetails = function (widgetObj) {
                    var inputObj = {
                        body: {},
                        widgetId: widgetObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(widgetObj.description)) {
                        widgetObj.description = '';
                    }
                    inputObj.body = {
                        name: widgetObj.name,
                        description: widgetObj.description
                    };
                    InsightWidgetFactory.updateWidget(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('WidgetDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Widget Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteWidget = function (widgetObj) {
                    swal({
                            title: "Delete the selected Widget?",
                            text: "You are about to permanently delete the selected Widget.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    widgetId: widgetObj.id
                                };
                                InsightWidgetFactory.deleteWidget(inputObj)
                                    .then(function () {
                                        $scope.$emit('QueriesDeleted', widgetObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.widgetObj = angular.copy($scope.resetWidgetObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitWidget = function () {
                    $scope.isWidgetDetailsLoaded = false;
                    $scope.widgetId = $scope.widgetObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('insightProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.widgetObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetWidget($scope.widgetId);
                    } else {
                        InsightProjectFactory.describeProject({projectId: $scope.widgetObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.widgetId) {
                                $scope.fnGetWidget($scope.widgetId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitWidget();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var widgetInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_widgets') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteWidget($scope.widgetObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var widgetInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_widgets') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', widgetInfoKeyDownEventHandler);
                document.addEventListener('keyup', widgetInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', widgetInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', widgetInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightWidgetCtrl',
            function ($scope, $window, $sce, $uibModal, moment, Highcharts, amaran, DB, $timeout, InsightChartFactory, InsightWidgetFactory, PaginationQueryService, AppInitService, QueryFactory, jsonToCsvConvertService, UserProfileService) {
                var vm = this;
                vm.title = "Create Widget";
                vm.svgArr = [
                    {
                        title: "Dashboard",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Account",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "User",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Team",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Vault",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Authenticator",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Federation",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email Template",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Audits",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/log.svg#log\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "S4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Issues",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Archives",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/archive.svg#archive\"></use> \n" +
                            "</svg>"
                    }, {
                        title: "Projects",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Labels",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/label.svg#label\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Priorities",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "States",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/state.svg#state\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Types",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/types.svg#types\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Payment Methods",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/card.svg#card\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Invoices",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/invoice.svg#invoice\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Discounts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/discount.svg#discount\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Credit Tokens",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/creditTokens.svg#creditToken\"></use> \n" +
                            "</svg>"

                    },
                    {
                        title: "Business",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/business.svg#business\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Plans",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/plan.svg#plan\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Products",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/product.svg#product\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Carts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"22px\" height=\"22px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/cart.svg#cart\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ECU",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Nodes",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/device.svg#device\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Alarms",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Jobs",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/jobs.svg#jobs\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Fleet",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Software",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/software.svg#software\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Healths",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/health.svg#health\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "ES4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/es4.svg#es4\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Observers",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/observers.svg#observers\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Emails",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    }
                ];
                vm.activeStep = 1;
                vm.newWidgetObj = {
                    name: '',
                    description: '',
                    chartId: '',
                    projectId: '',
                    layout: {}
                };
                vm.widgetConfig = {
                    title: "",
                    icon: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">   <use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use> </svg>",
                    buttonText: "",
                    buttonLink: "",
                    target: "Same Window",
                    isExport: true,
                    exportOptions: [
                        {
                            name:"Download PNG image",
                            action: "downloadPNG",
                            isAllow: true
                        },
                        {
                            name:"Download JPEG image",
                            action: "downloadJPEG",
                            isAllow: true
                        },
                        {
                            name:"Download PDF image",
                            action: "downloadPDF",
                            isAllow: true
                        },
                        {
                            name:"Download SVG vector image",
                            action: "downloadSVG",
                            isAllow: true
                        },
                        {
                            name:"Download CSV File",
                            action: "downloadCSV",
                            isAllow: true
                        },
                        {
                            name:"Download XLS File",
                            action: "downloadXLS",
                            isAllow: true
                        }
                    ],
                    isTrackerExport: false
                }
                vm.isPasteSVGCode = false;
                vm.isWidgetCreating = false;

                var tableName = 'insight_charts';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.chartsProjectFilter = "$";
                vm.chartsProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isChartsLoading = false;
                vm.chartsResponse = [];
                vm.chartsArr = [];
                vm.selectedChartsArr = [];
                vm.selectedChartsObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.fnEditSVGCode = function () {
                    vm.isPasteSVGCode = true;
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createWidgetModalBody").css('height', finalHeight + 'px');
                        if (angular.element(".wizard")[0] && angular.element(".tab-content")[0] && angular.element(".title-border-bottom")[0]) {
                            var wizardInner = angular.element(".wizard")[0].offsetHeight;
                            var titleBorderBottom = angular.element(".title-border-bottom")[0].offsetHeight !== 0 ? angular.element(".title-border-bottom")[0].offsetHeight : 29;
                            angular.element(".wizard-tab-height").css('height', finalHeight - (wizardInner + titleBorderBottom + 30) + 'px');
                            if (angular.element("#chartsTable")[0] && vm.activeStep === 1) {
                                if (angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                                    angular.isDefined(angular.element("thead")[0]) &&
                                    angular.isDefined(angular.element(".pagination-container")[0])) {
                                    var modalTotal = finalHeight - (wizardInner + titleBorderBottom + 30);
                                    var search = angular.element(".search-panel-v4")[0].offsetHeight;
                                    var searchTag = 0;
                                    var tableHeader = angular.element("thead")[0].offsetHeight;
                                    var pagination = angular.element(".pagination-container")[0].offsetHeight;
                                    var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                                    var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                                    var finalTableHeight = modalTotal - (search + pagination + searchTag + tableHeader + 70 + dashboardHeader + mainFooter);
                                    angular.element("#chartsTable").css('height', finalTableHeight + 'px');
                                }
                            }
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".wizard-tab-height")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".wizard-tab-height")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'charts', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectCharts = function (projectObj) {
                    vm.isChartsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetCharts(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.chartsArr);
                        vm.previousPage = page;
                        vm.fnGetCharts(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetCharts = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.chartsResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.chartsResponse.data && vm.chartsResponse.data.length) {
                                vm.totalItems = vm.chartsResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.chartsResponse.data.reverse();
                            }
                            vm.chartsArr = _.cloneDeepWith(vm.chartsResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isChartsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (chartsObj) {
                    angular.forEach(vm.chartsArr, function (obj) {
                        if (chartsObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindCharts = _.find(vm.chartsArr, function (chartsObj) {
                        return chartsObj.isCheck === true;
                    });
                    if (isFindCharts) {
                        vm.selectedChartsObj = _.cloneDeepWith(isFindCharts);
                    } else {
                        vm.selectedChartsObj = {};
                    }
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.isChartsObjSelected = function () {
                    return !!vm.selectedChartsObj && Object.keys(vm.selectedChartsObj).length;
                };

                vm.fnSelectIcon = function (obj) {
                    vm.widgetConfig.icon = obj.iconURL;
                };

                vm.fnGotoPreviousNextStep = function (isGotoPreviousStep) {
                    if (vm.activeStep === 1) {
                        if (angular.isDefined(vm.selectedChartsObj) && Object.keys(vm.selectedChartsObj).length) {
                            var inputObj = {
                                chartId: vm.selectedChartsObj.id
                            };
                            InsightChartFactory.executeChart(inputObj)
                                .then(function (response) {
                                    vm.previewWidgetChartData = "";
                                    var headers = {};
                                    _.forEach(response.definition.dataMapping, function (val) {
                                        headers[val] = val;
                                    });
                                    var items = [];
                                    if (response.query && response.query.results && response.query.results.data && response.query.results.data.length) {
                                        _.forEach(response.query.results.data, function (obj) {
                                            var tempObj = {};
                                            _.forEach(response.definition.dataMapping, function (val) {
                                                tempObj[val] = obj[val] !== null ? obj[val] : 0;
                                            });
                                            items.push(tempObj);
                                        });
                                    }
                                    items.unshift(headers);
                                    response.definition.chartConfig.data.csv = jsonToCsvConvertService.convertToCSV(angular.toJson(items));
                                    vm.previewWidgetChartData = _.cloneDeepWith(response.definition.chartConfig);
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    });
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isChartDetailsLoaded = true;
                                })
                        }
                    }
                    if (isGotoPreviousStep) {
                        vm.activeStep = vm.activeStep - 1;
                    } else {
                        vm.activeStep = vm.activeStep + 1;
                    }
                    /*if (vm.activeStep === 3) {

                    }*/
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnCreateNewWidget = function (newWidgetObj) {
                    vm.isWidgetCreating = true;
                    var inputObj = {
                        body: newWidgetObj
                    };
                    inputObj.body.chartId = vm.selectedChartsObj.id;
                    inputObj.body.projectId = vm.selectedChartsObj.projectId;
                    inputObj.body.layout = _.cloneDeepWith(vm.widgetConfig);
                    InsightWidgetFactory.createWidget(inputObj)
                        .then(function (resObj) {
                            vm.isWidgetCreating = false;
                            vm.newWidgetObj = {
                                name: '',
                                description: '',
                                chartId: '',
                                projectId: '',
                                layout: {}
                            };
                            vm.widgetConfig = {
                                title: "",
                                icon: "",
                                buttonText: "",
                                buttonLink: "",
                                target: "Same Window"
                            }
                            amaran.success("Widget created successfully");
                            $timeout(function () {
                                $scope.insightWidgets.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('widgetAdded', resObj.id);
                            $scope.insightWidgets.totalItems = $scope.insightWidgets.totalItems + 1;
                            $scope.insightWidgets.widgetsArr.push(resObj);
                            $scope.insightWidgets.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetCreating = false;
                        });
                }

                vm.fnInitCreateWidget = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightIssueCtrl',
            function ($rootScope, $window, $stateParams, $http, $scope, $timeout, $state, $uibModal, mermaid, AppInitService,
                      ProjectFactory, swal, amaran, moment, DB, PermissionsService, AvatarService, IssueFactory,
                      EmailFactory, UserFactory, QueryFactory, UserProfileService, TypeFormService, TypesFactory) {
                var vm = this;
                vm.issueDraftObj = {};
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    });
                });

                vm.isIssueCreating = false;
                vm.fileUploading = false;
                vm.newIssueObj = {
                    confidential: false,
                    assignees: [],
                    issueLabels: [],
                    participants: [],
                    name: "",
                    summary: "",
                    resolved: false
                };
                vm.resetNewIssueObj = angular.copy(vm.newIssueObj);
                vm.projectsArr = [];
                vm.selectedProject = {};

                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};

                vm.filter = "$";
                vm.labelSearch = {$: ''};

                /*Types: START*/
                vm.typesArr = [];
                vm.selectedType = {};
                vm.isIssueTypeLoaded = false;
                vm.model = {};
                vm.schema = {};
                vm.form = ['*'];
                vm.isTypeDetailsLoaded = true;
                /*Types: END*/

                /*Assignee: START*/
                vm.filterAssignees = "$";
                vm.assigneeSearch = {$: ''};
                vm.usersArr = [{
                    username: 'assign to me'
                }];
                vm.isIssueAssigneeLoaded = false;
                vm.changeAssigneeView = false;
                vm.isAssigneeChanged = true;
                vm.selectedUser = "";
                /*Assignee: END*/

                /*Labels: START*/
                vm.labelsArr = [];
                vm.isIssueLablesLoaded = false;
                vm.addLabelView = false;
                vm.isLabelsAdded = true;
                vm.selectedLabelsArr = [];
                vm.selectedLabel = {};
                /*Labels: END*/

                /*Priority: START*/
                vm.priorityFilter = "$";
                vm.prioritySearch = {$: ''};
                vm.prioritiesArr = [];
                vm.isIssuePriorityLoaded = false;
                vm.changePriorityView = false;
                vm.isPriorityChanged = true;
                vm.selectedPriority = "";
                /*Priority: END*/

                /*State: START*/
                vm.stateFilter = "$";
                vm.stateSearch = {$: ''};
                vm.statesArr = [];
                vm.isIssueStateLoaded = false;
                vm.changeStateView = false;
                vm.isStateChanged = true;
                vm.selectedState = {};
                /*State: END*/

                /*Participant: START*/
                vm.participantFilter = "$";
                vm.participantSearch = {$: ''};
                vm.participantsArr = [];
                vm.isIssueParticipantLoaded = false;
                vm.changeParticipantView = false;
                vm.isParticipantChanged = true;
                vm.selectedParticipant = {};
                vm.assigneesParticipants = [];
                /*Participant: END*/

                /*Confidential: START*/
                vm.confidentialsArr = [{'name': "Confidential", 'value': true}, {
                    'name': "Not Confidential",
                    'value': false
                }];
                vm.isIssueConfidentialLoaded = false;
                vm.changeConfidentialView = false;
                vm.isConfidentialChanged = true;
                vm.selectedConfidential = {};
                /*Confidential: END*/

                vm.projectRelationshipsObj = {};

                vm.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        vm.fnRenderMermaid();
                    }
                };

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        if (type === 'image') {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                        } else {
                            vm.newIssueObj.summary = vm.newIssueObj.summary + " [" + filedata.name + "](" + res.downloadUrl + ")";
                        }
                        vm.fileUploading = false;
                    });
                };

                vm.uploadFiles = function (type, filedata) {
                    if (vm.permissionObj.GET_FILE_UPLOAD_LINK) {
                        vm.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                vm.fnCreateNewIssue = function (newIssueObj) {
                    if (newIssueObj.issueType && newIssueObj.issueType.form) {
                        newIssueObj.issueType.form.values = vm.model;
                    }
                    if (newIssueObj.rowData) {
                        delete newIssueObj.rowData;
                    }
                    vm.isIssueCreating = true;
                    var inputObj = {
                        'body': newIssueObj,
                        'projectId': vm.selectedProject.id
                    };
                    IssueFactory.createIssue(inputObj)
                        .then(function () {
                            vm.isIssueCreating = false;
                            vm.newIssueObj = angular.copy(vm.resetNewIssueObj);
                            localStorage.removeItem('insightIssueDraft');
                            localStorage.removeItem('insightFedSupportIssueDraft');
                            if (newIssueObj.participants && newIssueObj.participants.length) {
                                var tempArr = [];
                                _.forEach(newIssueObj.participants, function (participant) {
                                    tempArr.push({
                                        email: participant
                                    })
                                });
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', tempArr);
                            } else {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', []);
                            }
                            vm.model = {};
                            vm.fnInitCreateIssue();
                            $scope.$emit('issueAdded');
                        }, function () {
                            vm.isIssueCreating = false;
                        })
                };

                vm.fnChangeProject = function (projectObj) {
                    vm.selectedProject = projectObj;
                    vm.newIssueObj.projectId = projectObj.id;
                    vm.newIssueObj.issueLabels = [];
                    delete vm.newIssueObj.issueState;
                    delete vm.newIssueObj.issuePriority;

                    /*Types: START*/
                    vm.typesArr = [];
                    vm.selectedType = {};
                    vm.isIssueTypeLoaded = false;
                    vm.model = {};
                    vm.schema = {};
                    vm.form = ['*'];
                    /*Types: END*/

                    /*Labels: START*/
                    vm.labelsArr = [];
                    vm.isIssueLablesLoaded = false;
                    vm.addLabelView = false;
                    vm.isLabelsAdded = true;
                    vm.selectedLabelsArr = [];
                    vm.selectedLabel = {};
                    /*Labels: END*/

                    /*Priority: START*/
                    vm.prioritiesArr = [];
                    vm.isIssuePriorityLoaded = false;
                    vm.changePriorityView = false;
                    vm.isPriorityChanged = true;
                    vm.selectedPriority = "";
                    /*Priority: END*/

                    /*State: START*/
                    vm.statesArr = [];
                    vm.isIssueStateLoaded = false;
                    vm.changeStateView = false;
                    vm.isStateChanged = true;
                    vm.selectedState = {};
                    /*State: END*/

                    vm.isIssueTypeLoaded = false;
                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;
                        }, function () {
                        });
                };

                /*Assignee: START*/
                vm.addAssigneeArr = [];
                vm.deleteAssigneeArr = [];

                vm.fnGetUsers = function (inputObj) {
                    ProjectFactory.listPossibleProjectAssignees(inputObj)
                        .then(function (response) {
                            _.forEach(response, function (userObj) {
                                userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                                if (vm.issueDraftObj && vm.issueDraftObj.assignees && vm.issueDraftObj.assignees.length) {
                                    var isFindAssignee = _.find(vm.issueDraftObj.assignees, {id: userObj.id});
                                    if (isFindAssignee) {
                                        userObj.isCheck = true;

                                        if (!vm.assigneesAssignees) {
                                            vm.assigneesAssignees = [];
                                        }
                                        vm.assigneesAssignees.push({
                                            bio: userObj.bio,
                                            firstName: userObj.firstName,
                                            id: userObj.id,
                                            lastName: userObj.lastName,
                                            tags: userObj.tags,
                                            username: userObj.username,
                                            userAvatar: userObj.userAvatar,
                                            email: userObj.email
                                        })
                                    }
                                }
                            });
                            response.sort(function (a, b) {
                                if (a.firstName < b.firstName) {
                                    return -1;
                                }
                                if (a.firstName > b.firstName) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.usersArr = _.cloneDeepWith(response);
                            vm.isIssueAssigneeLoaded = true;
                        }, function () {
                            vm.isIssueAssigneeLoaded = true;
                        })
                };

                vm.fnGetAssigneeInfo = function (assigneeObj) {
                    if (assigneeObj.isCheck) {
                        assigneeObj.isCheck = false;
                        var isFindAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (isFindAssignee) {
                            vm.deleteAssigneeArr.push(isFindAssignee);
                        } else {
                            var isFindAssigneeInAddAssigneeArr = _.findIndex(vm.addAssigneeArr, {id: assigneeObj.id});
                            if (isFindAssigneeInAddAssigneeArr !== 1) {
                                vm.addAssigneeArr.splice(isFindAssigneeInAddAssigneeArr, 1);
                            }
                        }
                    } else {
                        assigneeObj.isCheck = true;
                        var isFindAssigneesAssignee = _.find(vm.assigneesAssignees, {id: assigneeObj.id});
                        if (!isFindAssigneesAssignee) {
                            vm.addAssigneeArr.push(assigneeObj);
                        } else {
                            var isFindDeleteAssignee = _.findIndex(vm.deleteAssigneeArr, {id: assigneeObj.id});
                            if (isFindDeleteAssignee !== -1) {
                                vm.deleteAssigneeArr.splice(isFindDeleteAssignee, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeAssignee = function () {
                    vm.selectedAssignee = {};
                    vm.changeAssigneeView = false;
                    if (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length) {
                        vm.fnUpdateIssueAssignee();
                    }
                };

                vm.fnOnToggleAssignee = function (isOpen) {
                    if (isOpen === false && (vm.deleteAssigneeArr.length || vm.addAssigneeArr.length)) {
                        vm.fnUpdateIssueAssignee();
                    } else {
                        vm.changeAssigneeView = false;
                        vm.selectedAssignee = {};
                    }
                };

                vm.fnUpdateIssueAssignee = function () {
                    vm.isIssueAssigneeLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesAssignees, function (assigneeObj) {
                        var findIndex = _.findIndex(vm.deleteAssigneeArr, function (deleteObj) {
                            return deleteObj.id === assigneeObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: assigneeObj.bio,
                                firstName: assigneeObj.firstName,
                                id: assigneeObj.id,
                                lastName: assigneeObj.lastName,
                                tags: assigneeObj.tags,
                                username: assigneeObj.username,
                                userAvatar: assigneeObj.userAvatar,
                                email: assigneeObj.email
                            });
                        }
                    });
                    _.forEach(vm.addAssigneeArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesAssignees, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: addObj.bio,
                                firstName: addObj.firstName,
                                id: addObj.id,
                                lastName: addObj.lastName,
                                tags: addObj.tags,
                                username: addObj.username,
                                userAvatar: addObj.userAvatar,
                                email: addObj.email
                            })
                        }
                    });
                    vm.newIssueObj.assignees = _.cloneDeepWith(tempArr);
                    vm.assigneesAssignees = _.cloneDeepWith(tempArr);
                    vm.isIssueAssigneeLoaded = true;
                    vm.selectedAssignee = "";
                    vm.deleteAssigneeArr = [];
                    vm.addAssigneeArr = [];
                    vm.changeAssigneeView = false;
                };

                vm.fnOpenChangeAssigneeView = function () {
                    vm.changeAssigneeView = true;
                    _.forEach(vm.assigneesAssignees, function (issueAssigneeObj) {
                        var isFindAssignee = _.find(vm.usersArr, {id: issueAssigneeObj.id});
                        isFindAssignee.isCheck = !!isFindAssignee;
                    });
                };

                vm.fnManageAssignees = function () {
                    $state.go("main.users");
                };
                /*Assignee: END*/

                /*Type: START*/
                vm.fnGetTypes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            vm.typesArr = _.cloneDeepWith(response.data);
                            vm.typesArr.unshift({
                                id: "noType",
                                name: "Select Type"
                            });
                            if (vm.issueDraftObj && vm.issueDraftObj.issueType) {
                                var isFindType = _.find(vm.typesArr, {id: vm.issueDraftObj.issueType.id});
                                if (isFindType) {
                                    vm.selectedType = vm.issueDraftObj.issueType;
                                    vm.fnCreateTypeForm();
                                } else {
                                    vm.selectedType = vm.typesArr[0];
                                }
                            } else {
                                vm.selectedType = vm.typesArr[0];
                            }
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isIssueTypeLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        })
                };

                vm.fnSelectType = function (typeObj) {
                    vm.selectedType = typeObj;
                    if (vm.selectedType.id === 'noType') {
                        delete vm.newIssueObj.issueType;
                        vm.model = {};
                        vm.schema = {};
                        vm.form = ['*'];
                    } else {
                        vm.newIssueObj.issueType = typeObj;
                        vm.fnCreateTypeForm();
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                vm.fnCheckIssueTypeValidation = function () {
                    if (vm.newIssueObj.issueType && vm.form.length) {
                        var flag = false;
                        _.forEach(vm.form, function (formObj) {
                            if (formObj.required) {
                                _.forEach(formObj.key, function (keyValue) {
                                    if (angular.isUndefined(vm.model[keyValue]) || (angular.isDefined(vm.model[keyValue]) && !vm.model[keyValue].toString().length)) {
                                        flag = true;
                                    }
                                })
                            }
                        });
                        return flag;
                    } else {
                        return false;
                    }
                };

                vm.fnCreateTypeForm = function () {
                    vm.isTypeDetailsLoaded = false;
                    var inputObj = {
                        typeId: vm.selectedType.id
                    };
                    TypesFactory.describeIssueType(inputObj)
                        .then(function (response) {
                            if (response.form && response.form.schema && response.form.schema.properties && Object.keys(response.form.schema.properties).length) {
                                var tempData = TypeFormService.fnGenerateFormData(response.form.schema);
                                vm.schema = tempData.schema;
                                vm.form = tempData.form;
                                if (angular.isDefined(vm.issueDraftObj)) {
                                    if (angular.isDefined(vm.newIssueObj.issueType) && angular.isDefined(vm.newIssueObj.issueType.form)) {
                                        vm.model = vm.issueDraftObj.issueType.form.values;
                                    }
                                }
                            } else {
                                vm.schema = {
                                    $schema: "https://json-schema.org/draft/2019-09/schema",
                                    type: "object",
                                    properties: {}
                                };
                                vm.form = [];
                            }
                            vm.isTypeDetailsLoaded = true;
                            $timeout(function () {
                                vm.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            vm.isTypeDetailsLoaded = true;
                            //vm.fnCreateTypeForm();
                        });
                };
                /*Type: END*/

                /*Priority: START*/
                vm.addPrioritiesArr = [];
                vm.deletePrioritiesArr = [];
                vm.fnGetPriorities = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.prioritiesArr = _.cloneDeepWith(response.data);
                            vm.isIssuePriorityLoaded = true;
                        }, function () {
                            vm.isIssuePriorityLoaded = true;
                        })
                };

                vm.fnGetPrioritiesInfo = function (prioritiesObj) {
                    _.forEach(vm.prioritiesArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deletePrioritiesArr = [];
                    vm.addPrioritiesArr = [];
                    var isFindCheck = _.find(vm.prioritiesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id !== isFindCheck.id) {
                                vm.addPrioritiesArr = [prioritiesObj];
                            }
                        } else {
                            vm.addPrioritiesArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesPriorities.id)) {
                            if (vm.assigneesPriorities.id === prioritiesObj.id) {
                                vm.deletePrioritiesArr = [vm.assigneesPriorities];
                            }
                        }

                    }
                };

                vm.fnCancelChangePriority = function () {
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                    if (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length) {
                        vm.fnUpdateIssuePriority();
                    }
                };

                vm.fnOnTogglePriority = function (isOpen) {
                    if (isOpen === false && (vm.deletePrioritiesArr.length || vm.addPrioritiesArr.length)) {
                        vm.fnUpdateIssuePriority();
                    } else {
                        vm.changePriorityView = false;
                        vm.selectedPriority = {};
                    }
                };

                vm.fnUpdateIssuePriority = function () {
                    vm.isIssuePriorityLoaded = false;
                    if (vm.deletePrioritiesArr.length) {
                        delete vm.newIssueObj.issuePriority;
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    } else {
                        vm.newIssueObj.issuePriority = vm.addPrioritiesArr[0];
                        vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                        _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                        });
                        vm.changePriorityView = false;
                        vm.isIssuePriorityLoaded = true;
                        vm.deletePrioritiesArr = [];
                        vm.addPrioritiesArr = [];
                    }
                    vm.selectedPriority = {};
                    vm.changePriorityView = false;
                };

                vm.fnOpenChangePriorityView = function () {
                    vm.changePriorityView = true;
                    _.forEach(vm.prioritiesArr, function (prioritiesObj) {
                        prioritiesObj.isCheck = !!(vm.assigneesPriorities && vm.assigneesPriorities.id && prioritiesObj.id === vm.assigneesPriorities.id);
                    });
                };

                vm.fnManageProjectPriority = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.priorities", {filter: angular.toJson(inputObj)});
                };
                /*Priority: END*/

                /*State: START*/
                vm.addStatesArr = [];
                vm.deleteStatesArr = [];
                vm.fnGetStates = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.statesArr = _.cloneDeepWith(response.data);
                            vm.isIssueStateLoaded = true;
                        }, function () {
                            vm.isIssueStateLoaded = true;
                        })
                };

                vm.fnGetStatesInfo = function (statesObj) {
                    _.forEach(vm.statesArr, function (states) {
                        if (statesObj.id !== states.id) {
                            states.isCheck = false;
                        }
                    });
                    statesObj.isCheck = !statesObj.isCheck;
                    vm.deleteStatesArr = [];
                    vm.addStatesArr = [];
                    var isFindCheck = _.find(vm.statesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id !== isFindCheck.id) {
                                vm.addStatesArr = [statesObj];
                            }
                        } else {
                            vm.addStatesArr = [statesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.assigneesState.id)) {
                            if (vm.assigneesState.id === statesObj.id) {
                                vm.deleteStatesArr = [vm.assigneesState];
                            }
                        }
                    }
                };

                vm.fnCancelChangeState = function () {
                    vm.selectedState = {};
                    vm.changeStateView = false;
                    if (vm.deleteStatesArr.length || vm.addStatesArr.length) {
                        vm.fnUpdateIssueState();
                    }
                };

                vm.fnOnToggleState = function (isOpen) {
                    if (isOpen === false && (vm.deleteStatesArr.length || vm.addStatesArr.length)) {
                        vm.fnUpdateIssueState();
                    } else {
                        vm.changeStateView = false;
                        vm.selectedState = {};
                    }
                };

                vm.fnUpdateIssueState = function () {
                    vm.isIssueStateLoaded = false;
                    if (vm.deleteStatesArr.length) {
                        delete vm.newIssueObj.issueState;
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    } else {
                        vm.newIssueObj.issueState = vm.addStatesArr[0];
                        vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                        _.forEach(vm.statesArr, function (statesObj) {
                            statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                        });
                        vm.changeStateView = false;
                        vm.isIssueStateLoaded = true;
                        vm.deleteStatesArr = [];
                        vm.addStatesArr = [];
                    }
                    vm.selectedState = {};
                    vm.changeStateView = false;
                };

                vm.fnOpenChangeStateView = function () {
                    vm.changeStateView = true;
                    _.forEach(vm.statesArr, function (statesObj) {
                        statesObj.isCheck = !!(vm.assigneesState && vm.assigneesState.id && statesObj.id === vm.assigneesState.id);
                    });
                };

                vm.fnManageProjectState = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.project.id,
                        "displaySearchText": vm.newIssueObj.project.name
                    }];
                    vm.go("main.state", {filter: angular.toJson(inputObj)});
                };
                /*State: END*/

                /*Labels: START*/
                vm.addLabelArr = [];
                vm.deleteLabelArr = [];
                vm.fnGetLabels = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            vm.labelsArr = _.cloneDeepWith(response.data);
                            vm.isIssueLablesLoaded = true;
                        }, function () {
                            vm.isIssueLablesLoaded = true;
                        })
                };

                vm.fnGetLabelInfo = function (labelObj) {
                    if (labelObj.isCheck) {
                        labelObj.isCheck = false;
                        var isFindLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (isFindLabel) {
                            vm.deleteLabelArr.push(isFindLabel);
                        } else {
                            var isFindLabelInAddLabelArr = _.findIndex(vm.addLabelArr, {id: labelObj.id});
                            if (isFindLabelInAddLabelArr !== 1) {
                                vm.addLabelArr.splice(isFindLabelInAddLabelArr, 1);
                            }
                        }
                    } else {
                        labelObj.isCheck = true;
                        var isFindAssigneesLabel = _.find(vm.assigneesLabels, {id: labelObj.id});
                        if (!isFindAssigneesLabel) {
                            vm.addLabelArr.push(labelObj);
                        } else {
                            var isFindDeleteLabel = _.findIndex(vm.deleteLabelArr, {id: labelObj.id});
                            if (isFindDeleteLabel !== -1) {
                                vm.deleteLabelArr.splice(isFindDeleteLabel, 1);
                            }
                        }
                    }
                };

                vm.fnAddLabelsToIssue = function (selectedLabel) {
                    vm.isLabelsAdded = false;
                    vm.newIssueObj.issueLabels.push(selectedLabel);
                    vm.isLabelsAdded = true;
                    vm.addLabelView = false;
                    vm.selectedLabel = {};
                };

                vm.fnCancelAddLabelView = function () {
                    vm.selectedLabel = {};
                    vm.addLabelView = false;
                    if (vm.deleteLabelArr.length || vm.addLabelArr.length) {
                        vm.fnUpdateIssueLabel();
                    }
                };

                vm.fnOnToggle = function (isOpen) {
                    if (isOpen === false && (vm.deleteLabelArr.length || vm.addLabelArr.length)) {
                        vm.fnUpdateIssueLabel();
                    } else {
                        vm.addLabelView = false;
                        vm.selectedLabel = {};
                    }
                };

                vm.fnUpdateIssueLabel = function () {
                    vm.isIssueLablesLoaded = false;
                    var tempArr = [];
                    _.forEach(vm.assigneesLabels, function (labelObj) {
                        var findIndex = _.findIndex(vm.deleteLabelArr, function (deleteObj) {
                            return deleteObj.id === labelObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: labelObj.id,
                                name: labelObj.name,
                                color: labelObj.color,
                                tags: labelObj.tags ? labelObj.tags : {}
                            });
                        }
                    });
                    _.forEach(vm.addLabelArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesLabels, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: addObj.id,
                                name: addObj.name,
                                color: addObj.color,
                                tags: addObj.tags ? addObj.tags : {}
                            })
                        }
                    });
                    vm.newIssueObj.issueLabels = _.cloneDeepWith(tempArr);
                    vm.assigneesLabels = _.cloneDeepWith(tempArr);
                    vm.isIssueLablesLoaded = true;
                    vm.selectedLabel = {};
                    vm.deleteLabelArr = [];
                    vm.addLabelArr = [];
                    vm.addLabelView = false;
                };

                vm.fnOpenAddLabelView = function () {
                    vm.addLabelView = true;
                    _.forEach(vm.assigneesLabels, function (issueLabelObj) {
                        var isFindLabel = _.find(vm.labelsArr, {id: issueLabelObj.id});
                        isFindLabel.isCheck = !!isFindLabel;
                    });
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": vm.fnInvertColor(color.toString())
                        }
                    }
                };

                vm.fnManageProjectLabels = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": vm.newIssueObj.projectId
                    }];
                    $state.go("main.label", {filter: angular.toJson(inputObj)});
                };
                /*Labels: END*/

                /*Participant: START*/
                vm.addParticipantArr = [];
                vm.deleteParticipantArr = [];
                vm.fnGetParticipants = function () {
                    var participants = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'participantsList');
                    if (participants && participants.length) {
                        vm.participantUsersArr = _.cloneDeepWith(participants);
                    } else {
                        vm.participantUsersArr = [];
                    }
                    if (vm.newIssueObj &&
                        vm.newIssueObj.participants &&
                        vm.newIssueObj.participants.length) {
                        _.forEach(vm.newIssueObj.participants, function (participant) {
                            var isFindIndex = _.findIndex(vm.participantUsersArr, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndex === -1) {
                                vm.participantUsersArr.push({
                                    email: participant,
                                    isCheck: true
                                })
                            }

                            var isFindIndexAssignee = _.findIndex(vm.assigneesParticipants, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndexAssignee === -1) {
                                vm.assigneesParticipants.push({
                                    email: participant
                                })
                            }
                        })
                    }
                    vm.resetParticipantUsersArr = _.cloneDeepWith(vm.participantUsersArr);
                    vm.isIssueParticipantLoaded = true;
                };

                vm.fnGetParticipantInfo = function (participantObj) {
                    if (participantObj.isCheck) {
                        participantObj.isCheck = false;
                        var isFindParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (isFindParticipant) {
                            vm.deleteParticipantArr.push(isFindParticipant);
                        } else {
                            var isFindParticipantInAddParticipantArr = _.findIndex(vm.addParticipantArr, {email: participantObj.email});
                            if (isFindParticipantInAddParticipantArr !== 1) {
                                vm.addParticipantArr.splice(isFindParticipantInAddParticipantArr, 1);
                            }
                        }
                    } else {
                        participantObj.isCheck = true;
                        var isFindAssigneesParticipant = _.find(vm.assigneesParticipants, {email: participantObj.email});
                        if (!isFindAssigneesParticipant) {
                            vm.addParticipantArr.push(participantObj);
                        } else {
                            var isFindDeleteParticipant = _.findIndex(vm.deleteParticipantArr, {email: participantObj.email});
                            if (isFindDeleteParticipant !== -1) {
                                vm.deleteParticipantArr.splice(isFindDeleteParticipant, 1);
                            }
                        }
                    }
                };

                vm.fnCancelChangeParticipant = function () {
                    vm.selectedParticipant = {};
                    vm.changeParticipantView = false;
                    vm.isParticipantChanged = true;
                    if (vm.deleteParticipantArr.length || vm.addParticipantArr.length) {
                        vm.fnUpdateIssueParticipant();
                    }
                };

                vm.fnOnToggleParticipant = function (isOpen) {
                    if (isOpen === false && (vm.deleteParticipantArr.length || vm.addParticipantArr.length)) {
                        vm.fnUpdateIssueParticipant();
                    } else {
                        vm.changeParticipantView = false;
                        vm.selectedParticipant = {};
                    }
                };

                vm.fnUpdateIssueParticipant = function () {
                    vm.isIssueParticipantsLoaded = false;
                    var tempArr = [];
                    var participantsArr = [];
                    _.forEach(vm.assigneesParticipants, function (participantObj) {
                        var findIndex = _.findIndex(vm.deleteParticipantArr, function (deleteObj) {
                            return deleteObj.email === participantObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(participantObj.email);
                            tempArr.push(participantObj);
                        }
                    });
                    _.forEach(vm.addParticipantArr, function (addObj) {
                        var findIndex = _.findIndex(vm.assigneesParticipants, function (tempObj) {
                            return tempObj.email === addObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(addObj.email);
                            tempArr.push(addObj);
                        }
                    });
                    vm.newIssueObj.participants = _.cloneDeepWith(participantsArr);
                    vm.assigneesParticipants = _.cloneDeepWith(tempArr);
                    vm.isIssueParticipantsLoaded = true;
                    vm.selectedParticipant = {};
                    vm.deleteParticipantArr = [];
                    vm.addParticipantArr = [];
                    vm.changeParticipantView = false;
                };

                vm.fnOpenChangeParticipantView = function () {
                    vm.changeParticipantView = true;
                    _.forEach(vm.assigneesParticipants, function (issueParticipantObj) {
                        var isFindParticipant = _.find(vm.participantUsersArr, {email: issueParticipantObj.email});
                        isFindParticipant.isCheck = !!isFindParticipant;
                    });
                };

                vm.fnAddNewParticipant = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html',
                        size: 'lg',
                        controller: 'addParticipantCtrl as addParticipant',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (data) {
                        if (!vm.newIssueObj.participants) {
                            vm.newIssueObj.participants = [];
                        }
                        if (!vm.assigneesParticipants) {
                            vm.assigneesParticipants = [];
                        }
                        if (!vm.participantUsersArr) {
                            vm.participantUsersArr = [];
                        }
                        vm.newIssueObj.participants.push(_.cloneDeepWith(data.email));
                        vm.assigneesParticipants.push(_.cloneDeepWith(data));
                        vm.participantUsersArr.push(_.cloneDeepWith(data));
                    }, function () {

                    });
                };
                /*Participant: END*/

                /*Confidential: START*/
                vm.fnOpenChangeConfidentialView = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = true;
                };

                vm.fnChangeIssueConfidential = function (selectedConfidential) {
                    vm.isConfidentialChanged = false;
                    if (selectedConfidential.value) {
                        vm.newIssueObj.confidential = true;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    } else {
                        vm.newIssueObj.confidential = false;
                        vm.changeConfidentialView = false;
                        vm.isConfidentialChanged = true;
                    }
                };

                vm.fnCancelChangeConfidential = function () {
                    vm.selectedConfidential = {};
                    vm.changeConfidentialView = false;
                    vm.isConfidentialChanged = true;
                };
                /*Confidential: END*/

                vm.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                vm.fnInitSideBar = function () {
                    vm.usersArr = [{
                        username: 'assign to me'
                    }];
                    vm.isIssueAssigneeLoaded = false;
                    vm.usersArr = [];
                    vm.changeAssigneeView = false;
                    vm.fnUploadChartImage();
                    var input = {
                        projectId: vm.newIssueObj.projectId
                    };
                    vm.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            vm.projectRelationshipsObj = _.cloneDeepWith(response);
                            vm.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach(vm.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetTypes({sql: typeSQL});

                            vm.isIssueLablesLoaded = false;
                            vm.assigneesLabels = _.cloneDeepWith(vm.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetLabels({sql: labelSQL});

                            vm.isIssuePriorityLoaded = false;
                            vm.assigneesPriorities = angular.isDefined(vm.newIssueObj.issuePriority) ? _.cloneDeepWith(vm.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetPriorities({sql: prioritiesSQL});
                            vm.changePriorityView = false;

                            vm.isIssueStateLoaded = false;
                            vm.assigneesState = angular.isDefined(vm.newIssueObj.issueState) ? _.cloneDeepWith(vm.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where data->>'projectId' IN (" + upstreamProject + ")";
                            vm.fnGetStates({sql: stateSQL});
                            vm.changeStateView = false;

                            vm.isIssueParticipantLoaded = false;
                            vm.fnGetParticipants();
                            vm.changeParticipantView = false;
                        }, function () {
                        });
                };

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce();
                        vega_runonce();
                    }, 100);
                };
                /* eslint-enable */

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.sort(function (a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                                    var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                                    if (isFindDraftProject) {
                                        vm.selectedProject = isFindDraftProject;
                                        vm.newIssueObj.projectId = isFindDraftProject.id;
                                    } else {
                                        vm.fnGetSelectedProject();
                                    }
                                } else {
                                    vm.fnGetSelectedProject();
                                }
                                vm.fnInitSideBar();
                                vm.isProjectLoaded = true;
                            }
                        }, function () { // Error block
                            vm.isProjectLoaded = true;
                            vm.projectsArr = [];
                        })
                };

                vm.fnGetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.selectedProject = isFindProject;
                            vm.newIssueObj.projectId = isFindProject.id;
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.selectedProject = isFindStateParamsProject;
                            vm.newIssueObj.projectId = isFindStateParamsProject.id;
                        }
                    } else {
                        _.forEach(vm.projectsArr, function (dataObj) {
                            if (!dataObj.parentProjectId) {
                                vm.selectedProject = dataObj;
                                vm.newIssueObj.projectId = dataObj.id;
                            }
                        });
                    }
                };

                vm.fnInitCreateIssue = function () {
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        vm.issueDraftObj = localStorage.getItem('insightFedSupportIssueDraft') ?
                            angular.fromJson(localStorage.getItem('insightFedSupportIssueDraft')) : {};
                    } else {
                        vm.issueDraftObj = localStorage.getItem('insightIssueDraft') ?
                            angular.fromJson(localStorage.getItem('insightIssueDraft')) : {};
                    }
                    if (angular.isDefined(vm.issueDraftObj) && vm.issueDraftObj !== {}) {
                        vm.newIssueObj = vm.issueDraftObj;
                    }
                    if (localStorage.getItem('insightChartData')) {
                        var tempData = localStorage.getItem('insightChartData') ? _.cloneDeepWith(angular.fromJson(localStorage.getItem('insightChartData'))) : {};
                        //localStorage.removeItem('insightChartData');
                        vm.newIssueObj.rowData = _.cloneDeepWith(tempData.result.data);
                    }
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.isProjectLoaded = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        vm.projectsArr.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        });
                        if (vm.issueDraftObj && vm.issueDraftObj.projectId && vm.issueDraftObj.projectId !== '') {
                            var isFindDraftProject = _.find(vm.projectsArr, {id: vm.issueDraftObj.projectId});
                            if (isFindDraftProject) {
                                vm.selectedProject = isFindDraftProject;
                                vm.newIssueObj.projectId = isFindDraftProject.id;
                            } else {
                                vm.fnGetSelectedProject();
                            }
                        } else {
                            vm.fnGetSelectedProject();
                        }
                        $timeout(function () {
                            vm.fnInitSideBar();
                            vm.isProjectLoaded = true;
                        })
                    } else {
                        vm.isProjectLoaded = false;
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    $timeout(function () {
                        vm.fnSetIssueMarkdownHeight();
                    })
                };

                $scope.$on('resetCreateIssue', function () {
                    /*vm.newIssueObj = angular.copy(vm.resetNewIssueObj);
                    vm.fnInitCreateIssue();
                    $timeout(function () { // set table height
                        $scope.issue.fnSetTableHeight();//parent function
                    }, 800);*/
                });

                vm.fnSetIssueMarkdownHeight = function () {
                    var height = 282;
                    if (angular.isDefined(angular.element("#modal-body")[0]) &&
                        angular.isDefined(angular.element("#newIssueTitle")[0]) &&
                        angular.isDefined(angular.element("#typeListDropdown")[0])) {
                        var total = angular.element("#modal-body")[0].offsetHeight;
                        var newIssue = angular.element("#newIssueTitle")[0].offsetHeight;
                        var typeListDropdown = angular.element("#typeListDropdown")[0].offsetHeight;
                        var finalHeight = total - (newIssue + typeListDropdown + 60);
                        if (height < finalHeight) {
                            angular.element("#issueMarkdownContainer").css('height', finalHeight + 'px');
                        } else {
                            angular.element("#issueMarkdownContainer").css('height', 282 + 'px');
                        }
                    }

                };

                vm.fnSaveIssueDraft = function () {
                    if (vm.newIssueObj.issueType && vm.newIssueObj.issueType.form) {
                        vm.newIssueObj.issueType.form.values = vm.model;
                    }

                    if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                        localStorage.setItem('insightIssueDraft', angular.toJson(vm.newIssueObj));
                    } else {
                        localStorage.setItem('insightFedSupportIssueDraft', angular.toJson(vm.newIssueObj));
                    }
                };

                vm.fnUploadChartImage = function () {
                    if (localStorage.getItem('insightChartData')) {
                        var tempData = localStorage.getItem('insightChartData') ? _.cloneDeepWith(angular.fromJson(localStorage.getItem('insightChartData'))) : {};
                        localStorage.removeItem('insightChartData');
                        vm.fileUploading = true;
                        var exportUrl = "https://export.highcharts.com/";
                        $http.post(exportUrl, {
                            "async": true,
                            "infile": _.cloneDeepWith(angular.toJson(tempData.chart))
                        }).success(function (data) {
                            $http.get(exportUrl + data, {responseType: 'arraybuffer'})
                                .success(function (data) {
                                    var file = new Blob([data], {
                                        type: 'image/png'
                                    });
                                    var inputObj = {
                                        projectId: vm.newIssueObj.projectId
                                    };
                                    IssueFactory.getFileUploadLink(inputObj)
                                        .then(function (res) {
                                            $http({
                                                method: 'PUT',
                                                url: res.uploadUrl,
                                                config: {
                                                    headers: {
                                                        'Content-Type': file.type
                                                    }
                                                },
                                                data: file
                                            }).success(function () {
                                                if (vm.newIssueObj.summary && vm.newIssueObj.summary.length) {
                                                    vm.newIssueObj.summary += "\n<br>\n ### Chart \n![chart.png](" + res.downloadUrl + ")";
                                                } else {
                                                    vm.newIssueObj.summary = "### Chart \n![chart.png](" + res.downloadUrl + ")";
                                                }
                                                vm.fileUploading = false;
                                            }).error(function () {
                                                vm.fileUploading = false;
                                            });
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                            vm.fileUploading = false;
                                        })
                                }).error(function () {
                                vm.fileUploading = false;
                            });
                        }).error(function () {
                            vm.fileUploading = false;
                        });
                    }
                }

                vm.fnAddMetaInfo = function () {
                    if (vm.newIssueObj.rowData) {
                        var headersArr = Object.keys(vm.newIssueObj.rowData[0]);
                        var tableMDString = "\n <br>\n ### Chart Result \n <table>\n<tr>";
                        _.forEach(headersArr, function (header) {
                            tableMDString += "<th>" + header + "</th>";
                        })
                        tableMDString += "</tr>\n";
                        _.forEach(vm.newIssueObj.rowData, function (dataObj) {
                            tableMDString += "<tr>\n";
                            _.forEach(headersArr, function (header) {
                                tableMDString += "<td>" + dataObj[header] + "</td>";
                            })
                            tableMDString += "<tr>\n";
                        })
                        tableMDString += "</table>\n";
                        vm.newIssueObj.summary += tableMDString;
                    }
                }

                $window.onbeforeunload = function () {
                    return vm.fnSaveIssueDraft();
                };

                $scope.$on("$destroy", function () {
                    vm.fnSaveIssueDraft();
                });
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightQueryInfo', fnInsightQueryInfo)

    /** @ngInject */
    function fnInsightQueryInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, AppInitService, InsightProjectFactory, QueryFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/insight/insight_queries/insightQueryInfo/insightQueryInfo.html',
            scope: {
                queryObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Query',
                        tabIndex: 1,
                        templateUrl: 'app/insight/insight_queries/insightQueryInfo/insightQuerySteps/query/insightQuery.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 2,
                        templateUrl: 'app/insight/insight_queries/insightQueryInfo/insightQuerySteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 3,
                        templateUrl: 'app/insight/insight_queries/insightQueryInfo/insightQuerySteps/queryTags/queryTags.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.selectedProject = {};

                $scope.fnGetQuery = function (queryId) {
                    var inputObj = {
                        queryId: queryId
                    };
                    QueryFactory.describeQuery(inputObj)
                        .then(function (response) {
                            $scope.queryObj = response;
                            $scope.resetQueryObj = angular.copy($scope.queryObj);
                            if (angular.isUndefined($scope.queryObj.description)) {
                                $scope.queryObj.description = '';
                            }
                            $scope.isQueryDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isQueryDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.insight_queries', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateQueryDetails = function (queryObj) {
                    var inputObj = {
                        body: {},
                        queryId: queryObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(queryObj.description)) {
                        queryObj.description = '';
                    }
                    inputObj.body = {
                        name: queryObj.name,
                        description: queryObj.description
                    };
                    QueryFactory.updateQuery(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('QueriesDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Query Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteQuery = function (queryObj) {
                    swal({
                            title: "Delete the selected Query?",
                            text: "You are about to permanently delete the selected Query.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    queryId: queryObj.id
                                };
                                QueryFactory.deleteQuery(inputObj)
                                    .then(function () {
                                        $scope.$emit('QueriesDeleted', queryObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.queryObj = angular.copy($scope.resetQueryObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitQuery = function () {
                    $scope.isQueryDetailsLoaded = false;
                    $scope.queryId = $scope.queryObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('insightProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.queryObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetQuery($scope.queryId);
                    } else {
                        InsightProjectFactory.describeProject({projectId: $scope.queryObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.queryId) {
                                $scope.fnGetQuery($scope.queryId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitQuery();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var queryInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_queries') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteQuery($scope.queryObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var queryInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_queries') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', queryInfoKeyDownEventHandler);
                document.addEventListener('keyup', queryInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', queryInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', queryInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightQueryCtrl',
            function ($scope, $window, $uibModal, amaran, DB, $timeout, sqlFormatter, AppInitService, QueryFactory) {
                var vm = this;
                vm.title = "Create Query";
                vm.activeStep = 1;
                vm.isProjectCreateLoaded = false;
                vm.isQueryCreating = false;
                vm.newQueryObj = {
                    name: '',
                    description: '',
                    projectId: '',
                    sql: ''
                };
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.availableDataLibs = ['ql_S4'];
                vm.queryConfig = {
                    value: {},
                    editorValue: ''
                };
                vm.isQuerySearchDataLoading = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createQueryModalBody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGotoNextStep = function () {
                    vm.activeStep = vm.activeStep + 1;
                    if (vm.activeStep === 2) {
                        vm.queryConfig.editorValue = vm.newQueryObj.sql;
                    }
                    if (vm.activeStep === 3) {
                        vm.newQueryObj.sql = vm.queryConfig.value.getData();
                    }
                };

                vm.fnGotoPreviousStep = function () {
                    if (vm.activeStep === 2) {
                        vm.newQueryObj.sql = vm.queryConfig.value.getData();
                    }
                    vm.activeStep = vm.activeStep - 1;
                    if (vm.activeStep === 2) {
                        vm.queryConfig.editorValue = vm.newQueryObj.sql;
                    }
                };

                vm.fnRunQuery = function () {
                    if (vm.queryConfig.value.getData().length) {
                        vm.isQuerySearchDataLoading = true;
                        vm.softwareSearchData = [];
                        var input = {
                            "sql": vm.queryConfig.value.getData()
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            vm.querySearchData = res;
                            vm.querySearchDataHeader = [];
                            _.forEach(vm.querySearchData.data, function (dataObj) {
                                _.forEach(Object.keys(dataObj), function (value) {
                                    vm.querySearchDataHeader.push(value);
                                });
                            });
                            vm.querySearchDataHeader = _.uniq(_.map(vm.querySearchDataHeader)).sort();
                            vm.isQuerySearchDataLoading = false;
                        }, function () { // Error block
                            vm.isQuerySearchDataLoading = false;
                        });
                    }
                };

                vm.fnFormatSQL = function () {
                    var sql = vm.queryConfig.value.getData();
                    vm.queryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnCreateNewQuery = function (newQueryObj) {
                    vm.isQueryCreating = true;
                    var inputObj = {
                        body: newQueryObj
                    };

                    //inputObj.body.results = [];
                    QueryFactory.createQuery(inputObj)
                        .then(function (resObj) {
                            vm.isQueryCreating = false;
                            vm.newQueryObj = {
                                name: '',
                                description: '',
                                projectId: '',
                                sql: ''
                            };
                            amaran.success("Query created successfully");
                            $timeout(function () {
                                $scope.insightQueries.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('queryAdded', resObj.id);
                            $scope.insightQueries.totalItems = $scope.insightQueries.totalItems + 1;
                            $scope.insightQueries.projectsArr.push(resObj);
                            $scope.insightQueries.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueryCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                }, 0);
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newQueryObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newQueryObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnInitCreateQuery = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('insightProjectsArr');
                        vm.isProjectCreateLoaded = true;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        }, 0);
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightProjectInfo', fnInsightProjectInfo)

    /** @ngInject */
    function fnInsightProjectInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, AppInitService, InsightProjectFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/insight/insight_project/insightProjectInfo/insightProjectInfo.html',
            scope: {
                projectObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/insight/insight_project/insightProjectInfo/insightProjectSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/insight/insight_project/insightProjectInfo/insightProjectSteps/projectTags/insightProjectTags.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetProject = function (projectId) {
                    var inputObj = {
                        projectId: projectId
                    };
                    InsightProjectFactory.describeProject(inputObj)
                        .then(function (response) {
                            $scope.projectObj = response;
                            $scope.resetProjectObj = angular.copy($scope.projectObj);
                            if (angular.isUndefined($scope.projectObj.description)) {
                                $scope.projectObj.description = '';
                            }
                            $scope.isProjectDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isProjectDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.insight_project', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateProjectDetails = function (projectObj) {
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(projectObj.description)) {
                        projectObj.description = '';
                    }
                    inputObj.body = {
                        name: projectObj.name,
                        description: projectObj.description
                    };
                    InsightProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var projectArr = AppInitService.getInitData('insightProjectsArr');
                                var index = _.findIndex(projectArr, {id: response.id});
                                if (index !== -1) {
                                    projectArr[index].name = response.name;
                                    projectArr[index].description = response.description;
                                    AppInitService.fnUpdateInsightProjectData(projectArr);
                                }
                            }
                            $scope.$emit('ProjectDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteProject = function (projectObj) {
                    swal({
                            title: "Delete the selected Project?",
                            text: "You are about to permanently delete the selected Project.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    projectId: projectObj.id
                                };
                                InsightProjectFactory.deleteProject(inputObj)
                                    .then(function () {
                                        $scope.$emit('ProjectDeleted', projectObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        var projectArr = AppInitService.getInitData('insightProjectsArr');
                                        _.remove(projectArr, function (n) {
                                            return n.id === projectObj.id;
                                        });
                                        AppInitService.fnUpdateInsightProjectData(projectArr);
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.projectObj = angular.copy($scope.resetProjectObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitProject = function () {
                    $scope.isProjectDetailsLoaded = false;
                    $scope.projectId = $scope.projectObj.id;
                    if ($scope.projectObj.parentProjectId && $scope.projectObj.parentProjectId !== "") {
                        InsightProjectFactory.describeProject({projectId: $scope.projectObj.parentProjectId})
                            .then(function (response) {
                                $scope.selectedProject = response;
                                if ($scope.projectId) {
                                    $scope.fnGetProject($scope.projectId);
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        if ($scope.projectId) {
                            $scope.fnGetProject($scope.projectId);
                        }
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitProject();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var projectInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteProject($scope.projectObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var projectInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectInfoKeyDownEventHandler);
                document.addEventListener('keyup', projectInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', projectInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightProjectCtrl',
            function ($scope, $window, $uibModal, amaran, DB, InsightProjectFactory, $timeout, AppInitService, QueryFactory) {
                var vm = this;
                vm.title = "Create Project";
                vm.isProjectCreateLoaded = false;
                vm.newProjectObj = {
                    name: '',
                    description: '',
                    parentProjectId: ''
                };
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.fnCreateNewProject = function (newProjectObj) {
                    vm.isProjectCreating = true;
                    var inputObj = {
                        body: newProjectObj
                    };
                    InsightProjectFactory.createProject(inputObj)
                        .then(function (resObj) {
                            vm.isProjectCreating = false;
                            vm.newProjectObj = {
                                name: '',
                                description: '',
                                parentProjectId: ''
                            };
                            amaran.success("Project created successfully");
                            if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var projectArr = AppInitService.getInitData('insightProjectsArr');
                                projectArr.push(resObj);
                                AppInitService.fnUpdateInsightProjectData(projectArr);
                            }
                            $timeout(function () {
                                $scope.insightProject.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('projectAdded', resObj.id);
                            $scope.insightProject.totalItems = $scope.insightProject.totalItems + 1;
                            $scope.insightProject.projectsArr.push(resObj);
                            $scope.insightProject.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectCreating = false;
                        });
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newProjectObj.parentProjectId = "";
                        vm.selectedProject = {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newProjectObj.parentProjectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach($scope.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach($scope.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!($scope.selectedProject && $scope.selectedProject.id && projectObj.id === $scope.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnInitCreateProject = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('insightProjectsArr');
                        vm.isProjectCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateInsightDashboardCtrl',
            function ($scope, $window, $uibModal, $sce, amaran, DB, $timeout, QueryFactory, AppInitService, jsonToCsvConvertService, Highcharts, InsightDashboardFactory) {
                var vm = this;
                vm.isDashboardUpdating = false;
                vm.isDashboardDetailsLoaded = false
                vm.newDashboardObj = {
                    cells: []
                };

                vm.widgets = [];

                vm.options = {
                    cellHeight: 200,
                    verticalMargin: 20
                };

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.removeWidget = function (w) {
                    var index = vm.widgets.indexOf(w);
                    vm.widgets.splice(index, 1);
                    var temp = _.cloneDeepWith(vm.widgets);
                    vm.widgets = [];
                    $timeout(function () {
                        vm.widgets = _.cloneDeepWith(temp);
                    })
                };

                vm.onChange = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        for (var i = 0; i < Highcharts.charts.length; i++) {
                            if (angular.isDefined(Highcharts.charts[i]) && Highcharts.charts[i] && Highcharts.charts[i].renderTo && Highcharts.charts[i].renderTo.id && Highcharts.charts[i].renderTo.id.startsWith('insightDashboardWidgets')) {
                                Highcharts.charts[i].reflow();
                            }
                        }
                    }, 1000)
                };

                vm.fnOpenWidgetModal = function () {
                    //vm.addWidget();
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/insight/insight_dashboards/modals/dashboardWidgetModal.html',
                        size: 'lg',
                        controller: 'dashboardWidgetModalCtrl as dashboardWidgetModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        if (res.chart && res.chart.syntax === 'HIGHCHARTS') {
                            if (angular.isUndefined(res.layout.isExport)) {
                                res.layout.isExport = true;
                                res.layout.exportOptions = [
                                    {
                                        name: "Download PNG image",
                                        action: "downloadPNG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download JPEG image",
                                        action: "downloadJPEG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download PDF image",
                                        action: "downloadPDF",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download SVG vector image",
                                        action: "downloadSVG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download CSV File",
                                        action: "downloadCSV",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download XLS File",
                                        action: "downloadXLS",
                                        isAllow: true
                                    }
                                ];
                                res.layout.isTrackerExport = false
                            }
                            vm.dataConfig = [];
                            var headers = {};
                            _.forEach(res.chart.definition.dataMapping, function (value, key) {
                                vm.dataConfig.push({
                                    key: key,
                                    value: value
                                });
                                headers[value] = value
                            });
                            var items = [];
                            _.forEach(res.chart.query.results.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            res.chart.definition.chartConfig.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            var tempWidgetObj = {
                                x: 0,
                                y: 0,
                                width: 4,
                                height: 2,
                                widgetId: res.id,
                                widget: res
                            }
                            vm.widgets.push(tempWidgetObj);
                        }
                    }, function () {

                    });
                }

                vm.fnUpdateDashboard = function () {
                    vm.isDashboardUpdating = true;
                    var inputObj = {
                        body: {
                            cells: []
                        },
                        dashboardId: vm.selectedDashboardId
                    }
                    _.forEach(vm.widgets, function (widget) {
                        inputObj.body.cells.push({
                            x: widget.x,
                            y: widget.y,
                            w: widget.width,
                            h: widget.height,
                            widgetId: widget.widgetId
                        });
                    })
                    InsightDashboardFactory.updateDashboardCells(inputObj)
                        .then(function (resObj) {
                            amaran.success("Dashboard updated successfully");
                            vm.isDashboardUpdating = false;
                            $scope.$emit('dashboardDashboardDataUpdated', resObj.id);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardUpdating = false;
                        });
                }

                vm.fnGetDashboardInfo = function (dashboardId) {
                    var inputObj = {
                        dashboardId: dashboardId
                    };
                    InsightDashboardFactory.executeDashboard(inputObj)
                        .then(function (response) {
                            vm.selectDashboardObj = _.cloneDeepWith(response);
                            vm.selectDashboardObj.cells.sort(function(a, b) {
                                return a.y === b.y ? a.x - b.x : a.y - b.y;
                            });
                            var items = _.cloneDeepWith(vm.selectDashboardObj.cells);
                            var arranged = [];
                            for (var i = 0; i < items.length; i++) {
                                if (angular.isUndefined(items[i].wasAdded)) {
                                    arranged.push(items[i]);
                                    items[i].wasAdded = "true";
                                    for (var j = i + 1; j < items.length; j++) {
                                        if (items[i].y > items[j].y && angular.isUndefined(items[j].wasAdded)) {
                                            arranged.push(items[j]);
                                            items[j].wasAdded = "true";
                                        }
                                    }
                                }
                            }
                            vm.selectDashboardObj.cells = _.cloneDeepWith(arranged);
                            _.forEach(vm.selectDashboardObj.cells, function (cellObj) {
                                cellObj.width = _.cloneDeepWith(cellObj.w);
                                cellObj.height = _.cloneDeepWith(cellObj.h);
                                delete cellObj.w;
                                delete cellObj.h;
                                if (cellObj.widget.chart && cellObj.widget.chart.syntax === 'HIGHCHARTS') {
                                    vm.dataConfig = [];
                                    if (angular.isUndefined(cellObj.widget.layout.isExport)) {
                                        cellObj.widget.layout.isExport = true;
                                        cellObj.widget.layout.exportOptions = [
                                            {
                                                name: "Download PNG image",
                                                action: "downloadPNG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download JPEG image",
                                                action: "downloadJPEG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download PDF image",
                                                action: "downloadPDF",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download SVG vector image",
                                                action: "downloadSVG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download CSV File",
                                                action: "downloadCSV",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download XLS File",
                                                action: "downloadXLS",
                                                isAllow: true
                                            }
                                        ];
                                        cellObj.widget.layout.isTrackerExport = false
                                    }
                                    var headers = {};
                                    _.forEach(cellObj.widget.chart.definition.dataMapping, function (value, key) {
                                        vm.dataConfig.push({
                                            key: key,
                                            value: value
                                        });
                                        headers[value] = value
                                    });
                                    var items = [];
                                    _.forEach(cellObj.widget.chart.query.results.data, function (obj) {
                                        var tempObj = {};
                                        _.forEach(vm.dataConfig, function (dataConfigObj) {
                                            tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                        });
                                        items.push(tempObj);
                                    });
                                    items.unshift(headers);
                                    var jsonObject = angular.toJson(items);
                                    cellObj.widget.chart.definition.chartConfig.data = {
                                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                        "googleSpreadsheetKey": false,
                                        "googleSpreadsheetWorksheet": false,
                                        "decimalPoint": ","
                                    };
                                }
                                vm.widgets.push(cellObj);
                            })
                            //vm.widgets = _.cloneDeepWith();
                            vm.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardDetailsLoaded = true;
                        })
                };

                vm.fnInitUpdateDashboard = function () {
                    var selectedTabObj = _.find($scope.insightDashboards.tabs, {id: 'Update Dashboard'});
                    if (selectedTabObj) {
                        vm.isDashboardDetailsLoaded = false;
                        vm.selectedDashboardId = selectedTabObj.dashboardId;
                        vm.fnGetDashboardInfo(vm.selectedDashboardId);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('dashboardWidgetModalCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, amaran, moment, PaginationQueryService, QueryFactory, DB, AppInitService, UserProfileService, InsightWidgetFactory) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#widgetsTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.isWidgetAdding = false;

                var tableName = 'insight_widgets';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.widgetsProjectFilter = "$";
                vm.widgetsProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isWidgetsLoading = false;
                vm.widgetsResponse = [];
                vm.widgetsArr = [];
                vm.selectedWidgetsArr = [];
                vm.selectedWidgetsObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isWidgetsLoading = true;
                    vm.selectedWidgetsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'widgets', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetWidgets({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectWidgets = function (projectObj) {
                    vm.isWidgetsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_widgets';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_widgets';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetWidgets({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isWidgetsLoading = true;
                    vm.selectedWidgetsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_widgets';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_widgets';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetWidgets(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.widgetsArr);
                        vm.previousPage = page;
                        vm.fnGetWidgets(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetWidgets = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.widgetsResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.widgetsResponse.data && vm.widgetsResponse.data.length) {
                                vm.totalItems = vm.widgetsResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.widgetsResponse.data.reverse();
                            }
                            vm.widgetsArr = _.cloneDeepWith(vm.widgetsResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isWidgetsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (widgetsObj) {
                    angular.forEach(vm.widgetsArr, function (obj) {
                        if (widgetsObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindWidgets = _.find(vm.widgetsArr, function (widgetsObj) {
                        return widgetsObj.isCheck === true;
                    });
                    if (isFindWidgets) {
                        vm.selectedWidgetsObj = _.cloneDeepWith(isFindWidgets);
                    } else {
                        vm.selectedWidgetsObj = {};
                    }
                };

                vm.isWidgetsObjSelected = function () {
                    return !!vm.selectedWidgetsObj && Object.keys(vm.selectedWidgetsObj).length;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInjectWidget = function () {
                    //$uibModalInstance.close();
                    vm.isWidgetAdding = true;
                    var inputObj = {
                        widgetId: vm.selectedWidgetsObj.id
                    };
                    InsightWidgetFactory.executeWidget(inputObj)
                        .then(function (response) {
                            vm.isWidgetAdding = false;
                            $uibModalInstance.close(response)
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetAdding = false;
                        })
                };

                vm.fnInitDashboardWidgetModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightDashboardInfo', fnInsightDashboardInfo)

    /** @ngInject */
    function fnInsightDashboardInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, InsightDashboardFactory, AppInitService, InsightProjectFactory, QueryFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/insight/insight_dashboards/insightDashboardInfo/insightDashboardInfo.html',
            scope: {
                dashboardObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Dashboard',
                        tabIndex: 1,
                        templateUrl: 'app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/dashboard/insightDashboardDashboard.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 2,
                        templateUrl: 'app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 3,
                        templateUrl: 'app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/dashboardTags/insightDashboardTags.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.selectedProject = {};

                $scope.fnGetDashboard = function (dashboardId) {
                    var inputObj = {
                        dashboardId: dashboardId
                    };
                    InsightDashboardFactory.describeDashboard(inputObj)
                        .then(function (response) {
                            $scope.dashboardObj = response;
                            $scope.resetDashboardObj = angular.copy($scope.dashboardObj);
                            if (angular.isUndefined($scope.dashboardObj.description)) {
                                $scope.dashboardObj.description = '';
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.insight_dashboards', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateDashboardDetails = function (dashboardObj) {
                    var inputObj = {
                        body: {},
                        dashboardId: dashboardObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(dashboardObj.description)) {
                        dashboardObj.description = '';
                    }
                    inputObj.body = {
                        name: dashboardObj.name,
                        description: dashboardObj.description
                    };
                    InsightDashboardFactory.updateDashboard(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('DashboardDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Dashboard Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteDashboard = function (dashboardObj) {
                    swal({
                            title: "Delete the selected Dashboard?",
                            text: "You are about to permanently delete the selected Dashboard.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    dashboardId: dashboardObj.id
                                };
                                InsightDashboardFactory.deleteDashboard(inputObj)
                                    .then(function () {
                                        $scope.$emit('QueriesDeleted', dashboardObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.dashboardObj = angular.copy($scope.resetDashboardObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitDashboard = function () {
                    $scope.isDashboardDetailsLoaded = false;
                    $scope.dashboardId = $scope.dashboardObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('insightProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.dashboardObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetDashboard($scope.dashboardId);
                    } else {
                        InsightProjectFactory.describeProject({projectId: $scope.dashboardObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.dashboardId) {
                                $scope.fnGetDashboard($scope.dashboardId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitDashboard();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var dashboardInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_dashboards') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteDashboard($scope.dashboardObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var dashboardInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_dashboards') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', dashboardInfoKeyDownEventHandler);
                document.addEventListener('keyup', dashboardInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', dashboardInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', dashboardInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightDashboardCtrl',
            function ($scope, $window, $uibModal, $sce, amaran, DB, $timeout, QueryFactory, AppInitService, jsonToCsvConvertService, Highcharts, InsightDashboardFactory) {
                var vm = this;
                vm.isDashboardCreating = false;
                vm.newDashboardObj = {
                    name: '',
                    description: '',
                    projectId: '',
                    cells: []
                };
                vm.selectedProject = {};
                /*Project: START*/
                vm.changeProjectView = false;
                vm.projectFilter = "$";
                vm.projectSearch = {$: ''};
                vm.deleteProjectsArr = [];
                vm.addProjectsArr = [];
                /*Project: END*/

                vm.widgets = [];

                vm.options = {
                    cellHeight: 200,
                    verticalMargin: 20
                };
                /*disableDrag: true,
                    disableResize: true*/

                vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                vm.addWidget = function () {
                    var newWidget = {x: 0, y: 0, width: 4, height: 2, title: "Widget - " + (vm.widgets.length + 1)};
                    vm.widgets.push(newWidget);
                };

                vm.removeWidget = function (w) {
                    var index = vm.widgets.indexOf(w);
                    vm.widgets.splice(index, 1);
                    var temp = _.cloneDeepWith(vm.widgets);
                    vm.widgets = [];
                    $timeout(function () {
                        vm.widgets = _.cloneDeepWith(temp);
                    })
                };

                vm.onChange = function () {
                    $timeout(function () {
                        angular.element($window).triggerHandler('resize');
                        for (var i = 0; i < Highcharts.charts.length; i++) {
                            if (angular.isDefined(Highcharts.charts[i]) && Highcharts.charts[i] && Highcharts.charts[i].renderTo && Highcharts.charts[i].renderTo.id && Highcharts.charts[i].renderTo.id.startsWith('insightDashboardWidgets')) {
                                Highcharts.charts[i].reflow();
                            }
                        }
                    }, 1000)
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.isProjectCreateLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTabHeight();
                                }, 0);
                            }
                        }, function () { // Error block
                        })
                };

                /*Project: START*/
                vm.fnGetProjectInfo = function (prioritiesObj) {
                    _.forEach(vm.projectsArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    vm.deleteProjectsArr = [];
                    vm.addProjectsArr = [];
                    var isFindCheck = _.find(vm.projectsArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id !== isFindCheck.id) {
                                vm.addProjectsArr = [prioritiesObj];
                            }
                        } else {
                            vm.addProjectsArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined(vm.selectedProject.id)) {
                            if (vm.selectedProject.id === prioritiesObj.id) {
                                vm.deleteProjectsArr = [vm.selectedProject];
                            }
                        }

                    }
                };

                vm.fnUpdateIssueProject = function () {
                    if (vm.deleteProjectsArr.length) {
                        vm.newDashboardObj.projectId = "";
                        vm.selectedProject = {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    } else {
                        vm.newDashboardObj.projectId = vm.addProjectsArr[0].id;
                        vm.selectedProject = angular.isDefined(vm.addProjectsArr[0]) ? _.cloneDeepWith(vm.addProjectsArr[0]) : {};
                        _.forEach(vm.projectsArr, function (projectObj) {
                            projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                        });
                        vm.changeProjectView = false;
                        vm.deleteProjectsArr = [];
                        vm.addProjectsArr = [];
                    }
                    vm.changeProjectView = false;
                };

                vm.fnCancelChangeProject = function () {
                    vm.changeProjectView = false;
                    if (vm.deleteProjectsArr.length || vm.addProjectsArr.length) {
                        vm.fnUpdateIssueProject();
                        vm.selectedProject = {};
                    }
                };

                vm.fnOnToggleProject = function (isOpen) {
                    if (isOpen === false && (vm.deleteProjectsArr.length || vm.addProjectsArr.length)) {
                        vm.fnUpdateIssueProject();
                    } else {
                        if (!Object.keys(vm.selectedProject).length) {
                            vm.selectedProject = {};
                        }
                        vm.changeProjectView = false;
                    }
                };

                vm.fnOpenChangeProjectView = function () {
                    vm.changeProjectView = true;
                    _.forEach(vm.projectsArr, function (projectObj) {
                        projectObj.isCheck = !!(vm.selectedProject && vm.selectedProject.id && projectObj.id === vm.selectedProject.id);
                    });
                };

                /*Project: END*/

                vm.fnOpenWidgetModal = function () {
                    //vm.addWidget();
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/insight/insight_dashboards/modals/dashboardWidgetModal.html',
                        size: 'lg',
                        controller: 'dashboardWidgetModalCtrl as dashboardWidgetModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        if (res.chart && res.chart.syntax === 'HIGHCHARTS') {
                            if (angular.isUndefined(res.layout.isExport)) {
                                res.layout.isExport = true;
                                res.layout.exportOptions = [
                                    {
                                        name: "Download PNG image",
                                        action: "downloadPNG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download JPEG image",
                                        action: "downloadJPEG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download PDF image",
                                        action: "downloadPDF",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download SVG vector image",
                                        action: "downloadSVG",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download CSV File",
                                        action: "downloadCSV",
                                        isAllow: true
                                    },
                                    {
                                        name: "Download XLS File",
                                        action: "downloadXLS",
                                        isAllow: true
                                    }
                                ];
                                res.layout.isTrackerExport = false
                            }
                            vm.dataConfig = [];
                            var headers = {};
                            _.forEach(res.chart.definition.dataMapping, function (value, key) {
                                vm.dataConfig.push({
                                    key: key,
                                    value: value
                                });
                                headers[value] = value
                            });
                            var items = [];
                            _.forEach(res.chart.query.results.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            res.chart.definition.chartConfig.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            res.x = 0;
                            res.y = 0;
                            res.width = 4;
                            res.height = 2;
                            vm.widgets.push(res);
                        }
                    }, function () {

                    });
                }

                /* vm.fnExportChart = function (type, id) {
                     WidgetsListService.downloadChartData(type, id);
                 };*/

                vm.fnCreateNewDashboard = function () {
                    vm.isDashboardCreating = true;
                    var inputObj = {
                        body: vm.newDashboardObj
                    }
                    inputObj.body.cells = [];
                    _.forEach(vm.widgets,function (widget) {
                        inputObj.body.cells.push({
                            x: widget.x,
                            y: widget.y,
                            w: widget.width,
                            h: widget.height,
                            widgetId: widget.id
                        });
                    })
                    InsightDashboardFactory.createDashboard(inputObj)
                        .then(function (resObj) {
                            amaran.success("Dashboard created successfully");
                            vm.newDashboardObj = {
                                name: '',
                                description: '',
                                projectId: '',
                                cells: []
                            };
                            vm.widgets = [];
                            vm.isDashboardCreating = false;
                            $timeout(function () {
                                $scope.insightDashboards.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('dashboardAdded', resObj.id);
                            $scope.insightDashboards.totalItems = $scope.insightDashboards.totalItems + 1;
                            $scope.insightDashboards.dashboardsArr.push(resObj);
                            $scope.insightDashboards.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardCreating = false;
                        });
                }

                vm.fnInitCreateDashboard = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('insightProjectsArr');
                        vm.isProjectCreateLoaded = true;
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateInsightChartCtrl',
            function ($scope, $window, $uibModal, Highcharts, InsightChartFactory, highed, jsonToCsvConvertService, amaran, DB, $timeout) {
                var vm = this;
                vm.title = "Update Chart";
                vm.activeStep = 0;
                vm.newChartObj = {
                    name: '',
                    description: '',
                    queryId: '',
                    projectId: '',
                    syntax: 'HIGHCHARTS',
                    definition: {}
                };
                vm.selectedChartId = "";
                vm.selectedChartObj = "";
                vm.isChartUpdateing = false;
                vm.isChartDetailsLoaded = false;
                var chartMapping = [
                    {
                        "chartType": "arearange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "area",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "columnrange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "column",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "line",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "spline",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "pie",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "funnel",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "pyramid",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "solidgauge",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "bubble",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "value",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "boxplot",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "low",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q1",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "median",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q3",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "high",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "scatter",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    }
                ];
                var instance;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#updateChartModalBody").css('height', finalHeight + 'px');
                        if (angular.element(".wizard")[0] && angular.element(".tab-content")[0] && angular.element(".title-border-bottom")[0]) {
                            var wizardInner = angular.element(".wizard")[0].offsetHeight;
                            var titleBorderBottom = angular.element(".title-border-bottom")[0].offsetHeight !== 0 ? angular.element(".title-border-bottom")[0].offsetHeight : 29;
                            angular.element(".wizard-tab-height").css('height', finalHeight - (wizardInner + titleBorderBottom + 30) + 'px');
                        }
                    }
                };

                vm.fnGetChartInfo = function (chartId) {
                    var inputObj = {
                        chartId: chartId
                    };
                    InsightChartFactory.executeChart(inputObj)
                        .then(function (response) {
                            vm.selectChartObj = _.cloneDeepWith(response);
                            vm.isChartDetailsLoaded = true;
                            $timeout(function () {
                                vm.apiDataHeader = [];
                                vm.querySearchDataHeader = [];
                                _.forEach(vm.selectChartObj.query.results.data, function (dataObj) {
                                    _.forEach(dataObj, function (value, key) {
                                        if (!_.find(vm.querySearchDataHeader, {name: key})) {
                                            vm.querySearchDataHeader.push({
                                                name: key,
                                                type: typeof value,
                                                isPlotted: false
                                            });
                                        }
                                        vm.apiDataHeader.push(key);
                                    });
                                });
                                vm.apiDataHeader = _.uniq(_.map(vm.apiDataHeader)).sort();
                                vm.fnGotoPreviousNextStep();
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartDetailsLoaded = true;
                        })
                };

                vm.fnGotoPreviousNextStep = function (isGotoPreviousStep) {
                    if (isGotoPreviousStep) {
                        vm.activeStep = vm.activeStep - 1;
                    } else {
                        vm.activeStep = vm.activeStep + 1;
                    }
                    if (vm.activeStep === 1) {
                        $("#chartEditor").empty(); //eslint-disable-line
                        var myOptions = {
                            chart: {
                                type: 'pie'
                            },
                            title: {
                                text: " "
                            },
                            subtitle: {
                                text: " "
                            },
                            xAxis: {
                                type: "category"
                            },
                            exporting: {
                                enabled: false
                            },
                            credits: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            },
                            series: [
                                {
                                    animationLimit: -1
                                }
                            ],
                            legend: {
                                enabled: false
                            }
                        };
                        if (vm.selectChartObj && vm.selectChartObj.definition && vm.selectChartObj.definition.chartConfig && vm.selectChartObj.definition.chartConfig.chart && !_.isEmpty(vm.selectChartObj.definition.chartConfig.chart)) {
                            myOptions.chart.type = vm.selectChartObj.definition.chartConfig.chart.type;
                        }
                        instance = highed.DrawerEditor('chartEditor', {
                            defaultChartOptions: myOptions
                        });
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                        $timeout(function () {
                            $('.fa-bar-chart').click(); //eslint-disable-line
                            $timeout(function () {
                                if ($(".highed-list a:last-child")[0]) { //eslint-disable-line
                                    $(".highed-list a:last-child")[0].remove(); //eslint-disable-line
                                }
                                $timeout(function () {
                                    var data = document.getElementsByClassName("item");
                                    for (var i = 0; i < data.length; i++) {
                                        data[i].addEventListener("click", function () {  //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-cat-desc div').remove(); //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-samples').remove(); //eslint-disable-line
                                        });
                                    }
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    })
                                })
                            });
                        }, 250);
                    }
                    if (vm.activeStep === 2) {
                        vm.selectChartObj.definition.chartConfig = instance.getEmbeddableJSON();
                        vm.selectChartObj.definition.chartType = vm.selectChartObj.definition.chartConfig.chart.type;
                        var chartMappingData = _.find(chartMapping, {chartType: vm.selectChartObj.definition.chartType});
                        vm.isAllowMultiField = chartMappingData.isAllowMultiField;
                        vm.dataConfig = [];
                        if (vm.selectChartObj && vm.selectChartObj.definition && vm.selectChartObj.definition.dataMapping && !_.isEmpty(vm.selectChartObj.definition.dataMapping)) {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                if (vm.selectChartObj.definition.dataMapping[requiredDataObj.key]) {
                                    vm.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: vm.selectChartObj.definition.dataMapping[requiredDataObj.key],
                                        isRequired: true
                                    });
                                }
                            });
                            if (vm.dataConfig.length !== Object.keys(vm.selectChartObj.definition.dataMapping).length) {
                                var arr = Object.keys(vm.selectChartObj.definition.dataMapping);
                                _.forEach(arr, function (arrKey) {
                                    var isFind = _.find(vm.dataConfig, {key: arrKey});
                                    if (!isFind) {
                                        vm.dataConfig.push(
                                            {
                                                key: arrKey,
                                                value: vm.selectChartObj.definition.dataMapping[arrKey]
                                            }
                                        )
                                    }
                                });
                            }
                        } else {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                vm.dataConfig.push({
                                    key: requiredDataObj.key,
                                    value: '',
                                    isRequired: true
                                });
                            });
                        }
                        vm.fnDataConfigSelected();
                    }
                    if (vm.activeStep === 3) {
                        $timeout(function () {
                            vm.selectChartObj.definition.dataMapping = {};
                            _.forEach(vm.dataConfig, function (dataConfigObj) {
                                vm.selectChartObj.definition.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                            });
                            var testingJSON = vm.selectChartObj.definition.chartConfig;
                            var headers = {};
                            _.forEach(vm.dataConfig, function (dataConfigObj) {
                                headers[dataConfigObj.value] = dataConfigObj.value
                            });
                            var items = [];
                            _.forEach(vm.selectChartObj.query.results.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            testingJSON.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            vm.selectChartObj.definition.chartConfig = testingJSON;
                            $("#previewChart").empty(); //eslint-disable-line
                            var previewChart = highed.DrawerEditor('previewChart');
                            previewChart.chart.options.setAll(testingJSON);
                            previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                            $timeout(function () {
                                previewChart.resize();
                            }, 250);
                        })
                    }
                    if (vm.activeStep === 4) {
                        $timeout(function () {
                            Highcharts.chart('finalPreviewChart', vm.selectChartObj.definition.chartConfig);
                        })
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnDataConfigSelected = function () {
                    _.forEach(vm.querySearchDataHeader, function (headerObj) {
                        var isFind = _.find(vm.dataConfig, {value: headerObj.name});
                        headerObj.isPlotted = !!isFind;
                    })
                }

                vm.fnCheckRequiredInput = function () {
                    var flag = true;
                    vm.dataConfig.map(function (kvpPairObj) {
                        if (angular.isUndefined(kvpPairObj.key) || kvpPairObj.key === "" || angular.isUndefined(kvpPairObj.value) || kvpPairObj.value === "") {
                            flag = false;
                        }
                    });
                    return flag;
                };

                vm.fnAddNewMapping = function () {
                    var tempKey = "mapping_";
                    var keyNumber = 0;
                    _.forEach(vm.dataConfig, function (value) {
                        if (value.key.startsWith('mapping_')) {
                            var number = parseInt(value.key.toString().split('_')[1]);
                            if (number > keyNumber) {
                                keyNumber = number;
                            }
                        }
                    });
                    tempKey = tempKey + (keyNumber + 1);
                    vm.dataConfig.push({
                        key: tempKey,
                        value: ''
                    });
                };

                vm.fnRemoveMapping = function (index) {
                    vm.dataConfig.splice(index, 1);
                    vm.fnDataConfigSelected();
                };

                vm.fnEditChartProperties = function () {
                    var testingJSON = vm.selectChartObj.definition.chartConfig;
                    var headers = {};
                    _.forEach(vm.dataConfig, function (dataConfigObj) {
                        headers[dataConfigObj.value] = dataConfigObj.value
                    });
                    var items = [];
                    _.forEach(vm.selectChartObj.query.results.data, function (obj) {
                        var tempObj = {};
                        _.forEach(vm.dataConfig, function (dataConfigObj) {
                            tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                        });
                        items.push(tempObj);
                    });
                    items.unshift(headers);
                    var jsonObject = angular.toJson(items);
                    testingJSON.data = {
                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                        "googleSpreadsheetKey": false,
                        "googleSpreadsheetWorksheet": false,
                        "decimalPoint": ","
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/chartEditor/chartEditorModal.html',
                        size: 'lg',
                        controller: 'chartEditorModalCtrl as chartEditor',
                        windowClass: 'modal-height100',
                        resolve: {
                            chartObj: function () {
                                return testingJSON;
                            },
                            csvData: function () {
                                return jsonToCsvConvertService.convertToCSV(jsonObject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) { //response
                        vm.selectChartObj.definition.chartConfig = res;
                        $("#previewChart").empty(); //eslint-disable-line
                        var previewChart = highed.DrawerEditor('previewChart');
                        previewChart.chart.options.setAll(res);
                        previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                        $timeout(function () {
                            previewChart.resize();
                        }, 250);
                    }, function () {
                    });
                };

                vm.fnSaveChart = function () {
                    vm.isChartUpdateing = true;
                    var testingJSON = vm.selectChartObj.definition.chartConfig;
                    var inputObj = {
                        chartId: vm.selectChartObj.id,
                        body: {
                            definition: {}
                        }
                    };
                    inputObj.body.definition = {
                        chartType: _.cloneDeepWith(testingJSON.chart.type),
                        dataMapping: _.cloneDeepWith(vm.selectChartObj.definition.dataMapping),
                        chartConfig: _.cloneDeepWith(testingJSON)
                    };
                    InsightChartFactory.updateChartChart(inputObj)
                        .then(function () {
                            vm.isChartUpdateing = false;
                            amaran.success("Chart updated successfully");
                            $scope.$emit('chartChartDataUpdated');
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartUpdateing = false;
                        });
                }

                vm.fnInitUpdateChart = function () {
                    var selectedTabObj = _.find($scope.insightCharts.tabs, {id: 'Update Chart'});
                    if (selectedTabObj) {
                        vm.isChartDetailsLoaded = false;
                        vm.selectedChartId = selectedTabObj.chartId;
                        vm.fnGetChartInfo(vm.selectedChartId);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightChartInfo', fnInsightChartInfo)

    /** @ngInject */
    function fnInsightChartInfo($window, $state, DB, $stateParams, $timeout, microSpinner, swal, amaran, InsightChartFactory, AppInitService, InsightProjectFactory, QueryFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/insight/insight_charts/insightChartInfo/insightChartInfo.html',
            scope: {
                chartObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Chart',
                        tabIndex: 1,
                        templateUrl: 'app/insight/insight_charts/insightChartInfo/insightChartSteps/chartChart/insightChartChart.html'
                    },
                    {
                        title: 'Query',
                        tabIndex: 2,
                        templateUrl: 'app/insight/insight_charts/insightChartInfo/insightChartSteps/chartQuery/insightChartQuery.html'
                    },
                    {
                        title: 'Details',
                        tabIndex: 3,
                        templateUrl: 'app/insight/insight_charts/insightChartInfo/insightChartSteps/details.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 4,
                        templateUrl: 'app/insight/insight_charts/insightChartInfo/insightChartSteps/chartTags/insightChartTags.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.selectedProject = {};

                $scope.fnGetChart = function (chartId) {
                    var inputObj = {
                        chartId: chartId
                    };
                    InsightChartFactory.describeChart(inputObj)
                        .then(function (response) {
                            $scope.chartObj = response;
                            $scope.resetChartObj = angular.copy($scope.chartObj);
                            if (angular.isUndefined($scope.chartObj.description)) {
                                $scope.chartObj.description = '';
                            }
                            $scope.isChartDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isChartDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.insight_charts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateChartDetails = function (chartObj) {
                    var inputObj = {
                        body: {},
                        chartId: chartObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(chartObj.description)) {
                        chartObj.description = '';
                    }
                    inputObj.body = {
                        name: chartObj.name,
                        description: chartObj.description
                    };
                    InsightChartFactory.updateChart(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('ChartDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Chart Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteChart = function (chartObj) {
                    swal({
                            title: "Delete the selected Chart?",
                            text: "You are about to permanently delete the selected Chart.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    chartId: chartObj.id
                                };
                                InsightChartFactory.deleteChart(inputObj)
                                    .then(function () {
                                        $scope.$emit('QueriesDeleted', chartObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.chartObj = angular.copy($scope.resetChartObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitChart = function () {
                    $scope.isChartDetailsLoaded = false;
                    $scope.chartId = $scope.chartObj.id;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        var projectsArr = AppInitService.getInitData('insightProjectsArr');
                        var isFind = _.find(projectsArr, {id: $scope.chartObj.projectId});
                        if (isFind) {
                            $scope.selectedProject = _.cloneDeepWith(isFind);
                        }
                        $scope.fnGetChart($scope.chartId);
                    } else {
                        InsightProjectFactory.describeProject({projectId: $scope.chartObj.projectId}).then(function (res) { // Success block
                            $scope.selectedProject = _.cloneDeepWith(res);
                            if ($scope.chartId) {
                                $scope.fnGetChart($scope.chartId);
                            }
                        });
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitChart();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var chartInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_charts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteChart($scope.chartObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var chartInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_charts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', chartInfoKeyDownEventHandler);
                document.addEventListener('keyup', chartInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', chartInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', chartInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createInsightChartCtrl',
            function ($scope, $window, $uibModal, moment, Highcharts, amaran, DB, $timeout, highed, InsightChartFactory, PaginationQueryService, sqlFormatter, AppInitService, QueryFactory, jsonToCsvConvertService, UserProfileService) {
                var vm = this;
                vm.title = "Create Chart";
                vm.activeStep = 1;
                vm.newChartObj = {
                    name: '',
                    description: '',
                    queryId: '',
                    projectId: '',
                    syntax: 'HIGHCHARTS',
                    definition: {}
                };
                var chartMapping = [
                    {
                        "chartType": "arearange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "area",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "columnrange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "column",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "line",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "spline",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "pie",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "funnel",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "pyramid",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "solidgauge",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "bubble",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "value",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "boxplot",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "low",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q1",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "median",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q3",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "high",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "scatter",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    }
                ];

                vm.selectedWidget = {
                    chartConfiguration: {
                        chartType: 'pie'
                    }
                };

                var tableName = 'insight_queries';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.queriesProjectFilter = "$";
                vm.queriesProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isQueriesLoading = false;
                vm.queriesResponse = [];
                vm.queriesArr = [];
                vm.selectedQueriesArr = [];
                vm.selectedQueriesObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createChartModalBody").css('height', finalHeight + 'px');
                        if (angular.element(".wizard")[0] && angular.element(".tab-content")[0] && angular.element(".title-border-bottom")[0]) {
                            var wizardInner = angular.element(".wizard")[0].offsetHeight;
                            var titleBorderBottom = angular.element(".title-border-bottom")[0].offsetHeight !== 0 ? angular.element(".title-border-bottom")[0].offsetHeight : 29;
                            angular.element(".wizard-tab-height").css('height', finalHeight - (wizardInner + titleBorderBottom + 30) + 'px');
                            if (angular.element("#queriesTable")[0] && vm.activeStep === 1) {
                                if (angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                                    angular.isDefined(angular.element("thead")[0]) &&
                                    angular.isDefined(angular.element(".pagination-container")[0])) {
                                    var modalTotal = finalHeight - (wizardInner + titleBorderBottom + 30);
                                    var search = angular.element(".search-panel-v4")[0].offsetHeight;
                                    var searchTag = 0;
                                    var tableHeader = angular.element("thead")[0].offsetHeight;
                                    var pagination = angular.element(".pagination-container")[0].offsetHeight;
                                    var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                                    var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                                    var finalTableHeight = modalTotal - (search + pagination + searchTag + tableHeader + 70 + dashboardHeader + mainFooter);
                                    angular.element("#queriesTable").css('height', finalTableHeight + 'px');
                                }
                            }
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".wizard-tab-height")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".wizard-tab-height")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'queries', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectQueries = function (projectObj) {
                    vm.isQueriesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetQueries(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.queriesArr);
                        vm.previousPage = page;
                        vm.fnGetQueries(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetQueries = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.queriesResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.queriesResponse.data && vm.queriesResponse.data.length) {
                                vm.totalItems = vm.queriesResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.queriesResponse.data.reverse();
                            }
                            vm.queriesArr = _.cloneDeepWith(vm.queriesResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isQueriesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueriesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (queriesObj) {
                    angular.forEach(vm.queriesArr, function (obj) {
                        if (queriesObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindQueries = _.find(vm.queriesArr, function (queriesObj) {
                        return queriesObj.isCheck === true;
                    });
                    if (isFindQueries) {
                        vm.selectedQueriesObj = _.cloneDeepWith(isFindQueries);
                    } else {
                        vm.selectedQueriesObj = {};
                    }
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.isQueriesObjSelected = function () {
                    return !!vm.selectedQueriesObj && Object.keys(vm.selectedQueriesObj).length;
                };
                var instance;

                vm.fnGotoPreviousNextStep = function (isGotoPreviousStep) {
                    if (isGotoPreviousStep) {
                        vm.activeStep = vm.activeStep - 1;
                    } else {
                        vm.activeStep = vm.activeStep + 1;
                    }
                    if (vm.activeStep === 2) {
                        $("#chartEditor").empty(); //eslint-disable-line
                        vm.fnRunQuery();
                        var myOptions = {
                            chart: {
                                type: 'pie'
                            },
                            title: {
                                text: " "
                            },
                            subtitle: {
                                text: " "
                            },
                            xAxis: {
                                type: "category"
                            },
                            exporting: {
                                enabled: false
                            },
                            credits: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            },
                            series: [
                                {
                                    animationLimit: -1
                                }
                            ],
                            legend: {
                                enabled: false
                            }
                        };
                        instance = highed.DrawerEditor('chartEditor', {
                            defaultChartOptions: myOptions
                        });
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                        $timeout(function () {
                            $('.fa-bar-chart').click(); //eslint-disable-line
                            $timeout(function () {
                                if ($(".highed-list a:last-child")[0]) { //eslint-disable-line
                                    $(".highed-list a:last-child")[0].remove(); //eslint-disable-line
                                }
                                $timeout(function () {
                                    var data = document.getElementsByClassName("item");
                                    for (var i = 0; i < data.length; i++) {
                                        data[i].addEventListener("click", function () {  //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-cat-desc div').remove(); //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-samples').remove(); //eslint-disable-line
                                        });
                                    }
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    })
                                })
                            });
                        }, 250);
                    }
                    if (vm.activeStep === 3) {
                        if (!isGotoPreviousStep) {
                            vm.selectedWidget.chartConfiguration.chartConfig = instance.getEmbeddableJSON();
                        }
                        vm.selectedWidget.chartConfiguration.chartType = vm.selectedWidget.chartConfiguration.chartConfig.chart.type;
                        var chartMappingData = _.find(chartMapping, {chartType: vm.selectedWidget.chartConfiguration.chartType});
                        vm.isAllowMultiField = chartMappingData.isAllowMultiField;
                        vm.dataConfig = [];
                        if (vm.selectedWidget && vm.selectedWidget.chartConfiguration && vm.selectedWidget.chartConfiguration.dataMapping && !_.isEmpty(vm.selectedWidget.chartConfiguration.dataMapping)) {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                if (vm.selectedWidget.chartConfiguration.dataMapping[requiredDataObj.key]) {
                                    vm.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: vm.selectedWidget.chartConfiguration.dataMapping[requiredDataObj.key],
                                        isRequired: true
                                    });
                                }
                            });
                            if (vm.dataConfig.length !== Object.keys(vm.selectedWidget.chartConfiguration.dataMapping).length) {
                                var arr = Object.keys(vm.selectedWidget.chartConfiguration.dataMapping);
                                _.forEach(arr, function (arrKey) {
                                    var isFind = _.find(vm.dataConfig, {key: arrKey});
                                    if (!isFind) {
                                        vm.dataConfig.push(
                                            {
                                                key: arrKey,
                                                value: vm.selectedWidget.chartConfiguration.dataMapping[arrKey]
                                            }
                                        )
                                    }
                                });
                            }
                        } else {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                vm.dataConfig.push({
                                    key: requiredDataObj.key,
                                    value: '',
                                    isRequired: true
                                });
                            });
                        }
                    }
                    if (vm.activeStep === 4) {
                        $timeout(function () {
                            vm.selectedWidget.chartConfiguration.dataMapping = {};
                            _.forEach(vm.dataConfig, function (dataConfigObj) {
                                vm.selectedWidget.chartConfiguration.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                            });
                            var testingJSON = vm.selectedWidget.chartConfiguration.chartConfig;
                            var headers = {};
                            _.forEach(vm.dataConfig, function (dataConfigObj) {
                                headers[dataConfigObj.value] = dataConfigObj.value
                            });
                            var items = [];
                            _.forEach(vm.data, function (obj) {
                                var tempObj = {};
                                _.forEach(vm.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            testingJSON.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            vm.selectedWidget.chartConfiguration.chartConfig = testingJSON;
                            $("#previewChart").empty(); //eslint-disable-line
                            var previewChart = highed.DrawerEditor('previewChart');
                            previewChart.chart.options.setAll(testingJSON);
                            previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                            $timeout(function () {
                                previewChart.resize();
                            }, 250);
                        })
                    }
                    if (vm.activeStep === 5) {
                        $timeout(function () {
                            Highcharts.chart('finalPreviewChart', vm.selectedWidget.chartConfiguration.chartConfig);
                        })
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };

                vm.fnDataConfigSelected = function () {
                    _.forEach(vm.querySearchDataHeader, function (headerObj) {
                        var isFind = _.find(vm.dataConfig, {value: headerObj.name});
                        headerObj.isPlotted = !!isFind;
                    })
                }

                vm.fnCheckRequiredInput = function () {
                    var flag = true;
                    vm.dataConfig.map(function (kvpPairObj) {
                        if (angular.isUndefined(kvpPairObj.key) || kvpPairObj.key === "" || angular.isUndefined(kvpPairObj.value) || kvpPairObj.value === "") {
                            flag = false;
                        }
                    });
                    return flag;
                };

                vm.fnAddNewMapping = function () {
                    var tempKey = "mapping_";
                    var keyNumber = 0;
                    _.forEach(vm.dataConfig, function (value) {
                        if (value.key.startsWith('mapping_')) {
                            var number = parseInt(value.key.toString().split('_')[1]);
                            if (number > keyNumber) {
                                keyNumber = number;
                            }
                        }
                    });
                    tempKey = tempKey + (keyNumber + 1);
                    vm.dataConfig.push({
                        key: tempKey,
                        value: ''
                    });
                };

                vm.fnRemoveMapping = function (index) {
                    vm.dataConfig.splice(index, 1);
                };

                vm.fnEditChartProperties = function () {
                    var testingJSON = vm.selectedWidget.chartConfiguration.chartConfig;
                    var headers = {};
                    _.forEach(vm.dataConfig, function (dataConfigObj) {
                        headers[dataConfigObj.value] = dataConfigObj.value
                    });
                    var items = [];
                    _.forEach(vm.data, function (obj) {
                        var tempObj = {};
                        _.forEach(vm.dataConfig, function (dataConfigObj) {
                            tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                        });
                        items.push(tempObj);
                    });
                    items.unshift(headers);
                    var jsonObject = angular.toJson(items);
                    testingJSON.data = {
                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                        "googleSpreadsheetKey": false,
                        "googleSpreadsheetWorksheet": false,
                        "decimalPoint": ","
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/chartEditor/chartEditorModal.html',
                        size: 'lg',
                        controller: 'chartEditorModalCtrl as chartEditor',
                        windowClass: 'modal-height100',
                        resolve: {
                            chartObj: function () {
                                return testingJSON;
                            },
                            csvData: function () {
                                return jsonToCsvConvertService.convertToCSV(jsonObject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) { //response
                        vm.selectedWidget.chartConfiguration.chartConfig = res;
                        $("#previewChart").empty(); //eslint-disable-line
                        var previewChart = highed.DrawerEditor('previewChart');
                        previewChart.chart.options.setAll(res);
                        previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                        $timeout(function () {
                            previewChart.resize();
                        }, 250);
                    }, function () {
                    });
                };

                vm.fnRunQuery = function () {
                    if (vm.selectedQueriesObj.sql && vm.selectedQueriesObj.sql.length) {
                        vm.isQuerySearchDataLoading = true;
                        vm.softwareSearchData = [];
                        var input = {
                            "sql": vm.selectedQueriesObj.sql
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            vm.data = _.cloneDeepWith(res.data);
                            vm.apiData = res.data;
                            vm.querySearchDataHeader = [];
                            vm.apiDataHeader = [];
                            _.forEach(vm.apiData, function (dataObj) {
                                _.forEach(dataObj, function (value, key) {
                                    if (!_.find(vm.querySearchDataHeader, {name: key})) {
                                        vm.querySearchDataHeader.push({
                                            name: key,
                                            type: typeof value,
                                            isPlotted: false
                                        });
                                    }
                                    vm.apiDataHeader.push(key);
                                });
                            });
                            vm.apiDataHeader = _.uniq(_.map(vm.apiDataHeader)).sort();
                            vm.isQuerySearchDataLoading = false;
                        }, function () { // Error block
                            vm.isQuerySearchDataLoading = false;
                        });
                    }
                };

                vm.fnCreateNewChart = function (newChartObj) {
                    vm.isChartCreating = true;
                    var testingJSON = vm.selectedWidget.chartConfiguration.chartConfig;
                    var inputObj = {
                        body: newChartObj
                    };
                    inputObj.body.queryId = vm.selectedQueriesObj.id;
                    inputObj.body.projectId = vm.selectedQueriesObj.projectId;
                    inputObj.body.definition = {
                        chartType: _.cloneDeepWith(testingJSON.chart.type),
                        dataMapping: _.cloneDeepWith(vm.selectedWidget.chartConfiguration.dataMapping),
                        chartConfig: _.cloneDeepWith(testingJSON)
                    };
                    InsightChartFactory.createChart(inputObj)
                        .then(function (resObj) {
                            vm.isChartCreating = false;
                            vm.newChartObj = {
                                name: '',
                                description: '',
                                queryId: '',
                                projectId: '',
                                syntax: 'HIGHCHARTS',
                                definition: {}
                            };
                            amaran.success("Chart created successfully");
                            $timeout(function () {
                                $scope.insightCharts.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('chartAdded', resObj.id);
                            $scope.insightCharts.totalItems = $scope.insightCharts.totalItems + 1;
                            $scope.insightCharts.chartsArr.push(resObj);
                            $scope.insightCharts.fnReload();
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartCreating = false;
                        });
                };

                vm.fnInitCreateChart = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('telemetryDataLoadModalCtrl',
            function () {
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('postCreateActionModalCtrl',
            function (amaran, DB, $timeout, $uibModalInstance, UserFactory, ListenerFactory, postCreateOptionsArr,
                      UserProfileService) {
                var vm = this;
                vm.postCreateOptionsArr = postCreateOptionsArr;
                vm.isUserDataUpdating = false;

                vm.fnActionSelected = function (subOption) {
                    if(subOption.isWorkflowOperationNeeded) {
                        vm.isUserDataUpdating = true;
                        var action = (subOption.triggerObj.name.split("(")[1]).split(")")[0];
                        var inputObj = {
                            body: {
                                "name": "Auto Listener for " + subOption.workflowObj.name,
                                "description": "This Listener was automatically created for " + subOption.workflowObj.name,
                                "state": "ACTIVE",
                                "statements": [
                                    {
                                        "effect": "ALLOW",
                                        "actions": [
                                            action
                                        ],
                                        "expression": null
                                    }
                                ]
                            }
                        };
                        ListenerFactory.createListener(inputObj)
                            .then(function (response) {
                                var wfInputObj = {
                                    listenerId: response.id,
                                    workflowId: subOption.workflowObj.id
                                };
                                ListenerFactory.addWorkFlowToListener(wfInputObj)
                                    .then(function () {
                                        vm.isUserDataUpdating = false;
                                        amaran.success('Listener created based on this Workflow');
                                        $uibModalInstance.close();
                                    }, function () {
                                        vm.isUserDataUpdating = false;
                                        $uibModalInstance.close();
                                    })
                            }, function () {
                                vm.isUserDataUpdating = false;
                                $uibModalInstance.close();
                            })
                    } else {
                        $uibModalInstance.close(subOption);
                    }
                };

                vm.fnUpdateUserWindowChoice = function () {
                    vm.isUserDataUpdating = true;
                    if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                        UserProfileService.fnUpdateSystemProfileObj('postActionOptionsEnabled', false);
                        vm.isUserDataUpdating = false;
                        $timeout(function () {
                            $uibModalInstance.dismiss('cancel');
                        })
                    } else{
                        // FedSudoUserService.fnSetUserData('postActionOptionsEnabled', ["" + false + ""]);
                        vm.isUserDataUpdating = false;
                        $timeout(function () {
                            $uibModalInstance.dismiss('cancel');
                        })
                    }

                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('supplementFunctionModalCtrl',
            function ($timeout, $window, $uibModalInstance, L) {
                var vm = this;
                vm.coordinateArr = [{key: 'lat', value: '39.721712'},
                    {key: 'long', value: '-104.941406'}
                ];

                vm.isFunctionSelected = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTreeHeight();
                });

                vm.fnSetTreeHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".inputContainer")[0])) {
                        var total, inputContainer, finalHeight;
                        total = angular.element(".modal-body")[0].offsetHeight;
                        inputContainer = angular.element(".inputContainer")[0].offsetHeight;
                        finalHeight = total - (inputContainer + 50);
                        angular.element("#map1").css('height', finalHeight + 'px');
                    }
                };
                vm.functionsArr = [
                    {
                        "name": "GPS coordinates",
                        "description": "Retrieve the GPS coordinates from the map."
                    }];


                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClose = function () {
                    $uibModalInstance.close(vm.coordinateArr);
                };

                vm.fnInject = function (obj) {
                    vm.functionType = obj.name;
                    vm.isFunctionSelected = true;
                    $timeout(function () {
                        document.getElementById('supplementalMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                        var mapOptions = {};
                        mapOptions.center = [39.721712, -104.941406];
                        mapOptions.zoom = 8;
                        mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        var map = new L.Map('map1', mapOptions);
                        var marker = L.marker([39.721712, -104.941406], {
                            draggable: true
                        }).addTo(map);
                        $timeout(function () {
                            vm.fnSetTreeHeight();
                        });
                        marker.on('drag', function () {
                            $timeout(function () {
                                vm.coordinateArr[0].value = marker.getLatLng().lat.toString();
                                vm.coordinateArr[1].value = marker.getLatLng().lng.toString();
                            })
                        });
                        $timeout(function () {
                            map.invalidateSize()
                        });
                    });
                };

                vm.fnCheckSupplementValidation = function () {
                    var flag = true;
                    _.forEach(vm.coordinateArr, function (kvpPairObj) {
                        if (angular.isUndefined(kvpPairObj.key) || angular.isUndefined(kvpPairObj.value)) {
                            flag = false;
                        }
                    });
                    return flag;
                };

                vm.fnBackToFunctions = function () {
                    vm.functionType = '';
                    vm.isFunctionSelected = false;
                    vm.coordinateArr = [{key: 'latitude', value: '39.721712'},
                        {key: 'longitude', value: '-104.941406'}
                    ];
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('queryBuilderValueModalCtrl',
            function ($timeout, $window, $uibModalInstance) {
                var vm = this;

                /*filters: START*/

                vm.functionsArr = [
                    {
                        "name": "Sum(...)",
                        "description": "A function for addition of multiple values. This takes a comma separated list of values in the brackets.",
                        "value": "Sum()"
                    },
                    {
                        "name": "Join(...)",
                        "description": "A function to join multiple values in a single string. This takes a comma separated list of values in the brackets. ",
                        "value": "Join()"
                    }
                    ];

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInject = function (obj) {
                    $uibModalInstance.close(obj.value);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('modifyGhostAttributeCtrl',
            function ($timeout, $uibModalInstance, selectedGhostObj, ghostType, requiredInputObj, amaran, ComponentFactory, DeviceFactory, GatewayFactory) {
                var vm = this;
                vm.selectedGhostObj = selectedGhostObj;
                vm.ghostType = ghostType;
                vm.booleanOptionArr = ["true", "false"];
                vm.isInputValidated = false;
                vm.requiredInputObj = angular.copy(requiredInputObj);
                vm.isGhostUpdateCompleted = true;

                vm.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);
                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                vm.fnValidate = function (typePropertyObj) {
                    if (typePropertyObj.required && (typePropertyObj.required === true || typePropertyObj.required === "true")) {
                        if (typePropertyObj.typeValue) {
                            typePropertyObj.isValueMissing = false;
                        } else {
                            typePropertyObj.isValueMissing = true;
                        }
                    }
                    if (typePropertyObj.min) {
                        if (typePropertyObj.typeValue < typePropertyObj.min) {
                            typePropertyObj.isMinError = true;
                        } else {
                            typePropertyObj.isMinError = false;
                        }
                    }
                    if (typePropertyObj.max) {
                        if (typePropertyObj.typeValue > typePropertyObj.max) {
                            typePropertyObj.isMaxError = true;
                        } else {
                            typePropertyObj.isMaxError = false;
                        }
                    }
                    if (typePropertyObj.regex) {
                        var regExp = new RegExp(typePropertyObj.regex);
                        if (regExp.test(typePropertyObj.typeValue)) {
                            typePropertyObj.isPatternMismatch = false;
                        } else {
                            typePropertyObj.isPatternMismatch = true;
                        }
                    }

                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnCheckAllFieldsValidation = function () {
                    var flag = true;
                    vm.selectedGhostObj.map(function (typeObj) {
                        if (typeObj.required && (typeObj.required === true || typeObj.required === "true")) {
                            if (typeObj.type === 'Boolean') {
                                if (typeObj.typeValue !== false && typeObj.typeValue !== true) {
                                    flag = false;
                                }
                            } else {
                                if (!typeObj.typeValue) {
                                    flag = false;
                                }
                            }
                        }
                        if (typeObj.type !== "Array") {
                            if (typeObj.min) {
                                if (typeObj.typeValue < typeObj.min) {
                                    flag = false;
                                }
                            }
                            if (typeObj.max) {
                                if (typeObj.typeValue > typeObj.max) {
                                    flag = false;
                                }
                            }
                            if (typeObj.regex) {
                                var regExp = new RegExp(typeObj.regex);
                                if (!regExp.test(typeObj.typeValue)) {
                                    flag = false;
                                }
                            }
                        } else {
                            if (typeObj.min) {
                                if (typeObj.typeValue.length < typeObj.min) {
                                    flag = false;
                                }
                            }
                            if (typeObj.max) {
                                if (typeObj.typeValue.length > typeObj.max) {
                                    flag = false;
                                }
                            }
                        }
                    });
                    if (flag) {
                        var propertiesObj = {};
                        vm.selectedGhostObj.map(function (typeObj) {
                            if (typeObj.type === "Number") {
                                if (typeObj.precision && typeObj.typeValue) {
                                    typeObj.typeValue = parseFloat(typeObj.typeValue.toFixed(parseInt(typeObj.precision)))
                                }
                            }
                            propertiesObj[typeObj.name] = typeObj.typeValue;
                        });
                        vm.isInputValidated = true;
                    } else {
                        vm.isInputValidated = false;
                    }
                };

                vm.fnCreateArrayTag = function (arrValue, id, typePropertyObj) {
                    if (arrValue) {
                        var flag = false;
                        if (typePropertyObj.item !== "Boolean") {
                            angular.forEach(typePropertyObj.typeValue, function (obj) {
                                if (obj === arrValue) {
                                    flag = true;
                                }
                            });
                        }

                        if (!flag && typePropertyObj.isMaxError !== true) {
                            if (typePropertyObj.regex) {
                                if (typePropertyObj.isPatternMismatch === false) {
                                    typePropertyObj.typeValue.push(angular.copy(arrValue));
                                    typePropertyObj.arrValue = "";
                                    angular.element('#' + id).blur();
                                }
                            } else {
                                typePropertyObj.typeValue.push(angular.copy(arrValue));
                                typePropertyObj.arrValue = "";
                                angular.element('#' + id).blur();
                            }
                        }
                    }
                    vm.fnArrayValidation(typePropertyObj, typePropertyObj.arrValue);
                };

                vm.fnRemoveSelectedArrayTag = function (typePropertyObj, index) {
                    typePropertyObj.typeValue.splice(index, 1);
                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnArrayValidation = function (typePropertyObj, value) {
                    if (typePropertyObj.required && (typePropertyObj.required === true || typePropertyObj.required === "true")) {
                        if (typePropertyObj.typeValue) {
                            typePropertyObj.isValueMissing = false;
                        } else {
                            typePropertyObj.isValueMissing = true;
                        }
                    }
                    if (typePropertyObj.min) {
                        if (typePropertyObj.typeValue.length < typePropertyObj.min) {
                            typePropertyObj.isMinError = true;
                        } else {
                            typePropertyObj.isMinError = false;
                        }
                    }
                    if (typePropertyObj.max) {
                        if (typePropertyObj.typeValue.length >= typePropertyObj.max) {
                            typePropertyObj.isMaxError = true;
                        } else {
                            typePropertyObj.isMaxError = false;
                        }
                    }
                    if (typePropertyObj.regex) {
                        var regExp = new RegExp(typePropertyObj.regex);
                        if (regExp.test(value)) {
                            typePropertyObj.isPatternMismatch = false;
                        } else {
                            typePropertyObj.isPatternMismatch = true;
                        }
                    }
                    vm.fnCheckAllFieldsValidation();
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    var inputObj = {};
                    if (vm.ghostType === 'Component') {
                        vm.isGhostUpdateCompleted = false;
                        inputObj = vm.requiredInputObj;
                        inputObj.body = {
                            name: vm.selectedGhostObj[0].name,
                            desired: vm.selectedGhostObj[0].typeValue ? vm.selectedGhostObj[0].typeValue : ""
                        };
                        ComponentFactory.modifyComponentGhost(inputObj)
                            .then(function () {
                                vm.isGhostUpdateCompleted = true;
                                amaran.success("Ghost Value Updated");
                                $uibModalInstance.dismiss('cancel');
                            }, function () {
                                vm.isGhostUpdateCompleted = true;
                                $uibModalInstance.dismiss('cancel');
                            })
                    } else if (vm.ghostType === 'Device') {
                        inputObj = vm.requiredInputObj;
                        inputObj.body = {
                            name: vm.selectedGhostObj[0].name,
                            desired: vm.selectedGhostObj[0].typeValue ? vm.selectedGhostObj[0].typeValue : ""
                        };
                        DeviceFactory.modifyDeviceGhost(inputObj)
                            .then(function () {
                                vm.isGhostUpdateCompleted = true;
                                amaran.success("Ghost Value Updated");
                                $uibModalInstance.dismiss('cancel');
                            }, function () {
                                vm.isGhostUpdateCompleted = true;
                                $uibModalInstance.dismiss('cancel');
                            })
                    } else {
                        inputObj = vm.requiredInputObj;
                        inputObj.body = {
                            name: vm.selectedGhostObj[0].name,
                            desired: vm.selectedGhostObj[0].typeValue ? vm.selectedGhostObj[0].typeValue : ""
                        };
                        GatewayFactory.modifyGatewayGhost(inputObj)
                            .then(function () {
                                vm.isGhostUpdateCompleted = true;
                                amaran.success("Ghost Value Updated");
                                $uibModalInstance.dismiss('cancel');
                            }, function () {
                                vm.isGhostUpdateCompleted = true;
                                $uibModalInstance.dismiss('cancel');
                            })
                    }
                };

                $timeout(function () {
                    vm.fnValidate(vm.selectedGhostObj[0]);
                });


            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('exportOptionsModalCtrl',
            function ($uibModalInstance) {
                var vm = this;

                vm.exportOptions = [{
                    name: 'Export to CSV',
                    type: 'csv',
                    isCheck: false
                }, {
                    name: 'Export to Excel',
                    type: 'excel',
                    isCheck: false
                }];
                vm.selectedExportOption = null;
                vm.isErrorMessageEnabled = true;

                vm.fnCheckUncheckHeader = function (index) {
                    _.forEach(vm.exportOptions, function (exportOption, i) {
                        if (index !== i) {
                            vm.exportOptions[i].isCheck = false;
                        }
                    });
                    vm.selectedExportOption = vm.exportOptions[index].isCheck ? vm.exportOptions[index] : null;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSelectExportOption = function () {
                    $uibModalInstance.close(vm.selectedExportOption.type);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('dashboardListModalCtrl',
            function ($rootScope, $window, $timeout, $uibModalInstance, amaran, moment, PaginationQueryService, QueryFactory, DB, AppInitService, UserProfileService) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 70);
                        angular.element("#dashboardsTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.isDashboardAdding = false;

                var tableName = 'insight_dashboards';
                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.dashboardsProjectFilter = "$";
                vm.dashboardsProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isDashboardsLoading = false;
                vm.dashboardsResponse = [];
                vm.dashboardsArr = [];
                vm.selectedDashboardsArr = [];
                vm.selectedDashboardsObj = {};

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        vm.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        vm.sort = '';
                    }
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isDashboardsLoading = true;
                    vm.selectedDashboardsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'dashboards', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId'\ = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetDashboards({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjectDashboards = function (projectObj) {
                    vm.isDashboardsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetDashboards({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isDashboardsLoading = true;
                    vm.selectedDashboardsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetDashboards(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.dashboardsArr);
                        vm.previousPage = page;
                        vm.fnGetDashboards(input, false);
                    }
                };
                /*END: Search*/

                vm.fnGetDashboards = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.dashboardsResponse = _.cloneDeepWith(res);
                            if (isFirst && vm.dashboardsResponse.data && vm.dashboardsResponse.data.length) {
                                vm.totalItems = vm.dashboardsResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.dashboardsResponse.data.reverse();
                            }
                            vm.dashboardsArr = _.cloneDeepWith(vm.dashboardsResponse.data);
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isDashboardsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCheckUncheckHeader = function (dashboardsObj) {
                    angular.forEach(vm.dashboardsArr, function (obj) {
                        if (dashboardsObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindDashboards = _.find(vm.dashboardsArr, function (dashboardsObj) {
                        return dashboardsObj.isCheck === true;
                    });
                    if (isFindDashboards) {
                        vm.selectedDashboardsObj = _.cloneDeepWith(isFindDashboards);
                    } else {
                        vm.selectedDashboardsObj = {};
                    }
                };

                vm.isDashboardsObjSelected = function () {
                    return !!vm.selectedDashboardsObj && Object.keys(vm.selectedDashboardsObj).length;
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInjectDashboard = function () {
                    $uibModalInstance.close(vm.selectedDashboardsObj.id);
                };

                vm.fnInitDashboardListModal = function () {

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('customYearMonthPickerModalCtrl',
            function ($timeout, $window, $uibModalInstance, moment, selectedDateObj) {
                var vm = this;
                vm.yearArr = [];
                var todayDate = new Date();
                vm.currentYear = todayDate.getFullYear() + "";
                vm.currentMonth = todayDate.getMonth() + 1;
                vm.selectedDateObj = _.cloneDeepWith(selectedDateObj);

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnApply = function () {
                    $uibModalInstance.close(vm.selectedDateObj);
                };

                vm.fnChangeYear = function () {
                    if (vm.selectedDateObj.year === '2019' && vm.currentMonth < parseInt(vm.selectedDateObj.month)) {
                        vm.selectedDateObj.month = vm.currentMonth+'';
                    }
                };

                vm.fnInitMonthPickerModal = function () {
                    vm.yearArr.push(moment().format('YYYY'));
                    for (var i = 1; i <= 20; i++) {
                        vm.yearArr.push(moment().subtract(i, "year").format('YYYY'));
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('chartEditorModalCtrl',
            function ($scope, $timeout, $window, $uibModalInstance, highed, chartObj, csvData) {
                var vm = this;
                var newInstance;
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSaveChanges = function () {
                    $uibModalInstance.close(newInstance.getEmbeddableJSON());
                };

                vm.fnInitModal = function () {
                    $timeout(function () {
                        newInstance = highed.DrawerEditor('chartEditorModal');
                        newInstance.chart.options.setAll(chartObj);
                        newInstance.chart.data.csv(csvData);
                        $timeout(function () {
                            $('#chartEditorModal .highed-chart-frame').remove(); //eslint-disable-line
                            $('#chartEditorModal .fa-sliders').click(); //eslint-disable-line
                            $timeout(function () {
                                $("#chartEditorModal .highed-list a:last-child")[0].remove(); //eslint-disable-line
                            });
                        },250)
                    });

                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeStatisticsModalCtrl',
            function ($uibModalInstance, $uibModal, $cookies, $http, moment, amaran, AnalyticsFactory, ColorService, selectedAttribute, selectedComponent, analyticsService) {
                var vm = this;
                vm.selectedAttributeChartType = 'health';
                vm.selectedAttribute = _.cloneDeepWith(selectedAttribute);
                vm.selectedComponent = _.cloneDeepWith(selectedComponent);
                vm.selectedFilterObj = {
                    type: 'relative',
                    name: '3',
                    value: '3h',
                    units: 'hours',
                    window: '1m'
                };
                vm.healthData = [];
                vm.isAtomicHealthLoading = true;
                vm.isAtomicValueLoading = true;

                /*START: FILTER OPTIONS*/
                vm.filterOptions = [{
                    value: '1h',
                    tabIndex: 0,
                    name: '1',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3h',
                    tabIndex: 1,
                    name: '3',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '12h',
                    tabIndex: 2,
                    name: '12',
                    units: 'hours',
                    window: "1m",
                    type: 'relative'
                }, {
                    value: '3d',
                    tabIndex: 3,
                    name: '3',
                    units: 'days',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: '1w',
                    tabIndex: 4,
                    name: '1',
                    units: 'weeks',
                    window: "5m",
                    type: 'relative'
                }, {
                    value: 'Custom',
                    tabIndex: 5
                }];
                vm.chartOptions = [{
                    name: 'Area Chart',
                    icon: 'fa-area-chart',
                    tabIndex: 0
                }, {
                    name: 'Pie Chart',
                    icon: 'fa-pie-chart',
                    tabIndex: 1
                }];
                vm.selectedFilterOption = vm.filterOptions[1];
                vm.selectedFilterObj = vm.filterOptions[1];
                vm.selectedChartType = vm.chartOptions[0];
                vm.selectedAggregateFn = 'MEAN';
                /*END: FILTER OPTIONS*/
                vm.valuesArr = [];
                vm.isShowLabel = false;
                vm.attributeHealthPieData = [];
                vm.attributeValuePicData = [];
                vm.fnChangeFilterOption = function (filterOption) {
                    if ((vm.filterOptions.length - 1) === filterOption.tabIndex) {
                        vm.fnOpenDateTimeHelpModal();
                    }
                    if (vm.selectedFilterOption.tabIndex !== filterOption.tabIndex) {
                        vm.selectedFilterOption = filterOption;
                        if ((vm.filterOptions.length - 1) !== filterOption.tabIndex) {
                            vm.selectedFilterObj = filterOption;
                            vm.healthData = [];
                            vm.fnGetAnalyticsQuery();
                            vm.fnGetAttributeValue();
                        }
                    }
                };

                vm.fnChangeChartType = function (charType) {
                    if (vm.selectedChartType.tabIndex !== charType.tabIndex) {
                        vm.selectedChartType = charType;
                    }
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnGetAttributeValue = function () {
                    vm.isAtomicValueLoading = true;
                    var inputObj = {
                        "dataSets": ["ATOMIC"],
                        "nodeId": vm.selectedComponent.id,
                        "timeRange": {},
                        "attributeQuery": {
                            "attributeName": vm.selectedAttribute.name,
                            "queryType": "VALUE"
                        }
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };
                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsValueData = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if(response && response.data && response.data.data){
                                vm.analyticsValueData = response.data.data;
                            }else{
                                vm.analyticsValueData = {};
                            }
                            if (response && response.data && response.data.meta) {
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            } else {
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        vm.fnCreateAttributeValueAnalyticsData(timeStampsArr);
                    }, function error() {
                        vm.analyticsValueData = {};
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        vm.fnCreateAttributeValueAnalyticsData(timeStampsArr);
                    });
                };

                vm.fnCreateAttributeValueAnalyticsData = function (timeStampsArr) {
                    vm.atomicValuehArr = [];
                    if (vm.analyticsValueData && vm.analyticsValueData.ATOMIC && vm.analyticsValueData.ATOMIC.points) {
                        var attributeAnalyticsb64String = vm.analyticsValueData.ATOMIC.points;
                        var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAttributeValueData(attributeAnalyticsCSVString);
                        var attributePieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.attributeValueData.length) {
                            var analyticsAttrValueArr = [];
                            vm.valuesArr = tempAggregateHealthArr.attributeValuesArr.sort(function (a, b) {
                                return a - b;
                            });
                            _.forEach(tempAggregateHealthArr.attributeValueData, function (obj) {
                                analyticsAttrValueArr.push({
                                    x: obj.x,
                                    y: vm.valuesArr.indexOf(obj.y),
                                    marker: {fillColor: '#fc5425'}
                                })
                            });
                            vm.atomicValuehArr.push({
                                name: 'Attribute',
                                lineWidth: 1,
                                states: {
                                    hover: {
                                        lineWidth: 2
                                    }
                                },
                                data: analyticsAttrValueArr,
                                turboThreshold: analyticsAttrValueArr.length + 100
                            });
                            var attributePieChartString = vm.analyticsValueData.ATOMIC.summary;
                            var attributePieChartAnalyticsCSVString = analyticsService.getCSVString(attributePieChartString);
                            attributePieChartAnalyticsData = analyticsService.getAttributeValuePieData(attributePieChartAnalyticsCSVString);
                        } else {
                            attributePieChartAnalyticsData = vm.fnCreateAttributeStaticData(timeStampsArr);
                        }
                        vm.fnGeneratePieDataForComponent(attributePieChartAnalyticsData, 'value');
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAttributeStaticData(timeStampsArr);
                        vm.fnGeneratePieDataForComponent(pieChartAnalyticsData, 'value');
                    }
                    vm.isAtomicValueLoading = false;
                };

                vm.fnCreateAttributeStaticData = function (timeStampsArr) {
                    var analyticsAttrValueArr = [];
                    var attributeStaticPieData = [];
                    vm.valuesArr = [vm.selectedAttribute.value];
                    _.forEach(timeStampsArr, function (obj) {
                        analyticsAttrValueArr.push({
                            x: obj,
                            y: 0,
                            marker: {fillColor: '#fc5425'}
                        })
                    });
                    vm.atomicValuehArr.push({
                        name: 'Attribute',
                        lineWidth: 1,
                        states: {
                            hover: {
                                lineWidth: 2
                            }
                        },
                        data: analyticsAttrValueArr,
                        turboThreshold: analyticsAttrValueArr.length + 100
                    });
                    attributeStaticPieData.push({value: vm.selectedAttribute.value, percentage: 100});
                    return attributeStaticPieData;
                };

                vm.fnCreateTimeLineArr = function (startTime, endTime, value, units) {
                    var tempArr = [];
                    while (startTime < endTime) {
                        tempArr.push(startTime);
                        startTime = parseInt(moment(startTime).add(value, units).format('x'))
                    }
                    return tempArr;
                };


                vm.fnGetAnalyticsQuery = function () {
                    vm.isAtomicHealthLoading = true;
                    var inputObj = {
                        "dataSets": ["ATOMIC"],
                        "nodeId": vm.selectedComponent.id,
                        "timeRange": {},
                        "attributeQuery": {
                            "attributeName": vm.selectedAttribute.name,
                            "queryType": "HEALTH"
                        }
                    };
                    if (vm.selectedFilterObj.type === 'relative') {
                        inputObj.timeRange = {
                            relative: {
                                start: vm.selectedFilterObj.value
                            }
                        }
                    } else {
                        inputObj.timeRange = {
                            absolute: {
                                start: vm.selectedFilterObj.start,
                                stop: vm.selectedFilterObj.stop
                            }
                        }
                    }
                    var body = inputObj;
                    var headers = {
                        'Content-Type': 'application/json',
                        'x-pre-api-version': '4',
                        'authorization': 'Bearer ' + $cookies.get('phoenix')
                    };
                    var apiURL = HOST_URL.node + "/analytics/queries"; //eslint-disable-line
                    $http({
                        method: "POST",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        var timeStampsArr = [];
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            vm.analyticsData = {};
                            timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            amaran.error(response.data.message);
                        } else {
                            if(response && response.data && response.data.data){
                                vm.analyticsData = response.data.data;
                            }else{
                                vm.analyticsData = {};
                            }
                            if (response && response.data && response.data.meta) {
                                var queryStart = parseInt(moment.unix(response.data.meta.queryStart).format('x'));
                                var queryEnd = parseInt(moment.unix(response.data.meta.queryEnd).format('x'));
                                var queryResolution = parseInt(response.data.meta.queryResolution);
                                timeStampsArr = vm.fnCreateTimeLineArr(queryStart, queryEnd, queryResolution, 'seconds');
                            } else {
                                timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                            }
                        }
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateAttributeAnalyticsData(timeStampsArr);
                    }, function error() {
                        vm.analyticsData = {};
                        vm.aggregateCategoriesArr = [];
                        var startTime = parseInt(moment().subtract(parseInt(vm.selectedFilterObj.name), vm.selectedFilterObj.units).format('x'));
                        var endTime = Date.now();
                        var window = 1;
                        var units = "seconds";
                        switch (vm.selectedFilterObj.window) {
                            case "1m":
                                window = 1;
                                units = "minutes";
                                break;
                            case "5m":
                                window = 5;
                                units = "minutes";
                                break;
                            case "1h":
                                window = 1;
                                units = "hours";
                                break;
                        }
                        if (vm.selectedFilterObj.type !== 'relative') {
                            startTime = vm.selectedFilterObj.start * 1000;
                            endTime = vm.selectedFilterObj.stop * 1000;
                        }
                        var timeStampsArr = vm.fnCreateTimeLineArr(startTime, endTime, window, units);
                        _.forEach(timeStampsArr, function (timeStamp) {
                            vm.aggregateCategoriesArr.push(moment(timeStamp).format('MM/DD HH:mm'));
                        });
                        vm.fnCreateAttributeAnalyticsData(timeStampsArr);
                    });
                };

                vm.fnCreateAttributeAnalyticsData = function (timeStampsArr) {
                    vm.aggregateHealthArr = [];
                    if (vm.analyticsData && vm.analyticsData.ATOMIC && vm.analyticsData.ATOMIC.points) {
                        var attributeAnalyticsb64String = vm.analyticsData.ATOMIC.points;
                        var attributeAnalyticsCSVString = analyticsService.getCSVString(attributeAnalyticsb64String);
                        var tempAggregateHealthArr = analyticsService.getAggregateHealthData(attributeAnalyticsCSVString);
                        var attributePieChartAnalyticsData = [];
                        if (tempAggregateHealthArr.length) {
                            vm.aggregateHealthArr = tempAggregateHealthArr;
                            var attributePieChartString = vm.analyticsData.ATOMIC.summary;
                            var attributePieChartAnalyticsCSVString = analyticsService.getCSVString(attributePieChartString);
                            attributePieChartAnalyticsData = analyticsService.getAggregateHealthPieChartData(attributePieChartAnalyticsCSVString);
                        } else {
                            attributePieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        }
                        vm.fnGeneratePieDataForComponent(attributePieChartAnalyticsData, 'health');
                    } else {
                        var pieChartAnalyticsData = vm.fnCreateAggregateStaticHealth(timeStampsArr);
                        vm.fnGeneratePieDataForComponent(pieChartAnalyticsData, 'health');
                    }
                    vm.isAtomicHealthLoading = false;
                };

                vm.fnCreateAggregateStaticHealth = function (timeStampsArr) {
                    var analyticsHealthArr = [];
                    var tempIndex = 0;
                    _.forEach(timeStampsArr, function (timeStamp) {
                        var healthObj = ColorService.getHealthColorForLoop(parseInt(vm.selectedAttribute.health));
                        vm.aggregateHealthArr.push({
                            x: 0,
                            y: tempIndex,
                            value: parseInt(vm.selectedAttribute.health),
                            color: healthObj['background-color'],
                            healthObj: healthObj,
                            date: moment(timeStamp).format("MM/DD/YYYY HH:mm")
                        });
                        analyticsHealthArr.push({
                            duration: 100,
                            health: parseInt(vm.selectedAttribute.health),
                            healthObj: healthObj,
                            id: vm.selectedAttribute.id,
                            percentage: 100,
                            marker: {fillColor: healthObj['background-color']}
                        });
                        tempIndex++
                    });
                    return analyticsHealthArr;
                };

                vm.fnOpenDateTimeHelpModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html',
                        size: 'lg',
                        controller: 'analyticsDateTimeHelpModalCtrl as analyticsDateTimeModal',
                        resolve: {
                            selectedTime: function () {
                                return vm.selectedFilterObj;
                            },
                            selectedAggregateFn: function () {
                                return vm.selectedAggregateFn;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        vm.selectedFilterObj = response.selectedTime;
                        vm.selectedAggregateFn = response.selectedAggregateFn;
                        vm.healthData = [];
                        vm.fnGetAnalyticsQuery();
                        vm.fnGetAttributeValue();
                    }, function () {
                    });
                };

                vm.fnGeneratePieDataForComponent = function (healthArr, type) {
                    if (type === 'health') {
                        var pieData = [];
                        var groupedHealthObj = _.mapValues(_.groupBy(healthArr, "health"), function (v) {
                            return _.sortBy(v, "health");
                        });
                        _.forEach(groupedHealthObj, function (val, key) {
                            var totalP = 0;
                            _.forEach(val, function (valObj) {
                                totalP = totalP + valObj.percentage
                            });
                            var healthObj = ColorService.getHealthColorForLoop(key);
                            pieData.push({
                                name: healthObj.content,
                                y: totalP,
                                color: healthObj['background-color'],
                                healthTextColor: healthObj.color
                            })
                        });
                        vm.attributeHealthPieData = pieData;
                    } else {
                        pieData = [];
                        groupedHealthObj = _.mapValues(_.groupBy(healthArr, "value"), function (v) {
                            return _.sortBy(v, "value");
                        });
                        _.forEach(groupedHealthObj, function (val, key) {
                            var totalP = 0;
                            _.forEach(val, function (valObj) {
                                totalP = totalP + valObj.percentage
                            });
                            pieData.push({
                                name: key,
                                y: totalP
                            })
                        });
                        vm.attributeValuePicData = pieData;
                    }

                };

                vm.fnInitModel = function () {
                    vm.fnGetAnalyticsQuery();
                    vm.fnGetAttributeValue();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeManageIssueTemplateModalCtrl',
            function ($scope, $timeout, $window, $uibModalInstance, PermissionsService, $http, $state, $base64, $uibModal, swal, amaran, issueType, GhostObj, CommentFactory, componentObj, deviceObj, gatewayObj, IssueFactory) {
                var vm = this;
                vm.isIssueDetailsLoaded = false;
                vm.isFindIssue = false;
                vm.selectedIssueObj = {};
                vm.ghostObj = GhostObj;
                vm.componentObj = componentObj;
                vm.deviceObj = deviceObj;
                vm.gatewayObj = gatewayObj;
                vm.isIssueCreating = false;

                vm.newIssueObj = {
                    issue: {
                        title: "",
                        origin: ""
                    },
                    comment: {
                        body: ""
                    }
                };
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnViewIssue = function () {
                    $uibModalInstance.dismiss('cancel');
                    $state.go('main.issue', {
                        selectedId: vm.selectedIssueObj.id,
                        perPage: 0,
                        state: vm.selectedIssueObj.state === 'OPEN' ? 'open' : 'closed'
                    });
                };

                vm.fnCreateNewIssue = function () {
                    vm.isIssueCreating = true;
                    var inputObj = {
                        "body": vm.newIssueObj
                    };
                    IssueFactory.createIssue(inputObj)
                        .then(function () {
                            vm.isIssueCreating = false;
                            amaran.success("Issue Created Successfully.");
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            amaran.error("Issue Create was unsuccessful");
                            vm.isIssueCreating = false;
                            $uibModalInstance.dismiss('cancel');
                        })
                };

                vm.fnOpenStorageModal = function (filesObj) {
                    vm.fileUploading = true;
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/storageUploadFromIssue.html',
                        size: 'lg',
                        controller: 'storageUploadCtrl as storageUpload',
                        windowClass: 'modal-height100',
                        resolve: {
                            fileData: function () {
                                return filesObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (dataObj) {
                        if (dataObj) {
                            var string = "<img src=\"" + dataObj.extension + "\" width='25' height='25'/><a href=\"" + dataObj.url + "\" target=\"_blank\">" + filesObj.name + "</a>";
                            if (vm.newIssueObj.comment.body) {
                                vm.newIssueObj.comment.body = vm.newIssueObj.comment.body + string;
                            } else {
                                vm.newIssueObj.comment.body = string;
                            }
                        } else {
                            amaran.error("Url not available");
                        }
                        vm.fileUploading = false;
                    }, function () {
                        vm.fileUploading = false;
                        amaran.error("Upload process cancelled");
                    });
                };

                vm.uploadFiles = function (fileArrayBuffer, filesObj) {
                    vm.fileUploading = true;
                    var storagePermission = PermissionsService.getPermissions("storage:file");
                    var contentPermissionObj = PermissionsService.getPermissions("storage:content");
                    if (contentPermissionObj.List && storagePermission.Upload && (fileArrayBuffer === null || filesObj.size > 1000000)) {
                        var text = fileArrayBuffer === null ? 'The file type is not supported by tracker' : 'The file size is greater than 100Kb which exceeds the tracker limit';
                        swal({
                                title: "Do you want to upload the file to storage?",
                                text: text,
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "Upload to Storage",
                                closeOnConfirm: true,
                                showLoaderOnConfirm: false
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    swal.close();
                                    vm.fnOpenStorageModal(filesObj);
                                } else {
                                    swal.close();
                                    vm.fileUploading = false;
                                    $scope.$apply();
                                }
                            });
                    } else if (fileArrayBuffer !== null && filesObj.size < 1000000) {
                        var input = {
                            upfile: fileArrayBuffer,
                            fileName: filesObj.name
                        };
                        CommentFactory.uploadFile(input, filesObj.type)
                            .then(function (resData) {
                                vm.fileUploading = false;
                                if (resData.message) {
                                    amaran.error(resData.message);
                                } else {
                                    var string = "![" + filesObj.name + "](" + resData.basepath + resData.path + ")";
                                    if (vm.newIssueObj.comment.body) {
                                        vm.newIssueObj.comment.body = vm.newIssueObj.comment.body + string;
                                    } else {
                                        vm.newIssueObj.comment.body = string;
                                    }
                                }
                            }, function (error) {
                                vm.fileUploading = false;
                                amaran.error(error.errorMessage);
                            });
                    } else {
                        var errorMsg = fileArrayBuffer === null ? 'The file type is not supported by tracker' :
                            'The file size is greater than 100Kb which exceeds the tracker limit';
                        vm.fileUploading = false;
                        amaran.error(errorMsg);
                    }
                    $scope.$apply();
                };

                vm.fnInitModal = function () {
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    vm.filePermissionsObj = PermissionsService.getPermissions("tracker:file");
                    var originId = '';
                    if (issueType === 'component') {
                        originId = componentObj.id + ":" + GhostObj.name;
                    } else if (issueType === "device") {
                        originId = deviceObj.id + ":" + GhostObj.name;
                    } else if (issueType === "gateway") {
                        originId = gatewayObj.id + ":" + GhostObj.name;
                    }
                    if (vm.issuePermissionsObj.List) {
                        if (originId !== "") {
                            var apiURL = HOST_URL.tracker + "/issues/origin/" + originId; //eslint-disable-line
                            vm.isIssueDetailsLoaded = false;
                            $http({
                                method: "GET",
                                url: apiURL,
                                responseType: 'application/json'
                            }).then(function (response) {
                                if (response && response.data && response.data.code &&
                                    !response.data.code.toString().startsWith('20')) {
                                    vm.isFindIssue = false;
                                    var mdString = "";
                                    if (issueType === "component") {
                                        mdString = "<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns=\"http://www.w3.org/1999/xhtml\">\n" +
                                            "        <head>\n" +
                                            "            <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"/>\n" +
                                            "            <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>\n" +
                                            "            <title>ECSMon Notification</title>\n" +
                                            "        </head>\n" +
                                            "        <body bgcolor=\"#f7f7f7\"\n" +
                                            "              style=\"font-family: Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-webkit-text-size-adjust: none;width: 100% !important;margin: 0 !important;height: 100%;color: #676767\">\n" +
                                            "            " + document.getElementById('componentAttributeNotification').innerHTML + "\n" +
                                            "        </body>\n" +
                                            "        </html>";
                                        vm.newIssueObj.issue.title = 'Component ' + vm.componentObj.name + ' Attribute ' + vm.ghostObj.name + ' Observation';
                                        vm.newIssueObj.issue.origin = vm.componentObj.id + ":" + vm.ghostObj.name;
                                    } else if (issueType === "device") {
                                        mdString = "<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns=\"http://www.w3.org/1999/xhtml\">\n" +
                                            "        <head>\n" +
                                            "            <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"/>\n" +
                                            "            <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>\n" +
                                            "            <title>ECSMon Notification</title>\n" +
                                            "        </head>\n" +
                                            "        <body bgcolor=\"#f7f7f7\"\n" +
                                            "              style=\"font-family: Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-webkit-text-size-adjust: none;width: 100% !important;margin: 0 !important;height: 100%;color: #676767\">\n" +
                                            "            " + document.getElementById('deviceAttributeNotification').innerHTML + "\n" +
                                            "        </body>\n" +
                                            "        </html>";
                                        vm.newIssueObj.issue.title = 'Device ' + vm.deviceObj.name + ' Attribute ' + vm.ghostObj.name + ' Observation';
                                        vm.newIssueObj.issue.origin = vm.deviceObj.id + ":" + vm.ghostObj.name;
                                    } else if (issueType === "gateway") {
                                        mdString = "<html xmlns=\"http://www.w3.org/1999/xhtml\" xmlns=\"http://www.w3.org/1999/xhtml\">\n" +
                                            "        <head>\n" +
                                            "            <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"/>\n" +
                                            "            <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\"/>\n" +
                                            "            <title>ECSMon Notification</title>\n" +
                                            "        </head>\n" +
                                            "        <body bgcolor=\"#f7f7f7\"\n" +
                                            "              style=\"font-family: Helvetica, Arial, sans-serif;-webkit-font-smoothing: antialiased;-webkit-text-size-adjust: none;width: 100% !important;margin: 0 !important;height: 100%;color: #676767\">\n" +
                                            "            " + document.getElementById('gatewayAttributeNotification').innerHTML + "\n" +
                                            "        </body>\n" +
                                            "        </html>";
                                        vm.newIssueObj.issue.title = 'Gateway ' + vm.gatewayObj.name + ' Attribute ' + vm.ghostObj.name + ' Observation';
                                        vm.newIssueObj.issue.origin = vm.gatewayObj.id + ":" + vm.ghostObj.name;
                                    }
                                    vm.newIssueObj.comment.body = mdString;
                                } else {
                                    vm.isFindIssue = true;
                                    vm.selectedIssueObj = response.data;
                                }
                                vm.isIssueDetailsLoaded = true;
                            }, function error() {
                            });
                        } else {
                            vm.isFindIssue = false;
                            vm.isIssueDetailsLoaded = true;
                        }
                    } else {
                        vm.isFindIssue = false;
                        vm.isIssueDetailsLoaded = true;
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeRenameModalCtrl',
            function ($timeout, $uibModalInstance, $http, amaran, selectedGhostObj, ghostType, id) {
                var vm = this;
                vm.selectedGhostObj = selectedGhostObj;
                vm.ghostType = ghostType;
                vm.id = id;
                vm.newName = vm.selectedGhostObj.displayName;
                vm.isGhostUpdateCompleted = true;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isGhostUpdateCompleted = false;
                    var apiURL = HOST_URL.node; //eslint-disable-line
                    if (vm.ghostType === 'Component') {
                        apiURL = apiURL + "/devices/" + vm.id.substring(0, vm.id.lastIndexOf("-")) + "/components/" + vm.id + "/attributes/" + vm.selectedGhostObj.name;
                    } else if (vm.ghostType === 'Device') {
                        apiURL = apiURL + "/devices/" + vm.id + "/attributes/" + vm.selectedGhostObj.name;
                    } else {
                        apiURL = apiURL + "/gateways/" + vm.id + "/attributes/" + vm.selectedGhostObj.name;
                    }
                    var body = {"displayName": vm.newName};
                    var headers = {'Content-Type': 'application/json', 'x-pre-api-version': '4'};
                    $http({
                        method: "PATCH",
                        url: apiURL,
                        responseType: 'application/json',
                        headers: headers,
                        data: body
                    }).then(function (response) {
                        if (response && response.status && response.data &&
                            !response.status.toString().startsWith('20')) {
                            amaran.error(response.data.message);
                            vm.isGhostUpdateCompleted = true;
                            $uibModalInstance.dismiss('cancel');
                        } else {
                            amaran.success("Attribute renamed successfully");
                            vm.isGhostUpdateCompleted = true;
                            $uibModalInstance.close(response.data.after.displayName);
                        }
                    }, function error(error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }else{
                            amaran.error("Attribute rename was unsuccessful");
                        }
                        $uibModalInstance.dismiss('cancel');
                        vm.isGhostUpdateCompleted = true;
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('attributeManageIssueModalCtrl',
            function ($scope, $timeout, $window, $uibModalInstance, PermissionsService, $http, $state, $base64, $uibModal, swal, amaran, issueType, GhostObj, CommentFactory, componentObj, deviceObj, gatewayObj, IssueFactory) {
                var vm = this;
                vm.isIssueDetailsLoaded = false;
                vm.isFindIssue = false;
                vm.selectedIssueObj = {};
                vm.ghostObj = GhostObj;
                vm.componentObj = componentObj;
                vm.deviceObj = deviceObj;
                vm.gatewayObj = gatewayObj;
                vm.isIssueCreating = false;

                vm.newIssueObj = {
                    issue: {
                        title: "",
                        origin: ""
                    },
                    comment: {
                        body: ""
                    }
                };
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnViewIssue = function () {
                    $uibModalInstance.dismiss('cancel');
                    $state.go('main.issue', {
                        selectedId: vm.selectedIssueObj.id,
                        perPage: 0,
                        state: vm.selectedIssueObj.state === 'OPEN' ? 'open' : 'closed'
                    });
                };

                vm.fnCreateNewIssue = function () {
                    vm.isIssueCreating = true;
                    var inputObj = {
                        "body": vm.newIssueObj
                    };
                    IssueFactory.createIssue(inputObj)
                        .then(function () {
                            vm.isIssueCreating = false;
                            amaran.success("Issue Created Successfully.");
                            $uibModalInstance.dismiss('cancel');
                        }, function () {
                            amaran.error("Issue Create was unsuccessful");
                            vm.isIssueCreating = false;
                            $uibModalInstance.dismiss('cancel');
                        })
                };

                vm.fnOpenStorageModal = function (filesObj) {
                    vm.fileUploading = true;
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/storageUploadFromIssue.html',
                        size: 'lg',
                        controller: 'storageUploadCtrl as storageUpload',
                        windowClass: 'modal-height100',
                        resolve: {
                            fileData: function () {
                                return filesObj;
                            }
                        }
                    });

                    modalInstance.result.then(function (dataObj) {
                        if (dataObj) {
                            var string = "<img src=\"" + dataObj.extension + "\" width='25' height='25'/><a href=\"" + dataObj.url + "\" target=\"_blank\">" + filesObj.name + "</a>";
                            if (vm.newIssueObj.comment.body) {
                                vm.newIssueObj.comment.body = vm.newIssueObj.comment.body + string;
                            } else {
                                vm.newIssueObj.comment.body = string;
                            }
                        } else {
                            amaran.error("Url not available");
                        }
                        vm.fileUploading = false;
                    }, function () {
                        vm.fileUploading = false;
                        amaran.error("Upload process cancelled");
                    });
                };

                vm.uploadFiles = function (fileArrayBuffer, filesObj) {
                    vm.fileUploading = true;
                    var storagePermission = PermissionsService.getPermissions("storage:file");
                    var contentPermissionObj = PermissionsService.getPermissions("storage:content");
                    if (contentPermissionObj.List && storagePermission.Upload && (fileArrayBuffer === null || filesObj.size > 1000000)) {
                        var text = fileArrayBuffer === null ? 'The file type is not supported by tracker' : 'The file size is greater than 100Kb which exceeds the tracker limit';
                        swal({
                                title: "Do you want to upload the file to storage?",
                                text: text,
                                type: "warning",
                                html: true,
                                showCancelButton: true,
                                confirmButtonText: "Upload to Storage",
                                closeOnConfirm: true,
                                showLoaderOnConfirm: false
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    swal.close();
                                    vm.fnOpenStorageModal(filesObj);
                                } else {
                                    swal.close();
                                    vm.fileUploading = false;
                                    $scope.$apply();
                                }
                            });
                    } else if (fileArrayBuffer !== null && filesObj.size < 1000000) {
                        var input = {
                            upfile: fileArrayBuffer,
                            fileName: filesObj.name
                        };
                        CommentFactory.uploadFile(input, filesObj.type)
                            .then(function (resData) {
                                vm.fileUploading = false;
                                if (resData.message) {
                                    amaran.error(resData.message);
                                } else {
                                    var string = "![" + filesObj.name + "](" + resData.basepath + resData.path + ")";
                                    if (vm.newIssueObj.comment.body) {
                                        vm.newIssueObj.comment.body = vm.newIssueObj.comment.body + string;
                                    } else {
                                        vm.newIssueObj.comment.body = string;
                                    }
                                }
                            }, function (error) {
                                vm.fileUploading = false;
                                amaran.error(error.errorMessage);
                            });
                    } else {
                        var errorMsg = fileArrayBuffer === null ? 'The file type is not supported by tracker' :
                            'The file size is greater than 100Kb which exceeds the tracker limit';
                        vm.fileUploading = false;
                        amaran.error(errorMsg);
                    }
                    $scope.$apply();
                };

                vm.fnInitModal = function () {
                    vm.issuePermissionsObj = PermissionsService.getPermissions("tracker:issue");
                    vm.filePermissionsObj = PermissionsService.getPermissions("tracker:file");
                    var originId = '';
                    if (issueType === 'component') {
                        originId = componentObj.id + ":" + GhostObj.name;
                    }
                    if (vm.issuePermissionsObj.List) {
                        if (originId !== "") {
                            var apiURL = HOST_URL.tracker + "/issues/origin/" + originId; //eslint-disable-line
                            vm.isIssueDetailsLoaded = false;
                            $http({
                                method: "GET",
                                url: apiURL,
                                responseType: 'application/json'
                            }).then(function (response) {
                                if (response && response.data && response.data.code &&
                                    !response.data.code.toString().startsWith('20')) {
                                    vm.isFindIssue = false;
                                    var mdString = "";
                                    if (issueType === "component") {
                                        mdString = "<h2>The value of `" + vm.ghostObj.name + "` changed to `" + vm.ghostObj.value + "` !</h2>\n" +
                                            "The value of `" + vm.ghostObj.name + "` on **" + vm.componentObj.name + "** on your **" + vm.deviceObj.name + "** system changed to `" + vm.ghostObj.value + "`." +
                                            "<br/><br/>\n" +
                                            "**Gateway**<br/>\n" +
                                            "Name: " + vm.gatewayObj.name + "<br/>\n" +
                                            "Connection: " + vm.gatewayObj.connection + "<br/>\n" +
                                            "Health: " + vm.gatewayObj.health + "<br/>\n" +
                                            "ID: " + vm.gatewayObj.id + "<br/>\n" +
                                            "<br/>\n" +
                                            "**Device**<br/>\n" +
                                            "Name: " + vm.deviceObj.name + "<br/> \n" +
                                            "Model: " + vm.deviceObj.oem + " " + vm.deviceObj.model + " (v" + vm.deviceObj.version + ")<br/>\n" +
                                            "Connection: " + vm.deviceObj.connection + "<br/>\n" +
                                            "Health: " + vm.deviceObj.health + "<br/>\n" +
                                            "ID: " + vm.deviceObj.id + "<br/>\n" +
                                            "<br>\n" +
                                            "**Component**<br/>\n" +
                                            "Name: " + vm.componentObj.name + "<br/>\n" +
                                            "Index: " + vm.componentObj.index + "<br/>\n" +
                                            "Health: " + vm.componentObj.health + "<br/>\n" +
                                            "ID: " + vm.componentObj.id + "<br/>\n" +
                                            "<br/>\n" +
                                            "Attribute: `" + vm.ghostObj.name + "`<br/>\n" +
                                            "Value: `" + vm.ghostObj.value + "`\n";
                                        vm.newIssueObj.issue.title = 'Component ' + vm.componentObj.name + ' Attribute ' + vm.ghostObj.name + ' Observation';
                                        vm.newIssueObj.issue.origin = vm.componentObj.id + ":" + vm.ghostObj.name;
                                    }
                                    vm.newIssueObj.comment.body = mdString;
                                } else {
                                    vm.isFindIssue = true;
                                    vm.selectedIssueObj = response.data;
                                }
                                vm.isIssueDetailsLoaded = true;
                            }, function error() {
                            });
                        } else {
                            vm.isFindIssue = false;
                            vm.isIssueDetailsLoaded = true;
                        }
                    } else {
                        vm.isFindIssue = false;
                        vm.isIssueDetailsLoaded = true;
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('analyticsDateTimeHelpModalCtrl',
            function ($uibModalInstance, $timeout, $scope, TimezoneOptionArrService, moment, selectedTime, selectedAggregateFn) {
                var vm = this;
                vm.selectedTab = 2;
                vm.relativeTimeOptionsArr = [
                    {
                        name: "Minutes",
                        options: [
                            {
                                name: "1",
                                window: "",
                                value: "1m",
                                units: "minutes"
                            },
                            {
                                name: "3",
                                window: "1m",
                                value: "3m",
                                units: "minutes"
                            },
                            {
                                name: "5",
                                window: "1m",
                                value: "5m",
                                units: "minutes"
                            },
                            {
                                name: "15",
                                window: "1m",
                                value: "15m",
                                units: "minutes"
                            },
                            {
                                name: "30",
                                window: "1m",
                                value: "30m",
                                units: "minutes"
                            },
                            {
                                name: "45",
                                window: "1m",
                                value: "45m",
                                units: "minutes"
                            }
                        ]
                    },
                    {
                        name: "Hours",
                        options: [
                            {
                                name: "1",
                                window: "1m",
                                value: "1h",
                                units: "hours"
                            },
                            {
                                name: "2",
                                window: "1m",
                                value: "2h",
                                units: "hours"
                            },
                            {
                                name: "3",
                                window: "1m",
                                value: "3h",
                                units: "hours"
                            },
                            {
                                name: "6",
                                window: "1m",
                                value: "6h",
                                units: "hours"
                            },
                            {
                                name: "8",
                                window: "1m",
                                value: "8h",
                                units: "hours"
                            },
                            {
                                name: "12",
                                window: "1m",
                                value: "12h",
                                units: "hours"
                            }
                        ]
                    },
                    {
                        name: "Day",
                        options: [
                            {
                                name: "1",
                                window: "1m",
                                value: "1d",
                                units: "days"
                            },
                            {
                                name: "2",
                                window: "5m",
                                value: "2d",
                                units: "days"
                            },
                            {
                                name: "3",
                                window: "5m",
                                value: "3d",
                                units: "days"
                            },
                            {
                                name: "4",
                                window: "5m",
                                value: "4d",
                                units: "days"
                            },
                            {
                                name: "5",
                                window: "5m",
                                value: "5d",
                                units: "days"
                            },
                            {
                                name: "6",
                                window: "5m",
                                value: "6d",
                                units: "days"
                            }
                        ]
                    },
                    {
                        name: "Weeks",
                        options: [
                            {
                                name: "1",
                                window: "5m",
                                value: "1w",
                                units: "weeks"
                            },
                            {
                                name: "2",
                                window: "5m",
                                value: "2w",
                                units: "weeks"
                            },
                            {
                                name: "4",
                                window: "1h",
                                value: "4w",
                                units: "weeks"
                            },
                            {
                                name: "6",
                                window: "1h",
                                value: "6w",
                                units: "weeks"
                            }
                        ]
                    },
                    {
                        name: "Months",
                        options: [
                            {
                                name: "1",
                                window: "1h",
                                value: "4w",
                                units: "months"
                            },
                            {
                                name: "3",
                                window: "1h",
                                value: "13w",
                                units: "months"
                            },
                            {
                                name: "6",
                                window: "1h",
                                value: "26w",
                                units: "months"
                            },
                            {
                                name: "12",
                                window: "1h",
                                value: "52w",
                                units: "months"
                            },
                            {
                                name: "15",
                                window: "1h",
                                value: "65w",
                                units: "months"
                            }
                        ]
                    }
                ];
                vm.tabs = [{
                    title: 'Absolute',
                    tabIndex: 1,
                    templateUrl: ''
                }, {
                    title: 'Relative',
                    tabIndex: 2,
                    templateUrl: ''
                }];
                vm.aggregateFunctionOptions = [{
                    name: 'MEAN',
                    isCheck: false
                }, {
                    name: 'MAX',
                    isCheck: false
                }, {
                    name: 'MIN',
                    isCheck: false
                }];
                vm.startDate = '';
                vm.startTime = '00:00:00';
                vm.endDate = moment().format('YYYY/MM/DD');
                vm.endTime = '23:59:59';
                vm.selectedTimeZone = moment.tz.guess();
                vm.timeZoneArr = TimezoneOptionArrService.getTimezoneOptionArr();
                vm.startDateIsValid = true;
                vm.endDateIsValid = true;
                vm.dateRangeIsNotValid = true;
                vm.selectedTime = selectedTime;
                vm.startTimeIsValid = true;
                vm.endTimeIsValid = true;
                vm.isRelativeAdvancedView = false;
                vm.isAbsoluteAdvancedView = false;
                var todayDate = moment().format('MM/DD/YYYY').split("/");

                vm.fnClose = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnTabSelected = function(tab) {
                    vm.isRelativeAdvancedView = false;
                    vm.isAbsoluteAdvancedView = false;
                    vm.selectedTab = tab.tabIndex
                };

                vm.fnCheckUncheckHeader = function (aggOption) {
                    aggOption.isCheck = true;
                    _.forEach(vm.aggregateFunctionOptions, function (opt) {
                        if (opt.name !== aggOption.name) {
                            opt.isCheck = false;
                        }
                    })
                };

                vm.fnApplyFilter = function () {
                    var selectedAggregateIndex = _.findIndex(vm.aggregateFunctionOptions, {isCheck: true});
                    if (vm.selectedTab === 2) {
                        $uibModalInstance.close({selectedTime: vm.selectedTime, selectedAggregateFn: vm.aggregateFunctionOptions[selectedAggregateIndex].name});
                    } else {
                        var startTime = moment.tz(moment(vm.startDate).format('YYYY-MM-DD') + " " + vm.startTime, vm.selectedTimeZone).utc().format();
                        var endTime = moment.tz(moment(vm.endDate).format('YYYY-MM-DD') + " " + vm.endTime, vm.selectedTimeZone).utc().format();
                        var diff = moment(moment(vm.endDate).format('DD/MM/YYYY') + " " + vm.endTime, "DD/MM/YYYY HH:mm:ss").diff(moment(moment(vm.startDate).format('DD/MM/YYYY') + " " + vm.startTime, "DD/MM/YYYY HH:mm:ss"), 'hours');
                        var window = '';
                        if (diff > 1 && diff < 12) { // "> 1h && < 12h"
                            window = '1m';
                        } else if (diff >= 12 && diff < 24) { // ">= 12h && < 1d"
                            window = '1m';
                        } else if (diff >= 24 && diff < 168) { // ">= 1d && < 1w"
                            window = '5m';
                        } else if (diff >= 168 && diff < 672) { // ">= 1w && < 4w"
                            window = '5m';
                        } else if (diff >= 672) { // ">= 4w"
                            window = '1h';
                        }
                        vm.selectedTime = {
                            type: "absolute",
                            start: moment(Date.parse(startTime)).unix(),
                            stop: moment(Date.parse(endTime)).unix(),
                            window: window
                        };
                        $uibModalInstance.close({selectedTime: vm.selectedTime, selectedAggregateFn: vm.aggregateFunctionOptions[selectedAggregateIndex].name});
                    }

                };

                vm.fnChangeStartDate = function () {
                    var startDate = moment(vm.startDate).format('MM/DD/YYYY').split("/");
                    var dateOne = new Date(startDate[2], startDate[0], startDate[1]); //Year, Month, Day
                    var dateTwo = new Date(todayDate[2], todayDate[0], todayDate[1]); //Year, Month, Day
                    if (startDate.length === 3 && dateOne <= dateTwo) {
                        vm.startDateIsValid = true;
                        vm.fnCheckDateRangeValidation();
                        $('#daterangepicker1').data('daterangepicker').setStartDate(moment(vm.startDate).format('MM/DD/YYYY'));//eslint-disable-line
                        $('#daterangepicker1').data('daterangepicker').updateView();//eslint-disable-line
                    } else {
                        vm.startDateIsValid = false;
                    }
                };

                vm.fnChangeEndDate = function () {
                    var endDate = moment(vm.endDate).format('MM/DD/YYYY').split("/");
                    var dateOne = new Date(endDate[2], endDate[0], endDate[1]); //Year, Month, Day
                    var dateTwo = new Date(todayDate[2], todayDate[0], todayDate[1]); //Year, Month, Day
                    if (endDate.length === 3 && dateOne <= dateTwo) {
                        vm.endDateIsValid = true;
                        vm.fnCheckDateRangeValidation();
                        $('#daterangepicker1').data('daterangepicker').setEndDate(moment(vm.endDate).format('MM/DD/YYYY'));//eslint-disable-line
                        $('#daterangepicker1').data('daterangepicker').updateView();//eslint-disable-line
                    } else {
                        vm.endDateIsValid = false;
                    }
                };

                vm.fnCheckDateRangeValidation = function () {
                    vm.dateRangeIsNotValid = !!check_date_period(moment(vm.startDate).format('DD/MM/YYYY'), moment(vm.endDate).format('DD/MM/YYYY'));
                };

                function check_date_period(from, to) {
                    var result = false;
                    var yearFrom, yearTo, monthFrom, monthTo, dayFrom, dayTo;
                    var mySplit = [];
                    mySplit = from.split("/");
                    if (mySplit.length === 3) {
                        yearFrom = mySplit[2];
                        monthFrom = mySplit[1];
                        dayFrom = mySplit[0];
                    } else {
                        return false;
                    }
                    mySplit = to.split("/");
                    if (mySplit.length === 3) {
                        yearTo = mySplit[2];
                        monthTo = mySplit[1];
                        dayTo = mySplit[0];
                    } else {
                        return false;
                    }
                    // FINALLY: Compare dates
                    // Note: 00 is month i.e. January
                    monthFrom--;
                    if (dayTo !== 0) {
                        monthTo--
                    }
                    var dateOne = new Date(yearFrom, monthFrom, dayFrom); //Year, Month, Day
                    var dateTwo = new Date(yearTo, monthTo, dayTo); //Year, Month, Day
                    if (dateOne < dateTwo) {
                        result = true;
                    }
                    return result;
                }

                vm.fnSetRelativeTime = function (obj) {
                    vm.selectedTime = {
                        type: "relative",
                        name: obj.name,
                        window: obj.window,
                        value: obj.value,
                        units: obj.units
                    }
                };

                vm.fnCheckStartTime = function () {
                    vm.startTimeIsValid = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]:[0-5][0-9]$/.test(vm.startTime);
                };

                vm.fnCheckEndTime = function () {
                    vm.endTimeIsValid = /^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]:[0-5][0-9]$/.test(vm.endTime);
                };

                vm.fnInitAnalyticsDateTimeModal = function () {
                    var selectedAggregateIndex = _.findIndex(vm.aggregateFunctionOptions, {name: selectedAggregateFn});
                    if (selectedAggregateIndex !== -1) {
                        vm.aggregateFunctionOptions[selectedAggregateIndex].isCheck = true;
                    } else {
                        vm.aggregateFunctionOptions[0].isCheck = true;
                    }
                    $timeout(function () {
                        vm.selectedTab = 2;
                        var picker = $('#daterangepicker1').daterangepicker({//eslint-disable-line
                            "parentEl": "#daterangepicker1-container",
                            "autoApply": true,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days')
                        });
                        // range update listener
                        picker.on('apply.daterangepicker', function (ev, picker) {//eslint-disable-line
                            vm.startDate = picker.startDate.format('YYYY/MM/DD');
                            vm.endDate = picker.endDate.format('YYYY/MM/DD');
                            vm.fnCheckDateRangeValidation();
                            $scope.$apply();
                        });
                        vm.startDate = moment().startOf('month').format('YYYY/MM/DD');
                        vm.endTime = moment().format('HH:mm:ss');
                        picker.data('daterangepicker').hide = function () {
                        };
                        picker.data('daterangepicker').show();
                        $timeout(function () {
                            $('#daterangepicker1').data('daterangepicker').setStartDate(moment().startOf('month').format('MM/DD/YYYY'));//eslint-disable-line
                            $('#daterangepicker1').data('daterangepicker').updateView();//eslint-disable-line
                        });
                        picker.data('daterangepicker').updateView();
                        if (vm.selectedTime && vm.selectedTime.type === 'absolute') {
                            vm.selectedTab = 1;
                            var seletedStartDateTime = moment.unix(vm.selectedTime.start).format("YYYY/MM/DD HH:mm:ss");
                            var seletedEndDateTime = moment.unix(vm.selectedTime.stop).format("YYYY/MM/DD HH:mm:ss");
                            vm.startDate = seletedStartDateTime.split(" ")[0];
                            vm.endDate = seletedEndDateTime.split(" ")[0];
                            vm.startTime = seletedStartDateTime.split(" ")[1];
                            vm.endTime = seletedEndDateTime.split(" ")[1];
                            $timeout(function () {
                                $('#daterangepicker1').data('daterangepicker').setStartDate(moment(vm.startDate).format('MM/DD/YYYY'));//eslint-disable-line
                                $('#daterangepicker1').data('daterangepicker').setEndDate(moment(vm.endDate).format('MM/DD/YYYY'));//eslint-disable-line
                                $('#daterangepicker1').data('daterangepicker').updateView();//eslint-disable-line
                            });
                        }
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('advancedSearchModalCtrl',
            function ($timeout, $window, $uibModalInstance, typesArr, gatewaysArr, tagsArr, sortString, ColorService) {
                var vm = this;
                vm.healthData = ColorService.fnGetHealthData();
                vm.typesArr = _.cloneDeepWith(typesArr);
                vm.sortString = _.cloneDeepWith(sortString);
                vm.gatewaysArr = _.cloneDeepWith(gatewaysArr);
                vm.connectionArr = [
                    {
                        name: "CONNECTED",
                        isCheck: false
                    },
                    {
                        name: "DISCONNECTED",
                        isCheck: false
                    }
                ];
                vm.phaseArr = [
                    {
                        name: "PROVISIONING",
                        isCheck: false
                    },
                    {
                        name: "PROVISIONED",
                        isCheck: false
                    }, {
                        name: "COMMISSIONING",
                        isCheck: false
                    },
                    {
                        name: "COMMISSIONED",
                        isCheck: false
                    },
                    {
                        name: "PRODUCTION",
                        isCheck: false
                    }, {
                        name: "DECOMMISSIONING",
                        isCheck: false
                    }, {
                        name: "DECOMMISSIONED",
                        isCheck: false
                    }
                ];
                vm.searchArr = [];
                vm.tagsArr = _.cloneDeepWith(tagsArr);
                vm.healthType = '';
                vm.health = '';
                vm.oemArr = [];
                vm.modelArr = [];
                vm.newGatewayArr = [];
                vm.selectedTab = 1;
                vm.tabs = [
                    {
                        title: 'Health',
                        tabIndex: 1
                    },
                    {
                        title: 'Connection',
                        tabIndex: 2
                    },
                    {
                        title: 'Gateway',
                        tabIndex: 3
                    },
                    {
                        title: 'OEM',
                        tabIndex: 4
                    },
                    {
                        title: 'Model',
                        tabIndex: 5
                    },
                    {
                        title: 'Phase',
                        tabIndex: 6
                    },
                    {
                        title: 'Sort',
                        tabIndex: 7
                    }
                ];
                vm.gatewayFilter = "$";
                vm.gatewaySearch = {$: ''};
                vm.oemFilter = "$";
                vm.oemSearch = {$: ''};
                vm.modelFilter = "$";
                vm.modelSearch = {$: ''};
                vm.isHealthMinError = false;
                vm.isHealthMaxError = false;
                vm.isHealthString = false;
                vm.isHealthFind = false;
                vm.findHealthObj = {};
                vm.slider = {
                    minValue: 100,
                    maxValue: 599,
                    options: {
                        floor: 100,
                        ceil: 599,
                        step: 1
                    }
                };
                vm.sortFieldArr = [
                    {name: 'id', displayName: 'id', isDisplay: true},
                    {name: 'name', displayName: 'Name', isDisplay: true},
                    {name: 'description', displayName: 'Description', isDisplay: true},
                    {name: 'phase', displayName: 'Phase', isDisplay: true},
                    {name: 'health', displayName: 'Health', isDisplay: true},
                    {name: 'version', displayName: 'Version', isDisplay: true},
                    {name: 'mode', displayName: 'Mode', isDisplay: true},
                    {name: 'oem', displayName: 'OEM', isDisplay: true},
                    {name: 'typeid', displayName: 'Type Id', isDisplay: true},
                    {name: 'connection', displayName: 'Connection', isDisplay: true},
                    {name: 'location', displayName: 'Location', isDisplay: true},
                    {name: 'model', displayName: 'Model', isDisplay: true},
                    {name: 'gatewayid', displayName: 'Gateway Id', isDisplay: true}
                ];
                vm.sortOperator = [
                    {name: 'asc', displayName: 'Ascending'},
                    {name: 'desc', displayName: 'Descending'}
                ];
                vm.selectedSortField = '';
                vm.selectedSortOperator = '';
                vm.filterSortArr = [];
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnCheckHealthInputValue = function () {
                    if (vm.health && vm.health.toString().length) {
                        if (isNaN(vm.health)) {
                            vm.isHealthString = true;
                            var isFindObj = {};
                            _.forEach(vm.healthData, function (healthData) {
                                if (healthData.name.toLowerCase() === vm.health.toLowerCase()) {
                                    isFindObj = healthData;
                                    return false;
                                }
                            });
                            if (Object.keys(isFindObj).length) {
                                vm.findHealthObj = isFindObj;
                                vm.isHealthFind = true;
                            } else {
                                vm.findHealthObj = isFindObj;
                                vm.isHealthFind = false;
                            }
                        } else {
                            vm.isHealthMinError = vm.health < 100;
                            vm.isHealthMaxError = vm.health > 599;
                            if (vm.health >= 100 && vm.health <= 599) {
                                vm.isHealthMinError = false;
                                vm.isHealthMaxError = false;
                            }
                            vm.isHealthString = false;
                            vm.isHealthFind = false;
                        }
                    } else {
                        vm.isHealthString = false;
                        vm.isHealthFind = false;
                        vm.isHealthMinError = false;
                        vm.isHealthMaxError = false;
                        vm.isHealthFind = false;
                    }
                };

                vm.fnApplySearch = function () {
                    _.forEach(vm.connectionArr, function (connectionObj) {
                        if (connectionObj.isCheck === true) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "connection term: " + connectionObj.name.toLowerCase(),
                                    selectedField: "connection",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: connectionObj.name.toLowerCase()
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or connection term: " + connectionObj.name,
                                    selectedConnector: "or",
                                    selectedField: "connection",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: connectionObj.name.toLowerCase()
                                })
                            }
                        }
                    });
                    _.forEach(vm.phaseArr, function (phaseObj) {
                        if (phaseObj.isCheck === true) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "phase term: " + phaseObj.name.toLowerCase(),
                                    selectedField: "phase",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: phaseObj.name.toLowerCase()
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or phase term: " + phaseObj.name.toLowerCase(),
                                    selectedConnector: "or",
                                    selectedField: "phase",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: phaseObj.name.toLowerCase()
                                })
                            }
                        }
                    });
                    if (vm.healthType === 'healthRange') {
                        if (vm.searchArr.length === 0) {
                            vm.searchArr.push({
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                name: "health range: [" + vm.slider.minValue + "," + vm.slider.maxValue + "]",
                                selectedField: "health",
                                selectedFilter: {
                                    operatorName: "range",
                                    operator: "range"
                                },
                                searchText: "[" + vm.slider.minValue + "," + vm.slider.maxValue + "]"
                            })
                        } else {
                            vm.searchArr.push({
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                name: "or health range: [" + vm.slider.minValue + "," + vm.slider.maxValue + "]",
                                selectedConnector: "or",
                                selectedField: "health",
                                selectedFilter: {
                                    operatorName: "range",
                                    operator: "range"
                                },
                                searchText: "[" + vm.slider.minValue + "," + vm.slider.maxValue + "]"
                            })
                        }
                    } else if (vm.healthType === 'specificHealth') {
                        var health = '';
                        if (vm.isHealthFind) {
                            health = vm.findHealthObj.code;
                        } else {
                            if (vm.isHealthMinError === false && vm.isHealthMaxError === false && vm.health && vm.health.length && !isNaN(vm.health)) {
                                if (vm.health >= 100 && vm.health <= 599) {
                                    health = vm.health
                                }
                            }
                        }
                        if (health && health.toString().length) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "term health: " + health,
                                    selectedField: "health",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: health
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or term health: " + health,
                                    selectedConnector: "or",
                                    selectedField: "health",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: health
                                })
                            }
                        }
                    }
                    _.forEach(vm.oemArr, function (oemObj) {
                        if (oemObj.isCheck === true) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "oem term: " + oemObj.name.toLowerCase(),
                                    selectedField: "oem",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: oemObj.name.toLowerCase()
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or oem term: " + oemObj.name.toLowerCase(),
                                    selectedConnector: "or",
                                    selectedField: "oem",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: oemObj.name.toLowerCase()
                                })
                            }
                        }
                    });
                    _.forEach(vm.modelArr, function (modelObj) {
                        if (modelObj.isCheck === true) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "model term: " + modelObj.name.toLowerCase(),
                                    selectedField: "model",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: modelObj.name.toLowerCase()
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or model term: " + modelObj.name.toLowerCase(),
                                    selectedConnector: "or",
                                    selectedField: "model",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: modelObj.name.toLowerCase()
                                })
                            }
                        }
                    });
                    _.forEach(vm.newGatewayArr, function (gatewayObj) {
                        if (gatewayObj.isCheck === true) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "gatewayId term: " + gatewayObj.id,
                                    selectedField: "gatewayid",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: gatewayObj.id
                                })
                            } else {
                                vm.searchArr.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "or gatewayId term: " + gatewayObj.id,
                                    selectedConnector: "or",
                                    selectedField: "gatewayid",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: gatewayObj.id
                                })
                            }
                        }
                    });
                    $uibModalInstance.close([vm.searchArr, vm.filterSortArr]);
                };

                vm.fnAddSortFilter = function () {
                    var isFind = _.find(vm.sortFieldArr, {name: vm.selectedSortField.name});
                    if (isFind) {
                        isFind.isDisplay = false;
                        vm.filterSortArr.push({
                            sortFieldName: _.cloneDeep(vm.selectedSortField.name),
                            sortFieldDisplayName: _.cloneDeep(vm.selectedSortField.displayName),
                            sortOperatorName: _.cloneDeep(vm.selectedSortOperator.name),
                            sortOperatorDisplayName: _.cloneDeep(vm.selectedSortOperator.displayName)
                        });
                        vm.selectedSortField = '';
                        vm.selectedSortOperator = '';
                    }
                };

                vm.fnRemoveSortFilter = function (index, filterSortArr) {
                    var isFind = _.find(vm.sortFieldArr, {name: filterSortArr.sortFieldName});
                    if (isFind) {
                        isFind.isDisplay = true;
                    }
                    vm.filterSortArr.splice(index, 1);
                };

                vm.fnInitSearch = function () {
                    _.forEach(vm.typesArr, function (typeObj) {
                        var isFindOem = _.findIndex(vm.oemArr, function (o) {
                            return o.name === typeObj.oem;
                        });
                        if (isFindOem === -1) {
                            vm.oemArr.push({name: typeObj.oem, isCheck: false});
                        }
                        var isFindModel = _.findIndex(vm.modelArr, function (o) {
                            return o.name === typeObj.model;
                        });
                        if (isFindModel === -1) {
                            vm.modelArr.push({name: typeObj.model, isCheck: false});
                        }
                    });
                    _.forEach(vm.gatewaysArr, function (gatewayObj) {
                        vm.newGatewayArr.push({name: gatewayObj.name, id: gatewayObj.id, isCheck: false});
                    })
                    _.forEach(vm.tagsArr, function (tagObj) {
                        if (tagObj.selectedField === 'connection') {
                            if (tagObj.searchText === 'connected') {
                                vm.connectionArr[0].isCheck = true;
                            } else {
                                vm.connectionArr[1].isCheck = true;
                            }
                        }
                        if (tagObj.selectedField === 'health') {
                            if (tagObj.selectedFilter.operator === 'range') {
                                vm.healthType = 'healthRange';
                                vm.slider.minValue = angular.fromJson(tagObj.searchText)[0];
                                vm.slider.maxValue = angular.fromJson(tagObj.searchText)[1];
                            } else {
                                vm.healthType = 'specificHealth';
                                vm.health = tagObj.searchText;
                            }
                        }
                        if (tagObj.selectedField === 'oem') {
                            var isFindOEM = _.find(vm.oemArr, function (oemObj) {
                                if (oemObj.name.toLowerCase() === tagObj.searchText) {
                                    return oemObj;
                                }
                            });
                            if (isFindOEM) {
                                isFindOEM.isCheck = true;
                            }
                        }
                        if (tagObj.selectedField === 'model') {
                            var isFindModel = _.find(vm.modelArr, function (modelObj) {
                                if (modelObj.name.toLowerCase() === tagObj.searchText) {
                                    return modelObj;
                                }
                            });
                            if (isFindModel) {
                                isFindModel.isCheck = true;
                            }
                        }
                        if (tagObj.selectedField === 'gatewayid') {
                            var isFindGateway = _.find(vm.newGatewayArr, function (newGatewayObj) {
                                if (newGatewayObj.id === tagObj.searchText) {
                                    return newGatewayObj;
                                }
                            });
                            if (isFindGateway) {
                                isFindGateway.isCheck = true;
                            }
                        }
                        if (tagObj.selectedField === 'phase') {
                            var isFindPhase = _.find(vm.phaseArr, function (phaseObj) {
                                if (phaseObj.name.toLowerCase() === tagObj.searchText) {
                                    return phaseObj;
                                }
                            });
                            if (isFindPhase) {
                                isFindPhase.isCheck = true;
                            }
                        }
                        if (angular.isUndefined(tagObj.selectedField)) {
                            if (vm.searchArr.length === 0) {
                                vm.searchArr.push({
                                    id: tagObj.id,
                                    name: "Keyword: " + tagObj.searchText,
                                    searchText: tagObj.searchText
                                })
                            } else {
                                vm.searchArr.push({
                                    id: tagObj.id,
                                    name: "or Keyword: " + tagObj.searchText,
                                    selectedConnector: "or",
                                    searchText: tagObj.searchText
                                })
                            }
                        }
                    })
                    if (vm.sortString && vm.sortString.length) {
                        var tempSortArr = vm.sortString.split(',');
                        _.forEach(tempSortArr, function (tempString) {
                            var sortString = tempString.split(' ');
                            var isFind = _.find(vm.sortFieldArr, {name: sortString[0]});
                            if (isFind) {
                                isFind.isDisplay = false;
                                vm.filterSortArr.push({
                                    sortFieldName: _.cloneDeep(sortString[0]),
                                    sortFieldDisplayName: _.cloneDeep(isFind.displayName),
                                    sortOperatorName: _.cloneDeep(sortString[1]),
                                    sortOperatorDisplayName: _.cloneDeep(sortString[1] === 'desc' ? 'Descending' : 'Ascending')
                                });
                            }
                        })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('CreditCardInfoCtrl',
            function ($uibModalInstance) {
                var vm = this;
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('workflowFlow', fnWorkflowFlow);

    /** @ngInject */
    function fnWorkflowFlow() {
        return {
            restrict: 'EA',
            scope: {
                isWorkflowCreateMode: '=',
                cId: '=',
                isCalledFromAddBranch: '=',
                workflowHierarchyObj: '=',
                totalChoiceCount:'=',
                workflowFlowObj: '=',
                fnGetStateDetail: '&',
                fnSetChoiceLineConnectionConfig: '&',
                fnRenameWorkflowStateName: '&',
                fnRemoveWorkflowFlowState: '&',
                fnOpenFlowStateConfigModal: '&',
                fnAddNewStateInput: '&',
                fnAddExistingStateInput: '&',
                fnInjectExistingState: '&',
                fnAddNewErrorFlow:'&',
                selectedTab: "=",
                fnRemoveOnErrorFlow: "&"
            },
            templateUrl: "app/components/directives/workflowFlow/workflowFlow.html",
            link: function ($scope) {
                $scope.fnGetStateInfo = function (workflowHierarchyObj) {
                    return $scope.fnGetStateDetail({workflowHierarchyObj: workflowHierarchyObj});
                };

                $scope.fnSetChoiceConnectionConfig = function (currentWorkflowHierarchyObj, parentObj) {
                    return $scope.fnSetChoiceLineConnectionConfig({
                        currentWorkflowHierarchyObj: currentWorkflowHierarchyObj,
                        parentObj: parentObj
                    });
                };

                $scope.fnGetBranchesStatusIcon = function (choiceId, stateId) {
                    var selectedFlowObject = {};
                    if($scope.selectedTab === 1){
                        selectedFlowObject = _.find($scope.workflowFlowObj.tasks, {uid: choiceId});
                    }else{
                        selectedFlowObject = _.find($scope.workflowFlowObj, {uid: choiceId});
                    }
                    if (selectedFlowObject) {
                        var selectedBarnche = _.find(selectedFlowObject.connect.branches, {'on-pass': stateId});
                        if (selectedBarnche && selectedBarnche.logic && selectedBarnche.logic.expression && selectedBarnche.logic.expression.rules && selectedBarnche.logic.expression.rules.length) {
                            return 'setting-success';
                        } else {
                            return 'setting-warning';
                        }
                    }
                };

                $scope.fnRenameWorkflowState = function (workflowHierarchyObj) {
                    return $scope.fnRenameWorkflowStateName({workflowHierarchyObj: workflowHierarchyObj});
                };

                $scope.fnRemoveWorkflowFlow = function (uuid, parentObj, workflowHierarchyObj) {
                    return $scope.fnRemoveWorkflowFlowState({
                        uuid: uuid,
                        parentObj: parentObj,
                        workflowHierarchyObj: workflowHierarchyObj
                    });
                };

                $scope.fnOpenStateConfigModal = function (workflowHierarchyObj) {
                    return $scope.fnOpenFlowStateConfigModal({workflowHierarchyObj: workflowHierarchyObj});
                };

                $scope.fnGetStateInput = function (workflowChildren, workflowObj) {
                    return $scope.fnAddNewStateInput({workflowChildren: workflowChildren, workflowObj: workflowObj});
                };

                $scope.fnOpenWorkflowFlowModal = function (workflowChildren, workflowObj, isCalledFromAddBranch) {
                    return $scope.fnAddExistingStateInput({
                        workflowChildren: workflowChildren,
                        workflowObj: workflowObj,
                        isCalledFromAddBranch: isCalledFromAddBranch
                    });
                };

                $scope.fnInjectState = function (workflowHierarchyObj) {
                    return $scope.fnInjectExistingState({workflowHierarchyObj: workflowHierarchyObj});
                };

                $scope.fnAddErrorFlow = function (workflowObj) {
                    return $scope.fnAddNewErrorFlow({workflowObj: workflowObj});
                };

                $scope.fnRemoveErrorFlow = function (workflowObj) {
                    return $scope.fnRemoveOnErrorFlow({workflowObj: workflowObj});
                }

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('widgetEditor', fnWidgetEditor);

    /** @ngInject */
    function fnWidgetEditor($window, $timeout, $sce, UserProfileService, PaginationQueryService, QueryFactory, DB, AppInitService, moment, amaran, InsightDashboardFactory) {
        return {
            restrict: 'EA',
            scope: {
                appName: "=",
                serviceName: "=",
                serviceDisplayName: "="
            },
            templateUrl: "app/components/directives/widgetEditor/widgetEditor.html",
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total1 = angular.isDefined(angular.element(".content-container")[0]) ? angular.element(".content-container")[0].offsetHeight : 0;
                        var total2 = angular.isDefined(angular.element(".container-with-footer")[0]) ? angular.element(".container-with-footer")[0].offsetHeight: 0;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var finalHeightNew;
                        if (total1 === 0) {
                            finalHeightNew = total2 - footer;
                        } else {
                            finalHeightNew = total1 - footer;
                        }
                        angular.element(".widget-content-main").css('height', finalHeightNew + 'px');
                        if ($scope.isViewDashboardLists && angular.isDefined(angular.element("thead")[0])) {
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var searchTag = 0;
                            var header = angular.element("thead")[0].offsetHeight;
                            var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var extraSpace = $scope.serviceName === 'issue' || $scope.serviceName === 'archives' ? 275 : 165;
                            var finalHeight = finalHeightNew - (search + pagination + searchTag + header + extraSpace);
                            angular.element("#dashboardsTable").css('height', finalHeight + 'px');
                        }
                    }
                };

                $scope.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-container")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var extraSpace = $scope.serviceName === 'issue' || $scope.serviceName === 'archives' ? 306 : 196;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + extraSpace);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGotoListDashboards = function () {
                    $scope.isViewDashboardLists = true;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                var tableName = 'insight_dashboards';
                //Search Variables
                $scope.project = {};
                $scope.isProjectLoaded = false;
                $scope.isRefreshData = true;
                $scope.isInitIssue = true;
                $scope.isProjectsLoading = true;
                $scope.dashboardsProjectFilter = "$";
                $scope.dashboardsProjectSearch = {$: ''};


                $scope.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                $scope.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                $scope.filterQuery = "";
                $scope.sqlQuery = "";

                //Users Variables
                $scope.isDashboardsLoading = false;
                $scope.dashboardsResponse = [];
                $scope.dashboardsArr = [];
                $scope.selectedDashboardsArr = [];
                $scope.selectedDashboardsObj = {};
                $scope.isDashboardDetailsLoaded = true;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                $scope.perPage = parseInt(perPage === '' ? 50 : perPage);
                $scope.maxSize = 1;
                $scope.totalItems = 0;
                $scope.currentPage = 1;

                /*START: Search*/
                $scope.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $scope.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                        $scope.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                        $scope.sort = '';
                    }
                    $scope.sqlQuery = sqlQuery;
                    $scope.previousPage = 1;
                    if ($scope.currentPage) {
                        $scope.currentPage = Math.ceil($scope.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        $scope.currentPage = 1;
                    }
                    if ($scope.perPage) {
                        $scope.perPage = Math.ceil($scope.perPage)
                    }
                    $scope.isDashboardsLoading = true;
                    $scope.selectedDashboardsArr = [];
                    $scope.isAllChecked = false;
                    if ($scope.isInitIssue === false) {
                        $scope.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            $scope.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            $scope.projectsArr.unshift({name: "All", id: "All"});
                            $scope.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            $scope.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                $scope.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'dashboards', 'selectedProject');
                    var sortString = '';
                    if ($scope.sort) {
                        var sortType = $scope.sort.split(' ')[1];
                        var sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find($scope.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            $scope.project = isFindProject;
                        } else {
                            $scope.project = {};
                        }
                    } else {
                        $scope.project = {name: "All", id: "All"};
                    }

                    if ($scope.project && $scope.project.id === "All") {
                        var tempIndex = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //$scope.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            $scope.searchFiltersArr.splice(tempIndexForAll, 1);
                            //$scope.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if ($scope.project && Object.keys($scope.project).length && $scope.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? " WHERE " + $scope.sqlQuery.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                    }
                    $scope.fnGetDashboards({sql: sqlString}, true);
                    $scope.isProjectLoaded = true;
                };

                $scope.fnGetProjectDashboards = function (projectObj) {
                    $scope.isDashboardsLoading = true;
                    $scope.isProjectLoaded = false;
                    $scope.project = projectObj;
                    if ($scope.project && $scope.project.id === "All") {
                        var tempIndex = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            $scope.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: $scope.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //$scope.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex($scope.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            $scope.searchFiltersArr.splice(tempIndexForAll, 1);
                            //$scope.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if ($scope.sort) {
                        sortType = $scope.sort.split(' ')[1];
                        sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                        if ($scope.project && $scope.project.id && $scope.project.id !== 'All') {
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? " WHERE " + $scope.sqlQuery.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                        } else {
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                        if ($scope.project && $scope.project.id && $scope.project.id !== 'All') {
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? " WHERE " + $scope.sqlQuery.trim() + " and data->>\'projectId\' = '" + $scope.project.id + "'" : " WHERE data->>\'projectId\' = '" + $scope.project.id + "'";
                        } else {
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                    }
                    $scope.fnGetDashboards({sql: sqlString}, true);
                    $scope.isProjectLoaded = true;
                };

                $scope.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $scope.currentPage = page;
                    $scope.perPage = perPage;
                    $scope.isDashboardsLoading = true;
                    $scope.selectedDashboardsArr = [];
                    $scope.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if ($scope.sort) {
                        sortType = $scope.sort.split(' ')[1];
                        sortValue = $scope.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + $scope.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + $scope.sort.split(' ')[0] + ' ' + $scope.sort.split(' ')[1] + ' LIMIT ' + $scope.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += $scope.sqlQuery && $scope.sqlQuery.length ? ' WHERE ' + $scope.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + $scope.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        $scope.fnGetDashboards(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, $scope.sqlQuery, sortString, page, $scope.previousPage, perPage, $scope.totalItems, $scope.dashboardsArr);
                        $scope.previousPage = page;
                        $scope.fnGetDashboards(input, false);
                    }
                };
                /*END: Search*/

                $scope.fnGetDashboards = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = $scope.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = $scope.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find($scope.projectsArr, {id: obj.projectId});
                                }
                            });
                            $scope.dashboardsResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if ($scope.dashboardsResponse.data && $scope.dashboardsResponse.data.length) {
                                    $scope.totalItems = $scope.dashboardsResponse.data[0].totalItems;
                                } else {
                                    $scope.totalItems = 0;
                                }
                                $scope.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                $scope.dashboardsResponse.data.reverse();
                            }
                            $scope.dashboardsArr = _.cloneDeepWith($scope.dashboardsResponse.data);
                            $scope.isRefresh = false;
                            $scope.isInitIssue = false;
                            $scope.isDashboardsLoading = false;
                            $timeout(function () {
                                $scope.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDashboardsLoading = false;
                            $scope.isRefresh = false;
                        })
                };

                $scope.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    $scope.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                $scope.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                $scope.projectsArr = _.cloneDeepWith(projects);
                                $scope.projectsArr.unshift({name: "All", id: "All"});
                                $scope.fnSetSelectedProject();
                            }
                        }, function () {
                            $scope.fnGetProject(inputObj, [], false);
                        });
                };

                $scope.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                $scope.fnCheckUncheckHeader = function (dashboardsObj) {
                    angular.forEach($scope.dashboardsArr, function (obj) {
                        if (dashboardsObj.id !== obj.id) {
                            obj.isCheck = false;
                        }
                    });
                    var isFindDashboards = _.find($scope.dashboardsArr, function (dashboardsObj) {
                        return dashboardsObj.isCheck === true;
                    });
                    if (isFindDashboards) {
                        $scope.selectedDashboardsObj = _.cloneDeepWith(isFindDashboards);
                    } else {
                        $scope.selectedDashboardsObj = {};
                    }
                };

                $scope.isDashboardsObjSelected = function () {
                    return !!$scope.selectedDashboardsObj && Object.keys($scope.selectedDashboardsObj).length;
                };

                $scope.fnSaveWidget = function () {
                    $scope.isDashboardDetailsLoaded = false;
                    var inputObj = {
                        dashboardId: $scope.selectedDashboardsObj.id
                    };
                    InsightDashboardFactory.describeDashboard(inputObj)
                        .then(function (response) {
                            var isFind = _.find(response.cells, function (cellsObj) {
                                return cellsObj.y > 0;
                            });
                            if (!isFind) {
                                UserProfileService.fnUpdateUserProfileObj($scope.appName, $scope.serviceName, 'dashboardWidgets', _.cloneDeepWith($scope.selectedDashboardsObj.id), true);
                                $scope.fnExitWidgets();
                            } else {
                                amaran.error('Service dashboard allows only single row');
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        })
                };

                $scope.fnExitWidgets = function () {
                    $scope.isViewDashboardLists = false;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnInitWidgetEditor = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        $scope.isFullWidthDevice = true;
                    }
                    $scope.isViewDashboardLists = false;
                };

                $scope.fnInitWidgetEditor();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('v4SearchClient', fnV4SearchClient);

    /** @ngInject */
    function fnV4SearchClient($rootScope, $state, $stateParams, $timeout, $location, moment) {
        return {
            restrict: 'EA',
            scope: {
                filterQuery: "=",
                stateName: "=",
                fnFilterQueryChange: "&",
                fnResize: "&",
                noSetUrl: "=",
                filtersArr: "=",
                sortFieldArr: '=',
                searchIdentifier: '=',
                isColumnView: '=',
                tableAlias: '=', //Table alias for join query, It is optional.
                defaultTagArr: '=', //default filter array for default filter add on search init
                defaultSortString: '=' //default sort string for default sort add on search init
            },
            templateUrl: "app/components/directives/v4SearchClient/v4SearchClient.html",
            link: function ($scope) {
                $scope.tagsArr = [];
                $scope.selectedConnector = "and";
                $scope.selectedValue = "";
                $scope.optionTitle = "";
                $scope.selectedFilter = {
                    operator: "Select Filter"
                };
                $scope.filter = "$";
                $scope.search = {$: ''};
                $scope.selectedSortOperator = "asc"; //desc
                $scope.selectedStateFieldObj = {};
                $scope.pattern = "";
                $scope.errorMsg = "";
                $scope.operatorsArr = [
                    {operator: "=", operatorName: "="},
                    {operator: "!=", operatorName: "!="},
                    {operator: "contains", operatorName: "contains"},
                    {operator: "not contains", operatorName: "not contains"},
                    {operator: ">", operatorName: ">"},
                    {operator: "<", operatorName: "<"},
                    {operator: ">=", operatorName: ">="},
                    {operator: "<=", operatorName: "<="}
                ];
                $scope.resetOperatorsArr = _.cloneDeepWith($scope.operatorsArr);
                $scope.predefinedOperatorArr = [
                    {operator: "=", operatorName: "="},
                    {operator: "!=", operatorName: "!="}
                ];
                $scope.resetPredefinedOperatorArr = _.cloneDeepWith($scope.predefinedOperatorArr);
                $scope.dateTimeFilter = [
                    {operator: "<", operatorName: "before"},
                    {operator: ">", operatorName: "after"},
                    {operator: "between", operatorName: "between"}
                ];
                $scope.isShowFilterPredefinedValues = false;

                $scope.isFilterOptionView = false;

                /*new variable: Start*/
                $scope.isFilterSelected = false;
                $scope.selectedFilter = {};
                $scope.selectedOperator = {};
                $scope.isFilterOperatorSelected = false;
                /*new variable: End*/

                $scope.fnOptionalFilters = function (e, isOpen) {
                    $scope.isFilterOptionView = !isOpen;
                    e.stopPropagation();
                    e.preventDefault();
                };

                $scope.fnChangeSortDirection = function () {
                    $scope.selectedSortOperator = $scope.selectedSortOperator === "asc" ? "desc" : "asc";
                    if ($scope.selectedStateFieldObj && $scope.selectedStateFieldObj.name && $scope.selectedStateFieldObj.name !== "") {
                        $scope.sortString = $scope.selectedStateFieldObj.name + " " + $scope.selectedSortOperator;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {sort: $scope.sortString}, {notify: false});
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr, false);
                    }
                };

                $scope.fnChangeStateField = function (action) {
                    $scope.selectedStateFieldObj = action;
                    if ($scope.selectedStateFieldObj !== "" && $scope.selectedStateFieldObj.name && $scope.selectedStateFieldObj.name !== "") {
                        $scope.sortString = $scope.selectedStateFieldObj.name + " " + $scope.selectedSortOperator;
                        $scope.isFilterOptionView = false;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {sort: $scope.sortString}, {notify: false});
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr, false);
                    }
                };

                $scope.fnGenerateUniqueId = function () {
                    return Math.floor(Math.random() * (567234908 - 0 + 1)) + 0;
                };

                $scope.isConnectorVisible = false;

                $scope.fnCreateSearchTags = function (searchText, isInit) {
                    var tempObj = {};
                    if (isInit) {
                        angular.element('#' + $scope.searchIdentifier).blur();
                    }
                    if (angular.isDefined(searchText) && searchText.toString().length) {
                        searchText = isNaN(searchText) ? searchText.toString() : searchText;
                        var displaySearchText = "";
                        if ($scope.selectedFilter.type === 'dateTime' && $scope.isFilterOperatorSelected && ($scope.selectedOperator.operatorName === 'before' || $scope.selectedOperator.operatorName === 'after')) {
                            displaySearchText = moment.unix(searchText).format('YYYY/MM/DD HH:mm');
                        } else if ($scope.selectedFilter.type === 'dateTime' && $scope.isFilterOperatorSelected && $scope.selectedOperator.operatorName === 'between') {
                            displaySearchText = moment.unix(searchText.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(searchText.split(',')[1]).format('YYYY/MM/DD HH:mm');
                        } else {
                            displaySearchText = searchText;
                        }
                        $scope.isConnectorVisible = !!$scope.tagsArr.length;
                        if ($scope.selectedFilter && $scope.selectedFilter.displayName) {
                            if ($scope.isConnectorVisible) {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    selectedConnector: $scope.selectedConnector,
                                    selectedField: $scope.selectedFilter.name,
                                    displaySelectedField: $scope.selectedFilter.displayName,
                                    selectedFilter: {
                                        operatorName: $scope.selectedOperator.operatorName,
                                        operator: $scope.selectedOperator.operator
                                    },
                                    searchText: searchText,
                                    displaySearchText: displaySearchText,
                                    isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                                }
                            } else {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    selectedField: $scope.selectedFilter.name,
                                    displaySelectedField: $scope.selectedFilter.displayName,
                                    selectedFilter: {
                                        operatorName: $scope.selectedOperator.operatorName,
                                        operator: $scope.selectedOperator.operator
                                    },
                                    searchText: searchText,
                                    displaySearchText: displaySearchText,
                                    isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                                };
                            }
                            if ($scope.selectedFilter.localSearch && Object.keys($scope.selectedFilter.localSearch).length) {
                                tempObj.localSearch = $scope.selectedFilter.localSearch;
                            }
                            if ($scope.selectedFilter.sqlSearchType && $scope.selectedFilter.sqlSearchType === 'array') {
                                tempObj.sqlSearchType = 'array';
                            }
                        } else {
                            if ($scope.isConnectorVisible) {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "Keyword " + searchText,
                                    selectedConnector: $scope.selectedConnector,
                                    searchText: searchText
                                };
                            } else {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "Keyword " + searchText,
                                    searchText: searchText
                                };
                            }
                        }
                        if (Object.keys(tempObj).length) {
                            if ($scope.selectedFilter.displayName === 'Custom Field') {
                                tempObj.selectedField = tempObj.selectedField + '.'+ _.cloneDeepWith($scope.selectedFilter.customFieldName);
                                tempObj.customFieldName = _.cloneDeepWith($scope.selectedFilter.customFieldName);
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.selectedValue = "";
                            $scope.pattern = "";
                            $scope.errorMsg = "";
                            $scope.selectedConnector = "and";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            $scope.filter = "$";
                            $scope.search = {$: ''};
                            $scope.isFilterSelected = false;
                            $scope.selectedFilter = {};
                            $scope.selectedOperator = {};
                            $scope.isFilterOperatorSelected = false;
                            if (!$scope.noSetUrl) {
                                $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                            }
                            $scope.fnCreateFilterQuery($scope.tagsArr, false);
                        }
                    }
                    $timeout(function () { // changed table height when tag added
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnOnChange = function () {
                    if ($scope.selectedOperator.operator !== 'contains' && $scope.selectedOperator.operator !== 'not contains') {
                        $scope.pattern = $scope.selectedFilter.regexp !== "" ? $scope.selectedFilter.regexp : "";
                        $scope.errorMsg = $scope.selectedFilter.errorMessage !== "" ? $scope.selectedFilter.errorMessage : "";
                    } else {
                        $scope.pattern = "";
                        $scope.errorMsg = "";
                    }
                    $scope.fnSearchInputScrollRight();
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateFilterQuery = function (tagsArr, isCalledFromInit) {
                    $scope.filterQuery = '';
                    var newSQLFilterQuery = '';
                    angular.forEach(tagsArr, function (filterObj) {
                        var operator = filterObj.selectedConnector === "and" ? "&&" : "||";
                        var sqlOperator = filterObj.selectedConnector === "and" ? "and" : "or";
                        if (filterObj.selectedFilter) {
                            if (filterObj.selectedConnector) {
                                switch (filterObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '===', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '=', filterObj);
                                        break;
                                    case '!=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '!==', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '!=', filterObj);
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' ' + operator + ' obj.' + filterObj.selectedField + '.includes("' + filterObj.searchText + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' LOWER(' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\') LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        } else {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' LOWER(data->>\'' + filterObj.selectedField + 'data->>\') LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        }
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + operator + ' !obj.' + filterObj.selectedField + '.includes("' + filterObj.searchText + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' LOWER(' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\') NOT LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        } else {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' LOWER(data->>\'' + filterObj.selectedField + '\') NOT LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        }
                                        break;
                                    case '>':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '>', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '>', filterObj);
                                        break;
                                    case '<':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '<', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '<', filterObj);
                                        break;
                                    case '>=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '>=', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '>=', filterObj);
                                        break;
                                    case '<=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, operator, '<=', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, sqlOperator, '<=', filterObj);
                                        break;
                                    case 'between':
                                        $scope.filterQuery += ' ' + operator + ' (obj.' + filterObj.selectedField + ' >= ' + parseInt(filterObj.searchText.split(',')[0]) + ' && obj.' + filterObj.selectedField + ' <= ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' (' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\' BETWEEN ' + parseInt(filterObj.searchText.split(',')[0]) + ' AND ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        } else {
                                            newSQLFilterQuery += ' ' + sqlOperator + ' (' + filterObj.selectedField + ' BETWEEN ' + parseInt(filterObj.searchText.split(',')[0]) + ' AND ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        }
                                        break;
                                }
                            } else {
                                switch (filterObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '===', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '=', filterObj);
                                        break;
                                    case '!=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '!==', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '!=', filterObj);
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' obj.' + filterObj.selectedField + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' LOWER(' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\') LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        } else {
                                            newSQLFilterQuery += ' LOWER(data->>\'' + filterObj.selectedField + '\') LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        }
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' !obj.' + filterObj.selectedField + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' LOWER(' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\') NOT LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        } else {
                                            newSQLFilterQuery += ' LOWER(data->>\'' + filterObj.selectedField + '\') NOT LIKE ' + '\'%' + filterObj.searchText.toLowerCase() + '%\'';
                                        }
                                        break;
                                    case '>':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '>', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '>', filterObj);
                                        break;
                                    case '<':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '<', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '<', filterObj);
                                        break;
                                    case '>=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '>=', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '>=', filterObj);
                                        break;
                                    case '<=':
                                        $scope.filterQuery += $scope.fnCreateQueryString('Filter', filterObj.selectedConnector, '', '<=', filterObj);
                                        newSQLFilterQuery += $scope.fnCreateQueryString('SQL', filterObj.selectedConnector, '', '<=', filterObj);
                                        break;
                                    case 'between':
                                        $scope.filterQuery += ' (obj.' + filterObj.selectedField + ' >= ' + parseInt(filterObj.searchText.split(',')[0]) + ' && obj.' + filterObj.selectedField + ' <= ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            newSQLFilterQuery += ' (' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\' BETWEEN ' + parseInt(filterObj.searchText.split(',')[0]) + ' AND ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        } else {
                                            newSQLFilterQuery += ' (' + filterObj.selectedField + ' BETWEEN ' + parseInt(filterObj.searchText.split(',')[0]) + ' AND ' + parseInt(filterObj.searchText.split(',')[1]) + ')';
                                        }
                                        break;
                                }
                            }
                        } else if (filterObj.isDirectFilterApply === true) {
                            if (filterObj.selectedConnector) {
                                $scope.filterQuery += ' ' + operator + ' ' + filterObj.localSearchValue;
                                newSQLFilterQuery += ' ' + sqlOperator + ' ' + filterObj.sqlValue;
                            } else {
                                $scope.filterQuery += ' ' + filterObj.localSearchValue;
                                newSQLFilterQuery += ' ' + filterObj.sqlValue;
                            }
                        } else {
                            var tempString = '';
                            var tempSQLString = '';
                            var url = $location.absUrl().split('?')[0];
                            if ($scope.stateName === 'main.issue' || url.includes('#/tracker/')) {
                                if ($scope.tableAlias === 'tracker_histories') {
                                    if (!filterObj.selectedConnector) {
                                        tempSQLString = '(';
                                    } else {
                                        tempSQLString = ' ' + sqlOperator + ' (';
                                    }
                                    var tempFilterArr = [{name: 'description'}, {name: 'name'}]
                                    angular.forEach(tempFilterArr, function (fieldObj, index) {
                                        if (index === 0) {
                                            tempString += ' ' + ' obj.' + fieldObj.name + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                            if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                                tempSQLString += 'LOWER(' + $scope.tableAlias + '.data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                            } else {
                                                tempSQLString += 'LOWER(data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                            }
                                        } else {
                                            tempString += ' ' + ' || ' + ' obj.' + fieldObj.name + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                            if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                                tempSQLString += ' OR LOWER(' + $scope.tableAlias + '.data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                            } else {
                                                tempSQLString += ' OR LOWER(data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                            }
                                        }
                                    });
                                    tempSQLString += ')';
                                } else {
                                    if (filterObj.selectedConnector) {
                                        tempString += ' ' + operator + ' Object.values(obj).join(\' \').includes("' + filterObj.searchText + '")';
                                        tempSQLString += ' ' + sqlOperator + ' LOWER(data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    } else {
                                        tempString += ' Object.values(obj).join(\' \').includes("' + filterObj.searchText + '")';
                                        tempSQLString += ' LOWER(data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    }
                                }
                            } else if ($scope.stateName === 'main.node') {
                                if (filterObj.selectedConnector) {
                                    tempString += ' ' + operator + ' Object.values(obj).join(\' \').includes("' + filterObj.searchText + '")';
                                    if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                        tempSQLString += ' ' + sqlOperator + ' LOWER(' + $scope.tableAlias + '.data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    } else {
                                        tempSQLString += ' ' + sqlOperator + ' LOWER(data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    }
                                } else {
                                    tempString += ' Object.values(obj).join(\' \').includes("' + filterObj.searchText + '")';
                                    if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                        tempSQLString += ' LOWER(' + $scope.tableAlias + '.data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    } else {
                                        tempSQLString += ' LOWER(data->>\'keywords\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                    }
                                }
                            } else {
                                if (!filterObj.selectedConnector) {
                                    tempSQLString = '(';
                                } else {
                                    tempSQLString = ' ' + sqlOperator + ' (';
                                }
                                angular.forEach($scope.filtersArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempString += ' ' + ' obj.' + fieldObj.name + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            tempSQLString += 'LOWER(' + $scope.tableAlias + '.data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                        } else {
                                            tempSQLString += 'LOWER(data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                        }
                                    } else {
                                        tempString += ' ' + ' || ' + ' obj.' + fieldObj.name + '.toLowerCase().includes("' + filterObj.searchText.toLowerCase() + '")';
                                        if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                            tempSQLString += ' OR LOWER(' + $scope.tableAlias + '.data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                        } else {
                                            tempSQLString += ' OR LOWER(data->>\'' + fieldObj.name + '\') ~* \'' + filterObj.searchText.toLowerCase() + '\'';
                                        }
                                    }
                                });
                                tempSQLString += ')';
                            }
                            $scope.filterQuery += tempString;
                            newSQLFilterQuery += tempSQLString;
                        }
                    });
                    $scope.fnFilterQueryChange({
                        filterQuery: $scope.filterQuery,
                        sortQuery: $scope.sortString,
                        sqlQuery: newSQLFilterQuery,
                        isCalledFromInit: isCalledFromInit,
                        tagArr: tagsArr
                    });
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateQueryString = function (type, selectedConnector, operator, filter, filterObj) {
                    var queryString = "";
                    if (type === 'SQL') {
                        if (filterObj.localSearch && filterObj.localSearch.type === 'arrayOfObjects') {
                            if (selectedConnector) {
                                if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                    queryString = ' ' + operator + ' EXISTS (SELECT 1 FROM jsonb_array_elements(' + $scope.tableAlias + '.data->\''+filterObj.selectedField+'\') as data WHERE data->>\''+filterObj.localSearch.key+'\' ' + filter + ' \'' + filterObj.searchText + '\')';
                                } else {
                                    queryString = ' ' + operator + ' EXISTS (SELECT 1 FROM jsonb_array_elements(data->\''+filterObj.selectedField+'\') as data WHERE data->>\''+filterObj.localSearch.key+'\' ' + filter + ' \'' + filterObj.searchText + '\')';
                                }
                            } else {
                                if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                    queryString = ' EXISTS (SELECT 1 FROM jsonb_array_elements(' + $scope.tableAlias + '.data->\''+filterObj.selectedField+'\') as data WHERE data->>\''+filterObj.localSearch.key+'\' ' + filter + ' \'' + filterObj.searchText + '\')';
                                } else {
                                    queryString = ' EXISTS (SELECT 1 FROM jsonb_array_elements(data->\''+filterObj.selectedField+'\') as data WHERE data->>\''+filterObj.localSearch.key+'\' ' + filter + ' \'' + filterObj.searchText + '\')';
                                }
                            }
                        } else if (filterObj.sqlSearchType && filterObj.sqlSearchType === 'array') {
                            if (selectedConnector) {
                                if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                    if (filter === '=') {
                                        queryString = " " + operator + " '" + filterObj.searchText + "' = ANY(" + $scope.tableAlias + '.data->\'' + filterObj.selectedField + '\')';
                                    } else {
                                        queryString = " " + operator + " NOT ('" + filterObj.searchText + "' = ANY(" + $scope.tableAlias + '.data->\'' + filterObj.selectedField + '\'))';
                                    }
                                } else {
                                    if (filter === '=') {
                                        queryString = " " + operator + " '" + filterObj.searchText + "' = ANY(data->\'" + filterObj.selectedField + "\')";
                                    } else {
                                        queryString = " " + operator + " NOT ('" + filterObj.searchText + "' = ANY(data->\'" + filterObj.selectedField + "\'))";
                                    }
                                }
                            } else {
                                if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                    if (filter === '=') {
                                        queryString = " " + " '" + filterObj.searchText + "' = ANY(" + $scope.tableAlias + '.data->\'' + filterObj.selectedField + '\')';
                                    } else {
                                        queryString = " " + " NOT ('" + filterObj.searchText + "' = ANY(" + $scope.tableAlias + '.data->\'' + filterObj.selectedField + '\'))';
                                    }
                                } else {
                                    if (filter === '=') {
                                        queryString = " " + " '" + filterObj.searchText + "' = ANY(data->\'" + filterObj.selectedField + "\')";
                                    } else {
                                        queryString = " " + " NOT ('" + filterObj.searchText + "' = ANY(data->\'" + filterObj.selectedField + "\'))";
                                    }
                                }
                            }
                        } else {
                            if (angular.isDefined(filterObj.isPredefinedValue) && filterObj.isPredefinedValue === true) {
                                if (selectedConnector) {
                                    queryString = ' ' + operator + ' ' + filterObj.searchText;
                                } else {
                                    queryString = ' ' + filterObj.searchText;
                                }
                            } else {
                                if (selectedConnector) {
                                    if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                        queryString = ' ' + operator + ' ' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\' ' + filter + ' \'' + filterObj.searchText + '\'';
                                    } else {
                                        queryString = ' ' + operator + ' data->>\'' + filterObj.selectedField + '\' ' + filter + ' \'' + filterObj.searchText + '\'';
                                    }
                                } else {
                                    if ($scope.tableAlias && $scope.tableAlias !== '' && filterObj.isNeedTableAlias !== false) {
                                        queryString = ' ' + $scope.tableAlias + '.data->>\'' + filterObj.selectedField + '\' ' + filter + ' \'' + filterObj.searchText + '\'';
                                    } else {
                                        queryString = ' data->>\'' + filterObj.selectedField + '\' ' + filter + ' \'' + filterObj.searchText + '\'';
                                    }
                                }
                            }
                        }
                    } else {
                        if (angular.isDefined(filterObj.isPredefinedValue) && filterObj.isPredefinedValue === true) {
                            if (selectedConnector) {
                                queryString = ' ' + operator + ' ' + filterObj.localSearchText;
                            } else {
                                queryString = ' ' + filterObj.localSearchText;
                            }
                        } else {
                            if (selectedConnector) {
                                if (isNaN(filterObj.searchText)) {
                                    if (filterObj.localSearch && filterObj.localSearch.type === 'arrayOfObjects') {
                                        queryString = ' ' + operator + ' obj.' + filterObj.localSearch.name + '.some(e => e.' + filterObj.localSearch.key + ' ' + filter + ' ' + '"' + filterObj.searchText + '")';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'objects') {
                                        queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.' + filterObj.localSearch.key + ' ' + filter + ' ' + '"' + filterObj.searchText + '")';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'array') {
                                        if (filter === '===') {
                                            queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.includes(' + '"' + filterObj.searchText + '"))';
                                        } else {
                                            queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && !obj.' + filterObj.localSearch.name + '.includes(' + '"' + filterObj.searchText + '"))';
                                        }
                                    } else {
                                        queryString = ' ' + operator + ' obj.' + filterObj.selectedField + ' ' + filter + ' ' + '"' + filterObj.searchText + '"';
                                    }
                                } else {
                                    if (filterObj.localSearch && filterObj.localSearch.type === 'arrayOfObjects') {
                                        queryString = ' ' + operator + ' obj.' + filterObj.localSearch.name + '.some(e => e.' + filterObj.localSearch.key + ' ' + filter + ' ' + filterObj.searchText + ')';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'objects') {
                                        queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.' + filterObj.localSearch.key + ' ' + filter + ' ' + filterObj.searchText + ')';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'array') {
                                        if (filter === '===') {
                                            queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.includes(' + filterObj.searchText + '))';
                                        } else {
                                            queryString = ' ' + operator + ' (obj.' + filterObj.localSearch.name + ' && !obj.' + filterObj.localSearch.name + '.includes(' + filterObj.searchText + '))';
                                        }
                                    } else {
                                        queryString = ' ' + operator + ' obj.' + filterObj.selectedField + ' ' + filter + ' ' + filterObj.searchText;
                                    }
                                }
                            } else {
                                if (isNaN(filterObj.searchText)) {
                                    if (filterObj.localSearch && filterObj.localSearch.type === 'arrayOfObjects') {
                                        queryString = ' obj.' + filterObj.localSearch.name + '.some(e => e.' + filterObj.localSearch.key + ' ' + filter + ' ' + '"' + filterObj.searchText + '")';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'objects') {
                                        queryString = ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.' + filterObj.localSearch.key + ' ' + filter + ' ' + '"' + filterObj.searchText + '")';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'array') {
                                        if (filter === '===') {
                                            queryString = ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.includes(' + '"' + filterObj.searchText + '"))';
                                        } else {
                                            queryString = ' (obj.' + filterObj.localSearch.name + ' && !obj.' + filterObj.localSearch.name + '.includes(' + '"' + filterObj.searchText + '"))';
                                        }
                                    } else {
                                        queryString = ' obj.' + filterObj.selectedField + ' ' + filter + ' ' + '"' + filterObj.searchText + '"';
                                    }
                                } else {
                                    if (filterObj.localSearch && filterObj.localSearch.type === 'arrayOfObjects') {
                                        queryString = ' obj.' + filterObj.localSearch.name + '.some(e => e.' + filterObj.localSearch.key + ' ' + filter + ' ' + filterObj.searchText + ')';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'objects') {
                                        queryString = ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.' + filterObj.localSearch.key + ' ' + filter + ' ' + filterObj.searchText + ')';
                                    } else if (filterObj.localSearch && filterObj.localSearch.type === 'array') {
                                        if (filter === '===') {
                                            queryString = ' (obj.' + filterObj.localSearch.name + ' && obj.' + filterObj.localSearch.name + '.includes(' + filterObj.searchText + '))';
                                        } else {
                                            queryString = ' (obj.' + filterObj.localSearch.name + ' && !obj.' + filterObj.localSearch.name + '.includes(' + filterObj.searchText + '))';
                                        }
                                    } else {
                                        queryString = ' obj.' + filterObj.selectedField + ' ' + filter + ' ' + filterObj.searchText;
                                    }
                                }
                            }
                        }
                    }
                    return queryString;
                };

                $scope.fnRemoveTags = function (index) {
                    $scope.tagsArr.splice(index, 1);
                    if (index === 0 && $scope.tagsArr.length) {
                        delete $scope.tagsArr[0].selectedConnector;
                    }
                    if ($scope.tagsArr.length) {
                        $scope.isConnectorVisible = true;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    } else {
                        $scope.isConnectorVisible = false;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: ""}, {notify: false});
                        }
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr, false);
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnSearchInputFocus = function () {
                    if (Object.keys($scope.selectedFilter).length) {
                        if ($scope.selectedFilter.type === 'dateTime') {
                            $scope.operatorsArr = $scope.dateTimeFilter;
                        }
                        if ($scope.selectedFilter.type === 'dateTime' && $scope.isFilterOperatorSelected && ($scope.selectedOperator.operatorName === 'before' || $scope.selectedOperator.operatorName === 'after')) {
                            $('input[name="datetimes"]').focus();//eslint-disable-line
                        }
                        if ($scope.selectedFilter.type === 'dateTime' && $scope.isFilterOperatorSelected && $scope.selectedOperator.operatorName === 'between') {
                            $('input[name="rangedatetimes"]').focus();//eslint-disable-line
                        }
                    }
                    angular.element(".drpdwn_" + $scope.searchIdentifier).addClass('open');
                    angular.element(".searchable-dropdown-" + $scope.searchIdentifier).addClass('open');
                    angular.element(".search-bar-" + $scope.searchIdentifier).addClass('search-active');
                    if (angular.isDefined(angular.element(".input-token-" + $scope.searchIdentifier)[0])) {
                        var inputToken = angular.element(".input-token-" + $scope.searchIdentifier)[0];
                        var content = inputToken.offsetLeft - 15;
                        var scrollEle = angular.element(".search-container-scroll-" + $scope.searchIdentifier)[0];
                        $scope.fnSearchInputScrollRight();
                        if (scrollEle.scrollWidth > scrollEle.clientWidth) {
                            angular.element(".drpdwn_" + $scope.searchIdentifier).css('left', (scrollEle.clientWidth - inputToken.clientWidth + 30) + 'px');
                            angular.element(".searchable-dropdown-" + $scope.searchIdentifier).css('left', (scrollEle.clientWidth - inputToken.clientWidth + 30) + 'px');
                        } else {
                            angular.element(".drpdwn_" + $scope.searchIdentifier).css('left', (content) + 'px');
                            angular.element(".searchable-dropdown-" + $scope.searchIdentifier).css('left', content + 'px');
                        }
                    }
                };

                $scope.fnSearchInputBlur = function (isInit) {
                    if (isInit) {
                        angular.element('#' + $scope.searchIdentifier).blur();
                    }
                    angular.element(".drpdwn_" + $scope.searchIdentifier).removeClass('open');
                    angular.element(".search-bar-" + $scope.searchIdentifier).removeClass('search-active');
                    angular.element(".searchable-dropdown-" + $scope.searchIdentifier).removeClass('open');
                    if ($scope.selectedFilter.displayName === 'Custom Field' && $scope.selectedFilter.customFieldName === '') {
                        $scope.selectedFilter.customFieldName = _.cloneDeepWith($scope.searchText);
                        $scope.searchText = '';
                    } else {
                        $scope.fnCreateSearchTags($scope.searchText);
                        $scope.operatorsArr = _.cloneDeepWith($scope.resetOperatorsArr);
                        $scope.isFilterOptionView = false;
                    }
                };

                $scope.fnCheckReadOnlyInput = function () {
                    if ($scope.isFilterSelected && $scope.selectedFilter.displayName === 'Custom Field' && $scope.selectedFilter.customFieldName === '') {
                        return false;
                    } else {
                        return $scope.isShowFilterPredefinedValues || ($scope.isFilterSelected && !$scope.isFilterOperatorSelected);
                    }
                };

                $scope.fnCheckOperatorDropdown = function () {
                    if ($scope.isFilterSelected && $scope.selectedFilter.displayName === 'Custom Field' && $scope.selectedFilter.customFieldName === '') {
                        return false;
                    } else {
                        return $scope.isFilterSelected && !$scope.isFilterOperatorSelected;
                    }
                }

                $scope.fnFocusSearchableDropdown = function () {
                    angular.element(".searchable-dropdown-" + $scope.searchIdentifier).addClass('open');
                    angular.element(".drpdwn_" + $scope.searchIdentifier).removeClass('open');
                    if (angular.isDefined(angular.element(".input-token-" + $scope.searchIdentifier)[0])) {
                        var content = angular.element(".input-token-" + $scope.searchIdentifier)[0].offsetLeft - 15;
                        angular.element(".drpdwn_" + $scope.searchIdentifier).css('left', content + 'px');
                    }
                };

                $scope.fnBlurSearchableDropdown = function () {
                    angular.element(".searchable-dropdown-" + $scope.searchIdentifier).removeClass('open');
                    $scope.fnCreateSearchTags($scope.searchText);
                };

                $scope.fnInitSearch = function () {
                    if ($stateParams.sort) {
                        $scope.sortString = $stateParams.sort;
                    } else {
                        $scope.sortString = '';
                    }
                    if ($scope.sortString !== "") {
                        var fieldObj = _.find($scope.sortFieldArr, {name: $scope.sortString.split(' ')[0]});
                        $scope.selectedStateFieldObj = fieldObj ? fieldObj : {};
                        $scope.selectedSortOperator = $scope.sortString.split(' ')[1];
                    }
                    if ($stateParams.filter && !$scope.noSetUrl) {
                        $scope.tagsArr = angular.fromJson($stateParams.filter);
                        if ($scope.tagsArr.length) {
                            $scope.isConnectorVisible = true;
                        }
                        $scope.sortString = $stateParams.sort;
                        $scope.fnCreateFilterQuery($scope.tagsArr, true);
                    } else {
                        if ($scope.noSetUrl) {
                            if (angular.isDefined($scope.defaultTagArr) && $scope.defaultTagArr.length) {
                                $scope.tagsArr = $scope.defaultTagArr;
                            } else {
                                $scope.tagsArr = [];
                            }
                            if (angular.isDefined($scope.defaultSortString) && $scope.defaultSortString.length) {
                                $scope.sortString = $scope.defaultSortString;
                            } else {
                                $scope.sortString = '';
                            }
                            if ($scope.sortString !== "") {
                                var sortFieldObj = _.find($scope.sortFieldArr, {name: $scope.sortString.split(' ')[0]});
                                $scope.selectedStateFieldObj = sortFieldObj ? sortFieldObj : {};
                                $scope.selectedSortOperator = $scope.sortString.split(' ')[1];
                            }
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                                $scope.fnCreateFilterQuery($scope.tagsArr, true);
                            } else {
                                $scope.fnFilterQueryChange({
                                    filterQuery: '',
                                    sortQuery: $scope.sortString,
                                    sqlQuery: '',
                                    isCalledFromInit: true,
                                    tagArr: ''
                                });
                            }
                        } else {
                            $scope.fnFilterQueryChange({
                                filterQuery: '',
                                sortQuery: $scope.sortString,
                                sqlQuery: '',
                                isCalledFromInit: true,
                                tagArr: ''
                            });
                        }
                    }

                    $timeout(function () {
                        $('input[name="datetimes"]').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            singleDatePicker: true,
                            showDropdowns: true,
                            autoApply: true,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start) {
                            $scope.searchText = parseInt(moment(start._d).format("X"));
                            $timeout(function () {
                                angular.element(".drpdwn_" + $scope.searchIdentifier).removeClass('open');
                                angular.element(".search-bar-" + $scope.searchIdentifier).removeClass('search-active');
                                angular.element(".searchable-dropdown-" + $scope.searchIdentifier).removeClass('open');
                                $scope.fnCreateSearchTags($scope.searchText);
                                $scope.operatorsArr = _.cloneDeepWith($scope.resetOperatorsArr);
                                $scope.isFilterOptionView = false;
                            }, 100);
                        });
                        $('input[name="rangedatetimes"]').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end) {
                            $scope.searchText = moment(start._d).format("X") + "," + moment(end._d).format("X");
                            $timeout(function () {
                                angular.element(".drpdwn_" + $scope.searchIdentifier).removeClass('open');
                                angular.element(".search-bar-" + $scope.searchIdentifier).removeClass('search-active');
                                angular.element(".searchable-dropdown-" + $scope.searchIdentifier).removeClass('open');
                                $scope.fnCreateSearchTags($scope.searchText);
                                $scope.operatorsArr = _.cloneDeepWith($scope.resetOperatorsArr);
                                $scope.isFilterOptionView = false;
                            }, 100);
                        });
                    })
                };

                $scope.fnInitSearch(true);

                $scope.fnChangeSelectedConnector = function () {
                    $scope.selectedConnector = $scope.selectedConnector === 'or' ? 'and' : 'or';
                };

                $scope.fnSearchInputScrollRight = function () {
                    $timeout(function () {
                        angular.element(".search-container-scroll-" + $scope.searchIdentifier)[0].scrollBy(angular.element(".search-container-scroll-" + $scope.searchIdentifier)[0].scrollWidth, 0);
                    });
                };

                $scope.fnChangeConditionToggle = function (obj) {
                    if (obj.selectedConnector === "and") {
                        obj.selectedConnector = "or"
                    } else {
                        obj.selectedConnector = "and"
                    }
                    if (!$scope.noSetUrl) {
                        $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr, false);
                };

                $scope.fnClearSearch = function () {
                    $scope.tagsArr = [];
                    if (!$scope.noSetUrl) {
                        $state.go($scope.stateName, {
                            filter: '',
                            sort: ''
                        }, {notify: false});
                        delete $stateParams.sort;
                    }
                    $scope.sortString = '';
                    $scope.fnFilterQueryChange({
                        filterQuery: '',
                        sortQuery: $scope.sortString,
                        sqlQuery: '',
                        isCalledFromInit: false,
                        tagArr: ''
                    });
                    $scope.selectedValue = "";
                    $scope.pattern = "";
                    $scope.optionTitle = "";
                    $scope.selectedConnector = "and";
                    $scope.searchText = "";
                    $scope.errorMsg = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                    $scope.selectedStateFieldObj = {};
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                /*Filter: Start*/
                $scope.fnSelectFilter = function (selectedFilter) {
                    $scope.selectedValue = selectedFilter.displayName;
                    $scope.selectedFilter = selectedFilter;
                    if (selectedFilter.predefinedOperatorArr && selectedFilter.predefinedOperatorArr.length) {
                        $scope.predefinedOperatorArr = _.cloneDeepWith(selectedFilter.predefinedOperatorArr);
                    } else {
                        $scope.predefinedOperatorArr = _.cloneDeepWith($scope.resetPredefinedOperatorArr);
                    }
                    $scope.isFilterSelected = true;
                    $scope.searchText = "";
                    if ($scope.selectedFilter.displayName === 'Custom Field') {
                        $scope.selectedFilter.customFieldName = "";
                    }
                    if (selectedFilter.isDirectFilterApply === true) {
                        $scope.isConnectorVisible = !!$scope.tagsArr.length;
                        var tempTagObj = {};
                        if ($scope.isConnectorVisible) {
                            tempTagObj = {
                                id: $scope.fnGenerateUniqueId(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: $scope.selectedFilter.name,
                                displaySelectedField: $scope.selectedFilter.displayName,
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: selectedFilter.sqlValue,
                                localSearchValue: selectedFilter.localSearchValue,
                                isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                            };
                        } else {
                            tempTagObj = {
                                id: $scope.fnGenerateUniqueId(),
                                selectedField: $scope.selectedFilter.name,
                                displaySelectedField: $scope.selectedFilter.displayName,
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: selectedFilter.sqlValue,
                                localSearchValue: selectedFilter.localSearchValue,
                                isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                            };
                        }
                        $scope.tagsArr.push(tempTagObj);
                        $scope.fnSearchInputScrollRight();
                        $scope.selectedValue = "";
                        $scope.pattern = "";
                        $scope.errorMsg = "";
                        $scope.selectedConnector = "and";
                        $scope.selectedFilter = {
                            operator: "Select Filter"
                        };
                        $scope.searchText = "";
                        $scope.filter = "$";
                        $scope.search = {$: ''};
                        $scope.isFilterSelected = false;
                        $scope.selectedFilter = {};
                        $scope.selectedOperator = {};
                        $scope.isFilterOperatorSelected = false;
                        $scope.selectedFilterPredefinedValues = [];
                        $scope.isShowFilterPredefinedValues = false;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr, true);
                    }
                };

                $scope.fnRemoveSelectedFilter = function () {
                    $scope.selectedFilter = {};
                    $scope.isFilterSelected = false;
                    $scope.selectedOperator = {};
                    $scope.selectedStateValue = '';
                    $scope.isFilterOperatorSelected = false;
                    if ($scope.isShowFilterPredefinedValues === true) {
                        $scope.isShowFilterPredefinedValues = false;
                        $scope.selectedFilterPredefinedValues = [];
                    }
                    $scope.selectedValue = "";
                    $scope.pattern = "";
                    $scope.optionTitle = "";
                    $scope.selectedConnector = "and";
                    $scope.searchText = "";
                    $scope.errorMsg = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                    $scope.selectedStateFieldObj = {};
                };

                $scope.fnSelectFilterOperator = function (selectedOperator) {
                    $scope.selectedOperator = selectedOperator;
                    $scope.isFilterOperatorSelected = true;
                    if ($scope.selectedFilter.isPredefinedValue && $scope.selectedFilter.predefinedValues && $scope.selectedFilter.predefinedValues.length) {
                        $scope.selectedFilterPredefinedValues = $scope.selectedFilter.predefinedValues;
                        $scope.isShowFilterPredefinedValues = true;
                    }
                };

                $scope.fnRemoveFilterOperator = function () {
                    $scope.selectedOperator = {};
                    $scope.selectedStateValue = '';
                    $scope.isFilterOperatorSelected = false;
                    if ($scope.isShowFilterPredefinedValues === true) {
                        $scope.isShowFilterPredefinedValues = false;
                        $scope.selectedFilterPredefinedValues = [];
                    }
                    $scope.searchText = "";
                    $scope.errorMsg = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                    $scope.selectedStateFieldObj = {};
                };

                $scope.setFilterOptionsValue = function (selectedObj) {
                    $scope.isConnectorVisible = !!$scope.tagsArr.length;
                    var tempTagObj = {};
                    if ($scope.isConnectorVisible) {
                        tempTagObj = {
                            id: $scope.fnGenerateUniqueId(),
                            selectedConnector: $scope.selectedConnector,
                            selectedField: $scope.selectedFilter.name,
                            displaySelectedField: $scope.selectedFilter.displayName,
                            selectedFilter: {
                                operatorName: $scope.selectedOperator.operatorName,
                                operator: $scope.selectedOperator.operator
                            },
                            searchText: selectedObj[$scope.selectedFilter.filterApplyKeyName],
                            displaySearchText: selectedObj[$scope.selectedFilter.displayKeyName],
                            isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                        };
                    } else {
                        tempTagObj = {
                            id: $scope.fnGenerateUniqueId(),
                            selectedField: $scope.selectedFilter.name,
                            displaySelectedField: $scope.selectedFilter.displayName,
                            selectedFilter: {
                                operatorName: $scope.selectedOperator.operatorName,
                                operator: $scope.selectedOperator.operator
                            },
                            searchText: selectedObj[$scope.selectedFilter.filterApplyKeyName],
                            displaySearchText: selectedObj[$scope.selectedFilter.displayKeyName],
                            isNeedTableAlias: angular.isDefined($scope.selectedFilter.isNeedTableAlias) ? $scope.selectedFilter.isNeedTableAlias : true
                        };
                    }
                    if ($scope.selectedFilter.localSearch && Object.keys($scope.selectedFilter.localSearch).length) {
                        tempTagObj.localSearch = $scope.selectedFilter.localSearch;
                    }
                    if (selectedObj.isPredefinedValue === true) {
                        tempTagObj.isPredefinedValue = true;
                    }
                    if (angular.isDefined(selectedObj.localSearch) && selectedObj.localSearch.length) {
                        tempTagObj.localSearchText = selectedObj.localSearch;
                    }
                    $scope.tagsArr.push(tempTagObj);
                    $scope.fnSearchInputScrollRight();
                    $scope.selectedValue = "";
                    $scope.pattern = "";
                    $scope.errorMsg = "";
                    $scope.selectedConnector = "and";
                    $scope.selectedFilter = {
                        operator: "Select Filter"
                    };
                    $scope.searchText = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                    $scope.isFilterSelected = false;
                    $scope.selectedFilter = {};
                    $scope.selectedOperator = {};
                    $scope.isFilterOperatorSelected = false;
                    $scope.selectedFilterPredefinedValues = [];
                    $scope.isShowFilterPredefinedValues = false;
                    if (!$scope.noSetUrl) {
                        $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr, true);
                };

                $scope.$on('updateSortString', function (event, data) {
                    if (data) {
                        $scope.sortString = data;
                    } else {
                        $scope.sortString = '';
                    }
                    $stateParams.sort = data;
                    if ($scope.sortString !== "") {
                        var fieldObj = _.find($scope.sortFieldArr, {name: $scope.sortString.split(' ')[0]});
                        $scope.selectedStateFieldObj = fieldObj ? fieldObj : {};
                        $scope.selectedSortOperator = $scope.sortString.split(' ')[1];
                    }
                });
                /*Filter: End*/
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('tableLoader', fnTableLoader);

    /** @ngInject */
    function fnTableLoader($timeout) {
        return {
            restrict: 'EA',
            scope: {
                fnResize: "&",
                isAccountUsersTab: '=',
                hideCircle: '=',
                hideSquare:'=',
                hideLine:'=',
                isIssueTab:'=',
                setPadding:'='
            },
            templateUrl: "app/components/directives/tableLoader/tableLoader.html",
            link: function ($scope) {
                $timeout(function () { // changed table height when table is loading
                    $scope.fnResize();
                }, 100);
                $scope.rows = [0];
                var rowCount = 0;
                var totalRowHeight = 0;

                function incrementTableRow() {
                    if (angular.isDefined(angular.element(".loader-table")[0]) &&
                        angular.isDefined(angular.element(".table-row")[0])) {
                        var tableHeight = angular.element('.loader-table')[0].offsetHeight;
                        rowCount++;
                        totalRowHeight = totalRowHeight + parseInt(angular.isDefined(angular.element('.table-row')[rowCount - 1]) ? angular.element('.table-row')[rowCount - 1].offsetHeight : 0);
                        if (totalRowHeight <= tableHeight) {
                            $scope.rows.push(rowCount);
                            $timeout(function () {
                                incrementTableRow();
                            }, 1500);
                        }
                    }
                }

                $timeout(function () {
                    incrementTableRow();
                }, 1500);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('sunburstDirective', fmSunburstDirective);

    /** @ngInject */
    function fmSunburstDirective(d3, DB, $state, $timeout, ColorService) {
        return {
            restrict: 'E',
            scope: {
                treeData: '=',
                getComponent: '&'
            },
            template: '<div id="componentChart"></div>',
            link: function ($scope, element) {
                // Dimensions of sunburst (from parent)
                var healthsObj = {};
                var healthArr = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                _.forEach(healthArr, function (healthObj) {
                    healthsObj[healthObj.code] = healthObj;
                });

                var menu = [
                    {
                        text: "Component Details",
                        display: function () {
                            return 'block';
                        },
                        onClick: function (d) {
                            $scope.fnGetComponentDetail(d);
                        }
                    },{
                        text: "Edit Supplemental Data",
                        display: function () {
                            return 'block';
                        },
                        onClick: function (d) {
                            $scope.fnTriggerSupplementalDataModal(d);
                        }
                    }];

                $scope.fnGetComponentDetail = function (d) {
                    $scope.getComponent({componet: d});
                };

                $scope.fnTriggerSupplementalDataModal = function (d) {
                    $scope.getComponent({componet: d, isCalledForModal: true});
                };

                $scope.showContextMenu = function (data) {
                    d3.event.stopImmediatePropagation();
                    d3.event.preventDefault();
                    $scope.contextMenu = d3.select('body').selectAll('.context-menu-container').data([1]);
                    $scope.contextMenu.enter()
                        .append('div')
                        .attr('class', 'context-menu-container');
                    // this gets executed when a contextmenu event occurs
                    d3.select('body').selectAll('.context-menu-container')
                        .html('')
                        .append('ul')
                        .attr('class', 'context-menu-d3')
                        .selectAll('li')
                        .data(menu).enter()
                        .append('li')
                        .style('display', function (menuObj) {
                            return menuObj.display(menuObj, data);
                        })
                        .append('a')
                        .on('click', function (menuObj) {
                            d3.event.preventDefault();
                            // show sub menu
                            $scope.contextMenu.style('display', 'none');
                            // self.menuContainer.classed('active', false);
                            menuObj.onClick(data);
                            return menuObj.event;
                        })
                        .text(function (t) {
                            return t.text;
                        });
                    $scope.contextMenu
                        .style('left', d3.event.pageX + 'px')
                        .style('top', d3.event.pageY + 'px')
                        .style('display', 'block');
                    d3.select('body').on('click', function () {
                        if ($scope.contextMenu) {
                            $scope.contextMenu.style('display', 'none');
                        }
                    })
                };

                var width = element.parent()[0].offsetWidth;
                var height = width;
                var radius = Math.min(width, height) / 2;

                // decimal notation, rounded to integer.
                var formatNumber = d3.format(",d");

                var x = d3.scale.linear()
                    .range([0, 2 * Math.PI]);

                var y = d3.scale.sqrt()
                    .range([0, radius]);

                //Colors an ordinal scale
                // var color = d3.scale.category20c();

                //Create partition
                var partition = d3.layout.partition()
                    .value(function (d) {
                        return d.health;
                    });

                //Create the arc
                var arc = d3.svg.arc()
                    .startAngle(function (d) {
                        return Math.max(0, Math.min(2 * Math.PI, x(d.x)));
                    })
                    .endAngle(function (d) {
                        return Math.max(0, Math.min(2 * Math.PI, x(d.x + d.dx)));
                    })
                    .innerRadius(function (d) {
                        return Math.max(0, y(d.y));
                    })
                    .outerRadius(function (d) {
                        return Math.max(0, y(d.y + d.dy));
                    });

                //Create main svg
                var svg = d3.select('#componentChart').append('svg:svg')
                    .attr("preserveAspectRatio", "xMidYMid")
                    .attr("viewBox", "0 0 " + width + " " + height)
                    .append('svg:g')
                    .attr("id", "chartGroup")
                    .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');


                $timeout(function () {
                    svg.selectAll("path")
                        .data(partition.nodes($scope.treeData))
                        .enter().append("path")
                        .attr("d", arc)
                        .on("contextmenu", function (d) {
                            if (d.enabled === true) {
                                $scope.showContextMenu(d);
                            }else {
                                d3.select(".context-menu-container").remove();
                            }
                        })
                        .on("click", click)
                        .each(fnGetHealthColor)
                        .append("title")
                        .text(function (d) {
                            var text = d.name && d.name !== '' && d.name !== ' ' ? d.name : d.index;
                            return text + "\n" + formatNumber(d.health !==0? d.health:d.summaryHealthCode);
                        });


                }, 0);

                // zoom in when click on arc and zoom out when click on center root circle
                function click(d) {
                    svg.transition()
                        .duration(750)
                        .tween("scale", function () {
                            var xd = d3.interpolate(x.domain(), [d.x, d.x + d.dx]),
                                yd = d3.interpolate(y.domain(), [d.y, 1]),
                                yr = d3.interpolate(y.range(), [d.y ? 20 : 0, radius]);
                            return function (t) {
                                x.domain(xd(t));
                                y.domain(yd(t)).range(yr(t));
                            };
                        })
                        .selectAll("path")
                        .attrTween("d", function (d) {
                            return function () {
                                return arc(d);
                            };
                        });
                }

                function fnGetHealthColor(d) {
                    if(d.index === 'deviceRoot'){
                        d3.select(this).style("fill", '#6CCCCC');
                    }else{
                        if (d.index !== 'deviceRoot' && (d.children || d._children)) {
                            var backgroundColor = '';
                            if(d.health !== 0){
                                backgroundColor = healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health);
                            }else{
                                var summaryHealthCode = d.health ? d.health : 0;
                                var children = d.children ? d.children : d._children;
                                angular.forEach(children, function (device) {
                                    summaryHealthCode = getSummaryHealth(device, summaryHealthCode);
                                });
                                d.summaryHealthCode = summaryHealthCode;
                                backgroundColor = healthsObj[summaryHealthCode] ? healthsObj[summaryHealthCode].color : ColorService.getHealthColorForDeviceInventory(summaryHealthCode);
                            }
                            d3.select(this).style("fill", backgroundColor);
                        } else {
                            d3.select(this).style("fill", healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health));
                        }
                    }
                }

                function getSummaryHealth(deviceObj, healthCode) {
                    var summaryHealthCode = healthCode;
                    if(deviceObj.children && deviceObj.children.length){
                        angular.forEach(deviceObj.children, function (device) {
                            if (device.summaryHealthCode && device.summaryHealthCode > summaryHealthCode) {
                                summaryHealthCode = device.summaryHealthCode
                            } else if (device.health > summaryHealthCode) {
                                summaryHealthCode = device.health
                            }
                            if(device.children && device.children.length){
                                summaryHealthCode = getSummaryHealth(deviceObj.children,summaryHealthCode);
                            }
                        });
                        return summaryHealthCode;
                    }else{
                        if (deviceObj.summaryHealthCode && deviceObj.summaryHealthCode > summaryHealthCode) {
                            summaryHealthCode = deviceObj.summaryHealthCode;
                        } else if (deviceObj.health > summaryHealthCode) {
                            summaryHealthCode = deviceObj.health
                        }
                        return summaryHealthCode;
                    }
                }

                $scope.$watch('treeData', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.treeData = newValue;
                        d3.select('#componentChart').select("svg").remove();
                        var svg = d3.select('#componentChart').append('svg:svg')
                            .attr("preserveAspectRatio", "xMidYMid")
                            .attr("viewBox", "0 0 " + width + " " + height)
                            .append('svg:g')
                            .attr("id", "chartGroup")
                            .attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
                        svg.selectAll("path")
                            .data(partition.nodes($scope.treeData))
                            .enter().append("path")
                            .attr("d", arc)
                            .on("contextmenu", function (d) {
                                if (d.enabled === true) {
                                    $scope.showContextMenu(d);
                                }else {
                                    d3.select(".context-menu-container").remove();
                                }
                            })
                            .on("click", click)
                            .each(fnGetHealthColor)
                            .append("title")
                            .text(function (d) {
                                var text = d.name && d.name !== '' && d.name !== ' ' ? d.name : d.index;
                                return text + "\n" + formatNumber(d.health !==0? d.health:d.summaryHealthCode);
                            });
                    }
                });

            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('svgToggleSwitch', fnSvgToggleSwitch);

    /** @ngInject */
    function fnSvgToggleSwitch(d3) {
        return {
            restrict: 'EA',
            scope: {
                isChecked: "=",
                isDisabled: "="
            },
            template: '<svg width="50" height="25">' +
            '<rect x="5" y="5" width="37" height="12" rx="6" ry="6" style="fill:#fff; stroke-width:1px;stroke:#4d4d4d" />' +
            '<circle cx="14" cy="11" r="10" style="fill:#4d4d4d; stroke: transparent;" />' +
            '</svg>',
            link: function ($scope, ele) {
                angular.element(ele).find('circle').each(function () {
                    $scope.circle = d3.select(this);
                });
                angular.element(ele).find('rect')
                    .each(function () {
                        $scope.rect = d3.select(this);
                    });
                $scope.rect.on('click', function () {
                    $scope.fnToggleSwitch();
                });
                // $scope.svg = d3.select(ele)
                $scope.circle
                    .attr('cx', function () {
                        if( $scope.isChecked) {
                            $scope.rect.transition().duration(300).ease('linear').style('fill', "#6CCCCC").style('stroke', "#46bfbf");
                        }else{
                            $scope.rect.transition().duration(300).ease('linear').style('fill', "#fff").style('stroke', "#000000");
                        }
                        return $scope.isChecked ? '32' : '14';
                    })
                    .on('click', function () {
                        $scope.fnToggleSwitch();
                    });

                $scope.fnToggleSwitch= function(){
                    if(!$scope.isDisabled) {
                        $scope.isChecked = !$scope.isChecked;
                        if ($scope.isChecked) {
                            $scope.rect.transition().duration(300).ease('linear').style('fill', "#6CCCCC").style('stroke', "#46bfbf");
                        } else {
                            $scope.rect.transition().duration(300).ease('linear').style('fill', "#fff").style('stroke', "#000000");
                        }
                        $scope.circle.transition().duration(300).ease('linear')
                            .attr('cx', function () {
                                return $scope.isChecked ? '32' : '14';
                            });
                    }
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('storageSearchDirective', fnStorageSearchDirective);

    /** @ngInject */
    function fnStorageSearchDirective($state, $stateParams, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                fieldArr: "=",
                filterQuery: "=",
                stateName: "=",
                fnFilterQueryChange: "&",
                fnResize: "&",
                noSetUrl: "=",
                isFilterOptions: '='
            },
            templateUrl: "app/components/directives/storageSearchDirective/searchTemplate.html",
            link: function ($scope) {
                $scope.fieldArr=[
                    {
                        fieldDisplayName: "Path",
                        fieldName: "path"
                    }
                ];
                $scope.tagsArr = [];
                $scope.filterOptions = [
                    {
                        operatorName: "contains",
                        operator: "contains"
                    },
                    {
                        operatorName: "does not contains",
                        operator: "not contains"
                    },
                    {
                        operatorName: "starts with",
                        operator: "starts"
                    },
                    {
                        operatorName: "does not starts with",
                        operator: "not starts"
                    }
                ];
                $scope.selectedConnector = "AND";
                $scope.selectedField = "Select Field";
                $scope.selectedFilter = {
                    operator: "Select Filter"
                };
                $scope.isConnectorVisible = false;

                $scope.fnCreateSearchTags = function (selectedField, selectedFilter, searchText, selectedConnector) {
                    var tempObj = {};
                    if (angular.isDefined(searchText) && searchText.length) {
                        if (searchText && selectedField !== "Select Field" && angular.isDefined(selectedFilter.operatorName)) {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                switch (selectedFilter.operator) {
                                    case 'contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedConnector + " " + selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedConnector: selectedConnector,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                }
                            } else {
                                switch (selectedFilter.operator) {
                                    case 'contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        } else {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                var tempStringWithConnector = ' ' + selectedConnector +'';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if(index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempStringWithConnector;
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedConnector + " Keyword: " + searchText,
                                    selectedConnector: selectedConnector,
                                    searchText: searchText
                                };
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if(index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempString;
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: "Keyword: " + searchText,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "path";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        }
                        $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    }

                    $timeout(function () { // changed table height when tag added
                        $scope.fnResize();
                    }, 0);

                    if ($scope.tagsArr.length >= 1) {
                        angular.element("#storageSearchTextbox").blur();
                    }
                };

                $scope.fnCreateFilterQuery = function (tagsArr) {
                    $scope.filterQuery = '';
                    angular.forEach(tagsArr, function (tagObj, index) {
                        if (index === 0) {
                            if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += 'starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += 'not starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                }
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if(index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempString;
                            }
                        } else {
                            if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += 'starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += 'not starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                }
                            } else {
                                var tempStringWithConnector = ' ' + tagObj.selectedConnector +'';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if(index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempStringWithConnector;
                            }
                        }
                    });
                    $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                };

                $scope.fnRemoveTags = function (index) {
                    $scope.tagsArr.splice(index, 1);
                    if ($scope.tagsArr.length) {
                        $scope.isConnectorVisible = true;
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    } else {
                        $scope.isConnectorVisible = false;
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: ""}, {notify: false});
                        }
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr);

                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnFocus = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().addClass('active');
                };

                $scope.fnBlur = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().removeClass('active');
                };

                $scope.fnInitSearch = function () {
                    if(angular.isUndefined($scope.isFilterOptions)) {
                        $scope.isFilterOptionsVisible = true;
                    } else {
                        $scope.isFilterOptionsVisible = $scope.isFilterOptions;
                    }
                    if ($stateParams.filter) {
                        $scope.tagsArr = angular.fromJson($stateParams.filter);
                        if($scope.tagsArr.length) {
                            $scope.isConnectorVisible = true;
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr);
                    } else {
                        $scope.fnFilterQueryChange({filterQuery: ''});
                    }
                };
                $scope.fnInitSearch();

                $scope.fnSelectFields = function (field) {
                    $scope.selectedField = field;
                };

                $scope.fnSelectFilters = function (filter) {
                    $scope.selectedFilter = filter;
                };

                $scope.fnChangeSelectedConnector = function (selectedConnector) {
                    $scope.selectedConnector = selectedConnector;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('appSpinner', fnAppSpinner);

    /** @ngInject */
    function fnAppSpinner() {
        return {
            restrict: 'EA',
            scope: {
                spinnerType: '=',
                spinnerText: '='
            },
            templateUrl: "app/components/directives/spinnerDirective/spinnerDirective.html",
            link: function () {
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('sparkLineChart', fnSparkLineChart);

    /** @ngInject */
    function fnSparkLineChart(Highcharts, $timeout, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                chartClass: '@'
            },
            templateUrl: "app/components/directives/sparkLineChart/sparkLineChart.html",
            link: function ($scope) {
                $timeout(function () {
                    $timeout(function () {
                        var chart = new Highcharts.Chart({ //eslint-disable-line
                            chart: {
                                renderTo: $scope.chartClass,
                                backgroundColor: 'transparent',
                                borderWidth: 0,
                                type: 'area',
                                margin: [2, 0, 2, 0],
                                height: 45,
                                style: {
                                    overflow: 'visible'
                                },
                                skipClone: true
                            },
                            title: {
                                text: ''
                            },
                            credits: {
                                enabled: false
                            },
                            xAxis: {
                                enabled: false,
                                tickColor: 'transparent',
                                labels: {
                                    enabled: false
                                }
                            },
                            yAxis: {
                                endOnTick: false,
                                startOnTick: false,
                                labels: {
                                    enabled: false
                                },
                                title: {
                                    text: null
                                },
                                tickPositions: [0]
                            },
                            legend: {
                                enabled: false
                            },
                            tooltip: {
                                formatter: function () {
                                    //return '<div><label>'+ moment(this.x).format("MM/DD HH:mm") +'</label><br /><label>'+ this.series.name +':'+ this.y +'</label></div>'
                                    var value = this.point.name === null ? 0 : this.point.name;
                                    value = value.toString().length > 15 ? value.slice(0, 15) + "..." : value;
                                    return '<div><span style="font-size: 8px">' + moment(this.x).format("YYYY/MM/DD HH:mm") + '</span>' +
                                        '<br><label class="ellipsis-label" style="font-size: 9px">' + value + '</label></div>';
                                }
                            },
                            plotOptions: {
                                series: {
                                    tooltip: {
                                        crosshairs: true
                                    },
                                    animation: false,
                                    lineWidth: 1,
                                    shadow: false,
                                    states: {
                                        hover: {
                                            lineWidth: 1
                                        }
                                    },
                                    marker: {
                                        radius: 1,
                                        states: {
                                            hover: {
                                                radius: 2
                                            }
                                        }
                                    },
                                    fillOpacity: 0.25
                                },
                                column: {
                                    negativeColor: '#910000',
                                    borderColor: 'silver'
                                }
                            },
                            series: [{
                                data: $scope.chartData,
                                pointStart: 0
                            }],
                            exporting: {
                                enabled: false
                            }
                        })
                    }, 0);
                })

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('serviceStatsPieChart', fnServiceStatsPieChart);

    /** @ngInject */
    function fnServiceStatsPieChart(Highcharts, $timeout, jsonToCsvConvertService) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                chartClass: '@',
                chartTitle: '@',
                chartFor: '@',
                fnChartClickEvent: "&",
                isForCsvChart: '='
            },
            templateUrl: "app/components/directives/serviceStatsPieChart/serviceStatsPieChart.html",
            link: function ($scope) {
                $scope.showEmptyChart = false;
                $scope.$watch('chartData', function () {
                    $scope.fnDrawChart();
                }, true);

                $scope.fnDrawChart = function () {
                    var flag = false;
                    if ($scope.isForCsvChart) {
                        var tempChartData = jsonToCsvConvertService.convertCSVToJSON($scope.chartData.data.csv, ',');
                        flag = !!(tempChartData && tempChartData.length > 1);
                    } else {
                        flag = $scope.chartData && $scope.chartData.length;
                    }
                    if (flag) {
                        $timeout(function () {
                            if ($scope.isForCsvChart) {
                                if ($scope.chartData.chart.type === 'pie') {
                                    $scope.chartData.plotOptions.pie = {
                                        allowPointSelect: true,
                                        cursor: 'pointer',
                                        dataLabels: {
                                            enabled: true,
                                            format: '<b>{point.name}</b>: {point.y}'
                                        }
                                    }
                                }
                                if (angular.isDefined(angular.element("." + $scope.chartClass)[0])) {
                                    Highcharts.chart($scope.chartClass, $scope.chartData);
                                }
                            } else {
                                if (angular.isDefined(angular.element("." + $scope.chartClass)[0])) {
                                    Highcharts.chart($scope.chartClass, {
                                        chart: {
                                            plotBackgroundColor: null,
                                            plotBorderWidth: null,
                                            plotShadow: false,
                                            type: 'pie'
                                        },
                                        title: {
                                            text: ''
                                        },
                                        tooltip: {
                                            pointFormat: '{series.name}: <b>{point.y} ({point.percentage:.2f}%)</b>'
                                        },
                                        credits: {
                                            enabled: false
                                        },
                                        plotOptions: {
                                            pie: {
                                                allowPointSelect: true,
                                                cursor: 'pointer',
                                                dataLabels: {
                                                    enabled: false
                                                },
                                                showInLegend: false,
                                                point: {events: {click: pieChartClickEvent}}
                                            }
                                        },
                                        exporting: {
                                            enabled: false
                                        },
                                        series: [{
                                            name: $scope.chartTitle,
                                            colorByPoint: true,
                                            data: $scope.chartData
                                        }]
                                    });
                                }
                            }
                        })
                    } else {
                        $scope.showEmptyChart = true;
                    }
                };

                function pieChartClickEvent() {
                    $scope.fnChartClickEvent({
                        value: this.name,
                        type: $scope.chartFor
                    });
                }

                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('sortableTab', fnSortableTab);

    /** @ngInject */
    function fnSortableTab() {
        return {
            link: function ($scope, element, attrs) {
                // Attempt to integrate with ngRepeat
                // https://github.com/angular/angular.js/blob/master/src/ng/directive/ngRepeat.js#L211
                var match = attrs.ngRepeat.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
                var tabs;
                var customChangeEvent;
                $scope.$watch(match[2], function(newTabs) {
                    tabs = newTabs;
                });

                $scope.$watch(attrs.ngModel, function(newData) {
                    customChangeEvent = newData;
                });

                var index = $scope.$index;
                $scope.$watch('$index', function(newIndex) {
                    index = newIndex;
                });

                attrs.$set('draggable', true);

                // Wrapped in $apply so Angular reacts to changes
                var wrappedListeners = {
                    // On item being dragged
                    dragstart: function(e) {
                        e.originalEvent.dataTransfer.effectAllowed = 'move';
                        e.originalEvent.dataTransfer.dropEffect = 'move';
                        e.originalEvent.dataTransfer.setData('application/json', index);
                        //element.addClass('dragging');
                    },
                    dragend: function(e) {
                        //e.stopPropagation();
                        e.preventDefault();
                        e.stopPropagation();
                        element.removeClass('dragging');
                    },

                    // On item being dragged over / dropped onto
                    dragenter: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                    },
                    dragleave: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        element.removeClass('hover');
                    },
                    drop: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        var sourceIndex = e.originalEvent.dataTransfer.getData('application/json');
                        sourceIndex = sourceIndex === '' ? 1: sourceIndex;
                        move(sourceIndex, index);
                        element.removeClass('hover');
                        customChangeEvent.dropDone();
                    }
                };

                // For performance purposes, do not
                // call $apply for these
                var unwrappedListeners = {
                    dragover: function(e) {
                        e.preventDefault();
                        element.addClass('hover');
                    },
                    /* Use .hover instead of :hover. :hover doesn't play well with
                       moving DOM from under mouse when hovered */
                    mouseenter: function() {
                        element.addClass('hover');
                    },
                    mouseleave: function() {
                        element.removeClass('hover');
                    }
                };

                angular.forEach(wrappedListeners, function(listener, event) {
                    element.on(event, wrap(listener));
                });

                angular.forEach(unwrappedListeners, function(listener, event) {
                    element.on(event, listener);
                });

                function wrap(fn) {
                    return function(e) {
                        $scope.$apply(function() {
                            fn(e);
                        });
                    };
                }

                function move(fromIndex, toIndex) {
                    // http://stackoverflow.com/a/7180095/1319998
                    tabs.splice(toIndex, 0, tabs.splice(fromIndex, 1)[0]);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('searchDirective', fnSearchDirective);

    /** @ngInject */
    function fnSearchDirective($state, $stateParams, $timeout, DB) {
        return {
            restrict: 'EA',
            scope: {
                fieldArr: "=",
                filterQuery: "=",
                stateName: "=",
                fnFilterQueryChange: "&",
                fnResize: "&",
                noSetUrl: "=",
                isFilterOptions: '='
            },
            templateUrl: "app/components/directives/searchDirective/searchTemplate.html",
            link: function ($scope) {
                var loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');
                $scope.tagsArr = [];
                $scope.filterOptions = [
                    {
                        operatorName: "is equal to",
                        operator: "="
                    },
                    {
                        operatorName: "is not equal to",
                        operator: "<>"
                    },
                    {
                        operatorName: "contains",
                        operator: "contains"
                    },
                    {
                        operatorName: "does not contains",
                        operator: "not contains"
                    },
                    {
                        operatorName: "is greater than",
                        operator: ">"
                    },
                    {
                        operatorName: "is less than",
                        operator: "<"
                    },
                    {
                        operatorName: "is greater than or equal to",
                        operator: ">="
                    },
                    {
                        operatorName: "is less than or equal to",
                        operator: "<="
                    }
                ];
                $scope.selectedConnector = "AND";
                $scope.selectedField = "Select Field";
                $scope.selectedFilter = {
                    operator: "Select Filter"
                };
                $scope.isConnectorVisible = false;

                $scope.fnCreateSearchTags = function (selectedField, selectedFilter, searchText, selectedConnector) {
                    var tempObj = {};
                    if (angular.isDefined(searchText) && searchText.length) {
                        if (searchText && selectedField === "Select Field" && angular.isUndefined(selectedFilter.operatorName) && searchText.toLowerCase() === 'unread' && $scope.stateName === 'main.issue') {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                $scope.filterQuery += ' ' + selectedConnector + ' not contains(#{lastCommentReadBy}, ${' + loginUser.id + '})';
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: selectedConnector + " unread",
                                    selectedConnector: selectedConnector,
                                    selectedField: 'lastCommentReadBy',
                                    selectedFilter: 'not contains',
                                    searchText: searchText
                                };
                            }else{
                                $scope.filterQuery = 'not contains(#{lastCommentReadBy}, ${' + loginUser.id + '})';
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "unread",
                                    selectedConnector: selectedConnector,
                                    selectedField: 'lastCommentReadBy',
                                    selectedFilter: 'not contains',
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        } else if (searchText && selectedField !== "Select Field" && angular.isDefined(selectedFilter.operatorName)) {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                switch (selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} = ${' + searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} <> ${' + searchText + '}';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} > ${' + searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} < ${' + searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} >= ${' + searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} <= ${' + searchText + '}';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: selectedConnector + " " + selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedConnector: selectedConnector,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                }
                            } else {
                                switch (selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += '#{' + selectedField + '} = ${' + searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += '#{' + selectedField + '} <> ${' + searchText + '}';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += '#{' + selectedField + '} > ${' + searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += '#{' + selectedField + '} < ${' + searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += '#{' + selectedField + '} >= ${' + searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += '#{' + selectedField + '} <= ${' + searchText + '}';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        } else {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                var tempStringWithConnector = ' ' + selectedConnector + '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempStringWithConnector;
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: selectedConnector + " Keyword: " + searchText,
                                    selectedConnector: selectedConnector,
                                    searchText: searchText
                                };
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempString;
                                tempObj = {
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    name: "Keyword: " + searchText,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        }
                        $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    }

                    $timeout(function () { // changed table height when tag added
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateFilterQuery = function (tagsArr) {
                    $scope.filterQuery = '';
                    angular.forEach(tagsArr, function (tagObj, index) {
                        if (index === 0) {
                            if (tagObj.selectedField === 'lastCommentReadBy' && tagObj.selectedFilter === 'not contains' && tagObj.searchText.toLowerCase() === 'unread' && $scope.stateName === 'main.issue') {
                                $scope.filterQuery += 'not contains(#{lastCommentReadBy}, ${' + loginUser.id + '})';
                            } else if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} = ${' + tagObj.searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} <> ${' + tagObj.searchText + '}';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} > ${' + tagObj.searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} < ${' + tagObj.searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} >= ${' + tagObj.searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} <= ${' + tagObj.searchText + '}';
                                        break;
                                }
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempString;
                            }
                        } else {
                            if (tagObj.selectedField === 'lastCommentReadBy' && tagObj.selectedFilter === 'not contains' && tagObj.searchText.toLowerCase() === 'unread' && $scope.stateName === 'main.issue') {
                                $scope.filterQuery += ' ' + tagObj.selectedConnector + ' not contains(#{lastCommentReadBy}, ${' + loginUser.id + '})';
                            } else if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} = ${' + tagObj.searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} <> ${' + tagObj.searchText + '}';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} > ${' + tagObj.searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} < ${' + tagObj.searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} >= ${' + tagObj.searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} <= ${' + tagObj.searchText + '}';
                                        break;
                                }
                            } else {
                                var tempStringWithConnector = ' ' + tagObj.selectedConnector + '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                $scope.filterQuery += tempStringWithConnector;
                            }
                        }
                    });
                    $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                };

                $scope.fnRemoveTags = function (index) {
                    $scope.tagsArr.splice(index, 1);
                    if ($scope.tagsArr.length) {
                        $scope.isConnectorVisible = true;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    } else {
                        $scope.isConnectorVisible = false;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: ""}, {notify: false});
                        }
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr);

                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnFocus = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().addClass('active');
                };

                $scope.fnBlur = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().removeClass('active');
                };

                $scope.fnInitSearch = function () {
                    if (angular.isUndefined($scope.isFilterOptions)) {
                        $scope.isFilterOptionsVisible = true;
                    } else {
                        $scope.isFilterOptionsVisible = $scope.isFilterOptions;
                    }
                    if ($stateParams.filter) {
                        $scope.tagsArr = angular.fromJson($stateParams.filter);
                        if ($scope.tagsArr.length) {
                            $scope.isConnectorVisible = true;
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr);
                    } else {
                        $scope.fnFilterQueryChange({filterQuery: ''});
                    }
                };
                $scope.fnInitSearch();

                $scope.fnSelectFields = function (field) {
                    $scope.selectedField = field;
                };

                $scope.fnSelectFilters = function (filter) {
                    $scope.selectedFilter = filter;
                };

                $scope.fnChangeSelectedConnector = function (selectedConnector) {
                    $scope.selectedConnector = selectedConnector;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('schemaDirective', fnSchemaDirective);

    /** @ngInject */
    function fnSchemaDirective(VaultsFactory, PermissionsService, $uibModal, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                fnCheckTypeValidion: "&",
                typeArr: "="
            },
            templateUrl: "app/components/directives/schemaDirective/schemaTemplate.html",
            link: function ($scope) {

                $scope.permissionObj = {};
                $scope.selectedVault = '';
                $scope.isVaultLoaded = false;
                $scope.isVaultRefreshing = false;
                $scope.booleanOptionArr = ["true", "false"];
                $scope.typeArrName = [];
                $scope.connectedFieldTypeArr = [];
                $scope.valueFieldTypeArr = [];

                $scope.fnInitTypeArr = function(){
                    _.forEach($scope.typeArr, function (typeObj) {
                        if(typeObj.name === 'ip' || typeObj.name === 'port' || typeObj.name === 'https'){
                            $scope.connectedFieldTypeArr.push(typeObj)
                        }else {
                            $scope.valueFieldTypeArr.push(typeObj)
                        }
                    });
                };

                $scope.fnConnectedTypeArrNameFieldStyle = function () {
                    _.forEach($scope.typeArr, function (typeObj) {
                        $scope.typeArrName.push(typeObj.name);
                    });
                    if ($scope.typeArrName.includes('ip') && $scope.typeArrName.includes('port') && $scope.typeArrName.includes('https')) {
                        //ConnectedDivClass
                        angular.element('#ipField').addClass('col-sm-8');
                        angular.element('#portField').addClass('col-sm-2');
                        angular.element('#httpsField').addClass('col-sm-2');
                    }
                    else if ($scope.typeArrName.includes('ip') && ($scope.typeArrName.includes('port') || $scope.typeArrName.includes('https'))) {
                        //ConnectedDivClass
                        angular.element('#ipField').addClass('col-sm-10');
                        angular.element('#portField').addClass('col-sm-2');
                        angular.element('#httpsField').addClass('col-sm-2');
                    }
                    else {
                        angular.element('#ipField').addClass('col-sm-12');
                        angular.element('#portField').addClass('col-sm-12');
                        angular.element('#httpsField').addClass('col-sm-3');
                    }
                };

                $scope.fnSetFiledLabel = function (labelStr) {
                    var temp = angular.copy(labelStr);

                    if (temp === 'ip') {
                        return 'IP'
                    } else {
                        return temp.replace(/([A-Z])/g, ' $1')
                            .replace(/^./, function (str) {
                                return str.toUpperCase();
                            })
                    }
                };

                $scope.fnSelectVault = function (typePropertyObj, selectedVault) {
                    if (selectedVault) {
                        typePropertyObj.typeValue = selectedVault.id;
                    } else {
                        typePropertyObj.typeValue = ''
                    }
                    $scope.fnValidate(typePropertyObj);
                };

                $scope.fnValidate = function (typePropertyObj) {
                      $scope.selectedVaultName = '';
                    if (typePropertyObj.required && (typePropertyObj.required === true || typePropertyObj.required === "true")) {
                        if (typePropertyObj.typeValue) {
                            typePropertyObj.isValueMissing = false;
                        } else {
                            typePropertyObj.isValueMissing = true;
                        }
                    }
                    if (typePropertyObj.min) {
                        if (typePropertyObj.typeValue < typePropertyObj.min) {
                            typePropertyObj.isMinError = true;
                        } else {
                            typePropertyObj.isMinError = false;
                        }
                    }
                    if (typePropertyObj.max) {
                        if (typePropertyObj.typeValue > typePropertyObj.max) {
                            typePropertyObj.isMaxError = true;
                        } else {
                            typePropertyObj.isMaxError = false;
                        }
                    }
                    if (typePropertyObj.regex) {
                        var regExp = new RegExp(typePropertyObj.regex);
                        if (regExp.test(typePropertyObj.typeValue)) {
                            typePropertyObj.isPatternMismatch = false;
                        } else {
                            typePropertyObj.isPatternMismatch = true;
                        }
                    }

                    $scope.fnCheckAllFieldsValidation();
                };

                $scope.fnCheckAllFieldsValidation = function () {
                    var flag = true;

                    $scope.typeArr.map(function (typeObj) {
                        if (typeObj.required && (typeObj.required === true || typeObj.required === "true")) {
                            if (typeObj.type === 'Boolean') {
                                if (typeObj.typeValue !== false && typeObj.typeValue !== true) {
                                    flag = false;
                                }
                            } else {
                                if (!typeObj.typeValue) {
                                    flag = false;
                                }
                            }
                        }
                        if (typeObj.type !== "Array") {
                            if (typeObj.min) {
                                if (typeObj.typeValue < typeObj.min) {
                                    flag = false;
                                }
                            }
                            if (typeObj.max) {
                                if (typeObj.typeValue > typeObj.max) {
                                    flag = false;
                                }
                            }
                            if (typeObj.regex) {
                                var regExp = new RegExp(typeObj.regex);
                                if (!regExp.test(typeObj.typeValue)) {
                                    flag = false;
                                }
                            }
                        } else {
                            if (typeObj.min) {
                                if (typeObj.typeValue.length < typeObj.min) {
                                    flag = false;
                                }
                            }
                            if (typeObj.max) {
                                if (typeObj.typeValue.length > typeObj.max) {
                                    flag = false;
                                }
                            }
                        }
                    });
                    if (flag) {
                        var propertiesObj = {};
                        $scope.typeArr.map(function (typeObj) {
                            if (typeObj.type === "Number") {
                                if (typeObj.precision) {
                                    typeObj.typeValue = parseFloat(typeObj.typeValue.toFixed(parseInt(typeObj.precision)))
                                }
                            }
                            propertiesObj[typeObj.name] = typeObj.typeValue;
                        });
                        $scope.fnCheckTypeValidion({isValidate: true, propertiesObj: propertiesObj});
                    } else {
                        $scope.fnCheckTypeValidion({isValidate: false, propertiesObj: {}});
                    }
                };

                $scope.fnGetVaults = function () {
                    var inputObj = {
                        page: 1,
                        perPage: 0
                    };
                    VaultsFactory.getVaults(inputObj)
                        .then(function (res) {
                            $scope.vaultArr = res;
                            var tempVaultObj = _.find($scope.typeArr, {name: 'vaultId'});
                            if ($scope.typeArr && tempVaultObj) {
                                $scope.selectedVault = _.find($scope.vaultArr, {id: tempVaultObj.typeValue});
                            }
                            $scope.isVaultLoaded = true;
                            $timeout(function () {
                                $scope.fnConnectedTypeArrNameFieldStyle();
                            });
                            $scope.isVaultRefreshing = false;
                        }, function () {
                            $scope.vaultArr = [];
                            $scope.isVaultLoaded = true;
                            $timeout(function () {
                                $scope.fnConnectedTypeArrNameFieldStyle();
                            });
                            $scope.isVaultRefreshing = false;
                        })
                };

                $scope.fnRefreshVaultOptions = function () {
                    $scope.isVaultRefreshing = true;
                    $scope.fnGetVaults();
                };

                $scope.fnCreateArrayTag = function (arrValue, id, typePropertyObj) {
                    if (arrValue) {
                        var flag = false;
                        if (typePropertyObj.item !== "Boolean") {
                            angular.forEach(typePropertyObj.typeValue, function (obj) {
                                if (obj === arrValue) {
                                    flag = true;
                                }
                            });
                        }

                        if (!flag && typePropertyObj.isMaxError !== true) {
                            if (typePropertyObj.regex) {
                                if (typePropertyObj.isPatternMismatch === false) {
                                    typePropertyObj.typeValue.push(angular.copy(arrValue));
                                    typePropertyObj.arrValue = "";
                                    angular.element('#' + id).blur();
                                }
                            } else {
                                typePropertyObj.typeValue.push(angular.copy(arrValue));
                                typePropertyObj.arrValue = "";
                                angular.element('#' + id).blur();
                            }
                        }
                    }
                    $scope.fnArrayValidation(typePropertyObj, typePropertyObj.arrValue);
                };

                $scope.fnRemoveSelectedArrayTag = function (typePropertyObj, index) {
                    typePropertyObj.typeValue.splice(index, 1);
                    $scope.fnCheckAllFieldsValidation();
                };

                $scope.fnArrayValidation = function (typePropertyObj, value) {
                    if (typePropertyObj.required && (typePropertyObj.required === true || typePropertyObj.required === "true")) {
                        if (typePropertyObj.typeValue) {
                            typePropertyObj.isValueMissing = false;
                        } else {
                            typePropertyObj.isValueMissing = true;
                        }
                    }
                    if (typePropertyObj.min) {
                        if (typePropertyObj.typeValue.length < typePropertyObj.min) {
                            typePropertyObj.isMinError = true;
                        } else {
                            typePropertyObj.isMinError = false;
                        }
                    }
                    if (typePropertyObj.max) {
                        if (typePropertyObj.typeValue.length >= typePropertyObj.max) {
                            typePropertyObj.isMaxError = true;
                        } else {
                            typePropertyObj.isMaxError = false;
                        }
                    }
                    if (typePropertyObj.regex) {
                        var regExp = new RegExp(typePropertyObj.regex);
                        if (regExp.test(value)) {
                            typePropertyObj.isPatternMismatch = false;
                        } else {
                            typePropertyObj.isPatternMismatch = true;
                        }
                    }
                    $scope.fnCheckAllFieldsValidation();
                };

                $scope.fnOpenVaultsModal = function (typePropertyObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/directives/schemaDirective/vaultsGridModal/vaultsGridModal.html',
                        size: 'lg',
                        controller: 'vaultsModalCtrl as vaultsModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            vaultsArr: function () {
                                return $scope.vaultArr;
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        $scope.fnSelectVault(typePropertyObj, res);
                        $scope.selectedVault = res;
                        $scope.selectedVaultName = res.name;
                    }, function () {});
                };

                $scope.fnInit = function () {
                    $scope.fnInitTypeArr();
                    $scope.permissionObj = PermissionsService.getPermissions("access:vault");
                    if ($scope.permissionObj.List) {
                        $scope.isVaultLoaded = false;
                        $scope.fnGetVaults();
                    } else {
                        $scope.vaultArr = [];
                        $scope.isVaultLoaded = true;
                        $timeout(function () {
                            $scope.fnConnectedTypeArrNameFieldStyle();
                        });
                    }
                };

                $scope.fnInit();
            }
        }
    }
})();

/*eslint-disable*/
angular
    .module('phoenixNewUi').directive('ngRightClick', function($parse) {
    return function(scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function(event) {
            scope.$apply(function() {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
});
/*eslint-enable*/

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('radialProgressBar', fnRadialProgressBar);

    /** @ngInject */
    function fnRadialProgressBar($timeout, $sce) {
        return {
            restrict: 'EA',
            scope: {
                data: '=',
                issueObj: "=",
                chartId: '@'
            },
            templateUrl: "app/components/directives/radialProgressBar/radialProgressBar.html",
            link: function ($scope) {
                $scope.$watch('data', function () {
                    $scope.fnDrawChart();
                }, true);

                $scope.fnDrawChart = function () {
                    $scope.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline '+ $scope.issueObj.issueResponseDeadlineRelativeDateTime + '</b> </br>(At '+ $scope.issueObj.issueResponseDeadline +')<hr class="m-0 m-t-5 m-b-5"><b>Updated ' + $scope.issueObj.issueUpdatedRelativeDateTime + ' </b></br> (At '+ $scope.issueObj.issueUpdatedDate + ')</div>'); //eslint-disable-line*/
                    $timeout(function () {
                        var max = -219.99078369140625;
                        angular.element("#" + $scope.chartId + " .fill").css("stroke-dashoffset", ((100 - $scope.data) / 100) * max);
                    });
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('projectRelationships', fnProjectRelationships);

    /** @ngInject */
    function fnProjectRelationships() {
        return {
            restrict: 'EA',
            scope: {
                projectObj: '=',
                fnGetProjectDetail: '&'
            },
            templateUrl: "app/components/directives/projectRelationships/projectRelationships.html",
            link: function ($scope) {

                $scope.fnGetProjectInfo = function (projectObj) {
                    return $scope.fnGetProjectDetail({projectObj: projectObj});
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('pieChart', fnPieChart);

    /** @ngInject */
    function fnPieChart(Highcharts, $timeout, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                chartFullSize: '@',
                chartClass: '@',
                filterObj: '=',
                type: '=',
                nodeId: '=',
                isShowLabel: '=',
                isAlarmsPieChartExport: '=',
                isInventoryChart: "=",
                showOnlyPoint: '='
            },
            templateUrl: "app/components/directives/pieChart/pieChart.html",
            link: function ($scope) {
                var filename, start, end;
                if (!!$scope.chartFullSize) { //eslint-disable-line
                    if ($scope.filterObj.type === 'relative') {
                        start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                        end = moment().toISOString()
                    } else {
                        start = moment($scope.filterObj.start).toISOString();
                        end = moment($scope.filterObj.stop).toISOString();
                    }
                    filename = $scope.nodeId + '_' + $scope.type + '_' + start + '_' + end;
                }
                if ($scope.isAlarmsPieChartExport) {
                    filename = $scope.nodeId + '_' + $scope.type + '_' + moment().toISOString();
                }
                $scope.isShowPicLabel = false;

                $scope.fnShowLabel = function () {
                    $scope.fnDrawChart();
                };

                $scope.$watch('chartData', function () {
                    if ($scope.chartClass === 'atomicPieMainContainer') {
                        $scope.fnDrawChart();
                    }
                }, true);

                $scope.fnDrawChart = function () {
                    $timeout(function () {
                        Highcharts.chart($scope.chartClass, {
                            chart: {
                                plotBackgroundColor: null,
                                plotBorderWidth: null,
                                plotShadow: false,
                                type: 'pie',
                                width: $scope.chartFullSize ? 375 : 100,
                                height: $scope.chartFullSize ? 375 : 100,
                                align: 'left'
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: ''
                            },
                            subtitle: {
                                text: ''
                            },
                            tooltip: {
                                pointFormat: $scope.showOnlyPoint ? '<strong>Total: {point.y}</strong>' : $scope.isInventoryChart ? '<b>{point.percentage:.1f}% <br> <strong>Total: {point.y}</strong></b>' : '<b>{point.percentage:.1f}% </b>',
                                outside: true
                            },
                            plotOptions: {
                                pie: {
                                    allowPointSelect: false,
                                    cursor: 'pointer',
                                    dataLabels: {
                                        enabled: angular.isDefined($scope.isShowPicLabel) ? $scope.isShowPicLabel : false,
                                        format: !!$scope.chartFullSize ? '<b>{point.name}</b>: {point.percentage:.1f} %' : '' //eslint-disable-line
                                    },
                                    showInLegend: false
                                }
                            },
                            series: [{
                                data: $scope.chartData
                            }],
                            navigation: {
                                buttonOptions: {
                                    enabled: !!$scope.chartFullSize,
                                    height: 25,
                                    width: 25,
                                    symbolSize: 12,
                                    symbolX: 13,
                                    symbolY: 13,
                                    symbolStrokeWidth: 2,
                                    theme: {
                                        'stroke-width': 1,
                                        stroke: 'silver',
                                        r: 50
                                    }
                                }
                            },
                            exporting: {
                                filename: filename,
                                enabled: !!$scope.chartFullSize,
                                csv: {
                                    columnHeaderFormatter: function (item, key) {
                                        if (key === 'Category' || angular.isUndefined(key)) {
                                            return angular.isDefined($scope.isAlarmsPieChartExport) ? "Health" : $scope.type;
                                        } else if (key === 'y') {
                                            return 'Count'
                                        }
                                    }
                                },
                                buttons: {
                                    contextButton: {
                                        menuItems: $scope.isShowLabel ? ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS', 'label'] : ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                                    }
                                },
                                menuItemDefinitions: {
                                    printChart: {
                                        onclick: function () {
                                            var divToPrint = document.getElementById($scope.chartClass);
                                            var newWin = window.open(); //eslint-disable-line
                                            newWin.document.write(divToPrint.innerHTML);
                                            newWin.document.close();
                                            newWin.focus();
                                            newWin.print();
                                            newWin.close();
                                        }
                                    },
                                    label: {
                                        onclick: function () {
                                            $scope.isShowPicLabel = !$scope.isShowPicLabel;
                                            $scope.fnShowLabel();
                                        },
                                        text: $scope.isShowPicLabel ? "Hide Label" : "Show Label"
                                    }
                                }
                            }
                        });
                    })
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeSearchDirectiveV4', fnNodeSearchDirective);

    /** @ngInject */
    function fnNodeSearchDirective($state, $stateParams, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                fieldArr: "=",
                filterQuery: "=",
                stateName: "=",
                fnFilterQueryChange: "&",
                fnResize: "&",
                noSetUrl: "=",
                isFilterOptions: '=',
                isCalledFromNodeVisualizer: '=',
                isCalledForViewVisualizer: '=',
                typesArr: "=",
                gatewaysArr: "=",
                isSearchResultLoaded: "=",
                deviceFilters: "="
            },
            templateUrl: "app/components/directives/nodeSearchDirectiveV4/searchTemplateV4.html",
            link: function ($scope) {
                $scope.tagsArr = [];
                $scope.phaseArr = [
                    {
                        title: "PROVISIONING"
                    },
                    {
                        title: "PROVISIONED"
                    }, {
                        title: "COMMISSIONING"
                    },
                    {
                        title: "COMMISSIONED"
                    },
                    {
                        title: "PRODUCTION"
                    }, {
                        title: "DECOMMISSIONING"
                    }, {
                        title: "DECOMMISSIONED"
                    }
                ];
                $scope.filterOptions = [
                    /* {
                         operatorName: "matchall",
                         operator: "match all"
                     },*/
                    {
                        operatorName: "near",
                        operator: "close to"
                    },
                    {
                        operatorName: "phrase",
                        operator: "contains"
                    },
                    {
                        operatorName: "prefix",
                        operator: "starts with"
                    },
                    {
                        operatorName: "range",
                        operator: "range"
                    },
                    {
                        operatorName: "term",
                        operator: "term"
                    }
                ];
                $scope.selectedConnector = "and";
                $scope.selectedValue = "";
                $scope.subMenuOptions = {};
                $scope.optionTitle = "";
                $scope.selectedField = "Select Field";
                $scope.selectedFilter = {
                    operator: "Select Filter"
                };
                $scope.filter = "$";
                $scope.search = {$: ''};
                $scope.sortFieldArr = [
                    {name: 'id', displayName: 'id'},
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'phase', displayName: 'Phase'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'version', displayName: 'Version'},
                    {name: 'mode', displayName: 'Mode'},
                    {name: 'oem', displayName: 'OEM'},
                    {name: 'typeid', displayName: 'Type Id'},
                    {name: 'connection', displayName: 'Connection'},
                    {name: 'model', displayName: 'Model'},
                    {name: 'gatewayid', displayName: 'Gateway Id'}
                ];
                $scope.selectedSortOperator = "asc"; //desc
                $scope.selectedStateFieldObj = {};
                $scope.pattern = "";
                $scope.errorMsg = "";

                $scope.isFilterOptionView = false;
                $scope.fnOptionalFilters = function (e, isOpen) {
                    $scope.isFilterOptionView = !isOpen;
                    e.stopPropagation();
                    e.preventDefault();
                };

                $scope.fnChangeSortDirection = function () {
                    $scope.selectedSortOperator = $scope.selectedSortOperator === "asc" ? "desc" : "asc";
                    if ($scope.selectedStateFieldObj && $scope.selectedStateFieldObj.name && $scope.selectedStateFieldObj.name !== "") {
                        $scope.sortString = $scope.selectedStateFieldObj.name + " " + $scope.selectedSortOperator;
                        $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                    }
                };

                $scope.fnChangeStateField = function (action) {
                    $scope.selectedStateFieldObj = action;
                    if ($scope.selectedStateFieldObj !== "" && $scope.selectedStateFieldObj.name && $scope.selectedStateFieldObj.name !== "") {
                        $scope.sortString = $scope.selectedStateFieldObj.name + " " + $scope.selectedSortOperator;
                        $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                        $scope.isFilterOptionView = false;
                    }
                };

                $scope.setFilterValue = function (list) {
                    $scope.selectedValue = _.cloneDeepWith(list.title);
                    $scope.isVisible = list.isVisible;
                    $scope.subMenuOptions = _.cloneDeepWith(list);
                    $scope.searchText = "";
                };

                $scope.setFilterOptionsValue = function (options) {
                    $scope.optionTitle = _.cloneDeepWith(options.title);
                    if ($scope.selectedValue === "Health") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "health range: [" + options.healthrange.minValue + "," + options.healthrange.maxValue + "]",
                                selectedField: "health",
                                selectedFilter: {
                                    operatorName: "range",
                                    operator: "range"
                                },
                                searchText: "[" + options.healthrange.minValue + "," + options.healthrange.maxValue + "]"
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "health term: " + options.title,
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "health",
                                selectedFilter: {
                                    operatorName: "range",
                                    operator: "range"
                                },
                                searchText: "[" + options.healthrange.minValue + "," + options.healthrange.maxValue + "]"
                            })
                        }
                    }
                    if ($scope.selectedValue === "Connection") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "connection term: " + options.title.toLowerCase(),
                                selectedField: "connection",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.title.toLowerCase()
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "connection term: " + options.title,
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "connection",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.title.toLowerCase()
                            })
                        }
                    }
                    if ($scope.selectedValue === "Gateway") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "gatewayId term: " + options.id,
                                selectedField: "gatewayid",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.id
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "gatewayId term: " + options.id,
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "gatewayid",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.id
                            })
                        }
                    }
                    if ($scope.selectedValue === "OEM") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "oem term: " + options.name.toLowerCase(),
                                selectedField: "oem",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.oem.toLowerCase()
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "oem term: " + options.name.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "oem",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.oem.toLowerCase()
                            })
                        }
                    }
                    if ($scope.selectedValue === "Model") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "model term: " + options.name.toLowerCase(),
                                selectedField: "model",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.model.toLowerCase()
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "model term: " + options.name.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "model",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.model.toLowerCase()
                            })
                        }
                    }
                    if ($scope.selectedValue === "Phase") {
                        if ($scope.tagsArr.length === 0) {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "phase term: " + options.title.toLowerCase(),
                                selectedField: "phase",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.title.toLowerCase()
                            })
                        } else {
                            $scope.tagsArr.push({
                                id: $scope.fnGenerateUniqueId(),
                                name: "phase term: " + options.title.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "phase",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: options.title.toLowerCase()
                            })
                        }
                    }
                    $scope.fnSearchInputScrollRight();
                    $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                    $scope.selectedValue = "";
                    $scope.subMenuOptions = {};
                    $scope.optionTitle = "";
                    $scope.searchText = "";
                    $scope.pattern = "";
                    $scope.errorMsg = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                };

                $scope.fnGenerateUniqueId = function () {
                    return Math.floor(Math.random() * (567234908 - 0 + 1)) + 0;
                };

                $scope.isConnectorVisible = false;

                $scope.fnCreateSearchTags = function (searchText, isInit) {
                    var tempObj = {};
                    //angular.element('.drpdwn').addClass('close');
                    if (isInit) {
                        angular.element('#search-main-input').blur();
                    }
                    if (angular.isDefined(searchText) && searchText.length) {
                        searchText = isNaN(searchText) ? searchText.toString().toLowerCase() : searchText;
                        $scope.isConnectorVisible = !!$scope.tagsArr.length;
                        if ($scope.selectedValue) {
                            tempObj = $scope.fnCreateCustomSearchInputTag($scope.isConnectorVisible);
                        } else {
                            if ($scope.isConnectorVisible) {
                                var tempStringWithConnector = ' (prefix \'' + searchText + '\'))';
                                $scope.filterQuery = $scope.filterQuery.slice(0, -1) + tempStringWithConnector;
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "Keyword " + searchText,
                                    selectedConnector: $scope.selectedConnector,
                                    searchText: searchText
                                };
                            } else {
                                $scope.filterQuery += "(prefix '" + searchText + "')";
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "Keyword " + searchText,
                                    searchText: searchText
                                };
                            }
                        }
                        if (Object.keys(tempObj).length) {
                            $scope.tagsArr.push(tempObj);
                            $scope.subMenuOptions = {};
                            $scope.selectedValue = "";
                            $scope.pattern = "";
                            $scope.errorMsg = "";
                            $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "and";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            $scope.filter = "$";
                            $scope.search = {$: ''};
                            if ($scope.isCalledFromNodeVisualizer) {
                                $scope.fnFilterQueryChange({
                                    filterQuery: $scope.filterQuery,
                                    tagsArr: angular.toJson($scope.tagsArr)
                                });
                            } else {
                                $scope.fnFilterQueryChange({
                                    filterQuery: $scope.filterQuery,
                                    sortQuery: $scope.sortString,
                                    isCalledDirective: true,
                                    isCalledFromInit: false
                                });
                            }
                            if (!$scope.noSetUrl) {
                                $state.go($scope.stateName, {q: angular.toJson($scope.tagsArr)}, {notify: false});
                            }
                        }
                    }
                    $timeout(function () { // changed table height when tag added
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateCustomSearchInputTag = function (isConnectorVisible) {
                    var minRange = 0;
                    var maxRange = 0;
                    var tempObj = {};
                    var searchText = $scope.searchText;
                    if ($scope.selectedValue === "Health") {
                        if (isConnectorVisible) {
                            if (searchText.includes("-")) {
                                minRange = searchText.split("-")[0];
                                maxRange = searchText.split("-")[1];
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "health term: " + searchText,
                                    selectedConnector: $scope.selectedConnector,
                                    selectedField: "health",
                                    selectedFilter: {
                                        operatorName: "range",
                                        operator: "range"
                                    },
                                    searchText: "[" + minRange + "," + maxRange + "]"
                                }
                            } else {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "health term: " + searchText,
                                    selectedField: "health",
                                    selectedConnector: $scope.selectedConnector,
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: searchText
                                }
                            }
                        } else {
                            if (searchText.includes("-")) {
                                minRange = searchText.split("-")[0];
                                maxRange = searchText.split("-")[1];
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "health range: [" + minRange + "," + maxRange + "]",
                                    selectedField: "health",
                                    selectedFilter: {
                                        operatorName: "range",
                                        operator: "range"
                                    },
                                    searchText: "[" + minRange + "," + maxRange + "]"
                                };
                            } else {
                                tempObj = {
                                    id: $scope.fnGenerateUniqueId(),
                                    name: "health term:" + searchText,
                                    selectedField: "health",
                                    selectedFilter: {
                                        operatorName: "term",
                                        operator: "term"
                                    },
                                    searchText: searchText
                                }
                            }
                        }
                    }
                    if ($scope.selectedValue === "Connection") {
                        if (isConnectorVisible) {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "connection term: " + searchText.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "connection",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            }
                        } else {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "connection term: " + searchText.toLowerCase(),
                                selectedField: "connection",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        }
                    }
                    if ($scope.selectedValue === "Gateway") {
                        if (isConnectorVisible) {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "gatewayId term: " + searchText.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "gatewayid",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            }
                        } else {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "gatewayId term: " + searchText.toLowerCase(),
                                selectedField: "gatewayid",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        }
                    }
                    if ($scope.selectedValue === "Model") {
                        if (isConnectorVisible) {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "model term: " + searchText.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "model",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        } else {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "model term: " + searchText.toLowerCase(),
                                selectedField: "model",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        }
                    }
                    if ($scope.selectedValue === "OEM") {
                        if (isConnectorVisible) {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "oem term: " + searchText.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "oem",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        } else {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "oem term: " + searchText.toLowerCase(),
                                selectedField: "oem",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        }
                    }
                    if ($scope.selectedValue === "Phase") {
                        if (isConnectorVisible) {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "phase term: " + searchText.toLowerCase(),
                                selectedConnector: $scope.selectedConnector,
                                selectedField: "phase",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        } else {
                            tempObj = {
                                id: $scope.fnGenerateUniqueId(),
                                name: "phase term: " + searchText.toLowerCase(),
                                selectedField: "phase",
                                selectedFilter: {
                                    operatorName: "term",
                                    operator: "term"
                                },
                                searchText: searchText.toLowerCase()
                            };
                        }
                    }
                    return tempObj;
                };

                $scope.fnOnChange = function (searchText) {
                    if ($scope.selectedValue === "Health") {
                        var isFindSubMenuOption = _.find($scope.subMenuOptions.subMenu, {title: searchText});
                        if (!isFindSubMenuOption) {
                            angular.element('.drpdwn').removeClass('open');
                        } else {
                            angular.element('.drpdwn').addClass('open');
                        }
                        $scope.pattern = /^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2}))-((199|[2-5][0-9]{2})))$/;
                        $scope.errorMsg = "Health only accepts specific health (e.g. 500) or range (e.g 199-500).";
                    } else if ($scope.selectedValue === "Gateway") {
                        $scope.pattern = /^(\w{8})-((\w{8}))$/;
                        $scope.errorMsg = "GatewayId needs to be alphanumeric (e.g 12345678-abcd2544).";
                    } else if ($scope.selectedValue === "Model") {
                        $scope.pattern = /^([a-zA-z0-9]*\-)?[a-zA-Z0-9]+$/;
                        $scope.errorMsg = "Model needs to be alphanumeric.";
                    } else if ($scope.selectedValue === "Connection") {
                        $scope.pattern = /^(Connected|Disconnected)$/;
                        $scope.errorMsg = "Connection can be Connected or Disconnected";
                    }
                    if ($scope.selectedValue === ("Gateway") || $scope.selectedValue === ("Model") || $scope.selectedValue === ("OEM") || $scope.selectedValue === ("Phase")) {
                        angular.element('.searchable-dropdown').removeClass('open');
                    }
                    $scope.fnSearchInputScrollRight();
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateFilterQuery = function (tagsArr, isCalledFromModal, isCalledFromInit) {
                    $scope.filterQuery = '';
                    var tagsArrSize = $scope.tagsArr.length;
                    angular.forEach(tagsArr, function (tagObj, index) {
                        tagObj.searchText = isNaN(tagObj.searchText) ? tagObj.searchText.toString().toLowerCase() : tagObj.searchText;
                        if (tagsArrSize === 1) {
                            if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case 'close to':
                                        $scope.filterQuery += '(near field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += '(phrase field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                        break;
                                    case 'starts with':
                                        $scope.filterQuery += '(prefix field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                        break;
                                    case 'range':
                                        $scope.filterQuery += '(range field=' + tagObj.selectedField + ' ' + tagObj.searchText + ')';
                                        break;
                                    case 'term':
                                        $scope.filterQuery += '(term field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                        break;
                                }
                            } else {
                                $scope.filterQuery += '(prefix \'' + tagObj.searchText + '\')';
                            }
                        } else {
                            if (index === 0) {
                                if (tagObj.selectedField && tagObj.selectedFilter) {
                                    switch (tagObj.selectedFilter.operator) {
                                        case 'close to':
                                            $scope.filterQuery += '(near field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                            break;
                                        case 'contains':
                                            $scope.filterQuery += '(phrase field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                            break;
                                        case 'starts with':
                                            $scope.filterQuery += '(prefix field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                            break;
                                        case 'range':
                                            $scope.filterQuery += '(range field=' + tagObj.selectedField + ' ' + tagObj.searchText + ')';
                                            break;
                                        case 'term':
                                            $scope.filterQuery += '(term field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')';
                                            break;
                                    }
                                } else {
                                    $scope.filterQuery += '(prefix \'' + tagObj.searchText + '\')';
                                }
                            } else if (index === 1) {
                                $scope.filterQuery = '(' + tagObj.selectedConnector + ' ' + $scope.filterQuery + ' )';
                                $scope.filterQuery = $scope.filterQuery.slice(0, -1);
                                if (tagObj.selectedField && tagObj.selectedFilter) {
                                    switch (tagObj.selectedFilter.operator) {
                                        case 'close to':
                                            $scope.filterQuery += '(near field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\'))';
                                            break;
                                        case 'contains':
                                            $scope.filterQuery += '(phrase field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\'))';
                                            break;
                                        case 'starts with':
                                            $scope.filterQuery += '(prefix field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\'))';
                                            break;
                                        case 'range':
                                            $scope.filterQuery += '(range field=' + tagObj.selectedField + ' ' + tagObj.searchText + '))';
                                            break;
                                        case 'term':
                                            $scope.filterQuery += '(term field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\'))';
                                            break;
                                    }
                                } else {
                                    $scope.filterQuery += ' (prefix \'' + tagObj.searchText + '\'))';
                                }
                            } else {
                                $scope.filterQuery = $scope.filterQuery.slice(0, -1);
                                if (tagObj.selectedField && tagObj.selectedFilter) {
                                    switch (tagObj.selectedFilter.operator) {
                                        case 'close to':
                                            $scope.filterQuery += ' (' + tagObj.selectedConnector + ' ( near field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')))';
                                            break;
                                        case 'contains':
                                            $scope.filterQuery += ' (' + tagObj.selectedConnector + ' ( phrase field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')))';
                                            break;
                                        case 'starts with':
                                            $scope.filterQuery += ' (' + tagObj.selectedConnector + ' ( prefix field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')))';
                                            break;
                                        case 'range':
                                            $scope.filterQuery += ' (' + tagObj.selectedConnector + ' ( range field=' + tagObj.selectedField + ' ' + tagObj.searchText + ')))';
                                            break;
                                        case 'term':
                                            $scope.filterQuery += ' (' + tagObj.selectedConnector + ' ( term field=' + tagObj.selectedField + ' \'' + tagObj.searchText + '\')))';
                                            break;
                                    }
                                } else {
                                    $scope.filterQuery += ' (' + tagObj.selectedConnector + ' (prefix \'' + tagObj.searchText + '\')))';
                                }
                            }
                        }
                    });
                    if ($scope.isCalledFromNodeVisualizer) {
                        $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery, tagsArr: angular.toJson(tagsArr)});
                    } else {
                        if (isCalledFromModal) {
                            $scope.fnFilterQueryChange({
                                filterQuery: $scope.filterQuery,
                                sortQuery: $scope.sortString,
                                isCalledDirective: true,
                                isCalledFromInit: isCalledFromInit
                            });
                        } else {
                            $scope.fnFilterQueryChange({
                                filterQuery: $scope.filterQuery,
                                sortQuery: $scope.sortString,
                                isCalledDirective: false,
                                isCalledFromInit: isCalledFromInit
                            });
                        }
                    }
                    if (!$scope.noSetUrl) {
                        $state.go($scope.stateName, {q: angular.toJson($scope.tagsArr)}, {notify: false});
                    }
                    $scope.selectedConnector = "and";
                    $timeout(function () {
                        $scope.fnSearchInputScrollRight();
                    });
                };

                $scope.fnRemoveTags = function (index) {
                    $scope.tagsArr.splice(index, 1);
                    if (index === 0 && $scope.tagsArr.length) {
                        delete $scope.tagsArr[0].selectedConnector;
                    }
                    if ($scope.tagsArr.length) {
                        $scope.isConnectorVisible = true;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {q: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    } else {
                        $scope.isConnectorVisible = false;
                        if (!$scope.noSetUrl) {
                            $state.go($scope.stateName, {q: ""}, {notify: false});
                        }
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnSearchInputFocus = function () {
                    angular.element('.drpdwn').addClass('open');
                    angular.element('.searchable-dropdown').addClass('open');
                    if (angular.isDefined(angular.element(".input-token")[0])) {
                        var inputToken = angular.element(".input-token")[0];
                        var content = inputToken.offsetLeft - 15;
                        var scrollEle = angular.element(".search-container-scroll")[0];
                        $scope.fnSearchInputScrollRight();
                        if (scrollEle.scrollWidth > scrollEle.clientWidth) {
                            angular.element(".drpdwn").css('left', (scrollEle.clientWidth - inputToken.clientWidth + 30) + 'px');
                            angular.element(".searchable-dropdown").css('left', (scrollEle.clientWidth - inputToken.clientWidth + 30) + 'px');
                        } else {
                            angular.element(".drpdwn").css('left', (content) + 'px');
                            angular.element(".searchable-dropdown").css('left', content + 'px');
                        }
                    }
                    angular.element('.search-container').addClass('search-active');
                };

                $scope.fnSearchInputBlur = function () {
                    angular.element('.drpdwn').removeClass('open');
                    angular.element('.search-container').removeClass('search-active');
                    angular.element('.searchable-dropdown').removeClass('open');
                    $scope.fnCreateSearchTags($scope.searchText);
                    $scope.isFilterOptionView = false;
                };

                $scope.fnFocusSearchableDropdown = function () {
                    angular.element('.searchable-dropdown').addClass('open');
                    angular.element('.drpdwn').removeClass('open');
                    if (angular.isDefined(angular.element(".input-token")[0])) {
                        var content = angular.element(".input-token")[0].offsetLeft - 15;
                        angular.element(".drpdwn").css('left', content + 'px');
                    }
                };

                $scope.fnBlurSearchableDropdown = function () {
                    angular.element('.searchable-dropdown').removeClass('open');
                    $scope.fnCreateSearchTags($scope.searchText);
                };

                $scope.fnInitSearch = function (isCalledFromInit) {
                    $scope.isSearchResultLoaded = false;
                    if (angular.isUndefined($scope.isFilterOptions)) {
                        $scope.isFilterOptionsVisible = true;
                    } else {
                        $scope.isFilterOptionsVisible = false;
                    }
                    if ($stateParams.sort) {
                        $scope.sortString = $stateParams.sort;
                    } else {
                        $scope.sortString = '';
                    }
                    if ($scope.sortString !== "") {
                        var fieldObj = _.find($scope.sortFieldArr, {name: $scope.sortString.split(' ')[0]});
                        $scope.selectedStateFieldObj = fieldObj ? fieldObj : {};
                        $scope.selectedSortOperator = $scope.sortString.split(' ')[1];
                    }
                    if ($stateParams.q) {
                        $scope.tagsArr = angular.fromJson($stateParams.q);
                        if ($scope.tagsArr.length) {
                            $scope.isConnectorVisible = true;
                        }
                        $scope.sortString = $stateParams.sort;
                        $scope.fnCreateFilterQuery($scope.tagsArr, false, isCalledFromInit);
                    } else {
                        if ($scope.isCalledFromNodeVisualizer) {
                            $scope.fnFilterQueryChange({filterQuery: '', tagsArr: ''});
                        } else {
                            $scope.fnFilterQueryChange({
                                filterQuery: '',
                                sortQuery: $scope.sortString,
                                isCalledDirective: false,
                                isCalledFromInit: isCalledFromInit
                            });
                        }
                    }
                };

                $scope.fnInitSearch(true);

                $scope.fnSelectFields = function (field) {
                    $scope.selectedField = field;
                };

                $scope.fnSelectFilters = function (filter) {
                    $scope.selectedFilter = filter;
                };

                $scope.fnChangeSelectedConnector = function () {
                    $scope.selectedConnector = $scope.selectedConnector === 'or' ? 'and' : 'or';
                };

                $scope.fnSearchInputScrollRight = function () {
                    $timeout(function () {
                        angular.element(".search-container-scroll")[0].scrollBy(angular.element(".search-container-scroll")[0].scrollWidth, 0);
                    });
                };

                $scope.fnChangeConditionToggle = function (obj) {
                    if (obj.selectedConnector === "and") {
                        obj.selectedConnector = "or"
                    } else {
                        obj.selectedConnector = "and"
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr, false, false);
                };

                $scope.$watch('isSearchResultLoaded', function (newVal, oldVal) {
                    if (newVal !== oldVal) {
                        $scope.isSearchResultLoaded = newVal;
                    }
                }, true);

                $scope.fnRemoveSelectedFilterOption = function () {
                    $scope.selectedValue = "";
                    $scope.subMenuOptions = {};
                    $scope.optionTitle = "";
                    $scope.searchText = "";
                    $scope.pattern = "";
                    $scope.errorMsg = "";
                    //$scope.selectedStateFieldObj = {};
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                };

                $scope.fnClearSearch = function () {
                    $scope.tagsArr = [];
                    if (!$scope.noSetUrl) {
                        $state.go($scope.stateName, {
                            q: '',
                            sort: ''
                        }, {notify: false});
                        delete $stateParams.sort;
                    }
                    $scope.sortString = '';
                    $scope.fnFilterQueryChange({filterQuery: '', sortQuery: ''});
                    $scope.selectedValue = "";
                    $scope.pattern = "";
                    $scope.subMenuOptions = {};
                    $scope.optionTitle = "";
                    $scope.selectedConnector = "and";
                    $scope.searchText = "";
                    $scope.errorMsg = "";
                    $scope.filter = "$";
                    $scope.search = {$: ''};
                    $scope.selectedStateFieldObj = {};
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('nodeSearchDirective', fnNodeSearchDirective);

    /** @ngInject */
    function fnNodeSearchDirective($state, $stateParams, $timeout) {
        return {
            restrict: 'EA',
            scope: {
                fieldArr: "=",
                filterQuery: "=",
                stateName: "=",
                fnFilterQueryChange: "&",
                fnResize: "&",
                noSetUrl: "=",
                isFilterOptions: '=',
                isCalledFromNodeVisualizer: '=',
                isCalledForViewVisualizer: '='
            },
            templateUrl: "app/components/directives/nodeSearchDirective/searchTemplate.html",
            link: function ($scope) {
                $scope.tagsArr = [];
                $scope.filterOptions = [
                    {
                        operatorName: "is equal to",
                        operator: "="
                    },
                    {
                        operatorName: "is not equal to",
                        operator: "<>"
                    },
                    {
                        operatorName: "starts with",
                        operator: "starts"
                    },
                    {
                        operatorName: "does not starts with",
                        operator: "not starts"
                    },
                    {
                        operatorName: "is greater than",
                        operator: ">"
                    },
                    {
                        operatorName: "is less than",
                        operator: "<"
                    },
                    {
                        operatorName: "is greater than or equal to",
                        operator: ">="
                    },
                    {
                        operatorName: "is less than or equal to",
                        operator: "<="
                    },
                    {
                        operatorName: "contains",
                        operator: "contains"
                    },
                    {
                        operatorName: "does not contains",
                        operator: "not contains"
                    }
                ];
                $scope.selectedConnector = "AND";
                $scope.selectedField = "Select Field";
                $scope.selectedFilter = {
                    operator: "Select Filter"
                };
                $scope.isConnectorVisible = false;

                $scope.fnCreateSearchTags = function (selectedField, selectedFilter, searchText, selectedConnector) {
                    var tempObj = {};
                    if (angular.isDefined(searchText) && searchText.length) {
                        if (searchText && selectedField !== "Select Field" && angular.isDefined(selectedFilter.operatorName)) {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                switch (selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} = ${' + searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} <> ${' + searchText + '}';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + selectedConnector + ' not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} > ${' + searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} < ${' + searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} >= ${' + searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += ' ' + selectedConnector + ' #{' + selectedField + '} <= ${' + searchText + '}';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedConnector + " " + selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedConnector: selectedConnector,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                }
                            } else {
                                switch (selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += '#{' + selectedField + '} = ${' + searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += '#{' + selectedField + '} <> ${' + searchText + '}';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += 'starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += 'not starts(#{' + selectedField + '},${' + searchText + '})';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + selectedField + '}, ${' + searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += '#{' + selectedField + '} > ${' + searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += '#{' + selectedField + '} < ${' + searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += '#{' + selectedField + '} >= ${' + searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += '#{' + selectedField + '} <= ${' + searchText + '}';
                                        break;
                                }
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedField + " " + selectedFilter.operatorName + ": " + searchText,
                                    selectedField: selectedField,
                                    selectedFilter: selectedFilter,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        } else {
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                            if ($scope.isConnectorVisible) {
                                var tempStringWithConnector = ' ' + selectedConnector +'';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                // tempStringWithConnector += ' keyword(${' + searchText + '})';
                                $scope.filterQuery += tempStringWithConnector;
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: selectedConnector + " Keyword: " + searchText,
                                    selectedConnector: selectedConnector,
                                    searchText: searchText
                                };
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + searchText + '})';
                                    }
                                });
                                // tempString += ' keyword(${' + searchText + '})';
                                $scope.filterQuery += tempString;
                                tempObj = {
                                    id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                    name: "Keyword: " + searchText,
                                    searchText: searchText
                                };
                            }
                            $scope.tagsArr.push(tempObj);
                            $scope.encodedFilterQuery = encodeURIComponent($scope.filterQuery);
                            $scope.selectedConnector = "AND";
                            $scope.selectedField = "Select Field";
                            $scope.selectedFilter = {
                                operator: "Select Filter"
                            };
                            $scope.searchText = "";
                            if ($scope.tagsArr.length) {
                                $scope.isConnectorVisible = true;
                            } else {
                                $scope.isConnectorVisible = false;
                            }
                        }
                        if($scope.isCalledFromNodeVisualizer) {
                            $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery, tagsArr: angular.toJson($scope.tagsArr)});
                        } else {
                            $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                        }
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    }

                    if($scope.tagsArr.length >= 3) {
                       angular.element('#nodeSearchTextField').blur();
                    }

                    $timeout(function () { // changed table height when tag added
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnCreateFilterQuery = function (tagsArr) {
                    $scope.filterQuery = '';
                    angular.forEach(tagsArr, function (tagObj, index) {
                        if (index === 0) {
                            if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} = ${' + tagObj.searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} <> ${' + tagObj.searchText + '}';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += 'starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += 'not starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += 'contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += 'not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} > ${' + tagObj.searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} < ${' + tagObj.searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} >= ${' + tagObj.searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += '#{' + tagObj.selectedField + '} <= ${' + tagObj.searchText + '}';
                                        break;
                                }
                            } else {
                                var tempString = '';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempString += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempString += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                /*tempString += ' keyword(${' + tagObj.searchText + '})'*/
                                $scope.filterQuery += tempString;
                            }
                        } else {
                            if (tagObj.selectedField && tagObj.selectedFilter) {
                                //tagObj.selectedField = tagObj.selectedField.toLowerCase();
                                switch (tagObj.selectedFilter.operator) {
                                    case '=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} = ${' + tagObj.searchText + '}';
                                        break;
                                    case '<>':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} <> ${' + tagObj.searchText + '}';
                                        break;
                                    case 'starts':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'not starts':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' not starts(#{' + tagObj.selectedField + '},${' + tagObj.searchText + '})';
                                        break;
                                    case 'contains':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case 'not contains':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' not contains(#{' + tagObj.selectedField + '}, ${' + tagObj.searchText + '})';
                                        break;
                                    case '>':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} > ${' + tagObj.searchText + '}';
                                        break;
                                    case '<':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} < ${' + tagObj.searchText + '}';
                                        break;
                                    case '>=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} >= ${' + tagObj.searchText + '}';
                                        break;
                                    case '<=':
                                        $scope.filterQuery += ' ' + tagObj.selectedConnector + ' #{' + tagObj.selectedField + '} <= ${' + tagObj.searchText + '}';
                                        break;
                                }
                            } else {
                                var tempStringWithConnector = ' ' + tagObj.selectedConnector +'';
                                angular.forEach($scope.fieldArr, function (fieldObj, index) {
                                    if (index === 0) {
                                        tempStringWithConnector += ' contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})'
                                    } else if ($scope.fieldArr[$scope.fieldArr.length - 1].fieldName === fieldObj.fieldName) {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    } else {
                                        tempStringWithConnector += ' or contains(#{' + fieldObj.fieldName + '}, ${' + tagObj.searchText + '})';
                                    }
                                });
                                /*tempStringWithConnector += ' keyword(${' + tagObj.searchText + '})'*/
                                $scope.filterQuery += tempStringWithConnector;
                            }
                        }
                    });
                    if($scope.isCalledFromNodeVisualizer) {
                        $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery, tagsArr: angular.toJson(tagsArr)});
                    } else {
                        $scope.fnFilterQueryChange({filterQuery: $scope.filterQuery});
                    }
                };

                $scope.fnRemoveTags = function (index) {
                    $scope.tagsArr.splice(index, 1);
                    if ($scope.tagsArr.length) {
                        $scope.isConnectorVisible = true;
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: angular.toJson($scope.tagsArr)}, {notify: false});
                        }
                    } else {
                        $scope.isConnectorVisible = false;
                        if(!$scope.noSetUrl) {
                            $state.go($scope.stateName, {filter: ""}, {notify: false});
                        }
                    }
                    $scope.fnCreateFilterQuery($scope.tagsArr);

                    $timeout(function () { // Changed table height when tag remove
                        $scope.fnResize();
                    }, 0);
                };

                $scope.fnFocus = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().addClass('active');
                };

                $scope.fnBlur = function (e) {
                    angular.element(e.target).parent().parent().parent().parent().removeClass('active');
                };

                $scope.fnInitSearch = function () {
                    if(angular.isUndefined($scope.isFilterOptions)) {
                        $scope.isFilterOptionsVisible = true;
                    } else {
                        $scope.isFilterOptionsVisible = false;
                    }
                    if ($stateParams.filter) {
                        $scope.tagsArr = angular.fromJson($stateParams.filter);
                        if($scope.tagsArr.length) {
                            $scope.isConnectorVisible = true;
                        }
                        $scope.fnCreateFilterQuery($scope.tagsArr);
                    } else {
                        if($scope.isCalledFromNodeVisualizer) {
                            $scope.fnFilterQueryChange({filterQuery: '', tagsArr: ''});
                        } else {
                            $scope.fnFilterQueryChange({filterQuery: ''});
                        }
                    }
                };
                $scope.fnInitSearch();

                $scope.fnSelectFields = function (field) {
                    $scope.selectedField = field;
                };

                $scope.fnSelectFilters = function (filter) {
                    $scope.selectedFilter = filter;
                };

                $scope.fnChangeSelectedConnector = function (selectedConnector) {
                    $scope.selectedConnector = selectedConnector;
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngQueryBuilderNode', fnNgQueryBuilderNode);

    /** @ngInject */
    function fnNgQueryBuilderNode($compile, $uibModal, $window, moment, $timeout, ColorService) {
        return {
            restrict: 'E',
            scope: {
                queryBuilder: '=',
                actionFilters: '=',
                dropDownNeeded: '@'
            },
            templateUrl: 'app/components/directives/ngQueryBuilderNode/ngQueryBuilderNode.temp.html',
            compile: function (element) {
                var content, directive;
                content = element.contents().remove();
                return function (scope, element) {
                    var operatorsAll = [
                        'is equal to',
                        'is not equal to',
                        'contains',
                        'does not contain',
                        'starts with',
                        'does not start with',
                        'ends with',
                        'does not end with',
                        'is less than',
                        'is less than or equal to',
                        'is greater than',
                        'is greater than or equal to',
                        'is present',
                        'is not present',
                        'is empty',
                        'is not empty',
                        'matches',
                        'does not match'
                    ];
                    scope.operators = operatorsAll;

                    scope.conditions = [{name: 'AND'}, {name: 'OR'}];

                    scope.dropDownNeeded = scope.dropDownNeeded ? scope.dropDownNeeded : true;

                    scope.fnSetFocus = function (id) {
                        $timeout(function () {
                            $window.document.getElementById(id).focus();
                        });
                    };

                    scope.fnSetFieldValue = function (obj, isShow) {
                        obj.isFocusOutDone = isShow;
                        obj.test = obj.field.substring(8, obj.field.length - 1);
                    };

                    if (scope.dropDownNeeded === true) {
                        scope.filtersArr = scope.actionFilters ? scope.actionFilters : [];
                        /*var index = scope.filtersArr.map(function (obj) {
                         return obj;
                         }).indexOf('');
                         if (index === -1) {
                         scope.filtersArr.unshift('');
                         }*/
                    } else {
                        if (scope.actionFilters.length) {
                            scope.filtersArr = scope.actionFilters;
                        } else {
                            scope.filtersArr = null;
                        }
                    }
                    scope.fnGetOperatorBackgroundColor = function(operatorName){
                        return angular.isDefined(ColorService.getOperatorColor(operatorName).color) ? {'background-color': ColorService.getOperatorColor(operatorName).color,'color':'#fff'} : {'color': '#000'}
                    };

                    scope.resetFilterArr = angular.copy(scope.filtersArr);

                    scope.fnInjectValueFunction = function (val) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/ngQueryBuilderValueModal/ngQueryBuilderValueModal.html',
                            size: 'lg',
                            controller: 'queryBuilderValueModalCtrl as qbValueModal',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (modalValue) {
                            $timeout(function () {
                                val.value = modalValue;
                            })
                        }, function () {

                        });
                    };

                    scope.fnInjectFunction = function (index,condition) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/directives/ngQueryBuilderNode/queryBuilderModal/queryBuilderModal.html',
                            size: 'lg',
                            controller: 'queryBuilderModalCtrl as qbModal',
                            windowClass: 'modal-height100',
                            resolve: {
                                resetFilterArr: function () {
                                    return scope.resetFilterArr;
                                },
                                filtersArr: function () {
                                    return scope.filtersArr;
                                },
                                isCallFromNode: function () {
                                    return true;
                                },
                                operators: function () {
                                    return scope.operators;
                                },
                                conditionIndex : function(){
                                    return index;
                                },
                                condition : function(){
                                    return condition;
                                }
                            }
                        });
                        modalInstance.result.then(function (arr) {
                            scope.filtersArr = angular.copy(arr);
                        }, function () {

                        });
                    };

                    scope.fnCheckFilterValidation = function (obj, filedValue, index, condition) {
                        var counter = 0;
                        var tempArr = [];
                        if (index === 0 && condition === 'AND') {
                            if (angular.isDefined(filedValue) && (filedValue.startsWith("ghost(") || scope.fnCheckFunction(filedValue))) {
                                obj.functionGhostPatternMismatch = true;
                            } else {
                                obj.functionGhostPatternMismatch = false;
                            }
                        } else if (index !== 0 && condition === 'AND') {
                            if (angular.isDefined(filedValue) && (!filedValue.startsWith("ghost(") && !scope.fnCheckFunction(filedValue) && filedValue !== scope.queryBuilder.rules[0].field)) {
                                obj.functionGhostRequiredPatternMismatch = true;
                            } else {
                                obj.functionGhostRequiredPatternMismatch = false;
                                if (angular.isDefined(filedValue) && filedValue.startsWith("ghost(")) {
                                    counter = (filedValue.match(/\./g) || []).length;
                                    if (counter === 1) {
                                        tempArr = filedValue.split(").");
                                        if (tempArr.length === 2) {
                                            obj.functionPatternMismatch = false;
                                        } else {
                                            obj.functionPatternMismatch = true;
                                        }
                                    } else {
                                        obj.functionPatternMismatch = true;
                                    }
                                } else if (angular.isDefined(filedValue) && !filedValue.startsWith("ghost(") && filedValue === scope.queryBuilder.rules[0].field) {
                                    obj.functionPatternMismatch = false;
                                }
                            }
                        } else if (condition !== 'AND') {
                            if (angular.isDefined(filedValue) && filedValue.startsWith("ghost(")) {
                                counter = (filedValue.match(/\./g) || []).length;
                                if (counter === 1) {
                                    tempArr = filedValue.split(").");
                                    if (tempArr.length === 2) {
                                        obj.functionPatternMismatch = false;
                                    } else {
                                        obj.functionPatternMismatch = true;
                                    }
                                } else {
                                    obj.functionPatternMismatch = true;
                                }
                            }
                        }
                    };

                    scope.fnCheckFunction = function (filedValue) {
                        return (filedValue.startsWith("TimeOfDay(") || filedValue.startsWith("DayOfWeek(") || filedValue.startsWith("DayOfMonth(") || filedValue.startsWith("DayOfYear(") || filedValue.startsWith("Matches("));
                    };

                    scope.fnOnSelectFilter = function (obj, filedValue, index, condition) {
                        scope.fnCheckFilterValidation(obj, filedValue, index, condition);
                        var id = '';
                        if (filedValue.length !== 0) {
                            if (filedValue.includes('TimeOfDay')) {
                                id = '#TimeOfDay' + index;
                                $timeout(function () {
                                    angular.element(id).mdtimepicker();
                                })
                            }
                            if (filedValue.includes('DayOfWeek')) {
                                id = '#DayOfWeek' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                            if (filedValue.includes('DayOfMonth')) {
                                id = '#DayOfMonth' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                            if (filedValue.includes('DayOfYear')) {
                                id = '#DayOfYear' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                        }

                    };

                    scope.fnAddRule = function () {
                        scope.queryBuilder.rules.push({
                            type: 'string',
                            input: 'text',
                            operator: '',
                            field: '',
                            value: ''
                        });
                    };

                    scope.fnRemoveRule = function (index) {
                        scope.queryBuilder.rules.splice(index, 1);
                    };

                    scope.fnAddGroup = function () {
                        scope.queryBuilder.rules.push({
                            condition: 'OR',
                            rules: []
                        });
                    };

                    scope.fnRemoveGroup = function () {
                        /*eslint-disable*/
                        'queryBuilder' in scope.$parent && scope.$parent.queryBuilder.rules.splice(scope.$parent.$index, 1);
                        /*eslint-enable*/
                    };

                    scope.$watch('actionFilters', function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            scope.actionFilters = newValue;
                            scope.filtersArr = newValue;
                        }
                    });

                    scope.fnAddValue = function (rule, filedValue, index) {
                        var id = '';
                        if (filedValue.includes('TimeOfDay')) {
                            id = 'TimeOfDay' + index + "";
                            document.getElementById(id).click();
                            $timeout(function () {
                                angular.element('#' + id).mdtimepicker().on('timechanged', function (e) {
                                    var tempDate = moment(e.value, "h:mm A").format("HH:mm").replace(":", "");
                                    rule.value = parseInt(tempDate);
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfWeek')) {
                            id = 'DayOfWeek' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var dayOfWeek = CalDayOfWeek(date._d.getDate(), date._d.getMonth() + 1, date._d.getFullYear());
                                    if (dayOfWeek === 0) {
                                        dayOfWeek = 7;
                                    }
                                    rule.value = dayOfWeek;
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfMonth')) {
                            id = 'DayOfMonth' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var dayOfMonth = date._d.getDate();
                                    rule.value = dayOfMonth;
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfYear')) {
                            id = 'DayOfYear' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var start = new Date(date._d.getFullYear(), 0, 0);
                                    var diff = date._d - start;
                                    var oneDay = 1000 * 60 * 60 * 24;
                                    var day = Math.floor(diff / oneDay);
                                    rule.value = day;
                                    scope.$apply();
                                });
                            })
                        }
                    };

                    scope.fnGetFocus = function (id) {
                        $timeout(function () {
                            document.getElementById(id).focus();
                        })
                    };

                    function CalDayOfWeek(day, month, year) {
                        var a = Math.floor((14 - month) / 12);
                        var y = year - a;
                        var m = month + 12 * a - 2;
                        var d = (day + y + Math.floor(y / 4) - Math.floor(y / 100) +
                            Math.floor(year / 400) + Math.floor((31 * m) / 12)) % 7;
                        return d;
                    }

                    scope.$on('queryBuilderReset', function () {
                        //builder.queryBuilder('reset');
                        scope.queryBuilder = {"condition": "OR", "rules": []};
                    });

                    scope.$on('changeText', function () {
                        /* eslint-disable */
                        //$scope.run();
                        /* eslint-enable */
                    });
                    /*eslint-disable*/
                    directive || (directive = $compile(content));
                    /*eslint-enable*/

                    element.append(directive(scope, function ($compile) {
                        return $compile;
                    }));


                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngQueryBuilder', fnNgQueryBuilder);

    /** @ngInject */
    function fnNgQueryBuilder($compile, $uibModal, $timeout, moment, ColorService) {
        return {
            restrict: 'E',
            scope: {
                queryBuilder: '=',
                actionFilters: '=',
                clustersArr: '=',
                dropDownNeeded: '@'
            },
            templateUrl: 'app/components/directives/ngQueryBuilder/ngQueryBuilder.temp.html',
            compile: function (element) {
                var content, directive;
                content = element.contents().remove();
                return function (scope, element) {
                    var isFind = _.find(scope.actionFilters, {id: 'Cluster ID'});
                    scope.isClusterIDExists = !!isFind;
                    var operatorsAll = [
                        'is equal to',
                        'is not equal to',
                        'contains',
                        'does not contain',
                        'starts with',
                        'does not start with',
                        'ends with',
                        'does not end with',
                        'is less than',
                        'is less than or equal to',
                        'is greater than',
                        'is greater than or equal to',
                        'is present',
                        'is not present',
                        'is empty',
                        'is not empty',
                        'matches',
                        'does not match'
                    ];

                    scope.operators = operatorsAll;
                    scope.clusterOperators = [
                        'is equal to',
                        'is not equal to'];
                    scope.conditions = [{name: 'AND'}, {name: 'OR'}];

                    scope.dropDownNeeded = scope.dropDownNeeded ? scope.dropDownNeeded : true;

                    if (scope.dropDownNeeded === true) {
                        scope.filtersArr = scope.actionFilters ? scope.actionFilters : [];
                        /*var index = scope.filtersArr.map(function (obj) {
                            return obj.id;
                        }).indexOf('');
                        if (index === -1) {
                            scope.filtersArr.unshift({id: ''});
                        }*/
                    } else {
                        if (scope.actionFilters.length) {
                            scope.filtersArr = scope.actionFilters;
                        } else {
                            scope.filtersArr = null;
                        }
                    }
                    /*  scope.fnChangeField = function (ruleObj) {
                          var filterObj = scope.filtersArr.filter(function (obj) {
                              return obj.id === ruleObj.field;
                          })[0];
                          ruleObj.id = filterObj.id;
                          scope.operators = filterObj.operators ? filterObj.operators : operatorsAll;
                      };*/

                    scope.resetFilterArr = angular.copy(scope.filtersArr);

                    scope.fnGetOperatorBackgroundColor = function (operatorName) {
                        return angular.isDefined(ColorService.getOperatorColor(operatorName).color) ? {
                            'background-color': ColorService.getOperatorColor(operatorName).color,
                            'color': '#fff'
                        } : {'color': '#000'}
                    };
                    scope.fnInjectValueFunction = function (val) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/ngQueryBuilderValueModal/ngQueryBuilderValueModal.html',
                            size: 'lg',
                            controller: 'queryBuilderValueModalCtrl as qbValueModal',
                            windowClass: 'modal-height100'
                        });
                        modalInstance.result.then(function (modalValue) {
                            $timeout(function () {
                                val.value = modalValue;
                            })
                        }, function () {

                        });
                    };

                    scope.fnInjectFunction = function () {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/directives/ngQueryBuilderNode/queryBuilderModal/queryBuilderModal.html',
                            size: 'lg',
                            controller: 'queryBuilderModalCtrl as qbModal',
                            windowClass: 'modal-height100',
                            resolve: {
                                resetFilterArr: function () {
                                    return scope.resetFilterArr;
                                },
                                filtersArr: function () {
                                    return scope.filtersArr;
                                },
                                isCallFromNode: function () {
                                    return false;
                                },
                                operators: function () {
                                    return scope.operators;
                                },
                                conditionIndex: function () {
                                    return 0;
                                },
                                condition: function () {
                                    return '';
                                }
                            }
                        });
                        modalInstance.result.then(function (arr) {
                            $timeout(function () {
                                scope.filtersArr = angular.copy(arr);
                            });

                        }, function () {

                        });
                    };

                    scope.fnOnSelectFilter = function (obj, filedValue, index) {
                        var id = '';
                        if (filedValue.length !== 0) {
                            if (filedValue.includes('TimeOfDay')) {
                                id = '#TimeOfDay' + index;
                                $timeout(function () {
                                    angular.element(id).mdtimepicker();
                                })
                            }
                            if (filedValue.includes('DayOfWeek')) {
                                id = '#DayOfWeek' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                            if (filedValue.includes('DayOfMonth')) {
                                id = '#DayOfMonth' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                            if (filedValue.includes('DayOfYear')) {
                                id = '#DayOfYear' + index;
                                $timeout(function () {
                                    angular.element(id).bootstrapMaterialDatePicker({weekStart: 0, time: false});
                                })
                            }
                        }
                    };

                    scope.fnAddValue = function (rule, filedValue, index) {
                        var id = '';
                        if (filedValue.includes('TimeOfDay')) {
                            id = 'TimeOfDay' + index + "";
                            document.getElementById(id).click();
                            $timeout(function () {
                                angular.element('#' + id).mdtimepicker().on('timechanged', function (e) {
                                    var tempDate = moment(e.value, "h:mm A").format("HH:mm").replace(":", "");
                                    rule.value = parseInt(tempDate);
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfWeek')) {
                            id = 'DayOfWeek' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var dayOfWeek = CalDayOfWeek(date._d.getDate(), date._d.getMonth() + 1, date._d.getFullYear());
                                    if (dayOfWeek === 0) {
                                        dayOfWeek = 7;
                                    }
                                    rule.value = dayOfWeek;
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfMonth')) {
                            id = 'DayOfMonth' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var dayOfMonth = date._d.getDate();
                                    rule.value = dayOfMonth;
                                    scope.$apply();
                                });
                            })
                        }
                        if (filedValue.includes('DayOfYear')) {
                            id = 'DayOfYear' + index + "";
                            document.getElementById(id).focus();
                            $timeout(function () {
                                angular.element('#' + id).bootstrapMaterialDatePicker().on('change', function (e, date) {
                                    var start = new Date(date._d.getFullYear(), 0, 0);
                                    var diff = date._d - start;
                                    var oneDay = 1000 * 60 * 60 * 24;
                                    var day = Math.floor(diff / oneDay);
                                    rule.value = day;
                                    scope.$apply();
                                });
                            })
                        }
                    };

                    scope.fnGetFocus = function (id) {
                        $timeout(function () {
                            document.getElementById(id).focus();
                        })
                    };


                    function CalDayOfWeek(day, month, year) {
                        var a = Math.floor((14 - month) / 12);
                        var y = year - a;
                        var m = month + 12 * a - 2;
                        var d = (day + y + Math.floor(y / 4) - Math.floor(y / 100) +
                            Math.floor(year / 400) + Math.floor((31 * m) / 12)) % 7;
                        return d;
                    }

                    scope.fnAddRule = function () {
                        scope.queryBuilder.rules.push({
                            type: 'string',
                            input: 'text',
                            operator: '',
                            field: '',
                            value: ''
                        });
                    };

                    scope.fnRemoveRule = function (index) {
                        scope.queryBuilder.rules.splice(index, 1);
                    };

                    scope.fnAddGroup = function () {
                        scope.queryBuilder.rules.push({
                            condition: 'OR',
                            rules: []
                        });
                    };

                    scope.fnRemoveGroup = function () {
                        /*eslint-disable*/
                        'queryBuilder' in scope.$parent && scope.$parent.queryBuilder.rules.splice(scope.$parent.$index, 1);
                        /*eslint-enable*/
                    };

                    scope.$on('queryBuilderReset', function () {
                        //builder.queryBuilder('reset');
                        scope.queryBuilder = {"condition": "OR", "rules": []};
                    });

                    /*scope.$on('queryBuilderSet', function (event, args) {
                        console.log("args", args);
                        //builder.queryBuilder('setRules', args);
                    });*/

                    scope.$on('changeText', function () {
                        /* eslint-disable */
                        //$scope.run();
                        /* eslint-enable */
                    });
                    /*eslint-disable*/
                    directive || (directive = $compile(content));
                    /*eslint-enable*/

                    element.append(directive(scope, function ($compile) {
                        return $compile;
                    }));
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('javascriptEditor', fnJavascriptEditor);

    /** @ngInject */
    function fnJavascriptEditor(CodeMirror) {
        return {
            restrict: 'EA',
            scope: {
                editorValue: '=',
                readOnly: '=',
                value: "=",
                availableDefs: "=",
                isModeSql: "="
            },
            templateUrl: "app/components/directives/javascriptEditor/javascriptEditor.html",
            link: function ($scope) {
                /*New code: start*/
                var project;
                $scope.editor = '';
                var editorMode = !$scope.isModeSql ? "javascript" : "sql";

                $scope.$watch('editorValue', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.editorValue = newValue;
                        $scope.editor.getDoc().setValue(newValue);
                    }
                }, true);

                function Project(name, place, config, docs) {
                    this.name = name
                    this.docs = Object.create(null)
                    this.tabs = place.appendChild(document.createElement("ul"))
                    this.tabs.className = "tabs"
                    var self = this
                    CodeMirror.on(this.tabs, "click", function (e) {
                        var target = e.target || e.srcElement
                        if (target.nodeName.toLowerCase() !== "li") {
                            return
                        }
                        var doc = self.findDoc(target.textContent);
                        if (doc) {
                            self.selectDoc(doc);
                        }
                    });

                    var myConf = {
                        switchToDoc: function (name) {
                            self.selectDoc(self.findDoc(name))
                        },
                        useWorker: false
                    }
                    for (var prop in config) { //eslint-disable-line
                        myConf[prop] = config[prop];
                    }
                    var server = this.server = new CodeMirror.TernServer(myConf)

                    var firstDoc
                    for (var name1 in docs) { //eslint-disable-line
                        var data = this.registerDoc(name1, new CodeMirror.Doc(docs[name1], editorMode))
                        if (!firstDoc) {
                            firstDoc = data
                        }
                    }
                    this.curDoc = firstDoc
                    this.setSelectedTab(firstDoc)

                    var ExcludedIntelliSenseTriggerKeys =
                        {
                            "8": "backspace",
                            "9": "tab",
                            "13": "enter",
                            "16": "shift",
                            "17": "ctrl",
                            "18": "alt",
                            "19": "pause",
                            "20": "capslock",
                            "27": "escape",
                            "33": "pageup",
                            "34": "pagedown",
                            "35": "end",
                            "36": "home",
                            "37": "left",
                            "38": "up",
                            "39": "right",
                            "40": "down",
                            "45": "insert",
                            "46": "delete",
                            "48": "close round bracket",
                            "57": "open round bracket",
                            "91": "left window key",
                            "92": "right window key",
                            "93": "select",
                            "107": "add",
                            "109": "subtract",
                            "111": "divide",
                            "112": "f1",
                            "113": "f2",
                            "114": "f3",
                            "115": "f4",
                            "116": "f5",
                            "117": "f6",
                            "118": "f7",
                            "119": "f8",
                            "120": "f9",
                            "121": "f10",
                            "122": "f11",
                            "123": "f12",
                            "144": "numlock",
                            "145": "scrolllock",
                            "187": "equalsign",
                            "188": "comma",
                            "189": "dash",
                            "191": "slash",
                            "192": "graveaccent",
                            "219": "open curly bracket",
                            "220": "backslash",
                            "221": "close curly bracket",
                            "222": "quote"
                        };

                    var keyMap = {
                        "Ctrl-I": function (cm) {
                            server.showType(cm);
                        },
                        "Ctrl-Space": function (cm) {
                            server.complete(cm);
                        }
                    };
                    $scope.editor = new CodeMirror(place, {
                        lineNumbers: true,
                        extraKeys: keyMap,
                        matchBrackets: true,
                        autoCloseBrackets: true,
                        value: firstDoc.doc,
                        mode: editorMode
                    });
                    $scope.editor.getDoc().setValue($scope.editorValue);
                    var editorInstance = $scope.editor;
                    $scope.editor.on("cursorActivity", function (cm) {
                        server.updateArgHints(cm);
                    });
                    $scope.editor.on("keyup", function (cm) {
                        if (!editorInstance.state.completionActive &&
                            !ExcludedIntelliSenseTriggerKeys[(event.keyCode || event.which).toString()]) {
                            server.complete(cm);
                        }
                        $scope.editorValue = cm.getValue();
                    });

                    $scope.editor.on("change", function (cm) {
                        $scope.editorValue = cm.getValue();
                    });

                }

                Project.prototype = {
                    findDoc: function (name) {
                        return this.docs[name]
                    },

                    registerDoc: function (name, doc) {
                        this.server.addDoc(name, doc)
                        var data = this.docs[name] = {
                            name: name,
                            doc: doc,
                            tab: this.tabs.appendChild(document.createElement("li"))
                        }
                        data.tab.textContent = name
                        return data
                    },

                    unregisterDoc: function (doc) {
                        this.server.delDoc(doc.name)
                        delete this.docs[doc.name]
                        this.tabs.removeChild(doc.tab)
                        if (this.curDoc === doc) {
                            for (var n in this.docs) { //eslint-disable-line
                                return this.selectDoc(this.docs[n])
                            }
                        }
                    },

                    setSelectedTab: function (doc) {
                        for (var n = this.tabs.firstChild; n; n = n.nextSibling) {
                            n.className = n.textContent === doc.name ? "selected" : ""
                        }
                    },

                    selectDoc: function (doc) {
                        if (doc === this.curDoc) {
                            return
                        }
                        this.server.hideDoc(this.curDoc)
                        this.setSelectedTab(doc)
                        this.curDoc = doc
                        $scope.editor.swapDoc(doc.doc)
                    }
                }

                function load(file, c) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("get", file, true);
                    xhr.send(null);
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            c(xhr.responseText, xhr.status);
                        }
                    };
                }

                function loadFiles(project, c) {
                    var found = {}

                    function inner(node) {
                        while (node && node.nodeName !== "PRE") {
                            node = node.nextSibling
                        }
                        if (!node) {
                            return c(found)
                        }
                        if (node.hasAttribute("file")) {
                            load(node.getAttribute("file"), function (data) {
                                found[node.id] = data
                                inner(node.nextSibling)
                            })
                        } else {
                            found[node.id] = node.textContent
                            inner(node.nextSibling)
                        }
                    }

                    inner(project.firstChild)
                }

                var defsLoaded = Object.create(null)

                function loadDefs(defs, c) {
                    var result = [], loaded = 0
                    for (var i = 0; i < defs.length; ++i) (function (i) { //eslint-disable-line
                        var name = defs[i]
                        if (defsLoaded[name]) {
                            result[i] = defsLoaded[name]
                            if (++loaded === defs.length) {
                                c(result)
                            }
                        } else {
                            load("https://cdn.ecsmon.ecsiteapp.com/libs/s4/v1.0.2/defs/" + name + ".json", function (json) {
                                defsLoaded[name] = result[i] = JSON.parse(json) //eslint-disable-line
                                if (++loaded === defs.length) {
                                    c(result)
                                }
                            })
                        }
                    })(i)
                }

                function words(str) {
                    return str ? str.split(" ") : []
                }


                function initProject(name, c) {
                    var node = document.getElementById(name);
                    loadDefs($scope.availableDefs, function (defs) {
                        var plugins = {}
                        words(node.getAttribute("data-plugins")).forEach(function (name) {
                            plugins[name] = true
                        })

                        if (plugins.requirejs) {
                            plugins.requirejs = {override: {"jquery": "=$"}}
                        }

                        loadFiles(node, function (files) {
                            var place = document.getElementById("place")
                            place.textContent = ""

                            if (project) {
                                project.server.destroy()
                            }

                            project = new Project(name, place, {
                                defs: defs,
                                plugins: plugins
                            }, files)
                            //location.hash = "#" + name
                            c && c() //eslint-disable-line
                        })
                    })
                }

                initProject("simple");

                $scope.value.getData = function () {
                    return $scope.editor.getValue();
                };

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('lifecycleTimeline', fnLifecycleTimeline);

    /** @ngInject */
    function fnLifecycleTimeline() {
        return {
            restrict: 'EA',
            scope: {
                lifecycleStepsArr: '=',
                getLifecycleStep: '&'
            },
            templateUrl: "app/components/directives/lifecycleTimeline/lifecycleTimeline.html",
            link: function ($scope) {

                $scope.fnGetLifecycleStep = function (lifecycleObj) {
                    $scope.getLifecycleStep({lifecycle: lifecycleObj});
                };

                $scope.fnGetResultIcon = function (result) {
                    var icon = "";
                    switch(result) {
                        case "PASS":
                            icon = "fa-check";
                            break;
                        case "FAIL":
                            //icon = "fa-exclamation";
                            icon = "fa-exclamation-triangle";
                            break;
                        case "PROCESSING":
                            icon = "fa-clock";
                            break;
                    }
                    return icon;
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('userTreeView', fnUserTreeview);

    /** @ngInject */
    function fnUserTreeview($timeout, d3, ColorService, ComponentFactory, componentService) {
        return {
            restrict: 'EA',
            scope: {
                treeData: '='
            },
            templateUrl: "app/components/directives/interactiveUserTreeview/userTreeview.html",
            link: function ($scope) {
                $scope.total = 0;
                $scope.isZoomPositionSet = false;
                // set the dimensions of the canvas
                var totalHeight = angular.element(".content-main")[0].offsetHeight;
                var totalWidth = angular.element(".content-main")[0].offsetWidth;
                var margin = {top: 5, right: 10, bottom: 10, left: 10},
                    width = totalWidth,
                    height = (totalHeight - 10);
                var duration = 750,
                    root;

                var tree = d3.layout.tree()
                    .size([height, width]);

                var diagonal = d3.svg.diagonal()
                    .projection(function (d) {
                        return [d.y, d.x];
                    });

                var translate = { //eslint-disable-line
                    translate: [0, 0],
                    scale: 1
                };
                var zoom = d3.behavior.zoom()
                    .scaleExtent([0.08, 10])
                    .on("zoom", zoomed).translate(translate.translate).scale(translate.scale);

                function zoomed() {
                    translate = {
                        translate: d3.event.translate,
                        scale: d3.event.scale
                    };
                    d3.select("#treeComponents").attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                $scope.fnSetZoom = function () {
                    var n = d3.select('g#treeComponents').node().getBBox();
                    n.height = n.height + 50;
                    n.width = n.width + 50;
                    n.x = n.x - 25;
                    n.y = n.y - 25;
                    translate.scale = Math.min(height / n.height, width / n.width);
                    translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                    d3.select('g#treeComponents').attr("transform", "translate(" + translate.translate + ")scale(" + translate.scale + ")");
                    zoom.scale(translate.scale).translate(translate.translate);
                    $scope.isZoomPositionSet = true;
                };

                var svg = d3.select("#inventoryD3UserTreeview").append("svg")
                    .attr("viewBox", "0 0 " + width + " " + height)
                    .call(zoom)
                    .append("g")
                    .attr("id", "treeComponents")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                root = $scope.treeData;
                root.x0 = height / 2;
                root.y0 = 0;

                update(root);

                d3.select(self.frameElement).style("height", "500px");

                function update(source) {
                    var levelWidth = [1];
                    var childCount = function (level, n) {

                        if (n.children && n.children.length > 0) {
                            if (levelWidth.length <= level + 1) {
                                levelWidth.push(0);
                            }

                            levelWidth[level + 1] += n.children.length;
                            n.children.forEach(function (d) {
                                childCount(level + 1, d);
                            });
                        }
                    };
                    childCount(0, root);
                    var newHeight = d3.max(levelWidth) * 80; // 25 pixels per line
                    tree = tree.size([newHeight, 960]);
                    // Compute the new tree layout.
                    var nodes = tree.nodes(root).reverse(),
                        links = tree.links(nodes);

                    // Normalize for fixed-depth.
                    nodes.forEach(function (d) {
                        d.guid = guid();
                        d.y = d.depth * 180;
                    });

                    // Update the nodes…
                    var node = svg.selectAll("g.node")
                        .data(nodes, function (d) {
                            return d.guid;
                        });

                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node.enter().append("g")
                        .attr("class", function () {
                            return 'node';
                        })
                        .attr("transform", function () {
                            return "translate(" + source.y0 + "," + source.x0 + ")";
                        })
                        .on("click", click);

                    nodeEnter.append('rect')
                        .attr('height', function (d) {
                            return d.children || d._children ? '16.5px' : '10px';
                        })
                        .attr('width', function (d) {
                            if (d.type === 'device') {
                                return '28px';
                            } else if (d.type === "component") {
                                return '25px';
                            } else if (d.type === 'User') {
                                return '15px';
                            } else {
                                return d.children || d._children ? d.type === "User" ? '15px' : '20px' : '5px';
                            }
                        })
                        .attr("class", 'rect-fill')
                        .attr("x", function (d) {
                            return d.children || d._children ? '-13.5' : '-1.5';
                        })
                        .attr("y", '-7.5');
                    nodeEnter.append("text")
                        .attr("x", function (d) {
                            return d.children || d._children ? -11 : 1;
                        })
                        .attr("dy", function (d) {
                            if (d.type === 'device') {
                                return '0.38em';
                            } else if (d.type !== "device") {
                                return d.children || d._children ? d.name === "" ? "0.35em" : "0.4em" : "0.35em";
                            }
                        })
                        .attr("class", function (d) {
                            if (d.type === 'component') {
                                if (d.type === 'component' && d.enabled === false) {
                                    return 'treeIcon';
                                }
                                if (d.type === 'component' && !d.typeId) {
                                    return 'treeIcon fakeInventory';
                                }
                            } else {
                                return 'treeIcon';
                            }

                        })
                        .attr('font-family', 'FontAwesome')
                        .attr('font-size', '14px')
                        .style('stroke', 'none')
                        .style('fill', function (d) {
                            if (d.type === 'gateway' || d.type === 'device' || d.type === 'component') {
                                if (d.type === 'component' && !d.typeId) {
                                    return '';
                                } else {
                                    return ColorService.getHealthColorForLoop(d.health) ? ColorService.getHealthColorForLoop(d.health)['background-color'] : '';
                                }
                            } else {
                                return '';
                            }
                        })
                        .text(function (d) {
                            if (d.type === 'User') {
                                return '\uf007';
                            } else if (d.type === 'Group') {
                                return '\uf0c0';
                            } else if (d.type === 'gateway') {
                                return '\uf2db';
                            } else if (d.type === 'device') {
                                if (d.hasComponents) {
                                    return '\uf0e8 \uf054';
                                } else {
                                    return '\uf0e8';
                                }
                            } else if (d.type === 'component') {
                                if ((d.children && d.children.length) || (d._children && d._children.length)) {
                                    return '\uf140 \uf054';
                                } else {
                                    return '\uf140';
                                }
                            } else if (d.type === 'cluster') {
                                return '\uf00a';
                            } else {
                                return '\uf29a';
                            }
                        });

                    nodeEnter.append("text")
                        .attr("x", function (d) {
                            return d.type === 'device' && d.hasComponents ? -13 : d.children || d._children ? -13 : 20;
                        })
                        .attr("dy", function (d) {
                            return d.type === 'device' && d.hasComponents ? '2em' : d.children || d._children ? d.name === "" ? "0.35em" : "2em" : "0.35em";
                        })
                        .attr("text-anchor", function (d) {
                            return d.type === 'device' && d.hasComponents ? 'bottom' : d.children || d._children ? d.name === "" ? "end" : "bottom" : "start";
                        })
                        .text(function (d) {
                            if (d.type === 'component') {
                                return d.name && d.name !== ' ' ? d.name : d.index ? d.index.includes('#') ? d.index.split('#')[d.index.split('#').length - 1].replace(':', ' ') : d.index.replace(':', ' ') : 'default'
                            } else {
                                return d.name;
                            }
                        })
                        .style("fill-opacity", 1e-6)
                        .style("font-size", '10px')
                        .attr("class", function (d) {
                            if (d.type === 'component' && d.enabled === false) {
                                return 'fakeInventory';
                            } else {
                                return '';
                            }

                        });

                    // Transition nodes to their new position.
                    var nodeUpdate = node.transition()
                        .duration(duration)
                        .attr("transform", function (d) {
                            return "translate(" + d.y + "," + d.x + ")";
                        });

                    nodeUpdate.select("circle")
                        .attr("r", 10)
                        .attr("class", function () {
                            return 'treeCircle';
                        });

                    nodeUpdate.select("text")
                        .style("fill-opacity", 1);

                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node.exit().transition()
                        .duration(duration)
                        .attr("transform", function () {
                            return "translate(" + source.y + "," + source.x + ")";
                        })
                        .remove();

                    nodeExit.select("circle")
                        .attr("r", 1e-6);

                    nodeExit.select("text")
                        .style("fill-opacity", 1e-6);

                    // Update the links…
                    var link = svg.selectAll("path.link")
                        .data(links, function (d) {
                            return d.target.guid;
                        });

                    // Enter any new links at the parent's previous position.
                    link.enter().insert("path", "g")
                        .attr("class", "link")
                        .attr("d", function () {
                            var o = {x: source.x0, y: source.y0};
                            return diagonal({source: o, target: o});
                        });

                    // Transition links to their new position.
                    link.transition()
                        .duration(duration)
                        .attr("d", diagonal);

                    // Transition exiting nodes to the parent's new position.
                    link.exit().transition()
                        .duration(duration)
                        .attr("d", function () {
                            var o = {x: source.x, y: source.y};
                            return diagonal({source: o, target: o});
                        })
                        .remove();

                    // Stash the old positions for transition.
                    nodes.forEach(function (d) {
                        d.x0 = d.x;
                        d.y0 = d.y;
                    });
                }

                // Toggle children on click.
                function click(d) {
                    if (d.name !== "") {
                        if (d.type === 'device' && d.hasComponents && !d.isLoaded) {
                            if (d.children) {
                                d._children = [{
                                    name: 'Loading Components...',
                                    type: 'component'
                                }];
                                d.children = null;
                            } else {
                                d.children = [{
                                    name: 'Loading Components...',
                                    type: 'component'
                                }];
                                d._children = null;
                            }
                            update(d);
                            $scope.fnGetDeviceComponent(d);
                        } else {
                            if (d.children) {
                                d._children = d.children;
                                d.children = null;
                            } else {
                                d.children = d._children;
                                d._children = null;
                            }
                            update(d);
                        }
                    }
                }

                function guid() {
                    function s4() {
                        return Math.floor((1 + Math.random()) * 0x10000)
                            .toString(16)
                            .substring(1);
                    }

                    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
                }

                $timeout(function () {
                    $scope.fnSetZoom();
                }, 1000);

                $scope.fnGetDeviceComponent = function (device) {
                    ComponentFactory.getComponents({perPage: 0, deviceId: device.id})
                        .then(function (response) {
                            _.forEach(response, function (responseObj) {
                                responseObj.type = 'component';
                            });
                            var collator = new Intl.Collator(undefined, {
                                numeric: true,
                                sensitivity: 'base'
                            });
                            var indexArray = componentService.getUniqueIndex(response);
                            $scope.nestedComponentsArr = componentService.getHierarchy(indexArray, response);
                            $scope.nestedComponentsArr.forEach(function (treeObj) {
                                if (!treeObj.type) {
                                    treeObj.type = "component";
                                }
                            });
                            $scope.nestedComponentsArr.sort(function (a, b) {
                                return collator.compare(a.index, b.index)
                            });
                            $scope.nestedComponentsArr.forEach(function iter(a) {
                                if (a.children && a.children.length) {
                                    if (!a.children.type) {
                                        a.children.type = "component";
                                    }
                                    a.children.sort(function (a, b) {
                                        return collator.compare(a.index, b.index)
                                    });
                                }
                                return angular.isArray(a.children) && a.children.forEach(iter);
                            });
                            if (device.children) {
                                device._children = $scope.nestedComponentsArr;
                                device.children = null;
                            } else {
                                device.children = $scope.nestedComponentsArr;
                                device._children = null;
                            }
                            device.isLoaded = true;
                            click(device);
                            update(device);
                        }, function () {
                            if (device.children) {
                                device._children = [];
                                device.children = null;
                            } else {
                                device.children = [];
                                device._children = null;
                            }
                            device.isLoaded = true;
                            update(device);
                        });
                };
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('treeview', fnTreeview);

    /** @ngInject */
    function fnTreeview($timeout, d3, DB, ColorService, componentService) {
        return {
            restrict: 'EA',
            scope: {
                treeData: '=',
                getComponent: '&',
                registerCallBack: '&',
                renameComponent: '&',
                viewAttribute: '&'
            },
            templateUrl: "app/components/directives/interactiveTreeview/treeview.html",
            link: function ($scope) {
                $scope.total = 0;
                // set the dimensions of the canvas
                var search = angular.element("#SearchCol")[0].offsetHeight;
                var contentMain = angular.element(".content-main")[0].offsetHeight;
                var margin = {top: 5, right: 20, bottom: 20, left: 20},
                    width = angular.element(".content-main")[0].offsetWidth,
                    height = (contentMain - (search + 37)) - 10;
                var i = 0,
                    duration = 750,
                    root;

                var healthsObj = {};
                var healthArr = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                _.forEach(healthArr, function (healthObj) {
                    healthsObj[healthObj.code] = healthObj;
                });
                var tree = d3.layout.tree()
                    .size([height, width]);

                var diagonal = d3.svg.diagonal()
                    .projection(function (d) {
                        return [d.y, d.x];
                    });

                var translate = { //eslint-disable-line
                    translate: [0, 0],
                    scale: 1
                };
                var zoom = d3.behavior.zoom()
                    .scaleExtent([0.08, 10])
                    .on("zoom", zoomed).translate(translate.translate).scale(translate.scale);

                function zoomed() {
                    translate = {
                        translate: d3.event.translate,
                        scale: d3.event.scale
                    };
                    d3.select("#treeComponents").attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                $scope.fnSetZoom = function () {
                    var n = d3.select('g#treeComponents').node().getBBox();
                    n.height = n.height + 50;
                    n.width = n.width + 50;
                    n.x = n.x - 25;
                    n.y = n.y - 25;
                    translate.scale = Math.min(height / n.height, width / n.width);
                    translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                    d3.select('g#treeComponents').attr("transform", "translate(" + translate.translate + ")scale(" + translate.scale + ")");
                    zoom.scale(translate.scale).translate(translate.translate);
                };

                var svg = d3.select("#inventoryD3Treeview").append("svg")
                    .attr("viewBox", "0 0 " + width + " " + height)
                    .call(zoom)
                    .append("g")
                    .attr("id", "treeComponents")
                    .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
                var healthColor = '';
                var healthDarkColor = '';
                $scope.treeData.forEach(function (d) {
                    healthColor = healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health);
                    healthDarkColor = ColorService.getDark(healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health), 10);
                    d.healthColor = healthColor;
                    d.healthDarkColor = healthDarkColor;
                });
                var tempData = angular.copy($scope.treeData);
                var indexArray = componentService.getUniqueIndex(tempData);
                var nestedInventoriesArr = componentService.getHierarchy(indexArray, tempData);
                root = {
                    index: '',
                    children: nestedInventoriesArr,
                    health: 100,
                    healthColor: '#6CCCCC',
                    healthDarkColor: ColorService.getDark('#6CCCCC', 10)
                };
                root.x0 = height / 2;
                root.y0 = 0;

                var menu = [
                    {
                        text: function (data) {
                            return data.index !== "" && (angular.isDefined(data.children) || angular.isDefined(data._children)) && data.children ? "Collapse branch" : "Expand branch";
                        },
                        display: function (data) {
                            return data.index !== "" && (angular.isDefined(data.children) || angular.isDefined(data._children)) ? 'block' : 'none';
                        },
                        onClick: function (d) {
                            click(d);
                        }
                    }, {
                        text: function () {
                            return "Component Details";
                        },
                        display: function (data) {
                            if (data.enabled === true) {
                                return 'block';
                            } else {
                                return 'none'
                            }
                        },
                        onClick: function (d) {
                            $scope.fnGetComponentDetail(d);
                        }
                    }, {
                        text: function () {
                            return "Rename";
                        },
                        display: function (data) {
                            if (data.enabled === true) {
                                return 'block';
                            } else {
                                return 'none'
                            }
                        },
                        onClick: function (d) {
                            $scope.fnComponentRenameModal(d);
                        }
                    }, {
                        text: function () {
                            return "Edit Supplemental Data";
                        },
                        display: function (data) {
                            if (data.enabled === true) {
                                return 'block';
                            } else {
                                return 'none'
                            }
                        },
                        onClick: function (d) {
                            $scope.fnTriggerSupplementalDataModal(d);
                        }
                    }];

                $scope.fnGetComponentDetail = function (d) {
                    $scope.getComponent({componet: d});
                };

                $scope.fnTriggerSupplementalDataModal = function (d) {
                    $scope.getComponent({componet: d, isCalledForModal: true});
                };

                $scope.fnComponentRenameModal = function (d) {
                    $scope.selectedComponent = angular.copy(d);
                    $scope.renameComponent({componet: d});
                };

                $scope.fnOpenAttributeModal = function (d) {
                    $scope.viewAttribute({componet: d});
                };

                update(root);

                d3.select(self.frameElement).style("height", "500px");

                $scope.showContextMenu = function (data) {
                    d3.event.stopImmediatePropagation();
                    d3.event.preventDefault();
                    $scope.contextMenu = d3.select('body').selectAll('.context-menu-container').data([1]);
                    $scope.contextMenu.enter()
                        .append('div')
                        .attr('class', 'context-menu-container');
                    // this gets executed when a contextmenu event occurs
                    d3.select('body').selectAll('.context-menu-container')
                        .html('')
                        .append('ul')
                        .attr('class', 'context-menu-d3')
                        .selectAll('li')
                        .data(menu).enter()
                        .append('li')
                        .style('display', function (menuObj) {
                            return menuObj.display(data);
                        })
                        .append('a')
                        .on('click', function (menuObj) {
                            d3.event.preventDefault();
                            // show sub menu
                            $scope.contextMenu.style('display', 'none');
                            // self.menuContainer.classed('active', false);
                            menuObj.onClick(data);
                            return menuObj.event;
                        })
                        .text(function (menuObj) {
                            return menuObj.text(data);
                        });
                    $scope.contextMenu
                        .style('left', d3.event.pageX + 'px')
                        .style('top', d3.event.pageY + 'px')
                        .style('display', 'block');
                    d3.select('body').on('click', function () {
                        if ($scope.contextMenu) {
                            $scope.contextMenu.style('display', 'none');
                        }
                    })
                };

                function update(source) {
                    var levelWidth = [1];
                    var childCount = function (level, n) {

                        if (n.children && n.children.length > 0) {
                            if (levelWidth.length <= level + 1) {
                                levelWidth.push(0);
                            }

                            levelWidth[level + 1] += n.children.length;
                            n.children.forEach(function (d) {
                                childCount(level + 1, d);
                            });
                        }
                    };
                    childCount(0, root);
                    var newHeight = d3.max(levelWidth) * 80; // 25 pixels per line
                    tree = tree.size([newHeight, 960]);
                    // Compute the new tree layout.
                    var nodes = tree.nodes(root).reverse(),
                        links = tree.links(nodes);

                    // Normalize for fixed-depth.
                    nodes.forEach(function (d) {
                        d.y = d.depth * 180;
                    });

                    // Update the nodes…
                    var node = svg.selectAll("g.node")
                        .data(nodes, function (d) {
                            return d.id || (d.id = ++i);
                        });

                    // Enter any new nodes at the parent's previous position.
                    var nodeEnter = node.enter().append("g")
                        .attr("class", function (d) {
                            return d.index === '' ? 'node' : (!d.enabled || d.health === 0) ? 'node fakeInventory' : 'node';
                        })
                        .attr("transform", function () {
                            return "translate(" + source.y0 + "," + source.x0 + ")";
                        })
                        .on("click", function (d) {
                            if (d.index !== "" && d.enabled === true) {
                                $scope.fnOpenAttributeModal(d)
                            }
                        });//click

                    nodeEnter.append("circle")
                        .attr("r", 1e-6)
                        .style("fill", function (d) {
                            return d.healthColor ? d.healthColor : "#fff";
                        })
                        .on("contextmenu", function (d) {
                            if (d.index !== "") {
                                $scope.showContextMenu(d);
                            } else {
                                d3.select(".context-menu-container").remove();
                            }
                        });

                    nodeEnter.append("text")
                        .attr("x", function (d) {
                            return d.children || d._children ? -13 : 13;
                        })
                        .attr("dy", function (d) {
                            return d.children || d._children ? d.index === "" ? "0.35em" : "2em" : "0.35em";
                        })
                        .attr("text-anchor", function (d) {
                            return d.children || d._children ? d.index === "" ? "end" : "bottom" : "start";
                        })
                        .text(function (d) {
                            return d.name && d.name !== '' && d.name !== ' ' ? d.name :
                                d.index.includes('#') ? d.index.split('#')[d.index.split('#').length - 1].replace(':', ' ') : d.index.replace(':', ' ');
                        })
                        .style("fill-opacity", 1e-6);

                    // Update the text to reflect whether node has children or not.
                    node.select('text')
                        .attr("x", function (d) {
                            return d.children || d._children ? -13 : 13;
                        })
                        .attr("dy", function (d) {
                            return d.children || d._children ? d.index === "" ? "0.35em" : "2em" : "0.35em";
                        })
                        .attr("text-anchor", function (d) {
                            return d.children || d._children ? d.index === "" ? "end" : "bottom" : "start";
                        })
                        .text(function (d) {
                            return d.name && d.name !== '' && d.name !== ' ' ? d.name :
                                d.index.includes('#') ? d.index.split('#')[d.index.split('#').length - 1].replace(':', ' ') : d.index.replace(':', ' ');
                        })
                        .style("fill-opacity", 1e-6);

                    // Transition nodes to their new position.
                    var nodeUpdate = node.transition()
                        .duration(duration)
                        .attr("transform", function (d) {
                            return "translate(" + d.y + "," + d.x + ")";
                        });

                    nodeUpdate.select("circle")
                        .attr("r", 10)
                        .each(fnGetHealthColor);

                    function fnGetHealthColor(d) {
                        if (d.index !== '' && (d.children || d._children)) {
                            var backgroundColor = '';
                            if (d.health !== 0) {
                                backgroundColor = healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health);
                            } else {
                                var summaryHealthCode = d.health ? d.health : 0;
                                var children = d.children ? d.children : d._children;
                                angular.forEach(children, function (device) {
                                    if (device.summaryHealthCode && device.summaryHealthCode > summaryHealthCode) {
                                        summaryHealthCode = device.summaryHealthCode
                                    } else if (device.health > summaryHealthCode) {
                                        summaryHealthCode = device.health
                                    }
                                });
                                d.summaryHealthCode = summaryHealthCode;
                                backgroundColor = healthsObj[summaryHealthCode] ? healthsObj[summaryHealthCode].color : ColorService.getHealthColorForDeviceInventory(summaryHealthCode)
                            }
                            healthDarkColor = ColorService.getDark(backgroundColor, 10);
                            d3.select(this).style("fill", backgroundColor);
                            d3.select(this).style("stroke", healthDarkColor);
                        } else {
                            d3.select(this).style("fill", d.healthColor ? d.healthColor : '#fff');
                            d3.select(this).style("stroke", d.healthDarkColor ? d.healthDarkColor : '#fff');
                        }
                    }

                    nodeUpdate.select("text")
                        .style("fill-opacity", 1);

                    // Transition exiting nodes to the parent's new position.
                    var nodeExit = node.exit().transition()
                        .duration(duration)
                        .attr("transform", function () {
                            return "translate(" + source.y + "," + source.x + ")";
                        })
                        .remove();

                    nodeExit.select("circle")
                        .attr("r", 1e-6);

                    nodeExit.select("text")
                        .style("fill-opacity", 1e-6);

                    // Update the links…
                    var link = svg.selectAll("path.link")
                        .data(links, function (d) {
                            return d.target.id;
                        });

                    // Enter any new links at the parent's previous position.
                    link.enter().insert("path", "g")
                        .attr("class", "link")
                        .attr("d", function () {
                            var o = {x: source.x0, y: source.y0};
                            return diagonal({source: o, target: o});
                        });

                    // Transition links to their new position.
                    link.transition()
                        .duration(duration)
                        .attr("d", diagonal);

                    // Transition exiting nodes to the parent's new position.
                    link.exit().transition()
                        .duration(duration)
                        .attr("d", function () {
                            var o = {x: source.x, y: source.y};
                            return diagonal({source: o, target: o});
                        })
                        .remove();

                    // Stash the old positions for transition.
                    nodes.forEach(function (d) {
                        d.x0 = d.x;
                        d.y0 = d.y;
                    });
                }

                // Toggle children on click.
                function click(d) {
                    if (d.index !== "") {
                        if (d.children) {
                            d._children = d.children;
                            d.children = null;
                        } else {
                            d.children = d._children;
                            d._children = null;
                        }
                        update(d);
                    }
                }

                $scope.registerCallBack({
                    callback: function () {
                        var treeDataObj = {};
                        $scope.treeData.forEach(function (d) {
                            healthColor = healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health);
                            healthDarkColor = ColorService.getDark(healthsObj[d.health] ? healthsObj[d.health].color : ColorService.getHealthColorForDeviceInventory(d.health), 10);
                            d.healthColor = healthColor;
                            d.healthDarkColor = healthDarkColor;
                            treeDataObj[d.id] = d;
                        });

                        function fnGetData(data) {
                            _.forEach(data, function (inventoryObj) {
                                if (angular.isDefined(inventoryObj.name) && angular.isDefined(treeDataObj[inventoryObj.id])) {
                                    if (inventoryObj.id === treeDataObj[inventoryObj.id].id) {
                                        inventoryObj.name = treeDataObj[inventoryObj.id].name;
                                        inventoryObj.healthColor = treeDataObj[inventoryObj.id].healthColor;
                                        inventoryObj.healthDarkColor = treeDataObj[inventoryObj.id].healthDarkColor;
                                    }
                                }
                                if (inventoryObj.children && inventoryObj.children.length) {
                                    fnGetData(inventoryObj.children);
                                }
                            });
                        }

                        fnGetData(root.children);
                        update(root);
                        $scope.selectedComponent = angular.copy({});
                    }
                });
                $timeout(function () {
                    $scope.fnSetZoom();
                }, 1000);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightServiceDashboards', fnInsightServiceDashboards);

    /** @ngInject */
    function fnInsightServiceDashboards($sce, $window, $timeout, InsightDashboardFactory, moment, jsonToCsvConvertService, amaran, WidgetsListService, UserProfileService, $uibModal, PermissionsService) {
        return {
            restrict: 'EA',
            scope: {
                appName: "=",
                appKey: "=",
                serviceKey: "=",
                serviceName: '=',
                fnGetChartDetail: '&',
                fnGetChartEditor: '&',
                fnHideChart: '&'
            },
            templateUrl: "app/components/directives/insightServiceDashboards/insightServiceDashboards.html",
            link: function ($scope) {
                $scope.isDashboardIdSelected = false;
                $scope.isDashboardDetailsLoaded = false;
                $scope.widgets = [];

                $scope.options = {
                    cellHeight: 200,
                    verticalMargin: 20,
                    disableDrag: true,
                    disableResize: true
                };

                $scope.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                $scope.fnGetDashboardInfo = function (dashboardId) {
                    var inputObj = {
                        dashboardId: dashboardId
                    };
                    InsightDashboardFactory.executeDashboard(inputObj)
                        .then(function (response) {
                            $scope.widgets = [];
                            $scope.selectDashboardObj = _.cloneDeepWith(response);
                            $scope.selectDashboardObj.cells.sort(function (a, b) {
                                return a.y === b.y ? a.x - b.x : a.y - b.y;
                            });
                            var items = _.cloneDeepWith($scope.selectDashboardObj.cells);
                            var arranged = [];
                            for (var i = 0; i < items.length; i++) {
                                if (angular.isUndefined(items[i].wasAdded)) {
                                    arranged.push(items[i]);
                                    items[i].wasAdded = "true";
                                    for (var j = i + 1; j < items.length; j++) {
                                        if (items[i].y > items[j].y && angular.isUndefined(items[j].wasAdded)) {
                                            arranged.push(items[j]);
                                            items[j].wasAdded = "true";
                                        }
                                    }
                                }
                            }
                            $scope.selectDashboardObj.cells = _.cloneDeepWith(arranged);
                            _.forEach($scope.selectDashboardObj.cells, function (cellObj) {
                                cellObj.width = _.cloneDeepWith(cellObj.w);
                                cellObj.height = _.cloneDeepWith(cellObj.h);
                                delete cellObj.w;
                                delete cellObj.h;
                                if (cellObj.widget.chart && cellObj.widget.chart.syntax === 'HIGHCHARTS') {
                                    if (angular.isUndefined(cellObj.widget.layout.isExport)) {
                                        cellObj.widget.layout.isExport = true;
                                        cellObj.widget.layout.exportOptions = [
                                            {
                                                name: "Download PNG image",
                                                action: "downloadPNG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download JPEG image",
                                                action: "downloadJPEG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download PDF image",
                                                action: "downloadPDF",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download SVG vector image",
                                                action: "downloadSVG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download CSV File",
                                                action: "downloadCSV",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download XLS File",
                                                action: "downloadXLS",
                                                isAllow: true
                                            }
                                        ];
                                        cellObj.widget.layout.isTrackerExport = false
                                    }
                                    $scope.dataConfig = [];
                                    var headers = {};
                                    _.forEach(cellObj.widget.chart.definition.dataMapping, function (value, key) {
                                        $scope.dataConfig.push({
                                            key: key,
                                            value: value
                                        });
                                        headers[value] = value
                                    });
                                    var items = [];
                                    if (cellObj.widget.chart.definition.isSupportStringValue) {
                                        cellObj.widget.chart.definition.chartConfig.yAxis.categories = [];
                                    }
                                    _.forEach(cellObj.widget.chart.query.results.data, function (obj) {
                                        var tempObj = {};
                                        _.forEach($scope.dataConfig, function (dataConfigObj) {
                                            if (cellObj.widget.chart.definition.isSupportStringValue && dataConfigObj.key !== 'name') {
                                                if (obj[dataConfigObj.value] && obj[dataConfigObj.value] !== '' && cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1) {
                                                    cellObj.widget.chart.definition.chartConfig.yAxis.categories.push(obj[dataConfigObj.value]);
                                                }
                                                tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1 ? null : cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) : null;
                                            } else {
                                                tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                            }
                                        });
                                        items.push(tempObj);
                                    });
                                    items.unshift(headers);
                                    var jsonObject = angular.toJson(items);
                                    cellObj.widget.chart.definition.chartConfig.data = {
                                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                        "googleSpreadsheetKey": false,
                                        "googleSpreadsheetWorksheet": false,
                                        "decimalPoint": ","
                                    };
                                    if (angular.isDefined(cellObj.widget.chart.definition.chartFor)) {
                                        cellObj.widget.chart.definition.chartConfig.data = [];
                                        var chartData = [];
                                        _.forEach(items, function (obj) {
                                            if (obj.ts !== 'ts') {
                                                var tempObj = Object.values(obj);
                                                var tempA = tempObj[0].replace('T', ' ').split('.')[0];
                                                var timestamp = moment(tempA).format('x');
                                                tempObj[0] = parseInt(timestamp);
                                                chartData.push(tempObj);
                                            }
                                        })
                                        cellObj.widget.chart.definition.chartConfig.series = [];
                                        cellObj.widget.chart.definition.chartConfig.series.push({
                                            data: chartData,
                                            name: 'charts'
                                        });
                                        var tempValueAnomalyArr = {
                                            name: 'arearange',
                                            data: $scope.fnGenerateChartForecastAndAnomalyData(cellObj.widget.chart.query.results.data, cellObj.widget.chart.definition.chartFor, cellObj.widget.chart.definition.chartConfig),
                                            type: 'arearange',
                                            lineWidth: 0,
                                            linkedTo: ':previous',
                                            fillOpacity: 0.3,
                                            zIndex: 0,
                                            marker: {
                                                enabled: false
                                            }
                                        };
                                        cellObj.widget.chart.definition.chartConfig.series.push(tempValueAnomalyArr);
                                    }
                                }
                                $scope.widgets.push(cellObj);
                            })
                            $scope.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        })
                };

                $scope.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor, testingJSON) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = testingJSON.yAxis.categories.indexOf(tempDataObj.value) === -1 ? 0 : testingJSON.yAxis.categories.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                $scope.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                $scope.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                $scope.fnReload = function () {
                    $scope.fnInitInsightDashboards();
                };

                $scope.fnOpenDashboardListModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/dashboardListModal/dashboardListModal.html',
                        size: 'lg',
                        controller: 'dashboardListModalCtrl as dashboardListModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        var selectedDashboardId = _.cloneDeepWith(res.trim())
                        var dashboardIdPattern = /^(\w{8})-((\w{8}))$/g;
                        $scope.isDashboardIdSelected = dashboardIdPattern.test(selectedDashboardId);
                        if ($scope.isDashboardIdSelected) {
                            $scope.fnUpdateUserProfileData(selectedDashboardId);
                            $scope.isDashboardDetailsLoaded = false;
                            $scope.fnGetDashboardInfo(selectedDashboardId);
                        }
                    }, function () {

                    });
                };

                $scope.fnUpdateUserProfileData = function (id) {
                    UserProfileService.fnUpdateUserProfileObj($scope.appKey, $scope.serviceKey, 'dashboardWidgets', _.cloneDeepWith(id));
                };

                $scope.fnCreateIssue = function (widgetObj) {
                    return $scope.fnGetChartDetail({chartObj: widgetObj});
                }

                $scope.fnGetWidgetEditor = function () {
                    return $scope.fnGetChartEditor();
                }

                $scope.fnHideWidget = function () {
                    return $scope.fnHideChart();
                }

                $scope.fnInitInsightDashboards = function () {
                    $scope.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    var tempDashboardId = UserProfileService.fnGetUserProfileObj($scope.appKey, $scope.serviceKey, 'dashboardWidgets');
                    var dashboardIdPattern = /^(\w{8})-((\w{8}))$/g;
                    $scope.isDashboardIdSelected = dashboardIdPattern.test(tempDashboardId);
                    if ($scope.isDashboardIdSelected) {
                        $scope.isDashboardDetailsLoaded = false;
                        $scope.fnGetDashboardInfo(tempDashboardId);//cu000000-id84caee
                    }
                };

                $scope.fnInitInsightDashboards();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('insightDashboards', fnInsightDashboards);

    /** @ngInject */
    function fnInsightDashboards($sce, $window, $timeout, moment, InsightDashboardFactory, jsonToCsvConvertService, amaran, WidgetsListService, UserProfileService, $uibModal, PermissionsService) {
        return {
            restrict: 'EA',
            scope: {
                appName: "=",
                appKey: "=",
                serviceKey: "=",
                fnGetChartDetail: '&'
            },
            templateUrl: "app/components/directives/insightDashboards/insightDashboards.html",
            link: function ($scope) {
                $scope.isDashboardIdSelected = false;
                $scope.isDashboardDetailsLoaded = false;
                $scope.widgets = [];

                $scope.options = {
                    cellHeight: 200,
                    verticalMargin: 20,
                    disableDrag: true,
                    disableResize: true
                };

                $scope.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                $scope.fnGetDashboardInfo = function (dashboardId) {
                    var inputObj = {
                        dashboardId: dashboardId
                    };
                    InsightDashboardFactory.executeDashboard(inputObj)
                        .then(function (response) {
                            $scope.widgets = [];
                            $scope.selectDashboardObj = _.cloneDeepWith(response);
                            $scope.selectDashboardObj.cells.sort(function (a, b) {
                                return a.y === b.y ? a.x - b.x : a.y - b.y;
                            });
                            var items = _.cloneDeepWith($scope.selectDashboardObj.cells);
                            var arranged = [];
                            for (var i = 0; i < items.length; i++) {
                                if (angular.isUndefined(items[i].wasAdded)) {
                                    arranged.push(items[i]);
                                    items[i].wasAdded = "true";
                                    for (var j = i + 1; j < items.length; j++) {
                                        if (items[i].y > items[j].y && angular.isUndefined(items[j].wasAdded)) {
                                            arranged.push(items[j]);
                                            items[j].wasAdded = "true";
                                        }
                                    }
                                }
                            }
                            $scope.selectDashboardObj.cells = _.cloneDeepWith(arranged);
                            _.forEach($scope.selectDashboardObj.cells, function (cellObj) {
                                cellObj.width = _.cloneDeepWith(cellObj.w);
                                cellObj.height = _.cloneDeepWith(cellObj.h);
                                delete cellObj.w;
                                delete cellObj.h;
                                if (cellObj.widget.chart && cellObj.widget.chart.syntax === 'HIGHCHARTS') {
                                    if (angular.isUndefined(cellObj.widget.layout.isExport)) {
                                        cellObj.widget.layout.isExport = true;
                                        cellObj.widget.layout.exportOptions = [
                                            {
                                                name: "Download PNG image",
                                                action: "downloadPNG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download JPEG image",
                                                action: "downloadJPEG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download PDF image",
                                                action: "downloadPDF",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download SVG vector image",
                                                action: "downloadSVG",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download CSV File",
                                                action: "downloadCSV",
                                                isAllow: true
                                            },
                                            {
                                                name: "Download XLS File",
                                                action: "downloadXLS",
                                                isAllow: true
                                            }
                                        ];
                                        cellObj.widget.layout.isTrackerExport = false
                                    }
                                    $scope.dataConfig = [];
                                    var headers = {};
                                    _.forEach(cellObj.widget.chart.definition.dataMapping, function (value, key) {
                                        $scope.dataConfig.push({
                                            key: key,
                                            value: value
                                        });
                                        headers[value] = value
                                    });
                                    var items = [];
                                    if (cellObj.widget.chart.definition.isSupportStringValue) {
                                        cellObj.widget.chart.definition.chartConfig.yAxis.categories = [];
                                    }
                                    _.forEach(cellObj.widget.chart.query.results.data, function (obj) {
                                        var tempObj = {};
                                        _.forEach($scope.dataConfig, function (dataConfigObj) {
                                            if (cellObj.widget.chart.definition.isSupportStringValue && dataConfigObj.key !== 'name') {
                                                if (obj[dataConfigObj.value] && obj[dataConfigObj.value] !== '' && cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1) {
                                                    cellObj.widget.chart.definition.chartConfig.yAxis.categories.push(obj[dataConfigObj.value]);
                                                }
                                                tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) === -1 ? null : cellObj.widget.chart.definition.chartConfig.yAxis.categories.indexOf(obj[dataConfigObj.value]) : null;
                                            } else {
                                                tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                            }
                                        });
                                        items.push(tempObj);
                                    });
                                    items.unshift(headers);
                                    var jsonObject = angular.toJson(items);
                                    cellObj.widget.chart.definition.chartConfig.data = {
                                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                        "googleSpreadsheetKey": false,
                                        "googleSpreadsheetWorksheet": false,
                                        "decimalPoint": ","
                                    };
                                    if (angular.isDefined(cellObj.widget.chart.definition.chartFor)) {
                                        cellObj.widget.chart.definition.chartConfig.data = [];
                                        var chartData = [];
                                        _.forEach(items, function (obj) {
                                            if (obj.ts !== 'ts') {
                                                var tempObj = Object.values(obj);
                                                var tempA = tempObj[0].replace('T', ' ').split('.')[0];
                                                var timestamp = moment(tempA).format('x');
                                                tempObj[0] = parseInt(timestamp);
                                                chartData.push(tempObj);
                                            }
                                        })
                                        cellObj.widget.chart.definition.chartConfig.series = [];
                                        cellObj.widget.chart.definition.chartConfig.series.push({
                                            data: chartData,
                                            name: 'charts'
                                        });
                                        var tempValueAnomalyArr = {
                                            name: 'arearange',
                                            data: $scope.fnGenerateChartForecastAndAnomalyData(cellObj.widget.chart.query.results.data, cellObj.widget.chart.definition.chartFor, cellObj.widget.chart.definition.chartConfig),
                                            type: 'arearange',
                                            lineWidth: 0,
                                            linkedTo: ':previous',
                                            fillOpacity: 0.3,
                                            zIndex: 0,
                                            marker: {
                                                enabled: false
                                            }
                                        };
                                        cellObj.widget.chart.definition.chartConfig.series.push(tempValueAnomalyArr);
                                    }
                                }
                                $scope.widgets.push(cellObj);
                            })
                            $scope.isDashboardDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDashboardDetailsLoaded = true;
                        })
                };

                $scope.fnGenerateChartForecastAndAnomalyData = function (selectedData, intervalFor, testingJSON) {
                    var arr = [];
                    if (intervalFor === 'ValueForecast' || intervalFor === 'ValueAnomaly') {
                        var isStringFound = false;
                        _.forEach(selectedData, function (dataObj) {
                            if (dataObj.value && isNaN(dataObj.value)) {
                                isStringFound = true;
                            }
                        });
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (isStringFound) {
                                    if (tempDataObj.value && tempDataObj.value !== '') {
                                        var value = testingJSON.yAxis.categories.indexOf(tempDataObj.value) === -1 ? 0 : testingJSON.yAxis.categories.indexOf(tempDataObj.value);
                                        var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                        arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                    } else {
                                        arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                    }
                                } else {
                                    var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.value)) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), tempDataObj.value ? Number(tempDataObj.value) - confidenceValue : 0 - confidenceValue, tempDataObj.value ? Number(tempDataObj.value) + confidenceValue : confidenceValue]);
                                }
                            });
                        })
                    }
                    if (intervalFor === 'HealthForecast' || intervalFor === 'HealthAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                var confidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * Number(tempDataObj.health)) / 100) / 2 : 0;
                                arr.push([parseInt(moment(tempA).format('x')), tempDataObj.health !== "" ? Number(tempDataObj.health) - confidenceValue : 0 - confidenceValue, tempDataObj.health !== "" ? Number(tempDataObj.health) + confidenceValue : confidenceValue]);
                            });
                        })
                    }
                    if (intervalFor === 'ConnectionForecast' || intervalFor === 'ConnectionAnomaly') {
                        _.forEach(selectedData, function (tempDataObj) {
                            var tempA = tempDataObj.ts.replace('T', ' ').split('.')[0];
                            $timeout(function () {
                                if (tempDataObj.value && tempDataObj.value !== '') {
                                    var value = tempDataObj.value === true ? 1 : -1;
                                    var stringConfidenceValue = tempDataObj.confidence ? (((100 - tempDataObj.confidence) * value) / 100) / 2 : 0;
                                    arr.push([parseInt(moment(tempA).format('x')), parseInt(stringConfidenceValue) - value, parseInt(stringConfidenceValue) + value]);
                                } else {
                                    arr.push([parseInt(moment(tempA).format('x')), 0, 0]);
                                }
                            });
                        })
                    }
                    return arr;
                };

                $scope.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                $scope.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                $scope.fnReload = function () {
                    $scope.fnInitInsightDashboards();
                };

                $scope.fnOpenDashboardListModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/dashboardListModal/dashboardListModal.html',
                        size: 'lg',
                        controller: 'dashboardListModalCtrl as dashboardListModal',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (res) {
                        var selectedDashboardId = _.cloneDeepWith(res.trim())
                        var dashboardIdPattern = /^(\w{8})-((\w{8}))$/g;
                        $scope.isDashboardIdSelected = dashboardIdPattern.test(selectedDashboardId);
                        if ($scope.isDashboardIdSelected) {
                            $scope.fnUpdateUserProfileData(selectedDashboardId);
                            $scope.isDashboardDetailsLoaded = false;
                            $scope.fnGetDashboardInfo(selectedDashboardId);
                        }
                    }, function () {

                    });
                };

                $scope.fnUpdateUserProfileData = function (id) {
                    UserProfileService.fnUpdateUserProfileObj($scope.appKey, $scope.serviceKey, 'dashboardWidgets', _.cloneDeepWith(id));
                };

                $scope.fnCreateIssue = function (widgetObj) {
                    return $scope.fnGetChartDetail({chartObj: widgetObj});
                }

                $scope.fnInitInsightDashboards = function () {
                    $scope.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    var tempDashboardId = UserProfileService.fnGetUserProfileObj($scope.appKey, $scope.serviceKey, 'dashboardWidgets');
                    var dashboardIdPattern = /^(\w{8})-((\w{8}))$/g;
                    $scope.isDashboardIdSelected = dashboardIdPattern.test(tempDashboardId);
                    if ($scope.isDashboardIdSelected) {
                        $scope.isDashboardDetailsLoaded = false;
                        $scope.fnGetDashboardInfo(tempDashboardId);
                    }
                };

                $scope.fnInitInsightDashboards();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('horizontalBarChart', fnHorizontalBarChart);

    /** @ngInject */
    function fnHorizontalBarChart($timeout, Highcharts, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                categoriesArr: '=',
                nodeId: '=',
                filterObj: '=',
                infoSectionClass: "=",
                isShowGateway: '=',
                isFromGateway: '=',
                isShowTitle: '=',
                isGatewayShowHideOption: '='
            },
            templateUrl: "app/components/directives/horizontalBarChart/horizontalBarChart.html",
            link: function ($scope) {
                var filename, start, end;
                if ($scope.filterObj.type === 'relative') {
                    start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                    end = moment().toISOString()
                } else {
                    start = moment($scope.filterObj.start).toISOString();
                    end = moment($scope.filterObj.stop).toISOString();
                }
                filename = $scope.nodeId + '_connection_' + start + '_' + end;

                $scope.$watch('infoSectionClass', function () {
                    $scope.fnDrawChart();
                }, true);

                $scope.isViewGateway = true;
                $scope.fnHideShowGateway = function(){
                    $scope.isShowGateway = $scope.isViewGateway;
                    $timeout(function () {
                        $scope.fnDrawChart();
                    })
                };

                $scope.fnDrawChart = function () {
                    var chartDataCp = [];
                    if ($scope.isShowGateway) {
                        chartDataCp = angular.copy($scope.chartData)
                    } else {
                        chartDataCp = _.filter($scope.chartData, function (chartObj) {
                            return chartObj.y === 0;
                        })
                    }
                    $timeout(function () {
                        Highcharts.chart('horizontalBarChartMainContainer', {
                            chart: {
                                type: 'xrange',
                                height: $scope.isShowGateway ? 300 : 250,
                                marginTop: angular.isDefined($scope.isShowTitle) && $scope.isShowTitle === false ? 60 : 0
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: angular.isDefined($scope.isShowTitle) && $scope.isShowTitle === false ? '' : 'CONNECTION',
                                align: 'left'
                            },
                            subtitle: {
                                text: ''
                            },
                            xAxis: {
                                type: 'datetime',
                                labels: {
                                    formatter: function () {
                                        return moment(this.value).format("MM/DD HH:mm");
                                    },
                                    overflow: 'justify',
                                    rotation: -45
                                }
                            },
                            yAxis: {
                                categories: $scope.isFromGateway ? ["Gateway"] : $scope.isShowGateway ? ['Device', 'Gateway'] : ['Device'],
                                title: {
                                    text: ''
                                }
                            },
                            tooltip: {
                                enabled: false
                            },
                            legend: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    borderRadius: 0,
                                    groupPadding: 0,
                                    pointPadding: 0,
                                    events: {
                                        legendItemClick: function () {
                                            if (this.chart && this.chart.series && this.chart.series.length > 1) {
                                                var count = this.chart.series.length;
                                                _.forEach(this.chart.series, function (ser) {
                                                    if (!ser.visible) {
                                                        count--;
                                                    }
                                                });
                                                if (count === 1 && this.visible) {
                                                    return false;
                                                }
                                            } else {
                                                return false;
                                            }
                                        }
                                    }
                                }
                            },
                            series: [{
                                name: 'Series',
                                pointWidth: 20,
                                data: chartDataCp
                            }],
                            navigation: {
                                buttonOptions: {
                                    height: 25,
                                    width: 25,
                                    symbolSize: 12,
                                    symbolX: 13,
                                    symbolY: 13,
                                    symbolStrokeWidth: 2,
                                    theme: {
                                        'stroke-width': 1,
                                        stroke: 'silver',
                                        r: 50
                                    }
                                }
                            },
                            exporting: {
                                filename: filename,
                                csv: {
                                    columnHeaderFormatter: function (item, key) {
                                        if (key === 'x' || angular.isUndefined(key)) {
                                            return 'Start Timestamp';
                                        } else {
                                            return key
                                        }
                                    }
                                },
                                buttons: {
                                    contextButton: {
                                        menuItems: $scope.isGatewayShowHideOption ? ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG','label'] :['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                                    }
                                },
                                menuItemDefinitions: {
                                    printChart: {
                                        onclick: function () {
                                            var divToPrint = document.getElementById('horizontalBarChartMainContainer');
                                            var newWin = window.open(); //eslint-disable-line
                                            newWin.document.write(divToPrint.innerHTML);
                                            newWin.document.close();
                                            newWin.focus();
                                            newWin.print();
                                            newWin.close();
                                        }
                                    },
                                    label: {
                                        onclick: function () {
                                            $scope.isViewGateway = !$scope.isViewGateway;
                                            $scope.fnHideShowGateway();
                                        },
                                        text: $scope.isViewGateway ? "Hide Gateway" : "Show Gateway"
                                    }
                                }
                            }
                        });
                    })
                };

                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('heatMapChart', fnLineChart);

    /** @ngInject */
    function fnLineChart(Highcharts, $timeout, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                nodeId: '=',
                type: '=',
                infoSectionClass: "=",
                filterObj: '=',
                isAggregateHealth: "=",
                compArr: "=",
                categoriesArr: "="
            },
            templateUrl: "app/components/directives/heatMapChart/heatMapChart.html",
            link: function ($scope) {
                var filename, start, end;
                if ($scope.filterObj.type === 'relative') {
                    start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                    end = moment().toISOString()
                } else {
                    start = moment($scope.filterObj.start).toISOString();
                    end = moment($scope.filterObj.stop).toISOString();
                }
                $scope.isShowBorder = moment(end).diff(moment(start), 'hours') <= 3;
                filename = $scope.nodeId + '_' + $scope.type + '_' + start + '_' + end;
                $scope.$watch('infoSectionClass', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.fnDrawChart();
                    }
                }, true);
                $scope.isShowLabel = false;
                $scope.fnShowLabel = function () {
                    $scope.fnDrawChart();
                };
                $scope.fnDrawChart = function () {
                    $timeout(function () {
                        Highcharts.chart($scope.isAggregateHealth ? "aggregateHeatMapChartMainContainer" : "atomicHeatMapChartMainContainer", {
                            chart: {
                                type: 'heatmap',
                                margin: $scope.isAggregateHealth ? [50, 10, 75, 80] : $scope.isShowLabel ? [50, 10, 75] : [50, 10, 75, 80],
                                plotBorderWidth: 0,
                                inverted: true,
                                height: $scope.isAggregateHealth ? 160 : null
                            },
                            boost: {
                                useGPUTranslations: true,
                                usePreallocated: true
                            },
                            title: {
                                text: '',
                                align: 'left'
                            },
                            credits: {
                                enabled: false
                            },
                            xAxis: {
                                categories: $scope.compArr,
                                visible: $scope.isAggregateHealth ? false : $scope.isShowLabel
                            },
                            legend: {
                                enabled: false
                            },
                            yAxis: {
                                title: null,
                                visible: true,
                                tickInterval: Math.ceil($scope.categoriesArr.length/10),
                                tickPositioner: function(min, max){
                                    var interval = this.options.tickInterval,
                                        ticks = [],
                                        count = 0;
                                    while(min < max) {
                                        ticks.push(min);
                                        min += interval;
                                        count ++;
                                    }
                                    var isLastValue = ticks[ticks.length - 1];
                                    if(isLastValue < max){
                                        ticks.push(max);
                                    }
                                    ticks.info = {
                                        unitName: 'day',
                                        count: count,
                                        higherRanks: {},
                                        totalRange: interval * count
                                    };
                                    return ticks;
                                },
                                categories: $scope.categoriesArr ? $scope.categoriesArr : [],
                                labels: {
                                    rotation: -60
                                },
                                showLastLabel: false
                            },
                            tooltip: {
                                formatter: function () {
                                    var healthValue = this.point.healthObj.content === this.point.value ? this.point.value : this.point.healthObj.content + ' (' + this.point.value + ')';
                                    return '<b>' + this.series.xAxis.categories[this.point.x] + '</b> <br><b>' +
                                        this.point.date + '</b><br><b>' + healthValue + '</b>';
                                }
                            },
                            series: [{
                                name: '',
                                borderWidth: $scope.isShowBorder ? 1 : 0,
                                borderColor: "#ffffff",
                                data: $scope.chartData,
                                turboThreshold: $scope.chartData.length + 100
                            }],
                            navigation: {
                                buttonOptions: {
                                    height: 25,
                                    width: 25,
                                    symbolSize: 12,
                                    symbolX: 13,
                                    symbolY: 13,
                                    symbolStrokeWidth: 2,
                                    theme: {
                                        'stroke-width': 1,
                                        stroke: 'silver',
                                        r: 50
                                    }
                                }
                            },
                            exporting: {
                                filename: filename,
                                csv: {
                                    dateFormat: '%Y-%m-%d %H:%M:%S'
                                },
                                buttons: {
                                    contextButton: {
                                        menuItems: $scope.isAggregateHealth ? ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'] : ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'label']
                                    }
                                },
                                menuItemDefinitions: {
                                    printChart: {
                                        onclick: function () {
                                            var divToPrint = document.getElementById($scope.isAggregateHealth ? "aggregateHeatMapChartMainContainer" : "atomicHeatMapChartMainContainer");
                                            var newWin = window.open(); //eslint-disable-line
                                            newWin.document.write(divToPrint.innerHTML);
                                            newWin.document.close();
                                            newWin.focus();
                                            newWin.print();
                                            newWin.close();
                                        }
                                    },
                                    label: {
                                        onclick: function () {
                                            $scope.isShowLabel = !$scope.isShowLabel;
                                            $scope.fnShowLabel();
                                        },
                                        text: $scope.isShowLabel ? "Hide Label" : "Show Label"
                                    }
                                }
                            }

                        })
                        ;
                    })
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('graphRelationships', fnGraphRelationships);

    /** @ngInject */
    function fnGraphRelationships(ColorService) {
        return {
            restrict: 'EA',
            scope: {
                nodeObj: '=',
                selectedId: '=',
                fnGetNodeDetail: '&',
                fnGetNodeTelemetryDetail: '&'
            },
            templateUrl: "app/components/directives/graphRelationships/graphRelationships.html",
            link: function ($scope) {

                $scope.fnGetNodeInfo = function (nodeObj) {
                    return $scope.fnGetNodeDetail({nodeObj: nodeObj});
                };

                $scope.fnGetNodeTelemetryInfo = function (nodeObj) {
                    return $scope.fnGetNodeTelemetryDetail({nodeObj: nodeObj});
                };

                $scope.getHealthColor = function (nodeCode, nodeObj) {
                    if(nodeCode !== ''){
                        var nodeStyle = ColorService.getHealthColorForLoop(nodeObj.projectId, nodeCode);
                        nodeObj.healthName = nodeStyle.content;
                        return nodeStyle;
                    } else {
                        return {};
                    }
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ghostVisualizers', fnGhostVisualizers);

    /** @ngInject */
    function fnGhostVisualizers($timeout, $compile, d3, $window, GhostService, ColorService) {
        return {
            restrict: 'EA',
            scope: {
                mainImg: '=',
                mainArr: '=',
                ghostData: '=',
                isView: '='
            },
            templateUrl: "app/components/directives/ghostVisualizers/ghostVisualizers.html",
            link: function ($scope, element) {
                $scope.fnSetBGImage = function () {
                    var i = new Image();

                    i.onload = function () {
                        imgs
                            .attr("xlink:href", $scope.mainImg)
                            .attr("width", i.width)
                            .attr("height", i.height);
                        imgContainer.attr("transform", 'translate(' + ((width - imgs.attr("width")) / 2) + ',' + ((width - imgs.attr("height")) / 2) + ')');
                        $scope.fnSetZoom();
                    };
                    i.src = $scope.mainImg;

                };
                $scope.fnSetZoom = function () {
                    var n = d3.select('g#chartGroup').node().getBBox();
                    n.height = n.height + 50;
                    n.width = n.width + 50;
                    n.x = n.x - 25;
                    n.y = n.y - 25;
                    translate.scale = Math.min(height / n.height, width / n.width);
                    translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                    d3.select('g#chartGroup').attr("transform", "translate(" + translate.translate + ")scale(" + translate.scale + ")");
                    zoom.scale(translate.scale).translate(translate.translate);
                };
                $scope.fnReDrawSelected = function (lineToggle) {
                    if (lineToggle) {
                        $scope.selectedNode.linkType = $scope.selectedNode.linkType !== 'square' ? 'square' : 'straight'
                    }
                    if ($scope.selectedNode.id.indexOf('rect') > -1) {
                        $scope.nodeContainer.select('#' + $scope.selectedNode.id).select("rect.rect-border").call($scope.fnSetRectAttr);
                    } else if ($scope.selectedNode.id.indexOf('circle') > -1) {
                        $scope.nodeContainer.select('#' + $scope.selectedNode.id).call($scope.fnSetTargetCircleAttr);
                        $scope.fnEUD_links();
                    }
                    $scope.fnSaveData();
                };
                var menu = [
                    {
                        text: "Delete",
                        display: function () {
                            return 'block';
                        },
                        onClick: function () {
                            $scope.fnDeleteNode();
                        }
                    }];

                function hexify(color) {
                    var values = color
                        .replace(/rgba?\(/, '')
                        .replace(/\)/, '')
                        .replace(/[\s+]/g, '')
                        .split(',');
                    var a = parseFloat(values[3] || 1),
                        r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
                        g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
                        b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
                    return "#" +
                        ("0" + r.toString(16)).slice(-2) +
                        ("0" + g.toString(16)).slice(-2) +
                        ("0" + b.toString(16)).slice(-2);
                }

                $scope.fnSaveData = function () {
                    var data = {
                        nodes: {
                            source: $scope.data.nodes.source,
                            target: $scope.data.nodes.target
                        },
                        links: $scope.data.links.map(function (d) { //eslint-disable-line
                            return {sId: d.source.id, tId: d.target.id}
                        })
                    };
                    localStorage.setItem('ghostData', JSON.stringify(data)); //eslint-disable-line
                };
                $scope.showContextMenu = function (d) {
                    d3.event.stopImmediatePropagation();
                    d3.event.preventDefault();
                    if (!$scope.isView) {
                        d3.selectAll(".target-selected").classed('target-selected', false);
                        //Select only clicked node
                        d3.select(this).classed('target-selected', true);
                        $scope.contextMenu = d3.select('body').selectAll('.context-menu-container').data([1]);
                        $scope.contextMenu.enter()
                            .append('div')
                            .attr('class', 'context-menu-container');

                        // this gets executed when a contextmenu event occurs
                        d3.select('body').selectAll('.context-menu-container')
                            .html('')
                            .append('ul')
                            .attr('class', 'context-menu-d3')
                            .selectAll('li')
                            .data(menu).enter()
                            .append('li')
                            .style('display', function (menuObj) {
                                return menuObj.display(menuObj, d);
                            })
                            .append('a')
                            .on('click', function (menuObj) {
                                d3.event.preventDefault();
                                // show sub menu
                                $scope.contextMenu.style('display', 'none');
                                // self.menuContainer.classed('active', false);
                                menuObj.onClick(menuObj, d, d3.event);
                                return menuObj.event;
                            })
                            .text(function (t) {
                                return t.text;
                            });
                        $scope.contextMenu
                            .style('left', d3.event.pageX + 'px')
                            .style('top', d3.event.pageY + 'px')
                            .style('display', 'block');
                        d3.select('body').on('click', function () {
                            if ($scope.contextMenu) {
                                $scope.contextMenu.style('display', 'none');
                            }
                        })
                    }
                }
                $scope.showNodeOption = function () {
                    d3.event.stopImmediatePropagation();
                    d3.event.preventDefault();
                    if (!$scope.isView) {
                        $scope.nodeOptionMenu = d3.select('.node-menu-container');
                        $scope.nodeOptionMenu.style('display', 'block');
                        /*d3.select('body').on('click', function () {
                            if ($scope.nodeOptionMenu) {
                                $scope.nodeOptionMenu.style('display', 'none');
                            }
                        })*/
                    }
                }
                $scope.fnGetData = function () {
                    $scope.elementObj = {};
                    $scope.data = $scope.ghostData ? $scope.ghostData : localStorage.getItem('ghostData') ? JSON.parse(localStorage.getItem('ghostData')) : { //eslint-disable-line
                        nodes: {
                            source: [],
                            target: []
                        },
                        links: []
                    };
                    var linkData = _.cloneDeep($scope.data.links); //eslint-disable-line
                    $scope.data.links = [];
                    var sourceIdList = $scope.data.nodes.source.map(function (d) {
                        return d.id
                    });
                    var targetIdList = $scope.data.nodes.target.map(function (d) {
                        return d.id
                    });
                    angular.forEach(linkData, function (d) {
                        $scope.data.nodes.target[targetIdList.indexOf(d.tId)].linkType = $scope.data.nodes.target[targetIdList.indexOf(d.tId)].linkType ? $scope.data.nodes.target[targetIdList.indexOf(d.tId)].linkType : 'straight';
                        $scope.data.links.push({
                            source: $scope.data.nodes.source[sourceIdList.indexOf(d.sId)],
                            target: $scope.data.nodes.target[targetIdList.indexOf(d.tId)]
                        })
                    });
                    var objectIdArr = $scope.mainArr.map(function (c) {
                        return c.name
                    });
                    angular.forEach($scope.data.nodes.source, function (d) {
                        d.object = $scope.mainArr[objectIdArr.indexOf(d.objectId)] ? $scope.mainArr[objectIdArr.indexOf(d.objectId)] : d.object;
                    })
                };

                // Dimensions of sunburst (from parent)
                var width = element.parent()[0].offsetWidth, line;
                var height = element.parent()[0].offsetHeight;
                var rect = {
                    width: 210,
                    height: 160
                };
                $scope.fnGetData();

                angular.element($window).bind('resize', function () {
                    width = element.parent()[0].offsetWidth;
                    height = element.parent()[0].offsetHeight;
                    d3.select('#ghostVisualizers').select('svg').select("rect")
                        .attr("width", width)
                        .attr("height", height);
                    d3.select('#ghostVisualizers').select('svg').attr("viewBox", "0 0 " + width + " " + height)

                    /*  scope.width = $window.innerWidth;

                     // manuall $digest required as resize event
                     // is outside of angular
                     scope.$digest();*/
                });


                var translate = localStorage.getItem('ghostDataZoom') ? JSON.parse(localStorage.getItem('ghostDataZoom')) : { //eslint-disable-line
                    translate: [0, 0],
                    scale: 1
                };
                var zoom = d3.behavior.zoom()
                    .scaleExtent([0.05, 10])
                    .on("zoom", zoomed).translate(translate.translate).scale(translate.scale);

                function zoomed() {
                    translate = {
                        translate: d3.event.translate,
                        scale: d3.event.scale
                    };
                    localStorage.setItem('ghostDataZoom', JSON.stringify(translate)); //eslint-disable-line
                    container.attr("transform", "translate(" + d3.event.translate + ")scale(" + d3.event.scale + ")");
                }

                var sourceId, targetId; //eslint-disable-line
                var svg = d3.select('#ghostVisualizers')
                    .append('svg:svg')
                    .attr("preserveAspectRatio", "xMidYMid")
                    .attr("viewBox", "0 0 " + width + " " + height)
                    .on('click', function () {
                        d3.event.stopImmediatePropagation();
                        d3.selectAll(".target-selected").classed('target-selected', false);
                        if ($scope.contextMenu) {
                            $scope.contextMenu.style('display', 'none');
                        }
                        if ($scope.nodeOptionMenu) {
                            $scope.nodeOptionMenu.style('display', 'none');
                        }
                    })
                    .on('dragover', function () {
                        if (!$scope.isView) {
                            d3.event.preventDefault();
                        }
                    })
                    .on('drop', function () {
                        var ev = d3.mouse(imgContainer.node());
                        var objectId = JSON.parse(d3.event.dataTransfer.getData("text")).name; //eslint-disable-line
                        $scope.data.nodes.source.push({
                            x: ev[0],
                            y: ev[1],
                            id: 'rect' + (new Date()).getTime(),
                            objectId: objectId,
                            object: $scope.mainArr.filter(function (c) {
                                return c.name === objectId
                            })[0]
                        });
                        // $scope.value = $event.originalEvent.offsetX;
                        $scope.fnEUD_SourceNode();
                    })
                    .on("mousedown", fnSVGMouseDown)
                    .on("mouseup", fnSVGMouseUp)
                    .append("g").attr("transform", "translate(0,0)")
                    .call(zoom);
                svg.append("rect")
                    .attr("width", width)
                    .attr("height", height)
                    .style("fill", "none")
                    .style("pointer-events", "all");
                var container = svg.append("g")
                    .attr("id", "chartGroup").attr("transform", "translate(" + translate.translate + ")scale(" + translate.scale + ")");
                var imgContainer = container.append("g");
                var imgs = imgContainer.selectAll("image").data([0]);
                imgs.enter()
                    .append("svg:image").attr('id', 'image-ele');
                $scope.fnSetBGImage();

                function fnSVGMouseDown() {
                    if (d3.event.altKey) {
                        d3.event.stopImmediatePropagation();
                        sourceId = $(d3.event.target).closest('.draggableEle')[0].id; //eslint-disable-line
                        var m = d3.mouse(imgContainer.node()); // + d3.mouse(d3.select('#'+sourceId));
                        line = $scope.linkContainer.append("line")
                            .attr("class", 'draw-line')
                            .attr("x1", m[0])
                            .attr("y1", m[1])
                            .attr("x2", m[0])
                            .attr("y2", m[1])
                            .style("stroke", '#ffc107')
                            .style("stroke-width", '3px')
                            .style("stroke-linecap", 'round');

                        svg.on("mousemove", fnSVGMouseMove);
                    }
                }

                function fnSVGMouseMove() {
                    if (line && d3.event.altKey) {
                        d3.event.stopImmediatePropagation();
                        var m = d3.mouse(imgContainer.node());
                        line
                            .attr("x2", m[0])
                            .attr("y2", m[1]);
                    }
                }

                function fnSVGMouseUp() {
                    if (line && d3.event.altKey) {
                        targetId = d3.event.target.id;
                        svg.on("mousemove", null);
                        nodeDrag.on("drag", $scope.fnNodeDragged);
                        if (sourceId.indexOf('rect') !== -1) {
                            var sourceObj = $scope.data.nodes.source.filter(function (d) {
                                return d.id === sourceId;
                            });
                            if (sourceObj.length) {
                                $scope.fnAddTargetCircle(sourceObj[0], d3.mouse(imgContainer.node()));
                                $scope.fnEUD_links();
                            }
                        }
                    }
                    line = null;
                    d3.select('line.draw-line').remove();
                }

                d3.select("body")
                    .on("keydown", function () {
                        if (d3.event.keyCode === 46) {
                            $scope.fnDeleteNode();
                        }
                    });
                $scope.fnDeleteNode = function () {
                    if (d3.selectAll('circle.target-selected')[0].length) {
                        d3.selectAll('circle.target-selected').each(function (d) {
                            $scope.data.nodes.target = $scope.data.nodes.target.filter(function (c) {
                                return c.id !== d.id
                            });
                            $scope.data.links = $scope.data.links.filter(function (c) {
                                return c.target.id !== d.id
                            });
                            $scope.fnEUD_targetCircle();
                            $scope.fnEUD_links();
                        });
                    } else if (d3.selectAll('g.draggableEle.target-selected')[0].length) {
                        d3.selectAll('g.draggableEle.target-selected').each(function (d) {
                            $scope.data.nodes.source = $scope.data.nodes.source.filter(function (c) {
                                return c.id !== d.id
                            });
                            $scope.data.links.forEach(function (l) {
                                if (l.source.id === d.id) {
                                    $scope.data.nodes.target = $scope.data.nodes.target.filter(function (c) {
                                        return c.id !== l.target.id
                                    });
                                }
                            });

                            $scope.data.links = $scope.data.links.filter(function (c) {
                                return c.source.id !== d.id
                            });
                            $scope.fnEUD_SourceNode();
                            $scope.fnEUD_targetCircle();
                            $scope.fnEUD_links();
                        });
                    }
                    if ($scope.nodeOptionMenu) {
                        $scope.nodeOptionMenu.style('display', 'none');
                    }
                };
                //Create the drag and drop behavior to set for the objects crated
                var nodeDrag = d3.behavior.drag()
                    .origin(function () {
                        var t = d3.transform(d3.select(this).attr("transform"));
                        return {x: t.translate[0], y: t.translate[1]};
                    })
                    .on("dragstart", function () {
                        if (!d3.event.sourceEvent.altKey) {
                            d3.event.sourceEvent.stopPropagation();
                        }
                    })
                    .on("drag", function () {
                        if (d3.event.sourceEvent.altKey) {
                            // cancel the drag event
                            nodeDrag.on("drag", null);
                        } else {
                            nodeDrag.on("drag", $scope.fnNodeDragged);
                        }
                    });

                $scope.fnEUD_links = function () {
                    var lineData = _.filter($scope.data.links, function (d) {
                        return d.target.linkType === 'straight'
                    });
                    var linksSelection = $scope.linkContainer.selectAll("line.link")
                        .data(lineData, function (d) {
                            return d.source.id + '_' + d.target.id;
                        });
                    linksSelection.enter()
                        .append("line");
                    linksSelection.call($scope.fnEUD_setLineAttr);
                    linksSelection.exit().remove();

                    var pathData = _.filter($scope.data.links, function (d) {
                        return d.target.linkType === 'square'
                    });
                    var pathsSelection = $scope.linkContainer.selectAll("path.link")
                        .data(pathData, function (d) {
                            return d.source.id + '_' + d.target.id;
                        });
                    pathsSelection.enter()
                        .append("path");
                    pathsSelection.call($scope.fnEUD_setPathAttr);

                    pathsSelection.exit().remove();
                    $scope.fnSaveData();
                };

                function getDistance(point1, point2) {
                    var xs = point2.x - point1.x;
                    xs = xs * xs;

                    var ys = point2.y - point1.y;
                    ys = ys * ys;

                    return Math.sqrt(xs + ys);
                }

                /* var diagonal = d3.svg.diagonal()
                     .target(function (d) {
                         return {x: d.sourceY, y: d.sourceX};
                     })
                     .source(function (d) {
                         return {x: d.targetY, y: d.targetX};
                     })
                     .projection(function (d) {
                         return [d.y, d.x];
                     });*/
                $scope.fnEUD_setPathAttr = function (selection) {
                    selection
                        .attr('id', function (d) {
                            return 'line' + d.target.id
                        })
                        .attr("class", "link")
                        .attr("d", function (d) {
                            var pointArray = [{x: d.source.x + (rect.width / 2), y: d.source.y, line: ['V']},
                                {x: d.source.x + rect.width, y: d.source.y + (rect.height / 2), line: ['H']},
                                {x: d.source.x + (rect.width / 2), y: d.source.y + rect.height, line: ['V']},
                                {x: d.source.x, y: d.source.y + (rect.height / 2), line: ['H']}];
                            var distance = [];
                            angular.forEach(pointArray, function (f) {
                                distance.push(getDistance(f, d.target))
                            });
                            d.sourceX = pointArray[distance.indexOf(d3.min(distance))].x;
                            d.sourceY = pointArray[distance.indexOf(d3.min(distance))].y;
                            d.lineArray = pointArray[distance.indexOf(d3.min(distance))].line;
                            var circlePoint;
                            if (d.lineArray[0] === 'V') {
                                var xVal = d.sourceX > d.target.x ? (d.target.x + 8) : (d.target.x - 8);
                                circlePoint = {x: xVal, y: d.target.y}
                            } else {
                                var yVal = d.sourceY > d.target.y ? (d.target.y + 8) : (d.target.y - 8);
                                circlePoint = {x: d.target.x, y: yVal}
                            }
                            d.targetX = circlePoint.x;
                            d.targetY = circlePoint.y;
                            return 'M' + d.sourceX + ' ' + d.sourceY
                                + ' L' + (d.lineArray[0] === 'H' ? d.targetX : d.sourceX) + ' ' + (d.lineArray[0] === 'H' ? d.sourceY : d.targetY) + ' '
                                + ' L' + d.targetX + ' ' + d.targetY
                        })
                        .attr("stroke", function (d) {
                            d.target.borderColor = d.target.borderColor ? d.target.borderColor : "#ffc107";
                            return d.target.borderColor
                        })
                        .attr("stroke-opacity", function (d) {
                            d.target.borderOpacity = typeof d.target.borderOpacity !== 'undefined' ? parseFloat(d.target.borderOpacity) : 1;
                            return d.target.borderOpacity
                        })
                        .attr("stroke-width", function (d) {
                            d.target.borderWidth = typeof d.target.borderWidth !== 'undefined' ? d.target.borderWidth : 3;
                            return d.target.borderWidth;
                        })
                        .style("stroke-linecap", 'round')
                        .style("fill", 'none');
                }
                $scope.fnEUD_setLineAttr = function (selection) {
                    selection
                        .attr('id', function (d) {
                            return 'line' + d.target.id
                        })
                        .attr("class", "link")
                        .attr("x1", function (d) {
                            var pointArray = [{x: d.source.x + (rect.width / 2), y: d.source.y},
                                {x: d.source.x + rect.width, y: d.source.y + (rect.height / 2)},
                                {x: d.source.x + (rect.width / 2), y: d.source.y + rect.height},
                                {x: d.source.x, y: d.source.y + (rect.height / 2)}];
                            var distance = [];
                            angular.forEach(pointArray, function (f) {
                                distance.push(getDistance(f, d.target))
                            });
                            d.sourceX = pointArray[distance.indexOf(d3.min(distance))].x;
                            d.sourceY = pointArray[distance.indexOf(d3.min(distance))].y;
                            return d.sourceX;
                        })
                        .attr("y1", function (d) {
                            return d.sourceY;
                        })
                        .attr("x2", function (d) {
                            var x1 = d.sourceX,
                                y1 = d.sourceY,
                                x2 = d.target.x,
                                y2 = d.target.y,
                                angle = Math.atan2(y2 - y1, x2 - x1);
                            d.targetX = x2 - Math.cos(angle) * (8);
                            d.targetY = y2 - Math.sin(angle) * (8);
                            return d.targetX;
                        })
                        .attr("y2", function (d) {
                            return d.targetY;
                        })
                        .attr("stroke", function (d) {
                            d.target.borderColor = d.target.borderColor ? d.target.borderColor : "#ffc107";
                            return d.target.borderColor
                        })
                        .attr("stroke-opacity", function (d) {
                            d.target.borderOpacity = typeof d.target.borderOpacity !== 'undefined' ? parseFloat(d.target.borderOpacity) : 1;
                            return d.target.borderOpacity
                        })
                        .attr("stroke-width", function (d) {
                            d.target.borderWidth = typeof d.target.borderWidth !== 'undefined' ? d.target.borderWidth : 3;
                            return d.target.borderWidth;
                        })
                        .style("stroke-linecap", 'round');
                }
                $scope.fnEUD_SourceNode = function () {
                    var rectGSelection = $scope.nodeContainer.selectAll(".draggableEle").data($scope.data.nodes.source, function (d) {
                        return d.id
                    });
                    $scope.fnSaveData();
                    rectGSelection
                        .enter()
                        .append("g")
                        .attr('transform', function (d) {
                            return "translate(" + d.x + "," + d.y + ")"
                        });
                    rectGSelection.call($scope.fnSetRectGElementAttr);
                    var rectSelection = rectGSelection.selectAll("rect.rect-border")
                        .data(function (d) {
                            return [d];
                        });
                    rectSelection.enter().append('rect');
                    rectSelection.call($scope.fnSetRectAttr);
                    rectSelection.exit().remove();
                    var healthRectSelection = rectGSelection.selectAll("g.healthG")
                        .data(function (d) {
                            return [d];
                        });
                    healthRectSelection.enter().append('g');
                    healthRectSelection.attr('class', 'healthG');
                    healthRectSelection.exit().remove();

                    var healthTextSelection = rectGSelection.selectAll("text.health")
                        .data(function (d) {
                            return [d];
                        });
                    healthTextSelection.enter().append('text').call($scope.fnEU_setHeathTextAttr);
                    healthTextSelection.call($scope.fnEU_setHeathTextAttr);
                    healthTextSelection.exit().remove();

                    var foreignObjectSelection = rectGSelection.selectAll("foreignObject")
                        .data(function (d) {
                            return [d];
                        });
                    foreignObjectSelection.enter().append('foreignObject').call($scope.fnE_setForeignObjAttr);
                    foreignObjectSelection.call($scope.fnU_setForeignObjAttr);
                    foreignObjectSelection.exit().remove();

                    rectGSelection.exit().remove();
                };
                $scope.fnSetTargetCircleAttr = function (selection) {
                    selection
                        .attr('id', function (d) {
                            return d.id;
                        })
                        .attr('class', 'target-circle')
                        .classed('target-selected', function (d) {
                            return $scope.selectedNode && $scope.selectedNode.id === d.id
                        })
                        .attr("cx", function () {
                            return 0
                        })
                        .attr("cy", function () {
                            return 0
                        })
                        .attr("r", function () {
                            return 8
                        })
                        .attr("stroke", function (d) {
                            d.borderColor = d.borderColor ? d.borderColor : "#ffc107";
                            return d.borderColor
                        })
                        .attr("stroke-opacity", function (d) {
                            d.borderOpacity = typeof d.borderOpacity !== 'undefined' ? parseFloat(d.borderOpacity) : 1;
                            return d.borderOpacity
                        })
                        .attr("stroke-width", function (d) {
                            d.borderWidth = typeof d.borderWidth !== 'undefined' ? parseInt(d.borderWidth) : 3;
                            return d.borderWidth
                        })
                        .style("fill", function (d) {
                            d.bgColor = d.bgColor ? d.bgColor : "#F7931E";
                            return d.bgColor
                        })
                        .attr("fill-opacity", function (d) {
                            d.bgOpacity = typeof d.bgOpacity !== 'undefined' ? parseFloat(d.bgOpacity) : 1;
                            return d.bgOpacity
                        })
                        .on("click", function (d) {
                            if (!$scope.isView) {
                                d3.event.stopImmediatePropagation();
                                $scope.selectedNode = d;
                                // Deselect all node;
                                d3.selectAll(".target-selected").classed('target-selected', false);
                                //Select only clicked node
                                d3.select(this).classed('target-selected', true);
                                $scope.showNodeOption(d);
                            }
                        })
                        .attr('transform', function (d) {
                            return "translate(" + d.x + "," + d.y + ")";
                        })
                        .each(function () {
                            if (!$scope.isView) {
                                d3.select(this).call(nodeDrag)
                            }
                        });
                };
                $scope.fnSetRectGElementAttr = function (selection) {
                    selection.attr('class', 'draggableEle')
                        .classed('target-selected', function (d) {
                            return $scope.selectedNode && $scope.selectedNode.id === d.id
                        })
                        .attr('id', function (d) {
                            return d.id;
                        })
                        .on("click", function (d) {
                            if (!$scope.isView) {
                                $scope.selectedNode = d;
                                d3.event.stopImmediatePropagation();
                                // Deselect all node;
                                d3.selectAll(".target-selected").classed('target-selected', false);
                                //Select only clicked node
                                d3.select(this).classed('target-selected', true);
                                $scope.showNodeOption(d);
                            }
                        })
                        .on('contextmenu', $scope.showContextMenu)
                        .each(function () {
                            if (!$scope.isView) {
                                d3.select(this).call(nodeDrag)
                            }
                        })
                };
                $scope.fnSetRectAttr = function (selection) {
                    selection
                        .attr('class', 'rect-border')
                        .attr("x", 0)
                        .attr("y", 0)
                        .attr("width", function () {
                            return rect.width
                        })
                        .attr("height", function () {
                            return rect.height
                        })
                        .attr("stroke", function (d) {
                            d.borderColor = d.borderColor ? d.borderColor : "#cccccc";
                            return d.borderColor
                        })
                        .attr("stroke-opacity", function (d) {
                            d.borderOpacity = typeof d.borderOpacity !== 'undefined' ? parseFloat(d.borderOpacity) : 1;
                            return d.borderOpacity
                        })
                        .attr("stroke-width", function (d) {
                            d.borderWidth = typeof d.borderWidth !== 'undefined' ? parseInt(d.borderWidth) : 2;
                            return d.borderWidth
                        })
                        .style("fill", function (d) {
                            d.bgColor = d.bgColor ? d.bgColor : "#ffffff";
                            return d.bgColor
                        })
                        .attr("fill-opacity", function (d) {
                            d.bgOpacity = typeof d.bgOpacity !== 'undefined' ? parseFloat(d.bgOpacity) : 1;
                            return d.bgOpacity
                        });
                };
                $scope.fnU_setForeignObjAttr = function (selection) {
                    selection
                        .attr("x", 0)
                        .attr("y", 0)
                        .attr("width", function () {
                            return rect.width
                        })
                        .attr("height", function () {
                            return rect.height
                        })
                };
                $scope.fnEU_setHeathTextAttr = function (selection) {
                    selection
                        .attr("x", 10)
                        .attr("y", rect.height - 12)
                        .text(function (d) {
                            return d.object.health;
                        })
                        .style('text-anchor', 'start')
                        //.style('dominant-baseline', 'hanging')
                        .style('fill', function (d) {
                            var bgColor = d.object.healthColor.startsWith("#") ? d.object.healthColor : hexify(d.object.healthColor);
                            return ColorService.getContrastTextColor(bgColor);
                        })
                        .each(function (d) {
                            var bbox = d3.select(this).node().getBBox();
                            d3.select(this.parentNode).select('g.healthG').selectAll('.health-rect').remove();
                            d3.select(this.parentNode).select('g.healthG')
                                .append('rect')
                                .attr('class', 'health-rect')
                                .style('fill', d.object.healthColor)
                                .attr('x', bbox.x - 5)
                                .attr('y', bbox.y - 2.5)
                                .style("stroke", '#ccc')
                                .style("stroke-width", 1)
                                .attr('width', bbox.width + 10)
                                .attr('height', bbox.height + 5);
                        });
                };
                $scope.fnE_setForeignObjAttr = function (selection) {
                    selection.html(getUI).each(function (d) {
                        if (d.object.value !== null) {
                            if (d.object.display === "Gauge") {
                                if (d.object.value !== null && !isNaN(d.object.value)) {
                                    $scope.elementObj[d.id].knobOptions = {
                                        size: 150,
                                        startAngle: -90,
                                        endAngle: 90,
                                        readOnly: true,
                                        unit: $scope.elementObj[d.id].units ? $scope.elementObj[d.id].units : '',
                                        trackColor: "#D3D3D3",
                                        barColor: GhostService.fnGetColor($scope.elementObj[d.id].options, $scope.elementObj[d.id].value),
                                        trackWidth: 15,
                                        barWidth: 15,
                                        fontSize: '20',
                                        subText: {
                                            enabled: true,
                                            text: ''
                                        },
                                        max: $scope.elementObj[d.id].options.max,
                                        min: $scope.elementObj[d.id].options.min
                                    };
                                    angular.element(this).find('div.container').append($compile('<ui-knob value="elementObj[\'' + d.id + '\'].value" options="elementObj[\'' + d.id + '\'].knobOptions"></ui-knob>')($scope));
                                } else {
                                    angular.element(this).find('div.container').append('<label style="font-size:3em">' + $scope.elementObj[d.id].value + '</label>');
                                }
                                // })
                            } else if (d.object.display === "Toggle") {
                                var tempVal = GhostService.fnGetToggleValue($scope.elementObj[d.id].options, $scope.elementObj[d.id].value);
                                angular.element(this).find('div.container').append($compile('<svg-toggle-switch is-checked="' + tempVal.switchValue + '" is-disabled="' + $scope.isView + '"></svg-toggle-switch>')($scope));
                                angular.element(this).find('div.container').append('<br><label style="font-size:2em">' + tempVal.displayText + '</label>');
                            }
                        }
                    });
                }

                function getUI(d) {
                    var htmlUI;
                    $scope.elementObj[d.id] = d.object;
                    $scope.elementObj[d.id].title = d.object.title ? d.object.title : "&nbsp;";
                    var defualtHtml = '<div class="container p-5" style="width: 100%; height: 100%; text-align: center">' +
                        '<h4>' + $scope.elementObj[d.id].title + '</h4>' +
                        '<div style="display: block">' +
                        '<label style="font-size:3em">' + GhostService.fnGetTextValue($scope.elementObj[d.id].options, $scope.elementObj[d.id].value===null?"":$scope.elementObj[d.id].value) + '</label></div></div>';

                    if (d.object.value === null) {
                        htmlUI = '<div class="container p-5" style="width: 100%; height: 100%; text-align: center; background: #ccc">' +
                            '<h1 style="color: #000">Missing Attribute</h1>' +
                            '</div>';
                    } else {
                        switch (d.object.display) {
                            case "Gauge":
                            case "Toggle":
                                htmlUI = '<div class="container p-5" style="width: 100%; height: 100%; text-align: center">' +
                                    '<h4>' + $scope.elementObj[d.id].title + '</h4>' +
                                    '</div>';
                                break;
                            case "Stack":
                                if (d.object.value !== null && !isNaN(d.object.value)) {
                                    if (d.object.options.stackType === 'vertical') {
                                        htmlUI = '<div class="container p-5 p-l-10 p-r-10" style="width: 100%; height: 100%; text-align: center">' +
                                            '<h4>' + $scope.elementObj[d.id].title + '</h4>' +
                                            '<div class="progress progress-bar-vertical">\n' +
                                            '    <div class="progress-bar progress-bar-success active" role="progressbar" style="height:' + $scope.elementObj[d.id].value + '%; background-color:' + GhostService.fnGetColor($scope.elementObj[d.id].options, $scope.elementObj[d.id].value) + '" title="' + $scope.elementObj[d.id].value + $scope.elementObj[d.id].units + '">\n' +
                                            '  </div>' +
                                            '</div>' +
                                            '<div><span>' + $scope.elementObj[d.id].value + '</span> <span>' + $scope.elementObj[d.id].units + '</span></div>';
                                    } else {
                                        htmlUI = '<div class="container p-5 p-l-10 p-r-10" style="width: 100%; height: 100%; text-align: center">' +
                                            '<h4>' + $scope.elementObj[d.id].title + '</h4>' +
                                            '<div class="progress" style="height:50px; border-radius:0">\n' +
                                            '    <div class="progress-bar progress-bar-success" role="progressbar" style="width:' + $scope.elementObj[d.id].value + '%; background-color:' + GhostService.fnGetColor($scope.elementObj[d.id].options, $scope.elementObj[d.id].value) + '" title="' + $scope.elementObj[d.id].value + $scope.elementObj[d.id].units + '">\n' +
                                            '  </div></div>' +
                                            '<div><label>' + $scope.elementObj[d.id].value + ' ' + $scope.elementObj[d.id].units + '</label></div>';
                                    }
                                } else {
                                    htmlUI = defualtHtml;
                                }
                                break;
                            case "Icon":
                                htmlUI = '<div class="container p-5" style="width: 100%; height: 100%; text-align: center ">' +
                                    '<h4>' + $scope.elementObj[d.id].title + '</h4>' +
                                    '<i style="font-size:4em; display: block; text-align: center" class="fa ' + GhostService.fnGetIconValue($scope.elementObj[d.id].options, $scope.elementObj[d.id].value) + '"></i></div>';
                                break;
                            /*  case "Toggle":
                             htmlUI = '<switch id="federationSwitch" ng-model="fedSwitchValue"></switch>';
                             break;*/
                            default:
                                htmlUI = defualtHtml;
                                break;
                        }
                    }

                    return htmlUI;
                }

                $scope.fnAddTargetCircle = function (source, event) {
                    var t = d3.transform(imgContainer.attr('transform')); //eslint-disable-line
                    $scope.data.nodes.target.push({
                        x: event[0],
                        y: event[1],
                        id: 'circle' + (new Date()).getTime(),
                        linkType: 'straight'
                    });
                    $scope.data.links.push({
                        source: source,
                        target: $scope.data.nodes.target[$scope.data.nodes.target.length - 1]
                    });
                    $scope.fnEUD_targetCircle();
                };
                $scope.fnEUD_targetCircle = function () {
                    var circleSelection = $scope.nodeContainer.selectAll(".target-circle").data($scope.data.nodes.target, function (d) {
                        return d.id
                    });
                    $scope.fnSaveData();
                    circleSelection
                        .enter()
                        .append("circle");
                    circleSelection.call($scope.fnSetTargetCircleAttr);
                    circleSelection.exit().remove();
                };

                $scope.linkContainer = imgContainer.append("g")
                    .attr("id", "linkGroup");
                $scope.nodeContainer = imgContainer.append("g")
                    .attr("id", "nodeGroup");
                $scope.fnNodeDragged = function (d) {
                    if (!d3.event.sourceEvent.altKey) {
                        d.x = d3.event.x;
                        d.y = d3.event.y;
                        d3.select(this)
                            .attr({
                                transform: "translate(" + d.x + "," + d.y + ")"
                            });
                        $scope.fnEUD_links();
                    }
                };

                $scope.fnEUD_SourceNode();
                $scope.fnEUD_targetCircle();
                $scope.fnEUD_links();
                $scope.$watch('mainImg', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.mainImg = newValue;
                        if (imgs) {
                            $scope.fnSetBGImage();
                        }
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('focusMe', function($timeout, $parse) {
            return {
                //scope: true,   // optionally create a child scope
                link: function(scope, element, attrs) {
                    var model = $parse(attrs.focusMe);
                    scope.$watch(model, function(value) {
                        if(value === true) {
                            $timeout(function() {
                                element[0].focus();
                            });
                        }
                    });
                }
            };
        })
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('expandCollapseContainer', fneExpandCollapseContainer);

    /** @ngInject */
    function fneExpandCollapseContainer() {
        return {
            restrict: 'EA',
            scope: {
                infoSectionClass: '=',
                fnExpandCollapseEvent: '&'
            },
            templateUrl: "app/components/directives/expandCollapseContainer/expandCollapseContainer.html",
            link: function ($scope) {

                $scope.fnExpandCollapse = function () {
                    return $scope.fnExpandCollapseEvent();
                };

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('stateTemplate', fnStateTemplate);

    /** @ngInject */
    function fnStateTemplate(ColorService) {
        return {
            restrict: 'EA',
            scope: {
                stateObject: "=",
                widthAuto: "="
            },
            template: '<div class="col-xs-12 stateFigure">' +
            '                <label class="stateLabel ellipsis">' +
            '                     <img class="stateIcon" ng-src="data:image/svg+xml;base64,{{stateObject.icon}}" />' +
            '                     <span class="stateText">{{stateObject.name}}</span>' +
            '                </label>' +
            '           </div>',
            link: function (scope, element) {
                var stateLabel = element[0].querySelector(".stateLabel");
                stateLabel.style.width = scope.widthAuto ? "auto" : "100%";
                stateLabel.style.padding = "5px 5px";
                stateLabel.style.background = scope.stateObject.color;
                stateLabel.style.borderRadius = "5px";
                stateLabel.style.border = "solid rgba(0,0,0,0.3)";
                stateLabel.style.margin = "0";
                stateLabel.style.fontWeight = "normal";
                stateLabel.style.position = "relative";

                var stateIcon = element[0].querySelector(".stateIcon");
                stateIcon.style.position = "absolute";
                stateIcon.style.background = ColorService.getDark(scope.stateObject.color, 15);
                stateIcon.style.padding = "6px";
                stateIcon.style.top = "0";
                stateIcon.style.left = "0";

                var stateText = element[0].querySelector(".stateText");
                stateText.style.marginLeft = "32px";
                stateText.style.fontSize = "12px";
                stateText.style.fontWeight = "bold";
                stateText.style.color = ColorService.getContrastTextColor(scope.stateObject.color)
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('draw2dPalette', fnDraw2dPalette);

    /** @ngInject */
    function fnDraw2dPalette($window, $parse, $timeout) {
        return {
            restrict: 'E,A',
            scope: {
                triggerCount: "=",
                editor: "=",
                triggerStateDragStart: "&"
            },
            template: '<uib-accordion class="accordionPanel" close-others="false">' +
            '    <uib-accordion-group ng-repeat="(key, stateArr) in editor.palette.figuresObj"' +
            '                          ng-if="key !== \'TRIGGER\'" is-open="isOpen" class="{{checkTrigger(key)}}" role="button">' +
            '        <uib-accordion-heading>' +
            '            <div>' +
            '                {{key}}' +
            '                <i class="fa pull-right" ng-class="isOpen ? \'fa-caret-down\' : \'fa-caret-up\'"></i>' +
            '            </div>' +
            '        </uib-accordion-heading>' +
            '        <div class="row" ng-repeat="stateObj in stateArr track by $index">' +
            '            <div state-template class="draw2d_droppable" state-object="stateObj" data-state="{{stateObj}}">' +
            '            </div>' +
            '        </div>' +
            '    </uib-accordion-group>' +
            '</uib-accordion>',
            link: function (scope, element, attrs, controller) {
                scope.checkTrigger = function (key) {
                    return key === "TRIGGER" && scope.triggerCount ? 'pace' : '';
                };

                scope.checkTrigger1 = function (key) {
                    return key !== "TRIGGER";
                };
                scope.isOpen = true;

                // $timeout is used just to ensure that the template is rendered if we want access them
                // (leave the render cycle)
                $timeout(function () {
                    $(".draw2d_droppable").draggable({
                        appendTo: "body",
                        stack: "body",
                        zIndex: 27000,
                        helper: "clone",
                        drag: function (event, ui) {
                        },
                        stop: function (e, ui) {
                        },
                        start: function (e, ui) {
                            scope.triggerStateDragStart();
                            $(ui.helper).addClass("shadow");
                        }
                    });
                }, 0);

                scope.$watch('triggerCount', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        scope.triggerCount = newValue;
                    }
                }, true);
            },
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('draw2dCanvas', fnDraw2dCanvas);

    /** @ngInject */
    function fnDraw2dCanvas($window, $parse, $timeout) {
        return {
            restrict: 'EA',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var stackListener = 0;

                // provide the scope properties and override the defaults with the user settings
                //
                scope.editor = $.extend(true, {
                    canvas: {
                        width: 2000,
                        height: 2000,
                        fnInit: function (canvas) {
                        },
                        onDrop: function (dropTarget, x, y, shiftKey, ctrlKey) {
                        },
                        createConnection: function (sourcePort, targetPort) {
                        },
                        jsonRead: function () {
                        }
                    },
                    palette: {
                        figures: []
                    },
                    state: {
                        dirty: false,
                        canUndo: false,
                        canRedo: false
                    },
                    selection: {
                        className: null,
                        figure: null,
                        attr: null
                    },

                }, scope.editor);


                // init the Draw2D Canvas with the given user settings and overriden hooks
                //

                var canvas = new draw2d.Canvas(element.attr("id"), scope.editor.canvas.width, scope.editor.canvas.height);
                canvas.setScrollArea("#" + element.attr("id"));
                canvas.onDrop = $.proxy(scope.editor.canvas.onDrop, canvas);
                canvas.onRightClick = $.proxy(scope.editor.canvas.onRightClick, canvas);
                canvas.createConnection = $.proxy(scope.editor.canvas.createConnection, canvas);
                canvas.jsonRead = $.proxy(scope.editor.canvas.jsonRead, canvas);
                canvas.fnInit = $.proxy(scope.editor.canvas.fnInit, canvas);
                canvas.fnInit(canvas);

                // Install a special policy into the canvas to use my own implementation of connection
                // if we drag&drop a port
                canvas.installEditPolicy(new draw2d.policy.connection.DragConnectionCreatePolicy({
                    createConnection: canvas.createConnection
                }))

                var CanvasPolicy = draw2d.policy.canvas.CanvasPolicy.extend({
                    NAME: 'CanvasPolicy',
                    init: function () {
                        this._super();
                    },
                    onRightMouseDown: function (figure, mouseX, mouseY) {
                        document.addEventListener('callFromModelView', function (e) {
                            viewCall = e.detail;
                        });
                        if (figure && !viewCall) {
                            var mainFigure = figure;
                            if(figure.getRoot()){
                                mainFigure = figure.getRoot();
                            }

                            $.contextMenu({
                                selector: 'body',
                                events:
                                    {
                                        hide: function () {
                                            $.contextMenu('destroy');
                                        }
                                    },
                                callback: $.proxy(function (key) {
                                    switch (key) {
                                        case "delete":
                                            // with undo/redo support
                                            var cmd = new draw2d.command.CommandDelete(mainFigure);
                                            mainFigure.getCanvas().getCommandStack().execute(cmd);
                                        default:
                                            break;
                                    }

                                }, this),
                                x: mouseX,
                                y: mouseY,
                                items:
                                    {
                                        "delete": {name: "Delete"}
                                    }
                            });
                        }
                        else {
                            $("svg").bind("contextmenu", function (event) {
                                event.preventDefault();
                            })
                            $("svg").triggerHandler("contextmenu");
                        }
                    }
                });
                canvas.installEditPolicy(new CanvasPolicy());

                // update the scope model with the current state of the
                // CommandStack
                var stack = canvas.getCommandStack();

                stack.addEventListener(function (event) {
                    stackListener++;
                    $timeout(function () {
                        scope.editor.state.canUndo = stack.canUndo();
                        scope.editor.state.canRedo = stack.canRedo();
                    }, 0);

                    if (stackListener > 1) {
                        scope.fnGetJson();
                    }
                });

                // Update the selection in the model
                // and Databinding Draw2D -> Angular
                var changeCallback = function (emitter, attribute) {
                    $timeout(function () {
                        if (scope.editor.selection.attr !== null) {
                            scope.editor.selection.attr[attribute] = emitter.attr(attribute);
                        }
                    }, 0);
                };
                canvas.on("select", function (canvas, event) {
                    var figure = event.figure;
                    if (figure instanceof draw2d.Connection) {
                        return; // silently
                    }

                    $timeout(function () {
                        if (figure !== null) {
                            scope.editor.selection.className = figure.NAME;
                            scope.editor.selection.attr = figure.attr();
                        }
                        else {
                            scope.editor.selection.className = null;
                            scope.editor.selection.attr = null;
                        }

                        // unregister and register the attr listener to the new figure
                        //
                        if (scope.editor.selection.figure !== null) {
                            scope.editor.selection.figure.off("change", changeCallback);
                        }
                        scope.editor.selection.figure = figure;
                        if (scope.editor.selection.figure !== null) {
                            scope.editor.selection.figure.on("change", changeCallback);
                        }
                    }, 0);
                });

                // Databinding: Angular UI -> Draw2D
                // it is neccessary to call the related setter of the draw2d object. "Normal" Angular
                // Databinding didn't work for draw2d yet
                //
                scope.$watchCollection("editor.selection.attr", function (newValues, oldValues) {

                    if (oldValues !== null && scope.editor.selection.figure !== null) {
                        // for performance reason we post only changed attributes to the draw2d figure
                        //
                        var changes = draw2d.util.JSON.diff(newValues, oldValues);
                        scope.editor.selection.figure.attr(changes);
                    }
                });


                // get canvas json when stack change lisent
                scope.fnGetJson = function () {
                    var writer = new draw2d.io.json.Writer();
                    writer.marshal(canvas, function (json) {
                        // convert the json object into string representation
                        var jsonTxt = JSON.stringify(json, null, 2);

                        ngModel.$setViewValue(jsonTxt);
                        // insert the json string into a DIV for preview or post
                        // it via ajax to the server....
                        $("#json").text(jsonTxt);
                        stackListener = 0;
                    });
                };

                // push the canvas function to the scope for ng-action access
                //
                scope.editor.undo = $.proxy(stack.undo, stack);
                scope.editor.redo = $.proxy(stack.redo, stack);
                scope.editor["delete"] = $.proxy(function () {
                    var node = this.getCurrentSelection();
                    var command = new draw2d.command.CommandDelete(node);
                    this.getCommandStack().execute(command);
                }, canvas);
                scope.editor.load = $.proxy(function (json) {
                    canvas.clear();
                    var reader = new draw2d.io.json.Reader();
                    reader.unmarshal(canvas, json);
                }, canvas);
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('dashboardWidgetEditor', fnDashboardWidgetEditor);

    /** @ngInject */
    function fnDashboardWidgetEditor($window, $timeout, $sce, ApiListService, swal, microSpinner, QueryFactory, WidgetsListService, sqlFormatter, jsonToCsvConvertService, UserProfileService, LastPageService, postActionModelIcon, postActionModelMessage, highed, $uibModal) {
        return {
            restrict: 'EA',
            scope: {
                dashboardWidgets: "=",
                selectedColumn: "=",
                resetDashboardWidgets: "=",
                appName: "=",
                serviceName: "=",
                serviceDisplayName: "="
            },
            templateUrl: "app/components/directives/dashboardWidgetEditor/dashboardWidgetEditor.html",
            link: function ($scope) {
                $scope.availableDataLibs = ['ql_S4'];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $scope.fnSetTableHeight();
                    });
                });

                $scope.advanceSearchQueryConfig = {
                    value: {},
                    editorValue: ''
                };
                $scope.isAPIDataLoading = false;
                var chartMapping = [
                    {
                        "chartType": "arearange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "area",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "columnrange",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "column",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "line",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "spline",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    },
                    {
                        "chartType": "pie",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "funnel",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "pyramid",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "solidgauge",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "bubble",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "value",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "boxplot",
                        "requiredData": [
                            {
                                "key": "x",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "low",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q1",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "median",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "q3",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "high",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": false
                    },
                    {
                        "chartType": "scatter",
                        "requiredData": [
                            {
                                "key": "name",
                                "value": "",
                                "isRequired": true
                            },
                            {
                                "key": "y",
                                "value": "",
                                "isRequired": true
                            }
                        ],
                        "isAllowMultiField": true
                    }
                ];
                $scope.staticWidgetsArr = WidgetsListService.getStaticWidgets();
                $scope.resetStaticWidgetsArr = _.cloneDeepWith($scope.staticWidgetsArr);
                $scope.APIListsArr = ApiListService.getAPIList();
                $scope.maxSize = 3;
                $scope.svgArr = [
                    {
                        title: "Account",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "User",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Team",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Vault",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Authenticator",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Federation",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Email Template",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Audits",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/log.svg#log\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "S4",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Issues",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Archives",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/archive.svg#archive\"></use> \n" +
                            "</svg>"
                    }, {
                        title: "Projects",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Labels",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/label.svg#label\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Priorities",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "States",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/state.svg#state\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Types",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "<use\n" +
                            "xlink:href=\"assets/images/svg/service/types.svg#types\"></use>\n" +
                            "</svg>"
                    },
                    {
                        title: "Payment Methods",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/card.svg#card\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Invoices",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/invoice.svg#invoice\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Discounts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/discount.svg#discount\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Credit Tokens",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/creditTokens.svg#creditToken\"></use> \n" +
                            "</svg>"

                    },
                    {
                        title: "Business",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/business.svg#business\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Plans",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/plan.svg#plan\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Products",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/product.svg#product\"></use> \n" +
                            "</svg>"
                    },
                    {
                        title: "Carts",
                        iconURL: "<svg class=\"custom-svg-side-menu-icon\" width=\"22px\" height=\"22px\">\n" +
                            "   <use xlink:href=\"assets/images/svg/service/cart.svg#cart\"></use> \n" +
                            "</svg>"
                    }
                ];
                $scope.buildCustomWidgetActiveStep = 1;
                $scope.blueprintWidgetsArr = WidgetsListService.getDashboardBlueprintWidgets();
                $scope.resetBlueprintWidgetsArr = _.cloneDeepWith($scope.blueprintWidgetsArr);
                $scope.isPasteSVGCode = false;
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "text/x-mysql",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: false,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                    }
                };

                $scope.fnSelectIcon = function (obj) {
                    $scope.selectedWidget.widgetData.icon = obj.iconURL;
                };

                $scope.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
                    return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
                };

                $scope.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total1 = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var finalHeightNew = total1 - footer;
                        angular.element(".widget-content-main").css('height', finalHeightNew + 'px');
                        if ($scope.isViewStaticWidgets) {
                            var searchContainer = angular.element(".staticWidgetsSearchContainer")[0].offsetHeight;
                            var paginationContainer = angular.element(".staticWidgetsPaginationContainer")[0].offsetHeight;
                            var dashboard_header = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var staticWidgetsBodyHeight = finalHeightNew - (dashboard_header + searchContainer + paginationContainer + 40);
                            angular.element(".staticWidgetsBodyContainer").css('height', staticWidgetsBodyHeight + 'px');
                        }
                        if ($scope.isViewBlueprintWidgets) {
                            var blueprintWidgetsSearchContainer = angular.element(".blueprintWidgetsSearchContainer")[0].offsetHeight;
                            var blueprintWidgetsPaginationContainer = angular.element(".blueprintWidgetsPaginationContainer")[0].offsetHeight;
                            var dashboard_header_1 = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var blueprintWidgetsBodyHeight = finalHeightNew - (dashboard_header_1 + blueprintWidgetsSearchContainer + blueprintWidgetsPaginationContainer + 40);
                            angular.element(".blueprintWidgetsBodyContainer").css('height', blueprintWidgetsBodyHeight + 'px');
                        }
                    }
                };

                $scope.fnExitWidgets = function () {
                    $scope.isViewBlueprintWidgets = false;
                    $scope.isViewStaticWidgets = false;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnCancelWidgetEdit = function () {
                    $scope.selectedWidget = {};
                    $scope.isStaticWidgetEdit = false;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnCancelBuildCustomWidget = function () {
                    $scope.isViewBuildCustomWidget = false;
                    $scope.buildCustomWidgetActiveStep = 1;
                    $scope.queryConfig = {
                        sql: ""
                    };
                    $scope.apiData = [];
                    $scope.apiDataHeader = [];
                    $scope.selectedWidget = {};
                    $scope.isAPIDataLoading = false;
                    $scope.isAllowMultiField = false;
                    $("#chartEditor").empty(); //eslint-disable-line
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnCreateChartPreview = function () {
                    $scope.displayWidget = {};
                    $scope.displayWidgetChartData = '';
                    $timeout(function () {
                        $scope.displayWidget = _.cloneDeepWith($scope.dashboardWidgets[$scope.selectedColumn]);
                        if ($scope.displayWidget.widgetType === 'dynamic') {
                            var input = {
                                sql: $scope.displayWidget.APIConfiguration.sql
                            };
                            QueryFactory.executeQuery(input).then(function (res) {
                                if ($scope.displayWidget.chartConfiguration && $scope.displayWidget.chartConfiguration.dataMapping && !_.isEmpty($scope.displayWidget.chartConfiguration.dataMapping)) {
                                    if ($scope.displayWidget.chartConfiguration.chartConfig && !_.isEmpty($scope.displayWidget.chartConfiguration.chartConfig)) {
                                        var headers = {};
                                        _.forEach($scope.displayWidget.chartConfiguration.dataMapping, function (val) {
                                            headers[val] = val;
                                        });
                                        var items = [];
                                        _.forEach(res.data, function (obj) {
                                            var tempObj = {};
                                            _.forEach($scope.displayWidget.chartConfiguration.dataMapping, function (val) {
                                                tempObj[val] = obj[val] !== null ? obj[val] : 0;
                                            });
                                            items.push(tempObj);
                                        });
                                        items.unshift(headers);
                                        $scope.displayWidget.chartConfiguration.chartConfig.data.csv = jsonToCsvConvertService.convertToCSV(angular.toJson(items));
                                        $scope.displayWidgetChartData = $scope.displayWidget.chartConfiguration.chartConfig;
                                        $timeout(function () {
                                            $scope.fnSetTableHeight();
                                        });
                                    }
                                }
                            }, function () { // Error block
                            });
                        }
                    });
                };

                $scope.fnEditWidget = function (isCalledFromStaticWidget, selectedStaticWidget) {
                    if (isCalledFromStaticWidget) {
                        $scope.selectedWidget = selectedStaticWidget;
                        $scope.isViewStaticWidgets = false;
                        $scope.isStaticWidgetEdit = true;
                        $scope.isPasteSVGCode = false;
                    } else {
                        var tempWidget = $scope.dashboardWidgets[$scope.selectedColumn];
                        $scope.isStaticWidgetEdit = tempWidget.widgetType === 'static';
                        if ($scope.isStaticWidgetEdit) {
                            $scope.selectedWidget = _.cloneDeepWith(tempWidget);
                            $scope.isViewBuildCustomWidget = false;
                        } else {
                            $scope.selectedWidget = _.cloneDeepWith(tempWidget);
                            $scope.queryConfig = {
                                sql: tempWidget.APIConfiguration.sql
                            };
                            $scope.advanceSearchQueryConfig = {
                                value: {},
                                editorValue: tempWidget.APIConfiguration.sql
                            };
                            $scope.isViewBuildCustomWidget = true;
                            $scope.isPasteSVGCode = false;
                            $timeout(function () {
                                $scope.fnSetTableHeight();
                            })
                        }
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnGotoListStaticWidget = function () {
                    $scope.isViewStaticWidgets = true;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnGotoListBlueprintWidget = function () {
                    $scope.isViewBlueprintWidgets = true;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnBuildCustomWidget = function () {
                    $scope.isViewBuildCustomWidget = true;
                    $scope.selectedWidget = {
                        chartConfiguration: {
                            chartType: 'pie'
                        }
                    };
                    $scope.queryConfig = {
                        sql: ""
                    };
                    $scope.isPasteSVGCode = false;
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnRestoreDefault = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this widget back to its original design. All the current widgets settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                $scope.dashboardWidgets[$scope.selectedColumn] = $scope.resetDashboardWidgets[$scope.selectedColumn];
                                UserProfileService.fnUpdateUserProfileObj($scope.appName, $scope.serviceName, 'dashboardWidgets', angular.fromJson(angular.toJson($scope.dashboardWidgets)), true);
                                $scope.fnCancelWidgetEdit();
                                $scope.fnCancelBuildCustomWidget();
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                $scope.fnCreateChartPreview();
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                /*static Widget Search : Start*/
                $scope.staticWidgetSearchFiltersArr = [
                    {
                        displayName: "Title",
                        name: "widgetTitle",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "widgetDescription",
                        regexp: "",
                        errorMessage: ""
                    }];
                $scope.staticWidgetSortFieldArr = [
                    {name: 'widgetTitle', displayName: 'Title'},
                    {name: 'widgetDescription', displayName: 'Description'}
                ];
                $scope.staticWidgetSortQuery = "";
                $scope.staticWidgetFilterQuery = "";
                $scope.staticWidgetPerPage = 20;

                $scope.fnStaticWidgetFilterQueryChanged = function (filterQuery, sortQuery) {
                    if (sortQuery) {
                        $scope.staticWidgetSortQuery = sortQuery;
                    }
                    $scope.staticWidgetFilterQuery = filterQuery;
                    $scope.fnGetStaticWidgetFilterData();
                };

                $scope.fnGetStaticWidgetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterWidgetArr = [];
                    var widgetArr = [];
                    if ($scope.staticWidgetFilterQuery) {
                        filterWidgetArr = _.filter($scope.resetStaticWidgetsArr, function (obj) {
                            if (eval($scope.staticWidgetFilterQuery)) {
                                return obj;
                            }
                        });
                    } else {
                        filterWidgetArr = _.cloneDeepWith($scope.resetStaticWidgetsArr);
                    }
                    if ($scope.staticWidgetSortQuery) {
                        var sortType = $scope.staticWidgetSortQuery.split(' ')[1];
                        var sortValue = $scope.staticWidgetSortQuery.split(' ')[0];
                        widgetArr = _.orderBy(filterWidgetArr, [sortValue], [sortType]);
                    } else {
                        widgetArr = _.cloneDeepWith(filterWidgetArr);
                    }
                    $scope.staticWidgetTotalItems = widgetArr.length;
                    $scope.staticWidgetCurrentPage = LastPageService.getLastPage($scope.staticWidgetTotalItems, $scope.staticWidgetPerPage, page);
                    var startItem = ($scope.staticWidgetCurrentPage - 1) * $scope.staticWidgetPerPage;
                    var endItem = $scope.staticWidgetCurrentPage * $scope.staticWidgetPerPage;
                    $scope.staticWidgetsArr = widgetArr.slice(startItem, endItem);
                };

                $scope.fnStaticWidgetPageChanged = function (page, perPage) {
                    $scope.staticWidgetCurrentPage = page;
                    $scope.staticWidgetPerPage = perPage;
                    $scope.fnGetStaticWidgetFilterData(page);
                };
                /*static Widget Search : End*/

                /*Blueprint Widget Search : Start*/
                $scope.blueprintWidgetSearchFiltersArr = [
                    {
                        displayName: "Title",
                        name: "widgetTitle",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "widgetDescription",
                        regexp: "",
                        errorMessage: ""
                    }];
                $scope.blueprintWidgetSortFieldArr = [
                    {name: 'widgetTitle', displayName: 'Title'},
                    {name: 'widgetDescription', displayName: 'Description'}
                ];
                $scope.blueprintWidgetSortQuery = "";
                $scope.blueprintWidgetFilterQuery = "";
                $scope.blueprintWidgetPerPage = 20;

                $scope.fnBlueprintWidgetFilterQueryChanged = function (filterQuery, sortQuery) {
                    if (sortQuery) {
                        $scope.blueprintWidgetSortQuery = sortQuery;
                    }
                    $scope.blueprintWidgetFilterQuery = filterQuery;
                    $scope.fnGetBlueprintWidgetFilterData();
                };

                $scope.fnGetBlueprintWidgetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterWidgetArr = [];
                    var widgetArr = [];
                    if ($scope.blueprintWidgetFilterQuery) {
                        filterWidgetArr = _.filter($scope.resetBlueprintWidgetsArr, function (obj) {
                            if (eval($scope.blueprintWidgetFilterQuery)) {
                                return obj;
                            }
                        });
                    } else {
                        filterWidgetArr = _.cloneDeepWith($scope.resetBlueprintWidgetsArr);
                    }
                    if ($scope.blueprintWidgetSortQuery) {
                        var sortType = $scope.blueprintWidgetSortQuery.split(' ')[1];
                        var sortValue = $scope.blueprintWidgetSortQuery.split(' ')[0];
                        widgetArr = _.orderBy(filterWidgetArr, [sortValue], [sortType]);
                    } else {
                        widgetArr = _.cloneDeepWith(filterWidgetArr);
                    }
                    $scope.blueprintWidgetTotalItems = widgetArr.length;
                    $scope.blueprintWidgetCurrentPage = LastPageService.getLastPage($scope.blueprintWidgetTotalItems, $scope.blueprintWidgetPerPage, page);
                    var startItem = ($scope.blueprintWidgetCurrentPage - 1) * $scope.blueprintWidgetPerPage;
                    var endItem = $scope.blueprintWidgetCurrentPage * $scope.blueprintWidgetPerPage;
                    $scope.blueprintWidgetsArr = widgetArr.slice(startItem, endItem);
                };

                $scope.fnBlueprintWidgetPageChanged = function (page, perPage) {
                    $scope.blueprintWidgetCurrentPage = page;
                    $scope.blueprintWidgetPerPage = perPage;
                    $scope.fnGetBlueprintWidgetFilterData(page);
                };
                /*Blueprint Widget Search : End*/

                /*Edit Chart: Start*/
                var instance;
                $scope.fnEditBlueprintWidget = function (widget) {
                    widget.isWidgetLoading = true;
                    $scope.selectedWidget = _.cloneDeepWith(widget);
                    $scope.queryConfig = {
                        sql: widget.APIConfiguration.sql
                    };
                    $scope.advanceSearchQueryConfig = {
                        value: {},
                        editorValue: widget.APIConfiguration.sql
                    };
                    $scope.isPasteSVGCode = false;
                    $scope.fnRunQuery(true);
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    })
                };

                $scope.fnRunQuery = function (isCalledFromEditBlueprintWidget) {
                    $scope.isAPIDataLoading = true;
                    $scope.apiData = [];
                    $scope.apiDataHeader = [];
                    var input = {};
                    if (isCalledFromEditBlueprintWidget) {
                        input = {
                            "sql": $scope.queryConfig.sql
                        };
                    } else {
                        if ($scope.advanceSearchQueryConfig.value.getData().length) {
                            input = {
                                "sql": $scope.advanceSearchQueryConfig.value.getData()
                            };
                        }
                    }
                    if (input.sql && input.sql.length) {
                        QueryFactory.executeQuery(input).then(function (res) {
                            $scope.data = _.cloneDeepWith(res.data);
                            $scope.apiData = res.data;
                            $scope.apiDataHeader = [];
                            _.forEach($scope.apiData, function (dataObj) {
                                _.forEach(Object.keys(dataObj), function (value) {
                                    $scope.apiDataHeader.push(value);
                                });
                            });
                            $scope.apiDataHeader = _.uniq(_.map($scope.apiDataHeader)).sort();
                            if (isCalledFromEditBlueprintWidget) {
                                $scope.buildCustomWidgetActiveStep = 1;
                                $timeout(function () {
                                    $scope.fnGotoNextPreviousStep();
                                    $timeout(function () {
                                        $scope.fnGotoNextPreviousStep();
                                        $timeout(function () {
                                            $scope.fnGotoNextPreviousStep();
                                            $timeout(function () {
                                                $scope.fnGotoNextPreviousStep();
                                                $scope.isAPIDataLoading = false;
                                                $scope.isViewBlueprintWidgets = false;
                                                $scope.isViewBuildCustomWidget = true;
                                                $timeout(function () {
                                                    $scope.fnSetTableHeight();
                                                });
                                            }, 250)
                                        }, 250)
                                    }, 250)
                                }, 250)
                            } else {
                                $scope.isAPIDataLoading = false;
                            }
                            $timeout(function () {
                                $scope.fnSetTableHeight();
                            });
                        }, function () { // Error block
                            $scope.isAPIDataLoading = false;
                        });
                    }
                };

                $scope.fnFormatSQL = function () {
                    var sql = $scope.advanceSearchQueryConfig.value.getData();
                    $scope.advanceSearchQueryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                $scope.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                $scope.fnGetType = function (data) {
                    return typeof data;
                };

                $scope.fnGotoNextPreviousStep = function (isGotoPreviousStep) {
                    if (isGotoPreviousStep) {
                        $scope.buildCustomWidgetActiveStep = $scope.buildCustomWidgetActiveStep - 1;
                    } else {
                        $scope.buildCustomWidgetActiveStep = $scope.buildCustomWidgetActiveStep + 1;
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 1000);
                    if ($scope.buildCustomWidgetActiveStep === 2) {
                        var dashboard_header = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var wizard = angular.isDefined(angular.element(".wizard")[0]) ? angular.element(".wizard")[0].offsetHeight : 0;
                        var total1 = angular.element(".content-main")[0].offsetHeight;
                        $('#chartEditor').css('height', total1 - (dashboard_header + wizard + 67)); //eslint-disable-line
                        $("#chartEditor").empty(); //eslint-disable-line
                        var myOptions = {
                            chart: {
                                type: 'pie'
                            },
                            title: {
                                text: " "
                            },
                            subtitle: {
                                text: " "
                            },
                            xAxis: {
                                type: "category"
                            },
                            exporting: {
                                enabled: false
                            },
                            credits: {
                                enabled: false
                            },
                            plotOptions: {
                                series: {
                                    dataLabels: {
                                        enabled: true
                                    }
                                }
                            },
                            series: [
                                {
                                    animationLimit: -1
                                }
                            ],
                            legend: {
                                enabled: false
                            }
                        };
                        if ($scope.selectedWidget && $scope.selectedWidget.chartConfiguration && $scope.selectedWidget.chartConfiguration.chartConfig && $scope.selectedWidget.chartConfiguration.chartConfig.chart && !_.isEmpty($scope.selectedWidget.chartConfiguration.chartConfig.chart)) {
                            myOptions.chart.type = $scope.selectedWidget.chartConfiguration.chartConfig.chart.type;
                        }
                        instance = highed.DrawerEditor('chartEditor', {
                            defaultChartOptions: myOptions
                        });
                        $timeout(function () {
                            $scope.fnSetTableHeight();
                        });
                        $timeout(function () {
                            $('.fa-bar-chart').click(); //eslint-disable-line
                            $timeout(function () {
                                if ($(".highed-list a:last-child")[0]) { //eslint-disable-line
                                    $(".highed-list a:last-child")[0].remove(); //eslint-disable-line
                                }
                                $timeout(function () {
                                    var data = document.getElementsByClassName("item");
                                    for (var i = 0; i < data.length; i++) {
                                        data[i].addEventListener("click", function () {  //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-cat-desc div').remove(); //eslint-disable-line
                                            $('#chartEditor .highed-chart-template-samples').remove(); //eslint-disable-line
                                        });
                                    }
                                    $timeout(function () {
                                        $scope.fnSetTableHeight();
                                    })
                                })
                            });
                        }, 250);
                    }
                    if ($scope.buildCustomWidgetActiveStep === 3) {
                        $scope.selectedWidget.chartConfiguration.chartConfig = instance.getEmbeddableJSON();
                        $scope.selectedWidget.chartConfiguration.chartType = $scope.selectedWidget.chartConfiguration.chartConfig.chart.type;
                        var chartMappingData = _.find(chartMapping, {chartType: $scope.selectedWidget.chartConfiguration.chartType});
                        $scope.isAllowMultiField = chartMappingData.isAllowMultiField;
                        $scope.dataConfig = [];
                        if ($scope.selectedWidget && $scope.selectedWidget.chartConfiguration && $scope.selectedWidget.chartConfiguration.dataMapping && !_.isEmpty($scope.selectedWidget.chartConfiguration.dataMapping)) {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                if ($scope.selectedWidget.chartConfiguration.dataMapping[requiredDataObj.key]) {
                                    $scope.dataConfig.push({
                                        key: requiredDataObj.key,
                                        value: $scope.selectedWidget.chartConfiguration.dataMapping[requiredDataObj.key],
                                        isRequired: true
                                    });
                                }
                            });
                            if ($scope.dataConfig.length !== Object.keys($scope.selectedWidget.chartConfiguration.dataMapping).length) {
                                var arr = Object.keys($scope.selectedWidget.chartConfiguration.dataMapping);
                                _.forEach(arr, function (arrKey) {
                                    var isFind = _.find($scope.dataConfig, {key: arrKey});
                                    if (!isFind) {
                                        $scope.dataConfig.push(
                                            {
                                                key: arrKey,
                                                value: $scope.selectedWidget.chartConfiguration.dataMapping[arrKey]
                                            }
                                        )
                                    }
                                });
                            }
                        } else {
                            _.forEach(chartMappingData.requiredData, function (requiredDataObj) {
                                $scope.dataConfig.push({
                                    key: requiredDataObj.key,
                                    value: '',
                                    isRequired: true
                                });
                            });
                        }
                    }
                    if ($scope.buildCustomWidgetActiveStep === 4) {
                        $timeout(function () {
                            $scope.selectedWidget.chartConfiguration.dataMapping = {};
                            _.forEach($scope.dataConfig, function (dataConfigObj) {
                                $scope.selectedWidget.chartConfiguration.dataMapping[dataConfigObj.key] = dataConfigObj.value;
                            });
                            var testingJSON = $scope.selectedWidget.chartConfiguration.chartConfig;
                            var headers = {};
                            _.forEach($scope.dataConfig, function (dataConfigObj) {
                                headers[dataConfigObj.value] = dataConfigObj.value
                            });
                            var items = [];
                            _.forEach($scope.data, function (obj) {
                                var tempObj = {};
                                _.forEach($scope.dataConfig, function (dataConfigObj) {
                                    tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                                });
                                items.push(tempObj);
                            });
                            items.unshift(headers);
                            var jsonObject = angular.toJson(items);
                            testingJSON.data = {
                                "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                                "googleSpreadsheetKey": false,
                                "googleSpreadsheetWorksheet": false,
                                "decimalPoint": ","
                            };
                            $scope.selectedWidget.chartConfiguration.chartConfig = testingJSON;
                            $("#previewChart").empty(); //eslint-disable-line
                            var previewChart = highed.DrawerEditor('previewChart');
                            previewChart.chart.options.setAll(testingJSON);
                            previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                            $timeout(function () {
                                previewChart.resize();
                            }, 250);
                        })
                    }
                    if ($scope.buildCustomWidgetActiveStep === 5) {
                        $scope.previewWidgetChartData = '';
                        $timeout(function () {
                            $scope.previewWidgetChartData = _.cloneDeepWith($scope.selectedWidget.chartConfiguration.chartConfig);
                        })
                    }
                    $timeout(function () {
                        $scope.fnSetTableHeight();
                    }, 1000)
                };

                $scope.fnAddNewMapping = function () {
                    var tempKey = "mapping_";
                    var keyNumber = 0;
                    _.forEach($scope.dataConfig, function (value) {
                        if (value.key.startsWith('mapping_')) {
                            var number = parseInt(value.key.toString().split('_')[1]);
                            if (number > keyNumber) {
                                keyNumber = number;
                            }
                        }
                    });
                    tempKey = tempKey + (keyNumber + 1);
                    $scope.dataConfig.push({
                        key: tempKey,
                        value: ''
                    });
                };

                $scope.fnRemoveMapping = function (index) {
                    $scope.dataConfig.splice(index, 1);
                };

                $scope.fnCheckRequiredInput = function () {
                    var flag = true;
                    $scope.dataConfig.map(function (kvpPairObj) {
                        if (angular.isUndefined(kvpPairObj.key) || kvpPairObj.key === "" || angular.isUndefined(kvpPairObj.value) || kvpPairObj.value === "") {
                            flag = false;
                        }
                    });
                    return flag;
                };

                $scope.fnSaveBuildCustomWidget = function () {
                    $scope.queryConfig = {
                        "sql": $scope.advanceSearchQueryConfig.value.getData()
                    };
                    var testingJSON = $scope.selectedWidget.chartConfiguration.chartConfig;
                    $scope.dashboardWidgets[$scope.selectedColumn] = {
                        id: $scope.selectedColumn,
                        widgetType: "dynamic",
                        widgetData: _.cloneDeepWith($scope.selectedWidget.widgetData),
                        APIConfiguration: _.cloneDeepWith($scope.queryConfig),
                        chartConfiguration: {
                            chartType: _.cloneDeepWith(testingJSON.chart.type),
                            dataMapping: _.cloneDeepWith($scope.selectedWidget.chartConfiguration.dataMapping),
                            chartConfig: _.cloneDeepWith(testingJSON)
                        }
                    };
                    UserProfileService.fnUpdateUserProfileObj($scope.appName, $scope.serviceName, 'dashboardWidgets', angular.fromJson(angular.toJson($scope.dashboardWidgets)), true);
                    $scope.fnCancelWidgetEdit();
                    $scope.fnCancelBuildCustomWidget();
                    $scope.displayWidget = _.cloneDeepWith($scope.dashboardWidgets[$scope.selectedColumn]);
                };

                $scope.fnEditChartProperties = function () {
                    var testingJSON = $scope.selectedWidget.chartConfiguration.chartConfig;
                    var headers = {};
                    _.forEach($scope.dataConfig, function (dataConfigObj) {
                        headers[dataConfigObj.value] = dataConfigObj.value
                    });
                    var items = [];
                    _.forEach($scope.data, function (obj) {
                        var tempObj = {};
                        _.forEach($scope.dataConfig, function (dataConfigObj) {
                            tempObj[dataConfigObj.value] = obj[dataConfigObj.value] !== null ? obj[dataConfigObj.value] : 0;
                        });
                        items.push(tempObj);
                    });
                    items.unshift(headers);
                    var jsonObject = angular.toJson(items);
                    testingJSON.data = {
                        "csv": jsonToCsvConvertService.convertToCSV(jsonObject),
                        "googleSpreadsheetKey": false,
                        "googleSpreadsheetWorksheet": false,
                        "decimalPoint": ","
                    };
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/chartEditor/chartEditorModal.html',
                        size: 'lg',
                        controller: 'chartEditorModalCtrl as chartEditor',
                        windowClass: 'modal-height100',
                        resolve: {
                            chartObj: function () {
                                return testingJSON;
                            },
                            csvData: function () {
                                return jsonToCsvConvertService.convertToCSV(jsonObject);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) { //response
                        $scope.selectedWidget.chartConfiguration.chartConfig = res;
                        $("#previewChart").empty(); //eslint-disable-line
                        var previewChart = highed.DrawerEditor('previewChart');
                        previewChart.chart.options.setAll(res);
                        previewChart.chart.data.csv(jsonToCsvConvertService.convertToCSV(jsonObject));
                        $timeout(function () {
                            previewChart.resize();
                        }, 250);
                    }, function () {
                    });
                };
                /*Edit Chart: End*/

                /*Edit Static Widget: Start*/
                $scope.fnSaveWidgetEdit = function () {
                    $scope.dashboardWidgets[$scope.selectedColumn] = {
                        id: $scope.selectedColumn,
                        widgetType: "static",
                        widgetData: _.cloneDeepWith($scope.selectedWidget.widgetData)
                    };
                    UserProfileService.fnUpdateUserProfileObj($scope.appName, $scope.serviceName, 'dashboardWidgets', angular.fromJson(angular.toJson($scope.dashboardWidgets)), true);
                    $scope.fnCancelWidgetEdit();
                    $scope.displayWidget = _.cloneDeepWith($scope.dashboardWidgets[$scope.selectedColumn]);
                    $scope.$broadcast('updateChartData');
                };
                /*Edit Static Widget: End*/

                $scope.fnEditSVGCode = function () {
                    $scope.isPasteSVGCode = true;
                };

                $scope.fnOpenTablesModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/accountStatusModal/accountStatusModal.html',
                        size: 'lg',
                        controller: 'accountStatusCtrl as accountStat',
                        resolve: {
                            isCalledForFirstPaymentMethod: function () {
                                return false;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.fnInitWidgetEditor = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        $scope.isFullWidthDevice = true;
                    }
                    $scope.displayWidget = {};
                    $scope.fnExitWidgets();
                    $scope.fnCancelWidgetEdit();
                    $scope.fnCancelBuildCustomWidget();
                    $scope.selectedWidget = {};
                    $scope.isStaticWidgetEdit = false;
                    $scope.isViewStaticWidgets = false;
                    $scope.staticWidgetSortQuery = "";
                    $scope.staticWidgetFilterQuery = "";
                    $scope.staticWidgetPerPage = 20;
                    $scope.isViewBuildCustomWidget = false;
                    $scope.isViewBlueprintWidgets = false;
                    $scope.buildCustomWidgetActiveStep = 1;
                };
                $scope.fnInitWidgetEditor();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('dashboardPieChart', fnDashboardPieChart);

    /** @ngInject */
    function fnDashboardPieChart(Highcharts, $timeout, jsonToCsvConvertService) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                chartId: '=',
                name: '=',
                isForCsvChart: "="
            },
            templateUrl: "app/components/directives/dashboardPieChart/dashboardPieChart.html",
            link: function ($scope) {
                $scope.isShowPieLabel = true;
                $scope.showEmptyChart = false;
                $scope.fnShowLabel = function () {
                    $scope.fnDrawChart();
                };
                $scope.fnDrawChart = function () {
                    var flag = false;
                    if ($scope.isForCsvChart) {
                        var tempChartData = [];
                        if($scope.chartData.data && $scope.chartData.data.csv){
                            tempChartData = jsonToCsvConvertService.convertCSVToJSON($scope.chartData.data.csv, ',');
                        } else {
                            tempChartData = $scope.chartData.series;
                        }
                        flag = !!(tempChartData && tempChartData.length > 1);
                    } else {
                        flag = $scope.chartData && $scope.chartData.length;
                    }
                    if (flag) {
                        if ($scope.isForCsvChart) {
                            if (angular.isDefined(angular.element("#" + $scope.chartId)[0])) {
                                Highcharts.chart($scope.chartId, $scope.chartData);
                            }
                        } else {
                            if (angular.isDefined(angular.element("#" + $scope.chartId)[0])) {
                                Highcharts.chart($scope.chartId, {
                                    chart: {
                                        plotBackgroundColor: null,
                                        plotBorderWidth: null,
                                        plotShadow: false,
                                        type: 'pie',
                                        height: 250,
                                        margin: [10, 10, 2, 10]
                                    },
                                    title: {
                                        text: ''
                                    },
                                    tooltip: {
                                        pointFormat: '{series.name}: <b>{point.y}</b>'
                                    },
                                    subtitle: {
                                        text: ''
                                    },
                                    credits: {
                                        enabled: false
                                    },
                                    plotOptions: {
                                        pie: {
                                            allowPointSelect: true,
                                            cursor: 'pointer',
                                            dataLabels: {
                                                enabled: $scope.isShowPieLabel,
                                                format: '<b>{point.name}</b>: {point.y}'
                                            }
                                        }
                                    },
                                    series: [{
                                        name: $scope.name,
                                        colorByPoint: true,
                                        data: $scope.chartData
                                    }],
                                    navigation: {
                                        buttonOptions: {
                                            enabled: true,
                                            height: 25,
                                            width: 25,
                                            symbolSize: 12,
                                            symbolX: 13,
                                            symbolY: 13,
                                            x: 9,
                                            symbolStrokeWidth: 2,
                                            theme: {
                                                'stroke-width': 1,
                                                stroke: 'silver',
                                                r: 50
                                            }
                                        }
                                    },
                                    exporting: {
                                        enabled: true,
                                        csv: {
                                            columnHeaderFormatter: function (item, key) {
                                                if (key === 'Category' || angular.isUndefined(key)) {
                                                    return angular.isDefined($scope.isAlarmsPieChartExport) ? "Health" : $scope.type;
                                                } else if (key === 'y') {
                                                    return 'Count'
                                                }
                                            }
                                        },
                                        buttons: {
                                            contextButton: {
                                                menuItems: ['downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'label']
                                            }
                                        },
                                        menuItemDefinitions: {
                                            printChart: {
                                                onclick: function () {
                                                    var divToPrint = document.getElementById($scope.chartId);
                                                    var newWin = window.open(); //eslint-disable-line
                                                    newWin.document.write(divToPrint.innerHTML);
                                                    newWin.document.close();
                                                    newWin.focus();
                                                    newWin.print();
                                                    newWin.close();
                                                }
                                            },
                                            label: {
                                                onclick: function () {
                                                    $scope.isShowPieLabel = !$scope.isShowPieLabel;
                                                    $scope.fnShowLabel();
                                                },
                                                text: $scope.isShowPieLabel ? "Hide Label" : "Show Label"
                                            }
                                        }
                                    }
                                });
                            }
                        }
                    } else {
                        $scope.showEmptyChart = true;
                    }
                };
                $timeout(function () {
                    $scope.fnDrawChart();
                }, 1000)
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('dashboardCreateIssue', fnDashboardCreateIssue);

    /** @ngInject */
    function fnDashboardCreateIssue($rootScope, $window, $stateParams, $http, $timeout, $state, $uibModal, mermaid, AppInitService,
                                    ProjectFactory, swal, amaran, moment, DB, PermissionsService, AvatarService, IssueFactory,
                                    EmailFactory, UserFactory, QueryFactory, UserProfileService, TypeFormService, TypesFactory) {
        return {
            restrict: 'EA',
            scope: {
                appName: "=",
                appKey: "=",
                serviceKey: "="
            },
            templateUrl: "app/components/directives/dashboardCreateIssue/dashboardCreateIssue.html",
            link: function ($scope) {
                $scope.localdataKey = 'Insight' + capitalizeFirstLetter($scope.appKey) + capitalizeFirstLetter($scope.serviceKey);
                $scope.issueDraftObj = {};
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        $scope.fnSetIssueMarkdownHeight();
                    });
                });

                $scope.isIssueCreating = false;
                $scope.fileUploading = false;
                $scope.newIssueObj = {
                    confidential: false,
                    assignees: [],
                    issueLabels: [],
                    participants: [],
                    name: "",
                    summary: "",
                    resolved: false
                };
                $scope.resetNewIssueObj = angular.copy($scope.newIssueObj);
                $scope.projectsArr = [];
                $scope.selectedProject = {};

                $scope.issueProjectFilter = "$";
                $scope.issueProjectSearch = {$: ''};

                $scope.filter = "$";
                $scope.labelSearch = {$: ''};
                var expandedProfileData = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'sideBarExpanded');
                $scope.isExpanded = expandedProfileData !== '' ? expandedProfileData : false;

                /*Types: START*/
                $scope.typesArr = [];
                $scope.selectedType = {};
                $scope.isIssueTypeLoaded = false;
                $scope.model = {};
                $scope.schema = {};
                $scope.form = ['*'];
                $scope.isTypeDetailsLoaded = true;
                /*Types: END*/

                /*Assignee: START*/
                $scope.filterAssignees = "$";
                $scope.assigneeSearch = {$: ''};
                $scope.usersArr = [{
                    username: 'assign to me'
                }];
                $scope.isIssueAssigneeLoaded = false;
                $scope.changeAssigneeView = false;
                $scope.isAssigneeChanged = true;
                $scope.selectedUser = "";
                /*Assignee: END*/

                /*Labels: START*/
                $scope.labelsArr = [];
                $scope.isIssueLablesLoaded = false;
                $scope.addLabelView = false;
                $scope.isLabelsAdded = true;
                $scope.selectedLabelsArr = [];
                $scope.selectedLabel = {};
                /*Labels: END*/

                /*Priority: START*/
                $scope.priorityFilter = "$";
                $scope.prioritySearch = {$: ''};
                $scope.prioritiesArr = [];
                $scope.isIssuePriorityLoaded = false;
                $scope.changePriorityView = false;
                $scope.isPriorityChanged = true;
                $scope.selectedPriority = "";
                /*Priority: END*/

                /*State: START*/
                $scope.stateFilter = "$";
                $scope.stateSearch = {$: ''};
                $scope.statesArr = [];
                $scope.isIssueStateLoaded = false;
                $scope.changeStateView = false;
                $scope.isStateChanged = true;
                $scope.selectedState = {};
                /*State: END*/

                /*Participant: START*/
                $scope.participantFilter = "$";
                $scope.participantSearch = {$: ''};
                $scope.participantsArr = [];
                $scope.isIssueParticipantLoaded = false;
                $scope.changeParticipantView = false;
                $scope.isParticipantChanged = true;
                $scope.selectedParticipant = {};
                $scope.assigneesParticipants = [];
                /*Participant: END*/

                /*Confidential: START*/
                $scope.confidentialsArr = [{'name': "Confidential", 'value': true}, {
                    'name': "Not Confidential",
                    'value': false
                }];
                $scope.isIssueConfidentialLoaded = false;
                $scope.changeConfidentialView = false;
                $scope.isConfidentialChanged = true;
                $scope.selectedConfidential = {};
                /*Confidential: END*/

                $scope.projectRelationshipsObj = {};

                $scope.loginUser = DB.fnGet('sudo') ? DB.fnGet('sudo') : DB.fnGet('loginUser');

                $scope.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                        $scope.fnRenderMermaid();
                    }
                };

                /*Upload: START*/
                $scope.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        if (type === 'image') {
                            $scope.newIssueObj.summary = $scope.newIssueObj.summary + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                        } else {
                            $scope.newIssueObj.summary = $scope.newIssueObj.summary + " [" + filedata.name + "](" + res.downloadUrl + ")";
                        }
                        $scope.fileUploading = false;
                    });
                };

                $scope.uploadFiles = function (type, filedata) {
                    if ($scope.permissionObj.GET_FILE_UPLOAD_LINK) {
                        $scope.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: $scope.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                $scope.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                $scope.fnCreateNewIssue = function (newIssueObj) {
                    if (newIssueObj.issueType && newIssueObj.issueType.form) {
                        newIssueObj.issueType.form.values = $scope.model;
                    }
                    if (newIssueObj.rowData) {
                        delete newIssueObj.rowData;
                    }
                    $scope.isIssueCreating = true;
                    var inputObj = {
                        'body': newIssueObj,
                        'projectId': $scope.selectedProject.id
                    };
                    IssueFactory.createIssue(inputObj)
                        .then(function () {
                            $scope.isIssueCreating = false;
                            $scope.newIssueObj = angular.copy($scope.resetNewIssueObj);
                            localStorage.removeItem($scope.localdataKey + 'IssueDraft');
                            localStorage.removeItem($scope.localdataKey + 'FedSupportIssueDraft');
                            if (newIssueObj.participants && newIssueObj.participants.length) {
                                var tempArr = [];
                                _.forEach(newIssueObj.participants, function (participant) {
                                    tempArr.push({
                                        email: participant
                                    })
                                });
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', tempArr);
                            } else {
                                UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'participantsList', []);
                            }
                            $scope.model = {};
                            $scope.fnInitCreateIssue();
                            $scope.$emit('issueAdded');
                        }, function () {
                            $scope.isIssueCreating = false;
                        })
                };

                $scope.fnChangeProject = function (projectObj) {
                    $scope.selectedProject = projectObj;
                    $scope.newIssueObj.projectId = projectObj.id;
                    $scope.newIssueObj.issueLabels = [];
                    delete $scope.newIssueObj.issueState;
                    delete $scope.newIssueObj.issuePriority;

                    /*Types: START*/
                    $scope.typesArr = [];
                    $scope.selectedType = {};
                    $scope.isIssueTypeLoaded = false;
                    $scope.model = {};
                    $scope.schema = {};
                    $scope.form = ['*'];
                    /*Types: END*/

                    /*Labels: START*/
                    $scope.labelsArr = [];
                    $scope.isIssueLablesLoaded = false;
                    $scope.addLabelView = false;
                    $scope.isLabelsAdded = true;
                    $scope.selectedLabelsArr = [];
                    $scope.selectedLabel = {};
                    /*Labels: END*/

                    /*Priority: START*/
                    $scope.prioritiesArr = [];
                    $scope.isIssuePriorityLoaded = false;
                    $scope.changePriorityView = false;
                    $scope.isPriorityChanged = true;
                    $scope.selectedPriority = "";
                    /*Priority: END*/

                    /*State: START*/
                    $scope.statesArr = [];
                    $scope.isIssueStateLoaded = false;
                    $scope.changeStateView = false;
                    $scope.isStateChanged = true;
                    $scope.selectedState = {};
                    /*State: END*/

                    $scope.isIssueTypeLoaded = false;
                    var input = {
                        projectId: $scope.newIssueObj.projectId
                    };
                    $scope.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            $scope.projectRelationshipsObj = _.cloneDeepWith(response);
                            $scope.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetTypes({sql: typeSQL});

                            $scope.isIssueLablesLoaded = false;
                            $scope.assigneesLabels = _.cloneDeepWith($scope.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetLabels({sql: labelSQL});

                            $scope.isIssuePriorityLoaded = false;
                            $scope.assigneesPriorities = angular.isDefined($scope.newIssueObj.issuePriority) ? _.cloneDeepWith($scope.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetPriorities({sql: prioritiesSQL});
                            $scope.changePriorityView = false;

                            $scope.isIssueStateLoaded = false;
                            $scope.assigneesState = angular.isDefined($scope.newIssueObj.issueState) ? _.cloneDeepWith($scope.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetStates({sql: stateSQL});
                            $scope.changeStateView = false;
                        }, function () {
                        });
                };

                /*Assignee: START*/
                $scope.addAssigneeArr = [];
                $scope.deleteAssigneeArr = [];

                $scope.fnGetUsers = function (inputObj) {
                    ProjectFactory.listPossibleProjectAssignees(inputObj)
                        .then(function (response) {
                            _.forEach(response, function (userObj) {
                                userObj.userAvatar = angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg';
                                if ($scope.issueDraftObj && $scope.issueDraftObj.assignees && $scope.issueDraftObj.assignees.length) {
                                    var isFindAssignee = _.find($scope.issueDraftObj.assignees, {id: userObj.id});
                                    if (isFindAssignee) {
                                        userObj.isCheck = true;

                                        if (!$scope.assigneesAssignees) {
                                            $scope.assigneesAssignees = [];
                                        }
                                        $scope.assigneesAssignees.push({
                                            bio: userObj.bio,
                                            firstName: userObj.firstName,
                                            id: userObj.id,
                                            lastName: userObj.lastName,
                                            tags: userObj.tags,
                                            username: userObj.username,
                                            userAvatar: userObj.userAvatar,
                                            email: userObj.email
                                        })
                                    }
                                }
                            });
                            response.sort(function (a, b) {
                                if (a.firstName < b.firstName) {
                                    return -1;
                                }
                                if (a.firstName > b.firstName) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.usersArr = _.cloneDeepWith(response);
                            $scope.isIssueAssigneeLoaded = true;
                        }, function () {
                            $scope.isIssueAssigneeLoaded = true;
                        })
                };

                $scope.fnGetAssigneeInfo = function (assigneeObj) {
                    if (assigneeObj.isCheck) {
                        assigneeObj.isCheck = false;
                        var isFindAssignee = _.find($scope.assigneesAssignees, {id: assigneeObj.id});
                        if (isFindAssignee) {
                            $scope.deleteAssigneeArr.push(isFindAssignee);
                        } else {
                            var isFindAssigneeInAddAssigneeArr = _.findIndex($scope.addAssigneeArr, {id: assigneeObj.id});
                            if (isFindAssigneeInAddAssigneeArr !== 1) {
                                $scope.addAssigneeArr.splice(isFindAssigneeInAddAssigneeArr, 1);
                            }
                        }
                    } else {
                        assigneeObj.isCheck = true;
                        var isFindAssigneesAssignee = _.find($scope.assigneesAssignees, {id: assigneeObj.id});
                        if (!isFindAssigneesAssignee) {
                            $scope.addAssigneeArr.push(assigneeObj);
                        } else {
                            var isFindDeleteAssignee = _.findIndex($scope.deleteAssigneeArr, {id: assigneeObj.id});
                            if (isFindDeleteAssignee !== -1) {
                                $scope.deleteAssigneeArr.splice(isFindDeleteAssignee, 1);
                            }
                        }
                    }
                };

                $scope.fnCancelChangeAssignee = function () {
                    $scope.selectedAssignee = {};
                    $scope.changeAssigneeView = false;
                    if ($scope.deleteAssigneeArr.length || $scope.addAssigneeArr.length) {
                        $scope.fnUpdateIssueAssignee();
                    }
                };

                $scope.fnOnToggleAssignee = function (isOpen) {
                    if (isOpen === false && ($scope.deleteAssigneeArr.length || $scope.addAssigneeArr.length)) {
                        $scope.fnUpdateIssueAssignee();
                    } else {
                        $scope.changeAssigneeView = false;
                        $scope.selectedAssignee = {};
                    }
                };

                $scope.fnUpdateIssueAssignee = function () {
                    $scope.isIssueAssigneeLoaded = false;
                    var tempArr = [];
                    _.forEach($scope.assigneesAssignees, function (assigneeObj) {
                        var findIndex = _.findIndex($scope.deleteAssigneeArr, function (deleteObj) {
                            return deleteObj.id === assigneeObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: assigneeObj.bio,
                                firstName: assigneeObj.firstName,
                                id: assigneeObj.id,
                                lastName: assigneeObj.lastName,
                                tags: assigneeObj.tags,
                                username: assigneeObj.username,
                                userAvatar: assigneeObj.userAvatar,
                                email: assigneeObj.email
                            });
                        }
                    });
                    _.forEach($scope.addAssigneeArr, function (addObj) {
                        var findIndex = _.findIndex($scope.assigneesAssignees, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                bio: addObj.bio,
                                firstName: addObj.firstName,
                                id: addObj.id,
                                lastName: addObj.lastName,
                                tags: addObj.tags,
                                username: addObj.username,
                                userAvatar: addObj.userAvatar,
                                email: addObj.email
                            })
                        }
                    });
                    $scope.newIssueObj.assignees = _.cloneDeepWith(tempArr);
                    $scope.assigneesAssignees = _.cloneDeepWith(tempArr);
                    $scope.isIssueAssigneeLoaded = true;
                    $scope.selectedAssignee = "";
                    $scope.deleteAssigneeArr = [];
                    $scope.addAssigneeArr = [];
                    $scope.changeAssigneeView = false;
                };

                $scope.fnOpenChangeAssigneeView = function () {
                    $scope.changeAssigneeView = true;
                    _.forEach($scope.assigneesAssignees, function (issueAssigneeObj) {
                        var isFindAssignee = _.find($scope.usersArr, {id: issueAssigneeObj.id});
                        isFindAssignee.isCheck = !!isFindAssignee;
                    });
                };

                $scope.fnManageAssignees = function () {
                    $state.go("main.users");
                };
                /*Assignee: END*/

                /*Type: START*/
                $scope.fnGetTypes = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            $scope.typesArr = _.cloneDeepWith(response.data);
                            $scope.typesArr.unshift({
                                id: "noType",
                                name: "Select Type"
                            });
                            if ($scope.issueDraftObj && $scope.issueDraftObj.issueType) {
                                var isFindType = _.find($scope.typesArr, {id: $scope.issueDraftObj.issueType.id});
                                if (isFindType) {
                                    $scope.selectedType = $scope.issueDraftObj.issueType;
                                    $scope.fnCreateTypeForm();
                                } else {
                                    $scope.selectedType = $scope.typesArr[0];
                                }
                            } else {
                                $scope.selectedType = $scope.typesArr[0];
                            }
                            $scope.isIssueTypeLoaded = true;
                            $timeout(function () {
                                $scope.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            $scope.isIssueTypeLoaded = true;
                            $timeout(function () {
                                $scope.fnSetIssueMarkdownHeight();
                            })
                        })
                };

                $scope.fnSelectType = function (typeObj) {
                    $scope.selectedType = typeObj;
                    if ($scope.selectedType.id === 'noType') {
                        delete $scope.newIssueObj.issueType;
                        $scope.model = {};
                        $scope.schema = {};
                        $scope.form = ['*'];
                    } else {
                        $scope.newIssueObj.issueType = typeObj;
                        $scope.fnCreateTypeForm();
                    }
                    $timeout(function () {
                        $scope.fnSetIssueMarkdownHeight();
                    })
                };

                $scope.fnCheckIssueTypeValidation = function () {
                    if ($scope.newIssueObj.issueType && $scope.form.length) {
                        var flag = false;
                        _.forEach($scope.form, function (formObj) {
                            if (formObj.required) {
                                _.forEach(formObj.key, function (keyValue) {
                                    if (angular.isUndefined($scope.model[keyValue]) || (angular.isDefined($scope.model[keyValue]) && !$scope.model[keyValue].toString().length)) {
                                        flag = true;
                                    }
                                })
                            }
                        });
                        return flag;
                    } else {
                        return false;
                    }
                };

                $scope.fnCreateTypeForm = function () {
                    $scope.isTypeDetailsLoaded = false;
                    var inputObj = {
                        typeId: $scope.selectedType.id
                    };
                    TypesFactory.describeIssueType(inputObj)
                        .then(function (response) {
                            if (response.form && response.form.schema && response.form.schema.properties && Object.keys(response.form.schema.properties).length) {
                                var tempData = TypeFormService.fnGenerateFormData(response.form.schema);
                                $scope.schema = tempData.schema;
                                $scope.form = tempData.form;
                                if (angular.isDefined($scope.issueDraftObj)) {
                                    if (angular.isDefined($scope.newIssueObj.issueType) && angular.isDefined($scope.newIssueObj.issueType.form)) {
                                        $scope.model = $scope.issueDraftObj.issueType.form.values;
                                    }
                                }
                            } else {
                                $scope.schema = {
                                    $schema: "https://json-schema.org/draft/2019-09/schema",
                                    type: "object",
                                    properties: {}
                                };
                                $scope.form = [];
                            }
                            $scope.isTypeDetailsLoaded = true;
                            $timeout(function () {
                                $scope.fnSetIssueMarkdownHeight();
                            })
                        }, function () {
                            $scope.isTypeDetailsLoaded = true;
                            //$scope.fnCreateTypeForm();
                        });
                };
                /*Type: END*/

                /*Priority: START*/
                $scope.addPrioritiesArr = [];
                $scope.deletePrioritiesArr = [];
                $scope.fnGetPriorities = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.prioritiesArr = _.cloneDeepWith(response.data);
                            $scope.isIssuePriorityLoaded = true;
                        }, function () {
                            $scope.isIssuePriorityLoaded = true;
                        })
                };

                $scope.fnGetPrioritiesInfo = function (prioritiesObj) {
                    _.forEach($scope.prioritiesArr, function (priorities) {
                        if (prioritiesObj.id !== priorities.id) {
                            priorities.isCheck = false;
                        }
                    });
                    prioritiesObj.isCheck = !prioritiesObj.isCheck;
                    $scope.deletePrioritiesArr = [];
                    $scope.addPrioritiesArr = [];
                    var isFindCheck = _.find($scope.prioritiesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined($scope.assigneesPriorities.id)) {
                            if ($scope.assigneesPriorities.id !== isFindCheck.id) {
                                $scope.addPrioritiesArr = [prioritiesObj];
                            }
                        } else {
                            $scope.addPrioritiesArr = [prioritiesObj];
                        }
                    } else {
                        if (angular.isDefined($scope.assigneesPriorities.id)) {
                            if ($scope.assigneesPriorities.id === prioritiesObj.id) {
                                $scope.deletePrioritiesArr = [$scope.assigneesPriorities];
                            }
                        }

                    }
                };

                $scope.fnCancelChangePriority = function () {
                    $scope.selectedPriority = {};
                    $scope.changePriorityView = false;
                    if ($scope.deletePrioritiesArr.length || $scope.addPrioritiesArr.length) {
                        $scope.fnUpdateIssuePriority();
                    }
                };

                $scope.fnOnTogglePriority = function (isOpen) {
                    if (isOpen === false && ($scope.deletePrioritiesArr.length || $scope.addPrioritiesArr.length)) {
                        $scope.fnUpdateIssuePriority();
                    } else {
                        $scope.changePriorityView = false;
                        $scope.selectedPriority = {};
                    }
                };

                $scope.fnUpdateIssuePriority = function () {
                    $scope.isIssuePriorityLoaded = false;
                    if ($scope.deletePrioritiesArr.length) {
                        delete $scope.newIssueObj.issuePriority;
                        $scope.assigneesPriorities = angular.isDefined($scope.newIssueObj.issuePriority) ? _.cloneDeepWith($scope.newIssueObj.issuePriority) : {};
                        _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                        });
                        $scope.changePriorityView = false;
                        $scope.isIssuePriorityLoaded = true;
                        $scope.deletePrioritiesArr = [];
                        $scope.addPrioritiesArr = [];
                    } else {
                        $scope.newIssueObj.issuePriority = $scope.addPrioritiesArr[0];
                        $scope.assigneesPriorities = angular.isDefined($scope.newIssueObj.issuePriority) ? _.cloneDeepWith($scope.newIssueObj.issuePriority) : {};
                        _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                            prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                        });
                        $scope.changePriorityView = false;
                        $scope.isIssuePriorityLoaded = true;
                        $scope.deletePrioritiesArr = [];
                        $scope.addPrioritiesArr = [];
                    }
                    $scope.selectedPriority = {};
                    $scope.changePriorityView = false;
                };

                $scope.fnOpenChangePriorityView = function () {
                    $scope.changePriorityView = true;
                    _.forEach($scope.prioritiesArr, function (prioritiesObj) {
                        prioritiesObj.isCheck = !!($scope.assigneesPriorities && $scope.assigneesPriorities.id && prioritiesObj.id === $scope.assigneesPriorities.id);
                    });
                };

                $scope.fnManageProjectPriority = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.newIssueObj.project.id,
                        "displaySearchText": $scope.newIssueObj.project.name
                    }];
                    $scope.go("main.priorities", {filter: angular.toJson(inputObj)});
                };
                /*Priority: END*/

                /*State: START*/
                $scope.addStatesArr = [];
                $scope.deleteStatesArr = [];
                $scope.fnGetStates = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.statesArr = _.cloneDeepWith(response.data);
                            $scope.isIssueStateLoaded = true;
                        }, function () {
                            $scope.isIssueStateLoaded = true;
                        })
                };

                $scope.fnGetStatesInfo = function (statesObj) {
                    _.forEach($scope.statesArr, function (states) {
                        if (statesObj.id !== states.id) {
                            states.isCheck = false;
                        }
                    });
                    statesObj.isCheck = !statesObj.isCheck;
                    $scope.deleteStatesArr = [];
                    $scope.addStatesArr = [];
                    var isFindCheck = _.find($scope.statesArr, {isCheck: true});
                    if (isFindCheck) {
                        if (angular.isDefined($scope.assigneesState.id)) {
                            if ($scope.assigneesState.id !== isFindCheck.id) {
                                $scope.addStatesArr = [statesObj];
                            }
                        } else {
                            $scope.addStatesArr = [statesObj];
                        }
                    } else {
                        if (angular.isDefined($scope.assigneesState.id)) {
                            if ($scope.assigneesState.id === statesObj.id) {
                                $scope.deleteStatesArr = [$scope.assigneesState];
                            }
                        }
                    }
                };

                $scope.fnCancelChangeState = function () {
                    $scope.selectedState = {};
                    $scope.changeStateView = false;
                    if ($scope.deleteStatesArr.length || $scope.addStatesArr.length) {
                        $scope.fnUpdateIssueState();
                    }
                };

                $scope.fnOnToggleState = function (isOpen) {
                    if (isOpen === false && ($scope.deleteStatesArr.length || $scope.addStatesArr.length)) {
                        $scope.fnUpdateIssueState();
                    } else {
                        $scope.changeStateView = false;
                        $scope.selectedState = {};
                    }
                };

                $scope.fnUpdateIssueState = function () {
                    $scope.isIssueStateLoaded = false;
                    if ($scope.deleteStatesArr.length) {
                        delete $scope.newIssueObj.issueState;
                        $scope.assigneesState = angular.isDefined($scope.newIssueObj.issueState) ? _.cloneDeepWith($scope.newIssueObj.issueState) : {};
                        _.forEach($scope.statesArr, function (statesObj) {
                            statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                        });
                        $scope.changeStateView = false;
                        $scope.isIssueStateLoaded = true;
                        $scope.deleteStatesArr = [];
                        $scope.addStatesArr = [];
                    } else {
                        $scope.newIssueObj.issueState = $scope.addStatesArr[0];
                        $scope.assigneesState = angular.isDefined($scope.newIssueObj.issueState) ? _.cloneDeepWith($scope.newIssueObj.issueState) : {};
                        _.forEach($scope.statesArr, function (statesObj) {
                            statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                        });
                        $scope.changeStateView = false;
                        $scope.isIssueStateLoaded = true;
                        $scope.deleteStatesArr = [];
                        $scope.addStatesArr = [];
                    }
                    $scope.selectedState = {};
                    $scope.changeStateView = false;
                };

                $scope.fnOpenChangeStateView = function () {
                    $scope.changeStateView = true;
                    _.forEach($scope.statesArr, function (statesObj) {
                        statesObj.isCheck = !!($scope.assigneesState && $scope.assigneesState.id && statesObj.id === $scope.assigneesState.id);
                    });
                };

                $scope.fnManageProjectState = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "displaySelectedField": "Project",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.newIssueObj.project.id,
                        "displaySearchText": $scope.newIssueObj.project.name
                    }];
                    $scope.go("main.state", {filter: angular.toJson(inputObj)});
                };
                /*State: END*/

                /*Labels: START*/
                $scope.addLabelArr = [];
                $scope.deleteLabelArr = [];
                $scope.fnGetLabels = function (inputObj) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) {
                            response.data.sort(function (a, b) {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }
                                return 0;
                            });
                            $scope.labelsArr = _.cloneDeepWith(response.data);
                            $scope.isIssueLablesLoaded = true;
                        }, function () {
                            $scope.isIssueLablesLoaded = true;
                        })
                };

                $scope.fnGetLabelInfo = function (labelObj) {
                    if (labelObj.isCheck) {
                        labelObj.isCheck = false;
                        var isFindLabel = _.find($scope.assigneesLabels, {id: labelObj.id});
                        if (isFindLabel) {
                            $scope.deleteLabelArr.push(isFindLabel);
                        } else {
                            var isFindLabelInAddLabelArr = _.findIndex($scope.addLabelArr, {id: labelObj.id});
                            if (isFindLabelInAddLabelArr !== 1) {
                                $scope.addLabelArr.splice(isFindLabelInAddLabelArr, 1);
                            }
                        }
                    } else {
                        labelObj.isCheck = true;
                        var isFindAssigneesLabel = _.find($scope.assigneesLabels, {id: labelObj.id});
                        if (!isFindAssigneesLabel) {
                            $scope.addLabelArr.push(labelObj);
                        } else {
                            var isFindDeleteLabel = _.findIndex($scope.deleteLabelArr, {id: labelObj.id});
                            if (isFindDeleteLabel !== -1) {
                                $scope.deleteLabelArr.splice(isFindDeleteLabel, 1);
                            }
                        }
                    }
                };

                $scope.fnAddLabelsToIssue = function (selectedLabel) {
                    $scope.isLabelsAdded = false;
                    $scope.newIssueObj.issueLabels.push(selectedLabel);
                    $scope.isLabelsAdded = true;
                    $scope.addLabelView = false;
                    $scope.selectedLabel = {};
                };

                $scope.fnCancelAddLabelView = function () {
                    $scope.selectedLabel = {};
                    $scope.addLabelView = false;
                    if ($scope.deleteLabelArr.length || $scope.addLabelArr.length) {
                        $scope.fnUpdateIssueLabel();
                    }
                };

                $scope.fnOnToggle = function (isOpen) {
                    if (isOpen === false && ($scope.deleteLabelArr.length || $scope.addLabelArr.length)) {
                        $scope.fnUpdateIssueLabel();
                    } else {
                        $scope.addLabelView = false;
                        $scope.selectedLabel = {};
                    }
                };

                $scope.fnUpdateIssueLabel = function () {
                    $scope.isIssueLablesLoaded = false;
                    var tempArr = [];
                    _.forEach($scope.assigneesLabels, function (labelObj) {
                        var findIndex = _.findIndex($scope.deleteLabelArr, function (deleteObj) {
                            return deleteObj.id === labelObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: labelObj.id,
                                name: labelObj.name,
                                color: labelObj.color,
                                tags: labelObj.tags ? labelObj.tags : {}
                            });
                        }
                    });
                    _.forEach($scope.addLabelArr, function (addObj) {
                        var findIndex = _.findIndex($scope.assigneesLabels, function (tempObj) {
                            return tempObj.id === addObj.id;
                        });
                        if (findIndex === -1) {
                            tempArr.push({
                                id: addObj.id,
                                name: addObj.name,
                                color: addObj.color,
                                tags: addObj.tags ? addObj.tags : {}
                            })
                        }
                    });
                    $scope.newIssueObj.issueLabels = _.cloneDeepWith(tempArr);
                    $scope.assigneesLabels = _.cloneDeepWith(tempArr);
                    $scope.isIssueLablesLoaded = true;
                    $scope.selectedLabel = {};
                    $scope.deleteLabelArr = [];
                    $scope.addLabelArr = [];
                    $scope.addLabelView = false;
                };

                $scope.fnOpenAddLabelView = function () {
                    $scope.addLabelView = true;
                    _.forEach($scope.assigneesLabels, function (issueLabelObj) {
                        var isFindLabel = _.find($scope.labelsArr, {id: issueLabelObj.id});
                        isFindLabel.isCheck = !!isFindLabel;
                    });
                };

                $scope.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        return '#FFFFFF';
                        //throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                $scope.fnGetIssuesLabelColor = function (color) {
                    if (angular.isDefined(color)) {
                        return {
                            "background-color": color,
                            "color": $scope.fnInvertColor(color.toString())
                        }
                    }
                };

                $scope.fnManageProjectLabels = function () {
                    var inputObj = [{
                        "id": Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                        "selectedField": "projectId",
                        "selectedFilter": {
                            "operatorName": "equals to",
                            "operator": "="
                        },
                        "searchText": $scope.newIssueObj.projectId
                    }];
                    $state.go("main.label", {filter: angular.toJson(inputObj)});
                };
                /*Labels: END*/

                /*Participant: START*/
                $scope.addParticipantArr = [];
                $scope.deleteParticipantArr = [];
                $scope.fnGetParticipants = function () {
                    var participants = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'participantsList');
                    if (participants && participants.length) {
                        $scope.participantUsersArr = _.cloneDeepWith(participants);
                    } else {
                        $scope.participantUsersArr = [];
                    }
                    if ($scope.newIssueObj &&
                        $scope.newIssueObj.participants &&
                        $scope.newIssueObj.participants.length) {
                        _.forEach($scope.newIssueObj.participants, function (participant) {
                            var isFindIndex = _.findIndex($scope.participantUsersArr, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndex === -1) {
                                $scope.participantUsersArr.push({
                                    email: participant,
                                    isCheck: true
                                })
                            }

                            var isFindIndexAssignee = _.findIndex($scope.assigneesParticipants, function (addedParticipant) {
                                return addedParticipant.email === participant;
                            });
                            if (isFindIndexAssignee === -1) {
                                $scope.assigneesParticipants.push({
                                    email: participant
                                })
                            }
                        })
                    }
                    $scope.resetParticipantUsersArr = _.cloneDeepWith($scope.participantUsersArr);
                    $scope.isIssueParticipantLoaded = true;
                };

                $scope.fnGetParticipantInfo = function (participantObj) {
                    if (participantObj.isCheck) {
                        participantObj.isCheck = false;
                        var isFindParticipant = _.find($scope.assigneesParticipants, {email: participantObj.email});
                        if (isFindParticipant) {
                            $scope.deleteParticipantArr.push(isFindParticipant);
                        } else {
                            var isFindParticipantInAddParticipantArr = _.findIndex($scope.addParticipantArr, {email: participantObj.email});
                            if (isFindParticipantInAddParticipantArr !== 1) {
                                $scope.addParticipantArr.splice(isFindParticipantInAddParticipantArr, 1);
                            }
                        }
                    } else {
                        participantObj.isCheck = true;
                        var isFindAssigneesParticipant = _.find($scope.assigneesParticipants, {email: participantObj.email});
                        if (!isFindAssigneesParticipant) {
                            $scope.addParticipantArr.push(participantObj);
                        } else {
                            var isFindDeleteParticipant = _.findIndex($scope.deleteParticipantArr, {email: participantObj.email});
                            if (isFindDeleteParticipant !== -1) {
                                $scope.deleteParticipantArr.splice(isFindDeleteParticipant, 1);
                            }
                        }
                    }
                };

                $scope.fnCancelChangeParticipant = function () {
                    $scope.selectedParticipant = {};
                    $scope.changeParticipantView = false;
                    $scope.isParticipantChanged = true;
                    if ($scope.deleteParticipantArr.length || $scope.addParticipantArr.length) {
                        $scope.fnUpdateIssueParticipant();
                    }
                };

                $scope.fnOnToggleParticipant = function (isOpen) {
                    if (isOpen === false && ($scope.deleteParticipantArr.length || $scope.addParticipantArr.length)) {
                        $scope.fnUpdateIssueParticipant();
                    } else {
                        $scope.changeParticipantView = false;
                        $scope.selectedParticipant = {};
                    }
                };

                $scope.fnUpdateIssueParticipant = function () {
                    $scope.isIssueParticipantsLoaded = false;
                    var tempArr = [];
                    var participantsArr = [];
                    _.forEach($scope.assigneesParticipants, function (participantObj) {
                        var findIndex = _.findIndex($scope.deleteParticipantArr, function (deleteObj) {
                            return deleteObj.email === participantObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(participantObj.email);
                            tempArr.push(participantObj);
                        }
                    });
                    _.forEach($scope.addParticipantArr, function (addObj) {
                        var findIndex = _.findIndex($scope.assigneesParticipants, function (tempObj) {
                            return tempObj.email === addObj.email;
                        });
                        if (findIndex === -1) {
                            participantsArr.push(addObj.email);
                            tempArr.push(addObj);
                        }
                    });
                    $scope.newIssueObj.participants = _.cloneDeepWith(participantsArr);
                    $scope.assigneesParticipants = _.cloneDeepWith(tempArr);
                    $scope.isIssueParticipantsLoaded = true;
                    $scope.selectedParticipant = {};
                    $scope.deleteParticipantArr = [];
                    $scope.addParticipantArr = [];
                    $scope.changeParticipantView = false;
                };

                $scope.fnOpenChangeParticipantView = function () {
                    $scope.changeParticipantView = true;
                    _.forEach($scope.assigneesParticipants, function (issueParticipantObj) {
                        var isFindParticipant = _.find($scope.participantUsersArr, {email: issueParticipantObj.email});
                        isFindParticipant.isCheck = !!isFindParticipant;
                    });
                };

                $scope.fnAddNewParticipant = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html',
                        size: 'lg',
                        controller: 'addParticipantCtrl as addParticipant',
                        windowClass: 'modal-height100'
                    });
                    modalInstance.result.then(function (data) {
                        if (!$scope.newIssueObj.participants) {
                            $scope.newIssueObj.participants = [];
                        }
                        if (!$scope.assigneesParticipants) {
                            $scope.assigneesParticipants = [];
                        }
                        if (!$scope.participantUsersArr) {
                            $scope.participantUsersArr = [];
                        }
                        $scope.newIssueObj.participants.push(_.cloneDeepWith(data.email));
                        $scope.assigneesParticipants.push(_.cloneDeepWith(data));
                        $scope.participantUsersArr.push(_.cloneDeepWith(data));
                    }, function () {

                    });
                };
                /*Participant: END*/

                /*Confidential: START*/
                $scope.fnOpenChangeConfidentialView = function () {
                    $scope.selectedConfidential = {};
                    $scope.changeConfidentialView = true;
                };

                $scope.fnChangeIssueConfidential = function (selectedConfidential) {
                    $scope.isConfidentialChanged = false;
                    if (selectedConfidential.value) {
                        $scope.newIssueObj.confidential = true;
                        $scope.changeConfidentialView = false;
                        $scope.isConfidentialChanged = true;
                    } else {
                        $scope.newIssueObj.confidential = false;
                        $scope.changeConfidentialView = false;
                        $scope.isConfidentialChanged = true;
                    }
                };

                $scope.fnCancelChangeConfidential = function () {
                    $scope.selectedConfidential = {};
                    $scope.changeConfidentialView = false;
                    $scope.isConfidentialChanged = true;
                };
                /*Confidential: END*/

                $scope.fnCheckEmpty = function (obj) {
                    return angular.isDefined(obj) && obj.length > 0;
                };

                $scope.fnInitSideBar = function () {
                    $scope.usersArr = [{
                        username: 'assign to me'
                    }];
                    $scope.isIssueAssigneeLoaded = false;
                    $scope.usersArr = [];
                    $scope.changeAssigneeView = false;
                    $scope.fnUploadChartImage();
                    var input = {
                        projectId: $scope.newIssueObj.projectId
                    };
                    $scope.fnGetUsers(input);
                    ProjectFactory.describeProjectRelationships(input)
                        .then(function (response) {
                            $scope.projectRelationshipsObj = _.cloneDeepWith(response);
                            $scope.isIssueTypeLoaded = false;
                            var upstreamProject = "";
                            _.forEach($scope.projectRelationshipsObj.upstreamProjectIds, function (projectId) {
                                if (upstreamProject !== "") {
                                    upstreamProject += ", '" + projectId + "'";
                                } else {
                                    upstreamProject = "'" + projectId + "'";
                                }
                            });
                            var typeSQL = "SELECT * FROM tracker_types as types where where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetTypes({sql: typeSQL});

                            $scope.isIssueLablesLoaded = false;
                            $scope.assigneesLabels = _.cloneDeepWith($scope.newIssueObj.issueLabels);
                            var labelSQL = "SELECT * FROM tracker_labels as labels where where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetLabels({sql: labelSQL});

                            $scope.isIssuePriorityLoaded = false;
                            $scope.assigneesPriorities = angular.isDefined($scope.newIssueObj.issuePriority) ? _.cloneDeepWith($scope.newIssueObj.issuePriority) : {};
                            var prioritiesSQL = "SELECT * FROM tracker_priorities as priorities where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetPriorities({sql: prioritiesSQL});
                            $scope.changePriorityView = false;

                            $scope.isIssueStateLoaded = false;
                            $scope.assigneesState = angular.isDefined($scope.newIssueObj.issueState) ? _.cloneDeepWith($scope.newIssueObj.issueState) : {};
                            var stateSQL = "SELECT * FROM tracker_states as states where data->>'projectId' IN (" + upstreamProject + ")";
                            $scope.fnGetStates({sql: stateSQL});
                            $scope.changeStateView = false;

                            $scope.isIssueParticipantLoaded = false;
                            $scope.fnGetParticipants();
                            $scope.changeParticipantView = false;
                        }, function () {
                        });
                };

                /* eslint-disable */
                $scope.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        plantuml_runonce();
                        vega_runonce();
                    }, 100);
                };
                /* eslint-enable */

                $scope.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                $scope.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                $scope.projectsArr = _.cloneDeepWith(projects);
                                $scope.projectsArr.sort(function (a, b) {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }
                                    return 0;
                                });
                                if ($scope.issueDraftObj && $scope.issueDraftObj.projectId && $scope.issueDraftObj.projectId !== '') {
                                    var isFindDraftProject = _.find($scope.projectsArr, {id: $scope.issueDraftObj.projectId});
                                    if (isFindDraftProject) {
                                        $scope.selectedProject = isFindDraftProject;
                                        $scope.newIssueObj.projectId = isFindDraftProject.id;
                                    } else {
                                        $scope.fnGetSelectedProject();
                                    }
                                } else {
                                    $scope.fnGetSelectedProject();
                                }
                                $scope.fnInitSideBar();
                                $scope.isProjectLoaded = true;
                            }
                        }, function () { // Error block
                            $scope.isProjectLoaded = true;
                            $scope.projectsArr = [];
                        })
                };

                $scope.fnGetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find($scope.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            $scope.selectedProject = isFindProject;
                            $scope.newIssueObj.projectId = isFindProject.id;
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find($scope.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            $scope.selectedProject = isFindStateParamsProject;
                            $scope.newIssueObj.projectId = isFindStateParamsProject.id;
                        }
                    } else {
                        _.forEach($scope.projectsArr, function (dataObj) {
                            if (!dataObj.parentProjectId) {
                                $scope.selectedProject = dataObj;
                                $scope.newIssueObj.projectId = dataObj.id;
                            }
                        });
                    }
                };

                $scope.fnInitCreateIssue = function () {
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        if (!localStorage.getItem($scope.localdataKey + 'ChartData')) {
                            $scope.issueDraftObj = localStorage.getItem($scope.localdataKey + 'FedSupportIssueDraft') ?
                                angular.fromJson(localStorage.getItem($scope.localdataKey + 'FedSupportIssueDraft')) : {};
                        }
                    } else {
                        if (!localStorage.getItem($scope.localdataKey + 'ChartData')) {
                            $scope.issueDraftObj = localStorage.getItem($scope.localdataKey + 'IssueDraft') ?
                                angular.fromJson(localStorage.getItem($scope.localdataKey + 'IssueDraft')) : {};
                        }
                    }
                    if (angular.isDefined($scope.issueDraftObj) && $scope.issueDraftObj !== {}) {
                        $scope.newIssueObj = $scope.issueDraftObj;
                    }
                    if (localStorage.getItem($scope.localdataKey + 'ChartData')) {
                        var tempData = localStorage.getItem($scope.localdataKey + 'ChartData') ? _.cloneDeepWith(angular.fromJson(localStorage.getItem($scope.localdataKey + 'ChartData'))) : {};
                        //localStorage.removeItem($scope.localdataKey+'ChartData');
                        $scope.newIssueObj.rowData = _.cloneDeepWith(tempData.rowData);
                    }
                    $scope.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    $scope.isProjectLoaded = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        $scope.projectsArr = AppInitService.getInitData('projectsArr');
                        $scope.projectsArr.sort(function (a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        });
                        if ($scope.issueDraftObj && $scope.issueDraftObj.projectId && $scope.issueDraftObj.projectId !== '') {
                            var isFindDraftProject = _.find($scope.projectsArr, {id: $scope.issueDraftObj.projectId});
                            if (isFindDraftProject) {
                                $scope.selectedProject = isFindDraftProject;
                                $scope.newIssueObj.projectId = isFindDraftProject.id;
                            } else {
                                $scope.fnGetSelectedProject();
                            }
                        } else {
                            $scope.fnGetSelectedProject();
                        }
                        $timeout(function () {
                            $scope.fnInitSideBar();
                            $scope.isProjectLoaded = true;
                        })
                    } else {
                        $scope.isProjectLoaded = false;
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        $scope.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    $timeout(function () {
                        $scope.fnSetIssueMarkdownHeight();
                    })
                };

                $scope.$on('resetCreateIssue', function () {
                    /*$scope.newIssueObj = angular.copy($scope.resetNewIssueObj);
                    $scope.fnInitCreateIssue();
                    $timeout(function () { // set table height
                        $scope.issue.fnSetTableHeight();//parent function
                    }, 800);*/
                });

                $scope.fnSetIssueMarkdownHeight = function () {
                    var height = 282;
                    if (angular.isDefined(angular.element("#modal-body")[0]) &&
                        angular.isDefined(angular.element("#newIssueTitle")[0]) &&
                        angular.isDefined(angular.element("#typeListDropdown")[0])) {
                        var total = angular.element("#modal-body")[0].offsetHeight;
                        var newIssue = angular.element("#newIssueTitle")[0].offsetHeight;
                        var typeListDropdown = angular.element("#typeListDropdown")[0].offsetHeight;
                        var finalHeight = total - (newIssue + typeListDropdown + 60);
                        if (height < finalHeight) {
                            angular.element("#issueMarkdownContainer").css('height', finalHeight + 'px');
                        } else {
                            angular.element("#issueMarkdownContainer").css('height', 282 + 'px');
                        }
                    }

                };

                $scope.fnSaveIssueDraft = function () {
                    if ($scope.newIssueObj.issueType && $scope.newIssueObj.issueType.form) {
                        $scope.newIssueObj.issueType.form.values = $scope.model;
                    }

                    if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                        localStorage.setItem($scope.localdataKey + 'IssueDraft', angular.toJson($scope.newIssueObj));
                    } else {
                        localStorage.setItem($scope.localdataKey + 'FedSupportIssueDraft', angular.toJson($scope.newIssueObj));
                    }
                };

                $scope.fnUploadChartImage = function () {
                    if (localStorage.getItem($scope.localdataKey + 'ChartData')) {
                        var tempData = localStorage.getItem($scope.localdataKey + 'ChartData') ? _.cloneDeepWith(angular.fromJson(localStorage.getItem($scope.localdataKey + 'ChartData'))) : {};
                        localStorage.removeItem($scope.localdataKey + 'ChartData');
                        $scope.fileUploading = true;
                        var exportUrl = "https://export.highcharts.com/";
                        $http.post(exportUrl, {
                            "async": true,
                            "infile": _.cloneDeepWith(angular.toJson(tempData.chart))
                        }).success(function (data) {
                            $http.get(exportUrl + data, {responseType: 'arraybuffer'})
                                .success(function (data) {
                                    var file = new Blob([data], {
                                        type: 'image/png'
                                    });
                                    var inputObj = {
                                        projectId: $scope.newIssueObj.projectId
                                    };
                                    IssueFactory.getFileUploadLink(inputObj)
                                        .then(function (res) {
                                            $http({
                                                method: 'PUT',
                                                url: res.uploadUrl,
                                                config: {
                                                    headers: {
                                                        'Content-Type': file.type
                                                    }
                                                },
                                                data: file
                                            }).success(function () {
                                                if ($scope.newIssueObj.summary && $scope.newIssueObj.summary.length) {
                                                    $scope.newIssueObj.summary += "\n<br>\n ### Chart \n![chart.png](" + res.downloadUrl + ")";
                                                } else {
                                                    $scope.newIssueObj.summary = "### Chart \n![chart.png](" + res.downloadUrl + ")";
                                                }
                                                $scope.fileUploading = false;
                                            }).error(function () {
                                                $scope.fileUploading = false;
                                            });
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                            $scope.fileUploading = false;
                                        })
                                }).error(function () {
                                $scope.fileUploading = false;
                            });
                        }).error(function () {
                            $scope.fileUploading = false;
                        });
                    }
                }

                $scope.fnInitCreateIssue();

                function capitalizeFirstLetter(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                }

                $scope.fnAddMetaInfo = function () {
                    if ($scope.newIssueObj.rowData) {
                        var headersArr = Object.keys($scope.newIssueObj.rowData[0]);
                        var tableMDString = "\n <br>\n ### Chart Result \n <table>\n<tr>";
                        _.forEach(headersArr, function (header) {
                            tableMDString += "<th>" + header + "</th>";
                        })
                        tableMDString += "</tr>\n";
                        _.forEach($scope.newIssueObj.rowData, function (dataObj) {
                            tableMDString += "<tr>\n";
                            _.forEach(headersArr, function (header) {
                                tableMDString += "<td>" + dataObj[header] + "</td>";
                            })
                            tableMDString += "<tr>\n";
                        })
                        tableMDString += "</table>\n";
                        $scope.newIssueObj.summary += tableMDString;
                    }
                }

                $scope.fnExpandCollapseSideBar = function () {
                    $scope.isExpanded = !$scope.isExpanded;
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'sideBarExpanded', _.cloneDeepWith($scope.isExpanded));
                };

                $scope.fnGetAssigneesTooltipInfo = function () {
                    if ($scope.newIssueObj.assignees && $scope.newIssueObj.assignees.length) {
                        return $scope.newIssueObj.assignees.map(function (el) {
                            return el.firstName + " " + el.lastName
                        }).join(", ");
                    } else {
                        return "No assignee";
                    }
                };

                $scope.fnGetLabelsTooltipInfo = function () {
                    if ($scope.newIssueObj.issueLabels && $scope.newIssueObj.issueLabels.length) {
                        return $scope.newIssueObj.issueLabels.map(function (el) {
                            return el.name
                        }).join(", ");
                    } else {
                        return "No labels";
                    }
                };

                $scope.fnGetParticipantsTooltipInfo = function () {
                    if ($scope.newIssueObj.participants && $scope.newIssueObj.participants.length) {
                        return $scope.newIssueObj.participants.map(function (el) {
                            return el
                        }).join(", ");
                    } else {
                        return "No participant";
                    }
                };

                $window.onbeforeunload = function () {
                    return $scope.fnSaveIssueDraft();
                };

                $scope.$on("$destroy", function () {
                    $scope.fnSaveIssueDraft();
                });

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('customTreeUi', fnCustomTreeUI);

    /** @ngInject */
    function fnCustomTreeUI() {
        return {
            restrict: 'EA',
            scope: {
                treeData: '=',
                currentNode: '=',
                level: '=',
                isRootParent: '=',
                isLastChild: '=',
                getNodeInfo: '&',
                fnGetNodeDetail: '&',
                fnGetNodeTelemetryDetail: '&',
                fnGetNodeEditDetail: '&',
                fnGetNodeEditAndCascadeDetail: '&'
            },
            templateUrl: "app/components/directives/customTreeUI/customTreeUI.html",
            link: function ($scope) {
                if (!document.getElementById('style-' + $scope.level)) {
                    var cssStr = ".left_" + $scope.level + ":after{transform: translate(" + ((($scope.level - 1) * 16) + 9) + "px,0)!important;" +
                        "left:0%!important;}" +
                        ".left_" + $scope.level + ":before{transform: translate(" + ((($scope.level) * 16) + 9) + "px,0)!important;" +
                        "left:0%!important;}";
                    var style = document.createElement("style");
                    style.id = 'style-' + $scope.level;
                    style.innerHTML = cssStr;
                    document.head.appendChild(style);
                }

                $scope.nodeDetailContextMenu = function (nodeDetailObj) {
                    return [{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            $scope.fnGetNodeEditInfo(nodeDetailObj);
                        }
                    },{
                        text: 'Rename and Cascade',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            $scope.fnGetNodeEditAndCascadeInfo(nodeDetailObj);
                        },
                        displayed: !!(nodeDetailObj.children && nodeDetailObj.children.length)
                    }]
                };

                $scope.fnGetNodeSummaryHealthColor = function (deviceObj) {
                    if (deviceObj.health !== '') {
                        return "color :" + deviceObj.healthColor + ";";
                    } else {
                        return {};
                    }
                };

                $scope.isDropUp = false;
                $scope.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    $scope.isDropUp = finalPostion >= menuHeight;
                };

                $scope.fnGetNodeInfo = function (nodeObj) {
                    return $scope.fnGetNodeDetail({nodeObj: nodeObj});
                };

                $scope.fnGetNodeTelemetryInfo = function (nodeObj) {
                    return $scope.fnGetNodeTelemetryDetail({nodeObj: nodeObj});
                };

                $scope.fnGetNodeEditInfo = function (nodeObj) {
                    return $scope.fnGetNodeEditDetail({nodeObj: nodeObj});
                };

                $scope.fnGetNodeEditAndCascadeInfo = function (nodeObj) {
                    return $scope.fnGetNodeEditAndCascadeDetail({nodeObj: nodeObj});
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('connectionHeatMapChart', fnConnectionHeatMapChart);

    /** @ngInject */
    function fnConnectionHeatMapChart(Highcharts, $timeout, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                nodeId: '=',
                type: '=',
                infoSectionClass: "=",
                filterObj: '=',
                compArr: "=",
                categoriesArr: "="
            },
            templateUrl: "app/components/directives/connectionHeatMapChart/connectionHeatMapChart.html",
            link: function ($scope) {
                var filename, start, end;
                if ($scope.filterObj.type === 'relative') {
                    start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                    end = moment().toISOString()
                } else {
                    start = moment($scope.filterObj.start).toISOString();
                    end = moment($scope.filterObj.stop).toISOString();
                }
                $scope.isShowBorder = moment(end).diff(moment(start), 'hours') <= 3;
                filename = $scope.nodeId + '_' + $scope.type + '_' + start + '_' + end;
                $scope.$watch('infoSectionClass', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $scope.fnDrawChart();
                    }
                }, true);

                $scope.fnDrawChart = function () {
                    $timeout(function () {
                        Highcharts.chart("connectionHeatMapChartMainContainer", {
                            chart: {
                                type: 'heatmap',
                                margin: [50, 10, 75, 80],
                                plotBorderWidth: 0,
                                inverted: true,
                                height: 160
                            },
                            boost: {
                                useGPUTranslations: true,
                                usePreallocated: true
                            },
                            title: {
                                text: '',
                                align: 'left'
                            },
                            credits: {
                                enabled: false
                            },
                            xAxis: {
                                categories: $scope.compArr,
                                visible: false
                            },
                            legend: {
                                enabled: false
                            },
                            yAxis: {
                                title: null,
                                visible: true,
                                tickInterval: Math.ceil($scope.categoriesArr.length / 10),
                                tickPositioner: function (min, max) {
                                    var interval = this.options.tickInterval,
                                        ticks = [],
                                        count = 0;
                                    while (min < max) {
                                        ticks.push(min);
                                        min += interval;
                                        count++;
                                    }
                                    var isLastValue = ticks[ticks.length - 1];
                                    if (isLastValue < max) {
                                        ticks.push(max);
                                    }
                                    ticks.info = {
                                        unitName: 'day',
                                        count: count,
                                        higherRanks: {},
                                        totalRange: interval * count
                                    };
                                    return ticks;
                                },
                                categories: $scope.categoriesArr ? $scope.categoriesArr : [],
                                labels: {
                                    rotation: -60
                                },
                                showLastLabel: false
                            },
                            tooltip: {
                                formatter: function () {
                                    return '<b>' + this.series.xAxis.categories[this.point.x] + '</b> <br><b>' +
                                        this.point.date + '</b><br><b>' + this.point.connection + '</b>';
                                }
                            },
                            series: [{
                                name: '',
                                borderWidth: $scope.isShowBorder ? 1 : 0,
                                borderColor: "#ffffff",
                                data: $scope.chartData,
                                turboThreshold: $scope.chartData.length + 100
                            }],
                            navigation: {
                                buttonOptions: {
                                    height: 25,
                                    width: 25,
                                    symbolSize: 12,
                                    symbolX: 13,
                                    symbolY: 13,
                                    symbolStrokeWidth: 2,
                                    theme: {
                                        'stroke-width': 1,
                                        stroke: 'silver',
                                        r: 50
                                    }
                                }
                            },
                            exporting: {
                                filename: filename,
                                csv: {
                                    dateFormat: '%Y-%m-%d %H:%M:%S'
                                },
                                buttons: {
                                    contextButton: {
                                        menuItems: ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                                    }
                                },
                                menuItemDefinitions: {
                                    printChart: {
                                        onclick: function () {
                                            var divToPrint = document.getElementById("connectionHeatMapChartMainContainer");
                                            var newWin = window.open(); //eslint-disable-line
                                            newWin.document.write(divToPrint.innerHTML);
                                            newWin.document.close();
                                            newWin.focus();
                                            newWin.print();
                                            newWin.close();
                                        }
                                    }
                                }
                            }

                        })
                        ;
                    })
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('bubbleChart', fnBubbleChart);

    /** @ngInject */
    function fnBubbleChart($timeout, Highcharts) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                getComponent: '&'
            },
            templateUrl: "app/components/directives/bubbleChart/bubbleChart.html",
            link: function ($scope) {

                var fnGetComponentDetail = function fnGetComponentDetail(id) {
                    $scope.getComponent({componet: {id: id}});
                };

                var fnTriggerSupplementalDataModal = function fnTriggerSupplementalDataModal(id) {
                    $scope.getComponent({componet: {id: id}, isCalledForModal: true});
                };

                var mouseIn;

                $scope.fnDrawChart = function () {
                    $timeout(function () {
                        Highcharts.chart('bubbleChartMainContainer', {
                            chart: {
                                type: 'packedbubble'
                            },
                            title: {
                                text: ''
                            },
                            tooltip: {
                                useHTML: true,
                                pointFormat: '<b>{point.name}</b>'
                            },
                            legend: {
                                enabled: false
                            },
                            exporting: {
                                enabled: false
                            },
                            credits: {
                                enabled: false
                            },
                            plotOptions: {
                                packedbubble: {
                                    minSize: '20%',
                                    maxSize: '100%',
                                    zMin: 0,
                                    zMax: 1000,
                                    layoutAlgorithm: {
                                        gravitationalConstant: 0.05,
                                        splitSeries: true,
                                        seriesInteraction: false,
                                        dragBetweenSeries: false,
                                        parentNodeLimit: true
                                    },
                                    dataLabels: {
                                        enabled: true,
                                        format: '{point.name}',
                                        filter: {
                                            property: 'y',
                                            operator: '>',
                                            value: 250
                                        },
                                        style: {
                                            color: 'black',
                                            textOutline: 'none',
                                            fontWeight: 'normal'
                                        }
                                    },
                                    events: {
                                        click: function (event) {
                                            var contextMenu = document.getElementById('contextMenuBubble');
                                            var contextMenuItem1 = document.getElementById('contextMenuItem1');
                                            var contextMenuItem2 = document.getElementById('contextMenuItem2');

                                            contextMenuItem1.onclick = function () {
                                                fnGetComponentDetail(event.point.pointId)
                                            };
                                            contextMenuItem2.onclick = function () {
                                                fnTriggerSupplementalDataModal(event.point.pointId)
                                            };
                                            contextMenu.addEventListener('mouseenter', function () {
                                                mouseIn = true;
                                            }, false);

                                            contextMenu.addEventListener('mouseleave', function () {
                                                mouseIn = false;
                                                $timeout(function () {
                                                    if (!mouseIn) {
                                                        contextMenu.setAttribute('style', 'display: none');
                                                    }
                                                }, 1000);
                                            }, false);

                                            contextMenu.setAttribute('style', 'top: ' + event.chartY + 'px; left:'
                                                + event.chartX + 'px;');
                                        }
                                    }
                                }
                            },
                            series: $scope.chartData
                        });
                    })
                };

                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('donutChart', fnDonutChart);

    /** @ngInject */
    function fnDonutChart(Highcharts) {
        return {
            restrict: 'EA',
            scope: {
                donutData: "=",
                isShowLabel: "="
            },
            templateUrl: "app/components/directives/billingDonutChart/donutChart.html",
            link: function ($scope) {
                $scope.donutLegend = [];
                var data = [];
                _.forEach($scope.donutData, function (donutData) {
                    data.push([donutData.name, donutData.value])
                });
                $scope.$watch('isShowLabel', function () {
                    $scope.donutLegend = [];
                    var data = [];
                    _.forEach($scope.donutData, function (donutData) {
                        data.push([donutData.name, donutData.value])
                    });
                    $scope.fnDrawChart();
                }, true);

                $scope.fnDrawChart = function(){
                    Highcharts.chart('chart', {
                        chart: {
                            type: 'pie',
                            options3d: {
                                enabled: true,
                                alpha: 0
                            }
                        },
                        title: {
                            text: ''
                        },
                        subtitle: {
                            text: ''
                        },
                        credits: {
                            enabled: false
                        },
                        plotOptions: {
                            pie: {
                                innerSize: 100,
                                depth: 45,
                                dataLabels: {
                                    enabled: $scope.isShowLabel
                                }
                            },
                            series: {
                                dataLabels: {
                                    enabled: true,
                                    format: '{point.name}: ${point.y:.2f}'
                                }
                            }
                        },
                        series: [{
                            name: '',
                            data: data
                        }],
                        navigation: {
                            buttonOptions: {
                                height: 25,
                                width: 25,
                                symbolSize: 12,
                                symbolX: 13,
                                symbolY: 13,
                                symbolStrokeWidth: 2,
                                theme: {
                                    'stroke-width': 1,
                                    stroke: 'silver',
                                    r: 50
                                }
                            }
                        },
                        exporting: {
                            filename: "",
                            csv: {
                                columnHeaderFormatter: function (item, key) {
                                    if (key === 'x' || angular.isUndefined(key)) {
                                        return 'Start Timestamp';
                                    } else {
                                        return key
                                    }
                                }
                            },
                            buttons: {
                                contextButton: {
                                    menuItems: ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                                }
                            },
                            menuItemDefinitions: {
                                printChart: {
                                    onclick: function() {
                                        var divToPrint = document.getElementById('chart');
                                        var newWin = window.open(); //eslint-disable-line
                                        newWin.document.write(divToPrint.innerHTML);
                                        newWin.document.close();
                                        newWin.focus();
                                        newWin.print();
                                        newWin.close();
                                    }
                                }
                            }
                        }
                    }, function (chart) {
                        _.forEach(chart.series[0].data, function (data) {
                            $scope.donutLegend.push({color: data.color,name : data.name, value: data.y})
                        });
                    });
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('barChart', fnBarChart);

    /** @ngInject */
    function fnBarChart(Highcharts) {
        return {
            restrict: 'EA',
            scope: {
                barData: '='
            },
            templateUrl: "app/components/directives/billingBarChart/barChart.html",
            link: function ($scope) {
                var data = [];
                _.forEach($scope.barData, function(barObj) {
                    data.push({
                        name: barObj.Letter,
                        y: parseFloat(barObj.Freq),
                        color: barObj.currentMonth === "Yes" ?'#008000':''
                    });
                });
                Highcharts.chart('barChart', {
                    chart: {
                        type: 'column',
                        marginTop: 50
                    },
                    title: {
                        text: ''
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {
                        title: {
                            text: ''
                        }
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    plotOptions: {
                        series: {
                            borderWidth: 0,
                            dataLabels: {
                                enabled: true,
                                format: '${point.y}'
                            }
                        }
                    },
                    tooltip: {
                        headerFormat: '',
                        pointFormat: '<b>${point.y:.2f}</b>'
                    },
                    series: [
                        {
                            name: "",
                            data: data
                        }
                    ],
                    navigation: {
                        buttonOptions: {
                            height: 25,
                            width: 25,
                            symbolSize: 12,
                            symbolX: 13,
                            symbolY: 13,
                            symbolStrokeWidth: 2,
                            theme: {
                                'stroke-width': 1,
                                stroke: 'silver',
                                r: 50
                            }
                        }
                    },
                    exporting: {
                        menuItemDefinitions: {
                            printChart: {
                                onclick: function() {
                                    var divToPrint = document.getElementById('barChart');
                                    var newWin = window.open(); //eslint-disable-line
                                    newWin.document.write(divToPrint.innerHTML);
                                    newWin.document.close();
                                    newWin.focus();
                                    newWin.print();
                                    newWin.close();
                                }
                            }
                        },
                        buttons: {
                            contextButton: {
                                menuItems: ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
                            }
                        }
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('lineChart', fnLineChart);

    /** @ngInject */
    function fnLineChart(Highcharts, $timeout, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                nodeId: '=',
                type: '=',
                infoSectionClass: "=",
                filterObj: '='
            },
            templateUrl: "app/components/directives/LineChart/LineChart.html",
            link: function ($scope) {
                var filename, start, end;
                if ($scope.filterObj.type === 'relative') {
                    start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                    end = moment().toISOString()
                } else {
                    start = moment($scope.filterObj.start).toISOString();
                    end = moment($scope.filterObj.stop).toISOString();
                }
                filename = $scope.nodeId + '_' + $scope.type + '_' + start + '_' + end;
                $scope.$watch('infoSectionClass', function () {
                    $scope.fnDrawChart();
                }, true);

                $scope.fnDrawChart = function () {
                    $timeout(function () {
                        Highcharts.chart('lineChartMainContainer', {
                            chart: {
                                type: 'spline',
                                scrollablePlotArea: {
                                    minWidth: 600,
                                    scrollPositionX: 1
                                }
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: 'HEALTH',
                                align: 'left'
                            },
                            subtitle: {
                                text: ''
                            },
                            xAxis: {
                                type: 'datetime',
                                labels: {
                                    formatter: function () {
                                        return moment(this.value).format("MM/DD HH:mm");
                                    },
                                    overflow: 'justify',
                                    rotation: -45
                                }
                            },
                            yAxis: {
                                title: {
                                    text: ''
                                },
                                min: 100,
                                max: 599,
                                tickInterval: 100,
                                minorGridLineWidth: 0,
                                gridLineWidth: 0,
                                alternateGridColor: null,
                                plotBands: [{ // Light air
                                    from: 100,
                                    to: 199,
                                    color: 'rgba(68, 170, 213, 0.1)',
                                    label: {
                                        text: 'Informational',
                                        style: {
                                            color: '#606060'
                                        }
                                    }
                                }, { // Light breeze
                                    from: 200,
                                    to: 299,
                                    color: 'rgba(0, 0, 0, 0)',
                                    label: {
                                        text: 'Healthy',
                                        style: {
                                            color: '#606060'
                                        }
                                    }
                                }, { // Gentle breeze
                                    from: 300,
                                    to: 399,
                                    color: 'rgba(68, 170, 213, 0.1)',
                                    label: {
                                        text: 'Warning',
                                        style: {
                                            color: '#606060'
                                        }
                                    }
                                }, { // Moderate breeze
                                    from: 400,
                                    to: 499,
                                    color: 'rgba(0, 0, 0, 0)',
                                    label: {
                                        text: 'Severe',
                                        style: {
                                            color: '#606060'
                                        }
                                    }
                                }, { // Fresh breeze
                                    from: 500,
                                    to: 599,
                                    color: 'rgba(68, 170, 213, 0.1)',
                                    label: {
                                        text: 'Critical',
                                        style: {
                                            color: '#606060'
                                        }
                                    }
                                }]
                            },
                            tooltip: {
                                formatter: function () {
                                    //return '<div><label>'+ moment(this.x).format("MM/DD HH:mm") +'</label><br /><label>'+ this.series.name +':'+ this.y +'</label></div>'
                                    var tooltip = moment(this.x).format("dddd, DD, MMM HH:mm:ss");
                                    tooltip += '<br><span style="color:' + this.series.color + '">' + this.series.name + '</span>: ';
                                    tooltip += this.y;
                                    return tooltip;
                                }
                            },
                            plotOptions: {
                                spline: {
                                    lineWidth: 4,
                                    states: {
                                        hover: {
                                            lineWidth: 5
                                        }
                                    },
                                    marker: {
                                        enabled: false
                                    }
                                    /* pointInterval: 1000, // one second
                                     pointStart: 1563361200000*/
                                },
                                series: {
                                    events: {
                                        legendItemClick: function () {
                                            return false;
                                        }
                                    }
                                }
                            },
                            series: $scope.chartData,
                            navigation: {
                                buttonOptions: {
                                    height: 25,
                                    width: 25,
                                    symbolSize: 12,
                                    symbolX: 13,
                                    symbolY: 13,
                                    symbolStrokeWidth: 2,
                                    theme: {
                                        'stroke-width': 1,
                                        stroke: 'silver',
                                        r: 50
                                    }
                                }
                            },
                            exporting: {
                                filename: filename,
                                csv: {
                                    columnHeaderFormatter: function (item, key) {
                                        if (key === 'Category' || angular.isUndefined(key)) {
                                            return 'Timestamp';
                                        } else if (key === 'y') {
                                            return $scope.type === 'health' ? 'Health' : 'Connection';
                                        }
                                    },
                                    dateFormat: '%Y-%m-%d %H:%M:%S'
                                },
                                buttons: {
                                    contextButton: {
                                        menuItems: ['printChart', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG', 'downloadCSV', 'downloadXLS']
                                    }
                                },
                                menuItemDefinitions: {
                                    printChart: {
                                        onclick: function() {
                                            var divToPrint = document.getElementById('lineChartMainContainer');
                                            var newWin = window.open(); //eslint-disable-line
                                            newWin.document.write(divToPrint.innerHTML);
                                            newWin.document.close();
                                            newWin.focus();
                                            newWin.print();
                                            newWin.close();
                                        }
                                    }
                                }
                            }
                        });
                    })
                };
                $scope.fnDrawChart();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('attributeValueLineChart', fnAttributeValueLineChart);

    /** @ngInject */
    function fnAttributeValueLineChart(Highcharts, moment) {
        return {
            restrict: 'EA',
            scope: {
                chartData: '=',
                valueArr: '=',
                nodeId: '=',
                type: '=',
                filterObj: '='
            },
            templateUrl: "app/components/directives/attributeValueLineChart/attributeValueLineChart.html",
            link: function ($scope) {
                var filename, start, end;
                if ($scope.filterObj.type === 'relative') {
                    start = moment().subtract(parseInt($scope.filterObj.name), $scope.filterObj.units).toISOString();
                    end = moment().toISOString()
                } else {
                    start = moment($scope.filterObj.start).toISOString();
                    end = moment($scope.filterObj.stop).toISOString();
                }
                filename = $scope.nodeId + '_' + $scope.type + '_' + start + '_' + end;

                $scope.getLabelName = function(value) {
                    return $scope.valueArr[value];
                };

                Highcharts.chart('attributeValueChartMainContainer', {
                    chart: {
                        type: 'spline',
                        scrollablePlotArea: {
                            minWidth: 600,
                            scrollPositionX: 1
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: 'VALUE',
                        align:'left'
                    },
                    subtitle: {
                        text: ''
                    },
                    xAxis: {
                        type: 'datetime',
                        labels: {
                            formatter: function () {
                                return moment(this.value).format("MM/DD HH:mm");
                            },
                            overflow: 'justify',
                            rotation: -30
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Value'
                        },
                        labels: {
                            formatter: function () {
                                return $scope.getLabelName(this.value)
                            }
                        }
                    },
                    tooltip: {
                        formatter: function() {
                            //return '<div><label>'+ moment(this.x).format("MM/DD HH:mm") +'</label><br /><label>'+ this.series.name +':'+ this.y +'</label></div>'
                            var tooltip = moment(this.x).format("dddd, DD, MMM HH:mm");
                            tooltip += '<br><span style="color:' + this.series.color + '">' + this.series.name + '</span>: ';
                            tooltip += $scope.getLabelName(this.y);
                            return tooltip;
                        }
                    },
                    series: $scope.chartData,
                    navigation: {
                        buttonOptions: {
                            height: 25,
                            width: 25,
                            symbolSize: 12,
                            symbolX: 13,
                            symbolY: 13,
                            symbolStrokeWidth: 2,
                            theme: {
                                'stroke-width': 1,
                                stroke: 'silver',
                                r: 50
                            }
                        }
                    },
                    exporting: {
                        filename: filename,
                        csv:{
                            columnHeaderFormatter:function(item, key){
                                if(key === 'Category' || angular.isUndefined(key)){
                                    return 'Timestamp';
                                } else if (key === 'y') {
                                    return $scope.type;
                                }
                            },
                            dateFormat: '%Y-%m-%d %H:%M:%S'
                        },
                        buttons: {
                            contextButton: {//'viewFullscreen','viewData'
                                menuItems: ['printChart','downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG','downloadCSV','downloadXLS']
                            }
                        },
                        menuItemDefinitions: {
                            printChart: {
                                onclick: function() {
                                    var divToPrint = document.getElementById('attributeValueChartMainContainer');
                                    var newWin = window.open(); //eslint-disable-line
                                    newWin.document.write(divToPrint.innerHTML);
                                    newWin.document.close();
                                    newWin.focus();
                                    newWin.print();
                                    newWin.close();
                                }
                            }
                        }
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('advanceSearchDirective', fnAdvanceSearchDirective);

    /** @ngInject */
    function fnAdvanceSearchDirective($uibModal, $timeout, AdvanceSearchTablesService, UserProfileService, sqlFormatter, QueryFactory) {
        return {
            restrict: 'EA',
            scope: {
                appName: "=",
                appKey: "=",
                serviceKey: "="
            },
            templateUrl: "app/components/directives/advanceSearchDirective/advanceSearch.html",
            link: function ($scope) {
                $scope.advanceSearchData = [];
                $scope.advanceSearchDataHeader = [];
                $scope.availableDataLibs = ['ql_S4'];
                $scope.advanceSearchQueryConfig = {
                    value: {},
                    editorValue: ''
                };
                $scope.isAdvanceSearchDataLoading = false;
                $scope.isDataLibsLoading = true;

                $scope.fnOpenTablesModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/accountStatusModal/accountStatusModal.html',
                        size: 'lg',
                        controller: 'accountStatusCtrl as accountStat',
                        resolve: {
                            isCalledForFirstPaymentMethod: function () {
                                return false;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                $scope.fnGetType = function (data) {
                    return typeof data;
                };

                $scope.fnRunAdvanceSearchQuery = function () {
                    if ($scope.advanceSearchQueryConfig.value.getData().length) {
                        UserProfileService.fnUpdateUserProfileObj($scope.appKey, $scope.serviceKey, 'advanceSearchSQL', _.cloneDeepWith($scope.advanceSearchQueryConfig.value.getData()));
                        $scope.isAdvanceSearchDataLoading = true;
                        $scope.advanceSearchData = [];
                        var input = {
                            "sql": $scope.advanceSearchQueryConfig.value.getData()
                        };
                        QueryFactory.executeQuery(input).then(function (res) {
                            $scope.advanceSearchData = res.data;
                            $scope.advanceSearchDataHeader = [];
                            _.forEach($scope.advanceSearchData, function (dataObj) {
                                _.forEach(Object.keys(dataObj), function (value) {
                                    $scope.advanceSearchDataHeader.push(value);
                                });
                            });
                            $scope.advanceSearchDataHeader = _.uniq(_.map($scope.advanceSearchDataHeader)).sort();
                            $scope.isAdvanceSearchDataLoading = false;
                        }, function () { // Error block
                            $scope.isAdvanceSearchDataLoading = false;
                        });
                    }
                };

                $scope.fnInitAdvanceSearchEditor = function () {
                    var advanceSearchSQL = UserProfileService.fnGetUserProfileObj($scope.appKey, $scope.serviceKey, 'advanceSearchSQL');
                    $scope.isDataLibsLoading = true;
                    var additionalDefFiles = AdvanceSearchTablesService.getDefsFileName();
                    $scope.availableDataLibs.push.apply($scope.availableDataLibs, additionalDefFiles);
                    $timeout(function () {
                        $scope.isDataLibsLoading = false;
                        if (advanceSearchSQL !== '' || advanceSearchSQL.length) {
                            $scope.advanceSearchQueryConfig = {
                                value: {},
                                editorValue: advanceSearchSQL
                            };
                            $timeout(function () {
                                $scope.fnRunAdvanceSearchQuery();
                            }, 1000);
                        }
                    })
                };

                $scope.fnFormatSQL = function () {
                    var sql = $scope.advanceSearchQueryConfig.value.getData();
                    $scope.advanceSearchQueryConfig.editorValue = sqlFormatter.format(sql).toString();
                }

                $scope.fnInitAdvanceSearchEditor();
            }
        }
    }
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TypesFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listIssueTypes: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'type', 'listIssueTypes', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssueType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'type', 'createIssueType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIssueType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId  === null || angular.isUndefined(input.typeId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId
                };

                APIFactory.API(appName, 'type', 'describeIssueType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIssueType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId
                };

                APIFactory.API(appName, 'type', 'deleteIssueType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIssueType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'type', 'updateIssueType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIssueTypeForm: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'type', 'updateIssueTypeForm', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssueTypeTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId  === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId ,
                    "body": input.body
                };

                APIFactory.API(appName, 'type', 'replaceIssueTypeTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TrackerScriptFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listScriptTypes: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {};

                APIFactory.API(appName, 'script', 'listScriptTypes', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };
                APIFactory.API(appName, 'script', 'describeScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'script', 'updateScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'describeProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type,
                    "body": input.body,
                    "cascade": input.cascade,
                    "exclude": input.exclude
                };

                APIFactory.API(appName, 'script', 'updateProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listProjectScriptTypes: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'script', 'listProjectScriptTypes', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TrackerEmailTemplateFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            describeEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'describeEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'resetEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type,
                    "body": input.body,
                    "cascade": input.cascade,
                    "exclude": input.exclude
                };

                APIFactory.API(appName, 'email-template', 'updateEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listEmailTemplateTypes: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'email-template', 'listEmailTemplateTypes', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TrackerStateFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listIssueStates: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'state', 'listIssueStates', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssueState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'state', 'createIssueState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIssueState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.stateId === null || angular.isUndefined(input.stateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'stateId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "stateId": input.stateId
                };

                APIFactory.API(appName, 'state', 'describeIssueState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIssueState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.stateId === null || angular.isUndefined(input.stateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'stateId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "stateId": input.stateId
                };

                APIFactory.API(appName, 'state', 'deleteIssueState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIssueState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.stateId  === null || angular.isUndefined(input.stateId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'stateId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "stateId" : input.stateId ,
                    "body": input.body
                };

                APIFactory.API(appName, 'state', 'updateIssueState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssueStateTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.stateId === null || angular.isUndefined(input.stateId)) {
                    _deffered.reject({
                        errorMessage: "The property 'stateId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "stateId": input.stateId
                };
                APIFactory.API(appName, 'state', 'replaceIssueStateTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ProjectFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listProjects: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'project', 'listProjects', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'createProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'deleteProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'updateProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceProjectTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "projectId": input.projectId
                };
                APIFactory.API(appName, 'project', 'replaceProjectTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listProjectTeams: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'listProjectTeams', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectRelationships: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProjectRelationships', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listPossibleProjectAssignees: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'listPossibleProjectAssignees', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('PriorityFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listIssuePriorities: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'priority', 'listIssuePriorities', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssuePriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'priority', 'createIssuePriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIssuePriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.priorityId  === null || angular.isUndefined(input.priorityId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'priority id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "priorityId": input.priorityId
                };

                APIFactory.API(appName, 'priority', 'describeIssuePriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIssuePriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.priorityId === null || angular.isUndefined(input.priorityId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'label id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "priorityId": input.priorityId
                };

                APIFactory.API(appName, 'priority', 'deleteIssuePriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIssuePriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.priorityId === null || angular.isUndefined(input.priorityId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'priority id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "priorityId": input.priorityId,
                    "body": input.body
                };

                APIFactory.API(appName, 'priority', 'updateIssuePriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssuePriorityTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.priorityId  === null || angular.isUndefined(input.priorityId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'priority id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "priorityId": input.priorityId ,
                    "body": input.body
                };

                APIFactory.API(appName, 'priority', 'replaceIssuePriorityTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('LabelFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listIssueLabels: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'label', 'listIssueLabels', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssueLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'label', 'createIssueLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIssueLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.labelId === null || angular.isUndefined(input.labelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'labelId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "labelId": input.labelId
                };

                APIFactory.API(appName, 'label', 'describeIssueLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIssueLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.labelId === null || angular.isUndefined(input.labelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'labelId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "labelId": input.labelId
                };

                APIFactory.API(appName, 'label', 'deleteIssueLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIssueLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.labelId  === null || angular.isUndefined(input.labelId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'labelId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "labelId" : input.labelId ,
                    "body": input.body
                };

                APIFactory.API(appName, 'label', 'updateIssueLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssueLabelTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.labelId === null || angular.isUndefined(input.labelId)) {
                    _deffered.reject({
                        errorMessage: "The property 'labelId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "labelId": input.labelId
                };
                APIFactory.API(appName, 'label', 'replaceIssueLabelTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('IssueFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            modifyType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'typeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "typeId": input.typeId
                };

                APIFactory.API(appName, 'issue', 'modifyType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listIssues: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'issue', 'listIssues', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listArchivedIssues: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'issue', 'listArchivedIssues', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'describeIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'deleteIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeArchivedIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'describeArchivedIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteArchivedIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'deleteArchivedIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'createIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addAssignee: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.assigneeId === null || angular.isUndefined(input.assigneeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'assigneeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "assigneeId": input.assigneeId
                };

                APIFactory.API(appName, 'issue', 'addAssignee', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeAssignee: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.assigneeId === null || angular.isUndefined(input.assigneeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'assigneeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "assigneeId": input.assigneeId
                };

                APIFactory.API(appName, 'issue', 'removeAssignee', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addParticipant: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.participant === null || angular.isUndefined(input.participant)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'participant' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "participant": input.participant
                };

                APIFactory.API(appName, 'issue', 'addParticipant', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeParticipant: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.participant === null || angular.isUndefined(input.participant)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'participant' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "participant": input.participant
                };

                APIFactory.API(appName, 'issue', 'removeParticipant', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyName: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'modifyName', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifySummary: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'modifySummary', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifySyntax: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'modifySyntax', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyPriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.priorityId === null || angular.isUndefined(input.priorityId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'priorityId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "priorityId": input.priorityId
                };

                APIFactory.API(appName, 'issue', 'modifyPriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.stateId === null || angular.isUndefined(input.stateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'stateId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "stateId": input.stateId
                };

                APIFactory.API(appName, 'issue', 'modifyState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.labelId === null || angular.isUndefined(input.labelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'labelId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "labelId": input.labelId
                };

                APIFactory.API(appName, 'issue', 'addLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeLabel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.labelId === null || angular.isUndefined(input.labelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'labelId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "labelId": input.labelId
                };

                APIFactory.API(appName, 'issue', 'removeLabel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            upVoteIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'upVoteIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            downVoteIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'downVoteIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeIssuePublic: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'makeIssuePublic', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeIssuePrivate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'makeIssuePrivate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resolveIssueRequest: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'resolveIssueRequest', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resolveIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'resolveIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            reopenIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'reopenIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            archiveIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'archiveIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssueFormValues: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'replaceIssueFormValues', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            restoreIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'restoreIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceIssueTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'replaceIssueTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listIssueHistories: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'listIssueHistories', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            moveIssueProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'issue', 'moveIssueProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeIssueState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'removeState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeIssuePriority: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'removePriority', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeIssueType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'issue', 'removeType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getFileUploadLink: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'issue', 'getFileUploadLink', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createIssueFromNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "attributeId": input.attributeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'issue', 'createIssueFromNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addAttributeToIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'issue', 'addAttributeToIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeAttributeFromIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId,
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'issue', 'removeAttributeFromIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();


(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('CommentFactory', function ($q, $http, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            addComment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'comment', 'addComment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addSubComment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'commentId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'addSubComment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyCommentText: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'modifyCommentText', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyCommentSyntax: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'modifyCommentSyntax', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteComment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'deleteComment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            upVoteComment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'upVoteComment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            downVoteComment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'downVoteComment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeCommentPublic: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'makeCommentPublic', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeCommentPrivate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.commentId === null || angular.isUndefined(input.commentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'comment id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "commentId": input.commentId
                };

                APIFactory.API(appName, 'comment', 'makeCommentPrivate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ArchivedIssueFactory', function ($q, $cookies, APIFactory) {
        var appName = "tracker";
        return {
            listArchivedIssues: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'archived-issue', 'listArchivedIssues', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeArchivedIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'archived-issue', 'describeArchivedIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listArchivedIssueHistories: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "issueId": input.issueId
                };

                APIFactory.API(appName, 'archived-issue', 'listArchivedIssueHistories', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            restoreIssue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.issueId === null || angular.isUndefined(input.issueId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'issueId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {};

                if(angular.isDefined(input.projectId)){
                    queryBuilder = {
                        "issueId": input.issueId,
                        "projectId": input.projectId
                    };
                } else {
                    queryBuilder = {
                        "issueId": input.issueId
                    };
                }

                APIFactory.API(appName, 'archived-issue', 'restoreIssue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('infoModalCtrl',
            function ($uibModalInstance, DB) {
                var vm = this;
                var loginUser = DB.fnGet('loginUser');
                vm.accountId = loginUser.id.split("-")[0];
                var isShowFleetService = false;
                var isShowSoftwareService = false;
                var url = HOST_URL.node.split("https://")[1]; //eslint-disable-line
                var environment = url.startsWith('dev') ? 'dev' : 'prod';
                if (environment === 'dev') {
                    /*Fleet: For dev environment*/
                    //Tarka LHerpiniere, Bjoern Graf, Felipe Polanco, Deep Desai, Bhagyashree Bothra
                    if (vm.accountId === 'cu000000' && (loginUser.id === 'cu000000-au134b7d' || loginUser.id === 'cu000000-au7d7ee6' || loginUser.id === 'cu000000-au295f0e' || loginUser.id === 'cu000000-au429e91' || loginUser.id === 'cu000000-au9b3979')) {
                        isShowSoftwareService = true;
                    }
                    /*Software: For dev environment*/
                    //Tarka LHerpiniere, Bjoern Graf
                    if (vm.accountId === 'cu000000' && (loginUser.id === 'cu000000-au134b7d' || loginUser.id === 'cu000000-au7d7ee6')) {
                        isShowSoftwareService = true;
                    }
                } else {
                    /*Fleet: For prod environment*/
                    //Tarka LHerpiniere, Bjoern Graf, Felipe Polanco, Deep Desai, Bhagyashree Bothra
                    if (vm.accountId === 'cu000000' && (loginUser.id === 'cu000000-au134b7d' || loginUser.id === 'cu000000-auda7ab5' || loginUser.id === 'cu000000-au984683' || loginUser.id === 'cu000000-au62b128' || loginUser.id === 'cu000000-au5a2771')) {
                        isShowSoftwareService = true;
                    }
                    /*Software: For prod environment*/
                    //Tarka LHerpiniere, Bjoern Graf
                    if (vm.accountId === 'cu000000' && (loginUser.id === 'cu000000-au134b7d' || loginUser.id === 'cu000000-auda7ab5')) {
                        isShowSoftwareService = true;
                    }
                }

                vm.fnGetCheckPermission = function (type) {
                    var activeUser = '';
                    var isAccess = false;
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        var federationUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                        activeUser = federationUser.sessionObj.user;
                    } else {
                        activeUser = DB.fnGet("loginUser");
                    }
                    if (activeUser.accountOwner === true || activeUser.administrator === true) {
                        if (type === 'billingRole') {
                            if (activeUser.accountOwner === true) {
                                isAccess = true;
                            }
                        } else {
                            isAccess = true;
                        }
                    } else {
                        if (type === 'nodeRole') {
                            if (activeUser.nodeRole === 'MANAGER' || activeUser.nodeRole === 'SUPERVISOR' || activeUser.nodeRole === 'TEAM_MEMBER' || activeUser.nodeRole === 'CUSTOMER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'pipelineRole') {
                            if (activeUser.pipelineRole === 'MANAGER' || activeUser.pipelineRole === 'TEAM_MEMBER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'trackerRole') {
                            if (activeUser.trackerRole === 'MANAGER' || activeUser.trackerRole === 'TEAM_MEMBER' || activeUser.trackerRole === 'CUSTOMER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'storageRole') {
                            if (activeUser.storageRole === 'MANAGER' || activeUser.storageRole === 'TEAM_MEMBER' || activeUser.storageRole === 'CUSTOMER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'aiRole') {
                            if (activeUser.aiRole === 'MANAGER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'billingRole') {
                            if (activeUser.billingRole === 'MANAGER') {
                                isAccess = true;
                            }
                        }
                        if (type === 'insightRole') {
                            if (activeUser.insightRole === 'MANAGER' || activeUser.insightRole === 'TEAM_MEMBER' || activeUser.insightRole === 'CUSTOMER') {
                                isAccess = true;
                            }
                        }
                    }
                    return isAccess;
                };

                vm.PredictiveAppShortcutsArr = [
                    {
                        name: "Dashboard",
                        keys: ["q", "d"],
                        description: "Open Dashboard"
                    }, {
                        name: "Account",
                        keys: ["q", "a"],
                        description: "Open Account"
                    }
                ];
                vm.AccessAppShortcutsArr = [
                    {
                        name: "Dashboard",
                        keys: ["c", "d"],
                        description: "Open Dashboard"
                    }, {
                        name: "Users",
                        keys: ["c", "u"],
                        description: "Open Users"
                    }, {
                        name: "Teams",
                        keys: ["c", "t"],
                        description: "Open Teams"
                    }, {
                        name: "Vaults",
                        keys: ["c", "v"],
                        description: "Open Vaults"
                    }, {
                        name: "Authenticators",
                        keys: ["c", "a"],
                        description: "Open Authenticator"
                    }, {
                        name: "Federations",
                        keys: ["c", "f"],
                        description: "Open Federations"
                    }, {
                        name: "S4",
                        keys: ["c", "s"],
                        description: "Open S4"
                    }, {
                        name: "Email Templates",
                        keys: ["c", "m"],
                        description: "Open Email Templates"
                    }, {
                        name: "Whitelists",
                        keys: ["c", "e"],
                        description: "Open Whitelists"
                    }, {
                        name: "Audits",
                        keys: ["c", "i"],
                        description: "Open Audits"
                    }];
                /*vm.PipelineAppShortcutsArr = [
                    {
                        name: "Workflow",
                        keys: ["p", "w"],
                        description: "Open Workflows"
                    }, {
                        name: "Listener",
                        keys: ["p", "l"],
                        description: "Open Listeners"
                    }, {
                        name: "Template",
                        keys: ["p", "t"],
                        description: "Open Templates"
                    }, {
                        name: "Transformer",
                        keys: ["p", "r"],
                        description: "Open Transformers"
                    }
                ];*/
                vm.NodeAppShortcutsArr = [
                    {
                        name: "Dashboard",
                        keys: ["n", "d"],
                        description: "Open Dashboard",
                        isShow: true
                    }, {
                        name: "Alarms",
                        keys: ["n", "a"],
                        description: "Open Alarms",
                        isShow: true
                    }, {
                        name: "Alarm History",
                        keys: ["n", "z"],
                        description: "Open Alarm History",
                        isShow: true
                    }, {
                        name: "Nodes",
                        keys: ["n", "y"],
                        description: "Open Nodes",
                        isShow: true
                    }, {
                        name: "ECU",
                        keys: ["n", "x"],
                        description: "Open ECU",
                        isShow: true
                    }, {
                        name: "Jobs",
                        keys: ["n", "j"],
                        description: "Open Jobs",
                        isShow: true
                    }, {
                        name: "Fleet",
                        keys: ["n", "f"],
                        description: "Open Fleet",
                        isShow: isShowFleetService
                    }, {
                        name: "Software",
                        keys: ["n", "s"],
                        description: "Open Software",
                        isShow: isShowSoftwareService
                    }, {
                        name: "Project",
                        keys: ["n", "p"],
                        description: "Open Projects",
                        isShow: true
                    }, {
                        name: "Healths",
                        keys: ["n", "h"],
                        description: "Open Healths",
                        isShow: true
                    }, {
                        name: "S4",
                        keys: ["n", "s"],
                        description: "Open S4",
                        isShow: true
                    }, {
                        name: "ES4",
                        keys: ["n", "e"],
                        description: "Open ES4",
                        isShow: true
                    }, {
                        name: "Observers",
                        keys: ["n", "o"],
                        description: "Open Observers",
                        isShow: true
                    }, {
                        name: "Emails",
                        keys: ["n", "t"],
                        description: "Open Emails",
                        isShow: true
                    }
                ];
                vm.TrackerAppShortcutsArr = [
                    {
                        name: "Dashboard",
                        keys: ["t", "d"],
                        description: "Open Dashboard"
                    }, {
                        name: "Issues",
                        keys: ["t", "i"],
                        description: "Open Issues"
                    }, {
                        name: "Archives",
                        keys: ["t", "w"],
                        description: "Open Archives"
                    }, {
                        name: "Projects",
                        keys: ["t", "e"],
                        description: "Open Projects"
                    }, {
                        name: "Labels",
                        keys: ["t", "l"],
                        description: "Open Labels"
                    }, {
                        name: "Priorities",
                        keys: ["t", "r"],
                        description: "Open Priorities"
                    }, {
                        name: "States",
                        keys: ["t", "v"],
                        description: "Open States"
                    }, {
                        name: "Types",
                        keys: ["t", "y"],
                        description: "Open Types"
                    }, {
                        name: "S4",
                        keys: ["t", "s"],
                        description: "Open S4"
                    }
                ];
                vm.StorageAppShortcutsArr = [
                    {
                        name: "Drive",
                        keys: ["s", "f"],
                        description: "Open Drives"
                    }
                ];
                vm.InsightAppShortcutsArr = [
                    {
                        name: "Query Editor",
                        keys: ["i", "q"],
                        description: "Open Query Editor"
                    }, {
                        name: "Dashboards",
                        keys: ["i", "d"],
                        description: "Open Dashboards"
                    }, {
                        name: "Projects",
                        keys: ["i", "p"],
                        description: "Open Projects"
                    }, {
                        name: "Queries",
                        keys: ["i", "u"],
                        description: "Open Queries"
                    }, {
                        name: "Charts",
                        keys: ["i", "h"],
                        description: "Open Charts"
                    }, {
                        name: "Widgets",
                        keys: ["i", "w"],
                        description: "Open Widgets"
                    }
                ];
                /*vm.AIAppShortcutsArr = [
                    {
                        name: "Trainer",
                        keys: ["a", "t"],
                        description: "Open Trainer"
                    }, {
                        name: "Model",
                        keys: ["a", "m"],
                        description: "Open Models"
                    }, {
                        name: "Distribution",
                        keys: ["a", "i"],
                        description: "Open Distribution"
                    }, {
                        name: "Deployment",
                        keys: ["a", "e"],
                        description: "Open Deployment"
                    }
                ];*/
                vm.BillingAppShortcutsArr = [
                    {
                        name: "Products",
                        keys: ["b", "p"],
                        description: "Open Products",
                        isAccess: true
                    }, {
                        name: "Carts",
                        keys: ["b", "c"],
                        description: "Open Carts",
                        isAccess: true
                    }, {
                        name: "PaymentMethods",
                        keys: ["b", "m"],
                        description: "Open Payment Methods",
                        isAccess: true
                    }, {
                        name: "Invoices",
                        keys: ["b", "i"],
                        description: "Open Invoices",
                        isAccess: true
                    }, {
                        name: "Discounts",
                        keys: ["b", "d"],
                        description: "Open Discounts",
                        isAccess: !DB.fnGet('federation') && !DB.fnGet('support') && loginUser.administrator === true && loginUser.id === 'cu000000'
                    }, {
                        name: "CreditTokens",
                        keys: ["b", "t"],
                        description: "Open Credit Tokens",
                        isAccess: true
                    }, {
                        name: "Plans",
                        keys: ["b", "l"],
                        description: "Open Plans",
                        isAccess: true
                    }, {
                        name: "S4",
                        keys: ["b", "s"],
                        description: "Open S4",
                        isAccess: true
                    }
                ];
                vm.ProfileShortcutsArr = [
                    {
                        name: "Profile",
                        keys: ["y", "h"],
                        description: "Open Profile",
                        isAccess: true
                    }, {
                        name: "Preference",
                        keys: ["y", "p"],
                        description: "Open Preference",
                        isAccess: true
                    }, {
                        name: "Business",
                        keys: ["y", "b"],
                        description: "Open Business",
                        isAccess: vm.fnGetCheckPermission('billingRole')
                    }, {
                        name: "Support",
                        keys: ["y", "s"],
                        description: "Open Support",
                        isAccess: !DB.fnGet('federation') && !DB.fnGet('support') && loginUser.administrator === true && vm.accountId !== 'cu000000'
                    }
                ];
                vm.CRUDShortcutsArr = [
                    {
                        name: "New",
                        keys: ["up", "n"],
                        description: "New"
                    }/*, {
                        name: "New from blueprint",
                        keys: ["up", "b"],
                        description: "New from blueprint"
                    }*/, {
                        name: "Edit",
                        keys: ["up", "e"],
                        description: "Edit"
                    },
                    {
                        name: "Delete",
                        keys: ["up", "d"],
                        description: "Delete"
                    }
                ];
                vm.ExceptionalCustomShortcutsArr = [
                    {
                        keys: ["h"],
                        description: "Open shortcut help (double tap) (open modal with all available shortcuts)"
                    }, {
                        keys: ["/"],
                        description: "Go back to home page (double tap)"
                    }, {
                        keys: ["Shift"],
                        description: "Open documentation (double tap) (open in new tab)"
                    }, {
                        keys: ["l"],
                        description: "Lock screen (press and hold)"
                    }, {
                        keys: ["x"],
                        description: "Sign out (press and hold)"
                    }
                ];
                vm.selectedTab = 1;

                vm.tabs = [
                    {
                        title: 'ECSMon',
                        tabIndex: 1,
                        visible: !DB.fnGet('support') && !DB.fnGet('federation') && !DB.fnGet('support') && loginUser.administrator === true && vm.accountId === 'cu000000'
                    },
                    {
                        title: 'Node',
                        tabIndex: 2,
                        visible: vm.fnGetCheckPermission('nodeRole')
                    },
                    {
                        title: 'Tracker',
                        tabIndex: 3,
                        visible: vm.fnGetCheckPermission('trackerRole')
                    },
                    /*{
                        title: 'Automator',
                        tabIndex: 4,
                        visible: false
                    },
                    {
                        title: 'AI',
                        tabIndex: 5,
                        visible: false
                    },*/
                    {
                        title: 'Insight',
                        tabIndex: 6,
                        visible: vm.fnGetCheckPermission('insightRole')
                    },
                    {
                        title: 'Storage',
                        tabIndex: 7,
                        visible: false
                    },
                    {
                        title: 'Access',
                        tabIndex: 8,
                        visible: vm.fnGetCheckPermission('administrator')
                    },
                    {
                        title: 'Billing',
                        tabIndex: 9,
                        visible: vm.fnGetCheckPermission('billingRole')
                    },
                    {
                        title: 'Your Account',
                        tabIndex: 10,
                        visible: true
                    },
                    {
                        title: 'System',
                        tabIndex: 11,
                        visible: true
                    }
                ];

                vm.fnCancel = function () {
                    var element = document.getElementsByClassName("dropdown-menu");
                    for (var i = 0; i < element.length; i++) {
                        element[i].classList.remove("z-index-1500");
                    }
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnInitModel = function () {
                    var element = document.getElementsByClassName("dropdown-menu");
                    for (var i = 0; i < element.length; i++) {
                        element[i].classList.add("z-index-1500");
                    }
                    var findVal = _.find(vm.tabs, {'visible': true});
                    vm.selectedTab = findVal.tabIndex;
                };
            });
})
();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('feedbackSupportModalCtrl',
            function ($scope, $uibModalInstance, $rootScope, $http, amaran, DB, SupportFactory, PermissionsService, AppInitService, QueryFactory, IssueFactory) {
                var vm = this;
                var loginUser = {};
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    loginUser = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.user : DB.fnGet('support').sessionObj.user;
                } else {
                    loginUser = DB.fnGet('loginUser');
                }
                vm.feedbackObj = {
                    subject: "",
                    summary: "",
                    firstName: loginUser.firstName,
                    lastName: loginUser.lastName,
                    email: loginUser.email,
                    businessPhone: "",
                    companyName: "",
                    termsAgreed: true
                };
                vm.selectedProject = {};
                vm.isFeedbackCreating = false;
                vm.fileUploading = false;
                vm.supportId = "";

                vm.fnHideShowEditorPreview = function (id) {
                    if ($rootScope.markdownEditorObjects[id].$isPreview) {
                        $rootScope.markdownEditorObjects[id].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[id].showPreview();
                    }
                };

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        if (type === 'image') {
                            vm.feedbackObj.summary = vm.feedbackObj.summary + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                        } else {
                            vm.feedbackObj.summary = vm.feedbackObj.summary + " [" + filedata.name + "](" + res.downloadUrl + ")";
                        }
                        vm.fileUploading = false;
                    });
                };

                vm.uploadFiles = function (type, filedata) {
                    if (vm.permissionObj.GET_FILE_UPLOAD_LINK) {
                        vm.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.isProjectSelected = function () {
                    return !!Object.keys(vm.selectedProject).length;
                };

                vm.fnCreateFeedback = function () {
                    vm.isFeedbackCreating = true;
                    SupportFactory.createInternalSupportTicket({body: vm.feedbackObj})
                        .then(function (res) {
                            vm.supportId = _.cloneDeepWith(res.id);
                            vm.isFeedbackCreating = false;
                            amaran.success("Feedback & Support created successfully");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFeedbackCreating = false;
                        })
                }

                vm.fnInitModal = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.selectedProject = {};
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('projectsArr');
                        var project = _.find(vm.projectsArr, function (project) {
                            return angular.isUndefined(project.parentProjectId);
                        });
                        vm.selectedProject = _.cloneDeepWith(project);
                    } else {
                        var rootProjectSQL = {"sql": "select * from tracker_projects where data->>\'parentProjectId\' IS NULL"};
                        QueryFactory.executeQuery(rootProjectSQL)
                            .then(function (res) {
                                if (res && res.data && res.data.length) {
                                    vm.selectedProject = _.cloneDeepWith(res.data[0]);
                                }
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            })
                    }
                };
            });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('FolderFactory', function ($q, $cookies, APIFactory) {
        var appName = "storage";
        return {
            getContents: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "fields": input.fields,
                    "filter": input.filter,
                    "function": input.function,
                    "path": input.path,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'folder', 'get_contents', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createFolder: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'folder', 'create_folder', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyFolder: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'folder', 'modify_folder', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteFolder: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.path === null || angular.isUndefined(input.path)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'path' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "path": input.path,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'folder', 'delete_folder', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('FileFactory', function ($q, $cookies, APIFactory) {
        var appName = "storage";
        return {
            getContents: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "fields": input.fields,
                    "filter": input.filter,
                    "function": input.function,
                    "path": input.path,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'file', 'get_contents', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createFile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'file', 'create_file', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getFile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.path === null || angular.isUndefined(input.path)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'path' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "path": input.path,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'file', 'get_file', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyFile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'file', 'modify_file', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteFile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.path === null || angular.isUndefined(input.path)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'path' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "path": input.path,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'file', 'delete_file', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('WorkflowFactory', function ($q, $cookies, APIFactory) {
        var appName = "pipeline";
        return {
            getWorkflows: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'workflow', 'get_workflows', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'create_workflow', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workflowId": input.workflowId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'get_workflow', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workflowId": input.workflowId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'delete_workflow', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workflowId": input.workflowId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'modify_workflow', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "name": input.name,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'validate_workflow', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getWorkflowBluePrints: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var queryBuilder = {
                    "fields": input.fields,
                    "page": input.page,
                    "perPage": input.perPage,
                    "sort": input.sort,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'get_workflow_blueprints', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getWorkflowBluePrint: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workflowId": input.workflowId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'workflow', 'get_workflow_blueprint', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TransformerFactory', function ($q, $cookies, APIFactory) {
        var appName = "pipeline";
        return {
            getTransformers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'transformer', 'get_transformers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createTransformer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'create_transformer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTransformer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.transformerId === null || angular.isUndefined(input.transformerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'transformer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "transformerId": input.transformerId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'get_transformer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteTransformer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.transformerId === null || angular.isUndefined(input.transformerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'transformer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "transformerId": input.transformerId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'delete_transformer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyTransformer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.transformerId === null || angular.isUndefined(input.transformerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'transformer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "transformerId": input.transformerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'modify_transformer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateTransformer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "name": input.name,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'validate_transformer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTransformerBluePrints: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var queryBuilder = {
                    "fields": input.fields,
                    "page": input.page,
                    "perPage": input.perPage,
                    "sort": input.sort,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'get_transformer_blueprints', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTransformerBluePrint: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.transformerId === null || angular.isUndefined(input.transformerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'transformer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "transformerId": input.transformerId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transformer', 'get_transformer_blueprint', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TemplateFactory', function ($q, $cookies, APIFactory) {
        var appName = "pipeline";
        return {
            getTemplates: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'template', 'get_templates', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'create_template', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.templateId === null || angular.isUndefined(input.templateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'template Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "templateId": input.templateId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'get_template', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.templateId === null || angular.isUndefined(input.templateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'template Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "templateId": input.templateId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'delete_template', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.templateId === null || angular.isUndefined(input.templateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'template Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "templateId": input.templateId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'modify_template', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "name": input.name,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'validate_template', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTemplateBluePrints: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var queryBuilder = {
                    "fields": input.fields,
                    "page": input.page,
                    "perPage": input.perPage,
                    "sort": input.sort,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'get_template_blueprints', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTemplateBluePrint: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.templateId === null || angular.isUndefined(input.templateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'template Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "templateId": input.templateId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'template', 'get_template_blueprint', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('StateFactory', function ($q, $cookies, APIFactory) {
        var appName = "pipeline";
        return {
            getStates: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'state', 'get_states', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.stateId === null || angular.isUndefined(input.stateId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'state Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "stateId": input.stateId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'state', 'get_state', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ListenerFactory', function ($q, $cookies, $http, APIFactory) {
        var appName = "pipeline";
        return {
            getListeners: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'listener', 'get_listeners', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'create_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'get_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'delete_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'modify_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createListenerStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'create_listener_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyListenerStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.statementId === null || angular.isUndefined(input.statementId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'statement Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "statementId": input.statementId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'modify_listener_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteListenerStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.statementId === null || angular.isUndefined(input.statementId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'statement Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "statementId": input.statementId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'delete_listener_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getListenerWorkflow: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "fields": input.fields,
                    "page": input.page,
                    "perPage": input.perPage,
                    "sort": input.sort,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'get_listener_workflows', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addWorkFlowToListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "workflowId": input.workflowId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'add_workflow_to_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeWorkflowFromListener: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.listenerId === null || angular.isUndefined(input.listenerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'listener Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.workflowId === null || angular.isUndefined(input.workflowId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workflow Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "listenerId": input.listenerId,
                    "workflowId": input.workflowId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'listener', 'remove_workflow_from_listener', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getListenerModels: function (input) {
                var _deffered = $q.defer();
                var config = {};
                config.baseUri = APIFactory.BASEURL(appName);
                config.headers = {};
                config.headers.accept = 'application/json';
                config.headers['content-type'] = 'application/json; charset=utf-8';
                config.headers.authorization = 'Bearer ' + $cookies.get('phoenix');
                $http({
                    method: 'GET',
                    url: config.baseUri + '/models/' + input.appName,
                    headers: config.headers
                }).success(function (data) {
                    _deffered.resolve(data);
                }, function (data) {
                    _deffered.reject(data);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('WebSocketFactory', function ($q, $cookies, APIFactory, $http) {
        var appName = "node";
        return {
            getWebsocketUrl: function (input) {
            var _deffered = $q.defer();
            var config = {};
            config.baseUri = APIFactory.BASEURL(appName);
            config.headers = {};
            config.headers.accept = 'application/json';
            config.headers['content-type'] = 'application/json; charset=utf-8';
            config.headers.authorization = 'Bearer ' + $cookies.get('phoenix');
            $http({
                method: 'POST',
                url: config.baseUri + '/websockets?topic=' + input.topicId,
                headers: config.headers
            }).success(function (data) {
                _deffered.resolve(data);
            }, function (data) {
                _deffered.reject(data);
            });
            return _deffered.promise;
        }
        }
    });
})();

//VisualizerFactory
(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('VisualizerFactory', function ($q, $cookies, $http, APIFactory) {
        var appName = "node";
        return {
            getVisualizers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'visualizer', 'get_visualizers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createVisualizer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'create_visualizer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getVisualizer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.visualizerId === null || angular.isUndefined(input.visualizerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'visualizer id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "visualizerId": input.visualizerId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'get_visualizer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteVisualizer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.visualizerId === null || angular.isUndefined(input.visualizerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'visualizer id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "visualizerId": input.visualizerId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'delete_visualizer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyVisualizer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.visualizerId === null || angular.isUndefined(input.visualizerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'visualizer id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "visualizerId": input.visualizerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'modify_visualizer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyVisualizerMetadata: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.visualizerId === null || angular.isUndefined(input.visualizerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'visualizer id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "visualizerId": input.visualizerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'modify_visualizer_metadata', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyVisualizerLayout: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.visualizerId === null || angular.isUndefined(input.visualizerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'visualizer id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "visualizerId": input.visualizerId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'modify_visualizer_layout', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            uploadFile: function (input, contentType) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.file === null || angular.isUndefined(input.file)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'file' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                /*eslint-disable*/
                var queryBuilder = {
                    "file": input.file,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                /*eslint-enable*/
                var baseUrl = APIFactory.BASEURL(appName);
                var uploadURL = baseUrl + "/files";

                var splitArr = input.fileName.split(".");
                splitArr.pop();
                var finalName = splitArr.join(".").replace(" ", "_");
                uploadURL = uploadURL + '?name=' + finalName;

                $http.post(uploadURL, input.file, {
                    transformRequest: angular.identity,
                    headers: {'Content-Type': contentType}
                })
                    .success(function (response) {
                        var urlArr = baseUrl.split('/');
                        urlArr.pop();
                        var appHostURL = urlArr.join('/');
                        response.basepath = appHostURL;
                        _deffered.resolve(response);
                    })
                    .error(function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            downloadFile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accept === null || angular.isUndefined(input.accept)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'accept' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.year === null || angular.isUndefined(input.year)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'year' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.month === null || angular.isUndefined(input.month)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'month' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.day === null || angular.isUndefined(input.day)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'day' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.id === null || angular.isUndefined(input.id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.file === null || angular.isUndefined(input.file)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'file' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accept": input.accept,
                    "year": input.year,
                    "month": input.month,
                    "day": input.day,
                    "id": input.id,
                    "file": input.file,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'visualizer', 'download_file', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TypeFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getTypes: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'type', 'get_types', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'type', 'get_type', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TunnelFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            describeTunnel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.jobId === null || angular.isUndefined(input.jobId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'JOB id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "jobId": input.jobId
                };

                APIFactory.API(appName, 'tunnel', 'describeProject_1', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('SoftwareFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            createNewECUSoftwareVersion: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'software', 'createNewECUSoftwareVersion', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeECUSoftware: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.softwareId === null || angular.isUndefined(input.softwareId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'software Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "softwareId": input.softwareId
                };

                APIFactory.API(appName, 'software', 'describeECUSoftware', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeECUSoftwareLatest: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.softwareId === null || angular.isUndefined(input.softwareId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'software Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "softwareId": input.softwareId
                };

                APIFactory.API(appName, 'software', 'makeECUSoftwareLatest', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            broadcastNewECUSoftware: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.softwareId === null || angular.isUndefined(input.softwareId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'software Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "softwareId": input.softwareId,
                    "body": input.body
                };

                APIFactory.API(appName, 'software', 'broadcastNewECUSoftware', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteECUSoftware: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.softwareId === null || angular.isUndefined(input.softwareId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'software Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "softwareId": input.softwareId
                };

                APIFactory.API(appName, 'software', 'deleteECUSoftware', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            activateNewECUSoftwareUploaded: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.softwareId === null || angular.isUndefined(input.softwareId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'software Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "softwareId": input.softwareId
                };

                APIFactory.API(appName, 'software', 'activateNewECUSoftwareUploaded', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ObserverFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            describeECUObserver: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecu Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };
                APIFactory.API(appName, 'observer', 'describeECUObserver', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetECUObserver: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecu Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'observer', 'resetECUObserver', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateECUObserver: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecu Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'observer', 'updateECUObserver', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NotificationFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getNotifications: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'notification', 'get_notifications', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createNotification: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'notification', 'create_notification', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getNotification: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.notificationId === null || angular.isUndefined(input.notificationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'notification id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "notificationId": input.notificationId ,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'notification', 'get_notification', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteNotification: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.notificationId === null || angular.isUndefined(input.notificationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'notification id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "notificationId": input.notificationId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'notification', 'delete_notification', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyNotification: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.notificationId === null || angular.isUndefined(input.notificationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'notification id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "notificationId": input.notificationId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'notification', 'modify_notification', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeScriptFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            listScriptTypes: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {};

                APIFactory.API(appName, 'script', 'listScriptTypes', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };
                APIFactory.API(appName, 'script', 'describeScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'script', 'updateScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'describeProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProjectScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type,
                    "body": input.body,
                    "cascade": input.cascade,
                    "exclude": input.exclude
                };

                APIFactory.API(appName, 'script', 'updateProjectScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listProjectScriptTypes: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'script', 'listProjectScriptTypes', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeProjectFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            listProjects: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'project', 'listProjects', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'createProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'deleteProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'updateProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceProjectTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "projectId": input.projectId
                };
                APIFactory.API(appName, 'project', 'replaceProjectTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listProjectTeams: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'listProjectTeams', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectRelationships: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProjectRelationships', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listPossibleProjectAssignees: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'listPossibleProjectAssignees', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeIoT3Factory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            createIoT3Reference: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'iot3', 'createIoT3Reference', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIoT3Reference: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.iot3Id === null || angular.isUndefined(input.iot3Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'iot3Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "iot3Id": input.iot3Id
                };

                APIFactory.API(appName, 'iot3', 'describeIoT3Reference', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIoT3Reference: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.iot3Id === null || angular.isUndefined(input.iot3Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'iot3Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "iot3Id": input.iot3Id
                };

                APIFactory.API(appName, 'iot3', 'deleteIoT3Reference', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            registerNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ECU id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'registerNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'describeNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'deleteNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceNodeTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'replaceNodeTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceNodeLocation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'replaceNodeLocation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceNodeGraph: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'replaceNodeGraph', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateNodeNote: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'updateNodeNote', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateNodeName: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'updateNodeName', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deployNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'deployNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'enableNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'disableNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            requestNodeTunnel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.timeout === null || angular.isUndefined(input.timeout)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'timeout' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "timeout": input.timeout,
                    "type": input.type
                };

                APIFactory.API(appName, 'node', 'requestNodeTunnel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceRegistration: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'node', 'replaceRegistration', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            discoverNode: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.nodeId === null || angular.isUndefined(input.nodeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'node id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "nodeId": input.nodeId
                };

                APIFactory.API(appName, 'node', 'discoverNode', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeEmailTemplateFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            describeEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'describeEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'resetEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'email-template', 'updateEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listEmailTemplateTypes: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'email-template', 'listEmailTemplateTypes', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'describeProjectEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetProjectEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'resetProjectEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProjectEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "type": input.type,
                    "body": input.body,
                    "cascade": input.cascade,
                    "exclude": input.exclude
                };

                APIFactory.API(appName, 'email-template', 'updateProjectEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listProjectEmailTemplateTypes: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'email-template', 'listProjectEmailTemplateTypes', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeEcuFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            lockAccountToEcu: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'accountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.serialId === null || angular.isUndefined(input.serialId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'serialId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId,
                    "serialId": input.serialId
                };

                APIFactory.API(appName, 'ecu', 'lockSerialToAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            bindEcuToUnit: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.serialId === null || angular.isUndefined(input.serialId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'serialId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "serialId": input.serialId
                };

                APIFactory.API(appName, 'ecu', 'bindSerialToECU', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEcuProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'ecu', 'updateECUProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEcuName: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'updateECUName', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEcuDescription: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'updateECUDescription', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEcuLocation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'replaceECULocation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEcuTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'replaceECUTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableEcuVpn: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'enableECUVPN', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableEcuVpn: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'disableECUVPN', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableEcuNtp: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'enableECUNTP', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableEcuNtp: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'disableECUNTP', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deployEcu: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'deployECU', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            rebootEcu: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'rebootECU', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deregisterEcu: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'deregisterECU', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            ecuNetworkScan: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'networkScanRequest', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            ecuTunnelRequest: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.timeout === null || angular.isUndefined(input.timeout)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'timeout' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "timeout": input.timeout,
                    "type": input.type
                };

                APIFactory.API(appName, 'ecu', 'requestECUTunnel', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeECU: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId
                };

                APIFactory.API(appName, 'ecu', 'describeECU', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            requestECUBashCommand: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecuId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'ecu', 'requestECUBashCommand', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeBashCommand: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.jobId === null || angular.isUndefined(input.jobId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'jobId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "jobId": input.jobId
                };

                APIFactory.API(appName, 'ecu', 'describeBashCommand', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeES4Factory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            createES4: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.ecuId === null || angular.isUndefined(input.ecuId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'ecu Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "ecuId": input.ecuId,
                    "body": input.body
                };

                APIFactory.API(appName, 'es4', 'createES4', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateES4Name: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id,
                    "body": input.body
                };

                APIFactory.API(appName, 'es4', 'updateES4Name', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateES4Description: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id,
                    "body": input.body
                };

                APIFactory.API(appName, 'es4', 'updateES4Description', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateES4Script: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id,
                    "body": input.body
                };

                APIFactory.API(appName, 'es4', 'updateES4Script', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeES4: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id
                };

                APIFactory.API(appName, 'es4', 'describeES4', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteES4: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id
                };

                APIFactory.API(appName, 'es4', 'deleteES4', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceES4Tags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id,
                    "body": input.body
                };

                APIFactory.API(appName, 'es4', 'replaceES4Tags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deployES4: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.es4Id === null || angular.isUndefined(input.es4Id)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'es4 Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "es4Id": input.es4Id
                };

                APIFactory.API(appName, 'es4', 'deployES4', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('NodeAttributesFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            describeAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'attribute', 'describeAttribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateAttributeName: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'attribute', 'updateAttributeName', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateAttributeValue: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId,
                    "body": input.body
                };

                APIFactory.API(appName, 'attribute', 'updateAttributeValue', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'attribute', 'enableAttribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'attribute', 'disableAttribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deployAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'attribute', 'deployAttribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            writeAttributeValues: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.attributeId === null || angular.isUndefined(input.attributeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "attributeId": input.attributeId
                };

                APIFactory.API(appName, 'attribute', 'writeAttributeValues', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('LifecycleFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getLifecycles: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'lifecycle', 'get_lifecycles', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getLifecycle: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.lifecycleId === null || angular.isUndefined(input.lifecycleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'lifecycle id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "lifecycleId": input.lifecycleId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'lifecycle', 'get_lifecycle', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getLifecycleSteps: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.lifecycleId === null || angular.isUndefined(input.lifecycleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'lifecycle id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "lifecycleId": input.lifecycleId,
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'lifecycle', 'get_lifecycle_steps', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getLifecycleStep: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.lifecycleId === null || angular.isUndefined(input.lifecycleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'lifecycle id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.stepId === null || angular.isUndefined(input.stepId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'step id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "lifecycleId": input.lifecycleId,
                    "stepId": input.stepId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'lifecycle', 'get_lifecycle_step', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteLifecycle: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.lifecycleId === null || angular.isUndefined(input.lifecycleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'lifecycleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "lifecycleId": input.lifecycleId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'lifecycle', 'delete_lifecycle', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('Iot3WorkbenchFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            createIot3Workbench: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'workspace', 'createIoT3Workspace', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeIot3Worbench: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workspaceId === null || angular.isUndefined(input.workspaceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workspaceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workspaceId": input.workspaceId
                };

                APIFactory.API(appName, 'workspace', 'describeIoT3Workspace', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateIot3Worbench: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workspaceId === null || angular.isUndefined(input.workspaceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workspaceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workspaceId": input.workspaceId,
                    "body": input.body
                };

                APIFactory.API(appName, 'workspace', 'replaceIoT3Workspace', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteIot3Workbench: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.workspaceId === null || angular.isUndefined(input.workspaceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'workspaceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "workspaceId": input.workspaceId
                };

                APIFactory.API(appName, 'workspace', 'deleteIoT3Workspace', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            evaluateXpath: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'workspace', 'evaluateXPath', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            evaluateXslt: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'workspace', 'evaluateXSLT', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('HealthFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            createNodeHealth: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'health', 'createNodeHealth', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeNodeHealth: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.healthId === null || angular.isUndefined(input.healthId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'health id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "healthId": input.healthId
                };

                APIFactory.API(appName, 'health', 'describeNodeHealth', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteNodeHealth: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.healthId === null || angular.isUndefined(input.healthId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'health id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "healthId": input.healthId
                };

                APIFactory.API(appName, 'health', 'deleteNodeHealth', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateNodeHealth: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.healthId === null || angular.isUndefined(input.healthId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'health id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "healthId": input.healthId,
                    "body": input.body
                };

                APIFactory.API(appName, 'health', 'updateNodeHealth', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceNodeHealthTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.healthId === null || angular.isUndefined(input.healthId)) {
                    _deffered.reject({
                        errorMessage: "The property 'health id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "healthId": input.healthId
                };
                APIFactory.API(appName, 'health', 'replaceNodeHealthTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('DeviceFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getDevices: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'device', 'get_devices', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDevicesV4: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "size": input.size,
                    "start": input.start ? input.start : 0,
                    "q": input.q.length ? input.q : '',
                    "authorization": "Bearer " + $cookies.get('phoenix'),
                    "x-pre-api-version": "4"
                };
                if (angular.isDefined(input.sort) && input.sort.length) {
                    queryBuilder.sort = input.sort
                }
                APIFactory.API(appName, 'device', 'get_devices', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createDevice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'create_device', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createDeviceFromCSV: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix'),
                    "ContentType": "text/csv"
                };

                APIFactory.API(appName, 'device', 'create_device', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDevice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'get_device', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteDevice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'delete_device', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyDevice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'modify_device', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDeviceGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'get_device_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyDeviceGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'modify_device_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            cycleDeviceGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'cycle_device_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableDeviceAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'enable_device_attribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableDeviceAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.attributeName === null || angular.isUndefined(input.attributeName)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeName' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "attributeName": input.attributeName,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'disable_device_attribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateDeviceData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'device', 'update_device_data', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ComponentFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getDeviceInventories: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'component', 'get_device_inventory', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getComponents: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'component', 'get_components', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableComponent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'enable_component', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getComponent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'get_component', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableComponent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'disable_component', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyComponent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'modify_component', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getComponentGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'get_component_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyComponentGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'modify_component_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            cycleComponentGhost: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'cycle_component_ghost', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableComponentAttribute: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'enable_component_attribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableComponentAttribute:function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.componentId === null || angular.isUndefined(input.componentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'component id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.attributeName === null || angular.isUndefined(input.attributeName)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'attributeName' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "componentId": input.componentId,
                    "attributeName": input.attributeName,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'component', 'disable_component_attribute', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ClusterFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getClusters: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'cluster', 'get_clusters', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getClusterDevices: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "sort": input.sort,
                    "fields": input.fields,
                    "filter": input.filter,
                    "page": input.page,
                    "perPage": input.perPage,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'get_cluster_devices', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDeviceClusters: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deviceId": input.deviceId,
                    "sort": input.sort,
                    "fields": input.fields,
                    "filter": input.filter,
                    "page": input.page,
                    "perPage": input.perPage,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'get_device_clusters', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'create_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'get_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'delete_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'modify_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateClusterData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'update_cluster_data', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addDeviceToCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "deviceId": input.deviceId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'add_device_to_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeDeviceFromCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.deviceId === null || angular.isUndefined(input.deviceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'device id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "deviceId": input.deviceId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'remove_device_from_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getClusterGateways: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "sort": input.sort,
                    "fields": input.fields,
                    "filter": input.filter,
                    "page": input.page,
                    "perPage": input.perPage,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'get_cluster_gateways', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getGatewayClusters: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.gatewayId === null || angular.isUndefined(input.gatewayId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'gateway id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "gatewayId": input.gatewayId,
                    "sort": input.sort,
                    "fields": input.fields,
                    "filter": input.filter,
                    "page": input.page,
                    "perPage": input.perPage,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'get_gateway_clusters', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addGatewayToCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.gatewayId === null || angular.isUndefined(input.gatewayId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'gateway id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "gatewayId": input.gatewayId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'add_gateway_to_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeGatewayFromCluster: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.clusterId === null || angular.isUndefined(input.clusterId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'cluster id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.gatewayId === null || angular.isUndefined(input.gatewayId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'Gateway id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "clusterId": input.clusterId,
                    "gatewayId": input.gatewayId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'cluster', 'remove_gateway_from_cluster', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('AnalyticsFactory', function ($q, $cookies, APIFactory) {
        var appName = "node";
        return {
            getAnalyticsData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix'),
                    "x-pre-api-version": "4"
                };

                APIFactory.API(appName, 'analytic', 'analytic_query', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TransactionFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getTransactions: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'transaction', 'get_transactions', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTransaction: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.transactionId === null || angular.isUndefined(input.transactionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'transactionId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "transactionId": input.transactionId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'transaction', 'get_transaction', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('SummaryFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getSummaries: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'summary', 'get_summaries', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getSummary: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.summaryId === null || angular.isUndefined(input.summaryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'summaryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "summaryId": input.summaryId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'summary', 'get_summary', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ProfileFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getProfiles: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'profile', 'get_profiles', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createProfile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'profile', 'create_profile', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getProfile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.profileId === null || angular.isUndefined(input.profileId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'profileId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "profileId": input.profileId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'profile', 'get_profile', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteProfile: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.profileId === null || angular.isUndefined(input.profileId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'profileId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "profileId": input.profileId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'profile', 'delete_profile', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            makeProfilePrimary: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.profileId === null || angular.isUndefined(input.profileId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'profileId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "profileId": input.profileId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'profile', 'make_profile_primary', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ProductFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            listProducts: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'product', 'listProducts', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProduct: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.productId === null || angular.isUndefined(input.productId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'productId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "productId": input.invoiceId
                };

                APIFactory.API(appName, 'product', 'describeProduct', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('PreferencesFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getPreferences: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'preference', 'get_preference', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyPreferences: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'preference', 'modify_preference', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('PlanFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            describePlan: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //Process query parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'plan', 'describePlan', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            activatePlanApplication: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.application === null || angular.isUndefined(input.application)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'application' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "application": input.application
                };
                APIFactory.API(appName, 'plan', 'activatePlanApplication', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }, activatePlanSupport: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters

                APIFactory.API(appName, 'plan', 'activatePlanSupport', APIFactory.APIQueryBuilder({}, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }, deactivatePlanSupport: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters

                APIFactory.API(appName, 'plan', 'deactivatePlanSupport', APIFactory.APIQueryBuilder({}, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updatePlanAiFunctionCount: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.quantity === null || angular.isUndefined(input.quantity)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'quantity' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "quantity": input.quantity
                };
                APIFactory.API(appName, 'plan', 'updatePlanAiFunctionCount', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('PaymentMethodsFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            listPaymentMethods: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'payment-method', 'listPaymentMethods', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describePaymentMethod: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.methodId === null || angular.isUndefined(input.methodId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'methodId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "methodId": input.methodId
                };

                APIFactory.API(appName, 'payment-method', 'describePaymentMethod', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deletePaymentMethod: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.methodId === null || angular.isUndefined(input.methodId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'methodId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "methodId": input.methodId
                };

                APIFactory.API(appName, 'payment-method', 'deletePaymentMethod', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            requestNewPaymentMethod: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var queryBuilder = {};

                APIFactory.API(appName, 'payment-method', 'requestNewPaymentMethod', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            activatePaymentMethod: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.reference === null || angular.isUndefined(input.reference)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'reference' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "reference": input.reference
                };

                APIFactory.API(appName, 'payment-method', 'activatePaymentMethod', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            setDefaultPaymentMethod: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.methodId === null || angular.isUndefined(input.methodId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'methodId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "methodId": input.methodId
                };

                APIFactory.API(appName, 'payment-method', 'setDefaultPaymentMethod', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InvoiceFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getInvoices: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'invoice', 'listInvoices', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getInvoice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.invoiceId === null || angular.isUndefined(input.invoiceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'invoiceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "invoiceId": input.invoiceId
                };
                APIFactory.API(appName, 'invoice', 'describeInvoice', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getInvoiceAsPdf: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.invoiceId === null || angular.isUndefined(input.invoiceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'invoiceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "invoiceId": input.invoiceId
                };
                APIFactory.API(appName, 'invoice', 'getInvoiceAsPdf', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            payInvoice: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.invoiceId === null || angular.isUndefined(input.invoiceId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'invoiceId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "invoiceId": input.invoiceId,
                    "paymentMethodId": input.paymentMethodId ? input.paymentMethodId : ""
                };
                APIFactory.API(appName, 'invoice', 'payInvoice', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('DiscountFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            listDiscounts: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'discount', 'listDiscounts', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createDiscount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'accountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId,
                    "body": input.body
                };
                APIFactory.API(appName, 'discount', 'createDiscount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeDiscount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.discountId === null || angular.isUndefined(input.discountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'discountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "discountId": input.discountId
                };
                APIFactory.API(appName, 'discount', 'describeDiscount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteDiscount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.discountId === null || angular.isUndefined(input.discountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'discountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "discountId": input.discountId
                };
                APIFactory.API(appName, 'discount', 'deleteDiscount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateDiscount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.discountId === null || angular.isUndefined(input.discountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'discountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "discountId": input.discountId,
                    "body": input.body
                };
                APIFactory.API(appName, 'discount', 'updateDiscount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('CreditTokenFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            listUnclaimedCreditTokens: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'credit-token', 'listUnclaimedCreditTokens', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createUnclaimedCreditToken: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'credit-token', 'createUnclaimedCreditToken', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeUnclaimedCreditToken: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "tokenId": input && input.tokenId ? input.tokenId : ''
                };
                APIFactory.API(appName, 'credit-token', 'describeUnclaimedCreditToken', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            sendUnclaimedCreditTokenToUser: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'userId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "tokenId": input && input.tokenId ? input.tokenId : '',
                    "userId": input && input.userId ? input.userId : ''
                };
                APIFactory.API(appName, 'credit-token', 'sendUnclaimedCreditTokenToUser', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteUnclaimedCreditToken: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "tokenId": input && input.tokenId ? input.tokenId : ''
                };
                APIFactory.API(appName, 'credit-token', 'deleteUnclaimedCreditToken', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            claimUnclaimedCreditToken: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "tokenId": input && input.tokenId ? input.tokenId : ''
                };
                APIFactory.API(appName, 'credit-token', 'claimUnclaimedCreditToken', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listClaimedCreditTokens: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'credit-token', 'listClaimedCreditTokens', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeClaimedCreditToken: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {
                    "tokenId": input && input.tokenId ? input.tokenId : ''
                };
                APIFactory.API(appName, 'credit-token', 'describeClaimedCreditToken', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('CreditFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getCredits: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'credit', 'get_credit', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addCredit: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tokenId === null || angular.isUndefined(input.tokenId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tokenId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "tokenId": input.tokenId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'credit', 'add_credit', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('CartFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            describeCart: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'cart', 'describeCart', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addProductToCart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.productId === null || angular.isUndefined(input.productId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'productId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "productId": input.productId,
                    "quantity": input.quantity ? input.quantity : 1
                };

                APIFactory.API(appName, 'cart', 'addProductToCart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeItemFromCart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.itemId === null || angular.isUndefined(input.itemId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'itemId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "itemId": input.itemId
                };

                APIFactory.API(appName, 'cart', 'removeItemFromCart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            checkoutCart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "paymentMethodId": input.paymentMethodId ? input.paymentMethodId : "",
                    "body": input.body
                };

                APIFactory.API(appName, 'cart', 'checkoutCart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeGeocodeForAddress: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.address === null || angular.isUndefined(input.address)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'address' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }


                //Process query parameters
                var queryBuilder = {
                    address: input.address
                };
                APIFactory.API('access', 'geocode', 'describeGeocodeForAddress', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('BusinessDetailFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            describeBusinessDetails: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'business-detail', 'describeBusinessDetails', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateBusinessDetails: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'business-detail', 'updateBusinessDetails', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('BudgetFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getBudgets: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'budget', 'get_budgets', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createBudget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'create_budget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getBudget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'get_budget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteBudget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'delete_budget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyBudget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'modify_budget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createBudgetCondition: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'create_budget_condition', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyBudgetCondition: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.conditionId === null || angular.isUndefined(input.conditionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'conditionId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "conditionId": input.conditionId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'modify_budget_condition', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteBudgetConditon: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.budgetId === null || angular.isUndefined(input.budgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'budgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.conditionId === null || angular.isUndefined(input.conditionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'conditionId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "budgetId": input.budgetId,
                    "conditionId": input.conditionId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'budget', 'delete_budget_condition', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('BillingScriptFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            listScriptTypes: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {};

                APIFactory.API(appName, 'script', 'listScriptTypes', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type  === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };
                APIFactory.API(appName, 'script', 'describeScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type  === null || angular.isUndefined(input.type )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'script', 'updateScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('BillingNotificationFactory', function ($q, $cookies, APIFactory) {
        var appName = "billing";
        return {
            getNotifications: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'notification', 'describeBillingNotifications', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateBillingNotifications: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'notification', 'updateBillingNotifications', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('QueryFactory', function ($q, $cookies, APIFactory) {
        var appName = "insight";
        return {
            executeQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.sql === null || angular.isUndefined(input.sql)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'sql' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": { sql: input.sql}
                };

                APIFactory.API(appName, 'query', 'executeQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'query', 'createQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "queryId": input.queryId
                };

                APIFactory.API(appName, 'query', 'describeQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "queryId": input.queryId
                };

                APIFactory.API(appName, 'query', 'deleteQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "queryId": input.queryId,
                    "body": input.body
                };

                APIFactory.API(appName, 'query', 'updateQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateQuerySQL: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "queryId": input.queryId,
                    "body": input.body
                };

                APIFactory.API(appName, 'query', 'updateQuerySQL', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceQueryTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The property 'queryId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "queryId": input.queryId
                };
                APIFactory.API(appName, 'query', 'replaceQueryTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            executeStoredQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "queryId": input.queryId
                };

                APIFactory.API(appName, 'query', 'executeStoredQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InsightWidgetFactory', function ($q, $cookies, APIFactory) {
        var appName = "insight";
        return {
            createWidget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'widget', 'createWidget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeWidget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId
                };

                APIFactory.API(appName, 'widget', 'describeWidget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteWidget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId
                };

                APIFactory.API(appName, 'widget', 'deleteWidget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateWidget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId,
                    "body": input.body
                };

                APIFactory.API(appName, 'widget', 'updateWidget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateWidgetChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId,
                    "chartId": input.chartId
                };

                APIFactory.API(appName, 'widget', 'updateWidgetChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateWidgetLayout: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId,
                    "body": input.body
                };

                APIFactory.API(appName, 'widget', 'updateWidgetLayout', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceWidgetTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The property 'widgetId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "widgetId": input.widgetId
                };
                APIFactory.API(appName, 'widget', 'replaceWidgetTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            executeWidget: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.widgetId === null || angular.isUndefined(input.widgetId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'widgetId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "widgetId": input.widgetId
                };

                APIFactory.API(appName, 'widget', 'executeWidget', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InsightProjectFactory', function ($q, $cookies, APIFactory) {
        var appName = "insight";
        return {
            createProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'createProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'deleteProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId,
                    "body": input.body
                };

                APIFactory.API(appName, 'project', 'updateProject', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceProjectTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "projectId": input.projectId
                };
                APIFactory.API(appName, 'project', 'replaceProjectTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeProjectRelationships: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'projectId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "projectId": input.projectId
                };

                APIFactory.API(appName, 'project', 'describeProjectRelationships', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InsightDashboardFactory', function ($q, $cookies, APIFactory) {
        var appName = "insight";
        return {
            createDashboard: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'dashboard', 'createDashboard', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeDashboard: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'dashboardId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "dashboardId": input.dashboardId
                };

                APIFactory.API(appName, 'dashboard', 'describeDashboard', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteDashboard: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'dashboardId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "dashboardId": input.dashboardId
                };

                APIFactory.API(appName, 'dashboard', 'deleteDashboard', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateDashboard: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'dashboardId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "dashboardId": input.dashboardId,
                    "body": input.body
                };

                APIFactory.API(appName, 'dashboard', 'updateDashboard', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateDashboardCells: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'dashboardId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "dashboardId": input.dashboardId,
                    "body": input.body
                };

                APIFactory.API(appName, 'dashboard', 'updateDashboardCells', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceDashboardTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The property 'dashboardId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "dashboardId": input.dashboardId
                };
                APIFactory.API(appName, 'dashboard', 'replaceDashboardTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            executeDashboard: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.dashboardId === null || angular.isUndefined(input.dashboardId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'dashboardId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "dashboardId": input.dashboardId
                };

                APIFactory.API(appName, 'dashboard', 'executeDashboard', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InsightChartFactory', function ($q, $cookies, APIFactory) {
        var appName = "insight";
        return {
            createChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'chart', 'createChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId
                };

                APIFactory.API(appName, 'chart', 'describeChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId
                };

                APIFactory.API(appName, 'chart', 'deleteChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId,
                    "body": input.body
                };

                APIFactory.API(appName, 'chart', 'updateChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateChartQuery: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.queryId === null || angular.isUndefined(input.queryId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'queryId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId,
                    "queryId": input.queryId
                };

                APIFactory.API(appName, 'chart', 'updateChartQuery', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateChartChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId,
                    "body": input.body
                };

                APIFactory.API(appName, 'chart', 'updateChartChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceChartTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The property 'chartId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "chartId": input.chartId
                };
                APIFactory.API(appName, 'chart', 'replaceChartTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            executeChart: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.chartId === null || angular.isUndefined(input.chartId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'chartId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "chartId": input.chartId
                };

                APIFactory.API(appName, 'chart', 'executeChart', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('VaultsFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listVaults: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'vault', 'listVaults', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeVault: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'vaultId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "vaultId": input.vaultId
                };

                APIFactory.API(appName, 'vault', 'describeVault', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteVault: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'vaultId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "vaultId": input.vaultId
                };

                APIFactory.API(appName, 'vault', 'deleteVault', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createVault: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'vault', 'createVault', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateVault: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'userGroupId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "vaultId": input.vaultId,
                    "body": input.body
                };

                APIFactory.API(appName, 'vault', 'updateVault', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceVaultData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The property vault Id  in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "vaultId": input.vaultId
                };
                APIFactory.API(appName, 'vault', 'replaceVaultTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeVaultContent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The property vault Id  in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "vaultId": input.vaultId
                };
                APIFactory.API(appName, 'vault', 'describeVaultContent', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceVaultContent: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.vaultId === null || angular.isUndefined(input.vaultId)) {
                    _deffered.reject({
                        errorMessage: "The property vault Id  in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "vaultId": input.vaultId
                };
                APIFactory.API(appName, 'vault', 'replaceVaultContent', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('ValidationFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            /**
             * Validate a new account.
             */
            validateNewAccount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "body property body in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body
                };
                APIFactory.API(appName, 'validation', 'validateNewAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateNewUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "body property body in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body
                };
                APIFactory.API(appName, 'validation', 'validateNewUser', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateNewEmail: function () {

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {};
                APIFactory.API(appName, 'validation', 'validateNewEmail', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateNewPassword: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "body property body in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }
                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body
                };
                APIFactory.API(appName, 'validation', 'validateNewPassword', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi')
        .factory('UserFactory', function ($q, $cookies, $base64, APIFactory) {
            var appName = "access";
            return {
                listUsers: function (input, queryParameters) {
                    //Create promise to return
                    var _deffered = $q.defer();
                    queryParameters = queryParameters || null;
                    var queryBuilder = {
                        "orderBy": input && input.orderBy ? input.orderBy : '',
                        "limit": input && input.limit ? input.limit : '',
                        "offset": input && input.offset ? input.offset : '',
                        "query": input && input.query ? input.query : '',
                        "select": input && input.select ? input.select : '',
                        "where": input && input.where ? input.where : '',
                        "groupBy": input && input.groupBy ? input.groupBy : ''
                    };
                    APIFactory.API(appName, 'user', 'listUsers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                createUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    var queryBuilder = {
                        "body": input.body
                    };

                    APIFactory.API(appName, 'user', 'createUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                describeUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }


                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'describeUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                deleteUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The parameter 'userId' is a required parameter and cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'deleteUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserState: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserState', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                replaceUserData: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'replaceUserTags', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                listPrivileges: function () {
                    //Create promise to return
                    var _deffered = $q.defer();

                    APIFactory.API(appName, 'user', 'listPrivileges', {}).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                listUserTeams: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }


                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'listUserTeams', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                listUserSecurityRoles: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }


                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'listUserSecurityRoles', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                addTeamToUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.teamId === null || angular.isUndefined(input.teamId)) {
                        _deffered.reject({
                            errorMessage: "The property 'groupId id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId,
                        "teamId": input.teamId
                    };
                    APIFactory.API(appName, 'user', 'addTeamToUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                removeTeamFromUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.teamId === null || angular.isUndefined(input.teamId)) {
                        _deffered.reject({
                            errorMessage: "The property 'groupId id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId,
                        "teamId": input.teamId
                    };
                    APIFactory.API(appName, 'user', 'removeTeamFromUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                addSecurityRoleToUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                        _deffered.reject({
                            errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "securityRoleId": input.securityRoleId,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'addSecurityRoleToUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                removeSecurityRoleFromUser: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.roleId === null || angular.isUndefined(input.securityRoleId)) {
                        _deffered.reject({
                            errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "securityRoleId": input.securityRoleId,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'removeSecurityRoleFromUser', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserPassword: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserPassword', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                requestUnconfirmedUserActivationLink: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'userId' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'requestUnconfirmedUserActivationLink', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                describeUserProfile: function () {
                    var _deffered = $q.defer();

                    //Process template parameters
                    var queryBuilder = {};
                    APIFactory.API(appName, 'user', 'describeUserProfile', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserProfile: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body
                    };
                    APIFactory.API(appName, 'user', 'updateUserProfile', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                requestPasswordResetLink: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.identifier === null || angular.isUndefined(input.identifier)) {
                        _deffered.reject({
                            errorMessage: "The property 'identifier' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }


                    //Process template parameters
                    var queryBuilder = {
                        "identifier": input.identifier
                    };
                    APIFactory.API(appName, 'user', 'requestPasswordResetLink', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserAdministrator: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserAdministrator', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserBillingRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserBillingRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                enableMFA: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.secret === null || angular.isUndefined(input.secret)) {
                        _deffered.reject({
                            errorMessage: "The property 'secret' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "secret": input.secret
                    };
                    APIFactory.API(appName, 'user', 'enableMFA', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                disableMFA: function () {
                    var _deffered = $q.defer();

                    APIFactory.API(appName, 'user', 'disableMFA', {}).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserTrackerRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserTrackerRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserNodeRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserNodeRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserPipelineRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserPipelineRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserStorageRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserStorageRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserAiRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserAiRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                updateUserInsightRole: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.body === null || angular.isUndefined(input.body)) {
                        _deffered.reject({
                            errorMessage: "The property 'body' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    } else if (input.userId === null || angular.isUndefined(input.userId)) {
                        _deffered.reject({
                            errorMessage: "The property 'user Id' in the input object cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    //Process template parameters
                    var queryBuilder = {
                        "body": input.body,
                        "userId": input.userId
                    };
                    APIFactory.API(appName, 'user', 'updateUserInsightRole', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                }
            }
        });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TeamFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            addUserToTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The property 'teamId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'userId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "teamId": input.teamId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'team', 'addUserToTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeUserFromTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The property 'teamId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'userId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "teamId": input.teamId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'team', 'removeUserFromTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listTeams: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'team', 'listTeams', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'team', 'createTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'teamId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "teamId": input.teamId
                };

                APIFactory.API(appName, 'team', 'describeTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'teamId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "teamId": input.teamId
                };

                APIFactory.API(appName, 'team', 'deleteTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId  === null || angular.isUndefined(input.teamId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'teamId ' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "teamId" : input.teamId ,
                    "body": input.body
                };

                APIFactory.API(appName, 'team', 'updateTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceTeamTags: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The property 'teamId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "teamId": input.teamId
                };
                APIFactory.API(appName, 'team', 'replaceTeamTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listTeamUsers: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'teamId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "teamId": input.teamId
                };

                APIFactory.API(appName, 'team', 'listTeamUsers', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addResourceToTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The property 'teamId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.resourceId === null || angular.isUndefined(input.resourceId)) {
                    _deffered.reject({
                        errorMessage: "The property 'resourceId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "teamId": input.teamId,
                    "resourceId": input.resourceId
                };
                APIFactory.API(appName, 'team', 'addResourceToTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeResourceFromTeam: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.teamId === null || angular.isUndefined(input.teamId)) {
                    _deffered.reject({
                        errorMessage: "The property 'teamId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.resourceId === null || angular.isUndefined(input.resourceId)) {
                    _deffered.reject({
                        errorMessage: "The property 'resourceId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "teamId": input.teamId,
                    "resourceId": input.resourceId
                };
                APIFactory.API(appName, 'team', 'removeResourceFromTeam', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('SupportFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            createInternalSupportTicket: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'support', 'createInternalSupportTicket', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('SessionFactory', function ($q, $cookies, APIFactory, $http, DB, AvatarService, UserFactory) {
        function fnGetUserDetail(defer, currentAuthUserId) {
            UserFactory.describeUser({userId: currentAuthUserId})
                .then(function (success) {
                    success.avatar = AvatarService.getTextAvatar(success);
                    defer.resolve(success);
                });
        }
        var appName = "access";
        return {
            /**
             * Get an Authentication Token. See the Auth Token model for more information
             */
            describeUserAuthenticationMethod: function (input) {

                input = input || {};
                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.identifier === null || angular.isUndefined(input.identifier)) {
                    _deffered.reject({
                        errorMessage: "The property 'Identifier' in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "identifier": input.identifier
                };
                APIFactory.API(appName, 'session', 'describeUserAuthenticationMethod', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            createSession: function (input) {

                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.identifier === null || angular.isUndefined(input.identifier)) {
                    _deffered.reject({
                        errorMessage: "The property 'Identifier' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "identifier": input.identifier,
                    "body": input.body
                };

                APIFactory.API(appName, 'session', 'createSession', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            deleteSession: function () {

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters

                var queryBuilder = {};

                APIFactory.API(appName, 'session', 'deleteSession', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            validateUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "body property body in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.token === null || angular.isUndefined(input.token)) {
                    _deffered.reject({
                        errorMessage: "token property token in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "token": input.token
                };
                APIFactory.API(appName, 'security', 'validate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createFederationSession: function (input) {
                input = input || {};
                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The property 'federationId' in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId
                };
                APIFactory.API(appName, 'session', 'createFederationSession', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            createSupportSession: function (input) {
                input = input || {};
                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The property 'accountId' in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId
                };
                APIFactory.API(appName, 'session', 'createSupportSession', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             *Get an authenticated user (After login)
             */
            getLoginUser: function () {
                var _deffered = $q.defer();
                var currentAuthUserId = DB.fnGet('xContextId');
                if (currentAuthUserId) {
                    fnGetUserDetail(_deffered, currentAuthUserId);
                }
                /*var config = {};
                config.baseUri = APIFactory.BASEURL(appName);
                config.headers = {};
                config.headers.accept = 'application/json';
                config.headers['content-type'] = 'application/json; charset=utf-8';
                config.headers.authorization = 'Bearer ' + $cookies.get('phoenix');
                $http({
                    method: 'GET',
                    url: config.baseUri + '/users',
                    headers: config.headers
                }).success(function (data, status, headers/!*, config*!/) {
                    var currentAuthUserId = headers('x-pre-api-principal-id');
                    if (currentAuthUserId) {
                        DB.fnSet('xContextId', currentAuthUserId);
                        fnGetUserDetail(_deffered, currentAuthUserId);
                    }
                });*/

                return _deffered.promise;
            }

            /**
             * Get permissions for User
             */
            /*getPermissionOfLoginUser: function (userObj) {
                var _deffered = $q.defer();
                var urlVar = userObj.role === 'ADMINISTRATOR' ? 'assets/json/adminPermissions.json' : 'assets/json/userPermissions.json';
                $http({
                    method: 'GET',
                    url: urlVar
                }).success(function (permisiionObj) {
                    _deffered.resolve(permisiionObj);
                });
                return _deffered.promise;
            }*/
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('SecurityRoleFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            addFederationToSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The property 'federationId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "federationId": input.federationId
                };
                APIFactory.API(appName, 'security-role', 'addFederationToSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeFederationFromSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The property 'federationId id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "federationId": input.federationId
                };
                APIFactory.API(appName, 'security-role', 'removeFederationFromSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addUserToSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'userId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'security-role', 'addUserToSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeUserFromSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'userId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'security-role', 'removeUserFromSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityRoles: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'security-role', 'listSecurityRoles',  APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'security-role', 'createSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityRoleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityRoleId": input.securityRoleId
                };

                APIFactory.API(appName, 'security-role', 'describeSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityRoleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityRoleId": input.securityRoleId
                };

                APIFactory.API(appName, 'security-role', 'deleteSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityRoleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "body": input.body
                };

                APIFactory.API(appName, 'security-role', 'updateSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceSecurityRoleData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The property 'body' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "securityRoleId": input.securityRoleId
                };
                APIFactory.API(appName, 'security-role', 'replaceSecurityRoleTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addPermissionToSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.permission === null || angular.isUndefined(input.permission)) {
                    _deffered.reject({
                        errorMessage: "The property 'permission' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "permission": input.permission
                };
                APIFactory.API(appName, 'security-role', 'addPermissionToSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removePermissionFromSecurityRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.permission === null || angular.isUndefined(input.permission)) {
                    _deffered.reject({
                        errorMessage: "The property 'permission' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "permission": input.permission
                };
                APIFactory.API(appName, 'security-role', 'removePermissionFromSecurityRole', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityRolePermissions: function () {

                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'security-role', 'listSecurityRolePermissions', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityRoleUsers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId
                };
                APIFactory.API(appName, 'security-role', 'listSecurityRoleUsers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityRoleFederations: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId
                };
                APIFactory.API(appName, 'security-role', 'listSecurityRoleFederations', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('SecurityGroupFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listSecurityGroups: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'security-group', 'listSecurityGroups', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'security-group', 'createSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId
                };

                APIFactory.API(appName, 'security-group', 'describeSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId
                };

                APIFactory.API(appName, 'security-group', 'deleteSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId,
                    "body": input.body
                };

                APIFactory.API(appName, 'security-group', 'updateSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceSecurityGroupData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId,
                    "body": input.body
                };

                APIFactory.API(appName, 'security-group', 'replaceSecurityGroupTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addResourceToSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.resource === null || angular.isUndefined(input.resource)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'resource' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId,
                    "resource": input.resource
                };

                APIFactory.API(appName, 'security-group', 'addResourceToSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeResourceFromSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'securityGroupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.resource === null || angular.isUndefined(input.resource)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'resource' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId,
                    "resource": input.resource
                };

                APIFactory.API(appName, 'security-group', 'removeResourceFromSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityGroupResources: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'Security Group Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId
                };

                APIFactory.API(appName, 'security-group', 'listSecurityGroupResources', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addSecurityRoleToSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityGroupId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "securityGroupId": input.securityGroupId
                };
                APIFactory.API(appName, 'security-group', 'addSecurityRoleToSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeSecurityRoleFromSecurityGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityGroupId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.securityRoleId === null || angular.isUndefined(input.securityRoleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'securityRoleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "securityRoleId": input.securityRoleId,
                    "securityGroupId": input.securityGroupId
                };
                APIFactory.API(appName, 'security-group', 'removeSecurityRoleFromSecurityGroup', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listSecurityGroupSecurityRoles : function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.securityGroupId === null || angular.isUndefined(input.securityGroupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'Security Group Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "securityGroupId": input.securityGroupId
                };

                APIFactory.API(appName, 'security-group', 'listSecurityGroupSecurityRoles', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('SecurityFactory', function ($q, $cookies, APIFactory, $http, DB, AvatarService, UserFactory) {
        function fnGetUserDetail(defer, currentAuthUserId) {
            UserFactory.describeUser({userId: currentAuthUserId})
                .then(function (success) {
                    success.avatar = AvatarService.getTextAvatar(success);
                    defer.resolve(success);
                });
        }
        var appName = "access";
        return {
            /**
             * Get an Authentication Token. See the Auth Token model for more information
             */
            getAuthenticationParameters: function (input) {

                input = input || {};
                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "Type property in  the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.identifier === null || angular.isUndefined(input.identifier)) {
                    _deffered.reject({
                        errorMessage: "The property 'Identifier' in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "identifier": input.identifier
                };
                APIFactory.API(appName, 'session', 'describeUserAuthenticationMethod', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            createSession: function (input) {

                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The property 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.identifier === null || angular.isUndefined(input.identifier)) {
                    _deffered.reject({
                        errorMessage: "The property 'Identifier' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "identifier": input.identifier,
                    "requestBody": input.body
                };

                APIFactory.API(appName, 'session', 'createSession', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            validateUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "body property body in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.token === null || angular.isUndefined(input.token)) {
                    _deffered.reject({
                        errorMessage: "token property token in the object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "body": input.body,
                    "token": input.token
                };
                APIFactory.API(appName, 'security', 'validate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            /**
             *Get an authenticated user (After login)
             */
            getLoginUser: function () {
                var _deffered = $q.defer();
                var currentAuthUserId = DB.fnGet('xContextId');
                if (currentAuthUserId) {
                    fnGetUserDetail(_deffered, currentAuthUserId);
                }
                /*var config = {};
                config.baseUri = APIFactory.BASEURL(appName);
                config.headers = {};
                config.headers.accept = 'application/json';
                config.headers['content-type'] = 'application/json; charset=utf-8';
                config.headers.authorization = 'Bearer ' + $cookies.get('phoenix');
                $http({
                    method: 'GET',
                    url: config.baseUri + '/users',
                    headers: config.headers
                }).success(function (data, status, headers/!*, config*!/) {
                    var currentAuthUserId = headers('x-pre-api-principal-id');
                    if (currentAuthUserId) {
                        DB.fnSet('xContextId', currentAuthUserId);
                        fnGetUserDetail(_deffered, currentAuthUserId);
                    }
                });*/

                return _deffered.promise;
            }

            /**
             * Get permissions for User
             */
            /*getPermissionOfLoginUser: function (userObj) {
                var _deffered = $q.defer();
                var urlVar = userObj.role === 'ADMINISTRATOR' ? 'assets/json/adminPermissions.json' : 'assets/json/userPermissions.json';
                $http({
                    method: 'GET',
                    url: urlVar
                }).success(function (permisiionObj) {
                    _deffered.resolve(permisiionObj);
                });
                return _deffered.promise;
            }*/
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ScriptFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listScriptTypes: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {};

                APIFactory.API(appName, 'script', 'listScriptTypes', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type  === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };
                APIFactory.API(appName, 'script', 'describeScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type  === null || angular.isUndefined(input.type )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'script', 'resetScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'script', 'updateScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('RoleFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            getUserRoles: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'User Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "userId": input.userId
                };

                APIFactory.API(appName, 'role', 'get_user_roles', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addRoleToUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'role id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "userId": input.userId,
                    "roleId": input.roleId
                };
                APIFactory.API(appName, 'role', 'add_role_to_user', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeRoleFromUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'role id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "userId": input.userId,
                    "roleId": input.roleId
                };
                APIFactory.API(appName, 'role', 'remove_role_from_user', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getGroupRoles: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId
                };

                APIFactory.API(appName, 'role', 'get_group_roles', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addRoleToGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'roleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'groupId id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "roleId": input.roleId,
                    "groupId": input.groupId
                };
                APIFactory.API(appName, 'role', 'add_role_to_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeRoleFromGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The property 'roleId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'groupId id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "roleId": input.roleId,
                    "groupId": input.groupId
                };
                APIFactory.API(appName, 'role', 'remove_role_from_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getRoles: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'role', 'get_roles',{}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'role', 'create_role', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId
                };

                APIFactory.API(appName, 'role', 'get_role', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId
                };

                APIFactory.API(appName, 'role', 'delete_role', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyRole: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId,
                    "body": input.body
                };

                APIFactory.API(appName, 'role', 'modify_role', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createRoleStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId,
                    "body": input.body
                };

                APIFactory.API(appName, 'role', 'create_role_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyRoleStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.statementId === null || angular.isUndefined(input.statementId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'statementId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId,
                    "statementId": input.statementId,
                    "body": input.body
                };

                APIFactory.API(appName, 'role', 'modify_role_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteRoleStatement: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleId === null || angular.isUndefined(input.roleId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'roleId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.statementId === null || angular.isUndefined(input.statementId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'statementId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleId": input.roleId,
                    "statementId": input.statementId
                };

                APIFactory.API(appName, 'role', 'delete_role_statement', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getRoleBlueprints: function () {

                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'role', 'get_role_blueprints', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getRoleBlueprint: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.roleBlueprintId === null || angular.isUndefined(input.roleBlueprintId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'Blueprint Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "roleBlueprintId": input.roleBlueprintId
                };

                APIFactory.API(appName, 'role', 'get_role_blueprint', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('GroupFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            getGroups: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'group', 'get_groups', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'group', 'create_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId
                };

                APIFactory.API(appName, 'group', 'get_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId
                };

                APIFactory.API(appName, 'group', 'delete_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyGroup: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId,
                    "body": input.body
                };

                APIFactory.API(appName, 'group', 'modify_group', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateGroupData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId,
                    "body": input.body
                };

                APIFactory.API(appName, 'group', 'update_group_data', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getUserGroups: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'User Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "userId": input.userId
                };

                APIFactory.API(appName, 'group', 'get_user_groups', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addGroupToUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'groupId id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "userId": input.userId,
                    "groupId": input.groupId
                };
                APIFactory.API(appName, 'group', 'add_group_to_user', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeGroupFromUser: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The property 'groupId id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "userId": input.userId,
                    "groupId": input.groupId
                };
                APIFactory.API(appName, 'group', 'remove_group_from_user', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getGroupUsers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.groupId === null || angular.isUndefined(input.groupId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'groupId Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "groupId": input.groupId
                };

                APIFactory.API(appName, 'group', 'get_group_users', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('FederationsFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listFederations: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : '',
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : ''
                };

                APIFactory.API(appName, 'federation', 'listFederations', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeFederation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId
                };

                APIFactory.API(appName, 'federation', 'describeFederation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteFederation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId
                };

                APIFactory.API(appName, 'federation', 'deleteFederation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createFederation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.outboundAccountId === null || angular.isUndefined(input.outboundAccountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'outboundAccountId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "outboundAccountId": input.outboundAccountId
                };

                APIFactory.API(appName, 'federation', 'createFederation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateFederation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId,
                    "body": input.body
                };

                APIFactory.API(appName, 'federation', 'updateFederation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceFederationData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federation id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId,
                    "body": input.body
                };

                APIFactory.API(appName, 'federation', 'replaceFederationTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeFederationScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId
                };

                APIFactory.API(appName, 'federation', 'describeFederationScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetFederationScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId
                };

                APIFactory.API(appName, 'federation', 'resetFederationScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateFederationScript: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.federationId === null || angular.isUndefined(input.federationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'federationId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "federationId": input.federationId,
                    "body": input.body
                };

                APIFactory.API(appName, 'federation', 'updateFederationScript', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('EmailTemplateFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listEmailTemplateTypes: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'email-template', 'listEmailTemplateTypes', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'describeEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            resetEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type
                };

                APIFactory.API(appName, 'email-template', 'resetEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateEmailTemplate: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.type === null || angular.isUndefined(input.type)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "type": input.type,
                    "body": input.body
                };

                APIFactory.API(appName, 'email-template', 'updateEmailTemplate', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi')
        .factory('EmailFactory', function ($q, $cookies, $base64, APIFactory) {
            var appName = "access";
            return {
                listWhitelistedEmails: function (input, queryParameters) {
                    //Create promise to return
                    var _deffered = $q.defer();
                    queryParameters = queryParameters || null;
                    var queryBuilder = {
                        "select": input && input.select ? input.select : '',
                        "where": input && input.where ? input.where : '',
                        "groupBy": input && input.groupBy ? input.groupBy : '',
                        "orderBy": input && input.orderBy ? input.orderBy : '',
                        "limit": input && input.limit ? input.limit : '',
                        "offset": input && input.offset ? input.offset : '',
                        "query": input && input.query ? input.query : ''
                    };
                    APIFactory.API(appName, 'whitelist-email', 'listWhitelistedEmails', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                },
                requestEmailToBeWhitelisted: function (input) {
                    //Assign default values
                    input = input || {};

                    //Create promise to return
                    var _deffered = $q.defer();

                    //validating required parameters
                    var _missingArgs = false;
                    if (input.email === null || angular.isUndefined(input.email)) {
                        _deffered.reject({
                            errorMessage: "The parameter 'email' is a required parameter and cannot be null.",
                            errorCode: -1
                        });
                        _missingArgs = true;
                    }

                    if (_missingArgs) {
                        return _deffered.promise
                    }

                    var queryBuilder = {
                        "email": input.email
                    };

                    APIFactory.API(appName, 'whitelist-email', 'requestEmailToBeWhitelisted', queryBuilder).then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                    return _deffered.promise;
                }
            }
        });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('DocumentationFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            describeDocumentation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.documentationId === null || angular.isUndefined(input.documentationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'documentation Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "documentationId": input.documentationId
                };

                APIFactory.API(appName, 'docs', 'describeDocumentation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceDocumentation: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.documentationId === null || angular.isUndefined(input.documentationId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'documentation Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "documentationId": input.documentationId,
                    "body": input.body
                };

                APIFactory.API(appName, 'docs', 'replaceDocumentation', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ContactFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            getContacts: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'contact', 'get_contacts', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createContact: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'contact', 'create_contact', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getContact: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.contactId === null || angular.isUndefined(input.contactId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'contactId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "contactId": input.contactId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'contact', 'get_contact', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteContact: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.contactId === null || angular.isUndefined(input.contactId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'contactId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "contactId": input.contactId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'contact', 'delete_contact', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyContact: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.contactId === null || angular.isUndefined(input.contactId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'contactId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "contactId": input.contactId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'contact', 'modify_contact', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('AuthenticatorFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listAuthenticators: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'authenticator', 'listAuthenticators', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'authenticator', 'createAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId  === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'authenticatorId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "authenticatorId": input.authenticatorId
                };
                APIFactory.API(appName, 'authenticator', 'describeAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId  === null || angular.isUndefined(input.authenticatorId )) {
                    _deffered.reject({
                        errorMessage: "The parameter 'authenticatorId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "authenticatorId": input.authenticatorId
                };

                APIFactory.API(appName, 'authenticator', 'deleteAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'authenticatorId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "authenticatorId": input.authenticatorId,
                    "body": input.body
                };

                APIFactory.API(appName, 'authenticator', 'updateAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listAuthenticatorUsers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'authenticatorId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "authenticatorId": input.authenticatorId
                };

                APIFactory.API(appName, 'authenticator', 'listAuthenticatorUsers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceAuthenticatorData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'authenticator id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "authenticatorId": input.authenticatorId,
                    "body": input.body
                };

                APIFactory.API(appName, 'authenticator', 'replaceAuthenticatorTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            addUserToAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The property 'authenticator Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "authenticatorId": input.authenticatorId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'authenticator', 'addUserToAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            removeUserFromAuthenticator: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.authenticatorId === null || angular.isUndefined(input.authenticatorId)) {
                    _deffered.reject({
                        errorMessage: "The property 'authenticator Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.userId === null || angular.isUndefined(input.userId)) {
                    _deffered.reject({
                        errorMessage: "The property 'user Id' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "authenticatorId": input.authenticatorId,
                    "userId": input.userId
                };
                APIFactory.API(appName, 'authenticator', 'removeUserFromAuthenticator', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listAuthenticatorTypes: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'authenticator', 'listAuthenticatorTypes', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeAuthenticatorType: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.typeId === null || angular.isUndefined(input.typeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'type id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "typeId": input.typeId
                };

                APIFactory.API(appName, 'authenticator', 'describeAuthenticatorType', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('AuditFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listAudits: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();

                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };

                APIFactory.API(appName, 'audit', 'listAudits', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ApiKeyFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            listApiKeys: function () {
                //Create promise to return
                var _deffered = $q.defer();

                APIFactory.API(appName, 'api-key', 'listApiKeys', {}).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createNewApiKey: function () {
                //Create promise to return
                var _deffered = $q.defer();

                var queryBuilder = {
                };

                APIFactory.API(appName, 'api-key', 'createNewApiKey', APIFactory.APIQueryBuilder(queryBuilder)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeApiKey: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.apikeyId === null || angular.isUndefined(input.apikeyId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'apikeyId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "apikeyId": input.apikeyId
                };

                APIFactory.API(appName, 'api-key', 'describeApiKey', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteApiKey: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.apikeyId === null || angular.isUndefined(input.apikeyId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'apikeyId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "apikeyId": input.apikeyId
                };

                APIFactory.API(appName, 'api-key', 'deleteApiKey', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateApiKey: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.apikeyId === null || angular.isUndefined(input.apikeyId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'apikeyId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "apikeyId": input.apikeyId,
                    "body": input.body
                };

                APIFactory.API(appName, 'api-key', 'updateApiKey', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateApiKeyState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.apikeyId === null || angular.isUndefined(input.apikeyId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'apikeyId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "apikeyId": input.apikeyId,
                    "body": input.body
                };

                APIFactory.API(appName, 'api-key', 'updateApiKeyState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('AccountFactory', function ($q, $cookies, APIFactory) {
        var appName = "access";
        return {
            describeAccountState: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {};
                APIFactory.API(appName, 'account', 'describeAccountState', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listAccounts: function (input, queryParameters) {
                //Create promise to return
                var _deffered = $q.defer();
                queryParameters = queryParameters || null;
                var queryBuilder = {
                    "orderBy": input && input.orderBy ? input.orderBy : '',
                    "limit": input && input.limit ? input.limit : '',
                    "offset": input && input.offset ? input.offset : '',
                    "query": input && input.query ? input.query : '',
                    "select": input && input.select ? input.select : '',
                    "where": input && input.where ? input.where : '',
                    "groupBy": input && input.groupBy ? input.groupBy : ''
                };
                APIFactory.API(appName, 'account', 'listAccounts', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createNewSelfServiceAccount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body
                };

                APIFactory.API(appName, 'account', 'createNewAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            describeAccount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'account id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId
                };

                APIFactory.API(appName, 'account', 'describeAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteAccount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'account id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId
                };

                APIFactory.API(appName, 'account', 'deleteAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateAccount: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'account id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId,
                    "body": input.body
                };

                APIFactory.API(appName, 'account', 'updateAccount', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            updateAccountState: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'account id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId,
                    "body": input.body
                };

                APIFactory.API(appName, 'account', 'updateAccountState', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            replaceAccountData: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'account id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId,
                    "body": input.body
                };

                APIFactory.API(appName, 'account', 'replaceAccountTags', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            listAccountUsers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.accountId === null || angular.isUndefined(input.accountId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'Account Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "accountId": input.accountId
                };

                APIFactory.API(appName, 'account', 'listAccountUsers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            enableAccountSupportAccess: function () {

                //Create promise to return
                var _deffered = $q.defer();
                var queryBuilder = {};

                APIFactory.API(appName, 'account', 'enableAccountSupportAccess', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            disableAccountSupportAccess: function () {

                //Create promise to return
                var _deffered = $q.defer();
                var queryBuilder = {};

                APIFactory.API(appName, 'account', 'disableAccountSupportAccess', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('VmFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getVms: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'vm', 'get_vms', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getVm: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.vmId === null || angular.isUndefined(input.vmId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'vm Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "vmId": input.vmId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'vm', 'get_vm', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TrainerFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getTrainers: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'trainer', 'get_trainers', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createTrainer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'trainer', 'create_trainer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTrainer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.trainerId === null || angular.isUndefined(input.trainerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'trainer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "trainerId": input.trainerId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'trainer', 'get_trainer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteTrainer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.trainerId === null || angular.isUndefined(input.trainerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'trainer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "trainerId": input.trainerId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'trainer', 'delete_trainer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            stopTrainer: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.trainerId === null || angular.isUndefined(input.trainerId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'trainer Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "trainerId": input.trainerId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'trainer', 'stop_trainer', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('ModelFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getModels: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'model', 'get_models', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createModel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'model', 'create_model', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getModel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.modelId === null || angular.isUndefined(input.modelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'model Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "modelId": input.modelId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'model', 'get_model', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteModel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.modelId === null || angular.isUndefined(input.modelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'model Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "modelId": input.modelId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'model', 'delete_model', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyModel: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.modelId === null || angular.isUndefined(input.modelId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'model Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "modelId": input.modelId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'model', 'modify_model', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('InferenceFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            createInference: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.deploymentId === null || angular.isUndefined(input.deploymentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'deployment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "parallel": input.parallel,
                    "body": input.body,
                    "deploymentId": input.deploymentId,
                    "ContentType": input.ContentType,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'inference', 'make_inference', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('DistributionFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getDistributions: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'distribution', 'get_distributions', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createDistribution: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'distribution', 'create_distribution', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDistribution: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.distributionId === null || angular.isUndefined(input.distributionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'distribution Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "distributionId": input.distributionId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'distribution', 'get_distribution', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteDistribution: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.distributionId === null || angular.isUndefined(input.distributionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'distribution Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "distributionId": input.distributionId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'distribution', 'delete_distribution', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyDistribution: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.distributionId === null || angular.isUndefined(input.distributionId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'distribution Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "distributionId": input.distributionId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'distribution', 'modify_distribution', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('DeploymentFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getDeployments: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'deployment', 'get_deployments', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            createDeployment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'deployment', 'create_deployment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getDeployment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deploymentId === null || angular.isUndefined(input.deploymentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'deployment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deploymentId": input.deploymentId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'deployment', 'get_deployment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            deleteDeployment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deploymentId === null || angular.isUndefined(input.deploymentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'deployment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deploymentId": input.deploymentId,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'deployment', 'delete_deployment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            modifyDeployment: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.deploymentId === null || angular.isUndefined(input.deploymentId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'deployment Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "deploymentId": input.deploymentId,
                    "body": input.body,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'deployment', 'modify_deployment', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('AlgorithmFactory', function ($q, $cookies, APIFactory) {
        var appName = "ai";
        return {
            getAlgorithms: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "fields": input.fields,
                    "sort": input.sort,
                    "page": input.page,
                    "perPage": input.perPage,
                    "filter": input.filter,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };
                APIFactory.API(appName, 'algorithm', 'get_algorithms', APIFactory.APIQueryBuilder(queryBuilder, queryParameters)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getAlgorithm: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.algorithmId === null || angular.isUndefined(input.algorithmId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'algorithm Id' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                var queryBuilder = {
                    "algorithmId": input.algorithmId,
                    "fields": input.fields,
                    "authorization": "Bearer " + $cookies.get('phoenix')
                };

                APIFactory.API(appName, 'algorithm', 'get_algorithm', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('billingscriptInfo', fnScriptInfo)

    /** @ngInject */
    function fnScriptInfo($http, $window, $state, $timeout, $base64, BillingScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/billing/script/scriptInfo/scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4', 'billing_S4', 'notifications_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/billing/script/scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType
                    };
                    BillingScriptFactory.describeScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            $scope.scriptObj.name = toUpper(scriptType.replace(/_/g, " "));
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.billing_scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    $scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        $scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function () {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        }
                    };
                    BillingScriptFactory.updateScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType
                                };
                                BillingScriptFactory.resetScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            $scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('paymentMethodInfo', fnPaymentMethodInfo)

    /** @ngInject */
    function fnPaymentMethodInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, DB, PaymentMethodsFactory, BatchFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/billing/payment_method/paymentMethodInfo/paymentMethodInfo.html',
            scope: {
                paymentMethodObj: '=',
                paymentMethodPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/billing/payment_method/paymentMethodInfo/paymentMethodTabs/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isUpdateComplete = true;

                $scope.fnMakePaymentMethodPrimary = function (paymentMethodObj) {
                    $scope.isUpdateComplete = false;
                    var inputObj = {
                        methodId: paymentMethodObj.id
                    };
                    PaymentMethodsFactory.setDefaultPaymentMethod(inputObj)
                        .then(function () {
                            $scope.isUpdateComplete = true;
                            amaran.success("Payment Method Update successfully");
                            $scope.$emit('PaymentMethodPrimaryChanged', paymentMethodObj);
                        }, function () {
                            $scope.isUpdateComplete = true;
                        })
                };

                $scope.fnGetCreditCardClass = function (cardType) {
                    if (cardType === 'discover') {
                        return 'fa-cc-discover';
                    } else if (cardType === 'jcb') {
                        return 'fa-cc-jcb';
                    } else if (cardType === 'americanexpress') {
                        return 'fa-cc-amex';
                    } else if (cardType === 'dinersclub') {
                        return 'fa-cc-diners-club';
                    } else if (cardType === 'visa') {
                        return 'fa-cc-visa';
                    } else if (cardType === 'mastercard') {
                        return 'fa-cc-mastercard';
                    } else {
                        return 'fa-credit-card';
                    }
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.payment_method', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnGetExpirationDate = function () {
                    return $scope.paymentMethodObj.card.expiryMonth.toString().length === 1 ? "0" + $scope.paymentMethodObj.card.expiryMonth + "/" + $scope.paymentMethodObj.card.expiryYear : $scope.paymentMethodObj.card.expiryMonth + "/" + $scope.paymentMethodObj.card.expiryYear;
                };

                $scope.fnGetPaymentMethod = function (paymentMethodId) {
                    var inputObj = {
                        methodId: paymentMethodId
                    };
                    PaymentMethodsFactory.describePaymentMethod(inputObj)
                        .then(function (response) {
                            $scope.paymentMethodObj = response;
                            $scope.isPaymentMethodDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isPaymentMethodDetailsLoaded = true;
                        })
                };

                $scope.fnDeletePaymentMethod = function (paymentMethodObj) {
                    swal({
                            title: "Delete the selected payment method?",
                            text: "You are about to permanently delete the selected payment method.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    methodId: paymentMethodObj.id
                                };
                                PaymentMethodsFactory.deletePaymentMethod(inputObj)
                                    .then(function () {
                                        $scope.$emit('PaymentMethodDeleted', paymentMethodObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitPaymentMethodDetails = function () {
                    $scope.isPaymentMethodDetailsLoaded = false;
                    $scope.paymentMethodId = $scope.paymentMethodObj.id;
                    if ($scope.paymentMethodId) {
                        $scope.fnGetPaymentMethod($scope.paymentMethodId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                var paymentMethodInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.payment_method') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.paymentMethodPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeletePaymentMethod($scope.paymentMethodObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var paymentMethodInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.payment_method') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', paymentMethodInfoKeyDownEventHandler);
                document.addEventListener('keyup', paymentMethodInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', paymentMethodInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', paymentMethodInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('discountInfo', fnDiscountInfo)

    /** @ngInject */
    function fnDiscountInfo($window, $state, $stateParams, $timeout, DB, microSpinner, moment, swal, amaran, DiscountFactory, $uibModal, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/billing/discount/discountInfo/discountInfo.html',
            scope: {
                discountObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);

                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                $scope.accountId = $scope.authUserObj.id.split("-")[0];

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/billing/discount/discountInfo/discountSteps/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetDiscount = function (discountId) {
                    var inputObj = {
                        discountId: discountId
                    };
                    DiscountFactory.describeDiscount(inputObj)
                        .then(function (response) {
                            $scope.discountObj = response;
                            $scope.resetDiscountObj = angular.copy($scope.discountObj);
                            $scope.selectedDateTime = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires))._d : '';
                            response.expires = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires)).format('DD/MM/YYYY HH:mm') : '';
                            $timeout(function () {
                                angular.element('#expiresHiddenInputText').bootstrapMaterialDatePicker({
                                    format: 'DD/MM/YYYY HH:mm',
                                    minDate: new Date()
                                }).on('change', function (e, date) {
                                    $scope.selectedDateTime = date._d;
                                });
                            });
                            $scope.isDiscountDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDiscountDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.discount', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitDiscount = function () {
                    $scope.isDiscountDetailsLoaded = false;
                    $scope.discountId = $scope.discountObj.id;
                    if ($scope.discountId) {
                        // console.log($scope.discountId);
                        $scope.fnGetDiscount($scope.discountId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.discountObj = angular.copy($scope.resetDiscountObj);
                    $scope.isDetailsEditable = false;
                    $scope.selectedDateTime = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires))._d : '';
                    $scope.discountObj.expires = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires)).format('DD/MM/YYYY HH:mm') : '';
                };

                $scope.fnUpdateDiscountDetails = function (discountObj) {
                    var inputObj = {
                        body: {},
                        discountId: discountObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    inputObj.body = {
                        name: discountObj.name,
                        description: discountObj.name,
                        productId: discountObj.productId,
                        percentage: discountObj.percentage,
                        expires: Date.parse($scope.selectedDateTime) / 1000
                    };
                    DiscountFactory.updateDiscount(inputObj)
                        .then(function (response) {
                            $scope.discountObj = response;
                            $scope.resetDiscountObj = angular.copy($scope.discountObj);
                            $scope.selectedDateTime = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires))._d : '';
                            response.expires = $scope.discountObj.expires ? moment.unix(_.cloneDeepWith($scope.discountObj.expires)).format('DD/MM/YYYY HH:mm') : '';
                            $scope.$emit('DiscountDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Discount Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteDiscount = function (discountObj) {
                    swal({
                            title: "Delete the selected discount?",
                            text: "You are about to permanently delete the selected discount.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    discountId: discountObj.id
                                };
                                DiscountFactory.deleteDiscount(inputObj)
                                    .then(function () {
                                        $scope.$emit('DiscountDeleted', discountObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                var groupInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.discount') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteGroup($scope.discountObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var groupInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.discount') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', groupInfoKeyDownEventHandler);
                document.addEventListener('keyup', groupInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', groupInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', groupInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createPaymentMethodCtrl',
            function ($scope, $http, Stripe, $window, $timeout, microSpinner, amaran, swal, PaymentMethodsFactory) {
                var vm = this;
                vm.isRequestNewPaymentMethod = true;

                vm.addressArr = {
                    address: {
                        city: "",
                        country: "",
                        line1: "",
                        line2: "",
                        state: ""
                    },
                    name: ""
                };

                vm.isCardValid = false;
                vm.isRequestProcessing = false;

                var card = "";
                var stripe = "";
                var setupIntent = "";
                var publicKey = "";

                vm.countriesList = [];
                vm.resetStateList = [];
                vm.stateList = [];
                vm.resetCitiesList = [];
                vm.citiesList = [];
                vm.selectedCountry = '';
                vm.selectedState = '';
                vm.selectedCity = '';

                var stripeElements = function (publicKey) {
                    stripe = Stripe(publicKey);
                    var elements = stripe.elements();
                    var ele = document.getElementById('accountDetailsTitle');
                    var color = $window.getComputedStyle(ele).color; //eslint-disable-line*/
                    // Element styles
                    var style = {
                        base: {
                            fontSize: "16px",
                            background: "#fff",
                            iconColor: color,
                            color: color,
                            fontFamily:
                                "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
                            fontSmoothing: "antialiased",
                            "::placeholder": {
                                color: color
                            }
                        }
                    };

                    card = elements.create("card", {style: style, classes: {base: 'ttt'}});

                    card.mount("#card-element");

                    // Element focus ring
                    card.on("focus", function () {
                        var el = document.getElementById("card-element");
                        el.classList.add("focused");
                    });

                    card.on("blur", function () {
                        var el = document.getElementById("card-element");
                        el.classList.remove("focused");
                    });

                    card.on('change', function (event) {
                        var displayError = document.getElementById('card-errors');
                        vm.isCardValid = event.complete === true;
                        if (event.error) {
                            displayError.textContent = event.error.message;
                        } else {
                            displayError.textContent = '';
                        }
                        $scope.$apply();
                    });
                };

                vm.fnPaymentMethod = function () {
                    vm.isRequestProcessing = true;
                    stripe.confirmCardSetup(setupIntent.client_secret, {
                        payment_method: {
                            card: card,
                            billing_details: {
                                name: vm.addressArr.name,
                                address: {
                                    city: vm.addressArr.address.city,
                                    country: vm.addressArr.address.country,
                                    line1: vm.addressArr.address.line1,
                                    line2: vm.addressArr.address.line2,
                                    state: vm.addressArr.address.state
                                }
                            }
                        }
                    }).then(function (result) {
                        if (result.error) {
                            var displayError = document.getElementById("card-errors");
                            displayError.textContent = result.error.message;
                            vm.isRequestProcessing = false;
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                            $timeout(function () {
                                $scope.$apply();
                            })
                        } else {
                            stripe.retrieveSetupIntent(setupIntent.client_secret).then(function (result) {
                                var setupIntent = result.setupIntent;
                                PaymentMethodsFactory.activatePaymentMethod({reference: setupIntent.payment_method})
                                    .then(function () {
                                        $scope.$emit('paymentMethodAdded');
                                        amaran.success("Payment Method added successfully");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                        vm.isRequestProcessing = false;
                                    }, function () {
                                        vm.isRequestProcessing = false;
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            });
                        }
                    });
                };

                vm.fnAddCard = function () {
                    swal({
                            title: "Please Confirm",
                            text: "I authorize ECSite to send instructions to the financial institution that issued my card to take payments from my card account in accordance with the terms and conditions.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Confirm",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                vm.fnPaymentMethod();
                            } else {
                                swal("Cancelled", "Payment Method Creation Cancelled", "error");
                            }
                        });
                };

                vm.fnChangeSelectCountry = function () {
                    vm.stateList = [];
                    vm.citiesList = [];
                    vm.selectedState = '';
                    vm.selectedCity = '';
                    vm.addressArr.address.country = '';
                    vm.addressArr.address.state = '';
                    vm.addressArr.address.city = '';
                };

                vm.fnChangeSelectState = function () {
                    vm.citiesList = [];
                    vm.selectedCity = '';
                    vm.addressArr.address.state = '';
                    vm.addressArr.address.city = '';
                };

                vm.fnChangeSelectCity = function () {
                    vm.addressArr.address.city = '';
                };

                vm.fnSelectCountry = function (selectedCountry) {
                    vm.stateList = [];
                    vm.citiesList = [];
                    vm.selectedState = '';
                    vm.selectedCity = '';
                    vm.selectedCountry = selectedCountry;
                    vm.addressArr.address.country = angular.copy(vm.selectedCountry.sortname);
                    vm.stateList = _.filter(vm.resetStateList, {country_id: vm.selectedCountry.id + ""});
                };

                vm.fnSelectState = function (selectedState) {
                    vm.citiesList = [];
                    vm.selectedCity = '';
                    vm.selectedState = selectedState;
                    vm.addressArr.address.state = angular.copy(vm.selectedState.name);
                    vm.citiesList = _.filter(vm.resetCitiesList, {state_id: vm.selectedState.id + ""});
                };

                vm.fnSelectCity = function (selectedCity) {
                    vm.selectedCity = selectedCity;
                    vm.addressArr.address.city = angular.copy(vm.selectedCity.name);
                };

                vm.fnInitCreatePaymentMethod = function () {
                    vm.isRequestNewPaymentMethod = true;

                    $http.get('assets/json/countryData.json')
                        .then(function (response) {
                            vm.countriesList = response.data.countries;
                            vm.selectedCountry = _.find(vm.countriesList, {name: "United States"});
                        }, function () {
                        });

                    $http.get('assets/json/stateData.json')
                        .then(function (response) {
                            vm.resetStateList = angular.copy(response.data.states);
                            vm.fnSelectCountry(vm.selectedCountry);
                        }, function () {
                        });

                    $http.get('assets/json/cityData.json')
                         .then(function (response) {
                             vm.resetCitiesList = angular.copy(response.data.cities);
                         }, function () {
                         });

                    PaymentMethodsFactory.requestNewPaymentMethod()
                        .then(function (response) {
                            vm.requestTokens = _.cloneDeepWith(response);
                            vm.isRequestNewPaymentMethod = false;
                            $timeout(function () {
                                publicKey = vm.requestTokens.publishableKey;
                                setupIntent = {
                                    'client_secret': vm.requestTokens.clientSecret
                                };
                                stripeElements(publicKey, setupIntent);
                            })
                        }, function () {
                            vm.isRequestNewPaymentMethod = false;
                        })
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('invoiceInfo', fnInvoiceInfo)

    /** @ngInject */
    function fnInvoiceInfo($window, $state, $stateParams, $timeout, microSpinner, moment, swal, amaran,
                           DB, InvoiceFactory, $uibModal, copyService) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/billing/invoice/invoiceInfo/invoiceInfo.html',
            scope: {
                invoiceObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/billing/invoice/invoiceInfo/invoiceSteps/details.html'
                    }, {
                        title: 'Items',
                        tabIndex: 2,
                        templateUrl: 'app/billing/invoice/invoiceInfo/invoiceSteps/invoiceItems/invoiceItems.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.isInvoicePDFLoaded = true;

                $scope.accountId = DB.fnGet('loginUser').id.split("-")[0];

                $scope.fnGetInvoice = function (invoiceId) {
                    var inputObj = {
                        invoiceId: invoiceId
                    };
                    InvoiceFactory.getInvoice(inputObj)
                        .then(function (response) {
                            $scope.invoiceObj = response;
                            response.createdAt = moment.unix(response.createdAt).format("DD MMM YYYY");
                            response.dueDate = moment.unix(response.dueDate).format("DD MMM YYYY");
                            $scope.resetInvoiceObj = angular.copy($scope.invoiceObj);
                            $scope.isInvoiceDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isInvoiceDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.invoice', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateGroupDetails = function (invoiceObj) {
                    var inputObj = {
                        body: {},
                        invoiceId: invoiceObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(invoiceObj.description)) {
                        invoiceObj.description = '';
                    }
                    inputObj.body = {
                        name: invoiceObj.name,
                        description: invoiceObj.description
                    };
                    InvoiceFactory.updateInvoice(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('InvoiceDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Invoice Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitInvoice = function () {
                    $scope.isInvoiceDetailsLoaded = false;
                    $scope.invoiceId = $scope.invoiceObj.id;
                    if ($scope.invoiceId) {
                        // console.log($scope.invoiceId);
                        $scope.fnGetInvoice($scope.invoiceId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnExportPDF = function (invoiceId) {
                    var inputObj = {
                        invoiceId: invoiceId
                    };
                    $scope.isInvoicePDFLoaded = false;
                    InvoiceFactory.getInvoiceAsPdf(inputObj)
                        .then(function (response) {
                            var linkSource = 'data:application/pdf;base64,' + response;
                            var downloadLink = document.createElement("a");
                            var fileName = "invoice.pdf";
                            downloadLink.href = linkSource;
                            downloadLink.download = fileName;
                            downloadLink.click();
                            $scope.isInvoicePDFLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isInvoicePDFLoaded = true;
                        });
                };

                $scope.fnOpenPaymentMethodModal = function (invoiceId) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/billing/invoice/modal/paymentMethod/paymentMethod.html',
                        size: 'lg',
                        controller: 'paymentMethodCtrl as paymentMethod',
                        windowClass: 'modal-height100',
                        resolve: {
                            invoiceId: function () {
                                return invoiceId;
                            }
                        }
                    });
                    modalInstance.result.then(function () { //response
                        $scope.fnInitInvoice();
                    }, function () {
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var groupInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.invoice') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteGroup($scope.invoiceObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var groupInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.invoice') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', groupInfoKeyDownEventHandler);
                document.addEventListener('keyup', groupInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', groupInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', groupInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createDiscountCtrl',
            function ($scope, DB, amaran, TeamFactory, $timeout, AccountFactory, ProductFactory, DiscountFactory, QueryFactory) {
                var vm = this;

                vm.newDiscountObj = {
                    name: '',
                    description: '',
                    productId: '',
                    percentage: '',
                    expires: '',
                    accountId: ''
                };
                vm.selectedDateTime = "";
                vm.isShowCreateDiscountForm = false;
                vm.accountsArr = [];
                vm.productsArr = [{
                    id: 'bp000001',
                    name: 'Node'
                }, {
                    id: 'bp000002',
                    name: 'Pipeline'
                }, {
                    id: 'bp000003',
                    name: 'Tracker'
                }, {
                    id: 'bp000004',
                    name: 'Storage'
                }, {
                    id: 'bp000005',
                    name: 'AI'
                }, {
                    id: 'bp000006',
                    name: 'Insight'
                }];
                vm.selectedAccountObj = '';
                vm.selectedProductObj = '';
                vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                vm.accountId = vm.authUserObj.id.split("-")[0];

                vm.fnCreateNewDiscount = function (newDiscountObj) {
                    vm.isDiscountCreating = true;
                    var inputObj = {
                        accountId: newDiscountObj.accountId,
                        body: {
                            name: newDiscountObj.name,
                            description: newDiscountObj.description,
                            productId: newDiscountObj.productId,
                            percentage: newDiscountObj.percentage
                        }
                    };
                    inputObj.body.expires = Date.parse(vm.selectedDateTime) / 1000;
                    DiscountFactory.createDiscount(inputObj)
                        .then(function (resObj) {
                            vm.isDiscountCreating = false;
                            vm.newDiscountObj = {
                                name: '',
                                description: '',
                                productId: '',
                                percentage: '',
                                expires: '',
                                accountId: ''
                            };
                            vm.selectedDateTime = "";

                            $timeout(function () { // set table height
                                $scope.discount.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('discountAdded', resObj.id);
                            $scope.discount.totalItems = $scope.discount.totalItems + 1;
                            $scope.discount.discountArr.push(resObj);
                            $scope.discount.fnReload();

                            amaran.success("Discount created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDiscountCreating = false;
                        });
                };

                vm.fnInputFocus = function (id) {
                    document.getElementById(id).focus();
                };

                vm.fnAccountSelected = function (selectedAccountObj) {
                    vm.newDiscountObj.accountId = selectedAccountObj.id;
                };

                vm.fnProductSelected = function (selectedProductObj) {
                    vm.newDiscountObj.productId = selectedProductObj.id;
                };

                vm.fnGetProducts = function (inputObj, preDefinedProducts, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var products = isCalledForViz ? preDefinedProducts : [];
                            _.forEach(res.data, function (productObj) {
                                products.push(productObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (products[0] && products[0].totalItems > products.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM billing_products';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + products[products.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProducts({sql: sqlString}, products, true);
                            } else {
                                vm.productsArr = products;
                                vm.isShowCreateDiscountForm = true;
                                $timeout(function () {
                                    angular.element('#expiresHiddenInputText').bootstrapMaterialDatePicker({
                                        format: 'DD/MM/YYYY HH:mm',
                                        minDate: new Date()
                                    }).on('change', function (e, date) {
                                        vm.selectedDateTime = date._d;
                                    });
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAccounts = function (inputObj, preDefinedAccounts, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var accounts = isCalledForViz ? preDefinedAccounts : [];
                            _.forEach(res.data, function (accountObj) {
                                accounts.push(accountObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (accounts[0] && accounts[0].totalItems > accounts.length)) {
                                var sqlString = "SELECT *, data->>'\_id\' AS rt FROM access_accounts";
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + accounts[accounts.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAccounts({sql: sqlString}, accounts, true);
                            } else {
                                vm.accountsArr = accounts;
                                var productSqlString = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM billing_products ORDER BY rt asc LIMIT ' + 100 + ';';
                                vm.fnGetProducts({sql: productSqlString}, [], false);
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnInitCreateDiscount = function () {
                    vm.isShowCreateDiscountForm = false;
                    if (vm.accountId === 'cu000000') {
                        var sqlString = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_accounts ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetAccounts({sql: sqlString}, [], false);
                    } else {
                        vm.isShowCreateDiscountForm = true;
                        $timeout(function () {
                            angular.element('#expiresHiddenInputText').bootstrapMaterialDatePicker({
                                format: 'DD/MM/YYYY HH:mm',
                                minDate: new Date()
                            }).on('change', function (e, date) {
                                vm.selectedDateTime = date._d;
                            });
                        });
                    }
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('creditTokenInfo', fnCreditTokenInfo)

    /** @ngInject */
    function fnCreditTokenInfo($window, $state, $stateParams, $uibModal, $timeout, microSpinner, moment, swal, amaran, CreditTokenFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/billing/credit_token/credit_tokenInfo/credit_tokenInfo.html',
            scope: {
                creditTokenObj: '=',
                accountId: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/billing/credit_token/credit_tokenInfo/credit_tokenSteps/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetCreditToken = function (creditTokenId) {
                    var inputObj = {
                        tokenId: creditTokenId
                    };
                    if ($stateParams.type && $stateParams.type === "unclaimed") {
                        CreditTokenFactory.describeUnclaimedCreditToken(inputObj)
                            .then(function (response) {
                                $scope.creditTokenObj = response;
                                $scope.creditTokenObj.startsDate = response.startsAt ? moment.unix(response.startsAt).format("DD/MM/YYYY HH:mm:ss") : "";
                                $scope.creditTokenObj.expiresDate = response.expiresAt ? moment.unix(response.expiresAt).format("DD/MM/YYYY HH:mm:ss") : "";
                                $scope.creditTokenObj.createdDate = response.createdAt ? moment.unix(response.createdAt).format("DD/MM/YYYY HH:mm:ss") : "";
                                $scope.resetCreditTokenObj = angular.copy($scope.creditTokenObj);
                                if (angular.isUndefined($scope.creditTokenObj.description)) {
                                    $scope.creditTokenObj.description = '';
                                }
                                $scope.isCreditTokenDetailsLoaded = true;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                $scope.isCreditTokenDetailsLoaded = true;
                            })
                    } else {
                        CreditTokenFactory.describeClaimedCreditToken(inputObj)
                            .then(function (response) {
                                $scope.creditTokenObj = response;
                                $scope.creditTokenObj.startsDate = response.startsAt ? moment.unix(response.startsAt).format("DD/MM/YYYY HH:mm:ss") : "";
                                $scope.creditTokenObj.claimedDate = response.claimedAt ? moment.unix(response.claimedAt).format("DD/MM/YYYY HH:mm:ss") : "";
                                $scope.resetCreditTokenObj = angular.copy($scope.creditTokenObj);
                                if (angular.isUndefined($scope.creditTokenObj.description)) {
                                    $scope.creditTokenObj.description = '';
                                }
                                $scope.isCreditTokenDetailsLoaded = true;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                $scope.isCreditTokenDetailsLoaded = true;
                            })
                    }
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.credit_token', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnDeleteCreditToken = function (creditTokenObj) {
                    swal({
                            title: "Delete the selected Credit Token?",
                            text: "You are about to permanently delete the selected Credit Token.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    tokenId: creditTokenObj.id
                                };
                                CreditTokenFactory.deleteUnclaimedCreditToken(inputObj)
                                    .then(function () {
                                        $scope.$emit('CreditTokenDeleted', creditTokenObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnSendCreditToken = function (creditTokenId) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/billing/credit_token/modal/sendCreditToken/sendCreditToken.html',
                        size: 'md',
                        controller: 'sendCreditTokenCtrl as sendCreditToken',
                        resolve: {
                            creditTokenId: function () {
                                return creditTokenId;
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitCreditToken = function () {
                    $scope.isCreditTokenDetailsLoaded = false;
                    $scope.type = $stateParams.type;
                    $scope.creditTokenId = $scope.creditTokenObj.id;
                    if ($scope.creditTokenId) {
                        $scope.fnGetCreditToken($scope.creditTokenId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var groupInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.credit_token') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteGroup($scope.creditTokenObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var groupInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.credit_token') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', groupInfoKeyDownEventHandler);
                document.addEventListener('keyup', groupInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', groupInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', groupInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createCreditTokenCtrl',
            function ($scope, amaran, CreditTokenFactory, QueryFactory, $timeout, $log) {
                var vm = this;

                vm.title = "Create Credit Token";
                vm.newCreditTokenObj = {
                    "name": "",
                    "description": "",
                    "starts": '',
                    "expires": '',
                    "currency": "USD",
                    "amount": 0,
                    "transactionMax": '',
                    "transactionMin": '',
                    "productIds": []
                };
                vm.selectedProductsArr = [];
                vm.predefineProductsArr = [{
                    id: 'bp000001',
                    name: 'Node Product'
                }, {
                    id: 'bp000002',
                    name: 'Pipeline Product'
                }, {
                    id: 'bp000003',
                    name: 'Tracker Product'
                }, {
                    id: 'bp000004',
                    name: 'Storage Product'
                }, {
                    id: 'bp000005',
                    name: 'AI Product'
                }, {
                    id: 'bp000006',
                    name: 'Insight Product'
                }, {
                    id: 'bp000007',
                    name: 'VPN Product'
                }, {
                    id: 'bp000008',
                    name: 'Support Product'
                }];
                vm.isShowCreateForm = false;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields needed for products
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedData.description;

                                // Ensure numeric fields are properly parsed
                                if (angular.isDefined(parsedData.amount)) {
                                    parsedItem.amount = parseInt(parsedData.amount) || 0;
                                }
                                if (angular.isDefined(parsedData.transactionMax)) {
                                    parsedItem.transactionMax = parseInt(parsedData.transactionMax) || 0;
                                }
                                if (angular.isDefined(parsedData.transactionMin)) {
                                    parsedItem.transactionMin = parseInt(parsedData.transactionMin) || 0;
                                }

                                // Merge remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing product data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnCreateNewCreditToken = function (newCreditTokenObj) {
                    vm.isCreditTokenCreating = true;
                    var inputObj = {
                        body: {
                            name: newCreditTokenObj.name,
                            description: newCreditTokenObj.description,
                            amount: 100 * newCreditTokenObj.amount,
                            currency: "USD",
                            transactionMax: newCreditTokenObj.transactionMax,
                            transactionMin: newCreditTokenObj.transactionMin
                        }
                    };
                    inputObj.body.starts = Date.parse(vm.startsCreditTokenInput) / 1000;
                    inputObj.body.expires = Date.parse(vm.expiresCreditTokenInput) / 1000;
                    inputObj.body.productIds = [];
                    _.forEach(vm.selectedProductsArr, function (productObj) {
                        inputObj.body.productIds.push(productObj.id);
                    });

                    CreditTokenFactory.createUnclaimedCreditToken(inputObj)
                        .then(function (resObj) {
                            vm.isCreditTokenCreating = false;
                            $scope.creditTokens.fnHideShowCreateForm();

                            vm.newCreditTokenObj = {
                                "name": "",
                                "description": "",
                                "starts": '',
                                "expires": '',
                                "currency": "USD",
                                "amount": 0,
                                "transactionMax": '',
                                "transactionMin": '',
                                "productIds": []
                            };
                            $timeout(function () {
                                $scope.creditTokens.fnSetTableHeight();
                            }, 800);
                            $scope.$emit('creditTokenAdded', resObj.id);
                            $scope.creditTokens.totalItems = $scope.creditTokens.totalItems + 1;

                            // Parse the response before adding to array
                            var parsedToken = parsePostgresData([resObj])[0];
                            $scope.creditTokens.creditTokensArr.push(parsedToken);

                            $scope.creditTokens.fnReload();
                            amaran.success("Credit Token created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isCreditTokenCreating = false;
                        });
                };

                vm.fnCreateArrayTag = function (arrValue, id) {
                    if (arrValue) {
                        if (angular.isString(arrValue)) {
                            var strFlag = false;
                            angular.forEach(vm.selectedProductsArr, function (obj) {
                                if (obj.id === arrValue) {
                                    strFlag = true;
                                }
                            });

                            if (!strFlag) {
                                vm.selectedProductsArr.push({
                                    id: arrValue,
                                    name: arrValue
                                });
                                vm.selectedProductObj = "";
                                angular.element('#' + id).blur();
                            } else {
                                amaran.error('Value already present. Please enter a different Value.');
                            }
                        } else {
                            var flag = false;
                            angular.forEach(vm.selectedProductsArr, function (obj) {
                                if (obj.id === arrValue.id) {
                                    flag = true;
                                }
                            });

                            if (!flag) {
                                vm.selectedProductsArr.push(angular.copy(arrValue));
                                vm.selectedProductObj = "";
                                angular.element('#' + id).blur();
                            } else {
                                amaran.error('Value already present. Please enter a different Value.');
                            }
                        }
                    }
                };

                vm.fnRemoveArrayTag = function (index) {
                    vm.selectedProductsArr.splice(index, 1);
                };

                vm.fnGetProducts = function (inputObj, preDefinedProducts, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            var products = isCalledForViz ? preDefinedProducts : [];

                            // Parse the PostgreSQL response
                            var parsedData = parsePostgresData(res.data);

                            _.forEach(parsedData, function (accountObj) {
                                products.push(accountObj);
                            });

                            if ((parsedData && parsedData.length && parsedData.length > 0) &&
                                (products[0] && products[0].totalItems > products.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM billing_products';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + products[products.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProducts({sql: sqlString}, products, true);
                            } else {
                                vm.productsArr = products;
                                vm.productsArr.push.apply(vm.productsArr, vm.predefineProductsArr);
                                vm.isShowCreateForm = true;

                                $timeout(function () {
                                    angular.element('#expiresCreditTokenInput').bootstrapMaterialDatePicker({
                                        format: 'DD/MM/YYYY HH:mm',
                                        minDate: new Date()
                                    }).on('change', function (e, date) {
                                        vm.expiresCreditTokenInput = date._d;
                                        angular.element('#startsCreditTokenInput').bootstrapMaterialDatePicker('setMaxDate', date);
                                    });

                                    angular.element('#startsCreditTokenInput').bootstrapMaterialDatePicker({
                                        format: 'DD/MM/YYYY HH:mm',
                                        minDate: new Date()
                                    }).on('change', function (e, date) {
                                        vm.startsCreditTokenInput = date._d;
                                        angular.element('#expiresCreditTokenInput').bootstrapMaterialDatePicker('setMinDate', date);
                                    });
                                });
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnInitCreateCreditToken = function () {
                    vm.isShowCreateForm = false;
                    var sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_products ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetProducts({sql: sqlString}, [], false);
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('inputoutputModelCtrl',
            function ($uibModalInstance, $http, $scope, $window, $timeout, $stateParams, $state, $uibModal, moment, amaran, swal, microSpinner, DB, Authenticate, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, FileFactory, FolderFactory, pathType, extensionType) {
                var vm = this;
                vm.draftName = '';
                vm.pathType = pathType;
                vm.extensionType = extensionType;
                vm.archiveFileExtensionArr = ['zip', 'z', 'gz', 'tar', 'rpm', 'rar', 'pkg', 'deb', 'arj', '7z'];
                vm.programmingFileExtensionArr = ['sql', 'xml', 'db', 'apk', 'bat', 'bin', 'com', 'exe', 'jar', 'wsf', 'py', 'asp', 'aspx', 'css', 'htm', 'html', 'js', 'jsp', 'part', 'php', 'rss', 'xhtml', 'c', 'class', 'cpp', 'cs', 'h', 'java', 'sh', 'swift', 'vb', 'less', 'json'];
                vm.audioFileExtensionArr = ['aif', 'cda', 'mid', 'midi', 'mp3', 'mpa', 'ogg', 'wav', 'wma', 'wpl'];
                vm.videoFileExtensionArr = ['3g2', '3gp', 'h264', 'm4v', 'mkv', 'avi', 'flv', 'wmv', 'mov', 'mp4', 'mpg', 'mpeg', 'rm', 'swf', 'vob'];
                vm.imageFileExtensionArr = ['ai', 'bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'ps', 'psd', 'svg', 'tif', 'tiff'];
                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "Path",
                        fieldName: "path"
                    }
                ];
                vm.filterQuery = [];

                //Listener Variables
                vm.isFoldersLoading = false;
                vm.isShowFileDetails = false;
                vm.folderArr = [];
                vm.selectedFoldersArr = [];
                vm.selectedFolderObj = null;
                vm.selectedFunction = '';
                vm.breadcrumbArray = [];
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.currentPath = $stateParams.path ? $stateParams.path : '/';
                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isFoldersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "SEARCH",
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "LIST",
                            path: vm.currentPath
                        };
                    }
                    vm.selectedFunction = inputObj.function;
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.selectedFolderObj = null;
                    vm.isAllChecked = false;
                    if (vm.contentPermissionObj.List) {
                        vm.fnGetFolders(inputObj);
                    } else {
                        vm.folderArr = [];
                        vm.isFoldersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 110);

                        angular.element("#storageModalTable tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 90);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetFolders = function (inputObj) {
                    FolderFactory.getContents(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.contents;
                            res.map(function (obj) {
                                if (obj.path.slice(-1) === "/") {
                                    var folderName = obj.path.split('/');
                                    obj.name = folderName[folderName.length - 2];
                                    obj.icon = "fa-folder-open";
                                    obj.lastUpdate = "-";
                                    obj.fileSize = "-";
                                    obj.type = "folder";
                                } else {
                                    var fileName = obj.path.split('/');
                                    obj.name = fileName[fileName.length - 1];
                                    var extension = obj.name.split('.')[obj.name.split('.').length - 1];
                                    if (extension === "pdf") {
                                        obj.icon = "fa-file-pdf-o";
                                    } else if (_.includes(vm.programmingFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-code-o";
                                    } else if (_.includes(vm.audioFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-audio-o";
                                    } else if (_.includes(vm.videoFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-video-o";
                                    } else if (_.includes(vm.imageFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-image-o";
                                    } else if (extension === "xlsx" || extension === "xls") {
                                        obj.icon = "fa-file-excel-o";
                                    } else if (extension === "pptx" || extension === "ppt") {
                                        obj.icon = "fa-file-powerpoint-o";
                                    } else if (extension === "txt") {
                                        obj.icon = "fa-file-text-o";
                                    } else if (extension === "docx" || extension === "doc") {
                                        obj.icon = "fa-file-word-o";
                                    } else if (_.includes(vm.archiveFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-archive-o";
                                    } else {
                                        obj.icon = "fa-file-o";
                                    }
                                    obj.lastUpdate = moment(obj.lastModified).utc()._d;
                                    obj.fileSize = bytesToSize(obj.size);
                                    obj.type = "file";
                                }
                            });
                            vm.folderArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckHeader = function (folderObj) {
                    angular.forEach(vm.folderArr, function (obj) {
                        obj.isCheck = false;
                    });
                    folderObj.isCheck = true;
                    vm.selectedFolderObj = folderObj;
                };

                vm.fnGetFolder = function (folderObj) {
                    if (folderObj.type === "file") {
                        vm.fnCheckUncheckHeader(folderObj);
                    } else {
                        vm.breadcrumbArray.push(folderObj.name);
                        vm.currentPath = vm.currentPath + folderObj.name + "/";
                        $timeout(function () {
                            vm.fnReload();
                        }, 100)
                    }
                };

                vm.fnCheckFileFolder = function (folderObj) {
                    if (vm.pathType === 'folder') {
                        if (vm.pathType === folderObj.type) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        if (vm.extensionType !== '') {
                            if (vm.pathType === 'file' && folderObj.name.includes(vm.extensionType)) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            if (vm.pathType === folderObj.type) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery,
                            function: vm.selectedFunction
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            function: vm.selectedFunction
                        };
                    }

                    if (vm.selectedFunction === 'LIST') {
                        vm.inputObj.path = vm.currentPath;
                    }
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetFolders(vm.inputObj);
                };

                vm.fnGetPath = function (pathName, $index) {
                    vm.currentPath = '';
                    //var index =  vm.breadcrumbArray.indexOf(pathName);
                    vm.breadcrumbArray.splice($index + 1, vm.breadcrumbArray.length - 1);
                    angular.forEach(vm.breadcrumbArray, function (breadCrumbName) {
                        vm.currentPath = vm.currentPath + breadCrumbName;
                        if (breadCrumbName !== "/") {
                            vm.currentPath = vm.currentPath + "/";
                        }
                    });
                    $timeout(function () {
                        vm.fnReload();
                    }, 100)
                };
                /*END: TABLE*/
                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.contentPermissionObj.List = false;
                    $timeout(function () {
                        vm.contentPermissionObj.List = true;
                    }, 10)
                };

                function bytesToSize(bytes) {
                    var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
                    if (bytes === 0) {
                        return 'n/a';
                    }
                    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                    if (i === 0) {
                        return bytes + ' ' + sizes[i];
                    }
                    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
                }

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function (folderObj) {
                    $uibModalInstance.close(folderObj);
                };


                vm.fnInitModel = function () {
                    vm.folderPermissionObj = PermissionsService.getPermissions("storage:folder");
                    vm.filePermissionObj = PermissionsService.getPermissions("storage:file");
                    vm.contentPermissionObj = PermissionsService.getPermissions("storage:content");// list permission List:"TRUE"
                    if (vm.currentPath === '/') {
                        vm.breadcrumbArray = ["/"];
                    } else {
                        vm.breadcrumbArray = ["/"];
                        var tempArr = vm.currentPath.split("/");
                        angular.forEach(tempArr, function (path) {
                            if (path.length) {
                                vm.breadcrumbArray.push(path);
                            }
                        })
                    }
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('trainerInfo', fnTrainerInfo)

    /** @ngInject */
    function fnTrainerInfo($window, $state, $timeout, $stateParams, $uibModal, microSpinner, swal, amaran, DB, copyService, ColorService, PermissionsService, TrainerFactory, AlgorithmFactory, VmFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/ai/trainer/trainerInfo/trainerInfo.html',
            scope: {
                trainerObj: '=',
                trainerPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/ai/trainer/trainerInfo/trainerTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isUpdateCompleted = true;
                $scope.isTrainerProcessOnGoing = false;

                $scope.fnGetVm = function (vmId) {
                    var inputObj = {
                        vmId : vmId
                    };
                    VmFactory.getVm(inputObj)
                        .then(function (response) {
                            $scope.trainerObj.trainingVmName = response.name;
                            $scope.isTrainerDetailsLoaded = true;
                        }, function () {
                            $scope.trainerObj.trainingVmName = '';
                            $scope.isTrainerDetailsLoaded = true;
                        })
                };

                $scope.fnGetAlgorithm = function (algorithmId) {
                    var inputObj = {
                        algorithmId : algorithmId
                    };
                    AlgorithmFactory.getAlgorithm(inputObj)
                        .then(function (response) {
                            $scope.trainerObj.algorithmName = response.name;
                            $scope.fnGetVm($scope.trainerObj.trainingVmId);
                        }, function () {
                            $scope.trainerObj.algorithmName = '';
                            $scope.fnGetVm($scope.trainerObj.trainingVmId);
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.trainer', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };
                $scope.fnGetTrainer = function (trainerId) {
                    var inputObj = {
                        trainerId: trainerId
                    };
                    TrainerFactory.getTrainer(inputObj)
                        .then(function (response) {
                            $scope.trainerObj = response;
                            $scope.fnGetAlgorithm($scope.trainerObj.algorithmId);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isTrainerDetailsLoaded = true;
                        })
                };


                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetTrainerStatusIcon = function (status) {
                    var icon = "";
                    switch(status) {
                        case "PENDING":
                            icon = "fa-clock-o";
                            break;
                        case "IN_PROGRESS":
                            icon = "fa-hourglass-half";
                            break;
                        case "FAILED":
                            icon = "fa-times-circle";
                            break;
                        case "COMPLETED":
                            icon = "fa-check";
                            break;
                        case "DELETED":
                            icon = "fa-trash";
                            break;
                        case "STOPPING":
                            icon = "fa-close";
                            break;
                        case "STOPPED":
                            icon = "fa-ban";
                            break;
                        case "STARTED":
                            icon = "fa-gears";
                            break;
                        case "DOWNLOADING":
                            icon = "fa-download";
                            break;
                        case "TRAINING":
                            icon = "fa-empire";
                            break;
                        case "UPLOADING":
                            icon = "fa-upload";
                            break;
                    }
                    return icon;
                };

                $scope.fnGetTrainerStatusIconColor = function (status) {
                    return ColorService.getTrainerStatusColor(status);
                };

                $scope.fnOpenCreateFromTrainerModel = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/ai/trainer/modals/createMedalFromTrainer/createModelFromTrainer.html',
                        size: 'lg',
                        controller: 'createModelFromTrainerModalCtrl as createModel',
                        resolve: {
                            trainerObj: function () {
                                return $scope.trainerObj;
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                        amaran.success('Model Created Successfully')
                    }, function () {

                    });
                };

                $scope.fnStopTrainer = function () {
                    $scope.isTrainerProcessOnGoing = true;
                    var inputObj = {
                        trainerId:  $scope.trainerObj.id
                    };
                    TrainerFactory.stopTrainer(inputObj)
                        .then(function () {
                            $scope.isTrainerProcessOnGoing = false;
                            amaran.success("Request for stop Trainer is made successfully")
                        })
                };

                $scope.fnDeleteTrainer = function (trainerObj) {
                    swal({
                            title: "Delete the selected trainer?",
                            text: "You are about to permanently delete the selected trainer.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    trainerId: trainerObj.id
                                };
                                TrainerFactory.deleteTrainer(inputObj)
                                    .then(function () {
                                        $scope.$emit('trainerDeleted', trainerObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnCloneTrainer = function (trainerObj) {
                    $scope.$emit('cloneTrainer', trainerObj);
                };

                $scope.fnInitTrainer = function () {
                    $scope.modelPermissionObj = PermissionsService.getPermissions("ai:model");
                    $scope.isTrainerDetailsLoaded = false;
                    $scope.trainerId = $scope.trainerObj.id;
                    if ($scope.trainerId) {
                        $scope.fnGetTrainer($scope.trainerId);
                    }
                    $scope.fnSetTabHeight();
                };

                var trainerInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.trainer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.trainerPermissionsObj.Delete &&
                                ($scope.trainerObj.status === 'COMPLETED' || $scope.trainerObj.status === 'FAILED') &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteTrainer($scope.trainerObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var trainerInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.trainer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', trainerInfoKeyDownEventHandler);
                document.addEventListener('keyup', trainerInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', trainerInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', trainerInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createModelCtrl',
            function ($scope, $window, $uibModal, amaran, PermissionsService, AlgorithmFactory, TrainerFactory, ModelFactory) {
                var vm = this;
                vm.title = "Create Model";
                vm.newModelObj = {
                    name: '',
                    description: '',
                    algorithmId: '',
                    artifactPath: ''
                };
                var resetModelObj = angular.copy(vm.newModelObj);
                vm.isAlgorithmsFetched = false;
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnAlgorithmSelected = function (algorithmObj) {
                    vm.newModelObj.algorithmId = algorithmObj.id;
                };

                vm.fnCreateNewModel = function (newModelObj) {
                    vm.isModelCreating = true;
                    var inputObj = {
                        body: newModelObj
                    };
                    ModelFactory.createModel(inputObj)
                        .then(function (response) {
                            vm.isModelCreating = false;
                            $scope.model.fnHideShowCreateForm(); //parent function
                            vm.newModelObj = angular.copy(resetModelObj);
                            $scope.$emit('modelAdded', response.id);
                            if($scope.model.modelPermissionObj.List){
                                $scope.model.totalItems = $scope.model.totalItems + 1;
                                $scope.model.modelsArr.push(response);
                                $scope.model.fnReload();
                            }
                            amaran.success("Model is successfully created");
                        }, function () {
                            vm.isModelCreating = false;
                        })
                };

                vm.fnAddStorageOutputPath = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/ai/trainer/modals/inputoutputModel.html',
                        size: 'lg',
                        controller: 'inputoutputModelCtrl as inputOutputPathModel',
                        windowClass: 'modal-height100',
                        resolve: {
                            pathType: function () {
                                return 'file';
                            },
                            extensionType: function () {
                                return '.tar.gz'
                            }
                        }
                    });
                    modalInstance.result.then(function (folderObj) {
                        vm.newModelObj.artifactPath = folderObj.path;
                    }, function () {

                    });
                };
                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitCreateModelFromTrainer = function () {
                    var inputObj = {
                        filter: "#{status} = ${COMPLETED}"
                    };
                    TrainerFactory.getTrainers(inputObj)
                        .then(function (response) {
                            vm.trainersArr = response;
                            vm.fnInitCreateModel();
                        });
                    vm.fnSetTableHeight();
                };

                vm.fnSelectTrainer = function (selectedTrainerObj) {
                    vm.newModelObj.algorithmId = selectedTrainerObj.algorithmId;
                    vm.selectedAlgorithm = _.find(vm.algorithmsArr, {'id': selectedTrainerObj.algorithmId});
                    var url = HOST_URL.ai.split("https://")[1]; //eslint-disable-line
                    var stage;
                    if (url.startsWith('dev')) {
                        stage = 'dev';
                    } else {
                        stage = 'pro'
                    }
                    vm.newModelObj.artifactPath = selectedTrainerObj.outputPath + stage + "-" + selectedTrainerObj.id + "/output/model.tar.gz";
                };

                vm.fnInitCreateModel = function () {
                    vm.contentPermissionObj = PermissionsService.getPermissions("storage:content");
                    vm.isAlgorithmsFetched = false;
                    AlgorithmFactory.getAlgorithms()
                        .then(function (response) {
                            vm.algorithmsArr = response;
                            vm.isAlgorithmsFetched = true;
                        }, function () {
                            vm.isAlgorithmsFetched = true;
                        });
                    vm.fnSetTableHeight();
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createTrainerCtrl',
            function ($scope, $window, $uibModal, amaran, DB, PermissionsService, TrainerFactory, AlgorithmFactory, VmFactory) {
                var vm = this;
                vm.title = "Create Trainer";
                vm.newTrainerObj = {
                    name: '',
                    algorithmId: '',
                    parameters: {},
                    branches:[],
                    outputPath: '',
                    trainingVmId: '',
                    trainingVmCount: 1,
                    trainingMaxTime: 3600,
                    trainingVmDriveSize: 50
                };
                var resetTrainerObj = angular.copy(vm.newTrainerObj);
                vm.clonedTrainerObj = {};
                vm.selectedAlgorithm = '';
                vm.selectedVmObj = '';
                vm.isCreateFormLoading = false;
                vm.isParameterFormValidated = true;
                vm.isTrainerCreating = false;

                /*Branches*/
                vm.algorithmRequiredBranches=[];
                vm.algorithmOptionalBranches=[];
                vm.algorithmFormats =[];
                vm.algorithmCompression=[];
                vm.algorithmSharding=[];

                /*Vm*/
                vm.vmTrainingCountErrorMessage = '';
                var vmMinQuantity = 1;
                var vmMaxQuantity = '';

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnResetVm = function (type) {
                    if(type === 'algo') {
                        vm.newTrainerObj.algorithmId = '';
                        vm.algorithmFormats = [];
                        vm.algorithmRequiredBranches = [];
                        vm.algorithmOptionalBranches = [];
                        /*VM clear*/
                        vm.selectedVmObj = '';
                        vm.newTrainerObj.trainingVmId = "";
                        vm.newTrainerObj.trainingVmCount = 1;
                        vm.vmTrainingCountErrorMessage = '';
                    }
                    vm.newTrainerObj.trainingVmId = "";
                    vm.newTrainerObj.trainingVmCount = 1;
                    vm.vmTrainingCountErrorMessage = '';
                };

                vm.fnCheckRequiredBranches = function () {
                    var flag = false;
                    angular.forEach(vm.algorithmRequiredBranches, function (branchObj) {
                        if(!branchObj.name || !branchObj.format || !branchObj.compression ||
                            !branchObj.sharding || !branchObj.inputPath) {
                            flag = true;
                        }
                    });
                    return flag;
                };

                vm.fnCheckVmSettingValidation = function () {
                    var flag = false;
                    if((!vm.newTrainerObj.trainingVmId || !vm.newTrainerObj.trainingVmId.length) || vm.vmTrainingCountErrorMessage.length ||
                        !vm.newTrainerObj.trainingMaxTime || !vm.newTrainerObj.trainingVmDriveSize || !vm.newTrainerObj.trainingVmCount) {
                        flag = true;
                    }
                    return flag;
                };

                vm.fnCheckTrainerValidation = function () {
                    var flag = false;
                    if((!vm.newTrainerObj.name || !vm.newTrainerObj.name.length) ||
                        (!vm.newTrainerObj.algorithmId || !vm.newTrainerObj.algorithmId.length)  || !vm.isParameterFormValidated ||
                        (!vm.newTrainerObj.trainingVmId || !vm.newTrainerObj.trainingVmId.length) || vm.vmTrainingCountErrorMessage.length ||
                        !vm.newTrainerObj.trainingMaxTime || !vm.newTrainerObj.trainingVmDriveSize || !vm.newTrainerObj.trainingVmCount) {
                        flag = true;
                    }
                    angular.forEach(vm.algorithmRequiredBranches, function (branchObj) {
                        if(!branchObj.name || !branchObj.format || !branchObj.compression ||
                            !branchObj.sharding || !branchObj.inputPath) {
                            flag = true;
                        }
                    });
                    return flag;
                };

                vm.fnCreateTrainer = function (trainerObj) {
                    vm.isTrainerCreating = true;
                    trainerObj.branches = [];
                    var algorithmRequiredBranches = angular.copy(vm.algorithmRequiredBranches);
                    var algorithmOptionalBranches = angular.copy(vm.algorithmOptionalBranches);

                    angular.forEach(algorithmRequiredBranches, function (branchObj) {
                        delete branchObj.open;
                        if(branchObj.name.length && branchObj.format.length && branchObj.compression.length &&
                            branchObj.sharding.length && branchObj.inputPath.length) {
                            trainerObj.branches.push(branchObj);
                        }
                    });
                    angular.forEach(algorithmOptionalBranches, function (branchObj) {
                        delete branchObj.open;
                        if(branchObj.name.length && branchObj.format.length && branchObj.compression.length &&
                            branchObj.sharding.length && branchObj.inputPath.length) {
                            trainerObj.branches.push(branchObj);
                        }
                    });
                    if(angular.isUndefined(trainerObj.outputPath)) {
                        trainerObj.outputPath = ''
                    }
                    var inputObj = {
                        body: trainerObj
                    };
                    TrainerFactory.createTrainer(inputObj)
                        .then(function (response) {
                            vm.isTrainerCreating = false;
                            $scope.trainer.fnHideShowCreateForm(); //parent function
                            vm.newTrainerObj = angular.copy(resetTrainerObj);
                            $scope.$emit('trainerAdded', response.id);
                            if($scope.trainer.trainerPermissionObj.List){
                                $scope.trainer.totalItems = $scope.trainer.totalItems + 1;
                                $scope.trainer.trainersArr.push(response);
                                $scope.trainer.fnReload();
                            }
                            amaran.success("Trainer created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTrainerCreating = false;
                        })
                };

                vm.fnCheckParameterFormValidation = function (isValidate, parametersObj) {
                    vm.isParameterFormValidated = isValidate;
                    if(Object.keys(parametersObj).length) {
                        vm.newTrainerObj.parameters = parametersObj;
                    } else {
                        vm.newTrainerObj.parameters = {};
                    }
                };

                vm.fnChangeVmCount = function (trainingVmCount) {
                    if(vmMaxQuantity === '') {
                        if(trainingVmCount < vmMinQuantity) {
                            vm.vmTrainingCountErrorMessage = 'The Virtual Machine quantity for trainer cannot be less than ' + vmMinQuantity;
                        } else {
                            vm.vmTrainingCountErrorMessage = '';
                        }
                    } else {
                        if(trainingVmCount < vmMinQuantity || trainingVmCount > vmMaxQuantity) {
                            vm.vmTrainingCountErrorMessage = 'The Virtual Machine quantity for trainer should be between ' + vmMinQuantity + 'and ' + vmMaxQuantity;
                        } else {
                            vm.vmTrainingCountErrorMessage = '';
                        }
                    }
                };

                vm.fnVmsSelected = function (vmsObj) {
                    vm.newTrainerObj.trainingVmId = vmsObj.id;
                    if(vmsObj.cpu > 1){
                        vmMaxQuantity = '';
                    }else {
                        if(vmsObj.gpu > 1){
                            vmMaxQuantity = '';
                        }else{
                            vmMaxQuantity = 1;
                        }
                    }
                };

                vm.fnSetVmOptions = function (algorithmObj) {
                    vm.algoVmsArr = [];
                    var vmSupportsArr = algorithmObj.vmSupport;
                    vm.vmsArr.map(function (obj) {
                        if (vmSupportsArr.multiCPU === true) {
                            if (obj.cpu >= 0) {
                                if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                    vm.algoVmsArr.push(obj);
                                }
                            }
                        } else {
                            if (vmSupportsArr.singleCPU === true) {
                                if (obj.cpu <= 1) {
                                    if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                        vm.algoVmsArr.push(obj);
                                    }
                                }
                            }
                        }
                        if (vmSupportsArr.multiGPU === true) {
                            if (obj.gpu >= 0) {
                                if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                    vm.algoVmsArr.push(obj);
                                }
                            }
                        } else {
                            if (vmSupportsArr.singleGPU === true) {
                                if (obj.gpu <= 1) {
                                    if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                        vm.algoVmsArr.push(obj);
                                    }
                                }
                            }
                        }
                    });
                };

                vm.fnSelectAlgorithm = function (selectedAlgorithm) {
                    vm.newTrainerObj.algorithmId = selectedAlgorithm.id;
                    vm.algorithmFormats = selectedAlgorithm.formats;
                    vm.algorithmCompression = ["GZIP","NONE"];
                    vm.algorithmSharding = ["EVEN_SPLIT","NONE"];
                    vm.algorithmRequiredBranches = [];
                    vm.algorithmOptionalBranches = [];
                    angular.forEach(selectedAlgorithm.requiredBranches, function (branchName) {
                        var inputObj = {
                            name: branchName,
                            format: "",
                            compression: "",
                            sharding: "",
                            inputPath: ""
                        };
                        vm.algorithmRequiredBranches.push(inputObj);
                    });
                    angular.forEach(selectedAlgorithm.optionalBranches, function (branchName) {
                        var inputObj = {
                            name: branchName,
                            format: "",
                            compression: "",
                            sharding: "",
                            inputPath: ""
                        };
                        vm.algorithmOptionalBranches.push(inputObj);
                    });
                    vm.fnSetVmOptions(selectedAlgorithm);
                };

                vm.fnAddStoragePath = function (branchesObj, pathType) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/ai/trainer/modals/inputoutputModel.html',
                        size: 'lg',
                        controller: 'inputoutputModelCtrl as inputOutputPathModel',
                        windowClass: 'modal-height100',
                        resolve: {
                            pathType: function () {
                                return pathType;
                            },
                            extensionType: function () {
                                return ''
                            }
                        }
                    });

                    modalInstance.result.then(function (fileObj) {
                        if(pathType === 'file') {
                            branchesObj.inputPath = fileObj.path;
                        } else {
                            branchesObj.outputPath = fileObj.path;
                        }
                    }, function () {

                    });

                };

                vm.fnSetUpClonedTrainer = function (clonedTrainerObj) {
                    vm.newTrainerObj.name = clonedTrainerObj.name;
                    vm.selectedAlgorithm = _.find(vm.algorithmsArr, {id: clonedTrainerObj.algorithmId})
                    vm.fnSelectAlgorithm(vm.selectedAlgorithm);
                    vm.newTrainerObj.parameters = clonedTrainerObj.parameters;
                    vm.newTrainerObj.branches = clonedTrainerObj.branches;
                    angular.forEach(vm.newTrainerObj.branches, function (mainBranches) {
                        angular.forEach(vm.algorithmRequiredBranches, function (requiredBranchName) {
                            if(mainBranches.name === requiredBranchName.name) {
                                Object.keys(requiredBranchName).forEach(function (key) {
                                    requiredBranchName[key] = mainBranches[key];
                                })
                            }
                        });
                        angular.forEach(vm.algorithmOptionalBranches, function (optionalBranchName) {
                            if(mainBranches.name === optionalBranchName.name) {
                                Object.keys(optionalBranchName).forEach(function (key) {
                                    optionalBranchName[key] = mainBranches[key];
                                })
                            }
                        });
                    });
                    vm.newTrainerObj.outputPath = clonedTrainerObj.outputPath;
                    vm.selectedVmObj = _.find(vm.algoVmsArr, {id: clonedTrainerObj.trainingVmId});
                    vm.fnVmsSelected(vm.selectedVmObj);
                    vm.newTrainerObj.trainingVmCount = clonedTrainerObj.trainingVmCount;
                    vm.newTrainerObj.trainingMaxTime = clonedTrainerObj.trainingMaxTime;
                    vm.newTrainerObj.trainingVmDriveSize = clonedTrainerObj.trainingVmDriveSize;
                    vm.isCreateFormLoading = false;
                };

                vm.fnGetVms = function () {
                    VmFactory.getVms()
                        .then(function (response) {
                            vm.vmsArr = [];
                            angular.forEach(response, function (resObj) {
                                if(resObj.services.indexOf("ai.training") !== -1) {
                                    vm.vmsArr.push(resObj);
                                }
                            });
                            if(Object.keys(vm.clonedTrainerObj).length) {
                                vm.fnSetUpClonedTrainer(vm.clonedTrainerObj);
                            } else {
                                vm.isCreateFormLoading = false;
                            }
                        }, function () {
                            vm.vmsArr = [];
                            if(Object.keys(vm.clonedTrainerObj).length) {
                                vm.fnSetUpClonedTrainer(vm.clonedTrainerObj);
                            } else {
                                vm.isCreateFormLoading = false;
                            }
                        })
                };

                vm.fnGetAlgorithms = function () {
                    AlgorithmFactory.getAlgorithms()
                        .then(function (response) {
                            vm.algorithmsArr = response;
                            vm.fnGetVms();
                        }, function () {
                            vm.algorithmsArr = [];
                            vm.fnGetVms();
                        })
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitCreateTrainer = function () {
                    vm.storagePermissionObj = PermissionsService.getPermissions("content:List");
                    if(DB.fnGet('clonedTrainerObj')) {
                        vm.clonedTrainerObj = DB.fnGet('clonedTrainerObj');
                        DB.fnRemove('clonedTrainerObj')
                    } else {
                        vm.clonedTrainerObj = {};
                    }
                    vm.fnSetTableHeight();
                    vm.isCreateFormLoading = true;
                    vm.fnGetAlgorithms();
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('modelInfo', fnModelInfo)

    /** @ngInject */
    function fnModelInfo($window, $state, $timeout, $stateParams, microSpinner, swal, amaran, copyService, ModelFactory, AlgorithmFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/ai/model/modelInfo/modelInfo.html',
            scope: {
                modelObj: '=',
                modelPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/ai/model/modelInfo/modelTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isUpdateCompleted = true;
                $scope.isModelProcessOnGoing = false;
                $scope.isDetailsEditable = false;

                $scope.fnGetModel = function (modelId) {
                    var inputObj = {
                        modelId: modelId
                    };
                    ModelFactory.getModel(inputObj)
                        .then(function (response) {
                            $scope.modelObj = response;
                            $scope.resetModelObj = angular.copy($scope.modelObj);
                            AlgorithmFactory.getAlgorithms()
                                .then(function (response) {
                                    $scope.algorithmsArr = response;
                                    $scope.selectedAlgorithm = _.find( $scope.algorithmsArr, {id: $scope.modelObj.algorithmId});
                                    $scope.resetselectedAlgorithmObj = angular.copy($scope.selectedAlgorithm);
                                    $scope.isModelDetailsLoaded = true;
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    $scope.isModelDetailsLoaded = true;
                                });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isModelDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.model', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnDeleteModel = function (modelObj) {
                    swal({
                            title: "Delete the selected model?",
                            text: "You are about to permanently delete the selected model.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    modelId: modelObj.id
                                };
                                ModelFactory.deleteModel(inputObj)
                                    .then(function () {
                                        $scope.$emit('modelDeleted', modelObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnUpdateModelDetails = function (modelObj) {
                    var inputObj = {
                        body: {},
                        modelId: modelObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(modelObj.description)) {
                        modelObj.description = '';
                    }
                    inputObj.body = {
                        name: modelObj.name,
                        description: modelObj.description,
                        algorithmId:modelObj.algorithmId,
                        artifactPath:modelObj.artifactPath
                    };
                    ModelFactory.modifyModel(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetModelObj = angular.copy(response);
                            $scope.$emit('ModelDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Model Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                /*$scope.fnAlgorithmSelected = function (selectedAlgorithm) {
                    $scope.selectedAlgorithm = selectedAlgorithm;
                    $scope.modelObj.algorithmId = $scope.selectedAlgorithm.id;
                };*/

                $scope.fnResetDetails = function () {
                    $scope.modelObj = angular.copy($scope.resetModelObj);
                    //$scope.selectedAlgorithm = angular.copy($scope.resetselectedAlgorithmObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnInitModel = function () {
                    $scope.isModelDetailsLoaded = false;
                    $scope.modelId = $scope.modelObj.id;
                    if ($scope.modelId) {
                        $scope.fnGetModel($scope.modelId);
                    }
                    $scope.fnSetTabHeight();
                };

                var modelInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.model') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.modelPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteModel($scope.modelObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.modelPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var modelInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.model') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', modelInfoKeyDownEventHandler);
                document.addEventListener('keyup', modelInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', modelInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', modelInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();


(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('distributionInfo', fnDistributionInfo)

    /** @ngInject */
    function fnDistributionInfo($window, $state, $timeout, $stateParams, microSpinner, swal, amaran, copyService, PermissionsService, DistributionFactory, ModelFactory, VmFactory, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/ai/distribution/distributionInfo/distributionInfo.html',
            scope: {
                distributionObj: '=',
                distributionPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/ai/distribution/distributionInfo/distributionTabs/details.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;
                $scope.modelsArr = [];
                $scope.vmsArr = [];
                $scope.isShowModelIdInfo = true;

                $scope.fnGetVm = function () {
                    VmFactory.getVms()
                        .then(function (response) {
                            $scope.vmsArr = response;
                            $scope.isDistributionDetailsLoaded = true;
                        }, function () {
                            $scope.vmsArr = [];
                            $scope.isDistributionDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.distribution', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnGetModel = function () {
                    ModelFactory.getModels()
                        .then(function (response) {
                            $scope.modelsArr = response;
                            $scope.fnGetVm();
                        }, function () {
                            $scope.modelsArr = [];
                            $scope.fnGetVm();
                        })
                };

                $scope.fnGetDistribution = function (distributionId) {
                    var inputObj = {
                        distributionId: distributionId
                    };
                    DistributionFactory.getDistribution(inputObj)
                        .then(function (response) {
                            $scope.distributionObj = response;
                            $scope.resetDistributionObj= angular.copy($scope.distributionObj);
                            if($scope.modelPermissionObj.List) {
                                $scope.fnGetModel();
                            } else {
                                $scope.modelsArr = [];
                                $scope.fnGetVm();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDistributionDetailsLoaded = true;
                        })
                };

                $scope.fnGetModelName = function (modelId) {
                    if($scope.modelPermissionObj.List) {
                        var tempObj =  _.find($scope.modelsArr, {id: modelId});
                        if(tempObj) {
                            $scope.isShowModelIdInfo = true;
                            return tempObj.name
                        } else {
                            $scope.isShowModelIdInfo = false;
                            return modelId;
                        }
                    } else {
                        $scope.isShowModelIdInfo = false;
                        return modelId;
                    }
                };

                $scope.fnGetVmName = function (vmId) {
                    return _.find($scope.vmsArr, {id: vmId}).name;
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnDeleteDistribution = function (distributionObj) {
                    swal({
                            title: "Delete the selected distribution?",
                            text: "You are about to permanently delete the selected distribution.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    distributionId: distributionObj.id
                                };
                                DistributionFactory.deleteDistribution(inputObj)
                                    .then(function () {
                                        $scope.$emit('DistributionDeleted', distributionObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnUpdateDistributionDetails = function (distributionObj) {
                    var inputObj = {
                        body: {},
                        distributionId: distributionObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(distributionObj.description)) {
                        distributionObj.description = '';
                    }
                    inputObj.body = {
                        name: distributionObj.name,
                        description: distributionObj.description
                    };
                    DistributionFactory.modifyDistribution(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetDistributionObj = angular.copy(response);
                            $scope.$emit('DistributionDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Distribution Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnResetDetails = function () {
                    $scope.distributionObj = angular.copy($scope.resetDistributionObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnInitDistribution = function () {
                    $scope.modelPermissionObj = PermissionsService.getPermissions("ai:model");
                    $scope.isDistributionDetailsLoaded = false;
                    $scope.distributionId = $scope.distributionObj.id;
                    if ($scope.distributionId) {
                        $scope.fnGetDistribution($scope.distributionId);
                    }
                    $scope.fnSetTabHeight();
                };

                var distributionInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.distribution') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.distributionPermissionsObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteDistribution($scope.distributionObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.distributionPermissionsObj.Modify && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var distributionInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.distribution') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', distributionInfoKeyDownEventHandler);
                document.addEventListener('keyup', distributionInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', distributionInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', distributionInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createDistributionCtrl',
            function ($scope, $window, amaran, PermissionsService, ModelFactory, VmFactory, DistributionFactory, AlgorithmFactory) {
                var vm = this;
                vm.title = "Create Distribution";
                vm.newDistributionObj = {
                    name: '',
                    description: '',
                    divergences: null
                };
                var resetDistributionObj = angular.copy(vm.newDistributionObj);
                vm.divergences = [{
                    name: '',
                    description: '',
                    modelId: '',
                    virtualMachineId: '',
                    virtualMachineCount: 1
                }];
                var resetDivergences = angular.copy(vm.divergences);
                vm.modelsArr = [];
                vm.isCreateFormLoading = false;
                /*Vm*/
                vm.vmDivergenceCountErrorMessage = '';
                var vmMinQuantity = 1;
                var vmMaxQuantity = '';
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnCreateNewDistribution = function (newModelObj) {
                    angular.forEach(vm.divergences, function (value) {
                        delete value.selectedModel;
                        delete value.selectedVms;
                    });
                    newModelObj.divergences = vm.divergences;
                    vm.isDistributionCreating = true;
                    var inputObj = {
                        body: newModelObj
                    };
                    DistributionFactory.createDistribution(inputObj)
                        .then(function (response) {
                            $scope.distribution.fnHideShowCreateForm(); //parent function
                            vm.newDistributionObj = angular.copy(resetDistributionObj);
                            vm.divergences = angular.copy(resetDivergences);
                            $scope.$emit('distributionAdded', response.id);
                            if($scope.distribution.distributionPermissionObj.List){
                                $scope.distribution.totalItems = $scope.distribution.totalItems + 1;
                                $scope.distribution.distributionsArr.push(response);
                                $scope.distribution.fnReload();
                            }
                            amaran.success("Distribution is successfully created");
                            vm.isDistributionCreating = false;
                        }, function () {
                            vm.isDistributionCreating = false;
                        })
                };

                vm.fnAddNewDivergence = function () {
                    var newObj = {
                        name: '',
                        description: '',
                        modelId: '',
                        virtualMachineId: '',
                        virtualMachineCount: 1
                    };
                    vm.divergences.push(newObj);
                };

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSelectModel = function (divergencesObj) {
                    divergencesObj.modelId = divergencesObj.selectedModel.id;
                    var algorithmObj = _.find(vm.algorithmsArr, {id: divergencesObj.selectedModel.algorithmId});
                    vm.fnSetVmOptions(algorithmObj);
                };

                vm.fnSetVmOptions = function (algorithmObj) {
                    vm.algoVmsArr = [];
                    var vmSupportsArr = algorithmObj.vmSupport;
                    vm.vmsArr.map(function (obj) {
                        if (vmSupportsArr.multiCPU === true) {
                            if (obj.cpu >= 0) {
                                if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                    vm.algoVmsArr.push(obj);
                                }
                            }
                        } else {
                            if (vmSupportsArr.singleCPU === true) {
                                if (obj.cpu <= 1) {
                                    if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                        vm.algoVmsArr.push(obj);
                                    }
                                }
                            }
                        }
                        if (vmSupportsArr.multiGPU === true) {
                            if (obj.gpu >= 0) {
                                if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                    vm.algoVmsArr.push(obj);
                                }
                            }
                        } else {
                            if (vmSupportsArr.singleGPU === true) {
                                if (obj.gpu <= 1) {
                                    if (!_.find(vm.algoVmsArr, {id: obj.id})) {
                                        vm.algoVmsArr.push(obj);
                                    }
                                }
                            }
                        }
                    });
                };

                vm.fnVmsSelected = function (divergencesObj) {
                    var vmsObj = divergencesObj.selectedVms;
                    divergencesObj.virtualMachineId = vmsObj.id;
                    if (vmsObj.cpu > 1) {
                        vmMaxQuantity = '';
                    } else {
                        if (vmsObj.gpu > 1) {
                            vmMaxQuantity = '';
                        } else {
                            vmMaxQuantity = 1;
                        }
                    }
                };

                vm.fnChangeVmCount = function (divergenceVmCount) {
                    if (vmMaxQuantity === '') {
                        if (divergenceVmCount < vmMinQuantity) {
                            vm.vmDivergenceCountErrorMessage = 'The Virtual Machine quantity for divergence cannot be less than ' + vmMinQuantity;
                        } else {
                            vm.vmDivergenceCountErrorMessage = '';
                        }
                    } else {
                        if (divergenceVmCount < vmMinQuantity || divergenceVmCount > vmMaxQuantity) {
                            vm.vmDivergenceCountErrorMessage = 'The Virtual Machine quantity for divergence should be between ' + vmMinQuantity + 'and ' + vmMaxQuantity;
                        } else {
                            vm.vmDivergenceCountErrorMessage = '';
                        }
                    }
                };

                vm.fnCheckDistributionValidity = function () {
                    if(!vm.newDistributionObj.name.length) {
                        return true;
                    } else {
                        var flag = false;
                        angular.forEach(vm.divergences, function (divergenceObj) {
                            if(!divergenceObj.name.length || !divergenceObj.modelId.length || !divergenceObj.virtualMachineId.length || !divergenceObj.virtualMachineCount) {
                                flag = true;
                            }
                        });
                        return flag;
                    }
                };

                vm.fnGetVms = function () {
                    VmFactory.getVms()
                        .then(function (response) {
                            vm.vmsArr = [];
                            angular.forEach(response, function (resObj) {
                                if(resObj.services.indexOf('ai.deployment') !== -1) {
                                    vm.vmsArr.push(resObj);
                                }
                            });
                            if(!vm.modelPermissionObj.List) {
                                vm.algoVmsArr = angular.copy(vm.vmsArr);
                            }
                            vm.isCreateFormLoading = false;
                        }, function () {
                            vm.vmsArr = [];
                            vm.isCreateFormLoading = false;
                        })
                };

                vm.fnGetAlgorithms = function () {
                    AlgorithmFactory.getAlgorithms()
                        .then(function (response) {
                            vm.algorithmsArr = response;
                            vm.fnGetVms();
                        }, function () {
                            vm.algorithmsArr = [];
                            vm.fnGetVms();
                        })
                };
                vm.fnInitCreateDistribution = function () {
                    vm.modelPermissionObj = PermissionsService.getPermissions("ai:model");
                    vm.isCreateFormLoading = true;
                    if(vm.modelPermissionObj.List) {
                        ModelFactory.getModels()
                            .then(function (response) {
                                vm.modelsArr = response;
                                vm.fnGetAlgorithms();
                            }, function () {
                                vm.modelsArr = [];
                                vm.fnGetAlgorithms();
                            });
                    } else {
                        vm.modelsArr = [];
                        vm.fnGetAlgorithms();
                    }
                    vm.fnSetTableHeight();
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('deploymentInfo', fnDeploymentInfo)

    /** @ngInject */
    function fnDeploymentInfo($window, $state, $timeout, $stateParams, microSpinner, swal, amaran, copyService,ColorService,PermissionsService, DistributionFactory, DeploymentFactory,  postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/ai/deployment/deploymentInfo/deploymentInfo.html',
            scope: {
                deploymentObj: '=',
                deploymentPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $scope.fnSetTabHeight();
                });

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/ai/deployment/deploymentInfo/deploymentTabs/details.html',
                        visible : true
                    },{
                        title: 'Inference',
                        tabIndex: 2,
                        templateUrl: 'app/ai/deployment/deploymentInfo/deploymentTabs/inferences/inference.html',
                        visible : false
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        if($scope.tabs[parseInt($stateParams.selectedDetailsTab)-1].visible === true){
                            $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                        }else{
                            $scope.selectedTab = 1;
                        }
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnGetDeployment = function (deploymentId) {
                    var inputObj = {
                        deploymentId: deploymentId
                    };
                    DeploymentFactory.getDeployment(inputObj)
                        .then(function (response) {
                            $scope.deploymentObj = response;
                            $scope.resetDeploymentObj= angular.copy($scope.deploymentObj);
                            if($scope.distributionPermissionObj.List) {
                                $scope.fnGetDistribution($scope.deploymentObj.distributionId);
                            } else {
                                $scope.isDeploymentDetailsLoaded = true;
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDeploymentDetailsLoaded = true;
                        })
                };

                $scope.fnGetDistribution = function (distributionId) {
                    var inputObj = {
                        distributionId: distributionId
                    };
                    DistributionFactory.getDistribution(inputObj)
                        .then(function (response) {
                            $scope.distributionObj = response;
                            $scope.isDeploymentDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isDeploymentDetailsLoaded = true;
                        })
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnGetDeploymentStatusIcon = function (status) {
                    var icon = "";
                    switch (status) {
                        case "OUT_OF_SERVICE":
                            icon = "fa-exclamation-triangle";
                            break;
                        case "CREATING":
                            icon = "fa-gears";
                            break;
                        case "UPDATING":
                            icon = "fa-upload";
                            break;
                        case "ROLLING_BACK":
                            icon = "fa-retweet";
                            break;
                        case "IN_SERVICE":
                            icon = "fa-check";
                            break;
                        case "DELETING":
                            icon = "fa-trash-o";
                            break;
                        case "FAILED":
                            icon = "fa-times-circle";
                            break;
                    }
                    return icon;
                };

                $scope.fnGetDeploymentStatusIconColor = function (status) {
                    return ColorService.getDeploymentStatusColor(status);
                };

                $scope.fnDeleteDeployment = function (deploymentObj) {
                    swal({
                            title: "Delete the selected deployment?",
                            text: "You are about to permanently delete the selected deployment.<br/>" +
                            "You will not be able to recover any of the data related to it.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    deploymentId: deploymentObj.id
                                };
                                DeploymentFactory.deleteDeployment(inputObj)
                                    .then(function () {
                                        $scope.$emit('DeploymentDeleted', deploymentObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        },1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnUpdateDeploymentDetails = function (deploymentObj) {
                    var inputObj = {
                        body: {},
                        deploymentId: deploymentObj.id
                    };
                    $scope.isUpdateCompleted = false;

                    if (angular.isUndefined(deploymentObj.description)) {
                        deploymentObj.description = '';
                    }
                    inputObj.body = {
                        name: deploymentObj.name,
                        description: deploymentObj.description,
                        distributionId:deploymentObj.distributionId
                    };
                    DeploymentFactory.modifyDeployment(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.resetDeploymentObj = angular.copy(response);
                            $scope.$emit('DeploymentDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                            amaran.success("Deployment Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                            $scope.isDetailsEditable = false;
                        })
                };

                $scope.fnResetDetails = function () {
                    $scope.deploymentObj = angular.copy($scope.resetDeploymentObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.deployment', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnInitDeployment = function () {
                    $scope.isDeploymentDetailsLoaded = false;
                    $scope.inferencePermissionObj = PermissionsService.getPermissions("ai:inference");
                    $scope.distributionPermissionObj = PermissionsService.getPermissions("ai:distribution");
                    if($scope.inferencePermissionObj.Make && $scope.deploymentObj.status === 'IN_SERVICE'){
                        $scope.tabs[1].visible = true;
                    }else{
                        $scope.tabs[1].visible = false;
                    }
                    $scope.deploymentId = $scope.deploymentObj.id;
                    if ($scope.deploymentId) {
                        $scope.fnGetDeployment($scope.deploymentId);
                    }
                    $scope.fnSetTabHeight();
                };

                var deploymentInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.deployment') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && $scope.deploymentPermissionsObj.Delete && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteDeployment($scope.deploymentObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] && $scope.selectedTab === 1 && $scope.deploymentPermissionsObj.Modify
                                && !$scope.isDetailsEditable &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var deploymentInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.deployment') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', deploymentInfoKeyDownEventHandler);
                document.addEventListener('keyup', deploymentInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', deploymentInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', deploymentInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createDeploymentCtrl',
            function ($scope, $window, amaran, PermissionsService, DistributionFactory, DeploymentFactory) {
                var vm = this;
                vm.title = "Create Deployment";
                vm.newDeploymentObj = {
                    name: '',
                    description: '',
                    distributionId: ''
                };
                var resetDeploymentObj = angular.copy(vm.newDeploymentObj);
                vm.distributionsArr = [];
                vm.isCreateFormLoading = false;
                vm.isDeploymentCreating = false;
                vm.isDistributionsFetched = false;
                vm.selectedDistribution = '';

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 53;
                        var finalHeight = total - header;
                        angular.element(".modal-body").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCreateNewDeployment = function (newDeploymentObj) {
                    vm.isDeploymentCreating = true;
                    var inputObj = {
                        body: newDeploymentObj
                    };

                    DeploymentFactory.createDeployment(inputObj)
                        .then(function (response) {
                            $scope.deployment.fnHideShowCreateForm(); //parent function
                            vm.newDeploymentObj = angular.copy(resetDeploymentObj);
                            if($scope.deployment.deploymentPermissionObj.List){
                                $scope.deployment.totalItems = $scope.deployment.totalItems + 1;
                                $scope.deployment.deploymentsArr.push(response);
                                $scope.deployment.fnReload();
                            }
                            amaran.success("Distribution is successfully created");
                            vm.isDeploymentCreating = false;
                        }, function () {
                            vm.isDeploymentCreating = false;
                        })
                };

                vm.fnSelectDistribution = function (selectedDistributionObj) {
                    vm.newDeploymentObj.distributionId = selectedDistributionObj.id;
                };

                vm.fnInitCreateDeployment = function () {
                    vm.isCreateFormLoading = true;
                    vm.distributionPermissionObj = PermissionsService.getPermissions("ai:distribution");
                    if(vm.distributionPermissionObj.List){
                        DistributionFactory.getDistributions()
                            .then(function (response) {
                                vm.distributionsArr = response;
                                vm.isCreateFormLoading = false;
                            }, function () {
                                vm.distributionsArr = [];
                                vm.isCreateFormLoading = false;
                            });
                    }else {
                        vm.distributionsArr = [];
                        vm.isCreateFormLoading = false;
                    }
                    vm.fnSetTableHeight();
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('vaultInfo', fnVaultInfo)

    /** @ngInject */
    function fnVaultInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, VaultsFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/vault/vaultInfo/vaultInfo.html',
            scope: {
                vaultObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                var codeset = {
                    38: false, //up arrow
                    68: false //d
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/access/vault/vaultInfo/vaultSteps/details.html'
                    },
                    {
                        title: 'Content',
                        tabIndex: 2,
                        templateUrl: 'app/access/vault/vaultInfo/vaultSteps/content/content.html'
                    },
                    {
                        title: 'Teams',
                        tabIndex: 3,
                        templateUrl: 'app/access/vault/vaultInfo/vaultSteps/vaultTeams/vaultTeams.html'
                    },
                    {
                        title: 'Tags',
                        tabIndex: 4,
                        templateUrl: 'app/access/vault/vaultInfo/vaultSteps/vaultSupplemental/vaultSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetVault = function (vaultId) {
                    var inputObj = {
                        vaultId: vaultId
                    };
                    VaultsFactory.describeVault(inputObj)
                        .then(function (response) {
                            $scope.vaultObj = response;
                            $scope.resetvaultObj = angular.copy($scope.vaultObj);
                            if (angular.isUndefined($scope.vaultObj.description)) {
                                $scope.vaultObj.description = '';
                            }
                            $scope.isVaultDetailsLoaded = true;
                        })
                };

                $scope.fnUpdateVaultDetails = function (vaultObj) {
                    var inputObj = {
                        body: {},
                        vaultId: vaultObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(vaultObj.description)) {
                        vaultObj.description = '';
                    }
                    inputObj.body = {
                        name: vaultObj.name,
                        description: vaultObj.description
                    };
                    VaultsFactory.updateVault(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('VaultDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Vault Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.vaults', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnDeleteVault = function (vaultObj) {
                    swal({
                            title: "Delete the selected vault?",
                            text: "You are about to permanently delete the selected vault.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    vaultId: vaultObj.id
                                };
                                VaultsFactory.deleteVault(inputObj)
                                    .then(function () {
                                        $scope.$emit('VaultDeleted', vaultObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function () {
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.vaultObj = angular.copy($scope.resetvaultObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitVault = function () {
                    $scope.isVaultDetailsLoaded = false;
                    $scope.vaultId = $scope.vaultObj.id;
                    if ($scope.vaultId) {
                        $scope.fnGetVault($scope.vaultId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitVault();

                $scope.fnInitDetailsTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                var vaultInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteVault($scope.vaultObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var vaultInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', vaultInfoKeyDownEventHandler);
                document.addEventListener('keyup', vaultInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', vaultInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', vaultInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('vaultAuthenticatorModalCtrl',
            function ($timeout, $window, $uibModalInstance, jsSHA, DB) {
                var vm = this;

                /*filters: START*/
                vm.isFunctionSelected = false;
                vm.selectedFunction = "";
                vm.isFunctionSelected = false;
                vm.isDetailsLoaded = false;
                vm.functionsArr = [{
                    "name": "Time-based One-time Password()",
                    "description": "Time-based One-time Password Algorithm used by Google Authenticator"
                }];

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnClose = function () {
                    $uibModalInstance.close(vm.secretKey);
                };

                vm.fnInject = function (obj) {
                    vm.functionType = obj.name;
                    vm.isFunctionSelected = true;
                    vm.isDetailsLoaded = false;
                    vm.secretKey = stringGen(16);
                    updateOtp(vm.secretKey);
                };

                vm.fnBackToFunctions = function () {
                    vm.functionType = '';
                    vm.isFunctionSelected = false;
                };

                function dec2hex(s) {
                    return (s < 15.5 ? '0' : '') + Math.round(s).toString(16);
                }

                function base32tohex(base32) {
                    var base32chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
                    var bits = "";
                    var hex = "";
                    var i = 0;
                    for (i = 0; i < base32.length; i++) {
                        var val = base32chars.indexOf(base32.charAt(i).toUpperCase());
                        bits += leftpad(val.toString(2), 5, '0');
                    }

                    for (i = 0; i + 4 <= bits.length; i += 4) {
                        var chunk = bits.substr(i, 4);
                        hex = hex + parseInt(chunk, 2).toString(16);
                    }
                    return hex;
                }

                function leftpad(str, len, pad) {
                    if (len + 1 >= str.length) {
                        str = Array(len + 1 - str.length).join(pad) + str;
                    }
                    return str;
                }

                function updateOtp(secretKey) {
                    var key = base32tohex(secretKey);
                    var epoch = Math.round(new Date().getTime() / 1000.0);
                    var time = leftpad(dec2hex(Math.floor(epoch / 30)), 16, '0');
                    // updated for jsSHA v2.0.0 - http://caligatio.github.io/jsSHA/
                    var shaObj = new jsSHA("SHA-1", "HEX");
                    shaObj.setHMACKey(key, "HEX");
                    shaObj.update(time);
                    vm.img = 'https://chart.googleapis.com/chart?chs=200x200&cht=qr&chl=200x200&chld=M|0&cht=qr&chl=otpauth://totp/' + vm.userEmail + '%3Fsecret%3D' + secretKey;
                    $timeout(function () {
                        vm.isDetailsLoaded = true;
                    });
                }

                function stringGen(len) {
                    var text = "";
                    var charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
                    for (var i = 0; i < len; i++) {
                        text += charset.charAt(Math.floor(Math.random() * charset.length));
                    }
                    return text;
                }

                vm.fnInitVaultModal = function () {
                    var loginUser = DB.fnGet('sudo')?DB.fnGet('sudo'):DB.fnGet('loginUser');
                    vm.userEmail = loginUser.email ? loginUser.email : '';
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createVaultCtrl',
            function ($scope, $timeout, amaran, VaultsFactory) {

                var vm = this;
                vm.title = "Create Vault";
                vm.vaultKVPArr = [
                    {
                        key: '',
                        value: '',
                        inputType: 'password'
                    }
                ];
                vm.isAdvancedOption = false;
                vm.vaultContentObj = {};
                vm.newVaultObj = {
                    name: '',
                    description: '',
                    content: {}
                };
                vm.isObjectEmpty = function (obj) {
                    return Object.keys(obj).length === 0;
                };
                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        _cm.setOption('readOnly', false);
                    }
                };

                vm.hideShowPassword = function (kvpPair) {
                    if (kvpPair.inputType === 'password') {
                        kvpPair.inputType = 'text';
                    } else {
                        kvpPair.inputType = 'password';
                    }
                };

                vm.fnRemoveKvpPair = function (index) {
                    vm.vaultKVPArr.splice(index, 1);
                };

                vm.fnKvpPairChange = function (kvpPair, index) {
                    if (kvpPair.value && kvpPair.key) {
                        if (index + 1 === vm.vaultKVPArr.length) {
                            if (kvpPair.key.length && kvpPair.value.length && vm.vaultKVPArr[vm.vaultKVPArr.length - 1].key === kvpPair.key) {
                                var count = 0;
                                if (vm.vaultKVPArr.length > 1) {
                                    angular.forEach(vm.vaultKVPArr, function (kvpPairObj) {
                                        if (kvpPairObj.key === kvpPair.key) {
                                            count++;
                                        }
                                    });
                                }
                                if (count <= 1) {
                                    var inputObj = {
                                        key: '',
                                        value: '',
                                        inputType: 'password'
                                    };
                                    vm.vaultKVPArr.push(inputObj)
                                }
                            }
                        }
                    }
                };

                vm.fnOpenAdvancedMenu = function () {
                    if (!vm.isAdvancedOption) {
                        vm.vaultContentObj = {};
                        _.forEach(vm.vaultKVPArr, function (contentKVPObj) {
                            vm.vaultContentObj[contentKVPObj.key] = contentKVPObj.value;
                        });
                        vm.vaultContentObj = angular.toJson(vm.vaultContentObj, true);
                    } else {
                        vm.vaultContentObj = angular.fromJson(vm.vaultContentObj);
                        vm.vaultKVPArr = [];
                        if (!vm.isObjectEmpty(vm.vaultContentObj)) {
                            angular.forEach(vm.vaultContentObj, function (value, key) {
                                var tempObj = {
                                    key: key,
                                    value: value,
                                    inputType: 'password'
                                };
                                vm.vaultKVPArr.push(tempObj);
                            });
                        }
                    }
                    vm.isAdvancedOption = !vm.isAdvancedOption;
                };

                vm.fnCreateNewVault = function (newVaultObj, vaultKvpArr) {
                    angular.forEach(vaultKvpArr, function (kvpPairObj) {
                        if (angular.isDefined(kvpPairObj.key) && angular.isDefined(kvpPairObj.value)) {
                            if (/^\d+$/.test(kvpPairObj.value)) {
                                newVaultObj.content[kvpPairObj.key] = parseInt(kvpPairObj.value);
                            } else {
                                newVaultObj.content[kvpPairObj.key] = kvpPairObj.value;
                            }
                        }
                    });
                    vm.isVaultCreating = true;
                    var inputObj = {
                        body: newVaultObj
                    };
                    VaultsFactory.createVault(inputObj)
                        .then(function (resObj) {
                            vm.isVaultCreating = false;
                            $scope.vaults.fnHideShowCreateForm(); //parent function

                            vm.newVaultObj = {
                                name: '',
                                description: '',
                                content: {}
                            };
                            vm.vaultKVPArr = [
                                {
                                    key: '',
                                    value: '',
                                    inputType: 'password'
                                }
                            ];


                            $timeout(function () { // set table height
                                $scope.vaults.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('VaultAdded', 'Create Vault');
                            $scope.vaults.totalItems = $scope.vaults.totalItems + 1;
                            $scope.vaults.vaultsArr.push(resObj);
                            $scope.vaults.fnReload();
                            amaran.success("Vault created successfully");
                        }, function () {
                            vm.isVaultCreating = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('updateUserRoleModalCtrl',
            function ($scope, $timeout, $uibModalInstance, amaran, userRoleType, userObj, UserFactory) {
                var vm = this;
                vm.userRoleType = userRoleType;
                vm.userObj = userObj;
                vm.userRoleOptions = [];
                vm.selectedRole = '';
                var billingRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }
                ];
                var trackerRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }, {
                        id: 'TEAM_MEMBER',
                        displayName: 'TEAM MEMBER'
                    }, {
                        id: 'CUSTOMER',
                        displayName: 'CUSTOMER'
                    }
                ];
                var nodeRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }, {
                        id: 'SUPERVISOR',
                        displayName: 'SUPERVISOR'
                    }, {
                        id: 'TEAM_MEMBER',
                        displayName: 'TEAM MEMBER'
                    }, {
                        id: 'CUSTOMER',
                        displayName: 'CUSTOMER'
                    }
                ];
                var pipelineRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }, {
                        id: 'TEAM_MEMBER',
                        displayName: 'TEAM MEMBER'
                    }
                ];
                var storageRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }, {
                        id: 'TEAM_MEMBER',
                        displayName: 'TEAM MEMBER'
                    }, {
                        id: 'CUSTOMER',
                        displayName: 'CUSTOMER'
                    }
                ];
                var aiRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }
                ];
                var insightRole = [
                    {
                        id: 'NONE',
                        displayName: 'NONE'
                    }, {
                        id: 'MANAGER',
                        displayName: 'MANAGER'
                    }, {
                        id: 'TEAM_MEMBER',
                        displayName: 'TEAM MEMBER'
                    }, {
                        id: 'CUSTOMER',
                        displayName: 'CUSTOMER'
                    }
                ];
                vm.isUserUpdating = false;

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    vm.isUserUpdating = true;
                    var inputObj = {
                        body: {},
                        userId: vm.userObj.id
                    };
                    switch (vm.userRoleType) {
                        case 'Billing':
                            inputObj.body = {
                                billingRole: vm.selectedRole
                            };
                            UserFactory.updateUserBillingRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'Tracker':
                            inputObj.body = {
                                trackerRole: vm.selectedRole
                            };
                            UserFactory.updateUserTrackerRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'Node':
                            inputObj.body = {
                                nodeRole: vm.selectedRole
                            };
                            UserFactory.updateUserNodeRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'Pipeline':
                            inputObj.body = {
                                pipelineRole: vm.selectedRole
                            };
                            UserFactory.updateUserPipelineRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'Storage':
                            inputObj.body = {
                                storageRole: vm.selectedRole
                            };
                            UserFactory.updateUserStorageRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'AI':
                            inputObj.body = {
                                aiRole: vm.selectedRole
                            };
                            UserFactory.updateUserAiRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                        case 'Insight':
                            inputObj.body = {
                                insightRole: vm.selectedRole
                            };
                            UserFactory.updateUserInsightRole(inputObj)
                                .then(function (response) {
                                    $scope.$emit('UserDetailsChanged', response);
                                    vm.isUserUpdating = false;
                                    amaran.success("User Updated Successfully");
                                    $uibModalInstance.close(response);
                                }, function (error) {
                                    if (error && error.errorCode === -1) {
                                        amaran.error(error.errorMessage);
                                    }
                                    vm.isUserUpdating = false;
                                    $uibModalInstance.dismiss('cancel');
                                });
                            break;
                    }
                };

                vm.fnInit = function () {
                    switch (vm.userRoleType) {
                        case 'Billing':
                            vm.userRoleOptions = billingRole;
                            vm.selectedRole = vm.userObj.billingRole;
                            break;
                        case 'Tracker':
                            vm.userRoleOptions = trackerRole;
                            vm.selectedRole = vm.userObj.trackerRole;
                            break;
                        case 'Node':
                            vm.userRoleOptions = nodeRole;
                            vm.selectedRole = vm.userObj.nodeRole;
                            break;
                        case 'Pipeline':
                            vm.userRoleOptions = pipelineRole;
                            vm.selectedRole = vm.userObj.pipelineRole;
                            break;
                        case 'Storage':
                            vm.userRoleOptions = storageRole;
                            vm.selectedRole = vm.userObj.storageRole;
                            break;
                        case 'AI':
                            vm.userRoleOptions = aiRole;
                            vm.selectedRole = vm.userObj.aiRole;
                            break;
                        case 'Insight':
                            vm.userRoleOptions = insightRole;
                            vm.selectedRole = vm.userObj.insightRole;
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createUserModalCtrl',
            function ($scope, $timeout, amaran, UserFactory) {

                var vm = this;
                vm.title = "Invite User";
                vm.newUserObj = {
                    firstName: '',
                    lastName: '',
                    username: '',
                    email: ''
                };
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                vm.fnCreateNewUser = function (newUserObj) {
                    vm.isUserCreating = true;
                    var inputObj = {
                        body: newUserObj
                    };

                    UserFactory.createUser(inputObj)
                        .then(function (resObj) {
                            vm.isUserCreating = false;
                            $scope.users.fnHideShowCreateForm(); //parent function

                            vm.newUserObj = {
                                firstName: '',
                                lastName: '',
                                username: '',
                                email: ''
                            };
                            $timeout(function () { // set table height
                                $scope.users.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('userAdded', resObj.id);
                            $scope.users.totalItems = $scope.users.totalItems + 1;
                            $scope.users.userArr.push(resObj);
                            $scope.users.fnReload();
                            amaran.success("User created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUserCreating = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('teamInfo', fnTeamInfo)

    /** @ngInject */
    function fnTeamInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, TeamFactory, copyService,
                        PermissionsService, FederationsFactory, ProjectFactory, NodeProjectFactory, VaultsFactory,
                        postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/team/teamInfo/teamInfo.html',
            scope: {
                teamObj: '=',
                userPermissionObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false, //u
                    82: false //r
                };

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/access/team/teamInfo/teamSteps/details.html'
                    }, {
                        title: 'Resources',
                        tabIndex: 2,
                        templateUrl: 'app/access/team/teamInfo/teamSteps/teamResources/teamResources.html'
                    }, {
                        title: 'Users',
                        tabIndex: 3,
                        templateUrl: 'app/access/team/teamInfo/teamSteps/teamUsers/teamUsers.html'
                    }, {
                        title: 'Tags',
                        tabIndex: 4,
                        templateUrl: 'app/access/team/teamInfo/teamSteps/teamSupplemental/teamSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetFederationResource = function (id) {
                    var inputObj = {
                        federationId: id
                    };
                    FederationsFactory.describeFederation(inputObj)
                        .then(function (res) {
                            var index = _.findIndex($scope.resourceArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                $scope.resourceArr[index].resourceName = res.alias;
                            }
                        })
                };

                $scope.fnGetTrackerProjectResource = function (id) {
                    var inputObj = {
                        projectId: id
                    };
                    ProjectFactory.describeProject(inputObj)
                        .then(function (res) {
                            var index = _.findIndex($scope.resourceArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                $scope.resourceArr[index].resourceName = res.name;
                            }
                        })
                };

                $scope.fnGetVaultResource = function (id) {
                    var inputObj = {
                        vaultId: id
                    };
                    VaultsFactory.describeVault(inputObj)
                        .then(function (res) {
                            var index = _.findIndex($scope.resourceArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                $scope.resourceArr[index].resourceName = res.name;
                            }
                        })
                };

                $scope.fnGetNodeProjectResource = function (id) {
                    var inputObj = {
                        projectId: id
                    };
                    NodeProjectFactory.describeProject(inputObj)
                        .then(function (res) {
                            var index = _.findIndex($scope.resourceArr, function (resourceObj) {
                                return resourceObj.id === id;
                            });
                            if (index !== -1) {
                                $scope.resourceArr[index].resourceName = res.name;
                            }
                        })
                };

                $scope.fnGetTeam = function (teamId) {
                    var accessPerm = PermissionsService.getPermissionsV4('access');
                    var trackerPerm = PermissionsService.getPermissionsV4('tracker');
                    var nodePerm = PermissionsService.getPermissionsV4('node');
                    var inputObj = {
                        teamId: teamId
                    };
                    TeamFactory.describeTeam(inputObj)
                        .then(function (response) {
                            $scope.teamObj = response;
                            $scope.resetTeamObj = angular.copy($scope.teamObj);
                            if (angular.isUndefined($scope.teamObj.description)) {
                                $scope.teamObj.description = '';
                            }
                            $scope.resourceArr = [];
                            _.forEach($scope.teamObj.resourceIds, function (resourceId) {
                                var id = resourceId.split("-")[1];
                                if (id.startsWith('cu')) {
                                    $scope.resourceArr.push({
                                        service: 'ACCESS_FEDERATION',
                                        displayName: 'ACCESS FEDERATION',
                                        id: resourceId
                                    });
                                    if (accessPerm.DESCRIBE_FEDERATION) {
                                        $scope.fnGetFederationResource(resourceId);
                                    }
                                }
                                if (id.startsWith('tp')) {
                                    $scope.resourceArr.push({
                                        service: 'TRACKER_PROJECT',
                                        displayName: 'TRACKER PROJECT',
                                        id: resourceId
                                    });
                                    if (trackerPerm.DESCRIBE_PROJECT) {
                                        $scope.fnGetTrackerProjectResource(resourceId);
                                    }
                                }
                                if (id.startsWith('av')) {
                                    $scope.resourceArr.push({
                                        service: 'ACCESS_VAULT',
                                        displayName: 'ACCESS VAULT',
                                        id: resourceId
                                    });
                                    if (accessPerm.DESCRIBE_VAULT) {
                                        $scope.fnGetVaultResource(resourceId);
                                    }
                                }
                                if (id.startsWith('np')) {
                                    $scope.resourceArr.push({
                                        service: 'NODE_PROJECT',
                                        displayName: 'NODE PROJECT',
                                        id: resourceId
                                    });
                                    if (nodePerm.DESCRIBE_PROJECT) {
                                        $scope.fnGetNodeProjectResource(resourceId);
                                    }
                                }
                            });
                            $scope.isTeamDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isTeamDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.teams', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateGroupDetails = function (teamObj) {
                    var inputObj = {
                        body: {},
                        teamId: teamObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(teamObj.description)) {
                        teamObj.description = '';
                    }
                    inputObj.body = {
                        name: teamObj.name,
                        description: teamObj.description
                    };
                    TeamFactory.updateTeam(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('TeamDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Team Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteGroup = function (teamObj) {
                    swal({
                            title: "Delete the selected Team?",
                            text: "You are about to permanently delete the selected Team.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    teamId: teamObj.id
                                };
                                TeamFactory.deleteTeam(inputObj)
                                    .then(function () {
                                        $scope.$emit('TeamDeleted', teamObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.teamObj = angular.copy($scope.resetTeamObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        //var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitGroup = function () {
                    $scope.isTeamDetailsLoaded = false;

                    $scope.teamId = $scope.teamObj.id;
                    if ($scope.teamId) {
                        $scope.fnGetTeam($scope.teamId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitGroup();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var groupInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.teams') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnDeleteGroup($scope.teamObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[82] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Roles');
                                codeset[38] = false;
                                codeset[82] = false;
                            }
                        }
                    }
                };

                var groupInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.teams') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', groupInfoKeyDownEventHandler);
                document.addEventListener('keyup', groupInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', groupInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', groupInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('resourceModalCtrl',
            function ($uibModalInstance, resourceName, FederationsFactory, $window, $timeout, amaran,
                      FedSudoUserService, UserProfileService, ProjectFactory, QueryFactory,
                      PaginationQueryService, AvatarService, ColorService, IconService, $log)  {
                var vm = this;
                vm.resourceName = resourceName;
                vm.isDataLoading = true;
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isSinglePage = false;
                vm.tableName = vm.resourceName.type.toLowerCase().concat('s');

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                id: item.id || parsedData.id || '',
                                name: parsedData.name || '',
                                description: parsedData.description || '',
                                type: parsedData.type || '',
                                alias: parsedData.alias || '',
                                firstName: parsedData.firstName || '',
                                lastName: parsedData.lastName || '',
                                email: parsedData.email || '',
                                username: parsedData.username || '',
                                state: parsedData.state || '',
                                administrator: parsedData.administrator || false,
                                accountOwner: parsedData.accountOwner || false,
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Add timestamps if they exist
                            if (item.created_at || parsedData.createdAt) {
                                parsedItem.createdAt = parsedData.createdAt || item.created_at;
                            }

                            if (item.updated_at || parsedData.updatedAt) {
                                parsedItem.updatedAt = parsedData.updatedAt || item.updated_at;
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                // Add these helper functions right after the vm declarations
                vm.fnGetUserStateIcon = function (state) {
                    var icon = IconService.fnGetUserStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "SUSPENDED":
                            return icon + ' InactiveStateIcon';
                        default:
                            return icon + ' unconfirmedStateIcon';
                    }
                };

                vm.fnReturnUserImg = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                };

                vm.getUserStateColor = function (state) {
                    return ColorService.getUserStateColor(state);
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 90);
                        angular.element(".securityGroups-table tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".modal-body")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".modal-body")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (obj, isChecked) {
                    if (isChecked) {
                        vm.resourceId = obj.id
                    } else {
                        vm.resourceId = ""
                    }
                };

                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        vm.sort = sortQuery;
                    } else {
                        vm.sort = '';
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (vm.currentPage) {
                        vm.currentPage = Math.ceil(vm.currentPage) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if (vm.perPage) {
                        vm.perPage = Math.ceil(vm.perPage)
                    }
                    vm.isDataLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ' + vm.tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetResourceAccess(input, true);
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    vm.isDataLoading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM ' + vm.tableName;
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM ' + vm.tableName;
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ' + vm.tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetResourceAccess(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.dataArr);
                        vm.previousPage = page;
                        vm.fnGetResourceAccess(input, false);
                    }
                };

                vm.fnGetResourceAccess = function (input, isFirst) {
                    switch (vm.resourceName.type) {
                        case "ACCESS_FEDERATION":
                            var typeFieldArr = [
                                {name: 'INBOUND', displayName: 'INBOUND'},
                                {name: 'OUTBOUND', displayName: 'OUTBOUND'}
                            ];
                            vm.searchFiltersArr = [
                                {
                                    displayName: "ID",
                                    name: "id",
                                    regexp: "^(\\w{8})-((\\w{8}))$",
                                    errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                                }, {
                                    displayName: "Alias",
                                    name: "alias",
                                    regexp: "",
                                    errorMessage: ""
                                }, {
                                    displayName: "Description",
                                    name: "description",
                                    regexp: "",
                                    errorMessage: ""
                                }, {
                                    displayName: "Type",
                                    name: "type",
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: typeFieldArr,
                                    displayKeyName: 'displayName',
                                    isShowId: false,
                                    isShowSearchBar: false,
                                    filterApplyKeyName: 'name'
                                }];
                            vm.sortFieldArr = [
                                {name: 'alias', displayName: 'Alias'},
                                {name: 'description', displayName: 'Description'}
                            ];
                            break;
                        case "TRACKER_PROJECT":
                            vm.searchFiltersArr = [
                                {
                                    displayName: "ID",
                                    name: "id",
                                    regexp: "^(\\w{8})-((\\w{8}))$",
                                    errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                                }, {
                                    displayName: "Name",
                                    name: "name",
                                    regexp: "",
                                    errorMessage: ""
                                }, {
                                    displayName: "Description",
                                    name: "description",
                                    regexp: "",
                                    errorMessage: ""
                                }];
                            vm.sortFieldArr = [
                                {name: 'name', displayName: 'Name'},
                                {name: 'description', displayName: 'Description'}
                            ];
                            break;
                        case "ACCESS_VAULT":
                            vm.searchFiltersArr = [
                                {
                                    displayName: "ID",
                                    name: "id",
                                    regexp: "^(\\w{8})-((\\w{8}))$",
                                    errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                                }, {
                                    displayName: "Name",
                                    name: "name",
                                    regexp: "",
                                    errorMessage: ""
                                }, {
                                    displayName: "Description",
                                    name: "description",
                                    regexp: "",
                                    errorMessage: ""
                                }];

                            vm.sortFieldArr = [
                                {name: 'name', displayName: 'Name'},
                                {name: 'description', displayName: 'Description'}
                            ];
                            break;
                        case "NODE_PROJECT":
                            vm.searchFiltersArr = [
                                {
                                    displayName: "ID",
                                    name: "id",
                                    regexp: "^(\\w{8})-((\\w{8}))$",
                                    errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                                }, {
                                    displayName: "Name",
                                    name: "name",
                                    regexp: "",
                                    errorMessage: ""
                                }, {
                                    displayName: "Description",
                                    name: "description",
                                    regexp: "",
                                    errorMessage: ""
                                }];
                            vm.sortFieldArr = [
                                {name: 'name', displayName: 'Name'},
                                {name: 'description', displayName: 'Description'}
                            ];
                            break;
                    }
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            vm.dataResponse = _.cloneDeepWith(res);
                            // Parse the Postgres response
                            vm.dataResponse.data = vm.parsePostgresData(res.data);

                            if (isFirst && vm.dataResponse.data && vm.dataResponse.data.length) {
                                vm.totalItems = vm.dataResponse.data[0].totalItems;
                                vm.currentPage = 1;
                            }
                            if (input.isNeedDataReverse) {
                                vm.dataResponse.data.reverse();
                            }
                            vm.dataArr = vm.dataResponse.data;
                            vm.isDataLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDataLoading = false;
                            vm.isRefresh = false;
                        });
                };

                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };

                vm.fnSave = function () {
                    $uibModalInstance.close(vm.resourceId);
                };

                vm.fnInit = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0)
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createTeamCtrl',
            function ($scope, $window, $uibModal, amaran, TeamFactory, $timeout) {
                var vm = this;

                vm.title = "Create Team";
                vm.newTeamObj = {
                    name: '',
                    description: '',
                    resourceIds: []
                };
                vm.activeStep = 1;
                vm.securityGroupArr = [
                    {
                        title: "Access",
                        subapp: [
                            {name: 'Federation', type: 'ACCESS_FEDERATION', isChecked: false},
                            {name: 'Vault', type: 'ACCESS_VAULT', isChecked: false}
                        ]
                    },
                    {
                        title: "Tracker",
                        subapp: [{name: 'Project', type: 'TRACKER_PROJECT', isChecked: false}]
                    },
                    {
                        title: "Node",
                        subapp: [{name: 'Project', type: 'NODE_PROJECT', isChecked: false}]
                    }
                ];
                vm.resourceArr = [];
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var header = 0;
                        var footer = 0;
                        if (angular.element(".modal-footer")[0]) {
                            footer = angular.element(".modal-footer")[0].offsetHeight;
                        }
                        var finalHeight = total - (header + footer);
                        angular.element("#createSecurityGroup-modal-body").css('height', finalHeight + 'px');
                    }
                };

                $timeout(function () {
                    vm.fnSetTableHeight();
                });

                vm.fnGotoNextStep = function () {
                    vm.activeStep = vm.activeStep + 1;
                };

                vm.fnGotoPreviousStep = function () {
                    vm.activeStep = vm.activeStep - 1;
                };

                vm.fnCreateNewTeam = function (newTeamObj) {
                    vm.isTeamCreating = true;
                    var createObj = {
                        name: newTeamObj.name,
                        description: newTeamObj.description,
                        resourceIds: []
                    };
                    var tempResourceIds = [];
                    _.forEach(vm.resourceArr, function (resourceObj) {
                        tempResourceIds.push(resourceObj.id);
                    });
                    createObj.resourceIds = tempResourceIds;
                    var inputObj = {
                        body: createObj
                    };
                    TeamFactory.createTeam(inputObj)
                        .then(function (resObj) {

                            vm.isTeamCreating = false;
                            $scope.teams.fnHideShowCreateForm(); //parent function

                            vm.newTeamObj = {
                                name: '',
                                description: '',
                                resourceIds: []
                            };
                            $timeout(function () { // set table height
                                $scope.teams.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('teamAdded', resObj.id);
                            $scope.teams.totalItems = $scope.teams.totalItems + 1;
                            $scope.teams.teamsArr.push(resObj);
                            $scope.teams.fnReload();

                            amaran.success("Team created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTeamCreating = false;
                        });
                };

                vm.fnCheckUncheckApps = function (securityGroupObj, active) {
                    if (!active) {
                        vm.resourceArr.splice(vm.resourceArr.indexOf(securityGroupObj.type), 1);
                    }
                };

                vm.openModal = function (resource) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/access/team/modal/resourceModal.html',
                        size: 'lg',
                        controller: 'resourceModalCtrl as resourceModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            resourceName: function () {
                                return resource;
                            }
                        }
                    });
                    modalInstance.result.then(function (resourceId) {
                        vm.resourceArr.push({
                            service: resource.type,
                            id: resourceId
                        });
                    }, function () {
                        resource.isChecked = false;
                    });
                };

                vm.fnInit = function () {
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 0);
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('scriptInfo', fnScriptInfo)

    /** @ngInject */
    function fnScriptInfo($http, $window, $state, $timeout, $base64, ScriptFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/script/scriptInfo/scriptInfo.html',
            scope: {
                scriptObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isScriptLoading = true;
                $scope.scripts = {};
                $scope.scriptType = "";

                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "javascript",
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)
                        };
                        $scope.readOnlyFalse = function () {
                            $scope.editorOptions.readOnly = false;
                        };
                        $scope.readOnlyTrue = function () {
                            $scope.editorOptions.readOnly = true;
                        };
                    }
                };

                $scope.value = {};
                $scope.availableDataLibs = ['common_S4'];

                $scope.tabs = [
                    {
                        title: 'Code',
                        tabIndex: 1,
                        templateUrl: 'app/access/script/scriptInfo/scriptSteps/details.html'
                    }
                ];

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetScriptData = function (scriptType) {
                    $scope.isScriptDataLoading = true;
                    var inputObj = {
                        type: scriptType
                    };
                    ScriptFactory.describeScript(inputObj)
                        .then(function (response) {
                            $scope.scriptObj = _.cloneDeepWith(response);
                            $scope.scriptObj.name = toUpper(scriptType.replace(/_/g, " "));
                            $scope.scriptObj.type = scriptType;
                            $scope.scriptConfigObj = {
                                scriptBody: response.script
                            };
                            $scope.isScriptEditable = false;
                            $scope.isScriptDataLoading = false;
                            $timeout(function () {
                                $timeout(function () {
                                    //$scope.modeChanged();
                                    $scope.fnSetTabHeight();
                                }, 100);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isScriptDataLoading = false;
                        });

                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.scripts', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        angular.element(".tabContent1").css('height', (finalHeight - (aboutText)) + 'px');
                    }
                };

                $scope.selectedNewTab = 1;

                $scope.fnChangeToEditable = function () {
                    $scope.resetScriptBody = _.cloneDeepWith($scope.scriptConfigObj.scriptBody);
                    $scope.isScriptEditable = true;
                    //$scope.readOnlyFalse();
                };

                $scope.fnCancelEditable = function () {
                    $timeout(function () {
                        $scope.scriptConfigObj.scriptBody = _.cloneDeepWith($scope.resetScriptBody);
                        $scope.isScriptEditable = false;
                        //$scope.readOnlyTrue();
                    })
                };

                $scope.fnSaveScript = function () {
                    $scope.isSaveChanges = true;
                    var input = {
                        type: $scope.scriptType,
                        body: {
                            "scriptType": $scope.scriptObj.scriptType,
                            "context": $scope.scriptObj.context,
                            "script": $scope.value.getData()
                        }
                    };
                    ScriptFactory.updateScript(input).then(function (response) {
                        $scope.isSaveChanges = false;
                        $scope.scriptObj = _.cloneDeepWith(response);
                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                        $scope.scriptObj.type = $scope.scriptType;
                        $scope.scriptConfigObj = {
                            scriptBody: response.script
                        };
                        $scope.isScriptEditable = false;
                        $scope.selectedNewTab = 1;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                        amaran.success("Scripts update successfully");
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        $scope.isSaveChanges = false;
                        $scope.scriptConfigObj = {
                            scriptBody: $scope.scriptObj.script
                        };
                        $scope.isScriptEditable = false;
                        $timeout(function () {
                            $scope.readOnlyTrue();
                        });
                    });
                };

                $scope.fnResetScript = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this script back to its original script. All the current script settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.scriptType
                                };
                                ScriptFactory.resetScript(inputObj)
                                    .then(function (response) {
                                        $scope.scriptObj = _.cloneDeepWith(response);
                                        $scope.scriptObj.name = toUpper($scope.scriptType.replace(/_/g, " "));
                                        $scope.scriptObj.type = $scope.scriptType;
                                        $scope.scriptConfigObj = {
                                            scriptBody: response.script
                                        };
                                        $scope.isScriptEditable = false;
                                        $timeout(function () {
                                            //$scope.readOnlyTrue();
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitScript = function () {
                    $scope.scriptType = _.cloneDeepWith($scope.scriptObj.type);
                    if ($scope.scriptObj.type) {
                        $scope.fnGetScriptData($scope.scriptObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('federationInfo', fnFederationInfo)

    /** @ngInject */
    function fnFederationInfo($window, $state, $stateParams, microSpinner, $timeout, swal, amaran, FederationsFactory, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/federation/federationInfo/federationInfo.html',
            scope: {
                federationObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false //d
                };

                if ($scope.federationObj.type === 'OUTBOUND') {
                    $scope.tabs = [
                        {
                            title: 'Details',
                            tabIndex: 1,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/details.html',
                            visible: true
                        },
                        {
                            title: 'Teams',
                            tabIndex: 2,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/federationTeams/federationTeams.html',
                            visible: true
                        },
                        {
                            title: 'Tags',
                            tabIndex: 3,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/federationSupplemental/federationSupplemental.html',
                            visible: true
                        }
                    ];
                } else {
                    $scope.tabs = [
                        {
                            title: 'Details',
                            tabIndex: 1,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/details.html',
                            visible: true
                        },
                        {
                            title: 'S4',
                            tabIndex: 2,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/federationScript/federationScript.html',
                            visible: true
                        },
                        {
                            title: 'Tags',
                            tabIndex: 3,
                            templateUrl: 'app/access/federation/federationInfo/federationSteps/federationSupplemental/federationSupplemental.html',
                            visible: true
                        }
                    ];
                }
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        if ($scope.tabs[parseInt($stateParams.selectedDetailsTab) - 1].visible === true) {
                            $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                        } else {
                            $scope.selectedTab = 1;
                        }
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetFederation = function (federationId) {
                    var inputObj = {
                        federationId: federationId
                    };
                    FederationsFactory.describeFederation(inputObj)
                        .then(function (response) {
                            $scope.federationObj = response;
                            $scope.resetFederationObj = angular.copy($scope.federationObj);
                            if (angular.isUndefined($scope.federationObj.description)) {
                                $scope.federationObj.description = '';
                            }
                            $scope.isFederationDetailsLoaded = true;
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isFederationDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.federations', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateFederationDetails = function (federationObj, field) {
                    var inputObj = {
                        body: {},
                        federationId: federationObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(federationObj.description)) {
                        federationObj.description = '';
                    }

                    if (field) {
                        inputObj.body[field] = $scope.federationObj[field]
                    } else {
                        inputObj.body = {
                            alias: federationObj.alias,
                            type: federationObj.type,
                            description: federationObj.description
                        }
                    }
                    FederationsFactory.updateFederation(inputObj)
                        .then(function (response) {
                            $scope.$emit('federationDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Federation Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteFederation = function (federationObj) {
                    swal({
                            title: "Delete the selected federation?",
                            text: "You are about to permanently delete the selected federation.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    federationId: federationObj.id
                                };
                                FederationsFactory.deleteFederation(inputObj)
                                    .then(function () {
                                        $scope.$emit('federationDeleted', federationObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function () {
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.federationObj = angular.copy($scope.resetFederationObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitFederation = function () {
                    $scope.isFederationDetailsLoaded = false;
                    $scope.federationId = $scope.federationObj.id;
                    if ($scope.federationId) {
                        $scope.fnGetFederation($scope.federationId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitFederation();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                var federationInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.federations') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                $scope.fnDeleteFederation($scope.federationObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69] &&
                                !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Modify
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            }
                        }
                    }
                };

                var federationInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.federations') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', federationInfoKeyDownEventHandler);
                document.addEventListener('keyup', federationInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', federationInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', federationInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createFederationCtrl',
            function ($scope, $timeout, amaran, FederationsFactory) {

                var vm = this;
                vm.title = "Create Federation";
                vm.newfederationObj = {
                    alias: '',
                    description: '',
                    accountId: ''
                };

                vm.fnCreateNewFederation = function (newfederationObj) {
                    vm.isFederationCreating = true;
                    var inputObj = {
                        body: {
                            alias: newfederationObj.alias,
                            description: newfederationObj.description
                        },
                        outboundAccountId: newfederationObj.accountId
                    };

                    FederationsFactory.createFederation(inputObj)
                        .then(function (resObj) {
                            vm.isFederationCreating = false;
                            $scope.federations.fnHideShowCreateForm(); //parent function

                            vm.newfederationObj = {
                                alias: '',
                                description: '',
                                accountId: ''
                            };
                            $timeout(function () { // set table height
                                $scope.federations.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.$emit('federationAdded', resObj.id);

                            $scope.federations.totalItems = $scope.federations.totalItems + 1;
                            $scope.federations.federationsArr.push(resObj);
                            $scope.federations.fnReload();

                            amaran.success("Federation created successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFederationCreating = false;
                        });
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('emailTemplateInfo', fnEmailTemplateInfo)

    /** @ngInject */
    function fnEmailTemplateInfo($http, $window, $state, $timeout, $base64, EmailTemplateFactory, $stateParams, $uibModal, $rootScope, DB, BatchFactory, microSpinner, swal, amaran, copyService, postActionModelIcon, postActionModelMessage) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/emailTemplate/emailTemplateInfo/emailTemplateInfo.html',
            scope: {
                emailTemplateObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });

                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                $scope.isShowPrviewRenderedHTML = true;
                $scope.isEmailTemplateLoading = true;
                $scope.emailTemplates = {};
                $scope.activeTabIndex = 1;
                $scope.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                $scope.isEmailValid = true;
                $scope.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "xml",
                    htmlMode: true,
                    matchBrackets: true,
                    gutters: ["gutter-error", "CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    indentWithTabs: true,
                    smartIndent: true,
                    extraKeys: {"Ctrl-Space": "autocomplete"},
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        $scope.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        $scope.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        $scope.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        };
                        $scope.setLine = function (errors) {
                            $timeout(function () {
                                _cm.clearGutter('gutter-error');
                                if (errors && errors.length) {
                                    for (var i = 0; i < errors.length; i++) {
                                        var error = errors[i];
                                        var errorLine = error.line - 1;
                                        var marker = document.createElement("div");
                                        marker.setAttribute('class', 'CodeMirror-lint-marker-error');
                                        marker.setAttribute('data-toggle', 'tooltip');
                                        marker.setAttribute('data-placement', 'auto');
                                        marker.setAttribute('title', error.message);
                                        _cm.setGutterMarker(errorLine, 'gutter-error', marker);
                                    }
                                }
                            }, 0)

                        };
                        _cm.on("changes", function () {
                            $scope.isValidTemplate = false;
                        });
                        $scope.getString = function () {
                            return _cm.getSelection();
                        };

                        $scope.replaceString = function (str) {
                            return _cm.replaceSelection(str);
                        };

                    }
                };
                $scope.isValidTemplate = true;
                $scope.emailTemplateType = "";
                $scope.isShowVariables = false;

                $scope.tabs = [
                    {
                        title: 'Template',
                        tabIndex: 1,
                        templateUrl: 'app/access/emailTemplate/emailTemplateInfo/emailTemplateSteps/details.html'
                    }
                ];

                $scope.bold = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<b>' + string + '</b>');
                };

                $scope.italic = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<i>' + string + '</i>');
                };

                $scope.underline = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<u>' + string + '</u>');
                };

                $scope.strike = function () {
                    var string = $scope.getString();
                    $scope.replaceString('<span style="text-decoration: line-through;">' + string + '</span>');
                };

                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }

                $scope.fnGetEmailTemplateData = function (emailTemplateType) {
                    $scope.isEmailTemplateDataLoading = true;
                    var inputObj = {
                        type: emailTemplateType
                    };
                    EmailTemplateFactory.describeEmailTemplate(inputObj)
                        .then(function (response) {
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper(emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.isEmailTemplateDataLoading = false;
                                $scope.fnSetTabHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isEmailTemplateDataLoading = false;
                        });
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.emailTemplate', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                        if (angular.element(".loderDiv")[0]) {
                            angular.element(".loderDiv").css('height', total - (tabHeader + footer) + 'px');
                        }
                        var aboutText = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".aboutText")[0]) ? angular.element(".aboutText")[0].offsetHeight : 0;
                        var emailTemplateToolbar = $scope.isDetailsEditable ? 0 : angular.isDefined(angular.element(".email-template-toolbar")[0]) ? angular.element(".email-template-toolbar")[0].offsetHeight : 0;
                        angular.element(".email-body").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".email-template").css('height', (finalHeight - (emailTemplateToolbar)) + 'px');
                        angular.element(".tabContent1").css('height', (finalHeight - (42 + aboutText)) + 'px');
                        angular.element(".emailConfigurationInfo").css('height', (finalHeight - (42 + aboutText)) + 'px');
                    }
                };

                $scope.fnViewRenderedHTML = function (isRender) {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                    if (isRender) {
                        $scope.isShowPrviewRenderedHTML = true;
                    } else {
                        $scope.isShowPrviewRenderedHTML = !$scope.isShowPrviewRenderedHTML;
                    }
                    $timeout(function () {
                        if ($scope.isShowPrviewRenderedHTML) {
                            var string = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isTemplateLoading = true;
                            $http({
                                method: 'POST',
                                url: 'https://api.mjml.io/v1/render',
                                config: {},
                                data: {
                                    "mjml": string
                                }
                            }).success(function (res) {
                                $scope.isTemplateLoading = false;
                                if (res.errors && res.errors.length) {
                                    $scope.isValidTemplate = false;
                                    $scope.setLine(_.cloneDeepWith(res.errors));
                                } else {
                                    $scope.isValidTemplate = true;
                                    //$scope.setLine([]);
                                }
                                $timeout(function () {
                                    var element = document.getElementById('htmlParse');
                                    element.innerHTML = res.html; //eslint-disable-line
                                });
                                $timeout(function () {
                                    $scope.fnSetTabHeight();
                                });
                            });
                        } else {
                            if ($scope.isTemplateEditable) {
                                $timeout(function () {
                                    $scope.readOnlyFalse();
                                    $scope.fnValidateTemplate();
                                });
                            }
                            $timeout(function () {
                                $scope.fnSetTabHeight();
                                $scope.modeChanged();
                            });
                        }
                    });
                };

                $scope.fnCheckEmail = function () {
                    var patt = new RegExp($scope.emailPattern);
                    $scope.isEmailValid = patt.test($scope.templateConfigObj.emailFrom);
                };

                $scope.fnChangeToEditable = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        $timeout(function () {
                            $scope.resetHtmlbody = _.cloneDeepWith($scope.templateConfigObj.mjmlBody);
                            $scope.isShowPrviewRenderedHTML = false;
                            $scope.isTemplateEditable = true;
                            $timeout(function () {
                                $scope.readOnlyFalse();
                                $scope.fnValidateTemplate();
                            });
                        })
                    } else {
                        $timeout(function () {
                            $scope.fnViewRenderedHTML(true);
                            $scope.templateConfigObj.mjmlBody = _.cloneDeepWith($scope.resetHtmlbody);
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $scope.ReadOnlyTrue();
                            });
                        });
                    }
                };

                $scope.fnValidateTemplate = function () {
                    $scope.isValidatingTemplate = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        $scope.isValidatingTemplate = false;
                        if (res.errors && res.errors.length) {
                            $scope.isValidTemplate = false;
                            $scope.setLine(_.cloneDeepWith(res.errors));
                        } else {
                            $scope.isValidTemplate = true;
                            $scope.setLine([]);
                        }
                    });
                };

                $scope.fnSaveEmailTemplate = function () {
                    $scope.isSaveChanges = true;
                    $http({
                        method: 'POST',
                        url: 'https://api.mjml.io/v1/render',
                        config: {},
                        data: {
                            "mjml": $scope.templateConfigObj.mjmlBody
                        }
                    }).success(function (res) {
                        var input = {
                            type: $scope.emailTemplateObj.type,
                            body: {}
                        };
                        input.body = {
                            "templateType": $scope.emailTemplateObj.templateType,
                            "context": $scope.emailTemplateObj.context,
                            "body": res.mjml,
                            "from": $scope.templateConfigObj.emailFrom,
                            "subject": $scope.templateConfigObj.emailSubject,
                            "variables": $scope.emailTemplateObj.variables
                        };
                        EmailTemplateFactory.updateEmailTemplate(input).then(function (response) {
                            $scope.isSaveChanges = false;
                            $scope.emailTemplateObj = _.cloneDeepWith(response);
                            $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                            $scope.emailTemplateObj.type = $scope.emailTemplateType;
                            $scope.templateConfigObj = {
                                emailFrom: response.from,
                                mjmlBody: response.body,
                                emailSubject: response.subject,
                                emailVariables: response.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                            $timeout(function () {
                                $timeout(function () {
                                    $scope.fnViewRenderedHTML(true);
                                });
                            });
                            amaran.success("Template update successfully");
                        }, function () {
                            $scope.isSaveChanges = false;
                            $scope.templateConfigObj = {
                                emailFrom: $scope.emailTemplateObj.from,
                                mjmlBody: $scope.emailTemplateObj.body,
                                emailSubject: $scope.emailTemplateObj.subject,
                                emailVariables: $scope.emailTemplateObj.variables
                            };
                            $scope.isValidTemplate = true;
                            $scope.isTemplateEditable = false;
                        });
                    });
                };

                $scope.fnResetEmailTemplate = function () {
                    swal({
                            title: "Restore Default?",
                            text: "You are about to reset this email back to its original template. All the current email settings will be erased.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Restore",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    type: $scope.emailTemplateObj.type
                                };
                                EmailTemplateFactory.resetEmailTemplate(inputObj)
                                    .then(function (response) {
                                        $scope.emailTemplateObj = _.cloneDeepWith(response);
                                        $scope.emailTemplateObj.name = toUpper($scope.emailTemplateType.replace(/_/g, " "));
                                        $scope.emailTemplateObj.type = $scope.emailTemplateType;
                                        $scope.templateConfigObj = {
                                            emailFrom: response.from,
                                            mjmlBody: response.body,
                                            emailSubject: response.subject,
                                            emailVariables: response.variables
                                        };
                                        $scope.isValidTemplate = true;
                                        $scope.isTemplateEditable = false;
                                        $scope.isShowVariables = false;
                                        $timeout(function () {
                                            $timeout(function () {
                                                $scope.fnViewRenderedHTML(true);
                                            });
                                        });
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnInitEmailTemplate = function () {
                    $scope.emailTemplateType = _.cloneDeepWith($scope.emailTemplateObj.type);
                    if ($scope.emailTemplateObj.type) {
                        $scope.fnGetEmailTemplateData($scope.emailTemplateObj.type);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('createAuthenticatorCtrl',
            function ($scope, amaran, AuthenticatorFactory, $timeout, PermissionsService, VaultsFactory, QueryFactory, $log) {
                var vm = this;

                vm.title = "Create Authenticator";
                vm.isTypesLoading = true;
                vm.newAuthenticatorObj = {
                    name: '',
                    description: '',
                    typeId: '',
                    vaultId: ''
                };
                vm.selectedType = '';
                vm.selectedVault = '';
                var totalItems = 0;
                var totalVaultItems = 0;
                var dataLimit = 100;

                function parseAuthTypeData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing auth type data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            return {
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };
                        } catch (error) {
                            $log.error('Error parsing item in parseAuthTypeData:', error, item);
                            return item;
                        }
                    });
                }

                function parseVaultData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing vault data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            return {
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };
                        } catch (error) {
                            $log.error('Error parsing item in parseVaultData:', error, item);
                            return item;
                        }
                    });
                }

                vm.fnCreateNewAuthenticator = function (newAuthenticatorObj) {
                    vm.isAuthenticatorCreating = true;
                    var inputObj = {
                        body: newAuthenticatorObj
                    };
                    AuthenticatorFactory.createAuthenticator(inputObj)
                        .then(function (resObj) {
                            vm.isAuthenticatorCreating = false;
                            $scope.authenticators.fnHideShowCreateForm(); //parent function
                            vm.newAuthenticatorObj = {
                                name: '',
                                description: '',
                                typeId: '',
                                vaultId: ''
                            };
                            $timeout(function () { // set table height
                                $scope.authenticators.fnSetTableHeight();//parent function
                            }, 800);
                            $scope.authenticators.totalItems = $scope.authenticators.totalItems + 1;
                            $scope.authenticators.authenticatorsArr.push(resObj);
                            $scope.$emit('authenticatorAdded');
                            amaran.success("Authenticator created successfully");
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAuthenticatorCreating = false;
                        });
                };

                vm.fnTypeSelected = function (selectedType) {
                    vm.newAuthenticatorObj.typeId = selectedType.id;
                };

                vm.fnVaultSelected = function (selectedVault) {
                    vm.newAuthenticatorObj.vaultId = selectedVault.id;
                };

                vm.fnGetVaults = function (inputObj, previousData, isNextData) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) { // Success block
                            if (isNextData === false) {
                                totalVaultItems = _.cloneDeepWith(response.data[0].totalItems);
                            }
                            var parsedData = parseVaultData(response.data);
                            var vaults = isNextData ? previousData : [];
                            _.forEach(parsedData, function (vaultObj) {
                                vaults.push(vaultObj);
                            });
                            if ((parsedData && parsedData.length > 0) && (totalVaultItems > vaults.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_vaults';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + vaults[vaults.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                                vm.fnGetVaults({sql: sqlString}, vaults, true);
                            } else {
                                vm.vaultsArr = _.cloneDeepWith(vaults);
                                vm.isTypesLoading = false;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTypesLoading = false;
                        })
                };

                vm.fnGetAuthenticatorTypes = function (inputObj, previousData, isNextData) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) { // Success block
                            if (isNextData === false) {
                                totalItems = _.cloneDeepWith(response.data[0].totalItems);
                            }
                            var parsedData = parseAuthTypeData(response.data);
                            var authenticators = isNextData ? previousData : [];
                            _.forEach(parsedData, function (vaultObj) {
                                authenticators.push(vaultObj);
                            });
                            if ((parsedData && parsedData.length > 0) && (totalItems > authenticators.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_authenticator_types';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + authenticators[authenticators.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                                vm.fnGetAuthenticatorTypes({sql: sqlString}, authenticators, true);
                            } else {
                                vm.typesArr = _.cloneDeepWith(authenticators);
                                var vaultSql = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_vaults ORDER BY rt asc LIMIT ' + dataLimit + ';';
                                vm.fnGetVaults({sql: vaultSql}, [], false);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTypesLoading = false;
                        })

                };

                vm.fnInitCreateAuthenticator = function () {
                    vm.isTypesLoading = true;
                    var inputObj = {
                        sql: 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_authenticator_types ORDER BY rt asc LIMIT ' + dataLimit + ';'
                    };
                    vm.fnGetAuthenticatorTypes(inputObj, [], false);
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('authenticatorInfo', fnAuthenticatorInfo)

    /** @ngInject */
    function fnAuthenticatorInfo($window, $state, $stateParams, $timeout, microSpinner, swal, amaran, AuthenticatorFactory, VaultsFactory, copyService, PermissionsService, postActionModelIcon, postActionModelMessage, QueryFactory) {
        return {
            restrict: 'EA',
            replace: false,
            templateUrl: 'app/access/authenticator/authenticatorInfo/authenticatorInfo.html',
            scope: {
                authenticatorObj: '=',
                userPermissionsObj: '='
            },
            link: function ($scope) {
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    $scope.fnSetTabHeight();
                });
                var windowSize = angular.element($window);
                $scope.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                var codeset = {
                    38: false, //up arrow
                    69: false, //e
                    68: false, //d
                    85: false //u
                };
                var totalItems = 0;
                var dataLimit = 100;
                var totalVaultItems = 0;

                $scope.tabs = [
                    {
                        title: 'Details',
                        tabIndex: 1,
                        templateUrl: 'app/access/authenticator/authenticatorInfo/authenticatorSteps/details.html'
                    },/* {
                        title: 'Users',
                        tabIndex: 2,
                        templateUrl: 'app/access/authenticator/authenticatorInfo/authenticatorSteps/authenticatorUsers/authenticatorUsers.html'
                    },*/ {
                        title: 'Tags',
                        tabIndex: 2,
                        templateUrl: 'app/access/authenticator/authenticatorInfo/authenticatorSteps/authenticatorSupplemental/authenticatorSupplemental.html'
                    }
                ];
                if ($stateParams.selectedDetailsTab && $stateParams.selectedDetailsTab > 0) {
                    if ($scope.tabs.length >= parseInt($stateParams.selectedDetailsTab)) {
                        $scope.selectedTab = parseInt($stateParams.selectedDetailsTab);
                    } else {
                        $scope.selectedTab = 1;
                    }
                } else {
                    $scope.selectedTab = 1;
                }
                $scope.isDetailsEditable = false;
                $scope.isUpdateCompleted = true;

                $scope.fnGetAuthenticator = function (authenticatorId) {
                    var inputObj = {
                        authenticatorId: authenticatorId
                    };
                    AuthenticatorFactory.describeAuthenticator(inputObj)
                        .then(function (response) {
                            $scope.authenticatorObj = response;
                            $scope.resetAuthenticatorObj = angular.copy($scope.authenticatorObj);
                            if (angular.isUndefined($scope.authenticatorObj.description)) {
                                $scope.authenticatorObj.description = '';
                            }
                            var inputObj = {
                                sql: 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_authenticator_types ORDER BY rt asc LIMIT ' + dataLimit + ';'
                            };
                            $scope.fnGetTypes(inputObj, [], false);
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAuthenticatorDetailsLoaded = true;
                        })
                };

                $scope.fnGetTypes = function (inputObj, previousData, isNextData) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) { // Success block
                            if (isNextData === false) {
                                totalItems = _.cloneDeepWith(response.data[0].totalItems);
                            }
                            var authenticators = isNextData ? previousData : [];
                            _.forEach(response.data, function (vaultObj) {
                                authenticators.push(vaultObj);
                            });
                            if ((response.data && response.data.length && response.data.length > 0) && (totalItems > authenticators.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_authenticator_types';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + authenticators[authenticators.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                                $scope.fnGetTypes({sql: sqlString}, authenticators, true);
                            } else {
                                $scope.typesArr = _.cloneDeepWith(authenticators);
                                $scope.selectedType = _.find($scope.typesArr, {id: $scope.authenticatorObj.typeId});
                                var vaultSql = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_vaults ORDER BY rt asc LIMIT ' + dataLimit + ';';
                                $scope.fnGetVaults({sql: vaultSql}, [], false);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAuthenticatorDetailsLoaded = true;
                        })
                };

                $scope.fnGetVaults = function (inputObj, previousData, isNextData) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (response) { // Success block
                            if (isNextData === false) {
                                totalVaultItems = _.cloneDeepWith(response.data[0].totalItems);
                            }
                            var vaults = isNextData ? previousData : [];
                            _.forEach(response.data, function (vaultObj) {
                                vaults.push(vaultObj);
                            });
                            if ((response.data && response.data.length && response.data.length > 0) && (totalVaultItems > vaults.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_vaults';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + vaults[vaults.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                                $scope.fnGetVaults({sql: sqlString}, vaults, true);
                            } else {
                                $scope.vaultsArr = _.cloneDeepWith(vaults);
                                $scope.selectedVault = _.find($scope.vaultsArr, {id: $scope.authenticatorObj.vaultId});
                                $scope.isAuthenticatorDetailsLoaded = true;
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isAuthenticatorDetailsLoaded = true;
                        })
                };

                $scope.fnTabSelected = function (tab) {
                    $scope.selectedTab = tab.tabIndex;
                    $timeout(function () {
                        $state.go('main.authenticators', {selectedDetailsTab: $scope.selectedTab}, {notify: false});
                        $stateParams.selectedDetailsTab = $scope.selectedTab;
                    })
                };

                $scope.fnUpdateAuthenticatorDetails = function (authenticatorObj) {
                    var inputObj = {
                        body: {},
                        authenticatorId: authenticatorObj.id
                    };
                    $scope.isUpdateCompleted = false;
                    $scope.isDetailsEditable = false;

                    if (angular.isUndefined(authenticatorObj.description)) {
                        authenticatorObj.description = '';
                    }
                    inputObj.body = {
                        name: authenticatorObj.name,
                        description: authenticatorObj.description,
                        typeId: authenticatorObj.typeId,
                        vaultId: authenticatorObj.vaultId
                    };
                    AuthenticatorFactory.updateAuthenticator(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            $scope.$emit('AuthenticatorDetailsChanged', response);
                            $scope.isUpdateCompleted = true;
                            amaran.success("Authenticator Updated Successfully");
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            $scope.isUpdateCompleted = true;
                        })
                };

                $scope.fnDeleteAuthenticator = function (authenticatorObj) {
                    swal({
                            title: "Delete the selected authenticator?",
                            text: "You are about to permanently delete the selected authenticator.<br/>" +
                                "You will not be able to recover any of the data related to it.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    authenticatorId: authenticatorObj.id
                                };
                                AuthenticatorFactory.deleteAuthenticator(inputObj)
                                    .then(function () {
                                        $scope.$emit('AuthenticatorDeleted', authenticatorObj);
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                $scope.fnChangeFieldsToEditable = function () {
                    $scope.isDetailsEditable = true;
                };

                $scope.fnResetDetails = function () {
                    $scope.authenticatorObj = angular.copy($scope.resetAuthenticatorObj);
                    $scope.isDetailsEditable = false
                };

                $scope.fnCopyToClipboard = function (value, duration) {
                    $scope.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        $scope.isCopyClicked = false;
                    }, duration)
                };

                $scope.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-footer")[0]) ? angular.element(".content-footer")[0].offsetHeight : 0;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeight = total - (tabHeader + footer + dashboardHeader);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                $scope.fnInitAuthenticator = function () {
                    $scope.vaultPermissionObj = PermissionsService.getPermissions("access:vault");
                    $scope.isAuthenticatorDetailsLoaded = false;
                    $scope.authenticatorId = $scope.authenticatorObj.id;
                    if ($scope.authenticatorId) {
                        $scope.fnGetAuthenticator($scope.authenticatorId);
                    }
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnInitAuthenticator();

                $scope.fnInitDetailTab = function () {
                    $timeout(function () {
                        $scope.fnSetTabHeight();
                    });
                };

                $scope.fnSwitchTab = function (title) {
                    var tabObj = _.find($scope.tabs, {title: title});
                    if (tabObj) {
                        $scope.selectedTab = tabObj.tabIndex;
                        $scope.$apply();
                    }
                };

                var authenticatorInfoKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.authenticators') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && $scope.userPermissionsObj.DELETE_AUTHENTICATOR) { //Create
                                $scope.fnDeleteAuthenticator($scope.authenticatorObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[69]
                                && !$scope.isDetailsEditable && $scope.selectedTab === 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && $scope.userPermissionsObj.UPDATE_AUTHENTICATOR) { //Create
                                $scope.fnChangeFieldsToEditable();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[69] = false;
                            } else if (codeset[38] && codeset[85] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                $scope.fnSwitchTab('Users');
                                codeset[38] = false;
                                codeset[85] = false;
                            }
                        }
                    }
                };

                var authenticatorInfoKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.authenticators') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', authenticatorInfoKeyDownEventHandler);
                document.addEventListener('keyup', authenticatorInfoKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', authenticatorInfoKeyDownEventHandler);
                    document.removeEventListener('keyup', authenticatorInfoKeyUpEventHandler);
                })
                /*-------End: Controller Code------*/
            }
        };
    }

})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PredictiveSupportCtrl',
            function ($timeout, $window) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.tabs = [{
                    title: 'ECSite Support',
                    tabIndex: 1,
                    templateUrl: 'app/user-settings/support/supportTab/supportTab.html',
                    visible: true
                }];

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 0; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitSupport = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('RecipesCtrl',
            function ($window, $timeout, $uibModal,DB) {
                var vm = this;

                vm.recipesArr = [];
                vm.filter = "$";
                vm.search = {$: ''};
                vm.isRecipesAvailable = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });


                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel1")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel1")[0].offsetHeight;
                        var finalHeight = total - (search + 32);
                        angular.element(".recipesFunctionModal").css('height', finalHeight + 'px');
                    }
                };
                /*END: TABLE*/

                vm.fnRecipesSelected = function (recipeObj) {
                    switch (recipeObj.id) {
                        case 1:
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/user-settings/recipes/modal/setupModal/setupModal.html',
                                size: 'lg',
                                controller: 'setupModalCtrl as setupModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    recipeObj: function () {
                                        return recipeObj
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                            }, function () {});
                            break;
                        case 2:
                            var modalInstanceForNodeConfigure = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/user-settings/recipes/modal/nodeConfigurationModal/nodeConfigurationModal.html',
                                size: 'lg',
                                controller: 'nodeConfigurationModalCtrl as nodeConfigurationModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    recipeObj: function () {
                                        return recipeObj
                                    }
                                }
                            });
                            modalInstanceForNodeConfigure.result.then(function () {
                            }, function () {});
                            break;
                        case 3:
                            var modalInstanceForAccessConfigure = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/user-settings/recipes/modal/accessConfigurationModal/accessConfigurationModal.html',
                                size: 'lg',
                                controller: 'accessConfigurationModalCtrl as accessConfigurationModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    recipeObj: function () {
                                        return recipeObj
                                    }
                                }
                            });
                            modalInstanceForAccessConfigure.result.then(function () {
                            }, function () {});
                            break;
                    }
                };

                vm.fnInitRecipes = function () {
                    var loginUser = DB.fnGet('loginUser');
                    vm.recipesArr = [{
                        id: 1,
                        name: "Support Federation",
                        description: "Create a Federation between your account and the predictive support account. This will allow ECSite support staff to access your account and perform task on your behalf. If you do not select a pre-existing security group during the setup a default one will be created with full administrative priviledges.",
                        permissionArr: [
                            {
                                "name": "Create Group",
                                "reviewStepName" : "Creating Group...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:group:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Create Role",
                                "reviewStepName" : "Creating Role...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:role:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Add Role to Group",
                                "reviewStepName" : "Adding Role to Group...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:group:AddRole",
                                "isAccess": false
                            },
                            {
                                "name": "Create Federation",
                                "reviewStepName" : "Creating Federation...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:federation:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Add Group to Federation",
                                "reviewStepName" : "Adding Group to Federation...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:federation:AddGroup",
                                "isAccess": false
                            }
                        ],
                        isVisible:loginUser.id.split("-")[0] !== "cu000000"
                    }, {
                        id: 2,
                        name: "Basic Node Configuration",
                        description: "Set up basic node configuration for your account.",
                        permissionArr: [
                            {
                                "name": "Create Health",
                                "reviewStepName" : "Creating basic Healths...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "node:health:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Create Notifications",
                                "reviewStepName" : "Creating Notification...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "node:notification:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Get Devices",
                                "reviewStepName" : "Fetching Devices",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "node:device:List",
                                "isAccess": false
                            },
                            {
                                "name": "Create Observers",
                                "reviewStepName" : "Creating Observers...",
                                "isVisible" : false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "node:observer:Create",
                                "isAccess": false
                            }
                        ],
                        isVisible:loginUser.id.split("-")[0] !== "cu000000"
                    }, {
                        id: 3,
                        name: "Basic Access Configuration",
                        description: "Set up basic access configuration for your account.",
                        permissionArr: [
                            {
                                "name": "Get Roles",
                                "reviewStepName": "Getting Roles...",
                                "isVisible": false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:role:List",
                                "isAccess": false
                            },
                            {
                                "name": "Create Roles",
                                "reviewStepName": "Creating basic Roles...",
                                "isVisible": false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:role:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Create Groups",
                                "reviewStepName": "Creating Groups...",
                                "isVisible": false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:group:Create",
                                "isAccess": false
                            },
                            {
                                "name": "Add role to Group",
                                "reviewStepName": "Adding Roles to Groups...",
                                "isVisible": false,
                                "isStepFinished": false,
                                "isErrorOccurred": false,
                                "permission": "access:group:AddRole",
                                "isAccess": false
                            }
                        ],
                        isVisible:loginUser.id.split("-")[0] !== "cu000000"
                    }];
                    var isAvailable = _.find(vm.recipesArr, {'isVisible': true });
                    if(isAvailable){
                        vm.isRecipesAvailable = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UserProfileCtrl',
            function ($scope, $window, $timeout, DB, PermissionsService, UserProfileService, UserFactory) {
                var vm = this;
                vm.isFederationChanging = false;
                vm.isLandingUrlChanging = false;
                vm.isUserDataChanging = false;
                vm.isUserDataEditable = false;
                var loginUser = DB.fnGet('loginUser');
                var userProfile = DB.fnGet('userProfile');
                vm.tabs = [{
                    title: 'About Me',
                    tabIndex: 1,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/aboutMe/aboutMe.html',
                    visible: true
                }, {
                    title: 'About My Account',
                    tabIndex: 2,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/aboutMyAccount/aboutMyAccount.html',
                    visible: true
                }, {
                    title: 'Password',
                    tabIndex: 3,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/password/password.html',
                    visible: true
                }, /*{
                    title: 'Privileges',
                    tabIndex: 4,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/privileges/privileges.html',
                    visible: true
                }, */{
                    title: 'API Keys',
                    tabIndex: 5,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/apiKeys/apiKeys.html',
                    visible: true
                },{
                    title: 'Multi Factor Authentication',
                    tabIndex: 6,
                    templateUrl: 'app/user-settings/profile/userProfileTabs/multiFactorAuthentication/multiFactorAuthentication.html',
                    visible: true
                }];

                vm.editorOptions = {
                    lineNumbers: true,
                    lineWrapping: true,
                    mode: "application/json",
                    gutters: ["CodeMirror-lint-markers"],
                    lint: true,
                    readOnly: true,
                    onLoad: function (_cm) {
                        // HACK to have the codemirror instance in the scope...
                        vm.modeChanged = function () {
                            $timeout(function () {
                                _cm.refresh();
                            }, 0)

                        };
                        vm.readOnlyFalse = function () {
                            _cm.setOption('readOnly', false);
                        };
                        vm.ReadOnlyTrue = function () {
                            _cm.setOption('readOnly', true);
                        }
                    }
                };
                vm.tabSelected = function (tab) {
                    if (tab.title === 'User data') {
                        $timeout(function () {
                            vm.modeChanged();
                        })
                    }
                };
                vm.fnToggle = function (isToggleReadOnlyFalse) {
                    if (isToggleReadOnlyFalse) {
                        vm.isUserDataEditable = true;
                        vm.readOnlyFalse();
                    } else {
                        vm.isUserDataEditable = false;
                        vm.userData = angular.copy(vm.resetUserData);
                        vm.ReadOnlyTrue();
                    }
                };
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnFederationSwitchToggle = function (fedSwitchValue) {
                    vm.isFederationChanging = true;
                    var userProfileData = _.cloneDeepWith(userProfile);
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.isFederationsEnabled = fedSwitchValue;
                    } else {
                        userProfileData.pre.home.all = {
                            isFederationsEnabled: fedSwitchValue
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };
                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            vm.isFederationChanging = false;
                            DB.fnSet('userProfile', response);
                            userProfile = response;
                            $scope.$emit('FederationSettingsChanged');
                        }, function () {
                            vm.isFederationChanging = false;
                        });
                    return userProfileData;
                };

                vm.fnSaveUserLandingPageSettings = function (landingUrl) {
                    vm.isLandingUrlChanging = true;
                    var userProfileData = _.cloneDeepWith(userProfile);
                    if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                        userProfileData.pre.home.all.isLandingUrlSet = landingUrl;
                    } else {
                        userProfileData.pre.home.all = {
                            isLandingUrlSet: landingUrl
                        };
                    }
                    var inputObj = {
                        body: userProfileData
                    };

                    UserFactory.updateUserProfile(inputObj)
                        .then(function (response) {
                            DB.fnSet('userProfile', response);
                            userProfile = response;
                            vm.isLandingUrlChanging = false;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnSaveUserData = function (userData) {
                    vm.isUserDataChanging = true;
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: userData
                    };
                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            vm.userData = angular.toJson(data.data, true);
                            vm.resetUserData = angular.copy(vm.userData);
                            vm.fnInitUserProfiles();
                            vm.isUserDataChanging = false;
                            vm.isUserDataEditable = false;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isUserDataChanging = false;
                        });
                };

                vm.fnInitUserProfiles = function () {
                    if (userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isFederationsEnabled) {
                        vm.fedSwitchValue = userProfile.pre.home.all.isFederationsEnabled;
                    } else {
                        vm.fedSwitchValue = false;
                    }
                    if (userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet) {
                        vm.landingUrl = loginUser.data.isLandingUrlSet;
                    } else {
                        vm.landingUrl = '';
                    }
                    if (loginUser.data) {
                        vm.userData = angular.toJson(loginUser.data, true);
                        vm.resetUserData = angular.copy(vm.userData);
                    }
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PreferencesCtrl',
            function ($base64, $scope, $window, $timeout) {
                var vm = this;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.tabs = [{
                    title: 'Color Theme',
                    tabIndex: 1,
                    templateUrl: 'app/user-settings/preferences/preferencesTab/colorTheme/colorTheme.html',
                    visible: true
                }, {
                    title: 'Landing Page',
                    tabIndex: 2,
                    templateUrl: 'app/user-settings/preferences/preferencesTab/landingPage/landingPage.html',
                    visible: true
                }, {
                    title: 'Advanced',
                    tabIndex: 3,
                    templateUrl: 'app/user-settings/preferences/preferencesTab/advanced/advanced.html',
                    visible: true
                }];

                vm.fnInitPreferences = function () {
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    });
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UserAccountCtrl',
            function ($window, $cookies, WizardHandler, DB, amaran, copyService, SessionFactory, UserFactory) {
                var vm = this;
                vm.isAuthFieldsLoading = true;
                vm.isPasswordChanging = false;
                vm.isDetailsEditable = false;
                vm.isUserDetailsChanging = false;
                vm.oldPassword = '';
                vm.newPassword = '';
                vm.confirmPassword = '';
                vm.inputType = 'password';
                vm.inputTypeConfirm = 'password';
                var loginUser = DB.fnGet("loginUser");
                vm.tabs = [{
                    title: 'Details',
                    tabIndex: 1,
                    templateUrl: 'app/user-settings/account/accountInfo/details.html'
                },
                {
                    title: 'Change Password',
                    tabIndex: 2,
                    templateUrl: 'app/user-settings/account/accountInfo/passwordChange.html'
                }];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if(angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 38; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAuthFields = function () {
                    vm.isAuthFieldsLoading = true;
                    vm.userFields = [];
                    var inputObj = {
                        type: "email",
                        identifier: loginUser.email
                    };
                    SessionFactory.describeUserAuthenticationMethod(inputObj)
                        .then(function (response) {
                            var authObj = {
                                type: response.type,
                                key: response.fields[0].key,
                                templateOptions: response.fields[0].templateOptions
                            };
                            authObj.type = "md-password";
                            authObj.templateOptions.isHide = true;
                            vm.userFields.push(authObj);
                            vm.isAuthFieldsLoading = false;
                        }, function () {
                            vm.isAuthFieldsLoading = false;
                        });
                };

                vm.fnChangePassword = function () {
                    vm.isPasswordChanging = true;
                    var userInputObj = {
                        userId: loginUser.id,
                        body: {
                            secret : vm.newPassword
                        }
                    };
                    UserFactory.updateUserPassword(userInputObj)
                        .then(function () {
                            amaran.success("Password updated successfully");
                            vm.newPassword = '';
                            vm.confirmPassword = '';
                            vm.userFields = [];
                            vm.isPasswordChanging = false;
                            WizardHandler.wizard().goTo(0);
                        }, function (error) {
                            amaran.error(error.errorMessage);
                            vm.newPassword = '';
                            vm.confirmPassword = '';
                            vm.userFields = [];
                            vm.isPasswordChanging = false;
                            WizardHandler.wizard().goTo(0);
                        })
                };

                vm.hideShowPassword = function () {
                    if (vm.inputType === 'password') {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                };

                vm.hideShowPasswordConfirm = function () {
                    if (vm.inputTypeConfirm === 'password') {
                        vm.inputTypeConfirm = 'text';
                    } else {
                        vm.inputTypeConfirm = 'password';
                    }
                };

                vm.fnUpdateUserDetails = function (userObj) {
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    vm.isUserDetailsChanging = true;

                    if (angular.isUndefined(userObj.bio)) {
                        userObj.bio = '';
                    }

                    inputObj.body = {
                        name: userObj.name,
                        bio: userObj.bio
                    };
                    UserFactory.updateUser(inputObj)
                        .then(function (response) {
                            loginUser.name = response.name;
                            if(response.bio) {
                                loginUser.bio = response.bio;
                            }
                            DB.fnSet("loginUser", loginUser);
                            vm.isUserDetailsChanging = false;
                            vm.isDetailsEditable = false;
                            amaran.success("User details updated successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUserDetailsChanging = false;
                            vm.isDetailsEditable = false;
                        })
                };

                vm.fnResetValues = function () {
                    vm.isDetailsEditable = false;
                    vm.user = angular.copy(vm.resetUserObj)
                };

                vm.fnCopyInputText = function (data, type) {
                    if(type === 'Email') {
                        data = '@' + data.split("<?>@")[1];
                    }
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnInitUserAccount = function () {
                    vm.user = angular.copy(loginUser);
                    vm.user.accountId = vm.user.id.split("-")[0].trim();
                    if(Object.keys(HOST_URL).length) { //eslint-disable-line
                        var url = HOST_URL[Object.keys(HOST_URL)[0]].split("https://")[1]; //eslint-disable-line
                        vm.stage = '';
                        if (url.startsWith('dev')) {
                            vm.stage = '.notification-predictivetech.io';
                        } else {
                            vm.stage = '.predictivetech.io'
                        }
                    } else {
                        vm.stage = '.predictivetech.io';
                    }
                    vm.user.inboundEmail = "<?>@" + vm.user.accountId + vm.stage;
                    vm.resetUserObj = angular.copy(vm.user);
                    vm.fnSetTabHeight();
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AccessTokenCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, XLSX, amaran, swal, microSpinner, DB, LastPageService, PaginationService, BatchFactory, UserFactory, ApiKeyFactory, postActionModelIcon, postActionModelMessage, FedSudoUserService, jsonToCsvConvertService) {
                var vm = this;

                //Search Variables
                vm.isRefreshData = true;
                vm.isInit = true;
                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'INACTIVE', displayName: 'INACTIVE'}
                ];
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx-xxxxxxxx"
                    },{
                        displayName: "State",
                        name: "state",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.stateFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'state', displayName: 'State'}
                ];
                vm.filterQuery = "";

                //Access Token Variables
                vm.isAccessTokenLoading = false;
                vm.accessTokenArr = [];
                vm.selectedAccessTokenArr = [];
                vm.selectedAccessTokenObj = {};
                vm.isReload = false;
                vm.isTokenCreating = false;
                vm.isTokenDetailsChanging = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                vm.perPage = loginUser.data ? (loginUser.data.perPage ? parseInt(loginUser.data.perPage[0]) : 20) : 20;
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAccessTokenLoading = true;
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetAccessTokens();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterAccessTokenArr = [];
                    var accessTokenArr = [];
                    if (vm.accessTokenResponse.length) {
                        if (vm.filterQuery) {
                            filterAccessTokenArr = _.filter(vm.accessTokenResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterAccessTokenArr = _.cloneDeepWith(vm.accessTokenResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            accessTokenArr = _.orderBy(filterAccessTokenArr, [sortValue], [sortType]);
                        } else {
                            accessTokenArr = _.cloneDeepWith(filterAccessTokenArr);
                        }
                    }
                    vm.totalItems = accessTokenArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.accessTokenArr = accessTokenArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.access_token') {
                        $timeout(function () {
                            $state.go('main.access_token', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isAccessTokenLoading = false;
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = 0;
                        var finalHeight = total - (search + pagination + searchTag + 40);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (tokenObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.accessTokenArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === tokenObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected vault array*/
                    var isValueFind = _.find(vm.selectedAccessTokenArr, {'id': tokenObj.id});
                    if (!isValueFind) {
                        vm.selectedAccessTokenArr.push(tokenObj)
                    } else {
                        _.remove(vm.selectedAccessTokenArr, function (obj) {
                            return tokenObj.id === obj.id;
                        });
                    }

                    if (vm.selectedAccessTokenArr.length === 1) {
                        vm.selectedAccessTokenObj = vm.selectedAccessTokenArr[0];
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.accessTokenArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAccessTokenArr = angular.copy(vm.accessTokenArr);
                    } else {
                        vm.selectedAccessTokenArr = [];
                    }
                    if (vm.accessTokenArr.length === 1) {
                        vm.selectedAccessTokenObj = vm.accessTokenArr[0];
                    }

                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAccessTokenCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.accessTokenArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var vaultsArrCp = _.cloneDeepWith(vm.accessTokenArr);
                    var tempData = _.map(vaultsArrCp, function (tempObj) {
                        // delete tempObj.content;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "AccessToken");
                    XLSX.writeFile(wb, "access_token.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if(isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            vm.fnUpdateUserData(perPage);
                        } else {
                            FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAccessTokenLoading = true;
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetAccessTokens();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetAccessToken = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedAccessTokenArr = [tokenObj]; // Assign array with single token object
                    vm.selectedAccessTokenObj = tokenObj;
                };

                vm.fnGetAccessTokens = function (inputObj) {
                    ApiKeyFactory.listApiKeys(inputObj)
                        .then(function (res) { // Success block
                            vm.accessTokenResponse = _.cloneDeepWith(res);
                            vm.fnGetFilterData();
                            if ($state.current.name === 'main.access_token') {
                                $state.go('main.access_token', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                            }

                            vm.isAccessTokenLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAccessTokenLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnDeleteMultipleTokens = function (selectedAccessTokenArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedAccessTokenArr, function (selectedToken, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/api-keys/" + selectedToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/api-keys/" + selectedToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected access tokens?",
                            text: "You are about to permanently delete the selected access tokens.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'batch', appName: 'access'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccessTokenArr, function (selectedToken) {
                                    angular.forEach(vm.accessTokenArr, function (tokenObj, index) {
                                        if (selectedToken.id === tokenObj.id) {
                                            vm.accessTokenArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccessTokenArr.length;
                                vm.selectedAccessTokenObj = null;
                                vm.selectedAccessTokenArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccessTokenArr, function (selectedToken) {
                                    angular.forEach(vm.accessTokenArr, function (tokenObj, index) {
                                        if (selectedToken.id === tokenObj.id) {
                                            vm.accessTokenArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccessTokenArr.length;
                                vm.selectedAccessTokenObj = null;
                                vm.selectedAccessTokenArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnChangeStateOfToken = function (tokenObj) {
                    vm.isTokenDetailsChanging = true;
                    var inputObj = {
                        apikeyId: tokenObj.id,
                        body: {
                            "state": tokenObj.state === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE'
                        }
                    };
                    ApiKeyFactory.updateApiKeyState(inputObj)
                        .then(function (response) {
                            angular.forEach(vm.accessTokenArr, function (token) {
                                if (token.id === vm.selectedAccessTokenObj.id) {
                                    vm.selectedAccessTokenObj.state = response.state;
                                    token.state = response.state;
                                    vm.isTokenDetailsChanging = false;
                                    if(inputObj.body.state === 'ACTIVE') {
                                        amaran.success("State activated successfully")
                                    } else {
                                        amaran.success("State deactivated successfully")
                                    }
                                }
                            })
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTokenDetailsChanging = false;
                        })
                };

                vm.fnCreateNewToken = function () {
                    vm.selectedAccessTokenArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isTokenCreating = true;
                    ApiKeyFactory.createNewApiKey()
                        .then(function (resObj) {
                            vm.totalItems = vm.totalItems + 1;
                            vm.accessTokenArr.push(resObj);
                            vm.isTokenCreating = false;
                            vm.fnDownloadPrivateKey(resObj);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTokenCreating = false;
                        });
                };

                vm.fnDownloadPrivateKey = function (key) {
                    swal({
                            title: "Do you want to download the access-token?",
                            text: "You can download the access-token only once.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "download",
                            closeOnConfirm: true,
                            showLoaderOnConfirm: false
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var textFile = null,
                                    makeTextFile = function (text) {
                                        var data = new Blob([text], {type: 'text/plain'});

                                        // If we are replacing a previously generated file we need to
                                        // manually revoke the object URL to avoid memory leaks.
                                        if (textFile !== null) {
                                            $window.URL.revokeObjectURL(textFile);
                                        }

                                        textFile = $window.URL.createObjectURL(data);

                                        return textFile;
                                    };

                                var str = '';
                                str += 'Id : ' + key.id + ' \n';
                                str += 'Private Key : ' + key.privateKey + " \n";
                                str += 'State : ' + key.state + " \n";

                                var link = document.createElement('a');
                                link.href = makeTextFile(str);
                                link.download = "API_keys.txt";
                                link.click();
                            } else {
                                swal.close();
                            }
                        });
                };

                vm.fnInitAccessToken = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TypesCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      WidgetsListService, UserProfileService, amaran, ColorService, swal,
                      microSpinner, DB, XLSX, Authenticate, IconService, PermissionsService, LastPageService,
                      TypesFactory, ProjectFactory, BatchFactory, PaginationService, moment, FedSudoUserService,
                      postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, AppInitService,
                      PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                var tableName = 'tracker_types';
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.projectsArr = [];

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowTypeStats = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.typeProjectFilter = "$";
                vm.typeProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isTypesLoading = false;
                vm.typeArr = [];
                vm.selectedTypesArr = [];
                vm.selectedTypeObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.typeResponse = [];

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#typeTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.types', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isTypesLoading = true;
                    vm.selectedTypesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_types';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetTypes(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.typeArr);
                        vm.previousPage = page;
                        vm.fnGetTypes(input, false);
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'types', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isTypesLoading = true;
                    vm.selectedTypesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'types', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_types';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetTypes({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.typeArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedTypesArr = [];
                                vm.selectedTypeObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Type" && tab.id !== "PriorityStats" && tab.id !== "WidgetEditor" && tab.id !== 'Relationships') {
                                if (vm.isTypesLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedTypesArr = [];
                                    vm.selectedTypeObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.types', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Type";
                        vm.isShowUserStats = tab.id === "UserStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedPrioritiesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Type'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Type',
                                title: 'Create Type',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Type";
                    vm.isShowUserStats = tab.id === "PriorityStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Type" || tab.id === "Create Issue" || tab.id === "PriorityStats" || tab.id === "WidgetEditor" || tab.id === 'Relationships') {
                        $state.go('main.types', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedTypesArr = [];
                        vm.selectedTypeObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === 'Create Type') {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.types', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnGetTypeDetails = function (typeObj) {
                    vm.isTypesDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when priority is selected
                        vm.selectedTypeObj = typeObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.types', {
                                selectedId: vm.selectedTypeObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedTypeObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isTypesDetailsLoaded = true;
                        } else {
                            $state.go('main.types', {selectedId: vm.selectedTypeObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedTypeObj.id;
                            vm.isTypesDetailsLoaded = true;
                        }
                    })
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("TypeDeleted", function (evt, data) {
                    vm.selectedTypeObj = null;
                    vm.selectedTypesArr = [];
                    vm.typeArr = vm.typeArr.filter(function (typeObj) {
                        return (typeObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.types', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("TypeDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.typeArr, function (typeObj) {
                        if (typeObj.id === vm.selectedTypeObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedTypeObj[key] = val;
                                typeObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("typeAdded", function () {
                    vm.fnRemoveTab('Create Type');
                });

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.typeArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTypesArr = _.cloneDeepWith(vm.typeArr);
                    } else {
                        vm.selectedTypesArr = [];
                    }
                    $state.go('main.types', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'types', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.types", tempArr, {notify: false});
                    }
                };

                vm.fnInitTypes = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'types', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetTypes = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.typeResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.typeResponse.data && vm.typeResponse.data.length) {
                                    vm.totalItems = vm.typeResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.typeResponse.data.reverse();
                            }
                            vm.typeArr = _.cloneDeepWith(vm.typeResponse.data);
                            if ($stateParams.selectedId) {
                                var typeData = _.find(vm.typeArr, {"id": $stateParams.selectedId});
                                if (typeData) {
                                    vm.fnCheckUncheckHeader(typeData);
                                }
                            }
                            if ($state.current.name === 'main.types') {
                                $timeout(function () {
                                    $state.go('main.types', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10)
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isTypesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTypesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectType= function (projectObj) {
                    vm.isTypesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_types';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_types';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_types';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'types', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'types', 'selectedProject', '');
                    }
                    vm.fnGetTypes({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnOpenTypeInfoTab = function (typeObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(typeObj);
                };

                vm.fnSaveTypesInfo = function (typeObj) {
                    typeObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        typeId: typeObj.id
                    };
                    inputObj.body = {
                        name: typeObj.name,
                        description: angular.isUndefined(typeObj.description) ? '' : typeObj.description
                    };
                    TypesFactory.updateIssueType(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.typeArr, function (typeObj) {
                                if (Object.keys(vm.selectedTypeObj).length) {
                                    if (typeObj.id === vm.selectedTypeObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedTypeObj[key] = val;
                                            typeObj[key] = val;
                                        });
                                    }
                                }
                                if (typeObj.id === resetCopy.id) {
                                    typeObj.name = resetCopy.name;
                                    typeObj.description = resetCopy.description;
                                }
                            });
                            if(!DB.fnGet('federation') && !DB.fnGet('support')){
                                var typesArr = AppInitService.getInitData('issueTypesArr');
                                var index = _.findIndex(typesArr, {id: response.id});
                                if (index !== -1) {
                                    typesArr[index].name = response.name;
                                    typesArr[index].description = response.description;
                                    AppInitService.fnUpdateIssueTypesData(typesArr);
                                }
                            }
                            vm.fnCancelTypesEditMode(typeObj, true);
                            amaran.success("Type Updated Successfully");
                        }, function (error) {
                            vm.fnCancelTypesEditMode(typeObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                /*Start: Context Menu*/
                vm.resetEditTypesObj = {};

                vm.typesContextMenu = function (typeObj) {
                    if (Object.keys(vm.resetEditTypesObj).length) {
                        var isFindType = _.find(vm.typeArr, {id: vm.resetEditTypesObj.id});
                        if (isFindType) {
                            vm.fnCancelTypesEditMode(isFindType);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_TYPE) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                typeObj.isEditable = true;
                                vm.resetEditTypesObj = angular.copy(typeObj);
                            }
                        })
                    }
                    if (vm.permissionObj.CREATE_TYPE) {
                        tempArr.push({
                            text: 'Clone',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                vm.fnCloneType(typeObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };
                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getTypesCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.typeArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.typeArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Types");
                    XLSX.writeFile(wb, "types.xlsx");
                };
                /* Export Modal: End */

                vm.fnCheckUncheckHeader = function (typeObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_TYPE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.typeArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === typeObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedTypesArr, {'id': typeObj.id});
                        if (!isValueFind) {
                            vm.selectedTypesArr.push(typeObj);
                            var isTabExist = _.find(vm.tabs, {'id': typeObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: typeObj.id,
                                    title: typeObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedTypesArr, function (obj) {
                                return typeObj.id === obj.id;
                            });
                        }
                        if (vm.selectedTypesArr.length === 1) {
                            vm.fnGetTypeDetails(vm.selectedTypesArr[0])
                        } else {
                            $state.go('main.types', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnCancelTypesEditMode = function (typeObj, isSuccessCall) {
                    if (isSuccessCall) {
                        typeObj.name = angular.copy(typeObj.name);
                        typeObj.description = angular.copy(typeObj.description);
                        typeObj.isEditable = false;
                        vm.resetEditTypesObj = {};
                    } else {
                        typeObj.name = angular.copy(vm.resetEditTypesObj.name);
                        typeObj.description = angular.copy(vm.resetEditTypesObj.description);
                        typeObj.isEditable = false;
                        vm.resetEditTypesObj = {};
                    }
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get priorities color for the Types.
                vm.fnGetTypesColor = function (typeObj) {
                    if (angular.isDefined(typeObj.color)) {
                        vm.typeTextColor = vm.fnInvertColor(typeObj.color);
                        return {
                            "background-color": typeObj.color,
                            "color": "" + vm.typeTextColor
                        }
                    }
                };


                vm.fnGetTypeDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'types', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetTypeStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'TypeStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowTypeStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'TypeStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowTypeStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerTypesChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCloneType = function (typeObj) {
                    DB.fnSet('ClonedTypeObj', typeObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnGetTypeRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isTypeRelationshipsDataLoading = true;
                vm.newTypesArr = [];

                vm.fnInitTypeRelationships = function () {
                    vm.isTypeRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    var typeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_types ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAllTypeData({sql: typeSQL}, [], false);
                };

                vm.fnGetAllTypeData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var type = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                type.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (type[0] && type[0].totalItems > type.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + type[type.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAllTypeData({sql: sqlString}, type, true);
                            } else {
                                vm.newTypesArr = _.cloneDeepWith(type);
                                vm.fnGetAllProjects();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAllProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                            flat[projectObj.id].type = _.cloneDeepWith(_.filter(vm.newTypesArr, {projectId: projectObj.id}));
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.newProjectData = [vm.newProjectData];
                        vm.isTypeRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                    flat[projectObj.id].type = _.cloneDeepWith(_.filter(vm.newTypesArr, {projectId: projectObj.id}));
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.newProjectData = [vm.newProjectData];
                                vm.isTypeRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight + 10;
                        n.width = n.scrollWidth + 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('StateCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      TrackerStateFactory, ProjectFactory, amaran, swal, moment, microSpinner, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, postActionModelIcon, PermissionsService,
                      postActionModelMessage, AppInitService, PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.projectsArr = [];
                var tableName = 'tracker_states';

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.stateProjectFilter = "$";
                vm.stateProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //States Variables
                vm.isStatesLoading = false;
                vm.statesArr = [];
                vm.selectedStatesArr = [];
                vm.selectedStateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.stateResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowStateStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditStateObj = {};

                vm.stateContextMenu = function (stateObj) {
                    if (Object.keys(vm.resetEditStateObj).length) {
                        var isFindState = _.find(vm.statesArr, {id: vm.resetEditStateObj.id});
                        if (isFindState) {
                            vm.fnCancelStateEditMode(isFindState);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_STATE) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                stateObj.isEditable = true;
                                vm.resetEditStateObj = angular.copy(stateObj);
                            }
                        })
                    }
                    if (vm.permissionObj.CREATE_STATE) {
                        tempArr.push({
                            text: 'Clone',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                vm.fnCloneState(stateObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelStateEditMode = function (stateObj, isSuccessCall) {
                    if (isSuccessCall) {
                        stateObj.name = angular.copy(stateObj.name);
                        stateObj.description = angular.copy(stateObj.description);
                        stateObj.isEditable = false;
                        vm.resetEditStateObj = {};
                    } else {
                        stateObj.name = angular.copy(vm.resetEditStateObj.name);
                        stateObj.description = angular.copy(vm.resetEditStateObj.description);
                        stateObj.isEditable = false;
                        vm.resetEditStateObj = {};
                    }
                };

                vm.fnSaveStateInfo = function (stateObj) {
                    stateObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        stateId: stateObj.id
                    };
                    inputObj.body = {
                        name: stateObj.name,
                        description: angular.isUndefined(stateObj.description) ? '' : stateObj.description
                    };
                    TrackerStateFactory.updateIssueState(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.statesArr, function (stateObj) {
                                if (Object.keys(vm.selectedStateObj).length) {
                                    if (stateObj.id === vm.selectedStateObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedStateObj[key] = val;
                                            stateObj[key] = val;
                                        });
                                    }
                                }
                                if (stateObj.id === resetCopy.id) {
                                    stateObj.name = resetCopy.name;
                                    stateObj.description = resetCopy.description;
                                }
                            });
                            if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var stateArr = AppInitService.getInitData('issueStatesArr');
                                var index = _.findIndex(stateArr, {id: response.id});
                                if (index !== -1) {
                                    stateArr[index].name = response.name;
                                    stateArr[index].description = response.description;
                                    AppInitService.fnUpdateIssueStatesData(stateArr);
                                }
                            }
                            vm.fnCancelStateEditMode(stateObj, true);
                            amaran.success("State Updated Successfully");
                        }, function (error) {
                            vm.fnCancelStateEditMode(stateObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'state', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isStatesLoading = true;
                    vm.selectedStatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'state', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetStates({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.statesArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedStatesArr = [];
                                vm.selectedStateObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create State" && tab.id !== "stateStats" && tab.id !== "WidgetEditor" && tab.id !== "Relationships") {
                                if (vm.isStatesLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedStatesArr = [];
                                    vm.selectedStateObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.state', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create State";
                        vm.isShowStateStats = tab.id === "stateStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create State";
                    vm.isShowStateStats = tab.id === "stateStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create State" || tab.id === "Create Issue" || tab.id === "stateStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.state', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedStatesArr = [];
                        vm.selectedStateObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create State") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.state', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#stateTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (stateObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_STATE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.statesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === stateObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected state array*/
                        var isValueFind = _.find(vm.selectedStatesArr, {'id': stateObj.id});
                        if (!isValueFind) {
                            vm.selectedStatesArr.push(stateObj);
                            var isTabExist = _.find(vm.tabs, {'id': stateObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: stateObj.id,
                                    title: stateObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedStatesArr, function (obj) {
                                return stateObj.id === obj.id;
                            });
                        }
                        if (vm.selectedStatesArr.length === 1) {
                            vm.fnGetStateDetails(vm.selectedStatesArr[0])
                        } else {
                            $state.go('main.state', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.statesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedStatesArr = angular.copy(vm.statesArr);
                    } else {
                        vm.selectedStatesArr = [];
                    }
                    $state.go('main.state', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedStatesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create State'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create State',
                                title: 'Create State',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.getStateCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.statesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.statesArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "States");
                    XLSX.writeFile(wb, "states.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'state', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.state', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isStatesLoading = true;
                    vm.selectedStatesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_states';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_states';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetStates(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.statesArr);
                        vm.previousPage = page;
                        vm.fnGetStates(input, false);
                    }
                };

                vm.fnOpenStateInfoTab = function (stateObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(stateObj);
                };

                vm.fnGetState = function (stateObj, statesArr) {
                    angular.forEach(statesArr, function (state) {
                        state.isCheck = false;
                    });
                    stateObj.isCheck = true;
                    vm.selectedStatesArr = [stateObj]; // Assign array with single State object
                    vm.fnGetStateDetails(stateObj);
                };

                vm.fnGetStateDetails = function (stateObj) {
                    vm.isStateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when state is selected
                        vm.selectedStateObj = stateObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.state', {
                                selectedId: vm.selectedStateObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedStateObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isStateDetailsLoaded = true;
                        } else {
                            $state.go('main.state', {selectedId: vm.selectedStateObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedStateObj.id;
                            vm.isStateDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };
                //function to get state color for the States.
                vm.fnGetStateColor = function (stateObj) {
                    if (angular.isDefined(stateObj.color)) {
                        vm.stateTextColor = vm.fnInvertColor(stateObj.color);
                        return {
                            "background-color": stateObj.color,
                            "color": "" + vm.stateTextColor
                        }
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetStates = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.stateResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.stateResponse.data && vm.stateResponse.data.length) {
                                    vm.totalItems = vm.stateResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.stateResponse.data.reverse();
                            }
                            vm.statesArr = _.cloneDeepWith(vm.stateResponse.data);
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetState(res[0], vm.statesArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var stateData = _.find(vm.statesArr, {"id": $stateParams.selectedId});
                                if (stateData) {
                                    vm.fnCheckUncheckHeader(stateData)
                                }
                            }
                            if ($state.current.name === 'main.state') {
                                $state.go('main.state', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isStatesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isStatesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectState = function (projectObj) {
                    vm.isStatesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_states';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_states';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_states';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'state', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'state', 'selectedProject', '');
                    }
                    vm.fnGetStates({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("StateDeleted", function (evt, data) {
                    vm.selectedStateObj = null;
                    vm.selectedStatesArr = [];
                    vm.statesArr = vm.statesArr.filter(function (stateObj) {
                        return (stateObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.state', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("StateDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.statesArr, function (stateObj) {
                        if (stateObj.id === vm.selectedStateObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedStateObj[key] = val;
                                stateObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("stateAdded", function () {
                    vm.fnRemoveTab('Create State');
                });

                vm.fnDeleteMultipleStates = function (selectedStatesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedStatesArr, function (selectedState, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/states/" + selectedState.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/states/" + selectedState.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected States?",
                            text: "You are about to permanently delete the selected states.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedStatesArr, function (selectedState) {
                                    angular.forEach(vm.statesArr, function (stateObj, index) {
                                        if (selectedState.id === stateObj.id) {
                                            vm.statesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedStatesArr.length;
                                vm.selectedStateObj = null;
                                vm.selectedStatesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedStatesArr, function (selectedState) {
                                    angular.forEach(vm.statesArr, function (stateObj, index) {
                                        if (selectedState.id === stateObj.id) {
                                            vm.statesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedStatesArr.length;
                                vm.selectedStateObj = null;
                                vm.selectedStatesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'state', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.state", tempArr, {notify: false});
                    }
                };

                vm.fnInitStates = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'state', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetStateDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetStateStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'stateStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowStateStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'stateStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowStateStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetStateRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isStateRelationshipsDataLoading = true;
                vm.newStatesArr = [];

                vm.fnInitStateRelationships = function () {
                    vm.isStateRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    var stateSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_states ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAllStateData({sql: stateSQL}, [], false);
                };

                vm.fnGetAllStateData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var state = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                state.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (state[0] && state[0].totalItems > state.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + state[state.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAllStateData({sql: sqlString}, state, true);
                            } else {
                                vm.newStatesArr = _.cloneDeepWith(state);
                                vm.fnGetAllProjects();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAllProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                            flat[projectObj.id].state = _.cloneDeepWith(_.filter(vm.newStatesArr, {projectId: projectObj.id}));
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.newProjectData = [vm.newProjectData];
                        vm.isStateRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                    flat[projectObj.id].state = _.cloneDeepWith(_.filter(vm.newStatesArr, {projectId: projectObj.id}));
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.newProjectData = [vm.newProjectData];
                                vm.isStateRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight + 10;
                        n.width = n.scrollWidth + 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };


                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getStateCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.statesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.statesArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "States");
                    XLSX.writeFile(wb, "states.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'state', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerStateChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCloneState = function (stateObj) {
                    DB.fnSet('ClonedStateObj', stateObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var stateKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.state') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedStatesArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleStates(vm.selectedStatesArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var stateKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.state') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', stateKeyDownEventHandler);
                document.addEventListener('keyup', stateKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', stateKeyDownEventHandler);
                    document.removeEventListener('keyup', stateKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TrackerScriptsCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      WidgetsListService, TrackerScriptFactory, PermissionsService) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowScriptStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 's4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.tracker_scripts') {
                        $timeout(function () {
                            $state.go('main.tracker_scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.tracker_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.tracker_scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.tracker_scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.tracker_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionObj.LIST_SCRIPT_TYPES) {
                        TrackerScriptFactory.listScriptTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.tracker_scripts') {
                                    $state.go('main.tracker_scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "ScriptStats" && tab.id !== "WidgetEditor") {
                                if (vm.isScriptsloading || angular.isUndefined(isFindScript)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedScriptsArr = [];
                                    vm.selectedScriptObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.tracker_scripts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowScriptStats = tab.id === "ScriptStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowScriptStats = tab.id === "ScriptStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "ScriptStats" || tab.id === "WidgetEditor") {
                        $state.go('main.tracker_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.tracker_scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 's4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ScriptStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowScriptStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ScriptStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowScriptStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 's4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.tracker_scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 's4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerS4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectScriptsCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      WidgetsListService, TrackerScriptFactory, PermissionsService) {
                var vm = this;

                vm.isShowDashboard = false;
                vm.isShowScriptStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;
                vm.selectedProjectName = "";

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    if ($stateParams.name) {
                        vm.selectedProjectName = $stateParams.name;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'projectS4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.project_scripts') {
                        $timeout(function () {
                            $state.go('main.project_scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.project_scripts', {
                                selectedId: '',
                                selectedDetailsTab: ''
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.project_scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.project_scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.project_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionObj.LIST_PROJECT_SCRIPT_TYPES) {
                        TrackerScriptFactory.listProjectScriptTypes({projectId: $stateParams.selectedProject})
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.project_scripts') {
                                    $state.go('main.project_scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "ScriptStats" && tab.id !== "WidgetEditor") {
                                if (vm.isScriptsloading || angular.isUndefined(isFindScript)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedScriptsArr = [];
                                    vm.selectedScriptObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title, type: tab.id});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.project_scripts', {
                                selectedId: "",
                                selectedDetailsTab: ""
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowScriptStats = tab.id === "ScriptStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowScriptStats = tab.id === "ScriptStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "ScriptStats" || tab.id === "WidgetEditor") {
                        $state.go('main.project_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.project_scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    //UserProfileService.fnUpdateUserProfileObj('tracker', 'projectS4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ScriptStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowScriptStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ScriptStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowScriptStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'projectS4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.project_scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'projectS4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerProjectS4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectEmailTemplateCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      PermissionsService, WidgetsListService, TrackerEmailTemplateFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowEmailTemplateStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.selectedProjectName = "";

                //EmailTemplates Variables
                vm.isEmailTemplatesloading = false;
                vm.emailTemplateArr = [];
                vm.selectedEmailTemplatesArr = [];
                vm.selectedEmailTemplateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.emailTemplateResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    if ($stateParams.name) {
                        vm.selectedProjectName = $stateParams.name;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'projectEmailTemplate', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterEmailTemplateArr = [];
                    var emailTemplateArr = [];
                    if (vm.emailTemplateResponse.length) {
                        if (vm.filterQuery) {
                            filterEmailTemplateArr = _.filter(vm.emailTemplateResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterEmailTemplateArr = _.cloneDeepWith(vm.emailTemplateResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            emailTemplateArr = _.orderBy(filterEmailTemplateArr, [sortValue], [sortType]);
                        } else {
                            emailTemplateArr = _.cloneDeepWith(filterEmailTemplateArr);
                        }
                    }
                    vm.totalItems = emailTemplateArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.emailTemplateArr = emailTemplateArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.project_emailTemplate') {
                        $timeout(function () {
                            $state.go('main.project_emailTemplate', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isEmailTemplatesloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#emailTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (emailTemplateObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT_EMAIL_TEMPLATE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.emailTemplateArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === emailTemplateObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedEmailTemplatesArr, {'id': emailTemplateObj.id});
                        if (!isValueFind) {
                            vm.selectedEmailTemplatesArr.push(emailTemplateObj);
                            var isTabExist = _.find(vm.tabs, {'id': emailTemplateObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: emailTemplateObj.id,
                                    title: emailTemplateObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEmailTemplatesArr, function (obj) {
                                return emailTemplateObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEmailTemplatesArr.length === 1) {
                            vm.fnGetEmailTemplateDetails(vm.selectedEmailTemplatesArr[0])
                        } else {
                            $state.go('main.project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetEmailTemplateDetails = function (userObj) {
                    vm.isEmailTemplateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedEmailTemplateObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.project_emailTemplate', {
                                selectedId: vm.selectedEmailTemplateObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEmailTemplateDetailsLoaded = true;
                        } else {
                            $state.go('main.project_emailTemplate', {selectedId: vm.selectedEmailTemplateObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            vm.isEmailTemplateDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.emailTemplateArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEmailTemplatesArr = _.cloneDeepWith(vm.emailTemplateArr);
                    } else {
                        vm.selectedEmailTemplatesArr = [];
                    }
                    $state.go('main.project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        emailTemplateId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetEmailTemplate = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedEmailTemplatesArr = [tokenObj]; // Assign array with single token object
                    vm.selectedEmailTemplateObj = tokenObj;
                };

                vm.fnGetEmailTemplates = function () {
                    if (vm.permissionObj.LIST_PROJECT_EMAIL_TEMPLATE_TYPES) {
                        TrackerEmailTemplateFactory.listEmailTemplateTypes({projectId: $stateParams.selectedProject})
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.emailTemplateResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var emailTemplateData = _.find(vm.emailTemplateArr, {"id": $stateParams.selectedId});
                                    if (emailTemplateData) {
                                        vm.fnCheckUncheckHeader(emailTemplateData);
                                    }
                                }
                                if ($state.current.name === 'main.project_emailTemplate') {
                                    $state.go('main.project_emailTemplate', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.emailTemplateResponse = [];
                        vm.fnGetFilterData();
                        vm.isEmailTemplatesloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindEmailTemplate = _.find(vm.emailTemplateArr, {id: tab.id});
                            if (isFindEmailTemplate) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEmailTemplatesArr = [];
                                vm.selectedEmailTemplateObj = {};
                                vm.fnCheckUncheckHeader(isFindEmailTemplate);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "EmailTemplateStats" && tab.id !== "WidgetEditor") {
                                if (vm.isEmailTemplatesloading || angular.isUndefined(isFindEmailTemplate)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedEmailTemplatesArr = [];
                                    vm.selectedEmailTemplateObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title, type: tab.id});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.project_emailTemplate', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "EmailTemplateStats" || tab.id === "WidgetEditor") {
                        $state.go('main.project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.project_emailTemplate', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    //UserProfileService.fnUpdateUserProfileObj('tracker', 'projectEmailTemplate', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'EmailTemplateStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEmailTemplateStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'EmailTemplateStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEmailTemplateStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'projectEmailTemplate', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.project_emailTemplate", tempArr, {notify: false});
                    }
                };

                vm.fnInitEmailTemplate = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'projectEmailTemplate', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function(type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerProjectEmailTemplateChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProjectCtrl',
            function ($scope, $window, $timeout, $stateParams, d3, panzoom, $state, $uibModal,
                      AppInitService, amaran, swal, moment, microSpinner, PaginationQueryService, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, ProjectFactory, postActionModelIcon,
                      postActionModelMessage, QueryFactory, projectArr, $base64, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Projects Variables
                vm.isProjectsLoading = false;
                vm.projectsArr = [];
                vm.selectedProjectsArr = [];
                vm.selectedProjectObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.projectResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowProjectStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditProjectObj = {};

                vm.projectContextMenu = function (projectObj) {
                    if (Object.keys(vm.resetEditProjectObj).length) {
                        var isFindProject = _.find(vm.projectsArr, {id: vm.resetEditProjectObj.id});
                        if (isFindProject) {
                            vm.fnCancelProjectEditMode(isFindProject);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            projectObj.isEditable = true;
                            vm.resetEditProjectObj = angular.copy(projectObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core project fields
                                id: item.id || parsedData.id || '',
                                name: parsedData.name || '',
                                description: parsedData.description || '',
                                teamIds: parsedData.teamIds || [],
                                parentProjectId: parsedData.parentProjectId || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnCancelProjectEditMode = function (projectObj, isSuccessCall) {
                    if (isSuccessCall) {
                        projectObj.name = angular.copy(projectObj.name);
                        projectObj.description = angular.copy(projectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    } else {
                        projectObj.name = angular.copy(vm.resetEditProjectObj.name);
                        projectObj.description = angular.copy(vm.resetEditProjectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    }
                };

                vm.fnSaveProjectInfo = function (projectObj) {
                    projectObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    inputObj.body = {
                        name: projectObj.name,
                        description: angular.isUndefined(projectObj.description) ? '' : projectObj.description
                    };
                    ProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.projectsArr, function (projectObj) {
                                if (Object.keys(vm.selectedProjectObj).length) {
                                    if (projectObj.id === vm.selectedProjectObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedProjectObj[key] = val;
                                            projectObj[key] = val;
                                        });
                                    }
                                }
                                if (projectObj.id === resetCopy.id) {
                                    projectObj.name = resetCopy.name;
                                    projectObj.description = resetCopy.description;
                                }
                            });
                            var projectArr = AppInitService.getInitData('projectsArr');
                            var index = _.findIndex(projectArr, {id: response.id});
                            if (index !== -1) {
                                projectArr[index].name = response.name;
                                projectArr[index].description = response.description;
                                AppInitService.fnUpdateProjectData(projectArr);
                            }
                            vm.fnCancelProjectEditMode(projectObj, true);
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            vm.fnCancelProjectEditMode(projectObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'project', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetProjects(input, true);
                };

                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.projectsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedProjectsArr = [];
                                vm.selectedProjectObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Project" && tab.id !== "projectStats" && tab.id !== "WidgetEditor" && tab.id !== "Relationships") {
                                if (vm.isProjectsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedProjectsArr = [];
                                    vm.selectedProjectObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.project', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Project";
                        vm.isShowProjectStats = tab.id === "projectStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Project";
                    vm.isShowProjectStats = tab.id === "projectStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Project" || tab.id === "Create Issue" || tab.id === "projectStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Project") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.project', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#projectTable").css('height', finalHeight + 'px');
                    }
                    if (vm.isShowRelationships === true) {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    }
                };

                vm.fnCheckUncheckHeader = function (projectObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.projectsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === projectObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected project array*/
                        var isValueFind = _.find(vm.selectedProjectsArr, {'id': projectObj.id});
                        if (!isValueFind) {
                            vm.selectedProjectsArr.push(projectObj);
                            var isTabExist = _.find(vm.tabs, {'id': projectObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: projectObj.id,
                                    title: projectObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedProjectsArr, function (obj) {
                                return projectObj.id === obj.id;
                            });
                        }
                        if (vm.selectedProjectsArr.length === 1) {
                            vm.fnGetProjectDetails(vm.selectedProjectsArr[0])
                        } else {
                            $state.go('main.project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.projectsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedProjectsArr = angular.copy(vm.projectsArr);
                    } else {
                        vm.selectedProjectsArr = [];
                    }
                    $state.go('main.project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Project'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Project',
                                title: 'Create Project',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_projects';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetProjects(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.projectsArr);
                        vm.previousPage = page;
                        vm.fnGetProjects(input, false);
                    }
                };

                vm.fnOpenProjectInfoTab = function (projectObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(projectObj);
                };

                vm.fnGetProject = function (projectObj, projectsArr) {
                    angular.forEach(projectsArr, function (project) {
                        project.isCheck = false;
                    });
                    projectObj.isCheck = true;
                    vm.selectedProjectsArr = [projectObj]; // Assign array with single Project object
                    vm.fnGetProjectDetails(projectObj);
                };

                vm.fnGetProjectDetails = function (projectObj) {
                    vm.isProjectDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when project is selected
                        vm.selectedProjectObj = projectObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.project', {
                                selectedId: vm.selectedProjectObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isProjectDetailsLoaded = true;
                        } else {
                            $state.go('main.project', {selectedId: vm.selectedProjectObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            vm.isProjectDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetProjects = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data = vm.parsePostgresData(res.data);
                            vm.projectResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.projectResponse.data && vm.projectResponse.data.length) {
                                    vm.totalItems = vm.projectResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.projectResponse.data.reverse();
                            }
                            vm.projectsArr = vm.projectResponse.data;
                            // Set projects again in localstorage if they are reloaded
                            if(vm.isRefresh && !DB.fnGet('federation') && !DB.fnGet('support')) {
                                localStorage.setItem(projectArr, $base64.encode(angular.toJson(vm.projectsArr)));
                            }
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetProject(res[0], vm.projectsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var projectData = _.find(vm.projectsArr, {"id": $stateParams.selectedId});
                                if (projectData) {
                                    vm.fnCheckUncheckHeader(projectData)
                                }
                            }
                            if ($state.current.name === 'main.project') {
                                $state.go('main.project', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isProjectsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("ProjectDeleted", function (evt, data) {
                    vm.selectedProjectObj = null;
                    vm.selectedProjectsArr = [];
                    vm.projectsArr = vm.projectsArr.filter(function (projectObj) {
                        return (projectObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("ProjectDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.projectsArr, function (projectObj) {
                        if (projectObj.id === vm.selectedProjectObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedProjectObj[key] = val;
                                projectObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("projectAdded", function () {
                    vm.fnRemoveTab('Create Project');
                });

                vm.fnDeleteMultipleProjects = function (selectedProjectsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedProjectsArr, function (selectedProject, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Projects?",
                            text: "You are about to permanently delete the selected projects.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'project', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.project", tempArr, {notify: false});
                    }
                };

                vm.fnInitProjects = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'project', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjectDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'projectStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowProjectStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'projectStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowProjectStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isProjectRelationshipsDataLoading = true;
                vm.fnInitProjectRelationships = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.isProjectRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.isProjectRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getProjectCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.projectsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.projectsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Projects");
                    XLSX.writeFile(wb, "projects.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'project', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerProjectChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                }

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var projectKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedProjectsArr.length > 1 &&
                                vm.permissionObj.DELETE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleProjects(vm.selectedProjectsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var projectKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectKeyDownEventHandler);
                document.addEventListener('keyup', projectKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectKeyDownEventHandler);
                    document.removeEventListener('keyup', projectKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PrioritiesCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal, WidgetsListService,
                      UserProfileService, amaran, ColorService, swal, microSpinner, DB, XLSX, Authenticate, IconService,
                      PermissionsService, LastPageService, PriorityFactory, ProjectFactory, BatchFactory, PaginationService, moment, copyService,
                      FedSudoUserService, postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, AppInitService, PaginationQueryService, QueryFactory) {
                var vm = this;
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.projectsArr = [];
                var tableName = 'tracker_priorities';

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowPriorityStats = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.priorityProjectFilter = "$";
                vm.priorityProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isPrioritiesLoading = false;
                vm.priorityArr = [];
                vm.selectedPrioritiesArr = [];
                vm.selectedPriorityObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.priorityResponse = [];

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                /*Start: Context Menu*/
                vm.resetEditPrioritiesObj = {};

                vm.prioritiesContextMenu = function (prioritiesObj) {
                    if (Object.keys(vm.resetEditPrioritiesObj).length) {
                        var isFindPriorities = _.find(vm.prioritiesArr, {id: vm.resetEditPrioritiesObj.id});
                        if (isFindPriorities) {
                            vm.fnCancelPrioritiesEditMode(isFindPriorities);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_PRIORITY) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                prioritiesObj.isEditable = true;
                                vm.resetEditPrioritiesObj = angular.copy(prioritiesObj);
                            }
                        })
                    }
                    if (vm.permissionObj.CREATE_PRIORITY) {
                        tempArr.push({
                            text: 'Clone',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                vm.fnClonePriority(prioritiesObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelPrioritiesEditMode = function (prioritiesObj, isSuccessCall) {
                    if (isSuccessCall) {
                        prioritiesObj.name = angular.copy(prioritiesObj.name);
                        prioritiesObj.description = angular.copy(prioritiesObj.description);
                        prioritiesObj.isEditable = false;
                        vm.resetEditPrioritiesObj = {};
                    } else {
                        prioritiesObj.name = angular.copy(vm.resetEditPrioritiesObj.name);
                        prioritiesObj.description = angular.copy(vm.resetEditPrioritiesObj.description);
                        prioritiesObj.isEditable = false;
                        vm.resetEditPrioritiesObj = {};
                    }
                };

                vm.fnSavePrioritiesInfo = function (prioritiesObj) {
                    prioritiesObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        priorityId: prioritiesObj.id
                    };
                    inputObj.body = {
                        name: prioritiesObj.name,
                        description: angular.isUndefined(prioritiesObj.description) ? '' : prioritiesObj.description
                    };
                    PriorityFactory.updateIssuePriority(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.priorityArr, function (prioritiesObj) {
                                if (Object.keys(vm.selectedPriorityObj).length) {
                                    if (prioritiesObj.id === vm.selectedPriorityObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedPriorityObj[key] = val;
                                            prioritiesObj[key] = val;
                                        });
                                    }
                                }
                                if (prioritiesObj.id === resetCopy.id) {
                                    prioritiesObj.name = resetCopy.name;
                                    prioritiesObj.description = resetCopy.description;
                                }
                            });
                            var priorityArr = AppInitService.getInitData('issuePrioritiesArr');
                            var index = _.findIndex(priorityArr, {id: response.id});
                            if (index !== -1) {
                                priorityArr[index].name = response.name;
                                priorityArr[index].description = response.description;
                                AppInitService.fnUpdateIssuePrioritiesData(priorityArr);
                            }
                            vm.fnCancelPrioritiesEditMode(prioritiesObj, true);
                            amaran.success("Priority Updated Successfully");
                        }, function (error) {
                            vm.fnCancelPrioritiesEditMode(prioritiesObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                /*START: TABLE*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#prioritiesTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.priorities', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage',
                            // [perPage]);
                        }
                    }
                    vm.isPrioritiesLoading = true;
                    vm.selectedPrioritiesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_priorities';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetPriorities(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.priorityArr);
                        vm.previousPage = page;
                        vm.fnGetPriorities(input, false);
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'priorities', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isPrioritiesLoading = true;
                    vm.selectedPrioritiesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'priorities', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_priorities';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetPriorities({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.priorityArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedPrioritiesArr = [];
                                vm.selectedPriorityObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Priority" && tab.id !== "PriorityStats" && tab.id !== "WidgetEditor" && tab.id !== 'Relationships') {
                                if (vm.isPrioritiesLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedPrioritiesArr = [];
                                    vm.selectedPriorityObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.priorities', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Priority";
                        vm.isShowUserStats = tab.id === "UserStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedPrioritiesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Priority'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Priority',
                                title: 'Create Priority',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Priority";
                    vm.isShowUserStats = tab.id === "PriorityStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Priority" || tab.id === "Create Issue" || tab.id === "PriorityStats" || tab.id === "WidgetEditor" || tab.id === 'Relationships') {
                        $state.go('main.priorities', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedPrioritiesArr = [];
                        vm.selectedPriorityObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Priority") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.priorities', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getPrioritiesCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.priorityArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.priorityArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Priorities");
                    XLSX.writeFile(wb, "priorities.xlsx");
                };
                /* Export Modal: End */

                vm.fnCheckUncheckHeader = function (priorityObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PRIORITY) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.priorityArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === priorityObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedPrioritiesArr, {'id': priorityObj.id});
                        if (!isValueFind) {
                            vm.selectedPrioritiesArr.push(priorityObj);
                            var isTabExist = _.find(vm.tabs, {'id': priorityObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: priorityObj.id,
                                    title: priorityObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedPrioritiesArr, function (obj) {
                                return priorityObj.id === obj.id;
                            });
                        }
                        if (vm.selectedPrioritiesArr.length === 1) {
                            vm.fnGetPriorityDetails(vm.selectedPrioritiesArr[0])
                        } else {
                            $state.go('main.priorities', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetPriorityDetails = function (priorityObj) {
                    vm.isPrioritiesDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when priority is selected
                        vm.selectedPriorityObj = priorityObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.priorities', {
                                selectedId: vm.selectedPriorityObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedPriorityObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isPrioritiesDetailsLoaded = true;
                        } else {
                            $state.go('main.priorities', {selectedId: vm.selectedPriorityObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedPriorityObj.id;
                            vm.isPrioritiesDetailsLoaded = true;
                        }
                    })
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("PriorityDeleted", function (evt, data) {
                    vm.selectedPriorityObj = null;
                    vm.selectedPrioritiesArr = [];
                    vm.priorityArr = vm.priorityArr.filter(function (priorityObj) {
                        return (priorityObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.priorities', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("PriorityDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.priorityArr, function (priorityObj) {
                        if (priorityObj.id === vm.selectedPriorityObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedPriorityObj[key] = val;
                                priorityObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("priorityAdded", function () {
                    vm.fnRemoveTab('Create Priority');
                });

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.priorityArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedPrioritiesArr = _.cloneDeepWith(vm.priorityArr);
                    } else {
                        vm.selectedPrioritiesArr = [];
                    }
                    $state.go('main.priorities', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'priorities', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.priorities", tempArr, {notify: false});
                    }
                };

                vm.fnInitPriorities = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'priorities', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetPriorities = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.priorityResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.priorityResponse.data && vm.priorityResponse.data.length) {
                                    vm.totalItems = vm.priorityResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.priorityResponse.data.reverse();
                            }
                            vm.priorityArr = vm.priorityResponse.data;
                            if ($stateParams.selectedId) {
                                var priorityData = _.find(vm.priorityArr, {"id": $stateParams.selectedId});
                                if (priorityData) {
                                    vm.fnCheckUncheckHeader(priorityData);
                                }
                            }
                            if ($state.current.name === 'main.priorities') {
                                $timeout(function () {
                                    $state.go('main.priorities', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10)
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isPrioritiesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isPrioritiesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectPriority= function (projectObj) {
                    vm.isPrioritiesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_priorities';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_priorities';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_priorities';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'priorities', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'priorities', 'selectedProject', '');
                    }
                    vm.fnGetPriorities({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnOpenPriorityInfoTab = function (priorityObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(priorityObj);
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get priorities color for the Priorities.
                vm.fnGetPrioritiesColor = function (priorityObj) {
                    if (angular.isDefined(priorityObj.color)) {
                        vm.priorityTextColor = vm.fnInvertColor(priorityObj.color);
                        return {
                            "background-color": priorityObj.color,
                            "color": "" + vm.priorityTextColor
                        }
                    }
                };

                vm.fnGetPriorityDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'priorities', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetPriorityStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'PriorityStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowPriorityStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'PriorityStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowPriorityStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerPrioritiesChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnClonePriority = function (priorityObj) {
                    DB.fnSet('ClonedPriorityObj', priorityObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnGetPriorityRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isPrioritiesRelationshipsDataLoading = true;
                vm.newPrioritiesArr = [];

                vm.fnInitPrioritiesRelationships = function () {
                    vm.isPrioritiesRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    var prioritiesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_priorities ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAllPrioritiesData({sql: prioritiesSQL}, [], false);
                };

                vm.fnGetAllPrioritiesData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var priorities = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                priorities.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (priorities[0] && priorities[0].totalItems > priorities.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + priorities[priorities.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAllPrioritiesData({sql: sqlString}, priorities, true);
                            } else {
                                vm.newPrioritiesArr = _.cloneDeepWith(priorities);
                                vm.fnGetAllProjects();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAllProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                            flat[projectObj.id].priorities = _.cloneDeepWith(_.filter(vm.newPrioritiesArr, {projectId: projectObj.id}));
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.newProjectData = [vm.newProjectData];
                        vm.isPrioritiesRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                    flat[projectObj.id].priorities = _.cloneDeepWith(_.filter(vm.newPrioritiesArr, {projectId: projectObj.id}));
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.newProjectData = [vm.newProjectData];
                                vm.isPrioritiesRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight + 10;
                        n.width = n.scrollWidth + 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LabelCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, LabelFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, copyService) {
                var vm = this;

                var tableName = 'tracker_labels';
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.projectsArr = [];
                vm.labelProjectFilter = "$";
                vm.labelProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Labels Variables
                vm.isLabelsLoading = false;
                vm.labelsArr = [];
                vm.selectedLabelsArr = [];
                vm.selectedLabelObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.labelResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowLabelStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditLabelObj = {};

                vm.labelContextMenu = function (labelObj) {
                    if (Object.keys(vm.resetEditLabelObj).length) {
                        var isFindLabel = _.find(vm.labelsArr, {id: vm.resetEditLabelObj.id});
                        if (isFindLabel) {
                            vm.fnCancelLabelEditMode(isFindLabel);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_LABEL) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                labelObj.isEditable = true;
                                vm.resetEditLabelObj = angular.copy(labelObj);
                            }
                        })
                    }
                    if (vm.permissionObj.CREATE_LABEL) {
                        tempArr.push({
                            text: 'Clone',
                            click: function () {
                                vm.fnCloneLabel(labelObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelLabelEditMode = function (labelObj, isSuccessCall) {
                    if (isSuccessCall) {
                        labelObj.name = angular.copy(labelObj.name);
                        labelObj.description = angular.copy(labelObj.description);
                        labelObj.isEditable = false;
                        vm.resetEditLabelObj = {};
                    } else {
                        labelObj.name = angular.copy(vm.resetEditLabelObj.name);
                        labelObj.description = angular.copy(vm.resetEditLabelObj.description);
                        labelObj.isEditable = false;
                        vm.resetEditLabelObj = {};
                    }
                };

                vm.fnSaveLabelInfo = function (labelObj) {
                    labelObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        labelId: labelObj.id
                    };
                    inputObj.body = {
                        name: labelObj.name,
                        description: angular.isUndefined(labelObj.description) ? '' : labelObj.description
                    };
                    LabelFactory.updateIssueLabel(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.labelsArr, function (labelObj) {
                                if (Object.keys(vm.selectedLabelObj).length) {
                                    if (labelObj.id === vm.selectedLabelObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedLabelObj[key] = val;
                                            labelObj[key] = val;
                                        });
                                    }
                                }
                                if (labelObj.id === resetCopy.id) {
                                    labelObj.name = resetCopy.name;
                                    labelObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelLabelEditMode(labelObj, true);
                            amaran.success("Label Updated Successfully");
                        }, function (error) {
                            vm.fnCancelLabelEditMode(labelObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'label', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isLabelsLoading = true;
                    vm.selectedLabelsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'label', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY data->>\' ' + vm.sort.split(' ')[0] + ' \'' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\' ' + vm.sort.split(' ')[0] + ' \'AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\' ' + vm.sort.split(' ')[0] + ' \'' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetLabels({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.labelsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedLabelsArr = [];
                                vm.selectedLabelObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Label" && tab.id !== "labelStats" && tab.id !== "WidgetEditor" && tab.id !== "Relationships") {
                                if (vm.isLabelsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedLabelsArr = [];
                                    vm.selectedLabelObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.label', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Label";
                        vm.isShowLabelStats = tab.id === "labelStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Label";
                    vm.isShowLabelStats = tab.id === "labelStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Label" || tab.id === "Create Issue" || tab.id === "labelStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.label', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedLabelsArr = [];
                        vm.selectedLabelObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Label") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.label', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#labelTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (labelObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_LABEL) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.labelsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === labelObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected label array*/
                        var isValueFind = _.find(vm.selectedLabelsArr, {'id': labelObj.id});
                        if (!isValueFind) {
                            vm.selectedLabelsArr.push(labelObj);
                            var isTabExist = _.find(vm.tabs, {'id': labelObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: labelObj.id,
                                    title: labelObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedLabelsArr, function (obj) {
                                return labelObj.id === obj.id;
                            });
                        }
                        if (vm.selectedLabelsArr.length === 1) {
                            vm.fnGetLabelDetails(vm.selectedLabelsArr[0])
                        } else {
                            $state.go('main.label', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.labelsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedLabelsArr = angular.copy(vm.labelsArr);
                    } else {
                        vm.selectedLabelsArr = [];
                    }
                    $state.go('main.label', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedLabelsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Label'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Label',
                                title: 'Create Label',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.label', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isLabelsLoading = true;
                    vm.selectedLabelsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_labels';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\' ' + vm.sort.split(' ')[0] + ' \'AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\' ' + vm.sort.split(' ')[0] + ' \'' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_labels';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetLabels(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.labelsArr);
                        vm.previousPage = page;
                        vm.fnGetLabels(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnOpenLabelInfoTab = function (labelObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(labelObj);
                };

                vm.fnGetLabel = function (labelObj, labelsArr) {
                    angular.forEach(labelsArr, function (label) {
                        label.isCheck = false;
                    });
                    labelObj.isCheck = true;
                    vm.selectedLabelsArr = [labelObj]; // Assign array with single Label object
                    vm.fnGetLabelDetails(labelObj);
                };

                vm.fnGetLabelDetails = function (labelObj) {
                    vm.isLabelDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when label is selected
                        vm.selectedLabelObj = labelObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.label', {
                                selectedId: vm.selectedLabelObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedLabelObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isLabelDetailsLoaded = true;
                        } else {
                            $state.go('main.label', {selectedId: vm.selectedLabelObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedLabelObj.id;
                            vm.isLabelDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Labels.
                vm.fnGetLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj.color)) {
                        vm.labelTextColor = vm.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + vm.labelTextColor
                        }
                    }
                };

                vm.fnGetLabels = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.labelResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.labelResponse.data && vm.labelResponse.data.length) {
                                    vm.totalItems = vm.labelResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.labelResponse.data.reverse();
                            }
                            vm.labelsArr = vm.labelResponse.data;
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetLabel(res[0], vm.labelsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var labelData = _.find(vm.labelsArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.label') {
                                $state.go('main.label', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isLabelsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isLabelsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectLabel= function (projectObj) {
                    vm.isLabelsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM tracker_labels';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\' ' + vm.sort.split(' ')[0] + ' \'AS rt FROM tracker_labels';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY  data->>\' ' + vm.sort.split(' ')[0] + ' \'' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_labels';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'label', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'label', 'selectedProject', '');
                    }
                    vm.fnGetLabels({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("LabelDeleted", function (evt, data) {
                    vm.selectedLabelObj = null;
                    vm.selectedLabelsArr = [];
                    vm.labelsArr = vm.labelsArr.filter(function (labelObj) {
                        return (labelObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.label', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("LabelDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.labelsArr, function (labelObj) {
                        if (labelObj.id === vm.selectedLabelObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedLabelObj[key] = val;
                                labelObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("labelAdded", function () {
                    vm.fnRemoveTab('Create Label');
                });

                vm.fnDeleteMultipleLabels = function (selectedLabelsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedLabelsArr, function (selectedLabel, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/labels/" + selectedLabel.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/labels/" + selectedLabel.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Labels?",
                            text: "You are about to permanently delete the selected labels.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedLabelsArr, function (selectedLabel) {
                                    angular.forEach(vm.labelsArr, function (labelObj, index) {
                                        if (selectedLabel.id === labelObj.id) {
                                            vm.labelsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedLabelsArr.length;
                                vm.selectedLabelObj = null;
                                vm.selectedLabelsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedLabelsArr, function (selectedLabel) {
                                    angular.forEach(vm.labelsArr, function (labelObj, index) {
                                        if (selectedLabel.id === labelObj.id) {
                                            vm.labelsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedLabelsArr.length;
                                vm.selectedLabelObj = null;
                                vm.selectedLabelsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'label', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.label", tempArr, {notify: false});
                    }
                };

                vm.fnInitLabels = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4('tracker');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'label', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetLabelDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLabelStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'labelStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowLabelStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'labelStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowLabelStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLabelRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isLabelRelationshipsDataLoading = true;
                vm.newLabelsArr = [];
                vm.fnInitLabelRelationships = function () {
                    vm.isLabelRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    var labelSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_labels ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAllLabelData({sql: labelSQL}, [], false);
                };

                vm.fnGetAllLabelData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var labels = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                labels.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (labels[0] && labels[0].totalItems > labels.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + labels[labels.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAllLabelData({sql: sqlString}, labels, true);
                            } else {
                                vm.newLabelsArr = _.cloneDeepWith(labels);
                                vm.fnGetAllProjects();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAllProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                            flat[projectObj.id].labels = _.cloneDeepWith(_.filter(vm.newLabelsArr, {projectId: projectObj.id}));
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.newProjectData = [vm.newProjectData];
                        vm.isLabelRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                    flat[projectObj.id].labels = _.cloneDeepWith(_.filter(vm.newLabelsArr, {projectId: projectObj.id}));
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.newProjectData = [vm.newProjectData];
                                vm.isLabelRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight + 10;
                        n.width = n.scrollWidth + 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getLabelCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.labelsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.labelsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Labels");
                    XLSX.writeFile(wb, "labels.xlsx");
                };
                /* Export Modal: End */

                vm.fnCloneLabel = function(labelObj) {
                    DB.fnSet('ClonedLabelObj', labelObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'label', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerLabelChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                }

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var labelKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.label') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_LABEL &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedLabelsArr.length > 1 &&
                                vm.permissionObj.DELETE_LABEL &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleLabels(vm.selectedLabelsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var labelKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.label') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', labelKeyDownEventHandler);
                document.addEventListener('keyup', labelKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', labelKeyDownEventHandler);
                    document.removeEventListener('keyup', labelKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('IssueCtrl',
            function ($scope, $window, $timeout, $stateParams, AppInitService, $sce, $state, $uibModal, amaran, swal,
                      moment, copyService, microSpinner, AvatarService, WidgetsListService, UserProfileService,
                      UserFactory, DB, XLSX, Authenticate, LastPageService, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, ProjectFactory, IssueFactory, CommentFactory, QueryFactory,
                      postActionModelIcon, postActionModelMessage, PaginationQueryService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var tableName = 'tracker_issues';
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedIssueId = '';
                var loginUser = DB.fnGet('loginUser');
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitIssue = true;
                //Search Variables
                vm.isRefreshData = true;
                vm.assigneeArr = [];
                vm.issueTypesArr = [];
                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};
                var FiltersArrOrder = ['Assigned to me', 'Created by me', 'Resolution Overdue', 'Response Overdue', 'Open', 'Resolved', 'Assignee', 'Created', 'Updated', 'Type', 'Priority', 'Status', 'Label', 'Participant', 'ID', 'Name', 'Summary', 'Unread', 'Project', 'Custom Field'];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Summary",
                        name: "summary",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Created",
                        name: "createdAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Updated",
                        name: "updatedAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Open",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'false\'',
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Resolved",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'true\'',
                        localSearchValue: 'obj.resolved === true'
                    }, {
                        displayName: "Resolution Overdue",
                        name: "resolutionDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() > obj.resolutionDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(resolutionDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                localSearch: 'moment().unix() < obj.resolutionDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Response Overdue",
                        name: "responseDeadlineAt",
                        predefinedOperatorArr: [{operator: "=", operatorName: "="}],
                        localSearch: {
                            type: 'timestamp',
                            name: 'assignees',
                            key: 'email'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'CURRENT_TIMESTAMP() > TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Exceeded',
                                isPredefinedValue: true,
                                filter: '>',
                                localSearch: 'moment().unix() > obj.responseDeadlineAt'
                            },
                            {
                                name: 'CURRENT_TIMESTAMP() < TIMESTAMP_SECONDS(responseDeadlineAt)',
                                displayName: 'Not exceeded',
                                isPredefinedValue: true,
                                filter: '<',
                                localSearch: 'moment().unix() < obj.responseDeadlineAt'
                            }
                        ],
                        displayKeyName: 'displayName',
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Assigned to me",
                        name: tableName + ".data->>'assignees'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "EXISTS (SELECT 1 FROM jsonb_array_elements(" + tableName + ".data->'assignees') as u WHERE u->>'email' = '" + loginUser.email + "')",
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Created by me",
                        name: tableName + ".data->>'createdBy'",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "data->>'createdBy' = '" + loginUser.email + "'",
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Unread",
                        name: tableName + ".lastPublicCommentReadBy",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "NOT (" + tableName + ".data->'lastPublicCommentReadBy' ? '" + loginUser.email + "')",
                        localSearchValue: "!obj.lastPublicCommentReadBy.includes('" + loginUser.email + "')"
                    }, {
                        displayName: "Custom Field",
                        name: tableName + ".data->>'customForm.values'",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnOrderFiltersArr = function () {
                    var tempArr = FiltersArrOrder.map(function (i) {
                        return vm.searchFiltersArr.find(function (o) {
                            return o.displayName === i;
                        });
                    });
                    vm.searchFiltersArr = _.filter(tempArr, function (tempObj) {
                        return angular.isObject(tempObj);
                    });
                };

                vm.sortFieldArr = [
                    {name: 'data->>\'name\'', displayName: 'Name'},
                    {name: "data->>'createdAt'", displayName: "Created"},
                    {name: "data->>'updatedAt'", displayName: "Updated"},
                    {name: "tracker_issues.data->>'issuePriority'->>'order'", displayName: "Priority"}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Issues Variables
                vm.isIssuesLoading = false;
                vm.issuesArr = [];
                vm.selectedIssuesArr = [];
                vm.selectedIssueObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.issueResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowIssueStats = false;
                vm.isShowIssueStateBoard = false;
                vm.isShowIssuePriorityBoard = false;
                vm.isShowIssueTypeBoard = false;
                vm.isShowStateBoardSettings = false;
                vm.isShowPriorityBoardSettings = false;
                vm.isShowTypeBoardSettings = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.lastSQLQuery = "";
                vm.issueTableAPITimeout = '';

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditIssueObj = {};

                vm.issueContextMenu = function (issueObj) {
                    if (Object.keys(vm.resetEditIssueObj).length) {
                        var isFindIssue = _.find(vm.issuesArr, {id: vm.resetEditIssueObj.id});
                        if (isFindIssue) {
                            vm.fnCancelIssueEditMode(isFindIssue);
                        }
                    }
                    if (!issueObj.resolved) {
                        return [{
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                issueObj.isEditable = true;
                                vm.resetEditIssueObj = angular.copy(issueObj);
                            }
                        }, {
                            text: 'Quick Reply',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                vm.resetEditIssueObj = angular.copy(issueObj);
                                vm.fnOpenQuickReplyPopup(issueObj);
                            }
                        }]
                    } else {
                        return [{
                            text: 'Detail',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                vm.fnCheckUncheckHeader(issueObj)
                            }
                        }]
                    }
                };

                vm.fnOpenQuickReplyPopup = function (issueObj) {
                    swal({
                            title: issueObj.psuedoId + " - " + issueObj.name,
                            text: "<textarea id='swalTextarea' class='p-5' " +
                                "placeholder='Write a public comment' style='height: 200px'></textarea>",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Add a public comment",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                var inputValue = document.getElementById('swalTextarea').value;
                                if (inputValue === "" || inputValue === false) {
                                    $timeout(function () {
                                        angular.element(".sa-confirm-button-container .confirm").removeAttr("disabled");
                                        angular.element(".sa-button-container .cancel").removeAttr("disabled");
                                    }, 100)
                                    amaran.error('Comment cannot be empty.');
                                    return false
                                } else {
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    var inputObj = {
                                        issueId: issueObj.id,
                                        body: {
                                            privateStream: false,
                                            text: inputValue,
                                            syntax: "TEXT"
                                        }
                                    };
                                    CommentFactory.addComment(inputObj)
                                        .then(function (response) {
                                            if (!issueObj.publicCommentIds) {
                                                issueObj.publicCommentIds = [];
                                            }
                                            issueObj.publicCommentIds.push(response.id);
                                            if (!issueObj.publicComments) {
                                                issueObj.publicComments = [];
                                            }
                                            issueObj.publicComments.push(response.id);
                                            angular.element(".microSpinner").remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            amaran.success('Public comment added successfully');
                                        }, function () {
                                            angular.element(".microSpinner").remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            amaran.error('Public comment was not added successfully');
                                        })
                                }
                            } else {
                                swal.close();
                            }
                        });
                }

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelIssueEditMode = function (issueObj, isSuccessCall) {
                    if (isSuccessCall) {
                        issueObj.name = angular.copy(issueObj.name);
                        issueObj.isEditable = false;
                        vm.resetEditIssueObj = {};
                    } else {
                        issueObj.name = angular.copy(vm.resetEditIssueObj.name);
                        issueObj.isEditable = false;
                        vm.resetEditIssueObj = {};
                    }
                };

                vm.fnSaveIssueInfo = function (issueObj) {
                    issueObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        issueId: issueObj.id
                    };
                    inputObj.body = {
                        name: issueObj.name
                    };
                    IssueFactory.modifyName(inputObj)
                        .then(function (response) {
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.issuesArr, function (issueObj) {
                                if (Object.keys(vm.selectedIssueObj).length) {
                                    if (issueObj.id === vm.selectedIssueObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedIssueObj[key] = val;
                                            issueObj[key] = val;
                                        });
                                    }
                                }
                                if (issueObj.id === resetCopy.id) {
                                    issueObj.name = resetCopy.name;
                                    issueObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelIssueEditMode(issueObj, true);
                            amaran.success("Issue Updated Successfully");
                        }, function (error) {
                            vm.fnCancelIssueEditMode(issueObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnResolvedAllIssue = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedIssuesArr, function (selectedIssue, index) {
                        if (selectedIssue.resolved !== true) {
                            if (index <= step) {
                                inputObj.method = "PUT";
                                inputObj.id = index;
                                inputObj.path = "/tracker/issues/" + selectedIssue.id + "/resolutions";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            } else {
                                batchArr = [];
                                step = step + 15;
                                count++;
                                inputObj.method = "PUT";
                                inputObj.id = index;
                                inputObj.path = "/tracker/issues/" + selectedIssue.id + "/resolutions";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            }
                        }
                    });

                    swal({
                            title: "Resolved the selected Issues?",
                            text: "You are about to resolved the selected issues.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "resolved",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnResolvedBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Resolved Process Cancelled", "error");
                            }
                        });
                }

                vm.fnResolvedBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnResolvedBatchOperation(batchCollectionObj, count);
                            } else {
                                vm.selectedIssuesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnResolvedBatchOperation(batchCollectionObj, count);
                            } else {
                                vm.selectedIssuesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnArchiveAllIssue = function () {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(vm.selectedIssuesArr, function (selectedIssue, index) {
                        if (index <= step) {
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + selectedIssue.id + "/archives";
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "PUT";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + selectedIssue.id + "/archives";
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Archive the selected Issues?",
                            text: "You are about to Archive the selected issues.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Archive",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnArchiveBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Archive Process Cancelled", "error");
                            }
                        });
                };

                vm.fnArchiveBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnArchiveBatchOperation(batchCollectionObj, count);
                            } else {
                                vm.selectedIssuesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnArchiveBatchOperation(batchCollectionObj, count);
                            } else {
                                vm.selectedIssuesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });


                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj.color)) {
                        vm.labelTextColor = vm.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + vm.labelTextColor
                        }
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT data->>\'_id\' as _id, ' +
                                'data->>\'name\' as name, ' +
                                'COUNT(*) OVER() as totalItems, ' +
                                'data->>\'_id\' AS rt ' +
                                'FROM tracker_projects ' +
                                'ORDER BY data->>\'_id\' ASC ' +
                                'LIMIT ' + 100 + ';';

                            // Pass the query to the project fetch function along with parsePostgresData
                            vm.fnGetProject({sql: projectSQL}, [], false)
                                .then(function(response) {
                                    return parsePostgresData(response);
                                });
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    vm.selectedIssuesArr = [];
                    vm.selectedIssueObj = {};
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindIssue = _.find(vm.issuesArr, {id: tab.id});
                            if (isFindIssue) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedIssuesArr = [];
                                vm.selectedIssueObj = {};
                                vm.fnCheckUncheckHeader(isFindIssue);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "Create Issue" &&
                                tab.id !== "issueStateBoard" &&
                                tab.id !== "issuePriorityBoard" &&
                                tab.id !== "issueTypeBoard" &&
                                tab.id !== "boardSettings" &&
                                tab.id !== "priorityBoardSettings" &&
                                tab.id !== "typeBoardSettings" &&
                                tab.id !== "WidgetEditor" &&
                                tab.id !== "issueStats") {
                                if (vm.isIssuesLoading || angular.isUndefined(isFindIssue)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedIssuesArr = [];
                                    vm.selectedIssueObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.issue', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Issue";
                        vm.isShowIssueStats = tab.id === "issueStats";
                        vm.isShowIssueStateBoard = tab.id === "issueStateBoard";
                        vm.isShowIssuePriorityBoard = tab.id === "issuePriorityBoard";
                        vm.isShowIssueTypeBoard = tab.id === "issueTypeBoard";
                        vm.isShowStateBoardSettings = tab.id === "boardSettings";
                        vm.isShowPriorityBoardSettings = tab.id === "priorityBoardSettings";
                        vm.isShowTypeBoardSettings = tab.id === "typeBoardSettings";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.selectedIssuesArr = [];
                                vm.selectedIssueObj = {};
                                vm.dashboardWidgets = [];
                                vm.fnSetServiceDashboardHeight();
                            });
                            $timeout.cancel(vm.issueTableAPITimeout);
                            vm.fnUpdateTableData();
                        } else {
                            $timeout.cancel(vm.issueTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Issue";
                    vm.isShowIssueStats = tab.id === "issueStats";
                    vm.isShowIssueStateBoard = tab.id === "issueStateBoard";
                    vm.isShowIssuePriorityBoard = tab.id === "issuePriorityBoard";
                    vm.isShowIssueTypeBoard = tab.id === "issueTypeBoard";
                    vm.isShowStateBoardSettings = tab.id === "boardSettings";
                    vm.isShowPriorityBoardSettings = tab.id === "priorityBoardSettings";
                    vm.isShowTypeBoardSettings = tab.id === "typeBoardSettings";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "issueStats" || tab.id === "WidgetEditor") {
                        $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.issueTableAPITimeout);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 500)
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (id === "Create Issue") {
                        $scope.$broadcast('resetCreateIssue');
                    }
                    if (vm.tabs.length === (index + 1) || id === "Create Issue") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.issue', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (issueObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(issueObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#issueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (issueObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ISSUE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.issuesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === issueObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        vm.selectedIssuesArr = [];
                        /* Toggle push in selected issue array*/
                        var isValueFind = _.find(vm.selectedIssuesArr, {'id': issueObj.id});
                        if (!isValueFind) {
                            vm.selectedIssuesArr.push(issueObj);
                            var isTabExist = _.find(vm.tabs, {'id': issueObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: issueObj.id,
                                    title: issueObj.name,
                                    tabIndex: newTabIndex,
                                    projectName: issueObj.project && issueObj.project.name ? issueObj.project.name : ''
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedIssuesArr, function (obj) {
                                return issueObj.id === obj.id;
                            });
                        }
                        if (vm.selectedIssuesArr.length === 1) {
                            vm.fnGetIssueDetails(vm.selectedIssuesArr[0])
                        } else {
                            $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.issuesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedIssuesArr = angular.copy(vm.issuesArr);
                    } else {
                        vm.selectedIssuesArr = [];
                    }
                    $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (nodeObj) {
                    var isFindIndex = _.findIndex(vm.selectedIssuesArr, {id: nodeObj});
                    if (nodeObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedIssuesArr.push(nodeObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedIssuesArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        issueId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_issues';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIssues(perPageInput, true).then(function(response) {
                            return parsePostgresData(response);
                        });
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>'projectId' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>'projectId' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.issuesArr);
                        vm.previousPage = page;
                        vm.fnGetIssues(input, false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                };

                vm.fnOpenIssueInfoTab = function (issueObj, tabIndex) {
                    if (vm.permissionObj.DESCRIBE_ISSUE) {
                        vm.tabIndex = tabIndex;
                        vm.fnCheckUncheckHeader(issueObj);
                    }
                };

                vm.fnGetIssue = function (issueObj, issuesArr) {
                    angular.forEach(issuesArr, function (issue) {
                        issue.isCheck = false;
                    });
                    issueObj.isCheck = true;
                    vm.selectedIssuesArr = [issueObj]; // Assign array with single Issue object
                    vm.fnGetIssueDetails(issueObj);
                };

                vm.fnGetIssueDetails = function (issueObj) {
                    vm.isIssueDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when issue is selected
                        vm.selectedIssueObj = issueObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.issue', {
                                selectedId: vm.selectedIssueObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedIssueObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isIssueDetailsLoaded = true;
                        } else {
                            $state.go('main.issue', {selectedId: vm.selectedIssueObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedIssueObj.id;
                            vm.isIssueDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetIssues = function (inputObj, isFirst) {
                    vm.isIssuesLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var currentTime = moment().unix();
                            res.data.map(function (obj) {
                                obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.resolvedAt) {
                                    obj.resolvedDate = vm.fnGetAbsoluteOrRelativeTime(obj.resolvedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.resolutionDeadlineAt) {
                                    obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                                    obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                                    var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    obj.issueCreateDate = issueCreateDate;
                                    obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    obj.issueDeadline = issueDeadline;
                                    obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (obj.responseDeadlineAt) {
                                    obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                                    obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                                    var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    obj.issueUpdatedDate = issueUpdatedDate;
                                    obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    obj.issueResponseDeadline = issueResponseDeadline;
                                    obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (obj.resolved && obj.resolutionDeadlineAt) {
                                    if (obj.resolvedAt <= obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = true
                                    } else if (obj.resolvedAt > obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = false
                                    }
                                }
                                obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(obj.lastPublicCommentReadBy) && obj.lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(obj.lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    obj.isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    obj.isRead = false;
                                }
                            });
                            vm.issueResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.issueResponse.data && vm.issueResponse.data.length) {
                                    vm.totalItems = vm.issueResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.issueResponse.data.reverse();
                            }
                            vm.issuesArr = vm.issueResponse.data;
                            if (!$stateParams.selectedId) {
                                vm.issueTableAPITimeout = $timeout(function () {
                                    vm.fnUpdateTableData();
                                }, 60000);
                            }
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetIssue(res[0], vm.issuesArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var issueData = _.find(vm.issuesArr, {"id": $stateParams.selectedId});
                                if (issueData) {
                                    vm.fnCheckUncheckHeader(issueData)
                                } else {
                                    swal({
                                        title: "Please wait while your data loads...",
                                        type: "warning",
                                        showConfirmButton: true,
                                        showLoaderOnConfirm: true
                                    });
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    var tempObj = {
                                        issueId: $stateParams.selectedId
                                    };
                                    IssueFactory.describeIssue(tempObj)
                                        .then(function (response) {
                                            angular.element(".microSpinner").remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            if (response.projectId) {
                                                response.project = _.find(vm.projectsArr, {id: response.projectId});
                                            }
                                            vm.fnCheckUncheckHeader(response);
                                        }, function () {
                                        })
                                }
                            }
                            if (addedIssueId.length) {
                                vm.fnOpenPostCreateActionModal(addedIssueId);
                                addedIssueId = '';
                            }
                            if ($state.current.name === 'main.issue') {
                                $state.go('main.issue', {
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                            }
                            $timeout(function () {
                                if (Object.keys(vm.project).length && vm.project.id !== "All") {
                                    $state.go('main.issue', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        selectedProject: vm.project.id
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    $stateParams.selectedProject = vm.project.id;
                                } else {
                                    $state.go('main.issue', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        selectedProject: ""
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    delete $stateParams.selectedProject;
                                }
                            }, 10);
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                parsedData = parsePostgresData(res.data);
                                var projects = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (projectObj) {
                                    projects.push(projectObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                    var sqlString = 'SELECT data, data->>\'_id\' AS rt FROM tracker_projects';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetProject({sql: sqlString}, projects, true);
                                } else {
                                    vm.projectsArr = _.cloneDeepWith(projects);
                                    vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                    vm.projectsArr.unshift({name: "All", id: "All"});
                                    vm.fnSetSelectedProject();
                                }
                            });
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectIssue = function (projectObj) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>'projectId'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_issues';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT*, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT*, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>'projectId' = '" + vm.project.id + "'" : " WHERE data->>'projectId' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'selectedProject', '');
                    }
                    vm.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnCopyInfoToClipboard = function (data, type) {
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.fnAddDefaultFilter();
                    });
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.isShowFormOption = function (issueObj) {
                    return !!(angular.isDefined(issueObj.customForm) && issueObj.customForm.schema && issueObj.customForm.schema.properties && Object.keys(issueObj.customForm.schema.properties).length)
                };

                vm.fnSetBoardProjectTabName = function (tabProjectName) {
                    vm.tabs[vm.activeTabIndex - 1].projectName = tabProjectName;
                    $timeout(function () {
                        $scope.$apply();
                    })
                };

                $scope.$on("IssueDeleted", function (evt, data) {
                    vm.selectedIssueObj = null;
                    vm.selectedIssuesArr = [];
                    vm.issuesArr = vm.issuesArr.filter(function (issueObj) {
                        return (issueObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("issueArchive", function (evt, data) {
                    vm.selectedIssueObj = null;
                    vm.selectedIssuesArr = [];
                    vm.issueResponse.data = vm.issueResponse.data.filter(function (issueObj) {
                        return (issueObj.id !== data);
                    });
                    vm.issuesArr = vm.issuesArr.filter(function (issueObj) {
                        return (issueObj.id !== data);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnRemoveTab(data);
                });

                $scope.$on("issueResolved", function (evt, data) {
                    if (vm.lastSQLQuery && vm.lastSQLQuery.length && vm.lastSQLQuery.includes('data->\'resolved\' = \'false\'')) {
                        vm.issueResponse.data = vm.issueResponse.data.filter(function (issueObj) {
                            return (issueObj.id !== data);
                        });
                        vm.issuesArr = vm.issuesArr.filter(function (issueObj) {
                            return (issueObj.id !== data);
                        });
                        vm.totalItems = vm.totalItems - 1;
                        $state.go('main.issue', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                });

                $scope.$on("IssueDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    var issueFindIndex = _.findIndex(vm.issuesArr, {id: data.id});
                    if (issueFindIndex !== -1) {
                        vm.issuesArr[issueFindIndex] = resetCopy;
                    }
                    var currentTime = moment().unix();
                    vm.issuesArr.map(function (obj) {
                        obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                        if (obj.createdAt) {
                            obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                        }
                        if (obj.updatedAt) {
                            obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                        }
                        if (obj.projectId) {
                            obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                        }
                        if (obj.resolutionDeadlineAt) {
                            obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                            obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                            var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                            var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                            obj.issueCreateDate = issueCreateDate;
                            obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                            var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                            var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                            obj.issueDeadline = issueDeadline;
                            obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                        }
                        if (obj.responseDeadlineAt) {
                            obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                            obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                            var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                            var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                            obj.issueUpdatedDate = issueUpdatedDate;
                            obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                            var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                            var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                            obj.issueResponseDeadline = issueResponseDeadline;
                            obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                        }
                        if (obj.resolved && obj.resolutionDeadlineAt) {
                            if (obj.resolvedAt <= obj.resolutionDeadlineAt) {
                                obj.isResolvedAtTime = true
                            } else if (obj.resolvedAt > obj.resolutionDeadlineAt) {
                                obj.isResolvedAtTime = false
                            }
                        }
                        obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                        if (angular.isDefined(obj.lastPublicCommentReadBy) && obj.lastPublicCommentReadBy.length) {
                            var issueRead = _.find(obj.lastPublicCommentReadBy, function (id) {
                                return id === loginUser.email
                            });
                            obj.isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                        } else {
                            obj.isRead = false;
                        }
                    });
                    if (vm.selectedIssueObj.id === data.id && issueFindIndex !== -1) {
                        vm.selectedIssueObj = vm.issuesArr[issueFindIndex];
                    }
                    var isFind = _.find(vm.tabs, {id: data.id});
                    if (isFind) {
                        isFind.title = data.name;
                        isFind.projectName = issueFindIndex !== -1 ? vm.issuesArr[issueFindIndex].project.name : _.find(vm.projectsArr, {id: data.projectId}).name;
                    }
                });

                $scope.$on("issueAdded", function (evt, data) {
                    if (data.projectId && (vm.project.id === data.projectId || vm.project.id === "All")) {
                        var index = _.findIndex(vm.projectsArr, function (project) {
                            return project.id === data.projectId
                        });
                        if (index !== -1) {
                            data.project = _.cloneDeepWith(vm.projectsArr[index]);
                        } else {
                            data.project = {};
                        }
                        data.psuedoId = "#" + data.id.substr(data.id.length - 4);
                        vm.issueResponse.data.unshift(data);
                        //vm.issuesArr.unshift(data);
                        vm.totalItems = vm.totalItems + 1;
                    }
                    vm.fnRemoveTab('Create Issue');
                });


                vm.fnAddDefaultFilter = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.issue", tempArr, {notify: false});
                    } else {
                        if (angular.isDefined($stateParams.filter)) {
                            var filterJson = angular.fromJson($stateParams.filter);
                            var isFind = _.find(filterJson, {selectedField: 'resolved'});
                            if (!isFind) {
                                filterJson.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "resolved",
                                    displaySelectedField: "Open",
                                    selectedConnector: "and",
                                    searchText: '',
                                    displaySearchText: '',
                                    isDirectFilterApply: true,
                                    sqlValue: 'data->\'resolved\' = \'false\'',
                                    localSearchValue: 'obj.resolved === false'
                                });
                                $state.go("main.issue", {filter: angular.toJson(filterJson)}, {notify: false});
                                $stateParams.filter = angular.toJson(filterJson);
                            }
                        } else {
                            var inputObj = [{
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                selectedField: "resolved",
                                displaySelectedField: "Open",
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: 'data->\'resolved\' = \'false\'',
                                localSearchValue: 'obj.resolved === false'
                            }];
                            $state.go("main.issue", {filter: angular.toJson(inputObj)}, {notify: false});
                            $stateParams.filter = angular.toJson(inputObj);
                        }
                    }
                };

                vm.fnInitIssues = function () {
                    vm.fnAddDefaultFilter();
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.permissionObj.ADD_SUB_COMMENT = false;
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    var assigneeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAssignee({sql: assigneeSQL}, [], false).then(function(response) {
                        return parsePostgresData(response);
                    });
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issueTypesArr').length !== 0) {
                        vm.issueTypesArr = _.cloneDeepWith(AppInitService.getInitData('issueTypesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Type",
                                    name: tableName + ".data->>'issueType.id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueType',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issueTypesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        });
                    } else {
                        var typeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_types ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetTypes({sql: typeSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issuePrioritiesArr').length !== 0) {
                        vm.issuePrioritiesArr = _.cloneDeepWith(AppInitService.getInitData('issuePrioritiesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Priority",
                                    name: tableName + ".data->>'issuePriority.id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issuePriority',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issuePrioritiesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        });
                    } else {
                        var prioritiesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_priorities ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetPriorities({sql: prioritiesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('issueStatesArr').length !== 0) {
                        vm.issueStatesArr = _.cloneDeepWith(AppInitService.getInitData('issueStatesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Status",
                                    name: tableName + ".data->>'issueState.id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueState',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issueStatesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            vm.fnOrderFiltersArr();
                        });
                    } else {
                        var statesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_states ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetStates({sql: statesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    var labelsSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_labels ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetIssueLabels({sql: labelsSQL}, [], false).then(function(response) {
                        return parsePostgresData(response);
                    });
                    //var participantsSQL = 'SELECT data, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_whitelist_emails ORDER BY rt asc LIMIT ' + 100 + ';';
                    //vm.fnGetParticipants();
                    //vm.fnGetParticipants({sql: participantsSQL}, [], false);
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'issue', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetIssueDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssueStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetBoardSettings = function (isCalledForState, isCalledForPriority) {
                    var isTabExist = isCalledForState ? _.find(vm.tabs, {id: 'boardSettings'}) :
                        isCalledForPriority ? _.find(vm.tabs, {id: 'priorityBoardSettings'}) : _.find(vm.tabs, {id: 'typeBoardSettings'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            if (isCalledForState) {
                                vm.isShowStateBoardSettings = true;
                            } else if (isCalledForPriority) {
                                vm.isShowPriorityBoardSettings = true;
                            } else {
                                vm.isShowTypeBoardSettings = true;
                            }
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: isCalledForState ? 'boardSettings' : isCalledForPriority ? 'priorityBoardSettings' : 'typeBoardSettings',
                            title: isCalledForState ? 'State Board Settings' : isCalledForPriority ? 'Priority Board Settings' : 'Type Board Settings',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            if (isCalledForState) {
                                vm.isShowStateBoardSettings = true;
                            } else if (isCalledForPriority) {
                                vm.isShowPriorityBoardSettings = true;
                            } else {
                                vm.isShowTypeBoardSettings = true;
                            }
                        });
                    }
                };

                vm.fnGetIssueStateBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueStateBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueStateBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueStateBoard',
                            title: 'State Board',
                            tabIndex: newTabIndex,
                            projectName: ''
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueStateBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssuePriorityBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issuePriorityBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssuePriorityBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issuePriorityBoard',
                            title: 'Priority Board',
                            tabIndex: newTabIndex,
                            projectName: ''
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssuePriorityBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssueTypeBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueTypeBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueTypeBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueTypeBoard',
                            title: 'Type Board',
                            tabIndex: newTabIndex,
                            projectName: ''
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueTypeBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var optionsArr = [
                        {
                            faIcon: "fa-issue",
                            subOptions: [
                                {
                                    displayText: "Add Users",
                                    isRedirect: false,
                                    selectedTab: 2,
                                    isVisible: true
                                }
                            ]
                        }
                    ];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj)
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else {
                                var issueData = _.find(vm.issuesArr, {"id": selectedId});
                                if (issueData) {
                                    $state.go('main.issue', {selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnGetIssue(issueData, vm.issuesArr);
                                } else {
                                    var tempArr = [
                                        {
                                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                            name: "Keyword: " + selectedId,
                                            searchText: selectedId
                                        }
                                    ];
                                    $state.go('main.issue', {
                                        filter: angular.toJson(tempArr),
                                        selectedId: selectedId,
                                        selectedDetailsTab: selectedOption.selectedTab
                                    }, {notify: false});
                                    $stateParams.filter = angular.toJson(tempArr);
                                    $stateParams.selectedId = selectedId;
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnReload();
                                }
                            }
                        }, function () {
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getIssueCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.issuesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (issueObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = issueObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var issuesArrCp = _.cloneDeepWith(vm.issuesArr);
                    var data = [];
                    _.forEach(issuesArrCp, function (tempObj) {
                        var obj = {
                            id: tempObj.id,
                            name: tempObj.name,
                            summary: tempObj.summary
                        };
                        if (tempObj.issueType && Object.keys(tempObj.issueType).length) {
                            obj.issueType = tempObj.issueType.name + " (" + tempObj.issueType.id + ")";
                        } else {
                            obj.issueType = '';
                        }
                        if (tempObj.issuePriority && Object.keys(tempObj.issuePriority).length) {
                            obj.issuePriority = tempObj.issuePriority.name + " (" + tempObj.issuePriority.id + ")";
                        } else {
                            obj.issuePriority = '';
                        }
                        if (tempObj.issueState && Object.keys(tempObj.issueState).length) {
                            obj.issueState = tempObj.issueState.name + " (" + tempObj.issueState.id + ")";
                        } else {
                            obj.issueState = '';
                        }
                        if (tempObj.project) {
                            obj.project = tempObj.project.name + " (" + tempObj.project.id + ")";
                        } else {
                            obj.project = tempObj.projectId;
                        }
                        if (tempObj.issueLabels) {
                            var tempLabelsStr = "";
                            _.forEach(tempObj.issueLabels, function (labObj, index) {
                                if (index !== (tempObj.issueLabels.length - 1)) {
                                    tempLabelsStr += labObj.name + " (" + labObj.id + "), \n";
                                } else {
                                    tempLabelsStr += labObj.name + " (" + labObj.id + ")";
                                }
                            })
                            obj.issueLabels = tempLabelsStr;
                        } else {
                            obj.issueLabels = "";
                        }
                        if (tempObj.assignees) {
                            var tempAssigneesStr = "";
                            _.forEach(tempObj.assignees, function (assigneesObj, index) {
                                if (index !== (tempObj.assignees.length - 1)) {
                                    tempAssigneesStr += assigneesObj.firstName + " " + assigneesObj.lastName + " (" + assigneesObj.email + "), \n";
                                } else {
                                    tempAssigneesStr += assigneesObj.firstName + " " + assigneesObj.lastName + " (" + assigneesObj.email + ")";
                                }
                            })
                            obj.assignees = tempAssigneesStr;
                        } else {
                            obj.assignees = "";
                        }
                        if (tempObj.confidential) {
                            obj.confidential = 'Confidential';
                        } else {
                            obj.confidential = 'Not Confidential';
                        }
                        if (tempObj.createdAt !== 0) {
                            obj.createdAt = moment.unix(tempObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.createdAt = "";
                        }
                        if (tempObj.createdBy) {
                            obj.createdBy = tempObj.createdBy;
                        } else {
                            obj.createdBy = "";
                        }
                        if (tempObj.updatedAt) {
                            obj.updatedAt = moment.unix(tempObj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.updatedAt = "";
                        }
                        if (tempObj.updatedBy) {
                            obj.updatedBy = tempObj.updatedBy;
                        } else {
                            obj.updatedBy = "";
                        }
                        if (tempObj.resolved) {
                            obj.resolved = 'Resolved';
                        } else {
                            obj.resolved = 'Not Resolved';
                        }
                        if (tempObj.resolvedAt) {
                            obj.resolvedAt = moment.unix(tempObj.resolvedAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.resolvedAt = "";
                        }
                        if (tempObj.resolvedBy) {
                            obj.resolvedBy = tempObj.resolvedBy;
                        } else {
                            obj.resolvedBy = "";
                        }
                        if (angular.isDefined(tempObj.voteCount)) {
                            obj.voteCount = tempObj.voteCount;
                        } else {
                            obj.voteCount = "";
                        }
                        if (angular.isDefined(tempObj.voters)) {
                            obj.voters = tempObj.voters.join(', \n');
                        } else {
                            obj.voters = "";
                        }
                        if (angular.isDefined(tempObj.participants)) {
                            obj.participants = tempObj.participants.join(', \n');
                        } else {
                            obj.participants = "";
                        }
                        if (angular.isDefined(tempObj.lastPublicCommentReadBy)) {
                            obj.lastPublicCommentReadBy = tempObj.lastPublicCommentReadBy.join(', \n');
                        } else {
                            obj.lastPublicCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.lastPrivateCommentReadBy)) {
                            obj.lastPrivateCommentReadBy = tempObj.lastPrivateCommentReadBy.join(', \n');
                        } else {
                            obj.lastPrivateCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.lastPrivateCommentReadBy)) {
                            obj.lastPrivateCommentReadBy = tempObj.lastPrivateCommentReadBy.join(', \n');
                        } else {
                            obj.lastPrivateCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.publicCommentIds)) {
                            obj.publicCommentIds = tempObj.publicCommentIds.join(', \n');
                        } else {
                            obj.publicCommentIds = "";
                        }
                        if (angular.isDefined(tempObj.privateCommentIds)) {
                            obj.privateCommentIds = tempObj.privateCommentIds.join(', \n');
                        } else {
                            obj.privateCommentIds = "";
                        }
                        if (angular.isDefined(tempObj.attributeIds)) {
                            obj.attributeIds = tempObj.attributeIds.join(', \n');
                        } else {
                            obj.attributeIds = "";
                        }
                        if (tempObj.resolutionDeadlineAt) {
                            obj.resolutionDeadlineAt = moment.unix(tempObj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.resolutionDeadlineAt = "";
                        }
                        if (tempObj.responseDeadlineAt) {
                            obj.responseDeadlineAt = moment.unix(tempObj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.responseDeadlineAt = "";
                        }
                        if (tempObj.index) {
                            obj.index = tempObj.index;
                        } else {
                            obj.index = "";
                        }
                        if (tempObj.keywords) {
                            obj.keywords = tempObj.keywords;
                        } else {
                            obj.keywords = "";
                        }
                        if (angular.isDefined(tempObj.customForm) && Object.keys(tempObj.customForm).length) {
                            obj.customForm = angular.toJson(tempObj.customForm);
                        } else {
                            obj.customForm = "";
                        }
                        if (angular.isDefined(tempObj.tags) && Object.keys(tempObj.tags).length) {
                            obj.tags = angular.toJson(tempObj.tags);
                        } else {
                            obj.tags = "";
                        }
                        data.push(obj);
                    });
                    var heading = [
                        ["ID", "Name", "Summary", "Issue Type", "Issue Priority", "Issue State", "Project", "Issue Labels",
                            "Assignees", "Confidential", "Created At", "Created By", "Updated At", "Updated By", "Resolved",
                            "Resolved At", "Resolved By", "Vote Count", "Voters", "Participants", "Last Public Comment Read By",
                            "Last Private Comment Read By", "PublicComment Ids", "PrivateComment Ids", "Attribute Ids", "Resolution Deadline At",
                            "Response Deadline At", "Index", "Keywords", "Custom Form", "Tags"]
                    ];
                    var workbook = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.sheet_add_aoa(ws, heading);
                    XLSX.utils.book_append_sheet(workbook, ws);
                    XLSX.writeFile(workbook, 'issues.xlsx', {type: 'file'});
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'issue', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnExpandCollapseString = function (data, header) {
                    if (data[header].length > 50) {
                        data.isShowFullString = !data.isShowFullString
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnAddUpDownVoteToIssue = function (isUpVote, issueObj) {
                    if (isUpVote && !vm.permissionObj.UP_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to up vote an Issue.');
                        return;
                    } else if (!isUpVote && !vm.permissionObj.DOWN_VOTE_ISSUE) {
                        amaran.error('Sorry, Looks like you do not have permission to down vote an Issue.');
                        return;
                    }
                    issueObj.isVoteUpdating = true;
                    issueObj.voteCount = issueObj.voteCount ? issueObj.voteCount : 0;
                    var input = {
                        issueId: issueObj.id
                    };
                    if (isUpVote) {
                        IssueFactory.upVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdating;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(res.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    } else {
                        IssueFactory.downVoteIssue(input)
                            .then(function (res) {
                                delete issueObj.isVoteUpdating;
                                issueObj.humanDateCreated = moment.unix(res.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                issueObj.humanDateCreatedRelative = moment(res.humanDateCreated).fromNow();
                                issueObj.humanDateCreatedAbsolute = moment.unix(res.createdAt).format('MMMM Do YYYY, h:mm:ss a');
                                issueObj.voteCount = res.voteCount;
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                            });
                    }
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetAssignee = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var users = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (userObj) {
                                    users.push({
                                        id: userObj.id,
                                        firstName: userObj.firstName,
                                        lastName: userObj.lastName,
                                        fullName: userObj.firstName + ' ' + userObj.lastName,
                                        email: userObj.email,
                                        userAvatar: angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                    });
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (users[0] && users[0].totalItems > users.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetAssignee({sql: sqlString}, users, true);
                                } else {
                                    vm.assigneeArr = _.cloneDeepWith(users);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Assignee",
                                                name: tableName + ".data->>'assignees'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'assignees',
                                                    key: 'email'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.assigneeArr,
                                                displayKeyName: 'fullName',
                                                isShowId: true,
                                                isShowUserAvatar: true,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'email'
                                            }
                                        );
                                        vm.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetTypes = function (inputObj, preDefinedIssueTypes, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var types = isCalledForViz ? preDefinedIssueTypes : [];
                                _.forEach(parsedData, function (typeObj) {
                                    types.push(typeObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (types[0] && types[0].totalItems > types.length)) {
                                    var sqlString = 'SELECT *, data->.\'_id\' AS rt FROM tracker_types';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + types[types.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetTypes({sql: sqlString}, types, true);
                                } else {
                                    vm.issueTypesArr = _.cloneDeepWith(types);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Type",
                                                name: tableName + ".data->>'issueType.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueType',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueTypesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        vm.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetPriorities = function (inputObj, preDefinedIssuePriorities, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var priorities = isCalledForViz ? preDefinedIssuePriorities : [];
                                _.forEach(parsedData, function (priorityObj) {
                                    priorities.push(priorityObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (priorities[0] && priorities[0].totalItems > priorities.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + priorities[priorities.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetPriorities({sql: sqlString}, priorities, true);
                                } else {
                                    vm.issuePrioritiesArr = _.cloneDeepWith(priorities);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Priority",
                                                name: tableName + ".data->>'issuePriority.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issuePriority',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issuePrioritiesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        vm.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetStates = function (inputObj, preDefinedIssueStates, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var states = isCalledForViz ? preDefinedIssueStates : [];
                                _.forEach(parsedData, function (stateObj) {
                                    states.push(stateObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (states[0] && states[0].totalItems > states.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + states[states.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetStates({sql: sqlString}, states, true);
                                } else {
                                    vm.issueStatesArr = _.cloneDeepWith(states);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Status",
                                                name: tableName + ".data->>'issueState.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueState',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueStatesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        vm.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetIssueLabels = function (inputObj, preDefinedIssueLabels, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var labels = isCalledForViz ? preDefinedIssueLabels : [];
                                _.forEach(parsedData, function (labelObj) {
                                    labels.push(labelObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (labels[0] && labels[0].totalItems > labels.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + labels[labels.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetIssueLabels({sql: sqlString}, labels, true);
                                } else {
                                    vm.issueLabelsArr = _.cloneDeepWith(labels);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Label",
                                                name: tableName + ".data->>'issueLabels'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'issueLabels',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueLabelsArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                        vm.fnOrderFiltersArr();
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnOpenIssueAttributeModal = function (issueObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/tracker/issue/modal/issueAttributesModal/issueAttributesModal.html',
                        size: 'lg',
                        controller: 'issueAttributesModalCtrl as issueAttribute',
                        windowClass: 'modal-height100',
                        resolve: {
                            issueObj: function () {
                                return _.cloneDeepWith(issueObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnUpdateTableData = function () {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            var currentTime = moment().unix();
                            var isEditableFound = _.cloneDeepWith(_.find(vm.issuesArr, {isEditable: true}));
                            vm.issuesArr = [];
                            var tempSelectedIssuesObj = {};
                            vm.selectedIssuesArr = _.filter(vm.selectedIssuesArr, function (selectIssueObj) {
                                var isFind = _.find(res.data, {id: selectIssueObj.id});
                                if (isFind) {
                                    tempSelectedIssuesObj[selectIssueObj.id] = _.cloneDeepWith(isFind);
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                            _.forEach(res.data, function (resObj, index) {
                                if (isEditableFound && resObj.id === isEditableFound.id) {
                                    resObj.isEditable = true;
                                    vm.resetEditIssueObj = _.cloneDeepWith(resObj);
                                    resObj.name = _.cloneDeepWith(isEditableFound.name);
                                    resObj.description = _.cloneDeepWith(isEditableFound.description);
                                }
                                delete vm.issuesArr[index];
                                vm.issuesArr[index] = resObj;
                                vm.issuesArr[index].psuedoId = "#" + vm.issuesArr[index].id.substr(vm.issuesArr[index].id.length - 4);
                                if (vm.issuesArr[index].createdAt) {
                                    vm.issuesArr[index].createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].createdAt);
                                }
                                if (vm.issuesArr[index].updatedAt) {
                                    vm.issuesArr[index].updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].updatedAt);
                                }
                                if (vm.issuesArr[index].resolvedAt) {
                                    vm.issuesArr[index].resolvedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].resolvedAt);
                                }
                                if (vm.issuesArr[index].projectId) {
                                    vm.issuesArr[index].project = _.find(vm.projectsArr, {id: vm.issuesArr[index].projectId});
                                }
                                if (angular.isDefined(tempSelectedIssuesObj[resObj.id])) {
                                    vm.issuesArr[index].isCheck = true;
                                }
                                if (vm.issuesArr[index].resolutionDeadlineAt) {
                                    vm.issuesArr[index].isResolutionDeadlinePastDate = currentTime >= vm.issuesArr[index].resolutionDeadlineAt;
                                    vm.issuesArr[index].remainingTime = 100 * (1 - (currentTime - vm.issuesArr[index].createdAt) / (vm.issuesArr[index].resolutionDeadlineAt - vm.issuesArr[index].createdAt));
                                    var issueCreateDate = moment.unix(vm.issuesArr[index].createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    vm.issuesArr[index].issueCreateDate = issueCreateDate;
                                    vm.issuesArr[index].issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(vm.issuesArr[index].resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    vm.issuesArr[index].issueDeadline = issueDeadline;
                                    vm.issuesArr[index].issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (vm.issuesArr[index].responseDeadlineAt) {
                                    vm.issuesArr[index].isResponseDeadlinePastDate = currentTime >= vm.issuesArr[index].responseDeadlineAt;
                                    vm.issuesArr[index].responseTime = 100 * (1 - (currentTime - vm.issuesArr[index].updatedAt) / (vm.issuesArr[index].responseDeadlineAt - vm.issuesArr[index].updatedAt));
                                    var issueUpdatedDate = moment.unix(vm.issuesArr[index].updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    vm.issuesArr[index].issueUpdatedDate = issueUpdatedDate;
                                    vm.issuesArr[index].issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(vm.issuesArr[index].responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    vm.issuesArr[index].issueResponseDeadline = issueResponseDeadline;
                                    vm.issuesArr[index].issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (vm.issuesArr[index].resolved && vm.issuesArr[index].resolutionDeadlineAt) {
                                    if (vm.issuesArr[index].resolvedAt <= vm.issuesArr[index].resolutionDeadlineAt) {
                                        vm.issuesArr[index].isResolvedAtTime = true
                                    } else if (vm.issuesArr[index].resolvedAt > vm.issuesArr[index].resolutionDeadlineAt) {
                                        vm.issuesArr[index].isResolvedAtTime = false
                                    }
                                }
                                vm.issuesArr[index].tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + vm.issuesArr[index].issueDeadlineRelativeDateTime + '</b> </br>(At ' + vm.issuesArr[index].issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + vm.issuesArr[index].issueCreateRelativeDateTime + ' </b></br> (At ' + vm.issuesArr[index].issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(vm.issuesArr[index].lastPublicCommentReadBy) && vm.issuesArr[index].lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(vm.issuesArr[index].lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    vm.issuesArr[index].isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    vm.issuesArr[index].isRead = false;
                                }
                            })
                            if (vm.issueTableAPITimeout.$$state && (angular.isUndefined(vm.issueTableAPITimeout.$$state.value) || vm.issueTableAPITimeout.$$state.value !== "canceled")) { //eslint-disable-line
                                vm.issueTableAPITimeout = $timeout(function () {
                                    vm.fnUpdateTableData();
                                }, 60000);
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            if (vm.issueTableAPITimeout.$$state && (angular.isUndefined(vm.issueTableAPITimeout.$$state.value) || vm.issueTableAPITimeout.$$state.value !== "canceled")) { //eslint-disable-line
                                vm.issueTableAPITimeout = $timeout(function () {
                                    vm.fnUpdateTableData();
                                }, 60000);
                            }
                        })
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                /*vm.fnGetParticipants = function (inputObj, preDefinedIssueParticipants, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var participants = isCalledForViz ? preDefinedIssueParticipants : [];
                            _.forEach(res.data, function (participantObj) {
                                participants.push({
                                    name: participantObj.email,
                                    id: participantObj.email
                                });
                            });
                            if (participants[0] && participants[0].totalItems > participants.length) {
                                var sqlString = 'SELECT *, _id AS rt FROM access_whitelist_emails';
                                sqlString += ' WHERE _id > ' + "'" + participants[participants.length - 1].rt + "'";
                                sqlString += ' ORDER BY _id asc LIMIT ' + 100 + ';';
                                vm.fnGetParticipants({sql: sqlString}, participants, true);
                            } else {
                                vm.issueParticipantsArr = _.cloneDeepWith(participants);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Participant",
                                            name: tableName + ".participants",
                                            localSearch: {
                                                type: 'array',
                                                name: 'participants',
                                                key: 'id'
                                            },
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.issueParticipantsArr,
                                            displayKeyName: 'name',
                                            isShowId: false,
                                            isShowUserAvatar: false,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.fnOrderFiltersArr();
                                });
                            }
                        }, function () { // Error block
                        })
                };*/

                var issueKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.issue') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_ISSUE &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            }
                        }
                    }
                };

                var issueKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.issue') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', issueKeyDownEventHandler);
                document.addEventListener('keyup', issueKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    document.removeEventListener('keydown', issueKeyDownEventHandler);
                    document.removeEventListener('keyup', issueKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TrackerDashboardCtrl',
            function ($scope, $window, $timeout, $state) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;
                vm.isCreate = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1900;
                    });
                });

                vm.fnGoToState = function (state) {
                    $state.go(state)
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.isCreate = tab.id === "Create Issue";
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Issue";
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                };
                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerDashboardChartData', angular.toJson(tempIssueData));
                    vm.isCreate = true;
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnInit = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1900) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ArchivedIssueCtrl',
            function ($scope, $window, $timeout, $stateParams, AppInitService, $sce, $state, $uibModal, amaran, swal,
                      moment, copyService, microSpinner, AvatarService, WidgetsListService, UserProfileService,
                      UserFactory, DB, XLSX, Authenticate, LastPageService, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, ProjectFactory, ArchivedIssueFactory, QueryFactory, PaginationQueryService,
                      postActionModelIcon, postActionModelMessage, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var tableName = 'tracker_archived_issues';
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedIssueId = '';
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                //Search Variables
                vm.isRefreshData = true;
                vm.assigneeArr = [];
                vm.issueTypesArr = [];
                vm.isColumnView = true;
                vm.issueProjectFilter = "$";
                vm.issueProjectSearch = {$: ''};
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Summary",
                        name: "summary",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Created",
                        name: "createdAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Updated",
                        name: "updatedAt",
                        regexp: "",
                        errorMessage: "",
                        type: 'dateTime'
                    }, {
                        displayName: "Open",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'false\'',
                        localSearchValue: 'obj.resolved === false'
                    }, {
                        displayName: "Resolved",
                        name: "resolved",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'resolved\' = \'true\'',
                        localSearchValue: 'obj.resolved === true'
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Issues Variables
                vm.isIssuesLoading = false;
                vm.issuesArr = [];
                vm.selectedIssuesArr = [];
                vm.selectedIssueObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isInitIssue = true;
                vm.issueResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowIssueStats = false;
                vm.isShowIssueStateBoard = false;
                vm.isShowIssuePriorityBoard = false;
                vm.isShowIssueTypeBoard = false;
                vm.isShowStateBoardSettings = false;
                vm.isShowPriorityBoardSettings = false;
                vm.isShowTypeBoardSettings = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                vm.issueTableAPITimeout = '';

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditIssueObj = {};

                vm.issueContextMenu = function (issueObj) {
                    if (Object.keys(vm.resetEditIssueObj).length) {
                        var isFindIssue = _.find(vm.issuesArr, {id: vm.resetEditIssueObj.id});
                        if (isFindIssue) {
                            vm.fnCancelIssueEditMode(isFindIssue);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            issueObj.isEditable = true;
                            vm.resetEditIssueObj = angular.copy(issueObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnCancelIssueEditMode = function (issueObj, isSuccessCall) {
                    if (isSuccessCall) {
                        issueObj.name = angular.copy(issueObj.name);
                        issueObj.description = angular.copy(issueObj.description);
                        issueObj.isEditable = false;
                        vm.resetEditIssueObj = {};
                    } else {
                        issueObj.name = angular.copy(vm.resetEditIssueObj.name);
                        issueObj.description = angular.copy(vm.resetEditIssueObj.description);
                        issueObj.isEditable = false;
                        vm.resetEditIssueObj = {};
                    }
                };

                vm.fnSaveIssueInfo = function (issueObj) {
                    issueObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        issueId: issueObj.id
                    };
                    inputObj.body = {
                        name: issueObj.name,
                        description: angular.isUndefined(issueObj.description) ? '' : issueObj.description
                    };
                    ArchivedIssueFactory.updateIssue(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.issuesArr, function (issueObj) {
                                if (Object.keys(vm.selectedIssueObj).length) {
                                    if (issueObj.id === vm.selectedIssueObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedIssueObj[key] = val;
                                            issueObj[key] = val;
                                        });
                                    }
                                }
                                if (issueObj.id === resetCopy.id) {
                                    issueObj.name = resetCopy.name;
                                    issueObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelIssueEditMode(issueObj, true);
                            amaran.success("Issue Updated Successfully");
                        }, function (error) {
                            vm.fnCancelIssueEditMode(issueObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get label color for the Issues.
                vm.fnGetIssuesLabelColor = function (labelObj) {
                    if (angular.isDefined(labelObj.color)) {
                        vm.labelTextColor = vm.fnInvertColor(labelObj.color);
                        return {
                            "background-color": labelObj.color,
                            "color": "" + vm.labelTextColor
                        }
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'archives', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false).then(function(response) {
                                return parsePostgresData(response);
                            });
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('tracker', 'archives', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>'project.id'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_archived_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_archived_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_archived_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_archived_issues';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    vm.selectedIssuesArr = [];
                    vm.selectedIssueObj = {};
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindIssue = _.find(vm.issuesArr, {id: tab.id});
                            if (isFindIssue) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedIssuesArr = [];
                                vm.selectedIssueObj = {};
                                vm.fnCheckUncheckHeader(isFindIssue);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Issue" && tab.id !== "issueStats" && tab.id !== "WidgetEditor" && tab.id !== "issueStateBoard" && tab.id !== "issuePriorityBoard" && tab.id !== "issueTypeBoard" && tab.id !== "boardSettings" && tab.id !== "priorityBoardSettings" && tab.id !== "typeBoardSettings") {
                                if (vm.isIssuesLoading || angular.isUndefined(isFindIssue)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedIssuesArr = [];
                                    vm.selectedIssueObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.archives', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowIssueStats = tab.id === "issueStats";
                        vm.isShowIssueStateBoard = tab.id === "issueStateBoard";
                        vm.isShowIssuePriorityBoard = tab.id === "issuePriorityBoard";
                        vm.isShowIssueTypeBoard = tab.id === "issueTypeBoard";
                        vm.isShowStateBoardSettings = tab.id === "boardSettings";
                        vm.isShowPriorityBoardSettings = tab.id === "priorityBoardSettings";
                        vm.isShowTypeBoardSettings = tab.id === "typeBoardSettings";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            vm.fnSetServiceDashboardHeight();
                            $timeout(function () {
                                vm.selectedIssuesArr = [];
                                vm.selectedIssueObj = {};
                                vm.dashboardWidgets = [];
                            });
                            $timeout.cancel(vm.issueTableAPITimeout);
                            vm.fnUpdateTableData();
                        } else {
                            $timeout.cancel(vm.issueTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowIssueStats = tab.id === "issueStats";
                    vm.isShowIssueStateBoard = tab.id === "issueStateBoard";
                    vm.isShowIssuePriorityBoard = tab.id === "issuePriorityBoard";
                    vm.isShowIssueTypeBoard = tab.id === "issueTypeBoard";
                    vm.isShowStateBoardSettings = tab.id === "boardSettings";
                    vm.isShowPriorityBoardSettings = tab.id === "priorityBoardSettings";
                    vm.isShowTypeBoardSettings = tab.id === "typeBoardSettings";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "issueStats" || tab.id === "WidgetEditor") {
                        $state.go('main.archives', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    },500)
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Issue") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.archives', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (issueObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(issueObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#issueTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (issueObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ARCHIVED_ISSUE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.issuesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === issueObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        vm.selectedIssuesArr = [];
                        /* Toggle push in selected issue array*/
                        var isValueFind = _.find(vm.selectedIssuesArr, {'id': issueObj.id});
                        if (!isValueFind) {
                            vm.selectedIssuesArr.push(issueObj);
                            var isTabExist = _.find(vm.tabs, {'id': issueObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: issueObj.id,
                                    title: issueObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedIssuesArr, function (obj) {
                                return issueObj.id === obj.id;
                            });
                        }
                        if (vm.selectedIssuesArr.length === 1) {
                            vm.fnGetIssueDetails(vm.selectedIssuesArr[0])
                        } else {
                            $state.go('main.archives', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.issuesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedIssuesArr = angular.copy(vm.issuesArr);
                    } else {
                        vm.selectedIssuesArr = [];
                    }
                    $state.go('main.archives', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        issueId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.archives', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isIssuesLoading = true;
                    vm.selectedIssuesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_archived_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_archived_issues';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_archived_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_archived_issues';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetIssues(perPageInput, true).then(function(response) {
                            return parsePostgresData(response);
                        });
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.issuesArr);
                        vm.previousPage = page;
                        vm.fnGetIssues(input, false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                };

                vm.fnOpenIssueInfoTab = function (issueObj, tabIndex) {
                    if (vm.permissionObj.DESCRIBE_ARCHIVED_ISSUE) {
                        vm.tabIndex = tabIndex;
                        vm.fnCheckUncheckHeader(issueObj);
                    }
                };

                vm.fnGetIssue = function (issueObj, issuesArr) {
                    angular.forEach(issuesArr, function (issue) {
                        issue.isCheck = false;
                    });
                    issueObj.isCheck = true;
                    vm.selectedIssuesArr = [issueObj]; // Assign array with single Issue object
                    vm.fnGetIssueDetails(issueObj);
                };

                vm.fnGetIssueDetails = function (issueObj) {
                    vm.isIssueDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when issue is selected
                        vm.selectedIssueObj = issueObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.archives', {
                                selectedId: vm.selectedIssueObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedIssueObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isIssueDetailsLoaded = true;
                        } else {
                            $state.go('main.archives', {selectedId: vm.selectedIssueObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedIssueObj.id;
                            vm.isIssueDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetIssues = function (inputObj, isFirst) {
                    vm.isIssuesLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var currentTime = moment().unix();
                            res.data.map(function (obj) {
                                obj.psuedoId = "#" + obj.id.substr(obj.id.length - 4);
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.resolutionDeadlineAt) {
                                    obj.isResolutionDeadlinePastDate = currentTime >= obj.resolutionDeadlineAt;
                                    obj.remainingTime = 100 * (1 - (currentTime - obj.createdAt) / (obj.resolutionDeadlineAt - obj.createdAt));
                                    var issueCreateDate = moment.unix(obj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    obj.issueCreateDate = issueCreateDate;
                                    obj.issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(obj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    obj.issueDeadline = issueDeadline;
                                    obj.issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (obj.responseDeadlineAt) {
                                    obj.isResponseDeadlinePastDate = currentTime >= obj.responseDeadlineAt;
                                    obj.responseTime = 100 * (1 - (currentTime - obj.updatedAt) / (obj.responseDeadlineAt - obj.updatedAt));
                                    var issueUpdatedDate = moment.unix(obj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    obj.issueUpdatedDate = issueUpdatedDate;
                                    obj.issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(obj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    obj.issueResponseDeadline = issueResponseDeadline;
                                    obj.issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (obj.resolved && obj.resolutionDeadlineAt) {
                                    if (obj.resolvedAt <= obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = true
                                    } else if (obj.resolvedAt > obj.resolutionDeadlineAt) {
                                        obj.isResolvedAtTime = false
                                    }
                                }
                                obj.tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + obj.issueDeadlineRelativeDateTime + '</b> </br>(At ' + obj.issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + obj.issueCreateRelativeDateTime + ' </b></br> (At ' + obj.issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(obj.lastPublicCommentReadBy) && obj.lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(obj.lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    obj.isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    obj.isRead = false;
                                }
                            });
                            vm.issueResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.issueResponse.data && vm.issueResponse.data.length) {
                                    vm.totalItems = vm.issueResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.issueResponse.data.reverse();
                            }
                            vm.issuesArr = vm.issueResponse.data;
                            if (!$stateParams.selectedId) {
                                vm.issueTableAPITimeout = $timeout(function () {
                                    vm.fnUpdateTableData();
                                }, 60000);
                            }
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetIssue(res[0], vm.issuesArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var issueData = _.find(vm.issuesArr, {"id": $stateParams.selectedId});
                                if (issueData) {
                                    vm.fnCheckUncheckHeader(issueData)
                                }
                            }
                            if (addedIssueId.length) {
                                vm.fnOpenPostCreateActionModal(addedIssueId);
                                addedIssueId = '';
                            }
                            if ($state.current.name === 'main.archives') {
                                if (Object.keys(vm.project).length && vm.project.id !== "All") {
                                    $state.go('main.archives', {
                                        openCreateView: '',
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        selectedProject: vm.project.id
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    $stateParams.selectedProject = vm.project.id;
                                    delete $stateParams.openCreateView;
                                } else {
                                    $state.go('main.archives', {
                                        openCreateView: '',
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        selectedProject: ""
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    delete $stateParams.selectedProject;
                                    delete $stateParams.openCreateView;
                                }
                            }
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isIssuesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var projects = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (projectObj) {
                                    projects.push(projectObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetProjects({sql: sqlString}, projects, true);
                                } else {
                                    vm.projectsArr = _.cloneDeepWith(projects);
                                    vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                    vm.projectsArr.unshift({name: "All", id: "All"});
                                    vm.fnSetSelectedProject();
                                }
                            });
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectIssue = function (projectObj) {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'project.id\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM tracker_archived_issues';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_archived_issues';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM tracker_archived_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM tracker_archived_issues';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'archives', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('tracker', 'archives', 'selectedProject', '');
                    }
                    vm.fnGetIssues({sql: sqlString}, true).then(function(response) {
                        return parsePostgresData(response);
                    });
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnCopyInfoToClipboard = function (data, type) {
                    copyService.fnCopyToClipboard(data);
                    amaran.success(type + " copied successfully");
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("issueAdded", function (evt, data) {
                    if (data.projectId && (vm.project.id === data.projectId || vm.project.id === "All")) {
                        data.psuedoId = "#" + data.id.substr(data.id.length - 4);
                        vm.issueResponse.data.unshift(data);
                        vm.issueResponse.metadata.totalRecordsMatched = vm.totalItems + 1;
                        vm.fnGetFilterData();
                    }
                    vm.fnRemoveTab('Create Issue');
                });

                $scope.$on("issueRestore", function (evt, data) {
                    vm.selectedIssueObj = null;
                    vm.selectedIssuesArr = [];
                    vm.issueResponse.data = vm.issueResponse.data.filter(function (issueObj) {
                        return (issueObj.id !== data);
                    });
                    vm.issuesArr = vm.issuesArr.filter(function (issueObj) {
                        return (issueObj.id !== data);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.archives', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnRemoveTab(data);
                });

                vm.fnDeleteMultipleIssues = function (selectedIssuesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedIssuesArr, function (selectedIssue, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + selectedIssue.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/tracker/issues/" + selectedIssue.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Issues?",
                            text: "You are about to permanently delete the selected issues.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'tracker'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedIssuesArr, function (selectedIssue) {
                                    angular.forEach(vm.issuesArr, function (issueObj, index) {
                                        if (selectedIssue.id === issueObj.id) {
                                            vm.issuesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedIssuesArr.length;
                                vm.selectedIssueObj = null;
                                vm.selectedIssuesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedIssuesArr, function (selectedIssue) {
                                    angular.forEach(vm.issuesArr, function (issueObj, index) {
                                        if (selectedIssue.id === issueObj.id) {
                                            vm.issuesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedIssuesArr.length;
                                vm.selectedIssueObj = null;
                                vm.selectedIssuesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('tracker', 'archives', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.archives", tempArr, {notify: false});
                    }
                };

                vm.fnInitIssues = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    var assigneeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAssignee({sql: assigneeSQL}, [], false);
                    if (AppInitService.getInitData('issueTypesArr').length !== 0) {
                        vm.issueTypesArr = _.cloneDeepWith(AppInitService.getInitData('issueTypesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Type",
                                    name: tableName + ".data->>\'issueType.id\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueType',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issueTypesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        });
                    } else {
                        var typeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_types ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetTypes({sql: typeSQL}, [], false);
                    }
                    if (AppInitService.getInitData('issuePrioritiesArr').length !== 0) {
                        vm.issuePrioritiesArr = _.cloneDeepWith(AppInitService.getInitData('issuePrioritiesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Priority",
                                    name: tableName + ".data->>\'issuePriority\'->>\'id\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issuePriority',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issuePrioritiesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        });
                    } else {
                        var prioritiesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_priorities ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetPriorities({sql: prioritiesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    if (AppInitService.getInitData('issueStatesArr').length !== 0) {
                        vm.issueStatesArr = _.cloneDeepWith(AppInitService.getInitData('issueStatesArr'));
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Status",
                                    name: tableName + ".data->>\'issueState.id\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'issueState',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.issueStatesArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        });
                    } else {
                        var statesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_states ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetStates({sql: statesSQL}, [], false).then(function(response) {
                            return parsePostgresData(response);
                        });
                    }
                    var labelsSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_labels ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetIssueLabels({sql: labelsSQL}, [], false).then(function(response) {
                        return parsePostgresData(response);
                    });
                    //var participantsSQL = 'SELECT *, COUNT(*) OVER() as totalItems , _id AS rt FROM access_whitelist_emails ORDER BY rt asc LIMIT ' + 100 + ';';
                    //vm.fnGetParticipants({sql: participantsSQL}, [], false);
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('tracker', 'archives', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetIssueDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssueStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetBoardSettings = function (isCalledForState, isCalledForPriority) {
                    var isTabExist = isCalledForState ? _.find(vm.tabs, {id: 'boardSettings'}) :
                        isCalledForPriority ? _.find(vm.tabs, {id: 'priorityBoardSettings'}) : _.find(vm.tabs, {id: 'typeBoardSettings'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            if (isCalledForState) {
                                vm.isShowStateBoardSettings = true;
                            } else if (isCalledForPriority) {
                                vm.isShowPriorityBoardSettings = true;
                            } else {
                                vm.isShowTypeBoardSettings = true;
                            }
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: isCalledForState ? 'boardSettings' : isCalledForPriority ? 'priorityBoardSettings' : 'typeBoardSettings',
                            title: isCalledForState ? 'State Board Settings' : isCalledForPriority ? 'Priority Board Settings' : 'Type Board Settings',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            if (isCalledForState) {
                                vm.isShowStateBoardSettings = true;
                            } else if (isCalledForPriority) {
                                vm.isShowPriorityBoardSettings = true;
                            } else {
                                vm.isShowTypeBoardSettings = true;
                            }
                        });
                    }
                };

                vm.fnGetIssueStateBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueStateBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueStateBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueStateBoard',
                            title: 'State Board',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueStateBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssuePriorityBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issuePriorityBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssuePriorityBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issuePriorityBoard',
                            title: 'Priority Board',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssuePriorityBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetIssueTypeBoard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'issueTypeBoard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowIssueTypeBoard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'issueTypeBoard',
                            title: 'Type Board',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowIssueTypeBoard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var optionsArr = [
                        {
                            faIcon: "fa-issue",
                            subOptions: [
                                {
                                    displayText: "Add Users",
                                    isRedirect: false,
                                    selectedTab: 2,
                                    isVisible: true
                                }
                            ]
                        }
                    ];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj)
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else {
                                var issueData = _.find(vm.issuesArr, {"id": selectedId});
                                if (issueData) {
                                    $state.go('main.archives', {selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnGetIssue(issueData, vm.issuesArr);
                                } else {
                                    var tempArr = [
                                        {
                                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                            name: "Keyword: " + selectedId,
                                            searchText: selectedId
                                        }
                                    ];
                                    $state.go('main.archives', {
                                        filter: angular.toJson(tempArr),
                                        selectedId: selectedId,
                                        selectedDetailsTab: selectedOption.selectedTab
                                    }, {notify: false});
                                    $stateParams.filter = angular.toJson(tempArr);
                                    $stateParams.selectedId = selectedId;
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnReload();
                                }
                            }
                        }, function () {
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getIssueCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.issuesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (issueObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = issueObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var issuesArrCp = _.cloneDeepWith(vm.issuesArr);
                    var data = [];
                    _.forEach(issuesArrCp, function (tempObj) {
                        var obj = {
                            id: tempObj.id,
                            name: tempObj.name,
                            summary: tempObj.summary
                        };
                        if (tempObj.issueType && Object.keys(tempObj.issueType).length) {
                            obj.issueType = tempObj.issueType.name + " (" + tempObj.issueType.id + ")";
                        } else {
                            obj.issueType = '';
                        }
                        if (tempObj.issuePriority && Object.keys(tempObj.issuePriority).length) {
                            obj.issuePriority = tempObj.issuePriority.name + " (" + tempObj.issuePriority.id + ")";
                        } else {
                            obj.issuePriority = '';
                        }
                        if (tempObj.issueState && Object.keys(tempObj.issueState).length) {
                            obj.issueState = tempObj.issueState.name + " (" + tempObj.issueState.id + ")";
                        } else {
                            obj.issueState = '';
                        }
                        if (tempObj.project) {
                            obj.project = tempObj.project.name + " (" + tempObj.project.id + ")";
                        } else {
                            obj.project = tempObj.projectId;
                        }
                        if (tempObj.issueLabels) {
                            var tempLabelsStr = "";
                            _.forEach(tempObj.issueLabels, function (labObj, index) {
                                if (index !== (tempObj.issueLabels.length - 1)) {
                                    tempLabelsStr += labObj.name + " (" + labObj.id + "), \n";
                                } else {
                                    tempLabelsStr += labObj.name + " (" + labObj.id + ")";
                                }
                            })
                            obj.issueLabels = tempLabelsStr;
                        } else {
                            obj.issueLabels = "";
                        }
                        if (tempObj.assignees) {
                            var tempAssigneesStr = "";
                            _.forEach(tempObj.assignees, function (assigneesObj, index) {
                                if (index !== (tempObj.assignees.length - 1)) {
                                    tempAssigneesStr += assigneesObj.firstName + " " + assigneesObj.lastName + " (" + assigneesObj.email + "), \n";
                                } else {
                                    tempAssigneesStr += assigneesObj.firstName + " " + assigneesObj.lastName + " (" + assigneesObj.email + ")";
                                }
                            })
                            obj.assignees = tempAssigneesStr;
                        } else {
                            obj.assignees = "";
                        }
                        if (tempObj.confidential) {
                            obj.confidential = 'Confidential';
                        } else {
                            obj.confidential = 'Not Confidential';
                        }
                        if (tempObj.createdAt !== 0) {
                            obj.createdAt = moment.unix(tempObj.createdAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.createdAt = "";
                        }
                        if (tempObj.createdBy) {
                            obj.createdBy = tempObj.createdBy;
                        } else {
                            obj.createdBy = "";
                        }
                        if (tempObj.updatedAt) {
                            obj.updatedAt = moment.unix(tempObj.updatedAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.updatedAt = "";
                        }
                        if (tempObj.updatedBy) {
                            obj.updatedBy = tempObj.updatedBy;
                        } else {
                            obj.updatedBy = "";
                        }
                        if (tempObj.resolved) {
                            obj.resolved = 'Resolved';
                        } else {
                            obj.resolved = 'Not Resolved';
                        }
                        if (tempObj.resolvedAt) {
                            obj.resolvedAt = moment.unix(tempObj.resolvedAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.resolvedAt = "";
                        }
                        if (tempObj.resolvedBy) {
                            obj.resolvedBy = tempObj.resolvedBy;
                        } else {
                            obj.resolvedBy = "";
                        }
                        if (angular.isDefined(tempObj.voteCount)) {
                            obj.voteCount = tempObj.voteCount;
                        } else {
                            obj.voteCount = "";
                        }
                        if (angular.isDefined(tempObj.voters)) {
                            obj.voters = tempObj.voters.join(', \n');
                        } else {
                            obj.voters = "";
                        }
                        if (angular.isDefined(tempObj.participants)) {
                            obj.participants = tempObj.participants.join(', \n');
                        } else {
                            obj.participants = "";
                        }
                        if (angular.isDefined(tempObj.lastPublicCommentReadBy)) {
                            obj.lastPublicCommentReadBy = tempObj.lastPublicCommentReadBy.join(', \n');
                        } else {
                            obj.lastPublicCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.lastPrivateCommentReadBy)) {
                            obj.lastPrivateCommentReadBy = tempObj.lastPrivateCommentReadBy.join(', \n');
                        } else {
                            obj.lastPrivateCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.lastPrivateCommentReadBy)) {
                            obj.lastPrivateCommentReadBy = tempObj.lastPrivateCommentReadBy.join(', \n');
                        } else {
                            obj.lastPrivateCommentReadBy = "";
                        }
                        if (angular.isDefined(tempObj.publicCommentIds)) {
                            obj.publicCommentIds = tempObj.publicCommentIds.join(', \n');
                        } else {
                            obj.publicCommentIds = "";
                        }
                        if (angular.isDefined(tempObj.privateCommentIds)) {
                            obj.privateCommentIds = tempObj.privateCommentIds.join(', \n');
                        } else {
                            obj.privateCommentIds = "";
                        }
                        if (angular.isDefined(tempObj.attributeIds)) {
                            obj.attributeIds = tempObj.attributeIds.join(', \n');
                        } else {
                            obj.attributeIds = "";
                        }
                        if (tempObj.resolutionDeadlineAt) {
                            obj.resolutionDeadlineAt = moment.unix(tempObj.resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.resolutionDeadlineAt = "";
                        }
                        if (tempObj.responseDeadlineAt) {
                            obj.responseDeadlineAt = moment.unix(tempObj.responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                        } else {
                            obj.responseDeadlineAt = "";
                        }
                        if (tempObj.index) {
                            obj.index = tempObj.index;
                        } else {
                            obj.index = "";
                        }
                        if (tempObj.keywords) {
                            obj.keywords = tempObj.keywords;
                        } else {
                            obj.keywords = "";
                        }
                        if (angular.isDefined(tempObj.customForm) && Object.keys(tempObj.customForm).length) {
                            obj.customForm = angular.toJson(tempObj.customForm);
                        } else {
                            obj.customForm = "";
                        }
                        if (angular.isDefined(tempObj.tags) && Object.keys(tempObj.tags).length) {
                            obj.tags = angular.toJson(tempObj.tags);
                        } else {
                            obj.tags = "";
                        }
                        data.push(obj);
                    });
                    var heading = [
                        ["ID", "Name", "Summary", "Issue Type", "Issue Priority", "Issue State", "Project", "Issue Labels",
                            "Assignees", "Confidential", "Created At", "Created By", "Updated At", "Updated By", "Resolved",
                            "Resolved At", "Resolved By", "Vote Count", "Voters", "Participants", "Last Public Comment Read By",
                            "Last Private Comment Read By", "PublicComment Ids", "PrivateComment Ids", "Attribute Ids", "Resolution Deadline At",
                            "Response Deadline At", "Index", "Keywords", "Custom Form", "Tags"]
                    ];
                    var workbook = XLSX.utils.book_new();
                    var ws = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.sheet_add_aoa(ws, heading);
                    XLSX.utils.book_append_sheet(workbook, ws);
                    XLSX.writeFile(workbook, 'archivedIssues.xlsx', {type: 'file'});
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('tracker', 'archives', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightTrackerArchivesChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetAssignee = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var users = isCalledForViz ? preDefinedProjects : [];
                                _.forEach(parsedData, function (userObj) {
                                    users.push({
                                        id: userObj.id,
                                        firstName: userObj.firstName,
                                        lastName: userObj.lastName,
                                        fullName: userObj.firstName + ' ' + userObj.lastName,
                                        email: userObj.email,
                                        userAvatar: angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                    });
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (users[0] && users[0].totalItems > users.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetAssignee({sql: sqlString}, users, true);
                                } else {
                                    vm.assigneeArr = _.cloneDeepWith(users);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Assignee",
                                                name: tableName + ".data->>\'assignees\'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'assignees',
                                                    key: 'email'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.assigneeArr,
                                                displayKeyName: 'fullName',
                                                isShowId: true,
                                                isShowUserAvatar: true,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'email'
                                            }
                                        );
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetTypes = function (inputObj, preDefinedIssueTypes, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var types = isCalledForViz ? preDefinedIssueTypes : [];
                                _.forEach(parsedData, function (typeObj) {
                                    types.push(typeObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (types[0] && types[0].totalItems > types.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + types[types.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetTypes({sql: sqlString}, types, true);
                                } else {
                                    vm.issueTypesArr = _.cloneDeepWith(types);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Type",
                                                name: tableName + ".data->>'issueType.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueType',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueTypesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetPriorities = function (inputObj, preDefinedIssuePriorities, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var priorities = isCalledForViz ? preDefinedIssuePriorities : [];
                                _.forEach(parsedData, function (priorityObj) {
                                    priorities.push(priorityObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (priorities[0] && priorities[0].totalItems > priorities.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + priorities[priorities.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetPriorities({sql: sqlString}, priorities, true);
                                } else {
                                    vm.issuePrioritiesArr = _.cloneDeepWith(priorities);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Priority",
                                                name: tableName + ".data->>'issuePriority.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issuePriority',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issuePrioritiesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetStates = function (inputObj, preDefinedIssueStates, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var states = isCalledForViz ? preDefinedIssueStates : [];
                                _.forEach(parsedData, function (stateObj) {
                                    states.push(stateObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (states[0] && states[0].totalItems > states.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + states[states.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetStates({sql: sqlString}, states, true);
                                } else {
                                    vm.issueStatesArr = _.cloneDeepWith(states);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Status",
                                                name: tableName + ".data->>'issueState.id'",
                                                localSearch: {
                                                    type: 'objects',
                                                    name: 'issueState',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueStatesArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                vm.fnGetIssueLabels = function (inputObj, preDefinedIssueLabels, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            return parsePostgresData(res.data).then(function(parsedData) {
                                var labels = isCalledForViz ? preDefinedIssueLabels : [];
                                _.forEach(parsedData, function (labelObj) {
                                    labels.push(labelObj);
                                });
                                if ((parsedData && parsedData.length && parsedData.length > 0) && (labels[0] && labels[0].totalItems > labels.length)) {
                                    var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_labels';
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + labels[labels.length - 1].rt + "'";
                                    sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                    vm.fnGetIssueLabels({sql: sqlString}, labels, true);
                                } else {
                                    vm.issueLabelsArr = _.cloneDeepWith(labels);
                                    $timeout(function () {
                                        vm.searchFiltersArr.push(
                                            {
                                                displayName: "Label",
                                                name: tableName + ".data->>'issueLabels'",
                                                localSearch: {
                                                    type: 'arrayOfObjects',
                                                    name: 'issueLabels',
                                                    key: 'id'
                                                },
                                                regexp: "",
                                                errorMessage: "",
                                                isPredefinedValue: true,
                                                predefinedValues: vm.issueLabelsArr,
                                                displayKeyName: 'name',
                                                isShowId: true,
                                                isShowUserAvatar: false,
                                                isShowSearchBar: true,
                                                filterApplyKeyName: 'id'
                                            }
                                        );
                                    });
                                }
                            });
                        }, function () { // Error block
                        })
                };

                /*vm.fnGetParticipants = function (inputObj, preDefinedIssueParticipants, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var participants = isCalledForViz ? preDefinedIssueParticipants : [];
                            _.forEach(res.data, function (participantObj) {
                                participants.push({
                                    name: participantObj.email,
                                    id: participantObj.email
                                });
                            });
                            if (participants[0] && participants[0].totalItems > participants.length) {
                                var sqlString = 'SELECT *, _id AS rt FROM access_whitelist_emails';
                                sqlString += ' WHERE _id > ' + "'" + participants[participants.length - 1].rt + "'";
                                sqlString += ' ORDER BY _id asc LIMIT ' + 100 + ';';
                                vm.fnGetParticipants({sql: sqlString}, participants, true);
                            } else {
                                vm.issueParticipantsArr = _.cloneDeepWith(participants);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Participant",
                                            name: tableName + ".participants",
                                            localSearch: {
                                                type: 'array',
                                                name: 'participants',
                                                key: 'id'
                                            },
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.issueParticipantsArr,
                                            displayKeyName: 'name',
                                            isShowId: false,
                                            isShowUserAvatar: false,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                });
                            }
                        }, function () { // Error block
                        })
                };*/

                vm.isShowFormOption = function (issueObj) {
                    return !!(angular.isDefined(issueObj.customForm) && issueObj.customForm.schema && issueObj.customForm.schema.properties && Object.keys(issueObj.customForm.schema.properties).length)
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnUpdateTableData = function () {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            var currentTime = moment().unix();
                            vm.issuesArr = [];
                            var tempSelectedIssuesObj = {};
                            vm.selectedIssuesArr = _.filter(vm.selectedIssuesArr, function (selectIssueObj) {
                                var isFind = _.find(res.data, {id: selectIssueObj.id});
                                if (isFind) {
                                    tempSelectedIssuesObj[selectIssueObj.id] = _.cloneDeepWith(isFind);
                                    return true;
                                } else {
                                    return false;
                                }
                            });
                            _.forEach(res.data, function (resObj, index) {
                                delete vm.issuesArr[index];
                                vm.issuesArr[index] = resObj;
                                vm.issuesArr[index].psuedoId = "#" + vm.issuesArr[index].id.substr(vm.issuesArr[index].id.length - 4);
                                if (vm.issuesArr[index].createdAt) {
                                    vm.issuesArr[index].createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].createdAt);
                                }
                                if (vm.issuesArr[index].updatedAt) {
                                    vm.issuesArr[index].updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].updatedAt);
                                }
                                if (vm.issuesArr[index].resolvedAt) {
                                    vm.issuesArr[index].resolvedDate = vm.fnGetAbsoluteOrRelativeTime(vm.issuesArr[index].resolvedAt);
                                }
                                if (vm.issuesArr[index].projectId) {
                                    vm.issuesArr[index].project = _.find(vm.projectsArr, {id: vm.issuesArr[index].projectId});
                                }
                                if (angular.isDefined(tempSelectedIssuesObj[resObj.id])) {
                                    vm.issuesArr[index].isCheck = true;
                                }
                                if (vm.issuesArr[index].resolutionDeadlineAt) {
                                    vm.issuesArr[index].isResolutionDeadlinePastDate = currentTime >= vm.issuesArr[index].resolutionDeadlineAt;
                                    vm.issuesArr[index].remainingTime = 100 * (1 - (currentTime - vm.issuesArr[index].createdAt) / (vm.issuesArr[index].resolutionDeadlineAt - vm.issuesArr[index].createdAt));
                                    var issueCreateDate = moment.unix(vm.issuesArr[index].createdAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueCreateRelativeDateTime = moment(issueCreateDate).fromNow();
                                    vm.issuesArr[index].issueCreateDate = issueCreateDate;
                                    vm.issuesArr[index].issueCreateRelativeDateTime = issueCreateRelativeDateTime;
                                    var issueDeadline = moment.unix(vm.issuesArr[index].resolutionDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueDeadlineRelativeDateTime = moment(issueDeadline).fromNow();
                                    vm.issuesArr[index].issueDeadline = issueDeadline;
                                    vm.issuesArr[index].issueDeadlineRelativeDateTime = issueDeadlineRelativeDateTime;
                                }
                                if (vm.issuesArr[index].responseDeadlineAt) {
                                    vm.issuesArr[index].isResponseDeadlinePastDate = currentTime >= vm.issuesArr[index].responseDeadlineAt;
                                    vm.issuesArr[index].responseTime = 100 * (1 - (currentTime - vm.issuesArr[index].updatedAt) / (vm.issuesArr[index].responseDeadlineAt - vm.issuesArr[index].updatedAt));
                                    var issueUpdatedDate = moment.unix(vm.issuesArr[index].updatedAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueUpdatedRelativeDateTime = moment(issueUpdatedDate).fromNow();
                                    vm.issuesArr[index].issueUpdatedDate = issueUpdatedDate;
                                    vm.issuesArr[index].issueUpdatedRelativeDateTime = issueUpdatedRelativeDateTime;
                                    var issueResponseDeadline = moment.unix(vm.issuesArr[index].responseDeadlineAt).format("MM/DD/YYYY HH:mm:ss");
                                    var issueResponseDeadlineRelativeDateTime = moment(issueResponseDeadline).fromNow();
                                    vm.issuesArr[index].issueResponseDeadline = issueResponseDeadline;
                                    vm.issuesArr[index].issueResponseDeadlineRelativeDateTime = issueResponseDeadlineRelativeDateTime;
                                }
                                if (vm.issuesArr[index].resolved && vm.issuesArr[index].resolutionDeadlineAt) {
                                    if (vm.issuesArr[index].resolvedAt <= vm.issuesArr[index].resolutionDeadlineAt) {
                                        vm.issuesArr[index].isResolvedAtTime = true
                                    } else if (vm.issuesArr[index].resolvedAt > vm.issuesArr[index].resolutionDeadlineAt) {
                                        vm.issuesArr[index].isResolvedAtTime = false
                                    }
                                }
                                vm.issuesArr[index].tooltipContent = $sce.trustAsHtml('<div class="p-3"><b>Deadline ' + vm.issuesArr[index].issueDeadlineRelativeDateTime + '</b> </br>(At ' + vm.issuesArr[index].issueDeadline + ')<hr class="m-0 m-t-5 m-b-5"><b>Created ' + vm.issuesArr[index].issueCreateRelativeDateTime + ' </b></br> (At ' + vm.issuesArr[index].issueCreateDate + ')</div>'); //eslint-disable-line*/
                                if (angular.isDefined(vm.issuesArr[index].lastPublicCommentReadBy) && vm.issuesArr[index].lastPublicCommentReadBy.length) {
                                    var issueRead = _.find(vm.issuesArr[index].lastPublicCommentReadBy, function (id) {
                                        return id === loginUser.email
                                    });
                                    vm.issuesArr[index].isRead = !!(angular.isDefined(issueRead) && issueRead.length);
                                } else {
                                    vm.issuesArr[index].isRead = false;
                                }
                            })
                            vm.issueTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.issueTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        })
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var issueKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.archives') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedIssuesArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleIssues(vm.selectedIssuesArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var issueKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.archives') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', issueKeyDownEventHandler);
                document.addEventListener('keyup', issueKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.issueTableAPITimeout);
                    document.removeEventListener('keydown', issueKeyDownEventHandler);
                    document.removeEventListener('keyup', issueKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ProductCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, copyService, UserProfileService,
                      PaginationQueryService, PermissionsService, DiscountFactory, CartFactory, QueryFactory,
                      amaran, ColorService, swal, microSpinner, DB, $log) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                vm.accountId = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.accountId : vm.authUserObj.id.split("-")[0];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                    }
                };
                vm.activeTabIndex = 1;
                //Search Variables
                vm.isRefreshData = true;

                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'UNCONFIRMED', displayName: 'UNCONFIRMED'},
                    {name: 'SUSPENDED', displayName: 'SUSPENDED'},
                    {name: 'UNPAID', displayName: 'UNPAID'},
                    {name: 'CLOSED', displayName: 'CLOSED'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Category",
                        name: "category",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'id', displayName: 'Id'},
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'category', displayName: 'Category'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Products Variables
                vm.isProductsloading = true;
                vm.productArr = [];
                vm.selectedProductObj = {};
                vm.showEolProducts = UserProfileService.fnGetUserProfileObj('billing', 'products', 'showEolProducts') ===
                '' ? false : UserProfileService.fnGetUserProfileObj('billing', 'products', 'showEolProducts');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.productResponse = [];
                vm.isSinglePage = false;

                //sort variables
                vm.filteredData = [];
                vm.cartQuantity = 1;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    vm.fnSetTableHeight();
                });

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        // Create shallow copy of item
                        var parsedItem = angular.copy(item);

                        // Handle timestamps
                        if (item.updated_at) {
                            parsedItem.updatedAt = item.updated_at;
                        }
                        if (item.created_at) {
                            parsedItem.createdAt = item.created_at;
                        }

                        // Parse the data field if it exists and is a string
                        if (angular.isString(item.data)) {
                            try {
                                var parsedData = angular.fromJson(item.data);

                                // Set basic product fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name || '';
                                parsedItem.description = parsedData.description || '';
                                parsedItem.category = parsedData.category || '';

                                // Handle product-specific fields
                                parsedItem.mrr = parsedData.mrr || 0;
                                parsedItem.otc = parsedData.otc || 0;
                                parsedItem.orderable = !!parsedData.orderable;
                                parsedItem.shippable = !!parsedData.shippable;
                                parsedItem.maxPerCart = parsedData.maxPerCart || 0;
                                parsedItem.maxPerAccount = parsedData.maxPerAccount || 0;

                                // Handle metadata
                                if (parsedData.metadata) {
                                    parsedItem.metadata = parsedData.metadata;
                                }

                            } catch (e) {
                                $log.error('Error parsing product data:', e);
                                // Set default values on parse error
                                parsedItem.mrr = 0;
                                parsedItem.orderable = false;
                                parsedItem.maxPerCart = 0;
                                parsedItem.maxPerAccount = 0;
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnRange = function (start, end) {
                    var result = [];
                    for (var i = start; i <= end; i++) {
                        result.push(i);
                    }
                    return result;
                };

                vm.fnUpdateUserSettingsForEOLProducts = function () {
                    vm.showEolProducts = !vm.showEolProducts;
                    UserProfileService.fnUpdateUserProfileObj('billing', 'products', 'showEolProducts', vm.showEolProducts);
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('billing', 'products', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isProductsloading = true;
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortType === 'asc' ? '+' + sortValue : '-' + sortValue
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM billing_products';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_products';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetProducts(input, true);
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (vm.activeTabIndex === 1) {
                        if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                            angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                            angular.isDefined(angular.element(".pagination-container")[0])) {
                            var total = angular.element(".table-content-box")[0].offsetHeight;
                            var search = angular.element(".search-panel-v4")[0].offsetHeight;
                            var searchTag = 0;
                            // var pagination = angular.element(".pagination-container")[0].offsetHeight;
                            var pagination = 30;
                            var dashboardHeader1 = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                            var finalHeight = total - (search + pagination + searchTag + dashboardHeader1 + 64 + mainFooter);
                            angular.element("#productTable").css('height', finalHeight + 'px');
                        }
                    } else {
                        if (angular.element(".content-container")[0]) {
                            var totalInfoH = angular.element(".content-container")[0].offsetHeight;
                            var footer = vm.isFullWidthDevice && angular.isDefined(angular.element(".content-footer")[0]) ?
                                angular.element(".content-footer")[0].offsetHeight : 0;
                            var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ?
                                angular.element(".dashboard-header")[0].offsetHeight : 0;
                            var finalHeightInfo = totalInfoH - (footer + dashboardHeader);

                            var productBoxHeight = finalHeightInfo - 40;

                            angular.element(".infoDiv").css('height', finalHeightInfo + 'px');
                            angular.element(".alien").css('height', productBoxHeight + 'px');
                            angular.element(".imageGalleryDiv").css('height', productBoxHeight + 'px');
                        }
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.isDefined(angular.element(".search-panel-v4")[0]) ? angular.element(".search-panel-v4")[0].offsetHeight : 45;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 65 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetProducts = function (input, isFirst) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            try {
                                // Demo images for specific products
                                var demoImages = [
                                    {id: 2, image: "../../../assets/images/product/2.png"},
                                    {id: 1, image: "../../../assets/images/product/1.png"},
                                    {id: 3, image: "../../../assets/images/product/3.png"},
                                    {id: 4, image: "../../../assets/images/product/4.png"},
                                    {id: 5, image: "../../../assets/images/product/5.png"}
                                ];

                                // Parse the PostgreSQL data
                                if (res && res.data && res.data.length) {
                                    // First parse the data
                                    var parsedData = parsePostgresData(res.data);

                                    // Then handle images
                                    parsedData = parsedData.map(function(obj) {
                                        if (obj.id === 'bpfa4180') {
                                            obj.images = demoImages;
                                        } else if (!obj.orderable) {
                                            obj.images = [{id: 1, image: "../../../assets/images/product/gatewayBox.png"}];
                                        } else {
                                            obj.images = [{id: 1, image: "../../../assets/images/product/database.png"}];
                                        }
                                        return obj;
                                    });

                                    res.data = parsedData;
                                }

                                vm.productResponse = _.cloneDeepWith(res);

                                // Handle first page totals
                                if (isFirst && vm.productResponse.data && vm.productResponse.data.length) {
                                    vm.totalItems = vm.productResponse.data[0].totalItems;
                                    vm.currentPage = 1;
                                }

                                // Handle data reversal if needed
                                if (input.isNeedDataReverse) {
                                    vm.productResponse.data.reverse();
                                }

                                vm.productArr = vm.productResponse.data;

                                // Update state if needed
                                if ($state.current.name === 'main.products') {
                                    $timeout(function () {
                                        $state.go('main.products', {
                                            page: vm.currentPage,
                                            perPage: vm.perPage
                                        }, {notify: false});
                                        $stateParams.page = vm.currentPage;
                                        $stateParams.perPage = vm.perPage;
                                    }, 10)
                                }

                                // Handle selected product if any
                                if ($stateParams.selectedId) {
                                    var productData = _.find(vm.productArr, {"id": $stateParams.selectedId});
                                    if (productData) {
                                        vm.fnGetProductInfo(productData);
                                    }
                                }

                                // Clean up state
                                vm.isRefresh = false;
                                vm.isProductsloading = false;

                                // Update UI
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });

                            } catch (err) {
                                $log.error('Error processing product data:', err);
                                vm.isProductsloading = false;
                                vm.isRefresh = false;
                                amaran.error('Error processing product data');
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProductsloading = false;
                            vm.isRefresh = false;
                        });
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindProduct = _.find(vm.productArr, {id: tab.id});
                            if (isFindProduct) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedProductObj = {};
                                vm.fnGetProductDetails(isFindProduct);
                            }
                        } else {
                            $state.go('main.products', {selectedId: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function () {
                    vm.cartQuantity = 1;
                    vm.maxQuantity = 0;
                    vm.minQuantity = 0;
                    $timeout(function () {
                        if (vm.activeTabIndex === 1) {
                            vm.fnGetCartInfo();
                        }
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        vm.fnChangeTab(lastLast, true);
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.products', {
                        selectedId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    //vm.activeTabIndex = 1;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnGetProductDetails = function (productObj) {
                    vm.isProductDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when product is selected
                        vm.fnSetCartQuantity(productObj);
                        vm.selectedProductObj = productObj;
                        vm.imgSrc = vm.selectedProductObj.images[0].image;
                        $state.go('main.products', {
                            selectedId: vm.selectedProductObj.id
                        }, {notify: false});
                        $stateParams.selectedId = vm.selectedProductObj.id;
                        vm.isProductDetailsLoaded = true;
                        vm.isDiscountDetailsLoaded = false;
                        vm.fnGetDiscountInfo();
                    });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.products', {selectedId: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            //vm.fnUpdateUserData(perPage);
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isProductsloading = true;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM billing_products';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM billing_products';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM billing_products';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_products';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetProducts(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.productArr);
                        vm.previousPage = page;
                        vm.fnGetProducts(input, false);
                    }
                };

                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.fnGetCartInfo();
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnSetCartQuantity = function (productObj) {
                    if (productObj.orderable) {
                        productObj.cartQuantity = 1;
                        productObj.maxQuantity = productObj.maxPerCart;
                        productObj.minQuantity = 1;
                    } else {
                        productObj.cartQuantity = 0;
                        productObj.maxQuantity = 0;
                        productObj.minQuantity = 0;
                    }
                };

                vm.fnAddToCart = function (productObj) {
                    productObj.isCartUpdating = true;
                    CartFactory.addProductToCart({productId: productObj.id, quantity: productObj.cartQuantity})
                        .then(function () { // Success block
                            vm.isCartUpdating = false;
                            vm.fnGetCartInfo();
                            delete productObj.isCartUpdating;
                            vm.fnSetCartQuantity(productObj);
                            amaran.success("Cart Updated Successfully");
                        }, function () { // Error block
                            delete productObj.isCartUpdating;
                        })
                };

                vm.fnGetProductInfo = function (productInfo) {
                    var isTabExist = _.find(vm.tabs, {'id': productInfo.id});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: productInfo.id,
                            title: productInfo.name,
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            //vm.fnUpdateUserProfileData();
                        });
                    }
                    vm.fnGetProductDetails(productInfo);
                };

                vm.fnRemoveQuantity = function (productObj) {
                    productObj.cartQuantity = productObj.minQuantity === productObj.cartQuantity ? productObj.minQuantity : productObj.cartQuantity - 1;
                };

                vm.fnAddQuantity = function (productObj) {
                    productObj.cartQuantity = productObj.cartQuantity + 1;
                };

                vm.fnCopyToClipboard = function (value, duration) {
                    vm.isCopyClicked = true;
                    copyService.fnCopyToClipboard(value);
                    $timeout(function () {
                        vm.isCopyClicked = false;
                    }, duration)
                };

                vm.fnGetCartInfo = function () {
                    vm.isCartInfoLoading = true;
                    CartFactory.describeCart()
                        .then(function (res) { // Success block
                            vm.cartInfo = _.cloneDeepWith(res);
                            vm.isCartInfoLoading = false;
                        }, function () { // Error block
                            vm.isCartInfoLoading = false;
                        })
                };

                vm.fnGetDiscountInfo = function () {
                    vm.discountData = [];
                    var discountsSQL = "SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM billing_discounts WHERE data->>\'accountId\' = '" + vm.accountId + "' and data->>\'productId\' = '" + vm.selectedProductObj.id + "'";
                    QueryFactory.executeQuery({sql: discountsSQL}).then(function (res) { // Success block
                        vm.isDiscountDetailsLoaded = true;
                        vm.discountData = res.data;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }, function () { // Error block
                        vm.isDiscountDetailsLoaded = true;
                    });
                };

                vm.fnProceedToCheckout = function () {
                    var flag = false;
                    _.forEach(vm.cartInfo.cartItems, function (cartObj) {
                        if (cartObj.product && cartObj.product.shippable) {
                            flag = true;
                        }
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/store/cart/modal/shippingDetailsModal.html',
                        size: 'lg',
                        controller: 'shippingDetailsCtrl as shippingDetails',
                        resolve: {
                            selectedPaymentMethod: function () {
                                return {
                                    defaultPaymentMethod: true
                                };
                            },
                            isShippable: function () {
                                return flag;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        vm.fnGetCartInfo();
                        amaran.success("Checkout Successfully");
                    }, function () {
                        vm.isCartUpdating = false;
                    });
                };

                vm.fnOpenSupportModal = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/supportModal/supportModal.html',
                        size: 'md',
                        controller: 'SupportCtrl as support',
                        resolve: {
                            userObj: function () {
                                return '';
                            },
                            isCalledForSupport: function () {
                                return true;
                            },
                            recoveryType: function () {
                                return '';
                            }
                        }
                    })
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('billing', 'products', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.products", tempArr, {notify: false});
                    }
                };

                vm.fnInitProducts = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.nodePermissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1600) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                };
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('CartCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, CartFactory,
                      PermissionsService, PaymentMethodsFactory) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;

                //Products Variables
                vm.isCartsloading = true;
                vm.cartArr = [];
                vm.selectedPaymentMethod = {};
                vm.paymentMethodArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.fnSetTableHeight();
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var navTabs = angular.isDefined(angular.element(".nav-tabs")[0]) ? angular.element(".nav-tabs")[0].offsetHeight : 0;
                        var finalHeight = total - (dashboardHeader + mainFooter + navTabs);
                        angular.element("#cartTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetCarts = function () {
                    vm.isCartsloading = true;
                    CartFactory.describeCart()
                        .then(function (res) { // Success block
                            if (res && res.cartItems && res.cartItems.length) {
                                res.cartItems.map(function (obj) {
                                    if (obj.product.id === 'bpfa4180') {
                                        obj.product.image = "../../../assets/images/product/2.png";
                                    } else {
                                        obj.product.image = "../../../assets/images/product/database.png";
                                    }
                                });
                            }
                            vm.cartArr = _.cloneDeepWith(res);
                            vm.isRefresh = false;
                            vm.isCartsloading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isCartsloading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnRemoveItem = function (cartObj) {
                    cartObj.isCartUpdating = true;
                    CartFactory.removeItemFromCart({itemId: cartObj.id})
                        .then(function () { // Success block
                            vm.fnGetCarts();
                            delete cartObj.isCartUpdating;
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            delete cartObj.isCartUpdating;
                        })
                };

                vm.fnGetPaymentMethod = function () {
                    vm.isPaymentMethodLoading = true;
                    vm.selectedPaymentMethod = {};
                    PaymentMethodsFactory.listPaymentMethods()
                        .then(function (res) {
                            vm.paymentMethodArr = _.filter(res, function (paymentMethodObj) {
                                if (paymentMethodObj.defaultPaymentMethod === true) {
                                    vm.selectedPaymentMethod = _.cloneDeepWith(paymentMethodObj);
                                }
                                return paymentMethodObj.active === true;
                            });
                            if (!Object.keys(vm.selectedPaymentMethod).length) {
                                vm.selectedPaymentMethod = vm.paymentMethodArr.length ? vm.paymentMethodArr[0] : {};
                            }
                            vm.isPaymentMethodLoading = false;
                        }, function () {
                            vm.isPaymentMethodLoading = false;
                        })
                };

                vm.fnGetCreditCardClass = function (cardType) {
                    if (cardType === 'discover') {
                        return 'fa-cc-discover';
                    } else if (cardType === 'jcb') {
                        return 'fa-cc-jcb';
                    } else if (cardType === 'americanexpress') {
                        return 'fa-cc-amex';
                    } else if (cardType === 'dinersclub') {
                        return 'fa-cc-diners-club';
                    } else if (cardType === 'visa') {
                        return 'fa-cc-visa';
                    } else if (cardType === 'mastercard') {
                        return 'fa-cc-mastercard';
                    } else {
                        return 'fa-credit-card';
                    }
                };

                vm.fnCheckPaymentMethod = function () {
                    return Object.keys(vm.selectedPaymentMethod).length === 0;
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.fnInitCarts();
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnProceedToCheckout = function () {
                    //vm.isCartUpdating = true;
                    var flag = false;
                    _.forEach(vm.cartArr.cartItems, function (cartObj) {
                        if (cartObj.product && cartObj.product.shippable) {
                            flag = true;
                        }
                    });
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/store/cart/modal/shippingDetailsModal.html',
                        size: 'lg',
                        controller: 'shippingDetailsCtrl as shippingDetails',
                        resolve: {
                            selectedPaymentMethod: function () {
                                return vm.selectedPaymentMethod;
                            },
                            isShippable: function () {
                                return flag;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        //vm.isCartUpdating = false;
                        vm.fnInitCarts();
                        amaran.success("Checkout Successfully");
                    }, function () {
                        vm.isCartUpdating = false;
                    });
                };

                vm.fnInitCarts = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.nodePermissionObj = PermissionsService.getPermissionsV4('node');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                    vm.fnGetCarts();
                    vm.fnGetPaymentMethod();
                };
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FolderCtrl',
            function ($http, $scope, $window, $timeout, $stateParams, $state, $uibModal, moment, amaran, swal, microSpinner, DB, Authenticate, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, FileFactory, FolderFactory,  postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false, //d
                    85: false, //u
                    79: false //o
                };

                vm.archiveFileExtensionArr=['zip','z','gz','tar','rpm','rar','pkg','deb','arj','7z'];
                vm.programmingFileExtensionArr = ['sql','xml','db','apk','bat','bin','com','exe','jar','wsf','py','asp','aspx','css','htm','html','js','jsp','part','php','rss','xhtml','c','class','cpp','cs','h','java','sh','swift','vb','less','json'];
                vm.audioFileExtensionArr = ['aif','cda','mid','midi','mp3','mpa','ogg','wav','wma','wpl'];
                vm.videoFileExtensionArr = ['3g2','3gp','h264','m4v','mkv','avi','flv','wmv','mov','mp4','mpg','mpeg','rm','swf','vob'];
                vm.imageFileExtensionArr = ['ai','bmp','gif','ico','jpeg','jpg','png','ps','psd','svg','tif','tiff'];
                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "Path",
                        fieldName: "path"
                    }
                ];
                vm.filterQuery = [];

                //Listener Variables
                vm.isFoldersLoading = false;
                vm.isShowFileDetails = false;
                vm.isPasteProcess = false;
                vm.isFileUploading = false;
                vm.isFileDownloading = false;
                vm.folderArr = [];
                vm.selectedFoldersArr = [];
                vm.selectedFolderObj = null;
                vm.selectedFunction = '';
                vm.breadcrumbArray = [];
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.currentPath = $stateParams.path ? $stateParams.path : '/';
                //API params Variable
                vm.inputObj = {};

                //Copy Paste Variables
                vm.isFolderFileCopied = angular.isDefined(DB.fnGet('copiedFileFolder')) ? true : false;


                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 70);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                //Context Menu: Start
                vm.fileFolderContextMenu = function (folderObj) {
                    if(!vm.selectedFolderObj || vm.selectedFolderObj.path !== folderObj.path) {
                        vm.fnSelectSingleFolder(folderObj, vm.folderArr);
                    }
                    return [{
                        text: 'Open',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnOpenFileInNewTab(vm.selectedFolderObj);
                        },
                        displayed: folderObj && folderObj.size < 1000000 &&
                        folderObj.type === 'file' &&
                        vm.fnCheckFileType(vm.selectedFolderObj) && vm.filePermissionObj.Download
                    },{
                        text: 'Download',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnGetFileData(vm.selectedFolderObj)
                        },
                        displayed: vm.filePermissionObj.Download &&
                        folderObj &&
                        folderObj.type === 'file'
                    },{
                        text: 'Rename',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnOpenRenameModal(vm.selectedFolderObj)
                        },
                        displayed: folderObj ? folderObj.type === 'file' ?
                            vm.filePermissionObj.Modify : vm.folderPermissionObj.Modify : false,
                        hasTopDivider: folderObj && folderObj.type === 'file' &&
                        vm.filePermissionObj.Modify
                    },{
                        text: 'Delete',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnDeleteItem(vm.selectedFoldersArr)
                        },
                        displayed: vm.fnCheckFileFolderPermission('delete')
                    },{
                        text: 'Copy',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnSetCutCopyPath('COPY', vm.selectedFoldersArr)
                        },
                        displayed: vm.fnCheckFileFolderPermission('modify'),
                        hasTopDivider: vm.fnCheckFileFolderPermission('modify')
                    },{
                        text: 'Cut',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnSetCutCopyPath('MOVE', vm.selectedFoldersArr)
                        },
                        displayed: vm.fnCheckFileFolderPermission('modify')
                    },{
                        text: 'Paste',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            vm.fnPasteFileFolder()
                        },
                        displayed: vm.isFolderFileCopied !== false
                    }]
                };
                //Context Menu: End

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isFoldersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "SEARCH",
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            function: "LIST",
                            path: vm.currentPath
                        };
                    }
                    vm.selectedFunction = inputObj.function;
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.selectedFolderObj = null;
                    vm.isAllChecked = false;
                    if (vm.contentPermissionObj.List) {
                        vm.fnGetFolders(inputObj);
                    } else {
                        vm.folderArr = [];
                        vm.isFoldersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + searchTag + header + 100);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnGetFolders = function (inputObj) {
                    FolderFactory.getContents(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.contents;
                            res.map(function (obj) {
                                if (obj.path.slice(-1) === "/") {
                                    var folderName = obj.path.split('/');
                                    obj.name = folderName[folderName.length - 2];
                                    obj.icon = "fa-folder-open";
                                    obj.lastUpdate = "-";
                                    obj.fileSize = "-";
                                    obj.type = "folder";
                                } else {
                                    var fileName = obj.path.split('/');
                                    obj.name = fileName[fileName.length - 1];
                                    var extension = obj.name.split('.')[obj.name.split('.').length - 1];
                                    if (extension === "pdf") {
                                        obj.icon = "fa-file-pdf-o";
                                    } else if (_.includes(vm.programmingFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-code-o";
                                    } else if (_.includes(vm.audioFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-audio-o";
                                    }else if (_.includes(vm.videoFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-video-o";
                                    }else if (_.includes(vm.imageFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-image-o";
                                    }else if (extension === "xlsx" || extension === "xls" || extension === 'csv') {
                                        obj.icon = "fa-file-excel-o";
                                    } else if (extension === "pptx" || extension === "ppt") {
                                        obj.icon = "fa-file-powerpoint-o";
                                    } else if (extension === "txt") {
                                        obj.icon = "fa-file-text-o";
                                    } else if (extension === "docx" || extension === "doc") {
                                        obj.icon = "fa-file-word-o";
                                    } else if (_.includes(vm.archiveFileExtensionArr, extension)) {
                                        obj.icon = "fa-file-archive-o";
                                    } else {
                                        obj.icon = "fa-file-o";
                                    }
                                    obj.lastUpdate = moment(obj.lastModified).utc()._d;
                                    obj.fileSize = bytesToSize(obj.size);
                                    obj.type = "file";
                                }
                            });
                            vm.folderArr = angular.copy(res);
                            if($stateParams.selectedFile) {
                                angular.forEach(vm.folderArr, function (folderObj) {
                                    if(folderObj.name === $stateParams.selectedFile) {
                                        folderObj.isCheck = true;
                                        vm.fnGetFolder(folderObj);
                                    }
                                })
                            }else if($stateParams.selectedFolder){
                                angular.forEach(vm.folderArr, function (folderObj) {
                                    if(folderObj.name === $stateParams.selectedFolder) {
                                        vm.fnSelectSingleFolder(folderObj,vm.folderArr);
                                    }
                                })
                            }
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($state.current.name === 'main.folder') {
                                $state.go('main.folder', {
                                    page: vm.currentPage, perPage: vm.perPage, path: inputObj.path, selectedFile: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                $stateParams.path = inputObj.path;
                                delete $stateParams.selectedFile;
                            }

                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFoldersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.folderArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedFoldersArr = angular.copy(vm.folderArr);
                    } else {
                        vm.selectedFoldersArr = [];
                    }
                    vm.selectedFolderObj = null;
                    vm.isShowFileDetails = false;
                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                    delete $stateParams.selectedFolder;
                    delete $stateParams.selectedFile;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckHeader = function (folderObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.folderArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === folderObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });
                    vm.selectedFoldersArr = [];
                    angular.forEach(vm.folderArr, function (obj) {
                        if(obj.isCheck === true) {
                            vm.selectedFoldersArr.push(obj);
                        }
                    });

                    if(vm.selectedFoldersArr.length === 1) {
                        vm.selectedFolderObj = vm.selectedFoldersArr[0];
                        if(vm.selectedFolderObj.type === 'folder') {
                            $state.go('main.folder', {selectedFolder: vm.selectedFolderObj.name,selectedFile:''}, {notify: false});
                            $stateParams.selectedFolder = vm.selectedFolderObj.name;
                            delete $stateParams.selectedFile;
                            vm.isShowFileDetails = false;
                        } else {
                            $state.go('main.folder', {selectedFolder: '',selectedFile:vm.selectedFolderObj.name}, {notify: false});
                            delete $stateParams.selectedFolder;
                            $stateParams.selectedFile = vm.selectedFolderObj.name;
                            vm.isShowFileDetails = true;
                            vm.isFolderDetailsLoaded = false;
                            $timeout(function () {
                                vm.isFolderDetailsLoaded = true;
                            })
                        }
                    } else {
                        $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                        delete $stateParams.selectedFolder;
                        delete $stateParams.selectedFile;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedFolderObj = null;
                        vm.isShowFileDetails = false;
                    }
                };

                vm.fnSelectSingleFolder = function (folderObj, foldersArr) {
                    vm.isAllChecked = false;
                    vm.isShowFileDetails = false;
                    angular.forEach(foldersArr, function (folder) {
                        folder.isCheck = false;
                    });
                    folderObj.isCheck = true;
                    vm.selectedFoldersArr = [folderObj];
                    vm.selectedFolderObj = folderObj;
                    if(vm.selectedFolderObj.type === 'folder') {
                        $state.go('main.folder', {selectedFolder: vm.selectedFolderObj.name,selectedFile:''}, {notify: false});
                        $stateParams.selectedFolder = vm.selectedFolderObj.name;
                        delete $stateParams.selectedFile;
                        vm.isShowFileDetails = false;
                    } else {
                        vm.isShowFileDetails = true;
                        vm.isFolderDetailsLoaded = false;
                        $state.go('main.folder', {selectedFolder: '',selectedFile:vm.selectedFolderObj.name}, {notify: false});
                        delete $stateParams.selectedFolder;
                        $stateParams.selectedFile = vm.selectedFolderObj.name;
                        $timeout(function () {
                            vm.isFolderDetailsLoaded = true;
                        })
                    }
                };

                vm.fnGetFileDetails = function (folderObj) {
                    vm.isShowFileDetails = true;
                    vm.isFolderDetailsLoaded = false;
                    $timeout(function () {
                        vm.fnSelectSingleFolder(folderObj, vm.folderArr);
                        vm.isFolderDetailsLoaded = true;
                    })
                };

                vm.fnGetFolder = function (folderObj) {
                    if (folderObj.type === "file") {
                        vm.fnGetFileDetails(folderObj);
                    } else {
                        vm.breadcrumbArray.push(folderObj.name);
                        vm.currentPath = vm.currentPath + folderObj.name + "/";
                        $state.go('main.folder', {
                            page: '', perPage: '', path: '', filter: '', selectedFile: ''
                        }, {notify: false});

                        $timeout(function () {
                            vm.fnReload();
                        }, 100)
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                    delete $stateParams.selectedFolder;
                    delete $stateParams.selectedFile;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery,
                            function: vm.selectedFunction
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            function: vm.selectedFunction
                        };
                    }

                    if(vm.selectedFunction === 'LIST') {
                        vm.inputObj.path = vm.currentPath;
                    }
                    vm.isFoldersLoading = true;
                    vm.selectedFoldersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetFolders(vm.inputObj);
                };

                vm.fnGetPath = function (pathName, $index) {
                    vm.currentPath = '';
                    //var index =  vm.breadcrumbArray.indexOf(pathName);
                    vm.breadcrumbArray.splice($index + 1,vm.breadcrumbArray.length - 1);
                    angular.forEach(vm.breadcrumbArray, function (breadCrumbName) {
                        vm.currentPath = vm.currentPath + breadCrumbName;
                        if(breadCrumbName !== "/") {
                            vm.currentPath = vm.currentPath + "/";
                        }
                    });
                    $state.go('main.folder', {
                        page: '', perPage: '', path: '', filter: '', selectedFile: '', selectedDetailsTab:'',selectedFolder:''
                    }, {notify: false});

                    $timeout(function () {
                        if(vm.contentPermissionObj.List){
                            vm.fnReload();
                        }
                    }, 100)
                };
                /*END: TABLE*/

                vm.fnDeleteItem = function (itemArr) {
                    var count = 0;
                    swal({
                            title: "Delete the selected files/folders?",
                            text: "You are about to permanently delete the selected files/folders.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                               vm.fnConfirmDelete(count, itemArr);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnConfirmDelete = function (count, itemArr) {
                    var inputObj = {
                        path: itemArr[count].path
                    };
                    if(itemArr[count].type === 'folder') {
                        FolderFactory.deleteFolder(inputObj)
                            .then(function () {
                                count++;
                                if(count < itemArr.length) {
                                    vm.fnConfirmDelete(count, itemArr);
                                } else {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                                    delete $stateParams.selectedFolder;
                                    delete $stateParams.selectedFile;
                                    delete $stateParams.selectedDetailsTab;
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    },1000);
                                    vm.fnReload();
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                count++;
                                if(count < itemArr.length) {
                                    vm.fnConfirmDelete(count, itemArr);
                                } else {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element('.microSpinner').remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                                    delete $stateParams.selectedFolder;
                                    delete $stateParams.selectedFile;
                                    delete $stateParams.selectedDetailsTab;
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    },1000);
                                    vm.fnReload();
                                }
                            })
                    } else if (itemArr[count].type === 'file') {
                        FileFactory.deleteFile(inputObj)
                            .then(function () {
                                count++;
                                if(count < itemArr.length) {
                                    vm.fnConfirmDelete(count, itemArr);
                                } else {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    },1000);
                                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                                    delete $stateParams.selectedFolder;
                                    delete $stateParams.selectedFile;
                                    delete $stateParams.selectedDetailsTab;
                                    vm.fnReload();
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                count++;
                                if(count < itemArr.length) {
                                    vm.fnConfirmDelete(count, itemArr);
                                } else {
                                    swal({
                                        title: postActionModelMessage,
                                        html: true,
                                        imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                        showCancelButton: false,
                                        showConfirmButton: false,
                                        customClass: 'customSwalActionModel'
                                    });
                                    angular.element(".microSpinner").remove();
                                    angular.element(".confirm").css("visibility", "visible");
                                    $timeout(function () {
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    },1000);
                                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                                    delete $stateParams.selectedFolder;
                                    delete $stateParams.selectedFile;
                                    delete $stateParams.selectedDetailsTab;
                                    vm.fnReload();
                                }
                            })
                    }
                };

                vm.fnOpenRenameModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/storage/folder/modals/renameModal/renameModal.html',
                        size: 'md',
                        controller: 'renameModalCtrl as renameModal',
                        resolve: {
                            folderObj: function () {
                                return vm.selectedFolderObj;
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        if(response === 'success') {
                            amaran.success('Renamed successfully');
                            vm.fnReload();
                        } else {
                            amaran.error('Rename was unsuccessful');
                            vm.fnReload();
                        }
                    }, function () {

                    });
                };

                vm.fnSetCutCopyPath = function (functionType, foldersArr) {
                    var copyArr = [];
                    angular.forEach(foldersArr, function (folderObj) {
                        var inputObj = {
                            function: functionType,
                            path: folderObj.path,
                            type: folderObj.type,
                            name: folderObj.name
                        };
                        copyArr.push(inputObj);
                    });
                    DB.fnSet('copiedFileFolder', copyArr);
                    vm.isFolderFileCopied = true;
                };

                vm.fnPasteFileFolder = function () {
                    vm.isPasteProcess = true;
                    var count = 0;
                    var tempArr = DB.fnGet('copiedFileFolder');
                    var functionName = tempArr[0].function === 'MOVE' ? 'moved' : 'copied';
                    vm.fnConfirmPasteProcess(functionName, count, tempArr);
                };

                vm.fnConfirmPasteProcess = function (functionName, count, tempArr) {
                    var inputObj = {
                        body: {
                            function: tempArr[count].function,
                            source: {
                                path: tempArr[count].path
                            },
                            destination: {
                                path: ''
                            }
                        }
                    };

                    if(tempArr[count].type === 'file') {
                        inputObj.body.destination.path = vm.currentPath + tempArr[count].name;
                        FileFactory.modifyFile(inputObj)
                            .then(function () {
                                count++;
                                if(count < tempArr.length) {
                                    vm.fnConfirmPasteProcess(functionName, count, tempArr);
                                } else {
                                    if(functionName === 'moved') {
                                        DB.fnRemove('copiedFileFolder');
                                        vm.isFolderFileCopied = false;
                                    }
                                    vm.isPasteProcess = false;
                                    amaran.success('Selected Files/Folders ' + functionName + ' successfully');
                                    if(vm.contentPermissionObj.List){
                                        vm.fnReload();
                                    }
                                }
                            }, function() {
                                count++;
                                if(count < tempArr.length) {
                                    vm.fnConfirmPasteProcess(functionName, count, tempArr);
                                } else {
                                    if(functionName === 'moved') {
                                        DB.fnRemove('copiedFileFolder');
                                        vm.isFolderFileCopied = false;
                                    }
                                    vm.isPasteProcess = false;
                                    amaran.success('Selected Files/Folders ' + functionName + ' successfully');
                                    if(vm.contentPermissionObj.List){
                                        vm.fnReload();
                                    }
                                }
                            })
                    } else if (tempArr[count].type === 'folder') {
                        inputObj.body.destination.path = vm.currentPath + tempArr[count].name + "/";
                        FolderFactory.modifyFolder(inputObj)
                            .then(function () {
                                count++;
                                if(count < tempArr.length) {
                                    vm.fnConfirmPasteProcess(functionName, count, tempArr);
                                } else {
                                    if(functionName === 'moved') {
                                        DB.fnRemove('copiedFileFolder');
                                        vm.isFolderFileCopied = false;
                                    }
                                    vm.isPasteProcess = false;
                                    amaran.success('Selected Files/Folders ' + functionName + ' successfully');
                                    if(vm.contentPermissionObj.List){
                                        vm.fnReload();
                                    }
                                }
                            }, function() {
                                count++;
                                if(count < tempArr.length) {
                                    vm.fnConfirmPasteProcess(functionName, count, tempArr);
                                } else {
                                    if(functionName === 'moved') {
                                        DB.fnRemove('copiedFileFolder');
                                        vm.isFolderFileCopied = false;
                                    }
                                    vm.isPasteProcess = false;
                                    amaran.success('Selected Files/Folders ' + functionName + ' successfully');
                                    if(vm.contentPermissionObj.List){
                                        vm.fnReload();
                                    }
                                }
                            })
                    }
                };

                vm.uploadFiles = function (filedata) {
                    if(vm.filePermissionObj.Upload){
                        if(filedata.size < 5000000000000) {
                            vm.progressBar = 0;
                            vm.progressCounter = 0;
                            vm.isFileUploading = true;
                            var path = vm.currentPath;
                            var inputObj = {
                                body: {
                                    path: path + filedata.name,
                                    size: filedata.size
                                }
                            };
                            FileFactory.createFile(inputObj)
                                .then(function (response) {
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    });
                                    vm.uploadStorageFile(response.url, filedata);
                                })
                        } else {
                            amaran.error("File size should be less than 5 TB.")
                        }
                    }else{
                         swal("File upload was unsuccessful", "Insufficient privileges to upload a file.", "success");
                         angular.element(".microSpinner").remove();
                         angular.element(".confirm").css("visibility", "visible");
                    }
                };
                vm.uploadStorageFile = function (url, filedata) {
                    $http({
                        method: 'PUT',
                        url: url,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        uploadEventHandlers: {
                            progress: function (e) {
                                if (e.lengthComputable) {
                                    vm.progressBar = (e.loaded / e.total) * 100;
                                    vm.progressCounter = vm.progressBar;
                                }
                            }
                        },
                        data: filedata
                    }).success(function () {
                        vm.isFileUploading = false;
                        if(vm.contentPermissionObj.List){
                            vm.fnReload();
                        }
                    });
                };

                vm.fnGetFileData = function (folderObj) {
                    vm.isFileDownloading = true;
                    var inputObj = {
                        path: folderObj.path
                    };
                    FileFactory.getFile(inputObj)
                        .then(function (response) {
                            vm.fnDownloadFile(response.url, folderObj.name, response.metadata.type);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnDownloadFile = function (url,filename,fileType) {
                    $http({
                        method : "GET",
                        url : url,
                        responseType:'blob'
                    }).then(function mySuccess(response) {
                        var file = new Blob([response.data], { type: fileType });
                        var fileURL = URL.createObjectURL(file);
                        var link=document.createElement('a');
                        link.href=fileURL;
                        link.download=filename;
                        vm.isFileDownloading = false;
                        link.click();
                    }, function error () {

                    });
                };

                vm.fnCheckFileType = function (folderObj) {
                    var extensionArr = ["pdf", "jpg", "jpeg", "png", "txt", "json", "mp3"];
                    var extension = folderObj.name.split('.')[folderObj.name.split('.').length - 1];
                    var index = extensionArr.indexOf(extension);
                    if(index > -1) {
                        return true;
                    } else {
                        return false;
                    }
                };

                vm.fnOpenFileInNewTab = function (folderObj) {
                    var inputObj = {
                        path: folderObj.path
                    };
                    FileFactory.getFile(inputObj)
                        .then(function (response) {
                            var win = window.open(response.url, '_blank'); //eslint-disable-line
                            win.focus();
                            //vm.fnGetFileFromUrl(response.url, folderObj.name, response.metadata.type); //do not remove
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnGetFileFromUrl = function (url,filename,fileType) { //do not delete
                    $http({
                        method : "GET",
                        url : url,
                        responseType:'blob'
                    }).then(function (response) {
                        var file = new Blob([response.data], { type: fileType });
                        var fileURL = URL.createObjectURL(file);
                        var link=document.createElement('a');
                        link.target = "_blank";
                        link.href=fileURL;
                        link.click();
                    }, function error () {

                    });
                };

                vm.fnCheckFileFolderPermission = function (type) {
                    if(vm.selectedFoldersArr.length) {
                        var uniqueNames = _.map(_.uniqBy(vm.selectedFoldersArr, 'type'), function (item) {
                            return item.type;
                        });
                        if (type === 'delete') {
                            if(uniqueNames.length === 1) {
                                if(uniqueNames[0] === 'file' && vm.filePermissionObj.Delete) {
                                    return true;
                                } else if (uniqueNames[0] === 'folder' && vm.folderPermissionObj.Delete) {
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                if(vm.filePermissionObj.Delete && vm.folderPermissionObj.Delete) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        } else if (type === 'modify') {
                            if(uniqueNames.length === 1) {
                                if(uniqueNames[0] === 'file' && vm.filePermissionObj.Modify) {
                                    return true;
                                } else if (uniqueNames[0] === 'folder' && vm.folderPermissionObj.Modify) {
                                    return true;
                                } else {
                                    return false;
                                }
                            } else {
                                if(vm.filePermissionObj.Modify && vm.folderPermissionObj.Modify) {
                                    return true;
                                } else {
                                    return false;
                                }
                            }
                        }
                    } else {
                        return false;
                    }
                };

                vm.fnCheckActionsMenuValidations = function () {
                    if(vm.selectedFoldersArr.length) {
                        return vm.fnCheckFileFolderPermission('modify') &&
                            vm.fnCheckFileFolderPermission('delete') ||
                            (vm.isFolderFileCopied !== false && vm.isPasteProcess === false);
                    } else {
                        if(vm.isFolderFileCopied !== false && vm.isPasteProcess === false) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedFoldersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if(isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.contentPermissionObj.List = false;
                    $timeout(function () {
                        vm.contentPermissionObj.List = true;
                    }, 10)
                };

                function bytesToSize(bytes) {
                    var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
                    if (bytes === 0) {
                        return 'n/a';
                    }
                    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
                    if (i === 0) {
                        return bytes + ' ' + sizes[i];
                    }
                    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
                }

                $scope.$on("callReload", function () {
                    $state.go('main.folder', {selectedFolder: '',selectedFile:'',selectedDetailsTab:''}, {notify: false});
                    delete $stateParams.selectedFolder;
                    delete $stateParams.selectedFile;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("cutCopyEventTriggered", function (evt, data) {
                    DB.fnSet('copiedFileFolder', data);
                    vm.isFolderFileCopied = true;
                });

                vm.fnInitFolder = function () {
                    vm.folderPermissionObj = PermissionsService.getPermissions("storage:folder");
                    vm.filePermissionObj = PermissionsService.getPermissions("storage:file");
                    vm.contentPermissionObj = PermissionsService.getPermissions("storage:content");// list permission List:"TRUE"
                    if(vm.currentPath === '/') {
                        vm.breadcrumbArray = ["/"];
                    } else {
                        vm.breadcrumbArray = ["/"];
                        var tempArr = vm.currentPath.split("/");
                        angular.forEach(tempArr, function (path) {
                            if(path.length) {
                                vm.breadcrumbArray.push(path);
                            }
                        })
                    }
                };

                var folderKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.folder') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.folderPermissionObj.Create && !vm.filterQuery.length && vm.isPasteProcess === false && !vm.isFileDownloading &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && (vm.selectedFolderObj ? vm.selectedFolderObj.type === 'file' ? vm.filePermissionObj.Modify : vm.folderPermissionObj.Modify : false) &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteItem(vm.selectedFolderObj);
                                codeset[38] = false;
                                codeset[68] = false;
                            } else if (codeset[38] && codeset[85] && vm.filePermissionObj.Upload && !vm.filterQuery.length && vm.isPasteProcess === false && !vm.isFileDownloading &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                document.getElementById('storageFileUpload').click();
                                codeset[38] = false;
                                codeset[85] = false;
                            } else if (codeset[38] && codeset[79] && vm.filePermissionObj.Download && vm.selectedFolderObj &&
                                vm.selectedFolderObj.type === 'file' &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnGetFileData(vm.selectedFolderObj);
                                codeset[38] = false;
                                codeset[79] = false;
                            }
                        }
                    }
                };

                var folderKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.folder') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', folderKeyDownEventHandler);
                document.addEventListener('keyup', folderKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', folderKeyDownEventHandler);
                    document.removeEventListener('keyup', folderKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PredictiveDashboardCtrl',
            function ($scope, $window, $timeout, $sce, $state) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;
                vm.isCreate = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1900;
                    });
                });

                vm.fnGoToState = function (state) {
                    $state.go(state)
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.isCreate = tab.id === "Create Issue";
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Issue";
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                };
                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightPredictiveDashboardChartData', angular.toJson(tempIssueData));
                    vm.isCreate = true;
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnInit = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1900) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AccountsCtrl',
            function ($rootScope, $scope, $window, $timeout, $stateParams, $base64, SessionFactory, $state, WidgetsListService, PaginationQueryService, UserProfileService, $uibModal, amaran, swal, microSpinner, DB, Authenticate, XLSX, jsonToCsvConvertService, PermissionsService, LastPageService, AvatarService, UserFactory, AccountFactory, QueryFactory, BatchFactory, PaginationService, FedSudoUserService, postActionModelIcon, postActionModelMessage, copyService, $log) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.isShowWidgetEditor = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Accounts Variables
                vm.isAccountsloading = false;
                vm.AccountsArr = [];
                vm.selectedAccountsArr = [];
                vm.selectedAccountObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.accountsResponse = [];
                vm.isFullWidthDevice = false;
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateAccountProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowAccountStats = false;
                vm.lastSQLQuery = "";

                /*Start: Context Menu*/
                vm.resetEditAccountObj = {};

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.accountContextMenu = function (accountObj) {
                    if (Object.keys(vm.resetEditAccountObj).length) {
                        var isFindAccount = _.find(vm.AccountsArr, {id: vm.resetEditAccountObj.id});
                        if (isFindAccount) {
                            vm.fnCancelAccountEditMode(isFindAccount);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            accountObj.isEditable = true;
                            vm.resetEditAccountObj = angular.copy(accountObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        // Create shallow copy of item
                        var parsedItem = angular.copy(item);

                        // Handle timestamps
                        if (item.updated_at) {
                            parsedItem.updatedAt = new Date(item.updated_at).valueOf();
                        }
                        if (item.created_at) {
                            parsedItem.createdAt = new Date(item.created_at).valueOf();
                        }

                        // Parse the data field if it exists and is a string
                        if (angular.isString(item.data)) {
                            try {
                                var parsedData = angular.fromJson(item.data);

                                // Set required fields from parsed data
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedData.name || '';
                                parsedItem.description = parsedData.description || '';

                                // Handle account-specific fields
                                parsedItem.supportAccess = parsedData.supportAccess || false;
                                parsedItem.accountOwner = parsedData.accountOwner || false;
                                parsedItem.administrator = parsedData.administrator || false;

                                // Handle user roles and permissions
                                if (parsedData.roles) {
                                    parsedItem.roles = parsedData.roles;
                                }
                                if (parsedData.permissions) {
                                    parsedItem.permissions = parsedData.permissions;
                                }

                                // Handle additional metadata
                                if (parsedData.metadata) {
                                    parsedItem.metadata = parsedData.metadata;
                                }

                            } catch (e) {
                                $log.error('Error parsing account data:', e);
                            }
                        }

                        return parsedItem;
                    });
                }

                vm.fnCancelAccountEditMode = function (accountObj, isSuccessCall) {
                    if (isSuccessCall) {
                        accountObj.name = angular.copy(accountObj.name);
                        accountObj.description = angular.copy(accountObj.description);
                        accountObj.isEditable = false;
                        vm.resetEditAccountObj = {};
                    } else {
                        accountObj.name = angular.copy(vm.resetEditAccountObj.name);
                        accountObj.description = angular.copy(vm.resetEditAccountObj.description);
                        accountObj.isEditable = false;
                        vm.resetEditAccountObj = {};
                    }
                };

                vm.fnSaveAccountInfo = function (accountObj) {
                    accountObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        accountId: accountObj.id
                    };
                    inputObj.body = {
                        name: accountObj.name,
                        description: angular.isUndefined(accountObj.description) ? '' : accountObj.description
                    };
                    AccountFactory.updateAccount(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.AccountsArr, function (accountObj) {
                                if (Object.keys(vm.selectedAccountObj).length) {
                                    if (accountObj.id === vm.selectedAccountObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedAccountObj[key] = val;
                                            accountObj[key] = val;
                                        });
                                    }
                                }
                                if (accountObj.id === resetCopy.id) {
                                    accountObj.name = resetCopy.name;
                                    accountObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelAccountEditMode(accountObj, true);
                            amaran.success("Account Updated Successfully");
                        }, function (error) {
                            vm.fnCancelAccountEditMode(accountObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    vm.isAccountsloading = true;
                    vm.selectedAccountsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_accounts';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_accounts';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetAccounts(input, true);
                };
                /*END: Search*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAccountCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.AccountsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var accountsArrCp = _.cloneDeepWith(vm.AccountsArr);
                    var tempData = _.map(accountsArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Accounts");
                    XLSX.writeFile(wb, "accounts.xlsx");
                };
                /* Export Modal: End */

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#accountTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAccounts = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            try {
                                vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                                vm.accountsResponse = _.cloneDeepWith(res);

                                // Parse the PostgreSQL data if it exists
                                if (vm.accountsResponse.data) {
                                    vm.accountsResponse.data = parsePostgresData(vm.accountsResponse.data);
                                }

                                // Handle first page totals
                                if (isFirst) {
                                    if (vm.accountsResponse.data && vm.accountsResponse.data.length) {
                                        vm.totalItems = vm.accountsResponse.data[0].totalItems;
                                    } else {
                                        vm.totalItems = 0;
                                    }
                                    vm.currentPage = 1;
                                }

                                // Handle data reversal if needed
                                if (inputObj.isNeedDataReverse) {
                                    vm.accountsResponse.data.reverse();
                                }

                                vm.AccountsArr = vm.accountsResponse.data;

                                // Update state if needed
                                if ($state.current.name === 'main.accounts') {
                                    $timeout(function () {
                                        $state.go('main.accounts', {
                                            page: vm.currentPage,
                                            perPage: vm.perPage
                                        }, {notify: false});
                                        $stateParams.page = vm.currentPage;
                                        $stateParams.perPage = vm.perPage;
                                    }, 10)
                                }

                                // Clean up state and handle selected accounts
                                vm.isRefresh = false;
                                vm.isAccountsloading = false;

                                if ($stateParams.selectedId) {
                                    var accountData = _.find(vm.AccountsArr, {"id": $stateParams.selectedId});
                                    if (accountData) {
                                        vm.fnCheckUncheckHeader(accountData);
                                    }
                                }

                                // Final UI updates
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });

                            } catch (err) {
                                $log.error('Error processing account data:', err);
                                vm.isAccountsloading = false;
                                vm.isRefresh = false;
                                amaran.error('Error processing account data');
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAccountsloading = false;
                            vm.isRefresh = false;
                        });
                };

                vm.fnCheckUncheckHeader = function (accountObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.AccountsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === accountObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected accounts array*/
                    var isValueFind = _.find(vm.selectedAccountsArr, {'id': accountObj.id});
                    if (!isValueFind) {
                        vm.selectedAccountsArr.push(accountObj);
                        var isTabExist = _.find(vm.tabs, {'id': accountObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: accountObj.id,
                                title: accountObj.name,
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateAccountProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedAccountsArr, function (obj) {
                            return accountObj.id === obj.id;
                        });
                    }
                    if (vm.selectedAccountsArr.length === 1) {
                        vm.fnGetAccountDetails(vm.selectedAccountsArr[0])
                    } else {
                        $state.go('main.accounts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.AccountsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAccountsArr = angular.copy(vm.AccountsArr);
                    } else {
                        vm.selectedAccountsArr = [];
                    }
                    $state.go('main.accounts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetAccountDetails = function (accountObj) {
                    vm.isAccountDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when account is selected
                        vm.selectedAccountObj = accountObj;
                        if (vm.tabIndex !== 0) {
                            $state.go('main.accounts', {
                                selectedId: vm.selectedAccountObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedAccountObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isAccountDetailsLoaded = true;
                        } else {
                            $state.go('main.accounts', {selectedId: vm.selectedAccountObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedAccountObj.id;
                            vm.isAccountDetailsLoaded = true;
                        }
                    })
                };

                vm.fnOpenAccountInfoTab = function (accountObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(accountObj);
                };

                vm.fnGetAccount = function (accountObj, AccountsArr) {
                    angular.forEach(AccountsArr, function (account) {
                        account.isCheck = false;
                    });
                    accountObj.isCheck = true;
                    vm.selectedAccountsArr = [accountObj]; // Assign array with single account object
                    vm.fnGetAccountDetails(accountObj);
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedAccountsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Open Account'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Open Account',
                                title: 'Open Account',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateAccountProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.accounts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            //vm.fnUpdateUserData(perPage);
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAccountsloading = true;
                    vm.selectedAccountsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {//for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_accounts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_accounts';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_accounts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_accounts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAccounts(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.AccountsArr);
                        vm.previousPage = page;
                        vm.fnGetAccounts(input, false);
                    }
                };
                /*END: TABLE*/

                $scope.$on("AccountDeleted", function (evt, data) {
                    vm.selectedAccountObj = null;
                    vm.selectedAccountsArr = [];
                    vm.AccountsArr = vm.AccountsArr.filter(function (accountObj) {
                        return (accountObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.accounts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                });

                $scope.$on("AccountDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.AccountsArr, function (accountObj) {
                        if (accountObj.id === vm.selectedAccountObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedAccountObj[key] = val;
                                accountObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("accountAdded", function () {
                    vm.fnRemoveTab('Open Account');
                });

                vm.fnDeleteMultipleAccounts = function (selectedAccountsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedAccountsArr, function (selectedAccount, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/accounts/" + selectedAccount.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/accounts/" + selectedAccount.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected accounts?",
                            text: "You are about to permanently delete the selected accounts.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'account',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccountsArr, function (selectedAccount) {
                                    angular.forEach(vm.AccountsArr, function (accountObj, index) {
                                        if (selectedAccount.id === accountObj.id) {
                                            vm.AccountsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccountsArr.length;
                                vm.selectedAccountObj = null;
                                vm.selectedAccountsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAccountsArr, function (selectedAccount) {
                                    angular.forEach(vm.AccountsArr, function (accountObj, index) {
                                        if (selectedAccount.id === accountObj.id) {
                                            vm.AccountsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAccountsArr.length;
                                vm.selectedAccountObj = null;
                                vm.selectedAccountsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnCheckAuthAccount = function () {
                    /*var authAccount = Authenticate.fnIsAuthUser(selectedAccountsArr);
                     if (authAccount) {
                     return true;
                     } else {
                     return false;
                     }*/
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnInitAccounts = function () {
                    vm.permissionObj = PermissionsService.getPermissions("access:account");
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('ecsmon', 'account', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetAccountDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateAccountProfileData();
                        });
                    }
                };

                vm.fnGetAccountStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'AccountStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowAccountStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'AccountStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowAccountStats = true;
                            vm.fnUpdateAccountProfileData();
                        });
                    }
                };

                vm.fnUpdateAccountProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('ecsmon', 'account', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                /*Tab: Start*/

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.AccountsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedAccountsArr = [];
                                vm.selectedAccountObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.accounts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowAccountStats = tab.id === "AccountStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreate = tab.id === "Open Account";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowAccountStats = tab.id === "AccountStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreate = tab.id === "Open Account";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Open Account" || tab.id === "Create Issue" || tab.id === "AccountStats" || tab.id === "WidgetEditor") {
                        $state.go('main.accounts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.accounts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateAccountProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (AccountObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(AccountObj);
                };

                /*Tab: End*/
                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateAccountProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnCreateSupportSession = function (account) {
                    $rootScope.$broadcast("startSudoProcess", account); //will be listened in main controller
                };

                vm.fnLockECUSerial = function (accountObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/predictive/account/modal/lockECUSerial/lockECUSerial.html',
                        size: 'lg',
                        controller: 'LockECUSerialCtrl as LockECUSerial',
                        resolve: {
                            accountObj: function () {
                                return accountObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightECSMonAccountChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var accountKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.accounts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedAccountsArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleAccounts(vm.selectedAccountsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var accountKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.accounts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', accountKeyDownEventHandler);
                document.addEventListener('keyup', accountKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', accountKeyDownEventHandler);
                    document.removeEventListener('keyup', accountKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('WorkflowsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, UserFactory, BatchFactory, WorkflowFactory, FedSudoUserService, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }
                ];
                vm.filterQuery = "";

                //WorkFlows Variables
                vm.isWorkFlowsLoading = false;
                vm.workFlowsArr = [];
                vm.selectedWorkflowsArr = [];
                vm.selectedWorkflowObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');
                var drafts = DB.fnGet('WorkflowsSavedDrafts');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp=false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditWorkFlowObj = {};

                vm.workFlowContextMenu = function (workFlowObj) {
                    if (Object.keys(vm.resetEditWorkFlowObj).length) {
                        var isFindWorkFlow = _.find(vm.workFlowsArr, {id: vm.resetEditWorkFlowObj.id});
                        if (isFindWorkFlow) {
                            vm.fnCancelWorkFlowEditMode(isFindWorkFlow);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            workFlowObj.isEditable = true;
                            vm.resetEditWorkFlowObj = angular.copy(workFlowObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelWorkFlowEditMode = function (workFlowObj, isSuccessCall) {
                    if (isSuccessCall) {
                        workFlowObj.name = angular.copy(workFlowObj.name);
                        workFlowObj.description = angular.copy(workFlowObj.description);
                        workFlowObj.isEditable = false;
                        vm.resetEditWorkFlowObj = {};
                    } else {
                        workFlowObj.name = angular.copy(vm.resetEditWorkFlowObj.name);
                        workFlowObj.description = angular.copy(vm.resetEditWorkFlowObj.description);
                        workFlowObj.isEditable = false;
                        vm.resetEditWorkFlowObj = {};
                    }
                };

                vm.fnSaveWorkFlowInfo = function (workFlowObj) {
                    workFlowObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        workflowId: workFlowObj.id
                    };
                    inputObj.body = {
                        name: workFlowObj.name,
                        description: angular.isUndefined(workFlowObj.description)?'':workFlowObj.description
                    };
                    WorkflowFactory.modifyWorkflow(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.workFlowsArr, function (workFlowObj) {
                                if (Object.keys(vm.selectedWorkflowObj).length) {
                                    if (workFlowObj.id === vm.selectedWorkflowObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedWorkflowObj[key] = val;
                                            workFlowObj[key] = val;
                                        });
                                    }
                                }
                                if (workFlowObj.id === resetCopy.id) {
                                    workFlowObj.name = resetCopy.name;
                                    workFlowObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelWorkFlowEditMode(workFlowObj, true);
                            amaran.success("WorkFlow Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelWorkFlowEditMode(workFlowObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                // search type client side
                vm.search = '';
                vm.isBluePrintFilter = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isWorkFlowsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isWorkFlowsLoading = true;
                    vm.selectedWorkflowsArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetWorkFlows(inputObj);
                    } else {
                        vm.workFlowsArr = [];
                        vm.isWorkFlowsLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.workFlowsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedWorkflowsArr = angular.copy(vm.workFlowsArr);
                    } else {
                        vm.selectedWorkflowsArr = [];
                    }
                    $state.go('main.workflows', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenWorkflowInfoTab = function (workflowObj,tabIndex){
                    vm.tabIndex = tabIndex;
                    vm.fnGetWorkFlow(workflowObj, vm.workFlowsArr);
                };

                vm.fnGetWorkFlow = function (workflowObj, workFlowsArr) {
                    angular.forEach(workFlowsArr, function (workflow) {
                        workflow.isCheck = false;
                    });
                    workflowObj.isCheck = true;
                    vm.selectedWorkflowsArr = [workflowObj]; // Assign array with single workflow object
                    vm.fnGetWorkflowDetails(workflowObj);
                };

                vm.fnGetWorkflowDetails = function (workflowObj) {
                    vm.isWorkflowDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when workflow is selected
                        vm.selectedWorkflowObj = workflowObj;
                        if (vm.tabIndex !== 0) {
                            $state.go('main.workflows', {selectedId: vm.selectedWorkflowObj.id, selectedDetailsTab: vm.tabIndex}, {notify: false});
                            $stateParams.selectedId = vm.selectedWorkflowObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isWorkflowDetailsLoaded = true;
                        } else {
                            $state.go('main.workflows', {selectedId: vm.selectedWorkflowObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedWorkflowObj.id;
                            vm.isWorkflowDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckHeader = function (workflowObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.workFlowsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === workflowObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected workFlows array*/
                    var isValueFind = _.find(vm.selectedWorkflowsArr, {'id': workflowObj.id});
                    if (!isValueFind) {
                        vm.selectedWorkflowsArr.push(workflowObj)
                    } else {
                        _.remove(vm.selectedWorkflowsArr, function (obj) {
                            return workflowObj.id === obj.id;
                        });
                    }
                    if (vm.selectedWorkflowsArr.length === 1) {
                        vm.fnGetWorkflowDetails(vm.selectedWorkflowsArr[0])
                    }else {
                        $state.go('main.workflows', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleWorkFlows = function (selectedWorkflowsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedWorkflowsArr, function (selectedWorkflow, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/workflows/" + selectedWorkflow.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/workflows/" + selectedWorkflow.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected workflows?",
                            text: "You are about to permanently delete the selected workflows.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'workflow',
                        appName: 'pipeline'
                    }).then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedWorkflowsArr, function (selectedWorkflow) {
                                    angular.forEach(vm.workFlowsArr, function (workflowObj, index) {
                                        if (selectedWorkflow.id === workflowObj.id) {
                                            vm.workFlowsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedWorkflowsArr.length;
                                vm.selectedWorkflowObj = null;
                                vm.selectedWorkflowsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedWorkflowsArr, function (selectedWorkflow) {
                                    angular.forEach(vm.workFlowsArr, function (workflowObj, index) {
                                        if (selectedWorkflow.id === workflowObj.id) {
                                            vm.workFlowsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedWorkflowsArr.length;
                                vm.selectedWorkflowObj = null;
                                vm.selectedWorkflowsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetWorkFlows = function (inputObj) {
                    WorkflowFactory.getWorkflows(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.workflows;
                            vm.workFlowsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var workFlowData = _.find(vm.workFlowsArr,{"id":$stateParams.selectedId});
                                if(workFlowData){
                                    vm.fnGetWorkFlow(workFlowData, vm.workFlowsArr);
                                }
                            }
                            if ($state.current.name === 'main.workflows') {
                                $state.go('main.workflows', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isWorkFlowsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWorkFlowsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.workflows', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isWorkFlowsLoading = true;
                    vm.selectedWorkflowsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetWorkFlows(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.workflowSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "workflowSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.workflowSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnWorkflowsSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('workflowSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('workflowSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('workflowSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnShowCreateForm = function () {
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    $state.go("main.createWorkFlow");
                };

                vm.fnHideShowBluePrintForm = function (isCalledforOpen) {
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if(isCalledforOpen) {
                        vm.isCreateFromBluePrint = true;
                    } else {
                        vm.isCreateFromBluePrint = !vm.isCreateFromBluePrint;
                    }
                };

                $scope.$on("WorkflowDeleted", function (evt, data) {
                    vm.selectedWorkflowObj = null;
                    vm.selectedWorkflowsArr = [];
                    vm.workFlowsArr = vm.workFlowsArr.filter(function (workflowObj) {
                        return (workflowObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.workflows', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("WorkflowDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.workFlowsArr, function (workflowObj) {
                        if (workflowObj.id === vm.selectedWorkflowObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedWorkflowObj[key] = val;
                                workflowObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnInitWorkFlows = function () {
                    if (drafts && Object.keys(drafts).length) {
                        vm.isDraftsAvailable = true;
                    } else {
                        vm.isDraftsAvailable = false;
                    }
                    if($stateParams.isCalledAfterCreate) {
                        var tempObj = angular.fromJson($stateParams.isCalledAfterCreate);
                        $state.go('main.workflows', {isCalledAfterCreate: ''});
                        delete $stateParams.isCalledAfterCreate;
                        vm.fnOpenPostCreateActionModal(tempObj);
                    }
                    vm.permissionObj = PermissionsService.getPermissions("pipeline:workflow");
                    var sortData = FedSudoUserService.fnGetUserData('workflowSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                vm.fnOpenPostCreateActionModal = function (workFlowObj) {
                    var listenerPermissions = PermissionsService.getPermissions('pipeline:listener');
                    var optionsArr = [{
                        faIcon: "fa-bullhorn",
                        subOptions: []
                    }];
                    if(listenerPermissions.List && listenerPermissions.AddWorkflow) {
                        optionsArr[0].subOptions.push({
                            displayText: "Add to an existing Listener",
                            isRedirect: true,
                            calledForCreate: false,
                            stateName: "main.listeners"
                        })
                    }
                    if(listenerPermissions.Create) {
                        optionsArr[0].subOptions.push({
                            displayText: "Create a new Listener",
                            isRedirect: true,
                            calledForCreate: true,
                            stateName: "main.listeners"
                        })
                    }
                    if(listenerPermissions.Create && listenerPermissions.AddWorkflow) {
                        var triggerObj = {};
                        _.forEach(workFlowObj.flow, function (flowObj) {
                            if(flowObj.userData.category === 'TRIGGER') {
                                triggerObj = flowObj.userData;
                            }
                        });
                        if (Object.keys(triggerObj).length && triggerObj.name !== 'Undefined (*:*:*)') {
                            optionsArr[0].subOptions.push({
                                displayText: "Create a new Listener based on this Workflow",
                                isWorkflowOperationNeeded: true,
                                workflowObj: workFlowObj,
                                triggerObj: triggerObj
                            });
                        }
                    }
                    if(optionsArr[0].subOptions.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return optionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if(angular.isDefined(selectedOption)) {
                                if(selectedOption.isRedirect) {
                                    if(selectedOption.stateName.includes(".create") ||
                                        selectedOption.calledForCreate === false) {
                                        $state.go(selectedOption.stateName);
                                    } else {
                                        $state.go(selectedOption.stateName, {openCreateView: true});
                                    }
                                }
                            }
                        }, function () {});
                    }
                };

                /*start: blue print*/
                vm.isCalledFromBluePrint = false;
                vm.isBluePrintFetched = false;
                vm.isBluePrintSelected = false;
                vm.bluePrintArr = [];
                vm.selectedBluePrint = '';
                vm.createTitle = "Create from BluePrint";

                vm.fnBluePrintSelected = function (selectedBluePrint) {
                    vm.isBluePrintSelected = false;
                    if (selectedBluePrint) {
                        angular.forEach(vm.bluePrintArr, function (bluePrintObj) {
                            if (bluePrintObj.id === selectedBluePrint.id) {
                                $state.go("main.createWorkFlow", {'bluePrintId': bluePrintObj.id})
                            }
                        });
                        $timeout(function () {
                            vm.isBluePrintSelected = true;
                        })
                    }
                };
                vm.fnInitCreateWorkflowFromBluePrint = function () {
                    vm.isCalledFromBluePrint = true;
                    WorkflowFactory.getWorkflowBluePrints()
                        .then(function (response) {
                            vm.bluePrintArr = response;
                            vm.resetBluePrintArr = angular.copy(vm.bluePrintArr);
                            vm.isBluePrintFetched = true;
                        }, function () {
                            vm.isBluePrintFetched = true;
                        })
                };

                vm.fnBluePrintFilter = function () {
                    vm.isBluePrintFilter = true;
                    var searchArr = '';
                    if (angular.isDefined(vm.search)) {
                        searchArr = _.filter(vm.resetBluePrintArr, function (typeObj) {
                            if (typeObj.name.toLowerCase().includes(vm.search.toLowerCase())) {
                                return typeObj;
                            }
                        });
                    } else {
                        searchArr = angular.copy(vm.resetBluePrintArr);
                    }
                    vm.bluePrintArr = searchArr;
                    $timeout(function () {
                        vm.isBluePrintFilter = false;
                    },1000)
                };

                /*end: blue print*/

                /*Drafts: START*/
                vm.fnLoadDrafts = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/pipeline/workflows/modals/draftOptions/draftOptions.html',
                        size: 'md',
                        controller: 'draftOptionsCtrl as draftOptions',
                        resolve: {
                            draftObj: function () {
                                return drafts;
                            }
                        }
                    });
                    modalInstance.result.then(function (selectedDraftName) {
                        drafts = DB.fnGet('WorkflowsSavedDrafts');
                        if(drafts[selectedDraftName]) {
                            $state.go("main.createWorkFlow", {'draftName': selectedDraftName})
                        } else {
                            amaran.error("Draft not found");
                        }
                    }, function () {
                        drafts = DB.fnGet('WorkflowsSavedDrafts');
                        if (drafts && Object.keys(drafts).length) {
                            vm.isDraftsAvailable = true;
                        } else {
                            vm.isDraftsAvailable = false;
                        }
                    });
                };
                /*Drafts: END*/

                var workflowKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.workflows') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnHideShowBluePrintForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedWorkflowsArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleWorkFlows(vm.selectedWorkflowsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var workflowKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.workflows') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', workflowKeyDownEventHandler);
                document.addEventListener('keyup', workflowKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', workflowKeyDownEventHandler);
                    document.removeEventListener('keyup', workflowKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TransformersCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, TransformerFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }
                ];
                vm.filterQuery = "";

                //Transformer Variables
                vm.isTransformersLoading = false;
                vm.transformersArr = [];
                vm.selectedTransformersArr = [];
                vm.selectedTransformerObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditTransformerObj = {};

                vm.transformerContextMenu = function (transformerObj) {
                    if (Object.keys(vm.resetEditTransformerObj).length) {
                        var isFindTransformer = _.find(vm.transformersArr, {id: vm.resetEditTransformerObj.id});
                        if (isFindTransformer) {
                            vm.fnCancelTransformerEditMode(isFindTransformer);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            transformerObj.isEditable = true;
                            vm.resetEditTransformerObj = angular.copy(transformerObj);
                        }
                    }]
                };

                vm.fnCancelTransformerEditMode = function (transformerObj, isSuccessCall) {
                    if (isSuccessCall) {
                        transformerObj.name = angular.copy(transformerObj.name);
                        transformerObj.description = angular.copy(transformerObj.description);
                        transformerObj.spec = angular.copy(transformerObj.spec);
                        transformerObj.isEditable = false;
                        vm.resetEditTransformerObj = {};
                    } else {
                        transformerObj.name = angular.copy(vm.resetEditTransformerObj.name);
                        transformerObj.description = angular.copy(vm.resetEditTransformerObj.description);
                        transformerObj.spec = angular.copy(transformerObj.spec);
                        transformerObj.isEditable = false;
                        vm.resetEditTransformerObj = {};
                    }
                };

                vm.fnSaveTransformerInfo = function (transformerObj) {
                    transformerObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        transformerId: transformerObj.id
                    };
                    inputObj.body = {
                        name: transformerObj.name,
                        description: angular.isUndefined(transformerObj.description)?'':transformerObj.description,
                        spec: transformerObj.spec
                    };
                    TransformerFactory.modifyTransformer(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.transformersArr, function (transformerObj) {
                                if (Object.keys(vm.selectedTransformerObj).length) {
                                    if (transformerObj.id === vm.selectedTransformerObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedTransformerObj[key] = val;
                                            transformerObj[key] = val;
                                        });
                                    }
                                }
                                if (transformerObj.id === resetCopy.id) {
                                    transformerObj.name = resetCopy.name;
                                    transformerObj.description = resetCopy.description;
                                    transformerObj.spec = resetCopy.spec;
                                }
                            });
                            vm.fnCancelTransformerEditMode(transformerObj, true);
                            amaran.success("Transformer Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelTransformerEditMode(transformerObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isTransformersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTransformersLoading = true;
                    vm.selectedTransformersArr = [];
                    vm.isAllChecked = false;
                    if(vm.permissionObj.List) {
                        vm.fnGetTransformers(inputObj);
                    } else {
                        vm.transformersArr = [];
                        vm.isTransformersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.transformersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTransformersArr = angular.copy(vm.transformersArr);
                    } else {
                        vm.selectedTransformersArr = [];
                    }
                    $state.go('main.transformers', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenTransformerInfoTab = function(transformerObj){
                    vm.fnGetTransformer(transformerObj,vm.transformersArr);
                };

                vm.fnGetTransformer = function (transformerObj, transformersArr) {
                    angular.forEach(transformersArr, function (transformer) {
                        transformer.isCheck = false;
                    });
                    transformerObj.isCheck = true;
                    vm.selectedTransformersArr = [transformerObj]; // Assign array with single transformer object
                    vm.fnGetTransformerDetails(transformerObj);
                };

                vm.fnGetTransformerDetails = function (transformerObj) {
                    vm.isTransformerDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when transformer is selected
                        vm.selectedTransformerObj = transformerObj;
                        $state.go('main.transformers', {selectedId: vm.selectedTransformerObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedTransformerObj.id;
                        vm.isTransformerDetailsLoaded = true;
                    })
                };

                vm.fnCheckUncheckHeader = function (transformerObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.transformersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === transformerObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected transformers array*/
                    var isValueFind = _.find(vm.selectedTransformersArr, {'id': transformerObj.id});
                    if (!isValueFind) {
                        vm.selectedTransformersArr.push(transformerObj)
                    } else {
                        _.remove(vm.selectedTransformersArr, function (obj) {
                            return transformerObj.id === obj.id;
                        });
                    }
                    if (vm.selectedTransformersArr.length === 1) {
                        vm.fnGetTransformerDetails(vm.selectedTransformersArr[0])
                    }else {
                        $state.go('main.transformers', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleTransformers = function (selectedTransformersArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedTransformersArr, function (selectedTransformer, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/transformers/" + selectedTransformer.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/transformers/" + selectedTransformer.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected transformers?",
                            text: "You are about to permanently delete the selected transformers.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'transformer', appName: 'pipeline'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTransformersArr, function (selectedTransformer) {
                                    angular.forEach(vm.transformersArr, function (transformerObj, index) {
                                        if (selectedTransformer.id === transformerObj.id) {
                                            vm.transformersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTransformersArr.length;
                                vm.selectedTransformerObj = null;
                                vm.selectedTransformersArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTransformersArr, function (selectedTransformer) {
                                    angular.forEach(vm.transformersArr, function (transformerObj, index) {
                                        if (selectedTransformer.id === transformerObj.id) {
                                            vm.transformersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTransformersArr.length;
                                vm.selectedTransformerObj = null;
                                vm.selectedTransformersArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetTransformers = function (inputObj) {
                    TransformerFactory.getTransformers(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.transformers;
                            vm.transformersArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var transformerData = _.find(vm.transformersArr,{"id":$stateParams.selectedId});
                                if(transformerData){
                                    vm.fnGetTransformer(transformerData, vm.transformersArr);
                                }
                            }
                            if($state.current.name === 'main.transformers') {
                                $state.go('main.transformers', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isTransformersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTransformersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.transformers', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTransformersLoading = true;
                    vm.selectedTransformersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetTransformers(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.transformerSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "transformerSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.transformerSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnTransformersSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('transformerSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('transformerSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('transformerSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }

                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCreateFromBluePrint) {
                    vm.selectedTransformersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = !vm.isCreate;
                    if (isCreateFromBluePrint) {
                        vm.isCreateFromBluePrint = !vm.isCreateFromBluePrint;
                    }
                };

                vm.fnShowCreateForm = function (isCalledFromBluePrint) {
                    vm.selectedTransformersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCalledFromBluePrint) {
                        vm.isCreateFromBluePrint = true;
                    } else {
                        vm.isCreateFromBluePrint = false;
                    }
                };

                $scope.$on("TransformerDeleted", function (evt, data) {
                    vm.selectedTransformerObj = null;
                    vm.selectedTransformersArr = [];
                    vm.transformersArr = vm.transformersArr.filter(function (transformerObj) {
                        return (transformerObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.transformers', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("TransformerDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.transformersArr, function (transformerObj) {
                        if (transformerObj.id === vm.selectedTransformerObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedTransformerObj[key] = val;
                                transformerObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnInitTransformers = function () {
                    vm.permissionObj = PermissionsService.getPermissions("pipeline:transformer");
                    var sortData = FedSudoUserService.fnGetUserData('transformerSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var transformerKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.transformers') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedTransformersArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleTransformers(vm.selectedTransformersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var transformerKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.transformers') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', transformerKeyDownEventHandler);
                document.addEventListener('keyup', transformerKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', transformerKeyDownEventHandler);
                    document.removeEventListener('keyup', transformerKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PipelineTemplatesCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, TemplateFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }
                ];
                vm.filterQuery = "";

                //Template Variables
                vm.isTemplatesLoading = false;
                vm.templatesArr = [];
                vm.selectedTemplatesArr = [];
                vm.selectedTemplateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};
                /*Start: Context Menu*/

                vm.resetEditTemplateObj = {};

                vm.templateContextMenu = function (templateObj) {
                    if (Object.keys(vm.resetEditTemplateObj).length) {
                        var isFindTemplate = _.find(vm.templatesArr, {id: vm.resetEditTemplateObj.id});
                        if (isFindTemplate) {
                            vm.fnCancelTemplateEditMode(isFindTemplate);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            templateObj.isEditable = true;
                            vm.resetEditTemplateObj = angular.copy(templateObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelTemplateEditMode = function (templateObj, isSuccessCall) {
                    if (isSuccessCall) {
                        templateObj.name = angular.copy(templateObj.name);
                        templateObj.description = angular.copy(templateObj.description);
                        templateObj.isEditable = false;
                        vm.resetEditTemplateObj = {};
                    } else {
                        templateObj.name = angular.copy(vm.resetEditTemplateObj.name);
                        templateObj.description = angular.copy(vm.resetEditTemplateObj.description);
                        templateObj.isEditable = false;
                        vm.resetEditTemplateObj = {};
                    }
                };

                vm.fnSaveTemplateInfo = function (templateObj) {
                    templateObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        templateId: templateObj.id
                    };
                    inputObj.body = {
                        name: templateObj.name,
                        description: angular.isUndefined(templateObj.description)?'':templateObj.description,
                        body: templateObj.body
                    };
                    TemplateFactory.modifyTemplate(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.templatesArr, function (templateObj) {
                                if (Object.keys(vm.selectedTemplateObj).length) {
                                    if (templateObj.id === vm.selectedTemplateObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedTemplateObj[key] = val;
                                            templateObj[key] = val;
                                        });
                                    }
                                }
                                if (templateObj.id === resetCopy.id) {
                                    templateObj.name = resetCopy.name;
                                    templateObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelTemplateEditMode(templateObj, true);
                            amaran.success("Template Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelTemplateEditMode(templateObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isTemplatesLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTemplatesLoading = true;
                    vm.selectedTemplatesArr = [];
                    vm.isAllChecked = false;
                    if(vm.permissionObj.List) {
                        vm.fnGetTemplates(inputObj);
                    } else {
                        vm.templatesArr = [];
                        vm.isTemplatesLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.templatesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTemplatesArr = angular.copy(vm.templatesArr);
                    } else {
                        vm.selectedTemplatesArr = [];
                    }
                    $state.go('main.pipeline_templates', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenTemplateInfoTab = function(templateObj){
                    vm.fnGetTemplate(templateObj,vm.templatesArr);
                };


                vm.fnGetTemplate = function (templateObj, templatesArr) {
                    angular.forEach(templatesArr, function (template) {
                        template.isCheck = false;
                    });
                    templateObj.isCheck = true;
                    vm.selectedTemplatesArr = [templateObj]; // Assign array with single templates object
                    vm.fnGetTemplateDetails(templateObj);
                };

                vm.fnGetTemplateDetails = function (templateObj) {
                    vm.isTemplateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when template is selected
                        vm.selectedTemplateObj = templateObj;
                        $state.go('main.pipeline_templates', {selectedId: vm.selectedTemplateObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedTemplateObj.id;
                        vm.isTemplateDetailsLoaded = true;
                    })
                };

                vm.fnCheckUncheckHeader = function (templateObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.templatesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === templateObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected templates array*/
                    var isValueFind = _.find(vm.selectedTemplatesArr, {'id': templateObj.id});
                    if (!isValueFind) {
                        vm.selectedTemplatesArr.push(templateObj)
                    } else {
                        _.remove(vm.selectedTemplatesArr, function (obj) {
                            return templateObj.id === obj.id;
                        });
                    }
                    if (vm.selectedTemplatesArr.length === 1) {
                        vm.fnGetTemplateDetails(vm.selectedTemplatesArr[0])
                    } else {
                        $state.go('main.pipeline_templates', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleTemplates = function (selectedTemplatesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedTemplatesArr, function (selectedTemplate, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/templates/" + selectedTemplate.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/templates/" + selectedTemplate.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected templates?",
                            text: "You are about to permanently delete the selected templates.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'template', appName: 'pipeline'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTemplatesArr, function (selectedTemplate) {
                                    angular.forEach(vm.templatesArr, function (templateObj, index) {
                                        if (selectedTemplate.id === templateObj.id) {
                                            vm.templatesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTemplatesArr.length;
                                vm.selectedTemplateObj = null;
                                vm.selectedTemplatesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTemplatesArr, function (selectedTemplate) {
                                    angular.forEach(vm.templatesArr, function (templateObj, index) {
                                        if (selectedTemplate.id === templateObj.id) {
                                            vm.templatesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTemplatesArr.length;
                                vm.selectedTemplateObj = null;
                                vm.selectedTemplatesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetTemplates = function (inputObj) {
                    TemplateFactory.getTemplates(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.templates;
                            vm.templatesArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var templateData = _.find(vm.templatesArr,{"id":$stateParams.selectedId});
                                if(templateData){
                                    vm.fnGetTemplate(templateData, vm.templatesArr);
                                }
                            }
                            if($state.current.name === 'main.pipeline_templates') {
                                $state.go('main.pipeline_templates', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isTemplatesLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTemplatesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.pipeline_templates', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTemplatesLoading = true;
                    vm.selectedTemplatesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetTemplates(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.templateSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "templateSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.templateSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnTemplatesSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    } else {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('templateSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('templateSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('templateSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCreateFromBluePrint) {
                    vm.selectedTemplatesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = !vm.isCreate;
                    if (isCreateFromBluePrint) {
                        vm.isCreateFromBluePrint = !vm.isCreateFromBluePrint;
                    }
                };

                vm.fnShowCreateForm = function (isCalledFromBluePrint) {
                    vm.selectedTemplatesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCalledFromBluePrint) {
                        vm.isCreateFromBluePrint = true;
                    } else {
                        vm.isCreateFromBluePrint = false;
                    }
                };

                $scope.$on("TemplateDeleted", function (evt, data) {
                    vm.selectedTemplateObj = null;
                    vm.selectedTemplatesArr = [];
                    vm.templatesArr = vm.templatesArr.filter(function (templateObj) {
                        return (templateObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.pipeline_templates', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("TemplateDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.templatesArr, function (templateObj) {
                        if (templateObj.id === vm.selectedTemplateObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedTemplateObj[key] = val;
                                templateObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnInitTemplates = function () {
                    vm.permissionObj = PermissionsService.getPermissions("pipeline:template");
                    var sortData = FedSudoUserService.fnGetUserData('templateSort');
                    if (sortData !== '') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var templateKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.pipeline_templates') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedTemplatesArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleTemplates(vm.selectedTemplatesArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var templateKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.pipeline_templates') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', templateKeyDownEventHandler);
                document.addEventListener('keyup', templateKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', templateKeyDownEventHandler);
                    document.removeEventListener('keyup', templateKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ListenersCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, ColorService, IconService, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, ListenerFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedListenerId = '';

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "State",
                        fieldName: "state"
                    }
                ];
                vm.filterQuery = "";

                //Listener Variables
                vm.isListenersLoading = false;
                vm.listenersArr = [];
                vm.selectedListenersArr = [];
                vm.selectedListenerObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.statesArr = [
                    "INACTIVE",
                    "ACTIVE"
                ];
                vm.resetEditListenerObj = {};

                vm.listenerContextMenu = function (listenerObj) {
                    if (Object.keys(vm.resetEditListenerObj).length) {
                        var isFindListener = _.find(vm.listenersArr, {id: vm.resetEditListenerObj.id});
                        if (isFindListener) {
                            vm.fnCancelListenerEditMode(isFindListener);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            listenerObj.isEditable = true;
                            vm.resetEditListenerObj = angular.copy(listenerObj);
                        }
                    }]
                };

                vm.fnGetListenerStateIcon = function (state) {
                    var icon = IconService.fnGetListenerStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "INACTIVE":
                            return icon + ' InactiveStateIcon';
                    }
                };

                vm.getListenerStateColor = function (state) {
                    return ColorService.getListenerStateColor(state);
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };


                vm.fnCancelListenerEditMode = function (listenerObj, isSuccessCall) {
                    if (isSuccessCall) {
                        listenerObj.name = angular.copy(listenerObj.name);
                        listenerObj.description = angular.copy(listenerObj.description);
                        listenerObj.state = angular.copy(listenerObj.state);
                        listenerObj.isEditable = false;
                        vm.resetEditListenerObj = {};
                    } else {
                        listenerObj.name = angular.copy(vm.resetEditListenerObj.name);
                        listenerObj.description = angular.copy(vm.resetEditListenerObj.description);
                        listenerObj.state = angular.copy(vm.resetEditListenerObj.state);
                        listenerObj.isEditable = false;
                        vm.resetEditListenerObj = {};
                    }
                };

                vm.fnSaveListenerInfo = function (listenerObj) {
                    listenerObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        listenerId: listenerObj.id
                    };
                    inputObj.body = {
                        name: listenerObj.name,
                        description: angular.isUndefined(listenerObj.description)?'':listenerObj.description,
                        state: listenerObj.state
                    };
                    ListenerFactory.modifyListener(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.listenersArr, function (listenerObj) {
                                if (Object.keys(vm.selectedListenerObj).length) {
                                    if (listenerObj.id === vm.selectedListenerObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedListenerObj[key] = val;
                                            listenerObj[key] = val;
                                        });
                                    }
                                }
                                if (listenerObj.id === resetCopy.id) {
                                    listenerObj.name = resetCopy.name;
                                    listenerObj.description = resetCopy.description;
                                    listenerObj.state = resetCopy.state;
                                }
                            });
                            vm.fnCancelListenerEditMode(listenerObj, true);
                            amaran.success("Listener Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelListenerEditMode(listenerObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isListenersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isListenersLoading = true;
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    if(vm.permissionObj.List) {
                        vm.fnGetListeners(inputObj);
                    } else {
                        vm.listenersArr = [];
                        vm.isListenersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.listenersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedListenersArr = angular.copy(vm.listenersArr);
                    } else {
                        vm.selectedListenersArr = [];
                    }
                    $state.go('main.listeners', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenListenerInfoTab = function(listenerObj,tabIndex){
                    vm.tabIndex = tabIndex;
                    vm.fnGetListener(listenerObj,vm.listenersArr);
                };

                vm.fnGetListener = function (listenerObj, listenersArr) {
                    angular.forEach(listenersArr, function (listener) {
                        listener.isCheck = false;
                    });
                    listenerObj.isCheck = true;
                    vm.selectedListenersArr = [listenerObj]; // Assign array with single listeners object
                    vm.fnGetListenerDetails(listenerObj);
                };

                vm.fnGetListenerDetails = function (listenerObj) {
                    vm.isListenerDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when listener is selected
                        vm.selectedListenerObj = listenerObj;
                        if (vm.tabIndex !== 0) {
                            $state.go('main.listeners', {selectedId: vm.selectedListenerObj.id, selectedDetailsTab: vm.tabIndex}, {notify: false});
                            $stateParams.selectedId = vm.selectedListenerObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isListenerDetailsLoaded = true;
                        } else {
                            $state.go('main.listeners', {selectedId: vm.selectedListenerObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedListenerObj.id;
                            vm.isListenerDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckHeader = function (listenerObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.listenersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === listenerObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected listeners array*/
                    var isValueFind = _.find(vm.selectedListenersArr, {'id': listenerObj.id});
                    if (!isValueFind) {
                        vm.selectedListenersArr.push(listenerObj)
                    } else {
                        _.remove(vm.selectedListenersArr, function (obj) {
                            return listenerObj.id === obj.id;
                        });
                    }
                    if (vm.selectedListenersArr.length === 1) {
                        vm.fnGetListenerDetails(vm.selectedListenersArr[0])
                    }else {
                        $state.go('main.listeners', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleListeners = function (selectedListenersArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedListenersArr, function (selectedListener, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + selectedListener.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/listeners/" + selectedListener.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected listeners?",
                            text: "You are about to permanently delete the selected listeners.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'listener', appName: 'pipeline'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedListenersArr, function (selectedListener) {
                                    angular.forEach(vm.listenersArr, function (listenerObj, index) {
                                        if (selectedListener.id === listenerObj.id) {
                                            vm.listenersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedListenersArr.length;
                                vm.selectedListenerObj = null;
                                vm.selectedListenersArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedListenersArr, function (selectedListener) {
                                    angular.forEach(vm.listenersArr, function (listenerObj, index) {
                                        if (selectedListener.id === listenerObj.id) {
                                            vm.listenersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedListenersArr.length;
                                vm.selectedListenerObj = null;
                                vm.selectedListenersArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetListeners = function (inputObj) {
                    ListenerFactory.getListeners(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.listeners;
                            vm.listenersArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                    $stateParams.openCreateView === true)) {
                                vm.fnShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var listenerData = _.find(vm.listenersArr,{"id":$stateParams.selectedId});
                                if(listenerData){
                                    vm.fnGetListener(listenerData, vm.listenersArr);
                                }
                            }
                            if(addedListenerId.length) {
                                vm.fnOpenPostCreateActionModal(addedListenerId);
                                addedListenerId = '';
                            }
                            if($state.current.name === 'main.listeners') {
                                $state.go('main.listeners', {page: vm.currentPage, perPage: vm.perPage, openCreateView: ''}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }

                            vm.isListenersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isListenersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.listeners', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isListenersLoading = true;
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetListeners(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.listenerSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "listenerSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.listenerSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnListenersSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('listenerSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('listenerSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('listenerSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCreateFromBluePrint, isCalledForOpen) {
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if(isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (isCreateFromBluePrint) {
                        vm.isCreateFromBluePrint = !vm.isCreateFromBluePrint;
                    }
                };

                vm.fnShowCreateForm = function (isCalledFromBluePrint) {
                    vm.selectedListenersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCalledFromBluePrint) {
                        vm.isCreateFromBluePrint = true;
                    } else {
                        vm.isCreateFromBluePrint = false;
                    }
                };

                vm.fnGoToListenersWorkflow = function (listenerObj) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": 0,
                        "name": "",
                        "selectedField": "id",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": ""
                    };

                    if(listenerObj.workflowIds){
                        angular.forEach(listenerObj.workflowIds, function (workflowId, index) {
                            inputObj.id = Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0;
                            inputObj.searchText = workflowId;
                            if(index === 0) {
                                inputObj.name = "id is equal to: " + workflowId;
                                if(inputObj.selectedConnector) {
                                    delete inputObj.selectedConnector;
                                }
                            } else {
                                inputObj.name = "or id is equal to: " + workflowId;
                                inputObj.selectedConnector = "or";
                            }
                            tagsArr.push(angular.copy(inputObj));
                        });
                        $state.go("main.workflows", {filter: angular.toJson(tagsArr)});
                    }
                };

                $scope.$on("ListenerDeleted", function (evt, data) {
                    vm.selectedListenerObj = null;
                    vm.selectedListenersArr = [];
                    vm.listenersArr = vm.listenersArr.filter(function (listenerObj) {
                        return (listenerObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.listeners', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("ListenerDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.listenersArr, function (listenerObj) {
                        if (listenerObj.id === vm.selectedListenerObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedListenerObj[key] = val;
                                listenerObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("listenerAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedListenerId = '';
                    } else {
                        if (vm.permissionObj.List) {
                            addedListenerId = data;
                        } else {
                            addedListenerId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnInitListeners = function () {
                    vm.permissionObj = PermissionsService.getPermissions("pipeline:listener");
                    var sortData = FedSudoUserService.fnGetUserData('listenerSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var optionsArr = [{
                        faIcon: "fa-cubes",
                        subOptions: [{
                            displayText: "Add an existing Workflow",
                            isRedirect: false,
                            selectedTab: 2,
                            isVisible: vm.permissionObj.List &&
                            PermissionsService.getPermissions('pipeline:workflow').List
                        }, {
                            displayText: "Create a new Workflow",
                            isRedirect: true,
                            stateName: "main.createWorkFlow",
                            isVisible: PermissionsService.getPermissions('pipeline:workflow').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if(subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if(optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj)
                        }
                    });
                    if(finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if(selectedOption.isRedirect) {
                                if(selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else {
                                var listenerData = _.find(vm.listenersArr,{"id": selectedId});
                                if(listenerData){
                                    $state.go('main.listeners', {selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnGetListener(listenerData, vm.listenersArr);
                                } else {
                                    var tempArr = [
                                        {
                                            id: Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0,
                                            name: "Keyword: " + selectedId,
                                            searchText: selectedId
                                        }
                                    ];
                                    $state.go('main.listeners', {filter: angular.toJson(tempArr),
                                        selectedId: selectedId,
                                        selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.filter = angular.toJson(tempArr);
                                    $stateParams.selectedId = selectedId;
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnReload();
                                }
                            }
                        }, function () {});
                    }
                };

                var listenerKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.listeners') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(false, true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedListenersArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleListeners(vm.selectedListenersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var listenerKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.listeners') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', listenerKeyDownEventHandler);
                document.addEventListener('keyup', listenerKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', listenerKeyDownEventHandler);
                    document.removeEventListener('keyup', listenerKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('VisualizerCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, BatchFactory, PaginationService, FedSudoUserService, UserFactory, VisualizerFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    68: false, //d
                    86: false, //v
                    71: false, //g
                    72: false //h
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "Icon",
                        fieldName: "icon"
                    }
                ];
                vm.filterQuery = "";

                //Visualizer Variables
                vm.isVisualizersLoading = false;
                vm.visualizersArr = [];
                vm.selectedVisualizersArr = [];
                vm.selectedVisualizerObj = {};
                vm.isTabsLoading = null;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditVisualizerObj = {};

                vm.visualizerContextMenu = function (visualizerObj) {
                    if (Object.keys(vm.resetEditVisualizerObj).length) {
                        var isFindVisualizer = _.find(vm.visualizersArr, {id: vm.resetEditVisualizerObj.id});
                        if (isFindVisualizer) {
                            vm.fnCancelVisualizerEditMode(isFindVisualizer);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            visualizerObj.isEditable = true;
                            vm.resetEditVisualizerObj = angular.copy(visualizerObj);
                        }
                    }]
                };

                vm.fnCancelVisualizerEditMode = function (visualizerObj, isSuccessCall) {
                    if (isSuccessCall) {
                        visualizerObj.name = angular.copy(visualizerObj.name);
                        visualizerObj.description = angular.copy(visualizerObj.description);
                        visualizerObj.isEditable = false;
                        vm.resetEditVisualizerObj = {};
                    } else {
                        visualizerObj.name = angular.copy(vm.resetEditVisualizerObj.name);
                        visualizerObj.description = angular.copy(vm.resetEditVisualizerObj.description);
                        visualizerObj.isEditable = false;
                        vm.resetEditVisualizerObj = {};
                    }
                };

                vm.fnSaveVisualizerInfo = function (visualizerObj) {
                    visualizerObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        visualizerId: visualizerObj.id
                    };
                    inputObj.body = {
                        name: visualizerObj.name,
                        description: angular.isUndefined(visualizerObj.description)?'':visualizerObj.description
                    };
                    VisualizerFactory.modifyVisualizer(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.visualizersArr, function (visualizerObj) {
                                if (Object.keys(vm.selectedVisualizerObj).length) {
                                    if (visualizerObj.id === vm.selectedVisualizerObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedVisualizerObj[key] = val;
                                            visualizerObj[key] = val;
                                        });
                                    }
                                }
                                if (visualizerObj.id === resetCopy.id) {
                                    visualizerObj.name = resetCopy.name;
                                    visualizerObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelVisualizerEditMode(visualizerObj, true);
                            amaran.success("Visualizer Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelVisualizerEditMode(visualizerObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isVisualizersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isVisualizersLoading = true;
                    vm.selectedVisualizersArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetVisualizers(inputObj);
                    } else {
                        vm.visualizersArr = [];
                        vm.isVisualizersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);
                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };
                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.visualizersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedVisualizersArr = angular.copy(vm.visualizersArr);
                    } else {
                        vm.selectedVisualizersArr = [];
                    }
                    $state.go('main.visualizer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.visualizer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isVisualizersLoading = true;
                    vm.selectedVisualizersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetVisualizers(vm.inputObj);
                };

                vm.fnGetVisualizer = function (visualizerObj, visualizersArr) {
                    angular.forEach(visualizersArr, function (visualizer) {
                        visualizer.isCheck = false;
                    });
                    visualizerObj.isCheck = true;
                    vm.selectedVisualizersArr = [visualizerObj]; // Assign array with single Group object
                    vm.fnGetVisualizerDetails(visualizerObj);
                };

                vm.fnGetVisualizerDetails = function (visualizerObj) {
                    vm.isVisualizerDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when group is selected
                        vm.selectedVisualizerObj = visualizerObj;
                        $state.go('main.visualizer', {selectedId: vm.selectedVisualizerObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedVisualizerObj.id;
                        vm.isVisualizerDetailsLoaded = true;
                    });
                };

                vm.fnCheckUncheckHeader = function (visualizerObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.visualizersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === visualizerObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    var isValueFind = _.find(vm.selectedVisualizersArr, {'id': visualizerObj.id});
                    if (!isValueFind) {
                        vm.selectedVisualizersArr.push(visualizerObj)
                    } else {
                        _.remove(vm.selectedVisualizersArr, function (obj) {
                            return visualizerObj.id === obj.id;
                        });
                    }
                    if (vm.selectedVisualizersArr.length === 1) {
                        vm.fnGetVisualizerDetails(vm.selectedVisualizersArr[0])
                    }else {
                        $state.go('main.visualizer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleVisualizers = function (selectedVisualizersArr) {
                    var count = 1;
                    swal({
                            title: "Delete the selected visualizers?",
                            text: "You are about to permanently delete the selected visualizers.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedVisualizersArr, function (selectedVisualizer) {
                                    var inputObj = {
                                        visualizerId: selectedVisualizer.id
                                    };
                                    VisualizerFactory.deleteVisualizer(inputObj)
                                        .then(function () {
                                            if (count === selectedVisualizersArr.length) {
                                                angular.forEach(vm.selectedVisualizersArr, function (selectedVisualizer) {
                                                    angular.forEach(vm.visualizersArr, function (visualizerObj, index) {
                                                        if (selectedVisualizer.id === visualizerObj.id) {
                                                            vm.visualizersArr.splice(index, 1);
                                                        }
                                                    });
                                                });
                                                vm.totalItems = vm.totalItems - vm.selectedVisualizersArr.length;
                                                vm.selectedVisualizerObj = null;
                                                vm.selectedVisualizersArr = [];
                                                swal({
                                                    title: postActionModelMessage,
                                                    html: true,
                                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'customSwalActionModel'
                                                });
                                                angular.element(".microSpinner").remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                $timeout(function () {
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    swal.close();
                                                },1000);
                                                vm.fnReload();
                                            } else {
                                                count++;
                                            }
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                            angular.element('.microSpinner').remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        });
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetVisualizers = function (inputObj) {
                    VisualizerFactory.getVisualizers(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.visualizers;
                            vm.visualizersArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var visualizerData = _.find(vm.visualizersArr,{"id":$stateParams.selectedId});
                                if(visualizerData){
                                    vm.fnGetVisualizer(visualizerData, vm.visualizersArr);
                                }
                            }
                            if ($state.current.name === 'main.visualizer') {
                                $state.go('main.visualizer', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isVisualizersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isVisualizersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.visualizerSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "visualizerSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.visualizerSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnVisualizerSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('visualizerSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('visualizerSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('visualizerSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnGoToVisualization = function (type) {
                    if (type === 'Device') {
                        $state.go('main.createDeviceGatewayVisualizer', {
                            type: 'Device'
                        });
                    }
                    if (type === 'Gateway') {
                        $state.go('main.createDeviceGatewayVisualizer', {
                            type: 'Gateway'
                        });
                    }
                    if (type === 'Ghost') {
                        $state.go("main.createVisualizer");
                    }
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };
                $scope.$on("VisualizerDeleted", function (evt, data) {
                    vm.selectedVisualizerObj = null;
                    vm.selectedVisualizersArr = [];
                    vm.visualizersArr = vm.visualizersArr.filter(function (visualizerObj) {
                        return (visualizerObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.visualizer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                vm.fnInitVisualizer = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:visualizer");
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    var sortData = FedSudoUserService.fnGetUserData('visualizerSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var visualizerKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.visualizer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[86] && vm.permissionObj.Create && vm.devicePermissionObj.List &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnGoToVisualization('Device');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[86] = false;
                            } else if (codeset[38] && codeset[71] && vm.permissionObj.Create && vm.gatewayPermissionObj.List &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnGoToVisualization('Gateway');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[71] = false;
                            } else if (codeset[38] && codeset[72] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnGoToVisualization('Ghost');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[72] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedVisualizersArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleVisualizers(vm.selectedVisualizersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var visualizerKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.visualizer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', visualizerKeyDownEventHandler);
                document.addEventListener('keyup', visualizerKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', visualizerKeyDownEventHandler);
                    document.removeEventListener('keyup', visualizerKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('SoftwareCtrl',
            function ($scope, $window, $timeout, $stateParams, $log, d3, ApiListService, panzoom, $state, $uibModal,
                      amaran, swal, $base64, moment, microSpinner, PaginationQueryService, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, PermissionsService,
                      jsonToCsvConvertService, FedSudoUserService, BatchFactory, PaginationService, SoftwareFactory,
                      postActionModelIcon, postActionModelMessage, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Architecture",
                        name: "architecture",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Latest",
                        name: "latest",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'latest\' = \'true\'',
                        localSearchValue: 'obj.latest === true'
                    }, {
                        displayName: "Version",
                        name: "version",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'architecture', displayName: 'Architecture'},
                    {name: 'id', displayName: 'Id'},
                    {name: 'latest', displayName: 'Latest'},
                    {name: 'version', displayName: 'Version'},
                    {name: 'createdAt', displayName: 'created'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Softwares Variables
                vm.isSoftwaresLoading = false;
                vm.softwaresArr = [];
                vm.selectedSoftwaresArr = [];
                vm.selectedSoftwareObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.softwareResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowSoftwareStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                function parsePostgresData(items) {
                    $log.debug('Raw items:', items);

                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map core fields needed by UI
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.architecture = parsedData.architecture;
                                parsedItem.version = parsedData.version;
                                parsedItem.description = parsedData.description;
                                parsedItem.checksum = parsedData.checksum;
                                parsedItem.latest = parsedData.latest === true || parsedData.latest === 'true';

                                // Handle timestamps with both camelCase and snake_case
                                parsedItem.createdAt = parsedItem.createdAt ||
                                    parsedData.createdAt ||
                                    parsedItem.created_at ||
                                    parsedData.created_at;
                                parsedItem.created_at = parsedItem.createdAt;

                                parsedItem.updatedAt = parsedItem.updatedAt ||
                                    parsedData.updatedAt ||
                                    parsedItem.updated_at ||
                                    parsedData.updated_at;
                                parsedItem.updated_at = parsedItem.updatedAt;

                                // Handle totalItems count for pagination
                                parsedItem.totalItems = parseInt(item.totalitems || item.totalItems || 0);

                                $log.debug('Parsed software item:', parsedItem);
                            } catch (e) {
                                $log.error('Error parsing software data:', e);
                            }
                        }
                        return parsedItem;
                    });
                }
                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'software', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isSoftwaresLoading = true;
                    vm.selectedSoftwaresArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ecu_softwares';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ecu_softwares';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetSoftwares(input, true);
                };

                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.softwaresArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedSoftwaresArr = [];
                                vm.selectedSoftwareObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.software', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Software";
                        vm.isShowSoftwareStats = tab.id === "softwareStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Software";
                    vm.isShowSoftwareStats = tab.id === "softwareStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Software" || tab.id === "Create Issue" || tab.id === "softwareStats" || tab.id === "WidgetEditor") {
                        $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Software") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.software', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#softwareTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (softwareObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.softwaresArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === softwareObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected software array*/
                    var isValueFind = _.find(vm.selectedSoftwaresArr, {'id': softwareObj.id});
                    if (!isValueFind) {
                        vm.selectedSoftwaresArr.push(softwareObj);
                        var isTabExist = _.find(vm.tabs, {'id': softwareObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: softwareObj.id,
                                title: "V" + softwareObj.version + " " + softwareObj.architecture,
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedSoftwaresArr, function (obj) {
                            return softwareObj.id === obj.id;
                        });
                    }
                    if (vm.selectedSoftwaresArr.length === 1) {
                        vm.fnGetSoftwareDetails(vm.selectedSoftwaresArr[0])
                    } else {
                        $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.softwaresArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedSoftwaresArr = angular.copy(vm.softwaresArr);
                    } else {
                        vm.selectedSoftwaresArr = [];
                    }
                    $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (softwareObj) {
                    var isFindIndex = _.findIndex(vm.selectedSoftwaresArr, {id: softwareObj});
                    if (softwareObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedSoftwaresArr.push(softwareObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedSoftwaresArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedSoftwaresArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Software'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Software',
                                title: 'Create Software',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isSoftwaresLoading = true;
                    vm.selectedSoftwaresArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM ecu_softwares';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM ecu_softwares';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM ecu_softwares';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ecu_softwares';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetSoftwares(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.softwaresArr);
                        vm.previousPage = page;
                        vm.fnGetSoftwares(input, false);
                    }
                };

                vm.fnOpenSoftwareInfoTab = function (softwareObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(softwareObj);
                };

                vm.fnGetSoftware = function (softwareObj, softwaresArr) {
                    angular.forEach(softwaresArr, function (software) {
                        software.isCheck = false;
                    });
                    softwareObj.isCheck = true;
                    vm.selectedSoftwaresArr = [softwareObj]; // Assign array with single Software object
                    vm.fnGetSoftwareDetails(softwareObj);
                };

                vm.fnGetSoftwareDetails = function (softwareObj) {
                    vm.isSoftwareDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when software is selected
                        vm.selectedSoftwareObj = softwareObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.software', {
                                selectedId: vm.selectedSoftwareObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedSoftwareObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isSoftwareDetailsLoaded = true;
                        } else {
                            $state.go('main.software', {selectedId: vm.selectedSoftwareObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedSoftwareObj.id;
                            vm.isSoftwareDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetSoftwares = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var parsedData = parsePostgresData(res.data);
                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                            });
                            vm.softwareResponse = _.cloneDeepWith({ data: parsedData });
                            if (isFirst) {
                                if (vm.softwareResponse.data && vm.softwareResponse.data.length) {
                                    vm.totalItems = vm.softwareResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.softwareResponse.data.reverse();
                            }
                            vm.softwaresArr = vm.softwareResponse.data;
                            if ($stateParams.selectedId) {
                                var softwareData = _.find(vm.softwaresArr, {"id": $stateParams.selectedId});
                                if (softwareData) {
                                    vm.fnCheckUncheckHeader(softwareData)
                                }
                            }
                            if ($state.current.name === 'main.software') {
                                $state.go('main.software', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isSoftwaresLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isSoftwaresLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("SoftwareDeleted", function (evt, data) {
                    vm.selectedSoftwareObj = null;
                    vm.selectedSoftwaresArr = [];
                    vm.softwaresArr = vm.softwaresArr.filter(function (softwareObj) {
                        return (softwareObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("SoftwareDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.softwaresArr, function (softwareObj) {
                        if (softwareObj.id === vm.selectedSoftwareObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedSoftwareObj[key] = val;
                                softwareObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("softwareAdded", function () {
                    vm.fnRemoveTab('Create Software');
                });

                $scope.$on("SoftwareDeleted", function (evt, data) {
                    vm.selectedSoftwareObj = null;
                    vm.selectedSoftwaresArr = [];
                    vm.softwaresArr = vm.softwaresArr.filter(function (softwareObj) {
                        return (softwareObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.software', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                vm.fnDeleteMultipleSoftwares = function (selectedSoftwaresArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedSoftwaresArr, function (selectedSoftware, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/ecu-softwares/" + selectedSoftware.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/ecu-softwares/" + selectedSoftware.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Softwares?",
                            text: "You are about to permanently delete the selected softwares.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedSoftwaresArr, function (selectedSoftware) {
                                    angular.forEach(vm.softwaresArr, function (softwareObj, index) {
                                        if (selectedSoftware.id === softwareObj.id) {
                                            vm.softwaresArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedSoftwaresArr.length;
                                vm.selectedSoftwareObj = null;
                                vm.selectedSoftwaresArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedSoftwaresArr, function (selectedSoftware) {
                                    angular.forEach(vm.softwaresArr, function (softwareObj, index) {
                                        if (selectedSoftware.id === softwareObj.id) {
                                            vm.softwaresArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedSoftwaresArr.length;
                                vm.selectedSoftwareObj = null;
                                vm.selectedSoftwaresArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'software', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.software", tempArr, {notify: false});
                    }
                };

                vm.fnInitSoftwares = function () {
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'software', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetSoftwareDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetSoftwareStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'softwareStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowSoftwareStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'softwareStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowSoftwareStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getSoftwareCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.softwaresArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.softwaresArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Softwares");
                    XLSX.writeFile(wb, "softwares.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'software', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenBroadcastSoftware = function (softwareObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/software/modals/softwareBroadcast/softwareBroadcast.html',
                        size: 'lg',
                        controller: 'softwareBroadcastCtrl as softwareBroadcast',
                        windowClass: 'modal-height100',
                        resolve: {
                            softwareObj: function () {
                                return _.cloneDeepWith(softwareObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (data) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/node/software/modals/softwareJobTerminal/softwareJobTerminal.html',
                            size: 'lg',
                            controller: 'softwareJobTerminalCtrl as softwareJob',
                            windowClass: 'modal-height100',
                            resolve: {
                                jobsArr: function () {
                                    return _.cloneDeepWith(data);
                                }
                            }
                        });
                        modalInstance.result.then(function () {

                        }, function () {
                        });
                    }, function () {
                    });
                };

                vm.fnMakeLatest = function (softwareObj) {
                    var input = {
                        softwareId: softwareObj.id
                    };
                    SoftwareFactory.makeECUSoftwareLatest(input)
                        .then(function (res) { // Success block
                            softwareObj.latest = res.latest;
                            amaran.success("Software updated successfully");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnActivatesSoftware = function (softwareObj) {
                    var input = {
                        softwareId: softwareObj.id
                    };
                    SoftwareFactory.activateNewECUSoftwareUploaded(input)
                        .then(function (res) { // Success block
                            softwareObj.latest = res.latest;
                            amaran.success("Software activated successfully");
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeSoftwareChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var softwareKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.software') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedSoftwaresArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleSoftwares(vm.selectedSoftwaresArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var softwareKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.software') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', softwareKeyDownEventHandler);
                document.addEventListener('keyup', softwareKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', softwareKeyDownEventHandler);
                    document.removeEventListener('keyup', softwareKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeScriptsCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      WidgetsListService, NodeScriptFactory, PermissionsService) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowScriptStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 's4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.node_scripts') {
                        $timeout(function () {
                            $state.go('main.node_scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.node_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.node_scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.node_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionObj.LIST_SCRIPT_TYPES) {
                        NodeScriptFactory.listScriptTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    var name = '';
                                    if(obj.includes('ecu') || obj.includes('vpn') || obj.includes('ntp')) {
                                        var o = obj.split('_');
                                        name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                                    } else {
                                        name = toUpper(obj.replace(/_/g, " "));
                                    }
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: name
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.node_scripts') {
                                    $state.go('main.node_scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                        } else {
                            $state.go('main.node_scripts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowScriptStats = tab.id === "ScriptStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowScriptStats = tab.id === "ScriptStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard"  || tab.id === "Create Issue" || tab.id === "ScriptStats" || tab.id === "WidgetEditor") {
                        $state.go('main.node_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 's4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ScriptStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowScriptStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ScriptStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowScriptStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 's4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 's4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeS4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectScriptsCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      WidgetsListService, NodeScriptFactory, PermissionsService) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowScriptStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;
                vm.selectedProjectName = "";

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    if ($stateParams.name) {
                        vm.selectedProjectName = $stateParams.name;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'projectS4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.node_project_scripts') {
                        $timeout(function () {
                            $state.go('main.node_project_scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.node_project_scripts', {
                                selectedId: '',
                                selectedDetailsTab: ''
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_project_scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.node_project_scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.node_project_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionObj.LIST_PROJECT_SCRIPT_TYPES) {
                        NodeScriptFactory.listProjectScriptTypes({projectId: $stateParams.selectedProject})
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    var name = '';
                                    if(obj.includes('ecu') || obj.includes('vpn') || obj.includes('ntp')) {
                                        var o = obj.split('_');
                                        name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                                    } else {
                                        name = toUpper(obj.replace(/_/g, " "));
                                    }
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: name
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.node_project_scripts') {
                                    $state.go('main.node_project_scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                        } else {
                            $state.go('main.node_project_scripts', {
                                selectedId: "",
                                selectedDetailsTab: ""
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowScriptStats = tab.id === "ScriptStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowScriptStats = tab.id === "ScriptStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "ScriptStats" || tab.id === "WidgetEditor") {
                        $state.go('main.node_project_scripts', {
                            selectedId: '',
                            selectedDetailsTab: ''
                        }, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_project_scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'projectS4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ScriptStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowScriptStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ScriptStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowScriptStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'projectS4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_project_scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'projectS4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeProjectS4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectEmailTemplateCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      UserProfileService, LastPageService, PaginationService, amaran, swal,
                      microSpinner, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      PermissionsService, WidgetsListService, NodeEmailTemplateFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowEmailTemplateStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.selectedProjectName = "";

                //EmailTemplates Variables
                vm.isEmailTemplatesloading = false;
                vm.emailTemplateArr = [];
                vm.selectedEmailTemplatesArr = [];
                vm.selectedEmailTemplateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.emailTemplateResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    if ($stateParams.name) {
                        vm.selectedProjectName = $stateParams.name;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'projectEmailTemplate', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterEmailTemplateArr = [];
                    var emailTemplateArr = [];
                    if (vm.emailTemplateResponse.length) {
                        if (vm.filterQuery) {
                            filterEmailTemplateArr = _.filter(vm.emailTemplateResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterEmailTemplateArr = _.cloneDeepWith(vm.emailTemplateResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            emailTemplateArr = _.orderBy(filterEmailTemplateArr, [sortValue], [sortType]);
                        } else {
                            emailTemplateArr = _.cloneDeepWith(filterEmailTemplateArr);
                        }
                    }
                    vm.totalItems = emailTemplateArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.emailTemplateArr = emailTemplateArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.node_project_emailTemplate') {
                        $timeout(function () {
                            $state.go('main.node_project_emailTemplate', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isEmailTemplatesloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#emailTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (emailTemplateObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT_EMAIL_TEMPLATE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.emailTemplateArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === emailTemplateObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedEmailTemplatesArr, {'id': emailTemplateObj.id});
                        if (!isValueFind) {
                            vm.selectedEmailTemplatesArr.push(emailTemplateObj);
                            var isTabExist = _.find(vm.tabs, {'id': emailTemplateObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: emailTemplateObj.id,
                                    title: emailTemplateObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEmailTemplatesArr, function (obj) {
                                return emailTemplateObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEmailTemplatesArr.length === 1) {
                            vm.fnGetEmailTemplateDetails(vm.selectedEmailTemplatesArr[0])
                        } else {
                            $state.go('main.node_project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetEmailTemplateDetails = function (userObj) {
                    vm.isEmailTemplateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedEmailTemplateObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_project_emailTemplate', {
                                selectedId: vm.selectedEmailTemplateObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEmailTemplateDetailsLoaded = true;
                        } else {
                            $state.go('main.node_project_emailTemplate', {selectedId: vm.selectedEmailTemplateObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            vm.isEmailTemplateDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.emailTemplateArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEmailTemplatesArr = _.cloneDeepWith(vm.emailTemplateArr);
                    } else {
                        vm.selectedEmailTemplatesArr = [];
                    }
                    $state.go('main.node_project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        emailTemplateId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetEmailTemplate = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedEmailTemplatesArr = [tokenObj]; // Assign array with single token object
                    vm.selectedEmailTemplateObj = tokenObj;
                };

                vm.fnGetEmailTemplates = function () {
                    if (vm.permissionObj.LIST_PROJECT_EMAIL_TEMPLATE_TYPES) {
                        NodeEmailTemplateFactory.listProjectEmailTemplateTypes({projectId: $stateParams.selectedProject})
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    var name = '';
                                    if(obj.includes('ecu') || obj.includes('vpn') || obj.includes('ntp')) {
                                        var o = obj.split('_');
                                        name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                                    } else {
                                        name = toUpper(obj.replace(/_/g, " "));
                                    }
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: name
                                    })
                                });
                                vm.emailTemplateResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var emailTemplateData = _.find(vm.emailTemplateArr, {"id": $stateParams.selectedId});
                                    if (emailTemplateData) {
                                        vm.fnCheckUncheckHeader(emailTemplateData);
                                    }
                                }
                                if ($state.current.name === 'main.node_project_emailTemplate') {
                                    $state.go('main.node_project_emailTemplate', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.emailTemplateResponse = [];
                        vm.fnGetFilterData();
                        vm.isEmailTemplatesloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindEmailTemplate = _.find(vm.emailTemplateArr, {id: tab.id});
                            if (isFindEmailTemplate) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEmailTemplatesArr = [];
                                vm.selectedEmailTemplateObj = {};
                                vm.fnCheckUncheckHeader(isFindEmailTemplate);
                            }
                        } else {
                            $state.go('main.node_project_emailTemplate', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "EmailTemplateStats" || tab.id === "WidgetEditor") {
                        $state.go('main.node_project_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_project_emailTemplate', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    //UserProfileService.fnUpdateUserProfileObj('node', 'projectEmailTemplate', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'EmailTemplateStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEmailTemplateStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'EmailTemplateStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEmailTemplateStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'projectEmailTemplate', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_project_emailTemplate", tempArr, {notify: false});
                    }
                };

                vm.fnInitEmailTemplate = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'projectEmailTemplate', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function(type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeProjectEmailTemplateChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeProjectCtrl',
            function ($scope, $window, $timeout, $stateParams, d3, panzoom, $state, $uibModal,
                      AppInitService, amaran, swal, $base64, moment, microSpinner, PaginationQueryService, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, PermissionsService,
                      jsonToCsvConvertService, FedSudoUserService, BatchFactory, PaginationService, ProjectFactory,
                      postActionModelIcon, postActionModelMessage, QueryFactory, nodeProjectArr, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Projects Variables
                vm.isProjectsLoading = false;
                vm.projectsArr = [];
                vm.selectedProjectsArr = [];
                vm.selectedProjectObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.projectResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowProjectStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditProjectObj = {};

                vm.projectContextMenu = function (projectObj) {
                    if (Object.keys(vm.resetEditProjectObj).length) {
                        var isFindProject = _.find(vm.projectsArr, {id: vm.resetEditProjectObj.id});
                        if (isFindProject) {
                            vm.fnCancelProjectEditMode(isFindProject);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            projectObj.isEditable = true;
                            vm.resetEditProjectObj = angular.copy(projectObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core project fields
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',

                                // Additional project-specific fields
                                accountId: parsedData.accountId || '',
                                parentProjectId: parsedData.parentProjectId || '',
                                teamIds: parsedData.teamIds || [],

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnCancelProjectEditMode = function (projectObj, isSuccessCall) {
                    if (isSuccessCall) {
                        projectObj.name = angular.copy(projectObj.name);
                        projectObj.description = angular.copy(projectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    } else {
                        projectObj.name = angular.copy(vm.resetEditProjectObj.name);
                        projectObj.description = angular.copy(vm.resetEditProjectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    }
                };

                vm.fnSaveProjectInfo = function (projectObj) {
                    projectObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    inputObj.body = {
                        name: projectObj.name,
                        description: angular.isUndefined(projectObj.description) ? '' : projectObj.description
                    };
                    ProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.projectsArr, function (projectObj) {
                                if (Object.keys(vm.selectedProjectObj).length) {
                                    if (projectObj.id === vm.selectedProjectObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedProjectObj[key] = val;
                                            projectObj[key] = val;
                                        });
                                    }
                                }
                                if (projectObj.id === resetCopy.id) {
                                    projectObj.name = resetCopy.name;
                                    projectObj.description = resetCopy.description;
                                }
                            });
                            var projectArr = AppInitService.getInitData('nodeProjectsArr');
                            var index = _.findIndex(projectArr, {id: response.id});
                            if (index !== -1) {
                                projectArr[index].name = response.name;
                                projectArr[index].description = response.description;
                                AppInitService.fnUpdateNodeProjectData(projectArr);
                            }
                            vm.fnCancelProjectEditMode(projectObj, true);
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            vm.fnCancelProjectEditMode(projectObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'project', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetProjects(input, true);
                };

                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.projectsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedProjectsArr = [];
                                vm.selectedProjectObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.node_project', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Project";
                        vm.isShowProjectStats = tab.id === "projectStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Project";
                    vm.isShowProjectStats = tab.id === "projectStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Project" || tab.id === "Create Issue" || tab.id === "projectStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.node_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Project") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_project', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#projectTable").css('height', finalHeight + 'px');
                    }
                    if (vm.isShowRelationships === true) {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    }
                };

                vm.fnCheckUncheckHeader = function (projectObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.projectsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === projectObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected project array*/
                        var isValueFind = _.find(vm.selectedProjectsArr, {'id': projectObj.id});
                        if (!isValueFind) {
                            vm.selectedProjectsArr.push(projectObj);
                            var isTabExist = _.find(vm.tabs, {'id': projectObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: projectObj.id,
                                    title: projectObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedProjectsArr, function (obj) {
                                return projectObj.id === obj.id;
                            });
                        }
                        if (vm.selectedProjectsArr.length === 1) {
                            vm.fnGetProjectDetails(vm.selectedProjectsArr[0])
                        } else {
                            $state.go('main.node_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.projectsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedProjectsArr = angular.copy(vm.projectsArr);
                    } else {
                        vm.selectedProjectsArr = [];
                    }
                    $state.go('main.node_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Project'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Project',
                                title: 'Create Project',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.node_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_projects';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetProjects(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.projectsArr);
                        vm.previousPage = page;
                        vm.fnGetProjects(input, false);
                    }
                };

                vm.fnOpenProjectInfoTab = function (projectObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(projectObj);
                };

                vm.fnGetProject = function (projectObj, projectsArr) {
                    angular.forEach(projectsArr, function (project) {
                        project.isCheck = false;
                    });
                    projectObj.isCheck = true;
                    vm.selectedProjectsArr = [projectObj]; // Assign array with single Project object
                    vm.fnGetProjectDetails(projectObj);
                };

                vm.fnGetProjectDetails = function (projectObj) {
                    vm.isProjectDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when project is selected
                        vm.selectedProjectObj = projectObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_project', {
                                selectedId: vm.selectedProjectObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isProjectDetailsLoaded = true;
                        } else {
                            $state.go('main.node_project', {selectedId: vm.selectedProjectObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            vm.isProjectDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetProjects = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            res.data = vm.parsePostgresData(res.data);

                            vm.projectResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.projectResponse.data && vm.projectResponse.data.length) {
                                    vm.totalItems = vm.projectResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.projectResponse.data.reverse();
                            }
                            vm.projectsArr = vm.projectResponse.data;
                            // Set projects again in localstorage if they are reloaded
                            if(vm.isRefresh && !DB.fnGet('federation') && !DB.fnGet('support')) {
                                localStorage.setItem(nodeProjectArr, $base64.encode(angular.toJson(vm.projectsArr)));
                            }
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetProject(res[0], vm.projectsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var projectData = _.find(vm.projectsArr, {"id": $stateParams.selectedId});
                                if (projectData) {
                                    vm.fnCheckUncheckHeader(projectData)
                                }
                            }
                            if ($state.current.name === 'main.node_project') {
                                $state.go('main.node_project', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isProjectsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("ProjectDeleted", function (evt, data) {
                    vm.selectedProjectObj = null;
                    vm.selectedProjectsArr = [];
                    vm.projectsArr = vm.projectsArr.filter(function (projectObj) {
                        return (projectObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.node_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("ProjectDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.projectsArr, function (projectObj) {
                        if (projectObj.id === vm.selectedProjectObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedProjectObj[key] = val;
                                projectObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("projectAdded", function () {
                    vm.fnRemoveTab('Create Project');
                });

                vm.fnDeleteMultipleProjects = function (selectedProjectsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedProjectsArr, function (selectedProject, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Projects?",
                            text: "You are about to permanently delete the selected projects.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'project', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_project", tempArr, {notify: false});
                    }
                };

                vm.fnInitProjects = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'project', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjectDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'projectStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowProjectStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'projectStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowProjectStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isProjectRelationshipsDataLoading = true;
                vm.fnInitProjectRelationships = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.isProjectRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.isProjectRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getProjectCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.projectsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.projectsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Projects");
                    XLSX.writeFile(wb, "projects.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'project', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeProjectChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var projectKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedProjectsArr.length > 1 &&
                                vm.permissionObj.DELETE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleProjects(vm.selectedProjectsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var projectKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectKeyDownEventHandler);
                document.addEventListener('keyup', projectKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectKeyDownEventHandler);
                    document.removeEventListener('keyup', projectKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ObserverCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, NodeEcuFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, ColorService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitEcu = true;

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Registered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'true\'',
                        localSearchValue: 'obj.registered === true'
                    }, {
                        displayName: "Unregistered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = false',
                        localSearchValue: 'obj.registered === false'
                    }, {
                        displayName: "Phase",
                        name: "phase",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->\'connected\' = \'false\' or data->\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                vm.ecuProjectFilter = "$";
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};

                //Ecus Variables
                vm.isEcusLoading = false;
                vm.ecusArr = [];
                vm.selectedEcusArr = [];
                vm.selectedEcuObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                vm.isRefresh = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.ecuResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowObserver = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditEcuObj = {};

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core ecu fields
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',

                                // Additional ecu-specific fields
                                serial: parsedData.serial || '',
                                productId: parsedData.productId || '',
                                projectId: parsedData.projectId || '',

                                // Status and connection fields
                                phase: parsedData.phase || '',
                                health: parsedData.health || 0,
                                connected: parsedData.connected || false,
                                registered: parsedData.registered || false,

                                // Configuration fields
                                ntp: parsedData.ntp || '',
                                vpn: parsedData.vpn || '',

                                // Lifecycle and sync fields
                                syncState: parsedData.syncState || '',
                                lifecycleState: parsedData.lifecycleState || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',
                                lastSeenAt: parseInt(parsedData.lastSeenAt) || 0,
                                registeredAt: parseInt(parsedData.registeredAt) || 0,

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            // Process last seen time
                            if (parsedItem.lastSeenAt && parsedItem.lastSeenAt !== 0) {
                                var lastSeenTimestamp = moment.unix(parsedItem.lastSeenAt);
                                var lastSeenDifferenceHours = currentTime.diff(lastSeenTimestamp, 'hours');
                                parsedItem.lastSeenDate = lastSeenDifferenceHours > 24
                                    ? lastSeenTimestamp.format("DD/MM/YYYY")
                                    : lastSeenTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'observer', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'observer', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.ecusArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEcusArr = [];
                                vm.selectedEcuObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.node_observer', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowObserver = tab.id === "observerStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowObserver = tab.id === "observerStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "observerStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor") {
                        $state.go('main.node_observer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedEcuObj = [];
                        vm.selectedEcuObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_observer', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (ecuObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ECU) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.ecusArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === ecuObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Ecu array*/
                        var isValueFind = _.find(vm.selectedEcusArr, {'id': ecuObj.id});
                        if (!isValueFind) {
                            vm.selectedEcusArr.push(ecuObj);
                            var isTabExist = _.find(vm.tabs, {'id': ecuObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: ecuObj.id,
                                    title: ecuObj.name,
                                    tabIndex: newTabIndex,
                                    projectName: ecuObj.project.name
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEcusArr, function (obj) {
                                return ecuObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEcusArr.length === 1) {
                            vm.fnGetEcuDetails(vm.selectedEcusArr[0])
                        } else {
                            $state.go('main.node_observer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.ecusArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEcusArr = angular.copy(vm.ecusArr);
                    } else {
                        vm.selectedEcusArr = [];
                    }
                    $state.go('main.node_observer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.node_observer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnOpenEcuInfoTab = function (ecuObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(ecuObj);
                };

                vm.fnGetEcu = function (ecuObj, ecusArr) {
                    angular.forEach(ecusArr, function (ecu) {
                        ecu.isCheck = false;
                    });
                    ecuObj.isCheck = true;
                    vm.selectedEcusArr = [ecuObj]; // Assign array with single ecu object
                    vm.fnGetEcuDetails(ecuObj);
                };

                vm.fnGetEcuDetails = function (ecuObj) {
                    vm.isEcuDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when ecu is selected
                        vm.selectedEcuObj = ecuObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_observer', {
                                selectedId: vm.selectedEcuObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEcuDetailsLoaded = true;
                        } else {
                            $state.go('main.node_observer', {selectedId: vm.selectedEcuObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            vm.isEcuDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            res.data = vm.parsePostgresData(res.data);

                            vm.ecuResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                    vm.totalItems = vm.ecuResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }
                            vm.ecusArr = vm.ecuResponse.data;

                            vm.ecusArr = vm.ecusArr.map(function(ecuObj) {
                                if (ecuObj.projectId) {
                                    ecuObj.project = _.find(vm.projectsArr, {id: ecuObj.projectId});
                                }
                                return ecuObj;
                            });

                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.ecusArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.node_observer') {
                                $state.go('main.node_observer', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnGetProjectEcu = function (projectObj) {
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + '\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + '\' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'observer', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'observer', 'selectedProject', '');
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitEcu = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnAddDefaultFilter = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'observer', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_observer", tempArr, {notify: false});
                    } else {
                        if (angular.isDefined($stateParams.filter)) {
                            var filterJson = angular.fromJson($stateParams.filter);
                            var isFind = _.find(filterJson, {selectedField: 'registered'});
                            if (!isFind) {
                                filterJson.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "registered",
                                    displaySelectedField: "Registered",
                                    selectedConnector: "and",
                                    searchText: '',
                                    displaySearchText: '',
                                    isDirectFilterApply: true,
                                    sqlValue: 'data->\'registered\' = \'true\'',
                                    localSearchValue: 'obj.registered === true'
                                });
                                $state.go("main.node_observer", {filter: angular.toJson(filterJson)}, {notify: false});
                                $stateParams.filter = angular.toJson(filterJson);
                            }
                        } else {
                            var inputObj = [{
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                selectedField: "registered",
                                displaySelectedField: "Registered",
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: 'data->\'registered\' = \'true\'',
                                localSearchValue: 'obj.registered === true'
                            }];
                            $state.go("main.node_observer", {filter: angular.toJson(inputObj)}, {notify: false});
                            $stateParams.filter = angular.toJson(inputObj);
                        }
                    }
                };

                vm.fnInitEcus = function () {
                    vm.fnAddDefaultFilter();
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'observer', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetEcuDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEcuStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'observerStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowObserver = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'observerStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowObserver = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getEcuCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.ecusArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.ecusArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Ecus");
                    XLSX.writeFile(wb, "Ecus.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'observer', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeObserverChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var observerKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_observer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && vm.selectedEcusArr.length > 1 && vm.permissionObj.DELETE_ECU &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleEcus(vm.selectedEcusArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var observerKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node_observer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', observerKeyDownEventHandler);
                document.addEventListener('keyup', observerKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', observerKeyDownEventHandler);
                    document.removeEventListener('keyup', observerKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NotificationCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, NotificationFactory, BatchFactory, UserFactory, postActionModelIcon, postActionModelMessage,IconService,ColorService) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "State",
                        fieldName: "state"
                    }
                ];
                vm.filterQuery = "";

                //Notifications Variables
                vm.isNotificationsLoading = false;
                vm.notificationsArr = [];
                vm.selectedNotificationsArr = [];
                vm.selectedNotificationObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.statesArr = [
                    "INACTIVE",
                    "ACTIVE"
                ];
                vm.resetEditNotificationObj = {};
                vm.isEditing = false;

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.notificationContextMenu = function (notificationObj) {
                    if (Object.keys(vm.resetEditNotificationObj).length) {
                        var isFindNotification = _.find(vm.notificationsArr, {id: vm.resetEditNotificationObj.id});
                        if (isFindNotification) {
                            vm.fnCancelNotificationEditMode(isFindNotification);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            notificationObj.isEditable = true;
                            vm.resetEditNotificationObj = angular.copy(notificationObj);
                        }
                    }]
                };

                vm.fnCancelNotificationEditMode = function (notificationObj, isSuccessCall) {
                    if (isSuccessCall) {
                        notificationObj.name = angular.copy(notificationObj.name);
                        notificationObj.description = angular.copy(notificationObj.description);
                        notificationObj.state = angular.copy(notificationObj.state);
                        notificationObj.isEditable = false;
                        vm.resetEditNotificationObj = {};
                    } else {
                        notificationObj.name = angular.copy(vm.resetEditNotificationObj.name);
                        notificationObj.description = angular.copy(vm.resetEditNotificationObj.description);
                        notificationObj.state = angular.copy(vm.resetEditNotificationObj.state);
                        notificationObj.isEditable = false;
                        vm.resetEditNotificationObj = {};
                    }
                };

                vm.fnSaveNotificationInfo = function (notificationObj) {
                    notificationObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        notificationId: notificationObj.id
                    };
                    inputObj.body = {
                        name: notificationObj.name,
                        description: angular.isUndefined(notificationObj.description)?'':notificationObj.description,
                        state: notificationObj.state
                    };
                    NotificationFactory.modifyNotification(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.notificationsArr, function (notificationObj) {
                                if (Object.keys(vm.selectedNotificationObj).length) {
                                    if (notificationObj.id === vm.selectedNotificationObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedNotificationObj[key] = val;
                                            notificationObj[key] = val;
                                        });
                                    }
                                }
                                if (notificationObj.id === resetCopy.id) {
                                    notificationObj.name = resetCopy.name;
                                    notificationObj.description = resetCopy.description;
                                    notificationObj.state = resetCopy.state;
                                }
                            });
                            vm.fnCancelNotificationEditMode(notificationObj, true);
                            amaran.success("Notification Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelNotificationEditMode(notificationObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                    vm.isSmallScreen = angular.element($window)[0].innerWidth <= 1600;
                });

                vm.fnGetNotificationStateIcon = function (state) {
                    return state === 'INACTIVE' ? IconService.fnGetStateIcon(state) + ' InactiveStateIcon' : IconService.fnGetStateIcon(state);
                };

                vm.getNotificationStateColor = function (state) {
                    return ColorService.getStateColor(state);
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isNotificationsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isNotificationsLoading = true;
                    vm.selectedNotificationsArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetNotifications(inputObj);
                    } else {
                        vm.notificationsArr = [];
                        vm.isNotificationsLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);
                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.notification', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isNotificationsLoading = true;
                    vm.selectedNotificationsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetNotifications(vm.inputObj);
                };

                vm.fnNotificationInfoTab = function (notificationObj,state) {
                    if(state === 'Edit'){
                        vm.isEditing = true;
                    }
                    vm.fnGetNotification(notificationObj, vm.notificationsArr);
                };

                vm.fnGetNotification = function (notificationObj, notificationsArr) {
                    angular.forEach(notificationsArr, function (notification) {
                        notification.isCheck = false;
                    });
                    notificationObj.isCheck = true;
                    vm.selectedNotificationsArr = [notificationObj]; // Assign array with single notification object
                    vm.fnGetNotificationDetails(notificationObj);
                };

                vm.fnGetNotificationDetails = function (notificationObj) {
                    vm.isNotificationDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when notification is selected
                        vm.selectedNotificationObj = notificationObj;
                        if( vm.isEditing === true){
                            $state.go('main.notification', {selectedId: vm.selectedNotificationObj.id, openEditView: 'true'}, {notify: false});
                            $stateParams.selectedId = vm.selectedNotificationObj.id;
                            $stateParams.openEditView = true;
                            vm.isNotificationDetailsLoaded = true;
                            vm.isEditing = false;
                        }else {
                            $state.go('main.notification', {selectedId: vm.selectedNotificationObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedNotificationObj.id;
                            vm.isNotificationDetailsLoaded = true;
                        }
                    });
                };

                vm.fnGetNotifications = function (inputObj) {
                    NotificationFactory.getNotifications(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.notifications;
                            vm.notificationsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var notificationData = _.find(vm.notificationsArr, {"id": $stateParams.selectedId});
                                if (notificationData) {
                                    vm.fnGetNotification(notificationData, vm.notificationsArr);
                                }
                            }
                            if ($state.current.name === 'main.notification') {
                                $state.go('main.notification', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isNotificationsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNotificationsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.notificationSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "notificationSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.notificationSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnNotificationSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    } else {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('notificationSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('notificationSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('notificationSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };

                vm.fnCheckUncheckHeader = function (notificationObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.notificationsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === notificationObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected notification array*/
                    var isValueFind = _.find(vm.selectedNotificationsArr, {'id': notificationObj.id});
                    if (!isValueFind) {
                        vm.selectedNotificationsArr.push(notificationObj)
                    } else {
                        _.remove(vm.selectedNotificationsArr, function (obj) {
                            return notificationObj.id === obj.id;
                        });
                    }
                    if (vm.selectedNotificationsArr.length === 1) {
                        vm.fnGetNotificationDetails(vm.selectedNotificationsArr[0])
                    } else {
                        $state.go('main.notification', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.notificationsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedNotificationsArr = angular.copy(vm.notificationsArr);
                    } else {
                        vm.selectedNotificationsArr = [];
                    }
                    $state.go('main.notification', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                /*END: TABLE*/
                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedNotificationsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnDeleteMultipleNotifications = function (selectedNotificationsArr) {
                    var count = 1;
                    swal({
                            title: "Delete the selected notifications?",
                            text: "You are about to permanently delete the selected notifications.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedNotificationsArr, function (selectedNotification) {
                                    var inputObj = {
                                        notificationId: selectedNotification.id
                                    };
                                    NotificationFactory.deleteNotification(inputObj)
                                        .then(function () {
                                            if (count === selectedNotificationsArr.length) {
                                                angular.forEach(vm.selectedNotificationsArr, function (selectedNotification) {
                                                    angular.forEach(vm.notificationsArr, function (notificationObj, index) {
                                                        if (selectedNotification.id === notificationObj.id) {
                                                            vm.notificationsArr.splice(index, 1);
                                                        }
                                                    });
                                                });
                                                vm.totalItems = vm.totalItems - vm.selectedNotificationsArr.length;
                                                vm.selectedNotificationObj = null;
                                                vm.selectedNotificationsArr = [];
                                                swal({
                                                    title: postActionModelMessage,
                                                    html: true,
                                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'customSwalActionModel'
                                                });
                                                angular.element(".microSpinner").remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                $timeout(function () {
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    swal.close();
                                                },1000);
                                                vm.fnReload();
                                            } else {
                                                count++;
                                            }
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                            angular.element('.microSpinner').remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        });
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnChangeNotificationState = function (notificationObj) {
                    var inputObj = {
                        body: {},
                        notificationId: notificationObj.id
                    };

                    inputObj.body = {
                        state: notificationObj.state === 'ACTIVE'?'INACTIVE':'ACTIVE'
                    };
                    NotificationFactory.modifyNotification(inputObj)
                        .then(function (response) {
                            response.window.startHour = response.window.startHour.toString().length === 1 ? '0'+response.window.startHour:response.window.startHour;
                            response.window.startMinute = response.window.startMinute.toString().length === 1 ? '0'+response.window.startMinute:response.window.startMinute;
                            response.window.endHour = response.window.endHour.toString().length === 1 ? '0'+response.window.endHour:response.window.endHour;
                            response.window.endMinute = response.window.endMinute.toString().length === 1 ? '0'+response.window.endMinute:response.window.endMinute;
                            vm.fnChangedNotificationEvent(response);
                            amaran.success("Notification Updated Successfully");
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                $scope.$on("NotificationDeleted", function (evt, data) {
                    vm.selectedNotificationObj = null;
                    vm.selectedNotificationsArr = [];
                    vm.notificationsArr = vm.notificationsArr.filter(function (notificationObj) {
                        return (notificationObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.notification', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                vm.fnChangedNotificationEvent = function (data){
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.notificationsArr, function (notificationObj) {
                        if (notificationObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                data[key] = val;
                                notificationObj[key] = val;
                            });
                        }
                        if (notificationObj.id === vm.selectedNotificationObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedNotificationObj[key] = val;
                            });
                        }
                    });
                };

                $scope.$on("NotificationDetailsChanged", function (evt,data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.notificationsArr, function (notificationObj) {
                        if (notificationObj.id === vm.selectedNotificationObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedNotificationObj[key] = val;
                                notificationObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnNotificationClone = function(notificationObj){
                    DB.fnSet("ClonedNotificationObj", notificationObj);
                    vm.fnNotificationCloneEvent();
                };

                vm.fnNotificationCloneEvent = function(){
                    vm.selectedNotificationObj = null;
                    vm.selectedNotificationsArr = [];
                    $state.go('main.notification', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };
                $scope.$on("NotificationClone", function () {
                    vm.fnNotificationCloneEvent();
                });


                vm.fnInitNotifications = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:notification");
                    var sortData = FedSudoUserService.fnGetUserData('notificationSort');
                    vm.isSmallScreen = angular.element($window)[0].innerWidth <= 1600;
                    if (sortData !== '') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var notificationKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.notification') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedNotificationsArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleNotifications(vm.selectedNotificationsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var notificationKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.notification') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', notificationKeyDownEventHandler);
                document.addEventListener('keyup', notificationKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', notificationKeyDownEventHandler);
                    document.removeEventListener('keyup', notificationKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodesCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      NodeEcuFactory, BatchFactory, PaginationService, NodeFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, ColorService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];
                vm.isProjectLoaded = false;
                vm.isInitNode = true;
                vm.tableAlias = 'node_nodes';
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + '.data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: vm.tableAlias + '.data->\'connected\' = \'false\'',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Root",
                        name: "rootNodeId",      // Changed from parentNodeId
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        //sqlValue: vm.tableAlias + '.data->>\'rootNodeId\' IN (SELECT DISTINCT data->>\'rootNodeId\' FROM ' + vm.tableAlias + ' WHERE data->>\'rootNodeId\' IS NOT NULL)',
                        sqlValue: vm.tableAlias + '.data->>\'id\' = ' + vm.tableAlias + '.data->>\'rootNodeId\'',
                        localSearchValue: 'obj.data->>\'rootNodeId\' === obj.data->>\'_id\''
                    }, {
                        displayName: "Join",
                        name: vm.tableAlias + ".join",
                        localSearch: {
                            type: 'objects',
                            name: 'join',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Unknown',
                                id: 'UNKNOWN'
                            }, {
                                name: 'System Defined',
                                id: 'SYSTEM_DEFINED'
                            }, {
                                name: 'User Definable',
                                id: 'USER_DEFINABLE'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }, {
                        displayName: "Operation",
                        name: vm.tableAlias + ".data->>\'operation\'",
                        localSearch: {
                            type: 'objects',
                            name: 'operation',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Enabled',
                                id: 'ENABLED'
                            }, {
                                name: 'Disabled',
                                id: 'DISABLED'
                            }, {
                                name: 'Enabling',
                                id: 'ENABLING'
                            }, {
                                name: 'Disabling',
                                id: 'DISABLING'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Index",
                        name: "index",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'health', displayName: 'Health'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.nodeProjectFilter = "$";
                vm.nodeProjectSearch = {$: ''};
                vm.isShowECUInformation = false;
                vm.lastSQLQuery = "";

                //Nodes Variables
                vm.isNodesLoading = false;
                vm.nodesArr = [];
                vm.selectedNodesArr = [];
                vm.selectedNodeObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isUpdateIoT3 = false;
                vm.isDropUp = false;
                vm.isRediscoveryPermission = false;
                vm.nodeTableAPITimeout = '';

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.nodeResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowNodeStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                // Added this flag to track refresh state
                vm.isRefreshing = false;


                /*Start: Context Menu*/
                vm.resetEditNodeObj = {};

                var loginUser = DB.fnGet("loginUser");

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status - handle both camelCase and lowercase variations
                        if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === "true" || parsedItem.ecuconnected === true;
                            delete parsedItem.ecuconnected;
                        }
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === "true" || parsedItem.ecuConnected === true;
                        }

                        // Handle basic node connection if present in raw data
                        if (angular.isDefined(parsedItem.connected)) {
                            parsedItem.connected = parsedItem.connected === "true" || parsedItem.connected === true;
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Only override connection statuses from data if not already set from raw fields
                                if (angular.isUndefined(parsedItem.connected) && angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                if (angular.isUndefined(parsedItem.ecuConnected) &&
                                    (angular.isDefined(parsedData.ecuConnected) || angular.isDefined(parsedData.ecuconnected))) {
                                    parsedData.ecuConnected = parsedData.ecuConnected === "true" ||
                                        parsedData.ecuConnected === true ||
                                        parsedData.ecuconnected === "true" ||
                                        parsedData.ecuconnected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge parsed data with our item, giving priority to already processed fields
                                var mergedItem = angular.extend({}, parsedData, parsedItem);

                                // Ensure connection statuses are boolean
                                mergedItem.connected = !!mergedItem.connected;
                                mergedItem.ecuConnected = !!mergedItem.ecuConnected;

                                return mergedItem;
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }


                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.nodeContextMenu = function (nodeObj) {
                    if (Object.keys(vm.resetEditNodeObj).length) {
                        var isFindNode = _.find(vm.nodesArr, {id: vm.resetEditNodeObj.id});
                        if (isFindNode) {
                            vm.fnCancelNodeEditMode(isFindNode);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            nodeObj.isEditable = true;
                            vm.resetEditNodeObj = angular.copy(nodeObj);
                        }
                    }]
                };

                vm.fnCancelNodeEditMode = function (nodeObj, isSuccessCall) {
                    if (isSuccessCall) {
                        nodeObj.name = angular.copy(nodeObj.name);
                        nodeObj.description = angular.copy(nodeObj.description);
                        nodeObj.isEditable = false;
                        vm.resetEditNodeObj = {};
                    } else {
                        nodeObj.name = angular.copy(vm.resetEditNodeObj.name);
                        nodeObj.description = angular.copy(vm.resetEditNodeObj.description);
                        nodeObj.isEditable = false;
                        vm.resetEditNodeObj = {};
                    }
                };

                vm.fnSaveNodeInfo = function (nodeObj) {
                    nodeObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        nodeId: nodeObj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/nodes/" + nodeObj.id + "/names",
                        body: {name: nodeObj.name}
                    });
                    batchArr.push({
                        method: "PATCH",
                        id: 2,
                        path: "/node/nodes/" + nodeObj.id + "/descriptions",
                        body: {description: nodeObj.description}
                    });
                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        if (response && response.length) {
                            var tempNodeObj = response[response.length - 1].body;
                            if (tempNodeObj.code === 400) {
                                amaran.error(tempNodeObj.message);
                                vm.fnCancelNodeEditMode(tempNodeObj, false);
                            } else {
                                if (angular.isUndefined(tempNodeObj.description)) {
                                    tempNodeObj.description = '';
                                }
                                var resetCopy = angular.copy(tempNodeObj);
                                angular.forEach(vm.nodesArr, function (nodeObj) {
                                    if (Object.keys(vm.selectedNodeObj).length) {
                                        if (nodeObj.id === vm.selectedNodeObj.id) {
                                            angular.forEach(resetCopy, function (val, key) {
                                                vm.selectedNodeObj[key] = val;
                                                nodeObj[key] = val;
                                            });
                                        }
                                    }
                                    if (nodeObj.id === resetCopy.id) {
                                        nodeObj.name = resetCopy.name;
                                        nodeObj.description = resetCopy.description;
                                        if (resetCopy.createdAt) {
                                            nodeObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.createdAt);
                                        }
                                        if (resetCopy.updatedAt) {
                                            nodeObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.updatedAt);
                                        }
                                    }
                                });
                                vm.fnCancelNodeEditMode(nodeObj, true);
                                amaran.success("Node Updated Successfully");
                            }
                        }
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            vm.fnCancelNodeEditMode(nodeObj);
                            amaran.error(error.errorMessage);
                        }
                    });
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.nodeTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'node', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isNodesLoading = true;
                    vm.selectedNodesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitNode === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'node', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetNodes({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.nodesArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedNodesArr = [];
                                vm.selectedNodeObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "Create Node" &&
                                tab.id !== "Update IoT3" &&
                                tab.id !== "WidgetEditor" &&
                                tab.id !== "Tunnel" &&
                                tab.id !== "SynchronizingNode" &&
                                tab.id !== "RediscoveryNode" &&
                                tab.id !== "nodeStats") {
                                if (vm.isNodesLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedNodesArr = [];
                                    vm.selectedNodeObj = {};
                                    if (angular.isDefined(tab.rootNodeId)) {
                                        vm.fnCheckUncheckHeader({
                                            id: tab.id,
                                            name: tab.title,
                                            projectId: tab.projectId,
                                            rootNodeId: tab.rootNodeId
                                        });
                                    } else {
                                        vm.fnCheckUncheckHeader({
                                            id: tab.id,
                                            name: tab.title,
                                            projectId: tab.projectId
                                        });
                                    }
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.node', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Node";
                        vm.isShowNodeStats = tab.id === "nodeStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isUpdateIoT3 = tab.id === "Update IoT3";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        vm.isShowTunnel = tab.id === "Tunnel";
                        vm.isShowSynchronizingNode = tab.id === "SynchronizingNode";
                        vm.isShowRediscoveryNode = tab.id === "RediscoveryNode";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            $timeout.cancel(vm.nodeTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Node";
                    vm.isUpdateIoT3 = tab.id === "Update IoT3";
                    vm.isShowNodeStats = tab.id === "nodeStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    vm.isShowTunnel = tab.id === "Tunnel";
                    vm.isShowSynchronizingNode = tab.id === "SynchronizingNode";
                    vm.isShowRediscoveryNode = tab.id === "RediscoveryNode";
                    if (tab.id === "Dashboard" || tab.id === "Create Node" || tab.id === "Create Issue" || tab.title === "Update IoT3" || tab.id === "nodeStats" || tab.id === "WidgetEditor" || tab.id === "Tunnel" || tab.id === "SynchronizingNode" || tab.id === "RediscoveryNode") {
                        $state.go('main.node', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedNodeObj = [];
                        vm.selectedNodeObj = {};
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.nodeTableAPITimeout);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Node" || id === "Update IoT3") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#nodeTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (nodeObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_NODE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.nodesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === nodeObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Node array*/
                        var isValueFind = _.find(vm.selectedNodesArr, {'id': nodeObj.id});
                        if (!isValueFind) {
                            vm.selectedNodesArr.push(nodeObj);
                            var isTabExist = _.find(vm.tabs, {'id': nodeObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                if (angular.isUndefined(nodeObj.project)) {
                                    nodeObj.project = _.find(vm.projectsArr, {id: nodeObj.projectId});
                                }
                                if (angular.isDefined(nodeObj.rootNodeId)) {
                                    vm.tabs.push({
                                        id: nodeObj.id,
                                        title: nodeObj.name,
                                        tabIndex: newTabIndex,
                                        projectName: nodeObj.project.name,
                                        projectId: nodeObj.project.id,
                                        rootNodeId: nodeObj.rootNodeId
                                    });
                                } else {
                                    vm.tabs.push({
                                        id: nodeObj.id,
                                        title: nodeObj.name,
                                        tabIndex: newTabIndex,
                                        projectName: nodeObj.project.name,
                                        projectId: nodeObj.project.id
                                    });
                                }
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedNodesArr, function (obj) {
                                return nodeObj.id === obj.id;
                            });
                        }
                        if (vm.selectedNodesArr.length === 1) {
                            vm.fnGetNodeDetails(vm.selectedNodesArr[0])
                        } else {
                            $state.go('main.node', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.nodesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedNodesArr = angular.copy(vm.nodesArr);
                    } else {
                        vm.selectedNodesArr = [];
                    }
                    $state.go('main.node', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (nodeObj) {
                    var isFindIndex = _.findIndex(vm.selectedNodesArr, {id: nodeObj});
                    if (nodeObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedNodesArr.push(nodeObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedNodesArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedNodesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Node'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Node',
                                title: 'Register Node',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.nodeTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.node', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isNodesLoading = true;
                    vm.selectedNodesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                        sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                    } else { //for general sort
                        sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                        sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                    }

                    if (isPerPageChanged) {
                        if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                            if (sortString !== '') {
                                sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                                sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                            } else {
                                sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                                sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                            }
                        } else {
                            if (sortString !== '') {
                                sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                                sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                                sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                            } else {
                                sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                                sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                                sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                            }
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetNodes(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.nodesArr, true, 'node_nodes');
                        vm.previousPage = page;
                        vm.fnGetNodes(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];

                            if (res.data) {
                                var parsedProjects = parsePostgresData(res.data);
                                _.forEach(parsedProjects, function (projectObj) {
                                    projects.push(projectObj);
                                });
                            }
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnOpenNodeInfoTab = function (nodeObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(nodeObj);
                };

                vm.fnGetNode = function (nodeObj, nodesArr) {
                    angular.forEach(nodesArr, function (node) {
                        node.isCheck = false;
                    });
                    nodeObj.isCheck = true;
                    vm.selectedNodesArr = [nodeObj]; // Assign array with single node object
                    vm.fnGetNodeDetails(nodeObj);
                };

                vm.fnGetNodeDetails = function (nodeObj) {
                    vm.isNodeDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when node is selected
                        vm.selectedNodeObj = nodeObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node', {
                                selectedId: vm.selectedNodeObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedNodeObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isNodeDetailsLoaded = true;
                        } else {
                            $state.go('main.node', {selectedId: vm.selectedNodeObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedNodeObj.id;
                            vm.isNodeDetailsLoaded = true;
                        }
                    })
                };

                vm.fnRequestNodeTunnel = function (nodeObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'Tunnel'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.nodeId = nodeObj.id;
                            isTabExist.projectName = nodeObj.name;
                            isTabExist.rootNodeId = nodeObj.rootNodeId;
                            vm.isShowTunnel = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Tunnel',
                            title: 'Tunnel',
                            tabIndex: newTabIndex,
                            nodeId: nodeObj.id,
                            projectName: nodeObj.name,
                            rootNodeId: nodeObj.rootNodeId
                        });
                        $timeout(function () {
                            vm.isShowTunnel = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetNodeColor = function (nodeCode, nodeObj) {
                    var nodeStyle = ColorService.getNodeColorForLoop(nodeObj.projectId, nodeCode);
                    nodeObj.nodeName = nodeStyle.content;
                    return nodeStyle;
                };

                vm.fnGetNodes = function (inputObj, isFirst) {
                    vm.isNodesLoading = true;

                    if ($stateParams.selectedId) {
                        //var selectedRootId = $stateParams.selectedId;
                        var projectId = vm.project && vm.project.id !== 'All' ? vm.project.id : null;

                        var sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, ' +
                            'node_ecus.data->\'connected\' as ecuConnected, ' +
                            'node_ecus.data->>\'name\' as ecuName, ' +
                            vm.tableAlias + '.data->>\'_id\' AS rt ' +
                            'FROM node_nodes ';
                        sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\' ';
                        sqlString += ' WHERE ' + vm.tableAlias + '.data->>\'id\' = ' + vm.tableAlias + '.data->>\'rootNodeId\' ';

                        if (projectId) {
                            sqlString += ' AND ' + vm.tableAlias + '.data->>\'projectId\' = \'' + projectId + '\' ';
                        }

                        // Update the input object with our modified query
                        inputObj.sql = sqlString;
                    }

                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse the PostgreSQL data
                            var parsedData = parsePostgresData(res.data);

                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                            });

                            vm.nodeResponse = angular.extend({}, res, { data: parsedData });
                            if (isFirst) {
                                if (vm.nodeResponse.data && vm.nodeResponse.data.length) {
                                    vm.totalItems = vm.nodeResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.nodeResponse.data.reverse();
                            }
                            vm.nodesArr = vm.nodeResponse.data;
                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.nodesArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.node') {
                                $state.go('main.node', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isNodesLoading = false;
                            vm.isInitNode = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                            vm.nodeTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isNodesLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnGetProjectNode = function (projectObj) {
                    $timeout.cancel(vm.nodeTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE " + vm.tableAlias + ".data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.tableAlias + '.data->>\''+vm.sort.split(' ')[0]+'\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT ' + vm.tableAlias + '.*, COUNT(*) OVER() as totalItems, node_ecus.data->\'connected\' as ecuConnected, node_ecus.data->>\'name\' as ecuName, ' + vm.tableAlias + '.data->>\'_id\' AS rt FROM node_nodes';
                            sqlString += ' INNER JOIN node_ecus ON ' + vm.tableAlias + '.data->>\'ecuId\' = node_ecus.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'node', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'node', 'selectedProject', '');
                    }
                    vm.fnGetNodes({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnDeployNode = function (nodeObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'SynchronizingNode'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.nodeId = nodeObj.id;
                            isTabExist.projectName = nodeObj.name;
                            vm.isShowSynchronizingNode = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'SynchronizingNode',
                            title: 'Synchronizing Node',
                            tabIndex: newTabIndex,
                            nodeId: nodeObj.id,
                            projectName: nodeObj.name
                        });
                        $timeout(function () {
                            vm.isShowSynchronizingNode = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isInitNode = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("NodeDeleted", function (evt, data) {
                    vm.selectedNodeObj = null;
                    vm.selectedNodesArr = [];
                    vm.nodesArr = vm.nodesArr.filter(function (nodeObj) {
                        return (nodeObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    ColorService.fnSetNodeData(vm.nodesArr);
                    $state.go('main.node', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("NodeDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.nodesArr, function (nodeObj) {
                        if (nodeObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                data[key] = val;
                                nodeObj[key] = val;
                                vm.selectedNodeObj[key] = val;
                            });
                        }
                    });
                    var isFindTab = _.find(vm.tabs, {id: data.id});
                    if (isFindTab && isFindTab.title !== data.name) {
                        isFindTab.title = data.name;
                        vm.fnUpdateUserProfileData();
                    }
                });

                $scope.$on("nodeAdded", function () {
                    vm.fnRemoveTab('Create Node');
                });

                vm.fnAddDefaultFilter = function () {
                    if (angular.isUndefined($stateParams.filter)) {
                        var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'node', 'searchFilter');
                        if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                            var tempArr = {};
                            if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                                tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                                $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                            }
                            if (searchFilterObj.sort && searchFilterObj.sort.length) {
                                tempArr.sort = searchFilterObj.sort;
                                $stateParams.sort = searchFilterObj.sort;
                            }
                            $state.go("main.node", tempArr, {notify: false});
                        } else {
                            if (angular.isDefined($stateParams.filter)) {
                                var filterJson = angular.fromJson($stateParams.filter);
                                var isFind = _.find(filterJson, {selectedField: 'rootNodeId'});
                                if (!isFind) {
                                    filterJson.push({
                                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                        selectedField: "rootNodeId",
                                        displaySelectedField: "Root",
                                        selectedConnector: "and",
                                        searchText: '',
                                        displaySearchText: '',
                                        isDirectFilterApply: true,
                                        sqlValue: vm.tableAlias + '.data->>\'rootNodeId\' IN (SELECT DISTINCT data->>\'rootNodeId\' FROM ' + vm.tableAlias + ' WHERE data->>\'rootNodeId\' IS NOT NULL)',
                                        localSearchValue: 'obj.data->>\'rootNodeId\' === obj.data->>\'_id\''
                                    });
                                    $state.go("main.node", {filter: angular.toJson(filterJson)}, {notify: false});
                                    $stateParams.filter = angular.toJson(filterJson);
                                }
                            } else {
                                var inputObj = [{
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "rootNodeId",
                                    displaySelectedField: "Root",
                                    searchText: '',
                                    displaySearchText: '',
                                    isDirectFilterApply: true,
                                    sqlValue: vm.tableAlias + '.data->>\'rootNodeId\' IN (SELECT DISTINCT data->>\'rootNodeId\' FROM ' + vm.tableAlias + ' WHERE data->>\'rootNodeId\' IS NOT NULL)',
                                    localSearchValue: 'obj.data->>\'rootNodeId\' === obj.data->>\'_id\''
                                }];
                                $state.go("main.node", {filter: angular.toJson(inputObj)}, {notify: false});
                                $stateParams.filter = angular.toJson(inputObj);
                            }
                        }
                    }
                };

                vm.fnInitNodes = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.isRediscoveryPermission = false;
                    var activeUser = '';
                    if (DB.fnGet('federation') || DB.fnGet('support')) {
                        var federationUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                        activeUser = federationUser.sessionObj.user;
                    } else {
                        activeUser = DB.fnGet("loginUser");
                    }
                    if (activeUser.accountOwner === true || activeUser.administrator === true || activeUser.nodeRole === 'MANAGER') {
                        vm.isRediscoveryPermission = true;
                    }
                    vm.fnAddDefaultFilter();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'node', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetNodeDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetNodeStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'nodeStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowNodeStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'nodeStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowNodeStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getNodeCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.nodesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.nodesArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Nodes");
                    XLSX.writeFile(wb, "Nodes.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'node', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenNodeNotes = function (nodeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/nodeNotes/nodeNotesModal.html',
                        size: 'lg',
                        controller: 'nodeNotesModalCtrl as nodeNotesModal',
                        windowClass: 'modal-height100',
                        resolve: {
                            permissionObj: function () {
                                return vm.permissionObj;
                            },
                            nodeObj: function () {
                                return _.cloneDeepWith(nodeObj);
                            }
                        }
                    });
                    modalInstance.result.then(function (response) {
                        nodeObj.notes = response.notes
                    }, function () {
                    });
                };

                vm.fnGetHealthColor = function (nodeCode, nodeObj) {
                    var nodeStyle = ColorService.getHealthColorForLoop(nodeObj.projectId, nodeCode);
                    nodeObj.healthName = nodeStyle.content;
                    return nodeStyle;
                };

                vm.fnEditNodeInfoTab = function (nodeObj) {
                    DB.fnSet('isNodeEditable', true);
                    vm.fnOpenNodeInfoTab(nodeObj, 4);
                }

                vm.fnDeleteMultipleNodes = function (selectedNodesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedNodesArr, function (selectedNode, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/nodes/" + selectedNode.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/nodes/" + selectedNode.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected " + selectedNodesArr.length + " Nodes?",
                            text: "You are about to permanently delete the selected " + selectedNodesArr.length + " nodes.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.<br/><br/>" +
                                "Please type in the word \"Delete\" to delete Nodes.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (isConfirm) {
                            if (isConfirm === null) {
                                return false;
                            }
                            if (isConfirm === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (isConfirm !== 'Delete') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (isConfirm === 'Delete') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else if (isConfirm === false) {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedNodesArr, function (selectedSoftware) {
                                    angular.forEach(vm.nodesArr, function (softwareObj, index) {
                                        if (selectedSoftware.id === softwareObj.id) {
                                            vm.nodesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedNodesArr.length;
                                vm.selectedSoftwareObj = null;
                                vm.selectedNodesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedNodesArr, function (selectedSoftware) {
                                    angular.forEach(vm.nodesArr, function (softwareObj, index) {
                                        if (selectedSoftware.id === softwareObj.id) {
                                            vm.nodesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedNodesArr.length;
                                vm.selectedSoftwareObj = null;
                                vm.selectedNodesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnEnableMultipleNodes = function (selectedNodesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    var newTempIndex = 0;

                    angular.forEach(selectedNodesArr, function (selectedNode) {
                        if (selectedNode.lifecycleState === 'READY' && selectedNode.operation === 'DISABLED') {
                            if (newTempIndex <= step) {
                                inputObj.method = "POST";
                                inputObj.id = newTempIndex;
                                inputObj.path = "/node/nodes/" + selectedNode.id + "/operations";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            } else {
                                batchArr = [];
                                step = step + 15;
                                count++;
                                inputObj.method = "POST";
                                inputObj.id = newTempIndex;
                                inputObj.path = "/node/nodes/" + selectedNode.id + "/operations";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            }
                            newTempIndex++;
                        }
                    });

                    swal({
                            title: "Enable the selected Nodes?",
                            text: "You are about to enable the selected nodes.<br/>" +
                                "Please type in the word \"Enable\" to enable Nodes.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "enable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (isConfirm) {
                            if (isConfirm === null) {
                                return false;
                            }
                            if (isConfirm === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (isConfirm !== 'Enable') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (isConfirm === 'Enable') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                if (Object.keys(batchCollectionObj).length) {
                                    vm.fnEnableBatchOperation(batchCollectionObj, count);
                                } else {
                                    $timeout(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node enabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, 1500)
                                }
                            } else if (isConfirm === false) {
                                swal("Cancelled", "Enable Process Cancelled", "error");
                            }
                        });
                };

                vm.fnEnableBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    }).then(function () {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnEnableBatchOperation(batchCollectionObj, count);
                        } else {
                            swal({
                                title: postActionModelMessage,
                                html: true,
                                imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'customSwalActionModel'
                            });
                            amaran.success("Node enabling in progress.");
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            $timeout(function () {
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }, 1000);
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnEnableBatchOperation(batchCollectionObj, count);
                        } else {
                            angular.element('.microSpinner').remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    });
                }

                vm.fnDisableMultipleNodes = function (selectedNodesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};
                    var newTempIndex = 0;

                    angular.forEach(selectedNodesArr, function (selectedNode) {
                        if (selectedNode.lifecycleState === 'READY' && selectedNode.operation === 'ENABLED') {
                            if (newTempIndex <= step) {
                                inputObj.method = "DELETE";
                                inputObj.id = newTempIndex;
                                inputObj.path = "/node/nodes/" + selectedNode.id + "/operations";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            } else {
                                batchArr = [];
                                step = step + 15;
                                count++;
                                inputObj.method = "DELETE";
                                inputObj.id = newTempIndex;
                                inputObj.path = "/node/nodes/" + selectedNode.id + "/operations";
                                batchArr.push(inputObj);
                                batchCollectionObj[count] = batchArr;
                                inputObj = {};
                            }
                            newTempIndex++;
                        }
                    });
                    batchCollectionObj = {};
                    swal({
                            title: "Disable the selected Nodes?",
                            text: "You are about to disable the selected nodes.<br/>" +
                                "Please type in the word \"Disable\" to disable Nodes.",
                            type: "input",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true,
                            inputPlaceholder: "Enter Confirmation Text"
                        },
                        function (isConfirm) {
                            if (isConfirm === null) {
                                return false;
                            }
                            if (isConfirm === "") {
                                swal.showInputError("Please enter confirmation text!");
                                return false
                            } else if (isConfirm !== 'Disable') {
                                swal.showInputError("Please enter valid confirmation text!");
                                return false
                            } else if (isConfirm === 'Disable') {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                if (Object.keys(batchCollectionObj).length) {
                                    vm.fnDisableBatchOperation(batchCollectionObj, count);
                                } else {
                                    $timeout(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, 1500)
                                }
                            } else if (isConfirm === false) {
                                swal("Cancelled", "Disable Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDisableBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    }).then(function () {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnDisableBatchOperation(batchCollectionObj, count);
                        } else {
                            swal({
                                title: postActionModelMessage,
                                html: true,
                                imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                showCancelButton: false,
                                showConfirmButton: false,
                                customClass: 'customSwalActionModel'
                            });
                            amaran.success("Node disabling in progress.");
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            $timeout(function () {
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                            }, 1000);
                        }
                    }, function (error) {
                        if (count < Object.keys(batchCollectionObj).length) {
                            count++;
                            vm.fnDisableBatchOperation(batchCollectionObj, count);
                        } else {
                            angular.element('.microSpinner').remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        }
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                    });
                }

                vm.fnDisabledNode = function (nodeObj) {
                    swal({
                            title: "Disable the selected Node?",
                            text: "You are about to disable selected Node.<br/>",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "disable",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                var inputObj = {
                                    nodeId: nodeObj.id
                                };
                                NodeFactory.disableNode(inputObj)
                                    .then(function () {
                                        swal({
                                            title: postActionModelMessage,
                                            html: true,
                                            imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                            showCancelButton: false,
                                            showConfirmButton: false,
                                            customClass: 'customSwalActionModel'
                                        });
                                        amaran.success("Node disabling in progress.");
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        $timeout(function () {
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        }, 1000);
                                    }, function (error) {
                                        if (error && error.errorCode === -1) {
                                            amaran.error(error.errorMessage);
                                        }
                                        angular.element('.microSpinner').remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                swal("Cancelled", "Node disabling process cancelled", "error");
                            }
                        });
                };

                vm.fnRequestReplaceRediscovery = function (nodeObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'RediscoveryNode'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.nodeId = nodeObj.id;
                            isTabExist.projectName = nodeObj.name;
                            vm.isShowRediscoveryNode = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'RediscoveryNode',
                            title: 'Re-discover Nodes',
                            tabIndex: newTabIndex,
                            nodeId: nodeObj.id,
                            projectName: nodeObj.name
                        });
                        $timeout(function () {
                            vm.isShowRediscoveryNode = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                }

                vm.fnCloneNodeSettings = function (nodeObj) {
                    DB.fnSet('cloneNodeSettings', nodeObj);
                    vm.fnHideShowCreateForm();
                };

                vm.fnUpdateNodeIoT3 = function (nodeObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'Update IoT3'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.nodeId = nodeObj.id;
                            isTabExist.projectName = nodeObj.name;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Update IoT3',
                            title: 'Update IoT3',
                            tabIndex: newTabIndex,
                            nodeId: nodeObj.id,
                            projectName: nodeObj.name
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                }

                vm.fnShowAction = function (nodeObj) {
                    nodeObj.isShowAction = true;
                }

                vm.fnHideAction = function (nodeObj) {
                    delete nodeObj.isShowAction;
                }

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeNodeChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                /*vm.fnUpdateTableData = function () {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            var isEditableFound = _.cloneDeepWith(_.find(vm.nodesArr, {isEditable: true}));
                            vm.nodesArr = [];
                            var tempSelectedNodesObj = {};

                            var parsedData = parsePostgresData(res.data);

                            vm.selectedNodesArr = _.filter(vm.selectedNodesArr, function (selectNodeObj) {
                                var isFind = _.find(parsedData, {id: selectNodeObj.id});
                                if (isFind) {
                                    tempSelectedNodesObj[selectNodeObj.id] = _.cloneDeepWith(isFind);
                                    return true;
                                }
                                return false;
                            });
                            _.forEach(res.data, function (nodeObj, index) {
                                if (isEditableFound && nodeObj.id === isEditableFound.id) {
                                    nodeObj.isEditable = true;
                                    vm.resetEditNodeObj = _.cloneDeepWith(nodeObj);
                                    nodeObj.name = _.cloneDeepWith(isEditableFound.name);
                                    nodeObj.description = _.cloneDeepWith(isEditableFound.description);
                                }
                                if (angular.isDefined(tempSelectedNodesObj[nodeObj.id])) {
                                    nodeObj.isCheck = true;
                                }
                                delete vm.nodesArr[index];
                                vm.nodesArr[index] = nodeObj;
                                if (vm.nodesArr[index].createdAt) {
                                    vm.nodesArr[index].createdDate = vm.fnGetAbsoluteOrRelativeTime(vm.nodesArr[index].createdAt);
                                }
                                if (vm.nodesArr[index].updatedAt) {
                                    vm.nodesArr[index].updatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.nodesArr[index].updatedAt);
                                }
                                if (vm.nodesArr[index].projectId) {
                                    vm.nodesArr[index].project = _.find(vm.projectsArr, {id: vm.nodesArr[index].projectId});
                                }
                                if (vm.nodesArr[index].lastSeenAt && vm.nodesArr[index].lastSeenAt !== 0) {
                                    vm.nodesArr[index].lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(vm.nodesArr[index].lastSeenAt);
                                }
                            })
                            vm.nodeTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.nodeTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        })
                };*/

                vm.fnUpdateTableData = function () {
                    // Prevent multiple simultaneous refreshes
                    if (vm.isRefreshing) {
                        return;
                    }

                    vm.isRefreshing = true;

                    // Store current data as backup
                    var currentData = _.cloneDeep(vm.nodesArr);

                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) {
                            if (!res || !res.data) {
                                throw new Error('Invalid response data');
                            }

                            // Parse the new data
                            var parsedData = parsePostgresData(res.data);

                            // Preserve selection states and other UI state
                            parsedData = parsedData.map(function(newNode) {
                                var existingNode = _.find(currentData, {id: newNode.id});
                                if (existingNode) {
                                    // Merge existing node with new data while preserving UI state
                                    var mergedNode = angular.extend({}, newNode);
                                    mergedNode.isCheck = existingNode.isCheck;
                                    mergedNode.isEditable = existingNode.isEditable;
                                    return mergedNode;
                                }
                                return newNode;
                            });

                            // Update the data only if we have valid results
                            if (parsedData && parsedData.length > 0) {
                                vm.nodesArr = parsedData;

                                // Process additional data
                                vm.nodesArr.forEach(function(nodeObj) {
                                    if (nodeObj.createdAt) {
                                        nodeObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(nodeObj.createdAt);
                                    }
                                    if (nodeObj.updatedAt) {
                                        nodeObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(nodeObj.updatedAt);
                                    }
                                    if (nodeObj.projectId) {
                                        nodeObj.project = _.find(vm.projectsArr, {id: nodeObj.projectId});
                                    }
                                    if (nodeObj.lastSeenAt && nodeObj.lastSeenAt !== 0) {
                                        nodeObj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(nodeObj.lastSeenAt);
                                    }
                                });
                            } else {
                                // If no valid data, restore previous state
                                vm.nodesArr = currentData;
                            }
                        })
                        .catch(function (error) {
                            // On error, restore previous state
                            vm.nodesArr = currentData;
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                        .finally(function() {
                            vm.isRefreshing = false;

                            // Schedule next refresh
                            vm.nodeTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        });
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on('RequestReplaceRegistration', function (event, data) {
                    vm.fnUpdateNodeIoT3(data);
                })

                $scope.$on('CloneNodeSettings', function (event, data) {
                    vm.fnCloneNodeSettings(data);
                })

                $scope.$on('openNodeDetail', function (event, data) {
                    vm.selectedNodesArr = [];
                    vm.selectedNodeObj = {};
                    vm.fnOpenNodeInfoTab(data, 4)
                });

                $scope.$on('openNodeTelemetry', function (event, data) {
                    vm.selectedNodesArr = [];
                    vm.selectedNodeObj = {};
                    vm.fnOpenNodeInfoTab(data, 1)
                });

                $scope.$on('RequestNodeTunnel', function (event, data) {
                    vm.fnRequestNodeTunnel(data);
                });

                $scope.$on('RequestNodeSynchronizing', function (event, data) {
                    vm.fnDeployNode(data);
                });

                $scope.$on('RequestNodeDiscover', function (event, data) {
                    vm.fnRequestReplaceRediscovery(data);
                });

                var nodeKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_HEALTH &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedNodesArr.length > 1 && vm.permissionObj.DELETE_HEALTH &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleNodes(vm.selectedNodesArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var nodeKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.node') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', nodeKeyDownEventHandler);
                document.addEventListener('keyup', nodeKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.nodeTableAPITimeout);
                    document.removeEventListener('keydown', nodeKeyDownEventHandler);
                    document.removeEventListener('keyup', nodeKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LifecycleCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, moment, amaran, swal, microSpinner, DB, Authenticate, LastPageService, PermissionsService, ColorService, FedSudoUserService, BatchFactory, PaginationService, UserFactory, LifecycleFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "Gateway ID",
                        fieldName: "gatewayId"
                    },
                    {
                        fieldDisplayName: "Type ID",
                        fieldName: "typeId"
                    },
                    {
                        fieldDisplayName: "Result",
                        fieldName: "result"
                    },
                    {
                        fieldDisplayName: "Request",
                        fieldName: "request"
                    },
                    {
                        fieldDisplayName: "Request ID",
                        fieldName: "requestId"
                    },
                    {
                        fieldDisplayName: "Device ID",
                        fieldName: "deviceId"
                    },
                    {
                        fieldDisplayName: "Task",
                        fieldName: "task"
                    }
                ];
                vm.filterQuery = "";

                //Lifecycle Variables
                vm.isLifecyclesLoading = false;
                vm.lifecyclesArr = [];
                vm.selectedLifecyclesArr = [];
                vm.selectedLifecycleObj = {};
                vm.isTabsLoading = null;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });
                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isGroupsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    inputObj.sort = '[dec]timestamp';
                    vm.isLifecyclesLoading = true;
                    vm.selectedLifecyclesArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetLifecycles(inputObj);
                    } else {
                        vm.lifecyclesArr = [];
                        vm.isLifecyclesLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);
                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.lifecycle', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    vm.isLifecyclesLoading = true;
                    vm.selectedLifecyclesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetLifecycles(vm.inputObj);
                };

                vm.fnGetLifecycle = function (lifecycleObj, lifecyclesArr) {
                    angular.forEach(lifecyclesArr, function (lifecycle) {
                        lifecycle.isCheck = false;
                    });
                    lifecycleObj.isCheck = true;
                    vm.selectedLifecyclesArr = [lifecycleObj]; // Assign array with single Group object
                    vm.fnGetLifecycleDetails(lifecycleObj);
                };

                vm.fnGetLifecycleDetails = function (lifecycleObj) {
                    vm.isLifecycleDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when group is selected
                        vm.selectedLifecycleObj = lifecycleObj;
                        $state.go('main.lifecycle', {selectedId: vm.selectedLifecycleObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedLifecycleObj.id;
                        vm.isLifecycleDetailsLoaded = true;
                    });
                };

                vm.fnGetLifecycles = function (inputObj) {
                    LifecycleFactory.getLifecycles(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.lifecycles;
                            res.map(function (obj) {
                                var rids =  obj.requestId.split('-');
                                obj.reqId = "#" + rids[rids.length - 1];
                                obj.humanDateCreated = moment(obj.timestamp).format("MM/DD/YYYY HH:mm:ss:SSS");
                                obj.humanDateCreatedAbsolute = moment(obj.timestamp).format('MMMM Do YYYY, h:mm:ss:SSS a');
                                obj.humanDateCreatedRelative = moment(obj.humanDateCreated).fromNow();
                            });
                            vm.lifecyclesArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var lifecycleData = _.find(vm.lifecyclesArr, {"id": $stateParams.selectedId});
                                if (lifecycleData) {
                                    vm.fnGetLifecycle(lifecycleData, vm.lifecyclesArr);
                                }
                            }
                            if ($state.current.name === 'main.lifecycle') {
                                $state.go('main.lifecycle', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isLifecyclesLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isLifecyclesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetResultIcon = function (result) {
                    var icon = "";
                    switch(result) {
                        case "PASS":
                            icon = "fa-check";
                            break;
                        case "FAIL":
                            //icon = "fa-exclamation";
                            icon = "fa-exclamation-triangle";
                            break;
                        case "PROCESSING":
                            icon = "fa-clock";
                            break;
                    }
                    return icon;
                };

                vm.fnGetFilterDataByRequestId = function (requestId) {
                    var tagsArr = [];
                    var inputObj = {
                        "id": 0,
                        "name": "",
                        "selectedField": "requestId",
                        "selectedFilter": {
                            "operatorName": "is equal to",
                            "operator": "="
                        },
                        "searchText": ""
                    };
                    inputObj.name = "requestId is equal to: " + requestId;
                    inputObj.id = Math.floor(Math.random() * ( 567234908 - 0 + 1 )) + 0;
                    inputObj.searchText = requestId;
                    tagsArr.push(angular.copy(inputObj));
                    $state.go("main.lifecycle", {filter: angular.toJson(tagsArr)});
                };

                vm.fnCheckUncheckHeader = function (lifecycleObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.lifecyclesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === lifecycleObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected lifecycle array*/
                    var isValueFind = _.find(vm.selectedLifecyclesArr, {'id': lifecycleObj.id});
                    if (!isValueFind) {
                        vm.selectedLifecyclesArr.push(lifecycleObj)
                    } else {
                        _.remove(vm.selectedLifecyclesArr, function (obj) {
                            return lifecycleObj.id === obj.id;
                        });
                    }
                    if (vm.selectedLifecyclesArr.length === 1) {
                        vm.fnGetLifecycleDetails(vm.selectedLifecyclesArr[0])
                    } else {
                        $state.go('main.lifecycle', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.lifecyclesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedLifecyclesArr = angular.copy(vm.lifecyclesArr);
                    } else {
                        vm.selectedLifecyclesArr = [];
                    }
                    $state.go('main.lifecycle', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };
                /*END: TABLE*/

                vm.fnDeleteMultipleLifeCycles = function (selectedLifecyclesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedLifecyclesArr, function (selectedLifeCycle, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/lifecycles/" + selectedLifeCycle.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/lifecycles/" + selectedLifeCycle.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected lifecycles?",
                            text: "You are about to permanently delete the selected lifecycles.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'lifecycle', appName: 'node'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedLifecyclesArr, function (selectedLifeCycle) {
                                    angular.forEach(vm.lifecyclesArr, function (lifeCycleObj, index) {
                                        if (selectedLifeCycle.id === lifeCycleObj.id) {
                                            vm.lifecyclesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedLifecyclesArr.length;
                                vm.selectedLifecycleObj = null;
                                vm.selectedLifecyclesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedLifecyclesArr, function (selectedLifeCycle) {
                                    angular.forEach(vm.lifecyclesArr, function (lifeCycleObj, index) {
                                        if (selectedLifeCycle.id === lifeCycleObj.id) {
                                            vm.lifecyclesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedLifecyclesArr.length;
                                vm.selectedLifecycleObj = null;
                                vm.selectedLifecyclesArr = [];
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                $scope.$on("LifecycleDeleted", function (evt, data) {
                    vm.selectedLifecycleObj = null;
                    vm.selectedLifecyclesArr = [];
                    vm.lifecyclesArr = vm.lifecyclesArr.filter(function (lifecycleObj) {
                        return (lifecycleObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.lifecycle', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                vm.fnInitLifecycle = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:lifecycle");
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('JobsCtrl',
            function ($scope, $rootScope, $window, $timeout, $stateParams, $state, $uibModal, amaran,
                      moment, WidgetsListService, UserProfileService, DB, XLSX,
                      LastPageService, jsonToCsvConvertService, FedSudoUserService, PaginationService,
                      AvatarService, PaginationQueryService, QueryFactory, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                //Search Variables
                vm.isRefreshData = true;
                vm.jobTablesArr = [
                    {
                        "displayName": "Pending",
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "displayName": "Active",
                        "name": "ecu_active_jobs"
                    },
                    {
                        "displayName": "Completed",
                        "name": "ecu_completed_jobs"
                    }
                ];
                //vm.selectedJobTable = vm.jobTablesArr[0];
                var selectedJobType = UserProfileService.fnGetUserProfileObj('node', 'job', 'selectedJobType');
                if (selectedJobType !== '') {
                    vm.selectedJobTable = selectedJobType;
                } else {
                    vm.selectedJobTable = vm.jobTablesArr[0];
                }

                vm.jobTypeFilter = "$";
                vm.jobTypeSearch = {$: ''};

                var FiltersArrOrder = ['Requested Type', 'Requested By', 'ID'];
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Requested Type",
                        name: "requestType",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                if (vm.selectedJobTable.name === 'ecu_pending_jobs' || vm.selectedJobTable.name === 'ecu_active_jobs') {
                    vm.sortFieldArr = [
                        {name: "data->>\'startsAt\'", displayName: "Starts At"},
                        {name: "data->>\'expiresAt\'", displayName: "Expires At"}
                    ];
                } else {
                    vm.sortFieldArr = [
                        {name: "data->>\'startedAt\'", displayName: "Started At"},
                        {name: "data->>\'expiresAt\'", displayName: "Expires At"}
                    ];
                }

                vm.filterQuery = "";
                vm.sqlQuery = "";
                vm.ecusArr = [];

                //Jobs Variables
                vm.isJobsLoading = false;
                vm.jobsArr = [];
                vm.selectedJobsArr = [];
                vm.selectedJobObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowJobStats = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                vm.jobTableAPITimeout = '';

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Try explicit fields first, fall back to parsed data, then empty string
                                id: item.id || parsedData.id || '',
                                requestType: item.request_type || parsedData.requestType || '',
                                requestedBy: item.requested_by || parsedData.requestedBy || '',
                                startsAt: parseInt(item.starts_at || parsedData.startsAt) || 0,
                                startedAt: parseInt(item.started_at || parsedData.startedAt) || 0,
                                expiresAt: parseInt(item.expires_at || parsedData.expiresAt) || 0,
                                completedAt: parseInt(item.completed_at || parsedData.completedAt) || 0,
                                jobResult: item.job_result || parsedData.jobResult || '',
                                ecuId: item.ecu_id || parsedData.ecuId || '',
                                projectId: item.project_id || parsedData.projectId || '',
                                accountId: item.account_id || parsedData.accountId || '',
                                payload: item.payload || parsedData.payload || null,
                                payloadVersion: item.payload_version || parsedData.payloadVersion || 0,

                                // Metadata fields
                                totalItems: item.totalitems || 0,
                                createdAt: item.created_at || '',
                                updatedAt: item.updated_at || '',
                                rt: item.rt || ''
                            };

                            // Add the requestTypeString
                            parsedItem.requestTypeString = (parsedItem.requestType || '').replace(/_/g, " ");

                            // Time-related processing
                            if (parsedItem.startsAt || parsedItem.startedAt || parsedItem.expiresAt || parsedItem.completedAt) {
                                var timestamp = parsedItem.startsAt || parsedItem.startedAt || parsedItem.expiresAt || parsedItem.completedAt;
                                var itemTimestamp = moment.unix(timestamp);
                                var differenceHours = currentTime.diff(itemTimestamp, 'hours');
                                parsedItem.relativeTime = differenceHours > 24
                                    ? itemTimestamp.format("DD/MM/YYYY")
                                    : itemTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }

                vm.fnChangeJobType = function (index) {
                    $timeout.cancel(vm.jobTableAPITimeout);
                    vm.isJobsLoading = true;
                    vm.selectedJobTable = vm.jobTablesArr[index];
                    UserProfileService.fnUpdateUserProfileObj('node', 'job', 'selectedJobType', _.cloneDeepWith(angular.fromJson(angular.toJson(vm.selectedJobTable))));
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        if (vm.sort.split(' ')[0] === 'data->>\'startsAt\'' || vm.sort.split(' ')[0] === 'data->>\'startedAt\'') {
                            if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                                vm.sort = 'data->>\'startedAt\' ' + vm.sort.split(' ')[1];
                            } else {
                                vm.sort = 'data->>\'startsAt\' ' + vm.sort.split(' ')[1];
                            }
                            $state.go("main.job", {sort: vm.sort}, {notify: false});
                            $stateParams.sort = vm.sort;
                        }
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'completedAt\' as completed_at, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'jobResult\' as job_result, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startedAt\' as started_at';
                        vm.sortFieldArr = [
                            {name: "data->>\'startedAt\'", displayName: "Started At"},
                            {name: "data->>\'expiresAt\'", displayName: "Expires At"}
                        ];
                    } else if (vm.selectedJobTable.name === 'ecu_active_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startsAt\' as starts_at, ' +
                            'data->>\'payload\' as payload, ' +
                            'data->>\'payloadVersion\' as payload_version, ' +
                            'created_at, ' +
                            'updated_at';
                    } else {
                        sqlString = 'SELECT *';
                        vm.sortFieldArr = [
                            {name: "data->>\'startsAt\'", displayName: "Starts At"},
                            {name: "data->>\'expiresAt\'", displayName: "Expires At"}
                        ];
                    }
                    $timeout(function () {
                        $rootScope.$broadcast('updateSortString', vm.sort);
                    })
                    if (sortString !== '') {

                        // Extract sort field and ensure it has data->> prefix
                        var sortField = vm.sort.split(' ')[0];
                        var sortDirection = vm.sort.split(' ')[1];

                        // Ensure sortField has the data->> prefix if it's a JSON field and doesn't already have it
                        if (!sortField.includes('data->>') && !sortField.includes('.')) {
                            sortField = 'data->>\'' + sortField.replace(/^data->>\'|\'$/, '') + '\'';
                        }

                        sqlString += ', COUNT(*) OVER() as totalItems, ' + sortField + ' AS rt FROM ' + vm.selectedJobTable.name;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + sortField + ' ' + sortDirection + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString += ', COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.selectedJobTable.name;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    vm.fnGetJobs({sql: sqlString}, true);
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.jobTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'job', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isJobsLoading = true;
                    vm.selectedJobsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'completedAt\' as completed_at, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'jobResult\' as job_result, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startedAt\' as started_at';
                    } else if (vm.selectedJobTable.name === 'ecu_active_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startsAt\' as starts_at, ' +
                            'data->>\'payload\' as payload, ' +
                            'data->>\'payloadVersion\' as payload_version, ' +
                            'created_at, ' +
                            'updated_at';
                    } else {
                        sqlString = 'SELECT *';
                    }
                    if (sortString !== '') {
                        // Extract sort field and ensure it has data->> prefix
                        var sortField = vm.sort.split(' ')[0];
                        var sortDirection = vm.sort.split(' ')[1];

                        // Ensure sortField has the data->> prefix if it's a JSON field and doesn't already have it
                        if (!sortField.includes('data->>') && !sortField.includes('.')) {
                            sortField = 'data->>\'' + sortField.replace(/^data->>\'|\'$/, '') + '\'';
                        }
                        sqlString += ', COUNT(*) OVER() as totalItems, ' + sortField + ' AS rt FROM ' + vm.selectedJobTable.name;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + sortField + ' ' + sortDirection + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString += ', COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.selectedJobTable.name;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_ecus ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetECUs({sql: projectSQL}, [], false, input);
                    //vm.fnGetJobs(input, true);
                };

                vm.fnGetECUs = function (inputObj, preDefinedECUs, isCalledForViz, jobInput) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var ecus = isCalledForViz ? preDefinedECUs : [];
                            var parsedECUs = parsePostgresData(res.data);
                            _.forEach(parsedECUs, function (projectObj) {
                                ecus.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (ecus[0] && ecus[0].totalItems > ecus.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + ecus[ecus.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetECUs({sql: sqlString}, ecus, true, jobInput);
                            } else {
                                vm.ecusArr = _.cloneDeepWith(ecus);
                                vm.fnGetJobs(jobInput, true)
                            }
                        }, function () { // Error block
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_ecus ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetECUs({sql: projectSQL}, [], false, jobInput);
                        })
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.jobsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedJobsArr = [];
                                vm.selectedJobObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.job', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowJobStats = tab.id === "jobStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            $timeout.cancel(vm.jobTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowJobStats = tab.id === "jobStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "jobStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor") {
                        $state.go('main.job', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedJobObj = [];
                        vm.selectedJobObj = {};
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.jobTableAPITimeout);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.job', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#jobTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (jobObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.jobsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === jobObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected Job array*/
                    var isValueFind = _.find(vm.selectedJobsArr, {'id': jobObj.id});
                    if (!isValueFind) {
                        vm.selectedJobsArr.push(jobObj);
                        var isTabExist = _.find(vm.tabs, {'id': jobObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: jobObj.id,
                                title: jobObj.requestTypeString,
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedJobsArr, function (obj) {
                            return jobObj.id === obj.id;
                        });
                    }
                    if (vm.selectedJobsArr.length === 1) {
                        vm.fnGetJobDetails(vm.selectedJobsArr[0])
                    } else {
                        $state.go('main.job', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.jobTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.job', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isJobsLoading = true;
                    vm.selectedJobsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'completedAt\' as completed_at, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'jobResult\' as job_result, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startedAt\' as started_at'+
                            'data->>\'startsAt\' as starts_at';
                    } else if (vm.selectedJobTable.name === 'ecu_active_jobs') {
                        sqlString = 'SELECT ' +
                            'data->>\'accountId\' as account_id, ' +
                            'data->>\'ecuId\' as ecu_id, ' +
                            'data->>\'expiresAt\' as expires_at, ' +
                            'data->>\'id\' as id, ' +
                            'data->>\'projectId\' as project_id, ' +
                            'data->>\'requestType\' as request_type, ' +
                            'data->>\'requestedBy\' as requested_by, ' +
                            'data->>\'startsAt\' as starts_at, ' +
                            'data->>\'payload\' as payload, ' +
                            'data->>\'payloadVersion\' as payload_version, ' +
                            'created_at, ' +
                            'updated_at';
                    } else {
                        sqlString = 'SELECT *';
                    }
                    if (sortString !== '') { //for specific sort
                        sqlString = ', data->>\'' + sortValue + '\' AS rt FROM ' + vm.selectedJobTable.name;
                    } else { //for general sort
                        sqlString = ', data->>\'_id\' AS rt FROM ' + vm.selectedJobTable.name;
                    }
                    if (isPerPageChanged) {
                        if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                            sqlString = 'SELECT ' +
                                'data->>\'accountId\' as account_id, ' +
                                'data->>\'completedAt\' as completed_at, ' +
                                'data->>\'ecuId\' as ecu_id, ' +
                                'data->>\'expiresAt\' as expires_at, ' +
                                'data->>\'id\' as id, ' +
                                'data->>\'jobResult\' as job_result, ' +
                                'data->>\'projectId\' as project_id, ' +
                                'data->>\'requestType\' as request_type, ' +
                                'data->>\'requestedBy\' as requested_by, ' +
                                'data->>\'startedAt\' as started_at';
                        } else if (vm.selectedJobTable.name === 'ecu_active_jobs') {
                            sqlString = 'SELECT ' +
                                'data->>\'accountId\' as account_id, ' +
                                'data->>\'ecuId\' as ecu_id, ' +
                                'data->>\'expiresAt\' as expires_at, ' +
                                'data->>\'id\' as id, ' +
                                'data->>\'projectId\' as project_id, ' +
                                'data->>\'requestType\' as request_type, ' +
                                'data->>\'requestedBy\' as requested_by, ' +
                                'data->>\'startsAt\' as starts_at, ' +
                                'data->>\'payload\' as payload, ' +
                                'data->>\'payloadVersion\' as payload_version, ' +
                                'created_at, ' +
                                'updated_at';
                        } else {
                            sqlString = 'SELECT *';
                        }
                        if (sortString !== '') {
                            // Extract sort field and ensure it has data->> prefix
                            var sortField = vm.sort.split(' ')[0];
                            var sortDirection = vm.sort.split(' ')[1];

                            // Ensure sortField has the data->> prefix if it's a JSON field and doesn't already have it
                            if (!sortField.includes('data->>') && !sortField.includes('.')) {
                                sortField = 'data->>\'' + sortField.replace(/^data->>\'|\'$/, '') + '\'';
                            }
                            sqlString += ', COUNT(*) OVER() as totalItems, ' +sortField + ' AS rt FROM ' + vm.selectedJobTable.name;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + sortField + ' ' + sortDirection + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString += ', COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + vm.selectedJobTable.name;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetJobs(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.jobsArr);
                        vm.previousPage = page;
                        vm.fnGetJobs(input, false);
                    }
                };

                vm.fnOpenJobInfoTab = function (jobObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(jobObj);
                };

                vm.fnGetJob = function (jobObj, jobsArr) {
                    angular.forEach(jobsArr, function (job) {
                        job.isCheck = false;
                    });
                    jobObj.isCheck = true;
                    vm.selectedJobsArr = [jobObj]; // Assign array with single job object
                    vm.fnGetJobDetails(jobObj);
                };

                vm.fnGetJobDetails = function (jobObj) {
                    vm.isJobDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when job is selected
                        vm.selectedJobObj = jobObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.job', {
                                selectedId: vm.selectedJobObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedJobObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isJobDetailsLoaded = true;
                        } else {
                            $state.go('main.job', {selectedId: vm.selectedJobObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedJobObj.id;
                            vm.isJobDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetStartedTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var tempDate = moment.unix(timestamp).format("MM/DD/YYYY");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var tempCurrentDate = moment.unix(moment().unix()).format("MM/DD/YYYY");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (moment(tempDate).isSame(tempCurrentDate)) {
                        if (differenceHours > 24) {
                            relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' on ' + moment.unix(timestamp).format("DD/MM/YYYY");
                        } else if (differenceHours > 1) {
                            relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' today';
                        } else {
                            relativeTime = moment(datetime).fromNow();
                        }
                    } else {
                        relativeTime = 'at ' + moment.unix(timestamp).format("HH:mm") + ' on ' + moment.unix(timestamp).format("DD/MM/YYYY");
                    }
                    return relativeTime;
                };

                vm.fnGetJobs = function (inputObj, isFirst) {
                    vm.isJobsLoading = true; // Show loading state

                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            // Clone the last SQL query for debugging or re-execution purposes
                            //vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse and process data using the updated parsePostgresData function
                            vm.jobsArr = parsePostgresData(res.data).map(function (job) {
                                // Additional processing for time fields
                                if (job.startsAt) {
                                    job.startsAtTime = vm.fnGetStartedTime(job.startsAt);
                                }
                                if (job.startedAt) {
                                    job.startedAtTime = vm.fnGetStartedTime(job.startedAt);
                                }
                                if (job.expiresAt) {
                                    job.expiresAtTime = vm.fnGetAbsoluteOrRelativeTime(job.expiresAt);
                                }
                                if (job.completedAt) {
                                    job.completedAtTime = vm.fnGetStartedTime(job.completedAt);
                                }
                                if (job.requestType) {
                                    job.requestTypeString = job.requestType.replace(/_/g, " ");
                                }
                                if (job.ecuId) {
                                    job.ecu = _.find(vm.ecusArr, { id: job.ecuId });
                                }
                                return job;
                            });

                            // Update total items and current page based on the first job's metadata
                            if (isFirst && vm.jobsArr.length) {
                                vm.totalItems = vm.jobsArr[0].totalItems || 0;
                                vm.currentPage = 1;
                            } else if (!vm.jobsArr.length) {
                                vm.totalItems = 0;
                                vm.currentPage = 1;
                            }

                            // Handle selected item if present
                            if ($stateParams.selectedId) {
                                var selectedJob = _.find(vm.jobsArr, { id: $stateParams.selectedId });
                                if (selectedJob) {
                                    vm.fnCheckUncheckHeader(selectedJob);
                                }
                            }

                            // Update state and pagination params
                            $state.go('main.job', {
                                openCreateView: '',
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, { notify: false });
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                            delete $stateParams.openCreateView;

                            vm.isJobsLoading = false; // Hide loading state
                            vm.isRefresh = false;

                            // Set table height after rendering
                            $timeout(vm.fnSetTableHeight);

                            // Refresh the table periodically
                            vm.jobTableAPITimeout = $timeout(vm.fnUpdateTableData, 60000);
                        }, function (error) {
                            // Error handling
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isJobsLoading = false;
                            vm.isRefresh = false;
                        });
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetJobDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetJobStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'jobStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowJobStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'jobStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowJobStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getJobsCsvData = function () {
                    var tempData = _.cloneDeepWith(vm.jobsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.jobsArr);
                    var ws = XLSX.utils.json_to_sheet(usersArrCp);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Jobs");
                    XLSX.writeFile(wb, "Jobs.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'job', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOrderFiltersArr = function () {
                    var tempArr = FiltersArrOrder.map(function (i) {
                        return vm.searchFiltersArr.find(function (o) {
                            return o.displayName === i;
                        });
                    });
                    vm.searchFiltersArr = _.filter(tempArr, function (tempObj) {
                        return angular.isObject(tempObj);
                    });
                };

                vm.fnGetAssignee = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var users = isCalledForViz ? preDefinedProjects : [];
                            var parsedUsers = parsePostgresData(res.data);
                            _.forEach(parsedUsers, function (userObj) {
                                users.push({
                                    id: userObj.id,
                                    firstName: userObj.firstName,
                                    lastName: userObj.lastName,
                                    fullName: userObj.firstName + ' ' + userObj.lastName,
                                    email: userObj.email,
                                    userAvatar: angular.isDefined(userObj) ? AvatarService.getTextAvatar(userObj) : 'assets/images/svg/logo_color.svg'
                                });
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (users[0] && users[0].totalItems > users.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + users[users.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAssignee({sql: sqlString}, users, true);
                            } else {
                                vm.assigneeArr = _.cloneDeepWith(users);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Requested By",
                                            name: vm.selectedJobTable.name + ".requestedBy",
                                            localSearch: {
                                                type: 'objects',
                                                name: 'assignees',
                                                key: 'requestedBy'
                                            },
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.assigneeArr,
                                            displayKeyName: 'fullName',
                                            isShowId: true,
                                            isShowUserAvatar: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'email'
                                        }
                                    );
                                    vm.fnOrderFiltersArr();
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnAddDefaultSort = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'job', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        } else {
                            if (angular.isDefined($stateParams.sort)) {
                                var sortString = $stateParams.sort;
                                if (!sortString.includes('startedAt')) {
                                    if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                                        tempArr.sort = 'data->>\'startedAt\' desc';
                                        $stateParams.sort = 'data->>\'startedAt\' desc';
                                    } else {
                                        tempArr.sort = 'data->>\'startsAt\' desc';
                                        $stateParams.sort = 'data->>\'startsAt\' desc';
                                    }
                                }
                            } else {
                                if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                                    tempArr.sort = 'data->>\'startedAt\' desc';
                                    $stateParams.sort = 'data->>\'startedAt\' desc';
                                } else {
                                    tempArr.sort = 'data->>\'startsAt\' desc';
                                    $stateParams.sort = 'data->>\'startsAt\' desc';
                                }
                            }
                        }
                        $state.go("main.job", tempArr, {notify: false});
                    } else {
                        var tempSort = "";
                        if (angular.isDefined($stateParams.sort)) {
                            var sortString1 = $stateParams.sort;
                            if (!sortString1.includes('startedAt')) {
                                if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                                    tempSort = 'data->>\'startedAt\' desc';
                                    $stateParams.sort = 'data->>\'startedAt\' desc';
                                } else {
                                    tempSort = 'data->>\'startsAt\' desc';
                                    $stateParams.sort = 'data->>\'startsAt\' desc';
                                }
                            }
                        } else {
                            if (vm.selectedJobTable.name === 'ecu_completed_jobs') {
                                tempSort = 'data->>\'startedAt\' desc';
                                $stateParams.sort = 'data->>\'startedAt\' desc';
                            } else {
                                tempSort = 'data->>\'startsAt\' desc';
                                $stateParams.sort = 'data->>\'startsAt\' desc';
                            }
                        }
                        $state.go("main.job", {sort: tempSort}, {notify: false});
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeJobChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnUpdateTableData = function () {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            vm.jobsArr = [];
                            _.forEach(res.data, function (nodeObj, index) {
                                delete vm.jobsArr[index];
                                vm.jobsArr[index] = nodeObj;
                                if (vm.jobsArr[index].startsAt) {
                                    vm.jobsArr[index].startsAtTime = vm.fnGetStartedTime(vm.jobsArr[index].startsAt);
                                }
                                if (vm.jobsArr[index].startedAt) {
                                    vm.jobsArr[index].startedAtTime = vm.fnGetStartedTime(vm.jobsArr[index].startedAt);
                                }
                                if (vm.jobsArr[index].expiresAt) {
                                    vm.jobsArr[index].expiresAtTime = vm.fnGetAbsoluteOrRelativeTime(vm.jobsArr[index].expiresAt);
                                }
                                if (vm.jobsArr[index].completedAt) {
                                    vm.jobsArr[index].completedAtTime = vm.fnGetStartedTime(vm.jobsArr[index].completedAt);
                                }
                                if (vm.jobsArr[index].requestType) {
                                    vm.jobsArr[index].requestTypeString = vm.jobsArr[index].requestType.replace(/_/g, " ")
                                }
                                if (vm.jobsArr[index].ecuId) {
                                    vm.jobsArr[index].ecu = _.find(vm.ecusArr, {id: vm.jobsArr[index].ecuId});
                                }
                            })
                            vm.jobTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.jobTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        })
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                vm.fnInitJobs = function () {
                    vm.permissionObj = {};
                    //vm.fnGetLastFilterQuery();
                    //vm.selectedJobTable = UserProfileService.fnGetUserProfileObj('node', 'job', 'selectedJobType');
                    var selectedJobType = UserProfileService.fnGetUserProfileObj('node', 'job', 'selectedJobType');
                    if (selectedJobType !== '') {
                        vm.selectedJobTable = selectedJobType;
                    } else {
                        vm.selectedJobTable = vm.jobTablesArr[0];
                    }
                    vm.fnAddDefaultSort();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'job', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                    var assigneeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM access_users ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAssignee({sql: assigneeSQL}, [], false);
                };

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.jobTableAPITimeout);
                })

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('HealthCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, HealthFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, ColorService, ProjectHealthService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Healths Variables
                vm.isHealthsLoading = false;
                vm.healthsArr = [];
                vm.selectedHealthsArr = [];
                vm.selectedHealthObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.healthResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowHealthStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditHealthObj = {};

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Map health values to display names and determine styles
                            var healthInfo = {
                                name: parsedData.name || '',         // This will be "Healthy", "Minor", etc.
                                displayValue: parsedData.name || '', // Use the name as the display value
                                value: parsedData.value || 0,        // Numeric value (200, 300, etc.)
                                color: parsedData.color || ''        // Use the color from the data
                            };

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core health fields
                                id: item.id || parsedData.id || '',
                                name: parsedData.name || '',
                                description: parsedData.description || '',

                                // Health-specific fields
                                healthName: healthInfo.name,           // The display name ("Healthy", "Minor", etc)
                                healthValue: healthInfo.value,         // The numeric value
                                healthDisplayValue: healthInfo.displayValue, // What should be shown in the UI
                                value: healthInfo.value,               // Keep original value
                                color: healthInfo.color,               // Use color from data

                                // Metadata fields
                                accountId: parsedData.accountId || '',
                                projectId: parsedData.projectId || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: item.updated_at || '',

                                // Pagination and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation and update times
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            if (item.updated_at) {
                                var updatedTimestamp = moment(item.updated_at);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };
                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.healthContextMenu = function (healthObj) {
                    if (Object.keys(vm.resetEditHealthObj).length) {
                        var isFindHealth = _.find(vm.healthsArr, {id: vm.resetEditHealthObj.id});
                        if (isFindHealth) {
                            vm.fnCancelHealthEditMode(isFindHealth);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            healthObj.isEditable = true;
                            vm.resetEditHealthObj = angular.copy(healthObj);
                        }
                    }]
                };

                vm.fnCancelHealthEditMode = function (healthObj, isSuccessCall) {
                    if (isSuccessCall) {
                        healthObj.name = angular.copy(healthObj.name);
                        healthObj.description = angular.copy(healthObj.description);
                        healthObj.isEditable = false;
                        vm.resetEditHealthObj = {};
                    } else {
                        healthObj.name = angular.copy(vm.resetEditHealthObj.name);
                        healthObj.isEditable = false;
                        vm.resetEditHealthObj = {};
                    }
                };

                vm.fnSaveHealthInfo = function (healthObj) {
                    healthObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        healthId: healthObj.id
                    };
                    inputObj.body = {
                        name: healthObj.name,
                        description: healthObj.description
                    };
                    HealthFactory.updateNodeHealth(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.healthsArr, function (healthObj) {
                                if (Object.keys(vm.selectedHealthObj).length) {
                                    if (healthObj.id === vm.selectedHealthObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedHealthObj[key] = val;
                                            healthObj[key] = val;
                                        });
                                    }
                                }
                                if (healthObj.id === resetCopy.id) {
                                    healthObj.name = resetCopy.name;
                                    healthObj.description = resetCopy.description;
                                    if (resetCopy.createdAt) {
                                        healthObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.createdAt);
                                    }
                                    if (resetCopy.updatedAt) {
                                        healthObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.updatedAt);
                                    }
                                }
                            });
                            vm.fnCancelHealthEditMode(healthObj, true);
                            amaran.success("Health Updated Successfully");
                            var tempHealthData = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                            if (tempHealthData && tempHealthData.length) {
                                var isFindHealth = _.find(tempHealthData, {id: response.id})
                                if (isFindHealth) {
                                    angular.forEach(healthObj, function (val, key) {
                                        isFindHealth[key] = val;
                                    });
                                }
                                ColorService.fnSetHealthData(tempHealthData);
                                vm.updateProjectRelationHealthData();
                            }
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelHealthEditMode(healthObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'health', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isHealthsLoading = true;
                    vm.selectedHealthsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_healths';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_healths';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetHealths(input, true);
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.healthsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedHealthsArr = [];
                                vm.selectedHealthObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.health', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Health";
                        vm.isShowHealthStats = tab.id === "healthStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Health";
                    vm.isShowHealthStats = tab.id === "healthStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Health" || tab.id === "Create Issue" || tab.id === "healthStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.health', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedHealthObj = [];
                        vm.selectedHealthObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Health") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.health', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#healthTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (healthObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_HEALTH) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.healthsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === healthObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Health array*/
                        var isValueFind = _.find(vm.selectedHealthsArr, {'id': healthObj.id});
                        if (!isValueFind) {
                            vm.selectedHealthsArr.push(healthObj);
                            var isTabExist = _.find(vm.tabs, {'id': healthObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: healthObj.id,
                                    title: healthObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedHealthsArr, function (obj) {
                                return healthObj.id === obj.id;
                            });
                        }
                        if (vm.selectedHealthsArr.length === 1) {
                            vm.fnGetHealthDetails(vm.selectedHealthsArr[0])
                        } else {
                            $state.go('main.health', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.healthsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedHealthsArr = angular.copy(vm.healthsArr);
                    } else {
                        vm.selectedHealthsArr = [];
                    }
                    $state.go('main.health', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedHealthsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Health'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Health',
                                title: 'Create Health',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.health', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isHealthsLoading = true;
                    vm.selectedHealthsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_healths';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_healths';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_healths';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_healths';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetHealths(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.healthsArr);
                        vm.previousPage = page;
                        vm.fnGetHealths(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnOpenHealthInfoTab = function (healthObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(healthObj);
                };

                vm.fnGetHealth = function (healthObj, healthsArr) {
                    angular.forEach(healthsArr, function (health) {
                        health.isCheck = false;
                    });
                    healthObj.isCheck = true;
                    vm.selectedHealthsArr = [healthObj]; // Assign array with single health object
                    vm.fnGetHealthDetails(healthObj);
                };

                vm.fnGetHealthDetails = function (healthObj) {
                    vm.isHealthDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when health is selected
                        vm.selectedHealthObj = healthObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.health', {
                                selectedId: vm.selectedHealthObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedHealthObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isHealthDetailsLoaded = true;
                        } else {
                            $state.go('main.health', {selectedId: vm.selectedHealthObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedHealthObj.id;
                            vm.isHealthDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetHealthColor = function (healthCode, healthObj) {
                    var healthStyle = ColorService.getHealthColorForLoop(healthObj.projectId, healthCode);
                    healthObj.healthName = healthStyle.content;
                    return healthStyle;
                };

                vm.fnGetHealths = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            res.data = vm.parsePostgresData(res.data);
                            vm.healResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.healResponse.data && vm.healResponse.data.length) {
                                    vm.totalItems = vm.healResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.healResponse.data.reverse();
                            }
                            vm.healthsArr = vm.healResponse.data;
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetLabel(res[0], vm.healthsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var labelData = _.find(vm.healthsArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.health') {
                                $state.go('main.health', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isRefresh = false;
                            vm.isHealthsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isHealthsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("HealthDeleted", function (evt, data) {
                    vm.selectedHealthObj = null;
                    vm.selectedHealthsArr = [];
                    vm.healthsArr = vm.healthsArr.filter(function (healthObj) {
                        return (healthObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.health', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                    var tempHealthData = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                    if (tempHealthData && tempHealthData.length) {
                        tempHealthData = tempHealthData.filter(function (healthObj) {
                            return (healthObj.id !== data.id);
                        });
                        ColorService.fnSetHealthData(tempHealthData);
                        vm.updateProjectRelationHealthData();
                    }
                });

                $scope.$on("HealthDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.healthsArr, function (healthObj) {
                        if (healthObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                data[key] = val;
                                healthObj[key] = val;
                                vm.selectedHealthObj[key] = val;
                            });
                        }
                    });
                    vm.updateProjectRelationHealthData();
                });

                $scope.$on("healthAdded", function (evt, data) {
                    vm.fnRemoveTab('Create Health');
                    var tempHealthData = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                    tempHealthData.push(data);
                    ColorService.fnSetHealthData(tempHealthData);
                    vm.updateProjectRelationHealthData();
                });

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'health', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.health", tempArr, {notify: false});
                    }
                };

                vm.fnInitHealths = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    vm.projectsArr = AppInitService.getInitData('nodeProjectsArr');
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && vm.projectsArr && vm.projectsArr.length) {
                        $timeout(function () {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: "projectId",
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                        });
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false);
                    }
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'health', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetHealthDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetHealthStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'healthStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowHealthStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'healthStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowHealthStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetHealthRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isHealthRelationshipsDataLoading = true;
                vm.newHealthsArr = [];

                vm.fnInitHealthRelationships = function () {
                    vm.isHealthRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    var healthSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_healths ORDER BY rt asc LIMIT ' + 100 + ';';
                    vm.fnGetAllHealthData({sql: healthSQL}, [], false);
                };

                vm.fnGetAllHealthData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var healths = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                healths.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (healths[0] && healths[0].totalItems > healths.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_healths';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + healths[healths.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetAllHealthData({sql: sqlString}, healths, true);
                            } else {
                                vm.newHealthsArr = _.cloneDeepWith(healths);
                                vm.fnGetAllProjects();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetAllProjects = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                            flat[projectObj.id].healths = _.cloneDeepWith(_.filter(vm.newHealthsArr, {projectId: projectObj.id}));
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.newProjectData = [vm.newProjectData];
                        vm.isHealthRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                    flat[projectObj.id].healths = _.cloneDeepWith(_.filter(vm.newHealthsArr, {projectId: projectObj.id}));
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.newProjectData = [vm.newProjectData];
                                vm.isHealthRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight + 10;
                        n.width = n.scrollWidth + 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getHealthCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.healthsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.healthsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Healths");
                    XLSX.writeFile(wb, "Healths.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'health', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeHealthChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.updateProjectRelationHealthData = function () {
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        vm.projectsArr = AppInitService.getInitData('nodeProjectsArr');
                        var project = _.find(vm.projectsArr, function (project) {
                            return angular.isUndefined(project.parentProjectId);
                        });
                        ProjectHealthService.fnSetProjectRelationshipHealthArr(project.id);
                    } else {
                        var rootProjectSQL = {"sql": "select * from node_projects where data->>\'parentProjectId\' IS NULL"};
                        QueryFactory.executeQuery(rootProjectSQL)
                            .then(function (res) {
                                if (res && res.data && res.data.length) {
                                    var rootProject = res.data[0];
                                    ProjectHealthService.fnSetProjectRelationshipHealthArr(rootProject.id);
                                }
                            }, function () { // Error block

                            })
                    }
                }

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var healthKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.health') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_HEALTH &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedHealthsArr.length > 1 && vm.permissionObj.DELETE_HEALTH &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleHealths(vm.selectedHealthsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var healthKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.health') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', healthKeyDownEventHandler);
                document.addEventListener('keyup', healthKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', healthKeyDownEventHandler);
                    document.removeEventListener('keyup', healthKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('GatewayCtrl',
            function ($scope, $window, L, Paho, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB, Authenticate,
                      SortIconService, LastPageService, PermissionsService, PaginationService, IconService, ColorService, FedSudoUserService,
                      jsonToCsvConvertService, XLSX, AppInitService, WebSocketFactory, UserFactory, BatchFactory, GatewayFactory,
                      TypeFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;
                var client;
                var markerLayers = [];
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedGatewayId = '';

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "Phase",
                        fieldName: "phase"
                    },
                    {
                        fieldDisplayName: "Connection",
                        fieldName: "connection"
                    },
                    {
                        fieldDisplayName: "TypeId",
                        fieldName: "typeId"
                    },
                    {
                        fieldDisplayName: "Health",
                        fieldName: "health"
                    },
                    {
                        fieldDisplayName: "DefaultHealth",
                        fieldName: "defaultHealth"
                    }
                ];
                vm.filterQuery = "";

                vm.tabs = [
                    {
                        name: 'Table View',
                        icon: "fa-table",
                        tabIndex: 0
                    },
                    {
                        name: 'Geo Map',
                        icon: "fa-map-marker",
                        tabIndex: 1

                    },
                    {
                        name: 'Grid View',
                        icon: "fa-th-large",
                        tabIndex: 2
                    },
                    {
                        name: 'Tree Map',
                        icon: "fa-trello",
                        tabIndex: 3
                    }
                ];
                vm.selectedTab = {};

                vm.tableOptionsObj = {
                    name: true,
                    description: true,
                    phase: true,
                    connection: true,
                    health: true
                };
                vm.tableSectionView = true;
                vm.infoSectionView = true;
                vm.tableClass = 'col-sm-6';
                vm.infoSectionClass = 'col-sm-6';
                vm.csvHeaderArr = [];

                //Listener Variables
                vm.isGatewaysLoading = false;
                vm.gatewaysArr = [];
                vm.typesArr = [];
                vm.deviceTypesArr = [];
                vm.selectedGatewaysArr = [];
                vm.selectedGatewayObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;
                vm.tabIndex = 0;
                vm.isDropUp = false;
                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };
                //API params Variable
                vm.inputObj = {};
                /*Start: Context Menu*/
                vm.resetEditGatewayObj = {};

                vm.gatewayContextMenu = function (gatewayObj) {
                    if (Object.keys(vm.resetEditGatewayObj).length) {
                        var isFindGateway = _.find(vm.gatewaysArr, {id: vm.resetEditGatewayObj.id});
                        if (isFindGateway) {
                            vm.fnCancelGatewayEditMode(isFindGateway);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            gatewayObj.isEditable = true;
                            vm.resetEditGatewayObj = angular.copy(gatewayObj);
                        }
                    }]
                };

                vm.fnCancelGatewayEditMode = function (gatewayObj, isSuccessCall) {
                    if (isSuccessCall) {
                        gatewayObj.name = angular.copy(gatewayObj.name);
                        gatewayObj.description = angular.copy(gatewayObj.description);
                        gatewayObj.isEditable = false;
                        vm.resetEditGatewayObj = {};
                    } else {
                        gatewayObj.name = angular.copy(vm.resetEditGatewayObj.name);
                        gatewayObj.description = angular.copy(vm.resetEditGatewayObj.description);
                        gatewayObj.isEditable = false;
                        vm.resetEditGatewayObj = {};
                    }
                };

                vm.fnSaveGatewayInfo = function (gatewayObj) {
                    gatewayObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        gatewayId: gatewayObj.id
                    };
                    inputObj.body = {
                        name: gatewayObj.name,
                        description: angular.isUndefined(gatewayObj.description) ? '' : gatewayObj.description
                    };
                    GatewayFactory.modifyGateway(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.gatewaysArr, function (gatewayObj) {
                                if (Object.keys(vm.selectedGatewayObj).length) {
                                    if (gatewayObj.id === vm.selectedGatewayObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedGatewayObj[key] = val;
                                            gatewayObj[key] = val;
                                        });
                                    }
                                }
                                if (gatewayObj.id === resetCopy.id) {
                                    gatewayObj.name = resetCopy.name;
                                    gatewayObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelGatewayEditMode(gatewayObj, true);
                            amaran.success("Gateway Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelGatewayEditMode(gatewayObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    if (vm.selectedTab.tabIndex !== 0) {
                        if (vm.selectedTab.tabIndex === 1) {
                            vm.fnSetMapHeight();
                        } else if (vm.selectedTab.tabIndex === 3) {
                            vm.fnSetTreeMapHeight();
                        } else {
                            vm.fnSetTableHeight();
                        }
                    } else {
                        vm.fnSetTableHeight();
                    }
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isGatewaysLoading = true;
                    vm.filterQuery = filterQuery;

                    if (vm.selectedTab.tabIndex === 0) {
                        if ($stateParams.perPage) {
                            if ($stateParams.perPage === '0') {
                                perPage = FedSudoUserService.fnGetUserData('perPage');
                                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                            } else {
                                vm.perPage = Math.ceil($stateParams.perPage)
                            }
                        } else {
                            perPage = FedSudoUserService.fnGetUserData('perPage');
                            vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                        }
                    } else {
                        if ($stateParams.perPage && vm.selectedTab.tabIndex === '0') {
                            if ($stateParams.perPage === '0') {
                                perPage = FedSudoUserService.fnGetUserData('perPage');
                                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                            } else {
                                vm.perPage = Math.ceil($stateParams.perPage)
                            }
                        } else if (vm.selectedTab.tabIndex !== '0') {
                            vm.perPage = 0
                        }
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            perPage: vm.perPage
                        };
                    }

                    if (vm.selectedTab.tabIndex === 0) {
                        if ($stateParams.next) {
                            inputObj.next = $stateParams.next
                        } else if ($stateParams.previous) {
                            inputObj.previous = $stateParams.previous
                        }
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetGateways(inputObj);
                    } else {
                        vm.gatewaysArr = [];
                        vm.isGatewaysLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetMapHeight = function () {
                    if (vm.selectedTab.tabIndex === 1 &&
                        angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;

                        var finalHeight = total - (search + searchTag + 70);
                        angular.element("#map1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTreeMapHeight = function () {
                    if (vm.selectedTab.tabIndex === 3 &&
                        angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;

                        var finalHeight = total - (search + searchTag + 70);
                        angular.element("#treeMap").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.gatewaysArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedGatewaysArr = angular.copy(vm.gatewaysArr);
                    } else {
                        vm.selectedGatewaysArr = [];
                    }
                    $state.go('main.gateway', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetGateway = function (gatewayObj, gatewaysArr, isCalledFromDirective) {
                    angular.forEach(gatewaysArr, function (gateway) {
                        gateway.isCheck = false;
                    });
                    gatewayObj.isCheck = true;
                    vm.selectedGatewaysArr = [gatewayObj]; // Assign array with single gateway object
                    vm.fnGetGatewayDetails(gatewayObj, isCalledFromDirective);
                };

                vm.fnGetGatewayDetails = function (gatewayObj, isCalledFromDirective) {
                    vm.isGatewayDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when gateway is selected
                        vm.selectedGatewayObj = gatewayObj;
                        if (vm.tabIndex !== 0) {
                            $state.go('main.gateway', {
                                selectedId: vm.selectedGatewayObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedGatewayObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isGatewayDetailsLoaded = true;
                        } else {
                            $state.go('main.gateway', {
                                selectedId: vm.selectedGatewayObj.id
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedGatewayObj.id;
                            vm.isGatewayDetailsLoaded = true;
                        }

                    });
                    if (isCalledFromDirective) {
                        $scope.$apply();
                    }
                };

                vm.fnCheckUncheckHeader = function (gatewayObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.gatewaysArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === gatewayObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected gateways array*/
                    var isValueFind = _.find(vm.selectedGatewaysArr, {'id': gatewayObj.id});
                    if (!isValueFind) {
                        vm.selectedGatewaysArr.push(gatewayObj)
                    } else {
                        _.remove(vm.selectedGatewaysArr, function (obj) {
                            return gatewayObj.id === obj.id;
                        });
                    }
                    if (vm.selectedGatewaysArr.length === 1) {
                        vm.fnGetGatewayDetails(vm.selectedGatewaysArr[0])
                    } else {
                        $state.go('main.gateway', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleGateways = function (selectedGatewaysArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedGatewaysArr, function (selectedGateway, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/gateways/" + selectedGateway.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/gateways/" + selectedGateway.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected gateways?",
                            text: "You are about to permanently delete the selected gateways.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'gateway',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedGatewaysArr, function (selectedGateway) {
                                    angular.forEach(vm.gatewaysArr, function (gatewayObj, index) {
                                        if (selectedGateway.id === gatewayObj.id) {
                                            vm.gatewaysArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedGatewaysArr.length;
                                vm.selectedGatewayObj = null;
                                vm.selectedGatewaysArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });


                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedGatewaysArr, function (selectedGateway) {
                                    angular.forEach(vm.gatewaysArr, function (gatewayObj, index) {
                                        if (selectedGateway.id === gatewayObj.id) {
                                            vm.gatewaysArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedGatewaysArr.length;
                                vm.selectedGatewayObj = null;
                                vm.selectedGatewaysArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetGateways = function (inputObj) {
                    GatewayFactory.getGateways(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.gateways;
                            if (paginationObj.next && paginationObj.next.next) {
                                vm.nextCollection = paginationObj.next.next;
                            } else {
                                vm.nextCollection = "";
                            }
                            if (paginationObj.first) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = "";
                            } else {
                                vm.isPrevVisible = false;
                                vm.prevCollection = "";
                            }
                            if (paginationObj.previous && paginationObj.previous.previous) {
                                vm.isPrevVisible = true;
                                vm.prevCollection = paginationObj.previous.previous
                            }
                            vm.gatewaysArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            //vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var gatewayData = _.find(vm.gatewaysArr, {"id": $stateParams.selectedId});
                                if (gatewayData) {
                                    if (vm.selectedTab.tabIndex !== 0) {
                                        if (vm.selectedTab.tabIndex === 1 || vm.selectedTab.tabIndex === 3) {
                                            vm.fnGetGateway(gatewayData, vm.gatewaysArr);
                                        }
                                    } else {
                                        vm.fnGetGateway(gatewayData, vm.gatewaysArr);
                                    }
                                }
                            }
                            if (addedGatewayId.length) {
                                vm.fnOpenPostCreateActionModal(addedGatewayId);
                                addedGatewayId = '';
                            }
                            if ($state.current.name === 'main.gateway') {
                                $state.go('main.gateway', {
                                    perPage: vm.perPage,
                                    next: inputObj.next ? inputObj.next : "",
                                    previous: inputObj.previous ? inputObj.previous : ""
                                }, {notify: false});
                                $stateParams.perPage = vm.perPage;
                                $stateParams.next = inputObj.next;
                                $stateParams.previous = inputObj.previous;
                            }

                            if (vm.selectedTab.tabIndex === 1) {
                                vm.fnInitGeomapLayout();
                            } else {
                                vm.isGatewaysLoading = false;
                                vm.isRefresh = false;
                            }

                            $timeout(function () {
                                if (vm.selectedTab.tabIndex !== 0) {
                                    if (vm.selectedTab.tabIndex !== 0) {
                                        if (vm.selectedTab.tabIndex === 1) {
                                            vm.fnSetMapHeight();
                                        } else if (vm.selectedTab.tabIndex === 3) {
                                            angular.element($window).triggerHandler('resize')
                                        }
                                    } else {
                                        vm.fnSetTableHeight();
                                    }
                                } else {
                                    vm.fnSetTableHeight();
                                }
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isGatewaysLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (perPage) {
                    //vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.gateway', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetGateways(vm.inputObj);
                };

                vm.fnGetNextPrevCollection = function (collectionKey, collection, perPage) {
                    $state.go('main.gateway', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            perPage: vm.perPage
                        };
                    }

                    if (collection.length) {
                        vm.inputObj[collectionKey] = collection;
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isGatewaysLoading = true;
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetGateways(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.gatewaySort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "gatewaySort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.gatewaySort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnGatewaySort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    } else {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('gatewaySort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('gatewaySort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('gatewaySort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedGatewaysArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnGetHealthColor = function (health, gatewayObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    gatewayObj.healthName = healthObj.content;
                    if (gatewayObj.healthName === health) {
                        gatewayObj.toolTipName = health;
                    } else {
                        gatewayObj.toolTipName = gatewayObj.healthName + " " + health;
                    }
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return IconService.fnGetConnectionIcon(connection);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetConnectionIconColor = function (connection) {
                    return ColorService.getConnectionColor(connection);
                };

                $scope.$on("GatewayDeleted", function (evt, data) {
                    vm.selectedGatewayObj = null;
                    vm.selectedGatewaysArr = [];
                    vm.gatewaysArr = vm.gatewaysArr.filter(function (gatewayObj) {
                        return (gatewayObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.gateway', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("GatewayDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.gatewaysArr, function (gatewayObj) {
                        if (gatewayObj.id === vm.selectedGatewayObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedGatewayObj[key] = val;
                                gatewayObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("gatewayAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedGatewayId = '';
                    } else {
                        if (vm.permissionObj.List) {
                            addedGatewayId = data;
                        } else {
                            addedGatewayId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnSetSelectedTab = function (tabId) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        loginUser = DB.fnGet('loginUser');
                        var inputObj = {
                            userId: loginUser.id,
                            body: {}
                        };

                        if (angular.isDefined(tabId) && tabId.length) {
                            if (loginUser.data) {
                                loginUser.data.selectedTabGatewayVisualizer = ["" + tabId + ""];
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body.selectedTabGatewayVisualizer = ["" + tabId + ""];
                            }
                        } else {
                            if (loginUser.data) {
                                delete loginUser.data.selectedTabGatewayVisualizer;
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body = {}
                            }
                        }
                        UserFactory.updateUserData(inputObj)
                            .then(function (data) {
                                loginUser.data = data;
                                DB.fnSet('loginUser', loginUser);
                            }, function () {
                            });
                    } else {
                        if (angular.isDefined(tabId) && tabId.length) {
                            FedSudoUserService.fnSetUserData('selectedTabGatewayVisualizer', ["" + tabId + ""]);
                        } else {
                            if (loginUser.data) {
                                FedSudoUserService.fnRemoveUserData('selectedTabGatewayVisualizer');
                            }
                        }
                    }
                };

                vm.fnTabChanged = function (tabObj, isCalledFromInit) {
                    vm.selectedTab = tabObj;
                    vm.gatewaysArr = [];
                    $state.go("main.gateway", {filter: ''}, {notify: false});
                    $timeout(function () {
                        if (!isCalledFromInit) {
                            vm.fnReload();
                        }
                    });
                    if (vm.selectedTab.tabIndex !== 0) {
                        vm.fnSetSelectedTab(vm.selectedTab.name);
                    } else {
                        vm.fnSetSelectedTab()
                    }
                };

                vm.fnInitGeomapLayout = function () {
                    //vm.gatewaysArr[0].data = {"latitude": [21.1702], "longitude": [72.8311]};
                    //vm.gatewaysArr[1].data = {"latitude": [13.0827], "longitude": [80.2707]};
                    var loc = {};
                    var locations = [];
                    angular.forEach(vm.gatewaysArr, function (dataObj) {
                        loc = {};
                        if (angular.isDefined(dataObj) && angular.isDefined(dataObj.location)) {
                            var latLongArr = dataObj.location.split(',');
                            loc = {dataObj: dataObj};
                            loc.lat = latLongArr[0];
                            loc.lng = latLongArr[1];
                            if (Object.keys(loc).length && loc.lat && loc.lng) {
                                locations.push(loc);
                            }
                        }
                    });
                    vm.fnRenderMap(locations);
                };

                vm.fnRenderMap = function (locations) {
                    document.getElementById('gatewayMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                    $timeout(function () {
                        var mapOptions = {};
                        if (locations.length > 0) {
                            mapOptions.center = [locations[0].lat, locations[0].lng];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        } else {
                            mapOptions.center = [39.721712, -104.941406];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        }
                        var map = new L.Map('map1', mapOptions);
                        setMarkers(map, locations);
                    });
                };

                function setMarkers(map, locations) {
                    if (locations.length > 0) {
                        var markerClusterGroup = L.markerClusterGroup();
                        angular.forEach(locations, function (value) {
                            if (angular.isDefined(value.lat) && angular.isDefined(value.lng)) {
                                var typeObj = _.find(vm.typesArr, {'id': value.dataObj.typeId});
                                var typeName = '';
                                if (typeObj) {
                                    typeName = typeObj.name;
                                } else {
                                    typeName = value.dataObj.typeId;
                                }
                                var healthObj = ColorService.getHealthColorForLoop(value.dataObj.health);
                                var svg = '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.068 125" enable-background="new 0 0 56.068 100" xml:space="preserve">' +
                                    '<path stroke="black" stroke-width="2" fill="' + healthObj['background-color'] + '" d="M28.034,0C12.552,0,0,12.552,0,28.034S28.034,100,28.034,100s28.034-56.483,28.034-71.966S43.517,0,28.034,0z' +
                                    'M28.034,40.477c-6.871,0-12.442-5.572-12.442-12.442c0-6.872,5.571-12.442,12.442-12.442c6.872,0,12.442,5.57,12.442,12.442' +
                                    'C40.477,34.905,34.906,40.477,28.034,40.477z"/>' +
                                    ' </svg>';
                                var icon = L.icon({
                                    iconUrl: 'data:image/svg+xml;base64,' + btoa(svg),
                                    iconSize: [25, 41], // size of the icon
                                    shadowSize: [50, 64], // size of the shadow
                                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                                    shadowAnchor: [4, 62],  // the same for the shadow
                                    popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
                                });
                                var marker = L.marker([value.lat, value.lng], {icon: icon});
                                markerLayers[value.dataObj.id] = marker;
                                var contentString = '<div>' +
                                    '<h3>' + value.dataObj.name + '</h3>' +
                                    '<div class="m-t-4">' +
                                    '<button class="btn btn-xs btn-default ellipsis-label"' +
                                    'uib-tooltip="health"' +
                                    'tooltip-placement="right"' +
                                    'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                    '<span>' + healthObj.content + '</span>' +
                                    ' </button>' +
                                    '<div class="pull-right">' +
                                    '<span class="m-l-10 m-r-5 m-t-5 fa ' + vm.fnGetConnectionIcon(value.dataObj.connection) + '"' +
                                    'uib-tooltip="' + value.dataObj.connection + '"' +
                                    'tooltip-placement="left"' +
                                    'style="color:' + vm.fnGetConnectionIconColor(value.dataObj.connection).color + '"' +
                                    '</span>' +
                                    '</div>' +
                                    '<div class="pull-right">' +
                                    '<span class="m-r-5 deviceInfoPageIcon phaseIconBorder"' +
                                    'uib-tooltip="' + value.dataObj.phase + '"' +
                                    'tooltip-placement="left"' +
                                    'style="border-color:' + vm.fnGetPhaseIconBorderColor(value.dataObj.phase)['border-color'] + '">' +
                                    '<span class="' + vm.fnGetPhaseIcon(value.dataObj.phase) + '"></span>' +
                                    '</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '<p class="m-4">Type: ' + typeName + '</p>' +
                                    '<p class="m-4">Id: ' + value.dataObj.id + '</p>' +
                                    '</div>';
                                marker.bindPopup(contentString);
                                marker.on('click', function () {
                                    vm.fnGetGateway(value.dataObj, vm.gatewaysArr, true);
                                });
                                marker.on('mouseover', function () {
                                    this.openPopup(); //eslint-disable-line
                                });
                                markerClusterGroup.addLayer(marker);
                            }
                        });
                        map.addLayer(markerClusterGroup);
                    }
                    $timeout(function () {
                        map.invalidateSize()
                    }, 200);
                    vm.isGatewaysLoading = false;
                    vm.isRefresh = false;
                }

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.gatewaysArr, function (gateway) {
                        return gateway.id === messageJson.id;
                    });
                    if (index !== -1 && vm.gatewaysArr[index]) {
                        if (messageJson.health) {
                            vm.gatewaysArr[index].health = messageJson.health;
                        }
                        if (messageJson.phase) {
                            vm.gatewaysArr[index].phase = messageJson.phase;
                        }
                        if (messageJson.connection) {
                            vm.gatewaysArr[index].connection = messageJson.connection;
                        }
                        if (vm.selectedTab.tabIndex !== 0) {
                            if (vm.selectedTab.tabIndex === 3) {
                                angular.element($window).triggerHandler('resize');
                            } else if (vm.selectedTab.tabIndex === 1) {
                                var healthObj = ColorService.getHealthColorForLoop(vm.gatewaysArr[index].health);
                                var svg = '<svg version="1.0" id="' + vm.gatewaysArr[index].id + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.068 125" enable-background="new 0 0 56.068 100" xml:space="preserve">' +
                                    '<path stroke="black" stroke-width="2" fill="' + healthObj['background-color'] + '" d="M28.034,0C12.552,0,0,12.552,0,28.034S28.034,100,28.034,100s28.034-56.483,28.034-71.966S43.517,0,28.034,0z' +
                                    'M28.034,40.477c-6.871,0-12.442-5.572-12.442-12.442c0-6.872,5.571-12.442,12.442-12.442c6.872,0,12.442,5.57,12.442,12.442' +
                                    'C40.477,34.905,34.906,40.477,28.034,40.477z"/>' +
                                    '</svg>';
                                var icon = L.icon({
                                    iconUrl: 'data:image/svg+xml;base64,' + btoa(svg),
                                    iconSize: [25, 41], // size of the icon
                                    shadowSize: [50, 64], // size of the shadow
                                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                                    shadowAnchor: [4, 62],  // the same for the shadow
                                    popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
                                });
                                if (markerLayers[vm.gatewaysArr[index].id]) {
                                    markerLayers[vm.gatewaysArr[index].id].setIcon(icon);
                                    var contentString = '<div>' +
                                        '<h3>' + vm.gatewaysArr[index].name + '</h3>' +
                                        '<div class="m-t-4">' +
                                        '<button class="btn btn-xs btn-default ellipsis-label"' +
                                        'uib-tooltip="health"' +
                                        'tooltip-placement="right"' +
                                        'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                        '<span>' + healthObj.content + '</span>' +
                                        ' </button>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-l-10 m-r-5 m-t-5 fa ' + vm.fnGetConnectionIcon(vm.gatewaysArr[index].connection) + '"' +
                                        'uib-tooltip="' + vm.gatewaysArr[index].connection + '"' +
                                        'tooltip-placement="left"' +
                                        'style="color:' + vm.fnGetConnectionIconColor(vm.gatewaysArr[index].connection).color + '"' +
                                        '</span>' +
                                        '</div>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-r-5 deviceInfoPageIcon phaseIconBorder"' +
                                        'uib-tooltip="' + vm.gatewaysArr[index].phase + '"' +
                                        'tooltip-placement="left"' +
                                        'style="border-color:' + vm.fnGetPhaseIconBorderColor(vm.gatewaysArr[index].phase)['border-color'] + '">' +
                                        '<span class="' + vm.fnGetPhaseIcon(vm.gatewaysArr[index].phase) + '"></span>' +
                                        '</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<p class="m-4">Type Id: ' + vm.gatewaysArr[index].typeId + '</p>' +
                                        '<p class="m-4">Id: ' + vm.gatewaysArr[index].id + '</p>' +
                                        '</div>';
                                    markerLayers[vm.gatewaysArr[index].id].bindPopup(contentString);
                                }
                            }
                        }
                    }
                }


                vm.fnInitializeWebSockets = function () {
                    var sudoUserObj = DB.fnGet('sudo');
                    var federationObj = DB.fnGet('federation');
                    var webSocketId = '';
                    if (sudoUserObj) {
                        webSocketId = sudoUserObj.id.split("-")[0];
                    } else if (federationObj) {
                        webSocketId = federationObj.id.split("-")[1];
                    } else {
                        webSocketId = loginUser.id.split("-")[0];
                    }
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/gateways/" + webSocketId})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("gateway websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("gateway websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnGetTypes = function () {
                    if(AppInitService.getInitData('typesArr').length !== 0 ){
                        vm.typesArr = AppInitService.getInitData('typesArr');
                        vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                    }else{
                        TypeFactory.getTypes()
                            .then(function (response) {
                                vm.typesArr = response;
                                vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                            })
                    }
                };

                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getGatewayCSVData = function () {
                    var tempData = angular.copy(vm.gatewaysArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    if (data[0].indexOf('healthName') !== -1) {
                        data[0].splice(data[0].indexOf('healthName'), 1);
                    }
                    if (data[0].indexOf('toolTipName') !== -1) {
                        data[0].splice(data[0].indexOf('toolTipName'), 1);
                    }
                    if (data[0].indexOf('clusterIds') !== -1) {
                        data[0].splice(data[0].indexOf('clusterIds'), 1);
                    }
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (deviceObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = deviceObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var devicesArrCp = angular.copy(vm.gatewaysArr);
                    var tempData = _.map(devicesArrCp, function (tempObj) {
                        delete tempObj.toolTipName;
                        delete tempObj.healthName;
                        delete tempObj.clusterIds;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Gateways");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "gateways.xlsx");
                };

                vm.fnInitGateways = function () {
                    //vm.fnInitializeWebSockets();
                    //vm.fnGetTypes();
                    vm.permissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.isGatewayVisualizerLoaded = false;
                    var sortData = FedSudoUserService.fnGetUserData('gatewaySort');
                    if (sortData !== '') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                    if (vm.permissionObj.List) {
                        var selectedTabGatewayVisualizer = FedSudoUserService.fnGetUserData('selectedTabGatewayVisualizer');
                        var userChoice = selectedTabGatewayVisualizer === '' ? undefined : selectedTabGatewayVisualizer[0];
                        if (angular.isDefined(userChoice)) {
                            angular.forEach(vm.tabs, function (tabObj) {
                                if (tabObj && userChoice === tabObj.name) {
                                    vm.fnTabChanged(tabObj, true);
                                }
                            });
                            if (!Object.keys(vm.selectedTab).length) {
                                vm.selectedTab = vm.tabs[0];
                            }
                        } else {
                            vm.selectedTab = vm.tabs[0];
                        }
                    }
                    vm.isGatewayVisualizerLoaded = true;
                };

                vm.fnOpenPostCreateActionModal = function () { //selectedId
                    var optionsArr = [{
                        faIcon: "fa-sitemap",
                        subOptions: [{
                            displayText: "Register a new device",
                            isRedirect: true,
                            stateName: "main.device",
                            isVisible: PermissionsService.getPermissions('node:device').Create
                        }]
                    }, {
                        faIcon: "fa-binoculars",
                        subOptions: [{
                            displayText: "Create a new Observer",
                            isRedirect: true,
                            stateName: "main.observer",
                            isVisible: PermissionsService.getPermissions('node:observer').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.params) {
                                    $state.go(selectedOption.stateName, selectedOption.params);
                                } else {
                                    if (selectedOption.stateName.includes(".create")) {
                                        $state.go(selectedOption.stateName);
                                    } else {
                                        $state.go(selectedOption.stateName, {openCreateView: true});
                                    }
                                }
                            }
                        }, function () {
                        });
                    }
                };

                vm.fnGatewayTableFullScreen = function () {
                    if (vm.tableSectionView === true && vm.tableClass === 'col-sm-6') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = false;
                        vm.tableClass = 'col-sm-12';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    } else if (vm.tableSectionView === true && vm.tableClass === 'col-sm-12') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = true;
                        vm.tableClass = 'col-sm-6';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    }
                };

                vm.fnOpenGatewayInfoTab = function (gatewayObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnGetGateway(gatewayObj, vm.gatewaysArr);
                };

                $scope.$on("GatewayInfoSectionClick", function () {
                    if (vm.infoSectionView === true && vm.infoSectionClass === 'col-sm-6') {
                        vm.tableSectionView = false;
                        vm.infoSectionView = true;
                        vm.infoSectionClass = 'col-sm-12';
                    } else if (vm.infoSectionView === true && vm.infoSectionClass === 'col-sm-12') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = true;
                        vm.infoSectionClass = 'col-sm-6';
                        $timeout(function () {
                            if (vm.selectedTab.tabIndex !== 0) {
                                if (vm.selectedTab.tabIndex === 1) {
                                    vm.fnSetMapHeight();
                                } else if (vm.selectedTab.tabIndex === 3) {
                                    vm.fnSetTreeMapHeight();
                                } else {
                                    vm.fnSetTableHeight();
                                }
                            } else {
                                vm.fnSetTableHeight();
                            }
                        })
                    }
                });

                var gatewayKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.gateway') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedGatewaysArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleGateways(vm.selectedGatewaysArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var gatewayKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.gateway') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', gatewayKeyDownEventHandler);
                document.addEventListener('keyup', gatewayKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    if (client) {
                        client.disconnect();
                    }
                    document.removeEventListener('keydown', gatewayKeyDownEventHandler);
                    document.removeEventListener('keyup', gatewayKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FleetCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, NodeEcuFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, copyService, $log) {
                var vm = this;
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitEcu = true;

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Registered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'true\'',
                        localSearchValue: 'obj.registered === true'
                    }, {
                        displayName: "Unregistered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'false\'',
                        localSearchValue: 'obj.registered === false'
                    }, {
                        displayName: "Phase",
                        name: "data->>\'phase\'",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->\'connected\' = \'false\' or data->\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'health', displayName: 'Health'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                vm.ecuProjectFilter = "$";
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};

                //Ecus Variables
                vm.isEcusLoading = false;
                vm.ecusArr = [];
                vm.selectedEcusArr = [];
                vm.selectedEcuObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                vm.isRefresh = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.ecuResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowEcuStats = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                /*function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map essential fields from parsed data
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.health = parsedData.health || 0;
                                parsedItem.nodeId = parsedData.nodeId || parsedData.nodeid || parsedItem.nodeId || parsedItem.nodeid;
                                parsedItem.ecuId = parsedData.ecuId || parsedData.ecuid || parsedItem.ecuId || parsedItem.ecuid;
                                parsedItem.projectId = parsedData.projectId || parsedData.projectid || parsedItem.projectId || parsedItem.projectid;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedData.description || '';

                                // Connection status
                                parsedItem.connected = parsedData.connected === true || parsedData.connected === 'true';

                                // Registration status
                                parsedItem.registered = parsedData.registered === true || parsedData.registered === 'true';

                                // Phase status (with validation)
                                var validPhases = ['UNREGISTERED', 'REGISTERING', 'ACTIVE', 'PENDING_RETURN', 'DEREGISTERED'];
                                parsedItem.phase = validPhases.includes(parsedData.phase) ? parsedData.phase : 'UNREGISTERED';

                                // VPN status
                                var validVpnStates = ['ENABLED', 'DISABLED', 'ENABLING', 'DISABLING'];
                                parsedItem.vpn = validVpnStates.includes(parsedData.vpn) ? parsedData.vpn : 'DISABLED';

                                // NTP status
                                var validNtpStates = ['ENABLED', 'DISABLED', 'ENABLING', 'DISABLING'];
                                parsedItem.ntp = validNtpStates.includes(parsedData.ntp) ? parsedData.ntp : 'DISABLED';

                                // Last seen timestamp
                                if (parsedData.lastSeenAt) {
                                    parsedItem.lastSeenAt = parseInt(parsedData.lastSeenAt);
                                }

                                // Sync state for UI locks
                                parsedItem.syncState = parsedData.syncState;

                                // Return merged data
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }*/

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        try {
                            var parsedItem = _.cloneDeep(item);

                            // Parse the nested data JSON string
                            var parsedData = angular.isString(parsedItem.data) ? angular.fromJson(parsedItem.data) : parsedItem.data;

                            // Convert timestamps
                            if (parsedData.updatedAt) {
                                parsedItem.updatedAt = moment.unix(parsedData.updatedAt).format('YYYY-MM-DD HH:mm:ss');
                            } else if (parsedItem.updated_at) {
                                parsedItem.updatedAt = parsedItem.updated_at;
                            }

                            if (parsedData.createdAt) {
                                parsedItem.createdAt = moment.unix(parsedData.createdAt).format('YYYY-MM-DD HH:mm:ss');
                            } else if (parsedItem.created_at) {
                                parsedItem.createdAt = parsedItem.created_at;
                            }

                            // Extract and validate essential fields
                            var finalItem = {
                                id: parsedItem.id || parsedData.id,
                                name: parsedData.name || '',
                                description: parsedData.description || '',
                                health: parseInt(parsedData.health) || 0,
                                projectId: parsedData.projectId,
                                connected: parsedData.connected === true || parsedData.connected === 'true',
                                registered: parsedData.registered === true || parsedData.registered === 'true',
                                phase: ['UNREGISTERED', 'REGISTERING', 'ACTIVE', 'PENDING_RETURN', 'DEREGISTERED'].includes(parsedData.phase)
                                    ? parsedData.phase : 'UNREGISTERED',
                                vpn: ['ENABLED', 'DISABLED', 'ENABLING', 'DISABLING'].includes(parsedData.vpn)
                                    ? parsedData.vpn : 'DISABLED',
                                ntp: ['ENABLED', 'DISABLED', 'ENABLING', 'DISABLING'].includes(parsedData.ntp)
                                    ? parsedData.ntp : 'DISABLED',
                                lastSeenAt: parsedData.lastSeenAt ? parseInt(parsedData.lastSeenAt) : null,
                                syncState: parsedData.syncState || 'SYNCHRONIZED',
                                createdAt: parsedItem.createdAt,
                                updatedAt: parsedItem.updatedAt
                            };

                            // Merge with the original parsed data to preserve any additional fields
                            return angular.extend({}, parsedData, finalItem);

                        } catch (e) {
                            $log.error('Error parsing item:', e, item);
                            return item;
                        }
                    });
                }

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'fleet', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sqlString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_fleet_ecus';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_fleet_ecus';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetEcus(input, true);
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'fleet', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }

                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.ecusArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEcusArr = [];
                                vm.selectedEcuObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "Create Issue" &&
                                tab.id !== "ecuStats" &&
                                tab.id !== "WidgetEditor") {
                                if (vm.isEcusLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedEcusArr = [];
                                    vm.selectedEcuObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.fleet', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEcuStats = tab.id === "ecuStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEcuStats = tab.id === "ecuStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "ecuStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor") {
                        $state.go('main.fleet', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedEcuObj = [];
                        vm.selectedEcuObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.fleet', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (ecuObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ECU) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.ecusArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === ecuObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Ecu array*/
                        var isValueFind = _.find(vm.selectedEcusArr, {'id': ecuObj.id});
                        if (!isValueFind) {
                            vm.selectedEcusArr.push(ecuObj);
                            var isTabExist = _.find(vm.tabs, {'id': ecuObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: ecuObj.id,
                                    title: ecuObj.name,
                                    tabIndex: newTabIndex,
                                    projectName: ecuObj.project ? ecuObj.project.name : ''
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEcusArr, function (obj) {
                                return ecuObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEcusArr.length === 1) {
                            vm.fnGetEcuDetails(vm.selectedEcusArr[0])
                        } else {
                            $state.go('main.fleet', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.ecusArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEcusArr = angular.copy(vm.ecusArr);
                    } else {
                        vm.selectedEcusArr = [];
                    }
                    $state.go('main.fleet', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.fleet', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_fleet_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_fleet_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_fleet_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnOpenEcuInfoTab = function (ecuObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(ecuObj);
                };

                vm.fnGetEcu = function (ecuObj, ecusArr) {
                    angular.forEach(ecusArr, function (ecu) {
                        ecu.isCheck = false;
                    });
                    ecuObj.isCheck = true;
                    vm.selectedEcusArr = [ecuObj]; // Assign array with single ecu object
                    vm.fnGetEcuDetails(ecuObj);
                };

                vm.fnGetEcuDetails = function (ecuObj) {
                    vm.isEcuDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when ecu is selected
                        vm.selectedEcuObj = ecuObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.fleet', {
                                selectedId: vm.selectedEcuObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEcuDetailsLoaded = true;
                        } else {
                            $state.go('main.fleet', {selectedId: vm.selectedEcuObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            vm.isEcuDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Use the existing parsePostgresData function
                            var parsedData = parsePostgresData(res.data);

                            // Apply additional transformations
                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                            });

                            // Update response with parsed data
                            res.data = parsedData;

                            vm.ecuResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                    vm.totalItems = vm.ecuResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }
                            vm.ecusArr = vm.ecuResponse.data;
                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.ecusArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.fleet') {
                                $state.go('main.fleet', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitEcu = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnAddDefaultFilter = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'fleet', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.fleet", tempArr, {notify: false});
                    } else {
                        if (angular.isDefined($stateParams.filter)) {
                            var filterJson = angular.fromJson($stateParams.filter);
                            var isFind = _.find(filterJson, {selectedField: 'registered'});
                            if (!isFind) {
                                filterJson.push({
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "registered",
                                    displaySelectedField: "Registered",
                                    selectedConnector: "and",
                                    searchText: '',
                                    displaySearchText: '',
                                    isDirectFilterApply: true,
                                    sqlValue: 'data->\'registered\' = \'true\'',
                                    localSearchValue: 'obj.registered === true'
                                });
                                $state.go("main.fleet", {filter: angular.toJson(filterJson)}, {notify: false});
                                $stateParams.filter = angular.toJson(filterJson);
                            }
                        } else {
                            var inputObj = [{
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                selectedField: "registered",
                                displaySelectedField: "Registered",
                                searchText: '',
                                displaySearchText: '',
                                isDirectFilterApply: true,
                                sqlValue: 'data->\'registered\' = \'true\'',
                                localSearchValue: 'obj.registered === true'
                            }];
                            $state.go("main.fleet", {filter: angular.toJson(inputObj)}, {notify: false});
                            $stateParams.filter = angular.toJson(inputObj);
                        }
                    }
                };

                vm.fnInitEcus = function () {
                    vm.fnAddDefaultFilter();
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'fleet', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetEcuDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEcuStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ecuStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEcuStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ecuStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEcuStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getEcuCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.ecusArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.ecusArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Ecus");
                    XLSX.writeFile(wb, "Ecus.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'fleet', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRequestECUTunnel = function (ecuObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                        size: 'lg',
                        controller: 'nodeJobTerminalCtrl as jobTerminal',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith(ecuObj);
                            },
                            isEcuTunnel: function () {
                                return true;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        },1000);
                    }, function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        },1000);
                    });
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeFleetChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on("EcuFleetNotFound", function (evt, data) {
                    vm.selectedEcusArr = [];
                    vm.selectedEcuObj = {};
                    $state.go('main.fleet', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                var ecuKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.fleet') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && vm.selectedEcusArr.length > 1 && vm.permissionObj.DELETE_ECU &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleEcus(vm.selectedEcusArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var ecuKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.fleet') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', ecuKeyDownEventHandler);
                document.addEventListener('keyup', ecuKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', ecuKeyDownEventHandler);
                    document.removeEventListener('keyup', ecuKeyUpEventHandler);
                });

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('Es4Ctrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, NodeES4Factory, postActionModelIcon, postActionModelMessage,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                //Search Variables
                vm.isRefreshData = true;
                vm.ecusArr = [];
                vm.ecu = {};
                vm.isEcuLoaded = false;
                vm.isRefresh = false;
                vm.isInitEs4 = true;

                vm.es4EcuFilter = "$";
                vm.es4EcuFilter = "$";
                vm.es4EcuSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //ES4s Variables
                vm.isEs4sLoading = false;
                vm.es4sArr = [];
                vm.selectedEs4sArr = [];
                vm.selectedEs4Obj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.es4Response = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowEs4Stats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditEs4Obj = {};

                vm.es4ContextMenu = function (es4Obj) {
                    if (Object.keys(vm.resetEditEs4Obj).length) {
                        var isFindES4 = _.find(vm.es4sArr, {id: vm.resetEditEs4Obj.id});
                        if (isFindES4) {
                            vm.fnCancelEs4EditMode(isFindES4);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            es4Obj.isEditable = true;
                            vm.resetEditEs4Obj = angular.copy(es4Obj);
                        }
                    }]
                };

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core es4 fields
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',

                                // Additional es4-specific fields
                                ecuId: parsedData.ecuId || '',

                                // Lifecycle and sync fields
                                syncState: parsedData.syncState || '',
                                lifecycleState: parsedData.lifecycleState || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnCancelEs4EditMode = function (es4Obj, isSuccessCall) {
                    if (isSuccessCall) {
                        es4Obj.name = angular.copy(es4Obj.name);
                        es4Obj.description = angular.copy(es4Obj.description);
                        es4Obj.isEditable = false;
                        vm.resetEditEs4Obj = {};
                    } else {
                        es4Obj.name = angular.copy(vm.resetEditEs4Obj.name);
                        es4Obj.description = angular.copy(vm.resetEditEs4Obj.description);
                        es4Obj.isEditable = false;
                        vm.resetEditEs4Obj = {};
                    }
                };

                vm.fnSaveEs4Info = function (es4Obj) {
                    es4Obj.isEditable = false;
                    var inputObj = {
                        body: {},
                        es4Id: es4Obj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/edge-scripts/" + es4Obj.id + "/names",
                        body: {name: es4Obj.name}
                    });
                    batchArr.push({
                        method: "PATCH",
                        id: 2,
                        path: "/node/edge-scripts/" + es4Obj.id + "/descriptions",
                        body: {description: es4Obj.description}
                    });
                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        if (response && response.length) {
                            var tempEs4Obj = response[response.length - 1].body;
                            if (tempEs4Obj.code === 400) {
                                amaran.error(tempEs4Obj.message);
                                vm.fnCancelEs4EditMode(es4Obj, false);
                            } else {
                                if (angular.isUndefined(tempEs4Obj.description)) {
                                    tempEs4Obj.description = '';
                                }
                                var resetCopy = angular.copy(tempEs4Obj);
                                angular.forEach(vm.ecusArr, function (es4Obj) {
                                    if (Object.keys(vm.selectedEs4Obj).length) {
                                        if (es4Obj.id === vm.selectedEs4Obj.id) {
                                            angular.forEach(resetCopy, function (val, key) {
                                                vm.selectedEs4Obj[key] = val;
                                                es4Obj[key] = val;
                                            });
                                        }
                                    }
                                    if (es4Obj.id === resetCopy.id) {
                                        es4Obj.name = resetCopy.name;
                                        es4Obj.description = resetCopy.description;
                                        if (resetCopy.createdAt) {
                                            es4Obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.createdAt);
                                        }
                                        if (resetCopy.updatedAt) {
                                            es4Obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.updatedAt);
                                        }
                                    }
                                });
                                vm.fnCancelEs4EditMode(es4Obj, true);
                                amaran.success("ES4 Updated Successfully");
                            }
                        }
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            vm.fnCancelEs4EditMode(es4Obj);
                            amaran.error(error.errorMessage);
                        }
                    });
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'es4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEs4sLoading = true;
                    vm.selectedEs4sArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitEs4 === false) {
                        vm.fnSetSelectedEcu();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_ecus ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.isEcuLoaded = false;
                        vm.fnGetEcus({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetEcus = function (inputObj, preDefinedEcus, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var ecus = isCalledForViz ? preDefinedEcus : [];
                            _.forEach(res.data, function (projectObj) {
                                ecus.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (ecus[0] && ecus[0].totalItems > ecus.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + ecus[ecus.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetEcus({sql: sqlString}, ecus, true);
                            } else {
                                vm.ecusArr = _.cloneDeepWith(ecus);
                                vm.ecusArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedEcu();
                            }
                        }, function () { // Error block
                            vm.fnGetEcus(inputObj, [], false);
                        })
                };

                vm.fnSetSelectedEcu = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'es4', 'selectedEcu');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindEcu = _.find(vm.ecusArr, {id: tempSelectedProject.id});
                        if (isFindEcu) {
                            vm.ecu = isFindEcu;
                        } else {
                            vm.ecu = {};
                        }
                    } else if ($stateParams.selectedEcu) {
                        var isFindStateParamsEcu = _.find(vm.ecusArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsEcu) {
                            vm.ecu = isFindStateParamsEcu;
                        } else {
                            vm.ecu = {};
                        }
                    } else {
                        vm.ecu = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.ecu && Object.keys(vm.ecu).length && vm.ecu.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_es4s';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_es4s';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_es4s';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_es4s';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEs4s({sql: sqlString}, true);
                    vm.isEcuLoaded = true;
                };

                vm.fnGetEs4Ecu = function (ecuObj) {
                    vm.isEcuLoaded = false;
                    vm.ecu = ecuObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_es4s';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_es4s';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_es4s';
                        if (vm.ecu && vm.ecu.id && vm.ecu.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.ecu && vm.ecu.id && vm.ecu.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (ecuObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'es4', 'selectedEcu', _.cloneDeepWith(angular.fromJson(angular.toJson(ecuObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'es4', 'selectedEcu', '');
                    }
                    vm.fnGetEs4s({sql: sqlString}, true);
                    vm.isEcuLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.es4sArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEs4sArr = [];
                                vm.selectedEs4Obj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.node_es4', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEs4tats = tab.id === "es4Stats";
                        vm.isCreate = tab.id === "Create ES4";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEs4Stats = tab.id === "es4Stats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreate = tab.id === "Create ES4";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create ES4" || tab.id === "Create Issue" || tab.id === "es4Stats" || tab.id === "WidgetEditor") {
                        $state.go('main.node_es4', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedEs4Obj = [];
                        vm.selectedEs4Obj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_es4', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#es4Table").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetEs4s = function (inputObj, isFirst) {
                    vm.isEs4sLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            res.data = vm.parsePostgresData(res.data);

                            vm.es4Response = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.es4Response.data && vm.es4Response.data.length) {
                                    vm.totalItems = vm.es4Response.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.es4Response.data.reverse();
                            }
                            vm.es4sArr = vm.es4Response.data;

                            vm.es4sArr = vm.es4sArr.map(function(es4Obj) {
                                if (es4Obj.ecuId) {
                                    es4Obj.ecu = _.find(vm.ecusArr, {id: es4Obj.ecuId});
                                }
                                return es4Obj;
                            });

                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.es4sArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                }
                            }
                            if ($state.current.name === 'main.node_es4') {
                                $state.go('main.node_es4', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isEs4sLoading = false;
                            vm.isInitEs4 = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEs4sLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnCheckUncheckHeader = function (es4Obj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ES4) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.es4sArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === es4Obj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Es4 array*/
                        var isValueFind = _.find(vm.selectedEs4sArr, {'id': es4Obj.id});
                        if (!isValueFind) {
                            vm.selectedEs4sArr.push(es4Obj);
                            var isTabExist = _.find(vm.tabs, {'id': es4Obj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: es4Obj.id,
                                    title: es4Obj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEs4sArr, function (obj) {
                                return es4Obj.id === obj.id;
                            });
                        }
                        if (vm.selectedEs4sArr.length === 1) {
                            vm.fnGetEs4Details(vm.selectedEs4sArr[0])
                        } else {
                            $state.go('main.node_es4', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.es4sArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEs4sArr = angular.copy(vm.es4sArr);
                    } else {
                        vm.selectedEs4sArr = [];
                    }
                    $state.go('main.node_es4', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.node_es4', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEs4sLoading = true;
                    vm.selectedEs4sArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_es4s';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_es4s';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_es4s';
                            if (vm.ecu && vm.ecu.id && vm.ecu.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'ecuId\' = '" + vm.ecu.id + "'" : " WHERE data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEs4s(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.ecu && vm.ecu.id && vm.ecu.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            } else {
                                tempSQL += " data->>\'ecuId\' = '" + vm.ecu.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.es4sArr);
                        vm.previousPage = page;
                        vm.fnGetEs4s(input, false);
                    }
                };

                vm.fnOpenEs4InfoTab = function (ecuObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(ecuObj);
                };

                vm.fnGetEs4 = function (es4Obj, es4sArr) {
                    angular.forEach(es4sArr, function (ecu) {
                        ecu.isCheck = false;
                    });
                    es4Obj.isCheck = true;
                    vm.selectedEs4sArr = [es4sArr]; // Assign array with single ecu object
                    vm.fnGetEs4Details(es4sArr);
                };

                vm.fnGetEs4Details = function (es4Obj) {
                    vm.isEs4DetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when ecu is selected
                        vm.selectedEs4Obj = es4Obj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_es4', {
                                selectedId: vm.selectedEs4Obj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEs4Obj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEs4DetailsLoaded = true;
                        } else {
                            $state.go('main.node_es4', {selectedId: vm.selectedEs4Obj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEs4Obj.id;
                            vm.isEs4DetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedEs4sArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create ES4'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create ES4',
                                title: 'Create ES4',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnDeployES4 = function (es4Obj) {
                    es4Obj.deploysUnsynchronizedES4 = true;
                    var input = {
                        es4Id: es4Obj.id
                    };
                    NodeES4Factory.deleteES4(input)
                        .then(function () {
                            delete es4Obj.deploysUnsynchronizedES4;
                            amaran.success("ES4 Deploy Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            delete es4Obj.deploysUnsynchronizedES4;
                        });
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitEs4 = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("Es4Deleted", function (evt, data) {
                    vm.selectedEs4Obj = null;
                    vm.selectedEs4sArr = [];
                    vm.es4sArr = vm.es4sArr.filter(function (ecuObj) {
                        return (ecuObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.node_es4', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("Es4DetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.es4sArr, function (es4Obj) {
                        if (es4Obj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                data[key] = val;
                                es4Obj[key] = val;
                                vm.selectedEs4Obj[key] = val;
                            });
                            if (data.createdAt) {
                                es4Obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(data.createdAt);
                            }
                            if (data.updatedAt) {
                                es4Obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(data.updatedAt);
                            }
                        }
                    });
                });

                $scope.$on("es4Added", function () {
                    vm.fnRemoveTab('Create ES4');
                });

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'es4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_es4", tempArr, {notify: false});
                    }
                };

                vm.fnInitEs4s = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'es4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetEs4Dashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEs4Stats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'es4Stats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEs4Stats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'es4Stats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEs4Stats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getEs4CSVData = function () {
                    var tempData = _.cloneDeepWith(vm.es4sArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.es4sArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Es4s");
                    XLSX.writeFile(wb, "Es4s.xlsx");
                };
                /* Export Modal: End */

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeEs4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'es4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeEmailTemplateCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      QueryFactory, UserProfileService, LastPageService, PaginationService, amaran, swal,
                      PermissionsService, microSpinner, postActionModelMessage, postActionModelIcon,
                      jsonToCsvConvertService, WidgetsListService, NodeEmailTemplateFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowEmailTemplateStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;
                vm.isCreateIssue = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];

                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //EmailTemplates Variables
                vm.isEmailTemplatesloading = false;
                vm.emailTemplateArr = [];
                vm.selectedEmailTemplatesArr = [];
                vm.selectedEmailTemplateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.emailTemplateResponse = [];
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'emailTemplate', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterEmailTemplateArr = [];
                    var emailTemplateArr = [];
                    if (vm.emailTemplateResponse.length) {
                        if (vm.filterQuery) {
                            filterEmailTemplateArr = _.filter(vm.emailTemplateResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterEmailTemplateArr = _.cloneDeepWith(vm.emailTemplateResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            emailTemplateArr = _.orderBy(filterEmailTemplateArr, [sortValue], [sortType]);
                        } else {
                            emailTemplateArr = _.cloneDeepWith(filterEmailTemplateArr);
                        }
                    }
                    vm.totalItems = emailTemplateArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.emailTemplateArr = emailTemplateArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.node_emailTemplate') {
                        $timeout(function () {
                            $state.go('main.node_emailTemplate', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isEmailTemplatesloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#emailTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (emailTemplateObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_EMAIL_TEMPLATE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.emailTemplateArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === emailTemplateObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedEmailTemplatesArr, {'id': emailTemplateObj.id});
                        if (!isValueFind) {
                            vm.selectedEmailTemplatesArr.push(emailTemplateObj);
                            var isTabExist = _.find(vm.tabs, {'id': emailTemplateObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: emailTemplateObj.id,
                                    title: emailTemplateObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEmailTemplatesArr, function (obj) {
                                return emailTemplateObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEmailTemplatesArr.length === 1) {
                            vm.fnGetEmailTemplateDetails(vm.selectedEmailTemplatesArr[0])
                        } else {
                            $state.go('main.node_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetEmailTemplateDetails = function (userObj) {
                    vm.isEmailTemplateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedEmailTemplateObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.node_emailTemplate', {
                                selectedId: vm.selectedEmailTemplateObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEmailTemplateDetailsLoaded = true;
                        } else {
                            $state.go('main.node_emailTemplate', {selectedId: vm.selectedEmailTemplateObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            vm.isEmailTemplateDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.emailTemplateArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEmailTemplatesArr = _.cloneDeepWith(vm.emailTemplateArr);
                    } else {
                        vm.selectedEmailTemplatesArr = [];
                    }
                    $state.go('main.node_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        emailTemplateId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetEmailTemplate = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedEmailTemplatesArr = [tokenObj]; // Assign array with single token object
                    vm.selectedEmailTemplateObj = tokenObj;
                };

                vm.fnGetEmailTemplates = function () {
                    if (vm.permissionObj.LIST_EMAIL_TEMPLATE_TYPES) {
                        NodeEmailTemplateFactory.listEmailTemplateTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    var name = '';
                                    if(obj.includes('ecu') || obj.includes('vpn') || obj.includes('ntp')) {
                                        var o = obj.split('_');
                                        name = o[0].toUpperCase() + ' ' + toUpper(o[1]);
                                    } else {
                                        name = toUpper(obj.replace(/_/g, " "));
                                    }
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: name
                                    })
                                });
                                vm.emailTemplateResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var emailTemplateData = _.find(vm.emailTemplateArr, {"id": $stateParams.selectedId});
                                    if (emailTemplateData) {
                                        vm.fnCheckUncheckHeader(emailTemplateData);
                                    }
                                }
                                if ($state.current.name === 'main.node_emailTemplate') {
                                    $state.go('main.node_emailTemplate', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.emailTemplateResponse = [];
                        vm.fnGetFilterData();
                        vm.isEmailTemplatesloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindEmailTemplate = _.find(vm.emailTemplateArr, {id: tab.id});
                            if (isFindEmailTemplate) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEmailTemplatesArr = [];
                                vm.selectedEmailTemplateObj = {};
                                vm.fnCheckUncheckHeader(isFindEmailTemplate);
                            }
                        } else {
                            $state.go('main.node_emailTemplate', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "EmailTemplateStats" || tab.id === "WidgetEditor") {
                        $state.go('main.node_emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.node_emailTemplate', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'emailTemplate', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'EmailTemplateStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEmailTemplateStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'EmailTemplateStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEmailTemplateStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'emailTemplate', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.node_emailTemplate", tempArr, {notify: false});
                    }
                };

                vm.fnInitEmailTemplate = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'emailTemplate', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeEmailTemplateChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('EcusCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService, ProjectFactory,
                      BatchFactory, PaginationService, NodeEcuFactory, postActionModelIcon, postActionModelMessage,
                      AppInitService, $log, PaginationQueryService, QueryFactory, PermissionsService, ColorService, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefresh = false;
                vm.isInitEcu = true;

                //Search Variables
                vm.isRefreshData = true;
                vm.projectsArr = [];
                vm.isColumnView = true;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx",
                        sqlValue: 'data->>\'_id\' = \'#value#\''
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: "",
                        sqlValue: 'data->>\'name\' LIKE \'%#value#%\''
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: "",
                        sqlValue: 'data->>\'description\' LIKE \'%#value#%\''
                    }, {
                        displayName: "Registered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'true\'',
                        localSearchValue: 'obj.registered === true'
                    }, {
                        displayName: "Unregistered",
                        name: "registered",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'registered\' = \'false\'',
                        localSearchValue: 'obj.registered === false'
                    }, {
                        displayName: "Phase",
                        name: "phase",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'UNREGISTERED',
                                displayName: 'UNREGISTERED'
                            }, {
                                name: 'REGISTERING',
                                displayName: 'REGISTERING'
                            }, {
                                name: 'ACTIVE',
                                displayName: 'ACTIVE'
                            }, {
                                name: 'PENDING_RETURN',
                                displayName: 'PENDING RETURN'
                            }, {
                                name: 'DEREGISTERED',
                                displayName: 'DEREGISTERED'
                            }
                        ],
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Connected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: 'data->\'connected\' = \'true\'',
                        localSearchValue: 'obj.connected === true'
                    }, {
                        displayName: "Disconnected",
                        name: "connected",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: '(data->\'connected\' = \'false\' or data->\'connected\' = \'0\')',
                        localSearchValue: 'obj.connected === false'
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "NTP",
                        name: "ntp",
                        localSearch: {
                            type: 'objects',
                            name: 'ntp',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Enabled',
                                id: 'ENABLED'
                            }, {
                                name: 'Disabled',
                                id: 'DISABLED'
                            }, {
                                name: 'Enabling',
                                id: 'ENABLING'
                            }, {
                                name: 'Disabling',
                                id: 'DISABLING'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }, {
                        displayName: "VPN",
                        name: "vpn",
                        localSearch: {
                            type: 'objects',
                            name: 'vpn',
                            key: 'id'
                        },
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: [
                            {
                                name: 'Enabled',
                                id: 'ENABLED'
                            }, {
                                name: 'Disabled',
                                id: 'DISABLED'
                            }, {
                                name: 'Enabling',
                                id: 'ENABLING'
                            }, {
                                name: 'Disabling',
                                id: 'DISABLING'
                            }
                        ],
                        displayKeyName: 'name',
                        isShowId: false,
                        isShowUserAvatar: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'id'
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'health', displayName: 'Health'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                vm.ecuProjectFilter = "$";
                vm.ecuProjectFilter = "$";
                vm.ecuProjectSearch = {$: ''};

                //Ecus Variables
                vm.isEcusLoading = false;
                vm.ecusArr = [];
                vm.selectedEcusArr = [];
                vm.selectedEcuObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                vm.isRefresh = false;
                vm.isShowTunnel = false;
                vm.isShowSynchronizingECU = false;
                vm.isShowNetworkScanECU = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.ecuResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowEcuStats = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                vm.ecuTableAPITimeout = '';

                /*Start: Context Menu*/
                vm.resetEditEcuObj = {};
                vm.isRefreshing = false;

                var loginUser = DB.fnGet("loginUser");


                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.ecuContextMenu = function (ecuObj) {
                    if (Object.keys(vm.resetEditEcuObj).length) {
                        var isFindEcu = _.find(vm.ecusArr, {id: vm.resetEditEcuObj.id});
                        if (isFindEcu) {
                            vm.fnCancelEcuEditMode(isFindEcu);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            ecuObj.isEditable = true;
                            vm.resetEditEcuObj = angular.copy(ecuObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the nested data object - do this once
                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);
                                // Merge the parsed data first, so base properties can override if needed
                                parsedItem = angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                            }
                        }

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        // Handle boolean fields
                        if (angular.isDefined(parsedItem.connected)) {
                            parsedItem.connected = parsedItem.connected === "true" || parsedItem.connected === true;
                        }
                        if (angular.isDefined(parsedItem.registered)) {
                            parsedItem.registered = parsedItem.registered === "true" || parsedItem.registered === true;
                        }

                        // Handle timestamps
                        if (parsedItem._event_time && parsedItem._event_time.value) {
                            var microseconds = parseInt(parsedItem._event_time.value);
                            if (!isNaN(microseconds)) {
                                parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                            }
                        }
                        if (parsedItem.lastSeenAt) {
                            parsedItem.lastSeenAt = parseInt(parsedItem.lastSeenAt);
                        }

                        // Handle health status
                        if (parsedItem.updated_at) {
                            parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                        }


                        if (angular.isDefined(parsedItem.id)) {
                            parsedItem.id = String(parsedItem.id);        // Ensure string format
                            parsedItem.ecuId = String(parsedItem.id);     // Map for registration form
                            parsedItem._id = String(parsedItem.id);       // Internal ID reference
                        }


                        if (angular.isDefined(parsedItem.serial)) {
                            parsedItem.serialId = String(parsedItem.serial);
                        }

                        // Standardize projectId field
                        if (angular.isDefined(parsedItem.projectid)) {
                            parsedItem.projectId = parsedItem.projectid;
                            delete parsedItem.projectid;
                        } else if (angular.isDefined(parsedItem.project_id)) {
                            parsedItem.projectId = parsedItem.project_id;
                            delete parsedItem.project_id;
                        }

                        // Ensure projectId exists and is in string format
                        if (parsedItem.projectId) {
                            parsedItem.projectId = String(parsedItem.projectId);
                        }

                        if (parsedItem.phase === 'UNREGISTERED') {
                            parsedItem.registered = false;
                            parsedItem.connected = false;
                            parsedItem.ntp = parsedItem.ntp || 'DISABLED';
                            parsedItem.vpn = parsedItem.vpn || 'DISABLED';
                            parsedItem.syncState = parsedItem.syncState || 'NOT_SYNCHRONIZED';
                            parsedItem.lifecycleState = parsedItem.lifecycleState || 'CREATING';

                            // Additional checks for unregistered ECUs
                            if (angular.isUndefined(parsedItem.description)) {
                                parsedItem.description = '';
                            }
                            if (angular.isUndefined(parsedItem.health)) {
                                parsedItem.health = 200;
                            }
                            if (angular.isUndefined(parsedItem.version)) {
                                parsedItem.version = 1;
                            }
                        }

                        // Clean up by removing raw data after it's been parsed
                        delete parsedItem.data;

                        return parsedItem;
                    });
                }

                vm.fnCancelEcuEditMode = function (ecuObj, isSuccessCall) {
                    if (isSuccessCall) {
                        ecuObj.name = angular.copy(ecuObj.name);
                        ecuObj.description = angular.copy(ecuObj.description);
                        ecuObj.isEditable = false;
                        vm.resetEditEcuObj = {};
                    } else {
                        ecuObj.name = angular.copy(vm.resetEditEcuObj.name);
                        ecuObj.description = angular.copy(vm.resetEditEcuObj.description);
                        ecuObj.isEditable = false;
                        vm.resetEditEcuObj = {};
                    }
                };

                vm.fnSaveEcuInfo = function (ecuObj) {
                    ecuObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        ecuId: ecuObj.id
                    };
                    inputObj.body = {};
                    var batchArr = [];
                    batchArr.push({
                        method: "PATCH",
                        id: 1,
                        path: "/node/ecus/" + ecuObj.id + "/names",
                        body: {name: ecuObj.name}
                    });
                    batchArr.push({
                        method: "PATCH",
                        id: 2,
                        path: "/node/ecus/" + ecuObj.id + "/descriptions",
                        body: {description: ecuObj.description}
                    });
                    BatchFactory.executeBatchRequests({
                        body: batchArr,
                        tag: 'batch',
                        appName: 'node',
                        parallel: false
                    }).then(function (response) {
                        if (response && response.length) {
                            var tempEcuObj = response[response.length - 1].body;
                            if (tempEcuObj.code === 400) {
                                amaran.error(tempEcuObj.message);
                                vm.fnCancelEcuEditMode(ecuObj, false);
                            } else {
                                if (angular.isUndefined(tempEcuObj.description)) {
                                    tempEcuObj.description = '';
                                }
                                var resetCopy = angular.copy(tempEcuObj);
                                angular.forEach(vm.ecusArr, function (ecuObj) {
                                    if (Object.keys(vm.selectedEcuObj).length) {
                                        if (ecuObj.id === vm.selectedEcuObj.id) {
                                            angular.forEach(resetCopy, function (val, key) {
                                                vm.selectedEcuObj[key] = val;
                                                ecuObj[key] = val;
                                            });
                                        }
                                    }
                                    if (ecuObj.id === resetCopy.id) {
                                        ecuObj.name = resetCopy.name;
                                        ecuObj.description = resetCopy.description;
                                        if (resetCopy.createdAt) {
                                            ecuObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.createdAt);
                                        }
                                        if (resetCopy.updatedAt) {
                                            ecuObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(resetCopy.updatedAt);
                                        }
                                    }
                                });
                                vm.fnCancelEcuEditMode(ecuObj, true);
                                amaran.success("ECU Updated Successfully");
                            }
                        }
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            vm.fnCancelEcuEditMode(ecuObj);
                            amaran.error(error.errorMessage);
                        }
                    });
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.ecuTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.ecusArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEcusArr = [];
                                vm.selectedEcuObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "WidgetEditor" &&
                                tab.id !== "Tunnel" &&
                                tab.id !== "ecuStats" &&
                                tab.id !== "SynchronizingECU" &&
                                tab.id !== "NetworkScanECU") {
                                if (vm.isEcusLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedEcusArr = [];
                                    vm.selectedEcuObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title, projectId: tab.projectId});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.ecu', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEcuStats = tab.id === "ecuStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        vm.isShowTunnel = tab.id === "Tunnel";
                        vm.isShowSynchronizingECU = tab.id === "SynchronizingECU";
                        vm.isShowNetworkScanECU = tab.id === "NetworkScanECU";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            $timeout.cancel(vm.ecuTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEcuStats = tab.id === "ecuStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    vm.isShowTunnel = tab.id === "Tunnel";
                    vm.isShowSynchronizingECU = tab.id === "SynchronizingECU";
                    vm.isShowNetworkScanECU = tab.id === "NetworkScanECU";
                    if (tab.id === "Dashboard" || tab.id === "ecuStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor" || tab.id === "Tunnel" || tab.id === "SynchronizingECU" || tab.id === "NetworkScanECU") {
                        $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedEcuObj = [];
                        vm.selectedEcuObj = {};
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.ecuTableAPITimeout);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.ecu', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#ecuTable").css('height', finalHeight + 'px');
                    }
                };

                /*vm.fnCheckUncheckHeader = function (ecuObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_ECU) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.ecusArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === ecuObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /!* Toggle push in selected Ecu array*!/
                        var isValueFind = _.find(vm.selectedEcusArr, {'id': ecuObj.id});
                        if (!isValueFind) {
                            vm.selectedEcusArr.push(ecuObj);
                            var isTabExist = _.find(vm.tabs, {'id': ecuObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                if (angular.isUndefined(ecuObj.project)) {
                                    ecuObj.project = _.find(vm.projectsArr, {id: ecuObj.projectId});
                                }
                                vm.tabs.push({
                                    id: ecuObj.id,
                                    title: ecuObj.name,
                                    tabIndex: newTabIndex,
                                    projectName: ecuObj.project ? ecuObj.project.name : '',
                                    projectId: ecuObj.project.id
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEcusArr, function (obj) {
                                return ecuObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEcusArr.length === 1) {
                            vm.fnGetEcuDetails(vm.selectedEcusArr[0])
                        } else {
                            $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };*/

                vm.fnCheckUncheckHeader = function (ecuObj, fromList) {

                    if (ecuObj.data && angular.isString(ecuObj.data)) {
                        ecuObj = parsePostgresData([ecuObj])[0];
                    }


                    // Validate input
                    if (!ecuObj || !ecuObj.id) {
                        amaran.error("Invalid ECU object in checkUncheckHeader");
                        return;
                    }

                    if (vm.permissionObj.DESCRIBE_ECU) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.ecusArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === ecuObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected Ecu array*/
                        var isValueFind = _.find(vm.selectedEcusArr, {'id': ecuObj.id});
                        if (!isValueFind) {
                            vm.selectedEcusArr.push(ecuObj);
                            var isTabExist = _.find(vm.tabs, {'id': ecuObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                if (angular.isUndefined(ecuObj.project)) {
                                    ecuObj.project = _.find(vm.projectsArr, {id: ecuObj.projectId});
                                }
                                vm.tabs.push({
                                    id: ecuObj.id,
                                    title: ecuObj.name,
                                    tabIndex: newTabIndex,
                                    projectName: ecuObj.project ? ecuObj.project.name : '',
                                    projectId: ecuObj.project.id
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEcusArr, function (obj) {
                                return ecuObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEcusArr.length === 1) {
                            vm.fnGetEcuDetails(vm.selectedEcusArr[0])
                        } else {
                            $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.ecusArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEcusArr = angular.copy(vm.ecusArr);
                    } else {
                        vm.selectedEcusArr = [];
                    }
                    $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (ecuObj) {
                    var isFindIndex = _.findIndex(vm.selectedEcusArr, {id: ecuObj});
                    if (ecuObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedEcusArr.push(ecuObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedEcusArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.ecuTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEcusLoading = true;
                    vm.selectedEcusArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                            if (vm.project && vm.project.id && vm.project.id !== 'All') {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            }
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEcus(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.ecusArr);
                        vm.previousPage = page;
                        vm.fnGetEcus(input, false);
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];

                            if (res.data) {
                                var parsedProjects = parsePostgresData(res.data);
                                _.forEach(parsedProjects, function (projectObj) {
                                    projects.push(projectObj);
                                });
                            }

                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalitems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        });
                };

                /*vm.fnOpenEcuInfoTab = function (ecuObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(ecuObj);
                };*/

                vm.fnOpenEcuInfoTab = function (ecuObj, tabIndex) {
                    amaran.info("Starting fnOpenEcuInfoTab");

                    if (ecuObj.data && angular.isString(ecuObj.data)) {
                        var parsedEcuObj = parsePostgresData([ecuObj])[0];
                        ecuObj = parsedEcuObj;
                    }

                    amaran.info("Starting fnOpenEcuInfoTab");
                    $log.log('ECU object before processing:', ecuObj); // Debug log

                    if (!ecuObj) {
                        amaran.error("ecuObj is undefined or null");
                        return;
                    }

                    amaran.info("ECU object properties: id=" + ecuObj.id +
                        ", phase=" + ecuObj.phase +
                        ", projectId=" + ecuObj.projectId);

                    vm.tabIndex = tabIndex;

                    // Basic validation
                    if (!ecuObj || !ecuObj.id) {
                        amaran.error("Invalid ECU object");
                        return;
                    }

                    // Check permissions first
                    if (!vm.permissionObj || !vm.permissionObj.DESCRIBE_ECU) {
                        amaran.error("Missing required permissions");
                        return;
                    }

                    // Special handling for registration (tabIndex === 3)
                    if (ecuObj.data && angular.isString(ecuObj.data)) {
                        ecuObj = parsePostgresData([ecuObj])[0];
                    }

                    if (tabIndex === 3 && ecuObj.phase === 'UNREGISTERED') {
                        var isTabExist = _.find(vm.tabs, {id: ecuObj.id});

                        if (isTabExist) {
                            amaran.info("Found existing registration tab");
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            amaran.info("Creating new registration tab");
                            var newTabIndex = vm.tabs.length + 1;

                            // Ensure we have project data
                            if (angular.isUndefined(ecuObj.project)) {
                                ecuObj.project = _.find(vm.projectsArr, {id: ecuObj.projectId});
                                if (!ecuObj.project) {
                                    amaran.error("Could not find project for ECU");
                                    return;
                                }
                            }

                            // Create the registration tab
                            var newTab = {
                                id: ecuObj.id,
                                title: 'Register ECU',
                                tabIndex: newTabIndex,
                                projectName: ecuObj.project ? ecuObj.project.name : '',
                                projectId: ecuObj.project.id
                            };

                            vm.tabs.push(newTab);
                            amaran.success("Created new registration tab");

                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }

                    // Always call this at the end, just like in the original code
                    amaran.info("About to call checkUncheckHeader with ECU: " + angular.toJson(ecuObj));
                    vm.fnCheckUncheckHeader(ecuObj);
                };

                vm.fnGetEcu = function (ecuObj, ecusArr) {
                    angular.forEach(ecusArr, function (ecu) {
                        ecu.isCheck = false;
                    });
                    ecuObj.isCheck = true;
                    vm.selectedEcusArr = [ecuObj]; // Assign array with single ecu object
                    vm.fnGetEcuDetails(ecuObj);
                };

                vm.fnGetEcuDetails = function (ecuObj) {
                    vm.isEcuDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when ecu is selected
                        vm.selectedEcuObj = ecuObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.ecu', {
                                selectedId: vm.selectedEcuObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEcuDetailsLoaded = true;
                        } else {
                            $state.go('main.ecu', {selectedId: vm.selectedEcuObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEcuObj.id;
                            vm.isEcuDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetHealthColor = function (ecuCode, ecuObj) {
                    var ecuStyle = ColorService.getHealthColorForLoop(ecuObj.projectId, ecuCode);
                    ecuObj.healthName = ecuStyle.content;
                    return ecuStyle;
                };

                vm.fnGetEcus = function (inputObj, isFirst) {
                    vm.isEcusLoading = true;
                    if (inputObj.sql.includes("WHERE id =")) {
                        // Convert direct ID comparisons to JSONB queries
                        inputObj.sql = inputObj.sql.replace(/WHERE\s+id\s+=\s+'([^']+)'/g, "WHERE data->>'id' = '$1'");
                    }
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse PostgreSQL JSONB data first
                            var parsedData = parsePostgresData(res.data);

                            // Process the parsed data
                            parsedData.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                                if (obj.lastSeenAt && obj.lastSeenAt !== 0) {
                                    obj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(obj.lastSeenAt);
                                }
                            });

                            // Create response with parsed data
                            vm.ecuResponse = angular.extend({}, res, { data: parsedData });

                            if (isFirst) {
                                if (vm.ecuResponse.data && vm.ecuResponse.data.length) {
                                    vm.totalItems = vm.ecuResponse.data[0].totalitems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }

                            if (inputObj.isNeedDataReverse) {
                                vm.ecuResponse.data.reverse();
                            }

                            vm.ecusArr = vm.ecuResponse.data;

                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.ecusArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData);
                                }
                            }

                            if ($state.current.name === 'main.ecu') {
                                $state.go('main.ecu', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isRefresh = false;
                            vm.isEcusLoading = false;
                            vm.isInitEcu = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });

                            vm.ecuTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEcusLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };

                vm.fnGetProjectEcu = function (projectObj) {
                    $timeout.cancel(vm.ecuTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_ecus';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_ecus';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM node_ecus';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'selectedProject', '');
                    }
                    vm.fnGetEcus({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnDeployECU = function (ecuObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'SynchronizingECU'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.ecuId = ecuObj.id;
                            isTabExist.projectName = ecuObj.name;
                            vm.isShowSynchronizingECU = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'SynchronizingECU',
                            title: 'Synchronizing ECU',
                            tabIndex: newTabIndex,
                            ecuId: ecuObj.id,
                            projectName: ecuObj.name
                        });
                        $timeout(function () {
                            vm.isShowSynchronizingECU = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitEcu = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnDeleteMultipleEcus = function (selectedEcusArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedEcusArr, function (selectedEcu, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/ecus/" + selectedEcu.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/node/ecus/" + selectedEcu.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Deregister the selected ECUs?",
                            text: "You are about to deregister the selected ECUs.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Deregister Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'node'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedEcusArr, function (selectedEcu) {
                                    angular.forEach(vm.ecusArr, function (ecuObj, index) {
                                        if (selectedEcu.id === ecuObj.id) {
                                            vm.ecusArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedEcusArr.length;
                                vm.selectedEcuObj = null;
                                vm.selectedEcusArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedEcusArr, function (selectedEcu) {
                                    angular.forEach(vm.ecusArr, function (ecuObj, index) {
                                        if (selectedEcu.id === ecuObj.id) {
                                            vm.ecusArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedEcusArr.length;
                                vm.selectedEcuObj = null;
                                vm.selectedEcusArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                $scope.$on("EcuDeleted", function (evt, data) {
                    vm.selectedEcuObj = null;
                    vm.selectedEcusArr = [];
                    vm.ecusArr = vm.ecusArr.filter(function (ecuObj) {
                        return (ecuObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.ecu', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("EcuDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    if (resetCopy.data && angular.isString(resetCopy.data)) {
                        var parsed = angular.fromJson(resetCopy.data);
                        resetCopy = angular.extend({}, resetCopy, parsed);
                    }
                    angular.forEach(vm.ecusArr, function (ecuObj) {
                        if (ecuObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                data[key] = val;
                                ecuObj[key] = val;
                                vm.selectedEcuObj[key] = val;
                            });
                            if (data.createdAt) {
                                ecuObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(data.createdAt);
                            }
                            if (data.updatedAt) {
                                ecuObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(data.updatedAt);
                            }
                        }
                    });
                    var isTabExist = _.find(vm.tabs, {'id': data.id});
                    if (isTabExist) {
                        isTabExist.title = data.name;
                        isTabExist.projectName = _.find(vm.projectsArr, {id: data.projectId}).name;
                        UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'tabs', _.cloneDeepWith(vm.tabs));
                    }
                });

                $scope.$on('openECUDetail', function (event, data) {
                    vm.selectedEcusArr = [];
                    vm.selectedEcuObj = {};
                    vm.fnOpenEcuInfoTab(data, 2);
                });

                vm.fnAddDefaultFilter = function () {
                    if (angular.isUndefined($stateParams.filter)) {
                        var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'searchFilter');
                        if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                            var tempArr = {};
                            if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                                tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                                $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                            }
                            if (searchFilterObj.sort && searchFilterObj.sort.length) {
                                tempArr.sort = searchFilterObj.sort;
                                $stateParams.sort = searchFilterObj.sort;
                            }
                            $state.go("main.ecu", tempArr, {notify: false});
                        } else {
                            if (angular.isDefined($stateParams.filter)) {
                                var filterJson = angular.fromJson($stateParams.filter);
                                var isFind = _.find(filterJson, {selectedField: 'registered'});
                                if (!isFind) {
                                    filterJson.push({
                                        id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                        selectedField: "registered",
                                        displaySelectedField: "Registered",
                                        selectedConnector: "and",
                                        searchText: '',
                                        displaySearchText: '',
                                        isDirectFilterApply: true,
                                        sqlValue: 'data->\'registered\' = \'true\'',
                                        localSearchValue: 'obj.registered === true'
                                    });
                                    $state.go("main.ecu", {filter: angular.toJson(filterJson)}, {notify: false});
                                    $stateParams.filter = angular.toJson(filterJson);
                                }
                            } else {
                                var inputObj = [{
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "registered",
                                    displaySelectedField: "Registered",
                                    searchText: '',
                                    displaySearchText: '',
                                    isDirectFilterApply: true,
                                    sqlValue: 'data->\'registered\' = \'true\'',
                                    localSearchValue: 'obj.registered === true'
                                }];
                                $state.go("main.ecu", {filter: angular.toJson(inputObj)}, {notify: false});
                                $stateParams.filter = angular.toJson(inputObj);
                            }
                        }
                    }
                };

                vm.fnRequestEcuTunnel = function (ecuObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'Tunnel'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.ecuId = ecuObj.id;
                            isTabExist.projectName = ecuObj.name;
                            vm.isShowTunnel = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Tunnel',
                            title: 'Tunnel',
                            tabIndex: newTabIndex,
                            ecuId: ecuObj.id,
                            projectName: ecuObj.name
                        });
                        $timeout(function () {
                            vm.isShowTunnel = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnInitEcus = function () {
                    vm.fnAddDefaultFilter();
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    var loginUser = DB.fnGet('loginUser');
                    vm.isShowTunnelOption = loginUser.id.startsWith('cu000000') && !DB.fnGet('support') && !DB.fnGet('federation');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'ecu', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetEcuDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEcuStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ecuStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEcuStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ecuStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEcuStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getEcuCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.ecusArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.ecusArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Ecus");
                    XLSX.writeFile(wb, "Ecus.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'ecu', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnRequestStartNetworkScan = function (ecuObj) {
                    var isTabExist = _.find(vm.tabs, {id: 'NetworkScanECU'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.ecuId = ecuObj.id;
                            isTabExist.projectName = ecuObj.name;
                            vm.isShowSynchronizingECU = true;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'NetworkScanECU',
                            title: 'Network Scan ECU',
                            tabIndex: newTabIndex,
                            ecuId: ecuObj.id,
                            projectName: ecuObj.name
                        });
                        $timeout(function () {
                            vm.isShowSynchronizingECU = true;
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeEcuChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnUpdateTableData = function () {
                    // Prevent multiple simultaneous refreshes
                    if (vm.isRefreshing) {
                        return;
                    }

                    vm.isRefreshing = true;

                    // Store current data as backup
                    var currentData = _.cloneDeep(vm.ecusArr);

                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) {
                            if (!res || !res.data) {
                                throw new Error('Invalid response data');
                            }

                            // Parse the PostgreSQL data
                            var parsedData = parsePostgresData(res.data);

                            // Preserve selection states and other UI state
                            parsedData = parsedData.map(function(newEcu) {
                                var existingEcu = _.find(currentData, {id: newEcu.id});
                                if (existingEcu) {
                                    var mergedEcu = angular.extend({}, newEcu);
                                    mergedEcu.isCheck = existingEcu.isCheck;
                                    mergedEcu.isEditable = existingEcu.isEditable;
                                    return mergedEcu;
                                }
                                return newEcu;
                            });

                            // Update the data only if we have valid results
                            if (parsedData && parsedData.length > 0) {
                                vm.ecusArr = parsedData.map(function(ecuObj) {
                                    // Process timestamps and relationships
                                    if (ecuObj.createdAt) {
                                        ecuObj.createdDate = vm.fnGetAbsoluteOrRelativeTime(ecuObj.createdAt);
                                    }
                                    if (ecuObj.updatedAt) {
                                        ecuObj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(ecuObj.updatedAt);
                                    }
                                    if (ecuObj.projectId) {
                                        ecuObj.project = _.find(vm.projectsArr, {id: ecuObj.projectId});
                                    }
                                    if (ecuObj.lastSeenAt && ecuObj.lastSeenAt !== 0) {
                                        ecuObj.lastSeenDate = vm.fnGetAbsoluteOrRelativeTime(ecuObj.lastSeenAt);
                                    }
                                    return ecuObj;
                                });
                            } else {
                                // If no valid data, restore previous state
                                vm.ecusArr = currentData;
                            }

                            // Update selected ECUs
                            vm.selectedEcusArr = vm.selectedEcusArr.filter(function(selectedEcu) {
                                return _.find(vm.ecusArr, {id: selectedEcu.id});
                            });
                        })
                        .catch(function(error) {
                            // On error, restore previous state
                            vm.ecusArr = currentData;
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                        .finally(function() {
                            vm.isRefreshing = false;

                            // Schedule next refresh
                            vm.ecuTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 60000);
                        });
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ECU ID copied successfully");
                };

                $scope.$on('RequestECUTunnel', function (event, data) {
                    vm.fnRequestEcuTunnel(data);
                });

                $scope.$on('RequestECUSynchronizing', function (event, data) {
                    vm.fnDeployECU(data);
                });

                $scope.$on('RequestECUNetworkScan', function (event, data) {
                    vm.fnRequestStartNetworkScan(data);
                });

                var ecuKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.ecu') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[68] && vm.selectedEcusArr.length > 1 && vm.permissionObj.DELETE_ECU &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleEcus(vm.selectedEcusArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var ecuKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.ecu') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', ecuKeyDownEventHandler);
                document.addEventListener('keyup', ecuKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.ecuTableAPITimeout);
                    document.removeEventListener('keydown', ecuKeyDownEventHandler);
                    document.removeEventListener('keyup', ecuKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DevicesCtrl',
            function ($http, $scope, $window, L, $timeout, $stateParams, $state, $uibModal, Paho, amaran, swal,
                      microSpinner, DB, Authenticate, LastPageService, PermissionsService, SortIconService,
                      PaginationService, ColorService, FedSudoUserService, IconService, WebSocketFactory, UserFactory, BatchFactory,
                      DeviceFactory, VisualizerFactory, TypeFactory, postActionModelIcon, postActionModelMessage,
                      jsonToCsvConvertService, AppInitService, GatewayFactory, XLSX) {
                var vm = this;
                var client;
                var markerLayers = [];
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    67: false, //c
                    68: false //d
                };
                var addedDeviceId = '';
                var typeCount = 0;
                //dropdown filters
                vm.deviceFilter = [
                    {
                        title: 'Health',
                        subMenu: [{
                            title: '200-500',
                            healthrange: {
                                minValue: "200",
                                maxValue: "500"
                            }
                        }, {
                            title: '300-500',
                            healthrange: {
                                minValue: "300",
                                maxValue: "500"
                            }
                        }, {
                            title: '400-500',
                            healthrange: {
                                minValue: "400",
                                maxValue: "500"
                            }
                        }]
                    }, {
                        title: 'Connection',
                        subMenu: [{
                            title: 'Connected'
                        }, {
                            title: 'Disconnected'
                        }]
                    }, {
                        title: 'Gateway'
                    }, {
                        title: 'OEM'
                    }, {
                        title: 'Model'
                    }, {
                        title: 'Phase'
                    }];

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var finalHeight = total - (search + pagination + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.filterdevices = [];
                vm.isDeviceSearchDataLoaded = false;
                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "Phase",
                        fieldName: "phase"
                    },
                    {
                        fieldDisplayName: "TypeId",
                        fieldName: "typeId"
                    },
                    {
                        fieldDisplayName: "Health",
                        fieldName: "health"
                    },
                    {
                        fieldDisplayName: "DefaultHealth",
                        fieldName: "defaultHealth"
                    }
                ];
                vm.isDropUp = false;
                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };
                vm.filterQuery = "";

                vm.tabs = [
                    {
                        name: 'Table View',
                        icon: "fa-table",
                        tabIndex: 0
                    },
                    {
                        name: 'Geo Map',
                        icon: "fa-map-marker",
                        tabIndex: 1

                    },
                    {
                        name: 'Grid View',
                        icon: "fa-th-large",
                        tabIndex: 2
                    },
                    {
                        name: 'Tree Map',
                        icon: "fa-trello",
                        tabIndex: 3
                    }
                ];
                vm.selectedTab = {};

                vm.tableOptionsObj = {
                    name: true,
                    description: true,
                    phase: true,
                    health: true
                };
                vm.tableSectionView = true;
                vm.infoSectionView = true;
                vm.tableClass = 'col-sm-6';
                vm.infoSectionClass = 'col-sm-6';
                //Listener Variables
                vm.isDevicesLoading = false;
                vm.devicesArr = [];
                vm.typesArr = [];
                vm.deviceTypesArr = [];
                vm.gatewaysArr = [];
                vm.selectedDevicesArr = [];
                vm.selectedDeviceObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isCreateCSV = false;
                vm.isConnectNativeInterface = false;
                vm.csvHeaderArr = [];
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : parseInt(perPage[0]) > 100 ? '100' : perPage[0]);
                vm.cursor = '';
                vm.totalItems = 0;
                vm.prevCollection = null;
                vm.nextCollection = null;
                vm.isPrevVisible = false;
                vm.isNextVisisble = false;

                //API params Variable
                vm.inputObj = {};
                vm.resetEditDeviceObj = {};
                //Context Menu: Start
                vm.deviceContextMenu = function (deviceObj) {
                    if (Object.keys(vm.resetEditDeviceObj).length) {
                        var isFindDevice = _.find(vm.devicesArr, {id: vm.resetEditDeviceObj.id});
                        if (isFindDevice) {
                            vm.fnCancelDeviceEditMode(isFindDevice);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            deviceObj.isEditable = true;
                            vm.resetEditDeviceObj = angular.copy(deviceObj);
                        }
                    }]
                };

                vm.fnCancelDeviceEditMode = function (deviceObj, isSuccessCall) {
                    if (isSuccessCall) {
                        deviceObj.name = angular.copy(deviceObj.name);
                        deviceObj.description = angular.copy(deviceObj.description);
                        deviceObj.isEditable = false;
                        vm.resetEditDeviceObj = {};
                    } else {
                        deviceObj.name = angular.copy(vm.resetEditDeviceObj.name);
                        deviceObj.description = angular.copy(vm.resetEditDeviceObj.description);
                        deviceObj.isEditable = false;
                        vm.resetEditDeviceObj = {};
                    }
                };

                vm.fnSaveDeviceInfo = function (deviceObj) {
                    deviceObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        deviceId: deviceObj.id
                    };
                    inputObj.body = {
                        name: deviceObj.name,
                        description: angular.isUndefined(deviceObj.description) ? '' : deviceObj.description
                    };
                    DeviceFactory.modifyDevice(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.devicesArr, function (deviceObj) {
                                if (Object.keys(vm.selectedDeviceObj).length) {
                                    if (deviceObj.id === vm.selectedDeviceObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedDeviceObj[key] = val;
                                            deviceObj[key] = val;
                                        });
                                    }
                                }
                                if (deviceObj.id === resetCopy.id) {
                                    deviceObj.name = resetCopy.name;
                                    deviceObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelDeviceEditMode(deviceObj, true);
                            amaran.success("Device Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelDeviceEditMode(deviceObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                //Context Menu: End

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    if (vm.selectedTab.tabIndex !== 0) {
                        if (vm.selectedTab.tabIndex === 1) {
                            vm.fnSetMapHeight();
                        } else if (vm.selectedTab.tabIndex === 3) {
                            vm.fnSetTreeMapHeight();
                        }
                    } else {
                        vm.fnSetTableHeight();
                    }
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, isCalledDirective, isCalledFromInit) {
                    //vm.isDevicesLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.size) {
                        if ($stateParams.size === '0') {
                            perPage = FedSudoUserService.fnGetUserData('perPage');
                            vm.perPage = parseInt(perPage === '' ? 20 : parseInt(perPage[0] > 100 ? '100' : perPage[0]));
                        } else {
                            vm.perPage = Math.ceil($stateParams.size)
                        }
                    } else {
                        perPage = FedSudoUserService.fnGetUserData('perPage');
                        vm.perPage = parseInt(perPage === '' ? 20 : parseInt(perPage[0] > 100 ? '100' : perPage[0]));
                    }
                    var inputObj = {};
                    if (sortQuery && sortQuery.length && sortQuery !== '') {
                        inputObj.sort = sortQuery;
                        $stateParams.sort = inputObj.sort;
                    } else {
                        delete $stateParams.sort;
                    }
                    if (vm.filterQuery.length) {
                        inputObj = {
                            size: vm.perPage,
                            q: vm.filterQuery,
                            start: isCalledDirective ? 0 : $stateParams.start ? parseInt($stateParams.start) : 0,
                            sort: $stateParams.sort ? $stateParams.sort : ''
                        };
                    } else {
                        inputObj = {
                            size: vm.perPage,
                            q: '',
                            start: isCalledDirective ? 0 : $stateParams.start ? parseInt($stateParams.start) : 0,
                            sort: $stateParams.sort ? $stateParams.sort : ''
                        };
                    }
                    if (isCalledFromInit) {
                        vm.isDevicesLoading = true;
                    } else {
                        vm.isDeviceSearchDataLoaded = true;
                    }
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    if (vm.devicePermissionObj.List) {
                        if (typeCount === 0) {
                            vm.fnGetTypes(inputObj);
                        } else {
                            if (vm.selectedTab.tabIndex !== 0) {
                                inputObj.size = 100;
                                inputObj.start = 0;
                                vm.perPage = 100;
                                vm.fnGetDevices(inputObj);
                            } else {
                                vm.fnGetDevices(inputObj);
                            }
                        }
                    } else {
                        vm.devicesArr = [];
                        vm.isDevicesLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".selected-filter-info-msg")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = angular.element(".selected-filter-info-msg")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element(".deviceMainTable tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetMapHeight = function () {
                    if (vm.selectedTab.tabIndex !== 0 &&
                        vm.selectedTab.tabIndex === 1 &&
                        angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".selected-filter-info-msg")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = angular.element(".selected-filter-info-msg")[0].offsetHeight;

                        var finalHeight = total - (search + searchTag + 70);
                        angular.element("#map1").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetTreeMapHeight = function () {
                    if (vm.selectedTab.tabIndex !== 0 &&
                        vm.selectedTab.tabIndex === 3 &&
                        angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".selected-filter-info-msg")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = angular.element(".selected-filter-info-msg")[0].offsetHeight;

                        var finalHeight = total - (search + searchTag + 70);
                        angular.element("#treeMap").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    if (Object.keys(vm.resetEditDeviceObj).length) {
                        var isFindDevice = _.find(vm.devicesArr, {id: vm.resetEditDeviceObj.id});
                        if (isFindDevice) {
                            vm.fnCancelDeviceEditMode(isFindDevice);
                        }
                    }
                    angular.forEach(vm.devicesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDevicesArr = angular.copy(vm.devicesArr);
                    } else {
                        vm.selectedDevicesArr = [];
                    }
                    $state.go('main.device', {
                        selectedId: '',
                        selectedDetailsTab: '',
                        selectedComponentId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    delete $stateParams.selectedComponentId;
                };

                vm.fnGetDevice = function (deviceObj, devicesArr, isCalledFromDirective) {
                    if (Object.keys(vm.resetEditDeviceObj).length) {
                        var isFindDevice = _.find(vm.devicesArr, {id: vm.resetEditDeviceObj.id});
                        if (isFindDevice) {
                            vm.fnCancelDeviceEditMode(isFindDevice);
                        }
                    }
                    angular.forEach(devicesArr, function (device) {
                        device.isCheck = false;
                    });
                    deviceObj.isCheck = true;
                    vm.selectedDevicesArr = [deviceObj]; // Assign array with single device object
                    vm.fnGetDeviceDetails(deviceObj, isCalledFromDirective);
                };

                vm.fnGetDeviceDetails = function (deviceObj, isCalledFromDirective) {
                    vm.isDeviceDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when device is selected
                        vm.selectedDeviceObj = deviceObj;
                        if (vm.isConnectNativeInterface === true) {
                            $state.go('main.device', {
                                selectedId: vm.selectedDeviceObj.id,
                                isConnectNativeInterface: true
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedDeviceObj.id;
                            $stateParams.isConnectNativeInterface = true;
                            vm.isConnectNativeInterface = false;
                        } else {
                            $state.go('main.device', {selectedId: vm.selectedDeviceObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedDeviceObj.id;
                        }
                        vm.isDeviceDetailsLoaded = true;
                    });
                    if (isCalledFromDirective) {
                        $scope.$apply();
                    }
                };

                vm.fnCheckUncheckHeader = function (deviceObj, fromList) {
                    vm.isAllChecked = true;
                    if (Object.keys(vm.resetEditDeviceObj).length) {
                        var isFindDevice = _.find(vm.devicesArr, {id: vm.resetEditDeviceObj.id});
                        if (isFindDevice) {
                            vm.fnCancelDeviceEditMode(isFindDevice);
                        }
                    }
                    angular.forEach(vm.devicesArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === deviceObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected devices array*/
                    var isValueFind = _.find(vm.selectedDevicesArr, {'id': deviceObj.id});
                    if (!isValueFind) {
                        vm.selectedDevicesArr.push(deviceObj)
                    } else {
                        _.remove(vm.selectedDevicesArr, function (obj) {
                            return deviceObj.id === obj.id;
                        });
                    }
                    if (vm.selectedDevicesArr.length === 1) {
                        vm.fnGetDeviceDetails(vm.selectedDevicesArr[0])
                    } else {
                        $state.go('main.device', {
                            selectedId: '',
                            selectedDetailsTab: '',
                            selectedComponentId: ''
                        }, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        delete $stateParams.selectedComponentId;
                    }
                };

                vm.fnDeleteMultipleDevices = function (selectedDevicesArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedDevicesArr, function (selectedDevice, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/devices/" + selectedDevice.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/devices/" + selectedDevice.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected devices?",
                            text: "You are about to permanently delete the selected devices.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'device', appName: 'node'})
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDevicesArr, function (selectedDevice) {
                                    angular.forEach(vm.devicesArr, function (deviceObj, index) {
                                        if (selectedDevice.id === deviceObj.id) {
                                            vm.devicesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDevicesArr.length;
                                vm.selectedDeviceObj = null;
                                vm.selectedDevicesArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDevicesArr, function (selectedDevice) {
                                    angular.forEach(vm.devicesArr, function (deviceObj, index) {
                                        if (selectedDevice.id === deviceObj.id) {
                                            vm.devicesArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDevicesArr.length;
                                vm.selectedDeviceObj = null;
                                vm.selectedDevicesArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetDevices = function (inputObj, preDefinedDevices, isCalledForViz) {
                    DeviceFactory.getDevicesV4(inputObj)
                        .then(function (res) { // Success block
                            vm.isNextVisisble = (res.hit.length + res.start) < res.found;
                            vm.isPrevVisible = res.start !== 0;
                            var devicesArr = isCalledForViz ? preDefinedDevices : [];
                            var tempDeviceObj = {};
                            _.forEach(res.hit, function (hitObj) {
                                tempDeviceObj = {};
                                _.forEach(hitObj.fields, function (value, key) {
                                    var tempNewKey = '';
                                    switch (key) {
                                        case "typeid":
                                            tempNewKey = 'typeId';
                                            break;
                                        case "gatewayid":
                                            tempNewKey = 'gatewayId';
                                            break;
                                        case "clusterids":
                                            tempNewKey = 'clusterIds';
                                            break;
                                        default:
                                            tempNewKey = key;
                                            break
                                    }
                                    if (key !== 'clusterids') {
                                        tempDeviceObj[tempNewKey] = value[0];
                                    } else {
                                        tempDeviceObj[tempNewKey] = value;
                                    }
                                });
                                devicesArr.push(tempDeviceObj);
                            });
                            _.forEach(devicesArr, function (resObj) {
                                var typeObj = _.find(vm.typesArr, {'id': resObj.typeId});
                                if (typeObj) {
                                    resObj.hasComponents = typeObj.hasComponents;
                                    resObj.nativeUiType = typeObj.nativeUiType ? typeObj.nativeUiType : 'Embed'
                                }
                                resObj.isEditable = false;
                            });
                            if (vm.selectedTab.tabIndex !== 0) {
                                if (devicesArr.length < res.found) {
                                    var inputObjTemp = {
                                        start: inputObj.start + inputObj.size,
                                        size: inputObj.size,
                                        q: inputObj.q,
                                        sort: inputObj.sort
                                    };
                                    vm.fnGetDevices(inputObjTemp, devicesArr, true);
                                } else {
                                    vm.devicesArr = angular.copy(devicesArr);
                                    vm.totalItems = parseInt(res.found);
                                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, res.start === 0 ? 1 : (res.start / vm.perPage + 1));
                                    if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                            $stateParams.openCreateView === true)) {
                                        vm.fnHideShowCreateForm(true);
                                    } else if ($stateParams.selectedId) {
                                        var deviceData = _.find(vm.devicesArr, {"id": $stateParams.selectedId});
                                        if (deviceData) {
                                            if (vm.selectedTab.visualizerObj) {
                                                if (vm.selectedTab.visualizerObj.layout.type === 'Geomap' || vm.selectedTab.visualizerObj.layout.type === 'Treemap') {
                                                    vm.fnGetDevice(deviceData, vm.devicesArr);
                                                }
                                            } else {
                                                vm.fnGetDevice(deviceData, vm.devicesArr);
                                            }
                                        } else {
                                            $state.go('main.device', {
                                                selectedId: '',
                                                selectedDetailsTab: '',
                                                selectedComponentId: ''
                                            }, {notify: false});
                                            delete $stateParams.selectedId;
                                            delete $stateParams.selectedDetailsTab;
                                            delete $stateParams.selectedComponentId;
                                        }
                                    }
                                    if (addedDeviceId.length) {
                                        vm.fnOpenPostCreateActionModal(addedDeviceId);
                                        addedDeviceId = '';
                                    }
                                    if ($state.current.name === 'main.device') {
                                        $state.go('main.device', {
                                            size: vm.perPage,
                                            start: inputObj.start ? inputObj.start : 0,
                                            sort: inputObj.sort ? inputObj.sort : '',
                                            openCreateView: ''
                                        }, {notify: false});
                                        $stateParams.size = vm.perPage;
                                        $stateParams.start = inputObj.start;
                                        $stateParams.sort = inputObj.sort;
                                        delete $stateParams.openCreateView;
                                    }
                                    if (vm.selectedTab.tabIndex !== 0 && vm.selectedTab.tabIndex === 1) {
                                        vm.fnInitGeomapLayout();
                                    } else {
                                        vm.isDevicesLoading = false;
                                        vm.isRefresh = false;
                                    }
                                    if (vm.isDeviceSearchDataLoaded === true) {
                                        vm.isDeviceSearchDataLoaded = false;
                                    }
                                    $timeout(function () {
                                        if (vm.selectedTab.tabIndex !== 0) {
                                            if (vm.selectedTab.tabIndex === 1) {
                                                vm.fnSetMapHeight();
                                            } else if (vm.selectedTab.tabIndex === 3) {
                                                angular.element($window).triggerHandler('resize')
                                            }
                                        } else {
                                            vm.fnSetTableHeight();
                                        }
                                    })
                                }
                            } else {
                                vm.devicesArr = _.cloneDeepWith(devicesArr);
                                vm.totalItems = parseInt(res.found);
                                vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, res.start === 0 ? 1 : (res.start / vm.perPage + 1));
                                if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                        $stateParams.openCreateView === true)) {
                                    vm.fnHideShowCreateForm(true);
                                } else if ($stateParams.selectedId) {
                                    var SelectedDeviceData = _.find(vm.devicesArr, {"id": $stateParams.selectedId});
                                    if (SelectedDeviceData) {
                                        if (vm.selectedTab.visualizerObj) {
                                            if (vm.selectedTab.visualizerObj.layout.type === 'Geomap' || vm.selectedTab.visualizerObj.layout.type === 'Treemap') {
                                                vm.fnGetDevice(SelectedDeviceData, vm.devicesArr);
                                            }
                                        } else {
                                            vm.fnGetDevice(SelectedDeviceData, vm.devicesArr);
                                        }
                                    } else {
                                        $timeout(function () {
                                            $state.go('main.device', {
                                                selectedId: '',
                                                selectedDetailsTab: '',
                                                selectedComponentId: ''
                                            }, {notify: false});
                                            delete $stateParams.selectedId;
                                            delete $stateParams.selectedDetailsTab;
                                            delete $stateParams.selectedComponentId;
                                        });
                                    }
                                }
                                if (addedDeviceId.length) {
                                    vm.fnOpenPostCreateActionModal(addedDeviceId);
                                    addedDeviceId = '';
                                }
                                if ($state.current.name === 'main.device') {
                                    $state.go('main.device', {
                                        size: vm.perPage,
                                        start: inputObj.start ? inputObj.start : 0,
                                        sort: inputObj.sort ? inputObj.sort : '',
                                        openCreateView: ''
                                    }, {notify: false});
                                    $stateParams.size = vm.perPage;
                                    $stateParams.start = inputObj.start;
                                    $stateParams.sort = inputObj.sort;
                                    delete $stateParams.openCreateView;
                                }
                                if (vm.selectedTab.tabIndex !== 0 && vm.selectedTab.tabIndex === 1) {
                                    vm.fnInitGeomapLayout();
                                } else {
                                    vm.isDevicesLoading = false;
                                    vm.isRefresh = false;
                                }
                                if (vm.isDeviceSearchDataLoaded === true) {
                                    vm.isDeviceSearchDataLoaded = false;
                                }
                                $timeout(function () {
                                    if (vm.selectedTab.tabIndex !== 0) {
                                        if (vm.selectedTab.tabIndex === 1) {
                                            vm.fnSetMapHeight();
                                        } else if (vm.selectedTab.tabIndex === 3) {
                                            angular.element($window).triggerHandler('resize')
                                        }
                                    } else {
                                        vm.fnSetTableHeight();
                                    }
                                })
                            }
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDevicesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (perPage) {
                    //vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.device', {
                        selectedId: '',
                        selectedDetailsTab: '',
                        selectedComponentId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    delete $stateParams.selectedComponentId;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            size: perPage,
                            q: vm.filterQuery,
                            sort: $stateParams.sort ? $stateParams.sort : '',
                            start: 0
                        };
                    } else {
                        vm.inputObj = {
                            size: perPage,
                            q: '',
                            sort: $stateParams.sort ? $stateParams.sort : '',
                            start: 0
                        };
                    }
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };

                vm.fnGetNextPrePagination = function (page, perPage) {
                    $state.go('main.device', {
                        selectedId: '',
                        selectedDetailsTab: '',
                        selectedComponentId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    delete $stateParams.selectedComponentId;
                    vm.perPage = perPage;
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            size: perPage,
                            q: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            size: perPage,
                            q: ""
                        };
                    }
                    vm.inputObj.sort = $stateParams.sort ? $stateParams.sort : '';
                    vm.inputObj.start = parseInt(perPage * (page - 1));
                    vm.isDevicesLoading = true;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDevices(vm.inputObj);
                };

                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.devicePermissionObj.List = false;
                    $timeout(function () {
                        vm.devicePermissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.isCreateCSV = false;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnHideShowCreateDeviceFromCSVForm = function (isCalledForOpen) {
                    vm.isCreate = false;
                    vm.selectedDevicesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreateCSV = true;
                    } else {
                        vm.isCreateCSV = !vm.isCreateCSV;
                    }
                };

                vm.fnGetHealthColor = function (health, deviceObj) {
                    var healthObj = ColorService.getHealthColorForLoop(health);
                    deviceObj.healthName = healthObj.content;
                    return healthObj;
                };

                vm.fnGetPhaseIcon = function (phase) {
                    return IconService.fnGetPhaseIcon(phase);
                };

                vm.fnGetPhaseIconColor = function (phase) {
                    return ColorService.getPhaseColor(phase);
                };

                vm.fnGetPhaseIconBorderColor = function (phase) {
                    return {'border-color': ColorService.getPhaseColor(phase).color};
                };

                vm.fnGetConnectionIcon = function (connection) {
                    return connection === 'CONNECTED' ? 'device-connected' : 'device-disconnected';
                };

                vm.fnGetGatewayConnectionIconColor = function (connection) {
                    return {'border-color': ColorService.getConnectionColor(connection).color};
                };

                $scope.$on("DeviceDeleted", function (evt, data) {
                    vm.selectedDeviceObj = null;
                    vm.selectedDevicesArr = [];
                    vm.devicesArr = vm.devicesArr.filter(function (deviceObj) {
                        return (deviceObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.device', {
                        selectedId: '',
                        selectedDetailsTab: '',
                        selectedComponentId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    delete $stateParams.selectedComponentId;
                    vm.fnReload();
                });

                $scope.$on("DeviceDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.devicesArr, function (deviceObj) {
                        if (deviceObj.id === vm.selectedDeviceObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDeviceObj[key] = val;
                                deviceObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("deviceAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedDeviceId = '';
                    } else {
                        if (vm.devicePermissionObj.List) {
                            addedDeviceId = data;
                        } else {
                            addedDeviceId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnSetSelectedTab = function (tabId) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        loginUser = DB.fnGet('loginUser');
                        var inputObj = {
                            userId: loginUser.id,
                            body: {}
                        };

                        if (angular.isDefined(tabId) && tabId.length) {
                            if (loginUser.data) {
                                loginUser.data.selectedTabDeviceVisualizer = ["" + tabId + ""];
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body.selectedTabDeviceVisualizer = ["" + tabId + ""];
                            }
                        } else {
                            if (loginUser.data) {
                                delete loginUser.data.selectedTabDeviceVisualizer;
                                inputObj.body = loginUser.data;
                            } else {
                                inputObj.body = {}
                            }
                        }
                        UserFactory.updateUserData(inputObj)
                            .then(function (data) {
                                loginUser.data = data;
                                DB.fnSet('loginUser', loginUser);
                            }, function () {
                            });
                    } else {
                        if (angular.isDefined(tabId) && tabId.length) {
                            FedSudoUserService.fnSetUserData('selectedTabDeviceVisualizer', ["" + tabId + ""]);
                        } else {
                            if (loginUser.data) {
                                FedSudoUserService.fnRemoveUserData('selectedTabDeviceVisualizer');
                            }
                        }
                    }
                };

                vm.fnTabChanged = function (tabObj, isCalledFromInit) {
                    vm.selectedTab = tabObj;
                    vm.devicesArr = [];
                    $state.go("main.device", {q: ''}, {notify: false});
                    $timeout(function () {
                        if (!isCalledFromInit) {
                            vm.fnReload();
                        }
                    });
                    if (vm.selectedTab.tabIndex !== 0) {
                        vm.fnSetSelectedTab(vm.selectedTab.name);
                    } else {
                        vm.fnSetSelectedTab()
                    }
                };

                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDeviceCSVData = function () {
                    var tempData = angular.copy(vm.devicesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    var index = data[0].indexOf('isEditable');
                    if (index !== -1) {
                        data[0].splice(index, 1)
                    }
                    if (data[0].indexOf('healthName') !== -1) {
                        data[0].splice(data[0].indexOf('healthName'), 1);
                    }
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (deviceObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = deviceObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var devicesArrCp = angular.copy(vm.devicesArr);
                    var tempData = _.map(devicesArrCp, function (tempObj) {
                        delete tempObj.isEditable;
                        delete tempObj.healthName;
                        delete tempObj.clusterIds;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    /* add to workbook */
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Devices");

                    /* write workbook and force a download */
                    XLSX.writeFile(wb, "devices.xlsx");
                };

                vm.fnInitGeomapLayout = function () {
                    var loc = {};
                    var locations = [];
                    angular.forEach(vm.devicesArr, function (dataObj) {
                        loc = {};
                        if (angular.isDefined(dataObj.location)) {
                            var latLong = dataObj.location.split(',');
                            loc = {dataObj: dataObj};
                            loc.lat = latLong[0];
                            loc.lng = latLong[1];
                            locations.push(loc);
                        }
                    });
                    vm.fnRenderMap(locations);
                };

                vm.fnRenderMap = function (locations) {
                    document.getElementById('deviceMap').innerHTML = "<div id='map1' style='width: 100%;'></div>";
                    $timeout(function () {
                        var mapOptions = {};
                        if (locations.length > 0) {
                            mapOptions.center = [locations[0].lat, locations[0].lng];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        } else {
                            /*---- Default Location : Denver -----*/
                            mapOptions.center = [39.721712, -104.941406];
                            mapOptions.zoom = 8;
                            mapOptions.layers = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {});
                        }
                        var map = new L.Map('map1', mapOptions);
                        setMarkers(map, locations);
                    });
                };

                function setMarkers(map, locations) {
                    if (locations.length > 0) {
                        var markerClusterGroup = L.markerClusterGroup();
                        angular.forEach(locations, function (value) {
                            if (angular.isDefined(value.lat) && angular.isDefined(value.lng)) {
                                var typeObj = _.find(vm.typesArr, {'id': value.dataObj.typeId});
                                var typeName = '';
                                if (typeObj) {
                                    typeName = typeObj.name;
                                } else {
                                    typeName = value.dataObj.typeId;
                                }
                                var healthObj = ColorService.getHealthColorForLoop(value.dataObj.health);
                                var svg = '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.068 125" enable-background="new 0 0 56.068 100" xml:space="preserve">' +
                                    '<path stroke="black" stroke-width="2" fill="' + healthObj['background-color'] + '" d="M28.034,0C12.552,0,0,12.552,0,28.034S28.034,100,28.034,100s28.034-56.483,28.034-71.966S43.517,0,28.034,0z' +
                                    'M28.034,40.477c-6.871,0-12.442-5.572-12.442-12.442c0-6.872,5.571-12.442,12.442-12.442c6.872,0,12.442,5.57,12.442,12.442' +
                                    'C40.477,34.905,34.906,40.477,28.034,40.477z"/>' +
                                    ' </svg>';
                                var icon = L.icon({
                                    iconUrl: 'data:image/svg+xml;base64,' + btoa(svg),
                                    iconSize: [25, 41], // size of the icon
                                    shadowSize: [50, 64], // size of the shadow
                                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                                    shadowAnchor: [4, 62],  // the same for the shadow
                                    popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
                                });
                                var marker = L.marker([value.lat, value.lng], {icon: icon});
                                markerLayers[value.dataObj.id] = marker;
                                var contentString = '<div>' +
                                    '<h3>' + value.dataObj.name + '</h3>' +
                                    '<div class="m-t-4">' +
                                    '<button class="btn btn-xs btn-default ellipsis-label"' +
                                    'uib-tooltip="health"' +
                                    'tooltip-placement="right"' +
                                    'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                    '<span>' + healthObj.content + '</span>' +
                                    ' </button>' +
                                    '<div class="pull-right">' +
                                    '<span class="m-l-10 m-r-5 m-t-3 fa ' + vm.fnGetConnectionIcon(value.dataObj.connection) + '"' +
                                    'uib-tooltip="' + value.dataObj.connection + '"' +
                                    'tooltip-placement="left"' +
                                    '</span>' +
                                    '</div>' +
                                    '<div class="pull-right">' +
                                    '<span class="deviceInfoPageIcon phaseIconBorder"' +
                                    'uib-tooltip="' + value.dataObj.phase + '"' +
                                    'tooltip-placement="left"' +
                                    'style="border-color:' + vm.fnGetPhaseIconBorderColor(value.dataObj.phase)['border-color'] + '">' +
                                    '<span class="' + vm.fnGetPhaseIcon(value.dataObj.phase) + '"></span>' +
                                    '</span>' +
                                    '</div>' +
                                    '</div>' +
                                    '<p class="m-4">Type: ' + typeName + '</p>' +
                                    '<p class="m-4">Id: ' + value.dataObj.id + '</p>' +
                                    '</div>';
                                marker.bindPopup(contentString);
                                marker.on('click', function () {
                                    vm.fnGetDevice(value.dataObj, vm.devicesArr, true);
                                });
                                marker.on('mouseover', function () {
                                    this.openPopup(); //eslint-disable-line
                                });
                                markerClusterGroup.addLayer(marker);
                            }
                        });
                        map.addLayer(markerClusterGroup);
                    }
                    $timeout(function () {
                        map.invalidateSize()
                    }, 200);
                    vm.isDevicesLoading = false;
                    vm.isRefresh = false;
                }

                function onConnectionLost(responseObject) {
                    if (responseObject.errorCode !== 0) {
                        vm.fnInitializeWebSockets();
                    }
                }

                function onMessageArrived(message) {
                    var messageJson = angular.fromJson(message.payloadString);
                    var index = _.findIndex(vm.devicesArr, function (device) {
                        return device.id === messageJson.id;
                    });
                    if (index !== -1 && vm.devicesArr[index]) {
                        if (messageJson.health) {
                            vm.devicesArr[index].health = messageJson.health;
                            if ($stateParams.selectedId && $stateParams.selectedId === messageJson.id) {
                                $scope.$broadcast("DeviceHealthStatusChanged", messageJson);
                            }
                        }
                        if (messageJson.phase) {
                            vm.devicesArr[index].phase = messageJson.phase;
                        }
                        if (messageJson.connection) {
                            vm.devicesArr[index].connection = messageJson.connection;
                        }
                        if (vm.selectedTab.visualizerObj) {
                            if (vm.selectedTab.visualizerObj.layout.type === 'Treemap') {
                                angular.element($window).triggerHandler('resize');
                            } else if (vm.selectedTab.visualizerObj.layout.type === 'Geomap') {
                                var healthObj = ColorService.getHealthColorForLoop(vm.devicesArr[index].health);
                                var svg = '<svg version="1.0" id="' + vm.devicesArr[index].id + '" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 56.068 125" enable-background="new 0 0 56.068 100" xml:space="preserve">' +
                                    '<path stroke="black" stroke-width="2" fill="' + healthObj['background-color'] + '" d="M28.034,0C12.552,0,0,12.552,0,28.034S28.034,100,28.034,100s28.034-56.483,28.034-71.966S43.517,0,28.034,0z' +
                                    'M28.034,40.477c-6.871,0-12.442-5.572-12.442-12.442c0-6.872,5.571-12.442,12.442-12.442c6.872,0,12.442,5.57,12.442,12.442' +
                                    'C40.477,34.905,34.906,40.477,28.034,40.477z"/>' +
                                    '</svg>';
                                var icon = L.icon({
                                    iconUrl: 'data:image/svg+xml;base64,' + btoa(svg),
                                    iconSize: [25, 41], // size of the icon
                                    shadowSize: [50, 64], // size of the shadow
                                    iconAnchor: [12, 41], // point of the icon which will correspond to marker's location
                                    shadowAnchor: [4, 62],  // the same for the shadow
                                    popupAnchor: [0, -42] // point from which the popup should open relative to the iconAnchor
                                });
                                if (markerLayers[vm.devicesArr[index].id]) {
                                    markerLayers[vm.devicesArr[index].id].setIcon(icon);
                                    var contentString = '<div>' +
                                        '<h3>' + vm.devicesArr[index].name + '</h3>' +
                                        '<div class="m-t-4">' +
                                        '<button class="btn btn-xs btn-default ellipsis-label"' +
                                        'uib-tooltip="health"' +
                                        'tooltip-placement="right"' +
                                        'style="background-color: ' + healthObj['background-color'] + ';color: ' + healthObj.color + '">' +
                                        '<span>' + healthObj.content + '</span>' +
                                        ' </button>' +
                                        '<div class="pull-right">' +
                                        '<span class="m-l-10 m-r-5 m-t-3 fa ' + vm.fnGetConnectionIcon(vm.devicesArr[index].connection) + '"' +
                                        'uib-tooltip="' + vm.devicesArr[index].connection + '"' +
                                        'tooltip-placement="left"' +
                                        '</span>' +
                                        '</div>' +
                                        '<div class="pull-right">' +
                                        '<span class="deviceInfoPageIcon phaseIconBorder"' +
                                        'uib-tooltip="' + vm.devicesArr[index].phase + '"' +
                                        'tooltip-placement="left"' +
                                        'style="border-color:' + vm.fnGetPhaseIconBorderColor(vm.devicesArr[index].phase)['border-color'] + '">' +
                                        '<span class="' + vm.fnGetPhaseIcon(vm.devicesArr[index].phase) + '"></span>' +
                                        '</span>' +
                                        '</div>' +
                                        '</div>' +
                                        '<p class="m-4">Type Id: ' + vm.devicesArr[index].typeId + '</p>' +
                                        '<p class="m-4">Id: ' + vm.devicesArr[index].id + '</p>' +
                                        '</div>';
                                    markerLayers[vm.devicesArr[index].id].bindPopup(contentString);
                                }
                            }
                        } else {
                            angular.element($window).triggerHandler('resize');
                        }
                    }
                }

                vm.fnInitializeWebSockets = function () {
                    var sudoUserObj = DB.fnGet('sudo');
                    var federationObj = DB.fnGet('federation');
                    var webSocketId = '';
                    if (sudoUserObj) {
                        webSocketId = sudoUserObj.id.split("-")[0];
                    } else if (federationObj) {
                        webSocketId = federationObj.id.split("-")[1];
                    } else {
                        webSocketId = loginUser.id.split("-")[0];
                    }
                    WebSocketFactory.getWebsocketUrl({topicId: "wss/node/devices/" + webSocketId})
                        .then(function (res) {
                            var requestUrl = res.url;
                            client = new Paho.MQTT.Client(requestUrl, res.clientId);

                            client.onConnectionLost = onConnectionLost;
                            client.onMessageArrived = onMessageArrived;

                            var connectOptions = {
                                onSuccess: function () {
                                    /*console.log("device websocket onConnect"); //eslint-disable-line*/
                                    client.subscribe(res.topic);
                                },
                                useSSL: true,
                                timeout: 3,
                                mqttVersion: 4,
                                onFailure: function () {
                                    /*console.log("device websocket onFail"); //eslint-disable-line*/
                                }
                            };
                            client.connect(connectOptions);
                        })
                };

                vm.fnOpenDeviceGatewayInfo = function (deviceObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/device/modal/gatewayInfoDevice/gatewayInfoDevice.html',
                        size: 'md',
                        controller: 'gatewayInfoDeviceCtrl as gatewayDeviceInfo',
                        resolve: {
                            deviceObj: function () {
                                return deviceObj;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnGetTypes = function (inputObj) {
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        vm.typesArr = AppInitService.getInitData('typesArr');
                        vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                        typeCount++;
                        if (vm.selectedTab.tabIndex !== 0) {
                            inputObj.size = 100;
                            inputObj.start = 0;
                            vm.perPage = 100;
                            vm.fnGetDevices(inputObj);
                        } else {
                            vm.fnGetDevices(inputObj);
                        }
                    } else {
                        TypeFactory.getTypes()
                            .then(function (response) {
                                vm.typesArr = response;
                                vm.deviceTypesArr = _.filter(vm.typesArr, {category: 'DEVICE'});
                                typeCount++;
                                if (vm.selectedTab.tabIndex !== 0) {
                                    inputObj.size = 100;
                                    inputObj.start = 0;
                                    vm.perPage = 100;
                                    vm.fnGetDevices(inputObj);
                                } else {
                                    vm.fnGetDevices(inputObj);
                                }
                            })
                    }
                };

                vm.fnGetGatewaysInfo = function () {
                    GatewayFactory.getGateways({perPage: 0})
                        .then(function (res) {
                            vm.gatewaysArr = res;
                        }, function () {
                            vm.gatewaysArr = [];
                        })
                };

                vm.fnInitDevices = function () {
                    //vm.fnInitializeWebSockets();
                    vm.devicePermissionObj = PermissionsService.getPermissions("node:device");
                    vm.gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                    vm.componentPermissionObj = PermissionsService.getPermissions("node:component");
                    vm.isDeviceVisualizerLoaded = false;
                    if (vm.gatewayPermissionObj.List) {
                        vm.fnGetGatewaysInfo();
                    }
                    if (vm.devicePermissionObj.List) {
                        var selectedTabDeviceVisualizer = FedSudoUserService.fnGetUserData('selectedTabDeviceVisualizer');
                        var userChoice = selectedTabDeviceVisualizer === '' ? undefined : selectedTabDeviceVisualizer[0];
                        if (angular.isDefined(userChoice)) {
                            angular.forEach(vm.tabs, function (tabObj) {
                                if (tabObj && userChoice === tabObj.name) {
                                    vm.fnTabChanged(tabObj, true);
                                }
                            });
                            if (!Object.keys(vm.selectedTab).length) {
                                vm.selectedTab = vm.tabs[0];
                            }
                        } else {
                            vm.selectedTab = vm.tabs[0];
                        }
                    }
                    vm.isDeviceVisualizerLoaded = true;
                };

                vm.fnOpenPostCreateActionModal = function () { //selectedId
                    var optionsArr = [{
                        faIcon: "fa-history",
                        userStatement: 'Your Device is being provisioned in the background and will appear in your list once the Gateway has validated it. You can see a live activity stream of the tasks being undertaken in Lifecycles.',
                        subOptions: [{
                            displayText: "View the lifecycle",
                            isRedirect: true,
                            stateName: "main.lifecycle",
                            isVisible: PermissionsService.getPermissions('node:lifecycle').List
                        }]
                    }, /*{
                        faIcon: "fa-first-order",
                        subOptions: [{
                            displayText: "Create a new Visualizer",
                            isRedirect: true,
                            stateName: "main.createDeviceGatewayVisualizer",
                            params: {type: 'Device'},
                            isVisible: PermissionsService.getPermissions('node:visualizer').Create
                        }]
                    }, */{
                        faIcon: "fa-binoculars",
                        subOptions: [{
                            displayText: "Create a new Observer",
                            isRedirect: true,
                            stateName: "main.observer",
                            isVisible: PermissionsService.getPermissions('node:observer').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.params) {
                                    $state.go(selectedOption.stateName, selectedOption.params);
                                } else {
                                    if (selectedOption.stateName.startsWith("main.create")) {
                                        $state.go(selectedOption.stateName);
                                    } else {
                                        $state.go(selectedOption.stateName, {openCreateView: true});
                                    }
                                }
                            }
                        }, function () {
                        });
                    }
                };

                vm.fnGoToCreateVisualizer = function () {
                    $state.go("main.createDeviceGatewayVisualizer", {'type': 'Device'});
                };

                vm.fnDeviceTableFullScreen = function () {
                    if (vm.tableSectionView === true && vm.tableClass === 'col-sm-6') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = false;
                        vm.tableClass = 'col-sm-12';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    } else if (vm.tableSectionView === true && vm.tableClass === 'col-sm-12') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = true;
                        vm.tableClass = 'col-sm-6';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    }
                };

                vm.fnConnectNativeInterface = function (deviceObj) {
                    vm.isConnectNativeInterface = true;
                    vm.fnGetDevice(deviceObj, vm.devicesArr);
                };

                $scope.$on("DeviceInfoSectionClick", function () {
                    if (vm.infoSectionView === true && vm.infoSectionClass === 'col-sm-6') {
                        vm.tableSectionView = false;
                        vm.infoSectionView = true;
                        vm.infoSectionClass = 'col-sm-12';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    } else if (vm.infoSectionView === true && vm.infoSectionClass === 'col-sm-12') {
                        vm.tableSectionView = true;
                        vm.infoSectionView = true;
                        vm.infoSectionClass = 'col-sm-6';
                        $timeout(function () {
                            angular.element($window).resize();
                        })
                    }
                });

                var devicesKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.device') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.devicePermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[67] && vm.devicePermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from csv
                                vm.fnHideShowCreateDeviceFromCSVForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[67] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedDevicesArr.length > 1 && vm.devicePermissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleDevices(vm.selectedDevicesArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var devicesKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.device') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', devicesKeyDownEventHandler);
                document.addEventListener('keyup', devicesKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    typeCount = 0;
                    if (client) {
                        client.disconnect();
                    }
                    document.removeEventListener('keydown', devicesKeyDownEventHandler);
                    document.removeEventListener('keyup', devicesKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('NodeDashboardCtrl',
            function ($scope, $window, $timeout, $sce, $state) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;
                vm.isCreate = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1900;
                    });
                });

                vm.fnGoToState = function (state) {
                    $state.go(state)
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.isCreate = tab.id === "Create Issue";
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Issue";
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                };
                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeDashboardChartData', angular.toJson(tempIssueData));
                    vm.isCreate = true;
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnInit = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1900) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ClusterCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB,
                      Authenticate, SortIconService, LastPageService, PermissionsService, FedSudoUserService,
                      BatchFactory, PaginationService, AppInitService, TypeFactory, UserFactory, ClusterFactory, postActionModelIcon,
                      postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    }
                ];
                vm.filterQuery = "";

                //Clusters Variables
                vm.isClustersLoading = false;
                vm.clustersArr = [];
                vm.selectedClustersArr = [];
                vm.selectedClusterObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditClusterObj = {};
                vm.typesArr = [];

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.clusterContextMenu = function (clusterObj) {
                    if (Object.keys(vm.resetEditClusterObj).length) {
                        var isFindCluster = _.find(vm.clustersArr, {id: vm.resetEditClusterObj.id});
                        if (isFindCluster) {
                            vm.fnCancelClusterEditMode(isFindCluster);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            clusterObj.isEditable = true;
                            vm.resetEditClusterObj = angular.copy(clusterObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelClusterEditMode = function (clusterObj, isSuccessCall) {
                    if (isSuccessCall) {
                        clusterObj.name = angular.copy(clusterObj.name);
                        clusterObj.description = angular.copy(clusterObj.description);
                        clusterObj.isEditable = false;
                        vm.resetEditClusterObj = {};
                    } else {
                        clusterObj.name = angular.copy(vm.resetEditClusterObj.name);
                        clusterObj.description = angular.copy(vm.resetEditClusterObj.description);
                        clusterObj.isEditable = false;
                        vm.resetEditClusterObj = {};
                    }
                };

                vm.fnSaveClusterInfo = function (clusterObj) {
                    clusterObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        clusterId: clusterObj.id
                    };
                    inputObj.body = {
                        name: clusterObj.name,
                        description: angular.isUndefined(clusterObj.description) ? '' : clusterObj.description
                    };
                    ClusterFactory.modifyCluster(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.clustersArr, function (clusterObj) {
                                if (Object.keys(vm.selectedClusterObj).length) {
                                    if (clusterObj.id === vm.selectedClusterObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedClusterObj[key] = val;
                                            clusterObj[key] = val;
                                        });
                                    }
                                }
                                if (clusterObj.id === resetCopy.id) {
                                    clusterObj.name = resetCopy.name;
                                    clusterObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelClusterEditMode(clusterObj, true);
                            amaran.success("Cluster Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelClusterEditMode(clusterObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isClustersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isClustersLoading = true;
                    vm.selectedClustersArr = [];
                    vm.isAllChecked = false;
                    if (vm.permissionObj.List) {
                        vm.fnGetClusters(inputObj);
                    } else {
                        vm.clustersArr = [];
                        vm.isClustersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);
                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("#clusters-table tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (clusterObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.clustersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === clusterObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected cluster array*/
                    var isValueFind = _.find(vm.selectedClustersArr, {'id': clusterObj.id});
                    if (!isValueFind) {
                        vm.selectedClustersArr.push(clusterObj)
                    } else {
                        _.remove(vm.selectedClustersArr, function (obj) {
                            return clusterObj.id === obj.id;
                        });
                    }
                    if (vm.selectedClustersArr.length === 1) {
                        vm.fnGetClusterDetails(vm.selectedClustersArr[0])
                    } else {
                        $state.go('main.cluster', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.clustersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedClustersArr = angular.copy(vm.clustersArr);
                    } else {
                        vm.selectedClustersArr = [];
                    }
                    $state.go('main.cluster', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };
                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedClustersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.cluster', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if (vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isClustersLoading = true;
                    vm.selectedClustersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetClusters(vm.inputObj);
                };

                vm.fnOpenClustersInfoTab = function (clusterObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnGetCluster(clusterObj, vm.clustersArr);
                };

                vm.fnGetCluster = function (clusterObj, clustersArr) {
                    angular.forEach(clustersArr, function (cluster) {
                        cluster.isCheck = false;
                    });
                    clusterObj.isCheck = true;
                    vm.selectedClustersArr = [clusterObj]; // Assign array with single cluster object
                    vm.fnGetClusterDetails(clusterObj);
                };

                vm.fnGetClusterDetails = function (clusterObj) {
                    vm.isClusterDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when cluster is selected
                        vm.selectedClusterObj = clusterObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.cluster', {
                                selectedId: vm.selectedClusterObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedClusterObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isClusterDetailsLoaded = true;
                        } else {
                            $state.go('main.cluster', {selectedId: vm.selectedClusterObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedClusterObj.id;
                            vm.isClusterDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetClusters = function (inputObj) {
                    ClusterFactory.getClusters(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.clusters;
                            vm.isClusterDetailsLoaded = false;
                            vm.clustersArr = _.cloneDeepWith(res);
                            if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var clusterData = _.find(vm.clustersArr, {"id": $stateParams.selectedId});
                                if (clusterData) {
                                    vm.fnGetCluster(clusterData, vm.clustersArr);
                                }
                            }
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($state.current.name === 'main.cluster') {
                                $state.go('main.cluster', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }

                            vm.isClustersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isClustersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.clusterSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "clusterSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.clusterSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnClustersSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    } else {
                        if (vm.sortType === type) {
                            if (vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('clusterSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('clusterSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('clusterSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.permissionObj.List = false;
                    $timeout(function () {
                        vm.permissionObj.List = true;
                    }, 10)
                };

                $scope.$on("ClusterDeleted", function (evt, data) {
                    vm.selectedClusterObj = null;
                    vm.selectedClustersArr = [];
                    vm.clustersArr = vm.clustersArr.filter(function (clusterObj) {
                        return (clusterObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.cluster', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("ClusterDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.clustersArr, function (clusterObj) {
                        if (clusterObj.id === vm.selectedClusterObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedClusterObj[key] = val;
                                clusterObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnDeleteMultipleClusters = function (selectedClustersArr) {
                    var count = 1;

                    swal({
                            title: "Delete the selected clusters?",
                            text: "You are about to permanently delete the selected clusters.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.forEach(selectedClustersArr, function (selectedCluster) {
                                    var inputObj = {
                                        clusterId: selectedCluster.id
                                    };
                                    ClusterFactory.deleteCluster(inputObj)
                                        .then(function () {
                                            if (count === selectedClustersArr.length) {
                                                angular.forEach(vm.selectedClustersArr, function (selectedCluster) {
                                                    angular.forEach(vm.clustersArr, function (clusterObj, index) {
                                                        if (selectedCluster.id === clusterObj.id) {
                                                            vm.clustersArr.splice(index, 1);
                                                        }
                                                    });
                                                });
                                                vm.totalItems = vm.totalItems - vm.selectedClustersArr.length;
                                                vm.selectedClusterObj = null;
                                                vm.selectedClustersArr = [];
                                                swal({
                                                    title: postActionModelMessage,
                                                    html: true,
                                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                                    showCancelButton: false,
                                                    showConfirmButton: false,
                                                    customClass: 'customSwalActionModel'
                                                });
                                                angular.element(".microSpinner").remove();
                                                angular.element(".confirm").css("visibility", "visible");
                                                $timeout(function () {
                                                    angular.element(".confirm").css("visibility", "visible");
                                                    swal.close();
                                                }, 1000);
                                                vm.fnReload();
                                            } else {
                                                count++;
                                            }
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                            angular.element('.microSpinner').remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                        });
                                })
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetTypes = function (inputObj) {
                    if (AppInitService.getInitData('typesArr').length !== 0) {
                        var typesArr = AppInitService.getInitData('typesArr');
                        vm.typesArr = _.filter(typesArr, {category: 'DEVICE'});
                    } else {
                        TypeFactory.getTypes(inputObj)
                            .then(function (response) {
                                vm.typesArr = _.filter(response, {category: 'DEVICE'});
                            })
                    }
                };

                vm.fnInitClusters = function () {
                    vm.permissionObj = PermissionsService.getPermissions("node:cluster");
                    /*vm.fnGetTypes({
                        perPage: 0
                    });*/
                    var sortData = FedSudoUserService.fnGetUserData('clusterSort');
                    if (sortData !== '') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var clusterKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.cluster') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedClustersArr.length > 1 && vm.permissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleClusters(vm.selectedClustersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var clusterKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.cluster') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', clusterKeyDownEventHandler);
                document.addEventListener('keyup', clusterKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', clusterKeyDownEventHandler);
                    document.removeEventListener('keyup', clusterKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService,
                      BatchFactory, PaginationService, postActionModelIcon, postActionModelMessage, NodeFactory, NodeEcuFactory,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, NodeAttributesFactory, ColorService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.alarmProjectFilter = "$";
                vm.alarmProjectSearch = {$: ''};
                vm.projectsArr = [];
                vm.isProjectLoaded = false;

                //Search Variables
                vm.isRefreshData = true;
                vm.isProjectLoaded = false;
                vm.isInitAlarm = true;
                vm.tableAlias = 'node_attributes';
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Mode",
                        name: "mode",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Reference",
                        name: "reference",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Node ID",
                        name: "nodeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "ECU ID",
                        name: "ecuId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Node Name",
                        name: "node_nodes.data->>\'name\'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }, {
                        displayName: "ECU Name",
                        name: "node_nodes.data->>\'name\'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }, {
                        displayName: "Tracked",
                        name: "issueIds",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "jsonb_array_length(node_attributes.data->'issueIds') > 0",
                        localSearchValue: "obj.issueIds.length > 0"
                    }, {
                        displayName: "Untracked",
                        name: "issueIds",
                        regexp: "",
                        errorMessage: "",
                        isDirectFilterApply: true,
                        sqlValue: "node_attributes.data->'issueIds' IS NULL",
                        localSearchValue: "!obj.issueIds.length"
                    }, {
                        displayName: "Issue ID",
                        name: "issueIds",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="}
                        ],
                        sqlSearchType: "array"
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'healthLastChangedAt', displayName: 'Health Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Alarms Variables
                vm.isAlarmsLoading = false;
                vm.alarmsArr = [];
                vm.selectedAlarmsArr = [];
                vm.selectedAlarmObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                vm.isCreate = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.alarmResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowAlarmStats = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.lastSQLQuery = "";
                vm.alarmTableAPITimeout = '';

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // New parsing for the updated query result
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map fields from parsed data
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.health = parsedData.health;
                                parsedItem.nodeId = parsedData.nodeId || parsedData.nodeid || parsedItem.nodeId || parsedItem.nodeid;
                                parsedItem.ecuId = parsedData.ecuId || parsedData.ecuid || parsedItem.ecuId || parsedItem.ecuid;
                                parsedItem.projectId = parsedData.projectId || parsedData.projectid || parsedItem.projectId || parsedItem.projectid;

                                // Use timestamp for receivedAt if available
                                if (parsedData.timestamp) {
                                    parsedItem.receivedAt = parseInt(parsedData.timestamp);
                                }

                                // Use name from the main item if available, otherwise from parsed data
                                parsedItem.name = parsedItem.name || parsedData.name;

                                // Set ecuName
                                parsedItem.ecuName = parsedItem.ecuname || parsedData.ecuName;

                                // Merge parsed data
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.alarmTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;

                    if (vm.isInitEcu === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProjects({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'alarm', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    }
                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnGetProjectAlarm = function (projectObj) {
                    $timeout.cancel(vm.alarmTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM node_attributes';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_attributes';
                    }
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                            sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'selectedProject', '');
                    }
                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.alarmsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedAlarmsArr = [];
                                vm.selectedAlarmObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "WidgetEditor" &&
                                tab.id !== "Create Issue" &&
                                tab.id !== "alarmStats") {
                                if (vm.isAlarmsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedAlarmsArr = [];
                                    vm.selectedAlarmObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title, projectId: tab.projectId});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.alarms', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowAlarmStats = tab.id === "alarmStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreate = tab.id === "Create Issue";
                        vm.isCreateIssue = tab.id === "Create Insight Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            $timeout.cancel(vm.alarmTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowAlarmStats = tab.id === "alarmStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Insight Issue";
                    vm.isCreate = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "Create Insight Issue" || tab.id === "alarmStats" || tab.id === "WidgetEditor") {
                        $state.go('main.alarms', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedAlarmObj = [];
                        vm.selectedAlarmObj = {};
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.alarmTableAPITimeout);
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.alarms', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#alarmTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (alarmObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.alarmsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === alarmObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected Alarm array*/
                    var isValueFind = _.find(vm.selectedAlarmsArr, {'id': alarmObj.id});
                    if (!isValueFind) {
                        vm.selectedAlarmsArr.push(alarmObj);
                        var isTabExist = _.find(vm.tabs, {'id': alarmObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            var tempObj = {
                                id: alarmObj.id,
                                title: alarmObj.name,
                                tabIndex: newTabIndex
                            };
                            var isFindIndex = _.findIndex(vm.projectsArr, {id: alarmObj.projectId});
                            if (isFindIndex !== -1) {
                                tempObj.projectName = vm.projectsArr[isFindIndex].name
                                tempObj.projectId = vm.projectsArr[isFindIndex].id
                            }
                            vm.tabs.push(tempObj);
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedAlarmsArr, function (obj) {
                            return alarmObj.id === obj.id;
                        });
                    }
                    if (vm.selectedAlarmsArr.length === 1) {
                        vm.fnGetAlarmDetails(vm.selectedAlarmsArr[0])
                    } else {
                        $state.go('main.alarms', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.alarmsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAlarmsArr = angular.copy(vm.alarmsArr);
                    } else {
                        vm.selectedAlarmsArr = [];
                    }
                    $state.go('main.alarms', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (alarmObj) {
                    var isFindIndex = _.findIndex(vm.selectedAlarmsArr, {id: alarmObj});
                    if (alarmObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.push(alarmObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.alarmTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.alarms', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                        sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                    } else { //for general sort
                        sqlString = 'SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                        sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                    }

                    if (isPerPageChanged) {
                        if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_attributes.data->>\'projectId\' = '" + vm.project.id + "')" : " WHERE node_attributes.data->>\'projectId\' = '" + vm.project.id + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        } else {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY node_attributes.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " )" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                                sqlString += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() : "";
                                sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + ")" : " )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAlarms(perPageInput, true);
                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " node_attributes.data->>\'projectId\' = '" + vm.project.id + "'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.alarmsArr, true, 'node_attributes');
                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }
                        var newSQL = "WITH attributes AS (" + tempNewSQL + "),";
                        newSQL += " rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>'ecuId' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>'nodeId' = node_nodes.data->>\'id\'";
                        newSQL += tempSQL && tempSQL.length ? " WHERE " + tempSQL.trim() + ")" : " )";
                        newSQL += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }
                        vm.previousPage = page;
                        vm.fnGetAlarms(newInput, false);
                    }
                };

                vm.fnOpenAlarmInfoTab = function (alarmObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(alarmObj);
                };

                vm.fnGetAlarm = function (alarmObj, alarmsArr) {
                    angular.forEach(alarmsArr, function (alarm) {
                        alarm.isCheck = false;
                    });
                    alarmObj.isCheck = true;
                    vm.selectedAlarmsArr = [alarmObj]; // Assign array with single alarm object
                    vm.fnGetAlarmDetails(alarmObj);
                };

                vm.fnGetAlarmDetails = function (alarmObj) {
                    vm.isAlarmDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when alarm is selected
                        vm.selectedAlarmObj = alarmObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.alarms', {
                                selectedId: vm.selectedAlarmObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedAlarmObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isAlarmDetailsLoaded = true;
                        } else {
                            $state.go('main.alarms', {selectedId: vm.selectedAlarmObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedAlarmObj.id;
                            vm.isAlarmDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetAlarms = function (inputObj, isFirst) {
                    vm.isAlarmsLoading = true;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse the Postgres data before processing
                            var parsedData = parsePostgresData(res.data);

                            parsedData.map(function (obj) {
                                if (obj.receivedAt) {
                                    obj.receivedDate = vm.fnGetAbsoluteOrRelativeTime(obj.receivedAt);
                                }
                                if (obj.healthLastChangedAt) {
                                    obj.healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.healthLastChangedAt);
                                }
                            });

                            // Store the parsed response
                            vm.alarmResponse = angular.copy(res);
                            vm.alarmResponse.data = parsedData;

                            if (isFirst) {
                                if (vm.alarmResponse.data && vm.alarmResponse.data.length) {
                                    vm.totalItems = vm.alarmResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.alarmResponse.data.reverse();
                            }
                            vm.alarmsArr = vm.alarmResponse.data;

                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.alarmsArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData);
                                } else {
                                    swal({
                                        title: "Please wait while your data loads...",
                                        type: "warning",
                                        showConfirmButton: true,
                                        showLoaderOnConfirm: true
                                    });
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    var attributeSQLQuery = 'WITH attributes AS ( SELECT node_attributes.*, node_attributes.data->>\'_id\' AS rt, node_nodes.data->>\'name\' AS ecuName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_nodes.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, CASE WHEN node_attributes.data->>\'ecuId\' = node_attributes.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId FROM node_attributes AS node_attributes';
                                    attributeSQLQuery += ' LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                    attributeSQLQuery += " WHERE node_attributes.data->>'id' = '" + $stateParams.selectedId + "'";
                                    attributeSQLQuery += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                    attributeSQLQuery += ' rows AS ( SELECT COUNT(*) AS qty FROM node_attributes LEFT JOIN node_ecus ON node_attributes.data->>\'ecuId\' = node_ecus.data->>\'id\' LEFT JOIN node_nodes ON node_attributes.data->>\'nodeId\' = node_nodes.data->>\'id\'';
                                    attributeSQLQuery += " WHERE node_attributes.data->>'id' = '" + $stateParams.selectedId + "')";
                                    attributeSQLQuery += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                                    QueryFactory.executeQuery({sql: attributeSQLQuery})
                                        .then(function (response) {
                                            angular.element(".microSpinner").remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            if (response && response.data && response.data.length && response.data[0]) {
                                                if (response.data[0].projectId) {
                                                    response.data[0].project = _.find(vm.projectsArr, {id: response.data[0].projectId});
                                                }
                                                vm.fnCheckUncheckHeader(response.data[0]);
                                            }
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                        });
                                }
                            }

                            if ($state.current.name === 'main.alarms') {
                                $state.go('main.alarms', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isAlarmsLoading = false;
                            vm.isInitAlarm = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                            vm.alarmTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 5 * 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAlarmsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isInitAlarm = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnAddDefaultFilter = function () {
                    if (angular.isUndefined($stateParams.filter)) {
                        var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'alarm', 'searchFilter');
                        if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                            var tempArr = {};
                            if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                                tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                                $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                            }
                            if (searchFilterObj.sort && searchFilterObj.sort.length) {
                                tempArr.sort = searchFilterObj.sort;
                                $stateParams.sort = searchFilterObj.sort;
                            }
                            $state.go("main.alarms", tempArr, {notify: false});
                        } else {
                            if (angular.isUndefined($stateParams.filter)) {
                                var inputObj = [{
                                    id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                    selectedField: "health",
                                    displaySelectedField: "Health",
                                    selectedFilter: {operatorName: ">", operator: ">"},
                                    searchText: "299",
                                    displaySearchText: "299",
                                    sqlValue: 'data->>\'health\' > \'299\'',
                                    localSearchValue: 'obj.health > 299'
                                }];
                                $state.go("main.alarms", {filter: angular.toJson(inputObj)}, {notify: false});
                                $stateParams.filter = angular.toJson(inputObj);
                            }
                        }
                    }
                };

                vm.fnGetAlarmDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetAlarmStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'alarmStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowAlarmStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'alarmStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowAlarmStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAlarmCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.alarmsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.alarmsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Alarms");
                    XLSX.writeFile(wb, "Alarms.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'alarm', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                vm.fnOpenCreateIssueTab = function (alarmObj) {
                    vm.isCreate = true;
                    DB.fnSet('createIssueAlarmObj', alarmObj);
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnOpenLinkIssueModal = function (attributeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/linkIssueModal/linkIssueModal.html',
                        size: 'lg',
                        controller: 'linkIssueModalCtrl as linkIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(attributeObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                }

                vm.fnRequestNodeTunnel = function (alarmObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                        size: 'lg',
                        controller: 'nodeJobTerminalCtrl as jobTerminal',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith({id: alarmObj.rootNodeId});
                            },
                            isEcuTunnel: function () {
                                return false;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    }, function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    });
                };

                vm.fnRequestECUTunnel = function (alarmObj) {
                    swal({
                        title: "Please wait while your data loads...",
                        type: "warning",
                        showConfirmButton: true,
                        showLoaderOnConfirm: true
                    });
                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                    angular.element(".confirm").css("visibility", "hidden");
                    NodeEcuFactory.describeECU({'ecuId': alarmObj.ecuId})
                        .then(function (res) { // Success block
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                                size: 'lg',
                                controller: 'nodeJobTerminalCtrl as jobTerminal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    nodeObj: function () {
                                        return _.cloneDeepWith(res);
                                    },
                                    isEcuTunnel: function () {
                                        return true;
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                };

                vm.fnInitAlarms = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.isShowTunnelOption = loginUser.id.startsWith('cu000000') && !DB.fnGet('support') && !DB.fnGet('federation');
                    vm.fnAddDefaultFilter();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'alarm', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnOpenInsightCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeAlarmChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Insight Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnOpenIssueListModal = function (attributes) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/issueListModal/issueListModal.html',
                        size: 'lg',
                        controller: 'issueListModalCtrl as issueList',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributes: function () {
                                return _.cloneDeepWith(attributes);
                            }
                        }
                    });
                    modalInstance.result.then(function (res) {
                        _.forEach(attributes, function (attributeObj) {
                            var isFind = _.find(res.attributes, {id: attributeObj.id});
                            if (isFind) {
                                if (angular.isUndefined(attributeObj.issueIds)) {
                                    attributeObj.issueIds = [];
                                }
                                attributeObj.issueIds.push(_.cloneDeepWith(res.issueId));
                            }
                        })
                    }, function () {
                    });
                }

                vm.fnDeployAttribute = function (alarmObj) {
                    alarmObj.deploysUnsynchronizedAlarm = true;
                    var input = {
                        attributeId: alarmObj.id
                    };
                    NodeAttributesFactory.deployAttribute(input)
                        .then(function (res) {
                            delete alarmObj.deploysUnsynchronizedAlarm;
                            amaran.success("Attribute Synchronize in progress.");
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html',
                                size: 'lg',
                                controller: 'attributeSyncModalCtrl as attributeSyncModal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    jobObj: function () {
                                        return _.cloneDeepWith(res);
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            delete alarmObj.deploysUnsynchronizedAlarm;
                        });
                };

                vm.fnUpdateTableData = _.debounce(function() {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            // Use parsePostgresData only once
                            var parsedData = parsePostgresData(res.data || []);

                            // Update alarmsArr directly with parsed data
                            vm.alarmsArr = parsedData;

                            // Optimize selected alarms filtering
                            vm.selectedAlarmsArr = vm.selectedAlarmsArr.filter(function (selectAlarmObj) {
                                return _.some(parsedData, {id: selectAlarmObj.id});
                            });

                            // Use map instead of forEach for better readability and performance
                            vm.alarmsArr = vm.alarmsArr.map(function(nodeObj) {
                                // Update health updated date using the method from the controller
                                if (nodeObj.timestamp) {
                                    nodeObj.healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(nodeObj.timestamp);
                                }

                                // Check if the item was previously selected
                                nodeObj.isCheck = !!_.find(vm.selectedAlarmsArr, {id: nodeObj.id});

                                return nodeObj;
                            });

                            // Schedule next update
                            vm.alarmHistoryTableAPITimeout = $timeout(vm.fnUpdateTableData, 5 * 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }

                            // Schedule next update even on error
                            vm.alarmHistoryTableAPITimeout = $timeout(vm.fnUpdateTableData, 5 * 60000);
                        });
                }, 300); // Add a small debounce to prevent multiple rapid calls

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                vm.fnOpenRelatedAlarmInfo = function (alarmObj) {
                    DB.fnSet('isOpenRelatedAlarm', 'true');
                    vm.fnOpenAlarmInfoTab(alarmObj, 1);
                };

                $scope.$on("attributeIssueAdded", function () {
                    vm.fnRemoveTab('Create Issue');
                });

                $scope.$on('createIssueAttributeIssue', function (eve, data) {
                    vm.fnOpenCreateIssueTab(data)
                })

                $scope.$on('openNodeTunnel', function (eve, data) {
                    if (data.ecuId === data.nodeId) {
                        vm.fnRequestECUTunnel(data);
                    } else {
                        vm.fnRequestNodeTunnel(data);
                    }
                })

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.alarmTableAPITimeout);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AlarmHistoryCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, d3, panzoom, amaran, swal,
                      moment, microSpinner, WidgetsListService, UserProfileService, DB, XLSX,
                      Authenticate, LastPageService, jsonToCsvConvertService, FedSudoUserService,
                      BatchFactory, PaginationService, postActionModelIcon, postActionModelMessage, NodeFactory, NodeEcuFactory,
                      AppInitService, PaginationQueryService, QueryFactory, PermissionsService, NodeAttributesFactory, ColorService, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.alarmProjectFilter = "$";
                vm.alarmProjectSearch = {$: ''};
                vm.projectsArr = [];
                vm.isProjectLoaded = false;

                //Search Variables
                vm.isRefreshData = true;
                vm.isProjectLoaded = false;
                vm.isInitAlarm = true;
                vm.tableAlias = 'node_iot_attribute_healths';
                vm.searchFiltersArr = [
                    {
                        displayName: "Attribute ID",
                        name: "attributeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Health",
                        name: "health",
                        predefinedOperatorArr: [
                            {operator: "=", operatorName: "="},
                            {operator: "!=", operatorName: "!="},
                            {operator: ">", operatorName: ">"},
                            {operator: "<", operatorName: "<"},
                            {operator: ">=", operatorName: ">="},
                            {operator: "<=", operatorName: "<="},
                            {operator: "between", operatorName: "between"}
                        ],
                        regexp: "^(199|[2-5][0-9]{2}|((199|[2-5][0-9]{2})),((199|[2-5][0-9]{2})))$",
                        errorMessage: "Health only accepts specific health (e.g. 500) or range (e.g 199,500)."
                    }, {
                        displayName: "Node ID",
                        name: "nodeId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "ECU ID",
                        name: "ecuId",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Node Name",
                        name: "node_nodes.data->>\'name\'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }, {
                        displayName: "ECU Name",
                        name: "node_ecus.data->>\'name\'",
                        regexp: "",
                        errorMessage: "",
                        isNeedTableAlias: false
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'health', displayName: 'Health'},
                    {name: 'timestamp', displayName: 'Health Updated'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Alarms Variables
                vm.isAlarmsLoading = false;
                vm.alarmsArr = [];
                vm.selectedAlarmsArr = [];
                vm.selectedAlarmObj = {};
                vm.isTabsLoading = null;
                vm.isDropUp = false;
                vm.isCreate = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.alarmResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowAlarmStats = false;
                vm.isShowDashboard = false;
                vm.isShowWidgetEditor = false;
                vm.lastSQLQuery = "";
                vm.alarmHistoryTableAPITimeout = '';

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    // Precompute moment-related utilities outside the mapping function
                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the nested data string
                            var nestedData = angular.fromJson(item.data || '{}');
                            var primaryId = nestedData.attributeId || nestedData.id || item.id || '';

                            // Combine fields from item and nestedData with case sensitivity fixes
                            var parsedItem = {
                                // Primary fields
                                id: primaryId,
                                name: item.name || item.Name || nestedData.name || nestedData.Name || '',
                                health: parseInt(nestedData.health || nestedData.Health || 0),
                                timestamp: parseInt(nestedData.timestamp || nestedData.Timestamp || 0),

                                // Additional fields with case sensitivity handling
                                description: item.description || item.Description || '',
                                ecuName: item.ecuName || item.ecuname || '',
                                nodeName: item.nodeName || item.nodename || '',
                                ecuId: nestedData.ecuId || nestedData.ecuid || item.ecuId || item.ecuid || '',
                                nodeId: nestedData.nodeId || nestedData.nodeid || item.nodeId || item.nodeid || '',
                                projectId: nestedData.projectId || nestedData.projectid || item.projectId || item.projectid || '',
                                rootNodeId: nestedData.rootNodeId || nestedData.rootnodeid || item.rootNodeId || item.rootnodeid || '',

                                // Metadata fields
                                totalItems: item.totalitems || item.totalItems || 0,
                                createdAt: item.created_at || item.createdAt || '',
                                updatedAt: item.updated_at || item.updatedAt || '',
                                rt: item.rt || item.RT || '',

                                // Arrays and complex fields
                                issueIds: nestedData.issueIds ? safeParseJSON(nestedData.issueIds, []) : []
                            };

                            // Handle timestamp and relative time calculation
                            if (parsedItem.timestamp) {
                                var itemTimestamp = moment.unix(parsedItem.timestamp);
                                var differenceHours = currentTime.diff(itemTimestamp, 'hours');

                                parsedItem.healthUpdatedDate = differenceHours > 24
                                    ? itemTimestamp.format("DD/MM/YYYY")
                                    : itemTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }

                function safeParseJSON(jsonString, defaultValue) {
                    defaultValue = defaultValue || [];

                    try {
                        return jsonString ? angular.fromJson(jsonString) : defaultValue;
                    } catch (error) {
                        $log.error('JSON parsing error:', error);
                        return defaultValue;
                    }
                }

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('node', 'alarmHistory', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('nodeProjectsArr').length !== 0) {
                        vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('nodeProjectsArr'));
                        vm.projectsArr.unshift({name: "All", id: "All"});
                        vm.fnSetSelectedProject();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjects({sql: projectSQL}, [], false).then(function (response) {
                            vm.projectsArr = parsePostgresData(response.data || []);
                        }).catch(function (error) {
                            $log.error('Error fetching projects:', error);
                        });

                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('node', 'alarmHistory', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }
                    var sqlString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND" : " WHERE";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND" : " WHERE";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND" : " WHERE";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    }
                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var parsedData = parsePostgresData(res.data);

                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(parsedData, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((parsedData && parsedData.length && parsedData.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr = _.sortBy(vm.projectsArr, ['name']);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () { // Error block
                            vm.fnGetProjects(inputObj, [], false);
                        })
                };

                vm.fnGetProjectAlarm = function (projectObj) {
                    $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT ' +
                                'node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, ' +
                                'node_iot_attribute_healths.data->>\'attributeId\' as id, ' +
                                'node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, ' +
                                'node_iot_attribute_healths.data->>\'attributeId\' as id, ' +
                                'node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'_id\' ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, ' +
                                'node_iot_attribute_healths.data->>\'attributeId\' as id, ' +
                                'node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        } else {
                            sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                'node_attributes.data->>\'name\' AS name, ' +
                                'node_iot_attribute_healths.data->>\'attributeId\' as id, ' +
                                'node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                'node_ecus.data->>\'name\' AS ecuName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                            sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                            sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'_id\' ASC LIMIT ' + vm.perPage + ' ),';
                            sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                            sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                            sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        }
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarmHistory', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('node', 'alarmHistory', 'selectedProject', '');
                    }
                    vm.fnGetAlarms({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.alarmsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedAlarmsArr = [];
                                vm.selectedAlarmObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" &&
                                tab.id !== "WidgetEditor" &&
                                tab.id !== "Create Issue" &&
                                tab.id !== "alarmStats") {
                                if (vm.isAlarmsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedAlarmsArr = [];
                                    vm.selectedAlarmObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title, projectId: tab.projectId});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.alarmHistory', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowAlarmStats = tab.id === "alarmStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreate = tab.id === "Create Issue";
                        vm.isCreateIssue = tab.id === "Create Insight Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowAlarmStats = tab.id === "alarmStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Insight Issue";
                    vm.isCreate = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue" || tab.id === "Create Insight Issue" || tab.id === "alarmStats" || tab.id === "WidgetEditor") {
                        $state.go('main.alarmHistory', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedAlarmObj = [];
                        vm.selectedAlarmObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                    if (tab.tabIndex === 1) {
                        vm.fnSetDefaultTime();
                    }
                    if (tab.tabIndex !== 1) {
                        $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                    }
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.alarmHistory', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#alarmTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (alarmObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.alarmsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === alarmObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected Alarm array*/
                    var isValueFind = _.find(vm.selectedAlarmsArr, {'id': alarmObj.id});
                    if (!isValueFind) {
                        vm.selectedAlarmsArr.push(alarmObj);
                        var isTabExist = _.find(vm.tabs, {'id': alarmObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            var tempObj = {
                                id: alarmObj.id,
                                title: alarmObj.name,
                                tabIndex: newTabIndex
                            };
                            var isFindIndex = _.findIndex(vm.projectsArr, {id: alarmObj.projectId});
                            if (isFindIndex !== -1) {
                                tempObj.projectName = vm.projectsArr[isFindIndex].name
                                tempObj.projectId = vm.projectsArr[isFindIndex].id
                            }
                            vm.tabs.push(tempObj);
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedAlarmsArr, function (obj) {
                            return alarmObj.id === obj.id;
                        });
                    }
                    if (vm.selectedAlarmsArr.length === 1) {
                        vm.fnGetAlarmDetails(vm.selectedAlarmsArr[0])
                    } else {
                        $state.go('main.alarmHistory', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.alarmsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAlarmsArr = angular.copy(vm.alarmsArr);
                    } else {
                        vm.selectedAlarmsArr = [];
                    }
                    $state.go('main.alarmHistory', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnCheckUncheckCheckbox = function (alarmObj) {
                    var isFindIndex = _.findIndex(vm.selectedAlarmsArr, {id: alarmObj});
                    if (alarmObj.isCheck) {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.push(alarmObj);
                        }
                    } else {
                        if (isFindIndex === -1) {
                            vm.selectedAlarmsArr.splice(isFindIndex, 1);
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.alarmHistory', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAlarmsLoading = true;
                    vm.selectedAlarmsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT node_iot_attribute_healths.*, ' +
                            'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                            'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                            'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                            'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                            'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                            'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                    } else { //for general sort
                        sqlString = 'SELECT node_iot_attribute_healths.*, ' +
                            'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                            'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                            'node_ecus.data->>\'name\' AS ecuName, ' +
                            'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                            'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                            'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                            'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                            'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                    }
                    var endDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[1]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    var previousDateString = moment.utc(moment.unix(parseInt(vm.selectedRange.split(',')[0]))).format('YYYY-MM-DDTHH:mm:ss.000000') + 'Z';
                    if (isPerPageChanged) {
                        if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                    'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                    'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                    'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                                sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                                sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                    //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' )";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                    'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                    'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                    'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                                sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                                sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE node_iot_attribute_healths.data->>\'projectId\' = '" + vm.project.id + "'";
                                sqlString += " AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                    //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        } else {
                            if (sortString !== '') {
                                sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                    'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                    'node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                    'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                                sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                                sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                                sqlString += ' ORDER BY node_iot_attribute_healths.data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                                sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                    //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            } else {
                                sqlString = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                    'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                    'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                    'node_ecus.data->>\'name\' AS ecuName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                    'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                    'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                                sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' ";
                                sqlString += " AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'";
                                sqlString += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                sqlString += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                    'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                    'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                    'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " AND " : " WHERE ";
                                sqlString += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "' AND node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')";
                                    //"AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>\'timestamp\' AS BIGINT))) < TIMESTAMP '" + endDateString + "')";
                                sqlString += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                            }
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAlarms(perPageInput, true).then(function(response) {
                            vm.alarmsArr = parsePostgresData(response.data); // Parse Postgres data
                        });

                    } else {
                        var tempSQL = _.cloneDeepWith(vm.sqlQuery);
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and node_iot_attribute_healths.data->>'projectId' = '" + vm.project.id + "'";
                            } else {
                                tempSQL += " node_iot_attribute_healths.data->>'projectId' = '" + vm.project.id + "'";
                            }
                            tempSQL += " and date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) < TIMESTAMP '" + endDateString + "'";
                            tempSQL += " AND node_iot_attribute_healths.data->>'attributeId' = node_attributes.data->>'id'";
                        } else {
                            if (tempSQL && tempSQL.length) {
                                tempSQL += " and date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) < TIMESTAMP '" + endDateString + "'";
                                tempSQL += " AND node_iot_attribute_healths.data->>'attributeId' = node_attributes.data->>'id'";
                            } else {
                                tempSQL += " date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) > TIMESTAMP '" + previousDateString + "' " +
                                    "AND date_trunc('second', to_timestamp(CAST(node_iot_attribute_healths.data->>'timestamp' AS BIGINT))) < TIMESTAMP '" + endDateString + "'";
                                tempSQL += " AND node_iot_attribute_healths.data->>'attributeId' = node_attributes.data->>'id'";
                            }
                        }
                        var input = PaginationQueryService.getPaginationQuery(sqlString, tempSQL, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.alarmsArr, true, 'node_iot_attribute_healths');
                        var tempNewSQL = "";
                        if (input.sql.indexOf(';') !== -1) {
                            tempNewSQL = input.sql.substring(0, input.sql.length - 1);
                        } else {
                            tempNewSQL = input.sql;
                        }
                        var newSQL = "WITH attributes AS (" + tempNewSQL + "),";
                        newSQL += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                            'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                            'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                            'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                        newSQL += tempSQL && tempSQL.length ? " WHERE " + tempSQL.trim() + ")" : " )";
                        newSQL += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';
                        var newInput = {
                            sql: newSQL,
                            isNeedDataReverse: input.isNeedDataReverse
                        }
                        vm.previousPage = page;
                        vm.fnGetAlarms(newInput, false).then(function(response) {
                            vm.alarmsArr = parsePostgresData(response.data); // Parse Postgres data
                        });

                    }
                };

                vm.fnOpenAlarmInfoTab = function (alarmObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(alarmObj);
                };

                vm.fnGetAlarm = function (alarmObj, alarmsArr) {
                    angular.forEach(alarmsArr, function (alarm) {
                        alarm.isCheck = false;
                    });
                    alarmObj.isCheck = true;
                    vm.selectedAlarmsArr = [alarmObj]; // Assign array with single alarm object
                    vm.fnGetAlarmDetails(alarmObj);
                };

                vm.fnGetAlarmDetails = function (alarmObj) {
                    vm.isAlarmDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when alarm is selected
                        vm.selectedAlarmObj = alarmObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.alarmHistory', {
                                selectedId: vm.selectedAlarmObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedAlarmObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isAlarmDetailsLoaded = true;
                        } else {
                            $state.go('main.alarmHistory', {selectedId: vm.selectedAlarmObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedAlarmObj.id;
                            vm.isAlarmDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetAlarms = function (inputObj, isFirst) {
                    vm.isAlarmsLoading = true;
                    return QueryFactory.executeQuery(inputObj)
                        .then(function (res) {

                            vm.alarmResponse = _.cloneDeepWith(res);

                            if (vm.alarmResponse.data && vm.alarmResponse.data.length) {
                                // Apply parsePostgresData to the data
                                vm.alarmsArr = parsePostgresData(vm.alarmResponse.data);

                                if (isFirst) {
                                    // Maintain the original totalItems from the first response
                                    vm.totalItems = vm.alarmResponse.data[0].totalItems;
                                    vm.currentPage = 1;
                                }

                                // Reverse data if needed
                                if (inputObj.isNeedDataReverse) {
                                    vm.alarmsArr.reverse();
                                }
                            } else {
                                vm.alarmsArr = [];
                                vm.totalItems = 0;
                            }

                            if ($stateParams.selectedId) {
                                var labelData = _.find(vm.alarmsArr, {"id": $stateParams.selectedId});
                                if (labelData) {
                                    vm.fnCheckUncheckHeader(labelData)
                                } else {
                                    swal({
                                        title: "Please wait while your data loads...",
                                        type: "warning",
                                        showConfirmButton: true,
                                        showLoaderOnConfirm: true
                                    });
                                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                    angular.element(".confirm").css("visibility", "hidden");
                                    var attributeSQLQuery = 'WITH attributes AS ( SELECT node_iot_attribute_healths.*, ' +
                                        'node_attributes.data->>\'name\' AS name, node_iot_attribute_healths.data->>\'attributeId\' as id, node_attributes.data->>\'issueIds\' AS issueIds, ' +
                                        'node_iot_attribute_healths.data->>\'_id\' AS rt, ' +
                                        'node_ecus.data->>\'name\' AS ecuName, ' +
                                        'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'name\' ELSE node_nodes.data->>\'name\' END AS nodeName, ' +
                                        'CASE WHEN node_iot_attribute_healths.data->>\'ecuId\' = node_iot_attribute_healths.data->>\'nodeId\' THEN node_ecus.data->>\'id\' ELSE node_nodes.data->>\'rootNodeId\' END AS rootNodeId ' +
                                        'FROM node_iot_attribute_healths AS node_iot_attribute_healths ' +
                                        'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                        'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                        'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\'';
                                    attributeSQLQuery += " WHERE node_attributes.data->>\'id\' = '" + $stateParams.selectedId + "'";
                                    attributeSQLQuery += ' ORDER BY rt ASC LIMIT ' + vm.perPage + ' ),';
                                    attributeSQLQuery += ' rows AS ( SELECT COUNT(*) AS qty FROM node_iot_attribute_healths ' +
                                        'LEFT JOIN node_ecus ON node_iot_attribute_healths.data->>\'ecuId\' = node_ecus.data->>\'id\' ' +
                                        'LEFT JOIN node_nodes ON node_iot_attribute_healths.data->>\'nodeId\' = node_nodes.data->>\'id\' ' +
                                        'LEFT JOIN node_attributes ON node_iot_attribute_healths.data->>\'attributeId\' = node_attributes.data->>\'id\')';
                                    attributeSQLQuery += 'SELECT att.*, rows.qty AS totalItems FROM attributes AS att, rows';

                                    QueryFactory.executeQuery({sql: attributeSQLQuery})
                                        .then(function (response) {
                                            response.data = parsePostgresData(response.data);
                                            angular.element(".microSpinner").remove();
                                            angular.element(".confirm").css("visibility", "visible");
                                            swal.close();
                                            if (response && response.data && response.data.length && response.data[0]) {
                                                if (response.data[0].projectId) {
                                                    response.data[0].project = _.find(vm.projectsArr, {id: response.data[0].projectId});
                                                }
                                                vm.fnCheckUncheckHeader(response.data[0]);
                                            }
                                        }, function (error) {
                                            if (error && error.errorCode === -1) {
                                                amaran.error(error.errorMessage);
                                            }
                                        })
                                }
                            }
                            if ($state.current.name === 'main.alarmHistory') {
                                $state.go('main.alarmHistory', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isAlarmsLoading = false;
                            vm.isInitAlarm = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                            vm.alarmHistoryTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 5 * 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAlarmsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isInitAlarm = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnAddDefaultFilter = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('node', 'alarmHistory', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.alarmHistory", tempArr, {notify: false});
                    } else {
                        $state.go("main.alarmHistory", {sort: 'timestamp desc'}, {notify: false});
                        $stateParams.sort = 'timestamp desc';
                    }
                };

                vm.fnGetAlarmDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetAlarmStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'alarmStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowAlarmStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'alarmStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowAlarmStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAlarmCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.alarmsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.alarmsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Alarms");
                    XLSX.writeFile(wb, "Alarms.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('node', 'alarmHistory', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetHealthColor = function (alarmCode, alarmObj) {
                    var alarmStyle = ColorService.getHealthColorForLoop(alarmObj.projectId, alarmCode);
                    alarmObj.healthName = alarmStyle.content;
                    return alarmStyle;
                };

                vm.fnOpenCreateIssueTab = function (alarmObj) {
                    vm.isCreate = true;
                    DB.fnSet('createIssueAlarmObj', alarmObj);
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnOpenLinkIssueModal = function (attributeObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/alarms/modal/linkIssueModal/linkIssueModal.html',
                        size: 'lg',
                        controller: 'linkIssueModalCtrl as linkIssue',
                        windowClass: 'modal-height100',
                        resolve: {
                            attributeObj: function () {
                                return _.cloneDeepWith(attributeObj);
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                }

                vm.fnRequestNodeTunnel = function (alarmObj) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                        size: 'lg',
                        controller: 'nodeJobTerminalCtrl as jobTerminal',
                        windowClass: 'modal-height100',
                        resolve: {
                            nodeObj: function () {
                                return _.cloneDeepWith({id: alarmObj.rootNodeId});
                            },
                            isEcuTunnel: function () {
                                return false;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    }, function () {
                        $timeout(function () {
                            angular.element($window).triggerHandler('resize');
                        }, 1000);
                    });
                };

                vm.fnRequestECUTunnel = function (alarmObj) {
                    swal({
                        title: "Please wait while your data loads...",
                        type: "warning",
                        showConfirmButton: true,
                        showLoaderOnConfirm: true
                    });
                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                    angular.element(".confirm").css("visibility", "hidden");
                    NodeEcuFactory.describeECU({'ecuId': alarmObj.ecuId})
                        .then(function (res) { // Success block
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                            var modalInstance = $uibModal.open({
                                backdrop: 'static',
                                templateUrl: 'app/node/node/modals/jobTerminal/jobTerminal.html',
                                size: 'lg',
                                controller: 'nodeJobTerminalCtrl as jobTerminal',
                                windowClass: 'modal-height100',
                                resolve: {
                                    nodeObj: function () {
                                        return _.cloneDeepWith(res);
                                    },
                                    isEcuTunnel: function () {
                                        return true;
                                    }
                                }
                            });
                            modalInstance.result.then(function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            }, function () {
                                $timeout(function () {
                                    angular.element($window).triggerHandler('resize');
                                }, 1000);
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        })
                };

                vm.fnSetDefaultTime = function () {
                    var start = moment.unix(parseInt(vm.selectedRange.split(',')[0]));
                    var end = moment.unix(parseInt(vm.selectedRange.split(',')[1]));
                    /*vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');*/
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                    }
                    $timeout(function () {
                        //start = moment().subtract(3, 'hours');
                        //end = moment();
                        $('#rangedatetimesAttribute').daterangepicker({//eslint-disable-line
                            timePicker: true,
                            timePicker24Hour: true,
                            autoApply: true,
                            opens: 'left',
                            startDate: start,
                            endDate: end,
                            maxDate: moment(),
                            StartMinDate: moment().subtract(1, 'days'),
                            ranges: {
                                'Last 1 Hour': [moment().subtract(1, 'hours'), moment()],
                                'Last 3 Hour': [moment().subtract(3, 'hours'), moment()],
                                'Last 3 Days': [moment().subtract(3, 'days'), moment()],
                                'Last 1 Week': [moment().subtract(6, 'days'), moment()],
                                'Last 3 Weeks': [moment().subtract(20, 'days'), moment()],
                                'Today': [moment().startOf('day'), moment()],
                                'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('days')],
                                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                                'This Month': [moment().startOf('month'), moment().endOf('month')],
                                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                            },
                            locale: {
                                format: 'YYYY/MM/DD HH:mm'
                            }
                        }, function (start, end, label) {
                            $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                            if (label === 'Custom Range') {
                                vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                            } else {
                                if (label === "Last 1 Hour") {
                                    vm.selectedRange = moment().subtract(1, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Hour") {
                                    vm.selectedRange = moment().subtract(3, 'hours').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Days") {
                                    vm.selectedRange = moment().subtract(3, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 1 Week") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 3 Week") {
                                    vm.selectedRange = moment().subtract(20, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Today") {
                                    vm.selectedRange = moment().startOf('day').format('X') + "," + moment().format('X');
                                } else if (label === "Yesterday") {
                                    vm.selectedRange = moment().subtract(1, 'days').startOf('day').format('X') + "," + moment().subtract(1, 'days').endOf('days').format('X');
                                } else if (label === "Last 7 Days") {
                                    vm.selectedRange = moment().subtract(6, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "Last 30 Days") {
                                    vm.selectedRange = moment().subtract(29, 'days').format('X') + "," + moment().format('X');
                                } else if (label === "This Month") {
                                    vm.selectedRange = moment().startOf('month').format('X') + "," + moment().endOf('month').format('X');
                                } else {//"Last Month"
                                    vm.selectedRange = moment().subtract(1, 'month').startOf('month').format('X') + "," + moment().subtract(1, 'month').endOf('month').format('X');
                                }
                            }
                            if (angular.isDefined(angular.element("#selectedDate")[0])) {
                                document.getElementById('selectedDate').innerHTML = moment.unix(vm.selectedRange.split(',')[0]).format('YYYY/MM/DD HH:mm') + ' To ' + moment.unix(vm.selectedRange.split(',')[1]).format('YYYY/MM/DD HH:mm');
                            }
                            vm.isAlarmsLoading = true;
                            vm.fnSetSelectedProject();
                            $scope.$apply();
                        });
                        /*vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');*/
                        if (angular.isDefined(angular.element("#selectedDate")[0])) {
                            document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                        }
                    });
                }

                vm.fnInitAlarms = function () {
                    var start = moment().subtract(3, 'hours');
                    var end = moment();
                    vm.selectedRange = moment(start._d).format('X') + "," + moment(end._d).format('X');
                    if (angular.isDefined(angular.element("#selectedDate")[0])) {
                        document.getElementById('selectedDate').innerHTML = (start.format('YYYY/MM/DD HH:mm') + ' To ' + end.format('YYYY/MM/DD HH:mm'));
                    }
                    vm.fnSetDefaultTime();
                    vm.permissionObj = PermissionsService.getPermissionsV4('node');
                    vm.isShowTunnelOption = loginUser.id.startsWith('cu000000') && !DB.fnGet('support') && !DB.fnGet('federation');
                    vm.fnAddDefaultFilter();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('node', 'alarmHistory', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnOpenInsightCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightNodeAlarmHistoryChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Insight Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnUpdateTableData = _.debounce(function() {
                    QueryFactory.executeQuery({sql: vm.lastSQLQuery})
                        .then(function (res) { // Success block
                            vm.alarmsArr = parsePostgresData(res.data);
                            var tempSelectedAlarmsObj = {};

                            // Parse the data first
                            var parsedData = parsePostgresData(res.data || []);

                            vm.selectedAlarmsArr = _.filter(vm.selectedAlarmsArr, function (selectAlarmObj) {
                                var isFind = _.find(parsedData, {id: selectAlarmObj.id});
                                if (isFind) {
                                    tempSelectedAlarmsObj[selectAlarmObj.id] = _.cloneDeepWith(isFind);
                                    return true;
                                } else {
                                    return false;
                                }
                            });

                            _.forEach(parsedData, function (nodeObj, index) {
                                delete vm.alarmsArr[index];
                                vm.alarmsArr[index] = nodeObj;
                                if (vm.alarmsArr[index].timestamp) {
                                    vm.alarmsArr[index].healthUpdatedDate = vm.fnGetAbsoluteOrRelativeTime(vm.alarmsArr[index].timestamp);
                                }
                                if (angular.isDefined(tempSelectedAlarmsObj[nodeObj.id])) {
                                    vm.alarmsArr[index].isCheck = true;
                                }
                            });

                            vm.alarmHistoryTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 5 * 60000);
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.alarmHistoryTableAPITimeout = $timeout(function () {
                                vm.fnUpdateTableData();
                            }, 5 * 60000);
                        });
                });


                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on("attributeIssueAdded", function () {
                    vm.fnRemoveTab('Create Issue');
                });

                $scope.$on('createIssueAttributeIssue', function (eve, data) {
                    vm.fnOpenCreateIssueTab(data)
                })

                $scope.$on('openNodeTunnel', function (eve, data) {
                    if (data.ecuId === data.nodeId) {
                        vm.fnRequestECUTunnel(data);
                    } else {
                        vm.fnRequestNodeTunnel(data);
                    }
                })

                $scope.$on('$destroy', function () {
                    $timeout.cancel(vm.alarmHistoryTableAPITimeout);
                })

                vm.fnOpenData = function () {
                    $('#rangedatetimesAttribute').focus();//eslint-disable-line
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightWidgetsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      InsightWidgetFactory, ProjectFactory, amaran, swal, moment, microSpinner, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, postActionModelIcon, PermissionsService,
                      postActionModelMessage, AppInitService, PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.projectsArr = [];
                var tableName = 'insight_widgets';

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.widgetProjectFilter = "$";
                vm.widgetProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Widgets Variables
                vm.isWidgetsLoading = false;
                vm.widgetsArr = [];
                vm.selectedWidgetsArr = [];
                vm.selectedWidgetObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isUpdateWidget = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.widgetResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowWidgetStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditWidgetObj = {};

                vm.widgetContextMenu = function (widgetObj) {
                    if (Object.keys(vm.resetEditWidgetObj).length) {
                        var isFindWidget = _.find(vm.widgetsArr, {id: vm.resetEditWidgetObj.id});
                        if (isFindWidget) {
                            vm.fnCancelWidgetEditMode(isFindWidget);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_CHART) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                widgetObj.isEditable = true;
                                vm.resetEditWidgetObj = angular.copy(widgetObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelWidgetEditMode = function (widgetObj, isSuccessCall) {
                    if (isSuccessCall) {
                        widgetObj.name = angular.copy(widgetObj.name);
                        widgetObj.description = angular.copy(widgetObj.description);
                        widgetObj.isEditable = false;
                        vm.resetEditWidgetObj = {};
                    } else {
                        widgetObj.name = angular.copy(vm.resetEditWidgetObj.name);
                        widgetObj.description = angular.copy(vm.resetEditWidgetObj.description);
                        widgetObj.isEditable = false;
                        vm.resetEditWidgetObj = {};
                    }
                };

                vm.fnSaveWidgetInfo = function (widgetObj) {
                    widgetObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        widgetId: widgetObj.id
                    };
                    inputObj.body = {
                        name: widgetObj.name,
                        description: angular.isUndefined(widgetObj.description) ? '' : widgetObj.description
                    };
                    InsightWidgetFactory.updateWidget(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.widgetsArr, function (widgetObj) {
                                if (Object.keys(vm.selectedWidgetObj).length) {
                                    if (widgetObj.id === vm.selectedWidgetObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedWidgetObj[key] = val;
                                            widgetObj[key] = val;
                                        });
                                    }
                                }
                                if (widgetObj.id === resetCopy.id) {
                                    widgetObj.name = resetCopy.name;
                                    widgetObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelWidgetEditMode(widgetObj, true);
                            amaran.success("Widget Updated Successfully");
                        }, function (error) {
                            vm.fnCancelWidgetEditMode(widgetObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('insight', 'widget', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isWidgetsLoading = true;
                    vm.selectedWidgetsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'widget', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindWidgetParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindWidgetParamsProject) {
                            vm.project = isFindWidgetParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetWidgets({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.widgetsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedWidgetsArr = [];
                                vm.selectedWidgetObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Update Widget" && tab.id !== "Create Widget" && tab.id !== "widgetStats" && tab.id !== "WidgetEditor") {
                                if (vm.isWidgetsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedWidgetsArr = [];
                                    vm.selectedWidgetObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.insight_widgets', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Widget";
                        vm.isShowWidgetStats = tab.id === "widgetStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isUpdateWidget = tab.id === "Update Widget";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Widget";
                    vm.isShowWidgetStats = tab.id === "widgetStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isUpdateWidget = tab.id === "Update Widget";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Widget" || tab.id === "Create Issue" || tab.title === "Update Widget" || tab.id === "widgetStats" || tab.id === "WidgetEditor") {
                        $state.go('main.insight_widgets', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedWidgetsArr = [];
                        vm.selectedWidgetObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Widget" || id === "Update Widget") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.insight_widgets', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#widgetTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (widgetObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_CHART) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.widgetsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === widgetObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected widget array*/
                        var isValueFind = _.find(vm.selectedWidgetsArr, {'id': widgetObj.id});
                        if (!isValueFind) {
                            vm.selectedWidgetsArr.push(widgetObj);
                            var isTabExist = _.find(vm.tabs, {'id': widgetObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: widgetObj.id,
                                    title: widgetObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedWidgetsArr, function (obj) {
                                return widgetObj.id === obj.id;
                            });
                        }
                        if (vm.selectedWidgetsArr.length === 1) {
                            vm.fnGetWidgetDetails(vm.selectedWidgetsArr[0])
                        } else {
                            $state.go('main.insight_widgets', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.widgetsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedWidgetsArr = angular.copy(vm.widgetsArr);
                    } else {
                        vm.selectedWidgetsArr = [];
                    }
                    $state.go('main.insight_widgets', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedWidgetsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Widget'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Widget',
                                title: 'Create Widget',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.getWidgetCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.widgetsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.widgetsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Widgets");
                    XLSX.writeFile(wb, "widgets.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'widget', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.insight_widgets', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isWidgetsLoading = true;
                    vm.selectedWidgetsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_widgets';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_widgets';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetWidgets(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.widgetsArr);
                        vm.previousPage = page;
                        vm.fnGetWidgets(input, false);
                    }
                };

                vm.fnOpenWidgetInfoTab = function (widgetObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(widgetObj);
                };

                vm.fnGetWidget = function (widgetObj, widgetsArr) {
                    angular.forEach(widgetsArr, function (widget) {
                        widget.isCheck = false;
                    });
                    widgetObj.isCheck = true;
                    vm.selectedWidgetsArr = [widgetObj]; // Assign array with single Widget object
                    vm.fnGetWidgetDetails(widgetObj);
                };

                vm.fnGetWidgetDetails = function (widgetObj) {
                    vm.isWidgetDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when widget is selected
                        vm.selectedWidgetObj = widgetObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.insight_widgets', {
                                selectedId: vm.selectedWidgetObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedWidgetObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isWidgetDetailsLoaded = true;
                        } else {
                            $state.go('main.insight_widgets', {selectedId: vm.selectedWidgetObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedWidgetObj.id;
                            vm.isWidgetDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };
                //function to get widget color for the Widgets.
                vm.fnGetWidgetColor = function (widgetObj) {
                    if (angular.isDefined(widgetObj.color)) {
                        vm.widgetTextColor = vm.fnInvertColor(widgetObj.color);
                        return {
                            "background-color": widgetObj.color,
                            "color": "" + vm.widgetTextColor
                        }
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetWidgets = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.widgetResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.widgetResponse.data && vm.widgetResponse.data.length) {
                                    vm.totalItems = vm.widgetResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.widgetResponse.data.reverse();
                            }
                            vm.widgetsArr = _.cloneDeepWith(vm.widgetResponse.data);
                            if ($stateParams.selectedId) {
                                var widgetData = _.find(vm.widgetsArr, {"id": $stateParams.selectedId});
                                if (widgetData) {
                                    vm.fnCheckUncheckHeader(widgetData)
                                }
                            }
                            if ($state.current.name === 'main.insight_widgets') {
                                $state.go('main.insight_widgets', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isWidgetsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isWidgetsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectWidget = function (projectObj) {
                    vm.isWidgetsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM insight_widgets';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_widgets';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_widgets';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_widgets';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'widget', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'widget', 'selectedProject', '');
                    }
                    vm.fnGetWidgets({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("WidgetDeleted", function (evt, data) {
                    vm.selectedWidgetObj = null;
                    vm.selectedWidgetsArr = [];
                    vm.widgetsArr = vm.widgetsArr.filter(function (widgetObj) {
                        return (widgetObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.insight_widgets', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("WidgetDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.widgetsArr, function (widgetObj) {
                        if (widgetObj.id === vm.selectedWidgetObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedWidgetObj[key] = val;
                                widgetObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("widgetAdded", function () {
                    vm.fnRemoveTab('Create Widget');
                });

                $scope.$on('widgetWidgetDataUpdated', function () {
                    vm.fnRemoveTab('Update Widget');
                });

                vm.fnDeleteMultipleWidgets = function (selectedWidgetsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedWidgetsArr, function (selectedWidget, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/widgets/" + selectedWidget.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/widgets/" + selectedWidget.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Widgets?",
                            text: "You are about to permanently delete the selected widgets.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedWidgetsArr, function (selectedWidget) {
                                    angular.forEach(vm.widgetsArr, function (widgetObj, index) {
                                        if (selectedWidget.id === widgetObj.id) {
                                            vm.widgetsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedWidgetsArr.length;
                                vm.selectedWidgetObj = null;
                                vm.selectedWidgetsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedWidgetsArr, function (selectedWidget) {
                                    angular.forEach(vm.widgetsArr, function (widgetObj, index) {
                                        if (selectedWidget.id === widgetObj.id) {
                                            vm.widgetsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedWidgetsArr.length;
                                vm.selectedWidgetObj = null;
                                vm.selectedWidgetsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('insight', 'widget', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.insight_widgets", tempArr, {notify: false});
                    }
                };

                vm.fnInitWidgets = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4('insight');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'widget', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetWidgetDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetWidgetStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'widgetStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'widgetStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getWidgetCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.widgetsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.widgetsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Widgets");
                    XLSX.writeFile(wb, "widgets.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'widget', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportWidget = function (type, id) {
                    WidgetsListService.downloadWidgetData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightInsightWidgetChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCloneWidget = function (widgetObj) {
                    DB.fnSet('ClonedWidgetObj', widgetObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                $scope.$on("EditWidgetDetails", function (evt, data) {
                    var isTabExist = _.find(vm.tabs, {id: 'Update Widget'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.widgetId = data.id;
                            isTabExist.projectName = data.name;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Update Widget',
                            title: 'Update Widget',
                            tabIndex: newTabIndex,
                            widgetId: data.id,
                            projectName: data.name
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                });

                var widgetKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_widgets') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedWidgetsArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleWidgets(vm.selectedWidgetsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var widgetKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_widgets') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', widgetKeyDownEventHandler);
                document.addEventListener('keyup', widgetKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', widgetKeyDownEventHandler);
                    document.removeEventListener('keyup', widgetKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightQueryEditorCtrl',
            function ($scope, $timeout, $window, $uibModal, DB, amaran, QueryFactory, sqlFormatter, highed, Highcharts, jsonToCsvConvertService, UserProfileService) {
                var vm = this;
                vm.tabs = [
                    {
                        title: 'Editor',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.activeTabIndex = 1;
                vm.isCreate = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (mainFooter + 50);
                        angular.element("#queryEditorBody").css('height', finalHeight + 'px');
                    }

                    /*if (angular.isDefined(angular.element(".CodeMirror")[0])) {
                        var totalSQL = angular.element(".custom-sql-editor")[0].offsetHeight;
                        angular.element(".CodeMirror").css('height', (totalSQL - 15) + 'px');
                    }*/
                };

                vm.fnAddNewQueryEditor = function () {
                    var tempKey = "Editor ";
                    var keyNumber = 0;
                    _.forEach(vm.tabs, function (value) {
                        if (value.title.startsWith('Editor')) {
                            var number = parseInt(value.title.toString().split(' ')[1]);
                            if (number > keyNumber) {
                                keyNumber = number;
                            }
                        }
                    });
                    tempKey = tempKey + (keyNumber + 1);
                    var newTabIndex = vm.tabs.length + 1;
                    vm.tabs.push({
                        id: (new Date()).getTime(),
                        title: tempKey,
                        tabIndex: newTabIndex
                    });
                    $timeout(function () {
                        vm.activeTabIndex = newTabIndex;
                    });
                }

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.isCreate = tab.id === "Create Issue";
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        }, 1000);
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Issue";
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 1000);
                    vm.fnUpdateUserProfileData();
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    vm.fnUpdateUserProfileData();
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'queryEditor', 'tabs', _.cloneDeepWith(vm.tabs));
                };
                /*Tab: End*/

                $scope.$on("tabDetailsChanged", function () {
                    vm.fnUpdateUserProfileData();
                });

                $scope.$on("openCreateIssueTab", function (evt, data) {
                    localStorage.setItem('insightChartData', angular.toJson(data));
                    vm.isCreate = true;
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                });

                $scope.$on("issueAdded", function () {
                    vm.fnRemoveTab('Create Issue');
                });

                vm.fnInitQueryEditors = function () {
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'queryEditor', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                    if (DB.fnGet('telemetryChart')) {
                        var tempTabData = DB.fnGet('telemetryChart');
                        DB.fnRemove('telemetryChart');
                        var keyNumber = 0;
                        var tempKey = "Editor ";
                        _.forEach(vm.tabs, function (value) {
                            if (value.title.startsWith('Editor')) {
                                var number = parseInt(value.title.toString().split(' ')[1]);
                                if (number > keyNumber) {
                                    keyNumber = number;
                                }
                            }
                        });
                        _.forEach(tempTabData, function (tabObj) {
                            tempKey = "Editor ";
                            tempKey = tempKey + (keyNumber + 1);
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: (new Date()).getTime()+newTabIndex,
                                title: tempKey,
                                tabIndex: newTabIndex,
                                chart: tabObj.chart,
                                chartType: "HIGHCHARTS",
                                query: tabObj.query
                            });
                            keyNumber++;
                        });
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    }, 1000)
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightQueriesCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      WidgetsListService, UserProfileService, amaran, ColorService, swal,
                      microSpinner, DB, XLSX, Authenticate, IconService, PermissionsService, LastPageService,
                      TypesFactory, ProjectFactory, BatchFactory, PaginationService, moment, FedSudoUserService,
                      postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, AppInitService,
                      PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                var tableName = 'insight_queries';
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.projectsArr = [];

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowQueriesStats = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.queriesProjectFilter = "$";
                vm.queriesProjectSearch = {$: ''};


                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isQueriesLoading = false;
                vm.queriesArr = [];
                vm.selectedQueriesArr = [];
                vm.selectedQueriesObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.queriesResponse = [];

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#queriesTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.insight_queries', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetQueries(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.queriesArr);
                        vm.previousPage = page;
                        vm.fnGetQueries(input, false);
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('insight', 'queries', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isQueriesLoading = true;
                    vm.selectedQueriesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'queries', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindStateParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindStateParamsProject) {
                            vm.project = isFindStateParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.queriesArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedQueriesArr = [];
                                vm.selectedQueriesObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Query" && tab.id !== "PriorityStats" && tab.id !== "WidgetEditor") {
                                if (vm.isQueriesLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedQueriesArr = [];
                                    vm.selectedQueriesObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.insight_queries', {
                                selectedId: "",
                                selectedDetailsTab: ""
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Query";
                        vm.isShowUserStats = tab.id === "UserStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedPrioritiesArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Query'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Query',
                                title: 'Create Query',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Query";
                    vm.isShowUserStats = tab.id === "PriorityStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Query" || tab.id === "Create Issue" || tab.id === "PriorityStats" || tab.id === "WidgetEditor") {
                        $state.go('main.insight_queries', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedQueriesArr = [];
                        vm.selectedQueriesObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === 'Create Query') {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.insight_queries', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnGetQueriesDetails = function (queriesObj) {
                    vm.isQueriesDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when priority is selected
                        vm.selectedQueriesObj = queriesObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.insight_queries', {
                                selectedId: vm.selectedQueriesObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedQueriesObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isQueriesDetailsLoaded = true;
                        } else {
                            $state.go('main.insight_queries', {selectedId: vm.selectedQueriesObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedQueriesObj.id;
                            vm.isQueriesDetailsLoaded = true;
                        }
                    })
                };

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("QueriesDeleted", function (evt, data) {
                    vm.selectedQueriesObj = null;
                    vm.selectedQueriesArr = [];
                    vm.queriesArr = vm.queriesArr.filter(function (queriesObj) {
                        return (queriesObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.insight_queries', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("QueriesDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.queriesArr, function (queriesObj) {
                        if (queriesObj.id === vm.selectedQueriesObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedQueriesObj[key] = val;
                                queriesObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("queryAdded", function () {
                    vm.fnRemoveTab('Create Query');
                });

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.queriesArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedQueriesArr = _.cloneDeepWith(vm.queriesArr);
                    } else {
                        vm.selectedQueriesArr = [];
                    }
                    $state.go('main.insight_queries', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('insight', 'queries', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.insight_queries", tempArr, {notify: false});
                    }
                };

                vm.fnInitQueries = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4("insight");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'queries', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetQueries = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.queriesResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.queriesResponse.data && vm.queriesResponse.data.length) {
                                    vm.totalItems = vm.queriesResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.queriesResponse.data.reverse();
                            }
                            vm.queriesArr = _.cloneDeepWith(vm.queriesResponse.data);
                            if ($stateParams.selectedId) {
                                var queriesData = _.find(vm.queriesArr, {"id": $stateParams.selectedId});
                                if (queriesData) {
                                    vm.fnCheckUncheckHeader(queriesData);
                                }
                            }
                            if ($state.current.name === 'main.insight_queries') {
                                $timeout(function () {
                                    $state.go('main.insight_queries', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10)
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isQueriesLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isQueriesLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectQueries = function (projectObj) {
                    vm.isQueriesLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".projectId",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_queries';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_queries';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_queries';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'queries', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'queries', 'selectedProject', '');
                    }
                    vm.fnGetQueries({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };

                vm.fnOpenQueriesInfoTab = function (queriesObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(queriesObj);
                };

                vm.fnSaveQueriesInfo = function (queriesObj) {
                    queriesObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        queriesId: queriesObj.id
                    };
                    inputObj.body = {
                        name: queriesObj.name,
                        description: angular.isUndefined(queriesObj.description) ? '' : queriesObj.description
                    };
                    TypesFactory.updateIssueType(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.queriesArr, function (queriesObj) {
                                if (Object.keys(vm.selectedQueriesObj).length) {
                                    if (queriesObj.id === vm.selectedQueriesObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedQueriesObj[key] = val;
                                            queriesObj[key] = val;
                                        });
                                    }
                                }
                                if (queriesObj.id === resetCopy.id) {
                                    queriesObj.name = resetCopy.name;
                                    queriesObj.description = resetCopy.description;
                                }
                            });
                            if (!DB.fnGet('federation') && !DB.fnGet('support')) {
                                var queriesArr = AppInitService.getInitData('issueQueriesArr');
                                var index = _.findIndex(queriesArr, {id: response.id});
                                if (index !== -1) {
                                    queriesArr[index].name = response.name;
                                    queriesArr[index].description = response.description;
                                    AppInitService.fnUpdateIssueQueriesData(queriesArr);
                                }
                            }
                            vm.fnCancelQueriesEditMode(queriesObj, true);
                            amaran.success("Queries Updated Successfully");
                        }, function (error) {
                            vm.fnCancelQueriesEditMode(queriesObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };

                /*Start: Context Menu*/
                vm.resetEditQueriesObj = {};

                vm.queriesContextMenu = function (queriesObj) {
                    if (Object.keys(vm.resetEditQueriesObj).length) {
                        var isFindQueries = _.find(vm.queriesArr, {id: vm.resetEditQueriesObj.id});
                        if (isFindQueries) {
                            vm.fnCancelQueriesEditMode(isFindQueries);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_QUERY) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                queriesObj.isEditable = true;
                                vm.resetEditQueriesObj = angular.copy(queriesObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.fnExportChart = function (queries, id) {
                    WidgetsListService.downloadChartData(queries, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightInsightQueriesChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getQueriesCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.queriesArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.queriesArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Queries");
                    XLSX.writeFile(wb, "queries.xlsx");
                };
                /* Export Modal: End */

                vm.fnCheckUncheckHeader = function (queriesObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_QUERY) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.queriesArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === queriesObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedQueriesArr, {'id': queriesObj.id});
                        if (!isValueFind) {
                            vm.selectedQueriesArr.push(queriesObj);
                            var isTabExist = _.find(vm.tabs, {'id': queriesObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: queriesObj.id,
                                    title: queriesObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedQueriesArr, function (obj) {
                                return queriesObj.id === obj.id;
                            });
                        }
                        if (vm.selectedQueriesArr.length === 1) {
                            vm.fnGetQueriesDetails(vm.selectedQueriesArr[0])
                        } else {
                            $state.go('main.insight_queries', {
                                selectedId: '',
                                selectedDetailsTab: ''
                            }, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnCancelQueriesEditMode = function (queriesObj, isSuccessCall) {
                    if (isSuccessCall) {
                        queriesObj.name = angular.copy(queriesObj.name);
                        queriesObj.description = angular.copy(queriesObj.description);
                        queriesObj.isEditable = false;
                        vm.resetEditQueriesObj = {};
                    } else {
                        queriesObj.name = angular.copy(vm.resetEditQueriesObj.name);
                        queriesObj.description = angular.copy(vm.resetEditQueriesObj.description);
                        queriesObj.isEditable = false;
                        vm.resetEditQueriesObj = {};
                    }
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };

                //function to get priorities color for the Queries.
                vm.fnGetQueriesColor = function (queriesObj) {
                    if (angular.isDefined(queriesObj.color)) {
                        vm.queriesTextColor = vm.fnInvertColor(queriesObj.color);
                        return {
                            "background-color": queriesObj.color,
                            "color": "" + vm.queriesTextColor
                        }
                    }
                };


                vm.fnGetQueriesDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'queries', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetQueriesStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'QueriesStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowQueriesStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'QueriesStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowQueriesStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightProjectCtrl',
            function ($scope, $window, $timeout, $stateParams, d3, panzoom, $state, $uibModal,
                      AppInitService, amaran, swal, moment, microSpinner, PaginationQueryService, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, InsightProjectFactory, postActionModelIcon,
                      postActionModelMessage, QueryFactory, insightProjectArr, $base64, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Projects Variables
                vm.isProjectsLoading = false;
                vm.projectsArr = [];
                vm.selectedProjectsArr = [];
                vm.selectedProjectObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.projectResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowProjectStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isShowRelationships = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditProjectObj = {};

                vm.projectContextMenu = function (projectObj) {
                    if (Object.keys(vm.resetEditProjectObj).length) {
                        var isFindProject = _.find(vm.projectsArr, {id: vm.resetEditProjectObj.id});
                        if (isFindProject) {
                            vm.fnCancelProjectEditMode(isFindProject);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            projectObj.isEditable = true;
                            vm.resetEditProjectObj = angular.copy(projectObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelProjectEditMode = function (projectObj, isSuccessCall) {
                    if (isSuccessCall) {
                        projectObj.name = angular.copy(projectObj.name);
                        projectObj.description = angular.copy(projectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    } else {
                        projectObj.name = angular.copy(vm.resetEditProjectObj.name);
                        projectObj.description = angular.copy(vm.resetEditProjectObj.description);
                        projectObj.isEditable = false;
                        vm.resetEditProjectObj = {};
                    }
                };

                vm.fnSaveProjectInfo = function (projectObj) {
                    projectObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        projectId: projectObj.id
                    };
                    inputObj.body = {
                        name: projectObj.name,
                        description: angular.isUndefined(projectObj.description) ? '' : projectObj.description
                    };
                    InsightProjectFactory.updateProject(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.projectsArr, function (projectObj) {
                                if (Object.keys(vm.selectedProjectObj).length) {
                                    if (projectObj.id === vm.selectedProjectObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedProjectObj[key] = val;
                                            projectObj[key] = val;
                                        });
                                    }
                                }
                                if (projectObj.id === resetCopy.id) {
                                    projectObj.name = resetCopy.name;
                                    projectObj.description = resetCopy.description;
                                }
                            });
                            var projectArr = AppInitService.getInitData('insightProjectsArr');
                            var index = _.findIndex(projectArr, {id: response.id});
                            if (index !== -1) {
                                projectArr[index].name = response.name;
                                projectArr[index].description = response.description;
                                AppInitService.fnUpdateInsightProjectData(projectArr);
                            }
                            vm.fnCancelProjectEditMode(projectObj, true);
                            amaran.success("Project Updated Successfully");
                        }, function (error) {
                            vm.fnCancelProjectEditMode(projectObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('insight', 'project', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM insight_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_projects';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetProjects(input, true);
                };

                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.projectsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedProjectsArr = [];
                                vm.selectedProjectObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Create Project" && tab.id !== "projectStats" && tab.id !== "WidgetEditor" && tab.id !== "Relationships") {
                                if (vm.isProjectsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedProjectsArr = [];
                                    vm.selectedProjectObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.insight_project', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Project";
                        vm.isShowProjectStats = tab.id === "projectStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowRelationships = tab.id === "Relationships";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Project";
                    vm.isShowProjectStats = tab.id === "projectStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowRelationships = tab.id === "Relationships";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Project" || tab.id === "Create Issue" || tab.id === "projectStats" || tab.id === "WidgetEditor" || tab.id === "Relationships") {
                        $state.go('main.insight_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Project") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.insight_project', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#projectTable").css('height', finalHeight + 'px');
                    }
                    if (vm.isShowRelationships === true) {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    }
                };

                vm.fnCheckUncheckHeader = function (projectObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PROJECT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.projectsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === projectObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected project array*/
                        var isValueFind = _.find(vm.selectedProjectsArr, {'id': projectObj.id});
                        if (!isValueFind) {
                            vm.selectedProjectsArr.push(projectObj);
                            var isTabExist = _.find(vm.tabs, {'id': projectObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: projectObj.id,
                                    title: projectObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedProjectsArr, function (obj) {
                                return projectObj.id === obj.id;
                            });
                        }
                        if (vm.selectedProjectsArr.length === 1) {
                            vm.fnGetProjectDetails(vm.selectedProjectsArr[0])
                        } else {
                            $state.go('main.insight_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.projectsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedProjectsArr = angular.copy(vm.projectsArr);
                    } else {
                        vm.selectedProjectsArr = [];
                    }
                    $state.go('main.insight_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Project'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Project',
                                title: 'Create Project',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.insight_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isProjectsLoading = true;
                    vm.selectedProjectsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_projects';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM insight_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_projects';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetProjects(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.projectsArr);
                        vm.previousPage = page;
                        vm.fnGetProjects(input, false);
                    }
                };

                vm.fnOpenProjectInfoTab = function (projectObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(projectObj);
                };

                vm.fnGetProject = function (projectObj, projectsArr) {
                    angular.forEach(projectsArr, function (project) {
                        project.isCheck = false;
                    });
                    projectObj.isCheck = true;
                    vm.selectedProjectsArr = [projectObj]; // Assign array with single Project object
                    vm.fnGetProjectDetails(projectObj);
                };

                vm.fnGetProjectDetails = function (projectObj) {
                    vm.isProjectDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when project is selected
                        vm.selectedProjectObj = projectObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.insight_project', {
                                selectedId: vm.selectedProjectObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isProjectDetailsLoaded = true;
                        } else {
                            $state.go('main.insight_project', {selectedId: vm.selectedProjectObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedProjectObj.id;
                            vm.isProjectDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetProjects = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.projectResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.projectResponse.data && vm.projectResponse.data.length) {
                                    vm.totalItems = vm.projectResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.projectResponse.data.reverse();
                            }
                            vm.projectsArr = vm.projectResponse.data;
                            // Set projects again in localstorage if they are reloaded
                            if(vm.isRefresh && !DB.fnGet('federation') && !DB.fnGet('support')) {
                                localStorage.setItem(insightProjectArr, $base64.encode(angular.toJson(vm.projectsArr)));
                            }
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetProject(res[0], vm.projectsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var projectData = _.find(vm.projectsArr, {"id": $stateParams.selectedId});
                                if (projectData) {
                                    vm.fnCheckUncheckHeader(projectData)
                                }
                            }
                            if ($state.current.name === 'main.insight_project') {
                                $state.go('main.insight_project', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isProjectsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isProjectsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("ProjectDeleted", function (evt, data) {
                    vm.selectedProjectObj = null;
                    vm.selectedProjectsArr = [];
                    vm.projectsArr = vm.projectsArr.filter(function (projectObj) {
                        return (projectObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.insight_project', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("ProjectDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.projectsArr, function (projectObj) {
                        if (projectObj.id === vm.selectedProjectObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedProjectObj[key] = val;
                                projectObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("projectAdded", function () {
                    vm.fnRemoveTab('Create Project');
                });

                vm.fnDeleteMultipleProjects = function (selectedProjectsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedProjectsArr, function (selectedProject, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/projects/" + selectedProject.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Projects?",
                            text: "You are about to permanently delete the selected projects.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedProjectsArr, function (selectedProject) {
                                    angular.forEach(vm.projectsArr, function (projectObj, index) {
                                        if (selectedProject.id === projectObj.id) {
                                            vm.projectsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedProjectsArr.length;
                                vm.selectedProjectObj = null;
                                vm.selectedProjectsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('insight', 'project', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.insight_project", tempArr, {notify: false});
                    }
                };

                vm.fnInitProjects = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('insight');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'project', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetProjectDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'projectStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowProjectStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'projectStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowProjectStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetProjectRelationships = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Relationships'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowRelationships = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Relationships',
                            title: 'Relationships',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowRelationships = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.newProjectData = {};
                vm.isProjectRelationshipsDataLoading = true;
                vm.fnInitProjectRelationships = function () {
                    vm.isProjectRelationshipsDataLoading = true;
                    $timeout(function () {
                        if (angular.isDefined(angular.element(".content-box-content")[0])) {
                            var h = angular.element(".content-box-content")[0].offsetHeight;
                            var w = angular.element(".content-box-content")[0].offsetWidth;
                            angular.element("#projectParentDiv").css('height', (h - 4) + 'px');
                            angular.element("#projectParentDiv").css('width', w + 'px');
                        }
                    });
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                        var projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                        var flat = {};
                        _.forEach(projectsArr, function (projectObj) {
                            flat[projectObj.id] = projectObj;
                            flat[projectObj.id].children = [];
                        });
                        _.forEach(flat, function (flatObj) {
                            if (flat[flatObj.parentProjectId]) {
                                flat[flatObj.parentProjectId].children.push(flatObj);
                            }
                        });
                        vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                            return angular.isUndefined(flatObj.parentProjectId);
                        });
                        vm.isProjectRelationshipsDataLoading = false;
                        vm.fnCreateProjectRelationships();
                    } else {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProjectRelationshipsData({sql: projectSQL}, [], false);
                    }
                };

                vm.fnGetProjectRelationshipsData = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjectRelationshipsData({sql: sqlString}, projects, true);
                            } else {
                                var flat = {};
                                _.forEach(projects, function (projectObj) {
                                    flat[projectObj.id] = projectObj;
                                    flat[projectObj.id].children = [];
                                });
                                _.forEach(flat, function (flatObj) {
                                    if (flat[flatObj.parentProjectId]) {
                                        flat[flatObj.parentProjectId].children.push(flatObj);
                                    }
                                });
                                vm.newProjectData = _.find(Object.values(flat), function (flatObj) {
                                    return angular.isUndefined(flatObj.parentProjectId);
                                });
                                vm.isProjectRelationshipsDataLoading = false;
                                vm.fnCreateProjectRelationships();
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnCreateProjectRelationships = function () {
                    $timeout(function () {
                        var translate = {scale: 1, translate: [0, 0]};
                        var ele = d3.select('#projectParentDesign');
                        var n = ele.node();
                        n.height = n.scrollHeight - 10;
                        n.width = n.scrollWidth - 10;
                        n.x = 0;
                        n.y = 0;
                        var height = n.parentNode.clientHeight,
                            width = n.parentNode.clientWidth;
                        translate.scale = Math.min(height / n.height, width / n.width);
                        translate.translate = [(((-n.x * translate.scale) + width / 2) - (n.width / 2 * translate.scale)), (((-n.y * translate.scale) + height / 2) - (n.height / 2 * translate.scale))];
                        var instance = panzoom(document.getElementById('projectParentDesign'), {
                            zoomSpeed: 0.065, maxZoom: 1.5,
                            minZoom: translate.scale / 3
                        });
                        instance.zoomTo(0, 0, translate.scale);
                        instance.moveTo(translate.translate[0], translate.translate[1]);
                    }, 500)
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getProjectCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.projectsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.projectsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Projects");
                    XLSX.writeFile(wb, "projects.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'project', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightInsightProjectChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                var projectKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedProjectsArr.length > 1 &&
                                vm.permissionObj.DELETE_PROJECT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleProjects(vm.selectedProjectsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var projectKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_project') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', projectKeyDownEventHandler);
                document.addEventListener('keyup', projectKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', projectKeyDownEventHandler);
                    document.removeEventListener('keyup', projectKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightDashboardsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      InsightDashboardFactory, ProjectFactory, amaran, swal, moment, microSpinner, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, postActionModelIcon, PermissionsService,
                      postActionModelMessage, AppInitService, PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.projectsArr = [];
                var tableName = 'insight_dashboards';

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.dashboardProjectFilter = "$";
                vm.dashboardProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Dashboards Variables
                vm.isDashboardsLoading = false;
                vm.dashboardsArr = [];
                vm.selectedDashboardsArr = [];
                vm.selectedDashboardObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isUpdateDashboard = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.dashboardResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowDashboardStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                /*Start: Context Menu*/
                vm.resetEditDashboardObj = {};

                vm.dashboardContextMenu = function (dashboardObj) {
                    if (Object.keys(vm.resetEditDashboardObj).length) {
                        var isFindDashboard = _.find(vm.dashboardsArr, {id: vm.resetEditDashboardObj.id});
                        if (isFindDashboard) {
                            vm.fnCancelDashboardEditMode(isFindDashboard);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_DASHBOARD) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                dashboardObj.isEditable = true;
                                vm.resetEditDashboardObj = angular.copy(dashboardObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelDashboardEditMode = function (dashboardObj, isSuccessCall) {
                    if (isSuccessCall) {
                        dashboardObj.name = angular.copy(dashboardObj.name);
                        dashboardObj.description = angular.copy(dashboardObj.description);
                        dashboardObj.isEditable = false;
                        vm.resetEditDashboardObj = {};
                    } else {
                        dashboardObj.name = angular.copy(vm.resetEditDashboardObj.name);
                        dashboardObj.description = angular.copy(vm.resetEditDashboardObj.description);
                        dashboardObj.isEditable = false;
                        vm.resetEditDashboardObj = {};
                    }
                };

                vm.fnSaveDashboardInfo = function (dashboardObj) {
                    dashboardObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        dashboardId: dashboardObj.id
                    };
                    inputObj.body = {
                        name: dashboardObj.name,
                        description: angular.isUndefined(dashboardObj.description) ? '' : dashboardObj.description
                    };
                    InsightDashboardFactory.updateDashboard(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.dashboardsArr, function (dashboardObj) {
                                if (Object.keys(vm.selectedDashboardObj).length) {
                                    if (dashboardObj.id === vm.selectedDashboardObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedDashboardObj[key] = val;
                                            dashboardObj[key] = val;
                                        });
                                    }
                                }
                                if (dashboardObj.id === resetCopy.id) {
                                    dashboardObj.name = resetCopy.name;
                                    dashboardObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelDashboardEditMode(dashboardObj, true);
                            amaran.success("Dashboard Updated Successfully");
                        }, function (error) {
                            vm.fnCancelDashboardEditMode(dashboardObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('insight', 'dashboard', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isDashboardsLoading = true;
                    vm.selectedDashboardsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'dashboard', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindDashboardParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindDashboardParamsProject) {
                            vm.project = isFindDashboardParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetDashboards({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.dashboardsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedDashboardsArr = [];
                                vm.selectedDashboardObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Update Dashboard" && tab.id !== "Create Dashboard" && tab.id !== "dashboardStats" && tab.id !== "WidgetEditor") {
                                if (vm.isDashboardsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedDashboardsArr = [];
                                    vm.selectedDashboardObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.insight_dashboards', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Dashboard";
                        vm.isShowDashboardStats = tab.id === "dashboardStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isUpdateDashboard = tab.id === "Update Dashboard";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Dashboard";
                    vm.isShowDashboardStats = tab.id === "dashboardStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isUpdateDashboard = tab.id === "Update Dashboard";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Dashboard" || tab.id === "Create Issue" || tab.title === "Update Dashboard" || tab.id === "dashboardStats" || tab.id === "WidgetEditor") {
                        $state.go('main.insight_dashboards', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedDashboardsArr = [];
                        vm.selectedDashboardObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Dashboard" || id === "Update Dashboard") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.insight_dashboards', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#dashboardTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (dashboardObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_DASHBOARD) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.dashboardsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === dashboardObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected dashboard array*/
                        var isValueFind = _.find(vm.selectedDashboardsArr, {'id': dashboardObj.id});
                        if (!isValueFind) {
                            vm.selectedDashboardsArr.push(dashboardObj);
                            var isTabExist = _.find(vm.tabs, {'id': dashboardObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: dashboardObj.id,
                                    title: dashboardObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedDashboardsArr, function (obj) {
                                return dashboardObj.id === obj.id;
                            });
                        }
                        if (vm.selectedDashboardsArr.length === 1) {
                            vm.fnGetDashboardDetails(vm.selectedDashboardsArr[0])
                        } else {
                            $state.go('main.insight_dashboards', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.dashboardsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDashboardsArr = angular.copy(vm.dashboardsArr);
                    } else {
                        vm.selectedDashboardsArr = [];
                    }
                    $state.go('main.insight_dashboards', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedDashboardsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Dashboard'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Dashboard',
                                title: 'Create Dashboard',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.getDashboardCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.dashboardsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.dashboardsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Dashboards");
                    XLSX.writeFile(wb, "dashboards.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'dashboard', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.insight_dashboards', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isDashboardsLoading = true;
                    vm.selectedDashboardsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetDashboards(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.dashboardsArr);
                        vm.previousPage = page;
                        vm.fnGetDashboards(input, false);
                    }
                };

                vm.fnOpenDashboardInfoTab = function (dashboardObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(dashboardObj);
                };

                vm.fnGetDashboard = function (dashboardObj, dashboardsArr) {
                    angular.forEach(dashboardsArr, function (dashboard) {
                        dashboard.isCheck = false;
                    });
                    dashboardObj.isCheck = true;
                    vm.selectedDashboardsArr = [dashboardObj]; // Assign array with single Dashboard object
                    vm.fnGetDashboardDetails(dashboardObj);
                };

                vm.fnGetDashboardDetails = function (dashboardObj) {
                    vm.isDashboardDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when dashboard is selected
                        vm.selectedDashboardObj = dashboardObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.insight_dashboards', {
                                selectedId: vm.selectedDashboardObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedDashboardObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isDashboardDetailsLoaded = true;
                        } else {
                            $state.go('main.insight_dashboards', {selectedId: vm.selectedDashboardObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedDashboardObj.id;
                            vm.isDashboardDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };
                //function to get dashboard color for the Dashboards.
                vm.fnGetDashboardColor = function (dashboardObj) {
                    if (angular.isDefined(dashboardObj.color)) {
                        vm.dashboardTextColor = vm.fnInvertColor(dashboardObj.color);
                        return {
                            "background-color": dashboardObj.color,
                            "color": "" + vm.dashboardTextColor
                        }
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetDashboards = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.dashboardResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.dashboardResponse.data && vm.dashboardResponse.data.length) {
                                    vm.totalItems = vm.dashboardResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.dashboardResponse.data.reverse();
                            }
                            vm.dashboardsArr = _.cloneDeepWith(vm.dashboardResponse.data);
                            if ($stateParams.selectedId) {
                                var dashboardData = _.find(vm.dashboardsArr, {"id": $stateParams.selectedId});
                                if (dashboardData) {
                                    vm.fnCheckUncheckHeader(dashboardData)
                                }
                            }
                            if ($state.current.name === 'main.insight_dashboards') {
                                $state.go('main.insight_dashboards', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isDashboardsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDashboardsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectDashboard = function (projectObj) {
                    vm.isDashboardsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_dashboards';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_dashboards';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_dashboards';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_dashboards';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'dashboard', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'dashboard', 'selectedProject', '');
                    }
                    vm.fnGetDashboards({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("DashboardDeleted", function (evt, data) {
                    vm.selectedDashboardObj = null;
                    vm.selectedDashboardsArr = [];
                    vm.dashboardsArr = vm.dashboardsArr.filter(function (dashboardObj) {
                        return (dashboardObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.insight_dashboards', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("DashboardDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.dashboardsArr, function (dashboardObj) {
                        if (dashboardObj.id === vm.selectedDashboardObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDashboardObj[key] = val;
                                dashboardObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("dashboardAdded", function () {
                    vm.fnRemoveTab('Create Dashboard');
                });

                $scope.$on('dashboardDashboardDataUpdated', function () {
                    vm.fnRemoveTab('Update Dashboard');
                });

                vm.fnDeleteMultipleDashboards = function (selectedDashboardsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedDashboardsArr, function (selectedDashboard, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/dashboards/" + selectedDashboard.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/dashboards/" + selectedDashboard.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Dashboards?",
                            text: "You are about to permanently delete the selected dashboards.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDashboardsArr, function (selectedDashboard) {
                                    angular.forEach(vm.dashboardsArr, function (dashboardObj, index) {
                                        if (selectedDashboard.id === dashboardObj.id) {
                                            vm.dashboardsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDashboardsArr.length;
                                vm.selectedDashboardObj = null;
                                vm.selectedDashboardsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDashboardsArr, function (selectedDashboard) {
                                    angular.forEach(vm.dashboardsArr, function (dashboardObj, index) {
                                        if (selectedDashboard.id === dashboardObj.id) {
                                            vm.dashboardsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDashboardsArr.length;
                                vm.selectedDashboardObj = null;
                                vm.selectedDashboardsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('insight', 'dashboard', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.insight_dashboards", tempArr, {notify: false});
                    }
                };

                vm.fnInitDashboards = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4('insight');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'dashboard', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetDashboardDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetDashboardStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'dashboardStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboardStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'dashboardStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboardStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getDashboardCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.dashboardsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.dashboardsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Dashboards");
                    XLSX.writeFile(wb, "dashboards.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'dashboard', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightInsightDashboardChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                $scope.$on("EditDashboardDetails", function (evt, data) {
                    var isTabExist = _.find(vm.tabs, {id: 'Update Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.dashboardId = data.id;
                            isTabExist.projectName = data.name;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Update Dashboard',
                            title: 'Update Dashboard',
                            tabIndex: newTabIndex,
                            dashboardId: data.id,
                            projectName: data.name
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                });

                var dashboardKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_dashboards') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedDashboardsArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleDashboards(vm.selectedDashboardsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var dashboardKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_dashboards') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', dashboardKeyDownEventHandler);
                document.addEventListener('keyup', dashboardKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', dashboardKeyDownEventHandler);
                    document.removeEventListener('keyup', dashboardKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InsightChartsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, d3, panzoom, $uibModal,
                      InsightChartFactory, ProjectFactory, amaran, swal, moment, microSpinner, WidgetsListService,
                      UserProfileService, DB, XLSX, Authenticate, LastPageService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, postActionModelIcon, PermissionsService,
                      postActionModelMessage, AppInitService, PaginationQueryService, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.projectsArr = [];
                var tableName = 'insight_charts';

                //Search Variables
                vm.project = {};
                vm.isProjectLoaded = false;
                vm.isRefreshData = true;
                vm.isInitIssue = true;
                vm.isProjectsLoading = true;
                vm.chartProjectFilter = "$";
                vm.chartProjectSearch = {$: ''};

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Charts Variables
                vm.isChartsLoading = false;
                vm.chartsArr = [];
                vm.selectedChartsArr = [];
                vm.selectedChartObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isUpdateChart = false;
                vm.isDropUp = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.chartResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowChartStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet("loginUser");

                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditChartObj = {};

                vm.chartContextMenu = function (chartObj) {
                    if (Object.keys(vm.resetEditChartObj).length) {
                        var isFindChart = _.find(vm.chartsArr, {id: vm.resetEditChartObj.id});
                        if (isFindChart) {
                            vm.fnCancelChartEditMode(isFindChart);
                        }
                    }
                    var tempArr = [];
                    if (vm.permissionObj.UPDATE_CHART) {
                        tempArr.push({
                            text: 'Edit',
                            click: function () { //$itemScope, $event, modelValue, text, $li
                                chartObj.isEditable = true;
                                vm.resetEditChartObj = angular.copy(chartObj);
                            }
                        })
                    }
                    return tempArr;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelChartEditMode = function (chartObj, isSuccessCall) {
                    if (isSuccessCall) {
                        chartObj.name = angular.copy(chartObj.name);
                        chartObj.description = angular.copy(chartObj.description);
                        chartObj.isEditable = false;
                        vm.resetEditChartObj = {};
                    } else {
                        chartObj.name = angular.copy(vm.resetEditChartObj.name);
                        chartObj.description = angular.copy(vm.resetEditChartObj.description);
                        chartObj.isEditable = false;
                        vm.resetEditChartObj = {};
                    }
                };

                vm.fnSaveChartInfo = function (chartObj) {
                    chartObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        chartId: chartObj.id
                    };
                    inputObj.body = {
                        name: chartObj.name,
                        description: angular.isUndefined(chartObj.description) ? '' : chartObj.description
                    };
                    InsightChartFactory.updateChart(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.chartsArr, function (chartObj) {
                                if (Object.keys(vm.selectedChartObj).length) {
                                    if (chartObj.id === vm.selectedChartObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedChartObj[key] = val;
                                            chartObj[key] = val;
                                        });
                                    }
                                }
                                if (chartObj.id === resetCopy.id) {
                                    chartObj.name = resetCopy.name;
                                    chartObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelChartEditMode(chartObj, true);
                            amaran.success("Chart Updated Successfully");
                        }, function (error) {
                            vm.fnCancelChartEditMode(chartObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('insight', 'chart', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInitIssue === false) {
                        vm.fnSetSelectedProject();
                    } else {
                        if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('insightProjectsArr').length !== 0) {
                            vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('insightProjectsArr'));
                            vm.projectsArr.unshift({name: "All", id: "All"});
                            vm.fnSetSelectedProject();
                        } else {
                            var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                            vm.fnGetProject({sql: projectSQL}, [], false);
                        }
                    }
                };

                vm.fnSetSelectedProject = function () {
                    var tempSelectedProject = UserProfileService.fnGetUserProfileObj('insight', 'chart', 'selectedProject');
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    if (tempSelectedProject !== '') {
                        var isFindProject = _.find(vm.projectsArr, {id: tempSelectedProject.id});
                        if (isFindProject) {
                            vm.project = isFindProject;
                        } else {
                            vm.project = {};
                        }
                    } else if ($stateParams.selectedProject) {
                        var isFindChartParamsProject = _.find(vm.projectsArr, {id: $stateParams.selectedProject});
                        if (isFindChartParamsProject) {
                            vm.project = isFindChartParamsProject;
                        } else {
                            vm.project = {};
                        }
                    } else {
                        vm.project = {name: "All", id: "All"};
                    }

                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sqlString = '';
                    if (vm.project && Object.keys(vm.project).length && vm.project.id !== 'All') {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and projectId = '" + vm.project.id + "'" : " WHERE projectId = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    } else {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.chartsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedChartsArr = [];
                                vm.selectedChartObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                            if (tab.id !== "Dashboard" && tab.id !== "Update Chart" && tab.id !== "Create Chart" && tab.id !== "chartStats" && tab.id !== "WidgetEditor") {
                                if (vm.isChartsLoading || angular.isUndefined(isFindUser)) {
                                    vm.activeTabIndex = tab.tabIndex;
                                    vm.selectedChartsArr = [];
                                    vm.selectedChartObj = {};
                                    vm.fnCheckUncheckHeader({id: tab.id, name: tab.title});
                                }
                            } else {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.insight_charts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Chart";
                        vm.isShowChartStats = tab.id === "chartStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isUpdateChart = tab.id === "Update Chart";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Chart";
                    vm.isShowChartStats = tab.id === "chartStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isUpdateChart = tab.id === "Update Chart";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Chart" || tab.id === "Create Issue" || tab.title === "Update Chart" || tab.id === "chartStats" || tab.id === "WidgetEditor") {
                        $state.go('main.insight_charts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                        vm.selectedChartsArr = [];
                        vm.selectedChartObj = {};
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Chart" || id === "Update Chart") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.insight_charts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#chartTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (chartObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_CHART) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.chartsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === chartObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected chart array*/
                        var isValueFind = _.find(vm.selectedChartsArr, {'id': chartObj.id});
                        if (!isValueFind) {
                            vm.selectedChartsArr.push(chartObj);
                            var isTabExist = _.find(vm.tabs, {'id': chartObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: chartObj.id,
                                    title: chartObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedChartsArr, function (obj) {
                                return chartObj.id === obj.id;
                            });
                        }
                        if (vm.selectedChartsArr.length === 1) {
                            vm.fnGetChartDetails(vm.selectedChartsArr[0])
                        } else {
                            $state.go('main.insight_charts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.chartsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedChartsArr = angular.copy(vm.chartsArr);
                    } else {
                        vm.selectedChartsArr = [];
                    }
                    $state.go('main.insight_charts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Chart'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Chart',
                                title: 'Create Chart',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.getChartCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.chartsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.chartsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Charts");
                    XLSX.writeFile(wb, "charts.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'chart', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.insight_charts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isChartsLoading = true;
                    vm.selectedChartsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (isPerPageChanged) {
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetCharts(perPageInput, true);
                    } else {
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.chartsArr);
                        vm.previousPage = page;
                        vm.fnGetCharts(input, false);
                    }
                };

                vm.fnOpenChartInfoTab = function (chartObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(chartObj);
                };

                vm.fnGetChart = function (chartObj, chartsArr) {
                    angular.forEach(chartsArr, function (chart) {
                        chart.isCheck = false;
                    });
                    chartObj.isCheck = true;
                    vm.selectedChartsArr = [chartObj]; // Assign array with single Chart object
                    vm.fnGetChartDetails(chartObj);
                };

                vm.fnGetChartDetails = function (chartObj) {
                    vm.isChartDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when chart is selected
                        vm.selectedChartObj = chartObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.insight_charts', {
                                selectedId: vm.selectedChartObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedChartObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isChartDetailsLoaded = true;
                        } else {
                            $state.go('main.insight_charts', {selectedId: vm.selectedChartObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedChartObj.id;
                            vm.isChartDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnInvertColor = function (hex) {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);
                    // http://stackoverflow.com/a/3943023/112731
                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                };
                //function to get chart color for the Charts.
                vm.fnGetChartColor = function (chartObj) {
                    if (angular.isDefined(chartObj.color)) {
                        vm.chartTextColor = vm.fnInvertColor(chartObj.color);
                        return {
                            "background-color": chartObj.color,
                            "color": "" + vm.chartTextColor
                        }
                    }
                };

                vm.fnGetProjects = function (inputObj, preDefinedProjects, isCalledForViz) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProjects({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                $timeout(function () {
                                    vm.searchFiltersArr.push(
                                        {
                                            displayName: "Project",
                                            name: "projectId",
                                            regexp: "",
                                            errorMessage: "",
                                            isPredefinedValue: true,
                                            predefinedValues: vm.projectsArr,
                                            displayKeyName: 'name',
                                            isShowId: true,
                                            isShowSearchBar: true,
                                            filterApplyKeyName: 'id'
                                        }
                                    );
                                    vm.isProjectsLoading = false;
                                });
                            }
                        }, function () { // Error block
                        })
                };

                vm.fnGetCharts = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                                if (obj.projectId) {
                                    obj.project = _.find(vm.projectsArr, {id: obj.projectId});
                                }
                            });
                            vm.chartResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.chartResponse.data && vm.chartResponse.data.length) {
                                    vm.totalItems = vm.chartResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.chartResponse.data.reverse();
                            }
                            vm.chartsArr = _.cloneDeepWith(vm.chartResponse.data);
                            if ($stateParams.selectedId) {
                                var chartData = _.find(vm.chartsArr, {"id": $stateParams.selectedId});
                                if (chartData) {
                                    vm.fnCheckUncheckHeader(chartData)
                                }
                            }
                            if ($state.current.name === 'main.insight_charts') {
                                $state.go('main.insight_charts', {
                                    openCreateView: '',
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                delete $stateParams.openCreateView;
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isRefresh = false;
                            vm.isInitIssue = false;
                            vm.isChartsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isChartsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];
                            _.forEach(res.data, function (projectObj) {
                                projects.push(projectObj);
                            });
                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.projectsArr.unshift({name: "All", id: "All"});
                                vm.fnSetSelectedProject();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnGetProjectChart = function (projectObj) {
                    vm.isChartsLoading = true;
                    vm.isProjectLoaded = false;
                    vm.project = projectObj;
                    if (vm.project && vm.project.id === "All") {
                        var tempIndex = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndex === -1) {
                            vm.searchFiltersArr.push(
                                {
                                    displayName: "Project",
                                    name: tableName + ".data->>\'projectId\'",
                                    localSearch: {
                                        type: 'objects',
                                        name: 'project',
                                        key: 'id'
                                    },
                                    regexp: "",
                                    errorMessage: "",
                                    isPredefinedValue: true,
                                    predefinedValues: vm.projectsArr,
                                    displayKeyName: 'name',
                                    isShowId: true,
                                    isShowUserAvatar: false,
                                    isShowSearchBar: true,
                                    filterApplyKeyName: 'id'
                                }
                            );
                            //vm.fnOrderFiltersArr();
                        }
                    } else {
                        var tempIndexForAll = _.findIndex(vm.searchFiltersArr, function (searchObj) {
                            return searchObj.displayName === "Project";
                        });
                        if (tempIndexForAll !== -1) {
                            vm.searchFiltersArr.splice(tempIndexForAll, 1);
                            //vm.fnOrderFiltersArr();
                        }
                    }
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM insight_charts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_charts';
                    }
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM insight_charts';
                        if (vm.project && vm.project.id && vm.project.id !== 'All') {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? " WHERE " + vm.sqlQuery.trim() + " and data->>\'projectId\' = '" + vm.project.id + "'" : " WHERE data->>\'projectId\' = '" + vm.project.id + "'";
                        } else {
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        }
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    if (projectObj.id !== "All") {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'chart', 'selectedProject', _.cloneDeepWith(angular.fromJson(angular.toJson(projectObj))));
                    } else {
                        UserProfileService.fnUpdateUserProfileObj('insight', 'chart', 'selectedProject', '');
                    }
                    vm.fnGetCharts({sql: sqlString}, true);
                    vm.isProjectLoaded = true;
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isInitIssue = true;
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("ChartDeleted", function (evt, data) {
                    vm.selectedChartObj = null;
                    vm.selectedChartsArr = [];
                    vm.chartsArr = vm.chartsArr.filter(function (chartObj) {
                        return (chartObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.insight_charts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("ChartDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.chartsArr, function (chartObj) {
                        if (chartObj.id === vm.selectedChartObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedChartObj[key] = val;
                                chartObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("chartAdded", function () {
                    vm.fnRemoveTab('Create Chart');
                });

                $scope.$on('chartChartDataUpdated', function () {
                    vm.fnRemoveTab('Update Chart');
                });

                vm.fnDeleteMultipleCharts = function (selectedChartsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedChartsArr, function (selectedChart, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/charts/" + selectedChart.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/insight/charts/" + selectedChart.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Charts?",
                            text: "You are about to permanently delete the selected charts.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'insight'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedChartsArr, function (selectedChart) {
                                    angular.forEach(vm.chartsArr, function (chartObj, index) {
                                        if (selectedChart.id === chartObj.id) {
                                            vm.chartsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedChartsArr.length;
                                vm.selectedChartObj = null;
                                vm.selectedChartsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedChartsArr, function (selectedChart) {
                                    angular.forEach(vm.chartsArr, function (chartObj, index) {
                                        if (selectedChart.id === chartObj.id) {
                                            vm.chartsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedChartsArr.length;
                                vm.selectedChartObj = null;
                                vm.selectedChartsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('insight', 'chart', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.insight_charts", tempArr, {notify: false});
                    }
                };

                vm.fnInitCharts = function () {
                    //vm.isProjectsLoading = true;
                    vm.permissionObj = PermissionsService.getPermissionsV4('insight');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('insight', 'chart', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetChartDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetChartStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'chartStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowChartStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'chartStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowChartStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getChartCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.chartsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.chartsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Charts");
                    XLSX.writeFile(wb, "charts.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('insight', 'chart', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightInsightChartChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCloneChart = function (chartObj) {
                    DB.fnSet('ClonedChartObj', chartObj);
                    $timeout(function () {
                        vm.fnHideShowCreateForm(true);
                    });
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on('updateChartData', function () {
                    vm.fnGenerateChartData();
                });

                $scope.$on("EditChartDetails", function (evt, data) {
                    var isTabExist = _.find(vm.tabs, {id: 'Update Chart'});
                    if (isTabExist) {
                        $timeout(function () {
                            isTabExist.chartId = data.id;
                            isTabExist.projectName = data.name;
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Update Chart',
                            title: 'Update Chart',
                            tabIndex: newTabIndex,
                            chartId: data.id,
                            projectName: data.name
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                });

                var chartKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_charts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedChartsArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleCharts(vm.selectedChartsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var chartKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.insight_charts') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', chartKeyDownEventHandler);
                document.addEventListener('keyup', chartKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', chartKeyDownEventHandler);
                    document.removeEventListener('keyup', chartKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DocumentationCtrl',
            function ($scope, DB, $timeout, $state, $rootScope, $http, $stateParams, UserProfileService, moment, mermaid, amaran, IssueFactory, PermissionsService, AppInitService, QueryFactory, DocumentationFactory, $log) {
                var vm = this;

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {}
                vm.searchText = '';
                vm.accountId = vm.authUserObj && vm.authUserObj.id ? vm.authUserObj.id.split("-")[0] : '';
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;
                vm.userGuides = [
                    {
                        name: 'Permissions',
                        id: 'udf277ae'
                    }, {
                        name: 'Access',
                        id: 'ud5339ea'
                    }, {
                        name: 'Node',
                        id: 'uda6e767'
                    }, {
                        name: 'Tracker',
                        id: 'udc3404a'
                    }, {
                        name: 'Pipeline',
                        id: 'ud41881a'
                    }, {
                        name: 'Storage',
                        id: 'ud92ff8c'
                    }, {
                        name: 'AI',
                        id: 'ud37d743'
                    }, {
                        name: 'Insight',
                        id: 'ude38dcf'
                    }, {
                        name: 'Billing',
                        id: 'ud407d4f'
                    }
                ];
                vm.technical = [
                    {
                        name: 'IoT3 Workbench',
                        id: 'ud071354'
                    }, {
                        name: 'IoT3',
                        id: 'ud3729d5'
                    }, {
                        name: 'S4',
                        id: 'ud667bcf'
                    }, {
                        name: 'QL',
                        id: 'udc0d001'
                    }, {
                        name: 'MJML',
                        id: 'ud787be8'
                    }
                ];
                vm.api = [
                    {
                        name: 'OAS',
                        id: ''
                    }, {
                        name: 'HTTP API',
                        id: 'udc91abf'
                    }, {
                        name: 'SDK',
                        id: 'udcd7f53'
                    }
                ];
                vm.markedOptionObj = {
                    "iconlibrary": "fa",
                    "addExtraButtons": false,
                    "resize": "vertical",
                    "initialstate": "preview",
                    hiddenButtons: ['all']
                };
                vm.isEditMode = false;
                vm.markdownText = "";
                vm.isDocumentLoading = true;
                vm.lastUpdated = "";

                vm.resetMarkdownText = _.cloneDeepWith(vm.markdownText);
                vm.documentationUpdating = false;
                vm.markdownTOCData = [];
                vm.markdownText = "";
                vm.fileUploading = false;
                vm.selectedProject = {};

                vm.fnOpenNewTab = function (obj) {
                    var newTabIndex = vm.tabs.length + 1;
                    var isFindIndex = _.find(vm.tabs, {id: obj.id});
                    if (!isFindIndex) {
                        vm.tabs.push({
                            id: obj.id,
                            title: obj.name,
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            $state.go('main.documentations', {
                                selectedId: obj.id
                            }, {notify: false});
                            $stateParams.selectedId = obj.id;
                            vm.fnUpdateUserProfileData();
                        });
                    } else {
                        $timeout(function () {
                            vm.activeTabIndex = isFindIndex.tabIndex;
                            $state.go('main.documentations', {
                                selectedId: isFindIndex.id
                            }, {notify: false});
                            $stateParams.selectedId = isFindIndex.id;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.activeTabIndex = 1;
                        $timeout(function () {
                            vm.activeTabIndex = tab.tabIndex;
                            $state.go('main.documentations', {
                                selectedId: tab.id
                            }, {notify: false});
                            $stateParams.selectedId = tab.id;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnRemoveTab = function (id) {
                    var tabs = [];
                    var i = 1;
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    vm.activeTabIndex = 1;
                    $state.go('main.documentations', {
                        selectedId: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    vm.fnUpdateUserProfileData();
                };

                vm.fnInitDocPage = function () {
                    vm.isDocumentLoading = true;
                    vm.lastUpdated = "";
                    vm.markdownTOCData = [];
                    var docObj = {
                        documentationId: vm.tabs[vm.activeTabIndex - 1].id
                    };
                    DocumentationFactory.describeDocumentation(docObj)
                        .then(function (response) {
                            vm.lastUpdated = vm.fnGetAbsoluteOrRelativeTime(response.updatedAt);
                            vm.markdownText = response && response.document ? response.document : '';
                            vm.resetMarkdownText = response && response.document ? response.document : '';
                            vm.markdownTOCData = vm.fnGenerateMarkdownTOC();
                            vm.isDocumentLoading = false;
                            vm.fnRenderMermaid();
                            $timeout(function () {
                                document.getElementsByClassName("md-preview")[0].addEventListener("scroll", function () {
                                    if (location.href.split("#").length - 1 > 1) {
                                        location = location.href.substr(0, location.href.lastIndexOf("#")); //eslint-disable-line
                                    }
                                });
                            }, 1500);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDocumentLoading = false;
                        });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnCreateNestedData = function (tempMarkdownTOCArr, parentEleValue) {
                    if (!tempMarkdownTOCArr.length) {
                        return
                    } else {
                        var isFind = _.find(tempMarkdownTOCArr, function (tempObj) {
                            if (tempObj.id === parentEleValue) {
                                return tempObj;
                            }
                        });
                        if (isFind) {
                            return isFind; // eslint-disable-line
                        } else {
                            return vm.fnCreateNestedData(tempMarkdownTOCArr[tempMarkdownTOCArr.length - 1].children, parentEleValue); // eslint-disable-line
                        }
                    }

                };

                vm.fnScrollToTop = function (headId) {
                    document.getElementById(headId).scrollIntoView();
                };

                vm.fnEditDocumentation = function (editorName) {
                    vm.isEditMode = true;
                    vm.resetMarkdownText = _.cloneDeepWith(vm.markdownText);
                    $timeout(function () {
                        $rootScope.markdownEditorObjects[editorName].hidePreview();
                    }, 100);
                };

                vm.fnHideShowEditorPreview = function (editorName) {
                    if ($rootScope.markdownEditorObjects[editorName].$isPreview) {
                        $rootScope.markdownEditorObjects[editorName].hidePreview();
                    } else {
                        $rootScope.markdownEditorObjects[editorName].showPreview();
                        vm.markdownTOCData = [];
                        vm.markdownTOCData = vm.fnGenerateMarkdownTOC();
                        vm.fnRenderMermaid();
                        $timeout(function () {
                            document.getElementsByClassName("md-preview")[0].addEventListener("scroll", function () {
                                if (location.href.split("#").length - 1 > 1) {
                                    location = location.href.substr(0, location.href.lastIndexOf("#")); //eslint-disable-line
                                }
                            });
                        }, 100)
                    }
                };

                vm.fnCancelEditing = function (editorName) {
                    vm.isEditMode = false;
                    vm.markdownText = "";
                    $timeout(function () {
                        vm.markdownText = _.cloneDeepWith(vm.resetMarkdownText);
                        if ($rootScope.markdownEditorObjects[editorName].$isPreview) {
                            $rootScope.markdownEditorObjects[editorName].hidePreview();
                        }
                        $timeout(function () {
                            $rootScope.markdownEditorObjects[editorName].showPreview();
                            vm.markdownTOCData = [];
                            vm.markdownTOCData = vm.fnGenerateMarkdownTOC();
                            vm.fnRenderMermaid();
                        });
                    });
                };

                vm.fnGenerateMarkdownTOC = function () {
                    var markdownTextArr = vm.markdownText.split('\n');
                    var markdownHeaders = _.filter(markdownTextArr, function (arrObj) {
                        return arrObj !== '' && arrObj.startsWith('#') && !arrObj.includes('<!-- omit in toc -->');
                    });
                    var tempMarkdownTOCArr = [];
                    if (markdownHeaders && markdownHeaders.length) {
                        var firstHeaderElement = markdownHeaders[0].match(new RegExp("#", "g")) || [].length;
                        var startHeaderLength = firstHeaderElement.length;
                        tempMarkdownTOCArr = [];
                        _.forEach(markdownHeaders, function (headerString, index) {
                            var tempHeaderString = headerString.match(new RegExp("#", "g")) || [].length;
                            var tempMarkdownTOCObj = {
                                id: headerString,
                                markdownId: $.parseHTML(marked(headerString))[0].id, // eslint-disable-line
                                markdownText: $.parseHTML(marked(headerString))[0].innerHTML, // eslint-disable-line
                                children: []
                            };
                            if (tempHeaderString.length > startHeaderLength) {
                                var currentIndex = _.cloneDeepWith(index);
                                var isFindFlag = false;
                                var parentEleValue = "";
                                for (var i = currentIndex; i >= 0; i--) {
                                    if (!isFindFlag) {
                                        var a = markdownHeaders[i].match(new RegExp("#", "g")) || [].length;
                                        if ((tempHeaderString.length - 1) === a.length) {
                                            parentEleValue = markdownHeaders[i];
                                            isFindFlag = true;
                                        }
                                    }
                                }
                                var isFindTOCObj = vm.fnCreateNestedData(tempMarkdownTOCArr, parentEleValue);
                                if (isFindTOCObj) {
                                    isFindTOCObj.children.push(tempMarkdownTOCObj);
                                }
                            } else {
                                tempMarkdownTOCArr.push(tempMarkdownTOCObj);
                            }
                        });
                    } else {
                        tempMarkdownTOCArr = [];
                    }
                    return tempMarkdownTOCArr;
                };

                vm.fnSaveDocumentation = function (editorName) {
                    vm.documentationUpdating = true;
                    var docObj = {
                        documentationId: vm.tabs[vm.activeTabIndex - 1].id,
                        body: {}
                    };
                    docObj.body = {
                        document: vm.markdownText
                    };
                    DocumentationFactory.replaceDocumentation(docObj)
                        .then(function (response) {
                            vm.markdownText = _.cloneDeepWith(response.document);
                            vm.resetMarkdownText = _.cloneDeepWith(vm.markdownText);
                            vm.lastUpdated = vm.fnGetAbsoluteOrRelativeTime(response.updatedAt);
                            vm.documentationUpdating = false;
                            vm.isEditMode = false;
                            $rootScope.markdownEditorObjects[editorName].showPreview();
                            vm.fnRenderMermaid();
                            vm.markdownTOCData = [];
                            vm.markdownTOCData = vm.fnGenerateMarkdownTOC();
                            amaran.success("Documentation Update Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.documentationUpdating = false;
                        });
                };

                vm.searchDocumentation = function (e) {
                    if (vm.searchText) {
                        if (e && e.keyCode === 13) {
                            var matches = vm.markdownText.match(new RegExp('(\\w*' + vm.searchText + '\\w*)', 'gi'));
                            if (matches === null) {
                                return;
                            } else {
                                vm.markdownText = vm.markdownText.replace(new RegExp('(\\w*' + vm.searchText + '\\w*)', 'gi'), function (match) {
                                    return '<span style="background-color: yellow">' + match + '</span>';
                                });
                                $timeout(function () {
                                    $rootScope.markdownEditorObjects.documentationEditor.hidePreview();
                                    $rootScope.markdownEditorObjects.documentationEditor.showPreview();
                                    vm.fnRenderMermaid();
                                });
                            }
                        }
                    } else {
                        vm.markdownText = vm.resetMarkdownText;
                        $timeout(function () {
                            $rootScope.markdownEditorObjects.documentationEditor.hidePreview();
                            $rootScope.markdownEditorObjects.documentationEditor.showPreview();
                            vm.fnRenderMermaid();
                        });
                    }

                };

                /* eslint-disable */
                vm.fnRenderMermaid = function () {
                    $timeout(function () {
                        mermaid.init(".lang-mermaid");
                        var pre = document.getElementsByTagName('pre'),
                            pl = pre.length;
                        for (var i = 0; i < pl; i++) {
                            if (pre[i].childNodes[0].classList.contains('lang-javascript')) {
                                pre[i].innerHTML = '<span class="line-number"></span>' + pre[i].innerHTML;
                                var num = pre[i].innerHTML.split(/\n/).length;
                                for (var j = 0; j < num - 1; j++) {
                                    var line_num = pre[i].getElementsByTagName('span')[0];
                                    line_num.innerHTML += '<span>' + (j + 1) + '</span>';
                                }
                            }
                        }
                        $timeout(function () {
                            var el = document.querySelector('.lang-xml'),esc = _.escape(el.innerText);
                            // Reasign escaped to node and initialize highlight.js
                            el.innerHTML = esc;
                            hljs.highlightBlock(el);
                        }, 500);
                    }, 100);
                };
                /* eslint-enable */

                /*Upload: START*/
                vm.uploadIssueFile = function (res, type, filedata) {
                    $http({
                        method: 'PUT',
                        url: res.uploadUrl,
                        config: {
                            headers: {
                                'Content-Type': filedata.type
                            }
                        },
                        data: filedata
                    }).success(function () {
                        var domElement = document.getElementsByName('documentationEditor')[0];
                        if (angular.isDefined(domElement)) {
                            var val = '';
                            if (type === 'image') {
                                val = " ![" + filedata.name + "](" + res.downloadUrl + ")";
                            } else {
                                val = " [" + filedata.name + "](" + res.downloadUrl + ")";
                            }
                            if (document.selection) {
                                domElement.focus();
                                var sel = document.selection.createRange();
                                sel.text = val;
                                domElement.focus();
                            } else if (domElement.selectionStart || domElement.selectionStart === 0) {
                                var startPos = domElement.selectionStart;
                                var endPos = domElement.selectionEnd;
                                var scrollTop = domElement.scrollTop;
                                domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
                                domElement.focus();
                                domElement.selectionStart = startPos + val.length;
                                domElement.selectionEnd = startPos + val.length;
                                domElement.scrollTop = scrollTop;
                            } else {
                                domElement.value += val;
                                domElement.focus();
                            }
                            vm.markdownText = document.getElementsByName('documentationEditor')[0].value;
                            vm.fileUploading = false;
                        } else {
                            if (type === 'image') {
                                vm.markdownText = $scope.newCommentObj.text + " ![" + filedata.name + "](" + res.downloadUrl + ")";
                            } else {
                                vm.markdownText = $scope.newCommentObj.text + " [" + filedata.name + "](" + res.downloadUrl + ")";
                            }
                            vm.fileUploading = false;
                        }
                    });
                };

                vm.uploadFiles = function (type, filedata) {
                    if (vm.permissionObj.GET_FILE_UPLOAD_LINK) {
                        vm.fileUploading = true;
                        $scope.$apply();
                        var inputObj = {
                            projectId: vm.selectedProject.id
                        };
                        IssueFactory.getFileUploadLink(inputObj)
                            .then(function (res) {
                                vm.uploadIssueFile(res, type, filedata);
                            })
                    } else {
                        amaran.error('Sorry, Looks like you do not have permission to attach a file')
                    }
                };
                /*Upload: END*/

                vm.fnGetProject = function (inputObj, preDefinedProjects, isCalledForViz) {
                    vm.isProjectLoaded = false;
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            var projects = isCalledForViz ? preDefinedProjects : [];

                            // Parse data using parsePostgresData
                            if (res.data) {
                                var parsedProjects = parsePostgresData(res.data);
                                _.forEach(parsedProjects, function (projectObj) {
                                    projects.push(projectObj);
                                });
                            }

                            if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                                var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                                sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                                vm.fnGetProject({sql: sqlString}, projects, true);
                            } else {
                                vm.projectsArr = _.cloneDeepWith(projects);
                                vm.selectedProject = _.find(vm.projectsArr, function (projectObj) {
                                    return angular.isUndefined(projectObj.parentProjectId);
                                });
                                vm.fnOpenDocumentation();
                            }
                        }, function () {
                            vm.fnGetProject(inputObj, [], false);
                        });
                };

                vm.fnOpenDocumentation = function () {
                    if ($stateParams.selectedId) {
                        var isFindUserGuide = _.find(vm.userGuides, {id: $stateParams.selectedId});
                        if (isFindUserGuide) {
                            vm.fnOpenNewTab(isFindUserGuide);
                        } else {
                            var isFindTechnical = _.find(vm.technical, {id: $stateParams.selectedId});
                            if (isFindTechnical) {
                                vm.fnOpenNewTab(isFindTechnical);
                            } else {
                                var isFindAPI = _.find(vm.api, {id: $stateParams.selectedId});
                                if (isFindAPI) {
                                    vm.fnOpenNewTab(isFindAPI);
                                }
                            }
                        }
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('documentation', 'documentation', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnInitDocumentations = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("tracker");
                    var tempValue = UserProfileService.fnGetUserProfileObj('documentation', 'documentation', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }

                    // Fetch projects from AppInitService
                    if (!DB.fnGet('federation') && !DB.fnGet('support') && AppInitService.getInitData('projectsArr').length !== 0) {
                        // Use parsed data from AppInitService
                        vm.projectsArr = _.cloneDeepWith(AppInitService.getInitData('projectsArr'));
                        vm.selectedProject = _.find(vm.projectsArr, function (projectObj) {
                            return angular.isUndefined(projectObj.parentProjectId);
                        });
                        vm.fnOpenDocumentation();
                    } else {
                        // Fallback to querying projects directly
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + 100 + ';';
                        vm.fnGetProject({sql: projectSQL}, [], false);
                    }
                };
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('SupportCtrl',
            function ($uibModalInstance, isCalledForSupport, recoveryType,$timeout, amaran,$state,$http) {
                var vm = this;
                vm.isCalledForSupport = isCalledForSupport;
                vm.recoveryType = recoveryType;
                vm.isPasswordReset = false;
                vm.isPasswordResetCompleted = true;
                vm.fnCancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                vm.fnVerifyCaptcha = function () {
                    vm.captchaVerified = true;
                };

                vm.fnReVerifyCaptcha = function () {
                    vm.captchaVerified = false;
                };
                vm.fnResetPassword = function () {
                    vm.isPasswordResetCompleted = false;
                    var apiURL = HOST_URL.access + "/passwords?identifier="+vm.email; //eslint-disable-line
                    $http({
                        method: "GET",
                        url: apiURL,
                        responseType: 'application/json'
                    }).then(function (response) {
                        if (response && response.data && response.data.code &&
                            !response.data.code.toString().startsWith('20')) {
                            amaran.error(response.data.message);
                         vm.isPasswordReset = false;
                         vm.isPasswordResetCompleted = true;
                        } else {
                            amaran.success("Your request for reset password  is send Successfully");
                            vm.isPasswordResetCompleted = true;
                            vm.isPasswordReset = true;
                        }
                    }, function error() {
                    });
                }
            });
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('WidgetsListService', fnWidgetsListService);

    /** @ngInject */
    function fnWidgetsListService($window) {
        var url = "";
        if ($window.location.origin.startsWith('https://dev.predictive')) {
            url = 'https://www.ecsmon.ecsiteapp.com';
        } else if ($window.location.origin.startsWith('https://qa.predictive')) {
            url = 'https://www.ecsmon.ecsiteapp.com';
        } else if ($window.location.origin.startsWith('https://predictive')) {
            url = 'https://www.ecsmon.ecsiteapp.com';
        } else {
            url = 'https://www.ecsmon.ecsiteapp.com';
        }
        return {
            getStaticWidgets: function () {
                var staticWidgetsArr = [
                    {
                        "widgetType": "custom",
                        "widgetTitle": "Custom",
                        "widgetDescription": "Define Your own static widget from scratch.",
                        "widgetData": {
                            "title": "",
                            "icon": "",
                            "description": "",
                            "buttonText": "",
                            "buttonLink": "",
                            "target": "Same Window"
                        }
                    }, {
                        "widgetType": "static",
                        "widgetTitle": "Invite User",
                        "widgetDescription": "A static widget that provides a quick call to action to invite a new team members to collaborate.",
                        "widgetData": {
                            "title": "User",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                                "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                                "</svg>",
                            "description": "Invite your team members to collaborate.",
                            "buttonText": "Invite User",
                            "buttonLink": url + "/#/access/users?page=1&perPage=20",
                            "target": "Same Window"
                        }
                    }
                ];
                return _.cloneDeepWith(staticWidgetsArr);
            },
            getBlueprintWidgets: function () {
                var blueprintWidgetsArr = [
                    {
                        "widgetTitle": "Users By Status",
                        "widgetDescription": "A dynamic widget that provides summary of system user by their status.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "User Status",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"> <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select state, COUNT(*) AS count from access_users group by state"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "state",
                                "y": "count"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "chart": {
                                    "type": "pie"
                                },
                                "series": [
                                    {
                                        "name": "count",
                                        "turboThreshold": 0,
                                        "marker": {},
                                        "data": [
                                            [
                                                "ACTIVE",
                                                1
                                            ],
                                            [
                                                "UNCONFIRMED",
                                                7
                                            ]
                                        ]
                                    }
                                ],
                                "plotOptions": {
                                    "series": {
                                        "animation": false,
                                        "dataLabels": {
                                            "enabled": false
                                        }
                                    }
                                },
                                "data": {
                                    "csv": "state,count\r\nACTIVE,1\r\nUNCONFIRMED,7\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                },
                                "yAxis": {
                                    "title": {}
                                }
                            }
                        }
                    },
                    {
                        "widgetTitle": "Team By Users",
                        "widgetDescription": "A dynamic widget that provides the total user count by Team.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Team",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"> <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select name, LENGTH(userIds) AS userCount from access_teams"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "name",
                                "y": "userCount"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "series": [
                                    {
                                        "name": "userCount",
                                        "turboThreshold": 0,
                                        "data": [
                                            [
                                                "test new dev",
                                                0
                                            ],
                                            [
                                                "test",
                                                4
                                            ],
                                            [
                                                "demo demo",
                                                0
                                            ],
                                            [
                                                "Test Dev 2",
                                                0
                                            ]
                                        ]
                                    }
                                ],
                                "plotOptions": {
                                    "series": {
                                        "animation": false,
                                        "dataLabels": {
                                            "enabled": false
                                        }
                                    }
                                },
                                "data": {
                                    "csv": "name,userCount\r\ntest new dev,0\r\ntest,4\r\ndemo demo,0\r\nTest Dev 2,0\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ",",
                                    "dateFormat": "YYYY/mm/dd"
                                }
                            }
                        }
                    },
                    {
                        "widgetTitle": "User By Team",
                        "widgetDescription": "A dynamic widget that provides the total Team count by user.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Users",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n</svg>"
                        },
                        "APIConfiguration": {
                            "sql": "select CONCAT(firstName,' ' ,lastName) AS userName, LENGTH(teamIds) AS userGroupCount from access_users"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {"name": "userName", "y": "userGroupCount"},
                            "chartConfig": {
                                "title": {"text": ""},
                                "subtitle": {"text": ""},
                                "exporting": {"enabled": false},
                                "credits": {"enabled": false},
                                "chart": {"type": "pie"},
                                "yAxis": {"title": {}},
                                "series": [{"name": "userCount", "turboThreshold": 0}],
                                "plotOptions": {"series": {"animation": false}},
                                "data": {
                                    "csv": "\"userName\";\"userGroupCount\"\n\"TestUser5\";1\n\"TestUser2\";1\n\"TestUser6\";1\n\"TestUser1\";0\n\"TestUser4\";0\n\"TestUser3\";0\n\"TestUser7\";0\n\"KunalBariya\";1",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false
                                }
                            }
                        }
                    }
                ];
                return _.cloneDeepWith(blueprintWidgetsArr);
            },
            getDashboardBlueprintWidgets: function () {
                var dashboardBlueprintWidgetsArr = [
                    {
                        "widgetTitle": "Users By Status",
                        "widgetDescription": "A dynamic widget that provides summary of system user by their status.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Users",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"> <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg>",
                            "buttonText": "Manage Users",
                            "buttonLink": url + "/#/access/users?page=1&perPage=20",
                            "target": "Same Window"
                        },
                        "APIConfiguration": {
                            "sql": "select state, COUNT(*) AS count from access_users group by state"
                        },
                        "chartConfiguration": {
                            "chartType": "column",
                            "dataMapping": {
                                "name": "state",
                                "y": "count"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": true
                                        },
                                        "animation": true
                                    }
                                },
                                "series": [
                                    {
                                        "name": "count",
                                        "turboThreshold": 0,
                                        "marker": {}
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "data": {
                                    "csv": "state,count\r\nACTIVE,1\r\nUNCONFIRMED,7\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false
                                },
                                "yAxis": {
                                    "title": {},
                                    "labels": {}
                                },
                                "xAxis": {
                                    "title": {},
                                    "labels": {}
                                },
                                "legend": {
                                    "enabled": false
                                }
                            }
                        }
                    },
                    {
                        "widgetTitle": "User By Team",
                        "widgetDescription": "A dynamic widget that provides the total Team count by user.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Teams",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"> <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg>",
                            "buttonText": "Manage Teams",
                            "buttonLink": url + "/#/access/teams?page=1&perPage=20",
                            "target": "Same Window"
                        },
                        "APIConfiguration": {
                            "sql": "select CONCAT(firstName, lastName) AS userName, LENGTH(teamIds) AS userCount from access_users"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "userName",
                                "y": "userCount"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": true
                                        },
                                        "animation": true
                                    }
                                },
                                "series": [
                                    {
                                        "data": [
                                            [
                                                "Test12User5",
                                                1
                                            ],
                                            [
                                                "TestUser2",
                                                1
                                            ],
                                            [
                                                "TestUser6",
                                                3
                                            ],
                                            [
                                                "TestUser1",
                                                0
                                            ],
                                            [
                                                "TestUser4",
                                                1
                                            ],
                                            [
                                                "TestUser3",
                                                0
                                            ],
                                            [
                                                "TestUser7",
                                                0
                                            ],
                                            [
                                                "KunalBariya",
                                                1
                                            ]
                                        ],
                                        "name": "userCount",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "data": {
                                    "csv": "userName,userCount\r\nTest12User5,1\r\nTestUser2,1\r\nTestUser6,3\r\nTestUser1,0\r\nTestUser4,1\r\nTestUser3,0\r\nTestUser7,0\r\nKunalBariya,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                },
                                "legend": {
                                    "enabled": false
                                }
                            }
                        }
                    },
                    {
                        "widgetTitle": "Authenticator By Users",
                        "widgetDescription": "A dynamic widget that provides the total users count by authenticators.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Authenticator",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/password.svg#password\"></use> \n</svg>",
                            "buttonText": "Manage Authenticator",
                            "buttonLink": url + "/#/access/authenticators?page=1&perPage=20",
                            "target": "Same Window"
                        },
                        "APIConfiguration": {
                            "sql": "select name,LENGTH(userIds) AS userCount from access_authenticators"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "name",
                                "y": "userCount"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": true
                                        },
                                        "animation": true
                                    }
                                },
                                "series": [
                                    {
                                        "data": [],
                                        "name": "resourceCount",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "data": {
                                    "csv": "name,resourceCount\r\nTest dev Team1122,1\r\nTest dev Team,1\r\nTest dev Team cloned,1\r\nTest Empty Security Group,0\r\nTesting dev1,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                },
                                "legend": {
                                    "enabled": false
                                }
                            }
                        }
                    },
                    {
                        "widgetTitle": "Federation By Types",
                        "widgetDescription": "A dynamic widget that provides summary of federation by their types.",
                        "widgetType": "dynamic",
                        "widgetData": {
                            "title": "Federation",
                            "icon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n   <use xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use> \n</svg>",
                            "buttonText": "Manage Federation",
                            "buttonLink": url + "/#/access/federations?page=1&perPage=20",
                            "target": "Same Window"
                        },
                        "APIConfiguration": {
                            "sql": "select type, COUNT(*) AS count from access_federations group by type"
                        },
                        "chartConfiguration": {
                            "chartType": "pie",
                            "dataMapping": {
                                "name": "type",
                                "y": "count"
                            },
                            "chartConfig": {
                                "title": {
                                    "text": " "
                                },
                                "subtitle": {
                                    "text": " "
                                },
                                "exporting": {
                                    "enabled": false
                                },
                                "credits": {
                                    "enabled": false
                                },
                                "plotOptions": {
                                    "series": {
                                        "dataLabels": {
                                            "enabled": true
                                        },
                                        "animation": true
                                    }
                                },
                                "series": [
                                    {
                                        "data": [],
                                        "name": "resourceCount",
                                        "turboThreshold": 0
                                    }
                                ],
                                "chart": {
                                    "type": "pie"
                                },
                                "yAxis": {
                                    "title": {}
                                },
                                "data": {
                                    "csv": "type,count\r\nTest dev Team1122,1\r\nTest dev Team,1\r\nTest dev Team cloned,1\r\nTest Empty Security Group,0\r\nTesting dev1,1\r\n",
                                    "googleSpreadsheetKey": false,
                                    "googleSpreadsheetWorksheet": false,
                                    "decimalPoint": ","
                                },
                                "legend": {
                                    "enabled": false
                                }
                            }
                        }
                    }
                ];
                return _.cloneDeepWith(dashboardBlueprintWidgetsArr);
            },
            downloadChartData: function (type, id) {
                var chart = $('#' + id).highcharts(); //eslint-disable-line
                if (chart) {
                    if (type === 'downloadPNG') {
                        chart.exportChart();
                    } else if (type === 'downloadJPEG') {
                        chart.exportChart({
                            type: 'image/jpeg'
                        });
                    } else if (type === 'downloadPDF') {
                        chart.exportChart({
                            type: 'application/pdf'
                        });
                    } else if (type === 'downloadCSV') {
                        chart.downloadCSV()
                    } else if (type === 'downloadXLS') {
                        chart.downloadXLS()
                    } else {
                        chart.exportChart({
                            type: 'image/svg+xml'
                        });
                    }
                }
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('UserProfileService', fnUserProfileService);

    /** @ngInject */
    function fnUserProfileService(DB, swal, amaran, microSpinner, UserFactory) {
        var userProfile = DB.fnGet('userProfile');
        return {
            fnUpdateUserProfileObj: function (app, service, key, value, isCallFromWidgetEditor) {
                if (angular.isDefined(isCallFromWidgetEditor) && isCallFromWidgetEditor) {
                    swal({
                        title: "Please wait while your data is saving...",
                        type: "warning",
                        showConfirmButton: true,
                        showLoaderOnConfirm: true
                    });
                    angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                    angular.element(".sa-button-container").css('display', 'flex');
                    angular.element(".sa-button-container").css('align-items', 'center');
                    angular.element(".sa-button-container").css('justify-content', 'center');
                    angular.element(".confirm").css("visibility", "hidden");
                }
                userProfile = DB.fnGet('userProfile');
                var userProfileData = _.cloneDeepWith(userProfile);
                if (userProfileData && userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home[app] && userProfileData.pre.home[app][service]) {
                    userProfileData.pre.home[app][service][key] = value;
                } else if (userProfileData && userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home[app]) {
                    if (userProfileData.pre.home[app][service]) {
                        userProfileData.pre.home[app][service][key] = value;
                    } else {
                        userProfileData.pre.home[app][service] = {};
                        userProfileData.pre.home[app][service][key] = value;
                    }
                } else {
                    if (angular.isUndefined(userProfileData) || userProfileData === null) {
                        userProfileData = {};
                    }
                    if (angular.isUndefined(userProfileData.pre)) {
                        userProfileData.pre = {};
                    }
                    if (angular.isUndefined(userProfileData.pre.home)) {
                        userProfileData.pre = {home: {}};
                    }
                    if (angular.isUndefined(userProfileData.pre.home[app])) {
                        userProfileData.pre.home[app] = {};
                    }
                    if (angular.isUndefined(userProfileData.pre.home[app][service])) {
                        userProfileData.pre.home[app][service] = {};
                    }
                    userProfileData.pre.home[app][service][key] = value;
                }
                var inputObj = {
                    body: userProfileData
                };
                UserFactory.updateUserProfile(inputObj)
                    .then(function (response) {
                        DB.fnSet('userProfile', response);
                        userProfile = response;
                        if (angular.isDefined(isCallFromWidgetEditor) && isCallFromWidgetEditor) {
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            angular.element(".sa-button-container").css('display', '');
                            angular.element(".sa-button-container").css('align-items', '');
                            angular.element(".sa-button-container").css('justify-content', '');
                            swal.close();
                        }
                    }, function (error) {
                        if (error && error.errorCode === -1) {
                            amaran.error(error.errorMessage);
                        }
                        if (angular.isDefined(isCallFromWidgetEditor) && isCallFromWidgetEditor) {
                            angular.element(".microSpinner").remove();
                            angular.element(".confirm").css("visibility", "visible");
                            swal.close();
                        }
                    });
                return userProfileData;
            },

            fnGetUserProfileObj: function (app, service, key) {
                userProfile = DB.fnGet('userProfile');
                if (userProfile !== null && userProfile.pre && userProfile.pre.home && userProfile.pre.home[app] && userProfile.pre.home[app][service] && userProfile.pre.home[app][service][key]) {
                    return userProfile.pre.home[app][service][key];
                } else {
                    return '';
                }
            },

            fnUpdateSystemProfileObj: function (key, value) {
                userProfile = DB.fnGet('userProfile');
                var userProfileData = _.cloneDeepWith(userProfile);
                if (angular.isUndefined(userProfileData)) {
                    userProfileData = {};
                }
                if (angular.isUndefined(userProfileData.pre)) {
                    userProfileData.pre = {};
                }
                if (angular.isUndefined(userProfileData.pre.home)) {
                    userProfileData.pre.home = {};
                }
                if (angular.isUndefined(userProfileData.pre.home.all)) {
                    userProfileData.pre.home.all = {};
                }
                userProfileData.pre.home.all[key] = '';
                userProfileData.pre.home.all[key] = value;
                var inputObj = {
                    body: userProfileData
                };
                UserFactory.updateUserProfile(inputObj)
                    .then(function (response) {
                        DB.fnSet('userProfile', response);
                        userProfile = response;
                    }, function () {

                    });
                return userProfileData;
            },

            fnGetSystemProfileObj: function (key) {
                userProfile = DB.fnGet('userProfile');
                if (userProfile && userProfile !== null && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && angular.isDefined(userProfile.pre.home.all[key])) {
                    return userProfile.pre.home.all[key];
                } else {
                    return '';
                }
            }
        };
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('TypeFormService', fnTypeFormService);

    /** @ngInject */
    function fnTypeFormService() {
        return {
            fnGenerateFormData: function (schema) {
                var supportedInputTypes = ["string", "boolean", "number", "password", "object", "label", "button"];
                var tempArr = [];
                var formBuilderInput = [];
                _.forEach(schema.properties, function (value, key) {
                    if (value.type === 'string' && value.inputType !== 'textarea' && value.inputType !== 'dropdown' && value.inputType !== 'password') {
                        tempArr.push({
                            key: key,
                            type: "inputText",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputText",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'string' && value.inputType === 'textarea') {
                        tempArr.push({
                            key: key,
                            type: "inputTextarea",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputTextarea",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'boolean') {
                        tempArr.push({
                            key: key,
                            type: "inputCheckbox",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            required: value.required,
                            type: "inputCheckbox",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'number') {
                        tempArr.push({
                            key: key,
                            type: "inputNumber",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputNumber",
                            condition: value.hide
                        });
                    }
                    if ((value.type === 'string' && value.inputType === 'password') || value.type === 'password') {
                        tempArr.push({
                            key: key,
                            type: "inputPassword",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            description: value.description ? value.description : '',
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputPassword",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'string' && value.inputType === 'dropdown') {
                        tempArr.push({
                            key: key,
                            type: "inputDropdown",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            enum: value.enum,
                            type: "dropdown",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'label') {
                        tempArr.push({
                            key: key,
                            type: "inputLabel",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputLabel",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'button') {
                        tempArr.push({
                            key: key,
                            type: "inputButton",
                            feedback: false,
                            name: value.name,
                            value: value.value,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            name: value.name,
                            value: value.value,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "inputButton",
                            condition: value.hide
                        });
                    }
                    if (value.type === 'object' && value.inputType === "panel") {
                        var tempCondition = '';
                        if (value.multiformConfig && value.multiformConfig.conditionObj && (value.multiformConfig.conditionObj.show === true || value.multiformConfig.conditionObj.show === false) && value.multiformConfig.conditionObj.when.length && value.multiformConfig.conditionObj.value.length) {
                            var conditionValue = '';
                            if (value.multiformConfig.conditionObj.inputType !== 'Checkbox') {
                                conditionValue = "'" + value.multiformConfig.conditionObj.value + "'";
                            } else {
                                conditionValue = value.multiformConfig.conditionObj.value;
                            }
                            if (value.multiformConfig.conditionObj.show === true) {
                                tempCondition = "model." + value.multiformConfig.conditionObj.when + " === " + conditionValue;
                            } else {
                                tempCondition = "model." + value.multiformConfig.conditionObj.when + " !== " + conditionValue;
                            }
                        } else if (value.multiformConfig && value.multiformConfig.referenceKey && value.multiformConfig.referenceKey.length) {
                            tempCondition = "model." + value.multiformConfig.referenceKey
                        }
                        var conditionalArr = {
                            key: key,
                            type: "conditional",
                            title: value.title,
                            htmlClass: "divBlockTest m-b-20",
                            items: [{
                                type: "help",
                                helpvalue: "<h2 class=\'m-0 m-b-20\'><strong>" + value.title + "</strong></h2>"
                            }]
                        };
                        if (tempCondition.length) {
                            conditionalArr.condition = tempCondition;
                            conditionalArr.multiformConfig = value.multiformConfig;
                        }
                        var tempFormBuilderInput = {
                            key: key,
                            title: value.title,
                            multiformConfig: value.multiformConfig && Object.keys(value.multiformConfig).length ? value.multiformConfig : {},
                            required: value.required || (!!(schema.required && schema.required.includes(key))),
                            type: "panel-conditional",
                            items: []
                        };
                        var tempPropertiesObj = {};
                        _.forEach(value.properties, function (propertiesObj, propertiesKey) {
                            tempPropertiesObj = {};
                            var tempKey = key + '.' + propertiesKey + "";
                            if (propertiesObj.type === 'string' && propertiesObj.inputType !== 'textarea' && propertiesObj.inputType !== 'dropdown' && propertiesObj.inputType !== 'password') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputText",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputText",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'string' && propertiesObj.inputType === 'textarea') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputTextarea",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputTextarea",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'label') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputLabel",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputLabel",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'button') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputButton",
                                    feedback: false,
                                    name: propertiesObj.name,
                                    value: propertiesObj.value,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    name: propertiesObj.name,
                                    value: propertiesObj.value,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputButton",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'boolean') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputCheckbox",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    required: propertiesObj.required,
                                    type: "inputCheckbox",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'number') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputNumber",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputNumber",
                                    condition: value.hide
                                });
                            }
                            if ((propertiesObj.type === 'string' && propertiesObj.inputType === 'password') || propertiesObj.type === 'password') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputPassword",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    description: value.description ? value.description : '',
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputPassword",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'string' && propertiesObj.inputType === 'dropdown') {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputDropdown",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    enum: propertiesObj.enum,
                                    type: "dropdown",
                                    condition: value.hide
                                });
                            }
                            if (propertiesObj.type === 'object' && propertiesObj.inputType === "multiCheckbox") {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "conditional",
                                    title: propertiesObj.title,
                                    htmlClass: "divBlockTest m-b-20 d-flex flex-column",
                                    items: [{
                                        type: "help",
                                        helpvalue: "<h3 class=\'m-0 m-b-20\'><strong>" + propertiesObj.title + "</strong></h3>"
                                    }]
                                };

                                var tempMultiCheckboxFormBuilderInput = {
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    type: "panel-multiCheckbox",
                                    items: []
                                };

                                var tempMultiCheckboxPropertiesObj = {};
                                _.forEach(propertiesObj.properties, function (propertiesObj, propertiesKey) {
                                    tempMultiCheckboxPropertiesObj = {};
                                    var tempKey1 = tempKey + '.' + propertiesKey + "";
                                    if (propertiesObj.type === 'boolean') {
                                        tempMultiCheckboxPropertiesObj = {
                                            key: tempKey1,
                                            type: "inputCheckbox",
                                            feedback: false,
                                            title: propertiesObj.title,
                                            disableSuccessState: false,
                                            disableErrorState: false
                                        };
                                        tempPropertiesObj.items.push(tempMultiCheckboxPropertiesObj);
                                        tempMultiCheckboxFormBuilderInput.items.push({
                                            key: tempKey1,
                                            title: propertiesObj.title,
                                            type: "inputCheckbox"
                                        });
                                    }
                                });
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push(tempMultiCheckboxFormBuilderInput);
                            }
                            if (!supportedInputTypes.includes(propertiesObj.type)) {
                                tempPropertiesObj = {
                                    key: tempKey,
                                    type: "inputText",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    condition: value.hide
                                };
                                conditionalArr.items.push(tempPropertiesObj);
                                tempFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    placeholder: propertiesObj.placeholder && propertiesObj.placeholder !== '' ? propertiesObj.placeholder : propertiesObj.title,
                                    required: propertiesObj.required || (!!(schema.required && schema.required.includes(tempKey))).required,
                                    type: "inputText",
                                    condition: value.hide
                                });
                            }
                        });
                        tempArr.push(conditionalArr);
                        formBuilderInput.push(tempFormBuilderInput);
                    }
                    if (value.type === 'object' && value.inputType === "multiCheckbox") {
                        var multiCheckboxConditionalArr = {
                            key: key,
                            type: "conditional",
                            title: value.title,
                            htmlClass: "divBlockTest m-b-20",
                            items: [{
                                type: "help",
                                helpvalue: "<h3 class=\'m-0 m-b-20\'><strong>" + value.title + "</strong></h3>"
                            }]
                        };
                        var tempMultiFormBuilderInput = {
                            key: key,
                            title: value.title,
                            type: "panel-multiCheckbox",
                            items: []
                        };
                        var tempMultiPropertiesObj = {};
                        _.forEach(value.properties, function (propertiesObj, propertiesKey) {
                            tempMultiPropertiesObj = {};
                            var tempKey = key + '.' + propertiesKey + "";
                            if (propertiesObj.type === 'boolean') {
                                tempMultiPropertiesObj = {
                                    key: tempKey,
                                    type: "inputCheckbox",
                                    feedback: false,
                                    title: propertiesObj.title,
                                    disableSuccessState: false,
                                    disableErrorState: false,
                                    condition: value.hide
                                };
                                multiCheckboxConditionalArr.items.push(tempMultiPropertiesObj);
                                tempMultiFormBuilderInput.items.push({
                                    key: tempKey,
                                    title: propertiesObj.title,
                                    required: propertiesObj.required,
                                    type: "inputCheckbox",
                                    condition: value.hide
                                });
                            }
                        });
                        tempArr.push(multiCheckboxConditionalArr);
                        formBuilderInput.push(tempMultiFormBuilderInput);
                    }
                    if (!supportedInputTypes.includes(value.type)) {
                        tempArr.push({
                            key: key,
                            type: "inputText",
                            feedback: false,
                            title: value.title,
                            disableSuccessState: false,
                            disableErrorState: false,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))).required,
                            condition: value.hide
                        });
                        formBuilderInput.push({
                            key: key,
                            title: value.title,
                            placeholder: value.placeholder && value.placeholder !== '' ? value.placeholder : value.title,
                            required: value.required || (!!(schema.required && schema.required.includes(key))).required,
                            type: "inputText",
                            condition: value.hide
                        });
                    }
                });
                var tempSchema = _.cloneDeepWith(schema);
                var newSchema = {
                    $schema: "https://json-schema.org/draft/2019-09/schema",
                    type: "object",
                    properties: _.cloneDeepWith(tempSchema.properties)
                };
                return {form: tempArr, schema: newSchema, formBuilderInput: formBuilderInput};
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('TimezoneOptionArrService', fnTimezoneOptionArrService);

    /** @ngInject */
    function fnTimezoneOptionArrService() {
        return {
            getTimezoneOptionArr: function () {
                var timezoneOptionArr = [
                    "Africa/Abidjan",
                    "Africa/Accra",
                    "Africa/Addis_Ababa",
                    "Africa/Algiers",
                    "Africa/Asmara",
                    "Africa/Asmera",
                    "Africa/Bamako",
                    "Africa/Bangui",
                    "Africa/Banjul",
                    "Africa/Bissau",
                    "Africa/Blantyre",
                    "Africa/Brazzaville",
                    "Africa/Bujumbura",
                    "Africa/Cairo",
                    "Africa/Casablanca",
                    "Africa/Ceuta",
                    "Africa/Conakry",
                    "Africa/Dakar",
                    "Africa/Dar_es_Salaam",
                    "Africa/Djibouti",
                    "Africa/Douala",
                    "Africa/El_Aaiun",
                    "Africa/Freetown",
                    "Africa/Gaborone",
                    "Africa/Harare",
                    "Africa/Johannesburg",
                    "Africa/Juba",
                    "Africa/Kampala",
                    "Africa/Khartoum",
                    "Africa/Kigali",
                    "Africa/Kinshasa",
                    "Africa/Lagos",
                    "Africa/Libreville",
                    "Africa/Lome",
                    "Africa/Luanda",
                    "Africa/Lubumbashi",
                    "Africa/Lusaka",
                    "Africa/Malabo",
                    "Africa/Maputo",
                    "Africa/Maseru",
                    "Africa/Mbabane",
                    "Africa/Mogadishu",
                    "Africa/Monrovia",
                    "Africa/Nairobi",
                    "Africa/Ndjamena",
                    "Africa/Niamey",
                    "Africa/Nouakchott",
                    "Africa/Ouagadougou",
                    "Africa/Porto-Novo",
                    "Africa/Sao_Tome",
                    "Africa/Timbuktu",
                    "Africa/Tripoli",
                    "Africa/Tunis",
                    "Africa/Windhoek",
                    "America/Adak",
                    "America/Anchorage",
                    "America/Anguilla",
                    "America/Antigua",
                    "America/Araguaina",
                    "America/Argentina/Buenos_Aires",
                    "America/Argentina/Catamarca",
                    "America/Argentina/ComodRivadavia",
                    "America/Argentina/Cordoba",
                    "America/Argentina/Jujuy",
                    "America/Argentina/La_Rioja",
                    "America/Argentina/Mendoza",
                    "America/Argentina/Rio_Gallegos",
                    "America/Argentina/Salta",
                    "America/Argentina/San_Juan",
                    "America/Argentina/San_Luis",
                    "America/Argentina/Tucuman",
                    "America/Argentina/Ushuaia",
                    "America/Aruba",
                    "America/Asuncion",
                    "America/Atikokan",
                    "America/Atka",
                    "America/Bahia",
                    "America/Bahia_Banderas",
                    "America/Barbados",
                    "America/Belem",
                    "America/Belize",
                    "America/Blanc-Sablon",
                    "America/Boa_Vista",
                    "America/Bogota",
                    "America/Boise",
                    "America/Buenos_Aires",
                    "America/Cambridge_Bay",
                    "America/Campo_Grande",
                    "America/Cancun",
                    "America/Caracas",
                    "America/Catamarca",
                    "America/Cayenne",
                    "America/Cayman",
                    "America/Chicago",
                    "America/Chihuahua",
                    "America/Coral_Harbour",
                    "America/Cordoba",
                    "America/Costa_Rica",
                    "America/Creston",
                    "America/Cuiaba",
                    "America/Curacao",
                    "America/Danmarkshavn",
                    "America/Dawson",
                    "America/Dawson_Creek",
                    "America/Denver",
                    "America/Detroit",
                    "America/Dominica",
                    "America/Edmonton",
                    "America/Eirunepe",
                    "America/El_Salvador",
                    "America/Ensenada",
                    "America/Fort_Nelson",
                    "America/Fort_Wayne",
                    "America/Fortaleza",
                    "America/Glace_Bay",
                    "America/Godthab",
                    "America/Goose_Bay",
                    "America/Grand_Turk",
                    "America/Grenada",
                    "America/Guadeloupe",
                    "America/Guatemala",
                    "America/Guayaquil",
                    "America/Guyana",
                    "America/Halifax",
                    "America/Havana",
                    "America/Hermosillo",
                    "America/Indiana/Indianapolis",
                    "America/Indiana/Knox",
                    "America/Indiana/Marengo",
                    "America/Indiana/Petersburg",
                    "America/Indiana/Tell_City",
                    "America/Indiana/Vevay",
                    "America/Indiana/Vincennes",
                    "America/Indiana/Winamac",
                    "America/Indianapolis",
                    "America/Inuvik",
                    "America/Iqaluit",
                    "America/Jamaica",
                    "America/Jujuy",
                    "America/Juneau",
                    "America/Kentucky/Louisville",
                    "America/Kentucky/Monticello",
                    "America/Knox_IN",
                    "America/Kralendijk",
                    "America/La_Paz",
                    "America/Lima",
                    "America/Los_Angeles",
                    "America/Louisville",
                    "America/Lower_Princes",
                    "America/Maceio",
                    "America/Managua",
                    "America/Manaus",
                    "America/Marigot",
                    "America/Martinique",
                    "America/Matamoros",
                    "America/Mazatlan",
                    "America/Mendoza",
                    "America/Menominee",
                    "America/Merida",
                    "America/Metlakatla",
                    "America/Mexico_City",
                    "America/Miquelon",
                    "America/Moncton",
                    "America/Monterrey",
                    "America/Montevideo",
                    "America/Montreal",
                    "America/Montserrat",
                    "America/Nassau",
                    "America/New_York",
                    "America/Nipigon",
                    "America/Nome",
                    "America/Noronha",
                    "America/North_Dakota/Beulah",
                    "America/North_Dakota/Center",
                    "America/North_Dakota/New_Salem",
                    "America/Ojinaga",
                    "America/Panama",
                    "America/Pangnirtung",
                    "America/Paramaribo",
                    "America/Phoenix",
                    "America/Port-au-Prince",
                    "America/Port_of_Spain",
                    "America/Porto_Acre",
                    "America/Porto_Velho",
                    "America/Puerto_Rico",
                    "America/Punta_Arenas",
                    "America/Rainy_River",
                    "America/Rankin_Inlet",
                    "America/Recife",
                    "America/Regina",
                    "America/Resolute",
                    "America/Rio_Branco",
                    "America/Rosario",
                    "America/Santa_Isabel",
                    "America/Santarem",
                    "America/Santiago",
                    "America/Santo_Domingo",
                    "America/Sao_Paulo",
                    "America/Scoresbysund",
                    "America/Shiprock",
                    "America/Sitka",
                    "America/St_Barthelemy",
                    "America/St_Johns",
                    "America/St_Kitts",
                    "America/St_Lucia",
                    "America/St_Thomas",
                    "America/St_Vincent",
                    "America/Swift_Current",
                    "America/Tegucigalpa",
                    "America/Thule",
                    "America/Thunder_Bay",
                    "America/Tijuana",
                    "America/Toronto",
                    "America/Tortola",
                    "America/Vancouver",
                    "America/Virgin",
                    "America/Whitehorse",
                    "America/Winnipeg",
                    "America/Yakutat",
                    "America/Yellowknife",
                    "Antarctica/Casey",
                    "Antarctica/Davis",
                    "Antarctica/DumontDUrville",
                    "Antarctica/Macquarie",
                    "Antarctica/Mawson",
                    "Antarctica/McMurdo",
                    "Antarctica/Palmer",
                    "Antarctica/Rothera",
                    "Antarctica/South_Pole",
                    "Antarctica/Syowa",
                    "Antarctica/Troll",
                    "Antarctica/Vostok",
                    "Arctic/Longyearbyen",
                    "Asia/Aden",
                    "Asia/Almaty",
                    "Asia/Amman",
                    "Asia/Anadyr",
                    "Asia/Aqtau",
                    "Asia/Aqtobe",
                    "Asia/Ashgabat",
                    "Asia/Ashkhabad",
                    "Asia/Atyrau",
                    "Asia/Baghdad",
                    "Asia/Bahrain",
                    "Asia/Baku",
                    "Asia/Bangkok",
                    "Asia/Barnaul",
                    "Asia/Beirut",
                    "Asia/Bishkek",
                    "Asia/Brunei",
                    "Asia/Calcutta",
                    "Asia/Chita",
                    "Asia/Choibalsan",
                    "Asia/Chongqing",
                    "Asia/Chungking",
                    "Asia/Colombo",
                    "Asia/Dacca",
                    "Asia/Damascus",
                    "Asia/Dhaka",
                    "Asia/Dili",
                    "Asia/Dubai",
                    "Asia/Dushanbe",
                    "Asia/Famagusta",
                    "Asia/Gaza",
                    "Asia/Harbin",
                    "Asia/Hebron",
                    "Asia/Ho_Chi_Minh",
                    "Asia/Hong_Kong",
                    "Asia/Hovd",
                    "Asia/Irkutsk",
                    "Asia/Istanbul",
                    "Asia/Jakarta",
                    "Asia/Jayapura",
                    "Asia/Jerusalem",
                    "Asia/Kabul",
                    "Asia/Kamchatka",
                    "Asia/Karachi",
                    "Asia/Kashgar",
                    "Asia/Kathmandu",
                    "Asia/Katmandu",
                    "Asia/Khandyga",
                    "Asia/Kolkata",
                    "Asia/Krasnoyarsk",
                    "Asia/Kuala_Lumpur",
                    "Asia/Kuching",
                    "Asia/Kuwait",
                    "Asia/Macao",
                    "Asia/Macau",
                    "Asia/Magadan",
                    "Asia/Makassar",
                    "Asia/Manila",
                    "Asia/Muscat",
                    "Asia/Nicosia",
                    "Asia/Novokuznetsk",
                    "Asia/Novosibirsk",
                    "Asia/Omsk",
                    "Asia/Oral",
                    "Asia/Phnom_Penh",
                    "Asia/Pontianak",
                    "Asia/Pyongyang",
                    "Asia/Qatar",
                    "Asia/Qostanay",
                    "Asia/Qyzylorda",
                    "Asia/Rangoon",
                    "Asia/Riyadh",
                    "Asia/Saigon",
                    "Asia/Sakhalin",
                    "Asia/Samarkand",
                    "Asia/Seoul",
                    "Asia/Shanghai",
                    "Asia/Singapore",
                    "Asia/Srednekolymsk",
                    "Asia/Taipei",
                    "Asia/Tashkent",
                    "Asia/Tbilisi",
                    "Asia/Tehran",
                    "Asia/Tel_Aviv",
                    "Asia/Thimbu",
                    "Asia/Thimphu",
                    "Asia/Tokyo",
                    "Asia/Tomsk",
                    "Asia/Ujung_Pandang",
                    "Asia/Ulaanbaatar",
                    "Asia/Ulan_Bator",
                    "Asia/Urumqi",
                    "Asia/Ust-Nera",
                    "Asia/Vientiane",
                    "Asia/Vladivostok",
                    "Asia/Yakutsk",
                    "Asia/Yangon",
                    "Asia/Yekaterinburg",
                    "Asia/Yerevan",
                    "Atlantic/Azores",
                    "Atlantic/Bermuda",
                    "Atlantic/Canary",
                    "Atlantic/Cape_Verde",
                    "Atlantic/Faeroe",
                    "Atlantic/Faroe",
                    "Atlantic/Jan_Mayen",
                    "Atlantic/Madeira",
                    "Atlantic/Reykjavik",
                    "Atlantic/South_Georgia",
                    "Atlantic/St_Helena",
                    "Atlantic/Stanley",
                    "Australia/ACT",
                    "Australia/Adelaide",
                    "Australia/Brisbane",
                    "Australia/Broken_Hill",
                    "Australia/Canberra",
                    "Australia/Currie",
                    "Australia/Darwin",
                    "Australia/Eucla",
                    "Australia/Hobart",
                    "Australia/LHI",
                    "Australia/Lindeman",
                    "Australia/Lord_Howe",
                    "Australia/Melbourne",
                    "Australia/NSW",
                    "Australia/North",
                    "Australia/Perth",
                    "Australia/Queensland",
                    "Australia/South",
                    "Australia/Sydney",
                    "Australia/Tasmania",
                    "Australia/Victoria",
                    "Australia/West",
                    "Australia/Yancowinna",
                    "Brazil/Acre",
                    "Brazil/DeNoronha",
                    "Brazil/East",
                    "Brazil/West",
                    "CET",
                    "CST6CDT",
                    "Canada/Atlantic",
                    "Canada/Central",
                    "Canada/Eastern",
                    "Canada/Mountain",
                    "Canada/Newfoundland",
                    "Canada/Pacific",
                    "Canada/Saskatchewan",
                    "Canada/Yukon",
                    "Chile/Continental",
                    "Chile/EasterIsland",
                    "Cuba",
                    "EET",
                    "EST",
                    "EST5EDT",
                    "Egypt",
                    "Eire",
                    "Etc/GMT",
                    "Etc/GMT+0",
                    "Etc/GMT+1",
                    "Etc/GMT+10",
                    "Etc/GMT+11",
                    "Etc/GMT+12",
                    "Etc/GMT+2",
                    "Etc/GMT+3",
                    "Etc/GMT+4",
                    "Etc/GMT+5",
                    "Etc/GMT+6",
                    "Etc/GMT+7",
                    "Etc/GMT+8",
                    "Etc/GMT+9",
                    "Etc/GMT-0",
                    "Etc/GMT-1",
                    "Etc/GMT-10",
                    "Etc/GMT-11",
                    "Etc/GMT-12",
                    "Etc/GMT-13",
                    "Etc/GMT-14",
                    "Etc/GMT-2",
                    "Etc/GMT-3",
                    "Etc/GMT-4",
                    "Etc/GMT-5",
                    "Etc/GMT-6",
                    "Etc/GMT-7",
                    "Etc/GMT-8",
                    "Etc/GMT-9",
                    "Etc/GMT0",
                    "Etc/Greenwich",
                    "Etc/UCT",
                    "Etc/UTC",
                    "Etc/Universal",
                    "Etc/Zulu",
                    "Europe/Amsterdam",
                    "Europe/Andorra",
                    "Europe/Astrakhan",
                    "Europe/Athens",
                    "Europe/Belfast",
                    "Europe/Belgrade",
                    "Europe/Berlin",
                    "Europe/Bratislava",
                    "Europe/Brussels",
                    "Europe/Bucharest",
                    "Europe/Budapest",
                    "Europe/Busingen",
                    "Europe/Chisinau",
                    "Europe/Copenhagen",
                    "Europe/Dublin",
                    "Europe/Gibraltar",
                    "Europe/Guernsey",
                    "Europe/Helsinki",
                    "Europe/Isle_of_Man",
                    "Europe/Istanbul",
                    "Europe/Jersey",
                    "Europe/Kaliningrad",
                    "Europe/Kiev",
                    "Europe/Kirov",
                    "Europe/Lisbon",
                    "Europe/Ljubljana",
                    "Europe/London",
                    "Europe/Luxembourg",
                    "Europe/Madrid",
                    "Europe/Malta",
                    "Europe/Mariehamn",
                    "Europe/Minsk",
                    "Europe/Monaco",
                    "Europe/Moscow",
                    "Europe/Nicosia",
                    "Europe/Oslo",
                    "Europe/Paris",
                    "Europe/Podgorica",
                    "Europe/Prague",
                    "Europe/Riga",
                    "Europe/Rome",
                    "Europe/Samara",
                    "Europe/San_Marino",
                    "Europe/Sarajevo",
                    "Europe/Saratov",
                    "Europe/Simferopol",
                    "Europe/Skopje",
                    "Europe/Sofia",
                    "Europe/Stockholm",
                    "Europe/Tallinn",
                    "Europe/Tirane",
                    "Europe/Tiraspol",
                    "Europe/Ulyanovsk",
                    "Europe/Uzhgorod",
                    "Europe/Vaduz",
                    "Europe/Vatican",
                    "Europe/Vienna",
                    "Europe/Vilnius",
                    "Europe/Volgograd",
                    "Europe/Warsaw",
                    "Europe/Zagreb",
                    "Europe/Zaporozhye",
                    "Europe/Zurich",
                    "GB",
                    "GB-Eire",
                    "GMT",
                    "GMT+0",
                    "GMT-0",
                    "GMT0",
                    "Greenwich",
                    "HST",
                    "Hongkong",
                    "Iceland",
                    "Indian/Antananarivo",
                    "Indian/Chagos",
                    "Indian/Christmas",
                    "Indian/Cocos",
                    "Indian/Comoro",
                    "Indian/Kerguelen",
                    "Indian/Mahe",
                    "Indian/Maldives",
                    "Indian/Mauritius",
                    "Indian/Mayotte",
                    "Indian/Reunion",
                    "Iran",
                    "Israel",
                    "Jamaica",
                    "Japan",
                    "Kwajalein",
                    "Libya",
                    "MET",
                    "MST",
                    "MST7MDT",
                    "Mexico/BajaNorte",
                    "Mexico/BajaSur",
                    "Mexico/General",
                    "NZ",
                    "NZ-CHAT",
                    "Navajo",
                    "PRC",
                    "PST8PDT",
                    "Pacific/Apia",
                    "Pacific/Auckland",
                    "Pacific/Bougainville",
                    "Pacific/Chatham",
                    "Pacific/Chuuk",
                    "Pacific/Easter",
                    "Pacific/Efate",
                    "Pacific/Enderbury",
                    "Pacific/Fakaofo",
                    "Pacific/Fiji",
                    "Pacific/Funafuti",
                    "Pacific/Galapagos",
                    "Pacific/Gambier",
                    "Pacific/Guadalcanal",
                    "Pacific/Guam",
                    "Pacific/Honolulu",
                    "Pacific/Johnston",
                    "Pacific/Kiritimati",
                    "Pacific/Kosrae",
                    "Pacific/Kwajalein",
                    "Pacific/Majuro",
                    "Pacific/Marquesas",
                    "Pacific/Midway",
                    "Pacific/Nauru",
                    "Pacific/Niue",
                    "Pacific/Norfolk",
                    "Pacific/Noumea",
                    "Pacific/Pago_Pago",
                    "Pacific/Palau",
                    "Pacific/Pitcairn",
                    "Pacific/Pohnpei",
                    "Pacific/Ponape",
                    "Pacific/Port_Moresby",
                    "Pacific/Rarotonga",
                    "Pacific/Saipan",
                    "Pacific/Samoa",
                    "Pacific/Tahiti",
                    "Pacific/Tarawa",
                    "Pacific/Tongatapu",
                    "Pacific/Truk",
                    "Pacific/Wake",
                    "Pacific/Wallis",
                    "Pacific/Yap",
                    "Poland",
                    "Portugal",
                    "ROC",
                    "ROK",
                    "Singapore",
                    "Turkey",
                    "UCT",
                    "US/Alaska",
                    "US/Aleutian",
                    "US/Arizona",
                    "US/Central",
                    "US/East-Indiana",
                    "US/Eastern",
                    "US/Hawaii",
                    "US/Indiana-Starke",
                    "US/Michigan",
                    "US/Mountain",
                    "US/Pacific",
                    "US/Pacific-New",
                    "US/Samoa",
                    "UTC",
                    "Universal",
                    "W-SU",
                    "WET",
                    "Zulu"
                ];
                return timezoneOptionArr;
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('beforeUnload', fnCopyService1);

    /** @ngInject */
    function fnCopyService1($rootScope, $window) {

        $window.onbeforeunload = function () {
            var confirmation = {};
            var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
            if (event.defaultPrevented) {
                return confirmation.message;
            }
        };

        $window.onunload = function () {
            $rootScope.$broadcast('onUnload');
        };

        return fnCopyService1;
    }
})();


/**
 * Created by WebOsmotic on 12/5/2017.
 */
(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('TabHeight', fnTabHeight);

    /** @ngInject */
    function fnTabHeight() {

        return {
            fnSet: function () {
                if (angular.isDefined(angular.element(".content-container")[0])) {
                    var total = angular.element(".content-container")[0].offsetHeight;
                    var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                    var footer = angular.isDefined(angular.element(".tab-container .content-footer")[0]) ? angular.element(".tab-container .content-footer")[0].offsetHeight : 0; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                    var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                    var finalHeight = total - (tabHeader + footer + dashboardHeader);
                    angular.element(".tabContent").css('height', finalHeight + 'px');
                }
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('SortIconService', fnSortIconService);

    /** @ngInject */
    function fnSortIconService() {

        return {
            fnGetSortIcon : function (isSortingEnabled, sortType, sortReverse, type) {
                if(isSortingEnabled && sortType === type) {
                    if(sortReverse) {
                        return 'fa-sort-desc';
                    } else {
                        return 'fa-sort-asc';
                    }
                } else {
                    return 'fa-sort';
                }
            }
        }
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('SchemaService', fnSchemaService);

    function fnSchemaService() {
        return {
            convertJsonToSchema : function (typeObj) {
                var typePropertiesArr = [];
                Object.keys(typeObj).forEach(function (key) {
                    var outPutObj = {
                        name : key
                    };
                    var mainStr = typeObj[key];
                    var regArrStr, strArr, strArr1, boolArr, numArr, reqArr, defArr, minArr, maxArr, pecArr, itemArr = null;

                    if (mainStr.indexOf('String') > -1) {
                        var str = mainStr.substring(mainStr.indexOf("String"));
                        strArr = str.substring(str.indexOf("String"), 6);
                        outPutObj.type = strArr;
                    }
                    if (mainStr.indexOf('Boolean') > -1) {
                        var bool = mainStr.substring(mainStr.indexOf("Boolean"));
                        boolArr = bool.substring(bool.indexOf("Boolean"), 7);
                        outPutObj.type = boolArr;
                    }

                    if (mainStr.indexOf('Number') > -1) {
                        var num = mainStr.substring(mainStr.indexOf("Number"));
                        numArr = num.substring(num.indexOf("Number"), 6);
                        outPutObj.type = numArr;
                    }
                    if (mainStr.indexOf('Array') > -1) {
                        var str1 = mainStr.substring(mainStr.indexOf("Array"));
                        strArr1 = str1.substring(str1.indexOf("Array"), 5);
                        outPutObj.type = strArr1;
                    }
                    if (mainStr.indexOf('required') > -1) {
                        var req = mainStr.substring(mainStr.indexOf("required"));
                        reqArr = req.substring(req.indexOf("required"),req.indexOf(")") +1);
                        outPutObj.required = reqArr.substring(reqArr.indexOf("required(") + 9,reqArr.indexOf(")"));
                    }
                    if (mainStr.indexOf('default') > -1) {
                        var def = mainStr.substring(mainStr.indexOf("default"));
                        defArr = def.substring(def.indexOf("default"), def.indexOf(")") +1);
                        if(!isNaN(defArr.substring(defArr.indexOf("default(") + 8, defArr.indexOf(")")))) {
                            outPutObj.default = parseInt(defArr.substring(defArr.indexOf("default(") + 8, defArr.indexOf(")")));
                        } else {
                            var temp = defArr.substring(defArr.indexOf("default(") + 8, defArr.indexOf(")"));
                            if (outPutObj.type === 'Boolean') {
                                outPutObj.default = (temp === 'true');
                            } else {
                                outPutObj.default = temp;
                            }
                        }
                    }

                    if (mainStr.indexOf('min') > -1) {
                        var min = mainStr.substring(mainStr.indexOf("min"));
                        minArr = min.substring(min.indexOf("min"), min.indexOf(")") +1);
                        outPutObj.min = parseInt(minArr.substring(minArr.indexOf("min(") + 4, minArr.indexOf(")")));
                    }

                    if (mainStr.indexOf('max') > -1) {
                        var max = mainStr.substring(mainStr.indexOf("max"));
                        maxArr = max.substring(max.indexOf("max"), max.indexOf(")") +1);
                        outPutObj.max = parseInt(maxArr.substring(maxArr.indexOf("max(") + 4, maxArr.indexOf(")")));
                    }
                    if (mainStr.indexOf('precision') > -1) {
                        var pec = mainStr.substring(mainStr.indexOf("precision"));
                        pecArr = pec.substring(pec.indexOf("precision"), pec.indexOf(")") +1);
                        outPutObj.precision = pecArr.substring(pecArr.indexOf("precision(") + 10, pecArr.indexOf(")"));
                    }
                    if (mainStr.indexOf('item') > -1) {
                        var item = mainStr.substring(mainStr.indexOf("item"));
                        itemArr = item.substring(item.indexOf("item"), item.indexOf(")") +1);
                        outPutObj.item = (itemArr.substring(itemArr.indexOf("item(") + 5, itemArr.indexOf(")")));
                    }else{
                        if (mainStr.indexOf('Array') > -1) {
                            outPutObj.item ='';
                        }
                    }
                    if (mainStr.indexOf('regex') > -1) {
                        var regArr;
                        if (strArr !== null) {
                            regArr = mainStr.replace(strArr, "");
                        }
                        if (boolArr !== null) {
                            regArr = regArr.replace(boolArr, "");
                        }
                        if (numArr !== null) {
                            regArr = regArr.replace(numArr, "");
                        }
                        if (reqArr !== null) {
                            regArr = regArr.replace(reqArr, "");
                        }
                        if (defArr !== null) {
                            regArr = regArr.replace(defArr, "");
                        }
                        if (minArr !== null) {
                            regArr = regArr.replace(minArr, "");
                        }
                        if (maxArr !== null) {
                            regArr = regArr.replace(maxArr, "");
                        }
                        if (pecArr !== null) {
                            regArr = regArr.replace(pecArr, "");
                        }
                        if (itemArr !== null) {
                            regArr = regArr.replace(itemArr, "");
                        }
                        if (strArr1 !== null) {
                            regArr = regArr.replace(strArr1, "");
                        }
                        regArrStr = regArr.substring(regArr.indexOf("regex"), regArr.lastIndexOf(")") +1);
                        outPutObj.regex = regArrStr.substring(regArrStr.indexOf("regex(") + 6, regArrStr.lastIndexOf(")"));
                    }
                    typePropertiesArr.push(outPutObj);
                });
                return typePropertiesArr;
            }
        };
    }

})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('recipesService', recipesService);

    /** @ngInject */
    function recipesService($q, DB, GroupFactory, RoleFactory, FederationsFactory) {
        var deleteCount = 0;
        var tempObj = {};
        var loginUser = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
        recipesService.fnInitRecipes = function (count, recipesArr, idObj) {
            var defer = $q.defer();
            if(!idObj) {
                tempObj = {};
            } else {
                tempObj = angular.copy(idObj);
            }
            saveData(defer, count, recipesArr);
            return defer.promise;
        };

        function saveData(defer, count, recipesArr) {
            var inputObj = {};
            if (recipesArr[count].name === 'Create Group') {
                inputObj = {
                    body: {
                        name: 'ECSite Support Group',
                        description: 'ECSite Support Group'
                    }
                };
                GroupFactory.createGroup(inputObj)
                    .then(function (resObj) {
                        inputObj = {};
                        tempObj.groupId = resObj.id;
                        defer.resolve({
                            idObj : tempObj
                        })
                    }, function () {
                        defer.reject({
                            idObj : tempObj
                        });
                    });
            } else if (recipesArr[count].name === 'Create Role') {
                inputObj = {
                    body: {
                        "name": "ECSite Support Role",
                        "description": "ECSite Support Role",
                        "statements": [
                            {
                                "effect": "ALLOW",
                                "actions": ["*"]
                            }
                        ]
                    }
                };
                RoleFactory.createRole(inputObj)
                    .then(function (resObj) {
                        inputObj = {};
                        tempObj.roleId = resObj.id;
                        defer.resolve({
                            idObj : tempObj
                        })
                    }, function () {
                        defer.reject({
                            idObj : tempObj
                        });
                    })
            } else if (recipesArr[count].name === 'Add Role to Group') {
                inputObj = {
                    groupId: tempObj.groupId,
                    roleId: tempObj.roleId
                };
                RoleFactory.addRoleToGroup(inputObj)
                    .then(function () {
                        inputObj = {};
                        defer.resolve({
                            idObj : tempObj
                        })
                    }, function () {
                        defer.reject({
                            idObj : tempObj
                        });
                    })
            } else if (recipesArr[count].name === 'Create Federation') {
                var accId = loginUser ? loginUser.id.split("-")[0] : '';
                inputObj = {
                    body: {
                        alias: "ECSite Support " + accId,
                        description: "ECSite Support",
                        type: "INBOUND"
                    },
                    accountId: "cu000000"
                };
                FederationsFactory.createFederation(inputObj)
                    .then(function (resObj) {
                        inputObj = {};
                        tempObj.federationId = resObj.id;
                        defer.resolve({
                            idObj : tempObj
                        })
                    }, function () {
                        defer.reject({
                            idObj : tempObj
                        });
                    })
            } else if (recipesArr[count].name === 'Add Group to Federation') {
                inputObj = {
                    federationId: tempObj.federationId,
                    groupId: tempObj.groupId
                };
                FederationsFactory.addGroupToFederation(inputObj)
                    .then(function () {
                        inputObj = {};
                        defer.resolve({
                            idObj : tempObj
                        })
                    }, function () {
                        defer.reject({
                            idObj : tempObj
                        });
                    })
            }
        }

        recipesService.deleteSaveData = function(idObj) {
            var defer = $q.defer();
            deleteCount = 0;
            tempObj = idObj;
            if (Object.keys(tempObj).length) {
                deleteData(defer);
                return defer.promise;
            } else {
                defer.resolve();
            }
        };

        function deleteData(defer) {
            var inputObj = {};
            if (Object.keys(tempObj).length && deleteCount < Object.keys(tempObj).length) {
                if (Object.keys(tempObj)[deleteCount] === 'groupId') {
                    inputObj = {
                        groupId: tempObj[Object.keys(tempObj)[deleteCount]]
                    };
                    GroupFactory.deleteGroup(inputObj)
                        .then(function () {
                            inputObj = {};
                            deleteCount++;
                            deleteData(defer);
                        }, function (error) {
                            if(error){
                                deleteCount++;
                                deleteData(defer);
                            }
                        });
                } if (Object.keys(tempObj)[deleteCount] === 'roleId') {
                    inputObj = {
                        roleId: tempObj[Object.keys(tempObj)[deleteCount]]
                    };
                    RoleFactory.deleteRole(inputObj)
                        .then(function () {
                            inputObj = {};
                            deleteCount++;
                            deleteData(defer);
                        }, function (error) {
                            if(error){
                                deleteCount++;
                                deleteData(defer);
                            }
                        })
                } if (Object.keys(tempObj)[deleteCount] === 'federationId') {
                    inputObj = {
                        federationId: tempObj[Object.keys(tempObj)[deleteCount]]
                    };
                    FederationsFactory.deleteFederation(inputObj)
                        .then(function () {
                            inputObj = {};
                            deleteCount++;
                            deleteData(defer);
                        }, function (error) {
                            if(error){
                                deleteCount++;
                                deleteData(defer);
                            }
                        })
                }
            } else {
                deleteCount = 0;
                defer.resolve();
            }
        }

        return recipesService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('ProjectHealthService', fnProjectHealthService);

    /** @ngInject */
    function fnProjectHealthService(NodeProjectFactory, amaran, $base64, DB, ColorService, nodeProjectHealthArr) {
        var projectRelationships = {};
        var healthArr = [];
        var healthObj = {};
        var newHealthArr = [];

        function fnGenerateHealthData(projectObj) {
            if (projectObj.children && projectObj.children.length) {
                _.forEach(projectObj.children, function (projectChildrenObj) {
                    var tempHealth = healthObj[projectChildrenObj.node.id] ? healthObj[projectChildrenObj.node.id] : [];
                    projectChildrenObj.healths = tempHealth;
                    if (tempHealth && tempHealth.length) {
                        _.forEach(projectObj.healths, function (healthObj) {
                            var isFind = _.find(tempHealth, {value: healthObj.value});
                            if (!isFind) {
                                projectChildrenObj.healths.push(healthObj);
                            }
                        })
                    } else {
                        projectChildrenObj.healths = projectObj.healths;
                    }
                    var tempHealthObj = {};
                    _.forEach(projectChildrenObj.healths, function (healthObj) {
                        tempHealthObj = {}
                        tempHealthObj.id = healthObj.id;
                        tempHealthObj.color = healthObj.color;
                        tempHealthObj.name = healthObj.name;
                        tempHealthObj.value = healthObj.value;
                        tempHealthObj.projectId = projectChildrenObj.node.id;
                        newHealthArr.push(tempHealthObj)
                    })
                    if (projectChildrenObj.children && projectChildrenObj.children.length) {
                        fnGenerateHealthData(projectChildrenObj);
                    }
                })
            }
        }

        return {
            fnSetProjectRelationshipHealthArr: function (rootProjectId) {
                healthArr = [];
                healthObj = {};
                newHealthArr = [];
                var inputObj = {
                    projectId: rootProjectId
                };
                NodeProjectFactory.describeProjectRelationships(inputObj)
                    .then(function (response) {
                        healthArr = DB.fnGet("healthArray");
                        healthObj = _.groupBy(healthArr, 'projectId');
                        projectRelationships = _.cloneDeepWith(response);
                        projectRelationships.downstreamProjectsTree.healths = healthObj[projectRelationships.downstreamProjectsTree.node.id] ? healthObj[projectRelationships.downstreamProjectsTree.node.id] : [];
                        var tempHealthObj = {};
                        _.forEach(projectRelationships.downstreamProjectsTree.healths, function (healthObj) {
                            tempHealthObj = {}
                            tempHealthObj.id = healthObj.id;
                            tempHealthObj.color = healthObj.color;
                            tempHealthObj.name = healthObj.name;
                            tempHealthObj.value = healthObj.value;
                            tempHealthObj.projectId = projectRelationships.downstreamProjectsTree.node.id;
                            newHealthArr.push(tempHealthObj)
                        })
                        fnGenerateHealthData(projectRelationships.downstreamProjectsTree);
                        localStorage.setItem(nodeProjectHealthArr, $base64.encode(angular.toJson(newHealthArr)));
                        ColorService.setHealthObj(newHealthArr);
                    }, function () {

                    })
                return [];
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('PermissionsService', fnPermissionsService);

    /** @ngInject */
    function fnPermissionsService(DB) {

        //Get all permission form local storage which store from API call response
        var userPermissionsObj = DB.fnGet('userPermissions');
        var loginUserObj = DB.fnGet('loginUser');
        var accountId = '';
        var v4PermissionsJson = {
            "access": {
                "accountOwner": {
                    "REQUEST_NEW_SUPPORT_SESSION": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT_STATE": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DELETE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "REPLACE_ACCOUNT_TAGS": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT_STATE": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "REQUEST_WHITELIST_VALIDATION": {
                        "isAccess": true
                    },
                    "CREATE_USER": {
                        "isAccess": true
                    },
                    "DESCRIBE_USER": {
                        "isAccess": true
                    },
                    "UPDATE_USER": {
                        "isAccess": true
                    },
                    "UPDATE_USER_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_ADMINISTRATOR": {
                        "isAccess": true
                    },
                    "UPDATE_USER_BILLING_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_TRACKER_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_NODE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_STORAGE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PIPELINE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_AI_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_INSIGHT_ROLE": {
                        "isAccess": true
                    },
                    "DELETE_USER": {
                        "isAccess": true
                    },
                    "REPLACE_USER_TAGS": {
                        "isAccess": true
                    },
                    "REQUEST_UNCONFIRMED_USER_ACTIVATION": {
                        "isAccess": true
                    },
                    "CREATE_TEAM": {
                        "isAccess": true
                    },
                    "UPDATE_TEAM": {
                        "isAccess": true
                    },
                    "DESCRIBE_TEAM": {
                        "isAccess": true
                    },
                    "DELETE_TEAM": {
                        "isAccess": true
                    },
                    "REPLACE_TEAM_TAGS": {
                        "isAccess": true
                    },
                    "ADD_USER_TO_TEAM": {
                        "isAccess": true
                    },
                    "REMOVE_USER_FROM_TEAM": {
                        "isAccess": true
                    },
                    "ADD_RESOURCE_TO_TEAM": {
                        "isAccess": true
                    },
                    "REMOVE_RESOURCE_FROM_TEAM": {
                        "isAccess": true
                    },
                    "DESCRIBE_AUTHENTICATOR_TYPE": {
                        "isAccess": true
                    },
                    "CREATE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "UPDATE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "DESCRIBE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "DELETE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "REPLACE_AUTHENTICATOR_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_VAULT": {
                        "isAccess": true
                    },
                    "UPDATE_VAULT": {
                        "isAccess": true
                    },
                    "DESCRIBE_VAULT": {
                        "isAccess": true
                    },
                    "DELETE_VAULT": {
                        "isAccess": true
                    },
                    "REPLACE_VAULT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_VAULT_CONTENT": {
                        "isAccess": true
                    },
                    "REPLACE_VAULT_CONTENT": {
                        "isAccess": true
                    },
                    "CREATE_FEDERATION": {
                        "isAccess": true
                    },
                    "UPDATE_FEDERATION": {
                        "isAccess": true
                    },
                    "DESCRIBE_FEDERATION": {
                        "isAccess": true
                    },
                    "DELETE_FEDERATION": {
                        "isAccess": true
                    },
                    "REPLACE_FEDERATION_TAGS": {
                        "isAccess": true
                    },
                    "UPDATE_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "DESCRIBE_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "ENABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": true
                    },
                    "DISABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": true
                    },
                    "REQUEST_NEW_FEDERATION_SESSION": {
                        "isAccess": true
                    },
                    "DELETE_EXISTING_SESSION": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_SESSION": {
                        "isAccess": false
                    },
                    "CREATE_API_KEY": {
                        "isAccess": true
                    },
                    "LIST_API_KEYS": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_API_KEY": {
                        "isAccess": true
                    },
                    "DELETE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "DESCRIBE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "VALIDATE_SAML_RESPONSE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_PASSWORD": {
                        "isAccess": false
                    },
                    "REQUEST_PASSWORD_RESET": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_USER": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_EMAIL": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_ACCOUNT": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_PASSWORD": {
                        "isAccess": false
                    },
                    "ENABLE_USER_MFA": {
                        "isAccess": false
                    },
                    "DISABLE_USER_MFA": {
                        "isAccess": false
                    }
                },
                "administrator": {
                    "REQUEST_NEW_SUPPORT_SESSION": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT_STATE": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DELETE_ACCOUNT": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "REPLACE_ACCOUNT_TAGS": {
                        "isAccess": true,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT_STATE": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "REQUEST_WHITELIST_VALIDATION": {
                        "isAccess": true
                    },
                    "CREATE_USER": {
                        "isAccess": true
                    },
                    "DESCRIBE_USER": {
                        "isAccess": true
                    },
                    "UPDATE_USER": {
                        "isAccess": true
                    },
                    "UPDATE_USER_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_ADMINISTRATOR": {
                        "isAccess": true
                    },
                    "UPDATE_USER_BILLING_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_TRACKER_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_NODE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_STORAGE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PIPELINE_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_AI_ROLE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_INSIGHT_ROLE": {
                        "isAccess": true
                    },
                    "DELETE_USER": {
                        "isAccess": true
                    },
                    "REPLACE_USER_TAGS": {
                        "isAccess": true
                    },
                    "REQUEST_UNCONFIRMED_USER_ACTIVATION": {
                        "isAccess": true
                    },
                    "CREATE_TEAM": {
                        "isAccess": true
                    },
                    "UPDATE_TEAM": {
                        "isAccess": true
                    },
                    "DESCRIBE_TEAM": {
                        "isAccess": true
                    },
                    "DELETE_TEAM": {
                        "isAccess": true
                    },
                    "REPLACE_TEAM_TAGS": {
                        "isAccess": true
                    },
                    "ADD_USER_TO_TEAM": {
                        "isAccess": true
                    },
                    "REMOVE_USER_FROM_TEAM": {
                        "isAccess": true
                    },
                    "ADD_RESOURCE_TO_TEAM": {
                        "isAccess": true
                    },
                    "REMOVE_RESOURCE_FROM_TEAM": {
                        "isAccess": true
                    },
                    "DESCRIBE_AUTHENTICATOR_TYPE": {
                        "isAccess": true
                    },
                    "CREATE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "UPDATE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "DESCRIBE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "DELETE_AUTHENTICATOR": {
                        "isAccess": true
                    },
                    "REPLACE_AUTHENTICATOR_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_VAULT": {
                        "isAccess": true
                    },
                    "UPDATE_VAULT": {
                        "isAccess": true
                    },
                    "DESCRIBE_VAULT": {
                        "isAccess": true
                    },
                    "DELETE_VAULT": {
                        "isAccess": true
                    },
                    "REPLACE_VAULT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_VAULT_CONTENT": {
                        "isAccess": true
                    },
                    "REPLACE_VAULT_CONTENT": {
                        "isAccess": true
                    },
                    "CREATE_FEDERATION": {
                        "isAccess": true
                    },
                    "UPDATE_FEDERATION": {
                        "isAccess": true
                    },
                    "DESCRIBE_FEDERATION": {
                        "isAccess": true
                    },
                    "DELETE_FEDERATION": {
                        "isAccess": true
                    },
                    "REPLACE_FEDERATION_TAGS": {
                        "isAccess": true
                    },
                    "UPDATE_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "DESCRIBE_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_FEDERATION_SCRIPT": {
                        "isAccess": true
                    },
                    "ENABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": true
                    },
                    "DISABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": true
                    },
                    "REQUEST_NEW_FEDERATION_SESSION": {
                        "isAccess": true
                    },
                    "DELETE_EXISTING_SESSION": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_SESSION": {
                        "isAccess": false
                    },
                    "CREATE_API_KEY": {
                        "isAccess": true
                    },
                    "LIST_API_KEYS": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_API_KEY": {
                        "isAccess": true
                    },
                    "DELETE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "DESCRIBE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "VALIDATE_SAML_RESPONSE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_PASSWORD": {
                        "isAccess": false
                    },
                    "REQUEST_PASSWORD_RESET": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_USER": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_EMAIL": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_ACCOUNT": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_PASSWORD": {
                        "isAccess": false
                    },
                    "ENABLE_USER_MFA": {
                        "isAccess": false
                    },
                    "DISABLE_USER_MFA": {
                        "isAccess": false
                    }
                },
                "self": {
                    "REQUEST_NEW_SUPPORT_SESSION": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT_STATE": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DELETE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "REPLACE_ACCOUNT_TAGS": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT_STATE": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "REQUEST_WHITELIST_VALIDATION": {
                        "isAccess": false
                    },
                    "CREATE_USER": {
                        "isAccess": false
                    },
                    "DESCRIBE_USER": {
                        "isAccess": false
                    },
                    "UPDATE_USER": {
                        "isAccess": false
                    },
                    "UPDATE_USER_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_ADMINISTRATOR": {
                        "isAccess": false
                    },
                    "UPDATE_USER_BILLING_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_TRACKER_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_NODE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_STORAGE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_PIPELINE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_AI_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_INSIGHT_ROLE": {
                        "isAccess": false
                    },
                    "DELETE_USER": {
                        "isAccess": false
                    },
                    "REPLACE_USER_TAGS": {
                        "isAccess": false
                    },
                    "REQUEST_UNCONFIRMED_USER_ACTIVATION": {
                        "isAccess": false
                    },
                    "CREATE_TEAM": {
                        "isAccess": false
                    },
                    "UPDATE_TEAM": {
                        "isAccess": false
                    },
                    "DESCRIBE_TEAM": {
                        "isAccess": false
                    },
                    "DELETE_TEAM": {
                        "isAccess": false
                    },
                    "REPLACE_TEAM_TAGS": {
                        "isAccess": false
                    },
                    "ADD_USER_TO_TEAM": {
                        "isAccess": false
                    },
                    "REMOVE_USER_FROM_TEAM": {
                        "isAccess": false
                    },
                    "ADD_RESOURCE_TO_TEAM": {
                        "isAccess": false
                    },
                    "REMOVE_RESOURCE_FROM_TEAM": {
                        "isAccess": false
                    },
                    "DESCRIBE_AUTHENTICATOR_TYPE": {
                        "isAccess": false
                    },
                    "CREATE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "UPDATE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "DESCRIBE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "DELETE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "REPLACE_AUTHENTICATOR_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_VAULT": {
                        "isAccess": false
                    },
                    "UPDATE_VAULT": {
                        "isAccess": false
                    },
                    "DESCRIBE_VAULT": {
                        "isAccess": false
                    },
                    "DELETE_VAULT": {
                        "isAccess": false
                    },
                    "REPLACE_VAULT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_VAULT_CONTENT": {
                        "isAccess": false
                    },
                    "REPLACE_VAULT_CONTENT": {
                        "isAccess": false
                    },
                    "CREATE_FEDERATION": {
                        "isAccess": false
                    },
                    "UPDATE_FEDERATION": {
                        "isAccess": false
                    },
                    "DESCRIBE_FEDERATION": {
                        "isAccess": false
                    },
                    "DELETE_FEDERATION": {
                        "isAccess": false
                    },
                    "REPLACE_FEDERATION_TAGS": {
                        "isAccess": false
                    },
                    "UPDATE_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "DESCRIBE_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "ENABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": false
                    },
                    "DISABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_FEDERATION_SESSION": {
                        "isAccess": false
                    },
                    "DELETE_EXISTING_SESSION": {
                        "isAccess": true
                    },
                    "REQUEST_NEW_SESSION": {
                        "isAccess": true
                    },
                    "CREATE_API_KEY": {
                        "isAccess": true
                    },
                    "LIST_API_KEYS": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_API_KEY": {
                        "isAccess": true
                    },
                    "DELETE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PROFILE": {
                        "isAccess": true
                    },
                    "DESCRIBE_USER_PROFILE": {
                        "isAccess": true
                    },
                    "VALIDATE_SAML_RESPONSE": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PASSWORD": {
                        "isAccess": true
                    },
                    "REQUEST_PASSWORD_RESET": {
                        "isAccess": true
                    },
                    "VALIDATE_NEW_USER": {
                        "isAccess": true
                    },
                    "VALIDATE_NEW_EMAIL": {
                        "isAccess": true
                    },
                    "VALIDATE_NEW_ACCOUNT": {
                        "isAccess": true
                    },
                    "VALIDATE_NEW_PASSWORD": {
                        "isAccess": true
                    },
                    "ENABLE_USER_MFA": {
                        "isAccess": true
                    },
                    "DISABLE_USER_MFA": {
                        "isAccess": true
                    }
                },
                "teamMember": {
                    "REQUEST_NEW_SUPPORT_SESSION": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "UPDATE_ACCOUNT_STATE": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DELETE_ACCOUNT": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "REPLACE_ACCOUNT_TAGS": {
                        "isAccess": false,
                        "isPredictiveOnly": true
                    },
                    "DESCRIBE_ACCOUNT_STATE": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "REQUEST_WHITELIST_VALIDATION": {
                        "isAccess": false
                    },
                    "CREATE_USER": {
                        "isAccess": false
                    },
                    "DESCRIBE_USER": {
                        "isAccess": false
                    },
                    "UPDATE_USER": {
                        "isAccess": false
                    },
                    "UPDATE_USER_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_ADMINISTRATOR": {
                        "isAccess": false
                    },
                    "UPDATE_USER_BILLING_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_TRACKER_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_NODE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_STORAGE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_PIPELINE_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_AI_ROLE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_INSIGHT_ROLE": {
                        "isAccess": false
                    },
                    "DELETE_USER": {
                        "isAccess": false
                    },
                    "REPLACE_USER_TAGS": {
                        "isAccess": false
                    },
                    "REQUEST_UNCONFIRMED_USER_ACTIVATION": {
                        "isAccess": false
                    },
                    "CREATE_TEAM": {
                        "isAccess": false
                    },
                    "UPDATE_TEAM": {
                        "isAccess": false
                    },
                    "DESCRIBE_TEAM": {
                        "isAccess": false
                    },
                    "DELETE_TEAM": {
                        "isAccess": false
                    },
                    "REPLACE_TEAM_TAGS": {
                        "isAccess": false
                    },
                    "ADD_USER_TO_TEAM": {
                        "isAccess": false
                    },
                    "REMOVE_USER_FROM_TEAM": {
                        "isAccess": false
                    },
                    "ADD_RESOURCE_TO_TEAM": {
                        "isAccess": false
                    },
                    "REMOVE_RESOURCE_FROM_TEAM": {
                        "isAccess": false
                    },
                    "DESCRIBE_AUTHENTICATOR_TYPE": {
                        "isAccess": false
                    },
                    "CREATE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "UPDATE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "DESCRIBE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "DELETE_AUTHENTICATOR": {
                        "isAccess": false
                    },
                    "REPLACE_AUTHENTICATOR_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_VAULT": {
                        "isAccess": false
                    },
                    "UPDATE_VAULT": {
                        "isAccess": false
                    },
                    "DESCRIBE_VAULT": {
                        "isAccess": false
                    },
                    "DELETE_VAULT": {
                        "isAccess": false
                    },
                    "REPLACE_VAULT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_VAULT_CONTENT": {
                        "isAccess": false
                    },
                    "REPLACE_VAULT_CONTENT": {
                        "isAccess": false
                    },
                    "CREATE_FEDERATION": {
                        "isAccess": false
                    },
                    "UPDATE_FEDERATION": {
                        "isAccess": false
                    },
                    "DESCRIBE_FEDERATION": {
                        "isAccess": false
                    },
                    "DELETE_FEDERATION": {
                        "isAccess": false
                    },
                    "REPLACE_FEDERATION_TAGS": {
                        "isAccess": false
                    },
                    "UPDATE_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "DESCRIBE_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_FEDERATION_SCRIPT": {
                        "isAccess": false
                    },
                    "ENABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": false
                    },
                    "DISABLE_ACCOUNT_SUPPORT_ACCESS": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_FEDERATION_SESSION": {
                        "isAccess": true
                    },
                    "DELETE_EXISTING_SESSION": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_SESSION": {
                        "isAccess": false
                    },
                    "CREATE_API_KEY": {
                        "isAccess": true
                    },
                    "LIST_API_KEYS": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_API_KEY_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_API_KEY": {
                        "isAccess": true
                    },
                    "DELETE_API_KEY": {
                        "isAccess": true
                    },
                    "UPDATE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "DESCRIBE_USER_PROFILE": {
                        "isAccess": false
                    },
                    "VALIDATE_SAML_RESPONSE": {
                        "isAccess": false
                    },
                    "UPDATE_USER_PASSWORD": {
                        "isAccess": false
                    },
                    "REQUEST_PASSWORD_RESET": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_USER": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_EMAIL": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_ACCOUNT": {
                        "isAccess": false
                    },
                    "VALIDATE_NEW_PASSWORD": {
                        "isAccess": false
                    },
                    "ENABLE_USER_MFA": {
                        "isAccess": false
                    },
                    "DISABLE_USER_MFA": {
                        "isAccess": false
                    }
                }
            },
            "billing": {
                "accountOwner": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "DESCRIBE_BUSINESS_DETAILS": {
                        "isAccess": true
                    },
                    "UPDATE_BUSINESS_DETAILS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PLAN": {
                        "isAccess": true
                    },
                    "ACTIVATE_PLAN_APPLICATION": {
                        "isAccess": true
                    },
                    "ACTIVATE_PLAN_SUPPORT": {
                        "isAccess": true
                    },
                    "DEACTIVATE_PLAN_SUPPORT": {
                        "isAccess": true
                    },
                    "UPDATE_PLAN_AI_FUNCTION_COUNT": {
                        "isAccess": true
                    },
                    "QUOTE_PREPAY": {
                        "isAccess": true
                    },
                    "ORDER_PREPAY": {
                        "isAccess": true
                    },
                    "CONFIRM_PREPAY": {
                        "isAccess": true
                    },
                    "DESCRIBE_PREPAY": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "DESCRIBE_CART": {
                        "isAccess": true
                    },
                    "CLAIM_UNCLAIMED_CREDIT_TOKEN": {
                        "isAccess": true
                    },
                    "DESCRIBE_CLAIMED_CREDIT_TOKEN": {
                        "isAccess": true
                    },
                    "DESCRIBE_DISCOUNT": {
                        "isAccess": true
                    },
                    "DESCRIBE_INVOICE": {
                        "isAccess": true
                    },
                    "DOWNLOAD_INVOICE_PDF": {
                        "isAccess": true
                    },
                    "PAY_INVOICE": {
                        "isAccess": true
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "DELETE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "REQUEST_NEW_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "ACTIVATE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "SET_DEFAULT_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "DESCRIBE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "UPDATE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DESCRIBE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DELETE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "SEND_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "UPDATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DELETE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    }
                },
                "administrator": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": false
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": false
                    },
                    "CHECKOUT_CART": {
                        "isAccess": false
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": false
                    },
                    "DESCRIBE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "UPDATE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PLAN": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_APPLICATION": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "DEACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "UPDATE_PLAN_AI_FUNCTION_COUNT": {
                        "isAccess": false
                    },
                    "QUOTE_PREPAY": {
                        "isAccess": false
                    },
                    "ORDER_PREPAY": {
                        "isAccess": false
                    },
                    "CONFIRM_PREPAY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PREPAY": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "DESCRIBE_CART": {
                        "isAccess": false
                    },
                    "CLAIM_UNCLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_CLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_DISCOUNT": {
                        "isAccess": false
                    },
                    "DESCRIBE_INVOICE": {
                        "isAccess": false
                    },
                    "DOWNLOAD_INVOICE_PDF": {
                        "isAccess": false
                    },
                    "PAY_INVOICE": {
                        "isAccess": false
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DELETE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "ACTIVATE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "SET_DEFAULT_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DESCRIBE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DESCRIBE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "SEND_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    }
                },
                "billingRoles_none": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": false
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": false
                    },
                    "CHECKOUT_CART": {
                        "isAccess": false
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": false
                    },
                    "DESCRIBE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "UPDATE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PLAN": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_APPLICATION": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "DEACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "UPDATE_PLAN_AI_FUNCTION_COUNT": {
                        "isAccess": false
                    },
                    "QUOTE_PREPAY": {
                        "isAccess": false
                    },
                    "ORDER_PREPAY": {
                        "isAccess": false
                    },
                    "CONFIRM_PREPAY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PREPAY": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "DESCRIBE_CART": {
                        "isAccess": false
                    },
                    "CLAIM_UNCLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_CLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_DISCOUNT": {
                        "isAccess": false
                    },
                    "DESCRIBE_INVOICE": {
                        "isAccess": false
                    },
                    "DOWNLOAD_INVOICE_PDF": {
                        "isAccess": false
                    },
                    "PAY_INVOICE": {
                        "isAccess": false
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DELETE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "ACTIVATE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "SET_DEFAULT_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DESCRIBE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DESCRIBE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "SEND_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    }
                },
                "billingRoles_manager": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "DESCRIBE_BUSINESS_DETAILS": {
                        "isAccess": true
                    },
                    "UPDATE_BUSINESS_DETAILS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PLAN": {
                        "isAccess": true
                    },
                    "ACTIVATE_PLAN_APPLICATION": {
                        "isAccess": true
                    },
                    "ACTIVATE_PLAN_SUPPORT": {
                        "isAccess": true
                    },
                    "DEACTIVATE_PLAN_SUPPORT": {
                        "isAccess": true
                    },
                    "UPDATE_PLAN_AI_FUNCTION_COUNT": {
                        "isAccess": true
                    },
                    "QUOTE_PREPAY": {
                        "isAccess": true
                    },
                    "ORDER_PREPAY": {
                        "isAccess": true
                    },
                    "CONFIRM_PREPAY": {
                        "isAccess": true
                    },
                    "DESCRIBE_PREPAY": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "DESCRIBE_CART": {
                        "isAccess": true
                    },
                    "CLAIM_UNCLAIMED_CREDIT_TOKEN": {
                        "isAccess": true
                    },
                    "DESCRIBE_CLAIMED_CREDIT_TOKEN": {
                        "isAccess": true
                    },
                    "DESCRIBE_DISCOUNT": {
                        "isAccess": true
                    },
                    "DESCRIBE_INVOICE": {
                        "isAccess": true
                    },
                    "DOWNLOAD_INVOICE_PDF": {
                        "isAccess": true
                    },
                    "PAY_INVOICE": {
                        "isAccess": true
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "DELETE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "REQUEST_NEW_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "ACTIVATE_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "SET_DEFAULT_PAYMENT_METHOD": {
                        "isAccess": true
                    },
                    "DESCRIBE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "UPDATE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DESCRIBE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DELETE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "SEND_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "UPDATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "DELETE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    }
                },
                "nodeRoles_manager": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "DESCRIBE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "UPDATE_BUSINESS_DETAILS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PLAN": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_APPLICATION": {
                        "isAccess": false
                    },
                    "ACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "DEACTIVATE_PLAN_SUPPORT": {
                        "isAccess": false
                    },
                    "UPDATE_PLAN_AI_FUNCTION_COUNT": {
                        "isAccess": false
                    },
                    "QUOTE_PREPAY": {
                        "isAccess": false
                    },
                    "ORDER_PREPAY": {
                        "isAccess": false
                    },
                    "CONFIRM_PREPAY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PREPAY": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "DESCRIBE_CART": {
                        "isAccess": false
                    },
                    "CLAIM_UNCLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_CLAIMED_CREDIT_TOKEN": {
                        "isAccess": false
                    },
                    "DESCRIBE_DISCOUNT": {
                        "isAccess": false
                    },
                    "DESCRIBE_INVOICE": {
                        "isAccess": false
                    },
                    "DOWNLOAD_INVOICE_PDF": {
                        "isAccess": false
                    },
                    "PAY_INVOICE": {
                        "isAccess": false
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DELETE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "REQUEST_NEW_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "ACTIVATE_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "SET_DEFAULT_PAYMENT_METHOD": {
                        "isAccess": false
                    },
                    "DESCRIBE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_PAYMENT_SETTINGS": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DESCRIBE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "SEND_UNCLAIMED_CREDIT_TOKEN": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "UPDATE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "DELETE_DISCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    }
                }
            },
            "tracker": {
                "accountOwner": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "CREATE_LABEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": true
                    },
                    "UPDATE_LABEL": {
                        "isAccess": true
                    },
                    "DELETE_LABEL": {
                        "isAccess": true
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": true
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_STATE": {
                        "isAccess": true
                    },
                    "DELETE_STATE": {
                        "isAccess": true
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_TYPE": {
                        "isAccess": true
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": true
                    },
                    "DELETE_TYPE": {
                        "isAccess": true
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": true
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": true
                    },
                    "CREATE_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": true
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": true
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": true
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": true
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": true
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": true
                    },
                    "ADD_COMMENT": {
                        "isAccess": true
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": true
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": true
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": true
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": true
                    }
                },
                "administrator": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "CREATE_LABEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": true
                    },
                    "UPDATE_LABEL": {
                        "isAccess": true
                    },
                    "DELETE_LABEL": {
                        "isAccess": true
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": true
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_STATE": {
                        "isAccess": true
                    },
                    "DELETE_STATE": {
                        "isAccess": true
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_TYPE": {
                        "isAccess": true
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": true
                    },
                    "DELETE_TYPE": {
                        "isAccess": true
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": true
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": true
                    },
                    "CREATE_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": true
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": true
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": true
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": true
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": true
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": true
                    },
                    "ADD_COMMENT": {
                        "isAccess": true
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": true
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": true
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": true
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": true
                    }
                },
                "trackerRoles_none": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": false
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "CREATE_LABEL": {
                        "isAccess": false
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": false
                    },
                    "UPDATE_LABEL": {
                        "isAccess": false
                    },
                    "DELETE_LABEL": {
                        "isAccess": false
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": false
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": false
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_STATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_STATE": {
                        "isAccess": false
                    },
                    "DELETE_STATE": {
                        "isAccess": false
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_TYPE": {
                        "isAccess": false
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": false
                    },
                    "DELETE_TYPE": {
                        "isAccess": false
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": false
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": false
                    },
                    "CREATE_ISSUE": {
                        "isAccess": false
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": false
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": false
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": false
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": false
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": false
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": false
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": false
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": false
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": false
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": false
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": false
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": false
                    },
                    "ADD_COMMENT": {
                        "isAccess": false
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": false
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": false
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": false
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": false
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": false
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": false
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": false
                    }
                },
                "trackerRoles_manager": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "CREATE_LABEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": true
                    },
                    "UPDATE_LABEL": {
                        "isAccess": true
                    },
                    "DELETE_LABEL": {
                        "isAccess": true
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": true
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": true
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_STATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_STATE": {
                        "isAccess": true
                    },
                    "DELETE_STATE": {
                        "isAccess": true
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": true
                    },
                    "CREATE_TYPE": {
                        "isAccess": true
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": true
                    },
                    "DELETE_TYPE": {
                        "isAccess": true
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": true
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": true
                    },
                    "CREATE_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": true
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": true
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": true
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": true
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": true
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": true
                    },
                    "ADD_COMMENT": {
                        "isAccess": true
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": true
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": true
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": true
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": true
                    }
                },
                "trackerRoles_team_member": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "CREATE_LABEL": {
                        "isAccess": false
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": false
                    },
                    "UPDATE_LABEL": {
                        "isAccess": false
                    },
                    "DELETE_LABEL": {
                        "isAccess": false
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": false
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": false
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_STATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_STATE": {
                        "isAccess": false
                    },
                    "DELETE_STATE": {
                        "isAccess": false
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_TYPE": {
                        "isAccess": false
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": true
                    },
                    "DELETE_TYPE": {
                        "isAccess": false
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": true
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": true
                    },
                    "CREATE_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": true
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": true
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": true
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": true
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": true
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": true
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": true
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": true
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": true
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": true
                    },
                    "ADD_COMMENT": {
                        "isAccess": true
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": true
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": true
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": true
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": true
                    }
                },
                "trackerRoles_customer": {
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "LIST_POSSIBLE_PROJECT_ASSIGNEES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "GET_FILE_UPLOAD_LINK": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "CREATE_LABEL": {
                        "isAccess": false
                    },
                    "DESCRIBE_LABEL": {
                        "isAccess": false
                    },
                    "UPDATE_LABEL": {
                        "isAccess": false
                    },
                    "DELETE_LABEL": {
                        "isAccess": false
                    },
                    "REPLACE_LABEL_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DESCRIBE_PRIORITY": {
                        "isAccess": false
                    },
                    "UPDATE_PRIORITY": {
                        "isAccess": false
                    },
                    "DELETE_PRIORITY": {
                        "isAccess": false
                    },
                    "REPLACE_PRIORITY_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_STATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_STATE": {
                        "isAccess": false
                    },
                    "DELETE_STATE": {
                        "isAccess": false
                    },
                    "REPLACE_STATE_TAGS": {
                        "isAccess": false
                    },
                    "CREATE_TYPE": {
                        "isAccess": false
                    },
                    "DESCRIBE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_TYPE_FORM": {
                        "isAccess": false
                    },
                    "DELETE_TYPE": {
                        "isAccess": false
                    },
                    "REPLACE_TYPE_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_ISSUE": {
                        "isAccess": true
                    },
                    "DESCRIBE_ARCHIVED_ISSUE": {
                        "isAccess": true
                    },
                    "CREATE_ISSUE": {
                        "isAccess": true
                    },
                    "ADD_ASSIGNEE_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_ASSIGNEE_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "ADD_PARTICIPANT_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_PARTICIPANT_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_PRIORITY": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_STATE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_TYPE": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_PRIORITY": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_STATE": {
                        "isAccess": false
                    },
                    "REMOVE_ISSUE_TYPE": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ISSUE_SUMMARY": {
                        "isAccess": false
                    },
                    "ADD_LABEL_TO_ISSUE": {
                        "isAccess": false
                    },
                    "REMOVE_LABEL_FROM_ISSUE": {
                        "isAccess": false
                    },
                    "UP_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_ISSUE": {
                        "isAccess": true
                    },
                    "MAKE_ISSUE_PRIVATE": {
                        "isAccess": false
                    },
                    "MAKE_ISSUE_PUBLIC": {
                        "isAccess": false
                    },
                    "RESOLVE_ISSUE_REQUEST": {
                        "isAccess": false
                    },
                    "RESOLVE_ISSUE": {
                        "isAccess": false
                    },
                    "REOPEN_ISSUE": {
                        "isAccess": false
                    },
                    "ARCHIVE_ISSUE": {
                        "isAccess": false
                    },
                    "RESTORE_ISSUE": {
                        "isAccess": false
                    },
                    "REPLACE_ISSUE_TAGS": {
                        "isAccess": false
                    },
                    "MOVE_ISSUE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_ISSUE_FORM_VALUES": {
                        "isAccess": false
                    },
                    "ADD_COMMENT": {
                        "isAccess": true
                    },
                    "UPDATE_COMMENT_TEXT": {
                        "isAccess": false
                    },
                    "REMOVE_COMMENT": {
                        "isAccess": false
                    },
                    "ADD_SUB_COMMENT": {
                        "isAccess": true
                    },
                    "UP_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "DOWN_VOTE_COMMENT": {
                        "isAccess": true
                    },
                    "MAKE_COMMENT_PUBLIC": {
                        "isAccess": false
                    },
                    "MAKE_COMMENT_PRIVATE": {
                        "isAccess": false
                    }
                }
            },
            "node": {
                "accountOwner": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": true
                    },
                    "CREATE_HEALTH": {
                        "isAccess": true
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": true
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": true
                    },
                    "DELETE_HEALTH": {
                        "isAccess": true
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": true
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": true
                    },
                    "RESET_OBSERVER": {
                        "isAccess": true
                    },
                    "CREATE_ES4": {
                        "isAccess": true
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": true
                    },
                    "DELETE_ES4": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": true
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": true
                    },
                    "DEPLOY_ES4": {
                        "isAccess": true
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": true
                    },
                    "DISABLE_VPN": {
                        "isAccess": true
                    },
                    "ENABLE_NTP": {
                        "isAccess": true
                    },
                    "DISABLE_NTP": {
                        "isAccess": true
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": true
                    },
                    "REBOOT_ECU": {
                        "isAccess": true
                    },
                    "SCAN_NETWORK": {
                        "isAccess": true
                    },
                    "REGISTER_NODE": {
                        "isAccess": true
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": true
                    },
                    "DISABLE_NODE": {
                        "isAccess": true
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": true
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": true
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "administrator": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": true
                    },
                    "CREATE_HEALTH": {
                        "isAccess": true
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": true
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": true
                    },
                    "DELETE_HEALTH": {
                        "isAccess": true
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": true
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": true
                    },
                    "RESET_OBSERVER": {
                        "isAccess": true
                    },
                    "CREATE_ES4": {
                        "isAccess": true
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": true
                    },
                    "DELETE_ES4": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": true
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": true
                    },
                    "DEPLOY_ES4": {
                        "isAccess": true
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": true
                    },
                    "DISABLE_VPN": {
                        "isAccess": true
                    },
                    "ENABLE_NTP": {
                        "isAccess": true
                    },
                    "DISABLE_NTP": {
                        "isAccess": true
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": true
                    },
                    "REBOOT_ECU": {
                        "isAccess": true
                    },
                    "SCAN_NETWORK": {
                        "isAccess": true
                    },
                    "REGISTER_NODE": {
                        "isAccess": true
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": true
                    },
                    "DISABLE_NODE": {
                        "isAccess": true
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": true
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": true
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "nodeRoles_none": {
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": false
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": false
                    },
                    "CREATE_HEALTH": {
                        "isAccess": false
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": false
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": false
                    },
                    "DELETE_HEALTH": {
                        "isAccess": false
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": false
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": false
                    },
                    "RESET_OBSERVER": {
                        "isAccess": false
                    },
                    "CREATE_ES4": {
                        "isAccess": false
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": false
                    },
                    "DELETE_ES4": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": false
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": false
                    },
                    "DEPLOY_ES4": {
                        "isAccess": false
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": false
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": false
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": false
                    },
                    "ENABLE_VPN": {
                        "isAccess": false
                    },
                    "DISABLE_VPN": {
                        "isAccess": false
                    },
                    "ENABLE_NTP": {
                        "isAccess": false
                    },
                    "DISABLE_NTP": {
                        "isAccess": false
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": false
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": false
                    },
                    "REBOOT_ECU": {
                        "isAccess": false
                    },
                    "SCAN_NETWORK": {
                        "isAccess": false
                    },
                    "REGISTER_NODE": {
                        "isAccess": false
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": false
                    },
                    "ENABLE_NODE": {
                        "isAccess": false
                    },
                    "DISABLE_NODE": {
                        "isAccess": false
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": false
                    },
                    "DELETE_NODE": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": false
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": false
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": false
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": false
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": false
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": false
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": false
                    }
                },
                "nodeRoles_manager": {
                    "ADD_PRODUCT_TO_CART": {
                        "isAccess": true
                    },
                    "REMOVE_ITEM_FROM_CART": {
                        "isAccess": true
                    },
                    "CHECKOUT_CART": {
                        "isAccess": true
                    },
                    "DESCRIBE_PRODUCT": {
                        "isAccess": true
                    },
                    "LIST_PAYMENT_METHODS": {
                        "isAccess": true
                    },
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": true
                    },
                    "CREATE_HEALTH": {
                        "isAccess": true
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": true
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": true
                    },
                    "DELETE_HEALTH": {
                        "isAccess": true
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": true
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": true
                    },
                    "RESET_OBSERVER": {
                        "isAccess": true
                    },
                    "CREATE_ES4": {
                        "isAccess": true
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": true
                    },
                    "DELETE_ES4": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": true
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": true
                    },
                    "DEPLOY_ES4": {
                        "isAccess": true
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": true
                    },
                    "DISABLE_VPN": {
                        "isAccess": true
                    },
                    "ENABLE_NTP": {
                        "isAccess": true
                    },
                    "DISABLE_NTP": {
                        "isAccess": true
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": true
                    },
                    "REBOOT_ECU": {
                        "isAccess": true
                    },
                    "SCAN_NETWORK": {
                        "isAccess": true
                    },
                    "REGISTER_NODE": {
                        "isAccess": true
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": true
                    },
                    "DISABLE_NODE": {
                        "isAccess": true
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": true
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": true
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "nodeRoles_supervisor": {
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": true
                    },
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": true
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": true
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": true
                    },
                    "CREATE_HEALTH": {
                        "isAccess": true
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": true
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": true
                    },
                    "DELETE_HEALTH": {
                        "isAccess": true
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": true
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": true
                    },
                    "RESET_OBSERVER": {
                        "isAccess": true
                    },
                    "CREATE_ES4": {
                        "isAccess": true
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": true
                    },
                    "DELETE_ES4": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": true
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": true
                    },
                    "DEPLOY_ES4": {
                        "isAccess": true
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": false
                    },
                    "DISABLE_VPN": {
                        "isAccess": false
                    },
                    "ENABLE_NTP": {
                        "isAccess": true
                    },
                    "DISABLE_NTP": {
                        "isAccess": true
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": false
                    },
                    "REBOOT_ECU": {
                        "isAccess": true
                    },
                    "SCAN_NETWORK": {
                        "isAccess": true
                    },
                    "REGISTER_NODE": {
                        "isAccess": false
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": false
                    },
                    "DISABLE_NODE": {
                        "isAccess": false
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": false
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": false
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "nodeRoles_engineer": {
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": false
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": true
                    },
                    "CREATE_HEALTH": {
                        "isAccess": false
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": false
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": false
                    },
                    "DELETE_HEALTH": {
                        "isAccess": false
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": false
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": false
                    },
                    "RESET_OBSERVER": {
                        "isAccess": false
                    },
                    "CREATE_ES4": {
                        "isAccess": false
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": false
                    },
                    "DELETE_ES4": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": false
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": false
                    },
                    "DEPLOY_ES4": {
                        "isAccess": false
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": false
                    },
                    "DISABLE_VPN": {
                        "isAccess": false
                    },
                    "ENABLE_NTP": {
                        "isAccess": true
                    },
                    "DISABLE_NTP": {
                        "isAccess": true
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": false
                    },
                    "REBOOT_ECU": {
                        "isAccess": true
                    },
                    "SCAN_NETWORK": {
                        "isAccess": true
                    },
                    "REGISTER_NODE": {
                        "isAccess": false
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": false
                    },
                    "DISABLE_NODE": {
                        "isAccess": false
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": false
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": false
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "nodeRoles_team_member": {
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": true
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": false
                    },
                    "CREATE_HEALTH": {
                        "isAccess": false
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": false
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": false
                    },
                    "DELETE_HEALTH": {
                        "isAccess": false
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": false
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": false
                    },
                    "RESET_OBSERVER": {
                        "isAccess": false
                    },
                    "CREATE_ES4": {
                        "isAccess": false
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": false
                    },
                    "DELETE_ES4": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": false
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": false
                    },
                    "DEPLOY_ES4": {
                        "isAccess": false
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_VPN": {
                        "isAccess": false
                    },
                    "DISABLE_VPN": {
                        "isAccess": false
                    },
                    "ENABLE_NTP": {
                        "isAccess": false
                    },
                    "DISABLE_NTP": {
                        "isAccess": false
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": true
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": false
                    },
                    "REBOOT_ECU": {
                        "isAccess": false
                    },
                    "SCAN_NETWORK": {
                        "isAccess": false
                    },
                    "REGISTER_NODE": {
                        "isAccess": false
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": true
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": true
                    },
                    "ENABLE_NODE": {
                        "isAccess": false
                    },
                    "DISABLE_NODE": {
                        "isAccess": false
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": true
                    },
                    "DELETE_NODE": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": false
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": true
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": false
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": true
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": true
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": true
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": true
                    }
                },
                "nodeRoles_customer": {
                    "LOCK_ECU_SERIAL_TO_ACCOUNT": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "REQUEST_ECU_TUNNEL": {
                        "isPredictiveOnly": true,
                        "isAccess": false
                    },
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "LIST_PROJECT_HEALTHS": {
                        "isAccess": false
                    },
                    "LIST_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_SCRIPT_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_SCRIPT": {
                        "isAccess": false
                    },
                    "LIST_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "LIST_PROJECT_EMAIL_TEMPLATE_TYPES": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "RESET_PROJECT_EMAIL_TEMPLATE": {
                        "isAccess": false
                    },
                    "DESCRIBE_IOT3": {
                        "isAccess": true
                    },
                    "DESCRIBE_ROOT_CAUSE_ANALYSIS": {
                        "isAccess": false
                    },
                    "CREATE_HEALTH": {
                        "isAccess": false
                    },
                    "DESCRIBE_HEALTH": {
                        "isAccess": false
                    },
                    "UPDATE_HEALTH": {
                        "isAccess": false
                    },
                    "DELETE_HEALTH": {
                        "isAccess": false
                    },
                    "REPLACE_HEALTH_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_OBSERVER": {
                        "isAccess": false
                    },
                    "UPDATE_OBSERVER": {
                        "isAccess": false
                    },
                    "RESET_OBSERVER": {
                        "isAccess": false
                    },
                    "CREATE_ES4": {
                        "isAccess": false
                    },
                    "DESCRIBE_ES4": {
                        "isAccess": false
                    },
                    "DELETE_ES4": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_ES4_SCRIPT": {
                        "isAccess": false
                    },
                    "REPLACE_ES4_TAGS": {
                        "isAccess": false
                    },
                    "DEPLOY_ES4": {
                        "isAccess": false
                    },
                    "BIND_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU_SERIAL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ECU": {
                        "isAccess": true
                    },
                    "UPDATE_ECU_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ECU_DESCRIPTION": {
                        "isAccess": false
                    },
                    "REPLACE_ECU_LOCATION": {
                        "isAccess": false
                    },
                    "REPLACE_ECU_TAGS": {
                        "isAccess": false
                    },
                    "ENABLE_VPN": {
                        "isAccess": false
                    },
                    "DISABLE_VPN": {
                        "isAccess": false
                    },
                    "ENABLE_NTP": {
                        "isAccess": false
                    },
                    "DISABLE_NTP": {
                        "isAccess": false
                    },
                    "DEPLOY_ECU_CHANGES": {
                        "isAccess": false
                    },
                    "DEREGISTER_ECU": {
                        "isAccess": false
                    },
                    "REBOOT_ECU": {
                        "isAccess": false
                    },
                    "SCAN_NETWORK": {
                        "isAccess": false
                    },
                    "REGISTER_NODE": {
                        "isAccess": false
                    },
                    "DESCRIBE_NODE": {
                        "isAccess": true
                    },
                    "UPDATE_NODE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_DESCRIPTION": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_NOTE": {
                        "isAccess": false
                    },
                    "UPDATE_NODE_INDEX": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_LOCATION": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_GRAPH": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_TAGS": {
                        "isAccess": false
                    },
                    "ENABLE_NODE": {
                        "isAccess": false
                    },
                    "DISABLE_NODE": {
                        "isAccess": false
                    },
                    "DEPLOY_NODE_CHANGES": {
                        "isAccess": false
                    },
                    "DELETE_NODE": {
                        "isAccess": false
                    },
                    "REPLACE_NODE_IOT3": {
                        "isAccess": false
                    },
                    "REQUEST_NODE_TUNNEL": {
                        "isAccess": false
                    },
                    "NODE_JOIN_CHANGE_DECISION": {
                        "isAccess": false
                    },
                    "DESCRIBE_TUNNEL": {
                        "isAccess": false
                    },
                    "DESCRIBE_ATTRIBUTE": {
                        "isAccess": true
                    },
                    "UPDATE_ATTRIBUTE_NAME": {
                        "isAccess": false
                    },
                    "UPDATE_ATTRIBUTE_DESCRIPTION": {
                        "isAccess": false
                    },
                    "ENABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DISABLE_ATTRIBUTE": {
                        "isAccess": false
                    },
                    "DEPLOY_ATTRIBUTE_CHANGES": {
                        "isAccess": false
                    },
                    "UPDATE_ATTRIBUTE_VALUE": {
                        "isAccess": false
                    },
                    "WRITE_ATTRIBUTES": {
                        "isAccess": false
                    }
                }
            },
            "insight": {
                "accountOwner": {
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "CREATE_QUERY": {
                        "isAccess": true
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY": {
                        "isAccess": true
                    },
                    "DELETE_QUERY": {
                        "isAccess": true
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": true
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": true
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART": {
                        "isAccess": true
                    },
                    "DELETE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": true
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": true
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": true
                    },
                    "DELETE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": true
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": true
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                },
                "administrator": {
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "CREATE_QUERY": {
                        "isAccess": true
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY": {
                        "isAccess": true
                    },
                    "DELETE_QUERY": {
                        "isAccess": true
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": true
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": true
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART": {
                        "isAccess": true
                    },
                    "DELETE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": true
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": true
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": true
                    },
                    "DELETE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": true
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": true
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                },
                "insightRoles_none": {
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": false
                    },
                    "CREATE_QUERY": {
                        "isAccess": false
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY": {
                        "isAccess": false
                    },
                    "DELETE_QUERY": {
                        "isAccess": false
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": false
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": false
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART": {
                        "isAccess": false
                    },
                    "DELETE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": false
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": false
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": false
                    },
                    "DELETE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": false
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": false
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                },
                "insightRoles_manager": {
                    "CREATE_PROJECT": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": true
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": true
                    },
                    "DELETE_PROJECT": {
                        "isAccess": true
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": true
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": true
                    },
                    "CREATE_QUERY": {
                        "isAccess": true
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY": {
                        "isAccess": true
                    },
                    "DELETE_QUERY": {
                        "isAccess": true
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": true
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": true
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": true
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART": {
                        "isAccess": true
                    },
                    "DELETE_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": true
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": true
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": true
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": true
                    },
                    "DELETE_WIDGET": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": true
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": true
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": true
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": true
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": true
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": true
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                },
                "insightRoles_team_member": {
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": false
                    },
                    "CREATE_QUERY": {
                        "isAccess": false
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY": {
                        "isAccess": false
                    },
                    "DELETE_QUERY": {
                        "isAccess": false
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": false
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": false
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART": {
                        "isAccess": false
                    },
                    "DELETE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": false
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": false
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": false
                    },
                    "DELETE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": false
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": false
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                },
                "insightRoles_customer": {
                    "CREATE_PROJECT": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT": {
                        "isAccess": false
                    },
                    "UPDATE_PROJECT": {
                        "isAccess": false
                    },
                    "DELETE_PROJECT": {
                        "isAccess": false
                    },
                    "REPLACE_PROJECT_TAGS": {
                        "isAccess": false
                    },
                    "DESCRIBE_PROJECT_RELATIONSHIPS": {
                        "isAccess": false
                    },
                    "CREATE_QUERY": {
                        "isAccess": false
                    },
                    "DESCRIBE_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY": {
                        "isAccess": false
                    },
                    "DELETE_QUERY": {
                        "isAccess": false
                    },
                    "REPLACE_QUERY_TAGS": {
                        "isAccess": false
                    },
                    "UPDATE_QUERY_SQL": {
                        "isAccess": false
                    },
                    "EXECUTE_STORED_QUERY": {
                        "isAccess": true
                    },
                    "CREATE_CHART": {
                        "isAccess": false
                    },
                    "DESCRIBE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART": {
                        "isAccess": false
                    },
                    "DELETE_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_QUERY": {
                        "isAccess": false
                    },
                    "UPDATE_CHART_CHART": {
                        "isAccess": false
                    },
                    "REPLACE_CHART_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_CHART": {
                        "isAccess": true
                    },
                    "CREATE_WIDGET": {
                        "isAccess": false
                    },
                    "DESCRIBE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET": {
                        "isAccess": false
                    },
                    "DELETE_WIDGET": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_CHART": {
                        "isAccess": false
                    },
                    "UPDATE_WIDGET_LAYOUT": {
                        "isAccess": false
                    },
                    "REPLACE_WIDGET_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_WIDGET": {
                        "isAccess": true
                    },
                    "CREATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DESCRIBE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD": {
                        "isAccess": false
                    },
                    "DELETE_DASHBOARD": {
                        "isAccess": false
                    },
                    "UPDATE_DASHBOARD_CELLS": {
                        "isAccess": false
                    },
                    "REPLACE_DASHBOARD_TAGS": {
                        "isAccess": false
                    },
                    "EXECUTE_DASHBOARD": {
                        "isAccess": true
                    }
                }
            }
        };

        return {
            /*
            * pageName: string args which contain page name (ex.:"access:user")
            * return PermissionsObj for pageName
            * if userPermissionsObj value for key is 'FALSE' then set false otherwise set true (for "TRUE" and  "CONDITIONAL")
            * testing: set userPermissionsObj[pageName + ':List'] = 'FALSE'; which set false for {List: false}
            * */
            getPermissions: function (pageName) {
                //userPermissionsObj[pageName + ':Create'] = 'FALSE';
                userPermissionsObj = DB.fnGet('userPermissions');
                var tempPermissionsObj = {};
                _.forEach(userPermissionsObj, function (userPermissionObj) {
                    var key = userPermissionObj.securityAction;
                    var value = userPermissionObj.authorized;
                    if (key.includes(pageName)) {
                        var tempKey = key.split(":")[2];
                        tempPermissionsObj[tempKey] = value !== false;
                    }
                });
                return tempPermissionsObj;
            },
            getPermissionsV4: function (appName) {
                loginUserObj = DB.fnGet('loginUser');
                accountId = loginUserObj.id.split("-")[0];
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    loginUserObj = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.user : DB.fnGet('support').sessionObj.user;
                    accountId = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.accountId : DB.fnGet('support').sessionObj.accountId;
                } else {
                    loginUserObj = DB.fnGet('loginUser');
                    accountId = loginUserObj.id.split("-")[0];
                }
                var key = '';
                if (loginUserObj.accountOwner === true) {
                    key = 'accountOwner';
                } else if (loginUserObj.administrator === true) {
                    key = 'administrator';
                    if (appName === 'billing') {
                        if (loginUserObj.billingRole === 'NONE') {
                            key = 'billingRoles_none';
                        } else if (loginUserObj.billingRole === 'ADMINISTRATOR') {
                            key = 'administrator';
                        } else if (loginUserObj.billingRole === 'MANAGER') {
                            key = 'billingRoles_manager';
                        } else if (loginUserObj.nodeRole === 'MANAGER') {
                            key = 'nodeRoles_manager';
                        }
                    }
                    /*if (appName === 'access') {
                        if (loginUserObj.self === true) {
                            key = 'self';
                        } else if (loginUserObj.team_member === true) {
                            key = 'teamMember';
                        }
                    } else if (appName === 'billing') {
                        if (loginUserObj.billingRole === 'NONE') {
                            key = 'billingRoles_none';
                        } else if (loginUserObj.billingRole === 'MANAGER') {
                            key = 'billingRoles_manager';
                        } else if (loginUserObj.nodeRole === 'MANAGER') {
                            key = 'nodeRoles_manager';
                        }
                    } else if (appName === 'tracker') {
                        if (loginUserObj.trackerRole === 'NONE') {
                            key = 'trackerRoles_none';
                        } else if (loginUserObj.trackerRole === 'MANAGER') {
                            key = 'trackerRoles_manager';
                        } else if (loginUserObj.trackerRole === 'TEAM_MEMBER') {
                            key = 'trackerRoles_team_member';
                        } else if (loginUserObj.trackerRole === 'CUSTOMER') {
                            key = 'trackerRoles_customer';
                        }
                    } else if (appName === 'node') {
                        if (loginUserObj.nodeRole === 'NONE') {
                            key = 'nodeRoles_none';
                        } else if (loginUserObj.nodeRole === 'MANAGER') {
                            key = 'nodeRoles_manager';
                        } else if (loginUserObj.nodeRole === 'SUPERVISOR') {
                            key = 'nodeRoles_supervisor';
                        } else if (loginUserObj.nodeRole === 'TEAM_MEMBER') {
                            key = 'nodeRoles_team_member';
                        } else if (loginUserObj.nodeRole === 'CUSTOMER') {
                            key = 'nodeRoles_customer';
                        }
                    }*/
                } else {
                    if (appName === 'access') {
                        if (loginUserObj.self === true) {
                            key = 'self';
                        } else if (loginUserObj.team_member === true) {
                            key = 'teamMember';
                        }
                    } else if (appName === 'billing') {
                        if (loginUserObj.billingRole === 'NONE') {
                            key = 'billingRoles_none';
                        } else if (loginUserObj.billingRole === 'MANAGER') {
                            key = 'billingRoles_manager';
                        } else if (loginUserObj.nodeRole === 'MANAGER') {
                            key = 'nodeRoles_manager';
                        }
                    } else if (appName === 'tracker') {
                        if (loginUserObj.trackerRole === 'NONE') {
                            key = 'trackerRoles_none';
                        } else if (loginUserObj.trackerRole === 'MANAGER') {
                            key = 'trackerRoles_manager';
                        } else if (loginUserObj.trackerRole === 'TEAM_MEMBER') {
                            key = 'trackerRoles_team_member';
                        } else if (loginUserObj.trackerRole === 'CUSTOMER') {
                            key = 'trackerRoles_customer';
                        }
                    } else if (appName === 'node') {
                        if (loginUserObj.nodeRole === 'NONE') {
                            key = 'nodeRoles_none';
                        } else if (loginUserObj.nodeRole === 'MANAGER') {
                            key = 'nodeRoles_manager';
                        } else if (loginUserObj.nodeRole === 'SUPERVISOR') {
                            key = 'nodeRoles_supervisor';
                        } else if (loginUserObj.nodeRole === 'ENGINEER') {
                            key = 'nodeRoles_engineer';
                        } else if (loginUserObj.nodeRole === 'TEAM_MEMBER') {
                            key = 'nodeRoles_team_member';
                        } else if (loginUserObj.nodeRole === 'CUSTOMER') {
                            key = 'nodeRoles_customer';
                        }
                    } else if (appName === 'insight') {
                        if (loginUserObj.insightRole === 'NONE') {
                            key = 'insightRoles_none';
                        } else if (loginUserObj.insightRole === 'MANAGER') {
                            key = 'insightRoles_manager';
                        } else if (loginUserObj.insightRole === 'SUPERVISOR') {
                            key = 'insightRoles_supervisor';
                        } else if (loginUserObj.insightRole === 'TEAM_MEMBER') {
                            key = 'insightRoles_team_member';
                        } else if (loginUserObj.insightRole === 'CUSTOMER') {
                            key = 'insightRoles_customer';
                        }
                    }
                }
                var res = {};
                if (accountId !== 'cu000000') {
                    _.forEach(v4PermissionsJson[appName][key], function (value, key) {
                        if (value.isPredictiveOnly !== true) {
                            res[key] = value.isAccess;
                        } else {
                            res[key] = false
                        }
                    });
                    return res;
                } else {
                    _.forEach(v4PermissionsJson[appName][key], function (value, key) {
                        res[key] = value.isAccess;
                    });
                    return res;
                }
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('PaginationQueryService', fnPaginationQueryService);

    /** @ngInject */
    function fnPaginationQueryService() {
        function isNumeric(value) {
            return /^-?\d+$/.test(value);
        }

        return {
            getPaginationQuery: function (sqlString, sqlQuery, sortString, page, previousPage, perPage, totalItems, dataArr, isAliasNameNeeded, aliasName) {
                var resultToken = '';
                var lastPage = Math.ceil(totalItems / perPage);
                var isNeedDataReverse = false;
                var sortType = sortString.length ? sortString.split(' ')[1] : '';
                var sortValue = sortString.length ? sortString.split(' ')[0] : '';
                if (page > previousPage) { //for next page change
                    if (page === lastPage && previousPage !== (lastPage - 1)) { //for access direct last page
                        if (sqlQuery && sqlQuery.length) {
                            sqlString += ' WHERE ' + sqlQuery.trim();
                        }
                        if (sortString !== '') {
                            var sortApplied = sortType === 'desc' ? 'asc' : 'desc';
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'' + sortValue + '\' ' + sortApplied + ' LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'' + sortValue + '\' ' + sortApplied + ' LIMIT ' + perPage + ';';
                            }
                        } else {
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'_id\' DESC LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'_id\' DESC LIMIT ' + perPage + ';';
                            }
                        }
                        isNeedDataReverse = true;
                    } else { //for access next page
                        if (sortString !== '') {
                            var nextPageComparator = sortType === 'desc' ? '<' : '>';
                            resultToken = dataArr[dataArr.length - 1].rt;
                            if (isNumeric(resultToken)) {
                                if (isAliasNameNeeded) {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + resultToken;
                                    } else {
                                        sqlString += ' WHERE ' + aliasName + '.data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + resultToken;
                                    }
                                } else {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + resultToken;
                                    } else {
                                        sqlString += ' WHERE data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + resultToken;
                                    }
                                }
                            } else {
                                if (isAliasNameNeeded) {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + "'" + resultToken + "'";
                                    } else {
                                        sqlString += ' WHERE ' + aliasName + '.data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + "'" + resultToken + "'";
                                    }
                                } else {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + "'" + resultToken + "'";
                                    } else {
                                        sqlString += ' WHERE data->>\'' + sortValue + '\' ' + nextPageComparator + ' ' + "'" + resultToken + "'";
                                    }
                                }
                            }
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'' + sortValue + '\' ' + sortType + ' LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'' + sortValue + '\' ' + sortType + ' LIMIT ' + perPage + ';';
                            }
                        } else {
                            resultToken = dataArr[dataArr.length - 1].rt;
                            if (isAliasNameNeeded) {
                                if (sqlQuery && sqlQuery.length) {
                                    sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'_id\'  > ' + "'" + resultToken + "'";
                                } else {
                                    sqlString += ' WHERE ' + aliasName + '.data->>\'_id\' > ' + "'" + resultToken + "'";
                                }
                            } else {
                                if (sqlQuery && sqlQuery.length) {
                                    sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'_id\'  > ' + "'" + resultToken + "'";
                                } else {
                                    sqlString += ' WHERE data->>\'_id\' > ' + "'" + resultToken + "'";
                                }
                            }

                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'_id\' asc LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + perPage + ';';
                            }
                        }
                    }
                } else { //for previous page change
                    if (page === 1 && previousPage !== (lastPage - 1)) { //for access direct first page
                        if (sqlQuery && sqlQuery.length) {
                            sqlString += ' WHERE ' + sqlQuery.trim();
                        }
                        if (sortString !== '') {
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'' + sortValue + '\' ' + sortType + ' LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'' + sortValue + '\' ' + sortType + ' LIMIT ' + perPage + ';';
                            }
                        } else {
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'_id\' ASC LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'_id\' ASC LIMIT ' + perPage + ';';
                            }
                        }
                    } else {  //for access previous page
                        if (sortString !== '') {
                            var previousPageComparator = sortType === 'desc' ? '>' : '<';
                            var previousPageSort = sortType === 'desc' ? 'asc' : 'desc';
                            resultToken = dataArr[0].rt;
                            if (isNumeric(resultToken)) {
                                if (isAliasNameNeeded) {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + resultToken;
                                    } else {
                                        sqlString += ' WHERE ' + aliasName + '.data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + resultToken;
                                    }
                                } else {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + resultToken;
                                    } else {
                                        sqlString += ' WHERE data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + resultToken;
                                    }
                                }
                            } else {
                                if (isAliasNameNeeded) {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + "'" + resultToken + "'";
                                    } else {
                                        sqlString += ' WHERE ' + aliasName + '.data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + "'" + resultToken + "'";
                                    }
                                } else {
                                    if (sqlQuery && sqlQuery.length) {
                                        sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + "'" + resultToken + "'";
                                    } else {
                                        sqlString += ' WHERE data->>\'' + sortValue + '\' ' + previousPageComparator + ' ' + "'" + resultToken + "'";
                                    }
                                }
                            }
                            if (isAliasNameNeeded) {
                                sqlString += ' ORDER BY ' + aliasName + '.data->>\'' + sortValue + '\' ' + previousPageSort + ' LIMIT ' + perPage + ';';
                            } else {
                                sqlString += ' ORDER BY data->>\'' + sortValue + '\' ' + previousPageSort + ' LIMIT ' + perPage + ';';
                            }
                            isNeedDataReverse = true;
                        } else {
                            isNeedDataReverse = true;
                            resultToken = dataArr[0].rt;
                            if (isAliasNameNeeded) {
                                if (sqlQuery && sqlQuery.length) {
                                    sqlString += ' WHERE ' + sqlQuery.trim() + ' AND ' + aliasName + '.data->>\'_id\'  < ' + "'" + resultToken + "'";
                                } else {
                                    sqlString += ' WHERE ' + aliasName + '.data->>\'_id\' < ' + "'" + resultToken + "'";
                                }
                            } else {
                                if (sqlQuery && sqlQuery.length) {
                                    sqlString += ' WHERE ' + sqlQuery.trim() + ' AND data->>\'_id\' < ' + "'" + resultToken + "'";
                                } else {
                                    sqlString += ' WHERE data->>\'_id\' < ' + "'" + resultToken + "'";
                                }
                            }

                            if (isAliasNameNeeded) {
                                sqlString += sortString && sortString.length ? ' ORDER BY ' + aliasName + '.data->>\'' + sortString + '\', data->>\'_id\' DESC LIMIT ' + perPage : ' ORDER BY ' + aliasName + '.data->>\'_id\' DESC LIMIT ' + perPage + ';';
                            } else {
                                sqlString += sortString && sortString.length ? ' ORDER BY data->>\'' + sortString + '\', data->>\'_id\' DESC LIMIT ' + perPage : ' ORDER BY data->>\'_id\' DESC LIMIT ' + perPage + ';';
                            }
                        }
                    }
                }
                return {
                    sql: sqlString,
                    isNeedDataReverse: isNeedDataReverse
                };
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('PaginationService', PaginationService);

    /** @ngInject */
    function PaginationService() {

        PaginationService.Pagination = {};
        PaginationService.SetPagination = function (str, totalCollection, url) {
           if(angular.isDefined(url)) {
               var paginationObj = {};
               var API_NAME;
               if(!str.length) {
                   API_NAME = url.substring(1).split("?")[0].split("/").pop();
               } else {
                   var API_URL = str.split(',')[0].split(';')[0].replace('<', '').replace('>', '');
                   API_NAME = API_URL.substring(1).split("?")[0].split("/").pop();

                   var linksArr = str.split(', ');

                   angular.forEach(linksArr, function (value) {
                       paginationObj[value.split(';')[1].split('=')[1].replace(/"/g, "")] = value.split(';')[0].replace('<', '').replace('>', '');
                   });

                   angular.forEach(paginationObj, function (val, key) {
                       var url = val;
                       var params = {};
                       var query = url.substring(1).split("?")[1];
                       var vars = query.split("&");
                       for (var i = 0; i < vars.length; i++) {
                           if(vars[i].length) {
                               var pair = vars[i].split("=");
                               // If first entry with this name
                               if (typeof params[pair[0]] === "undefined") {
                                   params[pair[0]] = decodeURIComponent(pair[1].trim());
                                   // If second entry with this name
                               } else if (angular.isString(params[pair[0]])) {
                                   var arr = [params[pair[0]], decodeURIComponent(pair[1].trim())];
                                   params[pair[0]] = arr;
                                   // If third or later entry with this name
                               } else {
                                   params[pair[0]].push(decodeURIComponent(pair[1].trim()));
                               }
                           }
                       }
                       paginationObj[key] = params;
                   });
               }
               paginationObj.totalCollection = totalCollection;
               PaginationService.Pagination[API_NAME] = paginationObj;
           }
        };

        return PaginationService;
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('navigationMenuService', fnNavigationMenuService);

    /** @ngInject */
    function fnNavigationMenuService(DB) {

        /* var menuArr = {
             predictive: {
                 "name": "ECSMon",
                 /!*"tag": "BETA",*!/
                 "active": false
             },
             predictive_account: {
                 "name": "Account",
                 "icon": "fa-building",
                 "state": "main.accounts"
             },
             access: {
                 "name": "Access",
                 /!*"tag": "BETA",*!/
                 "active": false
             }/!*,
             access_user: {
                 "name": "User",
                 "icon": "fa-user",
                 "state": "main.users"
             },
             access_account: {
                 "name": "Account",
                 "icon": "fa-building",
                 "state": "main.accounts"
             },
             access_role: {
                 "name": "Role",
                 "icon": "fa-universal-access",
                 "state": "main.roles"
             },
             access_group: {
                 "name": "Group",
                 "icon": "fa-users",
                 "state": "main.groups"
             }/!*,
             access_log: {
                 "name": "Log",
                 "icon": "fa-address-book",
                 "state": "main.logs"
             }*!/,
             access_vault: {
                 "name": "Vault",
                 "icon": "fa-key",
                 "state": "main.vaults"
             },
             access_authenticator: {
                 "name": "Authenticator",
                 "icon": "fa-id-badge",
                 "state": "main.authenticators"
             },
             access_federation: {
                 "name": "Federation",
                 "icon": "fa-handshake-o",
                 "state": "main.federations"
             },
             access_contact: {
                 "name": "Contact",
                 "icon": "fa-address-card-o",
                 "state": "main.contacts"
             }*!/,
             node: {
                 "name": "Node", /!*
                 "tag": "BETA",*!/
                 "active": false
             },
             node_device: {
                 "name": "Device",
                 "icon": "fa-sitemap",
                 "state": "main.device",
                 "default": true
             },
             node_health: {
                 "name": "Health",
                 "icon": "fa-heartbeat",
                 "state": "main.health"
             },
             node_notification: {
                 "name": "Notification",
                 "icon": "fa-bell",
                 "state": "main.notification",
                 "tag": "NEW"
             },
             node_gateway: {
                 "name": "Gateway",
                 "icon": "fa-microchip",
                 "state": "main.gateway"
             },
             node_observer: {
                 "name": "Observer",
                 "icon": "fa-binoculars",
                 "state": "main.observer"
             },
             node_lifecycle: {
                 "name": "Lifecycle",
                 "icon": "fa-history",
                 "state": "main.lifecycle"
             },
             node_cluster: {
                 "name": "Cluster",
                 "icon": "fa-th",
                 "state": "main.cluster",
                 "tag": "BETA"
             },
             /!*node_visualizer: {
                 "name": "Visualizer",
                 "icon": "fa-first-order",
                 "state": "main.visualizer"
             },*!/
             pipeline: {
                 "name": "Pipeline",
                 "tag": "BETA",
                 "active": false
             },
             pipeline_listener: {
                 "name": "Listener",
                 "icon": "fa-bullhorn",
                 "state": "main.listeners"
             },
             pipeline_workflow: {
                 "name": "Workflow",
                 "icon": "fa-cubes",
                 "state": "main.workflows",
                 "default": true
             },
             pipeline_template: {
                 "name": "Template",
                 "icon": "fa-object-group",
                 "state": "main.pipeline_templates"
             },
             pipeline_transformer: {
                 "name": "Transformer",
                 "icon": "fa-random",
                 "state": "main.transformers"
             },
             tracker: {
                 "name": "Tracker", /!*
                 "tag": "BETA",*!/
                 "active": false
             },
             tracker_issue: {
                 "name": "Issue",
                 "icon": "fa-list",
                 "state": "main.issue"
             },
             tracker_label: {
                 "name": "Label",
                 "icon": "fa-tags",
                 "state": "main.label"
             },
             insight: {
                 "name": "Insight",
                 "tag": "BETA",
                 "active": false
             },
             /!*insight_template: {
                 "name": "Template",
                 "icon": "fa-th-large",
                 "state": "main.template"
             },
             insight_profile: {
                 "name": "Profile",
                 "icon": "fa-vcard",
                 "state": "main.profile"
             },
             insight_report: {
                 "name": "Report",
                 "icon": "fa-file-text",
                 "state": "main.report"
             },*!/
             external: {
                 "name": "External",
                 "tag": "BETA",
                 "active": false
             }, /!*
             external_email: {
                 "name": "ExternalEmail",
                 "icon": "fa-file-text",
                 "state": "main.email"
             },*!/
             ai: {
                 "name": "AI",
                 "tag": "BETA",
                 "active": false
             },
             ai_trainer: {
                 "name": "Trainer",
                 "icon": "fa-empire",
                 "state": "main.trainer"
             },
             ai_model: {
                 "name": "Model",
                 "icon": "fa-codepen",
                 "state": "main.model"
             },
             ai_distribution: {
                 "name": "Distribution",
                 "icon": "fa-share-alt",
                 "state": "main.distribution"
             },
             ai_deployment: {
                 "name": "Deployment",
                 "icon": "fa-cloud-upload",
                 "state": "main.deployment"
             },
             storage: {
                 "name": "Storage", /!*
                 "tag": "BETA",*!/
                 "active": false
             },
             /!*storage_file: {
                 "name": "StorageFile",
                 "icon": "fa-file-code-o",
                 "state": "main.file"
             },*!/
             storage_folder: {
                 "name": "Drive",
                 "icon": "fa-folder",
                 "state": "main.folder"
             },
             billing: {
                 "name": "Billing",
                 "tag": "BETA",
                 "active": false
             }

         };*/
        //var appOrder = ['Access', 'Pipeline', 'Node', 'Tracker', 'Storage', 'AI', 'Insight','External'];

        var nodeApp = {
            "name": "Node",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Dashboard",
                    "state": "main.node_dashboard",
                    "isAcess": true,
                    "default": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "ECU",
                    "state": "main.ecu",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Nodes",
                    "state": "main.node",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/device.svg#device\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Alarms",
                    "state": "main.alarms",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Jobs",
                    "state": "main.job",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/jobs.svg#jobs\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Fleet",
                    "state": "main.fleet",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Software",
                    "state": "main.software",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/software.svg#software\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Alarm History",
                    "state": "main.alarmHistory",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/alarmHistory.svg#alarmHistory\"></use> \n" +
                        "</svg>"
                }
            ]
        };

        /*var pipelineApp = {
            "name": "Automator",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Transformer",
                    "icon": "fa-random",
                    "state": "main.transformers",
                    "isAcess": true
                },
                {
                    "name": "Template",
                    "icon": "fa-object-group",
                    "state": "main.pipeline_templates",
                    "isAcess": true
                },
                {
                    "name": "Listener",
                    "icon": "fa-bullhorn",
                    "state": "main.listeners",
                    "isAcess": true
                },
                {
                    "name": "Workflow",
                    "icon": "fa-cubes",
                    "state": "main.workflows",
                    "default": true,
                    "isAcess": true
                }
            ],
            "transformer": {
                "name": "Transformer",
                "icon": "fa-random",
                "state": "main.transformers",
                "isAcess": true
            },
            "template": {
                "name": "Template",
                "icon": "fa-object-group",
                "state": "main.pipeline_templates",
                "isAcess": true
            },
            "listener": {
                "name": "Listener",
                "icon": "fa-bullhorn",
                "state": "main.listeners",
                "isAcess": true
            },
            "workflow": {
                "name": "Workflow",
                "icon": "fa-cubes",
                "state": "main.workflows",
                "default": true,
                "isAcess": true
            }
        };*/

        var trackerApp = {
            "name": "Tracker",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Dashboard",
                    "state": "main.tracker_dashboard",
                    "isAcess": true,
                    "default": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Issues",
                    "state": "main.issue",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Archives",
                    "state": "main.archives",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/archive.svg#archive\"></use> \n" +
                        "</svg>"
                }
            ],
            "issues": {
                "name": "Issues",
                "icon": "fa-list",
                "state": "main.issue",
                "isAcess": true
            },
            "Archives": {
                "name": "Archives",
                "icon": "fa-tags",
                "state": "main.archives",
                "isAcess": true
            }
        };

        var storageApp = {
            "name": "Storage",
            "active": false,
            "isAcess": false,
            "sideMenu": [
                {
                    "name": "Drive",
                    "icon": "fa-folder",
                    "state": "main.folder",
                    "isAcess": true
                }
            ],
            "folder": {
                "name": "Drive",
                "icon": "fa-folder",
                "state": "main.folder",
                "isAcess": true
            }
        };

        /*var aiApp = {
            "name": "AI",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Trainer",
                    "icon": "fa-empire",
                    "state": "main.trainer",
                    "isAcess": true
                },
                {
                    "name": "Model",
                    "icon": "fa-codepen",
                    "state": "main.model",
                    "isAcess": true
                },
                {
                    "name": "Deployment",
                    "icon": "fa-cloud-upload",
                    "state": "main.deployment",
                    "isAcess": true
                },
                {
                    "name": "Distribution",
                    "icon": "fa-share-alt",
                    "state": "main.distribution",
                    "isAcess": true
                }
            ],
            "trainer": {
                "name": "Trainer",
                "icon": "fa-empire",
                "state": "main.trainer",
                "isAcess": true
            },
            "model": {
                "name": "Model",
                "icon": "fa-codepen",
                "state": "main.model",
                "isAcess": true
            },
            "deployment": {
                "name": "Deployment",
                "icon": "fa-cloud-upload",
                "state": "main.deployment",
                "isAcess": true
            },
            "distribution": {
                "name": "Distribution",
                "icon": "fa-share-alt",
                "state": "main.distribution",
                "isAcess": true
            }
        };*/

        var insightApp = {
            "name": "Insight",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Query Editor",
                    "state": "main.insight_query_editor",
                    "isAcess": true,
                    "default": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/insight-query-editor.svg#insight-query-editor\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Dashboards",
                    "state": "main.insight_dashboards",
                    "isAcess": true,
                    "default": false,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                        "</svg>"
                }
            ]
        };

        var predictiveApp = {
            "name": "ECSMon",
            "active": false,
            "isAcess": true,
            "sideMenu": [
                {
                    "name": "Dashboard",
                    "state": "main.predictive_dashboard",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                        "</svg>"
                },
                {
                    "name": "Accounts",
                    "state": "main.accounts",
                    "isAcess": true,
                    "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                        "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                        "</svg>"
                }
            ],
            'dashboard': {
                "name": "Dashboard",
                "state": "main.predictive_dashboard",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                    "</svg>"
            },
            "account": {
                "name": "Accounts",
                "state": "main.accounts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/building.svg#account_1\"></use> \n" +
                    "</svg>"
            }
        };

        //var appOrder = ['ECSMon', 'Node', 'Tracker', 'Automator', 'AI', 'Storage', 'Insight']; //'Insight','External','Access',//ToDo by MV: That was temporarily disabled
        var appOrder = ['ECSMon', 'Node', 'Tracker', 'Storage', 'Insight']; //'Insight','External','Access',

        function fnCreateMenuForActiveUser(loginUserObj, menuTempArr) {
            var accountId = loginUserObj.id.split("-")[0];
            var url = HOST_URL.node.split("https://")[1]; //eslint-disable-line
            var environment = url.startsWith('dev') ? 'dev': 'prod';
            if (environment === 'dev') {
                /*Fleet: For dev environment*/
                //Tarka LHerpiniere, Bjoern Graf, Felipe Polanco, Deep Desai, Bhagyashree Bothra, Marinho Rosinei
                if (accountId === 'cu000000' && (loginUserObj.id === 'cu000000-au134b7d' || loginUserObj.id === 'cu000000-au7d7ee6' || loginUserObj.id === 'cu000000-au295f0e' || loginUserObj.id === 'cu000000-au429e91' || loginUserObj.id === 'cu000000-au9b3979' || loginUserObj.id === 'cu000000-aub8f3c1')) {
                    var fleetIndex = _.findIndex(nodeApp.sideMenu, {name: 'Fleet'});
                    nodeApp.sideMenu[fleetIndex].isAcess = true;
                }
                /*Software: For dev environment*/
                //Tarka LHerpiniere, Bjoern Graf
                if (accountId === 'cu000000' && (loginUserObj.id === 'cu000000-au134b7d' || loginUserObj.id === 'cu000000-au7d7ee6')) {
                    var softwareIndex = _.findIndex(nodeApp.sideMenu, {name: 'Software'});
                    nodeApp.sideMenu[softwareIndex].isAcess = true;
                }
            } else {
                /*Fleet: For prod environment*/
                //Tarka LHerpiniere, Bjoern Graf, Felipe Polanco, Deep Desai, Bhagyashree Bothra, Marinho Rosinei
                if (accountId === 'cu000000' && (loginUserObj.id === 'cu000000-au134b7d' || loginUserObj.id === 'cu000000-auda7ab5' || loginUserObj.id === 'cu000000-au984683' || loginUserObj.id === 'cu000000-au62b128' || loginUserObj.id === 'cu000000-au5a2771' || loginUserObj.id === 'cu000000-au5a2209')) {
                    var fleetProdIndex = _.findIndex(nodeApp.sideMenu, {name: 'Fleet'});
                    nodeApp.sideMenu[fleetProdIndex].isAcess = true;
                }
                /*Software: For prod environment*/
                //Tarka LHerpiniere, Bjoern Graf
                if (accountId === 'cu000000' && (loginUserObj.id === 'cu000000-au134b7d' || loginUserObj.id === 'cu000000-auda7ab5')) {
                    var softwareProdIndex = _.findIndex(nodeApp.sideMenu, {name: 'Software'});
                    nodeApp.sideMenu[softwareProdIndex].isAcess = true;
                }
            }
            if (loginUserObj.accountOwner === true || loginUserObj.administrator === true) {
                if (accountId === 'cu000000' && !DB.fnGet('support') && !DB.fnGet('federation')) {
                    menuTempArr.push(predictiveApp);
                }
                menuTempArr.push(nodeApp);
                //menuTempArr.push(pipelineApp);
                menuTempArr.push(trackerApp);
                menuTempArr.push(storageApp);
                //menuTempArr.push(aiApp);
                menuTempArr.push(insightApp);
            } else {
                if (loginUserObj.nodeRole === 'MANAGER' || loginUserObj.nodeRole === 'SUPERVISOR' || loginUserObj.nodeRole === 'ENGINEER' || loginUserObj.nodeRole === 'TEAM_MEMBER' || loginUserObj.nodeRole === 'CUSTOMER') {
                    menuTempArr.push(nodeApp);
                }
                if (loginUserObj.trackerRole === 'MANAGER' || loginUserObj.trackerRole === 'TEAM_MEMBER' || loginUserObj.trackerRole === 'CUSTOMER') {
                    menuTempArr.push(trackerApp);
                }
                /*if (loginUserObj.pipelineRole === 'MANAGER' || loginUserObj.pipelineRole === 'TEAM_MEMBER') {
                    menuTempArr.push(pipelineApp);
                }*/
                if (loginUserObj.storageRole === 'MANAGER' || loginUserObj.storageRole === 'TEAM_MEMBER' || loginUserObj.storageRole === 'CUSTOMER') {
                    menuTempArr.push(storageApp);
                }
                /*if (loginUserObj.aiRole === 'MANAGER') {
                    menuTempArr.push(aiApp);
                }*/
                if (loginUserObj.insightRole === 'MANAGER' || loginUserObj.insightRole === 'TEAM_MEMBER' || loginUserObj.insightRole === 'CUSTOMER') {
                    menuTempArr.push(insightApp);
                }
            }
            menuTempArr = mapOrder(menuTempArr, appOrder, 'name');
            //return menuTempArr;
            return {
                menuArr: menuTempArr,
                state: 'active',
                stateName: ''

            }
        }

        function fnCreateMenuForNoPaymentMethodUser(loginUserObj, menuTempArr) {
            if (loginUserObj.accountOwner === true || loginUserObj.billingRole === 'MANAGER') {
                menuTempArr = [];
                return {
                    menuArr: menuTempArr,
                    state: 'no_payment_method',
                    stateName: 'main.payment_method',
                    message: 'Your account does not seem to have a payment method set up yet. Please add a payment method to unlock your account.'
                }
            } else {
                return {
                    menuArr: menuTempArr,
                    state: 'no_payment_method',
                    stateName: 'main.access_dashboard',
                    message: 'Your account does not seem to have a payment method set up yet. Please contact your account owner for setting up a payment method to unlock your account.'
                }
            }
        }

        function fnCreateMenuForSuspendedUser(loginUserObj, menuTempArr) {
            if (loginUserObj.accountOwner === true || loginUserObj.billingRole === 'MANAGER') {
                menuTempArr = [];
                return {
                    menuArr: menuTempArr,
                    state: 'suspended',
                    stateName: 'main.access_dashboard',
                    message: 'Sorry your account has been temporarily suspended. Please contact ECSite support to get your account re-activated.'
                }
            } else {
                return {
                    menuArr: menuTempArr,
                    state: 'suspended',
                    stateName: 'main.no_privileges',
                    message: 'Sorry your account has been temporarily suspended. Please contact your account owner.'
                }
            }
        }

        function fnCreateMenuForUnpaidUser(loginUserObj, menuTempArr) {
            if (loginUserObj.accountOwner === true || loginUserObj.billingRole === 'MANAGER') {
                menuTempArr = [];
                return {
                    menuArr: menuTempArr,
                    state: 'unpaid',
                    stateName: 'main.payment_method',
                    message: 'Sorry your account has been temporarily suspended due to an unpaid invoice. Please add a new payment method to your account as soon as possible to prevent any service interruptions.'
                }
            } else {
                return {
                    menuArr: menuTempArr,
                    state: 'unpaid',
                    stateName: 'main.no_privileges',
                    message: 'Sorry your account has been temporarily suspended. Please contact your account owner.'
                }
            }
        }

        fnNavigationMenuService.fnCreateMenu = function (loginUserObj, accountObj) {
            var menuTempArr = [];
            switch (accountObj.state.toLowerCase()) {
                case 'active':
                    return fnCreateMenuForActiveUser(loginUserObj, menuTempArr);
                case 'no_payment_method':
                    return fnCreateMenuForNoPaymentMethodUser(loginUserObj, menuTempArr);
                case 'suspended':
                    return fnCreateMenuForSuspendedUser(loginUserObj, menuTempArr);
                case 'unpaid':
                    return fnCreateMenuForUnpaidUser(loginUserObj, menuTempArr);
                default:
                    return fnCreateMenuForActiveUser(loginUserObj, menuTempArr);
            }
        };

        function mapOrder(array, order, key) {
            array.sort(function (a, b) {
                var A = a[key], B = b[key];
                if (order.indexOf(A) > order.indexOf(B)) {
                    return 1;
                } else {
                    return -1;
                }
            });
            return array;
        }

        return fnNavigationMenuService;
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('LastPageService', fnLastPageService);

    /** @ngInject */
    function fnLastPageService() {
        return {
            /*
             * This Service is Used to get Last Page of the Table on a page. E.g. If a User Enters 5 as page value in the URL
             * then this service will check if the there is a page 5 in the list of response. if There is no page 5 it will return the last
             * page value calculating from the total items and per page value.
             * */
            getLastPage: function (totalItems, perPage, currentPage) {
                var lastPage;
                if (Math.ceil(totalItems / perPage) < currentPage) {
                    lastPage = Math.ceil(totalItems / perPage);
                } else {
                    lastPage = currentPage;
                }
                if(lastPage === 0) {
                    lastPage = 1;
                }
                return lastPage;
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('jsonToCsvConvertService', jsonToCsvConvertService);

    /** @ngInject */
    function jsonToCsvConvertService() {

        jsonToCsvConvertService.getCsvArray = function (dataArray) {
            var tempArr = [];
            var tempDataForHeader = flatten(dataArray[0]);
            var headerArray = [];
            angular.forEach(tempDataForHeader, function (key, value) {
                headerArray.push(value);
            });
            tempArr.push(headerArray);
            var tempData = [];
            angular.forEach(dataArray, function (value) {
                tempData.push(flatten(value));
            });
            tempArr.push(tempData);
            return tempArr;
        };

        jsonToCsvConvertService.convertToCSV = function (objArray) {
            var array = !angular.isObject(objArray) ? angular.fromJson(objArray) : objArray;
            var str = '';
            for (var i = 0; i < array.length; i++) {
                var line = '';
                for (var index in array[i]) {
                    if (line !== '') {
                        line += ','
                    }
                    line += array[i][index];
                }
                str += line + '\r\n';
            }
            return str;
        };

        jsonToCsvConvertService.convertCSVToJSON = function(str, delimiter) {
            var titles = str.slice(0, str.indexOf('\n')).split(delimiter);
            var rows = str.slice(str.indexOf('\n') + 1).split('\n');
            return rows.map(function (row) {
                var values = row.split(delimiter);
                return titles.reduce(function (object, curr, i) {
                    return object[curr] = values[i], object; //eslint-disable-line
                }, {});
            });
        };

        function flatten(data) {
            var result = {};

            function recurse(cur, prop) {
                if (Object(cur) !== cur) {
                    result[prop] = cur;
                } else if (angular.isArray(cur)) {
                    for (var i = 0, l = cur.length; i < l; i++) {
                        recurse(cur[i], prop ? prop + "." + i : "" + i);
                    }
                    if (l === 0) {
                        result[prop] = [];
                    }
                } else {
                    var isEmpty = true;
                    /*eslint-disable*/
                    for (var p in cur) {
                        isEmpty = false;
                        recurse(cur[p], prop ? prop + "." + p : p);
                    }
                    /*eslint-enable*/
                    if (isEmpty) {
                        result[prop] = {};
                    }
                }
            }

            recurse(data, "");
            return result;
        }

        return jsonToCsvConvertService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('interval', fnInterval);

    /** @ngInject */
    function fnInterval($interval) {
        return {
            //to keep a reference to all the intervals
            intervals: {},

            //create another interval
            start: function (name, callback, delay) {
                var argArr = [];
                //argument is use for callback function parameter.
                angular.forEach(arguments, function(val, argIndex){
                    if(argIndex > 2){
                        argArr.push(val);
                    }
                });
                var len = argArr.length;
                this.intervals[name] = $interval(function () {
                    if(len){
                        // Manage callback function parameters using javascript arguments
                        callback.apply(this, argArr); //Function.prototype.apply
                    } else {
                        callback();
                    }
                }, delay * 1000);
            },

            //clear a single interval
            clear: function (name) {
                $interval.cancel(this.intervals[name]);
            },

            //clear all intervals
            clearAll: function () {
                angular.forEach(this.intervals, function (interval) {
                    $interval.cancel(interval);
                });
                this.intervals = {}; //clear the object
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('InterceptorsService', InterceptorsService);

    /** @ngInject */
    function InterceptorsService($stateParams, $rootScope, $cookies, $q, $injector, $window, $base64, amaran, DB, PaginationService) {
        var linkStr;

        function fnErrorMsg(statusCode) {
            switch (statusCode) {
                case 401:
                    // amaran.error('Access is denied due to invalid credentials.', 'Sorry that didn\'t work!');
                    $rootScope.$broadcast('401_error');
                    break;

                /* case 403:
                     amaran.error('Do not have permission.', 'Sorry that didn\'t work!');
                     break;

                 // case 500:
                 case -1:
                     amaran.error('An unexpected error has occurred. Please try again.');
                     break;
*/
                default:
                    break;
            }
        }

        return {
            'request': function (req, app, apiObj) {
                //var APIFactory = $injector.get('APIFactory');
                var token = $cookies.get('phoenix');
                //var hashFunction = $window.btoa;
                var phoenixHeader = {};
                /*
                * This condition will be true when the Call is made from a factory/service and not when the API call is made from
                * a custom $http call in which case the following case would not apply.
                * */
                /*if (APIFactory.basicAuthUserName && APIFactory.basicAuthPassword && app) {
                    var hash = hashFunction(APIFactory.basicAuthUserName + ":" + APIFactory.basicAuthPassword);
                    phoenixHeader = {};
                    phoenixHeader['basic-auth'] = "Bearer " + hash;
                } else if (app) { /!*This condition is used when the page refreshes and authUserName and authPassword is not present at time to set the phoenix header this condition is used*!/

                }*/
                if ($stateParams.token && $stateParams.name) { // this used for account verification and used email verification.
                    phoenixHeader['basic-auth'] = "Basic " + $base64.encode("X-FVT:" + $stateParams.token)
                } else if ($stateParams.token) {
                    phoenixHeader['basic-auth'] = "Basic " + $base64.encode("X-FVT:" + $stateParams.token)
                } else if (DB.fnGet('federation')) {
                    phoenixHeader['basic-auth'] = "Basic " + DB.fnGet('federation').sessionObj.federationToken;
                } else if (DB.fnGet('support')) {
                    phoenixHeader['basic-auth'] = "Basic " + DB.fnGet('support').sessionObj.supportToken;
                } else {
                    phoenixHeader['basic-auth'] = "Basic " + token;
                }
                if (req && req.url.startsWith('https://s3.amazonaws.com/storage.predictivetech.io/') && req.method === 'PUT') {
                    req.headers['Content-Type'] = req.config.headers['Content-Type'];
                }

                if (apiObj && apiObj.ContentType) {
                    phoenixHeader['Content-Type'] = apiObj.ContentType;
                }
                if (apiObj && apiObj.identifier) {
                    phoenixHeader['identity-auth'] = apiObj.identifier;
                }
                if (apiObj && DB.fnGet('federation')) {
                    //apiObj['x-pre-api-federation'] = DB.fnGet('federation').id;
                }
                /* eslint-disable */
                if (phoenixHeader !== {} && phoenixObj[app]) {
                    phoenixObj[app].setHeaders(phoenixHeader);
                }
                /* eslint-enable */
                if ($cookies.get('phoenix')) {
                    if (req) {
                        if (req.url.indexOf('.md') === -1) {
                            if (!req.url.startsWith('data:;base64,') && !req.url.startsWith('data:application/json;base64') && !req.url.startsWith('https://s3.amazonaws.com/storage.predictivetech.io/') && req.url !== "https://api.mjml.io/v1/render") {
                                if (DB.fnGet('federation')) {
                                    req.headers['basic-auth'] = "Basic " + DB.fnGet('federation').sessionObj.federationToken;
                                } else if (DB.fnGet('support')) {
                                    req.headers['basic-auth'] = "Basic " + DB.fnGet('support').sessionObj.supportToken;
                                } else {
                                    req.headers['basic-auth'] = "Basic " + token;
                                }
                            }
                            if (req.url === "https://api.mjml.io/v1/render") {
                                var userToken = "dc425d75-dd5d-4d52-9ef2-c42d06e4ecc3:6fec8dbb-2c38-4a65-969c-ae09ccd25abf";
                                req.headers.authorization = "Basic " + $base64.encode(userToken);
                            }

                            if (req.url.startsWith('https://dev.tracker.ecsmon.ecsiteapp.com.s3.amazonaws.com/attachments')) {
                                if (DB.fnGet('federation')) {
                                    req.headers.authorization = "Basic " + DB.fnGet('federation').sessionObj.federationToken;
                                } else if (DB.fnGet('support')) {
                                    req.headers.authorization = "Basic " + DB.fnGet('support').sessionObj.supportToken;
                                } else {
                                    req.headers.authorization = "Basic " + token;
                                }
                                req.headers['Content-Type'] = req.config.headers['Content-Type'];
                            }
                            //req.headers['X-Phoenix-Session'] = token;
                            var typArr = ['png', 'jpeg', 'gif'];
                            if (req && req.url) {
                                var splitArr = req.url.split('.');
                                var type = splitArr[splitArr.length - 1];
                                if (typArr.includes(type)) {
                                    req.headers.Accept = "image/png, image/jpeg, image/gif";
                                }
                            }
                            if (DB.fnGet('federation')) {
                                req.headers['federation-auth'] = DB.fnGet('federation').id;
                            }
                            if (DB.fnGet('sudo')) {
                                req.headers['x-pre-api-sudo'] = DB.fnGet('sudo').id;
                            }
                            if (req && req.url.startsWith('https://export.highcharts.com')) {
                                delete req.headers['basic-auth'];
                                if (req.headers['Content-Type']) {
                                    req.headers['Content-Type'] = 'application/json'
                                }
                            }
                        } else {
                            delete req.headers["X-Requested-With"]
                        }

                    } else {
                        //phoenixHeader.authorization = "Basic " + token;
                        //phoenixHeader['X-Phoenix-Session'] = token;
                        if (angular.isDefined(DB.fnGet('federation'))) {
                            phoenixHeader['basic-auth'] = DB.fnGet('federation').sessionObj.federationToken;
                        }
                        if (angular.isDefined(DB.fnGet('support'))) {
                            phoenixHeader['basic-auth'] = DB.fnGet('support').sessionObj.supportToken;
                        }
                        if (DB.fnGet('sudo')) {
                            phoenixHeader['x-pre-api-sudo'] = DB.fnGet('sudo').id;
                        }
                        /* eslint-disable */
                        //phoenixObj[app].setHeaders(phoenixHeader);
                        /* eslint-enable */

                    }

                }
                return req;
            },

            'requestError': function (rejection) {
                return rejection;
            },

            'response': function (response) {
                if (response && response.url && response.url.includes('access/sessions') && (response.method === 'POST' || response.method === 'GET')) {
                    var currentAuthUserId = response.headers['x-pre-api-principal-id'];
                    if (currentAuthUserId) {
                        DB.fnSet('xContextId', currentAuthUserId);
                    }
                }
                var version;
                if (angular.isDefined(response.config)) {
                    /*-------------- Create Pagination Object -------------*/
                    if (response.headers('Link') !== null) {
                        linkStr = response.headers('Link');
                        PaginationService.SetPagination(linkStr, response.headers['x-pre-api-collection'], response.url);
                    } else {
                        if (angular.isDefined(response.url)) {
                            PaginationService.SetPagination('', response.headers['x-pre-api-collection'], response.url);
                        }
                    }
                    if (response.headers('x-pre-access-version') !== null) {
                        version = response.headers('x-pre-access-version');
                        DB.fnSet('xPhoenixVersion', version);
                    }
                    return response;
                } else {
                    if (response.status === 200 && response.method === 'GET') {
                        /*-------------- Create Pagination Object -------------*/
                        if (angular.isDefined(response.headers.link)) {
                            linkStr = response.headers.link;
                            PaginationService.SetPagination(linkStr, response.headers['x-pre-api-collection'], response.url);
                        } else {
                            if (angular.isDefined(response.url)) {
                                PaginationService.SetPagination('', response.headers['x-pre-api-collection'], response.url);
                            }
                        }
                        if (angular.isDefined(response.headers['x-pre-access-version'])) {
                            version = response.headers['x-pre-access-version'];
                            DB.fnSet('xPhoenixVersion', version);
                        }
                    }
                }

            },

            'responseError': function (rejection) {
                if (!(rejection.url && rejection.url.endsWith('/access/sessions') &&
                    rejection.method === 'DELETE' && rejection.status === 401)) {
                    fnErrorMsg(rejection.status);
                }
                return rejection;
            }


            /* request: function (req, phoenix) {
                 var APIFactory = $injector.get('APIFactory');
                 var token = $cookies.get('phoenix');
                 var hashFunction = $window.btoa;
                 var hash = hashFunction(APIFactory.basicAuthUserName + ":" + APIFactory.basicAuthPassword);
                 var phoenixHeader = {};
                 //get 'phoenix'(cookie) and set in API request call with 'Phoenix-Token' header
                 if ($cookies.get('phoenix')) {
                     if (req) {
                         if (req.url.indexOf('.md') === -1) {
                             req.headers.authorization = "Bearer " + hash;
                             req.headers['X-Phoenix-Session'] = token;
                             if (DB.fnGet('xSudoId')) {
                                 req.headers['X-Phoenix-Sudo-Id'] = DB.fnGet('xSudoId');
                             }
                         } else {
                             delete req.headers["X-Requested-With"]
                         }

                     } else {
                         phoenixHeader.authorization = "Bearer " + hash;
                         phoenixHeader['X-Phoenix-Session'] = token;
                         if (angular.isDefined(DB.fnGet('xSudoId'))) {
                             phoenixHeader['X-Phoenix-Sudo-Id'] = DB.fnGet('xSudoId');
                         }
                         phoenix.api.setHeaders(phoenixHeader);
                     }

                 } else if (angular.isDefined(req)) {
                     if (angular.isDefined(req.url)) {
                         if ((req.url).indexOf('api/users') === -1) {
                             req.headers.authorization = null;
                         }
                     }
                     interval.clearAll();
                 } else {
                     phoenixHeader.authorization = "Bearer " + hash;
                     phoenix.api.setHeaders(phoenixHeader);
                 }

                 //If 'phoenix'(cookie) not available ask to user login.
                 var deferred = $q.defer();

                 function fnRedirectUrl(url) {
                     if ($location.path() !== url) {
                         $location.url(url);
                     } else {
                         deferred.resolve(req);
                     }
                 }

                 if (!token) {
                     interval.clearAll();
                     if (DB.fnGet('loginUserEmail')) {
                         fnRedirectUrl('/lock');
                     } else {
                         fnRedirectUrl('/login');
                     }
                 }
                 else {
                     //If user already login and trying to access login screen.
                     if ($location.path() === '/login' || $location.path() === '/lock') {
                         var state = $injector.get('$state');
                         var stateParams = $injector.get('$stateParams');
                         if (state.current.name !== '') {
                             if (state.current.name === 'login' || state.current.name === 'lock') {
                                 $location.url('/dashboard');
                             } else {
                                 state.go(state.current.name, stateParams);
                             }
                         } else {
                             $location.url('/dashboard');
                         }
                     } else {
                         deferred.resolve(req);
                     }
                 }
                 return deferred.promise;
             },*/
            /*  response: function (res) {
                  var version, linkStr, userId, url;
                  if (angular.isDefined(res.config)) {
                      if (res.status === 200 && res.config.method === 'GET') {
                          /!*-------------- 'Phoenix-Token'(cookie) FOR Authentication -------------*!/
                          if (res.headers('X-Phoenix-Session') !== null) {
                              $cookies.put('phoenix', res.headers('X-Phoenix-Session'));
                          }
                          /!*-------------- Create Pagination Object -------------*!/
                          if (res.headers('Link') !== null) {
                              url = res.config.url;
                              linkStr = res.headers('Link');
                              PaginationService.SetPagination(linkStr, url);
                          }
                          /!*-------------- Set user id -------------*!/
                          if (res.headers('X-Phoenix-Context-Id') !== null) {
                              userId = res.headers('X-Phoenix-Context-Id');
                              if (!res.headers('X-Phoenix-Sudo-Id')) {
                                  DB.fnSet('xContextId', userId);
                              }
                          }
                          /!*--------------- Set X-Phoenix-Version -------------*!/
                          if (res.headers('x-phoenix-version') !== null) {
                              version = res.headers('x-phoenix-version');
                              DB.fnSet('xPhoenixVersion', version);
                          }
                      }
                      return res;
                  } else {
                      if (res.status === 200 && res.method === 'GET') {

                          /!*-------------- 'Phoenix-Token'(cookie) FOR Authentication -------------*!/
                          if (angular.isDefined(res.headers['X-Phoenix-Session'])) {
                              $cookies.put('phoenix', res.headers['X-Phoenix-Session']);
                          }
                          /!*-------------- Create Pagination Object -------------*!/
                          if (angular.isDefined(res.headers.link)) {
                              url = res.url ? res.url : res.config.url;
                              linkStr = res.headers.link;
                              PaginationService.SetPagination(linkStr, url);
                          }
                          /!*-------------- Set user id -------------*!/
                          if (angular.isDefined(res.headers['X-Phoenix-Context-Id'])) {
                              userId = res.headers['X-Phoenix-Context-Id'];
                              if (!res.headers['x-phoenix-sudo-id']) {
                                  DB.fnSet('xContextId', userId);
                              }
                          }
                          /!*--------------- Set X-Phoenix-Version -------------*!/
                          if (angular.isDefined(res.headers['x-phoenix-version'])) {
                              version = res.headers['x-phoenix-version'];
                              DB.fnSet('xPhoenixVersion', version);
                          }
                      }
                  }
              },*/
            // This is the responseError interceptor
            /* responseError: function (rejection) {
                 var deferred = $q.defer();
                 if (rejection.status === 401 || rejection.status === 403) {
                     interval.clearAll();
                     $cookies.remove('phoenix');
                     if ((angular.isUndefined(rejection.headers['x-phoenix-sudo-id'])) ? rejection.headers['x-phoenix-sudo-id'] : rejection.headers('X-Phoenix-Sudo-Id')) {
                         fnErrorMsg(rejection.status);
                         DB.fnRemove('xSudoId');
                         DB.fnRemove('xContextId');
                     } else {
                         // if(!rejection.obj.message){
                         //     amaran.error('You don\'t have permission to see this.', 'Sorry that didn\'t work!');
                         // }
                     }

                     if (DB.fnGet('loginUserEmail')) {
                         $injector.get('$state').transitionTo('lock');
                     } else {
                         $injector.get('$state').transitionTo('login');
                     }

                     deferred.reject(rejection);
                 } else if (rejection.status === 502) {
                     interval.clearAll();
                     $injector.get('$state').transitionTo('limitedAccess');
                     deferred.reject(rejection);
                 } else if (rejection.status === -1) {
                     if (rejection.config.url.indexOf('.md') === -1) {
                         fnErrorMsg(rejection.status);
                         interval.clearAll();
                         $cookies.remove('phoenix');
                         DB.fnRemove('xSudoId');
                         DB.fnRemove('xContextId');
                         if (DB.fnGet('loginUserEmail')) {
                             $injector.get('$state').transitionTo('lock');
                         } else {
                             $injector.get('$state').transitionTo('login');
                         }
                     }
                 }
                 else {
                     fnErrorMsg(rejection.status);
                     deferred.reject(rejection);
                 }
                 return deferred.promise;
             }*/
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('IconService', fnIconService);

    /** @ngInject */
    function fnIconService() {

        return {
            fnGetPhaseIcon: function (phase) {
                var icon = "";
                switch (phase) {
                    case "PROVISIONING":
                        icon = "phase_provisioning";
                        break;
                    case "PROVISIONED":
                        icon = "phase_provisioned";
                        break;
                    case "COMMISSIONING":
                        icon = "phase_commissioning";
                        break;
                    case "COMMISSIONED":
                        icon = "phase_commissioned";
                        break;
                    case "PRODUCTION":
                        icon = "phase_production";
                        break;
                    case "DECOMMISSIONING":
                        icon = "phase_decommissioning";
                        break;
                    case "DECOMMISSIONED":
                        icon = "phase_decommissioned";
                        break;
                    default:
                        icon = "phase_question";
                        break;
                }
                return icon;
            },
            fnGetConnectionIcon: function (connection) {
                var icon = "";
                switch (connection) {
                    case "CONNECTED":
                        icon = "fa-link";
                        break;
                    case "DISCONNECTED":
                        icon = "fa-unlink";
                        break
                }
                return icon;
            },
            fnGetStateIcon: function (state) {
                var icon = "";
                switch (state) {
                    case "ACTIVE":
                        icon = "fa fa-check";
                        break;
                    case "INACTIVE":
                        icon = "fa fa-times";
                        break
                }
                return icon;
            },
            fnGetUserStateIconClass: function (state) {
                var icon = "";
                switch (state) {
                    case "ACTIVE":
                        icon = "fa fa-check";
                        break;
                    case "SUSPENDED":
                        icon = "fa fa-times";
                        break;
                    case "UNCONFIRMED":
                        icon = "fa fa-exclamation error-icon"
                }
                return icon;
            },
            fnGetListenerStateIconClass: function (state) {
                var icon = "";
                switch (state) {
                    case "ACTIVE":
                        icon = "fa fa-check";
                        break;
                    case "INACTIVE":
                        icon = "fa fa-times"
                }
                return icon;
            }
        }
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('GhostService', fnGhostService);

    /** @ngInject */
    function fnGhostService() {

        fnGhostService.fnGetColor = function (attrObj, value) {
            var returnValue = attrObj.defaultColor ? attrObj.defaultColor : '#000';
            var tempObj = null;
            if (attrObj.mapType === "direct") {
                tempObj = _.find(attrObj[attrObj.mapType], {'value': value});
                returnValue = tempObj ? tempObj.color : returnValue;
            } else if (attrObj.mapType === "range") {
                tempObj = attrObj[attrObj.mapType].filter(function (obj) {
                    return value >= obj.from && value <= obj.to;
                })[0];
                returnValue = tempObj ? tempObj.color : returnValue;
            }
            return returnValue;
        };

        fnGhostService.fnGetIconValue = function (attrObj, value) {
            var returnValue = attrObj.defaultIcon ? attrObj.defaultIcon : 'fa-times';
            if(!isNaN(value) && value !== true) {
                value = parseInt(value)
            }
            var tempObj = null;
            if (attrObj.mapType === "direct") {
                tempObj = _.find(attrObj[attrObj.mapType], {'value': value});
                returnValue = tempObj ? tempObj.icon : returnValue;
            } else if (attrObj.mapType === "range") {
                tempObj = attrObj[attrObj.mapType].filter(function (obj) {
                    return value >= obj.from && value <= obj.to;
                })[0];
                returnValue = tempObj ? tempObj.icon : returnValue;
            }
            return returnValue;
        };

        fnGhostService.fnGetToggleValue = function (attrObj, value) {
            var returnValue = attrObj.default.value === true ? attrObj.default.trueText : attrObj.default.falseText;
            var tempObj = null;
            if (attrObj.mapType === "direct") {
                tempObj = _.find(attrObj[attrObj.mapType], {'value': value});
                returnValue = tempObj ? (tempObj.isTrue ? attrObj.default.trueText : attrObj.default.falseText) : returnValue;
            } else if (attrObj.mapType === "range") {
                tempObj = attrObj[attrObj.mapType].filter(function (obj) {
                    return value >= obj.from && value <= obj.to;
                })[0];
                returnValue = tempObj ? (tempObj.isTrue ? attrObj.default.trueText : attrObj.default.falseText) : returnValue;
            }
            return {displayText : returnValue, switchValue: tempObj ? tempObj.isTrue : attrObj.default.value};
        };

        fnGhostService.fnGetTextValue = function (attrObj, value) {
            var returnValue = "default string";
            var tempObj = null;
            if (attrObj.mapType === "direct") {
                var tempVal = value.toString();
                tempObj = _.find(attrObj[attrObj.mapType], {'value': tempVal});
                returnValue = tempObj ? tempObj.text : value;
            } else if (attrObj.mapType === "range") {
                tempObj = attrObj[attrObj.mapType].filter(function (obj) {
                    return value >= obj.from && value <= obj.to;
                })[0];
                returnValue = tempObj ? tempObj.text : value;
            }
            return returnValue;
        };
        return fnGhostService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('FilterQueryService', fnFilterQueryService);

    /** @ngInject */
    function fnFilterQueryService() {
        var filterArr = [];
        var workflowStateArr = [];
        var workflowInfoString = '';
        var workfolwInfoTriggersOutputArr = [];
        var type = '';
        var keyArr = ['i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r'];

        function fnCreateFilterArr(actionPropertiesObj, modelsArr) {
            if (actionPropertiesObj.schema.properties) {
                Object.keys(actionPropertiesObj.schema.properties).forEach(function (key) {
                    var tempKey = '';
                    if (!actionPropertiesObj.basePath) {
                        tempKey = "$." + key;
                    } else {
                        tempKey = actionPropertiesObj.basePath + "." + key;
                    }
                    if (!filterArr.includes(tempKey)) {
                        filterArr.push(tempKey);
                    }
                    if (actionPropertiesObj.schema.properties[key].$ref || (actionPropertiesObj.schema.properties[key].items && actionPropertiesObj.schema.properties[key].items.$ref)) {
                        var temp = actionPropertiesObj.schema.properties[key].$ref ? actionPropertiesObj.schema.properties[key].$ref : actionPropertiesObj.schema.properties[key].items.$ref;
                        var actionPropertiesObj1 = _.find(modelsArr, {'id': temp});
                        if (actionPropertiesObj1) {
                            actionPropertiesObj1.basePath = tempKey;
                            fnCreateFilterArr(actionPropertiesObj1, modelsArr);
                        }
                    }
                });
            }

        }

        function fnCreateStateArr(statePropertiesObj, modelsArr, preFix, count, isCalledForInput) {
            if (statePropertiesObj.schema.properties) {
                Object.keys(statePropertiesObj.schema.properties).forEach(function (key) {
                    var tempKey = '';
                    if (!statePropertiesObj.basePath) {
                        tempKey = "$" + preFix + "." + key;
                    } else {
                        tempKey = statePropertiesObj.basePath + "." + key;
                    }
                    if (statePropertiesObj.schema.properties[key].$ref || (statePropertiesObj.schema.properties[key].items && statePropertiesObj.schema.properties[key].items.$ref)) {
                        var temp = statePropertiesObj.schema.properties[key].$ref ? statePropertiesObj.schema.properties[key].$ref : statePropertiesObj.schema.properties[key].items.$ref;
                        var statePropertiesObj1 = _.find(modelsArr, {'id': temp});
                        if (statePropertiesObj1) {
                            if (statePropertiesObj.schema.properties[key].type === 'array') {
                                statePropertiesObj1.basePath = tempKey + "[" + keyArr[count] + "]";
                                count++;
                            } else {
                                statePropertiesObj1.basePath = tempKey;
                            }
                            fnCreateStateArr(statePropertiesObj1, modelsArr, preFix, count, isCalledForInput);
                        }
                    } else if (statePropertiesObj.schema.properties[key].items && statePropertiesObj.schema.properties[key].items.oneOf) {
                        var tempOneof = statePropertiesObj.schema.properties[key].items.oneOf;
                        _.forEach(tempOneof, function (ref) {
                            var tempId = ref.$ref;
                            if (!statePropertiesObj.basePath.includes(tempId)) {
                                var statePropertiesObj1 = _.find(modelsArr, {'id': tempId});
                                if (statePropertiesObj1) {
                                    if (statePropertiesObj.schema.properties[key].type === 'array') {
                                        statePropertiesObj1.basePath = tempKey + "[" + keyArr[count] + "]";
                                        count++;
                                    } else {
                                        statePropertiesObj1.basePath = tempKey;
                                    }
                                    fnCreateStateArr(statePropertiesObj1, modelsArr, preFix, count, isCalledForInput);
                                }
                            }
                        });
                    } else {
                        if(isCalledForInput && statePropertiesObj.schema.properties[key].required) {
                            tempKey = "*" + tempKey;
                            if (!workflowStateArr.includes(tempKey)) {
                                workflowStateArr.unshift(tempKey);
                            }
                        } else {
                            if (!workflowStateArr.includes(tempKey)) {
                                workflowStateArr.push(tempKey);
                            }
                        }
                    }
                });
            }
        }

        function fnCreateWorkflowInfoStringArr(statePropertiesObj, modelsArr, preFix, count) {
            if (statePropertiesObj.schema.properties) {
                Object.keys(statePropertiesObj.schema.properties).forEach(function (key) {
                    var tempKey = '';
                    if (!statePropertiesObj.basePath) {
                        tempKey = "$" + preFix + "." + key;
                    } else {
                        tempKey = statePropertiesObj.basePath + "." + key;
                    }
                    if (statePropertiesObj.schema.properties[key].$ref || (statePropertiesObj.schema.properties[key].items && statePropertiesObj.schema.properties[key].items.$ref)) {
                        var temp = statePropertiesObj.schema.properties[key].$ref ? statePropertiesObj.schema.properties[key].$ref : statePropertiesObj.schema.properties[key].items.$ref;
                        var statePropertiesObj1 = _.find(modelsArr, {'id': temp});
                        if (statePropertiesObj1) {
                            if (statePropertiesObj.schema.properties[key].type === 'array') {
                                statePropertiesObj1.basePath = tempKey + "[" + keyArr[count] + "]";
                                count++;
                            } else {
                                statePropertiesObj1.basePath = tempKey;
                            }
                            fnCreateWorkflowInfoStringArr(statePropertiesObj1, modelsArr, preFix, count);
                        }
                    } else if (statePropertiesObj.schema.properties[key].items && statePropertiesObj.schema.properties[key].items.oneOf) {
                        var tempOneof = statePropertiesObj.schema.properties[key].items.oneOf;
                        _.forEach(tempOneof, function (ref) {
                            var tempId = ref.$ref;
                            if (!statePropertiesObj.basePath.includes(tempId)) {
                                var statePropertiesObj1 = _.find(modelsArr, {'id': tempId});
                                if (statePropertiesObj1) {
                                    if (statePropertiesObj.schema.properties[key].type === 'array') {
                                        statePropertiesObj1.basePath = tempKey + "[" + keyArr[count] + "]";
                                        count++;
                                    } else {
                                        statePropertiesObj1.basePath = tempKey;
                                    }
                                    fnCreateWorkflowInfoStringArr(statePropertiesObj1, modelsArr, preFix, count);
                                }
                            }
                        });
                    } else {
                        if (!workflowInfoString.includes(tempKey)) {
                            var tempString = '';
                            var stateType = statePropertiesObj.schema.properties[key].type ? '`' + statePropertiesObj.schema.properties[key].type + '`' : '-';
                            if (type === 'Input') {
                                var req = statePropertiesObj.schema.properties[key].required ? 'yes' : 'no';
                                tempString = '| `' + tempKey + '` | ' + stateType + ' | ' + statePropertiesObj.schema.properties[key].description + '|' + req + '\n';
                            } else {
                                tempString = '| `' + tempKey + '` | ' + stateType + ' | ' + statePropertiesObj.schema.properties[key].description + '|\n';
                            }
                            var obj ={keyIndex:tempKey,
                                description:statePropertiesObj.schema.properties[key].description,
                                required:statePropertiesObj.schema.properties[key].required ? 'yes' : 'no',
                                type: statePropertiesObj.schema.properties[key].type ? statePropertiesObj.schema.properties[key].type:''
                            };
                            workfolwInfoTriggersOutputArr.push(obj);
                            workflowInfoString = workflowInfoString.concat(tempString);
                        }
                    }
                });
            }
        }

        return {
            fnGetFilterArr: function (actionArr, modelsObj) {
                filterArr = [];
                var serviceModelsObj = modelsObj;
                _.forEach(actionArr, function (action) {
                    var app = action.split(":")[0];
                    if (serviceModelsObj[app]) {
                        var arr = serviceModelsObj[app];
                        var actionPropertiesObj = _.find(arr, {'id': action});
                        if (actionPropertiesObj) {
                            fnCreateFilterArr(actionPropertiesObj, arr);
                        }
                    }
                });
                return filterArr;
            },
            fnGetWorkflowStateArr: function (stateArr, modelsObj, isCalledForInput) {
                workflowStateArr = [];
                var serviceModelsObj = modelsObj;
                _.forEach(stateArr, function (state) {
                    var count = 0;
                    var app = state.split("/")[0];
                    var id = state.split("/")[1];
                    if (serviceModelsObj[app]) {
                        var arr = serviceModelsObj[app];
                        var statePropertiesObj = {};
                        var preFix = '';
                        if (id.endsWith('[]')) {
                            preFix = "[" + keyArr[count] + "]";
                            statePropertiesObj = _.find(arr, {'id': id.replace('[]', '')});
                            count++;
                        } else {
                            preFix = '';
                            statePropertiesObj = _.find(arr, {'id': id});
                        }
                        if (statePropertiesObj) {
                            fnCreateStateArr(statePropertiesObj, arr, preFix, count, isCalledForInput);
                        }
                    }
                });
                return workflowStateArr;
            },
            fnGetWorkflowInputOutputInfo: function (stateArr, modelsObj, InfoType,isCallFromTriggersModal) {
                type = InfoType;
                workfolwInfoTriggersOutputArr = [];
                if (type === 'Input') {
                    workflowInfoString = '| FIELD      | TYPE     | NOTE                            |REQUIRED |\n|------------|----------|---------------------------------|-------|\n';
                } else {
                    workflowInfoString = '| FIELD      | TYPE     | NOTE                            |\n|------------|----------|---------------------------------|\n';
                }
                var serviceModelsObj = modelsObj;
                _.forEach(stateArr, function (state) {
                    var count = 0;
                    var app = state.split("/")[0];
                    var id = state.split("/")[1];
                    if (serviceModelsObj[app]) {
                        var arr = serviceModelsObj[app];
                        var statePropertiesObj = {};
                        var preFix = '';
                        if (id.endsWith('[]')) {
                            preFix = "[" + keyArr[count] + "]";
                            statePropertiesObj = _.find(arr, {'id': id.replace('[]', '')});
                            count++;
                        } else {
                            preFix = '';
                            statePropertiesObj = _.find(arr, {'id': id});
                        }
                        if (statePropertiesObj) {
                            fnCreateWorkflowInfoStringArr(statePropertiesObj, arr, preFix, count);
                        }
                    }
                });
                if(isCallFromTriggersModal){
                    return workfolwInfoTriggersOutputArr;
                }else{
                    return workflowInfoString;
                }

            },
            fnGetBudgetFilterArr: function () {
                var arr = [
                    "$.id",
                    "$.year",
                    "$.month",
                    "$.currency",
                    "$.service",
                    "$.title",
                    "$.quantity",
                    "$.price",
                    "$.details[i].description",
                    "$.details[i].units",
                    "$.details[i].currency",
                    "$.details[i].quantity",
                    "$.details[i].price"
                ];
                arr = arr.map(function (val) {
                    return {
                        id: val,
                        type: 'string',
                        operators: ['equal',
                            'not_equal',
                            'in',
                            'not_in',
                            'start',
                            'not_start',
                            'end',
                            'not_end',
                            'less',
                            'less_or_equal',
                            'greater',
                            'greater_or_equal']
                    }
                });
                return arr;
            },
            fnGetRoleFilterArr: function (actionsArr,actionOptionArr,filterArr) {
                var tempArr = actionsArr;
                var arr = [];

                if (actionsArr.includes('*') ||
                    actionsArr.includes('access:*') || actionsArr.includes('access:*:*') ||
                    actionsArr.includes('tracker:*') || actionsArr.includes('tracker:*:*') ||
                    actionsArr.includes('pipeline:*') || actionsArr.includes('pipeline:*:*')) {
                    tempArr = actionOptionArr;
                }

                angular.forEach(tempArr, function (value) {
                    var selectModel = value.split(":")[1];


                    var temp = filterArr.filter(function (val) {
                        return val.includes('.' + selectModel + '.');
                    });
                    if (temp.length) {
                        angular.forEach(temp, function (path) {
                            if (!arr.includes(path)) {
                                arr.push(path);
                            }
                        });
                    }

                });
                return arr;
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('FedSudoUserService', fnFedSudoUserService);

    /** @ngInject */
    function fnFedSudoUserService(DB) {
        var loginUser = DB.fnGet('loginUser');
        var fedString = '';
        var sudoString = '';
        var obj = {};
        var fedObj = {};
        var sudoObj = {};
        return {
            fnGetUserData: function (key) {
                loginUser = DB.fnGet('loginUser');
                var value = '';
                if (DB.fnGet('federation') || DB.fnGet('sudo')) {
                    if (DB.fnGet('federation')) {
                        if (loginUser.data && loginUser.data.hasOwnProperty("fed-" + DB.fnGet('federation').id)) {
                            fedObj = angular.fromJson(loginUser.data["fed-" + DB.fnGet('federation').id][0]);
                            if (fedObj.hasOwnProperty(key)) {
                                value = fedObj[key];
                            } else {
                                value = '';
                            }
                        }else{
                            value = '';
                        }
                    } else {
                        if (loginUser.data && loginUser.data.hasOwnProperty("sudo-" + DB.fnGet('sudo').id)) {
                            sudoObj = angular.fromJson(loginUser.data["sudo-" + DB.fnGet('sudo').id][0]);
                            if (sudoObj.hasOwnProperty(key)) {
                                value = sudoObj[key];
                            } else {
                                value = '';
                            }
                        }else{
                            value = '';
                        }
                    }
                } else {
                    value = loginUser && loginUser.data ? (loginUser.data[key] ? loginUser.data[key] : '') : '';
                }
                return value;
            },
            fnSetUserData: function (key, value) {
                loginUser = DB.fnGet('loginUser');
                if (DB.fnGet('federation') || DB.fnGet('sudo')) {
                    if (DB.fnGet('federation')) {
                        if (loginUser.data.hasOwnProperty("fed-" + DB.fnGet('federation').id)) {
                            fedObj = angular.fromJson(loginUser.data["fed-" + DB.fnGet('federation').id][0]);
                            if (fedObj.hasOwnProperty(key)) {
                                obj = fedObj;
                                fedObj[key] = value;
                                fedString = angular.toJson(fedObj);
                                loginUser.data["fed-" + DB.fnGet('federation').id] = ["" + fedString + ""];
                            } else {
                                obj = fedObj;
                                obj[key] = value;
                                fedString = angular.toJson(obj);
                                loginUser.data["fed-" + DB.fnGet('federation').id] = ["" + fedString + ""];
                            }
                        } else {
                            obj = {};
                            obj[key] = value;
                            fedString = angular.toJson(obj);
                            loginUser.data["fed-" + DB.fnGet('federation').id] = ["" + fedString + ""];
                        }
                        DB.fnSet('loginUser', loginUser);
                    } else {
                        if (loginUser.data.hasOwnProperty("sudo-" + DB.fnGet('sudo').id)) {
                            sudoObj = angular.fromJson(loginUser.data["sudo-" + DB.fnGet('sudo').id][0]);
                            if (sudoObj.hasOwnProperty(key)) {
                                obj = sudoObj;
                                sudoObj[key] = value;
                                sudoString = angular.toJson(sudoObj);
                                loginUser.data["sudo-" + DB.fnGet('sudo').id] = ["" + sudoString + ""];
                            } else {
                                obj = sudoObj;
                                obj[key] = value;
                                sudoString = angular.toJson(obj);
                                loginUser.data["sudo-" + DB.fnGet('sudo').id] = ["" + sudoString + ""];
                            }
                        } else {
                            obj = {};
                            obj[key] = value;
                            sudoString = angular.toJson(obj);
                            loginUser.data["sudo-" + DB.fnGet('sudo').id] = ["" + sudoString + ""];
                        }
                        DB.fnSet('loginUser', loginUser);
                    }
                }
                return loginUser;
            },
            fnRemoveUserData:function (key) {
                loginUser = DB.fnGet('loginUser');
                if (DB.fnGet('federation') || DB.fnGet('sudo')) {
                    if (DB.fnGet('federation')) {
                        if (loginUser.data.hasOwnProperty("fed-" + DB.fnGet('federation').id)) {
                            fedObj = angular.fromJson(loginUser.data["fed-" + DB.fnGet('federation').id][0]);
                            if (fedObj.hasOwnProperty(key)) {
                                obj = fedObj;
                                delete obj[key];
                                fedString = angular.toJson(fedObj);
                                loginUser.data["fed-" + DB.fnGet('federation').id] = ["" + fedString + ""];
                            }
                        }
                    }else{
                        if (loginUser.data.hasOwnProperty("sudo-" + DB.fnGet('sudo').id)) {
                            sudoObj = angular.fromJson(loginUser.data["sudo-" + DB.fnGet('sudo').id][0]);
                            if (sudoObj.hasOwnProperty(key)) {
                                obj = sudoObj;
                                delete obj[key];
                                sudoString = angular.toJson(sudoObj);
                                loginUser.data["sudo-" + DB.fnGet('sudo').id] = ["" + sudoString + ""];
                            }
                        }
                    }
                }
                DB.fnSet('loginUser', loginUser);
                return loginUser;
            },
            fnSetAuthUserData: function (key, value) {
                loginUser = DB.fnGet('loginUser');
                loginUser.data[key] = value;
                DB.fnSet('loginUser', loginUser);
                return loginUser;
            },
            fnGetAuthUserData: function (key) {
                loginUser = DB.fnGet('loginUser');
                return loginUser.data ? (loginUser.data[key] ? loginUser.data[key] : '') : '';
            }
        }
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('DB', fnDBService);

    /** @ngInject */
    function fnDBService($base64, localStorage, dbName) {

        var db = {};

        fnDBService.fnGet = function (key) {
            var db = angular.fromJson($base64.decode(localStorage.getItem(dbName)));
            return db[key];
        };

        fnDBService.fnSet = function (key, value) {
            var db = angular.fromJson($base64.decode(localStorage.getItem(dbName)));
            db[key] = value;
            localStorage.setItem(dbName, $base64.encode(angular.toJson(db)));
        };

        fnDBService.fnRemove = function (key) {
            var db = angular.fromJson($base64.decode(localStorage.getItem(dbName)));
            delete db[key];
            localStorage.setItem(dbName, $base64.encode(angular.toJson(db)));
        };

        fnDBService.fnInitDB = function () {
            if (angular.isUndefined(localStorage.getItem(dbName)) || localStorage.getItem(dbName) === null) {
                localStorage.setItem(dbName, $base64.encode(angular.toJson(db)));
            }
        };

        return fnDBService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('CurrencyService', fnCurrencyService);

    /** @ngInject */
    function fnCurrencyService() {

        var currencysArr = [{
            code: "ALL",
            symbol: "Lek"
        }, {
            code: "AFN",
            symbol: "؋"
        }, {
            code: "ARS",
            symbol: "$"
        }, {
            code: "AWG",
            symbol: "ƒ"
        }, {
            code: "AUD",
            symbol: "$"
        }, {
            code: "AZN",
            symbol: "₼"
        }, {
            code: "BSD",
            symbol: "$"
        }, {
            code: "BBD",
            symbol: "$"
        }, {
            code: "BYN",
            symbol: "Br"
        }, {
            code: "BZD",
            symbol: "BZ$"
        }, {
            code: "BMD",
            symbol: "$"
        }, {
            code: "BOB",
            symbol: "$b"
        }, {
            code: "BAM",
            symbol: "KM"
        }, {
            code: "BWP",
            symbol: "P"
        }, {
            code: "BGN",
            symbol: "лв"
        }, {
            code: "BRL",
            symbol: "R$"
        }, {
            code: "BND",
            symbol: "$"
        }, {
            code: "KHR",
            symbol: "៛"
        }, {
            code: "CAD",
            symbol: "$"
        }, {
            code: "KYD",
            symbol: "$"
        }, {
            code: "CLP",
            symbol: "$"
        }, {
            code: "CNY",
            symbol: "¥"
        }, {
            code: "COP",
            symbol: "$"
        }, {
            code: "CRC",
            symbol: "₡"
        }, {
            code: "HRK",
            symbol: "kn"
        }, {
            code: "CUP",
            symbol: "₱"
        }, {
            code: "CZK",
            symbol: "Kč"
        }, {
            code: "DKK",
            symbol: "kr"
        }, {
            code: "DOP",
            symbol: "RD$"
        }, {
            code: "XCD",
            symbol: "$"
        }, {
            code: "EGP",
            symbol: "£"
        }, {
            code: "SVC",
            symbol: "$"
        }, {
            code: "EUR",
            symbol: "€"
        }, {
            code: "FKP",
            symbol: "£"
        }, {
            code: "FJD",
            symbol: "$"
        }, {
            code: "GHS",
            symbol: "¢"
        }, {
            code: "GIP",
            symbol: "£"
        }, {
            code: "GTQ",
            symbol: "Q"
        }, {
            code: "GGP",
            symbol: "£"
        }, {
            code: "GYD",
            symbol: "$"
        }, {
            code: "HNL",
            symbol: "L"
        }, {
            code: "HKD",
            symbol: "$"
        }, {
            code: "HUF",
            symbol: "Ft"
        }, {
            code: "ISK",
            symbol: "kr"
        }, {
            code: "INR",
            symbol: "Rs"
        }, {
            code: "IDR",
            symbol: "Rp"
        }, {
            code: "IRR",
            symbol: "﷼"
        }, {
            code: "IMP",
            symbol: "£"
        }, {
            code: "ILS",
            symbol: "₪"
        }, {
            code: "JMD",
            symbol: "J$"
        }, {
            code: "JPY",
            symbol: "¥"
        }, {
            code: "JEP",
            symbol: "£"
        }, {
            code: "KZT",
            symbol: "лв"
        }, {
            code: "KPW",
            symbol: "₩"
        }, {
            code: "KRW",
            symbol: "₩"
        }, {
            code: "KGS",
            symbol: "лв"
        }, {
            code: "LAK",
            symbol: "₭"
        }, {
            code: "LBP",
            symbol: "£"
        }, {
            code: "LRD",
            symbol: "$"
        }, {
            code: "MKD",
            symbol: "ден"
        }, {
            code: "MYR",
            symbol: "RM"
        }, {
            code: "MUR",
            symbol: "₨"
        }, {
            code: "MXN",
            symbol: "$"
        }, {
            code: "MNT",
            symbol: "₮"
        }, {
            code: "MZN",
            symbol: "MT"
        }, {
            code: "NAD",
            symbol: "$"
        }, {
            code: "NPR",
            symbol: "₨"
        }, {
            code: "ANG",
            symbol: "ƒ"
        }, {
            code: "NZD",
            symbol: "$"
        }, {
            code: "NIO",
            symbol: "C$"
        }, {
            code: "NGN",
            symbol: "₦"
        }, {
            code: "NOK",
            symbol: "kr"
        }, {
            code: "OMR",
            symbol: "﷼"
        }, {
            code: "PKR",
            symbol: "₨"
        }, {
            code: "PAB",
            symbol: "B/."
        }, {
            code: "PYG",
            symbol: "Gs"
        }, {
            code: "PEN",
            symbol: "S/."
        }, {
            code: "PHP",
            symbol: "₱"
        }, {
            code: "PLN",
            symbol: "zł"
        }, {
            code: "QAR",
            symbol: "﷼"
        }, {
            code: "RON",
            symbol: "lei"
        }, {
            code: "RUB",
            symbol: "₽"
        }, {
            code: "SHP",
            symbol: "£"
        }, {
            code: "SAR",
            symbol: "﷼"
        }, {
            code: "RSD",
            symbol: "Дин."
        }, {
            code: "SCR",
            symbol: "₨"
        }, {
            code: "SGD",
            symbol: "$"
        }, {
            code: "SBD",
            symbol: "$"
        }, {
            code: "SOS",
            symbol: "S"
        }, {
            code: "ZAR",
            symbol: "R"
        }, {
            code: "LKR",
            symbol: "₨"
        }, {
            code: "SEK",
            symbol: "kr"
        }, {
            code: "CHF",
            symbol: "CHF"
        }, {
            code: "SRD",
            symbol: "$"
        }, {
            code: "SYP",
            symbol: "£"
        }, {
            code: "TWD",
            symbol: "NT$"
        }, {
            code: "THB",
            symbol: "฿"
        }, {
            code: "TTD",
            symbol: "TT$"
        }, {
            code: "TRY",
            symbol: "T"
        }, {
            code: "TVD",
            symbol: "$"
        }, {
            code: "UAH",
            symbol: "₴"
        }, {
            code: "GBP",
            symbol: "£"
        }, {
            code: "USD",
            symbol: "$"
        }, {
            code: "UYU",
            symbol: "$U"
        }, {
            code: "UZS",
            symbol: "лв"
        }, {
            code: "VEF",
            symbol: "Bs"
        }, {
            code: "VND",
            symbol: "₫"
        }, {
            code: "YER",
            symbol: "﷼"
        }, {
            code: "ZWD",
            symbol: "Z$"
        }];
        return {

            getCurrencySymbol: function (currency) {
                var symbol = _.find(currencysArr, {'code': currency});
                if (symbol) {
                    return symbol.symbol;
                } else {
                    return "$";
                }
            },
            fnNumberToCurrencyConvert: function (value) {
                return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            }

        };
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('copyService', fnCopyService);

    /** @ngInject */
    function fnCopyService() {

        fnCopyService.fnCopyToClipboard = function (value) {
            var $temp = angular.element("<input>");
            angular.element("body").append($temp);
            $temp.val(value).select(); // Make $tamp input value selected
            document.execCommand("copy"); // Copy selected value
            $temp.remove();
        };
        return fnCopyService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('componentService', componentService);

    /** @ngInject */
    function componentService(ColorService, FedSudoUserService) {
        componentService.getUniqueIndex = function (deviceArr) {
            var arr = [];
            angular.forEach(deviceArr, function (value) {
                var str = value.index ? value.index : '';
                var testArr = str.split("#");
                var tempArr = [str];
                testArr.map(function () {
                    str = str.split("#").reverse().slice(1).reverse().join("#");
                    tempArr.push(str);
                });
                tempArr.pop();
                arr = arr.concat(tempArr);
            });

            return _.uniq(_.map(arr)).sort();
        };

        componentService.getHierarchy = function (indexArr, deviceArr, resetDeviceArr) {
            var inventoryPreferences = [];
            if(deviceArr && deviceArr.length !== 0){
                var isFindInventoryPreferences = FedSudoUserService.fnGetUserData("inventoryPreferences" + deviceArr[0].id.substring(0, deviceArr[0].id.lastIndexOf("-")));
                if(isFindInventoryPreferences !== ''){
                    inventoryPreferences = isFindInventoryPreferences;
                }
            }
            var nestedArr = [];
            var temp, Obj, healthColor, healthDarkColor;
            var deviceObj = {};
            _.forEach(deviceArr, function (d) {
                deviceObj[d.index] = d
            });
            var resetDeviceObj = {};
            _.forEach(resetDeviceArr, function (d) {
                resetDeviceObj[d.index] = d
            });
            indexArr.map(function (value) {
                var tempData = deviceObj[value];
                if (tempData) {
                    tempData.isExpanded = _.indexOf(inventoryPreferences, value) !== -1;
                    nestedArr.push(tempData)
                } else {
                    temp = deviceObj[value.split("#").reverse().slice(1).reverse().join("#")];
                    Obj = {};
                    if (temp) {
                        healthColor = ColorService.getHealthColorForLoop(0)["background-color"];
                        healthDarkColor = ColorService.getDark(ColorService.getHealthColorForLoop(0)["background-color"], 10);
                        Obj = {
                            id: guid(),
                            index: value,
                            health: 0,
                            healthColor: healthColor,
                            healthDarkColor: healthDarkColor,
                            isExpanded: _.indexOf(inventoryPreferences, value) !== -1
                        };
                        nestedArr.push(Obj)
                    } else {
                        var resetTempData = resetDeviceObj[value];
                        if (resetTempData) {
                            Obj = {
                                id: resetTempData.id,
                                index: value,
                                typeId: resetTempData.typeId,
                                enabled: resetTempData.enabled,
                                health: resetTempData.health,
                                healthName: resetTempData.healthName,
                                toolTipName: resetTempData.toolTipName,
                                bgColor: resetTempData.bgColor,
                                textColor: resetTempData.textColor,
                                defaultHealth: resetTempData.defaultHealth,
                                healthColor: resetTempData.healthColor,
                                isExpanded: _.indexOf(inventoryPreferences, value) !== -1,
                                model: resetTempData.model,
                                name: resetTempData.name,
                                oem: resetTempData.oem,
                                phase: resetTempData.phase,
                                typeObj:resetTempData.typeObj
                            };
                        }
                        if (Object.keys(Obj).length) {
                            nestedArr.push(Obj);
                        } else {
                            temp = deviceObj[value.split("#").reverse().slice(1).reverse().join("#")];
                            healthColor = ColorService.getHealthColorForLoop(0)["background-color"];
                            healthDarkColor = ColorService.getDark(ColorService.getHealthColorForLoop(0)["background-color"], 10);
                            Obj = {
                                id: guid(),
                                index: value,
                                health: 0,
                                healthColor: healthColor,
                                healthDarkColor: healthDarkColor,
                                isExpanded: _.indexOf(inventoryPreferences, value) !== -1
                            };
                            nestedArr.push(Obj);
                        }
                    }
                }
            });
            var nested = fnCreateStructure(nestedArr);
            return _.filter(nested, {'parentIndex': ""});
        };

        function fnGetParentIndex(index) {
            var parentIndex = '';
            if (index.includes("#")) {
                var lastIndex = index.lastIndexOf("#");
                parentIndex = index.substr(0, lastIndex);
            } else {
                parentIndex = '';
            }
            /* var indexArr = index.split('#');
             var parentIndex = '';
             if (indexArr.length !== 1) {
                 parentIndex = index.replace("#" + indexArr[indexArr.length - 1], '')
             }*/
            return parentIndex;
        }

        function fnCreateStructure(f) {
            return f.sort(function (a, b) {
                return a.index.length < b.index.length ? 1 : a.index.length === b.index.length ? a.index < b.index ? -1 : 1 : -1;
            }).reduce(function (p, c, i, a) {
                c.parentIndex = fnGetParentIndex(c.index);
                var parent = !!c.parentIndex && a.find(function (e) {
                    return e.index === c.parentIndex;
                });
                /*eslint-disable*/
                if (!!parent) {
                    if (!!parent.children) {
                        var isValueFind = _.find(parent.children, {'index': c.index});
                        if (!isValueFind) {
                            parent.children.push(c);
                        }
                    } else {
                        (parent.children = [c]);
                    }
                } else {
                    p.push(c);
                }
                /*eslint-enable*/
                //!!parent ? !!parent.children && parent.children.push(c) || (parent.children = [c]) : p.push(c);
                return p;
            }, []);
        }

        componentService.getUniqueIndexForTriggersModal = function (deviceArr) {
            var arr = [];
            angular.forEach(deviceArr, function (value) {
                var str = value.keyIndex;
                var testArr = str.split(".");
                var tempArr = [str];
                testArr.map(function () {
                    str = str.split(".").reverse().slice(1).reverse().join(".");
                    tempArr.push(str);
                });
                tempArr.pop();
                arr = arr.concat(tempArr);
            });

            return _.uniq(_.map(arr)).sort();
        };

        componentService.getHierarchyForTriggersModal = function (indexArr, deviceArr) {
            var nestedArr = [];
            var temp, Obj;
            indexArr.map(function (value) {
                var tempData = _.find(deviceArr, {"keyIndex": value});
                if (tempData) {
                    tempData.index = value;
                    nestedArr.push(tempData)
                } else {
                    temp = _.find(deviceArr, {"keyIndex": value});
                    Obj = {};
                    if (temp) {
                        Obj = {
                            id: (new Date()).getTime(),
                            index: value,
                            'isClickAble': true
                        };
                        nestedArr.push(Obj)
                    } else {
                        temp = _.find(deviceArr, {"keyIndex": value});
                        Obj = {
                            id: (new Date()).getTime(),
                            index: value,
                            'isClickAble': true
                        };
                        nestedArr.push(Obj);
                    }
                }
            });
            var nested = fnCreateStructureForTriggersModal(nestedArr);
            return _.filter(nested, {'parentIndex': ""});
        };

        function fnCreateStructureForTriggersModal(f) {
            return f.sort(function (a, b) {
                return a.index.length < b.index.length ? 1 : a.index.length === b.index.length ? a.index < b.index ? -1 : 1 : -1;
            }).reduce(function (p, c, i, a) {
                c.parentIndex = fnGetParentIndexForTriggersModal(c.index);
                var parent = !!c.parentIndex && a.find(function (e) {
                    return e.index === c.parentIndex;
                });
                /*eslint-disable*/
                if (!!parent) {
                    if (!!parent.children) {
                        var isValueFind = _.find(parent.children, {'index': c.index});
                        if (!isValueFind) {
                            parent.children.push(c);
                        }
                    } else {
                        (parent.children = [c]);
                    }
                } else {
                    p.push(c);
                }
                /*eslint-enable*/
                //!!parent ? !!parent.children && parent.children.push(c) || (parent.children = [c]) : p.push(c);
                return p;
            }, []);
        }

        function fnGetParentIndexForTriggersModal(index) {
            var indexArr = index.split('.');
            var parentIndex = '';
            if (indexArr.length !== 1) {
                parentIndex = index.replace("." + indexArr[indexArr.length - 1], '')
            }
            return parentIndex;
        }

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }

            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        }

        return componentService;
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('ColorService', fnColorService);

    /** @ngInject */
    function fnColorService(DB) {
        var healthObj = {};

        function subtractLight(color, amount) {
            var cc = parseInt(color, 16) - amount;
            var c = cc < 0 ? 0 : cc;
            c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
            return c;
        }

        function addLight(color, amount) {
            var cc = parseInt(color, 16) + amount;
            var c = cc > 255 ? 255 : cc;
            c = c.toString(16).length > 1 ? c.toString(16) : "0" + c.toString(16);
            return c;
        }

        function hexify(color) {
            var values = color
                .replace(/rgba?\(/, '')
                .replace(/\)/, '')
                .replace(/[\s+]/g, '')
                .split(',');
            var a = parseFloat(values[3] || 1),
                r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
                g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
                b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255);
            return "#" +
                ("0" + r.toString(16)).slice(-2) +
                ("0" + g.toString(16)).slice(-2) +
                ("0" + b.toString(16)).slice(-2);
        }

        return {
            setHealthObj: function (healthsArr) {
                healthObj = {};
                var self = this;
                var data = healthsArr ? healthsArr : angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                _.forEach(data, function (obj) {
                    if (healthObj[obj.projectId]) {
                        healthObj[obj.projectId][obj.value] = _.cloneDeep(obj);
                    } else {
                        healthObj[obj.projectId] = {};
                        healthObj[obj.projectId][obj.value] = _.cloneDeep(obj);
                    }
                    if (healthObj[obj.projectId][obj.value].color.startsWith("#")) {
                        healthObj[obj.projectId][obj.value].textColor = self.getContrastTextColor(healthObj[obj.projectId][obj.value].color);
                    } else {
                        healthObj[obj.projectId][obj.value].textColor = self.getContrastTextColor(hexify(healthObj[obj.projectId][obj.value].color));
                    }
                });
            },
            fnSetHealthData: function (healthsArr) {
                DB.fnSet("healthArray", healthsArr);
                this.setHealthObj(healthsArr);
                return '';
            },
            fnGetHealthData: function () {
                return healthObj;
            },
            getDark: function (color, amount) {
                color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
                amount = parseInt(255 * amount / 100);
                color = "#" + subtractLight(color.substring(0, 2), amount) + subtractLight(color.substring(2, 4), amount) + subtractLight(color.substring(4, 6), amount);
                return color;
            },

            getLighten: function (color, amount) {
                color = color.indexOf("#") >= 0 ? color.substring(1, color.length) : color;
                amount = parseInt(255 * amount / 100);
                color = "#" + addLight(color.substring(0, 2), amount) + addLight(color.substring(2, 4), amount) + addLight(color.substring(4, 6), amount);
                return color;
            },

            hexToRgbA: function (hex, opacity) {
                var c;
                if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                    c = hex.substring(1).split('');
                    if (c.length === 3) {
                        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                    }
                    c = '0x' + c.join('');
                    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')';
                }
                throw new Error('Bad Hex');
            },

            getContrastTextColor: function (hex) {
                if (hex.indexOf('#') === 0) {
                    hex = hex.slice(1);
                }
                // convert 3-digit hex to 6-digits.
                if (hex.length === 3) {
                    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                }
                if (hex.length !== 6) {
                    throw new Error('Invalid HEX color.');
                }
                var r = parseInt(hex.slice(0, 2), 16),
                    g = parseInt(hex.slice(2, 4), 16),
                    b = parseInt(hex.slice(4, 6), 16);
                // http://stackoverflow.com/a/3943023/112731
                return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                    ? '#000000'
                    : '#FFFFFF';
            },
            getHealthColor: function (statusCode) {
                var color = "";
                var textColor = "";
                var text = "";
                if (angular.isDefined(statusCode)) {
                    var healthArr = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                    var flag = false;
                    var selectedHealthObj = {};
                    healthArr.map(function (healthObj) {
                        if (healthObj.code === statusCode) {
                            selectedHealthObj = angular.copy(healthObj);
                            flag = true;
                        }
                    });

                    if (flag) {
                        color = selectedHealthObj.color;
                        text = selectedHealthObj.name ? selectedHealthObj.name : statusCode;
                        if (color.startsWith("#")) {
                            textColor = this.getContrastTextColor(color);
                        } else {
                            textColor = this.getContrastTextColor(hexify(color));
                        }
                    } else {
                        // also change color in getHealthColorForDeviceInventory() function
                        text = statusCode;
                        var opacity = "0.";
                        if (statusCode.toString().substr(-2) === "00") {
                            opacity = 0.1;
                        } else {
                            opacity = "0." + statusCode.toString().substr(-2);
                        }
                        if (statusCode >= 100 && statusCode <= 199) {
                            color = "rgba(128,128,128," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 200 && statusCode <= 299) {
                            color = "rgba(0,255,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 300 && statusCode <= 399) {
                            color = "rgba(255,255,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 400 && statusCode <= 499) {
                            color = "rgba(255,140,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 500 && statusCode <= 599) {
                            color = "rgba(255,0,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else {
                            color = "rgba(128,128,128,1.0)";
                            textColor = this.getContrastTextColor(hexify(color));
                        }
                    }
                    return {
                        "background-color": color.startsWith("#") ? color : hexify(color),
                        "color": "" + textColor,
                        "content": text
                    };
                }
            },
            getHealthColorForLoop: function (projectId, statusCode) {
                var color = "";
                var textColor = "";
                var text = "";
                if (angular.isDefined(statusCode) && angular.isDefined(projectId)) {
                    /*if (Object.keys(healthObj).length === 0) {
                        var healthArr = angular.isDefined(DB.fnGet("healthArray")) ? DB.fnGet("healthArray") : [];
                        healthArr.forEach(function (obj) {
                            //healthObj[obj.code] = obj
                            if (healthObj[obj.projectId]) {
                                healthObj[obj.projectId][obj.value] = _.cloneDeep(obj);
                            } else {
                                healthObj[obj.projectId] = {};
                                healthObj[obj.projectId][obj.value] = _.cloneDeep(obj);
                            }
                        });
                    }*/
                    if (healthObj && healthObj[projectId] && healthObj[projectId][statusCode]) {
                        var selectedHealthObj = healthObj[projectId][statusCode];
                        color = selectedHealthObj.color;
                        text = selectedHealthObj.name ? selectedHealthObj.name : statusCode;
                        textColor = selectedHealthObj.textColor
                    } else {
                        text = statusCode;
                        var opacity = "0.";
                        if (statusCode.toString().substr(-2) === "00") {
                            opacity = 0.1;
                        } else {
                            opacity = "0." + statusCode.toString().substr(-2);
                        }
                        if (statusCode >= 100 && statusCode <= 199) {
                            color = "rgba(128,128,128," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 200 && statusCode <= 299) {
                            color = "rgba(0,255,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 300 && statusCode <= 399) {
                            color = "rgba(255,255,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 400 && statusCode <= 499) {
                            color = "rgba(255,140,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else if (statusCode >= 500 && statusCode <= 599) {
                            color = "rgba(255,0,0," + opacity + ")";
                            textColor = this.getContrastTextColor(hexify(color));
                        } else {
                            color = "rgba(128,128,128,1.0)";
                            textColor = this.getContrastTextColor(hexify(color));
                        }
                    }
                    return {
                        "background-color": color.startsWith("#") ? color : hexify(color),
                        "color": "" + textColor,
                        "content": text
                    };
                }
            },
            getHealthColorForDeviceInventory: function (statusCode) {
                var color = "";
                var opacity = "0.";
                if (statusCode.toString().substr(-2) === "00") {
                    opacity = 0.1;
                } else {
                    opacity = "0." + statusCode.toString().substr(-2);
                }
                if (statusCode >= 100 && statusCode <= 199) {
                    color = "rgba(128,128,128," + opacity + ")";
                } else if (statusCode >= 200 && statusCode <= 299) {
                    color = "rgba(0,255,0," + opacity + ")";
                } else if (statusCode >= 300 && statusCode <= 399) {
                    color = "rgba(255,255,0," + opacity + ")";
                } else if (statusCode >= 400 && statusCode <= 499) {
                    color = "rgba(255,140,0," + opacity + ")";
                } else if (statusCode >= 500 && statusCode <= 599) {
                    color = "rgba(255,0,0," + opacity + ")";
                } else {
                    color = "rgba(255,0,0,1.0)";
                }
                return color.startsWith("#") ? color : hexify(color);
            },
            getPhaseColor: function (phaseName) {
                var color = "#000";
                switch (phaseName) {
                    case "PROVISIONING":
                        color = "#0069D9";
                        //change color in SVG file ../assets/images/svg/phase_provisioning.svg
                        break;
                    case "PROVISIONED":
                        color = "#52a4ff";
                        //change color in SVG file ../assets/images/svg/phase_provisioned.svg
                        break;
                    case "COMMISSIONING":
                        color = "#00f9ff";
                        //change color in SVG file ../assets/images/svg/phase_commissioning.svg
                        break;
                    case "COMMISSIONED":
                        color = "#50ff7f";
                        //change color in SVG file ../assets/images/svg/phase_commissioned.svg
                        break;
                    case "PRODUCTION":
                        color = "#218838";
                        //change color in SVG file ../assets/images/svg/phase_production.svg
                        break;
                    case "DECOMMISSIONING":
                        color = "#FF5A00";
                        //change color in SVG file ../assets/images/svg/phase_decommissioning.svg
                        break;
                    case "DECOMMISSIONED":
                        color = "#C82333";
                        //change color in SVG file ../assets/images/svg/phase_decommissioned.svg
                        break
                }
                return {"color": color};
            },

            getConnectionColor: function (connection) {
                var color = "#000";
                switch (connection) {
                    case "CONNECTED":
                    case "connected":
                        color = "#218838";
                        break;
                    case "DISCONNECTED":
                    case "disconnected":
                        color = "#C82333";
                        break
                }
                return {"color": color};
            },

            getStateColor: function (state) {
                var color = "#000";
                switch (state) {
                    case "ACTIVE":
                        color = "#218838";
                        break;
                    case "INACTIVE":
                        color = "#C82333";
                        break
                }
                return {"color": color};
            },
            getUserStateColor: function (state) {
                var color = "#000";
                switch (state) {
                    case "ACTIVE":
                        color = "#218838";
                        break;
                    case "SUSPENDED":
                        color = "#C82333";
                        break;
                    case "UNCONFIRMED":
                        color = "#999999";
                        break
                }
                return {"color": color};
            },
            getListenerStateColor: function (state) {
                var color = "#000";
                switch (state) {
                    case "ACTIVE":
                        color = "#218838";
                        break;
                    case "INACTIVE":
                        color = "#C82333";
                        break
                }
                return {"color": color};
            },

            getTrainerStatusColor: function (status) {
                var color = "#000";
                switch (status) {
                    case "PENDING":
                        color = "#247fd9";
                        break;
                    case "IN_PROGRESS":
                        color = "#1e57d9";
                        break;
                    case "FAILED":
                        color = "#d10202";
                        break;
                    case "COMPLETED":
                        color = "#07ba63";
                        break;
                    case "DELETED":
                        color = "#ed3636";
                        break;
                    case "STOPPING":
                        color = "#e86f6f";
                        break;
                    case "STOPPED":
                        color = "#d13636";
                        break;
                    case "STARTED":
                        color = "#5ee594";
                        break;
                    case "DOWNLOADING":
                        color = "#04cbd6";
                        break;
                    case "TRAINING":
                        color = "#04d642";
                        break;
                    case "UPLOADING":
                        color = "#63eaed";
                        break;
                }
                return {"color": color};
            },

            getDeploymentStatusColor: function (status) {
                var color = "#000";
                switch (status) {
                    case "OUT_OF_SERVICE":
                        color = "#d14e0b";
                        break;
                    case "CREATING":
                        color = "#07ba63";
                        break;
                    case "UPDATING":
                        color = "#63eaed";
                        break;
                    case "ROLLING_BACK":
                        color = "#07ba63";
                        break;
                    case "IN_SERVICE":
                        color = "#2f51ed";
                        break;
                    case "DELETING":
                        color = "#ed3636";
                        break;
                    case "FAILED":
                        color = "#d10202";
                        break;
                }
                return {"color": color};
            },
            getOperatorColor: function (operatorName) {
                /*change background color of operator app/components/directives/ngQueryBuilderNode/ngQueryBuilderNode.temp.html*/
                var color;
                switch (operatorName) {
                    case "is not equal to":
                        color = "#0069D9";
                        break;
                    case "is equal to":
                        color = "#218838"
                        break;
                    case "contains":
                        color = "#52a4ff";
                        break;
                    case "does not contain":
                        color = "#FF5A00";
                        break;
                    case "starts with":
                        color = "#3CB371";
                        break;
                    case "does not start with":
                        color = "#F08080";
                        break;
                    case "ends with":
                        color = "#6A5ACD";
                        break;
                    case "does not end with":
                        color = "#00008B";
                        break;
                    case "is less than":
                        color = "#da9bd3";
                        break;
                    case "is less than or equal to":
                        color = "#FF00FF";
                        break;
                    case "is greater than":
                        color = "#DB7093";
                        break;
                    case "is greater than or equal to":
                        color = "#C71585";
                        break;
                    case "is present":
                        color = "#30A8DA";
                        break;
                    case "is not present":
                        color = "#FF4500";
                        break;
                    case "is empty":
                        color = "#C82333";
                        break;
                    case "is not empty":
                        color = "#D2691E";
                        break;
                    case "matches":
                        color = "#A52A2A";
                        break;
                    case "does not match":
                        color = "#800000";
                        break;
                }
                return {"color": color};
            }
        };
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('breadcrumbObjService', fnBreadcrumbObjService);

    /** @ngInject */
    function fnBreadcrumbObjService() {

        var breadcrumbObj = null;

        fnBreadcrumbObjService.fnSetBreadcrumbObj = function (object) {
            breadcrumbObj = object;
        };

        fnBreadcrumbObjService.fnGetBreadcrumbObj = function () {
            return breadcrumbObj;
        };

        fnBreadcrumbObjService.fnRemoveBreadcrumbObj = function () {
            breadcrumbObj = null;
        };

        return fnBreadcrumbObjService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('AvatarService', AvatarService);

    /** @ngInject */
    function AvatarService() {
        AvatarService.getTextAvatar = function (userObj) {
            var initials = "";
            var tempArr = [];

            if (userObj.firstName && userObj.lastName) {
                tempArr = angular.copy(userObj.firstName + " " + userObj.lastName).split(' ');
                if (tempArr.length > 1) {
                    initials = tempArr[0].charAt(0).toUpperCase() + tempArr[1].charAt(0).toUpperCase();
                } else {
                    initials = tempArr[0].charAt(0).toUpperCase()
                }
            } else if (userObj.username) {
                tempArr = angular.copy(userObj.username).split(' ');
                if (tempArr.length > 1) {
                    initials = tempArr[0].charAt(0).toUpperCase() + tempArr[1].charAt(0).toUpperCase();
                } else {
                    initials = tempArr[0].charAt(0).toUpperCase();
                }
            } else if (userObj.alias) {
                tempArr = angular.copy(userObj.alias).split(' ');
                if (tempArr.length > 1) {
                    initials = tempArr[0].charAt(0).toUpperCase() + tempArr[1].charAt(0).toUpperCase();
                } else {
                    initials = tempArr[0].charAt(0).toUpperCase();
                }
            } else {
                tempArr = angular.copy(userObj.email).split('@');
                initials = tempArr[0].charAt(0).toUpperCase() + tempArr[1].charAt(0).toUpperCase();
            }

            //Generate color from string hashcode
            function hashCode(str) { // java String#hashCode
                var hash = 0;
                for (var i = 0; i < str.length; i++) {
                    hash = str.charCodeAt(i) + ((hash << 5) - hash);
                }
                return hash;
            }

            function intToRGB(i) {
                var c = (i & 0x00FFFFFF)
                    .toString(16)
                    .toUpperCase();

                return "00000".substring(0, 6 - c.length) + c;
            }

            // var randomColor = '#' + (0x1000000 | (Math.random() * 0xFFFFFF)).toString(16).substr(1, 6);
            var randomColor = '#' + intToRGB(hashCode(userObj.name ?
                userObj.name : userObj.username ? userObj.username : userObj.alias ? userObj.alias : userObj.email));


            //get Luminance for hex color (Luminance is thus an indicator of how bright the surface will appear)
            var c = randomColor.substring(1);      // strip #
            var rgb = parseInt(c, 16);   // convert rrggbb to decimal
            var r = (rgb >> 16) & 0xff;  // extract red
            var g = (rgb >> 8) & 0xff;  // extract green
            var b = (rgb >> 0) & 0xff;  // extract blue
            var luma = 0.2126 * r + 0.7152 * g + 0.0722 * b; // per ITU-R BT.709

            //if background light then set true(for set text color bas on luma)
            if (luma > 150) {
                userObj.isLight = true;
            }
            // Create a rectangular canvas which will become th image.
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            canvas.width = 100;
            canvas.height = 100;
            // Draw the circle in the background using the randomColor.
            context.fillStyle = randomColor;
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.font = (canvas.height / 3) + "px serif";
            // Make the text's center overlap the image's center.
            context.textAlign = "center";
            context.font = '36pt "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif';
            if (context.measureText(initials).width > canvas.width - 15) {
                context.font = '30pt "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif';
            }
            context.fillStyle = userObj.isLight ? "#000000" : "#ffffff";
            context.fillText(initials, canvas.width / 2, canvas.height / 1.5);

            // Show the image to the world.
            return canvas.toDataURL(); //return base64 image string
        };

        return AvatarService;
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('Authenticate', Authenticate);

    /** @ngInject */
    function Authenticate($cookies, $q, $http, $window, $location, DB, AvatarService, $state) {

        /* function fnGetUserDetail(defer, userRole, person_id, stateId) {
         // var slowLoad = $timeout(function () {
         //     //alert("The page is taking its sweet time loading");
         //     $location.url('/limited-access');
         // }, 30000);
         UserFactory.getUser({person_id: person_id})
         .then(function (success) {
         success.avatar = AvatarService.getTextAvatar(success);
         if (DB.fnGet('xSudoId')) {
         success.isSudoUser = true;
         } else {
         DB.fnSet('loginUser', success);
         }

         Authenticate.user = success;
         if (userRole === 'admin') {
         if (Authenticate.user.role === "ADMINISTRATOR") {
         defer.resolve(Authenticate);
         } else {
         if (success.id === parseInt(stateId)) {
         defer.resolve(Authenticate);
         } else {
         $location.url('/dashboard');
         }
         }
         } else {
         defer.resolve(Authenticate);
         }
         // $timeout.cancel(slowLoad);
         });
         }*/

        Authenticate.fnVerifyUserRole = function (userRoleArr, app) {
            var defer = $q.defer();
            var loginUser = {};
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                loginUser = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.user : DB.fnGet('support').sessionObj.user;
            } else {
                loginUser = DB.fnGet('loginUser');
            }
            var isPagePermission = false;
            var currentAccountState = DB.fnGet('currentAccountState');
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                currentAccountState = DB.fnGet('federation') ? DB.fnGet('federation').currentAccountState : DB.fnGet('support').currentAccountState;
            } else {
                currentAccountState = DB.fnGet('currentAccountState');
            }
            if (app !== '') {
                if (currentAccountState.state.toLowerCase() === 'active') {
                    if (app.startsWith('billing')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER';
                    } else if (app.startsWith('access')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true;
                    } else if (app.startsWith('node')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.nodeRole === 'MANAGER' || loginUser.nodeRole === 'SUPERVISOR' || loginUser.nodeRole === 'ENGINEER' || loginUser.nodeRole === 'TEAM_MEMBER' || loginUser.nodeRole === 'CUSTOMER';
                    } else if (app.startsWith('pipeline')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.pipelineRole === 'MANAGER' || loginUser.pipelineRole === 'TEAM_MEMBER';
                    } else if (app.startsWith('tracker')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.trackerRole === 'MANAGER' || loginUser.trackerRole === 'TEAM_MEMBER' || loginUser.trackerRole === 'CUSTOMER'
                    } else if (app.startsWith('ai')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.aiRole === 'MANAGER'
                    } else if (app.startsWith('storage')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.storageRole === 'MANAGER' || loginUser.storageRole === 'TEAM_MEMBER' || loginUser.storageRole === 'CUSTOMER'
                    } else if (app.startsWith('store')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER' || loginUser.nodeRole === 'MANAGER';
                    } else if (app.startsWith('insight')) {
                        isPagePermission = loginUser.accountOwner === true || loginUser.administrator === true || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                    }
                } else {
                    if (currentAccountState.state.toLowerCase() === 'suspended' ||
                        currentAccountState.state.toLowerCase() === 'unpaid') {
                        isPagePermission = !!((loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER') &&
                            (app.startsWith('access') || app.startsWith('billing')));

                    } else {
                        if (app.startsWith('access') || app.startsWith('billing')) {
                            isPagePermission = true;
                        }
                    }
                }
            } else {
                isPagePermission = true;
            }
            if (isPagePermission === true) {
                loginUser.avatar = AvatarService.getTextAvatar(loginUser);
                Authenticate.user = loginUser;
                defer.resolve(Authenticate);
            } else {
                $window.location.href = '/#/404';
                $window.location.reload();
            }
            return defer.promise;
        };

        Authenticate.fnVerifyIot3Tools = function () {
            var defer = $q.defer();
            var loginUser = {};
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                loginUser = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.user : DB.fnGet('support').sessionObj.user;
            } else {
                loginUser = DB.fnGet('loginUser');
            }
            var isPagePermission = false;
            var currentAccountState = DB.fnGet('currentAccountState');
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                currentAccountState = DB.fnGet('federation') ? DB.fnGet('federation').currentAccountState : DB.fnGet('support').currentAccountState;
            } else {
                currentAccountState = DB.fnGet('currentAccountState');
            }

            if (currentAccountState.state.toLowerCase() === 'active') {
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    isPagePermission = false;
                } else {
                    isPagePermission = !!loginUser.id.startsWith('cu000000');
                }
            } else {
                isPagePermission = false;
            }
            if (isPagePermission === true) {
                loginUser.avatar = AvatarService.getTextAvatar(loginUser);
                Authenticate.user = loginUser;
                defer.resolve(Authenticate);
            } else {
                $window.location.href = '/#/404';
                $window.location.reload();
            }
            return defer.promise;
        };

        Authenticate.isLoggedInAsync = function (cb) {
            if ($cookies.get('phoenix')) {
                cb(true);
            } else {
                cb(false);
            }
        };

        Authenticate.checkForLockScreen = function () {
            if (DB.fnGet('loginUserEmail')) {
                return true;
            } else {
                return false;
            }
        };

        Authenticate.fnDefaultRedirect = function () {
            DB.fnSet("isProfileSelected", false);
            var devAccountIds = ["cu5e25fc", "cu000000", "cu767c86", "cueeed05"];
            var loginUser = {};
            if (DB.fnGet('federation')) {
                loginUser = DB.fnGet('federation').sessionObj.user;
            } else {
                loginUser = DB.fnGet('loginUser');
            }
            var accountId = loginUser.id.split("-")[0];
            var navMenu = DB.fnGet("menu");
            var tempTopNav = [], tempSideNav = [];
            if (navMenu && navMenu.length) {
                var nodeApp = _.find(navMenu, function (appObj) {
                    if (appObj.name === "Node" && appObj.isAcess === true) {
                        return appObj;
                    }
                });
                if (nodeApp) {
                    var deviceService = _.find(nodeApp.sideMenu, function (sideMenuObj) {
                        if (sideMenuObj.name === "Nodes" && sideMenuObj.isAcess === true) {
                            return sideMenuObj;
                        }
                    });
                    if (deviceService) {
                        $state.go(deviceService.state);
                    } else {
                        navMenu.filter(function (navMenuObj) {
                            if (navMenuObj.isAcess === true) {
                                tempTopNav.push(navMenuObj)
                            }
                        });
                        tempTopNav[0].sideMenu.filter(function (sideMenuObj) {
                            if (sideMenuObj.isAcess === true) {
                                tempSideNav.push(sideMenuObj)
                            }
                        });
                        $state.go(tempSideNav[0].state);
                    }
                } else {
                    navMenu.filter(function (navMenuObj) {
                        if (navMenuObj.isAcess === true) {
                            tempTopNav.push(navMenuObj)
                        }
                    });
                    if (tempTopNav && tempTopNav.length) {
                        tempTopNav[0].sideMenu.filter(function (sideMenuObj) {
                            if (sideMenuObj.isAcess === true) {
                                tempSideNav.push(sideMenuObj)
                            }
                        });
                        if (tempTopNav[0].name === "Pipeline" && !devAccountIds.includes(accountId)) {
                            $state.go('main.pipelinecomingsoon');
                        } else if (tempTopNav[0].name === "Storage" && !devAccountIds.includes(accountId)) {
                            $state.go('main.storagecomingsoon');
                        } else if (tempTopNav[0].name === 'AI' && !devAccountIds.includes(accountId)){
                            $state.go('main.aicomingsoon');
                        } else {
                            $state.go(tempSideNav[0].state);
                        }
                    } else {
                        if (DB.fnGet('federation')) {
                            var sessionUser = DB.fnGet('federation').sessionObj.user;
                            if (sessionUser && (sessionUser.administrator === true || sessionUser.accountOwner === true)) {
                                $state.go('main.users')
                            }
                            if (sessionUser && (sessionUser.billingRole === 'MANAGER' || sessionUser.nodeRole === 'MANAGER')) {
                                $state.go('main.products')
                            }
                        } else {
                            $state.go('main.no_privileges')
                        }
                    }
                }
            } else {
                $state.go('main.no_privileges');
            }
        };

        Authenticate.fnIsAuthUser = function (data) {
            var loginUser = DB.fnGet('loginUser');
            if (angular.isArray(data)) {
                if (angular.isObject(data[0])) { // check is data is json (array of object)
                    return _.find(data, {'id': loginUser.id});
                } else { // for array data
                    return data.includes(loginUser.id) ? loginUser : null;
                }
            } else if (angular.isObject(data)) { // for single object
                return data.id === loginUser.id ? loginUser : null
            } else if (angular.isString(data)) { // for data string id
                return data === loginUser.id ? loginUser : null
            } else {
                return null;
            }
        };

        return Authenticate;
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('AppInitService', fnAppInitService);

    /** @ngInject */
    function fnAppInitService($base64, DB, PermissionsService, UserFactory, $timeout, ProjectFactory, ListenerFactory,
                              StateFactory, TypeFactory, HealthFactory, TrackerStateFactory, PriorityFactory, TypesFactory, ProjectHealthService,
                              ColorService, $log, typeArrDb, statesArrDb, modelsObjDb, QueryFactory, projectArr, issueStateArr, issuePriorityArr, issueTypeArr, nodeProjectArr, insightProjectArr) {
        var modelsObj = {};
        var statesArr = [];
        var typesArr = [];
        //var appArr = ["access", "tracker", "storage", "ai", "node", "pipeline", "billing"];
        //var appCount = 0;
        /*var errorState = {
            id: "0011100",
            name: "Error Event (pipeline:workflow:ErrorEvent)",
            icon: "PHN2ZyBmaWxsPSIjRkZGRkZGIiBoZWlnaHQ9IjE4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+DQogICAgPHBhdGggZD0iTTIxIDMuMDFIM2MtMS4xIDAtMiAuOS0yIDJWOWgyVjQuOTloMTh2MTQuMDNIM1YxNUgxdjQuMDFjMCAxLjEuOSAxLjk4IDIgMS45OGgxOGMxLjEgMCAyLS44OCAyLTEuOTh2LTE0YzAtMS4xMS0uOS0yLTItMnpNMTEgMTZsNC00LTQtNHYzSDF2MmgxMHYzeiIvPg0KPC9zdmc+",
            color: "#818b8c",
            type: "INPUT",
            category: "TRIGGER",
            info: "VGhpcyBpbnB1dCB0cmlnZ2VyIHJlcHJlc2VudHMgdGhlIG1vZGVsIHRoYXQgaXMgcmVjZWl2ZWQuIEl0IGlzIG5vdCBwb3NzaWJsZSB0byBjb25maWd1cmUgb3IgbW9kaWZ5IHRoaXMgaW5wdXQgYXMgaXQgcmVwcmVzZW50cyB0aGUgdHJpZ2dlciBmb3IgdGhlIHdvcmtmbG93LiBUaGUgZm9sbG93aW5nIHRhYmxlIGRlc2NyaWJlcyB0aGUgb3V0cHV0Lg0KDQojIyMjICoqT3V0cHV0KioNCjxvdXRwdXQtdGFibGU+",
            outputs: [
                "access/access:user:ValidateEvent"
            ]
        };*/
        var projectsArr = [];
        var issueStatesArr = [];
        var issuePrioritiesArr = [];
        var issueTypesArr = [];
        /* eslint-disable no-unused-vars */
        var nodeProjectsArr = [];
        var insightProjectsArr = [];
        /* eslint-enable no-unused-vars */
        var loginUser = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
        var dataLimit = 100;

        function parsePostgresData(items) {
            return items.map(function(item) {
                var parsedItem = _.cloneDeep(item);

                // Handle timestamps standardization
                if (angular.isDefined(parsedItem.updatedAt)) {
                    parsedItem.updatedAt = parsedItem.updatedAt;
                } else if (angular.isDefined(parsedItem.updated_at)) {
                    parsedItem.updatedAt = parsedItem.updated_at;
                }

                if (angular.isDefined(parsedItem.createdAt)) {
                    parsedItem.createdAt = parsedItem.createdAt;
                } else if (angular.isDefined(parsedItem.created_at)) {
                    parsedItem.createdAt = parsedItem.created_at;
                }

                // Handle ECU connection status
                if (angular.isDefined(parsedItem.ecuConnected)) {
                    parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                } else if (angular.isDefined(parsedItem.ecuconnected)) {
                    parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                }

                if (angular.isString(parsedItem.data)) {
                    try {
                        var parsedData = angular.fromJson(parsedItem.data);

                        // Handle node connection status from data
                        if (angular.isDefined(parsedData.connected)) {
                            parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                        }

                        // Set receivedAt from _event_time if available
                        if (parsedData._event_time && parsedData._event_time.value) {
                            var microseconds = parseInt(parsedData._event_time.value);
                            if (!isNaN(microseconds)) {
                                parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                            }
                        }

                        // Set healthLastChangedAt from updated_at
                        if (parsedItem.updated_at) {
                            parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                        }

                        // Merge the parsed data with our item
                        return angular.extend({}, parsedItem, parsedData);
                    } catch (e) {
                        $log.error('Error parsing data:', e);
                        return parsedItem;
                    }
                }
                return parsedItem;
            });
        }

        /*function fnGetStates(inputObj) {
            StateFactory.getStates(inputObj)
                .then(function (response) {
                    response.push(errorState);
                    statesArr = response;
                    localStorage.setItem(modelsObjDb, $base64.encode(angular.toJson(modelsObj)));
                    localStorage.setItem(statesArrDb, $base64.encode(angular.toJson(statesArr)));
                }, function () {
                })
        }*/

        /*function fnGetAppModels(count) {
            var inputObj = {
                appName: appArr[count]
            };
            ListenerFactory.getListenerModels(inputObj)
                .then(function (response) {
                    modelsObj[appArr[count]] = response;
                    count++;
                    if (count < appArr.length) {
                        fnGetAppModels(count);
                    } else {
                        $timeout(function () {
                            var inputObj = {};
                            fnGetStates(inputObj);
                        });
                    }
                }, function () {
                    count++;
                    if (count < appArr.length) {
                        fnGetAppModels(count);
                    } else {
                        $timeout(function () {
                            var inputObj = {};
                            fnGetStates(inputObj);
                        });
                    }
                })
        }*/

        /*function fnInitGetAppModels() {
            if (appCount < appArr.length) {
                fnGetAppModels(appCount);
            } else {
                $timeout(function () {
                    var inputObj = {};
                    fnGetStates(inputObj);
                });
            }
        }

        function fnGetTypes() {
            TypeFactory.getTypes()
                .then(function (response) {
                    typesArr = response;
                    localStorage.setItem(typeArrDb, $base64.encode(angular.toJson(typesArr)));
                })
        }*/

        function fnGetProject(inputObj, preDefinedProjects, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var projects = isCalledForViz ? preDefinedProjects : [];

                    if (res.data) {
                        // Parse the nested data property
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (projectObj) {
                            projects.push(projectObj);
                        });
                    }

                    if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_projects';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetProject({sql: sqlString}, projects, true);
                    } else {
                        var encodedProjects = $base64.encode(angular.toJson(projects));
                        localStorage.setItem(projectArr, encodedProjects);
                        projectsArr = angular.copy(projects);
                    }
                }, function () { // Error block
                })
        }

        function fnGetIssueStates(inputObj, preDefinedIssueStates, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var states = isCalledForViz ? preDefinedIssueStates : [];
                    if (res.data) {
                        // Parse the nested data property
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (stateObj) {
                            states.push(stateObj);  // Changed from projects.push()
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (states[0] && states[0].totalItems > states.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_states';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + states[states.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetIssueStates({sql: sqlString}, states, true);
                    } else {
                        var encodedStates = $base64.encode(angular.toJson(states));
                        localStorage.setItem(issueStateArr, encodedStates);
                        issueStatesArr = angular.copy(states);
                    }
                }, function () { // Error block
                })
        }

        function fnGetIssuePriority(inputObj, preDefinedIssuePriorities, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var priorities = isCalledForViz ? preDefinedIssuePriorities : [];

                    if (res.data) {
                        // Parse the nested data property
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (priorityObj) {
                            priorities.push(priorityObj);  // Changed from projects.push()
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (priorities[0] && priorities[0].totalItems > priorities.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_priorities';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + priorities[priorities.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetIssuePriority({sql: sqlString}, priorities, true);
                    } else {
                        var encodedPriorities = $base64.encode(angular.toJson(priorities));
                        localStorage.setItem(issuePriorityArr, encodedPriorities);
                        issuePrioritiesArr = angular.copy(priorities);
                    }
                }, function () { // Error block
                })
        }

        function fnGetIssueType(inputObj, preDefinedIssueTypes, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var types = isCalledForViz ? preDefinedIssueTypes : [];

                    if (res.data) {
                        // Parse the nested data property
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (typeObj) {
                            types.push(typeObj);  // Changed from projects.push()
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (types[0] && types[0].totalItems > types.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM tracker_types';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + types[types.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetIssueType({sql: sqlString}, types, true);
                    } else {
                        var encodedTypes = $base64.encode(angular.toJson(types));
                        localStorage.setItem(issueTypeArr, encodedTypes);
                        issueTypesArr = angular.copy(types);
                    }
                }, function () { // Error block
                })
        }

        function fnGetNodeProject(inputObj, preDefinedNodeProjects, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var projects = isCalledForViz ? preDefinedNodeProjects : [];

                    if (res.data) {
                        // Parse the nested data property
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (projectObj) {
                            projects.push(projectObj);
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_projects';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetNodeProject({sql: sqlString}, projects, true);
                    } else {
                        var encodedProjects = $base64.encode(angular.toJson(projects));
                        localStorage.setItem(nodeProjectArr, encodedProjects);
                        nodeProjectsArr = angular.copy(projects);
                    }
                }, function () { // Error block
                })
        }

        function fnGetNodeHealth(inputObj, preDefinedNodeHealths, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var healthsArr = isCalledForViz ? preDefinedNodeHealths : [];
                    if (res.data) {
                        var parsedHealths = parsePostgresData(res.data);
                        _.forEach(parsedHealths, function (healthObj) {
                            healthsArr.push(healthObj);
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (healthsArr[0] && healthsArr[0].healthsArr > healthsArr.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_healths';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + healthsArr[healthsArr.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetNodeHealth({sql: sqlString}, healthsArr, true);
                    } else {
                        DB.fnSet("healthArray", healthsArr);
                        ColorService.fnSetHealthData(healthsArr);
                        var rootProjectSQL = {"sql": "select * from node_projects where data->>\'parentProjectId\' IS NULL"};
                        QueryFactory.executeQuery(rootProjectSQL)
                            .then(function (res) {
                                if (res && res.data && res.data.length) {
                                    // Parse the root project data
                                    var parsedRootProjects = parsePostgresData(res.data);
                                    var rootProject = parsedRootProjects[0];
                                    ProjectHealthService.fnSetProjectRelationshipHealthArr(rootProject.id);
                                }
                            }, function (error) { // Error block
                                $log.error('Error fetching root project:', error);
                            })
                    }
                }, function (error) { // Error block
                    $log.error('Error fetching health data:', error);
                })
        }

        function fnGetInsightProject(inputObj, preDefinedInsightProjects, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var projects = isCalledForViz ? preDefinedInsightProjects : [];
                    if (res.data) {
                        var parsedProjects = parsePostgresData(res.data);
                        _.forEach(parsedProjects, function (projectObj) {
                            projects.push(projectObj);
                        });
                    }
                    if ((res.data && res.data.length && res.data.length > 0) && (projects[0] && projects[0].totalItems > projects.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM insight_projects';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + projects[projects.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + dataLimit + ';';
                        fnGetInsightProject({sql: sqlString}, projects, true);
                    } else {
                        var encodedProjects = $base64.encode(angular.toJson(projects));
                        localStorage.setItem(insightProjectArr, encodedProjects);
                        insightProjectsArr = angular.copy(projects);
                    }
                }, function (error) { // Error block
                    $log.error('Error fetching insight projects:', error);
                })
        }

        return {
            setInitData: function () {
                modelsObj = localStorage.getItem(modelsObjDb) ? angular.fromJson($base64.decode(localStorage.getItem(modelsObjDb))) : {};
                statesArr = localStorage.getItem(statesArrDb) ? angular.fromJson($base64.decode(localStorage.getItem(statesArrDb))) : [];
                typesArr = localStorage.getItem(typeArrDb) ? angular.fromJson($base64.decode(localStorage.getItem(typeArrDb))) : [];
                projectsArr = localStorage.getItem(projectArr) ? angular.fromJson($base64.decode(localStorage.getItem(projectArr))) : [];
                issueStatesArr = localStorage.getItem(issueStateArr) ? angular.fromJson($base64.decode(localStorage.getItem(issueStateArr))) : [];
                issuePrioritiesArr = localStorage.getItem(issuePriorityArr) ? angular.fromJson($base64.decode(localStorage.getItem(issuePriorityArr))) : [];
                issueTypesArr = localStorage.getItem(issueTypeArr) ? angular.fromJson($base64.decode(localStorage.getItem(issueTypeArr))) : [];
                nodeProjectsArr = localStorage.getItem(nodeProjectArr) ? angular.fromJson($base64.decode(localStorage.getItem(nodeProjectArr))) : [];
                insightProjectsArr = localStorage.getItem(insightProjectArr) ? angular.fromJson($base64.decode(localStorage.getItem(insightProjectArr))) : [];
            },
            getInitData: function (keyName) {
                switch (keyName) {
                    case "modelsObj":
                        return modelsObj;
                    case "statesArr":
                        return statesArr;
                    case "typesArr":
                        return typesArr;
                    case "visualizersArr":
                        return [];
                    case "projectsArr":
                        var parsedProjects = projectsArr.map(function(project) {
                            if (angular.isString(project.data)) {
                                try {
                                    var parsed = angular.fromJson(project.data);
                                    return angular.extend({}, project, parsed);
                                } catch (e) {
                                    return project;
                                }
                            }
                            return project;
                        });
                        parsedProjects = _.sortBy(parsedProjects, ['name']);
                        return parsedProjects;
                    case "issueStatesArr":
                        return issueStatesArr;
                    case "issuePrioritiesArr":
                        return issuePrioritiesArr;
                    case "issueTypesArr":
                        return issueTypesArr;
                    case "nodeProjectsArr":
                        parsedProjects = nodeProjectsArr.map(function(project) {
                            if (angular.isString(project.data)) {
                                try {
                                    var parsed = angular.fromJson(project.data);
                                    return angular.extend({}, project, parsed);
                                } catch (e) {
                                    return project;
                                }
                            }
                            return project;
                        });
                        parsedProjects = _.sortBy(parsedProjects, ['name']);
                        return parsedProjects;
                    case "insightProjectsArr":
                        parsedProjects = insightProjectsArr.map(function(project) {
                            if (angular.isString(project.data)) {
                                try {
                                    var parsed = angular.fromJson(project.data);
                                    return angular.extend({}, project, parsed);
                                } catch (e) {
                                    return project;
                                }
                            }
                            return project;
                        });
                        parsedProjects = _.sortBy(parsedProjects, ['name']);
                        return parsedProjects;
                    default:
                        return [];
                }
            },
            fnSetAsynCall: function () {
                var currentAccountState;
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    loginUser = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.user : DB.fnGet('support').sessionObj.user;
                    if (DB.fnGet('federation')) {
                        currentAccountState = DB.fnGet('federation').currentAccountState;
                    } else {
                        currentAccountState = DB.fnGet('support').currentAccountState;
                    }
                } else {
                    loginUser = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                    currentAccountState = DB.fnGet('currentAccountState');
                }
                if (currentAccountState.state.toLowerCase() === 'active') {
                    /*var workflowPermissionObj = PermissionsService.getPermissions("pipeline:workflow");
                var devicePermissionObj = PermissionsService.getPermissions("node:device");
                var healthPermissionObj = PermissionsService.getPermissions("node:health");
                var gatewayPermissionObj = PermissionsService.getPermissions("node:gateway");
                var observerPermissionObj = PermissionsService.getPermissions("node:observer");
                var vaultPermissionObj = PermissionsService.getPermissions("access:vault");
                if (workflowPermissionObj.List || workflowPermissionObj.Create) {
                    fnInitGetAppModels();
                }
                if (devicePermissionObj.List || devicePermissionObj.Create || gatewayPermissionObj.List || gatewayPermissionObj.List || vaultPermissionObj.Create || observerPermissionObj.Create) {
                    fnGetTypes();
                }
                if (healthPermissionObj.List) {
                    HealthFactory.getHealths()
                        .then(function (response) {
                            ColorService.fnSetHealthData(response);
                        })
                }*/
                    if (loginUser.accountOwner === true || loginUser.administrator === true || loginUser.trackerRole === 'MANAGER' || loginUser.trackerRole === 'TEAM_MEMBER' || loginUser.trackerRole === 'CUSTOMER') {
                        var projectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_projects ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetProject({sql: projectSQL}, [], false);
                        var statesSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_states ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetIssueStates({sql: statesSQL}, [], false);
                        var prioritySQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_priorities ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetIssuePriority({sql: prioritySQL}, [], false);
                        var typeSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM tracker_types ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetIssueType({sql: typeSQL}, [], false);
                    }
                    if (loginUser.accountOwner === true || loginUser.administrator === true || loginUser.nodeRole === 'MANAGER' || loginUser.nodeRole === 'SUPERVISOR' || loginUser.nodeRole === 'ENGINEER' || loginUser.nodeRole === 'TEAM_MEMBER' || loginUser.nodeRole === 'CUSTOMER') {
                        var nodeProjectSQL = 'SELECT *, COUNT(*) OVER() as totalItems ,data->>\'_id\' AS rt FROM node_projects ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetNodeProject({sql: nodeProjectSQL}, [], false);
                        var nodeHealthSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_healths ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetNodeHealth({sql: nodeHealthSQL}, [], false);
                    }
                    if (loginUser.accountOwner === true || loginUser.administrator === true || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER') {
                        var insightProjectSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM insight_projects ORDER BY rt asc LIMIT ' + dataLimit + ';';
                        fnGetInsightProject({sql: insightProjectSQL}, [], false);
                    }
                }
                return '';
            },
            fnSetUserProfile: function () {
                var inputObj = {
                    body: {
                        "pre": {"home": {}}
                    }
                };
                UserFactory.updateUserProfile(inputObj)
                    .then(function (response) {
                        DB.fnSet('userProfile', response);
                    }, function () {
                    })
            },
            fnUpdateProjectData: function (projectData) {
                localStorage.setItem(projectArr, $base64.encode(angular.toJson(projectData)));
                projectsArr = projectData;
            },
            fnUpdateIssueStatesData: function (stateData) {
                localStorage.setItem(issueStateArr, $base64.encode(angular.toJson(stateData)));
                issueStatesArr = stateData;
            },
            fnUpdateIssuePrioritiesData: function (priorityData) {
                localStorage.setItem(issuePriorityArr, $base64.encode(angular.toJson(priorityData)));
                issuePrioritiesArr = priorityData;
            },
            fnUpdateIssueTypesData: function (priorityData) {
                localStorage.setItem(issueTypeArr, $base64.encode(angular.toJson(priorityData)));
                issueTypesArr = priorityData;
            },
            fnUpdateNodeProjectData: function (nodeProjectData) {
                localStorage.setItem(nodeProjectArr, $base64.encode(angular.toJson(nodeProjectData)));
            },
            fnUpdateInsightProjectData: function (insightProjectData) {
                localStorage.setItem(insightProjectArr, $base64.encode(angular.toJson(insightProjectData)));
            }
        };
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('ApiListService', fnApiListService);

    /** @ngInject */
    function fnApiListService($window, DB, AccountFactory, UserFactory, TeamFactory, IssueFactory, InvoiceFactory,
                              CreditTokenFactory, AuditFactory, VaultsFactory, AuthenticatorFactory,
                              FederationsFactory, EmailFactory) {
        return {
            getAPIList: function () {
                var authUserObj = DB.fnGet("loginUser");
                var federationObj = DB.fnGet('federation');
                var apiListArr = [
                    {
                        appName: "ECSMon",
                        serviceName: "Account",
                        displayName: "ECSMon - Account",
                        APIMethod: function (input) {
                            return AccountFactory.listAccounts(input);
                        },
                        isView: authUserObj.id.split("-")[0] === 'cu000000' && authUserObj.administrator === true && !DB.fnGet('federation')
                    }, {
                        appName: "Access",
                        serviceName: "User",
                        displayName: "Access - User",
                        APIMethod: function (input) {
                            return UserFactory.listUsers(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "Team",
                        displayName: "Access - Team",
                        APIMethod: function (input) {
                            return TeamFactory.listTeams(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "Vaults",
                        displayName: "Access - Vaults",
                        APIMethod: function (input) {
                            return VaultsFactory.listVaults(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "Authenticator",
                        displayName: "Access - Authenticator",
                        APIMethod: function (input) {
                            return AuthenticatorFactory.listAuthenticators(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "Federation",
                        displayName: "Access - Federation",
                        APIMethod: function (input) {
                            return FederationsFactory.listFederations(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "Audit",
                        displayName: "Access - Audit",
                        APIMethod: function (input) {
                            return AuditFactory.listAudits(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Access",
                        serviceName: "WhiteListEmail",
                        displayName: "Access - White Listed Email",
                        APIMethod: function (input) {
                            return EmailFactory.listWhitelistedEmails(input);
                        },
                        isView: authUserObj.administrator === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Tracker",
                        serviceName: "Issue",
                        displayName: "Tracker - Issue",
                        APIMethod: function (input) {
                            return IssueFactory.listIssues(input);
                        },
                        isView: authUserObj.administrator === true || authUserObj.trackerManager === true || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Billing",
                        serviceName: "CreditToken",
                        displayName: "Billing - CreditToken",
                        APIMethod: function (input) {
                            return CreditTokenFactory.listClaimedCreditTokens(input);
                        },
                        isView: authUserObj.administrator === true || authUserObj.billingManager === true  || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }, {
                        appName: "Billing",
                        serviceName: "Invoice",
                        displayName: "Billing - Invoice",
                        APIMethod: function (input) {
                            return InvoiceFactory.getInvoices(input);
                        },
                        isView: authUserObj.administrator === true || authUserObj.billingManager === true  || (federationObj && federationObj.sessionObj.user.administrator === true)
                    }
                ];
                return _.filter(apiListArr, {isView: true});
            },
            getCurrentURL: function () {
                var URL = "";
                if ($window.location.origin.startsWith('https://dev.predictive')) {
                    URL = 'https://www.ecsmon.ecsiteapp.com';
                } else if ($window.location.origin.startsWith('https://qa.predictive')) {
                    URL = 'https://www.ecsmon.ecsiteapp.com';
                } else if ($window.location.origin.startsWith('https://predictive')) {
                    URL = 'https://www.ecsmon.ecsiteapp.com';
                } else {
                    URL = 'https://www.ecsmon.ecsiteapp.com';
                }
                return URL;
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('analyticsService', analyticsService);

    /** @ngInject */
    function analyticsService(moment, pako, ColorService) {

        var componentsArr = [];
        var atomicCategoriesArr = [];
        var attributeValuesArr = [];

        analyticsService.getCSVString = function (base64String) {
            var strData = atob(base64String); // Decode base64 (convert ascii to binary)
            var charData = strData.split('').map(function (x) { // Convert binary string to character-number array
                return x.charCodeAt(0);
            });
            var binData = new Uint8Array(charData); // Turn number array into byte-array
            return pako.inflate(binData, {to: 'string'}); // Pako magic
        };

        analyticsService.getAggregateHealthData = function (csvString) {
            componentsArr = [];
            var tempAggregateHealthArr = angular.fromJson(CSV2JSON(csvString));
            tempAggregateHealthArr.pop();
            return tempAggregateHealthArr;
        };

        analyticsService.getAtomicHealthData = function (csvString, componentsData) {
            componentsArr = _.cloneDeepWith(componentsData);
            atomicCategoriesArr = [];
            var tempAtomicHealthArr = angular.fromJson(CSV2JSON(csvString, true));
            tempAtomicHealthArr.pop();
            atomicCategoriesArr.pop();
            return { atomicHealthArr : tempAtomicHealthArr, atomicHealthCategoriesArr : atomicCategoriesArr};
        };

        analyticsService.getAggregateHealthPieChartData = function(csvString){
            var tempAggregateHealthArr = angular.fromJson(CSV2JSONForPieChart(csvString));
            tempAggregateHealthArr.pop();
            return tempAggregateHealthArr;
        };

        analyticsService.getAtomicHealthPieChartData = function(csvString){
            var tempAtomicHealthArr = angular.fromJson(CSV2JSONForPieChart(csvString));
            tempAtomicHealthArr.pop();
            return tempAtomicHealthArr;
        };

        analyticsService.getConnectionData = function (csvString, isForGateway) {
            var tempConnectionArr = angular.fromJson(CSV2JSONForConnection(csvString, isForGateway));
            tempConnectionArr.pop();
            return tempConnectionArr;
        };

        analyticsService.getConnectionPieData = function (csvString) {
            var tempConnectionPicArr = angular.fromJson(CSV2JSONForConnectionPieChart(csvString));
            tempConnectionPicArr.pop();
            return tempConnectionPicArr;
        };

        analyticsService.getAttributeValueData = function (csvString) {
            attributeValuesArr = [];
            var attributeValueData = angular.fromJson(CSV2JSONForAttributeValue(csvString));
            attributeValueData.pop();
            attributeValuesArr.pop();
            return { attributeValueData : attributeValueData, attributeValuesArr : attributeValuesArr};
        };

        analyticsService.getAttributeValuePieData = function(csvString){
            var temptAttributeValuePieArr = angular.fromJson(CSV2JSONForConnectionPieChart(csvString));
            temptAttributeValuePieArr.pop();
            return temptAttributeValuePieArr;
        };

        function CSVToArray(strData, strDelimiter) {
            strDelimiter = (strDelimiter || ",");

            var objPattern = new RegExp((
                "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
                "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +

                "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");

            var arrData = [[]];
            var arrMatches = null;
            while (arrMatches = objPattern.exec(strData)) { //eslint-disable-line
                var strMatchedDelimiter = arrMatches[1];
                if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
                    arrData.push([]);
                }
                var strMatchedValue = "";
                if (arrMatches[2]) {
                    strMatchedValue = arrMatches[2].replace(
                        new RegExp("\"\"", "g"), "\"");
                } else {
                    strMatchedValue = arrMatches[3];
                }
                arrData[arrData.length - 1].push(strMatchedValue);
            }
            return (arrData);
        }

        function CSV2JSON(csv, isAtomicData) {
            var array = CSVToArray(csv);
            var objArray = [];
            var tempId = '';
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                for (var k = 0; k < array[0].length && k < array[i].length; k++) {
                    var key = array[0][k];
                    if (key === 'x') {
                        objArray[i - 1].y = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    } else if (key === 'y') {
                        objArray[i - 1].x = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    } else {
                        objArray[i - 1][key] = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    }
                }
                var healthObj = ColorService.getHealthColorForLoop(parseInt(array[i][2]));
                objArray[i - 1].date = moment(Date.parse(array[i][4])).format("MM/DD/YYYY HH:mm");
                if (isAtomicData) {
                    var componetName = "";
                    var isFindComponet = _.find(componentsArr, {id: array[i][3]});
                    if (isFindComponet) {
                        componetName = isFindComponet && isFindComponet.name && isFindComponet.name !== " " ? isFindComponet.name : isFindComponet.index ? isFindComponet.index.includes('#') ? isFindComponet.index.split('#')[isFindComponet.index.split('#').length - 1].replace(':', ' ') : isFindComponet.index.replace(':', ' ') : 'default';
                    } else {
                        componetName = 'default';
                    }
                    if (tempId !== array[i][3]) {
                        tempId = array[i][3];
                        atomicCategoriesArr.push(componetName);
                    }
                    objArray[i - 1].name = componetName;
                } else {
                    objArray[i - 1].name = "";
                }
                objArray[i - 1].color = healthObj['background-color'];
                objArray[i - 1].value = isNaN(array[i][2]) ? array[i][2] : parseInt(array[i][2]);
                objArray[i - 1].healthObj = healthObj;
            }
            var json = angular.toJson(objArray);
            return json.replace(/},/g, "},\r\n");
        }

        function CSV2JSONForPieChart(csv) {
            var array = CSVToArray(csv);
            var objArray = [];
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                for (var k = 0; k < array[0].length && k < array[i].length; k++) {
                    var key = array[0][k];
                    if (key === 'percentage') {
                        objArray[i - 1].percentage = parseFloat(array[i][k]);
                    } else {
                        objArray[i - 1][key] = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    }
                }
                var healthObj = ColorService.getHealthColorForLoop(parseInt(array[i][1]));
                objArray[i - 1].healthObj = healthObj;
                objArray[i - 1].marker = {fillColor: healthObj['background-color']};
            }
            var json = angular.toJson(objArray);
            return  json.replace(/},/g, "},\r\n");
        }

        function CSV2JSONForConnection(csv, isForGateway) {
            var array = CSVToArray(csv);
            var objArray = [];
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                for (var k = 0; k < array[0].length && k < array[i].length; k++) {
                    var key = array[0][k];
                    if (key === 'x') {
                        objArray[i - 1].y = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    } else if (key === 'y') {
                        if(isForGateway) {
                            objArray[i - 1].x = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k]) + 1
                        }else{
                            objArray[i - 1].x = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k]);
                        }
                    } else {
                        objArray[i - 1][key] = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    }
                }
                objArray[i - 1].date = moment(Date.parse(array[i][4])).format("MM/DD/YYYY HH:mm");
                objArray[i - 1].color = ColorService.getConnectionColor(array[i][2]).color;
                objArray[i - 1].value = array[i][3];
            }
            var json = angular.toJson(objArray);
            return json.replace(/},/g, "},\r\n");
        }

        function CSV2JSONForConnectionPieChart(csv) {
            var array = CSVToArray(csv);
            var objArray = [];
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                for (var k = 0; k < array[0].length && k < array[i].length; k++) {
                    var key = array[0][k];
                    if (key === 'percentage') {
                        objArray[i - 1].percentage = parseFloat(array[i][k]);
                    } else {
                        objArray[i - 1][key] = isNaN(array[i][k]) ? array[i][k] : parseInt(array[i][k])
                    }
                }
            }
            var json = angular.toJson(objArray);
            return  json.replace(/},/g, "},\r\n");
        }

        function CSV2JSONForAttributeValue(csv) {
            var array = CSVToArray(csv);
            var objArray = [];
            for (var i = 1; i < array.length; i++) {
                objArray[i - 1] = {};
                objArray[i - 1].x = Date.parse(array[i][4]);
                objArray[i - 1].y = isNaN(array[i][2]) ? array[i][2] : Number(array[i][2]);
                objArray[i - 1].marker = {fillColor: '#fc5425'};
                attributeValuesArr.push(isNaN(array[i][2]) ? array[i][2] : Number(array[i][2]));
            }
            var json = angular.toJson(objArray);
            return json.replace(/},/g, "},\r\n");
        }

        return analyticsService;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('amaran', fnAmaran);

    /** @ngInject */
    function fnAmaran(copyService) {

        fnAmaran.error = function (message) {
            $.amaran({
                'theme': 'awesome error',
                'content': {
                    'message': message +"<i class='m-l-5 fa fa-clipboard'></i>",
                    title: '',
                    info: '',
                    icon: 'fa fa-exclamation-circle'
                },
                "delay": 10000,
                "closeOnClick": false,
                "onClick": function () {
                    copyService.fnCopyToClipboard(message);
                }
            });
        };

        fnAmaran.success = function (message) {
            $.amaran({
                'theme': 'awesome ok',
                'content': {
                    'message': message,
                    title:'',
                    info:'',
                    icon:'fa fa-check'
                }
            });
        };

        fnAmaran.warning = function (message) {
            $.amaran({
                'theme': 'awesome warning',
                'content': {
                    'message': message,
                    title:'',
                    info:'',
                    icon:'fa fa-exclamation'
                }
            });
        };

        fnAmaran.info = function (message) {
            $.amaran({
                'theme': 'awesome info',
                'content': {
                    'message': message,
                    title:'',
                    info:'',
                    icon:'fa fa-info'
                }
            });
        };


        return fnAmaran;
    }
})();


(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('AdvanceSearchTablesService', fnAdvanceSearchTablesService);

    /** @ngInject */
    function fnAdvanceSearchTablesService(DB) {

        var loginUserObj = DB.fnGet('loginUser');
        var tablesData = {
            "access": {
                "accountOwner": [
                    {
                        "isPredictiveOnly": true,
                        "name": "access_account"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_audits"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_authenticators"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_authenticator_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_federations"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_teams"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_users"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_vaults"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_whitelist_emails"
                    }
                ],
                "administrator": [
                    {
                        "isPredictiveOnly": true,
                        "name": "access_account"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_audits"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_authenticators"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_authenticator_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_federations"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_teams"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_users"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_vaults"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_whitelist_emails"
                    }
                ],
                "team_member": [
                    {
                        "isPredictiveOnly": false,
                        "name": "access_authenticator_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_federations"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_teams"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_users"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "access_vaults"
                    }
                ]
            },
            "billing": {
                "accountOwner": [
                    {
                        "isPredictiveOnly": true,
                        "name": "billing_unclaimed_credit_tokens"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_claimed_credit_tokens"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_discounts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_invoices"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_prepays"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_products"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_usages"
                    }
                ],
                "administrator": [],
                "billingRoles_none": [],
                "billingRoles_manager": [
                    {
                        "isPredictiveOnly": true,
                        "name": "billing_unclaimed_credit_tokens"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_claimed_credit_tokens"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_discounts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_invoices"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_prepays"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_products"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_usages"
                    }
                ],
                "nodeRoles_manager": [
                    {
                        "isPredictiveOnly": false,
                        "name": "billing_products"
                    }
                ]
            },
            "tracker": {
                "accountOwner": [
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_labels"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_priorities"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_states"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_projects"
                    }
                ],
                "administrator": [
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_labels"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_priorities"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_states"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_projects"
                    }
                ],
                "trackerRoles_none": [],
                "trackerRoles_manager": [
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_labels"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_priorities"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_states"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_projects"
                    }
                ],
                "trackerRoles_team_member": [
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_labels"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_priorities"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_states"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_projects"
                    }
                ],
                "trackerRoles_customer": [
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_issues"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_comments"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_archived_histories"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_labels"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_priorities"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_states"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_types"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "tracker_projects"
                    }
                ]
            },
            "node": {
                "accountOwner": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_es4s"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_network_scan_results"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ],
                "administrator": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_es4s"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_network_scan_results"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ],
                "nodeRoles_none": [],
                "nodeRoles_manager": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_es4s"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_network_scan_results"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ],
                "nodeRoles_supervisor": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_es4s"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_network_scan_results"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ],
                "nodeRoles_engineer": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }

                ],
                "nodeRoles_team_member": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ],
                "nodeRoles_customer": [
                    {
                        "isPredictiveOnly": true,
                        "name": "ecu_logs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_ecus"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_nodes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_attributes"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_projects"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_root_cause_analysis"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_pending_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_active_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "ecu_completed_jobs"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecast"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomaly"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_healths"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_values"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connections"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_attribute_value_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_ecu_health_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_connection_anomalies"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_forecasts"
                    },
                    {
                        "isPredictiveOnly": false,
                        "name": "node_iot_node_health_anomalies"
                    }
                ]
            }
        };
        var possibleApps = ["access", "billing", "tracker", "node"];

        return {
            getAvailableTables: function () {
                var response = {};
                var accountId = loginUserObj.id.split("-")[0];
                if (DB.fnGet('federation')) {
                    loginUserObj = DB.fnGet('federation').sessionObj.user;
                    accountId = DB.fnGet('federation').sessionObj.accountId;
                } else {
                    loginUserObj = DB.fnGet('loginUser');
                    accountId = loginUserObj.id.split("-")[0];
                }
                if (loginUserObj.accountOwner === true) {
                    if (accountId !== 'cu000000') {
                        _.forEach(possibleApps, function (appName) {
                            if (!response[appName]) {
                                response[appName] = [];
                            }
                            _.forEach(tablesData[appName].accountOwner, function (obj) {
                                if (obj.isPredictiveOnly === false) {
                                    response[appName].push(obj)
                                }
                            })
                        })
                    } else {
                        _.forEach(possibleApps, function (appName) {
                            response[appName] = tablesData[appName].accountOwner;
                        })
                    }
                } else {
                    _.forEach(possibleApps, function (appName) {
                        if (!response[appName]) {
                            response[appName] = [];
                        }
                        if (appName === 'access') {
                            if (loginUserObj.administrator === true) {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.access.administrator, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.access.administrator;
                                }
                            } else if (loginUserObj.team_member === true) {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.access.team_member, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.access.team_member;
                                }
                            }
                        } else if (appName === 'billing') {
                            if (loginUserObj.administrator === true) {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.billing.administrator, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.billing.administrator;
                                }
                            } else if (loginUserObj.billingRole.toLowerCase() === 'none') {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.billing.billingRoles_none, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.billing.billingRoles_none;
                                }
                            } else if (loginUserObj.billingRole.toLowerCase() === 'manager') {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.billing.billingRoles_manager, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.billing.billingRoles_manager;
                                }
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'manager') {
                                if (accountId !== 'cu000000') {
                                    _.forEach(tablesData.billing.nodeRoles_manager, function (obj) {
                                        if (obj.isPredictiveOnly === false) {
                                            response[appName].push(obj)
                                        }
                                    })
                                } else {
                                    response[appName] = tablesData.billing.nodeRoles_manager;
                                }
                            }
                        } else if (appName === 'tracker') {
                            if (loginUserObj.administrator === true) {
                                response[appName] = tablesData.tracker.administrator;
                            } else if (loginUserObj.trackerRole.toLowerCase() === 'none') {
                                response[appName] = tablesData.tracker.trackerRoles_none;
                            } else if (loginUserObj.trackerRole.toLowerCase() === 'manager') {
                                response[appName] = tablesData.tracker.trackerRoles_manager;
                            } else if (loginUserObj.trackerRole.toLowerCase() === 'team_member') {
                                response[appName] = tablesData.tracker.trackerRoles_team_member;
                            }
                        } else if (appName === 'node') {
                            if (loginUserObj.administrator === true) {
                                response[appName] = tablesData.node.administrator;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'none') {
                                response[appName] = tablesData.node.nodeRoles_none;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'manager') {
                                response[appName] = tablesData.node.nodeRoles_manager;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'supervisor') {
                                response[appName] = tablesData.node.nodeRoles_supervisor;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'engineer') {
                                response[appName] = tablesData.node.nodeRoles_engineer;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'team_member') {
                                response[appName] = tablesData.node.nodeRoles_team_member;
                            } else if (loginUserObj.nodeRole.toLowerCase() === 'customer') {
                                response[appName] = tablesData.node.nodeRoles_customer;
                            }
                        }
                    });
                }
                return response;
            },
            getDefsFileName: function () {
                var tempArr = [];
                var accountId = loginUserObj.id.split("-")[0];
                if (DB.fnGet('federation')) {
                    loginUserObj = DB.fnGet('federation').sessionObj.user;
                    accountId = DB.fnGet('federation').sessionObj.accountId;
                } else {
                    loginUserObj = DB.fnGet('loginUser');
                    accountId = loginUserObj.id.split("-")[0];
                }
                if (loginUserObj.accountOwner) {
                    if (accountId === 'cu000000') {
                        tempArr.push('access_accountOwner_withPredictiveOnly');
                        tempArr.push('billing_accountOwner_withPredictiveOnly');
                        tempArr.push('tracker_tableName');
                    } else {
                        tempArr.push('access_accountOwner');
                        tempArr.push('billing_accountOwner');
                        tempArr.push('tracker_tableName');
                    }
                } else if (loginUserObj.administrator) {
                    if (accountId === 'cu000000') {
                        tempArr.push('access_accountOwner_withPredictiveOnly');
                        tempArr.push('tracker_tableName');
                    } else {
                        tempArr.push('access_accountOwner');
                        tempArr.push('tracker_tableName');
                    }
                } else {
                    if (loginUserObj.team_member) {
                        tempArr.push('access_team_member')
                    }
                    if (loginUserObj.billingRole.toLowerCase() === 'manager') {
                        if (accountId === 'cu000000') {
                            tempArr.push('billing_accountOwner_withPredictiveOnly')
                        } else {
                            tempArr.push('billing_accountOwner')
                        }
                    } else if (loginUserObj.nodeRole.toLowerCase() === 'manager') {
                        tempArr.push('billing_nodeRole_manager')
                    }
                    if (loginUserObj.trackerRole.toLowerCase() === 'manager' ||
                        loginUserObj.trackerRole.toLowerCase() === 'team_member') {
                        tempArr.push('tracker_tableName')
                    }
                }
                return tempArr;
            }
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .factory('ActionOptionArrService', fnActionOptionArrService);

    /** @ngInject */
    function fnActionOptionArrService() {
        return {
            getActionOptionArr: function () {
                var actionOptionArr = [
                    "access:federation:AddGroupEvent",
                    "access:federation:AddRoleEvent",
                    "access:federation:CreateEvent",
                    "access:federation:DeleteEvent",
                    "access:federation:InvokeEvent",
                    "access:federation:ModifyEvent",
                    "access:federation:RemoveGroupEvent",
                    "access:federation:RemoveRoleEvent",
                    "access:group:AddRoleEvent",
                    "access:group:CreateEvent",
                    "access:group:DeleteEvent",
                    "access:group:ModifyEvent",
                    "access:group:RemoveRoleEvent",
                    "access:role:CreateEvent",
                    "access:role:DeleteEvent",
                    "access:role:ModifyEvent",
                    "access:user:AddGroupEvent",
                    "access:user:AddRoleEvent",
                    "access:user:CreateEvent",
                    "access:user:DeleteEvent",
                    "access:user:ModifyEvent",
                    "access:user:ValidateEvent",
                    "access:user:AuthEvent",
                    "access:user:RemoveGroupEvent",
                    "access:user:RemoveRoleEvent",
                    "access:vault:CreateEvent",
                    "access:vault:DeleteEvent",
                    "access:vault:InvokeEvent",
                    "access:authenticator:CreateEvent",
                    "access:authenticator:ModifyEvent",
                    "access:authenticator:DeleteEvent",
                    "access:authenticator:AddUserEvent",
                    "access:authenticator:RemoveUserEvent",
                    "access:contact:ListEvent",
                    "access:contact:CreateEvent",
                    "access:contact:ModifyEvent",
                    "access:contact:DeleteEvent",
                    "tracker:issue:CreateEvent",
                    "tracker:issue:AddCommentEvent",
                    "tracker:issue:ModifyEvent",
                    "tracker:issue:ModifyCommentEvent",
                    "tracker:issue:DeleteEvent",
                    "tracker:issue:RemoveLabelEvent",
                    "tracker:issue:RemoveCommentEvent",
                    "tracker:issue:AddLabelEvent",
                    "tracker:file:UploadEvent",
                    "tracker:label:ModifyEvent",
                    "tracker:label:CreateEvent",
                    "tracker:label:DeleteEvent",
                    "pipeline:transformer:ModifyEvent",
                    "pipeline:transformer:CreateEvent",
                    "pipeline:transformer:DeleteEvent",
                    "pipeline:listener:RemoveWorkflowEvent",
                    "pipeline:listener:CreateEvent",
                    "pipeline:listener:ModifyEvent",
                    "pipeline:listener:DeleteEvent",
                    "pipeline:listener:AddWorkflowEvent",
                    'pipeline:workflow:CreateEvent',
                    'pipeline:workflow:ExecuteFailEvent',
                    "pipeline:workflow:ModifyEvent",
                    "pipeline:workflow:DeleteEvent",
                    "pipeline:template:CreateEvent",
                    "pipeline:template:ModifyEvent",
                    "pipeline:template:DeleteEvent",
                    "node:observer:DeleteEvent",
                    "node:observer:CreateEvent",
                    "node:observer:ModifyEvent",
                    "node:observer:MatchEvent",
                    "node:gateway:CreateEvent",
                    "node:gateway:ModifyEvent",
                    "node:gateway:DeleteEvent",
                    "node:gateway:ModifyGhostEvent",
                    "node:device:CreateEvent",
                    "node:device:DeleteEvent",
                    "node:device:LifecycleEvent",
                    "node:device:ModifyEvent",
                    "node:device:ModifyGhostEvent",
                    "node:device:CreateTunnelEvent",
                    "node:device:EnableAttributeEvent",
                    "node:device:DisableAttributeEvent",
                    "node:component:EnableEvent",
                    "node:component:DisableEvent",
                    "node:component:ModifyGhostEvent",
                    "node:component:ModifyEvent",
                    "node:component:EnableAttributeEvent",
                    "node:component:DisableAttributeEvent",
                    "node:visualizer:CreateEvent",
                    "node:visualizer:DeleteEvent",
                    "node:visualizer:ModifyEvent",
                    "node:health:ModifyEvent",
                    "node:health:CreateEvent",
                    "node:health:DeleteEvent",
                    "node:notification:CreateEvent",
                    "node:notification:ModifyEvent",
                    "node:notification:DeleteEvent",
                    "node:notification:MatchEvent",
                    "node:cluster:CreateEvent",
                    "node:cluster:DeleteEvent",
                    "node:cluster:RemoveDeviceEvent",
                    "node:cluster:ModifyEvent",
                    "node:cluster:AddDeviceEvent",
                    "node:cluster:AddGatewayEvent",
                    "node:cluster:RemoveGatewayEvent",
                    "storage:folder:ModifyEvent",
                    "storage:folder:CreateEvent",
                    "storage:folder:DeleteEvent",
                    "storage:file:UploadEvent",
                    "storage:file:ModifyEvent",
                    "storage:file:DeleteEvent",
                    "storage:file:AppendEvent",
                    "external:email:ReceiveEvent",
                    "ai:trainer:CreateEvent",
                    "ai:trainer:DeleteEvent",
                    "ai:trainer:StopEvent",
                    "ai:model:CreateEvent",
                    "ai:model:ModifyEvent",
                    "ai:model:DeleteEvent",
                    "ai:distribution:CreateEvent",
                    "ai:distribution:ModifyEvent",
                    "ai:distribution:DeleteEvent",
                    "ai:deployment:CreateEvent",
                    "ai:deployment:DeleteEvent",
                    "ai:deployment:ModifyEvent",
                    "billing:budget:CreateEvent",
                    "billing:budget:DeleteEvent",
                    "billing:budget:MatchEvent",
                    "billing:budget:ModifyEvent",
                    "billing:credit:AddEvent",
                    "billing:invoice:CreateEvent",
                    "billing:payment:FailureEvent",
                    "billing:payment:SuccessEvent",
                    "billing:preference:ModifyEvent",
                    "billing:profile:CreateEvent",
                    "billing:profile:DeleteEvent",
                    "billing:profile:ModifyEvent"
                ];
                return actionOptionArr;
            },
            getRoleActionOptionArr: function () {
                var roleActionOptionArr = [
                    "node:device:Modify",
                    "node:notification:View",
                    "node:cluster:View",
                    "node:health:View",
                    "access:federation:View",
                    "access:federation:Open",
                    "node:gateway:View",
                    "node:observer:View",
                    "node:device:View",
                    "node:cluster:Create",
                    "pipeline:workflow:View"
                ];
                return roleActionOptionArr;
            },
            getRoleFilterOptionArr: function () {
                var filterArr = [
                    '$.user.id',
                    '$.user.email',
                    '$.user.username',
                    '$.user.name',
                    '$.user.state',
                    '$.group.id',
                    '$.group.name',
                    '$.group.description',
                    '$.role.id',
                    '$.role.name',
                    '$.role.description',
                    '$.vault.id',
                    '$.vault.name',
                    '$.vault.description',
                    '$.vault.type',
                    '$.account.id',
                    '$.account.name',
                    '$.account.description',
                    '$.federation.id',
                    '$.federation.alias',
                    '$.federation.description',
                    '$.federation.type',
                    '$.authenticator.id',
                    '$.authenticator.name',
                    '$.authenticator.description',
                    '$.authenticator.typeId',
                    '$.authenticator.vaultId',
                    "$.contact.id",
                    "$.contact.firstName",
                    "$.contact.lastName",
                    "$.contact.company",
                    '$.issue.id',
                    '$.issue.title',
                    '$.issue.state',
                    '$.issue.labels',
                    '$.issue.created',
                    '$.issue.createdBy',
                    '$.issue.lastUpdated',
                    '$.issue.lastUpdatedBy',
                    '$.issue.assignee',
                    '$.label.id',
                    '$.label.title',
                    '$.label.color',
                    '$.listener.id',
                    '$.listener.name',
                    '$.listener.description',
                    '$.listener.state',
                    '$.template.id',
                    '$.template.name',
                    '$.template.description',
                    '$.template.body',
                    '$.transformer.id',
                    '$.transformer.name',
                    '$.transformer.description',
                    '$.workflow.id',
                    '$.workflow.name',
                    '$.workflow.description',
                    '$.device.id',
                    '$.device.name',
                    '$.device.description',
                    '$.gateway.id',
                    '$.gateway.name',
                    '$.gateway.description',
                    '$.health.id',
                    '$.health.name',
                    '$.health.color',
                    '$.health.code',
                    '$.lifecycle.id',
                    '$.lifecycle.name',
                    '$.lifecycle.description',
                    '$.observer.id',
                    '$.observer.name',
                    '$.notification.id',
                    '$.notification.name',
                    '$.notification.description',
                    '$.notification.state',
                    '$.observer.description',
                    '$.visualizer.id',
                    '$.visualizer.name',
                    '$.visualizer.description',
                    '$.folder.path',
                    '$.folder.source.path',
                    '$.folder.source.size',
                    '$.folder.source.lastModified',
                    '$.folder.destination.path',
                    '$.folder.destination.size',
                    '$.folder.destination.lastModified',
                    '$.file.path',
                    '$.file.size',
                    '$.file.lastModified',
                    '$.file.url',
                    '$.file.expires',
                    '$.file.method',
                    '$.file.metadata.type',
                    '$.file.metadata.encoding',
                    '$.file.metadata.language',
                    '$.file.metadata.md5',
                    '$.file.metadata.versionId',
                    '$.file.source.path',
                    '$.file.source.size',
                    '$.file.source.lastModified',
                    '$.file.destination.path',
                    '$.file.destination.size',
                    '$.file.destination.lastModified',
                    '$.content.path',
                    '$.content.size',
                    '$.content.lastModified',
                    '$.trainer.id',
                    '$.trainer.name',
                    '$.trainer.algorithmId',
                    '$.trainer.outputPath',
                    '$.trainer.trainingVmId',
                    '$.trainer.trainingVmCount',
                    '$.trainer.trainingMaxTime',
                    '$.trainer.trainingVmDriveSize',
                    '$.trainer.status',
                    '$.model.id',
                    '$.model.name',
                    '$.model.description',
                    '$.model.algorithmId',
                    '$.model.artifactPath',
                    '$.distribution.id',
                    '$.distribution.name',
                    '$.distribution.description',
                    '$.deployment.id',
                    '$.deployment.name',
                    '$.deployment.description',
                    '$.deployment.distributionId',
                    '$.deployment.status',
                    '$.budget.id',
                    '$.budget.name',
                    '$.budget.description',
                    '$.budget.policy',
                    '$.credit.global',
                    '$.credit.pipelineWorkflow',
                    '$.credit.nodeIoT',
                    '$.credit.nodeCellular',
                    '$.credit.nodeGateway',
                    '$.credit.storageFile',
                    '$.credit.aiIq',
                    '$.credit.insightQuery',
                    '$.credit.trackerIssue',
                    '$.invoice.id',
                    '$.invoice.year',
                    '$.invoice.month',
                    '$.invoice.currency',
                    '$.invoice.tax',
                    '$.invoice.total',
                    '$.invoice.amountPaid',
                    '$.invoice.amountDue',
                    '$.invoice.description',
                    '$.invoice.state',
                    '$.invoice.issued',
                    '$.invoice.dueBy',
                    '$.preference.receiveNewInvoice',
                    '$.profile.id',
                    '$.profile.primary',
                    '$.profile.customerType',
                    '$.summary.id',
                    '$.summary.year',
                    '$.summary.month',
                    '$.summary.currency',
                    '$.summary.service',
                    '$.summary.title',
                    '$.summary.quantity',
                    '$.summary.price',
                    '$.transaction.id',
                    '$.transaction.invoiceId',
                    '$.transaction.timestamp',
                    '$.transaction.source',
                    '$.transaction.amount',
                    '$.transaction.message'
                ];
                return filterArr;
            }
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .filter('unique', fnUniqueFilter);

    /** @ngInject */
    function fnUniqueFilter() {
        return function (items, filterOn) {


            if (filterOn === false) {
                return items;
            }

            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var newItems = [];

                var extractValueToCompare = function (item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    } else {
                        return item;
                    }
                };

                angular.forEach(items, function (item) {
                    var isDuplicate = false;

                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }

                });
                items = newItems;
            }
            return items;
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('phoenixNewUi')
        .directive('treeMap', fnTreeMap);

    /** @ngInject */
    function fnTreeMap(d3,ColorService) {
        return {
            restrict: 'AEC',
            scope: {
                treeDataArr: '=',
                isCalledFromGatewayDevice: '=',
                fnGetItems: '&'
            },
            template: '<section class="tree-map-container">'+
                            '<div id="main">'+
                                    '<div id="tree-map-graph" class="tree-map-graph" style="position: relative">'+
                                    '</div>'+
                            '</div>'+
                        '</section>',
            link: function ($scope) {
                //var pageHeight = 0;
                var treeArr = $scope.treeDataArr;

                $('body').resize(function () { //eslint-disable-line
                    alert('on inside iframe'); //eslint-disable-line
                });

                var aspect_ratio = 0.6;//eslint-disable-line
                var margin = {top: 10, right: 0, bottom: 10, left: 0};
                var width = window.parent.$("#treeMap").width();//eslint-disable-line
                var height = window.parent.$("#treeMap").height();//eslint-disable-line


                $(window).resize(function () {//eslint-disable-line
                    if (jQuery(window).width() !== width) {//eslint-disable-line
                        width = angular.element('#tree-map-graph').parent().width() - margin.left - margin.right;
                        if (width > 1100) {
                            aspect_ratio = 0.4
                        } else {
                            aspect_ratio = 0.6
                        }
                        height = window.parent.$("#treeMap").height();//eslint-disable-line
                        $("#tree-map-graph").empty();//eslint-disable-line
                        render();
                    }
                });
                function render() {
                    var treeChild = [];
                    treeArr.sort(function (a, b) {
                        return b.priority - a.priority;
                    });

                    treeArr.map(function (obj) {
                        treeChild.push({name: obj.name, size: 100, treeObj: obj, health: obj.health})
                    });
                    var root = {
                        name: "tree",
                        children: treeChild
                    };
                    var treemap = d3.layout.treemap()
                        .size([width, height])
                        .sticky(true)
                        .sort(function (a, b) {
                            return b.value - a.value;
                        })
                        .value(function (d) {
                            return d.size;
                        });

                    var div = d3.select("#tree-map-graph").append("div");


                    var node = div.datum(root).selectAll(".node")//eslint-disable-line
                        .data(treemap.nodes)
                        .enter().append("div")
                        .attr("class", "node")
                        .attr("title", function (d) {
                            return d.name
                        })
                        .call(position)
                        .style("background", function (d) {
                            var healthObj = ColorService.getHealthColorForLoop(d.health);
                            return angular.isDefined(healthObj) ? healthObj['background-color']:"";
                        })
                        .text(function (d) {
                            return d.children ? null : d.name;
                        })
                        .style("color", function (d) {
                            var healthObj = ColorService.getHealthColorForLoop(d.health);
                            return angular.isDefined(healthObj) ? healthObj.color:"";
                        })
                        .on("click", function (d) {
                            if($scope.isCalledFromGatewayDevice) {
                                $scope.selectedItem = d.treeObj;
                                $scope.fnGetItems({
                                    selectedItem: $scope.selectedItem,
                                    itemArr: $scope.treeDataArr,
                                    isCalledFromDirective: true
                                });
                            }
                        });
                    //pageHeight = height;

                    // $(window).resize();
                }

                function position() {
                    this.style("left", function (d) {
                        return d.x + "px";
                    })
                        .style("top", function (d) {
                            return d.y + "px";
                        })
                        .style("width", function (d) {
                            return Math.max(0, d.dx - 1) + "px";
                        })
                        .style("height", function (d) {
                            return Math.max(0, d.dy - 1) + "px";
                        });
                }

                /*function fnGetDeviceColor(health) {
                    health = health ? health : 'UNKNOWN';
                    switch (health) {
                        case 'OK':
                            return "#008000";
                            break;
                        case 'WARNING':
                            return "#F1C232";
                            break;
                        case 'DEGRADED':
                            return "#FFA500";
                            break;
                        case 'SEVERE':
                            return "#CC0000";
                            break;
                        case 'UNKNOWN':
                            return "#8c8c8c";
                            break;
                        case 'UNREACHABLE':
                            return 'repeating-linear-gradient(-55deg,#FFFF00,#FFFF00 10px,#000 10px,#000 20px)';
                            break;
                        case 'DISCONNECTED':
                            return 'repeating-linear-gradient(-55deg,#f00,#f00 10px,#000 10px,#000 20px)';
                            break;
                        default:
                            return "white";
                    }
                }*/

                render();


                $scope.$watch('treeDataArr', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        $("#tree-map-graph").empty();//eslint-disable-line
                        treeArr = newValue;
                        render();
                    }
                });
            }
        };
    }
})();

/*eslint-disable*/
angular.module('mc.resizer', []).directive('resizer', function($document) {

    return function($scope, $element, $attrs) {

        $element.on('mousedown', function(event) {
            event.preventDefault();

            $document.on('mousemove', mousemove);
            $document.on('mouseup', mouseup);
        });

        function mousemove(event) {

            if ($attrs.resizer == 'vertical') {
                // Handle vertical resizer
                var x = event.pageX;

                if ($attrs.resizerMax && x > $attrs.resizerMax) {
                    x = parseInt($attrs.resizerMax);
                }

                $element.css({
                    left: x + 'px'
                });

                $($attrs.resizerLeft).css({
                    width: x + 'px'
                });
                $($attrs.resizerRight).css({
                    left: (x + parseInt($attrs.resizerWidth)) + 'px'
                });

            } else {
                // Handle horizontal resizer
                var y = window.innerHeight - event.pageY;

                $element.css({
                    bottom: y + 'px'
                });

                $($attrs.resizerTop).css({
                    bottom: (y + parseInt($attrs.resizerHeight)) + 'px'
                });
                $($attrs.resizerBottom).css({
                    height: y + 'px'
                });
            }
        }

        function mouseup() {
            $document.unbind('mousemove', mousemove);
            $document.unbind('mouseup', mouseup);
        }
    };
});
/*eslint-enable*/

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngQueryBuilder1', fnNgQueryBuilder);

    /** @ngInject */
    function fnNgQueryBuilder() {
        return {
            restrict: 'EA',
            scope: {
                qbFilter: "=",
                resJson: "="
            },
            link: function ($scope, $element) {
                var builder = $element;
                builder.queryBuilder({
                    sortable: true,
                    filters: $scope.qbFilter
                });
                /* var rules = {
                     "condition": "AND",
                     "rules": [{
                         "id": "core_ID",
                         "field": "core_ID",
                         "type": "integer",
                         "input": "text",
                         "operator": "in",
                         "value": "1240"
                     }]
                 };

                 builder.queryBuilder('setRules', rules);*/

                $scope.run = function () {
                    // json
                    $scope.resJson = builder.queryBuilder('getRules');
                    /*  $scope.jsonParsed = JSON.stringify(resJson, null, "\t");

                      // SQL
                      var resSql = builder.queryBuilder('getSQL', false);
                      $scope.sqlParsed = resSql.sql;*/
                };

                $scope.$on('queryBuilderReset', function () {
                    builder.queryBuilder('reset');
                });

                $scope.$on('queryBuilderSet', function (event, args) {
                    builder.queryBuilder('setRules', args);
                });

                $scope.$on('changeText', function () {
                    /* eslint-disable */
                    $scope.run();
                    /* eslint-enable */
                });

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngStorageFiles', fnNgStorageFiles);

    /** @ngInject */
    function fnNgStorageFiles() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&'
            },
            link: function (scope, element) {
                //var onChange = $parse(attrs.ngFiles);
                element.on('change', function () {
                    var fileData = this.files[0];
                    scope.uploadFile({filedata: fileData});
                    //onChange(scope, {filedata: fileData});
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngStorageFileDrop', fnNgStorageFileDrop);

    /** @ngInject */
    function fnNgStorageFileDrop() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&',
                commentObj: '='
            },
            link: function (scope, element) {
                var dropZone = element.get(0);
                var dropZone1 = document.getElementById('dropzone');
                /*function readFile(file, callback) {
                    var reader = new FileReader();
                    reader.onload = callback;
                    reader.readAsArrayBuffer(file);
                }*/

                element.on('dragend', function (evt) {
                    evt.preventDefault();
                    dropZone1.style.display = "block";
                    //element.addClass('dropActive');
                });

                dropZone.addEventListener('drop', function (evt) {
                    evt.preventDefault();
                    dropZone1.style.display = "none";
                    //element.removeClass('dropActive');
                    if (evt.dataTransfer.files[0]) {
                        var fileData = evt.dataTransfer.files[0];
                        scope.uploadFile({filedata: fileData});
                        /*readFile(fileData, function (event) {
                            //manipulate with result...
                            if (scope.commentObj) {
                                scope.uploadFile({
                                    $files: event.target.result,
                                    filedata: fileData,
                                    commentObj: scope.commentObj
                                });
                            } else {
                                scope.uploadFile({$files: event.target.result, filedata: fileData});
                            }
                            element.removeClass('dropActive');
                        });*/
                    }
                });

                 element.on('dragover', function (evt) {
                     evt.preventDefault();
                     dropZone1.style.display = "block";
                 });

                element.on('dragleave', function (evt) {
                    evt.preventDefault();
                    var stopDrag = false;
                    if (!evt.relatedTarget) {
                        stopDrag = true;
                    }
                    else {
                        var parentDrop = $(evt.relatedTarget).parents('.storageDrop'); //eslint-disable-line
                        if (evt.relatedTarget !== this && !parentDrop.length) {
                            stopDrag = true;
                        }
                    }

                    if (stopDrag) {
                        dropZone1.style.display = "none";
                        //element.removeClass('dropActive');
                    }
                });

                element.on('dragenter', function (evt) {
                    evt.preventDefault();
                    dropZone1.style.display = "block";
                    //element.addClass('dropActive');
                });

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngSoftwareFiles', fnNgSoftwareFiles);

    /** @ngInject */
    function fnNgSoftwareFiles() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&'
            },
            link: function (scope, element) {
                //var onChange = $parse(attrs.ngFiles);
                element.on('change', function () {
                    var fileData = this.files[0];
                    scope.uploadFile({filedata: fileData});
                    //onChange(scope, {filedata: fileData});
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngFilesForIssue', fnNgFilesForIssue);

    /** @ngInject */
    function fnNgFilesForIssue() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&',
                commentObj: '='
            },
            link: function (scope, element) {
                //var onChange = $parse(attrs.ngFiles);
                element.on('change', function () {
                    var fileData = this.files[0];
                    if(fileData.type !== 'image/png' && fileData.type !== 'image/jpeg' && fileData.type !== 'image/jpg'
                        && fileData.type !== 'image/gif') {
                        if (scope.commentObj) {
                            scope.uploadFile({type: 'doc', filedata: fileData, commentObj: scope.commentObj});
                        } else {
                            scope.uploadFile({type: 'doc', filedata: fileData});
                        }
                    } else {
                        if (scope.commentObj) {
                            scope.uploadFile({type: 'image', filedata: fileData, commentObj: scope.commentObj});
                        } else {
                            scope.uploadFile({type: 'image', filedata: fileData});
                        }
                    }
                    //onChange(scope, {filedata: fileData});
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngFiles', fnNgFiles);

    /** @ngInject */
    function fnNgFiles($parse, $window) {
        return {
            restrict: 'EA',
            scope:{
                uploadSource:"=",
                uploadFiles: "&",
                commentObj: "="
            },
            link: function (scope, element) {
                //var onChange = $parse(attrs.ngFiles);
                // var canvas = document.getElementById('canvasImage');
                var img = new Image();
                var _URL = $window.URL || $window.webkitURL;

                element.on('change', function () {
                    var fileData = this.files[0];
                    if(angular.isDefined(scope.uploadSource) && scope.uploadSource === 'tracker' &&
                        fileData.type !== 'image/png' && fileData.type !== 'image/jpeg' && fileData.type !== 'image/jpg'
                        && fileData.type !== 'image/gif') {
                        if(scope.commentObj) {
                            scope.uploadFiles({$files: null, filedata: fileData, commentObj: scope.commentObj});
                        } else {
                            scope.uploadFiles({$files: null, filedata: fileData});
                        }
                    } else {
                        img.onload = function () {
                            var canvas = document.createElement('canvas');
                            var quality = 80 * 100 || 70;
                            var maxHeight = this.height;
                            var maxWidth = this.width;
                            var mimeType = fileData.type ? fileData.type : "image/jpeg";
                            var height = this.height;
                            var width = this.width;
                            if (mimeType !== 'image/gif' || mimeType !== 'image/png') {
                                // calculate the width and height, constraining the proportions
                                if (width > height) {
                                    if (width > maxWidth) {
                                        height = Math.round(height *= maxWidth / width);
                                        width = maxWidth;
                                    }
                                } else {
                                    if (height > maxHeight) {
                                        width = Math.round(width *= maxHeight / height);
                                        height = maxHeight;
                                    }
                                }

                                canvas.width = width;
                                canvas.height = height;
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);
                                canvas.toBlob(function (blob) {

                                    /*eslint-disable*/
                                    console.log('original size', fileData.size, "Byte");
                                    console.log('upload size', blob.size, 'Byte');
                                    /*eslint-enable*/

                                    readFile(blob, function (event) {
                                        //manipulate with result...
                                        if(angular.isDefined(scope.uploadSource) && scope.uploadSource === 'tracker' && scope.commentObj) {
                                            scope.uploadFiles({$files: event.target.result, filedata: fileData, commentObj: scope.commentObj});
                                        } else {
                                            scope.uploadFiles({$files: event.target.result, filedata: fileData});
                                        }
                                        //onChange(scope, {$files: event.target.result, filedata: fileData});
                                    });
                                }, mimeType, quality / 100);
                            } else {
                                readFile(fileData, function (event) {
                                    //manipulate with result...
                                    if(angular.isDefined(scope.uploadSource) && scope.uploadSource === 'tracker' && scope.commentObj) {
                                        scope.uploadFiles({$files: event.target.result, filedata: fileData, commentObj: scope.commentObj});
                                    } else {
                                        scope.uploadFiles({$files: event.target.result, filedata: fileData});
                                    }
                                    //onChange(scope, {$files: event.target.result, filedata: fileData});
                                });
                            }

                        };

                        img.src = _URL.createObjectURL(fileData);
                    }
                });

                function readFile(file, callback) {
                    var reader = new FileReader();
                    reader.onload = callback;
                    reader.readAsArrayBuffer(file);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngDropDirForSoftware', fnNgDropDirForSoftware);

    /** @ngInject */
    function fnNgDropDirForSoftware() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&'
            },
            link: function (scope, element) {
                var dropZone = element.get(0);

                element.on('dragend', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

                dropZone.addEventListener('drop', function (evt) {
                    evt.preventDefault();

                    if (evt.dataTransfer.files[0]) {
                        var fileData = evt.dataTransfer.files[0];
                        scope.uploadFile({type: 'doc', filedata: fileData});
                    }
                    element.removeClass('dropActive');
                });

                element.on('dragover', function (evt) {
                    evt.preventDefault();
                });

                element.on('dragleave', function (evt) {
                    evt.preventDefault();

                    element.removeClass('dropActive');
                });

                element.on('dragenter', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngDropDirForIssue', fnNgDropDirForIssue);

    /** @ngInject */
    function fnNgDropDirForIssue() {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&',
                commentObj: '='
            },
            link: function (scope, element) {
                var dropZone = element.get(0);

                element.on('dragend', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

                dropZone.addEventListener('drop', function (evt) {
                    evt.preventDefault();

                    if (evt.dataTransfer.files[0]) {
                        var fileData = evt.dataTransfer.files[0];
                        if(fileData.type !== 'image/png' && fileData.type !== 'image/jpeg' && fileData.type !== 'image/jpg'
                            && fileData.type !== 'image/gif') {
                            if(scope.commentObj) {
                                scope.uploadFile({type: 'doc', filedata: fileData, commentObj: scope.commentObj});
                            } else {
                                scope.uploadFile({type: 'doc', filedata: fileData});
                            }
                        } else {
                            if(scope.commentObj) {
                                scope.uploadFile({type: 'image', filedata: fileData, commentObj: scope.commentObj});
                            } else {
                                scope.uploadFile({type: 'image', filedata: fileData});
                            }
                        }
                    }
                    element.removeClass('dropActive');
                });

                /* element.on('dragover', function (evt) {

                 });*/

                element.on('dragleave', function (evt) {
                    evt.preventDefault();

                    element.removeClass('dropActive');
                });

                element.on('dragenter', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngDropDir', fnNgDropDir);

    /** @ngInject */
    function fnNgDropDir($window) {
        return {
            restrict: 'EA',
            scope: {
                uploadFile: '&',
                commentObj: '=',
                uploadSource: "="
            },
            link: function (scope, element) {
                var dropZone = element.get(0);
                var img = new Image();
                var _URL = $window.URL || $window.webkitURL;

                /* element.on('dragstart', function (evt) {

                 });*/

                function readFile(file, callback) {
                    var reader = new FileReader();
                    reader.onload = callback;
                    reader.readAsArrayBuffer(file);
                }

                element.on('dragend', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

                dropZone.addEventListener('drop', function (evt) {
                    evt.preventDefault();

                    if (evt.dataTransfer.files[0]) {
                        var fileData = evt.dataTransfer.files[0];
                        if(angular.isDefined(scope.uploadSource) && scope.uploadSource === 'tracker' &&
                            fileData.type !== 'image/png' && fileData.type !== 'image/jpeg' && fileData.type !== 'image/jpg'
                            && fileData.type !== 'image/gif') {
                            if(scope.commentObj) {
                                scope.uploadFile({$files: null, filedata: fileData, commentObj: scope.commentObj});
                            } else {
                                scope.uploadFile({$files: null, filedata: fileData});
                            }
                        } else {
                            img.onload = function () {
                                var canvas = document.createElement('canvas');
                                var quality = 80 * 100 || 70;
                                var maxHeight = 800;
                                var maxWidth = 800;
                                var mimeType = fileData.type.includes('gif') ? fileData.type : "image/jpeg";
                                var height = this.width;
                                var width = this.height;
                                if (mimeType !== 'image/gif') {
                                    // calculate the width and height, constraining the proportions
                                    if (width > height) {
                                        if (width > maxWidth) {
                                            height = Math.round(height *= maxWidth / width);
                                            width = maxWidth;
                                        }
                                    } else {
                                        if (height > maxHeight) {
                                            width = Math.round(width *= maxHeight / height);
                                            height = maxHeight;
                                        }
                                    }

                                    canvas.width = height;
                                    canvas.height = width;
                                    var ctx = canvas.getContext('2d');
                                    ctx.drawImage(img, 0, 0);
                                    canvas.toBlob(function (blob) {

                                        /*eslint-disable*/
                                        console.log('original size', fileData.size, "Byte");
                                        console.log('upload size', blob.size, 'Byte');
                                        /*eslint-enable*/

                                        readFile(blob, function (event) {
                                            //manipulate with result...
                                            if (scope.commentObj) {
                                                scope.uploadFile({
                                                    $files: event.target.result,
                                                    filedata: fileData,
                                                    commentObj: scope.commentObj
                                                });
                                            } else {
                                                scope.uploadFile({$files: event.target.result, filedata: fileData});
                                            }
                                            element.removeClass('dropActive');
                                        });

                                    }, mimeType, quality / 100);
                                } else {
                                    readFile(fileData, function (event) {
                                        //manipulate with result...
                                        if (scope.commentObj) {
                                            scope.uploadFile({
                                                $files: event.target.result,
                                                filedata: fileData,
                                                commentObj: scope.commentObj
                                            });
                                        } else {
                                            scope.uploadFile({$files: event.target.result, filedata: fileData});
                                        }
                                        element.removeClass('dropActive');
                                    });
                                }

                            };

                            img.src = _URL.createObjectURL(fileData);
                        }
                    }
                });

                /* element.on('dragover', function (evt) {

                 });*/

                element.on('dragleave', function (evt) {
                    evt.preventDefault();

                    element.removeClass('dropActive');
                });

                element.on('dragenter', function (evt) {
                    evt.preventDefault();

                    element.addClass('dropActive');
                });

            }
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('ngDrop', fnNgDrop);

    /** @ngInject */
    function fnNgDrop() {
        return {
            restrict: 'A',
            scope:{
                ngDropObj:"="
            },
            link: function ($scope, element) {
                element.prop('draggable', true);
                element.on('dragstart', function(event) {
                    event.originalEvent.dataTransfer.setData('text', JSON.stringify($scope.ngDropObj)) //eslint-disable-line
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .directive('httpSrc', fnHttpSrc);

    /** @ngInject */
    function fnHttpSrc($http) {
        return {
            link: function ($scope, elem, attrs) {
                function revokeObjectURL() {
                    if ($scope.objectURL) {
                        URL.revokeObjectURL($scope.objectURL);
                    }
                }

                /*	$scope.$watch('objectURL', function (objectURL) {
                        elem.attr('src', angular.copy(objectURL));
                    });*/

                $scope.$on('$destroy', function () {
                    revokeObjectURL();
                });

                attrs.$observe('httpSrc', function (url) {
                    revokeObjectURL();

                    if (url && url.indexOf('data:') === 0) {
                        $scope.objectURL = url;
                    } else if (url) {
                        $http.get(url, {responseType: 'arraybuffer'})
                            .then(function (response) {
                                var blob = new Blob(
                                    [response.data],
                                    {type: response.headers('Content-Type')}
                                );

                                // $scope.objectURL = URL.createObjectURL(blob);
                                elem.attr('src', URL.createObjectURL(blob));

                            });
                    }
                });
            }
        }
    }
})();

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
    if (typeof exports == "object" && typeof module == "object") // CommonJS
        mod(require("../../lib/codemirror"));
    else if (typeof define == "function" && define.amd) // AMD
        define(["../../lib/codemirror"], mod);
    else // Plain browser env
        mod(CodeMirror);
})(function(CodeMirror) {
    "use strict";
    var GUTTER_ID = "CodeMirror-lint-markers";

    function showTooltip(e, content) {
        var tt = document.createElement("div");
        tt.className = "CodeMirror-lint-tooltip";
        tt.appendChild(content.cloneNode(true));
        document.body.appendChild(tt);

        function position(e) {
            if (!tt.parentNode) return CodeMirror.off(document, "mousemove", position);
            tt.style.top = Math.max(0, e.clientY - tt.offsetHeight - 5) + "px";
            tt.style.left = (e.clientX + 5) + "px";
        }
        CodeMirror.on(document, "mousemove", position);
        position(e);
        if (tt.style.opacity != null) tt.style.opacity = 1;
        return tt;
    }
    function rm(elt) {
        if (elt.parentNode) elt.parentNode.removeChild(elt);
    }
    function hideTooltip(tt) {
        if (!tt.parentNode) return;
        if (tt.style.opacity == null) rm(tt);
        tt.style.opacity = 0;
        setTimeout(function() { rm(tt); }, 600);
    }

    function showTooltipFor(e, content, node) {
        var tooltip = showTooltip(e, content);
        function hide() {
            CodeMirror.off(node, "mouseout", hide);
            if (tooltip) { hideTooltip(tooltip); tooltip = null; }
        }
        var poll = setInterval(function() {
            if (tooltip) for (var n = node;; n = n.parentNode) {
                if (n && n.nodeType == 11) n = n.host;
                if (n == document.body) return;
                if (!n) { hide(); break; }
            }
            if (!tooltip) return clearInterval(poll);
        }, 400);
        CodeMirror.on(node, "mouseout", hide);
    }

    function LintState(cm, options, hasGutter) {
        this.marked = [];
        this.options = options;
        this.timeout = null;
        this.hasGutter = hasGutter;
        this.onMouseOver = function(e) { onMouseOver(cm, e); };
        this.waitingFor = 0
    }

    function parseOptions(_cm, options) {
        if (options instanceof Function) return {getAnnotations: options};
        if (!options || options === true) options = {};
        return options;
    }

    function clearMarks(cm) {
        var state = cm.state.lint;
        if (state.hasGutter) cm.clearGutter(GUTTER_ID);
        for (var i = 0; i < state.marked.length; ++i)
            state.marked[i].clear();
        state.marked.length = 0;
    }

    function makeMarker(labels, severity, multiple, tooltips) {
        var marker = document.createElement("div"), inner = marker;
        marker.className = "CodeMirror-lint-marker-" + severity;
        if (multiple) {
            inner = marker.appendChild(document.createElement("div"));
            inner.className = "CodeMirror-lint-marker-multiple";
        }

        if (tooltips != false) CodeMirror.on(inner, "mouseover", function(e) {
            showTooltipFor(e, labels, inner);
        });

        return marker;
    }

    function getMaxSeverity(a, b) {
        if (a == "error") return a;
        else return b;
    }

    function groupByLine(annotations) {
        var lines = [];
        for (var i = 0; i < annotations.length; ++i) {
            var ann = annotations[i], line = ann.from.line;
            (lines[line] || (lines[line] = [])).push(ann);
        }
        return lines;
    }

    function annotationTooltip(ann) {
        var severity = ann.severity;
        if (!severity) severity = "error";
        var tip = document.createElement("div");
        tip.className = "CodeMirror-lint-message-" + severity;
        if (typeof ann.messageHTML != 'undefined') {
            tip.innerHTML = ann.messageHTML;
        } else {
            tip.appendChild(document.createTextNode(ann.message));
        }
        return tip;
    }

    function lintAsync(cm, getAnnotations, passOptions) {
        var state = cm.state.lint
        var id = ++state.waitingFor
        function abort() {
            id = -1
            cm.off("change", abort)
        }
        cm.on("change", abort)
        getAnnotations(cm.getValue(), function(annotations, arg2) {
            cm.off("change", abort)
            if (state.waitingFor != id) return
            if (arg2 && annotations instanceof CodeMirror) annotations = arg2
            cm.operation(function() {updateLinting(cm, annotations)})
        }, passOptions, cm);
    }

    function startLinting(cm) {
        var state = cm.state.lint, options = state.options;
        /*
         * Passing rules in `options` property prevents JSHint (and other linters) from complaining
         * about unrecognized rules like `onUpdateLinting`, `delay`, `lintOnChange`, etc.
         */
        var passOptions = options.options || options;
        var getAnnotations = options.getAnnotations || cm.getHelper(CodeMirror.Pos(0, 0), "lint");
        if (!getAnnotations) return;
        if (options.async || getAnnotations.async) {
            lintAsync(cm, getAnnotations, passOptions)
        } else {
            var annotations = getAnnotations(cm.getValue(), passOptions, cm);
            if (!annotations) return;
            if (annotations.then) annotations.then(function(issues) {
                cm.operation(function() {updateLinting(cm, issues)})
            });
            else cm.operation(function() {updateLinting(cm, annotations)})
        }
    }

    function updateLinting(cm, annotationsNotSorted) {
        clearMarks(cm);
        var state = cm.state.lint, options = state.options;

        var annotations = groupByLine(annotationsNotSorted);

        for (var line = 0; line < annotations.length; ++line) {
            var anns = annotations[line];
            if (!anns) continue;

            var maxSeverity = null;
            var tipLabel = state.hasGutter && document.createDocumentFragment();

            for (var i = 0; i < anns.length; ++i) {
                var ann = anns[i];
                var severity = ann.severity;
                if (!severity) severity = "error";
                maxSeverity = getMaxSeverity(maxSeverity, severity);

                if (options.formatAnnotation) ann = options.formatAnnotation(ann);
                if (state.hasGutter) tipLabel.appendChild(annotationTooltip(ann));

                if (ann.to) state.marked.push(cm.markText(ann.from, ann.to, {
                    className: "CodeMirror-lint-mark-" + severity,
                    __annotation: ann
                }));
            }

            if (state.hasGutter)
                cm.setGutterMarker(line, GUTTER_ID, makeMarker(tipLabel, maxSeverity, anns.length > 1,
                    state.options.tooltips));
        }
        if (options.onUpdateLinting) options.onUpdateLinting(annotationsNotSorted, annotations, cm);
    }

    function onChange(cm) {
        var state = cm.state.lint;
        if (!state) return;
        clearTimeout(state.timeout);
        state.timeout = setTimeout(function(){startLinting(cm);}, state.options.delay || 500);
    }

    function popupTooltips(annotations, e) {
        var target = e.target || e.srcElement;
        var tooltip = document.createDocumentFragment();
        for (var i = 0; i < annotations.length; i++) {
            var ann = annotations[i];
            tooltip.appendChild(annotationTooltip(ann));
        }
        showTooltipFor(e, tooltip, target);
    }

    function onMouseOver(cm, e) {
        var target = e.target || e.srcElement;
        if (!/\bCodeMirror-lint-mark-/.test(target.className)) return;
        var box = target.getBoundingClientRect(), x = (box.left + box.right) / 2, y = (box.top + box.bottom) / 2;
        var spans = cm.findMarksAt(cm.coordsChar({left: x, top: y}, "client"));

        var annotations = [];
        for (var i = 0; i < spans.length; ++i) {
            var ann = spans[i].__annotation;
            if (ann) annotations.push(ann);
        }
        if (annotations.length) popupTooltips(annotations, e);
    }

    CodeMirror.defineOption("lint", false, function(cm, val, old) {
        if (old && old != CodeMirror.Init) {
            clearMarks(cm);
            if (cm.state.lint.options.lintOnChange !== false)
                cm.off("change", onChange);
            CodeMirror.off(cm.getWrapperElement(), "mouseover", cm.state.lint.onMouseOver);
            clearTimeout(cm.state.lint.timeout);
            delete cm.state.lint;
        }

        if (val) {
            var gutters = cm.getOption("gutters"), hasLintGutter = false;
            for (var i = 0; i < gutters.length; ++i) if (gutters[i] == GUTTER_ID) hasLintGutter = true;
            var state = cm.state.lint = new LintState(cm, parseOptions(cm, val), hasLintGutter);
            if (state.options.lintOnChange !== false)
                cm.on("change", onChange);
            if (state.options.tooltips != false && state.options.tooltips != "gutter")
                CodeMirror.on(cm.getWrapperElement(), "mouseover", state.onMouseOver);

            startLinting(cm);
        }
    });

    CodeMirror.defineExtension("performLint", function() {
        if (this.state.lint) startLinting(this);
    });
});

/* Jison generated parser */
var jsonlint = (function(){
    var parser = {trace: function trace() { },
        yy: {},
        symbols_: {"error":2,"JSONString":3,"STRING":4,"JSONNumber":5,"NUMBER":6,"JSONNullLiteral":7,"NULL":8,"JSONBooleanLiteral":9,"TRUE":10,"FALSE":11,"JSONText":12,"JSONValue":13,"EOF":14,"JSONObject":15,"JSONArray":16,"{":17,"}":18,"JSONMemberList":19,"JSONMember":20,":":21,",":22,"[":23,"]":24,"JSONElementList":25,"$accept":0,"$end":1},
        terminals_: {2:"error",4:"STRING",6:"NUMBER",8:"NULL",10:"TRUE",11:"FALSE",14:"EOF",17:"{",18:"}",21:":",22:",",23:"[",24:"]"},
        productions_: [0,[3,1],[5,1],[7,1],[9,1],[9,1],[12,2],[13,1],[13,1],[13,1],[13,1],[13,1],[13,1],[15,2],[15,3],[20,3],[19,1],[19,3],[16,2],[16,3],[25,1],[25,3]],
        performAction: function anonymous(yytext,yyleng,yylineno,yy,yystate,$$,_$) {

            var $0 = $$.length - 1;
            switch (yystate) {
                case 1: // replace escaped characters with actual character
                    this.$ = yytext.replace(/\\(\\|")/g, "$"+"1")
                        .replace(/\\n/g,'\n')
                        .replace(/\\r/g,'\r')
                        .replace(/\\t/g,'\t')
                        .replace(/\\v/g,'\v')
                        .replace(/\\f/g,'\f')
                        .replace(/\\b/g,'\b');

                    break;
                case 2:this.$ = Number(yytext);
                    break;
                case 3:this.$ = null;
                    break;
                case 4:this.$ = true;
                    break;
                case 5:this.$ = false;
                    break;
                case 6:return this.$ = $$[$0-1];
                    break;
                case 13:this.$ = {};
                    break;
                case 14:this.$ = $$[$0-1];
                    break;
                case 15:this.$ = [$$[$0-2], $$[$0]];
                    break;
                case 16:this.$ = {}; this.$[$$[$0][0]] = $$[$0][1];
                    break;
                case 17:this.$ = $$[$0-2]; $$[$0-2][$$[$0][0]] = $$[$0][1];
                    break;
                case 18:this.$ = [];
                    break;
                case 19:this.$ = $$[$0-1];
                    break;
                case 20:this.$ = [$$[$0]];
                    break;
                case 21:this.$ = $$[$0-2]; $$[$0-2].push($$[$0]);
                    break;
            }
        },
        table: [{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],12:1,13:2,15:7,16:8,17:[1,14],23:[1,15]},{1:[3]},{14:[1,16]},{14:[2,7],18:[2,7],22:[2,7],24:[2,7]},{14:[2,8],18:[2,8],22:[2,8],24:[2,8]},{14:[2,9],18:[2,9],22:[2,9],24:[2,9]},{14:[2,10],18:[2,10],22:[2,10],24:[2,10]},{14:[2,11],18:[2,11],22:[2,11],24:[2,11]},{14:[2,12],18:[2,12],22:[2,12],24:[2,12]},{14:[2,3],18:[2,3],22:[2,3],24:[2,3]},{14:[2,4],18:[2,4],22:[2,4],24:[2,4]},{14:[2,5],18:[2,5],22:[2,5],24:[2,5]},{14:[2,1],18:[2,1],21:[2,1],22:[2,1],24:[2,1]},{14:[2,2],18:[2,2],22:[2,2],24:[2,2]},{3:20,4:[1,12],18:[1,17],19:18,20:19},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:23,15:7,16:8,17:[1,14],23:[1,15],24:[1,21],25:22},{1:[2,6]},{14:[2,13],18:[2,13],22:[2,13],24:[2,13]},{18:[1,24],22:[1,25]},{18:[2,16],22:[2,16]},{21:[1,26]},{14:[2,18],18:[2,18],22:[2,18],24:[2,18]},{22:[1,28],24:[1,27]},{22:[2,20],24:[2,20]},{14:[2,14],18:[2,14],22:[2,14],24:[2,14]},{3:20,4:[1,12],20:29},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:30,15:7,16:8,17:[1,14],23:[1,15]},{14:[2,19],18:[2,19],22:[2,19],24:[2,19]},{3:5,4:[1,12],5:6,6:[1,13],7:3,8:[1,9],9:4,10:[1,10],11:[1,11],13:31,15:7,16:8,17:[1,14],23:[1,15]},{18:[2,17],22:[2,17]},{18:[2,15],22:[2,15]},{22:[2,21],24:[2,21]}],
        defaultActions: {16:[2,6]},
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this,
                stack = [0],
                vstack = [null], // semantic value stack
                lstack = [], // location stack
                table = this.table,
                yytext = '',
                yylineno = 0,
                yyleng = 0,
                recovering = 0,
                TERROR = 2,
                EOF = 1;

            //this.reductionCount = this.shiftCount = 0;

            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            if (typeof this.lexer.yylloc == 'undefined')
                this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);

            if (typeof this.yy.parseError === 'function')
                this.parseError = this.yy.parseError;

            function popStack (n) {
                stack.length = stack.length - 2*n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }

            function lex() {
                var token;
                token = self.lexer.lex() || 1; // $end = 1
                // if token isn't its numeric value, convert
                if (typeof token !== 'number') {
                    token = self.symbols_[token] || token;
                }
                return token;
            }

            var symbol, preErrorSymbol, state, action, a, r, yyval={},p,len,newState, expected;
            while (true) {
                // retreive state number from top of stack
                state = stack[stack.length-1];

                // use default actions if available
                if (this.defaultActions[state]) {
                    action = this.defaultActions[state];
                } else {
                    if (symbol == null)
                        symbol = lex();
                    // read action for current state and first input
                    action = table[state] && table[state][symbol];
                }

                // handle parse error
                _handle_error:
                    if (typeof action === 'undefined' || !action.length || !action[0]) {

                        if (!recovering) {
                            // Report error
                            expected = [];
                            for (p in table[state]) if (this.terminals_[p] && p > 2) {
                                expected.push("'"+this.terminals_[p]+"'");
                            }
                            var errStr = '';
                            if (this.lexer.showPosition) {
                                errStr = 'Parse error on line '+(yylineno+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+expected.join(', ') + ", got '" + this.terminals_[symbol]+ "'";
                            } else {
                                errStr = 'Parse error on line '+(yylineno+1)+": Unexpected " +
                                    (symbol == 1 /*EOF*/ ? "end of input" :
                                        ("'"+(this.terminals_[symbol] || symbol)+"'"));
                            }
                            this.parseError(errStr,
                                {text: this.lexer.match, token: this.terminals_[symbol] || symbol, line: this.lexer.yylineno, loc: yyloc, expected: expected});
                        }

                        // just recovered from another error
                        if (recovering == 3) {
                            if (symbol == EOF) {
                                throw new Error(errStr || 'Parsing halted.');
                            }

                            // discard current lookahead and grab another
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            symbol = lex();
                        }

                        // try to recover from error
                        while (1) {
                            // check for error recovery rule in this state
                            if ((TERROR.toString()) in table[state]) {
                                break;
                            }
                            if (state == 0) {
                                throw new Error(errStr || 'Parsing halted.');
                            }
                            popStack(1);
                            state = stack[stack.length-1];
                        }

                        preErrorSymbol = symbol; // save the lookahead token
                        symbol = TERROR;         // insert generic error symbol as new lookahead
                        state = stack[stack.length-1];
                        action = table[state] && table[state][TERROR];
                        recovering = 3; // allow 3 real symbols to be shifted before reporting a new error
                    }

                // this shouldn't happen, unless resolve defaults are off
                if (action[0] instanceof Array && action.length > 1) {
                    throw new Error('Parse Error: multiple actions possible at state: '+state+', token: '+symbol);
                }

                switch (action[0]) {

                    case 1: // shift
                        //this.shiftCount++;

                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]); // push state
                        symbol = null;
                        if (!preErrorSymbol) { // normal execution/no error
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0)
                                recovering--;
                        } else { // error just occurred, resume old lookahead f/ before error
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;

                    case 2: // reduce
                        //this.reductionCount++;

                        len = this.productions_[action[1]][1];

                        // perform semantic action
                        yyval.$ = vstack[vstack.length-len]; // default to $$ = $1
                        // default location, uses first token for firsts, last for lasts
                        yyval._$ = {
                            first_line: lstack[lstack.length-(len||1)].first_line,
                            last_line: lstack[lstack.length-1].last_line,
                            first_column: lstack[lstack.length-(len||1)].first_column,
                            last_column: lstack[lstack.length-1].last_column
                        };
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);

                        if (typeof r !== 'undefined') {
                            return r;
                        }

                        // pop off stack
                        if (len) {
                            stack = stack.slice(0,-1*len*2);
                            vstack = vstack.slice(0, -1*len);
                            lstack = lstack.slice(0, -1*len);
                        }

                        stack.push(this.productions_[action[1]][0]);    // push nonterminal (reduce)
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        // goto new state = table[STATE][NONTERMINAL]
                        newState = table[stack[stack.length-2]][stack[stack.length-1]];
                        stack.push(newState);
                        break;

                    case 3: // accept
                        return true;
                }

            }

            return true;
        }};
    /* Jison generated lexer */
    var lexer = (function(){
        var lexer = ({EOF:1,
            parseError:function parseError(str, hash) {
                if (this.yy.parseError) {
                    this.yy.parseError(str, hash);
                } else {
                    throw new Error(str);
                }
            },
            setInput:function (input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = ['INITIAL'];
                this.yylloc = {first_line:1,first_column:0,last_line:1,last_column:0};
                return this;
            },
            input:function () {
                var ch = this._input[0];
                this.yytext+=ch;
                this.yyleng++;
                this.match+=ch;
                this.matched+=ch;
                var lines = ch.match(/\n/);
                if (lines) this.yylineno++;
                this._input = this._input.slice(1);
                return ch;
            },
            unput:function (ch) {
                this._input = ch + this._input;
                return this;
            },
            more:function () {
                this._more = true;
                return this;
            },
            less:function (n) {
                this._input = this.match.slice(n) + this._input;
            },
            pastInput:function () {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput:function () {
                var next = this.match;
                if (next.length < 20) {
                    next += this._input.substr(0, 20-next.length);
                }
                return (next.substr(0,20)+(next.length > 20 ? '...':'')).replace(/\n/g, "");
            },
            showPosition:function () {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c+"^";
            },
            next:function () {
                if (this.done) {
                    return this.EOF;
                }
                if (!this._input) this.done = true;

                var token,
                    match,
                    tempMatch,
                    index,
                    col,
                    lines;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for (var i=0;i < rules.length; i++) {
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/\n.*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = {first_line: this.yylloc.last_line,
                        last_line: this.yylineno+1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length-1].length-1 : this.yylloc.last_column + match[0].length}
                    this.yytext += match[0];
                    this.match += match[0];
                    this.yyleng = this.yytext.length;
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index],this.conditionStack[this.conditionStack.length-1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;
                    else return;
                }
                if (this._input === "") {
                    return this.EOF;
                } else {
                    this.parseError('Lexical error on line '+(this.yylineno+1)+'. Unrecognized text.\n'+this.showPosition(),
                        {text: "", token: null, line: this.yylineno});
                }
            },
            lex:function lex() {
                var r = this.next();
                if (typeof r !== 'undefined') {
                    return r;
                } else {
                    return this.lex();
                }
            },
            begin:function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState:function popState() {
                return this.conditionStack.pop();
            },
            _currentRules:function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules;
            },
            topState:function () {
                return this.conditionStack[this.conditionStack.length-2];
            },
            pushState:function begin(condition) {
                this.begin(condition);
            }});
        lexer.options = {};
        lexer.performAction = function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {

            var YYSTATE=YY_START
            switch($avoiding_name_collisions) {
                case 0:/* skip whitespace */
                    break;
                case 1:return 6
                    break;
                case 2:yy_.yytext = yy_.yytext.substr(1,yy_.yyleng-2); return 4
                    break;
                case 3:return 17
                    break;
                case 4:return 18
                    break;
                case 5:return 23
                    break;
                case 6:return 24
                    break;
                case 7:return 22
                    break;
                case 8:return 21
                    break;
                case 9:return 10
                    break;
                case 10:return 11
                    break;
                case 11:return 8
                    break;
                case 12:return 14
                    break;
                case 13:return 'INVALID'
                    break;
            }
        };
        lexer.rules = [/^(?:\s+)/,/^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,/^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,/^(?:\{)/,/^(?:\})/,/^(?:\[)/,/^(?:\])/,/^(?:,)/,/^(?::)/,/^(?:true\b)/,/^(?:false\b)/,/^(?:null\b)/,/^(?:$)/,/^(?:.)/];
        lexer.conditions = {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13],"inclusive":true}};


        ;
        return lexer;})()
    parser.lexer = lexer;
    return parser;
})();
if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
    exports.parser = jsonlint;
    exports.parse = function () { return jsonlint.parse.apply(jsonlint, arguments); }
    exports.main = function commonjsMain(args) {
        if (!args[1])
            throw new Error('Usage: '+args[0]+' FILE');
        if (typeof process !== 'undefined') {
            var source = require('fs').readFileSync(require('path').join(process.cwd(), args[1]), "utf8");
        } else {
            var cwd = require("file").path(require("file").cwd());
            var source = cwd.join(args[1]).read({charset: "utf-8"});
        }
        return exports.parser.parse(source);
    }
    if (typeof module !== 'undefined' && require.main === module) {
        exports.main(typeof process !== 'undefined' ? process.argv.slice(1) : require("system").args);
    }
}

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

// Depends on jsonlint.js from https://github.com/zaach/jsonlint

// declare global: jsonlint

(function(mod) {
    if (typeof exports == "object" && typeof module == "object") // CommonJS
        mod(require("../../lib/codemirror"));
    else if (typeof define == "function" && define.amd) // AMD
        define(["../../lib/codemirror"], mod);
    else // Plain browser env
        mod(CodeMirror);
})(function(CodeMirror) {
    "use strict";

    CodeMirror.registerHelper("lint", "json", function(text) {
        var found = [];
        if (!window.jsonlint) {
            if (window.console) {
                window.console.error("Error: window.jsonlint not defined, CodeMirror JSON linting cannot run.");
            }
            return found;
        }
        jsonlint.parseError = function(str, hash) {
            var loc = hash.loc;
            found.push({from: CodeMirror.Pos(loc.first_line - 1, loc.first_column),
                to: CodeMirror.Pos(loc.last_line - 1, loc.last_column),
                message: str});
        };
        try { jsonlint.parse(text); }
        catch(e) {}
        return found;
    });

});

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: http://codemirror.net/LICENSE

(function(mod) {
    if (typeof exports == "object" && typeof module == "object") // CommonJS
        mod(require("../../lib/codemirror"));
    else if (typeof define == "function" && define.amd) // AMD
        define(["../../lib/codemirror"], mod);
    else // Plain browser env
        mod(CodeMirror);
})(function(CodeMirror) {
    "use strict";

    CodeMirror.defineMode("javascript", function(config, parserConfig) {
        var indentUnit = config.indentUnit;
        var statementIndent = parserConfig.statementIndent;
        var jsonldMode = parserConfig.jsonld;
        var jsonMode = parserConfig.json || jsonldMode;
        var isTS = parserConfig.typescript;
        var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;

        // Tokenizer

        var keywords = function(){
            function kw(type) {return {type: type, style: "keyword"};}
            var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
            var operator = kw("operator"), atom = {type: "atom", style: "atom"};

            return {
                "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
                "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
                "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
                "function": kw("function"), "catch": kw("catch"),
                "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
                "in": operator, "typeof": operator, "instanceof": operator,
                "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
                "this": kw("this"), "class": kw("class"), "super": kw("atom"),
                "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
                "await": C
            };
        }();

        var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
        var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;

        function readRegexp(stream) {
            var escaped = false, next, inSet = false;
            while ((next = stream.next()) != null) {
                if (!escaped) {
                    if (next == "/" && !inSet) return;
                    if (next == "[") inSet = true;
                    else if (inSet && next == "]") inSet = false;
                }
                escaped = !escaped && next == "\\";
            }
        }

        // Used as scratch variables to communicate multiple values without
        // consing up tons of objects.
        var type, content;
        function ret(tp, style, cont) {
            type = tp; content = cont;
            return style;
        }
        function tokenBase(stream, state) {
            var ch = stream.next();
            if (ch == '"' || ch == "'") {
                state.tokenize = tokenString(ch);
                return state.tokenize(stream, state);
            } else if (ch == "." && stream.match(/^\d+(?:[eE][+\-]?\d+)?/)) {
                return ret("number", "number");
            } else if (ch == "." && stream.match("..")) {
                return ret("spread", "meta");
            } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
                return ret(ch);
            } else if (ch == "=" && stream.eat(">")) {
                return ret("=>", "operator");
            } else if (ch == "0" && stream.eat(/x/i)) {
                stream.eatWhile(/[\da-f]/i);
                return ret("number", "number");
            } else if (ch == "0" && stream.eat(/o/i)) {
                stream.eatWhile(/[0-7]/i);
                return ret("number", "number");
            } else if (ch == "0" && stream.eat(/b/i)) {
                stream.eatWhile(/[01]/i);
                return ret("number", "number");
            } else if (/\d/.test(ch)) {
                stream.match(/^\d*(?:\.\d*)?(?:[eE][+\-]?\d+)?/);
                return ret("number", "number");
            } else if (ch == "/") {
                if (stream.eat("*")) {
                    state.tokenize = tokenComment;
                    return tokenComment(stream, state);
                } else if (stream.eat("/")) {
                    stream.skipToEnd();
                    return ret("comment", "comment");
                } else if (expressionAllowed(stream, state, 1)) {
                    readRegexp(stream);
                    stream.match(/^\b(([gimyu])(?![gimyu]*\2))+\b/);
                    return ret("regexp", "string-2");
                } else {
                    stream.eat("=");
                    return ret("operator", "operator", stream.current());
                }
            } else if (ch == "`") {
                state.tokenize = tokenQuasi;
                return tokenQuasi(stream, state);
            } else if (ch == "#") {
                stream.skipToEnd();
                return ret("error", "error");
            } else if (isOperatorChar.test(ch)) {
                if (ch != ">" || !state.lexical || state.lexical.type != ">") {
                    if (stream.eat("=")) {
                        if (ch == "!" || ch == "=") stream.eat("=")
                    } else if (/[<>*+\-]/.test(ch)) {
                        stream.eat(ch)
                        if (ch == ">") stream.eat(ch)
                    }
                }
                return ret("operator", "operator", stream.current());
            } else if (wordRE.test(ch)) {
                stream.eatWhile(wordRE);
                var word = stream.current()
                if (state.lastType != ".") {
                    if (keywords.propertyIsEnumerable(word)) {
                        var kw = keywords[word]
                        return ret(kw.type, kw.style, word)
                    }
                    if (word == "async" && stream.match(/^(\s|\/\*.*?\*\/)*[\(\w]/, false))
                        return ret("async", "keyword", word)
                }
                return ret("variable", "variable", word)
            }
        }

        function tokenString(quote) {
            return function(stream, state) {
                var escaped = false, next;
                if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
                    state.tokenize = tokenBase;
                    return ret("jsonld-keyword", "meta");
                }
                while ((next = stream.next()) != null) {
                    if (next == quote && !escaped) break;
                    escaped = !escaped && next == "\\";
                }
                if (!escaped) state.tokenize = tokenBase;
                return ret("string", "string");
            };
        }

        function tokenComment(stream, state) {
            var maybeEnd = false, ch;
            while (ch = stream.next()) {
                if (ch == "/" && maybeEnd) {
                    state.tokenize = tokenBase;
                    break;
                }
                maybeEnd = (ch == "*");
            }
            return ret("comment", "comment");
        }

        function tokenQuasi(stream, state) {
            var escaped = false, next;
            while ((next = stream.next()) != null) {
                if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
                    state.tokenize = tokenBase;
                    break;
                }
                escaped = !escaped && next == "\\";
            }
            return ret("quasi", "string-2", stream.current());
        }

        var brackets = "([{}])";
        // This is a crude lookahead trick to try and notice that we're
        // parsing the argument patterns for a fat-arrow function before we
        // actually hit the arrow token. It only works if the arrow is on
        // the same line as the arguments and there's no strange noise
        // (comments) in between. Fallback is to only notice when we hit the
        // arrow, and not declare the arguments as locals for the arrow
        // body.
        function findFatArrow(stream, state) {
            if (state.fatArrowAt) state.fatArrowAt = null;
            var arrow = stream.string.indexOf("=>", stream.start);
            if (arrow < 0) return;

            if (isTS) { // Try to skip TypeScript return type declarations after the arguments
                var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
                if (m) arrow = m.index
            }

            var depth = 0, sawSomething = false;
            for (var pos = arrow - 1; pos >= 0; --pos) {
                var ch = stream.string.charAt(pos);
                var bracket = brackets.indexOf(ch);
                if (bracket >= 0 && bracket < 3) {
                    if (!depth) { ++pos; break; }
                    if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
                } else if (bracket >= 3 && bracket < 6) {
                    ++depth;
                } else if (wordRE.test(ch)) {
                    sawSomething = true;
                } else if (/["'\/]/.test(ch)) {
                    return;
                } else if (sawSomething && !depth) {
                    ++pos;
                    break;
                }
            }
            if (sawSomething && !depth) state.fatArrowAt = pos;
        }

        // Parser

        var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};

        function JSLexical(indented, column, type, align, prev, info) {
            this.indented = indented;
            this.column = column;
            this.type = type;
            this.prev = prev;
            this.info = info;
            if (align != null) this.align = align;
        }

        function inScope(state, varname) {
            for (var v = state.localVars; v; v = v.next)
                if (v.name == varname) return true;
            for (var cx = state.context; cx; cx = cx.prev) {
                for (var v = cx.vars; v; v = v.next)
                    if (v.name == varname) return true;
            }
        }

        function parseJS(state, style, type, content, stream) {
            var cc = state.cc;
            // Communicate our context to the combinators.
            // (Less wasteful than consing up a hundred closures on every call.)
            cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;

            if (!state.lexical.hasOwnProperty("align"))
                state.lexical.align = true;

            while(true) {
                var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
                if (combinator(type, content)) {
                    while(cc.length && cc[cc.length - 1].lex)
                        cc.pop()();
                    if (cx.marked) return cx.marked;
                    if (type == "variable" && inScope(state, content)) return "variable-2";
                    return style;
                }
            }
        }

        // Combinator utils

        var cx = {state: null, column: null, marked: null, cc: null};
        function pass() {
            for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
        }
        function cont() {
            pass.apply(null, arguments);
            return true;
        }
        function register(varname) {
            function inList(list) {
                for (var v = list; v; v = v.next)
                    if (v.name == varname) return true;
                return false;
            }
            var state = cx.state;
            cx.marked = "def";
            if (state.context) {
                if (inList(state.localVars)) return;
                state.localVars = {name: varname, next: state.localVars};
            } else {
                if (inList(state.globalVars)) return;
                if (parserConfig.globalVars)
                    state.globalVars = {name: varname, next: state.globalVars};
            }
        }

        function isModifier(name) {
            return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
        }

        // Combinators

        var defaultVars = {name: "this", next: {name: "arguments"}};
        function pushcontext() {
            cx.state.context = {prev: cx.state.context, vars: cx.state.localVars};
            cx.state.localVars = defaultVars;
        }
        function popcontext() {
            cx.state.localVars = cx.state.context.vars;
            cx.state.context = cx.state.context.prev;
        }
        function pushlex(type, info) {
            var result = function() {
                var state = cx.state, indent = state.indented;
                if (state.lexical.type == "stat") indent = state.lexical.indented;
                else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
                    indent = outer.indented;
                state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
            };
            result.lex = true;
            return result;
        }
        function poplex() {
            var state = cx.state;
            if (state.lexical.prev) {
                if (state.lexical.type == ")")
                    state.indented = state.lexical.indented;
                state.lexical = state.lexical.prev;
            }
        }
        poplex.lex = true;

        function expect(wanted) {
            function exp(type) {
                if (type == wanted) return cont();
                else if (wanted == ";") return pass();
                else return cont(exp);
            };
            return exp;
        }

        function statement(type, value) {
            if (type == "var") return cont(pushlex("vardef", value.length), vardef, expect(";"), poplex);
            if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
            if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
            if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
            if (type == "debugger") return cont(expect(";"));
            if (type == "{") return cont(pushlex("}"), block, poplex);
            if (type == ";") return cont();
            if (type == "if") {
                if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
                    cx.state.cc.pop()();
                return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
            }
            if (type == "function") return cont(functiondef);
            if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
            if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), className, poplex); }
            if (type == "variable") {
                if (isTS && value == "type") {
                    cx.marked = "keyword"
                    return cont(typeexpr, expect("operator"), typeexpr, expect(";"));
                } else if (isTS && value == "declare") {
                    cx.marked = "keyword"
                    return cont(statement)
                } else if (isTS && (value == "module" || value == "enum") && cx.stream.match(/^\s*\w/, false)) {
                    cx.marked = "keyword"
                    return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
                } else if (isTS && value == "namespace") {
                    cx.marked = "keyword"
                    return cont(pushlex("form"), expression, block, poplex)
                } else {
                    return cont(pushlex("stat"), maybelabel);
                }
            }
            if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"),
                block, poplex, poplex);
            if (type == "case") return cont(expression, expect(":"));
            if (type == "default") return cont(expect(":"));
            if (type == "catch") return cont(pushlex("form"), pushcontext, expect("("), funarg, expect(")"),
                statement, poplex, popcontext);
            if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
            if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
            if (type == "async") return cont(statement)
            if (value == "@") return cont(expression, statement)
            return pass(pushlex("stat"), expression, expect(";"), poplex);
        }
        function expression(type, value) {
            return expressionInner(type, value, false);
        }
        function expressionNoComma(type, value) {
            return expressionInner(type, value, true);
        }
        function parenExpr(type) {
            if (type != "(") return pass()
            return cont(pushlex(")"), expression, expect(")"), poplex)
        }
        function expressionInner(type, value, noComma) {
            if (cx.state.fatArrowAt == cx.stream.start) {
                var body = noComma ? arrowBodyNoComma : arrowBody;
                if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
                else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
            }

            var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
            if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
            if (type == "function") return cont(functiondef, maybeop);
            if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
            if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
            if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
            if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
            if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
            if (type == "{") return contCommasep(objprop, "}", null, maybeop);
            if (type == "quasi") return pass(quasi, maybeop);
            if (type == "new") return cont(maybeTarget(noComma));
            return cont();
        }
        function maybeexpression(type) {
            if (type.match(/[;\}\)\],]/)) return pass();
            return pass(expression);
        }

        function maybeoperatorComma(type, value) {
            if (type == ",") return cont(expression);
            return maybeoperatorNoComma(type, value, false);
        }
        function maybeoperatorNoComma(type, value, noComma) {
            var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
            var expr = noComma == false ? expression : expressionNoComma;
            if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
            if (type == "operator") {
                if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
                if (isTS && value == "<" && cx.stream.match(/^([^>]|<.*?>)*>\s*\(/, false))
                    return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
                if (value == "?") return cont(expression, expect(":"), expr);
                return cont(expr);
            }
            if (type == "quasi") { return pass(quasi, me); }
            if (type == ";") return;
            if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
            if (type == ".") return cont(property, me);
            if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
            if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
            if (type == "regexp") {
                cx.state.lastType = cx.marked = "operator"
                cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
                return cont(expr)
            }
        }
        function quasi(type, value) {
            if (type != "quasi") return pass();
            if (value.slice(value.length - 2) != "${") return cont(quasi);
            return cont(expression, continueQuasi);
        }
        function continueQuasi(type) {
            if (type == "}") {
                cx.marked = "string-2";
                cx.state.tokenize = tokenQuasi;
                return cont(quasi);
            }
        }
        function arrowBody(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expression);
        }
        function arrowBodyNoComma(type) {
            findFatArrow(cx.stream, cx.state);
            return pass(type == "{" ? statement : expressionNoComma);
        }
        function maybeTarget(noComma) {
            return function(type) {
                if (type == ".") return cont(noComma ? targetNoComma : target);
                else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
                else return pass(noComma ? expressionNoComma : expression);
            };
        }
        function target(_, value) {
            if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
        }
        function targetNoComma(_, value) {
            if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
        }
        function maybelabel(type) {
            if (type == ":") return cont(poplex, statement);
            return pass(maybeoperatorComma, expect(";"), poplex);
        }
        function property(type) {
            if (type == "variable") {cx.marked = "property"; return cont();}
        }
        function objprop(type, value) {
            if (type == "async") {
                cx.marked = "property";
                return cont(objprop);
            } else if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                if (value == "get" || value == "set") return cont(getterSetter);
                var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
                if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
                    cx.state.fatArrowAt = cx.stream.pos + m[0].length
                return cont(afterprop);
            } else if (type == "number" || type == "string") {
                cx.marked = jsonldMode ? "property" : (cx.style + " property");
                return cont(afterprop);
            } else if (type == "jsonld-keyword") {
                return cont(afterprop);
            } else if (isTS && isModifier(value)) {
                cx.marked = "keyword"
                return cont(objprop)
            } else if (type == "[") {
                return cont(expression, maybetype, expect("]"), afterprop);
            } else if (type == "spread") {
                return cont(expressionNoComma, afterprop);
            } else if (value == "*") {
                cx.marked = "keyword";
                return cont(objprop);
            } else if (type == ":") {
                return pass(afterprop)
            }
        }
        function getterSetter(type) {
            if (type != "variable") return pass(afterprop);
            cx.marked = "property";
            return cont(functiondef);
        }
        function afterprop(type) {
            if (type == ":") return cont(expressionNoComma);
            if (type == "(") return pass(functiondef);
        }
        function commasep(what, end, sep) {
            function proceed(type, value) {
                if (sep ? sep.indexOf(type) > -1 : type == ",") {
                    var lex = cx.state.lexical;
                    if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
                    return cont(function(type, value) {
                        if (type == end || value == end) return pass()
                        return pass(what)
                    }, proceed);
                }
                if (type == end || value == end) return cont();
                return cont(expect(end));
            }
            return function(type, value) {
                if (type == end || value == end) return cont();
                return pass(what, proceed);
            };
        }
        function contCommasep(what, end, info) {
            for (var i = 3; i < arguments.length; i++)
                cx.cc.push(arguments[i]);
            return cont(pushlex(end, info), commasep(what, end), poplex);
        }
        function block(type) {
            if (type == "}") return cont();
            return pass(statement, block);
        }
        function maybetype(type, value) {
            if (isTS) {
                if (type == ":") return cont(typeexpr);
                if (value == "?") return cont(maybetype);
            }
        }
        function mayberettype(type) {
            if (isTS && type == ":") {
                if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
                else return cont(typeexpr)
            }
        }
        function isKW(_, value) {
            if (value == "is") {
                cx.marked = "keyword"
                return cont()
            }
        }
        function typeexpr(type, value) {
            if (type == "variable" || value == "void") {
                if (value == "keyof") {
                    cx.marked = "keyword"
                    return cont(typeexpr)
                } else {
                    cx.marked = "type"
                    return cont(afterType)
                }
            }
            if (type == "string" || type == "number" || type == "atom") return cont(afterType);
            if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
            if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType)
            if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType)
        }
        function maybeReturnType(type) {
            if (type == "=>") return cont(typeexpr)
        }
        function typeprop(type, value) {
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property"
                return cont(typeprop)
            } else if (value == "?") {
                return cont(typeprop)
            } else if (type == ":") {
                return cont(typeexpr)
            } else if (type == "[") {
                return cont(expression, maybetype, expect("]"), typeprop)
            }
        }
        function typearg(type) {
            if (type == "variable") return cont(typearg)
            else if (type == ":") return cont(typeexpr)
        }
        function afterType(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
            if (value == "|" || type == ".") return cont(typeexpr)
            if (type == "[") return cont(expect("]"), afterType)
            if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
        }
        function maybeTypeArgs(_, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
        }
        function typeparam() {
            return pass(typeexpr, maybeTypeDefault)
        }
        function maybeTypeDefault(_, value) {
            if (value == "=") return cont(typeexpr)
        }
        function vardef() {
            return pass(pattern, maybetype, maybeAssign, vardefCont);
        }
        function pattern(type, value) {
            if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
            if (type == "variable") { register(value); return cont(); }
            if (type == "spread") return cont(pattern);
            if (type == "[") return contCommasep(pattern, "]");
            if (type == "{") return contCommasep(proppattern, "}");
        }
        function proppattern(type, value) {
            if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
                register(value);
                return cont(maybeAssign);
            }
            if (type == "variable") cx.marked = "property";
            if (type == "spread") return cont(pattern);
            if (type == "}") return pass();
            return cont(expect(":"), pattern, maybeAssign);
        }
        function maybeAssign(_type, value) {
            if (value == "=") return cont(expressionNoComma);
        }
        function vardefCont(type) {
            if (type == ",") return cont(vardef);
        }
        function maybeelse(type, value) {
            if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
        }
        function forspec(type) {
            if (type == "(") return cont(pushlex(")"), forspec1, expect(")"), poplex);
        }
        function forspec1(type) {
            if (type == "var") return cont(vardef, expect(";"), forspec2);
            if (type == ";") return cont(forspec2);
            if (type == "variable") return cont(formaybeinof);
            return pass(expression, expect(";"), forspec2);
        }
        function formaybeinof(_type, value) {
            if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
            return cont(maybeoperatorComma, forspec2);
        }
        function forspec2(type, value) {
            if (type == ";") return cont(forspec3);
            if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression); }
            return pass(expression, expect(";"), forspec3);
        }
        function forspec3(type) {
            if (type != ")") cont(expression);
        }
        function functiondef(type, value) {
            if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
            if (type == "variable") {register(value); return cont(functiondef);}
            if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
            if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
        }
        function funarg(type, value) {
            if (value == "@") cont(expression, funarg)
            if (type == "spread") return cont(funarg);
            if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
            return pass(pattern, maybetype, maybeAssign);
        }
        function classExpression(type, value) {
            // Class expressions may have an optional name.
            if (type == "variable") return className(type, value);
            return classNameAfter(type, value);
        }
        function className(type, value) {
            if (type == "variable") {register(value); return cont(classNameAfter);}
        }
        function classNameAfter(type, value) {
            if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
            if (value == "extends" || value == "implements" || (isTS && type == ","))
                return cont(isTS ? typeexpr : expression, classNameAfter);
            if (type == "{") return cont(pushlex("}"), classBody, poplex);
        }
        function classBody(type, value) {
            if (type == "async" ||
                (type == "variable" &&
                    (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
                    cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (type == "variable" || cx.style == "keyword") {
                cx.marked = "property";
                return cont(isTS ? classfield : functiondef, classBody);
            }
            if (type == "[")
                return cont(expression, maybetype, expect("]"), isTS ? classfield : functiondef, classBody)
            if (value == "*") {
                cx.marked = "keyword";
                return cont(classBody);
            }
            if (type == ";") return cont(classBody);
            if (type == "}") return cont();
            if (value == "@") return cont(expression, classBody)
        }
        function classfield(type, value) {
            if (value == "?") return cont(classfield)
            if (type == ":") return cont(typeexpr, maybeAssign)
            if (value == "=") return cont(expressionNoComma)
            return pass(functiondef)
        }
        function afterExport(type, value) {
            if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
            if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
            if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
            return pass(statement);
        }
        function exportField(type, value) {
            if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
            if (type == "variable") return pass(expressionNoComma, exportField);
        }
        function afterImport(type) {
            if (type == "string") return cont();
            return pass(importSpec, maybeMoreImports, maybeFrom);
        }
        function importSpec(type, value) {
            if (type == "{") return contCommasep(importSpec, "}");
            if (type == "variable") register(value);
            if (value == "*") cx.marked = "keyword";
            return cont(maybeAs);
        }
        function maybeMoreImports(type) {
            if (type == ",") return cont(importSpec, maybeMoreImports)
        }
        function maybeAs(_type, value) {
            if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
        }
        function maybeFrom(_type, value) {
            if (value == "from") { cx.marked = "keyword"; return cont(expression); }
        }
        function arrayLiteral(type) {
            if (type == "]") return cont();
            return pass(commasep(expressionNoComma, "]"));
        }

        function isContinuedStatement(state, textAfter) {
            return state.lastType == "operator" || state.lastType == "," ||
                isOperatorChar.test(textAfter.charAt(0)) ||
                /[,.]/.test(textAfter.charAt(0));
        }

        function expressionAllowed(stream, state, backUp) {
            return state.tokenize == tokenBase &&
                /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
                (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
        }

        // Interface

        return {
            startState: function(basecolumn) {
                var state = {
                    tokenize: tokenBase,
                    lastType: "sof",
                    cc: [],
                    lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
                    localVars: parserConfig.localVars,
                    context: parserConfig.localVars && {vars: parserConfig.localVars},
                    indented: basecolumn || 0
                };
                if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
                    state.globalVars = parserConfig.globalVars;
                return state;
            },

            token: function(stream, state) {
                if (stream.sol()) {
                    if (!state.lexical.hasOwnProperty("align"))
                        state.lexical.align = false;
                    state.indented = stream.indentation();
                    findFatArrow(stream, state);
                }
                if (state.tokenize != tokenComment && stream.eatSpace()) return null;
                var style = state.tokenize(stream, state);
                if (type == "comment") return style;
                state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
                return parseJS(state, style, type, content, stream);
            },

            indent: function(state, textAfter) {
                if (state.tokenize == tokenComment) return CodeMirror.Pass;
                if (state.tokenize != tokenBase) return 0;
                var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
                // Kludge to prevent 'maybelse' from blocking lexical scope pops
                if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
                    var c = state.cc[i];
                    if (c == poplex) lexical = lexical.prev;
                    else if (c != maybeelse) break;
                }
                while ((lexical.type == "stat" || lexical.type == "form") &&
                (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
                    (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
                    !/^[,\.=+\-*:?[\(]/.test(textAfter))))
                    lexical = lexical.prev;
                if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
                    lexical = lexical.prev;
                var type = lexical.type, closing = firstChar == type;

                if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info + 1 : 0);
                else if (type == "form" && firstChar == "{") return lexical.indented;
                else if (type == "form") return lexical.indented + indentUnit;
                else if (type == "stat")
                    return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
                else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
                    return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
                else if (lexical.align) return lexical.column + (closing ? 0 : 1);
                else return lexical.indented + (closing ? 0 : indentUnit);
            },

            electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
            blockCommentStart: jsonMode ? null : "/*",
            blockCommentEnd: jsonMode ? null : "*/",
            blockCommentContinue: jsonMode ? null : " * ",
            lineComment: jsonMode ? null : "//",
            fold: "brace",
            closeBrackets: "()[]{}''\"\"``",

            helperType: jsonMode ? "json" : "javascript",
            jsonldMode: jsonldMode,
            jsonMode: jsonMode,

            expressionAllowed: expressionAllowed,

            skipExpression: function(state) {
                var top = state.cc[state.cc.length - 1]
                if (top == expression || top == expressionNoComma) state.cc.pop()
            }
        };
    });

    CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);

    CodeMirror.defineMIME("text/javascript", "javascript");
    CodeMirror.defineMIME("text/ecmascript", "javascript");
    CodeMirror.defineMIME("application/javascript", "javascript");
    CodeMirror.defineMIME("application/x-javascript", "javascript");
    CodeMirror.defineMIME("application/ecmascript", "javascript");
    CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
    CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
    CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
    CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
    CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });

});

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('TreeFactory', function ($q, APIFactory) {
        var appName = "phoenix2";
        return {
            /**
             * Create a Tree.  See the Tree model for more information.
             * @param {TreeModel} tree    Required parameter: The tree model specifying the values of the object to create. It is not a requirement to construct a complete model object.
             *
             * @return {promise<TreeModel>}
             */
            addTree: function (tree) {

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (tree === null || angular.isUndefined(tree)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'tree' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                APIFactory.API(appName, 'tree', 'createTree', {body: tree})
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Delete a tree. Only owned or authorized trees can be deleted. See the Tree model for more information.
             * @param {string} treeId    Required parameter: The URI path must specify the tree ID.
             *
             * @return {promise<void>}
             */
            removeTree: function (treeId) {

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (treeId === null || angular.isUndefined(treeId)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'treeId' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }


                //Process template parameters
                var queryBuilder = {
                    "tree_id": treeId
                };

                APIFactory.API(appName, 'tree', 'removeTree', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Add a tree to a project. Only owned trees can be added to owned projects. See the Project and Tree models for more information.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {string} projectId    Required parameter: The URI path must specify the project ID.
             *     {string} treeId    Required parameter: The URI path must specify the tree ID.
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<string>}
             */
            addTreeToProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "project_id": input.projectId,
                    "tree_id": input.treeId
                };

                APIFactory.API(appName, 'tree', 'Add_Tree_to_Project', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Get a collection of trees associated with a project. See the Tree model for more information.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {string} projectId    Required parameter: The URI path must specify the project ID.
             *     {array|null} addresses    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} created    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} description    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} engineId    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} fields    Optional parameter: It is possible to restrict data models response fields in order to reduce response size. It is possible to specify the fields of the returning model that should be populated with data using a comma separated list of field name. e.g. fields=name,created,updated
             *     {array|null} id    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} manufacturer    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} model    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} name    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {int|null} page    Optional parameter: Endpoints that return collections are automatically paginated and the first page of results is returned. The desired page number can be targeted using this parameter. e.g. page=2 would return the second page of results.
             *     {int|null} perPage    Optional parameter: Endpoints that return collections are automatically paginated with 10 results per page . The desired number of results per page can be set using this parameter. e.g. perPage=20 would return the 20 results on each page.
             *     {array|null} silent    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {string|null} sort    Optional parameter: The response collection can be sorted into an order based on a specific field value.  The parameter expects a field name from the response model. It is possible to prefix the field name with a minus sign (-) to invert the sort order. e.g. sort=created or sort=-created
             *     {array|null} status    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {array|null} updated    Optional parameter: Apply a search filter specifically for this model field. The parameter takes a collection of comma separated values that are interpreted  as 'OR' statements. e.g. 'name=foo,baa,lee' will filter the search so that field name must be equal to 'foo' or 'baa' or 'lee'. The query comparator that prefixes the first value can be extended to customise the meaning of the filter condition. Adding an additional '=' creates a 'LIKE' filter instead of 'EQUALS'. e.g. 'name==am' would return all results that  where the model field 'name' is 'LIKE' 'am'. So 'Sam', 'Pam', 'Amber' etc. are valid results. Numerical based fields can use the '>' and '<' to respectively query values that are greater than and smaller than. e.g. 'value=>10' will return only models where the field value is greater than 10. Simple collection fields can use the '^' prefix to indicate a 'CONTAINS' filter. e.g. 'values=^foo' will only return models whether the values field collection contains the value 'foo'.
             *     {Dictionary} queryParameters    Optional parameter: Additional optional query parameters are supported by this endpoint
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<array>}
             */
            getProjectTrees: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }


                //Process template parameters
                var queryBuilder = {
                    "project_id": input.projectId,
                    "addresses": input.addresses,
                    "created": input.created,
                    "description": input.description,
                    "engineId": input.engineId,
                    "fields": input.fields,
                    "id": input.id,
                    "manufacturer": input.manufacturer,
                    "model": input.model,
                    "name": input.name,
                    "page": input.page,
                    "perPage": input.perPage,
                    "silent": input.silent,
                    "sort": input.sort,
                    "status": input.status,
                    "updated": input.updated
                };
                APIFactory.API(appName, 'tree', 'Get_Project_Trees', APIFactory.APIQueryBuilder(queryBuilder, queryParameters))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Get a collection of trees. See the Tree model for more information.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {array|null} addresses    Optional parameter: Example:
             *     {array|null} created    Optional parameter: Example:
             *     {array|null} description    Optional parameter: Example:
             *     {array|null} engineId    Optional parameter: Example:
             *     {array|null} fields    Optional parameter: It is possible to restrict data models response fields in order to reduce response size. It is possible to specify the fields of the returning model that should be populated with data using a comma separated list of field name. e.g. fields=name,created,updated
             *     {array|null} id    Optional parameter: Example:
             *     {array|null} manufacturer    Optional parameter: Example:
             *     {array|null} model    Optional parameter: Example:
             *     {array|null} name    Optional parameter: Example:
             *     {int|null} page    Optional parameter: Endpoints that return collections are automatically paginated and the first page of results is returned. The desired page number can be targeted using this parameter. e.g. page=2 would return the second page of results.
             *     {int|null} perPage    Optional parameter: Endpoints that return collections are automatically paginated with 10 results per page . The desired number of results per page can be set using this parameter. e.g. perPage=20 would return the 20 results on each page.
             *     {array|null} silent    Optional parameter: Example:
             *     {string|null} sort    Optional parameter: The response collection can be sorted into an order based on a specific field value.  The parameter expects a field name from the response model. It is possible to prefix the field name with a minus sign (-) to invert the sort order. e.g. sort=created or sort=-created
             *     {array|null} status    Optional parameter: Example:
             *     {array|null} updated    Optional parameter: Example:
             *     {Dictionary} queryParameters    Optional parameter: Additional optional query parameters are supported by this endpoint
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<array>}
             */
            getTrees: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();


                //Process query parameters
                var queryBuilder = {
                    "created": input.created,
                    "description": input.description,
                    "fields": input.fields,
                    "id": input.id,
                    "health": input.health,
                    "name": input.name,
                    "limit": input.limit,
                    "before": input.before,
                    "after": input.after,
                    "sort": input.sort,
                    "updated": input.updated
                };

                APIFactory.API(appName, 'tree', 'getTrees', APIFactory.APIQueryBuilder(queryBuilder, queryParameters))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Remove a tree from a project. Only owned trees can be removed from owned projects.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {string} projectId    Required parameter: The URI path must specify the project ID.
             *     {string} treeId    Required parameter: The URI path must specify the tree ID.
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<string>}
             */
            removeTreeFromProject: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.projectId === null || angular.isUndefined(input.projectId)) {
                    _deffered.reject({
                        errorMessage: "The property 'projectId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "project_id": input.projectId,
                    "tree_id": input.treeId
                };

                APIFactory.API(appName, 'tree', 'Remove_Tree_from_Project', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Update a tree.  See the Tree model for more information.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {TreeModel} tree    Required parameter: The tree model specifying the values to be updated. It is not a requirement to construct a complete model object. Fields not set will be ignored and existing values will persist.
             *     {string} treeId    Required parameter: The URI path must specify the tree ID.
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<TreeModel>}
             */
            updateTree: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.tree === null || angular.isUndefined(input.tree)) {
                    _deffered.reject({
                        errorMessage: "The property 'tree' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": input.treeId,
                    "body": input.tree
                };

                APIFactory.API(appName, 'tree', 'updateTree', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Get a Tree. See the Tree model for more information.
             * All parameters to the endpoint are supplied through the object with their names
             * being the key and their desired values being the value. A list of parameters that can be used are:
             *
             *     {string} treeId    Required parameter: The URI path must specify the tree ID.
             *     {array|null} fields    Optional parameter: It is possible to restrict data models response fields in order to reduce response size. It is possible to specify the fields of the returning model that should be populated with data using a comma separated list of field name. e.g. fields=name,created,updated
             *
             * @param {object} input    RequiredParameter: object containing any of the parameters to this API Endpoint.
             *
             * @return {promise<TreeModel>}
             */
            getTree: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }


                //Process template parameters
                var queryBuilder = {
                    "tree_id": input.treeId,
                    "fields": input.fields
                };

                APIFactory.API(appName, 'tree', 'getTree', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Get protocol associated with a tree. See the Setting model for more information.
             *
             * @return {promise<MenuItemModel>}
             */
            getProtocolTrees: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": input.treeId
                };
                APIFactory.API(appName, 'tree', 'getTreeProtocol', queryBuilder)
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },

            /**
             * Adds a new extra to a device if it does not already exist.
             */
            addExtraToTree: function (extra) {
                //Assign default values
                extra = extra || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (extra.body === null || angular.isUndefined(extra.body)) {
                    _deffered.reject({
                        errorMessage: "body property in  the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": extra.treeId,
                    "body": extra.body,
                    "cryptography": extra.cryptography,
                    "secret": extra.secret
                };
                APIFactory.API(appName, 'tree', 'addTreeExtra', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },

            /**
             * Deletes the extra from the device.
             */
            removeExtraFromTree: function (extra) {
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (extra.id === null || angular.isUndefined(extra.id)) {
                    _deffered.reject({
                        errorMessage: "The property 'id' in  the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "extra_id": extra.id,
                    "tree_id": extra.treeId
                };
                APIFactory.API(appName, 'tree', 'removeTreeExtra', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            /**
             * Deletes all extras from the device.
             */
            removeAllExtraFromTree: function (extra) {
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;

                if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "extra_id": extra.id
                };
                APIFactory.API(appName, 'tree', 'removeTreeExtras', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            /**
             * Updates an Extra to the device.
             */
            updateTreeExtra: function (extra) {
                //Assign default values
                extra = extra || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (extra.body === null || angular.isUndefined(extra.body)) {
                    _deffered.reject({
                        errorMessage: "body property in  the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }else if (extra.extraId === null || angular.isUndefined(extra.extraId)) {
                    _deffered.reject({
                        errorMessage: "The property 'extraId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": extra.treeId,
                    "extra_id": extra.extraId,
                    "body": extra.body,
                    "cryptography": extra.cryptography,
                    "secret": extra.secret
                };
                APIFactory.API(appName, 'tree', 'updateTreeExtra', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getAllExtrasOfTree: function (extra) {
                //Assign default values
                extra = extra || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "treeId property in  the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": extra.treeId,
                    "cryptography": extra.cryptography,
                    "secret": extra.secret
                };

                APIFactory.API(appName, 'tree', 'getTreeExtras', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            getExtraOfTree: function (extra) {
                //Assign default values
                extra = extra || {};

                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (extra.treeId === null || angular.isUndefined(extra.treeId)) {
                    _deffered.reject({
                        errorMessage: "treeId property in  the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }else if (extra.extraId === null || angular.isUndefined(extra.extraId)) {
                    _deffered.reject({
                        errorMessage: "The property 'extraId' in the extra object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": extra.treeId,
                    "extra_id": extra.extraId,
                    "cryptography": extra.cryptography,
                    "secret": extra.secret
                };

                APIFactory.API(appName, 'tree', 'getTreeExtra', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            /**
             * Transfer Ownership of tree to other user.
             */
            transferTreeOwnership: function (inputObj) {
                //Create promise to return
                var _deffered = $q.defer();

                //validating required parameters
                var _missingArgs = false;
                if (inputObj.personId === null || angular.isUndefined(inputObj.personId)) {
                    _deffered.reject({
                        errorMessage: "The property 'personId' in  the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                } else if (inputObj.treeId === null || angular.isUndefined(inputObj.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process template parameters
                var queryBuilder = {
                    "tree_id": inputObj.treeId,
                    "person_id": inputObj.personId
                };
                APIFactory.API(appName, 'tree', 'transferTreeOwnership', queryBuilder).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            },
            getTreeReport: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in  the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }
                //Process query parameters
                var queryBuilder = {
                    "tree_id": input.treeId,
                    "limit": input.limit,
                    "before": input.before,
                    "after": input.after,
                    "range": input.range,
                    "interval": input.interval
                };

                APIFactory.API(appName, 'tree', 'getTreeReport', APIFactory.APIQueryBuilder(queryBuilder, queryParameters))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            getTreeSummaries: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in  the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }
                //Process query parameters
                var queryBuilder = {
                    "tree_id": input.treeId
                };

                APIFactory.API(appName, 'tree', 'getTreeSummaries', APIFactory.APIQueryBuilder(queryBuilder))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },
            getTreeValues: function (input, queryParameters) {
                //Assign default values
                input = input || {};
                queryParameters = queryParameters || null;

                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.treeId === null || angular.isUndefined(input.treeId)) {
                    _deffered.reject({
                        errorMessage: "The property 'treeId' in  the input object cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }
                //Process query parameters
                var queryBuilder = {
                    "tree_id": input.treeId,
                    "limit": input.limit,
                    "before": input.before,
                    "after": input.after,
                    "range": input.range,
                    "interval": input.interval
                };

                APIFactory.API(appName, 'tree', 'getTreeHistory', APIFactory.APIQueryBuilder(queryBuilder, queryParameters))
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('ErrorFactory', function () {
        return {
            getError: function (error) {
                if (angular.isDefined(error)) {
                    var message = {
                        errorMessage: error.message ? error.message : "HTTP Response Not OK",
                        errorCode: error.code,
                        errorResponse: error.description
                    };
                    message.message = error.message;
                    return message;
                    /* var message = {

                     };
                     switch (error.code) {
                         case (400):
                             message = {
                                 errorMessage: "Bad Request: The server cannot or will not process the request due " +
                                 "to an apparent client error e.g., malformed request syntax, invalid request message" +
                                 " framing, or deceptive request routing",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (401):
                             message = {
                                 errorMessage: "Unauthorized: The user does not have the necessary credentials.",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (404):
                             message = {
                                 errorMessage: "Not Found: Ohhhh you got our junior developer's homepage. For security," +
                                 " some resources not available to the requesting user will return 404 to prevent " +
                                 "exposing their existence.",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (405):
                             message = {
                                 errorMessage: "Method Not Allowed: A request method is not supported for the requested " +
                                 "resource; for example, a GET request on a form which requires data to be presented via POST" +
                                 ", or a PUT request on a read-only resource.",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (408):
                             message = {
                                 errorMessage: "Request Timeout: The server timed out waiting for the request.",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (415):
                             message = {
                                 errorMessage: "Unsupported Media Type: The request entity has a media type which" +
                                 " the server or resource does not support.",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         case (500):
                             message = {
                                 errorMessage: "Internal Server Error: Oooops, something went terribly wrong!",
                                 errorCode: 400,
                                 errorResponse: error.description
                             };
                             break;
                         default:
                             message = {
                                 errorMessage: "HTTP Response Not OK",
                                 errorCode: error.code,
                                 errorResponse: error.description
                             };
                             message.message= error.message;
                             return message;
                     }*/
                }
            }
        }
    });
})();

(function () {

    'use strict';
    angular.module('phoenixNewUi').factory('BatchFactory', function ($q, $cookies, APIFactory) {
        return {
            executeBatchRequests: function (input) {
                //Assign default values
                input = input || {};

                //Create promise to return
                var _deffered = $q.defer();

                var _missingArgs = false;
                if (input.body === null || angular.isUndefined(input.body)) {
                    _deffered.reject({
                        errorMessage: "The parameter 'body' is a required parameter and cannot be null.",
                        errorCode: -1
                    });
                    _missingArgs = true;
                }

                if (_missingArgs) {
                    return _deffered.promise
                }

                //Process query parameters
                var queryBuilder = {};
                if(angular.isDefined(input.parallel)){
                    queryBuilder = {
                        "body": input.body,
                        "parallel":angular.isUndefined(input.parallel)?true:input.parallel
                    };
                }else{
                    queryBuilder = {
                        "body": input.body
                    };
                }
                APIFactory.API(input.appName, input.tag, 'process', APIFactory.APIQueryBuilder(queryBuilder)).then(function (response) {
                    _deffered.resolve(response);
                }, function (reject) {
                    _deffered.reject(reject);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('AuthenticationFactory', function ($q, $http, DB, APIFactory, UserFactory, AvatarService) {
        function fnGetUserDetail(defer, currentAuthUserId) {
            UserFactory.getUser({person_id: currentAuthUserId})
                .then(function (success) {
                    success.avatar = AvatarService.getTextAvatar(success);
                    defer.resolve(success);
                });
        }
        var appName = "phoenix1";
        return {
            /**
             * Get an Authentication Token. See the Auth Token model for more information
             */
            getSessionToken: function () {
                //Create promise to return
                var _deffered = $q.defer();
                APIFactory.API(appName, 'session', 'getSessionToken', {})
                    .then(function (response) {
                        _deffered.resolve(response);
                    }, function (reject) {
                        _deffered.reject(reject);
                    });
                return _deffered.promise;
            },

            /**
             *Get an authenticated user (After login)
             */
            getLoginUser: function () {
                var _deffered = $q.defer();
                var config = {};
                config.baseUri = APIFactory.BASEURL(appName);
                config.headers = {};
                config.headers.accept = 'application/json';
                config.headers['content-type'] = 'application/json; charset=utf-8';
                config.headers.Authorization = 'Basic ' + APIFactory.base64Encode('TODO: Replace:TODO: Replace');
                $http({
                    method: 'GET',
                    url: config.baseUri + '/users',
                    headers: config.headers,
                    params: {perPage: 1, pageSize: 1}
                }).success(function (data, status, headers/*, config*/) {
                    var currentAuthUserId = headers('X-Phoenix-Context-Id');
                    if (currentAuthUserId) {
                        DB.fnSet('xContextId', currentAuthUserId);
                        fnGetUserDetail(_deffered, currentAuthUserId);
                    }
                });

                return _deffered.promise;
            },

            /**
             * Get permissions for
             */
            getPermissionOfLoginUser: function (userObj) {
                var _deffered = $q.defer();
                var urlVar = userObj.role === 'ADMINISTRATOR' ? 'assets/json/adminPermissions.json' : 'assets/json/userPermissions.json';
                $http({
                    method: 'GET',
                    url: urlVar
                }).success(function (permisiionObj) {
                    _deffered.resolve(permisiionObj);
                });
                return _deffered.promise;
            }
        }
    });
})();

(function () {
    'use strict';
    angular.module('phoenixNewUi').factory('APIFactory', function ($q, $rootScope, InterceptorsService, ErrorFactory, amaran) {
        this.basicAuthUserName = "TODO: Replace";
        this.basicAuthPassword = "TODO: Replace";
        var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var _utf8_encode = function (string) {
            string = string.replace(/\r\n/g, "\n");
            var utftext = "";

            for (var n = 0; n < string.length; n++) {

                var c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }
            }
            return utftext;
        };
        return {
            BASEURL: function (app) {
                return angular.copy(HOST_URL[app]); // eslint-disable-line
            },
            API: function (app, apiType, apiMethod, apiObj) {
                var _deffered = $q.defer();
                InterceptorsService.request(undefined, app, apiObj);
                // To pass request body in swagger object
                var body = {};
                var api;// eslint-disable-line
                if (apiObj.body) {
                    body = {'requestBody': apiObj.body};
                    api = phoenixObj[app].apis[apiType][apiMethod](apiObj, body);  // eslint-disable-line
                }else{
                    api = phoenixObj[app].apis[apiType][apiMethod](apiObj); // eslint-disable-line
                }
                /* eslint-disable */
                api.then(function (data) {
                    /* eslint-enable */
                    if (data.obj && angular.isDefined(data.status) && !data.status.toString().startsWith('20')) {
                        data.obj.code = data.status;
                        InterceptorsService.responseError(data);
                        if (data.obj) {
                            /* eslint-disable */
                            if (data.url.includes("/sessions") && data.obj.code === 401) {
                            } /* eslint-enable */ else {
                                if (!data.obj.message) {
                                    data.obj.message = data.obj.description;
                                }
                                if (data.obj.code !== 401) {
                                    amaran.error(data.obj.message);
                                    $rootScope.$broadcast('DeviceAttributeLoader');
                                }
                            }
                        }
                        _deffered.reject(ErrorFactory.getError(data.obj));
                    } else {
                        InterceptorsService.response(data);
                        _deffered.resolve(data.obj);
                    }
                });
                return _deffered.promise;
            },
            APIReturnData: function (app, apiType, apiMethod, apiObj) {
                var _deffered = $q.defer();
                InterceptorsService.request(undefined, app);
                /* eslint-disable */
                phoenixObj[app].api[apiType][apiMethod](apiObj).then(function (data) {
                    /* eslint-enable */
                    InterceptorsService.response(data);
                    _deffered.resolve(data.data);
                }, function (error) {
                    InterceptorsService.responseError(error);
                    _deffered.reject(ErrorFactory.getError(error.data));
                });
                return _deffered.promise;
            },
            APIQueryBuilder: function update(queryBuilder, queryParameters) {
                var queryReturn = {};
                var key
                var query = angular.copy(queryBuilder);
                if (queryParameters !== null) {
                    var parameters = angular.copy(queryParameters);
                    for (key in queryParameters) {
                        if (parameters.hasOwnProperty(key) && query.hasOwnProperty(key)) {
                            query[key] = parameters[key];
                        }
                    }
                }
                for (key in query) {
                    if (angular.isDefined(query[key]) && query[key] !== null) {
                        queryReturn [key] = query[key];
                    }
                }
                return queryReturn;
            },
            formatString: function (str) {

                if (!str || arguments.length <= 1) {
                    return str
                }
                for (var i = 1; i < arguments.length; i++) {
                    var reg = new RegExp("\\{" + (i - 1) + "\\}", "gm");
                    str = str.replace(reg, arguments[i]);
                }
                return str;
            },
            base64Encode: function (input) {
                if (typeof btoa !== "undefined") {
                    return btoa(input);
                }
                var output = "";
                var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
                var i = 0;

                input = _utf8_encode(input);

                while (i < input.length) {

                    chr1 = input.charCodeAt(i++);
                    chr2 = input.charCodeAt(i++);
                    chr3 = input.charCodeAt(i++);

                    enc1 = chr1 >> 2;
                    enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                    enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                    enc4 = chr3 & 63;

                    if (isNaN(chr2)) {
                        enc3 = enc4 = 64;
                    } else if (isNaN(chr3)) {
                        enc4 = 64;
                    }

                    output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);

                }

                return output;
            }

        }
    });
})();

/*
 * angular-ui-tab-scroll
 * https://github.com/VersifitTechnologies/angular-ui-tab-scroll
 *
 * Version: 2.3.4
 * License: MIT
 */

angular.module('ui.tab.scroll', [])
    .provider('scrollableTabsetConfig', function(){

          //the default options
          var defaultConfig = {
            showDropDown: true,
            showTooltips: true,
            tooltipLeftPlacement: 'right',
            tooltipRightPlacement: 'left',
            scrollBy: '50',
            autoRecalculate: false,
            leftScrollAddition: '0'
          };

          var config = angular.extend({}, defaultConfig);

          return {
            setShowDropDown : function(value){
              config.showDropDown = (value == true);
            },
            setShowTooltips : function(value){
              config.showTooltips = (value == true);
            },
            setTooltipLeftPlacement : function(value){
              config.tooltipLeftPlacement = value;
            },
            setTooltipRightPlacement : function(value){
              config.tooltipRightPlacement = value;
            },
            setScrollBy : function(value){
              config.scrollBy = value;
            },
            setAutoRecalculate : function(value){
              config.autoRecalculate = (value == true);
            },
            setLeftScrollAddition : function(value){
                config.leftScrollAddition = value;
            },
            $get: function(){
              return {
                showDropDown: config.showDropDown,
                showTooltips: config.showTooltips,
                tooltipLeftPlacement: config.tooltipLeftPlacement,
                tooltipRightPlacement: config.tooltipRightPlacement,
                scrollBy: config.scrollBy,
                autoRecalculate: config.autoRecalculate,
                leftScrollAddition: config.leftScrollAddition
              };
            }
          };
        }
    )
    .directive('scrollableTabset', [
      'scrollableTabsetConfig', '$window', '$interval', '$timeout','$sce',
      function(scrollableTabsetConfig, $window, $interval, $timeout, $sce) {

        return {
          restrict: 'AE',
          transclude: true,

          scope: {
            showDropDown: '@',
            showTooltips: '@',
            tooltipLeftPlacement: '@',
            tooltipRightPlacement: '@',
            scrollBy: '@',
            autoRecalculate: '@',
            isButtonsVisible: '=?',
            dropDownClass: '@?',
            dropDownMenuClass: '@?',
            dropDownHeaderTemplateUrl: '@?',
            dropDownHeaderClass: '@?',
            api: '=?',
            leftScrollAddition: '@'
          },

          template: [
            '<div class="ui-tabs-scrollable" ng-class="{\'show-drop-down\': !hideDropDown}">',
              '<button type="button" ng-mousedown="scrollButtonDown(\'left\', $event)" ng-mouseup="scrollButtonUp()" ng-hide="hideButtons"' +
              ' ng-disabled="disableLeft" class="btn nav-button left-nav-button"' +
              ' tooltip-placement="{{tooltipLeftDirection}}" uib-tooltip-html="tooltipLeftHtml"></button>',
              '<div class="spacer" ng-class="{\'hidden-buttons\': hideButtons}" ng-transclude></div>',
              '<button type="button" ng-mousedown="scrollButtonDown(\'right\', $event)" ng-mouseup="scrollButtonUp()" ng-hide="hideButtons"' +
              ' ng-disabled="disableRight" class="btn nav-button right-nav-button"' +
              ' tooltip-placement="{{tooltipRightDirection}}" uib-tooltip-html="tooltipRightHtml"></button>',
              '<div class="btn-group" ng-class="::dropDownClass" uib-dropdown dropdown-append-to-body ng-hide="hideDropDown">',
                '<button type="button" class="btn" uib-dropdown-toggle></button>',
                '<ul class="dropdown-menu" uib-dropdown-menu role="menu" ng-class="::dropDownMenuClass||\'dropdown-menu-right\'">',
                  '<li ng-class="::dropDownHeaderClass" ng-include="::dropDownHeaderTemplateUrl"></li>',
                  '<li role="menuitem" ng-repeat="tab in dropdownTabs" ng-class="{\'disabled\': tab.disabled, \'active\': tab.active}" ng-click="activateTab(tab)">',
                    '<a href><span class="dropDownTabActiveMark" ng-style="{\'visibility\': tab.active?\'visible\':\'hidden\'}"></span>{{tab.tabScrollTitle}}</a>',
                  '</li>',
                '</ul>',
              '</div>',
            '</div>'
          ].join(''),

          link: function($scope, $el) {

            $scope.dropdownTabs = [];
            $scope.hideButtons = true;
            $scope.hideDropDown = true;
            $scope.tooltipRightHtml = '';
            $scope.tooltipLeftHtml = '';
            $scope.disableLeft = true;
            $scope.disableRight = true;
            $scope.tooltipLeftDirection = $scope.tooltipLeftPlacement ? $scope.tooltipLeftPlacement : scrollableTabsetConfig.tooltipLeftPlacement;
            $scope.tooltipRightDirection =  $scope.tooltipRightPlacement ? $scope.tooltipRightPlacement : scrollableTabsetConfig.tooltipRightPlacement;
            $scope.mouseDownInterval = null;
            $scope.isHolding = false;
            $scope.winResizeTimeout;
            $scope.userShowDropDown = $scope.showDropDown ? $scope.showDropDown === 'true' : scrollableTabsetConfig.showDropDown;
            $scope.userShowTooltips = $scope.showTooltips ? $scope.showTooltips === 'true' : scrollableTabsetConfig.showTooltips == true;
            $scope.scrollByPixels = parseInt($scope.scrollBy ? $scope.scrollBy : scrollableTabsetConfig.scrollBy);
            $scope.leftScrollAdditionPixels = parseInt($scope.leftScrollAddition ? $scope.leftScrollAddition : scrollableTabsetConfig.leftScrollAddition);

            $scope.api = {
              doRecalculate: function(){
                $timeout(function(){$scope.reCalcAll()});
              },

              scrollTabIntoView: function(arg){
                $timeout(function(){$scope.scrollTabIntoView(arg)});
              }
            };

            $scope.scrollTo = function(element, change, duration, callback, isLinear) {
              var start = element.scrollLeft;
              var increment = 20;
              var position = 0;

              var animateScroll = function(elapsedTime) {
                elapsedTime += increment;
                if(isLinear === true) {
                  position = $scope.linearTween(elapsedTime, start, change, duration);
                } else {
                  position = $scope.easeInOutQuad(elapsedTime, start, change, duration);
                }
                element.scrollLeft = position;
                if (elapsedTime < duration) {
                  setTimeout(function() {
                    animateScroll(elapsedTime);
                  }, increment);
                }else{
                  callback();
                }
              };

              animateScroll(0);
            }

            $scope.linearTween = function (currentTime, start, change, duration) {
              return change * currentTime / duration + start;
            };

            $scope.easeInOutQuad = function(currentTime, start, change, duration) {
              currentTime /= duration / 2;
              if (currentTime < 1) {
                return change / 2 * currentTime * currentTime + start;
              }
              currentTime --;
              return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
            }

            $scope.onWindowResize = function() {
              // delay for a bit to avoid running lots of times.
              clearTimeout($scope.winResizeTimeout);
              $scope.winResizeTimeout = setTimeout(function(){
                $scope.reCalcAll();
				$scope.scrollTabIntoView();
                $scope.$apply();
              }, 250);
            };

            $scope.cancelMouseDownInterval = function() {
              $scope.isHolding = false;

              if($scope.mouseDownInterval) {
                $interval.cancel($scope.mouseDownInterval);
                $scope.mouseDownInterval = null;
              }
            };

            $scope.scrollButtonDown = function(direction, event) {
              event.stopPropagation();
              $scope.isHolding = true;

              var realScroll = direction === 'left' ? 0 - $scope.scrollByPixels : $scope.scrollByPixels;
              $scope.scrollTo($scope.tabContainer, realScroll, 150, function(){
                $timeout(function(){
                  $scope.reCalcSides();
                });
              }, true);

              $scope.mouseDownInterval = $interval(function() {

                if($scope.isHolding) {
                  $scope.scrollTo($scope.tabContainer, realScroll, 150, function(){
                    $timeout(function(){
                      $scope.reCalcSides();
                    });
                  }, true);

                  if(event.target.disabled) {
                    $scope.cancelMouseDownInterval();
                  }
                }
              }, 100);
            }

            $scope.scrollButtonUp = function() {
              $scope.cancelMouseDownInterval();
            }

            $scope.activateTab = function(tab) {
              if(tab.disabled)return;
              tab.select();
              $timeout(function () {
                $scope.scrollTabIntoView();
              });
            }

            $scope.reCalcSides = function() {
              if(!$scope.tabContainer || $scope.hideButtons)return;
              $scope.disableRight = $scope.tabContainer.scrollLeft >= $scope.tabContainer.scrollWidth - $scope.tabContainer.offsetWidth;
              $scope.disableLeft = $scope.tabContainer.scrollLeft <= 0;

              if($scope.userShowTooltips){
                $scope.reCalcTooltips();
              }
            };

            $scope.reCalcTooltips = function(){
              if(!$scope.tabContainer || $scope.hideButtons)return;
              var rightTooltips = [];
              var leftTooltips = [];

              var allTabs = $scope.tabContainer.querySelectorAll('ul.nav-tabs > li');
              angular.forEach(allTabs, function(tab) {

                var rightPosition = parseInt(tab.getBoundingClientRect().left + tab.getBoundingClientRect().width - $scope.tabContainer.getBoundingClientRect().left);
                var leftPosition = tab.getBoundingClientRect().left - $scope.tabContainer.getBoundingClientRect().left;
                var heading = tab.getAttribute("data-tabScrollHeading");
                var ignore = tab.getAttribute("data-tabScrollIgnore");

                if(rightPosition > $scope.tabContainer.offsetWidth && !ignore ) {
                  if(heading) {
                    rightTooltips.push(heading)
                  } else if (tab.textContent)rightTooltips.push(tab.textContent);
                }

                if (leftPosition < 0 && !ignore ) {
                  if(heading) {
                    leftTooltips.push(heading)
                  } else if (tab.textContent)leftTooltips.push(tab.textContent);
                }

              });

              var rightTooltipsHtml = rightTooltips.join('<br>');
              $scope.tooltipRightHtml = $sce.trustAsHtml(rightTooltipsHtml);

              var leftTooltipsHtml = leftTooltips.join('<br>');
              $scope.tooltipLeftHtml = $sce.trustAsHtml(leftTooltipsHtml);
            };

            $scope.scrollTabIntoView = function(arg){
              if(!$scope.tabContainer || $scope.hideButtons)return;

              var argInt = parseInt(arg);
              var tabToScroll;

              // first we find the tab element.
              if(argInt) { // scroll tab index into view
                var allTabs = $scope.tabContainer.querySelectorAll('ul.nav-tabs > li');
                if(allTabs.length > argInt) { // only if its really exist
                  tabToScroll = allTabs[argInt];
                }
              } else { // scroll selected tab into view
                var activeTab = $scope.tabContainer.querySelector('li.active');
                if(activeTab) {
                  tabToScroll = activeTab;
                }
              }

              // now let's scroll it into view.
              if(tabToScroll) {
                var rightPosition = parseInt(tabToScroll.getBoundingClientRect().left + tabToScroll.getBoundingClientRect().width - $scope.tabContainer.getBoundingClientRect().left);
                var leftPosition = tabToScroll.getBoundingClientRect().left - $scope.tabContainer.getBoundingClientRect().left;
                if (leftPosition - $scope.leftScrollAdditionPixels < 0) {
                  var dif = leftPosition - 20 - $scope.leftScrollAdditionPixels;
                  $scope.scrollTo($scope.tabContainer, dif, 700, function(){
                    $timeout(function(){
                      $scope.reCalcSides();
                    });
                  });
                } else if(rightPosition > $scope.tabContainer.offsetWidth){
                  var dif = rightPosition - $scope.tabContainer.offsetWidth + 20;
                  $scope.scrollTo($scope.tabContainer, dif, 700, function(){
                    $timeout(function(){
                      $scope.reCalcSides();
                    });
                  });
                }
              }
            };

            // init is called only once!
            $scope.init = function() {
              $scope.tabContainer = $el[0].querySelector('.spacer ul.nav-tabs');
              if(!$scope.tabContainer)return;

              var autoRecalc = $scope.autoRecalculate ? $scope.autoRecalculate === 'true' : scrollableTabsetConfig.autoRecalculate;
              if(autoRecalc) {
                var tabsetElement = angular.element($el[0].querySelector('.spacer div'));
                $scope.$watchCollection(
                    function () {
                      return tabsetElement.isolateScope() ? tabsetElement.isolateScope().tabs : false;
                    },
                    function () {
                      $timeout(function () {
                        $scope.reCalcAll()
                      });
                    }
                );
              }

              $scope.reCalcAll();

              // attaching event to window resize.
              angular.element($window).on('resize', $scope.onWindowResize);
            };

            // re-calculate if the scroll buttons are needed, than call re-calculate for both buttons.
            $scope.reCalcAll = function() {
              if(!$scope.tabContainer)return;

              $scope.hideButtons = $scope.tabContainer.scrollWidth <= $scope.tabContainer.offsetWidth;
              $scope.hideDropDown = $scope.userShowDropDown ? $scope.hideButtons : true;
              $scope.isButtonsVisible = !$scope.hideButtons;

              if(!$scope.hideButtons) {

                if(!$scope.hideDropDown) {
                  var allTabs = $scope.tabContainer.querySelectorAll('ul.nav-tabs > li');
                  $scope.dropdownTabs = [];
                  angular.forEach(allTabs, function (tab) {
                    var ignore = tab.getAttribute("data-tabScrollIgnore");
                    if(!ignore){
                      var heading = tab.getAttribute("data-tabScrollHeading");
                      var tabScope = angular.element(tab).isolateScope();
                      //push new field to use as title in the drop down.
                      tabScope.tabScrollTitle = heading ? heading : tab.textContent.trim();
                      $scope.dropdownTabs.push(tabScope);
                    }
                  });
                }

                $scope.reCalcSides();
              }
            };

            // this is how we init for the first time.
            $timeout(function(){
              $scope.init();
            });

            // when scope destroyed
            $scope.$on('$destroy', function () {
              angular.element($window).off('resize', $scope.onWindowResize);
            });

          }
        };
      }]);

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('accountStatusCtrl',
            function ($rootScope, $scope, $uibModalInstance, AdvanceSearchTablesService,
                      SessionFactory, isCalledForFirstPaymentMethod) {
                var vm = this;
                vm.isShowFooterLoader = false;
                vm.availableTables = [];
                vm.isCalledForFirstPaymentMethod = isCalledForFirstPaymentMethod;

                vm.fnForceLogout = function () {
                    vm.isShowFooterLoader = true;
                    SessionFactory.deleteSession()
                        .then(function () {});
                    $rootScope.$broadcast('forceLogOut');
                    vm.isShowFooterLoader = false;
                    $uibModalInstance.close();
                };

                vm.fnClose = function () {
                    $uibModalInstance.close();
                };

                vm.fnInitModal = function () {
                    if (!vm.isCalledForFirstPaymentMethod) {
                        vm.availableTables = AdvanceSearchTablesService.getAvailableTables();
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('billingDashboardCtrl',
            function ($timeout, $state, $window, CurrencyService, PermissionsService, PaginationService, SummaryFactory) {
                var vm = this;
                var monthsObj = {
                    1: "Jan",
                    2: "Feb",
                    3: "Mar",
                    4: "Apr",
                    5: "May",
                    6: "Jun",
                    7: "Jul ",
                    8: "Aug",
                    9: "Sep",
                    10: "Oct",
                    11: "Nov",
                    12: "Dec"
                };
                vm.barData = [];
                vm.barChartTotalPrice = 0;
                vm.isBarChartDataLoaded = false;
                vm.isSummariesLoaded = false;

                vm.isBarDataChange = false;
                vm.yearsArr = [];
                vm.selectedYear = 0;
                vm.summariesArr = [];
                vm.barchartArr = [];
                vm.summaryInputObj = {
                    page: 1,
                    perPage: 0
                };
                vm.isShowLabel = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                vm.fnSetTableHeight = function () {
                    var total = angular.element('.content-box-content')[0].offsetHeight;
                    var modalHeader = angular.element('.modal-header')[0].offsetHeight;
                    angular.element(".billing-main-body").css('height', (total - (modalHeader + 15)) + 'px');
                };

                vm.fnGoToBillDetails = function () {
                    $state.go("main.bill");
                };

                vm.fnGetSummaries = function () {
                    vm.isSummariesLoaded = false;
                    SummaryFactory.getSummaries(vm.summaryInputObj)
                        .then(function (response) {
                            var paginationObj = PaginationService.Pagination.summaries;
                            vm.summariesArr.push.apply(vm.summariesArr, response);
                            if ((response.data && response.data.length && response.data.length > 0) && (response.length < paginationObj.totalCollection)) {
                                vm.summaryInputObj.page = vm.summaryInputObj.page + 1;
                                vm.fnGetSummaries();
                            } else {
                                vm.totalPrice = 0;
                                vm.data = [];
                                _.forEach(vm.summariesArr, function (summarieObj) {
                                    if (summarieObj.year === vm.currentYYYY && summarieObj.month === vm.currentMM) {
                                        summarieObj.roundedPrice = Math.ceil(summarieObj.price * 100) / 100;
                                        vm.totalPrice += summarieObj.roundedPrice;
                                        vm.data.push({
                                            name: summarieObj.service.replace("_", " "),
                                            value: summarieObj.roundedPrice,
                                            currency: summarieObj.currency
                                        });
                                    }
                                });
                                vm.isSummariesLoaded = true;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                                if (vm.summariesArr.length) {
                                    vm.fnGetBarChartData(vm.summariesArr);
                                } else {
                                    vm.barchartArr = [];
                                    vm.isBarChartDataLoaded = true;
                                    $timeout(function () {
                                        vm.fnSetTableHeight();
                                    })
                                }
                            }
                        })
                };

                vm.fnGetBarChartData = function (summariesArr) {
                    vm.barchartArr = angular.copy(summariesArr);
                    if (vm.barchartArr.length) {
                        _.forEach(vm.barchartArr, function (barChartObj) {
                            if (!_.includes(vm.yearsArr, barChartObj.year)) {
                                vm.yearsArr.push(barChartObj.year);
                            }
                            barChartObj.roundedTotal = Math.ceil(barChartObj.price * 100) / 100;
                            vm.selectedYear = vm.currentYYYY;
                            vm.barChartTotalPrice += barChartObj.roundedTotal;
                            if (vm.selectedYear === barChartObj.year) {
                                barChartObj.roundedTotal = Math.ceil(barChartObj.price * 100) / 100;
                                var tempName = "( " + monthsObj[barChartObj.month] + " " + barChartObj.year + " )";
                                var isValueFind = _.find(vm.barData, {'Letter': tempName});
                                if (isValueFind) {
                                    isValueFind.Freq = (parseFloat(isValueFind.Freq) + parseFloat(barChartObj.roundedTotal)).toFixed(2)
                                } else {
                                    vm.barData.push(
                                        {
                                            Letter: tempName,
                                            Freq: parseFloat(barChartObj.roundedTotal).toFixed(2),
                                            currentMonth: "No",
                                            year: barChartObj.year,
                                            month: barChartObj.month
                                        }
                                    );
                                }
                                //vm.barChartTotalPrice += barChartObj.roundedTotal;
                            }
                        });
                        if (!_.includes(vm.yearsArr, vm.currentYYYY)) {
                            vm.yearsArr.push(vm.currentYYYY);
                        }
                        if (vm.data.length && vm.currentYYYY === vm.selectedYear) {
                            var barChartObjIndex = _.findIndex(vm.barData, function (obj) {
                                return obj.Letter === "( " + monthsObj[vm.currentMM] + " " + vm.currentYYYY + " )";
                            });
                            if (barChartObjIndex !== -1 && vm.barData[barChartObjIndex]) {
                                vm.barData[barChartObjIndex].currentMonth = "Yes";
                            } else {
                                vm.barData.push(
                                    {
                                        Letter: "( " + monthsObj[vm.currentMM] + " " + vm.currentYYYY + " )",
                                        Freq: parseFloat(vm.totalPrice).toFixed(2),
                                        currentMonth: "Yes",
                                        year: vm.currentYYYY,
                                        month: vm.currentMM
                                    }
                                );
                            }
                            vm.barChartTotalPrice += parseFloat(vm.totalPrice);
                        }
                    } else {
                        vm.selectedYear = vm.currentYYYY;
                        vm.barData.push(
                            {
                                Letter: "( " + monthsObj[vm.currentMM] + " " + vm.currentYYYY + " )",
                                Freq: parseFloat(vm.totalPrice).toFixed(2),
                                currentMonth: "Yes"
                            }
                        );
                        vm.barChartTotalPrice += parseFloat(vm.totalPrice);
                    }
                    vm.barChartTotalPrice = vm.barChartTotalPrice / vm.barchartArr.length;
                    var array = _.sortBy(vm.barData, ['year', 'month']);
                    vm.barData = angular.copy(array);
                    vm.isBarChartDataLoaded = true;
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnYearSelected = function (year) {
                    vm.selectedYear = year;
                    vm.isBarDataChange = true;
                    vm.barData = [];
                    //vm.barChartTotalPrice = 0;
                    _.forEach(vm.barchartArr, function (barChartObj) {
                        if (barChartObj.year === vm.selectedYear) {
                            barChartObj.roundedTotal = Math.ceil(barChartObj.price * 100) / 100;
                            var tempName = "( " + monthsObj[barChartObj.month] + " " + barChartObj.year + " )";
                            var isValueFind = _.find(vm.barData, {'Letter': tempName});
                            if (isValueFind) {
                                isValueFind.Freq = (parseFloat(isValueFind.Freq) + parseFloat(barChartObj.roundedTotal)).toFixed(2)
                            } else {
                                vm.barData.push(
                                    {
                                        Letter: tempName,
                                        Freq: parseFloat(barChartObj.roundedTotal).toFixed(2),
                                        currentMonth: "No",
                                        year: barChartObj.year,
                                        month: barChartObj.month
                                    }
                                );
                            }
                            //vm.barChartTotalPrice += barChartObj.roundedTotal;
                        }
                    });
                    if (vm.data.length && vm.currentYYYY === vm.selectedYear) {
                        var barChartObjIndex = _.findIndex(vm.barData, function (obj) {
                            return obj.Letter === "( " + monthsObj[vm.currentMM] + " " + vm.currentYYYY + " )";
                        });
                        if (barChartObjIndex !== -1 && vm.barData[barChartObjIndex]) {
                            vm.barData[barChartObjIndex].currentMonth = "Yes";
                        } else {
                            vm.barData.push(
                                {
                                    Letter: "( " + monthsObj[vm.currentMM] + " " + vm.currentYYYY + " )",
                                    Freq: parseFloat(vm.totalPrice).toFixed(2),
                                    currentMonth: "Yes",
                                    year: vm.currentYYYY,
                                    month: vm.currentMM
                                }
                            );
                        }
                        //vm.barChartTotalPrice += parseFloat(vm.totalPrice);
                    }
                    //vm.barChartTotalPrice = vm.barChartTotalPrice / vm.barData.length;
                    var array = _.sortBy(vm.barData, ['year', 'month']);
                    vm.barData = angular.copy(array);
                    $timeout(function () {
                        vm.isBarDataChange = false;
                    }, 100);
                };

                vm.fnGetCurrencySymbol = function (code) {
                    return CurrencyService.getCurrencySymbol(code);
                };

                vm.fnNumberToCurrency = function (number) {
                    return CurrencyService.fnNumberToCurrencyConvert(number);
                };

                vm.fnInitBillingDashboard = function () {
                    vm.summaryPermissionsObj = PermissionsService.getPermissions("billing:summary");
                    var today = new Date();
                    vm.currentMM = today.getMonth() + 1; //January is 0!
                    vm.currentYYYY = today.getFullYear();
                    if (vm.summaryPermissionsObj.List) {
                        vm.isSummariesLoaded = false;
                        vm.isBarChartDataLoaded = false;
                        vm.fnGetSummaries();
                    } else {
                        vm.summariesArr = [];
                        vm.data = [];
                        vm.barchartArr = [];
                        vm.isSummariesLoaded = true;
                        vm.isBarChartDataLoaded = true;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                }
            });
})();


(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('BillingScriptsCtrl',
            function ($window, $timeout, $http, $base64, $sce, $stateParams, $state, DB, UserProfileService,
                      LastPageService, PaginationService, amaran, swal, UserFactory, ApiListService, microSpinner,
                      PermissionsService, postActionModelMessage, postActionModelIcon, jsonToCsvConvertService,
                      BillingScriptFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('billing', 's4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.billing_scripts') {
                        $timeout(function () {
                            $state.go('main.billing_scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.billing_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.billing_scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.billing_scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.billing_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionObj.LIST_SCRIPT_TYPES) {
                        BillingScriptFactory.listScriptTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.billing_scripts') {
                                    $state.go('main.billing_scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                        } else {
                            $state.go('main.billing_scripts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    if (tab.id === "Dashboard") {
                        $state.go('main.billing_scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        vm.fnChangeTab(lastLast, true);
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.billing_scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('billing', 's4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('billing', 's4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.billing_scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    var tempValue = UserProfileService.fnGetUserProfileObj('billing', 's4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PlanCtrl',
            function ($timeout, $window, $scope, swal, microSpinner, DB, amaran, moment, PermissionsService, PlanFactory) {
                var vm = this;

                vm.isFullWidthDevice = false;
                vm.isPlanloading = true;
                vm.isAIFunctionCountChanging = false;
                vm.isShowSupportDeactivationLoader = false;
                vm.isAIChangesShow = false;
                vm.isShowAISlider = false;
                vm.planResponse = [];
                vm.planObj = {};
                vm.slider = {};

                vm.tabs = [{
                    title: 'Overview',
                    tabIndex: 1,
                    visible: true
                }];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.fnSetTabHeight();
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var footer = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var tabHeader = 0;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var finalHeightInfo = total - (tabHeader + footer + dashboardHeader + 30);
                        angular.element("#planData").css('height', finalHeightInfo + 'px');
                    }
                };

                vm.fnResetSliderValue = function () {
                    vm.slider.value = angular.copy(vm.planObj.ai.aiNodeFunctionCount.value);
                    vm.isShowAISlider = false;
                }

                vm.fnUpdatePlanDetails = function (res) {
                    res.supportDeactivationEpoch = moment.unix(res.supportDeactivationEpoch).format("DD MMM YYYY HH:mm");
                    res.supportDeactivationIsAfter = moment().isAfter(res.supportDeactivationEpoch);
                    vm.planResponse = _.cloneDeepWith(res);
                    vm.planObj = {};
                    vm.planObj.pipeline = {
                        appDisplayName: 'Pipeline',
                        panelDisplayName: 'Pipeline Support',
                        isActive: vm.planResponse.pipelineActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.pipelinePricePerNodeMonth
                        }
                    };
                    vm.planObj.tracker = {
                        appDisplayName: 'Tracker',
                        panelDisplayName: 'Tracker Support',
                        isActive: vm.planResponse.trackerActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.trackerPricePerNodeMonth
                        }
                    };
                    vm.planObj.storage = {
                        appDisplayName: 'Storage',
                        panelDisplayName: 'Storage Support',
                        isActive: vm.planResponse.storageActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.storagePricePerNodeMonth
                        }
                    };
                    vm.planObj.support = {
                        appDisplayName: 'Support',
                        panelDisplayName: 'Enterprise Support',
                        isActive: vm.planResponse.supportActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.supportPricePerNodeMonth
                        },
                        supportDeactivationEpoch: {
                            displayName: 'Deactivation Epoch :',
                            value: vm.planResponse.supportDeactivationEpoch
                        },
                        supportDeactivationIsAfter: vm.planResponse.supportDeactivationIsAfter
                    };
                    vm.planObj.node = {
                        appDisplayName: 'Node',
                        panelDisplayName: 'Node Support',
                        isActive: vm.planResponse.nodeActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.nodePricePerNodeMonth
                        },
                        minNodeCount: {
                            displayName: 'Min Node Count :',
                            value: vm.planResponse.minNodeCount
                        },
                        minPrepayNodeCount: {
                            displayName: 'Min Prepay Node Count :',
                            value: vm.planResponse.minPrepayNodeCount
                        }
                    };
                    vm.planObj.ai = {
                        appDisplayName: 'AI',
                        panelDisplayName: 'AI Functions',
                        isActive: vm.planResponse.aiActive,
                        pricePerNodeMonth: {
                            displayName: 'Price Per Node Month',
                            value: vm.planResponse.aiPricePerNodeFunctionMonth
                        },
                        aiNodeFunctionCount: {
                            displayName: 'Function Count :',
                            value: vm.planResponse.aiNodeFunctionCount
                        },
                        aiNodeFunctionMaxCount: {
                            displayName: 'Function Max Count :',
                            value: vm.planResponse.aiNodeFunctionMaxCount
                        },
                        aiNodeFunctionMinCount: {
                            displayName: 'Function Min Count :',
                            value: vm.planResponse.aiNodeFunctionMinCount
                        }
                    };
                    vm.slider = {
                        value: angular.copy(vm.planObj.ai.aiNodeFunctionCount.value),
                        options: {
                            floor: vm.planObj.ai.aiNodeFunctionMinCount.value,
                            ceil: vm.planObj.ai.aiNodeFunctionMaxCount.value,
                            showSelectionBar: true,
                            step: 1,
                            onEnd: function () {
                                vm.isAIChangesShow = vm.planObj.ai.aiNodeFunctionCount.value !== vm.slider.value;
                            }
                        }
                    };
                }

                vm.fnGetPlan = function () {
                    vm.isPlanloading = true;
                    PlanFactory.describePlan()
                        .then(function (res) { // Success block
                            vm.fnUpdatePlanDetails(res);
                            vm.isPlanloading = false;
                            $timeout(function () {
                                vm.fnSetTabHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isPlanloading = false;
                            vm.isRefresh = false;
                        });
                };

                vm.fnChangeAIFunctionCount = function () {
                    swal({
                            title: "Are you Sure?",
                            text: "Please note that by changing the AI Function count it will change your per node price per month. Please confirm your changes.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "Change AI Function Count",
                            cancelButtonText: "Cancel",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                vm.isAIFunctionCountChanging = true;
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                angular.element(".cancel").css("visibility", "hidden");
                                var inputObj = {
                                    "quantity": vm.slider.value
                                }
                                PlanFactory.updatePlanAiFunctionCount(inputObj)
                                    .then(function (res) {
                                        vm.fnUpdatePlanDetails(res);
                                        vm.isAIFunctionCountChanging = false;
                                        vm.isAIChangesShow = false;
                                        vm.isShowAISlider = false;
                                        angular.element(".microSpinner").remove();
                                        angular.element(".confirm").css("visibility", "visible");
                                        angular.element(".cancel").css("visibility", "visible");
                                        swal.close();
                                    })
                            } else {
                                vm.fnResetSliderValue();
                                swal.close();
                            }
                        });
                }

                vm.fnDeactiveSupport = function () {
                    vm.isShowSupportDeactivationLoader = true;
                    PlanFactory.deactivatePlanSupport()
                        .then(function (res) {
                            vm.fnUpdatePlanDetails(res);
                            vm.isShowSupportDeactivationLoader = false;
                        })
                };

                vm.fnPlanSwitchToggle = function (appName) {
                    vm.planObj[appName].isPlanStateChanging = true;

                    var input = {
                        application: appName
                    };
                    if (appName === 'support') {
                        PlanFactory.activatePlanSupport()
                            .then(function (res) { // Success block
                                delete vm.planObj.support.isPlanStateChanging;
                                vm.fnUpdatePlanDetails(res);
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                delete vm.planObj.support.isPlanStateChanging;
                            });
                    } else {
                        PlanFactory.activatePlanApplication(input)
                            .then(function (res) { // Success block
                                delete vm.planObj[appName].isPlanStateChanging;
                                vm.fnUpdatePlanDetails(res);
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                delete vm.planObj[appName].isPlanStateChanging;
                                vm.fnGetPlan();
                            });
                    }
                };

                vm.fnInitPlan = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.isPlanloading = true;
                    vm.fnGetPlan();
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('PaymentMethodCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB,
                      UserProfileService, PermissionsService, LastPageService, UserFactory, SessionFactory,
                      PaymentMethodsFactory, BatchFactory, PaginationService, FedSudoUserService,
                      postActionModelIcon, postActionModelMessage, copyService, $log) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                //Search Variables
                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'UNCONFIRMED', displayName: 'UNCONFIRMED'},
                    {name: 'SUSPENDED', displayName: 'SUSPENDED'},
                    {name: 'UNPAID', displayName: 'UNPAID'},
                    {name: 'CLOSED', displayName: 'CLOSED'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Brand",
                        name: "card.brand",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'id', displayName: 'Id'},
                    {name: 'card.brand', displayName: 'Brand'}
                ];
                vm.filterQuery = "";
                vm.isRefreshData = true;
                vm.isInit = true;
                //Payment Method Variables
                vm.isPaymentMethosLoading = false;
                vm.paymentMethodsArr = [];
                vm.selectedPaymentMethodsArr = [];
                vm.selectedPaymentMethodObj = {};
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('billing', 'paymentMethod', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isPaymentMethosLoading = true;
                    vm.selectedPaymentMethodsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetPaymentMethods();
                    } else {
                        vm.fnGetFilterData();
                    }
                };
                /*END: Search*/

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var paymentMethodArr = [];
                    var filterPaymentMethodArr = [];
                    if (vm.filterQuery) {
                        filterPaymentMethodArr = _.filter(vm.paymentMethodResponse, function (obj) {
                            if (eval(vm.filterQuery)) {
                                return obj;
                            }
                        });
                    } else {
                        filterPaymentMethodArr = _.cloneDeepWith(vm.paymentMethodResponse);
                    }
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        paymentMethodArr = _.orderBy(filterPaymentMethodArr, [sortValue], [sortType]);
                    } else {
                        paymentMethodArr = _.cloneDeepWith(filterPaymentMethodArr);
                    }
                    vm.totalItems = paymentMethodArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.paymentMethodsArr = paymentMethodArr.slice(startItem, endItem);
                    // vm.paymentMethodsArr = [];
                    if ($state.current.name === 'main.payment_method') {
                        $timeout(function () {
                            $state.go('main.payment_method', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isRefresh = false;
                    vm.isPaymentMethosLoading = false;
                };

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#paymentMethodTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields
                                parsedItem.id = parsedItem.id || parsedData.id;

                                // Card details
                                parsedItem.card = parsedData.card || {
                                    brand: parsedItem.brand || parsedData.brand,
                                    last4: parsedItem.last4 || parsedData.last4,
                                    expiryMonth: parsedItem.expiry_month || parsedData.expiryMonth,
                                    expiryYear: parsedItem.expiry_year || parsedData.expiryYear
                                };

                                // Billing details
                                parsedItem.billingDetails = parsedData.billingDetails || {
                                    name: parsedItem.billing_name || parsedData.billingName
                                };

                                // Default payment method flag
                                parsedItem.defaultPaymentMethod = parsedData.defaultPaymentMethod || parsedItem.default_payment_method || false;

                                // Merge remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing payment method data:', e);
                                return parsedItem;
                            }
                        }

                        // If no data field exists, still ensure basic fields are parsed
                        if (!parsedItem.card) {
                            parsedItem.card = {
                                brand: parsedItem.brand,
                                last4: parsedItem.last4,
                                expiryMonth: parsedItem.expiry_month,
                                expiryYear: parsedItem.expiry_year
                            };
                        }

                        if (!parsedItem.billingDetails) {
                            parsedItem.billingDetails = {
                                name: parsedItem.billing_name
                            };
                        }

                        parsedItem.defaultPaymentMethod = parsedItem.default_payment_method || false;

                        return parsedItem;
                    });
                }

// Update the payment methods retrieval
                vm.fnGetPaymentMethods = function () {
                    if (vm.permissionObj.LIST_PAYMENT_METHODS) {
                        PaymentMethodsFactory.listPaymentMethods()
                            .then(function (res) {
                                // Parse the PostgreSQL response
                                var parsedData = parsePostgresData(res);
                                vm.paymentMethodResponse = _.cloneDeepWith(parsedData);
                                vm.fnGetFilterData();
                                vm.isPaymentMethosLoading = false;

                                if ($stateParams.selectedId) {
                                    var paymentMethodData = _.find(vm.paymentMethodsArr, {"id": $stateParams.selectedId});
                                    if (paymentMethodData) {
                                        vm.fnCheckUncheckHeader(paymentMethodData);
                                    }
                                }

                                vm.isRefresh = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isPaymentMethosLoading = false;
                                vm.isRefresh = false;
                            });
                    } else {
                        vm.paymentMethodResponse = [];
                        vm.fnGetFilterData();
                        vm.isPaymentMethosLoading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }
                };

// Added delete button to HTML template
// Added this inside the dropdown menu in the HTML:
                vm.fnDeletePaymentMethod = function(payment) {
                    swal({
                        title: "Delete this payment method?",
                        text: "Are you sure you want to delete this payment method? This action cannot be undone.",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Delete",
                        closeOnConfirm: false,
                        showLoaderOnConfirm: true
                    }, function(isConfirm) {
                        if (isConfirm) {
                            PaymentMethodsFactory.deletePaymentMethod({
                                methodId: payment.id // Fixed parameter name to methodId
                            }).then(function() {
                                swal({
                                    title: "Deleted!",
                                    text: "Payment method has been deleted.",
                                    type: "success",
                                    timer: 2000,
                                    showConfirmButton: false
                                });

                                // Remove from arrays and update UI
                                _.remove(vm.paymentMethodsArr, {id: payment.id});
                                _.remove(vm.selectedPaymentMethodsArr, {id: payment.id});
                                vm.totalItems = vm.totalItems - 1;

                                // Update state
                                $state.go('main.payment_method', {
                                    selectedId: '',
                                    selectedDetailsTab: ''
                                }, {notify: false});
                                delete $stateParams.selectedId;
                                delete $stateParams.selectedDetailsTab;

                                vm.fnReload();
                                vm.fnRemoveTab(payment.id);

                            }, function(error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                swal("Error", "Failed to delete payment method", "error");
                            });
                        }
                    });
                };

                vm.fnCheckUncheckHeader = function (paymentMethodObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_PAYMENT_METHOD) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.paymentMethodsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === paymentMethodObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected accounts array*/
                        var isValueFind = _.find(vm.selectedPaymentMethodsArr, {'id': paymentMethodObj.id});
                        if (!isValueFind) {
                            vm.selectedPaymentMethodsArr.push(paymentMethodObj);
                            var isTabExist = _.find(vm.tabs, {'id': paymentMethodObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: paymentMethodObj.id,
                                    title: paymentMethodObj.billingDetails.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedPaymentMethodsArr, function (obj) {
                                return paymentMethodObj.id === obj.id;
                            });
                        }
                        if (vm.selectedPaymentMethodsArr.length === 1) {
                            vm.fnGetPaymentMethodDetails(vm.selectedPaymentMethodsArr[0])
                        } else {
                            $state.go('main.payment_method', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.paymentMethodsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedPaymentMethodsArr = angular.copy(vm.paymentMethodsArr);
                    } else {
                        vm.selectedPaymentMethodsArr = [];
                    }
                    $state.go('main.payment_method', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnGetPaymentMethodDetails = function (paymentMethodObj) {
                    vm.isPaymentMethodDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when payment method is selected
                        vm.selectedPaymentMethodObj = paymentMethodObj;
                        $state.go('main.payment_method', {selectedId: vm.selectedPaymentMethodObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedPaymentMethodObj.id;
                        vm.isPaymentMethodDetailsLoaded = true;
                    })
                };

                vm.fnOpenPaymentMethodInfoTab = function (paymentMethodObj) {
                    vm.fnCheckUncheckHeader(paymentMethodObj);
                };

                vm.fnGetPaymentMethod = function (paymentMethodObj, paymentMethodsArr) {
                    angular.forEach(paymentMethodsArr, function (payment) {
                        payment.isCheck = false;
                    });
                    paymentMethodObj.isCheck = true;
                    vm.selectedPaymentMethodsArr = [paymentMethodObj]; // Assign array with single payment method object
                    vm.fnGetPaymentMethodDetails(paymentMethodObj);
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedPaymentMethodsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Add Payment Method'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Add Payment Method',
                                title: 'Add Payment Method',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.payment_method', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isPaymentMethosLoading = true;
                    vm.selectedPaymentMethodsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetPaymentMethods();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.paymentMethodsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedPaymentMethodsArr = [];
                                vm.selectedPaymentMethodObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.payment_method', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isCreate = tab.id === "Add Payment Method";
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Add Payment Method";
                    if (tab.id === "Add Payment Method") {
                        $state.go('main.payment_method', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        vm.fnChangeTab(lastLast, true);
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.payment_method', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        if (vm.activeTabIndex === 1) {
                            vm.fnReload();
                        }
                    });
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    //UserProfileService.fnUpdateUserProfileObj('billing', 'paymentMethod', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnDeleteExistingSession = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/accountStatusModal/accountStatusModal.html',
                        size: 'md',
                        controller: 'accountStatusCtrl as accountStat',
                        resolve: {
                            isCalledForFirstPaymentMethod: function () {
                                return true;
                            }
                        }
                    });
                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                $scope.$on("PaymentMethodDeleted", function (evt, data) {
                    vm.selectedPaymentMethodObj = null;
                    vm.selectedPaymentMethodsArr = [];
                    vm.paymentMethodsArr = vm.paymentMethodsArr.filter(function (paymentMethodObj) {
                        return (paymentMethodObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.payment_method', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("PaymentMethodPrimaryChanged", function (evt, data) {
                    angular.forEach(vm.paymentMethodsArr, function (paymentMethodObj) {
                        if (paymentMethodObj.id === data.id) {
                            paymentMethodObj.defaultPaymentMethod = true;
                        } else {
                            paymentMethodObj.defaultPaymentMethod = false;
                        }
                    });
                    vm.fnReload();
                });

                $scope.$on("paymentMethodAdded", function () {
                    vm.fnRemoveTab('Add Payment Method');
                    if (vm.paymentMethodsArr.length === 0) {
                        vm.fnDeleteExistingSession();
                    }
                    vm.fnReload();
                });

                vm.fnDeleteMultiplePaymentMethods = function (selectedPaymentMethodsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedPaymentMethodsArr, function (selectedPaymentMethod, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/profiles/" + selectedPaymentMethod.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/profiles/" + selectedPaymentMethod.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete these Payment methods?",
                            text: "Deleting Payment methods will permanently remove these Payment methods.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'profile',
                        appName: 'billing'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedPaymentMethodsArr, function (selectedPayment) {
                                    angular.forEach(vm.paymentMethodsArr, function (paymentObj, index) {
                                        if (selectedPayment.id === paymentObj.id) {
                                            vm.paymentMethodsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedPaymentMethodsArr.length;
                                vm.selectedPaymentMethodObj = null;
                                vm.selectedPaymentMethodsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedPaymentMethodsArr, function (selectedPayment) {
                                    angular.forEach(vm.paymentMethodsArr, function (paymentObj, index) {
                                        if (selectedPayment.id === paymentObj.id) {
                                            vm.paymentMethodsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedPaymentMethodsArr.length;
                                vm.selectedPaymentMethodObj = null;
                                vm.selectedPaymentMethodsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetCreditCardClass = function (cardType) {
                    if (cardType === 'discover') {
                        return 'fa-cc-discover';
                    } else if (cardType === 'jcb') {
                        return 'fa-cc-jcb';
                    } else if (cardType === 'americanexpress') {
                        return 'fa-cc-amex';
                    } else if (cardType === 'dinersclub') {
                        return 'fa-cc-diners-club';
                    } else if (cardType === 'visa') {
                        return 'fa-cc-visa';
                    } else if (cardType === 'mastercard') {
                        return 'fa-cc-mastercard';
                    } else {
                        return 'fa-credit-card';
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('billing', 'paymentMethod', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.payment_method", tempArr, {notify: false});
                    }
                };

                vm.fnInitPaymentMethod = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    var tempValue = UserProfileService.fnGetUserProfileObj('billing', 'paymentMethod', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var paymentMethodKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.payment_method') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.REQUEST_NEW_PAYMENT_METHOD &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedPaymentMethodsArr.length > 1 && vm.permissionObj.DELETE_PAYMENT_METHOD &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete
                                vm.fnDeleteMultiplePaymentMethods(vm.selectedPaymentMethodsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var paymentMethodKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.payment_method') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', paymentMethodKeyDownEventHandler);
                document.addEventListener('keyup', paymentMethodKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', paymentMethodKeyDownEventHandler);
                    document.removeEventListener('keyup', paymentMethodKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('InvoiceCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, highed, moment,
                      WidgetsListService, PaginationQueryService, UserProfileService, InvoiceFactory,
                      QueryFactory, amaran, ColorService, swal, microSpinner, DB, XLSX, Authenticate, IconService,
                      PermissionsService, LastPageService, AvatarService, PaginationService, FedSudoUserService,
                      postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, copyService, $log) {
                var vm = this;
                var currentAccountState =  DB.fnGet('currentAccountState');
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateInvoiceProfileData();
                    }
                };
                vm.isShowDashboard = false;

                //Search Variables
                vm.isRefreshData = true;
                vm.statusFieldArr = [
                    {name: 'DRAFT', displayName: 'DRAFT'},
                    {name: 'OPEN', displayName: 'OPEN'},
                    {name: 'PAID', displayName: 'PAID'},
                    {name: 'UNCOLLECTIBLE', displayName: 'UNCOLLECTIBLE'},
                    {name: 'VOID', displayName: 'VOID'}
                ];
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Email",
                        name: "businessEmail",
                        regexp: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
                        errorMessage: "Invalid Email address."
                    },
                    {
                        displayName: "Amount",
                        name: "total",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Status",
                        name: "status",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.statusFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    },
                    {
                        displayName: "Company Name",
                        name: "businessName",
                        regexp: "",
                        errorMessage: ""
                    }];
                vm.sortFieldArr = [
                    {name: 'id', displayName: 'Id'},
                    {name: 'businessEmail', displayName: 'Email'},
                    {name: 'total', displayName: 'Amount'},
                    {name: 'status', displayName: 'Status'},
                    {name: 'dueDate', displayName: 'Due Date'},
                    {name: 'businessName', displayName: 'Company Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Invoice Variables
                vm.isInvoicesloading = false;
                vm.invoiceArr = [];
                vm.selectedInvoicesArr = [];
                vm.selectedInvoiceObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.isShowInvoiceStats = false;

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.invoiceResponse = [];
                vm.isSinglePage = false;

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.fnSetTableHeight();
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#invoiceTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('billing', 'invoice', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isInvoicesloading = true;
                    vm.selectedInvoicesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM billing_invoices';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_invoices';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetInvoices(input, true);
                };
                /*END: Search*/


                vm.fnCheckUncheckHeader = function (invoiceObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_INVOICE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.invoiceArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === invoiceObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected invoice array*/
                        var isValueFind = _.find(vm.selectedInvoicesArr, {'id': invoiceObj.id});
                        if (!isValueFind) {
                            vm.selectedInvoicesArr.push(invoiceObj)
                            var isTabExist = _.find(vm.tabs, {'id': invoiceObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: invoiceObj.id,
                                    title: invoiceObj.businessName,
                                    tabIndex: newTabIndex,
                                    projectName: invoiceObj.dueDate
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateInvoiceProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedInvoicesArr, function (obj) {
                                return invoiceObj.id === obj.id;
                            });
                        }
                        if (vm.selectedInvoicesArr.length === 1) {
                            vm.fnGetInvoiceDetails(vm.selectedInvoicesArr[0])
                        } else {
                            $state.go('main.invoice', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.invoiceArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedInvoicesArr = angular.copy(vm.invoiceArr);
                    } else {
                        vm.selectedInvoicesArr = [];
                    }
                    $state.go('main.invoice', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenInvoiceInfoTab = function (invoiceObj) {
                    vm.fnCheckUncheckHeader(invoiceObj);
                };

                vm.fnGetInvoice = function (invoiceObj, invoiceArr) {
                    angular.forEach(invoiceArr, function (invoice) {
                        invoice.isCheck = false;
                    });
                    invoiceObj.isCheck = true;
                    vm.selectedInvoicesArr = [invoiceObj]; // Assign array with single invoice object
                    vm.fnGetInvoiceDetails(invoiceObj);
                };

                vm.fnGetInvoiceDetails = function (invoiceObj) {
                    vm.isInvoiceDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when invoice is selected
                        vm.selectedInvoiceObj = invoiceObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.invoice', {
                                selectedId: vm.selectedInvoiceObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedInvoiceObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isInvoiceDetailsLoaded = true;
                        } else {
                            $state.go('main.invoice', {selectedId: vm.selectedInvoiceObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedInvoiceObj.id;
                            vm.isInvoiceDetailsLoaded = true;
                        }
                    });
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.businessName = parsedData.businessName || parsedItem.business_name;
                                parsedItem.businessEmail = parsedData.businessEmail || parsedItem.business_email;
                                parsedItem.status = parsedData.status || parsedItem.status;

                                // Handle amounts - ensure they are numbers
                                if (angular.isDefined(parsedData.total)) {
                                    parsedItem.total = parseInt(parsedData.total) || 0;
                                } else if (angular.isDefined(parsedItem.total)) {
                                    parsedItem.total = parseInt(parsedItem.total) || 0;
                                }

                                if (angular.isDefined(parsedData.amountDue)) {
                                    parsedItem.amountDue = parseInt(parsedData.amountDue) || 0;
                                } else if (angular.isDefined(parsedItem.amount_due)) {
                                    parsedItem.amountDue = parseInt(parsedItem.amount_due) || 0;
                                }

                                // Handle timestamps
                                if (parsedData.dueDate) {
                                    parsedItem.dueDate = parseInt(parsedData.dueDate);
                                } else if (parsedItem.due_date) {
                                    parsedItem.dueDate = parseInt(parsedItem.due_date);
                                }

                                // Merge remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing invoice data:', e);
                                return parsedItem;
                            }
                        }

                        // If no data field exists, still ensure basic fields are parsed
                        if (angular.isDefined(parsedItem.total)) {
                            parsedItem.total = parseInt(parsedItem.total) || 0;
                        }
                        if (angular.isDefined(parsedItem.amount_due)) {
                            parsedItem.amountDue = parseInt(parsedItem.amount_due) || 0;
                        }
                        if (angular.isDefined(parsedItem.due_date)) {
                            parsedItem.dueDate = parseInt(parsedItem.due_date);
                        }

                        return parsedItem;
                    });
                }

// Update the fnGetInvoices function to use the parser
                vm.fnGetInvoices = function (input, isFirst) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            // Parse the data first
                            var parsedData = parsePostgresData(res.data);

                            // Format dates after parsing
                            parsedData.map(function (obj) {
                                obj.dueDate = moment.unix(obj.dueDate).format("DD MMM YYYY");
                            });

                            vm.invoiceResponse = _.cloneDeepWith(angular.extend({}, res, {
                                data: parsedData
                            }));

                            if (isFirst) {
                                if (vm.invoiceResponse.data && vm.invoiceResponse.data.length) {
                                    vm.totalItems = vm.invoiceResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }

                            if (input.isNeedDataReverse) {
                                vm.invoiceResponse.data.reverse();
                            }

                            vm.invoiceArr = vm.invoiceResponse.data;

                            if ($state.current.name === 'main.invoice') {
                                $timeout(function () {
                                    $state.go('main.invoice', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10);
                            }

                            if ($stateParams.selectedId) {
                                var invoiceData = _.find(vm.invoiceArr, {"id": $stateParams.selectedId});
                                if (invoiceData) {
                                    vm.fnCheckUncheckHeader(invoiceData);
                                }
                            }

                            vm.isRefresh = false;
                            vm.isInvoicesloading = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isInvoicesloading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.invoice', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('invoice') && !DB.fnGet('sudo')) {
                            //vm.fnUpdateUserData(perPage);
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isInvoicesloading = true;
                    vm.selectedInvoicesArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM billing_invoices';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM billing_invoices';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM billing_invoices';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_invoices';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetInvoices(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.invoiceArr);
                        vm.previousPage = page;
                        vm.fnGetInvoices(input, false);
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateInvoiceProfileData();
                        });
                    }
                };

                vm.fnGetInvoiceStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'InvoiceStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowInvoiceStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'InvoiceStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowInvoiceStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("invoiceDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.invoiceArr, function (invoiceObj) {
                        if (invoiceObj.id === vm.selectedInvoiceObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedInvoiceObj[key] = val;
                                invoiceObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('billing', 'invoice', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.invoice", tempArr, {notify: false});
                    } else {
                        if (angular.isUndefined($stateParams.filter)) {
                            var inputObj = [{
                                id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                selectedField: "businessName",
                                displaySelectedField: "Company Name",
                                selectedFilter: {operatorName: "=", operator: "="},
                                searchText: currentAccountState.name,
                                displaySearchText: currentAccountState.name
                            }];
                            $state.go("main.invoice", {filter: angular.toJson(inputObj), sort: 'dueDate desc'}, {notify: false});
                            $stateParams.filter = angular.toJson(inputObj);
                            $stateParams.sort = 'dueDate desc';
                        }
                    }
                };

                vm.fnInitInvoice = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('billing', 'invoice', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnUpdateInvoiceProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('billing', 'invoice', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getInvoiceCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.invoiceArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (invoiceObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = invoiceObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var invoicesArrCp = _.cloneDeepWith(vm.invoiceArr);
                    var tempData = _.map(invoicesArrCp, function (tempObj) {
                        // delete tempObj.securityRoleIds;
                        // delete tempObj.userGroupIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Invoices");
                    XLSX.writeFile(wb, "invoices.xlsx");
                };

                /*Tab: Start*/

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindinvoice = _.find(vm.invoiceArr, {id: tab.id});
                            if (isFindinvoice) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedInvoicesArr = [];
                                vm.selectedInvoiceObj = {};
                                vm.fnCheckUncheckHeader(isFindinvoice);
                            }
                        } else {
                            $state.go('main.invoice', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isShowInvoiceStats = tab.id === "InvoiceStats";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isShowInvoiceStats = tab.id === "InvoiceStats";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "WidgetEditor" || tab.id === "InvoiceStats" || tab.id === "Create Issue") {
                        $state.go('main.invoice', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.invoice', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnUpdateInvoiceProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnGetInvoiceStatusBg = function (status) {
                    var statusClass = '';
                    switch (status.toLowerCase()) {
                        case 'paid':
                            statusClass = 'statusPaid';
                            break;
                        case 'open':
                            statusClass = 'statusOpen';
                            break;
                        case 'draft':
                            statusClass = 'statusDraft';
                            break;
                        case 'void':
                            statusClass = 'statusVoid';
                            break;
                        case 'uncollectible':
                            statusClass = 'statusUncollectible';
                            break;
                    }
                    return statusClass;
                };

                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightBillingInvoiceChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var invoiceKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.invoice') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            }
                        }
                    }
                };

                var invoiceKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.invoice') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', invoiceKeyDownEventHandler);
                document.addEventListener('keyup', invoiceKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', invoiceKeyDownEventHandler);
                    document.removeEventListener('keyup', invoiceKeyUpEventHandler);
                });

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DiscountCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, highed, moment,
                      WidgetsListService, PaginationQueryService, UserProfileService,
                      DiscountFactory, QueryFactory, amaran, ColorService, swal, microSpinner, DB, XLSX,
                      Authenticate, IconService, PermissionsService, LastPageService, AvatarService,
                      PaginationService, FedSudoUserService, postActionModelIcon, postActionModelMessage,
                      jsonToCsvConvertService, copyService, $log) {
                var vm = this;
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateDiscountProfileData();
                    }
                };
                vm.isShowDashboard = false;

                //Search Variables
                vm.isRefreshData = true;
                vm.statusFieldArr = [
                    {name: 'DRAFT', displayName: 'DRAFT'},
                    {name: 'OPEN', displayName: 'OPEN'},
                    {name: 'PAID', displayName: 'PAID'},
                    {name: 'UNCOLLECTIBLE', displayName: 'UNCOLLECTIBLE'},
                    {name: 'VOID', displayName: 'VOID'}
                ];
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Account ID",
                        name: "accountId",
                        regexp: "^cu(\\w{6})$",
                        errorMessage: "The Id does not satisfy the required format. cuxxxxxx"
                    }, {
                        displayName: "Product ID",
                        name: "productId",
                        regexp: "^(\\w{8})$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx"
                    }, {
                        displayName: "Percentage",
                        name: "percentage",
                        regexp: "",
                        errorMessage: ""
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'id', displayName: 'Id'},
                    {name: 'AccountId', displayName: 'Account Id'},
                    {name: 'productId', displayName: 'Product Id'},
                    {name: 'percentage', displayName: 'Percentage'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Discount Variables
                vm.isDiscountsloading = false;
                vm.discountArr = [];
                vm.selectedDiscountsArr = [];
                vm.selectedDiscountObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.isShowDiscountStats = false;

                vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
                vm.accountId = vm.authUserObj.id.split("-")[0];

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.discountResponse = [];

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.fnSetTableHeight();
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateDiscountProfileData('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#discountTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isDiscountsloading = true;
                    vm.selectedDiscountsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM billing_discounts';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_discounts';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetDiscounts(input, true);
                };
                /*END: Search*/

                vm.fnCheckUncheckHeader = function (discountObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_DISCOUNT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.discountArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === discountObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected discount array*/
                        var isValueFind = _.find(vm.selectedDiscountsArr, {'id': discountObj.id});
                        if (!isValueFind) {
                            vm.selectedDiscountsArr.push(discountObj);
                            var isTabExist = _.find(vm.tabs, {'id': discountObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: discountObj.id,
                                    title: discountObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateDiscountProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedDiscountsArr, function (obj) {
                                return discountObj.id === obj.id;
                            });
                        }
                        if (vm.selectedDiscountsArr.length === 1) {
                            vm.fnGetDiscountDetails(vm.selectedDiscountsArr[0])
                        } else {
                            $state.go('main.discount', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.discountArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDiscountsArr = angular.copy(vm.discountArr);
                    } else {
                        vm.selectedDiscountsArr = [];
                    }
                    $state.go('main.discount', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenDiscountInfoTab = function (discountObj) {
                    vm.fnCheckUncheckHeader(discountObj);
                };

                vm.fnGetDiscount = function (discountObj, discountArr) {
                    angular.forEach(discountArr, function (discount) {
                        discount.isCheck = false;
                    });
                    discountObj.isCheck = true;
                    vm.selectedDiscountsArr = [discountObj]; // Assign array with single discount object
                    vm.fnGetDiscountDetails(discountObj);
                };

                vm.fnGetDiscountDetails = function (discountObj) {
                    vm.isDiscountDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when discount is selected
                        vm.selectedDiscountObj = discountObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.discount', {
                                selectedId: vm.selectedDiscountObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedDiscountObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isDiscountDetailsLoaded = true;
                        } else {
                            $state.go('main.discount', {selectedId: vm.selectedDiscountObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedDiscountObj.id;
                            vm.isDiscountDetailsLoaded = true;
                        }
                    });
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedItem.description || parsedData.description;
                                parsedItem.accountId = parsedData.accountId || parsedItem.account_id || parsedItem.accountId;
                                parsedItem.productId = parsedData.productId || parsedItem.product_id || parsedItem.productId;

                                // Handle percentage - ensure it's a number
                                if (angular.isDefined(parsedData.percentage)) {
                                    parsedItem.percentage = parseFloat(parsedData.percentage) || 0;
                                } else if (angular.isDefined(parsedItem.percentage)) {
                                    parsedItem.percentage = parseFloat(parsedItem.percentage) || 0;
                                }

                                // Handle timestamps
                                if (parsedData.dueDate) {
                                    parsedItem.dueDate = parseInt(parsedData.dueDate);
                                } else if (parsedItem.due_date) {
                                    parsedItem.dueDate = parseInt(parsedItem.due_date);
                                }

                                // Merge any remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing discount data:', e);
                                return parsedItem;
                            }
                        }

                        // If no data field exists, still ensure basic fields are parsed
                        if (angular.isDefined(parsedItem.percentage)) {
                            parsedItem.percentage = parseFloat(parsedItem.percentage) || 0;
                        }
                        if (angular.isDefined(parsedItem.due_date)) {
                            parsedItem.dueDate = parseInt(parsedItem.due_date);
                        }

                        return parsedItem;
                    });
                }

// Update the fnGetDiscounts function to use the parser
                vm.fnGetDiscounts = function (input, isFirst) {
                    QueryFactory.executeQuery(input)
                        .then(function (res) { // Success block
                            // Parse the data first
                            var parsedData = parsePostgresData(res.data);

                            // Format dates after parsing
                            parsedData.map(function (obj) {
                                obj.dueDate = moment.unix(obj.dueDate).format("DD MMM YYYY");
                            });

                            vm.discountResponse = _.cloneDeepWith(angular.extend({}, res, {
                                data: parsedData
                            }));

                            if (isFirst) {
                                if (vm.discountResponse.data && vm.discountResponse.data.length) {
                                    vm.totalItems = vm.discountResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }

                            if (input.isNeedDataReverse) {
                                vm.discountResponse.data.reverse();
                            }

                            vm.discountArr = vm.discountResponse.data;

                            if ($stateParams.selectedId) {
                                var discountData = _.find(vm.discountArr, {"id": $stateParams.selectedId});
                                if (discountData) {
                                    vm.fnCheckUncheckHeader(discountData);
                                }
                            }

                            if ($state.current.name === 'main.discount') {
                                $timeout(function () {
                                    $state.go('main.discount', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10);
                            }

                            vm.isRefresh = false;
                            vm.isDiscountsloading = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDiscountsloading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.discount', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            //vm.fnUpdateUserData(perPage);
                            UserProfileService.fnUpdateDiscountProfileData('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isDiscountsloading = true;
                    vm.selectedDiscountsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM billing_discounts';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM billing_discounts';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM billing_invoices';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM billing_invoices';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetDiscounts(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.discountArr);
                        vm.previousPage = page;
                        vm.fnGetDiscounts(input, false);
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateDiscountProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetDiscountStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'DiscountStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDiscountStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'DiscountStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDiscountStats = true;
                            vm.fnUpdateDiscountProfileData();
                        });
                    }
                };

                $scope.$on("discountDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.discountArr, function (discountObj) {
                        if (discountObj.id === vm.selectedDiscountObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDiscountObj[key] = val;
                                discountObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnInitDiscount = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('billing', 'discount', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnUpdateDiscountProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('billing', 'discount', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getUserCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.discountArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (discountObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = discountObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var discountsArrCp = _.cloneDeepWith(vm.discountArr);
                    var tempData = _.map(discountsArrCp, function (tempObj) {
                        // delete tempObj.securityRoleIds;
                        // delete tempObj.discountGroupIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Discounts");
                    XLSX.writeFile(wb, "discounts.xlsx");
                };

                /*Tab: Start*/

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFinddiscount = _.find(vm.discountArr, {id: tab.id});
                            if (isFinddiscount) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedDiscountsArr = [];
                                // vm.selectedUserGroupObj = {};
                                vm.fnCheckUncheckHeader(isFinddiscount);
                            }
                        } else {
                            $state.go('main.discount', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isCreate = tab.id === "Create Discount";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        vm.isShowDiscountStats = tab.id === "DiscountStats";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.selectedDiscountsArr = [];
                                vm.selectedDiscountObj = {};
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Discount";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    vm.isShowDiscountStats = tab.id === "DiscountStats";
                    if (tab.id === "Create Discount" || tab.id === "WidgetEditor" || tab.id === "Create Issue" || tab.id === "DiscountStats") {
                        $state.go('main.discount', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.discount', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnUpdateDiscountProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightBillingDiscountChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedDiscountsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Discount'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Discount',
                                title: 'Create Discount',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateDiscountProfileData();
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on("discountAdded", function () {
                    vm.fnRemoveTab('Create Discount');
                });

                $scope.$on("DiscountDeleted", function (evt, data) {
                    vm.selectedDiscountObj = null;
                    vm.selectedDiscountsArr = [];
                    vm.discountArr = vm.discountArr.filter(function (discountObj) {
                        return (discountObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.discount', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("DiscountDetailsChanged", function (evt, data) {
                    var resetCopy = _.cloneDeepWith(data);
                    angular.forEach(vm.discountArr, function (discountObj) {
                        if (discountObj.id === vm.selectedDiscountObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDiscountObj[key] = val;
                                discountObj[key] = val;
                            });
                        }
                    });
                });


                var discountKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.discount') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_DISCOUNT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            }
                        }
                    }
                };

                var discountKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.discount') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', discountKeyDownEventHandler);
                document.addEventListener('keyup', discountKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', discountKeyDownEventHandler);
                    document.removeEventListener('keyup', discountKeyUpEventHandler);
                });

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('CreditTokensCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, moment, amaran, swal,
                      microSpinner, WidgetsListService, PaginationQueryService, QueryFactory, UserProfileService,
                      DB, XLSX, Authenticate, LastPageService, PermissionsService,
                      jsonToCsvConvertService, FedSudoUserService, BatchFactory, PaginationService,
                      UserFactory, CreditTokenFactory, postActionModelIcon, postActionModelMessage, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //CreditTokens Variables
                vm.isCreditTokensLoading = false;
                vm.creditTokensArr = [];
                vm.selectedCreditTokensArr = [];
                vm.selectedCreditTokenObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.isShowCreditTokenStats = false;
                var loginUser = DB.fnGet('loginUser');
                vm.accountId = DB.fnGet('federation') ? DB.fnGet('federation').sessionObj.accountId : loginUser.id.split("-")[0];

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.creditTokenResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.isCreate = false;

                /*Start: Context Menu*/
                vm.resetEditCreditTokenObj = {};

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    vm.fnSetTableHeight();
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('billing', 'creditToken', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isCreditTokensLoading = true;
                    vm.selectedCreditTokensArr = [];
                    vm.isAllChecked = false;
                    if ($stateParams.type) {
                        vm.type = $stateParams.type
                    } else {
                        vm.type = 'claimed';
                    }
                    if (vm.type === 'unclaimed' && vm.accountId !== 'cu000000') {
                        vm.type = 'claimed';
                    }
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var tableName = vm.type === 'claimed' ? 'billing_claimed_credit_tokens' : 'billing_unclaimed_credit_tokens';
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM ' + tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + tableName;
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetCreditTokens(input, true);
                };

                vm.fnHideShowUnclaimedClaimedTokens = function () {
                    $state.go('main.credit_token', {
                        selectedId: '',
                        selectedDetailsTab: '',
                        filter: '',
                        type: vm.type === 'claimed' ? 'unclaimed' : 'claimed'
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    delete $stateParams.filter;
                    $stateParams.type = vm.type === 'claimed' ? 'unclaimed' : 'claimed';
                    vm.tabs = [
                        {
                            title: 'Overview',
                            tabIndex: 1
                        }
                    ];
                    vm.fnReload();
                };
                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.creditTokensArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedCreditTokensArr = [];
                                vm.selectedCreditTokenObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.credit_token', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isCreate = tab.id === "Create Credit Token";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        vm.isShowCreditTokenStats = tab.id === "CreditTokenStats";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Credit Token";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    vm.isShowCreditTokenStats = tab.id === "CreditTokenStats";
                    if (tab.id === "Create Credit Token" || tab.id === "WidgetEditor" || tab.id === "Create Issue" || tab.id === "CreditTokenStats") {
                        $state.go('main.credit_token', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.credit_token', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnUpdateCreditTokenProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#creditTokenTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (creditTokenObj, fromList, isCalledForUnclaimed) {
                    var flag = isCalledForUnclaimed ? vm.permissionObj.DESCRIBE_UNCLAIMED_CREDIT_TOKEN :
                        vm.permissionObj.DESCRIBE_CLAIMED_CREDIT_TOKEN;
                    if (flag) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.creditTokensArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === creditTokenObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected creditToken array*/
                        var isValueFind = _.find(vm.selectedCreditTokensArr, {'id': creditTokenObj.id});
                        if (!isValueFind) {
                            vm.selectedCreditTokensArr.push(creditTokenObj);
                            var isTabExist = _.find(vm.tabs, {'id': creditTokenObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: creditTokenObj.id,
                                    title: creditTokenObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateCreditTokenProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedCreditTokensArr, function (obj) {
                                return creditTokenObj.id === obj.id;
                            });
                        }
                        if (vm.selectedCreditTokensArr.length === 1) {
                            vm.fnGetCreditTokenDetails(vm.selectedCreditTokensArr[0])
                        } else {
                            $state.go('main.credit_token', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.creditTokensArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedCreditTokensArr = angular.copy(vm.creditTokensArr);
                    } else {
                        vm.selectedCreditTokensArr = [];
                    }
                    $state.go('main.credit_token', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedCreditTokensArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Credit Token'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Credit Token',
                                title: 'Create Credit Token',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateCreditTokenProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.credit_token', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isCreditTokensLoading = true;
                    vm.selectedCreditTokensArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var tableName = vm.type === 'claimed' ? 'billing_claimed_credit_tokens' : 'billing_unclaimed_credit_tokens';
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM ' + tableName;
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM ' + tableName;
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM ' + tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM ' + tableName;
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetCreditTokens(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.creditTokensArr);
                        vm.previousPage = page;
                        vm.fnGetCreditTokens(input, false);
                    }
                };

                vm.fnOpenCreditTokenInfoTab = function (creditTokenObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(creditTokenObj);
                };

                vm.fnGetCreditToken = function (creditTokenObj, creditTokensArr) {
                    angular.forEach(creditTokensArr, function (creditToken) {
                        creditToken.isCheck = false;
                    });
                    creditTokenObj.isCheck = true;
                    vm.selectedCreditTokensArr = [creditTokenObj]; // Assign array with single CreditToken object
                    vm.fnGetCreditTokenDetails(creditTokenObj);
                };

                vm.fnGetCreditTokenDetails = function (creditTokenObj) {
                    vm.isCreditTokenDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when creditToken is selected
                        vm.selectedCreditTokenObj = creditTokenObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.credit_token', {
                                selectedId: vm.selectedCreditTokenObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedCreditTokenObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isCreditTokenDetailsLoaded = true;
                        } else {
                            $state.go('main.credit_token', {selectedId: vm.selectedCreditTokenObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedCreditTokenObj.id;
                            vm.isCreditTokenDetailsLoaded = true;
                        }
                    })
                };

                // In the controller where vm is defined
                vm.fnGetCreditTokens = function (inputObj, isFirst) {
                    if (vm.type === 'claimed') {
                        QueryFactory.executeQuery(inputObj)
                            .then(function (res) { // Success block
                                // Parse the response data
                                var parsedData = parsePostgresData(res.data);
                                vm.creditTokenResponse = _.cloneDeepWith(angular.extend({}, res, {
                                    data: parsedData
                                }));

                                if (isFirst) {
                                    if (vm.creditTokenResponse.data && vm.creditTokenResponse.data.length) {
                                        vm.totalItems = vm.creditTokenResponse.data[0].totalItems;
                                    } else {
                                        vm.totalItems = 0;
                                    }
                                    vm.currentPage = 1;
                                }

                                if (inputObj.isNeedDataReverse) {
                                    vm.creditTokenResponse.data.reverse();
                                }

                                vm.creditTokensArr = vm.creditTokenResponse.data;

                                if ($stateParams.selectedId) {
                                    var creditTokenData = _.find(vm.creditTokensArr, {"id": $stateParams.selectedId});
                                    if (creditTokenData) {
                                        vm.fnCheckUncheckHeader(creditTokenData)
                                    }
                                } else if ($stateParams.tokenId && vm.permissionObj.CLAIM_UNCLAIMED_CREDIT_TOKEN) {
                                    vm.fnClaimCredit($stateParams.tokenId)
                                }

                                if ($state.current.name === 'main.credit_token') {
                                    $state.go('main.credit_token', {
                                        openCreateView: '',
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        type: vm.type,
                                        tokenId: ''
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    $stateParams.type = vm.type;
                                    $stateParams.tokenId = '';
                                    delete $stateParams.openCreateView;
                                }

                                vm.isCreditTokensLoading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isCreditTokensLoading = false;
                                vm.isRefresh = false;
                            });
                    } else {
                        QueryFactory.executeQuery(inputObj)
                            .then(function (res) { // Success block
                                // Parse the response data
                                var parsedData = parsePostgresData(res.data);
                                vm.creditTokenResponse = _.cloneDeepWith(angular.extend({}, res, {
                                    data: parsedData
                                }));

                                if (isFirst) {
                                    if (vm.creditTokenResponse.data && vm.creditTokenResponse.data.length) {
                                        vm.totalItems = vm.creditTokenResponse.data[0].totalItems;
                                    } else {
                                        vm.totalItems = 0;
                                    }
                                    vm.currentPage = 1;
                                }

                                if (inputObj.isNeedDataReverse) {
                                    vm.creditTokenResponse.data.reverse();
                                }

                                vm.creditTokensArr = vm.creditTokenResponse.data;

                                if ($stateParams.selectedId) {
                                    var creditTokenData = _.find(vm.creditTokensArr, {"id": $stateParams.selectedId});
                                    if (creditTokenData) {
                                        vm.fnCheckUncheckHeader(creditTokenData)
                                    }
                                } else if ($stateParams.tokenId && vm.permissionObj.CLAIM_UNCLAIMED_CREDIT_TOKEN) {
                                    vm.fnClaimCredit($stateParams.tokenId)
                                }

                                if ($state.current.name === 'main.credit_token') {
                                    $state.go('main.credit_token', {
                                        openCreateView: '',
                                        page: vm.currentPage,
                                        perPage: vm.perPage,
                                        type: vm.type,
                                        tokenId: ''
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                    $stateParams.type = vm.type;
                                    $stateParams.tokenId = '';
                                    delete $stateParams.openCreateView;
                                }

                                vm.isCreditTokensLoading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    vm.fnSetTableHeight();
                                });
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isCreditTokensLoading = false;
                                vm.isRefresh = false;
                            });
                    }
                };

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Parse the data field if it exists and is a string
                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map basic fields
                                parsedItem.id = parsedItem.id || parsedData.id;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedItem.description || parsedData.description;

                                // Handle amounts - ensure they are numbers
                                // For unclaimed tokens
                                if (angular.isDefined(parsedData.amount)) {
                                    parsedItem.amount = parseInt(parsedData.amount) || 0;
                                } else if (angular.isDefined(parsedItem.amount)) {
                                    parsedItem.amount = parseInt(parsedItem.amount) || 0;
                                }

                                // For claimed tokens
                                if (angular.isDefined(parsedData.amountClaimed)) {
                                    parsedItem.amountClaimed = parseInt(parsedData.amountClaimed) || 0;
                                } else if (angular.isDefined(parsedItem.amount_claimed)) {
                                    parsedItem.amountClaimed = parseInt(parsedItem.amount_claimed) || 0;
                                }

                                if (angular.isDefined(parsedData.amountUsed)) {
                                    parsedItem.amountUsed = parseInt(parsedData.amountUsed) || 0;
                                } else if (angular.isDefined(parsedItem.amount_used)) {
                                    parsedItem.amountUsed = parseInt(parsedItem.amount_used) || 0;
                                }

                                if (angular.isDefined(parsedData.amountRemaining)) {
                                    parsedItem.amountRemaining = parseInt(parsedData.amountRemaining) || 0;
                                } else if (angular.isDefined(parsedItem.amount_remaining)) {
                                    parsedItem.amountRemaining = parseInt(parsedItem.amount_remaining) || 0;
                                }

                                // Handle timestamps
                                if (parsedData.createdAt) {
                                    parsedItem.createdAt = parseInt(parsedData.createdAt);
                                } else if (parsedItem.created_at) {
                                    parsedItem.createdAt = parseInt(parsedItem.created_at);
                                }

                                if (parsedData.expiresAt) {
                                    parsedItem.expiresAt = parseInt(parsedData.expiresAt);
                                } else if (parsedItem.expires_at) {
                                    parsedItem.expiresAt = parseInt(parsedItem.expires_at);
                                }

                                // Format dates for display
                                parsedItem.startsDate = parsedItem.createdAt ?
                                    moment.unix(parsedItem.createdAt).format("DD/MM/YYYY HH:mm:ss") : '-';
                                parsedItem.expiresDate = parsedItem.expiresAt ?
                                    moment.unix(parsedItem.expiresAt).format("DD/MM/YYYY HH:mm:ss") : '-';

                                // Merge remaining fields
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing credit token data:', e);
                                return parsedItem;
                            }
                        }

                        // If no data field exists, still ensure amounts are numbers
                        // For unclaimed tokens
                        if (angular.isDefined(parsedItem.amount)) {
                            parsedItem.amount = parseInt(parsedItem.amount) || 0;
                        }

                        // For claimed tokens
                        if (angular.isDefined(parsedItem.amount_claimed)) {
                            parsedItem.amountClaimed = parseInt(parsedItem.amount_claimed) || 0;
                        } else if (angular.isDefined(parsedItem.amountClaimed)) {
                            parsedItem.amountClaimed = parseInt(parsedItem.amountClaimed) || 0;
                        }

                        if (angular.isDefined(parsedItem.amount_used)) {
                            parsedItem.amountUsed = parseInt(parsedItem.amount_used) || 0;
                        } else if (angular.isDefined(parsedItem.amountUsed)) {
                            parsedItem.amountUsed = parseInt(parsedItem.amountUsed) || 0;
                        }

                        if (angular.isDefined(parsedItem.amount_remaining)) {
                            parsedItem.amountRemaining = parseInt(parsedItem.amount_remaining) || 0;
                        } else if (angular.isDefined(parsedItem.amountRemaining)) {
                            parsedItem.amountRemaining = parseInt(parsedItem.amountRemaining) || 0;
                        }

                        // Handle timestamps even if no data field
                        if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parseInt(parsedItem.created_at);
                            parsedItem.startsDate = moment.unix(parsedItem.createdAt).format("DD/MM/YYYY HH:mm:ss");
                        }

                        if (angular.isDefined(parsedItem.expires_at)) {
                            parsedItem.expiresAt = parseInt(parsedItem.expires_at);
                            parsedItem.expiresDate = moment.unix(parsedItem.expiresAt).format("DD/MM/YYYY HH:mm:ss");
                        }

                        return parsedItem;
                    });
                }
                /*END: TABLE*/

                vm.fnSendCreditToken = function (creditTokenId) {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/billing/credit_token/modal/sendCreditToken/sendCreditToken.html',
                        size: 'md',
                        controller: 'sendCreditTokenCtrl as sendCreditToken',
                        resolve: {
                            creditTokenId: function () {
                                return creditTokenId;
                            }
                        }
                    });

                    modalInstance.result.then(function () {
                    }, function () {
                    });
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateCreditTokenProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetCreditTokenStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'CreditTokenStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowCreditTokenStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'CreditTokenStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowCreditTokenStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                $scope.$on("CreditTokenDeleted", function (evt, data) {
                    vm.selectedCreditTokenObj = null;
                    vm.selectedCreditTokensArr = [];
                    vm.creditTokensArr = vm.creditTokensArr.filter(function (creditTokenObj) {
                        return (creditTokenObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.credit_token', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("CreditTokenDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.creditTokensArr, function (creditTokenObj) {
                        if (creditTokenObj.id === vm.selectedCreditTokenObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedCreditTokenObj[key] = val;
                                creditTokenObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("creditTokenAdded", function () {
                    vm.fnRemoveTab('Create Credit Token');
                });

                vm.fnDeleteMultipleCreditTokens = function (selectedCreditTokensArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedCreditTokensArr, function (selectedCreditToken, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + selectedCreditToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + selectedCreditToken.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected CreditTokens?",
                            text: "You are about to permanently delete the selected creditTokens.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedCreditTokensArr, function (selectedCreditToken) {
                                    angular.forEach(vm.creditTokensArr, function (creditTokenObj, index) {
                                        if (selectedCreditToken.id === creditTokenObj.id) {
                                            vm.creditTokensArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedCreditTokensArr.length;
                                vm.selectedCreditTokenObj = null;
                                vm.selectedCreditTokensArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedCreditTokensArr, function (selectedCreditToken) {
                                    angular.forEach(vm.creditTokensArr, function (creditTokenObj, index) {
                                        if (selectedCreditToken.id === creditTokenObj.id) {
                                            vm.creditTokensArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedCreditTokensArr.length;
                                vm.selectedCreditTokenObj = null;
                                vm.selectedCreditTokensArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('billing', 'creditToken', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.credit_token", tempArr, {notify: false});
                    }
                };

                vm.fnInitCreditTokens = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("billing");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    /*var tempValue = UserProfileService.fnGetUserProfileObj('access', 'creditToken', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }*/
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getCreditTokenCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.creditTokensArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.creditTokensArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "CreditTokens");
                    XLSX.writeFile(wb, "users.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateCreditTokenProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('billing', 'creditToken', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnClaimCredit = function (token) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/billing/credit_token/modal/ClaimCredit/claimCredit.html',
                        size: 'md',
                        resolve: {
                            token: function () {
                                return token ? token : ''
                            }
                        },
                        controller: 'claimCreditCtrl as claimCredit'
                    });
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightBillingCreditTokenChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var creditTokenKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.credit_token') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_UNCLAIMED_CREDIT_TOKEN &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedCreditTokensArr.length > 1 &&
                                vm.permissionObj.DELETE_UNCLAIMED_CREDIT_TOKEN &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleCreditTokens(vm.selectedCreditTokensArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var creditTokenKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.credit_token') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', creditTokenKeyDownEventHandler);
                document.addEventListener('keyup', creditTokenKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', creditTokenKeyDownEventHandler);
                    document.removeEventListener('keyup', creditTokenKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('BusinessCtrl',
            function ($timeout, $window, DB, PermissionsService) {
                var vm = this;
                var loginUser = DB.fnGet("loginUser");
                vm.tabs = [{
                    title: 'Business Details',
                    tabIndex: 1,
                    templateUrl: 'app/billing/business/businessTab/businessDetails/businessDetails.html',
                    visible: (loginUser.administrator && loginUser.administrator === true) || (loginUser.billingManager && loginUser.billingManager === true)
                }];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTabHeight();
                });

                vm.fnSetTabHeight = function () {
                    if (angular.element(".content-container")[0]) {
                        var total = angular.element(".content-container")[0].offsetHeight;
                        var tabHeader = 42; // angular.element(".tab-container .nav-tabs")[0].offsetHeight;
                        var footer = 55; // angular.element(".tab-container .content-footer")[0].offsetHeight;
                        var finalHeight = total - (tabHeader + footer);
                        angular.element(".tabContent").css('height', finalHeight + 'px');
                    }
                };

                vm.fnInitBusiness = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('billing');
                    $timeout(function () {
                        vm.fnSetTabHeight();
                    })
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TrainerCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal,moment, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, ColorService, FedSudoUserService, UserFactory, BatchFactory, TrainerFactory,  postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedTrainerId = '';

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Status",
                        fieldName: "status"
                    }
                ];
                vm.filterQuery = "";

                //Trainers Variables
                vm.isTrainersLoading = false;
                vm.trainersArr = [];
                vm.selectedTrainersArr = [];
                vm.selectedTrainerObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isTrainersLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTrainersLoading = true;
                    vm.selectedTrainersArr = [];
                    vm.isAllChecked = false;
                    if(vm.trainerPermissionObj.List) {
                        vm.fnGetTrainers(inputObj);
                    } else {
                        vm.trainersArr = [];
                        vm.isTrainersLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.trainersArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTrainersArr = angular.copy(vm.trainersArr);
                    } else {
                        vm.selectedTrainersArr = [];
                    }
                    $state.go('main.trainer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenTrainerInfoTab = function (trainerObj){
                    vm.fnGetTrainer(trainerObj,vm.trainersArr);
                };

                vm.fnGetTrainer = function (trainerObj, trainersArr) {
                    angular.forEach(trainersArr, function (trainer) {
                        trainer.isCheck = false;
                    });
                    trainerObj.isCheck = true;
                    vm.selectedTrainersArr = [trainerObj]; // Assign array with single trainers object
                    vm.fnGetTrainerDetails(trainerObj);
                };

                vm.fnGetTrainerDetails = function (trainerObj) {
                    vm.isTrainerDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when trainer is selected
                        vm.selectedTrainerObj = trainerObj;
                        $state.go('main.trainer', {selectedId: vm.selectedTrainerObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedTrainerObj.id;
                        vm.isTrainerDetailsLoaded = true;
                    })
                };

                vm.fnCheckUncheckHeader = function (trainerObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.trainersArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === trainerObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected trainers array*/
                    var isValueFind = _.find(vm.selectedTrainersArr, {'id': trainerObj.id});
                    if (!isValueFind) {
                        vm.selectedTrainersArr.push(trainerObj)
                    } else {
                        _.remove(vm.selectedTrainersArr, function (obj) {
                            return trainerObj.id === obj.id;
                        });
                    }
                    if (vm.selectedTrainersArr.length === 1) {
                        vm.fnGetTrainerDetails(vm.selectedTrainersArr[0])
                    }else {
                        $state.go('main.trainer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleTrainers = function (selectedTrainersArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedTrainersArr, function (selectedTrainer, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/trainers/" + selectedTrainer.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/trainers/" + selectedTrainer.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected trainers?",
                            text: "You are about to permanently delete the selected trainers.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'trainer', appName: 'ai'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTrainersArr, function (selectedTrainer) {
                                    angular.forEach(vm.trainersArr, function (trainerObj, index) {
                                        if (selectedTrainer.id === trainerObj.id) {
                                            vm.trainersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTrainersArr.length;
                                vm.selectedTrainerObj = null;
                                vm.selectedTrainersArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTrainersArr, function (selectedTrainer) {
                                    angular.forEach(vm.trainersArr, function (trainerObj, index) {
                                        if (selectedTrainer.id === trainerObj.id) {
                                            vm.trainersArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTrainersArr.length;
                                vm.selectedTrainerObj = null;
                                vm.selectedTrainersArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetTrainers = function (inputObj) {
                    TrainerFactory.getTrainers(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.trainers;
                            res.map(function (obj) {
                                obj.trainingStartDate = moment.utc(obj.trainingStart).format("MM/DD/YYYY HH:mm:ss:SSS");
                                obj.trainingEndDate = moment.utc(obj.trainingEnd).format("MM/DD/YYYY HH:mm:ss:SSS");
                                var now  = obj.trainingEndDate;
                                var then = obj.trainingStartDate;
                                var ms = moment(now).diff(moment(then));
                                var d = moment.duration(ms);
                                obj.durations = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
                            });
                            vm.trainersArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if ($stateParams.selectedId) {
                                var trainerData = _.find(vm.trainersArr,{"id":$stateParams.selectedId});
                                if(trainerData){
                                    vm.fnGetTrainer(trainerData, vm.trainersArr);
                                }
                            }
                            if(addedTrainerId.length) {
                                vm.fnOpenPostCreateActionModal(addedTrainerId);
                                addedTrainerId = '';
                            }
                            if($state.current.name === 'main.trainer') {
                                $state.go('main.trainer', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }

                            vm.isTrainersLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTrainersLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.trainer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isTrainersLoading = true;
                    vm.selectedTrainersArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetTrainers(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.trainerSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "trainerSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.trainerSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnTrainersSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('trainerSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('trainerSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('trainerSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.trainerPermissionObj.List = false;
                    $timeout(function () {
                        vm.trainerPermissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCalledFromClone, isCalledForOpen) {
                    vm.selectedTrainersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if(isCalledFromClone) {
                        vm.isCreate = false;
                        $timeout(function () {
                            vm.isCreate = true;
                        })
                    } else if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnGetTrainerStatusIcon = function (status) {
                    var icon = "";
                    switch(status) {
                        case "PENDING":
                            icon = "fa-clock-o";
                            break;
                        case "IN_PROGRESS":
                            icon = "fa-hourglass-half";
                            break;
                        case "FAILED":
                            icon = "fa-times-circle";
                            break;
                        case "COMPLETED":
                            icon = "fa-check";
                            break;
                        case "DELETED":
                            icon = "fa-trash";
                            break;
                        case "STOPPING":
                            icon = "fa-close";
                            break;
                        case "STOPPED":
                            icon = "fa-ban";
                            break;
                        case "STARTED":
                            icon = "fa-gears";
                            break;
                        case "DOWNLOADING":
                            icon = "fa-download";
                            break;
                        case "TRAINING":
                            icon = "fa-empire";
                            break;
                        case "UPLOADING":
                            icon = "fa-upload";
                            break;
                    }
                    return icon;
                };

                vm.fnGetTrainerStatusIconColor = function (status) {
                    return ColorService.getTrainerStatusColor(status);
                };

                $scope.$on("trainerDeleted", function (evt, data) {
                    vm.selectedTrainerObj = null;
                    vm.selectedTrainersArr = [];
                    vm.trainersArr = vm.trainersArr.filter(function (trainerObj) {
                        return (trainerObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.trainer', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on('cloneTrainer', function (evt, data) {
                    DB.fnSet('clonedTrainerObj', data);
                    vm.fnHideShowCreateForm(true);
                });

                $scope.$on("trainerAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedTrainerId = '';
                    } else {
                        if (vm.trainerPermissionObj.List) {
                            addedTrainerId = data;
                        } else {
                            addedTrainerId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnInitTrainer = function () {
                    vm.trainerPermissionObj = PermissionsService.getPermissions("ai:trainer");
                    var sortData = FedSudoUserService.fnGetUserData('trainerSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var optionsArr = [{
                        faIcon: "fa-codepen",
                        subOptions: [{
                            displayText: "Create a new Model from created Trainer",
                            isModalRequired: true,
                            isVisible: PermissionsService.getPermissions('ai:model').Create
                        }, {
                            displayText: "Create a new Model",
                            isRedirect: true,
                            stateName: "main.model",
                            isVisible: PermissionsService.getPermissions('ai:model').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if(subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if(optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if(finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if(selectedOption.isRedirect) {
                                if(selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else if(selectedOption.isModalRequired) {
                                var trainerObj = _.find(vm.trainersArr,{"id": selectedId});
                                if(trainerObj){
                                    var modalInstance = $uibModal.open({
                                        backdrop: 'static',
                                        templateUrl: 'app/ai/trainer/modals/createMedalFromTrainer/createModelFromTrainer.html',
                                        size: 'lg',
                                        controller: 'createModelFromTrainerModalCtrl as createModel',
                                        resolve: {
                                            trainerObj: function () {
                                                return trainerObj;
                                            }
                                        }
                                    });

                                    modalInstance.result.then(function () {
                                        amaran.success('Model Created Successfully')
                                    }, function () {

                                    });
                                }
                            }
                        }, function () {});
                    }
                };

                var trainerKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.trainer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.trainerPermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(false, true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedTrainersArr.length > 1 && vm.trainerPermissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleTrainers(vm.selectedTrainersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var trainerKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.trainer') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', trainerKeyDownEventHandler);
                document.addEventListener('keyup', trainerKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', trainerKeyDownEventHandler);
                    document.removeEventListener('keyup', trainerKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ModelCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, moment, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory, ModelFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };
                var addedModelId = '';

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    },
                    {
                        fieldDisplayName: "AlgorithmId",
                        fieldName: "algorithmId"
                    }, {
                        fieldDisplayName: "ArtifactPath",
                        fieldName: "artifactPath"
                    }
                ];
                vm.filterQuery = "";

                //Models Variables
                vm.isModelsLoading = false;
                vm.modelsArr = [];
                vm.selectedModelsArr = [];
                vm.selectedModelObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditModelObj = {};

                vm.modelContextMenu = function (modelObj) {
                    if (Object.keys(vm.resetEditModelObj).length) {
                        var isFindModel = _.find(vm.modelsArr, {id: vm.resetEditModelObj.id});
                        if (isFindModel) {
                            vm.fnCancelModelEditMode(isFindModel);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            modelObj.isEditable = true;
                            vm.resetEditModelObj = angular.copy(modelObj);
                        }
                    }]
                };

                vm.fnCancelModelEditMode = function (modelObj, isSuccessCall) {
                    if (isSuccessCall) {
                        modelObj.name = angular.copy(modelObj.name);
                        modelObj.description = angular.copy(modelObj.description);
                        modelObj.isEditable = false;
                        vm.resetEditModelObj = {};
                    } else {
                        modelObj.name = angular.copy(vm.resetEditModelObj.name);
                        modelObj.description = angular.copy(vm.resetEditModelObj.description);
                        modelObj.isEditable = false;
                        vm.resetEditModelObj = {};
                    }
                };

                vm.fnSaveModelInfo = function (modelObj) {
                    modelObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        modelId: modelObj.id
                    };
                    inputObj.body = {
                        name: modelObj.name,
                        description: angular.isUndefined(modelObj.description)?'':modelObj.description
                    };
                    ModelFactory.modifyModel(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.modelsArr, function (modelObj) {
                                if (Object.keys(vm.selectedModelObj).length) {
                                    if (modelObj.id === vm.selectedModelObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedModelObj[key] = val;
                                            modelObj[key] = val;
                                        });
                                    }
                                }
                                if (modelObj.id === resetCopy.id) {
                                    modelObj.name = resetCopy.name;
                                    modelObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelModelEditMode(modelObj, true);
                            amaran.success("Model Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelModelEditMode(modelObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isModelsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isModelsLoading = true;
                    vm.selectedModelsArr = [];
                    vm.isAllChecked = false;
                    if (vm.modelPermissionObj.List) {
                        vm.fnGetModels(inputObj);
                    } else {
                        vm.modelsArr = [];
                        vm.isModelsLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.modelsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedModelsArr = angular.copy(vm.modelsArr);
                    } else {
                        vm.selectedModelsArr = [];
                    }
                    $state.go('main.model', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenAiModelInfoTab = function(modelObj){
                    vm.fnGetModel(modelObj,vm.modelsArr);
                };

                vm.fnGetModel = function (modelObj, modelsArr) {
                    angular.forEach(modelsArr, function (model) {
                        model.isCheck = false;
                    });
                    modelObj.isCheck = true;
                    vm.selectedModelsArr = [modelObj];
                    vm.fnGetModelDetails(modelObj);
                };

                vm.fnGetModelDetails = function (modelObj) {
                    vm.isModelDetailsLoaded = false;
                    $timeout(function () {
                        vm.selectedModelObj = modelObj;
                        $state.go('main.model', {selectedId: vm.selectedModelObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedModelObj.id;
                        vm.isModelDetailsLoaded = true;
                    })
                };

                vm.fnCheckUncheckHeader = function (modelObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.modelsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === modelObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    var isValueFind = _.find(vm.selectedModelsArr, {'id': modelObj.id});
                    if (!isValueFind) {
                        vm.selectedModelsArr.push(modelObj)
                    } else {
                        _.remove(vm.selectedModelsArr, function (obj) {
                            return modelObj.id === obj.id;
                        });
                    }
                    if (vm.selectedModelsArr.length === 1) {
                        vm.fnGetModelDetails(vm.selectedModelsArr[0])
                    }else {
                        $state.go('main.model', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleModels = function (selectedModelsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedModelsArr, function (selectedModel, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/models/" + selectedModel.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/models/" + selectedModel.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected models?",
                            text: "You are about to permanently delete the selected models.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'model',
                        appName: 'ai'
                    })
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedModelsArr, function (selectedModel) {
                                    angular.forEach(vm.modelsArr, function (modelObj, index) {
                                        if (selectedModel.id === modelObj.id) {
                                            vm.modelsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedModelsArr.length;
                                vm.selectedModelObj = null;
                                vm.selectedModelsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedModelsArr, function (selectedModel) {
                                    angular.forEach(vm.modelsArr, function (modelObj, index) {
                                        if (selectedModel.id === modelObj.id) {
                                            vm.modelsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedModelsArr.length;
                                vm.selectedModelObj = null;
                                vm.selectedModelsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetModels = function (inputObj) {
                    ModelFactory.getModels(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.models;
                            res.map(function (obj) {
                                if (angular.isUndefined(obj.description)) {
                                    obj.description = '';
                                }
                            });
                            vm.modelsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                    $stateParams.openCreateView === true)) {
                                vm.fnShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var modelData = _.find(vm.modelsArr,{"id":$stateParams.selectedId});
                                if(modelData){
                                    vm.fnGetModel(modelData, vm.modelsArr);
                                }
                            }
                            if(addedModelId.length) {
                                vm.fnOpenPostCreateActionModal(addedModelId);
                                addedModelId = '';
                            }
                            if ($state.current.name === 'main.model') {
                                $state.go('main.model', {page: vm.currentPage, perPage: vm.perPage, openCreateView: ''}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }

                            vm.isModelsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isModelsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.model', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isModelsLoading = true;
                    vm.selectedModelsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetModels(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.modelSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "modelSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.modelSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnModelsSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('modelSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('modelSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('modelSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.modelPermissionObj.List = false;
                    $timeout(function () {
                        vm.modelPermissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCreateFromTrainer) {
                    vm.selectedModelsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = !vm.isCreate;
                    if (isCreateFromTrainer) {
                        vm.isCreateFromTrainer = !vm.isCreateFromTrainer;
                    }
                };

                vm.fnShowCreateForm = function (isCreateFromTrainer) {
                    vm.selectedModelsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCreateFromTrainer) {
                        vm.isCreateFromTrainer = true;
                    } else {
                        vm.isCreateFromTrainer = false;
                    }
                };

                $scope.$on("modelDeleted", function (evt, data) {
                    vm.selectedModelObj = null;
                    vm.selectedModelsArr = [];
                    vm.modelsArr = vm.modelsArr.filter(function (modelObj) {
                        return (modelObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.model', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("ModelDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.modelsArr, function (modelObj) {
                        if (modelObj.id === vm.selectedModelObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedModelObj[key] = val;
                                modelObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("modelAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedModelId = '';
                    } else {
                        if (vm.modelPermissionObj.List) {
                            addedModelId = data;
                        } else {
                            addedModelId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnInitModel = function () {
                    vm.modelPermissionObj = PermissionsService.getPermissions("ai:model");
                    vm.trainerPermissionObj = PermissionsService.getPermissions("ai:trainer");
                    var sortData = FedSudoUserService.fnGetUserData('modelSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                vm.fnOpenPostCreateActionModal = function () {
                    var optionsArr = [{
                        faIcon: "fa-share-alt",
                        subOptions: [{
                            displayText: "Create a new Distribution",
                            isRedirect: true,
                            stateName: "main.distribution",
                            isVisible: PermissionsService.getPermissions('ai:distribution').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if(subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if(optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if(finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if(selectedOption.isRedirect) {
                                if(selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            }
                        }, function () {});
                    }
                };

                var modelKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.model') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.modelPermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.modelPermissionObj.Create && vm.trainerPermissionObj.List &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedModelsArr.length > 1 && vm.modelPermissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleModels(vm.selectedModelsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var modelKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.model') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', modelKeyDownEventHandler);
                document.addEventListener('keyup', modelKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', modelKeyDownEventHandler);
                    document.removeEventListener('keyup', modelKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DistributionCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, microSpinner, DB,
                      Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService,
                      UserFactory, BatchFactory, DistributionFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedDistributionId = '';

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }
                ];
                vm.filterQuery = "";

                //Distributions Variables
                vm.isDistributionsLoading = false;
                vm.distributionsArr = [];
                vm.selectedDistributionsArr = [];
                vm.selectedDistributionObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp = false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditDistributionObj = {};

                vm.distributionContextMenu = function (distributionObj) {
                    if (Object.keys(vm.resetEditDistributionObj).length) {
                        var isFindDistribution = _.find(vm.distributionsArr, {id: vm.resetEditDistributionObj.id});
                        if (isFindDistribution) {
                            vm.fnCancelDistributionEditMode(isFindDistribution);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, distributionValue, text, $li
                            distributionObj.isEditable = true;
                            vm.resetEditDistributionObj = angular.copy(distributionObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelDistributionEditMode = function (distributionObj, isSuccessCall) {
                    if (isSuccessCall) {
                        distributionObj.name = angular.copy(distributionObj.name);
                        distributionObj.description = angular.copy(distributionObj.description);
                        distributionObj.isEditable = false;
                        vm.resetEditDistributionObj = {};
                    } else {
                        distributionObj.name = angular.copy(vm.resetEditDistributionObj.name);
                        distributionObj.description = angular.copy(vm.resetEditDistributionObj.description);
                        distributionObj.isEditable = false;
                        vm.resetEditDistributionObj = {};
                    }
                };

                vm.fnSaveDistributionInfo = function (distributionObj) {
                    distributionObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        distributionId: distributionObj.id
                    };
                    inputObj.body = {
                        name: distributionObj.name,
                        description: angular.isUndefined(distributionObj.description)?'':distributionObj.description
                    };
                    DistributionFactory.modifyDistribution(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.distributionsArr, function (distributionObj) {
                                if (Object.keys(vm.selectedDistributionObj).length) {
                                    if (distributionObj.id === vm.selectedDistributionObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedDistributionObj[key] = val;
                                            distributionObj[key] = val;
                                        });
                                    }
                                }
                                if (distributionObj.id === resetCopy.id) {
                                    distributionObj.name = resetCopy.name;
                                    distributionObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelDistributionEditMode(distributionObj, true);
                            amaran.success("Distribution Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelDistributionEditMode(distributionObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isDistributionsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isDistributionsLoading = true;
                    vm.selectedDistributionsArr = [];
                    vm.isAllChecked = false;
                    if(vm.distributionPermissionObj.List) {
                        vm.fnGetDistributions(inputObj);
                    } else {
                        vm.distributionsArr = [];
                        vm.isDistributionsLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.distributionsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDistributionsArr = angular.copy(vm.distributionsArr);
                    } else {
                        vm.selectedDistributionsArr = [];
                    }
                    $state.go('main.distribution', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenDistributionObjInfoTab = function(distributionObj){
                    vm.fnGetDistribution(distributionObj,vm.distributionsArr);
                };

                vm.fnGetDistribution = function (distributionObj, distributionsArr) {
                    angular.forEach(distributionsArr, function (distribution) {
                        distribution.isCheck = false;
                    });
                    distributionObj.isCheck = true;
                    vm.selectedDistributionsArr = [distributionObj]; // Assign array with single distribution object
                    vm.fnGetDistributionDetails(distributionObj);
                };

                vm.fnGetDistributionDetails = function (distributionObj) {
                    vm.isDistributionDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when distribution is selected
                        vm.selectedDistributionObj = distributionObj;
                        $state.go('main.distribution', {selectedId: vm.selectedDistributionObj.id}, {notify: false});
                        $stateParams.selectedId = vm.selectedDistributionObj.id;
                        vm.isDistributionDetailsLoaded = true;
                    })
                };

                vm.fnCheckUncheckHeader = function (distributionObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.distributionsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === distributionObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected distributions array*/
                    var isValueFind = _.find(vm.selectedDistributionsArr, {'id': distributionObj.id});
                    if (!isValueFind) {
                        vm.selectedDistributionsArr.push(distributionObj)
                    } else {
                        _.remove(vm.selectedDistributionsArr, function (obj) {
                            return distributionObj.id === obj.id;
                        });
                    }
                    if (vm.selectedDistributionsArr.length === 1) {
                        vm.fnGetDistributionDetails(vm.selectedDistributionsArr[0])
                    }else {
                        $state.go('main.distribution', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleDistributions = function (selectedDistributionsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedDistributionsArr, function (selectedDistribution, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/distributions/" + selectedDistribution.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/distributions/" + selectedDistribution.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected distributions?",
                            text: "You are about to permanently delete the selected distributions.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'distribution', appName: 'ai'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDistributionsArr, function (selectedDistribution) {
                                    angular.forEach(vm.distributionsArr, function (distributionObj, index) {
                                        if (selectedDistribution.id === distributionObj.id) {
                                            vm.distributionsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDistributionsArr.length;
                                vm.selectedDistributionObj = null;
                                vm.selectedDistributionsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDistributionsArr, function (selectedDistribution) {
                                    angular.forEach(vm.distributionsArr, function (distributionObj, index) {
                                        if (selectedDistribution.id === distributionObj.id) {
                                            vm.distributionsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDistributionsArr.length;
                                vm.selectedDistributionObj = null;
                                vm.selectedDistributionsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetDistributions = function (inputObj) {
                    DistributionFactory.getDistributions(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.distributions;
                            vm.distributionsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                    $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm(true);
                            } else if ($stateParams.selectedId) {
                                var distributionData = _.find(vm.distributionsArr,{"id":$stateParams.selectedId});
                                if(distributionData){
                                    vm.fnGetDistribution(distributionData, vm.distributionsArr);
                                }
                            }
                            if(addedDistributionId.length) {
                                vm.fnOpenPostCreateActionModal(addedDistributionId);
                                addedDistributionId = '';
                            }
                            if($state.current.name === 'main.distribution') {
                                $state.go('main.distribution', {page: vm.currentPage, perPage: vm.perPage, openCreateView: ''}, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isDistributionsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDistributionsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.distribution', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isDistributionsLoading = true;
                    vm.selectedDistributionsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDistributions(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.distributionSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "distributionSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.distributionSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnDistributionsSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('distributionSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('distributionSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('distributionSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.distributionPermissionObj.List = false;
                    $timeout(function () {
                        vm.distributionPermissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedDistributionsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen ) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                $scope.$on("DistributionDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.distributionsArr, function (distributionObj) {
                        if (distributionObj.id === vm.selectedDistributionObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDistributionObj[key] = val;
                                distributionObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("DistributionDeleted", function (evt, data) {
                    vm.selectedDistributionObj = null;
                    vm.selectedDistributionsArr = [];
                    vm.distributionsArr = vm.distributionsArr.filter(function (distributionObj) {
                        return (distributionObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.distribution', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                $scope.$on("distributionAdded", function (evt, data) {
                    var postActionOptions = FedSudoUserService.fnGetUserData('postActionOptionsEnabled');
                    if (postActionOptions && postActionOptions[0] === "false") {
                        addedDistributionId = '';
                    } else {
                        if (vm.distributionPermissionObj.List) {
                            addedDistributionId = data;
                        } else {
                            addedDistributionId = '';
                            vm.fnOpenPostCreateActionModal(data);
                        }
                    }
                });

                vm.fnInitDistribution = function () {
                    vm.distributionPermissionObj = PermissionsService.getPermissions("ai:distribution");
                    vm.modelPermissionObj = PermissionsService.getPermissions("ai:model");
                    var sortData = FedSudoUserService.fnGetUserData('distributionSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                vm.fnOpenPostCreateActionModal = function () {
                    var optionsArr = [{
                        faIcon: "fa-cloud-upload",
                        subOptions: [{
                            displayText: "Create a new Deployment",
                            isRedirect: true,
                            stateName: "main.deployment",
                            isVisible: PermissionsService.getPermissions('ai:deployment').Create
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if(subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if(optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if(finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if(selectedOption.isRedirect) {
                                if(selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            }
                        }, function () {});
                    }
                };

                var distributionKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.distribution') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.distributionPermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedDistributionsArr.length > 1 && vm.distributionPermissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleDistributions(vm.selectedDistributionsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var distributionKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.distribution') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', distributionKeyDownEventHandler);
                document.addEventListener('keyup', distributionKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', distributionKeyDownEventHandler);
                    document.removeEventListener('keyup', distributionKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DeploymentCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, amaran, swal, microSpinner, DB, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, ColorService, UserFactory, BatchFactory, DeploymentFactory, postActionModelIcon, postActionModelMessage) {
                var vm = this;

                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.searchFieldArr = [
                    {
                        fieldDisplayName: "ID",
                        fieldName: "id"
                    },
                    {
                        fieldDisplayName: "Name",
                        fieldName: "name"
                    },
                    {
                        fieldDisplayName: "Description",
                        fieldName: "description"
                    }, {
                        fieldDisplayName: "Distribution ID",
                        fieldName: "distributionId"
                    }, {
                        fieldDisplayName: "Status",
                        fieldName: "status"
                    }
                ];
                vm.filterQuery = "";

                //Deployments Variables
                vm.isDeploymentsLoading = false;
                vm.deploymentsArr = [];
                vm.selectedDeploymentsArr = [];
                vm.selectedDeploymentObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = FedSudoUserService.fnGetUserData('perPage');
                vm.perPage = parseInt(perPage === '' ? 20 : perPage[0]);
                vm.maxSize = 3;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.isDropUp=false;

                //Sorting Variables
                vm.isSortingEnabled = false;
                vm.sortType = '';
                vm.sortReverse = false;

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditDeploymentObj = {};

                vm.deploymentContextMenu = function (deploymentObj) {
                    if (Object.keys(vm.resetEditDeploymentObj).length) {
                        var isFindDeployment = _.find(vm.deploymentsArr, {id: vm.resetEditDeploymentObj.id});
                        if (isFindDeployment) {
                            vm.fnCancelDeploymentEditMode(isFindDeployment);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, DeploymentValue, text, $li
                            deploymentObj.isEditable = true;
                            vm.resetEditDeploymentObj = angular.copy(deploymentObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCancelDeploymentEditMode = function (deploymentObj, isSuccessCall) {
                    if (isSuccessCall) {
                        deploymentObj.name = angular.copy(deploymentObj.name);
                        deploymentObj.description = angular.copy(deploymentObj.description);
                        deploymentObj.isEditable = false;
                        vm.resetEditDeploymentObj = {};
                    } else {
                        deploymentObj.name = angular.copy(vm.resetEditDeploymentObj.name);
                        deploymentObj.description = angular.copy(vm.resetEditDeploymentObj.description);
                        deploymentObj.isEditable = false;
                        vm.resetEditDeploymentObj = {};
                    }
                };

                vm.fnSaveDeploymentInfo = function (deploymentObj) {
                    deploymentObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        deploymentId: deploymentObj.id
                    };
                    inputObj.body = {
                        name: deploymentObj.name,
                        description: angular.isUndefined(deploymentObj.description)?'':deploymentObj.description,
                        distributionId:deploymentObj.distributionId
                    };
                    DeploymentFactory.modifyDeployment(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.deploymentsArr, function (deploymentObj) {
                                if (Object.keys(vm.selectedDeploymentObj).length) {
                                    if (deploymentObj.id === vm.selectedDeploymentObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedDeploymentObj[key] = val;
                                            deploymentObj[key] = val;
                                        });
                                    }
                                }
                                if (deploymentObj.id === resetCopy.id) {
                                    deploymentObj.name = resetCopy.name;
                                    deploymentObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelDeploymentEditMode(deploymentObj, true);
                            amaran.success("Deployment Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelDeploymentEditMode(deploymentObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    vm.fnSetTableHeight();
                });

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery) {
                    vm.isDeploymentsLoading = true;
                    vm.filterQuery = filterQuery;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    var inputObj = {};
                    if (vm.filterQuery.length) {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        inputObj = {
                            page: vm.currentPage,
                            perPage: vm.perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isDeploymentsLoading = true;
                    vm.selectedDeploymentsArr = [];
                    vm.isAllChecked = false;
                    if (vm.deploymentPermissionObj.List) {
                        vm.fnGetDeployments(inputObj);
                    } else {
                        vm.deploymentsArr = [];
                        vm.isDeploymentsLoading = false;
                    }
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".search-tag-container")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var searchTag = angular.element(".search-tag-container")[0].offsetHeight;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;

                        var finalHeight = total - (search + pagination + searchTag + header + 60);

                        var rightTableHieght = total - (search + pagination + searchTag + header + 193);

                        angular.element("tbody").css('height', finalHeight + 'px');
                        angular.element("#infoSection tbody").css('height', rightTableHieght + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var searchTag = angular.isDefined(angular.element(".search-tag-container")[0]) ? angular.element(".search-tag-container")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + 30);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.deploymentsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedDeploymentsArr = angular.copy(vm.deploymentsArr);
                    } else {
                        vm.selectedDeploymentsArr = [];
                    }
                    $state.go('main.deployment', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnOpenDeploymentInfoTab = function(deploymentObj,tabIndex){
                    vm.tabIndex = tabIndex;
                    vm.fnGetDeployment(deploymentObj,vm.deploymentsArr);
                };

                vm.fnGetDeployment = function (deploymentObj, deploymentsArr) {
                    angular.forEach(deploymentsArr, function (deployment) {
                        deployment.isCheck = false;
                    });
                    deploymentObj.isCheck = true;
                    vm.selectedDeploymentsArr = [deploymentObj]; // Assign array with single deployment object
                    vm.fnGetDeploymentDetails(deploymentObj);
                };

                vm.fnGetDeploymentDetails = function (deploymentObj) {
                    vm.isDeploymentDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when deployment is selected
                        vm.selectedDeploymentObj = deploymentObj;
                        if (vm.tabIndex !== 0) {
                            $state.go('main.deployment', {selectedId: vm.selectedDeploymentObj.id, selectedDetailsTab: vm.tabIndex}, {notify: false});
                            $stateParams.selectedId = vm.selectedDeploymentObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isDeploymentDetailsLoaded = true;
                        } else {
                            $state.go('main.deployment', {selectedId: vm.selectedDeploymentObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedDeploymentObj.id;
                            vm.isDeploymentDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckHeader = function (deploymentObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.deploymentsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === deploymentObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected deployment array*/
                    var isValueFind = _.find(vm.selectedDeploymentsArr, {'id': deploymentObj.id});
                    if (!isValueFind) {
                        vm.selectedDeploymentsArr.push(deploymentObj)
                    } else {
                        _.remove(vm.selectedDeploymentsArr, function (obj) {
                            return deploymentObj.id === obj.id;
                        });
                    }
                    if (vm.selectedDeploymentsArr.length === 1) {
                        vm.fnGetDeploymentDetails(vm.selectedDeploymentsArr[0])
                    }else {
                        $state.go('main.deployment', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnDeleteMultipleDeployments = function (selectedDeploymentsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedDeploymentsArr, function (selectedDeployment, index) {
                        if(index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/deployments/" + selectedDeployment.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/deployments/" + selectedDeployment.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });
                    swal({
                            title: "Delete the selected deployments?",
                            text: "You are about to permanently delete the selected deployments.<br/>" +
                            "You will not be able to recover any of the data related to them.<br/>" +
                            "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({body: batchCollectionObj[count], tag: 'deployment', appName: 'ai'})
                        .then(function () {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDeploymentsArr, function (selectedDeployment) {
                                    angular.forEach(vm.deploymentsArr, function (deploymentObj, index) {
                                        if (selectedDeployment.id === deploymentObj.id) {
                                            vm.deploymentsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDeploymentsArr.length;
                                vm.selectedDeploymentObj = null;
                                vm.selectedDeploymentsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                },1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if(count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedDeploymentsArr, function (selectedDeployment) {
                                    angular.forEach(vm.deploymentsArr, function (deploymentObj, index) {
                                        if (selectedDeployment.id === deploymentObj.id) {
                                            vm.deploymentsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedDeploymentsArr.length;
                                vm.selectedDeploymentObj = null;
                                vm.selectedDeploymentsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetDeployments = function (inputObj) {
                    DeploymentFactory.getDeployments(inputObj)
                        .then(function (res) { // Success block
                            var paginationObj = PaginationService.Pagination.deployments;
                            vm.deploymentsArr = angular.copy(res);
                            vm.totalItems = parseInt(paginationObj.totalCollection);
                            vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, inputObj.page);
                            if($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                    $stateParams.openCreateView === true)) {
                                vm.fnShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var deploymentData = _.find(vm.deploymentsArr,{"id":$stateParams.selectedId});
                                if(deploymentData){
                                    vm.fnGetDeployment(deploymentData, vm.deploymentsArr);
                                }
                            }
                            if ($state.current.name === 'main.deployment') {
                                $state.go('main.deployment', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isDeploymentsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isDeploymentsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.deployment', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        vm.fnUpdateUserData(perPage);
                    } else {
                        FedSudoUserService.fnSetUserData('perPage', [perPage]);
                    }
                    if (vm.filterQuery.length) {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage,
                            filter: vm.filterQuery
                        };
                    } else {
                        vm.inputObj = {
                            page: page,
                            perPage: perPage
                        };
                    }
                    if (vm.isSortingEnabled) {
                        if( vm.sortReverse) {
                            vm.inputObj.sort = '[dec]' + vm.sortType
                        } else {
                            vm.inputObj.sort = '[asc]' + vm.sortType
                        }
                    }
                    vm.isDeploymentsLoading = true;
                    vm.selectedDeploymentsArr = [];
                    vm.isAllChecked = false;
                    vm.fnGetDeployments(vm.inputObj);
                };

                vm.fnGetSortClass = function (type) {
                    return SortIconService.fnGetSortIcon(vm.isSortingEnabled, vm.sortType, vm.sortReverse, type);
                };

                vm.fnUpdateSortUserData = function (sortArr) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if(sortArr && sortArr.length) {
                        if (loginUser.data) {
                            loginUser.data.deploymentSort = sortArr;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {
                                "deploymentSort": sortArr
                            }
                        }
                    } else {
                        if (loginUser.data) {
                            delete loginUser.data.deploymentSort;
                            inputObj.body = loginUser.data;
                        } else {
                            inputObj.body = {}
                        }
                    }
                    UserFactory.updateUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function () {
                            vm.isLandingUrlChanging = false;
                        });
                };

                vm.fnDeploymentsSort = function (type) {
                    if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                vm.fnUpdateSortUserData();
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            vm.fnUpdateSortUserData([type, "" + vm.sortReverse + ""]);
                        }
                    }else{
                        if(vm.sortType === type) {
                            if(vm.sortReverse === true) {
                                vm.isSortingEnabled = false;
                                vm.sortType = '';
                                vm.sortReverse = false;
                                FedSudoUserService.fnRemoveUserData('deploymentSort');
                            } else {
                                vm.isSortingEnabled = true;
                                vm.sortReverse = !vm.sortReverse;
                                FedSudoUserService.fnSetUserData('deploymentSort', [type, "" + vm.sortReverse + ""]);
                            }
                        } else {
                            vm.isSortingEnabled = true;
                            vm.sortType = type;
                            vm.sortReverse = false;
                            FedSudoUserService.fnSetUserData('deploymentSort', [type, "" + vm.sortReverse + ""]);
                        }
                    }
                    vm.fnReload();
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.deploymentPermissionObj.List = false;
                    $timeout(function () {
                        vm.deploymentPermissionObj.List = true;
                    }, 10)
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedDeploymentsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if(isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                };

                vm.fnGetDeploymentStatusIcon = function (status) {
                    var icon = "";
                    switch (status) {
                        case "OUT_OF_SERVICE":
                            icon = "fa-exclamation-triangle";
                            break;
                        case "CREATING":
                            icon = "fa-gears";
                            break;
                        case "UPDATING":
                            icon = "fa-upload";
                            break;
                        case "ROLLING_BACK":
                            icon = "fa-retweet";
                            break;
                        case "IN_SERVICE":
                            icon = "fa-check";
                            break;
                        case "DELETING":
                            icon = "fa-trash-o";
                            break;
                        case "FAILED":
                            icon = "fa-times-circle";
                            break;
                    }
                    return icon;
                };

                vm.fnGetDeploymentStatusIconColor = function (status) {
                    return ColorService.getDeploymentStatusColor(status);
                };

                $scope.$on("DeploymentDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.deploymentsArr, function (deploymentObj) {
                        if (deploymentObj.id === vm.selectedDeploymentObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedDeploymentObj[key] = val;
                                deploymentObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("DeploymentDeleted", function (evt, data) {
                    vm.selectedDeploymentObj = null;
                    vm.selectedDeploymentsArr = [];
                    vm.deploymentsArr = vm.deploymentsArr.filter(function (deploymentObj) {
                        return (deploymentObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.deployment', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                });

                vm.fnInitDeployment = function () {
                    vm.deploymentPermissionObj = PermissionsService.getPermissions("ai:deployment");
                    vm.distributionPermissionObj = PermissionsService.getPermissions("ai:distribution");
                    var sortData = FedSudoUserService.fnGetUserData('deploymentSort');
                    if (sortData !=='') {
                        vm.isSortingEnabled = true;
                        vm.sortType = sortData[0];
                        if (sortData[1] === "false") {
                            vm.sortReverse = false;
                        } else {
                            vm.sortReverse = true;
                        }
                    }
                };

                var deploymentKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.deployment') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.deploymentPermissionObj.Create &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedDeploymentsArr.length > 1 && vm.deploymentPermissionObj.Delete &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Delete multiple
                                vm.fnDeleteMultipleDeployments(vm.selectedDeploymentsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var deploymentKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.deployment') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', deploymentKeyDownEventHandler);
                document.addEventListener('keyup', deploymentKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', deploymentKeyDownEventHandler);
                    document.removeEventListener('keyup', deploymentKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('VaultsCtrl',
            function ($scope, $window, $timeout, $stateParams, $log, moment, $state, $uibModal, WidgetsListService, UserProfileService, amaran, swal, PaginationQueryService, microSpinner, BatchFactory, DB, XLSX, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, VaultsFactory, postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, QueryFactory, copyService) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };
                vm.isShowWidgetEditor = false;

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //vaults Variables
                vm.isVaultsLoading = false;
                vm.isCreateFromAuthenticator = false;
                vm.isCreateFromNode = false;
                vm.vaultsArr = [];
                vm.selectedVaultsArr = [];
                vm.selectedVaultObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');
                vm.lastSQLQuery = "";
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.tokenResponse = [];
                vm.vaultsResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateVaultProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowVaultStats = false;
                vm.isCreateIssue = false;

                //variables for chart
                vm.selectedVaultType = '';
                vm.selectedSecurityGroupId = '';
                vm.selectedSecurityRoleId = '';
                vm.vaultTypesData = [];
                vm.securityRoles = [];
                vm.securityGroups = [];

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        if (parsedItem.data && angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Map common fields
                                parsedItem.id = parsedItem.id || parsedData._id || parsedData.id;
                                parsedItem.name = parsedItem.name || parsedData.name;
                                parsedItem.description = parsedItem.description || parsedData.description;

                                // Vault specific fields
                                parsedItem.subject = parsedData.subject ? {
                                    name: parsedData.subject.name,
                                    description: parsedData.subject.description,
                                    type: parsedData.subject.type || 'string'
                                } : null;

                                // Handle timestamps
                                if (parsedItem.updatedAt || parsedData.updatedAt) {
                                    parsedItem.updatedAt = parsedItem.updatedAt || parsedData.updatedAt;
                                } else if (parsedItem.updated_at || parsedData.updated_at) {
                                    parsedItem.updatedAt = parsedItem.updated_at || parsedData.updated_at;
                                }

                                if (parsedItem.createdAt || parsedData.createdAt) {
                                    parsedItem.createdAt = parsedItem.createdAt || parsedData.createdAt;
                                } else if (parsedItem.created_at || parsedData.created_at) {
                                    parsedItem.createdAt = parsedItem.created_at || parsedData.created_at;
                                }

                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }
                vm.parsePostgresData = parsePostgresData;

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'vault', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isVaultsLoading = true;
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_vaults';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_vaults';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE data->>\'' + vm.sqlQuery.trim() : '\'';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetVaults(input, true);
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (vaultObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_VAULT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.vaultsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === vaultObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected vault array*/
                        var isValueFind = _.find(vm.selectedVaultsArr, {'id': vaultObj.id});
                        if (!isValueFind) {
                            vm.selectedVaultsArr.push(vaultObj);
                            var isTabExist = _.find(vm.tabs, {'id': vaultObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: vaultObj.id,
                                    title: vaultObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedVaultsArr, function (obj) {
                                return vaultObj.id === obj.id;
                            });
                        }
                        if (vm.selectedVaultsArr.length === 1) {
                            vm.fnGetVaultDetails(vm.selectedVaultsArr[0])
                        } else {
                            $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.vaultsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedVaultsArr = angular.copy(vm.vaultsArr);
                    } else {
                        vm.selectedVaultsArr = [];
                    }
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCreateFromType, type) {
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCreateFromType) {
                        if (type === 'auth') {
                            vm.isCreateFromAuthenticator = !vm.isCreateFromAuthenticator;
                            vm.isCreateFromType = false;
                            vm.isCreateFromNode = false;
                        } else if (type === 'node') {
                            vm.isCreateFromNode = !vm.isCreateFromNode;
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromType = false;
                        } else {
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromNode = false;
                            vm.isCreateFromType = !vm.isCreateFromType;
                        }
                        vm.isCreate = !vm.isCreate;
                    } else {
                        vm.isCreateFromType = false;
                        vm.isCreateFromAuthenticator = false;
                        vm.isCreateFromNode = false;
                        vm.isCreate = !vm.isCreate;
                    }

                    if (vm.isCreate) {
                        if (type === 'auth') {
                            var isTabExistAuth = _.find(vm.tabs, {'id': 'Create Vault  from Authenticator'});
                            if (isTabExistAuth) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExistAuth.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault  from Authenticator',
                                    title: 'Create Vault  from Authenticator',
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else if (type === 'node') {
                            var isTabExistAuthForNode = _.find(vm.tabs, {'id': 'Create Vault from Node'});
                            if (isTabExistAuthForNode) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExistAuthForNode.tabIndex;
                                });
                            } else {
                                var newTabIndexForNode = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault from Node',
                                    title: 'Create Vault from Node',
                                    tabIndex: newTabIndexForNode
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndexForNode;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else {
                            var isTabExist = _.find(vm.tabs, {'id': 'Create Vault'});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTempTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault',
                                    title: 'Create Vault',
                                    tabIndex: newTempTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTempTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        }
                    }
                };

                vm.fnShowCreateForm = function (isCreateFromType, type) {
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCreateFromType) {
                        if (type === 'auth') {
                            vm.isCreateFromAuthenticator = !vm.isCreateFromAuthenticator;
                            vm.isCreateFromType = false;
                            vm.isCreateFromNode = false;
                        } else if (type === 'node') {
                            vm.isCreateFromNode = !vm.isCreateFromNode;
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromType = false;
                        } else {
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromNode = false;
                            vm.isCreateFromType = !vm.isCreateFromType;
                        }
                    } else {
                        vm.isCreateFromType = false;
                        vm.isCreateFromAuthenticator = false;
                        vm.isCreateFromNode = false;
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isVaultsLoading = true;
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_vaults';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_vaults';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_vaults';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE data->>\'' + vm.sqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_vaults';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE data->>\'' + vm.sqlQuery.trim() : '\'';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetVaults(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.vaultsArr);
                        vm.previousPage = page;
                        vm.fnGetVaults(input, false);
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getVaultCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.vaultsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var vaultsArrCp = _.cloneDeepWith(vm.vaultsArr);
                    var tempData = _.map(vaultsArrCp, function (tempObj) {
                        delete tempObj.content;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Vaults");
                    XLSX.writeFile(wb, "vaults.xlsx");
                };
                /* Export Modal: End */

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenVaultInfoTab = function (vaultObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(vaultObj);
                };

                vm.fnGetVault = function (vaultObj, vaultsArr) {
                    angular.forEach(vaultsArr, function (vault) {
                        vault.isCheck = false;
                    });
                    vaultObj.isCheck = true;
                    vm.selectedVaultsArr = [vaultObj]; // Assign array with single vault object
                    vm.fnGetVaultDetails(vaultObj);
                };

                vm.fnGetVaultDetails = function (vaultObj) {
                    vm.isVaultDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when vault is selected
                        vm.selectedVaultObj = vaultObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.vaults', {
                                selectedId: vm.selectedVaultObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedVaultObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isVaultDetailsLoaded = true;
                        } else {
                            $state.go('main.vaults', {selectedId: vm.selectedVaultObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedVaultObj.id;
                            vm.isVaultDetailsLoaded = true;
                        }
                    });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetVaults = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data = vm.parsePostgresData(res.data);
                            res.data.map(function (obj) {
                                if (obj.createdAt) {
                                    obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                                }
                                if (obj.updatedAt) {
                                    obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                                }
                            });
                            vm.vaultsResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.vaultsResponse.data && vm.vaultsResponse.data.length) {
                                    vm.totalItems = vm.vaultsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.vaultsResponse.data.reverse();
                            }
                            vm.vaultsArr = vm.vaultsResponse.data;
                            if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var vaultData = _.find(vm.vaultsArr, {"id": $stateParams.selectedId});
                                if (vaultData) {
                                    vm.fnCheckUncheckHeader(vaultData);
                                }
                            }
                            if ($state.current.name === 'main.vaults') {
                                $state.go('main.vaults', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isVaultsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isVaultsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("VaultDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.vaultsArr, function (vaultObj) {
                        if (vaultObj.id === vm.selectedVaultObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedVaultObj[key] = val;
                                vaultObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("VaultDeleted", function (evt, data) {
                    vm.selectedVaultObj = null;
                    vm.selectedVaultsArr = [];
                    vm.vaultsArr = vm.vaultsArr.filter(function (vaultObj) {
                        return (vaultObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("VaultAdded", function (evt, data) {
                    vm.fnRemoveTab(data);
                });

                vm.fnDeleteMultipleVaults = function (selectedVaultsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedVaultsArr, function (selectedVault, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/vaults/" + selectedVault.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/vaults/" + selectedVault.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected vaults?",
                            text: "You are about to permanently delete the selected vaults.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'vault', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.vaults", tempArr, {notify: false});
                    }
                };

                vm.fnInitVaults = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("access");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.valuts = [];
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'vault', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetVaultDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnGetVaultStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'VaultStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowVaultStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'VaultStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowVaultStats = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnUpdateVaultProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'vault', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindvault = _.find(vm.vaultsArr, {id: tab.id});
                            if (isFindvault) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedVaultsArr = [];
                                vm.selectedVaultObj = {};
                                vm.fnCheckUncheckHeader(isFindvault);
                            }
                        } else {
                            $state.go('main.vaults', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Vault" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node";
                        vm.isShowVaultStats = tab.id === "VaultStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Vault" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node";
                    vm.isCreateFromAuthenticator = tab.id === "Create Vault  from Authenticator";
                    vm.isCreateFromNode = tab.id === "Create Vault from Node";
                    vm.isShowVaultStats = tab.id === "VaultStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Vault" || tab.id === "Create Issue" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node" || tab.id === "VaultStats" || tab.id === "WidgetEditor") {
                        $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === 'Create Vault' || id === 'Create Vault  from Authenticator' || id === 'Create Vault from Node') {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.vaults', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateVaultProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnOpenEditUserInfoTab = function (vaultObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(vaultObj);
                };

                /*Tab: End*/

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedVaultsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.vaultsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.vaultsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedVaultsArr.length;
                                vm.selectedVaultObj = null;
                                vm.selectedVaultsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedVaultsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.vaultsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.vaultsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedVaultsArr.length;
                                vm.selectedVaultObj = null;
                                vm.selectedVaultsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessVaultChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var vaultsKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.permissionObj.CREATE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnShowCreateForm(true, 'auth');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedVaultsArr.length > 1 && vm.permissionObj.DELETE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleVaults(vm.selectedVaultsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var vaultsKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', vaultsKeyDownEventHandler);
                document.addEventListener('keyup', vaultsKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', vaultsKeyDownEventHandler);
                    document.removeEventListener('keyup', vaultsKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('VaultsCtrl',
            function ($scope, $window, $timeout, $stateParams, moment, $state, $uibModal, WidgetsListService, UserProfileService, amaran, swal, PaginationQueryService, microSpinner, BatchFactory, DB, XLSX, Authenticate, SortIconService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, VaultsFactory, postActionModelIcon, postActionModelMessage, jsonToCsvConvertService, QueryFactory, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    66: false, //b
                    68: false //d
                };
                vm.isShowWidgetEditor = false;

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "data->>\'id\'",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //vaults Variables
                vm.isVaultsLoading = false;
                vm.isCreateFromAuthenticator = false;
                vm.isCreateFromNode = false;
                vm.vaultsArr = [];
                vm.selectedVaultsArr = [];
                vm.selectedVaultObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');
                vm.lastSQLQuery = "";
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.tokenResponse = [];
                vm.vaultsResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateVaultProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowVaultStats = false;
                vm.isCreateIssue = false;

                //variables for chart
                vm.selectedVaultType = '';
                vm.selectedSecurityGroupId = '';
                vm.selectedSecurityRoleId = '';
                vm.vaultTypesData = [];
                vm.securityRoles = [];
                vm.securityGroups = [];

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                });

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core vault fields
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'vault', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isVaultsLoading = true;
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_vaults';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_vaults';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetVaults(input, true);
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (vaultObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_VAULT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.vaultsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === vaultObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected vault array*/
                        var isValueFind = _.find(vm.selectedVaultsArr, {'id': vaultObj.id});
                        if (!isValueFind) {
                            vm.selectedVaultsArr.push(vaultObj);
                            var isTabExist = _.find(vm.tabs, {'id': vaultObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: vaultObj.id,
                                    title: vaultObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedVaultsArr, function (obj) {
                                return vaultObj.id === obj.id;
                            });
                        }
                        if (vm.selectedVaultsArr.length === 1) {
                            vm.fnGetVaultDetails(vm.selectedVaultsArr[0])
                        } else {
                            $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.vaultsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedVaultsArr = angular.copy(vm.vaultsArr);
                    } else {
                        vm.selectedVaultsArr = [];
                    }
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCreateFromType, type) {
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCreateFromType) {
                        if (type === 'auth') {
                            vm.isCreateFromAuthenticator = !vm.isCreateFromAuthenticator;
                            vm.isCreateFromType = false;
                            vm.isCreateFromNode = false;
                        } else if (type === 'node') {
                            vm.isCreateFromNode = !vm.isCreateFromNode;
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromType = false;
                        } else {
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromNode = false;
                            vm.isCreateFromType = !vm.isCreateFromType;
                        }
                        vm.isCreate = !vm.isCreate;
                    } else {
                        vm.isCreateFromType = false;
                        vm.isCreateFromAuthenticator = false;
                        vm.isCreateFromNode = false;
                        vm.isCreate = !vm.isCreate;
                    }

                    if (vm.isCreate) {
                        if (type === 'auth') {
                            var isTabExistAuth = _.find(vm.tabs, {'id': 'Create Vault  from Authenticator'});
                            if (isTabExistAuth) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExistAuth.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault  from Authenticator',
                                    title: 'Create Vault  from Authenticator',
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else if (type === 'node') {
                            var isTabExistAuthForNode = _.find(vm.tabs, {'id': 'Create Vault from Node'});
                            if (isTabExistAuthForNode) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExistAuthForNode.tabIndex;
                                });
                            } else {
                                var newTabIndexForNode = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault from Node',
                                    title: 'Create Vault from Node',
                                    tabIndex: newTabIndexForNode
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndexForNode;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        } else {
                            var isTabExist = _.find(vm.tabs, {'id': 'Create Vault'});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTempTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Vault',
                                    title: 'Create Vault',
                                    tabIndex: newTempTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTempTabIndex;
                                    vm.fnUpdateVaultProfileData();
                                });
                            }
                        }
                    }
                };

                vm.fnShowCreateForm = function (isCreateFromType, type) {
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    vm.isCreate = true;
                    if (isCreateFromType) {
                        if (type === 'auth') {
                            vm.isCreateFromAuthenticator = !vm.isCreateFromAuthenticator;
                            vm.isCreateFromType = false;
                            vm.isCreateFromNode = false;
                        } else if (type === 'node') {
                            vm.isCreateFromNode = !vm.isCreateFromNode;
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromType = false;
                        } else {
                            vm.isCreateFromAuthenticator = false;
                            vm.isCreateFromNode = false;
                            vm.isCreateFromType = !vm.isCreateFromType;
                        }
                    } else {
                        vm.isCreateFromType = false;
                        vm.isCreateFromAuthenticator = false;
                        vm.isCreateFromNode = false;
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isVaultsLoading = true;
                    vm.selectedVaultsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_vaults';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_vaults';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_vaults';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_vaults';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetVaults(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.vaultsArr);
                        vm.previousPage = page;
                        vm.fnGetVaults(input, false);
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getVaultCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.vaultsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var vaultsArrCp = _.cloneDeepWith(vm.vaultsArr);
                    var tempData = _.map(vaultsArrCp, function (tempObj) {
                        delete tempObj.content;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Vaults");
                    XLSX.writeFile(wb, "vaults.xlsx");
                };
                /* Export Modal: End */

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenVaultInfoTab = function (vaultObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(vaultObj);
                };

                vm.fnGetVault = function (vaultObj, vaultsArr) {
                    angular.forEach(vaultsArr, function (vault) {
                        vault.isCheck = false;
                    });
                    vaultObj.isCheck = true;
                    vm.selectedVaultsArr = [vaultObj]; // Assign array with single vault object
                    vm.fnGetVaultDetails(vaultObj);
                };

                vm.fnGetVaultDetails = function (vaultObj) {
                    vm.isVaultDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when vault is selected
                        vm.selectedVaultObj = vaultObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.vaults', {
                                selectedId: vm.selectedVaultObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedVaultObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isVaultDetailsLoaded = true;
                        } else {
                            $state.go('main.vaults', {selectedId: vm.selectedVaultObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedVaultObj.id;
                            vm.isVaultDetailsLoaded = true;
                        }
                    });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetVaults = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Use the new parsePostgresData method
                            res.data = vm.parsePostgresData(res.data);

                            vm.vaultsResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.vaultsResponse.data && vm.vaultsResponse.data.length) {
                                    vm.totalItems = vm.vaultsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }

                            if (inputObj.isNeedDataReverse) {
                                vm.vaultsResponse.data.reverse();
                            }

                            vm.vaultsArr = vm.vaultsResponse.data;

                            if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var vaultData = _.find(vm.vaultsArr, {"id": $stateParams.selectedId});
                                if (vaultData) {
                                    vm.fnCheckUncheckHeader(vaultData);
                                }
                            }

                            if ($state.current.name === 'main.vaults') {
                                $state.go('main.vaults', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }

                            vm.isVaultsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isVaultsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("VaultDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.vaultsArr, function (vaultObj) {
                        if (vaultObj.id === vm.selectedVaultObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedVaultObj[key] = val;
                                vaultObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("VaultDeleted", function (evt, data) {
                    vm.selectedVaultObj = null;
                    vm.selectedVaultsArr = [];
                    vm.vaultsArr = vm.vaultsArr.filter(function (vaultObj) {
                        return (vaultObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("VaultAdded", function (evt, data) {
                    vm.fnRemoveTab(data);
                });

                vm.fnDeleteMultipleVaults = function (selectedVaultsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedVaultsArr, function (selectedVault, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/vaults/" + selectedVault.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/vaults/" + selectedVault.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected vaults?",
                            text: "You are about to permanently delete the selected vaults.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'vault', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.vaults", tempArr, {notify: false});
                    }
                };

                vm.fnInitVaults = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("access");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.valuts = [];
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'vault', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetVaultDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnGetVaultStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'VaultStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowVaultStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'VaultStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowVaultStats = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnUpdateVaultProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'vault', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindvault = _.find(vm.vaultsArr, {id: tab.id});
                            if (isFindvault) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedVaultsArr = [];
                                vm.selectedVaultObj = {};
                                vm.fnCheckUncheckHeader(isFindvault);
                            }
                        } else {
                            $state.go('main.vaults', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Vault" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node";
                        vm.isShowVaultStats = tab.id === "VaultStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Vault" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node";
                    vm.isCreateFromAuthenticator = tab.id === "Create Vault  from Authenticator";
                    vm.isCreateFromNode = tab.id === "Create Vault from Node";
                    vm.isShowVaultStats = tab.id === "VaultStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Vault" || tab.id === "Create Issue" || tab.id === "Create Vault  from Authenticator" || tab.id === "Create Vault from Node" || tab.id === "VaultStats" || tab.id === "WidgetEditor") {
                        $state.go('main.vaults', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === 'Create Vault' || id === 'Create Vault  from Authenticator' || id === 'Create Vault from Node') {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.vaults', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateVaultProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };

                vm.fnOpenEditUserInfoTab = function (vaultObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(vaultObj);
                };

                /*Tab: End*/

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedVaultsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.vaultsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.vaultsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedVaultsArr.length;
                                vm.selectedVaultObj = null;
                                vm.selectedVaultsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedVaultsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.vaultsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.vaultsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedVaultsArr.length;
                                vm.selectedVaultObj = null;
                                vm.selectedVaultsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateVaultProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessVaultChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var vaultsKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnShowCreateForm();
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[66] && vm.permissionObj.CREATE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create from blueprint
                                vm.fnShowCreateForm(true, 'auth');
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[66] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedVaultsArr.length > 1 && vm.permissionObj.DELETE_VAULT &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleVaults(vm.selectedVaultsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var vaultsKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.vaults') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', vaultsKeyDownEventHandler);
                document.addEventListener('keyup', vaultsKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', vaultsKeyDownEventHandler);
                    document.removeEventListener('keyup', vaultsKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('UsersCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, highed, WidgetsListService,
                      UserProfileService, PaginationQueryService, amaran, ColorService, swal,
                      microSpinner, DB, XLSX, Authenticate, IconService, PermissionsService, LastPageService,
                      AvatarService, UserFactory, BatchFactory, TeamFactory, SecurityRoleFactory, PaginationService,
                      FedSudoUserService, postActionModelIcon, postActionModelMessage, SecurityGroupFactory,
                      FederationsFactory, AuthenticatorFactory, VaultsFactory, jsonToCsvConvertService, QueryFactory, copyService, $log) {
                var vm = this;
                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedUserId = '';

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowUserStats = false;
                vm.isShowWidgetEditor = false;

                //Search Variables
                vm.isRefreshData = true;

                vm.stateFieldArr = [
                    {name: 'ACTIVE', displayName: 'ACTIVE'},
                    {name: 'UNCONFIRMED', displayName: 'UNCONFIRMED'},
                    {name: 'SUSPENDED', displayName: 'SUSPENDED'},
                    {name: 'UNPAID', displayName: 'UNPAID'},
                    {name: 'CLOSED', displayName: 'CLOSED'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    },
                    {
                        displayName: "Email",
                        name: "email",
                        regexp: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
                        errorMessage: "Invalid Email address."
                    },
                    {
                        displayName: "Username",
                        name: "username",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "First Name",
                        name: "firstName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "Last Name",
                        name: "lastName",
                        regexp: "",
                        errorMessage: ""
                    },
                    {
                        displayName: "State",
                        name: "state",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.stateFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'firstName', displayName: 'Firstname'},
                    {name: 'lastName', displayName: 'Lastname'},
                    {name: 'description', displayName: 'Description'},
                    {name: 'email', displayName: 'Email'},
                    {name: 'username', displayName: 'Username'},
                    {name: 'state', displayName: 'State'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Users Variables
                vm.isUsersloading = false;
                vm.userArr = [];
                vm.selectedUsersArr = [];
                vm.selectedUserObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet('loginUser');
                vm.lastSQLQuery = "";
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.userResponse = [];

                //sort variables
                vm.filteredData = [];
                vm.csvHeaderArr = [];

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                function parsePostgresData(items) {
                    return items.map(function(item) {
                        var parsedItem = _.cloneDeep(item);

                        // Handle timestamps standardization
                        if (angular.isDefined(parsedItem.updatedAt)) {
                            parsedItem.updatedAt = parsedItem.updatedAt;
                        } else if (angular.isDefined(parsedItem.updated_at)) {
                            parsedItem.updatedAt = parsedItem.updated_at;
                        }

                        if (angular.isDefined(parsedItem.createdAt)) {
                            parsedItem.createdAt = parsedItem.createdAt;
                        } else if (angular.isDefined(parsedItem.created_at)) {
                            parsedItem.createdAt = parsedItem.created_at;
                        }

                        // Handle ECU connection status
                        if (angular.isDefined(parsedItem.ecuConnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuConnected === true || parsedItem.ecuConnected === 'true';
                        } else if (angular.isDefined(parsedItem.ecuconnected)) {
                            parsedItem.ecuConnected = parsedItem.ecuconnected === true || parsedItem.ecuconnected === 'true';
                        }

                        if (angular.isString(parsedItem.data)) {
                            try {
                                var parsedData = angular.fromJson(parsedItem.data);

                                // Handle node connection status from data
                                if (angular.isDefined(parsedData.connected)) {
                                    parsedData.connected = parsedData.connected === "true" || parsedData.connected === true;
                                }

                                // Set receivedAt from _event_time if available
                                if (parsedData._event_time && parsedData._event_time.value) {
                                    var microseconds = parseInt(parsedData._event_time.value);
                                    if (!isNaN(microseconds)) {
                                        parsedItem.receivedAt = Math.floor(microseconds / 1000000);
                                    }
                                }

                                // Set healthLastChangedAt from updated_at
                                if (parsedItem.updated_at) {
                                    parsedItem.healthLastChangedAt = new Date(parsedItem.updated_at).getTime() / 1000;
                                }

                                // Merge the parsed data with our item
                                return angular.extend({}, parsedItem, parsedData);
                            } catch (e) {
                                $log.error('Error parsing data:', e);
                                return parsedItem;
                            }
                        }
                        return parsedItem;
                    });
                }

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'user', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isUsersloading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_users';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetUsers(input, true);
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#userTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetUserStateIcon = function (state) {
                    var icon = IconService.fnGetUserStateIconClass(state);
                    switch (state) {
                        case "ACTIVE":
                            return icon;
                        case "SUSPENDED":
                            return icon + ' InactiveStateIcon';
                        default:
                            return icon + ' unconfirmedStateIcon';
                    }
                };

                vm.getUserStateColor = function (state) {
                    return ColorService.getUserStateColor(state);
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnReturnUserImg = function (userObj) {
                    return AvatarService.getTextAvatar(userObj);
                };

                vm.fnGetUsers = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse the data
                            var parsedResponse = _.cloneDeepWith(res);
                            parsedResponse.data = parsePostgresData(res.data);
                            vm.userResponse = parsedResponse;

                            if (isFirst) {
                                if (vm.userResponse.data && vm.userResponse.data.length) {
                                    vm.totalItems = vm.userResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.userResponse.data.reverse();
                            }
                            vm.userArr = vm.userResponse.data;
                            if ($stateParams.selectedId) {
                                var userData = _.find(vm.userArr, {"id": $stateParams.selectedId});
                                if (userData) {
                                    vm.fnCheckUncheckHeader(userData);
                                }
                            }
                            if (addedUserId.length) {
                                vm.fnOpenPostCreateActionModal(addedUserId);
                                addedUserId = '';
                            }
                            vm.isRefresh = false;
                            vm.isUsersloading = false;
                            if ($state.current.name === 'main.users') {
                                $timeout(function () {
                                    $state.go('main.users', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                    $stateParams.page = vm.currentPage;
                                    $stateParams.perPage = vm.perPage;
                                }, 10)
                            }
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUsersloading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getUserCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.userArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.userArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.securityRoleIds;
                        delete tempObj.userGroupIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Users");
                    XLSX.writeFile(wb, "users.xlsx");
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.userArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedUsersArr = [];
                                vm.selectedUserObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.users', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Invite User";
                        vm.isShowUserStats = tab.id === "UserStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Invite User";
                    vm.isShowUserStats = tab.id === "UserStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Invite User" || tab.id === "Create Issue" || tab.id === "UserStats" || tab.id === "WidgetEditor") {
                        $state.go('main.users', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.users', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnCheckUncheckHeader = function (userObj, fromList) {
                    if (vm.permissionsObj.DESCRIBE_USER) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.userArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === userObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedUsersArr, {'id': userObj.id});
                        if (!isValueFind) {
                            vm.selectedUsersArr.push(userObj);
                            var isTabExist = _.find(vm.tabs, {'id': userObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: userObj.id,
                                    title: userObj.firstName + ' ' + userObj.lastName,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedUsersArr, function (obj) {
                                return userObj.id === obj.id;
                            });
                        }
                        if (vm.selectedUsersArr.length === 1) {
                            vm.fnGetUserDetails(vm.selectedUsersArr[0])
                        } else {
                            $state.go('main.users', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.userArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedUsersArr = _.cloneDeepWith(vm.userArr);
                    } else {
                        vm.selectedUsersArr = [];
                    }
                    $state.go('main.users', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserDetails = function (userObj, field) {
                    var inputObj = {
                        body: {},
                        userId: userObj.id
                    };
                    inputObj.body[field] = userObj[field];
                    UserFactory.updateUserState(inputObj)
                        .then(function (response) {
                            vm.fnUserDetailsChangeEvent(response);
                            vm.isUpdateCompleted = true;
                            amaran.success("User Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isUpdateCompleted = true;
                        })
                };

                vm.fnUserDetailsChangeEvent = function (data) {
                    var resetCopy = _.cloneDeepWith(data);
                    angular.forEach(vm.userArr, function (userObj) {
                        if (userObj.id === vm.selectedUserObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedUserObj[key] = val;
                                userObj[key] = val;
                            });
                        }
                    });
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };

                vm.fnOpenUserInfoTab = function (userObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(userObj);
                };

                vm.fnGetUser = function (userObj, userArr) {
                    angular.forEach(userArr, function (user) {
                        user.isCheck = false;
                    });
                    userObj.isCheck = true;
                    vm.selectedUsersArr = [userObj]; // Assign array with single user object
                    vm.fnGetUserDetails(userObj);
                };

                vm.fnGetUserDetails = function (userObj) {
                    vm.isUserDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedUserObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.users', {
                                selectedId: vm.selectedUserObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedUserObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isUserDetailsLoaded = true;
                        } else {
                            if (vm.isEditing === true) {
                                $state.go('main.users', {
                                    selectedId: vm.selectedUserObj.id,
                                    selectedDetailsTab: 1,
                                    openEditView: 'true'
                                }, {notify: false});
                                $stateParams.selectedId = vm.selectedUserObj.id;
                                $stateParams.openEditView = 'true';
                                vm.isUserDetailsLoaded = true;
                                vm.isEditing = false;
                            } else {
                                $state.go('main.users', {selectedId: vm.selectedUserObj.id}, {notify: false});
                                $stateParams.selectedId = vm.selectedUserObj.id;
                                vm.isUserDetailsLoaded = true;
                            }
                        }
                    })
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Invite User'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Invite User',
                                title: 'Invite User',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.users', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            //vm.fnUpdateUserData(perPage);
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isUsersloading = true;
                    vm.selectedUsersArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_users';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_users';
                    }
                    if (isPerPageChanged) { //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_users';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_users';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetUsers(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.userArr);
                        vm.previousPage = page;
                        vm.fnGetUsers(input, false);
                    }
                };

                vm.resendUserActivationLink = function (user) {
                    user.isResendEmaiDone = true;
                    var inputObj = {
                        userId: user.id,
                        identifier: user.email
                    };
                    UserFactory.requestUnconfirmedUserActivationLink(inputObj)
                        .then(function () {
                            $timeout(function () {
                                delete user.isResendEmaiDone;
                            });
                            amaran.success("Email send Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                /*END: TABLE*/

                $scope.$on("UserDeleted", function (evt, data) {
                    vm.selectedUserObj = null;
                    vm.selectedUsersArr = [];
                    vm.userArr = vm.userArr.filter(function (userObj) {
                        return (userObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.users', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("UserDetailsChanged", function (evt, data) {
                    // Parse the incoming data to ensure booleans are handled correctly
                    var parsedData = parsePostgresData([data])[0];
                    var resetCopy = _.cloneDeepWith(parsedData);

                    angular.forEach(vm.userArr, function (userObj) {
                        if (userObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                userObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("userAdded", function (evt, data) {
                    var postActionOptions = UserProfileService.fnGetSystemProfileObj('postActionOptionsEnabled');
                    if (postActionOptions === false) {
                        addedUserId = '';
                    } else {
                        addedUserId = data;
                    }
                    vm.fnRemoveTab('Invite User');
                });

                vm.fnDeleteMultipleUsers = function (selectedUsersArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedUsersArr, function (selectedUser, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/users/users/" + selectedUser.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/users/" + selectedUser.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected users?",
                            text: "You are about to permanently delete the selected users.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedUsersArr, function (selectedUser) {
                                    angular.forEach(vm.userArr, function (userObj, index) {
                                        if (selectedUser.id === userObj.id) {
                                            vm.userArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedUsersArr.length;
                                vm.selectedUserObj = null;
                                vm.selectedUsersArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedUsersArr, function (selectedUser) {
                                    angular.forEach(vm.userArr, function (userObj, index) {
                                        if (selectedUser.id === userObj.id) {
                                            vm.userArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedUsersArr.length;
                                vm.selectedUserObj = null;
                                vm.selectedUsersArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnCheckAuthUser = function (selectedUsersArr) {
                    var authUser = Authenticate.fnIsAuthUser(selectedUsersArr);
                    if (authUser) {
                        return true;
                    } else {
                        return false;
                    }
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'user', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.users", tempArr, {notify: false});
                    }
                };

                vm.fnInitUsers = function () {
                    vm.permissionsObj = PermissionsService.getPermissionsV4('access');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'user', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetUserDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetUserStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'UserStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowUserStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'UserStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowUserStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'user', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var accessPermissionsObj = PermissionsService.getPermissionsV4('access');
                    var optionsArr = [{
                        svgIcon: "assets/images/svg/service/group.svg#group_1",
                        subOptions: [{
                            displayText: "Add to an existing Team",
                            isRedirect: false,
                            selectedTab: 2,
                            isVisible: accessPermissionsObj.ADD_USER_TO_TEAM
                        }, {
                            displayText: "Create a new Team",
                            isRedirect: true,
                            stateName: "main.teams",
                            isVisible: accessPermissionsObj.CREATE_TEAM
                        }]
                    }];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj);
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else {
                                var userData = _.find(vm.userArr, {"id": selectedId});
                                if (userData) {
                                    $state.go('main.users', {selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    //vm.fnGetUser(userData, vm.userArr);
                                    vm.fnCheckUncheckHeader(userData);
                                } else {
                                    var tempArr = [
                                        {
                                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                            name: "Keyword: " + selectedId,
                                            searchText: selectedId
                                        }
                                    ];
                                    $state.go('main.users', {
                                        filter: angular.toJson(tempArr),
                                        selectedId: selectedId,
                                        selectedDetailsTab: selectedOption.selectedTab
                                    }, {notify: false});
                                    $stateParams.filter = angular.toJson(tempArr);
                                    $stateParams.selectedId = selectedId;
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnReload();
                                }
                            }
                        }, function () {
                        });
                    }
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessUserChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var userKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.users') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedUsersArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleUsers(vm.selectedUsersArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var userKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.users') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', userKeyDownEventHandler);
                document.addEventListener('keyup', userKeyUpEventHandler);

                $scope.$on("$destroy", function () {
                    document.removeEventListener('keydown', userKeyDownEventHandler);
                    document.removeEventListener('keyup', userKeyUpEventHandler);
                })
            }
        );
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('TeamsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, amaran, swal, moment,
                      microSpinner, WidgetsListService, PaginationQueryService, UserProfileService, DB,
                      XLSX, Authenticate, LastPageService, PermissionsService, jsonToCsvConvertService,
                      FedSudoUserService, BatchFactory, PaginationService, UserFactory, TeamFactory,
                      postActionModelIcon, postActionModelMessage, QueryFactory, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                var addedTeamId = '';

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Teams Variables
                vm.isTeamsLoading = false;
                vm.teamsArr = [];
                vm.selectedTeamsArr = [];
                vm.selectedTeamObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.teamResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };

                vm.isShowDashboard = false;
                vm.isShowTeamStats = false;
                vm.isShowDashboard = false;
                vm.isCreate = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditTeamObj = {};

                vm.teamContextMenu = function (teamObj) {
                    if (Object.keys(vm.resetEditTeamObj).length) {
                        var isFindTeam = _.find(vm.teamsArr, {id: vm.resetEditTeamObj.id});
                        if (isFindTeam) {
                            vm.fnCancelTeamEditMode(isFindTeam);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            teamObj.isEditable = true;
                            vm.resetEditTeamObj = angular.copy(teamObj);
                        }
                    }]
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.parsePostgresData = function(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    var currentTime = moment();

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                // Core team fields
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',

                                // Timestamps and creator info
                                createdAt: parseInt(parsedData.createdAt) || 0,
                                createdBy: parsedData.createdBy || '',
                                updatedAt: parseInt(parsedData.updatedAt) || 0,
                                updatedBy: parsedData.updatedBy || '',

                                // Metadata and query-related fields
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process creation time
                            if (parsedItem.createdAt) {
                                var createdTimestamp = moment.unix(parsedItem.createdAt);
                                var createdDifferenceHours = currentTime.diff(createdTimestamp, 'hours');
                                parsedItem.createdDate = createdDifferenceHours > 24
                                    ? createdTimestamp.format("DD/MM/YYYY")
                                    : createdTimestamp.fromNow();
                            }

                            // Process update time
                            if (parsedItem.updatedAt) {
                                var updatedTimestamp = moment.unix(parsedItem.updatedAt);
                                var updatedDifferenceHours = currentTime.diff(updatedTimestamp, 'hours');
                                parsedItem.updatedDate = updatedDifferenceHours > 24
                                    ? updatedTimestamp.format("DD/MM/YYYY")
                                    : updatedTimestamp.fromNow();
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                };

                vm.fnCancelTeamEditMode = function (teamObj, isSuccessCall) {
                    if (isSuccessCall) {
                        teamObj.name = angular.copy(teamObj.name);
                        teamObj.description = angular.copy(teamObj.description);
                        teamObj.isEditable = false;
                        vm.resetEditTeamObj = {};
                    } else {
                        teamObj.name = angular.copy(vm.resetEditTeamObj.name);
                        teamObj.description = angular.copy(vm.resetEditTeamObj.description);
                        teamObj.isEditable = false;
                        vm.resetEditTeamObj = {};
                    }
                };

                vm.fnSaveTeamInfo = function (teamObj) {
                    teamObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        teamId: teamObj.id
                    };
                    inputObj.body = {
                        name: teamObj.name,
                        description: angular.isUndefined(teamObj.description) ? '' : teamObj.description
                    };
                    TeamFactory.updateTeam(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.teamsArr, function (teamObj) {
                                if (Object.keys(vm.selectedTeamObj).length) {
                                    if (teamObj.id === vm.selectedTeamObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedTeamObj[key] = val;
                                            teamObj[key] = val;
                                        });
                                    }
                                }
                                if (teamObj.id === resetCopy.id) {
                                    teamObj.name = resetCopy.name;
                                    teamObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelTeamEditMode(teamObj, true);
                            amaran.success("Team Updated Successfully");
                        }, function (error) {
                            vm.fnCancelTeamEditMode(teamObj);
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'team', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isTeamsLoading = true;
                    vm.selectedTeamsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_teams';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_teams';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetTeams(input, true);
                };

                /*END: Search*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindUser = _.find(vm.teamsArr, {id: tab.id});
                            if (isFindUser) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedTeamsArr = [];
                                vm.selectedTeamObj = {};
                                vm.fnCheckUncheckHeader(isFindUser);
                            }
                        } else {
                            $state.go('main.teams', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Team";
                        vm.isShowTeamStats = tab.id === "teamStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Team";
                    vm.isShowTeamStats = tab.id === "teamStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Team" ||  tab.id === "Create Issue" || tab.id === "teamStats" || tab.id === "WidgetEditor") {
                        $state.go('main.teams', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1) || id === "Create Team") {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.teams', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (userObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(userObj);
                };
                /*Tab: End*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#teamTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (teamObj, fromList) {
                    vm.isAllChecked = true;
                    angular.forEach(vm.teamsArr, function (obj) {
                        if (!obj.isCheck) {
                            vm.isAllChecked = false;
                        }
                        if (fromList) {
                            if (obj.id === teamObj.id) {
                                obj.isCheck = false;
                                vm.isAllChecked = false;
                            }
                        }
                    });

                    /* Toggle push in selected team array*/
                    var isValueFind = _.find(vm.selectedTeamsArr, {'id': teamObj.id});
                    if (!isValueFind) {
                        vm.selectedTeamsArr.push(teamObj);
                        var isTabExist = _.find(vm.tabs, {'id': teamObj.id});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: teamObj.id,
                                title: teamObj.name,
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateUserProfileData();
                            });
                        }
                    } else {
                        _.remove(vm.selectedTeamsArr, function (obj) {
                            return teamObj.id === obj.id;
                        });
                    }
                    if (vm.selectedTeamsArr.length === 1) {
                        vm.fnGetTeamDetails(vm.selectedTeamsArr[0])
                    } else {
                        $state.go('main.teams', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.teamsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedTeamsArr = angular.copy(vm.teamsArr);
                    } else {
                        vm.selectedTeamsArr = [];
                    }
                    $state.go('main.teams', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    if (vm.permissionObj.DESCRIBE_TEAM) {
                        vm.selectedTeamsArr = [];
                        vm.isAllChecked = false;
                        vm.fnCheckUncheckAll();
                        if (isCalledForOpen) {
                            vm.isCreate = true;
                        } else {
                            vm.isCreate = !vm.isCreate;
                        }
                        if (vm.isCreate) {
                            var isTabExist = _.find(vm.tabs, {'id': 'Create Team'});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: 'Create Team',
                                    title: 'Create Team',
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.teams', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isTeamsLoading = true;
                    vm.selectedTeamsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_teams';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_teams';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_teams';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_teams';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetTeams(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.teamsArr);
                        vm.previousPage = page;
                        vm.fnGetTeams(input, false);
                    }
                };

                vm.fnOpenTeamInfoTab = function (teamObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(teamObj);
                };

                vm.fnGetTeam = function (teamObj, teamsArr) {
                    angular.forEach(teamsArr, function (team) {
                        team.isCheck = false;
                    });
                    teamObj.isCheck = true;
                    vm.selectedTeamsArr = [teamObj]; // Assign array with single Team object
                    vm.fnGetTeamDetails(teamObj);
                };

                vm.fnGetTeamDetails = function (teamObj) {
                    vm.isTeamDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when team is selected
                        vm.selectedTeamObj = teamObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.teams', {
                                selectedId: vm.selectedTeamObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedTeamObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isTeamDetailsLoaded = true;
                        } else {
                            $state.go('main.teams', {selectedId: vm.selectedTeamObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedTeamObj.id;
                            vm.isTeamDetailsLoaded = true;
                        }
                    })
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetTeams = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            res.data = vm.parsePostgresData(res.data);
                            vm.teamResponse = _.cloneDeepWith(res);
                            if (isFirst) {
                                if (vm.teamResponse.data && vm.teamResponse.data.length) {
                                    vm.totalItems = vm.teamResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.teamResponse.data.reverse();
                            }
                            vm.teamsArr = vm.teamResponse.data;
                            var test = DB.fnGet('isCalledFromUser');
                            if (angular.isDefined(test) && test === true && res.length === 1) {
                                res[0].isCheck = true;
                                vm.fnGetTeam(res[0], vm.teamsArr);
                                DB.fnRemove('isCalledFromUser');
                            } else if ($stateParams.openCreateView && ($stateParams.openCreateView === 'true' ||
                                $stateParams.openCreateView === true)) {
                                vm.fnHideShowCreateForm();
                            } else if ($stateParams.selectedId) {
                                var teamData = _.find(vm.teamsArr, {"id": $stateParams.selectedId});
                                if (teamData) {
                                    vm.fnCheckUncheckHeader(teamData)
                                }
                            }
                            if (addedTeamId.length) {
                                vm.fnOpenPostCreateActionModal(addedTeamId);
                                addedTeamId = '';
                            }
                            if ($state.current.name === 'main.teams') {
                                $state.go('main.teams', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage,
                                    openCreateView: ''
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                                delete $stateParams.openCreateView;
                            }
                            vm.isRefresh = false;
                            vm.isTeamsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isTeamsLoading = false;
                            vm.isRefresh = false;
                        })
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("TeamDeleted", function (evt, data) {
                    vm.selectedTeamObj = null;
                    vm.selectedTeamsArr = [];
                    vm.teamsArr = vm.teamsArr.filter(function (teamObj) {
                        return (teamObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.teams', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("TeamDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.teamsArr, function (teamObj) {
                        if (teamObj.id === data.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedTeamObj[key] = val;
                                teamObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("teamAdded", function (evt, data) {
                    var postActionOptions = UserProfileService.fnGetSystemProfileObj('postActionOptionsEnabled');
                    if (postActionOptions === false) {
                        addedTeamId = '';
                    } else {
                        addedTeamId = data;
                    }
                    vm.fnRemoveTab('Create Team');
                });

                vm.fnDeleteMultipleTeams = function (selectedTeamsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedTeamsArr, function (selectedTeam, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + selectedTeam.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/teams/" + selectedTeam.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected Teams?",
                            text: "You are about to permanently delete the selected teams.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTeamsArr, function (selectedTeam) {
                                    angular.forEach(vm.teamsArr, function (teamObj, index) {
                                        if (selectedTeam.id === teamObj.id) {
                                            vm.teamsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTeamsArr.length;
                                vm.selectedTeamObj = null;
                                vm.selectedTeamsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedTeamsArr, function (selectedTeam) {
                                    angular.forEach(vm.teamsArr, function (teamObj, index) {
                                        if (selectedTeam.id === teamObj.id) {
                                            vm.teamsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedTeamsArr.length;
                                vm.selectedTeamObj = null;
                                vm.selectedTeamsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'team', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.teams", tempArr, {notify: false});
                    }
                };

                vm.fnInitTeams = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("access");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'team', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetTeamDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetTeamStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'teamStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowTeamStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'teamStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowTeamStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenPostCreateActionModal = function (selectedId) {
                    var accessPermissionsObj = PermissionsService.getPermissionsV4('access');
                    var optionsArr = [
                        {
                            svgIcon: "assets/images/svg/service/user.svg#user_1",
                            subOptions: [
                                {
                                    displayText: "Add Users",
                                    isRedirect: false,
                                    selectedTab: 3,
                                    isVisible: accessPermissionsObj.ADD_USER_TO_TEAM
                                }
                            ]
                        }
                    ];
                    var finalOptionsArr = [];
                    _.forEach(optionsArr, function (optionObj) {
                        _.forEach(optionObj.subOptions, function (subOptionObj, index) {
                            if (subOptionObj && subOptionObj.isVisible === false) {
                                optionObj.subOptions.splice(index, 1);
                            }
                        });
                        if (optionObj.subOptions.length) {
                            finalOptionsArr.push(optionObj)
                        }
                    });
                    if (finalOptionsArr.length) {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/modals/postCreateActionModal/postCreateActionModal.html',
                            size: 'md',
                            controller: 'postCreateActionModalCtrl as postCreateAction',
                            resolve: {
                                postCreateOptionsArr: function () {
                                    return finalOptionsArr;
                                }
                            }
                        });
                        modalInstance.result.then(function (selectedOption) {
                            if (selectedOption.isRedirect) {
                                if (selectedOption.stateName.includes(".create")) {
                                    $state.go(selectedOption.stateName);
                                } else {
                                    $state.go(selectedOption.stateName, {openCreateView: true});
                                }
                            } else {
                                var teamData = _.find(vm.teamsArr, {"id": selectedId});
                                if (teamData) {
                                    $state.go('main.teams', {selectedDetailsTab: selectedOption.selectedTab}, {notify: false});
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    //vm.fnGetTeam(teamData, vm.teamsArr);
                                    vm.fnCheckUncheckHeader(teamData);
                                } else {
                                    var tempArr = [
                                        {
                                            id: Math.floor(Math.random() * (567234908 - 0 + 1)) + 0,
                                            name: "Keyword: " + selectedId,
                                            searchText: selectedId
                                        }
                                    ];
                                    $state.go('main.teams', {
                                        filter: angular.toJson(tempArr),
                                        selectedId: selectedId,
                                        selectedDetailsTab: selectedOption.selectedTab
                                    }, {notify: false});
                                    $stateParams.filter = angular.toJson(tempArr);
                                    $stateParams.selectedId = selectedId;
                                    $stateParams.selectedDetailsTab = selectedOption.selectedTab;
                                    vm.fnReload();
                                }
                            }
                        }, function () {
                        });
                    }
                };

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getTeamCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.teamsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var usersArrCp = _.cloneDeepWith(vm.teamsArr);
                    var tempData = _.map(usersArrCp, function (tempObj) {
                        delete tempObj.userIds;
                        delete tempObj.data;
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Teams");
                    XLSX.writeFile(wb, "teams.xlsx");
                };
                /* Export Modal: End */

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'team', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessTeamChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var teamKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.teams') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedTeamsArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleTeams(vm.selectedTeamsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var teamKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.teams') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', teamKeyDownEventHandler);
                document.addEventListener('keyup', teamKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', teamKeyDownEventHandler);
                    document.removeEventListener('keyup', teamKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('ScriptsCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      PermissionsService, QueryFactory, UserProfileService, LastPageService, PaginationService,
                      amaran, swal, microSpinner, postActionModelMessage, postActionModelIcon,
                      jsonToCsvConvertService, WidgetsListService, ScriptFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowScriptStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //Scripts Variables
                vm.isScriptsloading = false;
                vm.scriptArr = [];
                vm.selectedScriptsArr = [];
                vm.selectedScriptObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.scriptResponse = [];
                vm.isSinglePage = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 's4', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterScriptArr = [];
                    var scriptArr = [];
                    if (vm.scriptResponse.length) {
                        if (vm.filterQuery) {
                            filterScriptArr = _.filter(vm.scriptResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterScriptArr = _.cloneDeepWith(vm.scriptResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            scriptArr = _.orderBy(filterScriptArr, [sortValue], [sortType]);
                        } else {
                            scriptArr = _.cloneDeepWith(filterScriptArr);
                        }
                    }
                    vm.totalItems = scriptArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.scriptArr = scriptArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.scripts') {
                        $timeout(function () {
                            $state.go('main.scripts', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isScriptsloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#scriptTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (scriptObj, fromList) {
                    if (vm.permissionsObj.DESCRIBE_SCRIPT) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.scriptArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === scriptObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedScriptsArr, {'id': scriptObj.id});
                        if (!isValueFind) {
                            vm.selectedScriptsArr.push(scriptObj);
                            var isTabExist = _.find(vm.tabs, {'id': scriptObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: scriptObj.id,
                                    title: scriptObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedScriptsArr, function (obj) {
                                return scriptObj.id === obj.id;
                            });
                        }
                        if (vm.selectedScriptsArr.length === 1) {
                            vm.fnGetScriptDetails(vm.selectedScriptsArr[0])
                        } else {
                            $state.go('main.scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetScriptDetails = function (userObj) {
                    vm.isScriptDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedScriptObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.scripts', {
                                selectedId: vm.selectedScriptObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isScriptDetailsLoaded = true;
                        } else {
                            $state.go('main.scripts', {selectedId: vm.selectedScriptObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedScriptObj.id;
                            vm.isScriptDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.scriptArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedScriptsArr = _.cloneDeepWith(vm.scriptArr);
                    } else {
                        vm.selectedScriptsArr = [];
                    }
                    $state.go('main.scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        scriptId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isScriptsloading = true;
                    vm.selectedScriptsArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetScripts();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetScript = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedScriptsArr = [tokenObj]; // Assign array with single token object
                    vm.selectedScriptObj = tokenObj;
                };

                vm.fnGetScripts = function () {
                    if (vm.permissionsObj.LIST_SCRIPT_TYPES) {
                        ScriptFactory.listScriptTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.scriptResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var scriptData = _.find(vm.scriptArr, {"id": $stateParams.selectedId});
                                    if (scriptData) {
                                        vm.fnCheckUncheckHeader(scriptData);
                                    }
                                }
                                if ($state.current.name === 'main.scripts') {
                                    $state.go('main.scripts', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isScriptsloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.scriptResponse = [];
                        vm.fnGetFilterData();
                        vm.isScriptsloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindScript = _.find(vm.scriptArr, {id: tab.id});
                            if (isFindScript) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedScriptsArr = [];
                                vm.selectedScriptObj = {};
                                vm.fnCheckUncheckHeader(isFindScript);
                            }
                        } else {
                            $state.go('main.scripts', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowScriptStats = tab.id === "ScriptStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowScriptStats = tab.id === "ScriptStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "ScriptStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor") {
                        $state.go('main.scripts', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.scripts', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 's4', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetScriptStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'ScriptStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowScriptStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'ScriptStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowScriptStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 's4', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.scripts", tempArr, {notify: false});
                    }
                };

                vm.fnInitScript = function () {
                    vm.permissionsObj = PermissionsService.getPermissionsV4('access');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 's4', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessS4ChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('FederationsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, moment, $uibModal, WidgetsListService, PaginationQueryService, UserProfileService, SecurityGroupFactory, SecurityRoleFactory, amaran, swal, microSpinner, DB, Authenticate, BatchFactory, XLSX, jsonToCsvConvertService, LastPageService, PermissionsService, PaginationService, FedSudoUserService, UserFactory, FederationsFactory, postActionModelIcon, postActionModelMessage, QueryFactory, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };

                //Search Variables
                vm.isRefreshData = true;

                var typeFieldArr = [
                    {name: 'INBOUND', displayName: 'INBOUND'},
                    {name: 'OUTBOUND', displayName: 'OUTBOUND'}
                ];

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Alias",
                        name: "alias",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Type",
                        name: "type",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: typeFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }];

                vm.sortFieldArr = [
                    {name: 'alias', displayName: 'Alias'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //federations Variables
                vm.isFederationsLoading = false;
                vm.federationsArr = [];
                vm.selectedFederationsArr = [];
                vm.selectedfederationObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.federationsResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateFederationProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowFederationStats = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                /*Start: Context Menu*/
                vm.resetEditFederationObj = {};
                vm.federationContextMenu = function (federationObj) {
                    if (Object.keys(vm.resetEditFederationObj).length) {
                        var isFindFederation = _.find(vm.federationsArr, {id: vm.resetEditFederationObj.id});
                        if (isFindFederation) {
                            vm.fnCancelFederationEditMode(isFindFederation);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            federationObj.isEditable = true;
                            vm.resetEditFederationObj = angular.copy(federationObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing federation data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                id: item.id || parsedData.id || '',
                                alias: item.alias || parsedData.alias || '',
                                type: (item.type || parsedData.type || '').toUpperCase(), // Ensure uppercase for type
                                description: item.description || parsedData.description || '',
                                createdAt: item.created_at || parsedData.createdAt || '',
                                updatedAt: item.updated_at || parsedData.updatedAt || '',
                                createdBy: item.created_by || parsedData.createdBy || '',
                                updatedBy: item.updated_by || parsedData.updatedBy || '',
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };

                            // Process relative times if timestamps exist
                            if (parsedItem.createdAt) {
                                parsedItem.createdDate = vm.fnGetAbsoluteOrRelativeTime(parsedItem.createdAt);
                            }
                            if (parsedItem.updatedAt) {
                                parsedItem.updatedDate = vm.fnGetAbsoluteOrRelativeTime(parsedItem.updatedAt);
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }


                vm.fnCancelFederationEditMode = function (federationObj, isSuccessCall) {
                    if (isSuccessCall) {
                        federationObj.alias = angular.copy(federationObj.alias);
                        federationObj.description = angular.copy(federationObj.description);
                        federationObj.isEditable = false;
                        vm.resetEditFederationObj = {};
                    } else {
                        federationObj.alias = angular.copy(vm.resetEditFederationObj.alias);
                        federationObj.description = angular.copy(vm.resetEditFederationObj.description);
                        federationObj.isEditable = false;
                        vm.resetEditFederationObj = {};
                    }
                };

                vm.fnSaveFederationInfo = function (federationObj) {
                    federationObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        federationId: federationObj.id
                    };
                    inputObj.body = {
                        alias: federationObj.alias,
                        description: angular.isUndefined(federationObj.description) ? '' : federationObj.description
                    };
                    FederationsFactory.updateFederation(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.federationsArr, function (federationObj) {
                                if (Object.keys(vm.selectedfederationObj).length) {
                                    if (federationObj.id === vm.selectedfederationObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedfederationObj[key] = val;
                                            federationObj[key] = val;
                                        });
                                    }
                                }
                                if (federationObj.id === resetCopy.id) {
                                    federationObj.alias = resetCopy.alias;
                                    federationObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelFederationEditMode(federationObj, true);
                            amaran.success("Federation Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelFederationEditMode(federationObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'federation', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    vm.isFederationsLoading = true;
                    vm.selectedFederationsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_federations';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_federations';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetFederations(input, true);
                };
                /*END: Search*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAccountCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.federationsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var federationsArrCp = _.cloneDeepWith(vm.federationsArr);
                    var tempData = _.map(federationsArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Federations");
                    XLSX.writeFile(wb, "federations.xlsx");
                };
                /* Export Modal: End */

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#federationsTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckHeader = function (federationObj, fromList) {
                    if (vm.permissionsObj.DESCRIBE_FEDERATION) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.federationsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === federationObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected federation array*/
                        var isValueFind = _.find(vm.selectedFederationsArr, {'id': federationObj.id});
                        if (!isValueFind) {
                            vm.selectedFederationsArr.push(federationObj)
                            var isTabExist = _.find(vm.tabs, {'id': federationObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: federationObj.id,
                                    title: federationObj.alias,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateFederationProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedFederationsArr, function (obj) {
                                return federationObj.id === obj.id;
                            });
                        }
                        if (vm.selectedFederationsArr.length === 1) {
                            vm.fnGetFederationDetails(vm.selectedFederationsArr[0])
                        } else {
                            $state.go('main.federations', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.federationsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedFederationsArr = angular.copy(vm.federationsArr);
                    } else {
                        vm.selectedFederationsArr = [];
                    }
                    $state.go('main.federations', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenFederationsInfoTab = function (federationObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(federationObj);
                };

                vm.fnGetFederation = function (federationObj, federationsArr) {
                    angular.forEach(federationsArr, function (federation) {
                        federation.isCheck = false;
                    });
                    federationObj.isCheck = true;
                    vm.selectedFederationsArr = [federationObj]; // Assign array with single federation object
                    vm.fnGetFederationDetails(federationObj);
                };

                vm.fnGetFederationDetails = function (federationObj) {
                    vm.isFederationDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when federation is selected
                        vm.selectedfederationObj = federationObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.federations', {
                                selectedId: vm.selectedfederationObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedfederationObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isFederationDetailsLoaded = true;
                        } else {
                            $state.go('main.federations', {selectedId: vm.selectedfederationObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedfederationObj.id;
                            vm.isFederationDetailsLoaded = true;
                        }
                    });
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetFederations = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var parsedData = parsePostgresData(res.data);
                            vm.federationsResponse = _.cloneDeepWith(res);
                            vm.federationsResponse.data = parsedData;
                            if (isFirst) {
                                if (vm.federationsResponse.data && vm.federationsResponse.data.length) {
                                    vm.totalItems = vm.federationsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.federationsResponse.data.reverse();
                            }
                            vm.federationsArr = vm.federationsResponse.data;
                            if ($stateParams.selectedId) {
                                var federationData = _.find(vm.federationsArr, {"id": $stateParams.selectedId});
                                if (federationData) {
                                    vm.fnCheckUncheckHeader(federationData);
                                }
                            }
                            vm.isRefresh = false;
                            vm.isFederationsLoading = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isFederationsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        })
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedFederationsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Federations'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Federations',
                                title: 'Create Federations',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateFederationProfileData();
                            });
                        }
                    }
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.federations', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isFederationsLoading = true;
                    vm.selectedFederationsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_federations';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_federations';
                    }
                    if (isPerPageChanged) {
                        //only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_federations';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_federations';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetFederations(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.federationsArr);
                        vm.previousPage = page;
                        vm.fnGetFederations(input, false);
                    }
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("federationDeleted", function (evt, data) {
                    vm.selectedfederationObj = null;
                    vm.selectedFederationsArr = [];
                    vm.federationsArr = vm.federationsArr.filter(function (federationObj) {
                        return (federationObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.federations', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("federationDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.federationsArr, function (federationObj) {
                        if (federationObj.id === vm.selectedfederationObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedfederationObj[key] = val;
                                federationObj[key] = val;
                            });
                        }
                    });
                });

                $scope.$on("federationAdded", function () {
                    vm.fnRemoveTab('Create Federations');
                });

                vm.fnDeleteMultipleFederations = function (selectedFederationsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedFederationsArr, function (selectedFederation, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/federations/" + selectedFederation.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/federations/" + selectedFederation.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected federations?",
                            text: "You are about to permanently delete the selected federations.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedFederationsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.federationsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.federationsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedFederationsArr.length;
                                vm.selectedfederationObj = null;
                                vm.selectedFederationsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedFederationsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.federationsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.federationsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedFederationsArr.length;
                                vm.selectedfederationObj = null;
                                vm.selectedFederationsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'federation', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.federations", tempArr, {notify: false});
                    }
                };

                vm.fnInitFederations = function () {
                    vm.permissionsObj = PermissionsService.getPermissionsV4('access');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'federation', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetFederationDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateFederationProfileData();
                        });
                    }
                };

                vm.fnGetFederationStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'FederationStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowFederationStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'FederationStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowFederationStats = true;
                            vm.fnUpdateFederationProfileData();
                        });
                    }
                };

                vm.fnUpdateFederationProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'federation', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateFederationProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                /*Tab: Start*/

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindfederation = _.find(vm.federationsArr, {id: tab.id});
                            if (isFindfederation) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedFederationsArr = [];
                                // vm.selectedUserGroupObj = {};
                                vm.fnCheckUncheckHeader(isFindfederation);
                            }
                        } else {
                            $state.go('main.federations', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Federations";
                        vm.isShowFederationStats = tab.id === "FederationStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Federations";
                    vm.isShowFederationStats = tab.id === "FederationStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Federations" || tab.id === "Create Issue" || tab.id === "FederationStats" || tab.id === "WidgetEditor") {
                        $state.go('main.federations', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.federations', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateFederationProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditUserInfoTab = function (federationObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(federationObj);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessFederationChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                /*Tab: End*/

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                var federationKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.federations') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedFederationsArr.length > 1 &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleFederations(vm.selectedFederationsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var federationKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.federations') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', federationKeyDownEventHandler);
                document.addEventListener('keyup', federationKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', federationKeyDownEventHandler);
                    document.removeEventListener('keyup', federationKeyUpEventHandler);
                })
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('EmailTemplateCtrl',
            function ($scope, $window, $timeout, $http, $base64, $stateParams, $state, DB, UserFactory,
                      QueryFactory, UserProfileService, LastPageService, PaginationService, amaran, swal,
                      PermissionsService, microSpinner, postActionModelMessage, postActionModelIcon,
                      jsonToCsvConvertService, WidgetsListService, EmailTemplateFactory) {
                var vm = this;

                vm.isShowDashboard = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isShowEmailTemplateStats = false;
                vm.isShowWidgetEditor = false;
                vm.isInit = true;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateUserProfileData();
                    }
                };
                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //EmailTemplates Variables
                vm.isEmailTemplatesloading = false;
                vm.emailTemplateArr = [];
                vm.selectedEmailTemplatesArr = [];
                vm.selectedEmailTemplateObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isEditing = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                var loginUser = DB.fnGet('loginUser');

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.emailTemplateResponse = [];
                vm.isSinglePage = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    $timeout(function () {
                        var windowSize = angular.element($window);
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                    });
                    vm.fnSetTableHeight();
                });

                vm.fnShowHideWidget = function () {
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                var windowSize = angular.element($window);
                vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'emailTemplate', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData();
                    }
                };

                vm.fnGetFilterData = function (page) {
                    page = page ? page : 1;
                    var filterEmailTemplateArr = [];
                    var emailTemplateArr = [];
                    if (vm.emailTemplateResponse.length) {
                        if (vm.filterQuery) {
                            filterEmailTemplateArr = _.filter(vm.emailTemplateResponse, function (obj) {
                                if (eval(vm.filterQuery)) {
                                    return obj;
                                }
                            });
                        } else {
                            filterEmailTemplateArr = _.cloneDeepWith(vm.emailTemplateResponse);
                        }
                        if (vm.sort) {
                            var sortType = vm.sort.split(' ')[1];
                            var sortValue = vm.sort.split(' ')[0];
                            emailTemplateArr = _.orderBy(filterEmailTemplateArr, [sortValue], [sortType]);
                        } else {
                            emailTemplateArr = _.cloneDeepWith(filterEmailTemplateArr);
                        }
                    }
                    vm.totalItems = emailTemplateArr.length;
                    vm.currentPage = LastPageService.getLastPage(vm.totalItems, vm.perPage, page);
                    var startItem = (vm.currentPage - 1) * vm.perPage;
                    var endItem = vm.currentPage * vm.perPage;
                    vm.emailTemplateArr = emailTemplateArr.slice(startItem, endItem);
                    if ($state.current.name === 'main.emailTemplate') {
                        $timeout(function () {
                            $state.go('main.emailTemplate', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isEmailTemplatesloading = false;
                    $timeout(function () {
                        angular.element($window).resize();
                    }, 100)
                };
                /*END: Search*/

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#emailTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnCheckUncheckHeader = function (emailTemplateObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_EMAIL_TEMPLATE) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.emailTemplateArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === emailTemplateObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });
                        var isValueFind = _.find(vm.selectedEmailTemplatesArr, {'id': emailTemplateObj.id});
                        if (!isValueFind) {
                            vm.selectedEmailTemplatesArr.push(emailTemplateObj);
                            var isTabExist = _.find(vm.tabs, {'id': emailTemplateObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: emailTemplateObj.id,
                                    title: emailTemplateObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateUserProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedEmailTemplatesArr, function (obj) {
                                return emailTemplateObj.id === obj.id;
                            });
                        }
                        if (vm.selectedEmailTemplatesArr.length === 1) {
                            vm.fnGetEmailTemplateDetails(vm.selectedEmailTemplatesArr[0])
                        } else {
                            $state.go('main.emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetEmailTemplateDetails = function (userObj) {
                    vm.isEmailTemplateDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when user is selected
                        vm.selectedEmailTemplateObj = userObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.emailTemplate', {
                                selectedId: vm.selectedEmailTemplateObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isEmailTemplateDetailsLoaded = true;
                        } else {
                            $state.go('main.emailTemplate', {selectedId: vm.selectedEmailTemplateObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedEmailTemplateObj.id;
                            vm.isEmailTemplateDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.emailTemplateArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedEmailTemplatesArr = _.cloneDeepWith(vm.emailTemplateArr);
                    } else {
                        vm.selectedEmailTemplatesArr = [];
                    }
                    $state.go('main.emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        emailTemplateId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEmailTemplatesloading = true;
                    vm.selectedEmailTemplatesArr = [];
                    vm.isAllChecked = false;
                    if (vm.isInit) {
                        vm.isInit = false;
                        vm.fnGetEmailTemplates();
                    } else {
                        vm.fnGetFilterData(page);
                    }
                };

                vm.fnGetEmailTemplate = function (tokenObj, tokenArr) {
                    angular.forEach(tokenArr, function (vault) {
                        vault.isCheck = false;
                    });
                    tokenObj.isCheck = true;
                    vm.selectedEmailTemplatesArr = [tokenObj]; // Assign array with single token object
                    vm.selectedEmailTemplateObj = tokenObj;
                };

                vm.fnGetEmailTemplates = function () {
                    if (vm.permissionObj.LIST_EMAIL_TEMPLATE_TYPES) {
                        EmailTemplateFactory.listEmailTemplateTypes()
                            .then(function (res) { // Success block
                                var tempArr = [];
                                _.forEach(res, function (obj) {
                                    tempArr.push({
                                        id: obj,
                                        type: obj,
                                        name: toUpper(obj.replace(/_/g, " "))
                                    })
                                });
                                vm.emailTemplateResponse = _.cloneDeepWith(tempArr);
                                vm.fnGetFilterData();
                                if ($stateParams.selectedId) {
                                    var emailTemplateData = _.find(vm.emailTemplateArr, {"id": $stateParams.selectedId});
                                    if (emailTemplateData) {
                                        vm.fnCheckUncheckHeader(emailTemplateData);
                                    }
                                }
                                if ($state.current.name === 'main.emailTemplate') {
                                    $state.go('main.emailTemplate', {
                                        page: vm.currentPage,
                                        perPage: vm.perPage
                                    }, {notify: false});
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            }, function (error) { // Error block
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isEmailTemplatesloading = false;
                                vm.isRefresh = false;
                                $timeout(function () {
                                    angular.element($window).resize();
                                }, 100)
                            })
                    } else {
                        vm.emailTemplateResponse = [];
                        vm.fnGetFilterData();
                        vm.isEmailTemplatesloading = false;
                        vm.isRefresh = false;
                        $timeout(function () {
                            angular.element($window).resize();
                        }, 100)
                    }
                };
                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindEmailTemplate = _.find(vm.emailTemplateArr, {id: tab.id});
                            if (isFindEmailTemplate) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEmailTemplatesArr = [];
                                vm.selectedEmailTemplateObj = {};
                                vm.fnCheckUncheckHeader(isFindEmailTemplate);
                            }
                        } else {
                            $state.go('main.emailTemplate', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowEmailTemplateStats = tab.id === "EmailTemplateStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "EmailTemplateStats" || tab.id === "Create Issue" || tab.id === "WidgetEditor") {
                        $state.go('main.emailTemplate', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.emailTemplate', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateUserProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnUpdateUserProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'emailTemplate', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    vm.isInit = true;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetEmailTemplateStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'EmailTemplateStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEmailTemplateStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'EmailTemplateStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEmailTemplateStats = true;
                            vm.fnUpdateUserProfileData();
                        });
                    }
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'emailTemplate', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.emailTemplate", tempArr, {notify: false});
                    }
                };

                vm.fnInitEmailTemplate = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('access');
                    vm.fnGetLastFilterQuery();
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'emailTemplate', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessEmailTemplateChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                function toUpper(str) {
                    return str
                        .toLowerCase().split(' ').map(function (word) {
                            return word[0].toUpperCase() + word.substr(1);
                        }).join(' ');
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('EmailCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, WidgetsListService,
                      PaginationQueryService, UserProfileService, SecurityGroupFactory,
                      SecurityRoleFactory, amaran, swal, microSpinner, DB, Authenticate, BatchFactory, XLSX,
                      jsonToCsvConvertService, LastPageService, PermissionsService, PaginationService,
                      FedSudoUserService, UserFactory, EmailFactory, QueryFactory, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                vm.isCreate = false;
                vm.newEmail = "";
                vm.isCreateDisabled = true;
                vm.isEmailCreating = true;
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "Email",
                        name: "email",
                        regexp: "^\\w+@[a-zA-Z_]+?\\.[a-zA-Z]{2,3}$",
                        errorMessage: "Invalid Email address."
                    }
                ];
                vm.sortFieldArr = [
                    {name: 'email', displayName: 'Email'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";

                //emails Variables
                vm.isEmailsLoading = false;
                vm.emailsArr = [];
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet('loginUser');
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.maxSize = 1;
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.emailsResponse = [];
                vm.isSinglePage = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.isShowDashboard = false;
                vm.isShowEmailStats = false;
                vm.isShowWidgetEditor = false;
                vm.isCreateIssue = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                });

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing whitelist email JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            return {
                                id: item.id || parsedData.id || '',
                                email: item.email || parsedData.email || '',
                                createdAt: item.created_at || parsedData.createdAt || '',
                                updatedAt: item.updated_at || parsedData.updatedAt || '',
                                createdBy: item.created_by || parsedData.createdBy || '',
                                updatedBy: item.updated_by || parsedData.updatedBy || '',
                                isVerified: item.is_verified || parsedData.isVerified || false,
                                totalItems: item.totalitems || 0,
                                rt: item.rt || ''
                            };
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    vm.filterQuery = filterQuery;
                    vm.sqlQuery = sqlQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'email', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.previousPage = 1;
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }

                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    vm.isEmailsLoading = true;
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_whitelist_emails';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_whitelist_emails';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetEmails(input, true);
                };

                vm.fnGetFilterData = function () {
                    var emailsArr = [];
                    if (vm.isSinglePage) {
                        if (vm.emailsResponse.data.length) {
                            var filterEmailsArr = [];
                            if (vm.filterQuery) {
                                filterEmailsArr = _.filter(vm.emailsResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterEmailsArr = _.cloneDeepWith(vm.emailsResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                emailsArr = _.orderBy(filterEmailsArr, [sortValue], [sortType]);
                            } else {
                                emailsArr = _.cloneDeepWith(filterEmailsArr);
                            }
                        }
                    } else {
                        emailsArr = vm.emailsResponse.data;
                    }
                    vm.totalItems = vm.isSinglePage ? emailsArr.length : vm.emailsResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.emailsResponse.metadata.currentPage;
                    vm.emailsArr = emailsArr;
                    if ($state.current.name === 'main.emails') {
                        $timeout(function () {
                            $state.go('main.emails', {page: vm.currentPage, perPage: vm.perPage}, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isRefresh = false;
                    vm.isEmailsLoading = false;
                };
                /*END: Search*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getEmailCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.emailsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var emailsArrCp = _.cloneDeepWith(vm.emailsArr);
                    var tempData = _.map(emailsArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Emails");
                    XLSX.writeFile(wb, "emails.xlsx");
                };
                /* Export Modal: End */

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element("#emailsTable").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetEmails = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);

                            // Parse the data using the new parser
                            var parsedData = parsePostgresData(res.data);

                            vm.isSinglePage = !(res && res.metadata && res.metadata.totalPages && res.metadata.totalPages > 1);

                            vm.emailsResponse = _.cloneDeepWith(res);
                            vm.emailsResponse.data = parsedData;

                            if (isFirst) {
                                if (vm.emailsResponse.data && vm.emailsResponse.data.length) {
                                    vm.totalItems = vm.emailsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }

                            if (inputObj.isNeedDataReverse) {
                                vm.emailsResponse.data.reverse();
                            }

                            vm.emailsArr = vm.emailsResponse.data;
                            vm.isRefresh = false;
                            vm.isEmailsLoading = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isEmailsLoading = false;
                            vm.isRefresh = false;

                            $timeout(function () {
                                vm.fnSetTableHeight();
                            });
                        });
                };


                vm.fnValidateEmail = function (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    if (re.test(email)) {
                        vm.isCreateDisabled = true;
                        return false;
                    } else {
                        vm.isCreateDisabled = false;
                        return true;
                    }
                };

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.isAllChecked = false;
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Whitelist Email'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Whitelist Email',
                                title: 'Whitelist Email',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateEmailProfileData();
                            });
                        }
                    }
                };

                vm.fnSaveEmail = function () {
                    vm.isEmailCreating = false;
                    var inputObj = {
                        email: vm.newEmail
                    };
                    EmailFactory.requestEmailToBeWhitelisted(inputObj)
                        .then(function () {
                            vm.isEmailCreating = true;
                            vm.isCreateDisabled = true;
                            vm.newEmail = "";
                            amaran.success("Email has sent successfully. Please verify the email to continue receiving notification");
                        }, function () {
                            vm.isEmailCreating = true;
                            vm.isCreateDisabled = true;
                            amaran.success("Email has not been whitelist. Please try again.");
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data.data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.emails', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('email') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            //FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isEmailsLoading = true;
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_whitelist_emails';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_whitelist_emails';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_whitelist_emails';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_whitelist_emails';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetEmails(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.emailsArr);
                        vm.previousPage = page;
                        vm.fnGetEmails(input, false);
                    }
                };
                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                vm.fnGetLastFilterQuery = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'email', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if (searchFilterObj.tagArr && searchFilterObj.tagArr.length) {
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if (searchFilterObj.sort && searchFilterObj.sort.length) {
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.emails", tempArr, {notify: false});
                    }
                };

                vm.fnInitEmails = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4('access');
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'email', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetEmailDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateEmailProfileData();
                        });
                    }
                };

                vm.fnGetEmailStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'EmailStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowEmailStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'EmailStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowEmailStats = true;
                            vm.fnUpdateEmailProfileData();
                        });
                    }
                };

                vm.fnUpdateEmailProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'email', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateEmailProfileData();
                        });
                    }
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessEmailChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindemail = _.find(vm.emailsArr, {id: tab.id});
                            if (isFindemail) {
                                vm.activeTabIndex = tab.tabIndex;
                            }
                        } else {
                            $state.go('main.emails', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Whitelist Email";
                        vm.isShowEmailStats = tab.id === "EmailStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Whitelist Email";
                    vm.isShowEmailStats = tab.id === "EmailStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Whitelist Email" || tab.id === "Create Issue" || tab.id === "EmailStats" || tab.id === "WidgetEditor") {
                        $state.go('main.emails', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        vm.activeTabIndex = 1;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.emails', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateEmailProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };
                /*Tab: End*/
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AccessDashboardCtrl',
            function ($scope, $window, $timeout, $state) {
                var vm = this;
                vm.isFullWidthDevice = false;

                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.activeTabIndex = 1;
                vm.isCreate = false;

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1900;
                    });
                });

                vm.fnGoToState = function (state) {
                    $state.go(state)
                };

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        vm.isCreate = tab.id === "Create Issue";
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isCreate = tab.id === "Create Issue";
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                };
                /*Tab: End*/

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessDashboardChartData', angular.toJson(tempIssueData));
                    vm.isCreate = true;
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                //vm.fnUpdateUserProfileData();
                            });
                        }
                    }
                }

                vm.fnInit = function () {
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1900) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AuthenticatorsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, moment,
                      WidgetsListService, UserProfileService, PaginationQueryService,
                      amaran, swal, microSpinner, DB, Authenticate, SortIconService, XLSX, LastPageService,
                      PermissionsService, PaginationService, FedSudoUserService, UserFactory, BatchFactory,
                      AuthenticatorFactory, postActionModelIcon, postActionModelMessage, jsonToCsvConvertService,
                      QueryFactory, copyService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                var codeset = {
                    38: false, //up arrow
                    78: false, //n
                    68: false //d
                };
                vm.isShowWidgetEditor = false;

                //Search Variables
                vm.isRefreshData = true;

                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Name",
                        name: "name",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Description",
                        name: "description",
                        regexp: "",
                        errorMessage: ""
                    }];

                vm.sortFieldArr = [
                    {name: 'name', displayName: 'Name'},
                    {name: 'description', displayName: 'Description'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //Authenticators Variables
                vm.isAuthenticatorsLoading = false;
                vm.authenticatorsArr = [];
                vm.selectedAuthenticatorsArr = [];
                vm.selectedAuthenticatorObj = {};
                vm.isTabsLoading = null;
                vm.isCreate = false;
                vm.isDropUp = false;
                vm.isCreateIssue = false;
                vm.lastSQLQuery = "";
                var loginUser = DB.fnGet('loginUser');
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };
                //pagination variables
                vm.maxSize = 1;
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.totalItems = 0;
                vm.currentPage = 1;

                vm.authenticatorsResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];
                vm.customChangeEvent = {
                    dropDone: function () {
                        var isFind = _.find(vm.tabs, {tabIndex: vm.activeTabIndex});
                        _.map(vm.tabs, function (tabObj, index) {
                            tabObj.tabIndex = index + 1;
                            if (tabObj.name === isFind.name && tabObj.id === isFind.id) {
                                vm.activeTabIndex = tabObj.tabIndex;
                            }
                        });
                        vm.fnUpdateAuthenticatorProfileData();
                    }
                };
                vm.isShowDashboard = false;
                vm.isShowAuthenticatorStats = false;

                //variables for chart
                vm.selectedAuthenticatorType = '';
                vm.selectedSecurityGroupId = '';
                vm.selectedSecurityRoleId = '';
                vm.authenticatorTypesData = [];
                vm.securityRoles = [];
                vm.securityGroups = [];

                //API params Variable
                vm.inputObj = {};

                /*Start: Context Menu*/
                vm.resetEditAuthenticatorObj = {};

                vm.authenticatorContextMenu = function (authenticatorObj) {
                    if (Object.keys(vm.resetEditAuthenticatorObj).length) {
                        var isFindAuthenticator = _.find(vm.authenticatorsArr, {id: vm.resetEditAuthenticatorObj.id});
                        if (isFindAuthenticator) {
                            vm.fnCancelAuthenticatorEditMode(isFindAuthenticator);
                        }
                    }
                    return [{
                        text: 'Edit',
                        click: function () { //$itemScope, $event, modelValue, text, $li
                            authenticatorObj.isEditable = true;
                            vm.resetEditAuthenticatorObj = angular.copy(authenticatorObj);
                        }
                    }]
                };

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                id: item.id || parsedData.id || '',
                                name: item.name || parsedData.name || '',
                                description: item.description || parsedData.description || '',
                                createdAt: item.created_at || parsedData.createdAt || '',
                                updatedAt: item.updated_at || parsedData.updatedAt || '',
                                createdBy: item.created_by || parsedData.createdBy || '',
                                updatedBy: item.updated_by || parsedData.updatedBy || '',
                                totalItems: item.totalitems || 0
                            };

                            // Convert timestamps to relative time if present
                            if (parsedItem.createdAt) {
                                parsedItem.createdDate = vm.fnGetAbsoluteOrRelativeTime(parsedItem.createdAt);
                            }
                            if (parsedItem.updatedAt) {
                                parsedItem.updatedDate = vm.fnGetAbsoluteOrRelativeTime(parsedItem.updatedAt);
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }

                vm.fnCancelAuthenticatorEditMode = function (authenticatorObj, isSuccessCall) {
                    if (isSuccessCall) {
                        authenticatorObj.name = angular.copy(authenticatorObj.name);
                        authenticatorObj.description = angular.copy(authenticatorObj.description);
                        authenticatorObj.isEditable = false;
                        vm.resetEditAuthenticatorObj = {};
                    } else {
                        authenticatorObj.name = angular.copy(vm.resetEditAuthenticatorObj.name);
                        authenticatorObj.description = angular.copy(vm.resetEditAuthenticatorObj.description);
                        authenticatorObj.isEditable = false;
                        vm.resetEditAuthenticatorObj = {};
                    }
                };

                vm.fnSaveAuthenticatorInfo = function (authenticatorObj) {
                    authenticatorObj.isEditable = false;
                    var inputObj = {
                        body: {},
                        authenticatorId: authenticatorObj.id
                    };
                    inputObj.body = {
                        name: authenticatorObj.name,
                        description: angular.isUndefined(authenticatorObj.description) ? '' : authenticatorObj.description
                    };
                    AuthenticatorFactory.updateAuthenticator(inputObj)
                        .then(function (response) {
                            if (angular.isUndefined(response.description)) {
                                response.description = '';
                            }
                            var resetCopy = angular.copy(response);
                            angular.forEach(vm.authenticatorsArr, function (authenticatorObj) {
                                if (Object.keys(vm.selectedAuthenticatorObj).length) {
                                    if (authenticatorObj.id === vm.selectedAuthenticatorObj.id) {
                                        angular.forEach(resetCopy, function (val, key) {
                                            vm.selectedAuthenticatorObj[key] = val;
                                            authenticatorObj[key] = val;
                                        });
                                    }
                                }
                                if (authenticatorObj.id === resetCopy.id) {
                                    authenticatorObj.name = resetCopy.name;
                                    authenticatorObj.description = resetCopy.description;
                                }
                            });
                            vm.fnCancelAuthenticatorEditMode(authenticatorObj, true);
                            amaran.success("Authenticator Updated Successfully");
                        }, function (error) {
                            if (error && error.errorCode === -1) {
                                vm.fnCancelAuthenticatorEditMode(authenticatorObj);
                                amaran.error(error.errorMessage);
                            }
                        })
                };
                /*End: Context Menu*/
                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'authenticator', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAuthenticatorsLoading = true;
                    vm.selectedAuthenticatorsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_authenticators';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_authenticators';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetAuthenticators(input, true);
                };

                vm.fnGetFilterData = function () {
                    var authenticatorsArr = [];
                    if (vm.isSinglePage) {
                        if (vm.authenticatorsResponse.data.length) {
                            var filterAuthenticatorsArr = [];
                            if (vm.filterQuery) {
                                filterAuthenticatorsArr = _.filter(vm.authenticatorsResponse.data, function (obj) {
                                    if (eval(vm.filterQuery)) {
                                        return obj;
                                    }
                                });
                            } else {
                                filterAuthenticatorsArr = _.cloneDeepWith(vm.authenticatorsResponse.data);
                            }
                            if (vm.sort) {
                                var sortType = vm.sort.split(' ')[1];
                                var sortValue = vm.sort.split(' ')[0];
                                authenticatorsArr = _.orderBy(filterAuthenticatorsArr, [sortValue], [sortType]);
                            } else {
                                authenticatorsArr = _.cloneDeepWith(filterAuthenticatorsArr);
                            }
                        }
                    } else {
                        authenticatorsArr = vm.authenticatorsResponse.data;
                    }
                    authenticatorsArr.map(function (obj) {
                        if (obj.createdAt) {
                            obj.createdDate = vm.fnGetAbsoluteOrRelativeTime(obj.createdAt);
                        }
                        if (obj.updatedAt) {
                            obj.updatedDate = vm.fnGetAbsoluteOrRelativeTime(obj.updatedAt);
                        }
                    });
                    vm.totalItems = vm.isSinglePage ? authenticatorsArr.length : vm.authenticatorsResponse.metadata.totalRecordsMatched;
                    vm.currentPage = vm.authenticatorsResponse.metadata.currentPage;
                    vm.authenticatorsArr = authenticatorsArr;
                    if ($state.current.name === 'main.authenticators') {
                        $timeout(function () {
                            $state.go('main.authenticators', {
                                page: vm.currentPage,
                                perPage: vm.perPage
                            }, {notify: false});
                            $stateParams.page = vm.currentPage;
                            $stateParams.perPage = vm.perPage;
                        }, 10)
                    }
                    vm.isRefresh = false;
                    vm.isAuthenticatorsLoading = false;
                };
                /*END: Search*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAuthenticatorCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.authenticatorsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var authenticatorsArrCp = _.cloneDeepWith(vm.authenticatorsArr);
                    var tempData = _.map(authenticatorsArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Authenticators");
                    XLSX.writeFile(wb, "authenticators.xlsx");
                };
                /* Export Modal: End */

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element(".authenticators-table tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnCheckUncheckAll = function () {
                    angular.forEach(vm.authenticatorsArr, function (obj) {
                        obj.isCheck = vm.isAllChecked;
                    });
                    if (vm.isAllChecked) {
                        vm.selectedAuthenticatorsArr = angular.copy(vm.authenticatorsArr);
                    } else {
                        vm.selectedAuthenticatorsArr = [];
                    }
                    $state.go('main.authenticators', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                };

                vm.toggleDropUp = function (id, $event) {
                    var dropdownContainer = $event.currentTarget;
                    var position = dropdownContainer.getBoundingClientRect().top;
                    var dropdownMenu = $(dropdownContainer).find('.dropdown-menu'); //eslint-disable-line
                    var menuHeight = dropdownMenu.outerHeight();
                    //var tableBody = $('#'+id);
                    var div = document.getElementById(id);
                    var rect = div.getBoundingClientRect();
                    var finalPostion = position - rect.top;
                    vm.isDropUp = finalPostion >= menuHeight;
                };

                vm.fnOpenAuthenticatorInfoTab = function (authenticatorObj, tabIndex) {
                    vm.tabIndex = tabIndex;
                    vm.fnCheckUncheckHeader(authenticatorObj);
                };

                vm.fnGetAuthenticator = function (authenticatorObj, authenticatorsArr) {
                    angular.forEach(authenticatorsArr, function (authenticator) {
                        authenticator.isCheck = false;
                    });
                    authenticatorObj.isCheck = true;
                    vm.selectedAuthenticatorsArr = [authenticatorObj]; // Assign array with single authenticators object
                    vm.fnGetAuthenticatorDetails(authenticatorObj);
                };

                vm.fnGetAuthenticatorDetails = function (authenticatorObj) {
                    vm.isAuthenticatorDetailsLoaded = false;
                    $timeout(function () { //to Intialize directive when authenticator is selected
                        vm.selectedAuthenticatorObj = authenticatorObj;
                        if (vm.tabIndex !== 0 && angular.isDefined(vm.tabIndex)) {
                            $state.go('main.authenticators', {
                                selectedId: vm.selectedAuthenticatorObj.id,
                                selectedDetailsTab: vm.tabIndex
                            }, {notify: false});
                            $stateParams.selectedId = vm.selectedAuthenticatorObj.id;
                            $stateParams.selectedDetailsTab = vm.tabIndex;
                            vm.tabIndex = 0;
                            vm.isAuthenticatorDetailsLoaded = true;
                        } else {
                            $state.go('main.authenticators', {selectedId: vm.selectedAuthenticatorObj.id}, {notify: false});
                            $stateParams.selectedId = vm.selectedAuthenticatorObj.id;
                            vm.isAuthenticatorDetailsLoaded = true;
                        }
                    })
                };

                vm.fnCheckUncheckHeader = function (authenticatorObj, fromList) {
                    if (vm.permissionObj.DESCRIBE_AUTHENTICATOR) {
                        vm.isAllChecked = true;
                        angular.forEach(vm.authenticatorsArr, function (obj) {
                            if (!obj.isCheck) {
                                vm.isAllChecked = false;
                            }
                            if (fromList) {
                                if (obj.id === authenticatorObj.id) {
                                    obj.isCheck = false;
                                    vm.isAllChecked = false;
                                }
                            }
                        });

                        /* Toggle push in selected authenticators array*/
                        var isValueFind = _.find(vm.selectedAuthenticatorsArr, {'id': authenticatorObj.id});
                        if (!isValueFind) {
                            vm.selectedAuthenticatorsArr.push(authenticatorObj);
                            var isTabExist = _.find(vm.tabs, {'id': authenticatorObj.id});
                            if (isTabExist) {
                                $timeout(function () {
                                    vm.activeTabIndex = isTabExist.tabIndex;
                                });
                            } else {
                                var newTabIndex = vm.tabs.length + 1;
                                vm.tabs.push({
                                    id: authenticatorObj.id,
                                    title: authenticatorObj.name,
                                    tabIndex: newTabIndex
                                });
                                $timeout(function () {
                                    vm.activeTabIndex = newTabIndex;
                                    vm.fnUpdateAuthenticatorProfileData();
                                });
                            }
                        } else {
                            _.remove(vm.selectedAuthenticatorsArr, function (obj) {
                                return authenticatorObj.id === obj.id;
                            });
                        }
                        if (vm.selectedAuthenticatorsArr.length === 1) {
                            vm.fnGetAuthenticatorDetails(vm.selectedAuthenticatorsArr[0])
                        } else {
                            $state.go('main.authenticators', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                        }
                    }
                };

                vm.fnGetAbsoluteOrRelativeTime = function (timestamp) {
                    var datetime = moment.unix(timestamp).format("MM/DD/YYYY HH:mm:ss");
                    var currentDate = moment.unix(moment().unix()).format("MM/DD/YYYY HH:mm:ss");
                    var differenceHours = moment(currentDate).diff(moment(datetime), 'hours');
                    var relativeTime = "";
                    if (differenceHours > 24) {
                        relativeTime = moment.unix(timestamp).format("DD/MM/YYYY");
                    } else {
                        relativeTime = moment(datetime).fromNow();
                    }
                    return relativeTime;
                };

                vm.fnGetAuthenticators = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var parsedData = parsePostgresData(res.data);

                            vm.authenticatorsResponse = _.cloneDeepWith(res);
                            vm.authenticatorsResponse.data = parsedData;

                            if (isFirst) {
                                if (vm.authenticatorsResponse.data && vm.authenticatorsResponse.data.length) {
                                    vm.totalItems = vm.authenticatorsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.authenticatorsResponse.data.reverse();
                            }
                            vm.authenticatorsArr = vm.authenticatorsResponse.data;
                            if ($stateParams.selectedId) {
                                var authenticatorData = _.find(vm.authenticatorsArr, {"id": $stateParams.selectedId});
                                if (authenticatorData) {
                                    vm.fnCheckUncheckHeader(authenticatorData);
                                }
                            }
                            if ($state.current.name === 'main.authenticators') {
                                $state.go('main.authenticators', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isAuthenticatorsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAuthenticatorsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    $state.go('main.authenticators', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAuthenticatorsLoading = true;
                    vm.selectedAuthenticatorsArr = [];
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, ' + sortValue + ' AS rt FROM access_authenticators';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_authenticators';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, ' + vm.sort.split(' ')[0] + ' AS rt FROM access_authenticators';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY ' + vm.sort.split(' ')[0] + ' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_authenticators';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAuthenticators(perPageInput, true);
                    } else { //for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.authenticatorsArr);
                        vm.previousPage = page;
                        vm.fnGetAuthenticators(input, false);
                    }
                };

                /*END: TABLE*/

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                $scope.$on("AuthenticatorDeleted", function (evt, data) {
                    vm.selectedAuthenticatorObj = null;
                    vm.selectedAuthenticatorsArr = [];
                    vm.authenticatorsArr = vm.authenticatorsArr.filter(function (authenticatorObj) {
                        return (authenticatorObj.id !== data.id);
                    });
                    vm.totalItems = vm.totalItems - 1;
                    $state.go('main.authenticators', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    vm.fnReload();
                    vm.fnRemoveTab(data.id);
                });

                $scope.$on("AuthenticatorDetailsChanged", function (evt, data) {
                    var resetCopy = angular.copy(data);
                    angular.forEach(vm.authenticatorsArr, function (authenticatorObj) {
                        if (authenticatorObj.id === vm.selectedAuthenticatorObj.id) {
                            angular.forEach(resetCopy, function (val, key) {
                                vm.selectedAuthenticatorObj[key] = val;
                                authenticatorObj[key] = val;
                            });
                        }
                    });
                });

                vm.fnHideShowCreateForm = function (isCalledForOpen) {
                    vm.selectedAuthenticatorsArr = [];
                    vm.isAllChecked = false;
                    vm.fnCheckUncheckAll();
                    if (isCalledForOpen) {
                        vm.isCreate = true;
                    } else {
                        vm.isCreate = !vm.isCreate;
                    }
                    if (vm.isCreate) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Authenticator'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Authenticator',
                                title: 'Create Authenticator',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                                vm.fnUpdateAuthenticatorProfileData();
                            });
                        }
                    }
                };

                vm.fnDeleteMultipleAuthenticators = function (selectedAuthenticatorsArr) {
                    var batchCollectionObj = {};
                    var step = 14;
                    var count = 1;
                    var batchArr = [];
                    var inputObj = {};

                    angular.forEach(selectedAuthenticatorsArr, function (selectedAuthenticator, index) {
                        if (index <= step) {
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/authenticators/" + selectedAuthenticator.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        } else {
                            batchArr = [];
                            step = step + 15;
                            count++;
                            inputObj.method = "DELETE";
                            inputObj.id = index;
                            inputObj.path = "/access/authenticators/" + selectedAuthenticator.id;
                            batchArr.push(inputObj);
                            batchCollectionObj[count] = batchArr;
                            inputObj = {};
                        }
                    });

                    swal({
                            title: "Delete the selected authenticators?",
                            text: "You are about to permanently delete the selected authenticators.<br/>" +
                                "You will not be able to recover any of the data related to them.<br/>" +
                                "This operation cannot be undone.",
                            type: "warning",
                            html: true,
                            showCancelButton: true,
                            confirmButtonText: "delete",
                            closeOnConfirm: false,
                            showLoaderOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                angular.element(".sa-confirm-button-container .confirm").after(microSpinner);
                                angular.element(".confirm").css("visibility", "hidden");
                                count = 1;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                swal("Cancelled", "Delete Process Cancelled", "error");
                            }
                        });
                };

                vm.fnDeleteBatchOperation = function (batchCollectionObj, count) {
                    BatchFactory.executeBatchRequests({
                        body: batchCollectionObj[count],
                        tag: 'batch',
                        appName: 'access'
                    })
                        .then(function () {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAuthenticatorsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.authenticatorsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.authenticatorsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAuthenticatorsArr.length;
                                vm.selectedAuthenticatorObj = null;
                                vm.selectedAuthenticatorsArr = [];
                                swal({
                                    title: postActionModelMessage,
                                    html: true,
                                    imageUrl: 'data:image/svg+xml;base64,' + btoa(postActionModelIcon),
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                    customClass: 'customSwalActionModel'
                                });
                                angular.element(".microSpinner").remove();
                                angular.element(".confirm").css("visibility", "visible");
                                $timeout(function () {
                                    angular.element(".confirm").css("visibility", "visible");
                                    swal.close();
                                }, 1000);
                                vm.fnReload();
                            }
                        }, function (error) {
                            if (count < Object.keys(batchCollectionObj).length) {
                                count++;
                                vm.fnDeleteBatchOperation(batchCollectionObj, count);
                            } else {
                                angular.forEach(vm.selectedAuthenticatorsArr, function (selectedAuthenticator) {
                                    angular.forEach(vm.authenticatorsArr, function (authenticatorObj, index) {
                                        if (selectedAuthenticator.id === authenticatorObj.id) {
                                            vm.authenticatorsArr.splice(index, 1);
                                        }
                                    });
                                });
                                vm.totalItems = vm.totalItems - vm.selectedAuthenticatorsArr.length;
                                vm.selectedAuthenticatorObj = null;
                                vm.selectedAuthenticatorsArr = [];
                                angular.element('.microSpinner').remove();
                                angular.element(".confirm").css("visibility", "visible");
                                swal.close();
                                vm.fnReload();
                            }
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnGetLastFilterQuery = function(){
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'authenticator', 'searchFilter');
                    if (searchFilterObj !== '') {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.authenticators", tempArr, {notify: false});
                    }
                };

                vm.fnInitAuthenticators = function () {
                    vm.permissionObj = PermissionsService.getPermissionsV4("access");
                    vm.fnGetLastFilterQuery();
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;
                    vm.authenticatorType = [];
                    vm.fnSetServiceDashboardHeight();
                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'authenticator', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnGetAuthenticatorDashboard = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'Dashboard'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowDashboard = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'Dashboard',
                            title: 'About',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowDashboard = true;
                            vm.fnUpdateAuthenticatorProfileData();
                        });
                    }
                };

                vm.fnGetAuthenticatorStats = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'AuthenticatorStats'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowAuthenticatorStats = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'AuthenticatorStats',
                            title: 'Stats',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowAuthenticatorStats = true;
                            vm.fnUpdateAuthenticatorProfileData();
                        });
                    }
                };

                vm.fnUpdateAuthenticatorProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'authenticator', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                /*Tab: Start*/

                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindAuthenticator = _.find(vm.authenticatorsArr, {id: tab.id});
                            if (isFindAuthenticator) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedAuthenticatorsArr = [];
                                // vm.selectedAuthenticatorObj = {};
                                vm.fnCheckUncheckHeader(isFindAuthenticator);
                            }
                        } else {
                            $state.go('main.authenticators', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isCreate = tab.id === "Create Authenticator";
                        vm.isShowAuthenticatorStats = tab.id === "AuthenticatorStats";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        })
                    }
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isCreate = tab.id === "Create Authenticator";
                    vm.isShowAuthenticatorStats = tab.id === "AuthenticatorStats";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Authenticator" ||  tab.id === "Create Issue" || tab.id === "AuthenticatorStats" || tab.id === "WidgetEditor") {
                        $state.go('main.authenticators', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        var lastLast = vm.tabs[vm.tabs.length - 2];
                        vm.activeTabIndex = lastLast.tabIndex;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        } else {
                            vm.fnChangeTab(lastLast, true);
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.authenticators', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateAuthenticatorProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnOpenEditAuthenticatorInfoTab = function (authenticatorObj) {
                    vm.isEditing = true;
                    vm.fnCheckUncheckHeader(authenticatorObj);
                };

                /*Tab: End*/

                vm.fnGetWidgetEditor = function (index) {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateAuthenticatorProfileData();
                        });
                    }
                    vm.selectedColumn = index;
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };

                vm.fnGetType = function (data) {
                    return typeof data;
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessAuthenticatorsChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };

                vm.fnCopyId = function (id) {
                    copyService.fnCopyToClipboard(id);
                    amaran.success("ID copied successfully");
                };

                $scope.$on("authenticatorAdded", function () {
                    vm.fnRemoveTab('Create Authenticator');
                });


                var authenticatorKeyDownEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.authenticators') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = true;
                            if (codeset[38] && codeset[78] && vm.permissionObj.CREATE_AUTHENTICATOR &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnHideShowCreateForm(true);
                                $scope.$apply();
                                codeset[38] = false;
                                codeset[78] = false;
                            } else if (codeset[38] && codeset[68] && vm.selectedAuthenticatorsArr.length > 1 && vm.permissionObj.DELETE_AUTHENTICATOR &&
                                !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Create
                                vm.fnDeleteMultipleAuthenticators(vm.selectedAuthenticatorsArr);
                                codeset[38] = false;
                                codeset[68] = false;
                            }
                        }
                    }
                };

                var authenticatorKeyUpEventHandler = function (e) {
                    if ($state.current && $state.current.name === 'main.authenticators') {
                        if (e.keyCode in codeset) {
                            codeset[e.keyCode] = false;
                        }
                    }
                };

                document.addEventListener('keydown', authenticatorKeyDownEventHandler);
                document.addEventListener('keyup', authenticatorKeyUpEventHandler);

                $scope.$on('$destroy', function () {
                    document.removeEventListener('keydown', authenticatorKeyDownEventHandler);
                    document.removeEventListener('keyup', authenticatorKeyUpEventHandler);
                })

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('AuditsCtrl',
            function ($scope, $window, $timeout, $stateParams, $state, $uibModal, UserProfileService, amaran,
                      swal, microSpinner, moment, DB, Authenticate, SortIconService, XLSX, LastPageService,
                      PermissionsService, PaginationService, FedSudoUserService, UserFactory, AuditFactory,
                      jsonToCsvConvertService, WidgetsListService, QueryFactory, PaginationQueryService, $log) {
                var vm = this;

                vm.isFullWidthDevice = false;
                var showWidgets = UserProfileService.fnGetSystemProfileObj('showWidgets');
                vm.isShowWidgets = showWidgets === '' ? true : showWidgets;
                //Search Variables
                vm.isRefreshData = true;
                vm.isCreateIssue = false;

                vm.applicationFieldArr = [
                    {name: 'ACCESS', displayName: 'ACCESS'},
                    {name: 'BILLING', displayName: 'BILLING'},
                    {name: 'NODE', displayName: 'NODE'},
                    {name: 'TRACKER', displayName: 'TRACKER'},
                    {name: 'PIPELINE', displayName: 'PIPELINE'}
                ];
                vm.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                vm.searchFiltersArr = [
                    {
                        displayName: "ID",
                        name: "id",
                        regexp: "^(\\w{8})-((\\w{8}))$",
                        errorMessage: "The Id does not satisfy the required format. xxxxxxxx-xxxxxxxx"
                    }, {
                        displayName: "Principal",
                        name: "principal",
                        regexp: vm.emailPattern,
                        errorMessage: "Invalid Email address."
                    }, {
                        displayName: "Application",
                        name: "application",
                        regexp: "",
                        errorMessage: "",
                        isPredefinedValue: true,
                        predefinedValues: vm.applicationFieldArr,
                        displayKeyName: 'displayName',
                        isShowId: false,
                        isShowSearchBar: false,
                        filterApplyKeyName: 'name'
                    }, {
                        displayName: "Event",
                        name: "event",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "Message",
                        name: "message",
                        regexp: "",
                        errorMessage: ""
                    }, {
                        displayName: "IP",
                        name: "ip",
                        regexp: "",
                        errorMessage: ""
                    }
                ];

                vm.sortFieldArr = [
                    {name: 'id', displayName: 'ID'},
                    {name: 'application', displayName: 'Application'},
                    {name: 'timestamp', displayName: 'Timestamp'},
                    {name: 'event', displayName: 'Event'}
                ];
                vm.filterQuery = "";
                vm.sqlQuery = "";
                //Audits Variables
                vm.isAuditsLoading = false;
                vm.auditsArr = [];
                vm.isTabsLoading = null;
                vm.lastSQLQuery = "";

                var loginUser = DB.fnGet('loginUser');
                vm.isShowInsightOption = function () {
                    return loginUser.accountOwner || loginUser.administrator || loginUser.insightRole === 'MANAGER' || loginUser.insightRole === 'TEAM_MEMBER' || loginUser.insightRole === 'CUSTOMER';
                };

                //pagination variables
                var perPage = UserProfileService.fnGetSystemProfileObj('perPage');
                vm.maxSize = 1;
                vm.perPage = parseInt(perPage === '' ? 50 : perPage);
                vm.totalItems = 0;
                vm.currentPage = 1;
                vm.auditsResponse = [];
                vm.tabs = [
                    {
                        title: 'Overview',
                        tabIndex: 1
                    }
                ];

                //API params Variable
                vm.inputObj = {};

                var appWindow = angular.element($window);
                appWindow.bind('resize', function () {
                    var windowSize = angular.element($window);
                    $timeout(function () {
                        vm.isFullWidthDevice = windowSize[0].innerWidth > 1600;
                        vm.fnSetTableHeight();
                    });
                });

                function parsePostgresData(items) {
                    if (!angular.isArray(items)) {
                        return [];
                    }

                    return items.map(function(item) {
                        try {
                            // Parse the data field if it exists and is a string
                            var parsedData = {};
                            if (item.data && angular.isString(item.data)) {
                                try {
                                    parsedData = angular.fromJson(item.data);
                                } catch (e) {
                                    $log.error('Error parsing data JSON:', e);
                                }
                            }

                            // Combine fields from both explicit columns and parsed data
                            var parsedItem = {
                                id: item.id || parsedData.id || '',
                                timestamp: item.timestamp || parsedData.timestamp || '',
                                application: (item.application || parsedData.application || '').toLowerCase(),
                                event: item.event || parsedData.event || '',
                                message: item.message || parsedData.message || '',
                                facility: (item.facility || parsedData.facility || '').toLowerCase(),
                                severity: (item.severity || parsedData.severity || '').toLowerCase(),
                                principal: item.principal || parsedData.principal || '',
                                ip: item.ip || parsedData.ip || '',
                                totalItems: item.totalitems || 0
                            };

                            // Process event string
                            if (parsedItem.event) {
                                var eventIndex = parsedItem.event.indexOf("__");
                                if (eventIndex !== -1) {
                                    parsedItem.event = parsedItem.event.substring(eventIndex).toLowerCase();
                                    parsedItem.event = parsedItem.event.replace("_", "-");
                                }
                            }

                            // Format timestamp
                            if (parsedItem.timestamp) {
                                parsedItem.timestamp = moment(parsedItem.timestamp).format("MM/DD/YYYY HH:mm:ss Z");
                            }

                            return parsedItem;
                        } catch (error) {
                            $log.error('Error parsing item in parsePostgresData:', error, item);
                            return item;
                        }
                    });
                }

                vm.fnShowHideWidget = function(){
                    vm.isShowWidgets = !vm.isShowWidgets;
                    UserProfileService.fnUpdateSystemProfileObj('showWidgets', vm.isShowWidgets);
                    $timeout(function () {
                        vm.fnSetServiceDashboardHeight();
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    });
                }

                /*START: Search*/
                vm.fnFilterQueryChanged = function (filterQuery, sortQuery, sqlQuery, tagArr) {
                    if (sortQuery) {
                        $stateParams.sort = sortQuery;
                    } else {
                        delete $stateParams.sort;
                    }
                    vm.filterQuery = filterQuery;
                    var tempSearchFilterObj = {};
                    if ((tagArr !== '' && tagArr.length) && angular.isDefined(tagArr)) {
                        tempSearchFilterObj.tagArr = tagArr;
                    } else {
                        tempSearchFilterObj.tagArr = [];
                    }
                    if (sortQuery) {
                        tempSearchFilterObj.sort = sortQuery;
                    } else {
                        tempSearchFilterObj.sort = '';
                    }
                    UserProfileService.fnUpdateUserProfileObj('access', 'audit', 'searchFilter', _.cloneDeepWith(tempSearchFilterObj));
                    vm.sqlQuery = sqlQuery;
                    vm.previousPage = 1;
                    if ($stateParams.page) {
                        vm.currentPage = Math.ceil($stateParams.page) //if the page value has decimal value then it will take up the upper value.
                    } else {
                        vm.currentPage = 1;
                    }
                    if ($stateParams.sort) {
                        vm.sort = $stateParams.sort
                    } else {
                        vm.sort = '';
                    }
                    if ($stateParams.perPage) {
                        vm.perPage = Math.ceil($stateParams.perPage)
                    }
                    vm.isAuditsLoading = true;
                    var sortString = '';
                    if (vm.sort) {
                        var sortType = vm.sort.split(' ')[1];
                        var sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_audits';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                    } else {
                        sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_audits';
                        sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                        sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                    }
                    var input = {
                        sql: sqlString
                    };
                    vm.fnGetAudits(input, true);
                };

                vm.fnGetTdStyle = function (data) {
                    if (angular.isNumber(data)) {
                        return {color: 'green'}
                    } else if (angular.isString(data)) { //eslint-disable-line*/
                        return {color: 'red'};
                    } else if (typeof data === 'boolean') {
                        return {color: 'blue'};
                    }
                };
                /*END: Search*/

                /* Export Modal: Start */
                vm.fnOpenExportModal = function () {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/exportOptionsModal/exportOptionsModal.html',
                        size: 'md',
                        controller: 'exportOptionsModalCtrl as exportOptionsModal'
                    });
                    modalInstance.result.then(function (type) {
                        switch (type) {
                            case 'csv':
                                if (angular.element('#csvAnchor')[0]) {
                                    $timeout(function () {
                                        document.getElementById('csvAnchor').click();
                                    })
                                }
                                break;
                            case 'excel':
                                vm.fnDownloadXls();
                                break;
                        }
                    }, function () {
                    });
                };

                vm.getAuditCSVData = function () {
                    var tempData = _.cloneDeepWith(vm.auditsArr);
                    var data = jsonToCsvConvertService.getCsvArray(angular.fromJson(angular.toJson(tempData)));
                    data[0].sort();
                    vm.csvHeaderArr = data[0];
                    return _.map(data[1], function (userObj) {
                        var tempObj = {};
                        _.forEach(data[0], function (headerText) {
                            tempObj[headerText] = userObj[headerText];
                        });
                        return tempObj;
                    });
                };

                vm.fnDownloadXls = function () {
                    var auditsArrCp = _.cloneDeepWith(vm.auditsArr);
                    var tempData = _.map(auditsArrCp, function (tempObj) {
                        return tempObj;
                    });
                    var ws = XLSX.utils.json_to_sheet(tempData);

                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Audits");
                    XLSX.writeFile(wb, "audits.xlsx");
                };
                /* Export Modal: End */

                /*START: TABLE*/
                vm.fnSetTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element("thead")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var searchTag = 0;
                        var header = angular.element("thead")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + pagination + searchTag + header + 70 + dashboardHeader + mainFooter);
                        angular.element(".audits-table tbody").css('height', finalHeight + 'px');
                    }
                };

                vm.fnSetLoaderTableHeight = function () {
                    if (angular.isDefined(angular.element(".table-content-box")[0]) &&
                        angular.isDefined(angular.element(".search-panel-v4")[0]) &&
                        angular.isDefined(angular.element(".pagination-container")[0])) {
                        var total = angular.element(".table-content-box")[0].offsetHeight;
                        var search = angular.element(".search-panel-v4")[0].offsetHeight;
                        var pagination = angular.element(".pagination-container")[0].offsetHeight;
                        var dashboardHeader = angular.isDefined(angular.element(".dashboard-header")[0]) ? angular.element(".dashboard-header")[0].offsetHeight : 0;
                        var searchTag = 0;
                        var mainFooter = angular.isDefined(angular.element(".content-box-footer")[0]) ? angular.element(".content-box-footer")[0].offsetHeight : 0;
                        var finalHeight = total - (search + (pagination !== 0 ? 0 : pagination) + searchTag + 55 + dashboardHeader + mainFooter);
                        angular.element("#loading-row").css('height', finalHeight + 'px');
                    }
                };

                vm.fnGetAudits = function (inputObj, isFirst) {
                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) { // Success block
                            vm.lastSQLQuery = _.cloneDeepWith(inputObj.sql);
                            var parsedData = parsePostgresData(res.data);
                            vm.auditsResponse = angular.copy(res);
                            vm.auditsResponse.data = parsedData;
                            if (isFirst) {
                                if (vm.auditsResponse.data && vm.auditsResponse.data.length) {
                                    vm.totalItems = vm.auditsResponse.data[0].totalItems;
                                } else {
                                    vm.totalItems = 0;
                                }
                                vm.currentPage = 1;
                            }
                            if (inputObj.isNeedDataReverse) {
                                vm.auditsResponse.data.reverse();
                            }
                            vm.auditsArr = vm.auditsResponse.data;
                            if ($state.current.name === 'main.audits') {
                                $state.go('main.audits', {
                                    page: vm.currentPage,
                                    perPage: vm.perPage
                                }, {notify: false});
                                $stateParams.page = vm.currentPage;
                                $stateParams.perPage = vm.perPage;
                            }
                            vm.isAuditsLoading = false;
                            vm.isRefresh = false;
                            $timeout(function () {
                                vm.fnSetTableHeight();
                            })
                        }, function (error) { // Error block
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isAuditsLoading = false;
                            vm.isRefresh = false;
                        })
                };

                vm.fnUpdateUserData = function (perPage) {
                    loginUser = DB.fnGet('loginUser');
                    var inputObj = {
                        userId: loginUser.id,
                        body: {}
                    };
                    if (loginUser.data) {
                        loginUser.data.perPage = ["" + perPage + ""];
                        inputObj.body = loginUser.data;
                    } else {
                        inputObj.body = {
                            "perPage": ["" + perPage + ""]
                        }
                    }

                    UserFactory.replaceUserData(inputObj)
                        .then(function (data) {
                            loginUser.data = data;
                            DB.fnSet('loginUser', loginUser);
                        }, function (error) {
                            if (error.errorCode === -1) {
                                amaran.error(error.errorMessage);
                            }
                        });
                };

                vm.fnPageChanged = function (page, perPage, isPerPageChanged) {
                    vm.currentPage = page;
                    vm.perPage = perPage;
                    if (isPerPageChanged) {
                        if (!DB.fnGet('federation') && !DB.fnGet('sudo')) {
                            UserProfileService.fnUpdateSystemProfileObj('perPage', perPage);
                        } else {
                            // FedSudoUserService.fnSetUserData('perPage', [perPage]);
                        }
                    }
                    vm.isAuditsLoading = true;
                    vm.isAllChecked = false;
                    var sortString = '';
                    var sortType = '';
                    var sortValue = '';
                    if (vm.sort) {
                        sortType = vm.sort.split(' ')[1];
                        sortValue = vm.sort.split(' ')[0];
                        sortString = sortValue + ' ' + sortType;
                    }
                    var sqlString = '';
                    if (sortString !== '') { //for specific sort
                        sqlString = 'SELECT *, data->>\'' + sortValue + '\' AS rt FROM access_audits';
                    } else { //for general sort
                        sqlString = 'SELECT *, data->>\'_id\' AS rt FROM access_audits';
                    }
                    if (isPerPageChanged) {//only for per page change
                        if (sortString !== '') {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'' + vm.sort.split(' ')[0] + '\' AS rt FROM access_audits';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY data->>\'' + vm.sort.split(' ')[0] + '\' ' + vm.sort.split(' ')[1] + ' LIMIT ' + vm.perPage + ';';
                        } else {
                            sqlString = 'SELECT *, COUNT(*) OVER() as totalItems, data->>\'_id\' AS rt FROM access_audits';
                            sqlString += vm.sqlQuery && vm.sqlQuery.length ? ' WHERE ' + vm.sqlQuery.trim() : '';
                            sqlString += ' ORDER BY rt asc LIMIT ' + vm.perPage + ';';
                        }
                        var perPageInput = {
                            sql: sqlString
                        };
                        vm.fnGetAudits(perPageInput, true);
                    } else {//for page change
                        var input = PaginationQueryService.getPaginationQuery(sqlString, vm.sqlQuery, sortString, page, vm.previousPage, perPage, vm.totalItems, vm.auditsArr);
                        vm.previousPage = page;
                        vm.fnGetAudits(input, false);
                    }
                };

                vm.fnReload = function () {
                    vm.isRefresh = true;
                    vm.isRefreshData = false;
                    $timeout(function () {
                        vm.fnAddDefaultSort();
                    });
                    $timeout(function () {
                        vm.isRefreshData = true;
                    }, 10)
                };

                /*END: TABLE*/

                /*Tab: Start*/
                vm.fnChangeTab = function (tab, isTabChange) {
                    if (isTabChange) {
                        if (tab.tabIndex !== 1) {
                            var isFindEmailTemplate = _.find(vm.emailTemplateArr, {id: tab.id});
                            if (isFindEmailTemplate) {
                                vm.activeTabIndex = tab.tabIndex;
                                vm.selectedEmailTemplatesArr = [];
                                vm.selectedEmailTemplateObj = {};
                                vm.fnCheckUncheckHeader(isFindEmailTemplate);
                            }
                        } else {
                            $state.go('main.audits', {selectedId: "", selectedDetailsTab: ""}, {notify: false});
                            delete $stateParams.selectedId;
                            delete $stateParams.selectedDetailsTab;
                            vm.activeTabIndex = tab.tabIndex;
                        }
                        vm.isShowDashboard = tab.id === "Dashboard";
                        vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                        vm.isCreateIssue = tab.id === "Create Issue";
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                        $timeout(function () {
                            vm.fnSetTableHeight();
                        });
                    }
                };

                vm.fnExportChart = function (type, id) {
                    WidgetsListService.downloadChartData(type, id);
                };

                vm.fnTabChanged = function (tab) {
                    vm.isShowDashboard = tab.id === "Dashboard";
                    vm.isShowWidgetEditor = tab.id === "WidgetEditor";
                    vm.isCreateIssue = tab.id === "Create Issue";
                    if (tab.id === "Dashboard" || tab.id === "Create Issue") {
                        $state.go('main.audits', {selectedId: '', selectedDetailsTab: ''}, {notify: false});
                        delete $stateParams.selectedId;
                        delete $stateParams.selectedDetailsTab;
                    }
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    })
                };

                vm.fnRemoveTab = function (id) {
                    var i = 1;
                    var tabs = [];
                    var index = _.findIndex(vm.tabs, {id: id});
                    if (vm.tabs.length === (index + 1)) {
                        vm.activeTabIndex = 1;
                        if (vm.activeTabIndex === 1) {
                            $timeout(function () {
                                vm.fnSetServiceDashboardHeight();
                            });
                        }
                    }
                    _.forEach(vm.tabs, function (tabObj) {
                        if (id !== tabObj.id) {
                            tabObj.tabIndex = _.cloneDeep(i);
                            tabs.push(tabObj);
                            i++;
                        }
                    });
                    vm.tabs = _.cloneDeepWith(tabs);
                    $state.go('main.audits', {
                        selectedId: '',
                        selectedDetailsTab: ''
                    }, {notify: false});
                    delete $stateParams.selectedId;
                    delete $stateParams.selectedDetailsTab;
                    //vm.activeTabIndex = 1;
                    if (id === "Dashboard") {
                        vm.isShowDashboard = false;
                    }
                    vm.fnUpdateAuditProfileData();
                    $timeout(function () {
                        vm.fnSetTableHeight();
                    });
                };
                /*Tab: End*/

                vm.fnAddDefaultSort = function () {
                    var searchFilterObj = UserProfileService.fnGetUserProfileObj('access', 'audit', 'searchFilter');
                    if (searchFilterObj !== '' && ((searchFilterObj.tagArr && searchFilterObj.tagArr.length) || (searchFilterObj.sort && searchFilterObj.sort.length))) {
                        var tempArr = {};
                        if(searchFilterObj.tagArr && searchFilterObj.tagArr.length){
                            tempArr.filter = angular.toJson(searchFilterObj.tagArr);
                            $stateParams.filter = angular.toJson(searchFilterObj.tagArr);
                        }
                        if(searchFilterObj.sort && searchFilterObj.sort.length){
                            tempArr.sort = searchFilterObj.sort;
                            $stateParams.sort = searchFilterObj.sort;
                        }
                        $state.go("main.audits", tempArr, {notify: false});
                    } else {
                        if (angular.isDefined($stateParams.sort)) {
                            var sortString = $stateParams.sort;
                            if (!sortString.includes('timestamp')) {
                                $state.go("main.audits", {sort: 'timestamp desc'}, {notify: false});
                                $stateParams.sort = 'timestamp desc';
                            }
                        } else {
                            $state.go("main.audits", {sort: 'timestamp desc'}, {notify: false});
                            $stateParams.sort = 'timestamp desc';
                        }
                    }
                };

                vm.fnInitAudits = function () {
                    vm.fnAddDefaultSort();
                    vm.permissionObj = PermissionsService.getPermissions("access:audit");
                    var windowSize = angular.element($window);
                    if (windowSize[0].innerWidth > 1366) {
                        vm.isFullWidthDevice = true;
                    }
                    vm.activeTabIndex = 1;

                    vm.fnSetServiceDashboardHeight();

                    var tempValue = UserProfileService.fnGetUserProfileObj('access', 'audit', 'tabs');
                    if (tempValue !== '') {
                        vm.tabs = _.cloneDeepWith(tempValue);
                    }
                };

                vm.fnSetServiceDashboardHeight = function () {
                    if (angular.isDefined(angular.element(".content-box")[0])) {
                        var total = angular.element(".content-box")[0].offsetHeight;
                        var final = total * 25 / 100;
                        $timeout(function () {
                            angular.element("#service-dashboard").css('height', parseInt(final) + 'px');
                        })
                    }
                };

                vm.fnUpdateAuditProfileData = function () {
                    UserProfileService.fnUpdateUserProfileObj('access', 'audit', 'tabs', _.cloneDeepWith(vm.tabs));
                };

                vm.fnOpenInInsight = function () {
                    DB.fnSet('insightQueryFromTable', vm.lastSQLQuery);
                    $state.go('main.insight_query_editor');
                };

                vm.fnGetWidgetEditor = function () {
                    var isTabExist = _.find(vm.tabs, {id: 'WidgetEditor'});
                    if (isTabExist) {
                        $timeout(function () {
                            vm.activeTabIndex = isTabExist.tabIndex;
                            vm.isShowWidgetEditor = true;
                        });
                    } else {
                        var newTabIndex = vm.tabs.length + 1;
                        vm.tabs.push({
                            id: 'WidgetEditor',
                            title: 'Widget Editor',
                            tabIndex: newTabIndex
                        });
                        $timeout(function () {
                            vm.activeTabIndex = newTabIndex;
                            vm.isShowWidgetEditor = true;
                            vm.fnUpdateAuditProfileData();
                        });
                    }
                };

                vm.fnGotoLink = function (link, target) {
                    $window.open(link, target === 'New Window' ? "_blank" : "_self");
                };

                vm.fnOpenCreateIssueTab = function (chartObj) {
                    var tempIssueData = {
                        chart: _.cloneDeepWith(chartObj.widget.chart.definition.chartConfig),
                        rowData: _.cloneDeepWith(chartObj.widget.chart.query.results.data)
                    };
                    localStorage.setItem('InsightAccessAuditChartData', angular.toJson(tempIssueData));
                    vm.isCreateIssue = true;
                    if (vm.isCreateIssue) {
                        var isTabExist = _.find(vm.tabs, {'id': 'Create Issue'});
                        if (isTabExist) {
                            $timeout(function () {
                                vm.activeTabIndex = isTabExist.tabIndex;
                            });
                        } else {
                            var newTabIndex = vm.tabs.length + 1;
                            vm.tabs.push({
                                id: 'Create Issue',
                                title: 'Create Issue',
                                tabIndex: newTabIndex
                            });
                            $timeout(function () {
                                vm.activeTabIndex = newTabIndex;
                            });
                        }
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('validationCtrl',
            function ($state, $stateParams, $timeout, ValidationFactory, amaran) {
                var vm = this;
                vm.isValidationProgress = false;
                vm.isShowValidateMessage = false;
                vm.name = "";
                vm.svg = 'predictiveSVG';
                vm.passInputType = 'password';
                vm.confirmPassInputType = 'password';
                vm.currentYear = new Date().getFullYear();
                vm.lastYear = vm.currentYear - 1;
                vm.password = "";
                vm.isPasswordValid = false;
                vm.passwordStrength = {};
                vm.checkpwdStrength = {
                    "background": "#f2f2f2",
                    "width": "0%",
                    "height": "100%",
                    "border-radius": "60px"
                };
                vm.passwordTest = 'Very weak';
                var keys = {
                    upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                    lowerCase: "abcdefghijklmnopqrstuvwxyz",
                    number: "0123456789",
                    symbol: "!@#$%^&*()_+~\`|}{[]:;?><,./-="
                }
                var getKey = [
                    function upperCase() {
                        return keys.upperCase[Math.floor(Math.random() * keys.upperCase.length)];
                    },
                    function lowerCase() {
                        return keys.lowerCase[Math.floor(Math.random() * keys.lowerCase.length)];
                    },
                    function number() {
                        return keys.number[Math.floor(Math.random() * keys.number.length)];
                    },
                    function symbol() {
                        return keys.symbol[Math.floor(Math.random() * keys.symbol.length)];
                    }
                ];

                vm.hideShowPassword = function () {
                    if (vm.passInputType === 'password') {
                        vm.passInputType = 'text';
                    } else {
                        vm.passInputType = 'password';
                    }
                };

                vm.hideShowPasswordForConfirm = function () {
                    if (vm.confirmPassInputType === 'password') {
                        vm.confirmPassInputType = 'text';
                    } else {
                        vm.confirmPassInputType = 'password';
                    }
                };

                vm.fnValidateUser = function () {
                    vm.isValidationProgress = true;
                    var inputObj = {
                        body: {
                            "password": vm.password
                        }
                    };
                    ValidationFactory.validateNewAccount(inputObj)
                        .then(function () {
                            vm.isValidationProgress = false;
                            vm.isShowValidateMessage = true;
                        }, function (error) {
                            if (error && error.errorMessage) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isValidationProgress = false;
                        })
                };

                vm.validationInputPwdText = function () {
                    $timeout(function () {
                        var strengthPercent = vm.passwordStrength.score / 4;
                        if (strengthPercent === 0) {
                            vm.checkpwdStrength["background-color"] = "#f2f2f2";
                            vm.checkpwdStrength.width = "0%";
                            vm.passwordTest = 'Very weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.25) {
                            vm.checkpwdStrength["background-color"] = "red";
                            vm.checkpwdStrength.width = "25%";
                            vm.passwordTest = 'Weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.50) {
                            vm.checkpwdStrength["background-color"] = "orange";
                            vm.checkpwdStrength.width = "50%";
                            vm.passwordTest = 'Fear';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.75) {
                            vm.checkpwdStrength["background-color"] = "yellowgreen";
                            vm.checkpwdStrength.width = "75%";
                            vm.passwordTest = 'Good';
                            vm.isPasswordValid = true;
                        } else {
                            vm.checkpwdStrength["background-color"] = "green";
                            vm.checkpwdStrength.width = "100%";
                            vm.passwordTest = 'Strong';
                            vm.isPasswordValid = true;
                        }
                    })
                };

                vm.fnGeneratePassword = function () {
                    var password = "";
                    var length = 13;
                    while (length > password.length) {
                        var keyToAdd = getKey[Math.floor(Math.random() * getKey.length)];
                        password += keyToAdd();
                    }
                    vm.password = _.cloneDeepWith(password);
                    vm.validationInputPwdText()
                }

                vm.fnInit = function () {
                    if($stateParams.name && $stateParams.token) {
                        vm.name = $stateParams.name;
                        vm.token = $stateParams.token;
                    } else {
                        $state.go("login");
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('validateNewEmailCtrl',
            function ($state, $stateParams, ValidationFactory, $timeout, amaran) {
                var vm = this;
                vm.isValidationProgress = false;
                vm.isShowValidateMessage = false;
                vm.name = "";
                vm.svg = 'predictiveSVG';
                vm.passInputType = 'password';
                vm.confirmPassInputType = 'password';
                vm.currentYear = new Date().getFullYear();
                vm.lastYear = vm.currentYear - 1;
                vm.isSetNewPassword = true;
                vm.password = "";
                vm.isPasswordValid = false;
                vm.passwordStrength = {};
                vm.checkpwdStrength = {
                    "background": "#f2f2f2",
                    "width": "0%",
                    "height": "100%",
                    "border-radius": "60px"
                };
                vm.passwordTest = 'Very weak';
                var keys = {
                    upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                    lowerCase: "abcdefghijklmnopqrstuvwxyz",
                    number: "0123456789",
                    symbol: "!@#$%^&*()_+~\`|}{[]:;?><,./-="
                }
                var getKey = [
                    function upperCase() {
                        return keys.upperCase[Math.floor(Math.random() * keys.upperCase.length)];
                    },
                    function lowerCase() {
                        return keys.lowerCase[Math.floor(Math.random() * keys.lowerCase.length)];
                    },
                    function number() {
                        return keys.number[Math.floor(Math.random() * keys.number.length)];
                    },
                    function symbol() {
                        return keys.symbol[Math.floor(Math.random() * keys.symbol.length)];
                    }
                ];

                vm.hideShowPassword = function () {
                    if (vm.passInputType === 'password') {
                        vm.passInputType = 'text';
                    } else {
                        vm.passInputType = 'password';
                    }
                };

                vm.hideShowPasswordForConfirm = function () {
                    if (vm.confirmPassInputType === 'password') {
                        vm.confirmPassInputType = 'text';
                    } else {
                        vm.confirmPassInputType = 'password';
                    }
                };

                vm.fnValidateUser = function () {
                    vm.isValidationProgress = true;
                    var inputObj = {
                        body: {
                            "password": vm.password
                        }
                    };
                    ValidationFactory.validateNewUser(inputObj)
                        .then(function () {
                            vm.isValidationProgress = false;
                            vm.isShowValidateMessage = true;
                        }, function (error) {
                            if (error && error.errorMessage) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isValidationProgress = false;
                        })
                };

                vm.fnValidateNewEmail = function () {
                    vm.isValidationProgress = true;
                    var inputObj = {
                        body: {
                            "password": vm.password
                        }
                    };
                    ValidationFactory.validateNewEmail(inputObj)
                        .then(function () {
                            vm.isValidationProgress = false;
                            vm.isShowValidateMessage = true;
                        }, function (error) {
                            if (error && error.errorMessage) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isValidationProgress = false;
                        })
                };

                vm.validationInputPwdText = function () {
                    $timeout(function () {
                        var strengthPercent = vm.passwordStrength.score / 4;
                        if (strengthPercent === 0) {
                            vm.checkpwdStrength["background-color"] = "#f2f2f2";
                            vm.checkpwdStrength.width = "0%";
                            vm.passwordTest = 'Very weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.25) {
                            vm.checkpwdStrength["background-color"] = "red";
                            vm.checkpwdStrength.width = "25%";
                            vm.passwordTest = 'Weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.50) {
                            vm.checkpwdStrength["background-color"] = "orange";
                            vm.checkpwdStrength.width = "50%";
                            vm.passwordTest = 'Fear';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.75) {
                            vm.checkpwdStrength["background-color"] = "yellowgreen";
                            vm.checkpwdStrength.width = "75%";
                            vm.passwordTest = 'Good';
                            vm.isPasswordValid = true;
                        } else {
                            vm.checkpwdStrength["background-color"] = "green";
                            vm.checkpwdStrength.width = "100%";
                            vm.passwordTest = 'Strong';
                            vm.isPasswordValid = true;
                        }
                    })
                };

                vm.fnGeneratePassword = function () {
                    var password = "";
                    var length = 13;
                    while (length > password.length) {
                        var keyToAdd = getKey[Math.floor(Math.random() * getKey.length)];
                        password += keyToAdd();
                    }
                    vm.password = _.cloneDeepWith(password);
                    vm.validationInputPwdText()
                };

                vm.fnInit = function () {
                    if($stateParams.name && $stateParams.token) {
                        vm.name = $stateParams.name;
                        vm.token = $stateParams.token;
                        vm.isSetNewPassword = true;
                    } else if($stateParams.token){
                        vm.token = $stateParams.token;
                        vm.isSetNewPassword = false;
                    }else{
                        $state.go("login");
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('validationsPasswordCtrl',
            function ($state, $stateParams, $timeout, ValidationFactory, amaran) {
                var vm = this;
                vm.isResetPasswordProgress = false;
                vm.isShowValidateMessage = false;
                vm.name = "";
                vm.svg = 'predictiveSVG';
                vm.passInputType = 'password';
                vm.confirmPassInputType = 'password';
                vm.currentYear = new Date().getFullYear();
                vm.lastYear = vm.currentYear - 1;
                vm.password = "";
                vm.isPasswordValid = false;
                vm.passwordStrength = {};
                vm.checkpwdStrength = {
                    "background": "#f2f2f2",
                    "width": "0%",
                    "height": "100%",
                    "border-radius": "60px"
                };
                vm.passwordTest = 'Very weak';
                var keys = {
                    upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
                    lowerCase: "abcdefghijklmnopqrstuvwxyz",
                    number: "0123456789",
                    symbol: "!@#$%^&*()_+~\`|}{[]:;?><,./-="
                }
                var getKey = [
                    function upperCase() {
                        return keys.upperCase[Math.floor(Math.random() * keys.upperCase.length)];
                    },
                    function lowerCase() {
                        return keys.lowerCase[Math.floor(Math.random() * keys.lowerCase.length)];
                    },
                    function number() {
                        return keys.number[Math.floor(Math.random() * keys.number.length)];
                    },
                    function symbol() {
                        return keys.symbol[Math.floor(Math.random() * keys.symbol.length)];
                    }
                ];

                vm.hideShowPassword = function () {
                    if (vm.passInputType === 'password') {
                        vm.passInputType = 'text';
                    } else {
                        vm.passInputType = 'password';
                    }
                };

                vm.hideShowPasswordForConfirm = function () {
                    if (vm.confirmPassInputType === 'password') {
                        vm.confirmPassInputType = 'text';
                    } else {
                        vm.confirmPassInputType = 'password';
                    }
                };

                vm.fnValidatePassword = function () {
                    vm.isResetPasswordProgress = true;
                    var inputObj = {
                        body: {}
                    };
                    inputObj.body = {"password": vm.password};
                    ValidationFactory.validateNewPassword(inputObj)
                        .then(function () {
                            amaran.success("Your password is reset Successfully");
                            vm.isResetPasswordProgress = false;
                            vm.isShowValidateMessage = true;
                        }, function (error) {
                            if (error && error.errorMessage) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isResetPasswordProgress = false;
                        })
                };

                vm.validationInputPwdText = function () {
                    $timeout(function () {
                        var strengthPercent = vm.passwordStrength.score / 4;
                        if (strengthPercent === 0) {
                            vm.checkpwdStrength["background-color"] = "#f2f2f2";
                            vm.checkpwdStrength.width = "0%";
                            vm.passwordTest = 'Very weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.25) {
                            vm.checkpwdStrength["background-color"] = "red";
                            vm.checkpwdStrength.width = "25%";
                            vm.passwordTest = 'Weak';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.50) {
                            vm.checkpwdStrength["background-color"] = "orange";
                            vm.checkpwdStrength.width = "50%";
                            vm.passwordTest = 'Fear';
                            vm.isPasswordValid = false;
                        } else if (strengthPercent <= 0.75) {
                            vm.checkpwdStrength["background-color"] = "yellowgreen";
                            vm.checkpwdStrength.width = "75%";
                            vm.passwordTest = 'Good';
                            vm.isPasswordValid = true;
                        } else {
                            vm.checkpwdStrength["background-color"] = "green";
                            vm.checkpwdStrength.width = "100%";
                            vm.passwordTest = 'Strong';
                            vm.isPasswordValid = true;
                        }
                    })
                };

                vm.fnGeneratePassword = function () {
                    var password = "";
                    var length = 13;
                    while (length > password.length) {
                        var keyToAdd = getKey[Math.floor(Math.random() * getKey.length)];
                        password += keyToAdd();
                    }
                    vm.password = _.cloneDeepWith(password);
                    vm.validationInputPwdText()
                }

                vm.fnInit = function () {
                    if ($stateParams.name && $stateParams.token) {
                        vm.name = $stateParams.name;
                        vm.token = $stateParams.token;
                    } else {
                        $state.go("login");
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('signupCtrl',
            function ($timeout, $scope, $cookies, $state, $http, $q, $uibModal, amaran, AccountFactory) {
                var vm = this;
                vm.isLoging = false;
                vm.currentYear = new Date().getFullYear();
                vm.svg = 'predictiveSVG';
                vm.headerText = 'Create a Free Account';
                vm.showUserNameSuggestions = false;
                vm.isSignupForm = true;
                vm.isEmailInvalid = true;
                vm.isEmailAvailable = true;
                vm.isUsernameAvailable = true;
                vm.newSinupObj = {
                    user: {},
                    account: {}
                };

                vm.userObj = {};
                vm.accountObj = {name: ''};
                vm.isCreatingNewAccount = false;
                vm.calculatorUrl = "https://predictivetech.io/resources/calculator/index.html";

                vm.isPolicyCheck = false;
                vm.fnGoToLoginPage = function () {
                    $state.go('login');
                };

                vm.fnValidateEmail = function (email) {
                    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    vm.isEmailInvalid = !re.test(email);
                };

                vm.fnCreateFreeAccount = function () {
                    vm.isCreatingNewAccount = true;
                    vm.newSinupObj.user = angular.copy({
                        firstName: vm.userObj.firstName,
                        lastName: vm.userObj.lastName,
                        username: vm.userObj.username,
                        email: vm.userObj.email
                    });
                    vm.accountObj.name = vm.accountObj.name === '' ? vm.userObj.firstName + "_" + vm.userObj.lastName : vm.accountObj.name;
                    vm.newSinupObj.account = angular.copy({
                        name: vm.accountObj.name
                    });
                    AccountFactory.createNewSelfServiceAccount({body: vm.newSinupObj})
                        .then(function () {
                            amaran.success("Free Account created Successfully");
                            vm.isCreatingNewAccount = false;
                            vm.headerText = 'Congratulations';
                            vm.isSignupForm = false;
                            vm.isProfileForm = false;
                            angular.element('#signupForm').removeClass('active');
                            vm.isProfileBillingView = true;
                            vm.isSignUpCompleted = true;
                        }, function (error) {
                            if (error && error.errorCode) {
                                amaran.error(error.errorMessage);
                            }
                            vm.isCreatingNewAccount = false;
                        });
                };

                vm.fnVerifyCaptcha = function () {
                    vm.captchaVerified = true;
                };

                vm.fnReVerifyCaptcha = function () {
                    vm.captchaVerified = false;
                };

                vm.fnOpenSupportModal = function (obj, isCalledForSupport, recoveryType) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/supportModal/supportModal.html',
                        size: 'md',
                        controller: 'SupportCtrl as support',
                        resolve: {
                            userObj: function () {
                                return obj;
                            },
                            isCalledForSupport: function () {
                                return isCalledForSupport;
                            },
                            recoveryType: function () {
                                return recoveryType;
                            }
                        }
                    })
                };

                vm.fnOpenCreditCardInfoModal = function () {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/modals/CreditCardInfoModel/creditCardInfoModal.html',
                        size: 'md',
                        controller: 'CreditCardInfoCtrl as CreditCardInfo'
                    })
                };


                vm.fnInitSignup = function () {
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('SAMLUserDataLoad',
            function (swal, $state, $cookies, $timeout, $window, Authenticate, DB, UserFactory, SecurityFactory,
                      SessionFactory, AccountFactory, navigationMenuService, AppInitService) {
                var vm = this;
                //vm.isForFederation = !!DB.fnGet('federation');
                vm.fnInit = function () {
                    SessionFactory.getLoginUser()
                        .then(function (loginUserObj) {
                            DB.fnSet('loginUser', loginUserObj);
                            AccountFactory.describeAccountState()
                                .then(function (response) {
                                    DB.fnSet('currentAccountState', response);
                                    var navigationResponse = navigationMenuService.fnCreateMenu(loginUserObj, response);
                                    var menu = navigationResponse.menuArr;
                                    DB.fnSet('menu', menu);
                                    $timeout(function () {
                                        AppInitService.fnSetAsynCall();
                                    });
                                    UserFactory.describeUserProfile()
                                        .then(function (userProfileObj) {
                                            DB.fnSet('userProfile', userProfileObj);
                                            var responseTheme;
                                            var userProfile = DB.fnGet('userProfile');
                                            if (userProfile !== null && angular.isDefined(userProfile) && angular.isDefined(userProfile.pre) && angular.isDefined(userProfile.pre.home) && angular.isDefined(userProfile.pre.home.all) && angular.isDefined(userProfile.pre.home.all.appliedTheme)) {
                                                if (!_.isEmpty(userProfile.pre.home.all.appliedTheme)) {
                                                    DB.fnSet('appliedTheme', userProfile.pre.home.all.appliedTheme);
                                                    less.modifyVars(userProfile.pre.home.all.appliedTheme); //eslint-disable-line
                                                } else {
                                                    responseTheme = {
                                                        "bgPrimaryColor": "#fff",
                                                        "brandPrimary": "#6CCCCC",
                                                        "previewBgColor": "#fff",
                                                        "previewPrimaryColor": "#6CCCCC"
                                                    };
                                                    DB.fnRemove('appliedTheme');
                                                    less.modifyVars(responseTheme); //eslint-disable-line
                                                }
                                            } else {
                                                responseTheme = {
                                                    "bgPrimaryColor": "#fff",
                                                    "brandPrimary": "#6CCCCC",
                                                    "previewBgColor": "#fff",
                                                    "previewPrimaryColor": "#6CCCCC"
                                                };
                                                DB.fnRemove('appliedTheme');
                                                less.modifyVars(responseTheme); //eslint-disable-line
                                            }
                                            if (_.isEmpty(userProfile)) {
                                                AppInitService.fnSetUserProfile();
                                            }

                                            if (navigationResponse.state === 'active') {
                                                if (userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet && userProfile.pre.home.all.isLandingUrlSet !== '') {
                                                    $window.location.href = userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet;
                                                } else {
                                                    Authenticate.fnDefaultRedirect();
                                                }
                                            } else {
                                                swal({
                                                    title: "",
                                                    text: navigationResponse.message,
                                                    type: "warning",
                                                    showCancelButton: false,
                                                    confirmButtonText: "OK",
                                                    closeOnConfirm: true,
                                                    showLoaderOnConfirm: false
                                                });
                                                $state.go(navigationResponse.stateName);
                                            }
                                        }, function () {
                                            DB.fnRemove('loginUserEmail');
                                            DB.fnRemove('loginUser');
                                            $cookies.remove('phoenix');
                                            DB.fnRemove('xContextId');
                                            vm.isLoging = false;
                                        });
                                }, function () {
                                    DB.fnRemove('loginUserEmail');
                                    DB.fnRemove('loginUser');
                                    $cookies.remove('phoenix');
                                    DB.fnRemove('xContextId');
                                    vm.isLoging = false;
                                })
                        }, function () {
                            DB.fnRemove('loginUserEmail');
                            $cookies.remove('phoenix');
                            DB.fnRemove('xContextId');
                            vm.isLoging = false;
                        })
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('renderCtrl',
            function ($scope, $stateParams, $timeout, $http, $state, vegaEmbed, jsyaml) {
                var vm = this;
                vm.chartType = '';
                vm.chartValue = '';
                vm.isChartTypeSupported = true;
                vm.isErrorFound = false;

                vm.fnRenderChart = function () {
                    var chartData;
                    var url;
                    if (vm.chartType === 'mermaid') {
                        try {
                            chartData = atob(vm.chartValue.replace(/ /g, "+"));
                        } catch (err) {
                            vm.isErrorFound = true;
                            return true;
                        }
                        url = "https://mermaid.ink/img/" + btoa(angular.toJson({"code": chartData}));
                        $timeout(function () {
                            angular.element(".imgRender").append("<img src='" + url + "'/>");
                        });
                    } else if (vm.chartType === 'vega') {
                        $timeout(function () {
                            angular.element(".imgRender").append("<div class='test' style='display: none'></div>");
                            try {
                                chartData = atob(vm.chartValue.replace(/ /g, "+"));
                            } catch (err) {
                                vm.isErrorFound = true;
                                return true;
                            }
                            $timeout(function () {
                                if (isJson(chartData)) {
                                    vegaEmbed(".test", angular.fromJson(angular.toJson(jsyaml.load(chartData))), {
                                        actions: false,
                                        renderer: 'svg'
                                    }).then(function (result) {
                                        result.view.toImageURL('png').then(function (url) {
                                            angular.element(".imgRender").innerHTML = "";
                                            angular.element(".imgRender").innerText = "";
                                            angular.element(".imgRender").append("<img src='" + url + "'/>");
                                        }).catch(function () { /* error handling */

                                        });
                                    }).catch(console.error); //eslint-disable-line
                                } else {
                                    vegaEmbed(".test", angular.fromJson(chartData), {
                                        actions: false,
                                        renderer: 'svg'
                                    }).then(function (result) {
                                        result.view.toImageURL('png').then(function (url) {
                                            angular.element(".imgRender").innerHTML = "";
                                            angular.element(".imgRender").innerText = "";
                                            angular.element(".imgRender").append("<img src='" + url + "'/>");
                                        }).catch(function () { /* error handling */
                                        });
                                    }).catch(console.error); //eslint-disable-line
                                }
                            }, 100);
                        });
                    } else if (vm.chartType === 'plantuml') {
                        $timeout(function () {
                            /* eslint-disable */
                            try {
                                var tempData = atob(vm.chartValue.replace(/ /g, "+"));
                            } catch (err) {
                                vm.isErrorFound = true;
                                return true;
                            }
                            angular.element(".imgRender").append("<pre style='width: max-content;'><code class='lang-plantuml'>" + tempData + "</code></pre>");
                            $timeout(function () {
                                plantuml_runonce();
                            });
                            /* eslint-disable */
                        })
                    } else if (vm.chartType === 'highchart') {
                        var exportUrl = "https://export.highcharts.com/";
                        try {
                            chartData = atob(vm.chartValue.replace(/ /g, "+"));
                        } catch (err) {
                            vm.isErrorFound = true;
                            return true;
                        }
                        /* eslint-disable */
                        $.ajax({
                            type: 'POST',
                            data: {"async": true, "options": chartData},
                            url: exportUrl,
                            success: function (data) {
                                $('.imgRender').html('<img src="' + exportUrl + data + '"/>');
                            }
                        });
                        /* eslint-enable */
                    } else {
                        vm.isChartTypeSupported = false;
                    }
                };

                vm.fnBackToHome = function () {
                    $state.go('login');
                };

                function isJson(validateInput) {
                    try {
                        angular.fromJson(validateInput);
                    } catch (err) {
                        return true;
                    }
                    return false;
                }

                vm.fnInit = function () {
                    if ($stateParams.type && $stateParams.value) {
                        vm.chartType = $stateParams.type;
                        vm.chartValue = $stateParams.value;
                        vm.fnRenderChart();
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('noPrivilegesCtrl',
            function (Authenticate) {
                var vm = this;

                vm.fnInitDashboard = function () {
                    Authenticate.fnDefaultRedirect();
                };
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($rootScope, $scope, $window, $uibModal, $timeout, $http, $state, $stateParams, $base64, $sce, interval, $cookies, $location, amaran, DB, QueryFactory,
                            copyService, navigationMenuService, AvatarService, PermissionsService, ColorService, FedSudoUserService, UserFactory, projectArr, issueStateArr, issuePriorityArr, issueTypeArr, nodeProjectArr,
                            FederationsFactory, HealthFactory, ListenerFactory, moment, StateFactory, TypeFactory, AppInitService, nodeProjectHealthArr, typeArrDb, statesArrDb, modelsObjDb, SessionFactory, ProjectHealthService, UserProfileService) {

        var vm = this;

        vm.authUserObj = DB.fnGet("loginUser") ? DB.fnGet("loginUser") : {};
        vm.federationObj = DB.fnGet('federation');
        vm.supportUserObj = DB.fnGet('support');
        vm.currentYear = new Date().getFullYear();
        vm.lastYear = vm.currentYear - 1;
        vm.phoenixVersion = DB.fnGet('xPhoenixVersion');
        vm.topNavMenu = DB.fnGet('menu');
        var isFindStorage = _.find(vm.topNavMenu, {name: "Storage"});
        if (isFindStorage) {
            isFindStorage.isAcess = false;
        }
        // vm.accountId = DB.fnGet('federation') ? DB.fnGet('federation').id.split("-")[1] : vm.authUserObj.id.split("-")[0];
        //var userProfile = DB.fnGet('userProfile');
        vm.accountId = vm.authUserObj && vm.authUserObj.id ? vm.authUserObj.id.split("-")[0] : '';
        if (!Object.keys(vm.authUserObj).length) {
            $state.go('samlUserLoading');
        }
        vm.isUserDataSet = true;
        vm.outBoundFederationLoading = false;
        vm.isFederationEnabled = false;
        vm.preferenceMenu = [
            {
                "name": "Profile",
                "state": "main.user_profiles",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/Asset4.svg#test_1\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Preferences",
                "state": "main.preferences",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/preferences.svg#preferences\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Support",
                "state": "main.support",
                "isAcess": (vm.authUserObj.administrator === true || vm.authUserObj.accountOwner === true) && vm.accountId !== 'cu000000',
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/support.svg#support\"></use> \n" +
                    "</svg>"
            }
        ];
        vm.iot3ToolsMenu = [
            {
                "name": "IoT3 Workbench",
                "state": "main.workbench",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/workbench.svg#workbench\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "IoT3 Library",
                "state": "main.iot3",
                "isAcess": vm.accountId === 'cu000000' && !DB.fnGet('federation') && !DB.fnGet('support'),
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/iot.svg#iot3\"></use> \n" +
                    "</svg>"
            }
        ];
        vm.billingMenu = [
            {
                "name": "Payment Methods",
                "state": "main.payment_method",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"23px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/card.svg#card\"></use> \n" +
                    "</svg>"
            }, {
                "name": "Invoices",
                "state": "main.invoice",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/invoice.svg#invoice\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Discounts",
                "state": "main.discount",
                "isAcess": vm.accountId === "cu000000" && !DB.fnGet('federation') && !DB.fnGet('support'),
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/discount.svg#discount\"></use> \n" +
                    "</svg>"
            }, {
                "name": "Credit Tokens",
                "state": "main.credit_token",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/creditTokens.svg#creditToken\"></use> \n" +
                    "</svg>"

            }, {
                "name": "Business",
                "state": "main.business",
                "isAcess": vm.authUserObj.administrator === true || vm.authUserObj.billingManager === true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/business.svg#business\"></use> \n" +
                    "</svg>"
            }, {
                "name": "Plans",
                "state": "main.plan",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/plan.svg#plan\"></use> \n" +
                    "</svg>"
            }, {
                "name": "S4",
                "state": "main.billing_scripts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                    "</svg>"
            }
        ];
        vm.accessMenu = [
            {
                "name": "Dashboard",
                "state": "main.access_dashboard",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Users",
                "state": "main.users",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Teams",
                "state": "main.teams",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use> \n" +
                    "</svg>"
            }/*,
            {
                "name": "Security Role",
                "state": "main.securityRoles",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/security-role.svg#security_role_1\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Security Group",
                "state": "main.securityGroups",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/securityGroup.svg#securtiy_group\"></use> \n" +
                    "</svg>"
            }*/,
            {
                "name": "Vaults",
                "state": "main.vaults",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/vault.svg#vault\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Authenticators",
                "state": "main.authenticators",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"23px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/password.svg#password\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Federations",
                "state": "main.federations",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "S4",
                "state": "main.scripts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Emails",
                "state": "main.emailTemplate",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Whitelists",
                "state": "main.emails",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/email.svg#email\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Audits",
                "state": "main.audits",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/log.svg#log\"></use>\n" +
                    "</svg>"
            } /*,
            {
                "name": "Contact",
                "icon": "fa-address-card-o",
                "state": "main.contacts",
                "isAcess": true
            }*/
        ];
        vm.trackerSettingsMenu = [
            {
                "name": "Projects",
                "state": "main.project",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Labels",
                "state": "main.label",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/label.svg#label\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Priorities",
                "state": "main.priorities",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "States",
                "state": "main.state",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/state.svg#state\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Types",
                "state": "main.types",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/types.svg#types\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "S4",
                "state": "main.tracker_scripts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                    "</svg>"
            }
        ];
        vm.nodeSettingsMenu = [
            {
                "name": "Projects",
                "state": "main.node_project",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Healths",
                "state": "main.health",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/health.svg#health\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "S4",
                "state": "main.node_scripts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "ES4",
                "state": "main.node_es4",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/es4.svg#es4\"></use>\n" +
                    "</svg>"
            }, {
                "name": "Observers",
                "state": "main.node_observer",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/observers.svg#observers\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Emails",
                "state": "main.node_emailTemplate",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use>\n" +
                    "</svg>"
            }
        ];
        vm.storeMenu = [
            {
                "name": "Products",
                "state": "main.products",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/product.svg#product\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Carts",
                "state": "main.cart",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"22px\" height=\"22px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/cart.svg#cart\"></use> \n" +
                    "</svg>"
            }];
        vm.documentationMenu = [
            {
                "name": "Documentation",
                "state": "main.documentations",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/documentations.svg#documentations\"></use> \n" +
                    "</svg>"
            }
        ];
        vm.insightSettingsMenu = [
            {
                "name": "Projects",
                "state": "main.insight_project",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "   <use xlink:href=\"assets/images/svg/service/project.svg#project\"></use> \n" +
                    "</svg>"
            },
            {
                "name": "Queries",
                "state": "main.insight_queries",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/service/script.svg#script\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Charts",
                "state": "main.insight_charts",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/insight-chart.svg#insight-chart\"></use>\n" +
                    "</svg>"
            },
            {
                "name": "Widgets",
                "state": "main.insight_widgets",
                "isAcess": true,
                "svgIcon": "<svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\">\n" +
                    "<use\n" +
                    "xlink:href=\"assets/images/svg/insight-widget.svg#insight-widget\"></use>\n" +
                    "</svg>"
            }
        ];
        vm.minutes = "00";
        vm.seconds = "00";
        vm.reloadTimeout = '';
        vm.isShowRefreshSwal = false;
        vm.pageURL = "";

        vm.deliberatelyTrustDangerousSnippet = function (svgIcon) { //eslint-disable-line*/
            return $sce.trustAsHtml(svgIcon); //eslint-disable-line*/
        };
        vm.accessAppOrder = ['Account', 'User', 'Role', 'Group', 'Vault', 'Authenticator', 'Contact', 'Federation'];
        vm.storeAppOrder = ['Products', 'Carts'];
        vm.trackerAppOrder = ['Dashboard', 'Issues', 'Archives', 'Labels', 'Projects', 'S4', 'Priorities', 'State', 'Types'];
        vm.pipelineAppOrder = ['Workflow', 'Listener', 'Template', 'Transformer'];
        // remove 'Visualizer'
        vm.nodeAppOrder = ['Dashboard', 'Alarms', 'Alarm History', 'Nodes', 'ECU', 'Jobs', 'Fleet', 'Software'];
        vm.aiAppOrder = ['Trainer', 'Model', 'Distribution', 'Deployment'];
        vm.insightAppOrder = ['Dashboard', 'Query Editor', 'Dashboards'];
        if (localStorage.getItem(nodeProjectHealthArr)) {
            var healthData = localStorage.getItem(nodeProjectHealthArr) ? angular.fromJson($base64.decode(localStorage.getItem(nodeProjectHealthArr))) : [];
            ColorService.setHealthObj(healthData);
        } else {
            ColorService.setHealthObj();
        }
        AppInitService.setInitData();
        vm.isSetDarkTheme = UserProfileService.fnGetSystemProfileObj('appliedTheme') === "" || _.isEmpty(UserProfileService.fnGetSystemProfileObj('appliedTheme'));
        var codeset = {
            65: false, //a
            85: false, //u
            82: false, //r
            71: false, //g
            86: false, //v
            70: false, //f
            80: false, //p
            87: false, //w
            76: false, //l
            84: false, //t
            78: false, //n
            68: false, //d
            79: false, //o
            72: false, //h
            73: false, //i
            66: false, //b
            83: false, //s
            77: false, //m
            89: false, //y
            67: false, //c
            81: false, //q
            88: false, //x
            69: false, //e
            16: false, //shift
            191: false, //forward slash
            90: false, // z,
            74: false //j
        };
        var docCount = 0;
        var infoCount = 0;
        var landingCount = 0;
        var helpCount = 0;
        var lockTimer;
        var loginTimer;
        var devAccountIds = ["cu5e25fc", "cu000000", "cu767c86", "cueeed05"];
        var comingSoonApps = ['Automator', 'Storage', 'AI'];

        function fnIsAccessToBilling() {
            var currentAccountState = {};
            var loginUser = DB.fnGet("loginUser");
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                loginUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                currentAccountState = loginUser.currentAccountState;
                if (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid') {
                    return loginUser.sessionObj.user.accountOwner === true || loginUser.sessionObj.user.billingRole === 'MANAGER';
                } else {
                    if (loginUser.sessionObj.user.accountOwner === true) {
                        return true;
                    } else {
                        return loginUser.sessionObj.user.billingRole === 'MANAGER';
                    }
                }
            } else {
                currentAccountState = DB.fnGet('currentAccountState');
                if (currentAccountState && (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid')) {
                    return loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER';
                } else {
                    if (loginUser.accountOwner === true) {
                        return true;
                    } else {
                        return loginUser.billingRole === 'MANAGER';
                    }
                }
            }
        }

        function fnIsAllowToAccess() {
            var currentAccountState = {};
            var loginUser = DB.fnGet("loginUser");
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                loginUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                currentAccountState = loginUser.currentAccountState;
                if (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid') {
                    return loginUser.sessionObj.user.accountOwner === true || loginUser.sessionObj.user.billingRole === 'MANAGER';
                } else {
                    return loginUser.sessionObj.user.accountOwner === true || loginUser.sessionObj.user.administrator === true;
                }
            } else {
                currentAccountState = DB.fnGet('currentAccountState');
                if (currentAccountState && (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid')) {
                    return loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER';
                } else {
                    return loginUser.accountOwner === true || loginUser.administrator === true;
                }
            }
        }

        function fnIsAllowStore() {
            var currentAccountState = {};
            var loginUser = DB.fnGet("loginUser");
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                loginUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                currentAccountState = loginUser.currentAccountState;
                if (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid') {
                    return loginUser.sessionObj.user.accountOwner === true || loginUser.sessionObj.user.billingRole === 'MANAGER';
                } else {
                    if (loginUser.sessionObj.user.accountOwner === true) {
                        return true;
                    } else {
                        return loginUser.sessionObj.user.billingRole === 'MANAGER' || loginUser.sessionObj.user.nodeRole === 'MANAGER';
                    }
                }
            } else {
                currentAccountState = DB.fnGet('currentAccountState');
                if (currentAccountState && (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid')) {
                    return loginUser.accountOwner === true || loginUser.billingRole === 'MANAGER';
                } else {
                    if (loginUser.accountOwner === true) {
                        return true;
                    } else {
                        return loginUser.billingRole === 'MANAGER' || loginUser.nodeRole === 'MANAGER';
                    }
                }
            }
        }

        vm.isAccessBilling = fnIsAccessToBilling();
        vm.isAllowdAccess = fnIsAllowToAccess();
        vm.isAllowStore = fnIsAllowStore();
        vm.fnCheckNavActive = function () {
            angular.element(".levelOneNav .nav-second-level").addClass("levelSecondNav");
            if (angular.element(".slimScrollDiv .levelOneNav").hasClass("active")) {
                angular.element(".metismenu .active .nav-second-level").removeClass("levelSecondNav");
            }
        };

        vm.fnMouseEnter = function (e, type) {
            var parentElem = angular.element(".sidebar .navbar-default");
            var top = e.currentTarget.offsetTop + e.currentTarget.clientHeight - (parentElem.scrollTop() + 1);
            var width = angular.element(".metismenu").width();

            var hoverMenuEle = angular.element(e.currentTarget).find('.levelSecondNav');
            if (angular.isDefined(type) && type === 'trackerSettingMenu') {
                var menuHeight = $('.' + type).height(); // eslint-disable-line
                var bodyHeight = $('body').height(); // eslint-disable-line
                angular.element(hoverMenuEle).css('top', bodyHeight - menuHeight - (36 + 60) + 'px');
            } else {
                angular.element(hoverMenuEle).css('top', top + 'px');
            }
            angular.element(hoverMenuEle).css('left', width + 'px');
        };

        vm.fnMouseLeave = function (e) {
            var hoverMenuEle = angular.element(e.currentTarget).find('.levelSecondNav');
            angular.element(hoverMenuEle).css('top', '');
            angular.element(hoverMenuEle).css('left', '');
        };

        vm.fnCheckScroll = function () {
            var element = angular.element('.mini-navbar .sidebar');
            if (element[0] && element[0].scrollHeight > element[0].clientHeight) {
                angular.element(".levelSecondNav").css("margin-left", "-1.6em");
            } else {
                angular.element(".levelSecondNav").css("margin-left", "");
            }
        };

        vm.fnHoverMenuSelected = function (e) {
            angular.element(".levelSecondNav").removeClass("in");
            $timeout(function () {
                var parentElem = angular.element(e.currentTarget).parent();
                angular.element(parentElem).addClass("in");
            }, 0)
        };

        vm.fnCheckHeight = function () {
            if (angular.element("#trackerSettingMenu").hasClass('mm-show')) {
                var totalHeight = angular.element('.navbar-static-side');
                var element = angular.element('#side-menu');
                var secondElement = angular.element('.tracker-setting-menu');
                var tempH = element[0].offsetHeight + secondElement[0].offsetHeight;
                if (tempH > totalHeight[0].offsetHeight) {
                    angular.element("#trackerSettingMenu").css('height', totalHeight[0].offsetHeight - (element[0].offsetHeight + 52) + 'px');
                    angular.element("#trackerSettingMenu").css('overflow', 'auto');
                } else {
                    angular.element("#trackerSettingMenu").css('height', '');
                    angular.element("#trackerSettingMenu").css('overflow', '');
                }
            }
        }

        vm.fnLogoutORLock = function (screen) {
            document.removeEventListener('keydown', eventHandler);
            document.removeEventListener('keyup', keyUpEventHandler);
            if (screen === 'login') {
                DB.fnRemove('loginUserEmail');
                DB.fnRemove('loginUser');
                DB.fnRemove('currentAccountState');
                DB.fnRemove('userPermissions');
                DB.fnRemove('hfs');
                DB.fnRemove('menu');
                DB.fnRemove('userProfile');
                DB.fnRemove('healthArray');
                localStorage.removeItem(modelsObjDb);
                localStorage.removeItem(statesArrDb);
                localStorage.removeItem(typeArrDb);
                localStorage.removeItem(projectArr);
                localStorage.removeItem(issueStateArr);
                localStorage.removeItem(issuePriorityArr);
                localStorage.removeItem(issueTypeArr);
                localStorage.removeItem(nodeProjectArr);
                localStorage.removeItem(nodeProjectHealthArr);
            } else {
                DB.fnSet('hfs', $location.path());
            }
            $cookies.remove('phoenix');
            DB.fnRemove('federation');
            DB.fnRemove('support');
            DB.fnRemove('xContextId');
            DB.fnRemove('xPhoenixVersion');
            interval.clearAll();
            $state.go(screen);
        };

        vm.fnFilterSideName = function () {
            if ($state.current.menu === "profile") {
                return vm.preferenceMenu;
            } else if ($state.current.menu === "iot3Tools") {
                return vm.iot3ToolsMenu;
            } else if ($state.current.menu === "billing") {
                return _.filter(vm.billingMenu, function (billObj) {
                    return billObj.isAcess === true;
                });
            } else if ($state.current.menu === "store") {
                return _.filter(vm.storeMenu, function (storeObj) {
                    return storeObj.isAcess === true;
                });
            } else if ($state.current.menu === "documentation") {
                return vm.documentationMenu;
            } else if ($state.current.menu === "access") {
                return vm.accessMenu;
            } else {
                var sideNav = vm.topNavMenu.filter(function (d) {
                    return d.name.toLowerCase().indexOf($state.current.menu) !== -1
                });
                if (sideNav.length) {
                    var sortedMenu = sideNav[0].sideMenu;
                    switch ($state.current.menu) {
                        case "tracker":
                            sortedMenu = vm.trackerAppOrder.map(function (i) {
                                return sideNav[0].sideMenu.find(function (o) {
                                    return o.name === i;
                                });
                            });
                            break;
                        //case 'Automator':
                            /*if (devAccountIds.includes(vm.accountId)) {
                                sortedMenu = vm.pipelineAppOrder.map(function (i) {
                                    return sideNav[0].sideMenu.find(function (o) {
                                        return o.name === i;
                                    });
                                });
                            } else {
                                sortedMenu = []
                            }
                            sortedMenu = []
                            break;*/
                        case 'node':
                            // if (DB.fnGet('federation') || DB.fnGet('support')) {
                            //     sortedMenu = vm.nodeAppOrder.map(function (i) {
                            //         return sideNav[0].sideMenu.find(function (o) {
                            //             return o.name === i;
                            //         });
                            //     });
                            //     _.forEach(sortedMenu, function (sortedMenuObj) {
                            //         if (sortedMenuObj.name === "Software" || sortedMenuObj.name === "Fleet") {
                            //             sortedMenuObj.isAcess = false;
                            //         }
                            //     })
                            // } else {
                                sortedMenu = vm.nodeAppOrder.map(function (i) {
                                    return sideNav[0].sideMenu.find(function (o) {
                                        return o.name === i;
                                    });
                                });
                            // }
                            break;
                        //case 'ai':
                            /*if (devAccountIds.includes(vm.accountId)) {
                                sortedMenu = vm.aiAppOrder.map(function (i) {
                                    return sideNav[0].sideMenu.find(function (o) {
                                        return o.name === i;
                                    });
                                });
                            } else {
                                sortedMenu = []
                            }
                            sortedMenu = []
                            break;*/
                        case 'storage':
                            if (!devAccountIds.includes(vm.accountId)) {
                                sortedMenu = []
                            }
                            break;
                        case 'insight':
                            sortedMenu = vm.insightAppOrder.map(function (i) {
                                return sideNav[0].sideMenu.find(function (o) {
                                    return o.name === i;
                                });
                            });
                            break;
                    }
                    return _.filter(sortedMenu, function (tempObj) {
                        return angular.isObject(tempObj);
                    });
                }
                return [];
            }
        };

        vm.fnShowHideMenuItem = function (itemObj) {
            if (angular.isDefined(itemObj)) {
                var tempReturn = angular.copy(itemObj.isAcess);
                /*if (itemObj.name === 'Federation') {
                    userProfile = DB.fnGet('userProfile');
                    if (angular.isDefined(userProfile) && angular.isDefined(userProfile.pre) && angular.isDefined(userProfile.pre.home) && angular.isDefined(userProfile.pre.home.all) && angular.isDefined(userProfile.pre.home.all.isFederationsEnabled)) {
                        if (userProfile.pre.home.all.isFederationsEnabled === false) {
                            tempReturn = false;
                        }
                    } else {
                        tempReturn = false;
                    }
                }*/
                return tempReturn;
            }
        };

        vm.fnGetProfileView = function () {
            $state.go(vm.preferenceMenu[0].state);
        };

        vm.fnGetBillingView = function () {
            $state.go(vm.billingMenu[0].state);
        };

        vm.fnGetStoreView = function () {
            $state.go(vm.storeMenu[0].state);
        };

        vm.fnGetAccessView = function () {
            $state.go(vm.accessMenu[0].state);
        };

        vm.fnGetDocumentationView = function () {
            $state.go(vm.documentationMenu[0].state);
        };

        vm.fnHideShowBillingMenu = function () {
            if (vm.federationObj && vm.federationObj.id.split("-")[1] === 'cu000000') {
                /*vm.billingMenu.map(function (billObj) {
                    if (billObj.name !== 'Dashboard' && billObj.name !== 'Bill' && billObj.name !== 'Budget') {
                        billObj.isAcess = false;
                    }
                })*/
            } else if (!vm.federationObj && vm.accountId === 'cu000000') {
                /*vm.billingMenu.map(function (billObj) {
                    if (billObj.name !== 'Dashboard' && billObj.name !== 'Bill' && billObj.name !== 'Budget') {
                        billObj.isAcess = false;
                    }
                })*/
            } else {
                _.filter(vm.billingMenu, function (billObj) {
                    return billObj.isAcess === true;
                });
            }
        };

        vm.fnGetHealths = function (inputObj, preDefinedNodeHealths, isCalledForViz) {
            QueryFactory.executeQuery(inputObj)
                .then(function (res) { // Success block
                    var healthsArr = isCalledForViz ? preDefinedNodeHealths : [];
                    _.forEach(res.data, function (projectObj) {
                        healthsArr.push(projectObj);
                    });
                    if ((res.data && res.data.length && res.data.length > 0) && (healthsArr[0] && healthsArr[0].healthsArr > healthsArr.length)) {
                        var sqlString = 'SELECT *, data->>\'_id\' AS rt FROM node_healths';
                        sqlString += ' WHERE data->>\'_id\' > ' + "'" + healthsArr[healthsArr.length - 1].rt + "'";
                        sqlString += ' ORDER BY data->>\'_id\' asc LIMIT ' + 100 + ';';
                        vm.fnGetHealths({sql: sqlString}, healthsArr, true);
                    } else {
                        //DB.fnSet("healthArray", healthsArr);
                        ColorService.fnSetHealthData(healthsArr);
                        var rootProjectSQL = {"sql": "select * from node_projects where data->>\'parentProjectId\' IS NULL"};
                        QueryFactory.executeQuery(rootProjectSQL)
                            .then(function (res) {
                                if (res && res.data && res.data.length) {
                                    var rootProject = res.data[0];
                                    ProjectHealthService.fnSetProjectRelationshipHealthArr(rootProject.id);
                                }
                            }, function () { // Error block

                            })
                    }
                }, function () { // Error block
                })
        };

        vm.getTrackerSettingMenu = function () {
            return $state.current.menu === 'tracker';
        };

        vm.getNodeSettingMenu = function () {
            return $state.current.menu === 'node';
        };

        vm.fnCheckSettingsMenuPermissions = function () {
            if ($state.current.menu === 'tracker') {
                return vm.authUserObj.trackerRole !== 'TEAM_MEMBER' && vm.authUserObj.trackerRole !== 'CUSTOMER';
            } else if ($state.current.menu === 'node') {
                return vm.authUserObj.nodeRole !== 'TEAM_MEMBER' && vm.authUserObj.nodeRole !== 'CUSTOMER' && vm.authUserObj.nodeRole !== 'ENGINEER'
            } else if ($state.current.menu === 'insight') {
                return vm.authUserObj.insightRole !== 'TEAM_MEMBER' && vm.authUserObj.insightRole !== 'CUSTOMER'
            } else {
                return false;
            }
        }

        vm.fnAppChange = function (e, navObj) {
            e.preventDefault();
            var sideFlag = false;
            var stateGo = null;
            if (navObj.name === "Node") {
                var loginUser = DB.fnGet("loginUser");
                var currentAccountState = '';
                var nodeHealthSQL = 'SELECT *, COUNT(*) OVER() as totalItems , data->>\'_id\' AS rt FROM node_healths ORDER BY rt asc LIMIT ' + 100 + ';';
                if (DB.fnGet('federation') || DB.fnGet('support')) {
                    loginUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                    currentAccountState = loginUser.currentAccountState;
                    if (currentAccountState && (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid')) {
                        DB.fnRemove("healthArray")
                    } else {
                        if (loginUser.sessionObj.user.accountOwner === true || loginUser.sessionObj.user.administrator === true || loginUser.sessionObj.user.nodeRole === 'MANAGER' || loginUser.sessionObj.user.nodeRole === 'SUPERVISOR' || loginUser.sessionObj.user.nodeRole === 'ENGINEER' || loginUser.sessionObj.user.nodeRole === 'TEAM_MEMBER' || loginUser.sessionObj.user.nodeRole === 'CUSTOMER') {
                            vm.fnGetHealths({sql: nodeHealthSQL}, [], false);
                        } else {
                            DB.fnRemove("healthArray");
                        }
                    }
                } else {
                    currentAccountState = DB.fnGet('currentAccountState');
                    if (currentAccountState && (currentAccountState.state.toLowerCase() === 'suspended' || currentAccountState.state.toLowerCase() === 'unpaid')) {
                        DB.fnRemove("healthArray")
                    } else {
                        if (loginUser.accountOwner === true || loginUser.administrator === true || loginUser.nodeRole === 'MANAGER' || loginUser.nodeRole === 'SUPERVISOR' || loginUser.nodeRole === 'ENGINEER' || loginUser.nodeRole === 'TEAM_MEMBER' || loginUser.nodeRole === 'CUSTOMER') {
                            vm.fnGetHealths({sql: nodeHealthSQL}, [], false);
                        } else {
                            DB.fnRemove("healthArray");
                        }
                    }
                }
            }
            navObj.sideMenu.filter(function (sideNavObj) {
                    if (sideNavObj.isAcess === true && !sideFlag) {
                        sideFlag = true;
                        stateGo = sideNavObj.state;
                    }
                    if (sideNavObj.default) {
                        stateGo = sideNavObj.state;
                    }
                    return false
                }
            );
            if (comingSoonApps.includes(navObj.name)) {
                if (navObj.name === "Automator") {
                    $state.go('main.pipelinecomingsoon');
                } else if (navObj.name === "Storage") {
                    $state.go('main.storagecomingsoon');
                } else {
                    $state.go('main.aicomingsoon');
                }
            } else {
                $state.go(stateGo);
            }
        };

        vm.fnGetAndSetPrivileges = function () {
            $timeout(function () {
                $state.go('loading');
                //$window.location.reload();
            }, 20);
        };

        vm.fnOpenFederationModal = function () {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                templateUrl: 'app/main/modals/federationOptions/federationOptions.html',
                size: 'lg',
                controller: 'federationOptionsCtrl as fedOptions',
                windowClass: 'modal-height100'
            });
            modalInstance.result.then(function (fedObj) {
                vm.fnSetFederation(fedObj);
            }, function () {
            });
        };

        vm.fnGetOutBoundFederations = function () {
            vm.fnHideShowBillingMenu();
            vm.outBoundFederationLoading = true;
            vm.isFederationEnabled = true;
            if ($stateParams.federationId && !DB.fnGet('federation')) {
                vm.federationWorking = true;
                var input = {
                    federationId: $base64.decode($stateParams.federationId)
                };
                FederationsFactory.describeFederation(input)
                    .then(function (response) {
                        if (_.isEmpty(response)) {
                            vm.federationWorking = false;
                            amaran.error('You are unauthorized to access ' + $base64.decode($stateParams.federationId) + ' federation.');
                            $state.go($state.current.name, {'federationId': ''}, {notify: false});
                            delete $stateParams.federationId;
                        } else {
                            vm.fnSetFederation(response);
                        }
                        vm.outBoundFederationLoading = false;
                    }, function (error) {
                        amaran.error(error.errorMessage);
                        if ($stateParams.federationId && !DB.fnGet('federation')) {
                            vm.federationWorking = false;
                            amaran.error('Retrieving federation details was unsuccessful');
                            $state.go($state.current.name, {'federationId': ''}, {notify: false});
                            delete $stateParams.federationId;
                        }
                        vm.outBoundFederationLoading = false;
                    })
            } else {
                vm.outBoundFederationLoading = false;
            }
        };

        vm.fnSetFederation = function (federationObj) {
            vm.federationWorking = true;
            var input = {
                federationId: federationObj.id
            };
            SessionFactory.createFederationSession(input).then(function (response) {
                response.federationToken = $base64.encode("X-FFT:" + response.id);
                federationObj.sessionObj = response;
                federationObj.currentAccountState = {
                    state: response.accountState,
                    accountPlan: response.accountPlan
                };
                DB.fnSet('federation', federationObj);
                var navigationResponse = navigationMenuService.fnCreateMenu(response.user, federationObj.currentAccountState);
                var menu = navigationResponse.menuArr;
                DB.fnSet('menu', menu);
                UserFactory.describeUserProfile()
                    .then(function (userProfileObj) {
                        DB.fnSet('userProfile', userProfileObj);
                        var userProfile = DB.fnGet('userProfile');
                        if (_.isEmpty(userProfile)) {
                            AppInitService.fnSetUserProfile();
                        }
                        $state.go('loading');
                    }, function () {
                        $state.go('loading');
                    });
                vm.federationWorking = false;
            }, function (error) {
                if (error && error.errorCode === -1) {
                    amaran.error(error.errorMessage);
                }
                vm.federationWorking = false;
            });
        };

        vm.fnRemoveFedration = function () {
            vm.federationWorking = true;
            $state.go($state.current.name, {federationId: ''}, {notify: false});
            DB.fnRemove('federation');
            localStorage.removeItem('fedSupportIssueDraft');
            var loginUserObj = DB.fnGet('loginUser');
            var currentAccountState = DB.fnGet('currentAccountState');
            var navigationResponse = navigationMenuService.fnCreateMenu(loginUserObj, currentAccountState);
            var menu = navigationResponse.menuArr;
            DB.fnSet('menu', menu);
            UserFactory.describeUserProfile()
                .then(function (userProfileObj) {
                    DB.fnSet('userProfile', userProfileObj);
                    var userProfile = DB.fnGet('userProfile');
                    if (_.isEmpty(userProfile)) {
                        AppInitService.fnSetUserProfile();
                    }
                    $state.go('loading');
                }, function () {
                    $state.go('loading');
                });
        };

        vm.fnRemoveSupport = function () {
            vm.federationWorking = true;
            DB.fnRemove('support');
            localStorage.removeItem('fedSupportIssueDraft');
            var loginUserObj = DB.fnGet('loginUser');
            var currentAccountState = DB.fnGet('currentAccountState');
            var navigationResponse = navigationMenuService.fnCreateMenu(loginUserObj, currentAccountState);
            var menu = navigationResponse.menuArr;
            DB.fnSet('menu', menu);
            UserFactory.describeUserProfile()
                .then(function (userProfileObj) {
                    DB.fnSet('userProfile', userProfileObj);
                    var userProfile = DB.fnGet('userProfile');
                    if (_.isEmpty(userProfile)) {
                        AppInitService.fnSetUserProfile();
                    }
                    $state.go('loading');
                }, function () {
                    $state.go('loading');
                });
        };

        vm.fnUpdateUserData = function () {
            /*var loginUser = DB.fnGet('loginUser');
            var inputObj = {
                userId: loginUser.id,
                body: {}
            };
            inputObj.body = loginUser.data;
            UserFactory.replaceUserData(inputObj)
                .then(function (data) {
                    loginUser.data = data.data;
                    DB.fnSet('loginUser', loginUser);
                    vm.fnGetAndSetPrivileges();
                }, function (error) {
                    if (error && error.errorCode === -1) {
                        amaran.error(error.errorMessage);
                    }
                });*/
            vm.fnGetAndSetPrivileges();
        };

        $scope.$on('401_error', function () {
            vm.fnLogoutORLock('lock');
        });

        $scope.$on('forceLogOut', function () {
            vm.fnLogoutORLock('login');
        });

        $scope.$on('FederationSettingsChanged', function () {
            vm.fnGetOutBoundFederations();
        });

        $scope.$on('ThemeSettingsChanged', function () {
            vm.isSetDarkTheme = UserProfileService.fnGetSystemProfileObj('appliedTheme') === "" || _.isEmpty(UserProfileService.fnGetSystemProfileObj('appliedTheme'));
            vm.fnAutoThemeAdjustment();
        });

        $scope.$on('startSudoProcess', function (event, data) {
            vm.federationWorking = true;
            var input = {
                accountId: data.id
            };
            SessionFactory.createSupportSession(input).then(function (response) {
                var supportObj = {};
                supportObj.alias = data.name;
                response.supportToken = $base64.encode("X-FPT:" + response.id);
                supportObj.sessionObj = response;
                supportObj.sessionObj.accountId = data.id;
                supportObj.sessionObj.accountName = data.name;
                supportObj.currentAccountState = {
                    state: response.accountState,
                    accountPlan: response.accountPlan
                };
                DB.fnSet('support', supportObj);
                var navigationResponse = navigationMenuService.fnCreateMenu(response.user, supportObj.currentAccountState);
                var menu = navigationResponse.menuArr;
                DB.fnSet('menu', menu);
                UserFactory.describeUserProfile()
                    .then(function (userProfileObj) {
                        DB.fnSet('userProfile', userProfileObj);
                        var userProfile = DB.fnGet('userProfile');
                        if (_.isEmpty(userProfile)) {
                            AppInitService.fnSetUserProfile();
                        }
                        $state.go('loading');
                    }, function () {
                        $state.go('loading');
                    });
            }, function (error) {
                if (error && error.errorCode === -1) {
                    amaran.error(error.errorMessage);
                }
            });
        });

        $scope.$on('startFederationProcess', function (event, data) {
            vm.fnSetFederation(data);
        });

        $scope.$on('destroy', function () {
            document.removeEventListener('keydown', eventHandler);
            document.removeEventListener('keyup', keyUpEventHandler);
        });

        vm.fnOpenInfoModel = function () {
            if (infoCount === 0) {
                infoCount++;
                var modalInstance = $uibModal.open({
                    backdrop: 'static',
                    templateUrl: 'app/components/breadcrumb/InformationModel/informationModal.html',
                    size: 'lg',
                    controller: 'infoModalCtrl as infoModal'
                });
                modalInstance.result.then(function () {
                    infoCount = 0;
                }, function () {
                    infoCount = 0;
                });
            }
        };

        vm.fnCopyInfoToClipboard = function (data, type) {
            copyService.fnCopyToClipboard(data);
            amaran.success(type + " copied successfully");
        };

        vm.fnChangeState = function (app, state) {
            var stateName;
            if (app === 'Profile' || app === 'Billing' || app === 'Access' ||
                (app === 'ECSMon' && (state === 'predictive_dashboard' || state === 'accounts')) ||
                (app === 'Tracker' && (state === 'project' || state === 'label' || state === 'priorities' || state === 'state' || state === 'types' || state === 'tracker_scripts')) ||
                (app === 'Node' && (state === 'node_project' || state === 'health' || state === 'node_scripts' || state === 'node_es4' || state === 'node_observer' || state === 'node_emailTemplate')) ||
                (app === 'Insight' && (state === 'insight_project' || state === 'insight_queries' || state === 'insight_charts' || state === 'insight_widgets'))) {
                stateName = 'main.' + state;
                $state.go(stateName);
            } else {
                var topNavMenu = DB.fnGet('menu');
                var appObj = _.find(topNavMenu, {name: app});
                if (appObj && appObj.isAcess) {
                    stateName = 'main.' + state;
                    var stateObj = _.find(appObj.sideMenu, {state: stateName});
                    if (stateObj && stateObj.isAcess) {
                        $state.go(stateName);
                    }
                }
            }
        };

        vm.fnGetUserAvatar = function (userObj) {
            return AvatarService.getTextAvatar(userObj);
        };

        vm.fnSetDarkTheme = function () {
            vm.isUserDataSet = false;
            var responseTheme = {
                "bgPrimaryColor": "#2b2c30",
                "brandPrimary": "#6CCCCC",
                "textPrimaryColor": "#ffffff",
                "textSecondaryColor": "#dedfe2",
                "previewBgColor": "#2b2c30",
                "previewPrimaryColor": "#6CCCCC",
                "previewTextPrimaryColor": "#ffffff",
                "previewTextSecondaryColor": "#dedfe2"
            };
            var userProfileData = DB.fnGet('userProfile');
            if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                userProfileData.pre.home.all.appliedTheme = responseTheme;
            } else {
                userProfileData.pre.home.all = {
                    appliedTheme: responseTheme
                };
            }
            var inputObj = {
                body: userProfileData
            };
            UserFactory.updateUserProfile(inputObj)
                .then(function (response) {
                    DB.fnSet('userProfile', response);
                    //userProfile = response;
                    DB.fnSet('appliedTheme', responseTheme);
                    less.modifyVars(responseTheme); // eslint-disable-line
                    vm.isUserDataSet = true;
                    vm.isSetDarkTheme = false;
                }, function () {
                    vm.isUserDataSet = true;
                });
        };

        vm.fnSetDefaultTheme = function () {
            vm.isUserDataSet = false;
            var responseTheme = {
                "bgPrimaryColor": "#fff",
                "brandPrimary": "#6CCCCC",
                "previewBgColor": "#fff",
                "previewPrimaryColor": "#6CCCCC"
            };
            var userProfileData = DB.fnGet('userProfile');
            if (userProfileData.pre && userProfileData.pre.home && userProfileData.pre.home.all) {
                userProfileData.pre.home.all.appliedTheme = {};
            } else {
                userProfileData.pre.home.all = {
                    appliedTheme: {}
                };
            }
            var inputObj = {
                body: userProfileData
            };
            UserFactory.updateUserProfile(inputObj)
                .then(function (response) {
                    DB.fnSet('userProfile', response);
                    //userProfile = response;
                    DB.fnRemove('appliedTheme');
                    less.modifyVars(responseTheme); // eslint-disable-line
                    vm.isUserDataSet = true;
                    vm.isSetDarkTheme = true;
                }, function () {
                    vm.isUserDataSet = true;
                });
        };

        vm.fnInitMain = function () {
            vm.permissionObj = PermissionsService.getPermissionsV4('access');
            vm.isViewAccessApp = fnIsAllowToAccess();
            if (DB.fnGet('federation')) {
                var fedObj = DB.fnGet('federation');
                $state.go($state.current.name, {'federationId': $base64.encode(fedObj.id)}, {notify: false});
                var federatedAccessModalEnabled = UserProfileService.fnGetSystemProfileObj('isFederationInitMessageEnabled');
                vm.isFederatedAccessModalEnabled = federatedAccessModalEnabled === '' ? true : federatedAccessModalEnabled;
                if (vm.isFederatedAccessModalEnabled && vm.isFederatedAccessModalEnabled !== "false") {
                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/main/modals/federatedAccess/federatedAccess.html',
                        size: 'lg',
                        controller: 'federatedAccessCtrl as federatedAccess'
                    });
                    modalInstance.result.then(function (type) {
                        if (type === 'ReturnToMyAccount') {
                            vm.fnRemoveFedration();
                        }
                    }, function () {
                    });
                }
            }
            if ($window.location.hostname !== "localhost") {
                var url = HOST_URL.node.split("https://")[1]; //eslint-disable-line
                vm.pageURL = "";
                if (url.startsWith('dev')) {
                    vm.pageURL = "www.ecsmon.ecsiteapp.com"
                } else if (url.startsWith('qa')) {
                    vm.pageURL = "www.ecsmon.ecsiteapp.com"
                } else {
                    vm.pageURL = "www.ecsmon.ecsiteapp.com"
                }
                $timeout(function () {
                    fnGetLatestAppVersion();
                }, 3600000)
            }
            vm.fnAutoThemeAdjustment();
        };

        vm.fnAutoThemeAdjustment = function () {
            var isAutoThemeAdjustment = UserProfileService.fnGetSystemProfileObj('autoThemeAdjustment');
            if (isAutoThemeAdjustment) {
                var hrs = +moment().format('HH');
                var startTime = "";
                var endTime = "";
                var diff = "";
                if (hrs >= 0 && hrs < 7) {
                    //morning
                    if (vm.isSetDarkTheme) {
                        vm.fnSetDarkTheme();
                    }
                    startTime = moment();
                    endTime = "07:00:01";
                    diff = moment.duration(moment(endTime, 'HH:mm:ss').diff(moment(startTime, 'HH:mm:ss')));
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnAutoThemeAdjustment();
                        }, 1000);
                        vm.fnSetDefaultTheme();
                    }, diff._milliseconds);
                } else if (hrs >= 7 && hrs < 19) {
                    //afternoon
                    if (!vm.isSetDarkTheme) {
                        vm.fnSetDefaultTheme();
                    }
                    startTime = moment().format('HH:mm:ss');
                    endTime = "19:00:01";
                    diff = moment.duration(moment(endTime, 'HH:mm:ss').diff(moment(startTime, 'HH:mm:ss')));
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnAutoThemeAdjustment();
                        }, 1000);
                        vm.fnSetDarkTheme();
                    }, diff._milliseconds);
                } else {
                    //night
                    if (vm.isSetDarkTheme) {
                        vm.fnSetDarkTheme();
                    }
                    startTime = moment();
                    endTime = moment(startTime).add(1, 'days').format("DD-MM-YYYY");
                    endTime = endTime + " 07:00:01"
                    diff = moment.duration(moment(endTime, 'DD-MM-YYYY HH:mm:ss').diff(moment(startTime, 'DD-MM-YYYY HH:mm:ss')));
                    $timeout(function () {
                        $timeout(function () {
                            vm.fnAutoThemeAdjustment();
                        }, 1000);
                        vm.fnSetDefaultTheme();
                    }, diff._milliseconds);
                }
            }
        }

        function fnGetLatestAppVersion() {
            $http({
                method: 'GET',
                url: "https://" + vm.pageURL + "/index.html"
            }).success(function (data) {
                var currentVersion = "";
                var newVersion = "";
                var currentVersionMetas = document.getElementsByTagName('meta');
                for (var i = 0; i < currentVersionMetas.length; i++) {
                    if (currentVersionMetas[i].getAttribute('name') === 'version') {
                        currentVersion = currentVersionMetas[i].getAttribute('content');
                    }
                }
                var doc = new DOMParser().parseFromString(data, "text/html");
                var metas = doc.getElementsByTagName('meta');
                for (var j = 0; j < metas.length; j++) {
                    if (metas[j].getAttribute('name') === 'version') {
                        newVersion = metas[j].getAttribute('content');
                    }
                }
                if (newVersion !== "" && currentVersion !== "" && newVersion !== currentVersion) {
                    vm.minutes = "05";
                    vm.seconds = "00";
                    vm.isShowRefreshSwal = true;
                    startTimer();
                }
                $timeout(function () {
                    fnGetLatestAppVersion();
                }, 3600000)
            });
        }

        function startTimer() {
            var m = parseInt(vm.minutes);
            var s = parseInt(checkSecond((parseInt(vm.seconds) - 1)));
            if (s === 59) {
                m = m - 1
            }
            if (m === 5 && s === 0) {
                vm.isShowRefreshSwal = true;
            }
            if (m < 0) {
                vm.fnReloadSnooze(true);
            } else {
                vm.minutes = m.toString().length === 1 ? '0' + m : m;
                vm.seconds = s.toString().length === 1 ? '0' + s : s;
                vm.reloadTimeout = $timeout(function () {
                    if (parseInt(vm.minutes) >= 0) {
                        startTimer();
                    }
                }, 1000)
            }
        }

        function checkSecond(sec) {
            if (sec < 10 && sec >= 0) {
                sec = "0" + sec
            }
            if (sec < 0) {
                sec = "59"
            }
            return sec;
        }

        vm.fnReloadSnooze = function (reoload) {
            if (reoload) {
                $window.location.reload();
            } else {
                vm.isShowRefreshSwal = false;
                $timeout.cancel(vm.reloadTimeout);
                vm.minutes = "15";
                vm.seconds = "00";
                startTimer();
            }
        }

        vm.fnGetCheckPermission = function (type) {
            var activeUser = '';
            var isAccess = false;
            if (DB.fnGet('federation') || DB.fnGet('support')) {
                var federationUser = DB.fnGet('federation') ? DB.fnGet('federation') : DB.fnGet('support');
                activeUser = federationUser.sessionObj.user;
            } else {
                activeUser = DB.fnGet("loginUser");
            }
            if (activeUser.accountOwner === true || activeUser.administrator === true) {
                if (type === 'billingRole') {
                    if (activeUser.accountOwner === true) {
                        isAccess = true;
                    }
                } else {
                    isAccess = true;
                }
            } else {
                if (type === 'nodeRole') {
                    if (activeUser.nodeRole === 'MANAGER' || activeUser.nodeRole === 'SUPERVISOR' || activeUser.nodeRole === 'ENGINEER' || activeUser.nodeRole === 'TEAM_MEMBER' || activeUser.nodeRole === 'CUSTOMER') {
                        isAccess = true;
                    }
                }
                if (type === 'pipelineRole') {
                    if (activeUser.pipelineRole === 'MANAGER' || activeUser.pipelineRole === 'TEAM_MEMBER') {
                        isAccess = true;
                    }
                }
                if (type === 'trackerRole') {
                    if (activeUser.trackerRole === 'MANAGER' || activeUser.trackerRole === 'TEAM_MEMBER' || activeUser.trackerRole === 'CUSTOMER') {
                        isAccess = true;
                    }
                }
                if (type === 'storageRole') {
                    if (activeUser.storageRole === 'MANAGER' || activeUser.storageRole === 'TEAM_MEMBER' || activeUser.storageRole === 'CUSTOMER') {
                        isAccess = true;
                    }
                }
                if (type === 'aiRole') {
                    if (activeUser.aiRole === 'MANAGER') {
                        isAccess = true;
                    }
                }
                if (type === 'billingRole') {
                    if (activeUser.billingRole === 'MANAGER') {
                        isAccess = true;
                    }
                }
                if (type === 'insightRole') {
                    if (activeUser.insightRole === 'MANAGER' || activeUser.insightRole === 'TEAM_MEMBER' || activeUser.insightRole === 'CUSTOMER') {
                        isAccess = true;
                    }
                }
            }
            return isAccess;
        };

        var eventHandler = function (e) {
            if ($state.current && $state.current.name !== 'login'
                && $state.current.name !== 'lock'
                && $state.current.name !== 'validation'
                && $state.current.name !== 'validations'
                && $state.current.name !== 'signup') {
                //var accPermissionObj = PermissionsService.getPermissions("access:account");
                if (e.keyCode in codeset) {
                    codeset[e.keyCode] = true;
                    if (codeset[81] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp && !DB.fnGet('federation') && !DB.fnGet('support') && vm.accountId === 'cu000000') {
                        event.preventDefault();
                        vm.fnChangeState('ECSMon', 'predictive_dashboard');
                        codeset[81] = false;
                        codeset[68] = false;
                    } else if (codeset[81] && codeset[65] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp && !DB.fnGet('federation') && !DB.fnGet('support') && vm.accountId === 'cu000000') {
                        event.preventDefault();
                        vm.fnChangeState('ECSMon', 'accounts');
                        codeset[81] = false;
                        codeset[65] = false;
                    } else if (codeset[67] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) {
                        event.preventDefault();
                        vm.fnChangeState('Access', 'access_dashboard');
                        codeset[67] = false;
                        codeset[68] = false;
                    } else if (codeset[67] && codeset[85] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Users
                        event.preventDefault();
                        vm.fnChangeState('Access', 'users');
                        codeset[67] = false;
                        codeset[85] = false;
                    } else if (codeset[67] && codeset[84] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Teams
                        event.preventDefault();
                        vm.fnChangeState('Access', 'teams');
                        codeset[67] = false;
                        codeset[84] = false;
                    } else if (codeset[67] && codeset[86] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Vaults
                        event.preventDefault();
                        vm.fnChangeState('Access', 'vaults');
                        codeset[67] = false;
                        codeset[86] = false;
                    } else if (codeset[67] && codeset[65] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Authenticator
                        event.preventDefault();
                        vm.fnChangeState('Access', 'authenticators');
                        codeset[67] = false;
                        codeset[65] = false;
                    } else if (codeset[67] && codeset[70] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Federation
                        event.preventDefault();
                        vm.fnChangeState('Access', 'federations');
                        codeset[67] = false;
                        codeset[70] = false;
                    } else if (codeset[67] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Scripts
                        event.preventDefault();
                        vm.fnChangeState('Access', 'scripts');
                        codeset[67] = false;
                        codeset[83] = false;
                    } else if (codeset[67] && codeset[77] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Email Template
                        event.preventDefault();
                        vm.fnChangeState('Access', 'emailTemplate');
                        codeset[67] = false;
                        codeset[77] = false;
                    } else if (codeset[67] && codeset[69] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Emails
                        event.preventDefault();
                        vm.fnChangeState('Access', 'emails');
                        codeset[67] = false;
                        codeset[69] = false;
                    } else if (codeset[67] && codeset[73] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.isViewAccessApp) { //Access -> Audits
                        event.preventDefault();
                        vm.fnChangeState('Access', 'audits');
                        codeset[67] = false;
                        codeset[73] = false;
                    } else if (codeset[80] && codeset[87] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('pipelineRole')) { //Pipeline -> Workflows
                        event.preventDefault();
                        vm.fnChangeState('Pipeline', 'workflows');
                        codeset[80] = false;
                        codeset[87] = false;
                    } else if (codeset[80] && codeset[76] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('pipelineRole')) { //Pipeline -> Listener
                        event.preventDefault();
                        vm.fnChangeState('Pipeline', 'listeners');
                        codeset[80] = false;
                        codeset[76] = false;
                    } else if (codeset[80] && codeset[84] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('pipelineRole')) { //Pipeline -> Template
                        event.preventDefault();
                        vm.fnChangeState('Pipeline', 'pipeline_templates');
                        codeset[80] = false;
                        codeset[84] = false;
                    } else if (codeset[80] && codeset[82] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('pipelineRole')) { //Pipeline -> Transformer
                        event.preventDefault();
                        vm.fnChangeState('Pipeline', 'transformers');
                        codeset[80] = false;
                        codeset[82] = false;
                    } else if (codeset[78] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Dashboard
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_dashboard');
                        codeset[78] = false;
                        codeset[68] = false;
                    } else if (codeset[78] && codeset[65] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Alarms
                        event.preventDefault();
                        vm.fnChangeState('Node', 'alarms');
                        codeset[78] = false;
                        codeset[65] = false;
                    } else if (codeset[78] && codeset[90] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Alarm History
                        event.preventDefault();
                        vm.fnChangeState('Node', 'alarmHistory');
                        codeset[78] = false;
                        codeset[90] = false;
                    } else if (codeset[78] && codeset[89] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node');
                        codeset[78] = false;
                        codeset[89] = false;
                    } else if (codeset[78] && codeset[88] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> ECU
                        event.preventDefault();
                        vm.fnChangeState('Node', 'ecu');
                        codeset[78] = false;
                        codeset[88] = false;
                    } else if (codeset[78] && codeset[74] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Job
                        event.preventDefault();
                        vm.fnChangeState('Node', 'job');
                        codeset[78] = false;
                        codeset[74] = false;
                    } else if (codeset[78] && codeset[70] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Fleet
                        event.preventDefault();
                        vm.fnChangeState('Node', 'fleet');
                        codeset[78] = false;
                        codeset[70] = false;
                    } else if (codeset[78] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Software
                        event.preventDefault();
                        vm.fnChangeState('Node', 'software');
                        codeset[78] = false;
                        codeset[83] = false;
                    } else if (codeset[78] && codeset[80] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node Project
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_project');
                        codeset[78] = false;
                        codeset[80] = false;
                    } else if (codeset[78] && codeset[72] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Health
                        event.preventDefault();
                        vm.fnChangeState('Node', 'health');
                        codeset[78] = false;
                        codeset[72] = false;
                    } else if (codeset[78] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node Scripts
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_scripts');
                        codeset[78] = false;
                        codeset[83] = false;
                    } else if (codeset[78] && codeset[69] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node ES4
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_es4');
                        codeset[78] = false;
                        codeset[69] = false;
                    } else if (codeset[78] && codeset[79] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node Observer
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_observer');
                        codeset[78] = false;
                        codeset[79] = false;
                    } else if (codeset[78] && codeset[84] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('nodeRole')) { //Node -> Node EmailTemplate
                        event.preventDefault();
                        vm.fnChangeState('Node', 'node_emailTemplate');
                        codeset[78] = false;
                        codeset[84] = false;
                    } else if (codeset[84] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Issue
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'tracker_dashboard');
                        codeset[84] = false;
                        codeset[68] = false;
                    } else if (codeset[84] && codeset[73] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Issue
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'issue');
                        codeset[84] = false;
                        codeset[73] = false;
                    } else if (codeset[84] && codeset[87] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Issue
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'archives');
                        codeset[84] = false;
                        codeset[87] = false;
                    } else if (codeset[84] && codeset[76] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Label
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'label');
                        codeset[84] = false;
                        codeset[76] = false;
                    } else if (codeset[84] && codeset[69] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Project
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'project');
                        codeset[84] = false;
                        codeset[69] = false;
                    } else if (codeset[84] && codeset[82] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Priorities
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'priorities');
                        codeset[84] = false;
                        codeset[82] = false;
                    } else if (codeset[84] && codeset[86] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> State
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'state');
                        codeset[84] = false;
                        codeset[86] = false;
                    } else if (codeset[84] && codeset[89] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Types
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'types');
                        codeset[84] = false;
                        codeset[89] = false;
                    } else if (codeset[84] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('trackerRole')) { //Tracker -> Tracker Scripts
                        event.preventDefault();
                        vm.fnChangeState('Tracker', 'tracker_scripts');
                        codeset[84] = false;
                        codeset[83] = false;
                    } else if (codeset[83] && codeset[70] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('storageRole')) { //Storage -> Folder
                        event.preventDefault();
                        vm.fnChangeState('Storage', 'folder');
                        codeset[83] = false;
                        codeset[70] = false;
                    } else if (codeset[65] && codeset[84] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('aiRole')) { //AI -> Trainer
                        event.preventDefault();
                        vm.fnChangeState('AI', 'trainer');
                        codeset[65] = false;
                        codeset[84] = false;
                    } else if (codeset[65] && codeset[77] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('aiRole')) { //AI -> Model
                        event.preventDefault();
                        vm.fnChangeState('AI', 'model');
                        codeset[65] = false;
                        codeset[77] = false;
                    } else if (codeset[65] && codeset[73] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('aiRole')) { //AI -> Distribution
                        event.preventDefault();
                        vm.fnChangeState('AI', 'distribution');
                        codeset[65] = false;
                        codeset[73] = false;
                    } else if (codeset[65] && codeset[69] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('aiRole')) { //AI -> Deployment
                        event.preventDefault();
                        vm.fnChangeState('AI', 'deployment');
                        codeset[65] = false;
                        codeset[69] = false;
                    } else if (codeset[73] && codeset[81] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Query Editor
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_query_editor');
                        codeset[73] = false;
                        codeset[81] = false;
                    } else if (codeset[73] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Dashboards
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_dashboards');
                        codeset[73] = false;
                        codeset[68] = false;
                    } else if (codeset[73] && codeset[80] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Project
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_project');
                        codeset[73] = false;
                        codeset[80] = false;
                    } else if (codeset[73] && codeset[85] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Queries
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_queries');
                        codeset[73] = false;
                        codeset[85] = false;
                    } else if (codeset[73] && codeset[72] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Charts
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_charts');
                        codeset[73] = false;
                        codeset[72] = false;
                    } else if (codeset[73] && codeset[87] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('insightRole')) { //Insight -> Widgets
                        event.preventDefault();
                        vm.fnChangeState('Insight', 'insight_widgets');
                        codeset[73] = false;
                        codeset[87] = false;
                    } else if (codeset[66] && codeset[80] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> Products
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'products');
                        codeset[66] = false;
                        codeset[80] = false;
                    } else if (codeset[66] && codeset[67] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> Cart
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'cart');
                        codeset[66] = false;
                        codeset[67] = false;
                    } else if (codeset[66] && codeset[77] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> payment_method
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'payment_method');
                        codeset[66] = false;
                        codeset[77] = false;
                    } else if (codeset[66] && codeset[73] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> invoice
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'invoice');
                        codeset[66] = false;
                        codeset[73] = false;
                    } else if (codeset[66] && codeset[68] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole') && !DB.fnGet('federation') && !DB.fnGet('support') && vm.accountId === 'cu000000') { //Billing -> discount
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'discount');
                        codeset[66] = false;
                        codeset[68] = false;
                    } else if (codeset[66] && codeset[84] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> credit_token
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'credit_token');
                        codeset[66] = false;
                        codeset[84] = false;
                    } else if (codeset[66] && codeset[76] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> plan
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'plan');
                        codeset[66] = false;
                        codeset[76] = false;
                    } else if (codeset[66] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && vm.fnGetCheckPermission('billingRole')) { //Billing -> billing_scripts
                        event.preventDefault();
                        vm.fnChangeState('Billing', 'billing_scripts');
                        codeset[66] = false;
                        codeset[83] = false;
                    } else if (codeset[89] && codeset[72] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Profile -> user_profiles
                        event.preventDefault();
                        vm.fnChangeState('Profile', 'user_profiles');
                        codeset[89] = false;
                        codeset[72] = false;
                    } else if (codeset[89] && codeset[80] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Profile -> preferences
                        event.preventDefault();
                        vm.fnChangeState('Profile', 'preferences');
                        codeset[89] = false;
                        codeset[80] = false;
                    } else if (codeset[89] && codeset[66] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Profile -> preferences
                        event.preventDefault();
                        vm.fnChangeState('Profile', 'business');
                        codeset[89] = false;
                        codeset[66] = false;
                    } else if (codeset[89] && codeset[83] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea') && !DB.fnGet('federation') && !DB.fnGet('support') && vm.accountId !== 'cu000000') { //Profile -> access_token
                        event.preventDefault();
                        vm.fnChangeState('Profile', 'support');
                        codeset[89] = false;
                        codeset[83] = false;
                    } else if (codeset[76] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Lock
                        lockTimer = $timeout(function () {
                            if (codeset[76]) {
                                codeset[76] = false;
                                vm.fnLogoutORLock('lock');
                            }
                        }, 2000);
                    } else if (codeset[88] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Login
                        loginTimer = $timeout(function () {
                            if (codeset[88]) {
                                codeset[88] = false;
                                vm.fnLogoutORLock('login');
                            }
                        }, 2000);
                    }
                }
            }
        };

        var keyUpEventHandler = function (e) {
            if (e.keyCode in codeset) {
                if (e.keyCode === 76) { //for long press lock
                    $timeout.cancel(lockTimer);
                    codeset[76] = false;
                } else if (e.keyCode === 88) { //for long press login
                    $timeout.cancel(loginTimer);
                    codeset[88] = false;
                }
            }
            if ($state.current && $state.current.name !== 'login'
                && $state.current.name !== 'lock'
                && $state.current.name !== 'validation'
                && $state.current.name !== 'validations'
                && $state.current.name !== 'signup') {
                if (e.keyCode in codeset) {
                    if (codeset[16] && e.key === 'Shift' && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Open Documentation
                        docCount++;
                        if (docCount === 2) {
                            event.preventDefault();
                            docCount = 0;
                            codeset[16] = false;
                            $window.open('https://docs.predictivetech.io', '_blank');
                        }
                        $timeout(function () {
                            docCount = 0;
                        }, 500)
                    } else if (codeset[72] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //open shortcut modal
                        helpCount++;
                        if (helpCount === 2) {
                            event.preventDefault();
                            helpCount = 0;
                            codeset[72] = false;
                            vm.fnOpenInfoModel();
                        }
                        $timeout(function () {
                            helpCount = 0;
                        }, 500);
                    } else if (codeset[191] && !e.target.outerHTML.startsWith('<input') && !e.target.outerHTML.startsWith('<textarea')) { //Default Route
                        landingCount++;
                        if (landingCount === 2) {
                            event.preventDefault();
                            landingCount = 0;
                            codeset[191] = false;
                            $state.go('main.dashboard');
                        }
                        $timeout(function () {
                            landingCount = 0;
                        }, 500);
                    }
                    codeset[e.keyCode] = false;
                }
            }
        };

        document.addEventListener('keydown', eventHandler);
        document.addEventListener('keyup', keyUpEventHandler);
    }
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('loginCtrl',
            function ($scope, $cookies, $sce, $timeout, $state, $rootScope, $location, $window, $base64, Authenticate,
                      APIFactory, SessionFactory, UserFactory, navigationMenuService, AppInitService, AccountFactory,
                      DB, swal, interval, $uibModal) {
                var vm = this;
                vm.isLoging = false;
                vm.currentYear = new Date().getFullYear();
                vm.lastYear = vm.currentYear - 1;
                vm.loginObj = {};
                vm.inputType = 'password';
                interval.clearAll();
                vm.svg = 'predictiveSVG';
                vm.userFields = [];
                vm.isAuthenticateParameters = false;
                vm.isSessionFailed = false;
                vm.isEmailInvalid = false;
                vm.accountInputType = '';
                vm.model = {};
                vm.sessionObj = {};

                vm.fnLogin = function (loginObj) {
                    angular.element('#passwordForm').removeClass('fadeInRight');
                    vm.isLoging = true;
                    APIFactory.basicAuthUserName = vm.loginObj.email;
                    APIFactory.basicAuthPassword = loginObj.password ? loginObj.password :
                        loginObj.verificationCode;
                    var inputObj = {
                        identifier: vm.loginObj.email,
                        body: loginObj
                    };
                    inputObj.body.typeId = vm.authenticationMethod.values.typeId;
                    /*
                     * Get auth token form credentials
                     * */
                    SessionFactory.createSession(inputObj)
                        .then(function (data) {
                            // vm.isLoging = false;
                            var userToken = "X-FST:" + data.id;
                            $cookies.put('phoenix', $base64.encode(userToken));
                            DB.fnSet('loginUserEmail', APIFactory.basicAuthUserName);

                            /*
                             * Get login user details
                             * */
                            SessionFactory.getLoginUser()
                                .then(function (loginUserObj) {
                                    DB.fnSet('loginUser', loginUserObj);
                                    AccountFactory.describeAccountState()
                                        .then(function (response) {
                                            DB.fnSet('currentAccountState', response);
                                            var navigationResponse = navigationMenuService.fnCreateMenu(loginUserObj, response);
                                            var menu = navigationResponse.menuArr;
                                            DB.fnSet('menu', menu);
                                            $timeout(function () {
                                                AppInitService.fnSetAsynCall();
                                            });
                                            UserFactory.describeUserProfile()
                                                .then(function (userProfileObj) {
                                                    DB.fnSet('userProfile', userProfileObj);
                                                    var responseTheme;
                                                    var userProfile = DB.fnGet('userProfile');
                                                    if (userProfile !== null && angular.isDefined(userProfile) && angular.isDefined(userProfile.pre) && angular.isDefined(userProfile.pre.home) && angular.isDefined(userProfile.pre.home.all) && angular.isDefined(userProfile.pre.home.all.appliedTheme)) {
                                                        if (!_.isEmpty(userProfile.pre.home.all.appliedTheme)) {
                                                            DB.fnSet('appliedTheme', userProfile.pre.home.all.appliedTheme);
                                                            less.modifyVars(userProfile.pre.home.all.appliedTheme); //eslint-disable-line
                                                        } else {
                                                            responseTheme = {
                                                                "bgPrimaryColor": "#fff",
                                                                "brandPrimary": "#6CCCCC",
                                                                "previewBgColor": "#fff",
                                                                "previewPrimaryColor": "#6CCCCC"
                                                            };
                                                            DB.fnRemove('appliedTheme');
                                                            less.modifyVars(responseTheme); //eslint-disable-line
                                                        }
                                                    } else {
                                                        responseTheme = {
                                                            "bgPrimaryColor": "#fff",
                                                            "brandPrimary": "#6CCCCC",
                                                            "previewBgColor": "#fff",
                                                            "previewPrimaryColor": "#6CCCCC"
                                                        };
                                                        DB.fnRemove('appliedTheme');
                                                        less.modifyVars(responseTheme); //eslint-disable-line
                                                    }
                                                    if (_.isEmpty(userProfile)) {
                                                        AppInitService.fnSetUserProfile();
                                                    }

                                                    if (navigationResponse.state === 'active') {
                                                        if (userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet && userProfile.pre.home.all.isLandingUrlSet !== '') {
                                                            $window.location.href = userProfile && userProfile.pre && userProfile.pre.home && userProfile.pre.home.all && userProfile.pre.home.all.isLandingUrlSet;
                                                        } else {
                                                            Authenticate.fnDefaultRedirect();
                                                        }
                                                    } else {
                                                        swal({
                                                                title: "",
                                                                text: navigationResponse.message,
                                                                type: "warning",
                                                                showCancelButton: false,
                                                                confirmButtonText: "OK",
                                                                closeOnConfirm: true,
                                                                showLoaderOnConfirm: false
                                                            });
                                                        $state.go(navigationResponse.stateName);
                                                    }
                                                }, function () {
                                                    DB.fnRemove('loginUserEmail');
                                                    DB.fnRemove('loginUser');
                                                    $cookies.remove('phoenix');
                                                    DB.fnRemove('xContextId');
                                                    vm.isLoging = false;
                                                });
                                        }, function () {
                                            DB.fnRemove('loginUserEmail');
                                            DB.fnRemove('loginUser');
                                            $cookies.remove('phoenix');
                                            DB.fnRemove('xContextId');
                                            vm.isLoging = false;
                                        })
                                }, function () {
                                    DB.fnRemove('loginUserEmail');
                                    $cookies.remove('phoenix');
                                    DB.fnRemove('xContextId');
                                    vm.isLoging = false;
                                })
                        }, function (error) {
                            if (error && error.errorCode === 401) {
                                vm.isSessionFailed = true;
                            }
                            vm.isLoging = false;
                        });

                };

                vm.fnOpenSupportModal = function (obj, isCalledForSupport, recoveryType) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/supportModal/supportModal.html',
                        size: 'md',
                        controller: 'SupportCtrl as support',
                        resolve: {
                            userObj: function () {
                                return obj;
                            },
                            isCalledForSupport: function () {
                                return isCalledForSupport;
                            },
                            recoveryType: function () {
                                return recoveryType;
                            }
                        }
                    })
                };

                vm.hideShowPassword = function () {
                    if (vm.inputType === 'password') {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                };

                vm.fnNextToPassword = function (email) {
                    vm.isAuthenticateParameters = true;
                    vm.loginObj.password = {};
                    vm.isSessionFailed = false;
                    vm.userFields = [];
                    var inputObj = {
                        identifier: email
                    };
                    SessionFactory.describeUserAuthenticationMethod(inputObj)
                        .then(function (response) {
                            vm.authenticationMethod = _.cloneDeepWith(response);
                            if (response.values.typeId === 'bdfe1bac') {
                                vm.apiRes = response.values;
                                vm.idpUrl = $sce.trustAsResourceUrl(vm.apiRes.idpUrl);
                                var userToken = "X-FST:" + vm.apiRes.token;
                                $cookies.put('phoenix', $base64.encode(userToken));
                                DB.fnSet('loginUserEmail', vm.loginObj.email);
                                $timeout(function () {
                                    document.getElementById('saml_form').submit();
                                });
                            } else {
                                var tempArr = [];
                                _.forEach(response.schema.properties, function (value, key) {
                                    tempArr.push({
                                        key: key,
                                        type: "loginInput",
                                        feedback: false,
                                        title: value.title,
                                        disableSuccessState: false,
                                        disableErrorState: false,
                                        placeholder: value.title,
                                        isHide: true
                                    });
                                });
                                vm.schema = _.cloneDeepWith(response.schema);
                                vm.form = tempArr;
                                vm.isAuthenticateParameters = false;
                                angular.element('#loginForm').removeClass('active');
                                angular.element('#passwordForm').addClass('active');
                                angular.element('#passwordForm').addClass('fadeInRight');
                            }
                        }, function (error) {
                            if (error && (error.errorCode === 401 || error.errorCode === 500)) {
                                vm.isEmailInvalid = true;
                            }
                            vm.isAuthenticateParameters = false;
                        });
                };

                vm.fnBackToUser = function () {
                    angular.element('#passwordForm').removeClass('active');
                    angular.element('#loginForm').addClass('active');
                    angular.element('#loginForm').addClass('fadeInRight');
                };

                vm.fnInitLoginScreen = function () {
                    DB.fnRemove('federation');
                    DB.fnRemove('support');
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LockCtrl',
            function ($state, $location, $cookies, $timeout, $sce, interval, APIFactory,
                      SessionFactory, DB, amaran, AvatarService, $uibModal, $base64, $rootScope, Authenticate,
                      modelsObjDb, statesArrDb, typeArrDb, projectArr, issueStateArr, issuePriorityArr,
                      issueTypeArr, nodeProjectArr, nodeProjectHealthArr) {

                var vm = this;
                vm.isUnlocking = false;
                interval.clearAll();
                vm.inputType = 'password';
                vm.currentYear = new Date().getFullYear();
                vm.lastYear = vm.currentYear - 1;
                vm.login = {'email': DB.fnGet('loginUserEmail')};
                //vm.userAvatar = AvatarService.getTextAvatar(DB.fnGet('loginUser'));
                vm.svgPath = 'predictiveSVG';
                vm.userFields = [];
                vm.isAuthenticateParametersFetch = false;
                vm.isSAMLUnlock = false;
                vm.model = {};

                vm.fnLogout = function () {
                    DB.fnRemove('loginUserEmail');
                    DB.fnRemove('loginUser');
                    DB.fnRemove('currentAccountState');
                    DB.fnRemove('userPermissions');
                    DB.fnRemove('hfs');
                    DB.fnRemove('menu');
                    DB.fnRemove('userProfile');
                    DB.fnRemove('healthArray');
                    localStorage.removeItem(modelsObjDb);
                    localStorage.removeItem(statesArrDb);
                    localStorage.removeItem(typeArrDb);
                    localStorage.removeItem(projectArr);
                    localStorage.removeItem(issueStateArr);
                    localStorage.removeItem(issuePriorityArr);
                    localStorage.removeItem(issueTypeArr);
                    localStorage.removeItem(nodeProjectArr);
                    localStorage.removeItem(nodeProjectHealthArr);
                    $cookies.remove('phoenix');
                    DB.fnRemove('federation');
                    DB.fnRemove('support');
                    DB.fnRemove('xContextId');
                    DB.fnRemove('xPhoenixVersion');
                    interval.clearAll();
                    $state.go('login');
                };

                vm.fnUnlock = function (obj) {
                    vm.isUnlocking = true;
                    APIFactory.basicAuthUserName = vm.login.email;
                    APIFactory.basicAuthPassword = obj.password;

                    if (DB.fnGet('loginUserEmail')) {
                        var inputObj = {
                            identifier: DB.fnGet('loginUserEmail'),
                            body: obj
                        };
                        inputObj.body.typeId = vm.authenticationMethod.values.typeId;
                        SessionFactory.createSession(inputObj)
                            .then(function (data) {
                                var userToken = "X-FST:" + data.id;
                                $cookies.put('phoenix', $base64.encode(userToken));
                                if (DB.fnGet('hfs')) {
                                    var hfs = DB.fnGet('hfs');
                                    DB.fnRemove('hfs');
                                    if (hfs === '/limited-access') {
                                        Authenticate.fnDefaultRedirect();
                                    } else if (hfs === '/lock') {
                                        Authenticate.fnDefaultRedirect();
                                    } else {
                                        $location.url(hfs);
                                    }
                                } else {
                                    //Authenticate.fnDefaultRedirect();
                                    $state.go("main.dashboard");
                                }
                                vm.isUnlocking = false;
                            }, function () {
                                vm.isUnlocking = false;
                            });
                    } else {
                        $location.url('/login');
                    }
                };

                vm.fnOpenSupportModal = function (obj, isCalledForSupport, recoveryType) {
                    $uibModal.open({
                        backdrop: 'static',
                        templateUrl: 'app/components/supportModal/supportModal.html',
                        size: 'md',
                        controller: 'SupportCtrl as support',
                        resolve: {
                            userObj: function () {
                                return obj;
                            },
                            isCalledForSupport: function () {
                                return false;
                            },
                            recoveryType: function () {
                                return recoveryType;
                            }
                        }
                    })
                };

                vm.hideShowPassword = function () {
                    if (vm.inputType === 'password') {
                        vm.inputType = 'text';
                    } else {
                        vm.inputType = 'password';
                    }
                };

                vm.fnUnlockSAML = function () {
                    $timeout(function () {
                        document.getElementById('saml_form').submit();
                    });
                };

                vm.fnInitLockScreen = function () {
                    DB.fnRemove('federation');
                    DB.fnRemove('support');
                    var loginUser = DB.fnGet('loginUser');
                    if (angular.isDefined(loginUser)) {
                        vm.isAuthenticateParametersFetch = false;
                        vm.isSAMLUnlock = false;
                        var inputObj = {
                            type: "email",
                            identifier: loginUser.email
                        };

                        SessionFactory.describeUserAuthenticationMethod(inputObj)
                            .then(function (response) {
                                vm.authenticationMethod = _.cloneDeepWith(response);
                                if (response.values.typeId === 'bdfe1bac') {
                                    vm.apiRes = response.values;
                                    vm.idpUrl = $sce.trustAsResourceUrl(vm.apiRes.idpUrl);
                                    var userToken = "X-FST:" + vm.apiRes.token;
                                    $cookies.put('phoenix', $base64.encode(userToken));
                                    vm.isSAMLUnlock = true;
                                } else {
                                    var tempArr = [];
                                    _.forEach(response.schema.properties, function (value, key) {
                                        tempArr.push({
                                            key: key,
                                            type: "loginInput",
                                            feedback: false,
                                            title: value.title,
                                            disableSuccessState: false,
                                            disableErrorState: false,
                                            placeholder: value.title,
                                            isHide: true
                                        });
                                    });
                                    vm.schema = _.cloneDeepWith(response.schema);
                                    vm.form = tempArr;
                                    vm.isAuthenticateParametersFetch = true;
                                }
                            }, function (error) {
                                if (error && error.errorCode === -1) {
                                    amaran.error(error.errorMessage);
                                }
                                vm.isAuthenticateParametersFetch = true;
                            });
                    } else {
                        SessionFactory.deleteSession()
                            .then(function () {});
                        DB.fnRemove('loginUserEmail');
                        DB.fnRemove('loginUser');
                        DB.fnRemove('currentAccountState');
                        DB.fnRemove('userPermissions');
                        DB.fnRemove('hfs');
                        DB.fnRemove('menu');
                        DB.fnRemove('userProfile');
                        DB.fnRemove('healthArray');
                        localStorage.removeItem(modelsObjDb);
                        localStorage.removeItem(statesArrDb);
                        localStorage.removeItem(typeArrDb);
                        localStorage.removeItem(projectArr);
                        localStorage.removeItem(issueStateArr);
                        localStorage.removeItem(issuePriorityArr);
                        localStorage.removeItem(issueTypeArr);
                        localStorage.removeItem(nodeProjectArr);
                        $cookies.remove('phoenix');
                        DB.fnRemove('federation');
                        DB.fnRemove('support');
                        DB.fnRemove('xContextId');
                        DB.fnRemove('xPhoenixVersion');
                        interval.clearAll();
                        $state.go('login');
                    }
                };
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('LoadingScreenCtrl',
            function ($state, $timeout, Authenticate, QueryFactory, ColorService, DB, ProjectHealthService, $log) {
                var vm = this;
                vm.isForFederation = !!DB.fnGet('federation');
                vm.isForSupport = !!DB.fnGet('support');

                vm.fnGetNodeHealth = function (isWaitForResponse) {
                    var inputObj = {
                        "sql": "SELECT * FROM node_healths"
                    };

                    QueryFactory.executeQuery(inputObj)
                        .then(function (res) {
                            if (res && res.data) {
                                // Parse the health data from each record
                                var healthsArr = res.data.map(function(item) {
                                    try {
                                        // Parse the nested data using Angular methods
                                        if (item.data && angular.isString(item.data)) {
                                            var parsedData = angular.fromJson(item.data);
                                            return {
                                                id: parsedData.id,
                                                name: parsedData.name,
                                                color: parsedData.color,
                                                value: parsedData.value,
                                                description: parsedData.description,
                                                createdAt: item.created_at,
                                                updatedAt: item.updated_at
                                            };
                                        }
                                        return item;
                                    } catch (e) {
                                        $log.error('Error parsing health data:', e);
                                        return item;
                                    }
                                });

                                // Sort by value
                                healthsArr.sort(function(a, b) {
                                    return a.value - b.value;
                                });

                                DB.fnSet("healthArray", healthsArr);
                                ColorService.fnSetHealthData(healthsArr);
                            }

                            var rootProjectSQL = {
                                "sql": "SELECT * FROM node_projects WHERE data->>'parentProjectId' IS NULL LIMIT 1"
                            };

                            return QueryFactory.executeQuery(rootProjectSQL);
                        })
                        .then(function (res) {
                            if (res && res.data && res.data.length) {
                                var rootProject = res.data[0];
                                ProjectHealthService.fnSetProjectRelationshipHealthArr(rootProject.id);
                            }

                            if (isWaitForResponse) {
                                $timeout(function () {
                                    Authenticate.fnDefaultRedirect();
                                }, 500);
                            }
                        })
                        .catch(function (error) {
                            $log.error('Error in health data flow:', error);
                            if (isWaitForResponse) {
                                $timeout(function () {
                                    Authenticate.fnDefaultRedirect();
                                }, 500);
                            }
                        });
                };

                vm.fnInit = function () {
                    if (vm.isForFederation || vm.isForSupport) {
                        vm.fnGetNodeHealth(true);
                    } else {
                        Authenticate.fnDefaultRedirect();
                        vm.fnGetNodeHealth(false);
                    }
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('DashboardCtrl',
            function ($state, Authenticate) {
                var vm = this;
                vm.fnInitDashboard = function () {
                    Authenticate.fnDefaultRedirect();
                }
            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('comingSoonCtrl',
            function () {

            });
})();

(function () {
    'use strict';

    angular.module('phoenixNewUi')
        .controller('404Ctrl',
            function ($state, PermissionsService, DB, ColorService, HealthFactory) {
                var vm = this;
                vm.pageOptions = [];

                vm.fnGoToState = function (state) {
                    $state.go(state)
                };

                vm.fnGetHealths = function () {
                    HealthFactory.getHealths()
                        .then(function (response) {
                            ColorService.fnSetHealthData(response);
                            //DB.fnSet("healthArray", response);
                        })
                };

                vm.fnInit404 = function () {
                    var permObj = PermissionsService.getPermissions("node:health");
                    if (permObj.List) {
                        vm.fnGetHealths();
                    } else {
                        DB.fnRemove('healthArray')
                    }
                    var menuArr = DB.fnGet('menu');
                    angular.forEach(menuArr, function (menuObj) {
                        if (menuObj.isAcess) {
                            var tempObj = {};
                            tempObj.appName = menuObj.name;
                            tempObj.pageOptions = [];
                            angular.forEach(menuObj.sideMenu, function (sideMenuObj) {
                                if (sideMenuObj.isAcess) {
                                    var sideTempObj = {};
                                    sideTempObj.state = sideMenuObj.state;
                                    sideTempObj.name = sideMenuObj.name;
                                    tempObj.pageOptions.push(sideTempObj);
                                }
                            });
                            vm.pageOptions.push(tempObj);
                        }
                    });
                }
            });
})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .run(runBlock);

    /** @ngInject */
    function runBlock($log, $rootScope, $timeout, $window, formlyConfig, $state, DB, Authenticate, beforeUnload) { // eslint-disable-line no-unused-vars
        /*---- Get Company Info ----*/

        $rootScope.$state = $state;
        $rootScope.$log = $log;
        $log.debug('runBlock end');
        var hideClass = 'ng-hide';
        var delay = 10;
        var isRefresh = true;

        /*---- Init local storage db ----*/
        DB.fnInitDB();

        /* eslint-disable */
        if (DB.fnGet('appliedTheme')) {
            var responseTheme = DB.fnGet('appliedTheme');
            less.modifyVars(responseTheme);
        }
        /* eslint-enable */

        // Redirect to login if route requires auth and you're not logged in
        $rootScope.$on('$stateChangeStart', function (event, next, toParams, fromState, fromParams) {// eslint-disable-line
            Authenticate.isLoggedInAsync(function (loggedIn) {
                if (!loggedIn && !Authenticate.checkForLockScreen() && next.name !== 'login' && next.name !== 'account-validation'
                    && next.name !== 'signup' && next.name !== 'render' && next.name !== 'password-validation' && next.name !== 'email-validation' && next.name !== 'user-validation') {
                    event.preventDefault();
                    $state.transitionTo('login');
                } else if (!loggedIn && Authenticate.checkForLockScreen() && next.name !== 'render' && next.name !== 'lock' && next.name !== 'password-validation' && next.name !== 'account-validation' && next.name !== 'email-validation' && next.name !== 'user-validation') {
                    event.preventDefault();
                    $state.transitionTo('lock');
                } else if (!next.authenticate && loggedIn && next.name !== 'render') {
                    if ($state.current.name) {
                        event.preventDefault();
                    }
                    Authenticate.fnDefaultRedirect();
                }
            });
            // Show loader when app reloads
            if (isRefresh) {
                $("#load").removeClass(hideClass); //eslint-disable-line
                $('.main').addClass(hideClass); //eslint-disable-line
            }
        });

        $rootScope.$on('$viewContentLoaded', function () { // eslint-disable-line
            if (isRefresh) {
                var main = $('.main'); //eslint-disable-line
                main.addClass(hideClass);
                // Hide the loader and show the new view after a delay
                // Pass false as the third argument to prevent the digest loop from starting (since you are just modifying CSS there is no reason for Angular to perform dirty checking in this example)
                $timeout(function () {
                    main.removeClass(hideClass);
                    $("#load").addClass(hideClass); //eslint-disable-line
                    isRefresh = false;
                }, delay, false);
            }
        });

        formlyConfig.setType({
            name: 'md-password',
            // template: '<input ng-model="model[options.key]" />',
            template: '<div class="md-input m-b-2">\n' +
                '                    <strong class="md-input-icon" ng-click="to.isHide = to.isHide ? false : true">\n' +
                '                        <i class="fa fa-eye fa-lg m-r-sm"\n' +
                '                           ng-class="to.isHide ? \'fa-eye-slash\' : \'fa-eye\' "></i>\n' +
                '                    </strong>\n' +
                '                    <input class="md-form-control" id="{{to.label}}" type="{{to.isHide ? \'password\' : \'text\' }}" required\n' +
                '                           ng-model="model[options.key]" ng-focus="to.isFocus = !to.isFocus" ng-blur="to.isFocus = false" placeholder="{{to.placeholder ? to.placeholder : to.label}}" />\n' +
                '\n' +
                '                    <span class="highlight"></span>\n' +
                '                    <label>{{to.label}}</label>\n' +
                '                </div>'
        });
    }

})();

(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
        $stateProvider
        /*------- START : Login -------*/
            .state('login', {
                url: "/login",
                templateUrl: "app/login/login.html",
                controller: 'loginCtrl as login',
                data: {pageTitle: 'Login'},
                authenticate: false
            })
            .state('lock', {
                url: "/lock",
                templateUrl: "app/lock/lock.html",
                controller: 'LockCtrl as lock',
                data: {pageTitle: 'Lock'},
                authenticate: false
            })
            .state('account-validation', {
                url: "/account-validation?name&token",
                templateUrl: "app/validation/validation.html",
                controller: 'validationCtrl as validation',
                data: {pageTitle: 'Validation'},
                authenticate: false
            })
            .state('password-validation', {
                url: "/password-validation?name&token",
                templateUrl: "app/validation/resetPassword.html",
                controller: 'validationsPasswordCtrl as validationsPassword',
                data: {pageTitle: 'validationsPassword'},
                authenticate: false
            })
            .state('email-validation', {
                url: "/email-validation?token",
                templateUrl: "app/validation/validateNewEmail.html",
                controller: 'validateNewEmailCtrl as validateNewEmail',
                data: {pageTitle: 'validationsEmail'},
                authenticate: false
            })
            .state('user-validation', {
                url: "/user-validation?name&token",
                templateUrl: "app/validation/validateNewEmail.html",
                controller: 'validateNewEmailCtrl as validateNewEmail',
                data: {pageTitle: 'validationsEmail'},
                authenticate: false
            })
            .state('render', {
                url: "/render?type&value",
                templateUrl: "app/render/render.html",
                controller: 'renderCtrl as render',
                data: {pageTitle: 'Chart Render'},
                authenticate: false
            })
            .state('samlUserLoading', {
                url: "/samlUserData",
                templateUrl: "app/samlUserDataLoad/samlUserDataLoad.html",
                controller: 'SAMLUserDataLoad as samlUser',
                data: {pageTitle: 'Loading'},
                authenticate: true
            })
            .state('loading', {
                url: "/loading",
                templateUrl: "app/loadingScreen/loadingScreen.html",
                controller: 'LoadingScreenCtrl as loadingScreen',
                data: {pageTitle: 'Loading'},
                authenticate: true
            })
            .state('main', {
                url: '/?federationId',
                templateUrl: 'app/main/main.html',
                controller: 'MainController',
                controllerAs: 'main',
                abstract: true,
                authenticate: true
            })
            .state('main.dashboard', {
                url: "dashboard",
                templateUrl: "app/dashboard/dashboard.html",
                controller: 'DashboardCtrl as dashboard',
                data: {pageTitle: 'Dashboard'},
                authenticate: true,
                menu: 'dashboard'
            })
            .state('main.documentations', {
                url: "documentation?selectedId",
                templateUrl: "app/documentation/documentation/documentation.html",
                controller: 'DocumentationCtrl as documentation',
                data: {pageTitle: 'Documentation'},
                menu: 'documentation',
                authenticate: true
            })
            .state('main.nopage', {
                url: "404",
                templateUrl: "app/404/404.html",
                controller: '404Ctrl as notFound',
                data: {pageTitle: 'The page you\'re looking for could not be found (404)'},
                authenticate: false
            })
            .state('main.no_privileges', {
                url: "noprivileges",
                templateUrl: "app/noPrivileges/noPrivileges.html",
                controller: 'noPrivilegesCtrl as notFound',
                data: {pageTitle: 'You don\'t appear to have been assigned any permissions. Please contact your administrator'},
                authenticate: true,
                menu: 'noprivileges'
            })
            .state('main.workbench', {
                url: "tools/iot3/workbench",
                templateUrl: "app/node/iot3/iot3Workbench/iot3Workbench.html",
                controller: 'iot3WorkbenchCtrl as workbench',
                data: {pageTitle: 'IoT3 | Workbench'},
                menu: 'iot3Tools',
                authenticate: true
            })
            .state('main.iot3', {
                url: "tools/iot3/iot3?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/iot3/iot3Service/iot3Service.html",
                controller: 'iot3Ctrl as iot3',
                data: {pageTitle: 'IoT3 | IoT3 Library'},
                menu: 'iot3Tools',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyIot3Tools();
                    }
                }
            })
            .state('main.access_dashboard', {

                url: "access/dashboard",
                templateUrl: "app/access/dashboard/dashboard.html",
                controller: 'AccessDashboardCtrl as accessDashboard',
                data: {pageTitle: 'Access | Dashboard'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR', 'USER'], 'access:user');
                    }
                }
            })
            .state('main.users', {
                url: "access/users?filter&sort&page&perPage&selectedId&selectedDetailsTab&openEditView",
                templateUrl: "app/access/users/users.html",
                controller: 'UsersCtrl as users',
                data: {pageTitle: 'Access | Users'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR', 'USER'], 'access:user');
                    }
                }
            })
            .state('main.predictive_dashboard', {
                url: "predictive/dashboard",
                templateUrl: "app/predictive/dashboard/predictive_dashboard.html",
                controller: 'PredictiveDashboardCtrl as predictiveDashboard',
                data: {pageTitle: 'ECSMon | Dashboard'},
                menu: 'ecsmon',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR'], 'access:account');
                    }
                }
            })
            .state('main.accounts', {
                url: "predictive/accounts?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/predictive/account/accounts.html",
                controller: 'AccountsCtrl as accounts',
                data: {pageTitle: 'ECSMon | Accounts'},
                menu: 'ecsmon',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR'], 'access:account');
                    }
                }
            })
            .state('main.teams', {
                url: "access/teams?filter&sort&page&perPage&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/access/team/teams.html",
                controller: 'TeamsCtrl as teams',
                data: {pageTitle: 'Access | Teams'},
                authenticate: true,
                menu: 'access',
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR', 'USER'], 'access:teams');
                    }
                }
            })
            /*.state('main.securityRoles', {
                url: "access/securityRoles?filter&sort&page&perPage&selectedId&selectedDetailsTab&openCreateView&openEditView",
                templateUrl: "app/access/securityRole/securityRole.html",
                controller: 'securityRolesCtrl as securityRoles',
                data: {pageTitle: 'Access | Security Roles'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:securityRole');
                    }
                }
            })
            .state('main.securityGroups', {
                url: "access/securityGroups?filter&sort&page&perPage&selectedId&selectedDetailsTab&openCreateView&openEditView",
                templateUrl: "app/access/securityGroup/securityGroup.html",
                controller: 'securityGroupsCtrl as securityGroups',
                data: {pageTitle: 'Access | Security Groups'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:securityGroups');
                    }
                }
            })*/
            /*.state('main.logs', {
                url: "access/logs?filter&page&perPage",
                templateUrl: "app/access/log/log.html",
                controller: 'LogsCtrl as logs',
                data: {pageTitle: 'Access | Logs'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:log');
                    }
                }
            })*/
            .state('main.vaults', {
                url: "access/vaults?filter&sort&page&perPage&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/access/vault/vaults.html",
                controller: 'VaultsCtrl as vaults',
                data: {pageTitle: 'Access | Vaults'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:vault');
                    }
                }
            })
            .state('main.authenticators', {
                url: "access/authenticators?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/access/authenticator/authenticators.html",
                controller: 'AuthenticatorsCtrl as authenticators',
                data: {pageTitle: 'Access | Authenticators'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:authenticator');
                    }
                }
            })
            .state('main.emails', {
                url: "access/emails?filter&sort&page&perPage",
                templateUrl: "app/access/email/email.html",
                controller: 'EmailCtrl as email',
                data: {pageTitle: 'Access | Emails'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:email');
                    }
                }
            })
            .state('main.emailTemplate', {
                url: "access/emailTemplate?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/access/emailTemplate/emailTemplate.html",
                controller: 'EmailTemplateCtrl as emailTemplate',
                data: {pageTitle: 'Access | Email Template'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:email');
                    }
                }
            })
            .state('main.federations', {
                url: "access/federations?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/access/federation/federations.html",
                controller: 'FederationsCtrl as federations',
                data: {pageTitle: 'Access | Federations'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:federation');
                    }
                }
            })
            .state('main.audits', {
                url: "access/audits?filter&sort&page&perPage",
                templateUrl: "app/access/audits/audits.html",
                controller: 'AuditsCtrl as audits',
                data: {pageTitle: 'Access | Audits'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:audits');
                    }
                }
            })
            .state('main.scripts', {
                url: "access/s4?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/access/script/scripts.html",
                controller: 'ScriptsCtrl as scripts',
                data: {pageTitle: 'Access | S4'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:scripts');
                    }
                }
            })
            .state('main.contacts', {
                url: "access/contacts?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/access/contact/contact.html",
                controller: 'ContactsCtrl as contacts',
                data: {pageTitle: 'Access | Contacts'},
                menu: 'access',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'access:contact');
                    }
                }
            })
            .state('main.nodecomingsoon', {
                url: "node/comingsoon",
                templateUrl: "app/coming-soon/coming-soon.html",
                controller: 'comingSoonCtrl as comingSoon',
                data: {pageTitle: 'Node | Coming Soon'},
                menu: 'node',
                authenticate: true
            })
            /*.state('main.pipelinecomingsoon', {
                url: "automator/comingsoon", //ToDo by MV: temporarily disabled
                templateUrl: "app/coming-soon/coming-soon.html",
                controller: 'comingSoonCtrl as comingSoon',
                data: {pageTitle: 'Automator | Coming Soon'},
                menu: 'pipeline',
                authenticate: true
            })*/
            .state('main.storagecomingsoon', {
                url: "storage/comingsoon",
                templateUrl: "app/coming-soon/coming-soon.html",
                controller: 'comingSoonCtrl as comingSoon',
                data: {pageTitle: 'Storage | Coming Soon'},
                menu: 'storage',
                authenticate: true
            })
            /*.state('main.aicomingsoon', { //ToDo by MV: temporarily disabled
                url: "ai/comingsoon",
                templateUrl: "app/coming-soon/coming-soon.html",
                controller: 'comingSoonCtrl as comingSoon',
                data: {pageTitle: 'AI | Coming Soon'},
                menu: 'ai',
                authenticate: true
            })*/
            .state('main.insightcomingsoon', {
                url: "insight/comingsoon",
                templateUrl: "app/coming-soon/coming-soon.html",
                controller: 'comingSoonCtrl as comingSoon',
                data: {pageTitle: 'Insight | Coming Soon'},
                menu: 'insight',
                authenticate: true
            })
            .state('main.node_dashboard', {
                url: "node/dashboard",
                templateUrl: "app/node/dashboard/dashboard.html",
                controller: 'NodeDashboardCtrl as nodeDashboard',
                data: {pageTitle: 'Node | Dashboard'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:dashboard');
                    }
                }
            })
            .state('main.node', {
                url: "node/node?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/node/node.html",
                controller: 'NodesCtrl as node',
                data: {pageTitle: 'Node | Node'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:device');
                    }
                }
            })
            .state('main.alarms', {
                url: "node/alarm?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/alarms/alarms.html",
                controller: 'AlarmsCtrl as alarm',
                data: {pageTitle: 'Node | Alarm'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:alarm');
                    }
                }
            })
            .state('main.alarmHistory', {
                url: "node/alarmHistory?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/alarmHistory/alarmHistory.html",
                controller: 'AlarmHistoryCtrl as alarmHistory',
                data: {pageTitle: 'Node | Alarm History'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:alarm');
                    }
                }
            })
            .state('main.job', {
                url: "node/job?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/job/jobs.html",
                controller: 'JobsCtrl as jobs',
                data: {pageTitle: 'Node | Job'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:job');
                    }
                }
            })
            .state('main.health', {
                url: "node/health?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/health/health.html",
                controller: 'HealthCtrl as health',
                data: {pageTitle: 'Node | Health'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:health');
                    }
                }
            })
            .state('main.notification', {
                url: "node/notification?filter&page&perPage&selectedId&selectedDetailsTab&openEditView",
                templateUrl: "app/node/notification/notification.html",
                controller: 'NotificationCtrl as notification',
                data: {pageTitle: 'Node | Notification'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:notification');
                    }
                }
            })
            .state('main.ecu', {
                url: "node/ecu?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/node/ecu/ecu.html",
                controller: 'EcusCtrl as ecu',
                data: {pageTitle: 'Node | ECU'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:ecu');
                    }
                }
            })
            .state('main.fleet', {
                url: "node/fleet?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/node/fleet/fleet.html",
                controller: 'FleetCtrl as fleet',
                data: {pageTitle: 'Node | Fleet'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:fleet');
                    }
                }
            })
            .state('main.software', {
                url: "node/software?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/node/software/software.html",
                controller: 'SoftwareCtrl as software',
                data: {pageTitle: 'Node | Software'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:software');
                    }
                }
            })
            .state('main.node_project', {
                url: "node/project?filter&sort&page&perPage&state&selectedId&selectedDetailsTab",
                templateUrl: "app/node/project/project.html",
                controller: 'NodeProjectCtrl as project',
                data: {pageTitle: 'Node | Project'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:project');
                    }
                }
            })
            .state('main.node_project_scripts', {
                url: "node/project/:name/s4?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/node/project_script/node_project_scripts.html",
                controller: 'NodeProjectScriptsCtrl as nodeProjectScripts',
                data: {pageTitle: 'Node | Project Script'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:project');
                    }
                }
            })
            .state('main.node_project_emailTemplate', {
                url: "node/project/:name/emailTemplate?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/node/project_emailTemplate/node_project_emailTemplate.html",
                controller: 'NodeProjectEmailTemplateCtrl as nodeProjectEmailTemplate',
                data: {pageTitle: 'Node | Project Email Template'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:project');
                    }
                }
            })
            .state('main.node_emailTemplate', {
                url: "node/emailTemplate?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/emailTemplate/emailTemplate.html",
                controller: 'NodeEmailTemplateCtrl as emailTemplate',
                data: {pageTitle: 'Node | Email Template'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:email');
                    }
                }
            })
            .state('main.node_scripts', {
                url: "node/s4?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/script/scripts.html",
                controller: 'NodeScriptsCtrl as nodeScripts',
                data: {pageTitle: 'Node | S4'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:scripts');
                    }
                }
            })
            .state('main.node_es4', {
                url: "node/es4?filter&sort&page&perPage&selectedId&selectedDetailsTab&selectedEcu",
                templateUrl: "app/node/es4/es4.html",
                controller: 'Es4Ctrl as es4',
                data: {pageTitle: 'Node | ES4'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:es4');
                    }
                }
            })


            /*.state('main.visualizer', {
                url: "node/visualizer?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/visualization/visualization.html",
                controller: 'VisualizerCtrl as visualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            .state('main.cluster', {
                url: "node/cluster?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/cluster/cluster.html",
                controller: 'ClusterCtrl as clusters',
                data: {pageTitle: 'Node | Cluster'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:cluster');
                    }
                }
            })
            /*.state('main.createVisualizer', {
                url: "node/visualizer/createVisualizer",
                templateUrl: "app/node/visualization/createVisualization/createVisualization.html",
                controller: 'CreateVisualizerCtrl as createVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            /*.state('main.viewVisualizer', {
                url: "node/visualizer/view/:id",
                templateUrl: "app/node/visualization/createVisualization/createVisualization.html",
                controller: 'CreateVisualizerCtrl as createVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            /*.state('main.editVisualizer', {
                url: "node/visualizer/edit/:id",
                templateUrl: "app/node/visualization/createVisualization/createVisualization.html",
                controller: 'CreateVisualizerCtrl as createVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            /*.state('main.createDeviceGatewayVisualizer', {
                url: "node/visualizer/createDeviceGatewayVisualizer?type?filter?perPage?next?previous",
                templateUrl: "app/node/visualization/createDeviceGatewayVisualization/createDeviceGatewayVisualization.html",
                controller: 'CreateDeviceGatewayVisualizationCtrl as createDeviceGatewayVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            /*.state('main.viewDeviceGatewayVisualizer', {
                url: "node/DeviceGatewayVisualizer/view/:id?type?filter?perPage?next?previous",
                templateUrl: "app/node/visualization/createDeviceGatewayVisualization/createDeviceGatewayVisualization.html",
                controller: 'CreateDeviceGatewayVisualizationCtrl as createDeviceGatewayVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            /*.state('main.editDeviceGatewayVisualizer', {
                url: "node/DeviceGatewayVisualizer/edit/:id?type?filter?perPage?next?previous",
                templateUrl: "app/node/visualization/createDeviceGatewayVisualization/createDeviceGatewayVisualization.html",
                controller: 'CreateDeviceGatewayVisualizationCtrl as createDeviceGatewayVisualizer',
                data: {pageTitle: 'Node | Visualization'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:visualizer');
                    }
                }
            })*/
            .state('main.node_observer', {
                url: "node/observer?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/observer/observer.html",
                controller: 'ObserverCtrl as observer',
                data: {pageTitle: 'Node | Observer'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:observer');
                    }
                }
            })
            .state('main.lifecycle', {
                url: "node/lifecycle?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/node/lifecycle/lifecycle.html",
                controller: 'LifecycleCtrl as lifecycle',
                data: {pageTitle: 'Node | Lifecycle'},
                menu: 'node',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'node:lifecycle');
                    }
                }
            })
            /*.state('main.listeners', { //ToDo by MV: temporarily disabled
                url: "pipeline/listeners?filter&page&perPage&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/pipeline/listeners/listeners.html",
                controller: 'ListenersCtrl as listeners',
                data: {pageTitle: 'Pipeline | Listeners'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:listener');
                    }
                }
            })*/
            /*.state('main.workflows', { //ToDo by MV: temporarily disabled
                url: "pipeline/workflows?filter&page&perPage&selectedId&selectedDetailsTab&isCalledAfterCreate",
                templateUrl: "app/pipeline/workflows/workflows.html",
                controller: 'WorkflowsCtrl as workflows',
                data: {pageTitle: 'Pipeline | Workflows'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:workflow');
                    }
                }
            })*/
            /*.state('main.workFlowsView', { //ToDo by MV: temporarily disabled
                url: "pipeline/workflows/view/:id",
                templateUrl: "app/pipeline/workflows/workflowInfo/workflowTabs/worflowFlowView/workflowFlowView.html",
                controller: 'WorkflowFlowViewCtrl as flowView',
                data: {pageTitle: 'Pipeline | Workflows'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:workflow');
                    }
                }
            })*/
            /*.state('main.createWorkFlow', { //ToDo by MV: temporarily disabled
                url: "pipeline/workflows/createWorkFlow?bluePrintId&draftName",
                templateUrl: "app/pipeline/workflows/createWorkFlow/createWorkFlow.html",
                controller: 'createWorkFlowCtrl as createWorkFlow',
                data: {pageTitle: 'Pipeline | Create Workflow'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:workflow');
                    }
                }
            })*/
            /*.state('main.pipeline_templates', { //ToDo by MV: temporarily disabled
                url: "pipeline/templates?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/pipeline/templates/templates.html",
                controller: 'PipelineTemplatesCtrl as templates',
                data: {pageTitle: 'Pipeline | Templates'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:template');
                    }
                }
            })*/
            /*.state('main.transformers', { //ToDo by MV: temporarily disabled
                url: "pipeline/transformers?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/pipeline/transformers/transformers.html",
                controller: 'TransformersCtrl as transformers',
                data: {pageTitle: 'Pipeline | Transformers'},
                menu: 'pipeline',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'pipeline:transformer');
                    }
                }
            })*/
            .state('main.insight_query_editor', {
                url: "insight/query_editor",
                templateUrl: "app/insight/insight_query_editor/insight_query_editor.html",
                controller: 'InsightQueryEditorCtrl as insightQueryEditor',
                data: {pageTitle: 'Insight | Query Editor'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:dashboard');
                    }
                }
            })
            .state('main.insight_dashboards', {
                url: "insight/dashboards?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/insight/insight_dashboards/insight_dashboards.html",
                controller: 'InsightDashboardsCtrl as insightDashboards',
                data: {pageTitle: 'Insight | Dashboards'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:dashboards');
                    }
                }
            })
            .state('main.insight_project', {
                url: "insight/project?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/insight/insight_project/insight_project.html",
                controller: 'InsightProjectCtrl as insightProject',
                data: {pageTitle: 'Insight | Project'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:project');
                    }
                }
            })
            .state('main.insight_charts', {
                url: "insight/charts?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/insight/insight_charts/insight_charts.html",
                controller: 'InsightChartsCtrl as insightCharts',
                data: {pageTitle: 'Insight | Charts'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:charts');
                    }
                }
            })
            .state('main.insight_queries', {
                url: "insight/queries?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/insight/insight_queries/insight_queries.html",
                controller: 'InsightQueriesCtrl as insightQueries',
                data: {pageTitle: 'Insight | Queries'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:queries');
                    }
                }
            })
            .state('main.insight_widgets', {
                url: "insight/widgets?filter&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/insight/insight_widgets/insight_widgets.html",
                controller: 'InsightWidgetsCtrl as insightWidgets',
                data: {pageTitle: 'Insight | Widgets'},
                menu: 'insight',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'insight:widgets');
                    }
                }
            })
            .state('main.tracker_dashboard', {
                url: "tracker/dashboard",
                templateUrl: "app/tracker/dashboard/dashboard.html",
                controller: 'TrackerDashboardCtrl as trackerDashboard',
                data: {pageTitle: 'Tracker | Issue'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:issue');
                    }
                }
            })
            .state('main.issue', {
                url: "tracker/issue?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/tracker/issue/issue.html",
                controller: 'IssueCtrl as issue',
                data: {pageTitle: 'Tracker | Issue'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:issue');
                    }
                }
            })
            .state('main.archives', {
                url: "tracker/archives?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/tracker/archived/archived.html",
                controller: 'ArchivedIssueCtrl as archivedIssue',
                data: {pageTitle: 'Tracker | Archives'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:archives');
                    }
                }
            })
            .state('main.label', {
                url: "tracker/label?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/tracker/label/label.html",
                controller: 'LabelCtrl as label',
                data: {pageTitle: 'Tracker | Label'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:label');
                    }
                }
            })
            .state('main.project', {
                url: "tracker/project?filter&sort&page&perPage&state&selectedId&selectedDetailsTab",
                templateUrl: "app/tracker/project/project.html",
                controller: 'ProjectCtrl as project',
                data: {pageTitle: 'Tracker | Project'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:project');
                    }
                }
            })
            .state('main.project_scripts', {
                url: "tracker/project/:name/s4?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/tracker/project_script/project_scripts.html",
                controller: 'ProjectScriptsCtrl as projectScripts',
                data: {pageTitle: 'Tracker | Project Script'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:project');
                    }
                }
            })
            .state('main.project_emailTemplate', {
                url: "tracker/project/:name/emailTemplate?filter&sort&page&perPage&state&selectedId&selectedDetailsTab&selectedProject",
                templateUrl: "app/tracker/project_emailTemplate/project_emailTemplate.html",
                controller: 'ProjectEmailTemplateCtrl as projectEmailTemplate',
                data: {pageTitle: 'Tracker | Project Email Template'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:project');
                    }
                }
            })
            .state('main.tracker_scripts', {
                url: "tracker/s4?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/tracker/script/scripts.html",
                controller: 'TrackerScriptsCtrl as trackerScripts',
                data: {pageTitle: 'Tracker | S4'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:scripts');
                    }
                }
            })
            .state('main.priorities', {
                url: "tracker/priorities?filter&sort&page&perPage&selectedId&selectedDetailsTab&openEditView",
                templateUrl: "app/tracker/priorities/priorities.html",
                controller: 'PrioritiesCtrl as priorities',
                data: {pageTitle: 'Tracker | Priorities'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['ADMINISTRATOR', 'USER'], 'tracker:priority');
                    }
                }
            })
            .state('main.state', {
                url: "tracker/state?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/tracker/state/state.html",
                controller: 'StateCtrl as state',
                data: {pageTitle: 'Tracker | State'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:state');
                    }
                }
            })
            .state('main.types', {
                url: "tracker/types?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/tracker/types/types.html",
                controller: 'TypesCtrl as types',
                data: {pageTitle: 'Tracker | Types'},
                menu: 'tracker',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'tracker:types');
                    }
                }
            })
            .state('main.folder', {
                url: "storage/folder?page&perPage&path&selectedFile&filter&selectedFolder&selectedDetailsTab",
                templateUrl: "app/storage/folder/folder.html",
                controller: 'FolderCtrl as folder',
                data: {pageTitle: 'Storage | Folder'},
                menu: 'storage',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'storage:folder');
                    }
                }
            })
            /*.state('main.trainer', { //ToDo by MV: temporarily disabled
                url: "ai/trainer?page&perPage&path&filter&selectedId&selectedDetailsTab",
                templateUrl: "app/ai/trainer/trainer.html",
                controller: 'TrainerCtrl as trainer',
                data: {pageTitle: 'AI | Trainer'},
                menu: 'ai',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'ai:trainer');
                    }
                }
            })
            .state('main.model', {
                url: "ai/model?page&perPage&path&filter&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/ai/model/model.html",
                controller: 'ModelCtrl as model',
                data: {pageTitle: 'AI | Model'},
                menu: 'ai',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'ai:model');
                    }
                }
            })
            .state('main.distribution', {
                url: "ai/distribution?page&perPage&path&filter&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/ai/distribution/distribution.html",
                controller: 'DistributionCtrl as distribution',
                data: {pageTitle: 'AI | Distribution'},
                menu: 'ai',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'ai:distribution');
                    }
                }
            })
            .state('main.deployment', {
                url: "ai/deployment?page&perPage&path&filter&selectedId&selectedDetailsTab&openCreateView",
                templateUrl: "app/ai/deployment/deployment.html",
                controller: 'DeploymentCtrl as deployment',
                data: {pageTitle: 'AI | Deployment'},
                menu: 'ai',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'ai:deployment');
                    }
                }
            })*/
            .state('main.cart', {
                url: "store/cart",
                templateUrl: "app/store/cart/cart.html",
                controller: 'CartCtrl as cart',
                data: {pageTitle: 'Store | Cart'},
                menu: 'store',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'store:cart');
                    }
                }
            })
            .state('main.invoice', {
                url: "billing/invoice?filter&sort&page&perPage&selectedId&selectedDetailsTab&openEditView",
                templateUrl: "app/billing/invoice/invoice.html",
                controller: 'InvoiceCtrl as invoice',
                data: {pageTitle: 'Billing | Invoice'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:invoices');
                    }
                }
            })
            .state('main.discount', {
                url: "billing/discount?page&perPage&filter&selectedId&selectedDetailsTab",
                templateUrl: "app/billing/discount/discount.html",
                controller: 'DiscountCtrl as discount',
                data: {pageTitle: 'Billing | Discount'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:discount');
                    }
                }
            })
            .state('main.products', {
                url: "store/product?filter&sort&page&perPage&selectedId",
                templateUrl: "app/store/product/product.html",
                controller: 'ProductCtrl as products',
                data: {pageTitle: 'Store | Product'},
                menu: 'store',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'store:product');
                    }
                }
            })
            .state('main.payment_method', {
                url: "billing/payment_method?page&perPage&filter&selectedId&selectedDetailsTab",
                templateUrl: "app/billing/payment_method/paymentMethod.html",
                controller: 'PaymentMethodCtrl as paymentMethod',
                data: {pageTitle: 'Billing | Payment Method'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:profile');
                    }
                }
            })
            .state('main.credit_token', {
                url: "billing/credit_token?page&perPage&filter&selectedId&selectedDetailsTab&type&tokenId",
                templateUrl: "app/billing/credit_token/credit_tokens.html",
                controller: 'CreditTokensCtrl as creditTokens',
                data: {pageTitle: 'Billing | Credit Token'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:credit_token');
                    }
                }
            })
            .state('main.plan', {
                url: "billing/plan",
                templateUrl: "app/billing/plan/plan.html",
                controller: 'PlanCtrl as plan',
                data: {pageTitle: 'Billing | Plan'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:plan');
                    }
                }
            })
            .state('main.billing_scripts', {
                url: "billing/s4?filter&sort&page&perPage&selectedId&selectedDetailsTab",
                templateUrl: "app/billing/script/scripts.html",
                controller: 'BillingScriptsCtrl as scripts',
                data: {pageTitle: 'Billing | S4'},
                menu: 'billing',
                authenticate: true,
                resolve: {
                    Authenticate: function (Authenticate) {
                        return Authenticate.fnVerifyUserRole(['USER'], 'billing:scripts');
                    }
                }
            })
            .state('main.user_profiles', {
                url: "settings/user_profiles",
                templateUrl: "app/user-settings/profile/userProfile.html",
                controller: 'UserProfileCtrl as userProfile',
                data: {pageTitle: 'Settings | User Profile'},
                menu: 'profile',
                authenticate: true
            })
            .state('main.user_account', {
                url: "profile/user_account",
                templateUrl: "app/user-settings/account/account.html",
                controller: 'UserAccountCtrl as userAccount',
                data: {pageTitle: 'Profile | User Account'},
                menu: 'profile',
                authenticate: true
            })
            .state('main.access_token', {
                url: "profile/access_token?filter&sort&page&perPage",
                templateUrl: "app/user-settings/access-tokens/access-token.html",
                controller: 'AccessTokenCtrl as accessToken',
                data: {pageTitle: 'Profile | Access Token'},
                menu: 'profile',
                authenticate: true
            })
            .state('main.preferences', {
                url: "settings/preferences",
                templateUrl: "app/user-settings/preferences/preferences.html",
                controller: 'PreferencesCtrl as preferences',
                data: {pageTitle: 'Profile | Preferences'},
                menu: 'profile',
                authenticate: true
            })
            .state('main.recipes', {
                url: "profile/recipes",
                templateUrl: "app/user-settings/recipes/recipes.html",
                controller: 'RecipesCtrl as recipes',
                data: {pageTitle: 'Profile | Recipes'},
                menu: 'profile',
                authenticate: true
            })
            .state('main.business', {
                url: "billing/business",
                templateUrl: "app/billing/business/business.html",
                controller: 'BusinessCtrl as business',
                data: {pageTitle: 'Billing | Business'},
                menu: 'billing',
                authenticate: true
            })
            .state('main.support', {
                url: "settings/support",
                templateUrl: "app/user-settings/support/support.html",
                controller: 'PredictiveSupportCtrl as predictiveSupport',
                data: {pageTitle: 'Settings | Support'},
                menu: 'profile',
                authenticate: true
            });
        $urlRouterProvider.otherwise(function () {
            return '/dashboard'
        });
    }

})();

/* global moment:false swal:false draw2d:false d3:false L:false jsSHA:false kendo:false Paho:false panzoom:false Highcharts:false XLSX:false mermaid:false pako:false Stripe:false highed:false CodeMirror:false vegaEmbed:false jsyaml:false sqlFormatter:false leafletImage:false*/
(function () {
    'use strict';

    angular
        .module('phoenixNewUi')
        .constant('moment', moment)
        .constant('swal', swal)
        .constant('microSpinner', '<div class="microSpinner">' +
            '                        <div class="spinnerContainer">' +
            '                            <div class="circular-container">' +
            '                                <div class="circle circular-loader1">' +
            '                                    <div class="circle circular-loader2">' +
            '                                    </div>' +
            '                                </div>' +
            '                            </div>' +
            '                        </div>' +
            '                    </div>'
        )
        .constant('localStorage', localStorage)
        .constant('draw2d', draw2d)
        .constant('d3', d3)
        .constant('L', L)
        .constant('jsSHA', jsSHA)
        .constant('Paho', Paho)
        .constant('kendo', kendo)
        .constant('panzoom', panzoom)
        .constant('vegaEmbed', vegaEmbed)
        .constant('jsyaml', jsyaml)
        .constant('dbName', '99jamttuwp8urhy28d7vi') //Math.random().toString(36).substring(7);
        .constant('postActionModelIcon', '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
            ' viewBox="0 0 426.667 426.667" style="enable-background:new 0 0 426.667 426.667;" xml:space="preserve">\n' +
            ' <path style="fill:#6AC259;" d="M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333\n' +
            '  c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622\n' +
            '  l140.894-140.898l31.309,31.309L174.199,322.918z"/>\n' +
            '  </svg>')
        .constant('postActionModelMessage', '<div><h3 style="text-align:center !important;" >All taken care of...</h3></div>')
        .constant('typeArrDb', '9v0q0j5osfe')
        .constant('statesArrDb', 'nxuht1lsfji')
        .constant('modelsObjDb', 'pd18vgiiho6i')
        .constant('Highcharts', Highcharts)
        .constant('pako', pako)
        .constant('highed', highed)
        .constant('Stripe', Stripe)
        .constant('CodeMirror', CodeMirror)
        .constant('XLSX', XLSX)
        .constant('mermaid', mermaid)
        .constant('sqlFormatter', sqlFormatter)
        .constant('leafletImage', leafletImage)
        .constant('projectArr', 'ajhthxziwo')
        .constant('issueStateArr', 'mm9n4vfabs9')
        .constant('issuePriorityArr', 'eurowmas7tv')
        .constant('issueTypeArr', 'dqnw4dyynkq')
        .constant('nodeProjectArr', 'm64bhlrowev')
        .constant('nodeProjectHealthArr', 'sfolgsjwve')
        .constant('insightProjectArr', 'ipcgdsaseh');
})();

(function() {
  'use strict';

  angular
    .module('phoenixNewUi')
    .config(config);

  /** @ngInject */
  function config($logProvider, $httpProvider) {
      // Enable log
      $logProvider.debugEnabled(true);

      /*--------- Global Config ----------*/
      $httpProvider.defaults.withCredentials = false;
      //$httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';

      // Pull in `Request/Response Service` from the dependency injector
      $httpProvider.interceptors.push('InterceptorsService');

      //Live favicon Tinycon Global Config
     /* anTinyconProvider.setOptions({
          width: 7,
          height: 9,
          font: "10px arial",
          colour: "#ffffff",
          background: "red",
          fallback: true,
          abbreviate: true
      });*/

      // ladda btn (loader btn)
     /* laddaProvider.setOption({
          style: 'zoom-in'
      });
*/
      // Configure all charts
    /*  ChartJsProvider.setOptions({
          colours: [
              '#f1f1f1', // Light grey
              '#46bfbd' // Light green
          ],
          responsive: true
      });*/
  }

})();

(function () {
    'use strict';

    //Directive used to set metisMenu and minimalize button
    angular.module('phoenixNewUi')
        .directive('sideNavigation', function ($timeout) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    $timeout(function () {
                        element.metisMenu();
                    }, 2000);
                }
            };
        })
        .directive('minimalizaSidebar', function ($timeout) {
            return {
                restrict: 'A',
                template: '<a class="navbar-minimalize minimalize-styl-2 visible-xs" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
                controller: function ($scope) {
                    $scope.minimalize = function () {
                        angular.element('body').toggleClass('mini-navbar');
                        if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                            // Hide menu in order to smoothly turn on when maximize menu
                            angular.element('#side-menu').hide();
                            angular.element('#incidents-count').removeClass('nav-count');
                            // For smoothly turn on menu
                            $timeout(function () {
                                angular.element('#side-menu').fadeIn(400);
                            }, 200);
                        } else {
                            // Remove all inline style from jquery fadeIn function to reset menu state
                            angular.element('#side-menu').removeAttr('style');
                            angular.element('#incidents-count').addClass('nav-count');
                        }
                    };
                }
            };
        })
        .directive('minimalizaLogoSidebar', function ($timeout, $rootScope, DB) {
            return {
                restrict: 'A',
                link: function ($scope, elem) {

                    $scope.minimalize = function () {
                        angular.element('body').toggleClass('mini-navbar');
                        if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                            /* angular.element('.navbar-default').css(
                                 {
                                     'overflow-y': 'auto',
                                     'position': 'fixed',
                                     'height': '92.5%'
                                 }
                             );*/

                            // Hide menu in order to smoothly turn on when maximize menu
                            angular.element('#side-menu').hide();
                            angular.element('#incidents-count').removeClass('nav-count');
                            // For smoothly turn on menu
                            $timeout(function () {
                                angular.element('#side-menu').fadeIn(400);
                                /*angular.element(".sidebar-collapse").slimscroll({
                                    height: '100%',
                                    railOpacity: 0.9
                                });*/
                            }, 200);
                            DB.fnSet('menuExpanded', true);
                            $rootScope.$broadcast('menuExpanded');
                        } else {
                            // Remove all inline style from jquery fadeIn function to reset menu state
                            angular.element('#side-menu').removeAttr('style');
                            angular.element('.navbar-default').removeAttr('style');
                            angular.element('#incidents-count').addClass('nav-count');
                            $timeout(function () {
                                //angular.element(".sidebar-collapse").slimScroll({destroy: true});
                                angular.element(".sidebar-collapse").removeAttr('style');
                            }, 200);
                            DB.fnSet('menuExpanded', false);
                            $rootScope.$broadcast('menuCollapse');
                        }
                    };

                    elem.bind('click', function () {
                        $scope.minimalize();
                    });

                    if (DB.fnGet('menuExpanded')) {
                        $timeout(function () {
                            angular.element('body').addClass('mini-navbar');
                            $scope.minimalize();
                        }, 0);
                    }
                }
            };
        })
        .directive('pageTitle', function ($rootScope, $timeout, $state, $cookies, $location, DB) {
            return {
                link: function (scope, element) {
                    var listener = function (event, toState, toParams, fromState) {
                        // Default title - load on Dashboard 1
                        var title = 'Login';
                        // Create your own title pattern
                        if (!$cookies.get('phoenix')) {
                            if (DB.fnGet('phoenixUserName')) {
                                if (fromState.data && fromState.data.pageTitle) {
                                    title = 'Lock';
                                }
                            } else {
                                if (toState.name === 'validation') {
                                    title = 'Validation';
                                } else if (fromState.data && fromState.data.pageTitle) {
                                    title = 'Login';
                                }
                                if (toState.name === 'validations') {
                                    title = 'Reset Password';
                                } else if (fromState.data && fromState.data.pageTitle) {
                                    title = 'Login';
                                }
                            }
                        } else {
                            if (toState.data && toState.data.pageTitle) {
                                title = toState.data.pageTitle;
                            }
                        }

                        $timeout(function () {
                            element.text(title);
                        });
                    };
                    var $stateChangeStart = $rootScope.$on('$stateChangeSuccess', listener);
                    $rootScope.$on('$destroy', $stateChangeStart);
                }
            };
        })
        .directive('breadcrumb', function ($location, $state, $window, $uibModal, DB, $timeout, breadcrumbObjService) {
            return {
                restrict: 'A',
                scope: {},
                link: function (scope) {
                    scope.fnGetBreadcrumbTitle = function (state) {
                        var tempState = angular.copy(state);
                        if (tempState && tempState.name && tempState.name.includes(':')) {
                            var key = tempState.name.split(":")[1];
                            var breadcrumbObj = breadcrumbObjService.fnGetBreadcrumbObj();
                            if (breadcrumbObj) {
                                state.title = breadcrumbObj[key];
                                breadcrumbObjService.fnRemoveBreadcrumbObj();
                            } else {
                                $timeout(function () {
                                    scope.fnGetBreadcrumbTitle(state)
                                }, 1000)
                            }
                        } else {
                            state.title = tempState.name;
                        }
                    };
                    scope.fnInitBreadcrumb = function () {
                        scope.currentYear = new Date().getFullYear();
                        scope.lastYear = scope.currentYear - 1;
                        scope.phoenixVersion = DB.fnGet('xPhoenixVersion');
                        scope.stateUrl = $state.current.url;
                        scope.StateArray = scope.stateUrl.split('/');
                        scope.breadCrumbArray = [];
                        angular.forEach(scope.StateArray, function (stateObj) {
                            var breadcrumbName = stateObj.replace("_", " ");
                            if (breadcrumbName) {
                                var capitalizeBreadCrumbName = breadcrumbName.toLowerCase().split(' ').map(function (word) {
                                    return word.replace(word[0], word[0].toUpperCase());
                                }).join(' ');
                                if (capitalizeBreadCrumbName === 'Devicegatewayvisualizer') {
                                    capitalizeBreadCrumbName = 'Visualizer';
                                }
                                if (capitalizeBreadCrumbName === 'Ai') {
                                    capitalizeBreadCrumbName = 'AI';
                                }
                                if (_.includes(capitalizeBreadCrumbName, "?")) {
                                    var tempName = capitalizeBreadCrumbName.split("?");
                                    capitalizeBreadCrumbName = tempName[0];
                                    if (capitalizeBreadCrumbName.includes("Create")) {
                                        capitalizeBreadCrumbName = "Create";
                                    }
                                }
                                if (capitalizeBreadCrumbName === 'Claim-credit-token') {
                                    capitalizeBreadCrumbName = 'Claim Credit Token';
                                }
                                if (capitalizeBreadCrumbName === 'Emailtemplate') {
                                    capitalizeBreadCrumbName = 'Email Template';
                                }
                                if (capitalizeBreadCrumbName === 'Ecu') {
                                    capitalizeBreadCrumbName = 'ECU';
                                }
                                if (capitalizeBreadCrumbName === 'Alarmhistory') {
                                    capitalizeBreadCrumbName = 'Alarm History';
                                }
                            }
                            var obj = {
                                name: capitalizeBreadCrumbName,
                                title: capitalizeBreadCrumbName,
                                redirectUrl: "main." + stateObj
                            };
                            scope.breadCrumbArray.push(obj);
                        });
                        if (scope.breadCrumbArray && scope.breadCrumbArray.length === 4 && scope.breadCrumbArray[0].name === 'Tracker' && scope.breadCrumbArray[1].name === 'Project' && scope.breadCrumbArray[2].name === ':name' && (scope.breadCrumbArray[3].name === 'S4' || scope.breadCrumbArray[3].name === 'Email Template')) {
                            $timeout(function () {
                                var url = $window.location.href;
                                var urlArr = url.split('/');
                                scope.breadCrumbArray[2].name = decodeURIComponent(urlArr[urlArr.length - 2]);
                                scope.breadCrumbArray[2].title = decodeURIComponent(urlArr[urlArr.length - 2]);
                                scope.breadCrumbArray[2].redirectUrl = "main.project({selectedId: '" + scope.getParameterByName('selectedProject') + "'})";
                                var tempBreadCrumbArray = _.cloneDeepWith(scope.breadCrumbArray);
                                scope.breadCrumbArray = [];
                                $timeout(function () {
                                    scope.breadCrumbArray = _.cloneDeepWith(tempBreadCrumbArray);
                                },100);
                            });
                        }
                        if (scope.breadCrumbArray && scope.breadCrumbArray.length === 4 && scope.breadCrumbArray[0].name === 'Node' && scope.breadCrumbArray[1].name === 'Project' && scope.breadCrumbArray[2].name === ':name' && (scope.breadCrumbArray[3].name === 'S4' || scope.breadCrumbArray[3].name === 'Email Template')) {
                            $timeout(function () {
                                var url = $window.location.href;
                                var urlArr = url.split('/');
                                scope.breadCrumbArray[1] = {name: "Project", title: "Project", redirectUrl: "main.node_project"};
                                scope.breadCrumbArray[2].name = decodeURIComponent(urlArr[urlArr.length - 2]);
                                scope.breadCrumbArray[2].title = decodeURIComponent(urlArr[urlArr.length - 2]);
                                scope.breadCrumbArray[2].redirectUrl = "main.node_project({selectedId: '" + scope.getParameterByName('selectedProject') + "'})";
                                var tempBreadCrumbArray = _.cloneDeepWith(scope.breadCrumbArray);
                                scope.breadCrumbArray = [];
                                $timeout(function () {
                                    scope.breadCrumbArray = _.cloneDeepWith(tempBreadCrumbArray);
                                    scope.$apply();
                                },100);
                            });
                        }
                    };
                    scope.fnInitBreadcrumb();

                    scope.$on('$stateChangeSuccess', function () {
                        scope.fnInitBreadcrumb();
                    });

                    scope.fnOpenFeedbackSupportModal = function () {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/breadcrumb/FeedbackModal/feedbackModal.html',
                            size: 'lg',
                            windowClass: 'modal-height100',
                            controller: 'feedbackSupportModalCtrl as feedbackSupport'
                        });
                        modalInstance.result.then(function (fedObj) {
                            if (fedObj) {
                                scope.$emit('startFederationProcess', fedObj);
                            }
                        }, function () {
                        });
                    };

                    scope.fnOpenInfoModel = function () {
                        var modalInstance = $uibModal.open({
                            backdrop: 'static',
                            templateUrl: 'app/components/breadcrumb/InformationModel/informationModal.html',
                            size: 'lg',
                            controller: 'infoModalCtrl as infoModal'
                        });
                        modalInstance.result.then(function () {
                        }, function () {
                        });
                    };

                    scope.getParameterByName = function (name) {
                        var url = $window.location.href;
                        name = name.replace(/[\[\]]/g, '\\$&');
                        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                            results = regex.exec(url);
                        if (!results) {
                            return null
                        }
                        if (!results[2]) {
                            return ''
                        }
                        return decodeURIComponent(results[2].replace(/\+/g, ' '));
                    }
                },
                templateUrl: 'app/components/breadcrumb/breadcrumb.html'
            }
        })

})();



angular.module("phoenixNewUi").run(["$templateCache", function($templateCache) {$templateCache.put("app/404/404.html","<div class=\"row h-100\" ng-init=\"notFound.fnInit404()\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content overflow-y-auto\"><div class=\"row\"><div class=\"col-sm-12 text-center\"><div class=\"col-sm-12 p-0\"><div class=\"jumbotron m-b-0\" style=\"background: transparent;\"><h1><strong>404</strong></h1><label>Looks like you don\'t have access to this page. Would you like to go to one of the following pages instead?</label></div></div><div class=\"col-sm-6 col-sm-offset-3\"><uib-accordion><uib-accordion-group ng-repeat=\"pageOption in notFound.pageOptions\" is-open=\"pageOption.open\"><uib-accordion-heading><div>{{$index + 1}}. {{pageOption.appName}}</div></uib-accordion-heading><div class=\"row\" ng-repeat=\"subPageOption in pageOption.pageOptions\"><div class=\"col-xs-12\"><button class=\"btn btn-link\" ng-click=\"notFound.fnGoToState(subPageOption.state)\">{{subPageOption.name}}</button></div></div></uib-accordion-group></uib-accordion></div></div></div></div><div class=\"content-box-footer\"></div></div></div></div>");
$templateCache.put("app/coming-soon/coming-soon.html","<div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content overflow-y-auto\"><div class=\"row h-100\"><div class=\"col-sm-12 text-center h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"jumbotron m-b-0 h-100 d-flex justify-content-center align-items-center flex-column\" style=\"background: transparent;\"><div style=\"height: 150px;width: 150px;\" class=\"pulse-animation\"><svg class=\"svgIconFillTextSecondaryColor\" version=\"1.1\" viewbox=\"0 0 480 480\"><g><g><rect x=\"216\" y=\"72\" width=\"216\" height=\"16\"></rect></g></g><g><g><rect x=\"216\" y=\"104\" width=\"136\" height=\"16\"></rect></g></g><g><g><rect x=\"216\" y=\"136\" width=\"136\" height=\"16\"></rect></g></g><g><g><rect x=\"280\" y=\"40\" width=\"152\" height=\"16\"></rect></g></g><g><g><rect x=\"248\" y=\"40\" width=\"16\" height=\"16\"></rect></g></g><g><g><rect x=\"232\" y=\"320\" width=\"16\" height=\"16\"></rect></g></g><g><g><path d=\"M133.656,53.656l-11.312-11.312l-16,16c-3.123,3.124-3.123,8.188,0,11.312l16,16l11.312-11.312L123.312,64L133.656,53.656 z\"></path></g></g><g><g><path d=\"M197.656,58.344l-16-16l-11.312,11.312L180.688,64l-10.344,10.344l11.312,11.312l16-16 C200.779,66.532,200.779,61.468,197.656,58.344z\"></path></g></g><g><g><rect x=\"126.697\" y=\"56\" transform=\"matrix(0.3165 -0.9486 0.9486 0.3165 43.1798 187.9208)\" width=\"50.6\" height=\"15.992\"></rect></g></g><g><g><polygon points=\"416,248 416,184 400,184 400,248 384,248 384,168 368,168 368,248 352,248 352,208 336,208 336,248 320,248 320,200 304,200 304,248 288,248 288,216 272,216 272,248 256,248 256,264 432,264 432,248\"></polygon></g></g><g><g><path d=\"M424,0H56C29.501,0.026,8.026,21.501,8,48v157.008v0.072V296v24c0.026,26.499,21.501,47.974,48,48h99.056l-32,64H80 c-13.255,0-24,10.745-24,24s10.745,24,24,24h320c13.255,0,24-10.745,24-24s-10.745-24-24-24h-43.056l-32-64H424 c26.499-0.026,47.974-21.501,48-48V48C471.974,21.501,450.499,0.026,424,0z M24,112.56l18.184,21.648 c1.52,1.811,3.764,2.856,6.128,2.856H72.8c2.364,0,4.608-1.045,6.128-2.856L97.12,112.56l17.952,5.832l1.984,28.184 c0.164,2.357,1.362,4.521,3.272,5.912l19.816,14.4c1.917,1.384,4.345,1.855,6.64,1.288l27.464-6.824l11.104,15.272l-14.968,24 c-1.24,2.012-1.527,4.469-0.784,6.712l7.576,23.288c0.729,2.246,2.412,4.056,4.6,4.944L208,246.2v18.88l-26.24,10.632 c-2.193,0.884-3.879,2.699-4.6,4.952l-2.4,7.336h-46.088c17.928-37.536,2.032-82.499-35.504-100.427 c-22.047-10.53-47.833-9.712-69.168,2.195V112.56z M24,208.8c25.876-20.187,63.218-15.575,83.404,10.302 C122.99,239.08,124.193,266.744,110.4,288H24V208.8z M400,448c4.418,0,8,3.582,8,8s-3.582,8-8,8H80c-4.418,0-8-3.582-8-8 s3.582-8,8-8H400z M339.056,432H140.944l32-64h134.112L339.056,432z M456,320c0,17.673-14.327,32-32,32H56 c-17.673,0-32-14.327-32-32v-16h90.576h0.072H456V320z M456,288H194.04l24.968-10.12c3.016-1.224,4.99-4.153,4.992-7.408V240.8 c0.001-3.258-1.973-6.191-4.992-7.416L191.2,222.136l-5.264-16.2l15.856-25.44c1.72-2.764,1.593-6.294-0.32-8.928l-17.44-24 c-1.915-2.637-5.237-3.849-8.4-3.064l-29.088,7.2L132.8,141.72l-2.104-29.84c-0.229-3.253-2.41-6.042-5.512-7.048l-28.2-9.168 c-3.103-0.988-6.495-0.013-8.6,2.472l-19.256,22.92H52.064L32.8,98.136c-2.106-2.488-5.503-3.464-8.608-2.472L24,95.736V48 c0-17.673,14.327-32,32-32h368c17.673,0,32,14.327,32,32V288z\"></path></g></g></svg></div><h2 style=\"font-weight: bold;\">Coming Soon.</h2></div></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"row h-100\" ng-init=\"dashboard.fnInitDashboard()\"></div>");
$templateCache.put("app/loadingScreen/loadingScreen.html","<div class=\"col-sm-12 h-100 p-0\" ng-init=\"loadingScreen.fnInit()\"><div class=\"h-100 d-flex flex-column align-items-center justify-content-center\" ng-if=\"loadingScreen.isForFederation\"><i class=\"fa fa-handshake-o fa-10x pulse-animation\"></i> <label class=\"m-t-10 font-italic\">Please wait while we are connecting to your federation...</label></div><div class=\"h-100 d-flex flex-column align-items-center justify-content-center\" ng-if=\"loadingScreen.isForSupport\"><i class=\"fa fa-gear fa-10x fa-spin\"></i> <label class=\"m-t-10 font-italic\">Please wait while we are connecting to your support...</label></div></div>");
$templateCache.put("app/lock/lock.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"lock.fnInitLockScreen()\"><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"lock.isUnlocking\"><div class=\"m-t-p-50\" app-spinner=\"\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Unlocking...\'\"></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"!lock.isUnlocking\"><div class=\"login-screen middle-box animated fadeInDown\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>Unlock</strong></h2><h2 class=\"m-t-20 text-center\">{{lock.login.email}}</h2><div class=\"m-t-20\" role=\"form\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!lock.isAuthenticateParametersFetch && !lock.isSAMLUnlock\"></div><div ng-if=\"lock.isAuthenticateParametersFetch && !lock.isSAMLUnlock\"><div class=\"m-b-30 floatingLabelInput\"><form id=\"unlockForm\" role=\"form\" name=\"unlockForm\" class=\"floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div sf-schema=\"lock.schema\" sf-form=\"lock.form\" sf-model=\"lock.model\"></div></div><div class=\"col-sm-12 p-0\"><button type=\"submit\" class=\"btn btn-primary ladda-md block full-width m-b-15\" ng-click=\"lock.fnUnlock(lock.model)\" ng-disabled=\"!unlockForm.$valid\">Unlock</button></div></form></div></div><div ng-if=\"lock.isSAMLUnlock && !lock.isAuthenticateParametersFetch\"><div class=\"m-b-30 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><button type=\"submit\" class=\"btn btn-primary ladda-md block full-width m-b-15\" ng-click=\"lock.fnUnlockSAML()\">Unlock</button></div></div></div><div class=\"m-b-15 text-center\"><a class=\"link-dk-primary\" ng-click=\"lock.fnOpenSupportModal(\'\',false,\'password\')\">Forgot password?</a> <i class=\"fa fa-circle fa-fw m-l-10 m-r-10\" style=\"vertical-align: middle; font-size: 3px\" aria-hidden=\"true\"></i> <a class=\"link-dk-primary\" ng-click=\"lock.fnLogout()\">Sign in with another account</a></div><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\"><i class=\"fa fa-copyright\"></i> Copyright © {{lock.lastYear}} - {{lock.currentYear }} ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></div></div></div><div class=\"col-sm-8 h-100\"><div id=\"image-wrapper\" style=\"height: 40%\" ng-include=\"\" src=\"lock.svgPath\"></div><div style=\"height: 60%; background-image: url(\'assets/predictive/city-scape.svg\'); background-size: contain; background-repeat: no-repeat; background-position: center bottom;\"></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div><form id=\"saml_form\" method=\"POST\" action=\"{{lock.idpUrl}}\"><input type=\"hidden\" name=\"SAMLRequest\" value=\"{{lock.apiRes.samlRequest}}\"> <input type=\"hidden\" name=\"RelayState\" value=\"{{lock.apiRes.token}}\"></form>");
$templateCache.put("app/login/login.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"login.fnInitLoginScreen()\"><div class=\"col-sm-4 img-shadow h-100\"><div class=\"login-screen middle-box animated fadeInDown\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Logging In...\'\" ng-show=\"login.isLoging\"></app-spinner><div ng-show=\"!login.isLoging\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>Log In</strong></h2><form id=\"loginForm\" role=\"form\" name=\"loginForm\" class=\"active animated floatingLabelInput\"><div class=\"md-input m-b-2 m-t-40\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"text\" ng-model=\"login.loginObj.email\" ng-change=\"login.isEmailInvalid = false\" placeholder=\"Email / User Name\"> <span class=\"highlight\"></span> <label>Email / User Name</label></div><small ng-if=\"login.isEmailInvalid\">Sorry, we don\'t recognise that {{login.accountInputType}}.</small><div class=\"m-t-30\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"login.isAuthenticateParameters\"></div><button class=\"btn btn-primary ladda-md block full-width m-b-15 m-t-30\" ng-if=\"!login.isAuthenticateParameters\" ng-disabled=\"!loginForm.$valid\" ng-click=\"login.fnNextToPassword(login.loginObj.email);\">Next</button><div class=\"m-b-15 text-center\" ng-if=\"!login.isAuthenticateParameters\"><a class=\"link-dk-primary\" ng-click=\"login.fnOpenSupportModal(\'\',false,\'username\')\">Forgot username?</a></div></form><form id=\"passwordForm\" role=\"form\" name=\"passwordForm\" class=\"animated floatingLabelInput\"><div class=\"col-sm-12 p-0 m-t-40\"><div sf-schema=\"login.schema\" sf-form=\"login.form\" sf-model=\"login.model\"></div></div><div class=\"col-sm-12 p-0\"><small ng-if=\"login.isSessionFailed\">Invalid Credentials.</small><div class=\"row\"><div class=\"col-sm-6\"><button class=\"btn btn-primary ladda-md block full-width m-b-15\" ng-disabled=\"!passwordForm.$valid\" ng-click=\"login.fnLogin(login.model);\">Log In</button></div><div class=\"col-sm-6\"><button class=\"btn btn-primary ladda-md block full-width m-b-15\" ng-click=\"login.fnBackToUser()\">Back</button></div></div><div class=\"m-b-15 text-center\"><a class=\"link-dk-primary\" ng-click=\"login.fnOpenSupportModal(\'\',false,\'password\')\">Forgot password?</a></div></div></form><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\">Copyright © {{login.lastYear}} - {{login.currentYear }} ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></div></div></div><div class=\"col-sm-8 text-center p-0 h-100\"><div id=\"image-wrapper\" style=\"height: 40%\" ng-include=\"\" src=\"login.svg\"></div><div style=\"height: 60%; background-image: url(\'assets/predictive/city-scape.svg\'); background-size: contain; background-repeat: no-repeat; background-position: center bottom;\"></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div><form id=\"saml_form\" method=\"POST\" action=\"{{login.idpUrl}}\"><input type=\"hidden\" name=\"SAMLRequest\" value=\"{{login.apiRes.samlRequest}}\"> <input type=\"hidden\" name=\"RelayState\" value=\"{{login.apiRes.token}}\"></form>");
$templateCache.put("app/login/passwordTemplate.html","<div class=\"md-input\"><strong class=\"md-input-icon\" ng-click=\"form.isHide = !form.isHide\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"form.isHide ? \'fa-eye-slash\' : \'fa-eye\'\"></i></strong> <input class=\"md-form-control\" type=\"{{form.isHide ? \'password\' : \'text\' }}\" ng-required=\"form.required\" schema-validate=\"form\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}\" ng-model=\"$$value$$\"> <label>{{form.title}}</label><div sf-message=\"\"></div></div>");
$templateCache.put("app/main/main.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/top-nav/top-nav.html\'\"></div><div id=\"page-wrapper\"><div class=\"sidebar\" ng-include=\"\'app/components/side-nav/side-nav.html\'\"></div><div class=\"page-content\" ng-init=\"main.fnInitMain()\"><div ui-view=\"\" class=\"h-100\"></div></div></div><div breadcrumb=\"\" class=\"breadcrumb-bar\"></div></div><div id=\"refreshSwal\" ng-if=\"main.isShowRefreshSwal\"><div class=\"alert\"><div class=\"m-b-10 d-flex align-items-center\"><svg class=\"svgIconFillTextSecondaryColor m-r-10\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/warning-exl.svg#elx\"></use></svg><span class=\"m-0\"><strong>New version is available</strong></span></div><div class=\"m-l-30 d-flex align-items-center\"><div class=\"m-r-10\"><strong>Reload in {{main.minutes}}:{{main.seconds}}</strong></div><div class=\"m-r-10\"><button class=\"btn btn-link p-0\" ng-click=\"main.fnReloadSnooze(false)\">Snooze</button></div><div class=\"m-r-10\"><button class=\"btn btn-link p-0\" ng-click=\"main.fnReloadSnooze(true)\">Reload now</button></div></div></div></div>");
$templateCache.put("app/noPrivileges/noPrivileges.html","<div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content overflow-y-auto\"><div class=\"row h-100\"><div class=\"col-sm-12 text-center h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"jumbotron m-b-0 h-100 d-flex justify-content-center align-items-center flex-column\" style=\"background: transparent;\"><div style=\"height: 150px;width: 150px;\" class=\"pulse-animation\"><svg class=\"svgIconFillTextSecondaryColor\" version=\"1.1\" id=\"Layer_1\" viewbox=\"0 0 511.999 511.999\"><g><path d=\"M310.825,239.768c1.173,3.182,4.223,5.455,7.811,5.455c27.669,0,50.179-22.511,50.179-50.181 c0-17.784-9.307-33.425-23.299-42.339c-16.281-34.076-50.809-55.956-88.723-55.956c-37.91,0-72.437,21.878-88.72,55.952 c-13.996,8.914-23.307,24.558-23.307,42.345c0,27.669,22.511,50.18,50.179,50.18c3.589,0,6.639-2.274,7.811-5.456 c5.777,6.968,12.875,12.799,20.904,17.119c-22.031,11.851-37.046,35.124-37.046,61.843c0,4.602,3.731,8.332,8.332,8.332 c4.601,0,8.332-3.731,8.332-8.332c0-29.507,24.004-53.511,53.511-53.511S310.3,289.223,310.3,318.73 c0,4.602,3.731,8.332,8.332,8.332c4.602,0,8.332-3.731,8.332-8.332c0-26.719-15.014-49.993-37.046-61.843 C297.951,252.567,305.048,246.735,310.825,239.768z M326.968,162.575c14.463,3.714,25.183,16.862,25.183,32.467 c0.001,15.606-10.72,28.755-25.183,32.469V162.575z M186.616,227.511c-14.463-3.714-25.183-16.862-25.183-32.469 c0-15.605,10.721-28.754,25.183-32.467V227.511z M194.948,144.862c-0.87,0-1.734,0.023-2.593,0.067 c15.26-19.583,38.927-31.519,64.44-31.519c25.514,0,49.182,11.936,64.44,31.519c-0.861-0.044-1.728-0.067-2.599-0.067 c-3.588,0-6.638,2.273-7.811,5.455c-12.883-15.536-32.32-25.45-54.032-25.45c-21.712,0-41.151,9.914-54.033,25.451 C201.587,147.136,198.537,144.862,194.948,144.862z M256.793,248.552c-15.593,0-29.647-6.708-39.435-17.385h23.884 c4.602,0,8.332-3.731,8.332-8.332c0-4.601-3.731-8.332-8.332-8.332h-34.281c-2.366-6.037-3.679-12.596-3.679-19.462 c0-29.506,24.004-53.511,53.511-53.511c29.507,0,53.511,24.004,53.511,53.511C310.304,224.548,286.299,248.552,256.793,248.552z\"></path></g><g><path d=\"M471.246,24.766H40.754C18.283,24.766,0,43.049,0,65.52v59.227c0,4.602,3.731,8.332,8.332,8.332 c4.601,0,8.332-3.731,8.332-8.332V65.52c0-13.284,10.807-24.09,24.09-24.09h430.492c13.284,0,24.09,10.807,24.09,24.09v284.411 h-52.21c-4.602,0-8.332,3.731-8.332,8.332s3.731,8.332,8.332,8.332h52.21v15.273c0,13.284-10.807,24.09-24.09,24.09H40.754 c-13.284,0-24.09-10.807-24.09-24.09v-15.273h398.688c4.602,0,8.332-3.731,8.332-8.332s-3.731-8.332-8.332-8.332H16.664V152.522 c0-4.602-3.731-8.332-8.332-8.332c-4.601,0-8.332,3.73-8.332,8.332V381.87c0,22.472,18.283,40.754,40.754,40.754H183.54 l-20.494,47.945h-40.034c-4.602,0-8.332,3.731-8.332,8.332s3.731,8.332,8.332,8.332h265.975c4.602,0,8.332-3.731,8.332-8.332 s-3.731-8.332-8.332-8.332h-40.034l-20.494-47.945h142.786c22.472,0,40.754-18.282,40.754-40.754V65.52 C512,43.049,493.717,24.766,471.246,24.766z M330.83,470.568H181.17l14.238-33.31h121.185L330.83,470.568z\"></path></g><g><path d=\"M262.924,379.679c-1.914-2.906-5.583-4.299-8.952-3.457c-3.517,0.879-6.116,4.048-6.291,7.67 c-0.364,7.534,9.106,11.629,14.33,6.172C264.674,387.282,265.089,382.887,262.924,379.679z\"></path></g></svg></div><h3 style=\"font-weight: bold;\">Sorry you don\'t appear to have been assigned any permissions. Please contact your administrator.</h3></div></div></div></div></div></div></div></div>");
$templateCache.put("app/render/render.html","<div class=\"col-sm-12 h-100 p-0\" ng-init=\"render.fnInit()\"><div class=\"imgRender\" ng-if=\"render.isChartTypeSupported\"></div><div class=\"w100 h-100 d-flex flex-column align-items-center justify-content-center\" ng-if=\"!render.isChartTypeSupported\"><h3>{{render.chartType}} chart type is not yet supported</h3><button class=\"btn btn-primary v4-primary-button m-t-10\" ng-click=\"render.fnBackToHome()\">Back to Home</button></div><div ng-if=\"render.isErrorFound\"><img src=\"assets/images/render/no_image_available.jpg\"></div></div>");
$templateCache.put("app/samlUserDataLoad/samlUserDataLoad.html","<div class=\"col-sm-12 h-100 p-0\" ng-init=\"samlUser.fnInit()\"><div class=\"h-100 d-flex flex-column align-items-center justify-content-center\"><i class=\"fa fa-handshake-o fa-10x pulse-animation\"></i> <label class=\"m-t-10 font-italic\">One moment while we fetch your data...</label></div></div>");
$templateCache.put("app/signup/signup.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"signup.fnInitSignup()\"><div id=\"signUpMainDiv\" class=\"col-sm-4 img-shadow\" style=\"overflow: auto; height: 100%\"><div class=\"login-screen middle-box animated fadeInDown\"><div class=\"floatingLabelInput\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>{{signup.headerText}}</strong></h2><div class=\"signInDiv m-b-25\" ng-if=\"signup.isSignupForm\">Already have an account? <a class=\"link-dk-primary\" ng-click=\"signup.fnGoToLoginPage()\">Sign In</a></div><form id=\"signupForm\" role=\"form\" name=\"signupForm\" class=\"active animated\" novalidate=\"\"><div class=\"md-input has-feedback\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" ng-model=\"signup.userObj.firstName\" placeholder=\"First Name*\" name=\"firstName\"> <span class=\"form-control-feedback validationTick\" ng-show=\"signupForm.firstName.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>First Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"lastName\" type=\"text\" ng-model=\"signup.userObj.lastName\" placeholder=\"Last Name*\" name=\"lastName\"> <span class=\"form-control-feedback validationTick\" ng-show=\"signupForm.lastName.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Last Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" name=\"email\" ng-change=\"signup.isEmailAvailable = true; signup.fnValidateEmail(signup.userObj.email)\" ng-model=\"signup.userObj.email\" placeholder=\"Email*\"> <span class=\"form-control-feedback validationTick\" ng-show=\"!signupForm.email.$error.required && !signup.isEmailInvalid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Email*</label> <small class=\"helper-text\"><span ng-if=\"!signupForm.email.$error.required && signup.isEmailInvalid\">Email is not Valid</span> <span ng-if=\"!signup.isEmailAvailable\">This Email is already taken. Please try another one.</span></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"username\" type=\"text\" ng-model=\"signup.userObj.username\" ng-pattern=\"/^[A-Za-z0-9_]+$/\" ng-change=\"signup.isUsernameAvailable = true\" ng-focus=\"signup.showUserNameSuggestions = true\" ng-blur=\"signup.showUserNameSuggestions = false\" placeholder=\"Username*\" name=\"Username\"> <span class=\"form-control-feedback validationTick\" ng-show=\"signupForm.Username.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Username*</label> <small class=\"helper-text\"><span ng-if=\"signup.showUserNameSuggestions && signup.isUsernameAvailable\">Username may contain a-z, A-Z, 0-9 and the _ characters</span> <span ng-if=\"!signup.isUsernameAvailable\">This Username is already taken. Please try another one.</span></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"companyName\" type=\"text\" ng-model=\"signup.accountObj.name\" placeholder=\"Company Name\" name=\"companyName\"> <span class=\"form-control-feedback validationTick\" ng-show=\"signupForm.companyName.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Company Name</label> <small class=\"helper-text\"></small></div><div class=\"d-flex p-b-10\" ng-click=\"$event.stopPropagation();\" style=\"align-items: center;\"><input type=\"checkbox\" id=\"chk_{{0}}\" class=\"float-left\" name=\"isCheck\" ng-model=\"signup.isPolicyCheck\" required=\"\"> <label for=\"chk_{{0}}\" class=\"check-box\"></label> <span class=\"float-right p-l-10\">I agree to ECSite\'s Terms of Service and Privacy Policy</span></div><div id=\"captchaDiv\" class=\"col-sm-12 p-0\" ng-if=\"!signup.captchaVerified\" vc-recaptcha=\"\" key=\"\'6LdBBcoZAAAAAKDO35-ce0GpmZpYmiaAe6dnmvCJ\'\" ng-model=\"signup.myRecaptchaResponse\" on-success=\"signup.fnVerifyCaptcha(response)\" on-expire=\"signup.fnReVerifyCaptcha(response)\"></div><button class=\"btn btn-primary block full-width m-b-15 m-t-30\" ng-if=\"signup.captchaVerified && !signup.isCreatingNewAccount\" ng-disabled=\"!signup.userObj.firstName.length || !signup.userObj.lastName.length || !signup.userObj.email.length || !signup.userObj.username.length || signupForm.username.$valid || signup.isEmailInvalid || !signup.isPolicyCheck\" ng-click=\"signup.fnCreateFreeAccount(login.loginObj.email);\">Create Free Account</button><div class=\"m-t-30 text-center\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"signup.isCreatingNewAccount\"></div></form><div class=\"col-sm-12\" ng-if=\"signup.isSignUpCompleted\"><span>As promised we have credited your new account with $150 so you can gain free, hands-on experience with our platform, products and services.</span><br><br><span>To start using your account you just need to confirm your account. We have sent you an email containing instructions on how to activate your account.</span><br><br><span>A member of our friendly support team will reach out to you soon to help organize your training. However, if you experience any difficulties don\'t hesitate to reach out to our <a class=\"btn btn-link p-0\" ng-click=\"signup.fnOpenSupportModal(\'\', false,\'\')\">support team</a> who will be happy to help you.</span><br><br><span>It is a pleasure having you join our community and we hope our platform helps grow you business.</span><br><br><span>The ECSite Team.</span></div><div class=\"col-sm-12 p-0 m-t-10\" style=\"font-size: 10px;\"><div class=\"text-center\">Copyright © {{login.lastYear}} - {{login.currentYear }} ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></div></div></div><div id=\"sslSecureDiv\" class=\"col-sm-6 p-0 m-t-10 m-b-10\" ng-if=\"signup.isProfileForm || signup.isSignUpCompleted\"><img width=\"100\" src=\"assets/images/ssl-secure.png\"></div></div><div id=\"pricingMainDiv\" class=\"col-sm-8 accountInfo\"><div class=\"col-sm-12\" style=\"padding-left: 5%;position: relative; top: 25%;\"><h1 class=\"p-b-10\"><b>Include with your account</b></h1><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Entire suite of application</h3></div><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Full feature set</h3></div><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Unlimited auto-scaling</h3></div><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Ultra high availability</h3></div><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Encryption</h3></div><div class=\"d-flex\"><i class=\"fa fa-lg fa-check m-r-10 m-t-7\"></i><h3>Dedicated solution architect to support initial pilot</h3></div></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div><script type=\"text/ng-template\" id=\"layoutTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <br> </a></script>");
$templateCache.put("app/validation/resetPassword.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"validationsPassword.fnInit()\"><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validationsPassword.isResetPasswordProgress\"><div class=\"m-t-p-50\" app-spinner=\"\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Validating...\'\"></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"!validationsPassword.isResetPasswordProgress && !validationsPassword.isShowValidateMessage\"><div class=\"login-screen middle-box animated fadeInDown floatingLabelInput\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>Reset password</strong></h2><div class=\"text-center\"><small>Please reset your password.</small></div><h3 class=\"m-t-20 text-center\">{{validationsPassword.name}}</h3><form class=\"m-t-20\" role=\"form\" name=\"validateForm\"><div class=\"md-input m-b-50\"><strong class=\"md-input-icon\" ng-click=\"validationsPassword.hideShowPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validationsPassword.passInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"password\" type=\"{{validationsPassword.passInputType}}\" required=\"\" ng-model=\"validationsPassword.password\" zxcvbn=\"validationsPassword.passwordStrength\" zx-extras=\"validateForm\" ng-change=\"validationsPassword.validationInputPwdText()\" placeholder=\"New Password*\"> <span class=\"highlight\"></span> <label>Password*</label><div class=\"col-sm-12 p-0 w100 d-flex align-items-center flex-column m-t-5\"><div class=\"col-sm-12 p-0 w100 d-flex align-items-center\"><div class=\"passwordStrength\"><div ng-style=\"validationsPassword.checkpwdStrength\"></div></div></div><div class=\"col-sm-12 p-0 w100 d-flex justify-content-flex-end align-items-center m-t-3\"><div>{{validationsPassword.passwordTest}}</div></div></div></div><div class=\"md-input m-b-10\"><strong class=\"md-input-icon\" ng-click=\"validationsPassword.hideShowPasswordForConfirm()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validationsPassword.confirmPassInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"confirmPassword\" type=\"{{validationsPassword.confirmPassInputType}}\" required=\"\" ng-model=\"validationsPassword.confirmPassword\" placeholder=\"Confirm Password*\"> <span class=\"highlight\"></span> <label>Confirm Password*</label></div><div ng-if=\"(validationsPassword.passwordStrength.feedback.warning && validationsPassword.passwordStrength.feedback.warning.length) || ((validationsPassword.password && validationsPassword.confirmPassword) && validationsPassword.password !== validationsPassword.confirmPassword)\" class=\"m-b-5\"><div><b>Warning:</b></div><ul class=\"m-0 p-l-15\" ng-if=\"validationsPassword.passwordStrength.feedback.warning.length\"><li>{{validationsPassword.passwordStrength.feedback.warning}}</li></ul><ul class=\"m-0 p-l-15\" ng-if=\"(validationsPassword.password && validationsPassword.confirmPassword) && validationsPassword.password !== validationsPassword.confirmPassword\"><li><b>Password</b> and <b>Confirm Password</b> do not match.</li></ul></div><div ng-if=\"validationsPassword.passwordStrength.feedback.suggestions && validationsPassword.passwordStrength.feedback.suggestions.length && (validationsPassword.password && validationsPassword.password.length)\"><div><b>Suggestions:</b></div><ul class=\"m-0 p-l-15\"><li ng-repeat=\"suggestion in validationsPassword.passwordStrength.feedback.suggestions\">{{suggestion}}</li></ul></div><button type=\"button\" class=\"btn btn-link p-0 m-t-5\" ng-click=\"validationsPassword.fnGeneratePassword()\">Generate Password</button> <button type=\"submit\" class=\"btn btn-primary block full-width m-b-15 m-t-20\" ng-click=\"validationsPassword.fnValidatePassword()\" ng-disabled=\"!validateForm.$valid || validationsPassword.password !== validationsPassword.confirmPassword || !validationsPassword.isPasswordValid\">Submit</button><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\"><i class=\"fa fa-copyright\"></i> Copyright © {{validationsPassword.lastYear}} - {{validationsPassword.currentYear }} ECSMon - ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></form></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validationsPassword.isShowValidateMessage\"><div class=\"text-center m-t-p-50\"><label>Password Reset Successfully.</label><br><button class=\"btn btn-primary m-t-10\" ng-click=\"$state.go(\'login\')\">Go To Login Page.</button></div></div><div class=\"col-sm-8 h-100\"><div id=\"image-wrapper\" style=\"height: 40%\" ng-include=\"\" src=\"validationsPassword.svg\"></div><div style=\"height: 60%; background-image: url(\'assets/predictive/city-scape.svg\'); background-size: contain; background-repeat: no-repeat; background-position: center bottom;\"></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div>");
$templateCache.put("app/validation/validateNewEmail.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"validateNewEmail.fnInit()\"><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validateNewEmail.isValidationProgress\"><div class=\"m-t-p-50\" app-spinner=\"\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Validating...\'\"></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"!validateNewEmail.isValidationProgress && !validateNewEmail.isShowValidateMessage\"><div class=\"login-screen middle-box animated fadeInDown floatingLabelInput\" ng-if=\"validateNewEmail.isSetNewPassword\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>User Validation</strong></h2><div class=\"text-center\"><small>Please set a password to validate your Email.</small></div><h3 class=\"m-t-20 text-center\">{{validateNewEmail.name}}</h3><form class=\"m-t-20\" role=\"form\" name=\"validateForm\"><div class=\"md-input m-b-50\"><strong class=\"md-input-icon\" ng-click=\"validateNewEmail.hideShowPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validateNewEmail.passInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"password\" type=\"{{validateNewEmail.passInputType}}\" required=\"\" ng-model=\"validateNewEmail.password\" zxcvbn=\"validateNewEmail.passwordStrength\" zx-extras=\"validateForm\" ng-change=\"validateNewEmail.validationInputPwdText()\" placeholder=\"New Password*\"> <span class=\"highlight\"></span> <label>Password*</label><div class=\"col-sm-12 p-0 w100 d-flex align-items-center flex-column m-t-5\"><div class=\"col-sm-12 p-0 w100 d-flex align-items-center\"><div class=\"passwordStrength\"><div ng-style=\"validateNewEmail.checkpwdStrength\"></div></div></div><div class=\"col-sm-12 p-0 w100 d-flex justify-content-flex-end align-items-center m-t-3\"><div>{{validateNewEmail.passwordTest}}</div></div></div></div><div class=\"md-input m-b-10\"><strong class=\"md-input-icon\" ng-click=\"validateNewEmail.hideShowPasswordForConfirm()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validateNewEmail.confirmPassInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"confirmPassword\" type=\"{{validateNewEmail.confirmPassInputType}}\" required=\"\" ng-model=\"validateNewEmail.confirmPassword\" placeholder=\"Confirm Password*\"> <span class=\"highlight\"></span> <label>Confirm Password*</label></div><div ng-if=\"(validateNewEmail.passwordStrength.feedback.warning && validateNewEmail.passwordStrength.feedback.warning.length) || ((validateNewEmail.password && validateNewEmail.confirmPassword) && validateNewEmail.password !== validateNewEmail.confirmPassword)\" class=\"m-b-5\"><div><b>Warning:</b></div><ul class=\"m-0 p-l-15\" ng-if=\"validateNewEmail.passwordStrength.feedback.warning.length\"><li>{{validateNewEmail.passwordStrength.feedback.warning}}</li></ul><ul class=\"m-0 p-l-15\" ng-if=\"(validateNewEmail.password && validateNewEmail.confirmPassword) && validateNewEmail.password !== validateNewEmail.confirmPassword\"><li><b>Password</b> and <b>Confirm Password</b> do not match.</li></ul></div><div ng-if=\"validateNewEmail.passwordStrength.feedback.suggestions && validateNewEmail.passwordStrength.feedback.suggestions.length && (validateNewEmail.password && validateNewEmail.password.length)\"><div><b>Suggestions:</b></div><ul class=\"m-0 p-l-15\"><li ng-repeat=\"suggestion in validateNewEmail.passwordStrength.feedback.suggestions\">{{suggestion}}</li></ul></div><button type=\"button\" class=\"btn btn-link p-0 m-t-5\" ng-click=\"validateNewEmail.fnGeneratePassword()\">Generate Password</button> <button type=\"submit\" class=\"btn btn-primary block full-width m-b-15 m-t-30\" ng-click=\"validateNewEmail.fnValidateUser()\" ng-disabled=\"!validateForm.$valid || validateNewEmail.password !== validateNewEmail.confirmPassword || !validateNewEmail.isPasswordValid\">Validate Email</button><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\"><i class=\"fa fa-copyright\"></i> Copyright © {{validateNewEmail.lastYear}} - {{validateNewEmail.currentYear }} ECSMon - ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></form></div><div class=\"login-screen middle-box animated fadeInDown floatingLabelInput\" ng-if=\"!validateNewEmail.isSetNewPassword\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>Email Validation</strong></h2><div class=\"text-center\"><small>Please click on a Validate Email button to validate your Email.</small></div><form class=\"m-t-20\" role=\"form\" name=\"validateForm\"><button type=\"submit\" class=\"btn btn-primary block full-width m-b-15 m-t-30\" ng-click=\"validateNewEmail.fnValidateNewEmail()\">Validate Email</button><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\"><i class=\"fa fa-copyright\"></i> Copyright © {{validateNewEmail.lastYear}} - {{validateNewEmail.currentYear }} ECSMon - ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></form></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validateNewEmail.isShowValidateMessage\"><div class=\"text-center m-t-p-50\"><label>Email Validated Successfully.</label><br><button class=\"btn btn-primary m-t-10\" ng-click=\"$state.go(\'login\')\">Go To Login Page.</button></div></div><div class=\"col-sm-8 h-100\"><div id=\"image-wrapper\" style=\"height: 40%\" ng-include=\"\" src=\"validateNewEmail.svg\"></div><div style=\"height: 60%; background-image: url(\'assets/predictive/city-scape.svg\'); background-size: contain; background-repeat: no-repeat; background-position: center bottom;\"></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div>");
$templateCache.put("app/validation/validation.html","<div class=\"col-sm-12 img-shadow h-100 p-0\" ng-init=\"validation.fnInit()\"><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validation.isValidationProgress\"><div class=\"m-t-p-50\" app-spinner=\"\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Validating...\'\"></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"!validation.isValidationProgress && !validation.isShowValidateMessage\"><div class=\"login-screen middle-box animated fadeInDown floatingLabelInput\"><div class=\"text-center\"><img width=\"100\" src=\"assets/images/svg/logo_color.svg\"></div><h2 class=\"text-center\"><strong>Account Validation</strong></h2><div class=\"text-center\"><small>Please set a password to validate your Account.</small></div><h3 class=\"m-t-20 text-center\">{{validation.name}}</h3><form class=\"m-t-20\" role=\"form\" name=\"validateForm\"><div class=\"md-input m-b-50\"><strong class=\"md-input-icon\" ng-click=\"validation.hideShowPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validation.passInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"password\" type=\"{{validation.passInputType}}\" required=\"\" ng-model=\"validation.password\" zxcvbn=\"validation.passwordStrength\" zx-extras=\"validateForm\" ng-change=\"validation.validationInputPwdText()\" placeholder=\"New Password*\"> <span class=\"highlight\"></span> <label>Password*</label><div class=\"col-sm-12 p-0 w100 d-flex align-items-center flex-column m-t-5\"><div class=\"col-sm-12 p-0 w100 d-flex align-items-center\"><div class=\"passwordStrength\"><div ng-style=\"validation.checkpwdStrength\"></div></div></div><div class=\"col-sm-12 p-0 w100 d-flex justify-content-flex-end align-items-center m-t-3\"><div>{{validation.passwordTest}}</div></div></div></div><div class=\"md-input m-b-10\"><strong class=\"md-input-icon\" ng-click=\"validation.hideShowPasswordForConfirm()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"validation.confirmPassInputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" id=\"confirmPassword\" type=\"{{validation.confirmPassInputType}}\" required=\"\" ng-model=\"validation.confirmPassword\" placeholder=\"Confirm Password*\"> <span class=\"highlight\"></span> <label>Confirm Password*</label></div><div ng-if=\"(validation.passwordStrength.feedback.warning && validation.passwordStrength.feedback.warning.length) || ((validation.password && validation.confirmPassword) && validation.password !== validation.confirmPassword)\" class=\"m-b-5\"><div><b>Warning:</b></div><ul class=\"m-0 p-l-15\" ng-if=\"validation.passwordStrength.feedback.warning.length\"><li>{{validation.passwordStrength.feedback.warning}}</li></ul><ul class=\"m-0 p-l-15\" ng-if=\"(validation.password && validation.confirmPassword) && validation.password !== validation.confirmPassword\"><li><b>Password</b> and <b>Confirm Password</b> do not match.</li></ul></div><div ng-if=\"validation.passwordStrength.feedback.suggestions && validation.passwordStrength.feedback.suggestions.length && (validation.password && validation.password.length)\"><div><b>Suggestions:</b></div><ul class=\"m-0 p-l-15\"><li ng-repeat=\"suggestion in validation.passwordStrength.feedback.suggestions\">{{suggestion}}</li></ul></div><button type=\"button\" class=\"btn btn-link p-0 m-t-5\" ng-click=\"validation.fnGeneratePassword()\">Generate Password</button> <button type=\"submit\" class=\"btn btn-primary block full-width m-b-15 m-t-30\" ng-click=\"validation.fnValidateUser()\" ng-disabled=\"!validateForm.$valid || validation.password !== validation.confirmPassword || !validation.isPasswordValid\">Validate Account</button><div class=\"m-b-15 m-t-40 text-center\" style=\"font-size: 10px\"><i class=\"fa fa-copyright\"></i> Copyright © {{validation.lastYear}} - {{validation.currentYear }} ECSMon - ECSite <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Privacy</a> and <a class=\"link-dk-primary\" target=\"_blank\" href=\"https://ecsite.ai/privacy/\">Terms</a></div></form></div></div><div class=\"col-sm-4 img-shadow h-100\" ng-if=\"validation.isShowValidateMessage\"><div class=\"text-center m-t-p-50\"><label>Account Validated Successfully.</label><br><button class=\"btn btn-primary m-t-10\" ng-click=\"$state.go(\'login\')\">Go To Login Page.</button></div></div><div class=\"col-sm-8 h-100\"><div id=\"image-wrapper\" style=\"height: 40%\" ng-include=\"\" src=\"validation.svg\"></div><div style=\"height: 60%; background-image: url(\'assets/predictive/city-scape.svg\'); background-size: contain; background-repeat: no-repeat; background-position: center bottom;\"></div></div><script type=\"text/ng-template\" id=\"predictiveSVG\"><svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0\" y=\"0\" width=\"528.744\" height=\"103.16\" viewBox=\"0, 0, 528.744, 103.16\"> <g id=\"Layer_1\" class=\"svgFill\"> <path d=\"M41.244,19.6 Q41.244,24.1 39.594,27.55 Q37.944,31 35.144,33.3 Q32.344,35.6 28.594,36.8 Q24.844,38 20.644,38 L2.344,38 L2.344,72.8 L0.144,72.8 L0.144,2 L19.344,2 Q23.144,2 27.044,2.85 Q30.944,3.7 34.094,5.7 Q37.244,7.7 39.244,11.1 Q41.244,14.5 41.244,19.6 z M39.044,19.6 Q39.044,15.1 37.344,12.1 Q35.644,9.1 32.944,7.3 Q30.244,5.5 26.894,4.7 Q23.544,3.9 20.244,3.9 L2.344,3.9 L2.344,36.1 L20.744,36.1 Q24.044,36.1 27.344,35.2 Q30.644,34.3 33.244,32.3 Q35.844,30.3 37.444,27.15 Q39.044,24 39.044,19.6 z\" fill=\"#404040\"/> <path d=\"M97.544,72.8 L76.144,37.1 L59.544,37.1 L59.544,72.8 L57.344,72.8 L57.344,2 L76.944,2 Q80.844,2 84.844,2.7 Q88.844,3.4 91.994,5.35 Q95.144,7.3 97.144,10.7 Q99.144,14.1 99.144,19.5 Q99.144,24.5 97.244,27.8 Q95.344,31.1 92.344,33.15 Q89.344,35.2 85.694,36.1 Q82.044,37 78.544,37 L100.044,72.8 z M96.944,19.5 Q96.944,14.9 95.144,11.85 Q93.344,8.8 90.394,7.05 Q87.444,5.3 83.594,4.6 Q79.744,3.9 75.744,3.9 L59.544,3.9 L59.544,35.2 L76.844,35.2 Q86.644,35.2 91.794,31.1 Q96.944,27 96.944,19.5 z\" fill=\"#404040\"/> <path d=\"M116.744,72.8 L116.744,2 L157.944,2 L157.944,4 L118.844,4 L118.844,35.1 L155.644,35.1 L155.644,37.1 L118.844,37.1 L118.844,70.8 L159.544,70.8 L159.544,72.8 z\" fill=\"#404040\"/> <path d=\"M234.944,37.4 Q234.944,46.6 231.944,53.25 Q228.944,59.9 223.644,64.25 Q218.344,68.6 211.194,70.7 Q204.044,72.8 195.844,72.8 L175.744,72.8 L175.744,2 L195.844,2 Q204.044,2 211.194,4.05 Q218.344,6.1 223.644,10.45 Q228.944,14.8 231.944,21.5 Q234.944,28.2 234.944,37.4 z M178.044,4 L178.044,70.8 L195.344,70.8 Q203.144,70.8 209.994,68.85 Q216.844,66.9 221.844,62.85 Q226.844,58.8 229.744,52.5 Q232.644,46.2 232.644,37.4 Q232.644,28.6 229.744,22.25 Q226.844,15.9 221.844,11.85 Q216.844,7.8 209.994,5.9 Q203.144,4 195.344,4 z\" fill=\"#404040\"/> <path d=\"M252.744,72.8 L252.744,2 L254.944,2 L254.944,72.8 z\" fill=\"#404040\"/> <path d=\"M334.144,64.1 Q329.644,69.5 322.794,72.15 Q315.944,74.8 308.844,74.8 Q300.844,74.8 294.244,72 Q287.644,69.2 282.844,64.25 Q278.044,59.3 275.394,52.4 Q272.744,45.5 272.744,37.4 Q272.744,29.3 275.394,22.4 Q278.044,15.5 282.844,10.55 Q287.644,5.6 294.294,2.8 Q300.944,0 308.844,0 Q315.444,0 321.694,2.25 Q327.944,4.5 332.344,9.1 L330.944,10.7 Q328.844,8.5 326.194,6.85 Q323.544,5.2 320.594,4.1 Q317.644,3 314.644,2.5 Q311.644,2 308.844,2 Q301.244,2 294.994,4.75 Q288.744,7.5 284.294,12.3 Q279.844,17.1 277.394,23.55 Q274.944,30 274.944,37.4 Q274.944,44.8 277.344,51.25 Q279.744,57.7 284.194,62.5 Q288.644,67.3 294.894,70.05 Q301.144,72.8 308.844,72.8 Q315.444,72.8 321.894,70.25 Q328.344,67.7 332.544,62.6 z\" fill=\"#404040\"/> <path d=\"M365.444,4 L365.444,72.8 L363.244,72.8 L363.244,4 L339.144,4 L339.144,2 L389.544,2 L389.544,4 z\" fill=\"#404040\"/> <path d=\"M401.944,72.8 L401.944,2 L404.144,2 L404.144,72.8 z\" fill=\"#404040\"/> <path d=\"M446.544,72.8 L443.144,72.8 L416.544,2 L418.944,2 L444.744,70.8 L444.944,70.8 L471.144,2 L473.544,2 z\" fill=\"#404040\"/> <path d=\"M485.944,72.8 L485.944,2 L527.144,2 L527.144,4 L488.044,4 L488.044,35.1 L524.844,35.1 L524.844,37.1 L488.044,37.1 L488.044,70.8 L528.744,70.8 L528.744,72.8 z\" fill=\"#404040\"/> <path d=\"M4.734,90.416 L4.734,102.8 L4.338,102.8 L4.338,90.416 L0,90.416 L0,90.056 L9.072,90.056 L9.072,90.416 z\" fill=\"#404040\"/> <path d=\"M46.304,102.8 L46.304,90.056 L53.72,90.056 L53.72,90.416 L46.682,90.416 L46.682,96.014 L53.306,96.014 L53.306,96.374 L46.682,96.374 L46.682,102.44 L54.008,102.44 L54.008,102.8 z\" fill=\"#404040\"/> <path d=\"M102.364,101.234 Q101.554,102.206 100.321,102.683 Q99.088,103.16 97.81,103.16 Q96.37,103.16 95.182,102.656 Q93.994,102.152 93.13,101.261 Q92.266,100.37 91.789,99.128 Q91.312,97.886 91.312,96.428 Q91.312,94.97 91.789,93.728 Q92.266,92.486 93.13,91.595 Q93.994,90.704 95.191,90.2 Q96.388,89.696 97.81,89.696 Q98.998,89.696 100.123,90.101 Q101.248,90.506 102.04,91.334 L101.788,91.622 Q101.41,91.226 100.933,90.929 Q100.456,90.632 99.925,90.434 Q99.394,90.236 98.854,90.146 Q98.314,90.056 97.81,90.056 Q96.442,90.056 95.317,90.551 Q94.192,91.046 93.391,91.91 Q92.59,92.774 92.149,93.935 Q91.708,95.096 91.708,96.428 Q91.708,97.76 92.14,98.921 Q92.572,100.082 93.373,100.946 Q94.174,101.81 95.299,102.305 Q96.424,102.8 97.81,102.8 Q98.998,102.8 100.159,102.341 Q101.32,101.882 102.076,100.964 z\" fill=\"#404040\"/> <path d=\"M148.92,102.8 L148.92,96.392 L140.352,96.392 L140.352,102.8 L139.956,102.8 L139.956,90.056 L140.352,90.056 L140.352,96.032 L148.92,96.032 L148.92,90.056 L149.316,90.056 L149.316,102.8 z\" fill=\"#404040\"/> <path d=\"M197.726,102.8 L188.582,90.56 L188.528,90.56 L188.528,102.8 L188.132,102.8 L188.132,90.056 L188.69,90.056 L197.852,102.278 L197.906,102.278 L197.906,90.056 L198.302,90.056 L198.302,102.8 z\" fill=\"#404040\"/> <path d=\"M249.61,96.428 Q249.61,97.904 249.115,99.137 Q248.62,100.37 247.747,101.261 Q246.874,102.152 245.668,102.656 Q244.462,103.16 243.058,103.16 Q241.654,103.16 240.448,102.656 Q239.242,102.152 238.369,101.261 Q237.496,100.37 237.001,99.137 Q236.506,97.904 236.506,96.428 Q236.506,94.952 237.001,93.719 Q237.496,92.486 238.369,91.595 Q239.242,90.704 240.439,90.2 Q241.636,89.696 243.058,89.696 Q244.48,89.696 245.677,90.2 Q246.874,90.704 247.747,91.595 Q248.62,92.486 249.115,93.719 Q249.61,94.952 249.61,96.428 z M249.214,96.428 Q249.214,95.096 248.764,93.935 Q248.314,92.774 247.495,91.91 Q246.676,91.046 245.542,90.551 Q244.408,90.056 243.058,90.056 Q241.708,90.056 240.574,90.551 Q239.44,91.046 238.621,91.91 Q237.802,92.774 237.352,93.935 Q236.902,95.096 236.902,96.428 Q236.902,97.76 237.343,98.921 Q237.784,100.082 238.594,100.946 Q239.404,101.81 240.538,102.305 Q241.672,102.8 243.058,102.8 Q244.444,102.8 245.578,102.305 Q246.712,101.81 247.522,100.946 Q248.332,100.082 248.773,98.921 Q249.214,97.76 249.214,96.428 z\" fill=\"#404040\"/> <path d=\"M287.814,102.8 L287.814,90.056 L288.21,90.056 L288.21,102.44 L294.546,102.44 L294.546,102.8 z\" fill=\"#404040\"/> <path d=\"M343.514,96.428 Q343.514,97.904 343.019,99.137 Q342.524,100.37 341.651,101.261 Q340.778,102.152 339.572,102.656 Q338.366,103.16 336.962,103.16 Q335.558,103.16 334.352,102.656 Q333.146,102.152 332.273,101.261 Q331.4,100.37 330.905,99.137 Q330.41,97.904 330.41,96.428 Q330.41,94.952 330.905,93.719 Q331.4,92.486 332.273,91.595 Q333.146,90.704 334.343,90.2 Q335.54,89.696 336.962,89.696 Q338.384,89.696 339.581,90.2 Q340.778,90.704 341.651,91.595 Q342.524,92.486 343.019,93.719 Q343.514,94.952 343.514,96.428 z M343.118,96.428 Q343.118,95.096 342.668,93.935 Q342.218,92.774 341.399,91.91 Q340.58,91.046 339.446,90.551 Q338.312,90.056 336.962,90.056 Q335.612,90.056 334.478,90.551 Q333.344,91.046 332.525,91.91 Q331.706,92.774 331.256,93.935 Q330.806,95.096 330.806,96.428 Q330.806,97.76 331.247,98.921 Q331.688,100.082 332.498,100.946 Q333.308,101.81 334.442,102.305 Q335.576,102.8 336.962,102.8 Q338.348,102.8 339.482,102.305 Q340.616,101.81 341.426,100.946 Q342.236,100.082 342.677,98.921 Q343.118,97.76 343.118,96.428 z\" fill=\"#404040\"/> <path d=\"M392.392,102.062 Q391.636,102.476 390.484,102.818 Q389.332,103.16 387.82,103.16 Q386.308,103.16 385.066,102.638 Q383.824,102.116 382.942,101.207 Q382.06,100.298 381.583,99.065 Q381.106,97.832 381.106,96.392 Q381.106,94.952 381.592,93.719 Q382.078,92.486 382.951,91.595 Q383.824,90.704 385.048,90.2 Q386.272,89.696 387.748,89.696 Q389.044,89.696 390.124,90.092 Q391.204,90.488 392.032,91.172 L391.744,91.46 Q391.384,91.118 390.907,90.857 Q390.43,90.596 389.899,90.416 Q389.368,90.236 388.81,90.146 Q388.252,90.056 387.73,90.056 Q386.326,90.056 385.174,90.551 Q384.022,91.046 383.203,91.91 Q382.384,92.774 381.943,93.926 Q381.502,95.078 381.502,96.392 Q381.502,97.706 381.934,98.876 Q382.366,100.046 383.185,100.919 Q384.004,101.792 385.183,102.296 Q386.362,102.8 387.856,102.8 Q389.152,102.8 390.16,102.53 Q391.168,102.26 392.014,101.846 L392.014,96.842 L388.702,96.842 L388.702,96.5 L392.392,96.5 z\" fill=\"#404040\"/> <path d=\"M431.028,102.8 L431.028,90.056 L431.424,90.056 L431.424,102.8 z\" fill=\"#404040\"/> <path d=\"M470.24,102.8 L470.24,90.056 L477.656,90.056 L477.656,90.416 L470.618,90.416 L470.618,96.014 L477.242,96.014 L477.242,96.374 L470.618,96.374 L470.618,102.44 L477.944,102.44 L477.944,102.8 z\" fill=\"#404040\"/> <path d=\"M522.916,99.74 Q522.916,100.55 522.601,101.189 Q522.286,101.828 521.764,102.269 Q521.242,102.71 520.531,102.935 Q519.82,103.16 519.046,103.16 Q517.858,103.16 516.877,102.737 Q515.896,102.314 515.248,101.594 L515.554,101.324 Q516.238,102.062 517.147,102.431 Q518.056,102.8 519.028,102.8 Q519.73,102.8 520.36,102.593 Q520.99,102.386 521.476,101.999 Q521.962,101.612 522.241,101.045 Q522.52,100.478 522.52,99.74 Q522.52,99.002 522.214,98.498 Q521.908,97.994 521.422,97.634 Q520.936,97.274 520.315,97.031 Q519.694,96.788 519.064,96.59 Q518.272,96.338 517.615,96.059 Q516.958,95.78 516.481,95.375 Q516.004,94.97 515.743,94.403 Q515.482,93.836 515.482,93.026 Q515.482,92.234 515.797,91.613 Q516.112,90.992 516.652,90.569 Q517.192,90.146 517.903,89.921 Q518.614,89.696 519.406,89.696 Q520.378,89.696 521.251,90.065 Q522.124,90.434 522.682,91.118 L522.376,91.388 Q521.872,90.758 521.089,90.407 Q520.306,90.056 519.388,90.056 Q518.74,90.056 518.119,90.236 Q517.498,90.416 516.994,90.785 Q516.49,91.154 516.184,91.712 Q515.878,92.27 515.878,93.026 Q515.878,93.764 516.148,94.277 Q516.418,94.79 516.868,95.15 Q517.318,95.51 517.885,95.744 Q518.452,95.978 519.046,96.176 Q519.856,96.446 520.558,96.725 Q521.26,97.004 521.791,97.4 Q522.322,97.796 522.619,98.363 Q522.916,98.93 522.916,99.74 z\" fill=\"#404040\"/> </g> </svg></script></div>");
$templateCache.put("app/access/audits/audits.html","<div class=\"row h-100\" ng-init=\"audits.fnInitAudits()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"audits.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in audits.tabs track by $index\" select=\"audits.fnTabChanged(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();audits.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"audits.isFullWidthDevice\"><a ng-click=\"audits.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{audits.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"audits.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"audits.isFullWidthDevice && audits.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'audit\'\" service-name=\"\'Audit\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"audits.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"audits.fnGetWidgetEditor()\" fn-hide-chart=\"audits.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"audits.isRefreshData\" search-identifier=\"\'auditSearch\'\" filters-arr=\"audits.searchFiltersArr\" filter-query=\"audits.filterQuery\" fn-filter-query-change=\"audits.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.audits\'\" fn-resize=\"audits.fnSetTableHeight()\" sort-field-arr=\"audits.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"audits.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"audits.getAuditCSVData()\" id=\"csvAnchor\" csv-header=\"audits.csvHeaderArr\" filename=\"audits.csv\"></a></li><li ng-if=\"audits.isShowInsightOption()\"><a ng-click=\"audits.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li></ul></div></div></div><div class=\"row\" ng-if=\"audits.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"audits.isAuditsLoading\" fn-resize=\"audits.fnSetLoaderTableHeight()\"></table-loader><div class=\"audits-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!audits.isAuditsLoading\"><thead><tr><th class=\"p-l-20\" ng-if=\"audits.auditsArr.length\"><span>Time</span></th><th ng-if=\"audits.auditsArr.length\"><span>Message</span></th><th ng-if=\"audits.auditsArr.length\"><span></span></th><th ng-if=\"audits.auditsArr.length\"><span></span></th><th ng-if=\"audits.auditsArr.length\"></th><th ng-if=\"audits.auditsArr.length\"></th><th ng-if=\"audits.auditsArr.length\"></th><th ng-if=\"!audits.auditsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"auditObj in audits.auditsArr track by $index\"><td class=\"attributeTdCSS-style\"><div ng-if=\"auditObj.timestamp\" class=\"d-flex p-l-20\" uib-tooltip=\"{{auditObj.timestamp}}\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">{{auditObj.timestamp}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{auditObj.event}} \'{{auditObj.principal}}\'\" tooltip-placement=\"auto\"><label class=\"ellipsis m-b-0\" style=\"width: fit-content !important;\">{{auditObj.event}} \'{{auditObj.principal}}\'</label></div><div ng-if=\"auditObj.message\" class=\"d-flex p-0\" uib-tooltip=\"{{auditObj.message}}\" tooltip-placement=\"auto\"><span class=\"ellipsis\" style=\"display: block;\"><span class=\"DescriptionText font-italic p-r-5 span_des\">{{auditObj.message}}</span></span></div></td><td class=\"attributeTdCSS-style\"><div ng-if=\"auditObj.application\" class=\"d-flex p-0\" uib-tooltip=\"{{auditObj.application}}\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">{{auditObj.application}}</span></div></td><td class=\"attributeTdCSS-style\"><div ng-if=\"auditObj.ip\" class=\"d-flex p-0\" uib-tooltip=\"{{auditObj.ip}}\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">{{auditObj.ip}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-0\" uib-tooltip=\"[{{auditObj.facility}}.{{auditObj.severity}}]\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">[{{auditObj.facility}}.{{auditObj.severity}}]</span></div></td><td class=\"attributeTdCSS-style\"><div ng-if=\"auditObj.principal\" class=\"d-flex p-0\" uib-tooltip=\"{{auditObj.principal}}\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">{{auditObj.principal}}</span></div></td><td class=\"attributeTdCSS-style\"><div ng-if=\"auditObj.id\" class=\"d-flex p-0\" uib-tooltip=\"{{auditObj.id}}\" tooltip-placement=\"auto\"><span class=\"ellipsis m-b-0\">{{auditObj.id}}</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!audits.isAuditsLoading && audits.auditsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{audits.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"audits.perPage = 10; audits.fnPageChanged(audits.currentPage, audits.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"audits.perPage = 20; audits.fnPageChanged(audits.currentPage, audits.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"audits.perPage = 50; audits.fnPageChanged(audits.currentPage, audits.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"audits.perPage = 100; audits.fnPageChanged(audits.currentPage,audits.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"audits.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"audits.currentPage\" items-per-page=\"audits.perPage\" max-size=\"audits.maxSize\" boundary-links=\"true\" ng-click=\"audits.fnPageChanged(audits.currentPage, audits.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\" style=\"height: 55px;\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-0\">Total: {{audits.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : audits.isRefresh}\" ng-click=\"audits.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"audits.activeTabIndex !== 1 && audits.isShowWidgetEditor && !audits.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-display-name=\"\'Audits\'\" service-name=\"\'audit\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"audits.activeTabIndex !== 1 && !audits.isShowWidgetEditor && audits.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'audit\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/authenticator/authenticators.html","<div class=\"row h-100\" ng-init=\"authenticators.fnInitAuthenticators()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"authenticators.activeTabIndex\"><uib-tab index=\"1\" select=\"authenticators.fnTabChanged(authenticators.tabs[0])\" ng-click=\"authenticators.fnChangeTab(authenticators.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"authenticators.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in authenticators.tabs track by $index\" select=\"authenticators.fnTabChanged(tab)\" ng-click=\"authenticators.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"authenticators.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();authenticators.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"authenticators.fnGetAuthenticatorDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!authenticators.isFullWidthDevice\"><a ng-click=\"authenticators.fnGetAuthenticatorStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"authenticators.isFullWidthDevice\"><a ng-click=\"authenticators.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{authenticators.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"authenticators.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-b-10 p-t-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"authenticators.isFullWidthDevice && authenticators.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'authenticator\'\" service-name=\"\'Authenticator\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"authenticators.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"authenticators.fnGetWidgetEditor()\" fn-hide-chart=\"authenticators.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"authenticators.isRefreshData\" search-identifier=\"\'authenticatorSearch\'\" filters-arr=\"authenticators.searchFiltersArr\" filter-query=\"authenticators.filterQuery\" fn-filter-query-change=\"authenticators.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.authenticators\'\" fn-resize=\"authenticators.fnSetTableHeight()\" sort-field-arr=\"authenticators.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"authenticators.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"authenticators.isShowInsightOption()\"><a ng-click=\"authenticators.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"authenticators.getAuthenticatorCSVData()\" id=\"csvAnchor\" csv-header=\"authenticators.csvHeaderArr\" filename=\"authenticators.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"authenticators.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"authenticators.isAuthenticatorsLoading\" fn-resize=\"authenticators.fnSetLoaderTableHeight()\"></table-loader><div class=\"authenticators-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!authenticators.isAuthenticatorsLoading\"><thead><tr><th ng-if=\"authenticators.authenticatorsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"authenticators.isAllChecked\" ng-click=\"authenticators.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"authenticators.authenticatorsArr.length\"><span>Name</span></th><th ng-if=\"authenticators.authenticatorsArr.length\"></th><th ng-if=\"authenticators.authenticatorsArr.length\"></th><th ng-if=\"authenticators.authenticatorsArr.length\"></th><th ng-if=\"!authenticators.authenticatorsArr.length\">No records found...</th></tr></thead><tbody id=\"authenticatorsTable\"><tr ng-repeat=\"authenticatorObj in authenticators.authenticatorsArr track by $index\" ng-click=\"authenticators.fnCheckUncheckHeader(authenticatorObj);\" context-menu=\"authenticators.authenticatorContextMenu(authenticatorObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"authenticatorObj.isCheck\" ng-change=\"authenticators.fnCheckUncheckHeader(authenticatorObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!authenticatorObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{authenticatorObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{authenticatorObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"authenticatorObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"authenticatorObj.name\" placeholder=\"Name for the Authenticator*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"authenticatorObj.description\" placeholder=\"Description regarding Authenticator\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();authenticators.fnCancelAuthenticatorEditMode(authenticatorObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!authenticatorObj.name.length\" ng-click=\"$event.stopPropagation();authenticators.fnSaveAuthenticatorInfo(authenticatorObj)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!authenticatorObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{authenticatorObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"authenticatorObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{authenticatorObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{authenticatorObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"authenticatorObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des\" ng-if=\"authenticatorObj.createdBy\">by {{authenticatorObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!authenticatorObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{authenticatorObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"authenticatorObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{authenticatorObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{authenticatorObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"authenticatorObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des\" ng-if=\"authenticatorObj.updatedBy\">by {{authenticatorObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!authenticatorObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': authenticators.isDropUp }\" ng-click=\"$event.stopPropagation(); authenticators.toggleDropUp(\'authenticatorsTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"authenticators.fnOpenAuthenticatorInfoTab(authenticatorObj,1)\">Details</a></li><li><a ng-click=\"authenticators.fnOpenAuthenticatorInfoTab(authenticatorObj,2)\">Tags</a></li><li><a ng-click=\"authenticators.fnCopyId(authenticatorObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!authenticators.isAuthenticatorsLoading && authenticators.authenticatorsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{authenticators.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"authenticators.perPage = 10; authenticators.fnPageChanged(authenticators.currentPage, authenticators.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticators.perPage = 20; authenticators.fnPageChanged(authenticators.currentPage, authenticators.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticators.perPage = 50; authenticators.fnPageChanged(authenticators.currentPage, authenticators.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticators.perPage = 100; authenticators.fnPageChanged(authenticators.currentPage,authenticators.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"authenticators.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"authenticators.currentPage\" items-per-page=\"authenticators.perPage\" max-size=\"authenticators.maxSize\" boundary-links=\"true\" ng-click=\"authenticators.fnPageChanged(authenticators.currentPage, authenticators.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-0\">Total: {{authenticators.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : authenticators.isRefresh}\" ng-click=\"authenticators.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"authenticators.fnHideShowCreateForm()\">Create Authenticator</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && authenticators.selectedAuthenticatorsArr.length === 1 && authenticators.selectedAuthenticatorObj && authenticators.isAuthenticatorDetailsLoaded && !authenticators.isCreate && !authenticators.isShowDashboard && !authenticators.isShowAuthenticatorStats && !authenticators.isShowWidgetEditor && !authenticators.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><authenticator-info authenticator-obj=\"authenticators.selectedAuthenticatorObj\" user-permissions-obj=\"authenticators.permissionObj\"></authenticator-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && authenticators.isCreate && !authenticators.isShowDashboard && !authenticators.isShowAuthenticatorStats && !authenticators.isShowWidgetEditor && !authenticators.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/access/authenticator/createAuthenticator/createAuthenticator.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && authenticators.isShowDashboard && !authenticators.isCreate && !authenticators.isShowAuthenticatorStats && !authenticators.isShowWidgetEditor && !authenticators.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Authenticators</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select \'Create Authenticator\' and select an authenticator</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Fill in your custom company details</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/service/Asset4.svg#test_1\"></use></svg></div><div class=\"position-r\" id=\"password\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10 m-b-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/service/script.svg#script\"></use></svg><div class=\"password-text-div\">Use the Authentication S4 to define who should use it and when</div></div><div class=\"\" id=\"login\" style=\"position: relative;\"><div class=\"login-text-div\" style=\"bottom: 40px;\">The specified users will be prompted to sign in using the authenticator</div><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"45px\" height=\"45px\"><use xlink:href=\"assets/images/svg/service/password.svg#password\"></use></svg></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create vaults from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create vaults from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Authenticators are real people that are members of your account. To create a authenticator, select Create Authenticator.</span><br><button class=\"btn btn-primary m-t-10\" ng-if=\"authenticators.permissionObj.CREATE_AUTHENTICATOR\" ng-click=\"authenticators.fnHideShowCreateForm()\">Create Authenticator</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Authenticators are free in your account.You can Create as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to authenticators</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add authenticators to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how authenticators sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && !authenticators.isShowDashboard && !authenticators.isCreate && authenticators.isShowAuthenticatorStats && !authenticators.isShowWidgetEditor && !authenticators.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'authenticator\'\" service-name=\"\'Authenticator\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"authenticators.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"authenticators.fnGetWidgetEditor()\" fn-hide-chart=\"authenticators.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && !authenticators.isShowDashboard && !authenticators.isCreate && !authenticators.isShowAuthenticatorStats && authenticators.isShowWidgetEditor && !authenticators.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-name=\"\'authenticator\'\" service-display-name=\"\'Authenticator\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"authenticators.activeTabIndex !== 1 && !authenticators.isShowDashboard && !authenticators.isCreate && !authenticators.isShowAuthenticatorStats && !authenticators.isShowWidgetEditor && authenticators.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'authenticator\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/dashboard/dashboard.html","<div class=\"row h-100\" ng-init=\"accessDashboard.fnInit()\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\" style=\"height: inherit;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"accessDashboard.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in accessDashboard.tabs track by $index\" select=\"accessDashboard.fnTabChanged(tab)\" ng-click=\"accessDashboard.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();accessDashboard.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"accessDashboard.activeTabIndex === 1\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\"><span>Security</span><h1 class=\"m-0 font-bold\">Access</h1><h2 class=\"m-0 m-t-10\">Securely control access to your ECSMon resources.</h2></div></div><div class=\"col-sm-12 p-0 d-flex dashboard-body\"><div class=\"overflow-auto\" ng-class=\"accessDashboard.isFullWidthDevice ? \'col-sm-9 p-r-0\':\'col-sm-12 \'\"><insight-dashboards app-key=\"\'access\'\" service-key=\"\'dashboard\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"accessDashboard.fnOpenCreateIssueTab(chartObj)\"></insight-dashboards></div><div ng-if=\"accessDashboard.isFullWidthDevice\" class=\"col-sm-3 p-l-0 side-bar\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Access helps you manage access to your ECSMon resources. Using Access, you can manage who can use your ECSMon resources (authentication) and what resources they can use and in what ways (authorization).</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">API documentation</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Manage federation</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">Get training</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"accessDashboard.activeTabIndex !== 1 && accessDashboard.isCreate\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'dashboard\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/email/email.html","<div class=\"row h-100\" ng-init=\"email.fnInitEmails()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"email.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in email.tabs track by $index\" select=\"email.fnTabChanged(tab)\" ng-click=\"email.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();email.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"email.fnGetEmailDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!email.isFullWidthDevice\"><a ng-click=\"email.fnGetEmailStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"email.isFullWidthDevice\"><a ng-click=\"email.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{email.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"email.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"email.isFullWidthDevice && email.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'email\'\" service-name=\"\'email\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"email.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"email.fnGetWidgetEditor()\" fn-hide-chart=\"email.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"email.isRefreshData\" search-identifier=\"\'emailSearch\'\" filters-arr=\"email.searchFiltersArr\" filter-query=\"email.filterQuery\" fn-filter-query-change=\"email.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.emails\'\" fn-resize=\"email.fnSetTableHeight()\" sort-field-arr=\"email.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"email.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"email.isShowInsightOption()\"><a ng-click=\"email.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"email.getEmailCSVData()\" id=\"csvAnchor\" csv-header=\"email.csvHeaderArr\" filename=\"email.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"email.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"email.isEmailsLoading\" fn-resize=\"email.fnSetLoaderTableHeight()\"></table-loader><div class=\"email-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!email.isEmailsLoading\"><thead><tr><th class=\"p-l-5\" ng-if=\"email.emailsArr.length\"><span>Email</span></th><th class=\"p-l-5\" ng-if=\"!email.emailsArr.length\">No records found...</th></tr></thead><tbody id=\"emailsTable\"><tr ng-repeat=\"emailObj in email.emailsArr track by $index\"><td class=\"p-l-5\"><span>{{emailObj.email}}</span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!email.isEmailsLoading && email.emailsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{email.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"email.perPage = 10; email.fnPageChanged(email.currentPage, email.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"email.perPage = 20; email.fnPageChanged(email.currentPage, email.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"email.perPage = 50; email.fnPageChanged(email.currentPage, email.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"email.perPage = 100; email.fnPageChanged(email.currentPage,email.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"email.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"email.currentPage\" items-per-page=\"email.perPage\" max-size=\"email.maxSize\" boundary-links=\"true\" ng-click=\"email.fnPageChanged(email.currentPage, email.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{email.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : email.isRefresh}\" ng-click=\"email.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"email.permissionObj.REQUEST_WHITELIST_VALIDATION\" ng-click=\"email.fnHideShowCreateForm()\">Whitelist Email</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"email.activeTabIndex !== 1 && email.isCreate && !email.isShowDashboard && !email.isShowEmailStats && !email.isShowWidgetEditor && !email.isShowEmailStats && !email.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><div class=\"col-sm-12 m-t-30 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0\">Whitelist email for system notifications.</h3></div><div class=\"col-sm-12 p-0 m-t-20\" ng-form=\"addEmailForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"email.newEmail\" ng-pattern=\"email.emailPattern\" placeholder=\"Email for system notifications*\" name=\"email\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"addEmailForm.email.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Email*</label> <small class=\"helper-text-error\" style=\"background-color: #ffffff00;\" ng-show=\"email.fnValidateEmail(email.newEmail)\"><span class=\"errorText\">Email is in incorrect format.</span></small></div></div><div class=\"col-sm-12 p-0 m-t-20\"><div class=\"col-sm-6 p-0\"></div><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"email.isEmailCreating\" ng-disabled=\"!email.isCreateDisabled\" ng-click=\"email.fnSaveEmail()\">Whitelist Email</button><div class=\"pull-right\" ng-if=\"!email.isEmailCreating\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"email.activeTabIndex !== 1 && email.isShowDashboard && !email.isCreate && !email.isShowEmailStats && !email.isShowWidgetEditor && !email.isShowEmailStats && !email.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Whitelist Email</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select \'Whitelist Email\' and enter the email address</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">We will send them an email with a confirmation link</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/email.svg#Capa_1\"></use></svg></div><div class=\"position-r\" id=\"password\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10 m-b-10\" width=\"33px\" height=\"33px\"><use xlink:href=\"assets/images/svg/email_validate.svg#emailValidate\"></use></svg><div class=\"password-text-div\">They use the link to validate their email address</div></div><div class=\"\" id=\"login\" style=\"position: relative;\"><div class=\"login-text-div\" style=\"bottom: 50px;left: -40px;\">They can then receive system notifications by email</div><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10 m-b-10\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/email_notification.svg#emailNotification\"></use></svg></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create email from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create email from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Emails are real people that are members of your account. To create a email, select Add Email.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"email.fnHideShowCreateForm()\">Add Email</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Emails are free in your account.You can Create as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to email</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add email to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how email sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"email.activeTabIndex !== 1 && !email.isShowDashboard && !email.isCreate && email.isShowEmailStats && !email.isShowWidgetEditor && !email.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'email\'\" service-name=\"\'Whitelist Email\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"email.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"email.fnGetWidgetEditor()\" fn-hide-chart=\"email.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"email.activeTabIndex !== 1 && !email.isShowDashboard && !email.isCreate && !email.isShowEmailStats && email.isShowWidgetEditor && !email.isShowEmailStats && !email.isCreateIssue\"><widget-editor dashboard-widgets=\"email.dashboardWidgets\" reset-dashboard-widgets=\"email.resetDashboardWidgets\" selected-column=\"email.selectedColumn\" app-name=\"\'access\'\" service-name=\"\'email\'\" service-display-name=\"\'Whitelist Email\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"email.activeTabIndex !== 1 && !email.isShowDashboard && !email.isCreate && !email.isShowEmailStats && !email.isShowWidgetEditor && !email.isShowEmailStats && email.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'emailTemplate\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/emailTemplate/emailTemplate.html","<div class=\"row h-100\" ng-init=\"emailTemplate.fnInitEmailTemplate();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"emailTemplate.activeTabIndex\"><uib-tab index=\"1\" select=\"emailTemplate.fnTabChanged(emailTemplate.tabs[0])\" ng-click=\"emailTemplate.fnChangeTab(emailTemplate.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"emailTemplate.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in emailTemplate.tabs track by $index\" select=\"emailTemplate.fnTabChanged(tab)\" ng-click=\"emailTemplate.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"emailTemplate.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();emailTemplate.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"emailTemplate.fnGetEmailTemplateDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!emailTemplate.isFullWidthDevice\"><a ng-click=\"emailTemplate.fnGetEmailTemplateStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"emailTemplate.isFullWidthDevice\"><a ng-click=\"emailTemplate.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{emailTemplate.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"emailTemplate.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"emailTemplate.isFullWidthDevice && emailTemplate.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'emailTemplate\'\" service-name=\"\'EmailTemplate\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"emailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"emailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"emailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"emailTemplate.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"emailTemplate.searchFiltersArr\" filter-query=\"emailTemplate.filterQuery\" fn-filter-query-change=\"emailTemplate.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.emailTemplate\'\" fn-resize=\"emailTemplate.fnSetTableHeight()\" sort-field-arr=\"emailTemplate.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"emailTemplate.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"emailTemplate.isEmailTemplatesloading\" fn-resize=\"emailTemplate.fnSetLoaderTableHeight()\"></table-loader><div class=\"email-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!emailTemplate.isEmailTemplatesloading\"><thead><tr><th ng-if=\"emailTemplate.emailTemplateArr.length\" class=\"p-8\"></th><th ng-if=\"emailTemplate.emailTemplateArr.length\"><span>Name</span></th><th ng-if=\"emailTemplate.emailTemplateArr.length\"></th><th ng-if=\"!emailTemplate.emailTemplateArr.length\">No records found...</th></tr></thead><tbody id=\"emailTable\"><tr ng-repeat=\"emailTemplateObj in emailTemplate.emailTemplateArr track by $index\" ng-click=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"emailTemplateObj.isCheck\" ng-change=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"emailTemplateObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': emailTemplate.isDropUp }\" ng-click=\"$event.stopPropagation(); emailTemplate.toggleDropUp(\'emailTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!emailTemplate.isEmailTemplatesloading && emailTemplate.emailTemplateArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{emailTemplate.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 10; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 20; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 50; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 100; emailTemplate.fnPageChanged(emailTemplate.currentPage,emailTemplate.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"emailTemplate.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"emailTemplate.currentPage\" items-per-page=\"emailTemplate.perPage\" max-size=\"emailTemplate.maxSize\" boundary-links=\"true\" ng-click=\"emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{emailTemplate.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : emailTemplate.isRefresh}\" ng-click=\"emailTemplate.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite EmailTemplate</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && emailTemplate.selectedEmailTemplatesArr.length === 1 && emailTemplate.selectedEmailTemplateObj && emailTemplate.isEmailTemplateDetailsLoaded && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><email-template-info email-template-obj=\"emailTemplate.selectedEmailTemplateObj\" user-permissions-obj=\"emailTemplate.permissionObj\"></email-template-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Emails</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use></svg><div class=\"user-text-div\">Select an Email</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Modify the template to suite your business</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/edit.svg#editIcon\"></use></svg></div><div class=\"position-r\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/email.svg#Capa_1\"></use></svg><div class=\"password-text-div m-t-15\" style=\"right: -40px\">System emails will be sent using your template</div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create federations from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create federations from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Emails</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Emails are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize emails</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'emailTemplate\'\" service-name=\"\'Emails\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"emailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"emailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"emailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-display-name=\"\'Emails\'\" service-name=\"\'emailTemplate\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'emailTemplate\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/federation/federations.html","<div class=\"row h-100\" ng-init=\"federations.fnInitFederations()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"federations.activeTabIndex\"><uib-tab index=\"1\" select=\"federations.fnTabChanged(federations.tabs[0])\" ng-click=\"federations.fnChangeTab(federations.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"federations.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in federations.tabs track by $index\" select=\"federations.fnTabChanged(tab)\" ng-click=\"federations.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"federations.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();federations.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"federations.fnGetFederationDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!federations.isFullWidthDevice\"><a ng-click=\"federations.fnGetFederationStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"federations.isFullWidthDevice\"><a ng-click=\"federations.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{federations.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"federations.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"federations.isFullWidthDevice && federations.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'federation\'\" service-name=\"\'Federation\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"federations.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"federations.fnGetWidgetEditor()\" fn-hide-chart=\"federations.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"federations.isRefreshData\" search-identifier=\"\'federationSearch\'\" filters-arr=\"federations.searchFiltersArr\" filter-query=\"federations.filterQuery\" fn-filter-query-change=\"federations.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.federations\'\" fn-resize=\"federations.fnSetTableHeight()\" sort-field-arr=\"federations.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"federations.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"federations.isShowInsightOption()\"><a ng-click=\"federations.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"federations.getFederationCSVData()\" id=\"csvAnchor\" csv-header=\"federations.csvHeaderArr\" filename=\"federations.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"federations.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"federations.isFederationsLoading\" fn-resize=\"federations.fnSetLoaderTableHeight()\"></table-loader><div class=\"federations-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!federations.isFederationsLoading\"><thead><tr><th ng-if=\"federations.federationsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"federations.isAllChecked\" ng-click=\"federations.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"federations.federationsArr.length\"></th><th ng-if=\"federations.federationsArr.length\"><span>Alias</span></th><th ng-if=\"federations.federationsArr.length\"></th><th ng-if=\"federations.federationsArr.length\"></th><th ng-if=\"federations.federationsArr.length\"></th><th ng-if=\"!federations.federationsArr.length\">No records found...</th></tr></thead><tbody id=\"federationsTable\"><tr ng-repeat=\"federation in federations.federationsArr track by $index\" ng-click=\"federations.fnCheckUncheckHeader(federation);\" context-menu=\"federations.federationContextMenu(federation)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"federation.isCheck\" ng-change=\"federations.fnCheckUncheckHeader(federation)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" ng-if=\"federation.type === \'OUTBOUND\'\" height=\"20px\"><use xlink:href=\"assets/images/svg/outbound.svg#outbound\"></use></svg><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" ng-if=\"federation.type === \'INBOUND\'\" height=\"20px\"><use xlink:href=\"assets/images/svg/inbound.svg#inbound\"></use></svg></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!federation.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{federation.alias}}</label> <span class=\"ellipsis DescriptionText span_des\">{{federation.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"federation.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"federation.alias\" placeholder=\"Alias for the Federation*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Alias*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"federation.description\" placeholder=\"Description regarding Federation\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();federations.fnCancelFederationEditMode(federation)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!federation.alias.length\" ng-click=\"$event.stopPropagation();federations.fnSaveFederationInfo(federation)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!federation.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{federation.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"federation.createdAt\"><label class=\"ellipsis m-b-0\">Created {{federation.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{federation.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"federation.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des\" ng-if=\"federation.createdBy\">by {{federation.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!federation.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{federation.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"federation.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{federation.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{federation.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"federation.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des\" ng-if=\"federation.updatedBy\">by {{federation.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!federation.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': federations.isDropUp }\" ng-click=\"$event.stopPropagation(); federations.toggleDropUp(\'federationsTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"federations.fnOpenFederationsInfoTab(federation,1)\">Details</a></li><li ng-if=\"federation.type !== \'OUTBOUND\'\"><a ng-click=\"federations.fnOpenFederationsInfoTab(federation,2)\">S4</a></li><li ng-if=\"federation.type === \'OUTBOUND\'\"><a ng-click=\"federations.fnOpenFederationsInfoTab(federation,2)\">Teams</a></li><li><a ng-click=\"federations.fnOpenFederationsInfoTab(federation,3)\">Tags</a></li><li><a ng-click=\"federations.fnCopyId(federation.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!federations.isFederationsLoading && federations.federationsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{federations.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"federations.perPage = 10; federations.fnPageChanged(federations.currentPage, federations.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"federations.perPage = 20; federations.fnPageChanged(federations.currentPage, federations.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"federations.perPage = 50; federations.fnPageChanged(federations.currentPage, federations.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"federations.perPage = 100; federations.fnPageChanged(federations.currentPage,federations.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"federations.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"federations.currentPage\" items-per-page=\"federations.perPage\" max-size=\"federations.maxSize\" boundary-links=\"true\" ng-click=\"federations.fnPageChanged(federations.currentPage, federations.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{federations.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : federations.isRefresh}\" ng-click=\"federations.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"federations.permissionsObj.CREATE_FEDERATION\" ng-click=\"federations.fnHideShowCreateForm()\">Create Federation</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && federations.selectedFederationsArr.length === 1 && federations.selectedfederationObj && federations.isFederationDetailsLoaded && !federations.isCreate && !federations.isShowDashboard && !federations.isShowFederationStats && !federations.isShowWidgetEditor && !federations.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><federation-info federation-obj=\"federations.selectedfederationObj\" user-permissions-obj=\"federations.permissionsObj\"></federation-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && federations.isCreate && !federations.isShowDashboard && !federations.isShowFederationStats && !federations.isShowWidgetEditor && !federations.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/access/federation/createFederation/createFederation.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && federations.isShowDashboard && !federations.isCreate && !federations.isShowFederationStats && !federations.isShowWidgetEditor && !federations.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Federations</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select \'Create Federation\' and give it an alias</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Enter the account ID you want to give access of your account</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets\\images\\svg\\service\\building.svg#account_1\"></use></svg></div><div class=\"position-r\" id=\"password\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10 m-b-5\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/service/script.svg#script\"></use></svg><div class=\"password-text-div\">Use the Federation S4 to define who can use the federation and what permissions they have in your account</div></div><div class=\"\" id=\"login\" style=\"position: relative;\"><div class=\"login-text-div\" style=\"bottom: 45px\">Users from the target account can see shared resources in your account</div><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"45px\" height=\"45px\"><use xlink:href=\"assets/images/svg/service/handshake.svg#fed\"></use></svg></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create federations from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create federations from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Federations are real people that are members of your account. To create a federation, select Create Federation.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"federations.fnHideShowCreateForm()\">Create Federation</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Federations are free in your account.You can Create as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to federations</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add federations to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how federations sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && !federations.isShowDashboard && !federations.isCreate && federations.isShowFederationStats && !federations.isShowWidgetEditor && !federations.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'federation\'\" service-name=\"\'Federation\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"federations.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"federations.fnGetWidgetEditor()\" fn-hide-chart=\"federations.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && !federations.isShowDashboard && !federations.isCreate && !federations.isShowFederationStats && federations.isShowWidgetEditor && !federations.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-name=\"\'federation\'\" service-display-name=\"\'Federation\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"federations.activeTabIndex !== 1 && !federations.isShowDashboard && !federations.isCreate && !federations.isShowFederationStats && !federations.isShowWidgetEditor && federations.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'federation\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/script/scripts.html","<div class=\"row h-100\" ng-init=\"scripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"scripts.activeTabIndex\"><uib-tab index=\"1\" select=\"scripts.fnTabChanged(scripts.tabs[0])\" ng-click=\"scripts.fnChangeTab(scripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"scripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in scripts.tabs track by $index\" select=\"scripts.fnTabChanged(tab)\" ng-click=\"scripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"scripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();scripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"scripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!scripts.isFullWidthDevice\"><a ng-click=\"scripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"scripts.isFullWidthDevice\"><a ng-click=\"scripts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{scripts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"scripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"scripts.isFullWidthDevice && scripts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"scripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"scripts.fnGetWidgetEditor()\" fn-hide-chart=\"scripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"scripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"scripts.searchFiltersArr\" filter-query=\"scripts.filterQuery\" fn-filter-query-change=\"scripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.scripts\'\" fn-resize=\"scripts.fnSetTableHeight()\" sort-field-arr=\"scripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"scripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"scripts.isScriptsloading\" fn-resize=\"scripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!scripts.isScriptsloading\"><thead><tr><th ng-if=\"scripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"scripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"scripts.scriptArr.length\"></th><th ng-if=\"!scripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in scripts.scriptArr track by $index\" ng-click=\"scripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"scripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': scripts.isDropUp }\" ng-click=\"$event.stopPropagation(); scripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"scripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!scripts.isScriptsloading && scripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{scripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 10; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 20; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 50; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 100; scripts.fnPageChanged(scripts.currentPage,scripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"scripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"scripts.currentPage\" items-per-page=\"scripts.perPage\" max-size=\"scripts.maxSize\" boundary-links=\"true\" ng-click=\"scripts.fnPageChanged(scripts.currentPage, scripts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{scripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : scripts.isRefresh}\" ng-click=\"scripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && scripts.selectedScriptsArr.length === 1 && scripts.selectedScriptObj && scripts.isScriptDetailsLoaded && !scripts.isShowDashboard && !scripts.isShowScriptStats && !scripts.isShowWidgetEditor && !scripts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><script-info script-obj=\"scripts.selectedScriptObj\" user-permissions-obj=\"scripts.permissionsObj\"></script-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && scripts.isShowDashboard && !scripts.isShowScriptStats && !scripts.isShowWidgetEditor && !scripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && !scripts.isShowDashboard && scripts.isShowScriptStats && !scripts.isShowWidgetEditor && !scripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"scripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"scripts.fnGetWidgetEditor()\" fn-hide-chart=\"scripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && !scripts.isShowDashboard && !scripts.isShowScriptStats && scripts.isShowWidgetEditor && !scripts.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-display-name=\"\'S4\'\" service-name=\"\'s4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && !scripts.isShowDashboard && !scripts.isShowScriptStats && !scripts.isShowWidgetEditor && scripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'s4\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/team/teams.html","<div class=\"row h-100\" ng-init=\"teams.fnInitTeams()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"teams.activeTabIndex\"><uib-tab index=\"1\" select=\"teams.fnTabChanged(teams.tabs[0])\" ng-click=\"teams.fnChangeTab(teams.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"teams.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" ng-repeat=\"tab in teams.tabs track by $index\" index=\"tab.tabIndex\" select=\"teams.fnTabChanged(tab)\" ng-click=\"teams.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"teams.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();teams.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"teams.fnGetTeamDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!teams.isFullWidthDevice\"><a ng-click=\"teams.fnGetTeamStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"teams.isFullWidthDevice\"><a ng-click=\"teams.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{teams.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"teams.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"teams.isFullWidthDevice && teams.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'team\'\" service-name=\"\'Team\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"teams.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"teams.fnGetWidgetEditor()\" fn-hide-chart=\"teams.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"teams.isRefreshData\" search-identifier=\"\'teamSearch\'\" filters-arr=\"teams.searchFiltersArr\" filter-query=\"teams.filterQuery\" fn-filter-query-change=\"teams.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.teams\'\" fn-resize=\"teams.fnSetTableHeight()\" sort-field-arr=\"teams.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"teams.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"teams.selectedTeamsArr.length\"><a ng-click=\"teams.fnDeleteMultipleTeams(teams.selectedTeamsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"teams.isShowInsightOption()\"><a ng-click=\"teams.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"teams.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"teams.csvHeaderArr\" filename=\"teams.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"teams.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"teams.isTeamsLoading\" fn-resize=\"teams.fnSetLoaderTableHeight()\"></table-loader><div class=\"user-groups-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-if=\"!teams.isTeamsLoading\"><thead><tr><th ng-if=\"teams.teamsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"teams.isAllChecked\" ng-click=\"teams.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"teams.teamsArr.length\"><span>Name</span></th><th ng-if=\"teams.teamsArr.length\"></th><th ng-if=\"teams.teamsArr.length\"></th><th ng-if=\"teams.teamsArr.length\"></th><th ng-if=\"!teams.teamsArr.length\">No records found...</th></tr></thead><tbody id=\"teamTable\"><tr ng-repeat=\"team in teams.teamsArr track by $index\" ng-click=\"teams.fnCheckUncheckHeader(team);\" context-menu=\"teams.teamContextMenu(team)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"team.isCheck\" ng-change=\"teams.fnCheckUncheckHeader(team)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!team.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{team.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{team.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"team.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"team.name\" placeholder=\"Name for the Team*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"team.description\" placeholder=\"Description regarding Team\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();teams.fnCancelTeamEditMode(team)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!team.name.length\" ng-click=\"$event.stopPropagation();teams.fnSaveTeamInfo(team)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!team.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{team.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"team.createdAt\"><label class=\"ellipsis m-b-0\">Created {{team.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{team.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"team.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{team.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!team.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{team.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"team.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{team.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{team.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"team.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{team.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!team.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': teams.isDropUp }\" ng-click=\"$event.stopPropagation(); teams.toggleDropUp(\'teamTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"teams.fnOpenTeamInfoTab(team,1)\">Details</a></li><li><a ng-click=\"teams.fnOpenTeamInfoTab(team,2)\">Resources</a></li><li><a ng-click=\"teams.fnOpenTeamInfoTab(team,3)\">Users</a></li><li><a ng-click=\"teams.fnOpenTeamInfoTab(team,4)\">Tags</a></li><li><a ng-click=\"teams.fnCopyId(team.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!teams.isTeamsLoading && teams.teamsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{teams.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"teams.perPage = 10; teams.fnPageChanged(teams.currentPage, teams.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"teams.perPage = 20; teams.fnPageChanged(teams.currentPage, teams.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"teams.perPage = 50; teams.fnPageChanged(teams.currentPage, teams.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"teams.perPage = 100; teams.fnPageChanged(teams.currentPage,teams.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"teams.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"teams.currentPage\" items-per-page=\"teams.perPage\" max-size=\"teams.maxSize\" boundary-links=\"true\" ng-click=\"teams.fnPageChanged(teams.currentPage, teams.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{teams.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : teams.isRefresh}\" ng-click=\"teams.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"teams.permissionObj.CREATE_TEAM\" ng-click=\"teams.fnHideShowCreateForm()\">Create Team</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && teams.selectedTeamObj && teams.isTeamDetailsLoaded && !teams.isCreate && !teams.isShowDashboard && !teams.isShowTeamStats && !teams.isShowWidgetEditor && !teams.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><team-info team-obj=\"teams.selectedTeamObj\" user-permission-obj=\"teams.permissionObj\"></team-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && teams.isCreate && !teams.isShowDashboard && !teams.isShowTeamStats && !teams.isShowWidgetEditor && !teams.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/access/team/createTeam/createTeam.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && teams.isShowDashboard && !teams.isCreate && !teams.isShowTeamStats && !teams.isShowWidgetEditor && !teams.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Teams</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select Create Team and give it a name</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Add users</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"position-r\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/productivity.svg#productivity\"></use></svg><div class=\"password-text-div m-t-15\" style=\"right: -40px\">Assign resources. These are the services and functions that the team has access to</div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can invite teams from within your organisation to manage and share resources and responsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can invite teams from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can invite them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Team. To create a team, select Create Team.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"teams.fnHideShowCreateForm()\">Create Team</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Teams are free in your account. You can create as many teams as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Teams</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && !teams.isShowDashboard && !teams.isCreate && teams.isShowTeamStats && !teams.isShowWidgetEditor && !teams.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'team\'\" service-name=\"\'Team\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"teams.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"teams.fnGetWidgetEditor()\" fn-hide-chart=\"teams.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && !teams.isShowDashboard && !teams.isCreate && !teams.isShowTeamStats && teams.isShowWidgetEditor && !teams.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-name=\"\'team\'\" service-display-name=\"\'Team\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"teams.activeTabIndex !== 1 && !teams.isShowDashboard && !teams.isCreate && !teams.isShowTeamStats && !teams.isShowWidgetEditor && teams.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'team\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/users/users.html","<div class=\"row h-100\" ng-init=\"users.fnInitUsers()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"1\" select=\"users.fnTabChanged(users.tabs[0])\" ng-click=\"users.fnChangeTab(users.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"users.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" ng-repeat=\"tab in users.tabs track by $index\" index=\"tab.tabIndex\" select=\"users.fnTabChanged(tab)\" ng-click=\"users.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"users.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();users.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"users.fnGetUserDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!users.isFullWidthDevice\"><a ng-click=\"users.fnGetUserStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"users.isFullWidthDevice\"><a ng-click=\"users.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{users.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"users.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"users.isFullWidthDevice && users.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'user\'\" service-name=\"\'User\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"users.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"users.fnGetWidgetEditor()\" fn-hide-chart=\"users.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"users.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"users.searchFiltersArr\" filter-query=\"users.filterQuery\" fn-filter-query-change=\"users.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.users\'\" fn-resize=\"users.fnSetTableHeight()\" sort-field-arr=\"users.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"users.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"users.isShowInsightOption()\"><a ng-click=\"users.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"users.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"users.csvHeaderArr\" filename=\"users.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"users.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"users.isUsersloading\" fn-resize=\"users.fnSetLoaderTableHeight()\"></table-loader><div class=\"users-details-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!users.isUsersloading\"><thead><tr><th ng-if=\"users.userArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"users.isAllChecked\" ng-click=\"users.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"users.userArr.length\"></th><th ng-if=\"users.userArr.length\"><span>Name</span></th><th ng-if=\"users.userArr.length\"></th><th ng-if=\"users.userArr.length\"></th><th ng-if=\"users.userArr.length\"></th><th ng-if=\"!users.userArr.length\">No records found...</th></tr></thead><tbody id=\"userTable\"><tr ng-repeat=\"user in users.userArr track by $index\" ng-click=\"users.fnCheckUncheckHeader(user);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"user.isCheck\" ng-change=\"users.fnCheckUncheckHeader(user)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" ui-sref=\"main.user({id:user.id})\" height=\"30\" width=\"30\" ng-src=\"{{users.fnReturnUserImg(user)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"user.firstName + \' \' +user.lastName\" style=\"width: fit-content !important;\"></label></div><span class=\"ellipsis\" style=\"display: block;\"><span class=\"DescriptionText font-italic\" ng-bind=\"user.username\"></span> <span style=\"\" class=\"userDiscDot m-l-5\" ng-hide=\"!user.email\">&bull;</span> <span class=\"DescriptionText p-l-5\" ng-bind=\"user.email\"></span></span></td><td><span class=\"ellipsis font-italic\">{{user.bio}}</span></td><td><div class=\"d-flex align-items-center justify-content-center\"><div ng-if=\"user.administrator\" class=\"d-flex\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" viewbox=\"0 0 511.999 511.999\" width=\"20\" height=\"20\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div><div ng-if=\"user.accountOwner\" class=\"d-flex\" uib-tooltip=\"Account Owner\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/account_owner.svg#acc_owner\"></use></svg></div><div ng-if=\"user.billingManager\" class=\"d-flex\" uib-tooltip=\"Billing Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" viewbox=\"0 0 487.565 487.565\" width=\"20\" height=\"20\"><g><g><path d=\"M115.171,183.665c4,25.7,23.7,58.3,56.2,69.7c13.3,4.7,28,4.7,41.3-0.1c32-11.5,52.4-44,56.4-69.6c4.3-0.3,10-6.4,16.1-28 c8.3-29.5-0.5-33.9-8-33.2c1.4-4.1,2.5-8.1,3.2-12.1c12.7-76.4-24.9-79.1-24.9-79.1s-6.2-12-22.7-21.1c-11-6.5-26.3-11.6-46.5-9.8 c-6.5,0.3-12.7,1.6-18.5,3.5l0,0c-7.4,2.5-14.2,6.2-20.4,10.4c-7.6,4.8-14.7,10.6-21,17.3c-10,10.2-18.8,23.3-22.7,39.8 c-3.2,12.3-2.5,25.1,0.2,38.8l0,0c0.7,4,1.8,8.1,3.2,12.1c-7.5-0.7-16.4,3.6-8,33.2 C105.171,177.265,110.871,183.365,115.171,183.665z\"></path><path d=\"M192.971,281.065L192.971,281.065h-0.1h-0.1h-0.1h-0.1l0,0c-6.6,0-44.8,2.4-9.3,52l-1.5,4.3c3.4-0.9,6.9-1.4,10.5-1.4 c4,0,8,0.6,11.7,1.7l-1.6-4.7C237.771,283.565,199.571,281.165,192.971,281.065z\"></path><path d=\"M225.471,352.665l11.5,11.5l45.6,45.6l32.6-32.6l13-13l5.3-5.3l34.4-34.4c-6.3-17.2-17.8-29.2-39.2-37 c-44.8-17.1-71.6-34.6-71.6-34.6L225.471,352.665z\"></path><path d=\"M128.571,252.965c0,0-26.8,17.5-71.6,34.6c-49.3,17.9-46.3,58.5-47.3,134.6h79.8l70.4-70.4L128.571,252.965z\"></path><path d=\"M341.171,228.965c6.9,3.3,14.3,5.1,21.8,6.3c5.9,0.9,6.1,1.2,6.2,7.3c0,2.8,0,5.6,0.1,8.3c0,3.5,1.7,5.5,5.3,5.6 c4.1,0.1,8.2,0.1,12.3,0c3.3-0.1,5.1-1.9,5.1-5.3c0-3.8,0.2-7.6,0-11.4c-0.2-3.9,1.5-5.8,5.2-6.8c8.5-2.3,15.8-6.9,21.5-13.8 c15.5-18.9,9.6-46.6-12.5-58.8c-6.9-3.8-14.3-6.7-21.6-9.8c-4.2-1.7-8.3-3.8-11.8-6.6c-7-5.6-5.7-14.7,2.6-18.3 c2.3-1,4.8-1.3,7.3-1.5c9.5-0.5,18.6,1.2,27.2,5.4c4.3,2.1,5.7,1.4,7.2-3c1.5-4.7,2.8-9.5,4.2-14.3c0.9-3.2-0.2-5.3-3.3-6.7 c-5.5-2.4-11.2-4.2-17.2-5.1c-7.8-1.2-7.8-1.3-7.8-9.1c0-11.1,0-11.1-11.1-11c-1.6,0-3.2,0-4.8,0c-5.2,0.2-6.1,1-6.2,6.3 c-0.1,2.3,0,4.7,0,7c0,6.9-0.1,6.8-6.7,9.2c-16,5.8-25.9,16.7-27,34.2c-0.9,15.5,7.1,25.9,19.8,33.5c7.8,4.7,16.5,7.5,24.8,11.1 c3.2,1.4,6.3,3.1,9,5.3c8,6.6,6.5,17.6-3,21.7c-5.1,2.2-10.4,2.8-15.9,2.1c-8.5-1.1-16.6-3.3-24.2-7.3c-4.5-2.3-5.8-1.7-7.3,3.1 c-1.3,4.2-2.5,8.4-3.6,12.6C335.171,224.965,335.671,226.265,341.171,228.965z\"></path><path d=\"M469.371,275.265c-0.3,0-0.6,0-1,0c-21.4,1-42.8,2-64.1,3c-3.3,0.2-6.6,0.3-8.4,4.3s0.3,6.2,2.5,8.5 c6.6,6.6,13,13.2,19.7,19.7l-7.3,7.3l-59.2,59.2l-5.3,5.3l-13,13l-50.9,50.9l-3-3l-60.9-60.9l-13-13l-3.5-3.5 c-2.8-2.8-6.4-4.1-10-4.1s-7.2,1.4-10,4.1l-3.5,3.5l-73.9,73.9c-5.5,5.5-5.5,14.4,0,20l3.5,3.5c2.8,2.8,6.4,4.1,10,4.1 s7.2-1.4,10-4.1l63.9-63.9l3,3l60.9,60.9l13,13l3.5,3.5c2.8,2.8,6.4,4.1,10,4.1s7.2-1.4,10-4.1l3.5-3.5l60.9-60.9l13-13l5.3-5.3 l59.2-59.2l7.2-7.2l19.3,19.2c1.8,1.8,3.6,3.7,6.1,3.7c0.9,0,2-0.3,3.2-0.9c3.9-2.1,4.7-5.5,4.9-9.3c0.9-20.9,1.9-41.7,2.9-62.6 C478.171,278.065,475.571,275.265,469.371,275.265z\"></path></g></g></svg></div><div ng-if=\"user.trackerManager\" class=\"d-flex p-2\" uib-tooltip=\"Tracker Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/managerType/tracker_manager.svg#tracker\"></use></svg></div><div ng-if=\"user.nodeManager\" class=\"d-flex p-2\" uib-tooltip=\"Node Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/managerType/node_manager.svg#node\"></use></svg></div><div ng-if=\"user.pipelineManager\" class=\"d-flex p-2\" uib-tooltip=\"Pipeline Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/managerType/pipeline_manager.svg#pipeline\"></use></svg></div><div ng-if=\"user.storageManager\" class=\"d-flex p-2\" uib-tooltip=\"Storage Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/managerType/storage_manager.svg#storage\"></use></svg></div><div ng-if=\"user.aiManager\" class=\"d-flex p-2\" uib-tooltip=\"AI Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20\" height=\"20\"><use xlink:href=\"assets/images/svg/managerType/ai_manager.svg#ai\"></use></svg></div></div></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" ng-if=\"user.state === \'SUSPENDED\' || user.state === \'ACTIVE\'\" uib-tooltip=\"{{user.state}}\" tooltip-placement=\"auto\" ng-style=\"users.getUserStateColor(user.state)\"><span class=\"fa stateIcon\" ng-class=\"users.fnGetUserStateIcon(user.state)\"></span></span> <span ng-if=\"user.state === \'UNCONFIRMED\'\"><small class=\"font-italic\" ng-if=\"!user.isResendEmaiDone\" ng-click=\"$event.stopPropagation(); users.resendUserActivationLink(user);\"><button class=\"btn btn-link p-0\" style=\"font-size: 12px\">Resend Email</button></small> <small class=\"font-italic\" ng-if=\"user.isResendEmaiDone\" ng-click=\"$event.stopPropagation();\"><button class=\"btn btn-link p-0\" style=\"font-size: 12px\">Sending...</button></small></span></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': users.isDropUp }\" ng-click=\"$event.stopPropagation(); users.toggleDropUp(\'userTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"users.fnOpenEditUserInfoTab(user)\">Edit</a></li><li ng-if=\"user.state === \'ACTIVE\'\" ng-click=\"user.state = \'SUSPENDED\';users.fnUpdateUserDetails(user, \'state\')\"><a class=\"btn btn-link\">Suspend</a></li><li ng-if=\"user.state === \'SUSPENDED\'\" ng-click=\"user.state = \'ACTIVE\';users.fnUpdateUserDetails(user, \'state\')\"><a class=\"btn btn-link\">Activate</a></li><li><a class=\"btn btn-link\" ng-click=\"users.fnOpenUserInfoTab(user,1);\">Details</a></li><li><a class=\"btn btn-link\" ng-click=\"users.fnOpenUserInfoTab(user,2);\">Teams</a></li><li><a ng-click=\"users.fnCopyId(user.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!users.isUsersloading && users.userArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{users.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"users.perPage = 10; users.fnPageChanged(users.currentPage, users.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"users.perPage = 20; users.fnPageChanged(users.currentPage, users.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"users.perPage = 50; users.fnPageChanged(users.currentPage, users.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"users.perPage = 100; users.fnPageChanged(users.currentPage,users.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"users.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"users.currentPage\" items-per-page=\"users.perPage\" max-size=\"users.maxSize\" boundary-links=\"true\" ng-click=\"users.fnPageChanged(users.currentPage, users.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{users.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : users.isRefresh}\" ng-click=\"users.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"users.permissionsObj.CREATE_USER\" ng-click=\"users.fnHideShowCreateForm()\">Invite User</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && users.selectedUsersArr.length === 1 && users.selectedUserObj && users.isUserDetailsLoaded && !users.isCreate && !users.isShowDashboard && !users.isShowUserStats && !users.isShowWidgetEditor && !users.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><user-info user-obj=\"users.selectedUserObj\" auth-user-obj=\"main.authUserObj\" user-permissions-obj=\"users.permissionsObj\"></user-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && users.isCreate && !users.isShowDashboard && !users.isShowUserStats && !users.isShowWidgetEditor && !users.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/access/users/createUser/createUser.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && users.isShowDashboard && !users.isCreate && !users.isShowUserStats && !users.isShowWidgetEditor && !users.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Users</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select Invite User and Enter their details</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">We will send them an email with a link</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/email.svg#Capa_1\"></use></svg></div><div class=\"position-r\" id=\"password\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"45px\" height=\"45px\"><use xlink:href=\"assets/images/svg/password.svg#Layer_1\"></use></svg><div class=\"password-text-div\">They use the link to set the password</div></div><div class=\"\" id=\"login\" style=\"position: relative;\"><div class=\"login-text-div\">Login at console.ecsmon.ecsiteapp.com</div><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"45px\" height=\"45px\"><use xlink:href=\"assets/images/svg/login.svg#Capa_1\"></use></svg></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can invite users from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can invite users from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can invite them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Users are real people that are members of your account. To create a user, select Invite User.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"users.fnHideShowCreateForm()\">Invite User</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Users are free in your account.You can invite as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && !users.isShowDashboard && !users.isCreate && users.isShowUserStats && !users.isShowWidgetEditor && !users.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'user\'\" service-name=\"\'User\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"users.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"users.fnGetWidgetEditor()\" fn-hide-chart=\"users.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && !users.isShowDashboard && !users.isCreate && !users.isShowUserStats && users.isShowWidgetEditor && !users.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-display-name=\"\'User\'\" service-name=\"\'user\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && !users.isShowDashboard && !users.isCreate && !users.isShowUserStats && !users.isShowWidgetEditor && users.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'user\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/vault/vaults.html","<div class=\"row h-100\" ng-init=\"vaults.fnInitVaults()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"vaults.activeTabIndex\"><uib-tab index=\"1\" select=\"vaults.fnTabChanged(vaults.tabs[0])\" ng-click=\"vaults.fnChangeTab(vaults.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"vaults.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in vaults.tabs track by $index\" select=\"vaults.fnTabChanged(tab)\" ng-click=\"vaults.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"vaults.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();vaults.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"vaults.fnGetVaultDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!vaults.isFullWidthDevice\"><a ng-click=\"vaults.fnGetVaultStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"vaults.isFullWidthDevice\"><a ng-click=\"vaults.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{vaults.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"vaults.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"vaults.isFullWidthDevice && vaults.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'vault\'\" service-name=\"\'Vault\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"vaults.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"vaults.fnGetWidgetEditor()\" fn-hide-chart=\"vaults.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"vaults.isRefreshData\" search-identifier=\"\'vaultSearch\'\" filters-arr=\"vaults.searchFiltersArr\" filter-query=\"vaults.filterQuery\" fn-filter-query-change=\"vaults.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.vaults\'\" fn-resize=\"vaults.fnSetTableHeight()\" sort-field-arr=\"vaults.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"vaults.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"vaults.isShowInsightOption()\"><a ng-click=\"vaults.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"vaults.getVaultCSVData()\" id=\"csvAnchor\" csv-header=\"vaults.csvHeaderArr\" filename=\"vaults.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"vaults.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"vaults.isVaultsLoading\" fn-resize=\"vaults.fnSetLoaderTableHeight()\"></table-loader><div class=\"vaults-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!vaults.isVaultsLoading\"><thead><tr><th ng-if=\"vaults.vaultsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"vaults.isAllChecked\" ng-click=\"vaults.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"vaults.vaultsArr.length\"><span>Name</span></th><th ng-if=\"vaults.vaultsArr.length\"></th><th ng-if=\"vaults.teamsArr.length\"></th><th ng-if=\"vaults.teamsArr.length\"></th><th ng-if=\"!vaults.vaultsArr.length\">No records found...</th></tr></thead><tbody id=\"vaultsTable\"><tr ng-repeat=\"vault in vaults.vaultsArr track by $index\" ng-click=\"vaults.fnCheckUncheckHeader(vault);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"vault.isCheck\" ng-change=\"vaults.fnCheckUncheckHeader(vault)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"vault.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"vault.description\">Desc</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{vault.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"vault.createdAt\"><label class=\"ellipsis m-b-0\">Created {{vault.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{vault.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"vault.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{vault.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{vault.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"vault.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{vault.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{vault.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"vault.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{vault.updatedBy}}</span></small></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': vaults.isDropUp }\" ng-click=\"$event.stopPropagation(); vaults.toggleDropUp(\'vaultsTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"vaults.fnOpenVaultInfoTab(vault,1)\">Details</a></li><li><a ng-click=\"vaults.fnOpenVaultInfoTab(vault,2)\">Content</a></li><li><a ng-click=\"vaults.fnOpenVaultInfoTab(vault,3)\">Teams</a></li><li><a ng-click=\"vaults.fnOpenVaultInfoTab(vault,4)\">Tags</a></li><li><a ng-click=\"vaults.fnCopyId(vault.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!vaults.isVaultsLoading && vaults.vaultsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{vaults.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"vaults.perPage = 10; vaults.fnPageChanged(vaults.currentPage, vaults.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"vaults.perPage = 20; vaults.fnPageChanged(vaults.currentPage, vaults.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"vaults.perPage = 50; vaults.fnPageChanged(vaults.currentPage, vaults.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"vaults.perPage = 100; vaults.fnPageChanged(vaults.currentPage,vaults.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"vaults.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"vaults.currentPage\" items-per-page=\"vaults.perPage\" max-size=\"vaults.maxSize\" boundary-links=\"true\" ng-click=\"vaults.fnPageChanged(vaults.currentPage, vaults.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-0\">Total: {{vaults.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : vaults.isRefresh}\" ng-click=\"vaults.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"vaults.permissionObj.CREATE_VAULT\"><button class=\"btn btn-primary v4-primary-button\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\">Create Vault <i class=\"m-l-3 fa fa-caret-up\"></i></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"vaults.fnHideShowCreateForm()\"><a class=\"btn btn-link\">Create Vault from scratch</a></li><li ng-click=\"vaults.fnHideShowCreateForm(true, \'auth\')\"><a class=\"btn btn-link\">Create Vault for authenticator</a></li><li ng-click=\"vaults.fnHideShowCreateForm(true, \'node\')\"><a class=\"btn btn-link\">Create Vault for Node</a></li></ul></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && vaults.selectedVaultsArr.length === 1 && vaults.selectedVaultObj && vaults.isVaultDetailsLoaded && !vaults.isCreate && !vaults.isShowDashboard && !vaults.isShowVaultStats && !vaults.isShowWidgetEditor && !vaults.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><vault-info vault-obj=\"vaults.selectedVaultObj\" user-permissions-obj=\"vaults.permissionObj\"></vault-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && vaults.isCreate && !vaults.isShowDashboard && !vaults.isShowVaultStats && !vaults.isShowWidgetEditor && !vaults.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include ng-if=\"!vaults.isCreateFromType && !vaults.isCreateFromAuthenticator && !vaults.isCreateFromNode\" src=\"\'app/access/vault/createVault/createVault.html\'\"></ng-include><ng-include ng-if=\"vaults.isCreateFromAuthenticator\" src=\"\'app/access/vault/createVault/createVaultFromAuthenticator/createVaultFromAuthenticator.html\'\"></ng-include><ng-include ng-if=\"vaults.isCreateFromNode\" src=\"\'app/access/vault/createVault/createVaultFromNode/createVaultFromNode.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && vaults.isShowDashboard && !vaults.isCreate && !vaults.isShowVaultStats && !vaults.isShowWidgetEditor && !vaults.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Vaults</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/dashboard_create_user.svg#create_user\"></use></svg><div class=\"user-text-div\">Select \'Create Vault\' and give it a name</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Add your secret information such as credentials</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/account_owner.svg#acc_owner\"></use></svg></div><div class=\"position-r\" id=\"password\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10 m-b-10\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg><div class=\"password-text-div\">Assign the vault to a team</div></div><div class=\"\" id=\"login\" style=\"position: relative;\"><div class=\"login-text-div\">Team members can use but not view the vault content</div><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"45px\" height=\"45px\"><use xlink:href=\"assets/images/svg/vault.svg#Layer_1\"></use></svg></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create vaults from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create vaults from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Vaults are real people that are members of your account. To create a vault, select Create Vault.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"vaults.fnHideShowCreateForm()\">Create Vault</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Vaults are free in your account.You can Create as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to vaults</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add vaults to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how vaults sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && !vaults.isShowDashboard && !vaults.isCreate && vaults.isShowVaultStats && !vaults.isShowWidgetEditor && !vaults.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'access\'\" service-key=\"\'vault\'\" service-name=\"\'Vault\'\" app-name=\"\'Access\'\" fn-get-chart-detail=\"vaults.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"vaults.fnGetWidgetEditor()\" fn-hide-chart=\"vaults.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && !vaults.isShowDashboard && !vaults.isCreate && !vaults.isShowVaultStats && vaults.isShowWidgetEditor && !vaults.isCreateIssue\"><widget-editor app-name=\"\'access\'\" service-name=\"\'vault\'\" service-display-name=\"\'Vault\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"vaults.activeTabIndex !== 1 && !vaults.isShowDashboard && !vaults.isCreate && !vaults.isShowVaultStats && !vaults.isShowWidgetEditor && vaults.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'access\'\" service-key=\"\'vault\'\" app-name=\"\'Access\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/ai/deployment/deployment.html","<div class=\"row h-100\" ng-init=\"deployment.fnInitDeployment()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"deployment.deploymentPermissionObj.List\" field-arr=\"deployment.searchFieldArr\" filter-query=\"deployment.filterQuery\" state-name=\"\'main.deployment\'\" fn-filter-query-change=\"deployment.fnFilterQueryChanged(filterQuery)\" fn-resize=\"deployment.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"deployment.deploymentPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"deployment.isDeploymentsLoading\" fn-resize=\"deployment.fnSetLoaderTableHeight()\"></table-loader><div class=\"deployments-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!deployment.isDeploymentsLoading\"><thead><tr><th ng-if=\"deployment.deploymentsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"deployment.isAllChecked\" ng-click=\"deployment.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"deployment.deploymentsArr.length\"></th><th ng-if=\"deployment.deploymentsArr.length\"><span ng-click=\"deployment.fnDeploymentsSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"deployment.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"deployment.deploymentsArr.length\"></th><th ng-if=\"!deployment.deploymentsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"deploymentObj in deployment.deploymentsArr track by $index\" ng-click=\"deployment.fnGetDeployment(deploymentObj, deployment.deploymentsArr);\" context-menu=\"deployment.deploymentContextMenu(deploymentObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"deploymentObj.isCheck\" ng-change=\"deployment.fnCheckUncheckHeader(deploymentObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center\" ng-show=\"!deploymentObj.isEditable\"><span class=\"deploymentInfoIcon deploymentIconBorder\" uib-tooltip=\"{{deploymentObj.status}}\" tooltip-placement=\"auto\" ng-style=\"deployment.fnGetDeploymentStatusIconColor(deploymentObj.status)\"><span class=\"deploymentIcon fa\" ng-class=\"deployment.fnGetDeploymentStatusIcon(deploymentObj.status)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!deploymentObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{deploymentObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{deploymentObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"deploymentObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"deploymentObj.name\" placeholder=\"Name for the Deployment*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"deploymentObj.description\" placeholder=\"Description regarding Deployment\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();deployment.fnCancelDeploymentEditMode(deploymentObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!deploymentObj.name.length\" ng-click=\"$event.stopPropagation();deployment.fnSaveDeploymentInfo(deploymentObj)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!deploymentObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': deployment.isDropUp }\" ng-click=\"$event.stopPropagation(); deployment.toggleDropUp(\'modelTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"deployment.fnOpenDeploymentInfoTab(deploymentObj,1)\">Details</a></li><li><a ng-click=\"deployment.fnOpenDeploymentInfoTab(deploymentObj,2)\">Inference</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!deployment.isDeploymentsLoading && deployment.deploymentsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{deployment.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"deployment.perPage = 10; deployment.fnPageChanged(deployment.currentPage, deployment.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"deployment.perPage = 20; deployment.fnPageChanged(deployment.currentPage, deployment.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"deployment.perPage = 50; deployment.fnPageChanged(deployment.currentPage, deployment.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"deployment.perPage = 100; deployment.fnPageChanged(deployment.currentPage,deployment.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"deployment.perPage = 500; deployment.fnPageChanged(deployment.currentPage, deployment.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"deployment.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"deployment.currentPage\" items-per-page=\"deployment.perPage\" max-size=\"deployment.maxSize\" boundary-links=\"true\" ng-click=\"deployment.fnPageChanged(deployment.currentPage, deployment.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!deployment.deploymentPermissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"deployment.deploymentPermissionObj.List\"><label>Total: {{deployment.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : deployment.isRefresh}\" ng-click=\"deployment.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"deployment.deploymentPermissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"deployment.fnHideShowCreateForm()\">Create Deployment</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"deployment.selectedDeploymentsArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Deployments:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedDeployment in deployment.selectedDeploymentsArr\" is-open=\"selectedDeployment.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedDeployment.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); deployment.fnCheckUncheckHeader(selectedDeployment, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedDeployment.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedDeployment.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"deployment.selectedDeploymentsArr.length && deployment.deploymentPermissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"deployment.deploymentPermissionObj.Delete\" ng-click=\"deployment.fnDeleteMultipleDeployments(deployment.selectedDeploymentsArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!deployment.isCreate && !deployment.selectedDeploymentsArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-cloud-upload\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Deployment</label></div><div class=\"col-sm-12\" ng-if=\"deployment.deploymentPermissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"deployment.fnHideShowCreateForm()\">Create Deployment</button></div></div></div><div class=\"content-container form-container\" ng-if=\"deployment.isCreate && !deployment.selectedDeploymentsArr.length\"><ng-include src=\"\'app/ai/deployment/createDeployment/createDeployment.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\'miniSpinner\'\" ng-if=\"deployment.selectedDeploymentsArr.length === 1 && deployment.selectedDeploymentObj && !deployment.isDeploymentDetailsLoaded\"></div><div ng-if=\"deployment.selectedDeploymentsArr.length === 1 && deployment.selectedDeploymentObj && deployment.isDeploymentDetailsLoaded\"><deployment-info deployment-obj=\"deployment.selectedDeploymentObj\" deployment-permissions-obj=\"deployment.deploymentPermissionObj\"></deployment-info></div></div></div></div></div></div>");
$templateCache.put("app/ai/distribution/distribution.html","<div class=\"row h-100\" ng-init=\"distribution.fnInitDistribution()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"distribution.distributionPermissionObj.List\" field-arr=\"distribution.searchFieldArr\" filter-query=\"distribution.filterQuery\" state-name=\"\'main.distribution\'\" fn-filter-query-change=\"distribution.fnFilterQueryChanged(filterQuery)\" fn-resize=\"distribution.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"distribution.distributionPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"distribution.isDistributionsLoading\" fn-resize=\"distribution.fnSetLoaderTableHeight()\"></table-loader><div class=\"distributions-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!distribution.isDistributionsLoading\"><thead><tr><th ng-if=\"distribution.distributionsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"distribution.isAllChecked\" ng-click=\"distribution.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"distribution.distributionsArr.length\"><span ng-click=\"distribution.fnDistributionsSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"distribution.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"distribution.distributionsArr.length\"></th><th ng-if=\"!distribution.distributionsArr.length\">No records found...</th></tr></thead><tbody id=\"distributionTable\"><tr ng-repeat=\"distributionObj in distribution.distributionsArr track by $index\" ng-click=\"distribution.fnGetDistribution(distributionObj, distribution.distributionsArr);\" context-menu=\"distribution.distributionContextMenu(distributionObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"distributionObj.isCheck\" ng-change=\"distribution.fnCheckUncheckHeader(distributionObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!distributionObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{distributionObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{distributionObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"distributionObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"distributionObj.name\" placeholder=\"Name for the Distribution*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"distributionObj.description\" placeholder=\"Description regarding Distribution\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();distribution.fnCancelDistributionEditMode(distributionObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!distributionObj.name.length\" ng-click=\"$event.stopPropagation();distribution.fnSaveDistributionInfo(distributionObj)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!distributionObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': distribution.isDropUp }\" ng-click=\"$event.stopPropagation(); distribution.toggleDropUp(\'distributionTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"distribution.fnOpenDistributionObjInfoTab(distributionObj)\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!distribution.isDistributionsLoading && distribution.distributionsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{distribution.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"distribution.perPage = 10; distribution.fnPageChanged(distribution.currentPage, distribution.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"distribution.perPage = 20; distribution.fnPageChanged(distribution.currentPage, distribution.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"distribution.perPage = 50; distribution.fnPageChanged(distribution.currentPage, distribution.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"distribution.perPage = 100; distribution.fnPageChanged(distribution.currentPage,distribution.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"distribution.perPage = 500; distribution.fnPageChanged(distribution.currentPage, distribution.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"distribution.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"distribution.currentPage\" items-per-page=\"distribution.perPage\" max-size=\"distribution.maxSize\" boundary-links=\"true\" ng-click=\"distribution.fnPageChanged(distribution.currentPage, distribution.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!distribution.distributionPermissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"distribution.distributionPermissionObj.List\"><label>Total: {{distribution.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : distribution.isRefresh}\" ng-click=\"distribution.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"distribution.distributionPermissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"distribution.fnHideShowCreateForm()\">Create Distribution</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"distribution.selectedDistributionsArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Distributions:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedDistribution in distribution.selectedDistributionsArr\" is-open=\"selectedDistribution.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedDistribution.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); distribution.fnCheckUncheckHeader(selectedDistribution, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedDistribution.description\"><div class=\"col-xs-2\"><label>Distribution Description:</label></div><div class=\"col-xs-10\">{{selectedDistribution.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"distribution.selectedDistributionsArr.length && distribution.distributionPermissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"distribution.distributionPermissionObj.Delete\" ng-click=\"distribution.fnDeleteMultipleDistributions(distribution.selectedDistributionsArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!distribution.isCreate && !distribution.selectedDistributionsArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-share-alt\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Distribution</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-if=\"distribution.distributionPermissionObj.Create\" ng-click=\"distribution.fnHideShowCreateForm()\">Create Distribution</button></div></div></div><div class=\"form-container\" ng-if=\"distribution.isCreate && !distribution.selectedDistributionsArr.length\"><ng-include src=\"\'app/ai/distribution/createDistribution/createDistribution.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"distribution.selectedDistributionsArr.length === 1 && distribution.selectedDistributionObj && !distribution.isDistributionDetailsLoaded\"></div><div ng-if=\"distribution.selectedDistributionsArr.length === 1 && distribution.selectedDistributionObj && distribution.isDistributionDetailsLoaded\"><distribution-info distribution-obj=\"distribution.selectedDistributionObj\" distribution-permissions-obj=\"distribution.distributionPermissionObj\"></distribution-info></div></div></div></div></div></div>");
$templateCache.put("app/ai/model/model.html","<div class=\"row h-100\" ng-init=\"model.fnInitModel()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"model.modelPermissionObj.List\" field-arr=\"model.searchFieldArr\" filter-query=\"model.filterQuery\" state-name=\"\'main.model\'\" fn-filter-query-change=\"model.fnFilterQueryChanged(filterQuery)\" fn-resize=\"model.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"model.modelPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"model.isModelsLoading\" fn-resize=\"model.fnSetLoaderTableHeight()\"></table-loader><div class=\"models-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!model.isModelsLoading\"><thead><tr><th ng-if=\"model.modelsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"model.isAllChecked\" ng-click=\"model.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"model.modelsArr.length\"><span ng-click=\"model.fnModelsSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"model.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"model.modelsArr.length\"></th><th ng-if=\"!model.modelsArr.length\">No records found...</th></tr></thead><tbody id=\"modelTable\"><tr ng-repeat=\"modelObj in model.modelsArr track by $index\" ng-click=\"model.fnGetModel(modelObj, model.modelsArr);\" context-menu=\"model.modelContextMenu(modelObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"modelObj.isCheck\" ng-change=\"model.fnCheckUncheckHeader(modelObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!modelObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{modelObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{modelObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"modelObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"modelObj.name\" placeholder=\"Name for the Authenticator*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"modelObj.description\" placeholder=\"Description regarding Model\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();model.fnCancelModelEditMode(modelObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!modelObj.name.length\" ng-click=\"$event.stopPropagation();model.fnSaveModelInfo(modelObj)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!modelObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': model.isDropUp }\" ng-click=\"$event.stopPropagation(); model.toggleDropUp(\'modelTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"model.fnOpenAiModelInfoTab(modelObj)\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!model.isModelsLoading && model.modelsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{model.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"model.perPage = 10; model.fnPageChanged(trainer.currentPage, model.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"model.perPage = 20; model.fnPageChanged(trainer.currentPage, model.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"model.perPage = 50; model.fnPageChanged(model.currentPage, model.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"model.perPage = 100; model.fnPageChanged(model.currentPage,model.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"model.perPage = 500; model.fnPageChanged(model.currentPage, model.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"model.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"model.currentPage\" items-per-page=\"model.perPage\" max-size=\"model.maxSize\" boundary-links=\"true\" ng-click=\"model.fnPageChanged(model.currentPage, model.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!model.modelPermissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"model.modelPermissionObj.List\"><label>Total: {{model.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : model.isRefresh}\" ng-click=\"model.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right content-box-footerItem\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"model.modelPermissionObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Create Model<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"model.modelPermissionObj.Create\" ng-click=\"model.fnShowCreateForm()\"><a class=\"btn btn-link\">Create Model from scratch</a></li><li ng-show=\"model.modelPermissionObj.Create && model.trainerPermissionObj.List\" ng-click=\"model.fnShowCreateForm(true)\"><a class=\"btn btn-link\">Create Model from trainer</a></li></ul></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"model.selectedModelsArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Models:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedModel in model.selectedModelsArr\" is-open=\"selectedModel.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedModel.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); model.fnCheckUncheckHeader(selectedModel, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedModel.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedModel.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"model.selectedModelsArr.length && model.modelPermissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"model.modelPermissionObj.Delete\" ng-click=\"model.fnDeleteMultipleModels(model.selectedModelsArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!model.isCreate && !model.selectedModelsArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-codepen\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Model</label></div><div class=\"col-sm-12\" ng-if=\"model.modelPermissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"model.fnHideShowCreateForm()\">Create Model</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"model.modelPermissionObj.Create && model.trainerPermissionObj.List\">or</div><div class=\"col-sm-12\" ng-if=\"model.modelPermissionObj.Create && model.trainerPermissionObj.List\"><button class=\"btn btn-primary\" ng-click=\"model.fnHideShowCreateForm(true)\">Create Model from Trainer</button></div></div></div><div class=\"content-container form-container\" ng-if=\"model.isCreate && !model.selectedModelsArr.length && !model.isCreateFromTrainer\"><ng-include src=\"\'app/ai/model/createModel/createModel.html\'\"></ng-include></div><div class=\"content-container form-container\" ng-if=\"model.isCreate && !model.selectedModelsArr.length && model.isCreateFromTrainer\"><ng-include src=\"\'app/ai/model/createModel/createModelFromTrainer.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"model.selectedModelsArr.length === 1 && model.selectedModelObj && !model.isModelDetailsLoaded\"></div><div ng-if=\"model.selectedModelsArr.length === 1 && model.selectedModelObj && model.isModelDetailsLoaded\"><model-info model-obj=\"model.selectedModelObj\" model-permissions-obj=\"model.modelPermissionObj\"></model-info></div></div></div></div></div></div>");
$templateCache.put("app/ai/trainer/trainer.html","<div class=\"row h-100\" ng-init=\"trainer.fnInitTrainer()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"trainer.trainerPermissionObj.List\" field-arr=\"trainer.searchFieldArr\" filter-query=\"trainer.filterQuery\" state-name=\"\'main.trainer\'\" fn-filter-query-change=\"trainer.fnFilterQueryChanged(filterQuery)\" fn-resize=\"trainer.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"trainer.trainerPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"trainer.isTrainersLoading\" fn-resize=\"trainer.fnSetLoaderTableHeight()\"></table-loader><div class=\"trainers-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!trainer.isTrainersLoading\"><thead><tr><th ng-if=\"trainer.trainersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"trainer.isAllChecked\" ng-click=\"trainer.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"trainer.trainersArr.length\"></th><th ng-if=\"trainer.trainersArr.length\"><span ng-click=\"trainer.fnTrainersSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"trainer.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"trainer.trainersArr.length\"></th><th ng-if=\"!trainer.trainersArr.length\">No records found...</th></tr></thead><tbody id=\"trainerTable\"><tr ng-repeat=\"trainerObj in trainer.trainersArr track by $index\" ng-click=\"trainer.fnGetTrainer(trainerObj, trainer.trainersArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"trainerObj.isCheck\" ng-change=\"trainer.fnCheckUncheckHeader(trainerObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center\"><span class=\"trainersInfoIcon trainersIconBorder\" uib-tooltip=\"{{trainerObj.status}}\" tooltip-placement=\"auto\" ng-style=\"trainer.fnGetTrainerStatusIconColor(trainerObj.status)\"><span class=\"trainersIcon fa\" ng-class=\"trainer.fnGetTrainerStatusIcon(trainerObj.status)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{trainerObj.name}}</label> <span class=\"ellipsis font-italic\"><span class=\"DescriptionText span_des\">Training Duration:</span> <span class=\"DescriptionText span_des p-l-2\">{{trainerObj.durations}}</span></span></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': trainer.isDropUp }\" ng-click=\"$event.stopPropagation(); trainer.toggleDropUp(\'trainerTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"trainer.fnOpenTrainerInfoTab(trainerObj)\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!trainer.isTrainersLoading && trainer.trainersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{trainer.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"trainer.perPage = 10; trainer.fnPageChanged(trainer.currentPage, trainer.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"trainer.perPage = 20; trainer.fnPageChanged(trainer.currentPage, trainer.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"trainer.perPage = 50; trainer.fnPageChanged(trainer.currentPage, trainer.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"trainer.perPage = 100; trainer.fnPageChanged(trainer.currentPage,trainer.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"trainer.perPage = 500; trainer.fnPageChanged(trainer.currentPage, trainer.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"trainer.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"trainer.currentPage\" items-per-page=\"trainer.perPage\" max-size=\"trainer.maxSize\" boundary-links=\"true\" ng-click=\"trainer.fnPageChanged(trainer.currentPage, trainer.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!trainer.trainerPermissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"trainer.trainerPermissionObj.List\"><label>Total: {{trainer.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : trainer.isRefresh}\" ng-click=\"trainer.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"trainer.trainerPermissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"trainer.fnHideShowCreateForm()\">Create Trainer</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"trainer.selectedTrainersArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Trainers:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedTrainer in trainer.selectedTrainersArr\" is-open=\"selectedTrainer.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedTrainer.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); trainer.fnCheckUncheckHeader(selectedTrainer, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedTrainer.status\"><div class=\"col-xs-2\"><label>Status:</label></div><div class=\"col-xs-10\">{{selectedTrainer.status}}</div></div><div class=\"row\" ng-if=\"selectedTrainer.durations\"><div class=\"col-xs-2\"><label>Training duration:</label></div><div class=\"col-xs-10\">{{selectedTrainer.durations}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"trainer.selectedTrainersArr.length && trainer.trainerPermissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"trainer.trainerPermissionObj.Delete\" ng-click=\"trainer.fnDeleteMultipleTrainers(trainer.selectedTrainersArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!trainer.isCreate && !trainer.selectedTrainersArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-empire\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Trainer</label></div><div class=\"col-sm-12\" ng-if=\"trainer.trainerPermissionObj.Create\"><button class=\"btn btn-primary\" ng-if=\"trainer.trainerPermissionObj.Create\" ng-click=\"trainer.fnHideShowCreateForm()\">Create Trainer</button></div></div></div><div class=\"content-container form-container\" ng-if=\"trainer.isCreate && !trainer.selectedTrainersArr.length\"><ng-include src=\"\'app/ai/trainer/createTrainer/createTrainer.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"trainer.selectedTrainersArr.length === 1 && trainer.selectedTrainerObj && !trainer.isTrainerDetailsLoaded\"></div><div ng-if=\"trainer.selectedTrainersArr.length === 1 && trainer.selectedTrainerObj && trainer.isTrainerDetailsLoaded\"><trainer-info trainer-obj=\"trainer.selectedTrainerObj\" trainer-permissions-obj=\"trainer.trainerPermissionObj\"></trainer-info></div></div></div></div></div></div>");
$templateCache.put("app/billing/business/business.html","<div class=\"row h-100\" ng-init=\"business.fnInitBusiness()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in business.tabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/billing/credit_token/credit_tokens.html","<div class=\"row h-100\" ng-init=\"creditTokens.fnInitCreditTokens()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"creditTokens.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in creditTokens.tabs track by $index\" select=\"creditTokens.fnTabChanged(tab)\" ng-click=\"creditTokens.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();creditTokens.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"creditTokens.isFullWidthDevice\"><a ng-click=\"creditTokens.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{creditTokens.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li><li ng-if=\"!creditTokens.isFullWidthDevice\"><a ng-click=\"creditTokens.fnGetCreditTokenStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"creditTokens.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"creditTokens.isFullWidthDevice && creditTokens.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'creditToken\'\" service-name=\"\'Credit Token\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"creditTokens.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"creditTokens.fnGetWidgetEditor()\" fn-hide-chart=\"creditTokens.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"creditTokens.isRefreshData\" search-identifier=\"\'creditTokenSearch\'\" filters-arr=\"creditTokens.searchFiltersArr\" filter-query=\"creditTokens.filterQuery\" fn-filter-query-change=\"creditTokens.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.credit_token\'\" fn-resize=\"creditTokens.fnSetTableHeight()\" sort-field-arr=\"creditTokens.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"creditTokens.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"creditTokens.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"creditTokens.csvHeaderArr\" filename=\"creditTokens.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"creditTokens.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"creditTokens.isCreditTokensLoading\" fn-resize=\"creditTokens.fnSetLoaderTableHeight()\"></table-loader><div class=\"credit-token-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!creditTokens.isCreditTokensLoading && creditTokens.type === \'claimed\'\"><thead><tr><th ng-if=\"creditTokens.creditTokensArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllClaimed\" ng-model=\"creditTokens.isAllChecked\" ng-click=\"creditTokens.fnCheckUncheckAll()\"> <label for=\"checkAllClaimed\" class=\"check-box\"></label></th><th ng-if=\"creditTokens.creditTokensArr.length\"><span>Name</span></th><th ng-if=\"creditTokens.creditTokensArr.length\"></th><th ng-if=\"creditTokens.creditTokensArr.length\"></th><th ng-if=\"!creditTokens.creditTokensArr.length\">No records found...</th></tr></thead><tbody id=\"creditTokenTable\"><tr ng-repeat=\"creditToken in creditTokens.creditTokensArr track by $index\" ng-click=\"creditTokens.fnCheckUncheckHeader(creditToken, false, false);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"creditToken.isCheck\" ng-change=\"creditTokens.fnCheckUncheckHeader(creditToken, false, false)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{creditToken.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{creditToken.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-2 label_name\" style=\"width: fit-content !important;\">Claimed Amount: ${{(creditToken.amountClaimed/100).toFixed(2)}}</label></div><span class=\"ellipsis\" style=\"display: block;\"><span class=\"DescriptionText font-italic p-r-5 span_des\">Used Amount: ${{(creditToken.amountUsed/100).toFixed(2)}}</span> <span class=\"discDot\" ng-hide=\"!creditToken.amountRemaining\"><span class=\"dot\"></span></span> <span class=\"DescriptionText font-italic p-l-10 span_des\">Remaining Amount: ${{(creditToken.amountRemaining/100).toFixed(2)}}</span></span></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': creditTokens.isDropUp }\" ng-click=\"$event.stopPropagation(); creditTokens.toggleDropUp(\'creditTokenTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"creditTokens.fnOpenCreditTokenInfoTab(creditToken,1)\">Details</a></li><li><a ng-click=\"creditTokens.fnCopyId(creditToken.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><table class=\"table table-striped table-check-box\" ng-if=\"!creditTokens.isCreditTokensLoading && creditTokens.type !== \'claimed\'\"><thead><tr><th ng-if=\"creditTokens.creditTokensArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"creditTokens.isAllChecked\" ng-click=\"creditTokens.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"creditTokens.creditTokensArr.length\"><span>Name</span></th><th ng-if=\"creditTokens.creditTokensArr.length\"></th><th ng-if=\"creditTokens.creditTokensArr.length\"></th><th ng-if=\"!creditTokens.creditTokensArr.length\">No records found...</th></tr></thead><tbody id=\"creditTokenTable\"><tr ng-repeat=\"creditToken in creditTokens.creditTokensArr track by $index\" ng-click=\"creditTokens.fnCheckUncheckHeader(creditToken, false, true);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"creditToken.isCheck\" ng-change=\"creditTokens.fnCheckUncheckHeader(creditToken, false, true)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{creditToken.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{creditToken.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-2 label_name\" style=\"width: fit-content !important;\">Amount: ${{(creditToken.amount/100).toFixed(2)}}</label></div><span class=\"ellipsis\" style=\"display: block;\"><span class=\"DescriptionText font-italic p-r-5 span_des\">Starts: {{creditToken.startsDate}}</span> <span class=\"discDot\"><span class=\"dot\"></span></span> <span class=\"DescriptionText font-italic p-l-10 span_des\">Expires: {{creditToken.expiresDate}}</span></span></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': creditTokens.isDropUp }\" ng-click=\"$event.stopPropagation(); creditTokens.toggleDropUp(\'creditTokenTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"creditTokens.fnOpenCreditTokenInfoTab(creditToken,1)\">Details</a></li><li ng-click=\"creditTokens.fnSendCreditToken(creditToken.id)\" ng-if=\"creditTokens.accountId === \'cu000000\' && creditTokens.type && creditTokens.type === \'unclaimed\'\"><a class=\"btn btn-link\">Send Credit Token</a></li><li><a ng-click=\"creditTokens.fnCopyId(creditToken.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!creditTokens.isCreditTokensLoading && creditTokens.creditTokensArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{creditTokens.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"creditTokens.perPage = 10; creditTokens.fnPageChanged(creditTokens.currentPage, creditTokens.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"creditTokens.perPage = 20; creditTokens.fnPageChanged(creditTokens.currentPage, creditTokens.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"creditTokens.perPage = 50; creditTokens.fnPageChanged(creditTokens.currentPage, creditTokens.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"creditTokens.perPage = 100; creditTokens.fnPageChanged(creditTokens.currentPage,creditTokens.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"creditTokens.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"creditTokens.currentPage\" items-per-page=\"creditTokens.perPage\" max-size=\"creditTokens.maxSize\" boundary-links=\"true\" ng-click=\"creditTokens.fnPageChanged(creditTokens.currentPage, creditTokens.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\" style=\"min-height: 55px;\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{creditTokens.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : creditTokens.isRefresh}\" ng-click=\"creditTokens.fnReload();\" aria-hidden=\"true\"></i></div><button ng-if=\"creditTokens.accountId === \'cu000000\'\" type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 m-l-10\" ng-click=\"creditTokens.fnHideShowUnclaimedClaimedTokens()\">View {{creditTokens.type === \'claimed\' ? \'Unclaimed\' : \'Claimed\'}} Credit Tokens</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"creditTokens.permissionObj.CLAIM_UNCLAIMED_CREDIT_TOKEN\" ng-click=\"creditTokens.fnClaimCredit()\">Claim Credit Token</button> <button ng-show=\"creditTokens.accountId === \'cu000000\' && creditTokens.permissionObj.CREATE_UNCLAIMED_CREDIT_TOKEN\" type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 m-l-10\" ng-click=\"creditTokens.fnHideShowCreateForm()\">Create Credit Token</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"creditTokens.activeTabIndex !== 1 && creditTokens.selectedCreditTokenObj && !creditTokens.isShowCreditTokenStats && creditTokens.isCreditTokenDetailsLoaded && !creditTokens.isCreate && !creditTokens.isShowDashboard && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowWidgetEditor && !creditTokens.isShowAdvanceSearch && !creditTokens.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><credit-token-info credit-token-obj=\"creditTokens.selectedCreditTokenObj\" account-id=\"creditTokens.accountId\" user-permissions-obj=\"creditTokens.permissionObj\"></credit-token-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"creditTokens.activeTabIndex !== 1 && creditTokens.isCreate && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowDashboard && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowWidgetEditor && !creditTokens.isShowAdvanceSearch && !creditTokens.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/billing/credit_token/createCreditToken/createCreditToken.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"creditTokens.activeTabIndex !== 1 && !creditTokens.isCreate && creditTokens.isShowCreditTokenStats && !creditTokens.isShowDashboard && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowWidgetEditor && !creditTokens.isShowAdvanceSearch && !creditTokens.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'creditToken\'\" service-name=\"\'Credit Token\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"creditTokens.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"creditTokens.fnGetWidgetEditor()\" fn-hide-chart=\"creditTokens.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"creditTokens.activeTabIndex !== 1 && !creditTokens.isCreate && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowDashboard && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowAdvanceSearch && creditTokens.isShowWidgetEditor && !creditTokens.isCreateIssue\"><widget-editor app-name=\"\'billing\'\" service-display-name=\"\'Credit Token\'\" service-name=\"\'creditToken\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"creditTokens.activeTabIndex !== 1 && !creditTokens.isCreate && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowDashboard && !creditTokens.isShowCreditTokenStats && !creditTokens.isShowAdvanceSearch && !creditTokens.isShowWidgetEditor && creditTokens.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'billing\'\" service-key=\"\'creditToken\'\" app-name=\"\'Billing\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/billing/dashboard/billingDashboard.html","<div class=\"row h-100\" ng-init=\"billingDashboard.fnInitBillingDashboard()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content\"><div class=\"row\"><div class=\"modal-header p-t-0 p-b-8\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Month-to-date</h3><button ng-if=\"billingDashboard.summaryPermissionsObj.List\" class=\"btn btn-link p-0 pull-right\" ng-click=\"billingDashboard.fnGoToBillDetails()\">View bill details</button></div><div class=\"col-sm-12 billing-main-body h-100\" style=\"overflow: auto\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-if=\"!billingDashboard.isSummariesLoaded\"></app-spinner><div ng-if=\"billingDashboard.isSummariesLoaded && billingDashboard.summariesArr.length\"><h4 class=\"m-t-20\"><strong>The chart below shows the costs spent for each service you use.</strong></h4><h2><strong>{{billingDashboard.fnGetCurrencySymbol(billingDashboard.summariesArr[0].currency)}}{{billingDashboard.fnNumberToCurrency(billingDashboard.totalPrice)}}</strong></h2><div class=\"col-sm-12 p-0\"><button class=\"btn btn-link p-0\" ng-click=\"billingDashboard.isShowLabel = !billingDashboard.isShowLabel\"><small>{{billingDashboard.isShowLabel ? \'Hide\':\'Show\'}} Label</small></button></div><donut-chart donut-data=\"billingDashboard.data\" is-show-label=\"billingDashboard.isShowLabel\" ng-if=\"billingDashboard.data.length && billingDashboard.summariesArr.length\"></donut-chart></div><div ng-if=\"billingDashboard.isSummariesLoaded && !billingDashboard.summariesArr.length\"><h4 class=\"m-t-20 text-center\">Data Unavailable</h4></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"></div><div class=\"col-sm-6\"></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content\"><div class=\"row\"><div class=\"modal-header p-t-0 p-b-8\"><h3 class=\"modal-title inline-display\">Compared to recent</h3></div><div class=\"col-sm-12 billing-main-body h-100\" style=\"overflow: auto\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-if=\"!billingDashboard.isBarChartDataLoaded\"></app-spinner><div ng-if=\"billingDashboard.isBarChartDataLoaded && billingDashboard.barchartArr.length\"><div class=\"col-sm-12 p-0\"><div class=\"pull-right\"><div class=\"btn-group m-t-20\" uib-dropdown=\"\" id=\"barChartDropdownMenu\"><button id=\"single-button\" type=\"button\" class=\"btn btn-link p-r-0\" uib-dropdown-toggle=\"\">{{billingDashboard.selectedYear}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right dropDownMaxHeight\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li role=\"menuitem\" ng-repeat=\"year in billingDashboard.yearsArr\"><a href=\"javascript:void(0);\" ng-click=\"billingDashboard.fnYearSelected(year)\">{{year}}</a></li></ul></div></div><div class=\"pull-left\"><h4 class=\"m-t-20\"><strong>Monthly average</strong></h4><h2><strong>{{billingDashboard.fnGetCurrencySymbol(billingDashboard.barchartArr[0].currency)}}{{billingDashboard.fnNumberToCurrency(billingDashboard.barChartTotalPrice)}}</strong></h2></div></div><bar-chart class=\"HighChartBarChart\" bar-data=\"billingDashboard.barData\" ng-if=\"!billingDashboard.isBarDataChange && billingDashboard.barData.length\"></bar-chart><div class=\"col-sm-12\" ng-if=\"billingDashboard.isBarDataChange\"><div class=\"m-r-32\"><app-spinner spinner-type=\"microSpinner\"></app-spinner></div></div></div><div ng-if=\"billingDashboard.isBarChartDataLoaded && !billingDashboard.barchartArr.length\"><h4 class=\"text-center m-t-20\">Data Unavailable</h4></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"></div><div class=\"col-sm-6\"></div></div></div></div></div></div>");
$templateCache.put("app/billing/discount/discount.html","<div class=\"row h-100\" ng-init=\"discount.fnInitDiscount()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"discount.activeTabIndex\"><uib-tab index=\"1\" select=\"discount.fnTabChanged(discount.tabs[0])\" ng-click=\"discount.fnChangeTab(discount.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"discount.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in discount.tabs track by $index\" select=\"discount.fnTabChanged(tab)\" ng-click=\"discount.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"discount.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();discount.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"discount.isFullWidthDevice\"><a ng-click=\"discount.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{discount.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li><li ng-if=\"!discount.isFullWidthDevice\"><a ng-click=\"discount.fnGetDiscountStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"discount.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"discount.isFullWidthDevice && discount.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'discount\'\" service-name=\"\'Discount\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"discount.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"discount.fnGetWidgetEditor()\" fn-hide-chart=\"discount.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"discount.isRefreshData\" search-identifier=\"\'discountSearch\'\" filters-arr=\"discount.searchFiltersArr\" filter-query=\"discount.filterQuery\" fn-filter-query-change=\"discount.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.discount\'\" fn-resize=\"discount.fnSetTableHeight()\" sort-field-arr=\"discount.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"discount.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"discount.getDiscountCSVData()\" id=\"csvAnchor\" csv-header=\"discount.csvHeaderArr\" filename=\"discount.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"discount.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"discount.isDiscountsloading\" fn-resize=\"discount.fnSetLoaderTableHeight()\"></table-loader><div class=\"discounts-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-if=\"!discount.isDiscountsloading\"><thead><tr><th ng-if=\"discount.discountArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"discount.isAllChecked\" ng-click=\"discount.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"discount.discountArr.length\"><span>Name</span></th><th ng-if=\"discount.discountArr.length\"></th><th ng-if=\"discount.discountArr.length\"></th><th ng-if=\"!discount.discountArr.length\">No records found...</th></tr></thead><tbody id=\"discountTable\"><tr ng-repeat=\"discountData in discount.discountArr track by $index\" ng-click=\"discount.fnCheckUncheckHeader(discountData);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"discountData.isCheck\" ng-change=\"discount.fnCheckUncheckHeader(discountData)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><label class=\"ellipsis m-b-0 label_name\">{{discountData.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{discountData.description}}</span></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-b-5\"><label class=\"ellipsis m-b-0 label_name\" uib-tooltip=\"Account ID\" tooptip-placement=\"auto\" style=\"width: fit-content !important;\">{{discountData.accountId}}</label></div><span class=\"ellipsis\" style=\"display: block;\"><span uib-tooltip=\"ProductId\" tooptip-placement=\"auto\" class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"discountData.productId\"></span> <span class=\"discDot\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" uib-tooltip=\"Discount Percentage\" tooptip-placement=\"auto\">{{discountData.percentage}} %</span></span></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': discount.isDropUp }\" ng-click=\"$event.stopPropagation(); discount.toggleDropUp(\'discountTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"discount.fnOpenDiscountInfoTab(discountData,1);\">Details</a></li><li><a ng-click=\"discount.fnCopyId(discountData.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!discount.isDiscountsloading && discount.discountArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{discount.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"discount.perPage = 10; discount.fnPageChanged(discount.currentPage, discount.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"discount.perPage = 20; discount.fnPageChanged(discount.currentPage, discount.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"discount.perPage = 50; discount.fnPageChanged(discount.currentPage, discount.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"discount.perPage = 100; discount.fnPageChanged(discount.currentPage,discount.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"discount.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"discount.currentPage\" items-per-page=\"discount.perPage\" max-size=\"10\" boundary-links=\"true\" ng-click=\"discount.fnPageChanged(discount.currentPage, discount.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\" style=\"height: 55px;\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{discount.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : discount.isRefresh}\" ng-click=\"discount.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"discount.accountId === \'cu000000\' && discount.permissionObj.CREATE_DISCOUNT\" ng-click=\"discount.fnHideShowCreateForm()\">Create Discount</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"discount.activeTabIndex !== 1 && discount.selectedDiscountObj && !discount.isShowDiscountStats && discount.isDiscountDetailsLoaded && !discount.isCreate && !discount.isShowWidgetEditor && !discount.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><discount-info discount-obj=\"discount.selectedDiscountObj\" user-permissions-obj=\"discount.permissionObj\"></discount-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"discount.activeTabIndex !== 1 && discount.isCreate && !discount.isShowDiscountStats && !discount.isShowWidgetEditor && !discount.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/billing/discount/createDiscount/createDiscount.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"discount.activeTabIndex !== 1 && !discount.isCreate && discount.isShowDiscountStats && !discount.isShowWidgetEditor && !discount.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'discount\'\" service-name=\"\'Discount\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"discount.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"discount.fnGetWidgetEditor()\" fn-hide-chart=\"discount.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"discount.activeTabIndex !== 1 && !discount.isCreate && !discount.isShowDiscountStats && discount.isShowWidgetEditor && !discount.isCreateIssue\"><widget-editor app-name=\"\'billing\'\" service-display-name=\"\'Discount\'\" service-name=\"\'discount\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"discount.activeTabIndex !== 1 && !discount.isCreate && !discount.isShowDiscountStats && !discount.isShowWidgetEditor && discount.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'billing\'\" service-key=\"\'discount\'\" app-name=\"\'Billing\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/billing/invoice/invoice.html","<div class=\"row h-100\" ng-init=\"invoice.fnInitInvoice()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"invoice.activeTabIndex\"><uib-tab index=\"invoice.tabs[0].tabIndex\" select=\"invoice.fnTabChanged(invoice.tabs[0])\" ng-click=\"invoice.fnChangeTab(invoice.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{invoice.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in invoice.tabs track by $index\" select=\"invoice.fnTabChanged(tab)\" ng-click=\"invoice.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"invoice.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();invoice.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"invoice.isFullWidthDevice\"><a ng-click=\"invoice.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{invoice.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li><li ng-if=\"!invoice.isFullWidthDevice\"><a ng-click=\"invoice.fnGetInvoiceStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"invoice.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"invoice.isFullWidthDevice && invoice.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'invoice\'\" service-name=\"\'Invoice\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"invoice.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"invoice.fnGetWidgetEditor()\" fn-hide-chart=\"invoice.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"invoice.isRefreshData\" search-identifier=\"\'invoiceSearch\'\" filters-arr=\"invoice.searchFiltersArr\" filter-query=\"invoice.filterQuery\" fn-filter-query-change=\"invoice.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.invoice\'\" fn-resize=\"invoice.fnSetTableHeight()\" sort-field-arr=\"invoice.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"invoice.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"invoice.getInvoiceCSVData()\" id=\"csvAnchor\" csv-header=\"invoice.csvHeaderArr\" filename=\"invoice.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"invoice.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"invoice.isInvoicesloading\" fn-resize=\"invoice.fnSetLoaderTableHeight()\"></table-loader><div class=\"invoices-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-if=\"!invoice.isInvoicesloading\"><thead><tr><th ng-if=\"invoice.invoiceArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"invoice.isAllChecked\" ng-click=\"invoice.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"invoice.invoiceArr.length\"><span>Payment Date</span></th><th ng-if=\"invoice.invoiceArr.length\">Company Name</th><th ng-if=\"invoice.invoiceArr.length\">Amount Due</th><th ng-if=\"invoice.invoiceArr.length\"></th><th ng-if=\"invoice.invoiceArr.length\"></th><th ng-if=\"!invoice.invoiceArr.length\">No records found...</th></tr></thead><tbody id=\"invoiceTable\"><tr ng-repeat=\"invoiceData in invoice.invoiceArr track by $index\" ng-click=\"invoice.fnCheckUncheckHeader(invoiceData);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"invoiceData.isCheck\" ng-change=\"invoice.fnCheckUncheckHeader(invoiceData)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-b-5\"><label class=\"ellipsis m-b-0 label_name\" style=\"width: fit-content !important;\">{{invoiceData.dueDate}}</label></div><span class=\"ellipsis\" style=\"display: block;\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"invoiceData.id\"></span> <span class=\"discDot\" ng-hide=\"!invoiceData.total\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\">$ {{(invoiceData.total/100).toFixed(2)}}</span></span></td><td><span>{{invoiceData.businessName}}</span></td><td><span>$ {{(invoiceData.amountDue/100).toFixed(2)}}</span></td><td class=\"text-right\"><div><button class=\"btn btn-primary\" ng-class=\"invoice.fnGetInvoiceStatusBg(invoiceData.status)\">{{invoiceData.status}}</button></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': invoice.isDropUp }\" ng-click=\"$event.stopPropagation(); invoice.toggleDropUp(\'invoiceTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"invoice.fnOpenInvoiceInfoTab(invoiceData,1);\">Details</a></li><li><a ng-click=\"invoice.fnCopyId(invoiceData.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!invoice.isInvoicesloading && invoice.invoiceArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{invoice.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"invoice.perPage = 10; invoice.fnPageChanged(invoice.currentPage, invoice.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"invoice.perPage = 20; invoice.fnPageChanged(invoice.currentPage, invoice.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"invoice.perPage = 50; invoice.fnPageChanged(invoice.currentPage, invoice.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"invoice.perPage = 100; invoice.fnPageChanged(invoice.currentPage,invoice.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"invoice.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"invoice.currentPage\" items-per-page=\"invoice.perPage\" max-size=\"invoice.maxSize\" boundary-links=\"true\" ng-click=\"invoice.fnPageChanged(invoice.currentPage, invoice.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{invoice.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : invoice.isRefresh}\" ng-click=\"invoice.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" style=\"visibility: hidden\">Invoice</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"invoice.activeTabIndex !== 1 && !invoice.isShowWidgetEditor && invoice.selectedInvoicesArr.length === 1 && invoice.selectedInvoiceObj && !invoice.isShowInvoiceStats && invoice.isInvoiceDetailsLoaded && !invoice.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><invoice-info invoice-obj=\"invoice.selectedInvoiceObj\" user-permissions-obj=\"invoice.permissionObj\"></invoice-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"users.activeTabIndex !== 1 && !invoice.isShowWidgetEditor && invoice.isShowInvoiceStats && !invoice.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'billing\'\" service-key=\"\'invoice\'\" service-name=\"\'Invoice\'\" app-name=\"\'Billing\'\" fn-get-chart-detail=\"invoice.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"invoice.fnGetWidgetEditor()\" fn-hide-chart=\"invoice.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"invoice.activeTabIndex !== 1 && invoice.isShowWidgetEditor && !invoice.isShowInvoiceStats && !invoice.isCreateIssue\"><widget-editor app-name=\"\'billing\'\" service-display-name=\"\'Invoice\'\" service-name=\"\'invoice\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"invoice.activeTabIndex !== 1 && !invoice.isShowWidgetEditor && !invoice.isShowInvoiceStats && invoice.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'billing\'\" service-key=\"\'invoice\'\" app-name=\"\'Billing\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/billing/payment_method/paymentMethod.html","<div class=\"row h-100\" ng-init=\"paymentMethod.fnInitPaymentMethod()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"paymentMethod.activeTabIndex\"><uib-tab index=\"1\" select=\"paymentMethod.fnTabChanged(paymentMethod.tabs[0])\" ng-click=\"paymentMethod.fnChangeTab(paymentMethod.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"paymentMethod.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in paymentMethod.tabs track by $index\" select=\"paymentMethod.fnTabChanged(tab)\" ng-click=\"paymentMethod.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"paymentMethod.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();paymentMethod.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"paymentMethod.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Billing</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"paymentMethod.isFullWidthDevice\">Payment Methods</h1><h3 class=\"m-0 font-bold\" ng-if=\"!paymentMethod.isFullWidthDevice\">Payment Methods</h3></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"paymentMethod.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"paymentMethod.searchFiltersArr\" filter-query=\"paymentMethod.filterQuery\" fn-filter-query-change=\"paymentMethod.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.payment_method\'\" fn-resize=\"paymentMethod.fnSetTableHeight()\" sort-field-arr=\"paymentMethod.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"paymentMethod.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"paymentMethod.isPaymentMethosLoading\" fn-resize=\"paymentMethod.fnSetLoaderTableHeight()\"></table-loader><div class=\"paymentMethod-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!paymentMethod.isPaymentMethosLoading\"><thead><tr><th ng-if=\"paymentMethod.paymentMethodsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"paymentMethod.isAllChecked\" ng-click=\"paymentMethod.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"paymentMethod.paymentMethodsArr.length\"></th><th ng-if=\"paymentMethod.paymentMethodsArr.length\"></th><th ng-if=\"paymentMethod.paymentMethodsArr.length\"></th><th ng-if=\"paymentMethod.paymentMethodsArr.length\"></th><th ng-if=\"!paymentMethod.paymentMethodsArr.length\">No records found...</th></tr></thead><tbody id=\"paymentMethodTable\"><tr ng-repeat=\"payment in paymentMethod.paymentMethodsArr track by $index\" ng-click=\"paymentMethod.fnCheckUncheckHeader(payment);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"payment.isCheck\" ng-change=\"paymentMethod.fnCheckUncheckHeader(payment)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><span><i class=\"fa fa-2x\" ng-class=\"paymentMethod.fnGetCreditCardClass(payment.card.brand)\"></i></span></td><td class=\"attributeTdCSS-style d-flex flex-column\"><label class=\"ellipsis m-b-0 label_name\">{{payment.billingDetails.name}}</label> <span class=\"p-t-5\"><span class=\"DescriptionText span_des p-r-5 font-italic\">XXXX{{payment.card.last4}}</span> <span class=\"discDot\"><span class=\"dot\"></span></span> <span class=\"DescriptionText span_des p-l-12\" uib-tooltip=\"Expires Date\" tooptip-placement=\"auto\">{{payment.card.expiryMonth.toString().length === 1 ? \"0\" + payment.card.expiryMonth : payment.card.expiryMonth}}/{{ payment.card.expiryYear}}</span></span></td><td class=\"text-center\"><span uib-tooltip=\"Default Payment Method\" tooltip-placement=\"auto\"><i class=\"fa\" ng-class=\"payment.defaultPaymentMethod ? \'fa-credit-card\' : \'\'\"></i></span></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': paymentMethod.isDropUp }\" ng-click=\"$event.stopPropagation(); paymentMethod.toggleDropUp(\'paymentMethodTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"paymentMethod.fnOpenPaymentMethodInfoTab(payment);\">Details</a></li><li><a ng-click=\"paymentMethod.fnCopyId(payment.id)\">Copy ID</a></li><li><a ng-click=\"paymentMethod.fnDeletePaymentMethod(payment)\" ng-if=\"paymentMethod.permissionObj.DELETE_PAYMENT_METHOD\">Delete Payment Method</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!paymentMethod.isPaymentMethosLoading && paymentMethod.paymentMethodsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{paymentMethod.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"paymentMethod.perPage = 10; paymentMethod.fnPageChanged(paymentMethod.currentPage, paymentMethod.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"paymentMethod.perPage = 20; paymentMethod.fnPageChanged(paymentMethod.currentPage, paymentMethod.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"paymentMethod.perPage = 50; paymentMethod.fnPageChanged(paymentMethod.currentPage, paymentMethod.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"paymentMethod.perPage = 100; paymentMethod.fnPageChanged(paymentMethod.currentPage,paymentMethod.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"paymentMethod.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"paymentMethod.currentPage\" items-per-page=\"paymentMethod.perPage\" max-size=\"paymentMethod.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"paymentMethod.fnPageChanged(paymentMethod.currentPage, paymentMethod.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{paymentMethod.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : paymentMethod.isRefresh}\" ng-click=\"paymentMethod.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"paymentMethod.permissionObj.REQUEST_NEW_PAYMENT_METHOD\" ng-click=\"paymentMethod.fnHideShowCreateForm()\">Add Payment Method</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"paymentMethod.activeTabIndex !== 1 && paymentMethod.selectedPaymentMethodsArr.length === 1 && paymentMethod.selectedPaymentMethodObj && paymentMethod.isPaymentMethodDetailsLoaded && !paymentMethod.isCreate\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><payment-method-info payment-method-obj=\"paymentMethod.selectedPaymentMethodObj\" payment-method-permissions-obj=\"paymentMethod.permissionObj\"></payment-method-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"paymentMethod.activeTabIndex !== 1 && paymentMethod.isCreate\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/billing/payment_method/createPaymentMethod/createPaymentMethod.html\'\"></ng-include></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/billing/plan/plan.html","<div id=\"billingPlansMainDiv\" class=\"row h-100\" ng-init=\"plan.fnInitPlan()\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"plan.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in plan.tabs track by $index\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-x-hidden h-100 content-container\" ng-if=\"plan.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Billing</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-12 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"plan.isFullWidthDevice === true\">Plans</h1><h3 class=\"m-0 font-bold\" ng-if=\"!plan.isFullWidthDevice === true\">Plans</h3></div></div></div><div class=\"col-sm-12 p-0 p-t-20 d-flex justify-content-center align-items-center\" ng-if=\"plan.isPlanloading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!plan.isPlanloading\"><div class=\"content-box\"><div class=\"row\"><div class=\"col-sm-12\"><div id=\"loading-row\" class=\"m-b-10 d-flex h-100 justify-content-center align-items-center\" ng-init=\"plan.fnSetLoaderTableHeight()\" ng-if=\"plan.isPlanloading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"planData\" ng-if=\"!plan.isPlanloading\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 h-100 overflow-auto\"><div class=\"col-sm-12 p-0 p-t-25 p-b-15\"><label>Additional Services</label></div><div class=\"col-sm-12 servicePanel m-b-15\" ng-repeat=\"(key, value) in plan.planObj\" ng-if=\"!value.isActive || key === \'ai\'\"><div class=\"col-sm-12 p-0 p-t-15 p-b-25 d-flex align-items-center justify-content-space-between\"><div class=\"col-sm-7 p-0\"><h3 class=\"font-size-19\">{{value.panelDisplayName}}</h3></div><div class=\"col-sm-5 p-0\" ng-if=\"key === \'ai\' && value.isActive\" ng-class=\"plan.isAIFunctionCountChanging ? \'pace\' : \'\'\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"!plan.isShowAISlider && plan.permissionObj.UPDATE_PLAN_AI_FUNCTION_COUNT\" ng-click=\"plan.isShowAISlider = true\">Change</button><rzslider ng-if=\"plan.isShowAISlider\" rz-slider-model=\"plan.slider.value\" rz-slider-options=\"plan.slider.options\"></rzslider></div><div class=\"col-sm-5 p-0 d-flex justify-content-flex-end\" ng-if=\"!value.isActive\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"!value.isPlanStateChanging && (key === \'support\' ? plan.permissionObj.ACTIVATE_PLAN_APPLICATION : plan.permissionObj.ACTIVATE_PLAN_SUPPORT)\" ng-click=\"plan.fnPlanSwitchToggle(key)\">Activate</button><app-spinner ng-if=\"value.isPlanStateChanging\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-if=\"value.appDisplayName === \'AI\'\"><label class=\"m-b-25\">Your account is configured so you can activate up to {{value.aiNodeFunctionCount.value}} concurrent AI Functions. If you would like, you can modify the number of concurrent AI functions you can run. The minimum number is {{value.aiNodeFunctionMinCount.value}} and the maximum is {{value.aiNodeFunctionMaxCount.value}}. If you need more than {{value.aiNodeFunctionMaxCount.value}} please contact support and request a capacity increase.</label> <label class=\"m-b-25\">AI functions are priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month with a minimum of 100 nodes.</label><div class=\"col-sm-5 p-0 d-flex\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-if=\"plan.isShowAISlider && !plan.isAIFunctionCountChanging\" ng-click=\"plan.fnResetSliderValue()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"plan.isAIChangesShow && !plan.isAIFunctionCountChanging\" ng-click=\"plan.fnChangeAIFunctionCount()\">Save Changes</button><app-spinner ng-if=\"plan.isAIFunctionCountChanging\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0\" ng-if=\"value.appDisplayName === \'Pipeline\'\"><label class=\"m-b-25\">Pipeline support are priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"value.appDisplayName === \'Tracker\'\"><label class=\"m-b-25\">Tracker provides end-to-end issue management capabilities to help team solve issues faster and smarter. Every team has a unique process for resolving issues. Use an out-of-the-box workflow, or create one to match the way your team works.</label> <label class=\"m-b-25\">Tracker support are priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"value.appDisplayName === \'Storage\'\"><label class=\"m-b-25\">Storage support are priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"value.appDisplayName === \'Node\'\"><label class=\"m-b-25\">Node support are priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"value.appDisplayName === \'Support\'\"><label class=\"m-b-15\">As you know with your account you get unlimited support included at no cost! You can ask us any question any time via email and our teams will get back to you as soon as they can with an answer. There are a couple of important points about the included support; it is only available via email and Tracker (yep we eat our own cooking). There are also no SLA or guarantees of any kind. We generally get back to most requests in two to three working days.</label> <label class=\"m-b-15\">If you are running mission critical services then we strongly recommend you subscribe to enterprise support. We offer a 24 hour SLA and in addition to email and Tracker you also get a dedicated phone number to call and we can support you via phone, SMS, IM, screen shares, etc.</label> <label class=\"m-b-15\">Enterprise support is priced at {{(value.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}} / node / month with a minimum of 100 nodes and 1 month.</label></div></div></div><div class=\"col-sm-4 h-100 overflow-y-auto\"><div class=\"col-sm-12 p-0 m-t-15 servicePanel\" style=\"height: 150px\"><div class=\"col-sm-12 d-flex justify-content-space-between align-items-center servicePanelBorder\" style=\"height: 38px\"><label class=\"m-0\">Pricing</label> <span>Minimum Nodes: {{plan.planResponse.minNodeCount}}</span></div><div class=\"col-sm-12 d-flex align-items-center\" style=\"height: calc(100% - 76px)\"><label class=\"m-0 m-r-10\">$</label><h2 class=\"m-0 m-r-10 font-bold\">{{(plan.planResponse.totalPricePerNodeMonth / 100).toFixed(2)| currency:\"\"}}</h2><label class=\"m-0\">/ node / month</label></div><div class=\"col-sm-12 d-flex align-items-center justify-content-flex-end\" style=\"height: 38px\"><label>({{plan.planResponse.currency}})</label></div></div><div class=\"col-sm-12 p-0 m-t-15 servicePanel\" style=\"height: 285px\"><div class=\"col-sm-12 d-flex justify-content-space-between align-items-center servicePanelBorder\" style=\"height: 38px\"><label class=\"m-0\">Services</label></div><div class=\"col-sm-12 d-flex flex-column\" style=\"height: calc(100% - 38px)\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between m-t-20 m-b-20\"><label>Node</label> <label class=\"font-italic\" ng-if=\"!plan.planObj.node.isActive\">{{plan.planObj.node.pricePerNodeMonth.displayName}}: {{(plan.planObj.node.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}}</label> <i class=\"fa fa-check\" ng-if=\"plan.planObj.node.isActive\"></i></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between m-b-20\"><label>Tracker</label> <label class=\"font-italic\" ng-if=\"!plan.planObj.tracker.isActive\">{{plan.planObj.tracker.pricePerNodeMonth.displayName}}: {{(plan.planObj.tracker.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}}</label> <i class=\"fa fa-check\" ng-if=\"plan.planObj.tracker.isActive\"></i></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between m-b-20\"><label>Pipeline</label> <label class=\"font-italic\" ng-if=\"!plan.planObj.pipeline.isActive\">{{plan.planObj.pipeline.pricePerNodeMonth.displayName}}: {{(plan.planObj.pipeline.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}}</label> <i class=\"fa fa-check\" ng-if=\"plan.planObj.pipeline.isActive\"></i></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between m-b-20\"><label>Storage</label> <label class=\"font-italic\" ng-if=\"!plan.planObj.storage.isActive\">{{plan.planObj.storage.pricePerNodeMonth.displayName}}: {{(plan.planObj.storage.pricePerNodeMonth.value / 100).toFixed(2) | currency:\"$ \"}}</label> <i class=\"fa fa-check\" ng-if=\"plan.planObj.storage.isActive\"></i></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between m-b-20\"><label>AI</label> <label class=\"font-italic\">Functions: {{plan.planObj.ai.aiNodeFunctionCount.value}}</label></div></div></div><div class=\"col-sm-12 p-0 m-t-15 m-b-10 servicePanel\" style=\"height: 200px\"><div class=\"col-sm-12 d-flex justify-content-space-between align-items-center servicePanelBorder\" style=\"height: 38px\"><label class=\"m-0\">Enterprise Support</label></div><div class=\"col-sm-12 d-flex flex-column\" style=\"height: calc(100% - 38px)\"><label class=\"m-0 m-r-10 m-b-15 m-t-15 font-italic\" ng-if=\"plan.planObj.support.isActive\">Your account has enterprise enabled.</label> <label class=\"m-0 m-r-10 m-b-15 m-t-15 font-italic\" ng-if=\"!plan.planObj.support.isActive\">Your account has enterprise disabled.</label> <label class=\"m-0 m-r-10 font-italic\" ng-if=\"plan.planObj.support.isActive\">Send us an email at ops@ecsiteapp.com</label><div ng-if=\"plan.planObj.support.isActive && plan.planObj.support.supportDeactivationIsAfter && !plan.isShowSupportDeactivationLoader && plan.permissionObj.DEACTIVATE_PLAN_SUPPORT\"><button class=\"btn btn-primary v4-primary-button m-t-15\" ng-click=\"plan.fnDeactiveSupport()\">Deactive</button></div><app-spinner ng-if=\"plan.isShowSupportDeactivationLoader\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6\"></div><div class=\"col-sm-6\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/billing/script/scripts.html","<div class=\"row h-100\" ng-init=\"scripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"scripts.activeTabIndex\"><uib-tab index=\"1\" select=\"scripts.fnTabChanged(scripts.tabs[0])\" ng-click=\"scripts.fnChangeTab(scripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"scripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in scripts.tabs track by $index\" select=\"scripts.fnTabChanged(tab)\" ng-click=\"scripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"scripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();scripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"scripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!scripts.isFullWidthDevice\"><a ng-click=\"scripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"scripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Billing</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"scripts.isFullWidthDevice\">S4</h1><h3 class=\"m-0 font-bold\" ng-if=\"!scripts.isFullWidthDevice\">S4</h3></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"scripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"scripts.searchFiltersArr\" filter-query=\"scripts.filterQuery\" fn-filter-query-change=\"scripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.script\'\" fn-resize=\"scripts.fnSetTableHeight()\" sort-field-arr=\"scripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"scripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"scripts.isScriptsloading\" fn-resize=\"scripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!scripts.isScriptsloading\"><thead><tr><th ng-if=\"scripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"scripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"scripts.scriptArr.length\"></th><th ng-if=\"!scripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in scripts.scriptArr track by $index\" ng-click=\"scripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"scripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': scripts.isDropUp }\" ng-click=\"$event.stopPropagation(); scripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"scripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!scripts.isScriptsloading && scripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{scripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 10; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 20; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 50; scripts.fnPageChanged(scripts.currentPage, scripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"scripts.perPage = 100; scripts.fnPageChanged(scripts.currentPage,scripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"scripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"scripts.currentPage\" items-per-page=\"scripts.perPage\" max-size=\"scripts.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"scripts.fnPageChanged(scripts.currentPage, scripts.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{scripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : scripts.isRefresh}\" ng-click=\"scripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && scripts.selectedScriptsArr.length === 1 && scripts.selectedScriptObj && scripts.isScriptDetailsLoaded && !scripts.isShowDashboard\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><billingscript-info script-obj=\"scripts.selectedScriptObj\" user-permissions-obj=\"scripts.permissionObj\"></billingscript-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"scripts.activeTabIndex !== 1 && scripts.isShowDashboard\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/accountStatusModal/accountStatusModal.html","<div class=\"inmodal theme_modal\" ng-init=\"accountStat.fnInitModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\"><span ng-if=\"accountStat.isCalledForFirstPaymentMethod\">Security Check</span> <span ng-if=\"!accountStat.isCalledForFirstPaymentMethod\">Available Tables</span></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"accountStat.isCalledForFirstPaymentMethod\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center\"><span>For your security, to activate this card please sign back into your account.</span></div></div><div class=\"col-sm-12\" ng-if=\"!accountStat.isCalledForFirstPaymentMethod\"><div class=\"col-sm-12 d-flex flex-column align-items-center justify-content-center\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-repeat=\"(key, value) in accountStat.availableTables\"><label class=\"text-capitalize\">{{key}}</label><ul><li ng-repeat=\"obj in value\">{{obj.name}}</li></ul></div></div></div></div></div></div><div class=\"modal-footer\"><app-spinner ng-if=\"accountStat.isShowFooterLoader\" spinner-type=\"\'microSpinner\'\"></app-spinner><button type=\"button\" ng-if=\"!accountStat.isShowFooterLoader && accountStat.isCalledForFirstPaymentMethod\" class=\"btn btn-primary\" ng-click=\"accountStat.fnForceLogout()\" tabindex=\"12\">Sign back in</button> <button type=\"button\" ng-if=\"!accountStat.isCalledForFirstPaymentMethod\" class=\"btn btn-primary\" ng-click=\"accountStat.fnClose()\" tabindex=\"12\">Close</button></div>");
$templateCache.put("app/components/breadcrumb/breadcrumb.html","<div class=\"btn-group btn-breadcrumb\"><a class=\"btn btn-default\" ng-class=\"$index === 0 ? \'pace\' : \'\'; state.title.includes(\':\') ? \'noElement\' : \'\'\" ng-repeat=\"state in breadCrumbArray track by $index\" ui-sref=\"{{state.redirectUrl}}\" ng-init=\"fnGetBreadcrumbTitle(state)\"><span>{{state.title.includes(\':\') ? \'&nbsp;\' : state.title}}</span></a></div><div class=\"pull-right footer-container\"><div class=\"breadcrumbFooterIcons p-r-18\"><button class=\"btn btn-link p-0\" ng-click=\"fnOpenFeedbackSupportModal()\">Feedback & Support</button></div><div class=\"breadcrumbFooterIcons p-r-18\"><i class=\"fa fa-question-circle-o\" aria-hidden=\"true\" ng-click=\"fnOpenInfoModel()\"></i></div><div class=\"version breadcrumbFooterIcons\"><i class=\"fa fa-code-fork\" aria-hidden=\"true\"></i> <span ng-if=\"phoenixVersion\">v {{phoenixVersion}}</span></div><div class=\"documentation breadcrumbFooterIcons\"><i class=\"fa fa-book\" aria-hidden=\"true\"></i> <a class=\"text-center link-dk-primary\" target=\"_blank\" tabindex=\"-1\" ng-href=\"https://docs.phoenix.predictivetech.io\">Documentation</a></div><div class=\"legal breadcrumbFooterIcons\"><i class=\"fa fa-gavel\" aria-hidden=\"true\"></i> <a class=\"text-center link-dk-primary\" target=\"_blank\" tabindex=\"-1\" ng-href=\"https://ecsite.ai/privacy/\">Legal</a></div><div class=\"copyRight breadcrumbFooterIcons\"><i class=\"fa fa-copyright\" aria-hidden=\"true\"></i> Copyright &copy; {{lastYear}} - <span ng-bind=\"currentYear\"></span> ECSite</div></div>");
$templateCache.put("app/components/inputTemplate/inputCheckboxTemplate.html","<div class=\"col-sm-12 p-0 m-b-20 d-flex\"><div class=\"w100 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{form.key}}\" name=\"{{form.key.toString()}}\" ng-model=\"$$value$$\"> <label for=\"chk_{{form.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{form.title}}</span></div><div class=\"m-l-10\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 4px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputDateTimeTemplate.html","<div class=\"col-sm-12 p-0 position-r\"><div class=\"md-input\"><input class=\"md-form-control\" type=\"text\" id=\"{{form.key.toString()}}_dateTimePicker\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}_dateTimePicker\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}} {{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div></div>");
$templateCache.put("app/components/inputTemplate/inputDropdownTemplate.html","<div class=\"col-sm-12 p-0 d-flex m-b-20\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{form.title}}{{form.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" ng-model=\"$$value$$\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue.value}}\" ng-repeat=\"arrValue in form.titleMap track by $index\">{{arrValue.value}}</option></select><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 12px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputLabelTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex\"><div class=\"w100\"><label>{{form.title}}</label></div></div>");
$templateCache.put("app/components/inputTemplate/inputNumberTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex\"><div class=\"md-input w100\"><input class=\"md-form-control\" type=\"number\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}} {{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 12px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputPasswordTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex\"><div class=\"md-input w100\"><input class=\"md-form-control\" type=\"password\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}} {{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 12px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputTextTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex\"><div class=\"md-input w100\"><input class=\"md-form-control\" type=\"{{form.type}}\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}} {{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 12px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputTextareaTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex\"><div class=\"md-input w100\"><textarea class=\"md-form-control\" type=\"{{form.type}}\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\" ng-model=\"$$value$$\">\n        </textarea> <label>{{form.title}}{{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 42px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div>");
$templateCache.put("app/components/inputTemplate/inputVaultDropdownTemplate.html","<div class=\"col-sm-12 p-0 position-r d-flex roleActions\"><div class=\"md-input w100\"><input class=\"md-form-control\" type=\"{{form.type}}\" typeahead-editable=\"true\" uib-typeahead=\"bluePrint.id as bluePrint.name for bluePrint in form.titleMap | filter: $viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeAheadTemplate.html\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}} {{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div><div class=\"m-l-10 p-b-30\" ng-if=\"form.description\" uib-tooltip=\"{{form.description}}\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" style=\"position: relative;top: 12px;\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/info.svg#info\"></use></svg></div></div><script type=\"text/ng-template\" id=\"TypeAheadTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <span ng-bind-html=\"match.model.name\"></span> <div class=\"font-italic\"> <small><span>({{match.model.id}})</span></small> </div> </div> </a></script>");
$templateCache.put("app/components/side-nav/side-nav.html","<nav class=\"navbar-default navbar-static-side side-nav\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\" sidebar=\"true\"><ul side-navigation=\"\" class=\"nav\" id=\"side-menu\"><li class=\"levelOneNav\" ng-repeat=\"item in main.fnFilterSideName()\" ui-sref-active=\"active\" ng-mouseenter=\"main.fnMouseEnter($event)\" ng-mousemove=\"main.fnMouseEnter($event)\" ng-mouseleave=\"main.fnMouseLeave($event)\" ng-class=\"main.fnCheckNavActive()\" ng-if=\"main.fnShowHideMenuItem(item)\"><a ng-if=\"!item.menus\" ui-sref=\"{{item.state}}\" title=\"{{item.name}}\"><i ng-if=\"item.icon\" class=\"fa\" ng-class=\"item.icon\" style=\"font-size: 19px\"></i> <i class=\"svgIconPosition\" ng-if=\"item.svgIcon\" ng-bind-html=\"main.deliberatelyTrustDangerousSnippet(item.svgIcon)\"></i> <span class=\"nav-label\" ng-class=\"item.svgIcon ? \'svgIconTitlePosition\':\'font-awesomeIconTitlePosition\'\" ng-bind=\"item.name\"></span> <span class=\"profile-element-beta-tag\">{{item.tag}}</span><div class=\"logo-element-beta-tag\" style=\"visibility: hidden\">{{item.tag}}</div></a> <a ng-if=\"item.menus && item.menus.length !== 0\" title=\"{{item.name}}\"><i class=\"fa\" ng-class=\"item.icon\"></i> <span class=\"nav-label\" ng-bind=\"item.name\"></span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level levelSecondNav collapse\" ng-class=\"main.fnCheckScroll()\" ng-if=\"item.menus\"><li ng-repeat=\"child in item.menus\" ng-click=\"main.fnHoverMenuSelected($event)\" ng-if=\"child.admin\"><a ui-sref=\"{{child.state}}\" title=\"{{child.name}}\"><i class=\"fa\" ng-class=\"child.icon\"></i> {{child.name}}</a></li></ul></li></ul><ul side-navigation=\"\" class=\"nav w100 tracker-setting-menu\" ng-if=\"main.fnCheckSettingsMenuPermissions()\"><li class=\"levelOneNav active mm-active\" ui-sref-active=\"active\" ng-mouseenter=\"main.fnMouseEnter($event, \'trackerSettingMenu\')\" ng-mousemove=\"main.fnMouseEnter($event, \'trackerSettingMenu\')\" ng-mouseleave=\"main.fnMouseLeave($event)\" ng-class=\"main.fnCheckNavActive()\"><a title=\"Settings\"><i class=\"svgIconPosition\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/tracker-settings.svg#tracker-settings\"></use></svg></i> <span class=\"nav-label svgIconTitlePosition\">Settings</span> <span class=\"fa arrow arrow-icon-position\"></span></a><ul class=\"nav nav-second-level levelSecondNav trackerSettingMenu\" id=\"trackerSettingMenu\" style=\"z-index: 1500\" ng-style=\"main.fnCheckHeight()\" ng-class=\"main.fnCheckScroll()\"><li ng-repeat=\"child in main.trackerSettingsMenu\" ng-if=\"$state.current && $state.current.url.includes(\'tracker\') && main.authUserObj.trackerRole !== \'TEAM_MEMBER\' && main.authUserObj.trackerRole !== \'CUSTOMER\'\" ng-click=\"main.fnHoverMenuSelected($event)\"><a ui-sref=\"{{child.state}}\" title=\"{{child.name}}\"><i class=\"svgIconPosition\" ng-if=\"child.svgIcon\" ng-bind-html=\"main.deliberatelyTrustDangerousSnippet(child.svgIcon)\"></i> <span class=\"nav-label\" style=\"display: unset\" ng-class=\"child.svgIcon ? \'svgIconTitlePosition\':\'font-awesomeIconTitlePosition\'\" ng-bind=\"child.name\"></span></a></li><li ng-repeat=\"child in main.nodeSettingsMenu\" ng-if=\"$state.current && $state.current.url.includes(\'node\') && main.authUserObj.nodeRole !== \'TEAM_MEMBER\' && main.authUserObj.nodeRole !== \'CUSTOMER\'\" ng-click=\"main.fnHoverMenuSelected($event)\"><a ui-sref=\"{{child.state}}\" title=\"{{child.name}}\"><i class=\"svgIconPosition\" ng-if=\"child.svgIcon\" ng-bind-html=\"main.deliberatelyTrustDangerousSnippet(child.svgIcon)\"></i> <span class=\"nav-label\" style=\"display: unset\" ng-class=\"child.svgIcon ? \'svgIconTitlePosition\':\'font-awesomeIconTitlePosition\'\" ng-bind=\"child.name\"></span></a></li><li ng-repeat=\"child in main.insightSettingsMenu\" ng-if=\"$state.current && $state.current.url.includes(\'insight\') && main.authUserObj.insightRole !== \'TEAM_MEMBER\' && main.authUserObj.insightRole !== \'CUSTOMER\'\" ng-click=\"main.fnHoverMenuSelected($event)\"><a ui-sref=\"{{child.state}}\" title=\"{{child.name}}\"><i class=\"svgIconPosition\" ng-if=\"child.svgIcon\" ng-bind-html=\"main.deliberatelyTrustDangerousSnippet(child.svgIcon)\"></i> <span class=\"nav-label\" style=\"display: unset\" ng-class=\"child.svgIcon ? \'svgIconTitlePosition\':\'font-awesomeIconTitlePosition\'\" ng-bind=\"child.name\"></span></a></li></ul></li></ul><ul side-navigation=\"\" class=\"nav metismenu navbar-toggle-menu\" id=\"side-menu-toggle\"><li minimaliza-logo-sidebar=\"\" role=\"button\"><a class=\"profile-element side-nav-collapse p-xs\"><i class=\"fa fa-angle-double-left\" title=\"Collapse Menu\"></i></a> <a class=\"logo-element side-nav-collapse\"><i class=\"fa fa-angle-double-right\" title=\"Expand Menu\"></i></a></li></ul></div></nav>");
$templateCache.put("app/components/supportModal/supportModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"support.isCalledForSupport ? \'Contact Sales\' : \'Account Recovery\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\" ng-if=\"!support.isCalledForSupport && support.recoveryType !== \'password\'\"><div class=\"divider\"></div><h3>To recover your username or password please contact your account manager.</h3><h4><i class=\"fa fa-envelope-o\"></i> ops@ecsiteapp.com</h4><h4><i class=\"fa fa-phone\"></i> (720) 663-0698</h4></div><div class=\"col-sm-12\" ng-if=\"!support.isCalledForSupport && support.recoveryType === \'password\' && support.isPasswordReset\"><div class=\"divider\"></div><h4>We have sent you an email containing instructions on how to reset your password. If you have any problems please contact support.</h4></div><div class=\"col-sm-12 floatingLabelInput p-0\" ng-if=\"!support.isCalledForSupport && support.recoveryType === \'password\' && !support.isPasswordReset\"><div class=\"divider\"></div><h4 class=\"m-b-15 m-t-0\">Enter Email / User Name.</h4><form id=\"supportForm\" role=\"form\" name=\"supportForm\" class=\"active animated\" novalidate=\"\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"text\" placeholder=\"Email / User Name for the reset password*\" ng-model=\"support.email\"> <span class=\"highlight\"></span> <label>Email / User Name*</label> <small class=\"helper-text\"></small></div><div id=\"captchaDiv\" class=\"col-sm-12 p-0 m-b-10\" ng-if=\"!support.captchaVerified\" vc-recaptcha=\"\" key=\"\'6LdBBcoZAAAAAKDO35-ce0GpmZpYmiaAe6dnmvCJ\'\" ng-model=\"support.myRecaptchaResponse\" on-success=\"support.fnVerifyCaptcha(response)\" on-expire=\"support.fnReVerifyCaptcha(response)\"></div><button ng-if=\"support.captchaVerified && support.isPasswordResetCompleted\" ng-disabled=\"!support.email.length || supportForm.email.$valid\" class=\"btn btn-primary block pull-right\" ng-click=\"support.fnResetPassword()\">Send Email</button><div class=\"col-sm-12\" ng-if=\"!support.isPasswordResetCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></form></div></div><div class=\"col-sm-12\" ng-if=\"support.isCalledForSupport\"><div class=\"divider\"></div><h3>To get more information please contact our Sales department.</h3><h4><i class=\"fa fa-envelope-o\"></i> sales@ecsiteapp.com.</h4><h4><i class=\"fa fa-phone\"></i> (720) 675-8324</h4></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"support.fnCancel()\" tabindex=\"12\">Close</button></div>");
$templateCache.put("app/components/top-nav/top-nav.html","<nav class=\"navbar navbar-default navbar-fixed-top\" ng-init=\"main.fnGetOutBoundFederations()\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><div class=\"top-nav-bar\"><ul id=\"appNavBar\" class=\"nav navbar-nav\"><li ng-if=\"topNavObj.isAcess === true && main.authUserObj.role === \'ADMINISTRATOR\'\" ng-repeat=\"topNavObj in main.topNavMenu\" ng-class=\"{active: topNavObj.name.toLowerCase().indexOf($state.current.menu)!==-1}\"><a ng-if=\"topNavObj.name === \'Access\'\" ng-href=\"#\" class=\"p-l-20\" ng-click=\"main.fnAppChange($event, topNavObj)\">MANAGER</a> <a ng-if=\"topNavObj.name !== \'Access\'\" ng-href=\"#\" ng-click=\"main.fnAppChange($event, topNavObj)\">{{topNavObj.name}}<span ng-if=\"topNavObj.tag\">{{topNavObj.tag}}</span></a></li><li ng-if=\"topNavObj.isAcess === true && main.authUserObj.role !== \'ADMINISTRATOR\'\" ng-style=\"topNavObj.name === \'AI\' ? {\'min-width\': \'66px\'} : \'\'\" ng-repeat=\"topNavObj in main.topNavMenu\" ng-class=\"{active: topNavObj.name.toLowerCase().indexOf($state.current.menu)!==-1}\"><a ng-href=\"#\" ng-if=\"topNavObj.name.toLowerCase()!== \'external\'\" ng-click=\"main.fnAppChange($event, topNavObj)\">{{topNavObj.name}}<span ng-if=\"topNavObj.tag\">{{topNavObj.tag}}</span></a></li></ul></div><div class=\"top-right-nav-bar\"><div class=\"top-nav-bar pull-right\"><ul class=\"nav navbar-nav\"><li ng-if=\"main.federationWorking\" class=\"federationBtn p-t-8 p-r-15\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></li></ul></div><ul class=\"nav navbar-nav navbar-right m-r-0\"><li ng-if=\"(!main.federationObj && !main.federationWorking) && !main.supportUserObj\"><span ng-if=\"main.isUserDataSet\" class=\"lightDarkThemeIcon\" uib-tooltip=\"{{main.isSetDarkTheme ? \'Enable Dark Theme\' : \'Enable Light Theme\'}}\" tooltip-placement=\"left\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 512 512\" ng-click=\"main.fnSetDarkTheme()\" ng-if=\"main.isSetDarkTheme\"><g><path d=\"M503.686,326.871c-7.932-6.33-19.109-6.452-27.18-0.29c-35.597,27.194-78.143,41.567-123.041,41.567 c-12.218,0-24.465-1.1-36.401-3.268c-4.761-0.868-9.317,2.291-10.181,7.051c-0.865,4.758,2.292,9.317,7.051,10.181 c12.966,2.356,26.266,3.55,39.53,3.55c48.774,0,94.997-15.617,133.671-45.162c1.67-1.276,3.982-1.25,5.624,0.059 c1.641,1.31,2.176,3.559,1.303,5.469c-19.069,41.693-49.47,77.047-87.915,102.238c-39.456,25.851-85.352,39.517-132.724,39.517 c-133.718,0-242.506-108.788-242.506-242.506c0-47.375,13.665-93.27,39.517-132.723c25.191-38.447,60.544-68.847,102.242-87.917 c1.908-0.874,4.152-0.337,5.462,1.305c1.309,1.641,1.336,3.953,0.061,5.621c-29.546,38.68-45.163,84.903-45.163,133.673 c0,47.23,14.783,92.296,42.752,130.328c27.397,37.254,64.95,64.578,108.6,79.017c4.595,1.516,9.545-0.974,11.065-5.564 c1.518-4.592-0.973-9.547-5.564-11.065c-83.343-27.567-139.338-105.013-139.338-192.715c0-44.895,14.374-87.442,41.567-123.042 c6.163-8.068,6.042-19.244-0.292-27.179c-6.337-7.94-17.215-10.527-26.439-6.304c-44.699,20.442-82.6,53.032-109.603,94.242 c-27.727,42.313-42.382,91.528-42.382,142.323c0,143.376,116.646,260.021,260.021,260.021 c50.792,0,100.007-14.655,142.324-42.382c41.209-27.003,73.8-64.903,94.245-109.603 C514.213,344.081,511.622,333.208,503.686,326.871z\"></path><path d=\"M251.454,164.085c20.691,0,37.526,16.834,37.526,37.525c0,4.836,3.921,8.757,8.757,8.757s8.757-3.921,8.757-8.757 c0-20.691,16.834-37.525,37.525-37.525c4.836,0,8.757-3.921,8.757-8.757c0-4.836-3.921-8.757-8.757-8.757 c-20.691,0-37.525-16.835-37.525-37.526c0-4.836-3.921-8.757-8.757-8.757s-8.757,3.921-8.757,8.757 c0,20.691-16.835,37.526-37.526,37.526c-4.836,0-8.757,3.921-8.757,8.757C242.697,160.164,246.618,164.085,251.454,164.085z M297.737,138.804c4.267,6.614,9.909,12.256,16.523,16.524c-6.614,4.267-12.255,9.909-16.523,16.523 c-4.267-6.614-9.91-12.255-16.524-16.523C287.827,151.061,293.47,145.418,297.737,138.804z\"></path><path d=\"M375.404,276.696c15.022,0,27.244-12.221,27.244-27.242c0-15.022-12.222-27.244-27.244-27.244 s-27.243,12.222-27.243,27.244C348.163,264.475,360.383,276.696,375.404,276.696z M375.404,239.726 c5.364,0,9.729,4.364,9.729,9.729c0,5.363-4.364,9.727-9.729,9.727s-9.728-4.363-9.728-9.727 C365.677,244.09,370.04,239.726,375.404,239.726z\"></path><circle cx=\"297.736\" cy=\"260.44\" r=\"10.979\"></circle><circle cx=\"368.144\" cy=\"90.735\" r=\"10.979\"></circle></g></svg><svg ng-click=\"main.fnSetDefaultTheme()\" ng-if=\"!main.isSetDarkTheme\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 302.4 302.4\"><g><g><path d=\"M204.8,97.6C191.2,84,172,75.2,151.2,75.2s-40,8.4-53.6,22.4c-13.6,13.6-22.4,32.8-22.4,53.6s8.8,40,22.4,53.6 c13.6,13.6,32.8,22.4,53.6,22.4s40-8.4,53.6-22.4c13.6-13.6,22.4-32.8,22.4-53.6S218.8,111.2,204.8,97.6z M190.4,190.4 c-10,10-24,16-39.2,16s-29.2-6-39.2-16s-16-24-16-39.2s6-29.2,16-39.2s24-16,39.2-16s29.2,6,39.2,16s16,24,16,39.2 S200.4,180.4,190.4,190.4z\"></path></g></g><g><g><path d=\"M292,140.8h-30.8c-5.6,0-10.4,4.8-10.4,10.4c0,5.6,4.8,10.4,10.4,10.4H292c5.6,0,10.4-4.8,10.4-10.4 C302.4,145.6,297.6,140.8,292,140.8z\"></path></g></g><g><g><path d=\"M151.2,250.8c-5.6,0-10.4,4.8-10.4,10.4V292c0,5.6,4.8,10.4,10.4,10.4c5.6,0,10.4-4.8,10.4-10.4v-30.8 C161.6,255.6,156.8,250.8,151.2,250.8z\"></path></g></g><g><g><path d=\"M258,243.6l-22-22c-3.6-4-10.4-4-14.4,0s-4,10.4,0,14.4l22,22c4,4,10.4,4,14.4,0S262,247.6,258,243.6z\"></path></g></g><g><g><path d=\"M151.2,0c-5.6,0-10.4,4.8-10.4,10.4v30.8c0,5.6,4.8,10.4,10.4,10.4c5.6,0,10.4-4.8,10.4-10.4V10.4 C161.6,4.8,156.8,0,151.2,0z\"></path></g></g><g><g><path d=\"M258.4,44.4c-4-4-10.4-4-14.4,0l-22,22c-4,4-4,10.4,0,14.4c3.6,4,10.4,4,14.4,0l22-22C262.4,54.8,262.4,48.4,258.4,44.4z\"></path></g></g><g><g><path d=\"M41.2,140.8H10.4c-5.6,0-10.4,4.8-10.4,10.4s4.4,10.4,10.4,10.4h30.8c5.6,0,10.4-4.8,10.4-10.4 C51.6,145.6,46.8,140.8,41.2,140.8z\"></path></g></g><g><g><path d=\"M80.4,221.6c-3.6-4-10.4-4-14.4,0l-22,22c-4,4-4,10.4,0,14.4s10.4,4,14.4,0l22-22C84.4,232,84.4,225.6,80.4,221.6z\"></path></g></g><g><g><path d=\"M80.4,66.4l-22-22c-4-4-10.4-4-14.4,0s-4,10.4,0,14.4l22,22c4,4,10.4,4,14.4,0S84.4,70.4,80.4,66.4z\"></path></g></g></svg></span> <span ng-if=\"!main.isUserDataSet\" class=\"themeChangeLoader\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></span></li><li ng-if=\"!main.supportUserObj && (main.federationObj && !main.federationWorking)\"><span class=\"federationTopNavIcon\" uib-tooltip=\"You are federated into {{main.federationObj.alias}}.\" tooltip-placement=\"left\"><i class=\"fa fa-handshake-o\"></i></span></li><li ng-if=\"main.supportUserObj && (!main.federationObj && !main.federationWorking)\"><span class=\"supportTopNavIcon\" uib-tooltip=\"You are supporting {{main.supportUserObj.sessionObj.accountName}}.\" tooltip-placement=\"left\"><svg class=\"svgIconFillTextSecondaryColor\" viewbox=\"0 0 64 64\" width=\"25\" height=\"25\"><g id=\"Support_service\" data-name=\"Support service\"><path d=\"M61.148,44.9a3.995,3.995,0,0,0-5.458-1.469l-9.751,5.629a3.964,3.964,0,0,0-2.259-1.629l-14.92-4a7,7,0,0,0-3.51-.03L20,44.719V43a1,1,0,0,0-1-1H11a1,1,0,0,0-1,1v1H3a1,1,0,0,0-1,1V59a1,1,0,0,0,1,1h7v1a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V59.618l1.286.643a7.027,7.027,0,0,0,3.13.739H39.393a7.011,7.011,0,0,0,3.5-.938l16.8-9.7A4.011,4.011,0,0,0,61.148,44.9ZM4,58V46h6V58Zm14,2H12V44h6ZM58.69,48.634l-16.8,9.7a5,5,0,0,1-2.5.67H24.416a5.027,5.027,0,0,1-2.235-.528L20,57.382v-10.6l5.734-1.434a5.025,5.025,0,0,1,2.508.021l14.92,4a2,2,0,1,1-1.035,3.863L30.2,50.034a1,1,0,0,0-.517,1.932l11.925,3.2a4.043,4.043,0,0,0,1.042.138,3.952,3.952,0,0,0,3.965-4.317l10.072-5.815a2.035,2.035,0,0,1,2.726.732A2.008,2.008,0,0,1,58.69,48.634Z\"></path><path d=\"M29,31h3.753c.057.144.114.283.174.418l-2.654,2.655a1,1,0,0,0,0,1.414l4.24,4.24a1,1,0,0,0,1.414,0l2.654-2.654c.136.059.275.117.419.174V41a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V37.247c.144-.057.283-.115.419-.174l2.654,2.654a1.029,1.029,0,0,0,1.414,0l4.24-4.24a1,1,0,0,0,0-1.414l-2.654-2.655c.06-.135.117-.274.174-.418H57a1,1,0,0,0,1-1V24a1,1,0,0,0-1-1H53.247c-.057-.144-.114-.283-.174-.419l2.654-2.654a1,1,0,0,0,0-1.414l-4.24-4.24a1,1,0,0,0-1.414,0l-2.654,2.654c-.136-.059-.275-.117-.419-.174V13a1,1,0,0,0-1-1H40a1,1,0,0,0-1,1v3.753c-.144.057-.283.115-.419.174l-2.654-2.654a1.029,1.029,0,0,0-1.414,0l-4.24,4.24a1,1,0,0,0,0,1.414l2.654,2.654c-.06.136-.117.275-.174.419H29a1,1,0,0,0-1,1v6A1,1,0,0,0,29,31Zm1-6h3.46a1,1,0,0,0,.952-.694,8.225,8.225,0,0,1,.605-1.446,1,1,0,0,0-.17-1.187L32.4,19.22l2.825-2.826,2.453,2.453a1,1,0,0,0,1.188.17,8.112,8.112,0,0,1,1.446-.605A1,1,0,0,0,41,17.46V14h4v3.46a1,1,0,0,0,.693.952,8.112,8.112,0,0,1,1.446.605,1,1,0,0,0,1.188-.17l2.453-2.453,2.825,2.826-2.452,2.453a1,1,0,0,0-.17,1.187,8.225,8.225,0,0,1,.605,1.446A1,1,0,0,0,52.54,25H56v4H52.54a1,1,0,0,0-.952.694,8.225,8.225,0,0,1-.605,1.446,1,1,0,0,0,.17,1.187l2.452,2.453L50.78,37.606l-2.453-2.453a1,1,0,0,0-1.188-.17,8.112,8.112,0,0,1-1.446.605A1,1,0,0,0,45,36.54V40H41V36.54a1,1,0,0,0-.693-.952,8.112,8.112,0,0,1-1.446-.605,1,1,0,0,0-1.188.17L35.22,37.606,32.4,34.78l2.452-2.453a1,1,0,0,0,.17-1.187,8.225,8.225,0,0,1-.605-1.446A1,1,0,0,0,33.46,29H30Z\"></path><path d=\"M43,33a6,6,0,1,1,6-6A6.006,6.006,0,0,1,43,33Zm0-10a4,4,0,1,0,4,4A4,4,0,0,0,43,23Z\"></path><path d=\"M18,27H14a1,1,0,0,1-1-1V24.244l-1.243,1.243a1,1,0,0,1-1.414,0l-2.83-2.83a1,1,0,0,1,0-1.414L8.756,20H7a1,1,0,0,1-1-1V15a1,1,0,0,1,1-1H8.756L7.513,12.757a1,1,0,0,1,0-1.414l2.83-2.83a1,1,0,0,1,1.414,0L13,9.756V8a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1V9.756l1.243-1.243a1,1,0,0,1,1.414,0l2.83,2.83a1,1,0,0,1,0,1.414L23.244,14H25a1,1,0,0,1,1,1v4a1,1,0,0,1-1,1H23.244l1.243,1.243a1,1,0,0,1,0,1.414l-2.83,2.83a1,1,0,0,1-1.414,0L19,24.244V26A1,1,0,0,1,18,27Zm-3-2h2V22.65a1,1,0,0,1,.713-.958,2.306,2.306,0,0,0,.4-.168,1,1,0,0,1,1.171.179l1.663,1.663,1.416-1.416L20.7,20.287a1,1,0,0,1-.179-1.171,2.234,2.234,0,0,0,.169-.406A1,1,0,0,1,21.65,18H24V16H21.65a1,1,0,0,1-.957-.71,2.234,2.234,0,0,0-.169-.406,1,1,0,0,1,.179-1.171l1.663-1.663L20.95,10.634,19.287,12.3a1,1,0,0,1-1.171.179,2.306,2.306,0,0,0-.4-.168A1,1,0,0,1,17,11.35V9H15v2.35a1,1,0,0,1-.713.958,2.306,2.306,0,0,0-.4.168,1,1,0,0,1-1.171-.179L11.05,10.634,9.634,12.05,11.3,13.713a1,1,0,0,1,.179,1.171,2.234,2.234,0,0,0-.169.406,1,1,0,0,1-.957.71H8v2h2.35a1,1,0,0,1,.957.71,2.234,2.234,0,0,0,.169.406,1,1,0,0,1-.179,1.171L9.634,21.95l1.416,1.416L12.713,21.7a1,1,0,0,1,1.171-.179,2.306,2.306,0,0,0,.4.168A1,1,0,0,1,15,22.65Z\"></path><path d=\"M16,21a4,4,0,1,1,4-4A4,4,0,0,1,16,21Zm0-6a2,2,0,1,0,2,2A2,2,0,0,0,16,15Z\"></path></g></svg></span></li><li class=\"dropdown no-hover\" uib-dropdown=\"\" ng-if=\"(!main.federationObj && !main.federationWorking) && !main.supportUserObj\"><a class=\"dropdown-toggle avatar-content\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><img alt=\"profile photo\" class=\"img-circle img-profile\" style=\"width: 30px; height: 30px\" ng-src=\"{{main.authUserObj.avatar}}\" on-error-src=\"\"></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"\"><strong>{{main.authUserObj.firstName + \' \'+ main.authUserObj.lastName}} [{{main.authUserObj.username}}]</strong></a></li><li ng-click=\"main.fnCopyInfoToClipboard(main.accountId, \'Account ID\')\" uib-tooltip=\"Click to copy Account ID\" tooltip-placement=\"left\"><a>Account ID: <strong>{{main.accountId}}</strong></a></li><li class=\"divider\"></li><li><a ng-click=\"main.fnGetProfileView()\" ng-bind=\"\'Settings\'\"></a></li><li ng-if=\"main.isAllowdAccess\"><a ng-click=\"main.fnGetAccessView()\" ng-bind=\"\'Access\'\"></a></li><li ng-if=\"main.isAccessBilling\"><a ng-click=\"main.fnGetBillingView()\" ng-bind=\"\'Billing\'\"></a></li><li ng-if=\"main.isAllowStore\"><a ng-click=\"main.fnGetStoreView()\" ng-bind=\"\'Store\'\"></a></li><li><a ng-click=\"main.fnGetDocumentationView()\" ng-bind=\"\'Documentation\'\"></a></li><li><a ng-click=\"main.fnLogoutORLock(\'lock\')\" ng-bind=\"\'Lock Session\'\"></a></li><li><a ng-click=\"main.fnLogoutORLock(\'login\')\" ng-bind=\"\'Sign Out\'\"></a></li><li class=\"divider\" ng-if=\"main.permissionObj.REQUEST_NEW_FEDERATION_SESSION && (main.outBoundFederationLoading || (!main.outBoundFederationLoading && main.isFederationEnabled))\"></li><li ng-if=\"!main.outBoundFederationLoading && main.isFederationEnabled && main.permissionObj.REQUEST_NEW_FEDERATION_SESSION\"><a class=\"\" ng-click=\"main.fnOpenFederationModal()\"><label class=\"m-b-0\">Open Federations</label></a></li><li class=\"d-flex justify-content-center align-items-center\" ng-if=\"main.outBoundFederationLoading\"><div class=\"m-r-10\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div><span>Loading Federations</span></li></ul></li><li class=\"dropdown no-hover\" uib-dropdown=\"\" ng-if=\"main.supportUserObj && (!main.federationObj && !main.federationWorking)\"><a class=\"dropdown-toggle avatar-content\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><img alt=\"profile photo\" class=\"img-circle img-profile\" style=\"width: 30px; height: 30px\" ng-src=\"{{main.fnGetUserAvatar(main.supportUserObj)}}\" on-error-src=\"\"></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"\"><i class=\"fa fa-user\"></i> {{main.authUserObj.firstName + \' \' + main.authUserObj.lastName}} [{{main.authUserObj.username}}]</a></li><li class=\"divider\"></li><li><a class=\"\"><strong>{{main.supportUserObj.sessionObj.accountName}}</strong></a></li><li ng-click=\"main.fnCopyInfoToClipboard(main.supportUserObj.sessionObj.accountId, \'Account ID\')\" uib-tooltip=\"Click to copy Account ID\" tooltip-placement=\"left\"><a>Account ID: {{main.supportUserObj.sessionObj.accountId}}</a></li><li class=\"divider\"></li><li ng-if=\"main.isAllowdAccess\"><a ng-click=\"main.fnGetAccessView()\" ng-bind=\"\'Access\'\"></a></li><li ng-if=\"main.isAccessBilling\"><a ng-click=\"main.fnGetBillingView()\" ng-bind=\"\'Billing\'\"></a></li><li ng-if=\"main.isAllowStore\"><a ng-click=\"main.fnGetStoreView()\" ng-bind=\"\'Store\'\"></a></li><li><a ng-click=\"main.fnGetDocumentationView()\" ng-bind=\"\'Documentation\'\"></a></li><li><a ng-click=\"main.fnRemoveSupport()\">Return to my account</a></li></ul></li><li class=\"dropdown no-hover\" uib-dropdown=\"\" ng-if=\"!main.supportUserObj && (main.federationObj && !main.federationWorking)\"><a class=\"dropdown-toggle avatar-content\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><img alt=\"profile photo\" class=\"img-circle img-profile\" style=\"width: 30px; height: 30px\" ng-src=\"{{main.fnGetUserAvatar(main.federationObj)}}\" on-error-src=\"\"></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"\"><i class=\"fa fa-user\"></i> {{main.authUserObj.firstName + \' \'+ main.authUserObj.lastName}} [{{main.authUserObj.username}}]</a></li><li class=\"divider\"></li><li><a class=\"\"><strong>{{main.federationObj.alias}}</strong></a></li><li ng-click=\"main.fnCopyInfoToClipboard(main.federationObj.id.split(\'-\')[1], \'Account ID\')\" uib-tooltip=\"Click to copy Account ID\" tooltip-placement=\"left\"><a>Account ID: {{main.federationObj.id.split(\"-\")[1]}}</a></li><li class=\"divider\"></li><li ng-if=\"main.isAllowdAccess\"><a ng-click=\"main.fnGetAccessView()\" ng-bind=\"\'Access\'\"></a></li><li ng-if=\"main.isAccessBilling\"><a ng-click=\"main.fnGetBillingView()\" ng-bind=\"\'Billing\'\"></a></li><li ng-if=\"main.isAllowStore\"><a ng-click=\"main.fnGetStoreView()\" ng-bind=\"\'Store\'\"></a></li><li><a ng-click=\"main.fnGetDocumentationView()\" ng-bind=\"\'Documentation\'\"></a></li><li><a ng-click=\"main.fnRemoveFedration()\">Return to my account</a></li></ul></li></ul></div></div></div></div></nav>");
$templateCache.put("app/documentation/documentation/documentation.html","<div class=\"row h-100\" ng-init=\"documentation.fnInitDocumentations()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0 height-100\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"documentation.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in documentation.tabs track by $index\" ng-click=\"documentation.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();documentation.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-auto documentation-main-page\" ng-if=\"documentation.activeTabIndex === 1\"><div class=\"col-sm-12 p-50 d-flex\"><div class=\"col-sm-3 p-0\"><div class=\"col-sm-12 p-0\"><span class=\"font-W\">Applications</span><h1 class=\"m-0 font-W\">User Guides</h1></div><div class=\"col-sm-12 p-0\"><div ng-repeat=\"obj in documentation.userGuides\" ng-class=\"$first ? \'p-t-20\':\'p-t-10\'\" class=\"p-l-0 p-r-0 p-b-10\"><span class=\"font-W-500 documentation-app-text\" ng-click=\"documentation.fnOpenNewTab(obj)\">ECSMon <span class=\"font-bold text-primary\">{{obj.name}}</span></span></div></div></div><div class=\"col-sm-3 p-0\"><div class=\"col-sm-12 p-0\"><span class=\"font-W\">Advanced Features</span><h1 class=\"m-0 font-W\">Technical</h1></div><div class=\"col-sm-12 p-0\"><div ng-repeat=\"obj in documentation.technical\" ng-class=\"$first ? \'p-t-20\':\'p-t-10\'\" class=\"p-l-0 p-r-0 p-b-10\"><span class=\"font-W-500 documentation-app-text\" ng-click=\"documentation.fnOpenNewTab(obj)\">ECSMon <span class=\"text-primary font-bold\">{{obj.name}}</span></span></div></div></div><div class=\"col-sm-3 p-0\"><div class=\"col-sm-12 p-0\"><span class=\"font-W\">Developers</span><h1 class=\"m-0 font-W\">API</h1></div><div class=\"col-sm-12 p-0\"><div ng-repeat=\"obj in documentation.api\" ng-class=\"$first ? \'p-t-20\':\'p-t-10\'\" class=\"p-l-0 p-r-0 p-b-10\"><span class=\"font-W-500 documentation-app-text\" ng-click=\"documentation.fnOpenNewTab(obj)\">ECSMon <span class=\"text-primary font-bold\">{{obj.name}}</span></span></div></div></div><div class=\"col-sm-3 p-0\"></div></div></div><div class=\"col-sm-12 p-0 overflow-auto documentation-main-page documentation-markdown-editor\" ng-if=\"documentation.activeTabIndex !== 1\" ng-init=\"documentation.fnInitDocPage()\"><div class=\"col-sm-12 p-0 hide-toolbar position-r\" ng-class=\"documentation.accountId === \'cu000000\' ? \'documentation-app-page\':\'h-100\'\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center h-100\" ng-if=\"documentation.isDocumentLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-3 p-0 height-100 overflow-auto p-t-20\" ng-if=\"!documentation.isDocumentLoading\"><ul ng-if=\"documentation.markdownTOCData && documentation.markdownTOCData.length\"><li ng-repeat=\"obj in documentation.markdownTOCData\"><a ng-click=\"documentation.fnScrollToTop(obj.markdownId)\">{{obj.markdownText}}</a><ul ng-if=\"obj.children\"><li ng-repeat=\"childrenEle in obj.children\" ng-include=\"\'markdown_toc.html\'\"></li></ul></li></ul><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"documentation.markdownTOCData && !documentation.markdownTOCData.length\"><h3 class=\"m-0\">No data found...</h3></div></div><div class=\"col-sm-9 p-0 height-100 documentation\" ng-if=\"!documentation.isDocumentLoading\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput\" ng-if=\"!documentation.isEditMode\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" ng-keyup=\"documentation.searchDocumentation($event)\" ng-model=\"documentation.searchText\" placeholder=\"Search\"></div></div><div class=\"col-sm-12 p-0\" ng-class=\"documentation.isEditMode ? \'height-100\':\'documentation-with-search-bar\'\"><textarea name=\"documentationEditor\" class=\"content-box\" ng-drop-dir-for-issue=\"\" upload-file=\"documentation.uploadFiles(type, filedata)\" ng-model=\"documentation.markdownText\" markdown-editor=\"documentation.markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\" ng-if=\"documentation.accountId === \'cu000000\'\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0 font-bold\" ng-if=\"documentation.lastUpdated !== \'\' && !documentation.isEditMode && !documentation.documentationUpdating\">Last updated: {{documentation.lastUpdated}}</label> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 m-r-10\" ng-if=\"documentation.isEditMode && !documentation.documentationUpdating && !documentation.fileUploading\" ng-click=\"documentation.fnHideShowEditorPreview(\'documentationEditor\')\">Preview</button> <button type=\"button\" class=\"btn btn-primary btn-primary-cancel m-t-0\" ng-if=\"documentation.isEditMode && !documentation.documentationUpdating && !documentation.fileUploading\" ng-click=\"documentation.fnCancelEditing(\'documentationEditor\')\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-20 p-r-20\" ng-if=\"!documentation.isEditMode && !documentation.documentationUpdating && !documentation.isDocumentLoading && documentation.accountId === \'cu000000\'\" ng-click=\"documentation.fnEditDocumentation(\'documentationEditor\')\">Edit</button> <input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"documentation.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0;width: 0\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"documentation.isEditMode && !documentation.documentationUpdating && !documentation.fileUploading && documentation.permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button p-l-20 p-r-20\" ng-if=\"documentation.isEditMode && !documentation.documentationUpdating && !documentation.fileUploading\" ng-click=\"documentation.fnSaveDocumentation(\'documentationEditor\')\">Save</button><div class=\"pull-right\" app-spinner=\"\" ng-if=\"documentation.documentationUpdating || documentation.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"markdown_toc.html\"><a ng-click=\"documentation.fnScrollToTop(childrenEle.markdownId)\">{{childrenEle.markdownText}}</a> <ul ng-if=\"childrenEle.children\"> <li ng-repeat=\"childrenEle in childrenEle.children\" ng-include=\"\'markdown_toc.html\'\"></li> </ul></script></div>");
$templateCache.put("app/insight/insight_charts/insight_charts.html","<div class=\"row h-100\" ng-init=\"insightCharts.fnInitCharts()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightCharts.activeTabIndex\"><uib-tab index=\"1\" select=\"insightCharts.fnTabChanged(insightCharts.tabs[0])\" ng-click=\"insightCharts.fnChangeTab(insightCharts.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{insightCharts.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightCharts.tabs track by $index\" select=\"insightCharts.fnTabChanged(tab)\" ng-click=\"insightCharts.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightCharts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightCharts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightCharts.fnGetChartDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!insightCharts.isFullWidthDevice\"><a ng-click=\"insightCharts.fnGetChartStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"insightCharts.isFullWidthDevice\"><a ng-click=\"insightCharts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{insightCharts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"insightCharts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"insightCharts.isFullWidthDevice && insightCharts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'chart\'\" service-name=\"\'Chart\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightCharts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightCharts.fnGetWidgetEditor()\" fn-hide-chart=\"insightCharts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightCharts.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightCharts.project.name ? insightCharts.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightCharts.chartProjectSearch[insightCharts.chartProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightCharts.filterProject=(insightCharts.projectsArr | filter:insightCharts.chartProjectSearch) track by $index\" ng-click=\"insightCharts.fnGetProjectChart(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightCharts.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightCharts.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightCharts.isRefreshData\" search-identifier=\"\'chartSearch\'\" filters-arr=\"insightCharts.searchFiltersArr\" filter-query=\"insightCharts.filterQuery\" fn-filter-query-change=\"insightCharts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_charts\'\" fn-resize=\"insightCharts.fnSetTableHeight()\" sort-field-arr=\"insightCharts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightCharts.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"insightCharts.selectedChartsArr.length\"><a ng-click=\"insightCharts.fnDeleteMultipleCharts(insightCharts.selectedChartsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"insightCharts.isShowInsightOption()\"><a ng-click=\"insightCharts.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"insightCharts.getChartCSVData()\" id=\"csvAnchor\" csv-header=\"insightCharts.csvHeaderArr\" filename=\"insightCharts.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"insightCharts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightCharts.isChartsLoading\" fn-resize=\"insightCharts.fnSetLoaderTableHeight()\"></table-loader><div class=\"charts-table table-container\"><table id=\"chartsTable\" class=\"table table-striped table-check-box\" ng-if=\"!insightCharts.isChartsLoading\"><thead><tr><th ng-if=\"insightCharts.chartsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"insightCharts.isAllChecked\" ng-click=\"insightCharts.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"insightCharts.chartsArr.length\">Name</th><th ng-if=\"insightCharts.chartsArr.length\">Project</th><th ng-if=\"insightCharts.chartsArr.length\"></th><th ng-if=\"insightCharts.chartsArr.length\"></th><th ng-if=\"insightCharts.chartsArr.length\"></th><th ng-if=\"!insightCharts.chartsArr.length\">No records found...</th></tr></thead><tbody id=\"chartTable\"><tr ng-repeat=\"chartObj in insightCharts.chartsArr track by $index\" ng-click=\"insightCharts.fnCheckUncheckHeader(chartObj);\" context-menu=\"insightCharts.chartContextMenu(chartObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"chartObj.isCheck\" ng-change=\"insightCharts.fnCheckUncheckHeader(chartObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!chartObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{chartObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{chartObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"chartObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"chartObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"chartObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!chartObj.name.length\" ng-click=\"$event.stopPropagation();insightCharts.fnSaveChartInfo(chartObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();insightCharts.fnCancelChartEditMode(chartObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!chartObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{chartObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!chartObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"chartObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{chartObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"chartObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!chartObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"chartObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{chartObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"chartObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!chartObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': insightCharts.isDropUp }\" ng-click=\"$event.stopPropagation(); insightCharts.toggleDropUp(\'chartTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightCharts.fnOpenChartInfoTab(chartObj,1)\">Details</a></li><li><a ng-click=\"insightCharts.fnOpenChartInfoTab(chartObj,2)\">Tags</a></li><li><a ng-click=\"insightCharts.fnCopyId(chartObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightCharts.isChartsLoading && insightCharts.chartsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightCharts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightCharts.perPage = 10; insightCharts.fnPageChanged(insightCharts.currentPage, insightCharts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightCharts.perPage = 20; insightCharts.fnPageChanged(insightCharts.currentPage, insightCharts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightCharts.perPage = 50; insightCharts.fnPageChanged(insightCharts.currentPage, insightCharts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightCharts.perPage = 100; insightCharts.fnPageChanged(insightCharts.currentPage,insightCharts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightCharts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightCharts.currentPage\" items-per-page=\"insightCharts.perPage\" max-size=\"insightCharts.maxSize\" boundary-links=\"true\" ng-click=\"insightCharts.fnPageChanged(insightCharts.currentPage, insightCharts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{insightCharts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : insightCharts.isRefresh}\" ng-click=\"insightCharts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"insightCharts.permissionObj.CREATE_CHART\" ng-click=\"insightCharts.fnHideShowCreateForm()\">Create Chart</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && insightCharts.selectedChartObj && insightCharts.isChartDetailsLoaded && !insightCharts.isUpdateChart && !insightCharts.isCreate && !insightCharts.isShowDashboard && !insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><insight-chart-info chart-obj=\"insightCharts.selectedChartObj\" user-permissions-obj=\"insightCharts.permissionObj\"></insight-chart-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && !insightCharts.isUpdateChart && insightCharts.isCreate && !insightCharts.isShowDashboard && !insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_charts/createChart/createChart.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && insightCharts.isUpdateChart && !insightCharts.isCreate && !insightCharts.isShowDashboard && !insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_charts/updateChart/updateChart.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && insightCharts.isShowDashboard && !insightCharts.isUpdateChart && !insightCharts.isCreate && !insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Charts</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"insightCharts.permissionObj.CREATE_CHART\"><span>Chart. To create a chart, select Create Chart.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"insightCharts.fnHideShowCreateForm()\">Create Chart</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Charts are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Charts</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && !insightCharts.isShowDashboard && !insightCharts.isUpdateChart && !insightCharts.isCreate && insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'chart\'\" service-name=\"\'Chart\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightCharts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightCharts.fnGetWidgetEditor()\" fn-hide-chart=\"insightCharts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && !insightCharts.isShowDashboard && !insightCharts.isUpdateChart && !insightCharts.isCreate && !insightCharts.isShowChartStats && insightCharts.isShowWidgetEditor && !insightCharts.isCreateIssue\"><widget-editor app-name=\"\'insight\'\" service-name=\"\'chart\'\" service-display-name=\"\'Chart\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightCharts.activeTabIndex !== 1 && !insightCharts.isShowDashboard && !insightCharts.isUpdateChart && !insightCharts.isCreate && !insightCharts.isShowChartStats && !insightCharts.isShowWidgetEditor && insightCharts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'insight\'\" service-key=\"\'chart\'\" app-name=\"\'Insight\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/insight_dashboards.html","<div class=\"row h-100\" ng-init=\"insightDashboards.fnInitDashboards()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightDashboards.activeTabIndex\"><uib-tab index=\"1\" select=\"insightDashboards.fnTabChanged(insightDashboards.tabs[0])\" ng-click=\"insightDashboards.fnChangeTab(insightDashboards.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{insightDashboards.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightDashboards.tabs track by $index\" select=\"insightDashboards.fnTabChanged(tab)\" ng-click=\"insightDashboards.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightDashboards.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightDashboards.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightDashboards.fnGetDashboardDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!insightDashboards.isFullWidthDevice\"><a ng-click=\"insightDashboards.fnGetDashboardStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"insightDashboards.isFullWidthDevice\"><a ng-click=\"insightDashboards.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{insightDashboards.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"insightDashboards.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"insightDashboards.isFullWidthDevice && insightDashboards.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'dashboard\'\" service-name=\"\'Dashboard\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightDashboards.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightDashboards.fnGetWidgetEditor()\" fn-hide-chart=\"insightDashboards.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightDashboards.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightDashboards.project.name ? insightDashboards.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightDashboards.dashboardProjectSearch[insightDashboards.dashboardProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightDashboards.filterProject=(insightDashboards.projectsArr | filter:insightDashboards.dashboardProjectSearch) track by $index\" ng-click=\"insightDashboards.fnGetProjectDashboard(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightDashboards.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightDashboards.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightDashboards.isRefreshData\" search-identifier=\"\'dashboardSearch\'\" filters-arr=\"insightDashboards.searchFiltersArr\" filter-query=\"insightDashboards.filterQuery\" fn-filter-query-change=\"insightDashboards.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_dashboards\'\" fn-resize=\"insightDashboards.fnSetTableHeight()\" sort-field-arr=\"insightDashboards.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightDashboards.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"insightDashboards.selectedDashboardsArr.length\"><a ng-click=\"insightDashboards.fnDeleteMultipleDashboards(insightDashboards.selectedDashboardsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"insightDashboards.isShowInsightOption()\"><a ng-click=\"insightDashboards.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"insightDashboards.getDashboardCSVData()\" id=\"csvAnchor\" csv-header=\"insightDashboards.csvHeaderArr\" filename=\"insightDashboards.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"insightDashboards.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightDashboards.isDashboardsLoading\" fn-resize=\"insightDashboards.fnSetLoaderTableHeight()\"></table-loader><div class=\"insight-dashboards-table table-container\"><table id=\"dashboardsTable\" class=\"table table-striped table-check-box\" ng-if=\"!insightDashboards.isDashboardsLoading\"><thead><tr><th ng-if=\"insightDashboards.dashboardsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"insightDashboards.isAllChecked\" ng-click=\"insightDashboards.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"insightDashboards.dashboardsArr.length\">Name</th><th ng-if=\"insightDashboards.dashboardsArr.length\">Project</th><th ng-if=\"insightDashboards.dashboardsArr.length\"></th><th ng-if=\"insightDashboards.dashboardsArr.length\"></th><th ng-if=\"insightDashboards.dashboardsArr.length\"></th><th ng-if=\"!insightDashboards.dashboardsArr.length\">No records found...</th></tr></thead><tbody id=\"dashboardTable\"><tr ng-repeat=\"dashboardObj in insightDashboards.dashboardsArr track by $index\" context-menu=\"insightDashboards.dashboardContextMenu(dashboardObj)\" ng-click=\"insightDashboards.fnCheckUncheckHeader(dashboardObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-change=\"insightDashboards.fnCheckUncheckHeader(dashboardObj)\" ng-model=\"dashboardObj.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!dashboardObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{dashboardObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{dashboardObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"dashboardObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"dashboardObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"dashboardObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!dashboardObj.name.length\" ng-click=\"$event.stopPropagation();insightDashboards.fnSaveDashboardInfo(dashboardObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();insightDashboards.fnCancelDashboardEditMode(dashboardObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!dashboardObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{dashboardObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!dashboardObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{dashboardObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!dashboardObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{dashboardObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!dashboardObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': insightDashboards.isDropUp }\" ng-click=\"$event.stopPropagation(); insightDashboards.toggleDropUp(\'dashboardTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightDashboards.fnOpenDashboardInfoTab(dashboardObj,1)\">Details</a></li><li><a ng-click=\"insightDashboards.fnOpenDashboardInfoTab(dashboardObj,2)\">Tags</a></li><li><a ng-click=\"insightDashboards.fnCopyId(dashboardObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightDashboards.isDashboardsLoading && insightDashboards.dashboardsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightDashboards.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightDashboards.perPage = 10; insightDashboards.fnPageChanged(insightDashboards.currentPage, insightDashboards.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightDashboards.perPage = 20; insightDashboards.fnPageChanged(insightDashboards.currentPage, insightDashboards.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightDashboards.perPage = 50; insightDashboards.fnPageChanged(insightDashboards.currentPage, insightDashboards.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightDashboards.perPage = 100; insightDashboards.fnPageChanged(insightDashboards.currentPage,insightDashboards.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightDashboards.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightDashboards.currentPage\" items-per-page=\"insightDashboards.perPage\" max-size=\"insightDashboards.maxSize\" boundary-links=\"true\" ng-click=\"insightDashboards.fnPageChanged(insightDashboards.currentPage, insightDashboards.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{insightDashboards.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : insightDashboards.isRefresh}\" ng-click=\"insightDashboards.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"insightDashboards.permissionObj.CREATE_DASHBOARD\" ng-click=\"insightDashboards.fnHideShowCreateForm()\">Create Dashboard</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && insightDashboards.selectedDashboardObj && insightDashboards.isDashboardDetailsLoaded && !insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && !insightDashboards.isShowDashboard && !insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><insight-dashboard-info dashboard-obj=\"insightDashboards.selectedDashboardObj\" user-permissions-obj=\"insightDashboards.permissionObj\"></insight-dashboard-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && !insightDashboards.isUpdateDashboard && insightDashboards.isCreate && !insightDashboards.isShowDashboard && !insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_dashboards/createDashboard/createDashboard.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && !insightDashboards.isShowDashboard && !insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_dashboards/updateDashboard/updateDashboard.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && insightDashboards.isShowDashboard && !insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && !insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Dashboards</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"insightDashboards.permissionObj.CREATE_DASHBOARD\"><span>Dashboard. To create a dashboard, select Create Dashboard.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"insightDashboards.fnHideShowCreateForm()\">Create Dashboard</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Dashboards are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Dashboards</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && !insightDashboards.isShowDashboard && !insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'dashboard\'\" service-name=\"\'Dashboard\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightDashboards.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightDashboards.fnGetWidgetEditor()\" fn-hide-chart=\"insightDashboards.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && !insightDashboards.isShowDashboard && !insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && !insightDashboards.isShowDashboardStats && insightDashboards.isShowWidgetEditor && !insightDashboards.isCreateIssue\"><widget-editor app-name=\"\'insight\'\" service-name=\"\'dashboard\'\" service-display-name=\"\'Dashboard\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightDashboards.activeTabIndex !== 1 && !insightDashboards.isShowDashboard && !insightDashboards.isUpdateDashboard && !insightDashboards.isCreate && !insightDashboards.isShowDashboardStats && !insightDashboards.isShowWidgetEditor && insightDashboards.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'insight\'\" service-key=\"\'dashboard\'\" app-name=\"\'Insight\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_project/insight_project.html","<div class=\"row h-100\" ng-init=\"insightProject.fnInitProjects()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightProject.activeTabIndex\"><uib-tab index=\"1\" select=\"insightProject.fnTabChanged(insightProject.tabs[0])\" ng-click=\"insightProject.fnChangeTab(insightProject.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"insightProject.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightProject.tabs track by $index\" select=\"insightProject.fnTabChanged(tab)\" ng-click=\"insightProject.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightProject.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightProject.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightProject.fnGetProjectDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!insightProject.isFullWidthDevice\"><a ng-click=\"insightProject.fnGetProjectStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"insightProject.fnGetProjectRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"insightProject.isFullWidthDevice\"><a ng-click=\"insightProject.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{insightProject.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"insightProject.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"insightProject.isFullWidthDevice && insightProject.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightProject.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightProject.fnGetWidgetEditor()\" fn-hide-chart=\"insightProject.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightProject.isRefreshData\" search-identifier=\"\'projectSearch\'\" filters-arr=\"insightProject.searchFiltersArr\" filter-query=\"insightProject.filterQuery\" fn-filter-query-change=\"insightProject.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_project\'\" fn-resize=\"insightProject.fnSetTableHeight()\" sort-field-arr=\"insightProject.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightProject.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"insightProject.selectedProjectsArr.length\"><a ng-click=\"insightProject.fnDeleteMultipleProjects(insightProject.selectedProjectsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"insightProject.isShowInsightOption()\"><a ng-click=\"insightProject.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"insightProject.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"insightProject.csvHeaderArr\" filename=\"insightProject.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"insightProject.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightProject.isProjectsLoading\" fn-resize=\"insightProject.fnSetLoaderTableHeight()\"></table-loader><div class=\"project-table table-container\"><table id=\"projectsTable\" class=\"table table-striped table-check-box\" ng-if=\"!insightProject.isProjectsLoading\"><thead><tr><th ng-if=\"insightProject.projectsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"insightProject.isAllChecked\" ng-click=\"insightProject.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"insightProject.projectsArr.length\"><span>Name</span></th><th ng-if=\"insightProject.projectsArr.length\"></th><th ng-if=\"insightProject.projectsArr.length\"></th><th ng-if=\"insightProject.projectsArr.length\"></th><th ng-if=\"!insightProject.projectsArr.length\">No records found...</th></tr></thead><tbody id=\"projectTable\"><tr ng-repeat=\"projectObj in insightProject.projectsArr track by $index\" ng-click=\"insightProject.fnCheckUncheckHeader(projectObj);\" context-menu=\"insightProject.projectContextMenu(projectObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectObj.isCheck\" ng-change=\"insightProject.fnCheckUncheckHeader(projectObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!projectObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{projectObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{projectObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"projectObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name for the Project*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description regarding Project\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();insightProject.fnCancelProjectEditMode(projectObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!projectObj.name.length\" ng-click=\"$event.stopPropagation();insightProject.fnSaveProjectInfo(projectObj)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!projectObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{projectObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!projectObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{projectObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!projectObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': insightProject.isDropUp }\" ng-click=\"$event.stopPropagation(); insightProject.toggleDropUp(\'projectTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightProject.fnOpenProjectInfoTab(projectObj,1)\">Details</a></li><li><a ng-click=\"insightProject.fnOpenProjectInfoTab(projectObj,2)\">Tags</a></li><li><a ng-click=\"insightProject.fnCopyId(projectObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightProject.isProjectsLoading && insightProject.projectsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightProject.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightProject.perPage = 10; insightProject.fnPageChanged(insightProject.currentPage, insightProject.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightProject.perPage = 20; insightProject.fnPageChanged(insightProject.currentPage, insightProject.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightProject.perPage = 50; insightProject.fnPageChanged(insightProject.currentPage, insightProject.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightProject.perPage = 100; insightProject.fnPageChanged(insightProject.currentPage,insightProject.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightProject.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightProject.currentPage\" items-per-page=\"insightProject.perPage\" max-size=\"insightProject.maxSize\" boundary-links=\"true\" ng-click=\"insightProject.fnPageChanged(insightProject.currentPage, insightProject.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{insightProject.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : insightProject.isRefresh}\" ng-click=\"insightProject.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"insightProject.permissionObj.CREATE_PROJECT\" ng-click=\"insightProject.fnHideShowCreateForm()\">Create Project</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && insightProject.selectedProjectObj && insightProject.isProjectDetailsLoaded && !insightProject.isCreate && !insightProject.isShowDashboard && !insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && !insightProject.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><insight-project-info project-obj=\"insightProject.selectedProjectObj\" user-permissions-obj=\"insightProject.permissionObj\"></insight-project-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && insightProject.isCreate && !insightProject.isShowDashboard && !insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && !insightProject.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_project/createProject/createInsightProject.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && insightProject.isShowDashboard && !insightProject.isCreate && !insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && !insightProject.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Projects</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>insightProject. To create a project, select Create insightProject.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"insightProject.fnHideShowCreateForm()\">Create Project</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Projects are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Projects</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && !insightProject.isShowDashboard && !insightProject.isCreate && insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && !insightProject.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightProject.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightProject.fnGetWidgetEditor()\" fn-hide-chart=\"insightProject.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && !insightProject.isShowDashboard && !insightProject.isCreate && !insightProject.isShowProjectStats && insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && !insightProject.isCreateIssue\"><widget-editor app-name=\"\'insight\'\" service-name=\"\'project\'\" service-display-name=\"\'Project\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightProject.activeTabIndex !== 1 && !insightProject.isShowDashboard && !insightProject.isCreate && !insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && !insightProject.isShowRelationships && insightProject.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'insight\'\" service-key=\"\'project\'\" app-name=\"\'Insight\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-init=\"insightProject.fnInitProjectRelationships()\" ng-if=\"insightProject.activeTabIndex !== 1 && !insightProject.isShowDashboard && !insightProject.isCreate && !insightProject.isShowProjectStats && !insightProject.isShowWidgetEditor && insightProject.isShowRelationships && !insightProject.isCreateIssue\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"insightProject.isProjectRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!insightProject.isProjectRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" project-relationships=\"\" fn-get-project-detail=\"insightProject.fnOpenProjectInfoTab(projectObj,1)\" project-obj=\"insightProject.newProjectData\"></li></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_queries/insight_queries.html","<div class=\"row h-100\" ng-init=\"insightQueries.fnInitQueries()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightQueries.activeTabIndex\"><uib-tab index=\"1\" select=\"insightQueries.fnTabChanged(insightQueries.tabs[0])\" ng-click=\"insightQueries.fnChangeTab(insightQueries.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"insightQueries.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightQueries.tabs track by $index\" select=\"insightQueries.fnTabChanged(tab)\" ng-click=\"insightQueries.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightQueries.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightQueries.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightQueries.fnGetQueriesDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!insightQueries.isFullWidthDevice\"><a ng-click=\"insightQueries.fnGetQueriesStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"insightQueries.isFullWidthDevice\"><a ng-click=\"insightQueries.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{insightQueries.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"insightQueries.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"insightQueries.isFullWidthDevice && insightQueries.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'queries\'\" service-name=\"\'Queries\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightQueries.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightQueries.fnGetWidgetEditor()\" fn-hide-chart=\"insightQueries.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightQueries.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightQueries.project.name ? insightQueries.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightQueries.queriesProjectSearch[insightQueries.queriesProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightQueries.filterProject=(insightQueries.projectsArr | filter:insightQueries.queriesProjectSearch) track by $index\" ng-click=\"insightQueries.fnGetProjectQueries(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightQueries.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightQueries.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightQueries.isRefreshData\" search-identifier=\"\'queriesssearch\'\" filters-arr=\"insightQueries.searchFiltersArr\" filter-query=\"insightQueries.filterQuery\" fn-filter-query-change=\"insightQueries.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_queries\'\" fn-resize=\"insightQueries.fnSetTableHeight()\" sort-field-arr=\"insightQueries.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightQueries.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"insightQueries.isShowInsightOption()\"><a ng-click=\"insightQueries.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"insightQueries.getQueriesCSVData()\" id=\"csvAnchor\" csv-header=\"insightQueries.csvHeaderArr\" filename=\"insightQueries.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"insightQueries.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightQueries.isQueriesLoading\" fn-resize=\"insightQueries.fnSetLoaderTableHeight()\"></table-loader><div class=\"queries-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!insightQueries.isQueriesLoading\"><thead><tr><th ng-if=\"insightQueries.queriesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"insightQueries.isAllChecked\" ng-click=\"insightQueries.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"insightQueries.queriesArr.length\">Name</th><th ng-if=\"insightQueries.queriesArr.length\">Project</th><th ng-if=\"insightQueries.queriesArr.length\"></th><th ng-if=\"insightQueries.queriesArr.length\"></th><th ng-if=\"insightQueries.queriesArr.length\"></th><th ng-if=\"!insightQueries.queriesArr.length\">No records found...</th></tr></thead><tbody id=\"queriesTable\"><tr ng-repeat=\"queriesObj in insightQueries.queriesArr track by $index\" ng-click=\"insightQueries.fnCheckUncheckHeader(queriesObj);\" context-menu=\"insightQueries.queriesContextMenu(queriesObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"queriesObj.isCheck\" ng-change=\"insightQueries.fnCheckUncheckHeader(queriesObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!queriesObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{queriesObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{queriesObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"queriesObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"queriesObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" queries=\"text\" ng-model=\"queriesObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!queriesObj.name.length\" ng-click=\"$event.stopPropagation();insightQueries.fnSaveQueriesInfo(queriesObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();insightQueries.fnCancelQueriesEditMode(queriesObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!queriesObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{queriesObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!queriesObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{queriesObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!queriesObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{queriesObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!queriesObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': insightQueries.isDropUp }\" ng-click=\"$event.stopPropagation(); insightQueries.toggleDropUp(\'queriesTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightQueries.fnOpenQueriesInfoTab(queriesObj,1)\">Details</a></li><li><a ng-click=\"insightQueries.fnOpenQueriesInfoTab(queriesObj,2)\">Query</a></li><li><a ng-click=\"insightQueries.fnOpenQueriesInfoTab(queriesObj,3)\">Tags</a></li><li><a ng-click=\"insightQueries.fnCopyId(queriesObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightQueries.isQueriesLoading && insightQueries.queriesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightQueries.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightQueries.perPage = 10; insightQueries.fnPageChanged(insightQueries.currentPage, insightQueries.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightQueries.perPage = 20; insightQueries.fnPageChanged(insightQueries.currentPage, insightQueries.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightQueries.perPage = 50; insightQueries.fnPageChanged(insightQueries.currentPage, insightQueries.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightQueries.perPage = 100; insightQueries.fnPageChanged(insightQueries.currentPage,insightQueries.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightQueries.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightQueries.currentPage\" items-per-page=\"insightQueries.perPage\" max-size=\"insightQueries.maxSize\" boundary-links=\"true\" ng-click=\"insightQueries.fnPageChanged(insightQueries.currentPage, insightQueries.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{insightQueries.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : insightQueries.isRefresh}\" ng-click=\"insightQueries.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"insightQueries.permissionObj.CREATE_QUERY\" ng-click=\"insightQueries.fnHideShowCreateForm()\">Create Query</button></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && insightQueries.selectedQueriesObj && insightQueries.isQueriesDetailsLoaded && !insightQueries.isCreate && !insightQueries.isShowDashboard && !insightQueries.isShowQueriesStats && !insightQueries.isShowWidgetEditor && !insightQueries.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><insight-query-info query-obj=\"insightQueries.selectedQueriesObj\" user-permissions-obj=\"insightQueries.permissionObj\"></insight-query-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && insightQueries.isCreate && !insightQueries.isShowDashboard && !insightQueries.isShowQueriesStats && !insightQueries.isShowWidgetEditor && !insightQueries.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_queries/createQuery/createQuery.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && insightQueries.isShowDashboard && !insightQueries.isCreate && !insightQueries.isShowQueriesStats && !insightQueries.isShowWidgetEditor && !insightQueries.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Queries</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"insightQueries.permissionObj.CREATE_QUERY\"><span>Queries. To create a query, select Create Query.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"insightQueries.fnHideShowCreateForm()\">Create Query</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Queries are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Labels</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && !insightQueries.isShowDashboard && !insightQueries.isCreate && insightQueries.isShowQueriesStats && !insightQueries.isShowWidgetEditor && !insightQueries.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'queries\'\" service-name=\"\'Queries\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightQueries.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightQueries.fnGetWidgetEditor()\" fn-hide-chart=\"insightQueries.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && !insightQueries.isShowDashboard && !insightQueries.isCreate && !insightQueries.isShowQueriesStats && insightQueries.isShowWidgetEditor && !insightQueries.isCreateIssue\"><widget-editor app-name=\"\'insight\'\" service-name=\"\'queries\'\" service-display-name=\"\'Queries\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightQueries.activeTabIndex !== 1 && !insightQueries.isShowDashboard && !insightQueries.isCreate && !insightQueries.isShowQueriesStats && !insightQueries.isShowWidgetEditor && insightQueries.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'insight\'\" service-key=\"\'queries\'\" app-name=\"\'Insight\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_query_editor/insight_query_editor.html","<div class=\"row h-100\" ng-init=\"insightQueryEditor.fnInitQueryEditors()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width-query-editor\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightQueryEditor.activeTabIndex\"><uib-tab index=\"1\" select=\"insightQueryEditor.fnTabChanged(insightQueryEditor.tabs[0])\" ng-click=\"insightQueryEditor.fnChangeTab(insightQueryEditor.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"insightQueryEditor.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightQueryEditor.tabs track by $index\" select=\"insightQueryEditor.fnTabChanged(tab)\" ng-click=\"insightQueryEditor.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightQueryEditor.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightQueryEditor.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\" style=\"width: 30px;\"><button class=\"btn btn-link p-0 d-flex align-items-center add-new-query-editor-icon\" ng-click=\"insightQueryEditor.fnAddNewQueryEditor()\" uib-tooltip=\"Add New Query Editor\" tooltip-placement=\"auto\"><svg class=\"editor-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/add-editor.svg#add-editor\"></use></svg></button></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightQueryEditor.fnGetWidgetDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden h-100\"><div class=\"content-box\"><div class=\"content-container h-100\" ng-repeat=\"tab in insightQueryEditor.tabs track by $index\" ng-if=\"tab.tabIndex === insightQueryEditor.activeTabIndex\"><query-editor tab-obj=\"tab\" ng-if=\"tab.tabIndex === insightQueryEditor.activeTabIndex && !insightQueryEditor.isCreate && tab.id !== \'Create Issue\'\"></query-editor><div class=\"col-sm-12 p-0 h-100\" ng-if=\"tab.tabIndex === insightQueryEditor.activeTabIndex && insightQueryEditor.isCreate && tab.id === \'Create Issue\'\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_query_editor/createInsightIssues/createInsightIssue.html\'\"></ng-include></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insight_widgets.html","<div class=\"row h-100\" ng-init=\"insightWidgets.fnInitWidgets()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"insightWidgets.activeTabIndex\"><uib-tab index=\"1\" select=\"insightWidgets.fnTabChanged(insightWidgets.tabs[0])\" ng-click=\"insightWidgets.fnChangeTab(insightWidgets.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{insightWidgets.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in insightWidgets.tabs track by $index\" select=\"insightWidgets.fnTabChanged(tab)\" ng-click=\"insightWidgets.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"insightWidgets.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();insightWidgets.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightWidgets.fnGetWidgetDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!insightWidgets.isFullWidthDevice\"><a ng-click=\"insightWidgets.fnGetWidgetStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"insightWidgets.isFullWidthDevice\"><a ng-click=\"insightWidgets.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{insightWidgets.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"insightWidgets.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"insightWidgets.isFullWidthDevice && insightWidgets.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'widget\'\" service-name=\"\'Widget\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightWidgets.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightWidgets.fnGetWidgetEditor()\" fn-hide-chart=\"insightWidgets.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightWidgets.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightWidgets.project.name ? insightWidgets.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightWidgets.widgetProjectSearch[insightWidgets.widgetProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightWidgets.filterProject=(insightWidgets.projectsArr | filter:insightWidgets.widgetProjectSearch) track by $index\" ng-click=\"insightWidgets.fnGetProjectWidget(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightWidgets.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightWidgets.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightWidgets.isRefreshData\" search-identifier=\"\'widgetSearch\'\" filters-arr=\"insightWidgets.searchFiltersArr\" filter-query=\"insightWidgets.filterQuery\" fn-filter-query-change=\"insightWidgets.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_widgets\'\" fn-resize=\"insightWidgets.fnSetTableHeight()\" sort-field-arr=\"insightWidgets.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightWidgets.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"insightWidgets.selectedWidgetsArr.length\"><a ng-click=\"insightWidgets.fnDeleteMultipleWidgets(insightWidgets.selectedWidgetsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"insightWidgets.isShowInsightOption()\"><a ng-click=\"insightWidgets.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"insightWidgets.getWidgetCSVData()\" id=\"csvAnchor\" csv-header=\"insightWidgets.csvHeaderArr\" filename=\"insightWidgets.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"insightWidgets.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightWidgets.isWidgetsLoading\" fn-resize=\"insightWidgets.fnSetLoaderTableHeight()\"></table-loader><div class=\"widgets-table table-container\"><table id=\"widgetsTable\" class=\"table table-striped table-check-box\" ng-if=\"!insightWidgets.isWidgetsLoading\"><thead><tr><th ng-if=\"insightWidgets.widgetsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"insightWidgets.isAllChecked\" ng-click=\"insightWidgets.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"insightWidgets.widgetsArr.length\">Name</th><th ng-if=\"insightWidgets.widgetsArr.length\">Project</th><th ng-if=\"insightWidgets.widgetsArr.length\"></th><th ng-if=\"insightWidgets.widgetsArr.length\"></th><th ng-if=\"insightWidgets.widgetsArr.length\"></th><th ng-if=\"!insightWidgets.widgetsArr.length\">No records found...</th></tr></thead><tbody id=\"widgetTable\"><tr ng-repeat=\"widgetObj in insightWidgets.widgetsArr track by $index\" ng-click=\"insightWidgets.fnCheckUncheckHeader(widgetObj);\" context-menu=\"insightWidgets.widgetContextMenu(widgetObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"widgetObj.isCheck\" ng-change=\"insightWidgets.fnCheckUncheckHeader(widgetObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!widgetObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{widgetObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{widgetObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"widgetObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"widgetObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"widgetObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!widgetObj.name.length\" ng-click=\"$event.stopPropagation();insightWidgets.fnSaveWidgetInfo(widgetObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();insightWidgets.fnCancelWidgetEditMode(widgetObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!widgetObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{widgetObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!widgetObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"widgetObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{widgetObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"widgetObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{widgetObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!widgetObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"widgetObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{widgetObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"widgetObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{widgetObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!widgetObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': insightWidgets.isDropUp }\" ng-click=\"$event.stopPropagation(); insightWidgets.toggleDropUp(\'widgetTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"insightWidgets.fnOpenWidgetInfoTab(widgetObj,1)\">Details</a></li><li><a ng-click=\"insightWidgets.fnOpenWidgetInfoTab(widgetObj,2)\">Tags</a></li><li><a ng-click=\"insightWidgets.fnCopyId(widgetObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightWidgets.isWidgetsLoading && insightWidgets.widgetsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightWidgets.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightWidgets.perPage = 10; insightWidgets.fnPageChanged(insightWidgets.currentPage, insightWidgets.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgets.perPage = 20; insightWidgets.fnPageChanged(insightWidgets.currentPage, insightWidgets.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgets.perPage = 50; insightWidgets.fnPageChanged(insightWidgets.currentPage, insightWidgets.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgets.perPage = 100; insightWidgets.fnPageChanged(insightWidgets.currentPage,insightWidgets.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightWidgets.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightWidgets.currentPage\" items-per-page=\"insightWidgets.perPage\" max-size=\"insightWidgets.maxSize\" boundary-links=\"true\" ng-click=\"insightWidgets.fnPageChanged(insightWidgets.currentPage, insightWidgets.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{insightWidgets.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : insightWidgets.isRefresh}\" ng-click=\"insightWidgets.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"insightWidgets.permissionObj.CREATE_WIDGET\" ng-click=\"insightWidgets.fnHideShowCreateForm()\">Create Widget</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && insightWidgets.selectedWidgetObj && insightWidgets.isWidgetDetailsLoaded && !insightWidgets.isUpdateWidget && !insightWidgets.isCreate && !insightWidgets.isShowDashboard && !insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><insight-widget-info widget-obj=\"insightWidgets.selectedWidgetObj\" user-permissions-obj=\"insightWidgets.permissionObj\"></insight-widget-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && !insightWidgets.isUpdateWidget && insightWidgets.isCreate && !insightWidgets.isShowDashboard && !insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_widgets/createWidget/createWidget.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && insightWidgets.isUpdateWidget && !insightWidgets.isCreate && !insightWidgets.isShowDashboard && !insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/insight/insight_widgets/updateWidget/updateWidget.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && insightWidgets.isShowDashboard && !insightWidgets.isUpdateWidget && !insightWidgets.isCreate && !insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Widgets</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"insightWidgets.permissionObj.CREATE_WIDGET\"><span>Widget. To create a widget, select Create Widget.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"insightWidgets.fnHideShowCreateForm()\">Create Widget</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Widgets are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Widgets</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && !insightWidgets.isShowDashboard && !insightWidgets.isUpdateWidget && !insightWidgets.isCreate && insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'insight\'\" service-key=\"\'widget\'\" service-name=\"\'Widget\'\" app-name=\"\'Insight\'\" fn-get-chart-detail=\"insightWidgets.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"insightWidgets.fnGetWidgetEditor()\" fn-hide-chart=\"insightWidgets.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && !insightWidgets.isShowDashboard && !insightWidgets.isUpdateWidget && !insightWidgets.isCreate && !insightWidgets.isShowWidgetStats && insightWidgets.isShowWidgetEditor && !insightWidgets.isCreateIssue\"><widget-editor app-name=\"\'insight\'\" service-name=\"\'widget\'\" service-display-name=\"\'Widget\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"insightWidgets.activeTabIndex !== 1 && !insightWidgets.isShowDashboard && !insightWidgets.isUpdateWidget && !insightWidgets.isCreate && !insightWidgets.isShowWidgetStats && !insightWidgets.isShowWidgetEditor && insightWidgets.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'insight\'\" service-key=\"\'widget\'\" app-name=\"\'Insight\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/alarmHistory/alarmHistory.html","<div class=\"row h-100\" ng-init=\"alarmHistory.fnInitAlarms()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"alarmHistory.activeTabIndex\"><uib-tab index=\"1\" select=\"alarmHistory.fnTabChanged(alarmHistory.tabs[0])\" ng-click=\"alarmHistory.fnChangeTab(alarmHistory.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{alarmHistory.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in alarmHistory.tabs track by $index\" select=\"alarmHistory.fnTabChanged(tab)\" ng-click=\"alarmHistory.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"alarmHistory.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();alarmHistory.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistory.fnGetAlarmDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!alarmHistory.isFullWidthDevice\"><a ng-click=\"alarmHistory.fnGetAlarmStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"alarmHistory.isFullWidthDevice\"><a ng-click=\"alarmHistory.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{alarmHistory.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"alarmHistory.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"alarmHistory.isFullWidthDevice && alarmHistory.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'alarmHistory\'\" service-name=\"\'Alarm History\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"alarmHistory.fnOpenInsightCreateIssueTab(chartObj)\" fn-get-chart-editor=\"alarmHistory.fnGetWidgetEditor()\" fn-hide-chart=\"alarmHistory.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"alarmHistory.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{alarmHistory.project.name ? alarmHistory.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"alarmHistory.alarmProjectSearch[alarmHistory.alarmProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in alarmHistory.filterProject=(alarmHistory.projectsArr | filter:alarmHistory.alarmProjectSearch) track by $index\" ng-click=\"alarmHistory.fnGetProjectAlarm(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === alarmHistory.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!alarmHistory.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"alarmHistory.isRefreshData\" search-identifier=\"\'nodeSearch\'\" filters-arr=\"alarmHistory.searchFiltersArr\" filter-query=\"alarmHistory.filterQuery\" fn-filter-query-change=\"alarmHistory.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.alarmHistory\'\" fn-resize=\"alarmHistory.fnSetTableHeight()\" sort-field-arr=\"alarmHistory.sortFieldArr\" is-column-view=\"true\" table-alias=\"alarmHistory.tableAlias\"></v4-search-client></div><div class=\"p-0 alarm-history-date-range position-r m-l-15\"><div class=\"p-r-0 h-44px position-r\"><div class=\"col-sm-12 p-l-20 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"alarmHistory.fnOpenData()\"><span class=\"m-0 ellipsis\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"m-l-15\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistory.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"alarmHistory.isShowInsightOption()\"><a ng-click=\"alarmHistory.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"alarmHistory.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"alarmHistory.csvHeaderArr\" filename=\"alarmHistory.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"alarmHistory.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"alarmHistory.isAlarmsLoading\" fn-resize=\"alarmHistory.fnSetLoaderTableHeight()\"></table-loader><div class=\"alarm-history-table table-container\"><table id=\"alarmsTable\" class=\"table table-striped table-check-box\" ng-if=\"!alarmHistory.isAlarmsLoading\"><thead><tr><th ng-if=\"alarmHistory.alarmsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"alarmHistory.isAllChecked\" ng-click=\"alarmHistory.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\">Name</th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarmHistory.alarmsArr.length\"></th><th ng-if=\"!alarmHistory.alarmsArr.length\">No records found...</th></tr></thead><tbody id=\"alarmTable\"><tr ng-repeat=\"alarmObj in alarmHistory.alarmsArr track by $index\" ng-click=\"alarmHistory.fnCheckUncheckHeader(alarmObj, alarmHistory.alarmsArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"alarmObj.isCheck\" ng-change=\"alarmHistory.fnCheckUncheckCheckbox(alarmObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmHistory.fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{alarmObj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.healthUpdatedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.timestamp\"><label class=\"ellipsis m-b-0\">Health last updated {{alarmObj.healthUpdatedDate}}</label></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.ecuName}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.nodeName}}</span></div></div></td><td class=\"text-right\" ng-show=\"!alarmObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': alarmHistory.isDropUp }\" ng-click=\"$event.stopPropagation(); alarmHistory.toggleDropUp(\'alarmTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistory.fnOpenAlarmInfoTab(alarmObj,1)\">Telemetry</a></li><li><a ng-click=\"alarmHistory.fnOpenAlarmInfoTab(alarmObj,2)\">Details</a></li><li><a ng-click=\"alarmHistory.fnOpenCreateIssueTab(alarmObj)\">Create Issue</a></li><li ng-if=\"alarmHistory.permissionObj.REQUEST_NODE_TUNNEL && alarmObj.ecuId !== alarmObj.nodeId\"><a ng-click=\"alarmHistory.fnRequestNodeTunnel(alarmObj)\">Open Tunnel</a></li><li ng-if=\"alarmHistory.isShowTunnelOption && alarmObj.ecuId === alarmObj.nodeId\"><a ng-click=\"alarmHistory.fnRequestECUTunnel(alarmObj)\">Open Tunnel</a></li><li><a ng-click=\"alarmHistory.fnCopyId(alarmObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!alarmHistory.isAlarmsLoading && alarmHistory.alarmsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{alarmHistory.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"alarmHistory.perPage = 10; alarmHistory.fnPageChanged(alarmHistory.currentPage, alarmHistory.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistory.perPage = 20; alarmHistory.fnPageChanged(alarmHistory.currentPage, alarmHistory.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistory.perPage = 50; alarmHistory.fnPageChanged(alarmHistory.currentPage, alarmHistory.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistory.perPage = 100; alarmHistory.fnPageChanged(alarmHistory.currentPage,alarmHistory.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"alarmHistory.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"alarmHistory.currentPage\" items-per-page=\"alarmHistory.perPage\" max-size=\"alarmHistory.maxSize\" boundary-links=\"true\" ng-click=\"alarmHistory.fnPageChanged(alarmHistory.currentPage, alarmHistory.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{alarmHistory.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : alarmHistory.isRefresh}\" ng-click=\"alarmHistory.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && !alarmHistory.isCreate && alarmHistory.selectedAlarmObj && alarmHistory.isAlarmDetailsLoaded && !alarmHistory.isShowDashboard && !alarmHistory.isShowAlarmStats && !alarmHistory.isShowWidgetEditor && !alarmHistory.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><alarm-history-info alarm-obj=\"alarmHistory.selectedAlarmObj\" user-permissions-obj=\"alarmHistory.permissionObj\"></alarm-history-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && alarmHistory.isCreate && !alarmHistory.isShowDashboard && !alarmHistory.isShowIssueStats && !alarmHistory.isShowWidgetEditor && !alarmHistory.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/alarms/createAttributeIssue/createAttributeIssue.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && !alarmHistory.isCreate && alarmHistory.isShowDashboard && !alarmHistory.isShowAlarmStats && !alarmHistory.isShowWidgetEditor && !alarmHistory.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Alarm History</h1><h2 class=\"m-t-10 m-0\"></h2></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && !alarmHistory.isCreate && !alarmHistory.isShowDashboard && alarmHistory.isShowAlarmStats && !alarmHistory.isShowWidgetEditor && !alarmHistory.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'alarmHistory\'\" service-name=\"\'Alarm History\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"alarmHistory.fnOpenInsightCreateIssueTab(chartObj)\" fn-get-chart-editor=\"alarmHistory.fnGetWidgetEditor()\" fn-hide-chart=\"alarmHistory.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && !alarmHistory.isCreate && !alarmHistory.isShowDashboard && !alarmHistory.isShowAlarmStats && alarmHistory.isShowWidgetEditor && !alarmHistory.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'alarmHistory\'\" service-display-name=\"\'Alarm History\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarmHistory.activeTabIndex !== 1 && !alarmHistory.isCreate && !alarmHistory.isShowDashboard && !alarmHistory.isShowAlarmStats && !alarmHistory.isShowWidgetEditor && alarmHistory.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'alarmHistory\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/alarms/alarms.html","<div class=\"row h-100\" ng-init=\"alarm.fnInitAlarms()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"alarm.activeTabIndex\"><uib-tab index=\"1\" select=\"alarm.fnTabChanged(alarm.tabs[0])\" ng-click=\"alarm.fnChangeTab(alarm.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{alarm.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in alarm.tabs track by $index\" select=\"alarm.fnTabChanged(tab)\" ng-click=\"alarm.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"alarm.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();alarm.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarm.fnGetAlarmDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!alarm.isFullWidthDevice\"><a ng-click=\"alarm.fnGetAlarmStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"alarm.isFullWidthDevice\"><a ng-click=\"alarm.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{alarm.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"alarm.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"alarm.isFullWidthDevice && alarm.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'alarm\'\" service-name=\"\'Alarm\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"alarm.fnOpenInsightCreateIssueTab(chartObj)\" fn-get-chart-editor=\"alarm.fnGetWidgetEditor()\" fn-hide-chart=\"alarm.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"alarm.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{alarm.project.name ? alarm.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"alarm.alarmProjectSearch[alarm.alarmProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in alarm.filterProject=(alarm.projectsArr | filter:alarm.alarmProjectSearch) track by $index\" ng-click=\"alarm.fnGetProjectAlarm(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === alarm.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!alarm.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"alarm.isRefreshData\" search-identifier=\"\'nodeSearch\'\" filters-arr=\"alarm.searchFiltersArr\" filter-query=\"alarm.filterQuery\" fn-filter-query-change=\"alarm.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.alarms\'\" fn-resize=\"alarm.fnSetTableHeight()\" sort-field-arr=\"alarm.sortFieldArr\" is-column-view=\"true\" table-alias=\"alarm.tableAlias\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarm.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"alarm.isShowInsightOption()\"><a ng-click=\"alarm.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li><a ng-click=\"alarm.fnOpenIssueListModal(alarm.selectedAlarmsArr)\" ng-class=\"!alarm.selectedAlarmsArr.length ? \'pace opacity-5\' : \'\'\"><i class=\"m-r-5 fa fa-list\"></i>Add to Issue</a></li><li ng-hide=\"true\"><a ng-csv=\"alarm.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"alarm.csvHeaderArr\" filename=\"alarm.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"alarm.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"alarm.isAlarmsLoading\" fn-resize=\"alarm.fnSetLoaderTableHeight()\"></table-loader><div class=\"alarms-table table-container\"><table id=\"alarmsTable\" class=\"table table-striped table-check-box\" ng-if=\"!alarm.isAlarmsLoading\"><thead><tr><th ng-if=\"alarm.alarmsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"alarm.isAllChecked\" ng-click=\"alarm.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\">Name</th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th class=\"\" ng-if=\"alarm.alarmsArr.length\">Mode</th><th class=\"\" ng-if=\"alarm.alarmsArr.length\"></th><th ng-if=\"!alarm.alarmsArr.length\">No records found...</th></tr></thead><tbody id=\"alarmTable\"><tr ng-repeat=\"alarmObj in alarm.alarmsArr track by $index\" ng-click=\"alarm.fnCheckUncheckHeader(alarmObj, alarm.alarmsArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"alarmObj.isCheck\" ng-change=\"alarm.fnCheckUncheckCheckbox(alarmObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarm.fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{alarmObj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}\" tooltip-placement=\"auto\"><label class=\"ellipsis m-b-0\"><strong>{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}</strong></label></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.receivedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.receivedAt\"><label class=\"ellipsis m-b-0\">Value last updated {{alarmObj.receivedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.healthUpdatedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.healthLastChangedAt\"><label class=\"ellipsis m-b-0\">Health last updated {{alarmObj.healthUpdatedDate}}</label></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.ecuName}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.nodeName}}</span></div></div></td><td><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"alarmObj.syncState === \'READY\'\">Ready</span> <span ng-if=\"alarmObj.syncState === \'SYNCHRONIZING\'\"><span ng-if=\"alarmObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"alarmObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"alarmObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"alarmObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"alarmObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"alarmObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"alarmObj.lifecycleState === \'READY\'\">Ready</span> <span ng-if=\"alarmObj.lifecycleState === \'FAILED\'\">Failed</span></span> <span ng-if=\"alarmObj.syncState === \'NOT_SYNCHRONIZED\'\"><button ng-if=\"!alarmObj.deploysUnsynchronizedAlarm\" ng-click=\"$event.stopPropagation(); alarm.fnDeployAttribute(alarmObj)\" class=\"btn btn-primary v4-primary-button\">Synchronize</button><div ng-if=\"alarmObj.deploysUnsynchronizedAlarm\"><span class=\"font-italic\">Synchronizing...</span></div></span></div></div></td><td><div class=\"col-sm-12 p-0 d-flex\" ng-show=\"!alarmObj.isEditable\"><div class=\"d-flex align-items-center\" uib-tooltip=\"View issues\" tooltip-placement=\"auto\" ng-click=\"$event.stopPropagation();alarm.fnOpenLinkIssueModal(alarmObj)\" ng-if=\"alarmObj.issueIds && alarmObj.issueIds.length\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use></svg></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.mode}}</label></div></td><td class=\"text-right\" ng-show=\"!alarmObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': alarm.isDropUp }\" ng-click=\"$event.stopPropagation(); alarm.toggleDropUp(\'alarmTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarm.fnOpenAlarmInfoTab(alarmObj,1)\">Alarms Telemetry</a></li><li><a ng-click=\"alarm.fnOpenRelatedAlarmInfo(alarmObj)\">Related Telemetry</a></li><li><a ng-click=\"alarm.fnOpenAlarmInfoTab(alarmObj,2)\">Details</a></li><li><a ng-click=\"alarm.fnOpenCreateIssueTab(alarmObj)\">Track Issue</a></li><li><a ng-click=\"alarm.fnOpenIssueListModal([alarmObj])\">Add to Issue</a></li><li ng-if=\"alarm.permissionObj.REQUEST_NODE_TUNNEL && alarmObj.ecuId !== alarmObj.nodeId\"><a ng-click=\"alarm.fnRequestNodeTunnel(alarmObj)\">Open Tunnel</a></li><li ng-if=\"alarm.isShowTunnelOption && alarmObj.ecuId === alarmObj.nodeId\"><a ng-click=\"alarm.fnRequestECUTunnel(alarmObj)\">Open Tunnel</a></li><li><a ng-click=\"alarm.fnCopyId(alarmObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!alarm.isAlarmsLoading && alarm.alarmsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{alarm.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"alarm.perPage = 10; alarm.fnPageChanged(alarm.currentPage, alarm.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"alarm.perPage = 20; alarm.fnPageChanged(alarm.currentPage, alarm.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"alarm.perPage = 50; alarm.fnPageChanged(alarm.currentPage, alarm.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"alarm.perPage = 100; alarm.fnPageChanged(alarm.currentPage,alarm.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"alarm.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"alarm.currentPage\" items-per-page=\"alarm.perPage\" max-size=\"alarm.maxSize\" boundary-links=\"true\" ng-click=\"alarm.fnPageChanged(alarm.currentPage, alarm.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{alarm.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : alarm.isRefresh}\" ng-click=\"alarm.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && !alarm.isCreate && alarm.selectedAlarmObj && alarm.isAlarmDetailsLoaded && !alarm.isShowDashboard && !alarm.isShowAlarmStats && !alarm.isShowWidgetEditor && !alarm.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><alarm-info alarm-obj=\"alarm.selectedAlarmObj\" user-permissions-obj=\"alarm.permissionObj\"></alarm-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && alarm.isCreate && !alarm.isShowDashboard && !alarm.isShowIssueStats && !alarm.isShowWidgetEditor && !alarm.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/alarms/createAttributeIssue/createAttributeIssue.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && !alarm.isCreate && alarm.isShowDashboard && !alarm.isShowAlarmStats && !alarm.isShowWidgetEditor && !alarm.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Nodes</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && !alarm.isCreate && !alarm.isShowDashboard && alarm.isShowAlarmStats && !alarm.isShowWidgetEditor && !alarm.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'alarm\'\" service-name=\"\'Alarm\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"alarm.fnOpenInsightCreateIssueTab(chartObj)\" fn-get-chart-editor=\"alarm.fnGetWidgetEditor()\" fn-hide-chart=\"alarm.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && !alarm.isCreate && !alarm.isShowDashboard && !alarm.isShowAlarmStats && alarm.isShowWidgetEditor && !alarm.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'alarm\'\" service-display-name=\"\'Alarm\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"alarm.activeTabIndex !== 1 && !alarm.isCreate && !alarm.isShowDashboard && !alarm.isShowAlarmStats && !alarm.isShowWidgetEditor && alarm.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'alarm\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/cluster/cluster.html","<div class=\"row h-100\" ng-init=\"clusters.fnInitClusters()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"clusters.permissionObj.List\" field-arr=\"clusters.searchFieldArr\" filter-query=\"clusters.filterQuery\" state-name=\"\'main.cluster\'\" fn-filter-query-change=\"clusters.fnFilterQueryChanged(filterQuery)\" fn-resize=\"clusters.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"clusters.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"clusters.isClustersLoading\" fn-resize=\"clusters.fnSetLoaderTableHeight()\"></table-loader><div class=\"clusters-table table-container\"><table id=\"clusters-table\" class=\"table table-striped table-check-box\" ng-if=\"!clusters.isClustersLoading\"><thead><tr><th ng-if=\"clusters.clustersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"clusters.isAllChecked\" ng-click=\"clusters.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"clusters.clustersArr.length\"><span ng-click=\"clusters.fnClustersSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"clusters.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"clusters.clustersArr.length\"></th><th ng-if=\"!clusters.clustersArr.length\">No records found...</th></tr></thead><tbody id=\"clusterTable\"><tr ng-repeat=\"cluster in clusters.clustersArr track by $index\" ng-click=\"clusters.fnGetCluster(cluster, clusters.clustersArr);\" context-menu=\"clusters.clusterContextMenu(cluster)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"cluster.isCheck\" ng-change=\"clusters.fnCheckUncheckHeader(cluster)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!cluster.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{cluster.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{cluster.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"cluster.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"cluster.name\" placeholder=\"Name for the Cluster*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"cluster.description\" placeholder=\"Description regarding Cluster\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();clusters.fnCancelClusterEditMode(cluster)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!cluster.name.length\" ng-click=\"$event.stopPropagation();clusters.fnSaveClusterInfo(cluster)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!cluster.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': clusters.isDropUp }\" ng-click=\"$event.stopPropagation(); clusters.toggleDropUp(\'clusterTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"clusters.fnOpenClustersInfoTab(cluster,1)\">Details</a></li><li><a ng-click=\"clusters.fnOpenClustersInfoTab(cluster,2)\">Devices</a></li><li><a ng-click=\"clusters.fnOpenClustersInfoTab(cluster,3)\">Gateways</a></li><li><a ng-click=\"clusters.fnOpenClustersInfoTab(cluster,4)\">Topology</a></li><li><a ng-click=\"clusters.fnOpenClustersInfoTab(cluster,5)\">Supplemental</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!clusters.isClustersLoading && clusters.clustersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{clusters.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"clusters.perPage = 10; clusters.fnPageChanged(clusters.currentPage, clusters.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"clusters.perPage = 20; clusters.fnPageChanged(clusters.currentPage, clusters.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"clusters.perPage = 50; clusters.fnPageChanged(clusters.currentPage, clusters.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"clusters.perPage = 100; clusters.fnPageChanged(clusters.currentPage,clusters.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"clusters.perPage = 500; clusters.fnPageChanged(clusters.currentPage, clusters.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"clusters.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"clusters.currentPage\" items-per-page=\"clusters.perPage\" max-size=\"clusters.maxSize\" boundary-links=\"true\" ng-click=\"clusters.fnPageChanged(clusters.currentPage, clusters.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!clusters.permissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"clusters.permissionObj.List\"><label>Total: {{clusters.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : clusters.isRefresh}\" ng-click=\"clusters.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"clusters.permissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"clusters.fnHideShowCreateForm()\">Create Cluster</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"clusters.selectedClustersArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of Selected Clusters:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedCluster in clusters.selectedClustersArr\" is-open=\"cluster.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedCluster.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); clusters.fnCheckUncheckHeader(selectedCluster, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedCluster.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedCluster.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"clusters.selectedClustersArr.length && clusters.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"clusters.permissionObj.Delete\" ng-click=\"clusters.fnDeleteMultipleClusters(clusters.selectedClustersArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-show=\"!clusters.isCreate && !clusters.selectedClustersArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-th\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Clusters</label></div><div class=\"col-sm-12\" ng-if=\"clusters.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"clusters.fnHideShowCreateForm()\">Create Cluster</button></div></div></div><div class=\"form-container\" ng-if=\"clusters.isCreate && !clusters.selectedClustersArr.length\"><ng-include src=\"\'app/node/cluster/createCluster/createCluster.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"clusters.selectedClustersArr.length === 1 && clusters.selectedClusterObj && !clusters.isClusterDetailsLoaded\"></div><div ng-if=\"clusters.selectedClustersArr.length === 1 && clusters.selectedClusterObj && clusters.isClusterDetailsLoaded\"><cluster-info cluster-obj=\"clusters.selectedClusterObj\" types-arr=\"clusters.typesArr\" cluster-permissions-obj=\"clusters.permissionObj\"></cluster-info></div></div></div></div></div></div>");
$templateCache.put("app/node/device/devices.html","<div class=\"row h-100\" ng-init=\"devices.fnInitDevices()\"><div class=\"col-sm-12 h-100\"><div class=\"h-100 p-l-0\" ng-show=\"devices.tableSectionView\" ng-class=\"devices.tableClass\"><div class=\"content-box\" ng-if=\"!devices.isDeviceVisualizerLoaded\"><div class=\"content-box-content\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div></div><div class=\"content-box\" ng-if=\"devices.isDeviceVisualizerLoaded\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"devices.devicePermissionObj.List\"><div class=\"p-0 w100\" style=\"width: calc(100% - 45px)\" node-search-directive-v4=\"\" device-filters=\"devices.deviceFilter\" field-arr=\"devices.searchFieldArr\" filter-query=\"devices.filterQuery\" state-name=\"\'main.device\'\" fn-filter-query-change=\"devices.fnFilterQueryChanged(filterQuery,sortQuery,isCalledDirective,isCalledFromInit)\" is-called-for-view-visualizer=\"true\" types-arr=\"devices.deviceTypesArr\" gateways-arr=\"devices.gatewaysArr\" is-search-result-loaded=\"devices.isDeviceSearchDataLoaded\" fn-resize=\"devices.fnSetTableHeight()\"></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"devices.fnDeviceTableFullScreen()\"><expand-collapse-container info-section-class=\"devices.tableClass\"></expand-collapse-container>{{devices.tableClass === \'col-sm-6\'?\'Expand\':\'Collapse\'}}</a></li><li><a ng-click=\"devices.fnTabChanged(devices.tabs[0])\"><i class=\"m-r-5 fa fa-table\"></i>Table View</a></li><li><a ng-click=\"devices.fnTabChanged(devices.tabs[1])\"><i class=\"m-r-5 fa fa-map-marker\"></i>Map View</a></li><li><a ng-click=\"devices.fnTabChanged(devices.tabs[3])\"><i class=\"m-r-5 fa fa-trello\"></i>Tree Map View</a></li><li><a ng-click=\"devices.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"devices.getDeviceCSVData()\" id=\"csvAnchor\" csv-header=\"devices.csvHeaderArr\" filename=\"devices.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"devices.devicePermissionObj.List\"><div class=\"col-sm-12\" ng-if=\"devices.selectedTab.tabIndex === 0\"><table-loader ng-if=\"devices.isDevicesLoading\" fn-resize=\"devices.fnSetLoaderTableHeight()\"></table-loader><div class=\"devices-table table-container\"><table class=\"deviceMainTable table table-striped table-check-box\" ng-if=\"!devices.isDevicesLoading\"><thead><tr><th ng-if=\"devices.devicesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"devices.isAllChecked\" ng-click=\"devices.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"devices.devicesArr.length\"></th><th ng-if=\"devices.devicesArr.length\"></th><th class=\"p-r-2\" ng-if=\"devices.devicesArr.length\"></th><th class=\"text-center\" ng-if=\"devices.devicesArr.length\"></th><th ng-if=\"!devices.devicesArr.length\">No records found...</th></tr></thead><tbody id=\"deviceConnection\"><tr ng-repeat=\"deviceObj in devices.devicesArr track by $index\" ng-click=\"devices.fnGetDevice(deviceObj, devices.devicesArr);\" context-menu=\"devices.deviceContextMenu(deviceObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"deviceObj.isCheck\" ng-change=\"devices.fnCheckUncheckHeader(deviceObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\" ng-show=\"!deviceObj.isEditable\" aria-hidden=\"false\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{deviceObj.connection === \'CONNECTED\' ?\'CONNECTED\':\'DISCONNECTED\'}}\" tooltip-placement=\"auto\" ng-style=\"devices.fnGetGatewayConnectionIconColor(deviceObj.connection)\"><span ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" class=\"device-disconnected\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-show=\"!deviceObj.isEditable\"><span class=\"deviceHasComponents\" ng-if=\"deviceObj.hasComponents\" uib-tooltip=\"This device has components\" tooltip-placement=\"auto\" style=\"display: inline-block;height: 16px;width: 16px;\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\"><g><g><path d=\"M128,213.334c-11.797-0.001-21.333,9.557-21.333,21.333v42.667c0,11.776,9.536,21.333,21.333,21.333 s21.333-9.557,21.333-21.333v-42.667C149.333,222.891,139.797,213.334,128,213.334z\"></path></g></g><g><g><path d=\"M207.083,326.25c-8.342-8.341-21.824-8.341-30.166,0.001l-29.056,29.056c-3.029-8.107-10.688-13.973-19.861-13.973 c-9.173,0-16.832,5.867-19.84,13.973l-29.077-29.056c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165l34.539,34.539 C71.764,398.571,64,411.712,64,426.667v42.667C64,492.864,83.135,512,106.667,512h42.667c23.53,0,42.666-19.136,42.666-42.667 v-42.667c0-14.955-7.765-28.096-19.456-35.712l34.539-34.539C215.424,348.074,215.424,334.591,207.083,326.25z\"></path></g></g><g><g><path d=\"M463.083,326.251c-8.341-8.341-21.824-8.341-30.165,0l-29.056,29.056c-3.029-8.107-10.688-13.973-19.861-13.973 c-9.173,0-16.832,5.867-19.861,13.973l-29.056-29.056c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165l34.539,34.539 C327.765,398.571,320,411.712,320,426.667v42.667c0,23.53,19.136,42.666,42.667,42.666h42.667 c23.53,0,42.666-19.136,42.666-42.667v-42.667c0-14.955-7.765-28.096-19.456-35.712l34.539-34.539 C471.424,348.075,471.424,334.592,463.083,326.251z\"></path></g></g><g><g><path d=\"M245.854,212.864c-11.883-1.109-23.381-4.181-34.155-9.109c-10.752-4.949-23.36-0.171-28.267,10.517 c-4.885,10.731-0.192,23.381,10.517,28.288c15.125,6.912,31.253,11.221,47.915,12.779c0.683,0.064,1.344,0.107,2.005,0.107 c10.901,0,20.203-8.299,21.227-19.349C266.185,224.384,257.588,213.973,245.854,212.864z\"></path></g></g><g><g><path d=\"M373.421,270.347c-10.304-13.099-22.635-24.299-36.651-33.323c-9.877-6.379-23.125-3.499-29.483,6.4 c-6.377,9.92-3.519,23.125,6.401,29.483c10.027,6.443,18.837,14.464,26.197,23.808c4.203,5.355,10.453,8.149,16.789,8.149 c4.587,0,9.237-1.493,13.163-4.565C379.096,293.003,380.695,279.606,373.421,270.347z\"></path></g></g><g><g><path d=\"M149.333,0h-42.667C83.135,0,64,19.136,64,42.667v42.667C64,108.864,83.135,128,106.667,128v21.333 c0,9.216,5.931,16.896,14.123,19.883c0.896,1.941,1.472,4.032,2.453,5.952c3.797,7.339,11.264,11.541,18.987,11.541 c3.285,0,6.656-0.768,9.771-2.368c10.453-5.419,14.571-18.283,9.173-28.757c-4.544-8.768-7.488-18.176-9.408-27.84 C174.143,126.464,192,108.032,192,85.333V42.667C192,19.136,172.864,0,149.333,0z\"></path></g></g></svg></span> {{deviceObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\" ng-show=\"!deviceObj.isEditable\">{{deviceObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\" ng-show=\"!deviceObj.isEditable\"><span ng-if=\"deviceObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{deviceObj.phase}}\" tooltip-placement=\"auto\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"devices.fnGetPhaseIconBorderColor(deviceObj.phase)\"><span ng-class=\"devices.fnGetPhaseIcon(deviceObj.phase)\"></span></span> <button ng-if=\"deviceObj.phase === \'PRODUCTION\' && deviceObj.health\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"devices.fnGetHealthColor(deviceObj.health, deviceObj)\"><span class=\"healtSpan\">{{deviceObj.healthName}}</span></button></div></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput\" ng-show=\"deviceObj.isEditable\"><div class=\"col-sm-5\" ng-click=\"$event.stopPropagation();\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"deviceObj.name\" placeholder=\"Name for the new Device*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-show=\"deviceObj.isEditable\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"deviceObj.description\" placeholder=\"Description regarding Device\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();devices.fnCancelDeviceEditMode(deviceObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!deviceObj.name.length\" ng-click=\"$event.stopPropagation();devices.fnSaveDeviceInfo(deviceObj)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!deviceObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-if=\"devices.devicePermissionObj.CreateTunnel || devices.gatewayPermissionObj.List\" ng-class=\"{ \'dropup\': devices.isDropUp }\" ng-click=\"$event.stopPropagation();devices.toggleDropUp(\'deviceConnection\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"devices.devicePermissionObj.CreateTunnel\" ng-class=\"deviceObj.nativeUiType === \'None\' ?\'pace nativeUiType-disabled\':\'\'\"><span class=\"service-action-beta-tag\">BETA</span> <a ng-click=\"devices.fnConnectNativeInterface(deviceObj)\">Native Interface</a></li><li ng-if=\"devices.gatewayPermissionObj.List\"><a ng-click=\"devices.fnOpenDeviceGatewayInfo(deviceObj)\">View Gateway</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!devices.isDevicesLoading && devices.devicesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{devices.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"devices.perPage = 10; devices.fnPageChanged(devices.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"devices.perPage = 20; devices.fnPageChanged(devices.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"devices.perPage = 50; devices.fnPageChanged(devices.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"devices.perPage = 100; devices.fnPageChanged(devices.perPage)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"devices.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"devices.currentPage\" items-per-page=\"devices.perPage\" max-size=\"3\" boundary-links=\"true\" ng-click=\"devices.fnGetNextPrePagination(devices.currentPage, devices.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div><div id=\"visualizerContainer\" class=\"col-sm-12\" ng-if=\"devices.selectedTab.tabIndex !== 0\"><div ng-if=\"devices.selectedTab.tabIndex === 1\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-show=\"devices.isDevicesLoading\"></app-spinner><div id=\"deviceMap\" ng-show=\"!devices.isDevicesLoading\"></div></div><div ng-if=\"devices.selectedTab.tabIndex === 3\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-show=\"devices.isDevicesLoading\"></app-spinner><div id=\"treeMap\" ng-show=\"!devices.isDevicesLoading\"><tree-map tree-data-arr=\"devices.devicesArr\" is-called-from-gateway-device=\"true\" fn-get-items=\"devices.fnGetDevice(selectedItem, itemArr, isCalledFromDirective)\"></tree-map></div></div></div></div><div class=\"row\" ng-if=\"!devices.devicePermissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"devices.devicePermissionObj.List\"><label>Total: {{devices.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : devices.isRefresh}\" ng-click=\"devices.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"devices.devicePermissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"devices.fnHideShowCreateForm()\">Register Device</button></div></div></div></div></div><div id=\"infoSection1\" class=\"h-100 p-0\" ng-show=\"devices.infoSectionView\" ng-class=\"devices.infoSectionClass\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"devices.selectedDevicesArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Device:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedDevice in devices.selectedDevicesArr\" is-open=\"selectedDevice.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedDevice.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); devices.fnCheckUncheckHeader(selectedDevice, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedDevice.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedDevice.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"devices.selectedDevicesArr.length && devices.devicePermissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"devices.devicePermissionObj.Delete\" ng-click=\"devices.fnDeleteMultipleDevices(devices.selectedDevicesArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!devices.isCreate && !devices.selectedDevicesArr.length && !devices.isCreateCSV\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-sitemap\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Device</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-if=\"devices.devicePermissionObj.Create\" ng-click=\"devices.fnHideShowCreateForm()\">Register Single Device</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"devices.devicePermissionObj.Create\">or</div><div class=\"col-sm-12\" ng-if=\"devices.devicePermissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"devices.fnHideShowCreateDeviceFromCSVForm()\">Bulk Register Devices</button></div></div></div><div class=\"content-container form-container\" ng-if=\"devices.isCreate && !devices.selectedDevicesArr.length && !devices.isCreateCSV\"><ng-include src=\"\'app/node/device/createDevice/createDevice.html\'\"></ng-include></div><div class=\"content-container form-container\" ng-if=\"devices.isCreateCSV && !devices.selectedDevicesArr.length\"><ng-include src=\"\'app/node/device/createDevice/createDeviceFromCSV.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"devices.selectedDevicesArr.length === 1 && devices.selectedDeviceObj && !devices.isDeviceDetailsLoaded\"></div><div class=\"h-100\" ng-if=\"devices.selectedDevicesArr.length === 1 && devices.selectedDeviceObj && devices.isDeviceDetailsLoaded\"><device-info device-obj=\"devices.selectedDeviceObj\" types-arr=\"devices.typesArr\" info-section-class=\"devices.infoSectionClass\" device-permissions-obj=\"devices.devicePermissionObj\"></device-info></div></div></div></div></div></div>");
$templateCache.put("app/node/ecu/ecu.html","<div class=\"row h-100\" ng-init=\"ecu.fnInitEcus()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"ecu.activeTabIndex\"><uib-tab index=\"1\" select=\"ecu.fnTabChanged(ecu.tabs[0])\" ng-click=\"ecu.fnChangeTab(ecu.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{ecu.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in ecu.tabs track by $index\" select=\"ecu.fnTabChanged(tab)\" ng-click=\"ecu.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"ecu.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();ecu.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecu.fnGetEcuDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!ecu.isFullWidthDevice\"><a ng-click=\"ecu.fnGetEcuStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"ecu.isFullWidthDevice\"><a ng-click=\"ecu.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{ecu.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"ecu.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"ecu.isFullWidthDevice && ecu.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'ecu\'\" service-name=\"\'ECU\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"ecu.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"ecu.fnGetWidgetEditor()\" fn-hide-chart=\"ecu.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"ecu.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{ecu.project.name ? ecu.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"ecu.ecuProjectSearch[ecu.ecuProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in ecu.filterProject=(ecu.projectsArr | filter:ecu.ecuProjectSearch) track by $index\" ng-click=\"ecu.fnGetProjectEcu(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === ecu.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!ecu.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"ecu.isRefreshData\" search-identifier=\"\'ecuSearch\'\" filters-arr=\"ecu.searchFiltersArr\" filter-query=\"ecu.filterQuery\" fn-filter-query-change=\"ecu.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.ecu\'\" fn-resize=\"ecu.fnSetTableHeight()\" is-column-view=\"ecu.isColumnView\" sort-field-arr=\"ecu.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecu.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"ecu.selectedEcusArr.length && ecu.permissionObj.DEREGISTER_ECU\"><a ng-click=\"ecu.fnDeleteMultipleEcus(ecu.selectedEcusArr)\"><i class=\"m-r-5 fa fa-chain-broken\"></i>Deregister</a></li><li ng-if=\"ecu.isShowInsightOption()\"><a ng-click=\"ecu.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"ecu.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"ecu.csvHeaderArr\" filename=\"ecu.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"ecu.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"ecu.isEcusLoading\" fn-resize=\"ecu.fnSetLoaderTableHeight()\"></table-loader><div class=\"ecus-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!ecu.isEcusLoading\"><thead><tr><th ng-if=\"ecu.ecusArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"ecu.isAllChecked\" ng-click=\"ecu.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecu.ecusArr.length\"></th><th ng-if=\"!ecu.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in ecu.ecusArr track by $index\" ng-click=\"ecu.fnCheckUncheckHeader(ecuObj, ecu.ecusArr);\" context-menu=\"ecu.ecuContextMenu(ecuObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"ecuObj.isCheck\" ng-change=\"ecu.fnCheckUncheckCheckbox(ecuObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecu.fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healthSpan\">{{ecuObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!ecuObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span><div class=\"d-flex flex-column m-t-5\"><div class=\"d-flex align-items-center\"><label class=\"m-b-0 m-r-5 font-12px\">ID:</label> <span class=\"font-12px\">{{ecuObj.id}}</span> <i class=\"m-l-5 fa fa-clipboard\" ng-click=\"$event.stopPropagation(); ecu.fnCopyId(ecuObj.id)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center m-t-2\" ng-if=\"ecuObj.serial\"><label class=\"m-b-0 m-r-5 font-12px\">Serial:</label> <span class=\"font-12px\">{{ecuObj.serial}}</span></div><div class=\"d-flex align-items-center m-t-2\"><label class=\"m-b-0 m-r-5 font-12px\">Phase:</label> <span class=\"font-12px\">{{ecuObj.phase}}</span></div><div class=\"d-flex align-items-center m-t-2\"><label class=\"m-b-0 m-r-5 font-12px\">ProjectId:</label> <span class=\"font-12px\">{{ecuObj.projectId}}</span></div></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"ecuObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"ecuObj.name\" placeholder=\"Name for the ECU*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"ecuObj.description\" placeholder=\"Description regarding ECU\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();ecu.fnCancelEcuEditMode(ecuObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!ecuObj.name.length\" ng-click=\"$event.stopPropagation();ecu.fnSaveEcuInfo(ecuObj)\" value=\"Save\"></div></div></div></td><td ng-show=\"!ecuObj.isEditable\"><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Sync Date\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex\"><button class=\"btn btn-sm btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation(); ecu.fnOpenEcuInfoTab(ecuObj,3)\">Register ECU</button></div></div></td><td ng-show=\"!ecuObj.isEditable\"><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered && ecuObj.phase === \'ACTIVE\'\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"ecuObj.syncState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\"><span ng-if=\"ecuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"ecuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"ecuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"ecuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"ecuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"ecuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"ecuObj.lifecycleState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.lifecycleState === \'FAILED\'\">Failed</span></span> <span ng-if=\"ecuObj.syncState === \'NOT_SYNCHRONIZED\'\"><button ng-if=\"!ecuObj.deploysUnsynchronizedECU\" ng-click=\"$event.stopPropagation(); ecu.fnDeployECU(ecuObj)\" class=\"btn btn-primary v4-primary-button\">Synchronize</button><div ng-if=\"ecuObj.deploysUnsynchronizedECU\"><span class=\"font-italic\">Synchronizing...</span></div></span></div></div><div class=\"d-flex align-items-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div></div></td><td ng-show=\"!ecuObj.isEditable\"><div class=\"d-flex flex-column\"><div uib-tooltip=\"Location\" ng-click=\"$event.stopPropagation(); ecu.fnOpenEcuInfoTab(ecuObj,4)\" tooltip-placement=\"auto\" class=\"d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/nodeLocation.svg#nodeLocation\"></use></svg></div></div></td><td class=\"text-right\" ng-show=\"!ecuObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': ecu.isDropUp }\" ng-click=\"$event.stopPropagation(); ecu.toggleDropUp(\'ecuTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecu.fnOpenEcuInfoTab(ecuObj,1)\">Detail</a></li><li ng-if=\"ecuObj.phase === \'UNREGISTERED\'\"><a ng-click=\"ecu.fnOpenEcuInfoTab(ecuObj,3)\">Register ECU</a></li><li><a ng-click=\"ecu.fnOpenEcuInfoTab(ecuObj,5)\">Tags</a></li><li ng-if=\"ecu.permissionObj.SCAN_NETWORK\"><a ng-click=\"ecu.fnRequestStartNetworkScan($parent.ecuObj)\">Start a network scan</a></li><li ng-if=\"ecu.isShowTunnelOption\"><a ng-click=\"ecu.fnRequestEcuTunnel(ecuObj)\">Request ECU Tunnel</a></li><li><a ng-click=\"ecu.fnCopyId(ecuObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!ecu.isEcusLoading && ecu.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{ecu.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"ecu.perPage = 10; ecu.fnPageChanged(ecu.currentPage, ecu.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"ecu.perPage = 20; ecu.fnPageChanged(ecu.currentPage, ecu.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"ecu.perPage = 50; ecu.fnPageChanged(ecu.currentPage, ecu.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"ecu.perPage = 100; ecu.fnPageChanged(ecu.currentPage,ecu.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"ecu.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"ecu.currentPage\" items-per-page=\"ecu.perPage\" max-size=\"ecu.maxSize\" boundary-links=\"true\" ng-click=\"ecu.fnPageChanged(ecu.currentPage, ecu.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{ecu.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : ecu.isRefresh}\" ng-click=\"ecu.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden\">Create ECU</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && ecu.selectedEcuObj && ecu.isEcuDetailsLoaded && !ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><ecu-info ecu-obj=\"ecu.selectedEcuObj\" user-permissions-obj=\"ecu.permissionObj\"></ecu-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Ecus</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>ECU To create a label, select Create ECU</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"ecu.fnHideShowCreateForm()\">Create ECU</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Ecus are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Ecus</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'ecu\'\" service-name=\"\'ECU\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"ecu.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"ecu.fnGetWidgetEditor()\" fn-hide-chart=\"ecu.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && !ecu.isShowEcuStats && ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><widget-editor app-name=\"\'node\'\" service-name=\"\'ecu\'\" service-display-name=\"\'ECU\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'ecu\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && ecu.isShowTunnel && !ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/ecu/ecuTunnel/ecuTunnel.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && ecu.isShowSynchronizingECU && !ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/ecu/ecuSynchronizing/ecuSynchronizing.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecu.activeTabIndex !== 1 && !ecu.isShowDashboard && !ecu.isShowEcuStats && !ecu.isShowWidgetEditor && !ecu.isCreateIssue && !ecu.isShowTunnel && !ecu.isShowSynchronizingECU && ecu.isShowNetworkScanECU\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/ecu/ecuNetworkscan/ecuNetworkscan.html\'\"></ng-include></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/dashboard/dashboard.html","<div class=\"row h-100\" ng-init=\"nodeDashboard.fnInit()\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\" style=\"height: inherit;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeDashboard.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeDashboard.tabs track by $index\" select=\"nodeDashboard.fnTabChanged(tab)\" ng-click=\"nodeDashboard.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();nodeDashboard.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"nodeDashboard.activeTabIndex === 1\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\"><span>Productivity</span><h1 class=\"m-0 font-bold\">Node</h1><h2 class=\"m-0 m-t-10\"></h2></div></div><div class=\"col-sm-12 p-0 d-flex dashboard-body\"><div class=\"overflow-auto\" ng-class=\"nodeDashboard.isFullWidthDevice ? \'col-sm-9 p-r-0\':\'col-sm-12 \'\"><insight-dashboards app-key=\"\'node\'\" service-key=\"\'dashboard\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeDashboard.fnOpenCreateIssueTab(chartObj)\"></insight-dashboards></div><div ng-if=\"nodeDashboard.isFullWidthDevice\" class=\"col-sm-3 p-l-0 side-bar\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Node</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">API documentation</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Manage Projects</td><td class=\"p-b-12 p-r-15\" ng-click=\"nodeDashboard.fnGoToState(\'main.project\')\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">Get training</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"nodeDashboard.activeTabIndex !== 1 && nodeDashboard.isCreate\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'dashboard\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/es4/es4.html","<div class=\"row h-100\" ng-init=\"es4.fnInitEs4s()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"es4.activeTabIndex\"><uib-tab index=\"1\" select=\"es4.fnTabChanged(es4.tabs[0])\" ng-click=\"es4.fnChangeTab(es4.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"es4.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in es4.tabs track by $index\" select=\"es4.fnTabChanged(tab)\" ng-click=\"es4.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"es4.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();es4.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"es4.fnGetEs4Dashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!es4.isFullWidthDevice\"><a ng-click=\"es4.fnGetEs4Stats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"es4.isFullWidthDevice\"><a ng-click=\"es4.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{es4.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"es4.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"es4.isFullWidthDevice && es4.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'es4\'\" service-name=\"\'Es4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"es4.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"es4.fnGetWidgetEditor()\" fn-hide-chart=\"es4.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"es4.isEcuLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{es4.ecu.name ? es4.ecu.name : \"All\"}}</span> <label class=\"titleLabel\">ECU*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"es4.es4EcuSearch[es4.es4EcuFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\" style=\"max-width: 350px;\"><li ng-repeat=\"ecuObj in es4.filterEcu=(es4.ecusArr | filter:es4.es4EcuSearch) track by $index\" ng-click=\"es4.fnGetEs4Ecu(ecuObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"ecuObj.id === es4.ecu.id\"></i></span> <span class=\"ellipsis\">{{ecuObj.name}}</span></a></li><li ng-if=\"!es4.filterEcu.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"es4.isRefreshData\" search-identifier=\"\'es4Search\'\" filters-arr=\"es4.searchFiltersArr\" filter-query=\"es4.filterQuery\" fn-filter-query-change=\"es4.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node_es4\'\" fn-resize=\"es4.fnSetTableHeight()\" is-column-view=\"es4.isColumnView\" sort-field-arr=\"es4.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"es4.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"es4.isShowInsightOption()\"><a ng-click=\"es4.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"es4.getEs4CSVData()\" id=\"csvAnchor\" csv-header=\"es4.csvHeaderArr\" filename=\"es4.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"es4.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"es4.isEs4sLoading\" fn-resize=\"es4.fnSetLoaderTableHeight()\"></table-loader><div class=\"es4s-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!es4.isEs4sLoading\"><thead><tr><th ng-if=\"es4.es4sArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"es4.isAllChecked\" ng-click=\"es4.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\"></th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\"></th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\"></th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\"></th><th class=\"p-r-2\" ng-if=\"es4.es4sArr.length\"></th><th ng-if=\"!es4.es4sArr.length\">No records found...</th></tr></thead><tbody id=\"es4Table\"><tr ng-repeat=\"es4Obj in es4.es4sArr track by $index\" ng-click=\"es4.fnCheckUncheckHeader(es4Obj, es4.es4sArr);\" context-menu=\"es4.es4ContextMenu(es4Obj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"es4Obj.isCheck\" ng-change=\"es4.fnCheckUncheckHeader(es4Obj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!es4Obj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{es4Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des p-t-5\">{{es4Obj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"es4Obj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"es4Obj.name\" placeholder=\"Name for the ECU*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"es4Obj.description\" placeholder=\"Description regarding ECU\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();es4.fnCancelEs4EditMode(es4Obj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!es4Obj.name.length\" ng-click=\"$event.stopPropagation();es4.fnSaveEs4Info(es4Obj)\" value=\"Save\"></div></div></div></td><td ng-show=\"!es4Obj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"ECU\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{es4Obj.ecu.name}}</span></div></div></div></td><td ng-show=\"!es4Obj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"es4Obj.syncState === \'READY\'\">Ready</span> <span ng-if=\"es4Obj.syncState === \'SYNCHRONIZING\'\"><span ng-if=\"es4Obj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"es4Obj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"es4Obj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"es4Obj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"es4Obj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"es4Obj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"es4Obj.lifecycleState === \'READY\'\">Ready</span></span> <span ng-if=\"es4Obj.syncState === \'NOT_SYNCHRONIZED\'\"><button ng-if=\"!es4Obj.deploysUnsynchronizedES4\" ng-click=\"$event.stopPropagation(); es4.fnDeployES4(es4Obj)\" class=\"btn btn-primary v4-primary-button\">Synchronize</button><div ng-if=\"es4Obj.deploysUnsynchronizedES4\"><span class=\"font-italic\">Synchronizing...</span></div></span></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!es4Obj.isEditable\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5\" uib-tooltip=\"{{es4Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"es4Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{es4Obj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-t-5\" uib-tooltip=\"{{es4Obj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"es4Obj.createdBy\"><small class=\"d-flex align-items-center w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{es4Obj.createdBy}}</span></small></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!es4Obj.isEditable\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5\" uib-tooltip=\"{{es4Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"es4Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{es4Obj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-t-5\" uib-tooltip=\"{{es4Obj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"es4Obj.updatedBy\"><small class=\"d-flex align-items-center w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{es4Obj.updatedBy}}</span></small></div></div></td><td class=\"text-right\" ng-show=\"!es4Obj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': es4.isDropUp }\" ng-click=\"$event.stopPropagation(); es4.toggleDropUp(\'es4Table\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"es4.fnOpenEs4InfoTab(es4Obj,1)\">Detail</a></li><li><a ng-click=\"es4.fnCopyId(es4Obj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!es4.isEs4sLoading && es4.es4sArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{es4.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"es4.perPage = 10; es4.fnPageChanged(es4.currentPage, es4.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"es4.perPage = 20; es4.fnPageChanged(es4.currentPage, es4.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"es4.perPage = 50; es4.fnPageChanged(es4.currentPage, es4.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"es4.perPage = 100; es4.fnPageChanged(es4.currentPage,es4.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"es4.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"es4.currentPage\" items-per-page=\"es4.perPage\" max-size=\"es4.maxSize\" boundary-links=\"true\" ng-click=\"es4.fnPageChanged(es4.currentPage, es4.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{es4.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : es4.isRefresh}\" ng-click=\"es4.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"es4.fnHideShowCreateForm()\" ng-show=\"es4.permissionObj.CREATE_ES4\">Create ES4</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && es4.selectedEs4Obj && es4.isEs4DetailsLoaded && !es4.isCreate && !es4.isShowDashboard && !es4.isShowEs4Stats && !es4.isShowWidgetEditor && !es4.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><es4-info es4-obj=\"es4.selectedEs4Obj\" user-permissions-obj=\"es4.permissionObj\"></es4-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && es4.isCreate && !es4.isShowDashboard && !es4.isShowEs4Stats && !es4.isShowWidgetEditor && !es4.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/es4/createEs4/createEs4.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && !es4.isCreate && es4.isShowDashboard && !es4.isShowEs4Stats && !es4.isShowWidgetEditor && !es4.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">ES4s</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Es4s are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && !es4.isCreate && !es4.isShowDashboard && es4.isShowEs4Stats && !es4.isShowWidgetEditor && !es4.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'es4\'\" service-name=\"\'Es4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"es4.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"es4.fnGetWidgetEditor()\" fn-hide-chart=\"es4.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && !es4.isCreate && !es4.isShowDashboard && !es4.isShowEs4Stats && es4.isShowWidgetEditor && !es4.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'es4\'\" service-display-name=\"\'ES4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"es4.activeTabIndex !== 1 && !es4.isCreate && !es4.isShowDashboard && !es4.isShowEs4Stats && !es4.isShowWidgetEditor && es4.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'es4\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/fleet/fleet.html","<div class=\"row h-100\" ng-init=\"fleet.fnInitEcus()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"fleet.activeTabIndex\"><uib-tab index=\"1\" select=\"fleet.fnTabChanged(fleet.tabs[0])\" ng-click=\"fleet.fnChangeTab(fleet.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{fleet.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in fleet.tabs track by $index\" select=\"fleet.fnTabChanged(tab)\" ng-click=\"fleet.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"fleet.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fleet.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"fleet.fnGetEcuDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!fleet.isFullWidthDevice\"><a ng-click=\"fleet.fnGetEcuStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"fleet.isFullWidthDevice\"><a ng-click=\"fleet.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{fleet.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"fleet.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"fleet.isFullWidthDevice && fleet.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'fleet\'\" service-name=\"\'Fleet\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"fleet.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"fleet.fnGetWidgetEditor()\" fn-hide-chart=\"fleet.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"fleet.isRefreshData\" search-identifier=\"\'fleetSearch\'\" filters-arr=\"fleet.searchFiltersArr\" filter-query=\"fleet.filterQuery\" fn-filter-query-change=\"fleet.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.fleet\'\" fn-resize=\"fleet.fnSetTableHeight()\" is-column-view=\"fleet.isColumnView\" sort-field-arr=\"fleet.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"fleet.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"fleet.selectedEcusArr.length\"><a ng-click=\"fleet.fnDeleteMultipleEcus(fleet.selectedEcusArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"fleet.isShowInsightOption()\"><a ng-click=\"fleet.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"fleet.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"fleet.csvHeaderArr\" filename=\"fleet.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"fleet.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"fleet.isEcusLoading\" fn-resize=\"fleet.fnSetLoaderTableHeight()\"></table-loader><div class=\"fleet-ecus-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!fleet.isEcusLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"fleet.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"fleet.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"fleet.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"fleet.ecusArr.length\"></th><th ng-if=\"!fleet.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in fleet.ecusArr track by $index\" ng-click=\"fleet.fnCheckUncheckHeader(ecuObj, fleet.ecusArr);\"><td><button class=\"btn btn-xs btn-default ellipsis-label w100\"><span class=\"healthSpan\">{{ecuObj.health}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span></div></td><td><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.phase === \'UNREGISTERED\'\">Unregistered</span> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex\"><span ng-if=\"ecuObj.phase === \'UNREGISTERED\'\">Unregistered</span></div></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': fleet.isDropUp }\" ng-click=\"$event.stopPropagation(); fleet.toggleDropUp(\'ecuTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"fleet.fnOpenEcuInfoTab(ecuObj,1)\">Detail</a></li><li><a ng-click=\"fleet.fnRequestECUTunnel(ecuObj)\">Request ECU tunnel</a></li><li><a ng-click=\"fleet.fnOpenEcuInfoTab(ecuObj,2)\">Execute Command</a></li><li><a ng-click=\"fleet.fnCopyId(ecuObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!fleet.isEcusLoading && fleet.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{fleet.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"fleet.perPage = 10; fleet.fnPageChanged(fleet.currentPage, fleet.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"fleet.perPage = 20; fleet.fnPageChanged(fleet.currentPage, fleet.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"fleet.perPage = 50; fleet.fnPageChanged(fleet.currentPage, fleet.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"fleet.perPage = 100; fleet.fnPageChanged(fleet.currentPage,fleet.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"fleet.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"fleet.currentPage\" items-per-page=\"fleet.perPage\" max-size=\"fleet.maxSize\" boundary-links=\"true\" ng-click=\"fleet.fnPageChanged(fleet.currentPage, fleet.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{fleet.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : fleet.isRefresh}\" ng-click=\"fleet.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden\">Create ECU</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"fleet.activeTabIndex !== 1 && fleet.selectedEcuObj && fleet.isEcuDetailsLoaded && !fleet.isShowDashboard && !fleet.isShowEcuStats && !fleet.isShowWidgetEditor && !fleet.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><fleet-ecu-info ecu-obj=\"fleet.selectedEcuObj\" user-permissions-obj=\"fleet.permissionObj\"></fleet-ecu-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"fleet.activeTabIndex !== 1 && fleet.isShowDashboard && !fleet.isShowEcuStats && !fleet.isShowWidgetEditor && !fleet.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Ecus</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>ECU To create a label, select Create ECU</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"fleet.fnHideShowCreateForm()\">Create ECU</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Ecus are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Ecus</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"fleet.activeTabIndex !== 1 && !fleet.isShowDashboard && fleet.isShowEcuStats && !fleet.isShowWidgetEditor && !fleet.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'fleet\'\" service-name=\"\'Fleet\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"fleet.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"fleet.fnGetWidgetEditor()\" fn-hide-chart=\"fleet.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"fleet.activeTabIndex !== 1 && !fleet.isShowDashboard && !fleet.isShowEcuStats && fleet.isShowWidgetEditor && !fleet.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'fleet\'\" service-display-name=\"\'Fleet\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"fleet.activeTabIndex !== 1 && !fleet.isShowDashboard && !fleet.isShowEcuStats && !fleet.isShowWidgetEditor && fleet.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'fleet\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gateway.html","<div class=\"row h-100\" ng-init=\"gateway.fnInitGateways()\"><div class=\"col-sm-12 h-100\"><div class=\"h-100 p-l-0\" ng-show=\"gateway.tableSectionView\" ng-class=\"gateway.tableClass\"><div class=\"content-box\" ng-if=\"!gateway.isGatewayVisualizerLoaded\"><div class=\"content-box-content\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div></div><div class=\"content-box\" ng-if=\"gateway.isGatewayVisualizerLoaded\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"gateway.permissionObj.List\"><div class=\"w100 p-0\" node-search-directive=\"\" field-arr=\"gateway.searchFieldArr\" filter-query=\"gateway.filterQuery\" state-name=\"\'main.gateway\'\" fn-filter-query-change=\"gateway.fnFilterQueryChanged(filterQuery)\" is-called-for-view-visualizer=\"false\" fn-resize=\"gateway.fnSetTableHeight()\"></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 5px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"gateway.fnGatewayTableFullScreen()\"><expand-collapse-container info-section-class=\"gateway.tableClass\"></expand-collapse-container>{{gateway.tableClass === \'col-sm-6\'?\'Expand\':\'Collapse\'}}</a></li><li><a ng-click=\"gateway.fnTabChanged(gateway.tabs[0])\"><i class=\"m-r-5 fa fa-table\"></i>Table View</a></li><li><a ng-click=\"gateway.fnTabChanged(gateway.tabs[1])\"><i class=\"m-r-5 fa fa-map-marker\"></i>Map View</a></li><li><a ng-click=\"gateway.fnTabChanged(gateway.tabs[3])\"><i class=\"m-r-5 fa fa-trello\"></i>Tree Map View</a></li><li><a ng-click=\"gateway.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"gateway.getGatewayCSVData()\" id=\"csvAnchor\" csv-header=\"gateway.csvHeaderArr\" filename=\"gateway.csv\"><i class=\"m-r-5 fa fa-file\"></i>Download CSV</a></li></ul></div></div></div><div class=\"row\" ng-if=\"gateway.permissionObj.List\"><div class=\"col-sm-12\" ng-if=\"gateway.selectedTab.tabIndex === 0\"><table-loader ng-if=\"gateway.isGatewaysLoading\" fn-resize=\"gateway.fnSetLoaderTableHeight()\"></table-loader><div class=\"gateways-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!gateway.isGatewaysLoading\"><thead><tr><th ng-if=\"gateway.gatewaysArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"gateway.isAllChecked\" ng-click=\"gateway.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"gateway.gatewaysArr.length\"></th><th ng-if=\"gateway.gatewaysArr.length\"><span ng-click=\"gateway.fnGatewaySort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"gateway.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"gateway.gatewaysArr.length\"></th><th ng-if=\"!gateway.gatewaysArr.length\">No records found...</th></tr></thead><tbody id=\"gatewayTable\"><tr ng-repeat=\"gatewayObj in gateway.gatewaysArr track by $index\" ng-click=\"gateway.fnGetGateway(gatewayObj, gateway.gatewaysArr);\" context-menu=\"gateway.gatewayContextMenu(gatewayObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"gatewayObj.isCheck\" ng-change=\"gateway.fnCheckUncheckHeader(gatewayObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\" ng-show=\"!gatewayObj.isEditable\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{gatewayObj.connection}}\" tooltip-placement=\"auto\" ng-style=\"gateway.fnGetConnectionIconColor(gatewayObj.connection)\"><span class=\"fa gatewayConnectionIcon\" ng-style=\"gateway.fnGetConnectionIconColor(gatewayObj.connection)\" ng-class=\"gateway.fnGetConnectionIcon(gatewayObj.connection)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-show=\"!gatewayObj.isEditable\">{{gatewayObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\" ng-show=\"!gatewayObj.isEditable\">{{gatewayObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\" ng-show=\"!gatewayObj.isEditable\"><span ng-if=\"gatewayObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{gatewayObj.phase}}\" tooltip-placement=\"auto\" class=\"phaseIconBorder\" ng-style=\"gateway.fnGetPhaseIconBorderColor(gatewayObj.phase)\"><span ng-class=\"gateway.fnGetPhaseIcon(gatewayObj.phase)\"></span></span> <button ng-if=\"gatewayObj.phase === \'PRODUCTION\'\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayObj.toolTipName}}\" tooltip-placement=\"auto\" ng-style=\"gateway.fnGetHealthColor(gatewayObj.health, gatewayObj)\"><span class=\"healtSpan\">{{gatewayObj.healthName}}</span></button></div></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput\" ng-show=\"gatewayObj.isEditable\"><div class=\"col-sm-5\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"gatewayObj.name\" placeholder=\"Name for the Gateway*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"gatewayObj.description\" placeholder=\"Description regarding Gateway\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();gateway.fnCancelGatewayEditMode(gatewayObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!gatewayObj.name.length\" ng-click=\"$event.stopPropagation();gateway.fnSaveGatewayInfo(gatewayObj)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!gatewayObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': gateway.isDropUp }\" ng-click=\"$event.stopPropagation(); gateway.toggleDropUp(\'gatewayTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"gateway.fnOpenGatewayInfoTab(gatewayObj,2);\">Telemetry</a></li><li><a ng-click=\"gateway.fnOpenGatewayInfoTab(gatewayObj,4)\">Details</a></li><li><a ng-click=\"gateway.fnOpenGatewayInfoTab(gatewayObj,7)\">Supplemental</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!gateway.isGatewaysLoading && gateway.gatewaysArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{gateway.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"gateway.perPage = 10; gateway.fnPageChanged(gateway.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"gateway.perPage = 20; gateway.fnPageChanged(gateway.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"gateway.perPage = 50; gateway.fnPageChanged(gateway.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"gateway.perPage = 100; gateway.fnPageChanged(gateway.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"gateway.perPage = 500; gateway.fnPageChanged(gateway.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"gateway.isPrevVisible\" ng-click=\"gateway.fnGetNextPrevCollection(\'previous\', gateway.prevCollection, gateway.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"gateway.fnGetNextPrevCollection(\'next\', gateway.nextCollection, gateway.perPage)\" ng-if=\"gateway.nextCollection.length\"></button></div></div></div></div></div><div id=\"visualizerContainer\" class=\"col-sm-12\" ng-if=\"gateway.selectedTab.tabIndex !== 0\"><div ng-if=\"gateway.selectedTab.tabIndex === 1\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-show=\"gateway.isGatewaysLoading\"></app-spinner><div id=\"gatewayMap\" ng-show=\"!gateway.isGatewaysLoading\"></div></div><div ng-if=\"gateway.selectedTab.tabIndex === 3\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-show=\"gateway.isGatewaysLoading\"></app-spinner><div id=\"treeMap\" ng-show=\"!gateway.isGatewaysLoading\"><tree-map tree-data-arr=\"gateway.gatewaysArr\" is-called-from-gateway-device=\"true\" fn-get-items=\"gateway.fnGetGateway(selectedItem, itemArr, isCalledFromDirective)\"></tree-map></div></div></div></div><div class=\"row\" ng-if=\"!gateway.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"gateway.permissionObj.List\"><label>Total: {{gateway.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : gateway.isRefresh}\" ng-click=\"gateway.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"gateway.permissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"gateway.fnHideShowCreateForm()\">Order Gateway</button></div></div></div></div></div><div id=\"infoSection\" class=\"h-100 p-0\" ng-show=\"gateway.infoSectionView\" ng-class=\"gateway.infoSectionClass\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"gateway.selectedGatewaysArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Gateways:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedGateway in gateway.selectedGatewaysArr\" is-open=\"selectedGateway.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedGateway.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); gateway.fnCheckUncheckHeader(selectedGateway, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedGateway.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedGateway.description}}</div></div><div class=\"row\" ng-if=\"selectedGateway.state\"><div class=\"col-xs-2\"><label>State:</label></div><div class=\"col-xs-10\">{{selectedGateway.state}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"gateway.selectedGatewaysArr.length && gateway.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"gateway.permissionObj.Delete\" ng-click=\"gateway.fnDeleteMultipleGateways(gateway.selectedGatewaysArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!gateway.isCreate && !gateway.selectedGatewaysArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-microchip\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Gateway</label></div><div class=\"col-sm-12\" ng-if=\"gateway.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"gateway.fnHideShowCreateForm()\">Order Gateway</button></div></div></div><div class=\"content-container form-container\" ng-if=\"gateway.isCreate && !gateway.selectedGatewaysArr.length\"><ng-include src=\"\'app/node/gateway/createGateway/createGateway.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"gateway.selectedGatewaysArr.length === 1 && gateway.selectedGatewayObj && !gateway.isGatewayDetailsLoaded\"></div><div ng-if=\"gateway.selectedGatewaysArr.length === 1 && gateway.selectedGatewayObj && gateway.isGatewayDetailsLoaded\"><gateway-info gateway-obj=\"gateway.selectedGatewayObj\" info-section-class=\"gateway.infoSectionClass\" device-types-arr=\"gateway.deviceTypesArr\" gateway-permissions-obj=\"gateway.permissionObj\"></gateway-info></div></div></div></div></div></div>");
$templateCache.put("app/node/health/health.html","<div class=\"row h-100\" ng-init=\"health.fnInitHealths()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"health.activeTabIndex\"><uib-tab index=\"1\" select=\"health.fnTabChanged(health.tabs[0])\" ng-click=\"health.fnChangeTab(health.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"health.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in health.tabs track by $index\" select=\"health.fnTabChanged(tab)\" ng-click=\"health.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"health.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();health.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"health.fnGetHealthDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!health.isFullWidthDevice\"><a ng-click=\"health.fnGetHealthStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"health.fnGetHealthRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"health.isFullWidthDevice\"><a ng-click=\"health.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{health.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"health.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"health.isFullWidthDevice && health.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'health\'\" service-name=\"\'Health\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"health.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"health.fnGetWidgetEditor()\" fn-hide-chart=\"health.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"health.isRefreshData\" search-identifier=\"\'healthSearch\'\" filters-arr=\"health.searchFiltersArr\" filter-query=\"health.filterQuery\" fn-filter-query-change=\"health.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.health\'\" fn-resize=\"health.fnSetTableHeight()\" sort-field-arr=\"health.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"health.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"health.selectedHealthsArr.length\"><a ng-click=\"health.fnDeleteMultipleHealths(health.selectedHealthsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"health.isShowInsightOption()\"><a ng-click=\"health.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"health.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"health.csvHeaderArr\" filename=\"health.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"health.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"health.isHealthsLoading\" fn-resize=\"health.fnSetLoaderTableHeight()\"></table-loader><div class=\"healths-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!health.isHealthsLoading\"><thead><tr><th ng-if=\"health.healthsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"health.isAllChecked\" ng-click=\"health.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\">Health</th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\"></th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\">Project</th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\"></th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\"></th><th class=\"p-r-2\" ng-if=\"health.healthsArr.length\"></th><th ng-if=\"!health.healthsArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"healthObj in health.healthsArr track by $index\" ng-click=\"health.fnCheckUncheckHeader(healthObj, health.healthsArr);\" context-menu=\"health.healthContextMenu(healthObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"healthObj.isCheck\" ng-change=\"health.fnCheckUncheckHeader(healthObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"arrowLine-container text-center\"><div class=\"healthStyle\">{{healthObj.value}}</div><span class=\"arrowLine arrow-right\"></span></div></td><td><button class=\"btn btn-xs btn-default ellipsis-label\" ng-style=\"health.fnGetHealthColor(healthObj.value, healthObj)\" uib-tooltip=\"{{healthObj.name}} {{healthObj.value}}\" tooltip-placement=\"top\"><span>{{healthObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!healthObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{healthObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{healthObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"healthObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"healthObj.name\" placeholder=\"Name for the Health*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"healthObj.description\" placeholder=\"Description regarding Health\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();health.fnCancelHealthEditMode(healthObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!healthObj.name.length\" ng-click=\"$event.stopPropagation();health.fnSaveHealthInfo(healthObj)\" value=\"Save\"></div></div></div></td><td ng-show=\"!healthObj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{healthObj.project.name}}</label></div></div></td><td ng-show=\"!healthObj.isEditable\" class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{healthObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"healthObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{healthObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{healthObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"healthObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{healthObj.createdBy}}</span></small></div></td><td ng-show=\"!healthObj.isEditable\" class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{healthObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"healthObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{healthObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{healthObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"healthObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{healthObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!healthObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': notification.isDropUp }\" ng-click=\"$event.stopPropagation(); healthObj.toggleDropUp(\'healthTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"health.fnOpenHealthInfoTab(healthObj,1)\">Detail</a></li><li><a ng-click=\"health.fnOpenHealthInfoTab(healthObj,2)\">Tags</a></li><li><a ng-click=\"health.fnCopyId(healthObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!health.isHealthsLoading && health.healthsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{health.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"health.perPage = 10; health.fnPageChanged(health.currentPage, health.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"health.perPage = 20; health.fnPageChanged(health.currentPage, health.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"health.perPage = 50; health.fnPageChanged(health.currentPage, health.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"health.perPage = 100; health.fnPageChanged(health.currentPage,health.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"health.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"health.currentPage\" items-per-page=\"health.perPage\" max-size=\"health.maxSize\" boundary-links=\"true\" ng-click=\"health.fnPageChanged(health.currentPage, health.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{health.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : health.isRefresh}\" ng-click=\"health.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"health.permissionObj.CREATE_HEALTH\" ng-click=\"health.fnHideShowCreateForm()\">Create Health</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && health.selectedHealthObj && health.isHealthDetailsLoaded && !health.isCreate && !health.isShowDashboard && !health.isShowHealthStats && !health.isShowWidgetEditor && !health.isShowRelationships && !health.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><health-info health-obj=\"health.selectedHealthObj\" user-permissions-obj=\"health.permissionObj\"></health-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && health.isCreate && !health.isShowDashboard && !health.isShowHealthStats && !health.isShowWidgetEditor && !health.isShowRelationships && !health.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/health/createHealth/createHealth.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && health.isShowDashboard && !health.isCreate && !health.isShowHealthStats && !health.isShowWidgetEditor && !health.isShowRelationships && !health.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Healths</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Health To create a label, select Create Health</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"health.fnHideShowCreateForm()\">Create Health</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Healths are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Healths</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && !health.isShowDashboard && !health.isCreate && health.isShowHealthStats && !health.isShowWidgetEditor && !health.isShowRelationships && !health.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'health\'\" service-name=\"\'Health\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"health.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"health.fnGetWidgetEditor()\" fn-hide-chart=\"health.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && !health.isShowDashboard && !health.isCreate && !health.isShowHealthStats && health.isShowWidgetEditor && !health.isShowRelationships && !health.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'health\'\" service-display-name=\"\'Health\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-init=\"health.fnInitHealthRelationships()\" ng-if=\"health.activeTabIndex !== 1 && !health.isShowDashboard && !health.isCreate && !health.isShowHealthStats && !health.isShowWidgetEditor && health.isShowRelationships && !health.isCreateIssue\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"health.isHealthRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!health.isHealthRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" ng-repeat=\"childrenObj in health.newProjectData\" ng-include=\"\'healthRelationshipsTree\'\"></li></ul></div><script type=\"text/ng-template\" id=\"healthRelationshipsTree\"><div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.childrenObj}\"> <a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.childrenObj.children.length !== 1 }\"></a> <div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.childrenObj.children.length !== 1}\"> <div class=\"panel-heading p-10 d-flex align-items-center\"> <div class=\"col-sm-12 p-0 d-flex align-items-center\"> <div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"> <label class=\"ellipsis m-b-0\"> {{childrenObj.name}} </label> </div> </div> </div> <div class=\"panel-body\"> <div class=\"col-sm-12 text-left\"> <div class=\"p-10\"> <span>{{childrenObj.description}}</span> </div> <div> <div class=\"border-top-1px\"></div> <div class=\"p-10\" ng-if=\"childrenObj.healths.length\"> <div> <button class=\"btn btn-xs btn-default m-r-5 m-b-5 ellipsis-button p-l-5 p-r-5 p-t-1 p-b-1\" ng-repeat=\"healthObj in childrenObj.healths track by $index\" ng-style=\"health.fnGetHealthColor(healthObj.value,healthObj)\" ng-click=\"health.fnCheckUncheckHeader(healthObj)\"> <span>{{healthObj.name}}</span> </button> </div> </div> <div class=\"p-10\" ng-if=\"!childrenObj.healths.length\"> <label class=\"m-b-0\">No healths found...</label> </div> </div> </div> </div> </div> </div> <ul ng-if=\"childrenObj.children && childrenObj.children.length\"> <li ng-repeat=\"childrenObj in childrenObj.children\" ng-include=\"\'healthRelationshipsTree\'\"> </li> </ul></script></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"health.activeTabIndex !== 1 && !health.isShowDashboard && !health.isCreate && !health.isShowHealthStats && !health.isShowWidgetEditor && !health.isShowRelationships && health.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'health\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/job/jobs.html","<div class=\"row h-100\" ng-init=\"jobs.fnInitJobs()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"jobs.activeTabIndex\"><uib-tab index=\"1\" select=\"jobs.fnTabChanged(jobs.tabs[0])\" ng-click=\"jobs.fnChangeTab(jobs.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"jobs.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in jobs.tabs track by $index\" select=\"jobs.fnTabChanged(tab)\" ng-click=\"jobs.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"jobs.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();jobs.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"jobs.fnGetJobDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!jobs.isFullWidthDevice\"><a ng-click=\"jobs.fnGetJobStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"jobs.isFullWidthDevice\"><a ng-click=\"jobs.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{jobs.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"jobs.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"jobs.isFullWidthDevice && jobs.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'job\'\" service-name=\"\'Job\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"jobs.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"jobs.fnGetWidgetEditor()\" fn-hide-chart=\"jobs.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"jobs.isJobsLoading ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"always\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{jobs.selectedJobTable.displayName}}</span> <label class=\"titleLabel\">Job Type</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"jobs.jobTypeSearch[jobs.jobTypeFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"jobTypeObj in jobs.filterJobType=(jobs.jobTablesArr | filter:jobs.jobTypeSearch) track by $index\" ng-click=\"jobs.fnChangeJobType($index)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"jobTypeObj.name === jobs.selectedJobTable.name\"></i></span> <span>{{jobTypeObj.displayName}}</span></a></li><li ng-if=\"!jobs.filterJobType.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"jobs.isRefreshData\" search-identifier=\"\'jobSearch\'\" filters-arr=\"jobs.searchFiltersArr\" filter-query=\"jobs.filterQuery\" fn-filter-query-change=\"jobs.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.job\'\" fn-resize=\"jobs.fnSetTableHeight()\" sort-field-arr=\"jobs.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"jobs.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"jobs.isShowInsightOption()\"><a ng-click=\"jobs.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"jobs.getJobsCsvData()\" id=\"csvAnchor\" csv-header=\"jobs.csvHeaderArr\" filename=\"jobs.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"jobs.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"jobs.isJobsLoading\" fn-resize=\"jobs.fnSetLoaderTableHeight()\"></table-loader><div class=\"jobs-table table-container\"><table id=\"jobsTable\" class=\"table table-striped table-check-box\" ng-if=\"!jobs.isJobsLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th class=\"p-r-2\" ng-if=\"jobs.jobsArr.length\"></th><th ng-if=\"!jobs.jobsArr.length\">No records found...</th></tr></thead><tbody id=\"jobTable\"><tr ng-repeat=\"jobObj in jobs.jobsArr track by $index\" ng-click=\"jobs.fnCheckUncheckHeader(jobObj, jobs.jobsArr);\"><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex\" uib-tooltip=\"{{\'Job Result: \' + jobObj.jobResult}}\" tooltip-placement=\"auto\"><svg width=\"23px\" height=\"23px\" ng-if=\"jobObj.jobResult === \'FAILURE\'\"><use xlink:href=\"assets/images/svg/service/job/job-fail.svg#job-fail\"></use></svg><svg width=\"23px\" height=\"23px\" ng-if=\"jobObj.jobResult === \'SUCCESS\'\"><use xlink:href=\"assets/images/svg/service/job/job-success.svg#job-success\"></use></svg></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis label_name d-flex align-items-center\">{{jobObj.requestTypeString}}</label> <span class=\"ellipsis DescriptionText span_des\">{{jobObj.id}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><label ng-if=\"jobObj.ecu\" class=\"ellipsis label_name d-flex align-items-center\">{{jobObj.ecu.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{jobObj.ecuId}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5\" uib-tooltip=\"{{jobObj.requestedBy}}\" tooltip-placement=\"auto\" ng-if=\"jobObj.requestedBy\"><label class=\"ellipsis m-b-0\">Requested by {{jobObj.requestedBy}}</label></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><label ng-if=\"jobObj.startsAt\" class=\"ellipsis label_name d-flex align-items-center\">Started {{jobObj.startsAtTime}}</label> <label ng-if=\"jobObj.startedAt\" class=\"ellipsis label_name d-flex align-items-center\">Started {{jobObj.startedAtTime}}</label> <span class=\"ellipsis DescriptionText span_des\" ng-if=\"jobObj.completedAt\">Ended {{jobObj.completedAtTime}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5\"><label class=\"ellipsis m-b-0\">Expires {{jobObj.expiresAtTime}}</label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': notification.isDropUp }\" ng-click=\"$event.stopPropagation(); jobObj.toggleDropUp(\'jobTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"jobs.fnOpenJobInfoTab(jobObj,1)\">Detail</a></li><li><a ng-click=\"jobs.fnCopyId(jobObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!jobs.isJobsLoading && jobs.jobsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{jobs.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"jobs.perPage = 10; jobs.fnPageChanged(jobs.currentPage, jobs.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"jobs.perPage = 20; jobs.fnPageChanged(jobs.currentPage, jobs.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"jobs.perPage = 50; jobs.fnPageChanged(jobs.currentPage, jobs.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"jobs.perPage = 100; jobs.fnPageChanged(jobs.currentPage,jobs.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"jobs.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"jobs.currentPage\" items-per-page=\"jobs.perPage\" max-size=\"jobs.maxSize\" boundary-links=\"true\" ng-click=\"jobs.fnPageChanged(jobs.currentPage, jobs.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{jobs.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : jobs.isRefresh}\" ng-click=\"jobs.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"jobs.activeTabIndex !== 1 && jobs.selectedJobObj && jobs.isJobDetailsLoaded && !jobs.isShowDashboard && !jobs.isShowJobStats && !jobs.isShowWidgetEditor && !jobs.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><job-info job-obj=\"jobs.selectedJobObj\" selected-job-table=\"jobs.selectedJobTable\" user-permissions-obj=\"jobs.permissionObj\"></job-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"jobs.activeTabIndex !== 1 && jobs.isShowDashboard && !jobs.isShowJobStats && !jobs.isShowWidgetEditor && !jobs.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Jobs</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Job To create a label, select Create Job</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Jobs are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Job</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"jobs.activeTabIndex !== 1 && !jobs.isShowDashboard && jobs.isShowJobStats && !jobs.isShowWidgetEditor && !jobs.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'job\'\" service-name=\"\'Job\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"jobs.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"jobs.fnGetWidgetEditor()\" fn-hide-chart=\"jobs.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"jobs.activeTabIndex !== 1 && !jobs.isShowDashboard && !jobs.isShowJobStats && jobs.isShowWidgetEditor && !jobs.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'job\'\" service-display-name=\"\'Job\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"jobs.activeTabIndex !== 1 && !jobs.isShowDashboard && !jobs.isShowJobStats && !jobs.isShowWidgetEditor && jobs.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'job\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/lifecycle/lifecycle.html","<div class=\"row h-100\" ng-init=\"lifecycle.fnInitLifecycle()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"lifecycle.permissionObj.List\" field-arr=\"lifecycle.searchFieldArr\" filter-query=\"lifecycle.filterQuery\" state-name=\"\'main.lifecycle\'\" fn-filter-query-change=\"lifecycle.fnFilterQueryChanged(filterQuery)\" fn-resize=\"lifecycle.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"lifecycle.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"lifecycle.isLifecyclesLoading\" hide-circle=\"true\" fn-resize=\"lifecycle.fnSetLoaderTableHeight()\"></table-loader><div class=\"lifecycle-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!lifecycle.isLifecyclesLoading\"><thead><tr><th ng-if=\"lifecycle.lifecyclesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"lifecycle.isAllChecked\" ng-click=\"lifecycle.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-l-10\" ng-if=\"lifecycle.lifecyclesArr.length\">Task</th><th ng-if=\"!lifecycle.lifecyclesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"lifecycleObj in lifecycle.lifecyclesArr track by $index\" ng-click=\"lifecycle.fnGetLifecycle(lifecycleObj, lifecycle.lifecyclesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"lifecycleObj.isCheck\" ng-change=\"lifecycle.fnCheckUncheckHeader(lifecycleObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"pull-left col-sm-10 p-l-10\"><div class=\"ellipsis\"><label class=\"m-b-0\">{{lifecycleObj.request.replace(\'_\',\' \')}}</label> <span class=\"m-l-0\" ng-click=\"lifecycle.fnGetFilterDataByRequestId(lifecycleObj.requestId)\"><small>{{lifecycleObj.reqId}}</small></span><br><span ng-if=\"lifecycleObj.gatewayId && !lifecycleObj.deviceId\"><i uib-tooltip=\"{{lifecycleObj.gatewayId}}\" tooltip-placement=\"right\" class=\"fa fa-microchip\"></i></span> <span ng-if=\"lifecycleObj.deviceId && lifecycleObj.gatewayId\"><i uib-tooltip-html=\"\'{{lifecycleObj.gatewayId}}<br>{{lifecycleObj.deviceId}}\'\" tooltip-placement=\"right\" class=\"fa fa-sitemap\"></i></span> <span class=\"m-l-5\"><small>{{lifecycleObj.task.replace(\'_\', \' \')}}: {{lifecycleObj.name.replace(\'_\', \' \')}}</small></span></div></div><div class=\"pull-right text-center col-sm-2\"><span class=\"ellipsis\" uib-tooltip=\"{{lifecycleObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"left\">{{lifecycleObj.humanDateCreatedRelative}}</span><br><span class=\"fa\" uib-tooltip=\"{{lifecycleObj.result}}\" tooltip-placement=\"top\" ng-class=\"lifecycle.fnGetResultIcon(lifecycleObj.result)\"></span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!lifecycle.isLifecyclesLoading && lifecycle.lifecyclesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{lifecycle.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"lifecycle.perPage = 10; lifecycle.fnPageChanged(lifecycle.currentPage, lifecycle.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"lifecycle.perPage = 20; lifecycle.fnPageChanged(lifecycle.currentPage, lifecycle.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"lifecycle.perPage = 50; lifecycle.fnPageChanged(lifecycle.currentPage, lifecycle.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"lifecycle.perPage = 100; lifecycle.fnPageChanged(lifecycle.currentPage,lifecycle.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"lifecycle.perPage = 500; lifecycle.fnPageChanged(lifecycle.currentPage, lifecycle.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"lifecycle.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"lifecycle.currentPage\" items-per-page=\"lifecycle.perPage\" max-size=\"lifecycle.maxSize\" boundary-links=\"true\" ng-click=\"lifecycle.fnPageChanged(lifecycle.currentPage, lifecycle.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"lifecycle.permissionObj.List\"><label>Total: {{lifecycle.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : lifecycle.isRefresh}\" ng-click=\"lifecycle.fnReload();\" aria-hidden=\"true\"></i></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"lifecycle.selectedLifecyclesArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Lifecycles:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedLifecycle in lifecycle.selectedLifecyclesArr\" is-open=\"selectedLifecycle.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedLifecycle.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); lifecycle.fnCheckUncheckHeader(selectedLifecycle, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedLifecycle.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedLifecycle.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"lifecycle.selectedLifecyclesArr.length && lifecycle.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"lifecycle.permissionObj.Delete\" ng-click=\"lifecycle.fnDeleteMultipleLifeCycles(lifecycle.selectedLifecyclesArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!lifecycle.selectedLifecyclesArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-history\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Lifecycle</label></div></div></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"lifecycle.selectedLifecyclesArr.length === 1 && lifecycle.selectedLifecycleObj && !lifecycle.isLifecycleDetailsLoaded\"></div><div ng-if=\"lifecycle.selectedLifecyclesArr.length === 1 && lifecycle.selectedLifecycleObj && lifecycle.isLifecycleDetailsLoaded\"><lifecycle-info lifecycle-obj=\"lifecycle.selectedLifecycleObj\" lifecycle-permissions-obj=\"lifecycle.permissionObj\"></lifecycle-info></div></div></div></div></div></div>");
$templateCache.put("app/node/node/node.html","<div class=\"row h-100\" ng-init=\"node.fnInitNodes()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"node.activeTabIndex\"><uib-tab index=\"1\" select=\"node.fnTabChanged(node.tabs[0])\" ng-click=\"node.fnChangeTab(node.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{node.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in node.tabs track by $index\" select=\"node.fnTabChanged(tab)\" ng-click=\"node.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"node.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();node.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"node.fnGetNodeDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!node.isFullWidthDevice\"><a ng-click=\"node.fnGetNodeStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"node.isFullWidthDevice\"><a ng-click=\"node.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{node.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"node.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"node.isFullWidthDevice && node.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'node\'\" service-name=\"\'Node\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"node.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"node.fnGetWidgetEditor()\" fn-hide-chart=\"node.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"node.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{node.project.name ? node.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"node.nodeProjectSearch[node.nodeProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in node.filterProject=(node.projectsArr | filter:node.nodeProjectSearch) track by $index\" ng-click=\"node.fnGetProjectNode(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === node.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!node.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"node.isRefreshData\" search-identifier=\"\'nodeSearch\'\" filters-arr=\"node.searchFiltersArr\" filter-query=\"node.filterQuery\" fn-filter-query-change=\"node.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node\'\" fn-resize=\"node.fnSetTableHeight()\" sort-field-arr=\"node.sortFieldArr\" is-column-view=\"true\" table-alias=\"node.tableAlias\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"node.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"node.isShowInsightOption()\"><a ng-click=\"node.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-if=\"node.permissionObj.ENABLE_NODE\"><a ng-click=\"node.fnEnableMultipleNodes(node.selectedNodesArr)\" ng-class=\"!node.selectedNodesArr.length ? \'pace opacity-5\' : \'\'\"><i class=\"m-r-5 fa fa-toggle-on\"></i>Enable</a></li><li ng-if=\"node.permissionObj.DISABLE_NODE\"><a ng-click=\"node.fnDisableMultipleNodes(node.selectedNodesArr)\" ng-class=\"!node.selectedNodesArr.length ? \'pace opacity-5\' : \'\'\"><i class=\"m-r-5 fa fa-toggle-off\"></i>Disable</a></li><li ng-hide=\"true\"><a ng-csv=\"node.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"node.csvHeaderArr\" filename=\"node.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"node.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"node.isNodesLoading\" fn-resize=\"node.fnSetLoaderTableHeight()\"></table-loader><div class=\"nodes-table table-container\"><table id=\"nodesTable\" class=\"table table-striped table-check-box\" ng-if=\"!node.isNodesLoading\"><thead><tr><th ng-if=\"node.nodesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"node.isAllChecked\" ng-click=\"node.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th class=\"\" ng-if=\"node.nodesArr.length\"></th><th ng-if=\"!node.nodesArr.length\">No records found...</th></tr></thead><tbody id=\"nodeTable\"><tr ng-repeat=\"nodeObj in node.nodesArr track by $index\" ng-click=\"node.fnCheckUncheckHeader(nodeObj, node.nodesArr);\" ng-mouseover=\"node.fnShowAction(nodeObj)\" ng-mouseleave=\"node.fnHideAction(nodeObj)\" context-menu=\"node.nodeContextMenu(nodeObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"nodeObj.isCheck\" ng-change=\"node.fnCheckUncheckCheckbox(nodeObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{nodeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"node.fnGetHealthColor(nodeObj.health, nodeObj)\"><span class=\"healtSpan\">{{nodeObj.healthName}}</span></button></td><td><div class=\"d-flex\"><div class=\"d-flex m-r-15\" uib-tooltip=\"{{nodeObj.ecuConnected ?\'ECU Connection: Connected\' : \'ECU Connection: Disconnected\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeObj.ecuConnected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><div class=\"d-flex\" uib-tooltip=\"{{nodeObj.connected ?\'Node Connection: Connected\' : \'Node Connection: Disconnected\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!nodeObj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex m-r-5 m-b-5\" ng-if=\"nodeObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"Node can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div><div class=\"d-flex\" style=\"width: calc(100% - 25px)\"><label class=\"ellipsis label_name\">{{nodeObj.name}}</label></div></div><span class=\"ellipsis DescriptionText span_des\" style=\"height: 20px\">{{nodeObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"nodeObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"nodeObj.name\" placeholder=\"Name for the Node*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"nodeObj.description\" placeholder=\"Description regarding Node\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();node.fnCancelNodeEditMode(nodeObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!nodeObj.name.length\" ng-click=\"$event.stopPropagation();node.fnSaveNodeInfo(nodeObj)\" value=\"Save\"></div></div></div></td><td ng-show=\"!nodeObj.isEditable\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Sync Date\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{nodeObj.lastSeenDate ? nodeObj.lastSeenDate : \'Never\' }}</span></div></div></td><td ng-show=\"!nodeObj.isEditable\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{nodeObj.project.name}}</span></div></div></td><td ng-show=\"!nodeObj.isEditable\"><div class=\"d-flex align-items-center justify-content-flex-end\" ng-if=\"nodeObj.isShowAction\"><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" uib-tooltip=\"Synchronize\" ng-if=\"nodeObj.syncState === \'NOT_SYNCHRONIZED\'\" ng-click=\"$event.stopPropagation(); node.fnDeployNode(nodeObj)\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" ng-if=\"node.permissionObj.UPDATE_NODE_NAME && node.permissionObj.UPDATE_NODE_DESCRIPTION && nodeObj.lifecycleState === \'READY\'\" ng-click=\"$event.stopPropagation();node.fnEditNodeInfoTab(nodeObj,4)\" uib-tooltip=\"Edit\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/pencil.svg#pencil\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" ng-if=\"node.permissionObj.REQUEST_NODE_TUNNEL\" ng-click=\"$event.stopPropagation();node.fnRequestNodeTunnel(nodeObj)\" uib-tooltip=\"Open Tunnel\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/service/node/tunnel.svg#tunnel\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" ng-if=\"node.permissionObj.REPLACE_NODE_IOT3\" ng-click=\"$event.stopPropagation();node.fnUpdateNodeIoT3(nodeObj)\" uib-tooltip=\"Update IoT3\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/node/updateIoT3.svg#updateIoT3\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" ng-if=\"node.isRediscoveryPermission && nodeObj.lifecycleState === \'READY\'\" ng-click=\"$event.stopPropagation();node.fnRequestReplaceRediscovery(nodeObj)\" uib-tooltip=\"Discover\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/service/node/discover.svg#discover\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" uib-tooltip=\"Notes\" ng-click=\"$event.stopPropagation();node.fnOpenNodeNotes(nodeObj)\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/node/notes.svg#notes\"></use></svg></div><div class=\"d-flex p-5 m-r-10 action-btn align-items-center justify-content-center\" uib-tooltip=\"Location\" ng-click=\"$event.stopPropagation();node.fnOpenNodeInfoTab(nodeObj,3)\" tooltip-append-to-body=\"true\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/node/nodeLocation.svg#nodeLocation\"></use></svg></div><div class=\"d-flex p-5 m-r-0 action-btn align-items-center justify-content-center\" ng-if=\"node.permissionObj.REGISTER_NODE\" uib-tooltip=\"Clone Settings\" tooltip-append-to-body=\"true\" ng-click=\"$event.stopPropagation();node.fnCloneNodeSettings(nodeObj)\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/service/node/clone.svg#clone\"></use></svg></div></div></td><td class=\"text-right\" ng-show=\"!nodeObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': node.isDropUp }\" ng-click=\"$event.stopPropagation(); node.toggleDropUp(\'nodeTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"node.permissionObj.UPDATE_NODE_NAME && node.permissionObj.UPDATE_NODE_DESCRIPTION && nodeObj.lifecycleState === \'READY\'\"><a ng-click=\"node.fnEditNodeInfoTab(nodeObj,4)\">Edit</a></li><li ng-if=\"node.permissionObj.DISABLE_NODE && nodeObj.lifecycleState === \'READY\' && nodeObj.operation === \'ENABLED\'\"><a ng-click=\"node.fnDisabledNode(nodeObj)\">Disable</a></li><li ng-if=\"node.permissionObj.REQUEST_NODE_TUNNEL\"><a ng-click=\"node.fnRequestNodeTunnel(nodeObj)\">Open Tunnel</a></li><li ng-if=\"node.permissionObj.REPLACE_NODE_IOT3\"><a ng-click=\"node.fnUpdateNodeIoT3(nodeObj)\">Update IoT3</a></li><li ng-if=\"node.isRediscoveryPermission && nodeObj.lifecycleState === \'READY\'\"><a ng-click=\"node.fnRequestReplaceRediscovery(nodeObj)\">Discover</a></li><li ng-if=\"node.permissionObj.REGISTER_NODE\"><a ng-click=\"node.fnCloneNodeSettings(nodeObj)\">Clone Settings</a></li><li><a ng-click=\"node.fnCopyId(nodeObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!node.isNodesLoading && node.nodesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{node.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"node.perPage = 10; node.fnPageChanged(node.currentPage, node.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"node.perPage = 20; node.fnPageChanged(node.currentPage, node.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"node.perPage = 50; node.fnPageChanged(node.currentPage, node.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"node.perPage = 100; node.fnPageChanged(node.currentPage,node.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"node.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"node.currentPage\" items-per-page=\"node.perPage\" max-size=\"node.maxSize\" boundary-links=\"true\" ng-click=\"node.fnPageChanged(node.currentPage, node.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{node.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : node.isRefresh}\" ng-click=\"node.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"node.permissionObj.REGISTER_NODE\" ng-click=\"node.fnHideShowCreateForm()\">Register Node</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && node.selectedNodeObj && node.isNodeDetailsLoaded && !node.isCreate && !node.isUpdateIoT3 && !node.isShowDashboard && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-info node-obj=\"node.selectedNodeObj\" user-permissions-obj=\"node.permissionObj\"></node-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && node.isCreate && !node.isUpdateIoT3 && !node.isShowDashboard && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/node/createNode/createNode.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isCreate && node.isUpdateIoT3 && !node.isShowDashboard && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/node/updateIoT3/updateIoT3.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Nodes</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Node To create a label, select Create Node</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"node.fnHideShowCreateForm()\">Create Node</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Nodes are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Nodes</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'node\'\" service-name=\"\'Node\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"node.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"node.fnGetWidgetEditor()\" fn-hide-chart=\"node.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><widget-editor app-name=\"\'node\'\" service-name=\"\'node\'\" service-display-name=\"\'Node\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && !node.isShowWidgetEditor && node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'node\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && node.isShowTunnel && !node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/node/nodeTunnel/nodeTunnel.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && node.isShowSynchronizingNode && !node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/node/nodeSynchronizing/nodeSynchronizing.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"node.activeTabIndex !== 1 && !node.isShowDashboard && !node.isCreate && !node.isUpdateIoT3 && !node.isShowNodeStats && !node.isShowWidgetEditor && !node.isCreateIssue && !node.isShowTunnel && !node.isShowSynchronizingNode && node.isShowRediscoveryNode\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/node/nodeDiscover/nodeDiscover.html\'\"></ng-include></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/notification/notification.html","<div class=\"row h-100\" ng-init=\"notification.fnInitNotifications()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"notification.permissionObj.List\" field-arr=\"notification.searchFieldArr\" filter-query=\"notification.filterQuery\" state-name=\"\'main.notification\'\" fn-filter-query-change=\"notification.fnFilterQueryChanged(filterQuery)\" fn-resize=\"notification.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"notification.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"notification.isNotificationsLoading\" fn-resize=\"notification.fnSetLoaderTableHeight()\"></table-loader><div class=\"notifications-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!notification.isNotificationsLoading\"><thead><tr><th ng-if=\"notification.notificationsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"notification.isAllChecked\" ng-click=\"notification.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"notification.notificationsArr.length\"></th><th ng-if=\"notification.notificationsArr.length\"><span ng-click=\"notification.fnNotificationSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"notification.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"notification.notificationsArr.length\"></th><th ng-if=\"!notification.notificationsArr.length\">No records found...</th></tr></thead><tbody id=\"notificationTable\"><tr ng-repeat=\"notificationObj in notification.notificationsArr track by $index\" ng-click=\"notification.fnGetNotification(notificationObj, notification.notificationsArr);\" context-menu=\"notification.notificationContextMenu(notificationObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"notificationObj.isCheck\" ng-change=\"notification.fnCheckUncheckHeader(notificationObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallStateIcon\" ng-show=\"!notificationObj.isEditable\"><span class=\"stateIconBorder\" ng-style=\"notification.getNotificationStateColor(notificationObj.state)\"><span class=\"fa stateIcon\" ng-class=\"notification.fnGetNotificationStateIcon(notificationObj.state)\"></span></span></td><td class=\"attributeTdCSS\" colspan=\"{{!notificationObj.isEditable ?0:1}}\"><label class=\"ellipsis m-b-0\" ng-show=\"!notificationObj.isEditable\">{{notificationObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription\" ng-bind=\"notificationObj.description\" ng-show=\"!notificationObj.isEditable\"></span><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput\" ng-show=\"notificationObj.isEditable\"><div class=\"col-sm-3 p-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"notificationObj.name\" placeholder=\"Name for the Notification*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-3 p-r-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"notificationObj.description\" placeholder=\"Description regarding Notification\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"notificationObj.state\">{{notificationObj.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in notification.statesArr\" role=\"menuitem\"><a ng-click=\"$event.stopPropagation();notificationObj.state = action;\">{{action}}</a></li></ul></div></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();notification.fnCancelNotificationEditMode(notificationObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!notificationObj.name.length\" ng-click=\"$event.stopPropagation();notification.fnSaveNotificationInfo(notificationObj)\" value=\"Save\"></div></div></div></div></td><td class=\"text-right\" ng-show=\"!notificationObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': notification.isDropUp }\" ng-click=\"$event.stopPropagation(); notification.toggleDropUp(\'notificationTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"notification.fnNotificationInfoTab(notificationObj,\'Details\')\">Details</a></li><li ng-if=\"notification.permissionObj.Modify\"><a ng-click=\"notification.fnNotificationInfoTab(notificationObj,\'Edit\')\">Edit</a></li><li ng-if=\"notification.permissionObj.Create\"><a ng-click=\"notification.fnNotificationClone(notificationObj)\">Clone</a></li><li ng-if=\"notification.permissionObj.Modify\"><a ng-click=\"notification.fnChangeNotificationState(notificationObj)\">{{notificationObj.state === \'ACTIVE\' ?\'Deactivate\':\'Activate\'}}</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!notification.isNotificationsLoading && notification.notificationsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{notification.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"notification.perPage = 10; notification.fnPageChanged(notification.currentPage, notification.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"notification.perPage = 20; notification.fnPageChanged(notification.currentPage, notification.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"notification.perPage = 50; notification.fnPageChanged(notification.currentPage, notification.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"notification.perPage = 100; notification.fnPageChanged(notification.currentPage,notification.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"notification.perPage = 500; notification.fnPageChanged(notification.currentPage, notification.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"notification.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"notification.currentPage\" items-per-page=\"notification.perPage\" max-size=\"notification.maxSize\" boundary-links=\"true\" ng-click=\"notification.fnPageChanged(notification.currentPage, notification.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!notification.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"notification.permissionObj.List\"><label>Total: {{notification.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : notification.isRefresh}\" ng-click=\"notification.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"notification.permissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"notification.fnHideShowCreateForm()\">Create Notification</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"notification.selectedNotificationsArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of Selected Notifications:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedNotification in notification.selectedNotificationsArr\" is-open=\"selectedNotification.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedNotification.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); notification.fnCheckUncheckHeader(selectedNotification, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedNotification.state\"><div class=\"col-xs-4\"><label>Notification State:</label></div><div class=\"col-xs-6\">{{selectedNotification.state}}</div></div><div class=\"row\" ng-if=\"selectedNotification.logging\"><div class=\"col-xs-4\"><label>Notification logging:</label></div><div class=\"col-xs-6\">{{selectedNotification.logging}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"notification.selectedNotificationsArr.length && notification.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"notification.permissionObj.Delete\" ng-click=\"notification.fnDeleteMultipleNotifications(notification.selectedNotificationsArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen overflow-y-auto\" style=\"overflow-x: hidden\" ng-show=\"!notification.isCreate && !notification.selectedNotificationsArr.length\"><div class=\"col-sm-12 text-left p-0 p-l-20 p-r-20\"><h2 class=\"m-b-0 text-primary\">Featured News</h2><h2 class=\"m-b-2\" style=\"font-weight: bold\">Node Notifications are now available at no charge</h2><small>Posted Monday 17th June 2019</small><p class=\"m-t-15 m-b-15\">Node Notifications allow you to send outbound messages directly from Observers simplifying the process of keeping your teams up to date about your system health and performance.</p><p class=\"m-b-15\">Based on feedback from our customers and to make ECSMon Node even more economical we are making Node Notifications available to all customers at no charge, this change to our pricing model goes in to effect on June 17, 2019.</p><p class=\"m-b-15\">Notifications sent prior to the transition will appear in your regular billing module. Notifications sent after this date will not incur any costs or appear in future billing cycles. This change goes in to effect on June 17, 2019! To learn more, feel free to contact.</p><p>- Eric</p></div><div class=\"row\"><div class=\"col-sm-12\"><i class=\"fa fa-bell\" ng-class=\"notification.isSmallScreen ? \'fa-4x\' : \'fa-10x\'\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Notification</label></div><div class=\"col-sm-12\" ng-if=\"notification.permissionObj.Create\"><button class=\"btn btn-primary m-b-10\" ng-click=\"notification.fnHideShowCreateForm()\">Create Notification</button></div></div></div><div class=\"content-container form-container\" ng-if=\"notification.isCreate && !notification.selectedNotificationsArr.length\"><ng-include src=\"\'app/node/notification/createNotification/createNotification.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"notification.selectedNotificationsArr.length === 1 && notification.selectedNotificationObj && !notification.isNotificationDetailsLoaded\"></div><div ng-if=\"notification.selectedNotificationsArr.length === 1 && notification.selectedNotificationObj && notification.isNotificationDetailsLoaded\"><notification-info notification-obj=\"notification.selectedNotificationObj\" notification-permissions-obj=\"notification.permissionObj\"></notification-info></div></div></div></div></div></div>");
$templateCache.put("app/node/observer/observer.html","<div class=\"row h-100\" ng-init=\"observer.fnInitEcus()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"observer.activeTabIndex\"><uib-tab index=\"1\" select=\"observer.fnTabChanged(observer.tabs[0])\" ng-click=\"observer.fnChangeTab(observer.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{observer.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in observer.tabs track by $index\" select=\"observer.fnTabChanged(tab)\" ng-click=\"observer.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"observer.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();observer.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"observer.fnGetEcuDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!observer.isFullWidthDevice\"><a ng-click=\"observer.fnGetEcuStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"observer.isFullWidthDevice\"><a ng-click=\"observer.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{observer.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"observer.activeTabIndex === 1\"><div class=\"col-sm-12 p-t-10 p-b-10 p-0 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"observer.isFullWidthDevice && observer.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'observer\'\" service-name=\"\'Observer\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"observer.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"observer.fnGetWidgetEditor()\" fn-hide-chart=\"observer.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"observer.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{observer.project.name ? observer.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"observer.ecuProjectSearch[observer.ecuProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in observer.filterProject=(observer.projectsArr | filter:observer.ecuProjectSearch) track by $index\" ng-click=\"observer.fnGetProjectEcu(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === observer.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!observer.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"observer.isRefreshData\" search-identifier=\"\'ecuSearch\'\" filters-arr=\"observer.searchFiltersArr\" filter-query=\"observer.filterQuery\" fn-filter-query-change=\"observer.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node_observer\'\" fn-resize=\"observer.fnSetTableHeight()\" is-column-view=\"observer.isColumnView\" sort-field-arr=\"observer.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"observer.isShowInsightOption()\"><a ng-click=\"observer.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li></ul></div></div></div><div class=\"row\" ng-if=\"observer.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"observer.isEcusLoading\" fn-resize=\"observer.fnSetLoaderTableHeight()\"></table-loader><div class=\"ecus-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!observer.isEcusLoading\"><thead><tr><th ng-if=\"observer.ecusArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"observer.isAllChecked\" ng-click=\"observer.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"observer.ecusArr.length\"></th><th ng-if=\"!observer.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in observer.ecusArr track by $index\" ng-click=\"observer.fnCheckUncheckHeader(ecuObj, observer.ecusArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"ecuObj.isCheck\" ng-change=\"observer.fnCheckUncheckHeader(ecuObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"observer.fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healthSpan\">{{ecuObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span></div></td><td><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-sm btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation();\">Unregistered</button> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex\"><label class=\"m-0\">Unregistered</label></div></div></td><td><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered && ecuObj.phase === \'ACTIVE\'\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"ecuObj.syncState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\"><span ng-if=\"ecuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"ecuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"ecuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"ecuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"ecuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"ecuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"ecuObj.lifecycleState === \'READY\'\">Ready</span></span> <span ng-if=\"ecuObj.syncState === \'NOT_SYNCHRONIZED\'\"><label class=\"m-0\">Not Synchronized</label></span></div></div><div class=\"d-flex align-items-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div></div></td><td></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': observer.isDropUp }\" ng-click=\"$event.stopPropagation(); observer.toggleDropUp(\'ecuTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"observer.fnOpenEcuInfoTab(ecuObj,1)\">Observer</a></li><li><a ng-click=\"observer.fnCopyId(ecuObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!observer.isEcusLoading && observer.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{observer.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"observer.perPage = 10; observer.fnPageChanged(observer.currentPage, observer.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"observer.perPage = 20; observer.fnPageChanged(observer.currentPage, observer.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"observer.perPage = 50; observer.fnPageChanged(observer.currentPage, observer.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"observer.perPage = 100; observer.fnPageChanged(observer.currentPage,observer.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"observer.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"observer.currentPage\" items-per-page=\"observer.perPage\" max-size=\"observer.maxSize\" boundary-links=\"true\" ng-click=\"observer.fnPageChanged(observer.currentPage, observer.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{observer.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : observer.isRefresh}\" ng-click=\"observer.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden\">Create ECU</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"observer.activeTabIndex !== 1 && observer.selectedEcuObj && observer.isEcuDetailsLoaded && !observer.isShowDashboard && !observer.isShowEcuStats && !observer.isShowWidgetEditor && !observer.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><observer-info ecu-obj=\"observer.selectedEcuObj\" user-permissions-obj=\"observer.permissionObj\"></observer-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"observer.activeTabIndex !== 1 && observer.isShowDashboard && !observer.isShowEcuStats && !observer.isShowWidgetEditor && !observer.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Observers</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Observers are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"observer.activeTabIndex !== 1 && !observer.isShowDashboard && observer.isShowEcuStats && !observer.isShowWidgetEditor && !observer.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'observer\'\" service-name=\"\'Observer\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"observer.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"observer.fnGetWidgetEditor()\" fn-hide-chart=\"observer.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"observer.activeTabIndex !== 1 && !observer.isShowDashboard && !observer.isShowEcuStats && observer.isShowWidgetEditor && !observer.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'observer\'\" service-display-name=\"\'Observer\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"observer.activeTabIndex !== 1 && !observer.isShowDashboard && !observer.isShowEcuStats && !observer.isShowWidgetEditor && observer.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'observer\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/project/project.html","<div class=\"row h-100\" ng-init=\"project.fnInitProjects()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"project.activeTabIndex\"><uib-tab index=\"1\" select=\"project.fnTabChanged(project.tabs[0])\" ng-click=\"project.fnChangeTab(project.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"project.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in project.tabs track by $index\" select=\"project.fnTabChanged(tab)\" ng-click=\"project.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"project.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();project.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnGetProjectDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!project.isFullWidthDevice\"><a ng-click=\"project.fnGetProjectStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"project.fnGetProjectRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"project.isFullWidthDevice\"><a ng-click=\"project.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{project.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"project.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"project.isFullWidthDevice && project.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"project.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"project.fnGetWidgetEditor()\" fn-hide-chart=\"project.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"project.isRefreshData\" search-identifier=\"\'projectSearch\'\" filters-arr=\"project.searchFiltersArr\" filter-query=\"project.filterQuery\" fn-filter-query-change=\"project.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node_project\'\" fn-resize=\"project.fnSetTableHeight()\" sort-field-arr=\"project.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"project.selectedProjectsArr.length\"><a ng-click=\"project.fnDeleteMultipleProjects(project.selectedProjectsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"project.isShowInsightOption()\"><a ng-click=\"project.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"project.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"project.csvHeaderArr\" filename=\"project.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"project.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"project.isProjectsLoading\" fn-resize=\"project.fnSetLoaderTableHeight()\"></table-loader><div class=\"project-table table-container\"><table id=\"projectsTable\" class=\"table table-striped table-check-box\" ng-if=\"!project.isProjectsLoading\"><thead><tr><th ng-if=\"project.projectsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"project.isAllChecked\" ng-click=\"project.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"project.projectsArr.length\"><span>Name</span></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"!project.projectsArr.length\">No records found...</th></tr></thead><tbody id=\"projectTable\"><tr ng-repeat=\"projectObj in project.projectsArr track by $index\" ng-click=\"project.fnCheckUncheckHeader(projectObj);\" context-menu=\"project.projectContextMenu(projectObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectObj.isCheck\" ng-change=\"project.fnCheckUncheckHeader(projectObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!projectObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{projectObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{projectObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"projectObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name for the Project*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description regarding Project\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();project.fnCancelProjectEditMode(projectObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!projectObj.name.length\" ng-click=\"$event.stopPropagation();project.fnSaveProjectInfo(projectObj)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{projectObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{projectObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!projectObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': project.isDropUp }\" ng-click=\"$event.stopPropagation(); project.toggleDropUp(\'project_Table\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,1)\">Details</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,2)\">Teams</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,3)\">S4</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,4)\">Email Template</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,5)\">Tags</a></li><li><a ng-click=\"project.fnCopyId(projectObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!project.isProjectsLoading && project.projectsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{project.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 10; project.fnPageChanged(project.currentPage, project.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 20; project.fnPageChanged(project.currentPage, project.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 50; project.fnPageChanged(project.currentPage, project.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 100; project.fnPageChanged(project.currentPage,project.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"project.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"project.currentPage\" items-per-page=\"project.perPage\" max-size=\"project.maxSize\" boundary-links=\"true\" ng-click=\"project.fnPageChanged(project.currentPage, project.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{project.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : project.isRefresh}\" ng-click=\"project.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button ng-if=\"project.permissionObj.CREATE_PROJECT\" type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"project.fnHideShowCreateForm()\">Create Project</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.selectedProjectObj && project.isProjectDetailsLoaded && !project.isCreate && !project.isShowDashboard && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-project-info project-obj=\"project.selectedProjectObj\" user-permissions-obj=\"project.permissionObj\"></node-project-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.isCreate && !project.isShowDashboard && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/project/createProject/createProject.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Projects</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Project. To create a project, select Create Project.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"project.fnHideShowCreateForm()\">Create Project</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Projects are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Projects</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"project.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"project.fnGetWidgetEditor()\" fn-hide-chart=\"project.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'project\'\" service-display-name=\"\'Project\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-init=\"project.fnInitProjectRelationships()\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && !project.isShowWidgetEditor && project.isShowRelationships && !project.isCreateIssue\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"project.isProjectRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!project.isProjectRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" project-relationships=\"\" fn-get-project-detail=\"project.fnOpenProjectInfoTab(projectObj,1)\" project-obj=\"project.newProjectData\"></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'project\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/project_emailTemplate/node_project_emailTemplate.html","<div class=\"row h-100\" ng-init=\"nodeProjectEmailTemplate.fnInitEmailTemplate();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeProjectEmailTemplate.activeTabIndex\"><uib-tab index=\"1\" select=\"nodeProjectEmailTemplate.fnTabChanged(nodeProjectEmailTemplate.tabs[0])\" ng-click=\"nodeProjectEmailTemplate.fnChangeTab(nodeProjectEmailTemplate.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"nodeProjectEmailTemplate.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in nodeProjectEmailTemplate.tabs track by $index\" select=\"nodeProjectEmailTemplate.fnTabChanged(tab)\" ng-click=\"nodeProjectEmailTemplate.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"nodeProjectEmailTemplate.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();nodeProjectEmailTemplate.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeProjectEmailTemplate.fnGetEmailTemplateDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!nodeProjectEmailTemplate.isFullWidthDevice\"><a ng-click=\"nodeProjectEmailTemplate.fnGetEmailTemplateStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"nodeProjectEmailTemplate.isFullWidthDevice\"><a ng-click=\"nodeProjectEmailTemplate.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{nodeProjectEmailTemplate.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"nodeProjectEmailTemplate.isFullWidthDevice && nodeProjectEmailTemplate.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'projectEmailTemplate\'\" service-name=\"\'ProjectEmailTemplate\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeProjectEmailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeProjectEmailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"nodeProjectEmailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"nodeProjectEmailTemplate.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"nodeProjectEmailTemplate.searchFiltersArr\" filter-query=\"nodeProjectEmailTemplate.filterQuery\" fn-filter-query-change=\"nodeProjectEmailTemplate.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.project_emailTemplate\'\" fn-resize=\"nodeProjectEmailTemplate.fnSetTableHeight()\" sort-field-arr=\"nodeProjectEmailTemplate.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"nodeProjectEmailTemplate.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"nodeProjectEmailTemplate.isEmailTemplatesloading\" fn-resize=\"nodeProjectEmailTemplate.fnSetLoaderTableHeight()\"></table-loader><div class=\"email-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!nodeProjectEmailTemplate.isEmailTemplatesloading\"><thead><tr><th ng-if=\"nodeProjectEmailTemplate.emailTemplateArr.length\" class=\"p-8\"></th><th ng-if=\"nodeProjectEmailTemplate.emailTemplateArr.length\"><span>Name</span></th><th ng-if=\"nodeProjectEmailTemplate.emailTemplateArr.length\"></th><th ng-if=\"!nodeProjectEmailTemplate.emailTemplateArr.length\">No records found...</th></tr></thead><tbody id=\"emailTable\"><tr ng-repeat=\"emailTemplateObj in nodeProjectEmailTemplate.emailTemplateArr track by $index\" ng-click=\"nodeProjectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"emailTemplateObj.isCheck\" ng-change=\"nodeProjectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"emailTemplateObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': nodeProjectEmailTemplate.isDropUp }\" ng-click=\"$event.stopPropagation(); nodeProjectEmailTemplate.toggleDropUp(\'emailTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeProjectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!nodeProjectEmailTemplate.isEmailTemplatesloading && nodeProjectEmailTemplate.emailTemplateArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{nodeProjectEmailTemplate.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeProjectEmailTemplate.perPage = 10; nodeProjectEmailTemplate.fnPageChanged(nodeProjectEmailTemplate.currentPage, nodeProjectEmailTemplate.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectEmailTemplate.perPage = 20; nodeProjectEmailTemplate.fnPageChanged(nodeProjectEmailTemplate.currentPage, nodeProjectEmailTemplate.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectEmailTemplate.perPage = 50; nodeProjectEmailTemplate.fnPageChanged(nodeProjectEmailTemplate.currentPage, nodeProjectEmailTemplate.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectEmailTemplate.perPage = 100; nodeProjectEmailTemplate.fnPageChanged(nodeProjectEmailTemplate.currentPage,nodeProjectEmailTemplate.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"nodeProjectEmailTemplate.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"nodeProjectEmailTemplate.currentPage\" items-per-page=\"nodeProjectEmailTemplate.perPage\" max-size=\"nodeProjectEmailTemplate.maxSize\" boundary-links=\"true\" ng-click=\"nodeProjectEmailTemplate.fnPageChanged(nodeProjectEmailTemplate.currentPage, nodeProjectEmailTemplate.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{nodeProjectEmailTemplate.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : nodeProjectEmailTemplate.isRefresh}\" ng-click=\"nodeProjectEmailTemplate.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite EmailTemplate</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex !== 1 && nodeProjectEmailTemplate.selectedEmailTemplatesArr.length === 1 && nodeProjectEmailTemplate.selectedEmailTemplateObj && nodeProjectEmailTemplate.isEmailTemplateDetailsLoaded && !nodeProjectEmailTemplate.isShowDashboard && !nodeProjectEmailTemplate.isShowEmailTemplateStats && !nodeProjectEmailTemplate.isShowWidgetEditor && !nodeProjectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-project-email-template-info email-template-obj=\"nodeProjectEmailTemplate.selectedEmailTemplateObj\" user-permissions-obj=\"nodeProjectEmailTemplate.permissionObj\"></node-project-email-template-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex !== 1 && nodeProjectEmailTemplate.isShowDashboard && !nodeProjectEmailTemplate.isShowEmailTemplateStats && !nodeProjectEmailTemplate.isShowWidgetEditor && !nodeProjectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Email Templates</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Email Templates</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Email Templates are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex !== 1 && !nodeProjectEmailTemplate.isShowDashboard && nodeProjectEmailTemplate.isShowEmailTemplateStats && !nodeProjectEmailTemplate.isShowWidgetEditor && !nodeProjectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'projectEmailTemplate\'\" service-name=\"\'ProjectEmailTemplate\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeProjectEmailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeProjectEmailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"nodeProjectEmailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex !== 1 && !nodeProjectEmailTemplate.isShowDashboard && !nodeProjectEmailTemplate.isShowEmailTemplateStats && nodeProjectEmailTemplate.isShowWidgetEditor && !nodeProjectEmailTemplate.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-display-name=\"nodeProjectEmailTemplate.selectedProjectName +\' Email Template\'\" service-name=\"\'projectEmailTemplate\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectEmailTemplate.activeTabIndex !== 1 && !nodeProjectEmailTemplate.isShowDashboard && !nodeProjectEmailTemplate.isShowEmailTemplateStats && !nodeProjectEmailTemplate.isShowWidgetEditor && nodeProjectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'projectEmailTemplate\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/project_script/node_project_scripts.html","<div class=\"row h-100\" ng-init=\"nodeProjectScripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeProjectScripts.activeTabIndex\"><uib-tab index=\"1\" select=\"nodeProjectScripts.fnTabChanged(nodeProjectScripts.tabs[0])\" ng-click=\"nodeProjectScripts.fnChangeTab(nodeProjectScripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"nodeProjectScripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in nodeProjectScripts.tabs track by $index\" select=\"nodeProjectScripts.fnTabChanged(tab)\" ng-click=\"nodeProjectScripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"nodeProjectScripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();nodeProjectScripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeProjectScripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!nodeProjectScripts.isFullWidthDevice\"><a ng-click=\"nodeProjectScripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"nodeProjectScripts.isFullWidthDevice\"><a ng-click=\"nodeProjectScripts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{nodeProjectScripts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"nodeProjectScripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"nodeProjectScripts.isFullWidthDevice && nodeProjectScripts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'projectS4\'\" service-name=\"\'ProjectS4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeProjectScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeProjectScripts.fnGetWidgetEditor()\" fn-hide-chart=\"nodeProjectScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"nodeProjectScripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"nodeProjectScripts.searchFiltersArr\" filter-query=\"nodeProjectScripts.filterQuery\" fn-filter-query-change=\"nodeProjectScripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.project_scripts\'\" fn-resize=\"nodeProjectScripts.fnSetTableHeight()\" sort-field-arr=\"nodeProjectScripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"nodeProjectScripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"nodeProjectScripts.isScriptsloading\" fn-resize=\"nodeProjectScripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!nodeProjectScripts.isScriptsloading\"><thead><tr><th ng-if=\"nodeProjectScripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"nodeProjectScripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"nodeProjectScripts.scriptArr.length\"></th><th ng-if=\"!nodeProjectScripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in nodeProjectScripts.scriptArr track by $index\" ng-click=\"nodeProjectScripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"nodeProjectScripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': nodeProjectScripts.isDropUp }\" ng-click=\"$event.stopPropagation(); nodeProjectScripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeProjectScripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!nodeProjectScripts.isScriptsloading && nodeProjectScripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{nodeProjectScripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeProjectScripts.perPage = 10; nodeProjectScripts.fnPageChanged(nodeProjectScripts.currentPage, nodeProjectScripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectScripts.perPage = 20; nodeProjectScripts.fnPageChanged(nodeProjectScripts.currentPage, nodeProjectScripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectScripts.perPage = 50; nodeProjectScripts.fnPageChanged(nodeProjectScripts.currentPage, nodeProjectScripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeProjectScripts.perPage = 100; nodeProjectScripts.fnPageChanged(nodeProjectScripts.currentPage,nodeProjectScripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"nodeProjectScripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"nodeProjectScripts.currentPage\" items-per-page=\"nodeProjectScripts.perPage\" max-size=\"nodeProjectScripts.maxSize\" boundary-links=\"true\" ng-click=\"nodeProjectScripts.fnPageChanged(nodeProjectScripts.currentPage, nodeProjectScripts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{nodeProjectScripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : nodeProjectScripts.isRefresh}\" ng-click=\"nodeProjectScripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectScripts.activeTabIndex !== 1 && nodeProjectScripts.selectedScriptsArr.length === 1 && nodeProjectScripts.selectedScriptObj && nodeProjectScripts.isScriptDetailsLoaded && !nodeProjectScripts.isShowDashboard && !nodeProjectScripts.isShowScriptStats && !nodeProjectScripts.isShowWidgetEditor && !nodeProjectScripts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-project-script-info script-obj=\"nodeProjectScripts.selectedScriptObj\" user-permissions-obj=\"nodeProjectScripts.permissionObj\"></node-project-script-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectScripts.activeTabIndex !== 1 && nodeProjectScripts.isShowDashboard && !nodeProjectScripts.isShowScriptStats && !nodeProjectScripts.isShowWidgetEditor && !nodeProjectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectScripts.activeTabIndex !== 1 && !nodeProjectScripts.isShowDashboard && nodeProjectScripts.isShowScriptStats && !nodeProjectScripts.isShowWidgetEditor && !nodeProjectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'projectS4\'\" service-name=\"\'ProjectS4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeProjectScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeProjectScripts.fnGetWidgetEditor()\" fn-hide-chart=\"nodeProjectScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectScripts.activeTabIndex !== 1 && !nodeProjectScripts.isShowDashboard && !nodeProjectScripts.isShowScriptStats && nodeProjectScripts.isShowWidgetEditor && !nodeProjectScripts.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-display-name=\"nodeProjectScripts.selectedProjectName + \' S4\'\" service-name=\"\'projectS4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeProjectScripts.activeTabIndex !== 1 && !nodeProjectScripts.isShowDashboard && !nodeProjectScripts.isShowScriptStats && !nodeProjectScripts.isShowWidgetEditor && nodeProjectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'projectS4\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/script/scripts.html","<div class=\"row h-100\" ng-init=\"nodeScripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeScripts.activeTabIndex\"><uib-tab index=\"1\" select=\"nodeScripts.fnTabChanged(nodeScripts.tabs[0])\" ng-click=\"nodeScripts.fnChangeTab(nodeScripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"nodeScripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in nodeScripts.tabs track by $index\" select=\"nodeScripts.fnTabChanged(tab)\" ng-click=\"nodeScripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"nodeScripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();nodeScripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeScripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!nodeScripts.isFullWidthDevice\"><a ng-click=\"nodeScripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"nodeScripts.isFullWidthDevice\"><a ng-click=\"nodeScripts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{nodeScripts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"nodeScripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"nodeScripts.isFullWidthDevice && nodeScripts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeScripts.fnGetWidgetEditor()\" fn-hide-chart=\"nodeScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"nodeScripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"nodeScripts.searchFiltersArr\" filter-query=\"nodeScripts.filterQuery\" fn-filter-query-change=\"nodeScripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.tracker_scripts\'\" fn-resize=\"nodeScripts.fnSetTableHeight()\" sort-field-arr=\"nodeScripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"nodeScripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"nodeScripts.isScriptsloading\" fn-resize=\"nodeScripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!nodeScripts.isScriptsloading\"><thead><tr><th ng-if=\"nodeScripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"nodeScripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"nodeScripts.scriptArr.length\"></th><th ng-if=\"!nodeScripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in nodeScripts.scriptArr track by $index\" ng-click=\"nodeScripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"nodeScripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': nodeScripts.isDropUp }\" ng-click=\"$event.stopPropagation(); nodeScripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeScripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!nodeScripts.isScriptsloading && nodeScripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{nodeScripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeScripts.perPage = 10; nodeScripts.fnPageChanged(nodeScripts.currentPage, nodeScripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeScripts.perPage = 20; nodeScripts.fnPageChanged(nodeScripts.currentPage, nodeScripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeScripts.perPage = 50; nodeScripts.fnPageChanged(nodeScripts.currentPage, nodeScripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeScripts.perPage = 100; nodeScripts.fnPageChanged(nodeScripts.currentPage,nodeScripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"nodeScripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"nodeScripts.currentPage\" items-per-page=\"nodeScripts.perPage\" max-size=\"nodeScripts.maxSize\" boundary-links=\"true\" ng-click=\"nodeScripts.fnPageChanged(nodeScripts.currentPage, nodeScripts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{nodeScripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : nodeScripts.isRefresh}\" ng-click=\"nodeScripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeScripts.activeTabIndex !== 1 && nodeScripts.selectedScriptsArr.length === 1 && nodeScripts.selectedScriptObj && nodeScripts.isScriptDetailsLoaded && !nodeScripts.isShowDashboard && !nodeScripts.isShowScriptStats && !nodeScripts.isShowWidgetEditor && !nodeScripts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-script-info script-obj=\"nodeScripts.selectedScriptObj\" user-permissions-obj=\"nodeScripts.permissionObj\"></node-script-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeScripts.activeTabIndex !== 1 && nodeScripts.isShowDashboard && !nodeScripts.isShowScriptStats && !nodeScripts.isShowWidgetEditor && !nodeScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeScripts.activeTabIndex !== 1 && !nodeScripts.isShowDashboard && nodeScripts.isShowScriptStats && !nodeScripts.isShowWidgetEditor && !nodeScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"nodeScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"nodeScripts.fnGetWidgetEditor()\" fn-hide-chart=\"nodeScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeScripts.activeTabIndex !== 1 && !nodeScripts.isShowDashboard && !nodeScripts.isShowScriptStats && nodeScripts.isShowWidgetEditor && !nodeScripts.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-display-name=\"\'S4\'\" service-name=\"\'s4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeScripts.activeTabIndex !== 1 && !nodeScripts.isShowDashboard && !nodeScripts.isShowScriptStats && !nodeScripts.isShowWidgetEditor && nodeScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'s4\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/software/software.html","<div class=\"row h-100\" ng-init=\"software.fnInitSoftwares()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"software.activeTabIndex\"><uib-tab index=\"1\" select=\"software.fnTabChanged(software.tabs[0])\" ng-click=\"software.fnChangeTab(software.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"software.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in software.tabs track by $index\" select=\"software.fnTabChanged(tab)\" ng-click=\"software.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"software.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();software.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"software.fnGetSoftwareDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!software.isFullWidthDevice\"><a ng-click=\"software.fnGetSoftwareStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"software.isFullWidthDevice\"><a ng-click=\"software.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{software.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"software.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"software.isFullWidthDevice && software.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'software\'\" service-name=\"\'Software\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"software.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"software.fnGetWidgetEditor()\" fn-hide-chart=\"software.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"software.isRefreshData\" search-identifier=\"\'softwareSearch\'\" filters-arr=\"software.searchFiltersArr\" filter-query=\"software.filterQuery\" fn-filter-query-change=\"software.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.software\'\" fn-resize=\"software.fnSetTableHeight()\" sort-field-arr=\"software.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"software.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"software.selectedSoftwaresArr.length\"><a ng-click=\"software.fnDeleteMultipleSoftwares(software.selectedSoftwaresArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"software.isShowInsightOption()\"><a ng-click=\"software.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"software.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"software.csvHeaderArr\" filename=\"software.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"software.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"software.isSoftwaresLoading\" fn-resize=\"software.fnSetLoaderTableHeight()\"></table-loader><div class=\"software-table table-container\"><table id=\"softwaresTable\" class=\"table table-striped table-check-box\" ng-if=\"!software.isSoftwaresLoading\"><thead><tr><th ng-if=\"software.softwaresArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"software.isAllChecked\" ng-click=\"software.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"software.softwaresArr.length\"><span>Architecture</span></th><th ng-if=\"software.softwaresArr.length\"></th><th ng-if=\"software.softwaresArr.length\"></th><th ng-if=\"software.softwaresArr.length\"></th><th ng-if=\"software.softwaresArr.length\"></th><th ng-if=\"!software.softwaresArr.length\">No records found...</th></tr></thead><tbody id=\"softwareTable\"><tr ng-repeat=\"softwareObj in software.softwaresArr track by $index\" ng-click=\"software.fnCheckUncheckHeader(softwareObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"softwareObj.isCheck\" ng-change=\"software.fnCheckUncheckCheckbox(softwareObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{\'V\'+softwareObj.version +\' \'+ softwareObj.architecture}}</label> <span class=\"ellipsis DescriptionText span_des\">{{softwareObj.description}}</span></div></td><td class=\"attributeTdCSS-style text-center\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{softwareObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"softwareObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{softwareObj.createdDate}}</label></div></td><td class=\"text-center\">{{softwareObj.checksum ? \'Activated\': \'Not Activated\'}}</td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"softwareObj.latest\"><div class=\"d-flex width-max-content\" uib-tooltip=\"Latest Software\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/latest.svg#latest\"></use></svg></div></div></td><td class=\"text-right\" ng-show=\"!softwareObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': software.isDropUp }\" ng-click=\"$event.stopPropagation(); software.toggleDropUp(\'softwareTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"software.fnOpenSoftwareInfoTab(softwareObj,1)\">Details</a></li><li><a ng-click=\"software.fnMakeLatest(softwareObj)\">Make Latest</a></li><li><a ng-click=\"software.fnOpenBroadcastSoftware(softwareObj)\">Broadcast</a></li><li ng-if=\"!softwareObj.checksum\"><a ng-click=\"software.fnActivatesSoftware(softwareObj)\">Activate</a></li><li><a ng-click=\"software.fnCopyId(softwareObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!software.isSoftwaresLoading && software.softwaresArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{software.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"software.perPage = 10; software.fnPageChanged(software.currentPage, software.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"software.perPage = 20; software.fnPageChanged(software.currentPage, software.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"software.perPage = 50; software.fnPageChanged(software.currentPage, software.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"software.perPage = 100; software.fnPageChanged(software.currentPage,software.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"software.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"software.currentPage\" items-per-page=\"software.perPage\" max-size=\"software.maxSize\" boundary-links=\"true\" ng-click=\"software.fnPageChanged(software.currentPage, software.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{software.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : software.isRefresh}\" ng-click=\"software.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"software.fnHideShowCreateForm()\">Create Software</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && software.selectedSoftwareObj && software.isSoftwareDetailsLoaded && !software.isCreate && !software.isShowDashboard && !software.isShowSoftwareStats && !software.isShowWidgetEditor && !software.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><software-info software-obj=\"software.selectedSoftwareObj\"></software-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && software.isCreate && !software.isShowDashboard && !software.isShowSoftwareStats && !software.isShowWidgetEditor && !software.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/node/software/createSoftware/createSoftware.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && software.isShowDashboard && !software.isCreate && !software.isShowSoftwareStats && !software.isShowWidgetEditor && !software.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Softwares</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>software. To create a software, select Create software.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"software.fnHideShowCreateForm()\">Create Software</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Softwares are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Softwares</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && !software.isShowDashboard && !software.isCreate && software.isShowSoftwareStats && !software.isShowWidgetEditor && !software.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'software\'\" service-name=\"\'Software\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"software.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"software.fnGetWidgetEditor()\" fn-hide-chart=\"software.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && !software.isShowDashboard && !software.isCreate && !software.isShowSoftwareStats && software.isShowWidgetEditor && !software.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-name=\"\'software\'\" service-display-name=\"\'Software\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"software.activeTabIndex !== 1 && !software.isShowDashboard && !software.isCreate && !software.isShowSoftwareStats && !software.isShowWidgetEditor && software.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'software\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/visualization/visualization.html","<div class=\"row h-100\" ng-init=\"visualizer.fnInitVisualizer()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"visualizer.permissionObj.List\" field-arr=\"visualizer.searchFieldArr\" filter-query=\"visualizer.filterQuery\" state-name=\"\'main.visualizer\'\" fn-filter-query-change=\"visualizer.fnFilterQueryChanged(filterQuery)\" fn-resize=\"visualizer.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"visualizer.permissionObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"visualizer.isVisualizersLoading\"></app-spinner><div class=\"visualization-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!visualizer.isVisualizersLoading\"><thead><tr><th ng-if=\"visualizer.visualizersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"visualizer.isAllChecked\" ng-click=\"visualizer.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"p-l-10\" ng-if=\"visualizer.visualizersArr.length\"><span ng-click=\"visualizer.fnVisualizerSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"visualizer.fnGetSortClass(\'name\')\"></i></span></th><th class=\"p-l-10\" ng-if=\"visualizer.visualizersArr.length\"><span ng-click=\"visualizer.fnVisualizerSort(\'description\')\">Description<i class=\"m-l-5 fa\" ng-class=\"visualizer.fnGetSortClass(\'description\')\"></i></span></th><th class=\"p-l-10 text-center\" ng-if=\"visualizer.visualizersArr.length\">Icon</th><th class=\"p-l-10 text-center\" ng-if=\"visualizer.visualizersArr.length\">Target</th><th ng-if=\"!visualizer.visualizersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"visualizerObj in visualizer.visualizersArr track by $index\" ng-click=\"visualizer.fnGetVisualizer(visualizerObj, visualizer.visualizersArr);\" context-menu=\"visualizer.visualizerContextMenu(visualizerObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"visualizerObj.isCheck\" ng-change=\"visualizer.fnCheckUncheckHeader(visualizerObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-l-10\"><span class=\"ellipsis\" ng-show=\"!visualizerObj.isEditable\">{{visualizerObj.name}}</span><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput\" ng-show=\"visualizerObj.isEditable\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"visualizerObj.name\" placeholder=\"Name for the Visualizer*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></td><td class=\"p-l-10\" collapsed=\"{{!visualizerObj.isEditable?0:2}}\"><span class=\"ellipsis\" ng-show=\"!visualizerObj.isEditable\">{{visualizerObj.description}}</span><div class=\"col-sm-12 p-l-0 p-r-10 inlineInputEdit\" ng-show=\"visualizerObj.isEditable\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"visualizerObj.description\" placeholder=\"Description regarding Visualizer\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();visualizer.fnCancelVisualizerEditMode(visualizerObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!visualizerObj.name.length\" ng-click=\"$event.stopPropagation();visualizer.fnSaveVisualizerInfo(visualizerObj)\" value=\"Save\"></div></div></td><td ng-show=\"!visualizerObj.isEditable\" class=\"p-l-10 text-center\"><span><i ng-class=\"\'fa \'+visualizerObj.icon\"></i></span></td><td ng-show=\"!visualizerObj.isEditable\" class=\"p-l-10 text-center\"><span class=\"ellipsis\" ng-bind=\"visualizerObj.typeId === \'Device\' || visualizerObj.typeId === \'Gateway\' ? visualizerObj.typeId + \'s\' : \'Ghosts\'\"></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!visualizer.isVisualizersLoading && visualizer.visualizersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{visualizer.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"visualizer.perPage = 10; visualizer.fnPageChanged(visualizer.currentPage, visualizer.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"visualizer.perPage = 20; visualizer.fnPageChanged(visualizer.currentPage, visualizer.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"visualizer.perPage = 50; visualizer.fnPageChanged(visualizer.currentPage, visualizer.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"visualizer.perPage = 100; visualizer.fnPageChanged(visualizer.currentPage,visualizer.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"visualizer.perPage = 500; visualizer.fnPageChanged(visualizer.currentPage, visualizer.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"visualizer.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"visualizer.currentPage\" items-per-page=\"visualizer.perPage\" max-size=\"visualizer.maxSize\" boundary-links=\"true\" ng-click=\"visualizer.fnPageChanged(visualizer.currentPage, visualizer.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!visualizer.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"visualizer.permissionObj.List\"><label>Total: {{visualizer.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : visualizer.isRefresh}\" ng-click=\"visualizer.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right content-box-footerItem\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"visualizer.permissionObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Create Visualizer<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"visualizer.permissionObj.Create && visualizer.devicePermissionObj.List\" ng-click=\"visualizer.fnGoToVisualization(\'Device\')\"><a class=\"btn btn-link\">Create Visualizer for Devices</a></li><li ng-show=\"visualizer.permissionObj.Create && visualizer.gatewayPermissionObj.List\" ng-click=\"visualizer.fnGoToVisualization(\'Gateway\')\"><a class=\"btn btn-link\">Create Visualizer for Gateways</a></li><li ng-show=\"visualizer.permissionObj.Create\" ng-click=\"visualizer.fnGoToVisualization(\'Ghost\')\"><a class=\"btn btn-link\">Create Visualizer for Ghost</a></li></ul></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"visualizer.selectedVisualizersArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Visualizers:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedVisualizer in visualizer.selectedVisualizersArr\" is-open=\"selectedVisualizer.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedVisualizer.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); visualizer.fnCheckUncheckHeader(selectedVisualizer, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedVisualizer.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedVisualizer.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"visualizer.selectedVisualizersArr.length && visualizer.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"visualizer.permissionObj.Delete\" ng-click=\"visualizer.fnDeleteMultipleVisualizers(visualizer.selectedVisualizersArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!visualizer.isCreate && !visualizer.selectedVisualizersArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-first-order\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Visualizer</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-if=\"visualizer.permissionObj.Create && visualizer.devicePermissionObj.List\" ng-click=\"visualizer.fnGoToVisualization(\'Device\')\">Create Visualizer for Devices</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"visualizer.permissionObj.Create && visualizer.devicePermissionObj.List\">or</div><div class=\"col-sm-12\" ng-if=\"visualizer.permissionObj.Create && visualizer.gatewayPermissionObj.List\"><button class=\"btn btn-primary\" ng-click=\"visualizer.fnGoToVisualization(\'Gateway\')\">Create Visualizer for Gateways</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"visualizer.permissionObj.Create && visualizer.gatewayPermissionObj.List\">or</div><div class=\"col-sm-12\" ng-if=\"visualizer.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"visualizer.fnGoToVisualization(\'Ghost\')\">Create Visualizer for Ghost</button></div></div></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"visualizer.selectedVisualizersArr.length === 1 && visualizer.selectedVisualizerObj && !visualizer.isVisualizerDetailsLoaded\"></div><div ng-if=\"visualizer.selectedVisualizersArr.length === 1 && visualizer.selectedVisualizerObj && visualizer.isVisualizerDetailsLoaded\"><visualization-info visualizer-obj=\"visualizer.selectedVisualizerObj\" visualizer-permissions-obj=\"visualizer.permissionObj\"></visualization-info></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/listeners.html","<div class=\"row h-100\" ng-init=\"listeners.fnInitListeners()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"listeners.permissionObj.List\" field-arr=\"listeners.searchFieldArr\" filter-query=\"listeners.filterQuery\" state-name=\"\'main.listeners\'\" fn-filter-query-change=\"listeners.fnFilterQueryChanged(filterQuery)\" fn-resize=\"listeners.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"listeners.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"listeners.isListenersLoading\" fn-resize=\"listeners.fnSetLoaderTableHeight()\"></table-loader><div class=\"listeners-table table-container\"><table id=\"listeners-mainTable\" class=\"table table-striped table-check-box\" ng-if=\"!listeners.isListenersLoading\"><thead><tr><th ng-if=\"listeners.listenersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"listeners.isAllChecked\" ng-click=\"listeners.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"listeners.listenersArr.length\"></th><th ng-if=\"listeners.listenersArr.length\"><span ng-click=\"listeners.fnListenersSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"listeners.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"listeners.listenersArr.length\"></th><th ng-if=\"listeners.listenersArr.length\"></th><th ng-if=\"listeners.listenersArr.length\"></th><th ng-if=\"!listeners.listenersArr.length\">No records found...</th></tr></thead><tbody id=\"listenerTable\"><tr ng-repeat=\"listener in listeners.listenersArr track by $index\" ng-click=\"listeners.fnGetListener(listener, listeners.listenersArr);\" context-menu=\"listeners.listenerContextMenu(listener)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"listener.isCheck\" ng-change=\"listeners.fnCheckUncheckHeader(listener)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallStateIcon\" ng-show=\"!listener.isEditable\"><span class=\"stateIconBorder\" uib-tooltip=\"{{listener.state}}\" tooltip-placement=\"auto\" ng-style=\"listeners.getListenerStateColor(listener.state)\"><span class=\"fa stateIcon\" ng-class=\"listeners.fnGetListenerStateIcon(listener.state)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!listener.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{listener.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{listener.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"listener.isEditable\"><div class=\"col-sm-3 p-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"listener.name\" placeholder=\"Name for the Listener*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-3 p-r-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"listener.description\" placeholder=\"Description regarding Listener\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"listener.state\">{{listener.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in listeners.statesArr\" role=\"menuitem\"><a ng-click=\"$event.stopPropagation();listener.state = action;\">{{action}}</a></li></ul></div></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();listeners.fnCancelListenerEditMode(listener)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!listener.name.length\" ng-click=\"$event.stopPropagation();listeners.fnSaveListenerInfo(listener)\" value=\"Save\"></div></div></div></td><td ng-if=\"!listener.isEditable\" class=\"text-center\" ng-click=\"$event.stopPropagation(); listeners.fnGoToListenersWorkflow(listener)\"><div class=\"arrowLine-container\"><div class=\"workFlowCounter\" ng-click=\"$event.stopPropagation();\"><i class=\"fa fa-cubes\"></i></div><span class=\"arrowLine arrow-right\"></span></div></td><td ng-click=\"$event.stopPropagation(); listeners.fnGoToListenersWorkflow(listener)\" ng-if=\"!listener.isEditable\"><div class=\"arrowLine-container\"><div class=\"workFlowCounter text-center p-t-2\" ng-click=\"$event.stopPropagation(); listeners.fnGoToListenersWorkflow(listener)\"><span ng-bind=\"listener.workflowIds ? listener.workflowIds.length : \'0\'\"></span></div></div></td><td class=\"text-right\" ng-show=\"!listener.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': listeners.isDropUp }\" ng-click=\"$event.stopPropagation(); listeners.toggleDropUp(\'listenerTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"listeners.fnOpenListenerInfoTab(listener,1)\">Details</a></li><li><a ng-click=\"listeners.fnOpenListenerInfoTab(listener,2)\">Workflows</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!listeners.isListenersLoading && listeners.listenersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{listeners.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"listeners.perPage = 10; listeners.fnPageChanged(listeners.currentPage, listeners.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"listeners.perPage = 20; listeners.fnPageChanged(listeners.currentPage, listeners.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"listeners.perPage = 50; listeners.fnPageChanged(listeners.currentPage, listeners.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"listeners.perPage = 100; listeners.fnPageChanged(listeners.currentPage,listeners.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"listeners.perPage = 500; listeners.fnPageChanged(listeners.currentPage, listeners.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"listeners.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"listeners.currentPage\" items-per-page=\"listeners.perPage\" max-size=\"listeners.maxSize\" boundary-links=\"true\" ng-click=\"listeners.fnPageChanged(listeners.currentPage, listeners.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!listeners.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"listeners.permissionObj.List\"><label>Total: {{listeners.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : listeners.isRefresh}\" ng-click=\"listeners.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\"><button ng-if=\"listeners.permissionObj.Create\" type=\"button\" class=\"btn btn-link m-t-2\" ng-click=\"listeners.fnHideShowCreateForm()\">Create Listener</button></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"listeners.selectedListenersArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Listeners:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedListener in listeners.selectedListenersArr\" is-open=\"selectedListener.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedListener.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); listeners.fnCheckUncheckHeader(selectedListener, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedListener.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedListener.description}}</div></div><div class=\"row\" ng-if=\"selectedListener.state\"><div class=\"col-xs-2\"><label>State:</label></div><div class=\"col-xs-10\">{{selectedListener.state}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"listeners.selectedListenersArr.length && listeners.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"listeners.permissionObj.Delete\" ng-click=\"listeners.fnDeleteMultipleListeners(listeners.selectedListenersArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!listeners.isCreate && !listeners.selectedListenersArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-bullhorn\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Listeners</label></div><div class=\"col-sm-12\" ng-if=\"listeners.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"listeners.fnHideShowCreateForm()\">Create Listener</button></div></div></div><div class=\"content-container form-container\" ng-if=\"listeners.isCreate && !listeners.selectedListenersArr.length && !listeners.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/listeners/createListener/createListener.html\'\"></ng-include></div><div class=\"content-container form-container\" ng-if=\"listeners.isCreate && !listeners.selectedListenersArr.length && listeners.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/listeners/createListener/createListenerFromBluePrint.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"listeners.selectedListenersArr.length === 1 && listeners.selectedListenerObj && !listeners.isListenerDetailsLoaded\"></div><div ng-if=\"listeners.selectedListenersArr.length === 1 && listeners.selectedListenerObj && listeners.isListenerDetailsLoaded\"><listener-info listener-obj=\"listeners.selectedListenerObj\" listener-permissions-obj=\"listeners.permissionObj\"></listener-info></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/templates/templates.html","<div class=\"row h-100\" ng-init=\"templates.fnInitTemplates()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"templates.permissionObj.List\" field-arr=\"templates.searchFieldArr\" filter-query=\"templates.filterQuery\" state-name=\"\'main.pipeline_templates\'\" fn-filter-query-change=\"templates.fnFilterQueryChanged(filterQuery)\" fn-resize=\"templates.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"templates.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"templates.isTemplatesLoading\" fn-resize=\"templates.fnSetLoaderTableHeight()\"></table-loader><div class=\"templates-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!templates.isTemplatesLoading\"><thead><tr><th ng-if=\"templates.templatesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"templates.isAllChecked\" ng-click=\"templates.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"templates.templatesArr.length\"><span ng-click=\"templates.fnTemplatesSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"templates.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"templates.templatesArr.length\"></th><th ng-if=\"!templates.templatesArr.length\">No records found...</th></tr></thead><tbody id=\"templateTable\"><tr ng-repeat=\"template in templates.templatesArr track by $index\" ng-click=\"templates.fnGetTemplate(template, templates.templatesArr);\" context-menu=\"templates.templateContextMenu(template)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"template.isCheck\" ng-change=\"templates.fnCheckUncheckHeader(template)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!template.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{template.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{template.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"template.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"template.name\" placeholder=\"Name for the Template*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"template.description\" placeholder=\"Description regarding Template\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();templates.fnCancelTemplateEditMode(template)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!template.name.length\" ng-click=\"$event.stopPropagation();templates.fnSaveTemplateInfo(template)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!template.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': templates.isDropUp }\" ng-click=\"$event.stopPropagation(); templates.toggleDropUp(\'templateTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"templates.fnOpenTemplateInfoTab(template)\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!templates.isTemplatesLoading && templates.templatesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{templates.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"templates.perPage = 10; templates.fnPageChanged(templates.currentPage, templates.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"templates.perPage = 20; templates.fnPageChanged(templates.currentPage, templates.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"templates.perPage = 50; templates.fnPageChanged(templates.currentPage, templates.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"templates.perPage = 100; templates.fnPageChanged(templates.currentPage,templates.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"templates.perPage = 500; templates.fnPageChanged(templates.currentPage, templates.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"templates.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"templates.currentPage\" items-per-page=\"templates.perPage\" max-size=\"templates.maxSize\" boundary-links=\"true\" ng-click=\"templates.fnPageChanged(templates.currentPage, templates.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!templates.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"templates.permissionObj.List\"><label>Total: {{templates.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : templates.isRefresh}\" ng-click=\"templates.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem\"><div class=\"pull-right\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"templates.permissionObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Create Template<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"templates.permissionObj.Create\" ng-click=\"templates.fnShowCreateForm()\"><a class=\"btn btn-link\">Create Template from scratch</a></li><li ng-show=\"templates.permissionObj.Create\" ng-click=\"templates.fnShowCreateForm(true)\"><a class=\"btn btn-link\">Create Template from blueprint</a></li></ul></div></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"templates.selectedTemplatesArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Templates:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedTemplate in templates.selectedTemplatesArr\" is-open=\"selectedTemplate.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedTemplate.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); templates.fnCheckUncheckHeader(selectedTemplate, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedTemplate.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedTemplate.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"templates.selectedTemplatesArr.length && templates.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"templates.permissionObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"templates.permissionObj.Delete\" ng-click=\"templates.fnDeleteMultipleTemplates(templates.selectedTemplatesArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!templates.isCreate && !templates.selectedTemplatesArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-object-group\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Templates</label></div><div class=\"col-sm-12\" ng-if=\"templates.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"templates.fnHideShowCreateForm(true)\">Create Template from blueprint</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"templates.permissionObj.Create\">or</div><div class=\"col-sm-12\" ng-if=\"templates.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"templates.fnHideShowCreateForm()\">Create Template from scratch</button></div></div></div><div class=\"content-container form-container\" ng-if=\"templates.isCreate && !templates.selectedTemplatesArr.length && !templates.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/templates/createTemplate/createTemplate.html\'\"></ng-include></div><div class=\"content-container form-container\" ng-if=\"templates.isCreate && !templates.selectedTemplatesArr.length && templates.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/templates/createTemplate/createTemplateFromBluePrint.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"templates.selectedTemplatesArr.length === 1 && templates.selectedTemplateObj && !templates.isTemplateDetailsLoaded\"></div><div ng-if=\"templates.selectedTemplatesArr.length === 1 && templates.selectedTemplateObj && templates.isTemplateDetailsLoaded\"><template-info template-obj=\"templates.selectedTemplateObj\" template-permissions-obj=\"templates.permissionObj\"></template-info></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/transformers.html","<div class=\"row h-100\" ng-init=\"transformers.fnInitTransformers()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"transformers.permissionObj.List\" field-arr=\"transformers.searchFieldArr\" filter-query=\"transformers.filterQuery\" state-name=\"\'main.transformers\'\" fn-filter-query-change=\"transformers.fnFilterQueryChanged(filterQuery)\" fn-resize=\"transformers.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"transformers.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"transformers.isTransformersLoading\" fn-resize=\"transformers.fnSetLoaderTableHeight()\"></table-loader><div class=\"transformers-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!transformers.isTransformersLoading\"><thead><tr><th ng-if=\"transformers.transformersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"transformers.isAllChecked\" ng-click=\"transformers.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"transformers.transformersArr.length\"><span ng-click=\"transformers.fnTransformersSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"transformers.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"transformers.transformersArr.length\"></th><th ng-if=\"!transformers.transformersArr.length\">No records found...</th></tr></thead><tbody id=\"transformerTable\"><tr ng-repeat=\"transformer in transformers.transformersArr track by $index\" ng-click=\"transformers.fnGetTransformer(transformer, transformers.transformersArr);\" context-menu=\"transformers.transformerContextMenu(transformer)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"transformer.isCheck\" ng-change=\"transformers.fnCheckUncheckHeader(transformer)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!transformer.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{transformer.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{transformer.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"transformer.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"transformer.name\" placeholder=\"Name for the Transformer*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"transformer.description\" placeholder=\"Description regarding Tansformer\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();transformers.fnCancelTransformerEditMode(transformer)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!transformer.name.length\" ng-click=\"$event.stopPropagation();transformers.fnSaveTransformerInfo(transformer)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!transformer.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': transformers.isDropUp }\" ng-click=\"$event.stopPropagation(); transformers.toggleDropUp(\'transformerTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"transformers.fnOpenTransformerInfoTab(transformer)\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!transformers.isTransformersLoading && transformers.transformersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{transformers.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"transformers.perPage = 10; transformers.fnPageChanged(transformers.currentPage, transformers.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"transformers.perPage = 20; transformers.fnPageChanged(transformers.currentPage, transformers.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"transformers.perPage = 50; transformers.fnPageChanged(transformers.currentPage, transformers.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"transformers.perPage = 100; transformers.fnPageChanged(transformers.currentPage,transformers.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"transformers.perPage = 500; transformers.fnPageChanged(transformers.currentPage, transformers.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"transformers.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"transformers.currentPage\" items-per-page=\"transformers.perPage\" max-size=\"transformers.maxSize\" boundary-links=\"true\" ng-click=\"transformers.fnPageChanged(transformers.currentPage, transformers.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!transformers.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"transformers.permissionObj.List\"><label>Total: {{transformers.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : transformers.isRefresh}\" ng-click=\"transformers.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem\"><div class=\"pull-right\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"transformers.permissionObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Create Transformer<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"transformers.permissionObj.Create\" ng-click=\"transformers.fnShowCreateForm()\"><a class=\"btn btn-link\">Create Transformer from scratch</a></li><li ng-show=\"transformers.permissionObj.Create\" ng-click=\"transformers.fnShowCreateForm(true)\"><a class=\"btn btn-link\">Create Transformer from blueprint</a></li></ul></div></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"transformers.selectedTransformersArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected Transformers:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedTransformer in transformers.selectedTransformersArr\" is-open=\"selectedTransformer.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedTransformer.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); transformers.fnCheckUncheckHeader(selectedTransformer, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedTransformer.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedTransformer.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"transformers.selectedTransformersArr.length && transformers.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"transformers.permissionObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"transformers.permissionObj.Delete\" ng-click=\"transformers.fnDeleteMultipleTransformers(transformers.selectedTransformersArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!transformers.isCreate && !transformers.selectedTransformersArr.length\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-random\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Transformers</label></div><div class=\"col-sm-12\" ng-if=\"transformers.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"transformers.fnHideShowCreateForm(true)\">Create Transformer from blueprint</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"transformers.permissionObj.Create\">or</div><div class=\"col-sm-12\" ng-if=\"transformers.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"transformers.fnHideShowCreateForm()\">Create Transformer from scratch</button></div></div></div><div class=\"content-container form-container\" ng-if=\"transformers.isCreate && !transformers.selectedTransformersArr.length && !transformers.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/transformers/createTransformer/createTransformer.html\'\"></ng-include></div><div class=\"content-container form-container\" ng-if=\"transformers.isCreate && !transformers.selectedTransformersArr.length && transformers.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/transformers/createTransformer/createTransformerFromBluePrint.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"transformers.selectedTransformersArr.length === 1 && transformers.selectedTransformerObj && !transformers.isTransformerDetailsLoaded\"></div><div ng-if=\"transformers.selectedTransformersArr.length === 1 && transformers.selectedTransformerObj && transformers.isTransformerDetailsLoaded\"><transformer-info transformer-obj=\"transformers.selectedTransformerObj\" transformer-permissions-obj=\"transformers.permissionObj\"></transformer-info></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/workflows.html","<div class=\"row h-100\" ng-init=\"workflows.fnInitWorkFlows()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><search-directive ng-if=\"workflows.permissionObj.List\" field-arr=\"workflows.searchFieldArr\" filter-query=\"workflows.filterQuery\" state-name=\"\'main.workflows\'\" fn-filter-query-change=\"workflows.fnFilterQueryChanged(filterQuery)\" fn-resize=\"workflows.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"workflows.permissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"workflows.isWorkFlowsLoading\" fn-resize=\"workflows.fnSetLoaderTableHeight()\"></table-loader><div class=\"workFlows-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!workflows.isWorkFlowsLoading\"><thead><tr><th ng-if=\"workflows.workFlowsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"workflows.isAllChecked\" ng-click=\"workflows.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"workflows.workFlowsArr.length\"><span ng-click=\"workflows.fnWorkflowsSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"workflows.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"workflows.workFlowsArr.length\"></th><th ng-if=\"!workflows.workFlowsArr.length\">No records found...</th></tr></thead><tbody id=\"workFlowTable\"><tr ng-repeat=\"workflow in workflows.workFlowsArr track by $index\" ng-click=\"workflows.fnGetWorkFlow(workflow, workflows.workFlowsArr);\" context-menu=\"workflows.workFlowContextMenu(workflow)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"workflow.isCheck\" ng-change=\"workflows.fnCheckUncheckHeader(workflow)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!workflow.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{workflow.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{workflow.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"workflow.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"workflow.name\" placeholder=\"Name for the Workflow*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"workflow.description\" placeholder=\"Description regarding Workflow\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();workflows.fnCancelWorkFlowEditMode(workflow)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!workflow.name.length\" ng-click=\"$event.stopPropagation();workflows.fnSaveWorkFlowInfo(workflow)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!workflow.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': workflows.isDropUp }\" ng-click=\"$event.stopPropagation(); workflows.toggleDropUp(\'workFlowTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"workflows.fnOpenWorkflowInfoTab(workflow,1)\">Details</a></li><li><a ng-click=\"workflows.fnOpenWorkflowInfoTab(workflow,2)\">Logging</a></li><li><a ng-click=\"workflows.fnOpenWorkflowInfoTab(workflow,3)\">Roles</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!workflows.isWorkFlowsLoading && workflows.workFlowsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{workflows.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"workflows.perPage = 10; workflows.fnPageChanged(workflows.currentPage, workflows.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"workflows.perPage = 20; workflows.fnPageChanged(workflows.currentPage, workflows.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"workflows.perPage = 50; workflows.fnPageChanged(workflows.currentPage, workflows.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"workflows.perPage = 100; workflows.fnPageChanged(workflows.currentPage,workflows.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"workflows.perPage = 500; workflows.fnPageChanged(workflows.currentPage, workflows.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"workflows.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"workflows.currentPage\" items-per-page=\"workflows.perPage\" max-size=\"workflows.maxSize\" boundary-links=\"true\" ng-click=\"workflows.fnPageChanged(workflows.currentPage, workflows.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!workflows.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"workflows.permissionObj.List\"><label>Total: {{workflows.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : workflows.isRefresh}\" ng-click=\"workflows.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem\"><div class=\"pull-right\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"workflows.permissionObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Create Workflow<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"workflows.permissionObj.Create\" ng-click=\"workflows.fnShowCreateForm()\"><a class=\"btn btn-link\">Create Workflow from scratch</a></li><li ng-show=\"workflows.permissionObj.Create\" ng-click=\"workflows.fnHideShowBluePrintForm()\"><a class=\"btn btn-link\">Create Workflow from blueprint</a></li><li ng-show=\"workflows.permissionObj.Create && workflows.isDraftsAvailable\" ng-click=\"workflows.fnLoadDrafts()\"><a class=\"btn btn-link\">Open Draft</a></li></ul></div></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\" ng-if=\"workflows.selectedWorkflowsArr.length > 1\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\">List of selected workflows:</h3></div><div class=\"content-body\"><div class=\"col-sm-12 p-t-15\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedWorkflow in workflows.selectedWorkflowsArr\" is-open=\"selectedWorkflow.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedWorkflow.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); workflows.fnCheckUncheckHeader(selectedWorkflow, true)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedWorkflow.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedWorkflow.description}}</div></div></uib-accordion-group></uib-accordion></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-8 content-box-footerItem\"></div><div class=\"col-sm-4 content-box-footerItem\"><div class=\"pull-right\" ng-if=\"workflows.selectedWorkflowsArr.length && workflows.permissionObj.Delete\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"workflows.permissionObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-show=\"workflows.permissionObj.Delete\" ng-click=\"workflows.fnDeleteMultipleWorkFlows(workflows.selectedWorkflowsArr)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div></div><div class=\"create-screen\" ng-if=\"!workflows.selectedWorkflowsArr.length && !workflows.isCreateFromBluePrint\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-cubes\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Workflows</label></div><div class=\"col-sm-12\" ng-if=\"workflows.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"workflows.fnHideShowBluePrintForm()\">Create Workflow from blueprint</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"workflows.permissionObj.Create\">or</div><div class=\"col-sm-12\" ng-if=\"workflows.permissionObj.Create\"><button class=\"btn btn-primary\" ng-click=\"workflows.fnShowCreateForm()\">Create Workflow from scratch</button></div><div ng-if=\"workflows.isDraftsAvailable && workflows.permissionObj.Create\"><div class=\"col-sm-12 m-t-5 m-b-5\">or</div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"workflows.fnLoadDrafts()\">Open Draft</button></div></div></div></div><div class=\"form-container\" ng-if=\"!workflows.selectedWorkflowsArr.length && workflows.isCreateFromBluePrint\"><ng-include src=\"\'app/pipeline/workflows/createWorkFlow/createWorkflowFromBluePrint.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"workflows.selectedWorkflowsArr.length === 1 && workflows.selectedWorkflowObj && !workflows.isWorkflowDetailsLoaded\"></div><div ng-if=\"workflows.selectedWorkflowsArr.length === 1 && workflows.selectedWorkflowObj && workflows.isWorkflowDetailsLoaded\"><workflow-info workflow-obj=\"workflows.selectedWorkflowObj\" workflow-permissions-obj=\"workflows.permissionObj\"></workflow-info></div></div></div></div></div></div>");
$templateCache.put("app/predictive/account/accounts.html","<div class=\"row h-100\" ng-init=\"accounts.fnInitAccounts()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"accounts.activeTabIndex\"><uib-tab index=\"1\" select=\"accounts.fnTabChanged(accounts.tabs[0])\" ng-click=\"accounts.fnChangeTab(accounts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"accounts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in accounts.tabs track by $index\" select=\"accounts.fnTabChanged(tab)\" ng-click=\"accounts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"accounts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();accounts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"accounts.fnGetAccountDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!accounts.isFullWidthDevice\"><a ng-click=\"accounts.fnGetAccountStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"accounts.isFullWidthDevice\"><a ng-click=\"accounts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i> {{accounts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"accounts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-b-15 p-t-15 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"accounts.isFullWidthDevice && accounts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'ecsmon\'\" service-key=\"\'account\'\" service-name=\"\'Account\'\" app-name=\"\'ECSMon\'\" fn-get-chart-detail=\"accounts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"accounts.fnGetWidgetEditor()\" fn-hide-chart=\"accounts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"accounts.isRefreshData\" search-identifier=\"\'accounts\'\" filters-arr=\"accounts.searchFiltersArr\" filter-query=\"accounts.filterQuery\" fn-filter-query-change=\"accounts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.accounts\'\" fn-resize=\"accounts.fnSetTableHeight()\" sort-field-arr=\"accounts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"accounts.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"accounts.isShowInsightOption()\"><a ng-click=\"accounts.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-if=\"accounts.selectedAccountsArr.length\"><a ng-click=\"accounts.fnDeleteMultipleAccounts(accounts.selectedAccountsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-hide=\"true\"><a ng-csv=\"accounts.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"accounts.csvHeaderArr\" filename=\"accounts.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"accounts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"accounts.isAccountsloading\" fn-resize=\"accounts.fnSetLoaderTableHeight()\"></table-loader><div class=\"accounts-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!accounts.isAccountsloading\"><thead><tr><th ng-if=\"accounts.AccountsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"accounts.isAllChecked\" ng-click=\"accounts.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"accounts.AccountsArr.length\">Name</th><th ng-if=\"accounts.AccountsArr.length\"></th><th ng-if=\"!accounts.AccountsArr.length\">No Records Found...</th></tr></thead><tbody id=\"accountTable\"><tr ng-repeat=\"account in accounts.AccountsArr track by $index\" ng-click=\"accounts.fnCheckUncheckHeader(account);\" context-menu=\"accounts.accountContextMenu(account)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"account.isCheck\" ng-change=\"accounts.fnCheckUncheckHeader(account)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!account.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{account.name}}</label> <span class=\"ellipsis\"><span class=\"DescriptionText span_des p-r-5 font-italic\" ng-bind=\"account.id\">Doe</span> <span class=\"discDot\" ng-hide=\"!account.description\"><span class=\"dot\"></span></span> <span class=\"DescriptionText span_des p-l-12\">{{account.description}}</span></span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"account.isEditable\" ng-click=\"$event.stopPropagation();\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"account.name\" placeholder=\"Name for the Account*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"account.description\" placeholder=\"Description regarding Account\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();accounts.fnCancelAccountEditMode(account)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!account.name.length\" ng-click=\"$event.stopPropagation();accounts.fnSaveAccountInfo(account)\" value=\"Save\"></div></div></div></td><td class=\"text-right\" ng-show=\"!account.isEditable\"><div class=\"d-flex align-items-center justify-content-flex-end\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"account.supportAccess\" ng-click=\"$event.stopPropagation();accounts.fnCreateSupportSession(account);\">Support Session</button></div></td><td class=\"text-right\" ng-show=\"!account.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': accounts.isDropUp }\" ng-click=\"$event.stopPropagation(); accounts.toggleDropUp(\'accountTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"accounts.fnOpenAccountInfoTab(account,1);\">Details</a></li><li><a ng-click=\"accounts.fnOpenAccountInfoTab(account,2);\">Users</a></li><li><a ng-click=\"accounts.fnOpenAccountInfoTab(account,3);\">Tags</a></li><li ng-if=\"account.supportAccess\"><a ng-click=\"accounts.fnCreateSupportSession(account);\">Start support session</a></li><li><a ng-click=\"accounts.fnLockECUSerial(account);\">Lock ECU serial</a></li><li><a ng-click=\"accounts.fnCopyId(account.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!accounts.isAccountsloading && accounts.AccountsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{accounts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"accounts.perPage = 10; accounts.fnPageChanged(accounts.currentPage, accounts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"accounts.perPage = 20; accounts.fnPageChanged(accounts.currentPage, accounts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"accounts.perPage = 50; accounts.fnPageChanged(accounts.currentPage, accounts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"accounts.perPage = 100; accounts.fnPageChanged(accounts.currentPage,accounts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"accounts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"accounts.currentPage\" items-per-page=\"accounts.perPage\" max-size=\"accounts.maxSize\" boundary-links=\"true\" ng-click=\"accounts.fnPageChanged(accounts.currentPage, accounts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-0\">Total: {{accounts.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : accounts.isRefresh}\" ng-click=\"accounts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"accounts.fnHideShowCreateForm()\">Open Account</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && !accounts.isCreate && accounts.selectedAccountsArr.length === 1 && accounts.selectedAccountObj && accounts.isAccountDetailsLoaded && !accounts.isShowDashboard && !accounts.isShowAccountStats && !accounts.isShowWidgetEditor && !accounts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><account-info account-obj=\"accounts.selectedAccountObj\" account-permissions-obj=\"accounts.permissionObj\"></account-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && accounts.isCreate && !accounts.isShowDashboard && !accounts.isShowAccountStats && !accounts.isShowWidgetEditor && !accounts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/predictive/account/createAccount/createAccount.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && accounts.isShowDashboard && !accounts.isShowAccountStats && !accounts.isShowWidgetEditor && !accounts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">accounts</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>accounts are real people that are members of your account. To create a user, select Invite User.</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>accounts are free in your account.You can invite as many people as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to accounts</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add accounts to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how accounts sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && !accounts.isShowDashboard && accounts.isShowAccountStats && !accounts.isShowWidgetEditor && !accounts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'ecsmon\'\" service-key=\"\'account\'\" service-name=\"\'Account\'\" app-name=\"\'ECSMon\'\" fn-get-chart-detail=\"accounts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"accounts.fnGetWidgetEditor()\" fn-hide-chart=\"accounts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && !accounts.isCreate && !accounts.isShowDashboard && !accounts.isShowAccountStats && accounts.isShowWidgetEditor && !accounts.isCreateIssue\"><widget-editor app-name=\"\'ecsmon\'\" service-name=\"\'account\'\" service-display-name=\"\'Account\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"accounts.activeTabIndex !== 1 && !accounts.isCreate && !accounts.isShowDashboard && !accounts.isShowAccountStats && !accounts.isShowWidgetEditor && accounts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'ecsmon\'\" service-key=\"\'account\'\" app-name=\"\'ECSMon\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/predictive/dashboard/predictive_dashboard.html","<div class=\"row h-100\" ng-init=\"predictiveDashboard.fnInit()\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\" style=\"height: inherit;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"predictiveDashboard.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in predictiveDashboard.tabs track by $index\" select=\"predictiveDashboard.fnTabChanged(tab)\" ng-click=\"predictiveDashboard.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();predictiveDashboard.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"predictiveDashboard.activeTabIndex === 1\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\"><span>Security</span><h1 class=\"m-0 font-bold\">ECSMon</h1><h2 class=\"m-0 m-t-10\">Securely control account to your ECSMon resources.</h2></div></div><div class=\"col-sm-12 p-0 d-flex dashboard-body\"><div class=\"overflow-auto\" ng-class=\"predictiveDashboard.isFullWidthDevice ? \'col-sm-9 p-r-0\':\'col-sm-12 \'\"><insight-dashboards app-key=\"\'ecsmon\'\" service-key=\"\'dashboard\'\" app-name=\"\'ECSMon\'\" fn-get-chart-detail=\"predictiveDashboard.fnOpenCreateIssueTab(chartObj)\"></insight-dashboards></div><div class=\"col-sm-3 p-l-0 side-bar\" ng-if=\"predictiveDashboard.isFullWidthDevice\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>ECSMon helps you manage account to your ECSMon resources.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Account is a feature of your ECSMon account offered at no additional charge. You will be charged only for the use of other ECSMon services by your users.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">API documentation</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Manage Account</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"predictiveDashboard.activeTabIndex !== 1 && predictiveDashboard.isCreate\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'ecsmon\'\" service-key=\"\'dashboard\'\" app-name=\"\'ECSMon\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/storage/folder/folder.html","<div class=\"row h-100\" ng-init=\"folder.fnInitFolder()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-8 h-100 p-l-0\"><div class=\"content-box\"><div id=\"storageDrop\" class=\"content-box-content table-content-box storageDrop\" ng-storage-file-drop=\"\" upload-file=\"folder.uploadFiles(filedata)\"><div id=\"dropzone\" class=\"dropzone\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><h1><strong>Drop to upload</strong></h1></div></div></div></div><div class=\"storage-breadcrumb\"><ul class=\"breadcrumb\" ng-if=\"!folder.filterQuery.length\"><li ng-repeat=\"pathName in folder.breadcrumbArray track by $index\"><a class=\"link-dk-primary\" ng-click=\"folder.fnGetPath(pathName, $index)\"><i ng-if=\"pathName === \'/\'\" class=\"fa fa-home\"></i>{{pathName === \'/\' ? \'\' : pathName}}</a></li></ul></div><storage-search-directive ng-if=\"folder.contentPermissionObj.List\" field-arr=\"folder.searchFieldArr\" filter-query=\"folder.filterQuery\" state-name=\"\'main.folder\'\" fn-filter-query-change=\"folder.fnFilterQueryChanged(filterQuery)\" fn-resize=\"folder.fnSetTableHeight()\"></storage-search-directive><div class=\"row\" ng-if=\"folder.contentPermissionObj.List\"><div class=\"col-sm-12 m-t-10\"><table-loader ng-if=\"folder.isFoldersLoading\" hide-circle=\"true\" set-padding=\"true\" hide-line=\"true\" fn-resize=\"folder.fnSetLoaderTableHeight()\"></table-loader><div class=\"folder-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!folder.isFoldersLoading\"><thead><tr ng-if=\"folder.folderArr.length\"><th class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"folder.isAllChecked\" ng-click=\"folder.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th>Name</th><th class=\"p-r-5\" ng-if=\"folder.filterQuery.length\">Path</th><th class=\"p-r-5\">Last modified</th><th>Size</th></tr><tr ng-if=\"!folder.folderArr.length\"><th>No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"folderObj in folder.folderArr track by $index\" ng-click=\"folder.fnSelectSingleFolder(folderObj, folder.folderArr)\" context-menu=\"folder.fileFolderContextMenu(folderObj)\" ng-dblclick=\"folder.fnGetFolder(folderObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"folderObj.isCheck\" ng-change=\"folder.fnCheckUncheckHeader(folderObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><i class=\"m-r-5\" ng-class=\"\'fa \'+folderObj.icon\"></i> <span ng-click=\"$event.stopPropagation();folder.fnGetFolder(folderObj);\">{{folderObj.name}}</span></td><td class=\"p-r-8\" ng-if=\"folder.filterQuery.length\" ng-bind=\"folderObj.path\" style=\"word-break: break-all\">Doe</td><td class=\"p-r-8\" ng-bind=\"folderObj.lastUpdate\">John</td><td ng-bind=\"folderObj.fileSize\">John</td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!folder.isFoldersLoading\" id=\"StorageFileUploadProgressBar\"><div class=\"progress text-center\" ng-if=\"folder.isFileUploading\"><div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"{{folder.progressBar}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{folder.progressBar}}%\"><span class=\"p-l-5\">{{folder.progressCounter.toFixed(2)}}%</span></div></div><div class=\"row\" ng-if=\"folder.folderArr.length && !folder.isFileUploading\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{folder.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"folder.perPage = 10; folder.fnPageChanged(folder.currentPage, folder.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"folder.perPage = 20; folder.fnPageChanged(folder.currentPage, folder.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"folder.perPage = 50; folder.fnPageChanged(folder.currentPage, folder.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"folder.perPage = 100; folder.fnPageChanged(folder.currentPage,folder.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"folder.perPage = 500; accounts.fnPageChanged(accounts.currentPage, accounts.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"folder.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"folder.currentPage\" items-per-page=\"folder.perPage\" max-size=\"folder.maxSize\" boundary-links=\"true\" ng-click=\"folder.fnPageChanged(folder.currentPage, folder.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!folder.contentPermissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><div ng-if=\"folder.contentPermissionObj.List\"><label>Total: {{folder.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : folder.isRefresh}\" ng-click=\"folder.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6\"><div class=\"row pull-right\" ng-if=\"folder.isFileDownloading\"><div class=\"pull-right m-r-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"row pull-right content-box-footerItem\" ng-if=\"!folder.isFileDownloading\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"folder.fnCheckActionsMenuValidations()\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Actions<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"folder.selectedFolderObj && folder.selectedFolderObj.size < 1000000 && folder.selectedFolderObj.type === \'file\' && folder.fnCheckFileType(folder.selectedFolderObj) && folder.filePermissionObj.Download\"><a ng-click=\"folder.fnOpenFileInNewTab(folder.selectedFolderObj)\" class=\"btn btn-link\">Open</a></li><li ng-if=\"folder.filePermissionObj.Download && folder.selectedFolderObj && folder.selectedFolderObj.type === \'file\'\"><a class=\"btn btn-link\" ng-click=\"folder.fnGetFileData(folder.selectedFolderObj)\">Download</a></li><li ng-if=\"folder.selectedFolderObj && folder.selectedFolderObj.type === \'file\' && folder.filePermissionObj.Modify\" class=\"divider\"></li><li ng-if=\"folder.selectedFolderObj ? folder.selectedFolderObj.type === \'file\' ? folder.filePermissionObj.Modify : folder.folderPermissionObj.Modify : false\"><a class=\"btn btn-link\" ng-click=\"folder.fnOpenRenameModal(folder.selectedFolderObj)\">Rename</a></li><li ng-if=\"folder.fnCheckFileFolderPermission(\'delete\')\"><a class=\"btn btn-link\" ng-click=\"folder.fnDeleteItem(folder.selectedFoldersArr)\">Delete</a></li><li ng-if=\"folder.fnCheckFileFolderPermission(\'modify\')\" class=\"divider\"></li><li ng-if=\"folder.fnCheckFileFolderPermission(\'modify\')\"><a class=\"btn btn-link\" ng-click=\"folder.fnSetCutCopyPath(\'COPY\', folder.selectedFoldersArr)\">Copy</a></li><li ng-if=\"folder.fnCheckFileFolderPermission(\'modify\')\"><a class=\"btn btn-link\" ng-click=\"folder.fnSetCutCopyPath(\'MOVE\', folder.selectedFoldersArr)\">Cut</a></li><li ng-if=\"folder.isFolderFileCopied !== false\"><a class=\"btn btn-link\" ng-click=\"folder.fnPasteFileFolder()\">Paste</a></li></ul></div></div><input ng-if=\"folder.filePermissionObj.Upload && !folder.filterQuery.length && folder.isPasteProcess === false && !folder.isFileDownloading\" type=\"file\" id=\"storageFileUpload\" name=\"file\" ng-storage-files=\"\" upload-file=\"folder.uploadFiles(filedata)\" style=\"visibility:hidden; height: 0px;\"> <button ng-if=\"folder.filePermissionObj.Upload && !folder.filterQuery.length && folder.isPasteProcess === false && !folder.isFileDownloading\" type=\"button\" class=\"btn btn-link m-t-2 pull-right\" onclick=\"document.getElementById(\'storageFileUpload\').click()\">Upload</button> <button ng-if=\"folder.folderPermissionObj.Create && !folder.filterQuery.length && folder.isPasteProcess === false && !folder.isFileDownloading\" type=\"button\" class=\"btn btn-link m-t-2 pull-right\" ng-class=\"{\'\': !folder.filePermissionObj.Upload, \'p-r-0\': folder.filePermissionObj.Upload}\" ng-click=\"folder.fnHideShowCreateForm()\">Create Folder</button><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"folder.isPasteProcess === true\"></div></div></div></div></div><div id=\"infoSection\" class=\"col-sm-4 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"create-screen\" ng-show=\"!folder.isCreate && !folder.isShowFileDetails\"><div class=\"row content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-folder\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Storage</label></div></div></div><div class=\"form-container\" ng-show=\"folder.isCreate && !folder.isShowFileDetails\"><ng-include src=\"\'app/storage/folder/createFolder/createFolder.html\'\"></ng-include></div><div class=\"p-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"folder.isShowFileDetails && folder.selectedFolderObj && !folder.isFolderDetailsLoaded\"></div><div ng-if=\"folder.isShowFileDetails && folder.selectedFolderObj && folder.isFolderDetailsLoaded\"><folder-info folder-current-path=\"folder.currentPath\" folder-breadcrumb-array=\"folder.breadcrumbArray\" folder-obj=\"folder.selectedFolderObj\" filter-query=\"folder.filterQuery\" folder-permissions-obj=\"folder.filePermissionObj\"></folder-info></div></div></div></div></div></div>");
$templateCache.put("app/store/product/product.html","<div class=\"row h-100\" ng-init=\"products.fnInitProducts()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"products.activeTabIndex\"><uib-tab index=\"1\" select=\"products.fnTabChanged(products.tabs[0])\" ng-click=\"products.fnChangeTab(products.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"products.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in products.tabs track by $index\" select=\"products.fnTabChanged(tab)\" ng-click=\"products.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"products.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();products.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"products.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Billing</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"products.isFullWidthDevice\">Products</h1><h3 class=\"m-0 font-bold\" ng-if=\"!products.isFullWidthDevice\">Products</h3></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"products.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"products.searchFiltersArr\" filter-query=\"products.filterQuery\" fn-filter-query-change=\"products.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.products\'\" fn-resize=\"products.fnSetTableHeight()\" sort-field-arr=\"products.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"products.fnUpdateUserSettingsForEOLProducts()\"><i class=\"m-r-5 fa fa-plug\"></i> {{products.showEolProducts ? \'Hide EOL Products\' : \'View EOL Products\'}}</a></li></ul></div></div></div><div class=\"row\" ng-if=\"products.isRefreshData\"><div class=\"col-sm-12\"><div id=\"loading-row\" class=\"m-b-10 d-flex h-100 justify-content-center align-items-center\" ng-init=\"products.fnSetLoaderTableHeight()\" ng-if=\"products.isProductsloading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"productTable\" class=\"m-b-10\" ng-if=\"!products.isProductsloading\"><div class=\"col-sm-12 p-0 overflow-auto\" style=\"height: inherit;\"><div class=\"col-sm-3 m-b-0\" ng-repeat=\"data in products.productArr\" ng-if=\"data.orderable ? true : products.showEolProducts\"><div class=\"col-sm-12 m-b-30 h-100 product-box\" ng-class=\"!data.orderable ? \'unavailableProduct\':\'\'\" ng-click=\"products.fnGetProductInfo(data)\"><div class=\"col-sm-12 align-items-center text-center p-t-20\"><img ng-src=\"{{data.images[0].image}}\" height=\"120px\" width=\"120px\"></div><div class=\"col-sm-12 p-0 p-t-15 p-b-5 d-flex\"><label class=\"m-0 font-size-19 ellipsis\">{{data.name}}</label></div><div class=\"col-sm-12 p-0 m-b-10 text-left\" style=\"height: 60px; overflow: auto\"><span class=\"block-with-text product-description\">{{data.description}}</span></div><div class=\"col-sm-12 p-0 m-b-10 text-left\"><h3 class=\"m-0\"><label class=\"m-0\">$ {{(data.mrr/100).toFixed(2)}} / month</label></h3></div></div></div><div class=\"col-sm-3 m-b-0\"><div class=\"col-sm-12 p-15 h-100 product-box customECUBox\" style=\"min-height: 286px\"><div class=\"col-sm-12 p-15 h-100 d-flex flex-column align-items-center\"><h2 class=\"m-b-40\">Need a custom ECU?</h2><small class=\"text-center m-b-40\">Need an ECU with custom branding or functionality? Whether you need built-in LoRa, WiFi or LTE we can create fully customized ECUs just for your company.</small> <button class=\"btn btn-link p-0\" ng-click=\"products.fnOpenSupportModal()\">Contact Sales</button></div></div></div></div></div><div class=\"pagination-container\" ng-show=\"!products.isProductsloading && products.productArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{products.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"products.perPage = 10; products.fnPageChanged(products.currentPage, products.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"products.perPage = 20; products.fnPageChanged(products.currentPage, products.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"products.perPage = 50; products.fnPageChanged(products.currentPage, products.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"products.perPage = 100; products.fnPageChanged(products.currentPage,products.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"products.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"products.currentPage\" items-per-page=\"products.perPage\" max-size=\"products.maxSize\" boundary-links=\"true\" ng-click=\"products.fnPageChanged(products.currentPage, products.perPage)\"></ul></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{products.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : products.isRefresh}\" ng-click=\"products.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"d-flex align-items-center m-r-10\" ng-if=\"!products.isCartInfoLoading\"><svg viewbox=\"-3 0 512 512\" class=\"custom-svg-side-menu-icon\" width=\"25px\" height=\"25px\"><path d=\"m494.929688 97.148438c-9.492188-10.84375-23.023438-16.816407-38.097657-16.816407h-364.429687l-3.667969-27.5c-3.953125-29.625-24.578125-52.832031-46.957031-52.832031h-26.777344c-8.285156 0-15 6.714844-15 15s6.714844 15 15 15h26.777344c4.8125 0 15.003906 10.175781 17.21875 26.796875l42.9375 322.039063c1.890625 14.195312 9.183594 27.484374 20.535156 37.421874 8.417969 7.371094 18.367188 12.273438 28.789062 14.324219-4.246093 7.808594-6.660156 16.753907-6.660156 26.25 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h78.601563c-3.890625 7.550781-6.101563 16.101562-6.101563 25.164062 0 30.421875 24.75 55.167969 55.167969 55.167969s55.167969-24.746094 55.167969-55.167969c0-9.0625-2.210938-17.613281-6.101563-25.164062h39.300782c8.28125 0 15-6.71875 15-15 0-8.285157-6.71875-15-15-15h-302.589844c-14.65625 0-28.671875-12.273438-30.609375-26.800781l-3.136719-23.535157h116.746094c.003906 0 .007812.003907.011718.003907.003907 0 .007813-.003907.015626-.003907h96.367187c.003906 0 .007813.003907.015625.003907.003906 0 .003906-.003907.007812-.003907h83.003907c14.320312 0 28.457031-5.472656 39.808593-15.40625 11.351563-9.9375 18.644532-23.230469 20.535157-37.425781l21.515625-161.367188c1.992187-14.941406-2.136719-29.140624-11.628906-39.984374zm-269.996094 359.683593c0 13.878907-11.289063 25.167969-25.167969 25.167969-13.875 0-25.167969-11.289062-25.167969-25.167969 0-13.875 11.292969-25.164062 25.167969-25.164062 13.878906 0 25.167969 11.289062 25.167969 25.164062zm176.734375 0c0 13.878907-11.289063 25.167969-25.167969 25.167969s-25.167969-11.289062-25.167969-25.167969c0-13.875 11.289063-25.164062 25.167969-25.164062s25.167969 11.289062 25.167969 25.164062zm70.6875-339.921875c3.714843 4.242188 5.300781 10.011719 4.464843 16.253906l-9.019531 67.667969h-102.0625l6.03125-90.5h85.0625c6.300781 0 11.8125 2.335938 15.523438 6.578125zm-213.019531 204.421875-6.035157-90.5h80.371094l-6.035156 90.5zm-8.035157-120.5-6.03125-90.5h96.433594l-6.03125 90.5zm-36.097656-90.5 6.03125 90.5h-112.769531l-12.066406-90.5zm-102.738281 120.5h110.769531l6.035156 90.5h-104.738281zm312.234375 90.5h-66.996094l6.035156-90.5h100.0625l-8.492187 63.703125c-1.9375 14.527344-15.957032 26.796875-30.609375 26.796875zm0 0\"></path></svg><span class=\"m-l-5\"><h3 class=\"m-0\">({{products.cartInfo.cartItems ? products.cartInfo.cartItems.length: 0}})</h3></span></div><div class=\"d-flex align-items-center m-r-10\" ng-if=\"products.isCartInfoLoading\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ui-sref=\"main.cart\">Manage Cart</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"products.activeTabIndex !== 1 && products.selectedProductObj && products.isProductDetailsLoaded\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><div class=\"container-with-footer tab-container\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"products.isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Product</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"products.isFullWidthDevice\">{{products.selectedProductObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!products.isFullWidthDevice\">{{products.selectedProductObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><div ng-if=\"!products.isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{products.selectedProductObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"products.fnCopyToClipboard(products.selectedProductObj.id, 2000)\" ng-class=\"!products.isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0\"></div></div></div></div><div class=\"col-sm-12 p-0 infoDiv\"><div class=\"col-sm-12 h-100 p-t-15\" ng-if=\"!products.isDiscountDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"products.isDiscountDetailsLoaded\"><div class=\"col-sm-4 p-0 p-t-20\"><div class=\"col-sm-12 h-100 d-flex imageGalleryDiv\"><div id=\"userDetailsContent\" class=\"content-main col-sm-4\"><div class=\"previews p-b-10\" ng-repeat=\"slide in products.selectedProductObj.images track by $index\"><img class=\"\" ng-src=\"{{slide.image}}\" ng-click=\"products.imgSrc = slide.image\"></div></div><div class=\"p-0 p-t-20 col-sm-8\" ng-class=\"products.isFullWidthDevice ? \'frameBigScreen\' : \'frameSmallScreen\'\"><img ng-src=\"{{products.imgSrc}}\"></div></div></div><div class=\"col-sm-5 p-0\"><div class=\"col-sm-12 h-100 p-t-15\"><div class=\"col-sm-12 p-0 p-b-10\"><h2 class=\"m-0 font-bold\">{{products.selectedProductObj.name}}</h2></div><div class=\"col-sm-12 p-0 p-b-10\"><span><small class=\"m-0\">{{products.selectedProductObj.category.replace(\'_\',\' \')}}</small></span></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-b-20\"><span>{{products.selectedProductObj.description}}</span></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-12 p-0 p-b-20 width-auto\"><h3 class=\"m-0\"><label class=\"m-0\">Price : $ {{(products.selectedProductObj.mrr/100).toFixed(2)}} / month</label></h3></div></div><div class=\"col-sm-12 p-0 product-details-page m-t-0\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"true\" is-disabled=\"true\"><uib-accordion-heading>Details</uib-accordion-heading><div><table class=\"w100\"><tr><td class=\"p-5\" style=\"width: 30%;\"><label class=\"m-0\">Category</label></td><td class=\"p-5 text-center\">{{products.selectedProductObj. category.replace(\'_\',\' \')}}</td></tr><tr><td class=\"p-5\"><label class=\"m-0\">Max Quantity Per Account</label></td><td class=\"p-5 text-center\">{{products.selectedProductObj.maxPerAccount}}</td></tr><tr><td class=\"p-5\"><label class=\"m-0\">Max Quantity Per Cart</label></td><td class=\"p-5 text-center\">{{products.selectedProductObj.maxPerCart}}</td></tr></table></div></div></uib-accordion><uib-accordion ng-if=\"products.discountData.length\"><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"true\" is-disabled=\"true\"><uib-accordion-heading>Discount</uib-accordion-heading><div><table class=\"w100\" ng-repeat=\"discountObj in products.discountData track by $index\"><tr><td class=\"p-5\" style=\"width: 30%;\"><label class=\"m-0\">Name</label></td><td class=\"p-5\">{{discountObj.name}}</td></tr><tr><td class=\"p-5\"><label class=\"m-0\">Description</label></td><td class=\"p-5\">{{discountObj.description}}</td></tr><tr><td class=\"p-5\"><label class=\"m-0\">Percentage</label></td><td class=\"p-5\">{{discountObj.percentage}}</td></tr></table></div></div></uib-accordion></div></div></div><div class=\"col-sm-3 p-20 h-100\"><div class=\"col-sm-12 p-20 product-box alien h-100\"><div class=\"col-sm-12 p-0 p-b-20 m-r-20\"><h3 class=\"m-0\"><label class=\"p-b-8\">$ {{(products.selectedProductObj.mrr/100).toFixed(2)}} / month</label><br><label class=\"p-b-8\">{{products.selectedProductObj.orderable ? \"In Stock\": \"Out of Stock\"}}</label><br><label class=\"p-b-8\" ng-if=\"products.selectedProductObj.orderable && products.selectedProductObj.otc\">Delivery: Shipping next day US shipping ${{products.selectedProductObj.otc}}</label></h3></div><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-if=\"products.selectedProductObj.orderable\"><div class=\"col-sm-6 p-0 p-t-5 p-b-5 d-flex m-r-20 m-b-20 width-max-content\"><h3 class=\"m-0\"><label class=\"m-0\">Quantity :</label></h3></div><div class=\"col-sm-6 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"products.selectedProductObj.cartQuantity\">{{products.selectedProductObj.cartQuantity}}</span> <label class=\"titleLabel\">Quantity</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu col-sm-12\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\" ng-repeat=\"x in products.fnRange(products.selectedProductObj.minQuantity, products.selectedProductObj.maxQuantity)\"><a ng-click=\"products.selectedProductObj.cartQuantity = x\">{{x}}</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-class=\"products.selectedProductObj.orderable ? \'p-t-20 p-b-20\' : \'p-t-0\'\"><button ng-if=\"products.selectedProductObj.orderable && !products.selectedProductObj.isCartUpdating && (products.permissionObj.ADD_PRODUCT_TO_CART || products.nodePermissionObj.ADD_PRODUCT_TO_CART)\" ng-click=\"products.fnAddToCart(products.selectedProductObj);\" class=\"btn btn-primary v4-primary-button p-11 p-r-30 p-l-30\">Add to Cart</button><div ng-if=\"!products.selectedProductObj.orderable\"><label class=\"m-0\">Currently unavailable</label></div><div ng-if=\"products.selectedProductObj.isCartUpdating\" class=\"m-l-20\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"products.isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{products.selectedProductObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"products.fnCopyToClipboard(products.selectedProductObj.id, 2000)\" ng-class=\"!products.isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div ng-if=\"products.isCartInfoLoading\" class=\"m-l-20\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div ng-if=\"products.cartInfo.cartItems && products.cartInfo.cartItems.length && !products.isCartInfoLoading\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"products.fnProceedToCheckout()\">Checkout</button></div></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/dashboard/dashboard.html","<div class=\"row h-100\" ng-init=\"trackerDashboard.fnInit()\"><div class=\"col-sm-12 h-100\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\" style=\"height: inherit;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"trackerDashboard.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in trackerDashboard.tabs track by $index\" select=\"trackerDashboard.fnTabChanged(tab)\" ng-click=\"trackerDashboard.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();trackerDashboard.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"trackerDashboard.activeTabIndex === 1\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\"><span>Productivity</span><h1 class=\"m-0 font-bold\">Tracker</h1><h2 class=\"m-0 m-t-10\">Efficiently manage issues for smarter and faster resolutions</h2></div></div><div class=\"col-sm-12 p-0 d-flex dashboard-body\"><div class=\"overflow-auto\" ng-class=\"trackerDashboard.isFullWidthDevice ? \'col-sm-9 p-r-0\':\'col-sm-12 \'\"><insight-dashboards app-key=\"\'tracker\'\" service-key=\"\'dashboard\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"trackerDashboard.fnOpenCreateIssueTab(chartObj)\"></insight-dashboards></div><div ng-if=\"trackerDashboard.isFullWidthDevice\" class=\"col-sm-3 p-l-0 side-bar\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Tracker provides end-to-end issue management capabilities to help team solve issues faster and smarter. Every team has a unique process for resolving issues. Use an out-of-the-box workflow, or create one to match the way your team works.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">API documentation</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Manage Projects</td><td class=\"p-b-12 p-r-15\" ng-click=\"trackerDashboard.fnGoToState(\'main.project\')\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-r-15\">Get training</td><td class=\"p-r-15\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 42px)\" ng-if=\"trackerDashboard.activeTabIndex !== 1 && trackerDashboard.isCreate\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'dashboard\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/archived/archived.html","<div class=\"row h-100\" ng-init=\"archivedIssue.fnInitIssues()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"archivedIssue.activeTabIndex\"><uib-tab index=\"1\" select=\"archivedIssue.fnTabChanged(archivedIssue.tabs[0])\" ng-click=\"archivedIssue.fnChangeTab(archivedIssue.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"archivedIssue.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in archivedIssue.tabs track by $index\" select=\"archivedIssue.fnTabChanged(tab)\" ng-click=\"archivedIssue.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"archivedIssue.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();archivedIssue.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"archivedIssue.fnGetIssueDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!archivedIssue.isFullWidthDevice\"><a ng-click=\"archivedIssue.fnGetIssueStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"archivedIssue.isFullWidthDevice\"><a ng-click=\"archivedIssue.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{archivedIssue.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-show=\"archivedIssue.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"archivedIssue.isFullWidthDevice && archivedIssue.activeTabIndex === 1 && archivedIssue.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'archives\'\" service-name=\"\'Archives\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"archivedIssue.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"archivedIssue.fnGetWidgetEditor()\" fn-hide-chart=\"archivedIssue.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"archivedIssue.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis\">{{archivedIssue.project.name ? archivedIssue.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"archivedIssue.issueProjectSearch[archivedIssue.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in archivedIssue.filterProject=(archivedIssue.projectsArr | filter:archivedIssue.issueProjectSearch) track by $index\" ng-click=\"archivedIssue.fnGetProjectIssue(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === archivedIssue.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!archivedIssue.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"archivedIssue.isRefreshData\" search-identifier=\"\'issueSearch\'\" filters-arr=\"archivedIssue.searchFiltersArr\" filter-query=\"archivedIssue.filterQuery\" fn-filter-query-change=\"archivedIssue.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.archives\'\" fn-resize=\"archivedIssue.fnSetTableHeight()\" is-column-view=\"archivedIssue.isColumnView\" sort-field-arr=\"archivedIssue.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"archivedIssue.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"archivedIssue.isShowInsightOption()\"><a ng-click=\"archivedIssue.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"archivedIssue.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"archivedIssue.csvHeaderArr\" filename=\"archivedIssue.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"archivedIssue.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"archivedIssue.isIssuesLoading\" fn-resize=\"archivedIssue.fnSetLoaderTableHeight()\"></table-loader><div class=\"issue-table table-container issue-table-grid\"><table id=\"issuesTable\" class=\"table table-striped table-check-box\" ng-if=\"!archivedIssue.isIssuesLoading\"><thead><tr><th ng-if=\"archivedIssue.issuesArr.length\"></th><th ng-if=\"archivedIssue.issuesArr.length\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"archivedIssue.isAllChecked\" ng-click=\"archivedIssue.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></div><div class=\"table-col-2\"></div><div class=\"table-col-3\"><label class=\"m-b-0\">Name</label></div></div></th><th ng-if=\"archivedIssue.issuesArr.length\"></th><th ng-if=\"!archivedIssue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"issueTable\"><tr ng-repeat=\"issueObj in archivedIssue.issuesArr track by $index\" ng-click=\"archivedIssue.fnCheckUncheckHeader(issueObj);\"><td ng-class=\"issueObj.state !== \'CLOSED\' ? issueObj.isRead ? \'\' : \'issueReadUnreadBGColor\' :\'\'\"></td><td><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-8 table-col-1\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"issueObj.isCheck\" ng-change=\"archivedIssue.fnCheckUncheckHeader(issueObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"table-col-2\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div><div class=\"table-col-3\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\"></span></div><div class=\"table-col-4\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div uib-tooltip=\"State\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"archivedIssue.fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div><div class=\"d-flex m-t-5\"><div uib-tooltip=\"Priorities\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"archivedIssue.fnGetIssuesLabelColor(issueObj.issuePriority)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div></div><div class=\"table-col-5\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\"><div uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-if=\"issueObj.issueLabels\" ng-repeat=\"label in issueObj.issueLabels\" ng-style=\"archivedIssue.fnGetIssuesLabelColor(label)\"><span>{{label.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"width-25px\"><div uib-tooltip=\"Assignees\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div></div><div class=\"ellipsis width-100-25px\"><span ng-repeat=\"user in issueObj.assignees\">{{user.firstName+ \" \" + user.lastName}}<span ng-if=\"!$last\">,</span></span></div></div></div></div><div class=\"attributeTdCSS-style table-col-6\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Opened \'+issueObj.createdDate + \' by \'+ issueObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.createdAt\"><label class=\"ellipsis m-b-0\">Opened {{issueObj.createdDate}} by {{issueObj.createdBy}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'updated \' + issueObj.updatedDate + \' by \'+ issueObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.updatedAt\"><span class=\"ellipsis\">Updated {{issueObj.updatedDate}} by {{issueObj.updatedBy}}</span></div></div><div class=\"table-col-7\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Type\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"archivedIssue.fnGetIssuesLabelColor(issueObj.issueType)\"><span>{{issueObj.issueType.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"d-flex m-r-5\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{issueObj.project.name}}</label></div></div></div></div><div class=\"table-col-8\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Comments\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.publicCommentIds.length ? issueObj.publicCommentIds.length : 0}}</span></div></div><div class=\"d-flex m-t-5\"><div class=\"width-25px\"><svg class=\"custom-svg-side-menu-icon m-r-10 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.voteCount ? issueObj.voteCount : 0}}</span></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\" ng-click=\"$event.stopPropagation();archivedIssue.fnCopyInfoToClipboard(issueObj.id, \'Archived Issue ID\')\"><label class=\"ellipsis m-b-0 label_name\" uib-tooltip=\"{{issueObj.psuedoId}}\" ng-click=\"$event.stopPropagation();archivedIssue.fnCopyInfoToClipboard(issueObj.id, \'Archived Issue ID\')\" tooltip-placement=\"auto\">{{issueObj.psuedoId}}</label></div><div class=\"position-r\" style=\"width: 95%;\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\" style=\"width: 100%\"><div class=\"progress w100 m-b-0\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div></div></div></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': archivedIssue.isDropUp }\" ng-click=\"$event.stopPropagation(); archivedIssue.toggleDropUp(\'issueTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"archivedIssue.fnOpenIssueInfoTab(issueObj,1)\">Public</a></li><li><a ng-click=\"archivedIssue.fnOpenIssueInfoTab(issueObj,2)\">Private</a></li><li ng-if=\"archivedIssue.isShowFormOption(issueObj)\"><a ng-click=\"archivedIssue.fnOpenIssueInfoTab(issueObj,3)\">Form</a></li><li><a ng-click=\"archivedIssue.fnOpenIssueInfoTab(issueObj,4)\">History</a></li><li><a ng-click=\"archivedIssue.fnCopyId(issueObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!archivedIssue.isIssuesLoading && archivedIssue.issuesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{archivedIssue.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"archivedIssue.perPage = 10; archivedIssue.fnPageChanged(archivedIssue.currentPage, archivedIssue.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"archivedIssue.perPage = 20; archivedIssue.fnPageChanged(archivedIssue.currentPage, archivedIssue.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"archivedIssue.perPage = 50; archivedIssue.fnPageChanged(archivedIssue.currentPage, archivedIssue.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"archivedIssue.perPage = 100; archivedIssue.fnPageChanged(archivedIssue.currentPage,archivedIssue.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"archivedIssue.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"archivedIssue.currentPage\" items-per-page=\"archivedIssue.perPage\" max-size=\"archivedIssue.maxSize\" boundary-links=\"true\" ng-click=\"archivedIssue.fnPageChanged(archivedIssue.currentPage, archivedIssue.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{archivedIssue.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : archivedIssue.isRefresh}\" ng-click=\"archivedIssue.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && archivedIssue.selectedIssueObj && archivedIssue.isIssueDetailsLoaded && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><archived-info issue-obj=\"archivedIssue.selectedIssueObj\" user-permissions-obj=\"archivedIssue.permissionObj\"></archived-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Archives</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Issue. To create a issue, select Create Issue.</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Issues are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Issues</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'archives\'\" service-name=\"\'Archives\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"archivedIssue.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"archivedIssue.fnGetWidgetEditor()\" fn-hide-chart=\"archivedIssue.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'archives\'\" service-display-name=\"\'Archives\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && archivedIssue.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'archives\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && archivedIssue.isShowIssueStateBoard && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"archivedIssue.fnSetTableHeight()\" fn-hide-show-create-form=\"archivedIssue.fnHideShowCreateForm()\" total-items=\"archivedIssue.totalItems\" get-settings=\"archivedIssue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"archivedIssue.fnCheckUncheckHeader(issueObj)\" issue-board-for-state=\"true\" issue-board-for-priority=\"false\" issue-board-for-type=\"false\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowIssueTypeBoard && archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"archivedIssue.fnSetTableHeight()\" fn-hide-show-create-form=\"archivedIssue.fnHideShowCreateForm()\" total-items=\"archivedIssue.totalItems\" get-settings=\"archivedIssue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"archivedIssue.fnCheckUncheckHeader(issueObj)\" issue-board-for-priority=\"true\" issue-board-for-type=\"false\" issue-board-for-state=\"false\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowIssuePriorityBoard && archivedIssue.isShowIssueTypeBoard && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"archivedIssue.fnSetTableHeight()\" fn-hide-show-create-form=\"archivedIssue.fnHideShowCreateForm()\" total-items=\"archivedIssue.totalItems\" get-settings=\"archivedIssue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"archivedIssue.fnCheckUncheckHeader(issueObj)\" issue-board-for-type=\"true\" issue-board-for-priority=\"false\" issue-board-for-state=\"false\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowTypeBoardSettings && !archivedIssue.isShowPriorityBoardSettings && archivedIssue.isShowStateBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"true\" is-called-for-priority=\"false\" is-called-for-type=\"false\"></board-settings></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowTypeBoardSettings && archivedIssue.isShowPriorityBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"false\" is-called-for-priority=\"true\" is-called-for-type=\"false\"></board-settings></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"archivedIssue.activeTabIndex !== 1 && !archivedIssue.isShowDashboard && !archivedIssue.isShowIssueStats && !archivedIssue.isShowWidgetEditor && !archivedIssue.isShowIssueStateBoard && !archivedIssue.isShowIssueTypeBoard && !archivedIssue.isShowIssuePriorityBoard && !archivedIssue.isShowStateBoardSettings && !archivedIssue.isShowPriorityBoardSettings && archivedIssue.isShowTypeBoardSettings && !archivedIssue.isCreateIssue\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"false\" is-called-for-priority=\"false\" is-called-for-type=\"true\"></board-settings></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/issue/issue.html","<div class=\"row h-100\" ng-init=\"issue.fnInitIssues()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"issue.activeTabIndex\"><uib-tab index=\"1\" select=\"issue.fnTabChanged(issue.tabs[0])\" ng-click=\"issue.fnChangeTab(issue.tabs[0], true)\" class=\"issueNavPadding\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"tab-max-width\"><span class=\"issueTitle\">{{issue.tabs[0].title}}</span></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in issue.tabs track by $index\" select=\"issue.fnTabChanged(tab)\" ng-click=\"issue.fnChangeTab(tab, true)\" class=\"{{!tab.projectName ? \'issueNavPadding\' : \'\'}}\" ng-if=\"tab.tabIndex > 1\" ng-model=\"issue.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div class=\"d-flex\"><div class=\"d-flex flex-column issueTabs\"><div class=\"d-flex tab-max-width issueProjectTitlePosition\" ng-if=\"tab.projectName\"><span class=\"font-italic issueProjectTitle\">{{tab.projectName}}</span></div><div class=\"{{tab.projectName ? \'tab-max-width issueTitlePosition\' : \'tab-max-width\'}}\"><span class=\"issueTitle\">{{tab.title}}</span></div></div><div class=\"d-flex\" style=\"width: 17px;\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();issue.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"issue.fnGetIssueDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!issue.isFullWidthDevice\"><a ng-click=\"issue.fnGetIssueStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"issue.project.id\"><a ng-click=\"issue.fnGetIssueStateBoard()\" ng-class=\"issue.project.id === \'All\' ? \'pace opacity-5\' : \'\'\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"12px\" height=\"12px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg>State Board</a></li><li ng-if=\"issue.project.id\"><a ng-click=\"issue.fnGetIssuePriorityBoard()\" ng-class=\"issue.project.id === \'All\' ? \'pace opacity-5\' : \'\'\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"12px\" height=\"12px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg>Priority Board</a></li><li ng-if=\"issue.project.id\"><a ng-click=\"issue.fnGetIssueTypeBoard()\" ng-class=\"issue.project.id === \'All\' ? \'pace opacity-5\' : \'\'\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"12px\" height=\"12px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg>Type Board</a></li><li ng-if=\"issue.isFullWidthDevice\"><a ng-click=\"issue.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{issue.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-show=\"issue.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"issue.isFullWidthDevice && issue.activeTabIndex === 1 && issue.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'issue\'\" service-name=\"\'Issue\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"issue.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"issue.fnGetWidgetEditor()\" fn-hide-chart=\"issue.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"issue.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{issue.project.name ? issue.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"issue.issueProjectSearch[issue.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in issue.filterProject=(issue.projectsArr | filter:issue.issueProjectSearch) track by $index\" ng-click=\"issue.fnGetProjectIssue(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === issue.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!issue.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"m-r-10\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-10\" ng-if=\"issue.permissionObj.CREATE_ISSUE\" ng-click=\"issue.fnHideShowCreateForm()\">New Issue</button></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"issue.isRefreshData\" search-identifier=\"\'issueSearch\'\" filters-arr=\"issue.searchFiltersArr\" filter-query=\"issue.filterQuery\" fn-filter-query-change=\"issue.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.issue\'\" fn-resize=\"issue.fnSetTableHeight()\" is-column-view=\"issue.isColumnView\" sort-field-arr=\"issue.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"issue.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"issue.isShowInsightOption()\"><a ng-click=\"issue.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-if=\"issue.permissionObj.RESOLVE_ISSUE\" ng-class=\"!issue.selectedIssuesArr.length ? \'pace opacity-5\' : \'\'\"><a ng-click=\"issue.fnResolvedAllIssue()\"><i class=\"m-r-5 fa fa-lightbulb-o\"></i>Resolved All</a></li><li ng-if=\"issue.permissionObj.ARCHIVE_ISSUE\" ng-class=\"!issue.selectedIssuesArr.length ? \'pace opacity-5\' : \'\'\"><a ng-click=\"issue.fnArchiveAllIssue()\"><i class=\"m-r-5 fa fa-archive\"></i>Archive All</a></li><li ng-hide=\"true\"><a ng-csv=\"issue.getIssueCSVData()\" id=\"csvAnchor\" csv-header=\"issue.csvHeaderArr\" filename=\"issue.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"issue.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"issue.isIssuesLoading\" fn-resize=\"issue.fnSetLoaderTableHeight()\"></table-loader><div class=\"issue-table table-container issue-table-grid\"><table id=\"issuesTable\" class=\"table table-striped table-check-box\" ng-if=\"!issue.isIssuesLoading\"><thead><tr><th ng-if=\"issue.issuesArr.length\"></th><th ng-if=\"issue.issuesArr.length\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"issue.isAllChecked\" ng-click=\"issue.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></div><div class=\"table-col-2\"></div><div class=\"table-col-3\"><label class=\"m-b-0\"></label></div></div></th><th ng-if=\"issue.issuesArr.length\"></th><th ng-if=\"issue.issuesArr.length\"></th><th ng-if=\"!issue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"issueTable\"><tr ng-repeat=\"issueObj in issue.issuesArr track by $index\" ng-click=\"issue.fnCheckUncheckHeader(issueObj);\" context-menu=\"issue.issueContextMenu(issueObj)\"><td ng-class=\"issueObj.state !== \'CLOSED\' ? issueObj.isRead ? \'\' : \'issueReadUnreadBGColor\' :\'\'\"></td><td ng-if=\"issueObj.isEditable\"><div class=\"col-sm-12 p-0 floatingLabelInput d-flex\"><div class=\"p-l-0 w100\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"issueObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"p-l-10 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!issueObj.name.length\" ng-click=\"$event.stopPropagation();issue.fnSaveIssueInfo(issueObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();issue.fnCancelIssueEditMode(issueObj)\" value=\"Cancel\"></div></div></div></td><td ng-if=\"!issueObj.isEditable\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-8 table-col-1\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"issueObj.isCheck\" ng-change=\"issue.fnCheckUncheckCheckbox(issueObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"table-col-2\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false && issueObj.resolved === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate && issueObj.resolved === false\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div><div class=\"table-col-3\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div><div class=\"table-col-4\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div uib-tooltip=\"State\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"issue.fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div><div class=\"d-flex m-t-5\"><div uib-tooltip=\"Priorities\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"issue.fnGetIssuesLabelColor(issueObj.issuePriority)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div></div><div class=\"table-col-5\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-if=\"issueObj.issueLabels\" ng-repeat=\"label in issueObj.issueLabels\" ng-style=\"issue.fnGetIssuesLabelColor(label)\"><span>{{label.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"width-25px\" uib-tooltip=\"Assignees\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"ellipsis width-100-25px p-t-2\"><span ng-repeat=\"user in issueObj.assignees\">{{user.firstName+ \" \" + user.lastName}}{{!$last ? \', \': \'\'}}</span></div></div></div></div><div class=\"attributeTdCSS-style table-col-6\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Opened \'+issueObj.createdDate + \' by \'+ issueObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.createdAt\"><label class=\"ellipsis m-b-0\">Opened {{issueObj.createdDate}} by {{issueObj.createdBy}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'updated \' + issueObj.updatedDate + \' by \'+ issueObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.updatedAt\"><span class=\"ellipsis\">Updated {{issueObj.updatedDate}} by {{issueObj.updatedBy}}</span></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Resolved \' + issueObj.resolvedDate + \' by \'+ issueObj.resolvedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.resolved === true\"><span class=\"ellipsis\">Resolved {{issueObj.resolvedDate}} by {{issueObj.resolvedBy}}</span></div></div><div class=\"table-col-7\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Type\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"issue.fnGetIssuesLabelColor(issueObj.issueType)\"><span>{{issueObj.issueType.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"d-flex m-r-5\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{issueObj.project.name}}</label></div></div></div></div><div class=\"table-col-8\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Comments\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.publicCommentIds.length ? issueObj.publicCommentIds.length : 0}}</span></div></div><div class=\"d-flex m-t-5\" ng-class=\"issueObj.isVoteUpdating ? \'pace opacity-5\' : \'\'\"><div class=\"width-25px\"><svg class=\"custom-svg-side-menu-icon m-r-10\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" ng-click=\"$event.stopPropagation();issue.fnAddUpDownVoteToIssue(true, issueObj)\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.voteCount ? issueObj.voteCount : 0}}</span></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\" ng-click=\"$event.stopPropagation();issue.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\"><label class=\"ellipsis m-b-0 label_name\" uib-tooltip=\"{{issueObj.psuedoId}}\" ng-click=\"$event.stopPropagation();issue.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\" tooltip-placement=\"auto\">{{issueObj.psuedoId}}</label></div><div class=\"position-r\" style=\"width: 95%;\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false && issueObj.resolved === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\" style=\"width: 100%\"><div class=\"progress w100 m-b-0\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate && issueObj.resolved === false\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && issueObj.isResolvedAtTime\"><svg class=\"svg-fill-green m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/check.svg#check\"></use></svg><div>This issue was resolved in time.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && !issueObj.isResolvedAtTime\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue was not resolved in time.</div></div></div></div></div></td><td class=\"text-center\" ng-if=\"!issueObj.isEditable\"><div uib-tooltip=\"Issue Resolved\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-if=\"issueObj.resolved === true\" width=\"25px\" height=\"25px\"><use xlink:href=\"assets/images/svg/service/lightbulb.svg#lightbulb\"></use></svg></div></td><td ng-if=\"!issueObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\" uib-tooltip=\"View attributes\" tooltip-placement=\"auto\" ng-click=\"$event.stopPropagation();issue.fnOpenIssueAttributeModal(issueObj)\" ng-if=\"issueObj.attributeIds && issueObj.attributeIds.length\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"25px\" height=\"25px\"><use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use></svg></div></td><td class=\"text-right\" ng-if=\"!issueObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': issue.isDropUp }\" ng-click=\"$event.stopPropagation(); issue.toggleDropUp(\'issueTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"issue.fnOpenIssueInfoTab(issueObj,1)\">Public</a></li><li><a ng-click=\"issue.fnOpenIssueInfoTab(issueObj,2)\">Private</a></li><li ng-if=\"issue.isShowFormOption(issueObj)\"><a ng-click=\"issue.fnOpenIssueInfoTab(issueObj,3)\">Form</a></li><li><a ng-click=\"issue.fnOpenIssueInfoTab(issueObj,4)\">History</a></li><li><a ng-click=\"issue.fnOpenIssueInfoTab(issueObj,5)\">Tags</a></li><li><a ng-click=\"issue.fnCopyId(issueObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!issue.isIssuesLoading && issue.issuesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{issue.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"issue.perPage = 10; issue.fnPageChanged(issue.currentPage, issue.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"issue.perPage = 20; issue.fnPageChanged(issue.currentPage, issue.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"issue.perPage = 50; issue.fnPageChanged(issue.currentPage, issue.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"issue.perPage = 100; issue.fnPageChanged(issue.currentPage,issue.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"issue.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"issue.currentPage\" items-per-page=\"issue.perPage\" max-size=\"issue.maxSize\" boundary-links=\"true\" ng-click=\"issue.fnPageChanged(issue.currentPage, issue.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{issue.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : issue.isRefresh}\" ng-click=\"issue.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"issue.permissionObj.CREATE_ISSUE\" ng-click=\"issue.fnHideShowCreateForm()\">New Issue</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && issue.selectedIssueObj && issue.isIssueDetailsLoaded && !issue.isCreate && !issue.isShowDashboard && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><issue-info issue-obj=\"issue.selectedIssueObj\" user-permissions-obj=\"issue.permissionObj\"></issue-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && issue.isCreate && !issue.isShowDashboard && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/issue/createIssue/createIssue.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Issues</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Issue. To create a issue, select Create Issue.</span><br><button class=\"btn btn-primary m-t-10\" ng-if=\"issue.permissionObj.CREATE_ISSUE\" ng-click=\"issue.fnHideShowCreateForm()\">Create Issue</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Issues are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Issues</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'issue\'\" service-name=\"\'Issue\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"issue.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"issue.fnGetWidgetEditor()\" fn-hide-chart=\"issue.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'issue\'\" service-display-name=\"\'Issue\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings && issue.isShowIssueStateBoard\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"issue.fnSetTableHeight()\" fn-hide-show-create-form=\"issue.fnHideShowCreateForm()\" total-items=\"issue.totalItems\" get-settings=\"issue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"issue.fnCheckUncheckHeader(issueObj)\" issue-board-for-state=\"true\" issue-board-for-priority=\"false\" issue-board-for-type=\"false\" user-permissions-obj=\"issue.permissionObj\" fn-set-tab-name=\"issue.fnSetBoardProjectTabName(data)\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings && !issue.isShowIssueTypeBoard && issue.isShowIssuePriorityBoard\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"issue.fnSetTableHeight()\" fn-hide-show-create-form=\"issue.fnHideShowCreateForm()\" total-items=\"issue.totalItems\" get-settings=\"issue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"issue.fnCheckUncheckHeader(issueObj)\" issue-board-for-priority=\"true\" issue-board-for-type=\"false\" issue-board-for-state=\"false\" user-permissions-obj=\"issue.permissionObj\" fn-set-tab-name=\"issue.fnSetBoardProjectTabName(data)\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && !issue.isShowStateBoardSettings && !issue.isShowIssuePriorityBoard && issue.isShowIssueTypeBoard\"><div class=\"content-box h-100 issueBoard\"><div class=\"content-container h-100\"><issue-boards fn-set-table-height=\"issue.fnSetTableHeight()\" fn-hide-show-create-form=\"issue.fnHideShowCreateForm()\" total-items=\"issue.totalItems\" get-settings=\"issue.fnGetBoardSettings(isCalledForState, isCalledForPriority)\" get-issue-details=\"issue.fnCheckUncheckHeader(issueObj)\" issue-board-for-type=\"true\" issue-board-for-priority=\"false\" issue-board-for-state=\"false\" user-permissions-obj=\"issue.permissionObj\" fn-set-tab-name=\"issue.fnSetBoardProjectTabName(data)\"></issue-boards></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowTypeBoardSettings && !issue.isShowPriorityBoardSettings && issue.isShowStateBoardSettings\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"true\" is-called-for-priority=\"false\" is-called-for-type=\"false\"></board-settings></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowStateBoardSettings && !issue.isShowTypeBoardSettings && issue.isShowPriorityBoardSettings\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"false\" is-called-for-priority=\"true\" is-called-for-type=\"false\"></board-settings></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"issue.activeTabIndex !== 1 && !issue.isShowDashboard && !issue.isCreate && !issue.isShowIssueStats && !issue.isShowWidgetEditor && !issue.isShowIssueStateBoard && !issue.isShowIssueTypeBoard && !issue.isShowIssuePriorityBoard && !issue.isShowStateBoardSettings && !issue.isShowPriorityBoardSettings && issue.isShowTypeBoardSettings\"><div class=\"content-box h-100 boardSettings\"><div class=\"content-container h-100\"><board-settings is-called-for-state=\"false\" is-called-for-priority=\"false\" is-called-for-type=\"true\"></board-settings></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/label/label.html","<div class=\"row h-100\" ng-init=\"label.fnInitLabels()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"label.activeTabIndex\"><uib-tab index=\"1\" select=\"label.fnTabChanged(label.tabs[0])\" ng-click=\"label.fnChangeTab(label.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"label.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in label.tabs track by $index\" select=\"label.fnTabChanged(tab)\" ng-click=\"label.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"label.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();label.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"label.fnGetLabelDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!label.isFullWidthDevice\"><a ng-click=\"label.fnGetLabelStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"label.fnGetLabelRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"label.isFullWidthDevice\"><a ng-click=\"label.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{label.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"label.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"label.isFullWidthDevice && label.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'label\'\" service-name=\"\'Label\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"label.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"label.fnGetWidgetEditor()\" fn-hide-chart=\"label.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"label.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{label.project.name ? label.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"label.labelProjectSearch[label.labelProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in label.filterProject=(label.projectsArr | filter:label.labelProjectSearch) track by $index\" ng-click=\"label.fnGetProjectLabel(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === label.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!label.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"label.isRefreshData\" search-identifier=\"\'labelSearch\'\" filters-arr=\"label.searchFiltersArr\" filter-query=\"label.filterQuery\" fn-filter-query-change=\"label.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.label\'\" fn-resize=\"label.fnSetTableHeight()\" sort-field-arr=\"label.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"label.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"label.selectedLabelsArr.length\"><a ng-click=\"label.fnDeleteMultipleLabels(label.selectedLabelsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"label.isShowInsightOption()\"><a ng-click=\"label.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"label.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"label.csvHeaderArr\" filename=\"label.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"label.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"label.isLabelsLoading\" fn-resize=\"label.fnSetLoaderTableHeight()\"></table-loader><div class=\"label-table table-container\"><table id=\"labelsTable\" class=\"table table-striped table-check-box\" ng-if=\"!label.isLabelsLoading\"><thead><tr><th ng-if=\"label.labelsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"label.isAllChecked\" ng-click=\"label.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"label.labelsArr.length\"><span>Label</span></th><th ng-if=\"label.labelsArr.length\">Name</th><th ng-if=\"label.labelsArr.length\">Project</th><th ng-if=\"label.labelsArr.length\"></th><th ng-if=\"label.labelsArr.length\"></th><th ng-if=\"label.labelsArr.length\"></th><th ng-if=\"!label.labelsArr.length\">No records found...</th></tr></thead><tbody id=\"labelTable\"><tr ng-repeat=\"labelObj in label.labelsArr track by $index\" ng-click=\"label.fnCheckUncheckHeader(labelObj);\" context-menu=\"label.labelContextMenu(labelObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"labelObj.isCheck\" ng-change=\"label.fnCheckUncheckHeader(labelObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"label.fnGetLabelColor(labelObj)\" uib-tooltip=\"{{labelObj.name}}\" tooltip-placement=\"auto\"><span>{{labelObj.name}}</span></button></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!labelObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{labelObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{labelObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"labelObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"labelObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"labelObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!labelObj.name.length\" ng-click=\"$event.stopPropagation();label.fnSaveLabelInfo(labelObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();label.fnCancelLabelEditMode(labelObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!labelObj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{labelObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!labelObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{labelObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"labelObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{labelObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{labelObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"labelObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{labelObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!labelObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{labelObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"labelObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{labelObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{labelObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"labelObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{labelObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!labelObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': label.isDropUp }\" ng-click=\"$event.stopPropagation(); label.toggleDropUp(\'labelTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"label.fnOpenLabelInfoTab(labelObj,1)\">Details</a></li><li><a ng-click=\"label.fnOpenLabelInfoTab(labelObj,2)\">Tags</a></li><li ng-if=\"label.permissionObj.CREATE_LABEL\"><a ng-click=\"label.fnCloneLabel(labelObj)\">Clone</a></li><li><a ng-click=\"label.fnCopyId(labelObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!label.isLabelsLoading && label.labelsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{label.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"label.perPage = 10; label.fnPageChanged(label.currentPage, label.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"label.perPage = 20; label.fnPageChanged(label.currentPage, label.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"label.perPage = 50; label.fnPageChanged(label.currentPage, label.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"label.perPage = 100; label.fnPageChanged(label.currentPage,label.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"label.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"label.currentPage\" items-per-page=\"label.perPage\" max-size=\"label.maxSize\" boundary-links=\"true\" ng-click=\"label.fnPageChanged(label.currentPage, label.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{label.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : label.isRefresh}\" ng-click=\"label.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"label.permissionObj.CREATE_LABEL\" ng-click=\"label.fnHideShowCreateForm()\">Create Label</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && label.selectedLabelObj && label.isLabelDetailsLoaded && !label.isCreate && !label.isShowDashboard && !label.isShowLabelStats && !label.isShowWidgetEditor && !label.isShowRelationships && !label.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><label-info label-obj=\"label.selectedLabelObj\" user-permissions-obj=\"label.permissionObj\" fn-call-clone-obj=\"label.fnCloneLabel(data)\"></label-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && label.isCreate && !label.isShowDashboard && !label.isShowLabelStats && !label.isShowWidgetEditor && !label.isShowRelationships && !label.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/label/createLabel/createLabel.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && label.isShowDashboard && !label.isCreate && !label.isShowLabelStats && !label.isShowWidgetEditor && !label.isShowRelationships && !label.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Labels</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"label.permissionObj.CREATE_LABEL\"><span>Label. To create a label, select Create Label.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"label.fnHideShowCreateForm()\">Create Label</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Labels are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Labels</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && !label.isShowDashboard && !label.isCreate && label.isShowLabelStats && !label.isShowWidgetEditor && !label.isShowRelationships && !label.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'label\'\" service-name=\"\'Label\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"label.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"label.fnGetWidgetEditor()\" fn-hide-chart=\"label.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && !label.isShowDashboard && !label.isCreate && !label.isShowLabelStats && label.isShowWidgetEditor && !label.isShowRelationships && !label.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'label\'\" service-display-name=\"\'Label\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"label.activeTabIndex !== 1 && !label.isShowDashboard && !label.isCreate && !label.isShowLabelStats && !label.isShowWidgetEditor && !label.isShowRelationships && label.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'label\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-init=\"label.fnInitLabelRelationships()\" ng-if=\"label.activeTabIndex !== 1 && !label.isShowDashboard && !label.isCreate && !label.isShowLabelStats && !label.isShowWidgetEditor && label.isShowRelationships && !label.isCreateIssue\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"label.isLabelRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!label.isLabelRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" ng-repeat=\"childrenObj in label.newProjectData\" ng-include=\"\'labelRelationshipsTree\'\"></li></ul></div><script type=\"text/ng-template\" id=\"labelRelationshipsTree\"><div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.childrenObj}\"> <a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.childrenObj.children.length !== 1 }\"></a> <div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.childrenObj.children.length !== 1}\"> <div class=\"panel-heading p-10 d-flex align-items-center\"> <div class=\"col-sm-12 p-0 d-flex align-items-center\"> <div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"> <label class=\"ellipsis m-b-0\"> {{childrenObj.name}} </label> </div> </div> </div> <div class=\"panel-body\"> <div class=\"col-sm-12 text-left\"> <div class=\"p-10\"> <span>{{childrenObj.description}}</span> </div> <div> <div class=\"border-top-1px\"></div> <div class=\"p-10\" ng-if=\"childrenObj.labels.length\"> <div> <button class=\"btn btn-xs btn-default m-r-5 m-b-5 ellipsis-button p-l-5 p-r-5 p-t-1 p-b-1\" ng-repeat=\"labelObj in childrenObj.labels track by $index\" ng-style=\"label.fnGetLabelColor(labelObj)\" ng-click=\"label.fnCheckUncheckHeader(labelObj)\"> <span>{{labelObj.name}}</span> </button> </div> </div> <div class=\"p-10\" ng-if=\"!childrenObj.labels.length\"> <label class=\"m-b-0\">No labels found...</label> </div> </div> </div> </div> </div> </div> <ul ng-if=\"childrenObj.children && childrenObj.children.length\"> <li ng-repeat=\"childrenObj in childrenObj.children\" ng-include=\"\'labelRelationshipsTree\'\"> </li> </ul></script></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/priorities/priorities.html","<div class=\"row h-100\" ng-init=\"priorities.fnInitPriorities()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"priorities.activeTabIndex\"><uib-tab index=\"1\" select=\"priorities.fnTabChanged(priorities.tabs[0])\" ng-click=\"priorities.fnChangeTab(priorities.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"priorities.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in priorities.tabs track by $index\" select=\"priorities.fnTabChanged(tab)\" ng-click=\"priorities.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"priorities.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();priorities.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"priorities.fnGetPriorityDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!priorities.isFullWidthDevice\"><a ng-click=\"priorities.fnGetPriorityStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"priorities.fnGetPriorityRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"priorities.isFullWidthDevice\"><a ng-click=\"priorities.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{priorities.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"priorities.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"priorities.isFullWidthDevice && priorities.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'priorities\'\" service-name=\"\'Priorities\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"priorities.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"priorities.fnGetWidgetEditor()\" fn-hide-chart=\"priorities.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"priorities.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{priorities.project.name ? priorities.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"priorities.priorityProjectSearch[priorities.priorityProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in priorities.filterProject=(priorities.projectsArr | filter:priorities.priorityProjectSearch) track by $index\" ng-click=\"priorities.fnGetProjectPriority(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === priorities.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!priorities.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"priorities.isRefreshData\" search-identifier=\"\'prioritiesearch\'\" filters-arr=\"priorities.searchFiltersArr\" filter-query=\"priorities.filterQuery\" fn-filter-query-change=\"priorities.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.priorities\'\" fn-resize=\"priorities.fnSetTableHeight()\" sort-field-arr=\"priorities.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"priorities.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"priorities.isShowInsightOption()\"><a ng-click=\"priorities.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"priorities.getPrioritiesCSVData()\" id=\"csvAnchor\" csv-header=\"priorities.csvHeaderArr\" filename=\"priorities.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"priorities.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"priorities.isPrioritiesLoading\" fn-resize=\"priorities.fnSetLoaderTableHeight()\"></table-loader><div class=\"priorities-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!priorities.isPrioritiesLoading\"><thead><tr><th ng-if=\"priorities.priorityArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"priorities.isAllChecked\" ng-click=\"priorities.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"priorities.priorityArr.length\"><span>Priorities</span></th><th ng-if=\"priorities.priorityArr.length\">Name</th><th ng-if=\"priorities.priorityArr.length\">Project</th><th ng-if=\"priorities.priorityArr.length\"></th><th ng-if=\"priorities.priorityArr.length\"></th><th ng-if=\"priorities.priorityArr.length\"></th><th ng-if=\"!priorities.priorityArr.length\">No records found...</th></tr></thead><tbody id=\"prioritiesTable\"><tr ng-repeat=\"priorityObj in priorities.priorityArr track by $index\" ng-click=\"priorities.fnCheckUncheckHeader(priorityObj);\" context-menu=\"priorities.prioritiesContextMenu(priorityObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"prioritiesObj.isCheck\" ng-change=\"priorities.fnCheckUncheckHeader(priorityObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"priorities.fnGetPrioritiesColor(priorityObj)\" uib-tooltip=\"{{priorityObj.name}}\" tooltip-placement=\"auto\"><span>{{priorityObj.name}}</span></button></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!priorityObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{priorityObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{priorityObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"priorityObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"priorityObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"priorityObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!priorityObj.name.length\" ng-click=\"$event.stopPropagation();priorities.fnSavePrioritiesInfo(priorityObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();priorities.fnCancelPrioritiesEditMode(priorityObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!priorityObj.isEditable\"><div class=\"d-flex align-items-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{priorityObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!priorityObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{priorityObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"priorityObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{priorityObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{priorityObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"priorityObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{priorityObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!priorityObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{priorityObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"priorityObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{priorityObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{priorityObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"priorityObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{priorityObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!priorityObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': priorities.isDropUp }\" ng-click=\"$event.stopPropagation(); priorities.toggleDropUp(\'prioritiesTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"priorities.fnOpenPriorityInfoTab(priorityObj,1)\">Details</a></li><li><a ng-click=\"priorities.fnOpenPriorityInfoTab(priorityObj,2)\">Tags</a></li><li ng-if=\"priorities.permissionObj.CREATE_PRIORITY\"><a ng-click=\"priorities.fnClonePriority(priorityObj)\">Clone</a></li><li><a ng-click=\"priorities.fnCopyId(priorityObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!priorities.isPrioritiesLoading && priorities.priorityArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{priorities.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"priorities.perPage = 10; priorities.fnPageChanged(priorities.currentPage, priorities.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"priorities.perPage = 20; priorities.fnPageChanged(priorities.currentPage, priorities.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"priorities.perPage = 50; priorities.fnPageChanged(priorities.currentPage, priorities.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"priorities.perPage = 100; priorities.fnPageChanged(priorities.currentPage,priorities.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"priorities.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"priorities.currentPage\" items-per-page=\"priorities.perPage\" max-size=\"priorities.maxSize\" boundary-links=\"true\" ng-click=\"priorities.fnPageChanged(priorities.currentPage, priorities.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{priorities.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : priorities.isRefresh}\" ng-click=\"priorities.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"priorities.permissionObj.CREATE_PRIORITY\" ng-click=\"priorities.fnHideShowCreateForm()\">Create Priority</button></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && priorities.selectedPriorityObj && priorities.isPrioritiesDetailsLoaded && !priorities.isCreate && !priorities.isShowDashboard && !priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && !priorities.isShowRelationships && !priorities.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><priority-info priority-obj=\"priorities.selectedPriorityObj\" user-permissions-obj=\"priorities.permissionObj\" fn-call-clone-obj=\"priorities.fnClonePriority(data)\"></priority-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && priorities.isCreate && !priorities.isShowDashboard && !priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && !priorities.isShowRelationships && !priorities.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/priorities/createPriority/createPriority.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && priorities.isShowDashboard && !priorities.isCreate && !priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && !priorities.isShowRelationships && !priorities.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Tracker</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Priorities</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"priorities.permissionObj.CREATE_PRIORITY\"><span>Priorities. To create a priority, select Create Priority.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"priorities.fnHideShowCreateForm()\">Create Priority</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Priorities are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Labels</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && !priorities.isShowDashboard && !priorities.isCreate && priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && !priorities.isShowRelationships && !priorities.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'priorities\'\" service-name=\"\'Priorities\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"priorities.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"priorities.fnGetWidgetEditor()\" fn-hide-chart=\"priorities.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && !priorities.isShowDashboard && !priorities.isCreate && !priorities.isShowPriorityStats && priorities.isShowWidgetEditor && !priorities.isShowRelationships && !priorities.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'priorities\'\" service-display-name=\"\'Priorities\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && !priorities.isShowDashboard && !priorities.isCreate && !priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && !priorities.isShowRelationships && priorities.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'priorities\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"priorities.activeTabIndex !== 1 && !priorities.isShowDashboard && !priorities.isCreate && !priorities.isShowPriorityStats && !priorities.isShowWidgetEditor && priorities.isShowRelationships && !priorities.isCreateIssue\" ng-init=\"priorities.fnInitPrioritiesRelationships()\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"priorities.isPrioritiesRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!priorities.isPrioritiesRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" ng-repeat=\"childrenObj in priorities.newProjectData\" ng-include=\"\'prioritiesRelationshipsTree\'\"></li></ul></div><script type=\"text/ng-template\" id=\"prioritiesRelationshipsTree\"><div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.childrenObj}\"> <a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.childrenObj.children.length !== 1 }\"></a> <div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.childrenObj.children.length !== 1}\"> <div class=\"panel-heading p-10 d-flex align-items-center\"> <div class=\"col-sm-12 p-0 d-flex align-items-center\"> <div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"> <label class=\"ellipsis m-b-0\"> {{childrenObj.name}} </label> </div> </div> </div> <div class=\"panel-body\"> <div class=\"col-sm-12 text-left\"> <div class=\"p-10\"> <span>{{childrenObj.description}}</span> </div> <div> <div class=\"border-top-1px\"></div> <div class=\"p-10\" ng-if=\"childrenObj.priorities.length\"> <div> <button class=\"btn btn-xs btn-default m-r-5 m-b-5 ellipsis-button p-l-5 p-r-5 p-t-1 p-b-1\" ng-repeat=\"prioritiesObj in childrenObj.priorities track by $index\" ng-style=\"priorities.fnGetPrioritiesColor(prioritiesObj)\" ng-click=\"priorities.fnCheckUncheckHeader(prioritiesObj)\"> <span>{{prioritiesObj.name}}</span> </button> </div> </div> <div class=\"p-10\" ng-if=\"!childrenObj.priorities.length\"> <label class=\"m-b-0\">No priority found...</label> </div> </div> </div> </div> </div> </div> <ul ng-if=\"childrenObj.children && childrenObj.children.length\"> <li ng-repeat=\"childrenObj in childrenObj.children\" ng-include=\"\'prioritiesRelationshipsTree\'\"> </li> </ul></script></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/project/project.html","<div class=\"row h-100\" ng-init=\"project.fnInitProjects()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"project.activeTabIndex\"><uib-tab index=\"1\" select=\"project.fnTabChanged(project.tabs[0])\" ng-click=\"project.fnChangeTab(project.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"project.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in project.tabs track by $index\" select=\"project.fnTabChanged(tab)\" ng-click=\"project.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"project.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();project.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnGetProjectDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!project.isFullWidthDevice\"><a ng-click=\"project.fnGetProjectStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"project.fnGetProjectRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"project.isFullWidthDevice\"><a ng-click=\"project.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{project.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"project.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"project.isFullWidthDevice && project.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"project.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"project.fnGetWidgetEditor()\" fn-hide-chart=\"project.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"project.isRefreshData\" search-identifier=\"\'projectSearch\'\" filters-arr=\"project.searchFiltersArr\" filter-query=\"project.filterQuery\" fn-filter-query-change=\"project.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.project\'\" fn-resize=\"project.fnSetTableHeight()\" sort-field-arr=\"project.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"project.selectedProjectsArr.length\"><a ng-click=\"project.fnDeleteMultipleProjects(project.selectedProjectsArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"project.isShowInsightOption()\"><a ng-click=\"project.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"project.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"project.csvHeaderArr\" filename=\"project.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"project.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"project.isProjectsLoading\" fn-resize=\"project.fnSetLoaderTableHeight()\"></table-loader><div class=\"project-table table-container\"><table id=\"projectsTable\" class=\"table table-striped table-check-box\" ng-if=\"!project.isProjectsLoading\"><thead><tr><th ng-if=\"project.projectsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"project.isAllChecked\" ng-click=\"project.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"project.projectsArr.length\"><span>Name</span></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"project.projectsArr.length\"></th><th ng-if=\"!project.projectsArr.length\">No records found...</th></tr></thead><tbody id=\"projectTable\"><tr ng-repeat=\"projectObj in project.projectsArr track by $index\" ng-click=\"project.fnCheckUncheckHeader(projectObj);\" context-menu=\"project.projectContextMenu(projectObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectObj.isCheck\" ng-change=\"project.fnCheckUncheckHeader(projectObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!projectObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{projectObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{projectObj.description}}</span></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"projectObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name for the Project*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" id=\"desc\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description regarding Project\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv\"><input type=\"button\" class=\"btn btn-link m-t-10 p-0 pull-right\" ng-click=\"$event.stopPropagation();project.fnCancelProjectEditMode(projectObj)\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link m-t-10 p-r-5 p-0 pull-right m-r-5\" ng-disabled=\"!projectObj.name.length\" ng-click=\"$event.stopPropagation();project.fnSaveProjectInfo(projectObj)\" value=\"Save\"></div></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!projectObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{projectObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!projectObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{projectObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{projectObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"projectObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{projectObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!projectObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': project.isDropUp }\" ng-click=\"$event.stopPropagation(); project.toggleDropUp(\'projectTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,1)\">Details</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,2)\">Teams</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,3)\">S4</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,4)\">Email Template</a></li><li><a ng-click=\"project.fnOpenProjectInfoTab(projectObj,5)\">Tags</a></li><li><a ng-click=\"project.fnCopyId(projectObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!project.isProjectsLoading && project.projectsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{project.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 10; project.fnPageChanged(project.currentPage, project.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 20; project.fnPageChanged(project.currentPage, project.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 50; project.fnPageChanged(project.currentPage, project.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"project.perPage = 100; project.fnPageChanged(project.currentPage,project.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"project.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"project.currentPage\" items-per-page=\"project.perPage\" max-size=\"project.maxSize\" boundary-links=\"true\" ng-click=\"project.fnPageChanged(project.currentPage, project.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{project.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : project.isRefresh}\" ng-click=\"project.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"project.permissionObj.CREATE_PROJECT\" ng-click=\"project.fnHideShowCreateForm()\">Create Project</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.selectedProjectObj && project.isProjectDetailsLoaded && !project.isCreate && !project.isShowDashboard && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><project-info project-obj=\"project.selectedProjectObj\" user-permissions-obj=\"project.permissionObj\"></project-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.isCreate && !project.isShowDashboard && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/project/createProject/createProject.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Projects</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Project. To create a project, select Create Project.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"project.fnHideShowCreateForm()\">Create Project</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Projects are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Projects</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && project.isShowProjectStats && !project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'project\'\" service-name=\"\'Project\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"project.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"project.fnGetWidgetEditor()\" fn-hide-chart=\"project.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && project.isShowWidgetEditor && !project.isShowRelationships && !project.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'project\'\" service-display-name=\"\'Project\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && project.isShowWidgetEditor && !project.isShowRelationships && project.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'project\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-init=\"project.fnInitProjectRelationships()\" ng-if=\"project.activeTabIndex !== 1 && !project.isShowDashboard && !project.isCreate && !project.isShowProjectStats && !project.isShowWidgetEditor && project.isShowRelationships && !project.isCreateIssue\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"project.isProjectRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!project.isProjectRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" project-relationships=\"\" fn-get-project-detail=\"project.fnOpenProjectInfoTab(projectObj,1)\" project-obj=\"project.newProjectData\"></li></ul></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/project_emailTemplate/project_emailTemplate.html","<div class=\"row h-100\" ng-init=\"projectEmailTemplate.fnInitEmailTemplate();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"projectEmailTemplate.activeTabIndex\"><uib-tab index=\"1\" select=\"projectEmailTemplate.fnTabChanged(projectEmailTemplate.tabs[0])\" ng-click=\"projectEmailTemplate.fnChangeTab(projectEmailTemplate.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"projectEmailTemplate.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in projectEmailTemplate.tabs track by $index\" select=\"projectEmailTemplate.fnTabChanged(tab)\" ng-click=\"projectEmailTemplate.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"projectEmailTemplate.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();projectEmailTemplate.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"projectEmailTemplate.fnGetEmailTemplateDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!projectEmailTemplate.isFullWidthDevice\"><a ng-click=\"projectEmailTemplate.fnGetEmailTemplateStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"projectEmailTemplate.isFullWidthDevice\"><a ng-click=\"projectEmailTemplate.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{projectEmailTemplate.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"projectEmailTemplate.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"projectEmailTemplate.isFullWidthDevice && projectEmailTemplate.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'projectEmailTemplate\'\" service-name=\"\'ProjectEmailTemplate\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"projectEmailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"projectEmailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"projectEmailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"projectEmailTemplate.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"projectEmailTemplate.searchFiltersArr\" filter-query=\"projectEmailTemplate.filterQuery\" fn-filter-query-change=\"projectEmailTemplate.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.project_emailTemplate\'\" fn-resize=\"projectEmailTemplate.fnSetTableHeight()\" sort-field-arr=\"projectEmailTemplate.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"projectEmailTemplate.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"projectEmailTemplate.isEmailTemplatesloading\" fn-resize=\"projectEmailTemplate.fnSetLoaderTableHeight()\"></table-loader><div class=\"email-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!projectEmailTemplate.isEmailTemplatesloading\"><thead><tr><th ng-if=\"projectEmailTemplate.emailTemplateArr.length\" class=\"p-8\"></th><th ng-if=\"projectEmailTemplate.emailTemplateArr.length\"><span>Name</span></th><th ng-if=\"projectEmailTemplate.emailTemplateArr.length\"></th><th ng-if=\"!projectEmailTemplate.emailTemplateArr.length\">No records found...</th></tr></thead><tbody id=\"emailTable\"><tr ng-repeat=\"emailTemplateObj in projectEmailTemplate.emailTemplateArr track by $index\" ng-click=\"projectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"emailTemplateObj.isCheck\" ng-change=\"projectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"emailTemplateObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': projectEmailTemplate.isDropUp }\" ng-click=\"$event.stopPropagation(); projectEmailTemplate.toggleDropUp(\'emailTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"projectEmailTemplate.fnCheckUncheckHeader(emailTemplateObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!projectEmailTemplate.isEmailTemplatesloading && projectEmailTemplate.emailTemplateArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{projectEmailTemplate.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"projectEmailTemplate.perPage = 10; projectEmailTemplate.fnPageChanged(projectEmailTemplate.currentPage, projectEmailTemplate.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"projectEmailTemplate.perPage = 20; projectEmailTemplate.fnPageChanged(projectEmailTemplate.currentPage, projectEmailTemplate.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"projectEmailTemplate.perPage = 50; projectEmailTemplate.fnPageChanged(projectEmailTemplate.currentPage, projectEmailTemplate.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"projectEmailTemplate.perPage = 100; projectEmailTemplate.fnPageChanged(projectEmailTemplate.currentPage,projectEmailTemplate.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"projectEmailTemplate.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"projectEmailTemplate.currentPage\" items-per-page=\"projectEmailTemplate.perPage\" max-size=\"projectEmailTemplate.maxSize\" boundary-links=\"true\" ng-click=\"projectEmailTemplate.fnPageChanged(projectEmailTemplate.currentPage, projectEmailTemplate.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{projectEmailTemplate.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : projectEmailTemplate.isRefresh}\" ng-click=\"projectEmailTemplate.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite EmailTemplate</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectEmailTemplate.activeTabIndex !== 1 && projectEmailTemplate.selectedEmailTemplatesArr.length === 1 && projectEmailTemplate.selectedEmailTemplateObj && projectEmailTemplate.isEmailTemplateDetailsLoaded && !projectEmailTemplate.isShowDashboard && !projectEmailTemplate.isShowEmailTemplateStats && !projectEmailTemplate.isShowWidgetEditor && !projectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><project-email-template-info email-template-obj=\"projectEmailTemplate.selectedEmailTemplateObj\" user-permissions-obj=\"projectEmailTemplate.permissionObj\"></project-email-template-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectEmailTemplate.activeTabIndex !== 1 && projectEmailTemplate.isShowDashboard && !projectEmailTemplate.isShowEmailTemplateStats && !projectEmailTemplate.isShowWidgetEditor && !projectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Email Templates</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Email Templates</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Email Templates are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectEmailTemplate.activeTabIndex !== 1 && !projectEmailTemplate.isShowDashboard && projectEmailTemplate.isShowEmailTemplateStats && !projectEmailTemplate.isShowWidgetEditor && !projectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'projectEmailTemplate\'\" service-name=\"\'ProjectEmailTemplate\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"projectEmailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"projectEmailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"projectEmailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectEmailTemplate.activeTabIndex !== 1 && !projectEmailTemplate.isShowDashboard && !projectEmailTemplate.isShowEmailTemplateStats && projectEmailTemplate.isShowWidgetEditor && !projectEmailTemplate.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-display-name=\"projectEmailTemplate.selectedProjectName +\' Email Template\'\" service-name=\"\'projectEmailTemplate\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectEmailTemplate.activeTabIndex !== 1 && !projectEmailTemplate.isShowDashboard && !projectEmailTemplate.isShowEmailTemplateStats && !projectEmailTemplate.isShowWidgetEditor && projectEmailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'projectEmailTemplate\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/project_script/project_scripts.html","<div class=\"row h-100\" ng-init=\"projectScripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"projectScripts.activeTabIndex\"><uib-tab index=\"1\" select=\"projectScripts.fnTabChanged(projectScripts.tabs[0])\" ng-click=\"projectScripts.fnChangeTab(projectScripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"projectScripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in projectScripts.tabs track by $index\" select=\"projectScripts.fnTabChanged(tab)\" ng-click=\"projectScripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"projectScripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();projectScripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"projectScripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!projectScripts.isFullWidthDevice\"><a ng-click=\"projectScripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"projectScripts.isFullWidthDevice\"><a ng-click=\"projectScripts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{projectScripts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"projectScripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"projectScripts.isFullWidthDevice && projectScripts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'projectS4\'\" service-name=\"\'ProjectS4\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"projectScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"projectScripts.fnGetWidgetEditor()\" fn-hide-chart=\"projectScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"projectScripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"projectScripts.searchFiltersArr\" filter-query=\"projectScripts.filterQuery\" fn-filter-query-change=\"projectScripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.project_scripts\'\" fn-resize=\"projectScripts.fnSetTableHeight()\" sort-field-arr=\"projectScripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"projectScripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"projectScripts.isScriptsloading\" fn-resize=\"projectScripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!projectScripts.isScriptsloading\"><thead><tr><th ng-if=\"projectScripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"projectScripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"projectScripts.scriptArr.length\"></th><th ng-if=\"!projectScripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in projectScripts.scriptArr track by $index\" ng-click=\"projectScripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"projectScripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': projectScripts.isDropUp }\" ng-click=\"$event.stopPropagation(); projectScripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"projectScripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!projectScripts.isScriptsloading && projectScripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{projectScripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"projectScripts.perPage = 10; projectScripts.fnPageChanged(projectScripts.currentPage, projectScripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"projectScripts.perPage = 20; projectScripts.fnPageChanged(projectScripts.currentPage, projectScripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"projectScripts.perPage = 50; projectScripts.fnPageChanged(projectScripts.currentPage, projectScripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"projectScripts.perPage = 100; projectScripts.fnPageChanged(projectScripts.currentPage,projectScripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"projectScripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"projectScripts.currentPage\" items-per-page=\"projectScripts.perPage\" max-size=\"projectScripts.maxSize\" boundary-links=\"true\" ng-click=\"projectScripts.fnPageChanged(projectScripts.currentPage, projectScripts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{projectScripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : projectScripts.isRefresh}\" ng-click=\"projectScripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectScripts.activeTabIndex !== 1 && projectScripts.selectedScriptsArr.length === 1 && projectScripts.selectedScriptObj && projectScripts.isScriptDetailsLoaded && !projectScripts.isShowDashboard && !projectScripts.isShowScriptStats && !projectScripts.isShowWidgetEditor && !projectScripts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><project-script-info script-obj=\"projectScripts.selectedScriptObj\" user-permissions-obj=\"projectScripts.permissionObj\"></project-script-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectScripts.activeTabIndex !== 1 && projectScripts.isShowDashboard && !projectScripts.isShowScriptStats && !projectScripts.isShowWidgetEditor && !projectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectScripts.activeTabIndex !== 1 && !projectScripts.isShowDashboard && projectScripts.isShowScriptStats && !projectScripts.isShowWidgetEditor && !projectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'projectS4\'\" service-name=\"\'ProjectS4\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"projectScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"projectScripts.fnGetWidgetEditor()\" fn-hide-chart=\"projectScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectScripts.activeTabIndex !== 1 && !projectScripts.isShowDashboard && !projectScripts.isShowScriptStats && projectScripts.isShowWidgetEditor && !projectScripts.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-display-name=\"projectScripts.selectedProjectName + \' S4\'\" service-name=\"\'projectS4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"projectScripts.activeTabIndex !== 1 && !projectScripts.isShowDashboard && !projectScripts.isShowScriptStats && !projectScripts.isShowWidgetEditor && projectScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'projectS4\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/script/scripts.html","<div class=\"row h-100\" ng-init=\"trackerScripts.fnInitScript();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"trackerScripts.activeTabIndex\"><uib-tab index=\"1\" select=\"trackerScripts.fnTabChanged(trackerScripts.tabs[0])\" ng-click=\"trackerScripts.fnChangeTab(trackerScripts.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"trackerScripts.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in trackerScripts.tabs track by $index\" select=\"trackerScripts.fnTabChanged(tab)\" ng-click=\"trackerScripts.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"trackerScripts.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();trackerScripts.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"trackerScripts.fnGetScriptDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!trackerScripts.isFullWidthDevice\"><a ng-click=\"trackerScripts.fnGetScriptStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"trackerScripts.isFullWidthDevice\"><a ng-click=\"trackerScripts.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{trackerScripts.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"trackerScripts.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"trackerScripts.isFullWidthDevice && trackerScripts.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"trackerScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"trackerScripts.fnGetWidgetEditor()\" fn-hide-chart=\"trackerScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"trackerScripts.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"trackerScripts.searchFiltersArr\" filter-query=\"trackerScripts.filterQuery\" fn-filter-query-change=\"trackerScripts.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.tracker_scripts\'\" fn-resize=\"trackerScripts.fnSetTableHeight()\" sort-field-arr=\"trackerScripts.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"trackerScripts.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"trackerScripts.isScriptsloading\" fn-resize=\"trackerScripts.fnSetLoaderTableHeight()\"></table-loader><div class=\"script-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!trackerScripts.isScriptsloading\"><thead><tr><th ng-if=\"trackerScripts.scriptArr.length\" class=\"p-8\"></th><th ng-if=\"trackerScripts.scriptArr.length\"><span>Name</span></th><th ng-if=\"trackerScripts.scriptArr.length\"></th><th ng-if=\"!trackerScripts.scriptArr.length\">No records found...</th></tr></thead><tbody id=\"scriptTable\"><tr ng-repeat=\"scriptObj in trackerScripts.scriptArr track by $index\" ng-click=\"trackerScripts.fnCheckUncheckHeader(scriptObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"scriptObj.isCheck\" ng-change=\"trackerScripts.fnCheckUncheckHeader(scriptObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"scriptObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': trackerScripts.isDropUp }\" ng-click=\"$event.stopPropagation(); trackerScripts.toggleDropUp(\'scriptTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"trackerScripts.fnCheckUncheckHeader(scriptObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!trackerScripts.isScriptsloading && trackerScripts.scriptArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{trackerScripts.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"trackerScripts.perPage = 10; trackerScripts.fnPageChanged(trackerScripts.currentPage, trackerScripts.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"trackerScripts.perPage = 20; trackerScripts.fnPageChanged(trackerScripts.currentPage, trackerScripts.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"trackerScripts.perPage = 50; trackerScripts.fnPageChanged(trackerScripts.currentPage, trackerScripts.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"trackerScripts.perPage = 100; trackerScripts.fnPageChanged(trackerScripts.currentPage,trackerScripts.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"trackerScripts.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"trackerScripts.currentPage\" items-per-page=\"trackerScripts.perPage\" max-size=\"trackerScripts.maxSize\" boundary-links=\"true\" ng-click=\"trackerScripts.fnPageChanged(trackerScripts.currentPage, trackerScripts.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{trackerScripts.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : trackerScripts.isRefresh}\" ng-click=\"trackerScripts.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"trackerScripts.activeTabIndex !== 1 && trackerScripts.selectedScriptsArr.length === 1 && trackerScripts.selectedScriptObj && trackerScripts.isScriptDetailsLoaded && !trackerScripts.isShowDashboard && !trackerScripts.isShowScriptStats && !trackerScripts.isShowWidgetEditor && !trackerScripts.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><tracker-script-info script-obj=\"trackerScripts.selectedScriptObj\" user-permissions-obj=\"trackerScripts.permissionObj\"></tracker-script-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"trackerScripts.activeTabIndex !== 1 && trackerScripts.isShowDashboard && !trackerScripts.isShowScriptStats && !trackerScripts.isShowWidgetEditor && !trackerScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">S4</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>S4</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>S4 are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize email templates</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"trackerScripts.activeTabIndex !== 1 && !trackerScripts.isShowDashboard && trackerScripts.isShowScriptStats && !trackerScripts.isShowWidgetEditor && !trackerScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'s4\'\" service-name=\"\'S4\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"trackerScripts.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"trackerScripts.fnGetWidgetEditor()\" fn-hide-chart=\"trackerScripts.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"trackerScripts.activeTabIndex !== 1 && !trackerScripts.isShowDashboard && !trackerScripts.isShowScriptStats && trackerScripts.isShowWidgetEditor && !trackerScripts.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-display-name=\"\'S4\'\" service-name=\"\'s4\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"trackerScripts.activeTabIndex !== 1 && !trackerScripts.isShowDashboard && !trackerScripts.isShowScriptStats && !trackerScripts.isShowWidgetEditor && trackerScripts.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'s4\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/state/state.html","<div class=\"row h-100\" ng-init=\"state.fnInitStates()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"state.activeTabIndex\"><uib-tab index=\"1\" select=\"state.fnTabChanged(state.tabs[0])\" ng-click=\"state.fnChangeTab(state.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"state.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in state.tabs track by $index\" select=\"state.fnTabChanged(tab)\" ng-click=\"state.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"state.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();state.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"state.fnGetStateDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!state.isFullWidthDevice\"><a ng-click=\"state.fnGetStateStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"state.fnGetStateRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"state.isFullWidthDevice\"><a ng-click=\"state.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{state.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"state.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"state.isFullWidthDevice && state.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'state\'\" service-name=\"\'State\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"state.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"state.fnGetWidgetEditor()\" fn-hide-chart=\"state.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"state.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{state.project.name ? state.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"state.stateProjectSearch[state.stateProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in state.filterProject=(state.projectsArr | filter:state.stateProjectSearch) track by $index\" ng-click=\"state.fnGetProjectState(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === state.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!state.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"state.isRefreshData\" search-identifier=\"\'stateSearch\'\" filters-arr=\"state.searchFiltersArr\" filter-query=\"state.filterQuery\" fn-filter-query-change=\"state.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.state\'\" fn-resize=\"state.fnSetTableHeight()\" sort-field-arr=\"state.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"state.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"state.selectedStatesArr.length\"><a ng-click=\"state.fnDeleteMultipleStates(state.selectedStatesArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li ng-if=\"state.isShowInsightOption()\"><a ng-click=\"state.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"state.getStateCSVData()\" id=\"csvAnchor\" csv-header=\"state.csvHeaderArr\" filename=\"state.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"state.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"state.isStatesLoading\" fn-resize=\"state.fnSetLoaderTableHeight()\"></table-loader><div class=\"state-table table-container\"><table id=\"statesTable\" class=\"table table-striped table-check-box\" ng-if=\"!state.isStatesLoading\"><thead><tr><th ng-if=\"state.statesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"state.isAllChecked\" ng-click=\"state.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"state.statesArr.length\"><span>State</span></th><th ng-if=\"state.statesArr.length\">Name</th><th ng-if=\"state.statesArr.length\">Project</th><th ng-if=\"state.statesArr.length\"></th><th ng-if=\"state.statesArr.length\"></th><th ng-if=\"state.statesArr.length\"></th><th ng-if=\"!state.statesArr.length\">No records found...</th></tr></thead><tbody id=\"stateTable\"><tr ng-repeat=\"stateObj in state.statesArr track by $index\" ng-click=\"state.fnCheckUncheckHeader(stateObj);\" context-menu=\"state.stateContextMenu(stateObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"stateObj.isCheck\" ng-change=\"state.fnCheckUncheckHeader(stateObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"state.fnGetStateColor(stateObj)\" uib-tooltip=\"{{stateObj.name}}\" tooltip-placement=\"auto\"><span>{{stateObj.name}}</span></button></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!stateObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{stateObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{stateObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"stateObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"stateObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"stateObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!stateObj.name.length\" ng-click=\"$event.stopPropagation();state.fnSaveStateInfo(stateObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();state.fnCancelStateEditMode(stateObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!stateObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{stateObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!stateObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{stateObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"stateObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{stateObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{stateObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"stateObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{stateObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!stateObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{stateObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"stateObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{stateObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{stateObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"stateObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{stateObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!stateObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': state.isDropUp }\" ng-click=\"$event.stopPropagation(); state.toggleDropUp(\'stateTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"state.fnOpenStateInfoTab(stateObj,1)\">Details</a></li><li><a ng-click=\"state.fnOpenStateInfoTab(stateObj,2)\">Tags</a></li><li ng-if=\"state.permissionObj.CREATE_STATE\"><a ng-click=\"state.fnCloneState(stateObj)\">Clone</a></li><li><a ng-click=\"state.fnCopyId(stateObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!state.isStatesLoading && state.statesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{state.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"state.perPage = 10; state.fnPageChanged(state.currentPage, state.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"state.perPage = 20; state.fnPageChanged(state.currentPage, state.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"state.perPage = 50; state.fnPageChanged(state.currentPage, state.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"state.perPage = 100; state.fnPageChanged(state.currentPage,state.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"state.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"state.currentPage\" items-per-page=\"state.perPage\" max-size=\"state.maxSize\" boundary-links=\"true\" ng-click=\"state.fnPageChanged(state.currentPage, state.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{state.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : state.isRefresh}\" ng-click=\"state.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"state.permissionObj.CREATE_STATE\" ng-click=\"state.fnHideShowCreateForm()\">Create State</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && state.selectedStateObj && state.isStateDetailsLoaded && !state.isCreate && !state.isShowDashboard && !state.isShowStateStats && !state.isShowWidgetEditor && !state.isShowRelationships && !state.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><state-info state-obj=\"state.selectedStateObj\" user-permissions-obj=\"state.permissionObj\" fn-call-clone-obj=\"state.fnCloneState(data)\"></state-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && state.isCreate && !state.isShowDashboard && !state.isShowStateStats && !state.isShowWidgetEditor && !state.isShowRelationships && !state.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/state/createState/createState.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && state.isShowDashboard && !state.isCreate && !state.isShowStateStats && !state.isShowWidgetEditor && !state.isShowRelationships && !state.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">States</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"state.permissionObj.CREATE_STATE\"><span>State. To create a state, select Create State.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"state.fnHideShowCreateForm()\">Create State</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>States are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to States</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && !state.isShowDashboard && !state.isCreate && state.isShowStateStats && !state.isShowWidgetEditor && !state.isShowRelationships && !state.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'state\'\" service-name=\"\'State\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"state.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"state.fnGetWidgetEditor()\" fn-hide-chart=\"state.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && !state.isShowDashboard && !state.isCreate && !state.isShowStateStats && state.isShowWidgetEditor && !state.isShowRelationships && !state.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'state\'\" service-display-name=\"\'State\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && !state.isShowDashboard && !state.isCreate && !state.isShowStateStats && state.isShowWidgetEditor && !state.isShowRelationships && state.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'state\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"state.activeTabIndex !== 1 && !state.isShowDashboard && !state.isCreate && !state.isShowStateStats && !state.isShowWidgetEditor && state.isShowRelationships && !state.isCreateIssue\" ng-init=\"state.fnInitStateRelationships()\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"state.isStateRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!state.isStateRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" ng-repeat=\"childrenObj in state.newProjectData\" ng-include=\"\'stateRelationshipsTree\'\"></li></ul></div><script type=\"text/ng-template\" id=\"stateRelationshipsTree\"><div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.childrenObj}\"> <a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.childrenObj.children.length !== 1 }\"></a> <div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.childrenObj.children.length !== 1}\"> <div class=\"panel-heading p-10 d-flex align-items-center\"> <div class=\"col-sm-12 p-0 d-flex align-items-center\"> <div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"> <label class=\"ellipsis m-b-0\"> {{childrenObj.name}} </label> </div> </div> </div> <div class=\"panel-body\"> <div class=\"col-sm-12 text-left\"> <div class=\"p-10\"> <span>{{childrenObj.description}}</span> </div> <div> <div class=\"border-top-1px\"></div> <div class=\"p-10\" ng-if=\"childrenObj.state.length\"> <div> <button class=\"btn btn-xs btn-default m-r-5 m-b-5 ellipsis-button p-l-5 p-r-5 p-t-1 p-b-1\" ng-repeat=\"prioritiesObj in childrenObj.state track by $index\" ng-style=\"state.fnGetStateColor(prioritiesObj)\" ng-click=\"state.fnCheckUncheckHeader(prioritiesObj)\"> <span>{{prioritiesObj.name}}</span> </button> </div> </div> <div class=\"p-10\" ng-if=\"!childrenObj.state.length\"> <label class=\"m-b-0\">No priority found...</label> </div> </div> </div> </div> </div> </div> <ul ng-if=\"childrenObj.children && childrenObj.children.length\"> <li ng-repeat=\"childrenObj in childrenObj.children\" ng-include=\"\'stateRelationshipsTree\'\"> </li> </ul></script></div></div></div></div></div></div></div></div>");
$templateCache.put("app/tracker/types/types.html","<div class=\"row h-100\" ng-init=\"types.fnInitTypes()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"types.activeTabIndex\"><uib-tab index=\"1\" select=\"types.fnTabChanged(types.tabs[0])\" ng-click=\"types.fnChangeTab(types.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"types.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in types.tabs track by $index\" select=\"types.fnTabChanged(tab)\" ng-click=\"types.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"types.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();types.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"types.fnGetTypeDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!types.isFullWidthDevice\"><a ng-click=\"types.fnGetTypeStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li><a ng-click=\"types.fnGetTypeRelationships()\"><i class=\"fa fa-sitemap m-r-10\"></i>Relationships</a></li><li ng-if=\"types.isFullWidthDevice\"><a ng-click=\"types.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{types.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"types.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"types.isFullWidthDevice && types.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'types\'\" service-name=\"\'Types\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"types.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"types.fnGetWidgetEditor()\" fn-hide-chart=\"types.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"types.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{types.project.name ? types.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"types.typeProjectSearch[types.typeProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in types.filterProject=(types.projectsArr | filter:types.typeProjectSearch) track by $index\" ng-click=\"types.fnGetProjectType(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === types.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!types.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"types.isRefreshData\" search-identifier=\"\'typessearch\'\" filters-arr=\"types.searchFiltersArr\" filter-query=\"types.filterQuery\" fn-filter-query-change=\"types.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.types\'\" fn-resize=\"types.fnSetTableHeight()\" sort-field-arr=\"types.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"types.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"types.isShowInsightOption()\"><a ng-click=\"types.fnOpenInInsight()\"><i class=\"m-r-5 fa fa-search\"></i>Open in Insight</a></li><li ng-hide=\"true\"><a ng-csv=\"types.getTypesCSVData()\" id=\"csvAnchor\" csv-header=\"types.csvHeaderArr\" filename=\"types.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"types.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"types.isTypesLoading\" fn-resize=\"types.fnSetLoaderTableHeight()\"></table-loader><div class=\"types-table table-container\"><table id=\"typesTable\" class=\"table table-striped table-check-box\" ng-if=\"!types.isTypesLoading\"><thead><tr><th ng-if=\"types.typeArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"types.isAllChecked\" ng-click=\"types.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"types.typeArr.length\"><span>Types</span></th><th ng-if=\"types.typeArr.length\">Name</th><th ng-if=\"types.typeArr.length\">Project</th><th ng-if=\"types.typeArr.length\"></th><th ng-if=\"types.typeArr.length\"></th><th ng-if=\"types.typeArr.length\"></th><th ng-if=\"!types.typeArr.length\">No records found...</th></tr></thead><tbody id=\"typeTable\"><tr ng-repeat=\"typeObj in types.typeArr track by $index\" ng-click=\"types.fnCheckUncheckHeader(typeObj);\" context-menu=\"types.typesContextMenu(typeObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"typesObj.isCheck\" ng-change=\"types.fnCheckUncheckHeader(typeObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"types.fnGetTypesColor(typeObj)\" uib-tooltip=\"{{typeObj.name}}\" tooltip-placement=\"auto\"><span>{{typeObj.name}}</span></button></td><td><div class=\"col-sm-12 p-0\" ng-show=\"!typeObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{typeObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{typeObj.description}}</span></div><div class=\"col-sm-12 p-l-0 p-r-10 floatingLabelInput inlineInputEdit\" ng-show=\"typeObj.isEditable\"><div class=\"col-sm-5 p-l-0\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"typeObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-7 p-l-0 p-r-10 inlineInputEdit\" ng-click=\"$event.stopPropagation();\"><div class=\"inputDiv\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"typeObj.description\" placeholder=\"Description\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!typeObj.name.length\" ng-click=\"$event.stopPropagation();types.fnSaveTypesInfo(typeObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();types.fnCancelTypesEditMode(typeObj)\" value=\"Cancel\"></div></div></div></td><td ng-show=\"!typeObj.isEditable\"><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{typeObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!typeObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{typeObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"typeObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{typeObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{typeObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"typeObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{typeObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\" ng-show=\"!typeObj.isEditable\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{typeObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"typeObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{typeObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{typeObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"typeObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{typeObj.updatedBy}}</span></small></div></td><td class=\"text-right\" ng-show=\"!typeObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': types.isDropUp }\" ng-click=\"$event.stopPropagation(); types.toggleDropUp(\'typesTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"types.fnOpenTypeInfoTab(typeObj,1)\">Details</a></li><li><a ng-click=\"types.fnOpenTypeInfoTab(typeObj,2)\">Form</a></li><li><a ng-click=\"types.fnOpenTypeInfoTab(typeObj,3)\">Tags</a></li><li ng-if=\"types.permissionObj.CREATE_TYPE\"><a ng-click=\"types.fnCloneType(typeObj)\">Clone</a></li><li><a ng-click=\"types.fnCopyId(typeObj.id)\">Copy ID</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!types.isTypesLoading && types.typeArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{types.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"types.perPage = 10; types.fnPageChanged(types.currentPage, types.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"types.perPage = 20; types.fnPageChanged(types.currentPage, types.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"types.perPage = 50; types.fnPageChanged(types.currentPage, types.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"types.perPage = 100; types.fnPageChanged(types.currentPage,types.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"types.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"types.currentPage\" items-per-page=\"types.perPage\" max-size=\"types.maxSize\" boundary-links=\"true\" ng-click=\"types.fnPageChanged(types.currentPage, types.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{types.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : types.isRefresh}\" ng-click=\"types.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"types.permissionObj.CREATE_TYPE\" ng-click=\"types.fnHideShowCreateForm()\">Create Type</button></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && types.selectedTypeObj && types.isTypesDetailsLoaded && !types.isCreate && !types.isShowDashboard && !types.isShowTypeStats && !types.isShowWidgetEditor && !types.isShowRelationships && !types.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><type-info type-obj=\"types.selectedTypeObj\" user-permissions-obj=\"types.permissionObj\" fn-call-clone-obj=\"types.fnCloneType(data)\"></type-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && types.isCreate && !types.isShowDashboard && !types.isShowTypeStats && !types.isShowWidgetEditor && !types.isShowRelationships && !types.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><ng-include src=\"\'app/tracker/types/createType/createType.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && types.isShowDashboard && !types.isCreate && !types.isShowTypeStats && !types.isShowWidgetEditor && !types.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Types</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\" ng-if=\"types.permissionObj.CREATE_TYPE\"><span>Type. To create a type, select Create Type.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"types.fnHideShowCreateForm()\">Create Type</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Types are free in your account.You can create as many group as you want to collaborate with you in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Add User to Labels</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && !types.isShowDashboard && !types.isCreate && types.isShowTypeStats && !types.isShowWidgetEditor && !types.isShowRelationships && !types.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'tracker\'\" service-key=\"\'types\'\" service-name=\"\'Types\'\" app-name=\"\'Tracker\'\" fn-get-chart-detail=\"types.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"types.fnGetWidgetEditor()\" fn-hide-chart=\"types.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && !types.isShowDashboard && !types.isCreate && !types.isShowTypeStats && types.isShowWidgetEditor && !types.isShowRelationships && !types.isCreateIssue\"><widget-editor app-name=\"\'tracker\'\" service-name=\"\'types\'\" service-display-name=\"\'Types\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && !types.isShowDashboard && !types.isCreate && !types.isShowTypeStats && types.isShowWidgetEditor && !types.isShowRelationships && types.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'tracker\'\" service-key=\"\'types\'\" app-name=\"\'Tracker\'\"></dashboard-create-issue></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"types.activeTabIndex !== 1 && !types.isShowDashboard && !types.isCreate && !types.isShowTypeStats && !types.isShowWidgetEditor && types.isShowRelationships && !types.isCreateIssue\" ng-init=\"types.fnInitTypeRelationships()\"><div class=\"col-sm-12 p-0 projectRelationships\" id=\"projectParentDiv\"><div ng-if=\"types.isTypeRelationshipsDataLoading\" class=\"d-flex align-items-center justify-content-center height-100\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"projectParentDesign\" ng-if=\"!types.isTypeRelationshipsDataLoading\"><div class=\"tf-tree width-fit-content height-fit-content\"><ul><li class=\"text-center\" ng-repeat=\"childrenObj in types.newProjectData\" ng-include=\"\'typeRelationshipsTree\'\"></li></ul></div><script type=\"text/ng-template\" id=\"typeRelationshipsTree\"><div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.childrenObj}\"> <a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.childrenObj.children.length !== 1 }\"></a> <div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.childrenObj.children.length !== 1}\"> <div class=\"panel-heading p-10 d-flex align-items-center\"> <div class=\"col-sm-12 p-0 d-flex align-items-center\"> <div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"> <label class=\"ellipsis m-b-0\"> {{childrenObj.name}} </label> </div> </div> </div> <div class=\"panel-body\"> <div class=\"col-sm-12 text-left\"> <div class=\"p-10\"> <span>{{childrenObj.description}}</span> </div> <div> <div class=\"border-top-1px\"></div> <div class=\"p-10\" ng-if=\"childrenObj.type.length\"> <div> <button class=\"btn btn-xs btn-default m-r-5 m-b-5 ellipsis-button p-l-5 p-r-5 p-t-1 p-b-1\" ng-repeat=\"typeObj in childrenObj.type track by $index\" ng-style=\"types.fnGetTypesColor(typeObj)\" ng-click=\"types.fnCheckUncheckHeader(typeObj)\"> <span>{{typeObj.name}}</span> </button> </div> </div> <div class=\"p-10\" ng-if=\"!childrenObj.type.length\"> <label class=\"m-b-0\">No priority found...</label> </div> </div> </div> </div> </div> </div> <ul ng-if=\"childrenObj.children && childrenObj.children.length\"> <li ng-repeat=\"childrenObj in childrenObj.children\" ng-include=\"\'typeRelationshipsTree\'\"> </li> </ul></script></div></div></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/access-tokens/access-token.html","<div class=\"row h-100\" style=\"overflow: hidden\" ng-init=\"accessToken.fnInitAccessToken()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-l-0 p-r-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\" style=\"width: calc(100% - 45px)\"><v4-search-client ng-if=\"accessToken.isRefreshData\" search-identifier=\"\'accessToken\'\" filters-arr=\"accessToken.searchFiltersArr\" filter-query=\"accessToken.filterQuery\" fn-filter-query-change=\"accessToken.fnFilterQueryChanged(filterQuery, sortQuery)\" state-name=\"\'main.access_token\'\" fn-resize=\"accessToken.fnSetTableHeight()\" sort-field-arr=\"accessToken.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"accessToken.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"accessToken.getAccessTokenCSVData()\" id=\"csvAnchor\" csv-header=\"vaults.csvHeaderArr\" filename=\"accessToken.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"!accessToken.isReload\"><div class=\"col-sm-12\"><table-loader ng-if=\"accessToken.isAccessTokenLoading\" hide-circle=\"true\" hide-line=\"true\" set-padding=\"true\" fn-resize=\"accessToken.fnSetLoaderTableHeight()\"></table-loader><div class=\"accessToken-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!accessToken.isAccessTokenLoading\"><thead><tr><th ng-if=\"accessToken.accessTokenArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"accessToken.isAllChecked\" ng-click=\"accessToken.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"accessToken.accessTokenArr.length\">ID</th><th ng-if=\"accessToken.accessTokenArr.length\">State</th><th ng-if=\"!accessToken.accessTokenArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"token in accessToken.accessTokenArr track by $index\" ng-click=\"accessToken.fnGetAccessToken(token, accessToken.accessTokenArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"token.isCheck\" ng-change=\"accessToken.fnCheckUncheckHeader(token)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><span class=\"ellipsis\" ng-bind=\"token.id\"></span></td><td ng-bind=\"token.state\">type</td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!accessToken.isAccessTokenLoading && accessToken.accessTokenArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{accessToken.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"accessToken.perPage = 10; accessToken.fnPageChanged(accessToken.currentPage, accessToken.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"accessToken.perPage = 20; accessToken.fnPageChanged(accessToken.currentPage, accessToken.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"accessToken.perPage = 50; accessToken.fnPageChanged(accessToken.currentPage, accessToken.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"accessToken.perPage = 100; accessToken.fnPageChanged(accessToken.currentPage,accessToken.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"accessToken.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"accessToken.currentPage\" items-per-page=\"accessToken.perPage\" max-size=\"accessToken.maxSize\" boundary-links=\"true\" ng-click=\"accessToken.fnPageChanged(accessToken.currentPage, accessToken.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><label>Total: {{accessToken.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : accessToken.isRefresh}\" ng-click=\"accessToken.fnReload();\" aria-hidden=\"true\"></i></div><div class=\"col-sm-6 m-t-3\" ng-if=\"accessToken.isTokenCreating || accessToken.isTokenDetailsChanging\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-6 content-box-footerItem\" ng-if=\"!accessToken.isTokenCreating && !accessToken.isTokenDetailsChanging\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"accessToken.selectedAccessTokenArr.length === 1 && accessToken.selectedAccessTokenObj\" ng-click=\"accessToken.fnChangeStateOfToken(accessToken.selectedAccessTokenObj)\"><a class=\"btn btn-link\" ng-bind=\"accessToken.selectedAccessTokenObj.state === \'ACTIVE\' ? \'Deactivate token\' : \'Activate token\'\"></a></li><li ng-if=\"accessToken.selectedAccessTokenArr.length\" ng-click=\"accessToken.fnDeleteMultipleTokens(accessToken.selectedAccessTokenArr)\"><a class=\"btn btn-link\" ng-bind=\"accessToken.selectedAccessTokenArr.length === 1 ? \'Delete token\' : \'Delete selected tokens\'\"></a></li><li ng-click=\"accessToken.fnCreateNewToken()\"><a class=\"btn btn-link\">Create access token</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/account/account.html","<div class=\"row h-100\" ng-init=\"userAccount.fnInitUserAccount()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in userAccount.tabs\" select=\"userAccount.tabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/preferences/preferences.html","<div class=\"row h-100\" ng-init=\"preferences.fnInitPreferences()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in preferences.tabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfile.html","<div class=\"row h-100\" ng-init=\"userProfile.fnInitUserProfiles()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in userProfile.tabs\" select=\"userProfile.tabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/recipes/recipes.html","<div class=\"row h-100\" ng-init=\"recipes.fnInitRecipes()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-l-0 p-r-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"search-panel1 m-t-5\" ng-if=\"recipes.isRecipesAvailable\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"recipes.search[recipes.filter]\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div></div></div><div class=\"row\"><div class=\"col-sm-12 p-0 m-t-10 recipesFunctionModal\" id=\"functionModal\" style=\"overflow-y: auto\"><div class=\"col-sm-3\" ng-if=\"recipes.isRecipesAvailable\" ng-repeat=\"recipeObj in recipes.recipesArr | filter: recipes.search\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{recipeObj.name}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{recipeObj.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"recipes.fnRecipesSelected(recipeObj)\">Connect</button></div></div></div></div><div class=\"panel-body recipesPanel-body\"><div class=\"col-sm-12 p-0\"><span>{{recipeObj.description}}</span></div></div></div></div><div class=\"col-sm-12\" ng-if=\"!recipes.isRecipesAvailable\"><div class=\"m-t-15 text-center\"><label>There are no recipes available for this account.</label></div></div></div></div></div><div class=\"content-box-footer\"></div></div></div></div></div>");
$templateCache.put("app/user-settings/support/support.html","<div class=\"row h-100 support-div\" ng-init=\"predictiveSupport.fnInitSupport()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in predictiveSupport.tabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/store/cart/cart.html","<div class=\"row h-100\" ng-init=\"cart.fnInitCarts()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in cart.tabs track by $index\" select=\"users.fnTabChanged(tab)\" ng-click=\"users.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();users.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"cart.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Billing</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"cart.isFullWidthDevice\">Carts</h1><h3 class=\"m-0 font-bold\" ng-if=\"!cart.isFullWidthDevice\">Carts</h3></div></div></div><div class=\"col-sm-12 p-15 d-flex\" id=\"cartTable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" ng-if=\"cart.isCartsloading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!cart.isCartsloading\"><div class=\"col-sm-8 p-0 h-100 overflow-auto\"><div class=\"col-sm-12 p-0 h-100 d-flex justify-content-center align-items-center flex-column\" ng-if=\"!cart.cartArr.cartItems.length\"><h1 class=\"m-0\">There are no items in your cart.</h1><button class=\"btn btn-primary v4-primary-button p-t-10 p-b-10 p-l-20 p-r-20 m-t-15\" ui-sref=\"main.products\">Go to Products</button></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"cart.cartArr && cart.cartArr.cartItems && cart.cartArr.cartItems.length\"><div class=\"col-sm-12 p-0 m-t-10 cart-card\" ng-repeat=\"cartInfo in cart.cartArr.cartItems\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><div class=\"col-sm-6 d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"m-r-10\"><img height=\"100px\" width=\"100px\" ng-src=\"{{cartInfo.product.image}}\"></div><div class=\"w100\"><h2 class=\"m-0 ellipsis\" uib-tooltip=\"{{cartInfo.product.name}}\" tooltip-placement=\"auto\">{{cartInfo.quantity}} X {{cartInfo.product.name}}</h2><span class=\"d-block\"><small class=\"m-0 font-italic\">#{{cartInfo.product.id}}</small></span> <span><small class=\"m-0\">{{cartInfo.product.category.replace(\'_\',\' \')}}</small></span></div></div><div class=\"col-sm-12 p-0 p-b-10\" ng-if=\"cartInfo.product && cartInfo.product.mrr\"><span>These {{cartInfo.quantity > 1 ? \'products\' : \'product\'}} will have a monthly recurring charge of ${{(cartInfo.product.mrr/100).toFixed(2)}}</span></div></div><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end p-r-30\" ng-if=\"cartInfo.isCartUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end p-r-30\" ng-if=\"!cartInfo.isCartUpdating && (cart.permissionObj.REMOVE_ITEM_FROM_CART || cart.nodePermissionObj.REMOVE_ITEM_FROM_CART)\"><div class=\"width-auto\"><i class=\"fa fa-trash fa-2x\" uib-tooltip=\"Remove Item\" ng-click=\"cart.fnRemoveItem(cartInfo)\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 m-t-30 d-flex justify-content-flex-end p-r-30\"><h2 class=\"m-0\"><span class=\"m-0\">${{(cartInfo.totalAmount/100).toFixed(2)}}</span></h2></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-flex-end p-r-30\" ng-if=\"cartInfo.discountPercent\"><h4 class=\"m-0\"><span class=\"m-0\">Discount: {{cartInfo.discountPercent}}% (${{(cartInfo.discountAmount/100).toFixed(2)}})</span></h4></div></div></div></div></div></div><div class=\"col-sm-4 h-100 p-0 d-flex\"><div class=\"col-sm-12 h-100 m-l-15 order-summary-card\"><div class=\"col-sm-12 p-0 p-t-15 p-b-30\"><label class=\"m-0\"><h2 class=\"m-0\">Order Summary</h2></label></div><div class=\"col-sm-12 p-0 p-r-5 overflow-auto order-summary-card-body\"><div class=\"col-sm-12 p-0 p-t-0 d-flex justify-content-space-between\"><h3 class=\"m-0\">{{cart.cartArr.cartItems.length}} items</h3><h3 class=\"m-0\">${{(cart.cartArr.subtotal/100).toFixed(2)}}</h3></div><div class=\"col-sm-12 p-0 p-t-30 d-flex justify-content-space-between\"><h3 class=\"m-0\">Taxes</h3><h3 class=\"m-0\">${{cart.cartArr.taxes ? (cart.cartArr.taxes/100).toFixed(2) : \"0.00\"}}</h3></div><div class=\"col-sm-12 p-0 p-t-30 d-flex justify-content-space-between\"><h3 class=\"m-0\">Total Cost</h3><h3 class=\"m-0\">${{(cart.cartArr.total/100).toFixed(2)}}</h3></div><div class=\"col-sm-12 p-0 p-t-30\" ng-if=\"!cart.isPaymentMethodLoading\"><h3 class=\"m-0 p-b-10\" ng-if=\"cart.paymentMethodArr.length\">Select Payment Method</h3><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\" ng-if=\"cart.paymentMethodArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\">XXXX-XXXX-XXXX-{{cart.selectedPaymentMethod.card.last4}}</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\" ng-repeat=\"paymentMethodObj in cart.paymentMethodArr\"><a ng-click=\"cart.selectedPaymentMethod = paymentMethodObj\"><div class=\"d-flex align-items-center\"><div><div><h3>XXXX-XXXX-XXXX-{{paymentMethodObj.card.last4}}</h3></div><div><h4>Valid Thru: {{paymentMethodObj.card.expiryMonth}}/{{paymentMethodObj.card.expiryYear}}</h4></div></div><div class=\"m-l-20\"><i class=\"fa fa-2x\" ng-class=\"cart.fnGetCreditCardClass(paymentMethodObj.card.brand)\"></i></div></div></a></li></ul></div><button class=\"btn btn-link p-0 pull-right\" ng-if=\"cart.permissionObj.REQUEST_NEW_PAYMENT_METHOD\" ui-sref=\"main.payment_method\" style=\"background: transparent\">Manage Payment Method</button></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\" ng-if=\"!cart.paymentMethodArr.length\"><h2 class=\"m-0\">There are no payment method found.</h2><button class=\"btn btn-primary v4-primary-button p-t-10 p-b-10 p-l-20 p-r-20 m-t-15\" ng-if=\"cart.permissionObj.REQUEST_NEW_PAYMENT_METHOD\" ui-sref=\"main.payment_method\">Manage Payment Method</button></div></div><div class=\"col-sm-12 p-0 p-t-30 d-flex justify-content-center align-items-center\" ng-if=\"cart.isPaymentMethodLoading\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0 p-t-15 p-b-15 d-flex justify-content-flex-end\"><button ng-if=\"!cart.isCartUpdating && (cart.permissionObj.CHECKOUT_CART || cart.nodePermissionObj.CHECKOUT_CART)\" ng-disabled=\"cart.fnCheckPaymentMethod() || !cart.cartArr.cartItems.length\" ng-click=\"cart.fnProceedToCheckout()\" class=\"btn btn-primary v4-primary-button p-t-10 p-b-10 p-l-20 p-r-20 m-r-10\">Proceed to Checkout</button><div ng-if=\"cart.isCartUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{cart.cartArr.cartItems && cart.cartArr.cartItems.length ? cart.cartArr.cartItems.length : 0}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : cart.isRefresh}\" ng-click=\"cart.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden\">Invite User</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/emailTemplate/emailTemplate.html","<div class=\"row h-100\" ng-init=\"emailTemplate.fnInitEmailTemplate();\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"emailTemplate.activeTabIndex\"><uib-tab index=\"1\" select=\"emailTemplate.fnTabChanged(emailTemplate.tabs[0])\" ng-click=\"emailTemplate.fnChangeTab(emailTemplate.tabs[0], true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"emailTemplate.tabs[0].title\"></div></div></div></uib-tab-heading></uib-tab><uib-tab sortable-tab=\"\" index=\"tab.tabIndex\" ng-repeat=\"tab in emailTemplate.tabs track by $index\" select=\"emailTemplate.fnTabChanged(tab)\" ng-click=\"emailTemplate.fnChangeTab(tab, true)\" ng-if=\"tab.tabIndex > 1\" ng-model=\"emailTemplate.customChangeEvent\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();emailTemplate.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"emailTemplate.fnGetEmailTemplateDashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!emailTemplate.isFullWidthDevice\"><a ng-click=\"emailTemplate.fnGetEmailTemplateStats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"emailTemplate.isFullWidthDevice\"><a ng-click=\"emailTemplate.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{emailTemplate.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"emailTemplate.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 p-t-10 p-b-10 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"emailTemplate.isFullWidthDevice && emailTemplate.isShowWidgets\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0\" id=\"service-dashboard\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'emailTemplate\'\" service-name=\"\'EmailTemplate\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"emailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"emailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"emailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\"><v4-search-client ng-if=\"emailTemplate.isRefreshData\" search-identifier=\"\'userSearch\'\" filters-arr=\"emailTemplate.searchFiltersArr\" filter-query=\"emailTemplate.filterQuery\" fn-filter-query-change=\"emailTemplate.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.emailTemplate\'\" fn-resize=\"emailTemplate.fnSetTableHeight()\" sort-field-arr=\"emailTemplate.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"emailTemplate.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"emailTemplate.isEmailTemplatesloading\" fn-resize=\"emailTemplate.fnSetLoaderTableHeight()\"></table-loader><div class=\"email-template-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!emailTemplate.isEmailTemplatesloading\"><thead><tr><th ng-if=\"emailTemplate.emailTemplateArr.length\" class=\"p-8\"></th><th ng-if=\"emailTemplate.emailTemplateArr.length\"><span>Name</span></th><th ng-if=\"emailTemplate.emailTemplateArr.length\"></th><th ng-if=\"!emailTemplate.emailTemplateArr.length\">No records found...</th></tr></thead><tbody id=\"emailTable\"><tr ng-repeat=\"emailTemplateObj in emailTemplate.emailTemplateArr track by $index\" ng-click=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"emailTemplateObj.isCheck\" ng-change=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div><label class=\"ellipsis m-b-0\" ng-bind=\"emailTemplateObj.name\"></label></div></td><td class=\"text-right\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': emailTemplate.isDropUp }\" ng-click=\"$event.stopPropagation(); emailTemplate.toggleDropUp(\'emailTable\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.fnCheckUncheckHeader(emailTemplateObj);\">Details</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!emailTemplate.isEmailTemplatesloading && emailTemplate.emailTemplateArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{emailTemplate.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 10; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 20; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 50; emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"emailTemplate.perPage = 100; emailTemplate.fnPageChanged(emailTemplate.currentPage,emailTemplate.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"emailTemplate.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"emailTemplate.currentPage\" items-per-page=\"emailTemplate.perPage\" max-size=\"emailTemplate.maxSize\" boundary-links=\"true\" ng-click=\"emailTemplate.fnPageChanged(emailTemplate.currentPage, emailTemplate.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{emailTemplate.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : emailTemplate.isRefresh}\" ng-click=\"emailTemplate.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" style=\"visibility: hidden;\">Invite EmailTemplate</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && emailTemplate.selectedEmailTemplatesArr.length === 1 && emailTemplate.selectedEmailTemplateObj && emailTemplate.isEmailTemplateDetailsLoaded && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><node-email-template-info email-template-obj=\"emailTemplate.selectedEmailTemplateObj\" user-permissions-obj=\"emailTemplate.permissionObj\"></node-email-template-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Emails</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"row h-100\"><div class=\"col-sm-12\"><h2>How it works</h2><div class=\"col-sm-12 h-100 dashboard-panel d-flex justify-content-center\"><div class=\"usecase-content d-flex flex-column align-items-center justify-content-center\"><div class=\"d-flex align-items-center\"><div class=\"position-r\" id=\"adduser\"><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/service/EmailTemplate.svg#emailTemplate\"></use></svg><div class=\"user-text-div\">Select an Email</div></div><div class=\"position-r\" id=\"email\"><div class=\"email-text-div\">Modify the template to suite your business</div><svg class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"30px\" height=\"30px\"><use xlink:href=\"assets/images/svg/edit.svg#editIcon\"></use></svg></div><div class=\"position-r\"><svg class=\"dashboard-pie-chart-img img-icon m-l-10 m-r-10\" width=\"35px\" height=\"35px\"><use xlink:href=\"assets/images/svg/email.svg#Capa_1\"></use></svg><div class=\"password-text-div m-t-15\" style=\"right: -40px\">System emails will be sent using your template</div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><h2>Use cases</h2><div class=\"col-sm-12 h-100 dashboard-panel\" style=\"min-height:285px\"><div class=\"usecase-content\"><h2>Internal Collaboration</h2><span class=\"f-s-12\">You can Create federations from within your organisation to manage and share resources and ressponsibilities. This might include NOC personnel, account managers, support staff, project managers etc.</span></div><div class=\"usecase-content\"><h2>External Collaboration</h2><span class=\"f-s-12\">You can Create federations from outside your organisation who provide services such as contractors or site technicians. Visibility into your account resources can be customized using security roles and groups.</span></div><div class=\"usecase-content m-b-15\"><h2>Client Visibility</h2><span class=\"f-s-12\">If you are managing resources for clients you can Create them and grant them visibility only into their resources.</span></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>Emails</span><br></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Emails are free in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Customize emails</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add permissions to users</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-12 p-r-15\">Add users to groups</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">Set how users sign in</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column\"><div class=\"col-sm-12 d-flex p-0 p-t-10 p-b-10 service-dashboard-stats-height\"><insight-service-dashboards class=\"w100\" app-key=\"\'node\'\" service-key=\"\'emailTemplate\'\" service-name=\"\'EmailTemplate\'\" app-name=\"\'Node\'\" fn-get-chart-detail=\"emailTemplate.fnOpenCreateIssueTab(chartObj)\" fn-get-chart-editor=\"emailTemplate.fnGetWidgetEditor()\" fn-hide-chart=\"emailTemplate.fnShowHideWidget()\"></insight-service-dashboards></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && emailTemplate.isShowWidgetEditor && !emailTemplate.isCreateIssue\"><widget-editor app-name=\"\'node\'\" service-display-name=\"\'Emails\'\" service-name=\"\'emailTemplate\'\"></widget-editor></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"emailTemplate.activeTabIndex !== 1 && !emailTemplate.isShowDashboard && !emailTemplate.isShowEmailTemplateStats && !emailTemplate.isShowWidgetEditor && emailTemplate.isCreateIssue\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"form-container\"><dashboard-create-issue app-key=\"\'node\'\" service-key=\"\'emailTemplate\'\" app-name=\"\'Node\'\"></dashboard-create-issue></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/access/authenticator/authenticatorInfo/authenticatorInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Authenticator</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{authenticatorObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{authenticatorObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{authenticatorObj.description ? authenticatorObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{authenticatorObj.description ? authenticatorObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{authenticatorObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(authenticatorObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/authenticator/createAuthenticator/createAuthenticator.html","<div class=\"container-with-out-footer\" ng-controller=\"createAuthenticatorCtrl as createAuthenticator\" ng-init=\"createAuthenticator.fnInitCreateAuthenticator()\"><div class=\"content-body modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"createAuthenticator.isTypesLoading\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput m-t-10\" ng-if=\"!createAuthenticator.isTypesLoading\"><form id=\"createNewAuthenticatorForm\" role=\"form\" name=\"createNewAuthenticatorForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createAuthenticator.newAuthenticatorObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewAuthenticatorForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createAuthenticator.newAuthenticatorObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewAuthenticatorForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"type\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"type as type.name for type in createAuthenticator.typesArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeTemplate.html\" typeahead-on-select=\"createAuthenticator.fnTypeSelected(createAuthenticator.selectedType)\" ng-change=\"!createAuthenticator.selectedType ? createAuthenticator.newAuthenticatorObj.typeId = \'\' : \'\'\" ng-model=\"createAuthenticator.selectedType\" placeholder=\"Select a Type*\" name=\"type\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewAuthenticatorForm.type.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Type*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo p-r-30\" ng-if=\"createAuthenticator.selectedType\"><span>({{createAuthenticator.selectedType.id}})</span></span></div><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"Vault\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"vault as vault.name for vault in createAuthenticator.vaultsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"VaultTemplate.html\" typeahead-on-select=\"createAuthenticator.fnVaultSelected(createAuthenticator.selectedVault)\" ng-change=\"!createAuthenticator.selectedVault ? createAuthenticator.newAuthenticatorObj.vaultId = \'\' : \'\'\" ng-model=\"createAuthenticator.selectedVault\" placeholder=\"Select a Vault*\" name=\"vault\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewAuthenticatorForm.vault.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Vault*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo p-r-30\" ng-if=\"createAuthenticator.selectedVault\"><span>({{createAuthenticator.selectedVault.id}})</span></span></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createAuthenticator.newAuthenticatorObj.name.length || !createAuthenticator.newAuthenticatorObj.typeId || !createAuthenticator.newAuthenticatorObj.vaultId\" ng-if=\"!createAuthenticator.isAuthenticatorCreating\" ng-click=\"createAuthenticator.fnCreateNewAuthenticator(createAuthenticator.newAuthenticatorObj)\">Create Authenticator</button></div><div class=\"col-sm-12\" ng-if=\"createAuthenticator.isAuthenticatorCreating\"><div class=\"pull-right m-r-20\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <span ng-bind-html=\"match.model.name\"></span> </a></script><script type=\"text/ng-template\" id=\"VaultTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>{{match.model.id}}</span></small> </div> <br> </div> </a></script></div>");
$templateCache.put("app/access/emailTemplate/emailTemplateInfo/emailTemplateInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Email</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{emailTemplateObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{emailTemplateObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/federation/createFederation/createFederation.html","<div ng-controller=\"createFederationCtrl as createFederation\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewFederationForm\" role=\"form\" name=\"createNewFederationForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"alias\" type=\"text\" ng-model=\"createFederation.newfederationObj.alias\" placeholder=\"Name*\" name=\"alias\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewFederationForm.alias.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Alias*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createFederation.newfederationObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewFederationForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"accoundId\" type=\"text\" ng-model=\"createFederation.newfederationObj.accountId\" placeholder=\"ID of an OUTBOUND Account.*\" name=\"idOutbound\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewFederationForm.idOutbound.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Account ID*</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createNewFederationForm.$valid\" ng-click=\"createFederation.fnCreateNewFederation(createFederation.newfederationObj)\" ng-if=\"!createFederation.isFederationCreating\">Create Federation</button></div><div class=\"col-sm-12\" ng-if=\"createFederation.isFederationCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Federation</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{federationObj.alias}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{federationObj.alias}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{federationObj.description ? federationObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{federationObj.description ? federationObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{federationObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" ng-if=\"tab.visible === true\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/script/scriptInfo/scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/team/createTeam/createTeam.html","<div ng-controller=\"createTeamCtrl as createTeam\" ng-init=\"createTeam.fnInit()\"><div class=\"modal-body\" id=\"createSecurityGroup-modal-body\"><div class=\"row security-group\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createTeam.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 55.25 55.25\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M52.618,2.631c-3.51-3.508-9.219-3.508-12.729,0L3.827,38.693C3.81,38.71,3.8,38.731,3.785,38.749 c-0.021,0.024-0.039,0.05-0.058,0.076c-0.053,0.074-0.094,0.153-0.125,0.239c-0.009,0.026-0.022,0.049-0.029,0.075 c-0.003,0.01-0.009,0.02-0.012,0.03l-3.535,14.85c-0.016,0.067-0.02,0.135-0.022,0.202C0.004,54.234,0,54.246,0,54.259 c0.001,0.114,0.026,0.225,0.065,0.332c0.009,0.025,0.019,0.047,0.03,0.071c0.049,0.107,0.11,0.21,0.196,0.296 c0.095,0.095,0.207,0.168,0.328,0.218c0.121,0.05,0.25,0.075,0.379,0.075c0.077,0,0.155-0.009,0.231-0.027l14.85-3.535 c0.027-0.006,0.051-0.021,0.077-0.03c0.034-0.011,0.066-0.024,0.099-0.039c0.072-0.033,0.139-0.074,0.201-0.123 c0.024-0.019,0.049-0.033,0.072-0.054c0.008-0.008,0.018-0.012,0.026-0.02l36.063-36.063C56.127,11.85,56.127,6.14,52.618,2.631z M51.204,4.045c2.488,2.489,2.7,6.397,0.65,9.137l-9.787-9.787C44.808,1.345,48.716,1.557,51.204,4.045z M46.254,18.895l-9.9-9.9 l1.414-1.414l9.9,9.9L46.254,18.895z M4.961,50.288c-0.391-0.391-1.023-0.391-1.414,0L2.79,51.045l2.554-10.728l4.422-0.491 l-0.569,5.122c-0.004,0.038,0.01,0.073,0.01,0.11c0,0.038-0.014,0.072-0.01,0.11c0.004,0.033,0.021,0.06,0.028,0.092 c0.012,0.058,0.029,0.111,0.05,0.165c0.026,0.065,0.057,0.124,0.095,0.181c0.031,0.046,0.062,0.087,0.1,0.127 c0.048,0.051,0.1,0.094,0.157,0.134c0.045,0.031,0.088,0.06,0.138,0.084C9.831,45.982,9.9,46,9.972,46.017 c0.038,0.009,0.069,0.03,0.108,0.035c0.036,0.004,0.072,0.006,0.109,0.006c0,0,0.001,0,0.001,0c0,0,0.001,0,0.001,0h0.001 c0,0,0.001,0,0.001,0c0.036,0,0.073-0.002,0.109-0.006l5.122-0.569l-0.491,4.422L4.204,52.459l0.757-0.757 C5.351,51.312,5.351,50.679,4.961,50.288z M17.511,44.809L39.889,22.43c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 L16.097,43.395l-4.773,0.53l0.53-4.773l22.38-22.378c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L10.44,37.738 l-3.183,0.354L34.94,10.409l9.9,9.9L17.157,47.992L17.511,44.809z M49.082,16.067l-9.9-9.9l1.415-1.415l9.9,9.9L49.082,16.067z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createTeam.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 512.001 512.001\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon m-t-3 m-l-3\"><g><path d=\"m408 184h-136c-4.417969 0-8-3.582031-8-8v-136c0-22.089844-17.910156-40-40-40s-40 17.910156-40 40v136c0 4.417969-3.582031 8-8 8h-136c-22.089844 0-40 17.910156-40 40s17.910156 40 40 40h136c4.417969 0 8 3.582031 8 8v136c0 22.089844 17.910156 40 40 40s40-17.910156 40-40v-136c0-4.417969 3.582031-8 8-8h136c22.089844 0 40-17.910156 40-40s-17.910156-40-40-40zm0 0\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createTeam.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 510 510\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\" style=\"margin-left: -1px;\"><g><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\"></path></g></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createTeam.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Details</h3></div><div class=\"col-sm-12 p-0 p-t-30 floatingLabelInput\"><form id=\"createNewGroupForm\" role=\"form\" name=\"createNewGroupForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTeam.newTeamObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewGroupForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createTeam.newTeamObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewGroupForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createTeam.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Add Resource</h3></div><div class=\"col-sm-12 p-0 p-t-10\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 AiBranchInput\"><uib-accordion close-others=\"false\"><uib-accordion-group class=\"m-t-20\" is-open=\"app.open\" ng-repeat=\"app in createTeam.securityGroupArr track by $index\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2 d-flex\"><div><span>{{app.title}}</span></div></div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !app.open, \'fa-angle-up\': app.open}\"></i><div class=\"col-sm-1 fa pull-right\"></div></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-4 m-b-4\" ng-repeat=\"subapp in app.subapp track by $index\"><div class=\"d-flex\"><input type=\"checkbox\" id=\"subappchk_{{$index + subapp.name + subapp.type}}\" ng-model=\"subapp.isChecked\" ng-change=\"createTeam.fnCheckUncheckApps(subapp, subapp.isChecked)\" ng-click=\"subapp.isChecked && createTeam.openModal(subapp)\"> <label for=\"subappchk_{{$index + subapp.name + subapp.type}}\" class=\"check-box\"></label><div class=\"m-l-5\" style=\"margin-top: -2px;\"><label>{{subapp.name}}</label></div></div></div></div></uib-accordion-group></uib-accordion></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createTeam.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Review</h3></div><div class=\"col-sm-12 p-0 p-t-20\"><div class=\"col-sm-12 p-0\">Please review all the team setting for this team. Once you have created it you can associate it either directly with a user or with a group of users.</div><div class=\"col-sm-12 p-0 p-t-20\" id=\"functionModal\"><div class=\"col-sm-12 p-0\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><h3 class=\"m-0\"><span class=\"p-b-5 ellipsis\">{{createTeam.newTeamObj.name}}</span></h3><h5 class=\"m-0 font-italic\"><span class=\"p-b-5 ellipsis\">{{createTeam.newTeamObj.description}}</span></h5></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><div class=\"col-sm-12 p-0 d-flex justify-content-start align-items-center\"><label>Selected Resources</label></div><div class=\"col-sm-12 p-0 m-t-10 d-flex\" style=\"min-height: 100px;border: 2px dashed;\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-12 p-0 d-flex justify-content-center p-t-30 p-b-30 flex-column\"><div class=\"col-sm-12 p-0 d-flex align-items-center p-l-30 justify-content-start\" ng-class=\"!$last ?\'p-b-10\' :\'\'\" ng-repeat=\"resource in createTeam.resourceArr\"><div class=\"m-r-10\"><svg viewbox=\"0 0 512.001 512.001\" width=\"20px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"m361.480469 309.242188-17.652344 9.777343c-3.625 2.011719-4.933594 6.574219-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226562 0 2.476562-.300781 3.628906-.9375l17.652344-9.78125c3.621094-2.007812 4.933594-6.574219 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m361.480469 287.960938-17.652344 9.777343c-3.625 2.007813-4.9375 6.574219-2.925781 10.199219 1.367187 2.46875 3.925781 3.863281 6.566406 3.863281 1.226562 0 2.476562-.300781 3.625-.9375l17.65625-9.78125c3.621094-2.007812 4.933594-6.570312 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m485.9375 377.816406c.71875-1.171875 1.121094-2.550781 1.121094-3.929687v-65.980469c0-4.144531-3.359375-7.5-7.503906-7.5-4.140626 0-7.5 3.355469-7.5 7.5v54.425781l-72.121094-32.167969v-139.367187l72.121094-39.957031v124.40625c0 4.144531 3.359374 7.5 7.5 7.5 4.144531 0 7.503906-3.355469 7.503906-7.5v-137.136719c0-2.675781-1.523438-5.261719-3.867188-6.558594l-235.777344-130.625c-2.238281-1.234375-5.03125-1.234375-7.269531 0l-235.777343 130.625c-2.382813 1.316407-3.898438 3.929688-3.867188 6.648438v235.6875c0 2.679687 1.519531 5.261719 3.867188 6.5625l103.882812 57.554687c3.625 2.003906 8.1875.695313 10.195312-2.925781 2.007813-3.625.695313-8.191406-2.925781-10.195313l-90.734375-50.269531 69.972656-31.207031 141.519532 78.402344v69.972656l-91.011719-50.417969c-3.621094-2.007812-8.1875-.699219-10.195313 2.925781-2.007812 3.621094-.695312 8.1875 2.925782 10.195313l102.148437 56.589844c2.226563 1.234375 5.042969 1.234375 7.269531 0l107.128907-59.355469c3.625-2.007812 4.933593-6.570312 2.925781-10.195312-2.003906-3.621094-6.570312-4.933594-10.195312-2.925782l-95.996094 53.183594v-69.972656l141.519531-78.402344 69.972656 31.207031-85.769531 47.519531c-3.625 2.007813-4.933594 6.570313-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226563 0 2.476563-.304687 3.628906-.941406l98.921875-54.804687c1.109375-.613281 2.082032-1.554688 2.746094-2.632813zm-242.160156-265.222656 133.179687 73.785156-133.179687 73.78125-133.175782-73.78125zm148.65625 65.210938-141.15625-78.203126v-79.386718l212.800781 117.894531zm-156.15625-78.203126-141.152344 78.203126-71.648438-39.695313 212.800782-117.894531zm-220.777344 51.238282 72.121094 39.957031v139.367187l-72.121094 32.167969zm87.125 48.269531 54.441406 30.160156 79.210938 43.886719v131.503906l-133.652344-74.046875zm148.652344 74.046875 133.65625-74.046875v131.503906l-133.65625 74.046875zm0 0\"></path></svg></div><div><label class=\"m-0\">{{resource.service}} ({{resource.id}})</label></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-l-30\" ng-if=\"!createTeam.resourceArr.length\"><label class=\"m-0\">No Resources</label></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><input type=\"button\" class=\"btn btn-primary pull-right\" value=\"Create Team\" ng-disabled=\"!createTeam.newTeamObj.name.length\" ng-click=\"createTeam.fnCreateNewTeam(createTeam.newTeamObj)\" ng-if=\"createTeam.activeStep === 3 && !createTeam.isTeamCreating\"><div class=\"col-sm-12 m-t-3\" ng-if=\"createTeam.isTeamCreating\"><div class=\"pull-right m-r-0\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!createTeam.isTeamCreating\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left\" ng-if=\"createTeam.activeStep !== 1\" ng-click=\"createTeam.fnGotoPreviousStep()\">Back</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createTeam.activeStep === 1\" ng-disabled=\"!createTeam.newTeamObj.name.length\" ng-click=\"createTeam.fnGotoNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createTeam.activeStep === 2\" ng-click=\"createTeam.fnGotoNextStep()\">Next</button></div></div></div></div>");
$templateCache.put("app/access/team/teamInfo/teamInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Team</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{teamObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{teamObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{teamObj.description ? teamObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{teamObj.description ? teamObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{teamObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(teamObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/users/createUser/createUser.html","<div ng-controller=\"createUserModalCtrl as userModal\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewUserForm\" role=\"form\" name=\"createNewUserForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" ng-model=\"userModal.newUserObj.firstName\" placeholder=\"First name*\" name=\"firstName\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewUserForm.firstName.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>First Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"lastName\" type=\"text\" ng-model=\"userModal.newUserObj.lastName\" placeholder=\"Last name*\" name=\"lastName\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewUserForm.lastName.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Last Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input\" ng-class=\"createNewUserForm.username.$error.pattern && createNewUserForm.username.$dirty ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" name=\"username\" required=\"\" id=\"UserName\" type=\"text\" ng-pattern=\"/^[A-Za-z0-9_]+$/\" ng-model=\"userModal.newUserObj.username\" placeholder=\"Username*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewUserForm.username.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Username*</label> <small class=\"helper-text-error\" ng-show=\"createNewUserForm.username.$error.pattern && createNewUserForm.username.$dirty\"><span class=\"errorText\">Username may contain a-z, A-Z, 0-9 and the _(underscore) characters only and must be unique.</span></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" name=\"email\" ng-pattern=\"userModal.emailPattern\" ng-model=\"userModal.newUserObj.email\" placeholder=\"Email*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewUserForm.email.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <small class=\"helper-text-error\" ng-show=\"createNewUserForm.email.$error.pattern && createNewUserForm.email.$dirty\"><span class=\"errorText\">Please enter valid email address.</span></small> <label>Email*</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createNewUserForm.$valid\" ng-click=\"userModal.fnCreateNewUser(userModal.newUserObj)\" ng-if=\"!userModal.isUserCreating\">Invite User</button></div><div class=\"col-sm-12\" ng-if=\"userModal.isUserCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/access/team/modal/resourceModal.html","<div class=\"form-content h-100\" ng-init=\"resourceModal.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Select Resource</h3></div><div class=\"modal-body\" id=\"resource-modal-body\" style=\"overflow: hidden;\"><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'resourceModal\'\" filters-arr=\"resourceModal.searchFiltersArr\" filter-query=\"resourceModal.filterQuery\" fn-filter-query-change=\"resourceModal.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.securityGroups\'\" no-set-url=\"true\" fn-resize=\"resourceModal.fnSetTableHeight()\" sort-field-arr=\"resourceModal.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"resourceModal.isDataLoading\" hide-circle=\"true\" fn-resize=\"resourceModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"securityGroups-table table-container\" id=\"securityGroupResourceModal\"><table class=\"table table-striped table-check-box\" ng-if=\"!resourceModal.isDataLoading\"><thead><tr><th ng-if=\"resourceModal.dataArr.length\" class=\"p-8\"></th><th ng-if=\"resourceModal.dataArr.length\"></th><th ng-if=\"resourceModal.dataArr.length\"><span>Name</span></th><th ng-if=\"resourceModal.dataArr.length\"></th><th ng-if=\"!resourceModal.dataArr.length\">No records found...</th></tr></thead><tbody id=\"userTable\"><tr ng-repeat=\"resource in resourceModal.dataArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"resource.isCheck\" ng-change=\"resourceModal.fnCheckUncheckHeader(resource, resource.isCheck)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" height=\"30\" width=\"30\" ng-src=\"{{resourceModal.fnReturnUserImg(resource)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"resource.firstName + \' \' + resource.lastName\" style=\"width: fit-content !important;\"></label></div><span class=\"ellipsis\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"resource.username\"></span> <span class=\"discDot\" ng-hide=\"!resource.email\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" ng-bind=\"resource.email\"></span></span></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{resource.state}}\" tooltip-placement=\"auto\" ng-style=\"resourceModal.getUserStateColor(resource.state)\"><span class=\"fa stateIcon\" ng-class=\"resourceModal.fnGetUserStateIcon(resource.state)\"></span></span></td></tr></tbody></table><div class=\"pagination-container\" ng-if=\"!resourceModal.isDataLoading && resourceModal.dataArr.length\"><div class=\"row m-b-15\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{resourceModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"resourceModal.perPage = 1; resourceModal.fnPageChanged(resourceModal.currentPage, resourceModal.perPage, true)\">1</a></li><li><a class=\"btn btn-link\" ng-click=\"resourceModal.perPage = 10; resourceModal.fnPageChanged(resourceModal.currentPage, resourceModal.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"resourceModal.perPage = 20; resourceModal.fnPageChanged(resourceModal.currentPage, resourceModal.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"resourceModal.perPage = 50; resourceModal.fnPageChanged(resourceModal.currentPage, resourceModal.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"resourceModal.perPage = 100; resourceModal.fnPageChanged(resourceModal.currentPage,resourceModal.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"resourceModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"resourceModal.currentPage\" items-per-page=\"resourceModal.perPage\" max-size=\"resourceModal.maxSize\" boundary-links=\"true\" ng-click=\"resourceModal.fnPageChanged(resourceModal.currentPage, resourceModal.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-click=\"resourceModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"resourceModal.fnSave()\" ng-disabled=\"!resourceModal.resourceId.length\">Add</button></div></div>");
$templateCache.put("app/access/users/modal/updateUserRoleModal.html","<div class=\"form-content h-100\" ng-init=\"updateUserRoleModal.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Update {{updateUserRoleModal.userRoleType}} Role</h3></div><div class=\"modal-body\" id=\"resource-modal-body\" style=\"overflow: hidden;\"><div class=\"col-sm-12 p-0\"><h3>{{updateUserRoleModal.userObj.firstName + \" \" + updateUserRoleModal.userObj.lastName}} {{updateUserRoleModal.userRoleType}} Role:</h3></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-10 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\">{{updateUserRoleModal.selectedRole}}</span> <label class=\"titleLabel\">Role*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"roleOption in updateUserRoleModal.userRoleOptions\"><a ng-click=\"updateUserRoleModal.selectedRole = roleOption.id\"><span>{{roleOption.displayName}}</span></a></li></ul></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"!updateUserRoleModal.isUserUpdating\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-click=\"updateUserRoleModal.fnCancel()\">Close</button> <button type=\"button\" ng-if=\"!updateUserRoleModal.isUserUpdating\" class=\"btn btn-primary v4-primary-button\" ng-click=\"updateUserRoleModal.fnSave()\">Update Role</button><div class=\"pull-right\" ng-if=\"updateUserRoleModal.isUserUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/access/vault/createVault/createVault.html","<div class=\"container-with-out-footer col-sm-12\" ng-controller=\"createVaultCtrl as createVault\"><div class=\"col-sm-12 p-0 m-0 p-t-15 p-b-15\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\" style=\"right: -4px\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"createVault.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{createVault.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div><div class=\"content-body modal-body floatingLabelInput\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 m-t-10\"><form id=\"createNewVaultForm\" role=\"form\" name=\"createNewVaultForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createVault.newVaultObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createVault.newVaultObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 m-t-0 p-0\" ng-repeat=\"kvpPair in createVault.vaultKVPArr track by $index\" ng-if=\"!createVault.isAdvancedOption\"><div class=\"md-input m-b-20 p-0 p-r-10 col-sm-5\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"text\" ng-model=\"kvpPair.key\" ng-change=\"createVault.fnKvpPairChange(kvpPair, $index)\" placeholder=\"Key\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 p-0 col-sm-6\"><strong class=\"md-input-icon\" ng-click=\"createVault.hideShowPassword(kvpPair)\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"kvpPair.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control p-r-30\" id=\"value\" type=\"{{kvpPair.inputType}}\" required=\"\" ng-model=\"kvpPair.value\" ng-change=\"createVault.fnKvpPairChange(kvpPair, $index)\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-1\"><button ng-if=\"$index !== 0\" class=\"btn btn-link m-t-5\"><i class=\"fa fa-trash-o fa-lg\" ng-click=\"createVault.fnRemoveKvpPair($index)\"></i></button></div></div><div class=\"col-sm-12 m-t-0 p-0 m-b-15\" ng-if=\"createVault.isAdvancedOption\"><ui-codemirror ng-model=\"createVault.vaultContentObj\" ui-codemirror-opts=\"createVault.editorOptions\"></ui-codemirror></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createVault.newVaultObj.name.length\" ng-click=\"createVault.fnCreateNewVault(createVault.newVaultObj, createVault.vaultKVPArr)\" ng-if=\"!createVault.isVaultCreating\">Create Vault</button></div><div class=\"col-sm-12\" ng-if=\"createVault.isVaultCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/access/vault/modal/vaultAuthenticatorModal.html","<div class=\"inmodal h-100\" ng-init=\"vAModal.fnInitVaultModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Functions</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div ng-if=\"!vAModal.isFunctionSelected\" id=\"functionModal\"><div class=\"col-sm-6\" ng-repeat=\"obj in vAModal.functionsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vAModal.fnInject(obj)\">Inject</button></div><h3 class=\"m-t-9\"><span>{{obj.name}}</span></h3></div><div class=\"panel-body\" style=\"height: 170px;\"><span>{{obj.description}}</span></div></div></div></div><div ng-if=\"vAModal.isFunctionSelected\"><div ng-if=\"vAModal.functionType !== \'\'\"><span><h3>{{vAModal.functionType}}</h3></span></div><div ng-if=\"!vAModal.isDetailsLoaded\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"!vAModal.isDetailsLoaded\"></app-spinner></div><div ng-if=\"vAModal.isDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-20 floatingLabelInput\"><div class=\"md-input m-b-10 pace\"><input class=\"md-form-control\" id=\"category\" type=\"text\" required=\"\" ng-model=\"vAModal.secretKey\"> <span class=\"highlight\"></span> <label>Secret (base32)</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><label>QR Code</label></div><div class=\"col-sm-12 p-0\"><img style=\"border: 3px solid;\" ng-src=\"{{vAModal.img}}\"></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"vAModal.isFunctionSelected\" class=\"btn btn-link pull-left\" ng-click=\"vAModal.fnBackToFunctions()\">Back</button> <button ng-if=\"!vAModal.isGettingGhostValues\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vAModal.fnCancel()\">Cancel</button> <button ng-if=\"vAModal.isFunctionSelected\" type=\"button\" class=\"btn btn-primary\" ng-click=\"vAModal.fnClose()\">Inject</button></div></div><script type=\"text/ng-template\" id=\"typeAheadTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <span ng-if=\"match.model.name\" ng-bind-html=\"match.model.name\"></span><br ng-if=\"match.model.name\"> <small ng-bind-html=\"match.model.id\"></small> </div> </a></script>");
$templateCache.put("app/access/vault/vaultInfo/vaultInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Vault</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{vaultObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{vaultObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{vaultObj.description ? vaultObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{vaultObj.description ? vaultObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{vaultObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(vaultObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/ai/deployment/createDeployment/createDeployment.html","<div ng-controller=\"createDeploymentCtrl as createDeployment\" ng-init=\"createDeployment.fnInitCreateDeployment()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createDeployment.title}}</h3><button ng-if=\"deployment.deploymentPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"deployment.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"createDeployment.isCreateFormLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"!createDeployment.isCreateFormLoading\"><form id=\"createNewDeploymentForm\" role=\"form\" name=\"createNewDeploymentForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createDeployment.newDeploymentObj.name\" placeholder=\"Name for the new Deployment*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createDeployment.newDeploymentObj.description\" placeholder=\"Description regarding Deployment\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\" ng-if=\"createDeployment.distributionPermissionObj.List\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"distributionObj as distributionObj.name for distributionObj in createDeployment.distributionsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"distributionTemplate.html\" ng-change=\"!createDeployment.selectedDistribution ? createDeployment.newDeploymentObj.distributionId = \'\' : \'\'\" typeahead-on-select=\"createDeployment.fnSelectDistribution(createDeployment.selectedDistribution)\" ng-model=\"createDeployment.selectedDistribution\" placeholder=\"Distribution for the Deployment*\"> <label>Distribution*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createDeployment.selectedDistribution.id\"><span>({{createDeployment.selectedDistribution.id}})</span></span></div><div class=\"md-input m-b-20\" ng-if=\"!createDeployment.distributionPermissionObj.List\"><input class=\"md-form-control\" required=\"\" id=\"did\" type=\"text\" ng-model=\"createDeployment.newDeploymentObj.distributionId\" placeholder=\"Distribution Id for the Deployment*\"> <span class=\"highlight\"></span> <label>Distribution Id*</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createDeployment.newDeploymentObj.name.length || !createDeployment.newDeploymentObj.distributionId.length\" ng-if=\"!createDeployment.isDeploymentCreating\" ng-click=\"createDeployment.fnCreateNewDeployment(createDeployment.newDeploymentObj)\">Create Deployment</button></div><div class=\"col-sm-12\" ng-if=\"createDeployment.isDeploymentCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"distributionTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-10\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right\"> <span ng-bind-html=\"match.model.id\"></span> </div> <br> </a></script>");
$templateCache.put("app/ai/deployment/deploymentInfo/deploymentInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/ai/distribution/createDistribution/createDistribution.html","<div ng-controller=\"createDistributionCtrl as createDistribution\" ng-init=\"createDistribution.fnInitCreateDistribution()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createDistribution.title}}</h3><button ng-if=\"distribution.distributionPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"distribution.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"createDistribution.isCreateFormLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"!createDistribution.isCreateFormLoading\"><form id=\"createNewModelForm\" role=\"form\" name=\"createNewModelForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createDistribution.newDistributionObj.name\" placeholder=\"Name for the new Distribution*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createDistribution.newDistributionObj.description\" placeholder=\"Description regarding Distribution\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-l-0\"><h3>Divergences</h3></div><div class=\"col-sm-12\"><div ng-repeat=\"divergencesObj in createDistribution.divergences track by $index\"><div class=\"m-l-20 m-b-10\"><label>{{$index+1 + \'. \' + divergencesObj.name.charAt(0).toUpperCase() + divergencesObj.name.substr(1);}}</label></div><div class=\"m-l-35\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"divergencesObj.name\" placeholder=\"Name for the Divergence*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"divergencesObj.description\" placeholder=\"Description regarding Divergence\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\" ng-if=\"createDistribution.modelPermissionObj.List\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"modelObj as modelObj.name for modelObj in createDistribution.modelsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"algorithmTemplate.html\" typeahead-on-select=\"createDistribution.fnSelectModel(divergencesObj)\" ng-model=\"divergencesObj.selectedModel\" placeholder=\"Model for Divergence*\"> <label>Model*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"divergencesObj.modelId\"><span>({{divergencesObj.modelId}})</span></span></div><div class=\"md-input m-b-20\" ng-if=\"!createDistribution.modelPermissionObj.List\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"divergencesObj.modelId\" placeholder=\"Model ID for Divergence*\"> <label>Model*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"algoVms as algoVms.name for algoVms in createDistribution.algoVmsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"algorithmTemplate.html\" typeahead-on-select=\"createDistribution.fnVmsSelected(divergencesObj)\" ng-model=\"divergencesObj.selectedVms\" placeholder=\"Virtual Machine for Divergence*\"> <span class=\"highlight\"></span> <label>Virtual Machine*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"divergencesObj.virtualMachineId\"><span>({{divergencesObj.virtualMachineId}})</span></span></div><div class=\"md-input m-b-20\" ng-class=\"createDistribution.vmDivergenceCountErrorMessage.length?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" type=\"number\" required=\"\" min=\"0\" ng-change=\"createDistribution.fnChangeVmCount(divergencesObj.virtualMachineCount)\" ng-model=\"divergencesObj.virtualMachineCount\" placeholder=\"Virtual Machine Quantity for Divergence*\"> <span class=\"highlight\"></span> <label>Virtual Machine Quantity*</label> <small class=\"helper-text-error\" ng-show=\"createDistribution.vmDivergenceCountErrorMessage.length\"><span class=\"errorText\">{{createDistribution.vmDivergenceCountErrorMessage}}</span></small></div></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createDistribution.fnAddNewDivergence()\">Add New Divergence</button></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"createDistribution.fnCheckDistributionValidity()\" ng-if=\"!createDistribution.isDistributionCreating\" ng-click=\"createDistribution.fnCreateNewDistribution(createDistribution.newDistributionObj)\">Create Distribution</button></div><div class=\"col-sm-12\" ng-if=\"createDistribution.isDistributionCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"algorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-10\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right\"> <span ng-bind-html=\"match.model.id\"></span> </div> <br> </a></script>");
$templateCache.put("app/ai/distribution/distributionInfo/distributionInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/ai/model/createModel/createModel.html","<div ng-controller=\"createModelCtrl as createModel\" ng-init=\"createModel.fnInitCreateModel()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createModel.title}}</h3><button ng-if=\"model.modelPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"model.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createModel.isAlgorithmsFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"createModel.isAlgorithmsFetched\"><form id=\"createNewModelForm\" role=\"form\" name=\"createNewModelForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createModel.newModelObj.name\" placeholder=\"Name for the new Model*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createModel.newModelObj.description\" placeholder=\"Description regarding Model\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"algorithm as algorithm.name for algorithm in createModel.algorithmsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"AlgorithmTemplate.html\" typeahead-on-select=\"createModel.fnAlgorithmSelected(createModel.selectedAlgorithm)\" ng-model=\"createModel.selectedAlgorithm\" placeholder=\"Select a Algorithm*\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createModel.selectedAlgorithm\"><span>({{createModel.selectedAlgorithm.id}})</span></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"storagePath\" type=\"text\" ng-model=\"createModel.newModelObj.artifactPath\" placeholder=\"Artifact Path for the Model*\"> <span class=\"highlight\"></span> <label>Artifact Path*</label> <small class=\"helper-text\"><button class=\"btn btn-link p-l-0 p-0\" ng-if=\"createModel.contentPermissionObj.List\" ng-click=\"createModel.fnAddStorageOutputPath()\"><small>Choose Artifact Path</small></button></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createModel.newModelObj.name.length || !createModel.newModelObj.algorithmId.length || !createModel.newModelObj.artifactPath.length\" ng-click=\"createModel.fnCreateNewModel(createModel.newModelObj)\" ng-if=\"!createModel.isModelCreating\">Create Model</button></div><div class=\"col-sm-12\" ng-if=\"createModel.isModelCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"AlgorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script>");
$templateCache.put("app/ai/model/createModel/createModelFromTrainer.html","<div ng-controller=\"createModelCtrl as createModel\" ng-init=\"createModel.fnInitCreateModelFromTrainer()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createModel.title}}</h3><button ng-if=\"model.modelPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"model.fnHideShowCreateForm(true)\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createModel.isAlgorithmsFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"createModel.isAlgorithmsFetched\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"trainerObj as trainerObj.name for trainerObj in createModel.trainersArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"AlgorithmTemplate.html\" typeahead-on-select=\"createModel.fnSelectTrainer(createModel.selectedTrainerObj)\" ng-model=\"createModel.selectedTrainerObj\" placeholder=\"Select a Trainer*\"> <span class=\"highlight\"></span> <label>Trainer*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createModel.selectedTrainerObj\"><span>({{createModel.selectedTrainerObj.id}})</span></span></div></div><div class=\"col-sm-12 m-t-0 floatingLabelInput\" ng-if=\"createModel.selectedTrainerObj\"><form id=\"createNewModelForm\" role=\"form\" name=\"createNewModelForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createModel.newModelObj.name\" placeholder=\"Name for the new Model*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createModel.newModelObj.description\" placeholder=\"Description regarding Model\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"blueprintAlgo\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"algorithm as algorithm.name for algorithm in createModel.algorithmsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"AlgorithmTemplate.html\" typeahead-on-select=\"createModel.fnAlgorithmSelected(createModel.selectedAlgorithm)\" ng-model=\"createModel.selectedAlgorithm\" placeholder=\"Select a Algorithm*\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createModel.selectedAlgorithm\"><span>({{createModel.selectedAlgorithm.id}})</span></span></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"storagePath\" type=\"text\" ng-model=\"createModel.newModelObj.artifactPath\" placeholder=\"Artifact Path for the Model*\"> <span class=\"highlight\"></span> <label>Artifact Path*</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createModel.newModelObj.name.length\" ng-click=\"createModel.fnCreateNewModel(createModel.newModelObj)\" ng-if=\"!createModel.isModelCreating\">Create Model</button></div><div class=\"col-sm-12\" ng-if=\"createModel.isModelCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"AlgorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script>");
$templateCache.put("app/ai/model/modelInfo/modelInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/ai/trainer/createTrainer/createTrainer.html","<div ng-controller=\"createTrainerCtrl as createTrainer\" ng-init=\"createTrainer.fnInitCreateTrainer()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createTrainer.title}}</h3><button ng-if=\"trainer.trainerPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"trainer.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12 m-t-15\" ng-if=\"createTrainer.isCreateFormLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 wizard\" ng-if=\"!createTrainer.isCreateFormLoading\"><wizard on-finish=\"createTrainer.finishedWizard()\" indicators-position=\"top\"><wz-step wz-title=\"1. Algorithm\"><div ng-include=\"\'app/ai/trainer/createTrainer/steps/algorithm.html\'\"></div></wz-step><wz-step wz-title=\"2. Parameters\"><div ng-include=\"\'app/ai/trainer/createTrainer/steps/parameters.html\'\"></div></wz-step><wz-step wz-title=\"3. Branches\"><div ng-include=\"\'app/ai/trainer/createTrainer/steps/branches.html\'\"></div></wz-step><wz-step wz-title=\"4. Settings\"><div ng-include=\"\'app/ai/trainer/createTrainer/steps/settings.html\'\"></div></wz-step><wz-step wz-title=\"5. Review\"><div ng-include=\"\'app/ai/trainer/createTrainer/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div><script type=\"text/ng-template\" id=\"algorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-10\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right\"> <span ng-bind-html=\"match.model.id\"></span> </div> <br> </a></script><script type=\"text/ng-template\" id=\"VmsTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <br> </div> </a></script>");
$templateCache.put("app/ai/trainer/modals/inputoutputModel.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"inputOutputPathModel.fnInitModel()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Select Storage Path\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"storage-breadcrumb\"><ul class=\"breadcrumb\" ng-if=\"!inputOutputPathModel.filterQuery.length\"><li ng-repeat=\"pathName in inputOutputPathModel.breadcrumbArray track by $index\"><a class=\"link-dk-primary\" ng-click=\"inputOutputPathModel.fnGetPath(pathName, $index)\"><i ng-if=\"pathName === \'/\'\" class=\"fa fa-home\"></i>{{pathName === \'/\' ? \'\' : pathName}}</a></li></ul></div><storage-search-directive ng-if=\"inputOutputPathModel.contentPermissionObj.List\" field-arr=\"inputOutputPathModel.searchFieldArr\" filter-query=\"inputOutputPathModel.filterQuery\" state-name=\"\'main.folder\'\" fn-filter-query-change=\"inputOutputPathModel.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"inputOutputPathModel.fnSetTableHeight()\"></storage-search-directive><div class=\"row\" ng-if=\"inputOutputPathModel.contentPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"inputOutputPathModel.isFoldersLoading\" hide-circle=\"true\" set-padding=\"true\" hide-line=\"true\" fn-resize=\"inputOutputPathModel.fnSetLoaderTableHeight()\"></table-loader><div class=\"table-container\" id=\"storageModalTable\"><table class=\"table table-striped table-check-box\" ng-show=\"!inputOutputPathModel.isFoldersLoading\"><thead><tr ng-if=\"inputOutputPathModel.folderArr.length\"><th class=\"p-8\"></th><th>Name</th><th class=\"p-r-5\" ng-if=\"inputOutputPathModel.filterQuery.length\">Path</th><th class=\"p-r-5\">Last modified</th><th>Size</th></tr><tr ng-if=\"!inputOutputPathModel.folderArr.length\"><th>No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"folderObj in inputOutputPathModel.folderArr track by $index\" ng-dblclick=\"inputOutputPathModel.fnGetFolder(folderObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input ng-if=\"inputOutputPathModel.fnCheckFileFolder(folderObj)\" type=\"checkbox\" ng-change=\"inputOutputPathModel.fnCheckUncheckHeader(folderObj);\" id=\"chk_{{$index}}\" ng-model=\"folderObj.isCheck\"> <label ng-if=\"inputOutputPathModel.fnCheckFileFolder(folderObj)\" for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><i class=\"m-r-5\" ng-class=\"\'fa \'+folderObj.icon\"></i> <span ng-click=\"$event.stopPropagation();inputOutputPathModel.fnGetFolder(folderObj);\">{{folderObj.name}}</span></td><td class=\"p-r-8\" ng-if=\"inputOutputPathModel.filterQuery.length\" ng-bind=\"folderObj.path\" style=\"word-break: break-all\">Doe</td><td class=\"p-r-8\" ng-bind=\"folderObj.lastUpdate\">John</td><td ng-bind=\"folderObj.fileSize\">John</td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!inputOutputPathModel.isFoldersLoading\"><div class=\"progress text-center\" ng-if=\"inputOutputPathModel.isFileUploading\"><div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"{{inputOutputPathModel.progressBar}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{inputOutputPathModel.progressBar}}%\"><span class=\"p-l-5\">{{inputOutputPathModel.progressCounter.toFixed(2)}}%</span></div></div><div class=\"row\" ng-if=\"inputOutputPathModel.folderArr.length && !inputOutputPathModel.isFileUploading\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{inputOutputPathModel.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"inputOutputPathModel.perPage = 10; inputOutputPathModel.fnPageChanged(inputOutputPathModel.currentPage, inputOutputPathModel.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"inputOutputPathModel.perPage = 20; inputOutputPathModel.fnPageChanged(inputOutputPathModel.currentPage, inputOutputPathModel.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"inputOutputPathModel.perPage = 50; inputOutputPathModel.fnPageChanged(inputOutputPathModel.currentPage, inputOutputPathModel.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"inputOutputPathModel.perPage = 100; inputOutputPathModel.fnPageChanged(inputOutputPathModel.currentPage,inputOutputPathModel.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"inputOutputPathModel.perPage = 500; accounts.fnPageChanged(accounts.currentPage, accounts.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"inputOutputPathModel.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"inputOutputPathModel.currentPage\" items-per-page=\"inputOutputPathModel.perPage\" max-size=\"inputOutputPathModel.maxSize\" boundary-links=\"true\" ng-click=\"inputOutputPathModel.fnPageChanged(inputOutputPathModel.currentPage, inputOutputPathModel.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"inputOutputPathModel.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!inputOutputPathModel.selectedFolderObj\" ng-click=\"inputOutputPathModel.fnSave(inputOutputPathModel.selectedFolderObj)\" tabindex=\"12\">Select</button></div></div>");
$templateCache.put("app/ai/trainer/trainerInfo/trainerInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/billing/credit_token/createCreditToken/createCreditToken.html","<div ng-controller=\"createCreditTokenCtrl as createCreditToken\" class=\"h-100\" ng-init=\"createCreditToken.fnInitCreateCreditToken()\"><div class=\"modal-body h-100\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createCreditToken.isShowCreateForm\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput m-t-10\" ng-if=\"createCreditToken.isShowCreateForm\"><form id=\"createNewCreditTokenForm\" role=\"form\" name=\"createNewCreditTokenForm\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createCreditToken.newCreditTokenObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" name=\"description\" ng-model=\"createCreditToken.newCreditTokenObj.description\" placeholder=\"Description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 cartValue\"><input class=\"md-form-control\" required=\"\" id=\"amount\" type=\"number\" name=\"amount\" ng-model=\"createCreditToken.newCreditTokenObj.amount\" step=\"0.1\" placeholder=\"Amount*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.amount.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Amount*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20 cartValue\"><input class=\"md-form-control\" required=\"\" id=\"startsCreditTokenInput\" type=\"text\" name=\"starts\" ng-model=\"createCreditToken.newCreditTokenObj.starts\" placeholder=\"Starts*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.starts.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Starts*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20 cartValue\"><input class=\"md-form-control\" required=\"\" id=\"expiresCreditTokenInput\" type=\"text\" name=\"expires\" ng-model=\"createCreditToken.newCreditTokenObj.expires\" placeholder=\"Expires*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.expires.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Expires*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input cartValue\"><input class=\"md-form-control\" required=\"\" id=\"transactionMin\" type=\"number\" name=\"transactionMin\" ng-model=\"createCreditToken.newCreditTokenObj.transactionMin\" placeholder=\"Min Transaction*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.transactionMin.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Min Transaction*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input cartValue\"><input class=\"md-form-control\" required=\"\" id=\"transactionMax\" type=\"number\" name=\"transactionMax\" ng-model=\"createCreditToken.newCreditTokenObj.transactionMax\" placeholder=\"Max Transaction*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewCreditTokenForm.transactionMax.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Max Transaction*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"Product Id*\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && createCreditToken.fnCreateArrayTag(createCreditToken.selectedProductObj, \'productId\')\" typeahead-editable=\"true\" uib-typeahead=\"productObj as productObj.name for productObj in createCreditToken.productsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"ProductTemplate.html\" name=\"productId\" id=\"productId\" ng-model=\"createCreditToken.selectedProductObj\"> <span class=\"highlight\"></span> <label>Product Id*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\" style=\"right: 0;\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"createCreditToken.fnCreateArrayTag(createCreditToken.selectedProductObj, \'productId\')\"><span><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm btn-default m-t-5 m-r-5\" ng-repeat=\"selectedArr in createCreditToken.selectedProductsArr track by $index\"><span class=\"healtSpan\">{{selectedArr.name}}</span> <span><i class=\"fa fa-times m-l-5\" ng-click=\"createCreditToken.fnRemoveArrayTag($index)\"></i></span></button></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createCreditToken.newCreditTokenObj.name.length\" ng-click=\"createCreditToken.fnCreateNewCreditToken(createCreditToken.newCreditTokenObj)\" ng-if=\"!createCreditToken.isCreditTokenCreating\">Create CreditToken</button></div><div class=\"col-sm-12\" ng-if=\"createCreditToken.isCreditTokenCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"ProductTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script>");
$templateCache.put("app/billing/credit_token/credit_tokenInfo/credit_tokenInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Credit Token</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{creditTokenObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{creditTokenObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{creditTokenObj.description ? creditTokenObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{creditTokenObj.description ? creditTokenObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{creditTokenObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(creditTokenObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/billing/discount/createDiscount/createDiscount.html","<div ng-controller=\"createDiscountCtrl as createDiscount\" ng-init=\"createDiscount.fnInitCreateDiscount()\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createDiscount.isShowCreateDiscountForm\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput m-t-10\" ng-if=\"createDiscount.isShowCreateDiscountForm\"><form id=\"createNewDiscountForm\" role=\"form\" name=\"createNewDiscountForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createDiscount.newDiscountObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" name=\"description\" ng-model=\"createDiscount.newDiscountObj.description\" placeholder=\"Description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input\" ng-if=\"createDiscount.accountId !== \'cu000000\'\" ng-class=\"createNewDiscountForm.accountId.$error.pattern && createNewDiscountForm.accountId.$dirty ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"accountId\" type=\"text\" name=\"accountId\" ng-model=\"createDiscount.newDiscountObj.accountId\" ng-pattern=\"/^cu(\\w{6})$/\" placeholder=\"Account Id*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.accountId.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Account Id*</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error\" ng-show=\"createNewDiscountForm.accountId.$error.pattern && createNewDiscountForm.accountId.$dirty\"><span class=\"errorText\">The Id does not satisfy the required format. cuxxxxxx</span></small></div><div class=\"md-input\" ng-if=\"createDiscount.accountId === \'cu000000\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"createDiscount.newDiscountObj.accountId = \'\'\" typeahead-editable=\"false\" uib-typeahead=\"accountObj as accountObj.name for accountObj in createDiscount.accountsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"AlgorithmTemplate.html\" typeahead-on-select=\"createDiscount.fnAccountSelected(createDiscount.selectedAccountObj)\" ng-model=\"createDiscount.selectedAccountObj\" placeholder=\"Account Id*\"> <span class=\"highlight\"></span> <label>Account Id*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createDiscount.selectedAccountObj\"><span>({{createDiscount.selectedAccountObj.id}})</span></span></div><div class=\"md-input\" ng-if=\"createDiscount.accountId !== \'cu000000\'\" ng-class=\"createNewDiscountForm.productId.$error.pattern && createNewDiscountForm.productId.$dirty ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"productId\" type=\"text\" name=\"productId\" ng-model=\"createDiscount.newDiscountObj.productId\" ng-pattern=\"/^(\\w{8})$/\" placeholder=\"Product Id*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.productId.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Product Id*</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error\" ng-show=\"createNewDiscountForm.productId.$error.pattern && createNewDiscountForm.productId.$dirty\"><span class=\"errorText\">The Id does not satisfy the required format. xxxxxxxx</span></small></div><div class=\"md-input\" ng-if=\"createDiscount.accountId === \'cu000000\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"createDiscount.newDiscountObj.productId = \'\'\" typeahead-editable=\"false\" uib-typeahead=\"productObj as productObj.name for productObj in createDiscount.productsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"AlgorithmTemplate.html\" typeahead-on-select=\"createDiscount.fnProductSelected(createDiscount.selectedProductObj)\" ng-model=\"createDiscount.selectedProductObj\" placeholder=\"Product Id*\"> <span class=\"highlight\"></span> <label>Product Id*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createDiscount.selectedProductObj\"><span>({{createDiscount.selectedProductObj.id}})</span></span></div><div class=\"md-input cartValue\" ng-class=\"createNewDiscountForm.percentage.$error.min || createNewDiscountForm.percentage.$error.max ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"percentage\" type=\"number\" name=\"percentage\" step=\"0.01\" min=\"0\" max=\"100\" ng-model=\"createDiscount.newDiscountObj.percentage\" placeholder=\"Percentage*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.percentage.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Percentage*</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error\" ng-show=\"createNewDiscountForm.percentage.$error.min || createNewDiscountForm.percentage.$error.max\"><span class=\"errorText\">The Discount Percentage should be greater than 0 and less than 100</span></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"expiresHiddenInputText\" type=\"text\" name=\"expires\" ng-model=\"createDiscount.newDiscountObj.expires\" placeholder=\"Expires\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewDiscountForm.expires.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Expires</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!(createDiscount.newDiscountObj.name.length && createDiscount.newDiscountObj.description.length && createDiscount.newDiscountObj.productId.length && createDiscount.newDiscountObj.accountId.length && createDiscount.newDiscountObj.percentage !== \'\' && createDiscount.newDiscountObj.percentage >= 0 && createDiscount.newDiscountObj.percentage <= 100)\" ng-click=\"createDiscount.fnCreateNewDiscount(createDiscount.newDiscountObj)\" ng-if=\"!createDiscount.isDiscountCreating\">Create Discount</button></div><div class=\"col-sm-12\" ng-if=\"createDiscount.isDiscountCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"AlgorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script>");
$templateCache.put("app/billing/discount/discountInfo/discountInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Discount</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{discountObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{discountObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{discountObj.description ? discountObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{discountObj.description ? discountObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{discountObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(discountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/billing/invoice/invoiceInfo/invoiceInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Invoice</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{invoiceObj.businessName}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{invoiceObj.businessName}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\"><span class=\"ellipsis\" style=\"display: block;\"><span>{{invoiceObj.dueDate | date: \'d MMM yyyy\'}}</span> <span>$ {{(invoiceObj.total/100).toFixed(2)}}</span></span></h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\"><span class=\"ellipsis\" style=\"display: block;\"><span>{{invoiceObj.dueDate | date: \'d MMM yyyy\'}}</span> <span>$ {{(invoiceObj.total/100).toFixed(2)}}</span></span></h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{invoiceObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(invoiceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/billing/payment_method/createPaymentMethod/createPaymentMethod.html","<div class=\"form-content\" ng-controller=\"createPaymentMethodCtrl as createPaymentMethod\" ng-init=\"createPaymentMethod.fnInitCreatePaymentMethod()\"><div class=\"modal-body height-100\" id=\"modal-body\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100 d-flex justify-content-center align-items-center\" ng-if=\"createPaymentMethod.isRequestNewPaymentMethod\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"!createPaymentMethod.isRequestNewPaymentMethod\"><form id=\"createNewPaymentForm\" autocomplete=\"off\" role=\"form\" name=\"createNewPaymentForm\" novalidate=\"\"><label id=\"accountDetailsTitle\" style=\"visibility: hidden\"></label><div class=\"col-sm-12 p-0 m-t-15 m-b-20\"><label>Payment details</label><div class=\"stripe-card-element\"><div class=\"sr-input sr-element sr-card-element\" id=\"card-element\"></div><span id=\"card-errors\"></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" name=\"first-name\" ng-model=\"createPaymentMethod.addressArr.name\" placeholder=\"Name*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"country\" type=\"text\" name=\"first-name\" typeahead-editable=\"false\" ng-change=\"createPaymentMethod.fnChangeSelectCountry()\" uib-typeahead=\"countriesObj as countriesObj.sortname for countriesObj in createPaymentMethod.countriesList | filter:$viewValue\" typeahead-template-url=\"layoutTemplate.html\" typeahead-min-length=\"0\" typeahead-on-select=\"createPaymentMethod.fnSelectCountry(createPaymentMethod.selectedCountry)\" ng-model=\"createPaymentMethod.selectedCountry\" placeholder=\"Country*\"> <span class=\"highlight\"></span> <label>Country*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"addressLine1\" type=\"text\" name=\"first-name\" ng-model=\"createPaymentMethod.addressArr.address.line1\" placeholder=\"Address Line 1*\"> <span class=\"highlight\"></span> <label>Address Line 1*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"addressLine2\" type=\"text\" name=\"first-name\" ng-model=\"createPaymentMethod.addressArr.address.line2\" placeholder=\"Address Line 2\"> <span class=\"highlight\"></span> <label>Address Line 2</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"State\" type=\"text\" name=\"first-name\" typeahead-editable=\"false\" ng-change=\"createPaymentMethod.fnChangeSelectState()\" uib-typeahead=\"statesObj as statesObj.name for statesObj in createPaymentMethod.stateList | filter:$viewValue | limitTo:10\" typeahead-template-url=\"layoutTemplate.html\" typeahead-min-length=\"0\" typeahead-on-select=\"createPaymentMethod.fnSelectState(createPaymentMethod.selectedState)\" ng-model=\"createPaymentMethod.selectedState\" placeholder=\"State*\"> <span class=\"highlight\"></span> <label>State*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"city\" type=\"text\" name=\"first-name\" typeahead-editable=\"false\" ng-change=\"createPaymentMethod.fnChangeSelectCity()\" uib-typeahead=\"citiesObj as citiesObj.name for citiesObj in createPaymentMethod.citiesList | filter:$viewValue | limitTo:10\" typeahead-template-url=\"layoutTemplate.html\" typeahead-min-length=\"0\" typeahead-on-select=\"createPaymentMethod.fnSelectCity(createPaymentMethod.selectedCity)\" ng-model=\"createPaymentMethod.selectedCity\" placeholder=\"City*\"> <span class=\"highlight\"></span> <label>City*</label> <small class=\"helper-text\"></small></div></div></div></form><button class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createPaymentMethod.addressArr.name.length || !createPaymentMethod.addressArr.address.country.length || !createPaymentMethod.addressArr.address.line1.length || !createPaymentMethod.addressArr.address.state.length || !createPaymentMethod.addressArr.address.city || !createPaymentMethod.isCardValid\" ng-click=\"createPaymentMethod.fnAddCard()\" ng-if=\"!createPaymentMethod.isRequestProcessing\" id=\"submitCard\">Add Card</button><div class=\"col-sm-12\" ng-if=\"createPaymentMethod.isRequestProcessing\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"layoutTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-if=\"match.model.sortname\"> {{match.model.sortname + \" (\"+match.model.name + \")\"}} </span> <span ng-if=\"!match.model.sortname\"> {{match.model.name}} </span> </div> <br> </a></script>");
$templateCache.put("app/billing/payment_method/paymentMethodInfo/paymentMethodInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Payment Method</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{paymentMethodObj.billingDetails.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{paymentMethodObj.billingDetails.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\"><span class=\"d-flex\"><span class=\"p-r-5 font-italic\">XXXX{{paymentMethodObj.card.last4}}</span> <span class=\"p-l-12\" uib-tooltip=\"Expires Date\" tooptip-placement=\"auto\">{{paymentMethodObj.card.expiryMonth.toString().length === 1 ? \"0\" + paymentMethodObj.card.expiryMonth : paymentMethodObj.card.expiryMonth}}/{{ paymentMethodObj.card.expiryYear}}</span></span></h2><h5 class=\"m-0 m-t-5\" ng-if=\"!isFullWidthDevice\"><span class=\"d-flex\"><span class=\"p-r-5 font-italic\">XXXX{{paymentMethodObj.card.last4}}</span> <span class=\"p-l-12\" uib-tooltip=\"Expires Date\" tooptip-placement=\"auto\">{{paymentMethodObj.card.expiryMonth.toString().length === 1 ? \"0\" + paymentMethodObj.card.expiryMonth : paymentMethodObj.card.expiryMonth}}/{{ paymentMethodObj.card.expiryYear}}</span></span></h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{paymentMethodObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(paymentMethodObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/billing/script/scriptInfo/scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/components/breadcrumb/FeedbackModal/feedbackModal.html","<div class=\"inmodal theme_modal h-100 feedbackAndSupportModal\" ng-init=\"feedbackSupport.fnInitModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\" ng-bind=\"\'Feedback & Support\'\"></strong></div><div class=\"modal-body\"><div class=\"row h-100\"><div class=\"col-sm-12 p-0 d-flex flex-column h-100 floatingLabelInput\" ng-class=\"feedbackSupport.isFeedbackCreating ? \'pace\' : \'\'\" ng-if=\"feedbackSupport.supportId === \'\'\"><div class=\"col-sm-12\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"feedbackSupport.feedbackObj.subject\" placeholder=\"Subject for the Feedback & Support*\"> <span class=\"highlight\"></span> <label>Subject*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 floatingLabelInput h-100\" id=\"issueMarkdownContainer\"><div class=\"m-b-0 createIssue hide-toolbar createIssueMarkdownEditor\"><textarea name=\"feedbackAndSupportEditor\" class=\"content-box\" ng-drop-dir-for-issue=\"\" placeholder=\"What can we help with?\" upload-file=\"feedbackSupport.uploadFiles(type, filedata)\" ng-model=\"feedbackSupport.feedbackObj.summary\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'none\'}\" rows=\"10\">\n                        </textarea></div></div></div><div class=\"col-sm-12 p-0 d-flex flex-column align-items-center justify-content-center p-l-50 p-r-50 h-100\" ng-if=\"feedbackSupport.supportId !== \'\'\"><div class=\"text-center p-b-30\"><h1><b>Thank You</b></h1></div><div class=\"text-center font-size-19 p-b-10\"><span><b>Someone from the team will be in touch shortly</b></span></div><div class=\"text-center font-size-19\"><span><b>[ {{feedbackSupport.supportId}} ]</b></span></div></div></div></div><div class=\"modal-footer p-b-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"feedbackSupport.fnCancel()\">Close</button> <button class=\"btn btn-primary v4-primary-button m-l-0 h-100 m-l-10\" ng-if=\"feedbackSupport.supportId === \'\' && !feedbackSupport.isFeedbackCreating && !feedbackSupport.fileUploading\" ng-click=\"feedbackSupport.fnHideShowEditorPreview(\'feedbackAndSupportEditor\')\"><span class=\"fa fa-eye\"></span> Preview</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div ng-if=\"feedbackSupport.supportId === \'\'\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"feedbackSupport.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"feedbackSupport.isProjectSelected() && !feedbackSupport.isFeedbackCreating && !feedbackSupport.fileUploading && feedbackSupport.permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button></div><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!feedbackSupport.isFeedbackCreating && !feedbackSupport.fileUploading && feedbackSupport.supportId === \'\'\" ng-disabled=\"!feedbackSupport.feedbackObj.subject.length || !feedbackSupport.feedbackObj.summary.length\" ng-click=\"feedbackSupport.fnCreateFeedback()\">Submit</button><app-spinner class=\"m-r-5 m-t-4\" ng-if=\"feedbackSupport.isFeedbackCreating || feedbackSupport.fileUploading\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/components/breadcrumb/InformationModel/informationModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\" ng-bind=\"\'Advanced keyboard shortcuts\'\"></strong></div><div class=\"modal-body h-dynamic p-0\" style=\"height: calc(100vh - 185px) !important;\"><div class=\"row h-100\" ng-init=\"infoModal.fnInitModel()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container p-0\" style=\"overflow: hidden\"><div class=\"col-sm-12 m-t-10\"><div class=\"col-sm-3 h-100 p-l-0 overflow-auto\" style=\"height: calc(100vh - 210px) !important;\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"infoModal.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"infoModal.selectedTab = item.tabIndex\" ng-if=\"item.visible === true\" ng-repeat=\"item in infoModal.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0 overflow-auto\" style=\"height: calc(100vh - 210px) !important;\"><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 1\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 m-t-10 p-0\" ng-repeat=\"shortcut in infoModal.PredictiveAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon p-l-10 p-r-10\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 2\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.NodeAppShortcutsArr\" ng-if=\"shortcut.isShow\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 3\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.TrackerAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 4\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.PipelineAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 5\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.AIAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 6\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.InsightAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 7\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.StorageAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 8\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.AccessAppShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 9\"><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Navigation</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.BillingAppShortcutsArr\" ng-if=\"shortcut.isAccess === true\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 10\"><div><div><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Functions</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.ProfileShortcutsArr\" ng-if=\"shortcut.isAccess === true\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div></div></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"infoModal.selectedTab === 11\"><div><div><div class=\"col-sm-12 p-l-15 m-t-10\"><strong>Functions</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.CRUDShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn fa fa-arrow-up\" ng-if=\"keys === \'up\'\"></div><div class=\"pull-left btn shortcutsBtn\" ng-if=\"keys !== \'up\'\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div><div class=\"col-sm-12 p-l-15 m-t-20\"><strong>Other</strong></div><div class=\"col-sm-12 p-0 m-t-10\" ng-repeat=\"shortcut in infoModal.ExceptionalCustomShortcutsArr\"><div class=\"col-sm-4\"><div ng-repeat=\"keys in shortcut.keys track by $index\"><div class=\"pull-left btn shortcutsBtn fa fa-arrow-up\" ng-if=\"keys === \'up\'\"></div><div class=\"pull-left btn shortcutsBtn\" ng-if=\"keys !== \'up\'\">{{keys}}</div><div class=\"pull-left plusIcon\" ng-if=\"shortcut.keys.length-1 !== $index\">+</div></div></div><div class=\"col-sm-8 descriptionText\">{{shortcut.description}}</div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-b-10\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"infoModal.fnCancel()\">Close</button></div></div>");
$templateCache.put("app/components/modals/CreditCardInfoModel/creditCardInfoModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Why do I need to add a card?</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\"><div class=\"divider\"></div><h4>All ECSMon accounts are full, production accounts. You will always need to provide a credit card to use ECSMon (even if you sign-up for PO or invoicing). If you wish to try some ECSMon service, you can take advantage of the Free Usage Tier.</h4><h4>The ECSMon Free Usage Tier provides a limited quantity of some ECSMon services at no charge. When you exceed the quantity of usage (eg hours, nodes or amount of storage), then you will be charged normal rates for the service. If you have chosen to use PO or invoicing your card will only be used as a security guarantee in the eventuality that your invoices are not paid.</h4></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"CreditCardInfo.fnCancel()\" tabindex=\"12\">Close</button></div>");
$templateCache.put("app/components/modals/advancedSearchModal/advancedSearchModal.html","<div class=\"inmodal h-100 supplementalTemplate\" ng-init=\"advancedSearchModal.fnInitSearch()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Advanced Search</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-3 h-100 p-l-0 p-b-0\" style=\"height: calc(100vh - 210px) !important;\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"advancedSearchModal.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"editListener.fnSet(); advancedSearchModal.selectedTab = item.tabIndex;\" ng-repeat=\"item in advancedSearchModal.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 1\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>Health:</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" style=\"display: flex;justify-content: center\"><input type=\"radio\" id=\"radio_range\" name=\"health\" ng-model=\"advancedSearchModal.healthType\" value=\"healthRange\"> <label for=\"radio_range\" class=\"radio\" style=\"position: relative;top: 3px\"></label> <label>&nbsp;By Health Range</label> <input type=\"radio\" id=\"radio_specific_health\" ng-model=\"advancedSearchModal.healthType\" name=\"health\" class=\"m-l-15\" value=\"specificHealth\"> <label for=\"radio_specific_health\" class=\"radio\" style=\"position: relative;top: 3px\"></label> <label>&nbsp;Specific Health</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-t-15\" id=\"healthRangeSlider\" ng-if=\"advancedSearchModal.healthType === \'healthRange\'\"><rzslider rz-slider-model=\"advancedSearchModal.slider.minValue\" rz-slider-high=\"advancedSearchModal.slider.maxValue\" rz-slider-options=\"advancedSearchModal.slider.options\"></rzslider></div><div class=\"col-sm-12 p-0 p-t-15 floatingLabelInput\" ng-if=\"advancedSearchModal.healthType === \'specificHealth\'\"><div class=\"col-sm-12 p-0\"><form id=\"healthForm\" role=\"form\" name=\"healthForm\" novalidate=\"\"><div class=\"md-input\" ng-class=\"healthForm.health.$error.min || healthForm.health.$error.max ?\'m-b-20\':\'m-b-10\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"advancedSearchModal.health\" min=\"100\" max=\"599\" ng-change=\"advancedSearchModal.fnCheckHealthInputValue()\" name=\"health\" placeholder=\"Health for Device*\"> <span class=\"highlight\"></span> <label>Health*</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error\" ng-show=\"advancedSearchModal.isHealthMinError || advancedSearchModal.isHealthMaxError\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small> <small class=\"helper-text-error\" ng-show=\"advancedSearchModal.isHealthString && !advancedSearchModal.isHealthFind\"><span class=\"errorText\">The {{advancedSearchModal.health}} does not match to any registered healths.</span></small></div></form></div></div></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 2\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>Connection:</label></div><div class=\"col-sm-12 p-0\" style=\"display: flex;justify-content: center;\"><div class=\"col-sm-4 p-0 p-t-5\" ng-repeat=\"connection in advancedSearchModal.connectionArr\"><input type=\"checkbox\" id=\"chk_Con_{{connection.name}}\" ng-model=\"connection.isCheck\"> <label for=\"chk_Con_{{connection.name}}\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <label>{{connection.name}}</label></div></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 3\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\" ng-if=\"advancedSearchModal.newGatewayArr.length\"><div class=\"col-sm-12 p-0\"><label>Gateway:</label></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-t-10 m-b-20\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"advancedSearchModal.gatewaySearch[advancedSearchModal.gatewayFilter]\"> <span class=\"highlight\"></span> <label>Search</label> <span class=\"bar\"></span></div></div><div class=\"col-sm-12 p-0\" style=\"max-height: 150px;overflow: auto\"><div class=\"col-sm-6 p-0 p-t-5\" ng-repeat=\"gatewayObj in advancedSearchModal.newGatewayArr | filter: advancedSearchModal.gatewaySearch | limitTo:10 track by $index\"><div class=\"col-sm-12 p-0 p-r-10 ellipsis\"><input type=\"checkbox\" id=\"chk_model_{{gatewayObj.name}}\" ng-model=\"gatewayObj.isCheck\"> <label for=\"chk_model_{{gatewayObj.name}}\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <label>{{gatewayObj.name}}</label></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 p-b-10\" ng-if=\"!advancedSearchModal.newGatewayArr.length\"><div class=\"col-sm-12 p-0\"><label>Gateway:</label></div><div class=\"col-sm-12 p-0\"><label>No Record Found...</label></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 4\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>OEM:</label></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-t-10 m-b-20\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-class=\"tagsArr.length ? \'p-r-35\':\'\'\" ng-model=\"advancedSearchModal.oemSearch[advancedSearchModal.oemFilter]\"> <span class=\"highlight\"></span> <label>Search</label> <span class=\"bar\"></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 p-t-5\" ng-repeat=\"oem in advancedSearchModal.oemArr | filter: advancedSearchModal.oemSearch | limitTo:10 track by $index\"><div class=\"col-sm-12 p-0 p-r-10 ellipsis\"><input type=\"checkbox\" id=\"chk_oem_{{oem.name}}\" ng-model=\"oem.isCheck\"> <label for=\"chk_oem_{{oem.name}}\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <label>{{oem.name}}</label></div></div></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 5\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>Model:</label></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-t-10 m-b-20\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-class=\"tagsArr.length ? \'p-r-35\':\'\'\" ng-model=\"advancedSearchModal.modelSearch[advancedSearchModal.modelFilter]\"> <span class=\"highlight\"></span> <label>Search</label> <span class=\"bar\"></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 p-t-5\" ng-repeat=\"model in advancedSearchModal.modelArr | filter: advancedSearchModal.modelSearch | limitTo:10 track by $index\"><div class=\"col-sm-12 p-0 p-r-10 ellipsis\"><input type=\"checkbox\" id=\"chk_model_{{model.name}}\" ng-model=\"model.isCheck\"> <label for=\"chk_model_{{model.name}}\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <label>{{model.name}}</label></div></div></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 6\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>Phase:</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 p-t-5\" ng-repeat=\"phase in advancedSearchModal.phaseArr\"><input type=\"checkbox\" id=\"chk_Phase_{{phase.name}}\" ng-model=\"phase.isCheck\"> <label for=\"chk_Phase_{{phase.name}}\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <label>{{phase.name}}</label></div></div></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"advancedSearchModal.selectedTab === 7\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 p-t-15 p-b-10 loadModalDivider\"><div class=\"col-sm-12 p-0\"><label>Sort:</label></div><div class=\"col-sm-12 p-0 m-t-5 floatingLabelInput\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"sortField as sortField.displayName for sortField in advancedSearchModal.sortFieldArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"createModel.fnAlgorithmSelected(createModel.selectedAlgorithm)\" typeahead-template-url=\"SortInputTemplate.html\" ng-model=\"advancedSearchModal.selectedSortField\" placeholder=\"Sort Field\"> <span class=\"highlight\"></span> <label>Sort Field</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"sortOperator as sortOperator.displayName for sortOperator in advancedSearchModal.sortOperator | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"createModel.fnAlgorithmSelected(createModel.selectedAlgorithm)\" ng-model=\"advancedSearchModal.selectedSortOperator\" placeholder=\"Sort By\"> <span class=\"highlight\"></span> <label>Sort By</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-2 p-l-0\"><button class=\"btn btn-primary m-t-5\" ng-disabled=\"!advancedSearchModal.selectedSortField || !advancedSearchModal.selectedSortOperator\" ng-click=\"advancedSearchModal.fnAddSortFilter()\">Add Sort</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"advancedSearchModal.selectedSortField && advancedSearchModal.selectedSortOperator\">Please click on \"Add Sort\" to apply selected sort condition.</div><div class=\"col-sm-12 p-0 m-t-5\" ng-if=\"advancedSearchModal.filterSortArr.length\"><div class=\"col-sm-12 p-0\"><label>List Of Selected Filter:</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0 p-t-5 p-b-5\"><label>Fields</label></div><div class=\"col-sm-5 p-0 p-t-5 p-b-5\"><label>Filter Order</label></div><div class=\"col-sm-2 p-0 p-t-5 p-b-5\"></div></div><div class=\"col-sm-12 p-0\" ng-repeat=\"filterSorObj in advancedSearchModal.filterSortArr track by $index\"><div class=\"col-sm-5 p-0 p-t-5 p-b-5\">{{filterSorObj.sortFieldDisplayName}}</div><div class=\"col-sm-5 p-0 p-t-5 p-b-5\">{{filterSorObj.sortOperatorDisplayName}}</div><div class=\"col-sm-2 p-0 p-t-5 p-b-5\"><i class=\"fa fa-trash-o\" ng-click=\"advancedSearchModal.fnRemoveSortFilter($index,filterSorObj)\"></i></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"advancedSearchModal.fnCancel()\">Cancel</button> <input type=\"button\" class=\"btn btn-primary\" ng-click=\"advancedSearchModal.fnApplySearch()\" value=\"Apply\"></div></div><script type=\"text/ng-template\" id=\"SortInputTemplate.html\"><a class=\"p-l-10 p-r-10\" ng-if=\"match.model.isDisplay\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.displayName\"></span> </div> <br> </a></script>");
$templateCache.put("app/components/modals/analyticsDateTimeHelpModal/analyticsDateTimeHelpModal.html","<div class=\"inmodal h-100\" ng-init=\"analyticsDateTimeModal.fnInitAnalyticsDateTimeModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Analytics</strong></div><div class=\"modal-body p-t-0\"><div class=\"row\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"analyticsDateTimeModal.selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in analyticsDateTimeModal.tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent-1\" ng-show=\"analyticsDateTimeModal.selectedTab === 1 && tab.tabIndex === 1\"><div class=\"col-sm-12 p-15\" ng-show=\"!analyticsDateTimeModal.isAbsoluteAdvancedView\"><div class=\"col-sm-12 p-0 m-b-15\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"analyticsDateTimeModal.isAbsoluteAdvancedView = true\">Advanced</button></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-9 p-0\"><h3 class=\"m-b-0 m-t-13\" id=\"daterangepicker-result\">Select Date Range</h3></div><div class=\"col-sm-3 p-0 floatingLabelInput pull-right\"><div class=\"md-input m-b-0 roleActions\"><input class=\"md-form-control\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"timeZone for timeZone in analyticsDateTimeModal.timeZoneArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-on-select=\"analyticsDateTimeModal.fnTimeZoneSelected(analyticsDateTimeModal.selectedTimeZone)\" ng-model=\"analyticsDateTimeModal.selectedTimeZone\" placeholder=\"Time Zone*\"> <span class=\"highlight\"></span> <label>Time Zone*</label></div></div></div><div class=\"col-sm-12 p-0\"><label for=\"daterangepicker1\"></label> <input id=\"daterangepicker1\" type=\"hidden\"><div id=\"daterangepicker1-container\" class=\"embedded-daterangepicker\"></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-3\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input m-b-20\"><input class=\"md-form-control date-picker\" required=\"\" id=\"gatewayId\" type=\"text\" ng-model=\"analyticsDateTimeModal.startDate\" ng-change=\"analyticsDateTimeModal.fnChangeStartDate()\" placeholder=\"YYYY/MM/DD*\"> <span class=\"highlight\"></span> <label>YYYY/MM/DD*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-3\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input m-b-20\"><input class=\"md-form-control date-picker\" required=\"\" id=\"a\" type=\"text\" ng-model=\"analyticsDateTimeModal.startTime\" ng-change=\"analyticsDateTimeModal.fnCheckStartTime()\" placeholder=\"HH:MM:SS*\"> <span class=\"highlight\"></span> <label>HH:MM:SS*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-3\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input m-b-20\"><input class=\"md-form-control date-picker\" required=\"\" id=\"b\" type=\"text\" ng-model=\"analyticsDateTimeModal.endDate\" ng-change=\"analyticsDateTimeModal.fnChangeEndDate()\" placeholder=\"YYYY/MM/DD*\"> <span class=\"highlight\"></span> <label>YYYY/MM/DD*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-3\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input m-b-20\"><input class=\"md-form-control date-picker\" required=\"\" id=\"c\" type=\"text\" ng-model=\"analyticsDateTimeModal.endTime\" ng-change=\"analyticsDateTimeModal.fnCheckEndTime()\" placeholder=\"HH:MM:SS*\"> <span class=\"highlight\"></span> <label>HH:MM:SS*</label> <small class=\"helper-text\"></small></div></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-show=\"!analyticsDateTimeModal.startDateIsValid\">Please Enter Valid Start Date.</div><div class=\"col-sm-12 p-0\" ng-show=\"!analyticsDateTimeModal.endDateIsValid\">Please enter valid End Date.</div><div class=\"col-sm-12 p-0\" ng-show=\"!analyticsDateTimeModal.dateRangeIsNotValid\">Start Date must be lower then End Date.</div><div class=\"col-sm-12 p-0\" ng-show=\"!analyticsDateTimeModal.startTimeIsValid\">Please enter valid start time.</div><div class=\"col-sm-12 p-0\" ng-show=\"!analyticsDateTimeModal.endTimeIsValid\">Please enter valid end time.</div></div></div><div class=\"col-sm-12 p-15\" ng-show=\"analyticsDateTimeModal.isAbsoluteAdvancedView\" ng-include=\"\'aggregateFunction.html\'\"></div></div><div class=\"tabContent-1\" ng-show=\"analyticsDateTimeModal.selectedTab === 2 && tab.tabIndex === 2\"><div class=\"col-sm-12 p-15\" ng-show=\"!analyticsDateTimeModal.isRelativeAdvancedView\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"analyticsDateTimeModal.isRelativeAdvancedView = true\">Advanced</button></div><div class=\"col-sm-12 p-0 m-t-10 d-flex justify-content-center align-items-center\" ng-repeat=\"relativeTimeOptionObj in analyticsDateTimeModal.relativeTimeOptionsArr\"><div class=\"col-sm-3 p-0\"><label class=\"m-b-0\">{{relativeTimeOptionObj.name}}</label></div><div class=\"col-sm-9 p-0 d-flex\"><div class=\"p-0 m-r-15\" ng-repeat=\"option in relativeTimeOptionObj.options\"><span class=\"d-flex justify-content-center align-items-center relative-time-box\" ng-click=\"analyticsDateTimeModal.fnSetRelativeTime(option)\" ng-class=\"analyticsDateTimeModal.selectedTime && analyticsDateTimeModal.selectedTime.type === \'relative\' && analyticsDateTimeModal.selectedTime.units === option.units && analyticsDateTimeModal.selectedTime.name === option.name ? \'selected-box\':\'\'\">{{option.name}}</span></div></div></div></div><div class=\"col-sm-12 p-15\" ng-show=\"analyticsDateTimeModal.isRelativeAdvancedView\" ng-include=\"\'aggregateFunction.html\'\"></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"analyticsDateTimeModal.fnClose()\">Cancel</button> <input type=\"button\" ng-if=\"analyticsDateTimeModal.selectedTab === 2 || analyticsDateTimeModal.selectedTab === 3\" class=\"btn btn-primary\" ng-click=\"analyticsDateTimeModal.fnApplyFilter()\" value=\"Apply\"> <button ng-if=\"analyticsDateTimeModal.selectedTab === 1\" ng-disabled=\"!analyticsDateTimeModal.startDateIsValid || !analyticsDateTimeModal.endDateIsValid || !analyticsDateTimeModal.dateRangeIsNotValid || !analyticsDateTimeModal.selectedTimeZone.length || !analyticsDateTimeModal.startTimeIsValid || !analyticsDateTimeModal.endTimeIsValid\" class=\"btn btn-primary\" ng-click=\"analyticsDateTimeModal.fnApplyFilter()\">Apply</button></div></div><script type=\"text/ng-template\" id=\"aggregateFunction.html\"><div class=\"col-sm-12 p-0\"> <button class=\"btn btn-link p-0 pull-right\" ng-click=\"analyticsDateTimeModal.selectedTab === 1 ? analyticsDateTimeModal.isAbsoluteAdvancedView = false : analyticsDateTimeModal.isRelativeAdvancedView = false\"> Back </button> </div> <div class=\"col-sm-12 p-0\"> <label class=\"m-b-15\">For Device Health Chart</label> <div class=\"d-flex align-items-center m-b-10\" ng-repeat=\"aggOption in analyticsDateTimeModal.aggregateFunctionOptions\"> <input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"aggOption.isCheck\" ng-change=\"analyticsDateTimeModal.fnCheckUncheckHeader(aggOption)\"/> <label for=\"chk_{{$index}}\" class=\"check-box m-r-10\"></label> <span>{{aggOption.name}}</span> </div> </div></script>");
$templateCache.put("app/components/modals/attributeManageIssueModal/attributeManageIssueModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Manage Issue</strong></div><div class=\"modal-body\" ng-init=\"attributeManageIssue.fnInitModal()\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"content-box\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" ng-if=\"!attributeManageIssue.isIssueDetailsLoaded\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"attributeManageIssue.isIssueDetailsLoaded\"><div class=\"col-sm-12 h-100 p-0 d-flex justify-content-center align-items-center\" style=\"flex-direction: column;\" ng-if=\"attributeManageIssue.isFindIssue\"><div>This Attribute Issue was opened. If you want to check. Please click on the \"View Issue\" button.</div><div class=\"m-t-5\"><button class=\"btn btn-primary\" ng-click=\"attributeManageIssue.fnViewIssue()\">View Issue</button></div></div><div class=\"col-sm-12 p-0 hide-md-control\" ng-if=\"!attributeManageIssue.isFindIssue\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"attributeManageIssue.newIssueObj.issue.title\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div><div class=\"m-b-20 createIssue\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir=\"\" upload-source=\"\'tracker\'\" upload-file=\"attributeManageIssue.uploadFiles($files, filedata)\" ng-model=\"attributeManageIssue.newIssueObj.comment.body\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'vertical\'}\" on-fullscreen=\"onFullScreenCallback()\" on-fullscreen-exit=\"onFullScreenExitCallback()\" rows=\"10\">\n                                            </textarea><div class=\"markdown-footer\"><input type=\"file\" id=\"markDownFile\" name=\"file\" ng-files=\"\" upload-source=\"\'tracker\'\" upload-files=\"attributeManageIssue.uploadFiles($files, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" ng-if=\"attributeManageIssue.filePermissionsObj.Upload\" class=\"btn btn-link btn-sm m-t-5 m-b-5 pull-right\" onclick=\"document.getElementById(\'markDownFile\').click()\" ng-disabled=\"attributeManageIssue.fileUploading\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button><div class=\"pull-right m-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"attributeManageIssue.fileUploading\"></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"!attributeManageIssue.isIssueCreating\" ng-click=\"attributeManageIssue.fnCancel()\">Cancel</button> <button class=\"btn btn-primary\" ng-if=\"!attributeManageIssue.isFindIssue && !attributeManageIssue.isIssueCreating && attributeManageIssue.issuePermissionsObj.Create\" ng-click=\"attributeManageIssue.fnCreateNewIssue()\">Create Issue</button><div class=\"pull-right m-l-10\" ng-if=\"attributeManageIssue.isIssueCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/components/modals/attributeManageIssueTemplateModal/attributeManageIssueTemplateModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Manage Issue</strong></div><div class=\"modal-body\" ng-init=\"attributeManageIssue.fnInitModal()\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"content-box\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" ng-if=\"!attributeManageIssue.isIssueDetailsLoaded\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"attributeManageIssue.isIssueDetailsLoaded\"><div class=\"col-sm-12 h-100 p-0 d-flex justify-content-center align-items-center\" style=\"flex-direction: column;\" ng-if=\"attributeManageIssue.isFindIssue\"><div>This Attribute Issue was opened. If you want to check. Please click on the \"View Issue\" button.</div><div class=\"m-t-5\"><button class=\"btn btn-primary\" ng-click=\"attributeManageIssue.fnViewIssue()\">View Issue</button></div></div><div class=\"col-sm-12 p-0 hide-md-control\" ng-if=\"!attributeManageIssue.isFindIssue\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"attributeManageIssue.newIssueObj.issue.title\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div><div class=\"m-b-20 createIssue\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir=\"\" upload-source=\"\'tracker\'\" upload-file=\"attributeManageIssue.uploadFiles($files, filedata)\" ng-model=\"attributeManageIssue.newIssueObj.comment.body\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'vertical\'}\" on-fullscreen=\"onFullScreenCallback()\" on-fullscreen-exit=\"onFullScreenExitCallback()\" rows=\"10\">\n                                            </textarea><div class=\"markdown-footer\"><input type=\"file\" id=\"markDownFile\" name=\"file\" ng-files=\"\" upload-source=\"\'tracker\'\" upload-files=\"attributeManageIssue.uploadFiles($files, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" ng-if=\"attributeManageIssue.filePermissionsObj.Upload\" class=\"btn btn-link btn-sm m-t-5 m-b-5 pull-right\" onclick=\"document.getElementById(\'markDownFile\').click()\" ng-disabled=\"attributeManageIssue.fileUploading\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button><div class=\"pull-right m-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"attributeManageIssue.fileUploading\"></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" style=\"display: none\" id=\"deviceAttributeNotification\" ng-include=\"\'device-attribute-notification.html\'\"></div><div class=\"col-sm-12 p-0\" style=\"display: none\" id=\"componentAttributeNotification\" ng-include=\"\'component-attribute-notification.html\'\"></div><div class=\"col-sm-12 p-0\" style=\"display: none\" id=\"gatewayAttributeNotification\" ng-include=\"\'gateway-attribute-notification.html\'\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"!attributeManageIssue.isIssueCreating\" ng-click=\"attributeManageIssue.fnCancel()\">Cancel</button> <button class=\"btn btn-primary\" ng-if=\"!attributeManageIssue.isFindIssue && !attributeManageIssue.isIssueCreating && attributeManageIssue.issuePermissionsObj.Create\" ng-click=\"attributeManageIssue.fnCreateNewIssue()\">Create Issue</button><div class=\"pull-right m-l-10\" ng-if=\"attributeManageIssue.isIssueCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><script type=\"text/ng-template\" id=\"device-attribute-notification.html\"><table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"container-for-gmail-android\" width=\"100%\" style=\"border-collapse: collapse !important;min-width: 600px;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 20px 0 5px\" class=\"content-padding\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"header-lg\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 32px;color: #4d4d4d;text-align: center;line-height: normal;font-weight: 700;padding: 35px 0 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>! </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"free-text\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 100% !important;padding: 10px 60px 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> on your <strong> {{attributeManageIssue.deviceObj.name}} </strong> system changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>. </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"button\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 30px 0\"> <div style=\"font-family: Helvetica, Arial, sans-serif\"> <!--[if mso]> <v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}\" target=\"_blank\" style=\"height:45px;v-text-anchor:middle;width:155px;\" arcsize=\"15%\" strokecolor=\"#ffffff\" fillcolor=\"#70CCCB\"> <w:anchorlock/> <center style=\"color:#ffffff;font-family:Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;\"> Show me {{attributeManageIssue.deviceObj.name}} on {{attributeManageIssue.deviceObj.name}} </center> </v:roundrect> <![endif]--><a href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}\" target=\"_blank\" style=\"background-color: #70CCCB;border-radius: 5px;color: #fff;display: inline-block;font-family: &quot;Cabin&quot;, Helvetica, Arial, sans-serif;font-size: 14px;font-weight: regular;line-height: 45px;text-align: center;text-decoration: none !important;width: 300px;-webkit-text-size-adjust: none;mso-hide: all\"> Show me {{attributeManageIssue.ghostObj.name}} on <strong> {{attributeManageIssue.deviceObj.name}} </strong></a> </div> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 278px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Gateway</span><br style=\"font-family: Helvetica, Arial, sans-serif\"/> Name: {{attributeManageIssue.gatewayObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Connection: {{attributeManageIssue.gatewayObj.connection}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Health: {{attributeManageIssue.gatewayObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> ID: {{attributeManageIssue.gatewayObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/gateway?selectedId={{attributeManageIssue.gatewayObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 600px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Device</span><br style=\"font-family: Helvetica, Arial, sans-serif\"/> Name: {{attributeManageIssue.deviceObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Model: {{attributeManageIssue.deviceObj.oem}} {{attributeManageIssue.deviceObj.model}} (v {{attributeManageIssue.deviceObj.version}}) <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Connection: {{attributeManageIssue.deviceObj.connection}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Health: {{attributeManageIssue.deviceObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> ID: {{attributeManageIssue.deviceObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Attribute: <code> {{attributeManageIssue.ghostObj.name}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\"/> Value: <code> {{attributeManageIssue.ghostObj.value}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\"/> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </center> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;height: 100px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td style=\"padding: 25px 0 25px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <strong style=\"font-family: Helvetica, Arial, sans-serif\">Thanks</strong><br style=\"font-family: Helvetica, Arial, sans-serif\"/> The ECSite Team <br style=\"font-family: Helvetica, Arial, sans-serif\"/> </td> </tr> </table> </center> </td> </tr> </table></script><script type=\"text/ng-template\" id=\"component-attribute-notification.html\"><table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"container-for-gmail-android\" width=\"100%\" style=\"border-collapse: collapse !important;min-width: 600px;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 20px 0 5px\" class=\"content-padding\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"header-lg\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 32px;color: #4d4d4d;text-align: center;line-height: normal;font-weight: 700;padding: 35px 0 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>! </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"free-text\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 100% !important;padding: 10px 60px 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> on <strong> {{attributeManageIssue.componentObj.name}} </strong> on your <strong> {{attributeManageIssue.deviceObj.name}} </strong> system changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>. </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"button\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 30px 0\"> <div style=\"font-family: Helvetica, Arial, sans-serif\"><!--[if mso]> <v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}&selectedComponentId={{attributeManageIssue.componentObj.id}}\" target=\"_blank\" style=\"height:45px;v-text-anchor:middle;width:155px;\" arcsize=\"15%\" strokecolor=\"#ffffff\" fillcolor=\"#70CCCB\"> <w:anchorlock/> <center style=\"color:#ffffff;font-family:Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;\">Show me {{attributeManageIssue.ghostObj.name}} on {{attributeManageIssue.componentObj.name}} </center> </v:roundrect> <![endif]--><a href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}&selectedComponentId={{attributeManageIssue.componentObj.id}}\" target=\"_blank\" style=\"background-color: #70CCCB;border-radius: 5px;color: #fff;display: inline-block;font-family: &quot;Cabin&quot;, Helvetica, Arial, sans-serif;font-size: 14px;font-weight: regular;line-height: 45px;text-align: center;text-decoration: none !important;width: 300px;-webkit-text-size-adjust: none;mso-hide: all\">Show me {{attributeManageIssue.ghostObj.name}} on <strong> {{attributeManageIssue.componentObj.name}} </strong></a></div> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 278px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Gateway</span><br style=\"font-family: Helvetica, Arial, sans-serif\" /> Name: {{attributeManageIssue.gatewayObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Connection: {{attributeManageIssue.gatewayObj.connection}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Health: {{attributeManageIssue.gatewayObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> ID: {{attributeManageIssue.gatewayObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/gateway?selectedId={{attributeManageIssue.gatewayObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 600px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Device</span><br style=\"font-family: Helvetica, Arial, sans-serif\" /> Name: {{attributeManageIssue.deviceObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Model: {{attributeManageIssue.deviceObj.oem}} {{attributeManageIssue.deviceObj.model}} (v {{attributeManageIssue.deviceObj.version}}) <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Connection: {{attributeManageIssue.deviceObj.connection}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Health: {{attributeManageIssue.deviceObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> ID: {{attributeManageIssue.deviceObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 600px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Component</span><br style=\"font-family: Helvetica, Arial, sans-serif\" /> Name: {{attributeManageIssue.componentObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Index: {{attributeManageIssue.componentObj.index}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Health: {{attributeManageIssue.componentObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> ID: {{attributeManageIssue.componentObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\" /> <br style=\"font-family: Helvetica, Arial, sans-serif\" /> Attribute: <code> {{attributeManageIssue.ghostObj.name}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\" /> Value: <code> {{attributeManageIssue.ghostObj.value}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\" /> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/device?selectedId={{attributeManageIssue.deviceObj.id}}&selectedComponentId={{attributeManageIssue.componentObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </center> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;height: 100px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td style=\"padding: 25px 0 25px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <strong style=\"font-family: Helvetica, Arial, sans-serif\">Thanks</strong><br style=\"font-family: Helvetica, Arial, sans-serif\" /> The ECSite Team <br style=\"font-family: Helvetica, Arial, sans-serif\" /> </td> </tr> </table> </center> </td> </tr> </table></script><script type=\"text/ng-template\" id=\"gateway-attribute-notification.html\"><table align=\"center\" cellpadding=\"0\" cellspacing=\"0\" class=\"container-for-gmail-android\" width=\"100%\" style=\"border-collapse: collapse !important;min-width: 600px;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 20px 0 5px\" class=\"content-padding\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"header-lg\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 32px;color: #4d4d4d;text-align: center;line-height: normal;font-weight: 700;padding: 35px 0 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>! </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"free-text\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 100% !important;padding: 10px 60px 0\"> The value of <code> {{attributeManageIssue.ghostObj.name}} </code> on your <strong> {{attributeManageIssue.gatewayObj.name}} </strong> Gateway changed to <code>` {{attributeManageIssue.ghostObj.value}} `</code>. </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"button\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;padding: 30px 0\"> <div style=\"font-family: Helvetica, Arial, sans-serif\"><!--[if mso]> <v:roundrect xmlns:v=\"urn:schemas-microsoft-com:vml\" xmlns:w=\"urn:schemas-microsoft-com:office:word\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/gateway?selectedId={{attributeManageIssue.gatewayObj.id}}\" target=\"_blank\" style=\"height:45px;v-text-anchor:middle;width:155px;\" arcsize=\"15%\" strokecolor=\"#ffffff\" fillcolor=\"#70CCCB\"> <w:anchorlock/> <center style=\"color:#ffffff;font-family:Helvetica, Arial, sans-serif;font-size:14px;font-weight:regular;\"> Show me {{attributeManageIssue.ghostObj.name}} on {{attributeManageIssue.gatewayObj.name}} </center> </v:roundrect> <![endif]--><a href=\"https://console.ecsmon.ecsiteapp.com/#/node/gateway?selectedId={{attributeManageIssue.gatewayObj.id}}\" target=\"_blank\" style=\"background-color: #70CCCB;border-radius: 5px;color: #fff;display: inline-block;font-family: &quot;Cabin&quot;, Helvetica, Arial, sans-serif;font-size: 14px;font-weight: regular;line-height: 45px;text-align: center;text-decoration: none !important;width: 300px;-webkit-text-size-adjust: none;mso-hide: all\">Show me {{attributeManageIssue.ghostObj.name}} on <strong> {{attributeManageIssue.gatewayObj.name}} </strong></a></div> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"w320\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-container-left\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px;width: 278px;padding: 10px 0 10px 15px\"> <table cellpadding=\"0\" cellspacing=\"0\" width=\"100%\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block-padding\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"100%\" style=\"border-collapse: separate !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td class=\"mini-block\" style=\"border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: left;line-height: 21px;border: 1px solid #e5e5e5;border-radius: 5px;background-color: #fff;padding: 12px 15px 15px;width: 253px\"> <span class=\"header-sm\" style=\"font-family: Helvetica, Arial, sans-serif;font-size: 18px;font-weight: 700;line-height: 1.3;padding: 5px 0;color: #4d4d4d\">Gateway</span><br style=\"font-family: Helvetica, Arial, sans-serif\"/> Name: {{attributeManageIssue.gatewayObj.name}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Connection: {{attributeManageIssue.gatewayObj.connection}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Health: {{attributeManageIssue.gatewayObj.health}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> ID: {{attributeManageIssue.gatewayObj.id}} <br style=\"font-family: Helvetica, Arial, sans-serif\"/> <br style=\"font-family: Helvetica, Arial, sans-serif\"/> Attribute: <code> {{attributeManageIssue.ghostObj.name}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\"/> Value: <code> {{attributeManageIssue.ghostObj.value}} </code><br style=\"font-family: Helvetica, Arial, sans-serif\"/> <p align=\"right\"><a style=\"color: #70CCCB; text-decoration:none\" href=\"https://console.ecsmon.ecsiteapp.com/#/node/gateway?selectedId={{attributeManageIssue.gatewayObj.id}}\" target=\"_blank\">View in console</a></p> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </td> </tr> </table> </center> </td> </tr> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td align=\"center\" valign=\"top\" width=\"100%\" style=\"background-color: #f7f7f7;height: 100px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <center style=\"font-family: Helvetica, Arial, sans-serif\"> <table cellspacing=\"0\" cellpadding=\"0\" width=\"600\" class=\"w320\" style=\"border-collapse: collapse !important;font-family: Helvetica, Arial, sans-serif\"> <tr style=\"font-family: Helvetica, Arial, sans-serif\"> <td style=\"padding: 25px 0 25px;border-collapse: collapse;font-family: Helvetica, Arial, sans-serif;font-size: 14px;color: #777;text-align: center;line-height: 21px\"> <strong style=\"font-family: Helvetica, Arial, sans-serif\">Thanks</strong><br style=\"font-family: Helvetica, Arial, sans-serif\"/> The ECSite Team <br style=\"font-family: Helvetica, Arial, sans-serif\"/> </td> </tr> </table> </center> </td> </tr> </table></script></div>");
$templateCache.put("app/components/modals/attributeRenameModal/attributeRenameModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title\">{{attributeRenameModal.selectedGhostObj.name}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"attributeRenameModal.newName\" placeholder=\"New Name*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"attributeRenameModal.isGhostUpdateCompleted\" ng-click=\"attributeRenameModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"attributeRenameModal.isGhostUpdateCompleted\" ng-disabled=\"!attributeRenameModal.newName.length\" ng-click=\"attributeRenameModal.fnSave()\" tabindex=\"12\">Save</button><div class=\"pull-right m-l-10\" ng-if=\"!attributeRenameModal.isGhostUpdateCompleted\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/components/modals/chartEditor/chartEditorModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Customize Chart</strong></div><div class=\"modal-body\" ng-init=\"chartEditor.fnInitModal()\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"content-box\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 chartEditor height-100 w100\" id=\"chartEditorModal\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary-cancel\" ng-click=\"chartEditor.fnCancel()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"chartEditor.fnSaveChanges()\">Save Changes</button></div></div>");
$templateCache.put("app/components/modals/attributeStatisticsModal/attributeStatisticsModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeStatistics.fnInitModel()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Attribute Statistics</strong></div><div class=\"modal-body p-t-0\"><div class=\"row\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 d-flex align-items-center\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-t-10 m-b-0 p-b-5 ellipsis font400\">{{attributeStatistics.selectedAttribute.displayName}}</h2></div><div class=\"col-sm-6 p-0 m-t-10 text-right\" ng-class=\"attributeStatistics.isAtomicHealthLoading && attributeStatistics.isAtomicValueLoading ? \'pace opacity-5\' : \'\'\"><span class=\"cursor-pointer p-r-5\" ng-repeat=\"filterOption in attributeStatistics.filterOptions track by $index\" ng-class=\"attributeStatistics.selectedFilterOption.tabIndex === filterOption.tabIndex ? \'overview-active-link\' : \'\'\" ng-click=\"attributeStatistics.fnChangeFilterOption(filterOption)\">{{filterOption.value}} <i ng-if=\"(attributeStatistics.filterOptions.length - 1) === $index\" class=\"m-l-3 fa fa-caret-down\"></i></span> <span ng-repeat=\"chartType in attributeStatistics.chartOptions track by $index\" ng-click=\"attributeStatistics.fnChangeChartType(chartType)\" ng-class=\"attributeStatistics.selectedChartType.tabIndex === chartType.tabIndex ? \'overview-active-link\' : \'\'\"><i class=\"cursor-pointer fa\" ng-class=\"$index === 0 ? \'m-l-5 m-r-5 \' + chartType.icon : chartType.icon\"></i></span></div></div><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\" ng-if=\"attributeStatistics.selectedChartType.tabIndex === 0\"><div class=\"col-sm-12 p-0\" ng-if=\"attributeStatistics.selectedAttributeChartType === \'health\'\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 210px;overflow: hidden;\"><div class=\"col-sm-12 p-0\" ng-if=\"attributeStatistics.isAtomicHealthLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!attributeStatistics.isAtomicHealthLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"attributeStatistics.aggregateHealthArr.length\"><heat-map-chart node-id=\"gatewayObj.id\" info-section-class=\"attributeStatistics.infoSectionClass\" type=\"\'health\'\" filter-obj=\"attributeStatistics.selectedFilterObj\" is-aggregate-health=\"true\" comp-arr=\"[\'Attribute\']\" chart-data=\"attributeStatistics.aggregateHealthArr\" categories-arr=\"attributeStatistics.aggregateCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!attributeStatistics.aggregateHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0 valueChart\" ng-if=\"attributeStatistics.selectedAttributeChartType !== \'health\'\"><attribute-value-line-chart node-id=\"attributeStatistics.selectedComponent.id\" type=\"\'value\'\" filter-obj=\"attributeStatistics.selectedFilterObj\" chart-data=\"[attributeStatistics.atomicValuehArr[0]]\" value-arr=\"attributeStatistics.valuesArr\"></attribute-value-line-chart></div><div class=\"col-sm-12 p-0 text-right\"><button class=\"btn btn-link p-0\" ng-click=\"attributeStatistics.selectedAttributeChartType = attributeStatistics.selectedAttributeChartType === \'health\' ? \'value\': \'health\'\">View {{attributeStatistics.selectedAttributeChartType === \'health\'?\'Value\':\'Health\'}}</button></div></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"attributeStatistics.selectedChartType.tabIndex === 1\"><div class=\"col-sm-6 p-0\"><label>Health</label><div class=\"col-sm-12 p-0\"><button class=\"btn btn-link p-0\" ng-click=\"attributeStatistics.isShowLabel = !attributeStatistics.isShowLabel\"><small>{{attributeStatistics.isShowLabel ? \'Hide\':\'Show\'}} Label</small></button></div><pie-chart node-id=\"attributeStatistics.selectedComponent.id\" filter-obj=\"attributeStatistics.selectedFilterObj\" type=\"\'health\'\" chart-full-size=\"true\" is-show-label=\"true\" chart-data=\"attributeStatistics.attributeHealthPieData\" chart-class=\"attributeHealthPieData\"></pie-chart></div><div class=\"col-sm-6 p-0\"><label>Value</label><pie-chart node-id=\"attributeStatistics.selectedComponent.id\" filter-obj=\"attributeStatistics.selectedFilterObj\" type=\"value\" chart-full-size=\"true\" chart-data=\"attributeStatistics.attributeValuePicData\" chart-class=\"attributeValuePieData\"></pie-chart></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"attributeStatistics.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/components/modals/customYearMonthPickerModal/customYearMonthPickerModal.html","<div class=\"inmodal h-100 supplementalTemplate\" ng-init=\"yearMonthPicker.fnInitMonthPickerModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Month Picker</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 d-flex\"><h3 class=\"m-0 d-flex justify-content-center align-items-center\">Year:</h3><div class=\"col-sm-12 p-0 m-b-0 m-l-25 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\">{{yearMonthPicker.selectedDateObj.year}}</span> <label class=\"titleLabel\">Year</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left year-dropdown-overflow\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"year in yearMonthPicker.yearArr\" role=\"menuitem\"><a ng-click=\"yearMonthPicker.selectedDateObj.year = year; yearMonthPicker.fnChangeYear()\">{{year}}</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex\"><h3 class=\"m-0 d-flex justify-content-center align-items-center\">Month:</h3><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 d-flex p-t-10 m-l-10\"><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'1\',\'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 1}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'1\'\">Jan</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'2\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 2}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'2\'\">Feb</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'3\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 3}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'3\'\">Mar</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'4\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 4}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'4\'\">Apr</div></div><div class=\"col-sm-12 p-0 d-flex p-t-10 m-l-10\"><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'5\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 5}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'5\'\">May</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'6\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 6}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'6\'\">Jun</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'7\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 7}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'7\'\">Jul</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'8\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 8}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'8\'\">Aug</div></div><div class=\"col-sm-12 p-0 d-flex p-t-10 m-l-10\"><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'9\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 9}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'9\'\">Sep</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'10\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 10}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'10\'\">Oct</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'11\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 11}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'11\'\">Nov</div><div class=\"month-box d-flex justify-content-center align-items-center m-r-20\" ng-class=\"{\'selected-box\': yearMonthPicker.selectedDateObj.month === \'12\', \'pace opacity-04\': yearMonthPicker.currentYear === yearMonthPicker.selectedDateObj.year && yearMonthPicker.currentMonth < 12}\" ng-click=\"yearMonthPicker.selectedDateObj.month = \'12\'\">Dec</div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"yearMonthPicker.fnCancel()\">Cancel</button> <input type=\"button\" class=\"btn btn-primary\" ng-click=\"yearMonthPicker.fnApply()\" value=\"Apply\"></div></div>");
$templateCache.put("app/components/modals/dashboardListModal/dashboardListModal.html","<div class=\"inmodal h-100\" ng-init=\"dashboardListModal.fnInitDashboardListModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Dashboards</h3></div><div class=\"modal-body\" style=\"overflow-x: hidden;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"dashboardListModal.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{dashboardListModal.project.name ? dashboardListModal.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"dashboardListModal.dashboardsProjectSearch[dashboardListModal.dashboardsProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in dashboardListModal.filterProject=(dashboardListModal.projectsArr | filter:dashboardListModal.dashboardsProjectSearch) track by $index\" ng-click=\"dashboardListModal.fnGetProjectDashboards(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === dashboardListModal.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!dashboardListModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"dashboardListModal.isRefreshData\" search-identifier=\"\'dashboardsssearch\'\" filters-arr=\"dashboardListModal.searchFiltersArr\" filter-query=\"dashboardListModal.filterQuery\" fn-filter-query-change=\"dashboardListModal.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_dashboards\'\" no-set-url=\"true\" fn-resize=\"dashboardListModal.fnSetTableHeight()\" sort-field-arr=\"dashboardListModal.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"dashboardListModal.isDashboardsLoading\" fn-resize=\"dashboardListModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"dashboard-modal-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!dashboardListModal.isDashboardsLoading\"><thead><tr><th ng-if=\"dashboardListModal.dashboardsArr.length\" class=\"p-8\"></th><th ng-if=\"dashboardListModal.dashboardsArr.length\">Name</th><th ng-if=\"dashboardListModal.dashboardsArr.length\">Project</th><th ng-if=\"dashboardListModal.dashboardsArr.length\"></th><th ng-if=\"dashboardListModal.dashboardsArr.length\"></th><th ng-if=\"!dashboardListModal.dashboardsArr.length\">No records found...</th></tr></thead><tbody id=\"dashboardsTable\"><tr ng-repeat=\"dashboardsObj in dashboardListModal.dashboardsArr track by $index\" ng-click=\"dashboardsObj.isCheck = !dashboardsObj.isCheck;dashboardListModal.fnCheckUncheckHeader(dashboardsObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"dashboardsObj.isCheck\" ng-change=\"dashboardListModal.fnCheckUncheckHeader(dashboardsObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{dashboardsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{dashboardsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{dashboardsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{dashboardsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{dashboardsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardsObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!dashboardListModal.isDashboardsLoading && dashboardListModal.dashboardsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{dashboardListModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"dashboardListModal.perPage = 10; dashboardListModal.fnPageChanged(dashboardListModal.currentPage, dashboardListModal.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardListModal.perPage = 20; dashboardListModal.fnPageChanged(dashboardListModal.currentPage, dashboardListModal.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardListModal.perPage = 50; dashboardListModal.fnPageChanged(dashboardListModal.currentPage, dashboardListModal.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardListModal.perPage = 100; dashboardListModal.fnPageChanged(dashboardListModal.currentPage,dashboardListModal.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"dashboardListModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"dashboardListModal.currentPage\" items-per-page=\"dashboardListModal.perPage\" max-size=\"dashboardListModal.maxSize\" boundary-links=\"true\" ng-click=\"dashboardListModal.fnPageChanged(dashboardListModal.currentPage, dashboardListModal.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary-cancel\" ng-if=\"!dashboardListModal.isDashboardAdding\" ng-click=\"dashboardListModal.fnCancel()\">Close</button></div><div class=\"col-sm-6 d-flex justify-content-flex-end p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!dashboardListModal.isDashboardAdding\" ng-disabled=\"!dashboardListModal.isDashboardsObjSelected()\" ng-click=\"dashboardListModal.fnInjectDashboard()\">Inject</button><div class=\"pull-right\" ng-if=\"dashboardListModal.isDashboardAdding\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/components/modals/exportOptionsModal/exportOptionsModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Choose an export method</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"d-flex align-items-center m-b-10\" ng-repeat=\"exportOption in exportOptionsModal.exportOptions\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-change=\"exportOptionsModal.fnCheckUncheckHeader($index)\" ng-model=\"exportOption.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box m-r-10\"></label>{{exportOption.name}}</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"exportOptionsModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!exportOptionsModal.selectedExportOption\" ng-click=\"exportOptionsModal.fnSelectExportOption()\" tabindex=\"12\">Select</button></div></div>");
$templateCache.put("app/components/modals/modifyGhostAttribute/modifyGhostAttribute.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Edit the value of {{modifyGhostAttribute.selectedGhostObj[0].name}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-repeat=\"typePropertyObj in modifyGhostAttribute.selectedGhostObj track by $index\"><div class=\"md-input\" ng-if=\"typePropertyObj.type === \'String\' && typePropertyObj.name !== \'vaultId\'\" ng-class=\"typePropertyObj.isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"text\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"modifyGhostAttribute.fnValidate(typePropertyObj)\" placeholder=\"New value\"> <span class=\"highlight\"></span> <label>{{modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)}}</label> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isPatternMismatch\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div class=\"md-input\" ng-if=\"typePropertyObj.type === \'Number\'\" ng-class=\"typePropertyObj.isMinError||typePropertyObj.isMaxError ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"number\" step=\"any\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"modifyGhostAttribute.fnValidate(typePropertyObj)\" placeholder=\"New value\"> <span class=\"highlight\"></span> <label>{{modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)}}</label> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError\"><span class=\"errorText\">The value should be less than {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small></div><div ng-if=\"typePropertyObj.type === \'Boolean\'\"><div ng-bind=\"modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)\"></div><div class=\"m-t-5 m-b-40\"><switch ng-attr-id=\"{{typePropertyObj.name+$index}}\" ng-change=\"modifyGhostAttribute.fnValidate(typePropertyObj)\" ng-model=\"typePropertyObj.typeValue\"></switch><span class=\"m-l-5\">{{typePropertyObj.typeValue.toString().toUpperCase()}}</span></div></div><div class=\"m-b-0\" ng-if=\"typePropertyObj.type === \'Array\'\"><div class=\"md-input m-b-10\" ng-if=\"typePropertyObj.item === \'Number\'\" ng-class=\"typePropertyObj.arrValue || typePropertyObj.isMaxError || typePropertyObj.isPatternMismatch || typePropertyObj.isMinError?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" required=\"\" type=\"number\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && modifyGhostAttribute.fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"modifyGhostAttribute.fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" placeholder=\"New value\"> <span class=\"highlight\"></span> <label>{{modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)}}</label> <small><span class=\"helper-text\" ng-if=\"typePropertyObj.arrValue && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div class=\"md-input\" ng-if=\"typePropertyObj.item === \'String\' || typePropertyObj.item === \'\'\" ng-class=\"typePropertyObj.arrValue.length || typePropertyObj.isMaxError || typePropertyObj.isPatternMismatch || typePropertyObj.isMinError?\'m-b-30\':\'m-b-10\'\"><input class=\"md-form-control\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" required=\"\" type=\"text\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && modifyGhostAttribute.fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"modifyGhostAttribute.fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" placeholder=\"New value\"> <span class=\"highlight\"></span> <label>{{modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)}}</label> <small class=\"helper-text\"><span ng-if=\"typePropertyObj.arrValue.length && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div ng-if=\"typePropertyObj.item === \'Boolean\'\"><div class=\"md-input m-b-10\" ng-class=\"\"><input class=\"md-form-control\" required=\"\" id=\"actions\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"value for value in booleanOptionArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"modifyGhostAttribute.fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && modifyGhostAttribute.fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" placeholder=\"New value\"> <span class=\"highlight\"></span> <label>{{modifyGhostAttribute.fnSetFiledLabel(typePropertyObj.name)}}</label> <small class=\"helper-text\"><span ng-if=\"typePropertyObj.arrValue.length && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div></div><button class=\"btn btn-sm btn-default m-t-15 m-r-5\" ng-repeat=\"selectedArr in typePropertyObj.typeValue track by $index\"><span>{{selectedArr}}<i class=\"fa fa-times m-l-5\" ng-click=\"modifyGhostAttribute.fnRemoveSelectedArrayTag(typePropertyObj,$index)\"></i></span></button></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"modifyGhostAttribute.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"modifyGhostAttribute.isGhostUpdateCompleted\" ng-disabled=\"!modifyGhostAttribute.isInputValidated\" ng-click=\"modifyGhostAttribute.fnSave()\" tabindex=\"12\">Save</button><div class=\"pull-right m-l-10\" ng-if=\"!modifyGhostAttribute.isGhostUpdateCompleted\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/components/modals/ngQueryBuilderValueModal/ngQueryBuilderValueModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Functions</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div id=\"functionModal\"><div class=\"col-sm-6\" ng-repeat=\"obj in qbValueModal.functionsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"qbValueModal.fnInject(obj)\">Inject</button></div><h3 class=\"m-t-9\"><span>{{obj.name}}</span></h3></div><div class=\"panel-body\" style=\"height: 170px;\"><span>{{obj.description}}</span></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"qbValueModal.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/components/modals/nodeSupplementalFunctionModel/supplementalFunctionModel.html","<div class=\"inmodal h-100 supplementalTemplate\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Functions</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6\" ng-if=\"!supplementModal.isFunctionSelected\" id=\"functionModal\" ng-repeat=\"obj in supplementModal.functionsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"supplementModal.fnInject(obj)\">Inject</button></div><h3 class=\"m-t-9\"><span>{{obj.name}}</span></h3></div><div class=\"panel-body\" style=\"height: 170px;\"><span>{{obj.description}}</span></div></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-if=\"supplementModal.functionType === \'GPS coordinates\' && supplementModal.isFunctionSelected\"><div class=\"col-sm-12 p-0 inputContainer\"><div class=\"col-sm-12 p-0 m-b-5\"><h3>GPS Coordinate()</h3></div><div class=\"col-sm-12 p-0\" ng-repeat=\"gpsObj in supplementModal.coordinateArr\"><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"GPS Coordinate Key must be unique.\" ng-model=\"gpsObj.key\"> <span class=\"highlight\"></span> <label>Key</label><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" ng-model=\"gpsObj.value\" placeholder=\"GPS Coordinate Supplemental Value\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div></div><div class=\"col-sm-12 p-0\"><h3>Drag marker to set coordinates</h3></div></div><div class=\"col-sm-12 p-0 mapContainer\"><div class=\"col-sm-12 p-0\" id=\"supplementalMap\"></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"supplementModal.isFunctionSelected\" class=\"btn btn-link pull-left\" ng-click=\"supplementModal.fnBackToFunctions()\">Back</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"supplementModal.fnCancel()\">Cancel</button> <input type=\"button\" ng-if=\"supplementModal.isFunctionSelected\" class=\"btn btn-primary\" value=\"Inject\" ng-click=\"supplementModal.fnClose()\" ng-disabled=\"!supplementModal.fnCheckSupplementValidation()\"></div></div>");
$templateCache.put("app/components/modals/postCreateActionModal/postCreateActionModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Next Step\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-repeat=\"postOption in postCreateAction.postCreateOptionsArr\"><div class=\"col-sm-12 p-0\" ng-if=\"postOption.userStatement\"><label>{{postOption.userStatement}}</label></div></div><div class=\"col-sm-12\"><div class=\"text-center\" ng-repeat=\"postOption in postCreateAction.postCreateOptionsArr\" ng-class=\"postCreateAction.postCreateOptionsArr.length === 1 ? \'col-sm-12 p-0\' : postCreateAction.postCreateOptionsArr.length === 3 ? $index === postCreateAction.postCreateOptionsArr.length - 1 ? \'col-sm-4 p-0\' : \'col-sm-4 p-l-0\' : $index === postCreateAction.postCreateOptionsArr.length - 1 ? \'col-sm-6 p-0\' : \'col-sm-6 p-l-0\'\"><i ng-if=\"postOption.faIcon\" class=\"fa fa-10x\" ng-class=\"postOption.faIcon\"></i><svg ng-if=\"postOption.svgIcon\" class=\"dashboard-pie-chart-img m-l-10 m-r-10\" width=\"100px\" height=\"100px\"><use xlink:href=\"{{postOption.svgIcon}}\"></use></svg><br><div ng-repeat=\"subOption in postOption.subOptions\" ng-click=\"postCreateAction.fnActionSelected(subOption)\"><button class=\"btn btn-primary m-t-30 w100\">{{subOption.displayText}}</button><br></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"postCreateAction.isUserDataUpdating\"></div><button class=\"btn btn-link pull-left\" ng-if=\"!postCreateAction.isUserDataUpdating\" ng-click=\"postCreateAction.fnUpdateUserWindowChoice()\">Don\'t show this window again</button> <button type=\"button\" class=\"btn btn-link\" ng-if=\"!postCreateAction.isUserDataUpdating\" ng-click=\"postCreateAction.fnCancel()\" tabindex=\"12\">No thanks</button></div></div>");
$templateCache.put("app/components/modals/telemetryDataLoadModal/telemetryDataLoadModal.html","<div class=\"inmodal h-100\"><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><h2 class=\"m-0\">One moment...</h2></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><div class=\"p-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div></div></div></div></div>");
$templateCache.put("app/insight/insight_charts/createChart/createChart.html","<div class=\"h-100\" ng-controller=\"createInsightChartCtrl as createInsightChart\" ng-init=\"createInsightChart.fnInitCreateChart()\"><div class=\"modal-body\" id=\"createChartModalBody\"><div class=\"row\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightChart.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><g transform=\"translate(0.000000,512.000000) scale(0.100000,-0.100000)\"><path d=\"M433 4890 c-87 -23 -130 -44 -209 -104 -101 -75 -176 -189 -208 -313 -14 -54 -16 -261 -16 -1913 0 -2055 -5 -1905 66 -2041 65 -123 197 -235 333 -282 l66 -22 2065 -3 c2249 -3 2133 -5 2255 52 113 53 220 157 278 272 60 119 57 -2 57 2024 0 2055 5 1905 -66 2041 -65 123 -197 235 -333 282 l-66 22 -2075 2 c-2003 2 -2077 1 -2147 -17z m4202 -334 c113 -52 154 -124 162 -287 l6 -109 -2243 0 -2243 0 6 109 c8 163 49 235 162 287 l50 24 2025 0 2025 0 50 -24z m163 -2263 l-3 -1548 -21 -45 c-28 -59 -77 -108 -139 -136 l-50 -24 -2025 0 -2025 0 -50 24 c-63 29 -112 77 -139 136 -21 45 -21 47 -24 1593 l-2 1547 2240 0 2240 0 -2 -1547z\"></path><path d=\"M2638 2970 c-20 -11 -45 -34 -56 -52 -24 -41 -345 -1424 -344 -1486 1 -89 67 -152 162 -152 68 0 115 27 143 80 24 47 337 1412 337 1470 0 124 -130 199 -242 140z\"></path><path d=\"M1794 2656 c-36 -16 -379 -412 -400 -462 -19 -45 -17 -81 5 -129 24 -51 342 -420 384 -446 21 -13 50 -19 87 -19 96 0 160 65 160 162 0 59 -12 78 -145 232 -76 89 -114 140 -109 148 4 7 59 72 121 144 62 72 117 143 123 158 40 107 -38 227 -149 226 -25 -1 -60 -7 -77 -14z\"></path><path d=\"M3169 2647 c-70 -47 -97 -128 -69 -203 6 -15 61 -86 123 -158 62 -72 117 -137 121 -144 5 -8 -32 -58 -107 -145 -63 -73 -122 -147 -131 -165 -35 -69 -8 -171 57 -211 45 -28 129 -29 174 -2 42 26 360 395 384 446 22 48 24 84 5 129 -8 18 -95 128 -194 243 -131 153 -189 213 -213 222 -52 18 -112 14 -150 -12z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightChart.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 -17 512 512\" width=\"26px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"m74.722656 297.265625h-51.734375c-12.675781 0-22.988281 10.3125-22.988281 22.992187v134.375c0 12.675782 10.3125 22.988282 22.988281 22.988282h51.734375c12.679688 0 22.992188-10.3125 22.992188-22.988282v-134.375c0-12.679687-10.3125-22.992187-22.992188-22.992187zm7.992188 157.367187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734375c-4.402343 0-7.988281-3.585938-7.988281-7.988282v-134.375c0-4.40625 3.585938-7.992187 7.988281-7.992187h51.734375c4.40625 0 7.992188 3.585937 7.992188 7.992187zm0 0\"></path><path d=\"m212.820312 191.945312h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988282v42.644531c0 4.140625 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359375 7.5-7.5v-42.644531c0-4.402344 3.582032-7.988282 7.988282-7.988282h51.734374c4.40625 0 7.988282 3.585938 7.988282 7.988282v239.699218c0 4.402344-3.582032 7.988282-7.988282 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-167.054687c0-4.140625-3.359375-7.5-7.5-7.5-4.144531 0-7.5 3.359375-7.5 7.5v167.054687c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.675782 0 22.988282-10.3125 22.988282-22.988282v-239.695312c0-12.679688-10.3125-22.992188-22.988282-22.992188zm0 0\"></path><path d=\"m350.914062 255.140625h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988281v176.503906c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.679688 0 22.992188-10.3125 22.992188-22.988282v-176.503906c0-12.675781-10.3125-22.988281-22.992188-22.988281zm7.992188 199.492187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-176.503906c0-4.40625 3.582032-7.988281 7.988282-7.988281h51.734374c4.40625 0 7.992188 3.582031 7.992188 7.988281zm0 0\"></path><path d=\"m489.011719 139.285156h-51.734375c-12.675782 0-22.992188 10.3125-22.992188 22.988282v214.304687c0 4.140625 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.359375 7.5-7.5v-214.304687c0-4.40625 3.585938-7.988282 7.992188-7.988282h51.734375c4.402343 0 7.988281 3.582032 7.988281 7.988282v292.359374c0 4.402344-3.585938 7.988282-7.988281 7.988282h-51.734375c-4.40625 0-7.992188-3.585938-7.992188-7.988282v-48.054687c0-4.140625-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.359375-7.5 7.5v48.054687c0 12.675782 10.316406 22.988282 22.992188 22.988282h51.734375c12.675781 0 22.988281-10.3125 22.988281-22.988282v-292.359374c0-12.675782-10.3125-22.988282-22.988281-22.988282zm0 0\"></path><path d=\"m48.855469 157.980469c-25.765625 0-46.730469 20.964843-46.730469 46.730469 0 25.769531 20.964844 46.734374 46.730469 46.734374 25.769531 0 46.734375-20.964843 46.734375-46.734374 0-2.046876-.148438-4.054688-.402344-6.03125l73.683594-56.199219c5.5625 2.34375 11.675781 3.644531 18.082031 3.644531 10.101563 0 19.457031-3.234375 27.109375-8.703125l64.460938 29.496094c2.195312 23.742187 22.21875 42.398437 46.523437 42.398437 25.769531 0 46.734375-20.964844 46.734375-46.730468 0-2.792969-.261719-5.523438-.730469-8.179688l76.027344-63.789062c5.011719 1.84375 10.425781 2.847656 16.066406 2.847656 25.765625 0 46.730469-20.964844 46.730469-46.734375 0-25.765625-20.964844-46.730469-46.730469-46.730469-25.769531 0-46.734375 20.964844-46.734375 46.730469 0 2.792969.261719 5.523437.730469 8.179687l-76.03125 63.789063c-5.007813-1.839844-10.421875-2.847657-16.0625-2.847657-10.101563 0-19.457031 3.234376-27.109375 8.707032l-64.460938-29.5c-2.195312-23.742188-22.214843-42.398438-46.523437-42.398438-25.769531 0-46.730469 20.964844-46.730469 46.730469 0 2.046875.144532 4.058594.402344 6.035156l-73.6875 56.195313c-5.566406-2.34375-11.671875-3.640625-18.082031-3.640625zm414.289062-142.980469c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.496093-14.234375 31.734375-31.730469 31.734375-17.234375 0-31.734375-14.5-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-40.5625 54.925781c.125.21875.261719.429688.390625.644531 2.710938 4.566407 6.199219 8.667969 10.277344 12.070313l-67.640625 56.746094c-.125-.21875-2.175781-3.476563-3.179687-4.816407-2.179688-2.90625-4.691407-5.5625-7.488282-7.898437zm-129.261719 92.191407c.257813-17.007813 14.621094-31.265626 31.726563-31.265626 17.054687 0 31.730469 14.582032 31.730469 31.734376 0 17.496093-14.234375 31.730468-31.730469 31.730468s-31.730469-14.234375-31.730469-31.730468c0-.15625 0-.3125.003906-.46875zm-67.832031-36.328126c3.070313-4.507812 5.386719-9.519531 6.738281-14.804687l54.46875 24.921875c-2.773437 3.996094-4.941406 8.433594-6.359374 13.089844-.203126.660156-.390626 1.324218-.5625 1.992187l-54.46875-24.921875c.0625-.089844.121093-.183594.183593-.277344zm-38.535156-58.128906c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.09375-14.664063 31.734375-31.730469 31.734375-17.074219 0-31.734375-14.5625-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-41.597656 53.019532c.089843.171874.191406.34375.28125.515624 2.507812 4.742188 5.832031 9.054688 9.789062 12.675782l-64.972656 49.554687c-1.203125-2.34375-2.617187-4.59375-4.195313-6.699219-1.75-2.335937-3.710937-4.515624-5.875-6.496093zm-77.589844 58.824218c7.699219 5.859375 12.824219 15.085938 12.824219 25.207032 0 17.5-14.234375 31.734374-31.734375 31.734374-17.496094 0-31.730469-14.234374-31.730469-31.734374 0-17.496094 14.234375-31.730469 31.730469-31.730469 6.976562 0 13.566406 2.449219 18.910156 6.523437zm0 0\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightChart.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon m-t-5 m-l-5\"><g><path d=\"m184.296875 512c-4.199219 0-8.277344-1.644531-11.304687-4.691406-3.925782-3.925782-5.527344-9.582032-4.265626-14.976563l23.253907-98.667969c.679687-2.902343 2.152343-5.546874 4.265625-7.636718l203.648437-203.648438c18.109375-18.132812 49.75-18.15625 67.882813 0l30.164062 30.164063c9.066406 9.046875 14.058594 21.121093 14.058594 33.921875 0 12.820312-4.992188 24.894531-14.058594 33.941406l-203.648437 203.625c-2.113281 2.113281-4.757813 3.585938-7.636719 4.265625l-98.667969 23.253906c-1.234375.320313-2.472656.449219-3.691406.449219zm37.78125-106.582031-16.277344 69.078125 69.078125-16.277344 200.429688-200.425781c3.027344-3.03125 4.691406-7.039063 4.691406-11.308594 0-4.265625-1.664062-8.296875-4.691406-11.304687l-30.167969-30.167969c-6.25-6.226563-16.382813-6.25-22.632813 0zm60.910156 67.328125h.210938zm0 0\"></path><path d=\"m433.835938 337.898438c-4.097657 0-8.191407-1.558594-11.308594-4.691407l-75.433594-75.4375c-6.25-6.25-6.25-16.382812 0-22.632812s16.382812-6.25 22.632812 0l75.4375 75.433593c6.25 6.25 6.25 16.382813 0 22.636719-3.136718 3.132813-7.234374 4.691407-11.328124 4.691407zm0 0\"></path><path d=\"m145.921875 448h-97.921875c-26.476562 0-48-21.523438-48-48v-352c0-26.476562 21.523438-48 48-48h309.332031c26.476563 0 48 21.523438 48 48v98.773438c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-98.773438c0-8.832031-7.167969-16-16-16h-309.332031c-8.832031 0-16 7.167969-16 16v352c0 8.832031 7.167969 16 16 16h97.921875c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m389.332031 138.667969h-373.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h373.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m310.828125 245.332031h-294.828125c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h294.828125c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352h-186.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h186.667969c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352c-8.832031 0-16-7.167969-16-16v-213.332031c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v213.332031c0 8.832031-7.167969 16-16 16zm0 0\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightChart.activeStep === 4}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"M410.34277,18.34277,388.68555,40H360a8.00039,8.00039,0,0,0-8,8V76.68555L324.68555,104H296a8.00039,8.00039,0,0,0-8,8v28.68555L260.68555,168H232a8.00039,8.00039,0,0,0-8,8v28.68555L188.68652,240H161.33423a95.64587,95.64587,0,0,1,42.97925-64.91309l-8.627-13.47461A112.00943,112.00943,0,0,0,256,368H358.75293A152.11931,152.11931,0,0,1,256,408c-83.81348,0-152-68.18652-152-152H88a167.79394,167.79394,0,0,0,4.82446,40H32V216H96a8,8,0,0,0,7.39062-4.93848l12.92188-31.19629a8.00028,8.00028,0,0,0-1.7334-8.71875l-45.25586-45.2539,56.56934-56.56934,45.2539,45.25586a7.99745,7.99745,0,0,0,8.71875,1.7334l31.19629-12.92188A8,8,0,0,0,216,96V32h80V80h16V24a8.00039,8.00039,0,0,0-8-8H208a8.00039,8.00039,0,0,0-8,8V90.6543l-21.31934,8.831L131.5498,52.35254a8.0018,8.0018,0,0,0-11.31445,0L52.35254,120.23535a8.0018,8.0018,0,0,0,0,11.31445l47.13281,47.13086L90.6543,200H24a8.00039,8.00039,0,0,0-8,8v96a8.00039,8.00039,0,0,0,8,8H90.6543l8.831,21.31934L52.35254,380.4502a8.0018,8.0018,0,0,0,0,11.31445l67.88281,67.88281a8.0018,8.0018,0,0,0,11.31445,0l47.13086-47.13281L200,421.3457V488a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V421.3457l21.31934-8.83105,47.13086,47.13281a8.0018,8.0018,0,0,0,11.31445,0l67.88281-67.88281a8.00062,8.00062,0,0,0-.001-11.31445L447.19629,368H488a8.00039,8.00039,0,0,0,8-8V88a8.00039,8.00039,0,0,0-8-8H424a8.00039,8.00039,0,0,0-8,8v56H360a8.00039,8.00039,0,0,0-8,8v40H296a8.00039,8.00039,0,0,0-8,8v48H232a8.00039,8.00039,0,0,0-8,8v32H165.491A95.5652,95.5652,0,0,1,160,256h32a8.00235,8.00235,0,0,0,5.65723-2.34277L235.31445,216H264a8.00039,8.00039,0,0,0,8-8V179.31445L299.31445,152H328a8.00039,8.00039,0,0,0,8-8V115.31445L363.31445,88H392a8.00039,8.00039,0,0,0,8-8V51.31445L419.31348,32H496V16H416A8.00235,8.00235,0,0,0,410.34277,18.34277Zm-284.45019,424.334L69.32324,386.10742l43.04395-43.042a169.30277,169.30277,0,0,0,56.56738,56.56738ZM216,480V419.17554a167.97791,167.97791,0,0,0,80-.01514V480Zm226.67676-93.89258-56.56934,56.56934-43.032-43.03369A168.05664,168.05664,0,0,0,381.20654,368h43.36182ZM432,96h48V352H432V96Zm-64,64h48V352H368V160Zm-64,48h48V352H304V208Zm-64,56h48v88H256a96.21362,96.21362,0,0,1-16-1.34082V264Zm-16,40v42.509A96.52,96.52,0,0,1,172.887,304Zm32-104H240V184h16Zm64-64H304V120h16Zm64-64H368V56h16Z\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightChart.activeStep === 5}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 56 56\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M8,14c3.519,0,6.432-2.614,6.92-6H54c0.553,0,1-0.447,1-1s-0.447-1-1-1H14.92C14.432,2.614,11.519,0,8,0 C4.14,0,1,3.141,1,7S4.14,14,8,14z M8,2c2.757,0,5,2.243,5,5s-2.243,5-5,5S3,9.757,3,7S5.243,2,8,2z\"></path><path d=\"M48,42c-3.519,0-6.432,2.614-6.92,6H2c-0.552,0-1,0.447-1,1s0.448,1,1,1h39.08c0.488,3.386,3.401,6,6.92,6 c3.859,0,7-3.141,7-7S51.859,42,48,42z M48,54c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S50.757,54,48,54z\"></path><path d=\"M54,27H35.368c-0.396-3.602-3.455-6.414-7.161-6.414c-3.706,0-6.765,2.813-7.161,6.414H2c-0.552,0-1,0.447-1,1s0.448,1,1,1 h19.109c0.577,3.4,3.536,6,7.098,6c3.562,0,6.52-2.6,7.097-6H54c0.553,0,1-0.447,1-1S54.553,27,54,27z M28.207,33 C25.336,33,23,30.664,23,27.793s2.336-5.207,5.207-5.207s5.207,2.336,5.207,5.207S31.078,33,28.207,33z\"></path></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightChart.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Queries</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\" style=\"overflow-x: hidden !important;\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"createInsightChart.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{createInsightChart.project.name ? createInsightChart.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightChart.queriesProjectSearch[createInsightChart.queriesProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightChart.filterProject=(createInsightChart.projectsArr | filter:createInsightChart.queriesProjectSearch) track by $index\" ng-click=\"createInsightChart.fnGetProjectQueries(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createInsightChart.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createInsightChart.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createInsightChart.isRefreshData\" search-identifier=\"\'queriesssearch\'\" filters-arr=\"createInsightChart.searchFiltersArr\" filter-query=\"createInsightChart.filterQuery\" fn-filter-query-change=\"createInsightChart.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_queries\'\" no-set-url=\"true\" fn-resize=\"createInsightChart.fnSetTableHeight()\" sort-field-arr=\"createInsightChart.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"createInsightChart.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createInsightChart.isQueriesLoading\" fn-resize=\"createInsightChart.fnSetLoaderTableHeight()\"></table-loader><div class=\"chart-queries-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!createInsightChart.isQueriesLoading\"><thead><tr><th ng-if=\"createInsightChart.queriesArr.length\" class=\"p-8\"></th><th ng-if=\"createInsightChart.queriesArr.length\">Name</th><th ng-if=\"createInsightChart.queriesArr.length\">Project</th><th ng-if=\"createInsightChart.queriesArr.length\"></th><th ng-if=\"createInsightChart.queriesArr.length\"></th><th ng-if=\"!createInsightChart.queriesArr.length\">No records found...</th></tr></thead><tbody id=\"queriesTable\"><tr ng-repeat=\"queriesObj in createInsightChart.queriesArr track by $index\" ng-click=\"queriesObj.isCheck = !queriesObj.isCheck;createInsightChart.fnCheckUncheckHeader(queriesObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"queriesObj.isCheck\" ng-change=\"createInsightChart.fnCheckUncheckHeader(queriesObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{queriesObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{queriesObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{queriesObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{queriesObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{queriesObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createInsightChart.isQueriesLoading && createInsightChart.queriesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createInsightChart.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createInsightChart.perPage = 10; createInsightChart.fnPageChanged(createInsightChart.currentPage, createInsightChart.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightChart.perPage = 20; createInsightChart.fnPageChanged(createInsightChart.currentPage, createInsightChart.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightChart.perPage = 50; createInsightChart.fnPageChanged(createInsightChart.currentPage, createInsightChart.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightChart.perPage = 100; createInsightChart.fnPageChanged(createInsightChart.currentPage,createInsightChart.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createInsightChart.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createInsightChart.currentPage\" items-per-page=\"createInsightChart.perPage\" max-size=\"createInsightChart.maxSize\" boundary-links=\"true\" ng-click=\"createInsightChart.fnPageChanged(createInsightChart.currentPage, createInsightChart.perPage)\"></ul></div></div></div></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightChart.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Charts</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12\"><label>Selected Chart: Pie</label></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 25px);\"><div id=\"chartEditor\" class=\"col-sm-12 p-0 chartEditor width-inherit height-100\"></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightChart.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Chart data mapping</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 height-100 d-flex align-items-center justify-content-center\" ng-if=\"createInsightChart.isQuerySearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 height-100 floatingLabelInput\" ng-if=\"!createInsightChart.isQuerySearchDataLoading\"><div class=\"col-sm-12 p-0 m-b-10 d-flex align-items-center\"><div class=\"col-sm-6 p-0\"></div><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightChart.isAllowMultiField\" ng-click=\"createInsightChart.fnAddNewMapping()\"><i class=\"fa fa-plus m-r-5\"></i>Add New Mapping</button></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><h3 class=\"m-b-20\">Available Fields</h3><div class=\"availableField col-sm-12 p-0 d-flex align-items-center m-b-10 p-5\" ng-repeat=\"headerObj in createInsightChart.querySearchDataHeader\" ng-class=\"{ \'p-b-5\': !$last, \'opacity-5\': headerObj.isPlotted}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg ng-if=\"headerObj.type === \'string\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"headerObj.type === \'number\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"headerObj.type === \'decimal\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"headerObj.type === \'boolean\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"headerObj.type === \'date\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"headerObj.type === \'object\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"headerObj.type === \'array\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-11 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><strong>{{headerObj.name}}</strong></label></div></div></div><div class=\"col-sm-7 p-0\"><h3 class=\"m-b-20\">Used Fields</h3><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-repeat=\"data in createInsightChart.dataConfig track by $index\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"data.value\" typeahead-editable=\"true\" uib-typeahead=\"dataHeader for dataHeader in createInsightChart.apiDataHeader | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-on-select=\"createInsightChart.fnDataConfigSelected()\" placeholder=\"Field {{data.isRequired ? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{data.key}} {{data.isRequired ? \'*\' : \'\'}}</label></div></div><div class=\"m-t-5\" style=\"width: 18px;\"><button ng-show=\"!data.isRequired\" class=\"btn btn-link p-r-0 p-l-0\" ng-click=\"createInsightChart.fnRemoveMapping($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightChart.activeStep === 4}\" role=\"tabpanel\" id=\"step4\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Chart Configuration</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"createInsightChart.fnEditChartProperties()\"><i class=\"fa fa-edit m-r-5\"></i>Customize chart</button></div><div class=\"col-sm-12 height-100 p-t-20 HighChartPie HighChartBarChart\"><div id=\"previewChart\" style=\"height: 500px;\" class=\"col-sm-12 p-0 previewChart width-inherit\"></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightChart.activeStep === 5}\" role=\"tabpanel\" id=\"step5\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Preview</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 m-t-20\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightChart.newChartObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightChart.newChartObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></form></div></div><div class=\"col-sm-4\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div id=\"finalPreviewChart\" class=\"col-sm-12 p-0 finalPreviewChart width-inherit\"></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createInsightChart.activeStep === 1\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{createInsightChart.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : createInsightChart.isRefresh}\" ng-click=\"createInsightChart.fnReload();\" aria-hidden=\"true\"></i></div></div></div><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left\" ng-if=\"createInsightChart.activeStep !== 1 && !createInsightChart.isChartCreating\" ng-click=\"createInsightChart.fnGotoPreviousNextStep(true)\">Back</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightChart.activeStep === 1\" ng-disabled=\"!createInsightChart.isQueriesObjSelected()\" ng-click=\"createInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightChart.activeStep === 2\" ng-click=\"createInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightChart.activeStep === 3\" ng-disabled=\"!createInsightChart.fnCheckRequiredInput()\" ng-click=\"createInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightChart.activeStep === 4\" ng-click=\"createInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createInsightChart.newChartObj.name.length\" ng-click=\"createInsightChart.fnCreateNewChart(createInsightChart.newChartObj)\" ng-if=\"createInsightChart.activeStep === 5 && !createInsightChart.isChartCreating\">Save Chart</button><div class=\"pull-right\" ng-if=\"createInsightChart.activeStep === 5 && createInsightChart.isChartCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_charts/insightChartInfo/insightChartInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Chart</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{chartObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{chartObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{chartObj.description ? chartObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{chartObj.description ? chartObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{chartObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(chartObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/insight/insight_charts/updateChart/updateChart.html","<div class=\"h-100\" ng-controller=\"updateInsightChartCtrl as updateInsightChart\" ng-init=\"updateInsightChart.fnInitUpdateChart()\"><div class=\"modal-body\" id=\"updateChartModalBody\"><div class=\"row update-chart\" ng-if=\"!updateInsightChart.isChartDetailsLoaded\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div></div><div class=\"row update-chart\" ng-if=\"updateInsightChart.isChartDetailsLoaded\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': updateInsightChart.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 -17 512 512\" width=\"26px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"m74.722656 297.265625h-51.734375c-12.675781 0-22.988281 10.3125-22.988281 22.992187v134.375c0 12.675782 10.3125 22.988282 22.988281 22.988282h51.734375c12.679688 0 22.992188-10.3125 22.992188-22.988282v-134.375c0-12.679687-10.3125-22.992187-22.992188-22.992187zm7.992188 157.367187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734375c-4.402343 0-7.988281-3.585938-7.988281-7.988282v-134.375c0-4.40625 3.585938-7.992187 7.988281-7.992187h51.734375c4.40625 0 7.992188 3.585937 7.992188 7.992187zm0 0\"></path><path d=\"m212.820312 191.945312h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988282v42.644531c0 4.140625 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359375 7.5-7.5v-42.644531c0-4.402344 3.582032-7.988282 7.988282-7.988282h51.734374c4.40625 0 7.988282 3.585938 7.988282 7.988282v239.699218c0 4.402344-3.582032 7.988282-7.988282 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-167.054687c0-4.140625-3.359375-7.5-7.5-7.5-4.144531 0-7.5 3.359375-7.5 7.5v167.054687c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.675782 0 22.988282-10.3125 22.988282-22.988282v-239.695312c0-12.679688-10.3125-22.992188-22.988282-22.992188zm0 0\"></path><path d=\"m350.914062 255.140625h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988281v176.503906c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.679688 0 22.992188-10.3125 22.992188-22.988282v-176.503906c0-12.675781-10.3125-22.988281-22.992188-22.988281zm7.992188 199.492187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-176.503906c0-4.40625 3.582032-7.988281 7.988282-7.988281h51.734374c4.40625 0 7.992188 3.582031 7.992188 7.988281zm0 0\"></path><path d=\"m489.011719 139.285156h-51.734375c-12.675782 0-22.992188 10.3125-22.992188 22.988282v214.304687c0 4.140625 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.359375 7.5-7.5v-214.304687c0-4.40625 3.585938-7.988282 7.992188-7.988282h51.734375c4.402343 0 7.988281 3.582032 7.988281 7.988282v292.359374c0 4.402344-3.585938 7.988282-7.988281 7.988282h-51.734375c-4.40625 0-7.992188-3.585938-7.992188-7.988282v-48.054687c0-4.140625-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.359375-7.5 7.5v48.054687c0 12.675782 10.316406 22.988282 22.992188 22.988282h51.734375c12.675781 0 22.988281-10.3125 22.988281-22.988282v-292.359374c0-12.675782-10.3125-22.988282-22.988281-22.988282zm0 0\"></path><path d=\"m48.855469 157.980469c-25.765625 0-46.730469 20.964843-46.730469 46.730469 0 25.769531 20.964844 46.734374 46.730469 46.734374 25.769531 0 46.734375-20.964843 46.734375-46.734374 0-2.046876-.148438-4.054688-.402344-6.03125l73.683594-56.199219c5.5625 2.34375 11.675781 3.644531 18.082031 3.644531 10.101563 0 19.457031-3.234375 27.109375-8.703125l64.460938 29.496094c2.195312 23.742187 22.21875 42.398437 46.523437 42.398437 25.769531 0 46.734375-20.964844 46.734375-46.730468 0-2.792969-.261719-5.523438-.730469-8.179688l76.027344-63.789062c5.011719 1.84375 10.425781 2.847656 16.066406 2.847656 25.765625 0 46.730469-20.964844 46.730469-46.734375 0-25.765625-20.964844-46.730469-46.730469-46.730469-25.769531 0-46.734375 20.964844-46.734375 46.730469 0 2.792969.261719 5.523437.730469 8.179687l-76.03125 63.789063c-5.007813-1.839844-10.421875-2.847657-16.0625-2.847657-10.101563 0-19.457031 3.234376-27.109375 8.707032l-64.460938-29.5c-2.195312-23.742188-22.214843-42.398438-46.523437-42.398438-25.769531 0-46.730469 20.964844-46.730469 46.730469 0 2.046875.144532 4.058594.402344 6.035156l-73.6875 56.195313c-5.566406-2.34375-11.671875-3.640625-18.082031-3.640625zm414.289062-142.980469c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.496093-14.234375 31.734375-31.730469 31.734375-17.234375 0-31.734375-14.5-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-40.5625 54.925781c.125.21875.261719.429688.390625.644531 2.710938 4.566407 6.199219 8.667969 10.277344 12.070313l-67.640625 56.746094c-.125-.21875-2.175781-3.476563-3.179687-4.816407-2.179688-2.90625-4.691407-5.5625-7.488282-7.898437zm-129.261719 92.191407c.257813-17.007813 14.621094-31.265626 31.726563-31.265626 17.054687 0 31.730469 14.582032 31.730469 31.734376 0 17.496093-14.234375 31.730468-31.730469 31.730468s-31.730469-14.234375-31.730469-31.730468c0-.15625 0-.3125.003906-.46875zm-67.832031-36.328126c3.070313-4.507812 5.386719-9.519531 6.738281-14.804687l54.46875 24.921875c-2.773437 3.996094-4.941406 8.433594-6.359374 13.089844-.203126.660156-.390626 1.324218-.5625 1.992187l-54.46875-24.921875c.0625-.089844.121093-.183594.183593-.277344zm-38.535156-58.128906c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.09375-14.664063 31.734375-31.730469 31.734375-17.074219 0-31.734375-14.5625-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-41.597656 53.019532c.089843.171874.191406.34375.28125.515624 2.507812 4.742188 5.832031 9.054688 9.789062 12.675782l-64.972656 49.554687c-1.203125-2.34375-2.617187-4.59375-4.195313-6.699219-1.75-2.335937-3.710937-4.515624-5.875-6.496093zm-77.589844 58.824218c7.699219 5.859375 12.824219 15.085938 12.824219 25.207032 0 17.5-14.234375 31.734374-31.734375 31.734374-17.496094 0-31.730469-14.234374-31.730469-31.734374 0-17.496094 14.234375-31.730469 31.730469-31.730469 6.976562 0 13.566406 2.449219 18.910156 6.523437zm0 0\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': updateInsightChart.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon m-t-5 m-l-5\"><g><path d=\"m184.296875 512c-4.199219 0-8.277344-1.644531-11.304687-4.691406-3.925782-3.925782-5.527344-9.582032-4.265626-14.976563l23.253907-98.667969c.679687-2.902343 2.152343-5.546874 4.265625-7.636718l203.648437-203.648438c18.109375-18.132812 49.75-18.15625 67.882813 0l30.164062 30.164063c9.066406 9.046875 14.058594 21.121093 14.058594 33.921875 0 12.820312-4.992188 24.894531-14.058594 33.941406l-203.648437 203.625c-2.113281 2.113281-4.757813 3.585938-7.636719 4.265625l-98.667969 23.253906c-1.234375.320313-2.472656.449219-3.691406.449219zm37.78125-106.582031-16.277344 69.078125 69.078125-16.277344 200.429688-200.425781c3.027344-3.03125 4.691406-7.039063 4.691406-11.308594 0-4.265625-1.664062-8.296875-4.691406-11.304687l-30.167969-30.167969c-6.25-6.226563-16.382813-6.25-22.632813 0zm60.910156 67.328125h.210938zm0 0\"></path><path d=\"m433.835938 337.898438c-4.097657 0-8.191407-1.558594-11.308594-4.691407l-75.433594-75.4375c-6.25-6.25-6.25-16.382812 0-22.632812s16.382812-6.25 22.632812 0l75.4375 75.433593c6.25 6.25 6.25 16.382813 0 22.636719-3.136718 3.132813-7.234374 4.691407-11.328124 4.691407zm0 0\"></path><path d=\"m145.921875 448h-97.921875c-26.476562 0-48-21.523438-48-48v-352c0-26.476562 21.523438-48 48-48h309.332031c26.476563 0 48 21.523438 48 48v98.773438c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-98.773438c0-8.832031-7.167969-16-16-16h-309.332031c-8.832031 0-16 7.167969-16 16v352c0 8.832031 7.167969 16 16 16h97.921875c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m389.332031 138.667969h-373.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h373.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m310.828125 245.332031h-294.828125c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h294.828125c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352h-186.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h186.667969c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352c-8.832031 0-16-7.167969-16-16v-213.332031c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v213.332031c0 8.832031-7.167969 16-16 16zm0 0\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': updateInsightChart.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"M410.34277,18.34277,388.68555,40H360a8.00039,8.00039,0,0,0-8,8V76.68555L324.68555,104H296a8.00039,8.00039,0,0,0-8,8v28.68555L260.68555,168H232a8.00039,8.00039,0,0,0-8,8v28.68555L188.68652,240H161.33423a95.64587,95.64587,0,0,1,42.97925-64.91309l-8.627-13.47461A112.00943,112.00943,0,0,0,256,368H358.75293A152.11931,152.11931,0,0,1,256,408c-83.81348,0-152-68.18652-152-152H88a167.79394,167.79394,0,0,0,4.82446,40H32V216H96a8,8,0,0,0,7.39062-4.93848l12.92188-31.19629a8.00028,8.00028,0,0,0-1.7334-8.71875l-45.25586-45.2539,56.56934-56.56934,45.2539,45.25586a7.99745,7.99745,0,0,0,8.71875,1.7334l31.19629-12.92188A8,8,0,0,0,216,96V32h80V80h16V24a8.00039,8.00039,0,0,0-8-8H208a8.00039,8.00039,0,0,0-8,8V90.6543l-21.31934,8.831L131.5498,52.35254a8.0018,8.0018,0,0,0-11.31445,0L52.35254,120.23535a8.0018,8.0018,0,0,0,0,11.31445l47.13281,47.13086L90.6543,200H24a8.00039,8.00039,0,0,0-8,8v96a8.00039,8.00039,0,0,0,8,8H90.6543l8.831,21.31934L52.35254,380.4502a8.0018,8.0018,0,0,0,0,11.31445l67.88281,67.88281a8.0018,8.0018,0,0,0,11.31445,0l47.13086-47.13281L200,421.3457V488a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V421.3457l21.31934-8.83105,47.13086,47.13281a8.0018,8.0018,0,0,0,11.31445,0l67.88281-67.88281a8.00062,8.00062,0,0,0-.001-11.31445L447.19629,368H488a8.00039,8.00039,0,0,0,8-8V88a8.00039,8.00039,0,0,0-8-8H424a8.00039,8.00039,0,0,0-8,8v56H360a8.00039,8.00039,0,0,0-8,8v40H296a8.00039,8.00039,0,0,0-8,8v48H232a8.00039,8.00039,0,0,0-8,8v32H165.491A95.5652,95.5652,0,0,1,160,256h32a8.00235,8.00235,0,0,0,5.65723-2.34277L235.31445,216H264a8.00039,8.00039,0,0,0,8-8V179.31445L299.31445,152H328a8.00039,8.00039,0,0,0,8-8V115.31445L363.31445,88H392a8.00039,8.00039,0,0,0,8-8V51.31445L419.31348,32H496V16H416A8.00235,8.00235,0,0,0,410.34277,18.34277Zm-284.45019,424.334L69.32324,386.10742l43.04395-43.042a169.30277,169.30277,0,0,0,56.56738,56.56738ZM216,480V419.17554a167.97791,167.97791,0,0,0,80-.01514V480Zm226.67676-93.89258-56.56934,56.56934-43.032-43.03369A168.05664,168.05664,0,0,0,381.20654,368h43.36182ZM432,96h48V352H432V96Zm-64,64h48V352H368V160Zm-64,48h48V352H304V208Zm-64,56h48v88H256a96.21362,96.21362,0,0,1-16-1.34082V264Zm-16,40v42.509A96.52,96.52,0,0,1,172.887,304Zm32-104H240V184h16Zm64-64H304V120h16Zm64-64H368V56h16Z\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': updateInsightChart.activeStep === 4}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 56 56\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M8,14c3.519,0,6.432-2.614,6.92-6H54c0.553,0,1-0.447,1-1s-0.447-1-1-1H14.92C14.432,2.614,11.519,0,8,0 C4.14,0,1,3.141,1,7S4.14,14,8,14z M8,2c2.757,0,5,2.243,5,5s-2.243,5-5,5S3,9.757,3,7S5.243,2,8,2z\"></path><path d=\"M48,42c-3.519,0-6.432,2.614-6.92,6H2c-0.552,0-1,0.447-1,1s0.448,1,1,1h39.08c0.488,3.386,3.401,6,6.92,6 c3.859,0,7-3.141,7-7S51.859,42,48,42z M48,54c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S50.757,54,48,54z\"></path><path d=\"M54,27H35.368c-0.396-3.602-3.455-6.414-7.161-6.414c-3.706,0-6.765,2.813-7.161,6.414H2c-0.552,0-1,0.447-1,1s0.448,1,1,1 h19.109c0.577,3.4,3.536,6,7.098,6c3.562,0,6.52-2.6,7.097-6H54c0.553,0,1-0.447,1-1S54.553,27,54,27z M28.207,33 C25.336,33,23,30.664,23,27.793s2.336-5.207,5.207-5.207s5.207,2.336,5.207,5.207S31.078,33,28.207,33z\"></path></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : updateInsightChart.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Charts</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12\"><label>Selected Chart: {{updateInsightChart.selectChartObj && updateInsightChart.selectChartObj.definition && updateInsightChart.selectChartObj.definition.chartType !== \'\' ? updateInsightChart.selectChartObj.definition.chartType : \'pie\'}}</label></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 25px);\"><div id=\"chartEditor\" class=\"col-sm-12 p-0 chartEditor width-inherit height-100\"></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : updateInsightChart.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12 height-100\"><div class=\"col-sm-12 p-0 height-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-10 d-flex align-items-center\"><div class=\"col-sm-6 p-0\"><label class=\"m-0\">Table field mapping for chart data:</label></div><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"updateInsightChart.isAllowMultiField\" ng-click=\"updateInsightChart.fnAddNewMapping()\"><i class=\"fa fa-plus m-r-5\"></i>Add New Mapping</button></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><h3 class=\"m-b-20\">Available Fields</h3><div class=\"availableField col-sm-12 p-0 d-flex align-items-center m-b-10 p-5\" ng-repeat=\"headerObj in updateInsightChart.querySearchDataHeader\" ng-class=\"{ \'p-b-5\': !$last, \'opacity-5\': headerObj.isPlotted}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg ng-if=\"headerObj.type === \'string\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"headerObj.type === \'number\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"headerObj.type === \'decimal\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"headerObj.type === \'boolean\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"headerObj.type === \'date\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"headerObj.type === \'object\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"headerObj.type === \'array\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-11 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><strong>{{headerObj.name}}</strong></label></div></div></div><div class=\"col-sm-7 p-0\"><h3 class=\"m-b-20\">Used Fields</h3><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-repeat=\"data in updateInsightChart.dataConfig track by $index\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"data.value\" typeahead-editable=\"true\" uib-typeahead=\"dataHeader for dataHeader in updateInsightChart.apiDataHeader | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-on-select=\"updateInsightChart.fnDataConfigSelected()\" placeholder=\"Field {{data.isRequired ? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{data.key}} {{data.isRequired ? \'*\' : \'\'}}</label></div></div><div class=\"m-t-5\" style=\"width: 18px;\"><button ng-show=\"!data.isRequired\" class=\"btn btn-link p-r-0 p-l-0\" ng-click=\"updateInsightChart.fnRemoveMapping($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : updateInsightChart.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Chart Configuration</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"updateInsightChart.fnEditChartProperties()\"><i class=\"fa fa-edit m-r-5\"></i>Customize chart</button></div><div class=\"col-sm-12 p-t-20 HighChartPie HighChartBarChart\" style=\"height: calc(100% - 35px) !important;\"><div id=\"previewChart\" class=\"col-sm-12 p-0 previewChart width-inherit h-100\"></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : updateInsightChart.activeStep === 4}\" role=\"tabpanel\" id=\"step4\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Preview</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 m-t-20 pace\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"updateInsightChart.selectChartObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"updateInsightChart.selectChartObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></form></div></div><div class=\"col-sm-4\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div id=\"finalPreviewChart\" class=\"col-sm-12 p-0 finalPreviewChart width-inherit\"></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left\" ng-if=\"updateInsightChart.activeStep !== 1 && !updateInsightChart.isChartUpdateing\" ng-click=\"updateInsightChart.fnGotoPreviousNextStep(true)\">Back</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"updateInsightChart.activeStep === 1\" ng-click=\"updateInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"updateInsightChart.activeStep === 2\" ng-disabled=\"!updateInsightChart.fnCheckRequiredInput()\" ng-click=\"updateInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"updateInsightChart.activeStep === 3\" ng-click=\"updateInsightChart.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!updateInsightChart.selectChartObj.name.length\" ng-click=\"updateInsightChart.fnSaveChart()\" ng-if=\"updateInsightChart.activeStep === 4 && !updateInsightChart.isChartUpdateing\">Save Chart</button><div class=\"pull-right\" ng-if=\"updateInsightChart.activeStep === 4 && updateInsightChart.isChartUpdateing\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/insightDashboardInfo/insightDashboardInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Dashboard</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{dashboardObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{dashboardObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{dashboardObj.description ? dashboardObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{dashboardObj.description ? dashboardObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{dashboardObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(dashboardObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/insight/insight_dashboards/createDashboard/createDashboard.html","<div class=\"h-100\" ng-controller=\"createInsightDashboardCtrl as createInsightDashboard\" ng-init=\"createInsightDashboard.fnInitCreateDashboard()\"><div class=\"modal-body\" style=\"height: calc(100% - 55px)\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!createInsightDashboard.isProjectCreateLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100 insight-dashboard-body\" ng-if=\"createInsightDashboard.isProjectCreateLoaded\"><div class=\"col-sm-9 h-100 overflow-auto p-0\"><div class=\"col-sm-12 p-0 h-100 d-flex justify-content-center align-items-center flex-column\" ng-if=\"!createInsightDashboard.widgets.length\"><span>You can assign chart to your dashboard in the form of widgets. Each widget is a name consisting of a user-defined query and chart.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"createInsightDashboard.fnOpenWidgetModal()\">Add Widget</button></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightDashboard.widgets.length\"><div gridstack=\"\" class=\"grid-stack grid1\" options=\"createInsightDashboard.options\" on-change=\"createInsightDashboard.onChange(event,items)\"><div gridstack-item=\"\" ng-repeat=\"w in createInsightDashboard.widgets track by $index\" class=\"grid-stack-item grid-stack-item-edit-icon\" gs-item-x=\"w.x\" gs-item-y=\"w.y\" gs-item-width=\"w.width\" gs-item-height=\"w.height\" gs-item-autopos=\"1\"><div class=\"grid-stack-item-content\"><div class=\"col-sm-12 p-15 h-100 dashboard-panel dashboard-panel-chart-widget\" style=\"height: 100%\" ng-if=\"w.chart.syntax === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!w.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!w.layout && !w.layout.icon && !w.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"w.layout && w.layout.icon && w.layout.icon.length\" ng-bind-html=\"createInsightDashboard.deliberatelyTrustDangerousSnippet(w.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{w.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"w.layout.isExport !== false\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in w.layout.exportOptions track by $index\" ng-click=\"createInsightDashboard.fnExportChart(exportOption.action, \'accessDashboardWidgets\'+$index)\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"w.layout.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 chart-height\" ng-class=\"w.layout.buttonLink.length ? \'widget-with-button\':\'widget-without-button\'\" ng-if=\"w.chart.query.results.data\"><dashboard-pie-chart ng-if=\"w.chart.query.results.data.length\" is-for-csv-chart=\"true\" chart-id=\"\'insightDashboardWidgets\'+$index\" chart-data=\"w.chart.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"!w.chart.query.results.data.length\" style=\"opacity: 0.5\"><svg style=\"height: 70px;width: 70px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><div class=\"col-sm-12 p-0 dashboard-pie-chart-img chart-height\" ng-if=\"!w.chart.query.results.data\"><svg class=\"p-t-40 p-b-40\" style=\"height: inherit;width: inherit;\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\" ng-if=\"w.layout.buttonLink.length && w.layout.buttonLink.length\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"createInsightDashboard.fnGotoLink(w.layout.buttonLink, w.layout.target)\">{{w.layout.buttonText}}</button></div></div></div><i class=\"fa fa-trash-o item-delete-icon\" ng-click=\"createInsightDashboard.removeWidget(w)\"></i></div></div></div></div><div class=\"col-sm-3 h-100 overflow-auto p-0\" style=\"border-left: 1.5px solid #f1f1f1;\"><div class=\"col-sm-12 m-b-10\"><h2 class=\"p-0 m-t-0\">Details</h2></div><div class=\"col-sm-12 floatingLabelInput\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightDashboard.newDashboardObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightDashboard.newDashboardObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createInsightDashboard.changeProjectView\" ng-click=\"$event.stopPropagation();createInsightDashboard.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createInsightDashboard.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightDashboard.selectedProject.name\"><span>{{createInsightDashboard.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createInsightDashboard.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightDashboard.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightDashboard.selectedProject.name\">{{createInsightDashboard.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightDashboard.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createInsightDashboard.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightDashboard.projectSearch[createInsightDashboard.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightDashboard.filterProject=(createInsightDashboard.projectsArr | filter:createInsightDashboard.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightDashboard.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createInsightDashboard.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"createInsightDashboard.widgets.length && !createInsightDashboard.isDashboardCreating\" ng-click=\"createInsightDashboard.fnOpenWidgetModal()\">Add Widget</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button ng-if=\"createInsightDashboard.isProjectCreateLoaded && !createInsightDashboard.isDashboardCreating\" ng-click=\"createInsightDashboard.fnCreateNewDashboard()\" ng-disabled=\"!createInsightDashboard.newDashboardObj.name.length || !createInsightDashboard.newDashboardObj.projectId.length || !createInsightDashboard.widgets.length\" type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\">Create Dashboard</button><div class=\"pull-right\" ng-if=\"createInsightDashboard.isDashboardCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/modals/dashboardWidgetModal.html","<div class=\"inmodal h-100\" ng-init=\"dashboardWidgetModal.fnInitDashboardWidgetModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Widget</h3></div><div class=\"modal-body\" style=\"overflow-x: hidden;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"dashboardWidgetModal.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{dashboardWidgetModal.project.name ? dashboardWidgetModal.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"dashboardWidgetModal.widgetsProjectSearch[dashboardWidgetModal.widgetsProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in dashboardWidgetModal.filterProject=(dashboardWidgetModal.projectsArr | filter:dashboardWidgetModal.widgetsProjectSearch) track by $index\" ng-click=\"dashboardWidgetModal.fnGetProjectWidgets(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === dashboardWidgetModal.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!dashboardWidgetModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"dashboardWidgetModal.isRefreshData\" search-identifier=\"\'widgetsssearch\'\" filters-arr=\"dashboardWidgetModal.searchFiltersArr\" filter-query=\"dashboardWidgetModal.filterQuery\" fn-filter-query-change=\"dashboardWidgetModal.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_widgets\'\" no-set-url=\"true\" fn-resize=\"dashboardWidgetModal.fnSetTableHeight()\" sort-field-arr=\"dashboardWidgetModal.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"dashboardWidgetModal.isWidgetsLoading\" fn-resize=\"dashboardWidgetModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"dashboard-widgets-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!dashboardWidgetModal.isWidgetsLoading\"><thead><tr><th ng-if=\"dashboardWidgetModal.widgetsArr.length\" class=\"p-8\"></th><th ng-if=\"dashboardWidgetModal.widgetsArr.length\">Name</th><th ng-if=\"dashboardWidgetModal.widgetsArr.length\">Project</th><th ng-if=\"dashboardWidgetModal.widgetsArr.length\"></th><th ng-if=\"dashboardWidgetModal.widgetsArr.length\"></th><th ng-if=\"!dashboardWidgetModal.widgetsArr.length\">No records found...</th></tr></thead><tbody id=\"widgetsTable\"><tr ng-repeat=\"widgetsObj in dashboardWidgetModal.widgetsArr track by $index\" ng-click=\"widgetsObj.isCheck = !widgetsObj.isCheck;dashboardWidgetModal.fnCheckUncheckHeader(widgetsObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"widgetsObj.isCheck\" ng-change=\"dashboardWidgetModal.fnCheckUncheckHeader(widgetsObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{widgetsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{widgetsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{widgetsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"widgetsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{widgetsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"widgetsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{widgetsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"widgetsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{widgetsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{widgetsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"widgetsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{widgetsObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!dashboardWidgetModal.isWidgetsLoading && dashboardWidgetModal.widgetsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{dashboardWidgetModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"dashboardWidgetModal.perPage = 10; dashboardWidgetModal.fnPageChanged(dashboardWidgetModal.currentPage, dashboardWidgetModal.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardWidgetModal.perPage = 20; dashboardWidgetModal.fnPageChanged(dashboardWidgetModal.currentPage, dashboardWidgetModal.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardWidgetModal.perPage = 50; dashboardWidgetModal.fnPageChanged(dashboardWidgetModal.currentPage, dashboardWidgetModal.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"dashboardWidgetModal.perPage = 100; dashboardWidgetModal.fnPageChanged(dashboardWidgetModal.currentPage,dashboardWidgetModal.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"dashboardWidgetModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"dashboardWidgetModal.currentPage\" items-per-page=\"dashboardWidgetModal.perPage\" max-size=\"dashboardWidgetModal.maxSize\" boundary-links=\"true\" ng-click=\"dashboardWidgetModal.fnPageChanged(dashboardWidgetModal.currentPage, dashboardWidgetModal.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary-cancel\" ng-if=\"!dashboardWidgetModal.isWidgetAdding\" ng-click=\"dashboardWidgetModal.fnCancel()\">Close</button></div><div class=\"col-sm-6 d-flex justify-content-flex-end p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!dashboardWidgetModal.isWidgetAdding\" ng-disabled=\"!dashboardWidgetModal.isWidgetsObjSelected()\" ng-click=\"dashboardWidgetModal.fnInjectWidget()\">Inject</button><div class=\"pull-right\" ng-if=\"dashboardWidgetModal.isWidgetAdding\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/updateDashboard/updateDashboard.html","<div class=\"h-100\" ng-controller=\"updateInsightDashboardCtrl as updateInsightDashboard\" ng-init=\"updateInsightDashboard.fnInitUpdateDashboard()\"><div class=\"modal-body\" style=\"height: calc(100% - 55px)\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!updateInsightDashboard.isDashboardDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100 insight-dashboard-body\" ng-if=\"updateInsightDashboard.isDashboardDetailsLoaded\"><div class=\"col-sm-12 p-0 h-100 overflow-auto\" ng-if=\"updateInsightDashboard.widgets.length\"><div gridstack=\"\" class=\"grid-stack grid1\" options=\"updateInsightDashboard.options\" on-change=\"updateInsightDashboard.onChange()\"><div gridstack-item=\"\" ng-repeat=\"w in updateInsightDashboard.widgets track by $index\" class=\"grid-stack-item grid-stack-item-edit-icon\" gs-item-x=\"w.x\" gs-item-y=\"w.y\" gs-item-width=\"w.width\" gs-item-height=\"w.height\" gs-item-autopos=\"1\"><div class=\"grid-stack-item-content\"><div class=\"col-sm-12 p-15 h-100 dashboard-panel dashboard-panel-chart-widget\" style=\"height: 100%\" ng-if=\"w.widget.chart.syntax === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!w.widget.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!w.widget.layout && !w.widget.layout.icon && !w.widget.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"w.widget.layout && w.widget.layout.icon && w.widget.layout.icon.length\" ng-bind-html=\"updateInsightDashboard.deliberatelyTrustDangerousSnippet(w.widget.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{w.widget.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"w.widget.layout.isExport !== false\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in w.widget.layout.exportOptions track by $index\" ng-click=\"updateInsightDashboard.fnExportChart(exportOption.action, \'accessDashboardWidgets\'+$index)\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"w.widget.layout.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 chart-height\" ng-class=\"w.widget.layout.buttonLink.length ? \'widget-with-button\':\'widget-without-button\'\" ng-if=\"w.widget.chart.query.results.data\"><dashboard-pie-chart ng-if=\"w.widget.chart.query.results.data.length\" is-for-csv-chart=\"true\" chart-id=\"\'insightDashboardWidgets\'+$index\" chart-data=\"w.widget.chart.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"!w.widget.chart.query.results.data.length\" style=\"opacity: 0.5\"><svg style=\"height: 70px;width: 70px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><div class=\"col-sm-12 p-0 dashboard-pie-chart-img chart-height\" ng-if=\"!w.widget.chart.query.results.data\"><svg class=\"p-t-40 p-b-40\" style=\"height: inherit;width: inherit;\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\" ng-if=\"w.widget.layout.buttonLink.length && w.widget.layout.buttonLink.length\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"updateInsightDashboard.fnGotoLink(w.widget.layout.buttonLink, w.widget.layout.target)\">{{w.widget.layout.buttonText}}</button></div></div></div><i class=\"fa fa-trash-o item-delete-icon\" ng-click=\"updateInsightDashboard.removeWidget(w)\"></i></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"!updateInsightDashboard.isDashboardUpdating && updateInsightDashboard.isDashboardDetailsLoaded\" ng-click=\"updateInsightDashboard.fnOpenWidgetModal()\">Add Widget</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button ng-if=\"!updateInsightDashboard.isDashboardUpdating && updateInsightDashboard.isDashboardDetailsLoaded\" ng-click=\"updateInsightDashboard.fnUpdateDashboard()\" ng-disabled=\"!updateInsightDashboard.widgets.length\" type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\">Update Dashboard</button><div class=\"pull-right\" ng-if=\"updateInsightDashboard.isDashboardUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_project/createProject/createInsightProject.html","<div class=\"h-100\" ng-controller=\"createInsightProjectCtrl as createInsightProject\" ng-init=\"createInsightProject.fnInitCreateProject()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createInsightProject.isProjectCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createInsightProject.isProjectCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewProjectForm\" role=\"form\" name=\"createNewProjectForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createInsightProject.newProjectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createInsightProject.newProjectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Parent Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createInsightProject.changeProjectView\" ng-click=\"$event.stopPropagation();createInsightProject.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createInsightProject.selectedProject.name\"><div class=\"grayItalicValue\">No Parent Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightProject.selectedProject.name\"><span>{{createInsightProject.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createInsightProject.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightProject.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightProject.selectedProject.name\">{{createInsightProject.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightProject.selectedProject.name\">No Parent Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createInsightProject.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightProject.projectSearch[createInsightProject.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightProject.filterProject=(createInsightProject.projectsArr | filter:createInsightProject.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightProject.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createInsightProject.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createInsightProject.newProjectObj.name.length || !(createInsightProject.selectedProject && createInsightProject.selectedProject.id)\" ng-click=\"createInsightProject.fnCreateNewProject(createInsightProject.newProjectObj)\" ng-if=\"!createInsightProject.isProjectCreating\">Create Project</button></div><div class=\"col-sm-12\" ng-if=\"createInsightProject.isProjectCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_project/insightProjectInfo/insightProjectInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Project</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{projectObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{projectObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/insight/insight_queries/createQuery/createQuery.html","<div class=\"h-100\" ng-controller=\"createInsightQueryCtrl as createInsightQuery\" ng-init=\"createInsightQuery.fnInitCreateQuery()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createInsightQuery.isProjectCreateLoaded\"></div><div class=\"modal-body\" id=\"createQueryModalBody\" ng-if=\"createInsightQuery.isProjectCreateLoaded\"><div class=\"row security-group\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightQuery.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 55.25 55.25\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M52.618,2.631c-3.51-3.508-9.219-3.508-12.729,0L3.827,38.693C3.81,38.71,3.8,38.731,3.785,38.749 c-0.021,0.024-0.039,0.05-0.058,0.076c-0.053,0.074-0.094,0.153-0.125,0.239c-0.009,0.026-0.022,0.049-0.029,0.075 c-0.003,0.01-0.009,0.02-0.012,0.03l-3.535,14.85c-0.016,0.067-0.02,0.135-0.022,0.202C0.004,54.234,0,54.246,0,54.259 c0.001,0.114,0.026,0.225,0.065,0.332c0.009,0.025,0.019,0.047,0.03,0.071c0.049,0.107,0.11,0.21,0.196,0.296 c0.095,0.095,0.207,0.168,0.328,0.218c0.121,0.05,0.25,0.075,0.379,0.075c0.077,0,0.155-0.009,0.231-0.027l14.85-3.535 c0.027-0.006,0.051-0.021,0.077-0.03c0.034-0.011,0.066-0.024,0.099-0.039c0.072-0.033,0.139-0.074,0.201-0.123 c0.024-0.019,0.049-0.033,0.072-0.054c0.008-0.008,0.018-0.012,0.026-0.02l36.063-36.063C56.127,11.85,56.127,6.14,52.618,2.631z M51.204,4.045c2.488,2.489,2.7,6.397,0.65,9.137l-9.787-9.787C44.808,1.345,48.716,1.557,51.204,4.045z M46.254,18.895l-9.9-9.9 l1.414-1.414l9.9,9.9L46.254,18.895z M4.961,50.288c-0.391-0.391-1.023-0.391-1.414,0L2.79,51.045l2.554-10.728l4.422-0.491 l-0.569,5.122c-0.004,0.038,0.01,0.073,0.01,0.11c0,0.038-0.014,0.072-0.01,0.11c0.004,0.033,0.021,0.06,0.028,0.092 c0.012,0.058,0.029,0.111,0.05,0.165c0.026,0.065,0.057,0.124,0.095,0.181c0.031,0.046,0.062,0.087,0.1,0.127 c0.048,0.051,0.1,0.094,0.157,0.134c0.045,0.031,0.088,0.06,0.138,0.084C9.831,45.982,9.9,46,9.972,46.017 c0.038,0.009,0.069,0.03,0.108,0.035c0.036,0.004,0.072,0.006,0.109,0.006c0,0,0.001,0,0.001,0c0,0,0.001,0,0.001,0h0.001 c0,0,0.001,0,0.001,0c0.036,0,0.073-0.002,0.109-0.006l5.122-0.569l-0.491,4.422L4.204,52.459l0.757-0.757 C5.351,51.312,5.351,50.679,4.961,50.288z M17.511,44.809L39.889,22.43c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 L16.097,43.395l-4.773,0.53l0.53-4.773l22.38-22.378c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L10.44,37.738 l-3.183,0.354L34.94,10.409l9.9,9.9L17.157,47.992L17.511,44.809z M49.082,16.067l-9.9-9.9l1.415-1.415l9.9,9.9L49.082,16.067z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightQuery.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 512.000 512.000\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon m-t-1 m-l-1\"><g transform=\"translate(0.000000,512.000000) scale(0.100000,-0.100000)\"><path d=\"M433 4890 c-87 -23 -130 -44 -209 -104 -101 -75 -176 -189 -208 -313 -14 -54 -16 -261 -16 -1913 0 -2055 -5 -1905 66 -2041 65 -123 197 -235 333 -282 l66 -22 2065 -3 c2249 -3 2133 -5 2255 52 113 53 220 157 278 272 60 119 57 -2 57 2024 0 2055 5 1905 -66 2041 -65 123 -197 235 -333 282 l-66 22 -2075 2 c-2003 2 -2077 1 -2147 -17z m4202 -334 c113 -52 154 -124 162 -287 l6 -109 -2243 0 -2243 0 6 109 c8 163 49 235 162 287 l50 24 2025 0 2025 0 50 -24z m163 -2263 l-3 -1548 -21 -45 c-28 -59 -77 -108 -139 -136 l-50 -24 -2025 0 -2025 0 -50 24 c-63 29 -112 77 -139 136 -21 45 -21 47 -24 1593 l-2 1547 2240 0 2240 0 -2 -1547z\"></path><path d=\"M2638 2970 c-20 -11 -45 -34 -56 -52 -24 -41 -345 -1424 -344 -1486 1 -89 67 -152 162 -152 68 0 115 27 143 80 24 47 337 1412 337 1470 0 124 -130 199 -242 140z\"></path><path d=\"M1794 2656 c-36 -16 -379 -412 -400 -462 -19 -45 -17 -81 5 -129 24 -51 342 -420 384 -446 21 -13 50 -19 87 -19 96 0 160 65 160 162 0 59 -12 78 -145 232 -76 89 -114 140 -109 148 4 7 59 72 121 144 62 72 117 143 123 158 40 107 -38 227 -149 226 -25 -1 -60 -7 -77 -14z\"></path><path d=\"M3169 2647 c-70 -47 -97 -128 -69 -203 6 -15 61 -86 123 -158 62 -72 117 -137 121 -144 5 -8 -32 -58 -107 -145 -63 -73 -122 -147 -131 -165 -35 -69 -8 -171 57 -211 45 -28 129 -29 174 -2 42 26 360 395 384 446 22 48 24 84 5 129 -8 18 -95 128 -194 243 -131 153 -189 213 -213 222 -52 18 -112 14 -150 -12z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightQuery.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 510 510\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\" style=\"margin-left: -1px;\"><g><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\"></path></g></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightQuery.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Details</h3></div><div class=\"col-sm-12 p-0 p-t-30 floatingLabelInput\"><form id=\"createNewGroupForm\" role=\"form\" name=\"createNewGroupForm\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createInsightQuery.newQueryObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createInsightQuery.newQueryObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createInsightQuery.changeProjectView\" ng-click=\"$event.stopPropagation();createInsightQuery.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createInsightQuery.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightQuery.selectedProject.name\"><span>{{createInsightQuery.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createInsightQuery.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightQuery.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightQuery.selectedProject.name\">{{createInsightQuery.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightQuery.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createInsightQuery.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightQuery.projectSearch[createInsightQuery.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightQuery.filterProject=(createInsightQuery.projectsArr | filter:createInsightQuery.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightQuery.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createInsightQuery.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightQuery.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">SQL</h3></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"createInsightQuery.activeStep === 2\"><div class=\"col-sm-12 p-0 floatingLabelInput custom-sql-editor\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"createInsightQuery.isQuerySearchDataLoading\" ng-click=\"createInsightQuery.fnRunQuery()\">Run Query</button> <button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"createInsightQuery.isAdvanceSearchDataLoading\" ng-click=\"createInsightQuery.fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-12 p-0 p-t-10 m-b-20\"><span>QUERY</span><div class=\"m-b-20 editorMedium\"><javascript-editor value=\"createInsightQuery.queryConfig.value\" available-defs=\"createInsightQuery.availableDataLibs\" editor-value=\"createInsightQuery.queryConfig.editorValue\" read-only=\"!createInsightQuery.isQuerySearchDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightQuery.isQuerySearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" style=\"overflow-x: auto\" ng-if=\"!createInsightQuery.isQuerySearchDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"createInsightQuery.querySearchData.data.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in createInsightQuery.querySearchDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in createInsightQuery.querySearchData.data\"><td ng-repeat=\"header in createInsightQuery.querySearchDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"createInsightQuery.fnGetTdStyle(data[header])\"><span class=\"ellipsis\" ng-if=\"createInsightQuery.fnGetType(data[header]) === \'string\'\">\'{{data[header]}}\'</span> <span class=\"ellipsis\" ng-if=\"createInsightQuery.fnGetType(data[header]) !== \'string\' && createInsightQuery.fnGetType(data[header]) !== \'object\'\">{{data[header]}}</span><json-formatter ng-if=\"createInsightQuery.fnGetType(data[header]) === \'object\' && createInsightQuery.fnGetType(data[header]) !== \'null\'\" json=\"data[header]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!createInsightQuery.querySearchData.data.length\">No records found...</div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightQuery.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Review</h3></div><div class=\"col-sm-12 p-0 p-t-20\"><div class=\"col-sm-12 p-0\">Please review all the query setting for this query. Once you have created it you can associate it with widgets.</div><div class=\"col-sm-12 p-0 p-t-20\" id=\"functionModal\"><div class=\"col-sm-12 p-0\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><h3 class=\"m-0\"><span class=\"p-b-5 ellipsis\">{{createInsightQuery.newQueryObj.name}}</span></h3><h5 class=\"m-0 font-italic\"><span class=\"p-b-5 ellipsis\">{{createInsightQuery.newQueryObj.description}}</span></h5></div></div><div class=\"panel-body\" ng-if=\"createInsightQuery.activeStep === 3\"><div class=\"col-sm-12 p-0 p-b-10\"><div class=\"col-sm-12 p-0 d-flex justify-content-start align-items-center\"><label>Selected Project: <strong>{{createInsightQuery.selectedProject.name}}</strong></label></div><div class=\"col-sm-12 p-0 d-flex justify-content-start align-items-center p-t-10\"><label>SQL Query</label></div><div class=\"col-sm-12 p-0 d-flex justify-content-start align-items-center p-10\" style=\"border: 2px dashed;\"><code>\n                                                                {{createInsightQuery.queryConfig.value.getData()}}\n                                                            </code></div></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left\" ng-if=\"createInsightQuery.activeStep !== 1 && !createInsightQuery.isQueryCreating\" ng-click=\"createInsightQuery.fnGotoPreviousStep()\">Back</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightQuery.activeStep === 1\" ng-disabled=\"!createInsightQuery.newQueryObj.name.length || !createInsightQuery.selectedProject.id.length\" ng-click=\"createInsightQuery.fnGotoNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightQuery.activeStep === 2\" ng-click=\"createInsightQuery.fnGotoNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createInsightQuery.newQueryObj.name.length || !createInsightQuery.selectedProject.id.length || !createInsightQuery.queryConfig.value.getData().length\" ng-click=\"createInsightQuery.fnCreateNewQuery(createInsightQuery.newQueryObj)\" ng-if=\"createInsightQuery.activeStep === 3 && !createInsightQuery.isQueryCreating\">Create Query</button><div class=\"pull-right\" ng-if=\"createInsightQuery.activeStep === 3 && createInsightQuery.isQueryCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_queries/insightQueryInfo/insightQueryInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Query</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{queryObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{queryObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{queryObj.description ? queryObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{queryObj.description ? queryObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{queryObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(queryObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/insight/insight_query_editor/createInsightIssues/createInsightIssue.html","<div class=\"form-content\" ng-controller=\"createInsightIssueCtrl as createInsightIssue\" ng-class=\"createInsightIssue.isIssueCreating ? \'pace\' : \'\'\" ng-init=\"createInsightIssue.fnInitCreateIssue()\"><div class=\"modal-body height-100\" id=\"modal-body\" style=\"overflow: hidden\"><div class=\"row h-100 overflow-auto\"><div class=\"col-sm-12 p-0\" ng-if=\"!createInsightIssue.isProjectLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex height-max-content\" ng-if=\"createInsightIssue.isProjectLoaded\"><div class=\"col-sm-9 p-0\"><div class=\"col-sm-12 m-t-10\" id=\"newIssueTitle\"><div class=\"col-sm-2 p-0 m-t-0 m-b-20 customDropdown floatingLabelInput\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary p-b-5 issue-project-dropdown-menu\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createInsightIssue.selectedProject.name}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown p-b-0\" style=\"max-height: none;\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.issueProjectSearch[createInsightIssue.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightIssue.filterProject=(createInsightIssue.projectsArr | filter:createInsightIssue.issueProjectSearch) track by $index\" ng-click=\"createInsightIssue.fnChangeProject(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createInsightIssue.selectedProject.id\"></i></span><div class=\"d-flex flex-column\"><span>{{projectObj.name}}</span> <span class=\"font-italic\">({{projectObj.id}})</span></div></a></li><li ng-if=\"!createInsightIssue.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"col-sm-10 p-r-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"createInsightIssue.newIssueObj.name\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 m-t-0 m-b-20 customDropdown\" id=\"typeListDropdown\"><app-spinner ng-if=\"!createInsightIssue.isIssueTypeLoaded\" spinner-type=\"\'microSpinner\'\"></app-spinner><div class=\"btn-group col-sm-12 p-0\" ng-if=\"createInsightIssue.isIssueTypeLoaded\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createInsightIssue.selectedType.name}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span> <span style=\"position: absolute;right: 25px;\" ng-if=\"createInsightIssue.selectedType && createInsightIssue.selectedType.id && createInsightIssue.selectedType.id !== \'noType\'\">({{createInsightIssue.selectedType.id}})</span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"typeObj in createInsightIssue.typesArr\"><a ng-click=\"createInsightIssue.fnSelectType(typeObj)\"><span>{{typeObj.name}}</span><br><span class=\"font-italic\" ng-if=\"typeObj.id !== \'noType\'\">({{typeObj.id}})</span></a></li></ul></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"!createInsightIssue.isTypeDetailsLoaded\"><app-spinner class=\"\" spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex m-t-20 typeFormInputAction\" ng-if=\"createInsightIssue.isIssueTypeLoaded && createInsightIssue.selectedType && createInsightIssue.isTypeDetailsLoaded && createInsightIssue.selectedType.id !== \'noType\' && createInsightIssue.form.length\"><form role=\"form\" name=\"typeForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"createInsightIssue.schema\" sf-form=\"createInsightIssue.form\" sf-model=\"createInsightIssue.model\"></form></div></div><div class=\"col-sm-12 floatingLabelInput\" id=\"issueMarkdownContainer\"><div class=\"m-b-20 createIssue hide-toolbar createIssueMarkdownEditor\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir-for-issue=\"\" placeholder=\"Type your message...\" upload-file=\"createInsightIssue.uploadFiles(type, filedata)\" ng-model=\"createInsightIssue.newIssueObj.summary\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'none\'}\" rows=\"10\">\n                            </textarea><div class=\"markdown-footer d-flex justify-content-space-between align-items-center\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-8 p-0 d-flex\"><button class=\"btn btn-primary m-l-0 h-100\" ng-click=\"createInsightIssue.fnHideShowEditorPreview(\'editor1\')\"><span class=\"fa fa-eye\"></span> Preview</button><div class=\"d-flex align-items-center m-l-20\"><div class=\"d-flex align-items-center\" ng-click=\"createInsightIssue.fnAddMetaInfo()\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/table-icon.svg#table-icon\"></use></svg><label class=\"m-0 m-l-5\"><strong>Metadata</strong></label></div></div></div><div class=\"col-sm-4 p-0\"><div class=\"d-flex justify-content-flex-end h-100\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"createInsightIssue.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!createInsightIssue.isIssueCreating && !createInsightIssue.fileUploading && createInsightIssue.permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary h-100\" ng-if=\"!createInsightIssue.isIssueCreating && !createInsightIssue.fileUploading\" ng-disabled=\"!createInsightIssue.newIssueObj.name.length || !createInsightIssue.newIssueObj.summary.length || !createInsightIssue.selectedProject.id.length || createInsightIssue.fnCheckIssueTypeValidation()\" ng-click=\"createInsightIssue.fnCreateNewIssue(createInsightIssue.newIssueObj)\">Submit</button><app-spinner class=\"m-r-5 m-t-4\" ng-if=\"createInsightIssue.isIssueCreating || createInsightIssue.fileUploading\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div><div class=\"col-sm-3 p-0\"><div class=\"issue-side-panel h-100 overflow-auto\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignees</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.changeAssigneeView && createInsightIssue.isIssueAssigneeLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createInsightIssue.fnOpenChangeAssigneeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!createInsightIssue.newIssueObj.assignees.length\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><div class=\"col-sm-12 p-0\"><span class=\"p-0 d-block p-b-5\" ng-if=\"createInsightIssue.newIssueObj.assignees.length\" ng-repeat=\"assignee in createInsightIssue.newIssueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createInsightIssue.changeAssigneeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightIssue.fnOnToggleAssignee(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightIssue.newIssueObj.assignees.length > 1\">{{createInsightIssue.newIssueObj.assignees[0].username + \' + \' + (createInsightIssue.newIssueObj.assignees.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createInsightIssue.newIssueObj.assignees.length === 1\">{{createInsightIssue.newIssueObj.assignees[0].firstName + \' \'+ createInsightIssue.newIssueObj.assignees[0].lastName}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightIssue.newIssueObj.assignees.length\">No Assignees</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign to</label> <span ng-click=\"createInsightIssue.fnCancelChangeAssignee()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.assigneeSearch[createInsightIssue.filterAssignees]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"assigneeObj in createInsightIssue.filterUsers=(createInsightIssue.usersArr | filter:createInsightIssue.assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnGetAssigneeInfo(assigneeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"assigneeObj.isCheck\"></i></span> <span class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" style=\"left: 0px;\" ng-src=\"{{assigneeObj.userAvatar}}\"></span> <span class=\"d-flex flex-column\"><span>{{assigneeObj.firstName + \" \"+ assigneeObj.lastName}}</span> <span class=\"font-italic gateway-id-menu-option\">({{assigneeObj.username}})</span></span></a></li><li ng-if=\"!createInsightIssue.filterUsers.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnManageAssignees()\"><a><span>Manage Assignees</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createInsightIssue.fnCancelChangeAssignee()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.changePriorityView && createInsightIssue.isIssuePriorityLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createInsightIssue.fnOpenChangePriorityView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createInsightIssue.newIssueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightIssue.newIssueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createInsightIssue.newIssueObj.issuePriority\" ng-style=\"createInsightIssue.fnGetIssuesLabelColor(createInsightIssue.newIssueObj.issuePriority.color)\"><span>{{createInsightIssue.newIssueObj.issuePriority.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createInsightIssue.changePriorityView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightIssue.fnOnTogglePriority(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightIssue.newIssueObj.issuePriority.name\">{{createInsightIssue.newIssueObj.issuePriority.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightIssue.newIssueObj.issuePriority.name\">No Priority</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Priority</label> <span ng-click=\"createInsightIssue.fnCancelChangePriority()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.prioritySearch[createInsightIssue.priorityFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"Priority in createInsightIssue.filterPriority=(createInsightIssue.prioritiesArr | filter:createInsightIssue.prioritySearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnGetPrioritiesInfo(Priority)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"Priority.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"Priority.color ? {\'background-color\' : Priority.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{Priority.name}}</span></a></li><li ng-if=\"!createInsightIssue.filterPriority.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnManageProjectPriority()\"><a><span>Manage project priorities</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createInsightIssue.fnCancelChangePriority()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.changeStateView && createInsightIssue.isIssueStateLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createInsightIssue.fnOpenChangeStateView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createInsightIssue.changeStateView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createInsightIssue.newIssueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createInsightIssue.newIssueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createInsightIssue.newIssueObj.issueState\" ng-style=\"createInsightIssue.fnGetIssuesLabelColor(createInsightIssue.newIssueObj.issueState.color)\"><span>{{createInsightIssue.newIssueObj.issueState.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createInsightIssue.changeStateView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightIssue.fnOnToggleState(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightIssue.newIssueObj.issueState.name\">{{createInsightIssue.newIssueObj.issueState.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightIssue.newIssueObj.issueState.name\">No State</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign State</label> <span ng-click=\"createInsightIssue.fnCancelChangeState()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.stateSearch[createInsightIssue.stateFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"state in createInsightIssue.filterState=(createInsightIssue.statesArr | filter:createInsightIssue.stateSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnGetStatesInfo(state)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"state.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"state.color ? {\'background-color\' : state.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{state.name}}</span></a></li><li ng-if=\"!createInsightIssue.filterState.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnManageProjectState()\"><a><span>Manage project state</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createInsightIssue.fnCancelChangeState()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.addLabelView && createInsightIssue.isIssueLablesLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createInsightIssue.fnOpenAddLabelView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createInsightIssue.newIssueObj.issueLabels.length\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in createInsightIssue.assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5 ellipsis-issues-label\" ng-style=\"createInsightIssue.fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createInsightIssue.addLabelView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightIssue.fnOnToggle(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightIssue.assigneesLabels.length > 1\">{{createInsightIssue.assigneesLabels[0].name + \' + \' + (createInsightIssue.assigneesLabels.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createInsightIssue.assigneesLabels.length === 1\">{{createInsightIssue.assigneesLabels[0].name}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightIssue.assigneesLabels.length\">No Labels</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign labels</label> <span ng-click=\"createInsightIssue.fnCancelAddLabelView()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.labelSearch[createInsightIssue.filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"labelObj in createInsightIssue.filterLabels=(createInsightIssue.labelsArr | filter:createInsightIssue.labelSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnGetLabelInfo(labelObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"labelObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"labelObj.color ? {\'background-color\' : labelObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{labelObj.name}}</span></a></li><li ng-if=\"!createInsightIssue.filterLabels.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnManageProjectLabels()\"><a><span>Manage project labels</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createInsightIssue.fnCancelAddLabelView()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PARTICIPANTS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.changeParticipantView && createInsightIssue.isIssueParticipantLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createInsightIssue.fnOpenChangeParticipantView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createInsightIssue.newIssueObj.participants.length\"><div class=\"grayItalicValue\">No Participants</div></div><span class=\"p-0 d-block m-r-5 m-b-5 p-2\" ng-if=\"createInsightIssue.newIssueObj.participants.length\" ng-repeat=\"participant in createInsightIssue.newIssueObj.participants\"><span class=\"border-1-assignee p-2\">{{participant}}</span></span></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createInsightIssue.changeParticipantView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createInsightIssue.fnOnToggleParticipant(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createInsightIssue.assigneesParticipants.length > 1\">{{createInsightIssue.assigneesParticipants[0].email + \' + \' + (createInsightIssue.assigneesParticipants.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createInsightIssue.assigneesParticipants.length === 1\">{{createInsightIssue.assigneesParticipants[0].email}}</span> <span class=\"w100 text-left\" ng-if=\"!createInsightIssue.assigneesParticipants.length\">No Participants</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Participants</label> <span ng-click=\"createInsightIssue.fnCancelChangeParticipant()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightIssue.participantSearch[createInsightIssue.participantFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"participantObj in createInsightIssue.filterParticipants=(createInsightIssue.participantUsersArr | filter:createInsightIssue.participantSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnGetParticipantInfo(participantObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"participantObj.isCheck\"></i></span> <span>{{participantObj.email}}</span></a></li><li ng-if=\"!createInsightIssue.filterParticipants.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createInsightIssue.fnAddNewParticipant()\"><a><span>Add new participant</span></a></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createInsightIssue.changeConfidentialView\"><i class=\"fa fa-edit fa-lg\" ng-click=\"createInsightIssue.fnOpenChangeConfidentialView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createInsightIssue.changeConfidentialView\"><span ng-if=\"!createInsightIssue.newIssueObj.confidential\">Not</span> Confidential</div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"createInsightIssue.changeConfidentialView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintConfidential\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"confidential as confidential.name for confidential in createInsightIssue.confidentialsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedConfidential.confidential\" placeholder=\"Confidential for the Issue\"> <span class=\"highlight\"></span> <label>Select Confidential</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"createInsightIssue.isConfidentialChanged\" ng-disabled=\"!createInsightIssue.fnCheckEmpty(selectedConfidential.confidential.name)\" ng-click=\"createInsightIssue.fnChangeIssueConfidential(selectedConfidential.confidential)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"createInsightIssue.isConfidentialChanged\" ng-click=\"createInsightIssue.fnCancelChangeConfidential()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!createInsightIssue.isConfidentialChanged\"></app-spinner></div></div></div></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"labelColor.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.name\"></span> <span class=\"pull-right m-t-5\" style=\"width: 15px; height: 15px; display: inline-block\" ng-style=\"match.model.color ? {\'background-color\' : match.model.color} : {\'background-color\' : \'inherit\'}\"></span> </a></script><script type=\"text/ng-template\" id=\"assigneeUser.html\"><a> <span class=\"d-flex align-items-center\"> <span class=\"m-r-5\"> <img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{match.model.userAvatar}}\"> </span> <span> <span style=\"display: block;\"> {{match.model.firstName + \" \"+ match.model.lastName}} </span> <span class=\"font-italic gateway-id-menu-option\">({{match.model.username}})</span> </span> </span> </a></script><script type=\"text/ng-template\" id=\"UserNameTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-if=\"match.model.company && match.model.company !==\'\'\"> {{match.model.firstName + \" \"+match.model.lastName + \" \"+\"(\"+match.model.company+\")\"}} </span> <span ng-if=\"!match.model.company || match.model.company ===\'\'\"> {{match.model.firstName + \" \"+match.model.lastName}} </span> </div> <br> </div> </a></script>");
$templateCache.put("app/insight/insight_widgets/createWidget/createWidget.html","<div class=\"h-100\" ng-controller=\"createInsightWidgetCtrl as createInsightWidget\" ng-init=\"createInsightWidget.fnInitCreateWidget()\"><div class=\"modal-body\" id=\"createWidgetModalBody\"><div class=\"row security-group\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightWidget.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 -17 512 512\" width=\"26px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"m74.722656 297.265625h-51.734375c-12.675781 0-22.988281 10.3125-22.988281 22.992187v134.375c0 12.675782 10.3125 22.988282 22.988281 22.988282h51.734375c12.679688 0 22.992188-10.3125 22.992188-22.988282v-134.375c0-12.679687-10.3125-22.992187-22.992188-22.992187zm7.992188 157.367187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734375c-4.402343 0-7.988281-3.585938-7.988281-7.988282v-134.375c0-4.40625 3.585938-7.992187 7.988281-7.992187h51.734375c4.40625 0 7.992188 3.585937 7.992188 7.992187zm0 0\"></path><path d=\"m212.820312 191.945312h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988282v42.644531c0 4.140625 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359375 7.5-7.5v-42.644531c0-4.402344 3.582032-7.988282 7.988282-7.988282h51.734374c4.40625 0 7.988282 3.585938 7.988282 7.988282v239.699218c0 4.402344-3.582032 7.988282-7.988282 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-167.054687c0-4.140625-3.359375-7.5-7.5-7.5-4.144531 0-7.5 3.359375-7.5 7.5v167.054687c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.675782 0 22.988282-10.3125 22.988282-22.988282v-239.695312c0-12.679688-10.3125-22.992188-22.988282-22.992188zm0 0\"></path><path d=\"m350.914062 255.140625h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988281v176.503906c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.679688 0 22.992188-10.3125 22.992188-22.988282v-176.503906c0-12.675781-10.3125-22.988281-22.992188-22.988281zm7.992188 199.492187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-176.503906c0-4.40625 3.582032-7.988281 7.988282-7.988281h51.734374c4.40625 0 7.992188 3.582031 7.992188 7.988281zm0 0\"></path><path d=\"m489.011719 139.285156h-51.734375c-12.675782 0-22.992188 10.3125-22.992188 22.988282v214.304687c0 4.140625 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.359375 7.5-7.5v-214.304687c0-4.40625 3.585938-7.988282 7.992188-7.988282h51.734375c4.402343 0 7.988281 3.582032 7.988281 7.988282v292.359374c0 4.402344-3.585938 7.988282-7.988281 7.988282h-51.734375c-4.40625 0-7.992188-3.585938-7.992188-7.988282v-48.054687c0-4.140625-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.359375-7.5 7.5v48.054687c0 12.675782 10.316406 22.988282 22.992188 22.988282h51.734375c12.675781 0 22.988281-10.3125 22.988281-22.988282v-292.359374c0-12.675782-10.3125-22.988282-22.988281-22.988282zm0 0\"></path><path d=\"m48.855469 157.980469c-25.765625 0-46.730469 20.964843-46.730469 46.730469 0 25.769531 20.964844 46.734374 46.730469 46.734374 25.769531 0 46.734375-20.964843 46.734375-46.734374 0-2.046876-.148438-4.054688-.402344-6.03125l73.683594-56.199219c5.5625 2.34375 11.675781 3.644531 18.082031 3.644531 10.101563 0 19.457031-3.234375 27.109375-8.703125l64.460938 29.496094c2.195312 23.742187 22.21875 42.398437 46.523437 42.398437 25.769531 0 46.734375-20.964844 46.734375-46.730468 0-2.792969-.261719-5.523438-.730469-8.179688l76.027344-63.789062c5.011719 1.84375 10.425781 2.847656 16.066406 2.847656 25.765625 0 46.730469-20.964844 46.730469-46.734375 0-25.765625-20.964844-46.730469-46.730469-46.730469-25.769531 0-46.734375 20.964844-46.734375 46.730469 0 2.792969.261719 5.523437.730469 8.179687l-76.03125 63.789063c-5.007813-1.839844-10.421875-2.847657-16.0625-2.847657-10.101563 0-19.457031 3.234376-27.109375 8.707032l-64.460938-29.5c-2.195312-23.742188-22.214843-42.398438-46.523437-42.398438-25.769531 0-46.730469 20.964844-46.730469 46.730469 0 2.046875.144532 4.058594.402344 6.035156l-73.6875 56.195313c-5.566406-2.34375-11.671875-3.640625-18.082031-3.640625zm414.289062-142.980469c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.496093-14.234375 31.734375-31.730469 31.734375-17.234375 0-31.734375-14.5-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-40.5625 54.925781c.125.21875.261719.429688.390625.644531 2.710938 4.566407 6.199219 8.667969 10.277344 12.070313l-67.640625 56.746094c-.125-.21875-2.175781-3.476563-3.179687-4.816407-2.179688-2.90625-4.691407-5.5625-7.488282-7.898437zm-129.261719 92.191407c.257813-17.007813 14.621094-31.265626 31.726563-31.265626 17.054687 0 31.730469 14.582032 31.730469 31.734376 0 17.496093-14.234375 31.730468-31.730469 31.730468s-31.730469-14.234375-31.730469-31.730468c0-.15625 0-.3125.003906-.46875zm-67.832031-36.328126c3.070313-4.507812 5.386719-9.519531 6.738281-14.804687l54.46875 24.921875c-2.773437 3.996094-4.941406 8.433594-6.359374 13.089844-.203126.660156-.390626 1.324218-.5625 1.992187l-54.46875-24.921875c.0625-.089844.121093-.183594.183593-.277344zm-38.535156-58.128906c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.09375-14.664063 31.734375-31.730469 31.734375-17.074219 0-31.734375-14.5625-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-41.597656 53.019532c.089843.171874.191406.34375.28125.515624 2.507812 4.742188 5.832031 9.054688 9.789062 12.675782l-64.972656 49.554687c-1.203125-2.34375-2.617187-4.59375-4.195313-6.699219-1.75-2.335937-3.710937-4.515624-5.875-6.496093zm-77.589844 58.824218c7.699219 5.859375 12.824219 15.085938 12.824219 25.207032 0 17.5-14.234375 31.734374-31.734375 31.734374-17.496094 0-31.730469-14.234374-31.730469-31.734374 0-17.496094 14.234375-31.730469 31.730469-31.730469 6.976562 0 13.566406 2.449219 18.910156 6.523437zm0 0\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightWidget.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"28px\" viewbox=\"0 0 512 512\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g transform=\"translate(0.000000,512.000000) scale(0.100000,-0.100000)\"><path d=\"M662 5109 c-247 -42 -471 -212 -582 -443 -82 -171 -75 23 -75 -2106 0 -2129 -7 -1935 75 -2106 79 -163 211 -295 374 -374 171 -82 -23 -75 2106 -75 2129 0 1935 -7 2106 75 163 79 295 211 374 374 82 171 75 -23 75 2106 0 2129 7 1935 -75 2106 -79 163 -211 296 -374 374 -170 82 28 74 -2076 76 -1051 1 -1898 -2 -1928 -7z m3760 -300 c226 -47 398 -259 398 -489 l0 -50 -2260 0 -2260 0 0 50 c0 225 164 433 383 486 71 17 3658 20 3739 3z m398 -2449 c0 -1136 -3 -1625 -11 -1662 -39 -187 -200 -348 -387 -387 -75 -16 -3649 -16 -3724 0 -187 39 -348 200 -387 387 -8 37 -11 526 -11 1662 l0 1610 2260 0 2260 0 0 -1610z\"></path><path d=\"M795 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M1195 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M1595 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M825 2925 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1519 0 c1322 0 1523 2 1548 15 119 62 97 238 -35 274 -28 8 -483 11 -1515 11 -1246 -1 -1481 -3 -1515 -15z\"></path><path d=\"M825 2325 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1250 0 c1217 0 1250 0 1281 19 93 58 90 200 -4 256 -35 20 -48 20 -1260 22 -1038 2 -1231 0 -1265 -12z\"></path><path d=\"M825 1725 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1394 0 c1311 0 1397 1 1425 18 94 55 93 201 -2 257 -35 20 -47 20 -1405 22 -1163 2 -1376 0 -1410 -12z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createInsightWidget.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 56 56\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M8,14c3.519,0,6.432-2.614,6.92-6H54c0.553,0,1-0.447,1-1s-0.447-1-1-1H14.92C14.432,2.614,11.519,0,8,0 C4.14,0,1,3.141,1,7S4.14,14,8,14z M8,2c2.757,0,5,2.243,5,5s-2.243,5-5,5S3,9.757,3,7S5.243,2,8,2z\"></path><path d=\"M48,42c-3.519,0-6.432,2.614-6.92,6H2c-0.552,0-1,0.447-1,1s0.448,1,1,1h39.08c0.488,3.386,3.401,6,6.92,6 c3.859,0,7-3.141,7-7S51.859,42,48,42z M48,54c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S50.757,54,48,54z\"></path><path d=\"M54,27H35.368c-0.396-3.602-3.455-6.414-7.161-6.414c-3.706,0-6.765,2.813-7.161,6.414H2c-0.552,0-1,0.447-1,1s0.448,1,1,1 h19.109c0.577,3.4,3.536,6,7.098,6c3.562,0,6.52-2.6,7.097-6H54c0.553,0,1-0.447,1-1S54.553,27,54,27z M28.207,33 C25.336,33,23,30.664,23,27.793s2.336-5.207,5.207-5.207s5.207,2.336,5.207,5.207S31.078,33,28.207,33z\"></path></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightWidget.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Charts</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\" style=\"overflow-x: hidden !important;\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"createInsightWidget.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{createInsightWidget.project.name ? createInsightWidget.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createInsightWidget.chartsProjectSearch[createInsightWidget.chartsProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createInsightWidget.filterProject=(createInsightWidget.projectsArr | filter:createInsightWidget.chartsProjectSearch) track by $index\" ng-click=\"createInsightWidget.fnGetProjectCharts(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createInsightWidget.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createInsightWidget.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createInsightWidget.isRefreshData\" search-identifier=\"\'chartsssearch\'\" filters-arr=\"createInsightWidget.searchFiltersArr\" filter-query=\"createInsightWidget.filterQuery\" fn-filter-query-change=\"createInsightWidget.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_charts\'\" no-set-url=\"true\" fn-resize=\"createInsightWidget.fnSetTableHeight()\" sort-field-arr=\"createInsightWidget.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\" ng-if=\"createInsightWidget.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createInsightWidget.isChartsLoading\" fn-resize=\"createInsightWidget.fnSetLoaderTableHeight()\"></table-loader><div class=\"widget-charts-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!createInsightWidget.isChartsLoading\"><thead><tr><th ng-if=\"createInsightWidget.chartsArr.length\" class=\"p-8\"></th><th ng-if=\"createInsightWidget.chartsArr.length\">Name</th><th ng-if=\"createInsightWidget.chartsArr.length\">Project</th><th ng-if=\"createInsightWidget.chartsArr.length\"></th><th ng-if=\"createInsightWidget.chartsArr.length\"></th><th ng-if=\"!createInsightWidget.chartsArr.length\">No records found...</th></tr></thead><tbody id=\"chartsTable\"><tr ng-repeat=\"chartsObj in createInsightWidget.chartsArr track by $index\" ng-click=\"chartsObj.isCheck = !chartsObj.isCheck;createInsightWidget.fnCheckUncheckHeader(chartsObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"chartsObj.isCheck\" ng-change=\"createInsightWidget.fnCheckUncheckHeader(chartsObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{chartsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{chartsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{chartsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{chartsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{chartsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createInsightWidget.isChartsLoading && createInsightWidget.chartsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createInsightWidget.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createInsightWidget.perPage = 10; createInsightWidget.fnPageChanged(createInsightWidget.currentPage, createInsightWidget.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightWidget.perPage = 20; createInsightWidget.fnPageChanged(createInsightWidget.currentPage, createInsightWidget.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightWidget.perPage = 50; createInsightWidget.fnPageChanged(createInsightWidget.currentPage, createInsightWidget.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createInsightWidget.perPage = 100; createInsightWidget.fnPageChanged(createInsightWidget.currentPage,createInsightWidget.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createInsightWidget.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createInsightWidget.currentPage\" items-per-page=\"createInsightWidget.perPage\" max-size=\"createInsightWidget.maxSize\" boundary-links=\"true\" ng-click=\"createInsightWidget.fnPageChanged(createInsightWidget.currentPage, createInsightWidget.perPage)\"></ul></div></div></div></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightWidget.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Widget Configuration</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 m-t-20 p-0\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title!\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.widgetConfig.title\" placeholder=\"Title*\" name=\"title\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-30 customDropdown\" ng-if=\"!createInsightWidget.isPasteSVGCode\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" style=\"height: 43px;\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-bind-html=\"createInsightWidget.deliberatelyTrustDangerousSnippet(createInsightWidget.widgetConfig.icon)\"></span> <label class=\"titleLabel\">ICON*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"min-width: 250px;\"><li ng-repeat=\"svgObj in createInsightWidget.svgArr track by $index\" ng-mousedown=\"createInsightWidget.fnSelectIcon(svgObj)\"><a><span>{{svgObj.title}}</span> <span class=\"pull-right pull-right font-italic m-t-2\" ng-bind-html=\"createInsightWidget.deliberatelyTrustDangerousSnippet(svgObj.iconURL)\"></span></a></li></ul></div><button class=\"btn-link p-0\" style=\"position: absolute;right: 0;top: 43px;\" ng-click=\"createInsightWidget.fnEditSVGCode()\">Paste SVG code</button></div><div class=\"md-input m-b-20\" ng-if=\"createInsightWidget.isPasteSVGCode\"><input class=\"md-form-control\" required=\"\" id=\"icon1\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.widgetConfig.icon\" placeholder=\"Icon*\" name=\"icon\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonText\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.widgetConfig.buttonText\" placeholder=\"Button Text\" name=\"actionButtonText\"> <span class=\"highlight\"></span> <label>Button Text</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonLink\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.widgetConfig.buttonLink\" placeholder=\"Button Link\" name=\"actionButtonLink\"> <span class=\"highlight\"></span> <label>Button Link</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createInsightWidget.widgetConfig.target\">{{createInsightWidget.widgetConfig.target}}</span> <label class=\"titleLabel\">TARGET</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\"><a ng-click=\"createInsightWidget.widgetConfig.target = \'New Window\'\">New Window</a></li><li role=\"menuitem\"><a ng-click=\"createInsightWidget.widgetConfig.target = \'Same Window\'\">Same Window</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-15\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_export\" ng-model=\"createInsightWidget.widgetConfig.isExport\"> <label for=\"chk_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export</div></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"createInsightWidget.widgetConfig.isExport\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 font-italic opacity-5\">Chart export options</span> <label class=\"titleLabel\">Chart Export Options</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in createInsightWidget.widgetConfig.exportOptions track by $index\"><a class=\"d-flex align-items-center\" ng-click=\"$event.stopPropagation();exportOption.isAllow = !exportOption.isAllow\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"exportOption.isAllow\"></i></span> <span>{{exportOption.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-if=\"createInsightWidget.widgetConfig.isExport\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_tracker_export\" ng-model=\"createInsightWidget.widgetConfig.isTrackerExport\"> <label for=\"chk_tracker_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export To Tracker</div></div></form></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createInsightWidget.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Preview</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 m-t-20\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.newWidgetObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"createInsightWidget.newWidgetObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></form></div></div><div class=\"col-sm-4\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!createInsightWidget.widgetConfig.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!createInsightWidget.widgetConfig && !createInsightWidget.widgetConfig.icon && !createInsightWidget.widgetConfig.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"createInsightWidget.widgetConfig && createInsightWidget.widgetConfig.icon && createInsightWidget.widgetConfig.icon.length\" ng-bind-html=\"createInsightWidget.deliberatelyTrustDangerousSnippet(createInsightWidget.widgetConfig.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{createInsightWidget.widgetConfig.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"createInsightWidget.widgetConfig.isExport\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in createInsightWidget.widgetConfig.exportOptions track by $index\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"createInsightWidget.widgetConfig.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center\" style=\"height: 250px;width: 100%\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"createInsightWidget.previewWidgetChartData\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'previewWidgetChart\'\" chart-data=\"createInsightWidget.previewWidgetChartData\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!createInsightWidget.previewWidgetChartData\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button ng-if=\"createInsightWidget.widgetConfig.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{createInsightWidget.widgetConfig.buttonText}}</button></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 55px;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-6 h-100 d-flex align-items-center\"><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createInsightWidget.activeStep === 1\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{createInsightWidget.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : createInsightWidget.isRefresh}\" ng-click=\"createInsightWidget.fnReload();\" aria-hidden=\"true\"></i></div></div></div><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left\" ng-if=\"createInsightWidget.activeStep !== 1 && !createInsightWidget.isWidgetCreating\" ng-click=\"createInsightWidget.fnGotoPreviousNextStep(true)\">Back</button></div><div class=\"col-sm-6 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightWidget.activeStep === 1\" ng-disabled=\"!createInsightWidget.isChartsObjSelected()\" ng-click=\"createInsightWidget.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createInsightWidget.activeStep === 2\" ng-disabled=\"!createInsightWidget.widgetConfig.title.length || !createInsightWidget.widgetConfig.icon.length\" ng-click=\"createInsightWidget.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createInsightWidget.newWidgetObj.name.length\" ng-click=\"createInsightWidget.fnCreateNewWidget(createInsightWidget.newWidgetObj)\" ng-if=\"createInsightWidget.activeStep === 3 && !createInsightWidget.isWidgetCreating\">Save Widget</button><div class=\"pull-right\" ng-if=\"createInsightWidget.activeStep === 3 && createInsightWidget.isWidgetCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insightWidgetInfo/insightWidgetInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Widget</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{widgetObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{widgetObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{widgetObj.description ? widgetObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{widgetObj.description ? widgetObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{widgetObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(widgetObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/components/directives/LineChart/LineChart.html","<div class=\"col-sm-12 p-0 h-100 w100 line-chart-root\"><div class=\"col-sm-12 p-0 lineChartMainContainer\" id=\"lineChartMainContainer\"></div></div>");
$templateCache.put("app/components/directives/advanceSearchDirective/advanceSearch.html","<div class=\"content-container h-100 overflow-auto\"><div class=\"container-with-footer tab-container\"><div><div class=\"content-main\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Advanced Search</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">{{appName}}</h1></div></div></div><div class=\"row d-flex align-items-center justify-content-center dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"isDataLibsLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"!isDataLibsLoading\"><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between\"><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"isAdvanceSearchDataLoading\" ng-click=\"fnRunAdvanceSearchQuery()\">Run Query</button> <button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"isAdvanceSearchDataLoading\" ng-click=\"fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><i class=\"fa fa-info-circle\" uib-tooltip=\"Click to see the list of available table names for your account\" tooltip-placement=\"left\" ng-click=\"fnOpenTablesModal()\"></i></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-30 floatingLabelInput custom-sql-editor\"><div><span>QUERY</span><div class=\"m-b-20 editorMedium\"><javascript-editor value=\"advanceSearchQueryConfig.value\" available-defs=\"availableDataLibs\" editor-value=\"advanceSearchQueryConfig.editorValue\" read-only=\"!isAdvanceSearchDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"isAdvanceSearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" style=\"overflow-x: auto\" ng-if=\"!isAdvanceSearchDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"advanceSearchData.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in advanceSearchDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in advanceSearchData\"><td ng-repeat=\"header in advanceSearchDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"fnGetTdStyle(data[header])\"><span class=\"ellipsis\" ng-if=\"fnGetType(data[header]) === \'string\'\">\'{{data[header]}}\'</span> <span class=\"ellipsis\" ng-if=\"fnGetType(data[header]) !== \'string\' && fnGetType(data[header]) !== \'object\'\">{{data[header]}}</span><json-formatter ng-if=\"fnGetType(data[header]) === \'object\' && fnGetType(data[header]) !== \'null\'\" json=\"data[header]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!advanceSearchData.length\">No records found...</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/attributeValueLineChart/attributeValueLineChart.html","<div class=\"col-sm-12 p-0 h-100 w100 attribute-line-chart-root\"><div class=\"col-sm-12 p-0 attributeValueChartMainContainer\" id=\"attributeValueChartMainContainer\"></div></div>");
$templateCache.put("app/components/directives/billingBarChart/barChart.html","<div class=\"col-sm-12 p-0\"><div id=\"barChart\"></div></div>");
$templateCache.put("app/components/directives/billingDonutChart/donutChart.html","<div class=\"col-sm-12 p-0\" id=\"HighChart3DDonutChart\"><div class=\"col-sm-6 p-0 HighChartBarChart\"><div id=\"chart\"></div></div><div class=\"col-sm-6 p-0\"><div id=\"donutLegend\" class=\"m-t-20\"><div class=\"col-sm-12 p-0 d-flex p-b-10 donutLegendBorderBottom {{ $index !== 0 ? \'m-t-10\':\'\'}}\" ng-repeat=\"donutData in donutLegend track by $index\"><div class=\"col-sm-10 p-0 d-flex align-items-center\"><div class=\"symbol\" style=\"{{\'background-color: \'+(donutData.color)}}\"></div><label class=\"ellipsis-label m-0 p-l-10\">{{donutData.name}}</label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\" style=\"justify-content: flex-end\"><label class=\"ellipsis m-0 text-right\">${{(donutData.value).toFixed(2)}}</label></div></div></div></div></div>");
$templateCache.put("app/components/directives/bubbleChart/bubbleChart.html","<div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 h-100 bubbleChartMainContainer\" id=\"bubbleChartMainContainer\"></div><div id=\"contextMenuBubble\" style=\"display: none\" class=\"contextMenuBubble p-t-5 p-b-5 p-l-3 p-r-3\"><div id=\"contextMenuItem1\" class=\"p-10\">Component Details</div><div id=\"contextMenuItem2\" class=\"p-10\">Edit SupplementalData</div></div></div>");
$templateCache.put("app/components/directives/connectionHeatMapChart/connectionHeatMapChart.html","<div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 connectionHeatMapChartMainContainer\" id=\"connectionHeatMapChartMainContainer\"></div></div>");
$templateCache.put("app/components/directives/customTreeUI/customTreeUI.html","<div class=\"parent-line {{\'left_\'+level +(treeData.index !== \'deviceRoot\'? \' \':\' noLine\')+(treeData.children && treeData.children.length > 0? \' \':\' noChild\')+(isRootParent? \' rootParent\':\' \')}}\"><div class=\"last-child-line {{\'left_\'+(level-1) +(treeData.index !== \'deviceRoot\'? \' \':\' noLine\')+(isLastChild? \' lastChild\':\' \')}}\"><div class=\"col-sm-12 p-0\" ng-if=\"treeData.index !== \'deviceRoot\'\"><div class=\"col-sm-12 p-0 m-t-10 m-b-3 {{treeData.visible === false?\'invisibleComponent\':\'\'}}\"><div class=\"col-sm-12\" style=\"{{\'padding-left :\'+((16*level) + 5)+\'px\'}}\"><span ng-if=\"treeData.children && treeData.children.length > 0\" ng-click=\"treeData.isExpanded = !treeData.isExpanded;fnGetTreeNodeInfo(treeData)\" class=\"fa {{ !treeData.isExpanded ? \'fa-caret-right\':\'fa-caret-down\'}}\" uib-tooltip=\"{{treeData.summaryHealthName}}\" tooltip-placement=\"auto\" style=\"{{::fnGetNodeSummaryHealthColor(treeData)}}\"></span> <span context-menu=\"nodeDetailContextMenu(treeData)\" ng-class=\"{\'current-node\': treeData.id === currentNode.id, \'opacity-5\': treeData.operation === \'DISABLED\'}\" ng-click=\"fnGetNodeTelemetryInfo(treeData)\"><b>{{treeData.name}}</b></span> <button class=\"btn btn-xs btn-default no-borders m-t-1\" ng-class=\"{\'opacity-5\': treeData.operation === \'DISABLED\'}\" ng-click=\"fnGetNodeTelemetryInfo(treeData)\" style=\"{{\'font-size: 9px; background-color :\' +treeData.healthColor +\'; color :\'+treeData.textColor+\';\'}}\"><span class=\"healtSpan\">{{treeData.healthName}}</span></button></div></div></div><custom-tree-ui ng-repeat=\"nodeData in treeData.children track by $index\" ng-show=\"treeData.isExpanded\" tree-data=\"nodeData\" current-node=\"currentNode\" level=\"level+1\" is-root-parent=\"treeData.index === \'deviceRoot\'\" is-last-child=\"$last\" fn-get-node-detail=\"fnGetNodeInfo(nodeObj)\" fn-get-node-telemetry-detail=\"fnGetNodeTelemetryInfo(nodeObj)\" fn-get-node-edit-detail=\"fnGetNodeEditInfo(nodeObj)\" fn-get-node-edit-and-cascade-detail=\"fnGetNodeEditAndCascadeInfo(nodeObj)\" parent-inventories=\"parentInventories\"></custom-tree-ui></div></div>");
$templateCache.put("app/components/directives/dashboardCreateIssue/dashboardCreateIssue.html","<div class=\"form-content\" ng-class=\"isIssueCreating ? \'pace\' : \'\'\"><div class=\"modal-body height-100\" id=\"modal-body\" style=\"overflow: hidden\"><div class=\"row h-100 overflow-auto\"><div class=\"col-sm-12 p-0\" ng-if=\"!isProjectLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex height-max-content\" ng-if=\"isProjectLoaded\"><div class=\"p-0 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class\'\"><div class=\"col-sm-12 m-t-10\" id=\"newIssueTitle\"><div class=\"col-sm-2 p-0 m-t-0 m-b-20 customDropdown floatingLabelInput\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary p-b-5 issue-project-dropdown-menu\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedProject.name}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown p-b-0\" style=\"max-height: none;\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"issueProjectSearch[issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in filterProject=(projectsArr | filter:issueProjectSearch) track by $index\" ng-click=\"fnChangeProject(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === selectedProject.id\"></i></span><div class=\"d-flex flex-column\"><span>{{projectObj.name}}</span> <span class=\"font-italic\">({{projectObj.id}})</span></div></a></li><li ng-if=\"!filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"col-sm-10 p-r-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"newIssueObj.name\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 m-t-0 m-b-20 customDropdown\" id=\"typeListDropdown\"><app-spinner ng-if=\"!isIssueTypeLoaded\" spinner-type=\"\'microSpinner\'\"></app-spinner><div class=\"btn-group col-sm-12 p-0\" ng-if=\"isIssueTypeLoaded\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedType.name}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span> <span style=\"position: absolute;right: 25px;\" ng-if=\"selectedType && selectedType.id && selectedType.id !== \'noType\'\">({{selectedType.id}})</span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"typeObj in typesArr\"><a ng-click=\"fnSelectType(typeObj)\"><span>{{typeObj.name}}</span><br><span class=\"font-italic\" ng-if=\"typeObj.id !== \'noType\'\">({{typeObj.id}})</span></a></li></ul></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"!isTypeDetailsLoaded\"><app-spinner class=\"\" spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex m-t-20 typeFormInputAction\" ng-if=\"isIssueTypeLoaded && selectedType && isTypeDetailsLoaded && selectedType.id !== \'noType\' && form.length\"><form role=\"form\" name=\"typeForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\"></form></div></div><div class=\"col-sm-12 floatingLabelInput\" id=\"issueMarkdownContainer\"><div class=\"m-b-20 createIssue hide-toolbar createIssueMarkdownEditor\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir-for-issue=\"\" placeholder=\"Type your message...\" upload-file=\"uploadFiles(type, filedata)\" ng-model=\"newIssueObj.summary\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'none\'}\" rows=\"10\">\n                            </textarea><div class=\"markdown-footer d-flex justify-content-space-between align-items-center\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-8 p-0 d-flex\"><button class=\"btn btn-primary m-l-0 h-100\" ng-click=\"fnHideShowEditorPreview(\'editor1\')\"><span class=\"fa fa-eye\"></span> Preview</button><div class=\"d-flex align-items-center m-l-20\"><div class=\"d-flex align-items-center\" ng-click=\"fnAddMetaInfo()\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/table-icon.svg#table-icon\"></use></svg><label class=\"m-0 m-l-5\"><strong>Metadata</strong></label></div></div></div><div class=\"col-sm-4 p-0\"><div class=\"d-flex justify-content-flex-end h-100\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!isIssueCreating && !fileUploading && permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary h-100\" ng-if=\"!isIssueCreating && !fileUploading\" ng-disabled=\"!newIssueObj.name.length || !newIssueObj.summary.length || !selectedProject.id.length || fnCheckIssueTypeValidation()\" ng-click=\"fnCreateNewIssue(newIssueObj)\">Submit</button><app-spinner class=\"m-r-5 m-t-4\" ng-if=\"isIssueCreating || fileUploading\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div><div class=\"p-0 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-3\': \'custom-class-sidebar\'\"><div class=\"issue-side-panel h-100 overflow-auto\"><div class=\"col-sm-12 p-0 overflow-auto expand-side-panel\"><div class=\"col-sm-12 p-0\" ng-if=\"isExpanded\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignees</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeAssigneeView && isIssueAssigneeLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeAssigneeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!newIssueObj.assignees.length\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><div class=\"col-sm-12 p-0\"><span class=\"p-0 d-block p-b-5\" ng-if=\"newIssueObj.assignees.length\" ng-repeat=\"assignee in newIssueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"changeAssigneeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleAssignee(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"newIssueObj.assignees.length > 1\">{{newIssueObj.assignees[0].username + \' + \' + (newIssueObj.assignees.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"newIssueObj.assignees.length === 1\">{{newIssueObj.assignees[0].firstName + \' \'+ newIssueObj.assignees[0].lastName}}</span> <span class=\"w100 text-left\" ng-if=\"!newIssueObj.assignees.length\">No Assignees</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign to</label> <span ng-click=\"fnCancelChangeAssignee()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"assigneeSearch[filterAssignees]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"assigneeObj in filterUsers=(usersArr | filter:assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetAssigneeInfo(assigneeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"assigneeObj.isCheck\"></i></span> <span class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" style=\"left: 0px;\" ng-src=\"{{assigneeObj.userAvatar}}\"></span> <span class=\"d-flex flex-column\"><span>{{assigneeObj.firstName + \" \"+ assigneeObj.lastName}}</span> <span class=\"font-italic gateway-id-menu-option\">({{assigneeObj.username}})</span></span></a></li><li ng-if=\"!filterUsers.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageAssignees()\"><a><span>Manage Assignees</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangeAssignee()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changePriorityView && isIssuePriorityLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangePriorityView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!newIssueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"newIssueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"newIssueObj.issuePriority\" ng-style=\"fnGetIssuesLabelColor(newIssueObj.issuePriority.color)\"><span>{{newIssueObj.issuePriority.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"changePriorityView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnTogglePriority(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"newIssueObj.issuePriority.name\">{{newIssueObj.issuePriority.name}}</span> <span class=\"w100 text-left\" ng-if=\"!newIssueObj.issuePriority.name\">No Priority</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Priority</label> <span ng-click=\"fnCancelChangePriority()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"prioritySearch[priorityFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"Priority in filterPriority=(prioritiesArr | filter:prioritySearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetPrioritiesInfo(Priority)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"Priority.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"Priority.color ? {\'background-color\' : Priority.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{Priority.name}}</span></a></li><li ng-if=\"!filterPriority.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectPriority()\"><a><span>Manage project priorities</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangePriority()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeStateView && isIssueStateLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeStateView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeStateView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!newIssueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"newIssueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"newIssueObj.issueState\" ng-style=\"fnGetIssuesLabelColor(newIssueObj.issueState.color)\"><span>{{newIssueObj.issueState.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"changeStateView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleState(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"newIssueObj.issueState.name\">{{newIssueObj.issueState.name}}</span> <span class=\"w100 text-left\" ng-if=\"!newIssueObj.issueState.name\">No State</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign State</label> <span ng-click=\"fnCancelChangeState()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"stateSearch[stateFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"state in filterState=(statesArr | filter:stateSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetStatesInfo(state)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"state.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"state.color ? {\'background-color\' : state.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{state.name}}</span></a></li><li ng-if=\"!filterState.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectState()\"><a><span>Manage project state</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangeState()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!addLabelView && isIssueLablesLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenAddLabelView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!newIssueObj.issueLabels.length\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5 ellipsis-issues-label\" ng-style=\"fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"addLabelView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggle(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"assigneesLabels.length > 1\">{{assigneesLabels[0].name + \' + \' + (assigneesLabels.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"assigneesLabels.length === 1\">{{assigneesLabels[0].name}}</span> <span class=\"w100 text-left\" ng-if=\"!assigneesLabels.length\">No Labels</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign labels</label> <span ng-click=\"fnCancelAddLabelView()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"labelSearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"labelObj in filterLabels=(labelsArr | filter:labelSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetLabelInfo(labelObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"labelObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"labelObj.color ? {\'background-color\' : labelObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{labelObj.name}}</span></a></li><li ng-if=\"!filterLabels.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectLabels()\"><a><span>Manage project labels</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelAddLabelView()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PARTICIPANTS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeParticipantView && isIssueParticipantLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeParticipantView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!newIssueObj.participants.length\"><div class=\"grayItalicValue\">No Participants</div></div><span class=\"p-0 d-block m-r-5 m-b-5 p-2\" ng-if=\"newIssueObj.participants.length\" ng-repeat=\"participant in newIssueObj.participants\"><span class=\"border-1-assignee p-2\">{{participant}}</span></span></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"changeParticipantView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleParticipant(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"assigneesParticipants.length > 1\">{{assigneesParticipants[0].email + \' + \' + (assigneesParticipants.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"assigneesParticipants.length === 1\">{{assigneesParticipants[0].email}}</span> <span class=\"w100 text-left\" ng-if=\"!assigneesParticipants.length\">No Participants</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Participants</label> <span ng-click=\"fnCancelChangeParticipant()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"participantSearch[participantFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"participantObj in filterParticipants=(participantUsersArr | filter:participantSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetParticipantInfo(participantObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"participantObj.isCheck\"></i></span> <span>{{participantObj.email}}</span></a></li><li ng-if=\"!filterParticipants.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnAddNewParticipant()\"><a><span>Add new participant</span></a></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeConfidentialView\"><i class=\"fa fa-edit fa-lg\" ng-click=\"fnOpenChangeConfidentialView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeConfidentialView\"><span ng-if=\"!newIssueObj.confidential\">Not</span> Confidential</div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"changeConfidentialView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintConfidential\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"confidential as confidential.name for confidential in confidentialsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedConfidential.confidential\" placeholder=\"Confidential for the Issue\"> <span class=\"highlight\"></span> <label>Select Confidential</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"isConfidentialChanged\" ng-disabled=\"!fnCheckEmpty(selectedConfidential.confidential.name)\" ng-click=\"fnChangeIssueConfidential(selectedConfidential.confidential)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"isConfidentialChanged\" ng-click=\"fnCancelChangeConfidential()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!isConfidentialChanged\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isExpanded\"><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetAssigneesTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{newIssueObj.issuePriority.name ? newIssueObj.issuePriority.name: \'No Priority\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{newIssueObj.issueState.name ? newIssueObj.issueState.name: \'No State\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetLabelsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetParticipantsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{newIssueObj.confidential ? \'Confidential\' : \'Not Confidential\'}}\" tooltip-placement=\"left\"><svg ng-if=\"newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/confidential.svg#confidential\"></use></svg><svg ng-if=\"!newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/notConfidential.svg#notConfidential\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 d-flex issue-side-panel-expand-btn\"><button class=\"btn btn-primary d-flex align-items-center justify-content-center w100\" ng-click=\"fnExpandCollapseSideBar()\"><i class=\"fa\" ng-class=\"isExpanded ? \'fa-angle-double-right\':\'fa-angle-double-left\'\"></i></button></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"labelColor.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.name\"></span> <span class=\"pull-right m-t-5\" style=\"width: 15px; height: 15px; display: inline-block\" ng-style=\"match.model.color ? {\'background-color\' : match.model.color} : {\'background-color\' : \'inherit\'}\"></span> </a></script><script type=\"text/ng-template\" id=\"assigneeUser.html\"><a> <span class=\"d-flex align-items-center\"> <span class=\"m-r-5\"> <img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{match.model.userAvatar}}\"> </span> <span> <span style=\"display: block;\"> {{match.model.firstName + \" \"+ match.model.lastName}} </span> <span class=\"font-italic gateway-id-menu-option\">({{match.model.username}})</span> </span> </span> </a></script><script type=\"text/ng-template\" id=\"UserNameTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-if=\"match.model.company && match.model.company !==\'\'\"> {{match.model.firstName + \" \"+match.model.lastName + \" \"+\"(\"+match.model.company+\")\"}} </span> <span ng-if=\"!match.model.company || match.model.company ===\'\'\"> {{match.model.firstName + \" \"+match.model.lastName}} </span> </div> <br> </div> </a></script>");
$templateCache.put("app/components/directives/dashboardPieChart/dashboardPieChart.html","<div class=\"col-sm-12 p-0 h-100 w100 HighChartPie\" ng-if=\"!showEmptyChart\"><div class=\"{{chartId}} col-sm-12 p-0 h-100 w100\" id=\"{{chartId}}\"></div></div><div class=\"col-sm-12 p-0 h-100 w100 HighChartPie\" ng-if=\"showEmptyChart\"><div class=\"h-100 d-flex flex-column justify-content-center align-items-center\" style=\"opacity: 0.5\"><svg class=\"dashboard-img-not-found\" style=\"height: 60px;width: 60px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div>");
$templateCache.put("app/components/directives/dashboardWidgetEditor/dashboardWidgetEditor.html","<div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"container-with-footer tab-container\"><div class=\"widget-content-main\"><div class=\"content-main\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Widget</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold text-capitalize\" ng-if=\"isFullWidthDevice\">{{serviceDisplayName}}</h1><h3 class=\"m-0 font-bold text-capitalize\" ng-if=\"!isFullWidthDevice\">{{serviceDisplayName}}</h3><div class=\"d-flex\"><div class=\"w100\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{displayWidget.widgetData.title}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{displayWidget.widgetData.title}}</h5></div><div class=\"w100 d-flex justify-content-flex-end\" ng-if=\"isFullWidthDevice\"><h2 class=\"m-t-10 m-0\" ng-if=\"isViewStaticWidgets\">Static</h2><h2 class=\"m-t-10 m-0\" ng-if=\"isViewBuildCustomWidget\">Custom</h2><h2 class=\"m-t-10 m-0\" ng-if=\"isViewBlueprintWidgets\">Blueprint</h2></div><div class=\"w100 d-flex justify-content-flex-end\" ng-if=\"!isFullWidthDevice\"><h5 class=\"m-t-10 m-0\" ng-if=\"isViewStaticWidgets\">Static</h5><h5 class=\"m-t-10 m-0\" ng-if=\"isViewBuildCustomWidget\">Custom</h5><h5 class=\"m-t-10 m-0\" ng-if=\"isViewBlueprintWidgets\">Blueprint</h5></div></div></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"!isStaticWidgetEdit && !isViewStaticWidgets && !isViewBuildCustomWidget && !isViewBlueprintWidgets\"><div class=\"col-sm-9 overflow-auto p-0\"><div class=\"col-sm-12 p-0 d-flex m-t-30\"><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Edit</label></div><div class=\"panel-body\"><span>Make changes to the current widget.</span></div><div class=\"panel-footer text-right\"><button class=\"btn btn-primary text-right v4-primary-button\" ng-click=\"fnEditWidget()\">Edit Widget</button></div></div></div></div><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Static</label></div><div class=\"panel-body\"><span>These are static widgets that display fixed text, links to services or documentation to help with common tasks or navigation.</span></div><div class=\"panel-footer text-right\"><button ng-click=\"fnGotoListStaticWidget()\" class=\"btn btn-primary text-right v4-primary-button\">Use Static Widget</button></div></div></div></div><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Blueprint</label></div><div class=\"panel-body\"><span>Build a widget from sample configuration presets for common use cases.</span></div><div class=\"panel-footer text-right\"><button ng-click=\"fnGotoListBlueprintWidget()\" class=\"btn btn-primary text-right v4-primary-button\">Use Blueprint Widget</button></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex m-t-30\"><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Customize</label></div><div class=\"panel-body\"><span>Start from scratch and create our own customized widget.</span></div><div class=\"panel-footer text-right\"><button class=\"btn btn-primary text-right v4-primary-button\" ng-click=\"fnBuildCustomWidget()\">Build Custom Widget</button></div></div></div></div><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Restore</label></div><div class=\"panel-body\"><span>If you need a fresh start you can restore the default widget.</span></div><div class=\"panel-footer text-right\"><button ng-click=\"fnRestoreDefault()\" class=\"btn btn-primary text-right v4-primary-button\">Restore Default</button></div></div></div></div><div class=\"col-sm-4 d-flex width-inherit justify-content-space-around\"></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" ng-init=\"fnCreateChartPreview()\" style=\"margin-top: -55px;\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-12 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"panel-body no-panel-footer\"><span>Every dashboard comes with a default view.While the default Dashboard may suffice, the real usefulness of Dashboards lies in your ability to create and customize them the way you want.</span><br><br><span>Dashboards contain one or more widgets that give you an overview of the dimensions and metrics you care about the most.This editor allows you to create and customize a Dashboard.</span></div></div></div></div></div><div class=\"col-sm-12 m-t-10 d-flex min-height-300\" ng-if=\"displayWidget.widgetType !== \'dynamic\'\"><div class=\"custom-widget width-inherit border-0\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW height-100\"><div class=\"dashboard-header-panel\"><div class=\"d-flex align-items-center p-b-10\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><div class=\"custom-svg-icon\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(displayWidget.widgetData.icon)\"></div><label class=\"m-0 m-l-5 font-size-19\">{{displayWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a>Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex align-items-center overflow-auto\" style=\"height: 230px\"><span>{{displayWidget.widgetData.description}}</span></div><div class=\"d-flex justify-content-flex-end p-t-10\"><button ng-if=\"displayWidget.widgetData.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{displayWidget.widgetData.buttonText}}</button></div></div></div></div></div><div class=\"col-sm-12 m-t-10\" ng-if=\"displayWidget.widgetType === \'dynamic\'\"><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!displayWidget.widgetData && !displayWidget.widgetData.icon && !displayWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"displayWidget.widgetData && displayWidget.widgetData.icon && displayWidget.widgetData.icon.length\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(displayWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19\">{{displayWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a>Download PNG image</a></li><li><a>Download JPEG image</a></li><li><a>Download PDF Document</a></li><li><a>Download SVG vector image</a></li><li><a>Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center\" style=\"height: 250px;width: 100%\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"displayWidgetChartData\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'userDashboardWidgets\'+$index\" chart-data=\"displayWidgetChartData\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!displayWidgetChartData\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-primary v4-primary-button\">{{displayWidget.widgetData.buttonText}}</button></div></div></div></div></div></div><div class=\"p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"isViewStaticWidgets\"><div class=\"col-sm-12 p-0 d-flex m-t-25 staticWidgetsSearchContainer\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'staticWidgetsSearchContainer\'\" filters-arr=\"staticWidgetSearchFiltersArr\" filter-query=\"filterQuery\" fn-filter-query-change=\"fnStaticWidgetFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'\'\" no-set-url=\"true\" fn-resize=\"fnSetTableHeight()\" sort-field-arr=\"staticWidgetSortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"col-sm-12 p-0 d-flex staticWidgetsBodyContainer overflow-auto\" style=\"overflow-x: hidden !important;\"><div class=\"w100\"><div class=\"col-sm-12 p-l-0 p-r-0 w100\"><div class=\"col-sm-12\" ng-if=\"!staticWidgetsArr.length\"><label>No records found...</label></div><div class=\"col-sm-3 m-b-15 p-0\" ng-repeat=\"tab in staticWidgetsArr track by $index\"><div class=\"p-r-15 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">{{tab.widgetTitle}}</label></div><div class=\"panel-body overflow-auto\" style=\"height: 100px !important;\"><span>{{tab.widgetDescription}}</span></div><div class=\"panel-footer text-right\"><button ng-click=\"fnEditWidget(true, tab)\" class=\"btn btn-primary text-right v4-primary-button\">Use Static Widget</button></div></div></div></div></div></div></div></div><div class=\"row d-flex m-b-0 staticWidgetsPaginationContainer\"><div class=\"col-sm-12 m-t-5\"><div class=\"pagination-container\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{staticWidgetPerPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"staticWidgetPerPage = 10; fnStaticWidgetPageChanged(staticWidgetCurrentPage, staticWidgetPerPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"staticWidgetPerPage = 20; fnStaticWidgetPageChanged(staticWidgetCurrentPage, staticWidgetPerPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"staticWidgetPerPage = 50; fnStaticWidgetPageChanged(staticWidgetCurrentPage, staticWidgetPerPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"staticWidgetPerPage = 100; fnStaticWidgetPageChanged(staticWidgetCurrentPage, staticWidgetPerPage)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"staticWidgetTotalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"staticWidgetCurrentPage\" items-per-page=\"staticWidgetPerPage\" max-size=\"maxSize\" boundary-links=\"true\" ng-click=\"fnStaticWidgetPageChanged(staticWidgetCurrentPage, staticWidgetPerPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"isViewBlueprintWidgets\"><div class=\"col-sm-12 p-0 d-flex m-t-25 blueprintWidgetsSearchContainer\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'blueprintWidgetsSearchContainer\'\" filters-arr=\"blueprintWidgetSearchFiltersArr\" filter-query=\"filterQuery\" fn-filter-query-change=\"fnBlueprintWidgetFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'\'\" no-set-url=\"true\" fn-resize=\"fnSetTableHeight()\" sort-field-arr=\"blueprintWidgetSortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"col-sm-12 p-0 d-flex blueprintWidgetsBodyContainer overflow-auto\" style=\"overflow-x: hidden !important;\"><div class=\"w100\"><div class=\"col-sm-12 p-l-0 p-r-0 w100\"><div class=\"col-sm-12\" ng-if=\"!blueprintWidgetsArr.length\"><label>No records found...</label></div><div class=\"col-sm-3 m-b-15 p-0\" ng-repeat=\"tab in blueprintWidgetsArr track by $index\"><div class=\"p-r-15 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">{{tab.widgetTitle}}</label></div><div class=\"panel-body overflow-auto\" style=\"height: 100px !important;\"><span>{{tab.widgetDescription}}</span></div><div class=\"panel-footer text-right\" style=\"height: 55px;\"><button ng-if=\"!tab.isWidgetLoading\" ng-click=\"fnEditBlueprintWidget(tab)\" class=\"btn btn-primary text-right v4-primary-button\">Use Widget</button><div class=\"d-flex justify-content-flex-end\" ng-if=\"tab.isWidgetLoading\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div><div class=\"row d-flex m-b-0 blueprintWidgetsPaginationContainer\"><div class=\"col-sm-12 m-t-5\"><div class=\"pagination-container\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{blueprintWidgetPerPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"blueprintWidgetPerPage = 10; fnBlueprintWidgetPageChanged(blueprintWidgetCurrentPage, blueprintWidgetPerPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"blueprintWidgetPerPage = 20; fnBlueprintWidgetPageChanged(blueprintWidgetCurrentPage, blueprintWidgetPerPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"blueprintWidgetPerPage = 50; fnBlueprintWidgetPageChanged(blueprintWidgetCurrentPage, blueprintWidgetPerPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"blueprintWidgetPerPage = 100; fnBlueprintWidgetPageChanged(blueprintWidgetCurrentPage,blueprintWidgetPerPage)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"blueprintWidgetTotalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"blueprintWidgetCurrentPage\" items-per-page=\"blueprintWidgetPerPage\" max-size=\"maxSize\" boundary-links=\"true\" ng-click=\"fnBlueprintWidgetPageChanged(blueprintWidgetCurrentPage, blueprintWidgetPerPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"isStaticWidgetEdit\"><div class=\"col-sm-8 p-l-0\"><div class=\"col-sm-12 p-0 d-flex m-t-20\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.title\" placeholder=\"Title*\" name=\"title\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-30 customDropdown\" ng-if=\"!isPasteSVGCode\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" style=\"height: 43px;\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(selectedWidget.widgetData.icon)\"></span> <label class=\"titleLabel\">ICON*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"min-width: 250px;\"><li ng-repeat=\"svgObj in svgArr track by $index\" ng-mousedown=\"fnSelectIcon(svgObj)\"><a><span>{{svgObj.title}}</span> <span class=\"pull-right pull-right font-italic m-t-2\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(svgObj.iconURL)\"></span></a></li></ul></div><button class=\"btn-link p-0\" style=\"position: absolute;right: 0;top: 43px;\" ng-click=\"fnEditSVGCode()\">Paste SVG code</button></div><div class=\"md-input m-b-20\" ng-if=\"isPasteSVGCode\"><input class=\"md-form-control\" id=\"icon\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.icon\" placeholder=\"Icon*\" name=\"icon\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"selectedWidget.widgetData.description\" placeholder=\"Description*\" autocomplete=\"off\" name=\"description\"> <span class=\"highlight\"></span> <label>Description*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"buttonText\" type=\"text\" name=\"buttonText\" autocomplete=\"off\" ng-pattern=\"userModal.emailPattern\" ng-model=\"selectedWidget.widgetData.buttonText\" placeholder=\"Button Text*\"> <span class=\"highlight\"></span> <label>Button Text*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"buttonLink\" type=\"text\" name=\"buttonLink\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.buttonLink\" placeholder=\"Button Link*\"> <span class=\"highlight\"></span> <label>Button Link*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"selectedWidget.widgetData.target\">{{selectedWidget.widgetData.target}}</span> <label class=\"titleLabel\">TARGET*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\"><a ng-click=\"selectedWidget.widgetData.target = \'New Window\'\">New Window</a></li><li role=\"menuitem\"><a ng-click=\"selectedWidget.widgetData.target = \'Same Window\'\">Same Window</a></li></ul></div></div></div></form></div></div></div><div class=\"col-sm-4 p-r-0\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 m-t-10 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW height-100\"><div class=\"dashboard-header-panel\"><div class=\"d-flex align-items-center p-b-10\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><div class=\"custom-svg-icon\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(selectedWidget.widgetData.icon)\"></div><label class=\"m-0 m-l-5 font-size-19\">{{selectedWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a>Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex align-items-center overflow-auto\" style=\"height: 230px;\"><span>{{selectedWidget.widgetData.description}}</span></div><div class=\"d-flex justify-content-flex-end p-t-10\"><button ng-if=\"selectedWidget.widgetData.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{selectedWidget.widgetData.buttonText}}</button></div></div></div></div></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"isViewBuildCustomWidget\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': buildCustomWidgetActiveStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 55.25 55.25\" width=\"25px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M52.618,2.631c-3.51-3.508-9.219-3.508-12.729,0L3.827,38.693C3.81,38.71,3.8,38.731,3.785,38.749 c-0.021,0.024-0.039,0.05-0.058,0.076c-0.053,0.074-0.094,0.153-0.125,0.239c-0.009,0.026-0.022,0.049-0.029,0.075 c-0.003,0.01-0.009,0.02-0.012,0.03l-3.535,14.85c-0.016,0.067-0.02,0.135-0.022,0.202C0.004,54.234,0,54.246,0,54.259 c0.001,0.114,0.026,0.225,0.065,0.332c0.009,0.025,0.019,0.047,0.03,0.071c0.049,0.107,0.11,0.21,0.196,0.296 c0.095,0.095,0.207,0.168,0.328,0.218c0.121,0.05,0.25,0.075,0.379,0.075c0.077,0,0.155-0.009,0.231-0.027l14.85-3.535 c0.027-0.006,0.051-0.021,0.077-0.03c0.034-0.011,0.066-0.024,0.099-0.039c0.072-0.033,0.139-0.074,0.201-0.123 c0.024-0.019,0.049-0.033,0.072-0.054c0.008-0.008,0.018-0.012,0.026-0.02l36.063-36.063C56.127,11.85,56.127,6.14,52.618,2.631z M51.204,4.045c2.488,2.489,2.7,6.397,0.65,9.137l-9.787-9.787C44.808,1.345,48.716,1.557,51.204,4.045z M46.254,18.895l-9.9-9.9 l1.414-1.414l9.9,9.9L46.254,18.895z M4.961,50.288c-0.391-0.391-1.023-0.391-1.414,0L2.79,51.045l2.554-10.728l4.422-0.491 l-0.569,5.122c-0.004,0.038,0.01,0.073,0.01,0.11c0,0.038-0.014,0.072-0.01,0.11c0.004,0.033,0.021,0.06,0.028,0.092 c0.012,0.058,0.029,0.111,0.05,0.165c0.026,0.065,0.057,0.124,0.095,0.181c0.031,0.046,0.062,0.087,0.1,0.127 c0.048,0.051,0.1,0.094,0.157,0.134c0.045,0.031,0.088,0.06,0.138,0.084C9.831,45.982,9.9,46,9.972,46.017 c0.038,0.009,0.069,0.03,0.108,0.035c0.036,0.004,0.072,0.006,0.109,0.006c0,0,0.001,0,0.001,0c0,0,0.001,0,0.001,0h0.001 c0,0,0.001,0,0.001,0c0.036,0,0.073-0.002,0.109-0.006l5.122-0.569l-0.491,4.422L4.204,52.459l0.757-0.757 C5.351,51.312,5.351,50.679,4.961,50.288z M17.511,44.809L39.889,22.43c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0 L16.097,43.395l-4.773,0.53l0.53-4.773l22.38-22.378c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L10.44,37.738 l-3.183,0.354L34.94,10.409l9.9,9.9L17.157,47.992L17.511,44.809z M49.082,16.067l-9.9-9.9l1.415-1.415l9.9,9.9L49.082,16.067z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': buildCustomWidgetActiveStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 -17 512 512\" width=\"26px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"m74.722656 297.265625h-51.734375c-12.675781 0-22.988281 10.3125-22.988281 22.992187v134.375c0 12.675782 10.3125 22.988282 22.988281 22.988282h51.734375c12.679688 0 22.992188-10.3125 22.992188-22.988282v-134.375c0-12.679687-10.3125-22.992187-22.992188-22.992187zm7.992188 157.367187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734375c-4.402343 0-7.988281-3.585938-7.988281-7.988282v-134.375c0-4.40625 3.585938-7.992187 7.988281-7.992187h51.734375c4.40625 0 7.992188 3.585937 7.992188 7.992187zm0 0\"></path><path d=\"m212.820312 191.945312h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988282v42.644531c0 4.140625 3.355469 7.5 7.5 7.5 4.140625 0 7.5-3.359375 7.5-7.5v-42.644531c0-4.402344 3.582032-7.988282 7.988282-7.988282h51.734374c4.40625 0 7.988282 3.585938 7.988282 7.988282v239.699218c0 4.402344-3.582032 7.988282-7.988282 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-167.054687c0-4.140625-3.359375-7.5-7.5-7.5-4.144531 0-7.5 3.359375-7.5 7.5v167.054687c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.675782 0 22.988282-10.3125 22.988282-22.988282v-239.695312c0-12.679688-10.3125-22.992188-22.988282-22.992188zm0 0\"></path><path d=\"m350.914062 255.140625h-51.734374c-12.675782 0-22.988282 10.3125-22.988282 22.988281v176.503906c0 12.675782 10.3125 22.988282 22.988282 22.988282h51.734374c12.679688 0 22.992188-10.3125 22.992188-22.988282v-176.503906c0-12.675781-10.3125-22.988281-22.992188-22.988281zm7.992188 199.492187c0 4.402344-3.585938 7.988282-7.992188 7.988282h-51.734374c-4.40625 0-7.988282-3.585938-7.988282-7.988282v-176.503906c0-4.40625 3.582032-7.988281 7.988282-7.988281h51.734374c4.40625 0 7.992188 3.582031 7.992188 7.988281zm0 0\"></path><path d=\"m489.011719 139.285156h-51.734375c-12.675782 0-22.992188 10.3125-22.992188 22.988282v214.304687c0 4.140625 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.359375 7.5-7.5v-214.304687c0-4.40625 3.585938-7.988282 7.992188-7.988282h51.734375c4.402343 0 7.988281 3.582032 7.988281 7.988282v292.359374c0 4.402344-3.585938 7.988282-7.988281 7.988282h-51.734375c-4.40625 0-7.992188-3.585938-7.992188-7.988282v-48.054687c0-4.140625-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.359375-7.5 7.5v48.054687c0 12.675782 10.316406 22.988282 22.992188 22.988282h51.734375c12.675781 0 22.988281-10.3125 22.988281-22.988282v-292.359374c0-12.675782-10.3125-22.988282-22.988281-22.988282zm0 0\"></path><path d=\"m48.855469 157.980469c-25.765625 0-46.730469 20.964843-46.730469 46.730469 0 25.769531 20.964844 46.734374 46.730469 46.734374 25.769531 0 46.734375-20.964843 46.734375-46.734374 0-2.046876-.148438-4.054688-.402344-6.03125l73.683594-56.199219c5.5625 2.34375 11.675781 3.644531 18.082031 3.644531 10.101563 0 19.457031-3.234375 27.109375-8.703125l64.460938 29.496094c2.195312 23.742187 22.21875 42.398437 46.523437 42.398437 25.769531 0 46.734375-20.964844 46.734375-46.730468 0-2.792969-.261719-5.523438-.730469-8.179688l76.027344-63.789062c5.011719 1.84375 10.425781 2.847656 16.066406 2.847656 25.765625 0 46.730469-20.964844 46.730469-46.734375 0-25.765625-20.964844-46.730469-46.730469-46.730469-25.769531 0-46.734375 20.964844-46.734375 46.730469 0 2.792969.261719 5.523437.730469 8.179687l-76.03125 63.789063c-5.007813-1.839844-10.421875-2.847657-16.0625-2.847657-10.101563 0-19.457031 3.234376-27.109375 8.707032l-64.460938-29.5c-2.195312-23.742188-22.214843-42.398438-46.523437-42.398438-25.769531 0-46.730469 20.964844-46.730469 46.730469 0 2.046875.144532 4.058594.402344 6.035156l-73.6875 56.195313c-5.566406-2.34375-11.671875-3.640625-18.082031-3.640625zm414.289062-142.980469c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.496093-14.234375 31.734375-31.730469 31.734375-17.234375 0-31.734375-14.5-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-40.5625 54.925781c.125.21875.261719.429688.390625.644531 2.710938 4.566407 6.199219 8.667969 10.277344 12.070313l-67.640625 56.746094c-.125-.21875-2.175781-3.476563-3.179687-4.816407-2.179688-2.90625-4.691407-5.5625-7.488282-7.898437zm-129.261719 92.191407c.257813-17.007813 14.621094-31.265626 31.726563-31.265626 17.054687 0 31.730469 14.582032 31.730469 31.734376 0 17.496093-14.234375 31.730468-31.730469 31.730468s-31.730469-14.234375-31.730469-31.730468c0-.15625 0-.3125.003906-.46875zm-67.832031-36.328126c3.070313-4.507812 5.386719-9.519531 6.738281-14.804687l54.46875 24.921875c-2.773437 3.996094-4.941406 8.433594-6.359374 13.089844-.203126.660156-.390626 1.324218-.5625 1.992187l-54.46875-24.921875c.0625-.089844.121093-.183594.183593-.277344zm-38.535156-58.128906c17.496094 0 31.730469 14.234375 31.730469 31.730469 0 17.09375-14.664063 31.734375-31.730469 31.734375-17.074219 0-31.734375-14.5625-31.734375-31.734375 0-17.496094 14.234375-31.730469 31.734375-31.730469zm-41.597656 53.019532c.089843.171874.191406.34375.28125.515624 2.507812 4.742188 5.832031 9.054688 9.789062 12.675782l-64.972656 49.554687c-1.203125-2.34375-2.617187-4.59375-4.195313-6.699219-1.75-2.335937-3.710937-4.515624-5.875-6.496093zm-77.589844 58.824218c7.699219 5.859375 12.824219 15.085938 12.824219 25.207032 0 17.5-14.234375 31.734374-31.734375 31.734374-17.496094 0-31.730469-14.234374-31.730469-31.734374 0-17.496094 14.234375-31.730469 31.730469-31.730469 6.976562 0 13.566406 2.449219 18.910156 6.523437zm0 0\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': buildCustomWidgetActiveStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon m-t-5 m-l-5\"><g><path d=\"m184.296875 512c-4.199219 0-8.277344-1.644531-11.304687-4.691406-3.925782-3.925782-5.527344-9.582032-4.265626-14.976563l23.253907-98.667969c.679687-2.902343 2.152343-5.546874 4.265625-7.636718l203.648437-203.648438c18.109375-18.132812 49.75-18.15625 67.882813 0l30.164062 30.164063c9.066406 9.046875 14.058594 21.121093 14.058594 33.921875 0 12.820312-4.992188 24.894531-14.058594 33.941406l-203.648437 203.625c-2.113281 2.113281-4.757813 3.585938-7.636719 4.265625l-98.667969 23.253906c-1.234375.320313-2.472656.449219-3.691406.449219zm37.78125-106.582031-16.277344 69.078125 69.078125-16.277344 200.429688-200.425781c3.027344-3.03125 4.691406-7.039063 4.691406-11.308594 0-4.265625-1.664062-8.296875-4.691406-11.304687l-30.167969-30.167969c-6.25-6.226563-16.382813-6.25-22.632813 0zm60.910156 67.328125h.210938zm0 0\"></path><path d=\"m433.835938 337.898438c-4.097657 0-8.191407-1.558594-11.308594-4.691407l-75.433594-75.4375c-6.25-6.25-6.25-16.382812 0-22.632812s16.382812-6.25 22.632812 0l75.4375 75.433593c6.25 6.25 6.25 16.382813 0 22.636719-3.136718 3.132813-7.234374 4.691407-11.328124 4.691407zm0 0\"></path><path d=\"m145.921875 448h-97.921875c-26.476562 0-48-21.523438-48-48v-352c0-26.476562 21.523438-48 48-48h309.332031c26.476563 0 48 21.523438 48 48v98.773438c0 8.832031-7.167969 16-16 16s-16-7.167969-16-16v-98.773438c0-8.832031-7.167969-16-16-16h-309.332031c-8.832031 0-16 7.167969-16 16v352c0 8.832031 7.167969 16 16 16h97.921875c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m389.332031 138.667969h-373.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h373.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m310.828125 245.332031h-294.828125c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h294.828125c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352h-186.667969c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h186.667969c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0\"></path><path d=\"m202.667969 352c-8.832031 0-16-7.167969-16-16v-213.332031c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v213.332031c0 8.832031-7.167969 16-16 16zm0 0\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': buildCustomWidgetActiveStep === 4}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 512 512\" width=\"30px\" class=\"m-auto d-flex justify-content-center custom-wizard-svg-icon\"><path d=\"M410.34277,18.34277,388.68555,40H360a8.00039,8.00039,0,0,0-8,8V76.68555L324.68555,104H296a8.00039,8.00039,0,0,0-8,8v28.68555L260.68555,168H232a8.00039,8.00039,0,0,0-8,8v28.68555L188.68652,240H161.33423a95.64587,95.64587,0,0,1,42.97925-64.91309l-8.627-13.47461A112.00943,112.00943,0,0,0,256,368H358.75293A152.11931,152.11931,0,0,1,256,408c-83.81348,0-152-68.18652-152-152H88a167.79394,167.79394,0,0,0,4.82446,40H32V216H96a8,8,0,0,0,7.39062-4.93848l12.92188-31.19629a8.00028,8.00028,0,0,0-1.7334-8.71875l-45.25586-45.2539,56.56934-56.56934,45.2539,45.25586a7.99745,7.99745,0,0,0,8.71875,1.7334l31.19629-12.92188A8,8,0,0,0,216,96V32h80V80h16V24a8.00039,8.00039,0,0,0-8-8H208a8.00039,8.00039,0,0,0-8,8V90.6543l-21.31934,8.831L131.5498,52.35254a8.0018,8.0018,0,0,0-11.31445,0L52.35254,120.23535a8.0018,8.0018,0,0,0,0,11.31445l47.13281,47.13086L90.6543,200H24a8.00039,8.00039,0,0,0-8,8v96a8.00039,8.00039,0,0,0,8,8H90.6543l8.831,21.31934L52.35254,380.4502a8.0018,8.0018,0,0,0,0,11.31445l67.88281,67.88281a8.0018,8.0018,0,0,0,11.31445,0l47.13086-47.13281L200,421.3457V488a8.00039,8.00039,0,0,0,8,8h96a8.00039,8.00039,0,0,0,8-8V421.3457l21.31934-8.83105,47.13086,47.13281a8.0018,8.0018,0,0,0,11.31445,0l67.88281-67.88281a8.00062,8.00062,0,0,0-.001-11.31445L447.19629,368H488a8.00039,8.00039,0,0,0,8-8V88a8.00039,8.00039,0,0,0-8-8H424a8.00039,8.00039,0,0,0-8,8v56H360a8.00039,8.00039,0,0,0-8,8v40H296a8.00039,8.00039,0,0,0-8,8v48H232a8.00039,8.00039,0,0,0-8,8v32H165.491A95.5652,95.5652,0,0,1,160,256h32a8.00235,8.00235,0,0,0,5.65723-2.34277L235.31445,216H264a8.00039,8.00039,0,0,0,8-8V179.31445L299.31445,152H328a8.00039,8.00039,0,0,0,8-8V115.31445L363.31445,88H392a8.00039,8.00039,0,0,0,8-8V51.31445L419.31348,32H496V16H416A8.00235,8.00235,0,0,0,410.34277,18.34277Zm-284.45019,424.334L69.32324,386.10742l43.04395-43.042a169.30277,169.30277,0,0,0,56.56738,56.56738ZM216,480V419.17554a167.97791,167.97791,0,0,0,80-.01514V480Zm226.67676-93.89258-56.56934,56.56934-43.032-43.03369A168.05664,168.05664,0,0,0,381.20654,368h43.36182ZM432,96h48V352H432V96Zm-64,64h48V352H368V160Zm-64,48h48V352H304V208Zm-64,56h48v88H256a96.21362,96.21362,0,0,1-16-1.34082V264Zm-16,40v42.509A96.52,96.52,0,0,1,172.887,304Zm32-104H240V184h16Zm64-64H304V120h16Zm64-64H368V56h16Z\"></path></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': buildCustomWidgetActiveStep === 5}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 56 56\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M8,14c3.519,0,6.432-2.614,6.92-6H54c0.553,0,1-0.447,1-1s-0.447-1-1-1H14.92C14.432,2.614,11.519,0,8,0 C4.14,0,1,3.141,1,7S4.14,14,8,14z M8,2c2.757,0,5,2.243,5,5s-2.243,5-5,5S3,9.757,3,7S5.243,2,8,2z\"></path><path d=\"M48,42c-3.519,0-6.432,2.614-6.92,6H2c-0.552,0-1,0.447-1,1s0.448,1,1,1h39.08c0.488,3.386,3.401,6,6.92,6 c3.859,0,7-3.141,7-7S51.859,42,48,42z M48,54c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S50.757,54,48,54z\"></path><path d=\"M54,27H35.368c-0.396-3.602-3.455-6.414-7.161-6.414c-3.706,0-6.765,2.813-7.161,6.414H2c-0.552,0-1,0.447-1,1s0.448,1,1,1 h19.109c0.577,3.4,3.536,6,7.098,6c3.562,0,6.52-2.6,7.097-6H54c0.553,0,1-0.447,1-1S54.553,27,54,27z M28.207,33 C25.336,33,23,30.664,23,27.793s2.336-5.207,5.207-5.207s5.207,2.336,5.207,5.207S31.078,33,28.207,33z\"></path></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div ng-if=\"buildCustomWidgetActiveStep === 1\" ng-class=\"{\'active\' : buildCustomWidgetActiveStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-space-between\"><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"isAPIDataLoading\" ng-click=\"fnRunQuery()\">Run Query</button> <button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"isAPIDataLoading\" ng-click=\"fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-6 p-0\"><i class=\"fa fa-info-circle\" uib-tooltip=\"Click to see the list of available table names for your account\" tooltip-placement=\"left\" ng-click=\"fnOpenTablesModal()\"></i></div></div><div class=\"col-sm-12 p-0 p-t-30 m-b-20 custom-sql-editor\"><div><span>QUERY</span><div class=\"editorMedium\"><javascript-editor value=\"advanceSearchQueryConfig.value\" available-defs=\"availableDataLibs\" editor-value=\"advanceSearchQueryConfig.editorValue\" read-only=\"!isAPIDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"isAPIDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" style=\"overflow-x: auto\" ng-if=\"!isAPIDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"apiData.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in apiDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in apiData\"><td ng-repeat=\"header in apiDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"fnGetTdStyle(data[header])\"><span class=\"ellipsis\" ng-if=\"fnGetType(data[header]) === \'string\'\">\'{{data[header]}}\'</span> <span class=\"ellipsis\" ng-if=\"fnGetType(data[header]) !== \'string\' && fnGetType(data[header]) !== \'object\'\">{{data[header]}}</span><json-formatter ng-if=\"fnGetType(data[header]) === \'object\' && fnGetType(data[header]) !== \'null\'\" json=\"data[header]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!apiData.length\">No records found...</div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : buildCustomWidgetActiveStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><label>Selected Chart: {{selectedWidget && selectedWidget.chartConfiguration && selectedWidget.chartConfiguration.chartType && selectedWidget.chartConfiguration.chartType !== \'\' ? selectedWidget.chartConfiguration.chartType : \'pie\'}}</label></div><div class=\"col-sm-12 height-100 p-0\"><div id=\"chartEditor\" style=\"height: 10px;\" class=\"col-sm-12 p-0 chartEditor width-inherit\"></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : buildCustomWidgetActiveStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12 height-100\"><div class=\"col-sm-12 p-0 height-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-10 d-flex align-items-center\"><div class=\"col-sm-6 p-0\"><label class=\"m-0\">Table field mapping for chart data:</label></div><div class=\"col-sm-6 p-0\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"isAllowMultiField\" ng-click=\"fnAddNewMapping()\"><i class=\"fa fa-plus m-r-5\"></i>Add New Mapping</button></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><h3 class=\"m-b-20\">Available Fields</h3><div ng-repeat=\"dataHeader in apiDataHeader\" class=\"availableField d-flex align-items-center m-b-20 p-10\"><span class=\"ellipsis\">{{dataHeader}}</span></div></div><div class=\"col-sm-7 p-0\"><h3 class=\"m-b-20\">Used Fields</h3><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-repeat=\"data in dataConfig track by $index\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"data.value\" typeahead-editable=\"true\" uib-typeahead=\"dataHeader for dataHeader in apiDataHeader | filter:$viewValue\" typeahead-min-length=\"0\" placeholder=\"Field {{data.isRequired ? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{data.key}} {{data.isRequired ? \'*\' : \'\'}}</label></div></div><div class=\"m-t-5\" style=\"width: 18px;\"><button ng-show=\"!data.isRequired\" class=\"btn btn-link p-r-0 p-l-0\" ng-click=\"fnRemoveMapping($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : buildCustomWidgetActiveStep === 4}\" role=\"tabpanel\" id=\"step4\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnEditChartProperties()\"><i class=\"fa fa-edit m-r-5\"></i>Customize chart</button></div><div class=\"col-sm-12 height-100 p-t-20 HighChartPie HighChartBarChart\"><div id=\"previewChart\" style=\"height: 500px;\" class=\"col-sm-12 p-0 previewChart width-inherit\"></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : buildCustomWidgetActiveStep === 5}\" role=\"tabpanel\" id=\"step5\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 m-t-20\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title!\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.title\" placeholder=\"Title*\" name=\"title\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-30 customDropdown\" ng-if=\"!isPasteSVGCode\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" style=\"height: 43px;\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(selectedWidget.widgetData.icon)\"></span> <label class=\"titleLabel\">ICON*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"min-width: 250px;\"><li ng-repeat=\"svgObj in svgArr track by $index\" ng-mousedown=\"fnSelectIcon(svgObj)\"><a><span>{{svgObj.title}}</span> <span class=\"pull-right pull-right font-italic m-t-2\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(svgObj.iconURL)\"></span></a></li></ul></div><button class=\"btn-link p-0\" style=\"position: absolute;right: 0;top: 43px;\" ng-click=\"fnEditSVGCode()\">Paste SVG code</button></div><div class=\"md-input m-b-20\" ng-if=\"isPasteSVGCode\"><input class=\"md-form-control\" required=\"\" id=\"icon1\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.icon\" placeholder=\"Icon*\" name=\"icon\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonText\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.buttonText\" placeholder=\"Button Text*\" name=\"actionButtonText\"> <span class=\"highlight\"></span> <label>Button Text*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonLink\" type=\"text\" autocomplete=\"off\" ng-model=\"selectedWidget.widgetData.buttonLink\" placeholder=\"Button Link*\" name=\"actionButtonLink\"> <span class=\"highlight\"></span> <label>Button Link*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"selectedWidget.widgetData.target\">{{selectedWidget.widgetData.target}}</span> <label class=\"titleLabel\">TARGET*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\"><a ng-click=\"selectedWidget.widgetData.target = \'New Window\'\">New Window</a></li><li role=\"menuitem\"><a ng-click=\"selectedWidget.widgetData.target = \'Same Window\'\">Same Window</a></li></ul></div></div></div></form></div></div><div class=\"col-sm-4\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!selectedWidget.widgetData && !selectedWidget.widgetData.icon && !selectedWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"selectedWidget.widgetData && selectedWidget.widgetData.icon && selectedWidget.widgetData.icon.length\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(selectedWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19\">{{selectedWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a>Download PNG image</a></li><li><a>Download JPEG image</a></li><li><a>Download PDF Document</a></li><li><a>Download SVG vector image</a></li><li><a>Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center\" style=\"height: 250px;width: 100%\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"previewWidgetChartData\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'previewWidgetChart\'+selectedColumn\" chart-data=\"previewWidgetChartData\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!previewWidgetChartData\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-primary v4-primary-button\">{{selectedWidget.widgetData.buttonText}}</button></div></div></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-0 p-t-10 p-b-10\" style=\"height: max-content\" ng-if=\"isStaticWidgetEdit\"><div class=\"col-sm-6 content-box-footerItem m-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"fnCancelWidgetEdit()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex justify-content-flex-end align-items-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"fnSaveWidgetEdit()\">Save Changes</button></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" style=\"height: max-content\" ng-if=\"isViewStaticWidgets\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-l-0\"><div><label class=\"m-0\">Total: {{staticWidgetTotalItems}}</label></div></div><div class=\"col-sm-6 content-box-footerItem m-0 p-r-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel m-r-0 pull-right\" ng-click=\"fnExitWidgets()\">Cancel</button></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" style=\"height: max-content\" ng-if=\"isViewBlueprintWidgets\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-l-0\"><div><label class=\"m-0\">Total: {{blueprintWidgetTotalItems}}</label></div></div><div class=\"col-sm-6 content-box-footerItem m-0 p-r-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel m-r-0 pull-right\" ng-click=\"fnExitWidgets()\">Cancel</button></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" style=\"height: max-content\" ng-if=\"isViewBuildCustomWidget\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-click=\"fnCancelBuildCustomWidget()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep !== 1\" ng-click=\"fnGotoNextPreviousStep(true)\">Back</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex justify-content-flex-end align-items-center p-r-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep === 1\" ng-disabled=\"isAPIDataLoading || !apiData.length\" ng-click=\"fnGotoNextPreviousStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep === 2\" ng-click=\"fnGotoNextPreviousStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep === 3\" ng-disabled=\"!fnCheckRequiredInput()\" ng-click=\"fnGotoNextPreviousStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep === 4\" ng-click=\"fnGotoNextPreviousStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"buildCustomWidgetActiveStep === 5\" ng-disabled=\"!selectedWidget.widgetData.title.length || !selectedWidget.widgetData.icon.length || !selectedWidget.widgetData.buttonText.length || !selectedWidget.widgetData.target.length || !selectedWidget.widgetData.buttonLink.length\" ng-click=\"fnSaveBuildCustomWidget()\">Save Changes</button></div></div></div></div></div><script type=\"text/ng-template\" id=\"apiListTemplate.html\"><a> <span class=\"m-r-5\">{{ match.model.appName +\' → \'+ match.model.serviceName}}</span> </a></script></div>");
$templateCache.put("app/components/directives/expandCollapseContainer/expandCollapseContainer.html","<span class=\"expandCollapseIcon\" ng-if=\"infoSectionClass === \'col-sm-6\'\" ng-click=\"fnExpandCollapse()\"><svg viewbox=\"0 0 489.3 489.3\"><g><path d=\"M476.95,0H12.35c-6.8,0-12.2,5.5-12.2,12.2V235c0,6.8,5.5,12.2,12.2,12.2s12.3-5.5,12.3-12.2V24.5h440.2v440.2h-211.9 c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h224c6.8,0,12.3-5.5,12.3-12.3V12.3C489.25,5.5,483.75,0,476.95,0z\"></path><path d=\"M0.05,476.9c0,6.8,5.5,12.3,12.2,12.3h170.4c6.8,0,12.3-5.5,12.3-12.3V306.6c0-6.8-5.5-12.3-12.3-12.3H12.35 c-6.8,0-12.2,5.5-12.2,12.3v170.3H0.05z M24.55,318.8h145.9v145.9H24.55V318.8z\"></path><path d=\"M222.95,266.3c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l138.6-138.7v79.9c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3 V98.1c0-6.8-5.5-12.3-12.3-12.3h-109.5c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h79.9L222.95,249 C218.15,253.8,218.15,261.5,222.95,266.3z\"></path></g></svg></span> <span class=\"expandCollapseIcon\" ng-if=\"infoSectionClass === \'col-sm-12\'\" ng-click=\"fnExpandCollapse()\"><svg viewbox=\"0 0 489.3 489.3\"><g transform=\"matrix(-1 1.22465e-16 -1.22465e-16 -1 489.3 489.3)\"><path d=\"M476.95,0H12.35c-6.8,0-12.2,5.5-12.2,12.2V235c0,6.8,5.5,12.2,12.2,12.2s12.3-5.5,12.3-12.2V24.5h440.2v440.2h-211.9 c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h224c6.8,0,12.3-5.5,12.3-12.3V12.3C489.25,5.5,483.75,0,476.95,0z\" data-original=\"#000000\" class=\"active-path\"></path><path d=\"M0.05,476.9c0,6.8,5.5,12.3,12.2,12.3h170.4c6.8,0,12.3-5.5,12.3-12.3V306.6c0-6.8-5.5-12.3-12.3-12.3H12.35 c-6.8,0-12.2,5.5-12.2,12.3v170.3H0.05z M24.55,318.8h145.9v145.9H24.55V318.8z\" data-original=\"#000000\" class=\"active-path\"></path><path d=\"M222.95,266.3c2.4,2.4,5.5,3.6,8.7,3.6s6.3-1.2,8.7-3.6l138.6-138.7v79.9c0,6.8,5.5,12.3,12.3,12.3s12.3-5.5,12.3-12.3 V98.1c0-6.8-5.5-12.3-12.3-12.3h-109.5c-6.8,0-12.3,5.5-12.3,12.3s5.5,12.3,12.3,12.3h79.9L222.95,249 C218.15,253.8,218.15,261.5,222.95,266.3z\" data-original=\"#000000\" class=\"active-path\"></path></g></svg></span>");
$templateCache.put("app/components/directives/graphRelationships/graphRelationships.html","<div class=\"tf-nc p-0 nodePanel position-r\" ng-class=\"{\'root\': !$parent.$parent.nodeObj.children.length}\"><a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.nodeObj.children.length !== 1 }\"></a><div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.nodeObj.children.length !== 1, \'activeNode\': nodeObj.id === selectedId, \'opacity-5\': nodeObj.operation === \'DISABLED\'}\" ng-style=\"{ \'border-color\': !nodeObj.isDummyNode ? getHealthColor(nodeObj.health, nodeObj)[\'background-color\'] : \'\'}\"><div class=\"panel-heading p-10 d-flex align-items-center\" ng-style=\"!nodeObj.isDummyNode ? getHealthColor(nodeObj.health, nodeObj): {}\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"p-0 text-left d-flex align-items-center\" uib-tooltip=\"{{nodeObj.name}}\" tooltip-placement=\"auto\" ng-class=\"nodeObj.isDummyNode ? \'col-sm-12 text-center\':\'col-sm-11\'\"><label class=\"m-b-0\" ng-class=\"nodeObj.isDummyNode ? \'w100\':\'ellipsis\'\">{{nodeObj.name}}</label></div><div class=\"col-sm-1 p-0 text-right\" ng-if=\"!nodeObj.isDummyNode\"><div class=\"dropdown\" uib-dropdown=\"\"><i class=\"dropdown-toggle fa fa-bars\" ng-click=\"$event.stopPropagation();\" style=\"font-size: 20px;\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"></i><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"fnGetNodeInfo(nodeObj)\"><a class=\"btn btn-link border-0\">Detail</a></li><li ng-click=\"fnGetNodeTelemetryInfo(nodeObj)\"><a class=\"btn btn-link border-0\">Telemetry</a></li></ul></div></div></div></div><div class=\"panel-body p-10\" ng-if=\"!nodeObj.isDummyNode\" ng-style=\"{ \'border-color\': nodeObj.id === selectedId ? !nodeObj.isDummyNode ? getHealthColor(nodeObj.health, nodeObj)[\'background-color\'] : \'\' : \'\'}\"><div class=\"col-sm-12 p-0 text-left\"><div><span>{{nodeObj.description}}</span></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-t-10\"><div class=\"col-sm-6 p-0\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center justify-content-space-between\"><div class=\"d-flex\" uib-tooltip=\"{{nodeObj.connected ?\'Node Connection: Connected\' : \'Node Connection: Disconnected\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><div class=\"connectionLine\"></div><div class=\"d-flex\" uib-tooltip=\"{{nodeObj.ecuConnected ?\'ECU Connection: Connected\' : \'ECU Connection: Disconnected\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeObj.ecuConnected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><div class=\"connectionLine\"></div><div class=\"d-flex\" uib-tooltip=\"User Connection\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor isConnected\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/userConnection.svg#userConnection\"></use></svg></div></div></div></div><div class=\"col-sm-6 p-0\"><button class=\"btn btn-xs btn-default ellipsis-label w100 p-4\" style=\"text-align: center\" ng-style=\"getHealthColor(nodeObj.health, nodeObj)\"><span class=\"healtSpan\">{{nodeObj.healthName}}</span></button></div></div></div></div><div ng-if=\"nodeObj.id === selectedId\" class=\"currentNode d-flex align-items-center justify-content-center\" ng-class=\"{ \'currentNode_t_27\': $parent.$parent.nodeObj.children.length !== 1, \'currentNode_root\': !$parent.$parent.nodeObj.children.length}\"><span class=\"text-rotate\">Current</span></div></div><ul ng-if=\"nodeObj.children && nodeObj.children.length !== 0\"><li ng-repeat=\"childrenObj in nodeObj.children\" graph-relationships=\"\" selected-id=\"selectedId\" node-obj=\"childrenObj\" fn-get-node-detail=\"fnGetNodeInfo(nodeObj)\" fn-get-node-telemetry-detail=\"fnGetNodeTelemetryInfo(nodeObj)\"></li></ul>");
$templateCache.put("app/components/directives/heatMapChart/heatMapChart.html","<div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 aggregateHeatMapChartMainContainer\" ng-if=\"isAggregateHealth\" id=\"aggregateHeatMapChartMainContainer\"></div><div class=\"col-sm-12 p-0 atomicHeatMapChartMainContainer\" ng-if=\"!isAggregateHealth\" id=\"atomicHeatMapChartMainContainer\"></div></div>");
$templateCache.put("app/components/directives/horizontalBarChart/horizontalBarChart.html","<div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 horizontalBarChartMainContainer\" id=\"horizontalBarChartMainContainer\"></div></div>");
$templateCache.put("app/components/directives/insightDashboards/insightDashboards.html","<div class=\"col-sm-12 p-0 w100 insight-dashboards-preview h-100\"><div class=\"col-sm-12 p-0 d-flex h-100 justify-content-center align-items-center flex-column\" ng-if=\"!isDashboardIdSelected\"><span>You can assign a dashboard to your {{appKey}} dashboard. Each dashboard is a consisting of a user-defined query, chart and widgets.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"fnOpenDashboardListModal()\">Add dashboard</button></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"isDashboardIdSelected\"><div class=\"col-sm-12 d-flex align-items-center h-100 justify-content-center\" ng-if=\"!isDashboardDetailsLoaded\"><app-spinner class=\"p-20\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 d-flex justify-content-flex-end m-t-6\" ng-if=\"isDashboardDetailsLoaded\"><div class=\"d-flex align-items-center justify-content-center m-r-10\" uib-tooltip=\"Change Dashboard\" tooltip-placement=\"auto\"><svg width=\"20px\" height=\"20px\" ng-click=\"fnOpenDashboardListModal()\" class=\"custom-svg-side-menu-icon\"><use xlink:href=\"assets/images/svg/service/dashbord.svg#dashbord_1\"></use></svg></div><div class=\"d-flex m-r-10 border-1px\" style=\"border-left: 0 !important;\"></div><div class=\"d-flex align-items-center justify-content-center\" uib-tooltip=\"Refresh Dashboard\" tooltip-placement=\"auto\"><div class=\"d-flex align-items-center\"><i class=\"fa fa-refresh\" ng-click=\"fnReload();\" aria-hidden=\"true\"></i></div></div></div><div class=\"col-sm-12 p-0 m-t-5 d-flex overflow-auto insight-dashboards-preview-main-container\" ng-if=\"isDashboardDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"widgets.length\"><div gridstack=\"\" class=\"grid-stack\" options=\"options\"><div gridstack-item=\"\" ng-repeat=\"w in widgets track by $index\" class=\"grid-stack-item\" gs-item-x=\"w.x\" gs-item-y=\"w.y\" gs-item-width=\"w.width\" gs-item-height=\"w.height\" gs-item-autopos=\"1\"><div class=\"grid-stack-item-content\"><div class=\"col-sm-12 p-15 h-100 dashboard-panel dashboard-panel-chart-widget\" style=\"height: 100%\" ng-if=\"w.widget.chart.syntax === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!w.widget.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!w.widget.layout && !w.widget.layout.icon && !w.widget.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"w.widget.layout && w.widget.layout.icon && w.widget.layout.icon.length\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(w.widget.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{w.widget.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"w.widget.layout.isExport !== false\"><div class=\"dropdown no-hover customDropdown-icon\" dropdown-append-to-body=\"true\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in w.widget.layout.exportOptions\" ng-click=\"fnExportChart(exportOption.action, \'insightDashboardWidgets\'+w.widget.id)\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"w.widget.layout.isTrackerExport && permissionObj.CREATE_ISSUE\" ng-click=\"fnCreateIssue(w)\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 chart-height\" ng-class=\"w.widget.layout.buttonLink.length ? \'widget-with-button\':\'widget-without-button\'\" ng-if=\"w.widget.chart.query.results.data\"><dashboard-pie-chart ng-if=\"w.widget.chart.query.results.data.length\" is-for-csv-chart=\"true\" chart-id=\"\'insightDashboardWidgets\'+w.widget.id\" chart-data=\"w.widget.chart.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"!w.widget.chart.query.results.data.length\" style=\"opacity: 0.5\"><svg style=\"height: 70px;width: 70px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><div class=\"col-sm-12 p-0 dashboard-pie-chart-img chart-height\" ng-if=\"!w.widget.chart.query.results.data\"><svg class=\"p-t-40 p-b-40\" style=\"height: inherit;width: inherit;\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\" ng-if=\"w.widget.layout.buttonLink.length && w.widget.layout.buttonLink.length\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnGotoLink(w.widget.layout.buttonLink, w.widget.layout.target)\">{{w.widget.layout.buttonText}}</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/insightServiceDashboards/insightServiceDashboards.html","<div class=\"col-sm-12 p-0 w100 insight-dashboards-preview h-100 insight-service-dashboards\"><div class=\"col-sm-12 p-0 d-flex h-100 justify-content-center align-items-center flex-column\" ng-if=\"!isDashboardIdSelected\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><span>You can assign an insight dashboard here if you want. Dashboards for this specific space must contain a single row.</span></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnGetWidgetEditor()\">Add dashboard</button> <button class=\"btn btn-primary v4-primary-button m-l-20\" ng-click=\"fnHideWidget()\">Hide dashboard</button></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"isDashboardIdSelected\"><div class=\"col-sm-12 d-flex align-items-center h-100 justify-content-center\" ng-if=\"!isDashboardDetailsLoaded\"><app-spinner class=\"p-20\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex overflow-auto h-100\" ng-if=\"isDashboardDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"widgets.length\"><div gridstack=\"\" class=\"grid-stack\" style=\"height: 100%\" options=\"options\"><div gridstack-item=\"\" ng-repeat=\"w in widgets track by $index\" class=\"grid-stack-item\" gs-item-x=\"w.x\" gs-item-y=\"w.y\" gs-item-width=\"w.width\" gs-item-height=\"w.height\" gs-item-autopos=\"1\"><div class=\"grid-stack-item-content\"><div class=\"col-sm-12 p-10 h-100 dashboard-panel dashboard-panel-chart-widget\" style=\"height: 100%\" ng-if=\"w.widget.chart.syntax === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!w.widget.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!w.widget.layout && !w.widget.layout.icon && !w.widget.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"w.widget.layout && w.widget.layout.icon && w.widget.layout.icon.length\" ng-bind-html=\"deliberatelyTrustDangerousSnippet(w.widget.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{w.widget.layout.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" dropdown-append-to-body=\"true\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in w.widget.layout.exportOptions\" ng-click=\"fnExportChart(exportOption.action, \'insightDashboardWidgets\'+w.widget.id)\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"w.widget.layout.isTrackerExport && permissionObj.CREATE_ISSUE\" ng-click=\"fnCreateIssue(w)\"><a>Create Issue</a></li><li><a ng-click=\"fnGetWidgetEditor()\">Edit Widget</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 chart-height\" ng-class=\"w.widget.layout.buttonLink.length ? \'widget-with-button\':\'widget-without-button\'\" ng-if=\"w.widget.chart.query.results.data\"><dashboard-pie-chart ng-if=\"w.widget.chart.query.results.data.length\" is-for-csv-chart=\"true\" chart-id=\"\'insightDashboardWidgets\'+w.widget.id\" chart-data=\"w.widget.chart.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"!w.widget.chart.query.results.data.length\" style=\"opacity: 0.5\"><svg style=\"height: 70px;width: 70px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><div class=\"col-sm-12 p-0 dashboard-pie-chart-img chart-height\" ng-if=\"!w.widget.chart.query.results.data\"><svg class=\"p-t-40 p-b-40\" style=\"height: inherit;width: inherit;\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\" ng-if=\"w.widget.layout.buttonLink.length && w.widget.layout.buttonLink.length\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnGotoLink(w.widget.layout.buttonLink, w.widget.layout.target)\">{{w.widget.layout.buttonText}}</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/interactiveTreeview/treeview.html","<div class=\"col-sm-12 h-100 p-0\"><div id=\"inventoryD3Treeview\" class=\"h-100\"></div></div>");
$templateCache.put("app/components/directives/interactiveUserTreeview/userTreeview.html","<div class=\"col-sm-12 h-100 p-0\" ng-style=\"{\'visibility\' : isZoomPositionSet ? \'visible\' : \'hidden\'}\"><div id=\"inventoryD3UserTreeview\" class=\"h-100\"></div></div>");
$templateCache.put("app/components/directives/javascriptEditor/javascriptEditor.html","<div class=\"col-sm-12 p-0 h-100 w100 javascriptEditor\" ng-class=\"!readOnly ? \'pace\': \'\'\"><div style=\"position: relative\" id=\"demospace\"><form id=\"place\"></form></div><div style=\"display: none\" id=\"projects\"><project id=\"simple\" data-plugins=\"doc_comments complete_strings\" data-libs=\"common_S4 notifications_S4 tracker_S4 billing_S4\"><pre id=\"test\">\n\n                </pre></project></div></div>");
$templateCache.put("app/components/directives/lifecycleTimeline/lifecycleTimeline.html","<div id=\"lifecycleTimeline\" class=\"col-sm-12 m-t-20\"><div ng-class=\"$index === lifecycleStepsArr.length - 1 ? \'message-first\' : \'message-item\'\" ng-repeat=\"lifecycleStepObj in lifecycleStepsArr track by $index\" ng-click=\"fnGetLifecycleStep(lifecycleStepObj)\"><div class=\"message-inner\"><div class=\"message-head clearfix\"><div class=\"user-detail\"><div class=\"pull-left\"><h5 class=\"handle text-left\">{{lifecycleStepObj.task.replace(\'_\', \' \')}}</h5><div class=\"post-meta\"><div class=\"asker-meta\"><span class=\"qa-message-what\"></span> <span class=\"qa-message-when\"><span class=\"qa-message-when-data\"><small>{{lifecycleStepObj.stepId}}</small></span></span></div></div></div><div class=\"pull-right\"><div class=\"post-meta\"><div class=\"asker-meta\"><label class=\"m-b-0 pull-right\"><small>Completed {{lifecycleStepObj.humanDateLastUpdatedRelative}}</small></label><br><span class=\"text-right fa\" uib-tooltip=\"{{lifecycleStepObj.result}}\" tooltip-placement=\"top\" ng-class=\"fnGetResultIcon(lifecycleStepObj.result)\"></span></div></div></div></div></div><div class=\"qa-message-content\"><span class=\"parentSpan\"><span class=\"firstContent\"><small>{{lifecycleStepObj.message}}</small></span> <span class=\"secondContent\"><button class=\"btn btn-link p-0\">See Details <i class=\"fa fa-arrow-right\"></i></button></span></span></div></div></div></div>");
$templateCache.put("app/components/directives/ngQueryBuilder/ngQueryBuilder.temp.html","<div class=\"queryBuilder ngQueryBuilderTemplate\"><div class=\"alert alert-group\" ng-class=\"!$parent.queryBuilder?\'border-none\':\'\'\"><div class=\"group-conditions floatingLabelInput\"><div ng-repeat=\"rule in queryBuilder.rules | orderBy:\'index\'\" class=\"condition\"><div ng-switch=\"rule.hasOwnProperty(\'condition\')\"><div ng-switch-when=\"true\"><ng-query-builder query-builder=\"rule\" action-filters=\"actionFilters\" clusters-arr=\"clustersArr\"></ng-query-builder><div ng-hide=\"$index === queryBuilder.rules.length - 1\" class=\"form-inline\"><div class=\"col-sm-12 text-center\"><button class=\"ngQueryBuilder-ConditionBuilder\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\">{{queryBuilder.condition}}</button> <span class=\"conditionSelector\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\"><i class=\"fa fa-caret-down\"></i></span></div></div></div><div ng-switch-default=\"ng-switch-default\"><div class=\"form-inline\"><div class=\"row m-t-0\"><div class=\"col-sm-4 p-0\"><div class=\"md-input roleActions filtersArrTypeahead\" ng-class=\"rule.functionPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control p-r-37\" required=\"\" id=\"field\" type=\"text\" uib-typeahead=\"t.id as t.id for t in filtersArr | filter:$viewValue\" ng-init=\"fnOnSelectFilter(rule, rule.field, $index)\" typeahead-min-length=\"0\" typeahead-on-select=\"fnOnSelectFilter(rule, rule.field, $index)\" typeahead-template-url=\"{{isClusterIDExists ? \'ngQueryBuilderTemplate1.html\': \'ngQueryBuilderTemplate2.html\'}}\" ng-model=\"rule.field\" placeholder=\"Field\"> <span class=\"highlight\"></span> <label>Attribute</label> <small><span class=\"helper-text\" ng-if=\"rule.functionPatternMismatch\">Please make sure the value have a .notation path</span></small> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"fnInjectFunction()\"><span id=\"timeId\"><em>f<small>(x)</small></em></span></a></span><div class=\"ngQueryBuilderInputBorder\"></div><div class=\"ngQueryBuilderInputBorder-part\"></div></div></div><div class=\"col-sm-3 p-0\" ng-if=\"rule.field !== \'Cluster ID\'\"><div ng-if=\"rule.field && rule.field !== \'-\'\"><div class=\"md-input m-b-20 roleActions\" ng-init=\"ConditionFocus=false\"><span class=\"builderSpanDot\" ng-style=\"fnGetOperatorBackgroundColor(rule.operator)\"></span> <input class=\"md-form-control p-l-27\" required=\"\" id=\"{{\'Operator\'+$index}}\" type=\"text\" uib-typeahead=\"c for c in operators | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-editable=\"false\" typeahead-on-select=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\' : \'\'\" ng-change=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\' : \'\'\" ng-blur=\"ConditionFocus=false\" ng-model=\"rule.operator\" ng-focus=\"ConditionFocus=true\" ng-class=\"ConditionFocus === false ? \'ngQueryBuilder-inputContent removeLeftBorder\':\'\'\" placeholder=\"The target operator\"> <span class=\"highlight\"></span> <label>Condition</label> <small class=\"helper-text\"></small><div class=\"ngQueryBuilderInputBorder\"></div><div ng-if=\"ConditionFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div class=\"col-sm-3 p-0\" ng-if=\"rule.field === \'Cluster ID\'\"><div ng-if=\"rule.field && rule.field !== \'-\'\"><div class=\"md-input m-b-20 roleActions\" ng-init=\"ConditionFocus=false\"><span class=\"builderSpanDot\" ng-style=\"fnGetOperatorBackgroundColor(rule.operator)\"></span> <input class=\"md-form-control p-l-27\" required=\"\" id=\"{{\'Operator\'+$index}}\" type=\"text\" uib-typeahead=\"c for c in clusterOperators | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-editable=\"false\" typeahead-on-select=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\' : \'\'\" ng-change=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\' : \'\'\" ng-blur=\"ConditionFocus=false\" ng-model=\"rule.operator\" ng-focus=\"ConditionFocus=true\" ng-class=\"ConditionFocus === false ? \'ngQueryBuilder-inputContent removeLeftBorder\':\'\'\" placeholder=\"The target operator\"> <span class=\"highlight\"></span> <label>Condition</label> <small class=\"helper-text\"></small><div class=\"ngQueryBuilderInputBorder\"></div><div ng-if=\"ConditionFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div class=\"col-sm-4 p-0\" ng-if=\"rule.field !== \'Cluster ID\'\"><div ng-if=\"rule.field && rule.field !== \'-\' && (rule.field.includes(\'TimeOfDay\') || rule.field.includes(\'DayOfWeek\') || rule.field.includes(\'DayOfMonth\') || rule.field.includes(\'DayOfYear\'))\" ng-hide=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\'\"><div class=\"md-input m-b-20\" ng-if=\"rule.field && rule.field !== \'-\'\"><input class=\"md-form-control removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"fnAddValue(rule,rule.field,$index)\" placeholder=\"The target value\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small></div></div><div ng-if=\"rule.field && rule.field !== \'-\' && !(rule.field.includes(\'TimeOfDay\') || rule.field.includes(\'DayOfWeek\') || rule.field.includes(\'DayOfMonth\') || rule.field.includes(\'DayOfYear\'))\" ng-hide=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\'\"><div class=\"md-input m-b-20\" ng-if=\"rule.field && rule.field !== \'-\'\"><input class=\"md-form-control p-r-37\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"FilterFocus=true\" ng-blur=\"FilterFocus=false\" ng-class=\"FilterFocus === true ? \'\':\'removeLeftBorder\'\" placeholder=\"The target value\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"fnInjectValueFunction(rule)\"><span id=\"valueFunctionFx\"><em>f<small>(x)</small></em></span></a></span><div class=\"ngQueryBuilderInputBorder-part\"></div><div ng-if=\"FilterFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div class=\"col-sm-4 p-0\" ng-if=\"rule.field === \'Cluster ID\'\"><div ng-if=\"rule.field && rule.field !== \'-\' && clustersArr.length === 0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"FilterFocus=true\" ng-blur=\"FilterFocus=false\" ng-class=\"FilterFocus === true ? \'\':\'removeLeftBorder\'\" placeholder=\"The target value\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small><div ng-if=\"FilterFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div><div ng-if=\"rule.field && rule.field !== \'-\' && clustersArr.length !== 0\"><div class=\"clusterTypeahead md-input m-b-20 roleActions\" ng-if=\"clustersArr.length !==0\"><input class=\"md-form-control removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"FilterFocus=true\" ng-blur=\"FilterFocus=false\" ng-class=\"FilterFocus === true ? \'\':\'removeLeftBorder\'\" uib-typeahead=\"cluster.id as cluster.id for cluster in clustersArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-editable=\"false\" typeahead-template-url=\"clusterTemplate.html\" placeholder=\"The target value\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small><div ng-if=\"FilterFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div><div class=\"clusterTypeahead md-input m-b-20\" ng-if=\"clustersArr.length === 0\"><input class=\"md-form-control removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"FilterFocus=true\" ng-blur=\"FilterFocus=false\" ng-class=\"FilterFocus === true ? \'\':\'removeLeftBorder\'\" placeholder=\"The target value\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small><div ng-if=\"FilterFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div><div class=\"hiddenInputText\" ng-if=\"rule.field && rule.field !== \'-\'\"><input type=\"text\" ng-attr-id=\"{{rule.field.includes(\'TimeOfDay\')?\'TimeOfDay\'+ $index:rule.field.includes(\'DayOfWeek\')?\'DayOfWeek\'+ $index:rule.field.includes(\'DayOfMonth\')?\'DayOfMonth\'+ $index:rule.field.includes(\'DayOfYear\')?\'DayOfYear\'+$index:\'\'}}\"></div></div><div class=\"col-sm-1 m-t-10\"><button type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"fnRemoveRule($index)\"><i class=\"fa fa-times\"></i></button></div></div></div><div ng-hide=\"$index === queryBuilder.rules.length - 1\" class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-12 text-center\"><button class=\"ngQueryBuilder-ConditionBuilder\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\">{{queryBuilder.condition}}</button> <span class=\"conditionSelector\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\"><i class=\"fa fa-caret-down\"></i></span></div></div></div></div></div></div></div><div class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right p-r-7\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"fnAddRule()\">New Rule</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-click=\"fnAddGroup()\">Add group</a></li><li role=\"menuitem\"><a class=\"btn btn-link\" ng-click=\"fnRemoveGroup()\" ng-if=\"$parent.queryBuilder\">Delete group</a></li></ul></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"clusterTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <span class=\"ellipsis\" style=\"display: block\"> {{match.model.name}} </span> <span class=\"font-italic\" style=\"opacity: 0.5\"> <small> ({{match.model.id}}) </small> </span> </div> </a></script><script type=\"text/ng-template\" id=\"ngQueryBuilderTemplate1.html\"><a class=\"p-l-10 p-r-10\"> <div ng-if=\"match.model.id !== \'Cluster ID\' && (match.model.id.includes(\'device\') || match.model.id.includes(\'gateway\'))\" style=\"display: flex\"> <span class=\"ellipsis\" style=\"display: inline-block; width: 70%\"> {{match.model.id}} </span> <span class=\"font-italic\" style=\"display: inline-block;opacity: 0.5;float: right\"> <small> (Create Only) </small> </span> </div> <div ng-if=\"match.model.id === \'Cluster ID\' || (!match.model.id.includes(\'device\') && !match.model.id.includes(\'gateway\'))\" style=\"display: flex\"> <span class=\"ellipsis\" style=\"display: inline-block; width: 100%;\"> {{match.model.id}} </span> </div> </a></script><script type=\"text/ng-template\" id=\"ngQueryBuilderTemplate2.html\"><a class=\"p-l-10 p-r-10\"> <div style=\"display: flex\"> <span class=\"ellipsis\" style=\"display: inline-block; width: 100%;\"> {{match.model.id}} </span> </div> </a></script>");
$templateCache.put("app/components/directives/ngQueryBuilderNode/ngQueryBuilderNode.temp.html","<div class=\"queryBuilder ngQueryBuilderTemplate\"><div class=\"alert alert-group\" ng-class=\"!$parent.queryBuilder?\'border-none\':\'\'\"><div class=\"group-conditions floatingLabelInput\"><div ng-repeat=\"rule in queryBuilder.rules | orderBy:\'index\'\" class=\"condition\"><div ng-switch=\"rule.hasOwnProperty(\'condition\')\"><div ng-switch-when=\"true\"><ng-query-builder-node query-builder=\"rule\" action-filters=\"actionFilters\"></ng-query-builder-node><div ng-hide=\"$index === queryBuilder.rules.length - 1\" class=\"form-inline\"><div class=\"col-sm-12 text-center\"><button class=\"ngQueryBuilder-ConditionBuilder\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\">{{queryBuilder.condition}}</button> <span class=\"conditionSelector\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\"><i class=\"fa fa-caret-down\"></i></span></div></div></div><div ng-switch-default=\"ng-switch-default\"><div class=\"form-inline\"><div class=\"row m-t-15\"><div class=\"col-sm-4 p-0 p-l-10\"><div class=\"md-input roleActions\" ng-init=\"rule.field.startsWith(\'Matches(\') && rule.field.endsWith(\')\') ? fnSetFieldValue(rule, true):\'\'\" ng-class=\"rule.functionPatternMismatch || rule.functionGhostPatternMismatch || rule.functionGhostRequiredPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control p-r-37\" required=\"\" id=\"fieldMatches{{$index}}\" type=\"text\" uib-typeahead=\"t for t in filtersArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-show=\"!rule.isFocusOutDone\" ng-init=\"fnOnSelectFilter(rule, rule.field, $index)\" ng-change=\"fnCheckFilterValidation(rule, rule.field, $index,queryBuilder.condition)\" typeahead-on-select=\"fnOnSelectFilter(rule, rule.field, $index, queryBuilder.condition)\" ng-blur=\"rule.field.startsWith(\'Matches(\') && rule.field.endsWith(\')\') ? fnSetFieldValue(rule, true) :\'\'\" ng-model=\"rule.field\" placeholder=\"Attribute\"> <input class=\"md-form-control p-l-50 p-r-37\" required=\"\" ng-show=\"rule.isFocusOutDone\" type=\"text\" ng-focus=\"rule.isFocusOutDone = false;fnSetFocus(\'fieldMatches\'+$index)\" ng-model=\"rule.test\" placeholder=\"Attribute\"> <span class=\"highlight\"></span> <label>Attribute</label> <span ng-if=\"rule.isFocusOutDone\" class=\"d-flex justify-content-center align-items-center\" style=\"position: absolute;top: 12px;left: 10px;\">(.*)<i class=\"fa fa-long-arrow-right m-l-3\"></i></span> <small class=\"helper-text-error\"><span class=\"errorText\" ng-if=\"rule.functionPatternMismatch\">Please make sure the value have a .notation path</span> <span class=\"errorText\" ng-if=\"rule.functionGhostPatternMismatch\">Value must not start with ghost references or functions.</span> <span class=\"errorText\" ng-if=\"rule.functionGhostRequiredPatternMismatch\">Value must starts with ghost references, functions or equal to first rule attribute.</span></small> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"fnInjectFunction($index,queryBuilder.condition)\"><span id=\"timeId\"><em>f<small>(x)</small></em></span></a></span><div class=\"ngQueryBuilderInputBorder\"></div><div class=\"ngQueryBuilderInputBorder-part\"></div><span class=\"ngQueryBuilderFocalIcon\" ng-if=\"queryBuilder.condition === \'AND\' && $index === 0 && !rule.functionGhostPatternMismatch\"><i class=\"fa fa-star\"></i></span></div></div><div class=\"col-sm-3 p-0\"><div ng-if=\"rule.field && rule.field !== \'-\'\"><div class=\"md-input m-b-20\" ng-init=\"ConditionFocus=false\"><span class=\"builderSpanDot\" ng-style=\"fnGetOperatorBackgroundColor(rule.operator)\"></span> <input class=\"md-form-control p-l-27\" required=\"\" id=\"{{\'Operator\'+$index}}\" type=\"text\" uib-typeahead=\"c for c in operators | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-editable=\"false\" typeahead-on-select=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\': \'\';editingInputCondition = false\" ng-change=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\' ? rule.value = \'\' : \'\'\" ng-blur=\"ConditionFocus=false\" ng-focus=\"ConditionFocus=true\" ng-class=\"ConditionFocus === false ? \'ngQueryBuilder-inputContent removeLeftBorder\':\'\'\" ng-model=\"rule.operator\" placeholder=\"The target operator\"> <span class=\"highlight\"></span> <label>Condition</label> <small class=\"helper-text\"></small><div class=\"ngQueryBuilderInputBorder\"></div><div ng-if=\"ConditionFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div class=\"col-sm-4 p-0\"><div ng-hide=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\'\" ng-if=\"rule.field && rule.field !== \'-\' && (rule.field.includes(\'TimeOfDay\') || rule.field.includes(\'DayOfWeek\') || rule.field.includes(\'DayOfMonth\') || rule.field.includes(\'DayOfYear\'))\"><div class=\"md-input m-b-20\" ng-if=\"rule.field && rule.field !== \'-\'\"><input class=\"md-form-control removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"fnAddValue(rule,rule.field,$index)\" placeholder=\"The target filter\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small></div></div><div ng-hide=\"rule.operator === \'is present\' || rule.operator === \'is not present\' || rule.operator === \'is empty\' || rule.operator === \'is not empty\'\" ng-if=\"rule.field && rule.field !== \'-\' && !(rule.field.includes(\'TimeOfDay\') || rule.field.includes(\'DayOfWeek\') || rule.field.includes(\'DayOfMonth\') || rule.field.includes(\'DayOfYear\'))\"><div class=\"md-input m-b-20\" ng-if=\"rule.field && rule.field !== \'-\'\"><input class=\"md-form-control p-r-37 removeLeftBorder\" required=\"\" type=\"text\" ng-model=\"rule.value\" ng-focus=\"FilterFocus=true\" ng-blur=\"FilterFocus=false\" ng-class=\"FilterFocus === true ? \'\':\'removeLeftBorder\'\" placeholder=\"The target filter\"> <span class=\"highlight\"></span> <label>Filter</label> <small class=\"helper-text\"></small> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"fnInjectValueFunction(rule)\"><span id=\"valueFunctionFx\"><em>f<small>(x)</small></em></span></a></span><div class=\"ngQueryBuilderInputBorder-part\"></div><div ng-if=\"FilterFocus\" class=\"ngQueryBuilderInputBorderLeft\"></div></div></div></div><div><div class=\"hiddenInputText\" ng-if=\"rule.field && rule.field !== \'-\'\"><input type=\"text\" ng-attr-id=\"{{rule.field.includes(\'TimeOfDay\')?\'TimeOfDay\'+ $index:rule.field.includes(\'DayOfWeek\')?\'DayOfWeek\'+ $index:rule.field.includes(\'DayOfMonth\')?\'DayOfMonth\'+ $index:rule.field.includes(\'DayOfYear\')?\'DayOfYear\'+$index:\'\'}}\"></div></div><div class=\"col-sm-1 m-t-10\"><button ng-if=\"!($index === 0 && queryBuilder.condition === \'AND\')\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"fnRemoveRule($index)\"><i class=\"fa fa-times\"></i></button></div></div></div><div ng-hide=\"$index === queryBuilder.rules.length - 1\" class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-12 text-center\"><button class=\"ngQueryBuilder-ConditionBuilder\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\">{{queryBuilder.condition}}</button> <span class=\"conditionSelector\" ng-click=\"queryBuilder.condition = queryBuilder.condition===\'OR\' ? \'AND\' :\'OR\'\"><i class=\"fa fa-caret-down\"></i></span></div></div></div></div></div></div></div><div class=\"form-inline\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right p-r-7\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"fnAddRule()\">New Rule</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-click=\"fnAddGroup()\">Add group</a></li><li role=\"menuitem\"><a class=\"btn btn-link\" ng-click=\"fnRemoveGroup()\" ng-if=\"$parent.queryBuilder\">Delete group</a></li></ul></div></div></div></div></div></div></div>");
$templateCache.put("app/components/directives/nodeSearchDirectiveV4/searchTemplateV4.html","<div class=\"search-panel-v4 floatingLabelInput\"><div class=\"row\"><div class=\"col-sm-12 d-flex p-r-10\"><div class=\"m-b-0 search-container\"><div class=\"d-flex\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"w100 search-container-scroll\"><ul class=\"m-b-0 d-flex search-main-ul\"><li class=\"m-0\" ng-class=\"{\'m-l-3\': !$first}\" ng-repeat=\"tag in tagsArr track by tag.id\"><div class=\"d-flex dropPos\"><div class=\"conditionToggle m-r-3\" ng-if=\"tag.selectedConnector\" ng-click=\"fnChangeConditionToggle(tag)\"><button class=\"btn btn-default btn-xs p-3\"><i ng-if=\"tag.selectedConnector === \'or\'\" class=\"fa fa-toggle-off\"></i> <i ng-if=\"tag.selectedConnector !== \'or\'\" class=\"fa fa-toggle-on\"></i> {{tag.selectedConnector === \"or\" ?\"OR\":\"AND\"}}</button></div><div class=\"tag-name\"><button class=\"btn btn-default btn-xs p-3\">{{tag.name.split(\' \')[0]}}</button></div><div class=\"remove-tag\"><button class=\"btn btn-primary btn-xs m-l-3 p-3\">{{tag.searchText}}<i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveTags($index)\"></i></button></div></div><div class=\"conditionToggle p-l-3\" ng-if=\"$last && selectedValue\" ng-click=\"fnChangeSelectedConnector();\"><button class=\"btn btn-default btn-xs p-3\"><i ng-if=\"selectedConnector === \'or\'\" class=\"fa fa-toggle-off\"></i> <i ng-if=\"selectedConnector !== \'or\'\" class=\"fa fa-toggle-on\"></i> {{selectedConnector === \"or\" ?\"OR\":\"AND\"}}</button></div></li><li ng-if=\"selectedValue || optionTitle\" class=\"m-0 m-l-3\"><div class=\"d-flex dropPos\"><div ng-if=\"selectedValue\" class=\"tag-name d-flex\"><button class=\"btn btn-default btn-xs p-3\">{{selectedValue}} <span ng-click=\"fnRemoveSelectedFilterOption()\" uib-tooltip=\"Remove Filter\" tooltip-placement=\"auto\"><i class=\"fa fa-trash-o m-l-2 m-r-3\"></i></span></button></div><div ng-if=\"optionTitle\" class=\"remove-tag\"><button class=\"btn btn-primary btn-xs m-l-3 p-3\">{{optionTitle}}<i class=\"fa fa-times m-l-5\"></i></button></div></div></li><li class=\"input-token m-0 inherit-width\" ng-class=\"tagsArr.length || selectedValue ? \'m-l-3\':\'\'\"><form class=\"inherit-width\" id=\"searchForm\" role=\"form\" name=\"searchForm\"><div class=\"md-input m-b-0 input-field inherit-width\"><input id=\"search-main-input\" type=\"text\" name=\"inputsearch\" class=\"md-form-control inputField p-l-2 search-main-input\" ng-focus=\"fnSearchInputFocus($event)\" ng-blur=\"fnSearchInputBlur($event)\" required=\"\" ng-change=\"fnOnChange(searchText)\" ng-pattern=\"pattern\" ng-keyup=\"$event.keyCode === 13 && fnCreateSearchTags(searchText,true)\" placeholder=\"Search\" ng-model=\"searchText\"></div></form></li></ul></div><div class=\"width-50px m-l-2\" ng-if=\"isSearchResultLoaded\"><span class=\"loader-position\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></span></div><div ng-class=\"{\'width-60px\': tagsArr.length || sortString.length,\'width-35px\': !sortString.length && tagsArr.length,\'width-1px\':!sortString.length && !tagsArr.length }\" ng-if=\"!isSearchResultLoaded\"><div class=\"pull-left\" ng-if=\"tagsArr.length || sortString.length\"><div class=\"position-relative\"><span class=\"clear-icon\" ng-click=\"fnClearSearch()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-right p-t-10 p-b-10 p-l-5 p-r-8\" ng-if=\"sortString.length\" ng-click=\"fnChangeSortDirection()\"><span><i class=\"fa\" ng-class=\"selectedSortOperator === \'asc\' ? \'fa-sort-amount-asc\' :\'fa-sort-amount-desc\'\"></i></span></div></div></div></div></div></div><div ng-if=\"!subMenuOptions.subMenu\" class=\"dropdown drpdwn m-t-10\"><ul class=\"dropdown-menu v4-sort-dropdown-menu\" style=\"min-width: 290px;\" ng-class=\"{\'hideMainMenu\': selectedValue == \'Gateway\' || selectedValue == \'OEM\' || selectedValue == \'Model\' || selectedValue == \'Phase\'}\"><li ng-if=\"isFilterOptionView\"><a ng-mousedown=\"$event.stopPropagation();$event.preventDefault();\" style=\"text-align: right\"><button class=\"btn btn-link p-0 p-t-2\" ng-mousedown=\"fnOptionalFilters($event, true)\">Back</button></a></li><li class=\"divider\" ng-if=\"isFilterOptionView\" style=\"height: 2px;\"></li><li class=\"pace\" ng-show=\"!isFilterOptionView\"><a><small class=\"font-italic opacity-5\">Type to search or use a quick filter</small></a></li><li class=\"divider\" ng-show=\"!isFilterOptionView\" style=\"height: 2px;\"></li><li ng-if=\"!isFilterOptionView\" ng-repeat=\"deviceFilter in deviceFilters | filter:searchText track by $index\" ng-mousedown=\"setFilterValue(deviceFilter)\"><a><span>{{deviceFilter.title}}</span> <span style=\"display: inline-block;font-size: 11px;\" class=\"pull-right pull-right font-italic\" ng-if=\"$index === 0\">Quick filter</span></a></li><li ng-if=\"isFilterOptionView\" role=\"menuitem\" ng-repeat=\"action in sortFieldArr\"><a class=\"p-l-25\" ng-mousedown=\"fnChangeStateField(action)\">{{action.displayName}} <span style=\"position: absolute;left: 7px;\" ng-if=\"selectedStateFieldObj.name === action.name\"><i class=\"fa fa-check\"></i></span></a></li><li class=\"divider\" ng-show=\"!isFilterOptionView\" style=\"height: 2px;\"></li><li ng-show=\"!isFilterOptionView\"><a ng-mousedown=\"$event.stopPropagation();$event.preventDefault();\"><span>Sort by{{!selectedStateFieldObj.displayName ?\' ...\':\": \"+selectedStateFieldObj.displayName}}</span> <button class=\"btn btn-link pull-right p-0 p-t-2\" ng-mousedown=\"fnOptionalFilters($event)\">{{!selectedStateFieldObj.displayName ?\'Select\':\'Change\'}} Filter</button></a></li></ul></div><div ng-if=\"subMenuOptions.subMenu\" class=\"dropdown drpdwn m-t-10\"><ul class=\"dropdown-menu sub-menu\"><li ng-repeat=\"subMenu in subMenuOptions.subMenu | filter:searchText\" ng-mousedown=\"setFilterOptionsValue(subMenu)\"><a>{{subMenu.title}}</a></li></ul></div><div ng-if=\"selectedValue === \'Gateway\'\" class=\"dropdown searchable-dropdown\"><ul class=\"dropdown-menu dropdown-menu-min-width\"><li><div class=\"md-input m-0 m-t-8 m-l-4 m-r-4\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search Gateway\" ng-model=\"search[filter]\" ng-focus=\"fnFocusSearchableDropdown($event)\" ng-blur=\"fnBlurSearchableDropdown($event)\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li ng-repeat=\"gatewayObj in gatewayArr=(gatewaysArr | filter:search) | limitTo:10 track by $index\" ng-mousedown=\"setFilterOptionsValue(gatewayObj)\"><a><span style=\"display: block;\">{{gatewayObj.name}}</span> <span class=\"font-italic gateway-id-menu-option\">({{gatewayObj.id}})</span></a></li><li ng-if=\"!gatewayArr.length\"><a>No matching results</a></li></ul></div><div ng-if=\"selectedValue === \'OEM\'\" class=\"dropdown searchable-dropdown\"><ul class=\"dropdown-menu dropdown-menu-min-width\"><li><div class=\"md-input m-0 m-t-8 m-l-4 m-r-4\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search OEM\" ng-model=\"search[filter]\" ng-focus=\"fnFocusSearchableDropdown($event)\" ng-blur=\"fnBlurSearchableDropdown($event)\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li ng-repeat=\"typeObj in oemArr=(typesArr | filter:search) | unique: \'oem\' | limitTo:10 track by $index\" ng-mousedown=\"setFilterOptionsValue(typeObj)\"><a>{{typeObj.oem}}</a></li><li ng-if=\"!oemArr.length\"><a>No matching results</a></li></ul></div><div ng-if=\"selectedValue === \'Model\'\" class=\"dropdown searchable-dropdown\"><ul class=\"dropdown-menu dropdown-menu-min-width\"><li><div class=\"md-input m-0 m-t-8 m-l-4 m-r-4\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search Model\" ng-model=\"search[filter]\" ng-focus=\"fnFocusSearchableDropdown($event)\" ng-blur=\"fnBlurSearchableDropdown($event)\"> <label>Search</label></div></li><li class=\"divider\"></li><li ng-repeat=\"typeObj in modelArr=(typesArr | filter:search) |unique: \'model\' | limitTo:10 track by $index\" ng-mousedown=\"setFilterOptionsValue(typeObj)\"><a>{{typeObj.model}}</a></li><li ng-if=\"!modelArr.length\"><a>No matching results</a></li></ul></div><div ng-if=\"selectedValue === \'Phase\'\" class=\"dropdown drpdwn m-t-10\"><ul class=\"dropdown-menu\"><li ng-repeat=\"phaseArr in phaseArr | filter:searchText track by $index\" ng-mousedown=\"setFilterOptionsValue(phaseArr)\"><a>{{phaseArr.title}}</a></li></ul></div></div><div class=\"col-sm-12 p-0 selected-filter-info-msg floatingLabelInput\"><small class=\"helper-text-error m-t-0 position-relative\" ng-show=\"searchForm.inputsearch.$error.pattern && searchForm.inputsearch.$dirty\"><span class=\"errorText p-0\">{{errorMsg}}</span></small></div>");
$templateCache.put("app/components/directives/pieChart/pieChart.html","<div class=\"col-sm-12 p-0 h-100 w100 HighChartPie\"><div class=\"{{chartClass}} col-sm-12 p-0 h-100 w100\" id=\"{{chartClass}}\"></div></div>");
$templateCache.put("app/components/directives/projectRelationships/projectRelationships.html","<div class=\"tf-nc p-0 projectPanel\" ng-class=\"{\'root\': !$parent.$parent.projectObj}\"><a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.projectObj.children.length !== 1 }\"></a><div class=\"panel panel-default m-b-0\" ng-class=\"{ \'m-t-27\': $parent.$parent.projectObj.children.length !== 1}\"><div class=\"panel-heading p-10 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-11 p-0 text-left d-flex align-items-center\"><label class=\"ellipsis m-b-0\">{{projectObj.name}}</label></div><div class=\"col-sm-1 p-0 text-right\"><div class=\"dropdown\" uib-dropdown=\"\"><i class=\"dropdown-toggle fa fa-bars\" ng-click=\"$event.stopPropagation();\" style=\"font-size: 20px;\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"></i><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"fnGetProjectInfo(projectObj)\"><a class=\"btn btn-link\">Detail</a></li></ul></div></div></div></div><div class=\"panel-body p-10\"><div class=\"col-sm-12 text-left\"><div><span>{{projectObj.description}}</span></div></div></div></div></div><ul ng-if=\"projectObj.children && projectObj.children.length !== 0\"><li ng-repeat=\"childrenObj in projectObj.children\" project-relationships=\"\" project-obj=\"childrenObj\" fn-get-project-detail=\"fnGetProjectInfo(projectObj)\"></li></ul>");
$templateCache.put("app/components/directives/radialProgressBar/radialProgressBar.html","<div class=\"redialProgressBar\"><div id=\"{{chartId}}\" class=\"center position-r\"><svg class=\"progress noselect\" data-progress=\"15.20\" x=\"0px\" y=\"0px\" viewbox=\"0 0 80 80\"><path class=\"track\" d=\"M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0\"></path><path class=\"fill\" d=\"M5,40a35,35 0 1,0 70,0a35,35 0 1,0 -70,0\"></path></svg><div uib-tooltip-html=\"tooltipContent\" tooltip-placement=\"auto\" class=\"tooltipPosition\"></div></div></div>");
$templateCache.put("app/components/directives/schemaDirective/schemaTemplate.html","<div ng-if=\"!isVaultLoaded\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"floatingLabelInput connectFieldTemplate\" ng-repeat=\"typePropertyObj in connectedFieldTypeArr track by $index\" ng-if=\"isVaultLoaded\"><div class=\"p-0 md-input\" id=\"ipField\" ng-init=\"ipFieldFocus=false\" ng-if=\"typePropertyObj.type === \'String\'\" ng-class=\"typePropertyObj.isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"text\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"fnValidate(typePropertyObj)\" ng-blur=\"ipFieldFocus=false\" ng-focus=\"typeArrName.includes(\'https\') ? ipFieldFocus=true : ipFieldFocus=false\" ng-class=\"! typeArrName.includes(\'https\') ? \'\' : ipFieldFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label><div ng-class=\"typeArrName.includes(\'ip\') && typeArrName.includes(\'port\') ? \'connectFieldRightArrowBorder\':\'\'\"></div><div ng-if=\"ipFieldFocus\" ng-class=\"typeArrName.includes(\'ip\') && typeArrName.includes(\'https\') ? \'connectFieldLeftArrowBorder\':\'\'\"></div></div><div id=\"portField\" class=\"p-0 md-input\" ng-init=\"portFieldFocus=false\" ng-if=\"typePropertyObj.type === \'Number\'\" ng-class=\"typePropertyObj.isMinError||typePropertyObj.isMaxError ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control portFieldSpinner\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"number\" step=\"any\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"fnValidate(typePropertyObj)\" ng-blur=\"portFieldFocus=false\" ng-focus=\"! typeArrName.includes(\'ip\') ? portFieldFocus=false : portFieldFocus=true\" ng-class=\"! typeArrName.includes(\'ip\') ? \'\' : portFieldFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label><div ng-if=\"portFieldFocus\" ng-class=\"typeArrName.includes(\'ip\') && typeArrName.includes(\'port\') ? \'connectFieldLeftArrowBorder\':\'\'\"></div></div><div ng-if=\"typePropertyObj.type === \'Boolean\'\" class=\"p-0\" id=\"httpsField\"><div class=\"md-input p-0 m-b-20\"><div class=\"md-form-control schema-switch-block p-l-10 p-b-8 p-t-12\"><switch ng-attr-id=\"{{typePropertyObj.name+$index}}\" ng-change=\"fnValidate(typePropertyObj)\" ng-model=\"typePropertyObj.typeValue\"></switch></div><span class=\"highlight\"></span> <label class=\"observe-focusSwitch\" ng-bind=\"fnSetFiledLabel(typePropertyObj.name)\"></label> <small class=\"helper-text\"></small><div ng-class=\"typeArrName.includes(\'https\') && typeArrName.includes(\'ip\') ? \'connectFieldRightArrowBorder\' : \'\'\"></div></div></div><div class=\"md-input m-b-0\" ng-if=\"typePropertyObj.isPatternMismatch || typePropertyObj.isMaxError || typePropertyObj.isMinError\"><small class=\"helper-text-error connectedErrorMsg\" ng-show=\"typePropertyObj.isPatternMismatch\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small> <small class=\"helper-text-error connectedErrorMsg\" ng-show=\"typePropertyObj.isMaxError\"><span class=\"errorText\">The value should be less than {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error connectedErrorMsg\" ng-show=\"typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small></div></div><div class=\"floatingLabelInput connectFieldTemplate\" ng-repeat=\"typePropertyObj in valueFieldTypeArr track by $index\" ng-if=\"isVaultLoaded\"><div class=\"md-input col-sm-12 p-0\" ng-if=\"typePropertyObj.type === \'String\' && typePropertyObj.name !== \'vaultId\'\" ng-class=\"typePropertyObj.isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"text\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"fnValidate(typePropertyObj)\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isPatternMismatch\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div ng-if=\"isVaultRefreshing && typePropertyObj.type === \'String\' && (typePropertyObj.name === \'vaultId\' && vaultArr.length && permissionObj.List)\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"m-b-20\" ng-if=\"!isVaultRefreshing && typePropertyObj.type === \'String\' && typePropertyObj.name === \'vaultId\'\"><div class=\"col-sm-12 p-0\"><div class=\"p-0\" ng-class=\"permissionObj.List ? \'col-sm-7\' : \'col-sm-12\'\"><div class=\"md-input roleActions\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"text\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"fnValidate(typePropertyObj)\" placeholder=\"Vault*\"> <span class=\"highlight\"></span> <label>Vault</label> <small class=\"helper-text\" ng-show=\"typePropertyObj.isPatternMismatch\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small> <span class=\"helper-text m-t-10\" ng-show=\"!typePropertyObj.isPatternMismatch\"><strong ng-show=\"selectedVaultName\">Selected Vault: {{selectedVaultName}}</strong></span><div ng-if=\"permissionObj.List\" class=\"connectFieldRightArrowBorder\"></div></div></div><div ng-if=\"permissionObj.List\" class=\"col-sm-2 p-0\"><div class=\"md-input m-b-20\"><div class=\"md-form-control removeLeftBorder p-0 text-center\"><span><a href=\"javascript:void(0);\" class=\"btn btn-link p-9\"><small ng-click=\"fnOpenVaultsModal(typePropertyObj)\">Search Vaults</small></a></span><div class=\"connectFieldRightArrowBorder\"></div></div></div></div><div ng-if=\"permissionObj.Create\" class=\"col-sm-2 p-0 schemaTemplateCreateVault\"><div class=\"md-input m-b-20\"><div class=\"md-form-control removeLeftBorder p-0 text-center\"><span id=\"vaultLabelWithTooltip\"><a ui-sref=\"main.vaults({openCreateView: true})\" href=\"javascript:void(0)\" class=\"btn btn-link p-9 ellipsis\" uib-tooltip=\"Create new Vault\" tooltip-placement=\"auto\"><small>Create new Vault</small></a></span> <span id=\"vaultLabelWithOutTooltip\"><a ui-sref=\"main.vaults({openCreateView: true})\" href=\"javascript:void(0)\" class=\"btn btn-link p-9 ellipsis\"><small>Create new Vault</small></a></span><div class=\"connectFieldRightArrowBorder\"></div></div></div></div><div ng-if=\"permissionObj.List\" class=\"col-sm-1 p-0\"><div class=\"md-input roleActions\"><div class=\"md-form-control removeLeftBorder p-0 text-center\"><span><a href=\"javascript:void(0);\" class=\"btn btn-link p-9\" ng-click=\"fnRefreshVaultOptions()\"><small><i class=\"fa fa-refresh\"></i></small></a></span></div></div></div></div></div><div class=\"col-sm-12 p-0 md-input\" ng-if=\"typePropertyObj.type === \'Number\'\" ng-class=\"typePropertyObj.isMinError||typePropertyObj.isMaxError ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" type=\"number\" step=\"any\" ng-model=\"typePropertyObj.typeValue\" ng-change=\"fnValidate(typePropertyObj)\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError\"><span class=\"errorText\">The value should be less than {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small></div><div ng-if=\"typePropertyObj.type === \'Boolean\'\" class=\"col-sm-3 p-0\"><div class=\"md-input p-0\"><div class=\"md-form-control schema-switch-block p-l-10 p-b-8 p-t-12\" ng-init=\"fnValidate(typePropertyObj)\"><switch ng-attr-id=\"{{typePropertyObj.name+$index}}\" ng-change=\"fnValidate(typePropertyObj)\" ng-model=\"typePropertyObj.typeValue\"></switch></div><span class=\"highlight\"></span> <label class=\"observe-focusSwitch\" ng-bind=\"fnSetFiledLabel(typePropertyObj.name)\"></label> <small class=\"helper-text\"></small></div></div><div class=\"m-b-0\" ng-if=\"typePropertyObj.type === \'Array\'\"><div class=\"col-sm-12 md-input m-b-10 p-0\" ng-if=\"typePropertyObj.item === \'Number\'\" ng-class=\"typePropertyObj.arrValue || typePropertyObj.isMaxError || typePropertyObj.isPatternMismatch || typePropertyObj.isMinError?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" required=\"\" type=\"number\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label> <small><span class=\"helper-text\" ng-if=\"typePropertyObj.arrValue && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div class=\"col-sm-12 md-input p-0\" ng-if=\"typePropertyObj.item === \'String\' || typePropertyObj.item === \'\'\" ng-class=\"typePropertyObj.arrValue.length || typePropertyObj.isMaxError || typePropertyObj.isPatternMismatch || typePropertyObj.isMinError?\'m-b-30\':\'m-b-30\'\"><input class=\"md-form-control\" ng-attr-id=\"{{typePropertyObj.name+$index}}\" required=\"\" type=\"text\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label> <small class=\"helper-text\"><span ng-if=\"typePropertyObj.arrValue.length && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div><div ng-if=\"typePropertyObj.item === \'Boolean\'\"><div class=\"col-sm-12 md-input m-b-10 p-0\"><input class=\"md-form-control\" required=\"\" id=\"actions\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"value for value in booleanOptionArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"typePropertyObj.arrValue\" ng-change=\"fnArrayValidation(typePropertyObj,typePropertyObj.arrValue)\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && fnCreateArrayTag(typePropertyObj.arrValue,typePropertyObj.name+$index,typePropertyObj)\" placeholder=\"{{fnSetFiledLabel(typePropertyObj.name)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(typePropertyObj.name)}}*</label> <small class=\"helper-text\"><span ng-if=\"typePropertyObj.arrValue.length && !typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\">Press enter to add your {{typePropertyObj.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && typePropertyObj.isMinError\"><span class=\"errorText\">The value should be greater than {{typePropertyObj.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && !typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value should be less than or equal to {{typePropertyObj.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"typePropertyObj.isMaxError && typePropertyObj.isPatternMismatch && !typePropertyObj.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{typePropertyObj.regex}}.</span></small></div></div><button class=\"btn btn-sm btn-default m-t-15 m-r-5\" ng-repeat=\"selectedArr in typePropertyObj.typeValue track by $index\"><span>{{selectedArr}}<i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveSelectedArrayTag(typePropertyObj,$index)\"></i></span></button></div></div>");
$templateCache.put("app/components/directives/searchDirective/searchTemplate.html","<div class=\"search-panel\"><div class=\"row\"><div ng-class=\"isFilterOptionsVisible ? \'col-sm-6\' : \'col-sm-12\'\"><div class=\"md-input\"><input type=\"text\" ng-focus=\"fnFocus($event)\" ng-blur=\"fnBlur($event)\" required=\"\" class=\"md-form-control\" ng-keyup=\"$event.keyCode === 13 && fnCreateSearchTags(selectedField, selectedFilter, searchText, selectedConnector.toLowerCase())\" ng-model=\"searchText\"> <span class=\"highlight\"></span><label>Search</label></div></div><div class=\"col-sm-6\" ng-if=\"isFilterOptionsVisible\"><div class=\"btn-group pull-right\" uib-dropdown=\"\"><button id=\"operatorOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedFilter.operator}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"operatorOptions\"><li ng-repeat=\"filter in filterOptions\" role=\"menuitem\" ng-click=\"fnSelectFilters(filter)\"><a>{{filter.operator}}</a></li></ul></div><div class=\"btn-group pull-right p-r-5\" uib-dropdown=\"\"><button id=\"fieldOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedField}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"fieldOptions\"><li ng-repeat=\"field in fieldArr\" role=\"menuitem\" ng-click=\"fnSelectFields(field.fieldName)\"><a>{{field.fieldDisplayName}}</a></li></ul></div><div ng-if=\"isConnectorVisible\" class=\"btn-group pull-right p-r-5\" uib-dropdown=\"\"><button id=\"connectorOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedConnector}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"connectorOptions\"><li role=\"menuitem\" ng-click=\"fnChangeSelectedConnector(\'AND\')\"><a>AND</a></li><li role=\"menuitem\" ng-click=\"fnChangeSelectedConnector(\'OR\')\"><a>OR</a></li></ul></div></div></div><span class=\"bar\"></span></div><div class=\"search-tag-container\" ng-class=\"{\'m-t-13\': tagsArr.length ===0 ,\'m-t-10 m-b-5\' : tagsArr && tagsArr.length !==0}\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-repeat=\"tag in tagsArr track by tag.id\">{{tag.name}}<i ng-click=\"fnRemoveTags($index)\" class=\"fa fa-times m-l-5\"></i></button></div>");
$templateCache.put("app/components/directives/serviceStatsPieChart/serviceStatsPieChart.html","<div class=\"col-sm-12 p-0 h-100 w100 HighChartPie\" ng-if=\"!showEmptyChart\"><div class=\"{{chartClass}} col-sm-12 p-0 h-100 w100\" id=\"{{chartClass}}\"></div></div><div class=\"col-sm-12 p-0 h-100 w100 HighChartPie\" ng-if=\"showEmptyChart\"><div class=\"h-100 d-flex flex-column justify-content-center align-items-center\" style=\"opacity: 0.5\"><svg class=\"dashboard-img-not-found\" style=\"height: 60px;width: 60px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div>");
$templateCache.put("app/components/directives/sparkLineChart/sparkLineChart.html","<div class=\"col-sm-12 p-0 h-100 w100 sparkLine\"><div class=\"{{chartClass}}\" id=\"{{chartClass}}\"></div></div>");
$templateCache.put("app/components/directives/spinnerDirective/spinnerDirective.html","<div ng-class=\"spinnerType\"><div class=\"spinnerContainer\"><div class=\"circular-container\"><div class=\"loaderText\" ng-if=\"spinnerType === \'pageSpinnerWithText\'\">{{spinnerText}}</div><div class=\"circle circular-loader1\"><div class=\"circle circular-loader2\"></div></div></div></div></div>");
$templateCache.put("app/components/directives/storageSearchDirective/searchTemplate.html","<div class=\"search-panel\" ng-class=\"tagsArr.length >= 1 ? \'pace\' : \'\'\"><div class=\"row\"><div ng-class=\"isFilterOptionsVisible ? \'col-sm-9\' : \'col-sm-12\'\"><div class=\"md-input\"><input type=\"text\" id=\"storageSearchTextbox\" ng-focus=\"fnFocus($event)\" ng-blur=\"fnBlur($event)\" required=\"\" class=\"md-form-control\" ng-keyup=\"$event.keyCode === 13 && fnCreateSearchTags(selectedField, selectedFilter, searchText, selectedConnector.toLowerCase())\" ng-model=\"searchText\"> <span class=\"highlight\"></span><label>Search</label></div></div><div class=\"col-sm-3\" ng-if=\"isFilterOptionsVisible\"><div class=\"btn-group pull-right\" uib-dropdown=\"\"><button id=\"operatorOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedFilter.operator}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"operatorOptions\"><li ng-repeat=\"filter in filterOptions\" role=\"menuitem\" ng-click=\"fnSelectFilters(filter)\"><a>{{filter.operator}}</a></li></ul></div></div></div><span class=\"bar\"></span></div><div class=\"search-tag-container\" ng-class=\"{\'m-t-13\': tagsArr.length ===0 ,\'m-t-10 m-b-5\' : tagsArr && tagsArr.length !==0}\"><button class=\"btn btn-primary btn-xs m-0\" ng-repeat=\"tag in tagsArr track by tag.id\">{{tag.name}}<i ng-click=\"fnRemoveTags($index)\" class=\"fa fa-times m-l-5\"></i></button><div><small class=\"helper-text\" ng-if=\"tagsArr.length >= 1\">The search can only have 1 condition.</small></div></div>");
$templateCache.put("app/components/directives/tableLoader/tableLoader.html","<div class=\"loader-table\"><table><tbody id=\"loading-row\"><tr class=\"table-row\" ng-repeat=\"row in rows track by $index\"><td class=\"td-2\" ng-class=\"{\'p-t-36\' : $index ===0}\"><span ng-if=\"!isAccountUsersTab\"></span></td><td class=\"td-3 p-l-0 p-r-0\" ng-class=\"{\'tdHeight\': isAccountUsersTab, \'p-t-36\' : $index ===0}\"><ul ng-class=\"{\'row-width\': isIssueTab}\"><li ng-style=\"{\'padding-bottom\': isAccountUsersTab || setPadding ? 0 : \'\'}\"><span class=\"tableNameText\"></span></li><li ng-style=\"{\'padding-bottom\': isIssueTab && \'5px\'}\"><span ng-if=\"!isAccountUsersTab && !hideLine\" class=\"tableDescText\"></span></li><li><span ng-if=\"isIssueTab\" class=\"labelText\"></span></li></ul><ul ng-if=\"isIssueTab\" class=\"issue-tab\"><li><div class=\"m-b-5 display-text\"><i class=\"fa fa-comments comments-icon m-b-5\"></i></div><div class=\"display-text\"><span class=\"issue-row\"></span></div></li></ul></td><td class=\"td-4\" ng-if=\"!isIssueTab\" ng-class=\"{\'p-t-36\' : $index ===0}\"></td><td ng-if=\"!isAccountUsersTab && !hideCircle && !isIssueTab\" class=\"td-5\" ng-class=\"{\'p-t-36\' : $index ===0}\"><span></span></td><td ng-if=\"isAccountUsersTab\" class=\"td-6\" ng-class=\"{\'p-t-36\' : $index ===0}\"><span></span></td></tr></tbody></table></div>");
$templateCache.put("app/components/directives/v4SearchClient/v4SearchClient.html","<div class=\"search-panel-v4 floatingLabelInput\"><div class=\"row\"><div class=\"col-sm-12 d-flex p-r-10\"><div class=\"m-b-0 search-container search-bar-{{searchIdentifier}}\"><div class=\"d-flex\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"w100 scroll-element search-container-scroll-{{searchIdentifier}} hide-scroll-bar\" style=\"overflow-x: auto;scroll-behavior: smooth\"><ul class=\"m-b-0 d-flex search-main-ul\"><li class=\"m-0\" ng-class=\"{\'m-l-3\': !$first}\" ng-repeat=\"tag in tagsArr track by tag.id\"><div class=\"d-flex dropPos\"><div class=\"conditionToggle m-r-3\" ng-if=\"tag.selectedConnector\" ng-click=\"fnChangeConditionToggle(tag)\"><button class=\"btn btn-default btn-xs p-3\"><i ng-if=\"tag.selectedConnector === \'or\'\" class=\"fa fa-toggle-off\"></i> <i ng-if=\"tag.selectedConnector !== \'or\'\" class=\"fa fa-toggle-on\"></i> {{tag.selectedConnector === \"or\" ?\"OR\":\"AND\"}}</button></div><div class=\"tag-name\"><button class=\"btn btn-default btn-xs p-3\">{{tag.displaySelectedField && tag.displaySelectedField !==\"\" ? tag.displaySelectedField : tag.selectedField ? tag.selectedField : \'Keyword\'}} <i class=\"fa fa-times m-l-5\" ng-if=\"tag.isDirectFilterApply === true\" ng-click=\"fnRemoveTags($index)\"></i></button></div><div ng-if=\"tag.displaySelectedField === \'Custom Field\'\" class=\"tag-name d-flex m-l-3\"><button class=\"btn btn-default btn-xs p-3\">{{tag.customFieldName}}</button></div><div class=\"tag-name\" ng-if=\"tag.selectedFilter && tag.selectedFilter.operatorName\"><button class=\"btn btn-default btn-xs m-l-3 p-3\">{{tag.selectedFilter.operatorName}}</button></div><div class=\"remove-tag\" ng-if=\"(tag.displaySearchText && tag.displaySearchText !== \'\') || (tag.searchText && tag.searchText !== \'\')\"><button class=\"btn btn-primary btn-xs m-l-3 p-3\">{{tag.displaySearchText && tag.displaySearchText !== \"\" ? tag.displaySearchText: tag.searchText}} <i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveTags($index)\"></i></button></div></div><div class=\"conditionToggle p-l-3\" ng-if=\"$last && selectedFilter.displayName\" ng-click=\"fnChangeSelectedConnector();\"><button class=\"btn btn-default btn-xs p-3\"><i ng-if=\"selectedConnector === \'or\'\" class=\"fa fa-toggle-off\"></i> <i ng-if=\"selectedConnector !== \'or\'\" class=\"fa fa-toggle-on\"></i> {{selectedConnector === \"or\" ?\"OR\":\"AND\"}}</button></div></li><li ng-if=\"selectedFilter.displayName || optionTitle\" class=\"m-0 m-l-3\"><div class=\"d-flex dropPos\"><div ng-if=\"selectedFilter.displayName\" class=\"tag-name d-flex\"><button class=\"btn btn-default btn-xs p-3\">{{selectedFilter.displayName}} <span ng-click=\"fnRemoveSelectedFilter()\" uib-tooltip=\"Remove Filter\" tooltip-placement=\"auto\"><i class=\"fa fa-trash-o m-l-2 m-r-3\"></i></span></button></div><div ng-if=\"selectedFilter.displayName === \'Custom Field\' && selectedFilter.customFieldName !== \'\'\" class=\"tag-name d-flex m-l-3\"><button class=\"btn btn-default btn-xs p-3\">{{selectedFilter.customFieldName}}</button></div><div ng-if=\"selectedOperator.operatorName\" class=\"tag-name d-flex m-l-3\"><button class=\"btn btn-primary btn-xs p-3\">{{selectedOperator.operatorName}} <span ng-click=\"fnRemoveFilterOperator()\" uib-tooltip=\"Remove Filter\" tooltip-placement=\"auto\"><i class=\"fa fa-trash-o m-l-2 m-r-3\"></i></span></button></div><div ng-if=\"selectedStateValue\" class=\"tag-name d-flex m-l-3\"><button class=\"btn btn-primary btn-xs p-3\">{{selectedStateValue}} <span ng-click=\"fnRemoveFilterOperator()\" uib-tooltip=\"Remove Filter\" tooltip-placement=\"auto\"><i class=\"fa fa-trash-o m-l-2 m-r-3\"></i></span></button></div><div ng-if=\"optionTitle\" class=\"remove-tag\"><button class=\"btn btn-primary btn-xs m-l-3 p-3\">{{optionTitle}}<i class=\"fa fa-times m-l-5\"></i></button></div></div></li><li class=\"input-token-{{searchIdentifier}} m-0 inherit-width\" ng-class=\"tagsArr.length || selectedValue ? \'m-l-3\':\'\'\"><form class=\"inherit-width\" id=\"searchForm\" role=\"form\" name=\"searchForm\"><div class=\"md-input m-b-0 input-field inherit-width\"><input ng-attr-id=\"{{searchIdentifier}}\" style=\"min-width: 290px\" type=\"text\" name=\"inputsearch\" ng-readonly=\"fnCheckReadOnlyInput()\" class=\"md-form-control inputField p-l-2 search-main-input\" ng-focus=\"fnSearchInputFocus($event)\" ng-blur=\"fnSearchInputBlur(false)\" required=\"\" ng-change=\"fnOnChange(searchText)\" ng-pattern=\"pattern\" ng-keyup=\"$event.keyCode === 13 && fnSearchInputBlur(true)\" placeholder=\"Search\" autocomplete=\"off\" ng-model=\"searchText\"><div class=\"hiddenInputText test\"><input type=\"text\" class=\"p-0\" name=\"datetimes\" id=\"datetimes\" tabindex=\"-1\"></div><div class=\"hiddenInputText test\"><input type=\"text\" class=\"p-0\" name=\"rangedatetimes\" id=\"rangedatetimes\" tabindex=\"-1\"></div></div></form></li></ul></div><div ng-class=\"{\'width-60px\': tagsArr.length || sortString.length,\'width-35px\': !sortString.length && tagsArr.length,\'width-1px\':!sortString.length && !tagsArr.length }\"><div class=\"pull-left\" ng-if=\"tagsArr.length || sortString.length\"><div class=\"position-relative\"><span class=\"clear-icon\" ng-click=\"fnClearSearch()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-right p-t-10 p-b-10 p-l-5 p-r-8\" ng-if=\"sortString.length\" ng-click=\"fnChangeSortDirection()\"><span><i class=\"fa\" ng-class=\"selectedSortOperator === \'asc\' ? \'fa-sort-amount-asc\' :\'fa-sort-amount-desc\'\"></i></span></div></div></div></div></div></div><div ng-show=\"!isFilterSelected\" class=\"dropdown drpdwn_{{searchIdentifier}} m-t-0\" style=\"top: 10px;\"><ul class=\"dropdown-menu v4-sort-dropdown-menu d-flex flex-column\" style=\"min-width: 290px;\" ng-class=\"{\'hideMainMenu\': selectedValue == \'devices\' || selectedValue == \'users\'}\"><li ng-if=\"isFilterOptionView\"><a ng-mousedown=\"$event.stopPropagation();$event.preventDefault();\" style=\"text-align: right\"><button class=\"btn btn-link p-0 p-t-2\" ng-mousedown=\"fnOptionalFilters($event, true)\">Back</button></a></li><li class=\"divider\" ng-if=\"isFilterOptionView\" style=\"height: 2px;\"></li><li class=\"pace\" ng-show=\"!isFilterOptionView\"><a><small class=\"font-italic opacity-5\">Type to search or use a quick filter</small></a></li><li class=\"divider\" ng-show=\"!isFilterOptionView\" style=\"height: 2px;\"></li><li ng-if=\"!isFilterOptionView && isColumnView === true\" class=\"li-column-view\"><ul class=\"dropdown-menu v4-sort-dropdown-menu w100\" id=\"new-sub-dropdown-menu\"><li ng-repeat=\"filter in searchFilterArr=(filtersArr | filter:searchText) track by $index\" ng-mousedown=\"fnSelectFilter(filter)\"><a><span>{{filter.displayName}}</span></a></li></ul></li><li ng-if=\"!isFilterOptionView && isColumnView !== true\" ng-repeat=\"filter in filtersArr | filter:searchText track by $index\" ng-mousedown=\"fnSelectFilter(filter)\"><a><span>{{filter.displayName}}</span> <span style=\"display: inline-block;font-size: 11px;\" class=\"pull-right pull-right font-italic\" ng-if=\"$index === 0\">Quick filter</span></a></li><li ng-if=\"isFilterOptionView\" role=\"menuitem\" ng-repeat=\"action in sortFieldArr\"><a class=\"p-l-25\" ng-mousedown=\"fnChangeStateField(action)\">{{action.displayName}} <span style=\"position: absolute;left: 7px;\" ng-if=\"selectedStateFieldObj.name === action.name\"><i class=\"fa fa-check\"></i></span></a></li><li class=\"divider\" ng-show=\"!isFilterOptionView\" style=\"height: 2px;\"></li><li ng-show=\"!isFilterOptionView\"><a ng-mousedown=\"$event.stopPropagation();$event.preventDefault();\"><span>Sort by{{!selectedStateFieldObj.displayName ?\' ...\':\": \"+selectedStateFieldObj.displayName}}</span> <button class=\"btn btn-link pull-right p-0 p-t-2\" ng-mousedown=\"fnOptionalFilters($event)\">{{!selectedStateFieldObj.displayName ?\'Select\':\'Change\'}} Filter</button></a></li></ul></div><div ng-show=\"fnCheckOperatorDropdown()\" class=\"dropdown drpdwn_{{searchIdentifier}} m-t-0\" style=\"top: 10px;\"><ul class=\"dropdown-menu sub-menu\"><li ng-repeat=\"operator in predefinedOperatorArr\" ng-if=\"selectedFilter.isPredefinedValue || selectedFilter.predefinedOperatorArr\" ng-mousedown=\"fnSelectFilterOperator(operator)\"><a>{{operator.operatorName}}</a></li><li ng-repeat=\"operator in operatorsArr\" ng-if=\"!selectedFilter.isPredefinedValue && !selectedFilter.predefinedOperatorArr\" ng-mousedown=\"fnSelectFilterOperator(operator)\"><a>{{operator.operatorName}}</a></li></ul></div><div ng-if=\"isShowFilterPredefinedValues\" class=\"dropdown searchable-dropdown-{{searchIdentifier}}\"><ul class=\"dropdown-menu dropdown-menu-min-width m-0 v4-sort-dropdown-menu\"><li ng-if=\"selectedFilter.isShowSearchBar\"><div class=\"md-input m-0 m-t-8 m-l-4 m-r-4\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"search[filter]\" ng-focus=\"fnFocusSearchableDropdown($event)\" ng-blur=\"fnBlurSearchableDropdown($event)\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\" ng-if=\"selectedFilter.isShowSearchBar\"></li><li ng-repeat=\"predefinedValuesObj in values=(selectedFilterPredefinedValues | filter:search) | limitTo:10 track by $index\" ng-mousedown=\"setFilterOptionsValue(predefinedValuesObj)\"><a><span class=\"d-flex align-items-center\"><span ng-if=\"selectedFilter.isShowUserAvatar\" class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{predefinedValuesObj.userAvatar}}\"></span> <span><span style=\"display: block;\">{{predefinedValuesObj[selectedFilter.displayKeyName]}}</span> <span class=\"font-italic gateway-id-menu-option\" ng-if=\"selectedFilter.isShowId\">({{predefinedValuesObj.id}})</span></span></span></a></li><li ng-if=\"!values.length\"><a>No matching results</a></li></ul></div></div><div class=\"col-sm-12 p-0 p-b-10 m-b-10 m-t-1 selected-filter-info-msg floatingLabelInput\"><small class=\"helper-text-error m-t-0 position-relative\" style=\"background: transparent;\" ng-show=\"searchForm.inputsearch.$error.pattern && searchForm.inputsearch.$dirty\"><span class=\"errorText p-0\">{{errorMsg}}</span></small></div>");
$templateCache.put("app/components/directives/workflowFlow/workflowFlow.html","<div class=\"tf-nc p-0 workflowStateBlock\" ng-class=\"{\'root\': workflowHierarchyObj.category === \'TRIGGER\' || !$parent.$parent.workflowHierarchyObj,\'choiceAfter\': workflowHierarchyObj.type === \'CHOICE\'}\" ng-click=\"fnGetStateInfo(workflowHierarchyObj)\"><a ng-class=\"{\'choiceArrowIcon\': $parent.$parent.workflowHierarchyObj.type === \'CHOICE\' && isWorkflowCreateMode === true ? true: $parent.$parent.workflowHierarchyObj.children.length !== 1 }\"></a> <span class=\"settingIcon\" ng-if=\"$parent.$parent.workflowHierarchyObj.type === \'CHOICE\' && isWorkflowCreateMode === true\" ng-click=\"$event.stopPropagation();fnSetChoiceConnectionConfig($parent.$parent.$parent.workflowHierarchyObj, $parent.$parent.workflowHierarchyObj)\"><i ng-class=\"fnGetBranchesStatusIcon($parent.$parent.$parent.workflowHierarchyObj.uuid, $parent.$parent.workflowHierarchyObj.isReference ? $parent.$parent.workflowHierarchyObj.isReference : $parent.$parent.workflowHierarchyObj.uuid)\"></i></span><div class=\"panel panel-default m-b-0\" ng-class=\"{\'m-t-27\': $parent.$parent.workflowHierarchyObj.type === \'CHOICE\' && isWorkflowCreateMode === true ? true: $parent.$parent.workflowHierarchyObj.children.length !== 1,\'p-1\': workflowHierarchyObj.isReference}\" ng-style=\"{\'border-color\': workflowHierarchyObj.userData.style.panel[\'border-color\'],\'border\': workflowHierarchyObj.userData.style.panel.border}\"><div ng-class=\"{\'referenceState\': workflowHierarchyObj.isReference}\"><div class=\"panel-heading p-6 p-r-15 workflowStatePanel-heading-height\" ng-style=\"{\'background-color\': workflowHierarchyObj.userData.style[\'panel-heading\'][\'background-color\'],\'border-color\': workflowHierarchyObj.userData.style[\'panel-heading\'][\'border-color\']}\"><div class=\"col-sm-12 p-0\" ng-if=\"isWorkflowCreateMode === true\"><div class=\"col-sm-11 p-0 text-left m-t-5\" ng-if=\"!workflowHierarchyObj.isReference\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><img class=\"stateIcon\" ng-style=\"workflowHierarchyObj.userData.style.stateIcon\" ng-src=\"data:image/svg+xml;base64,{{workflowHierarchyObj.icon}}\"> <span class=\"workflowStateText ellipsis\" ng-style=\"{\'color\': workflowHierarchyObj.userData.style.workflowStateText}\" ng-if=\"workflowHierarchyObj.userData.name !== workflowHierarchyObj.name\">{{workflowHierarchyObj.name}}</span> <span class=\"stateText\" ng-style=\"workflowHierarchyObj.userData.style.stateText\">{{workflowHierarchyObj.userData.name}}</span></label></div><div class=\"col-sm-11 p-0 text-left\" ng-if=\"workflowHierarchyObj.isReference\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><span class=\"m-t-9 m-l-5 referenceStateIcon\"><svg version=\"1.1\" ng-style=\"{\'fill\':workflowHierarchyObj.userData.style.referenceStateIcon}\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\"><g><g><path d=\"M368.64,0H20.48C9.175,0,0,9.175,0,20.48v348.16c0,11.305,9.175,20.48,20.48,20.48h348.16 c11.305,0,20.48-9.175,20.48-20.48V20.48C389.12,9.175,379.945,0,368.64,0z M348.16,348.16H40.96V40.96h307.2V348.16z\"></path></g></g><g><g><path d=\"M471.04,419.84v51.2h-51.2V512h71.68c11.305,0,20.48-9.175,20.48-20.48v-71.68H471.04z\"></path></g></g><g><g><rect x=\"262.349\" y=\"471.04\" width=\"110.182\" height=\"40.96\"></rect></g></g><g><g><path d=\"M163.84,471.04v-51.2h-40.96v71.68c0,11.305,9.175,20.48,20.48,20.48h71.68v-40.96H163.84z\"></path></g></g><g><g><path d=\"M491.52,122.88h-71.68v40.96h51.2v51.2H512v-71.68C512,132.055,502.825,122.88,491.52,122.88z\"></path></g></g><g><g><rect x=\"471.04\" y=\"262.349\" width=\"40.96\" height=\"110.182\"></rect></g></g></svg></span> <span class=\"stateText\" ng-style=\"workflowHierarchyObj.userData.style.referenceStateText\">Reference to Existing Step</span></label></div><div class=\"col-sm-1 p-0 text-right m-t-10\"><div class=\"dropdown\" uib-dropdown=\"\"><i class=\"dropdown-toggle fa fa-bars\" ng-click=\"$event.stopPropagation();\" ng-style=\"{\'color\':workflowHierarchyObj.userData.style.workflowStateText}\" style=\"font-size: 20px;\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"></i><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!workflowHierarchyObj.isReference\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnRenameWorkflowState(workflowHierarchyObj)\">Rename</a></li><li ng-if=\"!workflowHierarchyObj.isReference\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnRemoveWorkflowFlow(workflowHierarchyObj.uuid, $parent.$parent.$parent.$parent.workflowHierarchyObj, workflowHierarchyObj)\">Delete</a></li><li ng-if=\"!workflowHierarchyObj.isReference && workflowHierarchyObj.category !== \'TRIGGER\' && selectedTab === 1\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnAddErrorFlow(workflowHierarchyObj)\">{{workflowHierarchyObj.userData.isOnErrorSelected && workflowHierarchyObj.userData.isOnErrorSelected === true ? \"Change Error Flow\" :\"Add Error Flow\"}}</a></li><li ng-if=\"selectedTab === 1 && !workflowHierarchyObj.isReference && workflowHierarchyObj.userData.isOnErrorSelected && workflowHierarchyObj.userData.isOnErrorSelected === true\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnRemoveErrorFlow(workflowHierarchyObj)\">Remove Error Flow</a></li><li ng-if=\"workflowHierarchyObj.isReference\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnRemoveWorkflowFlow(workflowHierarchyObj.uuid, $parent.$parent.$parent.$parent.workflowHierarchyObj, workflowHierarchyObj)\">Delete Reference</a></li><li ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && isWorkflowCreateMode === true && !workflowHierarchyObj.isReference\"><a class=\"btn btn-link\" ng-click=\"$event.stopPropagation();fnOpenStateConfigModal(workflowHierarchyObj)\">Configure</a></li></ul></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"isWorkflowCreateMode !== true\"><div class=\"p-0 text-left m-t-5\" ng-if=\"!workflowHierarchyObj.isReference\" ng-class=\"cId === workflowHierarchyObj.uuid || workflowHierarchyObj.category === \'TRIGGER\' ?\'col-sm-12\':\'col-sm-10\'\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><img class=\"stateIcon\" ng-style=\"workflowHierarchyObj.userData.style.stateIcon\" ng-src=\"data:image/svg+xml;base64,{{workflowHierarchyObj.icon}}\"> <span class=\"workflowStateText ellipsis\" ng-style=\"{\'color\': workflowHierarchyObj.userData.style.workflowStateText}\" ng-if=\"workflowHierarchyObj.userData.name !== workflowHierarchyObj.name\">{{workflowHierarchyObj.name}}</span> <span class=\"stateText\" ng-style=\"workflowHierarchyObj.userData.style.stateText\">{{workflowHierarchyObj.userData.name}}</span></label></div><div class=\"col-sm-12 p-0 text-left\" ng-if=\"workflowHierarchyObj.isReference\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><span class=\"m-t-9 m-l-5 referenceStateIcon\"><svg version=\"1.1\" ng-style=\"{\'fill\': workflowHierarchyObj.userData.style.referenceStateIcon}\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\"><g><g><path d=\"M368.64,0H20.48C9.175,0,0,9.175,0,20.48v348.16c0,11.305,9.175,20.48,20.48,20.48h348.16 c11.305,0,20.48-9.175,20.48-20.48V20.48C389.12,9.175,379.945,0,368.64,0z M348.16,348.16H40.96V40.96h307.2V348.16z\"></path></g></g><g><g><path d=\"M471.04,419.84v51.2h-51.2V512h71.68c11.305,0,20.48-9.175,20.48-20.48v-71.68H471.04z\"></path></g></g><g><g><rect x=\"262.349\" y=\"471.04\" width=\"110.182\" height=\"40.96\"></rect></g></g><g><g><path d=\"M163.84,471.04v-51.2h-40.96v71.68c0,11.305,9.175,20.48,20.48,20.48h71.68v-40.96H163.84z\"></path></g></g><g><g><path d=\"M491.52,122.88h-71.68v40.96h51.2v51.2H512v-71.68C512,132.055,502.825,122.88,491.52,122.88z\"></path></g></g><g><g><rect x=\"471.04\" y=\"262.349\" width=\"40.96\" height=\"110.182\"></rect></g></g></svg></span> <span class=\"stateText\" ng-style=\"workflowHierarchyObj.userData.style.referenceStateText\">Reference to Existing Step</span></label></div><div class=\"col-sm-2 p-0 m-t-2\" ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && cId !== workflowHierarchyObj.uuid && (!isCalledFromAddBranch || $parent.$parent.$parent.$parent.workflowHierarchyObj.type !== \'CHOICE\' || $parent.$parent.$parent.$parent.workflowHierarchyObj.uuid !== cId) && !workflowHierarchyObj.isReference\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn pull-right p-t-6 p-b-6 p-r-12 p-l-12 workflowConnectButton\" ng-style=\"{\'color\': workflowHierarchyObj.userData.style.workflowStateText}\" ng-click=\"fnInjectState(workflowHierarchyObj)\">Connect</button></div></div></div></div><div class=\"panel-body p-10 stateTextDivCenter\" ng-style=\"workflowHierarchyObj.userData.style.stateTextDivCenter\"><div class=\"col-sm-12 text-left\" ng-if=\"!workflowHierarchyObj.isReference\"><div class=\"p-l-10\" ng-class=\"workflowHierarchyObj.category !== \'TRIGGER\' && isWorkflowCreateMode === true? \'col-sm-11\':\'col-sm-12\'\"><span>{{workflowHierarchyObj.stateInfo}}</span></div><div class=\"col-sm-1 p-0 settingIconPosition\" ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && isWorkflowCreateMode === true\" ng-click=\"$event.stopPropagation();fnOpenStateConfigModal(workflowHierarchyObj)\"><i class=\"fa fa-gear m-l-10 setting-icon-size\"></i></div></div><div class=\"col-sm-12 text-center workflowStatePanel-body\" ng-if=\"workflowHierarchyObj.isReference\"><div class=\"p-l-10 col-sm-12\"><span>{{workflowHierarchyObj.userData.name}}</span></div></div><span class=\"stateErrorIcon\" ng-click=\"$event.stopPropagation();fnOpenStateConfigModal(workflowHierarchyObj)\" ng-style=\"workflowHierarchyObj.userData.style.stateErrorIcon\" ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && workflowHierarchyObj.type !== \'FAIL\' && workflowHierarchyObj.type !== \'SUCCEED\' && !workflowHierarchyObj.isReference && isWorkflowCreateMode\"><i class=\"fa\" ng-class=\"workflowHierarchyObj.userData.isValidState === true ?\'fa-check success-icon\':\'fa-exclamation error-icon\'\"></i></span> <span class=\"stateErrorIcon\" ng-style=\"workflowHierarchyObj.userData.style.stateErrorIcon\" ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && workflowHierarchyObj.type !== \'FAIL\' && workflowHierarchyObj.type !== \'SUCCEED\' && !workflowHierarchyObj.isReference && !isWorkflowCreateMode\"><i class=\"fa\" ng-class=\"workflowHierarchyObj.userData.isValidState === true ?\'fa-check success-icon\':\'fa-exclamation error-icon\'\"></i></span><div class=\"errorConfigurationIcon\" ng-if=\"workflowHierarchyObj.category !== \'TRIGGER\' && selectedTab === 1 && !workflowHierarchyObj.isReference && workflowHierarchyObj.userData.isOnErrorSelected && workflowHierarchyObj.userData.isOnErrorSelected === true\" ng-style=\"{\'border-color\':workflowHierarchyObj.userData.style.panel[\'border-color\']}\"><div class=\"p-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewbox=\"-38 0 512 512.00142\" ng-style=\"{\'fill\':workflowHierarchyObj.userData.style.panel[\'border-color\']}\"><g id=\"surface1\"><path d=\"M 435.488281 138.917969 L 435.472656 138.519531 C 435.25 133.601562 435.101562 128.398438 435.011719 122.609375 C 434.59375 94.378906 412.152344 71.027344 383.917969 69.449219 C 325.050781 66.164062 279.511719 46.96875 240.601562 9.042969 L 240.269531 8.726562 C 227.578125 -2.910156 208.433594 -2.910156 195.738281 8.726562 L 195.40625 9.042969 C 156.496094 46.96875 110.957031 66.164062 52.089844 69.453125 C 23.859375 71.027344 1.414062 94.378906 0.996094 122.613281 C 0.910156 128.363281 0.757812 133.566406 0.535156 138.519531 L 0.511719 139.445312 C -0.632812 199.472656 -2.054688 274.179688 22.9375 341.988281 C 36.679688 379.277344 57.492188 411.691406 84.792969 438.335938 C 115.886719 468.679688 156.613281 492.769531 205.839844 509.933594 C 207.441406 510.492188 209.105469 510.945312 210.800781 511.285156 C 213.191406 511.761719 215.597656 512 218.003906 512 C 220.410156 512 222.820312 511.761719 225.207031 511.285156 C 226.902344 510.945312 228.578125 510.488281 230.1875 509.925781 C 279.355469 492.730469 320.039062 468.628906 351.105469 438.289062 C 378.394531 411.636719 399.207031 379.214844 412.960938 341.917969 C 438.046875 273.90625 436.628906 199.058594 435.488281 138.917969 Z M 384.773438 331.523438 C 358.414062 402.992188 304.605469 452.074219 220.273438 481.566406 C 219.972656 481.667969 219.652344 481.757812 219.320312 481.824219 C 218.449219 481.996094 217.5625 481.996094 216.679688 481.820312 C 216.351562 481.753906 216.03125 481.667969 215.734375 481.566406 C 131.3125 452.128906 77.46875 403.074219 51.128906 331.601562 C 28.09375 269.097656 29.398438 200.519531 30.550781 140.019531 L 30.558594 139.683594 C 30.792969 134.484375 30.949219 129.039062 31.035156 123.054688 C 31.222656 110.519531 41.207031 100.148438 53.765625 99.449219 C 87.078125 97.589844 116.34375 91.152344 143.234375 79.769531 C 170.089844 68.402344 193.941406 52.378906 216.144531 30.785156 C 217.273438 29.832031 218.738281 29.828125 219.863281 30.785156 C 242.070312 52.378906 265.921875 68.402344 292.773438 79.769531 C 319.664062 91.152344 348.929688 97.589844 382.246094 99.449219 C 394.804688 100.148438 404.789062 110.519531 404.972656 123.058594 C 405.0625 129.074219 405.21875 134.519531 405.453125 139.683594 C 406.601562 200.253906 407.875 268.886719 384.773438 331.523438 Z M 384.773438 331.523438\" style=\"stroke:none;fill-rule:nonzero;fill-opacity:1;\"></path><path d=\"M 217.996094 128.410156 C 147.636719 128.410156 90.398438 185.652344 90.398438 256.007812 C 90.398438 326.367188 147.636719 383.609375 217.996094 383.609375 C 288.351562 383.609375 345.59375 326.367188 345.59375 256.007812 C 345.59375 185.652344 288.351562 128.410156 217.996094 128.410156 Z M 217.996094 353.5625 C 164.203125 353.5625 120.441406 309.800781 120.441406 256.007812 C 120.441406 202.214844 164.203125 158.453125 217.996094 158.453125 C 271.785156 158.453125 315.546875 202.214844 315.546875 256.007812 C 315.546875 309.800781 271.785156 353.5625 217.996094 353.5625 Z M 217.996094 353.5625\" style=\"stroke:none;fill-rule:nonzero;fill-opacity:1;\"></path><path d=\"M 254.667969 216.394531 L 195.402344 275.660156 L 179.316406 259.574219 C 173.449219 253.707031 163.9375 253.707031 158.070312 259.574219 C 152.207031 265.441406 152.207031 274.953125 158.070312 280.816406 L 184.78125 307.527344 C 187.714844 310.460938 191.558594 311.925781 195.402344 311.925781 C 199.246094 311.925781 203.089844 310.460938 206.023438 307.527344 L 275.914062 237.636719 C 281.777344 231.769531 281.777344 222.257812 275.914062 216.394531 C 270.046875 210.523438 260.535156 210.523438 254.667969 216.394531 Z M 254.667969 216.394531\" style=\"stroke:none;fill-rule:nonzero;fill-opacity:1;\"></path></g></svg></div></div></div></div></div></div><ul ng-if=\"workflowHierarchyObj.children.length !== 0 && isWorkflowCreateMode !== true\" ng-class=\"workflowHierarchyObj.type === \'CHOICE\' ? \'parentChoice\':\'\'\"><li ng-repeat=\"workflowHierarchyObj in workflowHierarchyObj.children track by $index\" workflow-flow=\"\" c-id=\"cId\" is-called-from-add-branch=\"isCalledFromAddBranch\" is-workflow-create-mode=\"isWorkflowCreateMode\" workflow-hierarchy-obj=\"workflowHierarchyObj\" fn-inject-existing-state=\"fnInjectState(workflowHierarchyObj)\"></li></ul><ul ng-if=\"workflowHierarchyObj.children.length !== 0 && isWorkflowCreateMode === true\" ng-class=\"workflowHierarchyObj.type === \'CHOICE\' ? \'parentChoice\':\'\'\"><li ng-repeat=\"workflowHierarchyObj in workflowHierarchyObj.children track by $index\" workflow-flow=\"\" is-workflow-create-mode=\"isWorkflowCreateMode\" workflow-hierarchy-obj=\"workflowHierarchyObj\" workflow-flow-obj=\"workflowFlowObj\" total-choice-count=\"totalChoiceCount\" fn-get-state-detail=\"fnGetStateInfo(workflowHierarchyObj)\" fn-set-choice-line-connection-config=\"fnSetChoiceConnectionConfig(currentWorkflowHierarchyObj,parentObj)\" fn-rename-workflow-state-name=\"fnRenameWorkflowState(workflowHierarchyObj)\" fn-remove-workflow-flow-state=\"fnRemoveWorkflowFlow(uuid,parentObj,workflowHierarchyObj)\" fn-open-flow-state-config-modal=\"fnOpenStateConfigModal(workflowHierarchyObj)\" fn-add-new-state-input=\"fnGetStateInput(workflowChildren, workflowObj)\" fn-add-existing-state-input=\"fnOpenWorkflowFlowModal(workflowChildren, workflowObj, isCalledFromAddBranch)\" fn-add-new-error-flow=\"fnAddErrorFlow(workflowObj)\" selected-tab=\"selectedTab\" fn-remove-on-error-flow=\"fnRemoveErrorFlow(workflowObj)\"></li><li ng-if=\"workflowHierarchyObj.type === \'CHOICE\'\"><div class=\"tf-nc p-0 workflowStateBlock\"><a class=\"choiceArrowIcon\"></a><div class=\"col-sm-12 m-t-27 stateBoxBorder\"><div class=\"col-sm-12 p-0 text-center stateBoxText\"><button class=\"btn btn-link\" ng-click=\"fnGetStateInput(workflowHierarchyObj.children,workflowHierarchyObj)\">ADD NEW A BRANCH</button><br ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\"><small class=\"font-italic\" ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\">-</small><br ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\"><button class=\"btn btn-link\" ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\" ng-click=\"fnOpenWorkflowFlowModal(workflowHierarchyObj.children,workflowHierarchyObj,true)\">CONNECT TO AN EXISTING STEP</button></div></div></div></li></ul><ul ng-if=\"workflowHierarchyObj.children.length === 0 && workflowHierarchyObj.outPort !==0 && isWorkflowCreateMode === true\"><li class=\"\"><div class=\"tf-nc p-0 workflowStateBlock\" ng-class=\"{\'m-t-16\': workflowHierarchyObj.type === \'CHOICE\'}\"><a></a><div class=\"col-sm-12 stateBoxBorder\"><div class=\"col-sm-12 p-0 text-center stateBoxText\" ng-if=\"workflowHierarchyObj.type === \'CHOICE\'\"><button class=\"btn btn-link\" ng-click=\"fnGetStateInput(workflowHierarchyObj.children, workflowHierarchyObj)\">ADD A NEW STEP</button><br ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\"><small class=\"font-italic\" ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\">-</small><br ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\"><button class=\"btn btn-link\" ng-if=\"totalChoiceCount !== 0 && workflowHierarchyObj.children.length >= 1\" ng-click=\"fnOpenWorkflowFlowModal(workflowHierarchyObj.children,workflowHierarchyObj,false)\">CONNECT TO AN EXISTING STEP</button></div><div class=\"col-sm-12 p-0 text-center stateBoxText\" ng-if=\"workflowHierarchyObj.type !== \'CHOICE\'\"><button class=\"btn btn-link\" ng-click=\"fnGetStateInput(workflowHierarchyObj.children, workflowHierarchyObj)\">ADD A NEW STEP</button><br ng-if=\"totalChoiceCount !== 0\"><small class=\"font-italic\" ng-if=\"totalChoiceCount !== 0\">-</small><br ng-if=\"totalChoiceCount !== 0\"><button class=\"btn btn-link\" ng-if=\"totalChoiceCount !== 0\" ng-click=\"fnOpenWorkflowFlowModal(workflowHierarchyObj.children,workflowHierarchyObj,false)\">CONNECT TO AN EXISTING STEP</button></div></div></div></li></ul>");
$templateCache.put("app/components/directives/widgetEditor/widgetEditor.html","<div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"container-with-footer tab-container\"><div class=\"widget-content-main\"><div class=\"content-main\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Widget</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold text-capitalize\" ng-if=\"isFullWidthDevice\">{{serviceDisplayName}}</h1><h3 class=\"m-0 font-bold text-capitalize\" ng-if=\"!isFullWidthDevice\">{{serviceDisplayName}}</h3></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\" ng-if=\"!isViewDashboardLists\"><div class=\"col-sm-9 overflow-auto p-0\"><div class=\"col-sm-12 p-0 d-flex m-t-30\"><div class=\"col-sm-4\"><div class=\"dashboard-header-panel\" style=\"width: 100% !important\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Dashboard</label></div><div class=\"panel-body\"><span>You can assign widgets to your dashboard in the form of dashboard. Each dashboard is a name consisting of a user-defined widget, query and chart.</span></div><div class=\"panel-footer text-right\"><button class=\"btn btn-primary text-right v4-primary-button\" ng-click=\"fnGotoListDashboards()\">Change Dashboard</button></div></div></div></div></div></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-12 d-flex width-inherit justify-content-space-around\"><div class=\"dashboard-header-panel\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading d-flex align-items-center\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"panel-body no-panel-footer\"><span>Every dashboard comes with a default view.While the default Dashboard may suffice, the real usefulness of Dashboards lies in your ability to create and customize them the way you want.</span><br><br><span>Dashboards contain one or more widgets that give you an overview of the dimensions and metrics you care about the most.This editor allows you to create and customize a Dashboard.</span></div></div></div></div></div></div></div><div class=\"p-t-0 p-b-15 p-l-0 p-r-0\" ng-if=\"isViewDashboardLists\"><div class=\"col-sm-12 p-0 d-flex m-t-25 blueprintWidgetsSearchContainer issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{project.name ? project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"dashboardsProjectSearch[dashboardsProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in filterProject=(projectsArr | filter:dashboardsProjectSearch) track by $index\" ng-click=\"fnGetProjectDashboards(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"isRefreshData\" search-identifier=\"\'dashboardsssearch\'\" filters-arr=\"searchFiltersArr\" filter-query=\"filterQuery\" fn-filter-query-change=\"fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_dashboards\'\" no-set-url=\"true\" fn-resize=\"fnSetTableHeight()\" sort-field-arr=\"sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"col-sm-12 p-0\"><table-loader ng-if=\"isDashboardsLoading\" fn-resize=\"fnSetLoaderTableHeight()\"></table-loader><div class=\"dashboard-modal-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!isDashboardsLoading\"><thead><tr><th ng-if=\"dashboardsArr.length\" class=\"p-8\"></th><th ng-if=\"dashboardsArr.length\">Name</th><th ng-if=\"dashboardsArr.length\">Project</th><th ng-if=\"dashboardsArr.length\"></th><th ng-if=\"dashboardsArr.length\"></th><th ng-if=\"!dashboardsArr.length\">No records found...</th></tr></thead><tbody id=\"dashboardsTable\"><tr ng-repeat=\"dashboardsObj in dashboardsArr track by $index\" ng-click=\"dashboardsObj.isCheck = !dashboardsObj.isCheck;fnCheckUncheckHeader(dashboardsObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"dashboardsObj.isCheck\" ng-change=\"fnCheckUncheckHeader(dashboardsObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{dashboardsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{dashboardsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{dashboardsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{dashboardsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{dashboardsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{dashboardsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"dashboardsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{dashboardsObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!isDashboardsLoading && dashboardsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"perPage = 10; fnPageChanged(currentPage, perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"perPage = 20; fnPageChanged(currentPage, perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"perPage = 50; fnPageChanged(currentPage, perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"perPage = 100; fnPageChanged(currentPage,perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"currentPage\" items-per-page=\"perPage\" max-size=\"maxSize\" boundary-links=\"true\" ng-click=\"fnPageChanged(currentPage, perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" style=\"height: max-content\" ng-if=\"isViewDashboardLists\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-l-0\"><div><label class=\"m-0\">Total: {{totalItems}}</label></div></div><div class=\"col-sm-6 content-box-footerItem m-0 p-r-0\"><button type=\"button\" ng-if=\"isDashboardDetailsLoaded\" class=\"btn btn-primary v4-primary-button m-r-0 pull-right\" ng-disabled=\"!isDashboardsObjSelected()\" ng-click=\"fnSaveWidget()\">Save</button> <button type=\"button\" ng-if=\"isDashboardDetailsLoaded\" class=\"btn btn-primary btn-primary-cancel m-r-10 pull-right\" ng-click=\"fnExitWidgets()\">Cancel</button><div class=\"d-flex justify-content-flex-end\" ng-if=\"!isDashboardDetailsLoaded\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modals/federatedAccess/federatedAccess.html","<div class=\"inmodal theme_modal\" ng-init=\"federatedAccess.fnInitModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\" ng-bind=\"\'Federated Access\'\"></strong><div class=\"pull-right\"><img alt=\"profile photo\" class=\"img-circle img-profile\" style=\"width: 30px; height: 30px\" ng-src=\"{{federatedAccess.fnGetUserAvatar(federatedAccess.federationObj)}}\" on-error-src=\"\"></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-container p-0\"><div class=\"col-sm-12\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\"><span>You are currently federated into account {{federatedAccess.federationObj.alias}} ({{federatedAccess.federationObj.id.split(\'-\')[1]}}). The owners of this account have granted you access and have assigned you a set of privileges that may differ from those in your own account.</span></div><div class=\"col-sm-12 p-0 p-t-10\"><span>You can return to your account at any time by selecting \'Return to my account\' from your profile menu in the top right corner.</span></div></div><div class=\"col-sm-4 p-0\" id=\"federatedAccessModal\"><ul class=\"federatedAccess pull-right\"><li><a class=\"\"><i class=\"fa fa-user\"></i> {{federatedAccess.authUserObj.firstName +\' \'+ federatedAccess.authUserObj.lastName}} [{{federatedAccess.authUserObj.username}}]</a></li><li class=\"divider\"></li><li><a class=\"\"><strong>{{federatedAccess.federationObj.alias}}</strong></a></li><li ng-click=\"federatedAccess.fnCopyInfoToClipboard(federatedAccess.federationObj.id.split(\'-\')[1], \'Account ID\')\" uib-tooltip=\"Click to copy Account ID\" tooltip-placement=\"left\"><a>Account ID: {{federatedAccess.federationObj.id.split(\"-\")[1]}}</a></li><li class=\"divider\"></li><li><a ng-click=\"federatedAccess.fnReturnToMyAccount()\">Return to my account</a></li></ul></div></div></div></div></div></div></div><div class=\"modal-footer p-b-10\"><button type=\"button\" class=\"pull-left btn btn-link\" ng-click=\"federatedAccess.fnUpdateUserWindowChoice()\">Don\'t show me this message again</button> <button type=\"button\" class=\"pull-right btn btn-primary\" ng-click=\"federatedAccess.fnCancel()\">Close</button></div></div>");
$templateCache.put("app/main/modals/federationOptions/federationOptions.html","<div class=\"inmodal h-100\"><div class=\"modal-header federation-headerDiv\"><strong class=\"inline-display p-t-8\">Federations</strong></div><div class=\"modal-body\" style=\"overflow: hidden\"><div class=\"row\" id=\"functionModal\"><div class=\"col-sm-12 floatingLabelInput d-flex federation-searchDiv\"><div class=\"p-0 w100\" style=\"width: calc(100% - 5px)\"><v4-search-client ng-if=\"fedOptions.isRefreshData\" search-identifier=\"\'federations\'\" filters-arr=\"fedOptions.searchFiltersArr\" filter-query=\"fedOptions.filterQuery\" fn-filter-query-change=\"fedOptions.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.federations\'\" no-set-url=\"true\" fn-resize=\"fedOptions.fnSetTableHeight()\" sort-field-arr=\"fedOptions.sortFieldArr\"></v4-search-client></div></div><div class=\"col-sm-12 p-0 federation-ModelDiv\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0\" ng-if=\"fedOptions.isFederationsLoading\"><div class=\"\" app-spinner=\"\" spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading......\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!fedOptions.isFederationsLoading\"><div class=\"col-sm-12\" ng-if=\"!fedOptions.federationsArr.length\"><label class=\"m-0\">No records found...</label></div><div class=\"col-sm-6\" ng-repeat=\"obj in fedOptions.federationsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"fedOptions.fnSelectFederation(obj)\">Access</button></div><h3 class=\"m-t-9\"><span>{{obj.alias}}</span></h3></div><div class=\"panel-body\"><span>{{obj.description}}</span></div></div></div></div></div><div class=\"col-sm-12 federation-pagination m-t-10\"><div class=\"pagination-container\" ng-show=\"!fedOptions.isFederationsLoading && fedOptions.federationsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{fedOptions.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"fedOptions.perPage = 10; fedOptions.fnPageChanged(fedOptions.currentPage, fedOptions.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"fedOptions.perPage = 20; fedOptions.fnPageChanged(fedOptions.currentPage, fedOptions.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"fedOptions.perPage = 50; fedOptions.fnPageChanged(fedOptions.currentPage, fedOptions.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"fedOptions.perPage = 100; fedOptions.fnPageChanged(fedOptions.currentPage,fedOptions.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"fedOptions.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"fedOptions.currentPage\" items-per-page=\"fedOptions.perPage\" max-size=\"fedOptions.maxSize\" boundary-links=\"true\" ng-click=\"fedOptions.fnPageChanged(fedOptions.currentPage, fedOptions.perPage)\"></ul></div></div></div></div></div></div><div class=\"modal-footer federation-footerDiv\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"fedOptions.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/node/alarmHistory/alarmHistoryInfo/alarmHistoryInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-10 p-0\"><div class=\"col-sm-12 p-0\"><span>Alarm History</span></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{alarmObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{alarmObj.name}}</h3></div><div class=\"col-sm-12 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{alarmObj.description ? alarmObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{alarmObj.description ? alarmObj.description : \'\'}}</h5><div class=\"d-flex align-items-center\" ng-if=\"nodeName && nodeName.length\"><h3 class=\"m-0 m-t-0 ellipsis alarm-node-title\" ng-class=\"isFullWidthDevice ? \'m-t-5\':\'m-t-0\'\">{{nodeName ? nodeName : \'\'}}</h3><div class=\"d-flex align-items-center\"><i class=\"m-l-5 p-t-5 fa fa-external-link\" ng-click=\"fnOpenNodeInfo()\"></i></div></div><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{alarmObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div><div class=\"col-sm-2 p-0 m-auto justify-content-flex-end d-flex flex-column align-items-flex-end\"><div class=\"d-flex flex-column\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-b-10\" ng-click=\"fnCreateIssue(alarmObj)\">Create Issue</button> <button type=\"button\" ng-if=\"userPermissionsObj.REQUEST_NODE_TUNNEL || userPermissionsObj.isShowECUTunnelOption\" class=\"btn btn-gray\" ng-click=\"fnOpenNodeTunnel(alarmObj)\">Open Tunnel</button></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/alarms/alarmInfo/alarmInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-10 p-0\"><div class=\"col-sm-12 p-0\"><span>Alarm</span></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{alarmObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{alarmObj.name}}</h3></div><div class=\"col-sm-12 p-0\"><div><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{alarmObj.description ? alarmObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{alarmObj.description ? alarmObj.description : \'\'}}</h5></div><div class=\"d-flex align-items-center\" ng-if=\"nodeName && nodeName.length\"><h3 class=\"m-0 m-t-0 ellipsis alarm-node-title\" ng-class=\"isFullWidthDevice ? \'m-t-5\':\'m-t-0\'\">{{nodeName ? nodeName : \'\'}}</h3><div class=\"d-flex align-items-center\"><i class=\"m-l-5 p-t-5 fa fa-external-link\" ng-click=\"fnOpenNodeInfo()\"></i></div></div><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{alarmObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div><div class=\"col-sm-2 p-0 m-auto justify-content-flex-end d-flex flex-column align-items-flex-end\"><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center m-b-10\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary v4-primary-button border-right-0 p-r-6\" ng-click=\"fnCreateIssue(alarmObj)\">Track Issue</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button border-left-0 m-l-0 p-l-4\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"fnOpenIssueListModal([alarmObj])\"><a><span>Add to Issue</span></a></li></ul></div><button type=\"button\" ng-if=\"userPermissionsObj.REQUEST_NODE_TUNNEL || userPermissionsObj.isShowECUTunnelOption\" class=\"btn btn-gray m-b-10\" ng-click=\"fnOpenNodeTunnel(alarmObj)\">Open Tunnel</button> <button type=\"button\" ng-if=\"alarmObj.issueIds && alarmObj.issueIds.length\" class=\"btn btn-gray\" ng-click=\"fnOpenLinkIssueModal(alarmObj)\">View Issues</button></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/alarms/createAttributeIssue/createAttributeIssue.html","<div class=\"form-content\" ng-controller=\"createAttributeIssueCtrl as createAttributeIssue\" ng-class=\"createAttributeIssue.isIssueCreating ? \'pace\' : \'\'\" ng-init=\"createAttributeIssue.fnInitCreateIssue()\"><div class=\"modal-body height-100\" id=\"modal-body\" style=\"overflow: hidden\"><div class=\"row h-100 overflow-auto\"><div class=\"col-sm-12 p-0\" ng-if=\"!createAttributeIssue.isProjectLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex height-max-content\" ng-if=\"createAttributeIssue.isProjectLoaded\"><div class=\"p-0 issueSideAnimation\" ng-class=\"createAttributeIssue.isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class\'\"><div class=\"col-sm-12 m-t-10\" id=\"newIssueTitle\"><div class=\"col-sm-2 p-0 m-t-0 m-b-20 customDropdown floatingLabelInput\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary p-b-5 issue-project-dropdown-menu\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createAttributeIssue.selectedProject.name}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown p-b-0\" style=\"max-height: none;\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.issueProjectSearch[createAttributeIssue.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createAttributeIssue.filterProject=(createAttributeIssue.projectsArr | filter:createAttributeIssue.issueProjectSearch) track by $index\" ng-click=\"createAttributeIssue.fnChangeProject(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createAttributeIssue.selectedProject.id\"></i></span><div class=\"d-flex flex-column\"><span>{{projectObj.name}}</span> <span class=\"font-italic\">({{projectObj.id}})</span></div></a></li><li ng-if=\"!createAttributeIssue.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"col-sm-10 p-r-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"createAttributeIssue.newIssueObj.name\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 m-t-0 m-b-20 customDropdown\" id=\"typeListDropdown\"><app-spinner ng-if=\"!createAttributeIssue.isIssueTypeLoaded\" spinner-type=\"\'microSpinner\'\"></app-spinner><div class=\"btn-group col-sm-12 p-0\" ng-if=\"createAttributeIssue.isIssueTypeLoaded\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createAttributeIssue.selectedType.name}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span> <span style=\"position: absolute;right: 25px;\" ng-if=\"createAttributeIssue.selectedType && createAttributeIssue.selectedType.id && createAttributeIssue.selectedType.id !== \'noType\'\">({{createAttributeIssue.selectedType.id}})</span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"typeObj in createAttributeIssue.typesArr\"><a ng-click=\"createAttributeIssue.fnSelectType(typeObj)\"><span>{{typeObj.name}}</span><br><span class=\"font-italic\" ng-if=\"typeObj.id !== \'noType\'\">({{typeObj.id}})</span></a></li></ul></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"!createAttributeIssue.isTypeDetailsLoaded\"><app-spinner class=\"\" spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex m-t-20 typeFormInputAction\" ng-if=\"createAttributeIssue.isIssueTypeLoaded && createAttributeIssue.selectedType && createAttributeIssue.isTypeDetailsLoaded && createAttributeIssue.selectedType.id !== \'noType\' && createAttributeIssue.form.length\"><form role=\"form\" name=\"typeForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"createAttributeIssue.schema\" sf-form=\"createAttributeIssue.form\" sf-model=\"createAttributeIssue.model\"></form></div></div><div class=\"col-sm-12 floatingLabelInput\" id=\"issueMarkdownContainer\"><div class=\"m-b-20 createIssue hide-toolbar createIssueMarkdownEditor\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir-for-issue=\"\" placeholder=\"Type your message...\" upload-file=\"createAttributeIssue.uploadFiles(type, filedata)\" ng-model=\"createAttributeIssue.newIssueObj.summary\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'none\'}\" rows=\"10\">\n                            </textarea><div class=\"markdown-footer d-flex\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-8 p-0 d-flex\"><button class=\"btn btn-primary m-l-0 h-100\" ng-click=\"createAttributeIssue.fnHideShowEditorPreview(\'editor1\')\"><span class=\"fa fa-eye\"></span> Preview</button><div class=\"d-flex align-items-center m-l-20\"><div class=\"d-flex align-items-center m-r-20\" ng-if=\"createAttributeIssue.selectedAttributeObj.nodeId !== createAttributeIssue.selectedAttributeObj.ecuId\" ng-click=\"createAttributeIssue.fnOpenAttributeGraphModal()\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg><label class=\"m-0 p-l-5\"><strong>Graph</strong></label></div><div class=\"d-flex align-items-center\" ng-click=\"createAttributeIssue.fnOpenAttributeTelemetryModal()\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/telemetry.svg#telemetry\"></use></svg><label class=\"m-0 m-l-5\"><strong>Telemetry</strong></label></div><div class=\"d-flex align-items-center m-l-20\" ng-click=\"createAttributeIssue.fnOpenMetaInfoModal()\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/table-icon.svg#table-icon\"></use></svg><label class=\"m-0 m-l-5\"><strong>Metadata</strong></label></div></div></div><div class=\"col-sm-4 p-0\"><div class=\"d-flex justify-content-flex-end h-100\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"createAttributeIssue.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!createAttributeIssue.isIssueCreating && !createAttributeIssue.fileUploading && createAttributeIssue.permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary h-100\" ng-if=\"!createAttributeIssue.isIssueCreating && !createAttributeIssue.fileUploading\" ng-disabled=\"!createAttributeIssue.newIssueObj.name.length || !createAttributeIssue.newIssueObj.summary.length || !createAttributeIssue.selectedProject.id.length || createAttributeIssue.fnCheckIssueTypeValidation()\" ng-click=\"createAttributeIssue.fnCreateNewIssue(createAttributeIssue.newIssueObj)\">Submit</button><app-spinner class=\"m-r-5 m-t-4\" ng-if=\"createAttributeIssue.isIssueCreating || createAttributeIssue.fileUploading\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div><div class=\"p-0 issueSideAnimation\" ng-class=\"createAttributeIssue.isExpanded ? \'col-sm-3\': \'custom-class-sidebar\'\"><div class=\"issue-side-panel h-100 overflow-auto\"><div class=\"col-sm-12 p-0 overflow-auto expand-side-panel\"><div class=\"col-sm-12 p-0\" ng-if=\"createAttributeIssue.isExpanded\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignees</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.changeAssigneeView && createAttributeIssue.isIssueAssigneeLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createAttributeIssue.fnOpenChangeAssigneeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!createAttributeIssue.newIssueObj.assignees.length\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><div class=\"col-sm-12 p-0\"><span class=\"p-0 d-block p-b-5\" ng-if=\"createAttributeIssue.newIssueObj.assignees.length\" ng-repeat=\"assignee in createAttributeIssue.newIssueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createAttributeIssue.changeAssigneeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createAttributeIssue.fnOnToggleAssignee(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createAttributeIssue.newIssueObj.assignees.length > 1\">{{createAttributeIssue.newIssueObj.assignees[0].username + \' + \' + (createAttributeIssue.newIssueObj.assignees.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createAttributeIssue.newIssueObj.assignees.length === 1\">{{createAttributeIssue.newIssueObj.assignees[0].firstName + \' \'+ createAttributeIssue.newIssueObj.assignees[0].lastName}}</span> <span class=\"w100 text-left\" ng-if=\"!createAttributeIssue.newIssueObj.assignees.length\">No Assignees</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign to</label> <span ng-click=\"createAttributeIssue.fnCancelChangeAssignee()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.assigneeSearch[createAttributeIssue.filterAssignees]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"assigneeObj in createAttributeIssue.filterUsers=(createAttributeIssue.usersArr | filter:createAttributeIssue.assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnGetAssigneeInfo(assigneeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"assigneeObj.isCheck\"></i></span> <span class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" style=\"left: 0px;\" ng-src=\"{{assigneeObj.userAvatar}}\"></span> <span class=\"d-flex flex-column\"><span>{{assigneeObj.firstName + \" \"+ assigneeObj.lastName}}</span> <span class=\"font-italic gateway-id-menu-option\">({{assigneeObj.username}})</span></span></a></li><li ng-if=\"!createAttributeIssue.filterUsers.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnManageAssignees()\"><a><span>Manage Assignees</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createAttributeIssue.fnCancelChangeAssignee()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.changePriorityView && createAttributeIssue.isIssuePriorityLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createAttributeIssue.fnOpenChangePriorityView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createAttributeIssue.newIssueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createAttributeIssue.newIssueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createAttributeIssue.newIssueObj.issuePriority\" ng-style=\"createAttributeIssue.fnGetIssuesLabelColor(createAttributeIssue.newIssueObj.issuePriority.color)\"><span>{{createAttributeIssue.newIssueObj.issuePriority.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createAttributeIssue.changePriorityView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createAttributeIssue.fnOnTogglePriority(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createAttributeIssue.newIssueObj.issuePriority.name\">{{createAttributeIssue.newIssueObj.issuePriority.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createAttributeIssue.newIssueObj.issuePriority.name\">No Priority</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Priority</label> <span ng-click=\"createAttributeIssue.fnCancelChangePriority()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.prioritySearch[createAttributeIssue.priorityFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"Priority in createAttributeIssue.filterPriority=(createAttributeIssue.prioritiesArr | filter:createAttributeIssue.prioritySearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnGetPrioritiesInfo(Priority)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"Priority.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"Priority.color ? {\'background-color\' : Priority.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{Priority.name}}</span></a></li><li ng-if=\"!createAttributeIssue.filterPriority.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnManageProjectPriority()\"><a><span>Manage project priorities</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createAttributeIssue.fnCancelChangePriority()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.changeStateView && createAttributeIssue.isIssueStateLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createAttributeIssue.fnOpenChangeStateView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createAttributeIssue.changeStateView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createAttributeIssue.newIssueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createAttributeIssue.newIssueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createAttributeIssue.newIssueObj.issueState\" ng-style=\"createAttributeIssue.fnGetIssuesLabelColor(createAttributeIssue.newIssueObj.issueState.color)\"><span>{{createAttributeIssue.newIssueObj.issueState.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createAttributeIssue.changeStateView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createAttributeIssue.fnOnToggleState(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createAttributeIssue.newIssueObj.issueState.name\">{{createAttributeIssue.newIssueObj.issueState.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createAttributeIssue.newIssueObj.issueState.name\">No State</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign State</label> <span ng-click=\"createAttributeIssue.fnCancelChangeState()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.stateSearch[createAttributeIssue.stateFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"state in createAttributeIssue.filterState=(createAttributeIssue.statesArr | filter:createAttributeIssue.stateSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnGetStatesInfo(state)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"state.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"state.color ? {\'background-color\' : state.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{state.name}}</span></a></li><li ng-if=\"!createAttributeIssue.filterState.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnManageProjectState()\"><a><span>Manage project state</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createAttributeIssue.fnCancelChangeState()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.addLabelView && createAttributeIssue.isIssueLablesLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createAttributeIssue.fnOpenAddLabelView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createAttributeIssue.newIssueObj.issueLabels.length\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in createAttributeIssue.assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5\" ng-style=\"createAttributeIssue.fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createAttributeIssue.addLabelView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createAttributeIssue.fnOnToggle(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createAttributeIssue.assigneesLabels.length > 1\">{{createAttributeIssue.assigneesLabels[0].name + \' + \' + (createAttributeIssue.assigneesLabels.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createAttributeIssue.assigneesLabels.length === 1\">{{createAttributeIssue.assigneesLabels[0].name}}</span> <span class=\"w100 text-left\" ng-if=\"!createAttributeIssue.assigneesLabels.length\">No Labels</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign labels</label> <span ng-click=\"createAttributeIssue.fnCancelAddLabelView()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.labelSearch[createAttributeIssue.filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"labelObj in createAttributeIssue.filterLabels=(createAttributeIssue.labelsArr | filter:createAttributeIssue.labelSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnGetLabelInfo(labelObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"labelObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"labelObj.color ? {\'background-color\' : labelObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{labelObj.name}}</span></a></li><li ng-if=\"!createAttributeIssue.filterLabels.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnManageProjectLabels()\"><a><span>Manage project labels</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createAttributeIssue.fnCancelAddLabelView()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PARTICIPANTS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.changeParticipantView && createAttributeIssue.isIssueParticipantLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createAttributeIssue.fnOpenChangeParticipantView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createAttributeIssue.newIssueObj.participants.length\"><div class=\"grayItalicValue\">No Participants</div></div><span class=\"p-0 d-block m-r-5 m-b-5 p-2\" ng-if=\"createAttributeIssue.newIssueObj.participants.length\" ng-repeat=\"participant in createAttributeIssue.newIssueObj.participants\"><span class=\"border-1-assignee p-2\">{{participant}}</span></span></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createAttributeIssue.changeParticipantView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createAttributeIssue.fnOnToggleParticipant(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createAttributeIssue.assigneesParticipants.length > 1\">{{createAttributeIssue.assigneesParticipants[0].email + \' + \' + (createAttributeIssue.assigneesParticipants.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createAttributeIssue.assigneesParticipants.length === 1\">{{createAttributeIssue.assigneesParticipants[0].email}}</span> <span class=\"w100 text-left\" ng-if=\"!createAttributeIssue.assigneesParticipants.length\">No Participants</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Participants</label> <span ng-click=\"createAttributeIssue.fnCancelChangeParticipant()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createAttributeIssue.participantSearch[createAttributeIssue.participantFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"participantObj in createAttributeIssue.filterParticipants=(createAttributeIssue.participantUsersArr | filter:createAttributeIssue.participantSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnGetParticipantInfo(participantObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"participantObj.isCheck\"></i></span> <span>{{participantObj.email}}</span></a></li><li ng-if=\"!createAttributeIssue.filterParticipants.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createAttributeIssue.fnAddNewParticipant()\"><a><span>Add new participant</span></a></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createAttributeIssue.changeConfidentialView\"><i class=\"fa fa-edit fa-lg\" ng-click=\"createAttributeIssue.fnOpenChangeConfidentialView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createAttributeIssue.changeConfidentialView\"><span ng-if=\"!createAttributeIssue.newIssueObj.confidential\">Not</span> Confidential</div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"createAttributeIssue.changeConfidentialView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintConfidential\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"confidential as confidential.name for confidential in createAttributeIssue.confidentialsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedConfidential.confidential\" placeholder=\"Confidential for the Issue\"> <span class=\"highlight\"></span> <label>Select Confidential</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"createAttributeIssue.isConfidentialChanged\" ng-disabled=\"!createAttributeIssue.fnCheckEmpty(selectedConfidential.confidential.name)\" ng-click=\"createAttributeIssue.fnChangeIssueConfidential(selectedConfidential.confidential)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"createAttributeIssue.isConfidentialChanged\" ng-click=\"createAttributeIssue.fnCancelChangeConfidential()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!createAttributeIssue.isConfidentialChanged\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createAttributeIssue.isExpanded\"><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.fnGetAssigneesTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.newIssueObj.issuePriority.name ? createAttributeIssue.newIssueObj.issuePriority.name: \'No Priority\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.newIssueObj.issueState.name ? createAttributeIssue.newIssueObj.issueState.name: \'No State\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.fnGetLabelsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.fnGetParticipantsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createAttributeIssue.newIssueObj.confidential ? \'Confidential\' : \'Not Confidential\'}}\" tooltip-placement=\"left\"><svg ng-if=\"createAttributeIssue.newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/confidential.svg#confidential\"></use></svg><svg ng-if=\"!createAttributeIssue.newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/notConfidential.svg#notConfidential\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 d-flex issue-side-panel-expand-btn\"><button class=\"btn btn-primary d-flex align-items-center justify-content-center w100\" ng-click=\"createAttributeIssue.fnExpandCollapseSideBar()\"><i class=\"fa\" ng-class=\"createAttributeIssue.isExpanded ? \'fa-angle-double-right\':\'fa-angle-double-left\'\"></i></button></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"labelColor.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.name\"></span> <span class=\"pull-right m-t-5\" style=\"width: 15px; height: 15px; display: inline-block\" ng-style=\"match.model.color ? {\'background-color\' : match.model.color} : {\'background-color\' : \'inherit\'}\"></span> </a></script><script type=\"text/ng-template\" id=\"assigneeUser.html\"><a> <span class=\"d-flex align-items-center\"> <span class=\"m-r-5\"> <img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{match.model.userAvatar}}\"> </span> <span> <span style=\"display: block;\"> {{match.model.firstName + \" \"+ match.model.lastName}} </span> <span class=\"font-italic gateway-id-menu-option\">({{match.model.username}})</span> </span> </span> </a></script><script type=\"text/ng-template\" id=\"UserNameTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-if=\"match.model.company && match.model.company !==\'\'\"> {{match.model.firstName + \" \"+match.model.lastName + \" \"+\"(\"+match.model.company+\")\"}} </span> <span ng-if=\"!match.model.company || match.model.company ===\'\'\"> {{match.model.firstName + \" \"+match.model.lastName}} </span> </div> <br> </div> </a></script>");
$templateCache.put("app/components/directives/ghostVisualizers/ghostVisualizers.html","<div id=\"ghostVisualizers\"><div class=\"node-menu-container\"><ul><li class=\"dropdown\"><a title=\"Border color\" ng-click=\"$event.stopImmediatePropagation()\"><i ng-class=\"{\'fa fa-lg fa-sticky-note-o\':selectedNode.id.includes(\'rect\'),\'fa fa-lg fa-circle-thin\':selectedNode.id.includes(\'circle\')}\"></i></a><div class=\"dropdown-content\"><div><div class=\"minicolors minicolors-theme-bootstrap minicolors-position-bottom minicolors-position-right minicolors-inline\"><input minicolors=\"{position: \'bottom right\',inline: true}\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" type=\"text\" ng-model=\"selectedNode.borderColor\" class=\"ng-pristine ng-untouched ng-valid ng-empty minicolors-input\" size=\"7\" aria-invalid=\"false\"><div class=\"minicolors-panel minicolors-slider-hue\"><div class=\"minicolors-slider minicolors-sprite\"><div class=\"minicolors-picker\" style=\"top: 0px;\"></div></div><div class=\"minicolors-opacity-slider minicolors-sprite\"><div class=\"minicolors-picker\"></div></div><div class=\"minicolors-grid minicolors-sprite\" style=\"background-color: rgb(255, 0, 0);\"><div class=\"minicolors-grid-inner\"></div><div class=\"minicolors-picker\" style=\"top: 150px; left: 0px;\"><div></div></div></div></div></div></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-b-10 p-0\"><input class=\"md-form-control m-t-0\" type=\"text\" ng-model=\"selectedNode.borderColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-0\"><div class=\"col-sm-4 p-0\">Opacity :</div><div class=\"col-sm-4 col-sm-offset-1 p-0\"><input class=\"md-form-control m-t-0\" type=\"number\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"selectedNode.borderOpacity\"></div></div><div class=\"p-t-15 p-b-10\"><div class=\"row text-center\"><div class=\"col-sm-2 p-0\">0</div><div class=\"col-sm-8 p-0\"><input type=\"range\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"selectedNode.borderOpacity\" class=\"slider-color ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\" aria-valuemin=\"0\" aria-valuemax=\"1\"></div><div class=\"col-sm-2 p-0\">1</div></div></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-0\"><div class=\"col-sm-4 p-0\">Thickness :</div><div class=\"col-sm-4 col-sm-offset-1 p-0\"><input class=\"md-form-control m-t-0\" type=\"number\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" step=\"1\" min=\"0\" max=\"10\" ng-model=\"selectedNode.borderWidth\"></div></div><div class=\"p-t-15\"><div class=\"row text-center\"><div class=\"col-sm-2 p-0\">0</div><div class=\"col-sm-8 p-0\"><input type=\"range\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" step=\"1\" min=\"1\" max=\"10\" ng-model=\"selectedNode.borderWidth\" class=\"slider-color ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\" aria-valuemin=\"1\" aria-valuemax=\"10\"></div><div class=\"col-sm-2 p-0\">10</div></div></div></div></li><li class=\"dropdown\"><a title=\"Background color\" ng-click=\"$event.stopImmediatePropagation()\"><i ng-class=\"{\'fa fa-lg fa-sticky-note\':selectedNode.id.includes(\'rect\'),\'fa fa-lg fa-circle\':selectedNode.id.includes(\'circle\')}\"></i></a><div class=\"dropdown-content\"><div class=\"p-b-10\"><div class=\"minicolors minicolors-theme-bootstrap minicolors-position-bottom minicolors-position-right minicolors-inline\"><input minicolors=\"{position: \'bottom right\',inline: true}\" ng-click=\"$event.stopImmediatePropagation()\" ng-change=\"fnReDrawSelected()\" type=\"text\" ng-model=\"selectedNode.bgColor\" class=\"ng-pristine ng-untouched ng-valid ng-empty minicolors-input\" size=\"7\" aria-invalid=\"false\"><div class=\"minicolors-panel minicolors-slider-hue\"><div class=\"minicolors-slider minicolors-sprite\"><div class=\"minicolors-picker\" style=\"top: 0px;\"></div></div><div class=\"minicolors-opacity-slider minicolors-sprite\"><div class=\"minicolors-picker\"></div></div><div class=\"minicolors-grid minicolors-sprite\" style=\"background-color: rgb(255, 0, 0);\"><div class=\"minicolors-grid-inner\"></div><div class=\"minicolors-picker\" style=\"top: 150px; left: 0px;\"><div></div></div></div></div></div></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-b-10 p-0\"><input class=\"md-form-control m-t-0\" type=\"text\" ng-model=\"selectedNode.borderColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-0\"><div class=\"col-sm-4 p-0\">Opacity :</div><div class=\"col-sm-4 col-sm-offset-1 p-0\"><input class=\"md-form-control m-t-0\" type=\"number\" ng-change=\"fnReDrawSelected()\" ng-click=\"$event.stopImmediatePropagation()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"selectedNode.bgOpacity\"></div></div><div class=\"p-t-15\"><div class=\"row text-center\"><div class=\"col-sm-2 p-0\">0</div><div class=\"col-sm-8 p-0\"><input type=\"range\" ng-click=\"$event.stopImmediatePropagation()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"selectedNode.bgOpacity\" ng-change=\"fnReDrawSelected()\" class=\"slider-color ng-pristine ng-untouched ng-valid ng-empty\" aria-invalid=\"false\" aria-valuemin=\"0\" aria-valuemax=\"1\"></div><div class=\"col-sm-2 p-0\">1</div></div></div></div></li><li ng-if=\"selectedNode.id.includes(\'circle\')\"><a title=\"line type\" ng-click=\"fnReDrawSelected(true)\"><i class=\"fa fa-lg fa-rotate-90\" ng-class=\"selectedNode.linkType !== \'straight\'? \'fa-long-arrow-up\':\'fa-level-up\'\"></i></a></li><li><a title=\"Delete\" ng-click=\"fnDeleteNode()\"><i class=\"fa fa-lg fa-trash-o\"></i></a></li></ul></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/cluster/createCluster/createCluster.html","<div class=\"h-100\" ng-controller=\"createClusterCtrl as createCluster\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createCluster.title}}</h3><button ng-if=\"clusters.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"clusters.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewClusterForm\" role=\"form\" name=\"createNewClusterForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createCluster.newClusterObj.name\" placeholder=\"New name for the Cluster*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createCluster.newClusterObj.description\" placeholder=\"Description regarding Cluster\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form><div class=\"col-sm-12 p-0\" ng-if=\"clusters.permissionObj.AddDevice\"><button class=\"btn btn-link p-l-0\" ng-click=\"createCluster.fnOpenDeviceModal()\">Select Devices</button></div><div class=\"col-sm-12 p-0\" ng-if=\"createCluster.devicesArr.length\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedDevice in createCluster.devicesArr\" is-open=\"selectedDevice.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedDevice.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); createCluster.fnRemoveDeviceFromSelected(selectedDevice)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedDevice.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedDevice.description}}</div></div></uib-accordion-group></uib-accordion></div><div class=\"col-sm-12 p-0\" ng-if=\"clusters.permissionObj.AddGateway\"><button class=\"btn btn-link p-l-0\" ng-click=\"createCluster.fnOpenGatewayModel()\">Select Gateways</button></div><div class=\"col-sm-12 p-0\" ng-if=\"createCluster.gatewaysArr.length\"><uib-accordion><uib-accordion-group ng-repeat=\"selectedGateway in createCluster.gatewaysArr\" is-open=\"selectedGateway.open\"><uib-accordion-heading><div>{{$index + 1}}. {{selectedGateway.name}} <i class=\"fa fa-times pull-right\" ng-click=\"$event.preventDefault(); createCluster.fnRemoveGatewayFromSelected(selectedGateway)\"></i></div></uib-accordion-heading><div class=\"row\" ng-if=\"selectedGateway.description\"><div class=\"col-xs-2\"><label>Description:</label></div><div class=\"col-xs-10\">{{selectedGateway.description}}</div></div></uib-accordion-group></uib-accordion></div><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createCluster.newClusterObj.name.length\" ng-click=\"createCluster.fnCreateNewCluster(createCluster.newClusterObj)\" ng-if=\"!createCluster.isClusterCreating\">Create Cluster</button></div><div class=\"col-sm-12\" ng-if=\"createCluster.isClusterCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/device/createDevice/createDevice.html","<div ng-controller=\"createDeviceCtrl as createDevice\" ng-init=\"createDevice.fnInitCreateDevice()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createDevice.title}}</h3><button ng-if=\"devices.devicePermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"devices.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body create-device-modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createDevice.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab\"><i class=\"fa fa-bars\"></i></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createDevice.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab\"><i class=\"fa fa-microchip\"></i></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createDevice.activeStep === 3}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step3\" role=\"tab\" title=\"Observer\"><span class=\"round-tab\"><i class=\"fa fa-binoculars\"></i></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createDevice.activeStep === 4}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"complete\" role=\"tab\" title=\"Device Information\"><span class=\"round-tab\"><i class=\"fa fa-edit\"></i></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createDevice.activeStep === 5}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"complete\" role=\"tab\" title=\"Review Tab\"><span class=\"round-tab d-flex justify-content-center\"><svg viewbox=\"0 0 510 510\" width=\"25px\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\"></path></g></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createDevice.activeStep === 1}\" role=\"tabpanel\" id=\"step1\"><div class=\"col-sm-12\" ng-if=\"!createDevice.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 searchDiv floatingLabelInput\" ng-if=\"createDevice.isBluePrintFetched && !createDevice.isBluePrintSelected\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-10 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"createDevice.search\" placeholder=\"Search\" ng-change=\"createDevice.fnTypesFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0\"><label>Connect Device Type:</label></div><div class=\"col-sm-6 p-0 text-right\"><button class=\"btn btn-link p-0\" uib-tooltip=\"Please select the type of device you would like to connect to.\" tooltip-placement=\"left\"><i class=\"fa fa-info-circle\"></i></button></div></div></div><div id=\"functionModal\" class=\"col-sm-12 m-t-10 p-0\" ng-if=\"createDevice.isBluePrintFetched && !createDevice.isBluePrintSelected\"><div class=\"col-sm-12 h-100\" ng-if=\"createDevice.isTypesFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 deviceModelDiv\" style=\"overflow-y: auto;\"><div class=\"col-sm-6\" ng-if=\"!createDevice.isTypesFilter\" ng-repeat=\"(key, value) in createDevice.uniqueBluePrintObj\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{value.typeName}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{value.typeName}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!value.isGatewayDataLoad\" ng-click=\"createDevice.fnBluePrintSelected(value.selectedTypeVersionObj, value)\">Connect</button><div ng-if=\"value.isGatewayDataLoad\"><div class=\"text-center\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><small class=\"font-italic ellipsis\">OEM: {{value.selectedTypeVersionObj.oem}}</small><br><small class=\"font-italic ellipsis\">Model: {{value.selectedTypeVersionObj.model}}</small></div><div class=\"dropdown\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Version {{value.selectedTypeVersionObj.version}} <i class=\"fa fa-caret-down m-l-2\"></i></label> <label class=\"pull-right\">({{value.selectedTypeVersionObj.id}})</label></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"valueObj in value.typeValue\"><a class=\"btn btn-link\" ng-click=\"value.selectedTypeVersionObj = valueObj\">{{valueObj.version}}</a></li><li><a class=\"btn btn-link font-italic grayItalicValue m-t-0\" ng-click=\"createDevice.fnOpenVersionSupportModel()\">Don\'t see your version ?</a></li></ul></div></div></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createDevice.activeStep === 2}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12 p-0\" ng-if=\"createDevice.gatwayPermissionObj.List\"><div class=\"col-sm-12\" ng-if=\"!createDevice.isGatewayLoaded\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"createDevice.isGatewayLoaded && !createDevice.isGatewaySelected\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-10 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"createDevice.gatewaySearch\" placeholder=\"Search\" ng-change=\"createDevice.fnGatewaysFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0\"><label>Connect Gateway:</label></div><div class=\"col-sm-6 p-0 text-right\"><button class=\"btn btn-link p-0\" uib-tooltip=\"Please select the gateway that the device is connected to.\" tooltip-placement=\"left\"><i class=\"fa fa-info-circle\"></i></button></div></div></div><div class=\"col-sm-12 m-t-0 p-0\" ng-attr-id=\"{{ createDevice.gatwayPermissionObj.List ?\'functionModal\':\'\' }}\" ng-if=\"createDevice.isGatewayLoaded\"><div class=\"col-sm-12 h-100\" ng-if=\"createDevice.isGatewaysFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 m-t-10 deviceModelDiv\" style=\"overflow-y: auto;\"><div class=\"col-sm-6\" ng-if=\"!createDevice.isGatewaysFilter\" ng-repeat=\"value in createDevice.gatewaysArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{value.name}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{value.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!value.isGatewayDataLoad\" ng-click=\"createDevice.fnGatewaySelected(value, value)\">Connect</button><div ng-if=\"value.isGatewayDataLoad\"><div class=\"text-center\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 pull-left\"><span class=\"ellipsis\">{{value.description}}</span></div><div class=\"col-sm-6 p-0 pull-right text-right\"><span class=\"fa p-r-5\" uib-tooltip=\"{{value.connection}}\" tooltip-placement=\"top\" ng-style=\"createDevice.fnGetConnectionIconColor(value.connection)\" ng-class=\"createDevice.fnGetConnectionIcon(value.connection)\"></span> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"value.health\" style=\"max-width:79%\" ng-style=\"createDevice.fnGetHealthColor(value.health, value)\"><span class=\"healtSpan\">{{value.healthName}}</span></button></div></div></div></div></div></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"!createDevice.gatwayPermissionObj.List\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"gatewayId\" type=\"text\" ng-change=\"createDevice.newDeviceObj.gatewayId.length ? createDevice.isGatewaySelected = true : createDevice.isGatewaySelected = false\" ng-model=\"createDevice.newDeviceObj.gatewayId\" placeholder=\"Gateway ID for the Device*\"> <span class=\"highlight\"></span> <label>Gateway ID*</label> <small class=\"helper-text\"></small></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createDevice.activeStep === 3}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\" ng-if=\"createDevice.activeStep === 3\" ng-init=\"createDevice.fnInitObserverTab()\"><div class=\"col-sm-12 p-0 m-t-20 d-flex align-items-center justify-content-center\"><h2 class=\"m-0 p-b-5\">Observer Configuration</h2></div><div class=\"col-sm-12 p-0\" ng-if=\"createDevice.observerPermissionObj.List\"><div class=\"col-sm-12 p-0\" ng-if=\"!createDevice.isObserversFetched\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><label class=\"font-italic m-0 p-b-5\">One moment while we find matching observer for the intended device.</label></div><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"createDevice.isObserversFetched\"><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center align-items-center\" ng-if=\"createDevice.isObserverFound\"><label class=\"font-italic m-0 p-b-5\">You already have an observer configured for this device</label></div><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center align-items-center\" ng-if=\"createDevice.isObserverFound\"><button class=\"btn btn-primary\" ng-click=\"createDevice.fnObserverConfigurationDone()\">Next</button></div><div class=\"col-sm-12 p-0\" ng-if=\"createDevice.observerPermissionObj.Create\"><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!createDevice.isObserverFound && createDevice.isObserverFoundFromBluePrint\"><label class=\"font-italic m-0 p-b-5\" ng-if=\"createDevice.isObserverCreating\">You don\'t appear to have an observer configured for this device. Would you like us to create one for you based on the {{createDevice.uniqueSelectedBluePrintObj.oem}} recommendations?</label> <label class=\"font-italic m-0 p-b-5\" ng-if=\"!createDevice.isObserverCreating\">One moment while we are create your observer.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 d-flex justify-content-center align-items-center\" ng-if=\"!createDevice.isObserverFound && createDevice.isObserverFoundFromBluePrint\"><button class=\"btn btn-primary m-r-10\" ng-if=\"createDevice.isObserverCreating\" ng-click=\"createDevice.fnCreateObserver(true)\">Yes</button> <button class=\"btn btn-primary\" ng-if=\"createDevice.isObserverCreating\" ng-click=\"createDevice.fnCreateObserver(false)\">No</button><div ng-if=\"!createDevice.isObserverCreating\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Please wait...\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!createDevice.isObserverFound && !createDevice.isObserverFoundFromBluePrint\"><label class=\"font-italic m-0 p-b-5\">We are sorry but we don\'t appear to have found any observer blueprints matching your device. Please contact your account manager. In the mean time you can create one manually.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!createDevice.isObserverFound && !createDevice.isObserverFoundFromBluePrint\"><button class=\"btn btn-primary\" ng-click=\"createDevice.fnObserverConfigurationDone()\">Next</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createDevice.observerPermissionObj.Create\"><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\"><label class=\"font-italic m-0 p-b-5\">You don\'t have necessary privileges to configure observer.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\"><button class=\"btn btn-primary\" ng-click=\"createDevice.fnObserverConfigurationDone()\">Next</button></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createDevice.observerPermissionObj.List\"><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center align-items-center\"><label class=\"font-italic m-0 p-b-5\">You don\'t have necessary privileges to configure observer.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\"><button class=\"btn btn-primary\" ng-click=\"createDevice.fnObserverConfigurationDone()\">Next</button></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createDevice.activeStep === 4}\" role=\"tabpanel\" id=\"complete\"><div class=\"col-sm-12\" ng-if=\"createDevice.isBluePrintFetched && createDevice.isBluePrintSelected\"><div ng-show=\"createDevice.isBluePrintFetched && createDevice.isBluePrintSelected && createDevice.isGatewaySelected\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><form id=\"createNewDeviceInfoForm\" role=\"form\" name=\"createNewDeviceInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createDevice.newDeviceObj.name\" placeholder=\"Name for the new Device*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createDevice.newDeviceObj.description\" placeholder=\"Description regarding Device\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form><schema-directive type-arr=\"createDevice.typePropertiesArr\" fn-check-type-validion=\"createDevice.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive></div></div><div class=\"col-sm-12 p-0 m-t-5 m-b-5\" ng-if=\"createDevice.isBluePrintFetched && createDevice.isBluePrintSelected && createDevice.isGatewaySelected\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-disabled=\"!createDevice.newDeviceObj.name.length || !createDevice.isTypeformValidated\" ng-click=\"createDevice.fnGotoReviewTab()\" value=\"Next\"></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createDevice.activeStep === 5}\" role=\"tabpanel\"><div class=\"col-sm-6 col-sm-offset-3\"><div class=\"col-sm-12 p-0 m-b-20\" id=\"deviceFunctionalModel\"><div class=\"col-sm-12 p-l-0 p-r-0\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex\"><div class=\"col-sm-10 p-0\"><h3 class=\"m-t-3 m-b-3\"><span class=\"p-b-5 ellipsis\">{{createDevice.uniqueSelectedGatewayObj.name}}</span> <small class=\"ng-binding p-b-5 ellipsis font-italic\" style=\"position: relative;top: -2px;\">{{createDevice.uniqueSelectedGatewayObj.description}}</small></h3></div><div class=\"col-sm-2 p-0\" style=\"display: flex;align-items: center;justify-content: flex-end;\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-link p-0\" uib-tooltip=\"Edit Gateway\" tooltip-placement=\"left\" ng-click=\"createDevice.fnGoToGatewayStep()\"><i class=\"fa fa-pencil edit-icon-20px\"></i></button></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0\" ng-if=\"!createDevice.isGatewayDeviceLoading && createDevice.devicePieCount[0].y !== 0\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><strong>Connected Device</strong></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" style=\"min-height: 83%;font-size: 30px;\"><i class=\"fa fa-sitemap m-r-5\"></i> {{createDevice.devicePieCount[0].y}}</div></div><div class=\"col-sm-6 p-0\" ng-if=\"createDevice.showGatewayCapacityPie\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><strong>Gateway Capacity</strong></div><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><pie-chart ng-if=\"createDevice.showGatewayCapacityPie\" chart-class=\"gatewayCapacityPieCountsChart\" chart-data=\"createDevice.gatewayCapacityPieCount\" show-only-point=\"true\"></pie-chart></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 p-b-5\"><small class=\"font-italic ellipsis\">OEM: {{createDevice.uniqueSelectedGatewayObj.oem}}</small><br><small class=\"font-italic ellipsis\">Model: {{createDevice.uniqueSelectedGatewayObj.model}}</small></div><div class=\"col-sm-6 p-0 m-b-5\"><div class=\"col-sm-12 p-0\"><a class=\"btn btn-link p-0 ellipsis\" style=\"text-align: left\">Version {{createDevice.uniqueSelectedGatewayObj.version}}</a></div><div class=\"col-sm-12 p-0 font-italic\"><a class=\"btn btn-link p-0 ellipsis\" style=\"text-align: left\"><small>({{createDevice.uniqueSelectedGatewayObj.id}})</small></a></div></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" style=\"height: 100px;\"><span class=\"link-border\" style=\"height: 93%;width: 3px;position: relative;top: -4px;\"></span> <span class=\"link-arrow\"></span></div><div class=\"col-sm-12 p-l-0 p-r-0\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex\"><div class=\"col-sm-10 p-0\" uib-tooltip=\"{{createDevice.newDeviceObj.name}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-3 m-b-3\"><span class=\"p-b-5 ellipsis\">{{createDevice.newDeviceObj.name}}</span> <small class=\"ng-binding p-b-5 ellipsis font-italic\" style=\"position: relative;top: -2px;\">{{createDevice.newDeviceObj.description}}</small></h3></div><div class=\"col-sm-2 p-0 d-flex align-items-center\" style=\"justify-content: flex-end;\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-link p-0\" uib-tooltip=\"Edit Device\" tooltip-placement=\"left\" ng-click=\"createDevice.activeStep = 4\"><i class=\"fa fa-pencil edit-icon-20px\"></i></button></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0 m-t-5\" ng-repeat=\"typeObj in createDevice.typePropertiesArr\"><div class=\"col-sm-4 p-0\"><span ng-if=\"typeObj.name === \'ip\'\">IP</span> <span ng-if=\"typeObj.name === \'vaultId\'\">Vault</span> <span ng-if=\"typeObj.name !== \'ip\' && typeObj.name !== \'vaultId\'\">{{createDevice.fnSetFiledLabel(typeObj.name)}}</span></div><div class=\"col-sm-8 p-0\">{{typeObj.typeValue}}</div></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><label>Type:</label> <button type=\"button\" class=\"btn btn-link p-0 pull-right\" uib-tooltip=\"Edit Type\" tooltip-placement=\"left\" ng-click=\"createDevice.fnGoToDeviceType()\"><i class=\"fa fa-pencil edit-icon-20px\"></i></button></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 p-b-5\"><small class=\"font-italic ellipsis\">OEM: {{createDevice.uniqueSelectedBluePrintObj.oem}}</small><br><small class=\"font-italic ellipsis\">Model: {{createDevice.uniqueSelectedBluePrintObj.model}}</small></div><div class=\"col-sm-6 p-0 m-b-5\"><div class=\"col-sm-12 p-0\"><a class=\"btn btn-link p-0 ellipsis\" style=\"text-align: left\">Version {{createDevice.uniqueSelectedBluePrintObj.version}}</a></div><div class=\"col-sm-12 p-0 font-italic\"><a class=\"btn btn-link p-0 ellipsis\" style=\"text-align: left\"><small>({{createDevice.uniqueSelectedBluePrintObj.id}})</small></a></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"createDevice.isBluePrintFetched && createDevice.isBluePrintSelected && createDevice.isGatewaySelected\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createDevice.isDeviceCreating\" ng-click=\"createDevice.fnCreateDevice(createDevice.newDeviceObj)\" ng-disabled=\"!createDevice.newDeviceObj.name.length || !createDevice.isTypeformValidated\" value=\"Create Device\"><div ng-if=\"createDevice.isDeviceCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"clearfix\"></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"TypeAheadTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.oem\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script><script type=\"text/ng-template\" id=\"TypeAheadGatewayTemplate1.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script></div>");
$templateCache.put("app/node/device/createDevice/createDeviceFromCSV.html","<div class=\"h-100\" ng-controller=\"createDeviceCtrl as createDevice\" ng-init=\"createDevice.fnInitCreateDevice()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createDevice.title}}</h3><button ng-if=\"devices.devicePermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"devices.fnHideShowCreateDeviceFromCSVForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createDevice.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div ng-if=\"createDevice.isBluePrintFetched\" class=\"col-sm-12 floatingLabelInput\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input roleActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint as bluePrint.name for bluePrint in createDevice.bluePrintArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeAheadTemplate.html\" ng-change=\"!createDevice.selectedBluePrint.length ? createDevice.isButtonVisible = false : \'\'\" typeahead-on-select=\"createDevice.fnBluePrintSelectedForCSV(createDevice.selectedBluePrint)\" ng-model=\"createDevice.selectedBluePrint\" placeholder=\"Type for the Device*\"> <span class=\"highlight\"></span> <label>Select a Type of category Device*</label> <span class=\"typeInfo\" ng-if=\"createDevice.selectedBluePrint\"><span class=\"m-r-50\">{{createDevice.selectedBluePrint.model}}</span><span class=\"m-r-50\">{{createDevice.selectedBluePrint.version}}</span><span>({{createDevice.selectedBluePrint.id}})</span></span> <small class=\"helper-text\">You can select a type of category device to download a sample template.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createDevice.isButtonVisible\"><button class=\"btn btn-primary pull-right\" ng-csv=\"createDevice.getCSVData()\" csv-header=\"createDevice.headerArray\" filename=\"test.csv\">Download Sample CSV</button></div><div class=\"col-sm-12 p-0 m-t-20 m-b-20 text-center\">or</div><div class=\"col-sm-12 p-0 text-center\"><span id=\"fileselector\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".csv\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"createDevice.fnCreateDeviceFromCSV()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Create Devices from CSV upload</a></span></span></div></div></div></div><script type=\"text/ng-template\" id=\"TypeAheadTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.oem\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script></div>");
$templateCache.put("app/node/device/devicesInfo/devicesInfo.html","<div class=\"h-100\" ng-if=\"!isOpenNativeInterface\"><div class=\"container-with-footer tab-container deviceInventoryTabSetView\" ng-show=\"!isComponentViewSelected\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs track by $index\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"container-with-footer tab-container\" ng-if=\"isComponentViewSelected\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedComponentTab\"><uib-tab index=\"componentTab.tabIndex\" ng-if=\"componentTab.visible === true\" ng-repeat=\"componentTab in componentTabs\" select=\"fnComponentTabSelected(componentTab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"componentTab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"componentSelectedTab === componentTab.tabIndex\" ng-include=\"componentTab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div ng-if=\"isOpenNativeInterface\" class=\"nativeConsoleBlock h-100\"><div class=\"container-with-footer nativeNmsLayout h-100\"><div class=\"content-main\"><div id=\"userDetailsContent\" class=\"h-100\" ng-init=\"fnInitDeviceTunnel()\"><div class=\"col-sm-12 p-0 divCenterPosition\" ng-if=\"!isDeviceDeviceTunnelLoaded\"><div class=\"p-20 text-center\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div><div class=\"col-sm-12 p-0 text-center\"><label>{{nmsLoadMessage}}</label><br><small>{{nmsInformationMessage}}</small></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"isDeviceDeviceTunnelLoaded\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"isFindError\"><div class=\"col-sm-12 h-100 create-screen text-center\"><div class=\"content h-100\"><div class=\"col-sm-12 p-0 divCenterPosition\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-exclamation-triangle\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12 fa-2x\"><label>{{errorMessage}}</label></div><div class=\"col-sm-12\"><label>You can:</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"fnCloseNativeConsole()\">Go Back To Devices</button></div><div class=\"col-sm-12 m-t-5 m-b-5\">or</div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"fnInitDeviceTunnel()\">Retry</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!isFindError && !isNativeLaunchNewTab\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!isSessionEnd && isSessionStart\"><iframe id=\"nativeIFrame\" name=\"myFrame\" class=\"nmsIframe\" sandbox=\"allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts\"></iframe></div><div class=\"col-sm-12 h-100 create-screen text-center\" ng-if=\"isSessionEnd && !isSessionStart\"><div class=\"content h-100\"><div class=\"col-sm-12 p-0 divCenterPosition\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-clock-o\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12 fa-2x\"><label>Your session has timed out</label></div><div class=\"col-sm-12\"><label>You can:</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"fnCloseNativeConsole()\">Go Back To Devices</button></div><div class=\"col-sm-12 m-t-5 m-b-5\">or</div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"fnInitDeviceTunnel()\">Renew Session</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!isFindError && isNativeLaunchNewTab\"><div class=\"col-sm-12 p-0 create-screen text-center\"><div class=\"content h-100\"><div class=\"col-sm-12 p-0 divCenterPosition\"><div class=\"col-sm-12\"><label>{{nmsLoadMessage}}</label><br><small>{{nmsInformationMessage}}</small></div><div class=\"col-sm-12 m-t-10\"><button class=\"btn btn-primary m-r-5\" ng-click=\"fnCloseNativeConsole()\">Cancel</button> <button class=\"btn btn-primary\" ng-click=\"fnConfirmAndOpenNewTab()\">Confirm and Open Tab</button></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100 nmsOverlayLayout\" ng-if=\"isDeviceDeviceTunnelLoaded && !isIframeLoaded && !isNativeLaunchNewTab\" style=\"display: block\"><div class=\"col-sm-12 p-30 modal-content divCenterPosition\"><div class=\"p-20 text-center\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div><div class=\"col-sm-12 p-0 text-center\"><label>{{nmsLoadMessage}}</label><br><small>{{nmsInformationMessage}}</small></div></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-4 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-4 text-center content-box-footerItem\">Native Console For {{deviceObj.name}}</div><div class=\"col-sm-4 m-t-2 m-b-0 content-box-footerItem\"><div class=\"pull-right\"><a class=\"btn btn-link p-r-0\" ng-click=\"fnCloseNativeConsole()\">Close Session</a></div><div class=\"p-0 m-r-100\" id=\"animationClock\" ng-if=\"isDeviceDeviceTunnelLoaded && !isSessionEnd && isSessionStart && !isFindError\"><div class=\"block\"><p class=\"digit\">{{minutes}} : {{seconds}}</p></div></div></div></div></div></div>");
$templateCache.put("app/node/device/modal/viewGhostAttributes.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><div class=\"col-sm-12 p-0\"><strong class=\"inline-display p-t-8\">Attribute Telemetry</strong></div></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0\" ng-init=\"viewGhostAttributes.fnInitModel()\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 m-t-10\" ng-if=\"!viewGhostAttributes.isComponentGhostDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isComponentGhostDetailsLoaded\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"viewGhostAttributes.selectedAnalyticsTabs\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in viewGhostAttributes.analyticsTabs\" select=\"viewGhostAttributes.fnChangeAnalyticsTabs(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent-1\" ng-if=\"viewGhostAttributes.selectedAnalyticsTabs === 1 && tab.tabIndex === 1\"><div class=\"col-sm-12 p-15\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" style=\"height: 80px;\"><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><h2 class=\"m-t-0 m-b-0 ellipsis\">{{viewGhostAttributes.deviceObj.name}}</h2></div><div class=\"col-sm-12 p-0\"><h4 class=\"m-t-0 m-b-0 font-italic ellipsis\">{{viewGhostAttributes.selectedInventoryObj.name}}</h4></div></div></div><div class=\"col-sm-6 p-0 text-right\"><div class=\"col-sm-12 p-0 d-flex aaa\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"viewGhostAttributes.componentReportedArr.length\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isPieChartLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.isPieChartLoading\"><div class=\"w100 d-flex align-items-center\" style=\"justify-content: flex-end;\"><pie-chart chart-class=\"telemetryPieChart\" chart-data=\"viewGhostAttributes.TelemetryPieData\" is-inventory-chart=\"true\"></pie-chart></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"componentGhost\"><div class=\"col-sm-6 m-t-10 p-l-0 p-r-0 text-right\"><div class=\"componentGhost-breadcrumb col-sm-12 p-0\"><ul class=\"dot-breadcrumb\" id=\"inventoryInfo\"><li class=\"breadcrumb-item clickDisable\"><i><span class=\"gateway-info-box bgColorForGateway-info-box componentGhost-gateway-icon-modal\" ng-style=\"viewGhostAttributes.fnGetGatewayConnectionIconColor(viewGhostAttributes.gatewayObj.connection)\"><span class=\"gateway-icon-modal fa\" ng-class=\"viewGhostAttributes.fnGetConnectionIcon(viewGhostAttributes.gatewayObj.connection)\" ng-style=\"viewGhostAttributes.fnGetConnectionIconColor(viewGhostAttributes.gatewayObj.connection)\"></span></span> <a class=\"p-r-10\" style=\"position: relative;left: 5px;\">{{viewGhostAttributes.gatewayObj.name}}</a></i></li><li class=\"breadcrumb-item clickDisable\"><i><span class=\"device-info-box bgColorForGateway-info-box componentGhost-device-icon-modal\" ng-style=\"viewGhostAttributes.fnGetGatewayConnectionIconColor(viewGhostAttributes.deviceObj.connection)\"><span class=\"p-5 m-l-4 m-t-2 device-icon-modal\" ng-class=\"viewGhostAttributes.deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></span></span> <a class=\"p-r-10 componentGhost-device-name-modal\">{{viewGhostAttributes.deviceObj.name}}</a></i></li><li class=\"breadcrumb-item\" ng-repeat=\"pathName in viewGhostAttributes.breadcrumbArray track by $index\" ng-class=\"!pathName.healthColor ?\'clickDisable\':\'\'\"><i ng-if=\"pathName.healthColor\"><i ng-class=\"!pathName.healthColor ?\'dummyInventories\':\'\'\" ng-style=\"{\'background-color\' : pathName.healthColor}\" uib-tooltip=\"{{pathName.inventorieObj.toolTipName}}\" tooltip-placement=\"bottom\"></i> <a ng-if=\"pathName.healthColor\">{{pathName.displayName}}</a> <a ng-if=\"!pathName.healthColor\">{{pathName.displayName}}</a></i> <i ng-if=\"!pathName.healthColor\"><i class=\"dummyInventories\"></i> <a>{{pathName.displayName}}</a></i></li></ul></div></div><div class=\"col-sm-6 m-t-10 p-0 text-right\"><div class=\"col-sm-12 p-0\" ng-class=\"viewGhostAttributes.isAggregateHealthLoading ? \'pace opacity-5\' : \'\'\"><span class=\"cursor-pointer p-r-5\" ng-repeat=\"filterOption in viewGhostAttributes.filterOptions track by $index\" ng-class=\"viewGhostAttributes.selectedFilterOption.tabIndex === filterOption.tabIndex ? \'overview-active-link\' : \'\'\" ng-click=\"viewGhostAttributes.fnChangeFilterOption(filterOption)\">{{filterOption.value}} <i ng-if=\"(viewGhostAttributes.filterOptions.length - 1) === $index\" class=\"m-l-3 fa fa-caret-down\"></i></span> <span ng-repeat=\"chartType in viewGhostAttributes.chartOptions track by $index\" ng-click=\"viewGhostAttributes.fnChangeChartType(chartType)\" ng-class=\"viewGhostAttributes.selectedChartType.tabIndex === chartType.tabIndex ? \'overview-active-link\' : \'\'\"><i class=\"cursor-pointer fa\" ng-class=\"$index === 0 ? \'m-l-5 m-r-5 \' + chartType.icon : chartType.icon\"></i></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.selectedChartType.tabIndex === 0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 210px;overflow: hidden\"><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isAggregateHealthLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!viewGhostAttributes.isAggregateHealthLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.aggregateHealthArr.length\"><heat-map-chart node-id=\"viewGhostAttributes.selectedInventoryObj.id\" info-section-class=\"viewGhostAttributes.infoSectionClass\" type=\"\'health\'\" filter-obj=\"viewGhostAttributes.selectedFilterObj\" is-aggregate-health=\"true\" comp-arr=\"[\'Component\']\" chart-data=\"viewGhostAttributes.aggregateHealthArr\" categories-arr=\"viewGhostAttributes.aggregateCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!viewGhostAttributes.aggregateHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.selectedChartType.tabIndex === 1\"><div class=\"col-sm-12 p-0\"><label>Component Health</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"viewGhostAttributes.isAggregateHealthLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.isAggregateHealthLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.componentHealthPieData.length\"><pie-chart node-id=\"viewGhostAttributes.selectedInventoryObj.id\" filter-obj=\"viewGhostAttributes.selectedFilterObj\" type=\"\'health\'\" chart-full-size=\"true\" is-show-label=\"true\" chart-class=\"componentPieMainContainer\" chart-data=\"viewGhostAttributes.componentHealthPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!viewGhostAttributes.componentHealthPieData.length\"><label>No results found for component health for the selected range.</label> <label>Please select another range.</label></div></div></div></div></div></div></div><div class=\"tabContent-1\" ng-if=\"viewGhostAttributes.selectedAnalyticsTabs === 2 && tab.tabIndex === 2\"><div class=\"col-sm-12 p-15\"><div class=\"col-sm-12 p-0 viewGhostSearchBar floatingLabelInput d-flex\"><div class=\"md-input m-b-20 m-t-15 w100\"><input required=\"\" class=\"md-form-control p-l-35\" ng-model=\"viewGhostAttributes.search[viewGhostAttributes.filter]\" placeholder=\"Search for telemetry\" type=\"text\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"m-l-6\" ng-if=\"viewGhostAttributes.componentReportedArr.length\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 23px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"viewGhostAttributes.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"viewGhostAttributes.getDeviceCSVData()\" id=\"csvAnchorGhost\" csv-header=\"viewGhostAttributes.csvHeaderArr\" filename=\"{{\'componentGhost_\' + viewGhostAttributes.selectedInventoryObj.id + \'.csv\'}}\"></a></li></ul></div></div></div><div class=\"viewGhostAttributesLayout-table table-container ghostAttributeNewUI\"><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.isAttributeAnalyticsDataFetch\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isAttributeAnalyticsDataFetch\"><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.componentReportedArr.length\"><div class=\"col-sm-12 p-0\" id=\"noGhostAttributeData\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><svg viewbox=\"0 0 512.00037 512\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"m248.953125 61.273438c-5.367187-1.238282-10.722656 2.101562-11.964844 7.46875-1.242187 5.367187 2.105469 10.726562 7.472657 11.96875 24.8125 5.734374 47.492187 18.332031 65.582031 36.421874 53.183593 53.183594 53.183593 139.726563 0 192.910157-53.183594 53.1875-139.726563 53.1875-192.910157 0-53.1875-53.183594-53.1875-139.726563 0-192.910157 15.269532-15.269531 33.339844-26.40625 53.710938-33.109374 5.230469-1.71875 8.078125-7.355469 6.359375-12.589844-1.722656-5.234375-7.363281-8.082032-12.59375-6.359375-23.367187 7.683593-44.085937 20.453125-61.582031 37.953125-60.964844 60.964844-60.964844 160.160156 0 221.125 30.480468 30.480468 70.519531 45.722656 110.5625 45.722656 40.039062-.003906 80.078125-15.242188 110.5625-45.722656 60.960937-60.964844 60.960937-160.160156 0-221.125-20.738282-20.734375-46.738282-35.175782-75.199219-41.753906zm0 0\"></path><path d=\"m498.414062 432.707031-104.53125-104.53125c53.601563-84.054687 41.863282-194.484375-29.265624-265.617187-40.339844-40.339844-93.976563-62.558594-151.027344-62.558594-57.054688 0-110.691406 22.21875-151.03125 62.558594-40.34375 40.339844-62.558594 93.976562-62.558594 151.03125 0 57.050781 22.214844 110.6875 62.558594 151.027344 40.339844 40.339843 93.972656 62.554687 151.023437 62.554687 40.945313 0 80.386719-11.484375 114.59375-33.289063l104.53125 104.53125c8.746094 8.75 20.414063 13.566407 32.855469 13.566407 12.4375 0 24.105469-4.816407 32.855469-13.566407 18.109375-18.117187 18.109375-47.589843-.003907-65.707031zm-14.105468 51.601563c-4.980469 4.976562-11.636719 7.71875-18.746094 7.71875-7.113281 0-13.769531-2.742188-18.75-7.71875l-110.304688-110.304688c-1.929687-1.933594-4.484374-2.921875-7.054687-2.921875-1.976563 0-3.960937.582031-5.683594 1.777344-32.410156 22.480469-70.515625 34.363281-110.1875 34.363281-51.722656 0-100.347656-20.140625-136.917969-56.710937-75.5-75.5-75.5-198.347657 0-273.847657 36.574219-36.574218 85.199219-56.714843 136.925782-56.714843 51.722656 0 100.347656 20.140625 136.921875 56.714843 66.28125 66.285157 75.683593 170.207032 22.347656 247.105469-2.75 3.964844-2.269531 9.324219 1.144531 12.738281l110.304688 110.304688c10.335937 10.335938 10.335937 27.15625 0 37.496094zm0 0\"></path><path d=\"m273.804688 153.371094c-3.894532-3.894532-10.207032-3.894532-14.105469 0l-46.109375 46.109375-46.113282-46.109375c-3.894531-3.894532-10.210937-3.894532-14.105468 0-3.894532 3.894531-3.894532 10.210937 0 14.105468l46.109375 46.113282-46.109375 46.109375c-3.894532 3.894531-3.894532 10.210937 0 14.105469 1.945312 1.949218 4.5 2.921874 7.050781 2.921874 2.554687 0 5.105469-.972656 7.054687-2.921874l46.109376-46.109376 46.109374 46.109376c1.949219 1.949218 4.503907 2.921874 7.054688 2.921874 2.554688 0 5.105469-.972656 7.054688-2.921874 3.894531-3.894532 3.894531-10.210938 0-14.105469l-46.113282-46.109375 46.113282-46.113282c3.894531-3.894531 3.894531-10.210937 0-14.105468zm0 0\"></path><path d=\"m206.976562 77.328125c5.492188 0 9.972657-4.480469 9.972657-9.976563 0-5.492187-4.480469-9.972656-9.972657-9.972656-5.496093 0-9.976562 4.480469-9.976562 9.972656 0 5.496094 4.480469 9.976563 9.976562 9.976563zm0 0\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">No records found...</h2></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.componentReportedArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.isGhostDetailsEditable\"><div class=\"col-sm-12 p-0\" ng-if=\"!viewGhostAttributes.isShowAllGhostAttributes\"><div class=\"col-sm-12 p-0\"><label>Unhealthy</label><table class=\"table table-striped table-check-box\" ng-show=\"viewGhostAttributes.unhealthyComponentReportedArr.length && viewGhostAttributes.isComponentGhostDetailsLoaded\"><thead><tr><th class=\"p-r-2 p-l-8\" ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length\">Name</th><th ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length\">Value</th><th ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.unhealthyComponentReportedArr.length && (viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify)\"></th><th ng-if=\"!viewGhostAttributes.unhealthyComponentReportedArr.length\">No unhealthy attributes found...</th></tr></thead><tbody id=\"unhealthyComponentReportedArr\"><tr ng-repeat=\"componentGhostObj in viewGhostAttributes.unhealthyComponentReportedArr | orderBy:\'health\' | filter: viewGhostAttributes.search track by $index\" context-menu=\"viewGhostAttributes.attributesContextMenu(componentGhostObj)\"><td class=\"p-r-2 p-l-8\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0 attributeLabel\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{componentGhostObj.name}}\" tooltip-placement=\"auto\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime attributeSpan\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'Unhealthy\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"viewGhostAttributes.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"viewGhostAttributes.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': viewGhostAttributes.isDropUp }\" ng-click=\"viewGhostAttributes.toggleDropUp(\'unhealthyComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"viewGhostAttributes.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify\" ng-click=\"viewGhostAttributes.fnCreateObserverCondition(componentGhostObj)\"><a class=\"btn btn-link\">Create Observer</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"viewGhostAttributes.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"viewGhostAttributes.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"viewGhostAttributes.issuePermissionsObj.List || viewGhostAttributes.issuePermissionsObj.Create\" ng-click=\"viewGhostAttributes.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!viewGhostAttributes.unhealthyComponentReportedArr.length\" id=\"unhealthyComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\" style=\"enable-background:new 0 0 426.667 426.667;\" xml:space=\"preserve\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your attributes are reporting unhealthy telemetry.</small></div></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><label>Recently Updated</label><table class=\"table table-striped table-check-box\" ng-show=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length && viewGhostAttributes.isComponentGhostDetailsLoaded\"><thead><tr><th class=\"p-r-2 p-l-8\" ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\">Name</th><th ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\">Value</th><th ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.recentlyUpdatedComponentReportedArr.length && (viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify)\"></th><th ng-if=\"!viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\">No recently updated attributes found...</th></tr></thead><tbody id=\"recentlyUpdatedComponentReportedArr\"><tr ng-repeat=\"componentGhostObj in viewGhostAttributes.recentlyUpdatedComponentReportedArr | orderBy:\'timestamp\':true | filter: viewGhostAttributes.search track by $index\" context-menu=\"viewGhostAttributes.attributesContextMenu(componentGhostObj)\"><td class=\"p-r-2 p-l-8\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0 attributeLabel\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{componentGhostObj.name}}\" tooltip-placement=\"auto\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime attributeSpan\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'RecentlyUpdated\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"viewGhostAttributes.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"viewGhostAttributes.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': viewGhostAttributes.isDropUp }\" ng-click=\"viewGhostAttributes.toggleDropUp(\'recentlyUpdatedComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"viewGhostAttributes.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify\" ng-click=\"viewGhostAttributes.fnCreateObserverCondition(componentGhostObj)\"><a class=\"btn btn-link\">Create Observer</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"viewGhostAttributes.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"viewGhostAttributes.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"viewGhostAttributes.issuePermissionsObj.List || viewGhostAttributes.issuePermissionsObj.Create\" ng-click=\"viewGhostAttributes.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!viewGhostAttributes.recentlyUpdatedComponentReportedArr.length\" id=\"recentlyUpdatedComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 383.189 383.189\" style=\"enable-background:new 0 0 383.189 383.189;\" xml:space=\"preserve\" class=\"reportedComponentFillColor\"><g><path d=\"M297.184,164.538c-1.4-1.12-3.173-1.663-4.96-1.52h-26.88l25.2-28.16l2.4-2.64l1.52-1.84 c0.429-0.592,0.778-1.237,1.04-1.92c0.303-0.737,0.466-1.523,0.48-2.32c0.201-1.867-0.706-3.68-2.32-4.64 c-2.103-0.966-4.409-1.406-6.72-1.28h-31.68c-1.669-0.093-3.317,0.418-4.64,1.44c-1.106,0.93-1.725,2.316-1.68,3.76 c0,2.133,0.72,3.467,2.16,4c2.082,0.577,4.242,0.82,6.4,0.72h20.48c-0.8,1.2-1.92,2.56-3.36,4.24l-5.28,5.92l-6.88,8l-8,9.12 c-2.88,3.2-4.773,5.387-5.68,6.56c-1.885,2.418-1.643,5.868,0.56,8c1.679,1.249,3.754,1.846,5.84,1.68h37.12 c1.774,0.142,3.538-0.37,4.96-1.44c1.058-0.959,1.642-2.333,1.6-3.76C298.901,166.969,298.288,165.538,297.184,164.538z\"></path></g><g><path d=\"M381.104,119.578c-1.74-1.39-3.939-2.075-6.16-1.92h-33.84l31.6-35.28l2.96-3.28l1.92-2.32 c0.528-0.742,0.958-1.549,1.28-2.4c0.363-0.917,0.552-1.894,0.56-2.88c0.223-2.333-0.933-4.583-2.96-5.76 c-2.629-1.206-5.512-1.755-8.4-1.6h-39.68c-2.096-0.143-4.172,0.483-5.84,1.76c-1.378,1.173-2.145,2.911-2.08,4.72 c0,2.72,0.907,4.373,2.72,4.96c2.6,0.739,5.299,1.063,8,0.96h25.6c-1.067,1.493-2.453,3.253-4.16,5.28l-6.64,7.52l-8.64,9.6 l-10.32,11.44c-3.573,4-5.92,6.667-7.04,8c-2.54,3.085-2.224,7.618,0.72,10.32c2.11,1.59,4.726,2.357,7.36,2.16h46.64 c2.258,0.284,4.541-0.287,6.4-1.6c1.359-1.187,2.121-2.916,2.08-4.72C383.253,122.659,382.492,120.845,381.104,119.578z\"></path></g><g><path d=\"M353.504,254.298c-2.279-2.359-5.767-3.089-8.8-1.84c-86.708,35.894-186.097-5.298-221.992-92.007 c-18.227-44.031-17.127-93.693,3.032-136.873c1.889-3.994,0.182-8.763-3.812-10.652c-2.05-0.97-4.416-1.023-6.508-0.148 C20.363,51.827-25.044,160.545,14.005,255.606s147.767,140.468,242.829,101.419c43.356-17.81,78.394-51.325,98.111-93.848 C356.332,260.203,355.761,256.682,353.504,254.298z M186.224,355.098c-93.977-0.016-170.147-76.212-170.131-170.189 c0.01-61.708,33.428-118.574,87.331-148.611c-6.383,18.946-9.626,38.808-9.6,58.8c0.005,102.813,83.356,186.156,186.169,186.151 c17.231-0.001,34.378-2.394,50.951-7.111C299.919,324.303,245.207,354.91,186.224,355.098z\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2>Wow this component is quiet!</h2></div></div></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn p-b-0 p-r-0 p-t-0 btn-link pull-right\" ng-click=\"viewGhostAttributes.fnShowAllGhostAttributes()\">See all attributes</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isShowAllGhostAttributes\"><table class=\"table table-striped table-check-box\" ng-show=\"viewGhostAttributes.isComponentGhostDetailsLoaded\"><thead><tr><th class=\"p-r-2 p-l-8\" ng-if=\"viewGhostAttributes.componentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.componentReportedArr.length\">Name</th><th ng-if=\"viewGhostAttributes.componentReportedArr.length\">Value</th><th ng-if=\"viewGhostAttributes.componentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.componentReportedArr.length\"></th><th ng-if=\"viewGhostAttributes.componentReportedArr.length && (viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify)\"></th><th ng-if=\"!viewGhostAttributes.componentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"allGhostAttributes\"><tr ng-repeat=\"componentGhostObj in viewGhostAttributes.componentReportedArr | filter: viewGhostAttributes.search track by $index\" context-menu=\"viewGhostAttributes.attributesContextMenu(componentGhostObj)\"><td class=\"p-r-2 p-l-8\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{componentGhostObj.name}}\" tooltip-placement=\"auto\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'All\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"viewGhostAttributes.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"viewGhostAttributes.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': viewGhostAttributes.isDropUp }\" ng-click=\"viewGhostAttributes.toggleDropUp(\'allGhostAttributes\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"viewGhostAttributes.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"viewGhostAttributes.observerPermissionsObj.Create || viewGhostAttributes.observerPermissionsObj.Modify\" ng-click=\"viewGhostAttributes.fnCreateObserverCondition(componentGhostObj)\"><a class=\"btn btn-link\">Create Observer</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"viewGhostAttributes.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"viewGhostAttributes.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"viewGhostAttributes.issuePermissionsObj.List || viewGhostAttributes.issuePermissionsObj.Create\" ng-click=\"viewGhostAttributes.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table></div></div><div class=\"col-sm-12 p-0\" ng-if=\"viewGhostAttributes.isGhostDetailsEditable\"><div class=\"m-t-15 m-b-15\"><span ng-click=\"viewGhostAttributes.fnGoBackToTableView()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Table</label></a></span></div><schema-directive type-arr=\"viewGhostAttributes.selectedGhostObj\" fn-check-type-validion=\"viewGhostAttributes.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive><div class=\"pull-right\" ng-if=\"viewGhostAttributes.isEditInputValidated\"><button class=\"btn btn-primary\" ng-click=\"viewGhostAttributes.fnUpdateGhostValue()\" ng-if=\"viewGhostAttributes.isGhostUpdateCompleted\">Update Ghost</button><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!viewGhostAttributes.isGhostUpdateCompleted\"></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" ng-if=\"viewGhostAttributes.isFooterSpinnerActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"pull-left m-t-2 m-l-5\" ng-if=\"!viewGhostAttributes.isFooterSpinnerActive\"><label>ID: {{viewGhostAttributes.selectedInventoryObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"viewGhostAttributes.fnCopyToClipboard(viewGhostAttributes.selectedInventoryObj.id, 2000)\" ng-class=\"!viewGhostAttributes.isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-if=\"!viewGhostAttributes.isFooterSpinnerActive\" ng-click=\"viewGhostAttributes.fnCancel()\">Close</button></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuInfo.html","<div class=\"container-with-footer tab-container\" ng-init=\"fnInitDetailTab()\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Edge Compute Unit</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-10 p-0\"><h1 class=\"m-0 font-bold ellipsis\" ng-if=\"isFullWidthDevice\">{{ecuObj.name}}</h1><h3 class=\"m-0 font-bold ellipsis\" ng-if=\"!isFullWidthDevice\">{{ecuObj.name}}</h3></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end align-items-center\"><span class=\"ellipsis m-b-0 d-flex align-items-center justify-content-flex-end\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span><div class=\"d-flex\" uib-tooltip=\"ECU Connection\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor m-l-10\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div></span></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-10 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\" ng-if=\"isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0 ellipsis\" ng-if=\"!isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h5><div class=\"d-flex flex-column m-t-10\"><div class=\"d-flex align-items-center\"><label class=\"m-b-0 m-r-5\">ECU ID:</label> <span>{{ecuObj.id}}</span> <i class=\"m-l-5 fa fa-clipboard\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center m-t-5\" ng-if=\"ecuObj.serial\"><label class=\"m-b-0 m-r-5\">Serial Number:</label> <span>{{ecuObj.serial}}</span> <i class=\"m-l-5 fa fa-clipboard\" ng-click=\"fnCopyToClipboard(ecuObj.serial, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end align-items-center\"><div ng-if=\"ecuObj.phase !== \'ACTIVE\'\"><span ng-if=\"ecuObj.phase !== \'UNREGISTERED\'\" uib-tooltip=\"{{ecuObj.phase}}\" tooltip-placement=\"auto\"><b>{{ecuObj.phase}}</b></span> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation(); fnTabSelected({tabIndex: 3})\">Register ECU</button></div><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healtSpan\">{{ecuObj.healthName}}</span></button></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/ecu/ecuNetworkscan/ecuNetworkscan.html","<div ng-controller=\"ecuNetworkscanCtrl as ecuNetworkScan\" ng-init=\"ecuNetworkScan.fnInit()\"><div class=\"modal-body p-0\" id=\"ecu-networkscan-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuNetworkScan.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"ecuNetworkScan.ecuDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching ECU Details...</h2></div><div class=\"col-sm-12 h-100 p-t-20\" ng-class=\"ecuNetworkScan.isNetworkScanStart ? \'pace\': \'\'\" ng-if=\"!ecuNetworkScan.ecuDetailsLoading\"><div class=\"col-sm-12 p-0 m-t-10 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary d-flex\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuNetworkScan.inputObj.auto ? \'True\':\'False\'}}</span> <label class=\"titleLabel\">Auto</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"ecuNetworkScan.inputObj.auto = true;ecuNetworkScan.inputObj.range = \'\'\"><span>True</span></a></li><li><a ng-click=\"ecuNetworkScan.inputObj.auto = false;\"><span>False</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-if=\"ecuNetworkScan.inputObj.auto === false\"><div class=\"md-input m-b-0 h-100\"><input class=\"md-form-control h-100\" type=\"text\" name=\"range\" placeholder=\"Enter an IP address Scanning ranges using NMAP notation\" rows=\"4\" style=\"resize: none\" ng-model=\"ecuNetworkScan.inputObj.range\"> <label>Range</label></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuNetworkScan.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Network Scanning</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your network scanning you can watch it here real-time. Closing this window will have no effect on the execution.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"ecuNetworkScan.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in ecuNetworkScan.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"ecuNetworkScan.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"ecuNetworkScan.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in ecuNetworkScan.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-flex-end\" ng-if=\"ecuNetworkScan.activeStep === 1\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!ecuNetworkScan.ecuDetailsLoading && !ecuNetworkScan.isNetworkScanStart\" ng-click=\"ecuNetworkScan.fnRequestECUNetworkScan()\" tabindex=\"12\">Start Network Scan</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"ecuNetworkScan.isNetworkScanStart\"></app-spinner></div></div></div>");
$templateCache.put("app/node/ecu/ecuSynchronizing/ecuSynchronizing.html","<div ng-controller=\"ecuSynchronizingCtrl as ecuSynchronizing\" ng-init=\"ecuSynchronizing.fnInit()\"><div class=\"modal-body p-0\" id=\"ecu-synchronizing-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuSynchronizing.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"ecuSynchronizing.ecuDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching ECU Details...</h2></div><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center flex-column justify-content-center\" ng-if=\"!ecuSynchronizing.ecuDetailsLoading\"><div class=\"col-sm-6 p-0 d-flex justify-content-center align-items-center flex-column\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0\"><b>{{ecuSynchronizing.ecuObj.name}}</b></label></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0 font-italic opacity-5\">{{ecuSynchronizing.ecuObj.description}}</label></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!ecuSynchronizing.ecuDetailsLoading && (ecuSynchronizing.ecuObj && ecuSynchronizing.ecuObj.name) && !ecuSynchronizing.deploysUnsynchronizedEcu\" ng-click=\"ecuSynchronizing.fnRequestECUSynchronizing()\" tabindex=\"12\">Start ECU Synchronizing</button><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\" ng-if=\"ecuSynchronizing.deploysUnsynchronizedEcu\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuSynchronizing.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Synchronizing ECU</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Synchronizing ECU you can watch it here in real-time. Closing this window will have no effect on the Synchronizing.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"ecuSynchronizing.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in ecuSynchronizing.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"ecuSynchronizing.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"ecuSynchronizing.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in ecuSynchronizing.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/node/ecu/ecuTunnel/ecuTunnel.html","<div ng-controller=\"ecuTunnelCtrl as ecuTunnel\" ng-init=\"ecuTunnel.fnInit()\"><div class=\"modal-body p-0\" id=\"ecu-tunnel-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuTunnel.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"ecuTunnel.ecuDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching ECU Details...</h2></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!ecuTunnel.ecuDetailsLoading\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex align-items-center p-0 p-t-5\"><h2 class=\"m-0 font-bold\"><label>Select the Type of Tunnel you want to open.</label></h2></div></div><div class=\"col-sm-12 p-15\" ng-if=\"!ecuTunnel.tunnelTypes.length\">The ECU does not support any type of tunnels</div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"ecuTunnel.tunnelTypes.length\"><div class=\"col-sm-12 p-15\" ng-class=\"ecuTunnel.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuTunnel.selectedTunnelType}}</span> <label class=\"titleLabel\">Verify Selector Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"tunnelTypeObj in ecuTunnel.tunnelTypes\"><a ng-click=\"ecuTunnel.fnSelectTunnelType(tunnelTypeObj)\"><span ng-class=\"tunnelTypeObj.name === ecuTunnel.selectedTunnelType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"tunnelTypeObj.name === ecuTunnel.selectedTunnelType\"></i></span> <span>{{tunnelTypeObj.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-15\" ng-class=\"ecuTunnel.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuTunnel.selectedTimeout.displayName}}</span> <label class=\"titleLabel\">Tunnel duration</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"timeoutOption in ecuTunnel.timeOutOptions\"><a ng-click=\"ecuTunnel.fnChangeTimeout(timeoutOption)\"><span ng-class=\"timeoutOption.displayName === ecuTunnel.selectedTimeout.displayName ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"timeoutOption.displayName === ecuTunnel.selectedTimeout.displayName\"></i></span> <span>{{timeoutOption.displayName}}</span></a></li></ul></div></div></div><div ng-if=\"ecuTunnel.debugInfo\" class=\"col-sm-12 p-15 bg-light\"><h3 class=\"text-danger\">Debug Information</h3><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Parsing Steps:</strong><ul class=\"list-unstyled\"><li ng-repeat=\"step in ecuTunnel.debugInfo.parsingSteps\"><i class=\"fa fa-chevron-right m-r-5\"></i>{{step}}</li></ul></div></div><div class=\"row m-b-10\"><div class=\"col-sm-6\"><strong>Raw IoT3 Config:</strong><pre class=\"small\">{{ecuTunnel.debugInfo.rawIot3}}</pre></div><div class=\"col-sm-6\"><strong>Parsed Config:</strong><pre class=\"small\">{{ecuTunnel.debugInfo.parsedConfig | json}}</pre></div></div><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Detected Tunnel Types:</strong> <span ng-repeat=\"type in ecuTunnel.debugInfo.tunnelTypes\" class=\"badge bg-success m-r-5\">{{type}}</span> <span ng-if=\"!ecuTunnel.debugInfo.tunnelTypes.length\" class=\"badge bg-warning\">No tunnel types detected</span></div></div><div class=\"row m-b-10\" ng-if=\"ecuTunnel.debugInfo.validationIssues\"><div class=\"col-sm-12\"><strong>Validation Issues:</strong><div ng-if=\"ecuTunnel.debugInfo.validationIssues.errors.length\"><span class=\"text-danger\">Errors:</span><ul class=\"list-unstyled\"><li ng-repeat=\"error in ecuTunnel.debugInfo.validationIssues.errors\"><i class=\"fa fa-times-circle text-danger m-r-5\"></i>{{error}}</li></ul></div><div ng-if=\"ecuTunnel.debugInfo.validationIssues.warnings.length\"><span class=\"text-warning\">Warnings:</span><ul class=\"list-unstyled\"><li ng-repeat=\"warning in ecuTunnel.debugInfo.validationIssues.warnings\"><i class=\"fa fa-exclamation-triangle text-warning m-r-5\"></i>{{warning}}</li></ul></div></div></div><div class=\"row\" ng-if=\"ecuTunnel.debugInfo.parseError\"><div class=\"col-sm-12\"><div class=\"alert alert-danger\"><strong>Parse Error:</strong> {{ecuTunnel.debugInfo.parseError}}</div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuTunnel.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Open Tunnel</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. You can watch your open tunnel here in real-time. Closing this window will stop the tunnel request.</span></div><div class=\"col-sm-12 p-15 bg-light\" ng-show=\"true\"><h3 class=\"text-danger\">Debug Information</h3><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Controller Type:</strong> <span class=\"badge bg-info\">{{$ctrl.constructor.name}}</span></div></div><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Job Object:</strong><pre class=\"small\">{{jobObj | json}}</pre></div></div><div class=\"row m-b-10\"><div class=\"col-sm-6\"><strong>Raw Response:</strong><pre class=\"small\">{{latestResponse || \'No response yet\'}}</pre></div><div class=\"col-sm-6\"><strong>Parsed Response:</strong><pre class=\"small\">{{parsedResponse | json}}</pre></div></div><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Selected Configuration:</strong><ul class=\"list-unstyled\"><li><strong>Tunnel Type:</strong> {{selectedTunnelType}}</li><li><strong>Timeout:</strong> {{selectedTimeout.value}} seconds ({{selectedTimeout.displayName}})</li></ul></div></div><div class=\"row m-b-10\"><div class=\"col-sm-12\"><strong>Job States:</strong><ul class=\"list-unstyled\"><li><i class=\"fa\" ng-class=\"{\'fa-check-circle text-success\': !pendingJob, \'fa-circle-o\': pendingJob}\"></i> Pending</li><li><i class=\"fa\" ng-class=\"{\'fa-check-circle text-success\': !activeJob, \'fa-circle-o\': activeJob}\"></i> Active</li><li><i class=\"fa\" ng-class=\"{\'fa-check-circle text-success\': completedJob, \'fa-circle-o\': !completedJob}\"></i> Completed</li></ul></div></div></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"ecuTunnel.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in ecuTunnel.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"ecuTunnel.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"ecuTunnel.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in ecuTunnel.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-flex-end\" ng-if=\"ecuTunnel.activeStep === 1\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!ecuTunnel.ecuDetailsLoading && !ecuTunnel.isTunnelRequestActive\" ng-class=\"ecuTunnel.selectedTunnelType.length ? \'\' : \'pace opacity-5\'\" ng-click=\"ecuTunnel.fnRequestECUTunnel()\" tabindex=\"12\">Start Tunnel Request</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"ecuTunnel.isTunnelRequestActive\"></app-spinner></div></div></div>");
$templateCache.put("app/components/directives/nodeSearchDirective/searchTemplate.html","<div class=\"search-panel\" ng-style=\"isCalledForViewVisualizer ? {\'margin-top\' : \'30px\'} : \'\'\"><div class=\"row\"><div ng-class=\"isFilterOptionsVisible ? \'col-sm-6\' : \'col-sm-12\'\"><div class=\"md-input\"><input type=\"text\" id=\"nodeSearchTextField\" ng-focus=\"fnFocus($event)\" ng-blur=\"fnBlur($event)\" required=\"\" class=\"md-form-control\" ng-keyup=\"$event.keyCode === 13 && fnCreateSearchTags(selectedField, selectedFilter, searchText, selectedConnector.toLowerCase())\" ng-model=\"searchText\"> <span class=\"highlight\"></span><label>Search</label></div></div><div class=\"col-sm-6\" ng-if=\"isFilterOptionsVisible\"><div class=\"btn-group pull-right\" uib-dropdown=\"\"><button id=\"operatorOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedFilter.operator}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"operatorOptions\"><li ng-repeat=\"filter in filterOptions\" role=\"menuitem\" ng-click=\"fnSelectFilters(filter)\"><a>{{filter.operator}}</a></li></ul></div><div class=\"btn-group pull-right p-r-5\" uib-dropdown=\"\"><button id=\"fieldOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedField}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"fieldOptions\"><li ng-repeat=\"field in fieldArr\" role=\"menuitem\" ng-click=\"fnSelectFields(field.fieldName)\"><a>{{field.fieldDisplayName}}</a></li></ul></div><div ng-if=\"isConnectorVisible\" class=\"btn-group pull-right p-r-5\" uib-dropdown=\"\"><button id=\"connectorOptions\" type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\">{{selectedConnector}} <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"connectorOptions\"><li role=\"menuitem\" ng-click=\"fnChangeSelectedConnector(\'AND\')\"><a>AND</a></li><li role=\"menuitem\" ng-click=\"fnChangeSelectedConnector(\'OR\')\"><a>OR</a></li></ul></div></div></div><span class=\"bar\"></span></div><div class=\"search-tag-container\" ng-class=\"{\'m-t-13\': tagsArr.length === 0 ,\'m-t-10 m-b-5\' : tagsArr && tagsArr.length !==0}\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-repeat=\"tag in tagsArr track by tag.id\">{{tag.name}}<i ng-click=\"fnRemoveTags($index)\" class=\"fa fa-times m-l-5\"></i></button></div>");
$templateCache.put("app/node/es4/createEs4/createEs4.html","<div class=\"h-100\" ng-controller=\"createEs4Ctrl as createEs4\" ng-init=\"createEs4.fnInitCreateEs4()\"><div class=\"modal-body height-100\" id=\"modal-body\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createEs4.isEs4CreateLoaded\"></div><div class=\"row\" ng-if=\"createEs4.isEs4CreateLoaded\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 m-t-10 issueDropDown ecuNameContainer\"><div class=\"col-sm-2 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary p-b-5 issue-project-dropdown-menu\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createEs4.selectedEcu.name}}</span> <label class=\"titleLabel\">ECU*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown p-b-0\" style=\"max-height: none;max-width: 100%\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createEs4.es4EcuSearch[createEs4.es4EcuFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\" style=\"max-width: 350px;\"><li ng-repeat=\"ecuObj in createEs4.filterEcu=(createEs4.ecusArr | filter:createEs4.es4EcuSearch) track by $index\" ng-click=\"createEs4.fnGetEs4Ecu(ecuObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"ecuObj.id === createEs4.selectedEcu.id\"></i></span> <span class=\"ellipsis\">{{ecuObj.name}}</span></a></li><li ng-if=\"!createEs4.filterEcu.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"col-sm-10 p-r-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createEs4.newEs4Obj.name\" placeholder=\"Name*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 m-t-10 descriptionContainer\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createEs4.newEs4Obj.description\" placeholder=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12\"><label class=\"m-0 text-primary\">ES4 Script*</label></div><div class=\"col-sm-12 m-t-0 scriptContainer overflow-auto\"><div class=\"col-sm-12 p-0 email-template es4-script\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"createEs4.value\" available-defs=\"createEs4.availableDataLibs\" editor-value=\"createEs4.newEs4Obj.script\" read-only=\"createEs4.isScriptEditable\"></javascript-editor></div></div><div class=\"col-sm-12 m-t-10 createBtnContainer\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"!createEs4.isEs4Creating\" ng-disabled=\"!createEs4.newEs4Obj.name.length\" ng-click=\"createEs4.fnCreateNewEs4(createEs4.newEs4Obj)\">Create ES4</button><div class=\"col-sm-12 m-t-3 p-0\" ng-if=\"createEs4.isEs4Creating\"><div class=\"pull-right m-r-0\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div>");
$templateCache.put("app/node/es4/es4Info/es4Info.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>ES4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{es4Obj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{es4Obj.name}}</h3></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{es4Obj.description ? es4Obj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{es4Obj.description ? es4Obj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{es4Obj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(es4Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/fleet/fleetInfo/fleetInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Edge Compute Unit</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{ecuObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{ecuObj.name}}</h3></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><span class=\"ellipsis m-b-0 d-flex align-items-center justify-content-flex-end\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span><div class=\"d-flex\" uib-tooltip=\"ECU Connection\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor m-l-10\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div></span></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"fnCheckHealth()\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healtSpan\">{{ecuObj.healthName}}</span></button></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/gateway/createGateway/createGateway.html","<div ng-controller=\"createGatewayCtrl as createGateway\" ng-init=\"createGateway.fnInitCreateGateway()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createGateway.title}}</h3><button ng-if=\"gateway.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"gateway.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createGateway.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div id=\"functionModal\" ng-if=\"createGateway.isBluePrintFetched && !createGateway.isBluePrintSelected\" class=\"col-sm-12 m-t-10\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"createGateway.search\" ng-change=\"createGateway.fnTypesFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\" ng-if=\"createGateway.isBluePrintFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!createGateway.isBluePrintFilter\"><div class=\"col-sm-12\" ng-if=\"!createGateway.fnCheckObjLength(createGateway.uniqueBluePrintObj)\"><label>No records found...</label></div><div class=\"col-sm-12 p-0\" ng-if=\"createGateway.fnCheckObjLength(createGateway.uniqueBluePrintObj)\"><div class=\"col-sm-6\" ng-repeat=\"(key, value) in createGateway.uniqueBluePrintObj\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\" style=\"max-width: max-content\" uib-tooltip=\"{{value.typeName}}\" tooltip-placement=\"top\">{{value.typeName}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"createGateway.fnBluePrintSelected(value.selectedTypeVersionObj)\">Connect</button></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><small class=\"font-italic\">OEM: {{value.selectedTypeVersionObj.oem}}</small><br><small class=\"font-italic\">Model: {{value.selectedTypeVersionObj.model}}</small></div><div class=\"dropdown\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Version {{value.selectedTypeVersionObj.version}} <i class=\"fa fa-caret-down m-l-2\"></i></label> <label class=\"pull-right\">({{value.selectedTypeVersionObj.id}})</label></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"valueObj in value.typeValue\"><a class=\"btn btn-link\" ng-click=\"value.selectedTypeVersionObj = valueObj\">{{valueObj.version}}</a></li></ul></div></div></div></div></div></div></div><div ng-if=\"createGateway.isBluePrintFetched && createGateway.isBluePrintSelected\"><div class=\"col-sm-12 m-b-10\"><button class=\"btn btn-link p-l-0\" ng-click=\"createGateway.isBluePrintSelected = false; createGateway.newGatewayObj.typeId = \'\'; createGateway.fnInitCreateGateway()\">Back to Types</button></div><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewGatewayInfoForm\" role=\"form\" name=\"createNewGatewayInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createGateway.newGatewayObj.name\" placeholder=\"Name for the new Gateway*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createGateway.newGatewayObj.description\" placeholder=\"Description regarding Gateway\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form><h3 class=\"m-b-20\">Delivery Information</h3><schema-directive type-arr=\"createGateway.typePropertiesArr\" fn-check-type-validion=\"createGateway.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createGateway.isGatewayCreating\" ng-click=\"createGateway.fnCreateGateway(createGateway.newGatewayObj)\" ng-disabled=\"!createGateway.newGatewayObj.name.length || !createGateway.isTypeformValidated\" value=\"Order Gateway\"><div ng-if=\"createGateway.isGatewayCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.oem\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/health/createHealth/createHealth.html","<div class=\"h-100\" ng-controller=\"createHealthCtrl as createHealth\" ng-init=\"createHealth.fnInitCreateHealth()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createHealth.isHealthCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createHealth.isHealthCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewHealthForm\" role=\"form\" name=\"createNewHealthForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createHealth.newHealthObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewHealthForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createHealth.newHealthObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewHealthForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"code\" type=\"number\" ng-model=\"createHealth.newHealthObj.value\" name=\"value\" placeholder=\"Value*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewHealthForm.value.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-t-10 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"createHealth.newHealthObj.color\" placeholder=\"Color*\" name=\"color\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewHealthForm.color.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Color*</label> <small class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><br><div class=\"col-sm-12 p-0\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedLabel in createHealth.suggestedLabelsArr\" ng-style=\"createHealth.fnAssignSpanBackground(suggestedLabel)\" ng-click=\"createHealth.fnAssignSuggestedColor(suggestedLabel)\"></span></div><div class=\"col-sm-12 p-0\" ng-click=\"\"><button class=\"btn btn-link p-l-0\" ng-click=\"createHealth.fnDisplayMiniColors()\"><small>{{createHealth.isDisplayMiniColors ? \'hide\':\'see more\'}} colors</small></button></div><div class=\"p-b-15\" ng-if=\"createHealth.isDisplayMiniColors\"><input minicolors=\"createHealth.customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"createHealth.newHealthObj.color\"></div><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createHealth.changeProjectView\" ng-click=\"$event.stopPropagation();createHealth.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createHealth.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createHealth.selectedProject.name\"><span>{{createHealth.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createHealth.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createHealth.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createHealth.selectedProject.name\">{{createHealth.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createHealth.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createHealth.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createHealth.projectSearch[createHealth.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createHealth.filterProject=(createHealth.projectsArr | filter:createHealth.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createHealth.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createHealth.filterProject.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createHealth.fnManageProject()\"><a><span>Manage projects</span></a></li></ul></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createHealth.newHealthObj.name.length || !createHealth.newHealthObj.description.length || !createHealth.newHealthObj.color.length || !createHealth.newHealthObj.value.toString().length || !(createHealth.selectedProject && createHealth.selectedProject.id)\" ng-click=\"createHealth.fnCreateNewHealth(createHealth.newHealthObj)\" ng-if=\"!createHealth.isHealthCreating\">Create Health</button></div><div class=\"col-sm-12\" ng-if=\"createHealth.isHealthCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/health/healthInfo/healthInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Health</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{healthObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{healthObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{healthObj.description ? healthObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{healthObj.description ? healthObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{healthObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(healthObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/iot3/iot3Service/iot3Service.html","<div class=\"row h-100\" ng-init=\"iot3.fnInitIot3Service()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"iot3.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in iot3.tabs track by $index\" select=\"iot3.fnTabChanged(tab)\" ng-click=\"iot3.fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\" ng-bind=\"tab.title\"></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();iot3.fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"iot3.fnGetIot3Dashboard()\"><i class=\"fa fa-question-circle-o m-r-10\"></i>About</a></li><li ng-if=\"!iot3.isFullWidthDevice\"><a ng-click=\"iot3.fnGetIot3Stats()\"><i class=\"fa fa-pie-chart m-r-10\"></i>Stats</a></li><li ng-if=\"iot3.isFullWidthDevice\"><a ng-click=\"iot3.fnShowHideWidget()\"><i class=\"fa fa-th-large m-r-10\"></i>{{iot3.isShowWidgets ? \'Hide\': \'Show\'}} Widgets</a></li></ul></div></div><div class=\"col-sm-12 p-0 overflow-x-hidden\" ng-if=\"iot3.activeTabIndex === 1\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\" ng-if=\"iot3.isFullWidthDevice && iot3.isShowWidgets\"><div class=\"d-flex flex-column pie-background-color\"><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-3 custom-widget border-right-0\" ng-class=\"$first ? \'border-left-0\':\'\'\" ng-repeat=\"dashboardWidget in iot3.dashboardWidgets track by $index\"><div ng-if=\"dashboardWidget.widgetType === \'dynamic\'\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!dashboardWidget.widgetData && !dashboardWidget.widgetData.icon && !dashboardWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"dashboardWidget.widgetData && dashboardWidget.widgetData.icon && dashboardWidget.widgetData.icon.length\" ng-bind-html=\"iot3.deliberatelyTrustDangerousSnippet(dashboardWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{dashboardWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadPNG\', \'iot3DashboardWidgets\'+$index)\">Download PNG image</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadJPEG\', \'iot3DashboardWidgets\'+$index)\">Download JPEG image</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadPDF\', \'iot3DashboardWidgets\'+$index)\">Download PDF Document</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadSVG\', \'iot3DashboardWidgets\'+$index)\">Download SVG vector image</a></li><li><a ng-click=\"iot3.fnGetWidgetEditor($index)\">Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW\"><div class=\"p-t-0 service-pic-chart\" ng-if=\"iot3.chartData[$index]\"><service-stats-pie-chart ng-if=\"!dashboardWidget.isDataNull\" chart-title=\"User\" is-for-csv-chart=\"true\" chart-class=\"{{\'iot3DashboardWidgets\'+$index}}\" chart-for=\"userState\" chart-data=\"iot3.chartData[$index]\"></service-stats-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"dashboardWidget.isDataNull\" style=\"opacity: 0.5\"><svg style=\"height: 60px;width: 60px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><svg class=\"dashboard-pie-chart-img p-t-10\" ng-if=\"!iot3.chartData[$index]\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div></div><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW height-100\" ng-if=\"dashboardWidget.widgetType === \'static\'\"><div class=\"dashboard-header-panel\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!dashboardWidget.widgetData && !dashboardWidget.widgetData.icon && !dashboardWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"dashboardWidget.widgetData && dashboardWidget.widgetData.icon && dashboardWidget.widgetData.icon.length\" ng-bind-html=\"iot3.deliberatelyTrustDangerousSnippet(dashboardWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{dashboardWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"iot3.fnGetWidgetEditor($index)\">Edit Widget</a></li></ul></div></div></div></div><div class=\"custom-panel-body d-flex align-items-center\"><span>{{dashboardWidget.widgetData.description}}</span></div><div><button class=\"btn btn-primary v4-primary-button\" ng-click=\"iot3.fnGotoLink(dashboardWidget.widgetData.buttonLink, dashboardWidget.widgetData.target)\">{{dashboardWidget.widgetData.buttonText}}</button></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"iot3.isRefreshData\" search-identifier=\"\'iot3Search\'\" filters-arr=\"iot3.searchFiltersArr\" filter-query=\"iot3.filterQuery\" fn-filter-query-change=\"iot3.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.iot3\'\" fn-resize=\"iot3.fnSetTableHeight()\" sort-field-arr=\"iot3.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"iot3.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-if=\"iot3.selectedIot3FilesArr.length\"><a ng-click=\"iot3.fnDeleteMultipleIot3References(iot3.selectedIot3FilesArr)\"><i class=\"m-r-5 fa fa-trash\"></i>Delete</a></li><li><a ng-click=\"iot3.fnShowAdvanceSearchForm()\"><i class=\"m-r-5 fa fa-search\"></i>Advanced</a></li><li ng-hide=\"true\"><a ng-csv=\"iot3.getIot3CSVData()\" id=\"csvAnchor\" csv-header=\"iot3.csvHeaderArr\" filename=\"iot3.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"iot3.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"iot3.isIot3FilesLoading\" fn-resize=\"iot3.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-table table-container\"><table id=\"iotTable\" class=\"table table-striped table-check-box\" ng-if=\"!iot3.isIot3FilesLoading\"><thead><tr><th ng-if=\"iot3.iot3FilesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"iot3.isAllChecked\" ng-click=\"iot3.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"iot3.iot3FilesArr.length\"><span>Name</span></th><th ng-if=\"iot3.iot3FilesArr.length\"></th><th ng-if=\"iot3.iot3FilesArr.length\"></th><th ng-if=\"iot3.iot3FilesArr.length\"></th><th ng-if=\"!iot3.iot3FilesArr.length\">No records found...</th></tr></thead><tbody id=\"iot3Table\"><tr ng-repeat=\"iot3ReferenceObj in iot3.iot3FilesArr track by $index\" ng-click=\"iot3.fnCheckUncheckHeader(iot3ReferenceObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"iot3ReferenceObj.isCheck\" ng-change=\"iot3.fnCheckUncheckHeader(iot3ReferenceObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\" ng-show=\"!iot3ReferenceObj.isEditable\"><label class=\"ellipsis m-b-0 label_name\">{{iot3ReferenceObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3ReferenceObj.description}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Model\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/iot3model.svg#iot3model\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{iot3ReferenceObj.model}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Versions\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/iot3versions.svg#iot3versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-repeat=\"versionName in iot3ReferenceObj.versions track by $index\">{{versionName}}<span ng-if=\"$index !== iot3ReferenceObj.versions.length - 1\">,</span></span></span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-if=\"iot3ReferenceObj.labelsArr && iot3ReferenceObj.labelsArr.length\" ng-repeat=\"labelObj in iot3ReferenceObj.labelsArr\" ng-style=\"{\'background-color\': labelObj.bgColor, \'color\': labelObj.textColor}\"><span>{{labelObj.name}}</span></button></div></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Versions\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/recovery.svg#recovery\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{iot3ReferenceObj.revision}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3ReferenceObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3ReferenceObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3ReferenceObj.createdDate}}</label></div></div><div class=\"d-flex\"><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3ReferenceObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3ReferenceObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{iot3ReferenceObj.updatedDate}}</label></div></div><div class=\"d-flex\"><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3ReferenceObj.author}}\" tooltip-placement=\"auto\" ng-if=\"iot3ReferenceObj.author\"><label class=\"ellipsis m-b-0\">Authored by {{iot3ReferenceObj.author}}</label></div></div></td><td class=\"text-right\" ng-show=\"!iot3ReferenceObj.isEditable\"><div class=\"dropdown no-hover customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': iot3.isDropUp }\" ng-click=\"$event.stopPropagation(); iot3.toggleDropUp(\'iot3_Table\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"iot3.fnOpenIot3InfoTab(iot3ReferenceObj,1)\">Details</a></li><li><a ng-click=\"iot3.fnOpenIot3InfoTab(iot3ReferenceObj,2)\">Nodes</a></li><li><a ng-click=\"iot3.fnOpenIot3InfoTab(iot3ReferenceObj,3)\">Iot3</a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!iot3.isIot3FilesLoading && iot3.iot3FilesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{iot3.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"iot3.perPage = 10; iot3.fnPageChanged(iot3.currentPage, iot3.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"iot3.perPage = 20; iot3.fnPageChanged(iot3.currentPage, iot3.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"iot3.perPage = 50; iot3.fnPageChanged(iot3.currentPage, iot3.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"iot3.perPage = 100; iot3.fnPageChanged(iot3.currentPage,iot3.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"iot3.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"iot3.currentPage\" items-per-page=\"iot3.perPage\" max-size=\"iot3.maxSize\" boundary-links=\"true\" ng-click=\"iot3.fnPageChanged(iot3.currentPage, iot3.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{iot3.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : iot3.isRefresh}\" ng-click=\"iot3.fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"iot3.fnHideShowCreateForm()\">Create Iot3</button></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && iot3.selectedIot3Obj && iot3.isIot3DetailsLoaded && !iot3.isCreate && !iot3.isShowDashboard && !iot3.isShowIot3Stats && !iot3.isShowWidgetEditor && !iot3.isShowAdvanceSearch\"><div class=\"content-box h-100\" id=\"infoSection\"><div class=\"content-container h-100\"><iot3-service-info iot3-obj=\"iot3.selectedIot3Obj\" user-permissions-obj=\"iot3.permissionObj\"></iot3-service-info></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && iot3.isCreate && !iot3.isShowDashboard && !iot3.isShowIot3Stats && !iot3.isShowWidgetEditor && !iot3.isShowAdvanceSearch\"><div class=\"content-box h-100\"><div class=\"content-container h-100\"><div class=\"form-container\"><ng-include src=\"\'app/node/iot3/iot3Service/createIot3/createIot3.html\'\"></ng-include></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && iot3.isShowDashboard && !iot3.isCreate && !iot3.isShowIot3Stats && !iot3.isShowWidgetEditor && !iot3.isShowAdvanceSearch\"><div class=\"content-box h-100\"><div class=\"content-container h-100 overflow-auto\"><div class=\"col-sm-12 h-100\"><div class=\"row p-0\"><div class=\"col-sm-12 p-20 dashboard-header\"><div class=\"col-sm-12 p-l-10 p-r-10\"><span>Security</span><h1 class=\"m-0 font-weight-bold m-t-1 font-bold\">Iot3 References</h1><h2 class=\"m-t-10 m-0\">Collaborate with colleagues and clients</h2></div></div></div><div class=\"row d-flex dashboard-body p-t-0 p-b-15 p-l-15 p-r-15\"><div class=\"col-sm-9 overflow-auto\"></div><div class=\"col-sm-3 p-0 overflow-auto\" style=\"margin-top: -55px;\"><div class=\"col-sm-12\"><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Getting started</label></div><div class=\"p-15 text-justify\"><span>iot3. To create an Iot3 Reference, select Create iot3.</span><br><button class=\"btn btn-primary m-t-10\" ng-click=\"iot3.fnHideShowCreateForm()\">Create Iot3</button></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Pricing (US)</label></div><div class=\"p-15 text-justify\"><span>Iot3 are free in your account.You can create as many Iot3 References as you want in your account.</span></div></div></div></div><div class=\"row h-100 p-b-15\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Documentation</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\">Getting started</td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr><tr><td class=\"p-b-0 p-r-15\">API documentation</td><td class=\"p-b-0 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div><div class=\"row h-100 p-b-0\"><div class=\"col-sm-12 side-bar-panel\"><div class=\"dashboard-panel dashboard-panel-side-bar h-100\"><div class=\"p-15 dashboard-border\"><label class=\"m-0 font-size-19\">Resources</label></div><div class=\"p-15\"><table><tr><td class=\"p-b-12 p-r-15\"></td><td class=\"p-b-12 p-l-10\"><i class=\"fa fa-share-square-o\"></i></td></tr></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && !iot3.isShowDashboard && !iot3.isCreate && iot3.isShowIot3Stats && !iot3.isShowWidgetEditor && !iot3.isShowAdvanceSearch\"><div class=\"content-box h-100\"><div class=\"content-container h-100 scroll-0 overflow-auto\"><div class=\"col-sm-12 p-0 dashboard-header header-background-bgLgPrimaryColor\"><div class=\"d-flex flex-column pie-background-color\"><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-3 custom-widget border-right-0\" ng-class=\"$first ? \'border-left-0\':\'\'\" ng-repeat=\"dashboardWidget in iot3.dashboardWidgets track by $index\"><div ng-if=\"dashboardWidget.widgetType === \'dynamic\'\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!dashboardWidget.widgetData && !dashboardWidget.widgetData.icon && !dashboardWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"dashboardWidget.widgetData && dashboardWidget.widgetData.icon && dashboardWidget.widgetData.icon.length\" ng-bind-html=\"iot3.deliberatelyTrustDangerousSnippet(dashboardWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{dashboardWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadPNG\', \'iot3DashboardWidgets\'+$index)\">Download PNG image</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadJPEG\', \'iot3DashboardWidgets\'+$index)\">Download JPEG image</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadPDF\', \'iot3DashboardWidgets\'+$index)\">Download PDF Document</a></li><li ng-if=\"iot3.chartData[$index]\"><a ng-click=\"iot3.fnExportChart(\'downloadSVG\', \'iot3DashboardWidgets\'+$index)\">Download SVG vector image</a></li><li><a ng-click=\"iot3.fnGetWidgetEditor($index)\">Edit Widget</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW\"><div class=\"p-t-0 service-pic-chart\" ng-if=\"iot3.chartData[$index]\"><service-stats-pie-chart ng-if=\"!dashboardWidget.isDataNull\" chart-title=\"User\" is-for-csv-chart=\"true\" chart-class=\"{{\'iot3DashboardWidgets\'+$index}}\" chart-for=\"userState\" chart-data=\"iot3.chartData[$index]\"></service-stats-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"dashboardWidget.isDataNull\" style=\"opacity: 0.5\"><svg style=\"height: 60px;width: 60px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><svg class=\"dashboard-pie-chart-img p-t-10\" ng-if=\"!iot3.chartData[$index]\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div></div><div class=\"p-0 d-flex flex-column justify-content-center align-items-center full-width-pie-chart-HW height-100\" ng-if=\"dashboardWidget.widgetType === \'static\'\"><div class=\"dashboard-header-panel\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center widget-title-width\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!dashboardWidget.widgetData && !dashboardWidget.widgetData.icon && !dashboardWidget.widgetData.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"dashboardWidget.widgetData && dashboardWidget.widgetData.icon && dashboardWidget.widgetData.icon.length\" ng-bind-html=\"iot3.deliberatelyTrustDangerousSnippet(dashboardWidget.widgetData.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{dashboardWidget.widgetData.title}}</label></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"iot3.fnGetWidgetEditor($index)\">Edit Widget</a></li></ul></div></div></div></div><div class=\"custom-panel-body d-flex align-items-center\"><span>{{dashboardWidget.widgetData.description}}</span></div><div><button class=\"btn btn-primary v4-primary-button\" ng-click=\"iot3.fnGotoLink(dashboardWidget.widgetData.buttonLink, dashboardWidget.widgetData.target)\">{{dashboardWidget.widgetData.buttonText}}</button></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && !iot3.isShowDashboard && !iot3.isCreate && !iot3.isShowIot3Stats && !iot3.isShowWidgetEditor && iot3.isShowAdvanceSearch\"><div class=\"content-box h-100\" ng-init=\"iot3.fnShowAdvanceSearchForm()\"><advance-search-directive app-key=\"\'node\'\" service-key=\"\'iot3\'\" app-name=\"\'Iot3\'\"></advance-search-directive></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"iot3.activeTabIndex !== 1 && !iot3.isShowDashboard && !iot3.isCreate && !iot3.isShowIot3Stats && iot3.isShowWidgetEditor && !iot3.isShowAdvanceSearch\"><widget-editor dashboard-widgets=\"iot3.dashboardWidgets\" reset-dashboard-widgets=\"iot3.resetDashboardWidgets\" selected-column=\"iot3.selectedColumn\" app-name=\"\'node\'\" service-name=\"\'iot3\'\" service-display-name=\"\'Iot3\'\"></widget-editor></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/iot3Workbench.html","<div class=\"row h-100\" ng-init=\"workbench.fnInitIot3Workbench()\"><div class=\"col-sm-12 h-100\" ng-class=\"workbench.workspaceUpdating ? \'pace\' : \'\'\"><div class=\"col-sm-10 h-100 p-0\"><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 1\"><workbench-dashboard current-workspace=\"workbench.currentIot3Worspace\" iot3-json-obj=\"workbench.iot3JSON\" side-active-tab-index=\"workbench.sideActiveTabIndex\" is-iot3-file-loaded=\"workbench.isIot3FileLoaded\" fn-create-scratch-iot=\"workbench.fnCreateScratchIot(detailsObj)\" fn-create-iot-from-existing=\"workbench.fnCreateIot3WorkspaceFromExisting(isScratch, detailsObj)\" fn-create-iot-from-import=\"workbench.fnCreateFromImport(detailsObj, fileData)\" fn-create-wb-from-import=\"workbench.fnImportWorkbenchDetails(fileData)\" fn-export-workbench=\"workbench.fnDownloadWorkbench()\" fn-edit-workspace-details=\"workbench.fnEditWorkspaceDetails(workspaceObj)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\" fn-change-tab-dashboard=\"workbench.fnChangeSideTab(item)\"></workbench-dashboard></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 2\"><iot3-info current-workspace=\"workbench.currentIot3Worspace\" iot3-info-obj=\"workbench.iot3JSON.info\" iot3-version=\"workbench.iot3JSON.iot3\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-info></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 3\"><iot3-registration current-workspace=\"workbench.currentIot3Worspace\" iot3-registration-obj=\"workbench.iot3JSON.registration\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-registration></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 4\"><iot3-engine current-workspace=\"workbench.currentIot3Worspace\" side-active-tab-index=\"workbench.sideActiveTabIndex\" iot3-engine-obj=\"workbench.iot3JSON.engine\" iot3-json-obj=\"workbench.iot3JSON\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-engine></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 5\"><iot3-global current-workspace=\"workbench.currentIot3Worspace\" iot3-global-obj=\"workbench.iot3JSON.global\" iot3-authentication-obj=\"workbench.iot3JSON.auth\" iot3-json-obj=\"workbench.iot3JSON\" side-active-tab-index=\"workbench.sideActiveTabIndex\" attributes-obj=\"workbench.iot3JSON.template.attributes\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-global></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 6\"><iot3-authentication current-workspace=\"workbench.currentIot3Worspace\" iot3-authentication-obj=\"workbench.iot3JSON.auth\" iot3-json-obj=\"workbench.iot3JSON\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-global-from-attr=\"workbench.fnUpdateGlobalVarFromAttr(valueObj)\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-authentication></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 7\"><iot3-topology current-workspace=\"workbench.currentIot3Worspace\" iot3-json-obj=\"workbench.iot3JSON\" iot3-topology-obj=\"workbench.iot3JSON.topology\" types-obj=\"workbench.iot3JSON.template.types\" mappings-obj=\"workbench.iot3JSON.template.filters.mappers\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-global-from-attr=\"workbench.fnUpdateGlobalVarFromAttr(valueObj)\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-topology></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 8\"><iot3-types current-workspace=\"workbench.currentIot3Worspace\" iot3-json-obj=\"workbench.iot3JSON\" types-obj=\"workbench.iot3JSON.template.types\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-types></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 9\"><iot3-attributes current-workspace=\"workbench.currentIot3Worspace\" attributes-obj=\"workbench.iot3JSON.template.attributes\" iot3-json-obj=\"workbench.iot3JSON\" types-obj=\"workbench.iot3JSON.template.types\" mappings-obj=\"workbench.iot3JSON.template.filters.mappers\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-global-from-attr=\"workbench.fnUpdateGlobalVarFromAttr(valueObj)\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-attributes></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 10\"><iot3-mappings current-workspace=\"workbench.currentIot3Worspace\" mappings-obj=\"workbench.iot3JSON.template.filters.mappers\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-update-workbench=\"workbench.fnUpdateCurrentWorkbench(updateType, updateValue)\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-mappings></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"workbench.sideActiveTabIndex.tabIndex === 11\"><iot3-detail current-workspace=\"workbench.currentIot3Worspace\" side-active-tab-index=\"workbench.sideActiveTabIndex\" fn-reverse-update=\"workbench.fnReverseUpdateIot3(yamlStr)\" fn-download-iot3=\"workbench.fnDownloadIot3File()\" fn-initiate-reset-workspace=\"workbench.fnResetWorkspace()\"></iot3-detail></div></div><div class=\"col-sm-2 h-100 p-r-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0 overflow-y-auto\" style=\"height: calc(100% - 55px)\"><div class=\"col-sm-12 p-0 h-100\"><nav class=\"workbench-sideNav navbar-default h-100 p-b-5 p-t-5\" role=\"navigation\" style=\"box-shadow: none\"><ul class=\"nav metismenu h-100\"><li ng-repeat=\"item in workbench.sideTabs track by $index\" ng-if=\"item.tabIndex === 1 ? true : workbench.isIot3FileLoaded\" ng-class=\"workbench.sideActiveTabIndex.tabIndex === item.tabIndex ? \'active\' : \'\'\" ng-click=\"workbench.fnChangeSideTab(item)\"><a><span>{{item.title}}</span></a></li></ul></nav></div></div><div class=\"content-box-footer d-flex align-items-center justify-content-flex-end p-t-10 p-b-10 col-sm-12\"><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"workbench.workspaceUpdating\"></app-spinner><div class=\"d-flex align-items-center justify-content-flex-end\" ng-if=\"!workbench.workspaceUpdating && workbench.isIot3FileLoaded\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"workbench.fnCreateIot3WorkspaceToCloud()\" ng-if=\"!workbench.workspaceUpdating && workbench.isIot3FileLoaded && workbench.currentIot3Worspace.isScratch\">Save Workbench</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"workbench.fnUpdateIot3WorkspaceToCloud()\" ng-if=\"!workbench.workspaceUpdating && workbench.isIot3FileLoaded && !workbench.currentIot3Worspace.isScratch\">Save Workbench</button></div></div></div></div></div></div>");
$templateCache.put("app/node/job/jobInfo/jobInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Job</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{jobObj.requestTypeString}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{jobObj.requestTypeString}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/lifecycle/lifecycleInfo/lifecycleInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/node/createNode/_old_createNode.html","<div ng-controller=\"createNodeCtrl as createNode\" ng-init=\"createNode.fnInit()\"><div class=\"modal-body registerNode\" id=\"createNode-modal-body\" ng-class=\"createNode.activeStep === 3 || createNode.activeStep === 4 || createNode.activeStep === 8? \'p-0\':\'\'\"><div class=\"\" ng-class=\"createNode.activeStep !== 3 && createNode.activeStep !== 4 && createNode.activeStep !== 8? \'row\':\'\'\"><div class=\"col-sm-12 p-l-20 p-r-20\" ng-if=\"createNode.activeStep === 1\"><div class=\"col-sm-12 m-t-10\"><h3>Select your IoT3 Source</h3><div><span>The loT3 file you use to register the node defines the interaction between ECSMon and the node. This includes how to communicate, authenticate and discover the node as well as which attributes to manage and whether they can be modified.</span></div><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\"><h3>Managed Integration</h3><div><span>ECSMon maintains hundreds of pre-build files that are automatically kept remain up-to-date.</span></div><div class=\"m-t-15 d-flex align-items-center\"><div class=\"m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Cisco\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cisco.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cisco</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Cradlepoint\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cradlepoint.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cradlepoint</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'JMA\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/jma.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>JMA</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'SOLiD\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/solid.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>SOLiD</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Juniper\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/juniper.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Juniper</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/search.svg#search\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Search all</span></div></div></div></div><div class=\"col-sm-12 m-t-30\"><h3>Custom Integration</h3><div><span>Use ECSMon\'s IoT3 specification to build custom integration into millions of node types.</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIoT3Documentation()\">Read more about IoT3.</span></div><div class=\"m-t-15 d-flex\"><div class=\"m-r-10 io3-grid\" ng-click=\"createNode.fnGotoIoTEditor();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/iot3.svg#iot3\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Upload IoT3</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnGotoImportWorkbench();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/importWorkbench.svg#importWorkbench\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Import Workbench</span></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 2\"><div class=\"col-sm-12 m-t-10\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"createNode.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isIoT3RefreshData\" search-identifier=\"\'iot3Search\'\" filters-arr=\"createNode.iot3SearchFiltersArr\" filter-query=\"createNode.iot3FilterQuery\" fn-filter-query-change=\"createNode.fnIOT3FilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"createNode.fnSetTableHeight()\" no-set-url=\"true\" default-tag-arr=\"createNode.defaultIoT3FilterArr\" table-alias=\"node_iot3_references\" default-sort-string=\"createNode.defaultIot3SortString\" sort-field-arr=\"createNode.iot3SortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isIoT3RefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isIOT3sLoading\" fn-resize=\"createNode.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isIOT3sLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th ng-if=\"!createNode.iot3sArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in createNode.iot3sArr track by $index\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.model}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in iot3Obj.versions\">{{versionObj}}</button></span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in iot3Obj.labels\">{{labelObj}}</button></span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.revision}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate.relativeTime + \' (\' + iot3Obj.createdDate.date + \')\'}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate.relativeTime}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate.relativeTime + \' (\' + iot3Obj.updatedDate.date + \')\'}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate.relativeTime}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isIOT3sLoading && createNode.iot3sArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnIoT3PageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"!createNode.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isIoT3WorkspacesRefreshData\" search-identifier=\"\'iot3WorkspaceSearch\'\" filters-arr=\"createNode.iot3WorkspacesSearchFiltersArr\" filter-query=\"createNode.iot3WorkspacesFilterQuery\" fn-filter-query-change=\"createNode.fnIOT3WorkspacesFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"createNode.fnSetTableHeight()\" no-set-url=\"true\" table-alias=\"node_iot3_workspaces\" sort-field-arr=\"createNode.iot3WorkspacesSortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isIoT3WorkspacesRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isIOT3WorkspacesLoading\" fn-resize=\"createNode.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-workspace-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isIOT3WorkspacesLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th ng-if=\"!createNode.iot3WorkspacesArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in createNode.iot3WorkspacesArr track by $index\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isIOT3WorkspacesLoading && createNode.iot3WorkspacesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 3\"><div class=\"col-sm-12 p-0 p-t-20\" ng-if=\"createNode.isIoT3DetailLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"container-with-footer tab-container\" ng-if=\"!createNode.isIoT3DetailLoading\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{createNode.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in createNode.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{createNode.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{createNode.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.created && createNode.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{createNode.iot3JSON.info.created}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.updated && createNode.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{createNode.iot3JSON.info.updated}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"col-sm-12 p-0 p-t-10\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"createNode.fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"createNode.uploadFiles()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import IoT3 File</a></span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"createNode.selectedTabIndex\"><uib-tab index=\"1\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Summary</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 1\"><div class=\"col-sm-12 p-0 m-t-30 floatingLabelInput\"><div class=\"col-sm-12 pace\" ng-repeat=\"inputObj in createNode.iot3Summary track by $index\"><div class=\"md-input m-b-20\" ng-if=\"inputObj.valueType !== \'object\'\"><input class=\"md-form-control\" required=\"\" id=\"{{inputObj.key}}\" type=\"text\" ng-model=\"inputObj.value\" name=\"{{inputObj.key}}\"> <span class=\"highlight\"></span> <label>{{inputObj.key}}</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-b-20 customInputDesign\" ng-if=\"inputObj.valueType === \'object\'\"><div class=\"p-t-10 p-l-20\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in inputObj.value\">{{labelObj}}</button></div><label class=\"customLabel text-primary text-uppercase\">{{inputObj.key}}</label></div></div><div class=\"col-sm-12 pace\" ng-if=\"!createNode.iot3Summary.length\"><h4>IoT3 Summary not found.</h4></div></div></div></uib-tab><uib-tab index=\"2\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Nodes</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 2\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 m-t-10 iot3-node-desc\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"iot3-register-node-table table-container\"><table id=\"iot3RegisterNodeTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\">Type</th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th ng-if=\"!createNode.iot3NodeArr.length\">No records found...</th></tr></thead><tbody id=\"iot3RegisterNodeTableBody\"><tr ng-repeat=\"iot3NodeObj in createNode.iot3NodeArr track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3NodeObj.type}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3NodeObj.name}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.price.value + \" \" + iot3NodeObj.price.unit}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.energy.value + \" \" + iot3NodeObj.energy.unit}}</span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.attributes.length + \" Attributes\"}}</span></div></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnViewAttributes(iot3NodeObj)\">View Attributes</button></div></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">IoT3</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"tabContent\" ng-init=\"createNode.fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit\"><ui-codemirror ng-model=\"createNode.selectedIoT3FileObj.iot3File\" ui-codemirror-opts=\"createNode.editorOptions\"></ui-codemirror></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 4\"><div class=\"row user-header m-l-0 w100\" ng-init=\"createNode.fnSecurityRegistrationInit()\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{createNode.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in createNode.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{createNode.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{createNode.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.created && createNode.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{createNode.iot3JSON.info.created }} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.updated && createNode.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{createNode.iot3JSON.info.updated}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-auto\" id=\"step4\"><div class=\"col-sm-12 m-t-15\"><h3>Security Registration</h3><div><span>In order to connect to your node we need a few bites of security information. If you are unsure about IP addresses or ports you can <span class=\"text-primary\" ng-click=\"createNode.fnOpenECUListModel()\">initiate a network scan</span> from the ECU.</span></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!createNode.isLoading\" ng-init=\"createNode.fnInitSecurityRegistration()\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createNode.newNodeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createNode.newNodeObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 d-flex\"><form id=\"iotForm\" role=\"form\" name=\"iotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"createNode.schema\" sf-form=\"createNode.form\" sf-model=\"createNode.model\"></div><button type=\"button\" class=\"btn btn-primary\" style=\"display: none\" ng-disabled=\"createNode.fnCheckIot3Validation(iotForm.$valid)\">Continue</button></form></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 5\"><div class=\"col-sm-12 p-0\" id=\"step5\"><div class=\"col-sm-12\"><h3>ECU</h3><div><span>Select the ECU you would like to register the node on. The node must be directly connected to the ECU or on a network that is accessible by the ECU.</span></div></div><div class=\"col-sm-12 m-t-25\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"createNode.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{createNode.project.name ? createNode.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createNode.ecuProjectSearch[createNode.ecuProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createNode.filterProject=(createNode.projectsArr | filter:createNode.ecuProjectSearch) track by $index\" ng-click=\"createNode.fnGetProjectEcu(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createNode.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createNode.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isECURefreshData\" search-identifier=\"\'ecuSearch\'\" filters-arr=\"createNode.searchECUFiltersArr\" filter-query=\"createNode.ecuFilterQuery\" fn-filter-query-change=\"createNode.fnECUFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.ecu\'\" fn-resize=\"createNode.fnSetTableHeight()\" is-column-view=\"createNode.isColumnView\" no-set-url=\"true\" sort-field-arr=\"createNode.sortECUFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isECURefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isEcusLoading\" fn-resize=\"createNode.fnSetECULoaderTableHeight()\"></table-loader><div class=\"node-register-ecus-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isEcusLoading\"><thead><tr><th ng-if=\"createNode.ecusArr.length\" class=\"p-8\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th ng-if=\"!createNode.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in createNode.ecusArr track by $index\" ng-click=\"ecuObj.isCheck = !ecuObj.isCheck;createNode.fnECUCheckUncheckHeader(ecuObj)\"><td class=\"p-8\"><input type=\"checkbox\" id=\"chk_ecu_{{$index}}\" ng-model=\"ecuObj.isCheck\" ng-change=\"createNode.fnECUCheckUncheckHeader(ecuObj)\"> <label for=\"chk_ecu_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"createNode.fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healthSpan\">{{ecuObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span></div></td><td><div class=\"d-flex align-items-center\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{!ecuObj.connected ?\'The request to register the node will be valid for 10 days after which time it will expire.\': \'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-sm btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation(); createNode.fnOpenEcuInfoTab(ecuObj,2)\">Register ECU</button> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"ECUs with registered nodes cannot have their projects changes.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div></td><td ng-show=\"!ecuObj.isEditable\"><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.phase === \'ACTIVE\'\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"ecuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"ecuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"ecuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"ecuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"ecuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"ecuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"ecuObj.lifecycleState === \'READY\'\">Ready</span></div></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Sync State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/syncState.svg#syncState\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.syncState === \'SYNCHRONIZED\'\">Synchronized</span> <span ng-if=\"ecuObj.syncState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\">Synchronizing</span> <span ng-if=\"ecuObj.syncState === \'NOT_SYNCHRONIZED\'\">Not Synchronized</span></span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isEcusLoading && createNode.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnECUPageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 6\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"createNode.isEcuNodeGetting\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" id=\"step6\" ng-if=\"!createNode.isEcuNodeGetting\"><div class=\"col-sm-12\"><h3>ECU Project</h3><div><span>Select the project if you would like to change the ECU project. ECUs with registered nodes cannot have their projects changes.</span></div></div><div class=\"col-sm-12 m-t-25\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createNode.changeProjectView\" ng-click=\"$event.stopPropagation();createNode.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createNode.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createNode.selectedProject.name\"><span>{{createNode.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createNode.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createNode.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createNode.selectedProject.name\">{{createNode.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createNode.selectedProject.name\">No Parent Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Select Project</label> <span ng-click=\"createNode.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createNode.projectSearch[createNode.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createNode.filterProject=(createNode.projectsArr | filter:createNode.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createNode.fnGetProjectInfo(projectObj)\" ng-if=\"projectObj.id !== \'all\'\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createNode.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 7\"><div class=\"col-sm-12 p-0\" id=\"step7\"><div class=\"col-sm-12\"><h3>Node Registration Summary</h3></div></div><div class=\"col-sm-12 m-t-20 d-flex flex-column justify-content-center align-items-center\"><div class=\"col-sm-6 p-0\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><div class=\"d-flex flex-column w100\" style=\"width: 78%\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{createNode.selectedEcuObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{createNode.selectedEcuObj.description}}</span></div></div><div class=\"d-flex flex-column align-items-center\" style=\"width: 20%\"><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{createNode.selectedEcuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"createNode.fnGetHealthColor(createNode.selectedEcuObj.health, createNode.selectedEcuObj)\"><span class=\"healthSpan\">{{createNode.selectedEcuObj.healthName}}</span></button></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"createNode.selectedEcuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.connected\">Connected</span> <span ng-if=\"!createNode.selectedEcuObj.connected\">Disconnected</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.project.name}}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.phase === \'UNREGISTERED\'\">Unregistered</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.lastSeenDate ? createNode.selectedEcuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'DISABLING\'\">Disabling</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'DISABLING\'\">Disabling</span></span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'READY\'\">Ready</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Version\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/versions.svg#versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.version}}</span></div></div></div></div></div></div></div><div class=\"col-sm-6 p-0 m-t-30\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{createNode.newNodeObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{createNode.newNodeObj.description}}</span></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 m-t-10 m-b-10\"><div class=\"col-sm-12 p-0 m-t-5\" ng-repeat=\"formObj in createNode.form\"><div class=\"col-sm-4 p-0\"><span>{{formObj.title}}</span></div><div class=\"col-sm-8 p-0\">{{createNode.model[formObj.key[0]]}}</div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 8\"><div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Job</span></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Registering Node</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-12 p-0\"><span class=\"m-0 m-t-10 ellipsis\">This process can take several minutes. If you would like to see your node register you can watch it here in real-time. Closing this window will have no effect on the registration.</span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"createNode.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in createNode.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent tab-node-registration-summary\" ng-if=\"createNode.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"createNode.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in createNode.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary === \'Open\'\"><span>Open <button class=\"btn btn-link p-0\" ng-click=\"createNode.fnOpenCreatedNode(createNode.nodeRegisteringObj.payload.node)\">{{createNode.nodeRegisteringObj.payload.node.name}}</button></span></div><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 2\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!createNode.isIOT3sLoading\"><label class=\"m-b-0\">Total: {{createNode.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-if=\"createNode.isIoT3References\" ng-class=\"{\'fa-spin\' : createNode.isIoT3Refresh}\" ng-click=\"createNode.fnReloadIoT3s();\" aria-hidden=\"true\"></i> <i class=\"fa fa-refresh p-10\" ng-if=\"!createNode.isIoT3References\" ng-class=\"{\'fa-spin\' : createNode.isIoT3WorkspacesRefresh}\" ng-click=\"createNode.fnReloadIoT3Workspaces();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 3\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"d-flex justify-content-center align-items-center m-r-10\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"!createNode.isChangesSync\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"createNode.isChangesSync\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!createNode.isChangesSync\" ng-click=\"createNode.fnChangeDone()\">Save changes</button></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isIoT3DetailLoading\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isIoT3DetailLoading\" ng-disabled=\"!createNode.isValidateIoT3File();\" ng-click=\"createNode.fnGotoNextStep(4)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 4\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-disabled=\"!createNode.isIoT3FormValid || !createNode.newNodeObj.name.length\" ng-click=\"createNode.fnGotoNextStep(5)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 5\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!createNode.isEcusLoading\"><label class=\"m-b-0\">Total: {{createNode.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : createNode.isECURefresh}\" ng-click=\"createNode.fnECUReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-disabled=\"!createNode.isEcuObjSelected()\" ng-click=\"createNode.fnGotoNextStep(6)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 6\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isECUProjectUpdating\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isECUProjectUpdating\" ng-disabled=\"!createNode.isEcuObjSelected()\" ng-click=\"createNode.fnUpdateECUProject()\">Continue</button><div class=\"col-sm-12 p-0\" ng-if=\"createNode.isECUProjectUpdating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 7\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isNodeRegistering\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isNodeRegistering\" ng-click=\"createNode.fnRegisterNewNode()\">Register</button><div class=\"col-sm-12\" ng-if=\"createNode.isNodeRegistering\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 8\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div>");
$templateCache.put("app/node/node/createNode/createNode.html","<div ng-controller=\"createNodeCtrl as createNode\" ng-init=\"createNode.fnInit()\"><div class=\"modal-body registerNode\" id=\"createNode-modal-body\" ng-class=\"createNode.activeStep === 3 || createNode.activeStep === 4 || createNode.activeStep === 8? \'p-0\':\'\'\"><div class=\"\" ng-class=\"createNode.activeStep !== 3 && createNode.activeStep !== 4 && createNode.activeStep !== 8? \'row\':\'\'\"><div class=\"col-sm-12 p-l-20 p-r-20\" ng-if=\"createNode.activeStep === 1\"><div class=\"col-sm-12 m-t-10\"><h3>Select your IoT3 Source</h3><div><span>The loT3 file you use to register the node defines the interaction between ECSMon and the node. This includes how to communicate, authenticate and discover the node as well as which attributes to manage and whether they can be modified.</span></div><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\"><h3>Managed Integration</h3><div><span>ECSMon maintains hundreds of pre-build files that are automatically kept remain up-to-date.</span></div><div class=\"m-t-15 d-flex align-items-center\"><div class=\"m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Cisco\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cisco.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cisco</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Cradlepoint\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cradlepoint.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cradlepoint</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'JMA\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/jma.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>JMA</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'SOLiD\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/solid.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>SOLiD</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'Juniper\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/juniper.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Juniper</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnAddDefaultIoT3Filters(\'\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/search.svg#search\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Search all</span></div></div></div></div><div class=\"col-sm-12 m-t-30\"><h3>Custom Integration</h3><div><span>Use ECSMon\'s IoT3 specification to build custom integration into millions of node types.</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIoT3Documentation()\">Read more about IoT3.</span></div><div class=\"m-t-15 d-flex\"><div class=\"m-r-10 io3-grid\" ng-click=\"createNode.fnGotoIoTEditor();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/iot3.svg#iot3\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Upload IoT3</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"createNode.fnGotoImportWorkbench();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/importWorkbench.svg#importWorkbench\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Import Workbench</span></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 2\"><div class=\"col-sm-12 m-t-10\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"createNode.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isIoT3RefreshData\" search-identifier=\"\'iot3Search\'\" filters-arr=\"createNode.iot3SearchFiltersArr\" filter-query=\"createNode.iot3FilterQuery\" fn-filter-query-change=\"createNode.fnIOT3FilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"createNode.fnSetTableHeight()\" no-set-url=\"true\" default-tag-arr=\"createNode.defaultIoT3FilterArr\" table-alias=\"node_iot3_references\" default-sort-string=\"createNode.defaultIot3SortString\" sort-field-arr=\"createNode.iot3SortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isIoT3RefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isIOT3sLoading\" fn-resize=\"createNode.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isIOT3sLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3sArr.length\"></th><th ng-if=\"!createNode.iot3sArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in createNode.iot3sArr track by $index\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.model}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in iot3Obj.versions\">{{versionObj}}</button></span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in iot3Obj.labels\">{{labelObj}}</button></span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.revision}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate.relativeTime + \' (\' + iot3Obj.createdDate.date + \')\'}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate.relativeTime}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate.relativeTime + \' (\' + iot3Obj.updatedDate.date + \')\'}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate.relativeTime}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3File(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isIOT3sLoading && createNode.iot3sArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnIoT3PageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnIoT3PageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"!createNode.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isIoT3WorkspacesRefreshData\" search-identifier=\"\'iot3WorkspaceSearch\'\" filters-arr=\"createNode.iot3WorkspacesSearchFiltersArr\" filter-query=\"createNode.iot3WorkspacesFilterQuery\" fn-filter-query-change=\"createNode.fnIOT3WorkspacesFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"createNode.fnSetTableHeight()\" no-set-url=\"true\" table-alias=\"node_iot3_workspaces\" sort-field-arr=\"createNode.iot3WorkspacesSortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isIoT3WorkspacesRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isIOT3WorkspacesLoading\" fn-resize=\"createNode.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-workspace-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isIOT3WorkspacesLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3WorkspacesArr.length\"></th><th ng-if=\"!createNode.iot3WorkspacesArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in createNode.iot3WorkspacesArr track by $index\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnSelectIoT3WorkspacesFile(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isIOT3WorkspacesLoading && createNode.iot3WorkspacesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnIoT3WorkspacesPageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 3\"><div class=\"col-sm-12 p-0 p-t-20\" ng-if=\"createNode.isIoT3DetailLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"container-with-footer tab-container\" ng-if=\"!createNode.isIoT3DetailLoading\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{createNode.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in createNode.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{createNode.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{createNode.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.created && createNode.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{createNode.iot3JSON.info.created}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.updated && createNode.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{createNode.iot3JSON.info.updated}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"col-sm-12 p-0 p-t-10\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"createNode.fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"createNode.uploadFiles()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import IoT3 File</a></span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"createNode.selectedTabIndex\"><uib-tab index=\"1\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Summary</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 1\"><div class=\"col-sm-12 p-0 m-t-30 floatingLabelInput\"><div class=\"col-sm-12 pace\" ng-repeat=\"inputObj in createNode.iot3Summary track by $index\"><div class=\"md-input m-b-20\" ng-if=\"inputObj.valueType !== \'object\'\"><input class=\"md-form-control\" required=\"\" id=\"{{inputObj.key}}\" type=\"text\" ng-model=\"inputObj.value\" name=\"{{inputObj.key}}\"> <span class=\"highlight\"></span> <label>{{inputObj.key}}</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-b-20 customInputDesign\" ng-if=\"inputObj.valueType === \'object\'\"><div class=\"p-t-10 p-l-20\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in inputObj.value\">{{labelObj}}</button></div><label class=\"customLabel text-primary text-uppercase\">{{inputObj.key}}</label></div></div><div class=\"col-sm-12 pace\" ng-if=\"!createNode.iot3Summary.length\"><h4>IoT3 Summary not found.</h4></div></div></div></uib-tab><uib-tab index=\"2\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Nodes</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 2\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 m-t-10 iot3-node-desc\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"createNode.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"iot3-register-node-table table-container\"><table id=\"iot3RegisterNodeTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\">Type</th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.iot3NodeArr.length\"></th><th ng-if=\"!createNode.iot3NodeArr.length\">No records found...</th></tr></thead><tbody id=\"iot3RegisterNodeTableBody\"><tr ng-repeat=\"iot3NodeObj in createNode.iot3NodeArr track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3NodeObj.type}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3NodeObj.name}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.price.value + \" \" + iot3NodeObj.price.unit}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.energy.value + \" \" + iot3NodeObj.energy.unit}}</span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.attributes.length + \" Attributes\"}}</span></div></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createNode.fnViewAttributes(iot3NodeObj)\">View Attributes</button></div></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"createNode.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">IoT3</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"tabContent\" ng-init=\"createNode.fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit\"><ui-codemirror ng-model=\"createNode.selectedIoT3FileObj.iot3File\" ui-codemirror-opts=\"createNode.editorOptions\"></ui-codemirror></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 4\"><div class=\"row user-header m-l-0 w100\" ng-init=\"createNode.fnSecurityRegistrationInit()\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{createNode.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in createNode.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{createNode.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{createNode.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.created && createNode.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{createNode.iot3JSON.info.created }} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"createNode.iot3JSON.info.updated && createNode.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{createNode.iot3JSON.info.updated}} <span ng-if=\"createNode.iot3JSON.info.author\">by {{createNode.iot3JSON.info.author}}</span></label></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-auto\" id=\"step4\"><div class=\"col-sm-12 m-t-15\"><h3>Security Registration</h3><div><span>In order to connect to your node we need a few bites of security information. If you are unsure about IP addresses or ports you can <span class=\"text-primary\" ng-click=\"createNode.fnOpenECUListModel()\">initiate a network scan</span> from the ECU.</span></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!createNode.isLoading\" ng-init=\"createNode.fnInitSecurityRegistration()\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createNode.newNodeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createNode.newNodeObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 d-flex\"><form id=\"iotForm\" role=\"form\" name=\"iotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"createNode.schema\" sf-form=\"createNode.form\" sf-model=\"createNode.model\"></div><button type=\"button\" class=\"btn btn-primary\" style=\"display: none\" ng-disabled=\"createNode.fnCheckIot3Validation(iotForm.$valid)\">Continue</button></form></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 5\"><div class=\"col-sm-12 p-0\" id=\"step5\"><div class=\"col-sm-12\"><h3>ECU</h3><div><span>Select the ECU you would like to register the node on. The node must be directly connected to the ECU or on a network that is accessible by the ECU.</span></div></div><div class=\"col-sm-12 m-t-25\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"createNode.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{createNode.project.name ? createNode.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createNode.ecuProjectSearch[createNode.ecuProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createNode.filterProject=(createNode.projectsArr | filter:createNode.ecuProjectSearch) track by $index\" ng-click=\"createNode.fnGetProjectEcu(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createNode.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createNode.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"createNode.isECURefreshData\" search-identifier=\"\'ecuSearch\'\" filters-arr=\"createNode.searchECUFiltersArr\" filter-query=\"createNode.ecuFilterQuery\" fn-filter-query-change=\"createNode.fnECUFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.ecu\'\" fn-resize=\"createNode.fnSetTableHeight()\" is-column-view=\"createNode.isColumnView\" no-set-url=\"true\" sort-field-arr=\"createNode.sortECUFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"createNode.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"createNode.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"createNode.csvHeaderArr\" filename=\"createNode.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"createNode.isECURefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"createNode.isEcusLoading\" fn-resize=\"createNode.fnSetECULoaderTableHeight()\"></table-loader><div class=\"node-register-ecus-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!createNode.isEcusLoading\"><thead><tr><th ng-if=\"createNode.ecusArr.length\" class=\"p-8\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"createNode.ecusArr.length\"></th><th ng-if=\"!createNode.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in createNode.ecusArr track by $index\" ng-click=\"ecuObj.isCheck = !ecuObj.isCheck;createNode.fnECUCheckUncheckHeader(ecuObj)\"><td class=\"p-8\"><input type=\"checkbox\" id=\"chk_ecu_{{$index}}\" ng-model=\"ecuObj.isCheck\" ng-change=\"createNode.fnECUCheckUncheckHeader(ecuObj)\"> <label for=\"chk_ecu_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"createNode.fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healthSpan\">{{ecuObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span></div></td><td><div class=\"d-flex align-items-center\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{!ecuObj.connected ?\'The request to register the node will be valid for 10 days after which time it will expire.\': \'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-sm btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation(); createNode.fnOpenEcuInfoTab(ecuObj,2)\">Register ECU</button> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"ECUs with registered nodes cannot have their projects changes.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div></td><td ng-show=\"!ecuObj.isEditable\"><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.phase === \'ACTIVE\'\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"ecuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"ecuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"ecuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"ecuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"ecuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"ecuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"ecuObj.lifecycleState === \'READY\'\">Ready</span></div></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Sync State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/syncState.svg#syncState\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.syncState === \'SYNCHRONIZED\'\">Synchronized</span> <span ng-if=\"ecuObj.syncState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\">Synchronizing</span> <span ng-if=\"ecuObj.syncState === \'NOT_SYNCHRONIZED\'\">Not Synchronized</span></span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createNode.isEcusLoading && createNode.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createNode.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 10; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 20; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 50; createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createNode.perPage = 100; createNode.fnECUPageChanged(createNode.currentPage,createNode.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"createNode.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"createNode.currentPage\" items-per-page=\"createNode.perPage\" max-size=\"createNode.maxSize\" boundary-links=\"true\" ng-click=\"createNode.fnECUPageChanged(createNode.currentPage, createNode.perPage)\"></ul></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 6\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"createNode.isEcuNodeGetting\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" id=\"step6\" ng-if=\"!createNode.isEcuNodeGetting\"><div class=\"col-sm-12\"><h3>ECU Project</h3><div><span>Select the project if you would like to change the ECU project. ECUs with registered nodes cannot have their projects changes.</span></div></div><div class=\"col-sm-12 m-t-25\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createNode.changeProjectView\" ng-click=\"$event.stopPropagation();createNode.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createNode.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createNode.selectedProject.name\"><span>{{createNode.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createNode.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createNode.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createNode.selectedProject.name\">{{createNode.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createNode.selectedProject.name\">No Parent Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Select Project</label> <span ng-click=\"createNode.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createNode.projectSearch[createNode.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createNode.filterProject=(createNode.projectsArr | filter:createNode.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createNode.fnGetProjectInfo(projectObj)\" ng-if=\"projectObj.id !== \'all\'\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createNode.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 7\"><div class=\"col-sm-12 p-0\" id=\"step7\"><div class=\"col-sm-12\"><h3>Node Registration Summary</h3></div></div><div class=\"col-sm-12 m-t-20 d-flex flex-column justify-content-center align-items-center\"><div class=\"col-sm-6 p-0\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><div class=\"d-flex flex-column w100\" style=\"width: 78%\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{createNode.selectedEcuObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{createNode.selectedEcuObj.description}}</span></div></div><div class=\"d-flex flex-column align-items-center\" style=\"width: 20%\"><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{createNode.selectedEcuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"createNode.fnGetHealthColor(createNode.selectedEcuObj.health, createNode.selectedEcuObj)\"><span class=\"healthSpan\">{{createNode.selectedEcuObj.healthName}}</span></button></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"createNode.selectedEcuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.connected\">Connected</span> <span ng-if=\"!createNode.selectedEcuObj.connected\">Disconnected</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.project.name}}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.phase === \'UNREGISTERED\'\">Unregistered</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"createNode.selectedEcuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.lastSeenDate ? createNode.selectedEcuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"createNode.selectedEcuObj.vpn === \'DISABLING\'\">Disabling</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"createNode.selectedEcuObj.ntp === \'DISABLING\'\">Disabling</span></span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"createNode.selectedEcuObj.lifecycleState === \'READY\'\">Ready</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Version\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/versions.svg#versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{createNode.selectedEcuObj.version}}</span></div></div></div></div></div></div></div><div class=\"col-sm-6 p-0 m-t-30\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{createNode.newNodeObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{createNode.newNodeObj.description}}</span></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 m-t-10 m-b-10\"><div class=\"col-sm-12 p-0 m-t-5\" ng-repeat=\"formObj in createNode.form\"><div class=\"col-sm-4 p-0\"><span>{{formObj.title}}</span></div><div class=\"col-sm-8 p-0\">{{createNode.model[formObj.key[0]]}}</div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"createNode.activeStep === 8\"><div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Job</span></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Registering Node</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-12 p-0\"><span class=\"m-0 m-t-10 ellipsis\">This process can take several minutes. If you would like to see your node register you can watch it here in real-time. Closing this window will have no effect on the registration.</span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"createNode.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in createNode.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent tab-node-registration-summary\" ng-if=\"createNode.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"createNode.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in createNode.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary === \'Open\'\"><span>Open <button class=\"btn btn-link p-0\" ng-click=\"createNode.fnOpenCreatedNode(createNode.nodeRegisteringObj.payload.node)\">{{createNode.nodeRegisteringObj.payload.node.name}}</button></span></div><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 2\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!createNode.isIOT3sLoading\"><label class=\"m-b-0\">Total: {{createNode.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-if=\"createNode.isIoT3References\" ng-class=\"{\'fa-spin\' : createNode.isIoT3Refresh}\" ng-click=\"createNode.fnReloadIoT3s();\" aria-hidden=\"true\"></i> <i class=\"fa fa-refresh p-10\" ng-if=\"!createNode.isIoT3References\" ng-class=\"{\'fa-spin\' : createNode.isIoT3WorkspacesRefresh}\" ng-click=\"createNode.fnReloadIoT3Workspaces();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 3\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-if=\"createNode.selectedTabIndex === 3\"><div class=\"d-flex justify-content-center align-items-center m-r-10\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"!createNode.isChangesSync\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"createNode.isChangesSync\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!createNode.isChangesSync\" ng-click=\"createNode.fnChangeDone()\">Save changes</button></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isIoT3DetailLoading\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isIoT3DetailLoading\" ng-disabled=\"!createNode.isValidateIoT3File();\" ng-click=\"createNode.fnGotoNextStep(4)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 4\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-disabled=\"!createNode.isIoT3FormValid || !createNode.newNodeObj.name.length\" ng-click=\"createNode.fnGotoNextStep(5)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 5\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!createNode.isEcusLoading\"><label class=\"m-b-0\">Total: {{createNode.totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : createNode.isECURefresh}\" ng-click=\"createNode.fnECUReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-disabled=\"!createNode.isEcuObjSelected()\" ng-click=\"createNode.fnGotoNextStep(6)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 6\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isECUProjectUpdating\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isECUProjectUpdating\" ng-disabled=\"!createNode.isEcuObjSelected()\" ng-click=\"createNode.fnUpdateECUProject()\">Continue</button><div class=\"col-sm-12 p-0\" ng-if=\"createNode.isECUProjectUpdating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 7\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!createNode.isNodeRegistering\" ng-click=\"createNode.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!createNode.isNodeRegistering\" ng-click=\"createNode.fnRegisterNewNode()\">Register</button><div class=\"col-sm-12\" ng-if=\"createNode.isNodeRegistering\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"createNode.activeStep === 8\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div>");
$templateCache.put("app/node/node/nodeDiscover/nodeDiscover.html","<div ng-controller=\"nodeDiscoverCtrl as nodeDiscover\" ng-init=\"nodeDiscover.fnInit()\"><div class=\"modal-body p-0\" id=\"node-discover-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeDiscover.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"nodeDiscover.nodeDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching Node Details...</h2></div><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center flex-column justify-content-center\" ng-if=\"!nodeDiscover.nodeDetailsLoading\"><div class=\"col-sm-6 p-0 d-flex justify-content-center align-items-center flex-column\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0\"><b>{{nodeDiscover.nodeObj.name}}</b></label></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0 font-italic opacity-5\">{{nodeDiscover.nodeObj.description}}</label></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!nodeDiscover.nodeDetailsLoading && (nodeDiscover.nodeObj && nodeDiscover.nodeObj.name) && !nodeDiscover.discoverNode\" ng-click=\"nodeDiscover.fnRequestNodeDiscover()\" tabindex=\"12\">Start Node Discover</button><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\" ng-if=\"nodeDiscover.discoverNode\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeDiscover.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Re-discover Nodes</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your node re-discover you can watch it here in real-time. Closing this window will have no effect on the re-discover.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeDiscover.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeDiscover.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeDiscover.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"nodeDiscover.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in nodeDiscover.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-12 p-r-12 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Node</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_NODE_NAME && userPermissionsObj.UPDATE_NODE_DESCRIPTION && nodeObj.lifecycleState === \'READY\' && selectedTab === 4\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.ENABLE_NODE && nodeObj.lifecycleState === \'READY\' && nodeObj.operation === \'DISABLED\'\" ng-click=\"fnEnableNode(nodeObj)\"><a class=\"btn btn-link\">Enable</a></li><li ng-if=\"userPermissionsObj.DISABLE_NODE && nodeObj.lifecycleState === \'READY\' && nodeObj.operation === \'ENABLED\'\" ng-click=\"fnDisabledNode(nodeObj)\"><a class=\"btn btn-link\">Disable</a></li><li ng-if=\"userPermissionsObj.DEPLOY_NODE_CHANGES && nodeObj.syncState === \'NOT_SYNCHRONIZED\'\" ng-click=\"fnDeployNode(nodeObj)\"><a class=\"btn btn-link\">Synchronize</a></li><li ng-if=\"userPermissionsObj.REQUEST_NODE_TUNNEL\" ng-click=\"fnRequestNodeTunnel(nodeObj)\"><a class=\"btn btn-link\">Open Tunnel</a></li><li ng-if=\"userPermissionsObj.REPLACE_NODE_IOT3\" ng-click=\"fnRequestReplaceRegistration(nodeObj)\"><a class=\"btn btn-link\">Update IoT3</a></li><li ng-if=\"isRediscoveryPermission && nodeObj.lifecycleState === \'READY\'\" ng-click=\"fnRequestReplaceRediscovery(nodeObj)\"><a class=\"btn btn-link\">Discover</a></li><li ng-if=\"userPermissionsObj.REGISTER_NODE\" ng-click=\"fnCloneNodeSettings(nodeObj)\"><a class=\"btn btn-link\">Clone Settings</a></li></ul></div></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-11 p-0\"><h1 class=\"m-0 font-bold ellipsis\" ng-if=\"isFullWidthDevice\">{{nodeObj.name}}</h1><h3 class=\"m-0 font-bold ellipsis\" ng-if=\"!isFullWidthDevice\">{{nodeObj.name}}</h3></div><div class=\"col-sm-1 p-0 d-flex justify-content-flex-end align-items-center\"><div uib-tooltip=\"{{nodeObj.connected ?\'Node Connection: Connected\' : \'Node Connection: Disconnected\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\" ng-if=\"isFullWidthDevice\">{{nodeObj.description ? nodeObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0 ellipsis\" ng-if=\"!isFullWidthDevice\">{{nodeObj.description ? nodeObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{nodeObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><span class=\"ellipsis m-b-0 d-flex align-items-center justify-content-flex-end\"><span ng-if=\"nodeObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"nodeObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"nodeObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"nodeObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"nodeObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"nodeObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"nodeObj.lifecycleState === \'READY\'\">Ready</span> <span ng-if=\"nodeObj.lifecycleState === \'FAILED\'\">Failed</span><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor m-l-10\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div></span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/node/nodeSynchronizing/nodeSynchronizing.html","<div ng-controller=\"nodeSynchronizingCtrl as nodeSynchronizing\" ng-init=\"nodeSynchronizing.fnInit()\"><div class=\"modal-body p-0\" id=\"node-synchronizing-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeSynchronizing.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"nodeSynchronizing.nodeDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching Node Details...</h2></div><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center flex-column justify-content-center\" ng-if=\"!nodeSynchronizing.nodeDetailsLoading\"><div class=\"col-sm-6 p-0 d-flex justify-content-center align-items-center flex-column\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0\"><b>{{nodeSynchronizing.nodeObj.name}}</b></label></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><label class=\"m-0 font-italic opacity-5\">{{nodeSynchronizing.nodeObj.description}}</label></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!nodeSynchronizing.nodeDetailsLoading && (nodeSynchronizing.nodeObj && nodeSynchronizing.nodeObj.name) && !nodeSynchronizing.deploysUnsynchronizedNode\" ng-click=\"nodeSynchronizing.fnRequestNodeSynchronizing()\" tabindex=\"12\">Start Node Synchronizing</button><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center\" ng-if=\"nodeSynchronizing.deploysUnsynchronizedNode\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeSynchronizing.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Synchronizing Node</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Synchronizing Node you can watch it here in real-time. Closing this window will have no effect on the Synchronizing.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeSynchronizing.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeSynchronizing.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeSynchronizing.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"nodeSynchronizing.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in nodeSynchronizing.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div></div>");
$templateCache.put("app/node/node/nodeTunnel/nodeTunnel.html","<div ng-controller=\"nodeTunnelCtrl as nodeTunnel\" ng-init=\"nodeTunnel.fnInit()\"><div class=\"modal-body p-0\" id=\"node-tunnel-modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeTunnel.activeStep === 1\"><div class=\"col-sm-12 d-flex align-items-center p-0 flex-column justify-content-center h-100\" ng-if=\"nodeTunnel.nodeDetailsLoading\"><div class=\"col-sm-12 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><h2 class=\"m-0 font-bold m-t-20\">Fetching Node Details...</h2></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!nodeTunnel.nodeDetailsLoading\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex align-items-center p-0 p-t-5\"><h2 class=\"m-0 font-bold\"><label>Select the Type of Tunnel you want to open.</label></h2></div></div><div class=\"col-sm-12 p-15\" ng-if=\"!nodeTunnel.tunnelTypes.length\">The node does not support any type of tunnels</div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"nodeTunnel.tunnelTypes.length\"><div class=\"col-sm-12 p-15\" ng-class=\"nodeTunnel.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeTunnel.selectedTunnelType}}</span> <label class=\"titleLabel\">Verify Selector Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"tunnelTypeObj in nodeTunnel.tunnelTypes\"><a ng-click=\"nodeTunnel.fnSelectTunnelType(tunnelTypeObj)\"><span ng-class=\"tunnelTypeObj.name === nodeTunnel.selectedTunnelType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"tunnelTypeObj.name === nodeTunnel.selectedTunnelType\"></i></span> <span>{{tunnelTypeObj.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-15\" ng-class=\"nodeTunnel.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeTunnel.selectedTimeout.displayName}}</span> <label class=\"titleLabel\">Tunnel duration</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"timeoutOption in nodeTunnel.timeOutOptions\"><a ng-click=\"nodeTunnel.fnChangeTimeout(timeoutOption)\"><span ng-class=\"timeoutOption.displayName === nodeTunnel.selectedTimeout.displayName ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"timeoutOption.displayName === nodeTunnel.selectedTimeout.displayName\"></i></span> <span>{{timeoutOption.displayName}}</span></a></li></ul></div></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"nodeTunnel.activeStep === 2\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Open Tunnel</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. You can watch your open tunnel here in real-time. Closing this window will stop the tunnel request.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeTunnel.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeTunnel.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeTunnel.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit custom-node-register-terminal\" ng-init=\"nodeTunnel.fnIntiJob()\" style=\"position: relative\"><div class=\"p-t-2 p-b-2 terminal-line-number temp-terminal-line-number\"></div><div class=\"p-t-2 p-b-2 terminal-date-time temp-terminal-date-time\"></div><div class=\"p-t-2 p-b-2 terminal-summary temp-terminal-summary\"></div><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"summaryObj in nodeTunnel.jobSummaryArr track by $index\"><div class=\"p-t-2 p-b-2 terminal-line-number\"><span>{{$index + 1}}</span></div><div class=\"p-t-2 p-b-2 terminal-date-time\"><div class=\"font-monospace p-l-4 p-r-4\">&nbsp;> {{summaryObj.dateTime}}</div></div><div class=\"p-t-2 p-b-2 terminal-summary\"><div class=\"font-monospace\" ng-if=\"summaryObj.summary !== \'Open\'\">{{summaryObj.summary}}</div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-flex-end\" ng-if=\"nodeTunnel.activeStep === 1\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-r-3\" ng-if=\"!nodeTunnel.nodeDetailsLoading && !nodeTunnel.isTunnelRequestActive\" ng-class=\"nodeTunnel.selectedTunnelType.length ? \'\' : \'pace opacity-5\'\" ng-click=\"nodeTunnel.fnRequestNodeTunnel()\" tabindex=\"12\">Start Tunnel Request</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"nodeTunnel.isTunnelRequestActive\"></app-spinner></div></div></div>");
$templateCache.put("app/node/node/updateIoT3/updateIoT3.html","<div ng-controller=\"updateIoT3Ctrl as updateIoT3\" ng-init=\"updateIoT3.fnInit()\"><div class=\"modal-body registerNode\" id=\"createNode-modal-body\" ng-class=\"updateIoT3.activeStep === 3 || updateIoT3.activeStep === 4 || updateIoT3.activeStep === 6? \'p-0\':\'\'\"><div class=\"\" ng-class=\"updateIoT3.activeStep !== 3 && updateIoT3.activeStep !== 4 && updateIoT3.activeStep !== 6? \'row\':\'\'\"><div class=\"col-sm-12 p-l-20 p-r-20\" ng-if=\"updateIoT3.activeStep === 1\"><div class=\"col-sm-12 m-t-10\"><h3>Select your IoT3 Source</h3><div><span>The loT3 file you use to register the node defines the interaction between ECSMon and the node. This includes how to communicate, authenticate and discover the node as well as which attributes to manage and whether they can be modified.</span></div><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"updateIoT3.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\"><h3>Managed Integration</h3><div><span>ECSMon maintains hundreds of pre-build files that are automatically kept remain up-to-date.</span></div><div class=\"m-t-15 d-flex align-items-center\"><div class=\"m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'Cisco\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cisco.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cisco</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'Cradlepoint\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/cradlepoint.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Cradlepoint</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'JMA\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/jma.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>JMA</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'SOLiD\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/solid.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>SOLiD</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'Juniper\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><img class=\"grid-img\" src=\"assets/images/IoT3/juniper.png\"></div><div class=\"d-flex align-items-center justify-content-center\"><span>Juniper</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnAddDefaultIoT3Filters(\'\')\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/search.svg#search\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Search all</span></div></div></div></div><div class=\"col-sm-12 m-t-30\"><h3>Custom Integration</h3><div><span>Use ECSMon\'s IoT3 specification to build custom integration into millions of node types.</span> <span class=\"text-primary\" ng-click=\"updateIoT3.fnOpenIoT3Documentation()\">Read more about IoT3.</span></div><div class=\"m-t-15 d-flex\"><div class=\"m-r-10 io3-grid\" ng-click=\"updateIoT3.fnGotoIoTEditor();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/iot3.svg#iot3\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Upload IoT3</span></div></div><div class=\"m-l-10 m-r-10 io3-grid\" ng-click=\"updateIoT3.fnGotoImportWorkbench();\"><div class=\"icon-grid d-flex align-items-center justify-content-center\"><svg class=\"svgIconFillTextSecondaryColor fit-svg\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/importWorkbench.svg#importWorkbench\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center\"><span>Import Workbench</span></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"updateIoT3.activeStep === 2\"><div class=\"col-sm-12 m-t-10\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"updateIoT3.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"updateIoT3.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"updateIoT3.isIoT3RefreshData\" search-identifier=\"\'iot3Search\'\" filters-arr=\"updateIoT3.iot3SearchFiltersArr\" filter-query=\"updateIoT3.iot3FilterQuery\" fn-filter-query-change=\"updateIoT3.fnIOT3FilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"updateIoT3.fnSetTableHeight()\" no-set-url=\"true\" default-tag-arr=\"updateIoT3.defaultIoT3FilterArr\" table-alias=\"node_iot3_references\" default-sort-string=\"updateIoT3.defaultIot3SortString\" sort-field-arr=\"updateIoT3.iot3SortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"updateIoT3.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"updateIoT3.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"updateIoT3.csvHeaderArr\" filename=\"updateIoT3.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"updateIoT3.isIoT3RefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"updateIoT3.isIOT3sLoading\" fn-resize=\"updateIoT3.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!updateIoT3.isIOT3sLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3sArr.length\"></th><th ng-if=\"!updateIoT3.iot3sArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in updateIoT3.iot3sArr track by $index\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3File(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.model}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in iot3Obj.versions\">{{versionObj}}</button></span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in iot3Obj.labels\">{{labelObj}}</button></span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3Obj.revision}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3File(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3File(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!updateIoT3.isIOT3sLoading && updateIoT3.iot3sArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{updateIoT3.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 10; updateIoT3.fnIoT3PageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 20; updateIoT3.fnIoT3PageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 50; updateIoT3.fnIoT3PageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 100; updateIoT3.fnIoT3PageChanged(updateIoT3.currentPage,updateIoT3.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"updateIoT3.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"updateIoT3.currentPage\" items-per-page=\"updateIoT3.perPage\" max-size=\"updateIoT3.maxSize\" boundary-links=\"true\" ng-click=\"updateIoT3.fnIoT3PageChanged(updateIoT3.currentPage, updateIoT3.perPage)\"></ul></div></div></div></div></div></div></div><div class=\"col-sm-12 m-t-30\" ng-if=\"!updateIoT3.isIoT3References\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"updateIoT3.isIoT3WorkspacesRefreshData\" search-identifier=\"\'iot3WorkspaceSearch\'\" filters-arr=\"updateIoT3.iot3WorkspacesSearchFiltersArr\" filter-query=\"updateIoT3.iot3WorkspacesFilterQuery\" fn-filter-query-change=\"updateIoT3.fnIOT3WorkspacesFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.node\'\" fn-resize=\"updateIoT3.fnSetTableHeight()\" no-set-url=\"true\" table-alias=\"node_iot3_workspaces\" sort-field-arr=\"updateIoT3.iot3WorkspacesSortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"updateIoT3.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"updateIoT3.getUserCSVData()\" id=\"csvAnchor\" csv-header=\"updateIoT3.csvHeaderArr\" filename=\"updateIoT3.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"updateIoT3.isIoT3WorkspacesRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"updateIoT3.isIOT3WorkspacesLoading\" fn-resize=\"updateIoT3.fnSetLoaderTableHeight()\"></table-loader><div class=\"iot3-workspace-table table-container\"><table id=\"healthsTable\" class=\"table table-striped table-check-box\" ng-if=\"!updateIoT3.isIOT3WorkspacesLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3WorkspacesArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3WorkspacesArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3WorkspacesArr.length\"></th><th ng-if=\"!updateIoT3.iot3WorkspacesArr.length\">No records found...</th></tr></thead><tbody id=\"healthTable\"><tr ng-repeat=\"iot3Obj in updateIoT3.iot3WorkspacesArr track by $index\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3WorkspacesFile(iot3Obj,3)\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3Obj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3Obj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate}} <span ng-if=\"iot3Obj.createdBy\">by {{iot3Obj.createdBy}}</span></label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{iot3Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Updated {{iot3Obj.updatedDate}} <span ng-if=\"iot3Obj.updatedBy\">by {{iot3Obj.updatedBy}}</span></label></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3WorkspacesFile(iot3Obj,4)\">Quick Registration</button></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();updateIoT3.fnSelectIoT3WorkspacesFile(iot3Obj,3)\">Explore</button></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!updateIoT3.isIOT3WorkspacesLoading && updateIoT3.iot3WorkspacesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{updateIoT3.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 10; updateIoT3.fnIoT3WorkspacesPageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 20; updateIoT3.fnIoT3WorkspacesPageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 50; updateIoT3.fnIoT3WorkspacesPageChanged(updateIoT3.currentPage, updateIoT3.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"updateIoT3.perPage = 100; updateIoT3.fnIoT3WorkspacesPageChanged(updateIoT3.currentPage,updateIoT3.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"updateIoT3.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"updateIoT3.currentPage\" items-per-page=\"updateIoT3.perPage\" max-size=\"updateIoT3.maxSize\" boundary-links=\"true\" ng-click=\"updateIoT3.fnIoT3WorkspacesPageChanged(updateIoT3.currentPage, updateIoT3.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"updateIoT3.activeStep === 3\"><div class=\"col-sm-12 p-0 p-t-20\" ng-if=\"updateIoT3.isIoT3DetailLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"container-with-footer tab-container\" ng-if=\"!updateIoT3.isIoT3DetailLoading\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{updateIoT3.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in updateIoT3.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{updateIoT3.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{updateIoT3.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"updateIoT3.iot3JSON.info.created && updateIoT3.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{updateIoT3.iot3JSON.info.created}} <span ng-if=\"updateIoT3.iot3JSON.info.author\">by {{updateIoT3.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"updateIoT3.iot3JSON.info.updated && updateIoT3.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{updateIoT3.iot3JSON.info.updated}} <span ng-if=\"updateIoT3.iot3JSON.info.author\">by {{updateIoT3.iot3JSON.info.author}}</span></label></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"updateIoT3.selectedTabIndex === 3\"><div class=\"col-sm-12 p-0 p-t-10\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"updateIoT3.fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"updateIoT3.uploadFiles()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import IoT3 File</a></span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"updateIoT3.selectedTabIndex\"><uib-tab index=\"1\" select=\"updateIoT3.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Summary</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"updateIoT3.selectedTabIndex === 1\"><div class=\"col-sm-12 p-0 m-t-30 floatingLabelInput\"><div class=\"col-sm-12 pace\" ng-repeat=\"inputObj in updateIoT3.iot3Summary track by $index\"><div class=\"md-input m-b-20\" ng-if=\"inputObj.valueType !== \'object\'\"><input class=\"md-form-control\" required=\"\" id=\"{{inputObj.key}}\" type=\"text\" ng-model=\"inputObj.value\" name=\"{{inputObj.key}}\"> <span class=\"highlight\"></span> <label>{{inputObj.key}}</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-b-20 customInputDesign\" ng-if=\"inputObj.valueType === \'object\'\"><div class=\"p-t-10 p-l-20\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"labelObj in inputObj.value\">{{labelObj}}</button></div><label class=\"customLabel text-primary text-uppercase\">{{inputObj.key}}</label></div></div><div class=\"col-sm-12 pace\" ng-if=\"!updateIoT3.iot3Summary.length\"><h4>IoT3 Summary not found.</h4></div></div></div></uib-tab><uib-tab index=\"2\" select=\"updateIoT3.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Nodes</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"updateIoT3.selectedTabIndex === 2\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 m-t-10 iot3-node-desc\"><div class=\"m-t-5\"><span>Don\'t see the source you\'re looking for?</span> <span class=\"text-primary\" ng-click=\"updateIoT3.fnOpenIot3SupportModel()\">Tell us about it.</span></div></div><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"iot3-register-node-table table-container\"><table id=\"iot3RegisterNodeTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3NodeArr.length\">Type</th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3NodeArr.length\"></th><th class=\"p-r-2\" ng-if=\"updateIoT3.iot3NodeArr.length\"></th><th ng-if=\"!updateIoT3.iot3NodeArr.length\">No records found...</th></tr></thead><tbody id=\"iot3RegisterNodeTableBody\"><tr ng-repeat=\"iot3NodeObj in updateIoT3.iot3NodeArr track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3NodeObj.type}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3NodeObj.name}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.price.value + \" \" + iot3NodeObj.price.unit}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.energy.value + \" \" + iot3NodeObj.energy.unit}}</span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3NodeObj.attributes.length + \" Attributes\"}}</span></div></div></td><td><div class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();updateIoT3.fnViewAttributes(iot3NodeObj)\">View Attributes</button></div></td></tr></tbody></table></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"updateIoT3.fnTabSelected()\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">IoT3</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\" ng-if=\"updateIoT3.selectedTabIndex === 3\"><div class=\"tabContent\" ng-init=\"updateIoT3.fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit\"><ui-codemirror ng-model=\"updateIoT3.selectedIoT3FileObj.iot3File\" ui-codemirror-opts=\"updateIoT3.editorOptions\"></ui-codemirror></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"updateIoT3.activeStep === 4\"><div class=\"row user-header m-l-0 w100\" ng-init=\"updateIoT3.fnSecurityRegistrationInit()\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{updateIoT3.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-default btn-sm p-3 m-r-5\" ng-repeat=\"versionObj in updateIoT3.iot3JSON.info.versions\">{{versionObj}}</button></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">{{updateIoT3.iot3JSON.info.oem}}</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-8 p-0\"><h2 class=\"m-0 m-t-10 ellipsis\">{{updateIoT3.iot3JSON.info.documentation.description}}</h2></div><div class=\"col-sm-4 p-0 d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"updateIoT3.iot3JSON.info.created && updateIoT3.iot3JSON.info.created.length\"><label class=\"m-b-0\">Created {{updateIoT3.iot3JSON.info.created }} <span ng-if=\"updateIoT3.iot3JSON.info.author\">by {{updateIoT3.iot3JSON.info.author}}</span></label></div><div class=\"d-flex p-r-5 p-b-5 justify-content-flex-end\" ng-if=\"updateIoT3.iot3JSON.info.updated && updateIoT3.iot3JSON.info.updated.length\"><label class=\"m-b-0\">Updated {{updateIoT3.iot3JSON.info.updated}} <span ng-if=\"updateIoT3.iot3JSON.info.author\">by {{updateIoT3.iot3JSON.info.author}}</span></label></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-auto\" id=\"step4\"><div class=\"col-sm-12 m-t-15\"><h3>Security Registration</h3><div><span>In order to connect to your node we need a few bites of security information. If you are unsure about IP addresses or ports you can <span class=\"text-primary\" ng-click=\"updateIoT3.fnOpenECUListModel()\">initiate a network scan</span> from the ECU.</span></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!updateIoT3.isLoading\" ng-init=\"updateIoT3.fnInitSecurityRegistration()\"><div class=\"col-sm-12 p-0 floatingLabelInput pace\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"updateIoT3.newNodeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 floatingLabelInput pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"updateIoT3.newNodeObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-l-0 p-r-10 d-flex w100 flex-column\"><div class=\"col-sm-12 p-0 d-flex w100\"><h4 class=\"m-t-0 m-b-15\">New Security Registration</h4></div><div class=\"col-sm-12 p-0 d-flex w100\"><form id=\"iotForm\" role=\"form\" name=\"iotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"updateIoT3.schema\" sf-form=\"updateIoT3.form\" sf-model=\"updateIoT3.model\"></div><button type=\"button\" class=\"btn btn-primary\" style=\"display: none\" ng-disabled=\"updateIoT3.fnCheckIot3Validation(iotForm.$valid)\">Continue</button></form></div></div><div class=\"col-sm-6 p-l-10 p-r-0 d-flex w100 flex-column\"><div class=\"col-sm-12 p-0 d-flex w100\"><h4 class=\"m-t-0 m-b-15\">Old Security Registration</h4></div><div class=\"col-sm-12 p-0 d-flex w100\"><form id=\"oldIoTForm\" role=\"form\" name=\"oldIoTForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"updateIoT3.oldSchema\" sf-form=\"updateIoT3.oldForm\" sf-model=\"updateIoT3.oldModel\"></div></form></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"updateIoT3.activeStep === 5\"><div class=\"col-sm-12 p-0\" id=\"step6\"><div class=\"col-sm-12\"><h3>Node Registration Summary</h3></div></div><div class=\"col-sm-12 m-t-20 d-flex flex-column justify-content-center align-items-center\"><div class=\"col-sm-6 p-0\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><div class=\"d-flex flex-column w100\" style=\"width: 78%\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{updateIoT3.selectedEcuObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{updateIoT3.selectedEcuObj.description}}</span></div></div><div class=\"d-flex flex-column align-items-center\" style=\"width: 20%\"><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{updateIoT3.selectedEcuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"updateIoT3.fnGetHealthColor(updateIoT3.selectedEcuObj.health, updateIoT3.selectedEcuObj)\"><span class=\"healthSpan\">{{updateIoT3.selectedEcuObj.healthName}}</span></button></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"updateIoT3.selectedEcuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"updateIoT3.selectedEcuObj.connected\">Connected</span> <span ng-if=\"!updateIoT3.selectedEcuObj.connected\">Disconnected</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{updateIoT3.selectedEcuObj.project.name}}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"updateIoT3.selectedEcuObj.phase === \'UNREGISTERED\'\">Unregistered</span> <span ng-if=\"updateIoT3.selectedEcuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"updateIoT3.selectedEcuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"updateIoT3.selectedEcuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"updateIoT3.selectedEcuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{updateIoT3.selectedEcuObj.lastSeenDate ? updateIoT3.selectedEcuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"updateIoT3.selectedEcuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"updateIoT3.selectedEcuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"updateIoT3.selectedEcuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"updateIoT3.selectedEcuObj.vpn === \'DISABLING\'\">Disabling</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"updateIoT3.selectedEcuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"updateIoT3.selectedEcuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"updateIoT3.selectedEcuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"updateIoT3.selectedEcuObj.ntp === \'DISABLING\'\">Disabling</span></span></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"updateIoT3.selectedEcuObj.lifecycleState === \'READY\'\">Ready</span></span></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Version\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/versions.svg#versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{updateIoT3.selectedEcuObj.version}}</span></div></div></div></div></div></div></div><div class=\"col-sm-6 p-0 m-t-30\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\" style=\"height: 60px;\"><div class=\"col-sm-12 h-100 p-0 d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex\"><h4 class=\"m-0 p-l-10 ellipsis\">{{updateIoT3.newNodeObj.name}}</h4></div><div class=\"d-flex\"><span class=\"m-0 p-l-10 p-t-3 font-italic ellipsis\">{{updateIoT3.newNodeObj.description}}</span></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 m-t-10 m-b-10\"><div class=\"col-sm-12 p-0 m-t-5\" ng-repeat=\"formObj in updateIoT3.form\"><div class=\"col-sm-4 p-0\"><span>{{formObj.title}}</span></div><div class=\"col-sm-8 p-0\">{{updateIoT3.model[formObj.key[0]]}}</div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-l-0 p-r-0\" ng-if=\"updateIoT3.activeStep === 6\"><div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Job</span></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Updating Node IoT3</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-12 p-0\"><span class=\"m-0 m-t-10 ellipsis\">This process can take several minutes. If you would like to see your node update you can watch it here in real-time. Closing this window will have no effect on the update.</span></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"updateIoT3.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in updateIoT3.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"updateIoT3.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"updateIoT3.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"updateIoT3.jobSummary\" ui-codemirror-opts=\"updateIoT3.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer p-1 d-flex align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"updateIoT3.activeStep === 2\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!updateIoT3.isIOT3sLoading\"><label class=\"m-b-0\">Total: {{updateIoT3.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-if=\"updateIoT3.isIoT3References\" ng-class=\"{\'fa-spin\' : updateIoT3.isIoT3Refresh}\" ng-click=\"updateIoT3.fnReloadIoT3s();\" aria-hidden=\"true\"></i> <i class=\"fa fa-refresh p-10\" ng-if=\"!updateIoT3.isIoT3References\" ng-class=\"{\'fa-spin\' : updateIoT3.isIoT3WorkspacesRefresh}\" ng-click=\"updateIoT3.fnReloadIoT3Workspaces();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-click=\"updateIoT3.fnGotoPreviousStep()\">Back</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"updateIoT3.activeStep === 3\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-if=\"updateIoT3.selectedTabIndex === 3\"><div class=\"d-flex justify-content-center align-items-center m-r-10\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"!updateIoT3.isChangesSync\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"updateIoT3.isChangesSync\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!updateIoT3.isChangesSync\" ng-click=\"updateIoT3.fnChangeDone()\">Save changes</button></div></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!updateIoT3.isIoT3DetailLoading\" ng-click=\"updateIoT3.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!updateIoT3.isIoT3DetailLoading\" ng-disabled=\"!updateIoT3.isValidateIoT3File();\" ng-click=\"updateIoT3.fnGotoNextStep(4)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"updateIoT3.activeStep === 4\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-click=\"updateIoT3.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-disabled=\"!updateIoT3.isIoT3FormValid || !updateIoT3.newNodeObj.name.length\" ng-click=\"updateIoT3.fnGotoNextStep(5)\">Continue</button></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"updateIoT3.activeStep === 5\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25 m-r-10\" ng-if=\"!updateIoT3.isNodeRegistering\" ng-click=\"updateIoT3.fnGotoPreviousStep()\">Back</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-l-25 p-r-25\" ng-if=\"!updateIoT3.isNodeRegistering\" ng-click=\"updateIoT3.fnRegisterNewNode()\">Update IoT3</button><div class=\"col-sm-12 p-0\" ng-if=\"updateIoT3.isNodeRegistering\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 h-100 d-flex align-items-center\" ng-if=\"updateIoT3.activeStep === 6\"><div class=\"col-sm-6 m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div>");
$templateCache.put("app/node/notification/createNotification/createNotification.html","<div ng-controller=\"createNotificationCtrl as createNotification\" ng-init=\"createNotification.fnInitCreateNotification()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createNotification.title}}</h3><button ng-if=\"notification.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"notification.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"!createNotification.isBasicInformationDone\"><form id=\"createNewHealthForm\" role=\"form\" name=\"createNewHealthForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createNotification.newNotificationObj.name\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createNotification.newNotificationObj.description\" placeholder=\"Description regarding Notification\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createNotification.newNotificationObj.state\">{{createNotification.newNotificationObj.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in createNotification.statesArr\" role=\"menuitem\"><a ng-click=\"createNotification.newNotificationObj.state = action\">{{action}}</a></li></ul></div></div><div class=\"col-sm-12 p-0\"><h4 class=\"m-b-0\">Logging Options</h4><div class=\"m-t-10 m-b-20\"><span class=\"m-r-5 middle-display\">Enabled:</span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"createNotification.newNotificationObj.logging\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div></div></form></div><div class=\"col-sm-12 p-0\" ng-show=\"createNotification.isBasicInformationDone\"><div class=\"col-sm-12 p-0\" id=\"notificationParentDiv\"><div id=\"notificationDesign\"><div class=\"p-10 text-center notificationDetails\" id=\"functionModal\" style=\"width: fit-content;height: fit-content;\"><div class=\"p-15 thingDiv\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right m-t-5\"><span class=\"label label-default\" ng-bind=\"createNotification.newNotificationObj.state\" ng-class=\"{\'ACTIVE\':\'blue-bg\' ,\'INACTIVE\':\'red-bg\'}[createNotification.newNotificationObj.state]\"></span></div><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-calendar\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.window.always\"><span>Notification enabled 24 / 7 / 365</span></div><div class=\"col-sm-12 p-0\" ng-if=\"!createNotification.newNotificationObj.window.always\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.window.daysOfTheWeek.length\"><span ng-repeat=\"day in createNotification.newNotificationObj.window.daysOfTheWeek\">{{createNotification.dayName[day-1]}}<span ng-if=\"!$last\">,</span></span></div><div class=\"col-sm-12 p-0\">{{createNotification.newNotificationObj.window.startHour+\":\"+createNotification.newNotificationObj.window.startMinute+ \" (\"+createNotification.newNotificationObj.window.timezone+\") and \"+ createNotification.newNotificationObj.window.endHour+\":\"+createNotification.newNotificationObj.window.endMinute+ \" (\"+createNotification.newNotificationObj.window.timezone+\")\"}}</div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'window\',createNotification.newNotificationObj.window)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-heartbeat\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\"><span ng-if=\"createNotification.newNotificationObj.target.beforeHealth !==\'\' && createNotification.newNotificationObj.target.afterHealth !==\'\'\">When <span ng-if=\"createNotification.newNotificationObj.target.scope === \'ATTRIBUTE\'\">an Attribute</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'DEVICE\'\">a Device</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'COMPONENT\'\">a Component</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'GATEWAY\'\">a Gateway</span> health changes from <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.beforeHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.beforeHealth !== -1\" ng-style=\"createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.beforeHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.beforeHealth).content}}</span></button> to <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.afterHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.afterHealth !== -1\" ng-style=\"createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.afterHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.afterHealth).content}}</span></button></span></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'target\',createNotification.newNotificationObj.target)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"fxIcon\"><span><em>f<small>(x)</small></em></span></div></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.function.type === \'NONE\'\"><span>No function have been selected</span></div><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.function.type === \'REVERSE_LOOKUP\'\"><div class=\"col-sm-12 p-0\">The health must have remained unchanged in<div class=\"p-r-5\" style=\"display: inline-block\" ng-class=\"$index === 0 ?\'p-l-5\':\'\'\" ng-repeat=\"acceptableHealth in createNotification.newNotificationObj.function.settings.acceptableHealths track by $index\"><button class=\"btn btn-xs btn-default m-t-2\" ng-style=\"createNotification.fnGetHealthColor(acceptableHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(acceptableHealth).content}}</span></button> <span ng-if=\"$index !== createNotification.newNotificationObj.function.settings.acceptableHealths.length - 2 && !$last\">,</span> <span ng-if=\"$index === createNotification.newNotificationObj.function.settings.acceptableHealths.length - 2\">or</span></div>for {{createNotification.newNotificationObj.function.settings.seconds === 0 ?\'0 seconds\': createNotification.secondsToHms(createNotification.newNotificationObj.function.settings.seconds);}}</div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'function\',createNotification.newNotificationObj.function)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-at\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.dispatch.settings.emails && createNotification.newNotificationObj.dispatch.settings.emails.length\"><div class=\"col-sm-2 p-0\">To:</div><div class=\"col-sm-10 p-0\"><span ng-repeat=\"email in createNotification.newNotificationObj.dispatch.settings.emails\"><span>{{email}}<sapn ng-if=\"!$last\">,</sapn></span><br></span></div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'dispatch\',createNotification.newNotificationObj.dispatch)\">Configure</button></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-1\" style=\"height: 38px\"><div class=\"col-sm-12 p-r-12 p-l-0\" ng-if=\"!createNotification.isNotificationCreating\"><input type=\"button\" class=\"btn btn-link pull-right\" ng-if=\"!createNotification.isBasicInformationDone\" ng-disabled=\"!createNotification.newNotificationObj.name.length\" ng-click=\"createNotification.fnNextStep()\" value=\"Next\"> <input type=\"button\" class=\"btn btn-sm btn-primary pull-right p-r-20 p-l-20 m-t-3 p-t-4\" ng-if=\"createNotification.isBasicInformationDone\" ng-disabled=\"createNotification.fnCheckValidation()\" ng-click=\"createNotification.fnCreateNewNotification(createNotification.newNotificationObj)\" value=\"Create Notification\"> <input type=\"button\" class=\"btn btn-link\" ng-click=\"notification.fnHideShowCreateForm()\" ng-class=\"createNotification.isBasicInformationDone === false ? \'pull-left\' : \'pull-right\'\" value=\"Close\"> <input type=\"button\" class=\"btn btn-link p-r-0 p-l-15 pull-left\" ng-click=\"createNotification.isBasicInformationDone = false\" ng-if=\"createNotification.isBasicInformationDone\" value=\"Edit Details\"></div><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.isNotificationCreating\"><div class=\"col-sm-12 p-0\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/notification/createNotification/editNotification.html","<div ng-controller=\"createNotificationCtrl as createNotification\" ng-init=\"createNotification.fnInitEditNotification()\"><div class=\"row\"><div class=\"col-sm-12 p-t-20\" id=\"notificationContent\" style=\"overflow: auto\"><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-show=\"!createNotification.isBasicInformationDone\"><form id=\"createNewHealthForm\" role=\"form\" name=\"createNewHealthForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createNotification.newNotificationObj.name\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createNotification.newNotificationObj.description\" placeholder=\"Description regarding Notification\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createNotification.newNotificationObj.state\">{{createNotification.newNotificationObj.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in createNotification.statesArr\" role=\"menuitem\"><a ng-click=\"createNotification.newNotificationObj.state = action\">{{action}}</a></li></ul></div></div><div class=\"col-sm-12 p-0\"><h4 class=\"m-b-0\">Logging Options</h4><div class=\"m-t-10 m-b-20\"><span class=\"m-r-5 middle-display\">Enabled:</span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"createNotification.newNotificationObj.logging\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div></div></form></div><div class=\"col-sm-12 p-0\" ng-show=\"createNotification.isBasicInformationDone\"><div class=\"col-sm-12 p-0\" id=\"notificationParentDiv\"><div id=\"notificationDesign\"><div class=\"p-10 text-center notificationDetails\" id=\"functionModal\" style=\"width: fit-content;height: fit-content;\"><div class=\"p-15 thingDiv\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right m-t-5\"><span class=\"label label-default\" ng-bind=\"createNotification.newNotificationObj.state\" ng-class=\"{\'ACTIVE\':\'blue-bg\' ,\'INACTIVE\':\'red-bg\'}[createNotification.newNotificationObj.state]\"></span></div><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-calendar\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.window.always\"><span>Notification enabled 24 / 7 / 365</span></div><div class=\"col-sm-12 p-0\" ng-if=\"!createNotification.newNotificationObj.window.always\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.window.daysOfTheWeek.length\"><span ng-repeat=\"day in createNotification.newNotificationObj.window.daysOfTheWeek\">{{createNotification.dayName[day-1]}}<span ng-if=\"!$last\">,</span></span></div><div class=\"col-sm-12 p-0\">{{createNotification.newNotificationObj.window.startHour+\":\"+createNotification.newNotificationObj.window.startMinute+ \" (\"+createNotification.newNotificationObj.window.timezone+\") and \"+ createNotification.newNotificationObj.window.endHour+\":\"+createNotification.newNotificationObj.window.endMinute+ \" (\"+createNotification.newNotificationObj.window.timezone+\")\"}}</div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'window\',createNotification.newNotificationObj.window)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-heartbeat\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\"><span ng-if=\"createNotification.newNotificationObj.target.beforeHealth !==\'\' && createNotification.newNotificationObj.target.afterHealth !==\'\'\">When <span ng-if=\"createNotification.newNotificationObj.target.scope === \'ATTRIBUTE\'\">an Attribute</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'DEVICE\'\">a Device</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'COMPONENT\'\">a Component</span> <span ng-if=\"createNotification.newNotificationObj.target.scope === \'GATEWAY\'\">a Gateway</span> health changes from <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.beforeHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.beforeHealth !== -1\" ng-style=\"createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.beforeHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.beforeHealth).content}}</span></button> to <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.afterHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"createNotification.newNotificationObj.target.afterHealth !== -1\" ng-style=\"createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.afterHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(createNotification.newNotificationObj.target.afterHealth).content}}</span></button></span></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'target\',createNotification.newNotificationObj.target)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"fxIcon\"><span><em>f<small>(x)</small></em></span></div></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.function.type === \'NONE\'\"><span>No function have been selected</span></div><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.function.type === \'REVERSE_LOOKUP\'\"><div class=\"col-sm-12 p-0\">The health must have remained unchanged in<div class=\"p-r-5\" style=\"display: inline-block\" ng-class=\"$index === 0 ?\'p-l-5\':\'\'\" ng-repeat=\"acceptableHealth in createNotification.newNotificationObj.function.settings.acceptableHealths track by $index\"><button class=\"btn btn-xs btn-default m-t-2\" ng-style=\"createNotification.fnGetHealthColor(acceptableHealth)\"><span class=\"healtSpan\">{{createNotification.fnGetHealthColor(acceptableHealth).content}}</span></button> <span ng-if=\"$index !== createNotification.newNotificationObj.function.settings.acceptableHealths.length - 2 && !$last\">,</span> <span ng-if=\"$index === createNotification.newNotificationObj.function.settings.acceptableHealths.length - 2\">or</span></div>for {{createNotification.newNotificationObj.function.settings.seconds === 0 ?\'0 seconds\': createNotification.secondsToHms(createNotification.newNotificationObj.function.settings.seconds);}}</div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'function\',createNotification.newNotificationObj.function)\">Configure</button></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-at\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"createNotification.newNotificationObj.dispatch.settings.emails\"><div class=\"col-sm-2 p-0\">To:</div><div class=\"col-sm-10 p-0\"><span ng-repeat=\"email in createNotification.newNotificationObj.dispatch.settings.emails\"><span>{{email}}<sapn ng-if=\"!$last\">,</sapn></span><br></span></div></div></div><div class=\"panel-footer p-r-10\"><div class=\"text-right\"><button type=\"button\" class=\"btn btn-link p-0\" style=\"margin-top: -3px;\" ng-click=\"createNotification.fnOpenSettingModal(\'dispatch\',createNotification.newNotificationObj.dispatch)\">Configure</button></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 content-footer\" style=\"height: 38px\"><div class=\"col-sm-12 p-r-12\" ng-if=\"!createNotification.isNotificationCreating\"><input type=\"button\" class=\"btn btn-link pull-right\" ng-if=\"!createNotification.isBasicInformationDone\" ng-disabled=\"!createNotification.newNotificationObj.name.length\" ng-click=\"createNotification.fnNextStep(\'.content-main\')\" value=\"Next\"> <input type=\"button\" class=\"btn btn-sm btn-primary pull-right p-r-20 p-l-20 m-t-5\" ng-if=\"createNotification.isBasicInformationDone\" ng-disabled=\"createNotification.fnCheckValidation()\" ng-click=\"createNotification.fnSaveNotification(createNotification.newNotificationObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link p-t-10\" ng-click=\"createNotification.fnExitEditMode()\" ng-class=\"createNotification.isBasicInformationDone === false ? \'pull-left\' : \'pull-right\'\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-link pull-left p-r-0 p-l-0 p-t-10\" ng-if=\"createNotification.isBasicInformationDone\" ng-click=\"createNotification.isBasicInformationDone = false\" value=\"Edit Details\"></div><div class=\"col-sm-12 p-r-10 p-t-2\" ng-if=\"createNotification.isNotificationCreating\"><div class=\"col-sm-12 p-0\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div>");
$templateCache.put("app/node/notification/modal/notificationModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Notification Configuration</strong></div><div class=\"modal-body\" ng-init=\"notificationModal.fnInitModel()\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><form id=\"createNotificationForm\" role=\"form\" name=\"createNotificationForm\" novalidate=\"\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.conditionType === \'window\'\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"m-t-10 m-b-5\"><span class=\"m-r-5 middle-display m-b-0\"><strong>Enable this notification 24 / 7 / 365:</strong></span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"notificationModal.selectedTypeObj.always\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div></div></div><div class=\"col-sm-12 p-0\" ng-show=\"!notificationModal.selectedTypeObj.always\"><div class=\"col-sm-12 p-0 m-t-5 m-b-15\"><button type=\"button\" class=\"btn btn-link p-0 pull-right\" style=\"margin-top: -3px;\" ng-click=\"notificationModal.fnSetWorkingWeek()\">Set standard working week</button></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"Start Time for the Notification*\" ng-model=\"notificationModal.startTime\" ng-focus=\"notificationModal.fnAddValue(\'startTime\')\"> <span class=\"highlight\"></span> <label>Select Start Time*</label> <small class=\"helper-text\"></small></div><div class=\"hiddenInputText\"><input type=\"text\" id=\"startTime\" ng-model=\"notificationModal.startTime\"></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"End Time for the Notification*\" ng-model=\"notificationModal.endTime\" ng-focus=\"notificationModal.fnAddValue(\'endTime\')\"> <span class=\"highlight\"></span> <label>Select End Time*</label> <small class=\"helper-text\"></small></div><div class=\"hiddenInputText\"><input type=\"text\" id=\"endTime\" ng-model=\"notificationModal.endTime\"></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"timeZone for timeZone in notificationModal.timezoneOptionArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"notificationModal.selectedTypeObj.timezone\" placeholder=\"Time Zone*\"> <span class=\"highlight\"></span> <label>Timezone*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\">Select Days Of The Week</span> <label class=\"titleLabel\">Days Of The Week</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in notificationModal.dayName track by $index\" role=\"menuitem\"><a ng-click=\"notificationModal.fnCreateDaysOfTheWeek($index)\">{{action}}</a></li></ul></div></div><div class=\"m-t-10 m-b-10\"><button class=\"btn btn-sm btn-default m-t-10 m-r-5\" ng-repeat=\"selectedArr in notificationModal.selectedTypeObj.daysOfTheWeek track by $index\"><span>{{notificationModal.dayName[selectedArr-1]}} <i class=\"fa fa-times m-l-5\" ng-click=\"notificationModal.fnRemoveSelectedArrayTag(\'daysOfTheWeek\',$index)\"></i></span></button></div></div><div class=\"col-sm-12 p-0\"><button type=\"button\" class=\"btn btn-link p-5 pull-right\" ng-click=\"notificationModal.fnShowAdvancedOption()\">Advanced</button></div><div class=\"col-sm-12 p-0\" ng-show=\"notificationModal.isShowAdvancedOption\"><div class=\"col-sm-12 m-b-20 p-0\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" type=\"text\" name=\"includeDaysOfYear\" ng-focus=\"notificationModal.fnAddValue(\'includeDaysOfYear\')\" placeholder=\"Only on specific days of the year\"> <span class=\"highlight\"></span> <label>Only on specific days of the year</label><div class=\"hiddenInputText\"><input type=\"text\" id=\"includeDaysOfYear\"></div></div><div class=\"m-t-5 m-b-5\"><button class=\"btn btn-sm btn-default m-t-10 m-r-5\" ng-repeat=\"selectedArr in notificationModal.selectedTypeObj.includeDaysOfYear track by $index\"><span>{{notificationModal.dateFromDay(selectedArr)}} <i class=\"fa fa-times m-l-5\" ng-click=\"notificationModal.fnRemoveSelectedArrayTag(\'includeDaysOfYear\',$index)\"></i></span></button></div></div><div class=\"col-sm-12 m-b-20 p-0\" ng-show=\"!notificationModal.selectedTypeObj.includeDaysOfYear.length\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" type=\"text\" name=\"excludeDaysOfYear\" ng-focus=\"notificationModal.fnAddValue(\'excludeDaysOfYear\')\" placeholder=\"Exclude specific days of the year\"> <span class=\"highlight\"></span> <label>Exclude specific days of the year</label><div class=\"hiddenInputText\"><input type=\"text\" id=\"excludeDaysOfYear\"></div></div><div class=\"m-t-5 m-b-5\"><button class=\"btn btn-sm btn-default m-t-10 m-r-5\" ng-repeat=\"selectedArr in notificationModal.selectedTypeObj.excludeDaysOfYear track by $index\"><span>{{notificationModal.dateFromDay(selectedArr)}} <i class=\"fa fa-times m-l-5\" ng-click=\"notificationModal.fnRemoveSelectedArrayTag(\'excludeDaysOfYear\',$index)\"></i></span></button></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.conditionType === \'target\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"notificationModal.selectedTypeObj.scope\">{{notificationModal.selectedTypeObj.scope}}</span> <label class=\"titleLabel\">Scope*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in notificationModal.targetScopeArr\" role=\"menuitem\"><a ng-click=\"notificationModal.selectedTypeObj.scope = action\">{{action}}</a></li></ul></div></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!notificationModal.isHealthDetailsLoaded\"><div class=\"p-t-10\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.isHealthDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"!notificationModal.healthPermissionObj\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.beforeHealth !== -1\"><input class=\"md-form-control\" required=\"\" id=\"beforeHealth\" type=\"number\" placeholder=\"Initial Health for the Notification*\" name=\"beforeHealth\" min=\"100\" max=\"599\" ng-model=\"notificationModal.selectedTypeObj.beforeHealth\"> <span class=\"highlight\"></span> <label>Initial Health*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"createNotificationForm.beforeHealth.$error.min || createNotificationForm.beforeHealth.$error.max\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnSetBeforeAnyHealth()\">Set Any Health</a></small></div></div></div><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.beforeHealth === -1\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" value=\"Any Health\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>Initial Health*</label> <small class=\"helper-text\"></small> <small class=\"helper-text arrayHelper-text pull-right\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnUnSetBeforeAnyHealth()\">Change Health</a></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.afterHealth !== -1\"><input class=\"md-form-control\" required=\"\" id=\"afterHealth\" type=\"number\" placeholder=\"New Health for the Notification*\" min=\"100\" max=\"599\" name=\"afterHealth\" ng-model=\"notificationModal.selectedTypeObj.afterHealth\"> <span class=\"highlight\"></span> <label>New Health*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"createNotificationForm.afterHealth.$error.min || createNotificationForm.afterHealth.$error.max\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnSetAfterAnyHealth()\">Set Any Health</a></small></div></div></div><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.afterHealth === -1\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" value=\"Any Health\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>New Health*</label> <small class=\"helper-text\"></small> <small class=\"helper-text arrayHelper-text pull-right\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnUnSetAfterAnyHealth()\">Change Health</a></small></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.healthPermissionObj\"><div class=\"col-sm-12 p-0\"><div class=\"md-input roleActions m-b-40\" ng-if=\"notificationModal.selectedTypeObj.beforeHealth !== -1\"><input class=\"md-form-control\" required=\"\" id=\"blueprintLabel\" type=\"number\" typeahead-editable=\"true\" name=\"beforeHealth1\" uib-typeahead=\"health.code as health.code for health in notificationModal.healthsArr | filter:{code:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"healthTemplate.html\" min=\"100\" max=\"599\" ng-model=\"notificationModal.selectedTypeObj.beforeHealth\" placeholder=\"Initial Health for the Notification*\"> <span class=\"highlight\"></span> <label>Initial Health*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"createNotificationForm.beforeHealth1.$error.min || createNotificationForm.beforeHealth1.$error.max\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnSetBeforeAnyHealth()\">Set Any Health</a></small></div></div></div><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.beforeHealth === -1\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" value=\"Any Health\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>Initial Health*</label> <small class=\"helper-text\"></small> <small class=\"helper-text arrayHelper-text pull-right\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnUnSetBeforeAnyHealth()\">Change Health</a></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input roleActions m-b-40\" ng-if=\"notificationModal.selectedTypeObj.afterHealth !== -1\"><input class=\"md-form-control\" required=\"\" type=\"number\" placeholder=\"New Health for the Notification*\" typeahead-editable=\"true\" typeahead-min-length=\"0\" uib-typeahead=\"health.code as health.code for health in notificationModal.healthsArr | filter:{code:$viewValue}\" typeahead-template-url=\"healthTemplate.html\" min=\"100\" max=\"599\" name=\"afterHealth1\" ng-model=\"notificationModal.selectedTypeObj.afterHealth\"> <span class=\"highlight\"></span> <label>New Health*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"createNotificationForm.afterHealth1.$error.min || createNotificationForm.afterHealth1.$error.max\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnSetAfterAnyHealth()\">Set Any Health</a></small></div></div></div><div class=\"md-input m-b-40\" ng-if=\"notificationModal.selectedTypeObj.afterHealth === -1\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" value=\"Any Health\" placeholder=\"New name for the Notification*\"> <span class=\"highlight\"></span> <label>New Health*</label> <small class=\"helper-text\"></small> <small class=\"helper-text arrayHelper-text pull-right\"><a class=\"btn btn-link p-0\" ng-click=\"notificationModal.fnUnSetAfterAnyHealth()\">Change Health</a></small></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.conditionType === \'function\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"notificationModal.selectedTypeObj.type\">{{notificationModal.selectedTypeObj.type === \"REVERSE_LOOKUP\"?\'REVERSE LOOKUP\':notificationModal.selectedTypeObj.type}}</span> <label class=\"titleLabel\">Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in notificationModal.functionTypeArr\" role=\"menuitem\"><a ng-click=\"notificationModal.selectedTypeObj.type = action.option\">{{action.displayName}}</a></li></ul></div></div><div class=\"col-sm-12 p-0\" ng-show=\"notificationModal.selectedTypeObj.type !== \'NONE\'\"><div class=\"col-sm-12 p-0\" ng-repeat=\"notificationObj in notificationModal.functionSettingsArr track by $index\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.key === \'seconds\'\"><div class=\"md-input p-0\"><input class=\"md-form-control\" name=\"waitTime\" ng-attr-id=\"{{\'value\' + $index}}\" type=\"{{notificationObj.inputType}}\" required=\"\" min=\"0\" max=\"3600\" placeholder=\"Number of seconds the health should be unchanged.*\" ng-model=\"notificationObj.value\"> <span class=\"highlight\"></span> <label>Seconds*</label> <small class=\"helper-text-error\" ng-show=\"createNotificationForm.waitTime.$error.min || createNotificationForm.waitTime.$error.max\"><span class=\"errorText\">The value should be in between 0 and 3600.</span></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.key === \'acceptableHealths\'\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.type === \'array\'\"><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!notificationModal.isHealthDetailsLoaded\"><div class=\"p-t-10\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.isHealthDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"!notificationModal.healthPermissionObj\"><div class=\"md-input m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-attr-id=\"{{notificationObj.type+$index}}\" placeholder=\"Acceptable Healths for the Notification*\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\" name=\"acceptableHealths\" ng-model=\"notificationObj.arrValue\"> <span class=\"highlight\"></span> <label>Acceptable Healths*</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"notificationObj.isInputError\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\" style=\"right: 18px;\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\"><span><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.healthPermissionObj\"><div class=\"md-input m-b-40 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-attr-id=\"{{notificationObj.type+$index}}\" typeahead-editable=\"true\" name=\"acceptableHealths1\" uib-typeahead=\"health.code as health.code for health in notificationModal.healthsArr | filter:{code:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"healthTemplate.html\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\" ng-model=\"notificationObj.arrValue\" placeholder=\"Acceptable Healths for the Notification*\"> <span class=\"highlight\"></span> <label>Acceptable Healths*</label><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error\" ng-show=\"notificationObj.isInputError\"><span class=\"errorText\">The value should be in between 100 and 599.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\" style=\"right: 18px;\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\"><span><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm btn-default m-t-5 m-r-5\" ng-repeat=\"selectedArr in notificationObj.value track by $index\" ng-style=\"notificationModal.fnGetHealthColor(selectedArr)\"><span class=\"healtSpan\">{{notificationModal.fnGetHealthColor(selectedArr).content}}</span> <span><i class=\"fa fa-times m-l-5\" ng-click=\"notificationModal.fnRemoveDispatchEmailTag(notificationObj,$index)\"></i></span></button></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationModal.conditionType === \'dispatch\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"notificationModal.selectedTypeObj.type\" placeholder=\"Type*\"> <span class=\"highlight\"></span> <label>Type*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-repeat=\"notificationObj in notificationModal.dispatchSettingsArr track by $index\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.key === \'emails\'\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.type === \'array\'\"><div class=\"md-input m-b-40\"><input class=\"md-form-control p-r-30\" id=\"{{notificationObj.type+$index}}\" required=\"\" name=\"emails\" ng-pattern=\"notificationModal.emailPattern\" type=\"{{notificationObj.inputType}}\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\" ng-change=\"notificationObj.isInputError = false\" ng-model=\"notificationObj.arrValue\" placeholder=\"Recipient email address*\"> <span class=\"highlight\"></span> <label>Recipient email address*</label><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error m-t-2\" ng-if=\"createNotificationForm.emails.$error.pattern\"><span class=\"errorText p-0\">Please enter valid email address.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"notificationModal.fnCreateArrayTag(notificationObj.arrValue,notificationObj.type+$index,notificationObj)\"><span id=\"valueFunctionFx\"><small>Add</small></span></a></span></div><button class=\"btn btn-sm btn-default m-b-15 m-r-5\" ng-repeat=\"selectedArr in notificationObj.value track by $index\"><span>{{selectedArr}} <i class=\"fa fa-times m-l-5\" ng-click=\"notificationModal.fnRemoveDispatchEmailTag(notificationObj,$index)\"></i></span></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.key === \'subject\'\"><div class=\"md-input p-0\"><input class=\"md-form-control p-r-30\" ng-attr-id=\"{{\'value\' + $index}}\" type=\"{{notificationObj.inputType}}\" required=\"\" ng-model=\"notificationObj.value\" placeholder=\"Email Subject*\"> <span class=\"highlight\"></span> <label>Email Subject*</label></div></div></div></div></div></form></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary m-t-2 pull-left\" ng-click=\"notificationModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary m-t-2 pull-right\" ng-disabled=\"notificationModal.fnCheckValidation()\" ng-click=\"notificationModal.fnSave()\">Save</button></div><script type=\"text/ng-template\" id=\"healthTemplate.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.code\"></span> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-style=\"match.model.healthStyle\"> <span>{{match.model.healthName}}</span> </button> </a></script></div>");
$templateCache.put("app/node/notification/notificationInfo/notificationInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/observer/observerInfo/observerInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>ECU Observer</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{ecuObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{ecuObj.name}}</h3></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><span class=\"ellipsis m-b-0 d-flex align-items-center justify-content-flex-end\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span><div class=\"d-flex\" uib-tooltip=\"ECU Connection\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor m-l-10\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div></span></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{ecuObj.description ? ecuObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healtSpan\">{{ecuObj.healthName}}</span></button></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/project/createProject/createProject.html","<div class=\"h-100\" ng-controller=\"createNodeProjectCtrl as createProject\" ng-init=\"createProject.fnInitCreateProject()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createProject.isProjectCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createProject.isProjectCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewProjectForm\" role=\"form\" name=\"createNewProjectForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createProject.newProjectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createProject.newProjectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Parent Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createProject.changeProjectView\" ng-click=\"$event.stopPropagation();createProject.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createProject.selectedProject.name\"><div class=\"grayItalicValue\">No Parent Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createProject.selectedProject.name\"><span>{{createProject.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createProject.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createProject.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createProject.selectedProject.name\">{{createProject.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createProject.selectedProject.name\">No Parent Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createProject.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createProject.projectSearch[createProject.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createProject.filterProject=(createProject.projectsArr | filter:createProject.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createProject.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createProject.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createProject.newProjectObj.name.length || !(createProject.selectedProject && createProject.selectedProject.id)\" ng-click=\"createProject.fnCreateNewProject(createProject.newProjectObj)\" ng-if=\"!createProject.isProjectCreating\">Create Project</button></div><div class=\"col-sm-12\" ng-if=\"createProject.isProjectCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Project</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{projectObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{projectObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/project_emailTemplate/modal/nodeProjectTemplateModal.html","<div class=\"inmodal h-100\" ng-init=\"nodeProjectTemplate.fnInitNodeProjectTemplateModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Warning</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"nodeProjectTemplate.isProjectRelationshipsDataLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!nodeProjectTemplate.isProjectRelationshipsDataLoading\"><div class=\"col-sm-12 p-0\">You have selected to cascade the \'{{nodeProjectTemplate.selectedTemplateObj.name}}\' email template in the \'{{nodeProjectTemplate.selectedProjectObj.name}}\' project to overwrite the \'{{nodeProjectTemplate.selectedTemplateObj.name}}\' email template in all the downstream projects. Here is a list of all projects that will have their \'{{nodeProjectTemplate.selectedTemplateObj.name}}\' overwrite with this one.</div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center p-l-26\">{{nodeProjectTemplate.selectedProjectObj.name}}</div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-repeat=\"projectList in nodeProjectTemplate.selectedProjectRelationships.downstreamProjects track by $index\" ng-if=\"nodeProjectTemplate.selectedProjectObj.id !== projectList.id\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectList.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">{{projectList.name}}</div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><h4>This cannot be undone and all existing email templates will be lost.</h4></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"!nodeProjectTemplate.isProjectRelationshipsDataLoading\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"nodeProjectTemplate.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"nodeProjectTemplate.fnConfirm()\">Confirm</button></div></div></div></div>");
$templateCache.put("app/node/project_emailTemplate/node_project_emailTemplate/node_project_emailTemplateInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{selectedProjectName}} Email Template</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{emailTemplateObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{emailTemplateObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/project_script/modal/nodeProjectScriptModal.html","<div class=\"inmodal h-100\" ng-init=\"nodeProjectScript.fnInitNodeProjectScriptModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Warning</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"nodeProjectScript.isProjectRelationshipsDataLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!nodeProjectScript.isProjectRelationshipsDataLoading\"><div class=\"col-sm-12 p-0\">You have selected to cascade the \'{{nodeProjectScript.selectedScriptObj.name}}\' script in the \'{{nodeProjectScript.selectedProjectObj.name}}\' project to overwrite the \'{{nodeProjectScript.selectedScriptObj.name}}\' script in all the downstream projects. Here is a list of all projects that will have their \'{{nodeProjectScript.selectedScriptObj.name}}\' overwrite with this one.</div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center p-l-26\">{{nodeProjectScript.selectedProjectObj.name}}</div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-repeat=\"projectList in nodeProjectScript.selectedProjectRelationships.downstreamProjects track by $index\" ng-if=\"nodeProjectScript.selectedProjectObj.id !== projectList.id\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectList.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">{{projectList.name}}</div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><h4>This cannot be undone and all existing scripts will be lost.</h4></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"!nodeProjectScript.isProjectRelationshipsDataLoading\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"nodeProjectScript.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"nodeProjectScript.fnConfirm()\">Confirm</button></div></div></div></div>");
$templateCache.put("app/node/project_script/node_project_scriptInfo/node_project_scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{selectedProjectName}} S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/script/scriptInfo/scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/software/createSoftware/createSoftware.html","<div class=\"h-100\" ng-controller=\"createSoftwareCtrl as createSoftware\" ng-init=\"createSoftware.fnInitCreateSoftware()\"><div class=\"modal-body height-100\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewSoftwareForm\" role=\"form\" name=\"createNewSoftwareForm\" novalidate=\"\"><div class=\"col-sm-12 p-0 customDropdown m-b-20\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createSoftware.newSoftwareObj.architecture}}</span> <label class=\"titleLabel\">Architecture*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"createSoftware.newSoftwareObj.architecture = \'ARM\'\"><span>ARM</span></a></li><li><a ng-click=\"createSoftware.newSoftwareObj.architecture = \'AMD64\'\"><span>AMD64</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><textarea class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" style=\"resize: none\" ng-model=\"createSoftware.newSoftwareObj.description\" rows=\"10\" placeholder=\"Description\" name=\"description\"></textarea> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"version\" type=\"text\" ng-model=\"createSoftware.newSoftwareObj.version\" placeholder=\"Version*\" name=\"version\"> <span class=\"highlight\"></span> <label>Version*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 create-software-dropzone\"><div class=\"col-sm-12 p-0 w100 height-100 d-flex align-items-center justify-content-center flex-column\" ng-drop-dir-for-software=\"\" upload-file=\"createSoftware.uploadFiles(filedata)\"><div class=\"w100 d-flex align-items-center justify-content-center\"><h3 ng-if=\"createSoftware.selectedFileName.length\" class=\"ellipsis m-b-5 text-center\">Selected file: {{createSoftware.selectedFileName}}</h3></div><div class=\"w100 d-flex align-items-center justify-content-center\" ng-if=\"!createSoftware.selectedFileName.length\"><h2 class=\"m-t-10\">Drop your binary file here!</h2></div><div class=\"w100 d-flex align-items-center justify-content-center\" ng-if=\"!createSoftware.selectedFileName.length\"><h2 class=\"m-t-0\">or</h2></div><div class=\"w100 d-flex align-items-center justify-content-center\" ng-class=\"createSoftware.selectedFileName.length ? \'m-t-20\': \'\'\"><button class=\"btn btn-primary v4-primary-button p-r-30 p-l-30 m-b-10\" onclick=\"document.getElementById(\'fileInput\').click()\">{{createSoftware.selectedFileName.length ? \"Change\":\"Select\"}} File</button></div><input type=\"file\" name=\"file\" id=\"fileInput\" ng-software-files=\"\" upload-file=\"createSoftware.uploadFiles(filedata)\" style=\"visibility:hidden; height: 0px;\"></div></div></form><button class=\"btn btn-primary pull-right m-t-10\" ng-disabled=\"!createSoftware.newSoftwareObj.version.length || !createSoftware.selectedFileName.length\" ng-click=\"createSoftware.fnCreateNewSoftware(createSoftware.newSoftwareObj)\" ng-if=\"!createSoftware.isSoftwareCreating\">Create Software</button></div><div class=\"col-sm-12 m-t-20\" ng-if=\"createSoftware.isSoftwareCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/software/softwareInfo/softwareInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-12 p-r-12 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Software</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnMakeLatest(softwareObj)\"><a class=\"btn btn-link\">Make Latest</a></li><li ng-click=\"fnOpenBroadcastSoftware(softwareObj)\"><a class=\"btn btn-link\">Broadcast</a></li><li ng-if=\"!softwareObj.checksum\" ng-click=\"fnActivatesSoftware(softwareObj)\"><a class=\"btn btn-link\">Activate</a></li><li ng-click=\"fnDeleteSoftware(softwareObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{\"V\"+ softwareObj.version +\" \"+softwareObj.architecture}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{\"V\"+ softwareObj.version +\" \"+softwareObj.architecture}}</h3></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0\"><h2 class=\"m-0 m-t-10 ellipsis\" ng-if=\"isFullWidthDevice\">{{softwareObj.description ? softwareObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0 ellipsis\" ng-if=\"!isFullWidthDevice\">{{softwareObj.description ? softwareObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{softwareObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(softwareObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/visualization/createDeviceGatewayVisualization/createDeviceGatewayVisualization.html","<div class=\"row h-100\" ng-init=\"createDeviceGatewayVisualizer.fnInitDeviceGatewayVisualizer()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-2 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content p-0\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"createDeviceGatewayVisualizer.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"createDeviceGatewayVisualizer.selectedTab = item.tabIndex\" ng-repeat=\"item in createDeviceGatewayVisualizer.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div></div></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createDeviceGatewayVisualizer.selectedTab === 1\"><ng-include src=\"\'app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/details.html\'\"></ng-include></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createDeviceGatewayVisualizer.selectedTab === 2\"><ng-include src=\"\'app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/query.html\'\"></ng-include></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createDeviceGatewayVisualizer.selectedTab === 3\"><ng-include src=\"\'app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/configuration.html\'\"></ng-include></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createDeviceGatewayVisualizer.selectedTab === 4\"><ng-include src=\"\'app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/layout.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/node/visualization/createVisualization/createVisualization.html","<div class=\"row h-100\" ng-init=\"createVisualizer.fnInitVisualizer()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-2 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content p-0\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"createVisualizer.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"createVisualizer.selectedTab = item.tabIndex\" ng-repeat=\"item in createVisualizer.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div></div></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createVisualizer.selectedTab === 1\"><ng-include src=\"\'app/node/visualization/createVisualization/visualizerSteps/details.html\'\"></ng-include></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createVisualizer.selectedTab === 2\"><ng-include src=\"\'app/node/visualization/createVisualization/visualizerSteps/attributes.html\'\"></ng-include></div><div class=\"col-sm-10 h-100 p-0\" ng-if=\"createVisualizer.selectedTab === 3\"><ng-include src=\"\'app/node/visualization/createVisualization/visualizerSteps/layout.html\'\"></ng-include></div></div></div>");
$templateCache.put("app/node/visualization/visualizationInfo/visualizationInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/pipeline/listeners/createListener/createListener.html","<div ng-controller=\"createListenerCtrl as createListener\" ng-init=\"createListener.fnInitCreateListeners()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createListener.title}}</h3><button ng-if=\"listeners.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"listeners.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"m-t-10\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"createListener.isListenerModelsLoading\"></div><div class=\"row\" ng-if=\"!createListener.isListenerModelsLoading\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"createListener.finishedWizard()\" indicators-position=\"top\"><wz-step wz-title=\"1. Add information\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Add Statement\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/statement.html\'\"></div></wz-step><wz-step wz-title=\"3. Add Expression\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/expression.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/createListener/createListenerFromBluePrint.html","<div ng-controller=\"createListenerCtrl as createListener\" ng-init=\"createListener.fnInitCreateListenerFromBluePrint()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createListener.title}}</h3><button ng-if=\"listeners.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"listeners.fnHideShowCreateForm(true)\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createListener.isBluePrintFetched && createListener.isListenerModelsLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div ng-if=\"createListener.isBluePrintFetched && !createListener.isListenerModelsLoading\" class=\"col-sm-12 wizard\"><div class=\"m-t-20 m-b-5\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint.name as bluePrint.name for bluePrint in createListener.bluePrintArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"createListener.fnBluePrintSelected(createListener.selectedBluePrint)\" ng-model=\"createListener.selectedBluePrint\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Blue Print</label> <small class=\"helper-text\">Select a Blue Print</small></div></div><wizard on-finish=\"createListener.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\" ng-show=\"createListener.isBluePrintSelected\"><wz-step wz-title=\"1. Add information\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Add Statement\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/statement.html\'\"></div></wz-step><wz-step wz-title=\"3. Add Expression\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/expression.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/listeners/createListener/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/editListener.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Edit Listener\'\"></h4></div><div class=\"modal-body h-dynamic\" style=\"height: calc(100vh - 185px) !important;\" ng-init=\"editListener.fnInitEditBluePrint()\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100 p-10\"><div class=\"content-box\"><div class=\"content-container p-0\" style=\"overflow: hidden\"><div class=\"col-sm-12 m-t-10 p-0\" ng-if=\"editListener.isListenerModelsLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 m-t-10 p-0\" ng-if=\"!editListener.isListenerModelsLoading\"><div class=\"col-sm-3 h-100 p-l-0 p-b-0\" style=\"height: calc(100vh - 210px) !important;\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"editListener.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"editListener.fnSet(); editListener.selectedTab = item.tabIndex;\" ng-repeat=\"item in editListener.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"editListener.selectedTab === 1\"><div class=\"content-box\"><div class=\"content-box-content p-0\" style=\"overflow: auto\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/information.html\'\"></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" style=\"height: calc(100vh - 210px) !important;\" ng-if=\"editListener.selectedTab === 2\"><div class=\"content-box\"><div id=\"expressionDiv\" class=\"content-box-content p-0\" style=\"overflow: auto\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/expression.html\'\"></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer p-b-10\"><button ng-if=\"!editListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary\" ng-click=\"editListener.fnCancel()\" tabindex=\"12\">Close</button> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!editListener.isListenerCreating && !editListener.isListenerModelsLoading\" ng-click=\"editListener.finishedWizardEdit(editListener.newListenerObj)\" ng-disabled=\"!editListener.newListenerObj.name || !editListener.newListenerObj.statements.length || editListener.isAddExpression\" value=\"Save\"><div ng-if=\"editListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/listenerInfo/listenerInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/pipeline/templates/templateInfo/templateInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/pipeline/templates/createTemplate/createTemplate.html","<div ng-controller=\"createTemplateCtrl as createTemplate\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createTemplate.title}}</h3><button ng-if=\"templates.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"templates.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"createTemplate.finishedWizard()\" indicators-position=\"top\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Template\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/template.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Template\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"m-b-10\" ng-show=\"!createTemplate.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your template.</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTemplate.isInputBadlyFormatted = false\" ng-model=\"createTemplate.validateInput\" ui-codemirror-opts=\"createTemplate.editorOptions\"></ui-codemirror></div></div></div><div ng-show=\"createTemplate.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTemplate.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/validateTemplate.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/createTemplateFromBluePrint.html","<div ng-controller=\"createTemplateCtrl as createTemplate\" ng-init=\"createTemplate.fnInitCreateTemplateFromBluePrint()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createTemplate.title}}</h3><button ng-if=\"templates.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"templates.fnHideShowCreateForm(true)\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-show=\"!createTemplate.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div ng-show=\"createTemplate.isBluePrintFetched\" class=\"col-sm-12 wizard\"><div id=\"functionModal\" ng-show=\"!createTemplate.isBluePrintSelected\" class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"createTemplate.search\" ng-change=\"createTemplate.fnBluePrintFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\" ng-if=\"createTemplate.isBluePrintFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-6\" ng-if=\"!createTemplate.isBluePrintFilter && createTemplate.bluePrintArr.length\" ng-repeat=\"bluePrintObj in createTemplate.bluePrintArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{bluePrintObj.name}}\" tooltip-placement=\"top\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{bluePrintObj.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"createTemplate.fnBluePrintSelected(bluePrintObj.name)\">Select</button></div></div></div></div><div class=\"panel-body rolePanel-body\"><span>{{bluePrintObj.description}}</span></div></div></div><div class=\"col-sm-12\" ng-if=\"!createTemplate.bluePrintArr.length && !createTemplate.isBluePrintFilter\"><label>No records found...</label></div></div><div class=\"col-sm-12 p-0\" ng-show=\"createTemplate.isBluePrintSelected\"><button class=\"btn btn-link p-l-0\" ng-click=\"createTemplate.isBluePrintSelected = false;createTemplate.isBluePrintFetched=false;createTemplate.search=\'\';createTemplate.fnInitCreateTemplateFromBluePrint()\">Back</button></div><wizard on-finish=\"createTemplate.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\" ng-show=\"createTemplate.isBluePrintSelected\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Template\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/template.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Template\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"m-b-10\" ng-show=\"!createTemplate.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your template.</small></div><div class=\"row\"><div class=\"col-sm-12\" ng-init=\"createTemplate.modeChanged()\"><ui-codemirror ng-change=\"createTemplate.isInputBadlyFormatted = false\" ng-model=\"createTemplate.validateInput\" ui-codemirror-opts=\"createTemplate.editorOptions\"></ui-codemirror></div></div></div><div ng-show=\"createTemplate.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTemplate.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/validateTemplate.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/editTemplateFromBluePrint.html","<div ng-controller=\"createTemplateCtrl as createTemplate\" ng-init=\"createTemplate.fnInitEditBluePrint()\"><button type=\"button\" class=\"btn btn-link pull-right p-0 m-t-5\" ng-click=\"createTemplate.fnExitEditMode()\"><i class=\"fa fa-times\"></i></button><div><div class=\"row\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"createTemplate.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Template\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/template.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Template\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"m-b-10\" ng-show=\"!createTemplate.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your template.</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTemplate.isInputBadlyFormatted = false\" ng-model=\"createTemplate.validateInput\" ui-codemirror-opts=\"createTemplate.editorOptions\"></ui-codemirror></div></div></div><div ng-show=\"createTemplate.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTemplate.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/validateTemplate.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/templates/createTemplate/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/createTransformer.html","<div ng-controller=\"createTransformerCtrl as createTransformer\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createTransformer.title}}</h3><button ng-if=\"transformers.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"transformers.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"createTransformer.finishedWizard()\" indicators-position=\"top\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><span>Transformer Spec:</span> <small class=\"pull-right\">Enter transformer spec. spec should be in proper json format</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTransformer.isInputBadlyFormatted = false\" ng-model=\"createTransformer.newTransformerObj.txtSpec\" ui-codemirror-opts=\"createTransformer.editorOptions\"></ui-codemirror></div></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/transformer.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm1\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div ng-show=\"!createTransformer.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your transformer.</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTransformer.isInputBadlyFormatted = false\" ng-model=\"createTransformer.validateInput\" ui-codemirror-opts=\"createTransformer.editorOptions\"></ui-codemirror></div></div></div><div ng-if=\"createTransformer.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTransformer.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/validateTransformer.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/createTransformerFromBluePrint.html","<div ng-controller=\"createTransformerCtrl as createTransformer\" ng-init=\"createTransformer.fnInitCreateTransformerFromBluePrint()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createTransformer.title}}</h3><button ng-if=\"transformers.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"transformers.fnHideShowCreateForm(true)\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createTransformer.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div ng-if=\"createTransformer.isBluePrintFetched\" class=\"col-sm-12 wizard\"><div id=\"functionModal\" ng-show=\"!createTransformer.isBluePrintSelected\" class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"createTransformer.search\" ng-change=\"createTransformer.fnBluePrintFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\" ng-if=\"createTransformer.isBluePrintFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-6\" ng-if=\"!createTransformer.isBluePrintFilter && createTransformer.bluePrintArr.length\" ng-repeat=\"bluePrintObj in createTransformer.bluePrintArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{bluePrintObj.name}}\" tooltip-placement=\"top\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{bluePrintObj.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"createTransformer.fnBluePrintSelected(bluePrintObj.name)\">Select</button></div></div></div></div><div class=\"panel-body rolePanel-body\"><span>{{bluePrintObj.description}}</span></div></div></div><div class=\"col-sm-12\" ng-if=\"!createTransformer.bluePrintArr.length && !createTransformer.isBluePrintFilter\"><label>No records found...</label></div></div><div class=\"col-sm-12 p-0\" ng-show=\"createTransformer.isBluePrintSelected\"><button class=\"btn btn-link p-l-0\" ng-click=\"createTransformer.isBluePrintSelected = false;createTransformer.isBluePrintFetched=false;createTransformer.search=\'\';createTransformer.fnInitCreateTransformerFromBluePrint()\">Back</button></div><wizard on-finish=\"createTransformer.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\" ng-show=\"createTransformer.isBluePrintSelected\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><span>Transformer Spec:</span> <small class=\"pull-right\">Enter transformer spec. spec should be in proper json format</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTransformer.isInputBadlyFormatted = false\" ng-model=\"createTransformer.newTransformerObj.txtSpec\" ui-codemirror-opts=\"createTransformer.editorOptions\"></ui-codemirror></div></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/transformer.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm1\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div ng-show=\"!createTransformer.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your transformer.</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTransformer.isInputBadlyFormatted = false\" ng-model=\"createTransformer.validateInput\" ui-codemirror-opts=\"createTransformer.editorOptions\"></ui-codemirror></div></div></div><div ng-show=\"createTransformer.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTransformer.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/validateTransformer.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/editTransformerFromBluePrint.html","<div ng-controller=\"createTransformerCtrl as createTransformer\" ng-init=\"createTransformer.fnInitEditBluePrint()\"><button type=\"button\" class=\"btn btn-link pull-right p-0 m-t-5\" ng-click=\"createTransformer.fnExitEditMode()\"><i class=\"fa fa-times\"></i></button><div><div class=\"row\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"createTransformer.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\"><wz-step wz-title=\"1. Information\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/information.html\'\"></div></wz-step><wz-step wz-title=\"2. Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><span>Transformer Spec:</span> <small class=\"pull-right\">Enter transformer spec. spec should be in proper json format</small></div><div class=\"row\"><div class=\"col-sm-12\"><textarea id=\"jsoncode\" ui-codemirror=\"createTransformer.editorOptions\" ng-model=\"createTransformer.newTransformerObj.txtSpec\"></textarea></div></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/transformer.html\'\"></div></wz-step><wz-step wz-title=\"3. Validate Transformer\"><div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTransformerInfoForm1\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div ng-show=\"!createTransformer.isValidated\"><div class=\"col-sm-12 p-0\"><span>Input:</span> <small class=\"pull-right\">Enter a correct Json structure to validate your transformer.</small></div><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"createTransformer.isInputBadlyFormatted = false\" ng-model=\"createTransformer.validateInput\" ui-codemirror-opts=\"createTransformer.editorOptions\"></ui-codemirror></div></div></div><div ng-show=\"createTransformer.isValidated\" class=\"pace\"><div class=\"col-sm-12 p-0\"><span>Result from validation</span></div><textarea ng-model=\"createTransformer.validateResult\"></textarea></div></form></div></div><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/validateTransformer.html\'\"></div></wz-step><wz-step wz-title=\"4. Review\"><div ng-include=\"\'app/pipeline/transformers/createTransformer/steps/review.html\'\"></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/transformerInfo/transformerInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/createWorkFlow.html","<div class=\"row h-100\" ng-init=\"createWorkFlow.fnInitCreateWorkFlow()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-2 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"search-panel1 m-t-5\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13\"><input type=\"text\" id=\"stateSearchInput\" required=\"\" class=\"md-form-control\" ng-model=\"createWorkFlow.search\" ng-change=\"createWorkFlow.fnStatesFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"createWorkFlow.isStatesLoading || createWorkFlow.isListenerModelsLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 accordionWithScroll\" ng-if=\"!createWorkFlow.isStatesLoading && !createWorkFlow.isListenerModelsLoading\"><div id=\"accordionPanel\"><div id=\"palettePane\" draw2d-palette=\"\" ng-if=\"Object.keys(editor.palette.figuresObj).length !== 0\" trigger-count=\"createWorkFlow.triggerCount\" editor=\"editor\" trigger-state-drag-start=\"createWorkFlow.fnStateDragStart()\"></div><div ng-if=\"Object.keys(editor.palette.figuresObj).length === 0\"><label>No Records Found</label></div></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"></div><div class=\"col-sm-6\"></div></div></div></div><div class=\"col-sm-7 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content p-0\" ng-class=\"createWorkFlow.isStatesLoading || createWorkFlow.isListenerModelsLoading ? \'pace\' : \'\'\" style=\"overflow: scroll\"><div id=\"canvas\" draw2d-canvas=\"\" ng-model=\"createWorkFlow.flowJson\"></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6\"><div ng-if=\"!createWorkFlow.isWorkFlowLoading\"><button type=\"button\" class=\"btn btn-link m-t-2 p-l-0 p-r-2\" ng-if=\"!createWorkFlow.isWorkflowValidating && !createWorkFlow.isWorkFlowLoading\" ng-click=\"createWorkFlow.fnValidateWorkflow()\">Validate</button> <i ng-if=\"!createWorkFlow.isWorkflowValidating && !createWorkFlow.isWorkFlowLoading\" ng-class=\"createWorkFlow.isValidateSuccessful === null ? \'\' : createWorkFlow.isValidateSuccessful ? \'fa fa-check\' : \'fa fa-exclamation-triangle\'\"></i> <button type=\"button\" class=\"btn btn-link\" ng-if=\"!createWorkFlow.isWorkflowValidating && !createWorkFlow.isWorkFlowLoading\" ng-disabled=\"createWorkFlow.isCalledFromTidy\" ng-click=\"createWorkFlow.fnTidyWorkflow()\">Tidy</button></div><div ng-if=\"createWorkFlow.isWorkFlowLoading || createWorkFlow.isWorkflowValidating\"><div class=\"m-t-2 pull-left\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div><label class=\"m-l-5 m-t-8\" ng-bind=\"createWorkFlow.isWorkflowValidating ? \'Validating Workflow\' : \'Blue Print Loading\'\"></label></div></div><div class=\"col-sm-6\"><div class=\"pull-right\"><div class=\"m-t-2\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"createWorkFlow.isWorkflowsCreating\"></div><button type=\"button\" class=\"btn btn-link m-t-2 p-r-5\" ng-if=\"!createWorkFlow.isWorkflowsCreating && !createWorkFlow.isWorkFlowLoading\" ng-click=\"createWorkFlow.fnSaveDraft()\">Save Draft</button> <button type=\"button\" class=\"btn btn-link m-t-2 p-r-0\" ng-if=\"!createWorkFlow.isWorkflowsCreating && !createWorkFlow.isWorkFlowLoading\" ng-disabled=\"!createWorkFlow.newWorkFlowObj.name.length\" ng-click=\"createWorkFlow.fnCreateWorkFlow()\">Save Workflow</button></div></div></div></div></div><div class=\"col-sm-3 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer floatingLabelInput\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\" ng-bind=\"createWorkFlow.isStateSelectedOnCanvas ? \'State Details\' : \'Create New Workflow\'\"></h3><button type=\"button\" class=\"btn btn-link pull-right p-0\" ng-if=\"createWorkFlow.isStateSelectedOnCanvas\" ng-click=\"createWorkFlow.isStateSelectedOnCanvas = false; createWorkFlow.selectedStateObj = {};\"><i class=\"fa fa-times\"></i></button></div><div class=\"content-body\" ng-if=\"!createWorkFlow.isStateSelectedOnCanvas\"><div class=\"col-sm-12 p-t-10\"><h4 class=\"m-b-20\">Workflow Basic Information</h4><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"workFlowName\" type=\"text\" ng-model=\"createWorkFlow.newWorkFlowObj.name\" placeholder=\"Name for the new WorkFlow*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"workFlowDescription\" type=\"text\" ng-model=\"createWorkFlow.newWorkFlowObj.description\" placeholder=\"Description regarding WorkFlow\"> <span class=\"highlight\"></span> <label>Description</label></div><h4 class=\"m-t-35 m-b-0\">Logging Options</h4><div class=\"m-t-20 m-b-20\"><span class=\"m-r-5 middle-display\">Enabled:</span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"createWorkFlow.newWorkFlowObj.logging.enabled\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div></div></div><div class=\"content-body\" ng-if=\"createWorkFlow.isStateSelectedOnCanvas\"><div class=\"col-sm-12 p-t-15\" ng-if=\"!createWorkFlow.isStateMdInfoLoaded\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-t-15\" ng-if=\"createWorkFlow.isStateMdInfoLoaded\"><div class=\"md-input m-t-15 m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateName\" type=\"text\" ng-model=\"createWorkFlow.selectedStateObj.name\"> <span class=\"highlight\"></span> <label>Name</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateType\" type=\"text\" ng-model=\"createWorkFlow.selectedStateObj.type\"> <span class=\"highlight\"></span> <label>Type</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateId\" type=\"text\" ng-model=\"createWorkFlow.selectedStateObj.id\"> <span class=\"highlight\"></span> <label>Id</label></div><label>Information</label><div class=\"col-sm-12 p-0 preview-only info-preview\" id=\"workflowTriggersTreeView\" ng-if=\"!createWorkFlow.isRefreshMdEditor\"><textarea name=\"issueEditor\" class=\"content-box\" ng-model=\"createWorkFlow.selectedStateObj.mdInfo\" markdown-editor=\"createWorkFlow.markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 p-l-0\"></div><div class=\"col-sm-6\" ng-class=\"createWorkFlow.isStateSelectedOnCanvas ? \'p-r-0\' : \'content-box-footerItem\'\"><div class=\"pull-right\" ng-if=\"!createWorkFlow.isStateSelectedOnCanvas && !createWorkFlow.isWorkflowsCreating && !createWorkFlow.isWorkflowValidating\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><span id=\"fileselector\"><li for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".json\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"createWorkFlow.fnImportWorkflow()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-link\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import</a></li></span></li><li ng-click=\"createWorkFlow.fnExportWorkflow()\"><a class=\"btn btn-link\">Export</a></li><li ng-click=\"createWorkFlow.fnResetWorkflow()\"><a class=\"btn btn-link\">Reset</a></li><li ng-click=\"createWorkFlow.fnLoadDrafts()\" ng-if=\"createWorkFlow.isDraftsAvailable\"><a class=\"btn btn-link\">Drafts</a></li></ul></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/createWorkflowFromBluePrint.html","<div class=\"container-with-out-footer\" ng-init=\"workflows.fnInitCreateWorkflowFromBluePrint()\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{workflows.createTitle}}</h3><button ng-if=\"workflows.permissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"workflows.fnHideShowBluePrintForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"content-body modal-body p-t-0 p-r-15 p-l-15 p-b-15\" id=\"modal-body\" style=\"overflow-y: auto;\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!workflows.isBluePrintFetched\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div ng-if=\"workflows.isBluePrintFetched\" class=\"col-sm-12\"><div id=\"functionModal\" class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12\"><div class=\"md-input m-b-13 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"workflows.search\" ng-change=\"workflows.fnBluePrintFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\" ng-if=\"workflows.isBluePrintFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-6\" ng-if=\"!workflows.isBluePrintFilter && workflows.bluePrintArr.length\" ng-repeat=\"bluePrintObj in workflows.bluePrintArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{bluePrintObj.name}}\" tooltip-placement=\"top\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{bluePrintObj.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"workflows.fnBluePrintSelected(bluePrintObj)\">Select</button></div></div></div></div><div class=\"panel-body rolePanel-body\"><span>{{bluePrintObj.description}}</span></div></div></div><div class=\"col-sm-12\" ng-if=\"!workflows.bluePrintArr.length && !workflows.isBluePrintFilter\"><label>No records found...</label></div></div></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/storage/folder/createFolder/createFolder.html","<div ng-controller=\"createFolderCtrl as createFolder\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createFolder.title}}</h3><button ng-if=\"folder.folderPermissionObj.Create\" type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"folder.fnHideShowCreateForm()\"><i class=\"fa fa-times\"></i></button></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewFolderForm\" role=\"form\" name=\"createNewFolderForm\"><div class=\"md-input\" ng-class=\"createNewFolderForm.folderName.$error.pattern?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" name=\"folderName\" ng-model=\"createFolder.folderName\" ng-pattern=\'/^[^\\\\\\/\\?\\*\\\"\\>\\<\\:\\|]*$/\' placeholder=\"Name for the new Folder.*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text-error\" ng-show=\"createNewFolderForm.folderName.$error.pattern\"><span class=\"errorText\">Folder name should not contain \'/ \\ : ? * \" < >\' characters.</span></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createNewFolderForm.$valid\" ng-click=\"createFolder.fnCreateNewFolder(createFolder.folderName)\" ng-if=\"!createFolder.isFolderCreating\">Create Folder</button></div><div class=\"col-sm-12\" ng-if=\"createFolder.isFolderCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/predictive/account/createAccount/createAccount.html","<div ng-controller=\"createAccountCtrl as createAccount\"><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"signupForm\" role=\"form\" name=\"signupForm\" class=\"active animated\" novalidate=\"\"><div class=\"md-input has-feedback\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" ng-model=\"createAccount.userObj.firstName\" placeholder=\"First Name*\" name=\"firstName\"> <span class=\"highlight\"></span> <label>First Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"lastName\" type=\"text\" ng-model=\"createAccount.userObj.lastName\" placeholder=\"Last Name*\" name=\"lastName\"> <span class=\"highlight\"></span> <label>Last Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" name=\"email\" ng-change=\"createAccount.isEmailAvailable = true; createAccount.fnValidateEmail(createAccount.userObj.email)\" ng-model=\"createAccount.userObj.email\" placeholder=\"Email*\"> <span class=\"highlight\"></span> <label>Email*</label> <small class=\"helper-text\"><span ng-if=\"!signupForm.email.$error.required && createAccount.isEmailInvalid\">Email is not Valid</span> <span ng-if=\"!createAccount.isEmailAvailable\">This Email is already taken. Please try another one.</span></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"username\" type=\"text\" ng-model=\"createAccount.userObj.username\" ng-pattern=\"/^[A-Za-z0-9_]+$/\" ng-change=\"createAccount.isUsernameAvailable = true\" ng-focus=\"createAccount.showUserNameSuggestions = true\" ng-blur=\"createAccount.showUserNameSuggestions = false\" placeholder=\"Username*\" name=\"Username\"> <span class=\"highlight\"></span> <label>Username*</label> <small class=\"helper-text\"><span ng-if=\"createAccount.showUserNameSuggestions && createAccount.isUsernameAvailable\">Username may contain a-z, A-Z, 0-9 and the _ characters</span> <span ng-if=\"!createAccount.isUsernameAvailable\">This Username is already taken. Please try another one.</span></small></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"companyName\" type=\"text\" ng-model=\"createAccount.accountObj.name\" placeholder=\"Company Name\" name=\"companyName\"> <span class=\"highlight\"></span> <label>Company Name</label> <small class=\"helper-text\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-if=\"!createAccount.isCreatingNewAccount\" ng-disabled=\"!createAccount.userObj.firstName.length || !createAccount.userObj.lastName.length || !createAccount.userObj.email.length || !createAccount.userObj.username.length || signupForm.username.$valid || createAccount.isEmailInvalid\" ng-click=\"createAccount.fnCreateNewAccount()\">Open Account</button><div class=\"m-t-10 text-center pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"createAccount.isCreatingNewAccount\"></div></div></div></div></div>");
$templateCache.put("app/storage/folder/folderInfo/folderInfo.html","<div class=\"container-with-footer tab-container\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/archived/archivedInfo/archivedInfo.html","<div class=\"container-with-footer tab-container issue-detail-page\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-15 p-b-15\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\"><span>Archives</span></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-12 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{issueObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{issueObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0 p-t-10 align-items-center\"><div class=\"m-r-10\"><button class=\"btn btn-primary\" ng-show=\"!issueObj.resolved\">Open</button></div><div class=\"position-r w100\"><div class=\"\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"25px\" height=\"25px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div class=\"progress w100 m-b-0\" uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div></div></div></div></div><div class=\"col-sm-4 p-0 m-auto justify-content-flex-end d-flex flex-column align-items-flex-end\"><div class=\"customDropdown pull-right\"><button type=\"button\" class=\"btn btn-sm btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESTORE_ISSUE\" ng-click=\"fnRestoreIssue(issueObj)\">Restore Issue</button></div><div class=\"m-t-10\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0 d-flex\"></div></div></div></div><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"selectedCommentView === \'Vertical\'\"><a class=\"btn btn-link\" ng-click=\"fnChangeCommentView(\'Horizontal\')\" ng-class=\"selectedTab !== 1 && selectedTab !== 2 ? \'pace opacity-5\' : \'\'\">Horizontal View</a></li><li ng-if=\"selectedCommentView === \'Horizontal\'\"><a class=\"btn btn-link\" ng-click=\"fnChangeCommentView(\'Vertical\')\" ng-class=\"selectedTab !== 1 && selectedTab !== 2 ? \'pace opacity-5\' : \'\'\">Vertical View</a></li></ul></div></div></div>");
$templateCache.put("app/tracker/issue/createIssue/createIssue.html","<div class=\"form-content\" ng-controller=\"createIssueCtrl as createIssue\" ng-class=\"createIssue.isIssueCreating ? \'pace\' : \'\'\" ng-init=\"createIssue.fnInitCreateIssue()\"><div class=\"modal-body height-100\" id=\"modal-body\" style=\"overflow: hidden\"><div class=\"row h-100 overflow-auto\"><div class=\"col-sm-12 p-0\" ng-if=\"!createIssue.isProjectLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex height-max-content\" ng-if=\"createIssue.isProjectLoaded\"><div class=\"p-0 issueSideAnimation\" ng-class=\"createIssue.isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class\'\"><div class=\"col-sm-12 m-t-10\" id=\"newIssueTitle\"><div class=\"col-sm-2 p-0 m-t-0 m-b-20 customDropdown floatingLabelInput\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary p-b-5 issue-project-dropdown-menu\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createIssue.selectedProject.name}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown p-b-0\" style=\"max-height: none;\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.issueProjectSearch[createIssue.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createIssue.filterProject=(createIssue.projectsArr | filter:createIssue.issueProjectSearch) track by $index\" ng-click=\"createIssue.fnChangeProject(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === createIssue.selectedProject.id\"></i></span><div class=\"d-flex flex-column\"><span>{{projectObj.name}}</span> <span class=\"font-italic\">({{projectObj.id}})</span></div></a></li><li ng-if=\"!createIssue.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"col-sm-10 p-r-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"createIssue.newIssueObj.name\" placeholder=\"Title for the new Issue*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 m-t-0 m-b-20 customDropdown\" id=\"typeListDropdown\"><app-spinner ng-if=\"!createIssue.isIssueTypeLoaded\" spinner-type=\"\'microSpinner\'\"></app-spinner><div class=\"btn-group col-sm-12 p-0\" ng-if=\"createIssue.isIssueTypeLoaded\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createIssue.selectedType.name}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span> <span style=\"position: absolute;right: 25px;\" ng-if=\"createIssue.selectedType && createIssue.selectedType.id && createIssue.selectedType.id !== \'noType\'\">({{createIssue.selectedType.id}})</span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"typeObj in createIssue.typesArr\"><a ng-click=\"createIssue.fnSelectType(typeObj)\"><span>{{typeObj.name}}</span><br><span class=\"font-italic\" ng-if=\"typeObj.id !== \'noType\'\">({{typeObj.id}})</span></a></li></ul></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"!createIssue.isTypeDetailsLoaded\"><app-spinner class=\"\" spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 d-flex m-t-20 typeFormInputAction\" ng-if=\"createIssue.isIssueTypeLoaded && createIssue.selectedType && createIssue.isTypeDetailsLoaded && createIssue.selectedType.id !== \'noType\' && createIssue.form.length\"><form role=\"form\" name=\"typeForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"createIssue.schema\" sf-form=\"createIssue.form\" sf-model=\"createIssue.model\"></form></div></div><div class=\"col-sm-12 floatingLabelInput\" id=\"issueMarkdownContainer\"><div class=\"m-b-20 createIssue hide-toolbar createIssueMarkdownEditor\"><textarea name=\"editor1\" class=\"content-box\" ng-drop-dir-for-issue=\"\" placeholder=\"Type your message...\" upload-file=\"createIssue.uploadFiles(type, filedata)\" ng-model=\"createIssue.newIssueObj.summary\" markdown-editor=\"{\'iconlibrary\': \'fa\', addExtraButtons: false, resize: \'none\'}\" rows=\"10\">\n                            </textarea><div class=\"markdown-footer d-flex justify-content-space-between align-items-center\"><button class=\"btn btn-primary m-l-0 h-100\" ng-click=\"createIssue.fnHideShowEditorPreview(\'editor1\')\"><span class=\"fa fa-eye\"></span> Preview</button><div class=\"d-flex justify-content-flex-end h-100\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"createIssue.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!createIssue.isIssueCreating && !createIssue.fileUploading && createIssue.permissionObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary h-100\" ng-if=\"!createIssue.isIssueCreating && !createIssue.fileUploading\" ng-disabled=\"!createIssue.newIssueObj.name.length || !createIssue.newIssueObj.summary.length || !createIssue.selectedProject.id.length || createIssue.fnCheckIssueTypeValidation()\" ng-click=\"createIssue.fnCreateNewIssue(createIssue.newIssueObj)\">Submit</button><app-spinner class=\"m-r-5 m-t-4\" ng-if=\"createIssue.isIssueCreating || createIssue.fileUploading\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"p-0 issueSideAnimation\" ng-class=\"createIssue.isExpanded ? \'col-sm-3\': \'custom-class-sidebar\'\"><div class=\"issue-side-panel h-100 overflow-auto\"><div class=\"col-sm-12 p-0 overflow-auto expand-side-panel\"><div class=\"col-sm-12 p-0\" ng-if=\"createIssue.isExpanded\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignees</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.changeAssigneeView && createIssue.isIssueAssigneeLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createIssue.fnOpenChangeAssigneeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!createIssue.newIssueObj.assignees.length\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><div class=\"col-sm-12 p-0\"><span class=\"p-0 d-block p-b-5\" ng-if=\"createIssue.newIssueObj.assignees.length\" ng-repeat=\"assignee in createIssue.newIssueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createIssue.changeAssigneeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createIssue.fnOnToggleAssignee(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createIssue.newIssueObj.assignees.length > 1\">{{createIssue.newIssueObj.assignees[0].username + \' + \' + (createIssue.newIssueObj.assignees.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createIssue.newIssueObj.assignees.length === 1\">{{createIssue.newIssueObj.assignees[0].firstName + \' \'+ createIssue.newIssueObj.assignees[0].lastName}}</span> <span class=\"w100 text-left\" ng-if=\"!createIssue.newIssueObj.assignees.length\">No Assignees</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign to</label> <span ng-click=\"createIssue.fnCancelChangeAssignee()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.assigneeSearch[createIssue.filterAssignees]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"assigneeObj in createIssue.filterUsers=(createIssue.usersArr | filter:createIssue.assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetAssigneeInfo(assigneeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"assigneeObj.isCheck\"></i></span> <span class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" style=\"left: 0px;\" ng-src=\"{{assigneeObj.userAvatar}}\"></span> <span class=\"d-flex flex-column\"><span>{{assigneeObj.firstName + \" \"+ assigneeObj.lastName}}</span> <span class=\"font-italic gateway-id-menu-option\">({{assigneeObj.username}})</span></span></a></li><li ng-repeat=\"teamObj in filterteams=(createIssue.teamsArr | filter:createIssue.assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetTeamInfo(teamObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"teamObj.isCheck\"></i></span> <span class=\"d-flex flex-column ellipsis\"><span>{{teamObj.name}}</span> <span class=\"font-italic gateway-id-menu-option ellipsis\">{{teamObj.description}}</span></span></a></li><li ng-if=\"!createIssue.filterUsers.length && !createIssue.filterteams.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createIssue.fnManageAssignees()\"><a><span>Manage Assignees</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createIssue.fnCancelChangeAssignee()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.changePriorityView && createIssue.isIssuePriorityLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createIssue.fnOpenChangePriorityView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createIssue.newIssueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createIssue.newIssueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createIssue.newIssueObj.issuePriority\" ng-style=\"createIssue.fnGetIssuesLabelColor(createIssue.newIssueObj.issuePriority.color)\"><span>{{createIssue.newIssueObj.issuePriority.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createIssue.changePriorityView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createIssue.fnOnTogglePriority(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createIssue.newIssueObj.issuePriority.name\">{{createIssue.newIssueObj.issuePriority.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createIssue.newIssueObj.issuePriority.name\">No Priority</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Priority</label> <span ng-click=\"createIssue.fnCancelChangePriority()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.prioritySearch[createIssue.priorityFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"Priority in createIssue.filterPriority=(createIssue.prioritiesArr | filter:createIssue.prioritySearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetPrioritiesInfo(Priority)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"Priority.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"Priority.color ? {\'background-color\' : Priority.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{Priority.name}}</span></a></li><li ng-if=\"!createIssue.filterPriority.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createIssue.fnManageProjectPriority()\"><a><span>Manage project priorities</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createIssue.fnCancelChangePriority()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.changeStateView && createIssue.isIssueStateLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createIssue.fnOpenChangeStateView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createIssue.changeStateView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createIssue.newIssueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createIssue.newIssueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"createIssue.newIssueObj.issueState\" ng-style=\"createIssue.fnGetIssuesLabelColor(createIssue.newIssueObj.issueState.color)\"><span>{{createIssue.newIssueObj.issueState.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createIssue.changeStateView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createIssue.fnOnToggleState(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createIssue.newIssueObj.issueState.name\">{{createIssue.newIssueObj.issueState.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createIssue.newIssueObj.issueState.name\">No State</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign State</label> <span ng-click=\"createIssue.fnCancelChangeState()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.stateSearch[createIssue.stateFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"state in createIssue.filterState=(createIssue.statesArr | filter:createIssue.stateSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetStatesInfo(state)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"state.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"state.color ? {\'background-color\' : state.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{state.name}}</span></a></li><li ng-if=\"!createIssue.filterState.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createIssue.fnManageProjectState()\"><a><span>Manage project state</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createIssue.fnCancelChangeState()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.addLabelView && createIssue.isIssueLablesLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createIssue.fnOpenAddLabelView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createIssue.newIssueObj.issueLabels.length\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in createIssue.assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5 ellipsis-issues-label\" ng-style=\"createIssue.fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createIssue.addLabelView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createIssue.fnOnToggle(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createIssue.assigneesLabels.length > 1\">{{createIssue.assigneesLabels[0].name + \' + \' + (createIssue.assigneesLabels.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createIssue.assigneesLabels.length === 1\">{{createIssue.assigneesLabels[0].name}}</span> <span class=\"w100 text-left\" ng-if=\"!createIssue.assigneesLabels.length\">No Labels</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign labels</label> <span ng-click=\"createIssue.fnCancelAddLabelView()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.labelSearch[createIssue.filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"labelObj in createIssue.filterLabels=(createIssue.labelsArr | filter:createIssue.labelSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetLabelInfo(labelObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"labelObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"labelObj.color ? {\'background-color\' : labelObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{labelObj.name}}</span></a></li><li ng-if=\"!createIssue.filterLabels.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createIssue.fnManageProjectLabels()\"><a><span>Manage project labels</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"createIssue.fnCancelAddLabelView()\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PARTICIPANTS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.changeParticipantView && createIssue.isIssueParticipantLoaded\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();createIssue.fnOpenChangeParticipantView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!createIssue.newIssueObj.participants.length\"><div class=\"grayItalicValue\">No Participants</div></div><span class=\"p-0 d-block m-r-5 m-b-5 p-2\" ng-if=\"createIssue.newIssueObj.participants.length\" ng-repeat=\"participant in createIssue.newIssueObj.participants\"><span class=\"border-1-assignee p-2\">{{participant}}</span></span></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"createIssue.changeParticipantView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createIssue.fnOnToggleParticipant(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createIssue.assigneesParticipants.length > 1\">{{createIssue.assigneesParticipants[0].email + \' + \' + (createIssue.assigneesParticipants.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"createIssue.assigneesParticipants.length === 1\">{{createIssue.assigneesParticipants[0].email}}</span> <span class=\"w100 text-left\" ng-if=\"!createIssue.assigneesParticipants.length\">No Participants</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Participants</label> <span ng-click=\"createIssue.fnCancelChangeParticipant()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createIssue.participantSearch[createIssue.participantFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"participantObj in createIssue.filterParticipants=(createIssue.participantUsersArr | filter:createIssue.participantSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createIssue.fnGetParticipantInfo(participantObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"participantObj.isCheck\"></i></span> <span>{{participantObj.email}}</span></a></li><li ng-if=\"!createIssue.filterParticipants.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createIssue.fnAddNewParticipant()\"><a><span>Add new participant</span></a></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!createIssue.changeConfidentialView\"><i class=\"fa fa-edit fa-lg\" ng-click=\"createIssue.fnOpenChangeConfidentialView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!createIssue.changeConfidentialView\"><span ng-if=\"!createIssue.newIssueObj.confidential\">Not</span> Confidential</div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"createIssue.changeConfidentialView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintConfidential\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"confidential as confidential.name for confidential in createIssue.confidentialsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedConfidential.confidential\" placeholder=\"Confidential for the Issue\"> <span class=\"highlight\"></span> <label>Select Confidential</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"createIssue.isConfidentialChanged\" ng-disabled=\"!createIssue.fnCheckEmpty(selectedConfidential.confidential.name)\" ng-click=\"createIssue.fnChangeIssueConfidential(selectedConfidential.confidential)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"createIssue.isConfidentialChanged\" ng-click=\"createIssue.fnCancelChangeConfidential()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!createIssue.isConfidentialChanged\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createIssue.isExpanded\"><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.fnGetAssigneesTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.newIssueObj.issuePriority.name ? createIssue.newIssueObj.issuePriority.name: \'No Priority\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.newIssueObj.issueState.name ? createIssue.newIssueObj.issueState.name: \'No State\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.fnGetLabelsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.fnGetParticipantsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{createIssue.newIssueObj.confidential ? \'Confidential\' : \'Not Confidential\'}}\" tooltip-placement=\"left\"><svg ng-if=\"createIssue.newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/confidential.svg#confidential\"></use></svg><svg ng-if=\"!createIssue.newIssueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/notConfidential.svg#notConfidential\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 d-flex issue-side-panel-expand-btn\"><button class=\"btn btn-primary d-flex align-items-center justify-content-center w100\" ng-click=\"createIssue.fnExpandCollapseSideBar()\"><i class=\"fa\" ng-class=\"createIssue.isExpanded ? \'fa-angle-double-right\':\'fa-angle-double-left\'\"></i></button></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"labelColor.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.name\"></span> <span class=\"pull-right m-t-5\" style=\"width: 15px; height: 15px; display: inline-block\" ng-style=\"match.model.color ? {\'background-color\' : match.model.color} : {\'background-color\' : \'inherit\'}\"> </span> </a></script><script type=\"text/ng-template\" id=\"assigneeUser.html\"><a> <span class=\"d-flex align-items-center\"> <span class=\"m-r-5\"> <img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{match.model.userAvatar}}\"> </span> <span> <span style=\"display: block;\"> {{match.model.firstName + \" \"+ match.model.lastName}} </span> <span class=\"font-italic gateway-id-menu-option\">({{match.model.username}})</span> </span> </span> </a></script><script type=\"text/ng-template\" id=\"UserNameTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-if=\"match.model.company && match.model.company !==\'\'\"> {{match.model.firstName + \" \"+match.model.lastName + \" \"+\"(\"+match.model.company+\")\"}} </span> <span ng-if=\"!match.model.company || match.model.company ===\'\'\"> {{match.model.firstName + \" \"+match.model.lastName}} </span> </div> <br> </div> </a></script>");
$templateCache.put("app/tracker/issue/modal/storageUploadFromIssue.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"storageUpload.fnInitModel()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Select Path to Upload\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"storageUpload.isCreateViewSelected\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-link pull-right\"><i class=\"fa fa-times\" ng-if=\"!storageUpload.isFolderCreating\" ng-click=\"storageUpload.isCreateViewSelected = false; storageUpload.folderName = \'\'\"></i></button></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><form id=\"createNewFolderForm\" role=\"form\" name=\"createNewFolderForm\"><div class=\"md-input m-b-40\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" name=\"folderName\" ng-model=\"storageUpload.folderName\" ng-pattern=\'/^[^\\\\\\/\\?\\*\\\"\\>\\<\\:\\|]*$/\' placeholder=\"Name for the new Folder*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\" ng-if=\"createNewFolderForm.folderName.$error.pattern\">Folder name should not contain \'/ \\ : ? * \" < >\' characters.</small> <small class=\"helper-text\" ng-if=\"!createNewFolderForm.folderName.$error.pattern\"></small></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createNewFolderForm.$valid\" ng-click=\"storageUpload.fnCreateNewFolder(storageUpload.folderName)\" ng-if=\"!storageUpload.isFolderCreating\">Create Folder</button></div><div class=\"col-sm-12\" ng-if=\"storageUpload.isFolderCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"!storageUpload.isCreateViewSelected\"><div class=\"storage-breadcrumb\"><ul class=\"breadcrumb\" ng-if=\"!storageUpload.filterQuery.length\"><li ng-repeat=\"pathName in storageUpload.breadcrumbArray track by $index\"><a class=\"link-dk-primary\" ng-click=\"storageUpload.fnGetPath(pathName, $index)\"><i ng-if=\"pathName === \'/\'\" class=\"fa fa-home\"></i>{{pathName === \'/\' ? \'\' : pathName}}</a></li></ul></div><storage-search-directive ng-if=\"storageUpload.contentPermissionObj.List\" field-arr=\"storageUpload.searchFieldArr\" filter-query=\"storageUpload.filterQuery\" state-name=\"\'main.folder\'\" fn-filter-query-change=\"storageUpload.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"storageUpload.fnSetTableHeight()\"></storage-search-directive><div class=\"row\" ng-if=\"storageUpload.contentPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"storageUpload.isFoldersLoading\" hide-circle=\"true\" set-padding=\"true\" hide-line=\"true\" fn-resize=\"storageUpload.fnSetLoaderTableHeight()\"></table-loader><div class=\"folder-table-modal table-container\"><table id=\"storageUploadModal\" class=\"table table-striped table-check-box\" ng-show=\"!storageUpload.isFoldersLoading\"><thead><tr ng-if=\"storageUpload.folderArr.length\"><th class=\"p-l-5\">Name</th><th class=\"p-r-5\" ng-if=\"storageUpload.filterQuery.length\">Path</th><th class=\"p-r-5\">Last modified</th><th>Size</th></tr><tr ng-if=\"!storageUpload.folderArr.length\"><th>No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"folderObj in storageUpload.folderArr track by $index\" ng-dblclick=\"storageUpload.fnGetFolder(folderObj);\"><td class=\"p-l-5\"><i class=\"m-r-5 p-l-2\" ng-class=\"\'fa \'+folderObj.icon\"></i> <span ng-click=\"$event.stopPropagation();storageUpload.fnGetFolder(folderObj);\">{{folderObj.name}}</span></td><td class=\"p-r-8\" ng-if=\"storageUpload.filterQuery.length\" ng-bind=\"folderObj.path\" style=\"word-break: break-all\">Doe</td><td class=\"p-r-8\" ng-bind=\"folderObj.lastUpdate\">John</td><td ng-bind=\"folderObj.fileSize\">John</td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!storageUpload.isFoldersLoading\"><div class=\"progress text-center\" ng-if=\"storageUpload.isFileUploading\"><div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"{{storageUpload.progressBar}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{storageUpload.progressBar}}%\"><span class=\"p-l-5\">{{storageUpload.progressCounter.toFixed(2)}}%</span></div></div><div class=\"row\" ng-if=\"storageUpload.folderArr.length && !storageUpload.isFileUploading\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{storageUpload.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"storageUpload.perPage = 10; storageUpload.fnPageChanged(storageUpload.currentPage, storageUpload.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"storageUpload.perPage = 20; storageUpload.fnPageChanged(storageUpload.currentPage, storageUpload.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"storageUpload.perPage = 50; storageUpload.fnPageChanged(storageUpload.currentPage, storageUpload.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"storageUpload.perPage = 100; storageUpload.fnPageChanged(storageUpload.currentPage,storageUpload.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"storageUpload.perPage = 500; accounts.fnPageChanged(accounts.currentPage, accounts.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"storageUpload.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"storageUpload.currentPage\" items-per-page=\"storageUpload.perPage\" max-size=\"storageUpload.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"storageUpload.fnPageChanged(storageUpload.currentPage, storageUpload.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-show=\"storageUpload.isFileUploading\"></div><button class=\"btn btn-link pull-left p-l-0\" ng-if=\"storageUpload.folderPermissionObj.Create && !storageUpload.isCreateViewSelected && !storageUpload.isFileUploading && !storageUpload.isFolderCreating\" ng-click=\"storageUpload.isCreateViewSelected = true\">New Folder</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"!storageUpload.isFileUploading && !storageUpload.isFolderCreating\" ng-click=\"storageUpload.fnCancel()\" tabindex=\"12\">Close</button> <button ng-if=\"!storageUpload.filterQuery.length && !storageUpload.isFileUploading && !storageUpload.isCreateViewSelected\" type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"storageUpload.uploadFiles(storageUpload.fileData)\">Upload</button></div></div>");
$templateCache.put("app/tracker/label/createLabel/createLabel.html","<div class=\"h-100\" ng-controller=\"createLabelCtrl as createLabel\" ng-init=\"createLabel.fnInitCreateLabel()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createLabel.isLabelCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createLabel.isLabelCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewLabelForm\" role=\"form\" name=\"createNewLabelForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createLabel.newLabelObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewLabelForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createLabel.newLabelObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewLabelForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-t-10 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"createLabel.newLabelObj.color\" placeholder=\"Color*\" name=\"color\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewLabelForm.color.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Label Color*</label> <small class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><br><div class=\"col-sm-12 p-0\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedLabel in createLabel.suggestedLabelsArr\" ng-style=\"createLabel.fnAssignSpanBackground(suggestedLabel)\" ng-click=\"createLabel.fnAssignSuggestedColor(suggestedLabel)\"></span></div><div class=\"col-sm-12 p-0\" ng-click=\"\"><button class=\"btn btn-link p-l-0\" ng-click=\"createLabel.fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"createLabel.isDisplayMiniColors\"><input minicolors=\"createLabel.customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"createLabel.newLabelObj.color\"></div><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createLabel.changeProjectView\" ng-click=\"$event.stopPropagation();createLabel.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createLabel.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createLabel.selectedProject.name\"><span>{{createLabel.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createLabel.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createLabel.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createLabel.selectedProject.name\">{{createLabel.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createLabel.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createLabel.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createLabel.projectSearch[createLabel.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createLabel.filterProject=(createLabel.projectsArr | filter:createLabel.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createLabel.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createLabel.filterProject.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createLabel.fnManageProject()\"><a><span>Manage projects</span></a></li></ul></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createLabel.newLabelObj.name.length || !createLabel.newLabelObj.color.length || !(createLabel.selectedProject && createLabel.selectedProject.id)\" ng-click=\"createLabel.fnCreateNewLabel(createLabel.newLabelObj)\" ng-if=\"!createLabel.isLabelCreating\">Create Label</button></div><div class=\"col-sm-12\" ng-if=\"createLabel.isLabelCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/tracker/label/labelInfo/labelInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Label</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{labelObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{labelObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{labelObj.description ? labelObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{labelObj.description ? labelObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{labelObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(labelObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/priorities/createPriority/createPriority.html","<div ng-controller=\"createPriorityCtrl as createPriority\" class=\"h-100\" ng-init=\"createPriority.fnInitCreatePriority()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createPriority.isPriorityCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createPriority.isPriorityCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewPriorityForm\" role=\"form\" name=\"createNewPriorityForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createPriority.newPriorityObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewPriorityForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createPriority.newPriorityObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewPriorityForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"order\" type=\"number\" min=\"1\" ng-model=\"createPriority.newPriorityObj.order\" placeholder=\"Order*\" name=\"order\"> <span class=\"highlight\"></span> <label>Priority Order*</label></div><div class=\"md-input m-t-10 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"createPriority.newPriorityObj.color\" placeholder=\"Color*\" name=\"color\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewPriorityForm.color.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Label Color*</label> <small class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><br><div class=\"col-sm-12 p-0\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedPriority in createPriority.suggestedLabelsArr\" ng-style=\"createPriority.fnAssignSpanBackground(suggestedPriority)\" ng-click=\"createPriority.fnAssignSuggestedColor(suggestedPriority)\"></span></div><div class=\"col-sm-12 p-0\" ng-click=\"\"><button class=\"btn btn-link p-l-0\" ng-click=\"createPriority.fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"createPriority.isDisplayMiniColors\"><input minicolors=\"createPriority.customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"createPriority.newPriorityObj.color\"></div><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createPriority.changeProjectView\" ng-click=\"$event.stopPropagation();createPriority.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createPriority.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createPriority.selectedProject.name\"><span>{{createPriority.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createPriority.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createPriority.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createPriority.selectedProject.name\">{{createPriority.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createPriority.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createPriority.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createPriority.projectSearch[createPriority.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createPriority.filterProject=(createPriority.projectsArr | filter:createPriority.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createPriority.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createPriority.filterProject.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createPriority.fnManageProject()\"><a><span>Manage projects</span></a></li></ul></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createPriority.newPriorityObj.name.length || !createPriority.newPriorityObj.color.length || !(createPriority.selectedProject && createPriority.selectedProject.id)\" ng-click=\"createPriority.fnCreateNewPriority(createPriority.newPriorityObj)\" ng-if=\"!createPriority.isPriorityCreating\">Create Priority</button></div><div class=\"col-sm-12\" ng-if=\"createPriority.isPriorityCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/tracker/priorities/prioritiesInfo/priorityInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Priority</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{priorityObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{priorityObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{priorityObj.description ? priorityObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{priorityObj.description ? priorityObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{priorityObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(priorityObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/project/createProject/createProject.html","<div class=\"h-100\" ng-controller=\"createProjectCtrl as createProject\" ng-init=\"createProject.fnInitCreateProject()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createProject.isProjectCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createProject.isProjectCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form id=\"createNewProjectForm\" role=\"form\" name=\"createNewProjectForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createProject.newProjectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createProject.newProjectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewProjectForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Parent Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createProject.changeProjectView\" ng-click=\"$event.stopPropagation();createProject.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createProject.selectedProject.name\"><div class=\"grayItalicValue\">No Parent Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createProject.selectedProject.name\"><span>{{createProject.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createProject.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createProject.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createProject.selectedProject.name\">{{createProject.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createProject.selectedProject.name\">No Parent Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createProject.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createProject.projectSearch[createProject.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createProject.filterProject=(createProject.projectsArr | filter:createProject.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createProject.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createProject.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createProject.newProjectObj.name.length || !(createProject.selectedProject && createProject.selectedProject.id)\" ng-click=\"createProject.fnCreateNewProject(createProject.newProjectObj)\" ng-if=\"!createProject.isProjectCreating\">Create Project</button></div><div class=\"col-sm-12\" ng-if=\"createProject.isProjectCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Project</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{projectObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{projectObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{projectObj.description ? projectObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/project_emailTemplate/modal/trackerProjectTemplateModal.html","<div class=\"inmodal h-100\" ng-init=\"trackerProjectTemplate.fnInitTrackerProjectTemplateModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Warning</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"trackerProjectTemplate.isProjectRelationshipsDataLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!trackerProjectTemplate.isProjectRelationshipsDataLoading\"><div class=\"col-sm-12 p-0\">You have selected to cascade the \'{{trackerProjectTemplate.selectedTemplateObj.name}}\' email template in the \'{{trackerProjectTemplate.selectedProjectObj.name}}\' project to overwrite the \'{{trackerProjectTemplate.selectedTemplateObj.name}}\' email template in all the downstream projects. Here is a list of all projects that will have their \'{{trackerProjectTemplate.selectedTemplateObj.name}}\' overwrite with this one.</div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center p-l-26\">{{trackerProjectTemplate.selectedProjectObj.name}}</div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-repeat=\"projectList in trackerProjectTemplate.selectedProjectRelationships.downstreamProjects track by $index\" ng-if=\"trackerProjectTemplate.selectedProjectObj.id !== projectList.id\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectList.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">{{projectList.name}}</div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><h4>This cannot be undone and all existing email templates will be lost.</h4></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"!trackerProjectTemplate.isProjectRelationshipsDataLoading\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"trackerProjectTemplate.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"trackerProjectTemplate.fnConfirm()\">Confirm</button></div></div></div></div>");
$templateCache.put("app/tracker/project_emailTemplate/project_emailTemplateInfo/project_emailTemplateInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{selectedProjectName}} Email Template</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{emailTemplateObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{emailTemplateObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/project_script/modal/trackerProjectScriptModal.html","<div class=\"inmodal h-100\" ng-init=\"trackerProjectScript.fnInitTrackerProjectScriptModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Warning</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"trackerProjectScript.isProjectRelationshipsDataLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!trackerProjectScript.isProjectRelationshipsDataLoading\"><div class=\"col-sm-12 p-0\">You have selected to cascade the \'{{trackerProjectScript.selectedScriptObj.name}}\' script in the \'{{trackerProjectScript.selectedProjectObj.name}}\' project to overwrite the \'{{trackerProjectScript.selectedScriptObj.name}}\' script in all the downstream projects. Here is a list of all projects that will have their \'{{trackerProjectScript.selectedScriptObj.name}}\' overwrite with this one.</div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center p-l-26\">{{trackerProjectScript.selectedProjectObj.name}}</div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-repeat=\"projectList in trackerProjectScript.selectedProjectRelationships.downstreamProjects track by $index\" ng-if=\"trackerProjectScript.selectedProjectObj.id !== projectList.id\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"projectList.isCheck\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">{{projectList.name}}</div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><h4>This cannot be undone and all existing scripts will be lost.</h4></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"!trackerProjectScript.isProjectRelationshipsDataLoading\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"trackerProjectScript.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"trackerProjectScript.fnConfirm()\">Confirm</button></div></div></div></div>");
$templateCache.put("app/tracker/project_script/project_scriptInfo/project_scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{selectedProjectName}} S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/script/scriptInfo/scriptInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>S4</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{scriptObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{scriptObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/state/createState/createState.html","<div class=\"h-100\" ng-controller=\"createStateCtrl as createState\" ng-init=\"createState.fnInitCreateState()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createState.isStateCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createState.isStateCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewStateForm\" role=\"form\" name=\"createNewStateForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createState.newStateObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewStateForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createState.newStateObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewStateForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-t-10 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"createState.newStateObj.color\" placeholder=\"Color*\" name=\"color\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewStateForm.color.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Color*</label> <small class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><br><div class=\"col-sm-12 p-0\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedState in createState.suggestedStatesArr\" ng-style=\"createState.fnAssignSpanBackground(suggestedState)\" ng-click=\"createState.fnAssignSuggestedColor(suggestedState)\"></span></div><div class=\"col-sm-12 p-0\" ng-click=\"\"><button class=\"btn btn-link p-l-0\" ng-click=\"createState.fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"createState.isDisplayMiniColors\"><input minicolors=\"createState.customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"createState.newStateObj.color\"></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createState.changeProjectView\" ng-click=\"$event.stopPropagation();createState.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createState.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createState.selectedProject.name\"><span>{{createState.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createState.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createState.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createState.selectedProject.name\">{{createState.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createState.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createState.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createState.projectSearch[createState.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createState.filterProject=(createState.projectsArr | filter:createState.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createState.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createState.filterProject.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createState.fnManageProject()\"><a><span>Manage projects</span></a></li></ul></div></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createState.newStateObj.name.length || !createState.newStateObj.color.length || !(createState.selectedProject && createState.selectedProject.id)\" ng-click=\"createState.fnCreateNewState(createState.newStateObj)\" ng-if=\"!createState.isStateCreating\">Create State</button></div><div class=\"col-sm-12\" ng-if=\"createState.isStateCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/tracker/state/stateInfo/stateInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>State</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{stateObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{stateObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{stateObj.description ? stateObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{stateObj.description ? stateObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{stateObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(stateObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/tracker/types/createType/createType.html","<div class=\"h-100\" ng-controller=\"createTypeCtrl as createType\" ng-init=\"createType.fnInitCreateType()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createType.isTypeCreateLoaded\"></div><div class=\"modal-body height-100\" id=\"modal-body\" ng-if=\"createType.isTypeCreateLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewTypeForm\" role=\"form\" name=\"createNewTypeForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createType.newTypeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewTypeForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createType.newTypeObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewTypeForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-t-10 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"createType.newTypeObj.color\" placeholder=\"Color*\" name=\"color\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewTypeForm.color.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Color*</label> <small class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><br><div class=\"col-sm-12 p-0\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedType in createType.suggestedTypesArr\" ng-style=\"createType.fnAssignSpanBackground(suggestedType)\" ng-click=\"createType.fnAssignSuggestedColor(suggestedType)\"></span></div><div class=\"col-sm-12 p-0\" ng-click=\"\"><button class=\"btn btn-link p-l-0\" ng-click=\"createType.fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"createType.isDisplayMiniColors\"><input minicolors=\"createType.customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"createType.newTypeObj.color\"></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createType.changeProjectView\" ng-click=\"$event.stopPropagation();createType.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createType.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createType.selectedProject.name\"><span>{{createType.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createType.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createType.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createType.selectedProject.name\">{{createType.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createType.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createType.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createType.projectSearch[createType.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createType.filterProject=(createType.projectsArr | filter:createType.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createType.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createType.filterProject.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();createType.fnManageProject()\"><a><span>Manage projects</span></a></li></ul></div></div></div></div></div></div></form><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createType.newTypeObj.name.length || !createType.newTypeObj.color.length || !(createType.selectedProject && createType.selectedProject.id)\" ng-click=\"createType.fnCreateNewPriority(createType.newTypeObj)\" ng-if=\"!createType.isTypeCreating\">Create Type</button></div><div class=\"col-sm-12\" ng-if=\"createType.isTypeCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/tracker/types/typesInfo/typeInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Type</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{typeObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{typeObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{typeObj.description ? typeObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{typeObj.description ? typeObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{typeObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(typeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/user-settings/account/accountInfo/details.html","<div class=\"content-main\" ng-init=\"userAccount.fnSetTabHeight();\"><div class=\"col-sm-12 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-class=\"!userAccount.isDetailsEditable ? \'pace\' : \'\'\"><h4>1. Basic Information</h4><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"userAccount.user.name\" placeholder=\"Name for the User*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"UserName\" type=\"text\" ng-model=\"userAccount.user.username\"> <span class=\"highlight\"></span> <label>Username*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" ng-model=\"userAccount.user.email\"> <span class=\"highlight\"></span> <label>Email*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"status\" type=\"text\" ng-model=\"userAccount.user.state\"> <span class=\"highlight\"></span> <label>State*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bio\" type=\"text\" ng-model=\"userAccount.user.bio\" placeholder=\"Bio for the User\"> <span class=\"highlight\"></span> <label>Bio</label></div></div><div class=\"col-sm-12 p-0 m-t-0\"><h4>2. Account Details</h4><div class=\"md-input m-b-20 m-t-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"accountId\" type=\"text\" ng-model=\"userAccount.user.accountId\"> <span class=\"highlight\"></span> <label>Account ID*</label></div><div class=\"md-input m-b-40\"><input class=\"md-form-control pace\" required=\"\" id=\"inboundEmail\" type=\"text\" ng-model=\"userAccount.user.inboundEmail\"> <span class=\"highlight\"></span> <label>Inbound email*</label> <small class=\"helper-text\">The inbound email can be \'support@{{userAccount.user.accountId + userAccount.stage}}\' or \'example@{{userAccount.user.accountId + userAccount.stage}}\' anything you seem suitable.</small> <span class=\"typeInfo\"><i class=\"fa fa-clipboard\" title=\"Copy Email to Clipboard\" ng-click=\"userAccount.fnCopyInputText(userAccount.user.inboundEmail, \'Email\')\"></i></span></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><button class=\"btn btn-link p-0\" ng-if=\"userAccount.isDetailsEditable\" ng-click=\"userAccount.fnResetValues()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem\" ng-class=\"userAccount.isUserDetailsChanging ? \'m-t-0 m-b-0\':\'\'\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!userAccount.isDetailsEditable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"userAccount.isDetailsEditable = true;\"><a class=\"btn btn-link\">Edit</a></li></ul></div><button class=\"btn btn-link pull-right p-0\" ng-disabled=\"!userAccount.user.name.length\" ng-if=\"!userAccount.isUserDetailsChanging && userAccount.isDetailsEditable\" ng-click=\"userAccount.fnUpdateUserDetails(userAccount.user)\">Save</button><div class=\"pull-right\" ng-if=\"userAccount.isUserDetailsChanging && userAccount.isDetailsEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/account/accountInfo/passwordChange.html","<div class=\"content-main\" ng-init=\"userAccount.fnSetTabHeight();\"><div class=\"col-sm-12 wizard floatingLabelInput\"><wizard on-finish=\"createRole.finishedWizard()\" indicators-position=\"top\"><wz-step wz-title=\"1. Set up new password\"><div class=\"col-sm-6 col-sm-offset-3 p-0 m-t-20\"><div class=\"md-input m-b-20 m-t-20\"><strong class=\"md-input-icon\" ng-click=\"userAccount.hideShowPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"userAccount.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" required=\"\" id=\"newPassword\" type=\"{{userAccount.inputType}}\" ng-model=\"userAccount.newPassword\" placeholder=\"Enter New password*\"> <span class=\"highlight\"></span> <label>New password*</label></div><div class=\"md-input m-b-20\"><strong class=\"md-input-icon\" ng-click=\"userAccount.hideShowPasswordConfirm()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"userAccount.inputTypeConfirm === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" required=\"\" id=\"confirmPassword\" type=\"{{userAccount.inputTypeConfirm}}\" ng-model=\"userAccount.confirmPassword\" placeholder=\"Enter Confirm password*\"> <span class=\"highlight\"></span> <label>Confirm password*</label> <small class=\"helper-text\" ng-if=\"userAccount.newPassword.length && userAccount.confirmPassword.length && userAccount.newPassword !== userAccount.confirmPassword\">Passwords does not match</small></div><button class=\"btn btn-primary pull-right\" ng-disabled=\"!userAccount.newPassword.length || !userAccount.confirmPassword.length || userAccount.newPassword !== userAccount.confirmPassword\" wz-next=\"userAccount.fnGetAuthFields()\">Next</button></div></wz-step><wz-step wz-title=\"2. Change password\"><div class=\"col-sm-6 col-sm-offset-3 p-0 m-t-20\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"userAccount.isAuthFieldsLoading\"></app-spinner><div ng-show=\"!userAccount.isAuthFieldsLoading\"><formly-form model=\"userAccount.oldPassword\" fields=\"userAccount.userFields\"></formly-form><small>Enter old password</small></div><div class=\"pull-right\" ng-show=\"!userAccount.isAuthFieldsLoading\"><button class=\"btn btn-primary\" ng-if=\"!userAccount.isPasswordChanging\" ng-click=\"userAccount.fnChangePassword()\">Change password</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"userAccount.isPasswordChanging\"></app-spinner></div></div></wz-step></wizard></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"></div><div class=\"col-xs-6 content-box-footerItem\"></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/federations.html","<div class=\"content-main\" ng-init=\"userProfile.fnSetTabHeight();\"><div class=\"col-sm-12 m-t-15\"><div class=\"col-sm-1 p-l-0\"><label>Federations:</label></div><div class=\"col-sm-11 p-0 p-t-1\"><form><span class=\"m-r-5\" ng-class=\"userProfile.fedSwitchValue === false ? \'visible\' : \'nonVisible\'\">OFF</span><switch id=\"federationSwitch\" disabled=\"userProfile.isFederationChanging\" ng-model=\"userProfile.fedSwitchValue\" ng-change=\"userProfile.fnFederationSwitchToggle(userProfile.fedSwitchValue)\"></switch><span class=\"m-l-5\" ng-class=\"userProfile.fedSwitchValue === true ? \'visible\' : \'nonVisible\'\">ON</span><div class=\"inline-spinner\" ng-if=\"userProfile.isFederationChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></form></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"></div><div class=\"col-xs-6 content-box-footerItem\"></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/landingUrl.html","<div class=\"content-main\" ng-init=\"userProfile.fnSetTabHeight();\"><div class=\"col-sm-6 floatingLabelInput\"><div class=\"md-input m-b-2 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"landingUrl\" type=\"text\" ng-class=\"userProfile.isLandingUrlChanging ? \'pace\' : \'\'\" ng-model=\"userProfile.landingUrl\" placeholder=\"Enter Landing Url\"> <span class=\"highlight\"></span> <label>Landing Url</label></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"></div><div class=\"col-xs-6\"><button class=\"btn btn-link pull-right p-r-0\" type=\"button\" ng-if=\"!userProfile.isLandingUrlChanging\" ng-click=\"userProfile.fnSaveUserLandingPageSettings(userProfile.landingUrl)\">Save landing url</button><div class=\"m-t-2 pull-right\" ng-if=\"userProfile.isLandingUrlChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/userDataDetails.html","<div class=\"content-main\" ng-init=\"userProfile.fnSetTabHeight();\"><div class=\"col-sm-12\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12\"><ui-codemirror class=\"userDataEditor\" ng-model=\"userProfile.userData\" ui-codemirror-opts=\"userProfile.editorOptions\"></ui-codemirror></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><button class=\"btn btn-link p-0\" ng-if=\"userProfile.isUserDataEditable\" ng-click=\"userProfile.fnToggle()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem\" ng-class=\"userProfile.isUserDataChanging ? \'m-t-0 m-b-0\':\'\'\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!userProfile.isUserDataEditable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"userProfile.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div><button class=\"btn btn-link pull-right p-0\" ng-if=\"!userProfile.isUserDataChanging && userProfile.isUserDataEditable\" ng-click=\"userProfile.fnSaveUserData(userProfile.userData)\">Save</button><div class=\"pull-right\" ng-if=\"userProfile.isUserDataChanging && userProfile.isUserDataEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/support/supportTab/supportTab.html","<div id=\"supportTemplateContent\" class=\"h-100\" ng-controller=\"SupportTabCtrl as supportTab\" ng-init=\"supportTab.fnInitSupportTab();\"><div class=\"content-main\"><div class=\"col-sm-12 h-100 p-t-15\"><div class=\"col-sm-12 p-0 h-100 d-flex justify-content-center align-items-center\" ng-if=\"supportTab.isPlansLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100 d-flex justify-content-center align-items-center\" ng-if=\"!supportTab.isPlansLoading\"><div class=\"d-flex flex-column align-items-center\" ng-if=\"!supportTab.supportSwitchValue\"><span>Our System is built to protect you and your data at all times. That is why even our ECSite support staff cannot access your account or data</span> <span>without your consent. If you need help you can enable the temporary ability for our support staff to be able to access your account here.</span> <span>When you are done you can disable it again.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"!supportTab.isSupportChanging\" ng-click=\"supportTab.fnToggleSupportSwitch(true)\">Enable Support Access</button><app-spinner class=\"m-t-20\" ng-if=\"supportTab.isSupportChanging\" spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"d-flex flex-column align-items-center\" ng-if=\"supportTab.supportSwitchValue\"><span>ECSite support staff currently have access to your account. If you would like to revoke that privilege you can do here.</span> <span>You can re-enable this feature at any time.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"!supportTab.isSupportChanging\" ng-click=\"supportTab.fnToggleSupportSwitch(false)\">Disable Support Access</button><app-spinner class=\"m-t-20\" ng-if=\"supportTab.isSupportChanging\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/store/cart/modal/shippingDetailsModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"shippingDetails.fnInitShippingDetails()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Shipping Details\'\"></h4></div><div class=\"modal-body\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\" ng-if=\"shippingDetails.isShippable\" ng-class=\"shippingDetails.isCartCheckoutProcessing || shippingDetails.isPossibleAddressesLoading ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"companyName\" type=\"text\" name=\"first-name\" ng-model=\"shippingDetails.addressArr.companyName\" placeholder=\"Company Name\"> <span class=\"highlight\"></span> <label>Company Name</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"recipientName\" type=\"text\" name=\"first-name\" ng-model=\"shippingDetails.addressArr.recipientName\" placeholder=\"Recipient Name*\"> <span class=\"highlight\"></span> <label>Recipient Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"deliveryInstructions\" type=\"text\" name=\"first-name\" ng-model=\"shippingDetails.addressArr.deliveryInstructions\" placeholder=\"Delivery Instructions\"> <span class=\"highlight\"></span> <label>Delivery Instructions</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 d-flex align-items-baseline\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" id=\"address\" type=\"text\" name=\"first-name\" ng-change=\"shippingDetails.possibleAddresses = []; shippingDetails.selectedAddress = \'\'; shippingDetails.isAddressSelected = false\" ng-model=\"shippingDetails.addressArr.address\" placeholder=\"Address*\"> <span class=\"highlight\"></span> <label>Address*</label> <small class=\"helper-text\"></small></div><button class=\"btn btn-link m-r-5\" ng-click=\"shippingDetails.fnGetGooglePlusCodes()\">Find Address</button></div></div><div class=\"col-sm-12 p-0 h-100 m-t-10\" ng-if=\"shippingDetails.isPossibleAddressesLoading\"><div class=\"col-sm-12 p-0\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0 h-100 m-t-10\" ng-if=\"!shippingDetails.isPossibleAddressesLoading && shippingDetails.possibleAddresses.length\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 d-flex justify-content-center\"><label>Please select an address from the following options to proceed to checkout.</label></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\" ng-repeat=\"addressObj in shippingDetails.possibleAddresses track by $index\"><label>{{addressObj.formattedAddress}}</label> <input type=\"checkbox\" id=\"checkAddress_{{$index}}\" ng-model=\"addressObj.isChecked\" ng-change=\"shippingDetails.fnSelectAddress($index)\"> <label for=\"checkAddress_{{$index}}\" class=\"check-box\"></label></div></div></div></div><div class=\"col-sm-12 p-0 h-100 m-t-10\" ng-if=\"!shippingDetails.isPossibleAddressesLoading && !shippingDetails.possibleAddresses.length\"><label>No address found. Please try again.</label></div></div><div class=\"col-sm-12 h-100\" ng-if=\"!shippingDetails.isShippable\" ng-class=\"shippingDetails.isCartCheckoutProcessing || shippingDetails.isPossibleAddressesLoading ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center flex-column\"><label class=\"m-b-10\">Completing your checkout.</label> <label class=\"m-0\">Please wait...</label></div></div></div></div><div class=\"modal-footer\"><button ng-if=\"!shippingDetails.isCartCheckoutProcessing\" type=\"button\" class=\"btn btn-primary\" ng-click=\"shippingDetails.fnCancel()\" tabindex=\"12\">Close</button> <button ng-if=\"!shippingDetails.isCartCheckoutProcessing && shippingDetails.isShippable\" ng-disabled=\"!shippingDetails.addressArr.recipientName.length || !shippingDetails.isAddressSelected\" type=\"button\" class=\"btn btn-primary\" ng-click=\"shippingDetails.fnCheckout()\" tabindex=\"12\">Checkout</button><app-spinner ng-if=\"shippingDetails.isCartCheckoutProcessing\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div>");
$templateCache.put("app/node/emailTemplate/emailTemplateInfo/emailTemplateInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Email</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{emailTemplateObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{emailTemplateObj.name}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/authenticator/authenticatorInfo/authenticatorSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isAuthenticatorDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isAuthenticatorDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isAuthenticatorDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_AUTHENTICATOR\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_AUTHENTICATOR\" ng-click=\"fnDeleteAuthenticator(authenticatorObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isAuthenticatorDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"AuthenticatorForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"authenticatorObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"AuthenticatorForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"authenticatorObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"AuthenticatorForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"type\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"type as type.name for type in typesArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeTemplate.html\" typeahead-on-select=\"fnTypeSelected(selectedType)\" ng-model=\"selectedType\" placeholder=\"Select a type*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"AuthenticatorForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Type*</label> <span class=\"typeInfo p-r-30\" ng-if=\"selectedType\"><span>({{selectedType.id}})</span></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"Vault\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"vault as vault.name for vault in vaultsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"VaultTemplate.html\" typeahead-on-select=\"fnVaultSelected(selectedVault)\" ng-model=\"selectedVault\" placeholder=\"Select a Vault*\" name=\"VaultName\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"AuthenticatorForm.VaultName.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Vault*</label> <span class=\"typeInfo p-r-30\" ng-if=\"selectedVault\"><span>({{selectedVault.id}})</span></span></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-disabled=\"!authenticatorObj.name.length\" ng-click=\"fnUpdateAuthenticatorDetails(authenticatorObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{authenticatorObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(authenticatorObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/access/emailTemplate/emailTemplateInfo/emailTemplateSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitEmailTemplate()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isEmailTemplateDataLoading\"></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"!isEmailTemplateDataLoading\"><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput email-template-toolbar\"><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">From*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><input class=\"md-form-control p-t-5 p-b-5 p-l-10 border-0\" id=\"email\" type=\"email\" required=\"\" ng-pattern=\"emailPattern\" name=\"email\" placeholder=\"Email From*\" ng-change=\"fnCheckEmail()\" ng-model=\"templateConfigObj.emailFrom\"> <span class=\"highlight\"></span> <span style=\"position: absolute;top: 6px;right: 10px;\" ng-show=\"!isEmailValid\" uib-tooltip=\"Please enter valid email address.\" tooltip-placement=\"auto\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\"></i></span></div></div></div><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 p-t-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">Subject*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\"><input class=\"md-form-control border-0 p-t-5 p-b-5 p-l-10\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\" id=\"subject\" type=\"text\" required=\"\" name=\"subject\" placeholder=\"Email Subject*\" ng-model=\"templateConfigObj.emailSubject\"> <span class=\"highlight\"></span> <small class=\"helper-text\"></small></div></div></div><div class=\"d-flex w100 justify-content-flex-end p-t-5 p-b-5 p-l-5 email-template-border-bottom\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"bold()\">B</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"italic()\"><i>I</i></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"underline()\"><u>U</u></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"strike()\"><span style=\"text-decoration: line-through;\">S</span></button></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end h-100 align-items-center\"><button class=\"btn btn-link p-0\" ng-click=\"isShowVariables = !isShowVariables\">Variable</button> <button class=\"btn btn-link p-0 m-l-10 m-r-10\" ng-click=\"isShowVariables = false;fnViewRenderedHTML(isShowPrviewRenderedHTML ?false : true)\">{{isShowPrviewRenderedHTML ? \'Code\' : \'Preview\'}}</button></div></div></div></div><div class=\"col-sm-12 p-0 email-body\"><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-if=\"!isShowPrviewRenderedHTML && !isShowVariables\"><ui-codemirror ng-model=\"templateConfigObj.mjmlBody\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-init=\"fnViewRenderedHTML(true)\" ng-if=\"isShowPrviewRenderedHTML && !isShowVariables\"><div class=\"h-100 overflow-auto d-flex justify-content-center align-items-center\" ng-if=\"isTemplateLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"h-100 overflow-auto\" ng-if=\"!isTemplateLoading\"><div class=\"col-sm-12 p-0 h-100\" id=\"htmlParse\"></div></div></div><div class=\"col-sm-12 p-t-10 email-template-min-height\" ng-if=\"isShowVariables\"><label>Available Variables:</label><table border=\"1\" class=\"w100 variables-table\"><thead><tr class=\"variables-header\"><th class=\"p-5\">Name</th><th class=\"p-5\">Description</th></tr></thead><tbody><tr ng-repeat=\"(key,val) in templateConfigObj.emailVariables track by $index\"><td class=\"p-5\"><label>{{key}}</label></td><td class=\"p-5\">{{val}}</td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\" class=\"d-flex justify-content-center align-items-center m-r-10 m-t-3\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\" ng-if=\"!isValidTemplate\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"isValidTemplate\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable && !isValidTemplate\" ng-click=\"fnValidateTemplate()\">Validate Template</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isTemplateEditable && !isEmailTemplateDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_EMAIL_TEMPLATE\" ng-click=\"fnChangeToEditable(true)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_EMAIL_TEMPLATE\" ng-click=\"fnResetEmailTemplate(true)\"><a class=\"btn btn-link\">Reset Email</a></li></ul></div><button class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-if=\"isTemplateEditable && !isValidatingTemplate && !isSaveChanges\" ng-click=\"fnChangeToEditable()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid\" ng-click=\"fnSaveEmailTemplate()\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isValidatingTemplate || isSaveChanges && isTemplateEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isFederationDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isFederationDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isFederationDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_FEDERATION\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_FEDERATION\" ng-click=\"fnDeleteFederation(federationObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isFederationDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"FederationForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"alias\" type=\"text\" ng-model=\"federationObj.alias\" placeholder=\"Alias*\" ng-form=\"alias\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"FederationForm.alias.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Alias*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"type\" type=\"text\" ng-model=\"federationObj.type\" name=\"type\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"FederationForm.type.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Type*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"federationObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"FederationForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-disabled=\"!federationObj.alias.length\" ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateFederationDetails(federationObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{federationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/access/script/scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-click=\"fnSaveScript()\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/access/team/teamInfo/teamSteps/details.html","<div id=\"teamsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isTeamDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isTeamDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isTeamDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionObj.UPDATE_TEAM\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionObj.DELETE_TEAM\" ng-click=\"fnDeleteGroup(teamObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isTeamDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"teamForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"teamObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"teamForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"teamObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"teamForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0 p-t-20\" id=\"functionModal\" ng-if=\"!isDetailsEditable && isUpdateCompleted\"><div class=\"col-sm-12 p-0\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><label class=\"m-t-6\">Selected Resources</label></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><div class=\"col-sm-12 p-0 d-flex justify-content-start align-items-center\"></div><div class=\"col-sm-12 p-0 m-t-10 d-flex\" style=\"min-height: 100px;border: 2px dashed;\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-8 p-0 d-flex justify-content-center p-t-30 p-b-30 flex-column\"><label class=\"p-l-30\" ng-if=\"!resourceArr.length\">No Resources</label><div class=\"col-sm-12 p-0 d-flex align-items-center p-l-30 justify-content-start\" ng-class=\"!$last ?\'p-b-10\' :\'\'\" ng-repeat=\"resource in resourceArr\"><div class=\"m-r-10\"><svg viewbox=\"0 0 512.001 512.001\" width=\"20px\" class=\"d-flex justify-content-center custom-wizard-svg-icon svgIconFillTextSecondaryColor\"><path d=\"m361.480469 309.242188-17.652344 9.777343c-3.625 2.011719-4.933594 6.574219-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226562 0 2.476562-.300781 3.628906-.9375l17.652344-9.78125c3.621094-2.007812 4.933594-6.574219 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m361.480469 287.960938-17.652344 9.777343c-3.625 2.007813-4.9375 6.574219-2.925781 10.199219 1.367187 2.46875 3.925781 3.863281 6.566406 3.863281 1.226562 0 2.476562-.300781 3.625-.9375l17.65625-9.78125c3.621094-2.007812 4.933594-6.570312 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m485.9375 377.816406c.71875-1.171875 1.121094-2.550781 1.121094-3.929687v-65.980469c0-4.144531-3.359375-7.5-7.503906-7.5-4.140626 0-7.5 3.355469-7.5 7.5v54.425781l-72.121094-32.167969v-139.367187l72.121094-39.957031v124.40625c0 4.144531 3.359374 7.5 7.5 7.5 4.144531 0 7.503906-3.355469 7.503906-7.5v-137.136719c0-2.675781-1.523438-5.261719-3.867188-6.558594l-235.777344-130.625c-2.238281-1.234375-5.03125-1.234375-7.269531 0l-235.777343 130.625c-2.382813 1.316407-3.898438 3.929688-3.867188 6.648438v235.6875c0 2.679687 1.519531 5.261719 3.867188 6.5625l103.882812 57.554687c3.625 2.003906 8.1875.695313 10.195312-2.925781 2.007813-3.625.695313-8.191406-2.925781-10.195313l-90.734375-50.269531 69.972656-31.207031 141.519532 78.402344v69.972656l-91.011719-50.417969c-3.621094-2.007812-8.1875-.699219-10.195313 2.925781-2.007812 3.621094-.695312 8.1875 2.925782 10.195313l102.148437 56.589844c2.226563 1.234375 5.042969 1.234375 7.269531 0l107.128907-59.355469c3.625-2.007812 4.933593-6.570312 2.925781-10.195312-2.003906-3.621094-6.570312-4.933594-10.195312-2.925782l-95.996094 53.183594v-69.972656l141.519531-78.402344 69.972656 31.207031-85.769531 47.519531c-3.625 2.007813-4.933594 6.570313-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226563 0 2.476563-.304687 3.628906-.941406l98.921875-54.804687c1.109375-.613281 2.082032-1.554688 2.746094-2.632813zm-242.160156-265.222656 133.179687 73.785156-133.179687 73.78125-133.175782-73.78125zm148.65625 65.210938-141.15625-78.203126v-79.386718l212.800781 117.894531zm-156.15625-78.203126-141.152344 78.203126-71.648438-39.695313 212.800782-117.894531zm-220.777344 51.238282 72.121094 39.957031v139.367187l-72.121094 32.167969zm87.125 48.269531 54.441406 30.160156 79.210938 43.886719v131.503906l-133.652344-74.046875zm148.652344 74.046875 133.65625-74.046875v131.503906l-133.65625 74.046875zm0 0\"></path></svg></div><div><label class=\"m-0\">{{resource.displayName}} - {{resource.resourceName}} ({{resource.id}})</label></div></div></div></div></div></div></div></div></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!teamObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateGroupDetails(teamObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{teamObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(teamObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>User</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{userObj.firstName + \' \' + userObj.lastName}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{userObj.firstName + \' \' + userObj.lastName}}</h3></div><div class=\"col-sm-6 d-flex p-0 align-items-center justify-content-flex-end\"><div class=\"smallStateIcon text-center\" ng-class=\"userObj.administrator ? \'m-r-7\' : \'\'\"><span class=\"stateIconBorder\" ng-class=\"!isFullWidthDevice ? \'font-12px\':\'\'\" style=\"top: 0;\" ng-style=\"getUserStateColor(userObj.state)\"><span class=\"fa stateIcon\" ng-class=\"fnGetUserStateIcon(userObj.state)\"></span></span></div><div class=\"m-l-1 m-r-1 d-flex\" ng-if=\"userObj.administrator\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg viewbox=\"0 0 511.999 511.999\" class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div><div ng-if=\"userObj.accountOwner\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Account Owner\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/account_owner.svg#acc_owner\"></use></svg></div><div ng-if=\"userObj.billingManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Billing Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" viewbox=\"0 0 487.565 487.565\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><g><g><path d=\"M115.171,183.665c4,25.7,23.7,58.3,56.2,69.7c13.3,4.7,28,4.7,41.3-0.1c32-11.5,52.4-44,56.4-69.6c4.3-0.3,10-6.4,16.1-28 c8.3-29.5-0.5-33.9-8-33.2c1.4-4.1,2.5-8.1,3.2-12.1c12.7-76.4-24.9-79.1-24.9-79.1s-6.2-12-22.7-21.1c-11-6.5-26.3-11.6-46.5-9.8 c-6.5,0.3-12.7,1.6-18.5,3.5l0,0c-7.4,2.5-14.2,6.2-20.4,10.4c-7.6,4.8-14.7,10.6-21,17.3c-10,10.2-18.8,23.3-22.7,39.8 c-3.2,12.3-2.5,25.1,0.2,38.8l0,0c0.7,4,1.8,8.1,3.2,12.1c-7.5-0.7-16.4,3.6-8,33.2 C105.171,177.265,110.871,183.365,115.171,183.665z\"></path><path d=\"M192.971,281.065L192.971,281.065h-0.1h-0.1h-0.1h-0.1l0,0c-6.6,0-44.8,2.4-9.3,52l-1.5,4.3c3.4-0.9,6.9-1.4,10.5-1.4 c4,0,8,0.6,11.7,1.7l-1.6-4.7C237.771,283.565,199.571,281.165,192.971,281.065z\"></path><path d=\"M225.471,352.665l11.5,11.5l45.6,45.6l32.6-32.6l13-13l5.3-5.3l34.4-34.4c-6.3-17.2-17.8-29.2-39.2-37 c-44.8-17.1-71.6-34.6-71.6-34.6L225.471,352.665z\"></path><path d=\"M128.571,252.965c0,0-26.8,17.5-71.6,34.6c-49.3,17.9-46.3,58.5-47.3,134.6h79.8l70.4-70.4L128.571,252.965z\"></path><path d=\"M341.171,228.965c6.9,3.3,14.3,5.1,21.8,6.3c5.9,0.9,6.1,1.2,6.2,7.3c0,2.8,0,5.6,0.1,8.3c0,3.5,1.7,5.5,5.3,5.6 c4.1,0.1,8.2,0.1,12.3,0c3.3-0.1,5.1-1.9,5.1-5.3c0-3.8,0.2-7.6,0-11.4c-0.2-3.9,1.5-5.8,5.2-6.8c8.5-2.3,15.8-6.9,21.5-13.8 c15.5-18.9,9.6-46.6-12.5-58.8c-6.9-3.8-14.3-6.7-21.6-9.8c-4.2-1.7-8.3-3.8-11.8-6.6c-7-5.6-5.7-14.7,2.6-18.3 c2.3-1,4.8-1.3,7.3-1.5c9.5-0.5,18.6,1.2,27.2,5.4c4.3,2.1,5.7,1.4,7.2-3c1.5-4.7,2.8-9.5,4.2-14.3c0.9-3.2-0.2-5.3-3.3-6.7 c-5.5-2.4-11.2-4.2-17.2-5.1c-7.8-1.2-7.8-1.3-7.8-9.1c0-11.1,0-11.1-11.1-11c-1.6,0-3.2,0-4.8,0c-5.2,0.2-6.1,1-6.2,6.3 c-0.1,2.3,0,4.7,0,7c0,6.9-0.1,6.8-6.7,9.2c-16,5.8-25.9,16.7-27,34.2c-0.9,15.5,7.1,25.9,19.8,33.5c7.8,4.7,16.5,7.5,24.8,11.1 c3.2,1.4,6.3,3.1,9,5.3c8,6.6,6.5,17.6-3,21.7c-5.1,2.2-10.4,2.8-15.9,2.1c-8.5-1.1-16.6-3.3-24.2-7.3c-4.5-2.3-5.8-1.7-7.3,3.1 c-1.3,4.2-2.5,8.4-3.6,12.6C335.171,224.965,335.671,226.265,341.171,228.965z\"></path><path d=\"M469.371,275.265c-0.3,0-0.6,0-1,0c-21.4,1-42.8,2-64.1,3c-3.3,0.2-6.6,0.3-8.4,4.3s0.3,6.2,2.5,8.5 c6.6,6.6,13,13.2,19.7,19.7l-7.3,7.3l-59.2,59.2l-5.3,5.3l-13,13l-50.9,50.9l-3-3l-60.9-60.9l-13-13l-3.5-3.5 c-2.8-2.8-6.4-4.1-10-4.1s-7.2,1.4-10,4.1l-3.5,3.5l-73.9,73.9c-5.5,5.5-5.5,14.4,0,20l3.5,3.5c2.8,2.8,6.4,4.1,10,4.1 s7.2-1.4,10-4.1l63.9-63.9l3,3l60.9,60.9l13,13l3.5,3.5c2.8,2.8,6.4,4.1,10,4.1s7.2-1.4,10-4.1l3.5-3.5l60.9-60.9l13-13l5.3-5.3 l59.2-59.2l7.2-7.2l19.3,19.2c1.8,1.8,3.6,3.7,6.1,3.7c0.9,0,2-0.3,3.2-0.9c3.9-2.1,4.7-5.5,4.9-9.3c0.9-20.9,1.9-41.7,2.9-62.6 C478.171,278.065,475.571,275.265,469.371,275.265z\"></path></g></g></svg></div><div ng-if=\"userObj.trackerManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Tracker Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/managerType/tracker_manager.svg#tracker\"></use></svg></div><div ng-if=\"userObj.nodeManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Node Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/managerType/node_manager.svg#node\"></use></svg></div><div ng-if=\"userObj.pipelineManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Pipeline Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/managerType/pipeline_manager.svg#pipeline\"></use></svg></div><div ng-if=\"userObj.storageManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"Storage Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/managerType/storage_manager.svg#storage\"></use></svg></div><div ng-if=\"userObj.aiManager\" class=\"d-flex m-r-1 m-l-7\" uib-tooltip=\"AI Manager\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"isFullWidthDevice ? \'svgIcon-20px\':\'svgIcon-15px\'\"><use xlink:href=\"assets/images/svg/managerType/ai_manager.svg#ai\"></use></svg></div></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{userObj.bio ? userObj.bio : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{userObj.bio ? userObj.bio : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0\"><div class=\"text-right\"><span ng-class=\"!isFullWidthDevice ? \'font-12px\' :\'\'\">{{\'@\'+userObj.username}}</span></div><div class=\"text-right\"><span ng-class=\"!isFullWidthDevice ? \'font-12px\' :\'\'\">{{userObj.email}}</span></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/access/vault/createVault/createVaultFromAuthenticator/auth.html","<div class=\"col-sm-12 p-0 d-flex\"><div class=\"w100\"><div class=\"md-input m-b-20\"><strong class=\"md-input-icon\" ng-click=\"form.isHide = !form.isHide\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"form.isHide ? \'fa-eye-slash\' : \'fa-eye\'\"></i></strong> <input class=\"md-form-control\" type=\"{{form.isHide ? \'password\' : \'text\' }}\" ng-required=\"form.required\" schema-validate=\"form\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" ng-model=\"$$value$$\"> <label>{{form.title}}{{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div></div><div class=\"\"><a href=\"javascript:void(0);\" class=\"btn btn-link m-t-5\" ng-click=\"form.inputAction.fnInjectFunction(form.key)\"><span><em>f<small>(x)</small></em></span></a></div></div>");
$templateCache.put("app/access/vault/createVault/createVaultFromAuthenticator/createVaultFromAuthenticator.html","<div class=\"container-with-out-footer\" ng-if=\"vaults.isCreateFromAuthenticator\" ng-controller=\"createVaultFromAuthenticatorCtrl as createVaultFromAuthenticator\" ng-init=\"createVaultFromAuthenticator.fnInitCreateVaultFromAuthenticator()\"><div class=\"content-body modal-body floatingLabelInput\" id=\"modal-body\" style=\"height: 100%\"><div class=\"row p-t-20\"><div class=\"col-sm-12\" ng-if=\"createVaultFromAuthenticator.isTypesLoading\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-if=\"!createVaultFromAuthenticator.isTypesLoading\"><div class=\"m-t-10 m-b-5\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"type\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"type as type.name for type in createVaultFromAuthenticator.typesArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeTemplate.html\" typeahead-on-select=\"createVaultFromAuthenticator.fnTypeSelected(createVaultFromAuthenticator.selectedType)\" ng-model=\"createVaultFromAuthenticator.selectedType\" placeholder=\"Select a Type*\"> <span class=\"highlight\"></span> <label>Type*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createVaultFromAuthenticator.selectedType\"><span>({{createVaultFromAuthenticator.selectedType.id}})</span></span></div></div></div><div class=\"col-sm-12\" ng-if=\"!createVaultFromAuthenticator.isTypesLoading && createVaultFromAuthenticator.isTypeSelected\"><form id=\"createNewVaultForm\" role=\"form\" name=\"createNewVaultForm\" novalidate=\"\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createVaultFromAuthenticator.newVaultObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" autocomplete=\"off\" ng-model=\"createVaultFromAuthenticator.newVaultObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></form><form id=\"authForm\" role=\"form\" name=\"authForm\" novalidate=\"\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\" ng-if=\"createVaultFromAuthenticator.isTypeSelected\" sf-schema=\"createVaultFromAuthenticator.schema\" sf-form=\"createVaultFromAuthenticator.form\" sf-model=\"createVaultFromAuthenticator.model\"></div></form><div ng-if=\"!createVaultFromAuthenticator.isVaultCreating\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createVaultFromAuthenticator.newVaultObj.name.length || !authForm.$valid\" ng-click=\"createVaultFromAuthenticator.fnCreateNewVault(createVaultFromAuthenticator.newVaultObj, createVaultFromAuthenticator.vaultKVPArr)\">Create Vault</button></div><div ng-if=\"createVaultFromAuthenticator.isVaultCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <span ng-bind-html=\"match.model.name\"></span><br> <span class=\"font-italic\">({{match.model.id}})</span> </a></script></div>");
$templateCache.put("app/access/vault/createVault/createVaultFromAuthenticator/xmlAuthInput.html","<div class=\"col-sm-12 p-0 d-flex xmlAuthInput\"><div class=\"w100\"><div class=\"md-input m-b-20\"><textarea class=\"md-form-control\" type=\"{{form.isHide ? \'password\' : \'text\' }}\" ng-required=\"{{form.required}}\" schema-validate=\"form\" name=\"{{form.key.toString()}}\" placeholder=\"{{form.placeholder ? form.placeholder : form.title}}{{form.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\" ui-codemirror=\"\" ui-codemirror-opts=\"form.editorOpt\" ng-model=\"$$value$$\">\n            </textarea> <label>{{form.title}}{{form.required ? \'*\': \'\'}}</label><div sf-message=\"\"></div></div></div><div class=\"\"><a href=\"javascript:void(0);\" class=\"btn btn-link m-t-5\" ng-click=\"form.inputAction.fnInjectFunction(form.key)\"><span><em>f<small>(x)</small></em></span></a></div></div>");
$templateCache.put("app/access/vault/createVault/createVaultFromNode/createVaultFromNode.html","<div class=\"container-with-out-footer\" ng-if=\"vaults.isCreateFromNode\" ng-controller=\"createVaultFromNodeCtrl as createVaultFromNode\" ng-init=\"createVaultFromNode.fnInitCreateVaultFromNode()\"><div class=\"content-body modal-body floatingLabelInput\" id=\"modal-body\" style=\"height: 100%\"><div class=\"row p-t-20\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\" ng-class=\"createVaultFromNode.isIot3FileSelected ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-6 p-l-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Search and Import an IoT3 blueprint file.</label><div class=\"col-sm-12 p-0 p-t-20\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"createVaultFromNode.fnOpenIot3BlueprintsModal()\">Search</button></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Import your own existing IoT3 file.</label><div class=\"col-sm-12 p-0 p-t-20\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"createVaultFromNode.uploadFiles()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import</a></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15 d-flex align-items-center justify-content-flex-end\" ng-if=\"createVaultFromNode.isIot3FileSelected\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"createVaultFromNode.fnResetIot3File()\">Change IoT3 File</button></div></div><div class=\"col-sm-12 m-t-15\"><form id=\"createNewVaultForm\" role=\"form\" name=\"createNewVaultForm\" novalidate=\"\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createVaultFromNode.newVaultObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.name.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" autocomplete=\"off\" ng-model=\"createVaultFromNode.newVaultObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"createNewVaultForm.description.$valid\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></form><form id=\"authForm\" role=\"form\" name=\"authForm\" novalidate=\"\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\" ng-if=\"createVaultFromNode.isIot3FileSelected\" sf-schema=\"createVaultFromNode.schema\" sf-form=\"createVaultFromNode.form\" sf-model=\"createVaultFromNode.model\"></div></form><div ng-if=\"!createVaultFromNode.isVaultCreating\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createVaultFromNode.newVaultObj.name.length || !authForm.$valid\" ng-click=\"createVaultFromNode.fnCreateNewVault(createVaultFromNode.newVaultObj, createVaultFromNode.vaultKVPArr)\">Create Vault</button></div><div ng-if=\"createVaultFromNode.isVaultCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <span ng-bind-html=\"match.model.name\"></span><br> <span class=\"font-italic\">({{match.model.id}})</span> </a></script></div>");
$templateCache.put("app/access/vault/createVault/createVaultFromType/createVaultFromType.html","<div class=\"container-with-out-footer\" ng-if=\"vaults.isCreateFromType\" ng-controller=\"createVaultFromTypeCtrl as createVaultFromType\" ng-init=\"createVaultFromType.fnInitCreateVaultFromType()\"><div class=\"content-body modal-body floatingLabelInput\" id=\"modal-body\"><div class=\"row p-t-20\"><div class=\"col-sm-12\" ng-if=\"createVaultFromType.isTypesLoading\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-if=\"!createVaultFromType.isTypesLoading\"><div class=\"m-t-10 m-b-20\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"type\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"type as type.name for type in createVaultFromType.typesArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeTemplate.html\" typeahead-on-select=\"createVaultFromType.fnTypeSelected(createVaultFromType.selectedType)\" ng-model=\"createVaultFromType.selectedType\" placeholder=\"Select a Type*\"> <span class=\"highlight\"></span> <label>Type*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12\" ng-if=\"!createVaultFromType.isTypesLoading && createVaultFromType.isTypeSelected\"><form id=\"createNewVaultForm\" role=\"form\" name=\"createNewVaultForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createVaultFromType.newVaultObj.name\" placeholder=\"Name*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createVaultFromType.newVaultObj.description\" placeholder=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 m-t-10 p-0\" ng-repeat=\"kvpPair in createVaultFromType.vaultKVPArr track by $index\"><div class=\"md-input p-0 col-sm-12\" ng-if=\"kvpPair.type !==\'Array\'\" ng-class=\"kvpPair.isValueNotNumber || kvpPair.isPatternMismatch || kvpPair.isMinError || kvpPair.isMaxError ?\'m-b-40\':\'m-b-20\'\"><strong class=\"md-input-icon\" ng-click=\"createVaultFromType.hideShowPassword(kvpPair)\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"kvpPair.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control p-r-30\" ng-attr-id=\"{{\'value\' + $index}}\" type=\"{{kvpPair.inputType}}\" required=\"\" ng-model=\"kvpPair.value\" ng-change=\"createVaultFromType.fnKvpPairChange(kvpPair)\" placeholder=\"{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}} associated with Node{{kvpPair.required === \'true\'? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}}{{kvpPair.required === \'true\'? \'*\' : \'\'}}</label> <small class=\"helper-text\" ng-if=\"!kvpPair.isValueMissing && !kvpPair.isMinError && !kvpPair.isMinError && !kvpPair.isPatternMismatch && !kvpPair.isValueNotNumber\"></small> <small class=\"helper-text-error\" ng-show=\"kvpPair.isValueNotNumber\"><span class=\"errorText\">The value should be a number</span></small> <small class=\"helper-text-error\" ng-show=\"kvpPair.isPatternMismatch\"><span class=\"errorText\">The value does not satisfy the required pattern {{kvpPair.regex}}.</span></small> <small class=\"helper-text-error\" ng-show=\"kvpPair.isMinError\"><span class=\"errorText\">The value should be greater than {{kvpPair.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"kvpPair.isMaxError\"><span class=\"errorText\">The value should be less than {{kvpPair.max}}.</span></small></div><div class=\"col-sm-12 p-0\" ng-if=\"kvpPair.type ===\'Array\'\" ng-class=\"kvpPair.arrValue || kvpPair.isValueMissing || kvpPair.isMaxError || kvpPair.isPatternMismatch || kvpPair.isMinError ?\'m-b-40\':\'m-b-20\'\"><div class=\"md-input m-b-10\" ng-if=\"kvpPair.item === \'Number\'\"><input class=\"md-form-control p-r-30\" ng-attr-id=\"{{kvpPair.name+$index}}\" required=\"\" type=\"number\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && createVaultFromType.fnCreateArrayTag(kvpPair.arrValue,kvpPair.name+$index,kvpPair)\" ng-model=\"kvpPair.arrValue\" ng-change=\"createVaultFromType.fnArrayValidation(kvpPair,kvpPair.arrValue)\" placeholder=\"{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}} associated with Node{{kvpPair.required === \'true\'? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}}{{kvpPair.required === \'true\'? \'*\' : \'\'}}</label> <small class=\"helper-text\" ng-if=\"kvpPair.arrValue && !kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span>Press enter to add your {{kvpPair.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && kvpPair.isMinError\"><span class=\"errorText\">The value should be greater than {{kvpPair.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value should be less than {{kvpPair.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{kvpPair.regex}}.</span></small></div><div class=\"md-input\" ng-if=\"kvpPair.item === \'String\' || kvpPair.item === \'\'\" ng-class=\"kvpPair.arrValue || kvpPair.isValueMissing || kvpPair.isMaxError || kvpPair.isPatternMismatch || kvpPair.isMinError ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control p-r-30\" ng-attr-id=\"{{kvpPair.name+$index}}\" required=\"\" type=\"text\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && createVaultFromType.fnCreateArrayTag(kvpPair.arrValue,kvpPair.name+$index,kvpPair)\" ng-model=\"kvpPair.arrValue\" ng-change=\"createVaultFromType.fnArrayValidation(kvpPair,kvpPair.arrValue)\" placeholder=\"{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}} associated with Node{{kvpPair.required === \'true\'? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}}{{kvpPair.required === \'true\'? \'*\' : \'\'}}</label> <small class=\"helper-text\" ng-if=\"kvpPair.arrValue.length && !kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span>Press enter to add your {{kvpPair.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && kvpPair.isMinError\"><span class=\"errorText\">The value should be greater than {{kvpPair.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value should be less than {{kvpPair.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{kvpPair.regex}}.</span></small></div><div ng-if=\"kvpPair.item === \'Boolean\'\"><div class=\"md-input\" ng-if=\"kvpPair.arrValue || kvpPair.isValueMissing || kvpPair.isMaxError || kvpPair.isPatternMismatch || kvpPair.isMinError?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control p-r-30\" required=\"\" ng-attr-id=\"{{kvpPair.name+$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"value for value in createVaultFromType.booleanOptionArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"kvpPair.arrValue\" ng-change=\"createVaultFromType.fnArrayValidation(kvpPair,kvpPair.arrValue)\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && createVaultFromType.fnCreateArrayTag(kvpPair.arrValue,kvpPair.name+$index,kvpPair)\" placeholder=\"{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}} associated with Node{{kvpPair.required === \'true\'? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{createVaultFromType.fnSetFiledLabel(kvpPair.key)}}{{kvpPair.required === \'true\'? \'*\' : \'\'}}</label> <small class=\"helper-text\" ng-if=\"kvpPair.arrValue.length && !kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span>Press enter to add your {{kvpPair.name}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && !kvpPair.isPatternMismatch && kvpPair.isMinError\"><span class=\"errorText\">The value should be greater than {{kvpPair.min}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && kvpPair.isMaxError && !kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value should be less than {{kvpPair.max}}.</span></small> <small class=\"helper-text-error\" ng-show=\"!kvpPair.isValueMissing && !kvpPair.isMaxError && kvpPair.isPatternMismatch && !kvpPair.isMinError\"><span class=\"errorText\">The value does not satisfy the required pattern {{kvpPair.regex}}.</span></small></div></div><div class=\"m-t-25\"><button class=\"btn btn-sm btn-default m-t-10 m-r-5\" ng-repeat=\"selectedArr in kvpPair.value track by $index\"><span>{{selectedArr}}<i class=\"fa fa-times m-l-5\" ng-click=\"createVaultFromType.fnRemoveSelectedArrayTag(kvpPair,$index)\"></i></span></button></div></div></div><div class=\"col-sm-12 m-t-5 m-b-10 p-0\" ng-if=\"!createVaultFromType.isAdvancedVisible\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"createVaultFromType.isAdvancedVisible = true;\">Add new key</button></div><div class=\"col-sm-12 p-0\" ng-show=\"createVaultFromType.isAdvancedVisible\"><div class=\"col-sm-12 m-t-0 p-0\" ng-repeat=\"kvpPair in createVaultFromType.advancedVaultKVPArr track by $index\"><div class=\"md-input m-b-20 p-0 p-r-10 col-sm-5\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"text\" ng-model=\"kvpPair.key\" placeholder=\"Key\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text\"></small></div><div class=\"md-input p-0 col-sm-6\" ng-class=\"$last ?\'m-b-40\':\'m-b-20\'\"><strong class=\"md-input-icon\" ng-click=\"createVaultFromType.hideShowPassword(kvpPair)\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"kvpPair.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control p-r-30\" id=\"value\" type=\"{{kvpPair.inputType}}\" required=\"\" ng-model=\"kvpPair.value\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small> <small class=\"helper-text kvpAddText\" ng-if=\"$last\"><a class=\"btn btn-link p-0\" ng-click=\"createVaultFromType.fnAddNewKvp()\">Add new key</a></small></div><div class=\"col-sm-1\"><button class=\"btn btn-link m-t-5\"><i class=\"fa fa-trash-o fa-lg\" ng-click=\"createVaultFromType.fnRemoveAdvancedKvpPair($index)\"></i></button></div></div></div></form><div ng-if=\"!createVaultFromType.isVaultCreating\"><button class=\"btn btn-primary pull-right\" ng-disabled=\"!createVaultFromType.newVaultObj.name.length || !createVaultFromType.isFormValidated\" ng-click=\"createVaultFromType.fnCreateNewVault(createVaultFromType.newVaultObj, createVaultFromType.vaultKVPArr)\">Create Vault</button></div><div ng-if=\"createVaultFromType.isVaultCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.oem\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script></div>");
$templateCache.put("app/access/vault/vaultInfo/vaultSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailsTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isVaultDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isVaultDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isVaultDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_VAULT\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_VAULT\" ng-click=\"fnDeleteVault(vaultObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isVaultDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"vaultFrorm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"vaultObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"vaultFrorm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"vaultObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"vaultFrorm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!vaultObj.name.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateVaultDetails(vaultObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{vaultObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(vaultObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/ai/deployment/deploymentInfo/deploymentTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDeployment()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isDeploymentDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isDeploymentDetailsLoaded\"><div class=\"m-t-10\"><div class=\"pull-right\"><div class=\"col-sm-12 p-0 text-center\"><span class=\"deploymentInfoIcon deploymentIconBorder\" uib-tooltip=\"{{deploymentObj.status}}\" tooltip-placement=\"auto\" ng-style=\"fnGetDeploymentStatusIconColor(deploymentObj.status)\"><span class=\"deploymentIcon fa\" ng-class=\"fnGetDeploymentStatusIcon(deploymentObj.status)\"></span></span></div></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isDeploymentDetailsLoaded\" ng-class=\"!deploymentPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"deploymentObj.name\" placeholder=\"Name for the Deployment*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"deploymentObj.description\" placeholder=\"Description regarding Deployment\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\" ng-if=\"distributionPermissionObj.List\"><input class=\"md-form-control\" required=\"\" id=\"distribution\" type=\"text\" ng-model=\"distributionObj.name\"> <span class=\"highlight\"></span> <label>Distribution*</label> <span class=\"typeInfo\" ng-if=\"distributionObj.id\"><span>({{distributionObj.id}})</span></span></div><div class=\"md-input m-b-20 pace\" ng-if=\"!distributionPermissionObj.List\"><input class=\"md-form-control\" required=\"\" id=\"distributionId\" type=\"text\" ng-model=\"deploymentObj.distributionId\"> <span class=\"highlight\"></span> <label>Distribution ID</label></div><div class=\"col-sm-12 m-t-10 p-l-0 p-r-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!deploymentObj.name.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateDeploymentDetails(deploymentObj)\">Save</button></div><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deploymentObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deploymentObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(deploymentPermissionsObj.Modify || deploymentPermissionsObj.Delete) && isDeploymentDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"deploymentPermissionsObj.Modify && !isDetailsEditable\"><a class=\"btn btn-link\" ng-click=\"fnChangeFieldsToEditable()\">Edit</a></li><li ng-if=\"deploymentPermissionsObj.Delete\"><a class=\"btn btn-link\" ng-click=\"fnDeleteDeployment(deploymentObj)\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/ai/distribution/distributionInfo/distributionTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDistribution()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isDistributionDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isDistributionDetailsLoaded\" ng-class=\"!distributionPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-40\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"distributionObj.name\" placeholder=\"Name for the Distribution*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"distributionObj.description\" placeholder=\"Description regarding Distribution\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-l-0\"><h3>Divergences</h3></div><div class=\"col-sm-12 pace\"><div ng-repeat=\"divergencesObj in distributionObj.divergences track by $index\"><div class=\"m-l-20 m-b-10\"><label>{{$index+1 + \'. \' + divergencesObj.name.charAt(0).toUpperCase() + divergencesObj.name.substr(1);}}</label></div><div class=\"m-l-35\"><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" ng-model=\"divergencesObj.name\" placeholder=\"Name for the Divergence*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" ng-model=\"divergencesObj.description\" placeholder=\"Description regarding Divergence\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" ng-value=\"fnGetModelName(divergencesObj.modelId)\"> <span class=\"highlight\"></span> <label>Model*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"isShowModelIdInfo\"><span>({{divergencesObj.modelId}})</span></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" ng-value=\"fnGetVmName(divergencesObj.virtualMachineId)\"> <span class=\"highlight\"></span> <label>Virtual Machine*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\"><span>({{divergencesObj.virtualMachineId}})</span></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" type=\"text\" ng-model=\"divergencesObj.virtualMachineCount\"> <span class=\"highlight\"></span> <label>Virtual Machine Quantity*</label> <small class=\"helper-text\"></small></div></div></div></div><div class=\"col-sm-12 m-t-10 p-l-0 p-r-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!distributionObj.name.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateDistributionDetails(distributionObj)\">Save</button></div><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{distributionObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(distributionObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(distributionPermissionsObj.Modify || distributionPermissionsObj.Delete) && isDistributionDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"distributionPermissionsObj.Modify && !isDetailsEditable\"><a class=\"btn btn-link\" ng-click=\"fnChangeFieldsToEditable()\">Edit</a></li><li ng-if=\"distributionPermissionsObj.Delete\"><a class=\"btn btn-link\" ng-click=\"fnDeleteDistribution(distributionObj)\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/ai/model/modelInfo/modelTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitModel()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isModelDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isModelDetailsLoaded\" ng-class=\"!modelPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-40\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"modelObj.name\" placeholder=\"Name for the Model*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"modelObj.description\" placeholder=\"Description regarding Model\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"algorithmId\" type=\"text\" ng-model=\"selectedAlgorithm.name\" placeholder=\"Algorithm for the Model*\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <span class=\"typeInfo\"><span>({{selectedAlgorithm.id}})</span></span></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"artifactPath\" type=\"text\" ng-model=\"modelObj.artifactPath\"> <span class=\"highlight\"></span> <label>Artifact Path*</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 m-t-10 p-l-0 p-r-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!modelObj.name.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateModelDetails(modelObj)\">Save</button></div><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{modelObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(modelObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 p-t-3\" ng-if=\"isModelProcessOnGoing\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-xs-6 content-box-footerItem\" ng-if=\"!isModelProcessOnGoing && isModelDetailsLoaded\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"modelPermissionsObj.Modify || modelPermissionsObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"modelPermissionsObj.Modify && !isDetailsEditable\"><a class=\"btn btn-link\" ng-click=\"fnChangeFieldsToEditable()\">Edit</a></li><li ng-if=\"modelPermissionsObj.Delete\"><a class=\"btn btn-link\" ng-click=\"fnDeleteModel(modelObj)\">Delete</a></li></ul></div></div></div></div><script type=\"text/ng-template\" id=\"AlgorithmTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script>");
$templateCache.put("app/ai/trainer/createTrainer/steps/algorithm.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewTrainerForm\" role=\"form\" name=\"createNewTrainerForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTrainer.newTrainerObj.name\" placeholder=\"Name for the new Trainer*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-40 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"algorithmObj as algorithmObj.name for algorithmObj in createTrainer.algorithmsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"algorithmTemplate.html\" ng-change=\"!createTrainer.selectedAlgorithm ? createTrainer.fnResetVm(\'algo\') : \'\'\" typeahead-on-select=\"createTrainer.fnSelectAlgorithm(createTrainer.selectedAlgorithm)\" ng-model=\"createTrainer.selectedAlgorithm\" placeholder=\"Algorithm for the new Trainer*\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <span class=\"typeInfo\" ng-if=\"createTrainer.selectedAlgorithm\"><span>({{createTrainer.selectedAlgorithm.id}})</span></span></div></form></div></div><div class=\"col-sm-12 p-r-0\"><input type=\"button\" class=\"btn btn-primary pull-right\" wz-next=\"\" value=\"Next\" ng-disabled=\"!createTrainer.newTrainerObj.name || !createTrainer.newTrainerObj.algorithmId\"></div>");
$templateCache.put("app/ai/trainer/createTrainer/steps/branches.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 AiBranchInput\"><uib-tabset type=\"pills\"><uib-tab index=\"0\" heading=\"Required\"><uib-accordion ng-if=\"createTrainer.newTrainerObj.algorithmId.length\" close-others=\"false\"><uib-accordion-group class=\"m-t-20\" ng-repeat=\"branchesObj in createTrainer.algorithmRequiredBranches track by $index\" is-open=\"branchesObj.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2\">{{branchesObj.name}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !branchesObj.open, \'fa-angle-up\': branchesObj.open}\"></i><div class=\"col-sm-1 fa pull-right\" ng-class=\"(!branchesObj.name.length || !branchesObj.format.length || !branchesObj.compression.length || !branchesObj.sharding.length || !branchesObj.inputPath.length) ? \'fa-exclamation-triangle\' : \'fa-check\'\"></div></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.name\" placeholder=\"Name for the Branch*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"formatName for formatName in createTrainer.algorithmFormats | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.format\" placeholder=\"Format*\"> <span class=\"highlight\"></span> <label>Format*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"compressionName for compressionName in createTrainer.algorithmCompression | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.compression\" placeholder=\"Compression*\"> <span class=\"highlight\"></span> <label>Compression*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"shardingName for shardingName in createTrainer.algorithmSharding | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.sharding\" placeholder=\"Sharding*\"> <span class=\"highlight\"></span> <label>Sharding*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"branchesObj.inputPath\" placeholder=\"Input path*\"> <span class=\"highlight\"></span> <label>Input path*</label> <small class=\"helper-text w100\" ng-if=\"createTrainer.storagePermissionObj.List\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"createTrainer.fnAddStoragePath(branchesObj, \'file\')\"><small>Choose file path</small></button></small></div></div></div></uib-accordion-group></uib-accordion></uib-tab><uib-tab index=\"1\" heading=\"Optional\"><uib-accordion ng-if=\"createTrainer.newTrainerObj.algorithmId.length && createTrainer.algorithmOptionalBranches.length\" close-others=\"false\"><uib-accordion-group class=\"m-t-20\" ng-repeat=\"branchesObj in createTrainer.algorithmOptionalBranches track by $index\" is-open=\"branchesObj.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2\">{{branchesObj.name}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !branchesObj.open, \'fa-angle-up\': branchesObj.open}\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.name\" placeholder=\"Branch name\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"formatName for formatName in createTrainer.algorithmFormats | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.format\" placeholder=\"Format\"> <span class=\"highlight\"></span> <label>Format</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"compressionName for compressionName in createTrainer.algorithmCompression | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.compression\" placeholder=\"Compression\"> <span class=\"highlight\"></span> <label>Compression</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"shardingName for shardingName in createTrainer.algorithmSharding | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"branchesObj.sharding\" placeholder=\"Sharding\"> <span class=\"highlight\"></span> <label>Sharding</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"branchesObj.inputPath\" placeholder=\"Input path\"> <span class=\"highlight\"></span> <label>Input path</label> <small class=\"helper-text w100\" ng-if=\"createTrainer.storagePermissionObj.List\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"createTrainer.fnAddStoragePath(branchesObj, \'file\')\"><small>Choose file path</small></button></small></div></div></div></uib-accordion-group></uib-accordion></uib-tab></uib-tabset></div></div><div class=\"col-sm-12 p-r-0\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-disabled=\"createTrainer.fnCheckRequiredBranches()\" wz-next=\"\" value=\"Next\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-10\" wz-previous=\"\" value=\"Back\"></div>");
$templateCache.put("app/ai/trainer/createTrainer/steps/parameters.html","<div class=\"row m-t-55\"><div class=\"col-sm-12\"><div ng-if=\"createTrainer.newTrainerObj.algorithmId.length\"><trainer-params algorithm-id=\"createTrainer.newTrainerObj.algorithmId\" cloned-parameters-obj=\"createTrainer.clonedTrainerObj\" fn-check-parameter-validation=\"createTrainer.fnCheckParameterFormValidation(isValidate, parametersObj)\"></trainer-params></div></div></div><div class=\"col-sm-12 p-r-0\"><input type=\"button\" ng-disabled=\"!createTrainer.isParameterFormValidated\" class=\"btn btn-primary pull-right\" wz-next=\"\" value=\"Next\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-10\" wz-previous=\"\" value=\"Back\"></div>");
$templateCache.put("app/ai/trainer/createTrainer/steps/review.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><uib-tabset active=\"activeTab\" type=\"pills\"><uib-tab index=\"0\" heading=\"Algorithm\"><div class=\"m-t-30\"><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTrainer.newTrainerObj.name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"algorithm\" type=\"text\" ng-model=\"createTrainer.selectedAlgorithm.name\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <span class=\"typeInfo\" ng-if=\"createTrainer.selectedAlgorithm\"><span>({{createTrainer.selectedAlgorithm.id}})</span></span> <small class=\"helper-text\"></small></div></div></uib-tab><uib-tab index=\"1\" heading=\"Parameters\"><div class=\"md-input m-b-20 m-t-30 pace\" ng-repeat=\"(key, value) in createTrainer.newTrainerObj.parameters\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"value\"> <span class=\"highlight\"></span> <label>{{key}}</label> <small class=\"helper-text\"></small></div></uib-tab><uib-tab index=\"2\" heading=\"Branches\"><div class=\"m-t-20 AiBranchInput\"><uib-accordion close-others=\"false\"><uib-accordion-group class=\"m-t-20\" ng-repeat=\"branchesObj in createTrainer.algorithmRequiredBranches track by $index\" is-open=\"branchesObj.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2\">{{branchesObj.name}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !branchesObj.open, \'fa-angle-up\': branchesObj.open}\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 pace\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.name\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.format\"> <span class=\"highlight\"></span> <label>Format</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.compression\"> <span class=\"highlight\"></span> <label>Compression</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.sharding\"> <span class=\"highlight\"></span> <label>Sharding</label></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.inputPath\"> <span class=\"highlight\"></span> <label>Input path</label></div></div></div></uib-accordion-group></uib-accordion><uib-accordion close-others=\"false\"><uib-accordion-group class=\"m-t-20\" ng-repeat=\"branchesObj in createTrainer.algorithmOptionalBranches track by $index\" ng-if=\"branchesObj.name.length && branchesObj.format.length && branchesObj.compression.length && branchesObj.sharding.length && branchesObj.inputPath.length\" is-open=\"branchesObj.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2\">{{branchesObj.name}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !branchesObj.open, \'fa-angle-up\': branchesObj.open}\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 pace\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.name\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.format\"> <span class=\"highlight\"></span> <label>Format</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.compression\"> <span class=\"highlight\"></span> <label>Compression</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.sharding\"> <span class=\"highlight\"></span> <label>Sharding</label></div><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.inputPath\"> <span class=\"highlight\"></span> <label>Input path</label></div></div></div></uib-accordion-group></uib-accordion></div></uib-tab><uib-tab index=\"3\" heading=\"Settings\"><div class=\"m-t-30\"><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"outputPath\" type=\"text\" ng-model=\"createTrainer.newTrainerObj.outputPath\"> <span class=\"highlight\"></span> <label>Storage Output Path</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"vmId\" type=\"text\" ng-model=\"createTrainer.selectedVmObj.name\"> <span class=\"highlight\"></span> <label>Virtual Machine</label> <span class=\"typeInfo\" ng-if=\"createTrainer.selectedVmObj\"><span>({{createTrainer.selectedVmObj.id}})</span></span> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-model=\"createTrainer.newTrainerObj.trainingVmCount\"> <span class=\"highlight\"></span> <label>Virtual Machine Quantity</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-model=\"createTrainer.newTrainerObj.trainingMaxTime\"> <span class=\"highlight\"></span> <label>Virtual Machine Training Duration</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-model=\"createTrainer.newTrainerObj.trainingVmDriveSize\"> <span class=\"highlight\"></span> <label>Virtual Machine Drive Size</label></div></div></uib-tab></uib-tabset></div></div><div class=\"col-sm-12 p-r-0\"><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createTrainer.isTrainerCreating\" ng-click=\"createTrainer.fnCreateTrainer(createTrainer.newTrainerObj)\" ng-disabled=\"createTrainer.fnCheckTrainerValidation()\" value=\"Create Trainer\"><div ng-if=\"createTrainer.isTrainerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/ai/trainer/createTrainer/steps/settings.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"createTrainer.newTrainerObj.algorithmId.length\"><div class=\"md-input m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"createTrainer.newTrainerObj.outputPath\" placeholder=\"Choose folder path*\"> <span class=\"highlight\"></span> <label>Output path*</label> <small class=\"helper-text w100\" ng-if=\"createTrainer.storagePermissionObj.List\"><button class=\"btn btn-link p-0 pull-right\" ng-click=\"createTrainer.fnAddStoragePath(createTrainer.newTrainerObj, \'folder\')\"><small>Choose folder path</small></button></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"vms as vms.name for vms in createTrainer.algoVmsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"VmsTemplate.html\" ng-change=\"!createTrainer.selectedVmObj ? createTrainer.fnResetVm(\'vm\') : \'\'\" typeahead-on-select=\"createTrainer.fnVmsSelected(createTrainer.selectedVmObj)\" ng-model=\"createTrainer.selectedVmObj\" placeholder=\"Select a Virtual Machine*\"> <span class=\"highlight\"></span> <label>Virtual Machine*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createTrainer.selectedVmObj\"><span>({{createTrainer.selectedVmObj.id}})</span></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-change=\"createTrainer.fnChangeVmCount(createTrainer.newTrainerObj.trainingVmCount)\" ng-model=\"createTrainer.newTrainerObj.trainingVmCount\" placeholder=\"Virtual Machine Quantity for Trainer.*\"> <span class=\"highlight\"></span> <label>Virtual Machine Quantity*</label> <small class=\"helper-text\" ng-if=\"!createTrainer.vmTrainingCountErrorMessage.length\"></small> <small class=\"helper-text\" ng-if=\"createTrainer.vmTrainingCountErrorMessage.length\">{{createTrainer.vmTrainingCountErrorMessage}}</small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-model=\"createTrainer.newTrainerObj.trainingMaxTime\" placeholder=\"Virtual Machine Training Duration for Trainer (seconds).*\"> <span class=\"highlight\"></span> <label>Virtual Machine Training Duration*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" type=\"number\" required=\"\" ng-model=\"createTrainer.newTrainerObj.trainingVmDriveSize\" placeholder=\"Virtual Machine Drive Size for Trainer (GB).*\"> <span class=\"highlight\"></span> <label>Virtual Machine Drive Size*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-r-0\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-disabled=\"createTrainer.fnCheckVmSettingValidation()\" wz-next=\"\" value=\"Next\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-10\" wz-previous=\"\" value=\"Back\"></div>");
$templateCache.put("app/ai/trainer/directives/trainerParams/trainerParams.html","<uib-tabset active=\"activeTab\" type=\"pills\" class=\"floatingLabelInput\"><uib-tab index=\"0\" heading=\"Required\"><div class=\"row m-t-15\"><div class=\"p-l-15\" ng-repeat=\"(key, value) in parametersObj\"><div ng-if=\"parametersObj[key].isRequired === true\"><div class=\"col-sm-12 p-0\" ng-class=\"$first ? \'m-t-20\' : \'\'\"><div class=\"p-l-0 col-sm-12\"><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'input\' && parametersObj[key].type === \'number\'\" ng-class=\"parametersObj[key].isMinMaxError || parametersObj[key].isPatternMismatch || parametersObj[key].recommendValues?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"number\" step=\"{{parametersObj[key].subType === \'float\' ? \'any\' : 1}}\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isMinMaxError\"><span class=\"errorText\">The input should be greater than {{parametersObj[key].min}} {{parametersObj[key].max ? \'and less than \' + parametersObj[key].max : \'\'}}</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small> <small class=\"helper-text-error\" ng-show=\"parametersObj[key].recommendValues && !parametersObj[key].isValueMissing && !parametersObj[key].isMinMaxError && !parametersObj[key].isPatternMismatch\"><span class=\"errorText\">Recommended values are {{parametersObj[key].recommendValues[0]}} & {{parametersObj[key].recommendValues[1]}}.</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputComma\' && parametersObj[key].type === \'text\'\" ng-class=\"parametersObj[key].isCommaPatternMismatch || !parametersObj[key].isCommaPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isCommaPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].commaPatternMessage}}</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && !parametersObj[key].isCommaPatternMismatch\"><span class=\"errorText\">Input accepts comma separated values</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputComma\' && parametersObj[key].type === \'number\'\" ng-class=\"parametersObj[key].isCommaNumberPatternMismatch|| !parametersObj[key].isCommaNumberPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isCommaNumberPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].commaNumberPatternMessage}}</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && !parametersObj[key].isCommaNumberPatternMismatch\"><span class=\"errorText\">Input accepts comma separated values</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'input\' && parametersObj[key].type === \'text\'\" ng-class=\"parametersObj[key].isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'dropdown\'\" ng-class=\"parametersObj[key].isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"validValue for validValue in parametersObj[key].validValues | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"parametersObj[key].userInput\" typeahead-on-select=\"fnValidate(key)\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputCommaWithText\'\" ng-class=\"parametersObj[key].isInputCommaWithTextPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isInputCommaWithTextPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].isInputCommaWithTextPatternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'array\'\" ng-class=\"parametersObj[key].isNotArray?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}*\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}*</label> <small class=\"helper-text-error\" ng-show=\"[!parametersObjkey].isValueMissing && parametersObj[key].isNotArray\"><span class=\"errorText\">{{parametersObj[key].isNotArrayPatternMessage}}</span></small></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Optional\"><div class=\"row m-t-15 floatingLabelInput\"><div class=\"p-l-15\" ng-repeat=\"(key, value) in parametersObj\"><div ng-if=\"parametersObj[key].isRequired === false\"><div class=\"col-sm-12 p-0\" ng-class=\"$first ? \'m-t-20\' : \'\'\"><div class=\"p-l-0 col-sm-12\"><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'input\' && parametersObj[key].type === \'number\'\" ng-class=\"parametersObj[key].isMinMaxError || parametersObj[key].isPatternMismatch ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"number\" ng-disabled=\"parametersObj[key].isDisabled\" step=\"{{parametersObj[key].subType === \'float\' ? \'any\' : 1}}\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isMinMaxError\"><span class=\"errorText\">The input should be greater than {{parametersObj[key].min}} {{parametersObj[key].max ? \'and less than \' + parametersObj[key].max : \'\'}}</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputComma\' && parametersObj[key].type === \'text\'\" ng-class=\"!parametersObj[key].isCommaPatternMismatch || parametersObj[key].isCommaPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && !parametersObj[key].isCommaPatternMismatch\"><span class=\"errorText\">Input accepts comma separated values</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isCommaPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].commaPatternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputComma\' && parametersObj[key].type === \'number\'\" ng-class=\"parametersObj[key].isCommaNumberPatternMismatch || !parametersObj[key].isCommaNumberPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isCommaNumberPatternMismatch\"><span class=\"helper-text\">{{parametersObj[key].commaNumberPatternMessage}}</span></small> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && !parametersObj[key].isCommaNumberPatternMismatch\"><span class=\"helper-text\">Input accepts comma separated values</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'input\' && parametersObj[key].type === \'text\'\" ng-class=\"parametersObj[key].isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'dropdown\'\" ng-class=\"parametersObj[key].isPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" typeahead-editable=\"false\" uib-typeahead=\"validValue for validValue in parametersObj[key].validValues | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"parametersObj[key].userInput\" typeahead-on-select=\"fnValidate(key)\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].patternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'inputCommaWithText\'\" ng-class=\"parametersObj[key].isInputCommaWithTextPatternMismatch?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isInputCommaWithTextPatternMismatch\"><span class=\"errorText\">{{parametersObj[key].isInputCommaWithTextPatternMessage}}</span></small></div><div class=\"md-input\" ng-if=\"parametersObj[key].inputType === \'array\'\" ng-class=\"parametersObj[key].isNotArray?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" ng-attr-id=\"{{key+$index}}\" type=\"text\" ng-disabled=\"parametersObj[key].isDisabled\" ng-model=\"parametersObj[key].userInput\" ng-change=\"fnValidate(key)\" placeholder=\"{{fnSetFiledLabel(key)}}\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(key)}}</label> <small class=\"helper-text-error\" ng-show=\"!parametersObj[key].isValueMissing && parametersObj[key].isNotArray\"><span class=\"errorText\">{{parametersObj[key].isNotArrayPatternMessage}}</span></small></div></div></div></div></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/ai/trainer/modals/createMedalFromTrainer/createModelFromTrainer.html","<div class=\"inmodal\" ng-init=\"createModel.fnInitCreateModelFromTrainer()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{createModel.title}}</h3></div><div class=\"modal-body\" id=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"!createModel.isDetailsLoaded\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 m-t-20 floatingLabelInput\" ng-if=\"createModel.isDetailsLoaded\"><form id=\"createNewModelForm\" role=\"form\" name=\"createNewModelForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createModel.newModelObj.name\" placeholder=\"Name for the Model*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createModel.newModelObj.description\" placeholder=\"Description for the Model\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-40 pace\"><input class=\"md-form-control\" required=\"\" id=\"algorithmId\" type=\"text\" ng-model=\"createModel.algorithmObj.name\" placeholder=\"Algorithm for the Model*\"> <span class=\"highlight\"></span> <label>Algorithm*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\"><span>({{createModel.newModelObj.algorithmId}})</span></span></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"storagePath\" type=\"text\" ng-model=\"createModel.newModelObj.artifactPath\" placeholder=\"Artifact Path*\"> <span class=\"highlight\"></span> <label>Artifact Path*</label> <small class=\"helper-text\"></small></div></form></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"createModel.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!createModel.newModelObj.name.length\" ng-if=\"!createModel.isModelCreating\" ng-click=\"createModel.fnCreateNewModel(createModel.newModelObj)\" tabindex=\"12\">Create</button><div class=\"pull-right m-l-10\" ng-if=\"createModel.isModelCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/ai/trainer/trainerInfo/trainerTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitTrainer()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isTrainerDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isTrainerDetailsLoaded\"><div class=\"m-t-20\"><div class=\"pull-right\"><div class=\"col-sm-12 p-0 text-center\"><span class=\"trainersInfoIcon trainersIconBorder\" uib-tooltip=\"{{trainerObj.status}}\" tooltip-placement=\"auto\" ng-style=\"fnGetTrainerStatusIconColor(trainerObj.status)\"><span class=\"trainersIcon fa\" ng-class=\"fnGetTrainerStatusIcon(trainerObj.status)\"></span></span></div></div></div></div><div class=\"wizard col-sm-12 floatingLabelInput\" ng-if=\"isTrainerDetailsLoaded && !isDetailsEditable\"><uib-tabset active=\"activeTab\" type=\"pills\"><uib-tab index=\"0\" heading=\"Algorithm\"><div class=\"md-input m-b-20 m-t-30 pace\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"trainerObj.name\"> <span class=\"highlight\"></span> <label>Name</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"algorithmId\" type=\"text\" ng-model=\"trainerObj.algorithmName\"> <span class=\"highlight\"></span> <label>Algorithm</label> <span class=\"typeInfo\"><span>{{trainerObj.algorithmId}}</span></span></div></uib-tab><uib-tab index=\"1\" heading=\"Parameters\"><div class=\"m-t-20\"><div class=\"col-sm-12 p-0 pace\" ng-repeat=\"(key, value) in trainerObj.parameters track by $index\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"value\"> <span class=\"highlight\"></span> <label>{{key}}</label> <small class=\"helper-text\"></small></div></div></div></uib-tab><uib-tab index=\"2\" heading=\"Branches\"><div class=\"m-t-20 AiBranchInput\"><uib-accordion close-others=\"false\"><uib-accordion-group class=\"m-t-20\" ng-repeat=\"branchesObj in trainerObj.branches track by $index\" is-open=\"branchesObj.open\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2\">{{branchesObj.name}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !branchesObj.open, \'fa-angle-up\': branchesObj.open}\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 pace\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.name\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.format\"> <span class=\"highlight\"></span> <label>Format</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.compression\"> <span class=\"highlight\"></span> <label>Compression</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.sharding\"> <span class=\"highlight\"></span> <label>Sharding</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" tabindex=\"-1\" ng-model=\"branchesObj.inputPath\"> <span class=\"highlight\"></span> <label>Input path</label> <small class=\"helper-text w100\"></small></div></div></div></uib-accordion-group></uib-accordion></div></uib-tab><uib-tab index=\"3\" heading=\"Settings\"><div class=\"m-t-30\"><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"outputPath\" type=\"text\" ng-model=\"trainerObj.outputPath\"> <span class=\"highlight\"></span> <label>Storage Output Path</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"trainingMaxTime\" type=\"text\" ng-model=\"trainerObj.trainingMaxTime\"> <span class=\"highlight\"></span> <label>Maximum Training Duration (seconds)</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"trainingVmId\" type=\"text\" ng-model=\"trainerObj.trainingVmName\"> <span class=\"highlight\"></span> <label>Virtual Machine</label> <span class=\"typeInfo\"><span>{{trainerObj.trainingVmId}}</span></span></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"trainingVmCount\" type=\"text\" ng-model=\"trainerObj.trainingVmCount\"> <span class=\"highlight\"></span> <label>Virtual Machine Quantity</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"trainingVmDriveSize\" type=\"text\" ng-model=\"trainerObj.trainingVmDriveSize\"> <span class=\"highlight\"></span> <label>Virtual Machine Drive Size (GB)</label></div></div></uib-tab></uib-tabset></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{trainerObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(trainerObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 p-t-3\" ng-if=\"isTrainerProcessOnGoing\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-xs-6 content-box-footerItem\" ng-if=\"!isTrainerProcessOnGoing\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(trainerPermissionsObj.Stop || trainerPermissionsObj.Create || trainerPermissionsObj.Delete) && isTrainerDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"trainerPermissionsObj.Stop && (trainerObj.status !== \'COMPLETED\' && trainerObj.status !== \'FAILED\')\"><a class=\"btn btn-link\" ng-click=\"fnStopTrainer()\">Stop</a></li><li ng-if=\"trainerPermissionsObj.Create\"><a class=\"btn btn-link\" ng-click=\"fnCloneTrainer(trainerObj)\">Clone</a></li><li ng-if=\"modelPermissionObj.Create && trainerPermissionsObj.List && (trainerObj.status !== \'COMPLETED\' && trainerObj.status !== \'FAILED\')\"><a class=\"btn btn-link\" ng-click=\"fnOpenCreateFromTrainerModel(trainerObj)\">Create Model</a></li><li ng-if=\"trainerPermissionsObj.Delete && (trainerObj.status === \'COMPLETED\' || trainerObj.status === \'FAILED\')\"><a class=\"btn btn-link\" ng-click=\"fnDeleteTrainer(trainerObj)\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/billing/business/businessTab/businessDetails/businessDetails.html","<div id=\"emailTemplateContent\" class=\"h-100\" ng-controller=\"BusinessDetailsCtrl as businessDetail\" ng-init=\"businessDetail.fnInitBusinessDetail();\"><div class=\"content-main\"><div class=\"col-sm-12 dashboard-header p-15\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Business</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"businessDetail.isFullWidthDevice\">Business Details</h1><h3 class=\"m-0 font-bold\" ng-if=\"!businessDetail.isFullWidthDevice\">Business Details</h3></div></div></div><div class=\"col-sm-12 p-0 businessDetails overflow-auto\"><div class=\"col-sm-12 h-100 p-0 d-flex justify-content-center align-items-center\" ng-if=\"businessDetail.isBusinessDetailLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 floatingLabelInput p-t-30\" ng-if=\"!businessDetail.isBusinessDetailLoading\" ng-class=\"!businessDetail.isEditable || businessDetail.isBusinessDetailSaveChanges ? \'pace\' : \'\'\"><form id=\"businessDetailForm\" autocomplete=\"off\" role=\"form\" name=\"$root.businessDetailForm\" novalidate=\"\"><div class=\"col-sm-12\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessName\" name=\"businessName\" id=\"businessName\" placeholder=\"Business Name*\"> <span class=\"highlight\"></span> <label>Business Name*</label></div></div><div class=\"col-sm-12\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"email\" ng-model=\"businessDetail.businessInfo.businessEmail\" name=\"businessEmail\" ng-pattern=\"businessDetail.emailPattern\" id=\"businessEmail\" placeholder=\"Business Email*\"> <span class=\"highlight\"></span> <label>Business Email*</label></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessPhone\" name=\"businessPhone\" id=\"businessPhone\" ng-pattern=\"/^(?:(?:\\+?1\\s*(?:[.-]\\s*)?)?(?:\\(\\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\\s*\\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\\s*(?:[.-]\\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\\s*(?:[.-]\\s*)?([0-9]{4})(?:\\s*(?:#|x\\.?|ext\\.?|extension)\\s*(\\d+))?$/\" placeholder=\"Business Phone*\"> <span class=\"highlight\"></span> <label>Business Phone*</label> <small class=\"helper-text-error\" ng-show=\"businessDetailForm.businessPhone.$error.pattern\"><span class=\"errorText\">Enter Valid phone number</span></small></div></div></div><div class=\"col-sm-12\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessAddress.line1\" name=\"line1\" id=\"line1\" placeholder=\"Address line1*\"> <span class=\"highlight\"></span> <label>Address line1*</label></div></div><div class=\"col-sm-12\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessAddress.line2\" name=\"line2\" id=\"line2\" placeholder=\"Address line2\"> <span class=\"highlight\"></span> <label>Address line2</label></div></div><div class=\"col-sm-12\"><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessAddress.city\" name=\"city\" id=\"city\" placeholder=\"City*\"> <span class=\"highlight\"></span> <label>City*</label></div></div><div class=\"col-sm-4\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"businessDetail.businessInfo.businessAddress.state\" name=\"state\" id=\"state\" placeholder=\"State*\"> <span class=\"highlight\"></span> <label>State*</label></div></div><div class=\"col-sm-4\"><div class=\"md-input m-b-2 m-b-40\"><input class=\"md-form-control\" required=\"\" type=\"text\" id=\"postalCode\" name=\"postalCode\" ng-model=\"businessDetail.businessInfo.businessAddress.postalCode\" placeholder=\"Zip*\"> <span class=\"highlight\"></span> <label>Zip*</label></div></div></div></form></div></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center\"><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"businessDetail.isEditable && !businessDetail.isBusinessDetailSaveChanges\" ng-click=\"businessDetail.fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem p-0 m-0 d-flex justify-content-flex-end\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!businessDetail.isEditable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"businessDetail.permissionObj.UPDATE_BUSINESS_DETAILS\" ng-click=\"businessDetail.fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-if=\"businessDetail.isEditable && !businessDetail.isBusinessDetailSaveChanges\" ng-disabled=\"!$root.businessDetailForm.$valid\" ng-click=\"businessDetail.fnSaveBusinessDetail()\">Save Changes</button><div class=\"pull-right\" ng-if=\"businessDetail.isBusinessDetailSaveChanges && businessDetail.isEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/billing/credit_token/credit_tokenInfo/credit_tokenSteps/details.html","<div id=\"teamsContent\" class=\"content-main\" ng-init=\"fnInitCreditToken()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isCreditTokenDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isCreditTokenDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isCreditTokenDetailsLoaded && accountId === \'cu000000\'\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnSendCreditToken(creditTokenObj.id)\" ng-if=\"accountId === \'cu000000\' && type && type === \'unclaimed\' && userPermissionsObj.SEND_UNCLAIMED_CREDIT_TOKEN\"><a class=\"btn btn-link\">Send Credit Token</a></li><li ng-click=\"fnDeleteCreditToken(creditTokenObj)\" ng-if=\"accountId === \'cu000000\' && type && type === \'unclaimed\' && userPermissionsObj.DELETE_UNCLAIMED_CREDIT_TOKEN\"><a class=\"btn btn-link\">Delete Token</a></li></ul></div></div></div><div class=\"col-sm-12 m-t-10 m-b-10\" ng-if=\"isCreditTokenDetailsLoaded\"><table border=\"1\" class=\"w100 variables-table\" ng-if=\"type && type === \'claimed\'\"><tbody><tr><td class=\"p-10\"><label class=\"m-0\">Name</label></td><td class=\"p-10\">{{creditTokenObj.name}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Description</label></td><td class=\"p-10\">{{creditTokenObj.description}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Starts</label></td><td class=\"p-10\">{{creditTokenObj.startsDate}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Claimed</label></td><td class=\"p-10\">{{creditTokenObj.claimedDate}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Created By</label></td><td class=\"p-10\">{{creditTokenObj.createdBy}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Claimed By</label></td><td class=\"p-10\">{{creditTokenObj.claimedBy}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Claimed Amount</label></td><td class=\"p-10\">$ {{(creditTokenObj.amountClaimed/100).toFixed(2)}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Used Amount</label></td><td class=\"p-10\">$ {{(creditTokenObj.amountUsed/100).toFixed(2)}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Remaining Amount</label></td><td class=\"p-10\">$ {{(creditTokenObj.amountRemaining/100).toFixed(2)}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Products</label></td><td class=\"p-10\"><span ng-repeat=\"productId in creditTokenObj.productIds\">{{productId}}<span ng-if=\"!$last\" class=\"m-r-5\">,</span></span></td></tr></tbody></table><table border=\"1\" class=\"w100 variables-table\" ng-if=\"type && type === \'unclaimed\'\"><tbody><tr><td class=\"p-10\"><label class=\"m-0\">Name</label></td><td class=\"p-10\">{{creditTokenObj.name}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Description</label></td><td class=\"p-10\">{{creditTokenObj.description}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Starts</label></td><td class=\"p-10\">{{creditTokenObj.startsDate}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Expires</label></td><td class=\"p-10\">{{creditTokenObj.expiresDate}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Created</label></td><td class=\"p-10\">{{creditTokenObj.createdDate}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Created By</label></td><td class=\"p-10\">{{creditTokenObj.createdBy}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Amount</label></td><td class=\"p-10\">$ {{(creditTokenObj.amount/100).toFixed(2)}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Min Transaction</label></td><td class=\"p-10\">{{creditTokenObj.transactionMin}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Max Transaction</label></td><td class=\"p-10\">{{creditTokenObj.transactionMax}}</td></tr><tr><td class=\"p-10\"><label class=\"m-0\">Products</label></td><td class=\"p-10\"><span ng-repeat=\"productId in creditTokenObj.productIds\">{{productId}}<span ng-if=\"!$last\" class=\"m-r-5\">,</span></span></td></tr></tbody></table></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{creditTokenObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(creditTokenObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/billing/credit_token/modal/ClaimCredit/claimCredit.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Token ID\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput p-0\"><form novalidate=\"\" name=\"claimCreditForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"tokenId\" type=\"text\" name=\"tokenId\" ng-model=\"claimCredit.token\" placeholder=\"Token ID for the Claim Credit*\"> <span class=\"highlight\"></span> <label>Token ID*</label></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!claimCredit.isCreditToken\" ng-click=\"claimCredit.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!claimCredit.isCreditToken\" ng-disabled=\"!claimCredit.token.length\" ng-click=\"claimCredit.fnSave()\" tabindex=\"12\">Claim Credit Token</button><div class=\"pull-right\" ng-if=\"claimCredit.isCreditToken\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/billing/credit_token/modal/sendCreditToken/sendCreditToken.html","<div class=\"inmodal theme_modal\" ng-init=\"sendCreditToken.fnInitSendCreditTokens()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Send Credit Token\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\" ng-if=\"sendCreditToken.isUserListLoading\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-if=\"!sendCreditToken.isUserListLoading\"><form id=\"sendCreditTokenForm\" role=\"form\" name=\"sendCreditTokenForm\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"User ID*\" typeahead-editable=\"true\" uib-typeahead=\"userObj.id as userObj.id for userObj in sendCreditToken.usersArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"UserTemplate.html\" name=\"UserID\" ng-pattern=\"/^(\\w{8})-((\\w{8}))$/\" id=\"UserID\" ng-model=\"sendCreditToken.userId\"> <span class=\"highlight\"></span> <label>User ID*</label> <small class=\"helper-text-error\" ng-show=\"sendCreditTokenForm.UserID.$error.pattern && sendCreditTokenForm.UserID.$dirty\"><span class=\"errorText\">The Id does not satisfy the required format. cuxxxxxx-auxxxxxx</span></small> <button type=\"button\" class=\"btn btn-primary\" style=\"display: none\" ng-disabled=\"sendCreditToken.fnCheckValidation(sendCreditTokenForm.$valid)\">Continue</button></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!sendCreditToken.isCreditTokenSending\" ng-click=\"sendCreditToken.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!sendCreditToken.isFormValid\" ng-if=\"!sendCreditToken.isCreditTokenSending\" ng-click=\"sendCreditToken.fnSave()\" tabindex=\"12\">Submit</button><div class=\"pull-right\" ng-if=\"sendCreditToken.isCreditTokenSending\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><script type=\"text/ng-template\" id=\"UserTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.firstName + \' \' + match.model.lastName\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>({{match.model.id}})</span></small> </div> <br> </div> </a></script></div>");
$templateCache.put("app/billing/discount/discountInfo/discountSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDiscount()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isDiscountDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isDiscountDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"accountId ===\'cu000000\'\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_DISCOUNT\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_DISCOUNT\" ng-click=\"fnDeleteDiscount(discountObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isDiscountDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"discount\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"discountObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"discount.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"discountObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"discount.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input\" ng-class=\"discount.productId.$error.pattern && discount.productId.$dirty ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"productId\" type=\"text\" ng-model=\"discountObj.productId\" ng-pattern=\"/^(\\w{8})$/\" placeholder=\"Product Id*\" name=\"productId\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"discount.productId.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Product Id*</label> <small class=\"helper-text-error\" ng-show=\"discount.productId.$error.pattern && discount.productId.$dirty\"><span class=\"errorText\">The Id does not satisfy the required format. xxxxxxxx</span></small></div><div class=\"md-input\" ng-class=\"discount.percentage.$error.min || discount.percentage.$error.max ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"percentage\" type=\"number\" name=\"percentage\" step=\"0.01\" min=\"0\" max=\"100\" ng-model=\"discountObj.percentage\" placeholder=\"Percentage*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"discount.percentage.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Percentage*</label> <small class=\"helper-text-error\" ng-show=\"discount.percentage.$error.min || discount.percentage.$error.max\"><span class=\"errorText\">The Discount Percentage should be greater than 0 and less than 100</span></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"expiresHiddenInputText\" type=\"text\" name=\"expires\" ng-model=\"discountObj.expires\" placeholder=\"Expires*\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"discount.expires.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Expires*</label> <small class=\"helper-text\"></small></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!discount.$valid\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateDiscountDetails(discountObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{discountObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(discountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/billing/invoice/invoiceInfo/invoiceSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitInvoice()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isInvoiceDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isInvoiceDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isInvoiceDetailsLoaded && isInvoicePDFLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnOpenPaymentMethodModal(invoiceObj.id)\" ng-if=\"invoiceObj.status !== \'PAID\' && invoiceObj.accountId === accountId && userPermissionsObj.PAY_INVOICE\"><a class=\"btn btn-link\">Pay Invoice</a></li><li ng-if=\"userPermissionsObj.DOWNLOAD_INVOICE_PDF\" ng-click=\"fnExportPDF(invoiceObj.id)\"><a class=\"btn btn-link\">Export PDF</a></li></ul></div><div class=\"\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"isInvoiceDetailsLoaded && !isInvoicePDFLoaded\"></div></div></div><div class=\"col-sm-12 h-100 floatingLabelInput\" ng-if=\"isInvoiceDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-20\"><div class=\"col-sm-6 p-0 pull-left\"><h4>State: {{invoiceObj.status}}</h4></div><div class=\"col-sm-6 p-0 pull-right\"><h4><span class=\"pull-right\">Date: {{invoiceObj.createdAt | date: \'MMM yyyy\'}}</span></h4></div></div><div class=\"col-sm-12 m-t-5 p-0\"><h4><span>Issue Date: {{invoiceObj.createdAt}}</span></h4></div><div class=\"col-sm-12 m-t-5 p-0\"><h4><span>Due Date: {{invoiceObj.dueDate}}</span></h4></div><div id=\"BillTotalEstimate\" class=\"col-sm-12 p-0 billingHeader\"><div class=\"modal-header p-0\"><h2 class=\"modal-title inline-display m-b-0 m-t-7\" id=\"modal-title\"><strong>Estimated Total</strong></h2><h2 class=\"pull-right m-b-0\"><strong>$ {{(invoiceObj.total/100).toFixed(2)}}</strong></h2></div></div><div id=\"BillDetailsPartition\" class=\"col-sm-12 p-0 m-t-5 billingHeader\"><div class=\"modal-header p-0\"><h3 class=\"modal-title inline-display\" id=\"modal-title1\"><strong>Details</strong></h3></div><div class=\"modal-header p-t-10 p-b-10 p-0 m-t-5\" ng-repeat=\"invoiceItemData in invoiceObj.invoiceItems\"><h3 class=\"inline-display font500\"><strong>{{invoiceItemData.product ? invoiceItemData.product.name : invoiceItemData.description}}</strong></h3><h3 class=\"pull-right m-b-0\"><strong>$ {{(invoiceItemData.amount/100).toFixed(2)}}</strong></h3></div></div><div class=\"col-sm-12 m-t-10 p-0\"><h4 class=\"pull-right\"><strong>Price: $ {{(invoiceObj.total/100).toFixed(2)}}</strong></h4></div><div class=\"col-sm-12 m-t-10 p-0\"><h4 class=\"pull-right\"><strong>Tax: $ {{(invoiceObj.taxes/100).toFixed(2)}}</strong></h4></div><div class=\"col-sm-12 m-t-10 p-0\"><h4 class=\"pull-right\"><strong>Total: $ {{(invoiceObj.total/100).toFixed(2)}}</strong></h4></div><div class=\"col-sm-12 m-t-10 p-0\"><h4 class=\"pull-right\"><strong>Amount Paid: $ {{(invoiceObj.amountPaid/100).toFixed(2)}}</strong></h4></div><div class=\"col-sm-12 m-t-10 p-0\"><h4 class=\"pull-right\"><strong>Amount Due: $ {{(invoiceObj.amountDue/100).toFixed(2)}}</strong></h4></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{invoiceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(invoiceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/billing/invoice/modal/paymentMethod/paymentMethod.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"paymentMethod.fnInit()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Payment Method\'\"></h4></div><div class=\"modal-body\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!paymentMethod.isPaymentMethodLoading\"><h3 class=\"m-0 p-b-10\" ng-if=\"paymentMethod.paymentMethodArr.length\">Select Payment Method:</h3><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\" ng-if=\"paymentMethod.paymentMethodArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\">XXXX-XXXX-XXXX-{{paymentMethod.selectedPaymentMethod.card.last4}}</span> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\" ng-repeat=\"paymentMethodObj in paymentMethod.paymentMethodArr\"><a ng-click=\"paymentMethod.selectedPaymentMethod = paymentMethodObj\"><div class=\"d-flex align-items-center\"><div><div><h3>XXXX-XXXX-XXXX-{{paymentMethodObj.card.last4}}</h3></div><div><h4>Valid Thru: {{paymentMethodObj.card.expiryMonth}}/{{paymentMethodObj.card.expiryYear}}</h4></div></div><div class=\"m-l-20\"><i class=\"fa fa-2x\" ng-class=\"paymentMethod.fnGetCreditCardClass(paymentMethodObj.card.brand)\"></i></div></div></a></li></ul></div><button class=\"btn btn-link p-0 pull-right\" style=\"background: transparent;border: 0;\" ng-click=\"paymentMethod.fnManagePaymentMethod()\">Manage Payment Method</button></div><div class=\"col-sm-12 p-0 h-100 d-flex justify-content-center align-items-center flex-column\" ng-if=\"!paymentMethod.paymentMethodArr.length\"><h2 class=\"m-0\">There are no payment method found.</h2><button class=\"btn btn-primary v4-primary-button p-t-10 p-b-10 p-l-20 p-r-20 m-t-15\" ng-click=\"paymentMethod.fnManagePaymentMethod()\">Manage Payment Method</button></div></div><div class=\"col-sm-12 p-0 p-t-30 d-flex justify-content-center align-items-center h-100\" ng-if=\"paymentMethod.isPaymentMethodLoading\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"modal-footer\"><button ng-if=\"!paymentMethod.isCartUpdating\" type=\"button\" class=\"btn btn-primary\" ng-click=\"paymentMethod.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"!paymentMethod.isCartUpdating\" ng-disabled=\"paymentMethod.fnCheckPaymentMethod()\" ng-click=\"paymentMethod.fnPayInvoice()\" tabindex=\"12\">Pay Invoice</button><div class=\"pull-right p-r-10\" ng-if=\"paymentMethod.isCartUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/billing/payment_method/paymentMethodInfo/paymentMethodTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitPaymentMethodDetails()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isPaymentMethodDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isPaymentMethodDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isPaymentMethodDetailsLoaded && !paymentMethodObj.defaultPaymentMethod\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!paymentMethodObj.defaultPaymentMethod && paymentMethodPermissionsObj.SET_DEFAULT_PAYMENT_METHOD\" ng-click=\"fnMakePaymentMethodPrimary(paymentMethodObj)\"><a class=\"btn btn-link\">Set as default payment method</a></li><li ng-if=\"!paymentMethodObj.defaultPaymentMethod\" ng-click=\"fnDeletePaymentMethod(paymentMethodObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12\" ng-if=\"isPaymentMethodDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><div class=\"m-r-10\"><label class=\"m-0\">Card Type:</label></div><div><span class=\"fa fa-2x\" uib-tooltip=\"{{paymentMethodObj.card.brand}}\" tooltip-placement=\"auto\" ng-class=\"fnGetCreditCardClass(paymentMethodObj.card.brand)\"></span></div></div><div class=\"col-sm-6 p-0\"><span class=\"fa fa-2x fa-credit-card pull-right d-block\" ng-if=\"paymentMethodObj.defaultPaymentMethod\" uib-tooltip=\"Default Payment Method\" tooltip-placement=\"auto\"></span></div></div><div class=\"col-sm-12 p-0 pace floatingLabelInput\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" tabindex=\"-1\" ng-model=\"paymentMethodObj.billingDetails.name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"addressLine1\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.line1\" placeholder=\"Address Line 1*\"> <span class=\"highlight\"></span> <label>Address Line 1*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"addressLine2\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.line2\" placeholder=\"Address Line 2\"> <span class=\"highlight\"></span> <label>Address Line 2</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 pace floatingLabelInput\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"postalCode\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.postalCode\" placeholder=\"Postal Code*\"> <span class=\"highlight\"></span> <label>Postal Code*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"city\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.city\" placeholder=\"City*\"> <span class=\"highlight\"></span> <label>City*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 pace floatingLabelInput\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"State\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.state\" placeholder=\"State*\"> <span class=\"highlight\"></span> <label>State*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"country\" type=\"text\" name=\"first-name\" ng-model=\"paymentMethodObj.billingDetails.address.country\" placeholder=\"Country*\"> <span class=\"highlight\"></span> <label>Country*</label> <small class=\"helper-text\"></small></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{paymentMethodObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(paymentMethodObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/billing/script/scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-click=\"fnSaveScript()\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/insight/insight_charts/insightChartInfo/insightChartSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isChartDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isChartDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isChartDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_CHART\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteChart(chartObj)\" ng-if=\"userPermissionsObj.DELETE_CHART\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isChartDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"chartForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"chartObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"chartObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!chartObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateChartDetails(chartObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{chartObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(chartObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isDashboardDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isDashboardDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isDashboardDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_CHART\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteDashboard(dashboardObj)\" ng-if=\"userPermissionsObj.DELETE_CHART\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isDashboardDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"dashboardForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"dashboardObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"dashboardObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!dashboardObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateDashboardDetails(dashboardObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{dashboardObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(dashboardObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/insight/insight_project/insightProjectInfo/insightProjectSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isProjectDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isProjectDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isProjectDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_PROJECT\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteProject(projectObj)\" ng-if=\"projectObj.parentProjectId && userPermissionsObj.DELETE_PROJECT\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isProjectDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"projectForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\" ng-if=\"projectObj.parentProjectId\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Parent Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!projectObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateProjectDetails(projectObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/insight/insight_queries/insightQueryInfo/insightQuerySteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isQueryDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isQueryDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isQueryDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_QUERY\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteQuery(queryObj)\" ng-if=\"userPermissionsObj.DELETE_QUERY\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isQueryDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"queryForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"queryObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"queryObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!queryObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateQueryDetails(queryObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{queryObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(queryObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/insight/insight_query_editor/directives/queryEditor/queryEditor.html","<div class=\"content-container h-100 overflow-auto\"><div class=\"container-with-footer\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isEditorDataLoading\"></div><div class=\"content-main p-15 query-editor-main-content\" ng-if=\"!isEditorDataLoading\"><div class=\"col-sm-12 p-0 d-flex flex-column h-100 insight-query-editor\"><div class=\"col-sm-12 p-0 d-flex query-action-header\"><div class=\"col-sm-5 p-l-0 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-8 p-0\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"createInsightQuery.isQuerySearchDataLoading\" ng-click=\"fnRunQuery()\">Run Query</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-disabled=\"createInsightQuery.isQuerySearchDataLoading\" ng-click=\"fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end\"><div class=\"d-flex\" ng-click=\"fnOpenQueryModal();\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/script.svg#script\"></use></svg></div></div></div></div><div class=\"col-sm-7 p-0 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-7 p-0 d-flex\"></div><div class=\"col-sm-5 p-0 d-flex justify-content-flex-end\"><div class=\"d-flex align-items-center justify-content-center m-r-15 p-t-6 p-b-6\" ng-click=\"fnChangeChartType(\'HIGHCHARTS\');\"><svg ng-class=\"selectedChartType === \'HIGHCHARTS\' ? \'custom-svg-side-menu-icon-primary\':\'custom-svg-side-menu-icon\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"d-flex align-items-center justify-content-center p-t-6 p-b-6 m-r-10\" ng-click=\"fnChangeChartType(\'RAWDATA\')\"><svg width=\"20px\" height=\"20px\" ng-class=\"selectedChartType === \'RAWDATA\' ? \'custom-svg-side-menu-icon-primary\':\'custom-svg-side-menu-icon\'\"><use xlink:href=\"assets/images/svg/service/table-icon.svg#table-icon\"></use></svg></div><div class=\"d-flex m-r-10 border-1px\" style=\"border-left: 0 !important;\"></div><div class=\"d-flex align-items-center justify-content-center p-t-6 p-b-6 m-r-10\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-0 d-flex p-0 v4-primary-button\" uib-dropdown-toggle=\"\"><svg width=\"20px\" height=\"20px\" class=\"custom-svg-side-menu-icon\"><use xlink:href=\"assets/images/svg/download.svg#download\"></use></svg></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"selectedChartType === \'HIGHCHARTS\'\"><a ng-click=\"downloadChartData(\'previewChart\', \'downloadPNG\')\">PNG image</a></li><li ng-if=\"selectedChartType === \'HIGHCHARTS\'\"><a ng-click=\"downloadChartData(\'previewChart\', \'downloadJPEG\')\">JPEG image</a></li><li ng-if=\"selectedChartType === \'HIGHCHARTS\'\"><a ng-click=\"downloadChartData(\'previewChart\', \'downloadSVG\')\">SVG vector image</a></li><li ng-click=\"test()\"><a ng-click=\"insightCharts.fnExportChart(\'downloadCSV\', \'labelDashboardWidgets\'+$index)\">CSV File</a></li><li><a ng-click=\"fnDownloadJSON()\">JSON File</a></li></ul></div><button ng-hide=\"true\" ng-csv=\"fnDownloadCSV()\" id=\"csvAnchor\" csv-header=\"csvHeaderArr\" filename=\"rowdata.csv\"></button><div class=\"d-flex align-items-center justify-content-center p-t-6 p-b-6\" ng-click=\"fnOpenCreateIssueTab()\"><svg width=\"20px\" height=\"20px\" class=\"custom-svg-side-menu-icon\"><use xlink:href=\"assets/images/svg/service/issue.svg#issue\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex p-t-15 query-editor-body\"><div class=\"col-sm-5 p-l-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 custom-sql-editor\"><div class=\"m-b-20 editorMedium\"><javascript-editor value=\"queryConfig.value\" available-defs=\"availableDataLibs\" editor-value=\"queryConfig.editorValue\" read-only=\"!isQuerySearchDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div><div class=\"col-sm-12 p-0 chart-schema\"><div class=\"col-sm-5 p-0 border-1px h-100 position-r\"><label class=\"m-0 custom-label\">SCHEMA</label><div class=\"col-sm-12 p-0 p-t-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"isQuerySearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-t-15 h-100 overflow-auto\" ng-if=\"!isQuerySearchDataLoading\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-repeat=\"headerObj in querySearchDataHeader\" ng-class=\"{ \'p-b-5\': !$last, \'opacity-5\': headerObj.isPlotted}\"><div class=\"col-sm-2 p-0 d-flex align-items-center\"><svg ng-if=\"headerObj.type === \'string\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"headerObj.type === \'number\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"headerObj.type === \'decimal\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"headerObj.type === \'boolean\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"headerObj.type === \'date\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"headerObj.type === \'object\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"headerObj.type === \'array\'\" class=\"custom-svg-side-menu-icon\" width=\"16px\" height=\"16px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-10 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><strong>{{headerObj.name}}</strong></label></div></div></div></div><div class=\"col-sm-7 p-r-0 h-100\"><div class=\"col-sm-12 p-0 border-1px h-100 position-r\"><label class=\"m-0 custom-label\">AXIS</label><div class=\"col-sm-12 p-0 p-t-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"isQuerySearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-t-15 h-100 overflow-auto floatingLabelInput\" ng-if=\"!isQuerySearchDataLoading\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-repeat=\"data in dataConfig track by $index\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"data.value\" typeahead-editable=\"true\" uib-typeahead=\"dataHeader for dataHeader in apiDataHeader | filter:$viewValue\" typeahead-on-select=\"fnDataConfigSelected()\" typeahead-min-length=\"0\" placeholder=\"Field{{data.isRequired ? \'*\' : \'\'}}\"> <span class=\"highlight\"></span> <label>{{data.key}}{{data.isRequired ? \'*\' : \'\'}}</label></div></div><div class=\"m-t-5\" style=\"width: 18px;\"><button ng-show=\"!data.isRequired\" class=\"btn btn-link p-r-0 p-l-0\" ng-click=\"fnRemoveMapping($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end p-b-10\" ng-if=\"isAllowMultiField\"><button class=\"btn btn-primary v4-primary-button pull-right\" ng-click=\"fnAddNewMapping()\"><i class=\"fa fa-plus m-r-5\"></i>Add New Mapping</button></div></div></div></div></div></div><div class=\"col-sm-7 p-15 h-100 border-1px overflow-auto\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"selectedChartType === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0 d-flex p-b-15\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0\"><strong>Selected Chart: {{selectedChart && selectedChart.chartConfiguration && selectedChart.chartConfiguration.chartType && selectedChart.chartConfiguration.chartType !== \'\' ? selectedChart.chartConfiguration.chartType : \'pie\' }}</strong></label></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><button ng-disabled=\"selectedChartType !== \'HIGHCHARTS\'\" ng-click=\"fnOpenHighchartModal()\" class=\"btn btn-primary btn-primary-cancel d-flex align-items-center m-r-15\"><i class=\"fa fa-edit m-r-5\"></i> Change Chart</button> <button ng-disabled=\"selectedChartType !== \'HIGHCHARTS\'\" ng-click=\"fnEditChartProperties()\" class=\"btn btn-primary btn-primary-cancel d-flex align-items-center\"><i class=\"fa fa-sliders m-r-5\"></i> Customize Chart</button></div></div><div class=\"col-sm-12 p-0 HighChartPie HighChartBarChart\" style=\"height: calc(100% - 50px)\"><div id=\"previewChart\" class=\"col-sm-12 p-0 previewChart width-inherit h-100\"></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"selectedChartType === \'RAWDATA\'\"><div class=\"col-sm-12 p-0\" ng-if=\"querySearchData.data.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in querySearchDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header.name}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in querySearchData.data\"><td ng-repeat=\"header in querySearchDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"fnGetTdStyle(data[header.name])\"><span class=\"ellipsis\" ng-if=\"fnGetType(data[header.name]) === \'string\'\">\'{{data[header.name]}}\'</span> <span class=\"ellipsis\" ng-if=\"fnGetType(data[header.name]) !== \'string\' && fnGetType(data[header.name]) !== \'object\'\">{{data[header.name]}}</span><json-formatter ng-if=\"fnGetType(data[header.name]) === \'object\' && fnGetType(data[header.name]) !== \'null\'\" json=\"data[header.name]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!querySearchData.data.length\">No records found...</div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"!isEditorDataLoading\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\" ng-if=\"querySearchData\"><strong>{{querySearchData.data.length}} rows in {{querySearchData.metadata.elapsedTimeInMs}}ms</strong></label></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"btn-group dropup col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-disabled=\"fnIsValidWidget()\" ng-click=\"fnOpenCreateWidgetModal()\">Create Widget</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"fa fa-caret-up\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-disabled=\"fnIsValidWidget()\" ng-click=\"fnOpenCreateChartModal()\"><a><span>Create Chart</span></a></li></ul></div></div></div></div></div>");
$templateCache.put("app/insight/insight_query_editor/modals/createChartModal/createChartModal.html","<div class=\"inmodal h-100\" ng-init=\"createChartModal.fnInitCreateChartModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Chart Configuration</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!createChartModal.isProjectCreateLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"createChartModal.isProjectCreateLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createChartModal.newChartObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"createChartModal.newChartObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createChartModal.isPredefinedQueryMatch\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createChartModal.changeProjectView\" ng-click=\"$event.stopPropagation();createChartModal.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createChartModal.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createChartModal.selectedProject.name\"><span>{{createChartModal.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createChartModal.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createChartModal.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createChartModal.selectedProject.name\">{{createChartModal.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createChartModal.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createChartModal.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createChartModal.projectSearch[createChartModal.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createChartModal.filterProject=(createChartModal.projectsArr | filter:createChartModal.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createChartModal.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createChartModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 h-100 d-flex\"><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary-cancel m-r-10\" ng-if=\"!createChartModal.isChartCreating\" ng-click=\"createChartModal.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createChartModal.newChartObj.name.length || !createChartModal.newChartObj.projectId.length\" ng-click=\"createChartModal.fnCreateQuery()\" ng-if=\"!createChartModal.isChartCreating\">Save Chart</button><div class=\"pull-right\" ng-if=\"createChartModal.isChartCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_query_editor/modals/createWidgetModal/createWidgetModal.html","<div class=\"inmodal h-100\" ng-init=\"createWidgetModal.fnInitCreateWidgetModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Widget Configuration</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!createWidgetModal.isProjectCreateLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"createWidgetModal.isProjectCreateLoaded\"><div class=\"row create-widget-modal\"><div class=\"bubble-wizard\"><div class=\"wizard\"><div class=\"wizard-inner\"><div class=\"connecting-line\"></div><ul class=\"nav nav-tabs d-flex\" role=\"tablist\"><li class=\"pointer-none\" ng-class=\"{\'active\': createWidgetModal.activeStep === 1}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step1\" role=\"tab\" title=\"Device Type\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"28px\" viewbox=\"0 0 512 512\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g transform=\"translate(0.000000,512.000000) scale(0.100000,-0.100000)\"><path d=\"M662 5109 c-247 -42 -471 -212 -582 -443 -82 -171 -75 23 -75 -2106 0 -2129 -7 -1935 75 -2106 79 -163 211 -295 374 -374 171 -82 -23 -75 2106 -75 2129 0 1935 -7 2106 75 163 79 295 211 374 374 82 171 75 -23 75 2106 0 2129 7 1935 -75 2106 -79 163 -211 296 -374 374 -170 82 28 74 -2076 76 -1051 1 -1898 -2 -1928 -7z m3760 -300 c226 -47 398 -259 398 -489 l0 -50 -2260 0 -2260 0 0 50 c0 225 164 433 383 486 71 17 3658 20 3739 3z m398 -2449 c0 -1136 -3 -1625 -11 -1662 -39 -187 -200 -348 -387 -387 -75 -16 -3649 -16 -3724 0 -187 39 -348 200 -387 387 -8 37 -11 526 -11 1662 l0 1610 2260 0 2260 0 0 -1610z\"></path><path d=\"M795 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M1195 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M1595 4685 c-157 -56 -116 -285 50 -285 82 0 136 51 143 136 3 42 0 60 -18 89 -37 60 -108 84 -175 60z\"></path><path d=\"M825 2925 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1519 0 c1322 0 1523 2 1548 15 119 62 97 238 -35 274 -28 8 -483 11 -1515 11 -1246 -1 -1481 -3 -1515 -15z\"></path><path d=\"M825 2325 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1250 0 c1217 0 1250 0 1281 19 93 58 90 200 -4 256 -35 20 -48 20 -1260 22 -1038 2 -1231 0 -1265 -12z\"></path><path d=\"M825 1725 c-49 -17 -80 -52 -96 -106 -11 -34 -10 -46 7 -87 12 -28 32 -55 53 -69 l34 -23 1394 0 c1311 0 1397 1 1425 18 94 55 93 201 -2 257 -35 20 -47 20 -1405 22 -1163 2 -1376 0 -1410 -12z\"></path></g></svg></span></a></li><li class=\"pointer-none\" ng-class=\"{\'active\': createWidgetModal.activeStep === 2}\"><a href=\"javascript:void(0);\" data-toggle=\"tab\" aria-controls=\"step2\" role=\"tab\" title=\"Gateway\"><span class=\"round-tab d-flex justify-content-center\"><svg width=\"25px\" viewbox=\"0 0 56 56\" class=\"d-flex justify-content-center custom-wizard-svg-icon\"><g><path d=\"M8,14c3.519,0,6.432-2.614,6.92-6H54c0.553,0,1-0.447,1-1s-0.447-1-1-1H14.92C14.432,2.614,11.519,0,8,0 C4.14,0,1,3.141,1,7S4.14,14,8,14z M8,2c2.757,0,5,2.243,5,5s-2.243,5-5,5S3,9.757,3,7S5.243,2,8,2z\"></path><path d=\"M48,42c-3.519,0-6.432,2.614-6.92,6H2c-0.552,0-1,0.447-1,1s0.448,1,1,1h39.08c0.488,3.386,3.401,6,6.92,6 c3.859,0,7-3.141,7-7S51.859,42,48,42z M48,54c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S50.757,54,48,54z\"></path><path d=\"M54,27H35.368c-0.396-3.602-3.455-6.414-7.161-6.414c-3.706,0-6.765,2.813-7.161,6.414H2c-0.552,0-1,0.447-1,1s0.448,1,1,1 h19.109c0.577,3.4,3.536,6,7.098,6c3.562,0,6.52-2.6,7.097-6H54c0.553,0,1-0.447,1-1S54.553,27,54,27z M28.207,33 C25.336,33,23,30.664,23,27.793s2.336-5.207,5.207-5.207s5.207,2.336,5.207,5.207S31.078,33,28.207,33z\"></path></g></svg></span></a></li></ul></div><div class=\"tab-content\"><div class=\"tab-pane\" ng-class=\"{\'active\' : createWidgetModal.activeStep === 1}\" role=\"tabpanel\" id=\"step2\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Widget Configuration</h3></div><div class=\"col-sm-12 p-0 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 m-t-20 p-0\"><div class=\"col-sm-12 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title!\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.widgetConfig.title\" placeholder=\"Title*\" name=\"title\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-30 customDropdown\" ng-if=\"!createWidgetModal.isPasteSVGCode\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" style=\"height: 43px;\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-bind-html=\"createWidgetModal.deliberatelyTrustDangerousSnippet(createWidgetModal.widgetConfig.icon)\"></span> <label class=\"titleLabel\">ICON*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"min-width: 250px;\"><li ng-repeat=\"svgObj in createWidgetModal.svgArr track by $index\" ng-mousedown=\"createWidgetModal.fnSelectIcon(svgObj)\"><a><span>{{svgObj.title}}</span> <span class=\"pull-right pull-right font-italic m-t-2\" ng-bind-html=\"createWidgetModal.deliberatelyTrustDangerousSnippet(svgObj.iconURL)\"></span></a></li></ul></div><button class=\"btn-link p-0\" style=\"position: absolute;right: 0;top: 43px;\" ng-click=\"createWidgetModal.fnEditSVGCode()\">Paste SVG code</button></div><div class=\"md-input m-b-20\" ng-if=\"createWidgetModal.isPasteSVGCode\"><input class=\"md-form-control\" required=\"\" id=\"icon1\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.widgetConfig.icon\" placeholder=\"Icon*\" name=\"icon\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonText\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.widgetConfig.buttonText\" placeholder=\"Button Text\" name=\"actionButtonText\"> <span class=\"highlight\"></span> <label>Button Text</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonLink\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.widgetConfig.buttonLink\" placeholder=\"Button Link\" name=\"actionButtonLink\"> <span class=\"highlight\"></span> <label>Button Link</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createWidgetModal.widgetConfig.target\">{{createWidgetModal.widgetConfig.target}}</span> <label class=\"titleLabel\">TARGET</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\"><a ng-click=\"createWidgetModal.widgetConfig.target = \'New Window\'\">New Window</a></li><li role=\"menuitem\"><a ng-click=\"createWidgetModal.widgetConfig.target = \'Same Window\'\">Same Window</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-15\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_export\" ng-model=\"createWidgetModal.widgetConfig.isExport\"> <label for=\"chk_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export</div></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"createWidgetModal.widgetConfig.isExport\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 font-italic opacity-5\">Chart export options</span> <label class=\"titleLabel\">Chart Export Options</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in createWidgetModal.widgetConfig.exportOptions track by $index\"><a class=\"d-flex align-items-center\" ng-click=\"$event.stopPropagation();exportOption.isAllow = !exportOption.isAllow\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"exportOption.isAllow\"></i></span> <span>{{exportOption.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-if=\"createWidgetModal.widgetConfig.isExport\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_tracker_export\" ng-model=\"createWidgetModal.widgetConfig.isTrackerExport\"> <label for=\"chk_tracker_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export To Tracker</div></div></form></div></div></div></div></div><div class=\"tab-pane\" ng-class=\"{\'active\' : createWidgetModal.activeStep === 2}\" role=\"tabpanel\" id=\"step3\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 title-border-bottom\"><h3 class=\"m-b-0\">Preview</h3></div><div class=\"col-sm-12 p-t-20 wizard-tab-height overflow-auto\"><div class=\"col-sm-12 p-0 floatingLabelInput m-t-10\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.newWidgetObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-30\"><input class=\"md-form-control\" required=\"\" id=\"Description\" type=\"text\" autocomplete=\"off\" ng-model=\"createWidgetModal.newWidgetObj.description\" placeholder=\"Description\" name=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createWidgetModal.isPredefinedQueryMatch\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!createWidgetModal.changeProjectView\" ng-click=\"$event.stopPropagation();createWidgetModal.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!createWidgetModal.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"createWidgetModal.selectedProject.name\"><span>{{createWidgetModal.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"createWidgetModal.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"createWidgetModal.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"createWidgetModal.selectedProject.name\">{{createWidgetModal.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!createWidgetModal.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"createWidgetModal.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"createWidgetModal.projectSearch[createWidgetModal.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in createWidgetModal.filterProject=(createWidgetModal.projectsArr | filter:createWidgetModal.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();createWidgetModal.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!createWidgetModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></form></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!createWidgetModal.widgetConfig.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!createWidgetModal.widgetConfig && !createWidgetModal.widgetConfig.icon && !createWidgetModal.widgetConfig.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"createWidgetModal.widgetConfig && createWidgetModal.widgetConfig.icon && createWidgetModal.widgetConfig.icon.length\" ng-bind-html=\"createWidgetModal.deliberatelyTrustDangerousSnippet(createWidgetModal.widgetConfig.icon)\"></div><label class=\"m-0 font-size-19\">{{createWidgetModal.widgetConfig.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"createWidgetModal.widgetConfig.isExport\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in createWidgetModal.widgetConfig.exportOptions track by $index\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"createWidgetModal.widgetConfig.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\" ng-if=\"createWidgetModal.activeStep === 2\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center\" ng-if=\"createWidgetModal.selectedChartObj.syntax === \'HIGHCHARTS\'\" style=\"height: 250px;width: 100%\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"createWidgetModal.selectedChartObj.definition.chartConfig\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'previewWidgetChart\'\" chart-data=\"createWidgetModal.selectedChartObj.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!createWidgetModal.selectedChartObj.definition.chartConfig\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0\" ng-if=\"createWidgetModal.selectedChartObj.syntax === \'RAWDATA\'\" style=\"height: 250px;width: 100%;overflow: auto\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in createWidgetModal.selectedRawData.headerData\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header.name}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in createWidgetModal.selectedRawData.bodyData\"><td ng-repeat=\"header in createWidgetModal.selectedRawData.headerData\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"createWidgetModal.fnGetTdStyle(data[header.name])\"><span class=\"ellipsis\" ng-if=\"createWidgetModal.fnGetType(data[header.name]) === \'string\'\">\'{{data[header.name]}}\'</span> <span class=\"ellipsis\" ng-if=\"createWidgetModal.fnGetType(data[header.name]) !== \'string\' && createWidgetModal.fnGetType(data[header.name]) !== \'object\'\">{{data[header.name]}}</span><json-formatter ng-if=\"createWidgetModal.fnGetType(data[header.name]) === \'object\' && createWidgetModal.fnGetType(data[header.name]) !== \'null\'\" json=\"data[header.name]\" open=\"0\"></json-formatter></td></tr></tbody></table></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button ng-if=\"createWidgetModal.widgetConfig.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{createWidgetModal.widgetConfig.buttonText}}</button></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 h-100 d-flex\"><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary-cancel m-r-10\" ng-if=\"!createWidgetModal.isWidgetCreating\" ng-click=\"createWidgetModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-left m-0\" ng-if=\"createWidgetModal.activeStep !== 1 && !createWidgetModal.isWidgetCreating\" ng-click=\"createWidgetModal.fnGotoPreviousNextStep(true)\">Back</button></div><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"createWidgetModal.activeStep === 1\" ng-disabled=\"!createWidgetModal.widgetConfig.title.length || !createWidgetModal.widgetConfig.icon.length\" ng-click=\"createWidgetModal.fnGotoPreviousNextStep()\">Next</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!createWidgetModal.newWidgetObj.name.length || !createWidgetModal.newWidgetObj.projectId.length\" ng-click=\"createWidgetModal.fnCreateQuery()\" ng-if=\"createWidgetModal.activeStep === 2 && !createWidgetModal.isWidgetCreating\">Save Widget</button><div class=\"pull-right\" ng-if=\"createWidgetModal.activeStep === 2 && createWidgetModal.isWidgetCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/insight/insight_query_editor/modals/highchartModal/highchartModal.html","<div class=\"inmodal h-100\" ng-init=\"highchartModal.fnInitHighchartModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Chart</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div id=\"chartEditor\" class=\"col-sm-12 p-0 chartEditor width-inherit height-100\"></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary-cancel\" ng-click=\"highchartModal.fnCancel()\">Close</button></div><div class=\"col-sm-6 d-flex justify-content-flex-end p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"highchartModal.fnInjectChart()\">Inject</button></div></div></div></div>");
$templateCache.put("app/insight/insight_query_editor/modals/queryListModal/queryListModal.html","<div class=\"inmodal h-100\" ng-init=\"queryListModal.fnInitQueryListModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Query</h3></div><div class=\"modal-body\" style=\"overflow-x: hidden;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"queryListModal.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{queryListModal.project.name ? queryListModal.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"queryListModal.querysProjectSearch[queryListModal.querysProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in queryListModal.filterProject=(queryListModal.projectsArr | filter:queryListModal.querysProjectSearch) track by $index\" ng-click=\"queryListModal.fnGetProjectQuerys(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === queryListModal.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!queryListModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"queryListModal.isRefreshData\" search-identifier=\"\'querysssearch\'\" filters-arr=\"queryListModal.searchFiltersArr\" filter-query=\"queryListModal.filterQuery\" fn-filter-query-change=\"queryListModal.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_queries\'\" no-set-url=\"true\" fn-resize=\"queryListModal.fnSetTableHeight()\" sort-field-arr=\"queryListModal.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"queryListModal.isQuerysLoading\" fn-resize=\"queryListModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"editor-query-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!queryListModal.isQuerysLoading\"><thead><tr><th ng-if=\"queryListModal.querysArr.length\" class=\"p-8\"></th><th ng-if=\"queryListModal.querysArr.length\">Name</th><th ng-if=\"queryListModal.querysArr.length\">Project</th><th ng-if=\"queryListModal.querysArr.length\"></th><th ng-if=\"queryListModal.querysArr.length\"></th><th ng-if=\"!queryListModal.querysArr.length\">No records found...</th></tr></thead><tbody id=\"querysTable\"><tr ng-repeat=\"querysObj in queryListModal.querysArr track by $index\" ng-click=\"querysObj.isCheck = !querysObj.isCheck;queryListModal.fnCheckUncheckHeader(querysObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"querysObj.isCheck\" ng-change=\"queryListModal.fnCheckUncheckHeader(querysObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{querysObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{querysObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{querysObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{querysObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"querysObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{querysObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{querysObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"querysObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{querysObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{querysObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"querysObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{querysObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{querysObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"querysObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{querysObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!queryListModal.isQuerysLoading && queryListModal.querysArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{queryListModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"queryListModal.perPage = 10; queryListModal.fnPageChanged(queryListModal.currentPage, queryListModal.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"queryListModal.perPage = 20; queryListModal.fnPageChanged(queryListModal.currentPage, queryListModal.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"queryListModal.perPage = 50; queryListModal.fnPageChanged(queryListModal.currentPage, queryListModal.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"queryListModal.perPage = 100; queryListModal.fnPageChanged(queryListModal.currentPage,queryListModal.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"queryListModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"queryListModal.currentPage\" items-per-page=\"queryListModal.perPage\" max-size=\"queryListModal.maxSize\" boundary-links=\"true\" ng-click=\"queryListModal.fnPageChanged(queryListModal.currentPage, queryListModal.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 h-100 d-flex\"><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center\"><button type=\"button\" class=\"btn btn-primary-cancel m-r-10\" ng-click=\"queryListModal.fnCancel()\">Close</button></div><div class=\"col-sm-6 p-0 h-100 d-flex align-items-center justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!queryListModal.isQueryObjSelected()\" ng-click=\"queryListModal.fnInjectQuery()\">Inject Query</button></div></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isWidgetDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isWidgetDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isWidgetDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_CHART\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteWidget(widgetObj)\" ng-if=\"userPermissionsObj.DELETE_CHART\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isWidgetDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"widgetForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"widgetObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"widgetObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!widgetObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateWidgetDetails(widgetObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{widgetObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(widgetObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/components/directives/ngQueryBuilderNode/queryBuilderModal/queryBuilderModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Functions</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div ng-if=\"!qbModal.isFunctionSelected\" id=\"functionModal\"><div class=\"col-sm-6\" ng-repeat=\"obj in qbModal.functionsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"qbModal.fnInject(obj)\" ng-disabled=\"obj.isDisable\">Inject</button></div><h3 class=\"m-t-9\"><span>{{obj.name}}</span></h3></div><div class=\"panel-body\" style=\"height: 170px;\"><span>{{obj.description}}</span></div></div></div></div><div class=\"floatingLabelInput\" ng-if=\"qbModal.isFunctionSelected\"><div ng-if=\"qbModal.functionType !== \'\'\"><span><h3>{{qbModal.functionType}}</h3></span></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"qbModal.functionType === \'ghost(...)\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" id=\"category\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"categoryType for categoryType in qbModal.categoryArr\" typeahead-min-length=\"0\" typeahead-open-on-focus=\"\" typeahead-on-select=\"qbModal.fnCategorySelected(qbModal.selectedCategory)\" ng-model=\"qbModal.selectedCategory\" placeholder=\"Select a category*\"> <span class=\"highlight\"></span> <label>Select a category*</label> <small class=\"helper-text\"></small></div><div ng-if=\"qbModal.selectedCategory.length\"><div ng-if=\"qbModal.selectedCategory === \'COMPONENT\'\"><div ng-if=\"!qbModal.isOptionsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"qbModal.isOptionsLoaded\"><div class=\"md-input m-b-20 roleActions\" ng-class=\"qbModal.selectedDevice.name.length?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" id=\"devices\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"devices as devices.id for devices in qbModal.devicesArr\" typeahead-min-length=\"0\" typeahead-open-on-focus=\"\" typeahead-template-url=\"typeAheadTemplate.html\" typeahead-on-select=\"qbModal.fnDeviceSelected(qbModal.selectedDevice.id)\" ng-model=\"qbModal.selectedDevice\" placeholder=\"Select a Device*\"> <span class=\"highlight\"></span> <label>Select a Device*</label> <small class=\"helper-text\">{{qbModal.selectedDevice.name}}</small></div></div><div ng-if=\"!qbModal.isComponentsLoaded && qbModal.isDeviceSelected\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"qbModal.isComponentsLoaded && qbModal.isDeviceSelected\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" id=\"options\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"options as options.id for options in qbModal.optionsArr\" typeahead-min-length=\"0\" typeahead-open-on-focus=\"\" typeahead-template-url=\"typeAheadTemplate.html\" typeahead-on-select=\"qbModal.fnOptionSelected(qbModal.selectedCategory, qbModal.selectedOption.id)\" ng-model=\"qbModal.selectedOption\" placeholder=\"Select ID*\"> <span class=\"highlight\"></span> <label>Select an ID*</label> <small class=\"helper-text\">{{qbModal.selectedOption.name}}</small></div></div></div><div ng-if=\"qbModal.selectedCategory !== \'COMPONENT\'\"><div ng-if=\"!qbModal.isOptionsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"qbModal.isOptionsLoaded\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" id=\"options1\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"options as options.id for options in qbModal.optionsArr\" typeahead-min-length=\"0\" typeahead-open-on-focus=\"\" typeahead-template-url=\"typeAheadTemplate.html\" typeahead-on-select=\"qbModal.fnOptionSelected(qbModal.selectedCategory, qbModal.selectedOption.id)\" ng-model=\"qbModal.selectedOption\" placeholder=\"Select ID*\"> <span class=\"highlight\"></span> <label>Select an ID*</label> <small class=\"helper-text\">{{qbModal.selectedOption.name}}</small></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"qbModal.functionType !== \'ghost(...)\'\"><div class=\"md-input m-b-20 roleActions\" ng-if=\"qbModal.functionType !== \'Matches()\'\"><input class=\"md-form-control\" type=\"text\" required=\"\" typeahead-editable=\"false\" uib-typeahead=\"timeZone for timeZone in qbModal.timeZoneArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-on-select=\"qbModal.fnTimeZoneSelected(qbModal.selectedTimeZone)\" ng-model=\"qbModal.selectedTimeZone\" placeholder=\"Time Zone*\"> <span class=\"highlight\"></span> <label>Time Zone*</label> <small class=\"helper-text\">Select a Time Zone</small></div><div class=\"col-sm-12 p-0\" ng-if=\"qbModal.functionType === \'Matches()\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" type=\"text\" required=\"\" ng-model=\"qbModal.regularExpression\" placeholder=\"Regular Expression*\"> <span class=\"highlight\"></span> <label>Regular Expression*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><span><h3>Regular Expression Test</h3></span></div><div class=\"col-sm-12 p-0\" ng-repeat=\"inputObj in qbModal.regularExpressionTestArr track by $index\"><div class=\"col-sm-11\"><div class=\"md-input\" ng-class=\"$last ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" type=\"text\" required=\"\" ng-model=\"inputObj.inputValue\" ng-change=\"qbModal.fnTestRegularExpression(inputObj)\" placeholder=\"Test Field Name\"> <span class=\"highlight\"></span> <label>Test Field Name</label> <small class=\"helper-text w100\" ng-if=\"$last\"><a class=\"btn btn-link p-0 pull-right\" ng-click=\"qbModal.fnAddRegularExpressionInput()\">Add Test Field</a></small> <span class=\"regularExpressionTest\"><i class=\"fa\" ng-class=\"inputObj.isValid ?\'checkiconClass fa-check\':\'timesiconClass fa-times\'\"></i></span></div></div><div class=\"col-sm-1\"><a class=\"btn btn-link p-0 m-l-16 m-t-10\" ng-if=\"$index !== 0\" ng-click=\"qbModal.fnRemoveRegularExpressionInput($index)\"><i class=\"fa fa-times m-r-5\"></i></a></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"qbModal.isGettingGhostValues\"></div><button type=\"button\" ng-if=\"qbModal.isFunctionSelected\" class=\"btn btn-link pull-left\" ng-click=\"qbModal.fnBackToFunctions()\">Back</button> <button ng-if=\"!qbModal.isGettingGhostValues\" type=\"button\" class=\"btn btn-primary\" ng-click=\"qbModal.fnCancel()\">Cancel</button> <button ng-if=\"!qbModal.isSearchActivated ? !qbModal.isGettingGhostValues && qbModal.isFunctionSelected : !qbModal.isGettingGhostValues && qbModal.selectedOption && qbModal.isFunctionSelected\" type=\"button\" class=\"btn btn-primary\" ng-click=\"qbModal.fnClose()\">Inject</button></div></div><script type=\"text/ng-template\" id=\"typeAheadTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <span ng-if=\"match.model.name\" ng-bind-html=\"match.model.name\"></span><br ng-if=\"match.model.name\"> <small ng-bind-html=\"match.model.id\"></small> </div> </a></script>");
$templateCache.put("app/components/directives/schemaDirective/vaultsGridModal/vaultsGridModal.html","<div class=\"inmodal h-100\" ng-init=\"vaultsModal.fnInitModel()\"><div class=\"modal-header\" id=\"vaultHeader\"><strong class=\"inline-display p-t-8\">Select Vault</strong></div><div class=\"modal-body\"><div class=\"row\" id=\"functionModal\"><div class=\"col-sm-12 floatingLabelInput d-flex vaultSearchDiv\"><div class=\"md-input m-b-13 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" placeholder=\"Search for vault\" ng-model=\"vaultsModal.search\" ng-change=\"vaultsModal.fnVaultsFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div><div class=\"col-sm-12\" ng-if=\"vaultsModal.isVaultsFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 vaultModelDiv\" style=\"overflow-y: auto;\" ng-if=\"!vaultsModal.isVaultsFilter\"><div class=\"col-sm-6\" ng-repeat=\"value in vaultsModal.vaultsArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{value.name}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{value.name}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vaultsModal.fnSelectVault(value)\">Select</button></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\" style=\"height: 25px;\"><span class=\"ellipsis\">{{value.description !==\'\'?value.description:\' \'}}</span></div></div></div></div></div></div></div><div class=\"modal-footer\" id=\"vaultFooter\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-click=\"vaultsModal.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/node/alarmHistory/alarmHistoryInfo/alarmHistorySteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetails()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isAlarmDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isAlarmDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></div></div><div class=\"col-sm-12 floatingLabelInput pace\" ng-if=\"isAlarmDetailsLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"alarmObj.name\" placeholder=\"Name for the Alarm\"> <span class=\"highlight\"></span> <label>Name</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"alarmObj.description\" placeholder=\"Description for the Alarm\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"mode\" type=\"text\" ng-model=\"alarmObj.mode\" placeholder=\"Mode of the Alarm\"> <span class=\"highlight\"></span> <label>Mode</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"ecuName\" type=\"text\" ng-model=\"ecuName\" placeholder=\"Name of the Ecu\"> <span class=\"highlight\"></span> <label>Ecu Name</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"nodeName\" type=\"text\" ng-model=\"nodeName\" placeholder=\"Name of the Node\"> <span class=\"highlight\"></span> <label>Node Name</label></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/alarms/alarmInfo/alarmSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetails()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isAlarmDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isAlarmDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></div></div><div class=\"col-sm-12 floatingLabelInput pace\" ng-if=\"isAlarmDetailsLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"alarmObj.name\" placeholder=\"Name for the Alarm\"> <span class=\"highlight\"></span> <label>Name</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"alarmObj.description\" placeholder=\"Description for the Alarm\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"mode\" type=\"text\" ng-model=\"alarmObj.mode\" placeholder=\"Mode of the Alarm\"> <span class=\"highlight\"></span> <label>Mode</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"ecuName\" type=\"text\" ng-model=\"ecuName\" placeholder=\"Name of the Ecu\"> <span class=\"highlight\"></span> <label>Ecu Name</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"nodeName\" type=\"text\" ng-model=\"nodeName\" placeholder=\"Name of the Node\"> <span class=\"highlight\"></span> <label>Node Name</label></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/alarms/modal/attributeSyncModal/attributeSyncModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeSyncModal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\" ng-if=\"attributeSyncModal.ecuDetailsLoading\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex align-items-center p-0 p-t-5\"><h2 class=\"m-0 font-bold\">Fetching ECU Details...</h2></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 w100 h-100 d-flex align-items-center justify-content-center p-0 p-t-15\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div></div></div><div class=\"user-header m-l-0 w100\" ng-if=\"!attributeSyncModal.ecuDetailsLoading\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Synchronizing Attribute</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Synchronizing Attribute you can watch it here in real-time. Closing this window will have no effect on the Synchronizing.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"attributeSyncModal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in attributeSyncModal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"attributeSyncModal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"attributeSyncModal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"attributeSyncModal.jobSummary\" ui-codemirror-opts=\"attributeSyncModal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"attributeSyncModal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/alarms/modal/attributeGraphModal/attributeGraphModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeGraph.fnInitAttributeGraphModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Node Graph</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"attributeGraph.isNodeLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!attributeGraph.isNodeLoading\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-4 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{attributeGraph.selectedGraphObj.displayName}}</span> <label class=\"titleLabel\">Node</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"options in attributeGraph.graphOptionsArr\"><a ng-click=\"attributeGraph.selectedGraphObj = options;attributeGraph.fnRenderGraph(options)\"><span>{{options.displayName}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\" style=\"height: calc(100% - 50px)\" id=\"mermaidGraphParent\"><div id=\"mermaidGraph\" class=\"mermaid\" ng-if=\"attributeGraph.isShowMermaid && attributeGraph.finalMermaidString.length\">{{attributeGraph.finalMermaidString}}</div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"attributeGraph.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!attributeGraph.finalMermaidString.length\" ng-click=\"attributeGraph.fnInject()\" tabindex=\"12\">Inject</button></div></div></div></div>");
$templateCache.put("app/node/alarms/modal/attributeTelemetryModal/attributeTelemetryModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeTelemetry.fnInitAttributeTelemetryModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Attribute Telemetry</h3></div><div class=\"modal-body node-attributes-tab\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-7 p-0 d-flex align-items-center h-50px\"><div class=\"col-sm-12 h-100 m-r-15 border-1px d-flex align-items-center justify-content-center W-50\" ng-click=\"attributeTelemetry.selectedChartType = \'spline\'; attributeTelemetry.fnRenderChart()\"><svg ng-class=\"attributeTelemetry.selectedChartType === \'spline\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"col-sm-12 h-100 m-r-15 border-1px d-flex align-items-center justify-content-center W-50\" ng-click=\"attributeTelemetry.selectedChartType = \'pie\'; attributeTelemetry.selectedPieChartData = attributeTelemetry.selectedChartData[0];attributeTelemetry.fnRenderChart()\"><svg ng-class=\"attributeTelemetry.selectedChartType === \'pie\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/pie-chart.svg#pie-chart\"></use></svg></div><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center justify-content-center W-50\" ng-click=\"attributeTelemetry.selectedChartType = \'heatmap\';attributeTelemetry.selectedHeatmapChartAttr = attributeTelemetry.heatmapChartAttributeList[0] ;attributeTelemetry.fnRenderChart()\"><svg ng-class=\"attributeTelemetry.selectedChartType === \'heatmap\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/heatmap-chart.svg#heatmap-chart\"></use></svg></div></div><div class=\"col-sm-5 p-r-0 h-50px node-attribute-date-range\"><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"attributeTelemetry.fnOpenData()\"><span class=\"m-0\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"col-sm-12 p-0 m-t-15 border-1px chart-container-height\"><div class=\"d-flex align-items-center justify-content-center h-100 w100\" ng-if=\"attributeTelemetry.isChartDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div style=\"height: 100%;width: 100%\" ng-if=\"!attributeTelemetry.isChartDataLoading && attributeTelemetry.selectedChartType !== \'heatmap\'\" class=\"test-vega\" id=\"test-vega\"></div><div class=\"col-sm-12 p-0 w100 h-100\" ng-if=\"attributeTelemetry.selectedChartType === \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end p-r-10 p-t-10 customDropdown\"><div class=\"d-flex align-items-center m-r-15\" style=\"width: 20%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{attributeTelemetry.selectedYAxis.title}}</span> <label class=\"titleLabel\">Y AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in attributeTelemetry.axisArr track by $index\"><a ng-click=\"attributeTelemetry.selectedYAxis = axisObj;attributeTelemetry.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center m-r-15\" style=\"width: 20%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{attributeTelemetry.selectedXAxis.title}}</span> <label class=\"titleLabel\">X AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in attributeTelemetry.axisArr track by $index\"><a ng-click=\"attributeTelemetry.selectedXAxis = axisObj;attributeTelemetry.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 20%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{attributeTelemetry.selectedMathFunction}}</span> <label class=\"titleLabel\">Math Function</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mathFunctionObj in attributeTelemetry.mathFunction track by $index\"><a ng-click=\"attributeTelemetry.selectedMathFunction = mathFunctionObj.title;attributeTelemetry.fnRenderChart()\"><span>{{mathFunctionObj.title}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\"><div id=\"nodeAttributeHeatmapChart\" class=\"nodeAttributeChart h-100 w100\" ng-if=\"!attributeTelemetry.isHeatmapChartDataLoading\"></div><div class=\"d-flex align-items-center justify-content-center h-100 w100\" ng-if=\"attributeTelemetry.isHeatmapChartDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"attributeTelemetry.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"attributeTelemetry.fnInject()\" tabindex=\"12\">Inject</button></div></div></div></div>");
$templateCache.put("app/node/alarms/modal/issueListModal/issueListModal.html","<div class=\"inmodal h-100\" ng-init=\"issueList.fnInitLinkIssueModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Issues List</h3></div><div class=\"modal-body\" style=\"overflow-x: hidden;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"issueList.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{issueList.project.name ? issueList.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"issueList.issueProjectSearch[issueList.issueProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in issueList.filterProject=(issueList.projectsArr | filter:issueList.issueProjectSearch) track by $index\" ng-click=\"issueList.fnGetProjectIssue(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === issueList.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!issueList.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"issueList.isRefreshData\" search-identifier=\"\'issueSearch\'\" filters-arr=\"issueList.searchFiltersArr\" filter-query=\"issueList.filterQuery\" fn-filter-query-change=\"issueList.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.issue\'\" fn-resize=\"issueList.fnSetTableHeight()\" is-column-view=\"issueList.isColumnView\" no-set-url=\"true\" sort-field-arr=\"issueList.sortFieldArr\" default-tag-arr=\"issueList.defaultFilterArr\"></v4-search-client></div></div><div class=\"row\" ng-if=\"issueList.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"issueList.isIssuesLoading\" fn-resize=\"issueList.fnSetLoaderTableHeight()\"></table-loader><div class=\"issue-table table-container issue-table-grid\"><table id=\"issuesTable\" class=\"table table-striped table-check-box\" ng-if=\"!issueList.isIssuesLoading\"><thead><tr><th ng-if=\"issueList.issuesArr.length\"></th><th ng-if=\"issueList.issuesArr.length\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\"></div><div class=\"table-col-2\"></div><div class=\"table-col-3\"><label class=\"m-b-0\"></label></div></div></th><th ng-if=\"issueList.issuesArr.length\"></th><th ng-if=\"!issueList.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"issueTable\"><tr ng-repeat=\"issueObj in issueList.issuesArr track by $index\" ng-click=\"issueObj.isCheck = !issueObj.isCheck;issueList.fnCheckUncheckCheckbox(issueObj);\" context-menu=\"issueList.issueContextMenu(issueObj)\"><td ng-class=\"issueObj.state !== \'CLOSED\' ? issueObj.isRead ? \'\' : \'issueReadUnreadBGColor\' :\'\'\"></td><td ng-if=\"!issueObj.isEditable\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-8 table-col-1\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"issueObj.isCheck\" ng-change=\"issueList.fnCheckUncheckCheckbox(issueObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></div><div class=\"table-col-2\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false && issueObj.resolved === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate && issueObj.resolved === false\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div><div class=\"table-col-3\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div><div class=\"table-col-4\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div uib-tooltip=\"State\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"issueList.fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div><div class=\"d-flex m-t-5\"><div uib-tooltip=\"Priorities\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"issueList.fnGetIssuesLabelColor(issueObj.issuePriority)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div></div><div class=\"table-col-5\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-if=\"issueObj.issueLabels\" ng-repeat=\"label in issueObj.issueLabels\" ng-style=\"issueList.fnGetIssuesLabelColor(label)\"><span>{{label.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"width-25px\" uib-tooltip=\"Assignees\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"ellipsis width-100-25px p-t-2\"><span ng-repeat=\"user in issueObj.assignees\">{{user.firstName+ \" \" + user.lastName}}{{!$last ? \', \': \'\'}}</span></div></div></div></div><div class=\"attributeTdCSS-style table-col-6\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Opened \'+issueObj.createdDate + \' by \'+ issueObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.createdAt\"><label class=\"ellipsis m-b-0\">Opened {{issueObj.createdDate}} by {{issueObj.createdBy}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'updated \' + issueObj.updatedDate + \' by \'+ issueObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.updatedAt\"><span class=\"ellipsis\">Updated {{issueObj.updatedDate}} by {{issueObj.updatedBy}}</span></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Resolved \' + issueObj.resolvedDate + \' by \'+ issueObj.resolvedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.resolved === true\"><span class=\"ellipsis\">Resolved {{issueObj.resolvedDate}} by {{issueObj.resolvedBy}}</span></div></div><div class=\"table-col-7\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Type\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"issueList.fnGetIssuesLabelColor(issueObj.issueType)\"><span>{{issueObj.issueType.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"d-flex m-r-5\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{issueObj.project.name}}</label></div></div></div></div><div class=\"table-col-8\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Comments\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.publicCommentIds.length ? issueObj.publicCommentIds.length : 0}}</span></div></div><div class=\"d-flex m-t-5\" ng-class=\"issueObj.isVoteUpdating ? \'pace opacity-5\' : \'\'\"><div class=\"width-25px\"><svg class=\"custom-svg-side-menu-icon m-r-10\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" ng-click=\"$event.stopPropagation();issueList.fnAddUpDownVoteToIssue(true, issueObj)\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.voteCount ? issueObj.voteCount : 0}}</span></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-1\" ng-click=\"$event.stopPropagation();issueList.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\"><label class=\"ellipsis m-b-0 label_name\" uib-tooltip=\"{{issueObj.psuedoId}}\" ng-click=\"$event.stopPropagation();issueList.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\" tooltip-placement=\"auto\">{{issueObj.psuedoId}}</label></div><div class=\"position-r\" style=\"width: 95%;\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false && issueObj.resolved === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\" style=\"width: 100%\"><div class=\"progress w100 m-b-0\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate && issueObj.resolved === false\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && issueObj.isResolvedAtTime\"><svg class=\"svg-fill-green m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/check.svg#check\"></use></svg><div>This issue was resolved in time.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && !issueObj.isResolvedAtTime\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue was not resolved in time.</div></div></div></div></div></td><td class=\"text-center\" ng-if=\"!issueObj.isEditable\"><div uib-tooltip=\"Issue Resolved\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-if=\"issueObj.resolved === true\" width=\"25px\" height=\"25px\"><use xlink:href=\"assets/images/svg/service/lightbulb.svg#lightbulb\"></use></svg></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!issueList.isIssuesLoading && issueList.issuesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{issueList.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"issueList.perPage = 10; issueList.fnPageChanged(issueList.currentPage, issueList.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"issueList.perPage = 20; issueList.fnPageChanged(issueList.currentPage, issueList.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"issueList.perPage = 50; issueList.fnPageChanged(issueList.currentPage, issueList.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"issueList.perPage = 100; issueList.fnPageChanged(issueList.currentPage,issueList.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"issueList.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"issueList.currentPage\" items-per-page=\"issueList.perPage\" max-size=\"issueList.maxSize\" boundary-links=\"true\" ng-click=\"issueList.fnPageChanged(issueList.currentPage, issueList.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!issueList.isIssueAdding\" ng-click=\"issueList.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!issueList.isIssueAdding\" ng-disabled=\"!issueList.isIssueObjSelected()\" ng-click=\"issueList.fnAddIssue()\" tabindex=\"12\">Add</button><div class=\"pull-right\" ng-if=\"issueList.isIssueAdding\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div>");
$templateCache.put("app/node/alarms/modal/linkIssueModal/linkIssueModal.html","<div class=\"inmodal h-100\" ng-init=\"linkIssue.fnInitLinkIssueModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{linkIssue.selectedAttribute.name}} Issues</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"linkIssue.isIssueDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"alarms-issue-table table-container col-sm-12 p-0 h-100 issue-table-grid\" ng-if=\"!linkIssue.isIssueDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"linkIssue.issuesArr.length\"><thead><tr><th ng-if=\"linkIssue.issuesArr.length\">Name</th><th ng-if=\"linkIssue.issuesArr.length\"></th><th ng-if=\"!linkIssue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"alarmIssueTable\"><tr ng-repeat=\"issueObj in linkIssue.issuesArr track by $index\"><td ng-if=\"!issueObj.isEditable\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"table-col-2\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false && issueObj.resolved === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate && issueObj.resolved === false\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div><div class=\"table-col-3\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div><div class=\"table-col-4\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div uib-tooltip=\"State\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"linkIssue.fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div><div class=\"d-flex m-t-5\"><div uib-tooltip=\"Priorities\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"linkIssue.fnGetIssuesLabelColor(issueObj.issuePriority)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div></div><div class=\"table-col-5\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Labels\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-if=\"issueObj.issueLabels\" ng-repeat=\"label in issueObj.issueLabels\" ng-style=\"linkIssue.fnGetIssuesLabelColor(label)\"><span>{{label.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"width-25px\" uib-tooltip=\"Assignees\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"ellipsis width-100-25px p-t-2\"><span ng-repeat=\"user in issueObj.assignees\">{{user.firstName+ \" \" + user.lastName}}{{!$last ? \', \': \'\'}}</span></div></div></div></div><div class=\"attributeTdCSS-style table-col-6\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Opened \'+issueObj.createdDate + \' by \'+ issueObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.createdAt\"><label class=\"ellipsis m-b-0\">Opened {{issueObj.createdDate}} by {{issueObj.createdBy}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'updated \' + issueObj.updatedDate + \' by \'+ issueObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.updatedAt\"><span class=\"ellipsis\">Updated {{issueObj.updatedDate}} by {{issueObj.updatedBy}}</span></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{\'Resolved \' + issueObj.resolvedDate + \' by \'+ issueObj.resolvedBy}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.resolved === true\"><span class=\"ellipsis\">Resolved {{issueObj.resolvedDate}} by {{issueObj.resolvedBy}}</span></div></div><div class=\"table-col-7\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Type\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"linkIssue.fnGetIssuesLabelColor(issueObj.issueType)\"><span>{{issueObj.issueType.name}}</span></button></div></div><div class=\"d-flex m-t-5\"><div class=\"d-flex m-r-5\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{issueObj.project.name}}</label></div></div></div></div><div class=\"table-col-8\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"d-flex m-b-5\"><div class=\"width-25px\" uib-tooltip=\"Comments\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.publicCommentIds.length ? issueObj.publicCommentIds.length : 0}}</span></div></div><div class=\"d-flex m-t-5\" ng-class=\"issueObj.isVoteUpdating ? \'pace opacity-5\' : \'\'\"><div class=\"width-25px\"><svg class=\"custom-svg-side-menu-icon m-r-10\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" ng-click=\"$event.stopPropagation();\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.voteCount ? issueObj.voteCount : 0}}</span></div></div></div></div></div><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-l-8 table-col-2\" ng-click=\"$event.stopPropagation();linkIssue.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\"><label class=\"ellipsis m-b-0 label_name\" uib-tooltip=\"{{issueObj.psuedoId}}\" ng-click=\"$event.stopPropagation();linkIssue.fnCopyInfoToClipboard(issueObj.id, \'Issue ID\')\" tooltip-placement=\"auto\">{{issueObj.psuedoId}}</label></div><div class=\"position-r\" style=\"width: 93%;\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false && issueObj.resolved === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\" style=\"width: 100%\"><div class=\"progress w100 m-b-0\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate && issueObj.resolved === false\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && issueObj.isResolvedAtTime\"><svg class=\"svg-fill-green m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/check.svg#check\"></use></svg><div>This issue was resolved in time.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && !issueObj.isResolvedAtTime\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue was not resolved in time.</div></div></div></div></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"linkIssue.fnOpenIssueInfo(issueObj)\">View issue</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"linkIssue.fnOpenIssueInNewTab(issueObj)\"><a><span>View issue in new tab</span></a></li></ul></div></td></tr></tbody></table></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"linkIssue.fnCancel()\" tabindex=\"12\">Close</button></div></div></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitCluster()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isClusterDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isClusterDetailsLoaded\" ng-class=\"!clusterPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"clusterObj.name\" placeholder=\"Name for the new Cluster*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"clusterObj.description\" placeholder=\"Description regarding Cluster\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateClusterDetails(clusterObj)\">Save</button></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{clusterObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(clusterObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"clusterPermissionsObj.Delete && isClusterDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"clusterPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"clusterPermissionsObj.Delete\" ng-click=\"fnDeleteCluster(clusterObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/node/alarms/modal/metaInfoModal/metaInfoModal.html","<div class=\"inmodal h-100\" ng-init=\"metaInfoModal.fnInitMetaInfoModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Meta Information</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-4 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{metaInfoModal.selectedMetaOptions.title}}</span> <label class=\"titleLabel\">Metadata</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"options in metaInfoModal.metaDataOptionArr\" ng-if=\"options.isShow\"><a ng-click=\"metaInfoModal.selectedMetaOptions = options; metaInfoModal.isTableDataLoading = true; metaInfoModal.fnGetMetaInformation();\"><span>{{options.title}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 m-t-5 overflow-auto metadata-table\" style=\"height: calc(100% - 55px)\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"metaInfoModal.isTableDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!metaInfoModal.isTableDataLoading\"><h2>{{metaInfoModal.tableData.title}}</h2><table class=\"w100\"><tbody><tr ng-repeat=\"headerObj in metaInfoModal.tableData.headerArr\"><td ng-style=\"headerObj.name === \'tags\' ? {\'vertical-align\' : \'middle\'} : \'\'\"><b>{{headerObj.displayName}}</b></td><td ng-if=\"headerObj.name !== \'tags\'\">{{metaInfoModal.tableData.bodyObj[headerObj.name]}}</td><td ng-if=\"headerObj.name === \'tags\'\"><table class=\"w100\"><tr ng-repeat=\"(key,value) in metaInfoModal.tableData.bodyObj[headerObj.name]\"><td><b>{{key}}</b></td><td>{{value}}</td></tr></table></td></tr></tbody></table><div class=\"col-sm-12 p-0\" style=\"visibility: hidden;height: 0 !important; width: 0 !important;\" id=\"nodeLocationMap\"></div><div class=\"col-sm-12 p-0 d-flex flex-column\"><div class=\"col-sm-12 p-0 m-t-10 d-flex align-items-center\" ng-if=\"metaInfoModal.isShowMap\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"metaInfoModal.isLocationData\"> <label for=\"checkAll\" class=\"check-box\"></label> <label class=\"m-0 m-l-10\"><strong>Location Data</strong></label></div><div class=\"col-sm-12 p-0 m-t-10\" ng-show=\"metaInfoModal.isLocationData\"><div id=\"map-image\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!metaInfoModal.isImageUploading\" ng-click=\"metaInfoModal.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!metaInfoModal.isImageUploading\" ng-disabled=\"!metaInfoModal.tableMDString.length\" ng-click=\"metaInfoModal.fnInject()\" tabindex=\"12\">Inject</button><div class=\"m-t-5 pull-right\" ng-if=\"metaInfoModal.isImageUploading\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/cluster/modals/elementList/elementListModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Add Devices</strong></div><div class=\"modal-body\" id=\"ele\"><div class=\"row\" ng-init=\"elemList.fnInitModel()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div style=\"overflow: hidden\"><div ng-if=\"!elemList.isObjectSelect\" class=\"device-list-model-input\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\" ng-if=\"elemList.devicePermissionObj.List\" style=\"width: calc(100% - 25px)\" node-search-directive-v4=\"\" device-filters=\"elemList.deviceFilter\" field-arr=\"elemList.searchFieldArr\" filter-query=\"elemList.filterQuery\" state-name=\"\'main.device\'\" fn-filter-query-change=\"elemList.fnFilterQueryChanged(filterQuery,sortQuery,isCalledDirective,isCalledFromInit)\" is-called-for-view-visualizer=\"true\" types-arr=\"elemList.deviceTypesArr\" gateways-arr=\"elemList.gatewaysArr\" no-set-url=\"true\" is-search-result-loaded=\"elemList.isDeviceSearchDataLoaded\" fn-resize=\"elemList.fnSetTableHeight()\"></div></div><div class=\"row\" ng-if=\"elemList.devicePermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"elemList.isDevicesLoading\" hide-circle=\"true\" fn-resize=\"elemList.fnSetLoaderTableHeight()\"></table-loader><div class=\"devices-table table-container\"><table class=\"deviceMainTable table table-striped table-check-box\" id=\"devicesElementTable\" ng-show=\"!elemList.isDevicesLoading\"><thead><tr><th ng-if=\"elemList.devicesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"elemList.isAllChecked\" ng-click=\"elemList.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"elemList.devicesArr.length\"></th><th ng-if=\"elemList.devicesArr.length\">Name</th><th ng-if=\"!elemList.devicesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"deviceObj in elemList.devicesArr track by $index\" ng-click=\"elemList.fnGetDevice(deviceObj, elemList.devicesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"deviceObj.isCheck\" ng-change=\"elemList.fnCheckUncheckHeader(deviceObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\" aria-hidden=\"false\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{deviceObj.connection === \'CONNECTED\' ?\'CONNECTED\':\'DISCONNECTED\'}}\" tooltip-placement=\"auto\" ng-style=\"elemList.fnGetGatewayConnectionIconColor(deviceObj.connection)\"><span ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" class=\"device-disconnected\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-show=\"!deviceObj.isEditable\"><span class=\"deviceHasComponents\" ng-if=\"deviceObj.hasComponents\" uib-tooltip=\"This device has components\" tooltip-placement=\"auto\" style=\"display: inline-block;height: 16px;width: 16px;\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 512 512\" style=\"enable-background:new 0 0 512 512;\" xml:space=\"preserve\"><g><g><path d=\"M128,213.334c-11.797-0.001-21.333,9.557-21.333,21.333v42.667c0,11.776,9.536,21.333,21.333,21.333 s21.333-9.557,21.333-21.333v-42.667C149.333,222.891,139.797,213.334,128,213.334z\"></path></g></g><g><g><path d=\"M207.083,326.25c-8.342-8.341-21.824-8.341-30.166,0.001l-29.056,29.056c-3.029-8.107-10.688-13.973-19.861-13.973 c-9.173,0-16.832,5.867-19.84,13.973l-29.077-29.056c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165l34.539,34.539 C71.764,398.571,64,411.712,64,426.667v42.667C64,492.864,83.135,512,106.667,512h42.667c23.53,0,42.666-19.136,42.666-42.667 v-42.667c0-14.955-7.765-28.096-19.456-35.712l34.539-34.539C215.424,348.074,215.424,334.591,207.083,326.25z\"></path></g></g><g><g><path d=\"M463.083,326.251c-8.341-8.341-21.824-8.341-30.165,0l-29.056,29.056c-3.029-8.107-10.688-13.973-19.861-13.973 c-9.173,0-16.832,5.867-19.861,13.973l-29.056-29.056c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165l34.539,34.539 C327.765,398.571,320,411.712,320,426.667v42.667c0,23.53,19.136,42.666,42.667,42.666h42.667 c23.53,0,42.666-19.136,42.666-42.667v-42.667c0-14.955-7.765-28.096-19.456-35.712l34.539-34.539 C471.424,348.075,471.424,334.592,463.083,326.251z\"></path></g></g><g><g><path d=\"M245.854,212.864c-11.883-1.109-23.381-4.181-34.155-9.109c-10.752-4.949-23.36-0.171-28.267,10.517 c-4.885,10.731-0.192,23.381,10.517,28.288c15.125,6.912,31.253,11.221,47.915,12.779c0.683,0.064,1.344,0.107,2.005,0.107 c10.901,0,20.203-8.299,21.227-19.349C266.185,224.384,257.588,213.973,245.854,212.864z\"></path></g></g><g><g><path d=\"M373.421,270.347c-10.304-13.099-22.635-24.299-36.651-33.323c-9.877-6.379-23.125-3.499-29.483,6.4 c-6.377,9.92-3.519,23.125,6.401,29.483c10.027,6.443,18.837,14.464,26.197,23.808c4.203,5.355,10.453,8.149,16.789,8.149 c4.587,0,9.237-1.493,13.163-4.565C379.096,293.003,380.695,279.606,373.421,270.347z\"></path></g></g><g><g><path d=\"M149.333,0h-42.667C83.135,0,64,19.136,64,42.667v42.667C64,108.864,83.135,128,106.667,128v21.333 c0,9.216,5.931,16.896,14.123,19.883c0.896,1.941,1.472,4.032,2.453,5.952c3.797,7.339,11.264,11.541,18.987,11.541 c3.285,0,6.656-0.768,9.771-2.368c10.453-5.419,14.571-18.283,9.173-28.757c-4.544-8.768-7.488-18.176-9.408-27.84 C174.143,126.464,192,108.032,192,85.333V42.667C192,19.136,172.864,0,149.333,0z\"></path></g></g></svg></span> {{deviceObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\" ng-show=\"!deviceObj.isEditable\">{{deviceObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\" ng-show=\"!deviceObj.isEditable\"><span ng-if=\"deviceObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{deviceObj.phase}}\" tooltip-placement=\"auto\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"elemList.fnGetPhaseIconBorderColor(deviceObj.phase)\"><span ng-class=\"elemList.fnGetPhaseIcon(deviceObj.phase)\"></span></span> <button ng-if=\"deviceObj.phase === \'PRODUCTION\'\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"elemList.fnGetHealthColor(deviceObj.health, deviceObj)\"><span class=\"healtSpan\">{{deviceObj.healthName}}</span></button></div></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!elemList.isDevicesLoading && elemList.devicesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{elemList.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"elemList.perPage = 10; elemList.fnPageChanged(elemList.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"elemList.perPage = 20; elemList.fnPageChanged(elemList.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"elemList.perPage = 50; elemList.fnPageChanged(elemList.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"elemList.perPage = 100; elemList.fnPageChanged(elemList.perPage)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"elemList.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"elemList.currentPage\" items-per-page=\"elemList.perPage\" max-size=\"3\" boundary-links=\"true\" ng-click=\"elemList.fnGetNextPrePagination(elemList.currentPage, elemList.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!elemList.devicePermissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\" ng-if=\"!elemList.isCallFromDevicesTab\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!elemList.selectedDevicesArr.length\" ng-click=\"elemList.fnSelectDevices()\">Select Devices</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-click=\"elemList.fnCancel()\">Cancel</button></div><div class=\"col-sm-12 p-0\" ng-if=\"elemList.isCallFromDevicesTab\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!elemList.selectedDevicesArr.length\" ng-if=\"!elemList.isDeviceAdding\" ng-click=\"elemList.fnAddDevicesToCluster()\">Add Devices</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-if=\"!elemList.isDeviceAdding\" ng-click=\"elemList.fnCancel()\">Cancel</button><div class=\"col-sm-12 pull-right\" ng-if=\"elemList.isDeviceAdding\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/cluster/modals/gatewayElementList/gatewayElementListModel.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Add Gateways</strong></div><div class=\"modal-body\" id=\"ele\"><div class=\"row\" ng-init=\"gatewayElemList.fnInitModel()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div ng-if=\"!gatewayElemList.isObjectSelect\"><node-search-directive ng-if=\"gatewayElemList.gatewayPermissionObj.List\" field-arr=\"gatewayElemList.searchFieldArr\" filter-query=\"gatewayElemList.filterQuery\" state-name=\"\'main.gateway\'\" fn-filter-query-change=\"gatewayElemList.fnFilterQueryChanged(filterQuery)\" is-called-for-view-visualizer=\"true\" fn-resize=\"gatewayElemList.fnSetTableHeight()\" no-set-url=\"true\"></node-search-directive><div class=\"row\" ng-if=\"gatewayElemList.gatewayPermissionObj.List\"><div class=\"col-sm-12\"><table-loader ng-if=\"gatewayElemList.isGatewaysLoading\" hide-circle=\"true\" fn-resize=\"gatewayElemList.fnSetLoaderTableHeight()\"></table-loader><div class=\"gateways-table table-container\"><table class=\"table table-striped table-check-box\" id=\"gatewaysElementTable\" ng-if=\"!gatewayElemList.isGatewaysLoading\"><thead><tr><th ng-if=\"gatewayElemList.gatewaysArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"gatewayElemList.isAllChecked\" ng-click=\"gatewayElemList.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"text-center\" ng-if=\"gatewayElemList.gatewaysArr.length\"></th><th ng-if=\"gatewayElemList.gatewaysArr.length\">Name</th><th ng-if=\"!gatewayElemList.gatewaysArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"gatewayObj in gatewayElemList.gatewaysArr track by $index\" ng-click=\"gatewayElemList.fnGetGateways(gatewayObj, gatewayElemList.gatewaysArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"gatewayObj.isCheck\" ng-change=\"gatewayElemList.fnCheckUncheckHeader(gatewayObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{gatewayObj.connection}}\" tooltip-placement=\"auto\" ng-style=\"gatewayElemList.fnGetConnectionIconColor(gatewayObj.connection)\"><span class=\"fa gatewayConnectionIcon\" ng-style=\"gatewayElemList.fnGetConnectionIconColor(gatewayObj.connection)\" ng-class=\"gatewayElemList.fnGetConnectionIcon(gatewayObj.connection)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-show=\"!gatewayObj.isEditable\">{{gatewayObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\" ng-show=\"!gatewayObj.isEditable\">{{gatewayObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\" ng-show=\"!gatewayObj.isEditable\"><span ng-if=\"gatewayObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{gatewayObj.phase}}\" tooltip-placement=\"auto\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"gatewayElemList.fnGetPhaseIconBorderColor(gatewayObj.phase)\"><span ng-class=\"gatewayElemList.fnGetPhaseIcon(gatewayObj.phase)\"></span></span> <button ng-if=\"gatewayObj.phase === \'PRODUCTION\'\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"gatewayElemList.fnGetHealthColor(gatewayObj.health, gatewayObj)\"><span class=\"healtSpan\">{{gatewayObj.healthName}}</span></button></div></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!gatewayElemList.isGatewaysLoading && gatewayElemList.gatewaysArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"gatewayElemList.isPrevVisible\" ng-click=\"gatewayElemList.fnGetNextPrevCollection(\'previous\', gatewayElemList.prevCollection, gatewayElemList.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"gatewayElemList.fnGetNextPrevCollection(\'next\', gatewayElemList.nextCollection, gatewayElemList.perPage)\" ng-if=\"gatewayElemList.nextCollection.length\"></button></div></div></div></div></div></div><div class=\"row\" ng-if=\"!gatewayElemList.gatewayPermissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayElemList.isCallFromGatewaysTab\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!gatewayElemList.selectedgatewaysArr.length\" ng-click=\"gatewayElemList.fnSelectGateways()\">Select Gateways</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-click=\"gatewayElemList.fnCancel()\">Cancel</button></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayElemList.isCallFromGatewaysTab\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!gatewayElemList.selectedgatewaysArr.length\" ng-if=\"!gatewayElemList.isGatewayAdding\" ng-click=\"gatewayElemList.fnAddGatewaysToCluster()\">Add Gateways</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-if=\"!gatewayElemList.isGatewayAdding\" ng-click=\"gatewayElemList.fnCancel()\">Cancel</button><div class=\"col-sm-12 pull-right\" ng-if=\"gatewayElemList.isGatewayAdding\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDevice()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isDeviceDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isDeviceDetailsLoaded\"><div class=\"m-t-20\"><button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"deviceObj.health\" uib-tooltip=\"health\" tooltip-placement=\"right\" ng-style=\"fnGetHealthColor(deviceObj.health, deviceObj)\"><span>{{deviceObj.healthName}}</span></button><div class=\"pull-right\"><span class=\"deviceInfoPageIcon phaseIconBorder\" uib-tooltip=\"{{deviceObj.phase}}\" tooltip-placement=\"left\" ng-style=\"fnGetPhaseIconBorderColor(deviceObj.phase)\"><span ng-class=\"fnGetPhaseIcon(deviceObj.phase)\"></span></span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><label class=\"ellipsis\">Type: {{deviceTypeInfo.name}}</label></div><div class=\"col-sm-2\"><label class=\"ellipsis\">{{deviceTypeInfo.model}}</label></div><div class=\"col-sm-2\"><label class=\"ellipsis\">v{{deviceTypeInfo.version}}</label></div><div class=\"col-sm-2 p-r-0 text-right\"><label class=\"ellipsis\">{{\"(\"+deviceTypeInfo.id+\")\"}}</label></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isDeviceDetailsLoaded\" ng-class=\"!devicePermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"deviceObj.name\" placeholder=\"Name for the Device*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"deviceObj.description\" placeholder=\"Description regarding Device\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\" ng-if=\"deviceObj.gatewayId\"><input class=\"md-form-control\" required=\"\" id=\"gatewayId\" type=\"text\" ng-model=\"deviceObj.gatewayId\" placeholder=\"Gateway Id for the Device*\"> <span class=\"highlight\"></span> <label>Gateway Id*</label></div><div class=\"col-sm-12 m-t-0 p-0\" ng-repeat=\"kvpPair in devicePropertiesArr track by $index\"><div class=\"col-sm-12 p-0\" ng-if=\"kvpPair.isPreDefine\"><div class=\"md-input m-b-20 p-0\" ng-class=\"isDetailsEditable && isUpdateCompleted ? \'col-sm-11\' : \'col-sm-12\'\"><input class=\"md-form-control p-r-30\" type=\"text\" required=\"\" ng-model=\"kvpPair.value\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>{{fnSetFiledLabel(kvpPair.key)}}</label> <small class=\"helper-text w100\"><button class=\"btn btn-sm btn-link p-0 pull-right\" ng-if=\"$index === devicePropertiesArr.length - 1 && isDetailsEditable && isUpdateCompleted\" ng-click=\"fnAddNewKvp()\">Add new key</button></small></div><div class=\"col-sm-1\" ng-if=\"isDetailsEditable && isUpdateCompleted\"><button class=\"btn btn-link m-t-5\"><i class=\"fa fa-trash-o fa-lg\" ng-click=\"fnRemoveKvpPair($index)\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!kvpPair.isPreDefine\"><div class=\"md-input m-b-20 p-0 p-r-10 col-sm-5\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"text\" ng-model=\"kvpPair.key\" placeholder=\"Key\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 p-0\" ng-class=\"isDetailsEditable && isUpdateCompleted ? \'col-sm-6\' : \'col-sm-7\'\"><input class=\"md-form-control p-r-30\" id=\"value\" type=\"text\" required=\"\" ng-model=\"kvpPair.value\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text w100\"><button class=\"btn btn-sm btn-link p-0 pull-right\" ng-if=\"$index === devicePropertiesArr.length - 1 && isDetailsEditable && isUpdateCompleted\" ng-click=\"fnAddNewKvp()\">Add new key</button></small></div><div class=\"col-sm-1\" ng-if=\"isDetailsEditable && isUpdateCompleted\"><button class=\"btn btn-link m-t-5\"><i class=\"fa fa-trash-o fa-lg\" ng-click=\"fnRemoveKvpPair($index)\"></i></button></div></div></div><div class=\"col-sm-12 m-t-10 p-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateDeviceDetails(deviceObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right m-r-10\" uib-dropdown=\"\" ng-if=\"((devicePermissionsObj.Modify && !isDetailsEditable) || devicePermissionsObj.Delete) && isDeviceDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"devicePermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"devicePermissionsObj.Delete\" ng-click=\"fnDeleteDevice(deviceObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/node/device/modal/componentRenameModal/componentRenameModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Component Rename</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-class=\"compRename.isComponentUpdating ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"compRename.compName\" placeholder=\"Enter new name for Component\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text w100\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"compRename.compObj.name && compRename.compObj.name !== \'\'\" ng-click=\"compRename.fnRemoveCompName()\"><small>Reset to Default</small></button></small></div></div></div></div></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"compRename.isComponentUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" ng-if=\"!compRename.isComponentUpdating\" class=\"btn btn-primary pull-right\" ng-click=\"compRename.fnUpdateComponentName(compRename.compName)\">Save</button> <button type=\"button\" ng-if=\"!compRename.isComponentUpdating\" class=\"btn btn-primary pull-right m-r-5\" ng-click=\"compRename.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/node/device/modal/deviceVersionSupportModel/deviceVersionSupport.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Request a version</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\"><div class=\"divider\"></div><h3>To add your version, please contact our support team specifying the OEM, Model, Version you need and whether you have an active or lab unit available.</h3><h4><i class=\"fa fa-envelope-o\"></i> ops@ecsiteapp.com</h4></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"versionSupport.fnCancel()\" tabindex=\"12\">Close</button></div>");
$templateCache.put("app/node/device/modal/componentSupplementalDataModal/componentSupplementalData.html","<div class=\"inmodal h-100 supplementalTemplate\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Component Supplemental Data</strong></div><div class=\"modal-body\"><div class=\"row\" ng-init=\"supplementalDataModal.fnInitComponentSupplemental()\"><div class=\"col-sm-12\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!supplementalDataModal.isComponentSupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"supplementalDataModal.isComponentSupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-25\" ng-if=\"!supplementalDataModal.supplementalKVPArr.length && !supplementalDataModal.isAdvancedOption\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><label>There are no supplemental data for this device.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!supplementalDataModal.isAdvancedOption\" ng-class=\"!supplementalDataModal.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"supplementalDataModal.supplementalKVPArr.length\" ng-repeat=\"kvpPair in supplementalDataModal.supplementalKVPArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"supplementalDataModal.isKeyDuplicated && $index === supplementalDataModal.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"supplementalDataModal.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Keys must be unique.\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"supplementalDataModal.isKeyDuplicated && $index === supplementalDataModal.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"supplementalDataModal.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" placeholder=\"Supplemental Value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\"> <span class=\"highlight\"></span> <label>Value</label> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"supplementalDataModal.fnInjectFunction()\"><span id=\"timeId1\"><em>f<small>(x)</small></em></span></a></span><div class=\"supplementalInputBorder-part\"></div><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"col-sm-1 p-r-10 p-r-0 m-t-5\"><button ng-if=\"supplementalDataModal.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"supplementalDataModal.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"$last\"><div class=\"p-0 pull-right\" ng-if=\"supplementalDataModal.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary m-r-2\" ng-if=\"$last && kvpPair.key.length && kvpPair.value.length && !supplementalDataModal.isKeyDuplicated\" ng-click=\"supplementalDataModal.fnAddSupplementalKey()\">New Entry</button></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"supplementalDataModal.isSupplementalDetailsEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"supplementalDataModal.fnResetDetails()\">Cancel</button><div class=\"pull-right\"><button class=\"btn btn-sm btn-primary\" ng-if=\"!supplementalDataModal.isSupplementalDetailChanging\" ng-disabled=\"supplementalDataModal.isKeyDuplicated\" ng-click=\"supplementalDataModal.fnSaveDeviceData()\">Save</button></div><div class=\"m-t-5 pull-right\" ng-if=\"supplementalDataModal.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"supplementalDataModal.isAdvancedOption && !supplementalDataModal.isSupplementalDetailsEditable\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"supplementalDataModal.componentSupplementalObj\" ui-codemirror-opts=\"supplementalDataModal.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"supplementalDataModal.isSupplementalEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"supplementalDataModal.fnToggle()\">Cancel</button> <button class=\"btn btn-sm btn-primary pull-right\" ng-if=\"!supplementalDataModal.isSupplementalEditableUpdate\" ng-click=\"supplementalDataModal.fnEditDeviceData(supplementalDataModal.componentSupplementalObj)\">Save</button><div class=\"m-t-5 pull-right\" ng-if=\"supplementalDataModal.isSupplementalEditableUpdate\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\"><div class=\"pull-right\" ng-if=\"!supplementalDataModal.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"supplementalDataModal.fnAddSupplementalKey(true)\" ng-if=\"supplementalDataModal.componentPermissionObj.Modify\">New Entry</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-disabled=\"supplementalDataModal.isSupplementalEditable || supplementalDataModal.isSupplementalDetailsEditable\" ng-click=\"supplementalDataModal.fnOpenAdvancedMenu()\">{{supplementalDataModal.isAdvancedOption === true ?\"Default\":\"Advance\"}}</a></li></ul></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"supplementalDataModal.isSupplementalEditableUpdate || supplementalDataModal.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" class=\"btn btn-primary pull-left\" ng-if=\"!supplementalDataModal.isSupplementalEditableUpdate && !supplementalDataModal.isSupplementalDetailChanging\" ng-click=\"supplementalDataModal.fnCloseModal()\">Close</button><div class=\"dropdown dropup pull-right m-t-5\" uib-dropdown=\"\" ng-if=\"!supplementalDataModal.isObjectEmpty(supplementalDataModal.componentSupplementalObj) && supplementalDataModal.componentPermissionObj.Modify && !supplementalDataModal.isSupplementalEditableUpdate && !supplementalDataModal.isSupplementalDetailChanging\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!supplementalDataModal.isSupplementalDetailsEditable && !supplementalDataModal.isAdvancedOption && supplementalDataModal.componentPermissionObj.Modify\" ng-click=\"supplementalDataModal.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"supplementalDataModal.isAdvancedOption && supplementalDataModal.componentPermissionObj.Modify\" ng-click=\"supplementalDataModal.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div>");
$templateCache.put("app/node/device/modal/gatewayConnectionModal/gatewayConnectionModal.html","<div class=\"inmodal h-100 supplementalTemplate\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Gateway Connection</strong></div><div class=\"modal-body\"><div class=\"row\" ng-init=\"gatewayConnectionModal.fnInitGatewayConnectionModal()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 m-b-10 d-flex\"><div class=\"col-sm-10 p-0\"><h4 class=\"m-t-0 m-b-0 p-b-5 font-italic ellipsis\">{{gatewayConnectionModal.deviceGatewayObj.description}}</h4><h2 class=\"m-t-0 m-b-0 p-b-5 ellipsis\">{{gatewayConnectionModal.deviceGatewayObj.name}}</h2></div><div class=\"col-sm-2 p-0 text-right\" style=\"display: flex;justify-content: flex-end;align-items: flex-end;\"><span ng-class=\"gatewayConnectionModal.selectedTab === 0 ? \'overview-active-link\' : \'\'\" ng-click=\"gatewayConnectionModal.fnChangeSelectedTab(0)\"><i class=\"cursor-pointer fa fa-area-chart\"></i></span> <span class=\"m-l-5\" ng-class=\"gatewayConnectionModal.selectedTab === 1 ? \'overview-active-link\' : \'\'\" ng-click=\"gatewayConnectionModal.fnChangeSelectedTab(1)\"><i class=\"cursor-pointer fa fa-pie-chart\"></i></span></div></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayConnectionModal.selectedTab === 0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Connection</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 220px;overflow: hidden\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayConnectionModal.isBarCharLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!gatewayConnectionModal.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayConnectionModal.gatewayConnectionArr.length\"><connection-heat-map-chart node-id=\"gatewayConnectionModal.deviceGatewayObj.id\" info-section-class=\"\'infoSectionClass\'\" type=\"\'connection\'\" filter-obj=\"gatewayConnectionModal.selectedFilterObj\" comp-arr=\"[\'Gateway\']\" chart-data=\"gatewayConnectionModal.gatewayConnectionArr\" categories-arr=\"gatewayConnectionModal.heatmapCategoriesArr\"></connection-heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!gatewayConnectionModal.gatewayConnectionArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayConnectionModal.selectedTab === 1\"><div class=\"col-sm-12 p-0\"><label>Gateway Connection</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"gatewayConnectionModal.isBarCharLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayConnectionModal.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayConnectionModal.gatewayConnectionPieData.length\"><pie-chart chart-full-size=\"true\" node-id=\"gatewayConnectionModal.deviceGatewayObj.id\" filter-obj=\"gatewayConnectionModal.selectedFilterObj\" type=\"\'connection\'\" chart-class=\"gatewayPieConnectionMainContainer\" chart-data=\"gatewayConnectionModal.gatewayConnectionPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!gatewayConnectionModal.gatewayConnectionPieData.length\"><label>No results found for gateway connection for the selected range.</label> <label>Please select another range.</label></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"gatewayConnectionModal.fnCloseModal()\">Close</button></div></div>");
$templateCache.put("app/node/device/modal/gatewayInfoDevice/gatewayInfoDevice.html","<div class=\"inmodal theme_modal\" ng-init=\"gatewayDeviceInfo.fnInitGatewayDeviceModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Gateway\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"gatewayDeviceInfo.isGatewayLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-if=\"!gatewayDeviceInfo.isGatewayLoading\"><div class=\"col-sm-12 p-0\">Gateway Health: <button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayDeviceInfo.gatewayObj.toolTipName}}\" tooltip-placement=\"right\" ng-style=\"gatewayDeviceInfo.fnGetHealthColor(gatewayDeviceInfo.gatewayObj.health, gatewayDeviceInfo.gatewayObj)\"><span class=\"healtSpan\">{{gatewayDeviceInfo.gatewayObj.healthName}}</span></button></div><div class=\"col-sm-12 p-0 m-t-10\">Gateway Connection: <span class=\"fa\" uib-tooltip=\"{{gatewayDeviceInfo.gatewayObj.connection}}\" tooltip-placement=\"right\" ng-style=\"gatewayDeviceInfo.fnGetConnectionIconColor(gatewayDeviceInfo.gatewayObj.connection)\" ng-class=\"gatewayDeviceInfo.fnGetConnectionIcon(gatewayDeviceInfo.gatewayObj.connection)\"></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"gatewayDeviceInfo.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/node/device/modal/observerConditionModal/observerConditionModal.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Create Conditions</strong></div><div class=\"modal-body\" ng-init=\"observerConditionModal.fnInitModel()\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 p-0\"><div class=\"create-screen\" ng-if=\"!observerConditionModal.isExistionObserverOptionSelected\"><div class=\"content\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-binoculars\" aria-hidden=\"true\"></i></div><div class=\"col-sm-12\"><label>Observers</label></div><div class=\"col-sm-12\" ng-if=\"observerConditionModal.observerPermissionsObj.Create\"><button class=\"btn btn-primary\" ng-click=\"observerConditionModal.fnCreateNewObserver()\">Create new Observer</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"observerConditionModal.observerPermissionsObj.Modify\">or</div><div class=\"col-sm-12\" ng-if=\"observerConditionModal.observerPermissionsObj.Modify\"><button class=\"btn btn-primary\" ng-click=\"observerConditionModal.fnAddToExistingObserver()\">Add to existing Observer</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"observerConditionModal.isExistionObserverOptionSelected\"><div ng-if=\"!observerConditionModal.isObserverObjSelected\"><search-directive ng-if=\"observerConditionModal.observerPermissionsObj.List\" field-arr=\"observerConditionModal.searchFieldArr\" filter-query=\"observerConditionModal.filterQuery\" state-name=\"\'main.observer\'\" fn-filter-query-change=\"observerConditionModal.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"observerConditionModal.fnSetTableHeight()\"></search-directive><div class=\"row\" ng-if=\"observerConditionModal.observerPermissionsObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"observerConditionModal.isObserversLoading\"></app-spinner><div class=\"observers-table table-container\"><table id=\"observerConditionModal\" class=\"table table-striped table-check-box\" ng-show=\"!observerConditionModal.isObserversLoading\"><thead><tr><th ng-if=\"observerConditionModal.observersArr.length\" class=\"p-8\"></th><th ng-if=\"observerConditionModal.observersArr.length\"></th><th ng-if=\"observerConditionModal.observersArr.length\"><span ng-click=\"observerConditionModal.fnObserverSort(\'name\')\">Name<i class=\"m-l-5 fa\" ng-class=\"observerConditionModal.fnGetSortClass(\'name\')\"></i></span></th><th ng-if=\"observerConditionModal.observersArr.length\"></th><th ng-if=\"!observerConditionModal.observersArr.length\">No records found...</th></tr></thead><tbody id=\"observerTable\"><tr ng-repeat=\"observerObj in observerConditionModal.observersArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"observerObj.isCheck\" ng-change=\"observerConditionModal.fnCheckUncheckHeader(observerObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallStateIcon\" ng-show=\"!observerObj.isEditable\"><span class=\"stateIconBorder\" uib-tooltip=\"{{observerObj.state}}\" tooltip-placement=\"auto\" ng-style=\"observerConditionModal.getObserverStateColor(observerObj.state)\"><span class=\"fa stateIcon\" ng-class=\"observerConditionModal.fnGetObserveStateIcon(observerObj.state)\"></span></span></td><td class=\"attributeTdCSS\" colspan=\"{{!observerObj.isEditable ?0:1}}\"><label class=\"ellipsis m-b-0\" ng-show=\"!observerObj.isEditable\">{{observerObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription\" ng-bind=\"observerObj.description\" ng-show=\"!observerObj.isEditable\"></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!observerConditionModal.isObserversLoading && observerConditionModal.observersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{observerConditionModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"observerConditionModal.perPage = 10; observerConditionModal.fnPageChanged(observerConditionModal.currentPage, observerConditionModal.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"observerConditionModal.perPage = 20; observerConditionModal.fnPageChanged(observerConditionModal.currentPage, observerConditionModal.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"observerConditionModal.perPage = 50; observerConditionModal.fnPageChanged(observerConditionModal.currentPage, observerConditionModal.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"observerConditionModal.perPage = 100; observerConditionModal.fnPageChanged(observerConditionModal.currentPage,observerConditionModal.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"observerConditionModal.perPage = 500; observerConditionModal.fnPageChanged(observerConditionModal.currentPage, observerConditionModal.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"observerConditionModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"observerConditionModal.currentPage\" items-per-page=\"observerConditionModal.perPage\" max-size=\"observerConditionModal.maxSize\" boundary-links=\"true\" ng-click=\"observerConditionModal.fnPageChanged(observerConditionModal.currentPage, observerConditionModal.perPage)\" force-ellipses=\"true\"></ul></div></div></div></div></div></div><div class=\"row\" ng-if=\"!observerConditionModal.observerPermissionsObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div ng-if=\"observerConditionModal.isObserverObjSelected\"><div class=\"create-screen\" ng-if=\"!observerConditionModal.isExistionObserverConditionOptionSelected\"><div class=\"content\"><div class=\"col-sm-12\"><div class=\"col-sm-12\"><i class=\"fa fa-10x fa-binoculars\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-12\"><label>Observers</label></div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"observerConditionModal.fnCreateNewConditionForExistingObserver()\">Create new condition</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"observerConditionModal.observerPermissionsObj.Modify\">or</div><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"observerConditionModal.fnAddToExistingCondition()\">Add to existing condition</button></div></div></div><div ng-if=\"observerConditionModal.isExistionObserverConditionOptionSelected\"><div id=\"functionModal\"><div class=\"col-sm-6 p-15\" ng-repeat=\"conditions in observerConditionModal.selectedObserverObj.conditions track by $index\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><span class=\"observer-hierarchyIcon-modal\"><svg class=\"observer-hierarchyIconColor\" x=\"0px\" y=\"0px\" viewbox=\"0 0 512 512\"><path d=\"M452,363.518V316c0-24.814-20.186-45-45-45h-46v-45c0-24.814-20.186-45-45-45h-45v-32.518 c34.191-6.969,60-37.266,60-73.482c0-41.353-33.647-75-75-75c-41.353,0-75,33.647-75,75c0,36.216,25.809,66.513,60,73.482V181h-45 c-24.814,0-45,20.186-45,45v45h-46c-24.814,0-45,20.186-45,45v47.518C25.809,370.487,0,400.784,0,437c0,41.353,33.647,75,75,75 s75-33.647,75-75c0-36.216-25.809-66.513-60-73.482V316c0-8.276,6.724-15,15-15c4.409,0,131.512,0,136,0v62.518 c-34.191,6.969-60,37.266-60,73.482c0,41.353,33.647,75,75,75c41.353,0,75-33.647,75-75c0-36.216-25.809-66.513-60-73.482V301 c4.491,0,131.601,0,136,0c8.276,0,15,6.724,15,15v47.518c-34.191,6.969-60,37.266-60,73.482c0,41.353,33.647,75,75,75 c41.353,0,75-33.647,75-75C512,400.784,486.191,370.487,452,363.518z M331,271H181v-45c0-8.276,6.724-15,15-15h120 c8.276,0,15,6.724,15,15V271z\"></path></svg></span> <button class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-click=\"observerConditionModal.fnSelectObserverCondition(conditions)\">Select</button></div><div class=\"panel-body\"><strong>Rules:</strong><div class=\"m-t-2 m-b-5 observerConditionOverflow\"><div class=\"ellipsis\" ng-repeat=\"rules in conditions.expression.rules track by $index\"><div ng-if=\"rules.field\">{{rules.field}}</div><div ng-if=\"rules.rules\"><div ng-repeat=\"conditionRules in rules.rules\" ng-include=\"\'condition_renderer.html\'\"></div></div></div></div><div class=\"observer-condition-divider\"></div><div class=\"m-t-10\"></div><strong>Actions:</strong><div class=\"m-t-2 observerConditionOverflow\"><div class=\"ellipsis\" ng-repeat=\"actions in conditions.actions track by $index\"><strong class=\"text-capitalize\" ng-if=\"actions.node\">node</strong> <strong class=\"text-capitalize\" ng-if=\"actions.pipeline\">pipeline</strong> <strong class=\"text-capitalize\" ng-if=\"actions.storage\">storage</strong><div ng-if=\"actions.node\" class=\"text-center\"><strong>Update health to</strong><div class=\"m-t-5\"><button ng-if=\"observerConditionModal.healthPermissionObj.List\" class=\"btn btn-xs btn-default ellipsis-label\" ng-style=\"observerConditionModal.fnGetHealthColor(actions.node.updateHealth)\"><span ng-bind=\"observerConditionModal.fnGetHealthName(actions.node.updateHealth)\"></span></button> <label ng-if=\"!observerConditionModal.healthPermissionObj.List\">{{actions.node.updateHealth}}</label></div></div><div ng-if=\"actions.pipeline\" class=\"text-center\"><strong>Publish with custom</strong><div ng-class=\"$index === 0?\'m-t-5\':\'\'\" ng-repeat=\"(key,value) in actions.pipeline.publishEvent track by $index\"><span>{{key+\" : \"+value}}</span><br></div></div><div ng-if=\"actions.storage\" class=\"text-center\"><strong>Save to</strong><div class=\"m-t-5 text-left\"><span class=\"ellipsis\">{{actions.storage.writeEvent.path}}</span></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"condition_renderer.html\"><div ng-if=\"conditionRules.field\"> {{conditionRules.field}} </div> <div ng-if=\"conditionRules.rules\"> <div ng-repeat=\"conditionRules in conditionRules.rules\" ng-include=\"\'condition_renderer.html\'\"></div> </div></script></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div ng-if=\"!observerConditionModal.isExistionObserverOptionSelected\"><button type=\"button\" class=\"btn btn-primary m-t-2 pull-right\" ng-click=\"observerConditionModal.fnCancel()\">Close</button></div><div ng-if=\"observerConditionModal.isExistionObserverOptionSelected && !observerConditionModal.isObserverObjSelected && !observerConditionModal.isExistionObserverConditionOptionSelected\"><button type=\"button\" class=\"btn btn-primary m-t-2 pull-left\" ng-click=\"observerConditionModal.fnBackToExistingObserverOption()\">Back</button> <button type=\"button\" class=\"btn btn-primary m-t-2 pull-left\" ng-click=\"observerConditionModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"observerConditionModal.isObjectEmpty(observerConditionModal.selectedObserverObj)\" ng-click=\"observerConditionModal.fnSelectObserver(observerConditionModal.selectedObserverObj)\">Select Observer</button></div><div ng-if=\"observerConditionModal.isExistionObserverOptionSelected && observerConditionModal.isObserverObjSelected && !observerConditionModal.isExistionObserverConditionOptionSelected\"><button type=\"button\" class=\"btn btn-primary m-t-2 pull-left\" ng-click=\"observerConditionModal.fnBackToObserver()\">Back</button> <button type=\"button\" class=\"btn btn-primary m-t-2 pull-right\" ng-click=\"observerConditionModal.fnCancel()\">Close</button></div><div ng-if=\"observerConditionModal.isExistionObserverOptionSelected && observerConditionModal.isObserverObjSelected && observerConditionModal.isExistionObserverConditionOptionSelected\"><button type=\"button\" class=\"btn btn-primary m-t-2 pull-left\" ng-click=\"observerConditionModal.fnBackToExistingObserver()\">Back</button> <button type=\"button\" class=\"btn btn-primary m-t-2 pull-right\" ng-click=\"observerConditionModal.fnCancel()\">Close</button></div></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isEcuDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isEcuDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isEcuDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_ECU_DESCRIPTION && userPermissionsObj.UPDATE_ECU_NAME && ecuObj.lifecycleState === \'READY\'\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.ENABLE_NTP && ecuObj.lifecycleState === \'READY\' && ecuObj.ntp === \'DISABLED\'\" ng-click=\"fnEnableECUNTP(ecuObj)\"><a class=\"btn btn-link\">Enable NTP</a></li><li ng-if=\"userPermissionsObj.DISABLE_NTP && ecuObj.lifecycleState === \'READY\' && ecuObj.ntp === \'ENABLED\'\" ng-click=\"fnDisabledECUNTP(ecuObj)\"><a class=\"btn btn-link\">Disabled NTP</a></li><li ng-if=\"userPermissionsObj.ENABLE_VPN && ecuObj.lifecycleState === \'READY\' && ecuObj.vpn === \'DISABLED\'\" ng-click=\"fnEnableECUVPN(ecuObj)\"><a class=\"btn btn-link\">Enable VPN</a></li><li ng-if=\"userPermissionsObj.DISABLE_VPN && ecuObj.lifecycleState === \'READY\' && ecuObj.vpn === \'ENABLED\'\" ng-click=\"fnDisabledECUVPN(ecuObj)\"><a class=\"btn btn-link\">Disabled VPN</a></li><li ng-if=\"userPermissionsObj.DEREGISTER_ECU\" ng-click=\"fnDeregisterECU(ecuObj)\"><a class=\"btn btn-link\">Deregister ECU</a></li><li ng-if=\"userPermissionsObj.REBOOT_ECU\" ng-click=\"fnRebootECU(ecuObj)\"><a class=\"btn btn-link\">Reboot ECU</a></li><li ng-if=\"userPermissionsObj.DEPLOY_ECU_CHANGES && ecuObj.registered && ecuObj.phase === \'ACTIVE\' && ecuObj.syncState === \'NOT_SYNCHRONIZED\'\" ng-click=\"fnDeployECU(ecuObj)\"><a class=\"btn btn-link\">Synchronize</a></li><li ng-if=\"userPermissionsObj.UPDATE_ECU_PROJECT && (ecuObj.lifecycleState === \'READY\' || ecuObj.lifecycleState === \'CREATING\') && !isECUHasNode\" ng-click=\"fnChangeECUProject(ecuObj)\"><a class=\"btn btn-link\">Change Project</a></li><li ng-if=\"userPermissionsObj.SCAN_NETWORK\" ng-click=\"fnRequestStartNetworkScan(ecuObj)\"><a class=\"btn btn-link\">Start a network scan</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isEcuDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"ecuObj.name\" placeholder=\"Name for the ECU*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"ecuObj.description\" placeholder=\"Description for the ECU*\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0 pace\" ng-if=\"!isDetailsEditable\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">ECU Information</label></div><div class=\"panel-body\"><div class=\"m-t-10 d-flex align-items-center\"><div class=\"w100 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"w100 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"w100 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.phase === \'UNREGISTERED\'\">Unregistered</span> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div><div class=\"w100 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"w100 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Lifecycle State\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lifecycleState.svg#lifecycleState\"></use></svg></div><div class=\"d-flex m-l-10 m-b-0\"><span ng-if=\"ecuObj.lifecycleState === \'CREATING\'\">Creating</span> <span ng-if=\"ecuObj.lifecycleState === \'UPDATING\'\">Updating</span> <span ng-if=\"ecuObj.lifecycleState === \'DELETING\'\">Deleting</span> <span ng-if=\"ecuObj.lifecycleState === \'REBOOTING\'\">Rebooting</span> <span ng-if=\"ecuObj.lifecycleState === \'SCANNING\'\">Scanning</span> <span ng-if=\"ecuObj.lifecycleState === \'WRITING\'\">Writing</span> <span ng-if=\"ecuObj.lifecycleState === \'READY\'\">Ready</span> <span ng-if=\"ecuObj.lifecycleState === \'FAILED\'\">Failed</span></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Registration Information</label></div><div class=\"panel-body\"><div class=\"d-flex align-items-center flex-column ecu-registration-information\"><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.createdDate\"><div class=\"d-flex align-items-center info-title\"><b>Created At :</b></div><div class=\"d-flex align-items-center info-body\">{{ecuObj.createdDate}}</div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.createdBy\"><div class=\"d-flex align-items-center info-title\"><b>Created By :</b></div><div class=\"d-flex align-items-center info-body\">{{ecuObj.createdBy}}</div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\"><div class=\"d-flex align-items-center info-title\"><b>Registered :</b></div><div class=\"d-flex align-items-center info-body\"><span ng-if=\"ecuObj.registered\">Registered</span> <span ng-if=\"!ecuObj.registered\">Not Registered</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.registered\"><div class=\"d-flex align-items-center info-title\"><b>Registered At:</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.registeredDate}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.registered\"><div class=\"d-flex align-items-center info-title\"><b>Serial :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.serial}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.registered && (ecuObj.serialAssignedBy && ecuObj.serialAssignedBy.length)\"><div class=\"d-flex align-items-center info-title\"><b>Serial Assigned By :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.serialAssignedBy}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\"><div class=\"d-flex align-items-center info-title\"><b>Version :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.version}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\"><div class=\"d-flex align-items-center info-title\"><b>Backhaul :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.backhaul}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.updatedDate\"><div class=\"d-flex align-items-center info-title\"><b>Updated At :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.updatedDate}}</span></div></div><div class=\"d-flex align-items-center w100 p-t-3 p-b-3\" ng-if=\"ecuObj.updatedBy\"><div class=\"d-flex align-items-center info-title\"><b>Updated By :</b></div><div class=\"d-flex align-items-center info-body\"><span>{{ecuObj.updatedBy}}</span></div></div></div></div></div></div><div class=\"col-sm-12 p-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!ecuObj.name.length\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"fnUpdateEcuDetails(ecuObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/ecu/modals/ecuProject/ecuProject.html","<div class=\"inmodal h-100\" ng-init=\"ecuProject.fnInitECUProjectModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Change ECU Project</h3></div><div class=\"modal-body\"><div class=\"col-sm-12\" ng-if=\"!ecuProject.isProjectsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"ecuProject.isProjectsLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 p-t-10 p-b-20 position-r customProjectDropdown\"><div class=\"p-0 col-sm-12\"><label class=\"p-l-0 p-r-0 label-header\">Project*</label><div class=\"col-sm-12 label-box p-10 p-l-20\"><div class=\"col-sm-12 p-0 p-t-2 d-flex\" ng-if=\"!ecuProject.changeProjectView\" ng-click=\"$event.stopPropagation();ecuProject.fnOpenChangeProjectView()\"><div class=\"col-sm-12 p-0 font-italic p-t-15\" ng-if=\"!ecuProject.selectedProject.name\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"ecuProject.selectedProject.name\"><span>{{ecuProject.selectedProject.name}}</span></div><div class=\"col-sm-12 p-0\" style=\"width: 10px;\"><i class=\"fa fa-caret-down\"></i></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"ecuProject.changeProjectView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"ecuProject.fnOnToggleProject(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"ecuProject.selectedProject.name\">{{ecuProject.selectedProject.name}}</span> <span class=\"w100 text-left\" ng-if=\"!ecuProject.selectedProject.name\">No Project</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Project</label> <span ng-click=\"ecuProject.fnCancelChangeProject()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"ecuProject.projectSearch[ecuProject.projectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in ecuProject.filterProject=(ecuProject.projectsArr | filter:ecuProject.projectSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();ecuProject.fnGetProjectInfo(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.isCheck\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!ecuProject.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"ecuProject.isECUProjectUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" ng-if=\"!ecuProject.isECUProjectUpdating\" class=\"btn btn-primary pull-left m-r-5 btn-primary-cancel\" ng-click=\"ecuProject.fnCancel()\">Cancel</button> <button type=\"button\" ng-if=\"!ecuProject.isECUProjectUpdating\" ng-disabled=\"!ecuProject.selectedProjectId.length\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"ecuProject.fnUpdateECUProject()\">Save</button></div></div>");
$templateCache.put("app/node/ecu/modals/ecuSyncModal/ecuSyncModal.html","<div class=\"inmodal h-100\" ng-init=\"ecuSyncModal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Synchronizing ECU</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Synchronizing ECU you can watch it here in real-time. Closing this window will have no effect on the Synchronizing.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"ecuSyncModal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in ecuSyncModal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"ecuSyncModal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"ecuSyncModal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"ecuSyncModal.jobSummary\" ui-codemirror-opts=\"ecuSyncModal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"ecuSyncModal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/ecu/modals/networkScan/networkScan.html","<div class=\"inmodal h-100\" ng-init=\"networkScan.fnInitNetworkScanModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Network Scan</h3></div><div class=\"modal-body\" ng-class=\"networkScan.isJobIdFound ? \'p-0\':\'\'\"><div class=\"col-sm-12 p-0 h-100\" ng-class=\"networkScan.isNetworkScanStart ? \'pace\': \'\'\" ng-if=\"!networkScan.isJobIdFound\"><div class=\"col-sm-12 p-0 m-t-10 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary d-flex\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{networkScan.inputObj.auto ? \'True\':\'False\'}}</span> <label class=\"titleLabel\">Auto</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li><a ng-click=\"networkScan.inputObj.auto = true;networkScan.inputObj.range = \'\'\"><span>True</span></a></li><li><a ng-click=\"networkScan.inputObj.auto = false;\"><span>False</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-if=\"networkScan.inputObj.auto === false\"><div class=\"md-input m-b-0 h-100\"><input class=\"md-form-control h-100\" type=\"text\" name=\"range\" placeholder=\"Enter an IP address Scanning ranges using NMAP notation\" rows=\"4\" style=\"resize: none\" ng-model=\"networkScan.inputObj.range\"> <label>Range</label></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"networkScan.isJobIdFound\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Network Scanning</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your network scanning you can watch it here real-time. Closing this window will have no effect on the execution.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"networkScan.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in networkScan.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"networkScan.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"networkScan.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"networkScan.jobSummary\" ui-codemirror-opts=\"networkScan.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\" ng-if=\"!networkScan.isJobIdFound\"><div class=\"d-flex\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-if=\"!networkScan.isNetworkScanStart\" ng-click=\"networkScan.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3 v4-primary-button\" ng-if=\"!networkScan.isNetworkScanStart\" ng-click=\"networkScan.fnNetworkScan()\" tabindex=\"12\">Start Network Scan</button><div class=\"pull-right\" ng-if=\"networkScan.isNetworkScanStart\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\" ng-if=\"networkScan.isJobIdFound\"><div class=\"d-flex\"></div><div class=\"d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"networkScan.fnCancel()\" tabindex=\"12\">Close</button></div></div></div></div>");
$templateCache.put("app/node/es4/es4Info/es4Steps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isEs4DetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isEs4DetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isEs4DetailsLoaded && ((userPermissionsObj.DELETE_ES4 && es4Obj.lifecycleState === \'READY\') || (userPermissionsObj.UPDATE_ES4_DESCRIPTION && userPermissionsObj.UPDATE_ES4_NAME && es4Obj.lifecycleState === \'READY\') || (userPermissionsObj.DEPLOY_ES4 && es4Obj.syncState === \'NOT_SYNCHRONIZED\'))\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_ES4_DESCRIPTION && userPermissionsObj.UPDATE_ES4_NAME && es4Obj.lifecycleState === \'READY\'\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"!isDetailsEditable && userPermissionsObj.DELETE_ES4 && es4Obj.lifecycleState === \'READY\'\" ng-click=\"fnDeleteEs4(es4Obj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userPermissionsObj.DEPLOY_ES4 && es4Obj.syncState === \'NOT_SYNCHRONIZED\'\" ng-click=\"fnDeployES4(es4Obj)\"><a class=\"btn btn-link\">Deploy ES4</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isEs4DetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"es4Obj.name\" placeholder=\"Name for the Es4*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"es4Obj.description\" placeholder=\"Description for the Es4*\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!es4Obj.name.length\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"fnUpdateEs4Details(es4Obj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{es4Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(es4Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/es4/modal/es4JobTerminal/es4JobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"es4JobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Updating ES4</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Updating ES4 you can watch it here in real-time. Closing this window will have no effect on the updation.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"es4JobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in es4JobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"es4JobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"es4JobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"es4JobTerminal.jobSummary\" ui-codemirror-opts=\"es4JobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"es4JobTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/fleet/fleetInfo/fleetSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isEcuDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isEcuDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isEcuDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"accountId === \'cu000000\'\" ng-click=\"fnRequestECUTunnel(ecuObj)\"><a class=\"btn btn-link\">Request ECU tunnel</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isEcuDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"col-sm-4 p-l-0\"><label class=\"ellipsis\">OEM: {{ecuObj.meta.oem}}</label></div><div class=\"col-sm-4 p-l-0\"><label class=\"ellipsis\">Model: {{ecuObj.meta.model}}</label></div><div class=\"col-sm-4 p-r-0\"><label class=\"ellipsis text-right\">Version: V{{ecuObj.meta.version}}</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"ecuObj.name\" placeholder=\"Name for the ECU*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"ecuObj.description\" placeholder=\"Description for the ECU*\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0 m-b-20\" ng-if=\"!isDetailsEditable\"><div class=\"col-sm-12 p-0\"><label>Tags:</label></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm\" ng-repeat=\"tagObj in ecuObj.meta.tags track by $index\" ng-class=\"!$first ? \'m-l-5\' : \'\'\">{{tagObj}}</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Energy</label></div><div class=\"panel-body\"><div class=\"d-flex flex-column\"><label>Default Unit : {{ecuObj.meta.energy.defaultUnit}}</label> <label>Default Energy : {{ecuObj.meta.energy.defaultEnergy}}</label> <label>Energy Attribute : {{ecuObj.meta.energy.energyAttribute}}</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Price</label></div><div class=\"panel-body\"><div class=\"d-flex flex-column\"><label>Amount : {{ecuObj.meta.price.amount}}</label> <label>Currency : {{ecuObj.meta.price.currency}}</label></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/fleet/modal/jobTerminal/jobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"jobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Executing Command</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your executing command you can watch it here in real-time. Closing this window will have no effect on the execution.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"jobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in jobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"jobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"jobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"jobTerminal.jobSummary\" ui-codemirror-opts=\"jobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"jobTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitGateway()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isGatewayDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isGatewayDetailsLoaded\"><div class=\"m-t-20 col-sm-12 p-0\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"health\" tooltip-placement=\"right\" ng-style=\"fnGetHealthColor(gatewayObj.health, gatewayObj)\"><span ng-bind=\"gatewayObj.healthName === gatewayObj.health ? gatewayObj.health : gatewayObj.healthName + \' \' + gatewayObj.health\"></span></button><div class=\"pull-right\"><span class=\"deviceInfoPageIcon phaseIconBorder\" uib-tooltip=\"{{gatewayObj.phase}}\" tooltip-placement=\"left\" ng-style=\"fnGetPhaseIconBorderColor(gatewayObj.phase)\"><span ng-class=\"fnGetPhaseIcon(gatewayObj.phase)\"></span></span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><label class=\"ellipsis\">Type: {{gatewayTypObj.name}}</label></div><div class=\"col-sm-2\"><label class=\"ellipsis\">{{gatewayTypObj.model}}</label></div><div class=\"col-sm-2\"><label class=\"ellipsis\">v{{gatewayTypObj.version}}</label></div><div class=\"col-sm-2 p-r-0 text-right\"><label class=\"ellipsis\">{{\"(\"+gatewayTypObj.id+\")\"}}</label></div></div><div class=\"m-t-0 col-sm-12 p-0\"><label class=\"ellipsis\">OEM: {{gatewayObj.oem}}</label></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isGatewayDetailsLoaded\" ng-class=\"!gatewayPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"gatewayObj.name\" placeholder=\"Name for the Gateway*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"gatewayObj.description\" placeholder=\"Description regarding Gateway\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayObj.modem && !isObjectEmpty(gatewayObj.modem)\"><h2 class=\"m-t-0\">Modem Info</h2></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayObj.modem && !isObjectEmpty(gatewayObj.modem)\" ng-repeat=\"(key, value) in gatewayObj.modem track by $index\"><span><label><span class=\"text-uppercase\">{{key}} :</span></label> {{value}}</span></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateGatewayDetails(gatewayObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((gatewayPermissionsObj.Modify && !isDetailsEditable) || gatewayPermissionsObj.Delete) && isGatewayDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"gatewayPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"gatewayPermissionsObj.Delete\" ng-click=\"fnDeleteGateway(gatewayObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/node/health/healthInfo/healthTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isHealthDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isHealthDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isHealthDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_HEALTH\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_HEALTH\" ng-click=\"fnDeleteHealth(healthObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isHealthDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"healthObj.name\" placeholder=\"Name for the Health*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"healthObj.description\" placeholder=\"Description for the Health*\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"code\" type=\"text\" ng-model=\"healthObj.value\" placeholder=\"Value for the Health*\"> <span class=\"highlight\"></span> <label>Value*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"Color\" type=\"text\" ng-model=\"healthObj.color\" placeholder=\"Color for the Health*\"> <span class=\"highlight\"></span> <label>Color*</label> <small ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"helper-text\">Choose any color from above chart by clicking on it.<br>or you can choose one of the suggested colors below.</small></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"isDetailsEditable\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedLabel in suggestedLabelsArr\" ng-style=\"fnAssignSpanBackground(suggestedLabel)\" ng-click=\"fnAssignSuggestedColor(suggestedLabel)\"></span></div><div class=\"col-sm-12 p-0\" ng-if=\"isDetailsEditable\"><button class=\"btn btn-link p-l-0\" ng-if=\"isDetailsEditable\" ng-click=\"fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"isDisplayMiniColors && isDetailsEditable\"><input minicolors=\"customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"healthObj.color\"></div><div class=\"col-sm-12 p-0 m-b-20 m-t-10 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!healthObj.name.length || !healthObj.value.toString().length || !healthObj.color.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateHealthDetails(healthObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{healthObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(healthObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/iot3/iot3Service/createIot3/createIot3.html","<div class=\"container-with-footer tab-container\" ng-controller=\"createIoT3Ctrl as createIot3\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"createIot3.isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{createIot3.iot3Obj.iot3JSON.info.model}}</span></div><div class=\"col-sm-6 p-0 m-auto d-flex justify-content-flex-end\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Versions\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/iot3versions.svg#iot3versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-repeat=\"versionName in createIot3.iot3Obj.iot3JSON.info.versions track by $index\">{{versionName}}<span ng-if=\"$index !== createIot3.iot3Obj.iot3JSON.info.versions.length - 1\">,</span></span></span></div></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"createIot3.isFullWidthDevice\">{{createIot3.iot3Obj.iot3JSON.info.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!createIot3.isFullWidthDevice\">{{createIot3.iot3Obj.iot3JSON.info.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"createIot3.isFullWidthDevice\">{{createIot3.iot3Obj.iot3JSON.info.description ? createIot3.iot3Obj.iot3JSON.info.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!createIot3.isFullWidthDevice\">{{createIot3.iot3Obj.iot3JSON.info.description ? createIot3.iot3Obj.iot3JSON.info.description : \'\'}}</h5></div><div class=\"col-sm-6 p-0 m-auto d-flex justify-content-flex-end\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{createIot3.iot3Obj.iot3JSON.info.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"createIot3.iot3Obj.iot3JSON.info.createdAt\"><label class=\"ellipsis m-b-0\">Created {{createIot3.iot3Obj.iot3JSON.info.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{createIot3.iot3Obj.iot3JSON.info.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"createIot3.iot3Obj.iot3JSON.info.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{createIot3.iot3Obj.iot3JSON.info.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{createIot3.iot3Obj.iot3JSON.info.author}}\" tooltip-placement=\"auto\" ng-if=\"createIot3.iot3Obj.iot3JSON.info.author\"><label class=\"ellipsis m-b-0\">Authored by {{createIot3.iot3Obj.iot3JSON.info.author}}</label></div></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"createIot3.selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in createIot3.tabs\" select=\"createIot3.fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"createIot3.selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/iot3/iot3Service/iot3Info/iot3Info.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>{{iot3Obj.model}}</span></div><div class=\"col-sm-6 p-0 m-auto d-flex justify-content-flex-end\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Versions\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/iot3versions.svg#iot3versions\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-repeat=\"versionName in iot3Obj.versions track by $index\">{{versionName}}<span ng-if=\"$index !== iot3Obj.versions.length - 1\">,</span></span></span></div></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{iot3Obj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{iot3Obj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{iot3Obj.description ? iot3Obj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{iot3Obj.description ? iot3Obj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{iot3Obj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(iot3Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div><div class=\"col-sm-6 p-0 m-auto d-flex justify-content-flex-end\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3Obj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{iot3Obj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3Obj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{iot3Obj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5 w100\" uib-tooltip=\"{{iot3Obj.author}}\" tooltip-placement=\"auto\" ng-if=\"iot3Obj.author\"><label class=\"ellipsis m-b-0\">Authored by {{iot3Obj.author}}</label></div></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/node/job/jobInfo/jobTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitJobDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isJobDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isJobDetailsLoaded\"><div class=\"col-sm-12 p-0\" style=\"margin: auto;\"><h1>About</h1></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isJobDetailsLoaded\"><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"jobObj.requestTypeString\" placeholder=\"Request Type\"> <span class=\"highlight\"></span> <label>Request Type</label></div><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" id=\"requestedBy\" type=\"text\" ng-model=\"jobObj.requestedBy\" placeholder=\"Requested By\"> <span class=\"highlight\"></span> <label>Requested By</label></div><div class=\"md-input m-b-20 m-t-10 pace\" ng-if=\"jobObj.startsAt\"><input class=\"md-form-control\" required=\"\" id=\"startsTime\" type=\"text\" ng-model=\"jobObj.startsAtTime\" placeholder=\"Starts At\"> <span class=\"highlight\"></span> <label>Starts</label></div><div class=\"md-input m-b-20 m-t-10 pace\" ng-if=\"jobObj.startedAt\"><input class=\"md-form-control\" required=\"\" id=\"startedTime\" type=\"text\" ng-model=\"jobObj.startedAtTime\" placeholder=\"Started At\"> <span class=\"highlight\"></span> <label>Started</label></div><div class=\"md-input m-b-20 m-t-10 pace\" ng-if=\"jobObj.completedAt\"><input class=\"md-form-control\" required=\"\" id=\"completedAt\" type=\"text\" ng-model=\"jobObj.completedAtTime\" placeholder=\"Ended\"> <span class=\"highlight\"></span> <label>Ended</label></div><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" id=\"expiredTime\" type=\"text\" ng-model=\"jobObj.expiresAtTime\" placeholder=\"Expires\"> <span class=\"highlight\"></span> <label>Expires</label></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/lifecycle/lifecycleInfo/lifecycleTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitLifecycle()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isLifecycleDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isLifecycleDetailsLoaded\" ng-class=\"!lifecyclePermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-40\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"lifecycleObj.name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-if=\"lifecycleObj.description\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"lifecycleObj.description\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\" ng-if=\"lifecycleObj.principalId\"><input class=\"md-form-control\" required=\"\" id=\"principalId\" type=\"text\" ng-model=\"lifecycleObj.principalId\"> <span class=\"highlight\"></span> <label>Principal Id*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"requestId\" type=\"text\" ng-model=\"lifecycleObj.requestId\"> <span class=\"highlight\"></span> <label>Request Id*</label></div><div class=\"md-input m-b-20\" ng-if=\"lifecycleObj.deviceId\"><input class=\"md-form-control\" required=\"\" id=\"deviceId\" type=\"text\" ng-model=\"lifecycleObj.deviceId\"> <span class=\"highlight\"></span> <label>Device Id*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"request\" type=\"text\" ng-model=\"lifecycleObj.request\"> <span class=\"highlight\"></span> <label>Request*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"task\" type=\"text\" ng-model=\"lifecycleObj.task\"> <span class=\"highlight\"></span> <label>Task*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"result\" type=\"text\" ng-model=\"lifecycleObj.result\"> <span class=\"highlight\"></span> <label>Result*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"typeId\" type=\"text\" ng-model=\"lifecycleObj.typeId\"> <span class=\"highlight\"></span> <label>Type Id*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"gatewayId\" type=\"text\" ng-model=\"lifecycleObj.gatewayId\"> <span class=\"highlight\"></span> <label>Gateway Id*</label></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{lifecycleObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(lifecycleObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"lifecyclePermissionsObj.Delete && isLifecycleDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"lifecyclePermissionsObj.Delete\" ng-click=\"fnDeleteLifecycle(lifecycleObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/node/node/modals/attributeEditNameModal/attributeEditNameModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeEditModal.fnInitAttributeRenameModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Attribute Rename</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"attributeEditModal.selectedAttribute.name\" placeholder=\"Name\"> <span class=\"highlight\"></span> <label>Name</label></div></div></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"attributeEditModal.isNameUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" ng-if=\"!attributeEditModal.isNameUpdating\" class=\"btn btn-primary pull-left m-r-5 btn-primary-cancel\" ng-click=\"attributeEditModal.fnCancel()\">Cancel</button> <button type=\"button\" ng-if=\"!attributeEditModal.isNameUpdating\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"attributeEditModal.fnUpdateAttributeName()\">Save</button></div></div>");
$templateCache.put("app/node/node/modals/attributeEditValueModal/attributeEditValueModal.html","<div class=\"inmodal h-100\" ng-init=\"attributeEditValue.fnInitAttributeEditValueModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Attribute Update</h3></div><div class=\"modal-body\"><form id=\"iotForm\" role=\"form\" name=\"iotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0\"><span sf-schema=\"attributeEditValue.schema\" sf-form=\"attributeEditValue.form\" sf-model=\"attributeEditValue.model\"></span></div></form></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"attributeEditValue.isValueUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" ng-if=\"!attributeEditValue.isValueUpdating\" class=\"btn btn-primary pull-left m-r-5 btn-primary-cancel\" ng-click=\"attributeEditValue.fnCancel()\">Cancel</button> <button type=\"button\" ng-if=\"!attributeEditValue.isValueUpdating\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"attributeEditValue.fnUpdateAttributeValue()\">{{attributeEditValue.jsonSchema && attributeEditValue.jsonSchema.buttonText ? attributeEditValue.jsonSchema.buttonText : \'Save\'}}</button></div></div>");
$templateCache.put("app/node/node/modals/attributeValueUpdateTerminal/attributeValueUpdateTerminal.html","<div class=\"inmodal h-100\" ng-init=\"attributeValueUpdateTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Update Attribute</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your attribute update you can watch it here in real-time. Closing this window will have no effect on the update.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"attributeValueUpdateTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in attributeValueUpdateTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"attributeValueUpdateTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"attributeValueUpdateTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"attributeValueUpdateTerminal.jobSummary\" ui-codemirror-opts=\"attributeValueUpdateTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"attributeValueUpdateTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/modals/ecuInfoModal/ecuInfoModal.html","<div class=\"inmodal theme_modal\" ng-init=\"ecuInfoModal.fnInitECUNodeModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">{{ecuInfoModal.ecuObj.name}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" ng-if=\"ecuInfoModal.isECULoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-if=\"!ecuInfoModal.isECULoading\"><div class=\"col-sm-12 p-0\">ECU Health: <button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{ecuInfoModal.ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuInfoModal.fnGetHealthColor(ecuInfoModal.ecuObj.health, ecuInfoModal.ecuObj)\"><span class=\"healtSpan\">{{ecuInfoModal.ecuObj.healthName}}</span></button></div><div class=\"col-sm-12 p-0 m-t-10 d-flex align-items-center\"><span class=\"m-r-5\">ECU Connection:</span> <span class=\"d-flex width-max-content p-3 ecu-disconnected-icon\" ng-if=\"ecuInfoModal.ecuObj.connected === false || ecuInfoModal.ecuObj.connected === 0\" uib-tooltip=\"ECU Disconnected\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/nodeECU/disconnected.svg#disconnected\"></use></svg></span> <span class=\"d-flex width-max-content p-3 ecu-connected-icon\" ng-if=\"ecuInfoModal.ecuObj.connected === true || ecuInfoModal.ecuObj.connected === 1\" uib-tooltip=\"ECU Connected\" tooltip-placement=\"auto\"><svg class=\"custom-svg-side-menu-icon\" width=\"18px\" height=\"18px\"><use xlink:href=\"assets/images/svg/service/nodeECU/connected.svg#connected\"></use></svg></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ecuInfoModal.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/node/node/modals/ecuListModal/ecuList.html","<div class=\"inmodal h-100\" ng-init=\"ecuList.fnInitECUListModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">ECU</h3></div><div class=\"modal-body registerNode\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"ecuList.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{ecuList.project.name ? ecuList.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"ecuList.ecuProjectSearch[ecuList.ecuProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in ecuList.filterProject=(ecuList.projectsArr | filter:ecuList.ecuProjectSearch) track by $index\" ng-click=\"ecuList.fnGetProjectEcu(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === ecuList.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!ecuList.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"ecuList.isRefreshData\" search-identifier=\"\'ecuSearch\'\" filters-arr=\"ecuList.searchFiltersArr\" filter-query=\"ecuList.filterQuery\" fn-filter-query-change=\"ecuList.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.ecu\'\" no-set-url=\"true\" fn-resize=\"ecuList.fnSetTableHeight()\" is-column-view=\"ecuList.isColumnView\" default-tag-arr=\"ecuList.defaultECUFilterArr\" sort-field-arr=\"ecuList.sortFieldArr\"></v4-search-client></div></div><div class=\"row\" ng-if=\"ecuList.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"ecuList.isEcusLoading\" fn-resize=\"ecuList.fnSetLoaderTableHeight()\"></table-loader><div class=\"ecus-list-table table-container\"><table id=\"ecusTable\" class=\"table table-striped table-check-box\" ng-if=\"!ecuList.isEcusLoading\"><thead><tr><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\"></th><th class=\"p-r-2\" ng-if=\"ecuList.ecusArr.length\"></th><th ng-if=\"!ecuList.ecusArr.length\">No records found...</th></tr></thead><tbody id=\"ecuTable\"><tr ng-repeat=\"ecuObj in ecuList.ecusArr track by $index\"><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuList.fnGetHealthColor(ecuObj.health, ecuObj)\"><span class=\"healthSpan\">{{ecuObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis label_name d-flex align-items-center\"><div class=\"d-flex m-r-5\" ng-if=\"ecuObj.syncState === \'SYNCHRONIZING\'\" uib-tooltip=\"ECU can not be edited.\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/node/padlock.svg#padlock\"></use></svg></div>{{ecuObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{ecuObj.description}}</span></div></td><td><div class=\"d-flex align-items-center\" ng-if=\"ecuObj.registered\"><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.connected\">Connected</span> <span ng-if=\"!ecuObj.connected\">Disconnected</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Phase\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuPhase.svg#ecuPhase\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><button class=\"btn btn-sm btn-primary v4-primary-button\" ng-if=\"ecuObj.phase === \'UNREGISTERED\'\" ng-click=\"$event.stopPropagation(); ecuList.fnOpenEcuInfoTab(ecuObj,3)\">Register ECU</button> <span ng-if=\"ecuObj.phase === \'REGISTERING\'\">Registering</span> <span ng-if=\"ecuObj.phase === \'ACTIVE\'\">Active</span> <span ng-if=\"ecuObj.phase === \'PENDING_RETURN\'\">Pending Return</span> <span ng-if=\"ecuObj.phase === \'DEREGISTERED\'\">Deregistered</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"d-flex flex-column w100\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div><div class=\"m-t-10 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.lastSeenDate ? ecuObj.lastSeenDate : \'Never\' }}</span></div></div></div><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"!ecuObj.registered\"><div class=\"d-flex flex-column\" style=\"width: 66.66%\"><div class=\"d-flex align-items-center justify-content-center\"><span class=\"ellipsis text-center\">Unregistered ECU</span></div></div><div class=\"d-flex flex-column w100\" style=\"width: 33.33%\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Project\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{ecuObj.project.name}}</span></div></div></div></td><td class=\"text-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"ecuList.fnStartNetworkScan(ecuObj)\">Network Scan</button></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!ecuList.isEcusLoading && ecuList.ecusArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{ecuList.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"ecuList.perPage = 10; ecuList.fnPageChanged(ecuList.currentPage, ecuList.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuList.perPage = 20; ecuList.fnPageChanged(ecuList.currentPage, ecuList.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuList.perPage = 50; ecuList.fnPageChanged(ecuList.currentPage, ecuList.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuList.perPage = 100; ecuList.fnPageChanged(ecuList.currentPage,ecuList.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"ecuList.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"ecuList.currentPage\" items-per-page=\"ecuList.perPage\" max-size=\"ecuList.maxSize\" boundary-links=\"true\" ng-click=\"ecuList.fnPageChanged(ecuList.currentPage, ecuList.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"ecuList.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/modals/iot3Support/iot3Support.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Request a source</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"divider\"></div><h4>To add your source, please contact our support team specifying the source you need.</h4><h4 class=\"d-flex align-items-center\"><i class=\"fa fa-envelope-o m-r-5\"></i> ops@ecsiteapp.com</h4></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"iot3Support.fnCancel()\" tabindex=\"12\">Close</button></div>");
$templateCache.put("app/node/node/modals/jobTerminal/jobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"jobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Tunnel</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\" ng-if=\"!jobTerminal.isShowTerminal\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex align-items-center p-0 p-t-5\" ng-if=\"jobTerminal.nodeDetailsLoading\"><h2 class=\"m-0 font-bold\">Fetching Node Details...</h2></div><div class=\"col-sm-12 d-flex align-items-center p-0 p-t-5\" ng-if=\"!jobTerminal.nodeDetailsLoading\"><h2 class=\"m-0 font-bold\"><label>Select the Type of Tunnel you want to open.</label></h2></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 w100 h-100 d-flex align-items-center justify-content-center p-0 p-t-15\" ng-if=\"jobTerminal.nodeDetailsLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-15\" ng-if=\"!jobTerminal.nodeDetailsLoading && !jobTerminal.tunnelTypes.length\">The node does not support any type of tunnels</div><div class=\"col-sm-12 p-0\" ng-if=\"!jobTerminal.nodeDetailsLoading && jobTerminal.tunnelTypes.length\"><div class=\"col-sm-12 p-15\" ng-class=\"jobTerminal.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{jobTerminal.selectedTunnelType}}</span> <label class=\"titleLabel\">Verify Selector Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"tunnelTypeObj in jobTerminal.tunnelTypes\"><a ng-click=\"jobTerminal.fnSelectTunnelType(tunnelTypeObj)\"><span ng-class=\"tunnelTypeObj.name === jobTerminal.selectedTunnelType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"tunnelTypeObj.name === jobTerminal.selectedTunnelType\"></i></span> <span>{{tunnelTypeObj.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-15\" ng-class=\"jobTerminal.isTunnelRequestActive ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{jobTerminal.selectedTimeout.displayName}}</span> <label class=\"titleLabel\">Tunnel duration</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"timeoutOption in jobTerminal.timeOutOptions\"><a ng-click=\"jobTerminal.fnChangeTimeout(timeoutOption)\"><span ng-class=\"timeoutOption.displayName === jobTerminal.selectedTimeout.displayName ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"timeoutOption.displayName === jobTerminal.selectedTimeout.displayName\"></i></span> <span>{{timeoutOption.displayName}}</span></a></li></ul></div></div></div></div></div></div><div class=\"user-header m-l-0 w100\" ng-if=\"jobTerminal.isShowTerminal\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Open Tunnel</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. You can watch your open tunnel here in real-time. Closing this window will stop the tunnel request.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"jobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in jobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"jobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"jobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"jobTerminal.jobSummary\" ui-codemirror-opts=\"jobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-if=\"!jobTerminal.nodeDetailsLoading && !jobTerminal.isTunnelRequestActive\" ng-click=\"jobTerminal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary m-r-3\" ng-if=\"!jobTerminal.nodeDetailsLoading && !jobTerminal.isShowTerminal && !jobTerminal.isTunnelRequestActive\" ng-class=\"jobTerminal.selectedTunnelType.length ? \'\' : \'pace opacity-5\'\" ng-click=\"jobTerminal.fnRequestNodeTunnel(jobTerminal.nodeObj)\" tabindex=\"12\">Start Tunnel Request</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"jobTerminal.isTunnelRequestActive || jobTerminal.nodeDetailsLoading\"></app-spinner></div></div></div>");
$templateCache.put("app/node/node/modals/mermaidEditor/mermaidEditor.html","<div class=\"inmodal h-100\" ng-init=\"mermaidEditorModal.fnInitMermaidEditor()\"><div class=\"modal-header\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-8 p-0 d-flex align-items-center\"><h3 class=\"modal-title\">Mermaid Editor</h3></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"mermaidEditorModal.fnExpandNodes()\" ng-if=\"mermaidEditorModal.isShowNodeExpandOption\">Expand Nodes</button></div></div></div><div class=\"modal-body nodeMermaidEditorModal\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 position-r hide-toolbar\"><textarea name=\"nodeNotesTextBox\" class=\"content-box mermaidEditorTextBox\" id=\"notes\" ng-change=\"mermaidEditorModal.fnChangeEditorValue()\" ng-model=\"mermaidEditorModal.mdBody\" markdown-editor=\"mermaidEditorModal.newMarkedOptionObj\" rows=\"10\">\n                    </textarea></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"mermaidEditorModal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"mermaidEditorModal.fnSaveNotes()\" tabindex=\"12\">Save</button></div></div></div>");
$templateCache.put("app/node/node/modals/nodeDeleteJobTerminal/nodeDeleteJobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"nodeDeleteJobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Delete node</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your node delete you can watch it here in real-time. Closing this window will have no effect on the delete.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeDeleteJobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeDeleteJobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeDeleteJobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"nodeDeleteJobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"nodeDeleteJobTerminal.jobSummary\" ui-codemirror-opts=\"nodeDeleteJobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"nodeDeleteJobTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/modals/nodeDiscoverJobTerminal/nodeDiscoverJobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"nodeDiscoverJobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Re-discover Nodes</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your node re-discover you can watch it here in real-time. Closing this window will have no effect on the re-discover.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeDiscoverJobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeDiscoverJobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeDiscoverJobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"nodeDiscoverJobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"nodeDiscoverJobTerminal.jobSummary\" ui-codemirror-opts=\"nodeDiscoverJobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"nodeDiscoverJobTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/modals/nodeNotes/nodeNotesModal.html","<div class=\"inmodal h-100\" ng-init=\"nodeNotesModal.fnInitNodeNotesModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{nodeNotesModal.nodeObj.name}}</h3></div><div class=\"modal-body nodeNotesModal\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12\" ng-if=\"nodeNotesModal.isNodeLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!nodeNotesModal.isNodeLoading\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h3>Notes</h3></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"nodeNotesModal.permissionObj.UPDATE_NODE_NOTE && nodeNotesModal.nodeObj.lifecycleState === \'READY\'\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!nodeNotesModal.isDetailsEditable\" ng-click=\"nodeNotesModal.fnEditNodeNotes(\'nodeNotesTextBox\')\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 p-t-10 nodeNoteBody\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 position-r hide-toolbar\" ng-class=\"!nodeNotesModal.isDetailsEditable ? \'preview-only\' : \'\'\"><textarea name=\"nodeNotesTextBox\" class=\"content-box notesTextBox\" id=\"notes\" ng-model=\"nodeNotesModal.mdBody\" placeholder=\"Type your message...\" markdown-editor=\"nodeNotesModal.newCommentMarkedOptionObj\" rows=\"10\">\n                            </textarea></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-4 p-0 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex height-100\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-if=\"nodeNotesModal.isDetailsEditable && !nodeNotesModal.isNotesUpdating\" ng-click=\"nodeNotesModal.fnCancel()\" tabindex=\"12\">Close</button> <button class=\"btn btn-primary m-l-0\" ng-if=\"nodeNotesModal.isDetailsEditable && !nodeNotesModal.isNotesUpdating\" ng-click=\"nodeNotesModal.fnHideShowEditorPreview(\'nodeNotesTextBox\')\"><span class=\"fa fa-eye\"></span> Preview</button></div></div><div class=\"col-sm-8 p-0\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"!nodeNotesModal.isDetailsEditable && !nodeNotesModal.isNotesUpdating\" ng-click=\"nodeNotesModal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"nodeNotesModal.isDetailsEditable && !nodeNotesModal.isNotesUpdating\" ng-click=\"nodeNotesModal.fnSaveNotes(\'nodeNotesTextBox\')\" tabindex=\"12\">Save</button><div class=\"pull-right m-r-10\" ng-if=\"nodeNotesModal.isNotesUpdating\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div>");
$templateCache.put("app/node/node/modals/nodeRenameModal/nodeRenameModal.html","<div class=\"inmodal h-100\" ng-init=\"nodeRename.fnInitNodeRenameModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{nodeRename.isForCascadeRename ? \'Node Rename and Cascade\': \'Node Rename\'}}</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center\" ng-if=\"nodeRename.isNodeInfoLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\" ng-if=\"!nodeRename.isNodeInfoLoading\"><div class=\"col-sm-12 p-0\" ng-class=\"nodeRename.isNameUpdating ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"nodeRename.selectedNodeName\" placeholder=\"Name*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div><div class=\"col-sm-12 p-0\" ng-if=\"nodeRename.isForCascadeRename\"><div>You have selected to cascade the node name overwrite in all the sub-nodes.</div><div>Here is a list of all sub-nodes that will have their name overwrite with this one.</div></div><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"nodeRename.isForCascadeRename\"><ul class=\"p-0\" style=\"list-style: none;\"><li><strong>{{nodeRename.selectedNode.name}}</strong></li><li class=\"p-l-20\" ng-repeat=\"node in nodeRename.selectedNode.children\" ng-if=\"nodeRename.selectedNode.children && nodeRename.selectedNode.children.length\" ng-include=\"\'nodes_name_renderer.html\'\"></li></ul><script type=\"text/ng-template\" id=\"nodes_name_renderer.html\"><div class=\"col-sm-12 p-0\"> <div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-init=\"node.isCheck = true\"> <div class=\"d-flex align-items-center\"> <input type=\"checkbox\" id=\"chk_{{node.id}}\" ng-model=\"node.isCheck\"/> <label for=\"chk_{{node.id}}\" class=\"check-box\"></label> </div> <div class=\"d-flex align-items-center p-l-10\"> <strong>{{node.name}}</strong> </div> </div> </div> <ul class=\"p-0\" style=\"list-style: none;\" ng-if=\"node.children && node.children.length\"> <li class=\"p-l-20\" ng-repeat=\"node in node.children\" ng-include=\"\'nodes_name_renderer.html\'\"> </li> </ul></script></div></div></div><div class=\"modal-footer\"><div class=\"m-t-5 pull-right\" ng-if=\"nodeRename.isNameUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button type=\"button\" ng-if=\"!nodeRename.isNameUpdating\" class=\"btn btn-primary pull-left m-r-5 btn-primary-cancel\" ng-click=\"nodeRename.fnCancel()\">Cancel</button> <button type=\"button\" ng-if=\"!nodeRename.isNameUpdating && !nodeRename.isNodeInfoLoading\" ng-disabled=\"!nodeRename.selectedNodeName.length\" class=\"btn btn-primary pull-right v4-primary-button\" ng-click=\"nodeRename.fnUpdateNodeName()\">Save</button></div></div>");
$templateCache.put("app/node/node/modals/nodeSyncModal/nodeSyncModal.html","<div class=\"inmodal h-100\" ng-init=\"nodeSyncModal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Synchronizing Node</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Synchronizing Node you can watch it here in real-time. Closing this window will have no effect on the Synchronizing.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"nodeSyncModal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in nodeSyncModal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"nodeSyncModal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"nodeSyncModal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"nodeSyncModal.jobSummary\" ui-codemirror-opts=\"nodeSyncModal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"nodeSyncModal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/modals/updateNodeIoT3Modal/updateNodeIoT3Modal.html","<div class=\"inmodal h-100\" ng-init=\"updateNode.fnInitUpdateNodeIoT3Modal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Update IoT3</h3></div><div class=\"modal-body updateIoT3Modal\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!updateNode.isIoT3FileSelected\"><input id=\"upload-file-selector\" ng-model=\"updateNode.fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3\" style=\"visibility:hidden; height: 0px;width: 0px\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"updateNode.fnUpdateIoT3File()\" style=\"visibility:hidden; height: 0px;width: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import IoT3 File</a></div><div class=\"col-sm-12 p-0 h-100 d-flex flex-column\" ng-if=\"updateNode.isIoT3FileSelected\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-t-0\">Security Registration</h3></div><div class=\"col-sm-12 p-0 main-height\"><div class=\"col-sm-6 p-0 h-100 d-flex\"><div class=\"col-sm-12 m-r-5 box-border p-0\"><div class=\"col-sm-12\"><h4 class=\"m-t-10\">New Security Registration</h4></div><div class=\"col-sm-12 d-flex p-t-10 sub-height\"><form id=\"newIotForm\" role=\"form\" name=\"newIotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"updateNode.newSchema\" sf-form=\"updateNode.newForm\" sf-model=\"updateNode.newModel\"></div><button type=\"button\" class=\"btn btn-primary\" style=\"display: none\" ng-disabled=\"updateNode.fnCheckIot3Validation(newIotForm.$valid)\">Continue</button></form></div></div></div><div class=\"col-sm-6 p-0 h-100 d-flex\"><div class=\"col-sm-12 m-l-5 box-border p-0\"><div class=\"col-sm-12\"><h4 class=\"m-t-10\">Old Security Registration</h4></div><div class=\"col-sm-12 d-flex p-t-10 sub-height\"><form id=\"iotForm\" role=\"form\" name=\"iotForm\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"col-sm-12 p-0 d-flex flex-column\" sf-schema=\"updateNode.oldSchema\" sf-form=\"updateNode.oldForm\" sf-model=\"updateNode.oldModel\"></div></form></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"updateNode.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-click=\"updateNode.fnUpdateNode()\" ng-if=\"updateNode.isIoT3FileSelected && !updateNode.isNodeRegistering\" ng-disabled=\"!updateNode.isIoT3FormValid\">Update</button><div class=\"pull-right\" ng-if=\"updateNode.isNodeRegistering\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/node/node/modals/viewAttributes/viewAttributes.html","<div class=\"inmodal h-100\" ng-init=\"viewAttribute.fnInitViewAttributesModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{viewAttribute.selectedNode.type }} Attributes</h3></div><div class=\"modal-body nodeViewAttributesBody registerNode p-l-0 p-r-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" ng-model=\"viewAttribute.searchText\" type=\"text\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"node-view-attributes-table table-container\"><table id=\"nodeViewAttributesTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\">Name</th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\">Properties</th><th ng-if=\"!searchFilterArr.length\">No records found...</th></tr></thead><tbody id=\"nodeViewAttributesTableBody\"><tr ng-repeat=\"attributeObj in searchFilterArr=(viewAttribute.attributes | filter:viewAttribute.searchText) track by $index\"><td><label class=\"d-flex align-items-center ellipsis m-b-0\">{{attributeObj.displayName}}</label></td><td><label class=\"d-flex align-items-center ellipsis m-b-0\">{{attributeObj.mode}}</label></td></tr></tbody></table></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"viewAttribute.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isNodeDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isNodeDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isNodeDetailsLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-4 p-l-0\"><label class=\"ellipsis\">OEM: {{nodeObj.meta.oem}}</label></div><div class=\"col-sm-4 p-l-0\"><label class=\"ellipsis\">Model: {{nodeObj.meta.model}}</label></div><div class=\"col-sm-4 p-r-0\"><label class=\"ellipsis text-right\">Version: V{{nodeObj.meta.version}}</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"nodeObj.name\" placeholder=\"Name for the Node*\"> <span class=\"highlight\"></span> <label>Name*</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"nodeObj.description\" placeholder=\"Description for the Node*\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Security Registration Information</label></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 d-flex flex-column pace\" ng-if=\"!isDetailsEditable && form.length\" sf-schema=\"schema\" sf-form=\"form\" sf-model=\"model\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!form.length\"><span>The node does not specify security registration data.</span></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Energy</label></div><div class=\"panel-body\"><div class=\"d-flex flex-column\" ng-if=\"nodeEnergyObj.value && nodeEnergyObj.value !== \'\' && nodeEnergyObj.unit && nodeEnergyObj.unit !== \'\'\"><div><span class=\"m-0 font-bold\" style=\"font-size: 24px\">{{nodeEnergyObj.value}}</span><span class=\"p-l-5\">{{nodeEnergyObj.unit}}</span></div><div class=\"m-t-10\"><span class=\"text-primary\" ng-click=\"fnGotoTelemetryTab()\">See live energy telemetry</span></div></div><div ng-if=\"(!nodeEnergyObj.value || nodeEnergyObj.value === \'\') && (!nodeEnergyObj.unit || nodeEnergyObj.unit === \'\')\"><span>The unit does not specify a live energy data feed.</span></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isDetailsEditable\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><label class=\"m-0\">Price</label></div><div class=\"panel-body\"><span class=\"m-0 font-bold\" style=\"font-size: 24px\" ng-if=\"nodePriceObj.value && nodePriceObj.value !== \'\'\">{{nodePriceObj.value}}</span> <span class=\"p-l-5\" ng-if=\"nodePriceObj.unit && nodePriceObj.unit !== \'\'\">{{nodePriceObj.unit}}</span><div ng-if=\"(!nodePriceObj.value || nodePriceObj.value === \'\') && (!nodePriceObj.unit || nodePriceObj.unit === \'\')\"><span>The unit does not specify a price data.</span></div></div></div></div><div class=\"col-sm-12 p-0\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!nodeObj.name.length\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateNodeDetails(nodeObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/notification/notificationInfo/notificationTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitNotification()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isNotificationDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isNotificationDetailsLoaded && !isDetailsEditable\"><div class=\"inputDivForNotification\"><div class=\"md-input m-b-20 m-t-20\" ng-class=\"!notificationPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"notificationObj.name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-class=\"!notificationPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"notificationObj.description\" placeholder=\"Description regarding notification\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div class=\"col-sm-12 p-0\" id=\"notificationParentDiv\"><div id=\"notificationDesign\"><div class=\"p-10 text-center notificationDetails\" id=\"functionModal\" style=\"width: fit-content;height: fit-content;\"><div class=\"p-15 thingDiv\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right m-t-5\"><span class=\"label label-default\" ng-bind=\"notificationObj.state\" ng-class=\"{\'ACTIVE\':\'blue-bg\' ,\'INACTIVE\':\'red-bg\'}[notificationObj.state]\"></span></div><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-calendar\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.window.always\"><span>Notification enabled 24 / 7 / 365</span></div><div class=\"col-sm-12 p-0\" ng-if=\"!notificationObj.window.always\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.window.daysOfTheWeek.length\"><span ng-repeat=\"day in notificationObj.window.daysOfTheWeek\">{{dayName[day-1]}}<span ng-if=\"!$last\">,</span></span></div><div class=\"col-sm-12 p-0\">{{notificationObj.window.startHour+\":\"+notificationObj.window.startMinute+ \" (\"+notificationObj.window.timezone+\") and \"+ notificationObj.window.endHour+\":\"+notificationObj.window.endMinute+ \" (\"+notificationObj.window.timezone+\")\"}}</div></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-heartbeat\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\"><span ng-if=\"notificationObj.target.beforeHealth !==\'\' && notificationObj.target.afterHealth !==\'\'\">When <span ng-if=\"notificationObj.target.scope === \'ATTRIBUTE\'\">an Attribute</span> <span ng-if=\"notificationObj.target.scope === \'DEVICE\'\">a Device</span> <span ng-if=\"notificationObj.target.scope === \'COMPONENT\'\">a Component</span> <span ng-if=\"notificationObj.target.scope === \'GATEWAY\'\">a Gateway</span> health changes from <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"notificationObj.target.beforeHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"notificationObj.target.beforeHealth !== -1\" ng-style=\"fnGetHealthColor(notificationObj.target.beforeHealth)\"><span class=\"healtSpan\">{{fnGetHealthColor(notificationObj.target.beforeHealth).content}}</span></button> to <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"notificationObj.target.afterHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"notificationObj.target.afterHealth !== -1\" ng-style=\"fnGetHealthColor(notificationObj.target.afterHealth)\"><span class=\"healtSpan\">{{fnGetHealthColor(notificationObj.target.afterHealth).content}}</span></button></span></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><div class=\"fxIcon\"><span><em>f<small>(x)</small></em></span></div></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.function.type === \'NONE\'\"><span>No function have been selected</span></div><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.function.type === \'REVERSE_LOOKUP\'\"><span>The health must have remained unchanged in<div class=\"p-r-5\" style=\"display: inline-block\" ng-class=\"$index === 0?\'p-l-5\':\'\'\" ng-repeat=\"acceptableHealth in notificationObj.function.settings.acceptableHealths track by $index\"><button class=\"btn btn-xs btn-default m-t-2\" ng-style=\"fnGetHealthColor(acceptableHealth)\"><span class=\"healtSpan\">{{fnGetHealthColor(acceptableHealth).content}}</span></button> <span ng-if=\"$index !== notificationObj.function.settings.acceptableHealths.length - 2 && !$last\">,</span> <span ng-if=\"$index === notificationObj.function.settings.acceptableHealths.length - 2\">or</span></div>for {{notificationObj.function.settings.seconds === 0 ?\'0 seconds\': secondsToHms(notificationObj.function.settings.seconds);}}</span></div></div></div></div><div class=\"p-15 p-t-40 thingDiv actionDivArrow\"><div class=\"panel panel-default m-b-0\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-0 m-b-0 text-left\"><i class=\"fa fa-2x fa-at\"></i></h3></div><div class=\"panel-body text-left\"><div class=\"col-sm-12 p-0\" ng-if=\"notificationObj.dispatch.settings.emails\"><div class=\"col-sm-2 p-0\">To:</div><div class=\"col-sm-10 p-0\"><span ng-repeat=\"email in notificationObj.dispatch.settings.emails\"><span>{{email}}<sapn ng-if=\"!$last\">,</sapn></span><br></span></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12\" ng-if=\"isNotificationDetailsLoaded && isDetailsEditable\"><ng-include src=\"\'app/node/notification/createNotification/editNotification.html\'\"></ng-include></div></div><div class=\"col-sm-12 content-footer\" id=\"test\" ng-if=\"!isDetailsEditable\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{notificationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(notificationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem\" ng-class=\"!isNotificationStateUpdateCompleted ?\'m-0\':\'\'\"><div ng-if=\"isNotificationStateUpdateCompleted\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((notificationPermissionsObj.Modify && !isDetailsEditable) || notificationPermissionsObj.Delete) && isNotificationDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"notificationPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeNotificationState(notificationObj)\"><a class=\"btn btn-link\">{{notificationObj.state === \'ACTIVE\' ?\'Deactivate\':\'Activate\'}}</a></li><li ng-if=\"notificationPermissionsObj.Create && !isDetailsEditable\" ng-click=\"fnCloneNotification(notificationObj)\"><a class=\"btn btn-link\">Clone</a></li><li ng-if=\"notificationPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable(notificationObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"notificationPermissionsObj.Delete\" ng-click=\"fnDeleteNotification(notificationObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div><div class=\"p-t-1 pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!isNotificationStateUpdateCompleted\"></div></div></div></div>");
$templateCache.put("app/node/observer/modal/updateObserverJobTerminal/updateObserverJobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"updateObserverJobTerminal.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">Updating Observer</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your Updating Observer you can watch it here in real-time. Closing this window will have no effect on the updation.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"updateObserverJobTerminal.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in updateObserverJobTerminal.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"updateObserverJobTerminal.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"updateObserverJobTerminal.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"updateObserverJobTerminal.jobSummary\" ui-codemirror-opts=\"updateObserverJobTerminal.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"updateObserverJobTerminal.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/observer/observerInfo/observerTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitObserver()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isObserverDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isObserverDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"observerConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isObserverDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_OBSERVER\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_OBSERVER\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset Observer Script</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!observerConfigObj.scriptBody.length\" ng-click=\"fnSaveScript()\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isProjectDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isProjectDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isProjectDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_PROJECT\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteProject(projectObj)\" ng-if=\"projectObj.parentProjectId && userPermissionsObj.DELETE_PROJECT\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isProjectDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"projectForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\" ng-if=\"projectObj.parentProjectId\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Parent Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!projectObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateProjectDetails(projectObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/project_emailTemplate/node_project_emailTemplate/node_project_emailTemplateSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitEmailTemplate()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isEmailTemplateDataLoading\"></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"!isEmailTemplateDataLoading\"><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput email-template-toolbar\"><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">From*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><input class=\"md-form-control p-t-5 p-b-5 p-l-10 border-0\" id=\"email\" type=\"email\" required=\"\" ng-pattern=\"emailPattern\" name=\"email\" placeholder=\"Email From*\" ng-change=\"fnCheckEmail()\" ng-model=\"templateConfigObj.emailFrom\"> <span class=\"highlight\"></span> <span style=\"position: absolute;top: 6px;right: 10px;\" ng-show=\"!isEmailValid\" uib-tooltip=\"Please enter valid email address.\" tooltip-placement=\"auto\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\"></i></span></div></div></div><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 p-t-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">Subject*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\"><input class=\"md-form-control border-0 p-t-5 p-b-5 p-l-10\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\" id=\"subject\" type=\"text\" required=\"\" name=\"subject\" placeholder=\"Email Subject*\" ng-model=\"templateConfigObj.emailSubject\"> <span class=\"highlight\"></span> <small class=\"helper-text\"></small></div></div></div><div class=\"d-flex w100 justify-content-flex-end p-t-5 p-b-5 p-l-5 email-template-border-bottom\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"bold()\">B</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"italic()\"><i>I</i></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"underline()\"><u>U</u></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"strike()\"><span style=\"text-decoration: line-through;\">S</span></button></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end h-100 align-items-center\"><button class=\"btn btn-link p-0\" ng-click=\"isShowVariables = !isShowVariables\">Variable</button> <button class=\"btn btn-link p-0 m-l-10 m-r-10\" ng-click=\"isShowVariables = false;fnViewRenderedHTML(isShowPrviewRenderedHTML ?false : true)\">{{isShowPrviewRenderedHTML ? \'Code\' : \'Preview\'}}</button></div></div></div></div><div class=\"col-sm-12 p-0 email-body\"><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-if=\"!isShowPrviewRenderedHTML && !isShowVariables\"><ui-codemirror ng-model=\"templateConfigObj.mjmlBody\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-init=\"fnViewRenderedHTML(true)\" ng-if=\"isShowPrviewRenderedHTML && !isShowVariables\"><div class=\"h-100 overflow-auto d-flex justify-content-center align-items-center\" ng-if=\"isTemplateLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"h-100 overflow-auto\" ng-if=\"!isTemplateLoading\"><div class=\"col-sm-12 p-0 h-100\" id=\"htmlParse\"></div></div></div><div class=\"col-sm-12 p-t-10 email-template-min-height\" ng-if=\"isShowVariables\"><label>Available Variables:</label><table border=\"1\" class=\"w100 variables-table\"><thead><tr class=\"variables-header\"><th class=\"p-5\">Name</th><th class=\"p-5\">Description</th></tr></thead><tbody><tr ng-repeat=\"(key,val) in templateConfigObj.emailVariables track by $index\"><td class=\"p-5\"><label>{{key}}</label></td><td class=\"p-5\">{{val}}</td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\" class=\"d-flex justify-content-center align-items-center m-r-10 m-t-3\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\" ng-if=\"!isValidTemplate\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"isValidTemplate\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable && !isValidTemplate\" ng-click=\"fnValidateTemplate()\">Validate Template</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isTemplateEditable && !isEmailTemplateDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_PROJECT_EMAIL_TEMPLATE\" ng-click=\"fnChangeToEditable(true)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_PROJECT_EMAIL_TEMPLATE\" ng-click=\"fnResetEmailTemplate(true)\"><a class=\"btn btn-link\">Reset Email Template</a></li></ul></div><button class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-if=\"isTemplateEditable && !isValidatingTemplate && !isSaveChanges\" ng-click=\"fnChangeToEditable()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button border-right-0 p-r-4\" ng-disabled=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid\" ng-click=\"fnSaveEmailTemplate(false, \'\')\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\">Save Changes</button><div class=\"customDropdown d-flex h-100 script-dropdown\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm border-left-0 m-l-0 p-l-4 v4-primary-button d-flex align-items-center\" ng-class=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"fnOpenTemplateModal()\"><a><span>Save and Cascade</span></a></li></ul></div></div><div class=\"pull-right\" ng-if=\"isValidatingTemplate || isSaveChanges && isTemplateEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/node/project_script/node_project_scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_PROJECT_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_PROJECT_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button border-right-0 p-r-4\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-if=\"!isSaveChanges && isScriptEditable\" ng-click=\"fnSaveScript(false, \'\')\">Save Changes</button><div class=\"customDropdown d-flex h-100 script-dropdown\" ng-if=\"!isSaveChanges && isScriptEditable\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm border-left-0 m-l-0 p-l-4 v4-primary-button d-flex align-items-center\" ng-class=\"!scriptConfigObj.scriptBody.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"fnOpenScriptModal()\"><a><span>Save and Cascade</span></a></li></ul></div></div><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/node/script/scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-click=\"fnSaveScript()\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/node/software/modals/softwareBroadcast/softwareBroadcast.html","<div class=\"inmodal h-100\" ng-init=\"softwareBroadcast.fnInitSoftwareBroadcastModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Software Broadcast</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 floatingLabelInput custom-sql-editor\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"softwareBroadcast.isSoftwareSearchDataLoading\" ng-click=\"softwareBroadcast.fnRunSoftwareSearchQuery()\">Run Query</button> <button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"isAdvanceSearchDataLoading\" ng-click=\"softwareBroadcast.fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-12 p-0 p-t-10 m-b-20\"><span>QUERY</span><div class=\"m-b-20 editorMedium\"><javascript-editor value=\"softwareBroadcast.softwareQueryConfig.value\" available-defs=\"softwareBroadcast.availableDataLibs\" editor-value=\"softwareBroadcast.softwareQueryConfig.editorValue\" read-only=\"!softwareBroadcast.isSoftwareSearchDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div><div class=\"col-sm-12 p-0\" ng-if=\"softwareBroadcast.isSoftwareSearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" style=\"overflow-x: auto\" ng-if=\"!softwareBroadcast.isSoftwareSearchDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"softwareBroadcast.softwareSearchData.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in softwareBroadcast.softwareSearchDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in softwareBroadcast.softwareSearchData\"><td ng-repeat=\"header in softwareBroadcast.softwareSearchDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"softwareBroadcast.fnGetTdStyle(data[header])\"><span class=\"ellipsis\" ng-if=\"softwareBroadcast.fnGetType(data[header]) === \'string\'\">\'{{data[header]}}\'</span> <span class=\"ellipsis\" ng-if=\"softwareBroadcast.fnGetType(data[header]) !== \'string\' && softwareBroadcast.fnGetType(data[header]) !== \'object\'\">{{data[header]}}</span><json-formatter ng-if=\"softwareBroadcast.fnGetType(data[header]) === \'object\' && softwareBroadcast.fnGetType(data[header]) !== \'null\'\" json=\"data[header]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!softwareBroadcast.softwareSearchData.length\">No records found...</div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!softwareBroadcast.isBroadcastNewECUSoftware\" ng-click=\"softwareBroadcast.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end\"><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"softwareBroadcast.isBroadcastNewECUSoftware\"></app-spinner><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!softwareBroadcast.isBroadcastNewECUSoftware\" ng-click=\"softwareBroadcast.fnBroadcastECUSoftware(softwareBroadcast.selectedSoftware)\">Broadcast</button></div></div></div></div>");
$templateCache.put("app/node/software/modals/softwareJobTerminal/softwareJobTerminal.html","<div class=\"inmodal h-100\" ng-init=\"softwareJob.fnInitJobTerminalModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Job</h3></div><div class=\"modal-body p-0\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"user-header m-l-0 w100\"><div class=\"col-sm-12 p-15 dashboard-header\"><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\">New ECU Software Version</h1></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"></div></div><div class=\"col-sm-12 d-flex p-0 m-t-10\"><div class=\"col-sm-12 p-0\"><span class=\"m-0\">This process can take several minutes. If you would like to see your new ECU software version you can watch it here in real-time. Closing this window will have no effect on the ECU software version.</span></div></div></div><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"softwareJob.selectedJobTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in softwareJob.jobTabs\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent1\" ng-if=\"softwareJob.selectedJobTabIndex === 1\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"softwareJob.fnIntiJob()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"softwareJob.jobSummary\" ui-codemirror-opts=\"softwareJob.jobEditorOptions\"></ui-codemirror></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button type=\"button\" class=\"btn btn-primary m-r-3\" ng-click=\"softwareJob.fnCancel()\" tabindex=\"12\">Close</button></div></div></div>");
$templateCache.put("app/node/software/softwareInfo/softwareSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitSoftware()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isSoftwareDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isSoftwareDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\"></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isSoftwareDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"softwareObj.architecture\" placeholder=\"Architecture*\"> <span class=\"highlight\"></span> <label>Architecture*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><textarea class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" style=\"resize: none\" ng-model=\"softwareObj.description\" rows=\"10\" readonly=\"\" placeholder=\"Description\" name=\"description\">\n                    </textarea> <span class=\"highlight\"></span> <label class=\"activeLabel\">Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"version\" type=\"text\" ng-model=\"softwareObj.version\" placeholder=\"Version*\"> <span class=\"highlight\"></span> <label>Version*</label></div></div><div class=\"col-sm-12 p-0\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"latest\" type=\"text\" ng-model=\"softwareObj.latest\" placeholder=\"Latest*\"> <span class=\"highlight\"></span> <label>Latest*</label></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{softwareObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(softwareObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/configuration.html","<div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Grid\'\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-20 m-t-15\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"typeObj as typeObj.value for typeObj in createDeviceGatewayVisualizer.gridColumsOptionsArr | filter:{value:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"gridValueTemplate.html\" typeahead-on-select=\"createDeviceGatewayVisualizer.fnSelectedGridValue(createDeviceGatewayVisualizer.gridValue)\" ng-model=\"createDeviceGatewayVisualizer.gridValue\" placeholder=\"Enter Columns*\"> <span class=\"highlight\"></span> <label>Columns*</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Table\'\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div><input type=\"checkbox\" id=\"checkAll\" ng-model=\"createDeviceGatewayVisualizer.isAllChecked\" ng-click=\"createDeviceGatewayVisualizer.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label> <label>Select All</label></div><div ng-repeat=\"(key, value) in createDeviceGatewayVisualizer.tableOptionsObj\"><input type=\"checkbox\" id=\"chk_{{key}}\" ng-model=\"createDeviceGatewayVisualizer.tableOptionsObj[key]\" ng-change=\"createDeviceGatewayVisualizer.fnCheckUncheckHeader()\"> <label for=\"chk_{{key}}\" class=\"check-box\"></label> <label class=\"t-p-0 t-m-0\" style=\"text-transform: capitalize\">{{key}}</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Geomap\'\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-t-5 m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"latitude\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.metaDataObj.lat\" placeholder=\"Latitude key mapping of the Geomap*\"> <span class=\"highlight\"></span> <label>Latitude Key Mapping*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"longitude\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.metaDataObj.long\" placeholder=\"Longitude key mapping of the Geomap*\"> <span class=\"highlight\"></span> <label>Longitude Key Mapping*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"defaultZoom\" type=\"number\" ng-model=\"createDeviceGatewayVisualizer.metaDataObj.defaultZoom\" max=\"100\" step=\"any\" placeholder=\"Default Zoom of the Geomap\"> <span class=\"highlight\"></span> <label>Default Zoom</label> <small class=\"helper-text\"></small></div><label class=\"m-b-10\">Geomap default center co-ordinates</label><br><div class=\"col-sm-12 m-t-10 p-0\"><div class=\"md-input m-b-20 p-0 col-sm-5\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.metaDataObj.defaultLat\" placeholder=\"Latitude of the Geomap\"> <span class=\"highlight\"></span> <label>Latitude</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-2 p-0 text-center\"></div><div class=\"md-input m-b-20 p-0 col-sm-5\"><input class=\"md-form-control\" id=\"value\" type=\"text\" required=\"\" ng-model=\"createDeviceGatewayVisualizer.metaDataObj.defaultLong\" placeholder=\"Longitude of the Geomap\"> <span class=\"highlight\"></span> <label>Longitude</label> <small class=\"helper-text\"></small></div></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Treemap\'\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"m-t-15 text-center\"><label>There are no configuration options available for this layout.</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"m-t-15 text-center\"><label>Please select a Layout type in details tab to see configuration options.</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"gridValueTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.value\"></span> </div> <br> </a></script>");
$templateCache.put("app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/details.html","<div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12 floatingLabelInput\"><form role=\"form\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-t-5 m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"typeId\" type=\"text\" tabindex=\"-1\" ng-model=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId\" placeholder=\"Type for which the Visualizer is made for.*\"> <span class=\"highlight\"></span> <label>Type*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name\" placeholder=\"Name for the new Visualizer*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.description\" placeholder=\"Description regarding Visualizer\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createDeviceGatewayVisualizer.faIcons | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"IconTemplate.html\" typeahead-on-select=\"createDeviceGatewayVisualizer.fnSelectIcon(createDeviceGatewayVisualizer.selectedIcon)\" ng-model=\"createDeviceGatewayVisualizer.selectedIcon\" placeholder=\"Icon for the Visualizer*\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createDeviceGatewayVisualizer.layoutArray | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" ng-model=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" placeholder=\"Layout for the Visualizer*\"> <span class=\"highlight\"></span> <label>Layout*</label> <small class=\"helper-text\"></small></div></form></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"layoutTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model\"></span> </div> <br> </a></script><script type=\"text/ng-template\" id=\"IconTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model\"></span> </div> <div class=\"pull-right p-r-0\"> <i class=\"fa \" ng-class=\"\'fa-\'+match.model\"></i> </div> <br> </a></script></div>");
$templateCache.put("app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/layout.html","<div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Table\'\" ng-init=\"createDeviceGatewayVisualizer.fnInitLayout()\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-if=\"!createDeviceGatewayVisualizer.isLayoutDataLoaded\"></app-spinner><div id=\"tableContainerLayout\" ng-if=\"createDeviceGatewayVisualizer.isLayoutDataLoaded\"><table class=\"table table-striped table-check-box\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId !== \'Device\'\"><thead><tr ng-if=\"createDeviceGatewayVisualizer.layoutArr.length\"><th class=\"p-r-2 p-l-5\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.health\">Health</th><th class=\"p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.name\">Name</th><th class=\"p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.description\">Description</th><th class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.phase\">Phase</th><th class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.connection\">Connection</th></tr><tr ng-if=\"!createDeviceGatewayVisualizer.layoutArr.length\"><th ng-if=\"!createDeviceGatewayVisualizer.layoutArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"attrObj in createDeviceGatewayVisualizer.layoutArr | filter: createDeviceGatewayVisualizer.layoutSearch track by $index\"><td class=\"p-r-2 p-l-5\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.health\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{attrObj.healthName}}\" tooltip-placement=\"top\" ng-style=\"createDeviceGatewayVisualizer.fnGetHealthColor(attrObj.health, attrObj)\"><span>{{attrObj.healthName}}</span></button></td><td class=\"p-l-10\" ng-bind=\"attrObj.name\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.name\">Doe</td><td class=\"p-l-10\" ng-bind=\"attrObj.description\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.description\">Doe</td><td class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.phase\"><span uib-tooltip=\"{{attrObj.phase}}\" tooltip-placement=\"top\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"createDeviceGatewayVisualizer.fnGetPhaseIconBorderColor(attrObj.phase)\"><span ng-class=\"createDeviceGatewayVisualizer.fnGetPhaseIcon(attrObj.phase)\"></span></span></td><td class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.connection\"><span class=\"fa gatewayConnectionIcon\" ng-if=\"attrObj.connection\" uib-tooltip=\"{{attrObj.connection}}\" tooltip-placement=\"top\" ng-style=\"createDeviceGatewayVisualizer.fnGetConnectionIconColor(attrObj.connection)\" ng-class=\"createDeviceGatewayVisualizer.fnGetConnectionIcon(attrObj.connection)\"></span></td></tr></tbody></table><table class=\"table table-striped table-check-box\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId === \'Device\'\"><thead><tr ng-if=\"createDeviceGatewayVisualizer.layoutArr.length\"><th class=\"p-r-2 p-l-5\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.health\">Health</th><th class=\"p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.name\">Name</th><th class=\"p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.description\">Description</th><th class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.gateway\"></th><th class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.connection\"></th><th class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.phase\"></th></tr><tr ng-if=\"!createDeviceGatewayVisualizer.layoutArr.length\"><th ng-if=\"!createDeviceGatewayVisualizer.layoutArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"attrObj in createDeviceGatewayVisualizer.layoutArr | filter: createDeviceGatewayVisualizer.layoutSearch track by $index\"><td class=\"p-r-2 p-l-5\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.health\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{attrObj.healthName}}\" tooltip-placement=\"top\" ng-style=\"createDeviceGatewayVisualizer.fnGetHealthColor(attrObj.health, attrObj)\"><span>{{attrObj.healthName}}</span></button></td><td class=\"p-l-10\" ng-bind=\"attrObj.name\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.name\">Doe</td><td class=\"p-l-10\" ng-bind=\"attrObj.description\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.description\">Doe</td><td class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.gateway\"><i class=\"fa fa-microchip\"></i></td><td class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.connection\"><span ng-class=\"attrObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" uib-tooltip=\"{{attrObj.connection}}\" tooltip-placement=\"top\"></span></td><td class=\"text-center p-l-10\" ng-if=\"createDeviceGatewayVisualizer.tableOptionsObj.phase\"><span uib-tooltip=\"{{attrObj.phase}}\" tooltip-placement=\"top\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"createDeviceGatewayVisualizer.fnGetPhaseIconBorderColor(attrObj.phase)\"><span ng-class=\"createDeviceGatewayVisualizer.fnGetPhaseIcon(attrObj.phase)\"></span></span></td></tr></tbody></table></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(\'table\')\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Grid\'\" ng-init=\"createDeviceGatewayVisualizer.fnInitLayout()\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"node-menu-container\"><ul><li class=\"dropdown\"><a title=\"Border color\"><i class=\"fa fa-lg fa-sticky-note-o\"></i></a><div class=\"dropdown-content\"><div><input minicolors=\"{position: \'bottom right\',inline: true}\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.gridBorderColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-b-10 p-0\"><input class=\"md-form-control m-t-0\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.gridBorderColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-0\"><div class=\"col-sm-4 p-0 displayText\">Opacity :</div><div class=\"col-sm-4 col-sm-offset-1 p-0\"><input class=\"md-form-control m-t-0\" type=\"number\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"createDeviceGatewayVisualizer.gridBorderOpacity\"></div></div><div class=\"p-t-15 p-b-10\"><div class=\"row text-center\"><div class=\"col-sm-2 p-0 displayText\">0</div><div class=\"col-sm-8 p-0\"><input type=\"range\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"createDeviceGatewayVisualizer.gridBorderOpacity\" class=\"slider-color\"></div><div class=\"col-sm-2 p-0 displayText\">1</div></div></div></div></li><li class=\"dropdown\"><a title=\"Background color\"><i class=\"fa fa-lg fa-sticky-note\"></i></a><div class=\"dropdown-content\"><div><input minicolors=\"{position: \'bottom right\',inline: true}\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.gridBgColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-b-10 p-0\"><input class=\"md-form-control m-t-0\" type=\"text\" ng-model=\"createDeviceGatewayVisualizer.gridBgColor\"></div><div class=\"divider\"></div><div class=\"p-t-10 col-sm-12 p-0\"><div class=\"col-sm-4 p-0 displayText\">Opacity :</div><div class=\"col-sm-4 col-sm-offset-1 p-0\"><input class=\"md-form-control m-t-0\" type=\"number\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"createDeviceGatewayVisualizer.gridBgOpacity\"></div></div><div class=\"p-t-15 p-b-10\"><div class=\"row text-center\"><div class=\"col-sm-2 p-0 displayText\">0</div><div class=\"col-sm-8 p-0\"><input type=\"range\" ng-change=\"createDeviceGatewayVisualizer.fnSetGridLayoutOptions()\" step=\"0.01\" min=\"0\" max=\"1\" ng-model=\"createDeviceGatewayVisualizer.gridBgOpacity\" class=\"slider-color\"></div><div class=\"col-sm-2 p-0 displayText\">1</div></div></div></div></li></ul></div><div class=\"content-main p-15\" ng-click=\"createDeviceGatewayVisualizer.fnDeselectGrid()\" style=\"cursor: default\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-if=\"!createDeviceGatewayVisualizer.isLayoutDataLoaded\"></app-spinner><div class=\"minHeightGrid gridView\" ng-if=\"createDeviceGatewayVisualizer.isLayoutDataLoaded\" ng-class=\"createDeviceGatewayVisualizer.gridClass==\'\'?\'col-sm-4\':\'col-sm-\'+createDeviceGatewayVisualizer.gridClass\" ng-repeat=\"attrObj in createDeviceGatewayVisualizer.layoutArr\"><div class=\"col-sm-12 text-center\" ng-click=\"$event.stopPropagation();createDeviceGatewayVisualizer.fnShowGridStyleOptions(attrObj)\" ng-style=\"createDeviceGatewayVisualizer.fnSetGridStyle(attrObj)\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"createDeviceGatewayVisualizer.fnGetHealthColor(attrObj.health, attrObj)\"><span>{{attrObj.healthName}}</span></button></div><div class=\"phase-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.phase\"><span uib-tooltip=\"{{attrObj.phase}}\" tooltip-placement=\"left\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"createDeviceGatewayVisualizer.fnGetPhaseIconBorderColor(attrObj.phase)\"><span ng-class=\"createDeviceGatewayVisualizer.fnGetPhaseIcon(attrObj.phase)\"></span></span> <span class=\"m-l-5 fa gatewayConnectionIcon\" ng-if=\"attrObj.connection && createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId !== \'Device\'\" uib-tooltip=\"{{attrObj.connection}}\" tooltip-placement=\"left\" ng-style=\"createDeviceGatewayVisualizer.fnGetConnectionIconColor(attrObj.connection)\" ng-class=\"createDeviceGatewayVisualizer.fnGetConnectionIcon(attrObj.connection)\"></span> <span class=\"m-l-5 gatewayConnectionIcon\" ng-if=\"attrObj.connection && createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId === \'Device\'\" ng-class=\"attrObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" uib-tooltip=\"{{attrObj.connection}}\" tooltip-placement=\"left\"></span></div><h1 class=\"header text-center\">{{attrObj.name ? attrObj.name : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent\"><div class=\"container p-5\" style=\"width: 100%; height: 100%\"><h3 class=\"m-0\">{{attrObj.description}}</h3></div></div></div></div></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(\'grid\')\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Geomap\'\" ng-init=\"createDeviceGatewayVisualizer.fnInitLayout()\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-show=\"createDeviceGatewayVisualizer.isGeomapLoading\"></app-spinner><div class=\"col-sm-12 text-center p-0\" ng-show=\"!createDeviceGatewayVisualizer.isGeomapLoading && !createDeviceGatewayVisualizer.metaDataObj.lat && !createDeviceGatewayVisualizer.metaDataObj.long\"><strong>Please Enter Information regarding Latitude Key Mapping and Longitude Key Mapping in configurations tab to visualize the layout.</strong></div><div class=\"h-100\" ng-show=\"!createDeviceGatewayVisualizer.isGeomapLoading && createDeviceGatewayVisualizer.metaDataObj.lat && createDeviceGatewayVisualizer.metaDataObj.long\"><div class=\"h-100\" id=\"map\" style=\"width: 100%\"></div></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(\'geomap\')\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type === \'Treemap\'\" ng-init=\"createDeviceGatewayVisualizer.fnInitLayout()\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div id=\"treeMap\" class=\"content-main p-15\"><div class=\"row\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-if=\"!createDeviceGatewayVisualizer.isLayoutDataLoaded\"></app-spinner><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isLayoutDataLoaded\"><tree-map tree-data-arr=\"createDeviceGatewayVisualizer.layoutArr\"></tree-map></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(\'treemap\')\">Save Visualization</button></div><div ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"m-t-15 text-center\"><label>Please select a Layout type in details tab to see Layout.</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/visualization/createDeviceGatewayVisualization/visualizerSteps/query.html","<div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId == \'Device\'\"><div class=\"content-box-content table-content-box\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><node-search-directive ng-if=\"createDeviceGatewayVisualizer.devicePermissionObj.List\" field-arr=\"createDeviceGatewayVisualizer.deviceSearchFieldArr\" filter-query=\"createDeviceGatewayVisualizer.filterQuery\" state-name=\"createDeviceGatewayVisualizer.fnGetStateName()\" fn-filter-query-change=\"createDeviceGatewayVisualizer.fnFilterQueryChanged(filterQuery, tagsArr)\" is-called-from-node-visualizer=\"true\" fn-resize=\"createDeviceGatewayVisualizer.fnSetTableHeight()\"></node-search-directive><div class=\"row\" ng-if=\"createDeviceGatewayVisualizer.devicePermissionObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"createDeviceGatewayVisualizer.isDevicesLoading\"></app-spinner><div class=\"visualizer-devices-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!createDeviceGatewayVisualizer.isDevicesLoading\"><thead><tr><th class=\"p-r-2 p-l-8\" ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\"></th><th ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\">Name</th><th ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\">Description</th><th ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\"></th><th ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\"></th><th ng-if=\"createDeviceGatewayVisualizer.devicesArr.length\"></th><th ng-if=\"!createDeviceGatewayVisualizer.devicesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"deviceObj in createDeviceGatewayVisualizer.devicesArr track by $index\" ng-click=\"createDeviceGatewayVisualizer.fnGetDevice(deviceObj, devices.devicesArr);\"><td class=\"p-r-2 p-l-8\"><button class=\"btn btn-xs btn-default ellipsis-label\" ng-style=\"createDeviceGatewayVisualizer.fnGetHealthColor(deviceObj.health, deviceObj)\"><span class=\"healtSpan\">{{deviceObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{deviceObj.name}}</span></td><td><span class=\"ellipsis\">{{deviceObj.description}}</span></td><td><i class=\"fa fa-microchip\"></i></td><td><span ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" uib-tooltip=\"{{deviceObj.connection}}\" tooltip-placement=\"top\"></span></td><td class=\"text-center\"><span uib-tooltip=\"{{deviceObj.phase}}\" tooltip-placement=\"top\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"createDeviceGatewayVisualizer.fnGetPhaseIconBorderColor(deviceObj.phase)\"><span ng-class=\"createDeviceGatewayVisualizer.fnGetPhaseIcon(deviceObj.phase)\"></span></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createDeviceGatewayVisualizer.isDevicesLoading && createDeviceGatewayVisualizer.devicesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createDeviceGatewayVisualizer.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 10; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 20; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 50; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 100; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 500; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"createDeviceGatewayVisualizer.isPrevVisible\" ng-click=\"createDeviceGatewayVisualizer.fnGetNextPrevCollection(\'previous\', createDeviceGatewayVisualizer.prevCollection, createDeviceGatewayVisualizer.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"createDeviceGatewayVisualizer.fnGetNextPrevCollection(\'next\', createDeviceGatewayVisualizer.nextCollection, createDeviceGatewayVisualizer.perPage)\" ng-if=\"createDeviceGatewayVisualizer.nextCollection.length\"></button></div></div></div></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><label>Total: {{createDeviceGatewayVisualizer.totalItems}}</label></div><div class=\"col-sm-6\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-6\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div class=\"col-sm-6\" ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div><div class=\"col-sm-12 h-100\" ng-if=\"createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId == \'Gateway\'\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\" ng-class=\"createDeviceGatewayVisualizer.isView ? \'pace\' : \'\'\"><node-search-directive ng-if=\"createDeviceGatewayVisualizer.gatewayPermissionObj.List\" field-arr=\"createDeviceGatewayVisualizer.gatewaySearchFieldArr\" filter-query=\"createDeviceGatewayVisualizer.filterQuery\" state-name=\"createDeviceGatewayVisualizer.fnGetStateName()\" fn-filter-query-change=\"createDeviceGatewayVisualizer.fnFilterQueryChanged(filterQuery, tagsArr)\" is-called-from-node-visualizer=\"true\" fn-resize=\"createDeviceGatewayVisualizer.fnSetTableHeight()\"></node-search-directive><div class=\"row\" ng-if=\"createDeviceGatewayVisualizer.gatewayPermissionObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"createDeviceGatewayVisualizer.isGatewaysLoading\"></app-spinner><div class=\"visualizer-gateways-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!createDeviceGatewayVisualizer.isGatewaysLoading\"><thead><tr><th class=\"p-r-2 p-l-8\" ng-if=\"createDeviceGatewayVisualizer.gatewaysArr.length\"></th><th ng-if=\"createDeviceGatewayVisualizer.gatewaysArr.length\">Name</th><th ng-if=\"createDeviceGatewayVisualizer.gatewaysArr.length\">Description</th><th class=\"text-center\" ng-if=\"createDeviceGatewayVisualizer.gatewaysArr.length\">Phase</th><th class=\"text-center\" ng-if=\"createDeviceGatewayVisualizer.gatewaysArr.length\">Connection</th><th ng-if=\"!createDeviceGatewayVisualizer.gatewaysArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"gatewayObj in createDeviceGatewayVisualizer.gatewaysArr track by $index\" ng-click=\"createDeviceGatewayVisualizer.fnGetGateway(gatewayObj, createDeviceGatewayVisualizer.gatewaysArr);\"><td class=\"p-r-2 p-l-8\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"createDeviceGatewayVisualizer.fnGetHealthColor(gatewayObj.health, gatewayObj)\"><span class=\"healtSpan\">{{gatewayObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{gatewayObj.name}}</span></td><td><span class=\"ellipsis\">{{gatewayObj.description}}</span></td><td class=\"text-center\"><span uib-tooltip=\"{{gatewayObj.phase}}\" tooltip-placement=\"top\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"createDeviceGatewayVisualizer.fnGetPhaseIconBorderColor(gatewayObj.phase)\"><span ng-class=\"createDeviceGatewayVisualizer.fnGetPhaseIcon(gatewayObj.phase)\"></span></span></td><td class=\"text-center\"><span class=\"fa\" uib-tooltip=\"{{gatewayObj.connection}}\" tooltip-placement=\"top\" ng-style=\"createDeviceGatewayVisualizer.fnGetConnectionIconColor(gatewayObj.connection)\" ng-class=\"createDeviceGatewayVisualizer.fnGetConnectionIcon(gatewayObj.connection)\"></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!createDeviceGatewayVisualizer.isGatewaysLoading && createDeviceGatewayVisualizer.gatewaysArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{createDeviceGatewayVisualizer.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 10; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 20; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 50; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 100; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"createDeviceGatewayVisualizer.perPage = 500; createDeviceGatewayVisualizer.fnPageChanged(createDeviceGatewayVisualizer.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"createDeviceGatewayVisualizer.isPrevVisible\" ng-click=\"createDeviceGatewayVisualizer.fnGetNextPrevCollection(\'previous\', createDeviceGatewayVisualizer.prevCollection, createDeviceGatewayVisualizer.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"createDeviceGatewayVisualizer.fnGetNextPrevCollection(\'next\', createDeviceGatewayVisualizer.nextCollection, createDeviceGatewayVisualizer.perPage)\" ng-if=\"createDeviceGatewayVisualizer.nextCollection.length\"></button></div></div></div></div></div></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6 content-box-footerItem\"><label>Total: {{createDeviceGatewayVisualizer.totalItems}}</label></div><div class=\"col-sm-6\" ng-if=\"createDeviceGatewayVisualizer.isView\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"createDeviceGatewayVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-6\" ng-if=\"!createDeviceGatewayVisualizer.isView && !createDeviceGatewayVisualizer.isVisualizerCreating\"><button class=\"btn btn-link pull-right p-r-0\" ng-disabled=\"!createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.name.length || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.typeId || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.icon || !createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type\" ng-click=\"createDeviceGatewayVisualizer.fnCreateVisualizer(createDeviceGatewayVisualizer.newDeviceGatewayVisualizersObj.layout.type.lowercase())\">Save Visualization</button></div><div class=\"col-sm-6\" ng-if=\"createDeviceGatewayVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/node/visualization/createVisualization/visualizerSteps/attributes.html","<div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"md-input m-b-20 m-t-15\"><input required=\"\" class=\"md-form-control\" ng-model=\"createVisualizer.search[createVisualizer.filter]\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\"><div id=\"tableContainer\"><table class=\"attributes-table table table-striped table-check-box\"><thead><tr><th ng-if=\"createVisualizer.attributesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"createVisualizer.isAllAttributesChecked\" ng-click=\"createVisualizer.fnCheckUncheckAttributesAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"createVisualizer.attributesArr.length\">Name</th><th ng-if=\"createVisualizer.attributesArr.length\">Title</th><th ng-if=\"createVisualizer.attributesArr.length\">Display</th><th ng-if=\"!createVisualizer.attributesArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"attribute in createVisualizer.attributesArr | filter: createVisualizer.search track by $index\" ng-click=\"createVisualizer.fnEditAttribute(attribute)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"attribute.isCheck\" ng-change=\"createVisualizer.fnCheckUncheckAttributesHeader(attribute)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td ng-bind=\"attribute.name\">Doe</td><td ng-bind=\"attribute.title\">Doe</td><td ng-bind=\"attribute.display\">Desc</td></tr></tbody></table></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\" ng-if=\"!createVisualizer.isView\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"createVisualizer.fnResetAttributeForm()\"><a class=\"btn btn-link\">Add new Attribute</a></li><li ng-if=\"createVisualizer.devicePermissionObj.List\" ng-click=\"createVisualizer.fnAddNewAttributes(\'Device\')\"><a class=\"btn btn-link\">Add attributes from Device</a></li><li ng-if=\"createVisualizer.gatewayPermissionObj.List\" ng-click=\"createVisualizer.fnAddNewAttributes(\'Gateway\')\"><a class=\"btn btn-link\">Add attributes from Gateway</a></li><li ng-if=\"createVisualizer.selectedAttributesArr.length\" ng-click=\"createVisualizer.fnRemoveAttributes(createVisualizer.selectedAttributesArr)\"><a class=\"btn btn-link\">Remove Attribute</a></li></ul></div></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"create-screen\" ng-class=\"createVisualizer.isView ? \'pace\' : \'\'\" ng-if=\"!createVisualizer.isAttributeFormVisible && !createVisualizer.isView\"><div class=\"row content\"><div class=\"col-sm-12\"><button class=\"btn btn-primary\" ng-click=\"createVisualizer.isAttributeFormVisible = true\">Add attribute</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"createVisualizer.devicePermissionObj.List\">or</div><div class=\"col-sm-12\" ng-if=\"createVisualizer.devicePermissionObj.List\"><button class=\"btn btn-primary\" ng-click=\"createVisualizer.fnAddNewAttributes(\'Device\')\">Add attributes from Device</button></div><div class=\"col-sm-12 m-t-5 m-b-5\" ng-if=\"createVisualizer.gatewayPermissionObj.List\">or</div><div class=\"col-sm-12\" ng-if=\"createVisualizer.gatewayPermissionObj.List\"><button class=\"btn btn-primary\" ng-click=\"createVisualizer.fnAddNewAttributes(\'Gateway\')\">Add attributes from Gateway</button></div></div></div><div class=\"row m-t-10\" ng-if=\"createVisualizer.isAttributeFormVisible\" ng-class=\"createVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input\" ng-class=\"createVisualizer.isUniqueError?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-class=\"createVisualizer.isAttributeEditMode ? \'pace\' : \'\'\" ng-change=\"createVisualizer.fnCheckUniqueName(createVisualizer.attributeObj.name)\" ng-model=\"createVisualizer.attributeObj.name\" placeholder=\"Name for Attribute. Name should be a unique value.*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text-error\" ng-show=\"createVisualizer.isUniqueError\"><span class=\"errorText\">This Name is already in use. Please select another</span></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"createVisualizer.attributeObj.title\" placeholder=\"Title Name for Attribute.*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\" ng-if=\"!createVisualizer.isUniqueError\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createVisualizer.attributeObj.units\" placeholder=\"Type of Units of Attribute.*\"> <span class=\"highlight\"></span> <label>Units*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"chartObj for chartObj in createVisualizer.chartArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnResetDisplayOptions()\" ng-model=\"createVisualizer.attributeObj.display\" placeholder=\"Display type of Attribute. Field is required.*\"> <span class=\"highlight\"></span> <label>Display*</label> <small class=\"helper-text\"></small></div><div ng-if=\"createVisualizer.attributeObj.display == \'Gauge\'\"><form name=\"gaugeForm\" role=\"form\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoValue\" type=\"number\" ng-model=\"createVisualizer.attributeObj.value\" step=\"any\" placeholder=\"Demo Value for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoHealth\" type=\"number\" ng-model=\"createVisualizer.attributeObj.healthCode\" placeholder=\"Demo Health for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Health*</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-t-15 m-b-15\"><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" name=\"gaugeMin\" ng-model=\"createVisualizer.gaugeObj.min\" step=\"any\" placeholder=\"Minimum value.*\"> <span class=\"highlight\"></span> <label>Min Value*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" step=\"any\" name=\"gaugeMax\" ng-model=\"createVisualizer.gaugeObj.max\" placeholder=\"Maximum value*\"> <span class=\"highlight\"></span> <label>Max Value*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"createVisualizer.gaugeObj.defaultColor\" placeholder=\"Default Color.*\"> <span class=\"highlight\"></span> <label>Default Color*</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"gaugeColorDefault\" class=\"form-control\" type=\"text\" ng-model=\"createVisualizer.gaugeObj.defaultColor\"></div></div></div></form><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"mappingObj for mappingObj in createVisualizer.mappingArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnMapToggle(createVisualizer.mapType, createVisualizer.gaugeObj)\" ng-model=\"createVisualizer.mapType\" placeholder=\"Mapping\"> <span class=\"highlight\"></span> <label>Mapping</label> <small class=\"helper-text\">The strategy used to map values to the chart.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.directMap\"><div ng-repeat=\"directObj in createVisualizer.gaugeObj.direct\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"gauge_{{$index}}\" type=\"number\" ng-model=\"directObj.value\" step=\"any\" placeholder=\"Exact value the mapping should match\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"directObj.color\" placeholder=\"Color of the attribute\"> <span class=\"highlight\"></span> <label>Color</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"gaugeColorDirect_{{index}}\" class=\"form-control\" type=\"text\" ng-model=\"directObj.color\"></div></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.gaugeObj.direct)\">Add Map Condition</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createVisualizer.directMap\"><div ng-repeat=\"rangeObj in createVisualizer.gaugeObj.range\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"gaugeFromRange_{{$index}}\" type=\"number\" ng-model=\"rangeObj.from\" step=\"any\" placeholder=\"Start point of range\"> <span class=\"highlight\"></span> <label>From Range</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" id=\"gaugeToRange_{{$index}}\" type=\"number\" required=\"\" ng-model=\"rangeObj.to\" step=\"any\" placeholder=\"End point of range\"> <span class=\"highlight\"></span> <label>To Range</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"rangeObj.color\" placeholder=\"Color of the attribute\"> <span class=\"highlight\"></span> <label>Color</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"gaugeColor_{{$index}}\" class=\"form-control\" type=\"text\" ng-model=\"rangeObj.color\"></div></div></div></div><div class=\"col-sm-12 p-0 m-b-10 m-t-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.gaugeObj.range)\">Add Map Condition</button></div></div></div><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnAddAttribute(createVisualizer.gaugeObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || gaugeForm.$invalid || createVisualizer.isUniqueError\" value=\"Add Attribute\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnEditAttributeValues(createVisualizer.gaugeObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || gaugeForm.$invalid || createVisualizer.isUniqueError\" value=\"Save Attribute\"></div><div ng-if=\"createVisualizer.attributeObj.display == \'Stack\'\"><form name=\"stackForm\" role=\"form\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoValueStack\" type=\"number\" ng-model=\"createVisualizer.attributeObj.value\" step=\"any\" placeholder=\"Demo Value for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoHealthStack\" type=\"number\" ng-model=\"createVisualizer.attributeObj.healthCode\" placeholder=\"Demo Health for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Health*</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 m-t-15 m-b-15\"><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"createVisualizer.stackObj.min\" step=\"any\" placeholder=\"Minimum value.*\"> <span class=\"highlight\"></span> <label>Min Value*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"createVisualizer.stackObj.max\" step=\"any\" placeholder=\"Maximum value.*\"> <span class=\"highlight\"></span> <label>Max Value*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"createVisualizer.stackObj.defaultColor\" placeholder=\"Default Color.*\"> <span class=\"highlight\"></span> <label>Default Color*</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"stackColorDefault\" class=\"form-control\" type=\"text\" ng-model=\"createVisualizer.stackObj.defaultColor\"></div></div></div></form><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"orientationObj for orientationObj in createVisualizer.orientationArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnStackTypeToggle(createVisualizer.orientationType)\" ng-model=\"createVisualizer.orientationType\" placeholder=\"Chart orientation*\"> <span class=\"highlight\"></span> <label>Orientation*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"mappingObj for mappingObj in createVisualizer.mappingArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnMapToggle(createVisualizer.mapType, createVisualizer.stackObj)\" ng-model=\"createVisualizer.mapType\" placeholder=\"Mapping\"> <span class=\"highlight\"></span> <label>Mapping</label> <small class=\"helper-text\">The strategy used to map values to the chart.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.directMap\"><div ng-repeat=\"directObj in createVisualizer.stackObj.direct\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"stack_{{$index}}\" type=\"number\" ng-model=\"directObj.value\" step=\"any\" placeholder=\"Exact value the mapping should match\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"directObj.color\" placeholder=\"Color\"> <span class=\"highlight\"></span> <label>Color</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"stackColorDirect_{{index}}\" class=\"form-control\" type=\"text\" ng-model=\"directObj.color\"></div></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.stackObj.direct)\">Add Map Condition</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createVisualizer.directMap\"><div ng-repeat=\"rangeObj in createVisualizer.stackObj.range\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"stackFromRange_{{$index}}\" type=\"number\" ng-model=\"rangeObj.from\" step=\"any\" placeholder=\"Start point\"> <span class=\"highlight\"></span> <label>From Range</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" id=\"stackToRange_{{$index}}\" type=\"number\" required=\"\" ng-model=\"rangeObj.to\" step=\"any\" placeholder=\"End point\"> <span class=\"highlight\"></span> <label>To Range</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-4 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"rangeObj.color\" placeholder=\"Color\"> <span class=\"highlight\"></span> <label>Color</label> <small class=\"helper-text\"></small> <input minicolors=\"createVisualizer.customSettings\" id=\"stackColor_{{$index}}\" class=\"form-control\" type=\"text\" ng-model=\"rangeObj.color\"></div></div></div></div><div class=\"col-sm-12 p-0 m-b-10 m-t-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.stackObj.range)\">Add Map Condition</button></div></div></div><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnAddAttribute(createVisualizer.stackObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || stackForm.$invalid || createVisualizer.isUniqueError\" value=\"Add Attribute\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnEditAttributeValues(createVisualizer.stackObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || stackForm.$invalid || createVisualizer.isUniqueError\" value=\"Save Attribute\"></div><div ng-if=\"createVisualizer.attributeObj.display == \'Icon\'\" ng-init=\"createVisualizer.fnGetIcons()\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoValueIcon\" type=\"text\" ng-model=\"createVisualizer.attributeObj.value\" placeholder=\"Demo Value for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoHealthIcon\" type=\"number\" ng-model=\"createVisualizer.attributeObj.healthCode\" placeholder=\"Demo Health for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Health*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"defaultIcon\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.faIconsForAttribute | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"IconTemplate.html\" ng-model=\"createVisualizer.iconObj.defaultIcon\" placeholder=\"Default Icon*\"> <span class=\"highlight\"></span> <label>Default Icon*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"mappingObj for mappingObj in createVisualizer.mappingArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnMapToggle(createVisualizer.mapType, createVisualizer.iconObj)\" ng-model=\"createVisualizer.mapType\" placeholder=\"Mapping\"> <span class=\"highlight\"></span> <label>Mapping</label> <small class=\"helper-text\">The strategy used to map values to the chart.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.directMap\"><div ng-repeat=\"directObj in createVisualizer.iconObj.direct\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"icon_{{$index}}\" type=\"text\" ng-model=\"directObj.value\" placeholder=\"Exact value the mapping should match\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"iconList_{{$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.faIconsForAttribute | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"IconTemplate.html\" ng-model=\"directObj.icon\" placeholder=\"Icon of the attribute\"> <span class=\"highlight\"></span> <label>Icon</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.iconObj.direct)\">Add Map Condition</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createVisualizer.directMap\"><div ng-repeat=\"rangeObj in createVisualizer.iconObj.range\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20 col-sm-6 p-l-0\"><input class=\"md-form-control\" required=\"\" id=\"iconFromRange_{{$index}}\" type=\"number\" ng-model=\"rangeObj.from\" step=\"any\" placeholder=\"Start point\"> <span class=\"highlight\"></span> <label>From Range</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 col-sm-6 p-0\"><input class=\"md-form-control\" id=\"iconToRange_{{$index}}\" type=\"number\" required=\"\" ng-model=\"rangeObj.to\" step=\"any\" placeholder=\"End point\"> <span class=\"highlight\"></span> <label>To Range</label> <small class=\"helper-text\"></small></div></div><div class=\"md-input col-sm-12 p-0 m-t-15\"><input class=\"md-form-control\" required=\"\" id=\"iconListRange_{{$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.faIconsForAttribute | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"IconTemplate.html\" ng-model=\"rangeObj.icon\" placeholder=\"Icon\"> <span class=\"highlight\"></span> <label>Icon</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.iconObj.range)\">Add Map Condition</button></div></div></div></div><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnAddAttribute(createVisualizer.iconObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.value || !createVisualizer.attributeObj.display || !createVisualizer.iconObj.defaultIcon || createVisualizer.isUniqueError\" value=\"Add Attribute\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnEditAttributeValues(createVisualizer.iconObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || !createVisualizer.iconObj.defaultIcon || createVisualizer.isUniqueError\" value=\"Save Attribute\"></div><div ng-if=\"createVisualizer.attributeObj.display === \'Toggle\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoValueToggle\" type=\"text\" ng-model=\"createVisualizer.attributeObj.value\" placeholder=\"Demo Value for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoHealthToggle\" type=\"number\" ng-model=\"createVisualizer.attributeObj.healthCode\" placeholder=\"Demo Health for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Health*</label> <small class=\"helper-text\"></small></div><label>Default:</label><div class=\"md-input m-b-20 m-t-15\"><input class=\"md-form-control\" required=\"\" id=\"toggleDefaultValue\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.booleanValArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"createVisualizer.toggleObj.default.value\" placeholder=\"Default Value*\"> <span class=\"highlight\"></span> <label>Default Value*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"toggleDefaultTrue\" type=\"text\" ng-model=\"createVisualizer.toggleObj.default.trueText\" placeholder=\"Default True Text*\"> <span class=\"highlight\"></span> <label>Default True Text*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"toggleDefaultFalse\" type=\"text\" ng-model=\"createVisualizer.toggleObj.default.falseText\" placeholder=\"Default False Text*\"> <span class=\"highlight\"></span> <label>Default False Text*</label></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"mappingObj for mappingObj in createVisualizer.mappingArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnMapToggle(createVisualizer.mapType, createVisualizer.toggleObj)\" ng-model=\"createVisualizer.mapType\" placeholder=\"Mapping\"> <span class=\"highlight\"></span> <label>Mapping</label> <small class=\"helper-text\">The strategy used to map values to the chart.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.directMap\"><div ng-repeat=\"directObj in createVisualizer.toggleObj.direct\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"toggle_{{$index}}\" type=\"text\" ng-model=\"directObj.value\" placeholder=\"Exact value the mapping should match\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"toggleVal_{{$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.booleanValArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"directObj.isTrue\" placeholder=\"Boolean Value considered as true/false\"> <span class=\"highlight\"></span> <label>Boolean Value</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.toggleObj.direct)\">Add Map Condition</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createVisualizer.directMap\"><div ng-repeat=\"rangeObj in createVisualizer.toggleObj.range\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20 col-sm-6 p-l-0\"><input class=\"md-form-control\" required=\"\" id=\"toggleFromRange_{{$index}}\" type=\"number\" ng-model=\"rangeObj.from\" step=\"any\" placeholder=\"Start point of range\"> <span class=\"highlight\"></span> <label>From Range</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 col-sm-6 p-0\"><input class=\"md-form-control\" id=\"toggleToRange_{{$index}}\" type=\"number\" required=\"\" ng-model=\"rangeObj.to\" step=\"any\" placeholder=\"End point of range\"> <span class=\"highlight\"></span> <label>To Range</label> <small class=\"helper-text\"></small></div></div><div class=\"md-input col-sm-12 p-0 m-t-15\"><input class=\"md-form-control\" required=\"\" id=\"toggleListRange_{{$index}}\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.booleanValArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"rangeObj.isTrue\" placeholder=\"Boolean Value considered as true/false\"> <span class=\"highlight\"></span> <label>Boolean Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.toggleObj.range)\">Add Map Condition</button></div></div></div></div><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnAddAttribute(createVisualizer.toggleObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.value || !createVisualizer.attributeObj.display || !createVisualizer.toggleObj.default.value || !createVisualizer.toggleObj.default.trueText || !createVisualizer.toggleObj.default.falseText || createVisualizer.isUniqueError\" value=\"Add Attribute\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnEditAttributeValues(createVisualizer.toggleObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || !createVisualizer.toggleObj.default.value || !createVisualizer.toggleObj.default.trueText || !createVisualizer.toggleObj.default.falseText || createVisualizer.isUniqueError\" value=\"Save Attribute\"></div><div ng-if=\"createVisualizer.attributeObj.display === \'Text\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoValueText\" type=\"text\" ng-model=\"createVisualizer.attributeObj.value\" placeholder=\"Demo Value for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Value*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"demoHealthText\" type=\"number\" ng-model=\"createVisualizer.attributeObj.healthCode\" placeholder=\"Demo Health for the Attribute.*\"> <span class=\"highlight\"></span> <label>Demo Health*</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"mappingObj for mappingObj in createVisualizer.mappingArr | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" typeahead-on-select=\"createVisualizer.fnMapToggle(createVisualizer.mapType, createVisualizer.textObj)\" ng-model=\"createVisualizer.mapType\" placeholder=\"Mapping\"> <span class=\"highlight\"></span> <label>Mapping</label> <small class=\"helper-text\">The strategy used to map values to the chart.</small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.directMap\"><div ng-repeat=\"directObj in createVisualizer.textObj.direct\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"text_{{$index}}\" type=\"text\" ng-model=\"directObj.value\" placeholder=\"Exact value the mapping should match\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"textDisplay_{{$index}}\" type=\"text\" ng-model=\"directObj.text\" placeholder=\"Display Text of the attribute\"> <span class=\"highlight\"></span> <label>Text</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.textObj.direct)\">Add Map Condition</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createVisualizer.directMap\"><div ng-repeat=\"rangeObj in createVisualizer.textObj.range\"><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20 col-sm-6 p-l-0\"><input class=\"md-form-control\" required=\"\" id=\"textFromRange_{{$index}}\" type=\"number\" ng-model=\"rangeObj.from\" step=\"any\" placeholder=\"Start point of range\"> <span class=\"highlight\"></span> <label>From Range</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 col-sm-6 p-0\"><input class=\"md-form-control\" id=\"textToRange_{{$index}}\" type=\"number\" required=\"\" ng-model=\"rangeObj.to\" step=\"any\" placeholder=\"End point of range\"> <span class=\"highlight\"></span> <label>To Range</label> <small class=\"helper-text\"></small></div></div><div class=\"md-input col-sm-12 p-0 m-t-15\"><input class=\"md-form-control\" required=\"\" id=\"textDisplayRange_{{$index}}\" type=\"text\" ng-model=\"rangeObj.text\" placeholder=\"Display Text of the attribute\"> <span class=\"highlight\"></span> <label>Text</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-10\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-click=\"createVisualizer.fnAddMapCondition(createVisualizer.directMap, createVisualizer.textObj.range)\">Add Map Condition</button></div></div></div></div><input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnAddAttribute(createVisualizer.textObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.value || !createVisualizer.attributeObj.display || createVisualizer.isUniqueError || !createVisualizer.attributeObj.healthCode\" value=\"Add Attribute\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"createVisualizer.isAttributeEditMode\" ng-click=\"createVisualizer.fnEditAttributeValues(createVisualizer.textObj)\" ng-disabled=\"!createVisualizer.attributeObj.name || !createVisualizer.attributeObj.display || createVisualizer.isUniqueError\" value=\"Save Attribute\"></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createVisualizer.isView\"><button class=\"btn btn-link pull-right\" ng-click=\"createVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createVisualizer.isView\"><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.newVisualizersObj.layout.type === \'Overlay\' ? createVisualizer.base64data && !createVisualizer.isVisualizerCreating : !createVisualizer.isVisualizerCreating\"><button class=\"btn btn-link p-r-0 pull-right\" ng-disabled=\"!createVisualizer.newVisualizersObj.name.length || !createVisualizer.newVisualizersObj.typeId || !createVisualizer.newVisualizersObj.icon || !createVisualizer.attributesArr.length || !createVisualizer.newVisualizersObj.layout.type\" ng-click=\"createVisualizer.fnCreateVisualizer(createVisualizer.newVisualizersObj.layout.type.toLowerCase())\">Save Visualization</button></div></div><div ng-if=\"!createVisualizer.isView && createVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"layoutTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model\"></span> </div> <br> </a></script></div>");
$templateCache.put("app/node/visualization/createVisualization/visualizerSteps/details.html","<div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15 floatingLabelInput\"><div class=\"row\" ng-class=\"createVisualizer.isView ? \'pace\' : \'\'\"><div class=\"col-sm-12\" ng-if=\"!createVisualizer.isTypeFetched\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div ng-if=\"createVisualizer.isTypeFetched\" class=\"col-sm-12 m-t-5 m-b-5\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"typeObj as typeObj.name for typeObj in createVisualizer.typesArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"TypeTemplate.html\" typeahead-on-select=\"createVisualizer.fnTypeSelected(createVisualizer.selectedType)\" ng-change=\"!createVisualizer.selectedType ? createVisualizer.newVisualizersObj.typeId = \'\' : \'\'\" ng-model=\"createVisualizer.selectedType\" placeholder=\"Select Type*\"> <span class=\"highlight\"></span> <label>Select Type*</label> <small class=\"helper-text\"></small> <span class=\"typeInfo\" ng-if=\"createVisualizer.selectedType\"><span class=\"m-r-50\">{{createVisualizer.selectedType.model}}</span><span class=\"m-r-50\">{{createVisualizer.selectedType.version}}</span><span>({{createVisualizer.selectedType.id}})</span></span></div></div><div class=\"col-sm-12\" ng-if=\"createVisualizer.isTypeFetched && createVisualizer.isTypeSelected\"><form role=\"form\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createVisualizer.newVisualizersObj.name\" placeholder=\"Name for the New Visualizer*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createVisualizer.newVisualizersObj.description\" placeholder=\"Description regarding Visualizer\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.faIcons | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"IconTemplate.html\" typeahead-on-select=\"createVisualizer.fnSelectIcon(createVisualizer.selectedIcon)\" ng-model=\"createVisualizer.selectedIcon\" placeholder=\"Icon for the Visualizer*\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"bluePrint for bluePrint in createVisualizer.layoutArray | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" typeahead-template-url=\"layoutTemplate.html\" ng-model=\"createVisualizer.newVisualizersObj.layout.type\" placeholder=\"Layout for the Visualizer*\"> <span class=\"highlight\"></span> <label>Layout*</label> <small class=\"helper-text\"></small></div></form></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createVisualizer.isView\"><button class=\"btn btn-link pull-right\" ng-click=\"createVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createVisualizer.isView\"><div class=\"col-sm-12 p-0\" ng-if=\"createVisualizer.newVisualizersObj.layout.type === \'Overlay\' ? createVisualizer.base64data && !createVisualizer.isVisualizerCreating : !createVisualizer.isVisualizerCreating\"><button class=\"btn btn-link p-r-0 pull-right\" ng-disabled=\"!createVisualizer.newVisualizersObj.name.length || !createVisualizer.newVisualizersObj.typeId || !createVisualizer.newVisualizersObj.icon || !createVisualizer.attributesArr.length || !createVisualizer.newVisualizersObj.layout.type\" ng-click=\"createVisualizer.fnCreateVisualizer(createVisualizer.newVisualizersObj.layout.type.toLowerCase())\">Save Visualization</button></div></div><div ng-if=\"!createVisualizer.isView && createVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"layoutTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model\"></span> </div> <br> </a></script><script type=\"text/ng-template\" id=\"IconTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model\"></span> </div> <div class=\"pull-right p-r-0\"> <i class=\"fa \" ng-class=\"\'fa-\'+match.model\"></i> </div> <br> </a></script><script type=\"text/ng-template\" id=\"TypeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.name\"></span> </div> <div class=\"pull-right p-r-0\"> <small><span>v{{match.model.version}}</span></small> </div> <br> <small><span ng-bind-html=\"match.model.model\"></span></small> </div> </a></script></div>");
$templateCache.put("app/node/visualization/createVisualization/visualizerSteps/layout.html","<div class=\"h-100\" ng-if=\"createVisualizer.newVisualizersObj.layout.type === \'Table\'\" ng-init=\"createVisualizer.fnInitTableLayout()\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\" ng-class=\"createVisualizer.isView ? \'pace\' : \'\'\"><div><input type=\"checkbox\" id=\"checkAll\" ng-model=\"createVisualizer.isAllChecked\" ng-click=\"createVisualizer.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label> <label>Select All</label></div><div ng-repeat=\"(key, value) in createVisualizer.tableOptionsObj\"><input type=\"checkbox\" id=\"chk_{{key}}\" ng-model=\"createVisualizer.tableOptionsObj[key]\" ng-change=\"createVisualizer.fnCheckUncheckHeader()\"> <label for=\"chk_{{key}}\" class=\"check-box\"></label> <label class=\"t-p-0 t-m-0\" style=\"text-transform: capitalize\">{{key}}</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\"></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div id=\"tableContainerLayout\"><table class=\"attributesLayout-table table table-striped table-check-box\" ng-class=\"createVisualizer.tableOptionsObj.display && createVisualizer.isDisplayChart ? \'display-row\' : \'\'\"><thead><tr ng-if=\"createVisualizer.tableAttributeArr.length\"><th class=\"p-r-2 p-l-5\" ng-if=\"createVisualizer.tableOptionsObj.health\">Health</th><th class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.name\">Name</th><th class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.title\">Title</th><th class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.value\">Value</th><th class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.units\">Units</th><th class=\"text-center\" ng-if=\"createVisualizer.tableOptionsObj.display\">Display</th></tr><tr ng-if=\"!createVisualizer.tableAttributeArr.length\"><th ng-if=\"!createVisualizer.tableAttributeArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"attrObj in createVisualizer.tableAttributeArr | filter: createVisualizer.layoutSearch track by $index\"><td class=\"p-r-2 p-l-5\" ng-if=\"createVisualizer.tableOptionsObj.health\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{attrObj.health}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></td><td class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.name\"><span class=\"ellipsis-label\">{{attrObj.name}}</span></td><td class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.title\"><span class=\"ellipsis-label\">{{attrObj.title}}</span></td><td class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.value\"><span class=\"ellipsis-label\">{{attrObj.value}}</span></td><td class=\"p-l-10\" ng-if=\"createVisualizer.tableOptionsObj.units\"><span class=\"ellipsis-label\">{{attrObj.units}}</span></td><td class=\"text-center\" ng-if=\"createVisualizer.tableOptionsObj.display\"><div class=\"col-sm-12\" ng-if=\"attrObj.display === \'Gauge\'\" ng-init=\"createVisualizer.isDisplayChart = true;\"><div ng-if=\"!attrObj.isValueMissing && !attrObj.isErroPresent\"><ui-knob value=\"attrObj.value\" options=\"attrObj.knobOptions\"></ui-knob></div><div ng-if=\"attrObj.isValueMissing\"><span>Missing Attribute</span></div><div ng-if=\"attrObj.isErroPresent\"><span class=\"ellipsis-label\">{{attrObj.value}}</span></div></div><div class=\"col-sm-12\" ng-if=\"attrObj.display === \'Stack\'\" ng-init=\"createVisualizer.isDisplayChart = true;\"><div ng-if=\"!attrObj.isValueMissing && !attrObj.isErroPresent\"><div class=\"progress progress-bar-vertical\" ng-if=\"attrObj.options.stackType === \'vertical\'\" style=\"height:50px; border-radius:0\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" ng-style=\"{\'height\': attrObj.value, \'background-color\' : attrObj.stackColor}\" title=\"{{attrObj.value + \' \' + attrObj.units}}\"></div></div><div class=\"progress m-t-20\" style=\"height:50px; border-radius:0\" ng-if=\"attrObj.options.stackType !== \'vertical\'\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" ng-style=\"{\'width\': attrObj.value, \'background-color\' : attrObj.stackColor}\" title=\"{{attrObj.value + \' \' + attrObj.units}}\"></div></div></div><div ng-if=\"attrObj.isValueMissing\"><span>Missing Attribute</span></div><div ng-if=\"attrObj.isErroPresent\"><span class=\"ellipsis-label\">{{attrObj.value}}</span></div></div><div class=\"col-sm-12\" ng-if=\"attrObj.display === \'Toggle\'\"><div class=\"pace\" ng-if=\"!attrObj.isValueMissing\"><switch ng-model=\"attrObj.switchValue\"></switch><span>{{attrObj.displayText}}</span></div><div ng-if=\"attrObj.isValueMissing\"><span>Missing Attribute</span></div></div><div class=\"col-sm-12\" ng-if=\"attrObj.display === \'Icon\'\"><div ng-if=\"!attrObj.isValueMissing\"><i ng-class=\"\'fa fa-lg \' +attrObj.displayIcon\"></i></div><div ng-if=\"attrObj.isValueMissing\"><span>Missing Attribute</span></div></div><div class=\"col-sm-12 ellipsis\" ng-if=\"attrObj.display === \'Text\'\"><div ng-if=\"!attrObj.isValueMissing\"><span class=\"ellipsis-label\">{{attrObj.displayText}}</span></div><div ng-if=\"attrObj.isValueMissing\"><span>Missing Attribute</span></div></div></td></tr></tbody></table></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createVisualizer.isView\"><button class=\"btn btn-link pull-right\" ng-click=\"createVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createVisualizer.isView && !createVisualizer.isVisualizerCreating\"><button class=\"btn btn-link p-r-0 pull-right\" ng-disabled=\"!createVisualizer.newVisualizersObj.name.length || !createVisualizer.newVisualizersObj.typeId || !createVisualizer.newVisualizersObj.icon || !createVisualizer.attributesArr.length || !createVisualizer.newVisualizersObj.layout.type\" ng-click=\"createVisualizer.fnCreateVisualizer(\'table\')\">Save Visualization</button></div><div ng-if=\"createVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createVisualizer.newVisualizersObj.layout.type === \'Grid\'\" ng-init=\"createVisualizer.fnInitGridLayout()\"><div class=\"col-sm-6 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-20 m-t-15\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"typeObj as typeObj.value for typeObj in createVisualizer.gridColumsOptionsArr | filter:{value:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"gridValueTemplate.html\" typeahead-on-select=\"createVisualizer.fnSelectedGridValue(createVisualizer.gridValue)\" ng-model=\"createVisualizer.gridValue\" placeholder=\"Columns*\"> <span class=\"highlight\"></span> <label>Columns*</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\"></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"minHeightGrid gridView\" ng-class=\"createVisualizer.gridClass==\'\'?\'col-sm-4\':\'col-sm-\'+createVisualizer.gridClass\" ng-repeat=\"attrObj in createVisualizer.gridAttributeArr\"><div class=\"col-sm-12 text-center\" ng-if=\"attrObj.display === \'Gauge\'\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></div><h1 class=\"header text-center ellipsis\">{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent\" ng-if=\"!attrObj.isValueMissing && !attrObj.isErroPresent\"><ui-knob value=\"attrObj.value\" options=\"attrObj.knobOptions\"></ui-knob></div><div class=\"valueContent emptyGrid\" ng-if=\"attrObj.isValueMissing\"><label>{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</label><h3 class=\"m-0\">Missing Attribute</h3></div><div class=\"valueContent ellipsis\" ng-if=\"attrObj.isErroPresent\"><label>{{attrObj.displayText}}</label></div></div></div><div class=\"col-sm-12 text-center\" ng-if=\"attrObj.display === \'Stack\'\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></div><h1 class=\"header text-center ellipsis\">{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent p-5 p-l-10 p-r-10\" ng-if=\"!attrObj.isValueMissing && !attrObj.isErroPresent\"><div class=\"progress progress-bar-vertical\" ng-if=\"attrObj.options.stackType === \'vertical\'\" style=\"height:50px; border-radius:0\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" ng-style=\"{\'height\': attrObj.value, \'background-color\' : attrObj.stackColor}\" title=\"{{attrObj.value + \' \' + attrObj.units}}\"></div></div><div class=\"text-center m-t-10 ellipsis\"><label>{{ attrObj.value}} {{ attrObj.units}}</label></div><div class=\"progress m-t-20\" style=\"height:50px; border-radius:0\" ng-if=\"attrObj.options.stackType !== \'vertical\'\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" ng-style=\"{\'width\': attrObj.value, \'background-color\' : attrObj.stackColor}\" title=\"{{attrObj.value + \' \' + attrObj.units}}\"></div></div></div><div class=\"valueContent emptyGrid\" ng-if=\"attrObj.isValueMissing\"><h3 class=\"m-0\" style=\"font-size: 4em\">Missing Attribute</h3></div><div class=\"valueContent ellipsis\" ng-if=\"attrObj.isErroPresent\"><label>{{attrObj.displayText}}</label></div></div></div><div class=\"col-sm-12 text-center\" ng-if=\"attrObj.display === \'Toggle\'\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></div><h1 class=\"header text-center ellipsis\">{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent ellipsis\" ng-if=\"!attrObj.isValueMissing\"><div class=\"container p-5\" style=\"width: 100%; height: 100%\"><switch ng-model=\"attrObj.switchValue\"></switch><h2 style=\"font-size: 2em; word-break: break-all\">{{attrObj.displayText}}</h2></div></div><div class=\"valueContent emptyGrid\" ng-if=\"attrObj.isValueMissing\"><h3 class=\"m-0\" style=\"font-size: 4em\">Missing Attribute</h3></div></div></div><div class=\"col-sm-12 text-center\" ng-if=\"attrObj.display === \'Icon\'\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></div><h1 class=\"header text-center ellipsis\">{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent\" ng-if=\"!attrObj.isValueMissing && !attrObj.isErroPresent\"><div class=\"container p-5\" style=\"width: 100%; height: 100%\"><i ng-class=\"\'fa \' +attrObj.displayIcon\" style=\"font-size: 6em\"></i></div></div><div class=\"valueContent emptyGrid\" ng-if=\"attrObj.isValueMissing\"><h3 class=\"m-0\" style=\"font-size: 4em\">Missing Attribute</h3></div></div></div><div class=\"col-sm-12 text-center\" ng-if=\"attrObj.display === \'Text\'\"><div class=\"health-label text-right m-t-5 p-r-5 m-b-5\" ng-if=\"attrObj.health\"><button class=\"btn btn-xs btn-default\" ng-style=\"{\'background-color\': attrObj.healthColor}\"><span>{{attrObj.health}}</span></button></div><h1 class=\"header text-center ellipsis\">{{attrObj.title ? attrObj.title : \"&nbsp;\"}}</h1><div class=\"text-center\"><div class=\"valueContent\" ng-if=\"!attrObj.isValueMissing\"><div class=\"container p-5\" style=\"width: 100%; height: 100%\"><h3 class=\"m-0 ellipsis\" style=\"font-size: 3em\">{{attrObj.displayText}}</h3></div></div><div class=\"valueContent emptyGrid\" ng-if=\"attrObj.isValueMissing\"><h3 class=\"m-0\" style=\"font-size: 4em\">Missing Attribute</h3></div></div></div></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12\" ng-if=\"createVisualizer.isView\"><button class=\"btn btn-link pull-right\" ng-click=\"createVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"col-sm-12\" ng-if=\"!createVisualizer.isView && !createVisualizer.isVisualizerCreating\"><button class=\"btn btn-link p-r-0 pull-right\" ng-disabled=\"!createVisualizer.newVisualizersObj.name.length || !createVisualizer.newVisualizersObj.typeId || !createVisualizer.newVisualizersObj.icon || !createVisualizer.attributesArr.length || !createVisualizer.newVisualizersObj.layout.type\" ng-click=\"createVisualizer.fnCreateVisualizer(\'grid\')\">Save Visualization</button></div><div ng-if=\"createVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"createVisualizer.newVisualizersObj.layout.type === \'Overlay\'\"><div class=\"col-sm-6 h-100 p-l-0\" ng-class=\"createVisualizer.isView ? \'pace\' : \'\'\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"md-input m-b-20 m-t-15\"><input required=\"\" class=\"md-form-control\" ng-model=\"createVisualizer.layoutSearch[createVisualizer.layoutFilter]\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12\"><div id=\"tableContainer\"><table class=\"overlayAttributesLayout-table table table-striped table-check-box\"><thead><tr><th class=\"p-l-5\" ng-if=\"createVisualizer.attributesArr.length\">Name</th><th ng-if=\"createVisualizer.attributesArr.length\">Display</th><th ng-if=\"!createVisualizer.attributesArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-drop=\"\" ng-drop-obj=\"attribute\" ng-repeat=\"attribute in createVisualizer.attributesArr | filter: createVisualizer.layoutSearch track by $index\"><td class=\"p-l-5\" ng-bind=\"attribute.name\">Doe</td><td ng-bind=\"attribute.display\">Desc</td></tr></tbody></table></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\"></div></div></div></div></div></div><div class=\"col-sm-6 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-0\"><div class=\"create-screen\" ng-if=\"!createVisualizer.isView && !createVisualizer.base64data\"><div class=\"row content\"><div class=\"col-sm-12\"><div ng-if=\"!createVisualizer.fileUploading\"><input type=\"file\" id=\"bgFileBtn\" name=\"file\" upload-files=\"createVisualizer.uploadFiles($files, filedata)\" ng-files=\"createVisualizer.uploadFiles($files, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-primary\" onclick=\"document.getElementById(\'bgFileBtn\').click()\" ng-disabled=\"createVisualizer.fileUploading\"><i class=\"fa fa-file-image-o\"></i> Upload an image</button></div></div></div></div><ghost-visualizers main-img=\"createVisualizer.base64data\" main-arr=\"createVisualizer.attributesArr\" is-view=\"createVisualizer.isView\" ng-if=\"!createVisualizer.fileUploading && createVisualizer.base64data\"></ghost-visualizers></div><div class=\"content-footer\"><div ng-if=\"!createVisualizer.isView && !createVisualizer.base64data\"><div class=\"col-sm-12\" ng-if=\"!createVisualizer.fileUploading\"><input type=\"file\" id=\"bgFile\" name=\"file\" upload-files=\"createVisualizer.uploadFiles($files, filedata)\" ng-files=\"createVisualizer.uploadFiles($files, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-t-5 m-b-5 pull-right\" onclick=\"document.getElementById(\'bgFile\').click()\" ng-disabled=\"createVisualizer.fileUploading\"><i class=\"fa fa-file-image-o\"></i> Upload an image</button></div><div class=\"col-sm-12\" ng-if=\"createVisualizer.fileUploading\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div><div class=\"col-sm-12\" ng-if=\"createVisualizer.isView\"><button class=\"btn btn-link pull-right\" ng-click=\"createVisualizer.fnGoBackToVisualization()\">Back to visualizer</button></div><div class=\"pull-left\" ng-if=\"!createVisualizer.isView && createVisualizer.base64data\"><div ng-if=\"!createVisualizer.isVisualizerImageUpdate\"><button type=\"button\" class=\"btn btn-link btn-sm\" onclick=\"document.getElementById(\'bgFileSave\').click()\" ng-disabled=\"createVisualizer.fileUploading\"><i class=\"fa fa-file-image-o\"></i> Upload New Image</button> <input type=\"file\" id=\"bgFileSave\" name=\"file\" upload-files=\"createVisualizer.uploadFiles($files, filedata,true)\" ng-files=\"createVisualizer.uploadFiles($files, filedata,true)\" style=\"visibility:hidden; height: 0px;\"></div><div ng-if=\"createVisualizer.isVisualizerImageUpdate\"><div class=\"pull-right m-r-5 m-t-4 p-l-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div><div ng-if=\"!createVisualizer.isView && createVisualizer.base64data\"><button class=\"btn btn-link pull-right\" ng-if=\"!createVisualizer.isVisualizerCreating\" ng-disabled=\"!createVisualizer.newVisualizersObj.name.length || !createVisualizer.newVisualizersObj.typeId || !createVisualizer.newVisualizersObj.icon || !createVisualizer.attributesArr.length || !createVisualizer.newVisualizersObj.layout.type\" ng-click=\"createVisualizer.fnCreateVisualizer(\'overlay\')\">Save Visualization</button><div ng-if=\"createVisualizer.isVisualizerCreating\"><div class=\"pull-right m-r-5 m-t-4\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div><div class=\"h-100\" ng-if=\"!createVisualizer.newVisualizersObj.layout.type\"><div class=\"col-sm-12 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-main p-15\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"m-t-15 text-center\"><label>Please select a Layout type in details tab to see Layout options.</label></div></div></div></div><div class=\"content-footer\"><div class=\"col-sm-12 content-box-footerItem\"></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"gridValueTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.value\"></span> </div> <br> </a></script>");
$templateCache.put("app/node/visualization/visualizationInfo/visualizationTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitVisualization()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isVisualizerDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isVisualizerDetailsLoaded\"><div class=\"m-t-10\"><div class=\"pull-left\"><label>Type ID : {{visualizerObj.typeId}}</label></div><div class=\"pull-right\"><span class=\"m-l-20 m-r-10\"><i ng-class=\"\'fa \'+visualizerObj.icon\"></i></span></div></div></div><div class=\"col-sm-12 m-t-5 floatingLabelInput\" ng-if=\"isVisualizerDetailsLoaded\"><div class=\"md-input m-b-20 m-t-20\" ng-class=\"!visualizerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"visualizerObj.name\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-class=\"!visualizerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"visualizerObj.description\" placeholder=\"Description regarding Visualizer\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\" ng-class=\"!visualizerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"icon\" type=\"text\" ng-model=\"visualizerObj.icon\"> <span class=\"highlight\"></span> <label>Icon*</label></div><div class=\"md-input m-b-20\" ng-class=\"!visualizerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"layout\" type=\"text\" ng-model=\"visualizerObj.layout.type\"> <span class=\"highlight\"></span> <label>Layout*</label></div><button class=\"btn btn-primary\" ng-click=\"fnGoToVisualization(visualizerObj, \'view\')\">View Layout</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{visualizerObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(visualizerObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(visualizerPermissionsObj.Modify && !isDetailsEditable) || visualizerPermissionsObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"fnCheckUserPermission(visualizerObj)\" ng-click=\"fnCloneVisualizer(visualizerObj)\"><a class=\"btn btn-link\">Clone</a></li><li ng-if=\"visualizerPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnGoToVisualization(visualizerObj, \'edit\')\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"visualizerPermissionsObj.Delete\" ng-click=\"fnDeleteVisualizer(visualizerObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/createListener/steps/expression.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 conditionModelToggle-tab\"><div><button type=\"button\" class=\"btn btn-link p-0 pull-right\" ng-click=\"createListener.activeTab = createListener.activeTab === 0 ? 1:0\">{{createListener.activeTab === 0 ? \'Advance\':\'Basic\'}}</button></div><uib-tabset active=\"createListener.activeTab\" type=\"pills\"><uib-tab index=\"0\" heading=\"Builder\" select=\"createListener.queryBuilderSelected($event)\" class=\"hide-tab\"><div class=\"row m-t-15\"><div class=\"col-sm-12\" ng-if=\"createListener.qbFilters\"><ng-query-builder query-builder=\"createListener.queryBuilder\" action-filters=\"createListener.qbFilters\"></ng-query-builder></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createListener.isListenerCreating\" wz-next=\"createListener.fnExpression(true, createListener.isEditMode)\" value=\"Next\"> <input ng-if=\"createListener.reviewBtnTxt === \'Save Listener\' && !createListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createListener.finishedWizardEdit(createListener.newListenerObj)\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length\"><div ng-if=\"createListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Advance\" select=\"createListener.tabSelected($event)\" class=\"hide-tab\"><div class=\"row m-t-15\"><div class=\"col-sm-12\"><textarea ui-codemirror=\"createListener.editorOptions\" ng-model=\"createListener.statementsObj.advance\"></textarea></div><div class=\"col-sm-12 m-t-15\"><input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createListener.isListenerCreating\" wz-next=\"createListener.fnExpression(false, createListener.isEditMode)\" value=\"Next\"> <input ng-if=\"createListener.reviewBtnTxt === \'Save Listener\' && !createListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createListener.finishedWizardEdit(createListener.newListenerObj)\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length\"><div ng-if=\"createListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/pipeline/listeners/createListener/steps/information.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewListenerInfoForm\" role=\"form\" name=\"createNewListenerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createListener.newListenerObj.name\" placeholder=\"Name for the new Listener*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createListener.newListenerObj.description\" placeholder=\"Description regarding Listener\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createListener.newListenerObj.state\">{{createListener.newListenerObj.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in createListener.statesArr\" role=\"menuitem\"><a ng-click=\"createListener.newListenerObj.state = action\">{{action}}</a></li></ul></div></div></div></form></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-right\" wz-next=\"\" value=\"Next\" ng-if=\"!createListener.isListenerCreating\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.state.length\"> <input ng-if=\"createListener.reviewBtnTxt === \'Save Listener\' && !createListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createListener.finishedWizardEdit(createListener.newListenerObj)\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length\"><div ng-if=\"createListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/createListener/steps/review.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 pace floatingLabelInput\"><form id=\"createNewListenerInfoForm\" role=\"form\" name=\"createNewListenerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createListener.newListenerObj.name\" placeholder=\"Name of the New Listener.*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createListener.newListenerObj.description\" placeholder=\"Description regarding Listener\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"state\" type=\"text\" ng-model=\"createListener.newListenerObj.state\" placeholder=\"State of Listener.*\"> <span class=\"highlight\"></span> <label>State*</label> <small class=\"helper-text\"></small></div></form></div><div class=\"col-sm-12\"><label>Statement</label><br><div class=\"row\"><div class=\"col-sm-6 m-t-15\" ng-repeat=\"statements in createListener.newListenerObj.statements track by $index\"><div class=\"col-sm-12 statementsItem\" ng-click=\"createListener.fnEditStatements(statements)\"><div class=\"m-t-8\"><label>Actions</label> <button type=\"button\" class=\"btn btn-link pull-right p-0\" ng-click=\"$event.stopPropagation();createListener.fnRemoveFromArr($index, createListener.newListenerObj.statements)\"><i class=\"fa fa-times\"></i></button></div><div class=\"action-tags\"><div class=\"search-tag-container m-t-5\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-repeat=\"tag in statements.actions track by $index\">{{tag}}</button></div></div><div class=\"row footer\"><label class=\"m-0\">Expression: {{statements.expression ? \"Yes\" : \'No\'}}</label> <button type=\"button\" class=\"btn btn-link pull-right p-0\">Edit</button></div></div></div><div class=\"col-sm-6 m-t-15\"><div class=\"col-sm-12 statementsItem text-center\" ng-click=\"createListener.fnAddNewStatements()\"><div class=\"add-statment h-100\"><label>Add Statement</label></div></div></div></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!createListener.isListenerCreating\"><input ng-if=\"createListener.reviewBtnTxt === \'Create Listener\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createListener.reviewBtnTxt}}\" ng-click=\"createListener.finishedWizard()\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length\"> <input ng-if=\"createListener.reviewBtnTxt === \'Save Listener\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createListener.reviewBtnTxt}}\" ng-click=\"createListener.finishedWizardEdit(createListener.newListenerObj)\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length\"></div><div class=\"col-sm-12 m-t-15\" ng-if=\"createListener.isListenerCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/pipeline/listeners/createListener/steps/statement.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewListenerInfoForm\" role=\"form\" name=\"createNewListenerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0 m-t-10 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"createListener.statementsObj.effect\">{{createListener.statementsObj.effect}}</span> <label class=\"titleLabel\">Effect*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in createListener.effectOptionArr\" role=\"menuitem\"><a ng-click=\"createListener.statementsObj.effect = action\">{{action}}</a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"actions\" type=\"text\" uib-typeahead=\"action for action in createListener.actionOptionArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"createListener.action\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && createListener.fnCreateActionTag(createListener.action)\" placeholder=\"The target actions*\"> <span class=\"highlight\"></span> <label>Actions*</label> <small class=\"helper-text\"><span ng-if=\"createListener.action.length\">Press enter to add your action.</span></small></div><div class=\"search-tag-container m-t-10\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-repeat=\"tag in createListener.statementsObj.actions track by $index\">{{tag}}<i ng-click=\"createListener.fnRemoveTags($index)\" class=\"fa fa-times m-l-5\"></i></button></div></div></form></div><div class=\"col-sm-12\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"createListener.fnGoBacktoReview()\" ng-if=\"createListener.newListenerObj.statements.length\">Cancel</button> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createListener.isListenerCreating\" wz-next=\"createListener.fnCreateFilterObj(createListener.statementsObj.actions)\" value=\"Next\" ng-disabled=\"!createListener.statementsObj.actions.length\"> <input ng-if=\"createListener.reviewBtnTxt === \'Save Listener\' && !createListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createListener.finishedWizardEdit(createListener.newListenerObj)\" ng-disabled=\"!createListener.newListenerObj.name || !createListener.newListenerObj.statements.length || !createListener.statementsObj.actions.length\"><div ng-if=\"createListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/editListenerPanel/editListenerPanel.html","<div class=\"h-100\" ng-controller=\"editListenerPanelCtrl as editListener\" ng-init=\"editListener.fnInitEditBluePrint(listenerObj)\"><button type=\"button\" class=\"btn btn-link pull-right p-0 m-t-5\" ng-click=\"editListener.fnCancel()\"><i class=\"fa fa-times\"></i></button><div class=\"row\" style=\"height: calc(100% - 85px)\"><div class=\"col-sm-12 m-t-10 p-0\" ng-if=\"editListener.isListenerModelsLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 h-100 m-t-10 p-0\" ng-if=\"!editListener.isListenerModelsLoading\"><div class=\"col-sm-3 h-100 p-l-0 p-b-0\"><div class=\"content-box\"><div class=\"content-box-content p-0\"><div class=\"verticalMenu\"><ul class=\"nav\"><li ng-class=\"editListener.selectedTab === item.tabIndex ? \'active\' : \'\'\" ng-click=\"editListener.fnSet(); editListener.selectedTab = item.tabIndex;\" ng-repeat=\"item in editListener.tabs\"><a title=\"{{item.title}}\"><span>{{item.title}}</span></a></li></ul></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" ng-if=\"editListener.selectedTab === 1\"><div class=\"content-box\"><div class=\"content-box-content p-0\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/information.html\'\"></div></div></div></div><div class=\"col-sm-9 h-100 p-l-0 p-r-0\" ng-if=\"editListener.selectedTab === 2\"><div class=\"content-box\"><div id=\"expressionDiv\" class=\"content-box-content p-0\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/expression.html\'\"></div></div></div></div></div></div><div class=\"col-sm-12 m-t-10 p-0\" ng-if=\"!editListener.isListenerModelsLoading\"><button ng-if=\"!editListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary\" ng-click=\"editListener.fnCancel()\" tabindex=\"12\">Close</button> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!editListener.isListenerCreating\" ng-click=\"editListener.finishedWizardEdit(editListener.newListenerObj)\" ng-disabled=\"!editListener.newListenerObj.name || !editListener.newListenerObj.statements.length || editListener.isAddExpression\" value=\"Save\"><div ng-if=\"editListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/steps/AddExpression.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 conditionModelToggle-tab\"><uib-tabset active=\"editListener.activeTab\" type=\"pills\"><div><button type=\"button\" class=\"btn btn-link p-0 pull-right\" ng-click=\"editListener.activeTab = editListener.activeTab === 0 ? 1:0\">{{editListener.activeTab === 0 ? \'Advance\':\'Basic\'}}</button></div><uib-tab index=\"0\" heading=\"Builder\" select=\"editListener.queryBuilderSelected($event)\" class=\"hide-tab\"><div class=\"row m-t-15\"><div class=\"col-sm-12\" ng-if=\"editListener.qbFilters\"><ng-query-builder query-builder=\"editListener.queryBuilder\" action-filters=\"editListener.qbFilters\"></ng-query-builder></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-left\" ng-if=\"!editListener.isListenerCreating\" ng-click=\"editListener.fnGoBacktoReview()\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!editListener.isListenerCreating\" ng-click=\"editListener.fnExpression(true, editListener.isEditMode)\" value=\"Add\"><div ng-if=\"editListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Advance\" select=\"editListener.tabSelected($event)\" class=\"hide-tab\"><div class=\"row m-t-15\"><div class=\"col-sm-12\"><textarea ui-codemirror=\"editListener.editorOptions\" ng-model=\"editListener.statementsObj.advance\"></textarea></div><div class=\"col-sm-12 m-t-15\"><input type=\"button\" class=\"btn btn-primary pull-left\" ng-if=\"!editListener.isListenerCreating\" ng-click=\"editListener.fnGoBacktoReview()\" value=\"Cancel\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!editListener.isListenerCreating\" ng-click=\"editListener.fnExpression(true, editListener.isEditMode)\" value=\"Add\"><div ng-if=\"editListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-tab></uib-tabset></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/steps/AddStatement.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewListenerInfoForm\" role=\"form\" name=\"createNewListenerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0 m-t-10 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"editListener.statementsObj.effect\">{{editListener.statementsObj.effect}}</span> <label class=\"titleLabel\">Effect*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in editListener.effectOptionArr\" role=\"menuitem\"><a ng-click=\"editListener.statementsObj.effect = action\">{{action}}</a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"actions\" type=\"text\" uib-typeahead=\"action for action in editListener.actionOptionArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-model=\"editListener.action\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && editListener.fnCreateActionTag(editListener.action)\" placeholder=\"The target actions*\"> <span class=\"highlight\"></span> <label>Actions*</label> <small class=\"helper-text\"><span ng-if=\"editListener.action.length\">Press enter to add your action.</span></small></div><div class=\"search-tag-container m-t-10\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-repeat=\"tag in editListener.statementsObj.actions track by $index\">{{tag}}<i ng-click=\"editListener.fnRemoveTags($index)\" class=\"fa fa-times m-l-5\"></i></button></div></div></form></div><div class=\"col-sm-12\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"editListener.fnGoBacktoReview()\" ng-if=\"editListener.newListenerObj.statements.length\">Cancel</button> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!editListener.isListenerCreating\" wz-next=\"editListener.fnCreateFilterObj(editListener.statementsObj.actions)\" value=\"Next\" ng-disabled=\"!editListener.statementsObj.actions.length || !editListener.statementsObj.effect\"> <input ng-if=\"editListener.reviewBtnTxt === \'Save Listener\' && !editListener.isListenerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"editListener.finishedWizardEdit(editListener.newListenerObj)\" ng-disabled=\"!editListener.newListenerObj.name || !editListener.newListenerObj.statements.length || !editListener.statementsObj.actions.length\"><div ng-if=\"editListener.isListenerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/steps/expression.html","<div class=\"col-sm-12 m-t-26\" ng-if=\"!editListener.isAddExpression\"><div id=\"addExpressionDiv\" class=\"col-sm-12\"><button class=\"btn btn-link pull-right p-r-0\" ng-click=\"editListener.fnAddExpression()\">Add Statements</button></div><div class=\"edit-listener-table table-container\"><table class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"editListener.newListenerObj.statements.length\" class=\"p-8\"></th><th ng-if=\"editListener.newListenerObj.statements.length\">Statements</th><th ng-if=\"editListener.newListenerObj.statements.length\">Actions</th><th ng-if=\"!editListener.newListenerObj.statements.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"statementsObj in editListener.newListenerObj.statements track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}1\" ng-model=\"statementsObj.isCheck\" ng-change=\"editListener.fnCheckUncheckHeader(statementsObj)\"> <label for=\"chk_{{$index}}1\" class=\"check-box\"></label></td><td ng-bind=\"statementsObj.expression ? \'Condition\':\'Basic\'\">Doe</td><td ng-bind=\"statementsObj.actions.length\">Desc</td></tr></tbody></table><div class=\"pagination-container\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"pull-right content-box-footerItem\" ng-if=\"editListener.selectedStatementssArr.length\"><div class=\"dropdown dropup\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-if=\"editListener.selectedStatementssArr.length === 1\" ng-click=\"editListener.fnEditExpression(editListener.selectedStatementssArr[0])\">Edit</a></li><li><a class=\"btn btn-link\" ng-click=\"editListener.fnDeleteExpression(editListener.count)\">Delete</a></li></ul></div></div></div></div></div></div></div><div class=\"col-sm-12 m-t-0\" ng-if=\"editListener.isAddExpression\"><div class=\"col-sm-12 wizard\"><wizard on-finish=\"editListener.finishedWizard()\" edit-mode=\"true\" indicators-position=\"top\"><wz-step wz-title=\"1. Add Statement\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/AddStatement.html\'\"></div></wz-step><wz-step wz-title=\"2. Add Expression\"><div ng-include=\"\'app/pipeline/listeners/editListener/steps/AddExpression.html\'\"></div></wz-step></wizard></div></div>");
$templateCache.put("app/pipeline/listeners/editListener/steps/information.html","<div class=\"col-sm-12 h-100 p-0 m-t-12\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewListenerInfoForm\" role=\"form\" name=\"createNewListenerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"editListener.newListenerObj.name\" placeholder=\"Name of the Listener.*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"editListener.newListenerObj.description\" placeholder=\"Description regarding Listener\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"editListener.newListenerObj.state\">{{editListener.newListenerObj.state}}</span> <label class=\"titleLabel\">State*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"action in editListener.statesArr\" role=\"menuitem\"><a ng-click=\"editListener.newListenerObj.state = action\">{{action}}</a></li></ul></div></div></div></form></div></div>");
$templateCache.put("app/pipeline/listeners/listenerInfo/listenerTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitListener()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isListenerDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isListenerDetailsLoaded && !isDetailsEditable\"><div class=\"md-input m-b-20 m-t-40\" ng-class=\"!listenerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"listenerObj.name\" placeholder=\"Name for the new Listener\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-class=\"!listenerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"listenerObj.description\" placeholder=\"Description regarding Listener\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\" ng-class=\"!listenerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"state\" type=\"text\" ng-model=\"listenerObj.state\" placeholder=\"State for Listener\"> <span class=\"highlight\"></span> <label>State*</label></div><div class=\"col-sm-12 p-0\"><label>Statement</label><br><div class=\"row\"><div class=\"col-sm-6 m-t-15\" ng-repeat=\"statements in listenerObj.statements track by $index\"><div class=\"col-sm-12 statementsItem\"><div class=\"m-t-8\"><label>Actions</label> <button type=\"button\" class=\"btn btn-link pull-right p-0\"></button></div><div class=\"action-tags\"><div class=\"search-tag-container m-t-5\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5\" ng-class=\"!listenerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\" ng-repeat=\"tag in statements.actions track by $index\">{{tag}}</button></div></div><div class=\"row footer\"><label class=\"m-0\">Expression: {{statements.expression ? \"Yes\" : \'No\'}}</label></div></div></div></div></div></div><div class=\"col-sm-12 h-100\" ng-if=\"isListenerDetailsLoaded && isDetailsEditable\"><div class=\"h-100\" ng-include=\"\'app/pipeline/listeners/editListener/editListenerPanel/editListenerPanel.html\'\"></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{listenerObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(listenerObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem\" ng-class=\"!isUpdateListenerState ?\'m-0\':\'\'\"><div ng-if=\"isUpdateListenerState && isListenerDetailsLoaded\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(listenerPermissionsObj.Modify && !isDetailsEditable) || listenerPermissionsObj.Delete\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"listenerPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeListenerState(listenerObj)\"><a class=\"btn btn-link\">{{listenerObj.state === \'ACTIVE\' ?\'Deactivate\':\'Activate\'}}</a></li><li ng-if=\"listenerPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable(listenerObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"listenerPermissionsObj.Delete\" ng-click=\"fnDeleteListener(listenerObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div><div class=\"p-t-1 pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!isUpdateListenerState\"></div></div></div></div>");
$templateCache.put("app/pipeline/templates/modal/htmlPreviewModal/htmlPreviewModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"htmlPreview.fnInitHTMLPreviewModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">HTML Template Preview</h4></div><div class=\"modal-body\"><div class=\"col-sm-12 p-10 h-100\" id=\"htmlParse\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"htmlPreview.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/pipeline/templates/templateInfo/templateTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitTemplate()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isTemplateDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isTemplateDetailsLoaded && !isDetailsEditable\"><div class=\"md-input m-b-20 m-t-20\" ng-class=\"!templatePermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"templateObj.name\" placeholder=\"Name for the new Template*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-class=\"!templatePermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"templateObj.description\" placeholder=\"Description regarding Template\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"m-b-20\"><span class=\"pace\">Template</span> <small class=\"pull-right\"><a class=\"btn btn-link p-0 p-l-5 p-b-3\" style=\"font-size: 10px;\" ng-if=\"isHTMLCode\" ng-click=\"fnViewRenderedHTML()\">View Rendered HTML</a></small><pre class=\"m-t-5 pace\" ng-init=\"fnCheckIsHTML()\" ng-bind=\"getPrettyJson(templateObj.body)\"></pre></div></div><div class=\"col-sm-12\" ng-if=\"isTemplateDetailsLoaded && isDetailsEditable\"><ng-include src=\"\'app/pipeline/templates/createTemplate/editTemplateFromBluePrint.html\'\"></ng-include></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{templateObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(templateObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((templatePermissionsObj.Modify && !isDetailsEditable) || templatePermissionsObj.Delete) && isTemplateDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"templatePermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable(templateObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"templatePermissionsObj.Delete\" ng-click=\"fnDeleteTemplate(templateObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/steps/information.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTemplate.newTemplateObj.name\" placeholder=\"Name for the new Template*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createTemplate.newTemplateObj.description\" placeholder=\"Description regarding Template\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-right\" wz-next=\"\" value=\"Next\" ng-if=\"!createTemplate.isTemplateCreating\" ng-disabled=\"!createTemplate.newTemplateObj.name\"> <input ng-if=\"createTemplate.reviewBtnTxt === \'Save Template\' && !createTemplate.isTemplateCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTemplate.finishedWizardEdit(createTemplate.newTemplateObj)\" ng-disabled=\"!createTemplate.newTemplateObj.name || !createTemplate.newTemplateObj.decodedBody.length\"><div ng-if=\"createTemplate.isTemplateCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/steps/review.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 pace floatingLabelInput\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTemplate.newTemplateObj.name\" placeholder=\"Name for the new Template*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createTemplate.newTemplateObj.description\" placeholder=\"Description regarding Template\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div>Body: <textarea ng-model=\"createTemplate.newTemplateObj.decodedBody\"></textarea></form></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!createTemplate.isTemplateCreating\"><input ng-if=\"createTemplate.reviewBtnTxt === \'Create Template\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createTemplate.reviewBtnTxt}}\" ng-click=\"createTemplate.finishedWizard()\" ng-disabled=\"!createTemplate.newTemplateObj.name || !createTemplate.newTemplateObj.decodedBody.length\"> <input ng-if=\"createTemplate.reviewBtnTxt === \'Save Template\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createTemplate.reviewBtnTxt}}\" ng-click=\"createTemplate.finishedWizardEdit(createTemplate.newTemplateObj)\" ng-disabled=\"!createTemplate.newTemplateObj.name || !createTemplate.newTemplateObj.decodedBody.length\"></div><div class=\"col-sm-12 m-t-15\" ng-if=\"createTemplate.isTemplateCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/steps/template.html","<div class=\"row m-t-55\"><div class=\"col-sm-12\"><form id=\"createNewTemplateInfoForm\" role=\"form\" name=\"createNewTemplateInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"col-sm-12 p-0\"><span>Template:*</span> <small class=\"pull-right\">Template can be in HTML, TEXT, JSON, MARKDOWN, or YAML <a class=\"btn btn-link p-0 p-l-5 p-b-3\" style=\"font-size: 10px;\" ng-if=\"createTemplate.isHTMLCode\" ng-click=\"createTemplate.fnViewRenderedHTML()\">View Rendered HTML</a></small></div><textarea ng-model=\"createTemplate.newTemplateObj.decodedBody\" ng-change=\"createTemplate.fnCheckIsHTML()\"></textarea></form></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary\" ng-if=\"!createTemplate.isTemplateCreating\" wz-next=\"createTemplate.fnGoToValidation()\" value=\"Validate\" ng-disabled=\"!createTemplate.newTemplateObj.decodedBody.length\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createTemplate.isTemplateCreating\" value=\"Review\" ng-disabled=\"!createTemplate.newTemplateObj.decodedBody.length\" ng-click=\"createTemplate.fnGoToReview()\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createTemplate.isTemplateCreating\" ng-click=\"createTemplate.fnGoToInfo()\" value=\"Back\"> <input ng-if=\"createTemplate.reviewBtnTxt === \'Save Template\' && !createTemplate.isTemplateCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTemplate.finishedWizardEdit(createTemplate.newTemplateObj)\" ng-disabled=\"!createTemplate.newTemplateObj.name || !createTemplate.newTemplateObj.decodedBody.length\"><div ng-if=\"createTemplate.isTemplateCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/templates/createTemplate/steps/validateTemplate.html","<div class=\"row\"><div class=\"col-sm-12\" ng-if=\"createTemplate.isValidated\"><small>The above is the result of the validation. You can validate your template again or go to next step.</small></div><div class=\"col-sm-12\" ng-if=\"createTemplate.isValidateFailed\"><label>The Template failed validation. Please correct the template or input and try again.</label></div><div class=\"col-sm-12\" ng-if=\"createTemplate.isInputBadlyFormatted\">The input is not in a proper json structure. Please try again.</div><div class=\"col-sm-12\" ng-if=\"!createTemplate.isTemplateValidating\"><input type=\"button\" class=\"btn btn-primary\" ng-if=\"!createTemplate.isTemplateCreating\" ng-click=\"createTemplate.fnGoToTemplate()\" value=\"Back\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createTemplate.isValidated && !createTemplate.isTemplateCreating\" ng-click=\"createTemplate.fnValidateTemplate(createTemplate.validateInput, createTemplate.newTemplateObj)\" value=\"Validate Template\" ng-disabled=\"!createTemplate.validateInput.length || createTemplate.isValidateFailed || createTemplate.isInputBadlyFormatted\"> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-class=\"!createTemplate.isValidated ? \'m-r-5\' : \'\'\" ng-bind=\"createTemplate.isValidated ? \'Next\' : \'Skip validation and go to next step\'\" wz-next=\"\" ng-if=\"!createTemplate.isTemplateCreating\"></button> <input ng-if=\"createTemplate.reviewBtnTxt === \'Save Template\' && createTemplate.isValidated && !createTemplate.isTemplateCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTemplate.finishedWizardEdit(createTemplate.newTemplateObj)\" ng-disabled=\"!createTemplate.newTemplateObj.name || !createTemplate.newTemplateObj.decodedBody.length\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Validate Again\" ng-click=\"createTemplate.fnValidateAgain()\" ng-if=\"createTemplate.isValidated && !createTemplate.isTemplateCreating\"><div ng-if=\"createTemplate.isTemplateCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"createTemplate.isTemplateValidating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/steps/information.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 floatingLabelInput\"><form id=\"createNewTransformerInfoForm\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTransformer.newTransformerObj.name\" placeholder=\"Name for the new Transformer*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createTransformer.newTransformerObj.description\" placeholder=\"Description regarding Transformer\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></form></div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary pull-right\" wz-next=\"\" value=\"Next\" ng-if=\"!createTransformer.isTransformerCreating\" ng-disabled=\"!createTransformer.newTransformerObj.name\"> <input ng-if=\"createTransformer.reviewBtnTxt === \'Save Transformer\' && !createTransformer.isTransformerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTransformer.finishedWizardEdit(createTransformer.newTransformerObj)\" ng-disabled=\"!createTransformer.newTransformerObj.name || !createTransformer.newTransformerObj.txtSpec.length\"><div ng-if=\"createTransformer.isTransformerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/steps/review.html","<div class=\"row m-t-55\"><div class=\"col-sm-12 pace floatingLabelInput\"><form id=\"createNewTransformerInfoForm\" role=\"form\" name=\"createNewTransformerInfoForm\" autocomplete=\"off\" novalidate=\"\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTransformer.newTransformerObj.name\" placeholder=\"Name for the new Transformer*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"createTransformer.newTransformerObj.description\" placeholder=\"Description regarding Transformer\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div>Body:<pre ng-bind=\"createTransformer.getPrettyJson(createTransformer.newTransformerObj.txtSpec)\"></pre></form></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!createTransformer.isTransformerCreating\"><input ng-if=\"createTransformer.reviewBtnTxt === \'Create Transformer\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createTransformer.reviewBtnTxt}}\" ng-click=\"createTransformer.finishedWizard()\" ng-disabled=\"!createTransformer.newTransformerObj.name || !createTransformer.newTransformerObj.txtSpec.length\"> <input ng-if=\"createTransformer.reviewBtnTxt === \'Save Transformer\'\" type=\"button\" class=\"btn btn-primary pull-right\" value=\"{{createTransformer.reviewBtnTxt}}\" ng-click=\"createTransformer.finishedWizardEdit(createTransformer.newTransformerObj)\" ng-disabled=\"!createTransformer.newTransformerObj.name || !createTransformer.newTransformerObj.txtSpec.length\"></div><div class=\"col-sm-12 m-t-15\" ng-if=\"createTransformer.isTransformerCreating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/steps/transformer.html","<div class=\"row m-t-10\"><div class=\"col-sm-12\" ng-if=\"createTransformer.isInputBadlyFormatted\">The Spec is not in a proper Json Structure. Please Try Again.</div><div class=\"col-sm-12\"><input type=\"button\" class=\"btn btn-primary\" ng-if=\"!createTransformer.isTransformerCreating\" ng-click=\"createTransformer.fnGoToValidation(createTransformer.newTransformerObj.txtSpec)\" value=\"Validate\" ng-disabled=\"!createTransformer.newTransformerObj.txtSpec.length || createTransformer.isInputBadlyFormatted\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createTransformer.isTransformerCreating\" value=\"Review\" ng-disabled=\"!createTransformer.newTransformerObj.txtSpec.length\" ng-click=\"createTransformer.fnGoToReview()\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!createTransformer.isTransformerCreating\" ng-click=\"createTransformer.fnGoToInfo()\" value=\"Back\"> <input ng-if=\"createTransformer.reviewBtnTxt === \'Save Transformer\' && !createTransformer.isTransformerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTransformer.finishedWizardEdit(createTransformer.newTransformerObj)\" ng-disabled=\"!createTransformer.newTransformerObj.name || !createTransformer.newTransformerObj.txtSpec.length || createTransformer.isInputBadlyFormatted\"><div ng-if=\"createTransformer.isTransformerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/pipeline/transformers/createTransformer/steps/validateTransformer.html","<div class=\"row m-t-10\"><div class=\"col-sm-12\" ng-if=\"createTransformer.isValidated\"><small>The above is the result of the validation. You can validate your transformer again or go to next step.</small></div><div class=\"col-sm-12\" ng-if=\"createTransformer.isValidateFailed\"><label>The transformer failed validation. Please correct the transformer or input and try again.</label></div><div class=\"col-sm-12\" ng-if=\"createTransformer.isInputBadlyFormatted\">The input is not in a proper json structure. Please try again.</div><div class=\"col-sm-12\" ng-if=\"!createTransformer.isTransformerValidating\"><input type=\"button\" class=\"btn btn-primary\" ng-if=\"!createTransformer.isTransformerCreating\" ng-click=\"createTransformer.fnGoToTransformer()\" value=\"Back\"> <input type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!createTransformer.isValidated && !createTransformer.isTransformerCreating\" ng-click=\"createTransformer.fnValidateTransformer(createTransformer.validateInput, createTransformer.newTransformerObj)\" value=\"Validate Transformer\" ng-disabled=\"!createTransformer.validateInput.length || createTransformer.isValidateFailed || createTransformer.isInputBadlyFormatted\"> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-class=\"createTransformer.isValidated ? \'\' : \'m-r-5\'\" ng-bind=\"createTransformer.isValidated ? \'Next\' : \'Review\'\" wz-next=\"\" ng-if=\"!createTransformer.isTransformerCreating\"></button> <input ng-if=\"createTransformer.reviewBtnTxt === \'Save Transformer\' && createTransformer.isValidated && !createTransformer.isTransformerCreating\" type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Save\" ng-click=\"createTransformer.finishedWizardEdit(createTransformer.newTransformerObj)\" ng-disabled=\"!createTransformer.newTransformerObj.name || !createTransformer.newTransformerObj.txtSpec.length\"> <input type=\"button\" class=\"btn btn-primary pull-right m-r-5\" value=\"Validate Again\" ng-click=\"createTransformer.fnValidateAgain()\" ng-if=\"createTransformer.isValidated && !createTransformer.isTransformerCreating\"><div ng-if=\"createTransformer.isTransformerCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12 m-t-15\" ng-if=\"createTransformer.isTransformerValidating\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/pipeline/transformers/transformerInfo/transformerTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitTransformer()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isTransformerDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isTransformerDetailsLoaded && !isDetailsEditable\" ng-class=\"!transformerPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-40\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"transformerObj.name\" placeholder=\"Name for the new Transformer*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"transformerObj.description\" placeholder=\"Description regarding Transformer\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"pace m-b-20\"><span>Spec</span><pre class=\"m-t-5\" ng-bind=\"getPrettyJson(transformerObj.spec)\"></pre></div></div><div class=\"col-sm-12\" ng-if=\"isTransformerDetailsLoaded && isDetailsEditable\"><ng-include src=\"\'app/pipeline/transformers/createTransformer/editTransformerFromBluePrint.html\'\"></ng-include></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{transformerObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(transformerObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((transformerPermissionsObj.Modify && !isDetailsEditable) || transformerPermissionsObj.Delete) && isTransformerDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"transformerPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable(transformerObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"transformerPermissionsObj.Delete\" ng-click=\"fnDeleteTransformer(transformerObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/modals/WorkflowStateModal/workflowStatModal.html","<div class=\"inmodal h-100\" ng-init=\"workflowStateModal.fnInitWorkflowStatesModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Workflow States</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\" id=\"workflowStatesTabView\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"col-sm-12 p-0 workflowStatesPanel\"><uib-tabset active=\"activeForm\"><uib-tab index=\"0\" heading=\"FUNCTION\"><div class=\"col-sm-12 m-t-20 state-search-panel\"><div class=\"md-input\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"workflowStateModal.functionSearch\" ng-change=\"workflowStateModal.fnStatesFilter(\'FUNCTION\')\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12 p-0 functionTab\"><div class=\"col-sm-6\" ng-repeat=\"obj in workflowStateModal.statesArr.FUNCTION\"><div class=\"panel panel-default\" ng-style=\"{\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"panel-heading h-100 p-l-10 p-r-10\" ng-style=\"{\'background-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color),\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-10 p-0 text-left m-t-2\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><img class=\"stateIcon\" ng-style=\"workflowStateModal.fnGetStateIconCss(obj)\" ng-src=\"data:image/svg+xml;base64,{{obj.icon}}\"> <span class=\"stateText\" ng-if=\"obj.category === \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name.substring(0, obj.name.indexOf(\"(\"))}}</span> <span class=\"stateText\" ng-if=\"obj.category !== \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name}}</span></label></div><div class=\"col-sm-2 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn pull-right\" ng-style=\"workflowStateModal.fnGetInjectButtonCss(obj);\" ng-click=\"workflowStateModal.fnInject(obj)\">Inject</button></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"SERVICE\"><div class=\"col-sm-12 m-t-20 state-search-panel\"><div class=\"md-input\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"workflowStateModal.serviceSearch\" ng-change=\"workflowStateModal.fnStatesFilter(\'SERVICE\')\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12 serviceTab\"><div class=\"col-sm-6\" ng-repeat=\"obj in workflowStateModal.statesArr.SERVICE\"><div class=\"panel panel-default\" ng-style=\"{\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"panel-heading h-100 p-l-10 p-r-10\" ng-style=\"{\'background-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color),\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-10 p-0 text-left m-t-2\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><img class=\"stateIcon\" ng-style=\"workflowStateModal.fnGetStateIconCss(obj)\" ng-src=\"data:image/svg+xml;base64,{{obj.icon}}\"> <span class=\"stateText\" ng-if=\"obj.category === \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name.substring(0, obj.name.indexOf(\"(\"))}}</span> <span class=\"stateText\" ng-if=\"obj.category !== \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name}}</span></label></div><div class=\"col-sm-2 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn pull-right\" ng-style=\"workflowStateModal.fnGetInjectButtonCss(obj);\" ng-click=\"workflowStateModal.fnInject(obj)\">Inject</button></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" heading=\"OUTPUT\"><div class=\"col-sm-12 m-t-20 state-search-panel\"><div class=\"md-input\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"workflowStateModal.outputSearch\" ng-change=\"workflowStateModal.fnStatesFilter(\'OUTPUT\')\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12 outputTab\"><div class=\"col-sm-6\" ng-repeat=\"obj in workflowStateModal.statesArr.OUTPUT\"><div class=\"panel panel-default\" ng-style=\"{\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"panel-heading h-100 p-l-10 p-r-10\" ng-style=\"{\'background-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color),\'border-color\': workflowStateModal.fnGetPanelHeadingCss(obj.color)}\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-10 p-0 text-left m-t-2\"><label class=\"stateLabel ellipsis m-b-0 p-b-5\"><img class=\"stateIcon\" ng-style=\"workflowStateModal.fnGetStateIconCss(obj)\" ng-src=\"data:image/svg+xml;base64,{{obj.icon}}\"> <span class=\"stateText\" ng-if=\"obj.category === \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name.substring(0, obj.name.indexOf(\"(\"))}}</span> <span class=\"stateText\" ng-if=\"obj.category !== \'TRIGGER\'\" ng-style=\"workflowStateModal.fnGetStateTextCss(obj)\">{{obj.name}}</span></label></div><div class=\"col-sm-2 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn pull-right\" ng-style=\"workflowStateModal.fnGetInjectButtonCss(obj);\" ng-click=\"workflowStateModal.fnInject(obj)\">Inject</button></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"workflowStateModal.fnCancel()\">Close</button></div></div>");
$templateCache.put("app/pipeline/workflows/modals/connectorModal/connectorModal.html","<div class=\"inmodal theme_modal h-100\" ng-init=\"connectorModal.fnInitModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Connector Details\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\" ng-class=\"connectorModal.isReadOnly ? \'pace\' : \'\'\"><ng-query-builder query-builder=\"connectorModal.queryBuilder\" action-filters=\"connectorModal.connectorFieldExpArr\" drop-down-needed=\"false\"></ng-query-builder></div></div></div></div><div class=\"modal-footer text-right\"><div class=\"col-sm-12 p-0\" ng-if=\"!connectorModal.isReadOnly\"><button class=\"btn btn-link\" ng-click=\"connectorModal.fnExitExpression()\">Cancel</button> <button class=\"btn btn-link\" ng-click=\"connectorModal.fnSaveExpression()\">Save Expression</button></div><div class=\"col-sm-12 p-0\" ng-if=\"connectorModal.isReadOnly\"><button class=\"btn btn-link\" ng-click=\"connectorModal.fnClose()\">Close</button></div></div></div>");
$templateCache.put("app/pipeline/workflows/modals/draftOptions/draftOptions.html","<div class=\"inmodal theme_modal\" ng-init=\"draftOptions.fnInitModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Select a draft\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12\"><div id=\"tableContainer\" class=\"drafts-table\"><table class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"draftOptions.draftsArr.length\" class=\"p-8\"></th><th ng-if=\"draftOptions.draftsArr.length\">Draft name</th><th ng-if=\"draftOptions.draftsArr.length\" class=\"p-8\"></th><th ng-if=\"!draftOptions.draftsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"drafts in draftOptions.draftsArr track by $index\" ng-click=\"draftOptions.fnselectDraft(drafts)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"drafts.isCheck\" ng-change=\"draftOptions.fnselectDraft(drafts)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td ng-bind=\"drafts.name\">Doe</td><td><i class=\"fa fa-trash\" ng-if=\"draftOptions.selectedDraft === drafts.name\" ng-click=\"$event.stopPropagation(); draftOptions.fnDeleteDraft(drafts, $index)\"></i></td></tr></tbody></table></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"draftOptions.isOpenClicked\"></div><button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!draftOptions.isOpenClicked\" ng-disabled=\"!draftOptions.selectedDraft\" ng-click=\"draftOptions.fnOpen()\" tabindex=\"12\">Open</button><div class=\"pull-right m-r-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"draftOptions.isClosedClicked\"></div><button type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-if=\"!draftOptions.isClosedClicked\" ng-click=\"draftOptions.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/pipeline/workflows/modals/inputPrompt/inputPrompt.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h3 class=\"modal-title text-capitalize\" ng-bind=\"\'Array Input\'\"></h3><button style=\"position: absolute;right: 11px;top: 11px;\" uib-tooltip=\"This modal helps to set the value position in array.\" tooltip-placement=\"left\" type=\"button\" class=\"btn btn-link pull-right p-0\"><i class=\"fa fa-2x fa-question-circle-o\"></i></button></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput\"><form novalidate=\"\" name=\"inputPromptForm\"><div class=\"col-sm-12 p-0\" ng-repeat=\"kvpPair in inputPrompt.promptoptionsArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-40\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"number\" min=\"1\" ng-model=\"kvpPair.value\" placeholder=\"Input Value\"> <span class=\"highlight\"></span> <label>{{kvpPair.value ? inputPrompt.ordinal_suffix_of(kvpPair.value)+\" \":\"\"}}{{kvpPair.fieldLabel.toUpperCase()}}</label></div></div></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"inputPromptForm.$invalid\" ng-click=\"inputPrompt.fnClose()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"inputPromptForm.$invalid\" ng-click=\"inputPrompt.fnSave()\" tabindex=\"12\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/modals/previewWorkFlow/previewWorkFlow.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">{{previewWorkFlow.workflowObj.name}}</strong></div><div class=\"modal-body h-dynamic p-0\" style=\"height: calc(100vh - 153px) !important;\"><div class=\"row h-100\" ng-init=\"previewWorkFlow.fnInitModel()\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container p-0\" style=\"overflow: auto\"><div id=\"canvas\" draw2d-canvas=\"\" ng-model=\"previewWorkFlow.flowJson\"></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-if=\"previewWorkFlow.workflowPermissionObj.Create\" ng-click=\"previewWorkFlow.fnClone()\">Clone</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-click=\"previewWorkFlow.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/pipeline/workflows/modals/saveDraftName/saveDraftName.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Save Draft\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput\"><form novalidate=\"\" name=\"draftForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"workflowName\" type=\"text\" name=\"draftName\" ng-pattern=\"/^\\S*$/\" ng-change=\"createDraft.fnCheckNameAvailability(createDraft.draftName)\" ng-model=\"createDraft.draftName\" placeholder=\"Draft name*\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text-error\" ng-show=\"!createDraft.isDraftNameUnique && createDraft.draftName.length\"><span class=\"errorText\">Draft with name has already been saved. Please choose another one.</span></small> <small class=\"helper-text-error\" ng-show=\"draftForm.draftName.$error.pattern\"><span class=\"errorText\">Draft name should not contain spaces.</span></small></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"createDraft.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!createDraft.isDraftNameUnique || !createDraft.draftName.length || draftForm.draftName.$error.pattern\" ng-click=\"createDraft.fnSave()\" tabindex=\"12\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/modals/workflowTriggersModal/workflowTriggersModal.html","<div class=\"inmodal h-100\" ng-init=\"workflowTriggersModal.fnInitWorkflowTriggersModal()\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Workflow Triggers</strong></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div class=\"col-sm-12\" ng-if=\"!workflowTriggersModal.isTriggersModalSelected\"><div class=\"md-input\"><input type=\"text\" required=\"\" class=\"md-form-control\" ng-model=\"workflowTriggersModal.search\" ng-change=\"workflowTriggersModal.fnStatesFilter()\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div ng-if=\"!workflowTriggersModal.isTriggersModalSelected\" id=\"functionModal\"><div class=\"col-sm-6\" ng-repeat=\"obj in workflowTriggersModal.triggersArr\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"workflowTriggersModal.fnInject(obj)\">Inject</button></div><h3 class=\"m-t-9\"><span>{{obj.name.split(\'(\')[0]}}</span></h3></div><div class=\"panel-body\"><span>{{obj.name.split(\'(\')[1].replace(\')\',\'\')}}</span> <span class=\"pull-right\"><button class=\"btn btn-link p-0\" ng-click=\"workflowTriggersModal.fnGetModelInfo(obj)\">see model</button></span></div></div></div></div><div ng-if=\"workflowTriggersModal.isTriggersModalSelected\" id=\"workflowTriggersTreeView\"><div class=\"col-sm-12 p-0 m-b-10\"><span>{{workflowTriggersModal.selectedFunction.name.split(\'(\')[0]}}</span></div><div class=\"col-sm-12 p-0\" ng-if=\"workflowTriggersModal.selectedFunction.name === \'Undefined Event (*:*:*)\'\"><label>This trigger requires you to define your own data model.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"workflowTriggersModal.selectedFunction.name !== \'Undefined Event (*:*:*)\'\"><ul class=\"tree\"><li ng-repeat=\"node in workflowTriggersModal.workflowOutputsArr\" ng-include=\"\'nodes_renderer.html\'\"></li></ul><script type=\"text/ng-template\" id=\"nodes_renderer.html\">{{node.index.includes(\'.\')?node.index.split(\'.\')[node.index.split(\'.\').length-1]:node.index}} <ul> <li ng-repeat=\"node in node.children\" ng-include=\"\'nodes_renderer.html\'\"> </li> </ul></script></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"workflowTriggersModal.isTriggersModalSelected\" class=\"btn btn-link pull-left\" ng-click=\"workflowTriggersModal.fnBackToFunctions()\">Back</button> <button ng-if=\"workflowTriggersModal.isTriggersModalSelected\" type=\"button\" class=\"btn btn-primary\" ng-click=\"workflowTriggersModal.fnClose(workflowTriggersModal.selectedFunction)\">Inject</button></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitWorkflow()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isWorkflowDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isWorkflowDetailsLoaded\"><div id=\"wfFormDiv\" class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-40\" ng-class=\"!workflowPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"workflowObj.name\" placeholder=\"Name for the Workflow*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\" ng-class=\"!workflowPermissionsObj.Modify || !isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"workflowObj.description\" placeholder=\"Description regarding Workflow\"> <span class=\"highlight\"></span> <label>Description</label></div></div><div id=\"wfPreviewDiv\" class=\"col-sm-12 p-0\" ng-style=\"{\'height\' : fnGetPreviewDivHeight(), \'overflow\' : \'auto\'}\"><div id=\"canvas\" draw2d-canvas=\"\" ng-model=\"flowJson\"></div></div><div id=\"wfActionsDiv\" class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-primary\" ui-sref=\"main.workFlowsView({id : workflowObj.id})\">View Flow</button> <button ng-click=\"fnPreviewWorkFlow(workflowObj,workflowObj.id)\" class=\"btn btn-primary\">Preview Flow</button><br></div><div id=\"wfEditActionsDiv\" class=\"col-sm-12 p-0\"><div class=\"m-t-10\"><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnCancelEditing()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateWorkflowDetails(workflowObj)\">Save</button></div><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{workflowObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(workflowObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6\" ng-if=\"!isCloneCompleted\"><div class=\"m-t-1 m-b-0 p-b-0 pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-6 content-box-footerItem\" ng-if=\"isCloneCompleted && isWorkflowDetailsLoaded\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(workflowPermissionsObj.Modify && !isDetailsEditable) || workflowPermissionsObj.Delete || workflowPermissionsObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"workflowPermissionsObj.Modify && !isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable(workflowObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"workflowPermissionsObj.Delete\" ng-click=\"fnDeleteWorkflow(workflowObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"workflowPermissionsObj.Create\" ng-click=\"fnCloneWorkFlow(workflowObj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowTabs/logging.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnSetTabHeight()\"><div class=\"col-sm-12\" ng-class=\"!workflowPermissionsObj.Modify || !isLogginDetailsEditable ? \'pace\' : \'\'\"><div class=\"m-t-20 m-b-20\"><span class=\"m-r-5 middle-display\">Enabled:</span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"workflowObj.logging.enabled\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div><div class=\"m-t-10\"><button ng-if=\"isLogginDetailsEditable && isLoggingUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"fnCancelEditing()\">Cancel</button> <button ng-if=\"isLogginDetailsEditable && isLoggingUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateWorkflowLoggingDetails(workflowObj)\">Save</button></div><div class=\"col-sm-12\" ng-if=\"!isLoggingUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{workflowObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(workflowObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"workflowPermissionsObj.Modify || workflowPermissionsObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"workflowPermissionsObj.Modify\" ng-click=\"fnEnableLoggingEditable()\"><a class=\"btn btn-link\">Edit Logging</a></li><li ng-if=\"workflowPermissionsObj.Create\" ng-click=\"fnCloneWorkFlow(workflowObj)\"><a class=\"btn btn-link\">Clone Workflow</a></li></ul></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowTabs/roles.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnSetTabHeight()\"><div class=\"col-sm-12 floatingLabelInput\" ng-repeat=\"roleObj in workflowObj.roles track by $index\"><div class=\"md-input m-b-20 m-t-40\"><input class=\"md-form-control pace\" required=\"\" id=\"name\" type=\"text\" ng-model=\"roleObj.name\" placeholder=\"Name for the Role\"> <span class=\"highlight\"></span> <label>Name</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"description\" type=\"text\" ng-model=\"roleObj.description\" placeholder=\"Description regarding Role\"> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"col-sm-12 p-0\"><label>Statement</label><br><div class=\"row\"><div class=\"col-sm-6 m-t-15\" ng-repeat=\"statements in roleObj.statements track by $index\"><div class=\"col-sm-12 statementsItem\"><div class=\"m-t-8\"><label>Actions</label> <button type=\"button\" class=\"btn btn-link pull-right p-0\"></button></div><div class=\"action-tags\"><div class=\"search-tag-container m-t-5\"><button class=\"btn btn-primary btn-xs m-r-5 m-b-5 pace\" ng-repeat=\"tag in statements.actions track by $index\">{{tag}}</button></div></div><div class=\"row footer\"><label class=\"m-0\">Expression: {{statements.expression ? \"Yes\" : \'No\'}}</label></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{workflowObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(workflowObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"workflowPermissionsObj.Create\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"workflowPermissionsObj.Create\" ng-click=\"fnCloneWorkFlow(workflowObj)\"><a class=\"btn btn-link\">Clone Workflow</a></li></ul></div></div></div></div>");
$templateCache.put("app/predictive/account/directives/accountInfo/accountInfo.html","<div class=\"container-with-footer tab-container\"><div class=\"row user-header m-l-0 w100\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-30 p-b-30\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-6 p-0\"><span>Account</span></div><div class=\"col-sm-6 p-0 m-auto justify-content-flex-end\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-6 p-0\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{accountObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{accountObj.name}}</h3></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"m-0 m-t-10\" ng-if=\"isFullWidthDevice\">{{accountObj.description ? accountObj.description : \'\'}}</h2><h5 class=\"m-0 m-t-0\" ng-if=\"!isFullWidthDevice\">{{accountObj.description ? accountObj.description : \'\'}}</h5><div ng-if=\"!isFullWidthDevice\"><label class=\"m-b-0 m-t-7 font-12px\">ID: {{accountObj.id}}</label> <i class=\"m-l-5 fa m-t-7\" ng-click=\"fnCopyToClipboard(accountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div></div></div><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div>");
$templateCache.put("app/predictive/account/modal/lockECUSerial/lockECUSerial.html","<div class=\"inmodal theme_modal\" ng-init=\"LockECUSerial.fnInitLockECUSerialModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">{{LockECUSerial.accountObj.name}}</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 p-0 p-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-b-10\"><label>Lock a serial number to {{LockECUSerial.accountObj.name}} account.</label></div><div class=\"col-sm-12\"><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" id=\"AccountID\" type=\"text\" ng-model=\"LockECUSerial.inputObj.accountId\" placeholder=\"Account ID*\" name=\"AccountID\"> <span class=\"highlight\"></span> <label>Account ID*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"SerialNumber\" type=\"text\" ng-model=\"LockECUSerial.inputObj.serialId\" placeholder=\"Serial Number*\" name=\"SerialNumber\"> <span class=\"highlight\"></span> <label>Serial Number*</label></div></div></div></div></div><div class=\"modal-footer\"><button ng-if=\"LockECUSerial.isUpdateCompleted\" type=\"button\" class=\"btn btn-primary pull-left\" ng-click=\"LockECUSerial.fnCancel()\" tabindex=\"12\">Close</button> <button ng-if=\"LockECUSerial.isUpdateCompleted\" type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!LockECUSerial.inputObj.accountId.length || !LockECUSerial.inputObj.serialId.length\" ng-click=\"LockECUSerial.fnLockSerialToAccount(LockECUSerial.inputObj)\" tabindex=\"12\">Lock Serial Number</button><div class=\"col-sm-12\" ng-if=\"!LockECUSerial.isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/storage/folder/folderInfo/folderTabs/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitFolder()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isFolderDetailsLoaded\"></div><div class=\"col-sm-12\" ng-if=\"isFolderDetailsLoaded\"><div class=\"col-sm-12 m-t-20 p-0\"><label><i ng-class=\"\'fa \'+ folderObj.icon\"></i>&nbsp;&nbsp; <span>{{folderObj.name}}</span></label></div><div class=\"col-sm-12 m-t-20 p-0\"><button class=\"btn btn-primary m-r-15\" ng-if=\"folderPermissionsObj.Download\" ng-click=\"fnDownloadFile(fileObj.url, folderObj.name, fileObj.metadata.type)\">Download</button> <button class=\"btn btn-primary m-r-15\" ng-if=\"folderObj.size < 1000000 && fnCheckFileType(folderObj, fileObj)\" ng-click=\"fnOpenFileInNewTab(folderObj)\">Open</button> <button class=\"btn btn-primary\" ng-if=\"isFilePathCopied\" ng-click=\"fnCopyToClipboard(folderObj.path)\">Copy path</button> <label ng-if=\"!isFilePathCopied\" class=\"m-l-15\"><i class=\"fa fa-check m-r-5\"></i>Path Copied</label></div><div class=\"col-sm-12 m-b-5 m-t-20 p-0\"><div class=\"storage-breadcrumb\"><ul class=\"breadcrumb\"><li ng-repeat=\"pathName in directiveBreadcrumbArray track by $index\"><a class=\"link-dk-primary\"><i ng-if=\"pathName === \'/\'\" class=\"fa fa-home\"></i>{{pathName === \'/\' ? \'\' : pathName}}</a></li></ul></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Name:</span></div><div class=\"col-sm-9 p-0\"><span>{{folderObj.name}}</span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Size:</span></div><div class=\"col-sm-9 p-0\"><span>{{folderObj.fileSize}}</span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Last modified:</span></div><div class=\"col-sm-9 p-0\"><span ng-bind=\"folderObj.lastUpdate\"></span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Type:</span></div><div class=\"col-sm-9 p-0\"><span>{{fileObj.metadata.type}}</span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Encoding:</span></div><div class=\"col-sm-9 p-0\"><span>{{fileObj.metadata.encoding}}</span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>Language:</span></div><div class=\"col-sm-9 p-0\"><span>{{fileObj.metadata.language}}</span></div></div><div class=\"m-t-10 col-sm-12 p-0\"><div class=\"col-sm-3 p-0\"><span>MD5:</span></div><div class=\"col-sm-9 p-0\"><span>{{fileObj.metadata.md5}}</span></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"pull-right p-t-3\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"isFileDownloading\"></div><div class=\"row\" ng-if=\"!isFileDownloading\"><div class=\"col-sm-12 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(folderPermissionsObj.Download || folderPermissionsObj.Delete || folderPermissionsObj.Modify) && isFolderDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"folderObj.size < 1000000 && fnCheckFileType(folderObj, fileObj) && folderPermissionsObj.Download\"><a ng-click=\"fnOpenFileInNewTab(folderObj)\" class=\"btn btn-link\">Open</a></li><li ng-if=\"folderPermissionsObj.Download\"><a class=\"btn btn-link\" ng-click=\"fnDownloadFile(fileObj.url, folderObj.name, fileObj.metadata.type)\">Download</a></li><li class=\"divider\" ng-if=\"folderObj.type === \'file\' && folderPermissionsObj.Modify\"></li><li ng-if=\"folderPermissionsObj.Modify\"><a class=\"btn btn-link\" ng-click=\"fnOpenRenameModal(folderObj)\">Rename</a></li><li ng-if=\"folderPermissionsObj.Delete\"><a class=\"btn btn-link\" ng-click=\"fnDeleteFile(folderObj)\">Delete</a></li><li class=\"divider\" ng-if=\"folderObj.type === \'file\' && folderPermissionsObj.Modify\"></li><li ng-if=\"folderPermissionsObj.Modify\"><a class=\"btn btn-link\" ng-click=\"fnSetCutCopyPath(\'COPY\', folderObj)\">Copy</a></li><li ng-if=\"folderPermissionsObj.Modify\"><a class=\"btn btn-link\" ng-click=\"fnSetCutCopyPath(\'MOVE\', folderObj)\">Cut</a></li></ul></div></div></div></div>");
$templateCache.put("app/storage/folder/modals/renameModal/renameModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Enter new name for selected \'+ renameModal.folderObj.type\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput\"><form novalidate=\"\" name=\"renameForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"workflowName\" type=\"text\" name=\"itemName\" ng-pattern=\'/^[^\\\\\\/\\?\\*\\\"\\>\\<\\:\\|]*$/\' ng-model=\"renameModal.itemName\" placeholder=\"New Name for {{renameModal.folderObj.type}}*\"> <span class=\"highlight\"></span> <label>Enter new name for selected {{renameModal.folderObj.type}}*</label> <small class=\"helper-text-error\" ng-show=\"renameForm.itemName.$error.pattern\"><span class=\"errorText\">{{renameModal.folderObj.type}} name should not contain \'/ \\ : ? * \" < >\' characters.</span></small></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-if=\"!renameModal.isRenameProcessOn\" ng-click=\"renameModal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-if=\"!renameModal.isRenameProcessOn\" ng-disabled=\"!renameModal.itemName.length\" ng-click=\"renameModal.fnSave()\" tabindex=\"12\">Save</button><div class=\"pull-right m-r-5\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"renameModal.isRenameProcessOn\"></div></div></div>");
$templateCache.put("app/tracker/archived/archivedInfo/archivedSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitIssue()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isIssueDetailsLoaded\"></div><div class=\"col-sm-12 newCommentUI d-flex p-0 height-inherit\" ng-if=\"isIssueDetailsLoaded\"><div class=\"p-r-0 p-t-10 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class p-l-15\'\"><div class=\"col-sm-12 p-0\" ng-if=\"selectedCommentView === \'Horizontal\'\"><div class=\"col-sm-12 d-flex p-0 comment-timeline\"><div class=\"dashed-border w100 main-comment-line-position\"></div><div class=\"d-flex w100 justify-content-space-between\" style=\"overflow-y: hidden\"><div class=\"d-flex w100 position-r p-r-10\" ng-class=\"isShowIssueSummary ? \'commentArrowIcon\':\'\'\" style=\"z-index: 1;\"><span ng-click=\"fnShowIssueSummary()\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"isShowIssueSummary ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/main-comment.svg#mainComment\"></use></svg></span></div><div ng-repeat=\"comment in issueObj.publicComments track by $index\" class=\"d-flex position-r\" ng-class=\"{ \'width-auto bg-color m-l-10 p-r-1\': $last, \'w100 p-l-10 p-r-10\': !$last, \'commentArrowIcon\': comment.id === selectedComment.id }\" style=\"z-index: 1;\"><span ng-click=\"fnShowComment(comment, \'mainComment\')\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"comment.id === selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span><div ng-if=\"comment.subComments && comment.subComments.length\" class=\"aaa d-flex w100\" style=\"position: relative;\"><div class=\"dashed-border sub-comment-line-position\"></div><div class=\"d-flex w100 m-l-10 m-r-10\" ng-class=\"comment.subComments.length > 1 ?\'justify-content-space-between\':\'justify-content-flex-end\'\"><div ng-repeat=\"subComment in comment.subComments track by $index\" class=\"d-flex p-t-25 position-r\" ng-class=\"{ \'commentArrowIcon\': subComment.id === selectedComment.id, \'width-30px\': !$last }\" style=\"z-index: 1;\"><span ng-click=\"fnShowComment(subComment, \'subComment\')\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"subComment.id === selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"comment\"><div class=\"comment-header p-l-10 p-r-10\"><div class=\"col-sm-12 p-0 d-flex h-100\"><div class=\"col-sm-7 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"selectedComment.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{selectedComment.userAvatar}}\"> {{selectedComment.createdBy ? selectedComment.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{selectedComment.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{selectedComment.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-5 pull-right text-right p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex m-r-20\" ng-if=\"isShowIssueSummary\" ng-class=\"selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"d-flex m-r-20\" ng-if=\"!isShowIssueSummary\" ng-class=\"selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><span class=\"m-r-10 p-r-5 pull-right\"><span uib-tooltip=\"{{fnGetRelativeTime(selectedComment.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(selectedComment.createdAt)}}</span></span></div></div></div><div class=\"comment-body p-0 m-t-1 overflow-auto\"><div class=\"position-r hide-toolbar\" ng-if=\"selectedComment.mdBody\" style=\"height: inherit;\" ng-class=\"!selectedComment.isEditMode ? \'preview-only\' : \'\'\"><textarea name=\"editor{{selectedComment.id}}\" class=\"content-box\" ng-model=\"selectedComment.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                            </textarea></div></div></div></div></div><div class=\"col-sm-12 p-0 vertical-comment-view overflow-auto\" ng-if=\"selectedCommentView === \'Vertical\'\"><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 m-t-0 p-l-0 p-r-5\"><div ng-class=\"!issueObj.publicComments.length ? \'message-first m-b-0\' : \'message-item\'\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!issueSummary.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issueSummary.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issueSummary.userAvatar}}\"> {{issueSummary.createdBy ? issueSummary.createdBy : \"ECSMon\"}} - <span tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueSummary.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issueSummary.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10 pace opacity-5\"><label class=\"m-0 m-r-10\">{{issueSummary.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(issueSummary.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(issueSummary.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{issueSummary.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!issueSummary.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{issueSummary.id}}\" ng-model=\"issueSummary.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div></div><div ng-class=\"$index === issueObj.publicComments.length - 1 ? \'message-first m-b-0\' : \'message-item\'\" ng-repeat=\"commentObj in issueObj.publicComments track by $index\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"commentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{commentObj.userAvatar}}\"> {{commentObj.createdBy ? commentObj.createdBy : \"ECSMon\"}} - <span uib-tooltip=\"{{commentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{commentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10 pace opacity-5\"><label class=\"m-0 m-r-10\">{{commentObj.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(commentObj.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(commentObj.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{commentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!commentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{commentObj.id}}\" ng-model=\"commentObj.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div><div class=\"p-t-20 p-b-0 p-l-20 sub-comment-container position-r\" ng-if=\"(commentObj.subComments && commentObj.subComments.length) || commentObj.isShowSubCommentEditor\"><div ng-repeat=\"subCommentObj in commentObj.subComments track by $index\" ng-class=\"{\'message-first m-b-0\': $index === commentObj.subComments.length - 1 && !commentObj.isShowSubCommentEditor , \'message-item\': $index !== commentObj.subComments.length - 1 || commentObj.isShowSubCommentEditor}\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!subCommentObj.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"subCommentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{subCommentObj.userAvatar}}\"> {{subCommentObj.createdBy ? subCommentObj.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{subCommentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{subCommentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\"><label class=\"m-0 m-r-10\"></label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(subCommentObj.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(subCommentObj.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{subCommentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!subCommentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{subCommentObj.id}}\" ng-model=\"subCommentObj.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                                            </textarea></div></div></div></div></div></div></div></div></div><div class=\"p-r-0 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-3\': \'custom-class-sidebar p-l-15\'\"><archived-side-bar issue-obj=\"issueObj\" class=\"h-100\" is-expanded=\"isExpanded\"></archived-side-bar></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/archived/directives/archivedSideBar/archivedSideBar.html","<div class=\"issue-side-panel height-inherit\"><div class=\"col-sm-12 p-0 overflow-auto expand-side-panel\"><div class=\"col-sm-12 p-0\" ng-if=\"isExpanded\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignes</label><div class=\"col-sm-12 label-box p-10 issue-label\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!issueObj.assignees\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><span class=\"p-0 d-block p-b-5\" ng-if=\"issueObj.assignees\" ng-repeat=\"assignee in issueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">type</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueType\"><div class=\"grayItalicValue\">No Type</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issueType\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueType.color)\"><span>{{issueObj.issueType.name}}</span></button></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"fnGetIssuesLabelColor(issueObj.issuePriority.color)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueState.color)\"><span>{{issueObj.issueState.name}}</span></button></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueLabels\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5 ellipsis-issues-label\" ng-style=\"fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Participants</label><div class=\"col-sm-12 label-box p-10 issue-label\"><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.participants\"><div class=\"grayItalicValue\">No Participant</div></div><span class=\"p-0\" ng-if=\"issueObj.participants\" ng-repeat=\"participant in issueObj.participants\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\">{{participant}}</span></span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">RESOLUTION DEADLINE</label><div class=\"label-box p-10 p-b-40\"><div class=\"col-sm-12 p-0 font-italic p-t-20\" ng-if=\"!issueObj.issueDeadlineRelativeDateTime\"><div class=\"grayItalicValue\">No Resolution Deadline</div></div><div class=\"col-sm-12 p-0 p-t-5\"><span>{{issueObj.issueDeadlineRelativeDateTime}}</span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">RESPONSE DEADLINE</label><div class=\"label-box p-10 p-b-40\"><div class=\"col-sm-12 p-0 font-italic p-t-20\" ng-if=\"!issueObj.issueResponseDeadlineRelativeDateTime\"><div class=\"grayItalicValue\">No Response Deadline</div></div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"issueObj.issueResponseDeadlineRelativeDateTime\"><span>{{issueObj.issueResponseDeadlineRelativeDateTime}}</span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><span ng-if=\"!issueObj.confidential\">Not</span> Confidential</div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PROJECT</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-11 p-0 p-t-5\"><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"!isIssueProjectLoaded\"></app-spinner><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.projectId && isIssueProjectLoaded\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.projectId && isIssueProjectLoaded\"><span>{{issueObj.project.name}}</span></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!isExpanded\"><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetAssigneesTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueType.name ? issueObj.issueType.name: \'No Type\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issuePriority.name ? issueObj.issuePriority.name: \'No Priority\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueState.name ? issueObj.issueState.name: \'No State\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetLabelsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetParticipantsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueDeadlineRelativeDateTime ? issueObj.issueDeadlineRelativeDateTime : \'No Resolution Deadline\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueResponseDeadlineRelativeDateTime ? issueObj.issueResponseDeadlineRelativeDateTime : \'No Response Deadline\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/responseDeadline.svg#responseDeadline\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.confidential ? \'Confidential\' : \'Not Confidential\'}}\" tooltip-placement=\"left\"><svg ng-if=\"issueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/confidential.svg#confidential\"></use></svg><svg ng-if=\"!issueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/notConfidential.svg#notConfidential\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.project.name ? issueObj.project.name : \'No Project\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 d-flex issue-side-panel-expand-btn\"><button class=\"btn btn-primary d-flex align-items-center justify-content-center w100\" ng-click=\"fnExpandCollapseSideBar()\"><i class=\"fa\" ng-class=\"isExpanded ? \'fa-angle-double-right\':\'fa-angle-double-left\'\"></i></button></div></div>");
$templateCache.put("app/tracker/archived/modal/RestoreIssue/RestoreIssue.html","<div class=\"form-content h-100\" ng-init=\"restoreIssue.fnInitModal()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Restore Issue</h3></div><div class=\"modal-body\" style=\"overflow: hidden;\"><div class=\"col-sm-12 p-0\"><label class=\"m-0\">Select a project to which the issue should unarchive to :</label></div><div class=\"col-sm-12 p-0 m-t-20 floatingLabelInput\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintProject\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"project as project.name for project in restoreIssue.projectsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"restoreIssue.selectedProject\" placeholder=\"Project for the Issue\"> <span class=\"highlight\"></span> <label>Select Project</label></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"restoreIssue.isRestore\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-click=\"restoreIssue.fnCancel()\">Close</button> <button type=\"button\" ng-if=\"restoreIssue.isRestore\" class=\"btn btn-primary v4-primary-button\" ng-click=\"restoreIssue.fnUnarchivesIssue()\">Restore Issue</button><div class=\"pull-right\" ng-if=\"!restoreIssue.isRestore\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div>");
$templateCache.put("app/tracker/issue/directives/boardSettings/boardSettings.html","<div class=\"container-with-footer\"><div class=\"content-body-55\"><div class=\"col-sm-12 p-t-15 h-100\"><div class=\"col-sm-12 p-0 m-b-10 d-flex align-items-center\"><label class=\"m-0 m-r-10\">Selected Project:</label><div class=\"d-flex m-r-10 customDropdown\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><app-spinner ng-if=\"!isProjectLoaded\" spinner-type=\"\'microSpinnerXS\'\"></app-spinner><span class=\"p-l-1 ellipsis\" ng-if=\"isProjectLoaded\">{{project.name ? project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"projectObj in projectsArr\" ng-if=\"projectObj.id !== \'All\'\"><a ng-click=\"fnChangeProject(projectObj)\"><span>{{projectObj.name}}</span><br><span class=\"font-italic\">({{projectObj.id}})</span></a></li></ul></div></div></div><div class=\"boardSettingsContent col-sm-12 p-0\" style=\"height: calc(100% - 52px)\"><uib-accordion><div uib-accordion-group=\"\" class=\"panel-default\" is-open=\"true\" is-disabled=\"true\"><uib-accordion-heading><div class=\"d-flex justify-content-space-between align-items-center\"><label class=\"m-0\">List of Available {{isCalledForState ? \'State\' : isCalledForPriority ? \'Priority\' : \'Type\'}} Panels</label> <i class=\"fa fa-info-circle\" uib-tooltip=\"Adjust the panels according to the priority by clicking on the arrow on the row.\" tooltip-placement=\"left\"></i></div></uib-accordion-heading><div class=\"col-sm-12 p-0 h-100\"><app-spinner ng-if=\"isPanelsLoading\" spinner-type=\"\'miniSpinner\'\"></app-spinner><ul class=\"col-sm-12 p-0 h-100 panelList\" ng-if=\"!isPanelsLoading\"><li ng-repeat=\"panelObj in panelsArr track by $index\" class=\"m-r-10\" ng-style=\"{\'background-color\': panelObj.color, \'color\': fnInvertColor(panelObj.color)}\"><div class=\"d-flex flex-column col-sm-12 p-10 h-100\"><div class=\"d-flex align-items-center justify-content-space-between col-sm-12 p-0\"><label class=\"ellipsis-label\">{{panelObj.name}}</label><div class=\"d-flex flex-column justify-content-center\"><i class=\"fa fa-arrow-left m-b-5\" ng-click=\"fnMoveItem($index, $index - 1)\" ng-show=\"!$first\"></i> <i class=\"fa fa-arrow-right m-l-3\" ng-click=\"fnMoveItem($index, $index + 1)\" ng-show=\"!$last\"></i></div></div><div class=\"h-100 d-flex align-items-flex-end justify-content-flex-end\"><div class=\"d-flex align-items-center\"><switch id=\"CollapsedPanel\" uib-tooltip=\"{{panelObj.isShow ? \'Click to hide panel\' : \'Click to show panel\'}}\" tooltip-placement=\"left\" ng-model=\"panelObj.isShow\"></switch><span class=\"m-l-5\">{{panelObj.isShow ? \'Show\' : \'Hide\'}}</span></div></div></div></li></ul></div></div></uib-accordion></div></div></div><div class=\"content-footer d-flex col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 m-r-10\" ng-if=\"isSettingsSaved\" ng-click=\"fnResetPanels()\">Reset</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-if=\"isSettingsSaved\" ng-click=\"fnSaveSettings()\">Save Changes</button><div class=\"pull-right\" ng-if=\"!isSettingsSaved\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueAssigneeLabelSideBar/issueAssigneeLabelSideBar.html","<div class=\"issue-side-panel height-inherit\"><div class=\"col-sm-12 p-0 overflow-auto expand-side-panel\"><div class=\"col-sm-12 p-0\" ng-if=\"isExpanded\"><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Assignees</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssueAssigneeLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!changeAssigneeView && !issueObj.resolved && (userPermissionsObj.ADD_ASSIGNEE_TO_ISSUE || userPermissionsObj.REMOVE_ASSIGNEE_FROM_ISSUE)\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeAssigneeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 p-t-14 font-italic\" ng-if=\"!issueObj.assignees || !issueObj.assignees.length\"><div class=\"grayItalicValue p-0\">No Assignee</div></div><div class=\"col-sm-12 p-0\"><span class=\"p-0 d-block p-b-5\" ng-if=\"issueObj.assignees\" ng-repeat=\"assignee in issueObj.assignees\"><span class=\"m-r-5 m-b-5 p-2 border-1-assignee\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{assignee.userAvatar}}\"> <span class=\"user-name-position\">{{assignee.firstName}} {{assignee.lastName}}</span></span></span></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"changeAssigneeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleAssignee(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"issueObj.assignees.length > 1\">{{issueObj.assignees[0].username + \' + \' + (issueObj.assignees.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"issueObj.assignees.length === 1\">{{issueObj.assignees[0].firstName + \' \'+ issueObj.assignees[0].lastName}}</span> <span class=\"w100 text-left\" ng-if=\"!issueObj.assignees.length\">No Assignees</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign to</label> <span ng-click=\"fnCancelChangeAssignee()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"assigneeSearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"assigneeObj in filterAssignees=(usersArr | filter:assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetAssigneeInfo(assigneeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"assigneeObj.isCheck\"></i></span> <span class=\"m-r-5\"><img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" style=\"left: 0px;\" ng-src=\"{{assigneeObj.userAvatar}}\"></span> <span class=\"d-flex flex-column\"><span>{{assigneeObj.firstName + \" \"+ assigneeObj.lastName}}</span> <span class=\"font-italic gateway-id-menu-option\">({{assigneeObj.username}})</span></span></a></li><li ng-repeat=\"teamObj in filterteams=(teamsArr | filter:assigneeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetTeamInfo(teamObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"teamObj.isCheck\"></i></span> <span class=\"d-flex flex-column ellipsis\"><span>{{teamObj.name}}</span> <span class=\"font-italic gateway-id-menu-option ellipsis\">{{teamObj.description}}</span></span></a></li><li ng-if=\"!filterAssignees.length && !filterteams.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageAssignees()\"><a><span>Manage Assignees</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangeAssignee();\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">type</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssueTypeLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!changeTypeView && !issueObj.resolved && (userPermissionsObj.UPDATE_ISSUE_TYPE || userPermissionsObj.REMOVE_ISSUE_TYPE)\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeTypeView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueType\"><div class=\"grayItalicValue\">No Type</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issueType\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueType\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueType.color)\"><span>{{issueObj.issueType.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"changeTypeView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleType(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"issueObj.issueType.name\">{{issueObj.issueType.name}}</span> <span class=\"w100 text-left\" ng-if=\"!issueObj.issueType.name\">No Type</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Type</label> <span ng-click=\"fnCancelChangeType()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"typeSearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"typeObj in filterType=(typesArr | filter:typeSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetTypeInfo(typeObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"typeObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"typeObj.color ? {\'background-color\' : typeObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{typeObj.name}}</span></a></li><li ng-if=\"!filterType.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectTypes()\"><a><span>Manage project type</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangeType();\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">priority</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssuePriorityLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!changePriorityView && !issueObj.resolved && (userPermissionsObj.UPDATE_ISSUE_PRIORITY || userPermissionsObj.REMOVE_ISSUE_PRIORITY)\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangePriorityView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issuePriority\"><div class=\"grayItalicValue\">No Priority</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issuePriority\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issuePriority\" ng-style=\"fnGetIssuesLabelColor(issueObj.issuePriority.color)\"><span>{{issueObj.issuePriority.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"changePriorityView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnTogglePriority(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"issueObj.issuePriority.name\">{{issueObj.issuePriority.name}}</span> <span class=\"w100 text-left\" ng-if=\"!issueObj.issuePriority.name\">No Priority</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign Priority</label> <span ng-click=\"fnCancelChangePriority()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"prioritySearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"Priority in filterPriority=(prioritiesArr | filter:prioritySearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetPrioritiesInfo(Priority)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"Priority.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"Priority.color ? {\'background-color\' : Priority.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{Priority.name}}</span></a></li><li ng-if=\"!filterPriority.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectPriority()\"><a><span>Manage project priorities</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangePriority();\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">state</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssueStateLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!changeStateView && !issueObj.resolved && (userPermissionsObj.UPDATE_ISSUE_STATE || userPermissionsObj.REMOVE_ISSUE_STATE)\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeStateView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeStateView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueState\"><div class=\"grayItalicValue\">No State</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.issueState\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueObj.issueState\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueState.color)\"><span>{{issueObj.issueState.name}}</span></button></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput\" ng-if=\"changeStateView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggleState(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"issueObj.issueState.name\">{{issueObj.issueState.name}}</span> <span class=\"w100 text-left\" ng-if=\"!issueObj.issueState.name\">No State</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign State</label> <span ng-click=\"fnCancelChangeState()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"stateSearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"state in filterState=(statesArr | filter:stateSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetStatesInfo(state)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"state.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"state.color ? {\'background-color\' : state.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{state.name}}</span></a></li><li ng-if=\"!filterState.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectState()\"><a><span>Manage project state</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelChangeState();\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">LABELS</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssueLablesLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!addLabelView && !issueObj.resolved && (userPermissionsObj.ADD_LABEL_TO_ISSUE || userPermissionsObj.REMOVE_LABEL_FROM_ISSUE)\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenAddLabelView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\"><div class=\"col-sm-12 p-0 text-left\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.issueLabels\"><div class=\"grayItalicValue\">No Labels</div></div><div class=\"col-sm-12 p-0\"><button ng-repeat=\"labelsObj in assigneesLabels\" class=\"btn btn-default btn-xs m-r-5 m-b-5 ellipsis-issues-label\" ng-style=\"fnGetIssuesLabelColor(labelsObj.color)\">{{labelsObj.name}}</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"addLabelView\"><div class=\"btn-group p-0 d-flex\" uib-dropdown=\"\" auto-close=\"outsideClick\" is-open=\"true\" on-toggle=\"fnOnToggle(open)\"><button type=\"button\" class=\"btn btn-sm btn-primary v4-primary-button w100\" uib-dropdown-toggle=\"\"><div class=\"d-flex align-items-center\"><span class=\"w100 text-left\" ng-if=\"assigneesLabels.length > 1\">{{assigneesLabels[0].name + \' + \' + (assigneesLabels.length - 1) + \' more\'}}</span> <span class=\"w100 text-left\" ng-if=\"assigneesLabels.length === 1\">{{assigneesLabels[0].name}}</span> <span class=\"w100 text-left\" ng-if=\"!assigneesLabels.length\">No Labels</span> <span class=\"caret\" style=\"position: unset;\"></span></div></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu m-0 w100 sub-dropdown\"><li><span class=\"d-flex title\" style=\"padding: 3px 20px;margin: 4px;\"><label class=\"m-0 w100\">Assign labels</label> <span ng-click=\"fnCancelAddLabelView()\"><i class=\"fa fa-times\"></i></span></span></li><li class=\"divider\"></li><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"labelSearch[filter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"labelObj in filterLabels=(labelsArr | filter:labelSearch) track by $index\" ng-mousedown=\"$event.stopPropagation();fnGetLabelInfo(labelObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"labelObj.isCheck\"></i></span> <span class=\"m-r-5\" style=\"width: 15px; height: 15px;\" ng-style=\"labelObj.color ? {\'background-color\' : labelObj.color} : {\'background-color\' : \'inherit\'}\"></span> <span>{{labelObj.name}}</span></a></li><li ng-if=\"!filterLabels.length\"><a>No matching results</a></li></ul></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();fnManageProjectLabels()\"><a><span>Manage project labels</span></a></li><li class=\"divider\"></li><li ng-mousedown=\"$event.stopPropagation();\"><button type=\"button\" class=\"btn btn-primary pull-right m-r-24\" ng-click=\"fnCancelAddLabelView();\">Done</button></li></ul></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">Participants</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-class=\"!isIssueParticipantLoaded ? \'pace opacity-5\': \'\'\" ng-if=\"!changeParticipantView && !issueObj.resolved\"><i class=\"fa fa-edit fa-lg\" ng-click=\"$event.stopPropagation();fnOpenChangeParticipantView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeParticipantView\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.participants\"><div class=\"grayItalicValue\">No Participant</div></div><span class=\"p-0 d-block m-r-5 m-b-5 p-2\" ng-if=\"issueObj.participants\" ng-repeat=\"participant in issueObj.participants\"><span class=\"border-1-assignee p-4 m-b-5 d-flex align-items-center\"><span class=\"ellipsis\">{{participant}}</span> <i class=\"m-l-3 fa fa-times\" ng-click=\"fnDeleteParticipants(participant)\"></i></span></span></div><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput test\" ng-if=\"changeParticipantView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput linear-gradient-background\"><div class=\"md-input m-b-0\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"participants.email\" placeholder=\"participants\"> <span class=\"highlight\"></span> <label>Participants</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-disabled=\"!fnCheckEmpty(participants.email)\" ng-click=\"fnAddParticipants(participants.email)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-click=\"fnCancelChangeParticipant()\">Cancel</button></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">RESOLUTION DEADLINE</label><div class=\"label-box p-10 p-b-40\"><div class=\"col-sm-12 p-0 font-italic p-t-20\" ng-if=\"!issueObj.issueDeadlineRelativeDateTime\"><div class=\"grayItalicValue\">No Resolution Deadline</div></div><div class=\"col-sm-12 p-0 p-t-5\"><span>{{issueObj.issueDeadlineRelativeDateTime}}</span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">RESPONSE DEADLINE</label><div class=\"label-box p-10 p-b-40\"><div class=\"col-sm-12 p-0 font-italic p-t-20\" ng-if=\"!issueObj.issueResponseDeadlineRelativeDateTime\"><div class=\"grayItalicValue\">No Response Deadline</div></div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"issueObj.issueResponseDeadlineRelativeDateTime\"><span>{{issueObj.issueResponseDeadlineRelativeDateTime}}</span></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"label-header p-l-5 p-r-5\">CONFIDENTIALITY</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeConfidentialView && !issueObj.resolved\"><i class=\"fa fa-edit fa-lg\" ng-click=\"fnOpenChangeConfidentialView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeConfidentialView\"><span ng-if=\"!issueObj.confidential\">Not</span> Confidential</div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"changeConfidentialView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput linear-gradient-background\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintConfidential\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"confidential as confidential.name for confidential in confidentialsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedConfidential.confidential\" placeholder=\"Confidential for the Issue\"> <span class=\"highlight\"></span> <label>Select Confidential</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"isConfidentialChanged\" ng-disabled=\"!fnCheckEmpty(selectedConfidential.confidential.name)\" ng-click=\"fnChangeIssueConfidential(selectedConfidential.confidential)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"isConfidentialChanged\" ng-click=\"fnCancelChangeConfidential()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!isConfidentialChanged\"></app-spinner></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">PROJECT</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-1 p-0 pull-right text-right p-t-8\" ng-if=\"!changeProjectView && !issueObj.resolved && userPermissionsObj.MOVE_ISSUE_PROJECT\"><i class=\"fa fa-edit fa-lg\" ng-click=\"fnOpenChangeProjectView()\"></i></div><div class=\"col-sm-11 p-0 p-t-5\" ng-if=\"!changeProjectView\"><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"!isIssueProjectLoaded\"></app-spinner><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.projectId && isIssueProjectLoaded\"><div class=\"grayItalicValue\">No Project</div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueObj.projectId && isIssueProjectLoaded\"><span>{{issueObj.project.name}}</span></div></div><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"changeProjectView\"><div class=\"col-sm-12 p-0 m-t-10 floatingLabelInput linear-gradient-background\"><div class=\"md-input m-b-0 labelPanelActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintProject\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"project as project.name for project in projectsArr | filter:{name:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"selectedProject.project\" placeholder=\"Project for the Issue\"> <span class=\"highlight\"></span> <label>Select Project</label></div></div><div class=\"col-sm-12 p-0 m-t-10\"><button class=\"btn btn-link p-0 pull-right\" ng-if=\"isProjectChanged\" ng-disabled=\"!fnCheckEmpty(selectedProject.project.name)\" ng-click=\"fnChangeIssueProject(selectedProject.project)\">Save</button> <button class=\"btn btn-link p-0 m-r-5 pull-right\" ng-if=\"isProjectChanged\" ng-click=\"fnCancelChangeProject()\">Cancel</button><app-spinner spinner-type=\"\'microSpinner\'\" class=\"pull-right p-t-5\" ng-if=\"!isProjectChanged\"></app-spinner></div></div></div></div><div class=\"p-15 col-sm-12\"><label class=\"p-l-5 p-r-5 label-header\">ATTRIBUTES</label><div class=\"col-sm-12 label-box p-10\"><div class=\"col-sm-12 p-0 p-t-5\" ng-if=\"!isAttributeDataLoading\"><div class=\"col-sm-12 p-0 font-italic p-t-14\" ng-if=\"!issueObj.attributeIds.length\"><div class=\"grayItalicValue\">No Attributes</div></div><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-if=\"issueObj.attributeIds.length && !isAttributeDataLoading\" ng-repeat=\"attribute in selectedAttributesArr\" ng-class=\"!$last ? \'p-b-5\':\'\'\"><div class=\"col-sm-3 p-0\"><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{attribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"fnGetHealthColor(attribute.health, attribute)\"><span class=\"healtSpan\">{{attribute.healthName}}</span></button></div><div class=\"col-sm-8 p-0 d-flex align-items-center flex-column\" ng-click=\"fnOpenAttributeInfo(attribute)\"><div class=\"col-sm-12 p-0 d-flex\"><span class=\"ellipsis font-italic opacity-5\">{{attribute.nodeName}}</span></div><div class=\"col-sm-12 p-0 d-flex\"><span class=\"ellipsis\"><strong>{{attribute.name}}</strong></span></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center justify-content-flex-end\"><i class=\"fa fa-trash-o\" ng-click=\"$event.stopPropagation();fnDeleteAttribute(attribute)\"></i></div></div><div class=\"col-sm-12 p-0 d-flex p-t-10 align-items-center\" ng-if=\"!isAttributeDataLoading\"><div class=\"col-sm-6 p-0\"><button class=\"btn btn-link p-0\" ng-if=\"issueObj.attributeIds.length\" ng-click=\"fnOpenAllAttributeInfo()\">View attributes</button></div><div class=\"col-sm-6 p-0 d-flex justify-content-flex-end align-items-center\"><button class=\"btn btn-link p-0\" ng-if=\"!issueObj.resolved\" ng-click=\"$event.stopPropagation();fnOpenAttributeModal(issueObj)\">Add attribute</button></div></div></div><div class=\"col-sm-12 p-0 p-t-5 d-flex align-items-center justify-content-center\" ng-if=\"isAttributeDataLoading\"><div class=\"pull-right\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div><script type=\"text/ng-template\" id=\"labelColor.html\"><a> <span class=\"m-r-5\" ng-bind-html=\"match.model.name\"></span> <span class=\"pull-right m-t-5\" style=\"width: 15px; height: 15px; display: inline-block\" ng-style=\"match.model.color ? {\'background-color\' : match.model.color} : {\'background-color\' : \'inherit\'}\"></span> </a></script><script type=\"text/ng-template\" id=\"assigneeUser.html\"><a> <span class=\"d-flex align-items-center\"> <span class=\"m-r-5\"> <img class=\"avatarImage m-r-0 img-circle user-avatar-icon\" ng-src=\"{{match.model.userAvatar}}\"> </span> <span> <span style=\"display: block;\"> {{match.model.firstName + \" \"+ match.model.lastName}} </span> <span class=\"font-italic gateway-id-menu-option\">({{match.model.username}})</span> </span> </span> </a></script></div><div class=\"col-sm-12 p-0\" ng-if=\"!isExpanded\"><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetAssigneesTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/group.svg#group_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueType.name ? issueObj.issueType.name: \'No Type\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/types.svg#types\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issuePriority.name ? issueObj.issuePriority.name: \'No Priority\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueState.name ? issueObj.issueState.name: \'No State\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetLabelsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetParticipantsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/user.svg#user_1\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueDeadlineRelativeDateTime ? issueObj.issueDeadlineRelativeDateTime : \'No Resolution Deadline\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.issueResponseDeadlineRelativeDateTime ? issueObj.issueResponseDeadlineRelativeDateTime : \'No Response Deadline\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/responseDeadline.svg#responseDeadline\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.confidential ? \'Confidential\' : \'Not Confidential\'}}\" tooltip-placement=\"left\"><svg ng-if=\"issueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/confidential.svg#confidential\"></use></svg><svg ng-if=\"!issueObj.confidential\" class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/notConfidential.svg#notConfidential\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueObj.project.name ? issueObj.project.name : \'No Project\'}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"col-sm-12 p-15 d-flex align-items-center justify-content-center issue-side-panel-icon\" tooltip-append-to-body=\"true\" uib-tooltip=\"{{fnGetAlarmsTooltipInfo()}}\" tooltip-placement=\"left\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/alarms.svg#alarms\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 d-flex issue-side-panel-expand-btn\"><button class=\"btn btn-primary d-flex align-items-center justify-content-center w100\" ng-click=\"fnExpandCollapseSideBar()\"><i class=\"fa\" ng-class=\"isExpanded ? \'fa-angle-double-right\':\'fa-angle-double-left\'\"></i></button></div></div>");
$templateCache.put("app/tracker/issue/directives/issueBoards/issueBoards.html","<div class=\"container-with-footer\"><div class=\"content-main\"><div class=\"col-sm-12 p-t-15 h-100\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"d-flex m-r-10 customDropdown\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><app-spinner ng-if=\"!isProjectLoaded\" spinner-type=\"\'microSpinnerXS\'\"></app-spinner><span class=\"p-l-1 p-r-1 ellipsis\" ng-if=\"isProjectLoaded\">{{project.name ? project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"projectObj in projectsArr\"><a ng-click=\"fnGetProjectIssue(projectObj)\" ng-if=\"projectObj.id !== \'All\'\"><span>{{projectObj.name}}</span><br><span class=\"font-italic\">({{projectObj.id}})</span></a></li></ul></div></div><div class=\"m-r-10\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-10\" ng-click=\"fnHideShowCreateForm()\">New Issue</button></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"isRefreshData\" search-identifier=\"\'issueBoardsSearch\'\" filters-arr=\"searchFiltersArr\" filter-query=\"filterQuery\" fn-filter-query-change=\"fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, isCalledFromInit)\" state-name=\"\'main.issue\'\" no-set-url=\"true\" fn-resize=\"fnSetTableHeight()\" sort-field-arr=\"sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"fnOpenSettings()\"><i class=\"m-r-5 fa fa-search\"></i>Edit Board</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 p-t-10 p-b-10 boardOutline\"><div class=\"col-sm-12 p-0\" ng-if=\"areIssuesLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"boardPanel w100\" ng-if=\"!areIssuesLoading\"><div class=\"boardContentPanel h-100 p-r-10\" ng-repeat=\"(key, value) in boardData track by $index\" ng-style=\"{\'width\': value.isCollapsed ? \'60px\' : \'423px\'}\"><div class=\"boardHeading\" ng-click=\"fnChangeBoardSettings(key, value)\" ng-style=\"fnGetIssuesLabelColor({color: value.color})\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-space-between\" ng-if=\"!value.isCollapsed\"><label class=\"m-0\">{{value.name}}</label><div class=\"d-flex align-items-center justify-content-flex-end\"><i class=\"fa fa-archive m-r-5 m-t-3 font-size-19\" uib-tooltip=\"Dropping an issue in this state will archive an issue.\" tooltip-placement=\"left\" ng-if=\"issueBoardForState && key !== \'unassigned\' && value.archived\"></i> <i class=\"fa fa-check-square-o m-r-5 m-t-4 font-size-19\" uib-tooltip=\"Dropping an issue in this state will resolve an issue.\" tooltip-placement=\"left\" ng-if=\"issueBoardForState && key !== \'unassigned\' && value.resolved\"></i> <label class=\"m-0\">[{{value.totalItems ? value.totalItems : value.children.length}}]</label></div></div><div class=\"col-sm-12 h-100 d-flex justify-content-center align-items-center\" ng-if=\"value.isCollapsed\"><label class=\"m-0\">[{{value.totalItems ? value.totalItems : value.children.length}}]</label></div></div><div class=\"boardContent m-t-3\" ng-class=\"value.isCollapsed ? \'text-center\' : \'\'\"><label ng-if=\"value.isCollapsed\" class=\"p-t-10 font-italic\" style=\"writing-mode: vertical-lr;\">{{value.name}}</label><ul class=\"col-sm-12 p-t-15 p-b-15\" style=\"height: calc(100% - 10px)\" ng-hide=\"value.isCollapsed\" dnd-list=\"value.children\" dnd-allowed-types=\"[\'issueType\']\" dnd-drop=\"dropCallback(index, item, external, type, value, key)\" infinite-scroll=\"fnLoadNext(key, value)\" infinite-scroll-disabled=\"key === \'unassigned\' || value.isScrollDisabled || value.children.length >= value.totalItems\" infinite-scroll-parent=\"\'true\'\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"0\"><li class=\"col-sm-12 p-0 m-b-15 d-flex issueDetails\" ng-repeat=\"issueObj in value.children\" ng-click=\"getIssueDetails({\'issueObj\': issueObj})\" dnd-draggable=\"issueObj\" dnd-type=\"\'issueType\'\"><div ng-class=\"issueObj.state !== \'CLOSED\' ? issueObj.isRead ? \'\' : \'issueReadUnreadBGColor\' :\'\'\" style=\"width: 5px; height: 100%\"></div><div class=\"col-sm-12 p-t-10\"><div class=\"d-flex justify-content-space-between\"><label class=\"ellipsis-label m-b-10\">{{issueObj.name}}</label><div class=\"d-flex flex-column\"><div class=\"d-flex m-b-2\"><div class=\"width-25px m-r-5\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.publicCommentIds.length ? issueObj.publicCommentIds.length : 0}}</span></div></div><div class=\"d-flex\" ng-class=\"issueObj.isVoteUpdating ? \'pace opacity-5\' : \'\'\"><div class=\"width-25px m-r-5\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" ng-click=\"$event.stopPropagation();fnAddUpDownVoteToIssue(true, issueObj)\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg></div><div class=\"ellipsis width-100-25px\"><span>{{issueObj.voteCount ? issueObj.voteCount : 0}}</span></div></div></div></div><div class=\"d-flex m-b-5 m-t-5\"><div class=\"width-25px m-r-5\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/label.svg#label\"></use></svg></div><div class=\"ellipsis width-100-25px overflow-x-auto\"><button class=\"btn btn-xs btn-default m-r-5 m-b-2\" ng-if=\"issueObj.issueLabels\" ng-repeat=\"label in issueObj.issueLabels\" ng-style=\"fnGetIssuesLabelColor(label)\"><span>{{label.name}}</span></button></div></div><div class=\"d-flex m-b-5\"><div class=\"width-25px m-r-5\"><svg class=\"custom-svg-side-menu-icon\" width=\"20px\" height=\"20px\"><use ng-if=\"issueBoardForState || issueBoardForPriority\" xlink:href=\"assets/images/svg/service/types.svg#types\"></use><use ng-if=\"issueBoardForType\" xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg></div><div class=\"ellipsis width-100-25px\"><button ng-if=\"issueObj.issueType && (issueBoardForState || issueBoardForPriority)\" class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueType)\"><span>{{issueObj.issueType.name}}</span></button> <button ng-if=\"issueBoardForType\" class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div></div><div class=\"d-flex justify-content-space-between\"><div class=\"d-flex\" style=\"width: 50%\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use ng-if=\"issueBoardForState || issueBoardForType\" xlink:href=\"assets/images/svg/service/priorities.svg#priorities\"></use><use ng-if=\"issueBoardForPriority\" xlink:href=\"assets/images/svg/service/state.svg#state\"></use></svg><button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"(issueBoardForState || issueBoardForType) && issueObj.issuePriority\" ng-style=\"fnGetIssuesLabelColor(issueObj.issuePriority)\"><span>{{issueObj.issuePriority.name}}</span></button> <button class=\"btn btn-xs btn-default m-r-2 m-b-2 ellipsis-button\" ng-if=\"issueBoardForPriority && issueObj.issueState\" ng-style=\"fnGetIssuesLabelColor(issueObj.issueState)\"><span>{{issueObj.issueState.name}}</span></button></div><div><span ng-repeat=\"user in issueObj.assignees track by $index\"><img alt=\"profile photo\" class=\"img-circle img-profile\" ng-class=\"!$last ? \'m-r-5\' : \'\'\" style=\"width: 20px; height: 20px\" ng-src=\"{{fnGetAssigneeAvatar(user)}}\" on-error-src=\"\"></span></div></div><div class=\"position-r m-t-5\" style=\"width: 95%;\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\" style=\"width: 100%\"><div class=\"progress w100 m-b-0\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate\"><svg class=\"svg-fill-red m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its deadline</div></div></div></div></li></ul></div><div class=\"boardFooter d-flex align-items-center\" ng-class=\"value.isScrollDisabled ? \'justify-content-space-between\' : \'justify-content-flex-end\'\"><label class=\"m-l-10\" ng-if=\"value.isScrollDisabled\">Loading Issues...</label> <i class=\"fa fa-angle-double-left pull-right m-r-10\" ng-class=\"value.isCollapsed ? \'fa-angle-double-right\' : \'fa-angle-double-left\'\" ng-click=\"fnChangeBoardSettings(key, value)\"></i></div></div></div></div></div></div><div class=\"content-footer d-flex col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div><label class=\"m-b-0\">Total: {{totalItems}}</label> <i class=\"fa fa-refresh p-10 p-l-15\" ng-class=\"{\'fa-spin\' : isRefresh}\" ng-click=\"fnReload();\" aria-hidden=\"true\"></i></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"fnHideShowCreateForm()\">Create Issue</button></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueInfo.html","<div class=\"container-with-footer tab-container issue-detail-page\"><div class=\"row user-header m-l-0 w100\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-12 p-l-15 p-r-15 dashboard-header\" ng-class=\"isFullWidthDevice ? \'p-t-15 p-b-15\':\'p-t-10 p-b-10\'\"><div class=\"col-sm-12 d-flex p-0 align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\"><span>Issue</span></div><div class=\"col-sm-12 d-flex p-0 p-t-5\"><div class=\"col-sm-12 p-0\" context-menu=\"issueDetailContextMenu(issueObj)\" ng-if=\"!issueObj.isTitleEditable\"><h1 class=\"m-0 font-bold\" ng-if=\"isFullWidthDevice\">{{issueObj.name}}</h1><h3 class=\"m-0 font-bold\" ng-if=\"!isFullWidthDevice\">{{issueObj.name}}</h3></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-if=\"issueObj.isTitleEditable\"><div class=\"col-sm-12 p-l-0 inlineInputEdit\"><div class=\"inputDiv issue-name-input\"><div class=\"md-input m-b-0\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"issueObj.name\" placeholder=\"Name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"actionDiv m-t-5\"><input type=\"button\" class=\"btn btn-link m-t-5 p-r-5 p-0 pull-left m-r-5\" ng-disabled=\"!issueObj.name.length\" ng-click=\"$event.stopPropagation();fnSaveIssueTitle(issueObj)\" value=\"Save\"> <input type=\"button\" class=\"btn btn-link m-t-5 p-0 pull-left\" ng-click=\"$event.stopPropagation();fnCancelIssueTitleEditMode(issueObj)\" value=\"Cancel\"></div></div></div></div><div class=\"col-sm-12 d-flex p-0 p-t-10 align-items-center\"><div class=\"m-r-10\"><button class=\"btn btn-primary\">{{issueObj.resolved ? \'Resolved\' : \'Open\'}}</button></div><div class=\"position-r w100\"><div class=\"\"><div class=\"issue-progress-bar d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.remainingTime > 0 && issueObj.isResolutionDeadlinePastDate === false && issueObj.resolved === false\"><svg class=\"custom-svg-side-menu-icon m-r-10\" width=\"25px\" height=\"25px\"><use xlink:href=\"assets/images/svg/service/time.svg#time\"></use></svg><div class=\"progress w100 m-b-0\" uib-tooltip-html=\"issueObj.tooltipContent\" tooltip-placement=\"auto\"><div class=\"progress-bar\" ng-class=\"issueObj.remainingTime > 20 ? \'\': \'progress-color\'\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\' : issueObj.remainingTime+\'%\'}\"></div></div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.isResolutionDeadlinePastDate && issueObj.resolved === false\"><svg class=\"svg-fill-red m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue has missed its resolution deadline.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && issueObj.isResolvedAtTime\"><svg class=\"svg-fill-green m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/check.svg#check\"></use></svg><div>This issue was resolved in time.</div></div><div class=\"d-flex align-items-center width100\" ng-if=\"issueObj.resolutionDeadlineAt && issueObj.resolved === true && !issueObj.isResolvedAtTime\"><svg class=\"svg-fill-red m-l-10 m-r-10\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg><div>This issue was not resolved in time.</div></div></div></div></div></div><div class=\"col-sm-4 p-0 m-auto justify-content-flex-end d-flex flex-column align-items-flex-end\"><div class=\"d-flex flex-column\" ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating\"><button type=\"button\" class=\"btn btn-primary orange-btn m-b-10\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div class=\"d-flex flex-column\" ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating\"><button type=\"button\" class=\"btn btn-primary orange-btn m-b-10\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"m-t-10\"><radial-progress-bar ng-if=\"issueObj.responseDeadlineAt && issueObj.responseTime > 0 && issueObj.isResponseDeadlinePastDate === false && issueObj.resolved === false\" issue-obj=\"issueObj\" data=\"issueObj.responseTime\" chart-id=\"{{issueObj.id}}\"></radial-progress-bar><svg ng-if=\"issueObj.isResponseDeadlinePastDate && issueObj.resolved === false\" class=\"svg-fill-red m-r-0\" width=\"40px\" height=\"40px\"><use xlink:href=\"assets/images/svg/service/issue-deadline-warning.svg#issueDeadlineWarning\"></use></svg></div></div></div><div class=\"col-sm-12 d-flex p-0\"><div class=\"col-sm-6 p-0 d-flex\"></div></div></div></div><div class=\"col-sm-12 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-if=\"tab.visible === true\" ng-repeat=\"tab in tabs\" select=\"fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-if=\"selectedTab === tab.tabIndex\" ng-include=\"tab.templateUrl\"></div></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center serviceInfoIcon\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"selectedCommentView === \'Vertical\'\"><a class=\"btn btn-link\" ng-click=\"fnChangeCommentView(\'Horizontal\')\" ng-class=\"selectedTab !== 1 && selectedTab !== 2 ? \'pace opacity-5\' : \'\'\">Horizontal View</a></li><li ng-if=\"selectedCommentView === \'Horizontal\'\"><a class=\"btn btn-link\" ng-click=\"fnChangeCommentView(\'Vertical\')\" ng-class=\"selectedTab !== 1 && selectedTab !== 2 ? \'pace opacity-5\' : \'\'\">Vertical View</a></li></ul></div></div></div>");
$templateCache.put("app/tracker/issue/modal/AddNewParticipant/AddNewParticipant.html","<div class=\"form-content h-100\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Add Participant</h3></div><div class=\"modal-body\" id=\"resource-modal-body\" style=\"overflow: hidden;\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"addParticipant.newEmail\" ng-pattern=\"addParticipant.emailPattern\" placeholder=\"Email for system notifications*\" name=\"email\"> <span class=\"highlight\"></span> <label>Email*</label> <small class=\"helper-text-error\" style=\"background-color: #ffffff00;\" ng-show=\"addParticipant.fnValidateEmail(addParticipant.newEmail)\"><span class=\"errorText\">Email is in incorrect format.</span></small></div></div></div><div class=\"modal-footer\"><button type=\"button\" ng-if=\"addParticipant.isEmailCreating\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-click=\"addParticipant.fnCancel()\">Close</button> <button type=\"button\" ng-if=\"addParticipant.isEmailCreating\" class=\"btn btn-primary\" ng-click=\"addParticipant.fnSave()\" ng-disabled=\"!addParticipant.isCreateDisabled\">Add Participant</button><div class=\"pull-right\" ng-if=\"!addParticipant.isEmailCreating\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div>");
$templateCache.put("app/tracker/issue/modal/addNewAttribute/addNewAttribute.html","<div class=\"inmodal h-100\" ng-init=\"attributeModal.fnInitAttributesModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">Attributes List</h3></div><div class=\"modal-body\" style=\"overflow-x: hidden;\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"attributeModal.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{attributeModal.project.name ? attributeModal.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"attributeModal.alarmProjectSearch[attributeModal.alarmProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in attributeModal.filterProject=(attributeModal.projectsArr | filter:attributeModal.alarmProjectSearch) track by $index\" ng-click=\"attributeModal.fnGetProjectAlarm(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === attributeModal.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!attributeModal.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"attributeModal.isRefreshData\" search-identifier=\"\'nodeSearch\'\" filters-arr=\"attributeModal.searchFiltersArr\" filter-query=\"attributeModal.filterQuery\" fn-filter-query-change=\"attributeModal.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.alarms\'\" fn-resize=\"attributeModal.fnSetTableHeight()\" sort-field-arr=\"attributeModal.sortFieldArr\" is-column-view=\"true\" no-set-url=\"true\" table-alias=\"attributeModal.tableAlias\"></v4-search-client></div></div><div class=\"row\" ng-if=\"attributeModal.isRefreshData\"><div class=\"col-sm-12\"><table-loader ng-if=\"attributeModal.isAlarmsLoading\" fn-resize=\"attributeModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"add-alarms-table table-container\"><table id=\"alarmsTable\" class=\"table table-striped table-check-box\" ng-if=\"!attributeModal.isAlarmsLoading\"><thead><tr><th ng-if=\"attributeModal.alarmsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"attributeModal.isAllChecked\" ng-click=\"attributeModal.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\"></th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\">Name</th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\"></th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\"></th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\"></th><th class=\"\" ng-if=\"attributeModal.alarmsArr.length\">Mode</th><th ng-if=\"!attributeModal.alarmsArr.length\">No records found...</th></tr></thead><tbody id=\"alarmTable\"><tr ng-repeat=\"alarmObj in attributeModal.alarmsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"alarmObj.isCheck\" ng-change=\"attributeModal.fnCheckUncheckCheckbox(alarmObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"attributeModal.fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{alarmObj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}\" tooltip-placement=\"auto\"><label class=\"ellipsis m-b-0\"><strong>{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}</strong></label></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.receivedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.receivedAt\"><label class=\"ellipsis m-b-0\">Value last updated {{alarmObj.receivedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.healthUpdatedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.healthLastChangedAt\"><label class=\"ellipsis m-b-0\">Health last updated {{alarmObj.healthUpdatedDate}}</label></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.ecuName}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.nodeName}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.mode}}</label></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!attributeModal.isAlarmsLoading && attributeModal.alarmsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{attributeModal.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"attributeModal.perPage = 10; attributeModal.fnPageChanged(attributeModal.currentPage, attributeModal.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"attributeModal.perPage = 20; attributeModal.fnPageChanged(attributeModal.currentPage, attributeModal.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"attributeModal.perPage = 50; attributeModal.fnPageChanged(attributeModal.currentPage, attributeModal.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"attributeModal.perPage = 100; attributeModal.fnPageChanged(attributeModal.currentPage,attributeModal.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"attributeModal.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"attributeModal.currentPage\" items-per-page=\"attributeModal.perPage\" max-size=\"attributeModal.maxSize\" boundary-links=\"true\" ng-click=\"attributeModal.fnPageChanged(attributeModal.currentPage, attributeModal.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!attributeModal.isAttributeAdding\" ng-click=\"attributeModal.fnCancel()\" tabindex=\"12\">Close</button></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" ng-if=\"!attributeModal.isAttributeAdding\" ng-disabled=\"!attributeModal.isAlarmObjSelected()\" ng-click=\"attributeModal.fnAddAttribute()\" tabindex=\"12\">Add</button><div class=\"pull-right\" ng-if=\"attributeModal.isAttributeAdding\"><div app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div>");
$templateCache.put("app/tracker/issue/modal/issueAttributesModal/issueAttributesModal.html","<div class=\"inmodal h-100\" ng-init=\"issueAttribute.fnInitIssueAttributesModal()\"><div class=\"modal-header\"><h3 class=\"modal-title\">{{issueAttribute.selectedIssue.name}} Attributes</h3></div><div class=\"modal-body\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"issueAttribute.isAttributeDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"alarms-issue-new-table table-container col-sm-12 p-0 h-100\" ng-if=\"!issueAttribute.isAttributeDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"issueAttribute.attributesArr.length\"><thead><tr><th ng-if=\"issueAttribute.attributesArr.length\"></th><th ng-if=\"issueAttribute.attributesArr.length\">Name</th><th ng-if=\"issueAttribute.attributesArr.length\"></th><th ng-if=\"issueAttribute.attributesArr.length\"></th><th ng-if=\"issueAttribute.attributesArr.length\"></th><th ng-if=\"!issueAttribute.attributesArr.length\">No records found...</th></tr></thead><tbody id=\"alarmIssueTable\"><tr ng-repeat=\"issueObj in issueAttribute.attributesArr track by $index\"><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{issueObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"issueAttribute.fnGetHealthColor(issueObj.health, issueObj)\"><span class=\"healtSpan\">{{issueObj.healthName}}</span></button></td><td><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{issueObj.value}} {{issueObj.read && issueObj.read.unit ? issueObj.read.unit : \'\'}}\" tooltip-placement=\"auto\"><label class=\"ellipsis m-b-0\"><strong>{{issueObj.value}} {{issueObj.read && issueObj.read.unit ? issueObj.read.unit : \'\'}}</strong></label></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{issueObj.receivedDate}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.receivedAt\"><label class=\"ellipsis m-b-0\">Value last updated {{issueObj.receivedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{issueObj.healthUpdatedDate}}\" tooltip-placement=\"auto\" ng-if=\"issueObj.healthLastChangedAt\"><label class=\"ellipsis m-b-0\">Health last updated {{issueObj.healthUpdatedDate}}</label></div></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"issueAttribute.fnOpenIssueInfo(issueObj)\">View attribute</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"issueAttribute.fnOpenIssueInNewTab(issueObj)\"><a><span>View attribute in new tab</span></a></li></ul></div></td></tr></tbody></table></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 d-flex\"></div><div class=\"col-sm-6 p-0\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel\" ng-click=\"issueAttribute.fnCancel()\" tabindex=\"12\">Close</button></div></div></div></div>");
$templateCache.put("app/tracker/label/labelInfo/labelSteps/details.html","<div id=\"labelsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isLabelDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isLabelDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isLabelDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_LABEL\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_LABEL\" ng-click=\"fnDeleteLabel(labelObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userPermissionsObj.CREATE_LABEL\" ng-click=\"fnCloneLabelInfo(labelObj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isLabelDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"labelForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"labelObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"labelForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"labelObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"labelForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"labelObj.color\" placeholder=\"Color for the new Label*\"> <span class=\"highlight\"></span> <label>Label Color*</label> <small class=\"helper-text\" ng-if=\"isDetailsEditable\">Choose any Color.<br>or you can choose one of the suggested colors below.</small></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"isDetailsEditable\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedLabel in suggestedLabelsArr\" ng-style=\"fnAssignSpanBackground(suggestedLabel)\" ng-click=\"fnAssignSuggestedColor(suggestedLabel)\"></span></div><div class=\"col-sm-12 p-0\" ng-if=\"isDetailsEditable\"><button class=\"btn btn-link p-l-0\" ng-if=\"isDetailsEditable\" ng-click=\"fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"isDisplayMiniColors && isDetailsEditable\"><input minicolors=\"customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"labelObj.color\"></div><div class=\"col-sm-12 p-0 m-b-20 m-t-10 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!labelObj.name.length || !labelObj.color.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateLabelDetails(labelObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{labelObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(labelObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/priorities/prioritiesInfo/prioritySteps/details.html","<div id=\"priorityContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isPriorityDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isPriorityDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isPriorityDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_PRIORITY\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_PRIORITY\" ng-click=\"fnDeletePriority(priorityObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userPermissionsObj.CREATE_PRIORITY\" ng-click=\"fnClonePriorityInfo(priorityObj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isPriorityDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"priorityForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"priorityObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"priorityForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"priorityObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"priorityForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"order\" type=\"number\" min=\"1\" ng-model=\"priorityObj.order\" placeholder=\"Order\" name=\"order\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"priorityForm.order.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Priority Order*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"priorityObj.color\" placeholder=\"Color for the new Priority*\" name=\"color\"> <span class=\"highlight\"></span> <label>Priority Color*</label> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"priorityForm.color.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <small class=\"helper-text\" ng-if=\"isDetailsEditable\">Choose any Color.<br>or you can choose one of the suggested colors below.</small></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"isDetailsEditable\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedPriority in suggestedPrioritiesArr\" ng-style=\"fnAssignSpanBackground(suggestedPriority)\" ng-click=\"fnAssignSuggestedColor(suggestedPriority)\"></span></div><div class=\"col-sm-12 p-0\" ng-if=\"isDetailsEditable\"><button class=\"btn btn-link p-l-0\" ng-if=\"isDetailsEditable\" ng-click=\"fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"isDisplayMiniColors && isDetailsEditable\"><input minicolors=\"customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"priorityObj.color\"></div><div class=\"col-sm-12 p-0 m-b-20 m-t-10 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!priorityObj.name.length || !priorityObj.color.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdatePriorityDetails(priorityObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{priorityObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(priorityObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isProjectDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isProjectDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isProjectDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_PROJECT\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteProject(projectObj)\" ng-if=\"projectObj.parentProjectId && userPermissionsObj.DELETE_PROJECT\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isProjectDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"projectForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"projectObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"projectObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"projectForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20 pace\" ng-if=\"projectObj.parentProjectId\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Parent Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!projectObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateProjectDetails(projectObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/project_emailTemplate/project_emailTemplateInfo/project_emailTemplateSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitEmailTemplate()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isEmailTemplateDataLoading\"></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"!isEmailTemplateDataLoading\"><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput email-template-toolbar\"><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">From*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><input class=\"md-form-control p-t-5 p-b-5 p-l-10 border-0\" id=\"email\" type=\"email\" required=\"\" ng-pattern=\"emailPattern\" name=\"email\" placeholder=\"Email From*\" ng-change=\"fnCheckEmail()\" ng-model=\"templateConfigObj.emailFrom\"> <span class=\"highlight\"></span> <span style=\"position: absolute;top: 6px;right: 10px;\" ng-show=\"!isEmailValid\" uib-tooltip=\"Please enter valid email address.\" tooltip-placement=\"auto\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\"></i></span></div></div></div><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 p-t-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">Subject*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\"><input class=\"md-form-control border-0 p-t-5 p-b-5 p-l-10\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\" id=\"subject\" type=\"text\" required=\"\" name=\"subject\" placeholder=\"Email Subject*\" ng-model=\"templateConfigObj.emailSubject\"> <span class=\"highlight\"></span> <small class=\"helper-text\"></small></div></div></div><div class=\"d-flex w100 justify-content-flex-end p-t-5 p-b-5 p-l-5 email-template-border-bottom\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"bold()\">B</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"italic()\"><i>I</i></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"underline()\"><u>U</u></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"strike()\"><span style=\"text-decoration: line-through;\">S</span></button></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end h-100 align-items-center\"><button class=\"btn btn-link p-0\" ng-click=\"isShowVariables = !isShowVariables\">Variable</button> <button class=\"btn btn-link p-0 m-l-10 m-r-10\" ng-click=\"isShowVariables = false;fnViewRenderedHTML(isShowPrviewRenderedHTML ?false : true)\">{{isShowPrviewRenderedHTML ? \'Code\' : \'Preview\'}}</button></div></div></div></div><div class=\"col-sm-12 p-0 email-body\"><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-if=\"!isShowPrviewRenderedHTML && !isShowVariables\"><ui-codemirror ng-model=\"templateConfigObj.mjmlBody\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-init=\"fnViewRenderedHTML(true)\" ng-if=\"isShowPrviewRenderedHTML && !isShowVariables\"><div class=\"h-100 overflow-auto d-flex justify-content-center align-items-center\" ng-if=\"isTemplateLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"h-100 overflow-auto\" ng-if=\"!isTemplateLoading\"><div class=\"col-sm-12 p-0 h-100\" id=\"htmlParse\"></div></div></div><div class=\"col-sm-12 p-t-10 email-template-min-height\" ng-if=\"isShowVariables\"><label>Available Variables:</label><table border=\"1\" class=\"w100 variables-table\"><thead><tr class=\"variables-header\"><th class=\"p-5\">Name</th><th class=\"p-5\">Description</th></tr></thead><tbody><tr ng-repeat=\"(key,val) in templateConfigObj.emailVariables track by $index\"><td class=\"p-5\"><label>{{key}}</label></td><td class=\"p-5\">{{val}}</td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\" class=\"d-flex justify-content-center align-items-center m-r-10 m-t-3\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\" ng-if=\"!isValidTemplate\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"isValidTemplate\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable && !isValidTemplate\" ng-click=\"fnValidateTemplate()\">Validate Template</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isTemplateEditable && !isEmailTemplateDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_PROJECT_EMAIL_TEMPLATE\" ng-click=\"fnChangeToEditable(true)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_PROJECT_EMAIL_TEMPLATE\" ng-click=\"fnResetEmailTemplate(true)\"><a class=\"btn btn-link\">Reset Email Template</a></li></ul></div><button class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-if=\"isTemplateEditable && !isValidatingTemplate && !isSaveChanges\" ng-click=\"fnChangeToEditable()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button border-right-0 p-r-4\" ng-disabled=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid\" ng-click=\"fnSaveEmailTemplate(true, \'\')\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\">Save Changes</button><div class=\"customDropdown d-flex h-100 script-dropdown\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm border-left-0 m-l-0 p-l-4 v4-primary-button d-flex align-items-center\" ng-class=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"fnOpenTemplateModal()\"><a><span>Save and Cascade</span></a></li></ul></div></div><div class=\"pull-right\" ng-if=\"isValidatingTemplate || isSaveChanges && isTemplateEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/tracker/project_script/project_scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_PROJECT_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_PROJECT_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button border-right-0 p-r-4\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-click=\"fnSaveScript(false, \'\')\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"customDropdown d-flex h-100 script-dropdown\" ng-if=\"!isSaveChanges && isScriptEditable\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary btn-sm border-left-0 m-l-0 p-l-4 v4-primary-button d-flex align-items-center\" ng-class=\"!scriptConfigObj.scriptBody.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"fnOpenScriptModal()\"><a><span>Save and Cascade</span></a></li></ul></div></div><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/tracker/script/scriptInfo/scriptSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isScriptDataLoading\"></div><div class=\"col-sm-12 p-0\" ng-if=\"!isScriptDataLoading\"><div class=\"tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><javascript-editor value=\"value\" available-defs=\"availableDataLibs\" editor-value=\"scriptConfigObj.scriptBody\" read-only=\"isScriptEditable\"></javascript-editor></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"isScriptEditable && !isSaveChanges\" ng-click=\"fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isScriptEditable && !isScriptDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_SCRIPT\" ng-click=\"fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_SCRIPT\" ng-click=\"fnResetScript()\"><a class=\"btn btn-link\">Reset S4</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!scriptConfigObj.scriptBody.length\" ng-click=\"fnSaveScript()\" ng-if=\"!isSaveChanges && isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isSaveChanges && isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/tracker/state/stateInfo/stateSteps/details.html","<div id=\"statesContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isStateDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isStateDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isStateDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_STATE\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_STATE\" ng-click=\"fnDeleteState(stateObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userPermissionsObj.CREATE_STATE\" ng-click=\"fnCloneStateInfo(stateObj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isStateDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"stateForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"stateObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"stateForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"stateObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"stateForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"stateObj.color\" placeholder=\"Color*\"> <span class=\"highlight\"></span> <label>State Color*</label> <small class=\"helper-text\" ng-if=\"isDetailsEditable\">Choose any Color.<br>or you can choose one of the suggested colors below.</small></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"isDetailsEditable\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedState in suggestedStatesArr\" ng-style=\"fnAssignSpanBackground(suggestedState)\" ng-click=\"fnAssignSuggestedColor(suggestedState)\"></span></div><div class=\"col-sm-12 p-0\" ng-if=\"isDetailsEditable\"><button class=\"btn btn-link p-l-0\" ng-if=\"isDetailsEditable\" ng-click=\"fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"isDisplayMiniColors && isDetailsEditable\"><input minicolors=\"customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"stateObj.color\"></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!stateObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateStateDetails(stateObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{stateObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(stateObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/types/modal/addNewProperties/addNewProperties.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"newProperties.fnInitModel()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'Add New Properties\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-10 roleActions\"><input class=\"md-form-control\" required=\"\" id=\"blueprintLabel\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"input as input.displayName for input in newProperties.inputTypeArr | filter:{displayName:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"newProperties.selectedInput\" placeholder=\"Input Type\"> <span class=\"highlight\"></span> <label>Input Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"newProperties.selectedInput\"><h3 class=\"m-b-15\"><strong>Configuration</strong></h3></div><div class=\"col-sm-12 p-0 m-b-20\" ng-if=\"newProperties.selectedInput && (newProperties.selectedInput.displayName === \'Text\' || newProperties.selectedInput.displayName === \'Textarea\')\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title\" type=\"text\" ng-model=\"newProperties.textOrTextareaInputObj.title\" placeholder=\"Title for the new Input*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"Key\" type=\"text\" ng-model=\"newProperties.textOrTextareaInputObj.key\" placeholder=\"Key for the new Input*\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"newProperties.textOrTextareaInputObj.description\" placeholder=\"Description for the new Input\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"minLength\" type=\"number\" ng-model=\"newProperties.textOrTextareaInputObj.minLength\" placeholder=\"Min Length for the new Input\"> <span class=\"highlight\"></span> <label>Min Length</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"maxLength\" type=\"number\" ng-model=\"newProperties.textOrTextareaInputObj.maxLength\" placeholder=\"Max Length for the new Input\"> <span class=\"highlight\"></span> <label>Max Length</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"textInputRequired\" ng-model=\"newProperties.textOrTextareaInputObj.required\"> <label for=\"textInputRequired\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">Required</label></div></div><div class=\"col-sm-12 p-0 m-b-20\" ng-if=\"newProperties.selectedInput && newProperties.selectedInput.displayName === \'Dropdown\'\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.dropDownInputObj.title\" placeholder=\"Title for the new Input*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.dropDownInputObj.key\" placeholder=\"Key for the new Input*\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"dropdownInputRequired\" ng-model=\"newProperties.dropDownInputObj.required\"> <label for=\"dropdownInputRequired\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">Required</label></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-t-15\"><h4><strong>Dropdown options</strong></h4></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"Value\" id=\"dropdownEnum\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && newProperties.fnCreateArrayTag(newProperties.arrValue, \'dropdownEnum\')\" name=\"value\" ng-model=\"newProperties.arrValue\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\" style=\"right: 5px;\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"newProperties.fnCreateArrayTag(newProperties.arrValue, \'dropdownEnum\')\"><span><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm btn-default m-t-5 m-r-5\" ng-repeat=\"selectedArr in newProperties.dropDownInputObj.enum track by $index\"><span>{{selectedArr}}</span> <span><i class=\"fa fa-times m-l-5\" ng-click=\"newProperties.fnRemoveArrayTag($index)\"></i></span></button></div></div><div class=\"col-sm-12 p-0 m-b-0\" ng-if=\"newProperties.selectedInput && newProperties.selectedInput.displayName === \'Check Box\' && newProperties.selectedInput.name === \'boolean\'\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.checkboxInputObj.title\" placeholder=\"Title for the new Input*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.checkboxInputObj.key\" placeholder=\"Key for the new Input*\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><input type=\"checkbox\" id=\"chk_component\" ng-model=\"newProperties.checkboxInputObj.multiform\"> <label for=\"chk_component\" class=\"check-box\" style=\"position: relative;top: 3px\"></label> <span class=\"m-l-5\">Show hidden form if checked</span></div><div class=\"col-sm-12 p-t-10 m-t-10 multiForm\" ng-if=\"newProperties.checkboxInputObj.multiform\"><div class=\"col-sm-12 p-0\"><h3><strong>Form Configuration</strong></h3></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.newForm.title\" placeholder=\"Title*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newProperties.newForm.key\" placeholder=\"Key*\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0\"><h3><strong>Form Input Configuration</strong></h3></div><div class=\"col-sm-12 p-t-20 p-b-0 multiForm\" ng-class=\"!$last ? \'m-b-20\':\'\'\" ng-repeat=\"typeObj in newProperties.formInput track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"input as input.displayName for input in newProperties.inputTypeArr | filter:{displayName:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"newProperties.fnSelectedMultiFormInputType(typeObj.tempInputType, $index)\" ng-model=\"typeObj.tempInputType\" placeholder=\"Input Type\"> <span class=\"highlight\"></span> <label>Input Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"typeObj.tempInputType\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"typeObj.title\" placeholder=\"Title*\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"typeObj.key\" placeholder=\"Key*\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"typeObj.tempInputType && (typeObj.tempInputType.displayName === \'Text\' || typeObj.tempInputType.displayName === \'Textarea\')\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"typeObj.description\" placeholder=\"Description\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"typeObj.minLength\" placeholder=\"Min Length\"> <span class=\"highlight\"></span> <label>Min Length</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"typeObj.maxLength\" placeholder=\"Max Length\"> <span class=\"highlight\"></span> <label>Max Length</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\"><input type=\"checkbox\" id=\"{{$index}}\" ng-model=\"typeObj.required\"> <label for=\"{{$index}}\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">Required</label></div></div><div class=\"col-sm-12 p-0\" ng-if=\"typeObj.tempInputType && (typeObj.tempInputType.displayName === \'Dropdown\')\"><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\"><input type=\"checkbox\" id=\"dropdown{{$index}}\" ng-model=\"typeObj.required\"> <label for=\"dropdown{{$index}}\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">Required</label></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-t-15\"><h4><strong>Dropdown options</strong></h4></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" placeholder=\"Value\" id=\"dropdownEnum{{$index}}\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && newProperties.fnCreateArrayTagForMF(typeObj.arrValue, \'dropdownEnum\' + $index, typeObj)\" name=\"value\" ng-model=\"typeObj.arrValue\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\" style=\"right: 5px;\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"newProperties.fnCreateArrayTagForMF(typeObj.arrValue, \'dropdownEnum\' + $index, typeObj)\"><span><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm btn-default m-t-5 m-r-5\" ng-repeat=\"selectedArr in typeObj.enum track by $index\"><span>{{selectedArr}}</span> <span><i class=\"fa fa-times m-l-5\" ng-click=\"newProperties.fnRemoveArrayTagMF($index, typeObj)\"></i></span></button></div></div></div><div class=\"col-sm-12 p-20 d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"newProperties.fnAddNewInput()\"><i class=\"fa fa-plus m-r-5\"></i> Add New Input</button></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-show=\"newProperties.isFileUploading\"></div><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-left\" ng-click=\"newProperties.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary pull-right v4-primary-button\" ng-disabled=\"newProperties.validateNewInput()\" ng-click=\"newProperties.fnSave()\">Save</button></div></div>");
$templateCache.put("app/tracker/types/modal/inputConfigModal/inputConfigModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"inputConfigModal.fnInitModel()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">{{inputConfigModal.formComponent.name}} Component</h4></div><div class=\"modal-body inputConfigModal p-t-0 p-b-0 floatingLabelInput\"><div class=\"row height-100\"><div class=\"col-sm-12 height-100 p-0\"><uib-tabset active=\"activeForm\" class=\"height-100\"><uib-tab index=\"0\" heading=\"Display\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0\" ng-repeat=\"input in inputConfigModal.inputConfig.display\"><div class=\"md-input m-b-20\" ng-if=\"input.inputType ===\'text\'\"><input class=\"md-form-control\" required=\"\" type=\"{{input.inputType}}\" ng-model=\"input.inputValue\" ng-change=\"inputConfigModal.onInputChange(input)\" placeholder=\"{{input.inputPlaceholder}}{{input.inputRequired ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{input.inputTitle}} {{input.inputRequired ? \'*\':\'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\" ng-if=\"input.inputType ===\'checkbox\'\"><input type=\"checkbox\" id=\"{{\'hide_\' + input.labelId}}\" ng-model=\"input.inputValue\"> <label for=\"{{\'hide_\' + input.labelId}}\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">{{input.inputTitle}}</label></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Data\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0\" ng-repeat=\"input in inputConfigModal.inputConfig.data\"><div class=\"md-input m-b-20\" ng-if=\"input.inputType ===\'text\' || input.inputType ===\'button\'\" ng-init=\"inputConfigModal.fnCheckInputValid(input)\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" ng-change=\"inputConfigModal.fnCheckInputValid(input)\" placeholder=\"{{input.inputPlaceholder}}{{input.inputRequired ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{input.inputTitle}} {{input.inputRequired ? \'*\':\'\'}}</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error m-t-0\" ng-if=\"input.schemaKey === \'key\' && !inputConfigModal.isReferenceNameValid\"><span class=\"errorText\">The S4 reference name allows only alphanumeric and underscores(_).</span></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"inputConfigModal.formComponent.name === \'Select\'\"><div class=\"col-sm-12 p-0\"><label>Data Source Values</label></div><div class=\"col-sm-12 p-0\" style=\"border: 1px solid;\"><div class=\"col-sm-12 p-15\"><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"enumObj in inputConfigModal.selectEnumArr track by $index\"><div class=\"md-input m-b-20 w100\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"enumObj.value\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in inputConfigModal.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"inputConfigModal.fnGlobalKeySelected($item, $model, $label, $event, enumObj)\" ng-change=\"inputConfigModal.fnCheckUniqueKey(enumObj, $index)\" placeholder=\"Value*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Value*</label> <small class=\"helper-text\"></small></div><div class=\"m-t-12\"><i class=\"fa fa-trash-o m-l-15\" ng-click=\"inputConfigModal.fnRemoveArrayTag($index)\"></i></div></div></div><div class=\"col-sm-12 p-15 p-t-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"inputConfigModal.fnCreateArrayTag()\"><i class=\"fa fa-plus m-r-5\"></i> Add Another</button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"inputConfigModal.formComponent.name === \'Multi Checkbox\'\"><div class=\"col-sm-12 p-0\"><label>Checkbox Source Values</label></div><div class=\"col-sm-12 p-0\" style=\"border: 1px solid;\"><div class=\"col-sm-12 p-15\"><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"enumObj in inputConfigModal.selectChkEnumArr track by $index\"><div class=\"md-input m-b-20 w100 m-r-7\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"enumObj.title\" ng-change=\"inputConfigModal.onChkArrayInputChange(enumObj)\" placeholder=\"Field Title*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Checkbox Title*</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 w100 m-l-7\" ng-click=\"$event.stopPropagation();\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"enumObj.key\" placeholder=\"S4 reference name*\" ng-focus=\"$event.stopPropagation();\"> <span class=\"highlight\"></span> <label>Checkbox S4 reference name*</label> <small class=\"helper-text\"></small></div><div class=\"m-t-12\"><i class=\"fa fa-trash-o m-l-15\" ng-click=\"inputConfigModal.fnRemoveChkArrayTag($index)\"></i></div></div></div><div class=\"col-sm-12 p-15 p-t-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"inputConfigModal.fnCreateChkArrayTag()\"><i class=\"fa fa-plus m-r-5\"></i> Add Another</button></div></div></div></div></uib-tab><uib-tab index=\"2\" heading=\"Validation\" ng-if=\"inputConfigModal.inputConfig.validation.length\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0 d-flex\" ng-repeat=\"input in inputConfigModal.inputConfig.validation\"><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\" ng-if=\"input.inputType ===\'checkbox\'\"><input type=\"checkbox\" id=\"{{input.labelId}}\" ng-model=\"input.inputValue\"> <label for=\"{{input.labelId}}\" class=\"check-box\"></label> <label class=\"m-b-0 m-l-10\">{{input.inputTitle}}</label></div><div class=\"col-sm-12 p-0\" ng-if=\"input.inputType ===\'text\' || input.inputType ===\'number\'\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"{{input.inputType}}\" ng-model=\"input.inputValue\" placeholder=\"{{input.inputPlaceholder}}{{input.inputRequired ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{input.inputTitle}} {{input.inputRequired ? \'*\':\'\'}}</label> <small class=\"helper-text\"></small></div></div></div></div></uib-tab><uib-tab index=\"3\" heading=\"Conditional\" ng-if=\"inputConfigModal.formComponent.name === \'Panel\'\"><div class=\"col-sm-12 p-t-30\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><h3 class=\"m-0\"><span>Simple</span></h3></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0\"></div><div class=\"col-sm-12 p-0 m-b-20\"><div><label class=\"\">This component should Display:</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"inputConfigModal.conditional.show\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"true\">True</option><option value=\"false\">False</option></select></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div><label class=\"\">When the form component:</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"inputConfigModal.conditional.when\"><option selected=\"\" value=\"\">-- select an option --</option><option ng-repeat=\"keyObj in inputConfigModal.keyArr track by $index\" value=\"{{keyObj.key}}\">{{keyObj.title}} ({{keyObj.type}})</option></select></div></div><div class=\"col-sm-12 p-0 m-b-0\"><div><label class=\"\">Has the value:</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"inputConfigModal.conditional.value\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div></div></div></div></div></uib-tab></uib-tabset></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-left\" ng-click=\"inputConfigModal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"inputConfigModal.checkInputValue() || !inputConfigModal.isReferenceNameValid\" ng-click=\"inputConfigModal.fnSave()\" tabindex=\"12\">Save</button></div></div>");
$templateCache.put("app/tracker/types/typesInfo/typesSteps/details.html","<div id=\"priorityContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isTypeDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isTypeDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isTypeDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_TYPE\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.DELETE_TYPE\" ng-click=\"fnDeleteType(typeObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userPermissionsObj.CREATE_TYPE\" ng-click=\"fnCloneTypeInfo(typeObj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isTypeDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"typeForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"typeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"typeForm.name.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"typeObj.description\" placeholder=\"Description\" name=\"description\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"typeForm.description.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Description</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"typeObj.color\" placeholder=\"Color*\"> <span class=\"highlight\"></span> <label>Color*</label> <small class=\"helper-text\" ng-if=\"isDetailsEditable\">Choose any Color.<br>or you can choose one of the suggested colors below.</small></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"isDetailsEditable\"><span class=\"suggestedColorSpan m-r-5\" ng-repeat=\"suggestedType in suggestedTypesArr\" ng-style=\"fnAssignSpanBackground(suggestedType)\" ng-click=\"fnAssignSuggestedColor(suggestedType)\"></span></div><div class=\"col-sm-12 p-0\" ng-if=\"isDetailsEditable\"><button class=\"btn btn-link p-l-0\" ng-if=\"isDetailsEditable\" ng-click=\"fnDisplayMiniColors()\"><small>see more colors</small></button></div><div class=\"p-b-15\" ng-if=\"isDisplayMiniColors && isDetailsEditable\"><input minicolors=\"customSettings\" id=\"bgColor-input\" class=\"form-control\" type=\"text\" ng-model=\"typeObj.color\"></div><div class=\"col-sm-12 p-0 m-b-20 pace\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"selectedProject.name\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Project*</label> <span style=\"position: absolute;right: 10px;top: 12px;\" ng-if=\"selectedProject && selectedProject.id\">({{selectedProject.id}})</span></div></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!typeObj.name.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateTypeDetails(typeObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{typeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(typeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/user-settings/preferences/preferencesTab/advanced/advanced.html","<div id=\"userGroupsContent\" class=\"h-100\" ng-controller=\"AdvancedCtrl as advanced\" ng-init=\"advanced.fnInitAdvanced();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15\"><ui-codemirror class=\"userDataEditor\" ng-model=\"advanced.userProfile\" ui-codemirror-opts=\"advanced.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center\"><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"advanced.isUserDataEditable && !advanced.isUserProfileDetailsChanging\" ng-click=\"advanced.fnToggle()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!advanced.isUserDataEditable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"advanced.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"advanced.fnResetUserProfileData()\"><a class=\"btn btn-link\">Reset</a></li></ul></div><button class=\"btn btn-primary v4-primary-button pull-right\" ng-if=\"!advanced.isUserProfileDetailsChanging && advanced.isUserDataEditable\" ng-click=\"advanced.fnSaveUserProfileData(advanced.userProfile)\">Save Changes</button><div class=\"pull-right\" ng-if=\"advanced.isUserProfileDetailsChanging && advanced.isUserDataEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/preferences/preferencesTab/colorTheme/colorTheme.html","<div id=\"userGroupsContent\" class=\"h-100\" ng-controller=\"ColorThemeCtrl as colorTheme\" ng-init=\"colorTheme.fnInitColorTheme();\"><div class=\"content-main\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 m-b-12\"><div class=\"p-t-15 p-b-0\"><h2 class=\"m-t-0\">Themes</h2><div ng-repeat=\"theme in colorTheme.themeColors\" style=\"display: inline-table\" ng-click=\"colorTheme.fnChangeThemeColor(theme, true)\"><div class=\"preferences m-r-13 d-flex flex-column\" ng-class=\"colorTheme.isFullWidthDevice ? [\'table-width-large\'] : [\'table-width-small\']\"><div class=\"d-flex h-100 w100\"><div class=\"h-100 w100\"><span class=\"cell w-100 h-100 d-block\" id=\"cell00\" style=\"border-bottom: 0; border-right: 0;\" ng-style=\"{background: theme.bgColor}\"></span></div><div class=\"h-100 w100\"><span class=\"cell w-100 h-100 d-block\" id=\"cell01\" style=\"border-bottom: 0; border-right: 0;\" ng-style=\"{background: theme.bgDarkColor}\"></span></div><div class=\"h-100 w100\"><span class=\"cell w-100 h-100 d-block\" id=\"cell02\" style=\"border-bottom: 0;\" ng-style=\"{background: theme.bgLightColor}\"></span></div></div><div class=\"d-flex h-100 w100\"><div class=\"h-100 w100\"><span class=\"cell h-100 w100 d-block\" id=\"cell10\" style=\"border-bottom: 0; border-right: 0;\" ng-style=\"{background: theme.primaryColor}\"></span></div><div class=\"h-100 w100\"><span class=\"cell h-100 w100 d-block\" id=\"cell11\" style=\"border-bottom: 0; border-right: 0;\" ng-style=\"{background: theme.primaryDarkColor}\"></span></div><div class=\"h-100 w100\"><span class=\"cell h-100 w100 d-block\" id=\"cell12\" style=\"border-bottom: 0;\" ng-style=\"{background: theme.primaryLightColor}\"></span></div></div><div class=\"d-flex h-100 w100\"><div class=\"h-100 w100\"><span class=\"cell text-td d-block\" style=\"border-right: 0;\" ng-style=\"{background: theme.textColor}\"></span></div><div class=\"h-100 w100\"><span class=\"cell text-td d-block\" ng-style=\"{background: theme.textSecondaryColor}\"></span></div></div></div><small>{{theme.name}}</small></div></div></div><div class=\"col-sm-12 m-b-12\"><h2 class=\"m-t-0\">Theme builder</h2><div class=\"p-t-4 p-b-4 col-sm-12\" style=\"margin-left: -28px;\"><div class=\"row width-75\"><div class=\"col-sm-12 m-b-35\"><div class=\"col-sm-4 previewBg box-size\"><label class=\"theme-label\">Background</label><div class=\"col-sm-12 h-100 selectedPreviewBox bgCol2\"><div class=\"color-marker-icon d-flex\" style=\"justify-content: flex-end;\" ng-click=\"colorTheme.fnOpenColorModal(\'bgColorModal\')\"><svg xmlns=\"http://www.w3.org/2000/svg\" id=\"Layer_1\" enable-background=\"new 0 0 256 256\" height=\"20px\" viewbox=\"0 0 256 256\" width=\"20px\" class=\"svg-color-marker\"><g><g><g><path d=\"m146.069 48.46-86.574 86.574c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.392c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.391c8.664 3.706 19.078 2.041 26.149-5.031l86.574-86.573z\" fill=\"#f4efed\" data-original=\"#F4EFED\" class=\"\" data-old_color=\"#f4efed\" style=\"fill:#FFFFFF\"></path></g><g><g><path d=\"m174.176 76.567-90.623 90.623c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.684 24.004-5.814l86.574-86.574z\" fill=\"#d6d1cf\" data-original=\"#D6D1CF\" class=\"active-path\" data-old_color=\"#d6d1cf\" style=\"fill:#FFFFFF\"></path></g></g><g><g><path d=\"m151.564 53.955-90.623 90.623c-4.103 4.103-6.523 9.219-7.26 14.46-2.604-8.191-.684-17.507 5.814-24.004l86.573-86.574z\" fill=\"#fff\" data-original=\"#FFF\" class=\"\"></path></g></g><g><path d=\"m62.836 131.693-3.34 3.34c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.391c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.392c8.664 3.706 19.078 2.041 26.149-5.03l36.942-36.942h-67.203z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m119.049 131.693-35.496 35.496c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.683 24.004-5.814l36.942-36.942z\" fill=\"#34518c\" data-original=\"#34518C\" class=\"\" data-old_color=\"#34518c\" style=\"fill:#000000\"></path></g><g><path d=\"m73.826 131.693h-10.99l-3.34 3.34c-6.497 6.497-8.417 15.813-5.814 24.004.737-5.24 3.157-10.356 7.26-14.46z\" fill=\"#708dc8\" data-original=\"#708DC8\" class=\"\" data-old_color=\"#708dc8\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c7.604 7.604 7.604 19.933 0 27.537l-27.54 27.54-27.538-27.537 27.54-27.54c7.605-7.604 19.934-7.604 27.538 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m182.963 85.355-40.187-40.187c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l40.187 40.187c3.935 3.935 3.935 10.314 0 14.249-3.934 3.935-10.314 3.935-14.249 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c-.822-.822-1.707-1.537-2.627-2.181 5.317 7.595 4.602 18.127-2.181 24.91l-27.54 27.54 4.808 4.808 27.54-27.54c7.604-7.604 7.604-19.933 0-27.537z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c.822.822 1.537 1.707 2.181 2.627-7.595-5.317-18.127-4.602-24.91 2.181l-27.54 27.54-4.808-4.808 27.54-27.54c7.604-7.604 19.933-7.604 27.537 0z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m197.213 71.106-6.869-6.869c3.935 3.935 3.935 10.314 0 14.249-3.935 3.935-10.314 3.935-14.249 0l6.869 6.869c3.935 3.935 10.314 3.935 14.249 0 3.934-3.935 3.934-10.315 0-14.249z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m142.776 45.168 6.869 6.869c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l-6.869-6.869c-3.935-3.935-10.314-3.935-14.249 0-3.935 3.934-3.935 10.314 0 14.249z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 252c-15.903 0-25.843-17.216-17.891-30.989l17.891-30.989 17.891 30.989c7.952 13.773-1.988 30.989-17.891 30.989z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m190.888 66.781c-.512 0-1.023-.195-1.414-.586l-27.538-27.537c-.375-.375-.586-.884-.586-1.414s.211-1.039.586-1.414l27.541-27.541c8.371-8.372 21.994-8.372 30.365 0 4.056 4.056 6.29 9.448 6.29 15.183s-2.234 11.127-6.29 15.183l-27.54 27.541c-.39.389-.903.585-1.414.585zm-24.709-29.537 24.709 24.708 26.126-26.126c3.3-3.3 5.118-7.687 5.118-12.354s-1.818-9.054-5.118-12.355c-6.812-6.812-17.896-6.812-24.709 0z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m190.088 90.3c-3.092 0-6.185-1.177-8.539-3.531l-40.188-40.187c-4.708-4.708-4.708-12.369 0-17.077s12.369-4.708 17.078 0l40.187 40.188c2.281 2.28 3.537 5.313 3.537 8.539 0 3.225-1.256 6.258-3.537 8.538-2.353 2.353-5.446 3.53-8.538 3.53zm-5.711-6.359c3.15 3.148 8.273 3.147 11.421 0 1.525-1.525 2.365-3.554 2.365-5.71 0-2.157-.84-4.185-2.365-5.711l-40.187-40.187c-3.15-3.149-8.273-3.148-11.421 0-3.148 3.149-3.149 8.272-.001 11.421z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m126.518 82.459c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828l8.452-8.452c.78-.781 2.048-.781 2.828 0 .781.781.781 2.047 0 2.828l-8.452 8.452c-.39.391-.902.586-1.414.586z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 254c-8.192 0-15.528-4.235-19.624-11.33-4.096-7.094-4.096-15.565 0-22.659l17.892-30.988c.357-.619 1.018-1 1.732-1s1.375.381 1.732 1l17.891 30.988c4.096 7.094 4.096 15.566 0 22.66s-11.432 11.329-19.623 11.329zm0-59.977-16.16 27.988c-3.372 5.842-3.372 12.817 0 18.659 3.373 5.842 9.414 9.33 16.159 9.33 6.746 0 12.786-3.488 16.159-9.33 3.372-5.842 3.372-12.817 0-18.659z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.045-3.171-4.764-3.171-7.656s1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l86.574-86.574c.78-.781 2.048-.781 2.828 0l33.602 33.602c.781.781.781 2.047 0 2.828l-86.573 86.576c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm91.754-133.349-85.16 85.159c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.392c-1.29 1.29-2 3.004-2 4.827 0 1.824.71 3.538 2 4.828 2.662 2.661 6.993 2.661 9.655 0l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l85.159-85.16z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.044-3.171-4.763-3.171-7.656 0-2.892 1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l3.34-3.34c.375-.375.884-.586 1.414-.586h67.204c.809 0 1.538.487 1.848 1.235.31.747.139 1.607-.434 2.179l-36.941 36.944c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm9.349-50.945-2.755 2.754c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.391c-1.29 1.29-2 3.004-2 4.828s.71 3.538 2 4.827c2.663 2.663 6.994 2.662 9.655.001l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l33.528-33.528h-61.547z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g></g></g></svg></div></div></div><div class=\"col-sm-4 previewBg box-size\"><label class=\"theme-label\">Background Dark</label><div class=\"col-sm-12 h-100 selectedPreviewBox bgCol4\"></div></div><div class=\"col-sm-4 previewBg box-size\"><label class=\"theme-label\">Background Light</label><div class=\"h-100 col-sm-12 selectedPreviewBox bgCol3\"></div></div></div></div><div class=\"row width-75\"><div class=\"col-sm-12 m-b-35\"><div class=\"col-sm-4 previewPrimary box-size\"><label class=\"theme-label\">Accent</label><div class=\"h-100 col-sm-12 primaryCol2 selectedPreviewBox\" ng-class=\"colorTheme.isPrimarySelected === true? \'selectedPreviewBox\':\'\'\"><div class=\"color-marker-icon d-flex\" style=\"justify-content: flex-end;\" ng-click=\"colorTheme.fnOpenColorModal(\'primaryColorModal\')\"><svg xmlns=\"http://www.w3.org/2000/svg\" id=\"Layer_1\" enable-background=\"new 0 0 256 256\" height=\"20px\" viewbox=\"0 0 256 256\" width=\"20px\" class=\"svg-color-marker\"><g><g><g><path d=\"m146.069 48.46-86.574 86.574c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.392c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.391c8.664 3.706 19.078 2.041 26.149-5.031l86.574-86.573z\" fill=\"#f4efed\" data-original=\"#F4EFED\" class=\"\" data-old_color=\"#f4efed\" style=\"fill:#FFFFFF\"></path></g><g><g><path d=\"m174.176 76.567-90.623 90.623c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.684 24.004-5.814l86.574-86.574z\" fill=\"#d6d1cf\" data-original=\"#D6D1CF\" class=\"active-path\" data-old_color=\"#d6d1cf\" style=\"fill:#FFFFFF\"></path></g></g><g><g><path d=\"m151.564 53.955-90.623 90.623c-4.103 4.103-6.523 9.219-7.26 14.46-2.604-8.191-.684-17.507 5.814-24.004l86.573-86.574z\" fill=\"#fff\" data-original=\"#FFF\" class=\"\"></path></g></g><g><path d=\"m62.836 131.693-3.34 3.34c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.391c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.392c8.664 3.706 19.078 2.041 26.149-5.03l36.942-36.942h-67.203z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m119.049 131.693-35.496 35.496c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.683 24.004-5.814l36.942-36.942z\" fill=\"#34518c\" data-original=\"#34518C\" class=\"\" data-old_color=\"#34518c\" style=\"fill:#000000\"></path></g><g><path d=\"m73.826 131.693h-10.99l-3.34 3.34c-6.497 6.497-8.417 15.813-5.814 24.004.737-5.24 3.157-10.356 7.26-14.46z\" fill=\"#708dc8\" data-original=\"#708DC8\" class=\"\" data-old_color=\"#708dc8\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c7.604 7.604 7.604 19.933 0 27.537l-27.54 27.54-27.538-27.537 27.54-27.54c7.605-7.604 19.934-7.604 27.538 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m182.963 85.355-40.187-40.187c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l40.187 40.187c3.935 3.935 3.935 10.314 0 14.249-3.934 3.935-10.314 3.935-14.249 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c-.822-.822-1.707-1.537-2.627-2.181 5.317 7.595 4.602 18.127-2.181 24.91l-27.54 27.54 4.808 4.808 27.54-27.54c7.604-7.604 7.604-19.933 0-27.537z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c.822.822 1.537 1.707 2.181 2.627-7.595-5.317-18.127-4.602-24.91 2.181l-27.54 27.54-4.808-4.808 27.54-27.54c7.604-7.604 19.933-7.604 27.537 0z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m197.213 71.106-6.869-6.869c3.935 3.935 3.935 10.314 0 14.249-3.935 3.935-10.314 3.935-14.249 0l6.869 6.869c3.935 3.935 10.314 3.935 14.249 0 3.934-3.935 3.934-10.315 0-14.249z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m142.776 45.168 6.869 6.869c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l-6.869-6.869c-3.935-3.935-10.314-3.935-14.249 0-3.935 3.934-3.935 10.314 0 14.249z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 252c-15.903 0-25.843-17.216-17.891-30.989l17.891-30.989 17.891 30.989c7.952 13.773-1.988 30.989-17.891 30.989z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m190.888 66.781c-.512 0-1.023-.195-1.414-.586l-27.538-27.537c-.375-.375-.586-.884-.586-1.414s.211-1.039.586-1.414l27.541-27.541c8.371-8.372 21.994-8.372 30.365 0 4.056 4.056 6.29 9.448 6.29 15.183s-2.234 11.127-6.29 15.183l-27.54 27.541c-.39.389-.903.585-1.414.585zm-24.709-29.537 24.709 24.708 26.126-26.126c3.3-3.3 5.118-7.687 5.118-12.354s-1.818-9.054-5.118-12.355c-6.812-6.812-17.896-6.812-24.709 0z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m190.088 90.3c-3.092 0-6.185-1.177-8.539-3.531l-40.188-40.187c-4.708-4.708-4.708-12.369 0-17.077s12.369-4.708 17.078 0l40.187 40.188c2.281 2.28 3.537 5.313 3.537 8.539 0 3.225-1.256 6.258-3.537 8.538-2.353 2.353-5.446 3.53-8.538 3.53zm-5.711-6.359c3.15 3.148 8.273 3.147 11.421 0 1.525-1.525 2.365-3.554 2.365-5.71 0-2.157-.84-4.185-2.365-5.711l-40.187-40.187c-3.15-3.149-8.273-3.148-11.421 0-3.148 3.149-3.149 8.272-.001 11.421z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m126.518 82.459c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828l8.452-8.452c.78-.781 2.048-.781 2.828 0 .781.781.781 2.047 0 2.828l-8.452 8.452c-.39.391-.902.586-1.414.586z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 254c-8.192 0-15.528-4.235-19.624-11.33-4.096-7.094-4.096-15.565 0-22.659l17.892-30.988c.357-.619 1.018-1 1.732-1s1.375.381 1.732 1l17.891 30.988c4.096 7.094 4.096 15.566 0 22.66s-11.432 11.329-19.623 11.329zm0-59.977-16.16 27.988c-3.372 5.842-3.372 12.817 0 18.659 3.373 5.842 9.414 9.33 16.159 9.33 6.746 0 12.786-3.488 16.159-9.33 3.372-5.842 3.372-12.817 0-18.659z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.045-3.171-4.764-3.171-7.656s1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l86.574-86.574c.78-.781 2.048-.781 2.828 0l33.602 33.602c.781.781.781 2.047 0 2.828l-86.573 86.576c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm91.754-133.349-85.16 85.159c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.392c-1.29 1.29-2 3.004-2 4.827 0 1.824.71 3.538 2 4.828 2.662 2.661 6.993 2.661 9.655 0l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l85.159-85.16z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.044-3.171-4.763-3.171-7.656 0-2.892 1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l3.34-3.34c.375-.375.884-.586 1.414-.586h67.204c.809 0 1.538.487 1.848 1.235.31.747.139 1.607-.434 2.179l-36.941 36.944c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm9.349-50.945-2.755 2.754c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.391c-1.29 1.29-2 3.004-2 4.828s.71 3.538 2 4.827c2.663 2.663 6.994 2.662 9.655.001l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l33.528-33.528h-61.547z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g></g></g></svg></div></div></div><div class=\"col-sm-4 previewPrimary box-size\"><label class=\"theme-label\">Accent Dark</label><div class=\"h-100 col-sm-12 primaryCol4 selectedPreviewBox\" ng-class=\"colorTheme.isPrimarySelected === true? \'selectedPreviewBox\':\'\'\"></div></div><div class=\"col-sm-4 previewPrimary box-size\"><label class=\"theme-label\">Accent Light</label><div class=\"h-100 col-sm-12 primaryCol3 selectedPreviewBox\" ng-class=\"colorTheme.isPrimarySelected === true? \'selectedPreviewBox\':\'\'\"></div></div></div></div><div class=\"row width-75\"><div class=\"col-sm-12 m-b-35\"><div class=\"col-sm-6 previewText box-size\"><label class=\"theme-label\">Text Primary</label><div class=\"col-sm-12 previewTextCol h-100 selectedPreviewBox\"><div class=\"color-marker-icon d-flex\" style=\"justify-content: flex-end;\" ng-click=\"colorTheme.fnOpenColorModal(\'textPrimaryColor\')\"><svg xmlns=\"http://www.w3.org/2000/svg\" id=\"Layer_1\" enable-background=\"new 0 0 256 256\" height=\"20px\" viewbox=\"0 0 256 256\" width=\"20px\" class=\"svg-color-marker\"><g><g><g><path d=\"m146.069 48.46-86.574 86.574c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.392c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.391c8.664 3.706 19.078 2.041 26.149-5.031l86.574-86.573z\" fill=\"#f4efed\" data-original=\"#F4EFED\" class=\"\" data-old_color=\"#f4efed\" style=\"fill:#FFFFFF\"></path></g><g><g><path d=\"m174.176 76.567-90.623 90.623c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.684 24.004-5.814l86.574-86.574z\" fill=\"#d6d1cf\" data-original=\"#D6D1CF\" class=\"active-path\" data-old_color=\"#d6d1cf\" style=\"fill:#FFFFFF\"></path></g></g><g><g><path d=\"m151.564 53.955-90.623 90.623c-4.103 4.103-6.523 9.219-7.26 14.46-2.604-8.191-.684-17.507 5.814-24.004l86.573-86.574z\" fill=\"#fff\" data-original=\"#FFF\" class=\"\"></path></g></g><g><path d=\"m62.836 131.693-3.34 3.34c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.391c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.392c8.664 3.706 19.078 2.041 26.149-5.03l36.942-36.942h-67.203z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m119.049 131.693-35.496 35.496c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.683 24.004-5.814l36.942-36.942z\" fill=\"#34518c\" data-original=\"#34518C\" class=\"\" data-old_color=\"#34518c\" style=\"fill:#000000\"></path></g><g><path d=\"m73.826 131.693h-10.99l-3.34 3.34c-6.497 6.497-8.417 15.813-5.814 24.004.737-5.24 3.157-10.356 7.26-14.46z\" fill=\"#708dc8\" data-original=\"#708DC8\" class=\"\" data-old_color=\"#708dc8\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c7.604 7.604 7.604 19.933 0 27.537l-27.54 27.54-27.538-27.537 27.54-27.54c7.605-7.604 19.934-7.604 27.538 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m182.963 85.355-40.187-40.187c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l40.187 40.187c3.935 3.935 3.935 10.314 0 14.249-3.934 3.935-10.314 3.935-14.249 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c-.822-.822-1.707-1.537-2.627-2.181 5.317 7.595 4.602 18.127-2.181 24.91l-27.54 27.54 4.808 4.808 27.54-27.54c7.604-7.604 7.604-19.933 0-27.537z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c.822.822 1.537 1.707 2.181 2.627-7.595-5.317-18.127-4.602-24.91 2.181l-27.54 27.54-4.808-4.808 27.54-27.54c7.604-7.604 19.933-7.604 27.537 0z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m197.213 71.106-6.869-6.869c3.935 3.935 3.935 10.314 0 14.249-3.935 3.935-10.314 3.935-14.249 0l6.869 6.869c3.935 3.935 10.314 3.935 14.249 0 3.934-3.935 3.934-10.315 0-14.249z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m142.776 45.168 6.869 6.869c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l-6.869-6.869c-3.935-3.935-10.314-3.935-14.249 0-3.935 3.934-3.935 10.314 0 14.249z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 252c-15.903 0-25.843-17.216-17.891-30.989l17.891-30.989 17.891 30.989c7.952 13.773-1.988 30.989-17.891 30.989z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m190.888 66.781c-.512 0-1.023-.195-1.414-.586l-27.538-27.537c-.375-.375-.586-.884-.586-1.414s.211-1.039.586-1.414l27.541-27.541c8.371-8.372 21.994-8.372 30.365 0 4.056 4.056 6.29 9.448 6.29 15.183s-2.234 11.127-6.29 15.183l-27.54 27.541c-.39.389-.903.585-1.414.585zm-24.709-29.537 24.709 24.708 26.126-26.126c3.3-3.3 5.118-7.687 5.118-12.354s-1.818-9.054-5.118-12.355c-6.812-6.812-17.896-6.812-24.709 0z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m190.088 90.3c-3.092 0-6.185-1.177-8.539-3.531l-40.188-40.187c-4.708-4.708-4.708-12.369 0-17.077s12.369-4.708 17.078 0l40.187 40.188c2.281 2.28 3.537 5.313 3.537 8.539 0 3.225-1.256 6.258-3.537 8.538-2.353 2.353-5.446 3.53-8.538 3.53zm-5.711-6.359c3.15 3.148 8.273 3.147 11.421 0 1.525-1.525 2.365-3.554 2.365-5.71 0-2.157-.84-4.185-2.365-5.711l-40.187-40.187c-3.15-3.149-8.273-3.148-11.421 0-3.148 3.149-3.149 8.272-.001 11.421z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m126.518 82.459c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828l8.452-8.452c.78-.781 2.048-.781 2.828 0 .781.781.781 2.047 0 2.828l-8.452 8.452c-.39.391-.902.586-1.414.586z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 254c-8.192 0-15.528-4.235-19.624-11.33-4.096-7.094-4.096-15.565 0-22.659l17.892-30.988c.357-.619 1.018-1 1.732-1s1.375.381 1.732 1l17.891 30.988c4.096 7.094 4.096 15.566 0 22.66s-11.432 11.329-19.623 11.329zm0-59.977-16.16 27.988c-3.372 5.842-3.372 12.817 0 18.659 3.373 5.842 9.414 9.33 16.159 9.33 6.746 0 12.786-3.488 16.159-9.33 3.372-5.842 3.372-12.817 0-18.659z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.045-3.171-4.764-3.171-7.656s1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l86.574-86.574c.78-.781 2.048-.781 2.828 0l33.602 33.602c.781.781.781 2.047 0 2.828l-86.573 86.576c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm91.754-133.349-85.16 85.159c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.392c-1.29 1.29-2 3.004-2 4.827 0 1.824.71 3.538 2 4.828 2.662 2.661 6.993 2.661 9.655 0l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l85.159-85.16z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.044-3.171-4.763-3.171-7.656 0-2.892 1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l3.34-3.34c.375-.375.884-.586 1.414-.586h67.204c.809 0 1.538.487 1.848 1.235.31.747.139 1.607-.434 2.179l-36.941 36.944c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm9.349-50.945-2.755 2.754c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.391c-1.29 1.29-2 3.004-2 4.828s.71 3.538 2 4.827c2.663 2.663 6.994 2.662 9.655.001l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l33.528-33.528h-61.547z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g></g></g></svg></div></div></div><div class=\"col-sm-6 previewSecondaryText box-size\"><label class=\"theme-label\">Text Secondary</label><div class=\"col-sm-12 previewSecondaryTextCol h-100 selectedPreviewBox\"><div class=\"color-marker-icon d-flex\" style=\"justify-content: flex-end;\" ng-click=\"colorTheme.fnOpenColorModal(\'textSecondaryColor\')\"><svg xmlns=\"http://www.w3.org/2000/svg\" id=\"Layer_1\" enable-background=\"new 0 0 256 256\" height=\"20px\" viewbox=\"0 0 256 256\" width=\"20px\" class=\"svg-color-marker\"><g><g><g><path d=\"m146.069 48.46-86.574 86.574c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.392c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.391c8.664 3.706 19.078 2.041 26.149-5.031l86.574-86.573z\" fill=\"#f4efed\" data-original=\"#F4EFED\" class=\"\" data-old_color=\"#f4efed\" style=\"fill:#FFFFFF\"></path></g><g><g><path d=\"m174.176 76.567-90.623 90.623c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.684 24.004-5.814l86.574-86.574z\" fill=\"#d6d1cf\" data-original=\"#D6D1CF\" class=\"active-path\" data-old_color=\"#d6d1cf\" style=\"fill:#FFFFFF\"></path></g></g><g><g><path d=\"m151.564 53.955-90.623 90.623c-4.103 4.103-6.523 9.219-7.26 14.46-2.604-8.191-.684-17.507 5.814-24.004l86.573-86.574z\" fill=\"#fff\" data-original=\"#FFF\" class=\"\"></path></g></g><g><path d=\"m62.836 131.693-3.34 3.34c-7.071 7.071-8.737 17.485-5.03 26.149l-6.392 6.391c-3.447 3.447-3.447 9.036 0 12.483s9.036 3.447 12.483 0l6.391-6.392c8.664 3.706 19.078 2.041 26.149-5.03l36.942-36.942h-67.203z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m119.049 131.693-35.496 35.496c-4.103 4.103-9.219 6.523-14.46 7.26 8.191 2.604 17.507.683 24.004-5.814l36.942-36.942z\" fill=\"#34518c\" data-original=\"#34518C\" class=\"\" data-old_color=\"#34518c\" style=\"fill:#000000\"></path></g><g><path d=\"m73.826 131.693h-10.99l-3.34 3.34c-6.497 6.497-8.417 15.813-5.814 24.004.737-5.24 3.157-10.356 7.26-14.46z\" fill=\"#708dc8\" data-original=\"#708DC8\" class=\"\" data-old_color=\"#708dc8\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c7.604 7.604 7.604 19.933 0 27.537l-27.54 27.54-27.538-27.537 27.54-27.54c7.605-7.604 19.934-7.604 27.538 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m182.963 85.355-40.187-40.187c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l40.187 40.187c3.935 3.935 3.935 10.314 0 14.249-3.934 3.935-10.314 3.935-14.249 0z\" fill=\"#ff4397\" data-original=\"#FF4397\" class=\"\" data-old_color=\"#ff4397\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c-.822-.822-1.707-1.537-2.627-2.181 5.317 7.595 4.602 18.127-2.181 24.91l-27.54 27.54 4.808 4.808 27.54-27.54c7.604-7.604 7.604-19.933 0-27.537z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m218.428 9.703c.822.822 1.537 1.707 2.181 2.627-7.595-5.317-18.127-4.602-24.91 2.181l-27.54 27.54-4.808-4.808 27.54-27.54c7.604-7.604 19.933-7.604 27.537 0z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m197.213 71.106-6.869-6.869c3.935 3.935 3.935 10.314 0 14.249-3.935 3.935-10.314 3.935-14.249 0l6.869 6.869c3.935 3.935 10.314 3.935 14.249 0 3.934-3.935 3.934-10.315 0-14.249z\" fill=\"#e12579\" data-original=\"#E12579\" class=\"\" data-old_color=\"#e12579\" style=\"fill:#000000\"></path></g><g><path d=\"m142.776 45.168 6.869 6.869c-3.935-3.935-3.935-10.314 0-14.249 3.935-3.935 10.314-3.935 14.249 0l-6.869-6.869c-3.935-3.935-10.314-3.935-14.249 0-3.935 3.934-3.935 10.314 0 14.249z\" fill=\"#ff61b5\" data-original=\"#FF61B5\" class=\"\" data-old_color=\"#ff61b5\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 252c-15.903 0-25.843-17.216-17.891-30.989l17.891-30.989 17.891 30.989c7.952 13.773-1.988 30.989-17.891 30.989z\" fill=\"#526faa\" data-original=\"#526FAA\" class=\"\" data-old_color=\"#526faa\" style=\"fill:#000000\"></path></g><g><path d=\"m190.888 66.781c-.512 0-1.023-.195-1.414-.586l-27.538-27.537c-.375-.375-.586-.884-.586-1.414s.211-1.039.586-1.414l27.541-27.541c8.371-8.372 21.994-8.372 30.365 0 4.056 4.056 6.29 9.448 6.29 15.183s-2.234 11.127-6.29 15.183l-27.54 27.541c-.39.389-.903.585-1.414.585zm-24.709-29.537 24.709 24.708 26.126-26.126c3.3-3.3 5.118-7.687 5.118-12.354s-1.818-9.054-5.118-12.355c-6.812-6.812-17.896-6.812-24.709 0z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m190.088 90.3c-3.092 0-6.185-1.177-8.539-3.531l-40.188-40.187c-4.708-4.708-4.708-12.369 0-17.077s12.369-4.708 17.078 0l40.187 40.188c2.281 2.28 3.537 5.313 3.537 8.539 0 3.225-1.256 6.258-3.537 8.538-2.353 2.353-5.446 3.53-8.538 3.53zm-5.711-6.359c3.15 3.148 8.273 3.147 11.421 0 1.525-1.525 2.365-3.554 2.365-5.71 0-2.157-.84-4.185-2.365-5.711l-40.187-40.187c-3.15-3.149-8.273-3.148-11.421 0-3.148 3.149-3.149 8.272-.001 11.421z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m126.518 82.459c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828l8.452-8.452c.78-.781 2.048-.781 2.828 0 .781.781.781 2.047 0 2.828l-8.452 8.452c-.39.391-.902.586-1.414.586z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m52.559 254c-8.192 0-15.528-4.235-19.624-11.33-4.096-7.094-4.096-15.565 0-22.659l17.892-30.988c.357-.619 1.018-1 1.732-1s1.375.381 1.732 1l17.891 30.988c4.096 7.094 4.096 15.566 0 22.66s-11.432 11.329-19.623 11.329zm0-59.977-16.16 27.988c-3.372 5.842-3.372 12.817 0 18.659 3.373 5.842 9.414 9.33 16.159 9.33 6.746 0 12.786-3.488 16.159-9.33 3.372-5.842 3.372-12.817 0-18.659z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.045-3.171-4.764-3.171-7.656s1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l86.574-86.574c.78-.781 2.048-.781 2.828 0l33.602 33.602c.781.781.781 2.047 0 2.828l-86.573 86.576c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm91.754-133.349-85.16 85.159c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.392c-1.29 1.29-2 3.004-2 4.827 0 1.824.71 3.538 2 4.828 2.662 2.661 6.993 2.661 9.655 0l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l85.159-85.16z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g><g><path d=\"m54.315 184.638c-2.772 0-5.545-1.056-7.656-3.167-2.045-2.044-3.171-4.763-3.171-7.656 0-2.892 1.126-5.611 3.171-7.656l5.461-5.462c-3.467-9.426-1.197-19.922 5.96-27.079l3.34-3.34c.375-.375.884-.586 1.414-.586h67.204c.809 0 1.538.487 1.848 1.235.31.747.139 1.607-.434 2.179l-36.941 36.944c-7.158 7.158-17.655 9.425-27.079 5.96l-5.462 5.461c-2.11 2.112-4.883 3.167-7.655 3.167zm9.349-50.945-2.755 2.754c-6.318 6.318-8.126 15.719-4.605 23.949.321.751.153 1.623-.425 2.201l-6.392 6.391c-1.29 1.29-2 3.004-2 4.828s.71 3.538 2 4.827c2.663 2.663 6.994 2.662 9.655.001l6.392-6.392c.578-.577 1.45-.746 2.201-.425 8.229 3.521 17.629 1.714 23.948-4.605l33.528-33.528h-61.547z\" fill=\"#690589\" data-original=\"#690589\" class=\"\" data-old_color=\"#690589\" style=\"fill:#000000\"></path></g></g></g></svg></div></div></div></div></div></div></div><div class=\"col-sm-12 d-flex align-items-center\"><div class=\"d-flex align-items-center m-b-10\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_theme_adjustment\" ng-model=\"colorTheme.isAutoThemeAdjustment\" ng-change=\"colorTheme.fnSetAutoThemeAdjustment()\"> <label for=\"chk_theme_adjustment\" class=\"check-box\"></label></div><h3 class=\"m-0 m-t-0 m-l-10\">Use automatic theme adjustment</h3></div></div></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center\"><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"></div><div class=\"col-sm-6 content-box-footerItem p-0 m-0 d-flex justify-content-flex-end\"><div ng-if=\"colorTheme.isUserDataSet\"><button class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-click=\"colorTheme.fnResetTheme()\">Set Default Theme</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"colorTheme.fnApplyTheme(colorTheme.bgColor, colorTheme.primaryColor, colorTheme.textColor, colorTheme.secondaryTextColor)\" ng-disabled=\"!colorTheme.bgColor || !colorTheme.primaryColor || !colorTheme.textColor || !colorTheme.secondaryTextColor\">Apply</button></div><div class=\"pull-right\" ng-if=\"!colorTheme.isUserDataSet\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/preferences/preferencesTab/landingPage/landingPage.html","<div id=\"landingPageContent\" class=\"h-100\" ng-controller=\"LandingPageCtrl as landingPage\" ng-init=\"landingPage.fnInitLandingPage();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15 floatingLabelInput\"><div class=\"input-group\"><span class=\"input-group-addon\" style=\"border-radius: 0\">{{landingPage.stage}}</span> <input type=\"text\" required=\"\" class=\"form-control\" id=\"landingUrl\" ng-class=\"landingPage.isLandingUrlChanging ? \'pace\' : \'\'\" ng-model=\"landingPage.landingUrl\" ng-change=\"landingPage.fnCheckLandingInput(landingPage.landingUrl)\" placeholder=\"Enter Landing Url\"></div><div class=\"col-sm-12 p-0 m-t-10\"><span ng-if=\"landingPage.isLandingUrlEligible\">Please complete the url for setting up the landing page.</span> <span ng-if=\"!landingPage.isLandingUrlEligible\">URL entered is not in correct format. Please enter the URL completing the following URL \"{{landingPage.stage}}\".</span></div></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center\"><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"></div><div class=\"col-sm-6 content-box-footerItem p-0 m-0 d-flex justify-content-flex-end\"><button class=\"btn btn-primary v4-primary-button\" type=\"button\" ng-if=\"!landingPage.isLandingUrlChanging\" ng-class=\"landingPage.isLandingUrlEligible ? \'\' : \'pace opacity-5\'\" ng-click=\"landingPage.fnSaveUserLandingPageSettings(landingPage.landingUrl)\">Save landing url</button><div class=\"pull-right\" ng-if=\"landingPage.isLandingUrlChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/aboutMe/aboutMe.html","<div id=\"userGroupsContent\" class=\"h-100\" ng-controller=\"AboutMeCtrl as aboutMe\" ng-init=\"aboutMe.fnInitAboutMe();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-class=\"!aboutMe.isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" ng-model=\"aboutMe.user.firstName\" placeholder=\"First Name*\"> <span class=\"highlight\"></span> <label>First Name*</label></div><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"lastName\" type=\"text\" ng-model=\"aboutMe.user.lastName\" placeholder=\"Last Name*\"> <span class=\"highlight\"></span> <label>Last Name*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"UserName\" type=\"text\" ng-model=\"aboutMe.user.username\"> <span class=\"highlight\"></span> <label>Username*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" ng-model=\"aboutMe.user.email\"> <span class=\"highlight\"></span> <label>Email*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"status\" type=\"text\" ng-model=\"aboutMe.user.state\"> <span class=\"highlight\"></span> <label>State*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bio\" type=\"text\" ng-model=\"aboutMe.user.bio\" placeholder=\"Bio\"> <span class=\"highlight\"></span> <label>Bio</label></div></div></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center\"><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"aboutMe.isDetailsEditable && !aboutMe.isUserDetailsChanging\" ng-click=\"aboutMe.fnResetValues()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem p-0 m-0\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!aboutMe.isDetailsEditable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"aboutMe.isDetailsEditable = true;\"><a class=\"btn btn-link\">Edit</a></li></ul></div><button class=\"btn btn-primary v4-primary-button pull-right\" ng-disabled=\"!aboutMe.user.firstName.length || !aboutMe.user.lastName.length\" ng-if=\"!aboutMe.isUserDetailsChanging && aboutMe.isDetailsEditable\" ng-click=\"aboutMe.fnUpdateUserDetails(aboutMe.user)\">Save</button><div class=\"pull-right\" ng-if=\"aboutMe.isUserDetailsChanging && aboutMe.isDetailsEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/aboutMyAccount/aboutMyAccount.html","<div id=\"aboutMyAccountContent\" class=\"h-100\" ng-controller=\"AboutMyAccountCtrl as aboutMyAccount\" ng-init=\"aboutMyAccount.fnInitAboutMyAccount();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15 floatingLabelInput\"><div class=\"md-input m-b-20 m-t-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"accountId\" type=\"text\" ng-model=\"aboutMyAccount.user.accountId\"> <span class=\"highlight\"></span> <label>Account ID*</label></div><div class=\"md-input m-b-40\"><input class=\"md-form-control pace\" required=\"\" id=\"inboundEmail\" type=\"text\" ng-model=\"aboutMyAccount.user.inboundEmail\"> <span class=\"highlight\"></span> <label>Inbound email*</label> <small class=\"helper-text\">The inbound email can be \'support@{{aboutMyAccount.user.accountId + aboutMyAccount.stage}}\' or \'example@{{aboutMyAccount.user.accountId + aboutMyAccount.stage}}\' anything you seem suitable.</small> <span class=\"typeInfo\"><i class=\"fa fa-clipboard\" title=\"Copy Email to Clipboard\" ng-click=\"aboutMyAccount.fnCopyInputText(aboutMyAccount.user.inboundEmail, \'Email\')\"></i></span></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/apiKeys/apiKeys.html","<div id=\"apiKeysContent\" class=\"h-100\" ng-controller=\"APIKeysCtrl as apiKeys\" ng-init=\"apiKeys.fnInitAccessToken();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 w100\" style=\"width: calc(100% - 45px)\"><v4-search-client ng-if=\"apiKeys.isRefreshData\" search-identifier=\"\'accessToken\'\" filters-arr=\"apiKeys.searchFiltersArr\" filter-query=\"apiKeys.filterQuery\" fn-filter-query-change=\"apiKeys.fnFilterQueryChanged(filterQuery, sortQuery)\" state-name=\"\'main.access_token\'\" fn-resize=\"apiKeys.fnSetTableHeight()\" sort-field-arr=\"apiKeys.sortFieldArr\"></v4-search-client></div><div class=\"m-l-20\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 9px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"apiKeys.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"apiKeys.getAccessTokenCSVData()\" id=\"csvAnchor\" csv-header=\"vaults.csvHeaderArr\" filename=\"apiKeys.csv\"></a></li></ul></div></div></div><div class=\"row\" ng-if=\"!apiKeys.isReload\"><div class=\"col-sm-12\"><table-loader ng-if=\"apiKeys.isAccessTokenLoading\" hide-circle=\"true\" hide-line=\"true\" set-padding=\"true\" fn-resize=\"apiKeys.fnSetLoaderTableHeight()\"></table-loader><div class=\"accessToken-table table-container\"><table class=\"table table-striped table-check-box\" ng-show=\"!apiKeys.isAccessTokenLoading\"><thead><tr><th ng-if=\"apiKeys.accessTokenArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"apiKeys.isAllChecked\" ng-click=\"apiKeys.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"apiKeys.accessTokenArr.length\">ID</th><th ng-if=\"apiKeys.accessTokenArr.length\">State</th><th ng-if=\"!apiKeys.accessTokenArr.length\">No records found...</th></tr></thead><tbody id=\"apiKeys\"><tr ng-repeat=\"token in apiKeys.accessTokenArr track by $index\" ng-click=\"apiKeys.fnGetAccessToken(token, apiKeys.accessTokenArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"token.isCheck\" ng-change=\"apiKeys.fnCheckUncheckHeader(token)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><span class=\"ellipsis\" ng-bind=\"token.id\"></span></td><td ng-bind=\"token.state\">type</td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!apiKeys.isAccessTokenLoading && apiKeys.accessTokenArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{apiKeys.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"apiKeys.perPage = 10; apiKeys.fnPageChanged(apiKeys.currentPage, apiKeys.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"apiKeys.perPage = 20; apiKeys.fnPageChanged(apiKeys.currentPage, apiKeys.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"apiKeys.perPage = 50; apiKeys.fnPageChanged(apiKeys.currentPage, apiKeys.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"apiKeys.perPage = 100; apiKeys.fnPageChanged(apiKeys.currentPage,apiKeys.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"apiKeys.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"apiKeys.currentPage\" items-per-page=\"apiKeys.perPage\" max-size=\"apiKeys.maxSize\" boundary-links=\"true\" ng-click=\"apiKeys.fnPageChanged(apiKeys.currentPage, apiKeys.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex align-items-center p-0\"><div class=\"col-sm-6 content-box-footerItem m-0\"><label class=\"m-0\">Total: {{apiKeys.totalItems}}</label> <i class=\"fa fa-refresh p-10\" ng-class=\"{\'fa-spin\' : apiKeys.isRefresh}\" ng-click=\"apiKeys.fnReload();\" aria-hidden=\"true\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0\" ng-if=\"apiKeys.isTokenCreating || apiKeys.isTokenDetailsChanging\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex justify-content-flex-end\" ng-if=\"!apiKeys.isTokenCreating && !apiKeys.isTokenDetailsChanging\"><div class=\"customDropdown\" ng-if=\"(apiKeys.selectedAccessTokenArr.length === 1 && apiKeys.selectedAccessTokenObj && apiKeys.permissionObj.UPDATE_API_KEY_STATE) || (apiKeys.selectedAccessTokenArr.length && apiKeys.permissionObj.DELETE_API_KEY) || apiKeys.permissionObj.CREATE_API_KEY\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm border-right-0 p-r-4 v4-primary-button\" ng-if=\"apiKeys.permissionObj.CREATE_API_KEY\" style=\"border-right: 0 !important;\" ng-click=\"apiKeys.fnCreateNewToken()\">Create access token</button> <button type=\"button\" class=\"col-sm-12 btn btn-sm border-left-0 m-l-0 p-l-4 v4-primary-button\" style=\"border-left: 0 !important;\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;color: inherit;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"apiKeys.fnChangeStateOfToken(apiKeys.selectedAccessTokenObj)\" ng-if=\"apiKeys.selectedAccessTokenArr.length === 1 && apiKeys.selectedAccessTokenObj && apiKeys.permissionObj.UPDATE_API_KEY_STATE\"><a><span>{{apiKeys.selectedAccessTokenObj.state === \'ACTIVE\' ? \'Deactivate token\' : \'Activate token\'}}</span></a></li><li ng-click=\"apiKeys.fnDownloadToken(apiKeys.selectedAccessTokenObj)\" ng-if=\"apiKeys.selectedAccessTokenArr.length === 1 && apiKeys.selectedAccessTokenObj && apiKeys.permissionObj.DESCRIBE_API_KEY\"><a><span>Download token</span></a></li><li ng-click=\"apiKeys.fnDeleteMultipleTokens(apiKeys.selectedAccessTokenArr)\" ng-class=\"apiKeys.selectedAccessTokenArr.length && apiKeys.permissionObj.DELETE_API_KEY ? \'\' : \'pace opacity-5\'\"><a><span>{{apiKeys.selectedAccessTokenArr.length === 1 ? \'Delete token\' : \'Delete selected tokens\'}}</span></a></li></ul></div></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/multiFactorAuthentication/multiFactorAuthentication.html","<div id=\"multiFactorAuthenticationContent\" class=\"h-100\" ng-controller=\"MultiFactorAuthenticationCtrl as MFAuthentication\" ng-init=\"MFAuthentication.fnInitMultiFactorAuthentication();\"><div class=\"content-main\"><div class=\"col-sm-12 d-flex h-100\"><div class=\"col-sm-12 p-0 d-flex h-100 justify-content-center flex-column\" ng-if=\"MFAuthentication.tempSwitchValue === true\"><div class=\"col-sm-12 p-0 d-flex justify-content-center\"><label class=\"m-0\">Your account MFA is active.</label></div><div class=\"col-sm-12 p-0 m-t-10 d-flex justify-content-center\"><button class=\"btn btn-primary v4-primary-button p-r-20 p-l-20\" ng-if=\"!MFAuthentication.isAuthenticationChanging\" ng-click=\"MFAuthentication.fnAuthenticationSwitchToggle(false)\">Disable MFA</button><div ng-if=\"MFAuthentication.isAuthenticationChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12 p-0 d-flex h-100 align-items-center flex-column\" ng-if=\"MFAuthentication.tempSwitchValue === false\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center h-100\"><div class=\"d-flex justify-content-center align-items-center flex-column\" style=\"width: 80%\" ng-if=\"!MFAuthentication.secretKey.length\"><span class=\"text-center\">Make your account safer and don\'t just rely on your username and password to secure your account. Protect yourself by enabling two-factor authentication (2FA). This blocks anyone using your stolen data by verifying your identity through your device. Enable 2FA now to protect your accounts online.</span> <button class=\"btn btn-primary v4-primary-button p-r-20 p-l-20 m-t-20\" ng-click=\"MFAuthentication.fnGenerateMFAKey()\">Generate MFA Key</button></div><div ng-if=\"MFAuthentication.secretKey.length\"><div class=\"col-sm-12 p-0 m-t-20 floatingLabelInput d-flex justify-content-center\"><div class=\"md-input m-b-10 pace\" style=\"width: 50%;\"><input class=\"md-form-control\" id=\"category\" type=\"text\" required=\"\" ng-model=\"MFAuthentication.secretKey\"> <span class=\"highlight\"></span> <label>Secret (base32)</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0 d-flex justify-content-center\"><label>QR Code</label></div><div class=\"col-sm-12 p-0 d-flex justify-content-center\"><img style=\"border: 3px solid;\" ng-src=\"{{MFAuthentication.img}}\"></div></div><div class=\"col-sm-12 p-0 m-t-10 d-flex justify-content-center\"><button class=\"btn btn-primary v4-primary-button p-r-20 p-l-20\" ng-if=\"!MFAuthentication.isAuthenticationChanging\" ng-click=\"MFAuthentication.fnAuthenticationSwitchToggle(true)\">Enable MFA Key</button><div ng-if=\"MFAuthentication.isAuthenticationChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/password/password.html","<div id=\"passwordContent\" class=\"h-100\" ng-controller=\"PasswordCtrl as password\" ng-init=\"password.fnInitPassword();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 wizard\"><wizard indicators-position=\"top\"><wz-step wz-title=\"1. Set up new password\"><div class=\"col-sm-6 col-sm-offset-3 p-0 m-t-20\"><div class=\"md-input m-b-20 m-t-20\"><strong class=\"md-input-icon\" ng-click=\"password.hideShowPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"password.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" required=\"\" id=\"newPassword\" type=\"{{password.inputType}}\" ng-model=\"password.newPassword\" placeholder=\"Enter New password*\"> <span class=\"highlight\"></span> <label>New password*</label></div><div class=\"md-input m-b-20\"><strong class=\"md-input-icon\" ng-click=\"password.hideShowPasswordConfirm()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"password.inputTypeConfirm === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" required=\"\" id=\"confirmPassword\" type=\"{{password.inputTypeConfirm}}\" ng-model=\"password.confirmPassword\" placeholder=\"Enter Confirm password*\"> <span class=\"highlight\"></span> <label>Confirm password*</label> <small class=\"helper-text\" ng-if=\"password.newPassword.length && password.confirmPassword.length && password.newPassword !== password.confirmPassword\">Passwords does not match</small></div><button class=\"btn btn-primary pull-right\" ng-disabled=\"!password.newPassword.length || !password.confirmPassword.length || password.newPassword !== password.confirmPassword\" wz-next=\"password.fnGetAuthFields()\">Next</button></div></wz-step><wz-step wz-title=\"2. Change password\"><div class=\"col-sm-6 col-sm-offset-3 p-0 m-t-20\"><div><div class=\"md-input m-b-2\"><strong class=\"md-input-icon\" ng-click=\"password.hideShowOldPassword()\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"password.inputTypeOld === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control\" type=\"{{password.inputTypeOld}}\" required=\"\" placeholder=\"Enter Old Password*\" ng-model=\"password.oldPassword\"> <label>Password*</label></div><small>Enter old password</small></div><div class=\"pull-right\" ng-show=\"!password.isAuthFieldsLoading\"><button class=\"btn btn-primary\" ng-if=\"!password.isPasswordChanging\" ng-click=\"password.fnChangePassword()\">Change password</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"password.isPasswordChanging\"></app-spinner></div></div></wz-step></wizard></div></div></div></div>");
$templateCache.put("app/user-settings/profile/userProfileTabs/privileges/privileges.html","<div id=\"privilegesContent\" class=\"h-100\" ng-controller=\"PrivilegesCtrl as privileges\" ng-init=\"privileges.fnInitPrivileges();\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-15 m-b-15\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 border-1px d-flex\"><div class=\"col-sm-4 p-0 p-l-5 p-t-10 p-b-10 m-r-5\"><h3 class=\"m-0\">App</h3></div><div class=\"col-sm-5 p-0 p-t-10 p-b-10 p-l-10 border-left-1px\"><h3 class=\"m-0\">Service</h3></div><div class=\"col-sm-3 p-0 p-t-10 p-b-10 p-l-5\"><h3 class=\"m-0\">Permission</h3></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-l-5 border-1px\" ng-repeat=\"privilegesObj in privileges.privilegesArr\" style=\"border-top: 0;\"><div class=\"col-sm-4 p-0\"><h3 class=\"m-0\">{{privilegesObj.name}}</h3></div><div class=\"col-sm-8 p-0 border-left-1px\" ng-if=\"privilegesObj.name.toLowerCase() !== \'access\' && privilegesObj.name.toLowerCase() !== \'ecsmon\'\"><div class=\"col-sm-12 p-0 p-l-10 d-flex align-items-center p-t-5 p-b-5\" ng-class=\"{\'border-bottom-1px\' : !$last}\" ng-if=\"serviceObj.name.toLowerCase() !== \'dashboard\'\" ng-repeat=\"serviceObj in privilegesObj.sideMenu\"><div class=\"col-sm-10 p-0 d-flex align-items-center\"><div class=\"col-sm-1 p-0\"><i ng-if=\"serviceObj.icon\" class=\"fa\" style=\"font-size: 19px\" ng-class=\"serviceObj.icon\"></i> <i ng-if=\"serviceObj.svgIcon\" ng-bind-html=\"privileges.deliberatelyTrustDangerousSnippet(serviceObj.svgIcon)\"></i></div><div class=\"col-sm-11 m-l-10 p-0\"><h4 class=\"m-0\">{{serviceObj.name}}</h4></div></div><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-5\" ng-repeat=\"(key,value) in serviceObj track by $index\" ng-if=\"key.includes(privilegesObj.name.toLowerCase()) && key.includes(serviceObj.name.toLowerCase())\"><div style=\"width: 23px; height: 23px;\"><svg viewbox=\"0 0 510 510\" ng-if=\"value\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg><svg viewbox=\"0 0 510 510\" ng-if=\"!value\"><g id=\"do-not-disturb\"><path d=\"M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204 c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35 L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#FF0000\"></path></g></svg></div><div class=\"m-l-8\"><label class=\"m-0\">{{key.split(\':\')[2]}}</label></div></div></div></div></div><div class=\"col-sm-8 p-0 border-left-1px\" ng-if=\"privilegesObj.name.toLowerCase() === \'access\'\"><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-5 p-l-10\" ng-if=\"serviceObj.name.toLowerCase() !== \'dashboard\'\" ng-class=\"{\'border-bottom-1px\' : !$last}\" ng-repeat=\"serviceObj in privileges.accessMenu\"><div class=\"col-sm-10 p-0 d-flex align-items-center\"><div class=\"col-sm-1 p-0\"><i ng-bind-html=\"privileges.deliberatelyTrustDangerousSnippet(serviceObj.svgIcon)\"></i></div><div class=\"col-sm-11 m-l-10 p-0\"><h4 class=\"m-0\">{{serviceObj.name}}</h4></div></div><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center m-t-5 m-b-5\"><div style=\"width: 23px; height: 23px;\"><svg viewbox=\"0 0 510 510\" ng-if=\"privileges.isAccessAllowed\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg><svg viewbox=\"0 0 510 510\" ng-if=\"!privileges.isAccessAllowed\"><g id=\"do-not-disturb\"><path d=\"M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204 c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35 L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#FF0000\"></path></g></svg></div><div class=\"m-l-8\"><label class=\"m-0\">All Permission</label></div></div></div></div></div><div class=\"col-sm-8 p-0 border-left-1px\" ng-if=\"privilegesObj.name.toLowerCase() === \'ecsmon\'\"><div class=\"col-sm-12 p-0 p-l-10 d-flex align-items-center p-t-5 p-b-5\" ng-class=\"{\'border-bottom-1px\' : !$last}\" ng-if=\"serviceObj.name.toLowerCase() !== \'dashboard\'\" ng-repeat=\"serviceObj in privilegesObj.sideMenu\"><div class=\"col-sm-10 p-0 d-flex align-items-center\"><div class=\"col-sm-1 p-0\"><i ng-if=\"serviceObj.icon\" class=\"fa\" style=\"font-size: 19px\" ng-class=\"serviceObj.icon\"></i> <i ng-if=\"serviceObj.svgIcon\" ng-bind-html=\"privileges.deliberatelyTrustDangerousSnippet(serviceObj.svgIcon)\"></i></div><div class=\"col-sm-11 m-l-10 p-0\"><h4 class=\"m-0\">{{serviceObj.name}}</h4></div></div><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-5\"><div style=\"width: 23px; height: 23px;\"><svg viewbox=\"0 0 510 510\" ng-if=\"serviceObj.isAcess\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg><svg viewbox=\"0 0 510 510\" ng-if=\"!serviceObj.isAcess\"><g id=\"do-not-disturb\"><path d=\"M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z M51,255c0-112.2,91.8-204,204-204 c45.9,0,89.25,15.3,124.95,43.35l-285.6,285.6C66.3,344.25,51,300.9,51,255z M255,459c-45.9,0-89.25-15.3-124.95-43.35 L415.65,130.05C443.7,165.75,459,209.1,459,255C459,367.2,367.2,459,255,459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#FF0000\"></path></g></svg></div><div class=\"m-l-8\"><label class=\"m-0\">All Permission</label></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/user-settings/recipes/modal/nodeConfigurationModal/nodeConfigurationModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"nodeConfigurationModal.fnInitSetupModal()\" xmlns=\"http://www.w3.org/1999/html\"><div class=\"modal-header\"><h3 class=\"modal-title text-capitalize\">{{nodeConfigurationModal.recipeObj.name}}</h3></div><div class=\"modal-body p-t-0 recipesConfig\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0 m-t-20\" ng-show=\"nodeConfigurationModal.isDetailsLoaded\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 wizard wizard-steps-pace\" ng-show=\"!nodeConfigurationModal.isDetailsLoaded\"><wizard indicators-position=\"top\" edit-mode=\"false\"><wz-step wz-title=\"Privileges\"><div class=\"m-t-50\"><div class=\"col-sm-12 p-b-15\" ng-repeat=\"permissionObj in nodeConfigurationModal.recipeObj.permissionArr\"><div class=\"col-sm-1\"><i class=\"fa fa-check-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"permissionObj.isAccess\"></i> <i class=\"fa fa-times-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"!permissionObj.isAccess\"></i></div><div class=\"col-sm-11 p-t-3 p-l-0\"><span><h3>{{permissionObj.name}}</h3></span></div></div></div><div class=\"col-sm-12 m-t-50\"><div class=\"col-sm-12 text-center\"><i class=\"fa fa-10x fa-check-circle-o\" aria-hidden=\"true\" ng-if=\"nodeConfigurationModal.isAllAccess\"></i> <i class=\"fa fa-10x fa-times-circle-o\" aria-hidden=\"true\" ng-if=\"!nodeConfigurationModal.isAllAccess\"></i></div><div class=\"col-sm-12 text-center\"><span ng-if=\"nodeConfigurationModal.isAllAccess\">You have all the necessary privileges to use this recipe</span> <span ng-if=\"!nodeConfigurationModal.isAllAccess\">You don\'t have all the necessary privileges to use this recipe</span></div></div></wz-step><wz-step wz-title=\"Health\"><div class=\"col-sm-12 m-t-30 healthAnimation\"><div class=\"d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-heartbeat fa-10x\"></i> <label>Please wait while we are creating healths for you...</label></div></div></wz-step><wz-step wz-title=\"Notification\"><div class=\"col-sm-12 m-t-30 m-b-20 notificationAnimation\"><div class=\"d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-bell fa-5x\"></i> <label>Notification Configuration</label></div></div><div class=\"col-sm-12 floatingLabelInput\"><uib-accordion><uib-accordion-group ng-repeat=\"notificationObj in nodeConfigurationModal.defaultNotifications track by $index\" is-disabled=\"!notificationObj.isOpen\" is-open=\"notificationObj.isOpen\"><uib-accordion-heading><div ng-click=\"$event.preventDefault();$event.stopPropagation();\"><span>{{notificationObj.name}}</span> <i class=\"fa pull-right\" ng-class=\"notificationObj.isDone ? \'fa-check-circle-o\' : \'fa-exclamation-circle\'\" ng-click=\"$event.preventDefault(); devices.fnCheckUncheckHeader(selectedDevice, true)\"></i></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-10\"><h3 class=\"m-t-0 m-b-0 m-r-10\"><i class=\"fa fa-2x fa-calendar\"></i></h3><span>Notification enabled 24 / 7 / 365</span></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-10\"><h3 class=\"m-t-0 m-b-0 m-r-10\"><i class=\"fa fa-2x fa-heartbeat\"></i></h3><span>When an Attribute health changes from</span> <button class=\"btn btn-xs btn-default ellipsis-label m-l-5 m-r-5\" ng-if=\"notificationObj.beforeHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label m-l-5 m-r-5\" ng-if=\"notificationObj.beforeHealth !== -1\" ng-style=\"nodeConfigurationModal.fnGetHealthColor(notificationObj.beforeHealth)\"><span class=\"healtSpan\">{{nodeConfigurationModal.fnGetHealthColor(notificationObj.beforeHealth).content}}</span></button> <span>to</span> <button class=\"btn btn-xs btn-default ellipsis-label m-l-5\" ng-if=\"notificationObj.afterHealth === -1\"><span class=\"healtSpan\">{{\'Any Health\'}}</span></button> <button class=\"btn btn-xs btn-default ellipsis-label m-l-5\" ng-if=\"notificationObj.afterHealth !== -1\" ng-style=\"nodeConfigurationModal.fnGetHealthColor(notificationObj.afterHealth)\"><span class=\"healtSpan\">{{nodeConfigurationModal.fnGetHealthColor(notificationObj.afterHealth).content}}</span></button></div><div class=\"col-sm-12 p-0 m-b-5\"><label>Please select email address you wish to send notification to.</label></div></div><div class=\"col-sm-12 notificationEmailInput\"><div class=\"md-input m-b-30 email-dropdown-overflow\"><input class=\"md-form-control p-r-30\" ng-attr-id=\"{{\'emailInput\'+$index}}\" required=\"\" name=\"emails\" ng-pattern=\"nodeConfigurationModal.emailPattern\" type=\"text\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && nodeConfigurationModal.fnCreateArrayTag(notificationObj.emailValue,\'emailInput\'+$index,notificationObj)\" typeahead-editable=\"true\" uib-typeahead=\"users.email as users.email for users in nodeConfigurationModal.accountUsers | filter:{email:$viewValue}\" typeahead-min-length=\"0\" ng-model=\"notificationObj.emailValue\" placeholder=\"Recipient email address*\"> <span class=\"highlight\"></span> <label>Recipient email address*</label><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><small class=\"helper-text-error m-t-2\" ng-if=\"createNotificationForm.emails.$error.pattern || notificationObj.isInputError === true\"><span class=\"errorText p-0\">Please enter valid email address.</span></small></div><div class=\"col-sm-4 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div></div><span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"nodeConfigurationModal.fnCreateArrayTag(notificationObj.emailValue,\'emailInput\'+$index,notificationObj)\"><span id=\"valueFunctionFx\"><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 m-b-10\"><div class=\"col-sm-2 p-0 d-flex align-items-center\"><h3 class=\"m-t-0 m-b-0 m-r-10\"><i class=\"fa fa-2x fa-at\"></i></h3><span>To:</span></div><div class=\"col-sm-10 p-0\"><button class=\"btn btn-sm btn-default m-b-8 m-r-5\" ng-repeat=\"selectedArr in notificationObj.emails track by $index\"><span>{{selectedArr}} <i class=\"fa fa-times m-l-5\" ng-click=\"nodeConfigurationModal.fnRemoveEmailTag(notificationObj,$index)\"></i></span></button></div></div><div class=\"col-sm-12\"><button class=\"btn btn-primary pull-right\" ng-if=\"!nodeConfigurationModal.isNotificationCreating\" ng-disabled=\"!notificationObj.emails.length\" ng-click=\"nodeConfigurationModal.fnGotoNextNotification(notificationObj, $index)\">Save</button><div class=\"col-sm-12 p-0\" ng-if=\"nodeConfigurationModal.isNotificationCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-accordion-group></uib-accordion></div></wz-step><wz-step wz-title=\"Observer\"><div class=\"col-sm-12 m-t-10 m-b-15\"><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"!nodeConfigurationModal.isDeviceDetailsLoaded || !nodeConfigurationModal.isTypesDetailsLoaded || !nodeConfigurationModal.isObserversDetailsLoaded\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><label class=\"font-italic m-0 p-b-5\">One moment while we find matching observer for the intended devices.</label></div><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"nodeConfigurationModal.isDeviceDetailsLoaded && nodeConfigurationModal.isTypesDetailsLoaded && nodeConfigurationModal.isObserversDetailsLoaded\"><div class=\"col-sm-12 p-0\" ng-if=\"nodeConfigurationModal.devicesArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!nodeConfigurationModal.isObserversConfigurationDone\"><div class=\"col-sm-12 p-0\" ng-if=\"!nodeConfigurationModal.isFindDeviceObservers\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\"><label class=\"font-italic m-0 p-b-5\">One moment while we find matching observer for the intended devices.</label></div><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!nodeConfigurationModal.isObserverDataCreate\"><label class=\"font-italic m-0 p-b-5\">You don\'t appear to have an observer configured for this devices.</label> <label class=\"font-italic m-0 p-b-5\">One moment while we are create your observer.</label><div><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Please wait...\'\"></app-spinner></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"nodeConfigurationModal.isObserversConfigurationDone\"><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-binoculars fa-5x\"></i> <label class=\"m-0 p-b-5 m-t-5\">Observers configured successfully for the devices.</label></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!nodeConfigurationModal.devicesArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!nodeConfigurationModal.isBluePrintSelected\"><div class=\"col-sm-12 searchDiv floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-10 m-t-5\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"nodeConfigurationModal.search\" placeholder=\"Search\" ng-change=\"nodeConfigurationModal.fnTypesFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><label>You don\'t seem to have any registered devices in future. Please select a device type you intend to register in future.</label></div></div></div><div id=\"functionModal\" class=\"col-sm-12 m-t-10 p-0\"><div class=\"col-sm-12 h-100\" ng-if=\"nodeConfigurationModal.isTypesFilter\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0 deviceModelDiv\" style=\"overflow-y: auto;\"><div class=\"col-sm-6\" ng-if=\"!nodeConfigurationModal.isTypesFilter\" ng-repeat=\"(key, value) in nodeConfigurationModal.uniqueBluePrintObj\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><div class=\"col-sm-12 h-100 p-0\"><div class=\"col-sm-8 p-0\" uib-tooltip=\"{{value.typeName}}\" tooltip-placement=\"auto\"><h3 class=\"m-t-9\"><span class=\"p-b-5 ellipsis\">{{value.typeName}}</span></h3></div><div class=\"col-sm-4 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!value.isGatewayDataLoad\" ng-click=\"nodeConfigurationModal.fnBluePrintSelected(value.selectedTypeVersionObj, value)\">Select</button><div ng-if=\"value.isGatewayDataLoad\"><div class=\"text-center\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><small class=\"font-italic ellipsis\">OEM: {{value.selectedTypeVersionObj.oem}}</small><br><small class=\"font-italic ellipsis\">Model: {{value.selectedTypeVersionObj.model}}</small></div><div class=\"dropdown\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Version {{value.selectedTypeVersionObj.version}} <i class=\"fa fa-caret-down m-l-2\"></i></label> <label class=\"pull-right\">({{value.selectedTypeVersionObj.id}})</label></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li ng-repeat=\"valueObj in value.typeValue\"><a class=\"btn btn-link\" ng-click=\"value.selectedTypeVersionObj = valueObj\">{{valueObj.version}}</a></li></ul></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"nodeConfigurationModal.isBluePrintSelected\"><div class=\"col-sm-12 p-0 p-t-10 d-flex justify-content-center align-items-center\" ng-if=\"nodeConfigurationModal.isObserverFound\"><label class=\"font-italic m-0 p-b-5\">You already have an observer configured for this device type.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!nodeConfigurationModal.isObserverFound && nodeConfigurationModal.isObserverFoundFromBluePrint && !nodeConfigurationModal.isObserversConfigurationDone\"><label class=\"font-italic m-0 p-b-5\">You don\'t appear to have an observer configured for this device type.</label> <label class=\"font-italic m-0 p-b-5\">One moment while we are create your observer.</label><div><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Please wait...\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 d-flex flex-column justify-content-center align-items-center\" ng-if=\"!nodeConfigurationModal.isObserverFound && nodeConfigurationModal.isObserverFoundFromBluePrint && nodeConfigurationModal.isObserversConfigurationDone\"><i class=\"fa fa-binoculars fa-5x\"></i> <label class=\"m-0 p-b-5 m-t-5\">Observers configured successfully for selected type.</label></div><div class=\"col-sm-12 p-0 p-t-10 p-l-30 p-r-30 text-center\" ng-if=\"!nodeConfigurationModal.isObserverFound && !nodeConfigurationModal.isObserverFoundFromBluePrint\"><label class=\"font-italic m-0 p-b-5\">We are sorry but we don\'t appear to have found any observer blueprints matching your device. Please contact your account manager. In the mean time you can create one manually.</label></div></div></div></div></div></wz-step></wizard></div></div><div class=\"modal-footer\"><button class=\"btn btn-link\" ng-if=\"nodeConfigurationModal.currentStepIndex === 0\" ng-click=\"nodeConfigurationModal.fnCancel()\" tabindex=\"12\">Close</button> <button class=\"btn btn-primary\" type=\"button\" ng-if=\"nodeConfigurationModal.currentStepIndex !== 3 && nodeConfigurationModal.currentStepIndex !== 2 && !nodeConfigurationModal.isSpinnerShow\" ng-disabled=\"!nodeConfigurationModal.isAllAccess\" ng-click=\"nodeConfigurationModal.fnNextStep()\">Next</button> <button class=\"btn btn-primary\" type=\"button\" ng-if=\"nodeConfigurationModal.currentStepIndex === 3 && !nodeConfigurationModal.isSpinnerShow\" ng-disabled=\"!nodeConfigurationModal.isObserversConfigurationDone\" ng-click=\"nodeConfigurationModal.fnFinishedWizard()\">Finish</button><div class=\"col-sm-12\" ng-if=\"nodeConfigurationModal.isSpinnerShow\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/recipes/modal/setupModal/setupModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"setupModal.fnInitSetupModal()\"><div class=\"modal-header\"><h3 class=\"modal-title text-capitalize\">{{setupModal.recipeObj.name}}</h3></div><div class=\"modal-body p-t-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0 m-t-20\" ng-show=\"setupModal.isDetailsLoaded\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 wizard\" ng-class=\"setupModal.isSetupStart ? \'pace\' : \'\'\" ng-show=\"!setupModal.isDetailsLoaded\"><wizard indicators-position=\"top\"><wz-step wz-title=\"Priviledges\"><div class=\"m-t-50\"><div class=\"col-sm-12 p-b-15\" ng-repeat=\"permissionObj in setupModal.recipeObj.permissionArr\"><div class=\"col-sm-1\"><i class=\"fa fa-check-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"permissionObj.isAccess\"></i> <i class=\"fa fa-times-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"!permissionObj.isAccess\"></i></div><div class=\"col-sm-11 p-t-3 p-l-0\"><span><h3>{{permissionObj.name}}</h3></span></div></div></div><div class=\"col-sm-12 m-t-50\"><div class=\"col-sm-12 text-center\"><i class=\"fa fa-10x fa-check-circle-o\" aria-hidden=\"true\" ng-if=\"setupModal.isAllAccess\"></i> <i class=\"fa fa-10x fa-times-circle-o\" aria-hidden=\"true\" ng-if=\"!setupModal.isAllAccess\"></i></div><div class=\"col-sm-12 text-center\"><span ng-if=\"setupModal.isAllAccess\">You have all the necessary privileges to use this recipe</span> <span ng-if=\"!setupModal.isAllAccess\">You don\'t have all the necessary privileges to use this recipe</span></div></div></wz-step><wz-step wz-title=\"Review\"><div class=\"col-sm-12 m-t-10 m-b-15\"><span>This recipe will auto configure the necessary privileges to grant the ECSite support team administrative acces to your account. If you would like to restrict the scope of those privileges to only include or exclude specific features instead of full administrative rights, you can do so by simply replacing the auto created role with one of your own after the recipe has completed.<br><br>By clicking on \'Start\' you understand that you are granting another account access to your account. Federation usage is subject to the standard terms and any cost incurring are the responsibility of this account.</span></div><div class=\"col-sm-12 p-b-15\" ng-if=\"permObj.isVisible\" ng-repeat=\"permObj in setupModal.recipeObj.permissionArr\"><div class=\"col-sm-1 p-l-0\"><i class=\"fa fa-check-circle-o setupModalIcon m-r-5\" aria-hidden=\"true\" ng-if=\"permObj.isStepFinished\"></i> <i class=\"fa fa-times-circle-o setupModalIcon m-r-5\" aria-hidden=\"true\" ng-if=\"permObj.isErrorOccurred\"></i></div><div class=\"col-sm-11 p-0\"><span><h3>{{permObj.reviewStepName}}</h3></span></div></div><div class=\"col-sm-12 p-b-15 text-center\" ng-if=\"setupModal.isErrorOccurred\"><h3>An Error Occurred!</h3><h3>Please wait while we revert back the steps.</h3></div></wz-step></wizard></div></div><div class=\"modal-footer\"><button class=\"btn btn-link\" ng-if=\"!setupModal.isSetupStart\" ng-click=\"setupModal.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" ng-if=\"!setupModal.isWizardLastStep && !setupModal.isDetailsLoaded\" ng-disabled=\"!setupModal.isAllAccess\" ng-click=\"setupModal.fnNextStep()\" class=\"btn btn-primary\">Next</button> <button type=\"button\" ng-if=\"setupModal.isWizardLastStep && !setupModal.isDetailsLoaded && !setupModal.isSetupStart\" ng-click=\"setupModal.fnFinishedWizard()\" class=\"btn btn-primary\">Start</button><div class=\"col-sm-12\" ng-if=\"setupModal.isSetupStart\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/user-settings/recipes/modal/accessConfigurationModal/accessConfigurationModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"accessConfigurationModal.fnInitSetupModal()\"><div class=\"modal-header\"><h3 class=\"modal-title text-capitalize\">{{accessConfigurationModal.recipeObj.name}}</h3></div><div class=\"modal-body p-t-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0 m-t-20\" ng-show=\"accessConfigurationModal.isDetailsLoaded || !accessConfigurationModal.isDefaultRoleLoaded\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 wizard wizard-steps-pace\" ng-class=\"accessConfigurationModal.isSetupStart ? \'pace\' : \'\'\" ng-show=\"!accessConfigurationModal.isDetailsLoaded && accessConfigurationModal.isDefaultRoleLoaded\"><wizard indicators-position=\"top\"><wz-step wz-title=\"Privileges\"><div class=\"m-t-50\"><div class=\"col-sm-12 p-b-15\" ng-repeat=\"permissionObj in accessConfigurationModal.recipeObj.permissionArr\"><div class=\"col-sm-1\"><i class=\"fa fa-check-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"permissionObj.isAccess\"></i> <i class=\"fa fa-times-circle-o setupModalIcon\" aria-hidden=\"true\" ng-if=\"!permissionObj.isAccess\"></i></div><div class=\"col-sm-11 p-t-3 p-l-0\"><span><h3>{{permissionObj.name}}</h3></span></div></div></div><div class=\"col-sm-12 m-t-50\"><div class=\"col-sm-12 text-center\"><i class=\"fa fa-10x fa-check-circle-o\" aria-hidden=\"true\" ng-if=\"accessConfigurationModal.isAllAccess\"></i> <i class=\"fa fa-10x fa-times-circle-o\" aria-hidden=\"true\" ng-if=\"!accessConfigurationModal.isAllAccess\"></i></div><div class=\"col-sm-12 text-center\"><label ng-if=\"accessConfigurationModal.isAllAccess\">You have all the necessary privileges to use this recipe</label> <label ng-if=\"!accessConfigurationModal.isAllAccess\">You don\'t have all the necessary privileges to use this recipe</label></div></div></wz-step><wz-step wz-title=\"Role\"><div class=\"col-sm-12 m-t-10 m-b-15 healthAnimation\"><div class=\"d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-universal-access fa-10x\"></i> <label class=\"m-t-10\">Please wait while we are creating Roles for you...</label></div></div></wz-step><wz-step wz-title=\"Groups\"><div class=\"col-sm-12 m-t-10 m-b-15\"><div class=\"d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-users fa-10x\"></i> <label class=\"m-t-10\">Please wait while we are creating Groups for you...</label></div></div></wz-step><wz-step wz-title=\"Binding Roles to Groups\"><div class=\"col-sm-12 m-t-10 m-b-15 d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-universal-access fa-10x\"></i> <label class=\"m-t-10\">Please wait while we bind Roles to Groups...</label></div></wz-step><wz-step wz-title=\"Binding Users to Groups\"><div class=\"col-sm-12 m-t-10 m-b-15\"><div class=\"col-sm-12 m-t-20 m-b-20 notificationAnimation\"><div class=\"d-flex flex-column justify-content-center align-items-center\"><i class=\"fa fa-users fa-10x\"></i> <label class=\"m-t-10\">Group Configuration</label></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-class=\"accessConfigurationModal.isEntityCreating ? \'pace\':\'\'\"><uib-accordion><uib-accordion-group ng-repeat=\"groupsObj in accessConfigurationModal.defaultGroups track by $index\" is-open=\"groupsObj.open\"><uib-accordion-heading><div><h3 class=\"m-0\">{{groupsObj.name}}</h3></div><div><h5 class=\"font-italic m-b-0\">{{groupsObj.description}}</h5></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-10\"><h4 class=\"m-t-0 m-b-5\">Add users that you want to add to the group.</h4></div></div><div class=\"col-sm-12 accessUserInput\"><div class=\"md-input m-b-20 email-dropdown-overflow\"><input class=\"md-form-control p-r-30\" ng-attr-id=\"{{\'userInput\'+$index}}\" required=\"\" name=\"user\" type=\"text\" ng-keypress=\"($event.keyCode === 13 || $event.keyCode === 9) && accessConfigurationModal.fnCreateArrayTag(groupsObj.userValue,\'userInput\'+$index,groupsObj)\" typeahead-editable=\"false\" uib-typeahead=\"users as users.name for users in accessConfigurationModal.accountUsers | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"testTemplate.html\" ng-model=\"groupsObj.userValue\" placeholder=\"User*\"> <span class=\"highlight\"></span> <label>User*</label><div class=\"col-sm-12 p-0\"><small class=\"helper-text arrayHelper-text\"><span>Press enter to add.</span></small></div><span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"accessConfigurationModal.fnCreateArrayTag(groupsObj.userValue,\'userInput\'+$index,groupsObj)\"><span id=\"valueFunctionFx\"><small>Add</small></span></a></span></div></div><div class=\"col-sm-12 m-b-10\"><div class=\"col-sm-12 p-0 m-b-5\"><h4 class=\"m-t-0 m-b-0\">Selected Users:</h4></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-sm btn-default m-b-8 m-r-5\" ng-repeat=\"selectedUser in groupsObj.usersArr track by $index\"><span>{{selectedUser.name}} <i class=\"fa fa-times m-l-5\" ng-click=\"accessConfigurationModal.fnRemoveUserTag(groupsObj,$index)\"></i></span></button></div></div><div class=\"col-sm-12\"><button class=\"btn btn-primary pull-right\" ng-if=\"!accessConfigurationModal.isEntityCreating\" ng-disabled=\"!groupsObj.usersArr.length\" ng-click=\"accessConfigurationModal.fnAddUser(groupsObj, $index)\">Save</button><div class=\"col-sm-12 p-0\" ng-if=\"accessConfigurationModal.isEntityCreating\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-accordion-group></uib-accordion></div></div></wz-step></wizard></div></div><div class=\"modal-footer\"><button class=\"btn btn-link\" ng-if=\"accessConfigurationModal.currentStepIndex === 0\" ng-click=\"accessConfigurationModal.fnClose()\" tabindex=\"12\">Close</button> <button class=\"btn btn-primary\" type=\"button\" ng-if=\"accessConfigurationModal.currentStepIndex !== 4\" ng-disabled=\"!accessConfigurationModal.isAllAccess || !accessConfigurationModal.isDefaultRoleLoaded || accessConfigurationModal.isEntityCreating\" ng-click=\"accessConfigurationModal.fnNextStep()\">Next</button> <button class=\"btn btn-primary\" type=\"button\" ng-if=\"accessConfigurationModal.currentStepIndex === 4\" ng-disabled=\"!accessConfigurationModal.isAllAccess || !accessConfigurationModal.isDefaultRoleLoaded || accessConfigurationModal.isEntityCreating\" ng-click=\"accessConfigurationModal.fnClose()\">Finish</button></div><script type=\"text/ng-template\" id=\"testTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left\"> <b><span ng-bind-html=\"match.model.name\"></span></b> </div> <br> <div> <span class=\"ellipsis\"> <span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"match.model.username\"> </span> <span class=\"discDot\" style=\"top:3px\" ng-hide=\"!match.model.email\"> <span class=\"dot\"></span> </span> <span class=\"DescriptionText p-l-10 span_des\" style=\"top: -1px;position: relative;\" ng-bind=\"match.model.email\"> </span> </span> </div> </div> </a></script></div>");
$templateCache.put("app/node/emailTemplate/emailTemplateInfo/emailTemplateSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitEmailTemplate()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"isEmailTemplateDataLoading\"></div><div class=\"col-sm-12 h-100 p-0\" ng-if=\"!isEmailTemplateDataLoading\"><div class=\"col-sm-12 p-0 p-t-5 floatingLabelInput email-template-toolbar\"><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">From*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><input class=\"md-form-control p-t-5 p-b-5 p-l-10 border-0\" id=\"email\" type=\"email\" required=\"\" ng-pattern=\"emailPattern\" name=\"email\" placeholder=\"Email From*\" ng-change=\"fnCheckEmail()\" ng-model=\"templateConfigObj.emailFrom\"> <span class=\"highlight\"></span> <span style=\"position: absolute;top: 6px;right: 10px;\" ng-show=\"!isEmailValid\" uib-tooltip=\"Please enter valid email address.\" tooltip-placement=\"auto\"><i class=\"fa fa-exclamation-triangle\" style=\"color: red;\"></i></span></div></div></div><div class=\"d-flex w100 align-items-center p-l-10 p-b-5 p-t-5 email-template-border-bottom\"><div class=\"m-l-5 m-t-0 width-65px\"><label class=\"m-0\">Subject*:</label></div><div class=\"calc-width-80px\"><div class=\"md-input m-b-0\"><input class=\"md-form-control border-0 p-t-5 p-b-5 p-l-10\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\" id=\"subject\" type=\"text\" required=\"\" name=\"subject\" placeholder=\"Email Subject*\" ng-model=\"templateConfigObj.emailSubject\"> <span class=\"highlight\"></span> <small class=\"helper-text\"></small></div></div></div><div class=\"d-flex w100 justify-content-flex-end p-t-5 p-b-5 p-l-5 email-template-border-bottom\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\" ng-class=\"!isTemplateEditable ? \'pace\':\'\'\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"bold()\">B</button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"italic()\"><i>I</i></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"underline()\"><u>U</u></button> <button class=\"btn btn-primary v4-primary-button\" ng-click=\"strike()\"><span style=\"text-decoration: line-through;\">S</span></button></div><div class=\"col-sm-4 p-0 d-flex justify-content-flex-end h-100 align-items-center\"><button class=\"btn btn-link p-0\" ng-click=\"isShowVariables = !isShowVariables\">Variable</button> <button class=\"btn btn-link p-0 m-l-10 m-r-10\" ng-click=\"isShowVariables = false;fnViewRenderedHTML(isShowPrviewRenderedHTML ?false : true)\">{{isShowPrviewRenderedHTML ? \'Code\' : \'Preview\'}}</button></div></div></div></div><div class=\"col-sm-12 p-0 email-body\"><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-if=\"!isShowPrviewRenderedHTML && !isShowVariables\"><ui-codemirror ng-model=\"templateConfigObj.mjmlBody\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div><div class=\"col-sm-12 p-0 email-template email-template-min-height\" ng-init=\"fnViewRenderedHTML(true)\" ng-if=\"isShowPrviewRenderedHTML && !isShowVariables\"><div class=\"h-100 overflow-auto d-flex justify-content-center align-items-center\" ng-if=\"isTemplateLoading\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"h-100 overflow-auto\" ng-if=\"!isTemplateLoading\"><div class=\"col-sm-12 p-0 h-100\" id=\"htmlParse\"></div></div></div><div class=\"col-sm-12 p-t-10 email-template-min-height\" ng-if=\"isShowVariables\"><label>Available Variables:</label><table border=\"1\" class=\"w100 variables-table\"><thead><tr class=\"variables-header\"><th class=\"p-5\">Name</th><th class=\"p-5\">Description</th></tr></thead><tbody><tr ng-repeat=\"(key,val) in templateConfigObj.emailVariables track by $index\"><td class=\"p-5\"><label>{{key}}</label></td><td class=\"p-5\">{{val}}</td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\" class=\"d-flex justify-content-center align-items-center m-r-10 m-t-3\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\" ng-if=\"!isValidTemplate\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"isValidTemplate\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable && !isValidTemplate\" ng-click=\"fnValidateTemplate()\">Validate Template</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!isTemplateEditable && !isEmailTemplateDataLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_EMAIL_TEMPLATE\" ng-click=\"fnChangeToEditable(true)\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userPermissionsObj.RESET_EMAIL_TEMPLATE\" ng-click=\"fnResetEmailTemplate(true)\"><a class=\"btn btn-link\">Reset Email</a></li></ul></div><button class=\"btn btn-primary btn-primary-cancel m-r-10\" ng-if=\"isTemplateEditable && !isValidatingTemplate && !isSaveChanges\" ng-click=\"fnChangeToEditable()\">Cancel</button> <button class=\"btn btn-primary v4-primary-button\" ng-disabled=\"!isValidTemplate || !templateConfigObj.emailFrom.length || !templateConfigObj.emailSubject.length || !isEmailValid\" ng-click=\"fnSaveEmailTemplate()\" ng-if=\"!isValidatingTemplate && !isSaveChanges && isTemplateEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"isValidatingTemplate || isSaveChanges && isTemplateEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/access/authenticator/authenticatorInfo/authenticatorSteps/authenticatorSupplemental/authenticatorSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"AuthenticatorSupplementalCtrl as authenticatorSupplemental\" ng-init=\"authenticatorSupplemental.fnInitAuthenticatorSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!authenticatorSupplemental.parent.isAuthenticatorDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"authenticatorSupplemental.parent.isAuthenticatorDetailsLoaded\" ng-init=\"authenticatorSupplemental.fnGetAuthenticatorData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"authenticatorSupplemental.supplementalKVPArr.length || authenticatorSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!authenticatorSupplemental.isSupplementalDetailsEditable && authenticatorSupplemental.parent.userPermissionsObj.REPLACE_AUTHENTICATOR_TAGS\" ng-click=\"authenticatorSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"authenticatorSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{authenticatorSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!authenticatorSupplemental.supplementalKVPArr.length && !authenticatorSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"authenticatorSupplemental.parent.userPermissionsObj.REPLACE_AUTHENTICATOR_TAGS\" ng-click=\"authenticatorSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"authenticatorSupplemental.supplementalKVPArr.length && !authenticatorSupplemental.isAdvancedOption\" ng-class=\"!authenticatorSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"authenticatorSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in authenticatorSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"authenticatorSupplemental.isKeyDuplicated && $index === authenticatorSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"authenticatorSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"authenticatorSupplemental.isKeyDuplicated && $index === authenticatorSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"authenticatorSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"authenticatorSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"authenticatorSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"authenticatorSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"authenticatorSupplemental.authenticatorSupplementalObj\" ui-codemirror-opts=\"authenticatorSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"authenticatorSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!authenticatorSupplemental.isSupplementalDetailChanging\" ng-click=\"authenticatorSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!authenticatorSupplemental.isSupplementalDetailChanging\" ng-click=\"authenticatorSupplemental.fnSaveAuthenticatorData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"authenticatorSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{authenticatorSupplemental.parent.authenticatorObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(authenticatorSupplemental.parent.authenticatorObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/authenticator/authenticatorInfo/authenticatorSteps/authenticatorUsers/authenticatorUsers.html","<div id=\"authenticatorUsersContent\" class=\"h-100\" ng-controller=\"AuthenticatorUsersCtrl as authenticatorUsers\" ng-init=\"authenticatorUsers.fnInitAuthenticatorUsers()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"authenticatorUsers.isAuthenticatorUsersLoading\"><table-loader hide-circle=\"true\" fn-resize=\"authenticatorUsers.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!authenticatorUsers.isAuthenticatorUsersLoading\"><div class=\"col-sm-12 p-0 action-div p-t-10\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"!authenticatorUsers.isShowAddUser && authenticatorUsers.selectedAuthenticatorUsersArr.length && !authenticatorUsers.isAuthenticatorUsersLoading\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"authenticatorUsers.fnHideShowAddUsers()\" ng-if=\"!authenticatorUsers.isShowAddUser\"><a class=\"btn btn-link\">Add User</a></li><li ng-if=\"authenticatorUsers.selectedAuthenticatorUsersArr.length\" ng-click=\"authenticatorUsers.fnDeleteAuthenticatorUsers(authenticatorUsers.selectedAuthenticatorUsersArr)\"><a class=\"btn btn-link\">Remove Users</a></li></ul></div></div><div class=\"users-details-table tableContainer\" ng-if=\"!authenticatorUsers.isShowAddUser\"><table class=\"table table-striped table-check-box\" ng-if=\"authenticatorUsers.authenticatorUsersArr.length\"><thead><tr><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"authenticatorUsers.isAllAuthenticatorUsersChecked\" ng-click=\"authenticatorUsers.fnCheckUncheckAuthenticatorUsersAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\"></th><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\">Name</th><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\"></th><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\"></th><th ng-if=\"authenticatorUsers.authenticatorUsersArr.length\"></th><th ng-if=\"!authenticatorUsers.authenticatorUsersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"user in authenticatorUsers.authenticatorUsersArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUA_{{$index}}\" ng-model=\"user.isCheck\" ng-change=\"authenticatorUsers.fnCheckUncheckAuthenticatorUsersHeader(user)\"> <label for=\"chkUA_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" ng-click=\"authenticatorUsers.fnGoToUsers(user)\" height=\"30\" width=\"30\" ng-src=\"{{authenticatorUsers.fnReturnUserImg(user)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"user.firstName + \' \' +user.lastName\">Doe</label> <span class=\"ellipsis\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"user.username\">John</span> <span class=\"discDot\" ng-hide=\"!user.email\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" ng-bind=\"user.email\">Doe</span></span></td><td><div ng-if=\"user.administrator\" class=\"administrator-icon\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg viewbox=\"0 0 511.999 511.999\" width=\"20\" height=\"20\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{user.state}}\" tooltip-placement=\"auto\" ng-style=\"authenticatorUsers.getUserStateColor(user.state)\"><span class=\"fa stateIcon\" ng-class=\"authenticatorUsers.fnGetUserStateIcon(user.state)\"></span></span></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!authenticatorUsers.authenticatorUsersArr.length\"><button class=\"btn btn-primary\" ng-click=\"authenticatorUsers.fnHideShowAddUsers()\">Add User</button></div></div><div id=\"addUserContainer\" ng-if=\"authenticatorUsers.isShowAddUser\"><div class=\"p-t-10 p-b-10\"><label>Add User</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"authenticatorUsers.fnHideShowAddUsers()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'authenticatorUsers\'\" filters-arr=\"authenticatorUsers.searchFiltersArr\" filter-query=\"authenticatorUsers.filterQuery\" fn-filter-query-change=\"authenticatorUsers.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.authenticators\'\" no-set-url=\"true\" fn-resize=\"authenticatorUsers.fnSetTableHeight()\" sort-field-arr=\"authenticatorUsers.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"authenticatorUsers.isUsersLoading\" fn-resize=\"authenticatorUsers.fnSetLoaderTableHeight()\" hide-circle=\"true\"></table-loader><div class=\"users-details-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!authenticatorUsers.isUsersLoading\"><thead><tr><th ng-if=\"authenticatorUsers.usersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUser\" ng-model=\"authenticatorUsers.isAllChecked\" ng-click=\"authenticatorUsers.fnCheckUncheckAll()\"> <label for=\"checkAllUser\" class=\"check-box\"></label></th><th ng-if=\"authenticatorUsers.usersArr.length\"></th><th ng-if=\"authenticatorUsers.usersArr.length\">Name</th><th ng-if=\"authenticatorUsers.usersArr.length\"></th><th ng-if=\"authenticatorUsers.usersArr.length\"></th><th ng-if=\"authenticatorUsers.usersArr.length\"></th><th ng-if=\"!authenticatorUsers.usersArr.length\">No records found...</th></tr></thead><tbody id=\"UserTable\"><tr ng-repeat=\"user in authenticatorUsers.usersArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUser_{{$index}}\" ng-model=\"user.isCheck\" ng-change=\"authenticatorUsers.fnCheckUncheckHeader(user)\"> <label for=\"chkUser_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" ui-sref=\"main.user({id:user.id})\" height=\"30\" width=\"30\" ng-src=\"{{authenticatorUsers.fnReturnUserImg(user)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"user.firstName + \' \' +user.lastName\">Doe</label> <span class=\"ellipsis\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"user.username\">John</span> <span class=\"discDot\" ng-hide=\"!user.email\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" ng-bind=\"user.email\">Doe</span></span></td><td><div ng-if=\"user.administrator\" class=\"administrator-icon\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg viewbox=\"0 0 511.999 511.999\" width=\"20\" height=\"20\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{user.state}}\" tooltip-placement=\"auto\" ng-style=\"authenticatorUsers.getUserStateColor(user.state)\"><span class=\"fa stateIcon\" ng-class=\"authenticatorUsers.fnGetUserStateIcon(user.state)\"></span></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!authenticatorUsers.isUsersLoading && authenticatorUsers.usersArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{authenticatorUsers.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"authenticatorUsers.perPage = 10; authenticatorUsers.fnPageChanged(authenticatorUsers.currentPage, authenticatorUsers.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticatorUsers.perPage = 20; authenticatorUsers.fnPageChanged(authenticatorUsers.currentPage, authenticatorUsers.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticatorUsers.perPage = 50; authenticatorUsers.fnPageChanged(authenticatorUsers.currentPage, authenticatorUsers.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"authenticatorUsers.perPage = 100; authenticatorUsers.fnPageChanged(authenticatorUsers.currentPage,authenticatorUsers.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"authenticatorUsers.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"authenticatorUsers.currentPage\" items-per-page=\"authenticatorUsers.perPage\" max-size=\"authenticatorUsers.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"authenticatorUsers.fnPageChanged(authenticatorUsers.currentPage, authenticatorUsers.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!authenticatorUsers.isUserAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"authenticatorUsers.fnAddUser()\">Add</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"authenticatorUsers.isUserAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{authenticatorObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(authenticatorObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/federationGroups/federationGroups.html","<div id=\"federationGroupsContent\" class=\"h-100\" ng-controller=\"FederationGroupsCtrl as federationGroups\" ng-init=\"federationGroups.fnInitFederationGroups()\"><div class=\"content-main\"><div class=\"p-20\" ng-if=\"federationGroups.isFederationGroupsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"federationGroups.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!federationGroups.isFederationGroupsLoading\"><div class=\"col-sm-12 p-0 action-div p-t-10\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"((!federationGroups.isShowAddGroup) || (federationGroups.selectedFederationGroupsArr.length)) && !federationGroups.isFederationGroupsLoading\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"federationGroups.fnHideShowAddSecurityGroups()\" ng-if=\"!federationGroups.isShowAddGroup\"><a class=\"btn btn-link\">Add Security Group</a></li><li ng-if=\"federationGroups.selectedFederationGroupsArr.length\" ng-click=\"federationGroups.fnDeleteFederationGroups(federationGroups.selectedFederationGroupsArr)\"><a class=\"btn btn-link\">Remove Security Groups</a></li></ul></div></div><div class=\"user-groups-table table-container\" id=\"tableContainer\" ng-if=\"!federationGroups.isShowAddGroup\"><table id=\"usergroups-table\" class=\"table table-striped table-check-box\" ng-if=\"federationGroups.federationGroupsArr.length\"><thead><tr><th ng-if=\"federationGroups.federationGroupsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"federationGroups.isAllFederationGroupsChecked\" ng-click=\"federationGroups.fnCheckUncheckFederationGroupsAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"federationGroups.federationGroupsArr.length\">Name</th><th ng-if=\"!federationGroups.federationGroupsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"group in federationGroups.federationGroupsArr track by $index\" ng-click=\"federationGroups.fnGetGroup(group, federationGroups.federationGroupsArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"federationGroups.fnCheckUncheckFederationGroupsHeader(group)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!federationGroups.federationGroupsArr.length\"><button class=\"btn btn-primary\" ng-click=\"federationGroups.fnHideShowAddSecurityGroups()\">Add Security Groups</button></div></div><div id=\"addGroupContainer\" ng-if=\"federationGroups.isShowAddGroup\"><div class=\"p-t-10 p-b-10\"><label>Add Security Group</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"federationGroups.fnHideShowAddSecurityGroups()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'federationGroups\'\" filters-arr=\"federationGroups.searchFiltersArr\" filter-query=\"federationGroups.filterQuery\" fn-filter-query-change=\"federationGroups.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.federations\'\" no-set-url=\"true\" fn-resize=\"federationGroups.fnSetTableHeight()\" sort-field-arr=\"federationGroups.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"federationGroups.isGroupsLoading\" hide-circle=\"true\" fn-resize=\"federationGroups.fnSetLoaderTableHeight()\"></table-loader><div class=\"user-groups-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-show=\"!federationGroups.isGroupsLoading\"><thead><tr><th ng-if=\"federationGroups.groupsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGroup\" ng-model=\"federationGroups.isAllChecked\" ng-click=\"federationGroups.fnCheckUncheckAll()\"> <label for=\"checkAllGroup\" class=\"check-box\"></label></th><th ng-if=\"federationGroups.groupsArr.length\">Name</th><th ng-if=\"federationGroups.groupsArr.length\">Description</th><th ng-if=\"!federationGroups.groupsArr.length\">No records found...</th></tr></thead><tbody id=\"federationSecurityGroupsTable\"><tr ng-repeat=\"group in federationGroups.groupsArr track by $index\" ng-click=\"federationGroups.fnGetGroup(group, federationGroups.groupsArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkGroup_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"federationGroups.fnCheckUncheckHeader(group)\"> <label for=\"chkGroup_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!federationGroups.isGroupsLoading && federationGroups.groupsArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{federationGroups.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"federationGroups.perPage = 10; federationGroups.fnPageChanged(federationGroups.currentPage, federationGroups.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"federationGroups.perPage = 20; federationGroups.fnPageChanged(federationGroups.currentPage, federationGroups.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"federationGroups.perPage = 50; federationGroups.fnPageChanged(federationGroups.currentPage, federationGroups.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"federationGroups.perPage = 100; federationGroups.fnPageChanged(federationGroups.currentPage,federationGroups.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"federationGroups.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"federationGroups.currentPage\" items-per-page=\"federationGroups.perPage\" max-size=\"federationGroups.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"federationGroups.fnPageChanged(federationGroups.currentPage, federationGroups.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!federationGroups.isGroupAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"federationGroups.fnAddSecurityGroup()\">Add</button></div><div class=\"col-sm-12 m-t-15\" ng-if=\"federationGroups.isGroupAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{federationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/federationScript/federationScript.html","<div class=\"h-100\" ng-controller=\"FederationScriptCtrl as federationScript\" ng-init=\"federationScript.fnInitFederationScript()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"federationScript.isFederationScriptLoaded\"></div><div class=\"col-sm-12 p-0 m-t-0 floatingLabelInput h-100\" ng-if=\"!federationScript.isFederationScriptLoaded\"><div class=\"col-sm-12 p-0 tabContent1\"><div class=\"col-sm-12 p-0 email-template\" style=\"height: calc(100% - 5px)\"><ui-codemirror ng-model=\"federationScript.scriptBody\" ui-codemirror-opts=\"federationScript.editorOptions\"></ui-codemirror></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10 col-sm-12 align-items-center\" style=\"height: 55px;\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"federationScript.isScriptEditable && !federationScript.isSaveChanges\" ng-click=\"federationScript.fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0 justify-content-flex-end\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!federationScript.isScriptEditable && !federationScript.isScriptLoading && !federationScript.isScriptTypeLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"federationScript.parent.userPermissionsObj.UPDATE_FEDERATION_SCRIPT\" ng-click=\"federationScript.fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"federationScript.parent.userPermissionsObj.RESET_FEDERATION_SCRIPT\" ng-click=\"federationScript.fnResetScript()\"><a class=\"btn btn-link\">Reset Script</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-click=\"federationScript.fnSaveScript()\" ng-if=\"!federationScript.isSaveChanges && federationScript.isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"federationScript.isSaveChanges && federationScript.isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/federationRoles/federationRoles.html","<div id=\"federationRolesContent\" class=\"h-100\" ng-controller=\"FederationRolesCtrl as federationRoles\" ng-init=\"federationRoles.fnInitFederationSecurityRoles()\"><div class=\"content-main\"><div class=\"p-20\" ng-if=\"federationRoles.isFederationRolesLoading\"><table-loader hide-circle=\"true\" fn-resize=\"federationRoles.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!federationRoles.isFederationRolesLoading\"><div class=\"col-sm-12 p-0 action-div p-t-10\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"((!federationRoles.isShowAddRole) || (federationRoles.selectedFederationRolesArr.length)) && !federationRoles.isFederationRolesLoading\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"federationRoles.fnHideShowAddSecurityRoles()\" ng-if=\"!federationRoles.isShowAddRole\"><a class=\"btn btn-link\">Add Security Role</a></li><li ng-if=\"federationRoles.selectedFederationRolesArr.length\" ng-click=\"federationRoles.fnDeleteFederationSecurityRoles(federationRoles.selectedFederationRolesArr)\"><a class=\"btn btn-link\">Remove Security Role</a></li></ul></div></div><div id=\"tableContainer\" class=\"user-groups-table table-container\" ng-if=\"!federationRoles.isShowAddRole\"><table id=\"usergroups-table\" class=\"table table-striped table-check-box\" ng-if=\"federationRoles.federationRolesArr.length\"><thead><tr><th ng-if=\"federationRoles.federationRolesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"federationRoles.isAllFederationRolesChecked\" ng-click=\"federationRoles.fnCheckUncheckFederationRolesAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"federationRoles.federationRolesArr.length\">Name</th><th ng-if=\"!federationRoles.federationRolesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"role in federationRoles.federationRolesArr track by $index\" ng-click=\"federationRoles.fnGetRole(role, federationRoles.federationRolesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"role.isCheck\" ng-change=\"federationRoles.fnCheckUncheckFederationRolesHeader(role)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"role.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"role.description\">Desc</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!federationRoles.federationRolesArr.length\"><button class=\"btn btn-primary\" ng-click=\"federationRoles.fnHideShowAddSecurityRoles()\">Add Security Roles</button></div></div><div id=\"addRoleContainer\" ng-if=\"federationRoles.isShowAddRole\"><div class=\"p-t-10 p-b-10\"><label>Add Security Role</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"federationRoles.fnHideShowAddSecurityRoles()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'federationRoles\'\" filters-arr=\"federationRoles.searchFiltersArr\" filter-query=\"federationRoles.filterQuery\" fn-filter-query-change=\"federationRoles.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.federations\'\" no-set-url=\"true\" fn-resize=\"federationRoles.fnSetTableHeight()\" sort-field-arr=\"federationRoles.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"federationRoles.isRolesLoading\" hide-circle=\"true\" fn-resize=\"federationRoles.fnSetLoaderTableHeight()\"></table-loader><div class=\"user-groups-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-show=\"!federationRoles.isRolesLoading\"><thead><tr><th ng-if=\"federationRoles.rolesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllRole\" ng-model=\"federationRoles.isAllChecked\" ng-click=\"federationRoles.fnCheckUncheckAll()\"> <label for=\"checkAllRole\" class=\"check-box\"></label></th><th ng-if=\"federationRoles.rolesArr.length\">Name</th><th ng-if=\"!federationRoles.rolesArr.length\">No Records Found...</th></tr></thead><tbody id=\"federationSecurityRolesTable\"><tr ng-repeat=\"role in federationRoles.rolesArr track by $index\" ng-click=\"federationRoles.fnGetRole(role, federationRoles.rolesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkRole_{{$index}}\" ng-model=\"role.isCheck\" ng-change=\"federationRoles.fnCheckUncheckHeader(role)\"> <label for=\"chkRole_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"role.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"role.description\">Desc</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!federationRoles.isRolesLoading && federationRoles.rolesArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{federationRoles.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"federationRoles.perPage = 10; federationRoles.fnPageChanged(federationRoles.currentPage, federationRoles.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"federationRoles.perPage = 20; federationRoles.fnPageChanged(federationRoles.currentPage, federationRoles.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"federationRoles.perPage = 50; federationRoles.fnPageChanged(federationRoles.currentPage, federationRoles.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"federationRoles.perPage = 100; federationRoles.fnPageChanged(federationRoles.currentPage,federationRoles.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"federationRoles.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"federationRoles.currentPage\" items-per-page=\"federationRoles.perPage\" max-size=\"federationRoles.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"federationRoles.fnPageChanged(federationRoles.currentPage, federationRoles.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!federationRoles.isRoleAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"federationRoles.fnAddSecurityRole()\">Add</button></div><div class=\"col-sm-12 m-t-15\" ng-if=\"federationRoles.isRoleAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{federationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/federationSupplemental/federationSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"FederationSupplementalCtrl as federationSupplemental\" ng-init=\"federationSupplemental.fnInitFederationSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!federationSupplemental.parent.isFederationDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"federationSupplemental.parent.isFederationDetailsLoaded\" ng-init=\"federationSupplemental.fnGetFederationData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"federationSupplemental.supplementalKVPArr.length || federationSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!federationSupplemental.isSupplementalDetailsEditable && federationSupplemental.parent.userPermissionsObj.REPLACE_FEDERATION_TAGS\" ng-click=\"federationSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"federationSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{federationSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!federationSupplemental.supplementalKVPArr.length && !federationSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"federationSupplemental.parent.userPermissionsObj.REPLACE_FEDERATION_TAGS\" ng-click=\"federationSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"federationSupplemental.supplementalKVPArr.length && !federationSupplemental.isAdvancedOption\" ng-class=\"!federationSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"federationSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in federationSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"federationSupplemental.isKeyDuplicated && $index === federationSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"federationSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"federationSupplemental.isKeyDuplicated && $index === federationSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"federationSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"federationSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"federationSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"federationSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"federationSupplemental.federationSupplementalObj\" ui-codemirror-opts=\"federationSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"federationSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!federationSupplemental.isSupplementalDetailChanging\" ng-click=\"federationSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!federationSupplemental.isSupplementalDetailChanging\" ng-click=\"federationSupplemental.fnSaveFederationData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"federationSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{federationSupplemental.parent.federationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(federationSupplemental.parent.federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/federation/federationInfo/federationSteps/federationTeams/federationTeams.html","<div id=\"teamsContent\" class=\"h-100\" ng-controller=\"FederationsTeamsCtrl as federationTeams\" ng-init=\"federationTeams.fnInitFederationTeams()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"federationTeams.isFederationTeamsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"federationTeams.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!federationTeams.isFederationTeamsLoading\" ng-class=\"!federationTeams.federationTeamsArr.length ? \'h-100\' : \'\'\"><div class=\"federation-teams-info-table tableContainer\" ng-if=\"federationTeams.federationTeamsArr.length\"><table id=\"usergroups-table p-5\" class=\"table table-striped\"><thead><tr><th class=\"p-l-15 p-r-15\" ng-if=\"federationTeams.federationTeamsArr.length\">Name</th></tr></thead><tbody><tr ng-repeat=\"group in federationTeams.federationTeamsArr track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 p-l-15 p-r-15 p-t-4\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\" ng-click=\"$event.stopPropagation(); federationTeams.fnGoToTeam(group)\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table></div><div class=\"h-100\" ng-if=\"!federationTeams.federationTeamsArr.length\"><div class=\"h-100 d-flex flex-column align-items-center justify-content-center\"><div><label>The federation has not been added as a resource to any team.</label></div><div><label>To add federation as a resource visit Teams.</label></div><div class=\"m-t-10\"><button class=\"btn btn-primary v4-primary-button\" ui-sref=\"main.teams\">Teams</button></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{federationObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(federationObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/team/teamInfo/teamSteps/teamResources/teamResources.html","<div id=\"groupRolesContent\" class=\"h-100\" ng-controller=\"TeamResourcesCtrl as teamResources\" ng-init=\"teamResources.fnInitTeamResources()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"!teamResources.parent.isTeamDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 d-flex m-t-10\" ng-if=\"teamResources.parent.isTeamDetailsLoaded && !teamResources.isShowAddResources\" ng-init=\"teamResources.fnGetTeamResources()\"><div class=\"col-sm-12 d-flex p-0 justify-content-flex-end\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"!teamResources.isTeamResourcesLoading\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"teamResources.parent.userPermissionObj.ADD_RESOURCE_TO_TEAM\" ng-click=\"teamResources.fnHideShowAddResources()\"><a class=\"btn btn-link\">Add Resource</a></li></ul></div></div></div><div class=\"col-sm-12\" ng-if=\"!teamResources.isTeamResourcesLoading\" ng-style=\"{\'height\': !teamResources.teamResourcesArr.length ? \'calc(100% - 35px)\' : \'\'}\"><div class=\"col-sm-12 p-0\" ng-if=\"!teamResources.isShowAddResources\" ng-class=\"!teamResources.teamResourcesArr.length ? \'h-100\' : \'\'\"><div class=\"col-sm-12 m-t-20 p-0\" ng-if=\"teamResources.teamResourcesArr.length\"><div class=\"col-sm-12 p-0 p-t-0\" id=\"functionModal\"><div class=\"col-sm-12 p-0\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\" style=\"height: 55px;\"><label class=\"m-t-6\">Resources</label></div><div class=\"panel-body\"><div class=\"col-sm-12 p-0 p-b-10\"><div class=\"col-sm-12 p-0 m-t-10 d-flex\" style=\"min-height: 100px;border: 2px dashed;\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-12 p-0 d-flex justify-content-center p-t-30 p-b-30 flex-column\"><label ng-if=\"!teamResources.teamResourcesArr.length\">No Resources</label><div class=\"col-sm-12 p-0 d-flex align-items-center p-l-30 justify-content-start\" ng-class=\"!$last ?\'p-b-10\' :\'\'\" ng-repeat=\"resource in teamResources.teamResourcesArr\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-start\"><div class=\"m-r-10\"><svg viewbox=\"0 0 512.001 512.001\" width=\"20px\" class=\"d-flex justify-content-center custom-wizard-svg-icon svgIconFillTextSecondaryColor\"><path d=\"m361.480469 309.242188-17.652344 9.777343c-3.625 2.011719-4.933594 6.574219-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226562 0 2.476562-.300781 3.628906-.9375l17.652344-9.78125c3.621094-2.007812 4.933594-6.574219 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m361.480469 287.960938-17.652344 9.777343c-3.625 2.007813-4.9375 6.574219-2.925781 10.199219 1.367187 2.46875 3.925781 3.863281 6.566406 3.863281 1.226562 0 2.476562-.300781 3.625-.9375l17.65625-9.78125c3.621094-2.007812 4.933594-6.570312 2.925781-10.195312-2.007812-3.625-6.574219-4.933594-10.195312-2.925781zm0 0\"></path><path d=\"m485.9375 377.816406c.71875-1.171875 1.121094-2.550781 1.121094-3.929687v-65.980469c0-4.144531-3.359375-7.5-7.503906-7.5-4.140626 0-7.5 3.355469-7.5 7.5v54.425781l-72.121094-32.167969v-139.367187l72.121094-39.957031v124.40625c0 4.144531 3.359374 7.5 7.5 7.5 4.144531 0 7.503906-3.355469 7.503906-7.5v-137.136719c0-2.675781-1.523438-5.261719-3.867188-6.558594l-235.777344-130.625c-2.238281-1.234375-5.03125-1.234375-7.269531 0l-235.777343 130.625c-2.382813 1.316407-3.898438 3.929688-3.867188 6.648438v235.6875c0 2.679687 1.519531 5.261719 3.867188 6.5625l103.882812 57.554687c3.625 2.003906 8.1875.695313 10.195312-2.925781 2.007813-3.625.695313-8.191406-2.925781-10.195313l-90.734375-50.269531 69.972656-31.207031 141.519532 78.402344v69.972656l-91.011719-50.417969c-3.621094-2.007812-8.1875-.699219-10.195313 2.925781-2.007812 3.621094-.695312 8.1875 2.925782 10.195313l102.148437 56.589844c2.226563 1.234375 5.042969 1.234375 7.269531 0l107.128907-59.355469c3.625-2.007812 4.933593-6.570312 2.925781-10.195312-2.003906-3.621094-6.570312-4.933594-10.195312-2.925782l-95.996094 53.183594v-69.972656l141.519531-78.402344 69.972656 31.207031-85.769531 47.519531c-3.625 2.007813-4.933594 6.570313-2.925781 10.195313 1.367187 2.472656 3.925781 3.867187 6.566406 3.867187 1.226563 0 2.476563-.304687 3.628906-.941406l98.921875-54.804687c1.109375-.613281 2.082032-1.554688 2.746094-2.632813zm-242.160156-265.222656 133.179687 73.785156-133.179687 73.78125-133.175782-73.78125zm148.65625 65.210938-141.15625-78.203126v-79.386718l212.800781 117.894531zm-156.15625-78.203126-141.152344 78.203126-71.648438-39.695313 212.800782-117.894531zm-220.777344 51.238282 72.121094 39.957031v139.367187l-72.121094 32.167969zm87.125 48.269531 54.441406 30.160156 79.210938 43.886719v131.503906l-133.652344-74.046875zm148.652344 74.046875 133.65625-74.046875v131.503906l-133.65625 74.046875zm0 0\"></path></svg></div><div class=\"d-flex flex-column\"><label class=\"m-0\">{{resource.displayName}} - {{resource.resourceName}} ({{resource.id}})</label></div></div><div ng-class=\"teamResources.isResourceRemoveProcessActive ? \'p-r-15\' : \'p-r-30\'\"><i class=\"fa fa-times\" ng-if=\"!resource.isResourceRemoveProcessActive && teamResources.parent.userPermissionObj.REMOVE_RESOURCE_FROM_TEAM\" ng-click=\"teamResources.fnRemoveTeamResource(resource)\"></i><app-spinner ng-if=\"resource.isResourceRemoveProcessActive\" spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 h-100 d-flex flex-column justify-content-center align-items-center\" ng-if=\"!teamResources.teamResourcesArr.length\"><span>Resources are the specific account services that you wish to make available to this team and its members. For users with \'Team Member\' or \'Customer\'</span> <span>roles these resources control what they have access to while their individual permissions control what they can do with those resources.</span> <button class=\"btn btn-primary m-t-20\" ng-if=\"teamResources.parent.userPermissionObj.ADD_RESOURCE_TO_TEAM\" ng-click=\"teamResources.fnHideShowAddResources()\">Add Resource</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"teamResources.isShowAddResources\"><div class=\"col-sm-12 p-0 p-b-10 p-t-20\"><h3 class=\"m-b-0\">Add Resource</h3></div><div class=\"col-sm-12 p-0 AiBranchInput\"><uib-accordion close-others=\"false\"><uib-accordion-group class=\"m-t-20\" is-open=\"app.open\" ng-repeat=\"app in teamResources.teamArr track by $index\"><uib-accordion-heading><div class=\"row\"><div class=\"col-sm-2 d-flex\"><div><span>{{app.title}}</span></div></div><div class=\"col-sm-10\"><i class=\"fa pull-right\" ng-class=\"{\'fa-angle-down\': !app.open, \'fa-angle-up\': app.open}\"></i><div class=\"col-sm-1 fa pull-right\"></div></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-4 m-b-4\" ng-repeat=\"subapp in app.subapp track by $index\"><div class=\"d-flex\"><input type=\"checkbox\" id=\"subappchk_{{$index + subapp.name + subapp.type}}\" ng-model=\"subapp.isChecked\" ng-change=\"teamResources.fnCheckUncheckApps(subapp, subapp.isChecked)\" ng-click=\"subapp.isChecked && teamResources.openModal(subapp)\"> <label for=\"subappchk_{{$index + subapp.name + subapp.type}}\" class=\"check-box\"></label><div class=\"m-l-5\" style=\"margin-top: -2px;\"><label>{{subapp.name}}</label></div></div></div></div></uib-accordion-group></uib-accordion></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice || teamResources.isShowAddResources\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\" ng-if=\"!teamResources.isShowAddResources && isFullWidthDevice\"><label class=\"m-0\">ID: {{teamObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(teamObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\" ng-if=\"teamResources.isShowAddResources\"><button class=\"btn btn-primary v4-primary-button m-t-0\" ng-click=\"teamResources.fnCancel()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\" ng-if=\"teamResources.isShowAddResources\"><input type=\"button\" class=\"btn btn-primary v4-primary-button m-t-0 p-r-20 p-l-20\" ng-if=\"teamResources.isUpdateCompleted\" ng-click=\"teamResources.fnSave()\" value=\"Save\"><div class=\"p-t-2\" ng-if=\"!teamResources.isUpdateCompleted\"><div class=\"pull-right m-r-0\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div>");
$templateCache.put("app/access/team/teamInfo/teamSteps/teamSupplemental/teamSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"TeamSupplementalCtrl as teamSupplemental\" ng-init=\"teamSupplemental.fnInitTeamSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!teamSupplemental.parent.isTeamDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"teamSupplemental.parent.isTeamDetailsLoaded\" ng-init=\"teamSupplemental.fnGetTeamData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"teamSupplemental.supplementalKVPArr.length || teamSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!teamSupplemental.isSupplementalDetailsEditable && teamSupplemental.parent.userPermissionObj.REPLACE_TEAM_TAGS\" ng-click=\"teamSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"teamSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{teamSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!teamSupplemental.supplementalKVPArr.length && !teamSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"teamSupplemental.parent.userPermissionObj.REPLACE_TEAM_TAGS\" ng-click=\"teamSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"teamSupplemental.supplementalKVPArr.length && !teamSupplemental.isAdvancedOption\" ng-class=\"!teamSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-repeat=\"kvpPair in teamSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"teamSupplemental.isKeyDuplicated && $index === teamSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"teamSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"teamSupplemental.isKeyDuplicated && $index === teamSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"teamSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-if=\"teamSupplemental.isSupplementalDetailsEditable\" ng-click=\"teamSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"teamSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"teamSupplemental.teamSupplementalObj\" ui-codemirror-opts=\"teamSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"teamSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!teamSupplemental.isSupplementalDetailChanging\" ng-click=\"teamSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!teamSupplemental.isSupplementalDetailChanging\" ng-click=\"teamSupplemental.fnSaveTeamData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"teamSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{teamObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(teamObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/team/teamInfo/teamSteps/teamUsers/teamUsers.html","<div id=\"groupUsersContent\" class=\"h-100\" ng-controller=\"TeamUsersCtrl as teamUsers\" ng-init=\"teamUsers.fnInitTeamUsers()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"teamUsers.isTeamUsersLoading\"><table-loader hide-circle=\"true\" fn-resize=\"teamUsers.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!teamUsers.isTeamUsersLoading\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"!teamUsers.isShowAddUser && teamUsers.teamUsersArr.length\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"teamUsers.fnHideShowAddUsers()\" ng-if=\"!teamUsers.isShowAddUser && teamUsers.parent.userPermissionObj.ADD_USER_TO_TEAM\"><a class=\"btn btn-link\">Add User</a></li><li ng-if=\"teamUsers.selectedTeamUsersArr.length && teamUsers.parent.userPermissionObj.REMOVE_USER_FROM_TEAM\" ng-click=\"teamUsers.fnDeleteTeamUsers(teamUsers.selectedTeamUsersArr)\"><a class=\"btn btn-link\">Remove Users</a></li></ul></div></div><div class=\"users-details-table table-container tableContainer\" ng-if=\"!teamUsers.isShowAddUser\"><table class=\"table table-striped table-check-box\" ng-if=\"teamUsers.teamUsersArr.length\"><thead><tr><th ng-if=\"teamUsers.teamUsersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAll\" ng-model=\"users.isAllChecked\" ng-click=\"users.fnCheckUncheckAll()\"> <label for=\"checkAll\" class=\"check-box\"></label></th><th ng-if=\"teamUsers.teamUsersArr.length\"></th><th ng-if=\"teamUsers.teamUsersArr.length\"><span>Name</span></th><th ng-if=\"teamUsers.teamUsersArr.length\"></th><th ng-if=\"teamUsers.teamUsersArr.length\"></th><th ng-if=\"teamUsers.teamUsersArr.length\"></th><th ng-if=\"!teamUsers.teamUsersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"user in teamUsers.teamUsersArr track by $index\" ng-click=\"users.fnGetUser(user, teamUsers.teamUsersArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"user.isCheck\" ng-change=\"teamUsers.fnCheckUncheckTeamUsersHeader(user)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" ng-click=\"teamUsers.fnGoToUsers(user)\" height=\"30\" width=\"30\" ng-src=\"{{teamUsers.fnReturnUserImg(user)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"user.firstName + \' \' +user.lastName\" style=\"width: fit-content !important;\"></label></div><span class=\"ellipsis\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"user.username\"></span> <span class=\"discDot\" ng-hide=\"!user.email\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" ng-bind=\"user.email\"></span></span></td><td><div ng-if=\"user.administrator\" class=\"administrator-icon\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg viewbox=\"0 0 511.999 511.999\" width=\"20\" height=\"20\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{user.state}}\" tooltip-placement=\"auto\" ng-style=\"teamUsers.getUserStateColor(user.state)\"><span class=\"fa stateIcon\" ng-class=\"teamUsers.fnGetUserStateIcon(user.state)\"></span></span></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!teamUsers.teamUsersArr.length\"><button class=\"btn btn-primary\" ng-click=\"teamUsers.fnHideShowAddUsers()\">Add User</button></div></div><div id=\"addUserContainer\" ng-if=\"teamUsers.isShowAddUser\"><div class=\"p-t-10 p-b-10\"><label>Add User</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"teamUsers.fnHideShowAddUsers()\"><i class=\"fa fa-times\"></i></button></div><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"teamUsers.isGettingUsers\"></div><div ng-if=\"!teamUsers.isGettingUsers\"><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'teamUserSearch\'\" filters-arr=\"teamUsers.searchFiltersArr\" filter-query=\"teamUsers.filterQuery\" fn-filter-query-change=\"teamUsers.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.teams\'\" no-set-url=\"true\" fn-resize=\"teamUsers.fnSetLoaderTableHeight()\" sort-field-arr=\"teamUsers.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"teamUsers.isUsersLoading\" fn-resize=\"teamUsers.fnSetLoaderTableHeight()\" hide-circle=\"true\"></table-loader><div class=\"users-details-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!teamUsers.isUsersLoading\"><thead><tr><th ng-if=\"teamUsers.usersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUser\" ng-model=\"teamUsers.isAllChecked\" ng-click=\"teamUsers.fnCheckUncheckAll()\"> <label for=\"checkAllUser\" class=\"check-box\"></label></th><th ng-if=\"teamUsers.usersArr.length\"></th><th ng-if=\"teamUsers.usersArr.length\"><span>Name</span></th><th ng-if=\"teamUsers.usersArr.length\"></th><th ng-if=\"teamUsers.usersArr.length\"></th><th ng-if=\"teamUsers.usersArr.length\"></th><th ng-if=\"!teamUsers.usersArr.length\">No records found...</th></tr></thead><tbody id=\"teamsUserTable\"><tr ng-repeat=\"user in teamUsers.usersArr track by $index\" ng-click=\"users.fnGetUser(user, users.userArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUser_{{$index}}\" ng-model=\"user.isCheck\" ng-change=\"teamUsers.fnCheckUncheckHeader(user)\"> <label for=\"chkUser_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-6\"><img alt=\"member\" class=\"img-circle\" ng-click=\"teamUsers.fnGoToUsers(user)\" height=\"30\" width=\"30\" ng-src=\"{{teamUsers.fnReturnUserImg(user)}}\" on-error-src=\"\"></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"user.firstName + \' \' +user.lastName\" style=\"width: fit-content !important;\"></label></div><span class=\"ellipsis\"><span class=\"DescriptionText font-italic p-r-5 span_des\" ng-bind=\"user.username\"></span> <span class=\"discDot\" ng-hide=\"!user.email\"><span class=\"dot\"></span></span> <span class=\"DescriptionText p-l-10 span_des\" ng-bind=\"user.email\"></span></span></td><td><div ng-if=\"user.administrator\" class=\"administrator-icon\" uib-tooltip=\"Administrator\" tooltip-placement=\"auto\"><svg viewbox=\"0 0 511.999 511.999\" width=\"20\" height=\"20\"><g><path d=\"M465.682,104.665L260.75,1.163c-1.387-0.737-2.967-1.156-4.645-1.163c-0.013-0.001-0.012,0-0.017,0 c-0.013,0-0.016,0-0.022,0h-0.135c-0.007,0-0.009,0-0.022,0c-0.005,0-0.003,0-0.017,0c-1.678,0.006-3.258,0.426-4.645,1.163 L46.317,104.665c-3.368,1.701-5.492,5.153-5.492,8.926v187.295c0,36.505,10.981,67.362,33.57,94.333 c20.914,24.971,49.109,43.192,73.932,57.722c51.191,29.967,102.348,57.584,102.858,57.86c1.459,0.787,3.09,1.198,4.747,1.198 h0.135c1.657,0,3.288-0.412,4.747-1.198c0.511-0.276,51.667-27.893,102.858-57.86c4.767-2.79,6.368-8.916,3.578-13.682 c-2.789-4.767-8.913-6.369-13.682-3.578c-41.917,24.539-83.823,47.499-97.569,54.979c-13.743-7.479-55.641-30.434-97.569-54.978 c-47.224-27.644-97.605-63.137-97.605-134.795V119.744l195.174-98.575l195.175,98.575v181.143 c0,36.772-12.335,66.076-38.817,92.222c-3.931,3.88-3.971,10.211-0.091,14.142c3.88,3.931,10.213,3.97,14.142,0.091 c30.123-29.74,44.767-64.562,44.767-106.455V113.592C471.174,109.818,469.05,106.367,465.682,104.665z\"></path></g><g><path d=\"M431.174,138.201c0-3.773-2.124-7.225-5.492-8.926L260.507,45.852c-2.834-1.432-6.182-1.432-9.016,0L86.317,129.274 c-3.368,1.701-5.492,5.153-5.492,8.926v162.687c0,26.433,7.858,48.77,24.023,68.287c13.486,16.283,32.533,31.011,63.687,49.248 c31.094,18.202,62.104,35.496,82.644,46.798c1.501,0.826,3.161,1.239,4.821,1.239c1.66,0,3.32-0.413,4.821-1.239 c20.538-11.302,51.548-28.595,82.645-46.798c31.153-18.237,50.199-32.965,63.686-49.248 c16.165-19.518,24.023-41.854,24.023-68.287V138.201H431.174z M411.174,300.887c0,46.003-27.348,70.733-77.813,100.275 c-28.564,16.721-57.075,32.68-77.362,43.879c-20.288-11.199-48.8-27.159-77.361-43.878 c-50.466-29.542-77.813-54.272-77.813-100.275V144.353l155.174-78.371l155.175,78.371V300.887z\"></path></g><g><path d=\"M311.318,257.881l-16.389-3.584c-3.502-0.766-6.262-3.366-7.364-6.67c14.741-10.097,24.434-27.048,24.434-46.225v-36.8 c0-30.878-25.121-56-56-56c-30.879,0-56,25.122-56,56v36.8c0,19.097,9.615,35.984,24.252,46.096 c-1.063,3.353-3.852,6.029-7.409,6.809l-16.201,3.554c-13.173,2.89-25.082,10.268-33.534,20.776 c-8.452,10.508-13.108,23.721-13.108,37.207V346c0,5.523,4.478,10,10,10h184c5.522,0,10-4.477,10-10v-30.128 C357.999,288.184,338.366,263.795,311.318,257.881z M219.999,164.602c0-19.851,16.149-36,36-36 c15.381,0,28.532,9.698,33.679,23.298l-0.695,0.695c-13.089,13.089-30.493,20.298-49.005,20.298h-19.979V164.602z M219.999,201.402v-8.509h19.979c18.933,0,36.954-5.871,52.021-16.718v25.227c0,19.851-16.149,36-36,36 S219.999,221.253,219.999,201.402z M276.799,266.584c-12.539,8.559-29.215,8.529-41.726-0.088 c3.212-2.993,5.766-6.662,7.435-10.747c4.323,1.074,8.84,1.653,13.491,1.653c4.577,0,9.022-0.564,13.283-1.605 C270.97,259.904,273.552,263.588,276.799,266.584z M337.999,336h-164v-20.157c0-18.347,13.007-34.516,30.927-38.447l9.882-2.167 c0.287,0.385,0.594,0.759,0.943,1.108c11.097,11.096,25.673,16.645,40.249,16.645c14.576,0,29.152-5.548,40.249-16.645 c0.34-0.34,0.64-0.704,0.92-1.078l9.877,2.16c17.936,3.922,30.953,20.093,30.953,38.453V336z\"></path></g><g><path d=\"M397.778,416.82c-1.859-1.86-4.429-2.93-7.069-2.93c-2.63,0-5.2,1.07-7.07,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.44,2.93,7.07,2.93c2.64,0,5.21-1.07,7.069-2.93c1.87-1.86,2.94-4.44,2.94-7.07 S399.648,418.68,397.778,416.82z\"></path></g><g><path d=\"M137.899,161.89c-1.859-1.86-4.439-2.93-7.08-2.93c-2.63,0-5.199,1.07-7.069,2.93c-1.86,1.86-2.92,4.44-2.92,7.07 s1.06,5.21,2.92,7.07c1.87,1.86,4.439,2.93,7.069,2.93c2.64,0,5.21-1.07,7.08-2.93c1.861-1.86,2.931-4.44,2.931-7.07 S139.759,163.75,137.899,161.89z\"></path></g><g><path d=\"M130.824,192.391c-5.522,0-10,4.477-10,10V256c0,5.523,4.478,10,10,10c5.523,0,10-4.477,10-10v-53.609 C140.824,196.868,136.346,192.391,130.824,192.391z\"></path></g></svg></div></td><td class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{user.state}}\" tooltip-placement=\"auto\" ng-style=\"teamUsers.getUserStateColor(user.state)\"><span class=\"fa stateIcon\" ng-class=\"teamUsers.fnGetUserStateIcon(user.state)\"></span></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!teamUsers.isUsersLoading && teamUsers.usersArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{teamUsers.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"teamUsers.perPage = 10; teamUsers.fnPageChanged(teamUsers.currentPage, teamUsers.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"teamUsers.perPage = 20; teamUsers.fnPageChanged(teamUsers.currentPage, teamUsers.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"teamUsers.perPage = 50; teamUsers.fnPageChanged(teamUsers.currentPage, teamUsers.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"teamUsers.perPage = 100; teamUsers.fnPageChanged(teamUsers.currentPage,teamUsers.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"teamUsers.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"teamUsers.currentPage\" items-per-page=\"teamUsers.perPage\" max-size=\"teamUsers.maxSize\" boundary-links=\"true\" ng-click=\"teamUsers.fnPageChanged(teamUsers.currentPage, teamUsers.perPage)\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!teamUsers.isUserAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"teamUsers.fnAddUser()\">Add</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"teamUsers.isUserAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{teamObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(teamObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isUserDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isUserDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isUserDetailsLoaded && !isUserUpdating\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable && userPermissionsObj.UPDATE_USER\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"userObj.id !== authUserObj.id && userPermissionsObj.DELETE_USER\" ng-click=\"fnDeleteUser(userObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"userObj.state === \'ACTIVE\' && userObj.id !== authUserObj.id && userPermissionsObj.UPDATE_USER_STATE\" ng-click=\"userObj.state = \'SUSPENDED\';fnUpdateUserState(userObj)\"><a class=\"btn btn-link\">Suspend</a></li><li ng-if=\"userObj.state === \'SUSPENDED\' && userPermissionsObj.UPDATE_USER_STATE\" ng-click=\"userObj.state = \'ACTIVE\';fnUpdateUserState(userObj)\"><a class=\"btn btn-link\">Activate</a></li><li ng-if=\"userObj.state === \'ACTIVE\'\" ng-click=\"fnResetPassword(userObj)\"><a class=\"btn btn-link\">Reset Password</a></li><li ng-if=\"userObj.state === \'UNCONFIRMED\'\" ng-click=\"resendUserActivationLink(userObj)\"><a class=\"btn btn-link\">Resend Validation Email</a></li></ul></div><div class=\"\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"isUserDetailsLoaded && isUserUpdating\"></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isUserDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\" ng-form=\"userForm\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"firstName\" type=\"text\" ng-model=\"userObj.firstName\" placeholder=\"First name*\" name=\"firstName\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"userForm.firstName.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>First Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"lastName\" type=\"text\" ng-model=\"userObj.lastName\" placeholder=\"Last name*\" name=\"lastName\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"userForm.lastName.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Last Name*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"UserName\" type=\"text\" ng-model=\"userObj.username\" placeholder=\"Username may contain a-z, A-Z, 0-9 and the _ (underscore) characters only and must be unique.*\" name=\"username\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"userForm.username.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Username*</label></div><div class=\"md-input m-b-20 pace\"><input class=\"md-form-control\" required=\"\" id=\"email\" type=\"email\" ng-model=\"userObj.email\" placeholder=\"Email*\" name=\"email\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"userForm.email.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Email*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"bio\" type=\"text\" ng-model=\"userObj.bio\" placeholder=\"Bio\" name=\"bio\"> <span class=\"form-control-feedback inputCheckIcon\" ng-show=\"userForm.bio.$valid && isDetailsEditable\"><i class=\"fa fa-2x fa-check\"></i></span> <span class=\"highlight\"></span> <label>Bio</label></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-if=\"isDetailsEditable && isUpdateCompleted\" ng-disabled=\"!userObj.firstName.length || !userObj.lastName.length || !userObj.username.length || !userObj.email.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateUserBio(userObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/access/vault/vaultInfo/vaultSteps/content/content.html","<div class=\"h-100 contentTemplate\" ng-controller=\"ContentCtrl as content\" ng-init=\"content.fnInitVaultContent()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!content.isVaultContentDetailsLoaded && content.isContentDecrypt\"></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!content.isContentDecrypt\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>The content of the vault is encrypt for your security.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"content.parent.userPermissionsObj.DESCRIBE_VAULT_CONTENT\" ng-click=\"content.fnGetVaultData(content.parent.vaultObj);\">Decrypt My Vault</button></div></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"content.isVaultContentDetailsLoaded && content.isContentDecrypt\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"content.contentKVPArr.length || content.isContentDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"content.isContentDecrypt\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!content.isContentDetailsEditable && content.parent.userPermissionsObj.REPLACE_VAULT_CONTENT\" ng-click=\"content.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"content.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{content.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"content.contentKVPArr.length && !content.isAdvancedOption && content.isContentDecrypt\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"content.contentKVPArr.length\" ng-repeat=\"kvpPair in content.contentKVPArr track by $index\"><div class=\"md-input m-b-20 p-0 p-r-10 col-sm-5\" ng-class=\"!content.isContentDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"key\" type=\"text\" ng-model=\"kvpPair.key\" ng-change=\"content.fnKvpPairChange(kvpPair, $index)\" placeholder=\"Key\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text\"></small></div><div class=\"md-input m-b-20 p-0 col-sm-6\"><strong class=\"md-input-icon\" ng-click=\"content.hideShowPassword(kvpPair)\"><i class=\"fa fa-eye fa-lg m-r-sm\" ng-class=\"kvpPair.inputType === \'password\' ? \'fa-eye\' : \'fa-eye-slash\'\"></i></strong> <input class=\"md-form-control p-r-30\" id=\"value\" type=\"{{kvpPair.inputType}}\" required=\"\" ng-model=\"kvpPair.value\" ng-change=\"content.fnKvpPairChange(kvpPair, $index)\" ng-class=\"!content.isContentDetailsEditable ? \'pace\' : \'\'\" placeholder=\"Value\"> <span class=\"highlight\"></span> <label>Value</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-1\" ng-class=\"!content.isContentDetailsEditable ? \'pace\' : \'\'\"><button ng-if=\"content.isContentDetailsEditable\" class=\"btn btn-link m-t-5\"><i class=\"fa fa-trash-o fa-lg\" ng-click=\"content.fnRemoveContent($index)\"></i></button></div></div></div><div class=\"col-sm-12\" ng-if=\"content.isAdvancedOption && content.isContentDecrypt\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"content.vaultContentObj\" ui-codemirror-opts=\"content.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"content.isContentDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!content.isContentDetailChanging\" ng-click=\"content.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!content.isContentDetailChanging\" ng-click=\"content.fnSaveVaultData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"content.isContentDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{content.parent.vaultObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(content.parent.vaultObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/vault/vaultInfo/vaultSteps/vaultSupplemental/vaultSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"VaultSupplementalCtrl as vaultSupplemental\" ng-init=\"vaultSupplemental.fnInitVaultSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!vaultSupplemental.parent.isVaultDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"vaultSupplemental.parent.isVaultDetailsLoaded\" ng-init=\"vaultSupplemental.fnGetVaultData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"vaultSupplemental.supplementalKVPArr.length || vaultSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"vaultSupplemental.isVaultSupplementalDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!vaultSupplemental.isSupplementalDetailsEditable && vaultSupplemental.parent.userPermissionsObj.REPLACE_VAULT_TAGS\" ng-click=\"vaultSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"vaultSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{vaultSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!vaultSupplemental.supplementalKVPArr.length && !vaultSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"vaultSupplemental.parent.userPermissionsObj.REPLACE_VAULT_TAGS\" ng-click=\"vaultSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"vaultSupplemental.supplementalKVPArr.length && !vaultSupplemental.isAdvancedOption\" ng-class=\"!vaultSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"vaultSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in vaultSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"vaultSupplemental.isKeyDuplicated && $index === vaultSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"vaultSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"vaultSupplemental.isKeyDuplicated && $index === vaultSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"vaultSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"vaultSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"vaultSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"vaultSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"vaultSupplemental.vaultSupplementalObj\" ui-codemirror-opts=\"vaultSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"vaultSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!vaultSupplemental.isSupplementalDetailChanging\" ng-click=\"vaultSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!vaultSupplemental.isSupplementalDetailChanging\" ng-click=\"vaultSupplemental.fnSaveVaultData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"vaultSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{vaultSupplemental.parent.vaultObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(vaultSupplemental.parent.vaultObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/vault/vaultInfo/vaultSteps/vaultTeams/vaultTeams.html","<div id=\"teamsContent\" class=\"h-100\" ng-controller=\"VaultTeamsCtrl as vaultTeams\" ng-init=\"vaultTeams.fnInitVaultTeams()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"vaultTeams.isVaultTeamsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"vaultTeams.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!vaultTeams.isVaultTeamsLoading\" ng-class=\"!vaultTeams.vaultTeamsArr.length ? \'h-100\' : \'\'\"><div class=\"vault-teams-info-table tableContainer\" ng-if=\"vaultTeams.vaultTeamsArr.length\"><table id=\"usergroups-table p-5\" class=\"table table-striped\"><thead><tr><th class=\"p-l-15 p-r-15\" ng-if=\"vaultTeams.vaultTeamsArr.length\">Name</th></tr></thead><tbody><tr ng-repeat=\"group in vaultTeams.vaultTeamsArr track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 p-l-15 p-r-15 p-t-4\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\" ng-click=\"$event.stopPropagation(); vaultTeams.fnGoToTeam(group)\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table></div><div class=\"h-100\" ng-if=\"!vaultTeams.vaultTeamsArr.length\"><div class=\"h-100 d-flex flex-column align-items-center justify-content-center\"><div><label>The Vault has not been added as a resource to any team.</label></div><div><label>To add vault as a resource visit Teams.</label></div><div class=\"m-t-10\"><button class=\"btn btn-primary v4-primary-button\" ui-sref=\"main.teams\">Teams</button></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{vaultObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(vaultObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/ai/deployment/deploymentInfo/deploymentTabs/inferences/inference.html","<div class=\"h-100\" ng-controller=\"InferenceCtrl as inference\" ng-init=\"inference.fnInitInferences()\"><div class=\"content-main\" ng-if=\"!inference.isInferenceCreated\"><div class=\"col-sm-12 m-t-30 floatingLabelInput\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"blueprint\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"typeObj as typeObj.displayName for typeObj in inference.typesArr | filter:{displayName:$viewValue}\" typeahead-min-length=\"0\" typeahead-template-url=\"typeTemplate.html\" ng-model=\"inference.typeObj\" placeholder=\"Select Content Type\"> <span class=\"highlight\"></span> <label>Content Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"inference.typeObj\"><div class=\"col-sm-12\" ng-if=\"inference.typeObj.displayName !== \'Json\'\"><textarea style=\"min-height: 250px; width: 100%\" ng-model=\"inference.inferenceBody\"></textarea></div><div class=\"col-sm-12\" ng-if=\"inference.typeObj.displayName === \'Json\'\"><textarea ui-codemirror=\"\" ng-model=\"inference.jsonInferenceBody\" ui-codemirror-opts=\"inference.jsonEditorOptions\">\n                </textarea></div></div><div class=\"col-sm-12 m-t-10 m-b-10\" ng-if=\"inference.typeObj\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!inference.isInferenceCreating\" ng-disabled=\"inference.fnCheckValidationInference()\" ng-click=\"inference.fnSaveInference()\">Make Inference</button><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"inference.isInferenceCreating\"></div></div></div><div class=\"content-main\" ng-if=\"inference.isInferenceCreated\"><div class=\"col-sm-12\"><textarea ui-codemirror=\"\" class=\"pace\" ng-model=\"inference.inferenceResultBody\" ui-codemirror-opts=\"inference.resultEditorOptions\"></textarea></div><div class=\"col-sm-12 m-t-10 m-b-10\" ng-if=\"inference.typeObj\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"inference.fnResetInference()\">Add another Inference</button></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{deploymentObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deploymentObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem\"></div></div></div></div><script type=\"text/ng-template\" id=\"typeTemplate.html\"><a class=\"p-l-10 p-r-10\"> <div> <div class=\"pull-left m-r-60\"> <span ng-bind-html=\"match.model.displayName\"></span> </div> </div> <br> </a></script>");
$templateCache.put("app/billing/invoice/invoiceInfo/invoiceSteps/invoiceItems/invoiceItems.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitInvoice()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isInvoiceDetailsLoaded\"></div><div class=\"col-sm-12 h-100\" style=\"height: max-content;\" ng-if=\"isInvoiceDetailsLoaded\"><div class=\"col-sm-12 transaction-detail m-t-20\" ng-if=\"invoiceObj.invoiceItems.length\" ng-repeat=\"invoiceItemData in invoiceObj.invoiceItems track by $index\" ng-class=\"$last ? \'m-b-10\' : \'\'\"><div class=\"col-sm-12 p-t-10 p-0\"><div class=\"col-sm-11 p-0\"><span>{{invoiceItemData.description}}</span></div><div class=\"col-sm-1 p-0\"><span class=\"pull-right\"><span><strong>Quantity :{{invoiceItemData.quantity}}</strong></span></span></div></div><div class=\"col-sm-12 p-0 m-t-30 p-b-10 d-flex align-items-center\"><div class=\"col-sm-10 p-0 p-t-4 pull-left\"><span><strong>Discount: {{invoiceItemData.discountPercent ? invoiceItemData.discountPercent : 0}}%</strong></span><br><span><strong>Discount Amount: $ {{(invoiceItemData.discountAmount/100).toFixed(2)}}</strong></span><br><span><strong>Tax: $ {{(invoiceItemData.taxAmount/100).toFixed(2)}}</strong></span><br><span class=\"p-t-2\">{{invoiceItemData.id}}</span></div><div class=\"col-sm-2 p-b-5 p-0 p-t-2 pull-right\"><br><h3 class=\"pull-right\">$ {{(invoiceItemData.totalAmount/100).toFixed(2)}}</h3></div></div></div><div class=\"col-sm-12 m-t-20\" ng-if=\"!invoiceObj.invoiceItems.length\"><h4 class=\"m-t-20 text-center\">No records found...</h4></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{invoiceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(invoiceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/insight/insight_charts/insightChartInfo/insightChartSteps/chartChart/insightChartChart.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightChartChartCtrl as insightChartChart\" ng-init=\"insightChartChart.fnInitChartChart()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightChartChart.isChartDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex\" ng-if=\"insightChartChart.isChartDetailsLoaded\"><div class=\"col-sm-6 p-0\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"insightChartChart.parent.userPermissionsObj.UPDATE_CHART\" ng-click=\"insightChartChart.fnGotoChartEdit()\"><a class=\"btn btn-link\">Edit Chart</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 p-t-10 d-flex align-items-center justify-content-center\" style=\"height: calc(100% - 45px);\" ng-if=\"insightChartChart.isChartDetailsLoaded\"><div id=\"chartPreviewChart\" style=\"height: 50%; width: 50%\" class=\"col-sm-12 p-0 chartPreviewChart\"></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightChartChart.parent.chartObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightChartChart.parent.chartObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_charts/insightChartInfo/insightChartSteps/chartQuery/insightChartQuery.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightChartQueryCtrl as insightChartQuery\" ng-init=\"insightChartQuery.fnInitChartQuery()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightChartQuery.isQueryDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 h-100\" ng-if=\"insightChartQuery.isQueryDetailsLoaded\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"!insightChartQuery.isShowChangeQuery\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"insightChartQuery.fnHideShowChangeQuery()\"><a class=\"btn btn-link\">Change Query</a></li></ul></div></div><div class=\"table-container tableContainer\" ng-if=\"!insightChartQuery.isShowChangeQuery\"><div class=\"insight-sub-chart-queries-table table-container\"><table class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"insightChartQuery.selectedQueryArr.length\">Name</th><th ng-if=\"insightChartQuery.selectedQueryArr.length\">Project</th><th ng-if=\"insightChartQuery.selectedQueryArr.length\"></th><th ng-if=\"insightChartQuery.selectedQueryArr.length\"></th><th ng-if=\"!insightChartQuery.selectedQueryArr.length\">No records found...</th></tr></thead><tbody id=\"queriesTable\"><tr ng-repeat=\"queriesObj in insightChartQuery.selectedQueryArr track by $index\"><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{queriesObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{queriesObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{queriesObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{queriesObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{queriesObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.updatedBy}}</span></small></div></td></tr></tbody></table></div></div><div ng-if=\"insightChartQuery.isShowChangeQuery\"><div class=\"p-t-10 p-b-10\"><label>Change Query</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"insightChartQuery.fnHideShowChangeQuery()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightChartQuery.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightChartQuery.project.name ? insightChartQuery.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightChartQuery.queriesProjectSearch[insightChartQuery.queriesProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightChartQuery.filterProject=(insightChartQuery.projectsArr | filter:insightChartQuery.queriesProjectSearch) track by $index\" ng-click=\"insightChartQuery.fnGetProjectQueries(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightChartQuery.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightChartQuery.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightChartQuery.isRefreshData\" search-identifier=\"\'queriesssearch\'\" filters-arr=\"insightChartQuery.searchFiltersArr\" filter-query=\"insightChartQuery.filterQuery\" fn-filter-query-change=\"insightChartQuery.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_queries\'\" no-set-url=\"true\" fn-resize=\"insightChartQuery.fnSetTableHeight()\" sort-field-arr=\"insightChartQuery.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightChartQuery.isQueriesLoading\" fn-resize=\"insightChartQuery.fnSetLoaderTableHeight()\"></table-loader><div class=\"chart-queries-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!insightChartQuery.isQueriesLoading\"><thead><tr><th ng-if=\"insightChartQuery.queriesArr.length\" class=\"p-8\"></th><th ng-if=\"insightChartQuery.queriesArr.length\">Name</th><th ng-if=\"insightChartQuery.queriesArr.length\">Project</th><th ng-if=\"insightChartQuery.queriesArr.length\"></th><th ng-if=\"insightChartQuery.queriesArr.length\"></th><th ng-if=\"!insightChartQuery.queriesArr.length\">No records found...</th></tr></thead><tbody id=\"queriesTable\"><tr ng-repeat=\"queriesObj in insightChartQuery.queriesArr track by $index\" ng-click=\"queriesObj.isCheck = !queriesObj.isCheck;insightChartQuery.fnCheckUncheckHeader(queriesObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"queriesObj.isCheck\" ng-change=\"insightChartQuery.fnCheckUncheckHeader(queriesObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{queriesObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{queriesObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{queriesObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{queriesObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{queriesObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{queriesObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"queriesObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{queriesObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightChartQuery.isQueriesLoading && insightChartQuery.queriesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightChartQuery.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightChartQuery.perPage = 10; insightChartQuery.fnPageChanged(insightChartQuery.currentPage, insightChartQuery.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightChartQuery.perPage = 20; insightChartQuery.fnPageChanged(insightChartQuery.currentPage, insightChartQuery.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightChartQuery.perPage = 50; insightChartQuery.fnPageChanged(insightChartQuery.currentPage, insightChartQuery.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightChartQuery.perPage = 100; insightChartQuery.fnPageChanged(insightChartQuery.currentPage,insightChartQuery.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightChartQuery.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightChartQuery.currentPage\" items-per-page=\"insightChartQuery.perPage\" max-size=\"insightChartQuery.maxSize\" boundary-links=\"true\" ng-click=\"insightChartQuery.fnPageChanged(insightChartQuery.currentPage, insightChartQuery.perPage)\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!insightChartQuery.isQueryChanging\"><button class=\"btn btn-primary pull-right v4-primary-button\" ng-disabled=\"!insightChartQuery.isQueriesObjSelected()\" ng-click=\"insightChartQuery.fnSaveQuery()\">Change Query</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"insightChartQuery.isQueryChanging\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightChartQuery.parent.chartObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightChartQuery.parent.chartObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_charts/insightChartInfo/insightChartSteps/chartTags/insightChartTags.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightChartTagsCtrl as insightChartTags\" ng-init=\"insightChartTags.fnInitChartSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!insightChartTags.parent.isChartDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"insightChartTags.parent.isChartDetailsLoaded\" ng-init=\"insightChartTags.fnGetChartData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"insightChartTags.supplementalKVPArr.length || insightChartTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!insightChartTags.isSupplementalDetailsEditable && insightChartTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightChartTags.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"insightChartTags.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{insightChartTags.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!insightChartTags.supplementalKVPArr.length && !insightChartTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"insightChartTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightChartTags.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightChartTags.supplementalKVPArr.length && !insightChartTags.isAdvancedOption\" ng-class=\"!insightChartTags.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"insightChartTags.supplementalKVPArr.length\" ng-repeat=\"kvpPair in insightChartTags.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"insightChartTags.isKeyDuplicated && $index === insightChartTags.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightChartTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"insightChartTags.isKeyDuplicated && $index === insightChartTags.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightChartTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"insightChartTags.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"insightChartTags.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"insightChartTags.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"insightChartTags.chartSupplementalObj\" ui-codemirror-opts=\"insightChartTags.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"insightChartTags.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!insightChartTags.isSupplementalDetailChanging\" ng-click=\"insightChartTags.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!insightChartTags.isSupplementalDetailChanging\" ng-click=\"insightChartTags.fnSaveChartData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"insightChartTags.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightChartTags.parent.chartObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightChartTags.parent.chartObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/dashboard/insightDashboardDashboard.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightDashboardDashboardCtrl as insightDashboardDashboard\" ng-init=\"insightDashboardDashboard.fnInitDashboardDashboard()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-0 h-100 insight-dashboard-tab\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightDashboardDashboard.isDashboardDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-t-10 d-flex\" ng-if=\"insightDashboardDashboard.isDashboardDetailsLoaded\"><div class=\"col-sm-6 p-0\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"insightDashboardDashboard.parent.userPermissionsObj.UPDATE_DASHBOARD_CELLS\" ng-click=\"insightDashboardDashboard.fnGotoDashboardEdit()\"><a class=\"btn btn-link\">Edit Dashboard</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-10 d-flex\" ng-if=\"insightDashboardDashboard.isDashboardDetailsLoaded\" style=\"height: calc(100% - 55px);overflow: auto;\"><div class=\"col-sm-12 p-0\" ng-if=\"insightDashboardDashboard.widgets.length\"><div gridstack=\"\" class=\"grid-stack grid1\" options=\"insightDashboardDashboard.options\" on-change=\"insightDashboardDashboard.onChange(event,items)\"><div gridstack-item=\"\" ng-repeat=\"w in insightDashboardDashboard.widgets track by $index\" class=\"grid-stack-item\" gs-item-x=\"w.x\" gs-item-y=\"w.y\" gs-item-width=\"w.width\" gs-item-height=\"w.height\" gs-item-autopos=\"1\"><div class=\"grid-stack-item-content\"><div class=\"col-sm-12 p-15 h-100 dashboard-panel dashboard-panel-chart-widget\" style=\"height: 100%\" ng-if=\"w.widget.chart.syntax === \'HIGHCHARTS\'\"><div class=\"col-sm-12 p-0\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!w.widget.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!w.widget.layout && !w.widget.layout.icon && !w.widget.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"w.widget.layout && w.widget.layout.icon && w.widget.layout.icon.length\" ng-bind-html=\"insightDashboardDashboard.deliberatelyTrustDangerousSnippet(w.widget.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{w.widget.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"w.widget.layout.isExport !== false\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in w.widget.layout.exportOptions track by $index\" ng-click=\"insightDashboardDashboard.fnExportChart(exportOption.action, \'accessDashboardWidgets\'+$index)\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"w.widget.layout.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 chart-height\" ng-class=\"w.widget.layout.buttonLink.length ? \'widget-with-button\':\'widget-without-button\'\" ng-if=\"w.widget.chart.query.results.data\"><dashboard-pie-chart ng-if=\"w.widget.chart.query.results.data.length\" is-for-csv-chart=\"true\" chart-id=\"\'insightDashboardWidgets\'+$index\" chart-data=\"w.widget.chart.definition.chartConfig\" name=\"\'Users\'\"></dashboard-pie-chart><div class=\"h-100 d-flex flex-column justify-content-center align-items-center dashboard-img-not-found\" ng-if=\"!w.widget.chart.query.results.data.length\" style=\"opacity: 0.5\"><svg style=\"height: 70px;width: 70px;\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div><div class=\"col-sm-12 p-0 dashboard-pie-chart-img chart-height\" ng-if=\"!w.widget.chart.query.results.data\"><svg class=\"p-t-40 p-b-40\" style=\"height: inherit;width: inherit;\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\" ng-if=\"w.widget.layout.buttonLink.length && w.widget.layout.buttonLink.length\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"insightDashboardDashboard.fnGotoLink(w.widget.layout.buttonLink, w.widget.layout.target)\">{{w.widget.layout.buttonText}}</button></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightDashboardDashboard.parent.dashboardObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightDashboardDashboard.parent.dashboardObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_dashboards/insightDashboardInfo/insightDashboardSteps/dashboardTags/insightDashboardTags.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightDashboardTagsCtrl as insightDashboardTags\" ng-init=\"insightDashboardTags.fnInitDashboardSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!insightDashboardTags.parent.isDashboardDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"insightDashboardTags.parent.isDashboardDetailsLoaded\" ng-init=\"insightDashboardTags.fnGetDashboardData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"insightDashboardTags.supplementalKVPArr.length || insightDashboardTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!insightDashboardTags.isSupplementalDetailsEditable && insightDashboardTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightDashboardTags.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"insightDashboardTags.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{insightDashboardTags.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!insightDashboardTags.supplementalKVPArr.length && !insightDashboardTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"insightDashboardTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightDashboardTags.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightDashboardTags.supplementalKVPArr.length && !insightDashboardTags.isAdvancedOption\" ng-class=\"!insightDashboardTags.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"insightDashboardTags.supplementalKVPArr.length\" ng-repeat=\"kvpPair in insightDashboardTags.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"insightDashboardTags.isKeyDuplicated && $index === insightDashboardTags.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightDashboardTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"insightDashboardTags.isKeyDuplicated && $index === insightDashboardTags.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightDashboardTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"insightDashboardTags.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"insightDashboardTags.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"insightDashboardTags.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"insightDashboardTags.dashboardSupplementalObj\" ui-codemirror-opts=\"insightDashboardTags.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"insightDashboardTags.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!insightDashboardTags.isSupplementalDetailChanging\" ng-click=\"insightDashboardTags.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!insightDashboardTags.isSupplementalDetailChanging\" ng-click=\"insightDashboardTags.fnSaveDashboardData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"insightDashboardTags.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightDashboardTags.parent.dashboardObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightDashboardTags.parent.dashboardObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_project/insightProjectInfo/insightProjectSteps/projectTags/insightProjectTags.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightProjectTagsCtrl as insightProjectTags\" ng-init=\"insightProjectTags.fnInitProjectSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!insightProjectTags.parent.isProjectDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"insightProjectTags.parent.isProjectDetailsLoaded\" ng-init=\"insightProjectTags.fnGetProjectData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"insightProjectTags.supplementalKVPArr.length || insightProjectTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!insightProjectTags.isSupplementalDetailsEditable && insightProjectTags.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"insightProjectTags.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"insightProjectTags.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{insightProjectTags.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!insightProjectTags.supplementalKVPArr.length && !insightProjectTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"insightProjectTags.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"insightProjectTags.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightProjectTags.supplementalKVPArr.length && !insightProjectTags.isAdvancedOption\" ng-class=\"!insightProjectTags.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"insightProjectTags.supplementalKVPArr.length\" ng-repeat=\"kvpPair in insightProjectTags.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"insightProjectTags.isKeyDuplicated && $index === insightProjectTags.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightProjectTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"insightProjectTags.isKeyDuplicated && $index === insightProjectTags.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightProjectTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"insightProjectTags.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"insightProjectTags.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"insightProjectTags.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"insightProjectTags.projectSupplementalObj\" ui-codemirror-opts=\"insightProjectTags.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"insightProjectTags.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!insightProjectTags.isSupplementalDetailChanging\" ng-click=\"insightProjectTags.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!insightProjectTags.isSupplementalDetailChanging\" ng-click=\"insightProjectTags.fnSaveProjectData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"insightProjectTags.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightProjectTags.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightProjectTags.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_queries/insightQueryInfo/insightQuerySteps/query/insightQuery.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightQueryCtrl as insightQuery\" ng-init=\"insightQuery.fnInitQuery()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightQuery.parent.isQueryDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-t-20 h-100\" ng-if=\"insightQuery.parent.isQueryDetailsLoaded\" ng-init=\"insightQuery.fnGetQuery()\"><div class=\"col-sm-12 p-0 floatingLabelInput custom-sql-editor\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"insightQuery.isQuerySearchDataLoading\" ng-click=\"insightQuery.fnRunQuery()\">Run Query</button> <button class=\"btn btn-primary m-r-7 text-white\" ng-disabled=\"insightQuery.isAdvanceSearchDataLoading\" ng-click=\"insightQuery.fnFormatSQL()\">Format Query</button></div><div class=\"col-sm-12 p-0 p-t-10 m-b-20\"><span>QUERY</span><div class=\"m-b-20 editorMedium\"><javascript-editor value=\"insightQuery.queryConfig.value\" available-defs=\"insightQuery.availableDataLibs\" editor-value=\"insightQuery.queryConfig.editorValue\" read-only=\"!insightQuery.isQuerySearchDataLoading\" is-mode-sql=\"true\"></javascript-editor></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"!insightQuery.isQueryChanging\" ng-disabled=\"insightQuery.isAdvanceSearchDataLoading\" ng-click=\"insightQuery.fnSaveQuery()\">Save Query</button><div class=\"pull-right\" ng-if=\"insightQuery.isQueryChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightQuery.isQuerySearchDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" style=\"overflow-x: auto\" ng-if=\"!insightQuery.isQuerySearchDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"insightQuery.querySearchData.data.length\"><table class=\"table user-query-table\"><thead><tr><td ng-repeat=\"header in insightQuery.querySearchDataHeader\" style=\"vertical-align: top\"><label class=\"m-b-0 p-r-15\">{{header}}</label></td></tr></thead><tbody><tr ng-repeat=\"data in insightQuery.querySearchData.data\"><td ng-repeat=\"header in insightQuery.querySearchDataHeader\" class=\"p-r-15\" style=\"vertical-align: top\" ng-style=\"insightQuery.fnGetTdStyle(data[header])\"><span class=\"ellipsis\" ng-if=\"insightQuery.fnGetType(data[header]) === \'string\'\">\'{{data[header]}}\'</span> <span class=\"ellipsis\" ng-if=\"insightQuery.fnGetType(data[header]) !== \'string\' && insightQuery.fnGetType(data[header]) !== \'object\'\">{{data[header]}}</span><json-formatter ng-if=\"insightQuery.fnGetType(data[header]) === \'object\' && insightQuery.fnGetType(data[header]) !== \'null\'\" json=\"data[header]\" open=\"0\"></json-formatter></td></tr></tbody></table></div><div class=\"col-sm-12 p-0\" ng-if=\"!insightQuery.querySearchData.data.length\">No records found...</div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightQuery.parent.queryObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightQuery.parent.queryObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_queries/insightQueryInfo/insightQuerySteps/queryTags/queryTags.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightQueryTagsCtrl as insightQueryTags\" ng-init=\"insightQueryTags.fnInitQuerySupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!insightQueryTags.parent.isQueryDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"insightQueryTags.parent.isQueryDetailsLoaded\" ng-init=\"insightQueryTags.fnGetQueryData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"insightQueryTags.supplementalKVPArr.length || insightQueryTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!insightQueryTags.isSupplementalDetailsEditable && insightQueryTags.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"insightQueryTags.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"insightQueryTags.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{insightQueryTags.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!insightQueryTags.supplementalKVPArr.length && !insightQueryTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"insightQueryTags.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"insightQueryTags.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightQueryTags.supplementalKVPArr.length && !insightQueryTags.isAdvancedOption\" ng-class=\"!insightQueryTags.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"insightQueryTags.supplementalKVPArr.length\" ng-repeat=\"kvpPair in insightQueryTags.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"insightQueryTags.isKeyDuplicated && $index === insightQueryTags.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightQueryTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"insightQueryTags.isKeyDuplicated && $index === insightQueryTags.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightQueryTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"insightQueryTags.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"insightQueryTags.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"insightQueryTags.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"insightQueryTags.querySupplementalObj\" ui-codemirror-opts=\"insightQueryTags.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"insightQueryTags.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!insightQueryTags.isSupplementalDetailChanging\" ng-click=\"insightQueryTags.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!insightQueryTags.isSupplementalDetailChanging\" ng-click=\"insightQueryTags.fnSaveQueryData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"insightQueryTags.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightQueryTags.parent.queryObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightQueryTags.parent.queryObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetChart/insightWidgetChart.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightWidgetChartCtrl as insightWidgetChart\" ng-init=\"insightWidgetChart.fnInitChartChart()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightWidgetChart.isChartDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 h-100\" ng-if=\"insightWidgetChart.isChartDetailsLoaded\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"!insightWidgetChart.isShowChangeChart\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"insightWidgetChart.fnHideShowChangeChart()\"><a class=\"btn btn-link\">Change Chart</a></li></ul></div></div><div class=\"table-container tableContainer\" ng-if=\"!insightWidgetChart.isShowChangeChart\"><div class=\"insight-sub-widget-chart-table table-container\"><table class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"insightWidgetChart.selectedChartArr.length\">Name</th><th ng-if=\"insightWidgetChart.selectedChartArr.length\">Project</th><th ng-if=\"insightWidgetChart.selectedChartArr.length\"></th><th ng-if=\"insightWidgetChart.selectedChartArr.length\"></th><th ng-if=\"!insightWidgetChart.selectedChartArr.length\">No records found...</th></tr></thead><tbody id=\"chartsTable\"><tr ng-repeat=\"chartsObj in insightWidgetChart.selectedChartArr track by $index\"><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{chartsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{chartsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{chartsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{chartsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{chartsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.updatedBy}}</span></small></div></td></tr></tbody></table></div></div><div ng-if=\"insightWidgetChart.isShowChangeChart\"><div class=\"p-t-10 p-b-10\"><label>Change Chart</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"insightWidgetChart.fnHideShowChangeChart()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 p-0 d-flex issueDropDown\"><div class=\"d-flex m-r-10 customDropdown floatingLabelInput\" style=\"width:125px\"><div class=\"btn-group p-0\" style=\"width:125px\" ng-class=\"insightWidgetChart.isProjectLoaded === false ? \'pace opacity-5\':\'\'\" uib-dropdown=\"\" auto-close=\"outsideClick\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary issue-project-dropdown-menu p-b-5\" uib-dropdown-toggle=\"\"><span class=\"p-r-10 ellipsis\">{{insightWidgetChart.project.name ? insightWidgetChart.project.name : \"All\"}}</span> <label class=\"titleLabel\">Project*</label> <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\" class=\"dropdown-menu dropdown-menu-no-max-height sub-dropdown\"><li><div class=\"md-input m-0 m-t-8 m-l-24 m-r-24\"><input class=\"md-form-control\" type=\"text\" placeholder=\"Search\" ng-model=\"insightWidgetChart.chartsProjectSearch[insightWidgetChart.chartsProjectFilter]\"> <span class=\"highlight\"></span> <label>Search</label></div></li><li class=\"divider\"></li><li class=\"d-flex\"><ul class=\"dropdown-menu m-0 w100 sub-dropdown-menu position-r\"><li ng-repeat=\"projectObj in insightWidgetChart.filterProject=(insightWidgetChart.projectsArr | filter:insightWidgetChart.chartsProjectSearch) track by $index\" ng-click=\"insightWidgetChart.fnGetProjectCharts(projectObj)\"><a class=\"d-flex align-items-center\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"projectObj.id === insightWidgetChart.project.id\"></i></span> <span>{{projectObj.name}}</span></a></li><li ng-if=\"!insightWidgetChart.filterProject.length\"><a>No matching results</a></li></ul></li></ul></div></div><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client ng-if=\"insightWidgetChart.isRefreshData\" search-identifier=\"\'chartsssearch\'\" filters-arr=\"insightWidgetChart.searchFiltersArr\" filter-query=\"insightWidgetChart.filterQuery\" fn-filter-query-change=\"insightWidgetChart.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.insight_charts\'\" no-set-url=\"true\" fn-resize=\"insightWidgetChart.fnSetTableHeight()\" sort-field-arr=\"insightWidgetChart.sortFieldArr\"></v4-search-client></div><div class=\"m-l-5\"></div></div><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"insightWidgetChart.isChartsLoading\" fn-resize=\"insightWidgetChart.fnSetLoaderTableHeight()\"></table-loader><div class=\"widget-charts-table table-container\"><table class=\"table table-striped table-check-box\" ng-if=\"!insightWidgetChart.isChartsLoading\"><thead><tr><th ng-if=\"insightWidgetChart.chartsArr.length\" class=\"p-8\"></th><th ng-if=\"insightWidgetChart.chartsArr.length\">Name</th><th ng-if=\"insightWidgetChart.chartsArr.length\">Project</th><th ng-if=\"insightWidgetChart.chartsArr.length\"></th><th ng-if=\"insightWidgetChart.chartsArr.length\"></th><th ng-if=\"!insightWidgetChart.chartsArr.length\">No records found...</th></tr></thead><tbody id=\"chartsTable\"><tr ng-repeat=\"chartsObj in insightWidgetChart.chartsArr track by $index\" ng-click=\"chartsObj.isCheck = !chartsObj.isCheck;insightWidgetChart.fnCheckUncheckHeader(chartsObj);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"chartsObj.isCheck\" ng-change=\"insightWidgetChart.fnCheckUncheckHeader(chartsObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{chartsObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{chartsObj.description}}</span></div></td><td><div class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex m-r-5\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/project.svg#project\"></use></svg></div><div class=\"d-flex projectTitleWidth\"><label class=\"ellipsis m-b-0\">{{chartsObj.project.name}}</label></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdAt\"><label class=\"ellipsis m-b-0\">Created {{chartsObj.createdDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.createdBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.createdBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.createdBy}}</span></small></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedDate}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedAt\"><label class=\"ellipsis m-b-0\">Last updated {{chartsObj.updatedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{chartsObj.updatedBy}}\" tooltip-placement=\"auto\" ng-if=\"chartsObj.updatedBy\"><small class=\"w100\"><span class=\"ellipsis DescriptionText span_des font-italic\">by {{chartsObj.updatedBy}}</span></small></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!insightWidgetChart.isChartsLoading && insightWidgetChart.chartsArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{insightWidgetChart.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"insightWidgetChart.perPage = 10; insightWidgetChart.fnPageChanged(insightWidgetChart.currentPage, insightWidgetChart.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgetChart.perPage = 20; insightWidgetChart.fnPageChanged(insightWidgetChart.currentPage, insightWidgetChart.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgetChart.perPage = 50; insightWidgetChart.fnPageChanged(insightWidgetChart.currentPage, insightWidgetChart.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"insightWidgetChart.perPage = 100; insightWidgetChart.fnPageChanged(insightWidgetChart.currentPage,insightWidgetChart.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"insightWidgetChart.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"insightWidgetChart.currentPage\" items-per-page=\"insightWidgetChart.perPage\" max-size=\"insightWidgetChart.maxSize\" boundary-links=\"true\" ng-click=\"insightWidgetChart.fnPageChanged(insightWidgetChart.currentPage, insightWidgetChart.perPage)\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!insightWidgetChart.isChartChanging\"><button class=\"btn btn-primary pull-right v4-primary-button\" ng-disabled=\"!insightWidgetChart.isChartsObjSelected()\" ng-click=\"insightWidgetChart.fnSaveChart()\">Change Chart</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"insightWidgetChart.isChartChanging\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightWidgetChart.parent.widgetObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightWidgetChart.parent.widgetObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetTags/insightWidgetTags.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightWidgetTagsCtrl as insightWidgetTags\" ng-init=\"insightWidgetTags.fnInitWidgetSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!insightWidgetTags.parent.isWidgetDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"insightWidgetTags.parent.isWidgetDetailsLoaded\" ng-init=\"insightWidgetTags.fnGetWidgetData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"insightWidgetTags.supplementalKVPArr.length || insightWidgetTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!insightWidgetTags.isSupplementalDetailsEditable && insightWidgetTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightWidgetTags.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"insightWidgetTags.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{insightWidgetTags.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!insightWidgetTags.supplementalKVPArr.length && !insightWidgetTags.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"insightWidgetTags.parent.userPermissionsObj.REPLACE_CHART_TAGS\" ng-click=\"insightWidgetTags.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightWidgetTags.supplementalKVPArr.length && !insightWidgetTags.isAdvancedOption\" ng-class=\"!insightWidgetTags.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"insightWidgetTags.supplementalKVPArr.length\" ng-repeat=\"kvpPair in insightWidgetTags.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"insightWidgetTags.isKeyDuplicated && $index === insightWidgetTags.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightWidgetTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"insightWidgetTags.isKeyDuplicated && $index === insightWidgetTags.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"insightWidgetTags.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"insightWidgetTags.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"insightWidgetTags.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"insightWidgetTags.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"insightWidgetTags.widgetSupplementalObj\" ui-codemirror-opts=\"insightWidgetTags.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"insightWidgetTags.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!insightWidgetTags.isSupplementalDetailChanging\" ng-click=\"insightWidgetTags.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!insightWidgetTags.isSupplementalDetailChanging\" ng-click=\"insightWidgetTags.fnSaveWidgetData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"insightWidgetTags.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightWidgetTags.parent.widgetObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightWidgetTags.parent.widgetObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/insight/insight_widgets/insightWidgetInfo/insightWidgetSteps/widgetWidget/insightWidgetWidget.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"InsightWidgetWidgetCtrl as insightWidgetWidget\" ng-init=\"insightWidgetWidget.fnInitWidgetWidget()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!insightWidgetWidget.isWidgetDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 d-flex p-0 p-t-10\" ng-if=\"insightWidgetWidget.isWidgetDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"insightWidgetWidget.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"insightWidgetWidget.isWidgetDetailsLoaded\" style=\"height: calc(100% - 45px);overflow: auto;\"><div class=\"col-sm-12 p-0\" ng-if=\"insightWidgetWidget.isDetailsEditable\"><div class=\"col-sm-8 p-0 m-t-20\"><div class=\"col-sm-12 floatingLabelInput m-t-10 p-l-0\" ng-class=\"!insightWidgetWidget.isDetailsEditable ? \'pace\' : \'\'\"><form role=\"form\" autocomplete=\"off\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"title!\" type=\"text\" autocomplete=\"off\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.title\" placeholder=\"Title*\" name=\"title\"> <span class=\"highlight\"></span> <label>Title*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-30 customDropdown\" ng-if=\"!insightWidgetWidget.isPasteSVGCode\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" style=\"height: 43px;\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 svgTags\" style=\"height: 20px;width: 20px\" ng-bind-html=\"insightWidgetWidget.deliberatelyTrustDangerousSnippet(insightWidgetWidget.selectWidgetObj.layout.icon)\"></span> <label class=\"titleLabel\">ICON*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"min-width: 250px;\"><li ng-repeat=\"svgObj in insightWidgetWidget.svgArr track by $index\" ng-mousedown=\"insightWidgetWidget.fnSelectIcon(svgObj)\"><a><span>{{svgObj.title}}</span> <span class=\"pull-right pull-right font-italic m-t-2\" ng-bind-html=\"insightWidgetWidget.deliberatelyTrustDangerousSnippet(svgObj.iconURL)\"></span></a></li></ul></div><button class=\"btn-link p-0\" style=\"position: absolute;right: 0;top: 43px;\" ng-click=\"insightWidgetWidget.fnEditSVGCode()\">Paste SVG code</button></div><div class=\"md-input m-b-20\" ng-if=\"insightWidgetWidget.isPasteSVGCode\"><input class=\"md-form-control\" required=\"\" id=\"icon1\" type=\"text\" autocomplete=\"off\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.icon\" placeholder=\"Icon*\" name=\"icon\"> <span class=\"highlight\"></span> <label>Icon*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonText\" type=\"text\" autocomplete=\"off\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.buttonText\" placeholder=\"Button Text\" name=\"actionButtonText\"> <span class=\"highlight\"></span> <label>Button Text</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"actionButtonLink\" type=\"text\" autocomplete=\"off\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.buttonLink\" placeholder=\"Button Link\" name=\"actionButtonLink\"> <span class=\"highlight\"></span> <label>Button Link</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"insightWidgetWidget.selectWidgetObj.layout.target\">{{insightWidgetWidget.selectWidgetObj.layout.target}}</span> <label class=\"titleLabel\">TARGET</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"emailKeys\"><li role=\"menuitem\"><a ng-click=\"insightWidgetWidget.selectWidgetObj.layout.target = \'New Window\'\">New Window</a></li><li role=\"menuitem\"><a ng-click=\"insightWidgetWidget.selectWidgetObj.layout.target = \'Same Window\'\">Same Window</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5 p-b-15\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_export\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.isExport\"> <label for=\"chk_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export</div></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isExport\"><div class=\"col-sm-12 p-0 m-t-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 font-italic opacity-5\">Chart export options</span> <label class=\"titleLabel\">Chart Export Options</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in insightWidgetWidget.selectWidgetObj.layout.exportOptions track by $index\"><a class=\"d-flex align-items-center\" ng-click=\"$event.stopPropagation();exportOption.isAllow = !exportOption.isAllow\"><span class=\"m-r-5\" style=\"width: 20px;\"><i class=\"fa fa-check\" ng-if=\"exportOption.isAllow\"></i></span> <span>{{exportOption.name}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center p-t-5\" ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isExport\"><div class=\"d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_tracker_export\" ng-model=\"insightWidgetWidget.selectWidgetObj.layout.isTrackerExport\"> <label for=\"chk_tracker_export\" class=\"check-box\"></label></div><div class=\"d-flex align-items-center p-l-10\">Allow Chart Export To Tracker</div></div></form></div></div><div class=\"col-sm-4 p-r-0\"><div class=\"col-sm-12 p-0 m-b-10\"><h1>Preview</h1></div><div class=\"col-sm-12 p-0 d-flex min-height-300\"><div class=\"custom-widget width-inherit border-0\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!insightWidgetWidget.selectWidgetObj.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!insightWidgetWidget.selectWidgetObj && !insightWidgetWidget.selectWidgetObj.layout.icon && !insightWidgetWidget.selectWidgetObj.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"insightWidgetWidget.selectWidgetObj && insightWidgetWidget.selectWidgetObj.layout.icon && insightWidgetWidget.selectWidgetObj.layout.icon.length\" ng-bind-html=\"insightWidgetWidget.deliberatelyTrustDangerousSnippet(insightWidgetWidget.selectWidgetObj.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{insightWidgetWidget.selectWidgetObj.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isExport\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in insightWidgetWidget.selectWidgetObj.layout.exportOptions track by $index\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center\" style=\"height: 250px;width: 100%\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"insightWidgetWidget.previewWidgetChartData\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'previewWidgetChart\'\" chart-data=\"insightWidgetWidget.previewWidgetChartData\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!insightWidgetWidget.previewWidgetChartData\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end\"><button ng-if=\"insightWidgetWidget.selectWidgetObj.layout.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{insightWidgetWidget.selectWidgetObj.layout.buttonText}}</button></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-10\" ng-if=\"insightWidgetWidget.isDetailsEditable\"><button ng-if=\"insightWidgetWidget.isDetailsEditable && insightWidgetWidget.isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"insightWidgetWidget.fnResetDetails()\">Cancel</button> <button ng-if=\"insightWidgetWidget.isDetailsEditable && insightWidgetWidget.isUpdateCompleted\" ng-disabled=\"!insightWidgetWidget.selectWidgetObj.layout.title.length || !insightWidgetWidget.selectWidgetObj.layout.icon.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"insightWidgetWidget.fnUpdateWidgetInfo()\">Save Changes</button><div class=\"col-sm-12 p-0\" ng-if=\"!insightWidgetWidget.isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center h-100\" ng-if=\"!insightWidgetWidget.isDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex\" style=\"height: 70%;width: 70%\"><div class=\"custom-widget border-0 w100 h-100 d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex w100\"><div class=\"d-flex align-items-center\" ng-class=\"!insightWidgetWidget.selectWidgetObj.layout.isExport ? \'w100\':\'widget-title-width\'\"><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" ng-if=\"!insightWidgetWidget.selectWidgetObj && !insightWidgetWidget.selectWidgetObj.layout.icon && !insightWidgetWidget.selectWidgetObj.layout.icon.length\" height=\"20px\"><use xlink:href=\"assets/images/svg/dashboard.svg#Capa_1\"></use></svg><div class=\"custom-svg-icon m-r-5\" ng-if=\"insightWidgetWidget.selectWidgetObj && insightWidgetWidget.selectWidgetObj.layout.icon && insightWidgetWidget.selectWidgetObj.layout.icon.length\" ng-bind-html=\"insightWidgetWidget.deliberatelyTrustDangerousSnippet(insightWidgetWidget.selectWidgetObj.layout.icon)\"></div><label class=\"m-0 font-size-19 ellipsis\">{{insightWidgetWidget.selectWidgetObj.layout.title}}</label></div><div class=\"d-flex align-items-center\" ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isExport\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li role=\"menuitem\" ng-repeat=\"exportOption in insightWidgetWidget.selectWidgetObj.layout.exportOptions track by $index\" ng-if=\"exportOption.isAllow\"><a>{{exportOption.name}}</a></li><li ng-if=\"insightWidgetWidget.selectWidgetObj.layout.isTrackerExport\"><a>Create Issue</a></li></ul></div></div></div></div><div class=\"d-flex p-0 justify-content-space-around\" ng-style=\"insightWidgetWidget.selectWidgetObj.layout.buttonText.length ? {\'height\': \'calc(100% - 61px)\'} : {\'height\': \'calc(100% - 27px)\'}\"><div class=\"p-0 d-flex flex-column justify-content-center align-items-center w100 h-100\"><div class=\"p-t-0 width-inherit\" style=\"height: inherit;\" ng-if=\"insightWidgetWidget.previewWidgetChartData\"><dashboard-pie-chart is-for-csv-chart=\"true\" chart-id=\"\'previewWidgetChart\'\" chart-data=\"insightWidgetWidget.previewWidgetChartData\" name=\"\'Users\'\"></dashboard-pie-chart></div><svg class=\"dashboard-pie-chart-img p-t-40 p-b-40 width-inherit\" style=\"height: inherit;\" ng-if=\"!insightWidgetWidget.previewWidgetChartData\"><use xlink:href=\"assets/images/svg/dashboard-pie-chart.svg#dashboard_pie\"></use></svg></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-flex-end align-items-center\"><button ng-if=\"insightWidgetWidget.selectWidgetObj.layout.buttonText.length\" class=\"btn btn-primary v4-primary-button\">{{insightWidgetWidget.selectWidgetObj.layout.buttonText}}</button></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{insightWidgetWidget.parent.widgetObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(insightWidgetWidget.parent.widgetObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/alarmHistory/alarmHistoryInfo/alarmHistorySteps/alarmHistoryAttributes/alarmHistoryAttributes.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"AlarmHistoryAttributesCtrl as alarmHistoryAttribute\" ng-init=\"alarmHistoryAttribute.fnInitAlarmAttributes()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!alarmHistoryAttribute.parent.isAlarmDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-15 h-100\" ng-if=\"alarmHistoryAttribute.parent.isAlarmDetailsLoaded\" ng-init=\"alarmHistoryAttribute.fnGetAttributeInfo()\"><div class=\"p-0 h-100 border-1px\" ng-class=\"alarmHistoryAttribute.isFullWidthDevice ? \'col-sm-3\':\'col-sm-4\'\"><div class=\"col-sm-12 p-0 local-search-bar-container\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'nodeAttributeSearch\'\" filters-arr=\"alarmHistoryAttribute.searchFiltersArr\" filter-query=\"alarmHistoryAttribute.filterQuery\" fn-filter-query-change=\"alarmHistoryAttribute.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.alarmHistory\'\" no-set-url=\"true\" fn-resize=\"alarmHistoryAttribute.fnSetTableHeight()\" sort-field-arr=\"alarmHistoryAttribute.sortFieldArr\" default-tag-arr=\"alarmHistoryAttribute.defaultAttributeFilterArr\" table-alias=\"alarmHistoryAttribute.tableAlias\"></v4-search-client></div></div><div class=\"col-sm-12 p-0 overflow-auto\" ng-class=\"alarmHistoryAttribute.isShowPaginationContainer ? \'attribute-list-with-pagination-container\':\'attribute-list-container\'\"><div class=\"col-sm-12 p-0\" ng-if=\"alarmHistoryAttribute.isAttributesLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!alarmHistoryAttribute.isAttributesLoading\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in alarmHistoryAttribute.attributesList track by $index\" ng-click=\"alarmHistoryAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 type-icon\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 alarm-icon\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" context-menu=\"alarmHistoryAttribute.attributeValueContextMenu(attributeObj)\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 health-btn\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmHistoryAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center attr-name-value-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\" context-menu=\"alarmHistoryAttribute.attributeNameContextMenu(attributeObj)\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end\"><h3 class=\"ellipsis m-0 text-right\" ng-if=\"(attributeObj.value && attributeObj.value.length) || (attributeObj.read && attributeObj.read.unit.length)\" uib-tooltip=\"{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}\" tooltip-placement=\"auto\">{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}</h3></div></div></div></div><div class=\"col-sm-12 p-t-8 p-b-8\" ng-if=\"!alarmHistoryAttribute.attributesList.length\"><span class=\"ellipsis font-bold\">No matching results</span></div></div></div><div class=\"col-sm-12 p-t-10\"><div class=\"pagination-container\" ng-show=\"!alarmHistoryAttribute.isAttributesLoading && alarmHistoryAttribute.attributesList.length && alarmHistoryAttribute.isShowPaginationContainer\"><div class=\"row\"><div class=\"col-sm-4 p-r-0 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{alarmHistoryAttribute.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"alarmHistoryAttribute.perPage = 10; alarmHistoryAttribute.fnPageChanged(alarmHistoryAttribute.currentPage, alarmHistoryAttribute.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistoryAttribute.perPage = 20; alarmHistoryAttribute.fnPageChanged(alarmHistoryAttribute.currentPage, alarmHistoryAttribute.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistoryAttribute.perPage = 50; alarmHistoryAttribute.fnPageChanged(alarmHistoryAttribute.currentPage, alarmHistoryAttribute.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmHistoryAttribute.perPage = 100; alarmHistoryAttribute.fnPageChanged(alarmHistoryAttribute.currentPage,alarmHistoryAttribute.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-8 p-l-0 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"alarmHistoryAttribute.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"alarmHistoryAttribute.currentPage\" items-per-page=\"alarmHistoryAttribute.perPage\" max-size=\"alarmHistoryAttribute.maxSize\" boundary-links=\"true\" ng-click=\"alarmHistoryAttribute.fnPageChanged(alarmHistoryAttribute.currentPage, alarmHistoryAttribute.perPage)\"></ul></div></div></div></div></div></div><div class=\"p-r-0 h-100\" ng-class=\"alarmHistoryAttribute.isFullWidthDevice ? \'col-sm-2\':\'col-sm-3\'\"><div class=\"col-sm-12 p-0 attr-selected-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Selected</h3></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"alarmHistoryAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"selectedAttrObj in alarmHistoryAttribute.selectedAttrKeyArr\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">{{selectedAttrObj.name}}:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\'\"><strong>{{alarmHistoryAttribute.selectedAttribute[selectedAttrObj.key]}}</strong></label> <label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Units\'\"><strong>{{alarmHistoryAttribute.selectedAttribute.read.unit}}</strong></label><div class=\"d-flex align-items-center w100\" ng-if=\"selectedAttrObj.name === \'Health\'\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{alarmHistoryAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmHistoryAttribute.fnGetHealthColor(alarmHistoryAttribute.selectedAttribute[selectedAttrObj.key], alarmHistoryAttribute.selectedAttribute)\"></button><div class=\"d-flex align-items-center selected-attr-health-text\"><label class=\"ellipsis m-0 p-l-5\"><strong>{{alarmHistoryAttribute.selectedAttribute.healthName}}</strong></label></div></div><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Alarm\'\"><strong>{{alarmHistoryAttribute.selectedAttribute.reference.endsWith(\'!\') ? \'true\': \'false\'}}</strong></label><div ng-if=\"selectedAttrObj.name === \'Type\'\"><div class=\"p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'INT32\' || alarmHistoryAttribute.selectedAttribute.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'DATE\' || alarmHistoryAttribute.selectedAttribute.read.type === \'TIME\' || alarmHistoryAttribute.selectedAttribute.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"alarmHistoryAttribute.selectedAttribute.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\' && selectedAttrObj.name !== \'Node\'\"><i class=\"m-l-5 fa\" ng-click=\"alarmHistoryAttribute.fnSelectedAttributeCopyToClipboard(selectedAttrObj.key,alarmHistoryAttribute.selectedAttribute)\" ng-class=\"!alarmHistoryAttribute.selectedAttribute[selectedAttrObj.key+ \'IsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name === \'Node\'\"><i class=\"m-l-5 fa fa-external-link\" ng-click=\"alarmHistoryAttribute.fnOpenNodeInfo();\"></i></div></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotable-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plottable</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotable-container-body\" ng-if=\"alarmHistoryAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"plotableObj in alarmHistoryAttribute.plotableArr\" dnd-list=\"\" dnd-draggable=\"alarmHistoryAttribute.selectedAttribute\" dnd-callback=\"alarmHistoryAttribute.fnOnActionDrop(alarmHistoryAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': alarmHistoryAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!alarmHistoryAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotted-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plotted</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotted-container-body\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in alarmHistoryAttribute.selectedChartData track by $index\" ng-click=\"alarmHistoryAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex plotted-icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\" uib-tooltip=\"Alarm Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" uib-tooltip=\"RW Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmHistoryAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center plotted-attr-name-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex\"><label class=\"ellipsis m-0\"><strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeValue\'\">[AV]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeHealth\'\">[AH]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeValue\'\">[FV]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeHealth\'\">[FH]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeValue\'\">[VA]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeHealth\'\">[HA]</strong></label></div></div></div><div class=\"d-flex align-items-center w-15-px\"><div class=\"d-flex align-items-center w-15-px\"><i class=\"m-l-5 fa fa-trash-o\" ng-click=\"alarmHistoryAttribute.fnRemoveChartData(attributeObj)\"></i></div></div></div></div></div></div></div><div class=\"p-r-0 h-100 d-flex flex-column h-100\" ng-class=\"alarmHistoryAttribute.isFullWidthDevice ? \'col-sm-7\':\'col-sm-5\'\"><div class=\"col-sm-12 p-0 chart-icon-height\"><div class=\"col-sm-2 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-l-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedGranularity.name}}</span> <label class=\"titleLabel ellipsis-label\">GRANULARITY</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"granularityObj in alarmHistoryAttribute.granularityArr track by $index\"><a ng-click=\"alarmHistoryAttribute.selectedGranularity = granularityObj;alarmHistoryAttribute.fnSetGranularity()\"><span>{{granularityObj.name}}</span></a></li></ul></div></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px border-1px\"><div class=\"col-sm-12 p-0 w100 overflow-auto d-flex h-100\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmHistoryAttribute.selectedChartType = \'spline\'; alarmHistoryAttribute.fnRenderChart()\"><svg ng-class=\"alarmHistoryAttribute.selectedChartType === \'spline\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmHistoryAttribute.selectedChartType = \'pie\'; alarmHistoryAttribute.selectedPieChartData = alarmHistoryAttribute.pieChartAttributeList[0];alarmHistoryAttribute.fnRenderChart()\"><svg ng-class=\"alarmHistoryAttribute.selectedChartType === \'pie\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/pie-chart.svg#pie-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmHistoryAttribute.selectedChartType = \'bar\'; alarmHistoryAttribute.fnRenderChart()\"><svg ng-class=\"alarmHistoryAttribute.selectedChartType === \'bar\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/bar-chart.svg#bar-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmHistoryAttribute.selectedChartType = \'heatmap\';alarmHistoryAttribute.selectedHeatmapChartAttr = alarmHistoryAttribute.heatmapChartAttributeList[0] ;alarmHistoryAttribute.fnRenderChart()\"><svg ng-class=\"alarmHistoryAttribute.selectedChartType === \'heatmap\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/heatmap-chart.svg#heatmap-chart\"></use></svg></div></div><label class=\"customChartsLabel\">CHART</label></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-r-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedAutoUpdateType}}</span> <label class=\"titleLabel ellipsis-label\">AUTO UPDATE</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"alarmHistoryAttribute.selectedAutoUpdateType = \'Static\';alarmHistoryAttribute.fnSelectAutoUpdateChart()\"><span>Static</span></a></li><li><a ng-click=\"alarmHistoryAttribute.selectedAutoUpdateType = \'Streaming\';alarmHistoryAttribute.fnSelectAutoUpdateChart()\"><span>Streaming</span></a></li></ul></div></div><div class=\"col-sm-4 p-r-0 h-50px node-attribute-date-range\"><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"alarmHistoryAttribute.fnOpenData()\"><span class=\"m-0 ellipsis\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"col-sm-12 p-0 m-t-15 h-100 border-1px chart-container-height position-r\" dnd-list=\"\" dnd-drop=\"callback({targetList: attributeObj})\"><div class=\"col-sm-12 p-0 h-100 w100\" ng-if=\"alarmHistoryAttribute.selectedChartData.length\"><div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"alarmHistoryAttribute.selectedChartType !== \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10\" ng-if=\"alarmHistoryAttribute.selectedChartType !== \'pie\'\"><div class=\"d-flex align-items-center\"></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportToInsight()\">Export to Insight</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\" ng-if=\"alarmHistoryAttribute.selectedChartType === \'pie\'\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedPieChartData.name}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in alarmHistoryAttribute.pieChartAttributeList\"><a ng-click=\"alarmHistoryAttribute.fnSelectPieChartAttr(chartObj);\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie\" ng-class=\"alarmHistoryAttribute.selectedChartType === \'pie\' ? \'nodeAttributeChart-container-with-pie-chart\' : \'nodeAttributeChart-container\'\"><div id=\"nodeAttributeChart\" class=\"nodeAttributeChart h-100 w100\"></div></div></div><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"alarmHistoryAttribute.selectedChartType === \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedHeatmapChartAttr.name}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in alarmHistoryAttribute.heatmapChartAttributeList\"><a ng-click=\"alarmHistoryAttribute.selectedHeatmapChartAttr = chartObj;alarmHistoryAttribute.fnRenderChart()\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedYAxis.title}}</span> <label class=\"titleLabel\">Y AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in alarmHistoryAttribute.axisArr track by $index\"><a ng-click=\"alarmHistoryAttribute.selectedYAxis = axisObj;alarmHistoryAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedXAxis.title}}</span> <label class=\"titleLabel\">X AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in alarmHistoryAttribute.axisArr track by $index\"><a ng-click=\"alarmHistoryAttribute.selectedXAxis = axisObj;alarmHistoryAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmHistoryAttribute.selectedMathFunction}}</span> <label class=\"titleLabel\">Math Function</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mathFunctionObj in alarmHistoryAttribute.mathFunction track by $index\"><a ng-click=\"alarmHistoryAttribute.selectedMathFunction = mathFunctionObj.title;alarmHistoryAttribute.fnRenderChart()\"><span>{{mathFunctionObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeHeatmapChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeHeatmapChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeHeatmapChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmHistoryAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeHeatmapChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\"><div id=\"nodeAttributeHeatmapChart\" class=\"nodeAttributeChart h-100 w100\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!alarmHistoryAttribute.selectedChartData.length\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmHistoryAttribute.parent.alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmHistoryAttribute.parent.alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/alarmHistory/alarmHistoryInfo/alarmHistorySteps/alarmHistoryIssues/alarmHistoryIssues.html","{#<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"AlarmHistoryIssuesCtrl as alarmHistoryIssue\" ng-init=\"alarmHistoryIssue.fnInitAlarmIssues()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"alarmHistoryIssue.isIssueDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"alarms-issue-table table-container col-sm-12 h-100\" ng-if=\"!alarmHistoryIssue.isIssueDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"alarmHistoryIssue.issuesArr.length\"><thead><tr><th ng-if=\"alarmHistoryIssue.issuesArr.length\">Name</th><th ng-if=\"alarmHistoryIssue.issuesArr.length\"></th><th ng-if=\"!alarmHistoryIssue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"alarmIssueTable\"><tr ng-repeat=\"issueObj in alarmHistoryIssue.issuesArr track by $index\"><td><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"alarmHistoryIssue.fnOpenIssueInfo(issueObj)\">View Issue</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"alarmHistoryIssue.fnOpenIssueInNewTab(issueObj)\"><a><span>View issue in new tab</span></a></li></ul></div></td></tr></tbody></table></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmHistoryIssue.parent.alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmHistoryIssue.parent.alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>#}<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"AlarmHistoryIssuesCtrl as alarmHistoryIssue\" ng-init=\"alarmHistoryIssue.fnInitAlarmIssues()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"alarmHistoryIssue.isIssueDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"alarms-issue-table table-container col-sm-12 h-100\" ng-if=\"!alarmHistoryIssue.isIssueDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"alarmHistoryIssue.issuesArr.length\"><thead><tr><th ng-if=\"alarmHistoryIssue.issuesArr.length\">Name</th><th ng-if=\"alarmHistoryIssue.issuesArr.length\"></th><th ng-if=\"!alarmHistoryIssue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"alarmIssueTable\"><tr ng-repeat=\"issueObj in alarmHistoryIssue.issuesArr track by $index\"><td><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"alarmHistoryIssue.fnOpenIssueInfo(issueObj)\">View Issue</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"alarmHistoryIssue.fnOpenIssueInNewTab(issueObj)\"><a><span>View issue in new tab</span></a></li></ul></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"alarmHistoryIssue.issuesArr.length\"><div class=\"row\"><div class=\"col-sm-12 text-right\"><ul uib-pagination=\"\" total-items=\"alarmHistoryIssue.totalItems\" ng-model=\"alarmHistoryIssue.currentPage\" max-size=\"5\" items-per-page=\"alarmHistoryIssue.perPage\" class=\"pagination-sm\" boundary-links=\"true\" force-ellipses=\"true\" ng-change=\"alarmHistoryIssue.fnPageChanged(alarmHistoryIssue.currentPage)\"></ul></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmHistoryIssue.parent.alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmHistoryIssue.parent.alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/alarms/alarmInfo/alarmSteps/alarmAttributes/alarmAttributes.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"AlarmAttributesCtrl as alarmAttribute\" ng-init=\"alarmAttribute.fnInitAlarmAttributes()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!alarmAttribute.parent.isAlarmDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-15 h-100\" ng-if=\"alarmAttribute.parent.isAlarmDetailsLoaded\" ng-init=\"alarmAttribute.fnGetAttributeInfo()\"><div class=\"p-0 h-100 border-1px\" ng-class=\"alarmAttribute.isFullWidthDevice ? \'col-sm-3\':\'col-sm-4\'\"><div class=\"col-sm-12 p-0 local-search-bar-container\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'nodeAttributeSearch\'\" filters-arr=\"alarmAttribute.searchFiltersArr\" filter-query=\"alarmAttribute.filterQuery\" fn-filter-query-change=\"alarmAttribute.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node\'\" no-set-url=\"true\" fn-resize=\"alarmAttribute.fnSetTableHeight()\" sort-field-arr=\"alarmAttribute.sortFieldArr\" default-tag-arr=\"alarmAttribute.defaultAttributeFilterArr\" default-sort-string=\"alarmAttribute.defaultAttributeSortString\" table-alias=\"alarmAttribute.tableAlias\"></v4-search-client></div></div><div class=\"col-sm-12 p-0 overflow-auto\" ng-class=\"alarmAttribute.isShowPaginationContainer ? \'attribute-list-with-pagination-container\':\'attribute-list-container\'\"><div class=\"col-sm-12 p-0\" ng-if=\"alarmAttribute.isAttributesLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!alarmAttribute.isAttributesLoading\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in alarmAttribute.attributesList track by $index\" ng-click=\"alarmAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 type-icon\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 alarm-icon\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" context-menu=\"alarmAttribute.attributeValueContextMenu(attributeObj)\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 health-btn\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center attr-name-value-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\" context-menu=\"alarmAttribute.attributeNameContextMenu(attributeObj)\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end\"><h3 class=\"ellipsis m-0 text-right\" ng-if=\"(attributeObj.value && attributeObj.value.length) || (attributeObj.read && attributeObj.read.unit.length)\" uib-tooltip=\"{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}\" tooltip-placement=\"auto\">{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}</h3></div></div></div></div><div class=\"col-sm-12 p-t-8 p-b-8\" ng-if=\"!alarmAttribute.attributesList.length\"><span class=\"ellipsis font-bold\">No matching results</span></div></div></div><div class=\"col-sm-12 p-t-10\"><div class=\"pagination-container\" ng-show=\"!alarmAttribute.isAttributesLoading && alarmAttribute.attributesList.length && alarmAttribute.isShowPaginationContainer\"><div class=\"row\"><div class=\"col-sm-4 p-r-0 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{alarmAttribute.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"alarmAttribute.perPage = 10; alarmAttribute.fnPageChanged(alarmAttribute.currentPage, alarmAttribute.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmAttribute.perPage = 20; alarmAttribute.fnPageChanged(alarmAttribute.currentPage, alarmAttribute.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmAttribute.perPage = 50; alarmAttribute.fnPageChanged(alarmAttribute.currentPage, alarmAttribute.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"alarmAttribute.perPage = 100; alarmAttribute.fnPageChanged(alarmAttribute.currentPage,alarmAttribute.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-8 p-l-0 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"alarmAttribute.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"alarmAttribute.currentPage\" items-per-page=\"alarmAttribute.perPage\" max-size=\"alarmAttribute.maxSize\" boundary-links=\"true\" ng-click=\"alarmAttribute.fnPageChanged(alarmAttribute.currentPage, alarmAttribute.perPage)\"></ul></div></div></div></div></div></div><div class=\"p-r-0 h-100\" ng-class=\"alarmAttribute.isFullWidthDevice ? \'col-sm-2\':\'col-sm-3\'\"><div class=\"col-sm-12 p-0 attr-selected-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Selected</h3></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"alarmAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"selectedAttrObj in alarmAttribute.selectedAttrKeyArr\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">{{selectedAttrObj.name}}:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\'\"><strong>{{alarmAttribute.selectedAttribute[selectedAttrObj.key]}}</strong></label> <label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Units\'\"><strong>{{alarmAttribute.selectedAttribute.read.unit}}</strong></label><div class=\"d-flex align-items-center w100\" ng-if=\"selectedAttrObj.name === \'Health\'\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{alarmAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmAttribute.fnGetHealthColor(alarmAttribute.selectedAttribute[selectedAttrObj.key], alarmAttribute.selectedAttribute)\"></button><div class=\"d-flex align-items-center selected-attr-health-text\"><label class=\"ellipsis m-0 p-l-5\"><strong>{{alarmAttribute.selectedAttribute.healthName}}</strong></label></div></div><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Alarm\'\"><strong>{{alarmAttribute.selectedAttribute.reference.endsWith(\'!\') ? \'true\': \'false\'}}</strong></label><div ng-if=\"selectedAttrObj.name === \'Type\'\"><div class=\"p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'INT32\' || alarmAttribute.selectedAttribute.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'DATE\' || alarmAttribute.selectedAttribute.read.type === \'TIME\' || alarmAttribute.selectedAttribute.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"alarmAttribute.selectedAttribute.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\' && selectedAttrObj.name !== \'Node\'\"><i class=\"m-l-5 fa\" ng-click=\"alarmAttribute.fnSelectedAttributeCopyToClipboard(selectedAttrObj.key,alarmAttribute.selectedAttribute)\" ng-class=\"!alarmAttribute.selectedAttribute[selectedAttrObj.key+ \'IsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name === \'Node\'\"><i class=\"m-l-5 fa fa-external-link\" ng-click=\"alarmAttribute.fnOpenNodeInfo();\"></i></div></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotable-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plottable</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotable-container-body\" ng-if=\"alarmAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"plotableObj in alarmAttribute.plotableArr\" dnd-list=\"\" dnd-draggable=\"alarmAttribute.selectedAttribute\" dnd-callback=\"alarmAttribute.fnOnActionDrop(alarmAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': alarmAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!alarmAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotted-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plotted</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotted-container-body\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in alarmAttribute.selectedChartData track by $index\" ng-click=\"alarmAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex plotted-icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\" uib-tooltip=\"Alarm Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" uib-tooltip=\"RW Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"alarmAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center plotted-attr-name-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex\"><label class=\"ellipsis m-0\"><strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeValue\'\">[AV]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeHealth\'\">[AH]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeValue\'\">[FV]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeHealth\'\">[FH]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeValue\'\">[VA]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeHealth\'\">[HA]</strong></label></div></div></div><div class=\"d-flex align-items-center w-15-px\"><div class=\"d-flex align-items-center w-15-px\"><i class=\"m-l-5 fa fa-trash-o\" ng-click=\"alarmAttribute.fnRemoveChartData(attributeObj)\"></i></div></div></div></div></div></div></div><div class=\"p-r-0 h-100 d-flex flex-column h-100\" ng-class=\"alarmAttribute.isFullWidthDevice ? \'col-sm-7\':\'col-sm-5\'\"><div class=\"col-sm-12 p-0 chart-icon-height\"><div class=\"col-sm-2 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-l-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedGranularity.name}}</span> <label class=\"titleLabel ellipsis-label\">GRANULARITY</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"granularityObj in alarmAttribute.granularityArr track by $index\"><a ng-click=\"alarmAttribute.selectedGranularity = granularityObj;alarmAttribute.fnSetGranularity()\"><span>{{granularityObj.name}}</span></a></li></ul></div></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px border-1px\"><div class=\"col-sm-12 p-0 w100 overflow-auto d-flex h-100\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmAttribute.selectedChartType = \'spline\'; alarmAttribute.fnRenderChart()\"><svg ng-class=\"alarmAttribute.selectedChartType === \'spline\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmAttribute.selectedChartType = \'pie\'; alarmAttribute.selectedPieChartData = alarmAttribute.pieChartAttributeList[0];alarmAttribute.fnRenderChart()\"><svg ng-class=\"alarmAttribute.selectedChartType === \'pie\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/pie-chart.svg#pie-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmAttribute.selectedChartType = \'bar\'; alarmAttribute.fnRenderChart()\"><svg ng-class=\"alarmAttribute.selectedChartType === \'bar\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/bar-chart.svg#bar-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"alarmAttribute.selectedChartType = \'heatmap\';alarmAttribute.selectedHeatmapChartAttr = alarmAttribute.heatmapChartAttributeList[0] ;alarmAttribute.fnRenderChart()\"><svg ng-class=\"alarmAttribute.selectedChartType === \'heatmap\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/heatmap-chart.svg#heatmap-chart\"></use></svg></div></div><label class=\"customChartsLabel\">CHART</label></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-r-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedAutoUpdateType}}</span> <label class=\"titleLabel ellipsis-label\">AUTO UPDATE</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"alarmAttribute.selectedAutoUpdateType = \'Static\';alarmAttribute.fnSelectAutoUpdateChart()\"><span>Static</span></a></li><li><a ng-click=\"alarmAttribute.selectedAutoUpdateType = \'Streaming\';alarmAttribute.fnSelectAutoUpdateChart()\"><span>Streaming</span></a></li></ul></div></div><div class=\"col-sm-4 p-r-0 h-50px node-attribute-date-range\"><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"alarmAttribute.fnOpenData()\"><span class=\"m-0 ellipsis\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"col-sm-12 p-0 m-t-15 h-100 border-1px chart-container-height position-r\" dnd-list=\"\" dnd-drop=\"callback({targetList: attributeObj})\"><div class=\"col-sm-12 p-0 h-100 w100\" ng-if=\"alarmAttribute.selectedChartData.length\"><div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"alarmAttribute.selectedChartType !== \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10\" ng-if=\"alarmAttribute.selectedChartType !== \'pie\'\"><div class=\"d-flex align-items-center\"></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li><li><a ng-click=\"alarmAttribute.fnExportToInsight()\">Export to Insight</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\" ng-if=\"alarmAttribute.selectedChartType === \'pie\'\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedPieChartData.name}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in alarmAttribute.pieChartAttributeList\"><a ng-click=\"alarmAttribute.fnSelectPieChartAttr(chartObj);\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie\" ng-class=\"alarmAttribute.selectedChartType === \'pie\' ? \'nodeAttributeChart-container-with-pie-chart\' : \'nodeAttributeChart-container\'\"><div id=\"nodeAttributeChart\" class=\"nodeAttributeChart h-100 w100\"></div></div></div><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"alarmAttribute.selectedChartType === \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedHeatmapChartAttr.name}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in alarmAttribute.heatmapChartAttributeList\"><a ng-click=\"alarmAttribute.selectedHeatmapChartAttr = chartObj;alarmAttribute.fnRenderChart()\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedYAxis.title}}</span> <label class=\"titleLabel\">Y AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in alarmAttribute.axisArr track by $index\"><a ng-click=\"alarmAttribute.selectedYAxis = axisObj;alarmAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedXAxis.title}}</span> <label class=\"titleLabel\">X AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in alarmAttribute.axisArr track by $index\"><a ng-click=\"alarmAttribute.selectedXAxis = axisObj;alarmAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmAttribute.selectedMathFunction}}</span> <label class=\"titleLabel\">Math Function</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mathFunctionObj in alarmAttribute.mathFunction track by $index\"><a ng-click=\"alarmAttribute.selectedMathFunction = mathFunctionObj.title;alarmAttribute.fnRenderChart()\"><span>{{mathFunctionObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeHeatmapChart\')\">Download PNG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeHeatmapChart\')\">Download JPEG image</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeHeatmapChart\')\">Download PDF Document</a></li><li><a ng-click=\"alarmAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeHeatmapChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\"><div id=\"nodeAttributeHeatmapChart\" class=\"nodeAttributeChart h-100 w100\"></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!alarmAttribute.selectedChartData.length\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmAttribute.parent.alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmAttribute.parent.alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/alarms/alarmInfo/alarmSteps/alarmIssues/alarmIssues.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"AlarmIssuesCtrl as alarmIssue\" ng-init=\"alarmIssue.fnInitAlarmIssues()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"alarmIssue.isIssueDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"alarms-issue-table table-container col-sm-12 h-100\" ng-if=\"!alarmIssue.isIssueDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"alarmIssue.issuesArr.length\"><thead><tr><th ng-if=\"alarmIssue.issuesArr.length\">Name</th><th ng-if=\"alarmIssue.issuesArr.length\"></th><th ng-if=\"!alarmIssue.issuesArr.length\">No records found...</th></tr></thead><tbody id=\"alarmIssueTable\"><tr ng-repeat=\"issueObj in alarmIssue.issuesArr track by $index\"><td><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis m-b-0 label_name\">{{issueObj.name}}</label> <span class=\"ellipsis DescriptionText span_des font-italic\">{{issueObj.summary}}</span></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"alarmIssue.fnOpenIssueInfo(issueObj)\">View Issue</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"alarmIssue.fnOpenIssueInNewTab(issueObj)\"><a><span>View issue in new tab</span></a></li></ul></div></td></tr></tbody></table></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{alarmIssue.parent.alarmObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(alarmIssue.parent.alarmObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterSteps/clusterDevice/clusterDevice.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"ClusterDeviceCtrl as clusterDevice\" ng-init=\"clusterDevice.fnInitClusterDevices()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"!clusterDevice.isClusterDeviceDetailsLoaded\"><table-loader hide-circle=\"true\" fn-resize=\"clusterDevice.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"clusterDevice.isClusterDeviceDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-5 viewClusterSearchBar\"><div class=\"col-sm-12 floatingLabelInput p-0 d-flex federation-searchDiv\"><div class=\"md-input m-b-13 m-t-15 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" placeholder=\"Search for device\" ng-model=\"clusterDevice.search[clusterDevice.filter]\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"devices-table table-container\"><table class=\"table table-striped table-check-box m-b-0\" ng-show=\"clusterDevice.isClusterDeviceDetailsLoaded\"><thead><tr><th ng-if=\"clusterDevice.clusterDevicesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"clusterDevice.isAllClusterDevicesChecked\" ng-click=\"clusterDevice.fnCheckUncheckClusterDevicesAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"clusterDevice.clusterDevicesArr.length\"></th><th ng-if=\"clusterDevice.clusterDevicesArr.length\">Name</th><th ng-if=\"clusterDevice.clusterDevicesArr.length\"></th><th ng-if=\"!clusterDevice.clusterDevicesArr.length\">No records found...</th></tr></thead><tbody id=\"ClusterDevices\"><tr ng-repeat=\"clusterDeviceObj in clusterDevice.clusterDevicesArr | filter: clusterDevice.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"clusterDeviceObj.isCheck\" ng-change=\"clusterDevice.fnCheckUncheckClusterDevicesHeader(clusterDeviceObj)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\" aria-hidden=\"false\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{clusterDeviceObj.connection === \'CONNECTED\' ?\'CONNECTED\':\'DISCONNECTED\'}}\" tooltip-placement=\"auto\" ng-style=\"clusterDevice.fnGetGatewayConnectionIconColor(clusterDeviceObj.connection)\"><span ng-class=\"clusterDeviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" class=\"device-disconnected\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{clusterDeviceObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\">{{clusterDeviceObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\"><span ng-if=\"clusterDeviceObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{clusterDeviceObj.phase}}\" tooltip-placement=\"auto\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"clusterDevice.fnGetPhaseIconBorderColor(clusterDeviceObj.phase)\"><span ng-class=\"clusterDevice.fnGetPhaseIcon(clusterDeviceObj.phase)\"></span></span> <button ng-if=\"clusterDeviceObj.phase === \'PRODUCTION\' && clusterDeviceObj.health\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{clusterDeviceObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"clusterDevice.fnGetHealthColor(clusterDeviceObj.health, clusterDeviceObj)\"><span class=\"healtSpan\">{{clusterDeviceObj.healthName}}</span></button></div></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{clusterObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(clusterObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(clusterDevice.clusterPermissionObj.AddDevice || clusterDevice.clusterPermissionObj.RemoveDevice) && clusterDevice.isClusterDeviceDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"clusterDevice.clusterPermissionObj.AddDevice\" ng-click=\"clusterDevice.fnAddNewDevice()\"><a class=\"btn btn-link\">Add Device</a></li><li ng-if=\"clusterDevice.selectedClusterDevicesArr.length && clusterDevice.clusterPermissionObj.RemoveDevice\" ng-click=\"clusterDevice.fnDeleteGroupDevices(clusterDevice.selectedClusterDevicesArr)\"><a class=\"btn btn-link\">Remove Devices</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterSteps/clusterGateway/clusterGateway.html","<div id=\"gatewayDetailsContent\" class=\"h-100\" ng-controller=\"ClusterGatewayCtrl as clusterGateway\" ng-init=\"clusterGateway.fnInitClusterGateways()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"!clusterGateway.isClusterGatewayDetailsLoaded\"><table-loader hide-circle=\"true\" fn-resize=\"clusterGateway.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"clusterGateway.isClusterGatewayDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-5 viewClusterSearchBar\"><div class=\"col-sm-12 floatingLabelInput p-0 d-flex federation-searchDiv\"><div class=\"md-input m-b-13 m-t-15 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" placeholder=\"Search for gateway\" ng-model=\"clusterGateway.search[clusterGateway.filter]\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"gateways-table table-container\"><table class=\"table table-striped table-check-box m-b-0\" ng-show=\"clusterGateway.isClusterGatewayDetailsLoaded\"><thead><tr><th ng-if=\"clusterGateway.clusterGatewaysArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"clusterGateway.isAllClusterGatewaysChecked\" ng-click=\"clusterGateway.fnCheckUncheckClusterDevicesAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"clusterGateway.clusterGatewaysArr.length\"></th><th ng-if=\"clusterGateway.clusterGatewaysArr.length\">Name</th><th ng-if=\"!clusterGateway.clusterGatewaysArr.length\">No records found...</th></tr></thead><tbody id=\"ClusterGateways\"><tr ng-repeat=\"clusterGatewayObj in clusterGateway.clusterGatewaysArr | filter: clusterGateway.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"clusterGatewayObj.isCheck\" ng-change=\"clusterGateway.fnCheckUncheckClusterGatewaysHeader(clusterGatewayObj)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"text-center smallConnectionIcon\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{clusterGatewayObj.connection}}\" tooltip-placement=\"auto\" ng-style=\"clusterGateway.fnGetConnectionIconColor(clusterGatewayObj.connection)\"><span class=\"fa gatewayConnectionIcon\" ng-style=\"clusterGateway.fnGetConnectionIconColor(clusterGatewayObj.connection)\" ng-class=\"clusterGateway.fnGetConnectionIcon(clusterGatewayObj.connection)\"></span></span></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-8 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{clusterGatewayObj.name}}</label> <span class=\"ellipsis deviceAttributeDescription span_des\">{{clusterGatewayObj.description}}</span></div><div class=\"col-sm-4 m-t-13 p-0 text-center\"><span ng-if=\"clusterGatewayObj.phase !== \'PRODUCTION\'\" uib-tooltip=\"{{clusterGatewayObj.phase}}\" tooltip-placement=\"auto\" class=\"phaseIconBorder\" ng-style=\"clusterGateway.fnGetPhaseIconBorderColor(clusterGatewayObj.phase)\"><span ng-class=\"clusterGateway.fnGetPhaseIcon(clusterGatewayObj.phase)\"></span></span> <button ng-if=\"clusterGatewayObj.phase === \'PRODUCTION\'\" class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{clusterGatewayObj.toolTipName}}\" tooltip-placement=\"auto\" ng-style=\"clusterGateway.fnGetHealthColor(clusterGatewayObj.health, clusterGatewayObj)\"><span class=\"healtSpan\">{{clusterGatewayObj.healthName}}</span></button></div></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{clusterObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(clusterObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"(clusterGateway.clusterPermissionObj.AddGateway || clusterGateway.clusterPermissionObj.RemoveGateway) && clusterGateway.isClusterGatewayDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"clusterGateway.clusterPermissionObj.AddGateway\" ng-click=\"clusterGateway.fnAddNewGateway()\"><a class=\"btn btn-link\">Add Gateway</a></li><li ng-if=\"clusterGateway.selectedClusterGatewaysArr.length && clusterGateway.clusterPermissionObj.RemoveGateway\" ng-click=\"clusterGateway.fnDeleteGroupGateways(clusterGateway.selectedClusterGatewaysArr)\"><a class=\"btn btn-link\">Remove Gateways</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterSteps/clusterSupplement/clusterSupplement.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"clusterSupplementalCtrl as clusterSupplemental\" ng-init=\"clusterSupplemental.fnInitClusterSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!clusterSupplemental.isClusterSupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"clusterSupplemental.isClusterSupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-25\" ng-if=\"!clusterSupplemental.supplementalKVPArr.length && !clusterSupplemental.isAdvancedOption\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><label>There are no supplemental data for this cluster.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!clusterSupplemental.isAdvancedOption\" ng-class=\"!clusterSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"clusterSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in clusterSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"clusterSupplemental.isKeyDuplicated && $index === clusterSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"clusterSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Keys must be unique.\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"clusterSupplemental.isKeyDuplicated && $index === clusterSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"clusterSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" placeholder=\"Supplemental Value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\"> <span class=\"highlight\"></span> <label>Value</label> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" ng-click=\"clusterSupplemental.fnInjectFunction()\" class=\"btn btn-link\"><span id=\"timeId1\"><em>f<small>(x)</small></em></span></a></span><div class=\"supplementalInputBorder-part\"></div><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"col-sm-1 p-r-10 p-r-0 m-t-5\"><button ng-if=\"clusterSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"clusterSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"$last\"><div class=\"p-0 pull-right\" ng-if=\"clusterSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary m-r-2\" ng-if=\"$last && kvpPair.key.length && kvpPair.value.length && !clusterSupplemental.isKeyDuplicated\" ng-click=\"clusterSupplemental.fnAddSupplementalKey()\">New Entry</button></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"clusterSupplemental.isSupplementalDetailsEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"clusterSupplemental.fnResetDetails()\">Cancel</button><div class=\"pull-right\"><button class=\"btn btn-sm btn-primary\" ng-if=\"!clusterSupplemental.isSupplementalDetailChanging\" ng-disabled=\"clusterSupplemental.isKeyDuplicated\" ng-click=\"clusterSupplemental.fnSaveClusterData()\">Save</button></div><div class=\"m-t-5 pull-right\" ng-if=\"clusterSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"clusterSupplemental.isAdvancedOption && !clusterSupplemental.isSupplementalDetailsEditable\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"clusterSupplemental.clusterSupplementalObj\" ui-codemirror-opts=\"clusterSupplemental.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"clusterSupplemental.isSupplementalEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"clusterSupplemental.fnToggle()\">Cancel</button> <button class=\"btn btn-sm btn-primary pull-right\" ng-if=\"!clusterSupplemental.isSupplementalEditableUpdate\" ng-click=\"clusterSupplemental.fnEditClusterData(clusterSupplemental.clusterSupplementalObj)\">Save</button><div class=\"m-t-5 pull-right\" ng-if=\"clusterSupplemental.isSupplementalEditableUpdate\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\"><div class=\"pull-right\" ng-if=\"!clusterSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"clusterSupplemental.fnAddSupplementalKey(true)\" ng-hide=\"clusterSupplemental.isAdvancedOption\" ng-if=\"clusterSupplemental.clusterPermissionObj.Modify\">New Entry</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-disabled=\"clusterSupplemental.isSupplementalEditable || clusterSupplemental.isSupplementalDetailsEditable\" ng-click=\"clusterSupplemental.fnOpenAdvancedMenu()\">{{clusterSupplemental.isAdvancedOption === true ?\"Default\":\"Advance\"}}</a></li></ul></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{clusterObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(clusterObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!clusterSupplemental.isObjectEmpty(clusterSupplemental.clusterSupplementalObj)\" &&=\"\" clustersupplemental.clusterpermissionobj.modify=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!clusterSupplemental.isSupplementalDetailsEditable && !clusterSupplemental.isAdvancedOption && clusterSupplemental.clusterPermissionObj.Modify\" ng-click=\"clusterSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"clusterSupplemental.isAdvancedOption && clusterSupplemental.clusterPermissionObj.Modify\" ng-click=\"clusterSupplemental.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/cluster/clusterInfo/clusterSteps/clusterTopology/clusterTopology.html","<div class=\"h-100\" ng-controller=\"ClusterTopologyCtrl as clusterTopology\" ng-init=\"clusterTopology.fnInitClusterTopology()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!clusterTopology.isClusterTopologyDataLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"clusterTopology.isClusterTopologyDataLoaded\"><div class=\"col-sm-12\"><user-tree-view tree-data=\"clusterTopology.relationshipObj\"></user-tree-view></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{clusterObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(clusterObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/componentTabs/componentDetails/componentDetails.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"ComponentDetailsCtrl as componentDetails\"><div class=\"content-main\"><div class=\"col-sm-12\"><div class=\"m-t-15\"><span ng-click=\"componentDetails.fnGoBackToInventory()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Inventory</label></a></span></div><div class=\"col-sm-12 p-0\"><div class=\"m-t-20\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"health\" tooltip-placement=\"right\" ng-style=\"componentDetails.fnGetHealthColor(componentDetails.componentObj.health, componentDetails.componentObj)\"><span>{{componentDetails.componentObj.healthName}}</span></button><div class=\"pull-right\"><span class=\"deviceInfoPageIcon phaseIconBorder\" uib-tooltip=\"{{componentDetails.componentObj.phase}}\" tooltip-placement=\"left\" ng-style=\"componentDetails.fnGetPhaseIconBorderColor(componentDetails.componentObj.phase)\"><span ng-class=\"componentDetails.fnGetPhaseIcon(componentDetails.componentObj.phase)\"></span></span></div></div><div class=\"m-t-20\"><label>Category : {{componentDetails.componentObj.category}}</label></div><div class=\"m-t-20\"><label>Index : {{componentDetails.componentObj.index}}</label></div><div class=\"m-t-20\"><label>Type ID : {{componentDetails.componentObj.typeId}}</label></div><div class=\"m-t-20\"><label>OEM : {{componentDetails.componentObj.oem}}</label></div><div class=\"m-t-20\"><label>Model : {{componentDetails.componentObj.model}}</label></div><div class=\"m-t-20\"><label>Version : {{componentDetails.componentObj.version}}</label></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\" ng-class=\"!componentDetails.isComponentDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"componentDetails.componentObj.name\" placeholder=\"Name for the Ghost*\"> <span class=\"highlight\"></span> <label>Name*</label></div><button ng-if=\"componentDetails.isComponentDetailsEditable && componentDetails.isComponentUpdateCompleted\" class=\"btn btn-primary\" ng-click=\"componentDetails.fnResetDetails()\">Cancel</button> <button ng-if=\"componentDetails.isComponentDetailsEditable && componentDetails.isComponentUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"componentDetails.fnUpdateComponentDetails(componentDetails.componentObj)\">Save</button><div class=\"col-sm-12\" ng-if=\"!componentDetails.isComponentUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-7 content-box-footerItem\"><label>ID: {{selectedComponent.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(selectedComponent.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-5 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"componentDetails.fnMakeComponentDetailsEditable()\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/componentTabs/componentGhost/componentGhost.html","<div id=\"userDetailsContent\" class=\"h-100 componentGhost\" ng-controller=\"ComponentGhostCtrl as componentGhost\" ng-init=\"componentGhost.fnInitComponentGhost()\"><div class=\"content-main\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!componentGhost.isComponentGhostDetailsLoaded || !componentGhost.isAttributeAnalyticsDataFetch\"></div><div class=\"col-sm-12\" ng-if=\"componentGhost.isComponentGhostDetailsLoaded && componentGhost.isAttributeAnalyticsDataFetch\"><div class=\"col-sm-6 m-t-10 p-l-0 p-r-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-1 p-l-0 p-r-0 m-t-2\" style=\"width:20px;\"><span ng-click=\"componentGhost.fnGoBackToInventory()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label></label></a></span></div><div class=\"col-sm-11 p-l-0 p-r-0\"><div class=\"componentGhost-breadcrumb col-sm-12 p-0\"><ul class=\"dot-breadcrumb\" id=\"inventoryInfo\"><li class=\"breadcrumb-item clickDisable\"><i><span class=\"gateway-info-box bgColorForGateway-info-box componentGhost-gateway-icon\" ng-style=\"componentGhost.fnGetGatewayConnectionIconColor(componentGhost.gatewayObj.connection)\"><span class=\"gateway-icon fa\" ng-class=\"componentGhost.fnGetConnectionIcon(componentGhost.gatewayObj.connection)\" ng-style=\"componentGhost.fnGetConnectionIconColor(componentGhost.gatewayObj.connection)\"></span></span> <a class=\"p-r-10 componentGhost-gateway-name\">{{componentGhost.gatewayObj.name}}</a></i></li><li class=\"breadcrumb-item clickDisable\"><i><span class=\"device-info-box bgColorForGateway-info-box componentGhost-device-icon\" ng-style=\"componentGhost.fnGetGatewayConnectionIconColor(componentGhost.deviceObj.connection)\"><span class=\"p-5 m-l-4 m-t-2\" ng-class=\"componentGhost.deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></span></span> <a class=\"p-r-10\" style=\"position: relative;left: 5px;\">{{componentGhost.deviceObj.name}}</a></i></li><li class=\"breadcrumb-item\" ng-repeat=\"pathName in componentGhost.breadcrumbArray track by $index\" ng-class=\"!pathName.healthColor ?\'clickDisable\':\'\'\"><i ng-if=\"pathName.healthColor\"><i ng-class=\"!pathName.healthColor ?\'dummyInventories\':\'\'\" ng-style=\"{\'background-color\' : pathName.healthColor}\" uib-tooltip=\"{{pathName.inventorieObj.toolTipName}}\" tooltip-placement=\"bottom\"></i> <a ng-if=\"pathName.healthColor\" ng-click=\"componentGhost.fnGetComponent(pathName.inventorieObj)\">{{pathName.displayName}}</a> <a ng-if=\"!pathName.healthColor\">{{pathName.displayName}}</a></i> <i ng-if=\"!pathName.healthColor\"><i class=\"dummyInventories\"></i> <a>{{pathName.displayName}}</a></i></li></ul></div></div></div></div><div class=\"col-sm-2 m-t-13\"><span class=\"ellipsis\">{{componentGhost.typeObj.oem}}</span></div><div class=\"col-sm-1 m-t-13 p-0\"><span class=\"ellipsis\">{{componentGhost.typeObj.model}}</span></div><div class=\"col-sm-2 m-t-13\"><span class=\"ellipsis\">{{componentGhost.typeObj.name}}</span></div><div class=\"col-sm-1 m-t-13 p-0\"><span class=\"ellipsis\">v{{componentGhost.typeObj.version}}</span></div></div><div class=\"col-sm-12 layoutContainer\" ng-if=\"componentGhost.isComponentGhostDetailsLoaded && componentGhost.isAttributeAnalyticsDataFetch\"><div ng-if=\"componentGhost.selectedTab.tabIndex === 0\"><div class=\"col-sm-12 p-0 viewGhostSearchBar floatingLabelInput d-flex\"><div class=\"md-input m-b-20 m-t-15 w100\"><input required=\"\" class=\"md-form-control p-l-35\" ng-model=\"componentGhost.search[componentGhost.filter]\" placeholder=\"Search for telemetry\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"m-l-6\" ng-if=\"componentGhost.componentReportedArr.length\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 23px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"componentGhost.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"componentGhost.getDeviceCSVData()\" id=\"csvAnchorGhostForComponent\" csv-header=\"componentGhost.csvHeaderArr\" filename=\"{{\'componentGhost_\' + deviceObj.id + \'.csv\'}}\"></a></li></ul></div></div></div><div class=\"ghostAttributesLayout-table-normal table-container ghostAttributeNewUI\" ng-if=\"!componentGhost.isGhostDetailsEditable\"><div class=\"col-sm-12 p-0\" ng-if=\"!componentGhost.componentReportedArr.length\"><div class=\"col-sm-12 p-0\" id=\"noComponentReportedData\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><svg viewbox=\"0 0 512.00037 512\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"m248.953125 61.273438c-5.367187-1.238282-10.722656 2.101562-11.964844 7.46875-1.242187 5.367187 2.105469 10.726562 7.472657 11.96875 24.8125 5.734374 47.492187 18.332031 65.582031 36.421874 53.183593 53.183594 53.183593 139.726563 0 192.910157-53.183594 53.1875-139.726563 53.1875-192.910157 0-53.1875-53.183594-53.1875-139.726563 0-192.910157 15.269532-15.269531 33.339844-26.40625 53.710938-33.109374 5.230469-1.71875 8.078125-7.355469 6.359375-12.589844-1.722656-5.234375-7.363281-8.082032-12.59375-6.359375-23.367187 7.683593-44.085937 20.453125-61.582031 37.953125-60.964844 60.964844-60.964844 160.160156 0 221.125 30.480468 30.480468 70.519531 45.722656 110.5625 45.722656 40.039062-.003906 80.078125-15.242188 110.5625-45.722656 60.960937-60.964844 60.960937-160.160156 0-221.125-20.738282-20.734375-46.738282-35.175782-75.199219-41.753906zm0 0\"></path><path d=\"m498.414062 432.707031-104.53125-104.53125c53.601563-84.054687 41.863282-194.484375-29.265624-265.617187-40.339844-40.339844-93.976563-62.558594-151.027344-62.558594-57.054688 0-110.691406 22.21875-151.03125 62.558594-40.34375 40.339844-62.558594 93.976562-62.558594 151.03125 0 57.050781 22.214844 110.6875 62.558594 151.027344 40.339844 40.339843 93.972656 62.554687 151.023437 62.554687 40.945313 0 80.386719-11.484375 114.59375-33.289063l104.53125 104.53125c8.746094 8.75 20.414063 13.566407 32.855469 13.566407 12.4375 0 24.105469-4.816407 32.855469-13.566407 18.109375-18.117187 18.109375-47.589843-.003907-65.707031zm-14.105468 51.601563c-4.980469 4.976562-11.636719 7.71875-18.746094 7.71875-7.113281 0-13.769531-2.742188-18.75-7.71875l-110.304688-110.304688c-1.929687-1.933594-4.484374-2.921875-7.054687-2.921875-1.976563 0-3.960937.582031-5.683594 1.777344-32.410156 22.480469-70.515625 34.363281-110.1875 34.363281-51.722656 0-100.347656-20.140625-136.917969-56.710937-75.5-75.5-75.5-198.347657 0-273.847657 36.574219-36.574218 85.199219-56.714843 136.925782-56.714843 51.722656 0 100.347656 20.140625 136.921875 56.714843 66.28125 66.285157 75.683593 170.207032 22.347656 247.105469-2.75 3.964844-2.269531 9.324219 1.144531 12.738281l110.304688 110.304688c10.335937 10.335938 10.335937 27.15625 0 37.496094zm0 0\"></path><path d=\"m273.804688 153.371094c-3.894532-3.894532-10.207032-3.894532-14.105469 0l-46.109375 46.109375-46.113282-46.109375c-3.894531-3.894532-10.210937-3.894532-14.105468 0-3.894532 3.894531-3.894532 10.210937 0 14.105468l46.109375 46.113282-46.109375 46.109375c-3.894532 3.894531-3.894532 10.210937 0 14.105469 1.945312 1.949218 4.5 2.921874 7.050781 2.921874 2.554687 0 5.105469-.972656 7.054687-2.921874l46.109376-46.109376 46.109374 46.109376c1.949219 1.949218 4.503907 2.921874 7.054688 2.921874 2.554688 0 5.105469-.972656 7.054688-2.921874 3.894531-3.894532 3.894531-10.210938 0-14.105469l-46.113282-46.109375 46.113282-46.113282c3.894531-3.894531 3.894531-10.210937 0-14.105468zm0 0\"></path><path d=\"m206.976562 77.328125c5.492188 0 9.972657-4.480469 9.972657-9.976563 0-5.492187-4.480469-9.972656-9.972657-9.972656-5.496093 0-9.976562 4.480469-9.976562 9.972656 0 5.496094 4.480469 9.976563 9.976562 9.976563zm0 0\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">No records found...</h2></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"componentGhost.componentReportedArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!componentGhost.isShowAllGhostAttributes\"><div class=\"col-sm-12 p-0\"><label>Unhealthy</label><table class=\"table table-striped table-check-box\" ng-show=\"componentGhost.unhealthyComponentReportedArr.length && componentGhost.isComponentGhostDetailsLoaded\"><thead><tr><th ng-if=\"componentGhost.unhealthyComponentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost1\" ng-model=\"componentGhost.isAllChecked\" ng-click=\"componentGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost1\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"componentGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"componentGhost.unhealthyComponentReportedArr.length\">Name</th><th ng-if=\"componentGhost.unhealthyComponentReportedArr.length\">Value</th><th ng-if=\"componentGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"componentGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"!componentGhost.unhealthyComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"unhealthyComponentReportedArr\"><tr ng-repeat=\"componentGhostObj in componentGhost.unhealthyComponentReportedArr | orderBy:\'health\' | filter: componentGhost.search track by $index\" context-menu=\"componentGhost.attributesContextMenu(componentGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghostUnhealthy_{{$index}}\" ng-model=\"componentGhostObj.isCheck\" ng-change=\"componentGhost.fnCheckUncheckHeader()\"> <label for=\"ghostUnhealthy_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'Unhealthy\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"componentGhost.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"componentGhost.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': componentGhost.isDropUp }\" ng-click=\"componentGhost.toggleDropUp(\'unhealthyComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"componentGhost.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"componentGhost.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"componentGhost.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"componentGhost.issuePermissionsObj.List || componentGhost.issuePermissionsObj.Create\" ng-click=\"componentGhost.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!componentGhost.unhealthyComponentReportedArr.length\" id=\"unhealthyComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\" style=\"enable-background:new 0 0 426.667 426.667;\" xml:space=\"preserve\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your attributes are reporting unhealthy telemetry.</small></div></div></div></div><div class=\"col-sm-12 p-0 m-t-0\"><label>Recently Updated</label><table class=\"table table-striped table-check-box\" ng-show=\"componentGhost.isComponentGhostDetailsLoaded && componentGhost.recentlyUpdatedComponentReportedArr.length\"><thead><tr><th ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost2\" ng-model=\"componentGhost.isAllChecked\" ng-click=\"componentGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost2\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\">Name</th><th ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\">Value</th><th ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"componentGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"!componentGhost.recentlyUpdatedComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"recentlyUpdatedComponentReportedArr\"><tr ng-repeat=\"componentGhostObj in componentGhost.recentlyUpdatedComponentReportedArr | orderBy:\'timestamp\':true | filter: componentGhost.search track by $index\" context-menu=\"componentGhost.attributesContextMenu(componentGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghostRecently_{{$index}}\" ng-model=\"componentGhostObj.isCheck\" ng-change=\"componentGhost.fnCheckUncheckHeader()\"> <label for=\"ghostRecently_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{componentGhostObj.name}}\" tooltip-placement=\"auto\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'RecentlyUpdated\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"componentGhost.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"componentGhost.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': componentGhost.isDropUp }\" ng-click=\"componentGhost.toggleDropUp(\'recentlyUpdatedComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"componentGhost.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"componentGhost.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"componentGhost.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"componentGhost.issuePermissionsObj.List || componentGhost.issuePermissionsObj.Create\" ng-click=\"componentGhost.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!componentGhost.recentlyUpdatedComponentReportedArr.length\" id=\"recentlyUpdatedComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 383.189 383.189\" style=\"enable-background:new 0 0 383.189 383.189;\" xml:space=\"preserve\" class=\"reportedComponentFillColor\"><g><path d=\"M297.184,164.538c-1.4-1.12-3.173-1.663-4.96-1.52h-26.88l25.2-28.16l2.4-2.64l1.52-1.84 c0.429-0.592,0.778-1.237,1.04-1.92c0.303-0.737,0.466-1.523,0.48-2.32c0.201-1.867-0.706-3.68-2.32-4.64 c-2.103-0.966-4.409-1.406-6.72-1.28h-31.68c-1.669-0.093-3.317,0.418-4.64,1.44c-1.106,0.93-1.725,2.316-1.68,3.76 c0,2.133,0.72,3.467,2.16,4c2.082,0.577,4.242,0.82,6.4,0.72h20.48c-0.8,1.2-1.92,2.56-3.36,4.24l-5.28,5.92l-6.88,8l-8,9.12 c-2.88,3.2-4.773,5.387-5.68,6.56c-1.885,2.418-1.643,5.868,0.56,8c1.679,1.249,3.754,1.846,5.84,1.68h37.12 c1.774,0.142,3.538-0.37,4.96-1.44c1.058-0.959,1.642-2.333,1.6-3.76C298.901,166.969,298.288,165.538,297.184,164.538z\"></path></g><g><path d=\"M381.104,119.578c-1.74-1.39-3.939-2.075-6.16-1.92h-33.84l31.6-35.28l2.96-3.28l1.92-2.32 c0.528-0.742,0.958-1.549,1.28-2.4c0.363-0.917,0.552-1.894,0.56-2.88c0.223-2.333-0.933-4.583-2.96-5.76 c-2.629-1.206-5.512-1.755-8.4-1.6h-39.68c-2.096-0.143-4.172,0.483-5.84,1.76c-1.378,1.173-2.145,2.911-2.08,4.72 c0,2.72,0.907,4.373,2.72,4.96c2.6,0.739,5.299,1.063,8,0.96h25.6c-1.067,1.493-2.453,3.253-4.16,5.28l-6.64,7.52l-8.64,9.6 l-10.32,11.44c-3.573,4-5.92,6.667-7.04,8c-2.54,3.085-2.224,7.618,0.72,10.32c2.11,1.59,4.726,2.357,7.36,2.16h46.64 c2.258,0.284,4.541-0.287,6.4-1.6c1.359-1.187,2.121-2.916,2.08-4.72C383.253,122.659,382.492,120.845,381.104,119.578z\"></path></g><g><path d=\"M353.504,254.298c-2.279-2.359-5.767-3.089-8.8-1.84c-86.708,35.894-186.097-5.298-221.992-92.007 c-18.227-44.031-17.127-93.693,3.032-136.873c1.889-3.994,0.182-8.763-3.812-10.652c-2.05-0.97-4.416-1.023-6.508-0.148 C20.363,51.827-25.044,160.545,14.005,255.606s147.767,140.468,242.829,101.419c43.356-17.81,78.394-51.325,98.111-93.848 C356.332,260.203,355.761,256.682,353.504,254.298z M186.224,355.098c-93.977-0.016-170.147-76.212-170.131-170.189 c0.01-61.708,33.428-118.574,87.331-148.611c-6.383,18.946-9.626,38.808-9.6,58.8c0.005,102.813,83.356,186.156,186.169,186.151 c17.231-0.001,34.378-2.394,50.951-7.111C299.919,324.303,245.207,354.91,186.224,355.098z\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2>Wow this component is quiet!</h2></div></div></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn p-b-0 p-t-0 p-r-0 btn-link pull-right\" ng-click=\"componentGhost.fnShowAllGhostAttributes()\">See all attributes</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"componentGhost.isShowAllGhostAttributes\"><table class=\"table table-striped table-check-box\" ng-show=\"componentGhost.isComponentGhostDetailsLoaded\"><thead><tr><th ng-if=\"componentGhost.componentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost\" ng-model=\"componentGhost.isAllChecked\" ng-click=\"componentGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"componentGhost.componentReportedArr.length\"></th><th ng-if=\"componentGhost.componentReportedArr.length\">Name</th><th ng-if=\"componentGhost.componentReportedArr.length\">Value</th><th ng-if=\"componentGhost.componentReportedArr.length\"></th><th ng-if=\"componentGhost.componentReportedArr.length\"></th><th ng-if=\"!componentGhost.componentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"componentGhostData\"><tr ng-repeat=\"componentGhostObj in componentGhost.componentReportedArr | filter: componentGhost.search track by $index\" context-menu=\"componentGhost.attributesContextMenu(componentGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}\" ng-model=\"componentGhostObj.isCheck\" ng-change=\"componentGhost.fnCheckUncheckHeader()\"> <label for=\"ghost_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{componentGhostObj.name}}\" tooltip-placement=\"auto\">{{componentGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue + \' \' + componentGhostObj.unit}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue + \" \" + componentGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentGhostObj.health > 299 && componentGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{componentGhostObj.name+$index+\'All\'}}\" chart-data=\"componentGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"componentGhost.fnOpenAttributeStatistics(componentGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"componentGhost.componentPermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': componentGhost.isDropUp }\" ng-click=\"componentGhost.toggleDropUp(\'componentGhostData\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"componentGhost.fnEnableDisableAttribute(componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"componentGhostObj.editable && componentGhostObj.visible !== false\" ng-click=\"componentGhost.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"componentGhost.fnRenameAttribute(componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"componentGhost.issuePermissionsObj.List || componentGhost.issuePermissionsObj.Create\" ng-click=\"componentGhost.fnManageIssue(componentGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table></div></div></div><div ng-if=\"componentGhost.isGhostDetailsEditable\"><div class=\"m-t-15 m-b-15\"><span ng-click=\"componentGhost.fnGoBackToTableView()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Table</label></a></span></div><schema-directive type-arr=\"componentGhost.selectedGhostObj\" fn-check-type-validion=\"componentGhost.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive><div class=\"pull-right\" ng-if=\"componentGhost.isEditInputValidated\"><button class=\"btn btn-primary\" ng-click=\"componentGhost.fnUpdateGhostValue()\" ng-if=\"componentGhost.isGhostUpdateCompleted\">Update Ghost</button><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!componentGhost.isGhostUpdateCompleted\"></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-8 content-box-footerItem\"><label>ID: {{componentGhost.componentObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(componentGhost.componentObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-4 content-box-footerItem\" ng-class=\"componentGhost.isFooterLoaderActive ? \'m-t-2\' : \'\'\"><div class=\"pull-right\" ng-if=\"componentGhost.isFooterLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"pull-right m-l-5\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/componentTabs/componentOverview/componentOverview.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"ComponentOverviewCtrl as componentOverview\" ng-init=\"componentOverview.fnInitComponentOverview()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-10\" ng-if=\"!componentOverview.isComponentGhostDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 m-t-5\" ng-if=\"componentOverview.isComponentGhostDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-10 m-b-5\"><span ng-click=\"componentOverview.fnGoBackToInventory()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i> <label>Back to Inventory</label></a></span></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" style=\"height: 60px\"><div class=\"col-sm-6 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><h2 class=\"m-t-0 m-b-0 ellipsis\">{{componentOverview.deviceObj.name}}</h2></div><div class=\"col-sm-12 p-0\"><h4 class=\"m-t-0 m-b-0 font-italic ellipsis\">{{componentOverview.selectedComponent.name}}</h4></div></div></div><div class=\"col-sm-6 p-0 text-right\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.isPieChartLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!componentOverview.isPieChartLoading\"><div class=\"w100 d-flex align-items-center\" style=\"justify-content: flex-end\"><pie-chart chart-class=\"telemetryPieChart\" is-inventory-chart=\"true\" chart-data=\"componentOverview.telemetryPieData\"></pie-chart></div></div></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"componentGhost\"><div class=\"col-sm-6 m-t-10 p-l-0 p-r-0 text-right\"><div class=\"componentGhost-breadcrumb col-sm-12 p-0\"><ul class=\"dot-breadcrumb\" id=\"inventoryInfo\"><li class=\"breadcrumb-item clickDisable\"><i><span class=\"gateway-info-box bgColorForGateway-info-box componentGhost-gateway-icon-modal\" ng-style=\"componentOverview.fnGetGatewayConnectionIconColor(componentOverview.gatewayObj.connection)\"><span class=\"gateway-icon-modal fa\" ng-class=\"componentOverview.fnGetConnectionIcon(componentOverview.gatewayObj.connection)\" ng-style=\"componentOverview.fnGetConnectionIconColor(componentOverview.gatewayObj.connection)\"></span></span> <a class=\"p-r-10\" style=\"position: relative;left: 5px;\">{{componentOverview.gatewayObj.name}}</a></i></li><li class=\"breadcrumb-item clickDisable\"><i><span class=\"device-info-box bgColorForGateway-info-box componentGhost-device-icon-modal\" ng-style=\"componentOverview.fnGetGatewayConnectionIconColor(componentOverview.deviceObj.connection)\"><span class=\"p-5 m-l-4 m-t-2 device-icon-modal\" ng-class=\"componentOverview.deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></span></span> <a class=\"p-r-10 componentGhost-device-name-modal\">{{componentOverview.deviceObj.name}}</a></i></li><li class=\"breadcrumb-item\" ng-repeat=\"pathName in componentOverview.breadcrumbArray track by $index\" ng-class=\"!pathName.healthColor ?\'clickDisable\':\'\'\"><i ng-if=\"pathName.healthColor\"><i ng-class=\"!pathName.healthColor ?\'dummyInventories\':\'\'\" ng-style=\"{\'background-color\' : pathName.healthColor}\" uib-tooltip=\"{{pathName.inventorieObj.toolTipName}}\" tooltip-placement=\"bottom\"></i> <a ng-if=\"pathName.healthColor\">{{pathName.displayName}}</a> <a ng-if=\"!pathName.healthColor\">{{pathName.displayName}}</a></i> <i ng-if=\"!pathName.healthColor\"><i class=\"dummyInventories\"></i> <a>{{pathName.displayName}}</a></i></li></ul></div></div><div class=\"col-sm-6 m-t-10 p-0 text-right\"><div class=\"col-sm-12 p-0\" ng-class=\"componentOverview.isAggregateHealthLoading ? \'pace opacity-5\' : \'\'\"><span class=\"cursor-pointer p-r-5\" ng-repeat=\"filterOption in componentOverview.filterOptions track by $index\" ng-class=\"componentOverview.selectedFilterOption.tabIndex === filterOption.tabIndex ? \'overview-active-link\' : \'\'\" ng-click=\"componentOverview.fnChangeFilterOption(filterOption)\">{{filterOption.value}} <i ng-if=\"(componentOverview.filterOptions.length - 1) === $index\" class=\"m-l-3 fa fa-caret-down\"></i></span> <span ng-repeat=\"chartType in componentOverview.chartOptions track by $index\" ng-click=\"componentOverview.fnChangeChartType(chartType)\" ng-class=\"componentOverview.selectedChartType.tabIndex === chartType.tabIndex ? \'overview-active-link\' : \'\'\"><i class=\"cursor-pointer fa\" ng-class=\"$index === 0 ? \'m-l-5 m-r-5 \' + chartType.icon : chartType.icon\"></i></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.selectedChartType.tabIndex === 0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 160px\"><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.isAggregateHealthLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!componentOverview.isAggregateHealthLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.aggregateHealthArr.length\"><heat-map-chart node-id=\"componentOverview.selectedComponent.id\" info-section-class=\"componentOverview.infoSectionClass\" type=\"\'health\'\" filter-obj=\"componentOverview.selectedFilterObj\" is-aggregate-health=\"true\" comp-arr=\"[\'Component\']\" chart-data=\"componentOverview.aggregateHealthArr\" categories-arr=\"componentOverview.aggregateCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!componentOverview.aggregateHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.selectedChartType.tabIndex === 1\"><div class=\"col-sm-12 p-0\"><label>Component Health</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"componentOverview.isAggregateHealthLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!componentOverview.isAggregateHealthLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"componentOverview.componentHealthPieData.length\"><pie-chart node-id=\"componentOverview.selectedComponent.id\" chart-full-size=\"true\" filter-obj=\"componentOverview.selectedFilterObj\" chart-class=\"componentPieMainContainer\" is-show-label=\"true\" chart-data=\"componentOverview.componentHealthPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!componentOverview.componentHealthPieData.length\"><label>No results found for component health for the selected range.</label> <label>Please select another range.</label></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-9 content-box-footerItem\"><label>ID: {{componentOverview.selectedComponent.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(componentOverview.selectedComponent.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-3 content-box-footerItem\"><div class=\"pull-right m-l-5\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/componentTabs/componentSupplemental/componentSupplemental.html","<div id=\"userDetailsContent\" class=\"h-100 supplementalTemplate\" ng-controller=\"ComponentSupplementalCtrl as componentSupplemental\"><div class=\"content-main\" ng-init=\"componentSupplemental.fnInitComponentSupplemental()\"><div class=\"col-sm-12\"><div class=\"m-t-15\"><span ng-click=\"componentSupplemental.fnGoBackToInventory()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Inventory</label></a></span></div><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!componentSupplemental.isComponentSupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"componentSupplemental.isComponentSupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-25\" ng-if=\"!componentSupplemental.supplementalKVPArr.length && !componentSupplemental.isAdvancedOption\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><label>There are no supplemental data for this device.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!componentSupplemental.isAdvancedOption\" ng-class=\"!componentSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"componentSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in componentSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"componentSupplemental.isKeyDuplicated && $index === componentSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"componentSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Keys must be unique.\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"componentSupplemental.isKeyDuplicated && $index === componentSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"componentSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" placeholder=\"Supplemental Value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\"> <span class=\"highlight\"></span> <label>Value</label> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"componentSupplemental.fnInjectFunction()\"><span id=\"timeId1\"><em>f<small>(x)</small></em></span></a></span><div class=\"supplementalInputBorder-part\"></div><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"col-sm-1 p-r-10 p-r-0 m-t-5\"><button ng-if=\"componentSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"componentSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"$last\"><div class=\"p-0 pull-right\" ng-if=\"componentSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary m-r-2\" ng-if=\"$last && kvpPair.key.length && kvpPair.value.length && !componentSupplemental.isKeyDuplicated\" ng-click=\"componentSupplemental.fnAddSupplementalKey()\">New Entry</button></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"componentSupplemental.isSupplementalDetailsEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"componentSupplemental.fnResetDetails()\">Cancel</button><div class=\"pull-right\"><button class=\"btn btn-sm btn-primary\" ng-if=\"!componentSupplemental.isSupplementalDetailChanging\" ng-disabled=\"componentSupplemental.isKeyDuplicated\" ng-click=\"componentSupplemental.fnSaveDeviceData()\">Save</button></div><div class=\"m-t-5 pull-right\" ng-if=\"componentSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"componentSupplemental.isAdvancedOption && !componentSupplemental.isSupplementalDetailsEditable\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"componentSupplemental.componentSupplementalObj\" ui-codemirror-opts=\"componentSupplemental.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"componentSupplemental.isSupplementalEditable\"><button class=\"btn btn-primary\" ng-click=\"componentSupplemental.fnToggle()\">Cancel</button> <button class=\"btn btn-primary pull-right\" ng-if=\"!componentSupplemental.isSupplementalEditableUpdate\" ng-click=\"componentSupplemental.fnEditDeviceData(componentSupplemental.componentSupplementalObj)\">Save</button><div class=\"m-t-5 pull-right\" ng-if=\"componentSupplemental.isSupplementalEditableUpdate\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\"><div class=\"pull-right\" ng-if=\"!componentSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"componentSupplemental.fnAddSupplementalKey(true)\" ng-hide=\"componentSupplemental.isAdvancedOption\" ng-if=\"componentSupplemental.componentPermissionObj.Modify\">New Entry</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-disabled=\"componentSupplemental.isSupplementalEditable || componentSupplemental.isSupplementalDetailsEditable\" ng-click=\"componentSupplemental.fnOpenAdvancedMenu()\">{{componentSupplemental.isAdvancedOption === true ?\"Default\":\"Advance\"}}</a></li></ul></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-7 content-box-footerItem\"><label>ID: {{selectedComponent.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(selectedComponent.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-5 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!componentSupplemental.isObjectEmpty(componentSupplemental.componentSupplementalObj) && componentSupplemental.componentPermissionObj.Modify\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!componentSupplemental.isSupplementalDetailsEditable && !componentSupplemental.isAdvancedOption && componentSupplemental.componentPermissionObj.Modify\" ng-click=\"componentSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"componentSupplemental.isAdvancedOption && componentSupplemental.componentPermissionObj.Modify\" ng-click=\"componentSupplemental.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceAlarms/deviceAlarms.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceAlarmsCtrl as deviceAlarm\" ng-init=\"deviceAlarm.fnInitDeviceAlarms()\"><div class=\"content-main\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0\"><h2 class=\"m-t-10 m-b-0 ellipsis p-b-5\">{{deviceObj.name}}</h2><h4 class=\"m-t-0 m-b-0 p-b-5 font-italic ellipsis\">{{deviceObj.description}}</h4></div><div class=\"col-sm-12 p-0 healthy-device\" ng-if=\"deviceAlarm.isDeviceHealthy\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 iconCss\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your component are reporting unhealthy.</small></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceAlarm.isDeviceHealthy\" style=\"min-height: calc(100% - 71px) !important;\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceAlarm.isPieChartLoading || deviceAlarm.isComponentsLoading || deviceAlarm.isAttributeDataFetch || deviceAlarm.isGatewayLoaded\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceAlarm.isPieChartLoading && !deviceAlarm.isComponentsLoading && !deviceAlarm.isAttributeDataFetch && !deviceAlarm.isGatewayLoaded\"><div class=\"col-sm-12 p-r-0 w100 d-flex align-items-center\" style=\"justify-content: flex-end;\"><pie-chart chart-class=\"componentPieMainContainer\" chart-data=\"deviceAlarm.componentPieData\" is-alarms-pie-chart-export=\"true\" type=\"\'Alarms\'\" node-id=\"deviceObj.id\"></pie-chart><div class=\"d-flex flex-column m-t-0 m-r-10 text-center\"><span>Total</span> <label class=\"m-t-5\">{{deviceAlarm.totalAlarmsCount}}</label></div><div class=\"d-flex flex-column m-t-0 text-center\" ng-repeat=\"healthObj in deviceAlarm.componentPieData track by $index\" ng-class=\"$last ? \'m-r-20\':\'m-r-10\'\"><button class=\"btn btn-xs btn-default\" uib-tooltip=\"{{healthObj.name}}\" ng-style=\"{\'background-color\': healthObj.color, \'color\': healthObj.healthTextColor}\" tooltip-placement=\"auto\"><span class=\"healtSpan\">{{healthObj.name}}</span></button> <label class=\"m-t-5\">{{healthObj.y}}</label></div><div class=\"dropdown customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\" style=\"position: relative;top: -15px;\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" style=\"position: absolute;top: 9px;\" uib-dropdown-menu=\"\"><li ng-click=\"deviceAlarm.fnDownloadCSV(\'componentPieMainContainer\')\"><a class=\"btn btn-link\">Download CSV</a></li><li ng-click=\"deviceAlarm.fnDownloadXLS(\'componentPieMainContainer\')\"><a class=\"btn btn-link\">Download XLS</a></li></ul></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceAlarm.isPieChartLoading && !deviceAlarm.isComponentsLoading && !deviceAlarm.isAttributeDataFetch && !deviceAlarm.isGatewayLoaded\" ng-repeat=\"(key, value) in deviceAlarm.unhealthyComponentAttributeObj\"><div class=\"col-sm-12 p-0 full-width-breadcrumb\"><div class=\"componentGhost\"><div class=\"col-sm-12 m-t-10 p-l-0 p-r-0 text-right\"><div class=\"componentGhost-breadcrumb col-sm-12 p-0\"><ul class=\"dot-breadcrumb p-l-0\" id=\"inventoryInfo\"><li class=\"breadcrumb-item\" ng-right-click=\"deviceAlarm.fnGoToTab(\'gatewayTelemetry\')\"><i><span class=\"gateway-info-box bgColorForGateway-info-box componentGhost-gateway-icon-modal\" ng-style=\"deviceAlarm.fnGetGatewayConnectionIconColor(deviceAlarm.gatewayObj.connection)\"><span class=\"gateway-icon-modal fa\" ng-class=\"deviceAlarm.fnGetConnectionIcon(deviceAlarm.gatewayObj.connection)\" ng-style=\"deviceAlarm.fnGetConnectionIconColor(deviceAlarm.gatewayObj.connection)\"></span></span> <a class=\"p-r-10\" style=\"position: relative;left: 5px;\">{{deviceAlarm.gatewayObj.name}}</a></i></li><li class=\"breadcrumb-item\" ng-right-click=\"deviceAlarm.fnGoToTab(\'deviceTelemetry\')\"><i><span class=\"device-info-box bgColorForGateway-info-box componentGhost-device-icon-modal\" ng-style=\"deviceAlarm.fnGetGatewayConnectionIconColor(deviceAlarm.deviceObj.connection)\"><span class=\"p-5 m-l-4 m-t-2 device-icon-modal\" ng-class=\"deviceAlarm.deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></span></span> <a class=\"p-r-10 componentGhost-device-name-modal\">{{deviceAlarm.deviceObj.name}}</a></i></li><li class=\"breadcrumb-item\" ng-repeat=\"pathName in value.breadcrumbArr track by $index\" ng-class=\"!pathName.healthColor ?\'clickDisable\':\'\'\"><i ng-if=\"pathName.healthColor\" ng-right-click=\"deviceAlarm.fnRightClick(pathName)\"><i ng-class=\"!pathName.healthColor ?\'dummyInventories\':\'\'\" ng-style=\"{\'background-color\' : pathName.healthColor}\" uib-tooltip=\"{{pathName.inventorieObj.toolTipName}}\" tooltip-placement=\"bottom\"></i> <a ng-if=\"pathName.healthColor\">{{pathName.displayName}}</a> <a ng-if=\"!pathName.healthColor\">{{pathName.displayName}}</a></i> <i ng-if=\"!pathName.healthColor\"><i class=\"dummyInventories\"></i> <a>{{pathName.displayName}}</a></i></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15\"><table class=\"devicesAlarm-table table table-striped table-check-box\" ng-if=\"value.attributes.length\"><tbody><tr ng-repeat=\"componentGhostObj in value.attributes | orderBy:\'health\' track by $index\"><td class=\"p-l-10 p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.healthColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"componentGhostObj.editable === true\" class=\"fa fa-sliders\"></i> {{componentGhostObj.displayName}}</label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!componentGhostObj.isProcessing\">updated {{componentGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"componentGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"componentGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{componentGhostObj.displayValue}}\" tooltip-placement=\"left\">{{componentGhostObj.displayValue}}</span></td><td><div class=\"col-sm-12 p-0 customDropdown-icon\" style=\"left: 5px;\"><a class=\"link-primary p-0\" ng-click=\"deviceAlarm.fnOpenAttributeStatistics(componentGhostObj,key)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></td><td class=\"text-right\"><div class=\"dropdown customDropdown-icon m-r-10\" style=\"position: absolute;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" style=\"position: relative;top: -12px;\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\" style=\"margin-top: -12px;\"><li ng-if=\"deviceAlarm.issuePermissionsObj.List || deviceAlarm.issuePermissionsObj.Create\" ng-click=\"deviceAlarm.fnCreateIssue(key, componentGhostObj)\"><a class=\"btn btn-link\">Create Issue</a></li><li ng-click=\"deviceAlarm.fnDisableAttribute(key, componentGhostObj)\"><a class=\"btn btn-link\">{{componentGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-click=\"deviceAlarm.fnRenameAttribute(key, componentGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-click=\"deviceAlarm.fnRightClick(value.breadcrumbArr, componentGhostObj.id)\"><a class=\"btn btn-link\">View Component Telemetry</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-if=\"!value.attributes.length\"><div class=\"col-sm-12 p-0 healthy-device\" style=\"position: relative;margin-top: 50px;\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 iconCss\"><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your attributes are reporting unhealthy telemetry.</small></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceClusters/devicesClusters.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceClustersCtrl as deviceClusters\" ng-init=\"deviceClusters.fnInitDeviceClusters()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"!deviceClusters.isDeviceClustersDetailsLoaded\"><table-loader hide-circle=\"true\" fn-resize=\"deviceClusters.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"deviceClusters.isDeviceClustersDetailsLoaded && !deviceClusters.isShowAddCluster\"><div class=\"col-sm-12 p-0 m-t-5 viewClusterSearchBar\" ng-if=\"deviceClusters.deviceClustersArr.length\"><div class=\"col-sm-12 floatingLabelInput p-0 d-flex federation-searchDiv\"><div class=\"md-input m-b-13 m-t-15 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" placeholder=\"Search for cluster\" ng-model=\"deviceClusters.search[deviceClusters.filter]\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div><div class=\"col-sm-12 p-0\"><table class=\"clusters-table table table-striped table-check-box m-b-0\"><thead><tr><th ng-if=\"deviceClusters.deviceClustersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllCG\" ng-model=\"deviceClusters.isAllDeviceClustersChecked\" ng-click=\"deviceClusters.fnCheckUncheckDeviceClusterAll()\"> <label for=\"checkAllCG\" class=\"check-box\"></label></th><th ng-if=\"deviceClusters.deviceClustersArr.length\">Name</th></tr></thead><tbody id=\"deviceAllClusters\" ng-if=\"deviceClusters.deviceClustersArr.length\"><tr ng-repeat=\"deviceClusterObj in deviceClusters.deviceClustersArr | filter: deviceClusters.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkCG_{{$index}}\" ng-model=\"deviceClusterObj.isCheck\" ng-change=\"deviceClusters.fnCheckUncheckDeviceClusterHeader(deviceClusterObj)\"> <label for=\"chkCG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{deviceClusterObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{deviceClusterObj.description}}</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!deviceClusters.deviceClustersArr.length\"><button class=\"btn btn-primary\" ng-if=\"deviceClusters.permissionObj.AddDevice\" ng-click=\"deviceClusters.fnHideShowAddClusters()\">Add Clusters</button></div></div></div><div class=\"col-sm-12\" ng-if=\"deviceClusters.isShowAddCluster\"><div id=\"addClusterContainer\"><div class=\"headerTitle p-t-15 p-b-15\"><label>Add Cluster</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"deviceClusters.fnHideShowAddClusters()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><search-directive field-arr=\"deviceClusters.searchFieldArr\" filter-query=\"deviceClusters.filterQuery\" state-name=\"\'main.cluster\'\" fn-filter-query-change=\"deviceClusters.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"deviceClusters.fnSetTabHeight()\"></search-directive><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"deviceClusters.isClustersLoading\" hide-circle=\"true\" fn-resize=\"deviceClusters.fnSetLoaderTableHeight()\"></table-loader><div class=\"table-container clusters-table\"><table id=\"clusters-table\" class=\"table table-striped table-check-box\" ng-if=\"!deviceClusters.isClustersLoading\"><thead><tr><th ng-if=\"deviceClusters.clustersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllCluster\" ng-model=\"deviceClusters.isAllChecked\" ng-click=\"deviceClusters.fnCheckUncheckAll()\"> <label for=\"checkAllCluster\" class=\"check-box\"></label></th><th ng-if=\"deviceClusters.clustersArr.length\">Name</th><th ng-if=\"!deviceClusters.clustersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"cluster in deviceClusters.clustersArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkCluster_{{$index}}\" ng-model=\"cluster.isCheck\" ng-change=\"deviceClusters.fnCheckUncheckHeader(cluster)\"> <label for=\"chkCluster_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{cluster.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{cluster.description}}</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!deviceClusters.isClustersLoading && deviceClusters.clustersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{deviceClusters.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"deviceClusters.perPage = 10; deviceClusters.fnPageChanged(deviceClusters.currentPage, deviceClusters.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"deviceClusters.perPage = 20; deviceClusters.fnPageChanged(deviceClusters.currentPage, deviceClusters.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"deviceClusters.perPage = 50; deviceClusters.fnPageChanged(deviceClusters.currentPage, deviceClusters.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"deviceClusters.perPage = 100; deviceClusters.fnPageChanged(deviceClusters.currentPage,deviceClusters.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"deviceClusters.perPage = 500; deviceClusters.fnPageChanged(deviceClusters.currentPage, deviceClusters.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"deviceClusters.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"deviceClusters.currentPage\" items-per-page=\"deviceClusters.perPage\" max-size=\"deviceClusters.maxSize\" boundary-links=\"true\" ng-click=\"deviceClusters.fnPageChanged(deviceClusters.currentPage, deviceClusters.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!deviceClusters.isClusterAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"deviceClusters.fnAddClusterToDevice()\">Add</button></div><div class=\"col-sm-12 m-t-10\" ng-if=\"deviceClusters.isClusterAdding\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"!deviceClusters.permissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right m-r-10\" uib-dropdown=\"\" ng-if=\"((!deviceClusters.isShowAddCluster && deviceClusters.permissionObj.AddDevice) || (deviceClusters.selectedClustersArr.length && deviceClusters.permissionObj.RemoveDevice)) && deviceClusters.isDeviceClustersDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!deviceClusters.isShowAddCluster && deviceClusters.permissionObj.AddDevice\" ng-click=\"deviceClusters.fnHideShowAddClusters()\"><a class=\"btn btn-link\">Add Cluster</a></li><li ng-if=\"deviceClusters.selectedClustersArr.length && deviceClusters.permissionObj.RemoveDevice\" ng-click=\"deviceClusters.fnDeleteDeviceCluster(deviceClusters.selectedClustersArr)\"><a class=\"btn btn-link\">Remove Clusters</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceInventory/deviceInventory.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceInventoryCtrl as deviceInventory\" ng-init=\"deviceInventory.fnInitDeviceInventory()\"><div class=\"content-main\"><div class=\"col-sm-12 p-l-10 p-r-10 p-t-10\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" id=\"inventoryInfo\"><span class=\"gateway-info-box\" ng-style=\"deviceInventory.fnGetGatewayConnectionIconColor(deviceInventory.gatewayObj.connection)\" uib-tooltip=\"{{deviceInventory.gatewayObj.name}}\" tooltip-placement=\"right\"><i class=\"p-5 fa\" ng-style=\"deviceInventory.fnGetConnectionIconColor(deviceInventory.gatewayObj.connection)\" ng-class=\"deviceInventory.fnGetConnectionIcon(deviceInventory.gatewayObj.connection)\"></i></span> <span class=\"gateway-border\" ng-style=\"deviceInventory.fnGetGatewayConnectionIconColor(deviceInventory.gatewayObj.connection)\"></span> <span class=\"device-info-box\" ng-style=\"deviceInventory.fnGetGatewayConnectionIconColor(deviceObj.connection)\" uib-tooltip=\"{{deviceObj.name}}\" tooltip-placement=\"right\"><i class=\"p-5 m-l-4 m-t-2\" ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></i></span> <span class=\"device-border\" ng-style=\"deviceInventory.fnGetGatewayConnectionIconColor(deviceObj.connection)\" ng-show=\"deviceInventory.isDeviceInventoryDetailsLoaded\"></span> <span class=\"component-info-box\" uib-tooltip=\"{{deviceInventory.deviceHealthObj.content}}\" tooltip-placement=\"right\" ng-style=\"{\'border-color\' : deviceInventory.deviceHealthObj[\'background-color\']}\" ng-show=\"deviceInventory.isDeviceInventoryDetailsLoaded\">{{ deviceInventory.componentActive +\" / \"+ deviceInventory.resetInventoriesArr.length}}</span></div></div><div class=\"col-sm-4 p-0 text-right\" ng-if=\"deviceInventory.isDeviceInventoryDetailsLoaded\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-class=\"{\'active\': deviceInventory.isFileViewSelected}\"><a ng-click=\"deviceInventory.fnShowFileView()\"><i class=\"m-r-5 fa fa-th-list\"></i>File View</a></li><li ng-class=\"{\'active\': deviceInventory.isTableViewSelected}\"><a ng-click=\"deviceInventory.fnShowTableView()\"><i class=\"m-r-5 fa fa-table\"></i>Table View</a></li><li ng-class=\"{\'active\': deviceInventory.isSunburstViewSelected}\"><a ng-click=\"deviceInventory.fnShowSunburstView()\"><i class=\"m-r-5 fa fa-bullseye\"></i>Sunburst View</a></li><li ng-class=\"{\'active\': deviceInventory.isTreeViewSelected}\"><a ng-click=\"deviceInventory.fnShowTreeView()\"><i class=\"m-r-5 m-l-2 fa fa-code-fork\" style=\"font-size: 16px\"></i>Tree View</a></li><li ng-class=\"{\'active\': deviceInventory.isBubbleChartSelected}\"><a ng-click=\"deviceInventory.fnShowBubbleView()\"><i class=\"m-r-5 m-l-2 fa fa-circle\" style=\"font-size: 16px\"></i>Bubble View</a></li><li><a ng-click=\"deviceInventory.fnOpenExportModal()\"><i class=\"m-r-5 m-l-2 fa fa-file\" style=\"font-size: 16px\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"deviceInventory.getDeviceCSVData()\" id=\"csvAnchorGhost\" csv-header=\"deviceInventory.csvHeaderArr\" filename=\"{{\'deviceInventory_\' + deviceObj.id + \'.csv\'}}\"></a></li></ul></div></div></div><div id=\"SearchCol\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 m-t-15\" ng-class=\"!deviceInventory.isDeviceInventoryDetailsLoaded ? \'pace\' : \'\'\"><div class=\"search-panel1 m-t-5\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput d-flex\"><div class=\"md-input m-b-13 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"deviceInventory.search\" placeholder=\"Search for inventory\" ng-change=\"deviceInventory.fnInventoryFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div></div></div></div><div class=\"col-sm-12 m-t-10\" ng-if=\"!deviceInventory.isDeviceInventoryDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 m-t-10\" ng-if=\"!deviceInventory.isSearchDeviceInventoryDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"deviceInventory.isDeviceInventoryDetailsLoaded && deviceInventory.isSearchDeviceInventoryDetailsLoaded\" class=\"col-sm-12 p-0\"><div class=\"col-sm-12\" ng-if=\"deviceInventory.isTableViewSelected\"><div class=\"devicesInventory-table\"><table id=\"deviceInventoryTableView\" class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"deviceInventory.inventoriesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllInventory\" ng-model=\"deviceInventory.isAllChecked\" ng-click=\"deviceInventory.fnCheckUncheckAll()\"> <label for=\"checkAllInventory\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"deviceInventory.inventoriesArr.length\"></th><th ng-if=\"!deviceInventory.inventoriesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"inventoryObj in deviceInventory.inventoriesArr track by $index\" ng-click=\"deviceInventory.fnGetInventory(inventoryObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"inventory_{{$index}}\" ng-model=\"inventoryObj.isCheck\" ng-change=\"deviceInventory.fnCheckUncheckHeader(inventoryObj)\"> <label for=\"inventory_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"inventoryObj.enabled === true\" uib-tooltip=\"{{inventoryObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : inventoryObj.healthColor, \'color\' : inventoryObj.textColor}\"><span>{{inventoryObj.healthName}}</span></button></td><td ng-if=\"inventoryObj.enabled === true\" context-menu=\"deviceInventory.fnGetComponentContextMenu(inventoryObj)\"><span class=\"ellipsis\">{{inventoryObj.name && inventoryObj.name !== \' \' ? inventoryObj.name : inventoryObj.index}}</span></td><td ng-if=\"inventoryObj.enabled !== true\"><span class=\"ellipsis\">{{inventoryObj.name && inventoryObj.name !== \' \' ? inventoryObj.name : inventoryObj.index}}</span></td><td><span ng-if=\"inventoryObj.enabled === true\" ng-click=\"deviceInventory.fnGetComponentDetails(inventoryObj)\"><i class=\"fa fa-list\"></i></span></td><td><span ng-if=\"inventoryObj.enabled === true\" ng-click=\"deviceInventory.fnGetComponentGhostDetails(inventoryObj)\"><i class=\"fa fa-external-link\"></i></span></td><td><span class=\"ellipsis\" ng-if=\"inventoryObj.enabled === true\">{{deviceInventory.fnGetTopicInfo(inventoryObj.typeId).name}}</span></td><td><span class=\"ellipsis p-l-10\" ng-if=\"inventoryObj.enabled === true\">v{{deviceInventory.fnGetTopicInfo(inventoryObj.typeId).version}}</span></td></tr></tbody></table></div></div><div class=\"col-sm-12 m-t-30 p-l-0\" ng-if=\"deviceInventory.isFileViewSelected\" id=\"deviceInventoryFileViewContent\"><div ng-if=\"deviceInventory.nestedFileInventoriesObj\"><div class=\"col-sm-12 p-0 treeControlPanel\" id=\"inventoryFileTree\"><div class=\"createLine\"><custom-tree-ui ng-repeat=\"data in deviceInventory.nestedFileInventoriesObj\" tree-data=\"data\" level=\"0\" is-root-parent=\"false\" is-last-child=\"false\" get-context-menu=\"deviceInventory.fnGetComponentContextMenu(inventoriesObj)\" get-menu-option=\"deviceInventory.fnGetComponentContextMenuOption(inventoriesObj,option)\" fn-components-enable-disable=\"deviceInventory.fnEnableDisableComponent(inventoriesObj)\" is-file-view-updating=\"deviceInventory.isFileViewUpdating\" parent-inventories=\"deviceInventory.resetInventoriesArr\" device-obj=\"deviceInventory.parent.deviceObj\" gateway-obj=\"deviceInventory.gatewayObj\" get-node-info=\"deviceInventory.fnGetNodeInfo(inventoriesObj)\" is-disable-component-success=\"deviceInventory.isDisableComponentSuccess\"></custom-tree-ui></div></div></div><div class=\"text-center\" ng-if=\"!deviceInventory.nestedFileInventoriesObj\"><label>No Records Found...</label></div></div><div class=\"col-sm-12\" ng-if=\"deviceInventory.isSunburstViewSelected\" id=\"deviceInventorySunburstViewContent\"><div class=\"col-xs-8 col-xs-offset-2 m-t-50\" ng-if=\"deviceInventory.sunburstInventoriesObj\"><sunburst-directive tree-data=\"deviceInventory.sunburstInventoriesObj\" get-component=\"deviceInventory.fnGetComponentDetails(componet, isCalledForModal)\"></sunburst-directive></div><div class=\"text-center m-t-50\" ng-if=\"!deviceInventory.sunburstInventoriesObj\"><label>No Records Found...</label></div></div><div class=\"col-sm-12 m-t-0 p-l-0 h-100\" ng-if=\"deviceInventory.isTreeViewSelected\" id=\"deviceInventoryTreeViewContent\"><div class=\"col-sm-12 p-10 h-100\" ng-if=\"deviceInventory.inventoriesArr.length\"><treeview tree-data=\"deviceInventory.inventoriesArr\" register-call-back=\"registerCallBack(callback)\" get-component=\"deviceInventory.fnGetComponentDetails(componet, isCalledForModal)\" rename-component=\"deviceInventory.fnOpenComponentRenameModal(componet)\" view-attribute=\"deviceInventory.fnGetComponentGhostDetails(componet)\"></treeview></div><div class=\"text-center\" ng-if=\"!deviceInventory.inventoriesArr.length\"><label>No Records Found...</label></div></div><div class=\"col-sm-12 m-t-0 p-0 h-100\" ng-if=\"deviceInventory.isBubbleChartSelected\" id=\"deviceInventoryBubbleViewContent\"><div class=\"col-sm-12 p-10 h-100\" ng-if=\"deviceInventory.bubbleChartArr.length\"><bubble-chart chart-data=\"deviceInventory.bubbleChartArr\" get-component=\"deviceInventory.fnGetComponentDetails(componet, isCalledForModal)\"></bubble-chart></div><div class=\"text-center\" ng-if=\"!deviceInventory.bubbleChartArr.length\"><label>No Records Found...</label></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6\" ng-if=\"deviceInventory.isFileViewUpdating\"><div class=\"m-t-3 pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-6 content-box-footerItem\" ng-if=\"!deviceInventory.isFileViewUpdating\"><div class=\"col-sm-12 p-0\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"deviceInventory.isFileViewSelected\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceInventory.fnOpenNativeInterface()\" ng-if=\"deviceInventory.devicePermissionObj.CreateTunnel\" ng-class=\"deviceObj.nativeUiType === \'None\' ?\'pace nativeUiType-disabled\':\'\'\"><span class=\"service-action-beta-tag\">BETA</span> <a class=\"btn btn-link\">Launch Native Interface</a></li><li ng-click=\"deviceInventory.collapseAll()\"><a class=\"btn btn-link\">Collapse All</a></li><li ng-click=\"deviceInventory.expandAll()\"><a class=\"btn btn-link\">Expand All</a></li><li ng-if=\"deviceInventory.inventoriesArr.length && deviceInventory.componentPermissionObj.Enable\" ng-click=\"deviceInventory.fnEnableAllComponent(deviceInventory.inventoriesArr)\"><a class=\"btn btn-link\" ng-bind=\"\'Enable Components\'\"></a></li><li ng-if=\"deviceInventory.inventoriesArr.length && deviceInventory.componentPermissionObj.Disable\" ng-click=\"deviceInventory.fnDisableAllComponent(deviceInventory.inventoriesArr)\"><a class=\"btn btn-link\" ng-bind=\"\'Disable Components\'\"></a></li></ul></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"deviceInventory.isTableViewSelected\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"deviceInventory.devicePermissionObj.CreateTunnel\" ng-click=\"deviceInventory.fnOpenNativeInterface()\" ng-class=\"deviceObj.nativeUiType === \'None\' ?\'pace nativeUiType-disabled\':\'\'\"><span class=\"service-action-beta-tag\">BETA</span> <a class=\"btn btn-link\">Launch Native Interface</a></li><li ng-if=\"deviceInventory.selectedInventoryObj ? deviceInventory.selectedInventoryObj.enabled === true ? deviceInventory.componentPermissionObj.Disable : deviceInventory.componentPermissionObj.Enable : false\" ng-click=\"deviceInventory.fnEnableDisableComponent(deviceInventory.selectedInventoryObj, true)\"><a class=\"btn btn-link\" ng-bind=\"deviceInventory.selectedInventoryObj.enabled === true ? \'Disable Component\' : \'Enable Component\'\"></a></li><li ng-class=\"deviceInventory.selectedInventorysArr.length > 1 && deviceInventory.componentPermissionObj.Enable ? \'\' : \'pace opacity-5\'\" ng-click=\"deviceInventory.fnEnableAllComponent(deviceInventory.selectedInventorysArr)\"><a class=\"btn btn-link\" ng-bind=\"\'Enable Components\'\"></a></li><li ng-class=\"deviceInventory.selectedInventorysArr.length > 1 && deviceInventory.componentPermissionObj.Disable ? \'\' : \'pace opacity-5\'\" ng-click=\"deviceInventory.fnDisableAllComponent(deviceInventory.selectedInventorysArr)\"><a class=\"btn btn-link\" ng-bind=\"\'Disable Components\'\"></a></li></ul></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!deviceInventory.isFileViewSelected && !deviceInventory.isTableViewSelected\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceInventory.fnOpenNativeInterface()\" ng-if=\"deviceInventory.devicePermissionObj.CreateTunnel\" ng-class=\"deviceObj.nativeUiType === \'None\' ?\'pace nativeUiType-disabled\':\'\'\"><span class=\"service-action-beta-tag\">BETA</span> <a class=\"btn btn-link\">Launch Native Interface</a></li></ul></div></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceLocation/devicesLocation.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceLocationCtrl as deviceLocation\" ng-init=\"deviceLocation.fnInitDeviceLocation()\"><div class=\"content-main\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!deviceLocation.isDeviceLocationDetailsLoaded\"></div><div class=\"col-sm-12 p-t-10 p-l-10 p-r-10 floatingLabelInput\" ng-if=\"deviceLocation.isDeviceLocationDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-10\" id=\"locationInputBlock\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"lat\" type=\"text\" ng-model=\"deviceLocation.actualLatitude\" ng-change=\"deviceLocation.fnChangeLocation()\" placeholder=\"Latitude for Device*\"> <span class=\"highlight\"></span> <label>Latitude*</label></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"long\" type=\"text\" ng-model=\"deviceLocation.actualLongitude\" ng-change=\"deviceLocation.fnChangeLocation()\" placeholder=\"Longitude for Device*\"> <span class=\"highlight\"></span> <label>Longitude*</label></div></div><div class=\"col-sm-12 p-0\"><h3>Drag marker to set coordinates</h3></div></div><div class=\"col-sm-12 p-0 p-b-10\" id=\"locationMapBlock\"><div class=\"col-sm-12 p-0\" id=\"deviceLocationMap\"></div></div><div class=\"col-sm-12 p-0\" id=\"locationSaveActionBlock\" ng-if=\"deviceLocation.devicePermissionsObj.Modify\"><div class=\"pull-right\" ng-if=\"deviceLocation.isSaveLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button ng-if=\"!deviceLocation.isSaveLoaderActive\" ng-disabled=\"!deviceLocation.actualLatitude.toString().length || !deviceLocation.actualLongitude.toString().length\" class=\"btn btn-primary pull-right\" ng-click=\"deviceLocation.fnSaveLocationInfo()\">Save</button></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceObserver/deviceObserver.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceObserverCtrl as deviceObserver\"><div class=\"content-main\" ng-init=\"deviceObserver.fnInitDeviceObserver()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 m-t-15\" ng-if=\"!deviceObserver.isDeviceInventoryDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-0 m-t-15 observerSearchBar\" ng-if=\"deviceObserver.isDeviceInventoryDetailsLoaded\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"md-input m-b-13\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"deviceObserver.search\" placeholder=\"Search for inventory\" ng-change=\"deviceObserver.fnDeviceComponentFilter()\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15 componentAccordion\" style=\"overflow: auto\" ng-if=\"deviceObserver.isDeviceInventoryDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\" ng-if=\"deviceObserver.isDeviceComponentSearching\"></app-spinner><uib-accordion close-others=\"false\" ng-if=\"!deviceObserver.isDeviceComponentSearching\"><uib-accordion-group ng-repeat=\"component in deviceObserver.deviceComponentsArr\" ng-style=\"{\'pointer-events\': !component.enabled ? \'none\' : \'\'}\" is-open=\"component.open\"><uib-accordion-heading><div class=\"panel-heading-content d-flex align-items-center\" style=\"justify-content: space-between\"><div class=\"p-r-5\"><span class=\"ellipsis p-b-2\">{{component.name && component.name !== \' \' ? component.name : component.index}}</span></div><div class=\"p-r-5\"><span class=\"ellipsis p-b-2\">{{component.description}}</span></div><div class=\"p-r-5\"><span class=\"ellipsis p-b-2\">{{component.version}}</span></div><div class=\"p-r-5\"><span class=\"ellipsis p-b-2\" ng-if=\"component.enabled\">Found {{component.componentObserverArr.length === 0 ? \'no\' : component.componentObserverArr.length}} matching observers.</span> <span class=\"ellipsis p-b-2\" ng-if=\"!component.enabled\">Enable this component to observe it.</span></div><div><button ng-if=\"component.componentObserverArr.length === 0 && component.enabled\" class=\"btn btn-link p-0 pull-right p-b-2\" ng-click=\"deviceObserver.fnCreateObserverForComponent($event, component)\">Create</button> <button ng-if=\"component.componentObserverArr.length !== 0 && component.enabled\" class=\"btn btn-link p-0 pull-right p-b-2\">{{component.open ? \'Close\' : \'View\'}}</button></div></div></uib-accordion-heading><div class=\"col-sm-12 p-0\" ng-if=\"component.enabled && component.componentObserverArr.length !== 0\"><div class=\"col-sm-12 p-t-8 p-b-8 componentObserver d-flex align-items-center\" style=\"justify-content: space-between\" ng-repeat=\"observer in component.componentObserverArr\"><div class=\"text-center smallStateIcon\"><span class=\"stateIconBorder\" uib-tooltip=\"{{observer.state}}\" tooltip-placement=\"right\" ng-style=\"deviceObserver.getObserverStateColor(observer.state)\"><span class=\"fa stateIcon\" ng-class=\"deviceObserver.fnGetObserveStateIcon(observer.state)\"></span></span></div><div class=\"p-r-5 d-flex align-items-center\"><span class=\"ellipsis\">{{observer.name}}</span></div><div class=\"p-r-5 d-flex align-items-center\"><span class=\"ellipsis\">{{observer.description}}</span></div><div><button class=\"btn btn-link p-0 pull-right\" ng-click=\"deviceObserver.fnGoToObserver(observer)\">View</button></div></div></div></uib-accordion-group></uib-accordion></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right m-l-5\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceOverview/deviceOverview.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceOverviewCtrl as deviceOverview\" ng-init=\"deviceOverview.fnInitDeviceOverview()\"><div class=\"content-main\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 p-b-10 d-flex align-items-center\"><div class=\"col-sm-7 p-0\"><div class=\"col-sm-6 p-0\"><h4 class=\"m-t-10 m-b-0 p-b-5 font-italic ellipsis\">{{deviceObj.description}}</h4><h2 class=\"m-t-0 m-b-0 p-b-5 ellipsis\">{{deviceObj.name}}</h2><div class=\"col-sm-12 p-0 m-t-10\" ng-class=\"deviceOverview.isAggregateChartLoading || deviceOverview.isBarCharLoading ? \'pace opacity-5\' : \'\'\"><span class=\"cursor-pointer p-r-5\" ng-repeat=\"filterOption in deviceOverview.filterOptions track by $index\" ng-class=\"deviceOverview.selectedFilterOption.tabIndex === filterOption.tabIndex ? \'overview-active-link\' : \'\'\" ng-click=\"deviceOverview.fnChangeFilterOption(filterOption)\">{{filterOption.value}} <i ng-if=\"(deviceOverview.filterOptions.length - 1) === $index\" class=\"m-l-3 fa fa-caret-down\"></i></span> <span ng-repeat=\"chartType in deviceOverview.chartOptions track by $index\" ng-click=\"deviceOverview.fnChangeChartType(chartType)\" ng-class=\"deviceOverview.selectedChartType.tabIndex === chartType.tabIndex ? \'overview-active-link\' : \'\'\"><i class=\"cursor-pointer fa\" ng-class=\"$index === 0 ? \'m-l-5 m-r-5 \' + chartType.icon : chartType.icon\"></i></span></div></div><div class=\"col-sm-6 m-t-7 p-0\" ng-if=\"!deviceOverview.isGatewayDetailsLoading\"><label class=\"m-0 m-r-10 font-italic ellipsis\" ng-if=\"deviceOverview.gatewayPermissionObj.List\" uib-tooltip=\"{{deviceOverview.deviceGateway.name}}\" tooltip-placement=\"auto\"><strong>{{deviceOverview.deviceGateway.name}}</strong></label><div class=\"d-flex align-items-center\"><div class=\"overview-tab m-r-10 m-t-10\" ng-if=\"deviceOverview.gatewayPermissionObj.List\"><span class=\"text-center smallConnectionIcon\"><span class=\"connectionIconBorder\" uib-tooltip=\"{{deviceOverview.deviceGateway.connection}}\" tooltip-placement=\"auto\" ng-style=\"deviceOverview.fnGetConnectionIconColor(deviceOverview.deviceGateway.connection)\"><span class=\"fa gatewayConnectionIcon\" ng-style=\"deviceOverview.fnGetConnectionIconColor(deviceOverview.deviceGateway.connection)\" ng-class=\"deviceOverview.fnGetConnectionIcon(deviceOverview.deviceGateway.connection)\"></span></span></span></div><button class=\"btn btn-xs btn-default m-r-10 ellipsis-label\" ng-if=\"deviceOverview.gatewayPermissionObj.List\" uib-tooltip=\"{{deviceOverview.deviceGateway.healthName}}\" ng-style=\"deviceOverview.fnGetHealthColor(deviceOverview.deviceGateway.health, deviceOverview.deviceGateway)\" tooltip-placement=\"auto\"><span class=\"healtSpan\">{{deviceOverview.deviceGateway.healthName}}</span></button></div></div></div><div class=\"col-sm-5 p-0\"><div class=\"col-sm-12 p-0 m-t-0\" ng-if=\"deviceObj.hasComponents\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.isComponentsLoading\"><div class=\"m-t-5 p-20 pull-right\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-l-10\" ng-if=\"!deviceOverview.isComponentsLoading && !deviceOverview.componentsArr.length\">No components found for this device.</div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceOverview.isComponentsLoading && deviceOverview.componentsArr.length\"><div class=\"col-sm-12 p-0 w-100 d-flex align-items-center\" ng-if=\"!deviceOverview.isComponentsLoading && deviceOverview.componentsCount[0].total === 0\">No components found for this device.</div><div class=\"col-sm-12 p-0 w-100 d-flex align-items-center\" style=\"justify-content: flex-end\" ng-if=\"!deviceOverview.isComponentsLoading &&deviceOverview.componentsCount[0].total !== 0\"><pie-chart chart-class=\"componentPieCountsChart\" chart-data=\"deviceOverview.componentsCount\" is-inventory-chart=\"true\"></pie-chart><pie-chart chart-class=\"componentPieMainContainer\" chart-data=\"deviceOverview.componentPieData\" is-inventory-chart=\"true\"></pie-chart></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.selectedChartType.tabIndex === 0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Aggregate Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 160px\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.isAggregateChartLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!deviceOverview.isAggregateChartLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.aggregateHealthArr.length\"><heat-map-chart node-id=\"deviceObj.id\" info-section-class=\"deviceOverview.infoSectionClass\" type=\"\'health\'\" filter-obj=\"deviceOverview.selectedFilterObj\" is-aggregate-health=\"true\" comp-arr=\"[\'Device\']\" chart-data=\"deviceOverview.aggregateHealthArr\" categories-arr=\"deviceOverview.heatmapCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!deviceOverview.aggregateHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.hasComponents\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Atomic Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 atomicHealth d-flex\" style=\"min-height: 400px\" ng-if=\"deviceOverview.hasComponents\"><div class=\"col-sm-12 p-0 newLoaderForChart\" ng-if=\"!deviceOverview.isGetAtomicHealth\"><div class=\"atomic-height\"><span class=\"chart-export-button\"></span> <span class=\"atomic-health-chart d-flex\"><span style=\"width: 100%;flex-direction: column\" class=\"d-flex align-items-center justify-content-center\"><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"deviceOverview.isComponentsLoading\"><label class=\"font-italic opacity-5\">Fetching components...</label></div><div class=\"d-flex align-items-center justify-content-center\" ng-if=\"!deviceOverview.isComponentsLoading && !deviceOverview.isGetAtomicHealth && !deviceOverview.isComponentLongResponse\"><label class=\"font-italic opacity-5\">Fetching components analytics data...</label></div><div class=\"d-flex align-items-center justify-content-center p-r-15 p-l-15\" ng-if=\"!deviceOverview.isComponentsLoading && !deviceOverview.isGetAtomicHealth && deviceOverview.isComponentLongResponse\"><label class=\"font-italic opacity-5\" style=\"text-align: justify;\">One moment while we draw all this data on a beautiful chart for you.</label></div></span></span> <span class=\"atomic-health-chart-animation\"></span><div class=\"atomic-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"deviceOverview.isGetAtomicHealth && deviceOverview.componentsArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.atomicHealthArr.length\"><heat-map-chart comp-arr=\"deviceOverview.atomicHealthComponentArr\" node-id=\"deviceObj.id\" info-section-class=\"deviceOverview.infoSectionClass\" type=\"\'health\'\" filter-obj=\"deviceOverview.selectedFilterObj\" is-aggregate-health=\"false\" chart-data=\"deviceOverview.atomicHealthArr\" categories-arr=\"deviceOverview.heatmapCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"flex-direction: column;\" ng-if=\"!deviceOverview.atomicHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" ng-if=\"deviceOverview.isGetAtomicHealth && !deviceOverview.componentsArr.length\"><label>No components found for this device.</label></div></div><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Connection</h3><button class=\"btn btn-link p-0\" style=\"position: absolute;top: -3px;right: 0px;\" ng-if=\"!deviceOverview.isGatewayDetailsLoading && !deviceOverview.isGatewayEmpty\" ng-click=\"deviceOverview.fnOpenGatewayConnectionModal()\">View Gateway Connection</button></div><div class=\"col-sm-12 p-0 aggregateHealth\" style=\"min-height: 200px\"><div class=\"col-sm-12 p-0 newLoaderForChart\" ng-if=\"deviceOverview.isBarCharLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 m-t-0 animationIfOverview\" ng-if=\"!deviceOverview.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.deviceConnectionArr.length\"><connection-heat-map-chart node-id=\"deviceObj.id\" info-section-class=\"deviceOverview.infoSectionClass\" type=\"\'connection\'\" filter-obj=\"deviceOverview.selectedFilterObj\" comp-arr=\"[\'Device\']\" chart-data=\"deviceOverview.deviceConnectionArr\" categories-arr=\"deviceOverview.heatmapCategoriesArr\"></connection-heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!deviceOverview.deviceConnectionArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.selectedChartType.tabIndex === 1\"><div class=\"col-sm-6 p-0 m-t-20\"><div class=\"col-sm-12 p-0\"><label>Device Health</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"deviceOverview.isAggregateChartLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceOverview.isAggregateChartLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.deviceHealthPieData.length\"><pie-chart chart-full-size=\"true\" node-id=\"deviceObj.id\" filter-obj=\"deviceOverview.selectedFilterObj\" type=\"\'health\'\" chart-class=\"devicePieMainContainer\" is-show-label=\"true\" chart-data=\"deviceOverview.deviceHealthPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!deviceOverview.deviceHealthPieData.length\"><label>No results found for device health for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-6 p-0 m-t-20\" ng-if=\"deviceOverview.hasComponents\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.componentsArr.length\"><div class=\"col-sm-12 p-0\" ng-class=\"{\'pace\': !deviceOverview.isGetAtomicHealth}\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"p-0 p-l-10 m-b-0 customDropdown w100\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1\" ng-if=\"deviceOverview.selectedComponentPie\">{{deviceOverview.fnGetString(deviceOverview.selectedComponentPie)}}</span> <label class=\"titleLabel\">Component</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right w100\" uib-dropdown-menu=\"\" role=\"menu\" style=\"max-height: 362px;overflow: auto;\" aria-labelledby=\"emailKeys\"><li ng-repeat=\"(key, value) in deviceOverview.componentsPieDataObj\" role=\"menuitem\"><a ng-click=\"deviceOverview.selectedComponentPie = key;deviceOverview.fnChangeComponentPieOption()\">{{deviceOverview.fnGetString(key)}}</a></li></ul></div></div></div></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"!deviceOverview.isGetAtomicHealth\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.isGetAtomicHealth\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.atomicHealthArr.length\"><pie-chart chart-full-size=\"true\" node-id=\"deviceOverview.selectedComponentPie\" filter-obj=\"deviceOverview.selectedFilterObj\" type=\"\'health\'\" chart-class=\"atomicPieMainContainer\" is-show-label=\"true\" chart-data=\"deviceOverview.atomicComponentPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!deviceOverview.atomicHealthArr.length\"><label>No results found for this component health for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\" ng-if=\"!deviceOverview.componentsArr.length\" style=\"height: 400px;\"><label>No components found for this device.</label></div></div><div class=\"col-sm-6 p-0 m-t-20\"><div class=\"col-sm-12 p-0\"><label>Device Connection</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"deviceOverview.isBarCharLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceOverview.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceOverview.deviceConnectionPieData.length\"><pie-chart chart-full-size=\"true\" node-id=\"deviceObj.id\" filter-obj=\"deviceOverview.selectedFilterObj\" type=\"\'connection\'\" chart-class=\"devicePieConnectionMainContainer\" chart-data=\"deviceOverview.deviceConnectionPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!deviceOverview.deviceConnectionPieData.length\"><label>No results found for device connection for the selected range.</label> <label>Please select another range.</label></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 p-l-0 m-t-5 content-box-footerItem\"><div class=\"pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinnerXS\'\" ng-if=\"deviceOverview.isGatewayDetailsLoading && deviceOverview.gatewayPermissionObj.List\"></div><div class=\"d-flex align-items-center\" style=\"justify-content: flex-end\" ng-if=\"!deviceOverview.isGatewayDetailsLoading\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/deviceSupplemental/deviceSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"DeviceSupplementalCtrl as deviceSupplemental\" ng-init=\"deviceSupplemental.fnInitDeviceSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!deviceSupplemental.isDeviceSupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"deviceSupplemental.isDeviceSupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-25\" ng-if=\"!deviceSupplemental.supplementalKVPArr.length && !deviceSupplemental.isAdvancedOption\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><label>There are no supplemental data for this device.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!deviceSupplemental.isAdvancedOption\" ng-class=\"!deviceSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"deviceSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in deviceSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"deviceSupplemental.isKeyDuplicated && $index === deviceSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"deviceSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Keys must be unique.\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"deviceSupplemental.isKeyDuplicated && $index === deviceSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"deviceSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" placeholder=\"Supplemental Value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\"> <span class=\"highlight\"></span> <label>Value</label> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" ng-click=\"deviceSupplemental.fnInjectFunction()\" class=\"btn btn-link\"><span id=\"timeId1\"><em>f<small>(x)</small></em></span></a></span><div class=\"supplementalInputBorder-part\"></div><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"col-sm-1 p-r-10 p-r-0 m-t-5\"><button ng-if=\"deviceSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"deviceSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"$last\"><div class=\"p-0 pull-right\" ng-if=\"deviceSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary m-r-2\" ng-if=\"$last && kvpPair.key.length && kvpPair.value.length && !deviceSupplemental.isKeyDuplicated\" ng-click=\"deviceSupplemental.fnAddSupplementalKey()\">New Entry</button></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"deviceSupplemental.isSupplementalDetailsEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"deviceSupplemental.fnResetDetails()\">Cancel</button><div class=\"pull-right\"><button class=\"btn btn-sm btn-primary\" ng-if=\"!deviceSupplemental.isSupplementalDetailChanging\" ng-click=\"deviceSupplemental.fnSaveDeviceData()\">Save</button></div><div class=\"m-t-5 pull-right\" ng-if=\"deviceSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"deviceSupplemental.isAdvancedOption && !deviceSupplemental.isSupplementalDetailsEditable\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"deviceSupplemental.deviceSupplementalObj\" ui-codemirror-opts=\"deviceSupplemental.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"deviceSupplemental.isSupplementalEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"deviceSupplemental.fnToggle()\">Cancel</button> <button class=\"btn btn-sm btn-primary pull-right\" ng-if=\"!deviceSupplemental.isSupplementalEditableUpdate\" ng-click=\"deviceSupplemental.fnEditDeviceData(deviceSupplemental.deviceSupplementalObj)\">Save</button><div class=\"m-t-5 pull-right\" ng-if=\"deviceSupplemental.isSupplementalEditableUpdate\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\"><div class=\"pull-right\" ng-if=\"!deviceSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"deviceSupplemental.fnAddSupplementalKey(true)\" ng-hide=\"deviceSupplemental.isAdvancedOption\" ng-if=\"deviceSupplemental.devicePermissionObj.Modify\">New Entry</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-disabled=\"deviceSupplemental.isSupplementalEditable || deviceSupplemental.isSupplementalDetailsEditable\" ng-click=\"deviceSupplemental.fnOpenAdvancedMenu()\">{{deviceSupplemental.isAdvancedOption === true ?\"Default\":\"Advance\"}}</a></li></ul></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"deviceSupplemental.devicePermissionObj.Modify && !deviceSupplemental.isObjectEmpty(deviceSupplemental.deviceSupplementalObj)\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!deviceSupplemental.isSupplementalDetailsEditable && !deviceSupplemental.isAdvancedOption && deviceSupplemental.devicePermissionObj.Modify\" ng-click=\"deviceSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"deviceSupplemental.isAdvancedOption && deviceSupplemental.devicePermissionObj.Modify\" ng-click=\"deviceSupplemental.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/device/devicesInfo/devicesTabs/devicesGhost/devicesGhost.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"DeviceGhostCtrl as deviceGhost\" ng-init=\"deviceGhost.fnInitDeviceGhost()\"><div class=\"content-main\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!deviceGhost.isDeviceGhostDetailsLoaded || !deviceGhost.isAttributeAnalyticsDataFetch\"></div><div id=\"test\" class=\"col-sm-12 p-t-10 p-l-10 p-r-10\" ng-if=\"deviceGhost.isDeviceGhostDetailsLoaded && deviceGhost.isAttributeAnalyticsDataFetch\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhost.isDeviceGhostDetailsLoaded\"><div class=\"col-sm-12 p-0\" id=\"inventoryInfo\"><span class=\"gateway-info-box\" ng-style=\"deviceGhost.fnGetGatewayConnectionIconColor(deviceGhost.gatewayObj.connection)\" uib-tooltip=\"{{deviceGhost.gatewayObj.name}}\" tooltip-placement=\"right\"><i class=\"p-5 fa\" ng-style=\"deviceGhost.fnGetConnectionIconColor(deviceGhost.gatewayObj.connection)\" ng-class=\"deviceGhost.fnGetConnectionIcon(deviceGhost.gatewayObj.connection)\"></i></span> <span class=\"gateway-border\" ng-style=\"deviceGhost.fnGetGatewayConnectionIconColor(deviceGhost.gatewayObj.connection)\"></span> <span class=\"device-info-box\" ng-style=\"deviceGhost.fnGetGatewayConnectionIconColor(deviceObj.connection)\" uib-tooltip=\"{{deviceObj.name}}\" tooltip-placement=\"right\"><i class=\"p-5 m-l-4 m-t-2\" ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\"></i></span></div></div></div><div class=\"col-sm-12 layoutContainer\" ng-if=\"deviceGhost.isDeviceGhostDetailsLoaded && deviceGhost.isAttributeAnalyticsDataFetch\"><div ng-if=\"deviceGhost.selectedTab.tabIndex === 0\"><div class=\"col-sm-12 p-0 viewGhostSearchBar floatingLabelInput d-flex\"><div class=\"md-input m-b-20 m-t-15 w100\"><input required=\"\" class=\"md-form-control p-l-35\" ng-model=\"deviceGhost.search[deviceGhost.filter]\" placeholder=\"Search for telemetry\" type=\"text\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"m-l-6\" ng-if=\"deviceGhost.deviceReportedArr.length\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 23px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"deviceGhost.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"deviceGhost.getDeviceCSVData()\" id=\"csvAnchorGhost\" csv-header=\"deviceGhost.csvHeaderArr\" filename=\"{{\'deviceGhost_\' + deviceObj.id + \'.csv\'}}\"></a></li></ul></div></div></div><div class=\"devicesGhost-table table-container ghostAttributeNewUI\" ng-if=\"!deviceGhost.isGhostDetailsEditable\"><div class=\"col-sm-12 p-0\" ng-if=\"!deviceGhost.deviceReportedArr.length\"><div class=\"col-sm-12 p-0\" id=\"noComponentReportedData\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><svg viewbox=\"0 0 512.00037 512\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"m248.953125 61.273438c-5.367187-1.238282-10.722656 2.101562-11.964844 7.46875-1.242187 5.367187 2.105469 10.726562 7.472657 11.96875 24.8125 5.734374 47.492187 18.332031 65.582031 36.421874 53.183593 53.183594 53.183593 139.726563 0 192.910157-53.183594 53.1875-139.726563 53.1875-192.910157 0-53.1875-53.183594-53.1875-139.726563 0-192.910157 15.269532-15.269531 33.339844-26.40625 53.710938-33.109374 5.230469-1.71875 8.078125-7.355469 6.359375-12.589844-1.722656-5.234375-7.363281-8.082032-12.59375-6.359375-23.367187 7.683593-44.085937 20.453125-61.582031 37.953125-60.964844 60.964844-60.964844 160.160156 0 221.125 30.480468 30.480468 70.519531 45.722656 110.5625 45.722656 40.039062-.003906 80.078125-15.242188 110.5625-45.722656 60.960937-60.964844 60.960937-160.160156 0-221.125-20.738282-20.734375-46.738282-35.175782-75.199219-41.753906zm0 0\"></path><path d=\"m498.414062 432.707031-104.53125-104.53125c53.601563-84.054687 41.863282-194.484375-29.265624-265.617187-40.339844-40.339844-93.976563-62.558594-151.027344-62.558594-57.054688 0-110.691406 22.21875-151.03125 62.558594-40.34375 40.339844-62.558594 93.976562-62.558594 151.03125 0 57.050781 22.214844 110.6875 62.558594 151.027344 40.339844 40.339843 93.972656 62.554687 151.023437 62.554687 40.945313 0 80.386719-11.484375 114.59375-33.289063l104.53125 104.53125c8.746094 8.75 20.414063 13.566407 32.855469 13.566407 12.4375 0 24.105469-4.816407 32.855469-13.566407 18.109375-18.117187 18.109375-47.589843-.003907-65.707031zm-14.105468 51.601563c-4.980469 4.976562-11.636719 7.71875-18.746094 7.71875-7.113281 0-13.769531-2.742188-18.75-7.71875l-110.304688-110.304688c-1.929687-1.933594-4.484374-2.921875-7.054687-2.921875-1.976563 0-3.960937.582031-5.683594 1.777344-32.410156 22.480469-70.515625 34.363281-110.1875 34.363281-51.722656 0-100.347656-20.140625-136.917969-56.710937-75.5-75.5-75.5-198.347657 0-273.847657 36.574219-36.574218 85.199219-56.714843 136.925782-56.714843 51.722656 0 100.347656 20.140625 136.921875 56.714843 66.28125 66.285157 75.683593 170.207032 22.347656 247.105469-2.75 3.964844-2.269531 9.324219 1.144531 12.738281l110.304688 110.304688c10.335937 10.335938 10.335937 27.15625 0 37.496094zm0 0\"></path><path d=\"m273.804688 153.371094c-3.894532-3.894532-10.207032-3.894532-14.105469 0l-46.109375 46.109375-46.113282-46.109375c-3.894531-3.894532-10.210937-3.894532-14.105468 0-3.894532 3.894531-3.894532 10.210937 0 14.105468l46.109375 46.113282-46.109375 46.109375c-3.894532 3.894531-3.894532 10.210937 0 14.105469 1.945312 1.949218 4.5 2.921874 7.050781 2.921874 2.554687 0 5.105469-.972656 7.054687-2.921874l46.109376-46.109376 46.109374 46.109376c1.949219 1.949218 4.503907 2.921874 7.054688 2.921874 2.554688 0 5.105469-.972656 7.054688-2.921874 3.894531-3.894532 3.894531-10.210938 0-14.105469l-46.113282-46.109375 46.113282-46.113282c3.894531-3.894531 3.894531-10.210937 0-14.105468zm0 0\"></path><path d=\"m206.976562 77.328125c5.492188 0 9.972657-4.480469 9.972657-9.976563 0-5.492187-4.480469-9.972656-9.972657-9.972656-5.496093 0-9.976562 4.480469-9.976562 9.972656 0 5.496094 4.480469 9.976563 9.976562 9.976563zm0 0\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">No records found...</h2></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhost.deviceReportedArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!deviceGhost.isShowAllGhostAttributes\"><div class=\"col-sm-12 p-0\"><label>Unhealthy</label><table class=\"table table-striped table-check-box\" ng-show=\"deviceGhost.isDeviceGhostDetailsLoaded && deviceGhost.unhealthyComponentReportedArr.length\"><thead><tr><th ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost1\" ng-model=\"deviceGhost.isAllChecked\" ng-click=\"deviceGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost1\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\">Name</th><th ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\">Value</th><th ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"deviceGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"!deviceGhost.unhealthyComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"unhealthyComponentReportedArr\"><tr ng-repeat=\"deviceGhostObj in deviceGhost.unhealthyComponentReportedArr | orderBy:\'health\' | filter: deviceGhost.search track by $index\" context-menu=\"deviceGhost.attributesContextMenu(deviceGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghostUnhealthy_{{$index}}\" ng-model=\"deviceGhostObj.isCheck\" ng-change=\"deviceGhost.fnCheckUncheckHeader()\"> <label for=\"ghostUnhealthy_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': deviceGhostObj.healthColor, \'color\': deviceGhostObj.textColor}\"><span>{{deviceGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"deviceGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{deviceGhostObj.name}}\" tooltip-placement=\"auto\">{{deviceGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!deviceGhostObj.isProcessing\">updated {{deviceGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"deviceGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{deviceGhostObj.displayValue + \' \' + deviceGhostObj.unit}}\" tooltip-placement=\"left\">{{deviceGhostObj.displayValue + \" \" + deviceGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhostObj.health > 299 && deviceGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{deviceGhostObj.name+$index+\'Unhealthy\'}}\" chart-data=\"deviceGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"deviceGhost.fnOpenAttributeStatistics(deviceGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"deviceGhost.devicePermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': deviceGhost.isDropUp }\" ng-click=\"deviceGhost.toggleDropUp(\'unhealthyComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceGhost.fnEnableDisableAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">{{deviceGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"deviceGhostObj.editable\" ng-click=\"deviceGhost.fnEditGhostValue(deviceGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"deviceGhost.fnRenameAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"deviceGhost.issuePermissionsObj.List || deviceGhost.issuePermissionsObj.Create\" ng-click=\"deviceGhost.fnManageIssue(deviceGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!deviceGhost.unhealthyComponentReportedArr.length\" id=\"unhealthyComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\" style=\"enable-background:new 0 0 426.667 426.667;\" xml:space=\"preserve\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your attributes are reporting unhealthy telemetry.</small></div></div></div></div><div class=\"col-sm-12 p-0 m-t-10\"><label>Recently Updated</label><table class=\"table table-striped table-check-box\" ng-show=\"deviceGhost.isDeviceGhostDetailsLoaded && deviceGhost.recentlyUpdatedComponentReportedArr.length\"><thead><tr><th ng-if=\"deviceGhost.deviceReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost2\" ng-model=\"deviceGhost.isAllChecked\" ng-click=\"deviceGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost2\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"deviceGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"deviceGhost.recentlyUpdatedComponentReportedArr.length\">Name</th><th ng-if=\"deviceGhost.recentlyUpdatedComponentReportedArr.length\">Value</th><th ng-if=\"deviceGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"deviceGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"!deviceGhost.recentlyUpdatedComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"recentlyUpdatedComponentReportedArr\"><tr ng-repeat=\"deviceGhostObj in deviceGhost.recentlyUpdatedComponentReportedArr | orderBy:\'timestamp\':true | filter: deviceGhost.search track by $index\" context-menu=\"deviceGhost.attributesContextMenu(deviceGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost1_{{$index}}\" ng-model=\"deviceGhostObj.isCheck\" ng-change=\"deviceGhost.fnCheckUncheckHeader()\"> <label for=\"ghost1_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': deviceGhostObj.healthColor, \'color\': deviceGhostObj.textColor}\"><span>{{deviceGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"deviceGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{deviceGhostObj.name}}\" tooltip-placement=\"auto\">{{deviceGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!deviceGhostObj.isProcessing\">updated {{deviceGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"deviceGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{deviceGhostObj.displayValue + \' \' + deviceGhostObj.unit}}\" tooltip-placement=\"left\">{{deviceGhostObj.displayValue + \" \" + deviceGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhostObj.health > 299 && deviceGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{deviceGhostObj.name+$index+\'RecentlyUpdated\'}}\" chart-data=\"deviceGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"deviceGhost.fnOpenAttributeStatistics(deviceGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"deviceGhost.devicePermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': deviceGhost.isDropUp }\" ng-click=\"deviceGhost.toggleDropUp(\'recentlyUpdatedComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceGhost.fnEnableDisableAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">{{deviceGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"deviceGhostObj.editable\" ng-click=\"deviceGhost.fnEditGhostValue(deviceGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"deviceGhost.fnRenameAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"deviceGhost.issuePermissionsObj.List || deviceGhost.issuePermissionsObj.Create\" ng-click=\"deviceGhost.fnManageIssue(deviceGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!deviceGhost.recentlyUpdatedComponentReportedArr.length\" id=\"recentlyUpdatedComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 383.189 383.189\" style=\"enable-background:new 0 0 383.189 383.189;\" xml:space=\"preserve\" class=\"reportedComponentFillColor\"><g><path d=\"M297.184,164.538c-1.4-1.12-3.173-1.663-4.96-1.52h-26.88l25.2-28.16l2.4-2.64l1.52-1.84 c0.429-0.592,0.778-1.237,1.04-1.92c0.303-0.737,0.466-1.523,0.48-2.32c0.201-1.867-0.706-3.68-2.32-4.64 c-2.103-0.966-4.409-1.406-6.72-1.28h-31.68c-1.669-0.093-3.317,0.418-4.64,1.44c-1.106,0.93-1.725,2.316-1.68,3.76 c0,2.133,0.72,3.467,2.16,4c2.082,0.577,4.242,0.82,6.4,0.72h20.48c-0.8,1.2-1.92,2.56-3.36,4.24l-5.28,5.92l-6.88,8l-8,9.12 c-2.88,3.2-4.773,5.387-5.68,6.56c-1.885,2.418-1.643,5.868,0.56,8c1.679,1.249,3.754,1.846,5.84,1.68h37.12 c1.774,0.142,3.538-0.37,4.96-1.44c1.058-0.959,1.642-2.333,1.6-3.76C298.901,166.969,298.288,165.538,297.184,164.538z\"></path></g><g><path d=\"M381.104,119.578c-1.74-1.39-3.939-2.075-6.16-1.92h-33.84l31.6-35.28l2.96-3.28l1.92-2.32 c0.528-0.742,0.958-1.549,1.28-2.4c0.363-0.917,0.552-1.894,0.56-2.88c0.223-2.333-0.933-4.583-2.96-5.76 c-2.629-1.206-5.512-1.755-8.4-1.6h-39.68c-2.096-0.143-4.172,0.483-5.84,1.76c-1.378,1.173-2.145,2.911-2.08,4.72 c0,2.72,0.907,4.373,2.72,4.96c2.6,0.739,5.299,1.063,8,0.96h25.6c-1.067,1.493-2.453,3.253-4.16,5.28l-6.64,7.52l-8.64,9.6 l-10.32,11.44c-3.573,4-5.92,6.667-7.04,8c-2.54,3.085-2.224,7.618,0.72,10.32c2.11,1.59,4.726,2.357,7.36,2.16h46.64 c2.258,0.284,4.541-0.287,6.4-1.6c1.359-1.187,2.121-2.916,2.08-4.72C383.253,122.659,382.492,120.845,381.104,119.578z\"></path></g><g><path d=\"M353.504,254.298c-2.279-2.359-5.767-3.089-8.8-1.84c-86.708,35.894-186.097-5.298-221.992-92.007 c-18.227-44.031-17.127-93.693,3.032-136.873c1.889-3.994,0.182-8.763-3.812-10.652c-2.05-0.97-4.416-1.023-6.508-0.148 C20.363,51.827-25.044,160.545,14.005,255.606s147.767,140.468,242.829,101.419c43.356-17.81,78.394-51.325,98.111-93.848 C356.332,260.203,355.761,256.682,353.504,254.298z M186.224,355.098c-93.977-0.016-170.147-76.212-170.131-170.189 c0.01-61.708,33.428-118.574,87.331-148.611c-6.383,18.946-9.626,38.808-9.6,58.8c0.005,102.813,83.356,186.156,186.169,186.151 c17.231-0.001,34.378-2.394,50.951-7.111C299.919,324.303,245.207,354.91,186.224,355.098z\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2>Wow this device is quiet!</h2></div></div></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn p-b-0 p-r-0 p-t-0 btn-link pull-right\" ng-click=\"deviceGhost.fnShowAllGhostAttributes()\">See all attributes</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhost.isShowAllGhostAttributes\"><table class=\"table table-striped table-check-box\" ng-show=\"deviceGhost.isDeviceGhostDetailsLoaded\"><thead><tr><th ng-if=\"deviceGhost.deviceReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost\" ng-model=\"deviceGhost.isAllChecked\" ng-click=\"deviceGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"deviceGhost.deviceReportedArr.length\"></th><th ng-if=\"deviceGhost.deviceReportedArr.length\">Name</th><th ng-if=\"deviceGhost.deviceReportedArr.length\">Value</th><th ng-if=\"deviceGhost.deviceReportedArr.length\"></th><th ng-if=\"deviceGhost.deviceReportedArr.length\"></th><th ng-if=\"!deviceGhost.deviceReportedArr.length\">No records found...</th></tr></thead><tbody id=\"deviceAllGhostAttributes\"><tr ng-repeat=\"deviceGhostObj in deviceGhost.deviceReportedArr | filter: deviceGhost.search track by $index\" context-menu=\"deviceGhost.attributesContextMenu(deviceGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}\" ng-model=\"deviceGhostObj.isCheck\" ng-change=\"deviceGhost.fnCheckUncheckHeader()\"> <label for=\"ghost_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': deviceGhostObj.healthColor, \'color\': deviceGhostObj.textColor}\"><span>{{deviceGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\" ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><label class=\"ellipsis m-b-0\"><i ng-if=\"deviceGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{deviceGhostObj.name}}\" tooltip-placement=\"auto\">{{deviceGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!deviceGhostObj.isProcessing\">updated {{deviceGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"deviceGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"deviceGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{deviceGhostObj.displayValue + \' \' + deviceGhostObj.unit}}\" tooltip-placement=\"left\">{{deviceGhostObj.displayValue + \" \" + deviceGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"deviceGhostObj.health > 299 && deviceGhostObj.inlineChartData.length\"><spark-line-chart chart-class=\"{{deviceGhostObj.name+$index+\'All\'}}\" chart-data=\"deviceGhostObj.inlineChartData\"></spark-line-chart></div></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"deviceGhost.fnOpenAttributeStatistics(deviceGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"deviceGhost.devicePermissionsObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-10\" ng-class=\"{ \'dropup\': deviceGhost.isDropUp }\" ng-click=\"deviceGhost.toggleDropUp(\'deviceAllGhostAttributes\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceGhost.fnEnableDisableAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">{{deviceGhostObj.enabled === false ?\'Enable\':\'Disable\'}}</a></li><li ng-if=\"deviceGhostObj.editable\" ng-click=\"deviceGhost.fnEditGhostValue(deviceGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"deviceGhost.fnRenameAttribute(deviceGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"deviceGhost.issuePermissionsObj.List || deviceGhost.issuePermissionsObj.Create\" ng-click=\"deviceGhost.fnManageIssue(deviceGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table></div></div></div><div ng-if=\"deviceGhost.isGhostDetailsEditable\"><div class=\"m-t-15 m-b-15\"><span ng-click=\"deviceGhost.fnGoBackToTableView()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Table</label></a></span></div><schema-directive type-arr=\"deviceGhost.selectedGhostObj\" fn-check-type-validion=\"deviceGhost.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive><div class=\"pull-right\" ng-if=\"deviceGhost.isEditInputValidated\"><button class=\"btn btn-primary\" ng-click=\"deviceGhost.fnUpdateGhostValue()\" ng-if=\"deviceGhost.isGhostUpdateCompleted\">Update Ghost</button><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!deviceGhost.isGhostUpdateCompleted\"></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{deviceObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(deviceObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\" ng-class=\"deviceGhost.isFooterLoaderActive ? \'m-t-2\' : \'\'\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnDeviceInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"pull-right\" ng-if=\"deviceGhost.isFooterLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!deviceGhost.isFooterLoaderActive\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"deviceGhost.fnOpenNativeInterface()\" ng-if=\"deviceGhost.devicePermissionsObj.CreateTunnel\" ng-class=\"deviceObj.nativeUiType === \'None\' ?\'pace nativeUiType-disabled\':\'\'\"><span class=\"service-action-beta-tag\">BETA</span> <a class=\"btn btn-link\">Launch Native Interface</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuSteps/ecuAttributes/ecuAttributes.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"EcuAttributesCtrl as ecuAttribute\" ng-init=\"ecuAttribute.fnInitEcuAttributes()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!ecuAttribute.parent.isEcuDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-15 h-100\" ng-if=\"ecuAttribute.parent.isEcuDetailsLoaded\" ng-init=\"ecuAttribute.fnGetECUInfo()\"><div class=\"p-0 h-100 border-1px\" ng-class=\"ecuAttribute.isFullWidthDevice ? \'col-sm-3\':\'col-sm-4\'\"><div class=\"col-sm-12 p-0 local-search-bar-container\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'ecuAttributeSearch\'\" filters-arr=\"ecuAttribute.searchFiltersArr\" filter-query=\"ecuAttribute.filterQuery\" fn-filter-query-change=\"ecuAttribute.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.ecu\'\" no-set-url=\"true\" fn-resize=\"ecuAttribute.fnSetTableHeight()\" sort-field-arr=\"ecuAttribute.sortFieldArr\" default-tag-arr=\"ecuAttribute.defaultAttributeFilterArr\" default-sort-string=\"ecuAttribute.defaultAttributeSortString\" table-alias=\"ecuAttribute.tableAlias\"></v4-search-client></div></div><div class=\"col-sm-12 p-0 overflow-auto\" ng-class=\"ecuAttribute.isShowPaginationContainer ? \'attribute-list-with-pagination-container\':\'attribute-list-container\'\"><div class=\"col-sm-12 p-0\" ng-if=\"ecuAttribute.isAttributesLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!ecuAttribute.isAttributesLoading\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in ecuAttribute.attributesList track by $index\" ng-click=\"ecuAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 type-icon\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 alarm-icon\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" context-menu=\"ecuAttribute.attributeValueContextMenu(attributeObj)\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 health-btn\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center attr-name-value-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\" context-menu=\"ecuAttribute.attributeNameContextMenu(attributeObj)\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end\"><h3 class=\"ellipsis m-0 text-right\" ng-if=\"(attributeObj.value && attributeObj.value.length) || (attributeObj.read && attributeObj.read.unit.length)\" uib-tooltip=\"{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}\" tooltip-placement=\"auto\">{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}</h3></div></div></div></div><div class=\"col-sm-12 p-t-8 p-b-8\" ng-if=\"!ecuAttribute.attributesList.length\"><span class=\"ellipsis font-bold\">No matching results</span></div></div></div><div class=\"col-sm-12 p-t-10\"><div class=\"pagination-container\" ng-show=\"!ecuAttribute.isAttributesLoading && ecuAttribute.attributesList.length && ecuAttribute.isShowPaginationContainer\"><div class=\"row\"><div class=\"col-sm-4 p-r-0 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{ecuAttribute.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"ecuAttribute.perPage = 10; ecuAttribute.fnPageChanged(ecuAttribute.currentPage, ecuAttribute.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuAttribute.perPage = 20; ecuAttribute.fnPageChanged(ecuAttribute.currentPage, ecuAttribute.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuAttribute.perPage = 50; ecuAttribute.fnPageChanged(ecuAttribute.currentPage, ecuAttribute.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"ecuAttribute.perPage = 100; ecuAttribute.fnPageChanged(ecuAttribute.currentPage,ecuAttribute.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-8 p-l-0 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"ecuAttribute.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"ecuAttribute.currentPage\" items-per-page=\"ecuAttribute.perPage\" max-size=\"ecuAttribute.maxSize\" boundary-links=\"true\" ng-click=\"ecuAttribute.fnPageChanged(ecuAttribute.currentPage, ecuAttribute.perPage)\"></ul></div></div></div></div></div></div><div class=\"p-r-0 h-100\" ng-class=\"ecuAttribute.isFullWidthDevice ? \'col-sm-2\':\'col-sm-3\'\"><div class=\"col-sm-12 p-0 attr-selected-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Selected</h3></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"ecuAttribute.fnIsAttributeSelected() && ecuAttribute.selectedAttribute.type !== \'ecu\'\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"selectedAttrObj in ecuAttribute.selectedAttrKeyArr\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">{{selectedAttrObj.name}}:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\'\"><strong>{{ecuAttribute.selectedAttribute[selectedAttrObj.key]}}</strong></label> <label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Units\'\"><strong>{{ecuAttribute.selectedAttribute.read.unit}}</strong></label><div class=\"d-flex align-items-center w100\" ng-if=\"selectedAttrObj.name === \'Health\'\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{ecuAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuAttribute.fnGetHealthColor(ecuAttribute.selectedAttribute[selectedAttrObj.key], ecuAttribute.selectedAttribute)\"></button><div class=\"d-flex align-items-center selected-attr-health-text\"><label class=\"ellipsis m-0 p-l-5\"><strong>{{ecuAttribute.selectedAttribute.healthName}}</strong></label></div></div><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Alarm\'\"><strong>{{ecuAttribute.selectedAttribute.reference.endsWith(\'!\') ? \'true\': \'false\'}}</strong></label><div ng-if=\"selectedAttrObj.name === \'Type\'\"><div class=\"p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'INT32\' || ecuAttribute.selectedAttribute.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'DATE\' || ecuAttribute.selectedAttribute.read.type === \'TIME\' || ecuAttribute.selectedAttribute.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"ecuAttribute.selectedAttribute.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\' && selectedAttrObj.name !== \'Node\'\"><i class=\"m-l-5 fa\" ng-click=\"ecuAttribute.fnSelectedAttributeCopyToClipboard(selectedAttrObj.key,ecuAttribute.selectedAttribute)\" ng-class=\"!ecuAttribute.selectedAttribute[selectedAttrObj.key+ \'IsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name === \'Node\'\"><i class=\"m-l-5 fa fa-external-link\" ng-click=\"ecuAttribute.fnOpenNodeInfo();\"></i></div></div></div></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"ecuAttribute.fnIsAttributeSelected() && ecuAttribute.selectedAttribute.type === \'ecu\'\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">Name:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>ECU</strong></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">Health:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{ecuAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuAttribute.fnGetHealthColor(ecuAttribute.selectedAttribute.health, ecuAttribute.selectedAttribute)\"></button></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">ID:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{ecuAttribute.selectedAttribute.id}}</strong></label></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\"><i class=\"m-l-5 fa\" ng-click=\"ecuAttribute.fnSelectedAttributeCopyToClipboard(\'id\',ecuAttribute.selectedAttribute)\" ng-class=\"!ecuAttribute.selectedAttribute[\'idIsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">ECU:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{ecuAttribute.selectedAttribute.ecuName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotable-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plottable</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotable-container-body\" ng-if=\"ecuAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-if=\"ecuAttribute.selectedAttribute.type !== \'ecu\'\" ng-repeat=\"plotableObj in ecuAttribute.plotableArr\" dnd-list=\"\" dnd-draggable=\"ecuAttribute.selectedAttribute\" dnd-callback=\"ecuAttribute.fnOnActionDrop(ecuAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': ecuAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!ecuAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-if=\"ecuAttribute.selectedAttribute.type === \'ecu\'\" ng-repeat=\"plotableObj in ecuAttribute.ecuPlotableArr\" dnd-list=\"\" dnd-draggable=\"ecuAttribute.selectedAttribute\" dnd-callback=\"ecuAttribute.fnOnActionDrop(ecuAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': ecuAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!ecuAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotted-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plotted</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotted-container-body\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in ecuAttribute.selectedChartData track by $index\" ng-click=\"ecuAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex plotted-icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\" uib-tooltip=\"Alarm Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" uib-tooltip=\"RW Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"ecuAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center plotted-attr-name-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex\"><label class=\"ellipsis m-0\"><strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeValue\'\">[AV]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeHealth\'\">[AH]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeValue\'\">[FV]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeHealth\'\">[FH]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeValue\'\">[VA]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeHealth\'\">[HA]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'ecuConnection\'\">[AC]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'ecuHealth\'\">[AH]</strong></label></div></div></div><div class=\"d-flex align-items-center w-15-px\"><div class=\"d-flex align-items-center w-15-px\"><i class=\"m-l-5 fa fa-trash-o\" ng-click=\"ecuAttribute.fnRemoveChartData(attributeObj)\"></i></div></div></div></div></div></div></div><div class=\"p-r-0 h-100 d-flex flex-column h-100\" ng-class=\"ecuAttribute.isFullWidthDevice ? \'col-sm-7\':\'col-sm-5\'\"><div class=\"col-sm-12 p-0 chart-icon-height\"><div class=\"col-sm-2 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-l-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedGranularity.name}}</span> <label class=\"titleLabel ellipsis-label\">GRANULARITY</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"granularityObj in ecuAttribute.granularityArr track by $index\"><a ng-click=\"ecuAttribute.selectedGranularity = granularityObj;ecuAttribute.fnSetGranularity()\"><span>{{granularityObj.name}}</span></a></li></ul></div></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px border-1px\"><div class=\"col-sm-12 p-0 w100 overflow-auto d-flex h-100\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"ecuAttribute.selectedChartType = \'spline\'; ecuAttribute.fnRenderChart()\"><svg ng-class=\"ecuAttribute.selectedChartType === \'spline\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"ecuAttribute.selectedChartType = \'pie\'; ecuAttribute.selectedPieChartData = ecuAttribute.pieChartAttributeList[0];ecuAttribute.fnRenderChart()\"><svg ng-class=\"ecuAttribute.selectedChartType === \'pie\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/pie-chart.svg#pie-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"ecuAttribute.selectedChartType = \'bar\'; ecuAttribute.fnRenderChart()\"><svg ng-class=\"ecuAttribute.selectedChartType === \'bar\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/bar-chart.svg#bar-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"ecuAttribute.selectedChartType = \'heatmap\';ecuAttribute.selectedHeatmapChartAttr = ecuAttribute.heatmapChartAttributeList[0] ;ecuAttribute.fnRenderChart()\"><svg ng-class=\"ecuAttribute.selectedChartType === \'heatmap\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/heatmap-chart.svg#heatmap-chart\"></use></svg></div></div><label class=\"customChartsLabel\">CHART</label></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-r-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedAutoUpdateType}}</span> <label class=\"titleLabel ellipsis-label\">AUTO UPDATE</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"ecuAttribute.selectedAutoUpdateType = \'Static\';ecuAttribute.fnSelectAutoUpdateChart()\"><span>Static</span></a></li><li><a ng-click=\"ecuAttribute.selectedAutoUpdateType = \'Streaming\';ecuAttribute.fnSelectAutoUpdateChart()\"><span>Streaming</span></a></li></ul></div></div><div class=\"col-sm-4 p-r-0 h-50px node-attribute-date-range\"><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"ecuAttribute.fnOpenData()\"><span class=\"m-0 ellipsis\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"col-sm-12 p-0 m-t-15 h-100 border-1px chart-container-height position-r\" dnd-list=\"\" dnd-drop=\"callback({targetList: attributeObj})\"><div class=\"col-sm-12 p-0 h-100 w100\" ng-if=\"ecuAttribute.selectedChartData.length\"><div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"ecuAttribute.selectedChartType !== \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10\" ng-if=\"ecuAttribute.selectedChartType !== \'pie\'\"><div class=\"d-flex align-items-center\"></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPNG\', \'ecuAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadJPEG\', \'ecuAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPDF\', \'ecuAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadSVG\', \'ecuAttributeChart\')\">Download SVG vector image</a></li><li><a ng-click=\"ecuAttribute.fnExportToInsight()\">Export to Insight</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\" ng-if=\"ecuAttribute.selectedChartType === \'pie\'\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedPieChartData && ecuAttribute.selectedPieChartData.name ? ecuAttribute.selectedPieChartData.name : \'No data found\'}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in ecuAttribute.pieChartAttributeList\"><a ng-click=\"ecuAttribute.fnSelectPieChartAttr(chartObj);\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPNG\', \'ecuAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadJPEG\', \'ecuAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPDF\', \'ecuAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadSVG\', \'ecuAttributeChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container\" ng-if=\"ecuAttribute.selectedChartType !== \'pie\'\"><div id=\"ecuAttributeChart\" class=\"nodeAttributeChart h-100 w100\"></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container-with-pie-chart\" ng-if=\"ecuAttribute.selectedChartType === \'pie\'\"><div id=\"ecuAttributeChart\" class=\"nodeAttributeChart h-100 w100\" ng-if=\"ecuAttribute.selectedPieChartData && ecuAttribute.selectedPieChartData.name\"></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!ecuAttribute.selectedPieChartData && !ecuAttribute.selectedPieChartData.name\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"ecuAttribute.selectedChartType === \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedHeatmapChartAttr && ecuAttribute.selectedHeatmapChartAttr.name ? ecuAttribute.selectedHeatmapChartAttr.name : \'No data found\'}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in ecuAttribute.heatmapChartAttributeList\"><a ng-click=\"ecuAttribute.selectedHeatmapChartAttr = chartObj;ecuAttribute.fnRenderChart()\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedYAxis.title}}</span> <label class=\"titleLabel\">Y AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in ecuAttribute.axisArr track by $index\"><a ng-click=\"ecuAttribute.selectedYAxis = axisObj;ecuAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedXAxis.title}}</span> <label class=\"titleLabel\">X AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in ecuAttribute.axisArr track by $index\"><a ng-click=\"ecuAttribute.selectedXAxis = axisObj;ecuAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{ecuAttribute.selectedMathFunction}}</span> <label class=\"titleLabel\">Math Function</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mathFunctionObj in ecuAttribute.mathFunction track by $index\"><a ng-click=\"ecuAttribute.selectedMathFunction = mathFunctionObj.title;ecuAttribute.fnRenderChart()\"><span>{{mathFunctionObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPNG\', \'ecuAttributeHeatmapChart\')\">Download PNG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadJPEG\', \'ecuAttributeHeatmapChart\')\">Download JPEG image</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadPDF\', \'ecuAttributeHeatmapChart\')\">Download PDF Document</a></li><li><a ng-click=\"ecuAttribute.fnExportChart(\'downloadSVG\', \'ecuAttributeHeatmapChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\" ng-if=\"ecuAttribute.selectedHeatmapChartAttr && ecuAttribute.selectedHeatmapChartAttr.name\"><div id=\"ecuAttributeHeatmapChart\" class=\"nodeAttributeChart h-100 w100\"></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\" ng-if=\"!ecuAttribute.selectedHeatmapChartAttr && !ecuAttribute.selectedHeatmapChartAttr.name\"><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!ecuAttribute.selectedChartData.length\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ecuAttribute.parent.ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ecuAttribute.parent.ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuSteps/ecuLocation/ecuLocation.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"ECULocationCtrl as ECULocation\" ng-init=\"ECULocation.fnInitECULocation()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-0 h-100\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!ECULocation.parent.isEcuDetailsLoaded\"></div><div class=\"col-sm-12 p-t-10 p-l-10 p-r-10 floatingLabelInput\" ng-if=\"ECULocation.parent.isEcuDetailsLoaded\" ng-init=\"ECULocation.fnGetECULocation()\"><div class=\"col-sm-12 p-0 m-t-10\" id=\"locationInputBlock\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"lat\" type=\"text\" ng-model=\"ECULocation.actualLatitude\" ng-change=\"ECULocation.fnChangeLocation()\" placeholder=\"Latitude for ECU*\"> <span class=\"highlight\"></span> <label>Latitude*</label></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"long\" type=\"text\" ng-model=\"ECULocation.actualLongitude\" ng-change=\"ECULocation.fnChangeLocation()\" placeholder=\"Longitude for ECU*\"> <span class=\"highlight\"></span> <label>Longitude*</label></div></div><div class=\"col-sm-12 p-0\"><h3>Drag marker to set coordinates</h3></div></div><div class=\"col-sm-12 p-0 p-b-10\" id=\"locationMapBlock\"><div class=\"col-sm-12 p-0\" id=\"ecuLocationMap\"></div></div><div class=\"col-sm-12 p-0\" id=\"locationSaveActionBlock\"><div class=\"pull-right\" ng-if=\"ECULocation.isSaveLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button ng-if=\"!ECULocation.isSaveLoaderActive && ECULocation.ecuObj.lifecycleState === \'READY\'\" ng-disabled=\"!ECULocation.actualLatitude.toString().length || !ECULocation.actualLongitude.toString().length\" class=\"btn btn-primary pull-right\" ng-click=\"ECULocation.fnSaveLocationInfo()\">Save</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ECULocation.parent.ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ECULocation.parent.ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuSteps/ecuSupplemental/ecuSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"EcuSupplementalCtrl as ecuSupplemental\" ng-init=\"ecuSupplemental.fnInitEcuSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!ecuSupplemental.parent.isEcuDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"ecuSupplemental.parent.isEcuDetailsLoaded\" ng-init=\"ecuSupplemental.fnGetECUData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"ecuSupplemental.supplementalKVPArr.length || ecuSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!ecuSupplemental.isSupplementalDetailsEditable && ecuSupplemental.parent.userPermissionsObj.REPLACE_ECU_TAGS && ecuSupplemental.parent.ecuObj.lifecycleState === \'READY\'\" ng-click=\"ecuSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"ecuSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{ecuSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!ecuSupplemental.supplementalKVPArr.length && !ecuSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"ecuSupplemental.parent.userPermissionsObj.REPLACE_HEALTH_TAGS\" ng-click=\"ecuSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"ecuSupplemental.supplementalKVPArr.length && !ecuSupplemental.isAdvancedOption\" ng-class=\"!ecuSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"ecuSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in ecuSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"ecuSupplemental.isKeyDuplicated && $index === ecuSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"ecuSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"ecuSupplemental.isKeyDuplicated && $index === ecuSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"ecuSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"ecuSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"ecuSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"ecuSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"ecuSupplemental.ecuSupplementalObj\" ui-codemirror-opts=\"ecuSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"ecuSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!ecuSupplemental.isSupplementalDetailChanging\" ng-click=\"ecuSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!ecuSupplemental.isSupplementalDetailChanging\" ng-click=\"ecuSupplemental.fnSaveEcuData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"ecuSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ecuSupplemental.parent.ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ecuSupplemental.parent.ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/ecu/ecuInfo/ecuSteps/registerECU/registerECU.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"RegisterECUCtrl as registerECU\" ng-init=\"registerECU.fnInitRegisterECU()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-20 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-b-10\"><label>Binds a registered ECU with a physical unit via its serial number.</label></div><div class=\"col-sm-12\"><div class=\"md-input m-b-20 m-t-10 pace\"><input class=\"md-form-control\" required=\"\" id=\"ID\" type=\"text\" ng-model=\"registerECU.ecuRegisterObj.ecuId\" placeholder=\"ECU ID*\" name=\"ID\"> <span class=\"highlight\"></span> <label>ECU ID*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"SerialNumber\" type=\"text\" ng-model=\"registerECU.ecuRegisterObj.serialId\" placeholder=\"Serial Number*\" name=\"SerialNumber\"> <span class=\"highlight\"></span> <label>Serial Number*</label></div><button ng-if=\"registerECU.isUpdateCompleted\" ng-disabled=\"!registerECU.ecuRegisterObj.ecuId.length || !registerECU.ecuRegisterObj.serialId.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"registerECU.fnRegisterECU(registerECU.ecuRegisterObj)\">Register ECU</button><div class=\"col-sm-12\" ng-if=\"!registerECU.isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{registerECU.parent.ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(registerECU.parent.ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/es4/es4Info/es4Steps/es4Script/es4Script.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"Es4ScriptCtrl as es4Script\" ng-init=\"es4Script.fnInitEs4Script()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!es4Script.parent.isEs4DetailsLoaded\"></div><div class=\"col-sm-12 p-0 m-t-0 floatingLabelInput h-100\" ng-if=\"es4Script.parent.isEs4DetailsLoaded\" ng-init=\"es4Script.fnInitScriptTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!es4Script.isECUDetailsLoaded\"></div><div class=\"col-sm-12 p-0 email-template\" ng-if=\"es4Script.isECUDetailsLoaded\" style=\"height: calc(100% - 0px)\"><javascript-editor value=\"es4Script.value\" available-defs=\"es4Script.availableDataLibs\" editor-value=\"es4Script.scriptConfigObj.scriptBody\" read-only=\"es4Script.isScriptEditable\"></javascript-editor></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div ng-if=\"!es4Script.isScriptEditable\"><label class=\"m-0\">ID: {{es4Script.parent.es4Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(es4Script.parent.es4Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"es4Script.isScriptEditable && !es4Script.isSaveChanges\" ng-click=\"es4Script.fnCancelEditable()\">Cancel</button></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div class=\"dropdown dropup\" uib-dropdown=\"\" ng-if=\"!es4Script.isScriptEditable && !isScriptDataLoading && userPermissionsObj.UPDATE_ES4_SCRIPT\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label class=\"m-0\">Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_ES4_SCRIPT\" ng-click=\"es4Script.fnChangeToEditable()\"><a class=\"btn btn-link\">Edit</a></li></ul></div><button class=\"btn btn-primary v4-primary-button\" ng-click=\"es4Script.fnSaveScript()\" ng-if=\"!es4Script.isSaveChanges && es4Script.isScriptEditable\">Save Changes</button><div class=\"pull-right\" ng-if=\"es4Script.isSaveChanges && es4Script.isScriptEditable\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/node/es4/es4Info/es4Steps/es4Supplemental/es4Supplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"Es4SupplementalCtrl as es4Supplemental\" ng-init=\"es4Supplemental.fnInitEs4Supplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!es4Supplemental.parent.isEs4DetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"es4Supplemental.parent.isEs4DetailsLoaded\" ng-init=\"es4Supplemental.fnGetEs4Data()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"es4Supplemental.supplementalKVPArr.length || es4Supplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!es4Supplemental.isSupplementalDetailsEditable && es4Supplemental.parent.userPermissionsObj.REPLACE_ES4_TAGS\" ng-click=\"es4Supplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"es4Supplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{es4Supplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!es4Supplemental.supplementalKVPArr.length && !es4Supplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"es4Supplemental.parent.userPermissionsObj.REPLACE_ES4_TAGS\" ng-click=\"es4Supplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"es4Supplemental.supplementalKVPArr.length && !es4Supplemental.isAdvancedOption\" ng-class=\"!es4Supplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"es4Supplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in es4Supplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"es4Supplemental.isKeyDuplicated && $index === es4Supplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"es4Supplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"es4Supplemental.isKeyDuplicated && $index === es4Supplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"es4Supplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"es4Supplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"es4Supplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"es4Supplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"es4Supplemental.es4SupplementalObj\" ui-codemirror-opts=\"es4Supplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"es4Supplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!es4Supplemental.isSupplementalDetailChanging\" ng-click=\"es4Supplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!es4Supplemental.isSupplementalDetailChanging\" ng-click=\"es4Supplemental.fnSaveEs4Data(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"es4Supplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{es4Supplemental.parent.es4Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(es4Supplemental.parent.es4Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/fleet/fleetInfo/fleetSteps/script/script.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isEcuDetailsLoaded\"></div><div class=\"col-sm-12 p-0 height-100 floatingLabelInput\" ng-if=\"isEcuDetailsLoaded\" ng-init=\"fnInitScriptTab()\"><div class=\"col-sm-12 p-0 height-100\" ng-if=\"isShowScript\"><ui-codemirror class=\"userDataEditor\" ng-model=\"scriptObj.script\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{ecuObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(ecuObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"!isCommandExecuteing\" ng-disabled=\"!scriptObj.script.length\" ng-click=\"fnExecuteCommand()\">Execute Command</button><div class=\"pull-right\" ng-if=\"isCommandExecuteing\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewayClusters/gatewayClusters.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"GatewayClustersCtrl as gatewayClusters\" ng-init=\"gatewayClusters.fnInitGatewayClusters()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"!gatewayClusters.isgatewayClustersDetailsLoaded\"><table-loader hide-circle=\"true\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"gatewayClusters.isgatewayClustersDetailsLoaded && !gatewayClusters.isShowAddCluster\"><div class=\"col-sm-12 p-0 m-t-5 viewClusterSearchBar\" ng-if=\"gatewayClusters.gatewayClustersArr.length\"><div class=\"col-sm-12 floatingLabelInput p-0 d-flex federation-searchDiv\"><div class=\"md-input m-b-13 m-t-15 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" placeholder=\"Search for cluster\" ng-model=\"gatewayClusters.search[gatewayClusters.filter]\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div><div class=\"col-sm-12 p-0\"><table class=\"clusters-table table table-striped table-check-box m-b-0\"><thead><tr><th ng-if=\"gatewayClusters.gatewayClustersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllCG\" ng-model=\"gatewayClusters.isAllgatewayClustersChecked\" ng-click=\"gatewayClusters.fnCheckUncheckGatewayClusterAll()\"> <label for=\"checkAllCG\" class=\"check-box\"></label></th><th ng-if=\"gatewayClusters.gatewayClustersArr.length\">Name</th></tr></thead><tbody id=\"gatewayAllClusters\" ng-if=\"gatewayClusters.gatewayClustersArr.length\"><tr ng-repeat=\"gatewayClusterObj in gatewayClusters.gatewayClustersArr | filter: gatewayClusters.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkCG_{{$index}}\" ng-model=\"gatewayClusterObj.isCheck\" ng-change=\"gatewayClusters.fnCheckUncheckGatewayClusterHeader(gatewayClusterObj)\"> <label for=\"chkCG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{gatewayClusterObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{gatewayClusterObj.description}}</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!gatewayClusters.gatewayClustersArr.length\"><button class=\"btn btn-primary\" ng-if=\"gatewayClusters.permissionObj.AddGateway\" ng-click=\"gatewayClusters.fnHideShowAddClusters()\">Add Clusters</button></div></div></div><div class=\"col-sm-12\" ng-if=\"gatewayClusters.isShowAddCluster\"><div id=\"addClusterContainer\"><div class=\"headerTitle p-t-15 p-b-15\"><label>Add Cluster</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"gatewayClusters.fnHideShowAddClusters()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><search-directive field-arr=\"gatewayClusters.searchFieldArr\" filter-query=\"gatewayClusters.filterQuery\" state-name=\"\'main.cluster\'\" fn-filter-query-change=\"gatewayClusters.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"gatewayClusters.fnSetTabHeight()\"></search-directive><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"gatewayClusters.isClustersLoading\" hide-circle=\"true\" fn-resize=\"gatewayClusters.fnSetLoaderTableHeight()\"></table-loader><div class=\"table-container clusters-table\"><table id=\"clusters-table\" class=\"table table-striped table-check-box\" ng-if=\"!gatewayClusters.isClustersLoading\"><thead><tr><th ng-if=\"gatewayClusters.clustersArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllCluster\" ng-model=\"gatewayClusters.isAllChecked\" ng-click=\"gatewayClusters.fnCheckUncheckAll()\"> <label for=\"checkAllCluster\" class=\"check-box\"></label></th><th ng-if=\"gatewayClusters.clustersArr.length\">Name</th><th ng-if=\"!gatewayClusters.clustersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"cluster in gatewayClusters.clustersArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkCluster_{{$index}}\" ng-model=\"cluster.isCheck\" ng-change=\"gatewayClusters.fnCheckUncheckHeader(cluster)\"> <label for=\"chkCluster_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{cluster.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{cluster.description}}</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!gatewayClusters.isClustersLoading && gatewayClusters.clustersArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{gatewayClusters.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"gatewayClusters.perPage = 10; gatewayClusters.fnPageChanged(gatewayClusters.currentPage, gatewayClusters.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"gatewayClusters.perPage = 20; gatewayClusters.fnPageChanged(gatewayClusters.currentPage, gatewayClusters.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"gatewayClusters.perPage = 50; gatewayClusters.fnPageChanged(gatewayClusters.currentPage, gatewayClusters.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"gatewayClusters.perPage = 100; gatewayClusters.fnPageChanged(gatewayClusters.currentPage,gatewayClusters.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"gatewayClusters.perPage = 500; gatewayClusters.fnPageChanged(gatewayClusters.currentPage, gatewayClusters.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"gatewayClusters.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"gatewayClusters.currentPage\" items-per-page=\"gatewayClusters.perPage\" max-size=\"gatewayClusters.maxSize\" boundary-links=\"true\" ng-click=\"gatewayClusters.fnPageChanged(gatewayClusters.currentPage, gatewayClusters.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!gatewayClusters.isClusterAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"gatewayClusters.fnAddClusterToGateway()\">Add</button></div><div class=\"col-sm-12 m-t-10\" ng-if=\"gatewayClusters.isClusterAdding\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"!gatewayClusters.permissionObj.List\"><div class=\"col-sm-12\"><strong>No Records Found...</strong></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((!gatewayClusters.isShowAddCluster && gatewayClusters.permissionObj.AddGateway) || (gatewayClusters.selectedClustersArr.length && gatewayClusters.permissionObj.RemoveGateway)) && gatewayClusters.isgatewayClustersDetailsLoaded\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!gatewayClusters.isShowAddCluster && gatewayClusters.permissionObj.AddGateway\" ng-click=\"gatewayClusters.fnHideShowAddClusters()\"><a class=\"btn btn-link\">Add Cluster</a></li><li ng-if=\"gatewayClusters.selectedClustersArr.length && gatewayClusters.permissionObj.RemoveGateway\" ng-click=\"gatewayClusters.fnDeleteGatewayCluster(gatewayClusters.selectedClustersArr)\"><a class=\"btn btn-link\">Remove Clusters</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewayGhost/gatewayGhost.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"GatewayGhostCtrl as gatewayGhost\" ng-init=\"gatewayGhost.fnInitGatewayGhost()\"><div class=\"content-main\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!gatewayGhost.isGatewayGhostDetailsLoaded || !gatewayGhost.isAttributeAnalyticsDataFetch\"></div><div class=\"col-sm-12 ghostLayoutContainer\" ng-if=\"gatewayGhost.isGatewayGhostDetailsLoaded && gatewayGhost.isAttributeAnalyticsDataFetch\"><div ng-if=\"gatewayGhost.selectedTab.tabIndex === 0\"><div class=\"col-sm-12 p-0 viewGhostSearchBar floatingLabelInput d-flex\"><div class=\"md-input m-b-20 m-t-15 w100\"><input required=\"\" class=\"md-form-control p-l-35\" ng-model=\"gatewayGhost.search[gatewayGhost.filter]\" placeholder=\"Search for telemetry\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"m-l-6\" ng-if=\"gatewayGhost.gatewayReportedArr.length\"><div class=\"dropdown no-hover customDropdown-icon\" style=\"top: 23px;\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"gatewayGhost.fnOpenExportModal()\"><i class=\"m-r-5 fa fa-file\"></i>Export</a></li><li ng-hide=\"true\"><a ng-csv=\"gatewayGhost.getDeviceCSVData()\" id=\"csvAnchorGhost\" csv-header=\"gatewayGhost.csvHeaderArr\" filename=\"{{\'gatewayGhost_\' + gatewayObj.id + \'.csv\'}}\"></a></li></ul></div></div></div><div class=\"ghostAttributesLayout-table-normal table-container ghostAttributeNewUI\" ng-if=\"!gatewayGhost.isGhostDetailsEditable\"><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayGhost.gatewayReportedArr.length\"><div class=\"col-sm-12 p-0\" id=\"noComponentReportedData\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><svg viewbox=\"0 0 512.00037 512\" xmlns=\"http://www.w3.org/2000/svg\"><g fill-rule=\"evenodd\"><path d=\"m248.953125 61.273438c-5.367187-1.238282-10.722656 2.101562-11.964844 7.46875-1.242187 5.367187 2.105469 10.726562 7.472657 11.96875 24.8125 5.734374 47.492187 18.332031 65.582031 36.421874 53.183593 53.183594 53.183593 139.726563 0 192.910157-53.183594 53.1875-139.726563 53.1875-192.910157 0-53.1875-53.183594-53.1875-139.726563 0-192.910157 15.269532-15.269531 33.339844-26.40625 53.710938-33.109374 5.230469-1.71875 8.078125-7.355469 6.359375-12.589844-1.722656-5.234375-7.363281-8.082032-12.59375-6.359375-23.367187 7.683593-44.085937 20.453125-61.582031 37.953125-60.964844 60.964844-60.964844 160.160156 0 221.125 30.480468 30.480468 70.519531 45.722656 110.5625 45.722656 40.039062-.003906 80.078125-15.242188 110.5625-45.722656 60.960937-60.964844 60.960937-160.160156 0-221.125-20.738282-20.734375-46.738282-35.175782-75.199219-41.753906zm0 0\"></path><path d=\"m498.414062 432.707031-104.53125-104.53125c53.601563-84.054687 41.863282-194.484375-29.265624-265.617187-40.339844-40.339844-93.976563-62.558594-151.027344-62.558594-57.054688 0-110.691406 22.21875-151.03125 62.558594-40.34375 40.339844-62.558594 93.976562-62.558594 151.03125 0 57.050781 22.214844 110.6875 62.558594 151.027344 40.339844 40.339843 93.972656 62.554687 151.023437 62.554687 40.945313 0 80.386719-11.484375 114.59375-33.289063l104.53125 104.53125c8.746094 8.75 20.414063 13.566407 32.855469 13.566407 12.4375 0 24.105469-4.816407 32.855469-13.566407 18.109375-18.117187 18.109375-47.589843-.003907-65.707031zm-14.105468 51.601563c-4.980469 4.976562-11.636719 7.71875-18.746094 7.71875-7.113281 0-13.769531-2.742188-18.75-7.71875l-110.304688-110.304688c-1.929687-1.933594-4.484374-2.921875-7.054687-2.921875-1.976563 0-3.960937.582031-5.683594 1.777344-32.410156 22.480469-70.515625 34.363281-110.1875 34.363281-51.722656 0-100.347656-20.140625-136.917969-56.710937-75.5-75.5-75.5-198.347657 0-273.847657 36.574219-36.574218 85.199219-56.714843 136.925782-56.714843 51.722656 0 100.347656 20.140625 136.921875 56.714843 66.28125 66.285157 75.683593 170.207032 22.347656 247.105469-2.75 3.964844-2.269531 9.324219 1.144531 12.738281l110.304688 110.304688c10.335937 10.335938 10.335937 27.15625 0 37.496094zm0 0\"></path><path d=\"m273.804688 153.371094c-3.894532-3.894532-10.207032-3.894532-14.105469 0l-46.109375 46.109375-46.113282-46.109375c-3.894531-3.894532-10.210937-3.894532-14.105468 0-3.894532 3.894531-3.894532 10.210937 0 14.105468l46.109375 46.113282-46.109375 46.109375c-3.894532 3.894531-3.894532 10.210937 0 14.105469 1.945312 1.949218 4.5 2.921874 7.050781 2.921874 2.554687 0 5.105469-.972656 7.054687-2.921874l46.109376-46.109376 46.109374 46.109376c1.949219 1.949218 4.503907 2.921874 7.054688 2.921874 2.554688 0 5.105469-.972656 7.054688-2.921874 3.894531-3.894532 3.894531-10.210938 0-14.105469l-46.113282-46.109375 46.113282-46.113282c3.894531-3.894531 3.894531-10.210937 0-14.105468zm0 0\"></path><path d=\"m206.976562 77.328125c5.492188 0 9.972657-4.480469 9.972657-9.976563 0-5.492187-4.480469-9.972656-9.972657-9.972656-5.496093 0-9.976562 4.480469-9.976562 9.972656 0 5.496094 4.480469 9.976563 9.976562 9.976563zm0 0\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">No records found...</h2></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayGhost.gatewayReportedArr.length\"><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayGhost.isShowAllGhostAttributes\"><div class=\"col-sm-12 p-0\"><label>Unhealthy</label><table class=\"table table-striped table-check-box\" ng-show=\"gatewayGhost.isGatewayGhostDetailsLoaded && gatewayGhost.unhealthyComponentReportedArr.length\"><thead><tr><th ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost1\" ng-model=\"gatewayGhost.isAllChecked\" ng-click=\"gatewayGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost1\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\">Name</th><th ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\">Value</th><th ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"gatewayGhost.unhealthyComponentReportedArr.length\"></th><th ng-if=\"!gatewayGhost.unhealthyComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"unhealthyComponentReportedArr\"><tr ng-repeat=\"gatewayGhostObj in gatewayGhost.unhealthyComponentReportedArr | orderBy:\'health\' | filter: gatewayGhost.search track by $index\" context-menu=\"gatewayGhost.attributesContextMenu(gatewayGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghostUnhealthy_{{$index}}\" ng-model=\"gatewayGhostObj.isCheck\" ng-change=\"gatewayGhost.fnCheckUncheckHeader()\"> <label for=\"ghostUnhealthy_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': gatewayGhostObj.healthColor, \'color\': gatewayGhostObj.textColor}\"><span>{{gatewayGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\"><label class=\"ellipsis m-b-0\"><i ng-if=\"gatewayGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{gatewayGhostObj.name}}\" tooltip-placement=\"auto\">{{gatewayGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!gatewayGhostObj.isProcessing\">updated {{gatewayGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"gatewayGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"gatewayGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{gatewayGhostObj.displayValue + \' \' + gatewayGhostObj.unit}}\" tooltip-placement=\"left\">{{gatewayGhostObj.displayValue + \" \" + gatewayGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><spark-line-chart chart-class=\"{{gatewayGhostObj.name+$index}}\" chart-data=\"gatewayGhostObj.inlineChartData\"></spark-line-chart></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"gatewayGhost.fnOpenAttributeStatistics(gatewayGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"gatewayGhost.gatewayPermissionObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': gatewayGhost.isDropUp }\" ng-click=\"gatewayGhost.toggleDropUp(\'unhealthyComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"gatewayGhostObj.editable\" ng-click=\"gatewayGhost.fnEditGhostValue(gatewayGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"gatewayGhost.fnRenameAttribute(gatewayGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"gatewayGhost.issuePermissionsObj.List || gatewayGhost.issuePermissionsObj.Create\" ng-click=\"gatewayGhost.fnManageIssue(gatewayGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!gatewayGhost.unhealthyComponentReportedArr.length\" id=\"unhealthyComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 426.667 426.667\" style=\"enable-background:new 0 0 426.667 426.667;\" xml:space=\"preserve\"><path style=\"fill:#6AC259;\" d=\"M213.333,0C95.518,0,0,95.514,0,213.333s95.518,213.333,213.333,213.333 c117.828,0,213.333-95.514,213.333-213.333S331.157,0,213.333,0z M174.199,322.918l-93.935-93.931l31.309-31.309l62.626,62.622 l140.894-140.898l31.309,31.309L174.199,322.918z\"></path></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2 class=\"m-5\">Everything looks great.</h2></div><div class=\"col-sm-12 p-0 text-center\"><small>None of your attributes are reporting unhealthy telemetry.</small></div></div></div></div><div class=\"col-sm-12 p-0 m-t-0\"><label>Recently Updated</label><table class=\"table table-striped table-check-box\" ng-show=\"gatewayGhost.isGatewayGhostDetailsLoaded && gatewayGhost.recentlyUpdatedComponentReportedArr.length\"><thead><tr><th ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost2\" ng-model=\"gatewayGhost.isAllChecked\" ng-click=\"gatewayGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost2\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\">Name</th><th ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\">Value</th><th ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"gatewayGhost.recentlyUpdatedComponentReportedArr.length\"></th><th ng-if=\"!gatewayGhost.recentlyUpdatedComponentReportedArr.length\">No records found...</th></tr></thead><tbody id=\"recentlyUpdatedComponentReportedArr\"><tr ng-repeat=\"gatewayGhostObj in gatewayGhost.recentlyUpdatedComponentReportedArr | orderBy:\'timestamp\':true | filter: gatewayGhost.search track by $index\" context-menu=\"gatewayGhost.attributesContextMenu(gatewayGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghostRecently_{{$index}}\" ng-model=\"gatewayGhostObj.isCheck\" ng-change=\"gatewayGhost.fnCheckUncheckHeader()\"> <label for=\"ghostRecently_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': gatewayGhostObj.healthColor, \'color\': gatewayGhostObj.textColor}\"><span>{{gatewayGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\"><label class=\"ellipsis m-b-0\"><i ng-if=\"gatewayGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{gatewayGhostObj.name}}\" tooltip-placement=\"auto\">{{gatewayGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!gatewayGhostObj.isProcessing\">updated {{gatewayGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"gatewayGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"gatewayGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{gatewayGhostObj.displayValue + \' \' + gatewayGhostObj.unit}}\" tooltip-placement=\"left\">{{gatewayGhostObj.displayValue + \" \" + gatewayGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><spark-line-chart ng-if=\"gatewayGhostObj.health > 299\" chart-class=\"{{gatewayGhostObj.name+$index}}\" chart-data=\"gatewayGhostObj.inlineChartData\"></spark-line-chart></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"gatewayGhost.fnOpenAttributeStatistics(gatewayGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"gatewayGhost.gatewayPermissionObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': gatewayGhost.isDropUp }\" ng-click=\"gatewayGhost.toggleDropUp(\'recentlyUpdatedComponentReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"gatewayGhostObj.editable\" ng-click=\"gatewayGhost.fnEditGhostValue(gatewayGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"gatewayGhost.fnRenameAttribute(gatewayGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"gatewayGhost.issuePermissionsObj.List || gatewayGhost.issuePermissionsObj.Create\" ng-click=\"gatewayGhost.fnManageIssue(gatewayGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table><div class=\"col-sm-12 p-0\" ng-show=\"!gatewayGhost.recentlyUpdatedComponentReportedArr.length\" id=\"recentlyUpdatedComponentReported\"><div class=\"col-sm-12 p-0 componentReportedCSS\"><div class=\"col-sm-12 p-0 iconCSS\"><?xml version=\"1.0\" encoding=\"iso-8859-1\"?><svg version=\"1.1\" id=\"Capa_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewbox=\"0 0 383.189 383.189\" style=\"enable-background:new 0 0 383.189 383.189;\" xml:space=\"preserve\" class=\"reportedComponentFillColor\"><g><path d=\"M297.184,164.538c-1.4-1.12-3.173-1.663-4.96-1.52h-26.88l25.2-28.16l2.4-2.64l1.52-1.84 c0.429-0.592,0.778-1.237,1.04-1.92c0.303-0.737,0.466-1.523,0.48-2.32c0.201-1.867-0.706-3.68-2.32-4.64 c-2.103-0.966-4.409-1.406-6.72-1.28h-31.68c-1.669-0.093-3.317,0.418-4.64,1.44c-1.106,0.93-1.725,2.316-1.68,3.76 c0,2.133,0.72,3.467,2.16,4c2.082,0.577,4.242,0.82,6.4,0.72h20.48c-0.8,1.2-1.92,2.56-3.36,4.24l-5.28,5.92l-6.88,8l-8,9.12 c-2.88,3.2-4.773,5.387-5.68,6.56c-1.885,2.418-1.643,5.868,0.56,8c1.679,1.249,3.754,1.846,5.84,1.68h37.12 c1.774,0.142,3.538-0.37,4.96-1.44c1.058-0.959,1.642-2.333,1.6-3.76C298.901,166.969,298.288,165.538,297.184,164.538z\"></path></g><g><path d=\"M381.104,119.578c-1.74-1.39-3.939-2.075-6.16-1.92h-33.84l31.6-35.28l2.96-3.28l1.92-2.32 c0.528-0.742,0.958-1.549,1.28-2.4c0.363-0.917,0.552-1.894,0.56-2.88c0.223-2.333-0.933-4.583-2.96-5.76 c-2.629-1.206-5.512-1.755-8.4-1.6h-39.68c-2.096-0.143-4.172,0.483-5.84,1.76c-1.378,1.173-2.145,2.911-2.08,4.72 c0,2.72,0.907,4.373,2.72,4.96c2.6,0.739,5.299,1.063,8,0.96h25.6c-1.067,1.493-2.453,3.253-4.16,5.28l-6.64,7.52l-8.64,9.6 l-10.32,11.44c-3.573,4-5.92,6.667-7.04,8c-2.54,3.085-2.224,7.618,0.72,10.32c2.11,1.59,4.726,2.357,7.36,2.16h46.64 c2.258,0.284,4.541-0.287,6.4-1.6c1.359-1.187,2.121-2.916,2.08-4.72C383.253,122.659,382.492,120.845,381.104,119.578z\"></path></g><g><path d=\"M353.504,254.298c-2.279-2.359-5.767-3.089-8.8-1.84c-86.708,35.894-186.097-5.298-221.992-92.007 c-18.227-44.031-17.127-93.693,3.032-136.873c1.889-3.994,0.182-8.763-3.812-10.652c-2.05-0.97-4.416-1.023-6.508-0.148 C20.363,51.827-25.044,160.545,14.005,255.606s147.767,140.468,242.829,101.419c43.356-17.81,78.394-51.325,98.111-93.848 C356.332,260.203,355.761,256.682,353.504,254.298z M186.224,355.098c-93.977-0.016-170.147-76.212-170.131-170.189 c0.01-61.708,33.428-118.574,87.331-148.611c-6.383,18.946-9.626,38.808-9.6,58.8c0.005,102.813,83.356,186.156,186.169,186.151 c17.231-0.001,34.378-2.394,50.951-7.111C299.919,324.303,245.207,354.91,186.224,355.098z\"></path></g></svg></div><div class=\"col-sm-12 p-0 text-center\"><h2>Wow this gateway is quiet!</h2></div></div></div></div><div class=\"col-sm-12 p-0\"><button class=\"btn p-b-0 p-t-0 p-r-0 btn-link pull-right\" ng-click=\"gatewayGhost.fnShowAllGhostAttributes()\">See all attributes</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"gatewayGhost.isShowAllGhostAttributes\"><table class=\"table table-striped table-check-box\" ng-show=\"gatewayGhost.isGatewayGhostDetailsLoaded\"><thead><tr><th ng-if=\"gatewayGhost.gatewayReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost\" ng-model=\"gatewayGhost.isAllChecked\" ng-click=\"gatewayGhost.fnCheckUncheckAll()\"> <label for=\"checkAllGhost\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"gatewayGhost.gatewayReportedArr.length\"></th><th ng-if=\"gatewayGhost.gatewayReportedArr.length\">Name</th><th ng-if=\"gatewayGhost.gatewayReportedArr.length\">Value</th><th ng-if=\"gatewayGhost.gatewayReportedArr.length\"></th><th ng-if=\"gatewayGhost.gatewayReportedArr.length\"></th><th ng-if=\"!gatewayGhost.gatewayReportedArr.length\">No records found...</th></tr></thead><tbody id=\"gatewayReportedArr\"><tr ng-repeat=\"gatewayGhostObj in gatewayGhost.gatewayReportedArr | filter: gatewayGhost.search track by $index\" context-menu=\"gatewayGhost.attributesContextMenu(gatewayGhostObj)\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}\" ng-model=\"gatewayGhostObj.isCheck\" ng-change=\"gatewayGhost.fnCheckUncheckHeader()\"> <label for=\"ghost_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\': gatewayGhostObj.healthColor, \'color\': gatewayGhostObj.textColor}\"><span>{{gatewayGhostObj.healthName}}</span></button></td><td class=\"attributeTdCSS\"><label class=\"ellipsis m-b-0\"><i ng-if=\"gatewayGhostObj.editable === true\" class=\"fa fa-sliders\"></i> <span class=\"pos-top-0\" uib-tooltip=\"Reference Name: {{gatewayGhostObj.name}}\" tooltip-placement=\"auto\">{{gatewayGhostObj.displayName}}</span></label> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"!gatewayGhostObj.isProcessing\">updated {{gatewayGhostObj.humanDateLastUpdatedRelative}}</span> <span class=\"ellipsis attributeRelativeTime\" ng-if=\"gatewayGhostObj.isProcessing\">Processing...</span></td><td ng-class=\"gatewayGhostObj.enabled === false?\'attributeDisableColor\':\'\'\"><span class=\"ellipsis\" uib-tooltip=\"{{gatewayGhostObj.displayValue + \' \' + gatewayGhostObj.unit}}\" tooltip-placement=\"left\">{{gatewayGhostObj.displayValue + \" \" + gatewayGhostObj.unit}}</span></td><td><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center\"><div class=\"col-sm-8 p-0\"><spark-line-chart ng-if=\"gatewayGhostObj.health > 299\" chart-class=\"{{gatewayGhostObj.name+$index}}\" chart-data=\"gatewayGhostObj.inlineChartData\"></spark-line-chart></div><div class=\"col-sm-4 p-0 customDropdown-icon\"><a class=\"link-primary p-0\" ng-click=\"gatewayGhost.fnOpenAttributeStatistics(gatewayGhostObj)\"><span class=\"customMenuBar\" style=\"font-size: 13px\"><i class=\"fa fa-bar-chart m-t-6 m-l-4\"></i></span></a></div></div></td><td class=\"text-right\"><div ng-if=\"gatewayGhost.gatewayPermissionObj.ModifyGhost\" class=\"dropdown customDropdown-icon m-r-20\" ng-class=\"{ \'dropup\': gatewayGhost.isDropUp }\" ng-click=\"gatewayGhost.toggleDropUp(\'gatewayReportedArr\',$event)\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"gatewayGhostObj.editable\" ng-click=\"gatewayGhost.fnEditGhostValue(gatewayGhostObj)\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"gatewayGhost.fnRenameAttribute(gatewayGhostObj)\"><a class=\"btn btn-link\">Rename</a></li><li ng-if=\"gatewayGhost.issuePermissionsObj.List || gatewayGhost.issuePermissionsObj.Create\" ng-click=\"gatewayGhost.fnManageIssue(gatewayGhostObj)\"><a class=\"btn btn-link\">Manage Issue</a></li></ul></div></td></tr></tbody></table></div></div></div><div ng-if=\"gatewayGhost.isGhostDetailsEditable\"><div class=\"m-t-15 m-b-15\"><span ng-click=\"gatewayGhost.fnGoBackToTableView()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Table</label></a></span></div><schema-directive type-arr=\"gatewayGhost.selectedGhostObj\" fn-check-type-validion=\"gatewayGhost.fnCheckTypeFormValidation(isValidate, propertiesObj)\"></schema-directive><div class=\"pull-right\" ng-if=\"gatewayGhost.isEditInputValidated\"><button class=\"btn btn-primary\" ng-click=\"gatewayGhost.fnUpdateGhostValue()\" ng-if=\"gatewayGhost.isGhostUpdateCompleted\">Update Ghost</button><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!gatewayGhost.isGhostUpdateCompleted\"></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewayLocation/gatewayLocation.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"GatewayLocationCtrl as gatewayLocation\" ng-init=\"gatewayLocation.fnInitGatewayLocation()\"><div class=\"content-main\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!gatewayLocation.isGatewayLocationDetailsLoaded\"></div><div class=\"col-sm-12 p-t-10 p-l-10 p-r-10 floatingLabelInput\" ng-if=\"gatewayLocation.isGatewayLocationDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-10\" id=\"locationInputBlock\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"lat\" type=\"text\" ng-model=\"gatewayLocation.actualLatitude\" ng-change=\"gatewayLocation.fnChangeLocation()\" placeholder=\"Latitude for Gateway*\"> <span class=\"highlight\"></span> <label>Latitude*</label></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"long\" type=\"text\" ng-change=\"gatewayLocation.fnChangeLocation()\" ng-model=\"gatewayLocation.actualLongitude\" placeholder=\"Longitude for Gateway*\"> <span class=\"highlight\"></span> <label>Longitude*</label></div></div><div class=\"col-sm-12 p-0\"><h3>Drag marker to set coordinates</h3></div></div><div class=\"col-sm-12 p-0 p-b-10\" id=\"locationMapBlock\"><div class=\"col-sm-12 p-0\" id=\"gatewayLocationMap\"></div></div><div class=\"col-sm-12 p-0\" id=\"locationSaveActionBlock\" ng-if=\"gatewayLocation.gatewayPermissionsObj.Modify\"><div class=\"pull-right\" ng-if=\"gatewayLocation.isSaveLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button ng-if=\"!gatewayLocation.isSaveLoaderActive\" ng-disabled=\"!gatewayLocation.actualLatitude.toString().length || !gatewayLocation.actualLongitude.toString().length\" class=\"btn btn-primary pull-right\" ng-click=\"gatewayLocation.fnSaveLocationInfo()\">Save</button></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewayOverview/gatewayOverview.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"GatewayOverviewCtrl as gatewayOverview\" ng-init=\"gatewayOverview.fnInitGatewayOverview()\"><div class=\"content-main\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0\"><h4 class=\"m-t-10 m-b-0 p-b-5 font-italic ellipsis\">{{gatewayObj.description}}</h4><h2 class=\"m-t-0 m-b-0 p-b-5 ellipsis\">{{gatewayObj.name}}</h2></div><div class=\"col-sm-6 p-0 m-t-10 text-right\" ng-class=\"gatewayOverview.isGatewayAggregateDataLoading || gatewayOverview.isBarCharLoading ? \'pace opacity-5\' : \'\'\"><span class=\"cursor-pointer p-r-5\" ng-repeat=\"filterOption in gatewayOverview.filterOptions track by $index\" ng-class=\"gatewayOverview.selectedFilterOption.tabIndex === filterOption.tabIndex ? \'overview-active-link\' : \'\'\" ng-click=\"gatewayOverview.fnChangeFilterOption(filterOption)\">{{filterOption.value}} <i ng-if=\"(gatewayOverview.filterOptions.length - 1) === $index\" class=\"m-l-3 fa fa-caret-down\"></i></span> <span ng-repeat=\"chartType in gatewayOverview.chartOptions track by $index\" ng-click=\"gatewayOverview.fnChangeChartType(chartType)\" ng-class=\"gatewayOverview.selectedChartType.tabIndex === chartType.tabIndex ? \'overview-active-link\' : \'\'\"><i class=\"cursor-pointer fa\" ng-class=\"$index === 0 ? \'m-l-5 m-r-5 \' + chartType.icon : chartType.icon\"></i></span></div></div><div class=\"col-sm-12 p-0 m-t-5\" ng-if=\"gatewayOverview.selectedChartType.tabIndex === 0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Health</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 160px;\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.isGatewayAggregateDataLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!gatewayOverview.isGatewayAggregateDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.aggregateHealthArr.length\"><heat-map-chart node-id=\"gatewayObj.id\" info-section-class=\"gatewayOverview.infoSectionClass\" type=\"\'health\'\" filter-obj=\"gatewayOverview.selectedFilterObj\" is-aggregate-health=\"true\" comp-arr=\"[\'Gateway\']\" chart-data=\"gatewayOverview.aggregateHealthArr\" categories-arr=\"gatewayOverview.aggregateCategoriesArr\"></heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!gatewayOverview.aggregateHealthArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div><div class=\"col-sm-12 p-0\"><h3 class=\"m-0 p-b-5 titleWithBorderBottom\">Connection</h3></div><div class=\"col-sm-12 p-0 m-b-20 aggregateHealth d-flex\" style=\"min-height: 160px\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.isBarCharLoading\"><div class=\"aggregate-height\"><span class=\"chart-export-button\"></span> <span class=\"aggregate-health-chart\"></span> <span class=\"aggregate-health-chart-animation\"></span><div class=\"aggregate-health-chart-date-plotting\"><span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span> <span class=\"chart-date-label\"></span></div></div></div><div class=\"col-sm-12 p-0 animationIfOverview d-flex\" ng-if=\"!gatewayOverview.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.gatewayConnectionArr.length\"><connection-heat-map-chart node-id=\"gatewayObj.id\" info-section-class=\"gatewayOverview.infoSectionClass\" type=\"\'connection\'\" filter-obj=\"gatewayOverview.selectedFilterObj\" comp-arr=\"[\'Gateway\']\" chart-data=\"gatewayOverview.gatewayConnectionArr\" categories-arr=\"gatewayOverview.aggregateCategoriesArr\"></connection-heat-map-chart></div><div class=\"col-sm-12 p-0 m-t-20 d-flex justify-content-center align-items-center\" style=\"display: flex; flex-direction: column; justify-content: center; align-items: center\" ng-if=\"!gatewayOverview.gatewayConnectionArr.length\"><label>No results found for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-12 p-0 m-t-5\" ng-if=\"gatewayOverview.selectedChartType.tabIndex === 1\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0 m-t-0\"><div class=\"col-sm-12 p-0\"><label>Gateway Health</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"gatewayOverview.isGatewayAggregateDataLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayOverview.isGatewayAggregateDataLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.gatewayHealthPieData.length\"><pie-chart chart-full-size=\"true\" node-id=\"gatewayObj.id\" filter-obj=\"gatewayOverview.selectedFilterObj\" type=\"\'health\'\" is-show-label=\"true\" chart-class=\"gatewayPieMainContainer\" chart-data=\"gatewayOverview.gatewayHealthPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!gatewayOverview.gatewayHealthPieData.length\"><label>No results found for gateway health for the selected range.</label> <label>Please select another range.</label></div></div></div></div><div class=\"col-sm-6 p-0 m-t-0\"><div class=\"col-sm-12 p-0\"><label>Gateway Connection</label></div><div class=\"col-sm-12 p-0 d-flex\" style=\"min-height: 375px\"><div class=\"col-sm-12 p-0 d-flex align-items-center justify-content-center\" ng-if=\"gatewayOverview.isBarCharLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayOverview.isBarCharLoading\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.gatewayConnectionPieData.length\"><pie-chart chart-full-size=\"true\" node-id=\"gatewayObj.id\" filter-obj=\"gatewayOverview.selectedFilterObj\" type=\"\'connection\'\" chart-class=\"gatewayPieConnectionMainContainer\" chart-data=\"gatewayOverview.gatewayConnectionPieData\"></pie-chart></div><div class=\"col-sm-12 p-0 text-center\" ng-if=\"!gatewayOverview.gatewayConnectionPieData.length\"><label>No results found for gateway connection for the selected range.</label> <label>Please select another range.</label></div></div></div></div></div></div></div><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><h3 class=\"m-0\" ng-class=\"{\'titleWithBorderBottom p-b-5\': gatewayOverview.selectedChartType.tabIndex === 0}\">Devices</h3><button class=\"btn btn-link p-l-5 p-t-2\" style=\"position: absolute;top: -3px;left: 60px;\" ng-click=\"gatewayOverview.fnGoToDevices()\">View</button></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"gatewayOverview.isPieChartLoading\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!gatewayOverview.isPieChartLoading\"><div class=\"w100 d-flex align-items-center\" ng-if=\"gatewayOverview.gatewayPieData.length\"><pie-chart chart-class=\"componentPieMainContainer\" chart-data=\"gatewayOverview.gatewayPieData\"></pie-chart><div class=\"d-flex flex-column m-t-13 m-r-10 text-center\"><span>Total</span> <label class=\"m-t-5\">{{gatewayOverview.totalItems}}</label></div><div class=\"d-flex flex-column m-t-13 m-r-10 text-center\" ng-repeat=\"healthObj in gatewayOverview.gatewayPieData track by $index\"><button class=\"btn btn-xs btn-default\" uib-tooltip=\"{{healthObj.name}}\" ng-style=\"{\'background-color\': healthObj.color, \'color\': healthObj.healthTextColor}\" tooltip-placement=\"auto\"><span class=\"healtSpan\">{{healthObj.name}}</span></button> <label class=\"m-t-5\">{{healthObj.y}}</label></div></div><div class=\"w100 d-flex align-items-center m-t-20 m-b-20\" ng-if=\"!gatewayOverview.gatewayPieData.length\">No devices found for this gateway</div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem\"><div class=\"pull-right\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewaySupplemental/gatewaySupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"GatewaySupplementalCtrl as gatewaySupplemental\" ng-init=\"gatewaySupplemental.fnInitGatewaySupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!gatewaySupplemental.isGatewaySupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"gatewaySupplemental.isGatewaySupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 m-t-25\" ng-if=\"!gatewaySupplemental.supplementalKVPArr.length && !gatewaySupplemental.isAdvancedOption\"><div class=\"create-screen\"><div class=\"row content\"><div class=\"col-sm-12\"><label>There are no supplemental data for this device.</label></div></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!gatewaySupplemental.isAdvancedOption\" ng-class=\"!gatewaySupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"gatewaySupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in gatewaySupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"gatewaySupplemental.isKeyDuplicated && $index === gatewaySupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"gatewaySupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Keys must be unique.\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"gatewaySupplemental.isKeyDuplicated && $index === gatewaySupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-6 p-0\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"gatewaySupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" placeholder=\"Supplemental Value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\"> <span class=\"highlight\"></span> <label>Value</label> <span class=\"typeInfoQb\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-click=\"gatewaySupplemental.fnInjectFunction()\"><span id=\"timeId1\"><em>f<small>(x)</small></em></span></a></span><div class=\"supplementalInputBorder-part\"></div><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"col-sm-1 p-r-10 p-r-0 m-t-5\"><button ng-if=\"gatewaySupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"gatewaySupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"$last\"><div class=\"p-0 pull-right\" ng-if=\"gatewaySupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary m-r-2\" ng-if=\"$last && kvpPair.key.length && kvpPair.value.length && !gatewaySupplemental.isKeyDuplicated\" ng-click=\"gatewaySupplemental.fnAddSupplementalKey()\">New Entry</button></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"gatewaySupplemental.isSupplementalDetailsEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"gatewaySupplemental.fnResetDetails()\">Cancel</button><div class=\"pull-right\"><button class=\"btn btn-sm btn-primary\" ng-if=\"!gatewaySupplemental.isSupplementalDetailChanging\" ng-disabled=\"gatewaySupplemental.isKeyDuplicated\" ng-click=\"gatewaySupplemental.fnSaveGatewayData()\">Save</button></div><div class=\"m-t-5 pull-right\" ng-if=\"gatewaySupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\" ng-if=\"gatewaySupplemental.isAdvancedOption && !gatewaySupplemental.isSupplementalDetailsEditable\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"gatewaySupplemental.gatewaySupplementalObj\" ui-codemirror-opts=\"gatewaySupplemental.editorOptions\"></ui-codemirror></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"gatewaySupplemental.isSupplementalEditable\"><button class=\"btn btn-sm btn-primary\" ng-click=\"gatewaySupplemental.fnToggle()\">Cancel</button> <button class=\"btn btn-sm btn-primary pull-right\" ng-if=\"!gatewaySupplemental.isSupplementalEditableUpdate\" ng-click=\"gatewaySupplemental.fnEditDeviceData(gatewaySupplemental.gatewaySupplementalObj)\">Save</button><div class=\"m-t-5 pull-right\" ng-if=\"gatewaySupplemental.isSupplementalEditableUpdate\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div><div class=\"col-sm-12\"><div class=\"pull-right\" ng-if=\"!gatewaySupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-sm btn-primary\" ng-click=\"gatewaySupplemental.fnAddSupplementalKey(true)\" ng-hide=\"gatewaySupplemental.isAdvancedOption\">New Entry</button><div id=\"dropDown\" class=\"nav navbar-nav navbar-right p-l-2\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span><i class=\"fa fa-caret-down\"></i></span></button><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"split-button\"><li role=\"menuitem\"><a class=\"btn btn-link\" ng-disabled=\"gatewaySupplemental.isSupplementalEditable || gatewaySupplemental.isSupplementalDetailsEditable\" ng-click=\"gatewaySupplemental.fnOpenAdvancedMenu()\">{{gatewaySupplemental.isAdvancedOption === true ?\"Default\":\"Advance\"}}</a></li></ul></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"pull-right m-l-10\"><expand-collapse-container info-section-class=\"infoSectionClass\" fn-expand-collapse-event=\"fnGatewayInfoSectionFullScreen()\"></expand-collapse-container></div><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"!gatewaySupplemental.isObjectEmpty(gatewaySupplemental.gatewaySupplementalObj) && gatewaySupplemental.permissionObj.Modify\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"!gatewaySupplemental.isSupplementalDetailsEditable && !gatewaySupplemental.isAdvancedOption\" ng-click=\"gatewaySupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-if=\"gatewaySupplemental.isAdvancedOption\" ng-click=\"gatewaySupplemental.fnToggle(true)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/gateway/gatewayInfo/gatewayTabs/gatewayTopology/gatewayTopology.html","<div class=\"h-100\" ng-controller=\"GatewayTopologyCtrl as gatewayTopology\" ng-init=\"gatewayTopology.fnInitGatewayTopology()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!gatewayTopology.isGatewayTopologyDataLoaded\"></div><div class=\"col-sm-12 m-t-25 floatingLabelInput\" ng-if=\"gatewayTopology.isGatewayTopologyDataLoaded\"><div class=\"col-sm-12\"><user-tree-view tree-data=\"gatewayTopology.relationshipObj\"></user-tree-view></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{gatewayObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(gatewayObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"></div></div></div></div>");
$templateCache.put("app/node/health/healthInfo/healthTabs/healthSupplemental/healthSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"HealthSupplementalCtrl as healthSupplemental\" ng-init=\"healthSupplemental.fnInitHealthSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!healthSupplemental.parent.isHealthDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"healthSupplemental.parent.isHealthDetailsLoaded\" ng-init=\"healthSupplemental.fnGetHealthData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"healthSupplemental.supplementalKVPArr.length || healthSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!healthSupplemental.isSupplementalDetailsEditable && healthSupplemental.parent.userPermissionsObj.REPLACE_HEALTH_TAGS\" ng-click=\"healthSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"healthSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{healthSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!healthSupplemental.supplementalKVPArr.length && !healthSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"healthSupplemental.parent.userPermissionsObj.REPLACE_HEALTH_TAGS\" ng-click=\"healthSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"healthSupplemental.supplementalKVPArr.length && !healthSupplemental.isAdvancedOption\" ng-class=\"!healthSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"healthSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in healthSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"healthSupplemental.isKeyDuplicated && $index === healthSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"healthSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"healthSupplemental.isKeyDuplicated && $index === healthSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"healthSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"healthSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"healthSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"healthSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"healthSupplemental.healthSupplementalObj\" ui-codemirror-opts=\"healthSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"healthSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!healthSupplemental.isSupplementalDetailChanging\" ng-click=\"healthSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!healthSupplemental.isSupplementalDetailChanging\" ng-click=\"healthSupplemental.fnSaveHealthData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"healthSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{healthSupplemental.parent.healthObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(healthSupplemental.parent.healthObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/iot3/iot3Service/createIot3/iot3CreateSteps/details.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"createIot3.fnInitIot3()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createIot3.isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"createIot3.isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"createIot3.isIot3ReferenceLoaded\" ng-class=\"!createIot3.isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"engine\" type=\"text\" ng-model=\"createIot3.iot3Obj.iot3JSON.engine.engineType\" placeholder=\"Engine\" name=\"engine\"> <span class=\"highlight\"></span> <label>Engine</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"spec\" type=\"text\" ng-model=\"createIot3.iot3Obj.iot3JSON.iot3\" placeholder=\"IoT3 Spec\" name=\"spec\"> <span class=\"highlight\"></span> <label>IoT3 Spec</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"Iteration\" type=\"text\" ng-model=\"createIot3.iot3Obj.iot3JSON.info.revision\" placeholder=\"Iteration\" name=\"Iteration\"> <span class=\"highlight\"></span> <label>Revision</label></div><div class=\"col-sm-6 p-0\" ng-if=\"createIot3.iot3Obj.iot3JSON.info.labelsArr && createIot3.iot3Obj.iot3JSON.info.labelsArr.length\"><label>Labels</label><div class=\"col-sm-12 p-0\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-repeat=\"labelObj in createIot3.iot3Obj.iot3JSON.info.labelsArr\" ng-style=\"{\'background-color\': labelObj.bgColor, \'color\': labelObj.textColor}\"><span>{{labelObj.name}}</span></button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"createIot3.iot3Obj && createIot3.iot3Obj.iot3.length && createIot3.isChangesSync ? \'\' : \'pace opacity-5\'\" ng-click=\"createIot3.fnSaveIot3Reference()\" ng-if=\"!createIot3.isIot3ReferenceSaving\">Save Iot3 Reference</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"createIot3.isIot3ReferenceSaving\"></app-spinner></div></div>");
$templateCache.put("app/node/iot3/iot3Service/iot3Info/iot3Steps/details.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"fnInitializeResizeEvent()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isIot3ReferenceLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnDeleteIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-click=\"fnCloneIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isIot3ReferenceLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"engine\" type=\"text\" ng-model=\"engineType\" placeholder=\"Engine\" name=\"engine\"> <span class=\"highlight\"></span> <label>Engine</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"spec\" type=\"text\" ng-model=\"iot3Obj.iot3JSON.iot3\" placeholder=\"IoT3 Spec\" name=\"spec\"> <span class=\"highlight\"></span> <label>IoT3 Spec</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"Iteration\" type=\"text\" ng-model=\"iot3Obj.revision\" placeholder=\"Iteration\" name=\"Iteration\"> <span class=\"highlight\"></span> <label>Revision</label></div><div class=\"col-sm-6 p-0\" ng-if=\"iot3Obj.labelsArr && iot3Obj.labelsArr.length\"><label>Labels</label><div class=\"col-sm-12 p-0\"><button class=\"btn btn-xs btn-default m-r-2 m-b-2\" ng-repeat=\"labelObj in iot3Obj.labelsArr\" ng-style=\"{\'background-color\': labelObj.bgColor, \'color\': labelObj.textColor}\"><span>{{labelObj.name}}</span></button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{iot3Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(iot3Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/modals/createWorkspaceModal/createWorkspaceModal.html","<div class=\"form-content h-100\" ng-init=\"createWorkspace.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Create Iot3 Workspace</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"workSpaceName\" type=\"text\" ng-model=\"createWorkspace.workspaceObj.name\" placeholder=\"Name*\" name=\"workSpaceName\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"workSpaceDescription\" type=\"text\" ng-model=\"createWorkspace.workspaceObj.description\" placeholder=\"Description\" name=\"workSpaceDescription\"> <span class=\"highlight\"></span> <label>Description</label> <small class=\"helper-text\"></small></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-click=\"createWorkspace.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!createWorkspace.workspaceObj.name.length\" ng-click=\"createWorkspace.fnSave()\">{{createWorkspace.isEdit ? \'Save\' : \'Create\'}}</button></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/modals/expressionModal/expressionModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"expressionModal.fnInitModel()\"><div class=\"modal-header\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between align-items-center\"><h4 class=\"modal-title text-capitalize\">Expression Tester</h4><h3 class=\"modal-title text-capitalize\">[{{expressionModal.expressionObj.expressionType}}]</h3></div></div><div class=\"modal-body floatingLabelInput\"><div class=\"row height-100\"><div class=\"col-sm-12 height-100\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpression\" type=\"text\" ng-model=\"expressionModal.expressionObj.expression\" placeholder=\"Selector Expression*\" name=\"selectorExpression\"> <span class=\"highlight\"></span> <label>Selector Expression*</label> <small class=\"helper-text\"></small></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-click=\"expressionModal.fnTestExpression()\">Test Expression</button></div><div class=\"col-sm-12 p-0 m-t-10\" style=\"height: calc(100% - 50px); position: relative\"><div id=\"sampleDataContent\" class=\"sampleDataContent\"><div class=\"col-sm-12 p-l-0 p-t-15 w100 h-100\"><ui-codemirror ng-init=\"expressionModal.fnInitCalled()\" ng-model=\"expressionModal.sampleData\" ui-codemirror-opts=\"expressionModal.editorOptions\"></ui-codemirror></div></div><div id=\"extractedDataContent\" class=\"extractedDataContent\"><div class=\"col-sm-12 p-r-0 p-t-15 w100 h-100\"><textarea ng-if=\"expressionModal.expressionObj.expressionType !== \'xpath\' && expressionModal.expressionObj.expressionType !== \'xslt\'\" class=\"w100 h-100 p-15 overflow-auto\" ng-model=\"expressionModal.selectedSampleData\" readonly=\"\">\n\n                            </textarea><textarea ng-if=\"(expressionModal.expressionObj.expressionType === \'xpath\' || expressionModal.expressionObj.expressionType === \'xslt\') && !expressionModal.selectedSampleData.isCollection\" class=\"w100 h-100 p-15 overflow-auto\" ng-model=\"expressionModal.selectedSampleData.sampleDataVal\" readonly=\"\">\n\n                            </textarea><textarea ng-if=\"(expressionModal.expressionObj.expressionType === \'xpath\' || expressionModal.expressionObj.expressionType === \'xslt\') && expressionModal.selectedSampleData.isCollection\" class=\"w100 h-100 p-15 overflow-auto\" ng-model=\"expressionModal.selectedSampleData.arrText\" readonly=\"\">\n\n                            </textarea></div></div><div id=\"sidebar-resizer\" resizer=\"vertical\" resizer-width=\"10\" resizer-left=\"#sampleDataContent\" resizer-right=\"#extractedDataContent\" resizer-max=\"1500\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-left\" ng-click=\"expressionModal.fnCancel()\" tabindex=\"12\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button pull-right\" ng-click=\"expressionModal.fnSave()\" tabindex=\"12\">Use Expression</button></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/modals/sampleDataModal/sampleDataModal.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"sampleDataModal.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Sample Data</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100\" ng-init=\"sampleDataModal.fnInitCalled()\"><ui-codemirror ng-model=\"sampleDataModal.sampleDataObj.value\" ui-codemirror-opts=\"sampleDataModal.editorOptions\"></ui-codemirror></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link p-0 p-t-6 pull-right\" ng-click=\"sampleDataModal.fnCancel()\">Close</button></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/modals/workspaceListModal/workspaceListModal.html","<div class=\"form-content h-100\" ng-init=\"workspaceList.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">{{workspaceList.isGetBlueprints ? \'Select Iot3 Blueprint\' : \'Select Iot3 Workspace\'}}</h3></div><div class=\"modal-body\" style=\"overflow: hidden;\"><div class=\"content-box-content table-content-box p-0\"><v4-search-client ng-if=\"workspaceList.isRefreshed\" search-identifier=\"\'workspaceListModal\'\" filters-arr=\"workspaceList.searchFiltersArr\" filter-query=\"workspaceList.filterQuery\" fn-filter-query-change=\"workspaceList.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.workbench\'\" no-set-url=\"true\" fn-resize=\"workspaceList.fnSetTableHeight()\" sort-field-arr=\"workspaceList.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"workspaceList.isDataLoading\" hide-circle=\"true\" fn-resize=\"resourceModal.fnSetLoaderTableHeight()\"></table-loader><div class=\"workspaceList-table table-container\" id=\"securityGroupResourceModal\"><table class=\"table table-striped table-check-box\" ng-class=\"workspaceList.isShowLoader ? \'pace opacity-5\' : \'\'\" ng-if=\"!workspaceList.isDataLoading\"><thead><tr><th ng-if=\"workspaceList.dataArr.length\" class=\"p-8\"></th><th ng-if=\"workspaceList.dataArr.length\"><span>Name</span></th><th ng-if=\"workspaceList.dataArr.length\"></th><th ng-if=\"!workspaceList.dataArr.length\">No records found...</th></tr></thead><tbody id=\"userTable\"><tr ng-repeat=\"resource in workspaceList.dataArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"resource.isCheck\" ng-change=\"workspaceList.fnCheckUncheckHeader(resource)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{resource.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{resource.description}}</span></div></td><td><i class=\"fa fa-trash\" ng-if=\"!workspaceList.isHideDelete\" ng-click=\"workspaceList.fnDeleteWorkspace(resource)\"></i></td><td ng-if=\"!workspaceList.dataArr.length\">No records found...</td></tr></tbody></table><div class=\"pagination-container\" ng-if=\"!workspaceList.isDataLoading && workspaceList.dataArr.length\"><div class=\"row m-b-15\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{workspaceList.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"workspaceList.perPage = 1; workspaceList.fnPageChanged(workspaceList.currentPage, workspaceList.perPage, true)\">1</a></li><li><a class=\"btn btn-link\" ng-click=\"workspaceList.perPage = 10; workspaceList.fnPageChanged(workspaceList.currentPage, workspaceList.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"workspaceList.perPage = 20; workspaceList.fnPageChanged(workspaceList.currentPage, workspaceList.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"workspaceList.perPage = 50; workspaceList.fnPageChanged(workspaceList.currentPage, workspaceList.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"workspaceList.perPage = 100; workspaceList.fnPageChanged(workspaceList.currentPage,workspaceList.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"workspaceList.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"workspaceList.currentPage\" items-per-page=\"workspaceList.perPage\" max-size=\"workspaceList.maxSize\" boundary-links=\"true\" ng-click=\"workspaceList.fnPageChanged(workspaceList.currentPage, workspaceList.perPage)\"></ul></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link p-0 p-t-6 pull-left\" ng-if=\"!workspaceList.isShowLoader\" ng-click=\"workspaceList.fnCancel()\">Close</button><app-spinner class=\"pull-right\" spinner-type=\"\'microSpinner\'\" ng-if=\"workspaceList.isShowLoader\"></app-spinner><button type=\"button\" class=\"btn btn-primary\" ng-if=\"!workspaceList.isShowLoader\" ng-disabled=\"!(workspaceList.selectedWorkspace && workspaceList.selectedWorkspace.id)\" ng-click=\"workspaceList.fnSave()\">Open</button></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/attributes/attributes.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in attributesTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id, tab.tabIndex)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Attributes</h1><h2 class=\"m-0 m-t-10\">Define the attributes metadata, value expressions and dependencies.</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"row\"><div id=\"attributesMainContainer\" class=\"col-sm-12 overflow-hidden\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 m-t-5 searchContainer\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput d-flex\"><div class=\"md-input m-b-13 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"attrSearch[filter]\" placeholder=\"Search\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-5\"><div class=\"attrsTemplate-table table-container\"><table id=\"attrsTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-l-8\">Type</th><th>Key</th><th>Name</th><th>Mode</th><th class=\"p-r-8\">Status</th></tr></thead><tbody id=\"attributeTable\" class=\"overflow-auto\"><tr ng-repeat=\"attrObj in filterAttributes = (attributesArr | filter:attrSearch) track by $index\" ng-click=\"fnGetAttributeDetails(attrObj)\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{attrObj.parentName}}</label></td><td><label class=\"m-0 ellipsis-label\">{{attrObj.id}}</label></td><td><label class=\"m-0 ellipsis-label\">{{attrObj.name}}</label></td><td>{{attrObj.properties.readWrite}}</td><td class=\"p-r-8\"><i class=\"fa\" style=\"font-size: 20px\" ng-class=\"(attrObj.name && attrObj.name.length) && (attrObj.properties && attrObj.properties.read && attrObj.properties.read.type && attrObj.properties.read.type.length) && (attrObj.attributes && attrObj.attributes.selector && attrObj.attributes.selector.type && attrObj.attributes.selector.type.length) && (attrObj.attributes && attrObj.attributes.selector && attrObj.attributes.selector.expression && attrObj.attributes.selector.expression.length) ? \'fa-check-circle\' : \'fa-exclamation-circle\'\"></i></td></tr><tr ng-if=\"filterAttributes.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\" style=\"height: 55px;\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex !== 1 && selectedAttributeObj\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Attributes</h1><h2 class=\"m-0 m-t-10\">Define the attributes metadata, value expressions and dependencies.</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"attrMainContainerDetail\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\" select=\"selectedDetailSubTabIndex = 1\" ng-click=\"fnSelectSubTab(1)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 pace\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"attributeParentName\" type=\"text\" ng-model=\"selectedAttributeObj.parentName\" placeholder=\"Parent Type*\" name=\"attributeParentName\"> <span class=\"highlight\"></span> <label>Parent Type*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 pace\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"attributeReference\" type=\"text\" ng-model=\"selectedAttributeObj.id\" placeholder=\"Reference*\" name=\"attributeReference\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"attributeName\" type=\"text\" ng-model=\"selectedAttributeObj.name\" placeholder=\"Name*\" name=\"attributeName\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"attributeDescription\" type=\"text\" ng-model=\"selectedAttributeObj.description\" placeholder=\"Description*\" name=\"attributeDescription\"> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"attributeWriteButtonLabel\" type=\"text\" ng-model=\"writeButtonLabelObj.labelVal\" placeholder=\"Write Button Label\" name=\"attributeWriteButtonLabel\"> <span class=\"highlight\"></span> <label>Write Button Label</label> <small class=\"helper-text\"></small></div></div></div></div></div></uib-tab><uib-tab index=\"2\" select=\"selectedDetailSubTabIndex = 2\" ng-click=\"fnSelectSubTab(2)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Read</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedAttributeObj.properties.read.type}}</span> <label class=\"titleLabel\">Value Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"(key, value) in selectorValueOption\"><a ng-click=\"fnSelectValueTypeForSelectors(key)\"><span ng-class=\"key === selectedAttributeObj.properties.read.type ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === selectedAttributeObj.properties.read.type\"></i></span> <span>{{key}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"selectorOptionUnit\" type=\"text\" ng-model=\"selectedAttributeObj.properties.read.unit\" placeholder=\"Value Unit*\" name=\"selectorOptionUnit\"> <span class=\"highlight\"></span> <label>Value Unit*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in selectedAttributeObj.properties.read.instructionsArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"md-input\" ng-class=\"isKeyDuplicatedForReadInstruction && $index === duplicatedIndexForReadInstruction?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKeyForReadInstruction(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Instruction\"> <span class=\"highlight\"></span> <label>Instruction</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicatedForReadInstruction && $index === duplicatedIndexForReadInstruction\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocusForReadInstruction=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKeyForReadInstruction(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocusForReadInstruction=false\" ng-focus=\"valueFocusForReadInstruction=true\" ng-class=\"valueFocusForReadInstruction === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label></label><div ng-if=\"valueFocusForReadInstruction === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"selectedAttributeObj.properties.read.instructionsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForReadInstruction($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"selectedDetailSubTabIndex = 3\" ng-click=\"fnSelectSubTab(3)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Write</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-t-0 p-15 h-100 d-flex newTypeFormConfig\"><div class=\"col-sm-2 p-0 h-100 border-1px-solid\"><div class=\"col-sm-12 border-bottom-1px\"><h3 class=\"m-t-10 m-b-10\">Form Control</h3></div><div class=\"col-sm-12 p-0 h-100 overflow-auto\"><div class=\"col-sm-12 w100 p-t-5 p-b-5\" ng-class=\"{\'p-t-10\' : $first, \'p-b-10\' : $last}\" ng-repeat=\"input in fieldArrForForm\"><button class=\"btn btn-primary v4-primary-button w100\" dnd-list=\"\" dnd-draggable=\"input\" dnd-callback=\"fnOnActionDrop(input, targetIndex, schemaType)\" style=\"text-align: left;\"><i class=\"fa {{input.icon}} m-r-5\"></i>{{input.name}}</button></div></div></div><div class=\"col-sm-10 h-100 m-l-10 p-0 overflow-auto formBuilderTabUI\"><uib-tabset active=\"activeForm\" class=\"height-100\"><uib-tab index=\"0\" heading=\"Form Builder\"><div class=\"col-sm-12 p-t-30 floatingLabelInput\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: \'main\', schemaType: \'form\'})\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputObj in formBuilderInput track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputButton\'\"><div class=\"m-b-20 w100\"><button class=\"btn btn-primary v4-primary-button\" type=\"button\" name=\"{{inputObj.name}}\" value=\"{{inputObj.value}}\">{{inputObj.name}}</button></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{inputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"inputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{inputObj.title}}{{inputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"input.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in inputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"inputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{inputObj.key}}\" name=\"{{inputObj.key.toString()}}\" ng-model=\"input.inputValue\"> <label for=\"chk_{{inputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{inputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"inputObj.type === \'panel-conditional\'\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: inputObj.key, schemaType: \'form\'})\"><div class=\"col-sm-12 p-0 d-flex\"><h2 class=\"m-0 m-b-20 w100\"><strong>{{inputObj.title}}</strong></h2><div class=\"m-t-5 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in inputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{subInputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"subInputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"subInputObj.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in subInputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chk_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div></div><div class=\"d-flex align-items-center justify-content-center m-t-10 drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></div></div><div class=\"d-flex align-items-center justify-content-center drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></uib-tab><uib-tab index=\"1\" heading=\"Preview\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0 d-flex typeFormInputAction\" ng-if=\"formArrForForm.length\"><form role=\"form\" name=\"passwordForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"formSchema\" sf-form=\"formArrForForm\" sf-model=\"formModel\"></form></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"4\" select=\"selectedDetailSubTabIndex = 4\" ng-click=\"fnSelectSubTab(4)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Lookup</div></div></div></uib-tab-heading><div id=\"lookupMainContainer\" class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit floatingLabelInput\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSource\" type=\"text\" ng-model=\"selectedAttributeObj.attributes.dataSource\" ng-blur=\"fnGetTypeSampleData()\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, selectedAttributeObj.attributes.dataSource)\" ng-change=\"fnCheckUniqueKeyForDataSource(selectedAttributeObj.attributes.dataSource)\" placeholder=\"Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"requires\" type=\"text\" uib-typeahead=\"attrOption for attrOption in attrOptions | filter:$viewValue | limitTo:10\" typeahead-min-length=\"0\" ng-model=\"selectedRequire.value\" placeholder=\"Requires\" name=\"requires\"> <span class=\"highlight\"></span> <label>Requires</label> <small class=\"helper-text\"></small></div><a href=\"javascript:void(0);\" class=\"link-primary m-l-10\" ng-class=\"selectedRequire.value.length ? \'\' : \'pace opacity-5\'\" ng-click=\"fnAddRequires(selectedRequire.value)\">Add</a></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary m-r-5 m-t-10\" ng-repeat=\"requireName in selectedAttributeObj.attributes.requires track by $index\">{{requireName}} <i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveRequire($index)\"></i></button></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedAttrSelectorType}}</span> <label class=\"titleLabel\">Selector Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"selector in attrSelectorPathOptions\"><a ng-click=\"fnSelectSelectorPathOptions(selector)\"><span ng-class=\"selector === selectedAttrSelectorType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"selector === selectedAttrSelectorType\"></i></span> <span>{{selector}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-if=\"selectedAttrSelectorType.length\"><div class=\"md-input m-b-0 w100\" ng-if=\"selectedAttrSelectorType !== \'xslt\'\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpression\" type=\"text\" ng-model=\"selectedAttributeObj.attributes.selector.expression\" placeholder=\"Selector Expression*\" name=\"selectorExpression\"> <span class=\"highlight\"></span> <label>Selector Expression*</label> <small class=\"helper-text\" ng-if=\"sampleDataForSelectedAttr.sampleDataType === \'CSV\' && sampleDataForSelectedAttr.sampleData && sampleDataForSelectedAttr.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!sampleDataForSelectedAttr.sampleData || (sampleDataForSelectedAttr.sampleData && sampleDataForSelectedAttr.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><div class=\"m-b-0 w100\" ng-if=\"selectedAttrSelectorType === \'xslt\'\"><textarea id=\"selectorExpressionXslt\" rows=\"15\" style=\"resize: none\" class=\"p-15 textAreaStyle\" ng-model=\"selectedAttributeObj.attributes.selector.expression\" placeholder=\"Selector Expression*\" name=\"selectorExpression\"></textarea> <small class=\"helper-text\" ng-if=\"sampleDataForSelectedAttr.sampleDataType === \'CSV\' && sampleDataForSelectedAttr.sampleData && sampleDataForSelectedAttr.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!sampleDataForSelectedAttr.sampleData || (sampleDataForSelectedAttr.sampleData && sampleDataForSelectedAttr.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><svg class=\"custom-svg-side-menu-icon m-l-10 cursor-pointer\" width=\"20px\" height=\"20px\" ng-if=\"sampleDataForSelectedAttr.sampleData && sampleDataForSelectedAttr.sampleData !== \'\'\" ng-click=\"fnOpenExpressionModal(selectedAttributeObj.attributes.selector.expression, selectedAttrSelectorType)\"><use xlink:href=\"assets/images/svg/service/web-programming.svg#codeEditor\"></use></svg></div><div class=\"col-sm-12 p-0 m-b-30 customDropdown\" ng-if=\"mappingsArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedAttributeObj.attributes.extractor.mapper}}</span> <label class=\"titleLabel\">Mapper</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mappingObj in mappingsArr\"><a ng-click=\"fnSelectMapper(mappingObj)\"><span ng-class=\"mappingObj.id === selectedAttributeObj.attributes.extractor.mapper ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"mappingObj.id === selectedAttributeObj.attributes.extractor.mapper\"></i></span> <span>{{mappingObj.id}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in extractFiltersArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.key}}</span> <label class=\"titleLabel\">Filter</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"height: 200px; overflow-x: auto\"><li ng-repeat=\"attrFilterObj in attrFilterOptions\"><a ng-click=\"fnSelectExtractFilter(attrFilterObj, kvpPair)\"><span ng-class=\"attrFilterObj.filterValue === kvpPair.key ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrFilterObj.filterValue === kvpPair.key\"></i></span> <span>{{attrFilterObj.filterValue}}</span></a></li></ul></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\" ng-class=\"kvpPair.isArguments ? \'\' : \'pace opacity-5\'\"><div class=\"md-input m-b-20\" ng-init=\"valueFocusForMapper=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocusForMapper=false\" ng-focus=\"valueFocusForMapper=true\" ng-class=\"valueFocusForMapper === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocusForMapper === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"extractFiltersArr.length === 1 && $index === 0\" ng-click=\"fnRemoveExtractFilter(kvpPair, $index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"isShowSampleData\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"manipulatedSampleData\" type=\"text\" ng-model=\"manipulatedSampleData\" placeholder=\"Final Value From Sample Data\" name=\"manipulatedSampleData\"> <span class=\"highlight\"></span> <label>Final Value From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSink\" type=\"text\" ng-model=\"selectedAttributeObj.attributes.dataSink\" placeholder=\"Data Sink\" name=\"dataSink\"> <span class=\"highlight\"></span> <label>Data Sink</label> <small class=\"helper-text\"></small></div></div></div></div></div></uib-tab><uib-tab index=\"5\" select=\"selectedDetailSubTabIndex = 5\" ng-click=\"fnSelectSubTab(5)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Condition</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in selectedAttributeObj.readConditionsArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"md-input\" ng-class=\"isKeyDuplicated && $index === duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'key\')\" ng-change=\"fnCheckUniqueKey(kvpPair, $index, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"READ LOGIC*\"> <span class=\"highlight\"></span> <label>READ LOGIC*</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicated && $index === duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.operator}}</span> <label class=\"titleLabel\"></label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"conditionTypeObj in conditionTypes\"><a ng-click=\"fnSelectConditionOperator(kvpPair, conditionTypeObj)\"><span ng-class=\"conditionTypeObj.key === kvpPair.operator ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"conditionTypeObj.key === kvpPair.operator\"></i></span> <span>{{conditionTypeObj.key}}</span></a></li></ul></div></div></div><div class=\"col-sm-4 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKey(kvpPair, $index, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"readConditionsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in selectedAttributeObj.deleteConditionsArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"md-input\" ng-class=\"isDeleteKeyDuplicated && $index === deleteDuplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'key\')\" ng-change=\"fnCheckUniqueKeyForDelete(kvpPair, $index, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"DELETE LOGIC*\"> <span class=\"highlight\"></span> <label>DELETE LOGIC*</label> <small class=\"helper-text-error\" ng-show=\"isDeleteKeyDuplicated && $index === deleteDuplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.operator}}</span> <label class=\"titleLabel\"></label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"conditionTypeObj in conditionTypes\"><a ng-click=\"fnSelectConditionOperator(kvpPair, conditionTypeObj, \'delete\')\"><span ng-class=\"conditionTypeObj.key === kvpPair.operator ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"conditionTypeObj.key === kvpPair.operator\"></i></span> <span>{{conditionTypeObj.key}}</span></a></li></ul></div></div></div><div class=\"col-sm-4 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueDeleteFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKeyForDelete(kvpPair, $index, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueDeleteFocus=false\" ng-focus=\"valueDeleteFocus=true\" ng-class=\"valueDeleteFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueDeleteFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"deleteConditionsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForDelete($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/authentication/authentication.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in authenticationTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Authentication</h1><h2 class=\"m-0 m-t-10\"></h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"authenticationMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Authentication Types</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3AuthenticationObj.authenticationType.toUpperCase()}}</span> <label class=\"titleLabel\">Engine Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li class=\"p-10\" ng-repeat=\"(key, value) in authenticationTypes\" ng-click=\"fnSelectAuthenticationType(key)\"><span ng-class=\"key === iot3AuthenticationObj.authenticationType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === iot3AuthenticationObj.authenticationType\"></i></span> <span><span>{{value}}</span></span></li></ul></div></div><div class=\"col-sm-12 p-0 m-b-20\" ng-if=\"iot3AuthenticationObj.authenticationType === \'http\'\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">HTTP Authentication details</h2></div><div class=\"col-sm-12 p-0 customDropdown\"><h3 class=\"bold m-0\">Login Details</h3><div id=\"lookupMainContainer\" class=\"col-sm-12 p-t-20 height-inherit floatingLabelInput\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSource\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.login.dataSource\" ng-blur=\"fnGetTypeSampleData(\'login\')\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, iot3AuthenticationObj.http.actions.login.dataSource, \'login\')\" ng-change=\"fnCheckUniqueKeyForDataSource(iot3AuthenticationObj.http.actions.login.dataSource)\" placeholder=\"Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{loginSelectorType}}</span> <label class=\"titleLabel\">Selector Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"selector in attrSelectorPathOptions\"><a ng-click=\"fnSelectSelectorPathOptions(selector, \'login\')\"><span ng-class=\"selector === loginSelectorType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"selector === loginSelectorType\"></i></span> <span>{{selector}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-if=\"loginSelectorType.length\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpression\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.login.selector.expression\" placeholder=\"Selector Expression*\" name=\"selectorExpression\"> <span class=\"highlight\"></span> <label>Selector Expression*</label> <small class=\"helper-text\" ng-if=\"sampleDataForLogin.sampleDataType === \'CSV\' && sampleDataForLogin.sampleData && sampleDataForLogin.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!sampleDataForLogin.sampleData || (sampleDataForLogin.sampleData && sampleDataForLogin.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><svg class=\"custom-svg-side-menu-icon m-l-10 cursor-pointer\" width=\"20px\" height=\"20px\" ng-if=\"sampleDataForLogin.sampleData && sampleDataForLogin.sampleData !== \'\'\" ng-click=\"fnOpenExpressionModal( iot3AuthenticationObj.http.actions.login.selector.expression, loginSelectorType, sampleDataForLogin, \'login\')\"><use xlink:href=\"assets/images/svg/service/web-programming.svg#codeEditor\"></use></svg></div><div class=\"col-sm-12 p-0 m-b-30 customDropdown\" ng-if=\"mappingsArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3AuthenticationObj.http.actions.login.extractor.mapper}}</span> <label class=\"titleLabel\">Mapper</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mappingObj in mappingsArr\"><a ng-click=\"fnSelectMapper(mappingObj, \'login\')\"><span ng-class=\"mappingObj.id === iot3AuthenticationObj.http.actions.login.extractor.mapper ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"mappingObj.id === iot3AuthenticationObj.http.actions.login.extractor.mapper\"></i></span> <span>{{mappingObj.id}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in extractFiltersArrForLogin track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.key}}</span> <label class=\"titleLabel\">Filter</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"height: 200px; overflow-x: auto\"><li ng-repeat=\"attrFilterObj in attrFilterOptionsForLogin\" ng-show=\"attrFilterObj.isShow\"><a ng-click=\"fnSelectExtractFilterForLogin(attrFilterObj, kvpPair)\"><span ng-class=\"attrFilterObj.filterValue === kvpPair.key ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrFilterObj.filterValue === kvpPair.key\"></i></span> <span>{{attrFilterObj.filterValue}}</span></a></li></ul></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\" ng-class=\"kvpPair.isArguments ? \'\' : \'pace opacity-5\'\"><div class=\"md-input m-b-20\" ng-init=\"valueFocusForMapper=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocusForMapper=false\" ng-focus=\"valueFocusForMapper=true\" ng-class=\"valueFocusForMapper === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocusForMapper === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"extractFiltersArrForLogin.length === 1 && $index === 0\" ng-click=\"fnRemoveExtractFilterForLogin(kvpPair, $index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"isShowSampleDataForLogin\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"manipulatedSampleDataForLogin\" type=\"text\" ng-model=\"manipulatedSampleDataForLogin\" placeholder=\"Final Value From Sample Data\" name=\"manipulatedSampleDataForLogin\"> <span class=\"highlight\"></span> <label>Final Value From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSink\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.login.dataSink\" placeholder=\"Data Sink\" name=\"dataSink\"> <span class=\"highlight\"></span> <label>Data Sink</label> <small class=\"helper-text\"></small></div></div></div></div></div><div class=\"col-sm-12 p-0 customDropdown\"><h3 class=\"bold m-0\">Logout Details</h3><div id=\"lookupMainContainerForLogout\" class=\"col-sm-12 p-t-20 height-inherit floatingLabelInput\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSourceLogout\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.logout.dataSource\" ng-blur=\"fnGetTypeSampleData(\'logout\')\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, iot3AuthenticationObj.http.actions.logout.dataSource, \'logout\')\" ng-change=\"fnCheckUniqueKeyForDataSource(iot3AuthenticationObj.http.actions.logout.dataSource)\" placeholder=\"Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{logoutSelectorType}}</span> <label class=\"titleLabel\">Selector Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"selector in attrSelectorPathOptions\"><a ng-click=\"fnSelectSelectorPathOptions(selector, \'logout\')\"><span ng-class=\"selector === logoutSelectorType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"selector === logoutSelectorType\"></i></span> <span>{{selector}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-if=\"logoutSelectorType.length\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpressionForLogout\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.logout.selector.expression\" placeholder=\"Selector Expression*\" name=\"selectorExpression\"> <span class=\"highlight\"></span> <label>Selector Expression*</label> <small class=\"helper-text\" ng-if=\"sampleDataForLogout.sampleDataType === \'CSV\' && sampleDataForLogout.sampleData && sampleDataForLogout.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!sampleDataForLogout.sampleData || (sampleDataForLogout.sampleData && sampleDataForLogout.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><svg class=\"custom-svg-side-menu-icon m-l-10 cursor-pointer\" width=\"20px\" height=\"20px\" ng-if=\"sampleDataForLogout.sampleData && sampleDataForLogout.sampleData !== \'\'\" ng-click=\"fnOpenExpressionModal( iot3AuthenticationObj.http.actions.logout.selector.expression, logoutSelectorType, selectedSampleDataForLogout, \'logout\')\"><use xlink:href=\"assets/images/svg/service/web-programming.svg#codeEditor\"></use></svg></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"isShowSampleDataForLogout\"><div class=\"md-input\" ng-if=\"logoutSelectorType.toLowerCase() !== \'xpath\'\"><input class=\"md-form-control\" required=\"\" id=\"selectedSampleDataForLogout\" type=\"text\" ng-model=\"selectedSampleDataForLogout\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForLogout\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\" ng-if=\"logoutSelectorType.toLowerCase() === \'xpath\' && !selectedSampleDataForLogout.isCollection\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"selectedSampleDataForLogoutForXpath\" type=\"text\" ng-model=\"selectedSampleDataForLogout.sampleDataVal\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForLogout\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"logoutSelectorType.toLowerCase() === \'xpath\' && selectedSampleDataForLogout.isCollection\"><div class=\"md-input\" ng-repeat=\"sampleData in selectedSampleDataForLogout.sampleDataVal track by $index\"><input class=\"md-form-control\" required=\"\" id=\"selectedSampleDataForLogoutForCollection\" type=\"text\" ng-model=\"sampleData\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForLogout\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-30 customDropdown\" ng-if=\"mappingsArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3AuthenticationObj.http.actions.logout.extractor.mapper}}</span> <label class=\"titleLabel\">Mapper</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mappingObj in mappingsArr\"><a ng-click=\"fnSelectMapper(mappingObj, \'logout\')\"><span ng-class=\"mappingObj.id === iot3AuthenticationObj.http.actions.logout.extractor.mapper ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"mappingObj.id === iot3AuthenticationObj.http.actions.logout.extractor.mapper\"></i></span> <span>{{mappingObj.id}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in extractFiltersArrForLogout track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.key}}</span> <label class=\"titleLabel\">Filter</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"height: 200px; overflow-x: auto\"><li ng-repeat=\"attrFilterObj in attrFilterOptionsForLogout\" ng-show=\"attrFilterObj.isShow\"><a ng-click=\"fnSelectExtractFilterForLogout(attrFilterObj, kvpPair)\"><span ng-class=\"attrFilterObj.filterValue === kvpPair.key ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrFilterObj.filterValue === kvpPair.key\"></i></span> <span>{{attrFilterObj.filterValue}}</span></a></li></ul></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\" ng-class=\"kvpPair.isArguments ? \'\' : \'pace opacity-5\'\"><div class=\"md-input m-b-20\" ng-init=\"valueFocusForMapperForLogout=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocusForMapperForLogout=false\" ng-focus=\"valueFocusForMapperForLogout=true\" ng-class=\"valueFocusForMapperForLogout === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocusForMapperForLogout === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"extractFiltersArrForLogout.length === 1 && $index === 0\" ng-click=\"fnRemoveExtractFilterForLogout(kvpPair, $index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"isShowSampleDataForLogout\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"manipulatedSampleDataForLogout\" type=\"text\" ng-model=\"manipulatedSampleDataForLogout\" placeholder=\"Final Value From Sample Data\" name=\"manipulatedSampleDataForLogout\"> <span class=\"highlight\"></span> <label>Final Value From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSinkForLogout\" type=\"text\" ng-model=\"iot3AuthenticationObj.http.actions.logout.dataSink\" placeholder=\"Data Sink\" name=\"dataSink\"> <span class=\"highlight\"></span> <label>Data Sink</label> <small class=\"helper-text\"></small></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-b-20 m-t-20\" ng-if=\"iot3AuthenticationObj.authenticationType === \'snmp\'\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">SNMP Authentication details</h2></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"version\" type=\"text\" ng-model=\"iot3AuthenticationObj.snmp.version\" placeholder=\"Version*\" name=\"version\"> <span class=\"highlight\"></span> <label>Version*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in iot3AuthenticationObj.snmp.credentialsArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnKeySelectedForAutoFill($item, $model, $label, $event, kvpPair, \'key\')\" ng-change=\"fnCheckUniqueKeyForCredentials(kvpPair, $index, iot3AuthenticationObj.snmp.credentialsArr, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"Query Key\"> <span class=\"highlight\"></span> <label>Credentials Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueCredentialFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnKeySelectedForAutoFill($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKeyForCredentials(kvpPair, $index, iot3AuthenticationObj.snmp.credentialsArr, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueCredentialFocus=false\" ng-focus=\"valueCredentialFocus=true\" ng-class=\"valueCredentialFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Credentials Value\"> <span class=\"highlight\"></span> <label>Credentials Value</label><div ng-if=\"valueCredentialFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"iot3AuthenticationObj.snmp.credentialsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForCredential($index, iot3AuthenticationObj.snmp.credentialsArr)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/engine/engine.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in engineTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Engine</h1><h2 class=\"m-0 m-t-10\"></h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"engineMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\" ng-click=\"fnChangeSubTab(1)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Engine Type</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main h-100\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3EngineObj.engineType.toUpperCase()}}</span> <label class=\"titleLabel\">Engine Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li class=\"p-10\" ng-repeat=\"(key, value) in engineTypesArr\" ng-click=\"fnSelectEngineType(key)\"><span ng-class=\"key === iot3EngineObj.engineType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === iot3EngineObj.engineType\"></i></span> <span><span>{{value}}</span></span></li></ul></div></div><div class=\"col-sm-12 p-0 m-b-20\" style=\"height: calc(100% - 85px)\" ng-if=\"iot3EngineObj.engineType === \'http\'\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">HTTP Engine details</h2></div><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3EngineObj.http.type.toUpperCase()}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"typeEnumeration in typeEnumerationOptions\"><a ng-click=\"fnSelectHttpTypeEnumeration(typeEnumeration.name)\"><span>{{typeEnumeration.name.toUpperCase()}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 engine-table\" style=\"height: calc(100% - 80px)\"><table id=\"issuesTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-l-8\">Name</th><th class=\"p-l-8\"></th><th class=\"p-l-8\"></th></tr></thead><tbody id=\"typeTable\" class=\"overflow-auto\"><tr ng-repeat=\"requestObj in iot3EngineObj.http.requestsArr track by $index\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{requestObj.name}}</label></td><td class=\"text-right p-r-8\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnOpenEngineDetails(false, requestObj, $index)\">Edit Request</button></td><td class=\"text-right p-r-8\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnDeleteEngineRequest($index)\">Delete Request</button></td></tr><tr ng-if=\"iot3EngineObj.http.requestsArr.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div><div class=\"col-sm-12 p-0 m-b-20 m-t-20\" ng-if=\"iot3EngineObj.engineType === \'snmp\'\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">SNMP Engine details</h2></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\"><switch id=\"CollapsedPanel\" uib-tooltip=\"{{iot3EngineObj.snmp.supportsBulk ? \'Click to disable Bulk supports\' : \'Click to enable Bulk supports\'}}\" tooltip-placement=\"right\" ng-model=\"iot3EngineObj.snmp.supportsBulk\"></switch><span class=\"m-l-5\">{{iot3EngineObj.snmp.supportsBulk ? \'Bulk supports Enabled\' : \'Bulk supports Disabled\'}}</span></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"bulkRange\" type=\"number\" ng-model=\"iot3EngineObj.snmp.bulkRange\" placeholder=\"Bulk Range\" name=\"bulkRange\"> <span class=\"highlight\"></span> <label>Bulk Range</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"maxOids\" type=\"number\" ng-model=\"iot3EngineObj.snmp.maxOids\" placeholder=\"Max Oids\" name=\"maxOids\"> <span class=\"highlight\"></span> <label>Max Oids</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"timeout\" type=\"number\" ng-model=\"iot3EngineObj.snmp.timeout\" placeholder=\"Timeout\" name=\"timeout\"> <span class=\"highlight\"></span> <label>Timeout</label> <small class=\"helper-text\"></small></div></div></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" ng-click=\"fnChangeSubTab(2)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Tunnel Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">SSH Details</h2></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"d-flex align-items-center\"><switch id=\"CollapsedPanel\" uib-tooltip=\"{{iot3EngineObj.tunnel.ssh.supported ? \'Click to disable SSH support\' : \'Click to enable SSH Support\'}}\" tooltip-placement=\"right\" ng-model=\"iot3EngineObj.tunnel.ssh.supported\"></switch><span class=\"m-l-5\">{{iot3EngineObj.tunnel.ssh.supported ? \'SSH Support Enabled\' : \'SSH Support Disabled\'}}</span></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in iot3EngineObj.tunnel.ssh.sshInstructionsArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isSshKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'key\')\" ng-change=\"fnCheckUniqueKeyForSsh(kvpPair, $index, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"SSH Key\"> <span class=\"highlight\"></span> <label>SSH Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isSshKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueSshFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKeyForSsh(kvpPair, $index, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueSshFocus=false\" ng-focus=\"valueSshFocus=true\" ng-class=\"valueSshFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"SSH Value\"> <span class=\"highlight\"></span> <label>SSH Value</label><div ng-if=\"valueSshFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"iot3EngineObj.tunnel.ssh.sshInstructionsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForSsh($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-20\"><h2 class=\"bold m-0\">HTTP Details</h2></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"d-flex align-items-center\"><switch id=\"CollapsedPanel\" uib-tooltip=\"{{iot3EngineObj.tunnel.http.supported ? \'Click to disable HTTP support\' : \'Click to enable HTTP Support\'}}\" tooltip-placement=\"right\" ng-model=\"iot3EngineObj.tunnel.http.supported\"></switch><span class=\"m-l-5\">{{iot3EngineObj.tunnel.http.supported ? \'HTTP Support Enabled\' : \'HTTP Support Disabled\'}}</span></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in iot3EngineObj.tunnel.http.httpInstructionsArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isHttpKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'key\')\" ng-change=\"fnCheckUniqueKeyForHttp(kvpPair, $index, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"HTTP Key\"> <span class=\"highlight\"></span> <label>HTTP Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isHttpKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueHttpFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKeyForHttp(kvpPair, $index, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueHttpFocus=false\" ng-focus=\"valueHttpFocus=true\" ng-class=\"valueHttpFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"HTTP Value\"> <span class=\"highlight\"></span> <label>HTTP Value</label><div ng-if=\"valueHttpFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"iot3EngineObj.tunnel.http.httpInstructionsArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForHttp($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" style=\"opacity: 0; pointer-events: none\" ng-if=\"iot3EngineObj.engineType !== \'http\' || selectedSubTabIndex !== 1\">Create</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"selectedSubTabIndex === 1 && iot3EngineObj.engineType === \'http\'\" ng-click=\"fnOpenEngineDetails(true)\">Create HTTP Request</button></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/global/global.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in globalTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Global</h1><h2 class=\"m-0 m-t-10\">Set variables that are globally available throughout the IoT3 file.</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"globalMainContainer\" class=\"col-sm-12 overflow-auto floatingLabelInput\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 supplementalTemplate\"><div class=\"col-sm-12 p-0\" ng-repeat=\"kvpPair in globalKVPArr track by $index\" ng-class=\"kvpPair.isFromAttr || kvpPair.isFromAuthLogin || kvpPair.isFromAuthLogout ? \'pace opacity-5\' : \'\'\"><div class=\"col-sm-3 p-0\"><div class=\"md-input\" ng-class=\"isKeyDuplicated && $index === duplicatedIndex || kvpPair.isFromAttr || kvpPair.isFromAuthLogin || kvpPair.isFromAuthLogout ?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'key\')\" ng-focus=\"oldValue = \'\'\" ng-change=\"fnCheckUniqueKey(kvpPair, $index, \'key\')\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicated && $index === duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small> <small class=\"helper-text\" ng-if=\"!(isKeyDuplicated && $index === duplicatedIndex) && kvpPair.isFromAttr\">This is a dynamic kvp generated from attributes.</small> <small class=\"helper-text\" ng-if=\"!(isKeyDuplicated && $index === duplicatedIndex) && !kvpPair.isFromAttr && kvpPair.isFromAuthLogin\">This is a dynamic kvp generated from Authentication Login.</small> <small class=\"helper-text\" ng-if=\"!(isKeyDuplicated && $index === duplicatedIndex) && !kvpPair.isFromAttr && kvpPair.isFromAuthLogout\">This is a dynamic kvp generated from Authentication Logout.</small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-9 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in kvpPair.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelected($item, $model, $label, $event, kvpPair, \'value\')\" ng-change=\"fnCheckUniqueKey(kvpPair, $index, \'value\')\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"globalKVPArr.length === 1 && $index === 0 && !kvpPair.isFromAttr\" ng-click=\"fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/info/info.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in infoTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Info</h1><h2 class=\"m-0 m-t-10\">Metadata relating to the IoT3 file</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"row\"><div id=\"infoMainContainer\" class=\"col-sm-12 overflow-auto\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 floatingLabelInput m-t-10\"><div class=\"col-sm-12 p-0 pace\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"iot3Version\" type=\"text\" ng-model=\"iot3Version\" placeholder=\"IoT3 Version*\" name=\"iot3Version\"> <span class=\"highlight\"></span> <label>IoT3 Version*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"infoObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"infoObj.description\" placeholder=\"Description*\" name=\"description\"> <span class=\"highlight\"></span> <label>Description*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"oem\" type=\"text\" ng-model=\"infoObj.oem\" placeholder=\"OEM*\" name=\"oem\"> <span class=\"highlight\"></span> <label>OEM*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"model\" type=\"text\" ng-model=\"infoObj.model\" placeholder=\"Model*\" name=\"model\"> <span class=\"highlight\"></span> <label>Model*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"versions\" type=\"text\" ng-model=\"selectedVersion\" ng-keyup=\"$event.keyCode === 13 && fnAddResources(\'versions\', selectedVersion)\" placeholder=\"Versions*\" name=\"versions\"> <span class=\"highlight\"></span> <label>Versions*</label> <small class=\"helper-text\"></small></div><a href=\"javascript:void(0);\" class=\"btn btn-primary v4-primary-button m-l-10\" ng-class=\"selectedVersion.length ? \'\' : \'pace opacity-5\'\" ng-click=\"fnAddResources(\'versions\', selectedVersion)\">Add</a></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary m-r-5 m-t-10\" ng-repeat=\"versionName in infoObj.versions track by $index\">{{versionName}} <i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveResource(\'versions\', $index)\"></i></button></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"author\" type=\"text\" ng-model=\"infoObj.author\" placeholder=\"Author\" name=\"author\"> <span class=\"highlight\"></span> <label>Author</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{infoObj.stage}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"stageObj in stagesArr\"><a ng-click=\"fnSelectStage(stageObj)\"><span ng-class=\"stageObj.name === infoObj.stage ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"stageObj.name === infoObj.stage\"></i></span> <span>{{stageObj.name}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"revision\" type=\"number\" ng-model=\"infoObj.revision\" placeholder=\"Revision\" name=\"revision\"> <span class=\"highlight\"></span> <label>Revision</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"created\" type=\"text\" ng-model=\"infoObj.created\" placeholder=\"Created\" name=\"created\"> <span class=\"highlight\"></span> <label>Created</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"updated\" type=\"text\" ng-model=\"infoObj.updated\" placeholder=\"Updated\" name=\"updated\"> <span class=\"highlight\"></span> <label>Updated</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"labels\" type=\"text\" ng-model=\"selectedLabel\" ng-keyup=\"$event.keyCode === 13 && fnAddResources(\'labels\', selectedLabel)\" placeholder=\"Labels\" name=\"labels\"> <span class=\"highlight\"></span> <label>Labels</label> <small class=\"helper-text\"></small></div><a href=\"javascript:void(0);\" class=\"btn btn-primary v4-primary-button m-l-10\" ng-class=\"selectedLabel.length ? \'\' : \'pace opacity-5\'\" ng-click=\"fnAddResources(\'labels\', selectedLabel)\">Add</a></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary m-r-5 m-t-10\" ng-repeat=\"labelName in infoObj.labels track by $index\">{{labelName}} <i class=\"fa fa-times m-l-5\" ng-click=\"fnRemoveResource(\'labels\', $index)\"></i></button></div></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/iot3/iot3.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in iot3Tabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header d-flex align-items-center justify-content-space-between\" ng-if=\"isFullWidthDevice\"><div class=\"d-flex flex-column\"><h1 class=\"m-0 font-bold\">IoT3</h1><h2 class=\"m-0 m-t-10\">This is the complete IoT3 file that should be used when registering a node</h2></div><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnDownloadIot3File()\">Download Iot3 File</button></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"iot3TabMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Code</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\" ng-init=\"fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit\"><ui-codemirror ng-model=\"iot3Detail.yamlString\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div class=\"d-flex justify-content-center align-items-center m-r-10\"><svg xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"!isChangesSync\" style=\"height: 25px;width: 25px\" viewbox=\"0 -27 511.99932 511\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: 25px;width: 25px\" viewbox=\"0 0 510 510\" ng-if=\"isChangesSync\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"isChangesSync ? \'\' : \'pace opacity-5\'\" ng-click=\"fnSaveIot3File()\">Save Changes</button></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/mappings/mappings.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in mappingsTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id, tab.tabIndex)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Mappings</h1><h2 class=\"m-0 m-t-10\">Map OEM reference values to literals</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"row\"><div id=\"mappingsMainContainer\" class=\"col-sm-12 overflow-hidden\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 m-t-5 searchContainer\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput d-flex\"><div class=\"md-input m-b-13 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"mappingSearch[filter]\" placeholder=\"Search\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-5\"><div class=\"mappings-table table-container\"><table id=\"mappingsTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-l-8\">Key</th><th>Key Type</th><th>Value Type</th><th class=\"p-r-8\">Mappings</th></tr></thead><tbody id=\"mappingTable\" class=\"overflow-auto\"><tr ng-repeat=\"mappingObj in filterMappings = (mappingsArr | filter:mappingSearch) track by $index\" ng-click=\"fnGetMappingDetails(mappingObj)\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{mappingObj.id}}</label></td><td>{{mappingObj.keyType}}</td><td>{{mappingObj.valueType}}</td><td class=\"p-r-8\">{{mappingObj.mapArr.length}}</td></tr><tr ng-if=\"filterMappings.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button ng-click=\"fnOpenCreateMappingView()\" class=\"btn btn-primary v4-primary-button\">Create Mapping</button></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex !== 1 && isCreate\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Mappings</h1><h2 class=\"m-0 m-t-10\">Map OEM reference values to literals</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"mappingsCreateMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedCreateSubTabIndex\"><uib-tab index=\"1\" select=\"selectedCreateSubTabIndex = 1\" ng-click=\"fnSelectSubTab(1)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"reference\" type=\"text\" ng-model=\"createMappingObj.id\" ng-change=\"fnCheckCreateMappingReference()\" placeholder=\"Reference*\" name=\"reference\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\" ng-if=\"isReferencePatternMismatched\">Reference can only contain lowercase letters and numbers.</small> <small class=\"helper-text\" ng-if=\"isReferenceDuplicated\">The Reference is already in use.</small></div></div><div class=\"col-sm-12 p-0 m-b-30\"><div class=\"d-flex align-items-center\"><switch ng-model=\"createMappingObj.isMap\" ng-change=\"fnChangeMappingTypeForCreate(createMappingObj)\"></switch><span class=\"m-l-10\">{{createMappingObj.isMap ? \'Map\' : \'Array\'}}</span></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\" ng-if=\"createMappingObj.isMap\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createMappingObj.keyType}}</span> <label class=\"titleLabel\">Key Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"(key, value) in dataTypeOptions\"><a ng-click=\"fnSelectKeyTypeValue(key)\"><span ng-class=\"key === createMappingObj.keyType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === createMappingObj.keyType\"></i></span> <span>{{key}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\" ng-if=\"createMappingObj.isMap\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createMappingObj.valueType}}</span> <label class=\"titleLabel\">Value Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"(key, value) in dataTypeOptions\"><a ng-click=\"fnSelectKeyTypeValue(key)\"><span ng-class=\"key === createMappingObj.valueType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === createMappingObj.valueType\"></i></span> <span>{{key}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-if=\"createMappingObj.isMap\" ng-repeat=\"kvpPair in createMappingObj.mapArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"md-input\" ng-class=\"isKeyDuplicated && $index === duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicated && $index === duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"createMappingObj.mapArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!createMappingObj.isMap\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\" ng-repeat=\"attrObj in createMappingObj.mapArr track by $index\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"{{\'create\' + attrObj.key + \'_\' + $index}}\" type=\"text\" ng-model=\"attrObj.key\" ng-change=\"fnCheckUniqueKeyArr(attrObj, $index)\" placeholder=\"Key*\" name=\"{{\'create\' + attributeName + \'_\' + $index}}\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\" ng-show=\"isKeyDuplicatedForArr && $index === duplicatedIndexForArr\"><span class=\"errorText\">The Key is already in Use.</span></small></div><i ng-hide=\"createMappingObj.mapArr.length === 1 && $index === 0\" class=\"fa fa-trash link-primary cursor-pointer m-l-10\" ng-click=\"fnRemoveSupplemental($index)\"></i></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"fnCheckAddMapping() ? \'pace opacity-5\' : \'\'\" ng-click=\"fnAddMappingToList()\">Add Mapping</button></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex !== 1 && !isCreate && selectedMappingObj\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Mappings</h1><h2 class=\"m-0 m-t-10\">Map OEM reference values to literals</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"mappingsMainContainerDetail\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\" select=\"selectedDetailSubTabIndex = 1\" ng-click=\"fnSelectSubTab(1, \'detail\')\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 pace\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"mappingReference\" type=\"text\" ng-model=\"selectedMappingObj.id\" placeholder=\"Reference*\" name=\"mappingReference\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30\"><div><switch ng-model=\"selectedMappingObj.isMap\" ng-change=\"fnChangeMappingTypeForCreate(selectedMappingObj)\"></switch><span>{{selectedMappingObj.isMap ? \'Map\' : \'Array\'}}</span></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\" ng-if=\"selectedMappingObj.isMap\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedMappingObj.keyType}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"(key, value) in dataTypeOptions\"><a ng-click=\"fnSelectKeyTypeValue(key, \'detail\')\"><span ng-class=\"key === selectedMappingObj.keyType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === selectedMappingObj.keyType\"></i></span> <span>{{key}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\" ng-if=\"selectedMappingObj.isMap\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedMappingObj.valueType}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"(key, value) in dataTypeOptions\"><a ng-click=\"fnSelectKeyTypeValue(key, \'detail\')\"><span ng-class=\"key === selectedMappingObj.valueType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"key === selectedMappingObj.valueType\"></i></span> <span>{{key}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-if=\"selectedMappingObj.isMap\" ng-repeat=\"kvpPair in selectedMappingObj.mapArr track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"md-input\" ng-class=\"isKeyDuplicatedForDetail && $index === duplicatedIndexForDetail ? \'m-b-40\' : \'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKeyForDetail(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicatedForDetail && $index === duplicatedIndexForDetail\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocusForDetail = false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"fnCheckUniqueKeyForDetail(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocusForDetail = false\" ng-focus=\"valueFocusForDetail = true\" ng-class=\"valueFocusForDetail === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocusForDetail === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"selectedMappingObj.mapArr.length === 1 && $index === 0\" ng-click=\"fnRemoveSupplementalForDetail($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!selectedMappingObj.isMap\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\" ng-repeat=\"attrObj in selectedMappingObj.mapArr track by $index\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"{{\'map\' + attrObj.key + \'_\' + $index}}\" type=\"text\" ng-model=\"attrObj.key\" ng-change=\"fnCheckUniqueKeyArrForDetail(attrObj, $index)\" placeholder=\"Key*\" name=\"{{\'map\' + attributeName + \'_\' + $index}}\"> <span class=\"highlight\"></span> <label>Key*</label> <small class=\"helper-text\" ng-show=\"isKeyDuplicatedForArrDetail && $index === duplicatedIndexForArrDetail\"><span class=\"errorText\">The Key is already in Use.</span></small></div><i ng-hide=\"selectedMappingObj.mapArr.length === 1 && $index === 0\" class=\"fa fa-trash link-primary cursor-pointer m-l-10\" ng-click=\"fnRemoveSupplementalForDetail($index)\"></i></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button m-l-5\" ng-click=\"fnDeleteMapping()\">Delete Mapping</button></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/registration/registration.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in registrationTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Registration</h1><h2 class=\"m-0 m-t-10\">Define the form and security information that must be completed when registering a node.</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"registrationMainContainer\" class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0\" ng-if=\"vaultBuilderInput.length\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"vaultId\" type=\"text\" uib-typeahead=\"vaultOptionName for vaultOptionName in vaultOptionsArr\" typeahead-on-select=\"fnSelectVaultId($item, $model, $label, $event)\" typeahead-min-length=\"0\" ng-model=\"vaultId.name\" placeholder=\"Vault ID*\" name=\"vaultId\"> <span class=\"highlight\"></span> <label>Vault ID*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-repeat=\"selectedFingerPrint in fingerPrintArr track by $index\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedFingerPrint.value}}</span> <label class=\"titleLabel\">FINGERPRINT FIELD REFERENCE</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"formOption in formOptionsArr\"><a ng-click=\"fnSelectFormOption(formOption, selectedFingerPrint)\"><span>{{formOption}}</span></a></li></ul></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-link m-l-10 p-0 border-0\" ng-hide=\"fingerPrintArr.length === 1 && $index === 0\" ng-click=\"fnRemoveFormOption($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Form</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-t-0 p-15 h-100 d-flex newTypeFormConfig\"><div class=\"col-sm-2 p-0 h-100 border-1px-solid\"><div class=\"col-sm-12 border-bottom-1px\"><h3 class=\"m-t-10 m-b-10\">Form Control</h3></div><div class=\"col-sm-12 p-0 h-100 overflow-auto\"><div class=\"col-sm-12 w100 p-t-5 p-b-5\" ng-class=\"{\'p-t-10\' : $first, \'p-b-10\' : $last}\" ng-repeat=\"input in fieldArrForForm\"><button class=\"btn btn-primary v4-primary-button w100\" dnd-list=\"\" dnd-draggable=\"input\" dnd-callback=\"fnOnActionDrop(input, targetIndex, schemaType)\" style=\"text-align: left;\"><i class=\"fa {{input.icon}} m-r-5\"></i>{{input.name}}</button></div></div></div><div class=\"col-sm-10 h-100 m-l-10 p-0 overflow-auto formBuilderTabUI\"><uib-tabset active=\"activeForm\" class=\"height-100\"><uib-tab index=\"0\" heading=\"Form Builder\"><div class=\"col-sm-12 p-t-30 floatingLabelInput\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: \'main\', schemaType: \'form\'})\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputObj in formBuilderInput track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputButton\'\"><div class=\"m-b-20 w100\"><button class=\"btn btn-primary v4-primary-button\" type=\"button\" name=\"{{inputObj.name}}\" value=\"{{inputObj.value}}\">{{inputObj.name}}</button></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{inputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"inputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{inputObj.title}}{{inputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"input.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in inputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"inputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{inputObj.key}}\" name=\"{{inputObj.key.toString()}}\" ng-model=\"input.inputValue\"> <label for=\"chk_{{inputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{inputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"inputObj.type === \'panel-conditional\'\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: inputObj.key, schemaType: \'form\'})\"><div class=\"col-sm-12 p-0 d-flex\"><h2 class=\"m-0 m-b-20 w100\"><strong>{{inputObj.title}}</strong></h2><div class=\"m-t-5 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in inputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{subInputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"subInputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"subInputObj.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in subInputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chk_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'form\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div></div><div class=\"d-flex align-items-center justify-content-center m-t-10 drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></div></div><div class=\"d-flex align-items-center justify-content-center drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></uib-tab><uib-tab index=\"1\" heading=\"Preview\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0 d-flex typeFormInputAction\" ng-if=\"formArrForForm.length\"><form role=\"form\" name=\"passwordForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"formSchema\" sf-form=\"formArrForForm\" sf-model=\"formModel\"></form></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"3\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Vault</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-t-0 p-15 h-100 d-flex newTypeFormConfig\"><div class=\"col-sm-2 p-0 h-100 border-1px-solid\"><div class=\"col-sm-12 border-bottom-1px\"><h3 class=\"m-t-10 m-b-10\">Form Control</h3></div><div class=\"col-sm-12 p-0 h-100 overflow-auto\"><div class=\"col-sm-12 w100 p-t-5 p-b-5\" ng-class=\"{\'p-t-10\' : $first, \'p-b-10\' : $last}\" ng-repeat=\"input in fieldArrForVault\"><button class=\"btn btn-primary v4-primary-button w100\" dnd-list=\"\" dnd-draggable=\"input\" dnd-callback=\"fnOnActionDrop(input, targetIndex, schemaType)\" style=\"text-align: left;\"><i class=\"fa {{input.icon}} m-r-5\"></i>{{input.name}}</button></div></div></div><div class=\"col-sm-10 h-100 m-l-10 p-0 overflow-auto formBuilderTabUI\"><uib-tabset active=\"activeForm\" class=\"height-100\"><uib-tab index=\"0\" heading=\"Form Builder\"><div class=\"col-sm-12 p-t-30 floatingLabelInput\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: \'main\', schemaType: \'vault\'})\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputObj in vaultBuilderInput track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{inputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"inputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{inputObj.title}}{{inputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"input.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in inputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"inputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chkVault_{{inputObj.key}}\" name=\"{{inputObj.key.toString()}}\" ng-model=\"input.inputValue\"> <label for=\"chkVault_{{inputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{inputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"inputObj.type === \'panel-conditional\'\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: inputObj.key, schemaType: \'vault\'})\"><div class=\"col-sm-12 p-0 d-flex\"><h2 class=\"m-0 m-b-20 w100\"><strong>{{inputObj.title}}</strong></h2><div class=\"m-t-5 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(inputObj, false, {}, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in inputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputText\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputTextarea\'\"><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                                                                                            </textarea> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputLabel\'\"><div class=\"md-input m-b-20 w100\"><label>{{subInputObj.title}}</label></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"subInputObj.type === \'dropdown\'\"><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"subInputObj.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in subInputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chkVault_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chkVault_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputNumber\'\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"fnEditInput(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"fnRemove(subInputObj, true, inputObj, \'vault\')\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div></div><div class=\"d-flex align-items-center justify-content-center m-t-10 drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></div></div><div class=\"d-flex align-items-center justify-content-center drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></uib-tab><uib-tab index=\"1\" heading=\"Preview\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0 d-flex typeFormInputAction\" ng-if=\"formArrForVault.length\"><form role=\"form\" name=\"passwordForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"vaultSchema\" sf-form=\"formArrForVault\" sf-model=\"vaultModel\"></form></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/topology/topology.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in topologyTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Topology</h1><h2 class=\"m-0 m-t-10\">Describes the types of nodes that are supported and their attributes</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"topologyMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\" ng-click=\"fnChangeSubTab(1)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div id=\"lookupMainContainer\" class=\"tabContent overflow-auto\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main h-100\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-30 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3TopologyObj.rootType}}</span> <label class=\"titleLabel\">Root Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"rootType in rootTypesArr\"><a ng-click=\"fnSelectRootType(rootType)\"><span ng-class=\"rootType.name === iot3TopologyObj.rootType ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"rootType.name === iot3TopologyObj.rootType\"></i></span> <span>{{rootType.name}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"wrapperType\" type=\"text\" ng-blur=\"fnAddWrapperToList()\" ng-model=\"iot3TopologyObj.wrapperType\" placeholder=\"Wrapper Type\" name=\"rootType\"> <span class=\"highlight\"></span> <label>Wrapper Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><label class=\"m-b-0 m-r-10\">Does the device have nodes?</label> <input type=\"checkbox\" id=\"nodesCheck\" ng-model=\"iot3TopologyObj.nodes\"> <label for=\"nodesCheck\" class=\"check-box\"></label></div><div class=\"col-sm-12 p-0 m-t-20\" ng-if=\"iot3TopologyObj.nodes\"><div class=\"col-sm-12 p-0 m-b-30\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{iot3TopologyObj.discovery.type}}</span> <label class=\"titleLabel\">Type*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"discoveryType in discoveryTypeOptions\"><a ng-click=\"fnSelectDiscoveryTypeOptions(discoveryType)\"><span ng-class=\"discoveryType === iot3TopologyObj.discovery.type ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"discoveryType === iot3TopologyObj.discovery.type\"></i></span> <span>{{discoveryType}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSourceForNodesDiscovery\" type=\"text\" ng-model=\"iot3TopologyObj.discovery.dataSource\" ng-blur=\"fnGetTypeSampleData(\'discovery\')\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, iot3TopologyObj.discovery.dataSource, \'discovery\')\" ng-change=\"fnCheckUniqueKeyForDataSource(iot3TopologyObj.discovery.dataSource)\" placeholder=\"Discovery Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Discovery Data Source</label> <small class=\"helper-text\"></small></div></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"2\" ng-click=\"fnChangeSubTab(2)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Verify</div></div></div></uib-tab-heading><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main h-100\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput mainTableContent\"><div class=\"col-sm-12 p-0 m-b-20 infoDiv\"><label class=\"m-0\">This allows you to define a function that verifies that the remote system is of the correct type and version.</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"verify-table table-container\"><table id=\"verifyTable\" class=\"table table-striped table-check-box m-b-0\"><thead class=\"tableHeader\"><tr><th class=\"p-l-8\">Name</th><th></th></tr></thead><tbody id=\"verifierTable\"><tr ng-repeat=\"verifyObj in filterVerifiers = (verifyArr | filter:verifySearch) track by $index\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">Verifier {{$index + 1}}.</label></td><td class=\"text-right\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"fnOpenVerifierModal(false, verifyObj, $index)\">Edit Verifier</button> <button class=\"btn btn-primary v4-primary-button m-r-8\" ng-click=\"fnDeleteVerifyObj($event, $index)\">Delete Verifier</button></td></tr><tr ng-if=\"filterVerifiers.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"3\" ng-click=\"fnChangeSubTab(3)\" ng-if=\"iot3TopologyObj.nodes\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Discover</div></div></div></uib-tab-heading><div id=\"lookupMainContainerForDiscovery\" class=\"tabContent\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main h-100\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput mainTableContent\"><div class=\"col-sm-12 p-0 m-b-20 infoDiv\"><label class=\"m-0\">This function should output a collection of the entire remote system topology including information required to make calls to specific nodes.</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"discovery-table table-container\"><table id=\"discoveryTable\" class=\"table table-striped table-check-box\"><thead class=\"tableHeader\"><tr><th class=\"p-l-8\">Name</th><th></th></tr></thead><tbody id=\"discoverTable\"><tr ng-repeat=\"discoverySelectorObj in filterDiscoveries = (selectorsArrForDiscovery | filter:discoverySearch) track by $index\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{discoverySelectorObj.key}}</label></td><td class=\"text-right\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"fnOpenDiscoveryModal(false, discoverySelectorObj, $index)\">Edit Discovery</button> <button class=\"btn btn-primary v4-primary-button m-r-8\" ng-click=\"fnDeleteDiscoveryObj($event, $index, \'selector\')\">Delete Discovery</button></td></tr><tr ng-if=\"filterDiscoveries.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></uib-tab><uib-tab index=\"4\" ng-click=\"fnChangeSubTab(4)\" ng-if=\"iot3TopologyObj.nodes\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Flatten</div></div></div></uib-tab-heading><div id=\"lookupMainContainerForDiscoveryFlatten\" class=\"tabContent\"><div class=\"tabContent\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100 supplementalTemplate\"><div class=\"content-main h-100\"><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput mainTableContent\"><div class=\"col-sm-12 p-0 m-b-20 infoDiv\"><label class=\"m-0\">Each item from the discovery list is passed and processed by this function. These should contain all the variables required to identify an individual node and make a call to the remote system to obtain its attributes.</label></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\"><div class=\"flatten-table table-container\"><table id=\"flattensTable\" class=\"table table-striped table-check-box\"><thead class=\"tableHeader\"><tr><th class=\"p-l-8\">Name</th><th></th></tr></thead><tbody id=\"flattenTable\"><tr ng-repeat=\"discoverySelectorObj in filterFlattens = (extractorsArrForDiscovery | filter:flattenSearch) track by $index\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{discoverySelectorObj.key}}</label></td><td class=\"text-right\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-click=\"fnOpenFlattenModal(false, discoverySelectorObj, $index)\">Edit Flatten</button> <button class=\"btn btn-primary v4-primary-button m-r-8\" ng-click=\"fnDeleteDiscoveryObj($event, $index, \'extractor\')\">Delete Flatten</button></td></tr><tr ng-if=\"filterFlattens.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-if=\"selectedSubTabIndex === 1\" style=\"opacity: 0; pointer-events: none\">Create</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"selectedSubTabIndex === 2\" ng-click=\"fnOpenVerifierModal(true)\">Create Verifier</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"selectedSubTabIndex === 3\" ng-click=\"fnOpenDiscoveryModal(true)\">Create Discovery</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"selectedSubTabIndex === 4\" ng-click=\"fnOpenFlattenModal(true)\">Create Flatten</button></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/types/types.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in typesTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id, tab.tabIndex)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Types</h1><h2 class=\"m-0 m-t-10\">Describes the types of nodes that are supported and their attributes</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"row\"><div id=\"typesMainContainer\" class=\"col-sm-12 overflow-hidden\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0 m-t-5 searchContainer\"><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput d-flex\"><div class=\"md-input m-b-13 w100\"><input type=\"text\" required=\"\" class=\"md-form-control p-l-35\" ng-model=\"typeSearch[filter]\" placeholder=\"Search\"> <span class=\"highlight\"></span> <label class=\"m-l-30\">Search</label> <span class=\"search-icon-searchBar\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div></div></div></div><div class=\"col-sm-12 p-0 m-t-5\"><div class=\"iotType-table table-container\"><table id=\"issuesTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-l-8\">Key</th><th>Name</th><th>Version</th><th>Price</th><th>Energy</th><th class=\"p-r-8\">Attributes</th></tr></thead><tbody id=\"typeTable\" class=\"overflow-auto\"><tr ng-repeat=\"typeObj in filterTypes=(typesArr | filter:typeSearch) track by $index\" ng-click=\"fnGetTypeDetails(typeObj)\"><td class=\"p-l-8\"><label class=\"m-0 ellipsis-label\">{{typeObj.id}}</label></td><td><label class=\"m-0 ellipsis-label\">{{typeObj.name}}</label></td><td><label class=\"m-0 ellipsis-label\">{{typeObj.version}}</label></td><td><label class=\"m-0 ellipsis-label\">{{typeObj.price.unit + \' \' + (typeObj.price.value / 100).toFixed(2)}}</label></td><td><label class=\"m-0 ellipsis-label\">{{typeObj.energy.value + \' \' + typeObj.energy.unit}}</label></td><td class=\"p-r-8\">{{typeObj.attributesKvpArr.length}}</td></tr><tr ng-if=\"filterTypes.length === 0\"><td class=\"p-l-8\">No matching results</td></tr></tbody></table></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button ng-click=\"fnOpenCreateTypeView()\" class=\"btn btn-primary v4-primary-button\">Create Type</button></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex !== 1 && isCreate\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Types</h1><h2 class=\"m-0 m-t-10\">Describes the types of nodes that are supported and their attributes</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"typesCreateMainContainer\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedCreateSubTabIndex\"><uib-tab index=\"1\" select=\"selectedCreateSubTabIndex = 1\" ng-click=\"fnSelectSubTab(1)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"reference\" type=\"text\" ng-model=\"createTypeObj.id\" ng-change=\"fnCheckCreateTypeReference()\" placeholder=\"Reference*\" name=\"reference\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\" ng-if=\"isReferencePatternMismatched\">Reference can only contain lowercase letters and numbers.</small> <small class=\"helper-text\" ng-if=\"isReferenceDuplicated\">The Reference is already in use.</small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"createTypeObj.name\" placeholder=\"Name*\" name=\"name\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"version\" type=\"text\" ng-model=\"createTypeObj.version\" placeholder=\"Version*\" name=\"version\"> <span class=\"highlight\"></span> <label>Version*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSource\" type=\"text\" ng-model=\"createTypeObj.dataSource\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, createTypeObj.dataSource, \'create\')\" ng-change=\"fnCheckUniqueKeyForDataSource(createTypeObj.dataSource)\" placeholder=\"Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"price\" type=\"number\" ng-model=\"createTypeObj.price.value\" placeholder=\"Price*\" name=\"price\"> <span class=\"highlight\"></span> <label>Price*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{createTypeObj.price.unit}}</span> <label class=\"titleLabel\">Currency*</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"currencyObj in currencyArr\"><a ng-click=\"fnSelectCurrencyCode(currencyObj.code)\"><span ng-class=\"currencyObj.code === createTypeObj.price.unit ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"currencyObj.code === createTypeObj.price.unit\"></i></span> <span>{{currencyObj.code}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"energy\" type=\"number\" ng-model=\"createTypeObj.energy.value\" placeholder=\"Energy*\" name=\"energy\"> <span class=\"highlight\"></span> <label>Energy*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"unit\" type=\"text\" ng-model=\"createTypeObj.energy.unit\" placeholder=\"Unit*\" name=\"unit\"> <span class=\"highlight\"></span> <label>Unit*</label> <small class=\"helper-text\"></small></div></div></div></div></div></uib-tab><uib-tab index=\"2\" select=\"selectedCreateSubTabIndex = 2\" ng-click=\"fnSelectSubTab(2)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Attributes</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 m-b-30 p-0 d-flex align-items-center\" ng-repeat=\"attrObj in createTypeObj.attributesKvpArr track by $index\"><div class=\"md-input w100 m-b-0 m-r-10\"><input class=\"md-form-control\" required=\"\" id=\"{{attrObj.key + \'_\' + $index}}\" type=\"text\" ng-model=\"attrObj.key\" ng-change=\"fnCheckUniqueKeyForCreateAttributes(attrObj, $index)\" placeholder=\"Reference*\" name=\"{{attrObj.key + \'_\' + $index}}\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicatedForCreateAttr && $index === duplicatedIndexForCreateAttr\"><span class=\"errorText\">The Key is already in Use.</span></small> <small class=\"helper-text\" ng-if=\"isReferencePatternMismatchedForCreateAttr && $index === duplicatedIndexForCreateAttr\">Reference can only contain lowercase letters and numbers.</small></div><i ng-hide=\"createTypeObj.attributesKvpArr.length === 1 && $index === 0\" class=\"fa fa-trash link-primary cursor-pointer\" ng-click=\"fnRemoveAttribute($index)\"></i> <button ng-if=\"$index === createTypeObj.attributesKvpArr.length - 1\" class=\"btn btn-primary v4-primary-button m-l-10\" ng-click=\"fnAddAttribute()\">Add new attribute</button></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"selectedCreateSubTabIndex = 3\" ng-click=\"fnSelectSubTab(2)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Alarms</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><uib-accordion><uib-accordion-group class=\"m-t-20\" ng-repeat=\"alarmsObj in createTypeObj.alarmsArr track by $index\" is-open=\"alarmsObj.open\"><uib-accordion-heading><div class=\"row p-10\"><div class=\"col-sm-2\">{{$index + 1}}. Alarms {{alarmsObj.key}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right m-l-40\" ng-class=\"{\'fa-angle-down\': !alarmsObj.open, \'fa-angle-up\': alarmsObj.open}\"></i> <i class=\"fa fa-plus pull-right m-l-40\" ng-click=\"fnAddAlarm($event, \'create\')\"></i> <i class=\"fa fa-trash pull-right\" ng-hide=\"createTypeObj.alarmsArr.length === 1 && $index === 0\" ng-click=\"fnDeleteAlarm($event, $index, \'create\')\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"alarmKey{{$index}}\" type=\"text\" ng-change=\"fnCheckUniqueAlarmName(alarmsObj, $index, \'create\')\" ng-model=\"alarmsObj.key\" placeholder=\"Alarm Name*\" name=\"typeReference\"> <span class=\"highlight\"></span> <label>Alarm Name*</label> <small class=\"helper-text\" ng-if=\"alarmsObj.isAlarmKeyDuplicated\">The Alarm name is already in use.</small></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmsObj.attributeName}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"attrKey in createTypeObj.attributesKvpArr\"><a ng-click=\"fnSelectAttributeForAlarms(attrKey.key, alarmsObj)\"><span ng-class=\"attrKey.key === alarmsObj.attributeName ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrKey.key === alarmsObj.attributeName\"></i></span> <span>{{attrKey.key}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"mapper\" type=\"text\" ng-model=\"alarmsObj.mapper\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in alarmsObj.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForMappings($item, $model, $label, $event, alarmsObj, alarmsObj.mapper)\" ng-change=\"fnCheckUniqueKeyForMappings(alarmsObj, alarmsObj.mapper)\" placeholder=\"Mapper\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Mapper</label> <small class=\"helper-text\"></small></div></div></div></div></uib-accordion-group></uib-accordion></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"!createTypeObj.id.length || !createTypeObj.name.length || !createTypeObj.version.length || isReferenceDuplicated || isReferencePatternMismatched || isKeyDuplicatedForCreateAttr || isReferencePatternMismatchedForCreateAttr ? \'pace opacity-5\' : \'\'\" ng-click=\"fnAddTypeToList()\">Save Type</button></div></div></div></div></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-if=\"activeTabIndex !== 1 && !isCreate && selectedTypeObj\"><div class=\"col-sm-12 p-20 p-l-30 dashboard-header\" ng-if=\"isFullWidthDevice\"><h1 class=\"m-0 font-bold\">Types</h1><h2 class=\"m-0 m-t-10\">Describes the types of nodes that are supported and their attributes</h2></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"row\"><div id=\"typesMainContainerDetail\" class=\"col-sm-12\"><div class=\"col-sm-12 p-0 h-100\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"selectedSubTabIndex\"><uib-tab index=\"1\" select=\"selectedDetailSubTabIndex = 1\" ng-click=\"fnSelectSubTab(1, \'detail\')\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Details</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeReference\" type=\"text\" ng-model=\"selectedTypeObj.id\" placeholder=\"Reference*\" name=\"typeReference\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeName\" type=\"text\" ng-model=\"selectedTypeObj.name\" placeholder=\"Name*\" name=\"typeName\"> <span class=\"highlight\"></span> <label>Name*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeVersion\" type=\"text\" ng-model=\"selectedTypeObj.version\" placeholder=\"Version*\" name=\"typeVersion\"> <span class=\"highlight\"></span> <label>Version*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeDataSource\" type=\"text\" ng-model=\"selectedTypeObj.dataSource\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForDataSource($item, $model, $label, $event, selectedTypeObj.dataSource, \'select\')\" ng-change=\"fnCheckUniqueKeyForDataSource(selectedTypeObj.dataSource)\" placeholder=\"Data Source\" name=\"typeDataSource\"> <span class=\"highlight\"></span> <label>Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typePrice\" type=\"text\" ng-model=\"selectedTypeObj.price.value\" placeholder=\"Price*\" name=\"typePrice\"> <span class=\"highlight\"></span> <label>Price*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{selectedTypeObj.price.unit}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"currencyObj in currencyArr\"><a ng-click=\"fnSelectCurrencyCode(currencyObj.code, \'detail\')\"><span ng-class=\"currencyObj.code === selectedTypeObj.price.unit ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"currencyObj.code === selectedTypeObj.price.unit\"></i></span> <span>{{currencyObj.code}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeEnergy\" type=\"text\" ng-model=\"selectedTypeObj.energy.value\" placeholder=\"Energy*\" name=\"typeEnergy\"> <span class=\"highlight\"></span> <label>Energy*</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"typeUnit\" type=\"text\" ng-model=\"selectedTypeObj.energy.unit\" placeholder=\"Unit*\" name=\"typeUnit\"> <span class=\"highlight\"></span> <label>Unit*</label> <small class=\"helper-text\"></small></div></div></div></div></div></uib-tab><uib-tab index=\"2\" select=\"selectedDetailSubTabIndex = 2\" ng-click=\"fnSelectSubTab(2, \'detail\')\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Attributes</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\" ng-repeat=\"attrObj in selectedTypeObj.attributesKvpArr track by $index\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"{{\'Type\' + attrObj.key + \'_\' + $index}}\" type=\"text\" ng-model=\"attrObj.key\" ng-change=\"fnCheckUniqueKeyForDetailAttributes(attrObj, $index)\" placeholder=\"Reference*\" name=\"{{\'Type\' + attrObj.key + \'_\' + $index}}\"> <span class=\"highlight\"></span> <label>Reference*</label> <small class=\"helper-text\"></small> <small class=\"helper-text-error\" ng-show=\"isKeyDuplicatedForDetailAttr && $index === duplicatedIndexForDetailAttr\"><span class=\"errorText\">The Key is already in Use.</span></small> <small class=\"helper-text\" ng-if=\"isReferencePatternMismatchedForDetailAttr && $index === duplicatedIndexForDetailAttr\">Reference can only contain lowercase letters and numbers.</small></div><i ng-hide=\"selectedTypeObj.attributesKvpArr.length === 1 && $index === 0\" class=\"fa fa-trash link-primary cursor-pointer m-l-10\" ng-click=\"fnRemoveAttribute($index, \'detail\')\"></i> <button ng-if=\"$index === selectedTypeObj.attributesKvpArr.length - 1\" class=\"btn btn-primary v4-primary-button m-l-10\" ng-click=\"fnAddAttribute(\'detail\')\">Add new attribute</button></div></div></div></div></uib-tab><uib-tab index=\"3\" select=\"selectedDetailSubTabIndex = 3\" ng-click=\"fnSelectSubTab(2, \'detail\')\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\">Alarms</div></div></div></uib-tab-heading><div class=\"tabContent overflow-auto\"><div class=\"col-sm-12 p-t-20 height-inherit\"><div class=\"col-sm-12 p-0 h-100 floatingLabelInput\"><uib-accordion><uib-accordion-group class=\"m-t-20\" ng-repeat=\"alarmsObj in selectedTypeObj.alarmsArr track by $index\" is-open=\"alarmsObj.open\"><uib-accordion-heading><div class=\"row p-10\"><div class=\"col-sm-2\">{{$index + 1}}. Alarms {{alarmsObj.key}}</div><div class=\"col-sm-10\"><i class=\"fa pull-right m-l-40\" ng-class=\"{\'fa-angle-down\': !alarmsObj.open, \'fa-angle-up\': alarmsObj.open}\"></i> <i class=\"fa fa-plus pull-right m-l-40\" ng-click=\"fnAddAlarm($event, \'detail\')\"></i> <i class=\"fa fa-trash pull-right\" ng-hide=\"selectedTypeObj.alarmsArr.length === 1 && $index === 0\" ng-click=\"fnDeleteAlarm($event, $index, \'detail\')\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"alarmKeyDetail{{$index}}\" type=\"text\" ng-change=\"fnCheckUniqueAlarmName(alarmsObj, $index, \'detail\')\" ng-model=\"alarmsObj.key\" placeholder=\"Alarm Name*\" name=\"typeReference\"> <span class=\"highlight\"></span> <label>Alarm Name*</label> <small class=\"helper-text\" ng-if=\"alarmsObj.isAlarmKeyDuplicated\">The Alarm name is already in use.</small></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{alarmsObj.attributeName}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"attrKey in selectedTypeObj.attributesKvpArr\"><a ng-click=\"fnSelectAttributeForAlarms(attrKey.key, alarmsObj)\"><span ng-class=\"attrKey.key === alarmsObj.attributeName ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrKey.key === alarmsObj.attributeName\"></i></span> <span>{{attrKey.key}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"mappingsDetail\" type=\"text\" ng-model=\"alarmsObj.mapper\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in alarmsObj.globalKeyOptions | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"fnGlobalKeySelectedForMappings($item, $model, $label, $event, alarmsObj, alarmsObj.mapper)\" ng-change=\"fnCheckUniqueKeyForMappings(alarmsObj, alarmsObj.mapper)\" placeholder=\"Mapper\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Mapper</label> <small class=\"helper-text\"></small></div></div></div></div></uib-accordion-group></uib-accordion></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button m-l-5\" ng-click=\"fnDeleteType()\">Delete Type</button></div></div></div></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/workbenchDashboard/workbenchDashboard.html","<div class=\"content-box\"><div class=\"content-box-content table-content-box p-0\"><div class=\"col-sm-12 w100 p-0 scrollable-tabset-width\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"users.activeTabIndex\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in workbenchDashboardTabs track by $index\" select=\"fnTabChanged(tab)\" ng-click=\"fnChangeTab(tab, true)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline d-flex\"><div class=\"d-flex flex-column\">{{tab.tabIndex === 1 ? currentWorkspace && currentWorkspace.name ? currentWorkspace.name : tab.title : tab.title}}</div><div class=\"pull-left\" ng-if=\"tab.tabIndex === 1 && isIot3FileLoaded\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnCallResetWorkspace()\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div><div class=\"pull-left\" ng-if=\"tab.tabIndex !== 1\"><div class=\"tab-clear-icon-position\"><span ng-click=\"$event.preventDefault();fnRemoveTab(tab.id)\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 475.2 475.2\"><g><path d=\"M405.6,69.6C360.7,24.7,301.1,0,237.6,0s-123.1,24.7-168,69.6S0,174.1,0,237.6s24.7,123.1,69.6,168s104.5,69.6,168,69.6 s123.1-24.7,168-69.6s69.6-104.5,69.6-168S450.5,114.5,405.6,69.6z M386.5,386.5c-39.8,39.8-92.7,61.7-148.9,61.7 s-109.1-21.9-148.9-61.7c-82.1-82.1-82.1-215.7,0-297.8C128.5,48.9,181.4,27,237.6,27s109.1,21.9,148.9,61.7 C468.6,170.8,468.6,304.4,386.5,386.5z\"></path><path d=\"M342.3,132.9c-5.3-5.3-13.8-5.3-19.1,0l-85.6,85.6L152,132.9c-5.3-5.3-13.8-5.3-19.1,0c-5.3,5.3-5.3,13.8,0,19.1 l85.6,85.6l-85.6,85.6c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4l85.6-85.6l85.6,85.6c2.6,2.6,6.1,4,9.5,4 c3.5,0,6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1l-85.4-85.6l85.6-85.6C347.6,146.7,347.6,138.2,342.3,132.9z\"></path></g></svg></span></div></div></div></div></uib-tab-heading></uib-tab></uib-tabset></scrollable-tabset></div><div class=\"col-sm-12 p-0 overflow-hidden\" ng-show=\"activeTabIndex.tabIndex === 1\"><div class=\"col-sm-12 p-20 p-l-30 p-r-30 dashboard-header d-flex align-items-center justify-content-space-between\" ng-if=\"isFullWidthDevice\"><div class=\"d-flex flex-column\"><h1 class=\"m-0 font-bold\" ng-if=\"!isIot3FileLoaded\">Dashboard</h1><h2 class=\"m-0 m-t-10\" ng-if=\"!isIot3FileLoaded\">Welcome to the IoT3 Workbench</h2><h1 class=\"m-0 font-bold\" ng-if=\"isIot3FileLoaded && currentWorkspace.name\">{{currentWorkspace.name}}</h1><h2 class=\"m-0 m-t-10\" ng-if=\"isIot3FileLoaded && currentWorkspace.description\">{{currentWorkspace.description}}</h2></div><div class=\"d-flex align-items-center justify-content-center\"><button class=\"btn btn-primary v4-primary-button m-r-10\" ng-if=\"isIot3FileLoaded\" ng-click=\"fnEditWorkspace()\"><i class=\"fa fa-edit m-r-5\"></i> Edit Workspace Details</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"isIot3FileLoaded\" ng-click=\"fnInitiateExportWorkbench()\">Export</button></div></div><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div class=\"content-box-content table-content-box\"><div class=\"row\"><div id=\"dashboardMainContainer\" class=\"col-sm-12 overflow-auto\"><div class=\"col-sm-12 p-0 h-100\" ng-if=\"!isIot3FileLoaded\"><div class=\"col-sm-12 p-0 p-t-15 d-flex flex-column\"><h1 class=\"m-0\">Getting Started</h1><label class=\"m-t-10\">Welcome to the next generation of the IoT3 Workbench. This tool is designed to help you create and work with IoT3 files to interact with anything that has a digital footprint. IoT3 files are text based files that contain instruction on how the ECU should go about reading and writing data from OEM equipment. Once you have created and tested a file you can remotely deploy it to an ECU to connect with it instantly.</label><div class=\"col-sm-12 p-0 m-t-20\"><div class=\"col-sm-3 p-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Build an IoT3 workspace from scratch.</label><div class=\"col-sm-12 p-0 p-t-20\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnCreateIot3Workspace(true)\">New</button></div></div></div><div class=\"col-sm-3 p-r-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Open an existing IoT3 workspace.</label><div class=\"col-sm-12 p-0 p-t-20\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnOpenWorkspaceList(false)\">Open</button></div></div></div><div class=\"col-sm-3 p-r-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Import your own existing IoT3 file.</label><div class=\"col-sm-12 p-0 p-t-20\"><span for=\"upload-file-selector\"><input id=\"upload-file-selector\" ng-model=\"fileArray\" name=\"myfile\" onclick=\"document.getElementById(\'upload-file-selector\').value = \'\'\" onchange=\"document.getElementById(\'uploadProcessLink\').click()\" type=\"file\" accept=\".iot3, .iot3Wb\" style=\"visibility:hidden; height: 0px;\"> <a id=\"uploadProcessLink\" class=\"p-0 m-0 no-borders\" ng-click=\"uploadFiles()\" style=\"visibility:hidden; height: 0px;\"></a> <a class=\"btn btn-primary v4-primary-button\" onclick=\"document.getElementById(\'upload-file-selector\').click()\">Import</a></span></div></div></div><div class=\"col-sm-3 p-r-0\"><div class=\"col-sm-12 p-t-15 p-b-15 iotDashboardPanel\"><label class=\"ellipsis m-0\">Search and Import an IoT3 blueprint file.</label><div class=\"col-sm-12 p-0 p-t-20\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"fnOpenWorkspaceList(true)\">Search</button></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-40 d-flex flex-column\"><h1 class=\"m-0\">Tutorials</h1><div class=\"col-sm-12 p-0 m-t-10 d-flex align-items-center justify-content-start\"><div class=\"d-flex flex-column p-r-25\"><h3 class=\"m-0 m-b-5\" style=\"font-weight: normal\">Discover IoT3</h3><label class=\"m-b-10\">Learn about IoT3, what is it made up of and how does it work.</label><iframe width=\"500\" height=\"250\" ng-src=\"{{ videoSource }}\" ng-if=\"videoSource\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div><div class=\"d-flex flex-column\"><h3 class=\"m-0 m-b-5\" style=\"font-weight: normal\">Build your first IoT3</h3><label class=\"m-b-10\">The team that created IoT3 shows how to create your first file from scratch.</label><iframe width=\"500\" height=\"250\" ng-src=\"{{ videoSource }}\" ng-if=\"videoSource\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></div></div><div class=\"col-sm-12 p-0 p-t-40 d-flex flex-column\"><h1 class=\"m-0\">Documentation</h1><div class=\"col-sm-12 p-0 m-t-10 d-flex flex-column\"><label class=\"m-0 m-b-5\" style=\"font-weight: normal\">ECSMon: <button class=\"btn btn-link p-0 m-0\"><label class=\"m-0\">IoT3 Syntax</label></button></label> <label class=\"m-0\" style=\"font-weight: normal\">ECSMon: <button class=\"btn btn-link p-0 m-0\"><label class=\"m-0\">IoT3 Workbench</label></button></label></div></div></div><div class=\"col-sm-12 p-0 h-100\" ng-if=\"isIot3FileLoaded\" ng-init=\"fnInitIot3Dashboard()\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-6 p-0\"><h2 class=\"font-bold m-b-15\">Stats</h2><div class=\"col-sm-12 m-b-10\" ng-repeat=\"statObj in statsArr track by $index\"><div class=\"col-sm-3 p-0\"><label class=\"m-0\">{{statObj.key}}</label></div><div class=\"col-sm-9 p-0\"><label class=\"m-0 text-primary\">{{statObj.value}}</label></div></div></div><div class=\"col-sm-6 p-0\"><h2 class=\"font-bold m-b-15\">Info</h2><div class=\"col-sm-12 m-b-10\" ng-repeat=\"infoSecObj in infoSecArr track by $index\"><div class=\"col-sm-3 p-0\"><label class=\"m-0\">{{infoSecObj.key}}</label></div><div class=\"col-sm-9 p-0\"><label class=\"m-0 text-primary\" ng-if=\"infoSecObj.key === \'Versions\'\"><span ng-repeat=\"revValue in infoSecObj.value track by $index\">{{revValue}} <span ng-if=\"$index !== infoSecObj.value.length - 1\">,</span></span> <span ng-if=\"!infoSecObj.value.length\">-</span></label> <label class=\"m-0 text-primary\" ng-if=\"infoSecObj.key === \'Labels\'\"><span ng-repeat=\"labelVal in infoSecObj.value track by $index\">{{labelVal}} <span ng-if=\"$index !== infoSecObj.value.length - 1\">,</span></span> <span ng-if=\"!infoSecObj.value.length\">-</span></label> <label class=\"m-0 text-primary\" ng-if=\"infoSecObj.key !== \'Versions\' && infoSecObj.key !== \'Labels\'\">{{infoSecObj.value}}</label></div></div></div></div><div class=\"col-sm-12 p-0\"><h2 class=\"font-bold m-b-15\">Progress</h2><div class=\"col-sm-12 p-0\"><div class=\"col-sm-4 m-b-15\" ng-repeat=\"progressObj in progressArr track by $index\"><div class=\"col-sm-12 p-t-15 p-b-15 product-card\"><div class=\"col-sm-12 p-0 m-b-15 d-flex align-items-center justify-content-space-between\"><h2 class=\"m-0 text-primary\" ng-click=\"fnInitiateTabChange(progressObj.sideTab)\">{{progressObj.displayName}}</h2><h1 class=\"font-bold m-0\">{{progressObj.percentage}}%</h1></div><div class=\"col-sm-12 p-0\"><button class=\"m-0 p-0 btn btn-link\" uib-tooltip=\"{{progressObj.issuesArr && progressObj.issuesArr.length ? \'Click to see the issue details\' : \'\'}}\" tooltip-placement=\"right\" ng-class=\"progressObj.issuesArr && progressObj.issuesArr.length ? \'\' : \'pace\'\" ng-click=\"fnShowIssues(progressObj.displayName, progressObj.issuesArr)\">{{progressObj.issues}} Issues</button></div></div></div></div></div><div class=\"col-sm-12 p-0\"><h2 class=\"font-bold m-b-15\">Comments</h2></div></div></div></div></div></div><div class=\"content-box-footer d-flex p-t-10 p-b-10 col-sm-12\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div></div></div></div></div>");
$templateCache.put("app/node/job/jobInfo/jobTabs/jobBashScript/jobBashScript.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitBashScript()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!jobBashCommandDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput p-0 h-100\" ng-if=\"jobBashCommandDetailsLoaded\"><div class=\"col-sm-12 p-0 height-inherit\"><ui-codemirror class=\"userDataEditor\" ng-model=\"scriptObj.script\" ui-codemirror-opts=\"jobBashScriptOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/job/jobInfo/jobTabs/jobOutput/jobOutput.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitOutput()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!jobBashCommandDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput p-0 h-100\" ng-if=\"jobBashCommandDetailsLoaded\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"fnInitJobAudits()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"jobOutput\" ui-codemirror-opts=\"jobEditorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/job/jobInfo/jobTabs/jobPayload/jobPayload.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitPayload()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isJobDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isJobDetailsLoaded\"><div class=\"col-sm-12 p-0\" style=\"margin: auto;\"><h1>Payload</h1></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isJobDetailsLoaded && jobObj.payload\"><div class=\"md-input m-b-20 m-t-10\"><json-formatter json=\"jobObj.payload\" open=\"100\"></json-formatter></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/job/jobInfo/jobTabs/jobResults/jobResults.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitResults()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isJobDetailsLoaded\"></div><div class=\"col-sm-12 floatingLabelInput p-0 h-100\" ng-if=\"isJobDetailsLoaded\"><div class=\"col-sm-12 p-0 height-inherit\" ng-init=\"fnInitJobAudits()\"><ui-codemirror class=\"userDataEditor\" ng-model=\"jobSummary\" ui-codemirror-opts=\"jobEditorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{jobObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(jobObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/lifecycle/lifecycleInfo/lifecycleTabs/lifecycleStep/lifecycleStep.html","<div class=\"h-100\" ng-controller=\"LifecycleStepCtrl as lifecycleStep\" ng-init=\"lifecycleStep.fnInitLifecycleSteps()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"lifecycleStep.isLifecycleStepsLoading\"></div><div class=\"col-sm-12\" ng-if=\"!lifecycleStep.isLifecycleStepsLoading && !lifecycleStep.isLifecycleStepDetailLoad\"><lifecycle-timeline lifecycle-steps-arr=\"lifecycleStep.lifecycleStepsArr\" get-lifecycle-step=\"lifecycleStep.fnGetLifecycleStep(lifecycle)\"></lifecycle-timeline></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"!lifecycleStep.isLifecycleStepsLoading && lifecycleStep.isLifecycleStepDetailLoad\"><div class=\"m-b-10 m-t-10\" ng-click=\"lifecycleStep.fnInitLifecycleSteps()\"><span class=\"btn btn-link p-l-0 p-b-0\"><i class=\"fa fa-arrow-left fa-1x m-r-5\"></i>Back</span></div><div class=\"md-input m-b-10 m-t-20\" ng-if=\"lifecycleStep.selectedLifecycleObj.task\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"task\" type=\"text\" ng-model=\"lifecycleStep.selectedLifecycleObj.task\"> <span class=\"highlight\"></span> <label>Task</label></div><div class=\"md-input m-b-10 m-t-20\" ng-if=\"lifecycleStep.selectedLifecycleObj.result\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"result\" type=\"text\" ng-model=\"lifecycleStep.selectedLifecycleObj.result\"> <span class=\"highlight\"></span> <label>Result</label></div><div class=\"md-input m-b-10 m-t-20\" ng-if=\"lifecycleStep.selectedLifecycleObj.message\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"message\" type=\"text\" ng-model=\"lifecycleStep.selectedLifecycleObj.message\"> <span class=\"highlight\"></span> <label>Message</label></div><div class=\"md-input m-b-10 m-t-20\" ng-if=\"lifecycleStep.selectedLifecycleObj.createDate\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><input class=\"md-form-control\" required=\"\" id=\"time\" type=\"text\" ng-model=\"lifecycleStep.selectedLifecycleObj.createDate\"> <span class=\"highlight\"></span> <label>Date</label></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{lifecycleObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(lifecycleObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"lifecyclePermissionsObj.Delete && !lifecycleStep.isLifecycleStepsLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-if=\"lifecyclePermissionsObj.Delete\" ng-click=\"fnDeleteLifecycle(lifecycleObj)\"><a class=\"btn btn-link\">Delete</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeAttributes/nodeAttributes.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"NodeAttributesCtrl as nodeAttribute\" ng-init=\"nodeAttribute.fnInitNodeAttributes()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"!nodeAttribute.parent.isNodeDetailsLoaded\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-15 h-100\" ng-if=\"nodeAttribute.parent.isNodeDetailsLoaded\" ng-init=\"nodeAttribute.fnGetNodeInfo()\"><div class=\"p-0 h-100 border-1px\" ng-class=\"nodeAttribute.isFullWidthDevice ? \'col-sm-3\':\'col-sm-4\'\"><div class=\"col-sm-12 p-0 local-search-bar-container\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"p-0 w100 v4-search-client-width\"><v4-search-client search-identifier=\"\'nodeAttributeSearch\'\" filters-arr=\"nodeAttribute.searchFiltersArr\" filter-query=\"nodeAttribute.filterQuery\" fn-filter-query-change=\"nodeAttribute.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" state-name=\"\'main.node\'\" no-set-url=\"true\" fn-resize=\"nodeAttribute.fnSetTableHeight()\" sort-field-arr=\"nodeAttribute.sortFieldArr\" default-tag-arr=\"nodeAttribute.defaultAttributeFilterArr\" default-sort-string=\"nodeAttribute.defaultAttributeSortString\" table-alias=\"nodeAttribute.tableAlias\"></v4-search-client></div></div><div class=\"col-sm-12 p-0 overflow-auto\" ng-class=\"nodeAttribute.isShowPaginationContainer ? \'attribute-list-with-pagination-container\':\'attribute-list-container\'\"><div class=\"col-sm-12 p-0\" ng-if=\"nodeAttribute.isAttributesLoading\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\"></app-spinner></div><div class=\"col-sm-12 p-0\" ng-if=\"!nodeAttribute.isAttributesLoading\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in nodeAttribute.attributesList track by $index\" ng-click=\"nodeAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 type-icon\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 alarm-icon\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" context-menu=\"nodeAttribute.attributeNameContextMenu(attributeObj)\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 health-btn\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"nodeAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center attr-name-value-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong context-menu=\"nodeAttribute.attributeNameContextMenu(attributeObj)\" uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex justify-content-flex-end\"><h3 class=\"ellipsis m-0 text-right\" ng-if=\"(attributeObj.value && attributeObj.value.length) || (attributeObj.read && attributeObj.read.unit.length)\" uib-tooltip=\"{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}\" tooltip-placement=\"auto\">{{attributeObj.value}} {{attributeObj.read && attributeObj.read.unit ? attributeObj.read.unit : \'\'}}</h3></div></div></div></div><div class=\"col-sm-12 p-t-8 p-b-8\" ng-if=\"!nodeAttribute.attributesList.length\"><span class=\"ellipsis font-bold\">No matching results</span></div></div></div><div class=\"col-sm-12 p-t-10\"><div class=\"pagination-container\" ng-show=\"!nodeAttribute.isAttributesLoading && nodeAttribute.attributesList.length && nodeAttribute.isShowPaginationContainer\"><div class=\"row\"><div class=\"col-sm-4 p-r-0 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{nodeAttribute.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"nodeAttribute.perPage = 10; nodeAttribute.fnPageChanged(nodeAttribute.currentPage, nodeAttribute.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeAttribute.perPage = 20; nodeAttribute.fnPageChanged(nodeAttribute.currentPage, nodeAttribute.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeAttribute.perPage = 50; nodeAttribute.fnPageChanged(nodeAttribute.currentPage, nodeAttribute.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"nodeAttribute.perPage = 100; nodeAttribute.fnPageChanged(nodeAttribute.currentPage,nodeAttribute.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-8 p-l-0 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"nodeAttribute.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"nodeAttribute.currentPage\" items-per-page=\"nodeAttribute.perPage\" max-size=\"nodeAttribute.maxSize\" boundary-links=\"true\" ng-click=\"nodeAttribute.fnPageChanged(nodeAttribute.currentPage, nodeAttribute.perPage)\"></ul></div></div></div></div></div></div><div class=\"p-r-0 h-100\" ng-class=\"nodeAttribute.isFullWidthDevice ? \'col-sm-2\':\'col-sm-3\'\"><div class=\"col-sm-12 p-0 attr-selected-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Selected</h3></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"nodeAttribute.fnIsAttributeSelected() && nodeAttribute.selectedAttribute.type !== \'node\'\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-repeat=\"selectedAttrObj in nodeAttribute.selectedAttrKeyArr\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">{{selectedAttrObj.name}}:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\'\"><strong>{{nodeAttribute.selectedAttribute[selectedAttrObj.key]}}</strong></label> <label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Units\'\"><strong>{{nodeAttribute.selectedAttribute.read.unit}}</strong></label><div class=\"d-flex align-items-center w100\" ng-if=\"selectedAttrObj.name === \'Health\'\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{nodeAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"nodeAttribute.fnGetHealthColor(nodeAttribute.selectedAttribute[selectedAttrObj.key], nodeAttribute.selectedAttribute)\"></button><div class=\"d-flex align-items-center selected-attr-health-text\"><label class=\"ellipsis m-0 p-l-5\"><strong>{{nodeAttribute.selectedAttribute.healthName}}</strong></label></div></div><label class=\"ellipsis m-0\" ng-if=\"selectedAttrObj.name === \'Alarm\'\"><strong>{{nodeAttribute.selectedAttribute.reference.endsWith(\'!\') ? \'true\': \'false\'}}</strong></label><div ng-if=\"selectedAttrObj.name === \'Type\'\"><div class=\"p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'INT32\' || nodeAttribute.selectedAttribute.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'DATE\' || nodeAttribute.selectedAttribute.read.type === \'TIME\' || nodeAttribute.selectedAttribute.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"nodeAttribute.selectedAttribute.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name !== \'Health\' && selectedAttrObj.name !== \'Type\' && selectedAttrObj.name !== \'Alarm\' && selectedAttrObj.name !== \'Units\' && selectedAttrObj.name !== \'Node\'\"><i class=\"m-l-5 fa\" ng-click=\"nodeAttribute.fnSelectedAttributeCopyToClipboard(selectedAttrObj.key,nodeAttribute.selectedAttribute)\" ng-class=\"!nodeAttribute.selectedAttribute[selectedAttrObj.key+ \'IsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"d-flex align-items-center\" ng-if=\"selectedAttrObj.name === \'Node\'\"><i class=\"m-l-5 fa fa-external-link\" ng-click=\"nodeAttribute.fnOpenNodeInfo();\"></i></div></div></div></div><div class=\"col-sm-12 p-0 overflow-auto selected-container-body\" ng-if=\"nodeAttribute.fnIsAttributeSelected() && nodeAttribute.selectedAttribute.type === \'node\'\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">Name:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>Node</strong></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">Health:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{nodeAttribute.selectedAttribute.healthName}}\" tooltip-placement=\"auto\" ng-style=\"nodeAttribute.fnGetHealthColor(nodeAttribute.selectedAttribute.health, nodeAttribute.selectedAttribute)\"></button></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">ID:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{nodeAttribute.selectedAttribute.id}}</strong></label></div><div class=\"col-sm-1 p-0 d-flex align-items-center\"><div class=\"d-flex align-items-center\"><i class=\"m-l-5 fa\" ng-click=\"nodeAttribute.fnSelectedAttributeCopyToClipboard(\'id\',nodeAttribute.selectedAttribute)\" ng-class=\"!nodeAttribute.selectedAttribute[\'idIsCopyClicked\'] ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\"><div class=\"col-sm-3 p-0 d-flex align-items-center\"><h4 class=\"m-0\">Node:</h4></div><div class=\"col-sm-8 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{nodeAttribute.selectedAttribute.nodeName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotable-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plottable</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotable-container-body\" ng-if=\"nodeAttribute.fnIsAttributeSelected()\"><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-if=\"nodeAttribute.selectedAttribute.type !== \'node\'\" ng-repeat=\"plotableObj in nodeAttribute.plotableArr\" dnd-list=\"\" dnd-draggable=\"nodeAttribute.selectedAttribute\" dnd-callback=\"nodeAttribute.fnOnActionDrop(nodeAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': nodeAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!nodeAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div><div class=\"col-sm-12 p-0 p-l-10 p-b-3 d-flex align-items-center\" ng-if=\"nodeAttribute.selectedAttribute.type === \'node\'\" ng-repeat=\"plotableObj in nodeAttribute.nodePlotableArr\" dnd-list=\"\" dnd-draggable=\"nodeAttribute.selectedAttribute\" dnd-callback=\"nodeAttribute.fnOnActionDrop(nodeAttribute.selectedAttribute, plotableObj.dataType, plotableObj.chartType)\" ng-class=\"{\'pace opacity-5\': nodeAttribute.selectedAttribute[plotableObj.attrKey]}\"><div class=\"col-sm-1 p-0 d-flex align-items-center\"><svg class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\" ng-show=\"!nodeAttribute.selectedAttribute[plotableObj.attrKey]\"><use xlink:href=\"assets/images/svg/drag-drop-icon.svg#drag-drop-icon\"></use></svg></div><div class=\"col-sm-9 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.name}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong>{{plotableObj.sortName}}</strong></label></div></div></div></div></div><div class=\"col-sm-12 p-0 p-t-15 attr-plotted-container\"><div class=\"border-1px h-100\"><div class=\"p-t-10 p-l-10 p-b-10\"><h3 class=\"m-0\">Plotted</h3></div><div class=\"col-sm-12 p-0 overflow-auto plotted-container-body\"><div class=\"col-sm-12 d-flex\" ng-class=\"{\'p-t-2\': !$first, \'p-b-2\': !$last}\" ng-repeat=\"attributeObj in nodeAttribute.selectedChartData track by $index\" ng-click=\"nodeAttribute.fnSelectAttribute(attributeObj)\"><div class=\"d-flex plotted-icon-container\"><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><svg ng-if=\"attributeObj.read.type === \'STRING\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/string.svg#string\"></use></svg><svg ng-if=\"attributeObj.read.type === \'INT32\' || attributeObj.read.type === \'INT64\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/number.svg#number\"></use></svg><svg ng-if=\"attributeObj.read.type === \'FLOAT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/decimal.svg#decimal\"></use></svg><svg ng-if=\"attributeObj.read.type === \'BOOL\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/boolean.svg#boolean\"></use></svg><svg ng-if=\"attributeObj.read.type === \'DATE\' || attributeObj.read.type === \'TIME\' || attributeObj.read.type === \'DATETIME\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/date-time.svg#date_time\"></use></svg><svg ng-if=\"attributeObj.read.type === \'OBJECT\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/json.svg#json\"></use></svg><svg ng-if=\"attributeObj.read.type === \'ARRAY\'\" class=\"custom-svg-side-menu-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/dataType/array.svg#array\"></use></svg></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><div class=\"d-flex\" ng-if=\"attributeObj.reference.endsWith(\'!\')\" uib-tooltip=\"Alarm Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/alarm.svg#alarm\"></use></svg></div><div class=\"d-flex\" ng-if=\"attributeObj.mode === \'RW\' || attributeObj.mode === \'rw\'\" uib-tooltip=\"RW Attribute\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor attribute-icon\" width=\"15px\" height=\"15px\"><use xlink:href=\"assets/images/svg/readWriteAttribute.svg#readWriteAttribute\"></use></svg></div></div><div class=\"col-sm-1 p-0 d-flex align-items-center m-r-5 w-15-px\"><button class=\"btn btn-xs btn-default health-btn-default\" uib-tooltip=\"{{attributeObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"nodeAttribute.fnGetHealthColor(attributeObj.health, attributeObj)\"></button></div></div><div class=\"d-flex align-items-center plotted-attr-name-container\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-10 p-l-5 p-r-5 d-flex align-items-center\"><label class=\"ellipsis m-0\"><strong uib-tooltip=\"{{attributeObj.displayName}}\" tooltip-placement=\"auto\">{{attributeObj.displayName}}</strong></label></div><div class=\"col-sm-2 p-0 d-flex\"><label class=\"ellipsis m-0\"><strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeValue\'\">[AV]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'attributeHealth\'\">[AH]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeValue\'\">[FV]</strong> <strong ng-if=\"attributeObj.dataType === \'Forecast\' && attributeObj.chartType === \'attributeHealth\'\">[FH]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeValue\'\">[VA]</strong> <strong ng-if=\"attributeObj.dataType === \'Anomaly\' && attributeObj.chartType === \'attributeHealth\'\">[HA]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'nodeConnection\'\">[AC]</strong> <strong ng-if=\"attributeObj.dataType === \'Actual\' && attributeObj.chartType === \'nodeHealth\'\">[AH]</strong></label></div></div></div><div class=\"d-flex align-items-center w-15-px\"><div class=\"d-flex align-items-center w-15-px\"><i class=\"m-l-5 fa fa-trash-o\" ng-click=\"nodeAttribute.fnRemoveChartData(attributeObj)\"></i></div></div></div></div></div></div></div><div class=\"p-r-0 h-100 d-flex flex-column h-100\" ng-class=\"nodeAttribute.isFullWidthDevice ? \'col-sm-7\':\'col-sm-5\'\"><div class=\"col-sm-12 p-0 chart-icon-height\"><div class=\"col-sm-2 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-l-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedGranularity.name}}</span> <label class=\"titleLabel ellipsis-label\">GRANULARITY</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"granularityObj in nodeAttribute.granularityArr track by $index\"><a ng-click=\"nodeAttribute.selectedGranularity = granularityObj;nodeAttribute.fnSetGranularity()\"><span>{{granularityObj.name}}</span></a></li></ul></div></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px border-1px\"><div class=\"col-sm-12 p-0 w100 overflow-auto d-flex h-100\"><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"nodeAttribute.selectedChartType = \'spline\'; nodeAttribute.fnRenderChart()\"><svg ng-class=\"nodeAttribute.selectedChartType === \'spline\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/arrow-chart.svg#arrow-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"nodeAttribute.selectedChartType = \'pie\'; nodeAttribute.selectedPieChartData = nodeAttribute.pieChartAttributeList[0];nodeAttribute.fnRenderChart()\"><svg ng-class=\"nodeAttribute.selectedChartType === \'pie\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/pie-chart.svg#pie-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"nodeAttribute.selectedChartType = \'bar\'; nodeAttribute.fnRenderChart()\"><svg ng-class=\"nodeAttribute.selectedChartType === \'bar\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/bar-chart.svg#bar-chart\"></use></svg></div><div class=\"col-sm-12 h-100 d-flex align-items-center justify-content-center W-50\" ng-click=\"nodeAttribute.selectedChartType = \'heatmap\';nodeAttribute.selectedHeatmapChartAttr = nodeAttribute.heatmapChartAttributeList[0] ;nodeAttribute.fnRenderChart()\"><svg ng-class=\"nodeAttribute.selectedChartType === \'heatmap\' ? \'selected-chart-type\':\'svgIconFillTextSecondaryColor\'\" width=\"26px\" height=\"26px\"><use xlink:href=\"assets/images/svg/service/node/nodeAttributes/heatmap-chart.svg#heatmap-chart\"></use></svg></div></div><label class=\"customChartsLabel\">CHART</label></div><div class=\"col-sm-3 p-0 d-flex align-items-center h-50px customDropdown\"><div class=\"btn-group col-sm-12 p-r-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedAutoUpdateType}}</span> <label class=\"titleLabel ellipsis-label\">AUTO UPDATE</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"nodeAttribute.selectedAutoUpdateType = \'Static\';nodeAttribute.fnSelectAutoUpdateChart()\"><span>Static</span></a></li><li><a ng-click=\"nodeAttribute.selectedAutoUpdateType = \'Streaming\';nodeAttribute.fnSelectAutoUpdateChart()\"><span>Streaming</span></a></li></ul></div></div><div class=\"col-sm-4 p-r-0 h-50px node-attribute-date-range\"><div class=\"col-sm-12 h-100 border-1px d-flex align-items-center\" id=\"rangedatetimesAttribute\" ng-click=\"nodeAttribute.fnOpenData()\"><span class=\"m-0 ellipsis\" id=\"selectedDate\">No date range selected...</span></div><label class=\"dateRangeLabel\">Date Range</label> <span class=\"caret\"></span></div></div><div class=\"col-sm-12 p-0 m-t-15 h-100 border-1px chart-container-height position-r\" dnd-list=\"\" dnd-drop=\"callback({targetList: attributeObj})\"><div class=\"col-sm-12 p-0 h-100 w100\" ng-if=\"nodeAttribute.selectedChartData.length\"><div class=\"col-sm-12 p-0 h-100 w100\"><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"nodeAttribute.selectedChartType !== \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10\" ng-if=\"nodeAttribute.selectedChartType !== \'pie\'\"><div class=\"d-flex align-items-center\"></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li><li><a ng-click=\"nodeAttribute.fnExportToInsight()\">Export to Insight</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\" ng-if=\"nodeAttribute.selectedChartType === \'pie\'\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedPieChartData && nodeAttribute.selectedPieChartData.name ? nodeAttribute.selectedPieChartData.name : \'No data found\'}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in nodeAttribute.pieChartAttributeList\"><a ng-click=\"nodeAttribute.fnSelectPieChartAttr(chartObj);\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeChart\')\">Download PNG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeChart\')\">Download JPEG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeChart\')\">Download PDF Document</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container\" ng-if=\"nodeAttribute.selectedChartType !== \'pie\'\"><div id=\"nodeAttributeChart\" class=\"nodeAttributeChart h-100 w100\"></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container-with-pie-chart\" ng-if=\"nodeAttribute.selectedChartType === \'pie\'\"><div id=\"nodeAttributeChart\" class=\"nodeAttributeChart h-100 w100\" ng-if=\"nodeAttribute.selectedPieChartData && nodeAttribute.selectedPieChartData.name\"></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!nodeAttribute.selectedPieChartData && !nodeAttribute.selectedPieChartData.name\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div><div class=\"col-sm-12 p-0 p-r-5 p-l-5 h-100\" ng-if=\"nodeAttribute.selectedChartType === \'heatmap\'\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between p-r-10 p-t-10 customDropdown\"><div class=\"d-flex align-items-center W-50\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedHeatmapChartAttr && nodeAttribute.selectedHeatmapChartAttr.name ? nodeAttribute.selectedHeatmapChartAttr.name : \'No data found\'}}</span> <label class=\"titleLabel\">Attribute</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"chartObj in nodeAttribute.heatmapChartAttributeList\"><a ng-click=\"nodeAttribute.selectedHeatmapChartAttr = chartObj;nodeAttribute.fnRenderChart()\"><span>{{chartObj.name}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedYAxis.title}}</span> <label class=\"titleLabel\">Y AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in nodeAttribute.axisArr track by $index\"><a ng-click=\"nodeAttribute.selectedYAxis = axisObj;nodeAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedXAxis.title}}</span> <label class=\"titleLabel\">X AXIS</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"axisObj in nodeAttribute.axisArr track by $index\"><a ng-click=\"nodeAttribute.selectedXAxis = axisObj;nodeAttribute.fnRenderChart()\"><span>{{axisObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\" style=\"width: 15%\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeAttribute.selectedMathFunction}}</span> <label class=\"titleLabel\">Math Function</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mathFunctionObj in nodeAttribute.mathFunction track by $index\"><a ng-click=\"nodeAttribute.selectedMathFunction = mathFunctionObj.title;nodeAttribute.fnRenderChart()\"><span>{{mathFunctionObj.title}}</span></a></li></ul></div></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPNG\', \'nodeAttributeHeatmapChart\')\">Download PNG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadJPEG\', \'nodeAttributeHeatmapChart\')\">Download JPEG image</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadPDF\', \'nodeAttributeHeatmapChart\')\">Download PDF Document</a></li><li><a ng-click=\"nodeAttribute.fnExportChart(\'downloadSVG\', \'nodeAttributeHeatmapChart\')\">Download SVG vector image</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\" ng-if=\"nodeAttribute.selectedHeatmapChartAttr && nodeAttribute.selectedHeatmapChartAttr.name\"><div id=\"nodeAttributeHeatmapChart\" class=\"nodeAttributeChart h-100 w100\"></div></div><div class=\"col-sm-12 p-0 HighChartPie nodeAttributeChart-container heatmapChart-container m-t-20\" ng-if=\"!nodeAttribute.selectedHeatmapChartAttr && !nodeAttribute.selectedHeatmapChartAttr.name\"><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 p-0 h-100 w100 d-flex align-items-center justify-content-center\" ng-if=\"!nodeAttribute.selectedChartData.length\"><svg class=\"dashboard-img-not-found\"><use xlink:href=\"assets/images/svg/statistics.svg#statistics\"></use></svg></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeAttribute.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeAttribute.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeForm/nodeForm.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeFormCtrl as nodeForm\" ng-init=\"nodeForm.fnInitNodeForm()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-20 h-100\"></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeForm.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeForm.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeGraph/nodeGraph.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeGraphCtrl as nodeGraph\" ng-init=\"nodeGraph.fnInitNodeGraph();nodeGraph.fnGetNodeInfo()\"><div class=\"content-main node-graph-tab\"><div class=\"col-sm-12 p-0 p-15 h-100 d-flex align-items-center justify-content-center\" ng-if=\"nodeGraph.isNodeLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\"></div></div><div class=\"col-sm-12 p-0 p-t-20 h-100\" ng-if=\"!nodeGraph.isNodeLoading\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-3 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{nodeGraph.selectedGraphObj.displayName}}</span> <label class=\"titleLabel\">Node</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"options in nodeGraph.graphOptionsArr\"><a ng-click=\"nodeGraph.selectedGraphObj = options;nodeGraph.fnRenderGraph(options);nodeGraph.fnSaveGraphInfo()\"><span>{{options.displayName}}</span></a></li></ul></div></div><div class=\"col-sm-8 p-l-0\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"nodeGraph.parent.isEcuDetailsLoaded && !nodeGraph.parent.isObjectEmpty(nodeGraph.parent.ecuObj)\" ng-click=\"nodeGraph.fnOpenECUInfo()\"><div class=\"col-sm-3 p-0\"><div class=\"ellipsis\"><h3 class=\"m-0\">{{nodeGraph.parent.ecuObj.name}}</h3></div><div class=\"ellipsis m-t-5\"><i>{{nodeGraph.parent.ecuObj.description}}</i></div></div><div class=\"col-sm-2 p-0 d-flex flex-column\"><div class=\"d-flex align-items-center justify-content-space-between w-90\"><div class=\"d-flex\" uib-tooltip=\"{{\'ECU Connection\'}}\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" ng-class=\"nodeGraph.parent.ecuObj.connected ? \'isConnected\':\'isDisconnected\'\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"nodeGraph.parent.ecuObj.connected\">Connected</span> <span ng-if=\"!nodeGraph.parent.ecuObj.connected\">Disconnected</span></span></div><div class=\"m-t-5 d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"Last Seen\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/node/lastSeen.svg#lastSeen\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{nodeGraph.parent.ecuObj.lastSeenDate ? nodeGraph.parent.ecuObj.lastSeenDate : \'Never\' }}</span></div></div><div class=\"col-sm-2 p-0 d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\" uib-tooltip=\"VPN\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuvpn.svg#ecuvpn\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"nodeGraph.parent.ecuObj.vpn === \'ENABLED\'\">Enabled</span> <span ng-if=\"nodeGraph.parent.ecuObj.vpn === \'DISABLED\'\">Disabled</span> <span ng-if=\"nodeGraph.parent.ecuObj.vpn === \'ENABLING\'\">Enabling</span> <span ng-if=\"nodeGraph.parent.ecuObj.vpn === \'DISABLING \'\">Disabling</span></span></div><div class=\"d-flex m-t-5 align-items-center\"><div class=\"d-flex\" uib-tooltip=\"NTP\" tooltip-placement=\"auto\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/nodeECU/ecuntp.svg#ecuntp\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\"><span ng-if=\"nodeGraph.parent.ecuObj.ntp === \'ENABLED\'\">Enabled</span> <span ng-if=\"nodeGraph.parent.ecuObj.ntp === \'DISABLED\'\">Disabled</span> <span ng-if=\"nodeGraph.parent.ecuObj.ntp === \'ENABLING\'\">Enabling</span> <span ng-if=\"nodeGraph.parent.ecuObj.ntp === \'DISABLING \'\">Disabling</span></span></div></div><div class=\"col-sm-2 p-0 d-flex align-items-center\"><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{nodeGraph.parent.ecuObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"nodeGraph.parent.fnGetHealthColor(nodeGraph.parent.ecuObj.health, nodeGraph.parent.ecuObj)\"><span class=\"healthSpan\">{{nodeGraph.parent.ecuObj.healthName}}</span></button></div><div class=\"col-sm-3\"></div></div><div class=\"col-sm-12 p-0\" ng-if=\"!nodeGraph.parent.isEcuDetailsLoaded\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div><div class=\"col-sm-1\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"nodeGraph.selectedGraphObj.name === \'MERMAID\'\"><a class=\"btn btn-link\" ng-click=\"nodeGraph.fnOpenMermaidEditor()\">Mermaid Editor</a></li><li ng-if=\"nodeGraph.selectedGraphObj.name !== \'MERMAID\' && nodeGraph.selectedGraphView === \'fileView\'\"><a class=\"btn btn-link\" ng-click=\"nodeGraph.selectedGraphView = \'HierarchicalView\';nodeGraph.fnCreatePanzoom()\">Graph View</a></li><li ng-if=\"nodeGraph.selectedGraphObj.name !== \'MERMAID\' && nodeGraph.selectedGraphView !== \'fileView\'\"><a class=\"btn btn-link\" ng-click=\"nodeGraph.selectedGraphView = \'fileView\'; nodeGraph.expandAll()\">File View</a></li><li ng-if=\"nodeGraph.selectedGraphObj.name !== \'MERMAID\' && nodeGraph.selectedGraphView === \'fileView\'\" ng-click=\"nodeGraph.collapseAll()\"><a class=\"btn btn-link\">Collapse All</a></li><li ng-if=\"nodeGraph.selectedGraphObj.name !== \'MERMAID\' && nodeGraph.selectedGraphView === \'fileView\'\" ng-click=\"nodeGraph.expandAll()\"><a class=\"btn btn-link\">Expand All</a></li><li ng-if=\"nodeGraph.selectedGraphObj.name !== \'MERMAID\' && nodeGraph.selectedGraphView === \'fileView\'\" ng-click=\"nodeGraph.fnExportXLS()\"><a class=\"btn btn-link\">Export XLS</a></li></ul></div></div></div><div class=\"col-sm-12 graphRelationships overflow-auto\" ng-if=\"nodeGraph.selectedGraphObj.name === \'AUTO_COMPLETE\' || nodeGraph.selectedGraphObj.name === \'AUTO_UPSTREAM\' || nodeGraph.selectedGraphObj.name === \'AUTO_DOWNSTREAM\'\" style=\"height: calc(100% - 55px)\"><div class=\"h-100\" id=\"graphRelationshipsParentDiv\" ng-if=\"nodeGraph.selectedGraphView === \'HierarchicalView\'\"><div class=\"h-100\" id=\"graphRelationshipsParentDesign\"><div class=\"tf-tree text-center p-b-15 width-fit-content height-fit-content\" ng-if=\"nodeGraph.nodeTreeData && nodeGraph.nodeTreeData.name && nodeGraph.nodeTreeData.name !== \'\'\"><ul><li class=\"text-center\" graph-relationships=\"\" selected-id=\"nodeGraph.parent.nodeObj.id\" fn-get-node-detail=\"nodeGraph.fnOpenNodeInfoTab(nodeObj)\" fn-get-node-telemetry-detail=\"nodeGraph.fnOpenNodeTelemetryTab(nodeObj)\" node-obj=\"nodeGraph.nodeTreeData\"></li></ul></div></div></div><div class=\"h-100 p-t-10\" ng-if=\"nodeGraph.selectedGraphView === \'fileView\'\"><div class=\"col-sm-12 p-0 treeControlPanel\" id=\"inventoryFileTree\"><div class=\"createLine\"><custom-tree-ui ng-repeat=\"data in nodeGraph.nodeFileDisplayData\" current-node=\"nodeGraph.parent.nodeObj\" tree-data=\"data\" level=\"0\" is-root-parent=\"false\" is-last-child=\"false\" parent-inventories=\"nodeGraph.nodeFileDisplayData\" fn-get-node-detail=\"nodeGraph.fnOpenNodeInfoTab(nodeObj)\" fn-get-node-telemetry-detail=\"nodeGraph.fnOpenNodeTelemetryTab(nodeObj)\" fn-get-node-edit-detail=\"nodeGraph.fnOpenNodeEditModal(nodeObj)\" fn-get-node-edit-and-cascade-detail=\"nodeGraph.fnOpenNodeEditAndCascadeModal(nodeObj)\"></custom-tree-ui></div></div></div></div><div class=\"col-sm-12 overflow-auto\" ng-if=\"nodeGraph.selectedGraphObj.name === \'MERMAID\'\" style=\"height: calc(100% - 55px)\"><div class=\"w100 d-flex align-items-center justify-content-center h-100\" ng-if=\"!nodeGraph.finalMermaidString.length\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>Create a customized mermaid graph.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"nodeGraph.fnOpenMermaidEditor()\">Create Mermaid Graph</button></div></div><div class=\"col-sm-12 p-0\" style=\"height: 100%; width: 100%\" id=\"mermaidGraphParent\"><div id=\"mermaidGraph\" class=\"mermaid\" ng-if=\"nodeGraph.isShowMermaid && nodeGraph.finalMermaidString.length\">{{nodeGraph.finalMermaidString}}</div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeGraph.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeGraph.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><label class=\"m-0\">Total Nodes: {{nodeGraph.totalNodes}}</label></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeIOT3/nodeIOT3.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeIOT3Ctrl as nodeIOT\" ng-init=\"nodeIOT.fnInitNodeIOT3()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-20 h-100\"></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeIOT.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeIOT.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeLocation/nodeLocation.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeLocationCtrl as nodeLocation\" ng-init=\"nodeLocation.fnInitNodeLocation()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-0 h-100\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!nodeLocation.parent.isNodeDetailsLoaded\"></div><div class=\"col-sm-12 p-t-10 p-l-10 p-r-10 floatingLabelInput\" ng-if=\"nodeLocation.parent.isNodeDetailsLoaded\" ng-init=\"nodeLocation.fnGetNodeLocation()\"><div class=\"col-sm-12 p-0 m-t-10\" id=\"locationInputBlock\"><div class=\"col-sm-6 p-l-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"lat\" type=\"text\" ng-model=\"nodeLocation.actualLatitude\" ng-change=\"nodeLocation.fnChangeLocation()\" placeholder=\"Latitude for node*\"> <span class=\"highlight\"></span> <label>Latitude*</label></div></div><div class=\"col-sm-6 p-r-0\"><div class=\"md-input m-b-10\"><input class=\"md-form-control\" required=\"\" id=\"long\" type=\"text\" ng-model=\"nodeLocation.actualLongitude\" ng-change=\"nodeLocation.fnChangeLocation()\" placeholder=\"Longitude for node*\"> <span class=\"highlight\"></span> <label>Longitude*</label></div></div><div class=\"col-sm-12 p-0\"><h3>Drag marker to set coordinates</h3></div></div><div class=\"col-sm-12 p-0 p-b-10\" id=\"locationMapBlock\"><div class=\"col-sm-12 p-0\" id=\"nodeLocationMap\"></div></div><div class=\"col-sm-12 p-0\" id=\"locationSaveActionBlock\"><div class=\"pull-right\" ng-if=\"nodeLocation.isSaveLoaderActive\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><button ng-if=\"!nodeLocation.isSaveLoaderActive && nodeLocation.nodeObj.lifecycleState === \'READY\'\" ng-disabled=\"!nodeLocation.actualLatitude.toString().length || !nodeLocation.actualLongitude.toString().length\" class=\"btn btn-primary pull-right\" ng-click=\"nodeLocation.fnSaveLocationInfo()\">Save</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeLocation.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeLocation.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeMeta/nodeMeta.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeMetaCtrl as nodeMeta\" ng-init=\"nodeMeta.fnInitNodeMeta()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 p-t-20 h-100\"></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeMeta.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeMeta.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/node/nodeInfo/nodeSteps/nodeSupplemental/nodeSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeSupplementalCtrl as nodeSupplemental\" ng-init=\"nodeSupplemental.fnInitNodeSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!nodeSupplemental.parent.isNodeDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"nodeSupplemental.parent.isNodeDetailsLoaded\" ng-init=\"nodeSupplemental.fnGetNodeData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"nodeSupplemental.supplementalKVPArr.length || nodeSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!nodeSupplemental.isSupplementalDetailsEditable && nodeSupplemental.parent.userPermissionsObj.REPLACE_NODE_TAGS && nodeSupplemental.parent.nodeObj.lifecycleState === \'READY\'\" ng-click=\"nodeSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"nodeSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{nodeSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!nodeSupplemental.supplementalKVPArr.length && !nodeSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"nodeSupplemental.parent.userPermissionsObj.REPLACE_HEALTH_TAGS\" ng-click=\"nodeSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"nodeSupplemental.supplementalKVPArr.length && !nodeSupplemental.isAdvancedOption\" ng-class=\"!nodeSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"nodeSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in nodeSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"nodeSupplemental.isKeyDuplicated && $index === nodeSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"nodeSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"nodeSupplemental.isKeyDuplicated && $index === nodeSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"nodeSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"nodeSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"nodeSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"nodeSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"nodeSupplemental.nodeSupplementalObj\" ui-codemirror-opts=\"nodeSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"nodeSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!nodeSupplemental.isSupplementalDetailChanging\" ng-click=\"nodeSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!nodeSupplemental.isSupplementalDetailChanging\" ng-click=\"nodeSupplemental.fnSaveNodeData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"nodeSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeSupplemental.parent.nodeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeSupplemental.parent.nodeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectSteps/projectEmailTemplate/nodeProjectEmail.html","<div class=\"h-100\" ng-controller=\"NodeProjectEmailCtrl as nodeProjectEmail\" ng-init=\"nodeProjectEmail.fnInitProjectEmail()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>Customize the email templates used by the system to send out notifications. Add your own branding and styles.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"nodeProjectEmail.fnGotoEmailTemplate()\">Edit Email Templates</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeProjectEmail.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeProjectEmail.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectSteps/projectS4/nodeProjectScripts.html","<div class=\"h-100\" ng-controller=\"NodeProjectScriptCtrl as nodeProjectScript\" ng-init=\"nodeProjectScript.fnInitProjectScript()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>S4 (Secure Server Side Scripting) is the latest ECSMon technology that allows you to adapt our tools for your business by describing your own logic.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"nodeProjectScript.fnGotoScripts()\">Edit S4 Scripts</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{nodeProjectScript.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(nodeProjectScript.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectSteps/projectSupplemental/nodeProjectSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"NodeProjectSupplementalCtrl as projectSupplemental\" ng-init=\"projectSupplemental.fnInitProjectSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!projectSupplemental.parent.isProjectDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"projectSupplemental.parent.isProjectDetailsLoaded\" ng-init=\"projectSupplemental.fnGetProjectData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"projectSupplemental.supplementalKVPArr.length || projectSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!projectSupplemental.isSupplementalDetailsEditable && projectSupplemental.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"projectSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"projectSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{projectSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!projectSupplemental.supplementalKVPArr.length && !projectSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"projectSupplemental.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"projectSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"projectSupplemental.supplementalKVPArr.length && !projectSupplemental.isAdvancedOption\" ng-class=\"!projectSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"projectSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in projectSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"projectSupplemental.isKeyDuplicated && $index === projectSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"projectSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"projectSupplemental.isKeyDuplicated && $index === projectSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"projectSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"projectSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"projectSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"projectSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"projectSupplemental.projectSupplementalObj\" ui-codemirror-opts=\"projectSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"projectSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!projectSupplemental.isSupplementalDetailChanging\" ng-click=\"projectSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!projectSupplemental.isSupplementalDetailChanging\" ng-click=\"projectSupplemental.fnSaveProjectData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"projectSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectSupplemental.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectSupplemental.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/project/projectInfo/projectSteps/projectTeam/projectTeam.html","<div id=\"teamsContent\" class=\"h-100\" ng-controller=\"NodeProjectTeamsCtrl as projectTeams\" ng-init=\"projectTeams.fnInitProjectTeams()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"projectTeams.isProjectTeamsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"projectTeams.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!projectTeams.isProjectTeamsLoading\"><div><div class=\"project-groups-info-table tableContainer p-t-10\"><table id=\"projectgroups-table\" class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"projectTeams.projectTeamsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"projectTeams.isAllTeamsChecked\" ng-click=\"projectTeams.fnCheckUncheckTeamsAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"projectTeams.projectTeamsArr.length\">Name</th><th ng-if=\"!projectTeams.projectTeamsArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"group in projectTeams.projectTeamsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"projectTeams.fnCheckUncheckTeamsHeader(group)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\"></label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\"></span></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/visualization/createVisualization/modal/addAttributes/addAttributes.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Add Attributes</strong></div><div class=\"modal-body\"><div class=\"row\" ng-init=\"addAttributes.fnInitModel()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div ng-if=\"!addAttributes.isObjectSelect\"><node-search-directive ng-if=\"addAttributes.permissionObj.List\" field-arr=\"addAttributes.searchFieldArr\" filter-query=\"addAttributes.filterQuery\" state-name=\"\'main.gateway\'\" fn-filter-query-change=\"addAttributes.fnFilterQueryChanged(filterQuery)\" is-called-for-view-visualizer=\"true\" fn-resize=\"addAttributes.fnSetTableHeight()\" no-set-url=\"true\"></node-search-directive><div ng-if=\"addAttributes.permissionObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"addAttributes.isGatewaysLoading\"></app-spinner><div class=\"gateways-table table-container\"><table id=\"gatewaysTable\" class=\"table table-striped table-check-box\" ng-show=\"!addAttributes.isGatewaysLoading\"><thead><tr><th ng-if=\"addAttributes.gatewaysArr.length\" class=\"p-8\"></th><th class=\"p-r-2\" ng-if=\"addAttributes.gatewaysArr.length\"></th><th ng-if=\"addAttributes.gatewaysArr.length\">Name</th><th ng-if=\"addAttributes.gatewaysArr.length\">Description</th><th class=\"text-center\" ng-if=\"addAttributes.gatewaysArr.length\">Phase</th><th class=\"text-center\" ng-if=\"addAttributes.gatewaysArr.length\">Connection</th><th ng-if=\"!addAttributes.gatewaysArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"gatewayObj in addAttributes.gatewaysArr track by $index\" ng-click=\"addAttributes.fnGetGateway(gatewayObj, addAttributes.gatewaysArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"gatewayObj.isCheck\" ng-change=\"addAttributes.fnCheckUncheckHeader(gatewayObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"addAttributes.fnGetHealthColor(gatewayObj.health, gatewayObj)\"><span class=\"healtSpan\">{{gatewayObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{gatewayObj.name}}</span></td><td><span class=\"ellipsis\">{{gatewayObj.description}}</span></td><td class=\"text-center\"><span uib-tooltip=\"{{gatewayObj.phase}}\" tooltip-placement=\"top\" class=\"phaseIconBorder\" ng-style=\"addAttributes.fnGetPhaseIconBorderColor(gatewayObj.phase)\"><span ng-class=\"addAttributes.fnGetPhaseIcon(gatewayObj.phase)\"></span></span></td><td class=\"text-center\"><span class=\"fa\" uib-tooltip=\"{{gatewayObj.connection}}\" tooltip-placement=\"top\" ng-style=\"addAttributes.fnGetConnectionIconColor(gatewayObj.connection)\" ng-class=\"addAttributes.fnGetConnectionIcon(gatewayObj.connection)\"></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!addAttributes.isGatewaysLoading && addAttributes.gatewaysArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{addAttributes.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"addAttributes.perPage = 10; addAttributes.fnPageChanged(addAttributes.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributes.perPage = 20; addAttributes.fnPageChanged(addAttributes.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributes.perPage = 50; addAttributes.fnPageChanged(addAttributes.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributes.perPage = 100; addAttributes.fnPageChanged(addAttributes.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributes.perPage = 500; addAttributes.fnPageChanged(addAttributes.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"addAttributes.isPrevVisible\" ng-click=\"addAttributes.fnGetNextPrevCollection(\'previous\', addAttributes.prevCollection, addAttributes.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"addAttributes.fnGetNextPrevCollection(\'next\', addAttributes.nextCollection, addAttributes.perPage)\" ng-if=\"addAttributes.nextCollection.length\"></button></div></div></div></div></div></div><div ng-if=\"!addAttributes.permissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div ng-if=\"addAttributes.isObjectSelect\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!addAttributes.isGatewayGhostDetailsLoaded\"></div><div class=\"col-sm-12 ghostLayoutContainer\" ng-if=\"addAttributes.isGatewayGhostDetailsLoaded\"><div class=\"m-t-15\"><span ng-click=\"addAttributes.fnGoBackToGateway()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Gateway</label></a></span></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-15\"><input required=\"\" class=\"md-form-control\" ng-model=\"addAttributes.search[addAttributes.filter]\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"table-container\" ng-if=\"!addAttributes.isGhostDetailsEditable\"><table class=\"table table-striped table-check-box\" ng-show=\"addAttributes.isGatewayGhostDetailsLoaded\"><thead><tr><th ng-if=\"addAttributes.gatewayReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost\" ng-model=\"addAttributes.isAllChecked\" ng-click=\"addAttributes.fnCheckUncheckAllGatewayGhost()\"> <label for=\"checkAllGhost\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"addAttributes.gatewayReportedArr.length\"></th><th ng-if=\"addAttributes.gatewayReportedArr.length\">Name</th><th ng-if=\"addAttributes.gatewayReportedArr.length\">Value</th><th ng-if=\"addAttributes.gatewayReportedArr.length\"></th><th ng-if=\"addAttributes.gatewayReportedArr.length\"></th><th ng-if=\"!addAttributes.gatewayReportedArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"gatewayGhostObj in addAttributes.gatewayReportedArr | filter: addAttributes.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}\" ng-model=\"gatewayGhostObj.isCheck\" ng-change=\"addAttributes.fnCheckUncheckHeaderGatewayGhost(gatewayGhostObj)\"> <label for=\"ghost_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{gatewayGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : gatewayGhostObj.bgColor, \'color\' : gatewayGhostObj.textColor}\"><span>{{gatewayGhostObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{gatewayGhostObj.name}}</span></td><td><span class=\"ellipsis\">{{gatewayGhostObj.value}}</span></td><td><span class=\"ellipsis\">{{gatewayGhostObj.humanDateLastUpdatedRelative}}</span></td><td class=\"text-right p-r-15\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"gatewayGhostObj.editable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label><i class=\"fa fa-ellipsis-v m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\">Edit</a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-if=\"!addAttributes.isObjectEmpty(addAttributes.selectedGatewayObj) && !addAttributes.isObjectSelect\" ng-click=\"addAttributes.fnSelectGateway(addAttributes.selectedGatewayObj)\">Select Gateway</button> <button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!addAttributes.selectedGhostGatewaysArr.length\" ng-click=\"addAttributes.fnCreateAttribute()\" ng-if=\"addAttributes.isObjectSelect\">Add Attributes</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-click=\"addAttributes.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/node/visualization/createVisualization/modal/addAttributesFromDevice/addAttributesFromDevice.html","<div class=\"inmodal h-100\"><div class=\"modal-header\"><strong class=\"inline-display p-t-8\">Add Attributes From Device</strong></div><div class=\"modal-body\"><div class=\"row\" ng-init=\"addAttributesFromDevice.fnInitModel()\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0\"><div class=\"content-box\"><div><div ng-if=\"!addAttributesFromDevice.isObjectSelect\"><node-search-directive ng-if=\"addAttributesFromDevice.devicePermissionObj.List\" field-arr=\"addAttributesFromDevice.searchFieldArr\" filter-query=\"addAttributesFromDevice.filterQuery\" state-name=\"\'main.device\'\" fn-filter-query-change=\"addAttributesFromDevice.fnFilterQueryChanged(filterQuery)\" is-called-for-view-visualizer=\"true\" fn-resize=\"addAttributesFromDevice.fnSetTableHeight()\"></node-search-directive><div class=\"row\" ng-if=\"addAttributesFromDevice.devicePermissionObj.List\"><div class=\"col-sm-12\"><app-spinner spinner-type=\"\'pageSpinnerWithText\'\" spinner-text=\"\'Loading...\'\" ng-show=\"addAttributesFromDevice.isDevicesLoading\"></app-spinner><div class=\"devicesAttribute-table table-container\"><table id=\"devicesAttributeTable\" class=\"table table-striped table-check-box\" ng-show=\"!addAttributesFromDevice.isDevicesLoading\"><thead><tr><th ng-if=\"addAttributesFromDevice.devicesArr.length\" class=\"p-8\"></th><th class=\"p-r-2\" ng-if=\"addAttributesFromDevice.devicesArr.length\"></th><th ng-if=\"addAttributesFromDevice.devicesArr.length\">Name</th><th ng-if=\"addAttributesFromDevice.devicesArr.length\">Description</th><th class=\"text-center\" ng-if=\"addAttributesFromDevice.devicesArr.length\"></th><th class=\"text-center\" ng-if=\"addAttributesFromDevice.devicesArr.length\"></th><th ng-if=\"!addAttributesFromDevice.devicesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"deviceObj in addAttributesFromDevice.devicesArr track by $index\" ng-click=\"addAttributesFromDevice.fnGetDevice(deviceObj, addAttributesFromDevice.devicesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chk_{{$index}}\" ng-model=\"deviceObj.isCheck\" ng-change=\"addAttributesFromDevice.fnCheckUncheckHeader(deviceObj)\"> <label for=\"chk_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceObj.healthName}}\" tooltip-placement=\"top\" ng-style=\"addAttributesFromDevice.fnGetHealthColor(deviceObj.health, deviceObj)\"><span class=\"healtSpan\">{{deviceObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{deviceObj.name}}</span></td><td><span class=\"ellipsis\">{{deviceObj.description}}</span></td><td class=\"text-center\"><span ng-class=\"deviceObj.connection === \'CONNECTED\' ?\'device-connected\':\'device-disconnected\'\" uib-tooltip=\"{{deviceObj.connection}}\" tooltip-placement=\"top\"></span></td><td class=\"text-center\"><span uib-tooltip=\"{{deviceObj.phase}}\" tooltip-placement=\"top\" class=\"deviceInfoPageIcon phaseIconBorder\" ng-style=\"addAttributesFromDevice.fnGetPhaseIconBorderColor(deviceObj.phase)\"><span ng-class=\"addAttributesFromDevice.fnGetPhaseIcon(deviceObj.phase)\"></span></span></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!addAttributesFromDevice.isDevicesLoading && addAttributesFromDevice.devicesArr.length\"><div class=\"row\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{addAttributesFromDevice.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"addAttributesFromDevice.perPage = 10; addAttributesFromDevice.fnPageChanged(addAttributesFromDevice.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributesFromDevice.perPage = 20; addAttributesFromDevice.fnPageChanged(addAttributesFromDevice.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributesFromDevice.perPage = 50; addAttributesFromDevice.fnPageChanged(addAttributesFromDevice.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributesFromDevice.perPage = 100; addAttributesFromDevice.fnPageChanged(addAttributesFromDevice.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"addAttributesFromDevice.perPage = 500; addAttributesFromDevice.fnPageChanged(addAttributesFromDevice.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Previous\'\" ng-if=\"addAttributesFromDevice.isPrevVisible\" ng-click=\"addAttributesFromDevice.fnGetNextPrevCollection(\'previous\', addAttributesFromDevice.prevCollection, addAttributesFromDevice.perPage)\"></button> <button type=\"button\" class=\"btn btn-primary btn-xs\" ng-bind=\"\'Next\'\" ng-click=\"addAttributesFromDevice.fnGetNextPrevCollection(\'next\', addAttributesFromDevice.nextCollection, addAttributesFromDevice.perPage)\" ng-if=\"addAttributesFromDevice.nextCollection.length\"></button></div></div></div></div></div></div><div class=\"row\" ng-if=\"!addAttributesFromDevice.devicePermissionObj.List\"><div class=\"col-sm-12\"><strong>No records found...</strong></div></div></div><div ng-if=\"addAttributesFromDevice.isObjectSelect\"><div ng-if=\"addAttributesFromDevice.isInventoryObjectSelect\"><div class=\"m-t-15\"><span ng-click=\"addAttributesFromDevice.fnGoBackToInventory()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Inventory</label></a></span></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-15\"><input required=\"\" class=\"md-form-control\" ng-model=\"addAttributesFromDevice.search[addAttributesFromDevice.filter]\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"col-sm-12 m-t-10\" ng-if=\"!addAttributesFromDevice.isComponentGhostDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div class=\"table-container\" ng-if=\"!addAttributesFromDevice.isGhostDetailsEditable\"><table class=\"table table-striped table-check-box\" ng-show=\"addAttributesFromDevice.isComponentGhostDetailsLoaded\"><thead><tr><th ng-if=\"addAttributesFromDevice.componentReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost\" ng-model=\"addAttributesFromDevice.isAllChecked\" ng-click=\"addAttributesFromDevice.fnCheckUncheckAllGhost()\"> <label for=\"checkAllGhost\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"addAttributesFromDevice.componentReportedArr.length\"></th><th ng-if=\"addAttributesFromDevice.componentReportedArr.length\">Name</th><th ng-if=\"addAttributesFromDevice.componentReportedArr.length\">Value</th><th ng-if=\"addAttributesFromDevice.componentReportedArr.length\"></th><th ng-if=\"addAttributesFromDevice.componentReportedArr.length\"></th><th ng-if=\"!addAttributesFromDevice.componentReportedArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"componentGhostObj in addAttributesFromDevice.componentReportedArr | filter: addAttributesFromDevice.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}\" ng-model=\"componentGhostObj.isCheck\" ng-change=\"addAttributesFromDevice.fnCheckUncheckGhostHeader(componentGhostObj)\"> <label for=\"ghost_{{$index}}\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{componentGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : componentGhostObj.bgColor, \'color\' : componentGhostObj.textColor}\"><span>{{componentGhostObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{componentGhostObj.name}}</span></td><td><span class=\"ellipsis\">{{componentGhostObj.value}}</span></td><td><span class=\"ellipsis\">{{componentGhostObj.humanDateLastUpdatedRelative}}</span></td><td class=\"text-right p-r-15\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"componentGhostObj.editable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label><i class=\"fa fa-ellipsis-v m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"addAttributesFromDevice.fnEditGhostValue(componentGhostObj)\"><a class=\"btn btn-link\">Edit</a></li></ul></div></td></tr></tbody></table></div></div><div ng-if=\"!addAttributesFromDevice.isInventoryObjectSelect\"><div class=\"m-t-15\"><span ng-click=\"addAttributesFromDevice.fnGoBackToDevice()\"><a class=\"link-primary\"><i class=\"fa fa-arrow-circle-left m-r-2\"></i><label>Back to Device</label></a></span></div><div class=\"m-t-20\" ng-if=\"addAttributesFromDevice.isInventoryVisible && !addAttributesFromDevice.isGhostVisible\"><search-directive field-arr=\"addAttributesFromDevice.inventorieSearchFieldArr\" filter-query=\"addAttributesFromDevice.inventorieFilterQuery\" state-name=\"\'main.device\'\" no-set-url=\"true\" fn-filter-query-change=\"addAttributesFromDevice.fnInventoriesFilterQueryChanged(filterQuery)\" fn-resize=\"addAttributesFromDevice.fnSetTableHeight()\"></search-directive><div class=\"col-sm-12 m-t-10\" ng-if=\"!addAttributesFromDevice.isDeviceInventoryDetailsLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"addAttributesFromDevice.isDeviceInventoryDetailsLoaded\"><div class=\"col-sm-12\"><div class=\"devicesInventory-table\"><table class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"addAttributesFromDevice.inventoriesArr.length\" class=\"p-8\"></th><th class=\"p-r-2\" ng-if=\"addAttributesFromDevice.inventoriesArr.length\"></th><th ng-if=\"addAttributesFromDevice.inventoriesArr.length\">Index</th><th ng-if=\"!addAttributesFromDevice.inventoriesArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"inventoryObj in addAttributesFromDevice.inventoriesArr track by $index\" ng-click=\"addAttributesFromDevice.fnGetInventory(inventoryObj)\" ng-class=\"inventoryObj.enabled === false ? \'disableTr\' : \'\'\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"inventory_{{$index}}\" ng-model=\"inventoryObj.isCheck\" ng-change=\"addAttributesFromDevice.fnCheckUncheckInventoriesHeader(inventoryObj)\" ng-if=\"inventoryObj.enabled===true\"> <label for=\"inventory_{{$index}}\" class=\"check-box\" ng-if=\"inventoryObj.enabled===true\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" ng-if=\"inventoryObj.enabled === true\" uib-tooltip=\"{{inventoryObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : inventoryObj.bgColor, \'color\' : inventoryObj.textColor}\"><span>{{inventoryObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{inventoryObj.index}}</span></td></tr></tbody></table></div></div></div></div><div ng-if=\"!addAttributesFromDevice.isInventoryVisible && addAttributesFromDevice.isGhostVisible\"><div class=\"m-t-5 p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!addAttributesFromDevice.isDeviceGhostDetailsLoaded\"></div><div class=\"col-sm-12 layoutContainer\" ng-if=\"addAttributesFromDevice.isDeviceGhostDetailsLoaded\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-15\"><input required=\"\" class=\"md-form-control\" ng-model=\"addAttributesFromDevice.search[addAttributesFromDevice.filter]\" type=\"text\"> <span class=\"highlight\"></span> <span class=\"bar\"></span> <label>Search</label></div></div><div class=\"table-container\" ng-if=\"!addAttributesFromDevice.isGhostDetailsEditable\"><table class=\"table table-striped table-check-box\" ng-show=\"addAttributesFromDevice.isDeviceGhostDetailsLoaded\"><thead><tr><th ng-if=\"addAttributesFromDevice.deviceReportedArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGhost1\" ng-model=\"addAttributesFromDevice.isAllChecked\" ng-click=\"addAttributesFromDevice.fnCheckUncheckAllDeviceGhost()\"> <label for=\"checkAllGhost1\" class=\"check-box\"></label></th><th class=\"p-r-2\" ng-if=\"addAttributesFromDevice.deviceReportedArr.length\"></th><th ng-if=\"addAttributesFromDevice.deviceReportedArr.length\">Name</th><th ng-if=\"addAttributesFromDevice.deviceReportedArr.length\">Value</th><th ng-if=\"addAttributesFromDevice.deviceReportedArr.length\">Set</th><th ng-if=\"addAttributesFromDevice.deviceReportedArr.length\"></th><th ng-if=\"!addAttributesFromDevice.deviceReportedArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"deviceGhostObj in addAttributesFromDevice.deviceReportedArr | filter: addAttributesFromDevice.search track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"ghost_{{$index}}1\" ng-model=\"deviceGhostObj.isCheck\" ng-change=\"addAttributesFromDevice.fnCheckUncheckDeviceGhostHeader(deviceGhostObj)\"> <label for=\"ghost_{{$index}}1\" class=\"check-box\"></label></td><td class=\"p-r-2\"><button class=\"btn btn-xs btn-default ellipsis-label\" uib-tooltip=\"{{deviceGhostObj.toolTipName}}\" tooltip-placement=\"top\" ng-style=\"{\'background-color\' : deviceGhostObj.bgColor, \'color\' : deviceGhostObj.textColor}\"><span>{{deviceGhostObj.healthName}}</span></button></td><td><span class=\"ellipsis\">{{deviceGhostObj.name}}</span></td><td><span class=\"ellipsis\">{{deviceGhostObj.value}}</span></td><td><span class=\"ellipsis\">requested {{deviceGhostObj.humanDateLastUpdatedRelative}}</span></td><td class=\"text-right p-r-15\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"deviceGhostObj.editable\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label><i class=\"fa fa-ellipsis-v m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\">Edit</a></li></ul></div></td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-if=\"!addAttributesFromDevice.isObjectEmpty(addAttributesFromDevice.selectedDeviceObj) && !addAttributesFromDevice.isObjectSelect\" ng-click=\"addAttributesFromDevice.fnSelectDevice(addAttributesFromDevice.selectedDeviceObj)\">Select Device</button> <button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-click=\"addAttributesFromDevice.fnSelectInventory()\" ng-if=\"!addAttributesFromDevice.isObjectEmpty(addAttributesFromDevice.selectedInventoryObj) && addAttributesFromDevice.isObjectSelect && addAttributesFromDevice.isInventoryVisible && !addAttributesFromDevice.isGhostVisible && !addAttributesFromDevice.isInventoryObjectSelect\">Select Component</button> <button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!addAttributesFromDevice.selectedGhostComponentsArr.length\" ng-click=\"addAttributesFromDevice.fnCreateAttribute(addAttributesFromDevice.selectedGhostComponentsArr)\" ng-if=\"addAttributesFromDevice.isObjectSelect && addAttributesFromDevice.isInventoryVisible && !addAttributesFromDevice.isGhostVisible && addAttributesFromDevice.isInventoryObjectSelect\">Add Attributes</button> <button type=\"button\" class=\"btn btn-primary pull-right m-l-5 m-t-2\" ng-disabled=\"!addAttributesFromDevice.selectedGhostDevicesArr.length\" ng-click=\"addAttributesFromDevice.fnCreateAttribute(addAttributesFromDevice.selectedGhostDevicesArr)\" ng-if=\"addAttributesFromDevice.isObjectSelect && !addAttributesFromDevice.isInventoryVisible && addAttributesFromDevice.isGhostVisible\">Add Attributes</button> <button type=\"button\" class=\"btn btn-primary pull-right m-t-2\" ng-click=\"addAttributesFromDevice.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/pipeline/listeners/listenerInfo/listenerTabs/listenerWorkflow/listenerWorkflow.html","<div id=\"listenerWorkflowsContent\" class=\"h-100\" ng-controller=\"ListenerWorkflowCtrl as listenerWorkflows\" ng-init=\"listenerWorkflows.fnInitListenerWorkflows()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"listenerWorkflows.isListenerWorkflowsLoading\"><table-loader hide-circle=\"true\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!listenerWorkflows.isListenerWorkflowsLoading\"><div id=\"tableContainer\" ng-if=\"!listenerWorkflows.isShowAddWorkflow\"><table class=\"table table-striped table-check-box\" ng-if=\"listenerWorkflows.listenerWorkflowsArr.length\"><thead><tr><th ng-if=\"listenerWorkflows.listenerWorkflowsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"listenerWorkflows.isAllListenerWorkflowsChecked\" ng-click=\"listenerWorkflows.fnCheckUncheckListenerWorkflowsAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"listenerWorkflows.listenerWorkflowsArr.length\">Name</th><th ng-if=\"listenerWorkflows.listenerWorkflowsArr.length\"></th><th ng-if=\"!listenerWorkflows.listenerWorkflowsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"workflow in listenerWorkflows.listenerWorkflowsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"workflow.isCheck\" ng-change=\"listenerWorkflows.fnCheckUnchecklistenerWorkflowsHeader(workflow)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"workflow.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"workflow.description\">Desc</span></div></td><td class=\"text-right\"><button class=\"btn btn-link\" ui-sref=\"main.workFlowsView({id : workflow.id})\">View Workflow</button></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!listenerWorkflows.listenerWorkflowsArr.length\"><button class=\"btn btn-primary\" ng-if=\"listenerPermissionsObj.AddWorkflow\" ng-click=\"listenerWorkflows.fnHideShowAddWorkflows()\">Add Workflow</button></div></div><div id=\"addWorkflowContainer\" ng-if=\"listenerWorkflows.isShowAddWorkflow\"><div class=\"p-t-15 p-b-15\"><label>Add Workflow</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"listenerWorkflows.fnHideShowAddWorkflows()\"><i class=\"fa fa-times\"></i></button></div><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"listenerWorkflows.isGettingWorkflows\"></div><div ng-if=\"!listenerWorkflows.isGettingWorkflows\"><div class=\"content-box-content table-content-box p-0\"><search-directive field-arr=\"listenerWorkflows.searchFieldArr\" filter-query=\"listenerWorkflows.filterQuery\" state-name=\"\'main.workflows\'\" fn-filter-query-change=\"listenerWorkflows.fnFilterQueryChanged(filterQuery)\" no-set-url=\"true\" fn-resize=\"listenerWorkflows.fnSetTableHeight()\"></search-directive><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"listenerWorkflows.isWorkflowsLoading\" hide-circle=\"true\" fn-resize=\"listenerWorkflows.fnSetLoaderTableHeight()\"></table-loader><div class=\"listeners-table table-container\"><table id=\"listeners-secondaryTable\" class=\"table table-striped table-check-box\" ng-if=\"!listenerWorkflows.isWorkflowsLoading\"><thead><tr><th ng-if=\"listenerWorkflows.workflowsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllWorkflow\" ng-model=\"listenerWorkflows.isAllChecked\" ng-click=\"listenerWorkflows.fnCheckUncheckAll()\"> <label for=\"checkAllWorkflow\" class=\"check-box\"></label></th><th ng-if=\"listenerWorkflows.workflowsArr.length\">Name</th><th ng-if=\"!listenerWorkflows.workflowsArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"workflow in listenerWorkflows.workflowsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkWorkflow_{{$index}}\" ng-model=\"workflow.isCheck\" ng-change=\"listenerWorkflows.fnCheckUncheckHeader(workflow)\"> <label for=\"chkWorkflow_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"workflow.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"workflow.description\">Desc</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!listenerWorkflows.isWorkflowsLoading && listenerWorkflows.workflowsArr.length\"><div class=\"row m-b-15\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{listenerWorkflows.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"listenerWorkflows.perPage = 10; listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage, listenerWorkflows.perPage)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"listenerWorkflows.perPage = 20; listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage, listenerWorkflows.perPage)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"listenerWorkflows.perPage = 50; listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage, listenerWorkflows.perPage)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"listenerWorkflows.perPage = 100; listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage,listenerWorkflows.perPage)\">100</a></li><li><a class=\"btn btn-link\" ng-click=\"listenerWorkflows.perPage = 500; listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage, listenerWorkflows.perPage)\">500</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"listenerWorkflows.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"listenerWorkflows.currentPage\" items-per-page=\"listenerWorkflows.perPage\" max-size=\"listenerWorkflows.maxSize\" boundary-links=\"true\" ng-click=\"listenerWorkflows.fnPageChanged(listenerWorkflows.currentPage, listenerWorkflows.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-15\" ng-if=\"!listenerWorkflows.isWorkflowAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"listenerWorkflows.fnAddWorkflow()\">Add</button></div><div class=\"col-sm-12 m-t-15\" ng-if=\"listenerWorkflows.isWorkflowAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-xs-6 content-box-footerItem\"><label>ID: {{listenerObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(listenerObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-xs-6 content-box-footerItem\"><div class=\"dropdown dropup pull-right\" uib-dropdown=\"\" ng-if=\"((listenerPermissionsObj.AddWorkflow && !listenerWorkflows.isShowAddWorkflow) || (listenerWorkflows.selectedListenerWorkflowsArr.length && listenerPermissionsObj.RemoveWorkflow)) && !listenerWorkflows.isListenerWorkflowsLoading\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Action<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-right\" uib-dropdown-menu=\"\"><li ng-click=\"listenerWorkflows.fnHideShowAddWorkflows()\" ng-if=\"listenerPermissionsObj.AddWorkflow && !listenerWorkflows.isShowAddWorkflow\"><a class=\"btn btn-link\">Add Workflow</a></li><li ng-if=\"listenerWorkflows.selectedListenerWorkflowsArr.length && listenerPermissionsObj.RemoveWorkflow\" ng-click=\"listenerWorkflows.fnDeleteListenerWorkflows(listenerWorkflows.selectedListenerWorkflowsArr)\"><a class=\"btn btn-link\">Remove Workflow</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/addNewInputModal/addNewInputModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"loadModal.fnInitLoadModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Add New Input</h4></div><div class=\"modal-body p-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"newInputModal.selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in newInputModal.tabs\" ng-if=\"tab.visible === true\" select=\"newInputModal.fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-show=\"newInputModal.selectedTab === 1 && tab.tabIndex === 1\"><div class=\"col-sm-12 p-0 m-b-15 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"inputObj as inputObj.index for inputObj in newInputModal.customInputIndexArr | filter:$viewValue\" typeahead-min-length=\"0\" placeholder=\"Select base path*\" ng-model=\"newInputModal.selectedInputObj\"> <span class=\"highlight\"></span> <label>SELECT BASE PATH*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"newInputModal.name\" placeholder=\"Name for the input*\"> <span class=\"highlight\"></span> <label>INPUT NAME*</label></div></div></div></div></div><div class=\"tabContent\" ng-show=\"newInputModal.selectedTab === 2 && tab.tabIndex === 2\"><div class=\"col-sm-12 p-0 m-b-15 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" typeahead-editable=\"false\" uib-typeahead=\"inputObj as inputObj.index for inputObj in newInputModal.customInputIndexArr | filter:$viewValue\" typeahead-min-length=\"0\" placeholder=\"Select base path*\" ng-model=\"newInputModal.selectedInputObj\"> <span class=\"highlight\"></span> <label>SELECT BASE PATH*</label></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"newInputModal.name\" placeholder=\"Name for the input*\"> <span class=\"highlight\"></span> <label>INPUT NAME*</label></div></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary pull-left\" ng-click=\"newInputModal.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-disabled=\"!newInputModal.name.length || newInputModal.fnCheckObjectLength(newInputModal.selectedInputObj)\" ng-click=\"newInputModal.fnSaveStateInput()\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/arrayInputModal/arrayInputModal.html","<div class=\"inmodal theme_modal\" ng-init=\"arrayInput.fnInitArrayInputModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Array Values</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"row\"><div class=\"col-sm-12\"><ui-codemirror ng-change=\"arrayInput.fnCheckInput()\" ng-model=\"arrayInput.txtSpec\" ui-codemirror-opts=\"arrayInput.editorOptions\"></ui-codemirror></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"arrayInput.fnCancel()\" tabindex=\"12\">Close</button> <button type=\"button\" ng-disabled=\"!arrayInput.isInputBadlyFormatted\" class=\"btn btn-primary p-l-10\" ng-click=\"arrayInput.fnSave()\" tabindex=\"12\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/errorFlowOptionsModal/errorFlowOptionsModal.html","<div class=\"inmodal h-100 theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Add Error Flow</h4></div><div class=\"modal-body errorFlowModal errorFlowOptionModal\"><div class=\"row\"><div class=\"col-sm-12 p-r-5 p-l-5\"><div class=\"col-sm-12 m-t-5 m-b-20\">If your {{errorFlowOption.stateName}} experiences an error during execution the primary workflow will stop running and the workflow will end. In such an event you can help your workflow fail gracefully by optionally starting an error flow.</div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0\" id=\"\"><div class=\"col-sm-6 newErrorFlowCss\" ng-if=\"errorFlowOption.tabsArr.length === 1\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-7 m-b-7 text-center\"><button class=\"btn btn-link p-0\" ng-click=\"errorFlowOption.fnAddNewErrorFlow()\">New Error Flow</button></h3></div></div></div><div class=\"col-sm-6\" ng-repeat=\"obj in errorFlowOption.tabsArr track by $index\" ng-if=\"obj.tabIndex !== 1\"><div class=\"panel panel-default\" ng-style=\"{\'border-color\': errorFlowOption.errorFlowStyle.panel[\'border-color\'],\'border\': errorFlowOption.errorFlowStyle.panel.border}\"><div class=\"panel-heading h-100\" ng-style=\"{\'background-color\': errorFlowOption.errorFlowStyle[\'panel-heading\'][\'background-color\'],\'border-color\': errorFlowOption.errorFlowStyle[\'panel-heading\'][\'border-color\']}\"><div class=\"col-sm-12 p-0\"><div class=\"col-sm-10 p-0\"><h3 class=\"m-t-9 ellipsis\" ng-style=\"errorFlowOption.errorFlowStyle.stateText\">{{obj.title}}</h3></div><div class=\"col-sm-2 p-0\"><div class=\"btn-group pull-right\"><button type=\"button\" ng-style=\"errorFlowOption.errorFlowStyle.button\" class=\"btn btn-primary pull-right\" ng-click=\"errorFlowOption.fnInjectErrorFlow(obj)\">Select</button></div></div></div></div></div></div><div class=\"col-sm-6 newErrorFlowCss\" ng-if=\"errorFlowOption.tabsArr.length > 1\"><div class=\"panel panel-default\"><div class=\"panel-heading h-100\"><h3 class=\"m-t-7 m-b-7 text-center\"><button class=\"btn btn-link p-0\" ng-click=\"errorFlowOption.fnAddNewErrorFlow()\">New Error Flow</button></h3></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><button class=\"btn btn-link pull-left\" ng-if=\"errorFlowOption.isAddExistingErrorFlow\" ng-click=\"errorFlowOption.isAddExistingErrorFlow = false\">Back</button> <button type=\"button\" class=\"btn btn-primary pull-right m-r-5\" ng-click=\"errorFlowOption.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/existingWorkflowFlowModal/existingWorkflowFlowModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"existingWorkflowFlow.fnInitWorkflowFlowModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Workflow Flow</h4></div><div class=\"modal-body p-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0\" id=\"newWorkflowUI\"><div class=\"col-sm-12 p-0 triggerSelectBox\"><div class=\"col-sm-12 p-l-20 p-r-20 stateBoxLayout\" ng-if=\"existingWorkflowFlow.flowObj.length !== 0\"><div class=\"tf-tree p-l-20 p-r-20 stateBoxLayout\"><ul><li class=\"text-center\" ng-repeat=\"workflowHierarchyObj in existingWorkflowFlow.flowObj track by $index\" workflow-flow=\"\" is-workflow-create-mode=\"false\" c-id=\"existingWorkflowFlow.cId\" is-called-from-add-branch=\"existingWorkflowFlow.isCalledFromAddBranch\" workflow-hierarchy-obj=\"workflowHierarchyObj\" fn-inject-existing-state=\"existingWorkflowFlow.fnInjectState(workflowHierarchyObj)\"></li></ul></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-link\" ng-click=\"existingWorkflowFlow.fnCancel()\">Cancel</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/inputInfoModal/inputInfoModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">{{inputInfoModal.fnSetFiledLabel(inputInfoModal.fnIndexName(inputInfoModal.inputObj.index).replace(\'*\',\'\')).toUpperCase()}} <code class=\"pull-right\">{{\"(\"+inputInfoModal.inputObj.type+\")\"}}</code></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 text-center\"><h4>{{inputInfoModal.inputObj.description}}</h4></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"inputInfoModal.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/inputTypeInfo/inputTypeInfo.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Information</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 p-0 text-left\"><h4>By switching the switch to static, you can add any string/Json/data to the inputs.<br>If you switch to dynamic then you can add dynamic mappings to the rest of the states for the inputs by selecting a value from the drop down</h4></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"InputTypeInfo.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/loadModal/loadModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"loadModal.fnInitLoadModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\"><div class=\"pull-left\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!loadModal.isStateInfoLoaded\"></div><div state-template=\"\" state-object=\"loadModal.stateObj\" ng-if=\"loadModal.isStateInfoLoaded\" data-state=\"{{loadModal.stateObj}}\" width-auto=\"true\"></div></h4></div><div class=\"modal-body p-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"loadModal.selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in loadModal.tabs\" ng-if=\"tab.visible === true\" select=\"loadModal.fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-show=\"loadModal.selectedTab === 1 && tab.tabIndex === 1\"><div class=\"col-sm-12 p-0 m-t-20\" ng-show=\"loadModal.isStructureCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-show=\"!loadModal.isShowJsonMapView && !loadModal.isStructureCreating\"><div class=\"col-sm-12 p-0 m-b-15 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputFieldObj in loadModal.stateInputFieldArr track by $index\"><div class=\"col-sm-11 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"inputFieldObj.type !== \'array\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 customStateInputs\"><input class=\"md-form-control p-r-35\" required=\"\" type=\"text\" typeahead-editable=\"true\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-20\':\'p-t-10\'\" ng-change=\"inputFieldObj.displayPath = \'\';inputFieldObj.value = \'\';inputFieldObj.isValidInput=false\" uib-typeahead=\"inputObj.keyIndex as inputObj.keyIndex for inputObj in loadModal.savedLoadInputsArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-focus=\"inputFieldObj.displayPath === \'Custom\'?loadModal.fnKvpPairChangeInject(inputFieldObj, $index):\'\'\" typeahead-on-select=\"loadModal.fnLoadValueSelected(inputFieldObj,$index)\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && loadModal.fnLoadInputOnBlur(inputFieldObj,$index)\" ng-model=\"inputFieldObj.displayValue\" placeholder=\"{{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \'yes\' ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"inputErrorIcon\" ng-if=\"!inputFieldObj.isValidInput\"><span ng-if=\"inputFieldObj.type === \'boolean\'\" uib-tooltip=\"The value of {{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}} should be a boolean value. Please either dynamically pass in or statically assign a value of true or false.\" tooltip-placement=\"left\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span> <span ng-if=\"inputFieldObj.type === \'number\' || inputFieldObj.type ===\'integer\'\" uib-tooltip=\"The value of {{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}} should be a boolean value. Please either dynamically pass in or statically assign a numerical value.\" tooltip-placement=\"left\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span> <span ng-if=\"inputFieldObj.type === \'string\'\" uib-tooltip=\"You have set the value of {{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}} to be an entire object when it expects a string. This will result in a serialized JSON representation of the object. This is not usually the desired effect and you may wish to pass in a individual value.\" tooltip-placement=\"left\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span></span> <span class=\"inputInfoIcon\" ng-if=\"inputFieldObj.description !==\'\'\"><a href=\"javascript:void(0);\" class=\"btn btn-link p-l-0 m-r-10\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-8\':\'p-t-3\'\" ng-click=\"loadModal.fnOpenInputInfo(inputFieldObj)\"><span><i class=\"f-23 fa fa-question-circle-o\"></i></span></a></span> <span class=\"loadModalDisplayPath\" ng-if=\"inputFieldObj.displayPath && inputFieldObj.displayPath !==\'\'\">{{inputFieldObj.displayPath === \"Custom\"?\'Static value\':loadModal.fnIndexName(inputFieldObj.displayPath).replace(\'*\',\'\')}}</span></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"inputFieldObj.type === \'array\'\"><div class=\"md-input\" ng-class=\"inputFieldObj.inputGroups.length === 1?\'m-b-10\':\'m-b-0\'\"><input class=\"md-form-control p-t-20 pace\" required=\"\" type=\"text\" value=\"Click to add new {{inputFieldObj.index.includes(\'.\') ? inputFieldObj.index.split(\'.\')[inputFieldObj.index.split(\'.\').length - 1] : inputFieldObj.index}} entry\"> <span class=\"highlight\"></span> <span class=\"inputInfoIcon\"><a href=\"javascript:void(0);\" class=\"btn btn-link p-t-10\" ng-click=\"loadModal.fnOpenArrayInputModal(inputFieldObj)\"><span><i uib-tooltip=\"Add Custom Array\" tooltip-placement=\"left\" class=\"fa fa-2x fa-archive\"></i></span></a></span> <label>{{loadModal.fnSetFiledLabel(loadModal.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"loadModalDisplayPath\">Array</span></div><div class=\"col-sm-12 p-0 m-l-25 workflowLoadModalTreeView createArrayNestedUI\"><div class=\"col-sm-12 p-0\"><ul class=\"tree\"><li ng-repeat=\"inputGroup in inputFieldObj.inputGroups track by $index\"><span style=\"display: inline-block;width: 90%\"><div class=\"md-input m-b-20 customStateInputs\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-20\':\'p-t-10\'\" typeahead-editable=\"true\" ng-change=\"inputGroup.displayPath = \'\';inputGroup.value = \'\';inputFieldObj.isValidInput=false\" uib-typeahead=\"inputObj.keyIndex as inputObj.keyIndex for inputObj in loadModal.savedLoadInputsArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-focus=\"inputGroup.displayPath === \'Custom\'?loadModal.fnKvpPairChangeInject(inputGroup, $index):\'\'\" typeahead-on-select=\"loadModal.fnLoadValueSelected(inputGroup,$index)\" ng-model=\"inputGroup.displayValue\" ng-keydown=\"($event.keyCode === 13 || $event.keyCode === 9) && loadModal.fnLoadInputOnBlur(inputGroup,$index)\" placeholder=\"{{loadModal.fnSetFiledLabel(inputGroup.displayName.replace(\'*\',\'\')).toUpperCase()}}{{inputGroup.required && inputGroup.required === \'yes\' ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{loadModal.ordinal_suffix_of($index+1)+\" \"+loadModal.fnSetFiledLabel(inputGroup.displayName.substring(0, inputGroup.displayName.length - 1).replace(\'*\',\'\')).toUpperCase()}}{{inputGroup.required && inputGroup.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"inputErrorIcon\" ng-if=\"!inputGroup.isValidInput\"><span ng-if=\"inputGroup.type === \'boolean\'\" uib-tooltip=\"The value of {{loadModal.ordinal_suffix_of($index+1)+\' \'+loadModal.fnSetFiledLabel(inputGroup.displayName.substring(0, inputGroup.displayName.length - 1).replace(\'*\',\'\')).toUpperCase()}} should be a boolean value. Please either dynamically pass in or statically assign a value of true or false.\" tooltip-placement=\"left\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span> <span ng-if=\"inputGroup.type === \'number\' || inputGroup.type ===\'integer\'\" uib-tooltip=\"The value of {{loadModal.ordinal_suffix_of($index+1)+\' \'+loadModal.fnSetFiledLabel(inputGroup.displayName.substring(0, inputGroup.displayName.length - 1).replace(\'*\',\'\')).toUpperCase()}} should be a boolean value. Please either dynamically pass in or statically assign a numerical value.\" tooltip-placement=\"left\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span> <span ng-if=\"inputGroup.type === \'string\'\" uib-tooltip=\"You have set the value of {{loadModal.ordinal_suffix_of($index+1)+\' \'+loadModal.fnSetFiledLabel(inputGroup.displayName.substring(0, inputGroup.displayName.length - 1).replace(\'*\',\'\')).toUpperCase()}} to be an entire object when it expects a string. This will result in a serialized JSON representation of the object. This is not usually the desired effect and you may wish to pass in a individual value.\" tooltip-placement=\"left\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-8\':\'p-t-3\'\"><i class=\"f-23 fa fa-exclamation-circle\"></i></span></span> <span class=\"inputInfoIcon\" ng-if=\"inputGroup.description !==\'\'\"><a href=\"javascript:void(0);\" class=\"btn btn-link m-r-10\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-8\':\'p-t-3\'\" ng-click=\"loadModal.fnOpenInputInfo(inputGroup)\"><span><i class=\"f-23 fa fa-question-circle-o\"></i></span></a></span> <span class=\"loadModalDisplayPath\" ng-if=\"inputGroup.displayPath && inputGroup.displayPath !==\'\'\">{{inputGroup.displayPath === \"Custom\"?\'Static value\':loadModal.fnIndexName(inputGroup.displayPath).replace(\'*\',\'\')}}</span></div></span> <span style=\"display: inline-block;width: 5%\"><a class=\"btn btn-link p-0 m-l-16 m-t-0\" ng-class=\"inputGroup.value && inputGroup.value !== \'\' ?\'arrayInputRemove\':\'\'\" ng-if=\"inputGroup.required && inputGroup.required !== \'yes\'\" ng-click=\"loadModal.fnRemoveArrayEntry(inputFieldObj,inputFieldObj.inputGroups,$index,$parent.$parent.$index)\"><i class=\"fa fa-times m-r-5\"></i></a></span></li></ul></div></div></div></div><div class=\"col-sm-1 p-0 text-right\"><div class=\"col-sm-12 p-0\"><a class=\"btn btn-link p-0 m-l-16\" ng-class=\"inputFieldObj.type === \'array\' ?\'m-t-15\':inputFieldObj.value && inputFieldObj.value !==\'\'?\'m-t-15\':\'m-t-10\'\" ng-if=\"inputFieldObj.required && inputFieldObj.required !== \'yes\' && inputFieldObj.type !== \'array\'\" ng-click=\"loadModal.fnRemoveInputField(inputFieldObj,$index)\"><i class=\"fa fa-times m-r-5\"></i></a> <a class=\"btn btn-link p-0 m-l-16 m-t-15\" ng-if=\"inputFieldObj.type === \'array\'\" ng-click=\"loadModal.fnAddNewEntry(inputFieldObj)\"><i class=\"fa fa-plus m-r-5\"></i></a></div></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"loadModalDivider\"></div></div><div class=\"col-sm-12 p-0 m-t-15 floatingLabelInput\" ng-if=\"loadModal.isDisplayMappingInputs\"><div class=\"col-sm-11 p-0\"><div class=\"md-input m-t-15 m-b-40 roleActions\"><input class=\"md-form-control\" required=\"\" type=\"text\" id=\"mappingInput\" typeahead-editable=\"true\" uib-typeahead=\"inputObj as inputObj.displayName for inputObj in loadModal.selectedStateInputsArr | filter:$viewValue\" typeahead-min-length=\"0\" typeahead-template-url=\"inputTemplate.html\" typeahead-should-select=\"false\" ng-keydown=\"($event.keyCode === 13 ) && loadModal.fnCreateNewStateInputObj(loadModal.selectedInputObj,\'mappingInput\')\" placeholder=\"Select Input\" ng-model=\"loadModal.selectedInputObj\"> <span class=\"highlight\"></span> <label>ADD NEW MAPPING</label></div></div><div class=\"col-sm-1 p-0 text-right\"><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary m-l-16 m-t-20\" ng-disabled=\"loadModal.isObjectEmpty(loadModal.selectedInputObj)\" ng-click=\"loadModal.fnAddNewInput(loadModal.selectedInputObj)\">Add</button></div></div></div></div><div class=\"col-sm-12\" ng-show=\"loadModal.isShowJsonMapView\"><div class=\"pull-right\"><button class=\"btn btn-link\" ng-class=\"loadModal.kvpPair.isJsonIndex ? \'\' : \'linkDeactive\'\" ng-click=\"loadModal.fnConvertFlattToObject(loadModal.kvpPair)\">Json</button> <button class=\"btn btn-link\" ng-class=\"!loadModal.kvpPair.isJsonIndex ? \'\' : \'linkDeactive\'\" ng-click=\"loadModal.fnConvertObjectToFlatt(loadModal.kvpPair)\">Map</button></div><div class=\"wizard\"><ng-code-mirror ng-if=\"loadModal.kvpPair.isJsonIndex\" inject-model=\"loadModal.kvpPair\" index-num=\"$index\" is-config-saved=\"loadModal.isConfigurationsSaved\" fn-change-model=\"\"></ng-code-mirror><textarea style=\"height: 150px\" ng-if=\"!loadModal.kvpPair.isJsonIndex\" ng-change=\"loadModal.isConfigurationsSaved = false\" ng-model=\"loadModal.kvpPair.injectMap\">map</textarea></div><div class=\"pull-right\"><button class=\"btn btn-link p-l-0 p-r-0\" ng-click=\"loadModal.fnChangeInputStateType()\">Change to dynamic input</button></div></div></div><div class=\"tabContent\" ng-show=\"loadModal.selectedTab === 2 && tab.tabIndex === 2\"><div class=\"col-sm-12 p-0 m-t-60 stashForm\"><div class=\"col-sm-6 stashDecorativeDiv targetTreeView\" ng-style=\"{\'border-color\': loadModal.stateObj ? loadModal.stateObj.color : \'\'}\"><div class=\"col-sm-12 p-l-0 p-t-30 workflowLoadModalTreeView\"><ul class=\"tree\"><li ng-repeat=\"node in loadModal.nestedOutputArr\" ng-include=\"\'nodes_renderer2.html\'\"></li></ul><script type=\"text/ng-template\" id=\"nodes_renderer2.html\">{{node.index.includes(\'.\')?node.index.split(\'.\')[node.index.split(\'.\').length-1]:node.index}} <div ng-if=\"node.isClickAble\" class=\"treeItem\" style=\"float: right\"></div> <ul> <li ng-repeat=\"node in node.children\" ng-include=\"\'nodes_renderer2.html\'\"> </li> </ul></script></div></div><div class=\"col-sm-6 p-0\"><div class=\"stashFormName\"><form novalidate=\"\" name=\"stashForm\"><div class=\"col-sm-12 p-l-0\"><div class=\"col-sm-2 m-t-13\"><img src=\"../assets/images/svg/Database_clip_art.svg\" style=\"height: 20px;width: 20px\"></div><div class=\"col-sm-10 floatingLabelInput\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"stashName\" type=\"text\" name=\"stashName\" ng-pattern=\"/^[a-zA-Z\\d-]{1,50}$/\" ng-change=\"loadModal.isConfigurationsSaved = false;\" ng-model=\"loadModal.stashValue\" placeholder=\"Name for the new stashName\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text stashFormError\" ng-if=\"stashForm.stashName.$error.pattern\">Stash Name may contain a-z, A-Z, 0-9 and the - (hyphen) characters only. It can only be 50 characters long. Stash name will not be saved.</small></div><div ng-if=\"!stashForm.stashName.$error.pattern\"><div ng-repeat=\"stashName in loadModal.savedStashNameArr\"><span class=\"saveStashInfo\">{{stashName}}</span></div></div></div></div></form></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><script type=\"text/ng-template\" id=\"inputTemplate.html\"><a ng-if=\"match.model.isDisplay\"> <span class=\"m-r-5\" ng-bind-html=\"match.model.displayName\"></span> </a></script><div class=\"modal-footer\"><div ng-if=\"!loadModal.isShowJsonMapView\" class=\"dropdown dropup pull-left m-t-7\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>Advanced<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li ng-click=\"loadModal.fnCreateNewStateInput()\"><a class=\"btn btn-link\">Add new custom input field</a></li></ul></div><button ng-if=\"loadModal.isShowJsonMapView\" type=\"button\" class=\"btn btn-link\" ng-click=\"loadModal.fnCancelJsonMapView()\">Cancel</button> <button ng-if=\"loadModal.isShowJsonMapView\" type=\"button\" class=\"btn btn-primary\" ng-click=\"loadModal.fnInjectJsonMapView()\" tabindex=\"12\">Inject</button> <button ng-if=\"!loadModal.isShowJsonMapView\" type=\"button\" class=\"btn btn-link\" ng-click=\"loadModal.fnCancel()\" tabindex=\"12\">Close</button> <button ng-if=\"!loadModal.isShowJsonMapView\" type=\"button\" class=\"btn btn-primary\" ng-disabled=\"stashForm.stashName.$error.pattern || loadModal.isStructureCreating\" ng-click=\"loadModal.fnSaveLoad()\" tabindex=\"12\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/createWorkFlow/modals/stateRenameModal/stateRenameModal.html","<div class=\"inmodal theme_modal\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\" ng-bind=\"\'State Name\'\"></h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"col-sm-12 floatingLabelInput\"><form novalidate=\"\" name=\"draftForm\"><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"workflowName\" type=\"text\" name=\"stateName\" ng-model=\"stateRename.stateName\" placeholder=\"Draft name*\"> <span class=\"highlight\"></span> <label>Name*</label></div></form></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"stateRename.fnCancel()\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!stateRename.stateName.length\" ng-click=\"stateRename.fnSave()\">Save</button></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowTabs/worflowFlowView/workflowFlowView.html","<div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-8 h-100 p-l-0\"><div class=\"content-box\"><div class=\"content-box-content p-0\" ng-class=\"!flowView.isWorkflowLoaded || flowView.isListenerModelsLoading ? \'pace\' : \'\'\" style=\"overflow: scroll;\"><div id=\"canvas\" draw2d-canvas=\"\" ng-model=\"flowView.flowJson\"></div></div><div class=\"content-box-footer\"><div class=\"col-sm-6\"><div class=\"m-t-2 pull-left\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!flowView.isWorkflowLoaded || flowView.isListenerModelsLoading\"></div><label class=\"m-l-5 m-t-8\" ng-if=\"!flowView.isWorkflowLoaded || flowView.isListenerModelsLoading\">Loading Workflow</label></div><div class=\"col-sm-6\" ng-if=\"!flowView.isCloneCompleted\"><div class=\"m-t-2 pull-right\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-6\" ng-if=\"flowView.isCloneCompleted\"><div class=\"pull-right\"><button class=\"btn btn-link pull-right\" ng-click=\"flowView.fnCloneWorkFlow(flowView.workflowObj)\" ng-if=\"flowView.isWorkflowLoaded && !flowView.isListenerModelsLoading && flowView.workflowPermissionObj.Create\">Clone Workflow</button></div></div></div></div></div><div class=\"col-sm-4 h-100 p-0\"><div class=\"content-box\"><div class=\"content-container\"><div class=\"container-with-footer\"><div class=\"content-head modal-header\"><h3 class=\"modal-title inline-display p-t-3\" ng-bind=\"flowView.isStateSelectedOnCanvas ? \'State Details\' : \'Name of the Workflow\'\"></h3><button type=\"button\" class=\"btn btn-link pull-right p-0\" ng-if=\"flowView.isStateSelectedOnCanvas\" ng-click=\"flowView.isStateSelectedOnCanvas = false; flowView.selectedStateObj = {};\"><i class=\"fa fa-times\"></i></button></div><div class=\"content-body floatingLabelInput\" ng-if=\"!flowView.isStateSelectedOnCanvas\"><div class=\"col-sm-12 p-t-10\"><h4 class=\"m-b-20\">Workflow Basic Information</h4><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"workFlowName\" type=\"text\" ng-model=\"flowView.workflowObj.name\" placeholder=\"Name for the new WorkFlow\"> <span class=\"highlight\"></span> <label>Name</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"workFlowDescription\" type=\"text\" ng-model=\"flowView.workflowObj.description\" placeholder=\"Description regarding WorkFlow\"> <span class=\"highlight\"></span> <label>Description</label></div><h4 class=\"m-t-20 m-b-20\">Logging Options</h4><div class=\"m-t-20 m-b-20 pace\"><span class=\"m-r-5 middle-display\">Enabled:</span> <input type=\"checkbox\" id=\"checkEnabled\" ng-model=\"flowView.workflowObj.logging.enabled\"> <label for=\"checkEnabled\" class=\"check-box middle-display\"></label></div></div></div><div class=\"content-body\" ng-if=\"flowView.isStateSelectedOnCanvas\"><div class=\"col-sm-12 p-t-15\" ng-if=\"!flowView.isStateMdInfoLoaded\"><app-spinner spinner-type=\"\'pageSpinner\'\"></app-spinner></div><div class=\"col-sm-12 p-t-15 floatingLabelInput\" ng-if=\"flowView.isStateMdInfoLoaded\"><div class=\"md-input m-t-15 m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateName\" type=\"text\" ng-model=\"flowView.selectedStateObj.name\"> <span class=\"highlight\"></span> <label>Name</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateType\" type=\"text\" ng-model=\"flowView.selectedStateObj.type\"> <span class=\"highlight\"></span> <label>Type</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control pace\" required=\"\" id=\"stateId\" type=\"text\" ng-model=\"flowView.selectedStateObj.id\"> <span class=\"highlight\"></span> <label>Id</label></div><label>Information</label><div class=\"col-sm-12 p-0 preview-only info-preview\" id=\"workflowTriggersTreeView\" ng-if=\"!flowView.isRefreshMdEditor\"><textarea name=\"issueEditor\" class=\"content-box\" ng-model=\"flowView.selectedStateObj.mdInfo\" markdown-editor=\"flowView.markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div><div class=\"col-sm-12 content-footer\"><div class=\"row\"><div class=\"col-sm-6 p-l-0\"></div><div class=\"col-sm-6 p-r-0\"><button class=\"btn btn-link pull-right\" ui-sref=\"main.workflows\" ng-if=\"!flowView.isStateSelectedOnCanvas\">Back to Workflows</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/predictive/account/directives/accountInfo/accountSteps/details.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitDetailTab()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isAccountDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isAccountDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>About</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isAccountDetailsLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isDetailsEditable\" ng-click=\"fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"fnDeleteAccount(accountObj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-if=\"accountObj.supportAccess\"><a ng-click=\"fnCreateSupportSession(accountObj);\">Start support session</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isAccountDetailsLoaded\" ng-class=\"!isDetailsEditable ? \'pace\' : \'\'\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" id=\"name\" type=\"text\" ng-model=\"accountObj.name\" placeholder=\"Name for the Account*\"> <span class=\"highlight\"></span> <label>Name*</label></div><div class=\"md-input m-b-20\"><input class=\"md-form-control\" required=\"\" id=\"description\" type=\"text\" ng-model=\"accountObj.description\" placeholder=\"Description regarding Account\"> <span class=\"highlight\"></span> <label>Description</label></div><button ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15\" ng-click=\"fnResetDetails()\">Cancel</button> <button ng-disabled=\"!accountObj.name.length\" ng-if=\"isDetailsEditable && isUpdateCompleted\" class=\"btn btn-primary pull-right\" ng-click=\"fnUpdateAccountDetails(accountObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{accountObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(accountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/tracker/archived/archivedInfo/archivedSteps/archivedForm/archivedForm.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"ArchivedFormCtrl as archivedForm\" ng-init=\"archivedForm.fnInitIssueForm()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!archivedForm.isIssueDetailsLoaded\"></div><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\" ng-if=\"archivedForm.isIssueDetailsLoaded\"><div class=\"col-sm-12 p-0 p-l-10 p-t-10 h-100\" ng-if=\"!archivedForm.form.length\"><label>Form not defined</label></div><div class=\"col-sm-12 p-t-20\" ng-if=\"archivedForm.form.length\"><div class=\"col-sm-12 p-0 d-flex pace\"><form id=\"customForm\" role=\"form\" name=\"customForm\" novalidate=\"\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"d-flex flex-column\" sf-schema=\"archivedForm.schema\" sf-form=\"archivedForm.form\" sf-model=\"archivedForm.model\"></div></form></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{archivedForm.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(archivedForm.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/archived/archivedInfo/archivedSteps/archivedHistory/archivedHistory.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"ArchivedHistoryCtrl as issueHistory\" ng-init=\"issueHistory.fnInitIssueHistory()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issueHistory.isIssueHistoryDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"issueHistory.isIssueHistoryDetailsLoaded\"><div ng-if=\"!issueHistory.issueHistorysArr.length\" class=\"m-t-15\"><label class=\"m-0\"><strong>No records found...</strong></label></div><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 m-t-20\" ng-if=\"issueHistory.issueHistorysArr.length\"><div ng-class=\"$index === issueHistory.issueHistorysArr.length - 1 ? \'message-first\' : \'message-item\'\" ng-repeat=\"issueHistoryObj in issueHistory.issueHistorysArr track by $index\"><div class=\"message-inner\"><div class=\"message-head clearfix\"><div class=\"user-detail\"><div class=\"pull-left\"><h5 class=\"handle text-left\">{{issueHistoryObj.name.replace(\'_\', \' \')}}</h5><div class=\"post-meta\"><div class=\"asker-meta m-t-5\" style=\"text-align: left\"><span class=\"qa-message-what\"></span> <span class=\"qa-message-when\"><span class=\"qa-message-when-data\"><small>{{issueHistoryObj.eventType}}<br>{{\"#\"+issueHistoryObj.id}}</small></span></span></div></div></div><div class=\"pull-right\"><div class=\"post-meta\"><div class=\"asker-meta\"><label class=\"m-b-0 pull-right\"><small>Completed {{issueHistoryObj.eventEpoch}}</small></label><br><span class=\"text-right\">{{issueHistoryObj.privateStream ? \'private comment\': \'public comment\'}}</span></div></div></div></div></div><div class=\"qa-message-content\"><span class=\"parentSpan\"><span class=\"hide-toolbar\"><textarea class=\"content-box\" ng-model=\"issueHistoryObj.description\" markdown-editor=\"issueHistory.markedOptionObj\" rows=\"10\">\n                                    </textarea></span></span></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueHistory.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueHistory.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/archived/archivedInfo/archivedSteps/archivedPrivate/archivedPrivate.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"ArchivedPrivateCtrl as issuePrivate\" ng-init=\"issuePrivate.fnInitIssuePrivate()\"><div class=\"p-20 height-inherit\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issuePrivate.isIssueDetailsLoaded\"></div><div class=\"col-sm-12 newCommentUI d-flex p-0 height-inherit\" ng-if=\"issuePrivate.isIssueDetailsLoaded\"><div class=\"p-r-0 p-t-10 issueSideAnimation\" ng-class=\"issuePrivate.isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class p-l-15\'\"><div class=\"col-sm-12 p-0\" ng-if=\"issuePrivate.selectedCommentView === \'Horizontal\'\"><div class=\"col-sm-12 d-flex p-0 comment-timeline\"><div class=\"dashed-border w100 main-comment-line-position\"></div><div class=\"d-flex w100 justify-content-space-between\" style=\"overflow-y: hidden\"><div class=\"d-flex w100 position-r p-r-10\" ng-class=\"issuePrivate.isShowIssueSummary ? \'commentArrowIcon\':\'\'\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowIssueSummary()\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"issuePrivate.isShowIssueSummary ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/main-comment.svg#mainComment\"></use></svg></span></div><div ng-repeat=\"comment in issuePrivate.issueObj.privateComments track by $index\" class=\"d-flex position-r\" ng-class=\"{ \'width-auto bg-color m-l-10 p-r-1\': $last, \'w100 p-l-10 p-r-10\': !$last, \'commentArrowIcon\': comment.id === issuePrivate.selectedComment.id }\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowComment(comment, \'mainComment\')\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"comment.id === issuePrivate.selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span><div ng-if=\"comment.subComments && comment.subComments.length\" class=\"aaa d-flex w100\" style=\"position: relative;\"><div class=\"dashed-border sub-comment-line-position\"></div><div class=\"d-flex w100 m-l-10 m-r-10\" ng-class=\"comment.subComments.length > 1 ?\'justify-content-space-between\':\'justify-content-flex-end\'\"><div ng-repeat=\"subComment in comment.subComments track by $index\" class=\"d-flex p-t-25 position-r\" ng-class=\"{ \'commentArrowIcon\': subComment.id === issuePrivate.selectedComment.id, \'width-30px\': !$last }\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowComment(subComment, \'subComment\')\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"subComment.id === issuePrivate.selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"comment\"><div class=\"comment-header p-l-10 p-r-10\"><div class=\"col-sm-12 p-0 d-flex h-100\"><div class=\"col-sm-7 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issuePrivate.selectedComment.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issuePrivate.selectedComment.userAvatar}}\"> {{issuePrivate.selectedComment.createdBy ? issuePrivate.selectedComment.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{issuePrivate.selectedComment.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issuePrivate.selectedComment.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-5 pull-right text-right p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex m-r-20\" ng-if=\"issuePrivate.isShowIssueSummary\" ng-class=\"issuePrivate.selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issuePrivate.selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"d-flex m-r-20\" ng-if=\"!issuePrivate.isShowIssueSummary\" ng-class=\"issuePrivate.selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issuePrivate.selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5 pace opacity-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><span class=\"m-r-10 p-r-5 pull-right\"><span uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(issuePrivate.selectedComment.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(issuePrivate.selectedComment.createdAt)}}</span></span></div></div></div><div class=\"comment-body p-0 m-t-1 overflow-auto\"><div class=\"position-r hide-toolbar\" ng-if=\"issuePrivate.selectedComment.mdBody\" style=\"height: inherit;\" ng-class=\"!issuePrivate.selectedComment.isEditMode ? \'preview-only\' : \'\'\"><textarea name=\"editor{{issuePrivate.selectedComment.id}}\" class=\"content-box\" ng-model=\"issuePrivate.selectedComment.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                            </textarea></div></div></div></div></div><div class=\"col-sm-12 p-0 vertical-comment-view overflow-auto\" ng-if=\"issuePrivate.selectedCommentView === \'Vertical\'\"><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 m-t-0 p-l-0 p-r-5\"><div ng-class=\"!issuePrivate.issueObj.privateComments.length ? \'message-first m-b-0\' : \'message-item\'\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issuePrivate.issueSummary.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issuePrivate.issueSummary.userAvatar}}\"> {{issuePrivate.issueSummary.createdBy ? issuePrivate.issueSummary.createdBy : \"ECSMon\"}} - <span tooltip-append-to-body=\"true\" uib-tooltip=\"{{issuePrivate.issueSummary.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issuePrivate.issueSummary.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10 pace opacity-5\"><label class=\"m-0 m-r-10\">{{issuePrivate.issueSummary.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(issuePrivate.issueSummary.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(issuePrivate.issueSummary.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{issuePrivate.issueSummary.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!issuePrivate.issueSummary.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{issuePrivate.issueSummary.id}}\" ng-model=\"issuePrivate.issueSummary.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div></div><div ng-class=\"$index === issuePrivate.issueObj.privateComments.length - 1 ? \'message-first m-b-0\' : \'message-item\'\" ng-repeat=\"commentObj in issuePrivate.issueObj.privateComments track by $index\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"commentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{commentObj.userAvatar}}\"> {{commentObj.createdBy ? commentObj.createdBy : \"ECSMon\"}} - <span uib-tooltip=\"{{commentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{commentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10 pace opacity-5\"><label class=\"m-0 m-r-10\">{{commentObj.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(commentObj.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(commentObj.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{commentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!commentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{commentObj.id}}\" ng-model=\"commentObj.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" rows=\"10\">\n                                    </textarea></div></div></div><div class=\"p-t-20 p-b-0 p-l-20 sub-comment-container position-r\" ng-if=\"(commentObj.subComments && commentObj.subComments.length) || commentObj.isShowSubCommentEditor\"><div ng-repeat=\"subCommentObj in commentObj.subComments track by $index\" ng-class=\"{\'message-first m-b-0\': $index === commentObj.subComments.length - 1 && !commentObj.isShowSubCommentEditor , \'message-item\': $index !== commentObj.subComments.length - 1 || commentObj.isShowSubCommentEditor}\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"subCommentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{subCommentObj.userAvatar}}\"> {{subCommentObj.createdBy ? subCommentObj.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{subCommentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{subCommentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\"><label class=\"m-0 m-r-10\"></label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(subCommentObj.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(subCommentObj.createdAt)}}</span></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{subCommentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!subCommentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{subCommentObj.id}}\" ng-model=\"subCommentObj.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" rows=\"10\">\n                                            </textarea></div></div></div></div></div></div></div></div></div><div class=\"p-r-0 issueSideAnimation\" ng-class=\"issuePrivate.isExpanded ? \'col-sm-3\': \'custom-class-sidebar p-l-15\'\"><archived-side-bar issue-obj=\"issueObj\" class=\"h-100\" is-expanded=\"issuePrivate.isExpanded\"></archived-side-bar></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issuePrivate.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issuePrivate.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/details.html","<div id=\"projectsContent\" class=\"content-main\" ng-init=\"fnInitIssue()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isIssueDetailsLoaded\"></div><div class=\"col-sm-12 newCommentUI d-flex p-0 height-inherit\" ng-if=\"isIssueDetailsLoaded\"><div class=\"p-r-0 p-t-10 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class p-l-15\'\"><div class=\"col-sm-12 p-0\" ng-if=\"selectedCommentView === \'Horizontal\'\"><div class=\"col-sm-12 d-flex p-0 comment-timeline\"><div class=\"dashed-border w100 main-comment-line-position\"></div><div class=\"d-flex w100 justify-content-space-between\" style=\"overflow-y: hidden\"><div class=\"d-flex w100 position-r p-r-10\" ng-class=\"isShowIssueSummary ? \'commentArrowIcon\':\'\'\" style=\"z-index: 1;\"><span ng-click=\"fnShowIssueSummary()\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"isShowIssueSummary ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/main-comment.svg#mainComment\"></use></svg></span></div><div ng-repeat=\"comment in issueObj.publicComments track by $index\" class=\"d-flex position-r\" ng-class=\"{ \'width-auto bg-color m-l-10 p-r-1\': $last, \'w100 p-l-10 p-r-10\': !$last, \'commentArrowIcon\': comment.id === selectedComment.id }\" style=\"z-index: 1;\"><span ng-click=\"fnShowComment(comment, \'mainComment\', {})\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"comment.id === selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span><div ng-if=\"comment.subComments && comment.subComments.length\" class=\"aaa d-flex w100\" style=\"position: relative;\"><div class=\"dashed-border sub-comment-line-position\"></div><div class=\"d-flex w100 m-l-10 m-r-10\" ng-class=\"comment.subComments.length > 1 ?\'justify-content-space-between\':\'justify-content-flex-end\'\"><div ng-repeat=\"subComment in comment.subComments track by $index\" class=\"d-flex p-t-25 position-r\" ng-class=\"{ \'commentArrowIcon\': subComment.id === selectedComment.id, \'width-30px\': !$last }\" style=\"z-index: 1;\"><span ng-click=\"fnShowComment(subComment, \'subComment\', comment)\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"subComment.id === selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"comment\"><div class=\"comment-header p-l-10 p-r-10\"><div class=\"col-sm-12 p-0 d-flex h-100\"><div class=\"col-sm-7 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"selectedComment.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{selectedComment.userAvatar}}\"> {{selectedComment.createdBy ? selectedComment.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{selectedComment.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{selectedComment.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-5 pull-right text-right p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex m-r-20\" ng-if=\"isShowIssueSummary\" ng-class=\"selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(true, selectedComment)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(false, selectedComment)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"d-flex m-r-20\" ng-if=\"!isShowIssueSummary\" ng-class=\"selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToComment(true, selectedComment)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" ng-class=\"issueObj.resolved ? \'pace opacity-5\' : \'\'\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToComment(false, selectedComment)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><span class=\"m-r-10 p-r-5 pull-right\"><span uib-tooltip=\"{{fnGetRelativeTime(selectedComment.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(selectedComment.createdAt)}}</span></span><div class=\"dropdown no-hover customDropdown-icon m-r-5 pull-right\" ng-if=\"!issueObj.resolved\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15\" uib-dropdown-menu=\"\"><li ng-if=\"!selectedComment.isEditMode && userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"fnEditIssueComment(issueObj, selectedComment, \'editor\')\">Edit</a></li><li ng-if=\"!isShowIssueSummary && (selectedComment && (!selectedComment.subComments || (selectedComment.subComments && selectedComment.subComments.length === 0))) && userPermissionsObj.REMOVE_COMMENT && !selectedComment.mainCommentId\"><a class=\"btn btn-link\" ng-if=\"userPermissionsObj.REMOVE_COMMENT\" ng-click=\"fnDeleteIssueComment(issueObj, selectedComment)\">Delete</a></li></ul></div></div></div></div><div class=\"comment-body p-0 m-t-1 overflow-auto\"><div class=\"position-r hide-toolbar\" ng-if=\"selectedComment.isShowComment\" style=\"height: inherit;\" ng-class=\"!selectedComment.isEditMode ? \'preview-only\' : \'\'\"><textarea name=\"editor{{selectedComment.id}}\" class=\"content-box\" ng-drop-dir-for-issue=\"\" comment-obj=\"selectedComment\" upload-file=\"uploadFiles(type, filedata, commentObj)\" ng-model=\"selectedComment.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                                </textarea></div></div><div class=\"comment-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"selectedComment.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"selectedComment.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"fnHideShowEditorPreview(\'editor\'+selectedComment.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!selectedComment.fileUploading\" ng-click=\"fnCancelCommentEditing(selectedComment)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"selectedComment\" upload-file=\"uploadFiles(type, filedata, commentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!selectedComment.fileUploading && selectedComment.isEditMode && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!selectedComment.fileUploading && selectedComment.isEditMode && !isShowIssueSummary\" ng-click=\"fnUpdateComment(issueObj, selectedComment)\">Save</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!selectedComment.fileUploading && selectedComment.isEditMode && isShowIssueSummary\" ng-click=\"fnUpdateIssueSummary(issueObj, selectedComment)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"selectedComment.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 vertical-comment-view overflow-auto\" ng-if=\"selectedCommentView === \'Vertical\'\"><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 m-t-0 p-l-0 p-r-5\"><div ng-class=\"!issueObj.publicComments.length ? \'message-first m-b-0\' : \'message-item\'\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!issueSummary.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issueSummary.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issueSummary.userAvatar}}\"> {{issueSummary.createdBy ? issueSummary.createdBy : \"ECSMon\"}} - <span tooltip-append-to-body=\"true\" uib-tooltip=\"{{issueSummary.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issueSummary.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\" ng-class=\"issueSummary.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issueSummary.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(true, issueSummary)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(false, issueSummary)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(issueSummary.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(issueSummary.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"!issueSummary.isEditMode && userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"fnEditIssueComment(issueObj, issueSummary, \'editor\')\">Edit</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{issueSummary.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!issueSummary.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{issueSummary.id}}\" ng-model=\"issueSummary.mdBody\" markdown-editor=\"markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"issueSummary\" upload-file=\"uploadFiles(type, filedata, issueSummary)\" rows=\"10\">\n                                    </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"issueSummary.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"issueSummary.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"fnHideShowEditorPreview(\'editor\'+issueSummary.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!issueSummary.fileUploading\" ng-click=\"fnCancelVerticalCommentEditing(issueSummary, true)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalSummary1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"issueSummary\" upload-file=\"uploadFiles(type, filedata, issueSummary)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalSummary1\').click()\" ng-if=\"!issueSummary.fileUploading && issueSummary.isEditMode && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!issueSummary.fileUploading && issueSummary.isEditMode\" ng-click=\"fnUpdateIssueSummary(issueObj, issueSummary)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"issueSummary.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><div ng-class=\"$index === issueObj.publicComments.length - 1 ? \'message-first m-b-0\' : \'message-item\'\" ng-repeat=\"commentObj in issueObj.publicComments track by commentObj.id\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!commentObj.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"commentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{commentObj.userAvatar}}\"> {{commentObj.createdBy ? commentObj.createdBy : \"ECSMon\"}} - <span uib-tooltip=\"{{commentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{commentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\" ng-class=\"commentObj.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{commentObj.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToComment(true, commentObj)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToComment(false, commentObj)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(commentObj.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(commentObj.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"!commentObj.isEditMode && userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"fnEditIssueComment(issueObj, commentObj, \'editor\')\">Edit</a></li><li ng-if=\"userPermissionsObj.REMOVE_COMMENT\"><a class=\"btn btn-link\" ng-if=\"userPermissionsObj.REMOVE_COMMENT && (commentObj && (!commentObj.subComments || (commentObj.subComments && commentObj.subComments.length === 0)))\" ng-click=\"fnDeleteIssueComment(issueObj, commentObj)\">Delete</a></li><li ng-if=\"userPermissionsObj.ADD_SUB_COMMENT\"><a class=\"btn btn-link\" ng-click=\"fnAddNewSubComment(issueObj, commentObj)\">Add sub Comment</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{commentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!commentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{commentObj.id}}\" ng-model=\"commentObj.mdBody\" markdown-editor=\"markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"commentObj\" upload-file=\"uploadFiles(type, filedata, commentObj)\" rows=\"10\">\n                                    </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"commentObj.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"commentObj.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"fnHideShowEditorPreview(\'editor\'+commentObj.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!commentObj.fileUploading\" ng-click=\"fnCancelVerticalCommentEditing(commentObj, false)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalComment1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"commentObj\" upload-file=\"uploadFiles(type, filedata, commentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalComment1\').click()\" ng-if=\"!commentObj.fileUploading && commentObj.isEditMode && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!commentObj.fileUploading && commentObj.isEditMode\" ng-click=\"fnUpdateComment(issueObj, commentObj)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"commentObj.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div><div class=\"p-t-20 p-b-0 p-l-20 sub-comment-container position-r\" ng-if=\"(commentObj.subComments && commentObj.subComments.length) || commentObj.isShowSubCommentEditor\"><div ng-repeat=\"subCommentObj in commentObj.subComments track by subCommentObj.id\" ng-class=\"{\'message-first m-b-0\': $index === commentObj.subComments.length - 1 && !commentObj.isShowSubCommentEditor , \'message-item\': $index !== commentObj.subComments.length - 1 || commentObj.isShowSubCommentEditor}\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!subCommentObj.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"subCommentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{subCommentObj.userAvatar}}\"> {{subCommentObj.createdBy ? subCommentObj.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{subCommentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{subCommentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\"><label class=\"m-0 m-r-10\"></label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(true, subCommentObj)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"fnAddUpDownVoteToIssue(false, subCommentObj)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{fnGetRelativeTime(subCommentObj.createdAt)}}\" tooltip-placement=\"left\">{{fnGetRelativeTime(subCommentObj.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"fnEditIssueComment(issueObj, subCommentObj, \'editor\')\">Edit</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{subCommentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!subCommentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{subCommentObj.id}}\" ng-model=\"subCommentObj.mdBody\" markdown-editor=\"markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"subCommentObj\" upload-file=\"uploadFiles(type, filedata, subCommentObj)\" rows=\"10\">\n                                            </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"subCommentObj.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"subCommentObj.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"fnHideShowEditorPreview(\'editor\'+subCommentObj.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!subCommentObj.fileUploading\" ng-click=\"fnCancelVerticalCommentEditing(subCommentObj, false)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalSubComment1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"subCommentObj\" upload-file=\"uploadFiles(type, filedata, subCommentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalSubComment1\').click()\" ng-if=\"!subCommentObj.fileUploading && subCommentObj.isEditMode && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!subCommentObj.fileUploading && subCommentObj.isEditMode\" ng-click=\"fnUpdateComment(issueObj, subCommentObj)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"subCommentObj.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><div class=\"message-first m-b-0 new-sub-comment-editor\" ng-if=\"commentObj.isShowSubCommentEditor\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5 img-circle\" ng-src=\"{{loginUserAvatar}}\"> {{loginUser.email}}</label></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"newSubComment\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\"><textarea class=\"content-box\" name=\"newSubCommentEditor\" ng-model=\"newSubComment.text\" markdown-editor=\"newCommentMarkedOptionObj\" ng-drop-dir-for-issue=\"\" upload-file=\"uploadFiles(type, filedata, null, newSubComment)\" rows=\"10\">\n                                            </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><button class=\"btn btn-primary m-r-10\" ng-click=\"fnHideShowEditorPreview(\'newSubCommentEditor\')\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!newSubComment.fileUploading\" ng-click=\"fnCancelVerticalNewSubComment(commentObj)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalNewSubComment1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"uploadFiles(type, filedata, null, newSubComment)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalNewSubComment1\').click()\" ng-if=\"!newSubComment.fileUploading && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!newSubComment.fileUploading && userPermissionsObj.ADD_SUB_COMMENT\" ng-disabled=\"!newSubComment.text.length\" ng-click=\"fnAddSubCommentToComment(commentObj, newSubComment, false)\">Add sub Comment</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"newSubComment.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15 m-b-15 d-flex newComment flex-column new-comment-block\" ng-if=\"!issueObj.resolved\"><div class=\"col-sm-12 p-0 newCommentBody hide-toolbar\"><div><textarea name=\"newCommentEditor\" class=\"content-box newCommentTextBox\" ng-drop-dir-for-issue=\"\" upload-file=\"uploadFiles(type, filedata)\" id=\"newCommentBlock\" ng-focus=\"fnClickNewComment()\" ng-blur=\"fnClickNewComment(true)\" ng-keydown=\"fnKeyDownComment()\" ng-model=\"newCommentObj.text\" placeholder=\"Type your message...\" markdown-editor=\"newCommentMarkedOptionObj\" rows=\"10\">\n                        </textarea></div></div><div class=\"col-sm-12 p-0 newCommentFooter d-flex\"><div class=\"col-sm-4 p-0 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex height-100\"><button class=\"btn btn-primary m-2 m-l-0\" ng-click=\"fnHideShowEditorPreview(\'newCommentEditor\')\"><span class=\"fa fa-eye\"></span> Preview</button></div></div><div class=\"col-sm-8 p-0 d-flex align-items-flex-end justify-content-flex-end\"><div class=\"pull-right m-5 m-r-10\" ng-if=\"newCommentObj.fileUploading\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-8 p-0 d-flex align-items-center\" ng-if=\"!newCommentObj.fileUploading\"><div class=\"col-sm-12 p-0 text-right d-flex justify-content-flex-end\"><input type=\"file\" id=\"markDownFile\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" ng-if=\"userPermissionsObj.GET_FILE_UPLOAD_LINK\" onclick=\"document.getElementById(\'markDownFile\').click()\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button><div class=\"d-flex\"><div class=\"customDropdown\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button id=\"split-button\" type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary orange-btn border-right-0 p-r-4\" ng-class=\"!newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" ng-if=\"userPermissionsObj.ADD_COMMENT && userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnAddCommentToIssue(issueObj, newCommentObj, \'CommentResolve\')\">Comment & resolve</button> <button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary orange-btn border-left-0 p-l-4\" ng-class=\"!newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;color: orange !important;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"userPermissionsObj.ADD_COMMENT && userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnAddCommentToIssue(issueObj, newCommentObj, \'CommentResolveRequest\')\" ng-class=\"!newCommentObj.text.length ? \'pace opacity-5\' : \'\'\"><a><span>Comment & send request</span></a></li></ul></div></div><div class=\"customDropdown m-l-2\" ng-if=\"issueObj.publicComments && issueObj.publicComments.length\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary btnPrimary border-right-0 p-r-4\" ng-class=\"{ \'pace opacity-5\': !newCommentObj.text.length, \'p-r-20\': !userPermissionsObj.ADD_SUB_COMMENT}\" ng-if=\"userPermissionsObj.ADD_COMMENT\" ng-click=\"fnAddCommentToIssue(issueObj, newCommentObj, false)\">Comment</button> <button type=\"button\" ng-if=\"userPermissionsObj.ADD_SUB_COMMENT\" class=\"col-sm-12 btn btn-sm btn-primary btnPrimary border-left-0 m-l-0 p-l-4\" ng-class=\"!newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"userPermissionsObj.ADD_SUB_COMMENT\" ng-click=\"fnAddSubCommentToComment(issueObj.publicComments[issueObj.publicComments.length - 1], newCommentObj, false)\" ng-class=\"!newCommentObj.text.length ? \'pace opacity-5\' : \'\'\"><a><span>Add Sub Comment</span></a></li></ul></div></div><button class=\"btn btn-primary m-l-2\" ng-if=\"userPermissionsObj.ADD_COMMENT && (!issueObj.publicComments || issueObj.publicComments.length === 0)\" ng-click=\"fnAddCommentToIssue(issueObj, newCommentObj, false)\" ng-disabled=\"!newCommentObj.text.length\">Comment</button></div></div></div></div></div></div><div class=\"p-r-0 issueSideAnimation\" ng-class=\"isExpanded ? \'col-sm-3\': \'custom-class-sidebar p-l-15\'\"><issue-assignee-label-side-bar issue-obj=\"issueObj\" class=\"h-100\" user-permissions-obj=\"userPermissionsObj\" is-expanded=\"isExpanded\"></issue-assignee-label-side-bar></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><div ng-if=\"isFullWidthDevice\"><button class=\"btn btn-link\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button></div><div class=\"d-flex align-items-center justify-content-flex-end\" ng-if=\"!isFullWidthDevice\"><button class=\"btn btn-link m-r-5\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button><div ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating && !isFullWidthDevice\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/tracker/label/labelInfo/labelSteps/labelSupplemental/labelSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"LabelSupplementalCtrl as labelSupplemental\" ng-init=\"labelSupplemental.fnInitLabelSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!labelSupplemental.parent.isLabelDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"labelSupplemental.parent.isLabelDetailsLoaded\" ng-init=\"labelSupplemental.fnGetLabelData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"labelSupplemental.supplementalKVPArr.length || labelSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!labelSupplemental.isSupplementalDetailsEditable && labelSupplemental.parent.userPermissionsObj.REPLACE_LABEL_TAGS\" ng-click=\"labelSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"labelSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{labelSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!labelSupplemental.supplementalKVPArr.length && !labelSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"labelSupplemental.parent.userPermissionsObj.REPLACE_LABEL_TAGS\" ng-click=\"labelSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"labelSupplemental.supplementalKVPArr.length && !labelSupplemental.isAdvancedOption\" ng-class=\"!labelSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"labelSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in labelSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"labelSupplemental.isKeyDuplicated && $index === labelSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"labelSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"labelSupplemental.isKeyDuplicated && $index === labelSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"labelSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"labelSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"labelSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"labelSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"labelSupplemental.labelSupplementalObj\" ui-codemirror-opts=\"labelSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"labelSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!labelSupplemental.isSupplementalDetailChanging\" ng-click=\"labelSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!labelSupplemental.isSupplementalDetailChanging\" ng-click=\"labelSupplemental.fnSaveLabelData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"labelSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{labelSupplemental.parent.labelObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(labelSupplemental.parent.labelObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/priorities/prioritiesInfo/prioritySteps/prioritySupplemental/prioritySupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"PrioritySupplementalCtrl as prioritySupplemental\" ng-init=\"prioritySupplemental.fnInitPrioritySupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!prioritySupplemental.parent.isPriorityDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"prioritySupplemental.parent.isPriorityDetailsLoaded\" ng-init=\"prioritySupplemental.fnGetPriorityData();\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"prioritySupplemental.supplementalKVPArr.length || prioritySupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!prioritySupplemental.isSupplementalDetailsEditable && prioritySupplemental.parent.userPermissionsObj.REPLACE_PRIORITY_TAGS\" ng-click=\"prioritySupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"prioritySupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{prioritySupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!prioritySupplemental.supplementalKVPArr.length && !prioritySupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"prioritySupplemental.parent.userPermissionsObj.REPLACE_PRIORITY_TAGS\" ng-click=\"prioritySupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"prioritySupplemental.supplementalKVPArr.length && !prioritySupplemental.isAdvancedOption\" ng-class=\"!prioritySupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"prioritySupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in prioritySupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"prioritySupplemental.isKeyDuplicated && $index === prioritySupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"prioritySupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"prioritySupplemental.isKeyDuplicated && $index === prioritySupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"prioritySupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"prioritySupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"prioritySupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"prioritySupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"prioritySupplemental.prioritySupplementalObj\" ui-codemirror-opts=\"prioritySupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"prioritySupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!prioritySupplemental.isSupplementalDetailChanging\" ng-click=\"prioritySupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!prioritySupplemental.isSupplementalDetailChanging\" ng-click=\"prioritySupplemental.fnSavePriorityData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"prioritySupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{prioritySupplemental.parent.priorityObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(prioritySupplemental.parent.priorityObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectSteps/projectEmail/projectEmail.html","<div class=\"h-100\" ng-controller=\"ProjectEmailCtrl as projectEmail\" ng-init=\"projectEmail.fnInitProjectEmail()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>Customize the email templates used by the system to send out notifications. Add your own branding and styles.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"projectEmail.fnGotoEmailTemplate()\">Edit Email Templates</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectEmail.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectEmail.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectSteps/projectScripts/projectScripts.html","<div class=\"h-100\" ng-controller=\"ProjectScriptCtrl as projectScript\" ng-init=\"projectScript.fnInitProjectScript()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 h-100\"><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>S4 (Secure Server Side Scripting) is the latest ECSMon technology that allows you to adapt our tools for your business by describing your own logic.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"projectScript.fnGotoScripts()\">Edit S4 Scripts</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectScript.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectScript.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectSteps/projectSupplemental/projectSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"ProjectSupplementalCtrl as projectSupplemental\" ng-init=\"projectSupplemental.fnInitProjectSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!projectSupplemental.parent.isProjectDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"projectSupplemental.parent.isProjectDetailsLoaded\" ng-init=\"projectSupplemental.fnGetProjectData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"projectSupplemental.supplementalKVPArr.length || projectSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!projectSupplemental.isSupplementalDetailsEditable && projectSupplemental.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"projectSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"projectSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{projectSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!projectSupplemental.supplementalKVPArr.length && !projectSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"projectSupplemental.parent.userPermissionsObj.REPLACE_PROJECT_TAGS\" ng-click=\"projectSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"projectSupplemental.supplementalKVPArr.length && !projectSupplemental.isAdvancedOption\" ng-class=\"!projectSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"projectSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in projectSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"projectSupplemental.isKeyDuplicated && $index === projectSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"projectSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"projectSupplemental.isKeyDuplicated && $index === projectSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"projectSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"projectSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"projectSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"projectSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"projectSupplemental.projectSupplementalObj\" ui-codemirror-opts=\"projectSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"projectSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!projectSupplemental.isSupplementalDetailChanging\" ng-click=\"projectSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!projectSupplemental.isSupplementalDetailChanging\" ng-click=\"projectSupplemental.fnSaveProjectData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"projectSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectSupplemental.parent.projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectSupplemental.parent.projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/project/projectInfo/projectSteps/projectTeam/projectTeam.html","<div id=\"teamsContent\" class=\"h-100\" ng-controller=\"ProjectTeamsCtrl as projectTeams\" ng-init=\"projectTeams.fnInitProjectTeams()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"projectTeams.isProjectTeamsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"projectTeams.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!projectTeams.isProjectTeamsLoading\"><div><div class=\"project-groups-info-table tableContainer p-t-10\"><table id=\"projectgroups-table\" class=\"table table-striped table-check-box\"><thead><tr><th ng-if=\"projectTeams.projectTeamsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"projectTeams.isAllTeamsChecked\" ng-click=\"projectTeams.fnCheckUncheckTeamsAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"projectTeams.projectTeamsArr.length\">Name</th><th ng-if=\"!projectTeams.projectTeamsArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"group in projectTeams.projectTeamsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"projectTeams.fnCheckUncheckTeamsHeader(group)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\"></label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\"></span></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{projectObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(projectObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/state/stateInfo/stateSteps/stateSupplemental/stateSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"StateSupplementalCtrl as stateSupplemental\" ng-init=\"stateSupplemental.fnInitStateSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!stateSupplemental.parent.isStateDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"stateSupplemental.parent.isStateDetailsLoaded\" ng-init=\"stateSupplemental.fnGetStateData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"stateSupplemental.supplementalKVPArr.length || stateSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!stateSupplemental.isSupplementalDetailsEditable && stateSupplemental.parent.userPermissionsObj.REPLACE_STATE_TAGS\" ng-click=\"stateSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"stateSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{stateSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!stateSupplemental.supplementalKVPArr.length && !stateSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a state consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"stateSupplemental.parent.userPermissionsObj.REPLACE_STATE_TAGS\" ng-click=\"stateSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"stateSupplemental.supplementalKVPArr.length && !stateSupplemental.isAdvancedOption\" ng-class=\"!stateSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"stateSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in stateSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"stateSupplemental.isKeyDuplicated && $index === stateSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"stateSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"stateSupplemental.isKeyDuplicated && $index === stateSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"stateSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"stateSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"stateSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"stateSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"stateSupplemental.stateSupplementalObj\" ui-codemirror-opts=\"stateSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"stateSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!stateSupplemental.isSupplementalDetailChanging\" ng-click=\"stateSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!stateSupplemental.isSupplementalDetailChanging\" ng-click=\"stateSupplemental.fnSaveStateData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"stateSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{stateSupplemental.parent.stateObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(stateSupplemental.parent.stateObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/types/typesInfo/typesSteps/typeForm/typeForm.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"TypeFormCtrl as typeForm\" ng-init=\"typeForm.fnInitTypeForm()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!typeForm.parent.isTypeDetailsLoaded\"></div><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\" ng-if=\"typeForm.parent.isTypeDetailsLoaded\" ng-init=\"typeForm.fnGetTypeData()\"><div class=\"col-sm-12 m-t-0 p-15 h-100 d-flex newTypeFormConfig\" ng-if=\"typeForm.isShowFormBuilderTabUI\"><div class=\"col-sm-2 p-0 h-100 border-1px-solid\"><div class=\"col-sm-12 border-bottom-1px\"><h3 class=\"m-t-10 m-b-10\">Form Control</h3></div><div class=\"col-sm-12 p-0 overflow-auto\" style=\"height: calc(100% - 38px);\"><div class=\"col-sm-12 w100 p-t-5 p-b-5\" ng-class=\"{\'p-t-10\' : $first, \'p-b-10\' : $last}\" ng-repeat=\"input in typeForm.fieldArr\"><button class=\"btn btn-primary v4-primary-button w100\" dnd-list=\"\" dnd-draggable=\"input\" dnd-callback=\"typeForm.fnOnActionDrop(input, targetIndex)\" style=\"text-align: left;\"><i class=\"fa {{input.icon}} m-r-5\"></i>{{input.name}}</button></div></div></div><div class=\"col-sm-10 h-100 m-l-10 p-0 overflow-auto formBuilderTabUI\"><uib-tabset active=\"activeForm\" class=\"height-100\"><uib-tab index=\"0\" heading=\"Form Builder\"><div class=\"col-sm-12 p-t-30 floatingLabelInput\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: \'main\'})\"><div class=\"col-sm-12 p-0\" ui-sortable=\"typeForm.sortableOptions\" ng-model=\"typeForm.formBuilderInput\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputObj in typeForm.formBuilderInput track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputText\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputTextarea\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                </textarea> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"inputObj.type === \'dropdown\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{inputObj.title}}{{inputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"input.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in inputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"inputObj.type === \'inputCheckbox\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{inputObj.key}}\" name=\"{{inputObj.key.toString()}}\" ng-model=\"input.inputValue\"> <label for=\"chk_{{inputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{inputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputNumber\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"inputObj.type === \'inputPassword\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"password\" ng-model=\"input.inputValue\" placeholder=\"{{inputObj.placeholder ? inputObj.placeholder : inputObj.title}}{{inputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{inputObj.title}} {{inputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"inputObj.type === \'panel-conditional\'\" dnd-list=\"\" dnd-drop=\"callback({targetList: input, targetIndex: inputObj.key})\"><div class=\"col-sm-12 p-0 d-flex\"><i class=\"fa fa-arrows m-r-10 m-t-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i><h2 class=\"m-0 m-b-20 w100\"><strong>{{inputObj.title}}</strong></h2><div class=\"m-t-5 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\" ui-sortable=\"typeForm.subSortableOptions\" ng-model=\"inputObj.items\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in inputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputText\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputTextarea\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><textarea class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\" rows=\"4\" style=\"resize: none\">\n                                                            </textarea> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20\" ng-if=\"subInputObj.type === \'dropdown\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"m-r-15 m-t-11\"><label class=\"m-0\">{{subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}</label></div><div class=\"md-input m-0 width-inherit position-r\"><select class=\"md-form-control\" ng-model=\"subInputObj.inputValue\"><option selected=\"\" value=\"\">-- select an option --</option><option value=\"{{arrValue}}\" ng-repeat=\"arrValue in subInputObj.enum track by $index\">{{arrValue}}</option></select></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chk_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div><div class=\"m-t-0 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputNumber\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"number\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0 d-flex\" ng-if=\"subInputObj.type === \'inputPassword\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"password\" ng-model=\"subInputObj.inputValue\" placeholder=\"{{subInputObj.placeholder ? subInputObj.placeholder : subInputObj.title}}{{subInputObj.required ? \'*\': \'\'}}\"> <span class=\"highlight\"></span> <label>{{subInputObj.title}} {{subInputObj.required ? \'*\': \'\'}}</label> <small class=\"helper-text\"></small></div><div class=\"m-t-11 m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"subInputObj.type === \'panel-multiCheckbox\'\"><div class=\"col-sm-12 p-0 d-flex\"><i class=\"fa fa-arrows m-r-10 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i><h3 class=\"m-0 m-b-20 w100\"><strong>{{subInputObj.title}}</strong></h3><div class=\"m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(subInputObj, true, inputObj)\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(subInputObj, true, inputObj)\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\" ui-sortable=\"typeForm.subCHKSortableOptions\" ng-model=\"subInputObj.items\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in subInputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chk_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div></div></div></div></div></div><div class=\"d-flex align-items-center justify-content-center m-t-10 drag-drop-div\"><h3>Drag and Drop a form component</h3></div></div></div><div class=\"col-sm-12 divBlockTest m-b-20\" ng-if=\"inputObj.type === \'panel-multiCheckbox\'\"><div class=\"col-sm-12 p-0 d-flex\"><i class=\"fa fa-arrows m-r-10 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i><h3 class=\"m-0 m-b-20 w100\"><strong>{{inputObj.title}}</strong></h3><div class=\"m-l-10\" style=\"width: 45px\"><i class=\"fa fa-gear m-r-5 font-size-16\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\" ng-click=\"typeForm.fnEditInput(inputObj, false, {})\" uib-tooltip=\"Edit\" tooltip-placement=\"auto\"></i> <i class=\"fa fa-trash-o font-size-16\" ng-click=\"typeForm.fnRemove(inputObj, false, {})\" uib-tooltip=\"Delete\" tooltip-placement=\"auto\"></i></div></div><div class=\"col-sm-12 p-0\" ui-sortable=\"typeForm.subSortableOptions\" ng-model=\"inputObj.items\"><div class=\"col-sm-12 p-0\" ng-repeat=\"subInputObj in inputObj.items track by $index\"><div class=\"col-sm-12 p-0 d-flex m-b-20 align-items-center\" ng-if=\"subInputObj.type === \'inputCheckbox\'\"><div class=\"m-t-11 m-r-10\" ng-if=\"typeForm.parent.userPermissionsObj.UPDATE_TYPE_FORM\"><i class=\"fa fa-arrows font-size-16\" uib-tooltip=\"Drag\" tooltip-placement=\"auto\"></i></div><div class=\"col-sm-12 p-0 m-b-0 d-flex align-items-center\"><input type=\"checkbox\" id=\"chk_{{subInputObj.key}}\" name=\"{{subInputObj.key.toString()}}\" ng-model=\"subInputObj.inputValue\"> <label for=\"chk_{{subInputObj.key}}\" class=\"check-box\"></label> <span class=\"m-l-10\">{{subInputObj.title}}</span></div></div></div></div></div></div></div><div class=\"d-flex align-items-center justify-content-center drag-drop-div\"><h3>Drag and Drop a form component</h3></div><div class=\"col-sm-12 p-t-20 p-0\"><button ng-if=\"typeForm.isUpdateCompleted\" ng-disabled=\"!typeForm.form.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"typeForm.fnUpdateFormConfig()\">Save Form</button><div class=\"col-sm-12 m-b-10\" ng-if=\"!typeForm.isUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Preview\"><div class=\"col-sm-12 p-t-30\"><div class=\"col-sm-12 p-0 d-flex typeFormInputAction\" ng-if=\"typeForm.form.length\"><form role=\"form\" name=\"passwordForm\" class=\"floatingLabelInput typeForm d-flex flex-column\" sf-schema=\"typeForm.schema\" sf-form=\"typeForm.form\" sf-model=\"typeForm.model\"></form></div></div></uib-tab></uib-tabset></div></div><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column h-100\" ng-if=\"!typeForm.isShowFormBuilderTabUI\"><div class=\"d-flex justify-content-center align-items-center flex-column text-center\" style=\"width: 60%;\"><span>Types allow you to optionally create custom forms to capture structured information that you might need when creating an issue. When an issue is of type \'{{typeForm.parent.typeObj.name}}\' the form you create here will automatically be added to the issue. For example you might like to capture node information or client information.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"typeForm.isShowFormBuilderTabUI = true;\">Create Form</button></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{typeForm.parent.typeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(typeForm.parent.typeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/types/typesInfo/typesSteps/typeSupplemental/typeSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"TypeSupplementalCtrl as typeSupplemental\" ng-init=\"typeSupplemental.fnInitTypeSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!typeSupplemental.parent.isTypeDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"typeSupplemental.parent.isTypeDetailsLoaded\" ng-init=\"typeSupplemental.fnGetTypeData()\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"typeSupplemental.supplementalKVPArr.length || typeSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!typeSupplemental.isSupplementalDetailsEditable && typeSupplemental.parent.userPermissionsObj.REPLACE_TYPE_TAGS\" ng-click=\"typeSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"typeSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{typeSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!typeSupplemental.supplementalKVPArr.length && !typeSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"typeSupplemental.parent.userPermissionsObj.REPLACE_TYPE_TAGS\" ng-click=\"typeSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"typeSupplemental.supplementalKVPArr.length && !typeSupplemental.isAdvancedOption\" ng-class=\"!typeSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"typeSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in typeSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"typeSupplemental.isKeyDuplicated && $index === typeSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"typeSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"typeSupplemental.isKeyDuplicated && $index === typeSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"typeSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"typeSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"typeSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"typeSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"typeSupplemental.typeSupplementalObj\" ui-codemirror-opts=\"typeSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"typeSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!typeSupplemental.isSupplementalDetailChanging\" ng-click=\"typeSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!typeSupplemental.isSupplementalDetailChanging\" ng-click=\"typeSupplemental.fnSaveTypeData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"typeSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{typeSupplemental.parent.typeObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(typeSupplemental.parent.typeObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/user-settings/preferences/preferencesTab/colorTheme/modal/colorpicker.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"colorPickerModal.fnInitColorPickerModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\">Select Color</h4></div><div class=\"modal-body\"><div><form id=\"colorForm\" role=\"form\" name=\"colorForm\" class=\"active animated floatingLabelInput\"><div class=\"p-b-15\"><div class=\"minicolors minicolors-theme-bootstrap minicolors-position-bottom minicolors-position-left minicolors-inline\"><input minicolors=\"colorPickerModal.customSettings\" id=\"bgColor-input\" class=\"md-form-control\" type=\"text\" ng-model=\"colorPickerModal.bgColor\" size=\"7\"></div></div><div class=\"md-input has-feedback m-t-10 p-r-0\"><input class=\"md-form-control\" required=\"\" id=\"bgColor-value\" type=\"text\" ng-model=\"colorPickerModal.bgColor\" placeholder=\"Select Background Color\" name=\"bgColor\"> <span class=\"highlight\"></span> <label>Select Background Color</label> <small class=\"helper-text\"></small></div></form></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary v4-primary-button\" tabindex=\"12\" ng-click=\"colorPickerModal.fnApply()\" ng-disabled=\"!colorPickerModal.fnCheckInput()\">Apply</button> <button type=\"button\" class=\"btn btn-primary pull-left btn-primary-cancel\" ng-click=\"colorPickerModal.fnCancel()\" tabindex=\"12\">Close</button></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userSteps/teams/teams.html","<div id=\"teamsContent\" class=\"h-100\" ng-controller=\"UserTeamsCtrl as userTeams\" ng-init=\"userTeams.fnInitUserTeams()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"userTeams.isUserTeamsLoading\"><table-loader hide-circle=\"true\" fn-resize=\"userTeams.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!userTeams.isUserTeamsLoading\"><div><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"!userTeams.isShowAddGroup && userTeams.userTeamsArr.length\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"userTeams.fnHideShowAddGroups()\" ng-if=\"!userTeams.isShowAddGroup\"><a class=\"btn btn-link\">Add Team</a></li><li ng-if=\"userTeams.selectedUserTeamsArr.length\" ng-click=\"userTeams.fnDeleteTeams(userTeams.selectedUserTeamsArr)\"><a class=\"btn btn-link\">Remove Teams</a></li></ul></div></div><div class=\"user-groups-info-table tableContainer\" ng-if=\"!userTeams.isShowAddGroup\"><table id=\"usergroups-table\" class=\"table table-striped table-check-box\" ng-if=\"userTeams.userTeamsArr.length\"><thead><tr><th ng-if=\"userTeams.userTeamsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"userTeams.isAllTeamsChecked\" ng-click=\"userTeams.fnCheckUncheckTeamsAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"userTeams.userTeamsArr.length\">Name</th><th ng-if=\"!userTeams.userTeamsArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"group in userTeams.userTeamsArr track by $index\" ng-click=\"userTeams.fnGetGroup(group, userTeams.userTeamsArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"userTeams.fnCheckUncheckTeamsHeader(group)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\" ng-click=\"$event.stopPropagation(); userTeams.fnGoToTeam(group)\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!userTeams.userTeamsArr.length\"><button class=\"btn btn-primary\" ng-click=\"userTeams.fnHideShowAddGroups()\">Add Team</button></div></div><div id=\"addGroupContainer\" ng-if=\"userTeams.isShowAddGroup\"><div class=\"p-t-10 p-b-10\"><label>Add Team</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"userTeams.fnHideShowAddGroups()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'groupSearch\'\" filters-arr=\"userTeams.searchFiltersArr\" filter-query=\"userTeams.filterQuery\" fn-filter-query-change=\"userTeams.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.users\'\" no-set-url=\"true\" fn-resize=\"userTeams.fnSetTableHeight()\" sort-field-arr=\"userTeams.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader hide-circle=\"true\" fn-resize=\"userTeams.fnSetLoaderTableHeight()\" ng-if=\"userTeams.isTeamsLoading\"></table-loader><div class=\"user-groups-info-table table-container\"><table id=\"usergroups-table\" class=\"table table-striped table-check-box\" ng-if=\"!userTeams.isTeamsLoading\"><thead><tr><th ng-if=\"userTeams.teamsArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllGroup\" ng-model=\"userTeams.isAllChecked\" ng-click=\"userTeams.fnCheckUncheckAll()\"> <label for=\"checkAllGroup\" class=\"check-box\"></label></th><th ng-if=\"userTeams.teamsArr.length\">Name</th><th ng-if=\"!userTeams.teamsArr.length\">No Records Found...</th></tr></thead><tbody id=\"userTeamsTable\"><tr ng-repeat=\"group in userTeams.teamsArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkGroup_{{$index}}\" ng-model=\"group.isCheck\" ng-change=\"userTeams.fnCheckUncheckHeader(group)\"> <label for=\"chkGroup_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"group.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"group.description\">Desc</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!userTeams.isTeamsLoading && userTeams.teamsArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{userTeams.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"userTeams.perPage = 10; userTeams.fnPageChanged(userTeams.currentPage, userTeams.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"userTeams.perPage = 20; userTeams.fnPageChanged(userTeams.currentPage, userTeams.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"userTeams.perPage = 50; userTeams.fnPageChanged(userTeams.currentPage, userTeams.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"userTeams.perPage = 100; userTeams.fnPageChanged(userTeams.currentPage,userTeams.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"userTeams.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"userTeams.currentPage\" items-per-page=\"userTeams.perPage\" max-size=\"userTeams.maxSize\" boundary-links=\"true\" ng-click=\"userTeams.fnPageChanged(userTeams.currentPage, userTeams.perPage)\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!userTeams.isGroupAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"userTeams.fnAddGroup()\">Add</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"userTeams.isGroupAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userSteps/userSecurityRoles/userSecurityRoles.html","<div id=\"userRolesContent\" class=\"h-100\" ng-controller=\"UserSecurityRolesCtrl as userSecurityRoles\" ng-init=\"userSecurityRoles.fnInitUserSecurityRoles()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center m-t-20\" ng-if=\"userObj.administrator\"><label>Admins have all permissions and security roles have no effect.</label></div><div class=\"col-sm-12 p-0\" ng-if=\"!userObj.administrator\"><div class=\"col-sm-12 p-0 m-t-10\" ng-if=\"userSecurityRoles.isUserSecurityRolesLoading\"><table-loader hide-circle=\"true\" fn-resize=\"userSecurityRoles.fnSetLoaderTableHeight()\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!userSecurityRoles.isUserSecurityRolesLoading\"><div><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"!userSecurityRoles.isShowAddRole && userSecurityRoles.userSecurityRolesArr.length\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"userSecurityRoles.fnHideShowAddRoles()\" ng-if=\"!userSecurityRoles.isShowAddRole\"><a class=\"btn btn-link\">Add Security Role</a></li><li ng-if=\"userSecurityRoles.selectedUserRolesArr.length\" ng-click=\"userSecurityRoles.fnDeleteUserRoles(userSecurityRoles.selectedUserRolesArr)\"><a class=\"btn btn-link\">Remove Security Roles</a></li></ul></div></div><div id=\"tableContainer\" ng-if=\"!userSecurityRoles.isShowAddRole\"><table class=\"user-security-role-info-table table table-striped table-check-box\" ng-if=\"userSecurityRoles.userSecurityRolesArr.length\"><thead><tr><th ng-if=\"userSecurityRoles.userSecurityRolesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllUG\" ng-model=\"userSecurityRoles.isAllUserRolesChecked\" ng-click=\"userSecurityRoles.fnCheckUncheckUserRolesAll()\"> <label for=\"checkAllUG\" class=\"check-box\"></label></th><th ng-if=\"userSecurityRoles.userSecurityRolesArr.length\">Name</th><th ng-if=\"!userSecurityRoles.userSecurityRolesArr.length\">No Records Found...</th></tr></thead><tbody><tr ng-repeat=\"role in userSecurityRoles.userSecurityRolesArr track by $index\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkUG_{{$index}}\" ng-model=\"role.isCheck\" ng-change=\"userSecurityRoles.fnCheckUncheckUserRolesHeader(role)\"> <label for=\"chkUG_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"role.name\" ng-click=\"$event.stopPropagation(); userSecurityRoles.fnGoToUserRole(role)\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"role.description\">Desc</span></div></td></tr></tbody></table><div class=\"text-center m-t-40\" ng-if=\"!userSecurityRoles.userSecurityRolesArr.length\"><button class=\"btn btn-primary\" ng-click=\"userSecurityRoles.fnHideShowAddRoles()\">Add Security Role</button></div></div><div id=\"addRoleContainer\" ng-if=\"userSecurityRoles.isShowAddRole\"><div class=\"p-t-10 p-b-10\"><label>Add Security Role</label> <button type=\"button\" class=\"btn btn-link pull-right p-0 ng-scope\" ng-click=\"userSecurityRoles.fnHideShowAddRoles()\"><i class=\"fa fa-times\"></i></button></div><div><div class=\"content-box-content table-content-box p-0\"><v4-search-client search-identifier=\"\'userSecurityRole\'\" filters-arr=\"userSecurityRoles.searchFiltersArr\" filter-query=\"userSecurityRoles.filterQuery\" fn-filter-query-change=\"userSecurityRoles.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery)\" state-name=\"\'main.users\'\" no-set-url=\"true\" fn-resize=\"userSecurityRoles.fnSetTableHeight()\" sort-field-arr=\"userSecurityRoles.sortFieldArr\"></v4-search-client><div class=\"row\"><div class=\"col-sm-12\"><table-loader ng-if=\"userSecurityRoles.isSecurityRolesLoading\" is-user-roles=\"userSecurityRoles.isSecurityRolesLoading\" fn-resize=\"userSecurityRoles.fnSetLoaderTableHeight()\"></table-loader><div class=\"user-groups-table table-container\"><table id=\"groups-secondaryTable\" class=\"table table-striped table-check-box\" ng-show=\"!userSecurityRoles.isSecurityRolesLoading\"><thead><tr><th ng-if=\"userSecurityRoles.securityRolesArr.length\" class=\"p-8\"><input type=\"checkbox\" id=\"checkAllRole\" ng-model=\"userSecurityRoles.isAllChecked\" ng-click=\"userSecurityRoles.fnCheckUncheckAll()\"> <label for=\"checkAllRole\" class=\"check-box\"></label></th><th ng-if=\"userSecurityRoles.securityRolesArr.length\">Name</th><th ng-if=\"!userSecurityRoles.securityRolesArr.length\">No Records Found...</th></tr></thead><tbody id=\"userSecurityRolesTable\"><tr ng-repeat=\"role in userSecurityRoles.securityRolesArr track by $index\" ng-click=\"userSecurityRoles.fnGetRole(role, userSecurityRoles.securityRolesArr);\"><td class=\"p-8\" ng-click=\"$event.stopPropagation();\"><input type=\"checkbox\" id=\"chkRole_{{$index}}\" ng-model=\"role.isCheck\" ng-change=\"userSecurityRoles.fnCheckUncheckHeader(role)\"> <label for=\"chkRole_{{$index}}\" class=\"check-box\"></label></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\" ng-bind=\"role.name\">Doe</label> <span class=\"ellipsis DescriptionText span_des\" ng-bind=\"role.description\">Desc</span></div></td></tr></tbody></table><div class=\"pagination-container\" ng-show=\"!userSecurityRoles.isSecurityRolesLoading && userSecurityRoles.securityRolesArr.length\"><div class=\"row m-b-0\"><div class=\"col-sm-3 m-t-5\"><div class=\"dropdown dropup\" uib-dropdown=\"\">Per page: &nbsp; <a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><label>{{userSecurityRoles.perPage}}<i class=\"fa fa-caret-up m-l-2\"></i></label></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li><a class=\"btn btn-link\" ng-click=\"userSecurityRoles.perPage = 10; userSecurityRoles.fnPageChanged(userSecurityRoles.currentPage, userSecurityRoles.perPage, true)\">10</a></li><li><a class=\"btn btn-link\" ng-click=\"userSecurityRoles.perPage = 20; userSecurityRoles.fnPageChanged(userSecurityRoles.currentPage, userSecurityRoles.perPage, true)\">20</a></li><li><a class=\"btn btn-link\" ng-click=\"userSecurityRoles.perPage = 50; userSecurityRoles.fnPageChanged(userSecurityRoles.currentPage, userSecurityRoles.perPage, true)\">50</a></li><li><a class=\"btn btn-link\" ng-click=\"userSecurityRoles.perPage = 100; userSecurityRoles.fnPageChanged(userSecurityRoles.currentPage,userSecurityRoles.perPage, true)\">100</a></li></ul></div></div><div class=\"col-sm-9 text-right\"><ul uib-pagination=\"\" class=\"m-0 text-center\" total-items=\"userSecurityRoles.totalItems\" style=\"margin-bottom: -5px !important;\" ng-model=\"userSecurityRoles.currentPage\" items-per-page=\"userSecurityRoles.perPage\" max-size=\"userSecurityRoles.maxSize\" rotate=\"false\" boundary-links=\"true\" ng-click=\"userSecurityRoles.fnPageChanged(userSecurityRoles.currentPage, userSecurityRoles.perPage)\" force-ellipses=\"true\"></ul></div><div class=\"col-sm-12 m-t-12\" ng-if=\"!userSecurityRoles.isRoleAdding\"><button class=\"btn btn-primary pull-right\" ng-click=\"userSecurityRoles.fnAddRole()\">Add</button></div><div class=\"col-sm-12 m-t-12\" ng-if=\"userSecurityRoles.isRoleAdding\"><div class=\"pull-right m-r-32\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userSteps/userPermissions/userPermissions.html","<div id=\"userDetailsContent\" class=\"content-main\" ng-init=\"fnInitUserPermissions()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isUserPermissionDetailsLoaded\"></div><div class=\"col-sm-12 d-flex\" ng-if=\"isUserPermissionDetailsLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"><h1>Permissions</h1></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-class=\"isUserPermissionDetailsLoaded && isPermissionUpdateCompleted ? \'\' : \'pace opacity-5\'\" ng-if=\"!isPermissionsEditable\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!isPermissionsEditable && userPermissionsObj.UPDATE_USER\" ng-click=\"fnChangePermissionsToEditable()\"><a class=\"btn btn-link\">Edit</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" ng-if=\"isUserPermissionDetailsLoaded\" ng-class=\"!isPermissionsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 m-b-20 p-0\" ng-if=\"!userObj.accountOwner\"><div class=\"col-sm-6 p-0\"><table class=\"table table-responsive UserDetailPermissionTable\"><thead><tr><th></th><th class=\"text-center\">MANAGER</th><th class=\"text-center\">SUPERVISOR</th><th class=\"text-center\">ENGINEER</th><th class=\"text-center\">TEAM MEMBER</th><th class=\"text-center\">CUSTOMER</th><th class=\"text-center\">NONE</th><th class=\"text-center\"></th></tr></thead><tbody><tr ng-repeat=\"(key, value) in permissionsStructureObj track by $index\" ng-class=\"fnIsPermissionAllowed(key) ? \'\' : \'pace opacity-5\'\"><td class=\"text-capitalize\">{{key}}</td><td class=\"text-center\" ng-repeat=\"(k, v) in value\" ng-if=\"k !== \'isChanged\'\"><div class=\"radio\"><input ng-if=\"v.isApplicable\" type=\"checkbox\" id=\"{{key + \'_\' + k}}\" ng-click=\"fnUpdatePermissions(value, k, key)\" ng-model=\"v.isActive\"> <label ng-if=\"v.isApplicable\" for=\"{{key + \'_\' + k}}\" class=\"permCheck check-box\"></label> <label ng-if=\"!v.isApplicable\" class=\"p-l-0\">-</label></div></td><td ng-repeat=\"(k, v) in value\" ng-if=\"k !== \'isChanged\' && v.isActive\"><label class=\"font-italic\">{{v.permDetail}}</label></td></tr></tbody></table></div></div><div class=\"col-sm-12 m-b-20 p-0\" ng-if=\"!userObj.accountOwner\" ng-class=\"userObj.id !== authUserObj.id && userPermissionsObj.UPDATE_USER_ADMINISTRATOR ? \'\' : \'pace opacity-5\'\"><div class=\"col-sm-6 p-0\"><label class=\"m-b-10 opacity-5 font-italic\">Administrators are granted MANAGER permissions to all applications except billing</label><table class=\"table table-responsive UserDetailPermissionTable\"><tr><td>Administrator</td><td class=\"text-center\"><input type=\"checkbox\" id=\"administrator\" ng-click=\"fnChangeAdminStatus(adminPermissionStructureObj.isActive)\" ng-model=\"adminPermissionStructureObj.isActive\"> <label for=\"administrator\" class=\"check-box\"></label></td><td></td><td></td><td></td><td></td><td></td><td></td></tr></table></div></div><div class=\"col-sm-12 m-b-20 p-0\" ng-if=\"userObj.accountOwner\"><label class=\"m-b-10 font-italic\">Account Owners are granted full access to all applications.</label></div><button ng-if=\"isPermissionsEditable && isPermissionUpdateCompleted\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-click=\"fnResetPermissionDetails()\">Cancel</button> <button ng-if=\"isPermissionsEditable && isPermissionUpdateCompleted\" ng-disabled=\"!userObj.firstName.length || !userObj.lastName.length || !userObj.username.length || !userObj.email.length\" class=\"btn btn-primary pull-right m-b-10\" ng-click=\"fnUpdateUserDetails(userObj)\">Save Changes</button><div class=\"col-sm-12\" ng-if=\"!isPermissionUpdateCompleted\"><div class=\"pull-right\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/access/users/directives/userInfo/userSteps/userRelationships/userRelationships.html","<div id=\"userDetailsContent\" class=\"h-100\" ng-controller=\"UserRelationshipsCtrl as userRelationship\" ng-init=\"userRelationship.fnInitUserRelationships()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-10\" ng-if=\"!userRelationship.isUserRelationshipLoaded\"><app-spinner spinner-type=\"\'miniSpinner\'\"></app-spinner></div><div ng-if=\"userRelationship.isUserRelationshipLoaded\"><div class=\"col-sm-12 m-t-5 p-l-5 p-r-5 h-100\"><div ng-if=\"!userRelationship.groupPermObj.List && !userRelationship.rolePermObj.List\"><div class=\"col-sm-12 text-center p-t-10\"><strong>No Records Found...</strong></div></div><div ng-if=\"userRelationship.groupPermObj.List || userRelationship.rolePermObj.List\"><div class=\"col-sm-12 p-5 h-100\" ng-if=\"userRelationship.relationshipObj\"><user-tree-view tree-data=\"userRelationship.relationshipObj\"></user-tree-view></div><div class=\"text-center\" ng-if=\"!userRelationship.relationshipObj\"><label>No Records Found...</label></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{userObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(userObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/node/iot3/iot3Service/createIot3/iot3CreateSteps/iot3Edtior/iot3Editor.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"createIot3.fnInitIot3()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createIot3.isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"createIot3.isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"></div></div><div class=\"col-sm-12 floatingLabelInput\" style=\"height: calc(100% - 65px)\" ng-class=\"createIot3.isIot3ReferenceSaving ? \'pace\' : \'\'\" ng-if=\"createIot3.isIot3ReferenceLoaded\"><div class=\"col-sm-12 p-0 h-100\" ng-init=\"createIot3.fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit codeMirrorMainContent\"><ui-codemirror ng-model=\"createIot3.iot3Obj.iot3\" ui-codemirror-opts=\"createIot3.editorOptions\"></ui-codemirror></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"createIot3.isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"d-flex justify-content-center align-items-center m-r-10\" style=\"height: 25px;width: 25px;\"><svg xmlns=\"http://www.w3.org/2000/svg\" ng-if=\"!createIot3.isChangesSync\" style=\"height: inherit;width: inherit\" viewbox=\"0 -27 511.99932 511\"><g><path d=\"m213.410156 25.089844-206.746094 358.09375c-18.929687 32.789062 4.730469 73.773437 42.589844 73.773437h413.492188c37.859375 0 61.519531-40.984375 42.589844-73.773437l-206.746094-358.09375c-18.929688-32.785156-66.25-32.785156-85.179688 0zm0 0\" fill=\"#65687f\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687f\" style=\"fill:#F50000\"></path><path d=\"m49.253906 415.160156c-2.828125 0-4.980468-1.242187-6.394531-3.691406s-1.414063-4.9375 0-7.386719l206.746094-358.09375c1.414062-2.449219 3.566406-3.691406 6.394531-3.691406s4.980469 1.242187 6.394531 3.691406l206.746094 358.09375c1.417969 2.449219 1.417969 4.933594 0 7.386719-1.414063 2.449219-3.5625 3.691406-6.394531 3.691406zm0 0\" fill=\"#ffe37d\" data-original=\"#FFE37D\" class=\"active-path\" style=\"fill:#FBFBFB\" data-old_color=\"#ffe37d\"></path><g fill=\"#65687f\"><path d=\"m288.980469 347.046875c0 18.214844-14.765625 32.980469-32.980469 32.980469s-32.980469-14.765625-32.980469-32.980469 14.765625-32.980469 32.980469-32.980469 32.980469 14.765625 32.980469 32.980469zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path><path d=\"m265.1875 131.980469h-18.375c-10.71875 0-19.40625 8.691406-19.40625 19.410156v116.414063c0 10.714843 8.6875 19.40625 19.40625 19.40625h18.375c10.71875 0 19.40625-8.691407 19.40625-19.40625v-116.414063c0-10.71875-8.6875-19.410156-19.40625-19.410156zm0 0\" data-original=\"#65687F\" class=\"\" data-old_color=\"#65687F\" style=\"fill:#F50000\"></path></g></g></svg><svg xmlns=\"http://www.w3.org/2000/svg\" style=\"height: inherit;width: inherit\" viewbox=\"0 0 510 510\" ng-if=\"createIot3.isChangesSync\"><g id=\"check-circle-outline\"><path d=\"M150.45,206.55l-35.7,35.7L229.5,357l255-255l-35.7-35.7L229.5,285.6L150.45,206.55z M459,255c0,112.2-91.8,204-204,204 S51,367.2,51,255S142.8,51,255,51c20.4,0,38.25,2.55,56.1,7.65l40.801-40.8C321.3,7.65,288.15,0,255,0C114.75,0,0,114.75,0,255 s114.75,255,255,255s255-114.75,255-255H459z\" data-original=\"#000000\" class=\"active-path\" data-old_color=\"#000000\" fill=\"#00AF80\"></path></g></svg></div><button class=\"btn btn-primary v4-primary-button m-l-10\" ng-if=\"!createIot3.isChangesSync\" ng-click=\"createIot3.fnChangeDone()\">Save changes</button></div></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"createIot3.iot3Obj && createIot3.iot3Obj.iot3.length && createIot3.isChangesSync ? \'\' : \'pace opacity-5\'\" ng-click=\"createIot3.fnSaveIot3Reference()\" ng-if=\"!createIot3.isIot3ReferenceSaving\">Save Iot3 Reference</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"createIot3.isIot3ReferenceSaving\"></app-spinner></div></div>");
$templateCache.put("app/node/iot3/iot3Service/iot3Info/iot3Steps/iot3Nodes/iot3Nodes.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"fnInitializeResizeEvent()\" style=\"overflow-y: hidden\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isIot3ReferenceLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnDeleteIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-click=\"fnCloneIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput iot3NodeMainContent\" style=\"height: calc(100% - 60px)\" ng-if=\"isIot3ReferenceLoaded\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\" style=\"width: 35px !important;\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" ng-model=\"searchText\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"iot3-register-node-table table-container\"><table id=\"iot3NodeTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\">Type</th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th ng-if=\"!searchFilterArr.length\">No records found...</th></tr></thead><tbody id=\"iot3NodeTableBody\"><tr ng-repeat=\"iot3TypeObj in searchFilterArr=(iot3Obj.iot3JSON.template.typesArr | filter: searchText) track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3TypeObj.id}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3TypeObj.name}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.price.value + \" \" + iot3TypeObj.price.unit}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.energy.value + \" \" + iot3TypeObj.energy.unit}}</span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.attributes ? iot3TypeObj.attributes.length + \" Attributes\" : \"0 Attributes\"}}</span></div></div></td><td><div ng-show=\"iot3TypeObj.attributes && iot3TypeObj.attributes.length\" class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();fnViewAttributes(iot3TypeObj)\">View Attributes</button></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{iot3Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(iot3Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/iot3/iot3Service/iot3Info/iot3Steps/iot3Edtior/iot3Editor.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"fnInitializeResizeEvent()\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" ng-if=\"isIot3ReferenceLoaded\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-click=\"fnDeleteIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Delete</a></li><li ng-click=\"fnCloneIot3Reference(iot3Obj)\"><a class=\"btn btn-link\">Clone</a></li></ul></div></div></div><div class=\"col-sm-12 floatingLabelInput\" style=\"height: calc(100% - 65px)\" ng-if=\"isIot3ReferenceLoaded\"><div class=\"col-sm-12 p-0 h-100\" ng-init=\"fnInitCalled()\"><div class=\"col-sm-12 p-0 height-inherit codeMirrorMainContent\"><ui-codemirror ng-model=\"iot3Obj.iot3\" ui-codemirror-opts=\"editorOptions\"></ui-codemirror></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{iot3Obj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(iot3Obj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div>");
$templateCache.put("app/node/iot3/iot3Service/createIot3/iot3CreateSteps/iot3Nodes/iot3Nodes.html","<div id=\"iot3Content\" class=\"content-main\" ng-init=\"createIot3.fnInitIot3()\" style=\"overflow-y: hidden\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!createIot3.isIot3ReferenceLoaded\"></div><div class=\"col-sm-12 d-flex p-t-15 p-b-15\" ng-if=\"createIot3.isIot3ReferenceLoaded\"><div class=\"col-sm-6 p-0\" style=\"margin: auto;\"></div><div class=\"col-sm-6 d-flex p-0 justify-content-flex-end\" style=\"margin: auto;\"></div></div><div class=\"col-sm-12 floatingLabelInput iot3NodeMainContent\" style=\"height: calc(100% - 60px)\" ng-if=\"createIot3.isIot3ReferenceLoaded\"><div class=\"col-sm-12 m-t-10 local-search-bar floatingLabelInput iot3-node-search\"><div class=\"w-35px m-r-5\" style=\"width: 35px !important;\"><span class=\"search-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 446.25 446.25\"><g id=\"search\"><path d=\"M318.75,280.5h-20.4l-7.649-7.65c25.5-28.05,40.8-66.3,40.8-107.1C331.5,73.95,257.55,0,165.75,0S0,73.95,0,165.75 S73.95,331.5,165.75,331.5c40.8,0,79.05-15.3,107.1-40.8l7.65,7.649v20.4L408,446.25L446.25,408L318.75,280.5z M165.75,280.5 C102,280.5,51,229.5,51,165.75S102,51,165.75,51S280.5,102,280.5,165.75S229.5,280.5,165.75,280.5z\"></path></g></svg></span></div><div class=\"md-input m-b-20\"><input class=\"md-form-control p-l-35\" type=\"text\" ng-model=\"createIot3.searchText\" placeholder=\"Search\"></div></div><div class=\"col-sm-12\"><div class=\"iot3-register-node-table table-container\"><table id=\"iot3NodeTable\" class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\">Type</th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th class=\"p-r-2\" ng-if=\"searchFilterArr.length\"></th><th ng-if=\"!searchFilterArr.length\">No records found...</th></tr></thead><tbody id=\"iot3NodeTableBody\"><tr ng-repeat=\"iot3TypeObj in searchFilterArr=(createIot3.iot3Obj.iot3JSON.template.typesArr | filter: createIot3.searchText) track by $index\"><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0\"><label class=\"ellipsis m-b-0 label_name\">{{iot3TypeObj.id}}</label> <span class=\"ellipsis DescriptionText span_des\">{{iot3TypeObj.name}}</span></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.price.value + \" \" + iot3TypeObj.price.unit}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.energy.value + \" \" + iot3TypeObj.energy.unit}}</span></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><span class=\"ellipsis m-l-10 m-b-0\">{{iot3TypeObj.attributes ? iot3TypeObj.attributes.length + \" Attributes\" : \"0 Attributes\"}}</span></div></div></td><td><div ng-show=\"iot3TypeObj.attributes && iot3TypeObj.attributes.length\" class=\"d-flex justify-content-center align-items-center\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"$event.stopPropagation();createIot3.fnViewAttributes(iot3TypeObj)\">View Attributes</button></div></td></tr></tbody></table></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"createIot3.isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-primary v4-primary-button\" ng-class=\"createIot3.iot3Obj && createIot3.iot3Obj.iot3.length && createIot3.isChangesSync ? \'\' : \'pace opacity-5\'\" ng-click=\"createIot3.fnSaveIot3Reference()\" ng-if=\"!createIot3.isIot3ReferenceSaving\">Save Iot3 Reference</button><app-spinner spinner-type=\"\'microSpinner\'\" ng-if=\"createIot3.isIot3ReferenceSaving\"></app-spinner></div></div>");
$templateCache.put("app/predictive/account/directives/accountInfo/accountSteps/accountSupplemental/accountSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"AccountSupplementalCtrl as accountSupplemental\" ng-init=\"accountSupplemental.fnInitAccountSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!accountSupplemental.parent.isAccountDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"accountSupplemental.parent.isAccountDetailsLoaded\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"accountSupplemental.supplementalKVPArr.length || accountSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!accountSupplemental.isSupplementalDetailsEditable\" ng-click=\"accountSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"accountSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{accountSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!accountSupplemental.supplementalKVPArr.length && !accountSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-click=\"accountSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"accountSupplemental.supplementalKVPArr.length && !accountSupplemental.isAdvancedOption\" ng-class=\"!accountSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"accountSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in accountSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"accountSupplemental.isKeyDuplicated && $index === accountSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"accountSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"accountSupplemental.isKeyDuplicated && $index === accountSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"accountSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"accountSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"accountSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"accountSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"accountSupplemental.accountSupplementalObj\" ui-codemirror-opts=\"accountSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 m-t-10 m-b-10\" ng-if=\"accountSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!accountSupplemental.isSupplementalDetailChanging\" ng-click=\"accountSupplemental.fnResetDetails(true)\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!accountSupplemental.isSupplementalDetailChanging\" ng-click=\"accountSupplemental.fnSaveAccountData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"accountSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{accountObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(accountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/predictive/account/directives/accountInfo/accountSteps/accountUsers/accountUsers.html","<div id=\"accountUsersContent\" class=\"h-100\" ng-controller=\"AccountUsersCtrl as accountUsers\" ng-init=\"accountUsers.fnInitAccountUsers()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 m-t-5\" ng-if=\"accountUsers.isAccountUsersLoading\"><table-loader is-account-users-tab=\"true\"></table-loader></div><div class=\"col-sm-12\" ng-if=\"!accountUsers.isAccountUsersLoading\"><div id=\"tableContainer\" ng-if=\"!accountUsers.isShowAddUser\"><table class=\"table table-striped table-check-box\"><thead><tr><th class=\"p-8\" ng-if=\"accountUsers.accountUsersArr.length\">Name</th><th ng-if=\"accountUsers.accountUsersArr.length\">Description</th><th ng-if=\"accountUsers.accountUsersArr.length\"></th><th ng-if=\"!accountUsers.accountUsersArr.length\">No records found...</th></tr></thead><tbody><tr ng-repeat=\"user in accountUsers.accountUsersArr track by $index\"><td class=\"p-8\" ng-bind=\"user.firstName + \' \' +user.lastName\">Doe</td><td ng-bind=\"user.bio\">Desc</td><td></td></tr></tbody></table></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{accountObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(accountObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/IssueForm/issueForm.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"IssueFormCtrl as issueForm\" ng-init=\"issueForm.fnInitIssueForm()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issueForm.isIssueDetailsLoaded\"></div><div class=\"col-sm-12 p-0 m-t-0 h-100 floatingLabelInput\" ng-if=\"issueForm.isIssueDetailsLoaded\"><div class=\"col-sm-12 p-0 p-l-10 p-t-10 h-100\" ng-if=\"!issueForm.form.length\"><label>Form not defined</label></div><div class=\"col-sm-12 p-t-20\" ng-if=\"issueForm.form.length\"><div class=\"col-sm-12 p-0 d-flex\"><form id=\"customForm\" role=\"form\" name=\"customForm\" novalidate=\"\" class=\"floatingLabelInput typeForm d-flex flex-column\"><div class=\"d-flex flex-column\" sf-schema=\"issueForm.schema\" sf-form=\"issueForm.form\" sf-model=\"issueForm.model\"></div></form></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary pull-right m-l-15 m-b-10\" ng-disabled=\"!customForm.$valid\" ng-if=\"!issueForm.isDateUpdating\" ng-click=\"issueForm.fnSaveValue()\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"issueForm.isDateUpdating\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueForm.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueForm.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-link m-r-5\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button><div ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/issueAttributes/issueAttributes.html","<div class=\"h-100 supplementalTemplate node-attributes-tab\" ng-controller=\"IssueAttributesCtrl as issueAttributeTab\" ng-init=\"issueAttributeTab.fnInitIssueAttributes()\"><div class=\"content-main\"><div class=\"col-sm-12 p-0 h-100 d-flex align-items-center justify-content-center\" ng-if=\"issueAttributeTab.isAttributeDataLoading\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'pageSpinner\'\"></div></div><div class=\"issue-alarms-table table-container col-sm-12 h-100\" ng-if=\"!issueAttributeTab.isAttributeDataLoading\"><table class=\"table table-striped table-check-box m-b-0\" ng-if=\"issueAttributeTab.attributesArr.length\"><thead><tr><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\">Name</th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\"></th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\"></th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\"></th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\"></th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\">Mode</th><th class=\"\" ng-if=\"issueAttributeTab.attributesArr.length\"></th><th ng-if=\"!issueAttributeTab.attributesArr.length\">No records found...</th></tr></thead><tbody id=\"issueAlarmTable\"><tr ng-repeat=\"alarmObj in issueAttributeTab.attributesArr track by $index\"><td><button class=\"btn btn-xs btn-default ellipsis-label w100\" uib-tooltip=\"{{alarmObj.healthName}}\" tooltip-placement=\"auto\" ng-style=\"issueAttributeTab.fnGetHealthColor(alarmObj.health, alarmObj)\"><span class=\"healtSpan\">{{alarmObj.healthName}}</span></button></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.name}}</label> <span class=\"ellipsis DescriptionText span_des\">{{alarmObj.description}}</span></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}\" tooltip-placement=\"auto\"><label class=\"ellipsis m-b-0\"><strong>{{alarmObj.value}} {{alarmObj.read && alarmObj.read.unit ? alarmObj.read.unit : \'\'}}</strong></label></div></td><td class=\"attributeTdCSS-style\"><div class=\"d-flex flex-column\"><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.receivedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.receivedAt\"><label class=\"ellipsis m-b-0\">Value last updated {{alarmObj.receivedDate}}</label></div><div class=\"d-flex p-r-5 p-b-5\" uib-tooltip=\"{{alarmObj.healthUpdatedDate}}\" tooltip-placement=\"auto\" ng-if=\"alarmObj.healthLastChangedAt\"><label class=\"ellipsis m-b-0\">Health last updated {{alarmObj.healthUpdatedDate}}</label></div></div></td><td><div class=\"d-flex flex-column\"><div class=\"d-flex align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/ecu.svg#ecu\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.ecuName}}</span></div><div class=\"d-flex m-t-10 align-items-center\"><div class=\"d-flex\"><svg class=\"svgIconFillTextSecondaryColor\" width=\"23px\" height=\"23px\"><use xlink:href=\"assets/images/svg/service/device.svg#device\"></use></svg></div><span class=\"ellipsis m-l-10 m-b-0\">{{alarmObj.nodeName}}</span></div></div></td><td class=\"attributeTdCSS-style\"><div class=\"col-sm-12 p-0 d-flex flex-column\" ng-show=\"!alarmObj.isEditable\"><label class=\"ellipsis label_name d-flex align-items-center\">{{alarmObj.mode}}</label></div></td><td><div class=\"btn-group col-sm-12 p-0 d-flex justify-content-flex-end\" uib-dropdown=\"\"><button type=\"button\" class=\"btn btn-primary border-right-0 p-r-4 v4-primary-button\" ng-click=\"issueAttributeTab.fnOpenIssueInfo(alarmObj)\">View attribute</button> <button type=\"button\" class=\"btn btn-primary border-left-0 m-l-0 v4-primary-button\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-click=\"issueAttributeTab.fnOpenIssueInNewTab(alarmObj)\"><a><span>View attribute in new tab</span></a></li></ul></div></td></tr></tbody></table></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueAttributeTab.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueAttributeTab.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/Linked/issueLinked.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"IssueLinkedCtrl as issueLinked\" ng-init=\"issueLinked.fnInitIssueLinked()\"><div class=\"content-main\">Issue Linked</div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\" ng-if=\"isFullWidthDevice\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueLinked.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueLinked.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-link\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/issueHistory/issueHistory.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"IssueHistoryCtrl as issueHistory\" ng-init=\"issueHistory.fnInitIssueHistory()\"><div class=\"content-main\"><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\"><div class=\"m-t-20\"><v4-search-client search-identifier=\"\'nodeAttributeSearch\'\" filters-arr=\"issueHistory.searchFiltersArr\" filter-query=\"issueHistory.filterQuery\" state-name=\"\'main.issue\'\" no-set-url=\"true\" fn-filter-query-change=\"issueHistory.fnFilterQueryChanged(filterQuery, sortQuery, sqlQuery, tagArr)\" fn-resize=\"nodeAttribute.fnSetTableHeight()\" sort-field-arr=\"issueHistory.sortFieldArr\" default-sort-string=\"issueHistory.defaultSortString\" table-alias=\"issueHistory.tableAlias\"></v4-search-client></div><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issueHistory.isIssueHistoryDetailsLoaded\"></div><div ng-if=\"issueHistory.isIssueHistoryDetailsLoaded && !issueHistory.issueHistorysArr.length\" class=\"m-t-15\"><label class=\"m-0\"><strong>No records found...</strong></label></div><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 p-0 m-t-10\" ng-if=\"issueHistory.isIssueHistoryDetailsLoaded && issueHistory.issueHistorysArr && issueHistory.issueHistorysArr.length\"><div ng-class=\"$index === issueHistory.issueHistorysArr.length - 1 ? \'message-first\' : \'message-item\'\" ng-repeat=\"issueHistoryObj in issueHistory.issueHistorysArr track by issueHistoryObj.myIndex\"><div class=\"message-inner\"><div class=\"message-head clearfix\"><div class=\"user-detail\"><div class=\"pull-left\"><div><label class=\"m-0 p-b-5\"><img class=\"avatarImage m-r-5 img-circle\" ng-src=\"{{issueHistoryObj.userAvatar}}\"> {{issueHistoryObj.tags.user}}</label></div><h5 class=\"handle text-left\">{{issueHistoryObj.name.replace(\'_\', \' \')}}</h5><div class=\"post-meta\"><div class=\"asker-meta m-t-5\" style=\"text-align: left\"><span class=\"qa-message-what\"></span> <span class=\"qa-message-when\"><span class=\"qa-message-when-data\"><small>{{issueHistoryObj.eventType}}<br>{{\"#\"+issueHistoryObj.id}}</small></span></span></div></div></div><div class=\"pull-right\"><div class=\"post-meta\"><div class=\"asker-meta\"><label class=\"m-b-0 pull-right\"><small>Completed {{issueHistoryObj.eventEpoch}}</small></label><br><span class=\"text-right\">{{issueHistoryObj.privateStream ? \'private comment\': \'public comment\'}}</span></div></div></div></div></div><div class=\"qa-message-content\"><span class=\"parentSpan\"><span class=\"hide-toolbar\"><textarea class=\"content-box\" ng-model=\"issueHistoryObj.description\" markdown-editor=\"issueHistory.markedOptionObj\" rows=\"10\">\n                                    </textarea></span></span></div></div></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueHistory.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueHistory.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-link m-r-5\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button><div ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/issueSupplemental/issueSupplemental.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"IssueSupplementalCtrl as issueSupplemental\" ng-init=\"issueSupplemental.fnInitIssueSupplemental()\"><div class=\"content-main\"><div class=\"p-20\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issueSupplemental.isIssueSupplementalDetailsLoaded\"></div><div class=\"col-sm-12 m-t-0 floatingLabelInput h-100\" ng-if=\"issueSupplemental.isIssueSupplementalDetailsLoaded\"><div class=\"col-sm-12 p-0 action-div p-t-10\" ng-if=\"issueSupplemental.supplementalKVPArr.length || issueSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 m-b-20\"><div class=\"dropdown no-hover pull-right customDropdown-icon\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-10\" uib-dropdown-menu=\"\"><li ng-if=\"!issueSupplemental.isSupplementalDetailsEditable && issueSupplemental.parent.userPermissionsObj.REPLACE_ISSUE_TAGS\" ng-click=\"issueSupplemental.fnChangeFieldsToEditable()\"><a class=\"btn btn-link\">Edit</a></li><li ng-click=\"issueSupplemental.fnOpenAdvancedMenu()\"><a class=\"btn btn-link\">{{issueSupplemental.isAdvancedOption === true ?\"Basic\":\"Advance\"}} View</a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-t-0 d-flex h-100\" ng-if=\"!issueSupplemental.supplementalKVPArr.length && !issueSupplemental.isSupplementalDetailsEditable\"><div class=\"col-sm-12 p-0 d-flex justify-content-center align-items-center flex-column\"><span>You can assign metadata to your ECSMon resources in the form of tags. Each tag is a label consisting of a user-defined key and value.</span> <span>Tags can help you manage, identify, organize, search for, and filter resources. You can create tags to categorize resources by purpose, owner, environment, or other criteria.</span> <button class=\"btn btn-primary v4-primary-button m-t-20\" ng-if=\"!issueObj.resolved && issueSupplemental.parent.userPermissionsObj.REPLACE_ISSUE_TAGS\" ng-click=\"issueSupplemental.fnAddSupplementalKey(true)\">Add Tag</button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"issueSupplemental.supplementalKVPArr.length && !issueSupplemental.isAdvancedOption\" ng-class=\"!issueSupplemental.isSupplementalDetailsEditable ? \'pace\' : \'\'\"><div class=\"col-sm-12 p-0 m-t-0 m-b-0\" ng-if=\"issueSupplemental.supplementalKVPArr.length\" ng-repeat=\"kvpPair in issueSupplemental.supplementalKVPArr track by $index\"><div class=\"col-sm-2 p-0\"><div class=\"md-input\" ng-class=\"issueSupplemental.isKeyDuplicated && $index === issueSupplemental.duplicatedIndex?\'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"issueSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.key\" placeholder=\"Key *\"> <span class=\"highlight\"></span> <label>Key</label> <small class=\"helper-text-error\" ng-show=\"issueSupplemental.isKeyDuplicated && $index === issueSupplemental.duplicatedIndex\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-10 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"issueSupplemental.fnCheckUniqueKey(kvpPair, $index)\" ng-model=\"kvpPair.value\" ng-blur=\"valueFocus=false\" ng-focus=\"valueFocus=true\" ng-class=\"valueFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Value *\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"valueFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button ng-if=\"issueSupplemental.isSupplementalDetailsEditable\" class=\"btn btn-link\" ng-click=\"issueSupplemental.fnRemoveSupplemental($index)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div></div><div class=\"col-sm-12\" ng-if=\"issueSupplemental.isAdvancedOption\"><div class=\"row m-t-15 m-b-5\"><div class=\"col-sm-12 p-0\"><ui-codemirror ng-model=\"issueSupplemental.issueSupplementalObj\" ui-codemirror-opts=\"issueSupplemental.editorOptions\"></ui-codemirror></div></div></div><div class=\"col-sm-12 p-0 m-t-10 m-b-10\" ng-if=\"issueSupplemental.isSupplementalDetailsEditable\"><button type=\"button\" class=\"btn btn-primary btn-primary-cancel pull-right m-l-15 m-b-10\" ng-if=\"!issueSupplemental.isSupplementalDetailChanging\" ng-click=\"issueSupplemental.fnResetDetails()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary pull-right\" ng-if=\"!issueSupplemental.isSupplementalDetailChanging\" ng-click=\"issueSupplemental.fnSaveIssueData(true)\">Save Changes</button><div class=\"m-t-5 pull-right\" ng-if=\"issueSupplemental.isSupplementalDetailChanging\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issueSupplemental.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issueSupplemental.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-link m-r-5\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button><div ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/tracker/issue/directives/issueInfo/issueSteps/issuePrivate/issuePrivate.html","<div class=\"h-100 supplementalTemplate\" ng-controller=\"IssuePrivateCtrl as issuePrivate\" ng-init=\"issuePrivate.fnInitIssuePrivate()\"><div class=\"p-20 height-inherit\" app-spinner=\"\" spinner-type=\"\'miniSpinner\'\" ng-if=\"!issuePrivate.isIssueDetailsLoaded\"></div><div class=\"col-sm-12 newCommentUI d-flex p-0 height-inherit\" ng-if=\"issuePrivate.isIssueDetailsLoaded\"><div class=\"p-r-0 p-t-10 issueSideAnimation\" ng-class=\"issuePrivate.isExpanded ? \'col-sm-9\': \'issue-sidebar-collapse-class p-l-15\'\"><div class=\"col-sm-12 p-0\" ng-if=\"issuePrivate.selectedCommentView === \'Horizontal\'\"><div class=\"col-sm-12 d-flex p-0 comment-timeline\"><div class=\"dashed-border w100 main-comment-line-position\"></div><div class=\"d-flex w100 justify-content-space-between\" style=\"overflow-y: hidden\"><div class=\"d-flex w100 position-r p-r-10\" ng-class=\"issuePrivate.isShowIssueSummary ? \'commentArrowIcon\':\'\'\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowIssueSummary()\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"issuePrivate.isShowIssueSummary ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/main-comment.svg#mainComment\"></use></svg></span></div><div ng-repeat=\"comment in issuePrivate.issueObj.privateComments track by $index\" class=\"d-flex position-r\" ng-class=\"{ \'width-auto bg-color m-l-10 p-r-1\': $last, \'w100 p-l-10 p-r-10\': !$last, \'commentArrowIcon\': comment.id === issuePrivate.selectedComment.id }\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowComment(comment, \'mainComment\', {})\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"comment.id === issuePrivate.selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span><div ng-if=\"comment.subComments && comment.subComments.length\" class=\"aaa d-flex w100\" style=\"position: relative;\"><div class=\"dashed-border sub-comment-line-position\"></div><div class=\"d-flex w100 m-l-10 m-r-10\" ng-class=\"comment.subComments.length > 1 ?\'justify-content-space-between\':\'justify-content-flex-end\'\"><div ng-repeat=\"subComment in comment.subComments track by $index\" class=\"d-flex p-t-25 position-r\" ng-class=\"{ \'commentArrowIcon\': subComment.id === issuePrivate.selectedComment.id, \'width-30px\': !$last }\" style=\"z-index: 1;\"><span ng-click=\"issuePrivate.fnShowComment(subComment, \'subComment\', comment)\"><svg class=\"custom-svg-side-menu-icon issue-timeline-icon\" ng-class=\"subComment.id === issuePrivate.selectedComment.id ? \'selected-comment\':\'\'\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/service/comment.svg#comment\"></use></svg></span></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15\"><div class=\"comment\"><div class=\"comment-header p-l-10 p-r-10\"><div class=\"col-sm-12 p-0 d-flex h-100\"><div class=\"col-sm-7 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issuePrivate.selectedComment.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issuePrivate.selectedComment.userAvatar}}\"> {{issuePrivate.selectedComment.createdBy ? issuePrivate.selectedComment.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{issuePrivate.selectedComment.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issuePrivate.selectedComment.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-5 pull-right text-right p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex m-r-20\" ng-if=\"issuePrivate.isShowIssueSummary\" ng-class=\"issuePrivate.selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issuePrivate.selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(true, issuePrivate.selectedComment)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(false, issuePrivate.selectedComment)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"d-flex m-r-20\" ng-if=\"!issuePrivate.isShowIssueSummary\" ng-class=\"issuePrivate.selectedComment.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issuePrivate.selectedComment.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" ng-class=\"issuePrivate.issueObj.resolved ? \'pace opacity-5\' : \'\'\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToComment(true, issuePrivate.selectedComment)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" ng-class=\"issuePrivate.issueObj.resolved ? \'pace opacity-5\' : \'\'\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToComment(false, issuePrivate.selectedComment)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><span class=\"m-r-10 p-r-5 pull-right\"><span uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(issuePrivate.selectedComment.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(issuePrivate.selectedComment.createdAt)}}</span></span><div class=\"dropdown no-hover customDropdown-icon m-r-5 pull-right\" ng-if=\"!issuePrivate.issueObj.resolved\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15\" uib-dropdown-menu=\"\"><li ng-if=\"!issuePrivate.selectedComment.isEditMode && issuePrivate.parent.userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnEditIssueComment(issuePrivate.issueObj, issuePrivate.selectedComment, \'editor\')\">Edit</a></li><li ng-if=\"!issuePrivate.isShowIssueSummary && (issuePrivate.selectedComment && (!issuePrivate.selectedComment.subComments || (issuePrivate.selectedComment.subComments && issuePrivate.selectedComment.subComments.length === 0))) && issuePrivate.parent.userPermissionsObj.REMOVE_COMMENT && !issuePrivate.selectedComment.mainCommentId\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnDeleteIssueComment(issuePrivate.issueObj, issuePrivate.selectedComment)\">Delete</a></li></ul></div></div></div></div><div class=\"comment-body p-0 m-t-1 overflow-auto\"><div class=\"position-r hide-toolbar\" ng-if=\"issuePrivate.selectedComment.isShowComment\" style=\"height: inherit;\" ng-class=\"!issuePrivate.selectedComment.isEditMode ? \'preview-only\' : \'\'\"><textarea name=\"editor{{issuePrivate.selectedComment.id}}\" class=\"content-box\" ng-drop-dir-for-issue=\"\" comment-obj=\"issuePrivate.selectedComment\" upload-file=\"issuePrivate.uploadFiles(type, filedata, commentObj)\" ng-model=\"issuePrivate.selectedComment.mdBody\" markdown-editor=\"markedOptionObj\" rows=\"10\">\n                            </textarea></div></div><div class=\"comment-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"issuePrivate.selectedComment.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"issuePrivate.selectedComment.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'editor\'+issuePrivate.selectedComment.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!issuePrivate.selectedComment.fileUploading\" ng-click=\"issuePrivate.fnCancelCommentEditing(issuePrivate.selectedComment)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFile1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"issuePrivate.selectedComment\" upload-file=\"issuePrivate.uploadFiles(type, filedata, commentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFile1\').click()\" ng-if=\"!issuePrivate.selectedComment.fileUploading && issuePrivate.selectedComment.isEditMode && issuePrivate.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!issuePrivate.selectedComment.fileUploading && issuePrivate.selectedComment.isEditMode && !issuePrivate.isShowIssueSummary\" ng-click=\"issuePrivate.fnUpdateComment(issuePrivate.issueObj, issuePrivate.selectedComment)\">Save</button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!issuePrivate.selectedComment.fileUploading && issuePrivate.selectedComment.isEditMode && issuePrivate.isShowIssueSummary\" ng-click=\"issuePrivate.fnUpdateIssueSummary(issuePrivate.issueObj, issuePrivate.selectedComment)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"issuePrivate.selectedComment.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 vertical-comment-view overflow-auto\" ng-if=\"issuePrivate.selectedCommentView === \'Vertical\'\"><div id=\"lifecycleTimeline\" class=\"issue_history col-sm-12 m-t-0 p-l-0 p-r-5\"><div ng-class=\"!issuePrivate.issueObj.privateComments.length ? \'message-first m-b-0\' : \'message-item\'\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!issuePrivate.issueSummary.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"issuePrivate.issueSummary.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{issuePrivate.issueSummary.userAvatar}}\"> {{issuePrivate.issueSummary.createdBy ? issuePrivate.issueSummary.createdBy : \"ECSMon\"}} - <span tooltip-append-to-body=\"true\" uib-tooltip=\"{{issuePrivate.issueSummary.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\">{{issuePrivate.issueSummary.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\" ng-class=\"issuePrivate.issueSummary.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{issuePrivate.issueSummary.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(true, issuePrivate.issueSummary)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(false, issuePrivate.issueSummary)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(issuePrivate.issueSummary.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(issuePrivate.issueSummary.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issuePrivate.issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"!issuePrivate.issueSummary.isEditMode && issuePrivate.parent.userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnEditIssueComment(issuePrivate.issueObj, issuePrivate.issueSummary, \'editor\')\">Edit</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{issuePrivate.issueSummary.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!issuePrivate.issueSummary.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{issuePrivate.issueSummary.id}}\" ng-model=\"issuePrivate.issueSummary.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"issuePrivate.issueSummary\" upload-file=\"issuePrivate.uploadFiles(type, filedata, issuePrivate.issueSummary)\" rows=\"10\">\n                                    </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"issuePrivate.issueSummary.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"issuePrivate.issueSummary.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'editor\'+issuePrivate.issueSummary.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!issuePrivate.issueSummary.fileUploading\" ng-click=\"issuePrivate.fnCancelVerticalCommentEditing(issuePrivate.issueSummary, true)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalSummary1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"issuePrivate.issueSummary\" upload-file=\"issuePrivate.uploadFiles(type, filedata, issuePrivate.issueSummary)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalSummary1\').click()\" ng-if=\"!issuePrivate.issueSummary.fileUploading && issuePrivate.issueSummary.isEditMode && issuePrivate.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!issuePrivate.issueSummary.fileUploading && issuePrivate.issueSummary.isEditMode\" ng-click=\"issuePrivate.fnUpdateIssueSummary(issuePrivate.issueObj, issuePrivate.issueSummary)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"issuePrivate.issueSummary.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><div ng-class=\"$index === issuePrivate.issueObj.privateComments.length - 1 ? \'message-first m-b-0\' : \'message-item\'\" ng-repeat=\"commentObj in issuePrivate.issueObj.privateComments track by commentObj.id\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!commentObj.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"commentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{commentObj.userAvatar}}\"> {{commentObj.createdBy ? commentObj.createdBy : \"ECSMon\"}} - <span uib-tooltip=\"{{commentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{commentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\" ng-class=\"commentObj.isVoteUpdateing ? \'pace opacity-5\':\'\'\"><label class=\"m-0 m-r-10\">{{commentObj.voteCount}}</label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToComment(true, commentObj)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToComment(false, commentObj)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(commentObj.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(commentObj.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issuePrivate.issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"issuePrivate.toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"!commentObj.isEditMode && issuePrivate.parent.userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnEditIssueComment(issuePrivate.issueObj, commentObj, \'editor\')\">Edit</a></li><li ng-if=\"issuePrivate.parent.userPermissionsObj.REMOVE_COMMENT\"><a class=\"btn btn-link\" ng-if=\"issuePrivate.parent.userPermissionsObj.REMOVE_COMMENT && (commentObj && (!commentObj.subComments || (commentObj.subComments && commentObj.subComments.length === 0)))\" ng-click=\"issuePrivate.fnDeleteIssueComment(issuePrivate.issueObj, commentObj)\">Delete</a></li><li ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_SUB_COMMENT\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnAddNewSubComment(issuePrivate.issueObj, commentObj)\">Add sub Comment</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{commentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!commentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{commentObj.id}}\" ng-model=\"commentObj.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"commentObj\" upload-file=\"issuePrivate.uploadFiles(type, filedata, commentObj)\" rows=\"10\">\n                                    </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"commentObj.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"commentObj.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'editor\'+commentObj.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!commentObj.fileUploading\" ng-click=\"issuePrivate.fnCancelVerticalCommentEditing(commentObj, false)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalComment1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"commentObj\" upload-file=\"issuePrivate.uploadFiles(type, filedata, commentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalComment1\').click()\" ng-if=\"!commentObj.fileUploading && commentObj.isEditMode && userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!commentObj.fileUploading && commentObj.isEditMode\" ng-click=\"issuePrivate.fnUpdateComment(issuePrivate.issueObj, commentObj)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"commentObj.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div><div class=\"p-t-20 p-b-0 p-l-20 sub-comment-container position-r\" ng-if=\"(commentObj.subComments && commentObj.subComments.length) || commentObj.isShowSubCommentEditor\"><div ng-repeat=\"subCommentObj in commentObj.subComments track by subCommentObj.id\" ng-class=\"{\'message-first m-b-0\': $index === commentObj.subComments.length - 1 && !commentObj.isShowSubCommentEditor , \'message-item\': $index !== commentObj.subComments.length - 1 || commentObj.isShowSubCommentEditor}\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\" ng-class=\"!subCommentObj.isEditMode ? \'message-head-border-unset\' : \'\'\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5\" ng-class=\"subCommentObj.createdBy ?\'img-circle\':\'\'\" ng-src=\"{{subCommentObj.userAvatar}}\"> {{subCommentObj.createdBy ? subCommentObj.createdBy : \"Predictive\"}} - <span uib-tooltip=\"{{subCommentObj.humanDateCreatedAbsolute}}\" tooltip-placement=\"top\" tooltip-append-to-body=\"true\">{{subCommentObj.humanDateCreatedRelative}}</span></label></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><div class=\"d-flex align-items-center m-r-10\"><label class=\"m-0 m-r-10\"></label><svg class=\"custom-svg-side-menu-icon m-r-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(true, subCommentObj)\"><use xlink:href=\"assets/images/svg/service/like.svg#like\"></use></svg><svg class=\"custom-svg-side-menu-icon m-l-5\" width=\"20px\" height=\"20px\" ng-click=\"issuePrivate.fnAddUpDownVoteToIssue(false, subCommentObj)\"><use xlink:href=\"assets/images/svg/service/dislike.svg#dislike\"></use></svg></div><div class=\"m-r-10 d-flex align-items-center\"><span class=\"p-t-3\" uib-tooltip=\"{{issuePrivate.fnGetRelativeTime(subCommentObj.createdAt)}}\" tooltip-placement=\"left\">{{issuePrivate.fnGetRelativeTime(subCommentObj.createdAt)}}</span></div><div class=\"d-flex align-items-center\"><div class=\"dropdown no-hover customDropdown-icon m-r-5\" ng-if=\"!issuePrivate.issueObj.resolved\" dropdown-append-to-body=\"true\" ng-click=\"issuePrivate.toggleDropUp(\'issueCommentDiv\',$event);\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><span class=\"customMenuBar\"><i class=\"fa fa-bars p-r-10\"></i></span></a><ul class=\"dropdown-menu pull-right m-r-15 dropdown-menu-right\" uib-dropdown-menu=\"\"><li ng-if=\"issuePrivate.parent.userPermissionsObj.UPDATE_COMMENT_TEXT\"><a class=\"btn btn-link\" ng-click=\"issuePrivate.fnEditIssueComment(issuePrivate.issueObj, subCommentObj, \'editor\')\">Edit</a></li></ul></div></div></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"{{subCommentObj.id}}\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\" ng-class=\"!subCommentObj.isEditMode ? \'preview-only\' : \'\'\"><textarea class=\"content-box\" name=\"editor{{subCommentObj.id}}\" ng-model=\"subCommentObj.mdBody\" markdown-editor=\"issuePrivate.markedOptionObj\" ng-drop-dir-for-issue=\"\" comment-obj=\"subCommentObj\" upload-file=\"issuePrivate.uploadFiles(type, filedata, subCommentObj)\" rows=\"10\">\n                                            </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\" ng-if=\"subCommentObj.isEditMode\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\" ng-if=\"subCommentObj.isEditMode\"><button class=\"btn btn-primary m-r-10\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'editor\'+subCommentObj.id)\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!subCommentObj.fileUploading\" ng-click=\"issuePrivate.fnCancelVerticalCommentEditing(subCommentObj, false)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalSubComment1\" name=\"file\" ng-files-for-issue=\"\" comment-obj=\"subCommentObj\" upload-file=\"issuePrivate.uploadFiles(type, filedata, subCommentObj)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalSubComment1\').click()\" ng-if=\"!subCommentObj.fileUploading && subCommentObj.isEditMode && issuePrivate.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!subCommentObj.fileUploading && subCommentObj.isEditMode\" ng-click=\"issuePrivate.fnUpdateComment(issuePrivate.issueObj, subCommentObj)\">Save</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"subCommentObj.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div><div class=\"message-first m-b-0 new-sub-comment-editor\" ng-if=\"commentObj.isShowSubCommentEditor\"><div class=\"message-inner p-0\"><div class=\"message-head clearfix p-l-5 p-r-0 p-b-10 p-t-2 m-0\"><div class=\"user-detail\"><div class=\"col-sm-12 p-0 d-flex align-items-center\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><label class=\"m-0 ellipsis\"><img class=\"avatarImage m-r-5 img-circle\" ng-src=\"{{issuePrivate.loginUserAvatar}}\"> {{issuePrivate.loginUser.email}}</label></div></div></div></div><div class=\"qa-message-content overflow-auto\" id=\"newSubComment\"><div class=\"position-r hide-toolbar\" style=\"height: inherit;\"><textarea class=\"content-box\" name=\"newSubCommentEditor\" ng-model=\"issuePrivate.newSubComment.text\" markdown-editor=\"issuePrivate.newCommentMarkedOptionObj\" ng-drop-dir-for-issue=\"\" upload-file=\"issuePrivate.uploadFiles(type, filedata, null, issuePrivate.newSubComment)\" rows=\"10\">\n                                            </textarea></div></div><div class=\"qa-message-footer p-l-10 p-r-10 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex\"><div class=\"col-sm-6 p-0 d-flex align-items-center\"><button class=\"btn btn-primary m-r-10\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'newSubCommentEditor\')\"><span class=\"fa fa-eye\"></span> Preview</button> <button class=\"btn btn-primary btn-primary-cancel\" ng-if=\"!issuePrivate.newSubComment.fileUploading\" ng-click=\"issuePrivate.fnCancelVerticalNewSubComment(commentObj)\">Cancel</button></div><div class=\"col-sm-6 p-0 d-flex align-items-center justify-content-flex-end\"><input type=\"file\" id=\"markDownFileVerticalNewSubComment1\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"issuePrivate.uploadFiles(type, filedata, null, issuePrivate.newSubComment)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" onclick=\"document.getElementById(\'markDownFileVerticalNewSubComment1\').click()\" ng-if=\"!issuePrivate.newSubComment.fileUploading && issuePrivate.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button> <button class=\"btn btn-primary v4-primary-button\" ng-if=\"!issuePrivate.newSubComment.fileUploading && issuePrivate.parent.userPermissionsObj.ADD_SUB_COMMENT\" ng-disabled=\"!issuePrivate.newSubComment.text.length\" ng-click=\"issuePrivate.fnAddSubCommentToComment(commentObj, issuePrivate.newSubComment, false)\">Add sub Comment</button><div class=\"pull-right m-5\" app-spinner=\"\" ng-if=\"issuePrivate.newSubComment.fileUploading\" spinner-type=\"\'microSpinner\'\"></div></div></div></div></div></div></div></div></div></div><div class=\"col-sm-12 p-0 m-t-15 m-b-15 d-flex newComment flex-column new-comment-block\" ng-if=\"!issuePrivate.issueObj.resolved\"><div class=\"col-sm-12 p-0 newCommentBody hide-toolbar\"><div><textarea name=\"newCommentEditor\" class=\"content-box newCommentTextBox\" ng-drop-dir-for-issue=\"\" upload-file=\"issuePrivate.uploadFiles(type, filedata)\" id=\"newCommentBlock\" ng-keydown=\"issuePrivate.fnKeyDownComment()\" ng-focus=\"issuePrivate.fnClickNewComment()\" ng-blur=\"issuePrivate.fnClickNewComment(true)\" ng-model=\"issuePrivate.newCommentObj.text\" placeholder=\"Type your message...\" markdown-editor=\"issuePrivate.newCommentMarkedOptionObj\" rows=\"10\">\n                        </textarea></div></div><div class=\"col-sm-12 p-0 newCommentFooter d-flex\"><div class=\"col-sm-4 p-0 d-flex align-items-center\"><div class=\"col-sm-12 p-0 d-flex height-100\"><button class=\"btn btn-primary m-2 m-l-0\" ng-click=\"issuePrivate.fnHideShowEditorPreview(\'newCommentEditor\')\"><span class=\"fa fa-eye\"></span> Preview</button></div></div><div class=\"col-sm-8 p-0 d-flex align-items-flex-end justify-content-flex-end\" ng-if=\"issuePrivate.newCommentObj.fileUploading\"><div class=\"pull-right m-5 m-r-10\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\"></div></div><div class=\"col-sm-8 p-0 d-flex align-items-center\" ng-if=\"!issuePrivate.newCommentObj.fileUploading\"><div class=\"col-sm-12 p-0 text-right d-flex justify-content-flex-end\"><input type=\"file\" id=\"markDownFile\" name=\"file\" ng-files-for-issue=\"\" upload-file=\"issuePrivate.uploadFiles(type, filedata)\" style=\"visibility:hidden; height: 0px;\"> <button type=\"button\" class=\"btn btn-link btn-sm m-r-5\" ng-if=\"issuePrivate.parent.userPermissionsObj.GET_FILE_UPLOAD_LINK\" onclick=\"document.getElementById(\'markDownFile\').click()\"><span class=\"d-flex align-items-center svg-fill-primary\"><svg class=\"m-r-5\" width=\"20px\" height=\"20px\"><use xlink:href=\"assets/images/svg/paper-clip.svg#paperClip\"></use></svg></span></button><div class=\"d-flex\"><div class=\"customDropdown\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button id=\"split-button\" type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary orange-btn border-right-0 p-r-4\" ng-class=\"!issuePrivate.newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_COMMENT && issuePrivate.parent.userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"issuePrivate.fnAddCommentToIssue(issuePrivate.issueObj, issuePrivate.newCommentObj, \'CommentResolve\')\">Comment & resolve</button> <button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary orange-btn border-left-0 p-l-4\" ng-class=\"!issuePrivate.newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;color: orange !important;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_COMMENT && issuePrivate.parent.userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"issuePrivate.fnAddCommentToIssue(issuePrivate.issueObj, issuePrivate.newCommentObj, \'CommentResolveRequest\')\" ng-class=\"!issuePrivate.newCommentObj.text.length ? \'pace opacity-5\' : \'\'\"><a><span>Comment & send request</span></a></li></ul></div></div><div class=\"customDropdown m-l-2\" ng-if=\"issuePrivate.issueObj.privateComments && issuePrivate.issueObj.privateComments.length\"><div class=\"btn-group col-sm-12 p-0 dropup d-flex\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary btnPrimary border-right-0 p-r-4\" ng-class=\"{ \'pace opacity-5\': !issuePrivate.newCommentObj.text.length, \'p-r-20\': !issuePrivate.parent.userPermissionsObj.ADD_SUB_COMMENT}\" ng-click=\"issuePrivate.fnAddCommentToIssue(issuePrivate.issueObj, issuePrivate.newCommentObj, false)\">Comment</button> <button type=\"button\" ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_SUB_COMMENT\" class=\"col-sm-12 btn btn-sm btn-primary btnPrimary border-left-0 m-l-0 p-l-4\" ng-class=\"!issuePrivate.newCommentObj.text.length ? \'pace opacity-5\' : \'\'\" uib-dropdown-toggle=\"\"><span class=\"caret\" style=\"position: unset;\"></span></button><ul class=\"dropdown-menu pull-right\"><li ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_SUB_COMMENT\" ng-click=\"issuePrivate.fnAddSubCommentToComment(issuePrivate.issueObj.privateComments[issuePrivate.issueObj.privateComments.length - 1], issuePrivate.newCommentObj, false)\" ng-class=\"!issuePrivate.newCommentObj.text.length ? \'pace opacity-5\' : \'\'\"><a><span>Add Sub Comment</span></a></li></ul></div></div><button class=\"btn btn-primary m-l-2\" ng-if=\"issuePrivate.parent.userPermissionsObj.ADD_COMMENT && (!issuePrivate.issueObj.privateComments || issuePrivate.issueObj.privateComments.length === 0)\" ng-click=\"issuePrivate.fnAddCommentToIssue(issuePrivate.issueObj, issuePrivate.newCommentObj, false)\" ng-disabled=\"!issuePrivate.newCommentObj.text.length\">Comment</button></div></div></div></div></div></div><div class=\"p-r-0 issueSideAnimation\" ng-class=\"issuePrivate.isExpanded ? \'col-sm-3\': \'custom-class-sidebar p-l-15\'\"><issue-assignee-label-side-bar issue-obj=\"issuePrivate.issueObj\" class=\"h-100\" user-permissions-obj=\"issuePrivate.parent.userPermissionsObj\" is-expanded=\"issuePrivate.isExpanded\"></issue-assignee-label-side-bar></div></div><div class=\"col-sm-12 content-footer d-flex p-t-10 p-b-10\"><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center p-r-0 p-l-0\"><label class=\"m-0\">ID: {{issuePrivate.parent.issueObj.id}}</label> <i class=\"m-l-5 fa\" ng-click=\"fnCopyToClipboard(issuePrivate.parent.issueObj.id, 2000)\" ng-class=\"!isCopyClicked ? \'fa-clipboard\' : \'fa-check\'\"></i></div><div class=\"col-sm-6 content-box-footerItem m-0 d-flex align-items-center justify-content-flex-end p-r-0 p-l-0\"><button class=\"btn btn-link m-r-5\" ng-click=\"fnCopyIssueLink()\">Copy Issue Link</button><div ng-if=\"issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.ARCHIVE_ISSUE\" ng-click=\"fnArchivedIssue(issueObj)\">Archive Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.REOPEN_ISSUE\" ng-click=\"fnReOpenIssue(issueObj)\">Re-open Issue</button></div><div ng-if=\"!issueObj.resolved && !newCommentObj.fileUploading && !isIssueInfoUpdating && !isFullWidthDevice\"><button type=\"button\" class=\"btn btn-primary orange-btn\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE\" ng-click=\"fnResolveIssue(issueObj)\">Resolve Issue</button> <button type=\"button\" class=\"btn btn-gray m-l-5\" ng-if=\"userPermissionsObj.RESOLVE_ISSUE_REQUEST\" ng-click=\"fnResolveIssueRequest(issueObj)\">Send Resolve Request</button></div><div ng-if=\"isIssueInfoUpdating && !isFullWidthDevice\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/engine/modals/sampleDataModal/sampleDataModal.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"sampleDataModal.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Sample Data</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 h-100\"><div class=\"h-100\" ng-init=\"sampleDataModal.fnInitCalled()\"><ui-codemirror ng-model=\"sampleDataModal.sampleDataObj.value\" ui-codemirror-opts=\"sampleDataModal.editorOptions\"></ui-codemirror></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"dropdown dropup d-flex align-items-center justify-content-space-between\" uib-dropdown=\"\"><a class=\"dropdown-toggle link-primary list-inline\" uib-dropdown-toggle=\"\" data-toggle=\"dropdown\"><button class=\"btn btn-primary v4-primary-button\">{{sampleDataModal.sampleDataObj.type}}<i class=\"fa fa-caret-up m-l-2\"></i></button></a><ul class=\"dropdown-menu pull-left\" uib-dropdown-menu=\"\"><li ng-repeat=\"(key, value) in sampleDataModal.sampleDataOptions\" ng-if=\"sampleDataModal.sampleDataObj.type !== key\"><a class=\"btn btn-link\" ng-click=\"sampleDataModal.fnSelectSampleDataLanguage(value, key)\">{{key}}</a></li></ul><button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 m-l-10 pull-right\" ng-click=\"sampleDataModal.fnSave(sampleDataModal.sampleDataObj)\">Save</button></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/topology/modals/discoveryDetailsModal/discoveryDetails.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"discoveryDetails.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Discovery Details</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"discoveryDetails.discoverySelectorObj.key\" placeholder=\"Discovery Selector Name\"> <span class=\"highlight\"></span> <label>Discovery Selector Name</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 d-flex align-items-center m-b-20\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{discoveryDetails.discoverySelectorObj.value.selectorObj.type}}</span> <label class=\"titleLabel\">Discovery Selector Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"selector in discoveryDetails.attrSelectorPathOptions\"><a ng-click=\"discoveryDetails.fnSelectDiscoveryPathOptions(selector, discoveryDetails.discoverySelectorObj)\"><span ng-class=\"selector === discoveryDetails.discoverySelectorObj.value.selectorObj.type ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"selector === discoveryDetails.discoverySelectorObj.value.selectorObj.type\"></i></span> <span>{{selector}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-if=\"discoveryDetails.discoverySelectorObj.value.selectorObj.type.length\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpressionForDiscovery\" type=\"text\" ng-model=\"discoveryDetails.discoverySelectorObj.value.selectorObj.expression\" placeholder=\"Discovery Selector Expression*\" name=\"selectorExpressionForDiscovery\"> <span class=\"highlight\"></span> <label>Discovery Selector Expression*</label> <small class=\"helper-text\" ng-if=\"discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleDataType === \'CSV\' && discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData && discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData || (discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData && discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><svg class=\"custom-svg-side-menu-icon m-l-10 cursor-pointer\" width=\"20px\" height=\"20px\" ng-if=\"discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData && discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery.sampleData !== \'\'\" ng-click=\"discoveryDetails.fnOpenExpressionModal( discoveryDetails.discoverySelectorObj.value.selectorObj.expression, discoveryDetails.discoverySelectorObj.value.selectorObj.type, discoveryDetails.discoverySelectorObj.value.sampleDataForDiscovery)\"><use xlink:href=\"assets/images/svg/service/web-programming.svg#codeEditor\"></use></svg></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"discoveryDetails.fnCancel()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"discoveryDetails.fnSave()\">Save</button></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/engine/modals/engineRequestModal/engineRequestModal.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"engineRequestModal.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Engine Request</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 h-100 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"engineRequestModal.requestObj.name\" placeholder=\"Request Name\"> <span class=\"highlight\"></span> <label>Request Name</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{engineRequestModal.requestObj.value.method}}</span> <label class=\"titleLabel\">Method</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li class=\"p-10\" ng-repeat=\"methodOption in engineRequestModal.methodOptionsArr\" ng-click=\"engineRequestModal.fnSelectMethodType(engineRequestModal.requestObj, methodOption)\"><span ng-class=\"methodOption === engineRequestModal.requestObj.value.method ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"methodOption === engineRequestModal.requestObj.value.method\"></i></span> <span><span>{{methodOption}}</span></span></li></ul></div></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"engineRequestModal.requestObj.value.uri\" placeholder=\"URI\"> <span class=\"highlight\"></span> <label>URI</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"engineRequestModal.requestObj.value.encoding\" placeholder=\"Request Content Type\"> <span class=\"highlight\"></span> <label>Request Content Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"engineRequestModal.requestObj.value.contentType\" placeholder=\"Response Content Type\"> <span class=\"highlight\"></span> <label>Response Content Type</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-10\"><h3 class=\"m-0\">Query Parameters</h3></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in engineRequestModal.requestObj.value.queryArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.queryArr)\" ng-model=\"kvpPair.key\" placeholder=\"Query Key\"> <span class=\"highlight\"></span> <label>Query Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueQueryFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.queryArr)\" ng-model=\"kvpPair.value\" ng-blur=\"valueQueryFocus=false\" ng-focus=\"valueQueryFocus=true\" ng-class=\"valueQueryFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Query Value\"> <span class=\"highlight\"></span> <label>Query Value</label><div ng-if=\"valueQueryFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"engineRequestModal.requestObj.value.queryArr.length === 1 && $index === 0\" ng-click=\"engineRequestModal.fnRemoveSupplementalForOption($index, engineRequestModal.requestObj.value.queryArr)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><h3 class=\"m-0\">Header Parameters</h3></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in engineRequestModal.requestObj.value.headerArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.headerArr)\" ng-model=\"kvpPair.key\" placeholder=\"Header Key\"> <span class=\"highlight\"></span> <label>Header Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueHeaderFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.headerArr)\" ng-model=\"kvpPair.value\" ng-blur=\"valueHeaderFocus=false\" ng-focus=\"valueHeaderFocus=true\" ng-class=\"valueHeaderFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Header Value\"> <span class=\"highlight\"></span> <label>Header Value</label><div ng-if=\"valueHeaderFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"engineRequestModal.requestObj.value.headerArr.length === 1 && $index === 0\" ng-click=\"engineRequestModal.fnRemoveSupplementalForOption($index, engineRequestModal.requestObj.value.headerArr)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><h3 class=\"m-0\">Body Parameters</h3></div><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in engineRequestModal.requestObj.value.bodyArr track by $index\"><div class=\"col-sm-5 p-0\"><div class=\"md-input\" ng-class=\"kvpPair.isKeyDuplicated ? \'m-b-40\':\'m-b-20\'\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.bodyArr)\" ng-model=\"kvpPair.key\" placeholder=\"Body Key\"> <span class=\"highlight\"></span> <label>Body Key</label> <small class=\"helper-text-error\" ng-show=\"kvpPair.isKeyDuplicated\"><span class=\"errorText\">The Key is already in Use.</span></small><div class=\"supplementalInputBorder\"></div></div></div><div class=\"col-sm-7 p-0 d-flex\"><div class=\"w100 m-r-20\"><div class=\"md-input m-b-20\" ng-init=\"valueBodyFocus=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-change=\"engineRequestModal.fnCheckUniqueKeyForOptions(kvpPair, $index, engineRequestModal.requestObj.value.bodyArr)\" ng-model=\"kvpPair.value\" ng-blur=\"valueBodyFocus=false\" ng-focus=\"valueBodyFocus=true\" ng-class=\"valueBodyFocus === false ? \'removeLeftBorder\':\'\'\" placeholder=\"Body Value\"> <span class=\"highlight\"></span> <label>Body Value</label><div ng-if=\"valueBodyFocus === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"engineRequestModal.requestObj.value.bodyArr.length === 1 && $index === 0\" ng-click=\"engineRequestModal.fnRemoveSupplementalForOption($index, engineRequestModal.requestObj.value.bodyArr)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div></div><div class=\"col-sm-12 p-0 m-b-10\"><h3 class=\"m-0\">Success Responses</h3></div><div class=\"col-sm-12 p-0\"><uib-accordion><uib-accordion-group class=\"m-t-20\" ng-repeat=\"successObj in engineRequestModal.requestObj.value.responses.success track by $index\" is-open=\"successObj.open\"><uib-accordion-heading><div class=\"row p-10\"><div class=\"col-sm-4\">Success Response {{$index + 1.}}</div><div class=\"col-sm-8\"><i class=\"fa pull-right m-l-10\" ng-class=\"{\'fa-angle-down\': !successObj.open, \'fa-angle-up\': successObj.open}\"></i> <i class=\"fa fa-plus pull-right m-l-10\" ng-click=\"engineRequestModal.fnAddResponse($event, engineRequestModal.requestObj.value.responses.success)\"></i> <i class=\"fa fa-trash pull-right m-l-10\" ng-hide=\"engineRequestModal.requestObj.value.responses.success.length === 1 && $index === 0\" ng-click=\"engineRequestModal.fnRemoveResponse($event, $index, engineRequestModal.requestObj.value.responses.success)\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{successObj.type.toUpperCase()}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"responseEnumerationObj in engineRequestModal.responseTypeEnumerationOptions\"><a ng-click=\"engineRequestModal.fnSelectHttpResponseEnumeration(responseEnumerationObj.name, successObj)\"><span>{{responseEnumerationObj.name.toUpperCase()}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"successObj.expression\" placeholder=\"Expression\"> <span class=\"highlight\"></span> <label>Expression</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"successObj.match\" placeholder=\"Match\"> <span class=\"highlight\"></span> <label>Match</label> <small class=\"helper-text\"></small></div></div></div></div></uib-accordion-group></uib-accordion></div><div class=\"col-sm-12 p-0 m-b-10\"><h3 class=\"m-0\">Failure Responses</h3></div><div class=\"col-sm-12 p-0\"><uib-accordion><uib-accordion-group class=\"m-t-20\" ng-repeat=\"failureObj in engineRequestModal.requestObj.value.responses.failure track by $index\" is-open=\"failureObj.open\"><uib-accordion-heading><div class=\"row p-10\"><div class=\"col-sm-4\">Failure Response {{$index + 1.}}</div><div class=\"col-sm-8\"><i class=\"fa pull-right m-l-10\" ng-class=\"{\'fa-angle-down\': !failureObj.open, \'fa-angle-up\': failureObj.open}\"></i> <i class=\"fa fa-plus pull-right m-l-10\" ng-click=\"engineRequestModal.fnAddResponse($event, engineRequestModal.requestObj.value.responses.failure)\"></i> <i class=\"fa fa-trash pull-right m-l-10\" ng-hide=\"engineRequestModal.requestObj.value.responses.failure.length === 1 && $index === 0\" ng-click=\"engineRequestModal.fnRemoveResponse($event, $index, engineRequestModal.requestObj.value.responses.failure)\"></i></div></div></uib-accordion-heading><div class=\"row\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{failureObj.type.toUpperCase()}}</span> <label class=\"titleLabel\">Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"responseEnumerationObj in engineRequestModal.responseTypeEnumerationOptions\"><a ng-click=\"engineRequestModal.fnSelectHttpResponseEnumeration(responseEnumerationObj.name, failureObj)\"><span>{{responseEnumerationObj.name.toUpperCase()}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"failureObj.expression\" placeholder=\"Expression\"> <span class=\"highlight\"></span> <label>Expression</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"failureObj.match\" placeholder=\"Match\"> <span class=\"highlight\"></span> <label>Match</label> <small class=\"helper-text\"></small></div></div></div></div></uib-accordion-group></uib-accordion></div><div class=\"col-sm-12 p-0\"><button class=\"btn btn-primary v4-primary-button\" ng-click=\"engineRequestModal.fnOpenSampleDataModal(engineRequestModal.requestObj)\">{{engineRequestModal.requestObj.sampleData.length ? \'Edit Sample Data\' : \'Add Sample Data\'}}</button></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"engineRequestModal.fnCancel()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"engineRequestModal.fnSave()\">Save</button></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/topology/modals/flattenDetailsModal/flattenDetails.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"flattenDetails.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Flatten Details</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 m-t-10\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"flattenDetails.discoveryExtractorObj.key\" placeholder=\"Discovery Flatten Name\"> <span class=\"highlight\"></span> <label>Discovery Flatten Name</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30 customDropdown\" ng-if=\"flattenDetails.mappingsArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{flattenDetails.discoveryExtractorObj.value.extractorObj.mapper}}</span> <label class=\"titleLabel\">Flatten Mapper</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mappingObj in flattenDetails.mappingsArr\"><a ng-click=\"flattenDetails.fnSelectMapper(mappingObj, flattenDetails.discoveryExtractorObj.value.extractorObj)\"><span ng-class=\"mappingObj.id === flattenDetails.discoveryExtractorObj.value.extractorObj.mapper ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"mappingObj.id === flattenDetails.discoveryExtractorObj.value.extractorObj.mapper\"></i></span> <span>{{mappingObj.id}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in flattenDetails.discoveryExtractorObj.value.extractFiltersArrForDiscovery track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.key}}</span> <label class=\"titleLabel\">Flatten Filters</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"height: 200px; overflow-x: auto\"><li ng-repeat=\"attrFilterObj in flattenDetails.attrFilterOptionsForVerify\"><a ng-click=\"flattenDetails.fnSelectExtractFilterForDiscovery(attrFilterObj, kvpPair, flattenDetails.discoveryExtractorObj.value.extractFiltersArrForDiscovery)\"><span ng-class=\"attrFilterObj.filterValue === kvpPair.key ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrFilterObj.filterValue === kvpPair.key\"></i></span> <span>{{attrFilterObj.filterValue}}</span></a></li></ul></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\" ng-class=\"kvpPair.isArguments && kvpPair.key !== \'switch\' ? \'\' : \'pace opacity-5\'\"><div class=\"md-input m-b-20\" ng-init=\"flattenDetails.valueFocusForMapper=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"kvpPair.value\" ng-blur=\"flattenDetails.valueFocusForMapper=false\" ng-focus=\"flattenDetails.valueFocusForMapper=true\" ng-class=\"flattenDetails.valueFocusForMapper === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"flattenDetails.valueFocusForMapper === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"flattenDetails.discoveryExtractorObj.value.extractFiltersArrForDiscovery.length === 1 && $index === 0\" ng-click=\"flattenDetails.fnRemoveExtractFilterForDiscovery(kvpPair, $index, flattenDetails.discoveryExtractorObj.value.extractFiltersArrForDiscovery)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"kvpPair.key === \'switch\'\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-repeat=\"switchValue in kvpPair.switchValuesArr track by $index\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"switchValue.value\" placeholder=\"Switch Value\"> <span class=\"highlight\"></span> <label>Switch Value</label></div><button class=\"btn btn-primary v4-primary-button m-b-20 m-l-10\" ng-if=\"$index === kvpPair.switchValuesArr.length - 1\" ng-click=\"flattenDetails.fnAddSwitchOption(kvpPair)\">Add Another Switch Value</button></div></div></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"flattenDetails.fnCancel()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"flattenDetails.fnSave()\">Save</button></div></div></div>");
$templateCache.put("app/node/iot3/iot3Workbench/steps/topology/modals/verifyDetailsModal/verifyDetails.html","<div id=\"sampleDataModal\" class=\"form-content h-100\" ng-init=\"verifyDetails.fnInit()\"><div class=\"modal-header\"><h3 class=\"modal-title inline-display\" id=\"modal-title\">Verify Details</h3></div><div class=\"modal-body\"><div class=\"content-box-content table-content-box p-0 h-100\"><div class=\"row h-100\"><div class=\"col-sm-12 h-100\"><div class=\"col-sm-12 floatingLabelInput\"><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"dataSource\" type=\"text\" ng-model=\"verifyDetails.verifyObj.dataSource\" ng-blur=\"verifyDetails.fnGetTypeSampleData(verifyDetails.verifyObj)\" uib-typeahead=\"globalKeyObj as globalKeyObj.name for globalKeyObj in verifyDetails.verifyObj.globalKeyOptionsForDataSource | filter:{key:$viewValue}\" typeahead-min-length=\"0\" typeahead-on-select=\"verifyDetails.fnGlobalKeySelectedForDataSource($item, $model, $label, $event, verifyDetails.verifyObj.dataSource, verifyDetails.verifyObj)\" ng-change=\"verifyDetails.fnCheckUniqueKeyForDataSource(verifyDetails.verifyObj.dataSource, verifyDetails.verifyObj)\" placeholder=\"Verify Data Source\" name=\"dataSource\"> <span class=\"highlight\"></span> <label>Verify Data Source</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0 m-b-30 d-flex align-items-center\"><div class=\"col-sm-12 p-0 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{verifyDetails.verifyObj.selector.type}}</span> <label class=\"titleLabel\">Verify Selector Type</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"selector in verifyDetails.attrSelectorPathOptions\"><a ng-click=\"verifyDetails.fnSelectSelectorPathOptions(selector, verifyDetails.verifyObj)\"><span ng-class=\"selector === verifyDetails.verifyObj.selector.type ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"selector === verifyDetails.verifyObj.selector.type\"></i></span> <span>{{selector}}</span></a></li></ul></div></div></div><div class=\"col-sm-12 p-0 m-b-40 d-flex align-items-center\" ng-if=\"verifyDetails.verifyObj.selector.type.length\"><div class=\"md-input m-b-0 w100\"><input class=\"md-form-control\" required=\"\" id=\"selectorExpression\" type=\"text\" ng-model=\"verifyDetails.verifyObj.selector.expression\" placeholder=\"Verify Selector Expression*\" name=\"selectorExpression\"> <span class=\"highlight\"></span> <label>Verify Selector Expression*</label> <small class=\"helper-text\" ng-if=\"verifyDetails.verifyObj.sampleDataForVerify.sampleDataType === \'CSV\' && verifyDetails.verifyObj.sampleDataForVerify.sampleData && verifyDetails.verifyObj.sampleDataForVerify.sampleData !== \'\'\">The CSV sample data has been converted to an xml.</small> <small class=\"helper-text\" ng-if=\"!verifyDetails.verifyObj.sampleDataForVerify.sampleData || (verifyDetails.verifyObj.sampleDataForVerify.sampleData && verifyDetails.verifyObj.sampleDataForVerify.sampleData === \'\')\">Please add data to the type to get the sample data.</small></div><svg class=\"custom-svg-side-menu-icon m-l-10 cursor-pointer\" width=\"20px\" height=\"20px\" ng-if=\"verifyDetails.verifyObj.sampleDataForVerify.sampleData && verifyDetails.verifyObj.sampleDataForVerify.sampleData !== \'\'\" ng-click=\"verifyDetails.fnOpenExpressionModal( verifyDetails.verifyObj.selector.expression, verifyDetails.verifyObj.selector.type, verifyDetails.verifyObj.sampleDataForVerify)\"><use xlink:href=\"assets/images/svg/service/web-programming.svg#codeEditor\"></use></svg></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"verifyDetails.verifyObj.isShowSampleDataForVerify\"><div class=\"md-input\" ng-if=\"verifyDetails.verifyObj.selector.type !== \'xpath\'\"><input class=\"md-form-control\" required=\"\" id=\"selectedSampleDataForVerify\" type=\"text\" ng-model=\"verifyDetails.verifyObj.selectedSampleDataForVerify\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForVerify\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div><div class=\"col-sm-12 p-0\" ng-if=\"verifyDetails.verifyObj.selector.type === \'xpath\' && !verifyDetails.verifyObj.selectedSampleDataForVerify.isCollection\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"selectedSampleDataForVerifyForXPath\" type=\"text\" ng-model=\"verifyDetails.verifyObj.selectedSampleDataForVerify.sampleDataVal\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForDiscovery\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\" ng-if=\"verifyDetails.verifyObj.selector.type === \'xpath\' && verifyDetails.verifyObj.selectedSampleDataForVerify.isCollection\"><div class=\"md-input\" ng-repeat=\"sampleData in verifyDetails.verifyObj.selectedSampleDataForVerify.sampleDataVal track by $index\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"sampleData\" placeholder=\"Value Selected From Sample Data\" name=\"selectedSampleDataForDiscovery\"> <span class=\"highlight\"></span> <label>Value Selected From Sample Data</label> <small class=\"helper-text\"></small></div></div></div><div class=\"col-sm-12 p-0 m-b-30 customDropdown\" ng-if=\"verifyDetails.mappingsArr.length\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{verifyDetails.verifyObj.extractor.mapper}}</span> <label class=\"titleLabel\">Mapper</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\"><li ng-repeat=\"mappingObj in verifyDetails.mappingsArr\"><a ng-click=\"verifyDetails.fnSelectMapper(mappingObj, verifyDetails.verifyObj)\"><span ng-class=\"mappingObj.id === verifyDetails.verifyObj.extractor.mapper ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"mappingObj.id === verifyDetails.verifyObj.extractor.mapper\"></i></span> <span>{{mappingObj.id}}</span></a></li></ul></div></div><div class=\"col-sm-12 p-0 floatingLabelInput\"><div class=\"col-sm-12 p-0 supplementalTemplate\" ng-repeat=\"kvpPair in verifyDetails.verifyObj.extractFiltersArrForVerify track by $index\"><div class=\"col-sm-4 p-0\"><div class=\"col-sm-12 p-0 m-b-20 customDropdown\"><div class=\"btn-group col-sm-12 p-0\" uib-dropdown=\"\"><button type=\"button\" style=\"height: 43px\" class=\"col-sm-12 btn btn-sm btn-primary\" uib-dropdown-toggle=\"\"><span class=\"p-l-1 ellipsis-label\">{{kvpPair.key}}</span> <label class=\"titleLabel\">Verify Filter</label> <span class=\"caret\"></span></button><ul class=\"dropdown-menu\" style=\"height: 200px; overflow-x: auto\"><li ng-repeat=\"attrFilterObj in verifyDetails.attrFilterOptionsForVerify\"><a ng-click=\"verifyDetails.fnSelectExtractFilterForVerify(attrFilterObj, kvpPair, verifyDetails.verifyObj)\"><span ng-class=\"attrFilterObj.filterValue === kvpPair.key ? \'m-r-5\' : \'m-r-25\'\"><i class=\"fa fa-check\" ng-show=\"attrFilterObj.filterValue === kvpPair.key\"></i></span> <span>{{attrFilterObj.filterValue}}</span></a></li></ul></div></div></div><div class=\"col-sm-8 p-0 d-flex\"><div class=\"w100 m-r-20\" ng-class=\"kvpPair.isArguments && kvpPair.key !== \'switch\' ? \'\' : \'pace opacity-5\'\"><div class=\"md-input m-b-20\" ng-init=\"verifyDetails.verifyObj.valueFocusForMapper=false\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"kvpPair.value\" ng-blur=\"verifyDetails.verifyObj.valueFocusForMapper=false\" ng-focus=\"verifyDetails.verifyObj.valueFocusForMapper=true\" ng-class=\"verifyDetails.verifyObj.valueFocusForMapper === false ? \'removeLeftBorder\':\'\'\" placeholder=\"\"> <span class=\"highlight\"></span> <label>Value</label><div ng-if=\"verifyDetails.verifyObj.valueFocusForMapper === true\" class=\"supplementalInputBorderLeft\"></div></div></div><div class=\"m-t-5\"><button class=\"btn btn-link p-r-0 p-l-0\" ng-hide=\"verifyDetails.verifyObj.extractFiltersArrForVerify.length === 1 && $index === 0\" ng-click=\"verifyDetails.fnRemoveExtractFilterForVerify(kvpPair, $index, verifyDetails.verifyObj)\"><i class=\"fa fa-trash-o fa-lg\"></i></button></div></div><div class=\"col-sm-12 p-0\" ng-if=\"kvpPair.key === \'switch\'\"><div class=\"col-sm-12 p-0 d-flex align-items-center\" ng-repeat=\"switchValue in kvpPair.switchValuesArr track by $index\"><div class=\"md-input m-b-20 w100\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-model=\"switchValue.value\" placeholder=\"Switch Value\"> <span class=\"highlight\"></span> <label>Switch Value</label></div><button class=\"btn btn-primary v4-primary-button m-b-20 m-l-10\" ng-if=\"$index === kvpPair.switchValuesArr.length - 1\" ng-click=\"verifyDetails.fnAddSwitchOption(kvpPair)\">Add Another Switch Value</button></div></div></div></div><div class=\"col-sm-12 p-0 pace opacity-5\" ng-if=\"verifyDetails.verifyObj.isShowSampleDataForVerify\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"manipulatedSampleDataForVerify\" type=\"text\" ng-model=\"verifyDetails.manipulatedSampleDataForVerify\" placeholder=\"Final Value From Sample Data\" name=\"manipulatedSampleDataForVerify\"> <span class=\"highlight\"></span> <label>Final Value From Sample Data</label> <small class=\"helper-text\"></small></div></div><div class=\"col-sm-12 p-0\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"verifyMatch\" type=\"text\" ng-model=\"verifyDetails.verifyObj.match\" placeholder=\"Match\" name=\"verifyMatch\"> <span class=\"highlight\"></span> <label>Match</label> <small class=\"helper-text\"></small></div></div></div></div></div></div></div><div class=\"modal-footer\"><div class=\"col-sm-12 p-0 d-flex justify-content-space-between\"><button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"verifyDetails.fnCancel()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary v4-primary-button p-t-6 pull-right\" ng-click=\"verifyDetails.fnSave()\">Save</button></div></div></div>");
$templateCache.put("app/pipeline/workflows/workflowInfo/workflowTabs/worflowFlowView/modals/loadModal/loadModal.html","<div class=\"inmodal h-100 theme_modal\" ng-init=\"loadModalView.fnInitLoadViewModal()\"><div class=\"modal-header\"><h4 class=\"modal-title text-capitalize\"><div class=\"pull-left\" app-spinner=\"\" spinner-type=\"\'microSpinner\'\" ng-if=\"!loadModalView.isStateInfoLoaded\"></div><div state-template=\"\" state-object=\"loadModalView.stateObj\" ng-if=\"loadModalView.isStateInfoLoaded\" data-state=\"{{loadModalView.stateObj}}\" width-auto=\"true\"></div></h4></div><div class=\"modal-body p-0\" id=\"loadModalBody\"><div class=\"col-sm-12 p-0\"><scrollable-tabset show-tooltips=\"false\" scroll-by=\"150\"><uib-tabset active=\"loadModalView.selectedTab\"><uib-tab index=\"tab.tabIndex\" ng-repeat=\"tab in loadModalView.tabs\" ng-if=\"tab.visible === true\" select=\"loadModalView.fnTabSelected(tab)\"><uib-tab-heading class=\"tabHeading\"><div><div class=\"inline\"><div class=\"inline\" ng-bind=\"tab.title\"></div></div></div></uib-tab-heading><div class=\"tabContent\" ng-show=\"loadModalView.selectedTab === 1 && tab.tabIndex === 1\"><div class=\"col-sm-12 p-0 m-t-20\" ng-show=\"loadModalView.isStructureCreating\"><app-spinner spinner-type=\"\'microSpinner\'\"></app-spinner></div><div class=\"col-sm-12\" ng-show=\"!loadModalView.isShowJsonMapView && !loadModalView.isStructureCreating\"><div class=\"col-sm-12 p-0 m-b-15 m-t-15 floatingLabelInput\"><div class=\"col-sm-12 p-0\" ng-repeat=\"inputFieldObj in loadModalView.stateInputFieldArr track by $index\"><div class=\"col-sm-11 p-0\"><div class=\"col-sm-12 p-0\" ng-if=\"inputFieldObj.type !== \'array\'\"><div class=\"col-sm-12 p-0\"><div class=\"md-input m-b-20 customStateInputs\"><input class=\"md-form-control p-r-35\" required=\"\" type=\"text\" typeahead-editable=\"false\" ng-class=\"{\'p-t-20\': inputFieldObj.value && inputFieldObj.value !==\'\',\'p-t-10\':inputFieldObj.value && inputFieldObj.value ===\'\',\'pace\':inputFieldObj.displayPath !== \'Custom\'}\" ng-change=\"inputFieldObj.displayPath = \'\';inputFieldObj.value = \'\'\" uib-typeahead=\"inputObj.keyIndex as inputObj.keyIndex for inputObj in loadModalView.savedLoadInputsArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-focus=\"inputFieldObj.displayPath === \'Custom\'?loadModalView.fnKvpPairChangeInject(inputFieldObj, $index):\'\'\" typeahead-on-select=\"loadModalView.fnLoadValueSelected(inputFieldObj,$index)\" ng-model=\"inputFieldObj.displayValue\" placeholder=\"{{loadModalView.fnSetFiledLabel(loadModalView.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \'yes\' ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{loadModalView.fnSetFiledLabel(loadModalView.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"inputInfoIcon\" ng-if=\"inputFieldObj.description !==\'\'\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-class=\"inputFieldObj.value && inputFieldObj.value !==\'\'?\'p-t-8\':\'p-t-3\'\" ng-click=\"loadModalView.fnOpenInputInfo(inputFieldObj)\"><span><i class=\"f-23 fa fa-question-circle-o\"></i></span></a></span> <span class=\"loadModalDisplayPath\" ng-if=\"inputFieldObj.displayPath && inputFieldObj.displayPath !==\'\'\">{{inputFieldObj.displayPath === \"Custom\"?\'Static value\':loadModalView.fnIndexName(inputFieldObj.displayPath).replace(\'*\',\'\')}}</span></div></div></div><div class=\"col-sm-12 p-0\" ng-if=\"inputFieldObj.type === \'array\'\"><div class=\"md-input pace\" ng-class=\"inputFieldObj.inputGroups.length === 1?\'m-b-10\':\'m-b-0\'\"><input class=\"md-form-control p-t-20 pace\" required=\"\" type=\"text\" value=\"Click to add new {{inputFieldObj.index.includes(\'.\') ? inputFieldObj.index.split(\'.\')[inputFieldObj.index.split(\'.\').length - 1] : inputFieldObj.index}} entry\"> <span class=\"highlight\"></span> <label>{{loadModalView.fnSetFiledLabel(loadModalView.fnIndexName(inputFieldObj.index).replace(\'*\',\'\')).toUpperCase()}}{{inputFieldObj.required && inputFieldObj.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"loadModalDisplayPath\">Array</span></div><div class=\"col-sm-12 p-0 m-l-25 workflowLoadModalTreeView createArrayNestedUI\"><div class=\"col-sm-12 p-0\"><ul class=\"tree\"><li ng-repeat=\"inputGroup in inputFieldObj.inputGroups track by $index\"><span style=\"display: inline-block;width: 90%\"><div class=\"md-input m-b-20 customStateInputs\"><input class=\"md-form-control\" required=\"\" type=\"text\" ng-class=\"{\'p-t-20\': inputGroup.value && inputGroup.value !==\'\',\'p-t-10\':inputGroup.value && inputGroup.value ===\'\',\'pace\':inputGroup.displayPath !== \'Custom\'}\" typeahead-editable=\"false\" ng-change=\"inputGroup.displayPath = \'\';inputGroup.value = \'\'\" uib-typeahead=\"inputObj.keyIndex as inputObj.keyIndex for inputObj in loadModalView.savedLoadInputsArr | filter:$viewValue\" typeahead-min-length=\"0\" ng-focus=\"inputGroup.displayPath === \'Custom\'?loadModalView.fnKvpPairChangeInject(inputGroup, $index):\'\'\" typeahead-on-select=\"loadModalView.fnLoadValueSelected(inputGroup,$index)\" ng-model=\"inputGroup.displayValue\" placeholder=\"{{loadModalView.fnSetFiledLabel(inputGroup.displayName.replace(\'*\',\'\')).toUpperCase()}}{{inputGroup.required && inputGroup.required === \'yes\' ? \'*\':\'\'}}\"> <span class=\"highlight\"></span> <label>{{loadModalView.ordinal_suffix_of($index+1)+\" \"+loadModalView.fnSetFiledLabel(inputGroup.displayName.substring(0, inputGroup.displayName.length - 1).replace(\'*\',\'\')).toUpperCase()}}{{inputGroup.required && inputGroup.required === \"yes\" ? \'*\':\'\'}}</label> <span class=\"inputInfoIcon\" ng-if=\"inputGroup.description !==\'\'\"><a href=\"javascript:void(0);\" class=\"btn btn-link\" ng-class=\"inputGroup.value && inputGroup.value !==\'\'?\'p-t-8\':\'p-t-3\'\" ng-click=\"loadModalView.fnOpenInputInfo(inputGroup)\"><span><i class=\"f-23 fa fa-question-circle-o\"></i></span></a></span> <span class=\"loadModalDisplayPath\" ng-if=\"inputGroup.displayPath && inputGroup.displayPath !==\'\'\">{{inputGroup.displayPath === \"Custom\"?\'Static value\':loadModalView.fnIndexName(inputGroup.displayPath).replace(\'*\',\'\')}}</span></div></span></li></ul></div></div></div></div><div class=\"col-sm-1 p-0 text-right\"></div></div></div></div><div class=\"col-sm-12\" ng-show=\"loadModalView.isShowJsonMapView\"><div class=\"pull-left\"></div><div class=\"pull-right\"><button class=\"btn btn-link\" ng-class=\"loadModalView.kvpPair.isJsonIndex ? \'\' : \'linkDeactive\'\" ng-click=\"loadModalView.fnConvertFlattToObject(loadModalView.kvpPair)\">Json</button> <button class=\"btn btn-link\" ng-class=\"!loadModalView.kvpPair.isJsonIndex ? \'\' : \'linkDeactive\'\" ng-click=\"loadModalView.fnConvertObjectToFlatt(loadModalView.kvpPair)\">Map</button></div><div class=\"wizard pace\"><ng-code-mirror ng-if=\"loadModalView.kvpPair.isJsonIndex\" inject-model=\"loadModalView.kvpPair\" index-num=\"$index\" is-config-saved=\"loadModalView.isConfigurationsSaved\" fn-change-model=\"\"></ng-code-mirror><textarea style=\"height: 150px\" ng-if=\"!loadModalView.kvpPair.isJsonIndex\" ng-change=\"loadModalView.isConfigurationsSaved = false\" ng-model=\"loadModalView.kvpPair.injectMap\">map</textarea></div></div></div><div class=\"tabContent\" ng-show=\"loadModalView.selectedTab === 2 && tab.tabIndex === 2\"><div class=\"col-sm-12 p-0 m-t-60 pace stashForm\"><div class=\"col-sm-6 stashDecorativeDiv targetTreeView\" ng-style=\"{\'border-color\': loadModalView.stateObj ? loadModalView.stateObj.color : \'\'}\"><div class=\"col-sm-12 p-l-0 p-t-30 workflowLoadModalTreeView\"><ul class=\"tree\"><li ng-repeat=\"node in loadModalView.nestedOutputArr\" ng-include=\"\'nodes_renderer2.html\'\"></li></ul><script type=\"text/ng-template\" id=\"nodes_renderer2.html\">{{node.index.includes(\'.\')?node.index.split(\'.\')[node.index.split(\'.\').length-1]:node.index}} <div ng-if=\"node.isClickAble\" class=\"treeItem\" style=\"float: right\"></div> <ul> <li ng-repeat=\"node in node.children\" ng-include=\"\'nodes_renderer2.html\'\"> </li> </ul></script></div></div><div class=\"col-sm-6 p-0\"><div class=\"stashFormName\"><form novalidate=\"\" name=\"stashForm\"><div class=\"col-sm-12 p-l-0\"><div class=\"col-sm-2 m-t-13\"><img src=\"../assets/images/svg/Database_clip_art.svg\" style=\"height: 20px;width: 20px\"></div><div class=\"col-sm-10 floatingLabelInput\"><div class=\"md-input\"><input class=\"md-form-control\" required=\"\" id=\"stashName\" type=\"text\" name=\"stashName\" ng-pattern=\"/^[a-zA-Z\\d-]{1,50}$/\" ng-change=\"loadModalView.isConfigurationsSaved = false;\" ng-model=\"loadModalView.stashValue\" placeholder=\"Name for the new stashName\"> <span class=\"highlight\"></span> <label>Name</label> <small class=\"helper-text stashFormError\" ng-if=\"stashForm.stashName.$error.pattern\">Stash Name may contain a-z, A-Z, 0-9 and the - (hyphen) characters only. It can only be 50 characters long. Stash name will not be saved.</small></div></div></div></form></div></div></div></div></uib-tab></uib-tabset></scrollable-tabset></div></div><div class=\"modal-footer\"><button ng-if=\"loadModalView.isShowJsonMapView\" type=\"button\" class=\"btn btn-link\" ng-click=\"loadModalView.fnCancelJsonMapView()\">Back</button> <button ng-if=\"!loadModalView.isShowJsonMapView\" type=\"button\" class=\"btn btn-primary\" ng-click=\"loadModalView.fnCancel()\" tabindex=\"12\">Close</button></div></div>");}]);